/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		4: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".bundle.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/n/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1159);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1162);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            __webpack_require__(1244)("./" + name);
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trans = exports.I18nextProvider = exports.Interpolate = exports.translate = exports.loadNamespaces = undefined;

var _translate = __webpack_require__(1225);

var _translate2 = _interopRequireDefault(_translate);

var _interpolate = __webpack_require__(1228);

var _interpolate2 = _interopRequireDefault(_interpolate);

var _trans = __webpack_require__(1229);

var _trans2 = _interopRequireDefault(_trans);

var _I18nextProvider = __webpack_require__(1230);

var _I18nextProvider2 = _interopRequireDefault(_I18nextProvider);

var _loadNamespaces = __webpack_require__(1231);

var _loadNamespaces2 = _interopRequireDefault(_loadNamespaces);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.loadNamespaces = _loadNamespaces2.default;
exports.translate = _translate2.default;
exports.Interpolate = _interpolate2.default;
exports.I18nextProvider = _I18nextProvider2.default;
exports.Trans = _trans2.default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var core = __webpack_require__(51);
var hide = __webpack_require__(92);
var redefine = __webpack_require__(93);
var ctx = __webpack_require__(108);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1226)();
}


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * The main AWS namespace
 */
var AWS = { util: __webpack_require__(68) };

/**
 * @api private
 * @!macro [new] nobrowser
 *   @note This feature is not supported in the browser environment of the SDK.
 */
var _hidden = {}; _hidden.toString(); // hack to parse macro

module.exports = AWS;

AWS.util.update(AWS, {

  /**
   * @constant
   */
  VERSION: '2.101.0',

  /**
   * @api private
   */
  Signers: {},

  /**
   * @api private
   */
  Protocol: {
    Json: __webpack_require__(440),
    Query: __webpack_require__(775),
    Rest: __webpack_require__(321),
    RestJson: __webpack_require__(777),
    RestXml: __webpack_require__(778)
  },

  /**
   * @api private
   */
  XML: {
    Builder: __webpack_require__(1352),
    Parser: null // conditionally set based on environment
  },

  /**
   * @api private
   */
  JSON: {
    Builder: __webpack_require__(441),
    Parser: __webpack_require__(442)
  },

  /**
   * @api private
   */
  Model: {
    Api: __webpack_require__(801),
    Operation: __webpack_require__(802),
    Shape: __webpack_require__(253),
    Paginator: __webpack_require__(803),
    ResourceWaiter: __webpack_require__(804)
  },

  /**
   * @api private
   */
  apiLoader: __webpack_require__(1459)
});

__webpack_require__(1460);
__webpack_require__(1463);

__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(1464);
__webpack_require__(1467);
__webpack_require__(1469);
__webpack_require__(1470);
__webpack_require__(1471);
__webpack_require__(1477);

/**
 * @readonly
 * @return [AWS.SequentialExecutor] a collection of global event listeners that
 *   are attached to every sent request.
 * @see AWS.Request AWS.Request for a list of events to listen for
 * @example Logging the time taken to send a request
 *   AWS.events.on('send', function startSend(resp) {
 *     resp.startTime = new Date().getTime();
 *   }).on('complete', function calculateTime(resp) {
 *     var time = (new Date().getTime() - resp.startTime) / 1000;
 *     console.log('Request took ' + time + ' seconds');
 *   });
 *
 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
 */
AWS.events = new AWS.SequentialExecutor();


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowseButton = exports.IconButton = exports.Button = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Button = __webpack_require__(334);

var _BrowseButton = __webpack_require__(1771);

var _IconButton = __webpack_require__(338);

var _FontIcon = __webpack_require__(81);

var _ripple = __webpack_require__(162);

var _ripple2 = _interopRequireDefault(_ripple);

var _theme = __webpack_require__(868);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (0, _Button.buttonFactory)((0, _ripple2.default)({ centered: false }), _FontIcon.FontIcon);
var IconButton = (0, _IconButton.iconButtonFactory)((0, _ripple2.default)({ centered: true }), _FontIcon.FontIcon);
var BrowseButton = (0, _BrowseButton.browseButtonFactory)((0, _ripple2.default)({ centered: false }), _FontIcon.FontIcon);
var ThemedButton = (0, _reactCssThemr.themr)(_identifiers.BUTTON, _theme2.default)(Button);
var ThemedIconButton = (0, _reactCssThemr.themr)(_identifiers.BUTTON, _theme2.default)(IconButton);
var ThemedBrowseButton = (0, _reactCssThemr.themr)(_identifiers.BUTTON, _theme2.default)(BrowseButton);

exports.default = ThemedButton;
exports.Button = ThemedButton;
exports.IconButton = ThemedIconButton;
exports.BrowseButton = ThemedBrowseButton;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(1285);

var _assign2 = _interopRequireDefault(_assign);

var _reduce = __webpack_require__(160);

var _reduce2 = _interopRequireDefault(_reduce);

var _account = __webpack_require__(773);

var account = _interopRequireWildcard(_account);

var _activityReport = __webpack_require__(818);

var activityReport = _interopRequireWildcard(_activityReport);

var _alertMessage = __webpack_require__(13);

var alertMessage = _interopRequireWildcard(_alertMessage);

var _announce = __webpack_require__(819);

var announce = _interopRequireWildcard(_announce);

var _attachments = __webpack_require__(820);

var attachments = _interopRequireWildcard(_attachments);

var _buildNo = __webpack_require__(821);

var buildNo = _interopRequireWildcard(_buildNo);

var _chatMessages = __webpack_require__(822);

var chatMessages = _interopRequireWildcard(_chatMessages);

var _chatRooms = __webpack_require__(823);

var chatRooms = _interopRequireWildcard(_chatRooms);

var _comments = __webpack_require__(330);

var comments = _interopRequireWildcard(_comments);

var _diaries = __webpack_require__(259);

var diaries = _interopRequireWildcard(_diaries);

var _favorite = __webpack_require__(460);

var favorite = _interopRequireWildcard(_favorite);

var _block = __webpack_require__(824);

var block = _interopRequireWildcard(_block);

var _groups = __webpack_require__(825);

var groups = _interopRequireWildcard(_groups);

var _homeDiaries = __webpack_require__(826);

var homeDiaries = _interopRequireWildcard(_homeDiaries);

var _homeNotifications = __webpack_require__(827);

var homeNotifications = _interopRequireWildcard(_homeNotifications);

var _homeSubDiaries = __webpack_require__(828);

var homeSubDiaries = _interopRequireWildcard(_homeSubDiaries);

var _kpiChart = __webpack_require__(829);

var kpiChart = _interopRequireWildcard(_kpiChart);

var _kpi = __webpack_require__(461);

var kpi = _interopRequireWildcard(_kpi);

var _likes = __webpack_require__(331);

var likes = _interopRequireWildcard(_likes);

var _pins = __webpack_require__(830);

var pins = _interopRequireWildcard(_pins);

var _notifications = __webpack_require__(831);

var notifications = _interopRequireWildcard(_notifications);

var _organizations = __webpack_require__(832);

var organizations = _interopRequireWildcard(_organizations);

var _preservedQueries = __webpack_require__(833);

var preservedQueries = _interopRequireWildcard(_preservedQueries);

var _reactChat = __webpack_require__(462);

var reactChat = _interopRequireWildcard(_reactChat);

var _savedDiaries = __webpack_require__(834);

var savedDiaries = _interopRequireWildcard(_savedDiaries);

var _sessions = __webpack_require__(260);

var sessions = _interopRequireWildcard(_sessions);

var _subDiaries = __webpack_require__(835);

var subDiaries = _interopRequireWildcard(_subDiaries);

var _subscribe = __webpack_require__(836);

var subscribe = _interopRequireWildcard(_subscribe);

var _templates = __webpack_require__(463);

var templates = _interopRequireWildcard(_templates);

var _uploadFile = __webpack_require__(261);

var uploadFile = _interopRequireWildcard(_uploadFile);

var _uploadVideo = __webpack_require__(464);

var uploadVideo = _interopRequireWildcard(_uploadVideo);

var _user = __webpack_require__(177);

var user = _interopRequireWildcard(_user);

var _users = __webpack_require__(837);

var users = _interopRequireWildcard(_users);

var _sidebar = __webpack_require__(838);

var sidebar = _interopRequireWildcard(_sidebar);

var _socket = __webpack_require__(839);

var socket = _interopRequireWildcard(_socket);

var _rightSidebar = __webpack_require__(840);

var rightSidebar = _interopRequireWildcard(_rightSidebar);

var _googleApi = __webpack_require__(465);

var googleAPI = _interopRequireWildcard(_googleApi);

var _outlookCalendar = __webpack_require__(841);

var outlookAPI = _interopRequireWildcard(_outlookCalendar);

var _diaryForm = __webpack_require__(842);

var diaryForm = _interopRequireWildcard(_diaryForm);

var _editDiary = __webpack_require__(466);

var editDiary = _interopRequireWildcard(_editDiary);

var _groupSettings = __webpack_require__(843);

var groupSettings = _interopRequireWildcard(_groupSettings);

var _userSettings = __webpack_require__(844);

var userSettings = _interopRequireWildcard(_userSettings);

var _deviceOrientation = __webpack_require__(1743);

var deviceOrientation = _interopRequireWildcard(_deviceOrientation);

var _productTour = __webpack_require__(845);

var productTour = _interopRequireWildcard(_productTour);

var _registrationUrl = __webpack_require__(846);

var registrationUrl = _interopRequireWildcard(_registrationUrl);

var _accountOtherMembersCount = __webpack_require__(847);

var accountOtherMembersCount = _interopRequireWildcard(_accountOtherMembersCount);

var _urlInfo = __webpack_require__(848);

var urlInfo = _interopRequireWildcard(_urlInfo);

var _imagesView = __webpack_require__(849);

var imagesView = _interopRequireWildcard(_imagesView);

var _translate = __webpack_require__(262);

var translate = _interopRequireWildcard(_translate);

var _dashboard = __webpack_require__(850);

var dashboard = _interopRequireWildcard(_dashboard);

var _submissionSchedules = __webpack_require__(851);

var submissionSchedules = _interopRequireWildcard(_submissionSchedules);

var _report = __webpack_require__(852);

var report = _interopRequireWildcard(_report);

var _diaryReport = __webpack_require__(467);

var diaryReport = _interopRequireWildcard(_diaryReport);

var _divisions = __webpack_require__(468);

var divisions = _interopRequireWildcard(_divisions);

var _divisionSettings = __webpack_require__(856);

var divisionSettings = _interopRequireWildcard(_divisionSettings);

var _divisionsGroupManager = __webpack_require__(857);

var divisionGroupManager = _interopRequireWildcard(_divisionsGroupManager);

var _menus = __webpack_require__(858);

var menus = _interopRequireWildcard(_menus);

var _review = __webpack_require__(859);

var review = _interopRequireWildcard(_review);

var _reviewSetting = __webpack_require__(860);

var reviewSetting = _interopRequireWildcard(_reviewSetting);

var _showTimestampeSetting = __webpack_require__(861);

var showTimeStampSetting = _interopRequireWildcard(_showTimestampeSetting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/index.js

var actions = (0, _reduce2.default)([account, activityReport, alertMessage, announce, attachments, buildNo, chatMessages, chatRooms, comments, diaries, favorite, block, groups, homeDiaries, homeNotifications, homeSubDiaries, kpiChart, kpi, likes, pins, notifications, organizations, preservedQueries, reactChat, savedDiaries, sessions, subDiaries, subscribe, templates, uploadFile, uploadVideo, user, users, sidebar, socket, rightSidebar, googleAPI, outlookAPI, diaryForm, editDiary, groupSettings, userSettings, deviceOrientation, productTour, registrationUrl, accountOtherMembersCount, urlInfo, imagesView, translate, dashboard, submissionSchedules, report, diaryReport, divisions, divisionSettings, divisionGroupManager, menus, review, reviewSetting, showTimeStampSetting], function (result, value) {
  return (0, _assign2.default)(result, value);
}, {});

exports.default = actions;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ThemeProvider = __webpack_require__(1765);

Object.defineProperty(exports, 'ThemeProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ThemeProvider).default;
  }
});

var _themr = __webpack_require__(1767);

Object.defineProperty(exports, 'themr', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_themr).default;
  }
});
Object.defineProperty(exports, 'themeable', {
  enumerable: true,
  get: function get() {
    return _themr.themeable;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var outer_args = arguments;

  return function (Component) {
    /*
    var displayName = Component.name
    class LoggerComponent extends React.Component {
      UNSAFE_componentWillReceiveProps(nextProps) {
        var { ui, ...otherProps } = this.props
        var { ui, ...nextOtherProps } = nextProps
        if (!shallowEqual(otherProps, nextOtherProps) || !shallowEqual(this.props.ui, nextProps.ui)) {
          var changedKeys = filter(Object.keys(nextProps), (key)=> typeof nextProps[key] != 'function' && key != 'ui' && this.props[key] !== nextProps[key])
          var changedUiKeys = nextProps.ui && filter(Object.keys(nextProps.ui), (key)=> typeof nextProps.ui[key] != 'function' && this.props.ui[key] !== nextProps.ui[key]) || []
          if (changedKeys.length > 0 || changedUiKeys.length > 0)
            global.nativeLoggingHook(`${displayName} changed props:${changedKeys.join(',')} changed ui props:${changedUiKeys.join(',')}`, 1)
        }
      }
       render() {
        return <Component {...this.props} />
      }
    }
     return reduceRight(outer_args, (result, func)=> {
      return func(result)
    }, LoggerComponent)
    */

    return (0, _reduceRight2.default)(outer_args, function (result, func) {
      return func(result);
    }, Component);
  };
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowEqual = __webpack_require__(264);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _reduceRight = __webpack_require__(1748);

var _reduceRight2 = _interopRequireDefault(_reduceRight);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_ALERT_MESSAGE = exports.EMIT_ALERT_MESSAGE = undefined;
exports.emitAlertMessage = emitAlertMessage;
exports.clearAlertMessage = clearAlertMessage;

var _route = __webpack_require__(67);

var EMIT_ALERT_MESSAGE = exports.EMIT_ALERT_MESSAGE = "EMIT_ALERT_MESSAGE";
// src/actions/alert-message.js

var CLEAR_ALERT_MESSAGE = exports.CLEAR_ALERT_MESSAGE = "CLEAR_ALERT_MESSAGE";

function handleError(message) {
  var trial_expired = false;
  var re_trial = false;

  switch (message.status) {
    case 401:
    case 402:
    case 410:
      trial_expired = message.status == 402 || !!(message.error[0] && message.error[0].match(/無料トライアル期間が終了/));
      re_trial = message.status == 410 || !!(message.error[0] && message.error[0].match(/お客様のトライアル期間は終了/));
      (0, _route.pushRoute)('login');
      break;
    case 503:
      (0, _route.pushRoute)('unavailable');
      break;
    case 404:
      if (message.error.code && message.error.code.match(/MailboxNotEnabledForRESTAPI/)) {
        message = 'error:MSアカウント';
      }
      break;
  }

  return { trial_expired: trial_expired, re_trial: re_trial, message: message };
}

function emitAlertMessage(message, category) {
  var result = message.error ? handleError(message) : { message: message };
  var alertMessage = result.message.error ? result.message.error : result.message;

  return {
    type: EMIT_ALERT_MESSAGE,
    message: alertMessage,
    category: category,
    trial_expired: result.trial_expired,
    re_trial: result.re_trial
  };
}

function clearAlertMessage() {
  return {
    type: CLEAR_ALERT_MESSAGE
  };
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Component) {
  var LifecycleComponent = function (_React$PureComponent) {
    _inherits(LifecycleComponent, _React$PureComponent);

    function LifecycleComponent() {
      _classCallCheck(this, LifecycleComponent);

      return _possibleConstructorReturn(this, (LifecycleComponent.__proto__ || Object.getPrototypeOf(LifecycleComponent)).apply(this, arguments));
    }

    _createClass(LifecycleComponent, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        this.props.willMount && (0, _runAfterInteractions2.default)(function () {
          return _this2.props.willMount(_this2.props);
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.props.willUpdate && this.props.willUpdate(this.props, nextProps);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var _this3 = this;

        this.props.willUnmount && (0, _runAfterInteractions2.default)(function () {
          return _this3.props.willUnmount(_this3.props);
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, this.props);
      }
    }]);

    return LifecycleComponent;
  }(_react2.default.PureComponent);

  LifecycleComponent.displayName = 'Lifecycle(' + Component.displayName + ')';
  return LifecycleComponent;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _runAfterInteractions = __webpack_require__(1753);

var _runAfterInteractions2 = _interopRequireDefault(_runAfterInteractions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/helpers/lifecycle.js

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var APP_BAR = exports.APP_BAR = 'RTAppBar';
var AUTOCOMPLETE = exports.AUTOCOMPLETE = 'RTAutocomplete';
var AVATAR = exports.AVATAR = 'RTAvatar';
var BUTTON = exports.BUTTON = 'RTButton';
var CARD = exports.CARD = 'RTCard';
var CHIP = exports.CHIP = 'RTChip';
var CHECKBOX = exports.CHECKBOX = 'RTCheckbox';
var DATE_PICKER = exports.DATE_PICKER = 'RTDatePicker';
var DIALOG = exports.DIALOG = 'RTDialog';
var DRAWER = exports.DRAWER = 'RTDrawer';
var DROPDOWN = exports.DROPDOWN = 'RTDropdown';
var INPUT = exports.INPUT = 'RTInput';
var LAYOUT = exports.LAYOUT = 'RTLayout';
var LINK = exports.LINK = 'RTLink';
var LIST = exports.LIST = 'RTList';
var MENU = exports.MENU = 'RTMenu';
var NAVIGATION = exports.NAVIGATION = 'RTNavigation';
var OVERLAY = exports.OVERLAY = 'RTOverlay';
var PROGRESS_BAR = exports.PROGRESS_BAR = 'RTProgressBar';
var RADIO = exports.RADIO = 'RTRadio';
var RIPPLE = exports.RIPPLE = 'RTRipple';
var SLIDER = exports.SLIDER = 'RTSlider';
var SNACKBAR = exports.SNACKBAR = 'RTSnackbar';
var SWITCH = exports.SWITCH = 'RTSwitch';
var TABLE = exports.TABLE = 'RTTable';
var TABS = exports.TABS = 'RTTabs';
var TOOLTIP = exports.TOOLTIP = 'RTTooltip';
var TIME_PICKER = exports.TIME_PICKER = 'RTTimePicker';

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = ui;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _shallowEqual = __webpack_require__(264);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // src/helpers/ui-state.js

function getState(state, props) {
  var _state = {};
  (0, _each2.default)(state, function (value, key) {
    _state[key] = typeof value == 'function' ? value(props) : value;
  });
  return _state;
}

/*
  ui(opts)(Component)とすることで、Componentコンポーネントの props に updateUI メソッド, ui オブジェクトが埋め込まれる。
  コンポーネント内からは、
    - this.props.ui で ui を参照することができる
    - this.props.updateUI で ui を書き換えることができる
    - this.props.resetUI で ui を初期値に戻すことができる
  optsには以下の内容を指定する:
    - state: uiの初期状態
  redux-uiの簡易的な置き換えが可能、かつこの実装の方がおそらく高速に動作する
*/
function ui() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { inherit: true };

  return function (Component) {
    var UIComponent = function (_React$Component) {
      _inherits(UIComponent, _React$Component);

      function UIComponent(props, context) {
        _classCallCheck(this, UIComponent);

        var _this = _possibleConstructorReturn(this, (UIComponent.__proto__ || Object.getPrototypeOf(UIComponent)).call(this, props, context));

        _this._resetState = function () {
          return _this.setState({ ui: getState(opts.state, _this.props) });
        };

        _this._setState = function (state) {
          return _this.setState(function (_state) {
            return { ui: Object.assign({}, _state.ui, state) };
          });
        };

        _this.state = { ui: getState(opts.state, props) };
        return _this;
      }

      _createClass(UIComponent, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, _extends({}, this.props, { ui: this.state.ui, updateUI: this._setState, resetUI: this._resetState }));
        }
      }]);

      return UIComponent;
    }(_react2.default.Component);

    UIComponent.displayName = 'ui(' + Component.displayName + ')';
    return UIComponent;
  };
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
// src/helpers/store.js

exports.stripArray = stripArray;
exports.mergeArray = mergeArray;
exports.deleteArray = deleteArray;
exports.updateArray = updateArray;
exports.getArray = getArray;
exports.sortArray = sortArray;
exports.findTree = findTree;
exports.replaceTree = replaceTree;

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _findIndex = __webpack_require__(263);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _some = __webpack_require__(161);

var _some2 = _interopRequireDefault(_some);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function stripArray(array) {
  if (array instanceof Array && array.length > 0) return array;else return undefined;
}

function mergeArray(key, orig, adding) {
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'replace_or_append';

  var result = Object.assign([], orig);

  (0, _each2.default)(adding, function (adding_elm) {

    var index = (0, _findIndex2.default)(result, function (orig_elm) {
      return orig_elm[key] == adding_elm[key];
    });

    if (mode == 'replace_or_append') {
      if (index > -1) result[index] = adding_elm;else result.push(adding_elm);
    } else if (mode == 'replace_or_prepend') {
      if (index > -1) result[index] = adding_elm;else result.unshift(adding_elm);
    } else if (mode == 'append') {
      if (index > -1) result.splice(index, 1);
      result.push(adding_elm);
    } else if (mode == 'prepend') {
      if (index > -1) result.splice(index, 1);
      result.unshift(adding_elm);
    } else if (mode == 'discard') {
      if (index > -1) result[index] = adding_elm;
    }
  });
  // マージした結果、配列の中身に何も変化がなかった場合は、元の配列をそのまま返す
  if (mode == 'discard' && orig && result && orig.length == result.length && !(0, _some2.default)(Object.keys(result), function (i) {
    return result[i] !== orig[i];
  })) return orig;

  return result;
}

function deleteArray(key, orig, id) {
  var result = Object.assign([], orig);
  var index = (0, _findIndex2.default)(result, function (elm) {
    return elm[key] == id;
  });

  if (index > -1) result.splice(index, 1);

  return result;
}

function updateArray(key, orig, id, attr, val) {
  var result = Object.assign([], orig);
  var index = (0, _findIndex2.default)(result, function (elm) {
    return elm[key] == id;
  });
  if (index > -1) {
    if ((typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) == 'object' || result[index][attr] != val) {
      result[index] = Object.assign({}, result[index], (typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) == 'object' ? attr : _defineProperty({}, attr, val));
      return result;
    }
  }
  return orig;
}

function getArray(key, orig, id) {
  return (0, _find2.default)(orig, function (elm) {
    return elm[key] == id;
  });
}

function sortArray(orig, attr) {
  var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var result = Object.assign([], orig);
  return result.sort(function (a, b) {
    if (typeof a[attr] == 'undefined') return typeof b[attr] == 'undefined' ? 0 : order;
    if (typeof b[attr] == 'undefined') return -1 * order;
    return a[attr] > b[attr] ? order : a[attr] == b[attr] ? 0 : -1 * order;
  });
}

function findTree(key, children, id) {
  for (var i = 0; children && i < children.length; i++) {
    if (children[i][key] == id) return children[i];

    var r = findTree(key, children[i].children, id);
    if (r) return r;
  }

  return undefined;
}

function replaceTree(key, children, node) {
  for (var i = 0; children && i < children.length; i++) {
    if (children[i][key] == node[key]) {
      children[i] = node;
      return children;
    }

    replaceTree(key, children[i].children, node);
  }

  return children;
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var util = __webpack_require__(68);

// browser specific modules
util.crypto.lib = __webpack_require__(1482);
util.Buffer = __webpack_require__(76).Buffer;
util.url = __webpack_require__(459);
util.querystring = __webpack_require__(320);
util.environment = 'js';

var AWS = __webpack_require__(7);
module.exports = AWS;

__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(1491);
__webpack_require__(1495);
__webpack_require__(1496);
__webpack_require__(1500);

// Load the DOMParser XML parser
AWS.XML.Parser = __webpack_require__(1501);

// Load the XHR HttpClient
__webpack_require__(1502);

if (typeof process === 'undefined') {
  process = {
    browser: true
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(103)(module)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1163);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _accessToken = __webpack_require__(220);

var _accessToken2 = _interopRequireDefault(_accessToken);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _querystring = __webpack_require__(320);

var _querystring2 = _interopRequireDefault(_querystring);

var _s3upload = __webpack_require__(1349);

var _s3upload2 = _interopRequireDefault(_s3upload);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _fetch(method, path, query, file, onprogress) {
  var url = _config2.default.baseApiUrl + path;
  var body = null;
  if (query) {
    switch (method) {
      case 'GET':
      case 'DELETE':
        if (query) url = url + '?' + _querystring2.default.stringify(query);
        break;
      case 'POST':
      case 'PUT':
        if (file) {
          body = new FormData();
          body.append('file', file);
          (0, _each2.default)(query, function (value, key) {
            body.append(key, value.toString());
          });
        } else {
          body = JSON.stringify(query);
        }
    }
  }

  return new Promise(function (resolve, reject) {
    _accessToken2.default.get(function (token) {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url);

      //xhr.withCredentials = true
      xhr.setRequestHeader('Accept', 'application/json');
      !file && xhr.setRequestHeader('Content-Type', 'application/json');

      if (token) xhr.setRequestHeader('Authorization', token);

      xhr.onload = function () {
        try {
          var json = JSON.parse(xhr.responseText);
          if (json.status == 'ok') resolve(json.results);else {
            reject({ error: json.error, status: xhr.status });
          }
        } catch (e) {
          reject({ error: xhr.status == 503 && "error:unavailable" || "error:fetch_error", status: xhr.status });
        }
      };

      xhr.onabort = xhr.ontimeout = xhr.onerror = function () {
        reject({ error: xhr.status == 503 && "error:unavailable" || "error:fetch_error", status: xhr.status });
      };

      if (onprogress) xhr.onprogress = onprogress;

      xhr.send(body);
    });
  });
}
// src/actions/gamba-api.js

exports.default = {
  get: function get(path) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _fetch('GET', path, query, null);
  },

  post: function post(path) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _fetch('POST', path, query, null);
  },

  put: function put(path) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _fetch('PUT', path, query, null);
  },

  delete: function _delete(path) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _fetch('DELETE', path, query, null);
  },

  upload: function upload(path, query, file, onprogress) {
    return _fetch('POST', path, query, file, onprogress);
  },

  s3upload: _s3upload2.default
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontIcon = undefined;

var _FontIcon = __webpack_require__(81);

exports.default = _FontIcon.FontIcon;
exports.FontIcon = _FontIcon.FontIcon;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = exports.ListItem = exports.ListDivider = exports.ListCheckbox = exports.ListItemText = exports.ListSubHeader = exports.ListItemLayout = exports.ListItemContent = exports.ListItemActions = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _avatar = __webpack_require__(26);

var _checkbox = __webpack_require__(54);

var _ListItemText = __webpack_require__(887);

var _ListItemAction = __webpack_require__(888);

var _ListSubHeader = __webpack_require__(1827);

var _ListDivider = __webpack_require__(1828);

var _List = __webpack_require__(1829);

var _ListItem = __webpack_require__(889);

var _ListCheckbox = __webpack_require__(1830);

var _ListItemActions = __webpack_require__(891);

var _ListItemContent = __webpack_require__(343);

var _ListItemLayout = __webpack_require__(890);

var _ripple = __webpack_require__(162);

var _ripple2 = _interopRequireDefault(_ripple);

var _theme = __webpack_require__(266);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applyTheme = function applyTheme(Component) {
  return (0, _reactCssThemr.themr)(_identifiers.LIST, _theme2.default)(Component);
};
var ripple = (0, _ripple2.default)({ centered: false, listItemIgnore: true });
var ThemedListItemAction = applyTheme(_ListItemAction.ListItemAction);
var ThemedListSubHeader = applyTheme(_ListSubHeader.ListSubHeader);
var ThemedListItemText = applyTheme(_ListItemText.ListItemText);
var ThemedListDivider = applyTheme(_ListDivider.ListDivider);
var ThemedListItemContent = applyTheme((0, _ListItemContent.listItemContentFactory)(ThemedListItemText));
var ThemedListItemActions = applyTheme((0, _ListItemActions.listItemActionsFactory)(ThemedListItemAction));
var ThemedListItemLayout = applyTheme((0, _ListItemLayout.listItemLayoutFactory)(_avatar.Avatar, ThemedListItemContent, ThemedListItemActions));
var ThemedListCheckbox = applyTheme((0, _ListCheckbox.listCheckboxFactory)(_checkbox.Checkbox, ThemedListItemContent));
var ThemedListItem = applyTheme((0, _ListItem.listItemFactory)(ripple, ThemedListItemLayout, ThemedListItemContent));
var ThemedList = applyTheme((0, _List.listFactory)(ThemedListItem));

exports.ListItemActions = ThemedListItemActions;
exports.ListItemContent = ThemedListItemContent;
exports.ListItemLayout = ThemedListItemLayout;
exports.ListSubHeader = ThemedListSubHeader;
exports.ListItemText = ThemedListItemText;
exports.ListCheckbox = ThemedListCheckbox;
exports.ListDivider = ThemedListDivider;
exports.ListItem = ThemedListItem;
exports.List = ThemedList;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Avatar = __webpack_require__(342);

var _FontIcon = __webpack_require__(81);

var _theme = __webpack_require__(1825);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Avatar = (0, _Avatar.avatarFactory)(_FontIcon.FontIcon);
var ThemedAvatar = (0, _reactCssThemr.themr)(_identifiers.AVATAR, _theme2.default)(Avatar);

exports.default = ThemedAvatar;
exports.Avatar = ThemedAvatar;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.setId = setId;
exports.track = track;
exports.trackPage = trackPage;
exports.trackHandlers = trackHandlers;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mixpanel = __webpack_require__(1818);

var _mixpanel2 = _interopRequireDefault(_mixpanel);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/helpers/analytics.js

_config2.default.mixpanelToken && _mixpanel2.default.init(_config2.default.mixpanelToken);

var user_id, account_id;

function setId(_user_id, _account_id) {
  user_id = _user_id;
  account_id = _account_id;
}

function track(event) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _config2.default.mixpanelToken && _mixpanel2.default.track(event, Object.assign({}, opts, { distinct_id: user_id, account_id: account_id }));
}

function trackPage(event) {
  return function (Component) {
    var TrackComponent = function (_React$Component) {
      _inherits(TrackComponent, _React$Component);

      function TrackComponent() {
        _classCallCheck(this, TrackComponent);

        return _possibleConstructorReturn(this, (TrackComponent.__proto__ || Object.getPrototypeOf(TrackComponent)).apply(this, arguments));
      }

      _createClass(TrackComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          track(event);
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, this.props);
        }
      }]);

      return TrackComponent;
    }(_react2.default.Component);

    TrackComponent.displayName = 'TrackPage(' + Component.displayName + ')';
    return TrackComponent;
  };
}

function trackHandlers(name, event) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return function (Component) {
    var TrackComponent = function (_React$Component2) {
      _inherits(TrackComponent, _React$Component2);

      function TrackComponent(props) {
        _classCallCheck(this, TrackComponent);

        var _this2 = _possibleConstructorReturn(this, (TrackComponent.__proto__ || Object.getPrototypeOf(TrackComponent)).call(this, props));

        _this2._mergeProps = {};
        _this2._mergeProps[name] = function () {
          var _this2$props;

          track(event, opts, { distinct_id: user_id, account_id: account_id });
          (_this2$props = _this2.props)[name].apply(_this2$props, arguments);
        };
        return _this2;
      }

      _createClass(TrackComponent, [{
        key: 'render',
        value: function render() {
          var props = Object.assign({}, this.props, this._mergeProps);
          return _react2.default.createElement(Component, props);
        }
      }]);

      return TrackComponent;
    }(_react2.default.Component);

    TrackComponent.displayName = 'TrackHandlers(' + (Component.displayName || Component.name) + ')';
    return TrackComponent;
  };
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardTitle = exports.CardText = exports.CardMedia = exports.CardActions = exports.Card = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Card = __webpack_require__(1832);

var _CardActions = __webpack_require__(1833);

var _CardMedia = __webpack_require__(1834);

var _CardText = __webpack_require__(1835);

var _CardTitle = __webpack_require__(1836);

var _avatar = __webpack_require__(26);

var _theme = __webpack_require__(1837);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardTitle = (0, _CardTitle.cardTitleFactory)(_avatar.Avatar);
var ThemedCard = (0, _reactCssThemr.themr)(_identifiers.CARD, _theme2.default)(_Card.Card);
var ThemedCardActions = (0, _reactCssThemr.themr)(_identifiers.CARD, _theme2.default)(_CardActions.CardActions);
var ThemedCardMedia = (0, _reactCssThemr.themr)(_identifiers.CARD, _theme2.default)(_CardMedia.CardMedia);
var ThemedCardText = (0, _reactCssThemr.themr)(_identifiers.CARD, _theme2.default)(_CardText.CardText);
var ThemedCardTitle = (0, _reactCssThemr.themr)(_identifiers.CARD, _theme2.default)(CardTitle);

exports.default = ThemedCard;
exports.Card = ThemedCard;
exports.CardActions = ThemedCardActions;
exports.CardMedia = ThemedCardMedia;
exports.CardText = ThemedCardText;
exports.CardTitle = ThemedCardTitle;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// src/config/index.js
// import * as msal from '@azure/msal-browser';
var config;

if (true) config = {
  packageName: 'com.rikkeisoft.gamba',
  baseUrl: 'https://www.getgamba.com/',
  baseApiUrl: 'https://www.getgamba.com/api/v3',
  webSocketUrl: 'wss://ws.getgamba.com/v3websocket',
  textareaHtml: '/n/textarea.html',
  googleAnalyticsID: 'UA-36388017-4',
  mixpanelToken: '182757b1ecae6c9df7424454b3842780',
  integrationKeys: {
    google: { APIKey: 'AIzaSyB2xFJD9hgt9xPBrnHOVn9w_V02QnA7rWw',
      scope: ["https://www.googleapis.com/auth/calendar.readonly", "https://www.googleapis.com/auth/drive.readonly", "https://www.googleapis.com/auth/drive.file", "https://www.googleapis.com/auth/userinfo.email", "https://www.googleapis.com/auth/userinfo.profile"],
      redirect_uri: 'https://www.getgamba.com/api/v3/app_redirect/google_oauth2',
      gcmSenderId: '1019125704984',
      clientSecret: '_4AsfaUTewfYaKOT-Bv6qX8w',
      clientIdIOS: '175355942715-b319334tv10926p25i3dodviqsppslqu.apps.googleusercontent.com',
      clientId: '175355942715.apps.googleusercontent.com' }
  },
  sentry: {
    dsn: 'https://674fcc50300740259aa68736eed7014b@o531922.ingest.sentry.io/5651430',
    environment: "production",
    isPerformMonitorEnable: true // パフォーマンスモニタリングを有効化
  },
  graph: {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphCalendarEndpoint: "https://graph.microsoft.com/v1.0/me/calendars",
    graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages"
  },
  msal: {
    auth: {
      clientId: "bb7a36f6-a000-4308-a8ec-56c04a3d18ff", // Microsoft Entraの「gamba」アプリを使用
      redirectUri: "https://www.getgamba.com/window-close"
    },
    cache: {
      cacheLocation: "localStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
  },
  aws: {
    lambdaEndpoint: "https://tisfiy6gkzs4oobyfaqnkw7t740isdfk.lambda-url.ap-northeast-1.on.aws",
    accessKeyId: "AKIAVOJYLJZG45QU6MXE",
    secretAccessKey: "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"
  },
  env: 'production'
};else if (process.env.RAILS_ENV == 'staging') config = {
  packageName: 'com.rikkeisoft.gamba',
  baseUrl: 'https://dev.getgamba.com/',
  baseApiUrl: 'https://dev.getgamba.com/api/v3',
  webSocketUrl: 'wss://dev.getgamba.com/v3websocket',
  textareaHtml: '/n/textarea.html',
  googleAnalyticsID: 'UA-36388017-5',
  mixpanelToken: undefined,
  integrationKeys: {
    google: { APIKey: 'AIzaSyB2xFJD9hgt9xPBrnHOVn9w_V02QnA7rWw',
      scope: ["https://www.googleapis.com/auth/calendar.readonly", "https://www.googleapis.com/auth/drive.readonly", "https://www.googleapis.com/auth/drive.file", "https://www.googleapis.com/auth/userinfo.email", "https://www.googleapis.com/auth/userinfo.profile"],
      redirect_uri: 'https://dev.getgamba.com/api/v3/app_redirect/google_oauth2',
      gcmSenderId: '156469777344',
      clientSecret: 'v6aBZN-zPi8Y-HL8k7ubxM0a',
      clientIdIOS: '175355942715-b319334tv10926p25i3dodviqsppslqu.apps.googleusercontent.com',
      clientId: '175355942715-me6hh7vj8vlcggfvd6s09kec7nrft59a.apps.googleusercontent.com' }
  },
  sentry: {
    dsn: 'https://674fcc50300740259aa68736eed7014b@o531922.ingest.sentry.io/5651430',
    environment: process.env.RAILS_ENV
  },
  graph: {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphCalendarEndpoint: "https://graph.microsoft.com/v1.0/me/calendars",
    graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages"
  },
  env: 'staging',
  msal: {
    auth: {
      clientId: "dba35891-65ac-479e-9271-a59996a3b70e", // Microsoft Entraの「gamba」アプリを使用
      redirectUri: "https://dev.getgamba.com/window-close"
    },
    cache: {
      cacheLocation: "localStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
  },
  aws: {
    lambdaEndpoint: "https://tisfiy6gkzs4oobyfaqnkw7t740isdfk.lambda-url.ap-northeast-1.on.aws",
    accessKeyId: "AKIAVOJYLJZG45QU6MXE",
    secretAccessKey: "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"
  }
};else config = {
  packageName: 'com.rikkeisoft.gamba',
  baseUrl: 'http://localhost:3000/',
  baseApiUrl: 'http://localhost:3000/api/v3',
  webSocketUrl: 'ws://localhost:3003/v3websocket',
  textareaHtml: '/textarea.html',
  googleAnalyticsID: 'UA-36388017-5',
  mixpanelToken: undefined,
  integrationKeys: {
    google: { APIKey: 'AIzaSyB2xFJD9hgt9xPBrnHOVn9w_V02QnA7rWw',
      scope: ["https://www.googleapis.com/auth/calendar.readonly", "https://www.googleapis.com/auth/drive.readonly", "https://www.googleapis.com/auth/drive.file", "https://www.googleapis.com/auth/userinfo.email", "https://www.googleapis.com/auth/userinfo.profile"],
      redirect_uri: 'http://localhost:3000/api/v3/app_redirect/google_oauth2',
      gcmSenderId: '156469777344',
      clientSecret: 'OVCKw0a5OxVWRzKsgRln8nmy',
      clientIdIOS: '175355942715-b319334tv10926p25i3dodviqsppslqu.apps.googleusercontent.com',
      clientId: '175355942715-9hr5aakabmdc5diba82k42gi2nspckkq.apps.googleusercontent.com' }
  },
  sentry: {
    dsn: 'https://674fcc50300740259aa68736eed7014b@o531922.ingest.sentry.io/5651430',
    environment: 'development'
  },
  graph: {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphCalendarEndpoint: "https://graph.microsoft.com/v1.0/me/calendars",
    graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages"
  },
  aws: {
    lambdaEndpoint: "https://tisfiy6gkzs4oobyfaqnkw7t740isdfk.lambda-url.ap-northeast-1.on.aws",
    accessKeyId: "AKIAVOJYLJZG45QU6MXE",
    secretAccessKey: "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",
    region: 'ap-northeast-1'
  },
  msal: {
    auth: {
      clientId: "dba35891-65ac-479e-9271-a59996a3b70e", // Microsoft Entraの「gamba」アプリを使用
      redirectUri: "http://localhost:8888/"
    },
    cache: {
      cacheLocation: "localStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
    // system: {
    //   loggerOptions: {
    //       loggerCallback: (level, message, containsPii) => {
    //           if (containsPii) {
    //               return;
    //           }
    //           switch (level) {
    //               case msal.LogLevel.Error:
    //                   console.error(message);
    //                   return;
    //               case msal.LogLevel.Info:
    //                   console.info(message);
    //                   return;
    //               case msal.LogLevel.Verbose:
    //                   console.debug(message);
    //                   return;
    //               case msal.LogLevel.Warning:
    //                   console.warn(message);
    //                   return;
    //           }
    //       }
    //   }
    // },
  },
  env: 'development'
};

config.codePushKeys = {
  android: {
    staging: "_Xii8gQtfTNcoMoOESkOPy7cokav5614df7a-9884-424f-9dae-4f673820adf9",
    production: "nBreEWuVGbl50Axz4JJaTZoo24o85614df7a-9884-424f-9dae-4f673820adf9"
  },
  ios: {
    staging: "TY4DtBfMkrWAdtTx5TS9mKP5S95_5614df7a-9884-424f-9dae-4f673820adf9",
    production: "h-mpAI2cwKfon4_9_yRO6wT8VGQk5614df7a-9884-424f-9dae-4f673820adf9"
  }
};
config.emojiPNG = 'https://cdn.jsdelivr.net/emojione/assets/4.5/png/128/';
config.BUILD_NO = "202507040022";
config.timerexUrl = 'https://timerex.net/s/gambarese/6c59c6dd';

exports.default = config;

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client_AuthorizationCodeClient_js__ = __webpack_require__(2725);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__client_AuthorizationCodeClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client_DeviceCodeClient_js__ = __webpack_require__(2726);
/* unused harmony reexport DeviceCodeClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client_RefreshTokenClient_js__ = __webpack_require__(1112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_2__client_RefreshTokenClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client_ClientCredentialClient_js__ = __webpack_require__(2727);
/* unused harmony reexport ClientCredentialClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__client_OnBehalfOfClient_js__ = __webpack_require__(2728);
/* unused harmony reexport OnBehalfOfClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__client_SilentFlowClient_js__ = __webpack_require__(2729);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_5__client_SilentFlowClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__client_UsernamePasswordClient_js__ = __webpack_require__(2730);
/* unused harmony reexport UsernamePasswordClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_ClientConfiguration_js__ = __webpack_require__(1099);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_7__config_ClientConfiguration_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__account_AuthToken_js__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__account_AuthToken_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_8__account_AuthToken_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__account_CcsCredential_js__ = __webpack_require__(295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__account_CcsCredential_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__account_ClientInfo_js__ = __webpack_require__(241);
/* unused harmony reexport buildClientInfo */
/* unused harmony reexport buildClientInfoFromHomeAccountId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__authority_Authority_js__ = __webpack_require__(1113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_11__authority_Authority_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__authority_AuthorityOptions_js__ = __webpack_require__(578);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__authority_AuthorityOptions_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__authority_AuthorityFactory_js__ = __webpack_require__(2736);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_13__authority_AuthorityFactory_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__authority_AuthorityType_js__ = __webpack_require__(397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__authority_AuthorityType_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__authority_ProtocolMode_js__ = __webpack_require__(1114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_15__authority_ProtocolMode_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__cache_CacheManager_js__ = __webpack_require__(1101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_16__cache_CacheManager_js__["a"]; });
/* unused harmony reexport DefaultStorageClass */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cache_entities_CacheRecord_js__ = __webpack_require__(1108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_17__cache_entities_CacheRecord_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__cache_entities_CredentialEntity_js__ = __webpack_require__(398);
/* unused harmony reexport CredentialEntity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__cache_entities_AppMetadataEntity_js__ = __webpack_require__(1110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_19__cache_entities_AppMetadataEntity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__cache_entities_AccountEntity_js__ = __webpack_require__(579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_20__cache_entities_AccountEntity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__cache_entities_IdTokenEntity_js__ = __webpack_require__(1105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_21__cache_entities_IdTokenEntity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__cache_entities_AccessTokenEntity_js__ = __webpack_require__(1106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_22__cache_entities_AccessTokenEntity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__cache_entities_RefreshTokenEntity_js__ = __webpack_require__(1107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_23__cache_entities_RefreshTokenEntity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__cache_entities_ServerTelemetryEntity_js__ = __webpack_require__(1116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_24__cache_entities_ServerTelemetryEntity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__cache_entities_AuthorityMetadataEntity_js__ = __webpack_require__(1115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_25__cache_entities_AuthorityMetadataEntity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__cache_entities_ThrottlingEntity_js__ = __webpack_require__(2737);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_26__cache_entities_ThrottlingEntity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__cache_persistence_TokenCacheContext_js__ = __webpack_require__(1111);
/* unused harmony reexport TokenCacheContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__network_INetworkModule_js__ = __webpack_require__(2738);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_28__network_INetworkModule_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__network_NetworkManager_js__ = __webpack_require__(1102);
/* unused harmony reexport NetworkManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__network_ThrottlingUtils_js__ = __webpack_require__(1103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_30__network_ThrottlingUtils_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__url_UrlString_js__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_31__url_UrlString_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__crypto_ICrypto_js__ = __webpack_require__(1100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_32__crypto_ICrypto_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__crypto_JoseHeader_js__ = __webpack_require__(2739);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_33__crypto_JoseHeader_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__request_ScopeSet_js__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_34__request_ScopeSet_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__request_AuthenticationHeaderParser_js__ = __webpack_require__(2741);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_35__request_AuthenticationHeaderParser_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__logger_Logger_js__ = __webpack_require__(577);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_36__logger_Logger_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_36__logger_Logger_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__error_InteractionRequiredAuthError_js__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_37__error_InteractionRequiredAuthError_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_37__error_InteractionRequiredAuthError_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__error_AuthError_js__ = __webpack_require__(112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_38__error_AuthError_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_38__error_AuthError_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__error_ServerError_js__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_39__error_ServerError_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_40__error_ClientAuthError_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_40__error_ClientAuthError_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_41__error_ClientConfigurationError_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_41__error_ClientConfigurationError_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__utils_Constants_js__ = __webpack_require__(32);
/* unused harmony reexport AADServerParamKeys */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_42__utils_Constants_js__["e"]; });
/* unused harmony reexport CacheAccountType */
/* unused harmony reexport CacheType */
/* unused harmony reexport ClaimsRequestKeys */
/* unused harmony reexport CodeChallengeMethodValues */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_42__utils_Constants_js__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_42__utils_Constants_js__["n"]; });
/* unused harmony reexport Errors */
/* unused harmony reexport HeaderNames */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_42__utils_Constants_js__["s"]; });
/* unused harmony reexport ONE_DAY_IN_MS */
/* unused harmony reexport PasswordGrantConstants */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_42__utils_Constants_js__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_42__utils_Constants_js__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_42__utils_Constants_js__["A"]; });
/* unused harmony reexport SSOTypes */
/* unused harmony reexport THE_FAMILY_ID */
/* unused harmony reexport ThrottlingConstants */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_43__utils_StringUtils_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__utils_ProtocolUtils_js__ = __webpack_require__(1109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_44__utils_ProtocolUtils_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__utils_TimeUtils_js__ = __webpack_require__(114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_45__utils_TimeUtils_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__telemetry_server_ServerTelemetryManager_js__ = __webpack_require__(2742);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_46__telemetry_server_ServerTelemetryManager_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__telemetry_performance_PerformanceEvent_js__ = __webpack_require__(153);
/* unused harmony reexport IntFields */
/* unused harmony reexport PerformanceEventStatus */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_47__telemetry_performance_PerformanceEvent_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__telemetry_performance_PerformanceClient_js__ = __webpack_require__(1117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_48__telemetry_performance_PerformanceClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__telemetry_performance_StubPerformanceClient_js__ = __webpack_require__(2743);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_49__telemetry_performance_StubPerformanceClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__crypto_PopTokenGenerator_js__ = __webpack_require__(399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_50__crypto_PopTokenGenerator_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__packageMetadata_js__ = __webpack_require__(396);
/* unused harmony reexport version */
/*! @azure/msal-common v13.3.1 2023-10-27 */





















































//# sourceMappingURL=index.js.map


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AADAuthorityConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AADServerParamKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_METADATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTHORITY_METADATA_CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AuthenticationScheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AuthorityMetadataSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLIENT_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CacheAccountType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CacheOutcome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CacheType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ClaimsRequestKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CodeChallengeMethodValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Constants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CredentialType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return Errors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GrantType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return HeaderNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return JsonTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return OIDC_DEFAULT_SCOPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return OIDC_SCOPES; });
/* unused harmony export ONE_DAY_IN_MS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PasswordGrantConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PersistentCacheKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PromptValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return RegionDiscoveryOutcomes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return RegionDiscoverySources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ResponseCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ResponseMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SERVER_TELEM_CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SSOTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return Separators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return THE_FAMILY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return ThrottlingConstants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/*! @azure/msal-common v13.3.1 2023-10-27 */



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var Constants = {
    LIBRARY_NAME: "MSAL.JS",
    SKU: "msal.js.common",
    // Prefix for all library cache entries
    CACHE_PREFIX: "msal",
    // default authority
    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
    DEFAULT_COMMON_TENANT: "common",
    // ADFS String
    ADFS: "adfs",
    DSTS: "dstsv2",
    // Default AAD Instance Discovery Endpoint
    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
    // CIAM URL
    CIAM_AUTH_URL: ".ciamlogin.com",
    AAD_TENANT_DOMAIN_SUFFIX: ".onmicrosoft.com",
    // Resource delimiter - used for certain cache entries
    RESOURCE_DELIM: "|",
    // Placeholder for non-existent account ids/objects
    NO_ACCOUNT: "NO_ACCOUNT",
    // Claims
    CLAIMS: "claims",
    // Consumer UTID
    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
    // Default scopes
    OPENID_SCOPE: "openid",
    PROFILE_SCOPE: "profile",
    OFFLINE_ACCESS_SCOPE: "offline_access",
    EMAIL_SCOPE: "email",
    // Default response type for authorization code flow
    CODE_RESPONSE_TYPE: "code",
    CODE_GRANT_TYPE: "authorization_code",
    RT_GRANT_TYPE: "refresh_token",
    FRAGMENT_RESPONSE_MODE: "fragment",
    S256_CODE_CHALLENGE_METHOD: "S256",
    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
    AUTHORIZATION_PENDING: "authorization_pending",
    NOT_DEFINED: "not_defined",
    EMPTY_STRING: "",
    NOT_APPLICABLE: "N/A",
    FORWARD_SLASH: "/",
    IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
    IMDS_VERSION: "2020-06-01",
    IMDS_TIMEOUT: 2000,
    AZURE_REGION_AUTO_DISCOVER_FLAG: "TryAutoDetect",
    REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
    REGIONAL_AUTH_NON_MSI_QUERY_STRING: "allowestsrnonmsi=true",
    KNOWN_PUBLIC_CLOUDS: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"],
    TOKEN_RESPONSE_TYPE: "token",
    ID_TOKEN_RESPONSE_TYPE: "id_token",
    SHR_NONCE_VALIDITY: 240,
    INVALID_INSTANCE: "invalid_instance",
};
var OIDC_DEFAULT_SCOPES = [
    Constants.OPENID_SCOPE,
    Constants.PROFILE_SCOPE,
    Constants.OFFLINE_ACCESS_SCOPE
];
var OIDC_SCOPES = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["e" /* __spreadArrays */])(OIDC_DEFAULT_SCOPES, [
    Constants.EMAIL_SCOPE
]);
/**
 * Request header names
 */
var HeaderNames;
(function (HeaderNames) {
    HeaderNames["CONTENT_TYPE"] = "Content-Type";
    HeaderNames["RETRY_AFTER"] = "Retry-After";
    HeaderNames["CCS_HEADER"] = "X-AnchorMailbox";
    HeaderNames["WWWAuthenticate"] = "WWW-Authenticate";
    HeaderNames["AuthenticationInfo"] = "Authentication-Info";
    HeaderNames["X_MS_REQUEST_ID"] = "x-ms-request-id";
    HeaderNames["X_MS_HTTP_VERSION"] = "x-ms-httpver";
})(HeaderNames || (HeaderNames = {}));
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */
var PersistentCacheKeys;
(function (PersistentCacheKeys) {
    PersistentCacheKeys["ID_TOKEN"] = "idtoken";
    PersistentCacheKeys["CLIENT_INFO"] = "client.info";
    PersistentCacheKeys["ADAL_ID_TOKEN"] = "adal.idtoken";
    PersistentCacheKeys["ERROR"] = "error";
    PersistentCacheKeys["ERROR_DESC"] = "error.description";
    PersistentCacheKeys["ACTIVE_ACCOUNT"] = "active-account";
    PersistentCacheKeys["ACTIVE_ACCOUNT_FILTERS"] = "active-account-filters"; // new cache entry for active_account for a more robust version for browser
})(PersistentCacheKeys || (PersistentCacheKeys = {}));
/**
 * String constants related to AAD Authority
 */
var AADAuthorityConstants;
(function (AADAuthorityConstants) {
    AADAuthorityConstants["COMMON"] = "common";
    AADAuthorityConstants["ORGANIZATIONS"] = "organizations";
    AADAuthorityConstants["CONSUMERS"] = "consumers";
})(AADAuthorityConstants || (AADAuthorityConstants = {}));
/**
 * Keys in the hashParams sent by AAD Server
 */
var AADServerParamKeys;
(function (AADServerParamKeys) {
    AADServerParamKeys["CLIENT_ID"] = "client_id";
    AADServerParamKeys["REDIRECT_URI"] = "redirect_uri";
    AADServerParamKeys["RESPONSE_TYPE"] = "response_type";
    AADServerParamKeys["RESPONSE_MODE"] = "response_mode";
    AADServerParamKeys["GRANT_TYPE"] = "grant_type";
    AADServerParamKeys["CLAIMS"] = "claims";
    AADServerParamKeys["SCOPE"] = "scope";
    AADServerParamKeys["ERROR"] = "error";
    AADServerParamKeys["ERROR_DESCRIPTION"] = "error_description";
    AADServerParamKeys["ACCESS_TOKEN"] = "access_token";
    AADServerParamKeys["ID_TOKEN"] = "id_token";
    AADServerParamKeys["REFRESH_TOKEN"] = "refresh_token";
    AADServerParamKeys["EXPIRES_IN"] = "expires_in";
    AADServerParamKeys["STATE"] = "state";
    AADServerParamKeys["NONCE"] = "nonce";
    AADServerParamKeys["PROMPT"] = "prompt";
    AADServerParamKeys["SESSION_STATE"] = "session_state";
    AADServerParamKeys["CLIENT_INFO"] = "client_info";
    AADServerParamKeys["CODE"] = "code";
    AADServerParamKeys["CODE_CHALLENGE"] = "code_challenge";
    AADServerParamKeys["CODE_CHALLENGE_METHOD"] = "code_challenge_method";
    AADServerParamKeys["CODE_VERIFIER"] = "code_verifier";
    AADServerParamKeys["CLIENT_REQUEST_ID"] = "client-request-id";
    AADServerParamKeys["X_CLIENT_SKU"] = "x-client-SKU";
    AADServerParamKeys["X_CLIENT_VER"] = "x-client-VER";
    AADServerParamKeys["X_CLIENT_OS"] = "x-client-OS";
    AADServerParamKeys["X_CLIENT_CPU"] = "x-client-CPU";
    AADServerParamKeys["X_CLIENT_CURR_TELEM"] = "x-client-current-telemetry";
    AADServerParamKeys["X_CLIENT_LAST_TELEM"] = "x-client-last-telemetry";
    AADServerParamKeys["X_MS_LIB_CAPABILITY"] = "x-ms-lib-capability";
    AADServerParamKeys["X_APP_NAME"] = "x-app-name";
    AADServerParamKeys["X_APP_VER"] = "x-app-ver";
    AADServerParamKeys["POST_LOGOUT_URI"] = "post_logout_redirect_uri";
    AADServerParamKeys["ID_TOKEN_HINT"] = "id_token_hint";
    AADServerParamKeys["DEVICE_CODE"] = "device_code";
    AADServerParamKeys["CLIENT_SECRET"] = "client_secret";
    AADServerParamKeys["CLIENT_ASSERTION"] = "client_assertion";
    AADServerParamKeys["CLIENT_ASSERTION_TYPE"] = "client_assertion_type";
    AADServerParamKeys["TOKEN_TYPE"] = "token_type";
    AADServerParamKeys["REQ_CNF"] = "req_cnf";
    AADServerParamKeys["OBO_ASSERTION"] = "assertion";
    AADServerParamKeys["REQUESTED_TOKEN_USE"] = "requested_token_use";
    AADServerParamKeys["ON_BEHALF_OF"] = "on_behalf_of";
    AADServerParamKeys["FOCI"] = "foci";
    AADServerParamKeys["CCS_HEADER"] = "X-AnchorMailbox";
    AADServerParamKeys["RETURN_SPA_CODE"] = "return_spa_code";
    AADServerParamKeys["NATIVE_BROKER"] = "nativebroker";
    AADServerParamKeys["LOGOUT_HINT"] = "logout_hint";
})(AADServerParamKeys || (AADServerParamKeys = {}));
/**
 * Claims request keys
 */
var ClaimsRequestKeys;
(function (ClaimsRequestKeys) {
    ClaimsRequestKeys["ACCESS_TOKEN"] = "access_token";
    ClaimsRequestKeys["XMS_CC"] = "xms_cc";
})(ClaimsRequestKeys || (ClaimsRequestKeys = {}));
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */
var PromptValue = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * SSO Types - generated to populate hints
 */
var SSOTypes;
(function (SSOTypes) {
    SSOTypes["ACCOUNT"] = "account";
    SSOTypes["SID"] = "sid";
    SSOTypes["LOGIN_HINT"] = "login_hint";
    SSOTypes["ID_TOKEN"] = "id_token";
    SSOTypes["DOMAIN_HINT"] = "domain_hint";
    SSOTypes["ORGANIZATIONS"] = "organizations";
    SSOTypes["CONSUMERS"] = "consumers";
    SSOTypes["ACCOUNT_ID"] = "accountIdentifier";
    SSOTypes["HOMEACCOUNT_ID"] = "homeAccountIdentifier";
})(SSOTypes || (SSOTypes = {}));
/**
 * allowed values for codeVerifier
 */
var CodeChallengeMethodValues = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * allowed values for response_mode
 */
var ResponseMode;
(function (ResponseMode) {
    ResponseMode["QUERY"] = "query";
    ResponseMode["FRAGMENT"] = "fragment";
    ResponseMode["FORM_POST"] = "form_post";
})(ResponseMode || (ResponseMode = {}));
/**
 * allowed grant_type
 */
var GrantType;
(function (GrantType) {
    GrantType["IMPLICIT_GRANT"] = "implicit";
    GrantType["AUTHORIZATION_CODE_GRANT"] = "authorization_code";
    GrantType["CLIENT_CREDENTIALS_GRANT"] = "client_credentials";
    GrantType["RESOURCE_OWNER_PASSWORD_GRANT"] = "password";
    GrantType["REFRESH_TOKEN_GRANT"] = "refresh_token";
    GrantType["DEVICE_CODE_GRANT"] = "device_code";
    GrantType["JWT_BEARER"] = "urn:ietf:params:oauth:grant-type:jwt-bearer";
})(GrantType || (GrantType = {}));
/**
 * Account types in Cache
 */
var CacheAccountType;
(function (CacheAccountType) {
    CacheAccountType["MSSTS_ACCOUNT_TYPE"] = "MSSTS";
    CacheAccountType["ADFS_ACCOUNT_TYPE"] = "ADFS";
    CacheAccountType["MSAV1_ACCOUNT_TYPE"] = "MSA";
    CacheAccountType["GENERIC_ACCOUNT_TYPE"] = "Generic"; // NTLM, Kerberos, FBA, Basic etc
})(CacheAccountType || (CacheAccountType = {}));
/**
 * Separators used in cache
 */
var Separators;
(function (Separators) {
    Separators["CACHE_KEY_SEPARATOR"] = "-";
    Separators["CLIENT_INFO_SEPARATOR"] = ".";
})(Separators || (Separators = {}));
/**
 * Credential Type stored in the cache
 */
var CredentialType;
(function (CredentialType) {
    CredentialType["ID_TOKEN"] = "IdToken";
    CredentialType["ACCESS_TOKEN"] = "AccessToken";
    CredentialType["ACCESS_TOKEN_WITH_AUTH_SCHEME"] = "AccessToken_With_AuthScheme";
    CredentialType["REFRESH_TOKEN"] = "RefreshToken";
})(CredentialType || (CredentialType = {}));
/**
 * Combine all cache types
 */
var CacheType;
(function (CacheType) {
    CacheType[CacheType["ADFS"] = 1001] = "ADFS";
    CacheType[CacheType["MSA"] = 1002] = "MSA";
    CacheType[CacheType["MSSTS"] = 1003] = "MSSTS";
    CacheType[CacheType["GENERIC"] = 1004] = "GENERIC";
    CacheType[CacheType["ACCESS_TOKEN"] = 2001] = "ACCESS_TOKEN";
    CacheType[CacheType["REFRESH_TOKEN"] = 2002] = "REFRESH_TOKEN";
    CacheType[CacheType["ID_TOKEN"] = 2003] = "ID_TOKEN";
    CacheType[CacheType["APP_METADATA"] = 3001] = "APP_METADATA";
    CacheType[CacheType["UNDEFINED"] = 9999] = "UNDEFINED";
})(CacheType || (CacheType = {}));
/**
 * More Cache related constants
 */
var APP_METADATA = "appmetadata";
var CLIENT_INFO = "client_info";
var THE_FAMILY_ID = "1";
var AUTHORITY_METADATA_CONSTANTS = {
    CACHE_KEY: "authority-metadata",
    REFRESH_TIME_SECONDS: 3600 * 24 // 24 Hours
};
var AuthorityMetadataSource;
(function (AuthorityMetadataSource) {
    AuthorityMetadataSource["CONFIG"] = "config";
    AuthorityMetadataSource["CACHE"] = "cache";
    AuthorityMetadataSource["NETWORK"] = "network";
    AuthorityMetadataSource["HARDCODED_VALUES"] = "hardcoded_values";
})(AuthorityMetadataSource || (AuthorityMetadataSource = {}));
var SERVER_TELEM_CONSTANTS = {
    SCHEMA_VERSION: 5,
    MAX_CUR_HEADER_BYTES: 80,
    MAX_LAST_HEADER_BYTES: 330,
    MAX_CACHED_ERRORS: 50,
    CACHE_KEY: "server-telemetry",
    CATEGORY_SEPARATOR: "|",
    VALUE_SEPARATOR: ",",
    OVERFLOW_TRUE: "1",
    OVERFLOW_FALSE: "0",
    UNKNOWN_ERROR: "unknown_error"
};
/**
 * Type of the authentication request
 */
var AuthenticationScheme;
(function (AuthenticationScheme) {
    AuthenticationScheme["BEARER"] = "Bearer";
    AuthenticationScheme["POP"] = "pop";
    AuthenticationScheme["SSH"] = "ssh-cert";
})(AuthenticationScheme || (AuthenticationScheme = {}));
/**
 * Constants related to throttling
 */
var ThrottlingConstants = {
    // Default time to throttle RequestThumbprint in seconds
    DEFAULT_THROTTLE_TIME_SECONDS: 60,
    // Default maximum time to throttle in seconds, overrides what the server sends back
    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
    // Prefix for storing throttling entries
    THROTTLING_PREFIX: "throttling",
    // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
    X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
};
var Errors = {
    INVALID_GRANT_ERROR: "invalid_grant",
    CLIENT_MISMATCH_ERROR: "client_mismatch",
};
/**
 * Password grant parameters
 */
var PasswordGrantConstants;
(function (PasswordGrantConstants) {
    PasswordGrantConstants["username"] = "username";
    PasswordGrantConstants["password"] = "password";
})(PasswordGrantConstants || (PasswordGrantConstants = {}));
/**
 * Response codes
 */
var ResponseCodes;
(function (ResponseCodes) {
    ResponseCodes[ResponseCodes["httpSuccess"] = 200] = "httpSuccess";
    ResponseCodes[ResponseCodes["httpBadRequest"] = 400] = "httpBadRequest";
})(ResponseCodes || (ResponseCodes = {}));
/**
 * Region Discovery Sources
 */
var RegionDiscoverySources;
(function (RegionDiscoverySources) {
    RegionDiscoverySources["FAILED_AUTO_DETECTION"] = "1";
    RegionDiscoverySources["INTERNAL_CACHE"] = "2";
    RegionDiscoverySources["ENVIRONMENT_VARIABLE"] = "3";
    RegionDiscoverySources["IMDS"] = "4";
})(RegionDiscoverySources || (RegionDiscoverySources = {}));
/**
 * Region Discovery Outcomes
 */
var RegionDiscoveryOutcomes;
(function (RegionDiscoveryOutcomes) {
    RegionDiscoveryOutcomes["CONFIGURED_MATCHES_DETECTED"] = "1";
    RegionDiscoveryOutcomes["CONFIGURED_NO_AUTO_DETECTION"] = "2";
    RegionDiscoveryOutcomes["CONFIGURED_NOT_DETECTED"] = "3";
    RegionDiscoveryOutcomes["AUTO_DETECTION_REQUESTED_SUCCESSFUL"] = "4";
    RegionDiscoveryOutcomes["AUTO_DETECTION_REQUESTED_FAILED"] = "5";
})(RegionDiscoveryOutcomes || (RegionDiscoveryOutcomes = {}));
var CacheOutcome;
(function (CacheOutcome) {
    CacheOutcome["NO_CACHE_HIT"] = "0";
    CacheOutcome["FORCE_REFRESH"] = "1";
    CacheOutcome["NO_CACHED_ACCESS_TOKEN"] = "2";
    CacheOutcome["CACHED_ACCESS_TOKEN_EXPIRED"] = "3";
    CacheOutcome["REFRESH_CACHED_ACCESS_TOKEN"] = "4";
    CacheOutcome["CLAIMS_REQUESTED_CACHE_SKIPPED"] = "5";
})(CacheOutcome || (CacheOutcome = {}));
var JsonTypes;
(function (JsonTypes) {
    JsonTypes["Jwt"] = "JWT";
    JsonTypes["Jwk"] = "JWK";
    JsonTypes["Pop"] = "pop";
})(JsonTypes || (JsonTypes = {}));
var ONE_DAY_IN_MS = 86400000;


//# sourceMappingURL=Constants.js.map


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1746),
    findIndex = __webpack_require__(263);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __generator; });
/* unused harmony export __read */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __spread; });
/*! @azure/msal-browser v2.38.3 2023-10-27 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}


//# sourceMappingURL=_tslib.js.map


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Tooltip = __webpack_require__(1897);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _theme = __webpack_require__(1898);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var themedTooltipFactory = function themedTooltipFactory(options) {
  return (0, _Tooltip2.default)(_extends({}, options, { theme: _theme2.default }));
};
exports.default = (0, _Tooltip2.default)({ theme: _theme2.default });
exports.tooltipFactory = themedTooltipFactory;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __spreadArrays; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}


//# sourceMappingURL=_tslib.js.map


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.inject = inject;

exports.default = function (contextTypes) {
  return function (Component) {
    var ContextComponent = function (_React$Component2) {
      _inherits(ContextComponent, _React$Component2);

      function ContextComponent() {
        _classCallCheck(this, ContextComponent);

        return _possibleConstructorReturn(this, (ContextComponent.__proto__ || Object.getPrototypeOf(ContextComponent)).apply(this, arguments));
      }

      _createClass(ContextComponent, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, _extends({}, this.props, this.context));
        }
      }]);

      return ContextComponent;
    }(_react2.default.Component);

    ContextComponent.contextTypes = contextTypes;
    ContextComponent.displayName = 'Context(' + Component.displayName + ')';
    return ContextComponent;
  };
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/helpers/context.js

function inject(contextTypes) {
  return function (Component) {
    var ContextComponent = function (_React$Component) {
      _inherits(ContextComponent, _React$Component);

      function ContextComponent() {
        _classCallCheck(this, ContextComponent);

        return _possibleConstructorReturn(this, (ContextComponent.__proto__ || Object.getPrototypeOf(ContextComponent)).call(this));
      }

      _createClass(ContextComponent, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, _extends({}, this.props, this.context));
        }
      }, {
        key: 'getChildContext',
        value: function getChildContext() {
          var _this2 = this;

          var childContext = {};
          (0, _each2.default)(contextTypes, function (value, key) {
            if (typeof _this2.props[key] == 'function') childContext[key] = function () {
              var _props;

              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return (_props = _this2.props)[key].apply(_props, args.concat([_this2.props]));
            };else childContext[key] = _this2.props[key];
          });
          return childContext;
        }
      }]);

      return ContextComponent;
    }(_react2.default.Component);

    ContextComponent.childContextTypes = contextTypes;
    ContextComponent.displayName = 'ContextInject(' + Component.displayName + ')';
    return ContextComponent;
  };
}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkUI = linkUI;
exports.resetUI = resetUI;
exports.linkNativeUI = linkNativeUI;
exports.validate = validate;

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _at = __webpack_require__(1814);

var _at2 = _interopRequireDefault(_at);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/helpers/form-validator.js

// rules: {
//   name: {
//     rule: 'isEmail',
//     errorText: '',
//   }
// }

function linkUI(component, key) {
  var onChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return function (value) {
    component.props.updateUI(_defineProperty({}, key, value));
    if (onChange) onChange(value);
  };
}

function resetUI(component, key) {
  var onChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return function (event) {
    component.props.updateUI(_defineProperty({}, key, ''));
    if (onChange) onChange(undefined);
  };
}

function linkNativeUI(component, key) {
  var onChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return function (event) {
    component.props.updateUI(_defineProperty({}, key, event));
    if (onChange) onChange(event);
  };
}

function validate(ui, rules, callback) {
  var errorState = {};
  var errors = undefined;

  (0, _each2.default)(rules, function (rule, key) {
    var keys = key.split('.');
    var key0 = keys[0],
        key1 = keys.slice(1).join('.');
    var value = keys.length == 1 ? ui[key0] : (0, _at2.default)(ui[key0], key1)[0];
    var error = undefined;

    if (rule.rule == 'isEmail') {
      if (!value || !value.toString().trim().match(/^[\d\w+-_.]+@[\d\w+-_.]+$/)) {
        error = true;
      }
    } else if (rule.rule == 'isRequired') {
      if (typeof value == 'undefined' || value === null || value.toString().trim().length == 0) {
        error = true;
      }
    } else if (rule.rule == 'isNumber') {
      if (typeof value == 'undefined' || value === null || !value.toString().trim().match(/^[-+]?[0-9]+\.?[0-9]*$/)) {
        error = true;
      }
    } else if (rule.rule == 'isSame') {
      if (!value || value.toString().trim().length == 0 || value != ui[rule.name]) {
        error = true;
      }
    }

    var state = keys.length == 1 ? ui[key0 + 'Error'] : ui[key0][key1 + 'Error'];
    if (error) {
      if (keys.length == 1) {
        errorState[key0 + 'Error'] = error;
      } else {
        if (errorState[key0]) errorState[key0][key1 + 'Error'] = error;else errorState[key0] = _defineProperty({}, key1 + 'Error', error);
      }
      errors = true;
    } else if (state) {
      if (keys.length == 1) {
        errorState[key0 + 'Error'] = error;
      } else {
        if (errorState[key0]) errorState[key0][key1 + 'Error'] = error;else errorState[key0] = _defineProperty({}, key1 + 'Error', error);
      }
    }
  });

  callback(errors, errorState);
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["d"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["f"] = __values;
/* harmony export (immutable) */ __webpack_exports__["c"] = __read;
/* harmony export (immutable) */ __webpack_exports__["e"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(318),
    baseIteratee = __webpack_require__(139),
    baseMap = __webpack_require__(903),
    isArray = __webpack_require__(62);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Loading;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/web/components/loading.jsx

function Loading(props) {
  return _react2.default.createElement(
    'div',
    { style: { height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
    _react2.default.createElement(_progress_bar2.default, { type: 'circular', multicolor: true, mode: 'indeterminate' })
  );
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async__ = __webpack_require__(2299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser__ = __webpack_require__(984);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__browser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dsn__ = __webpack_require__(2300);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__dsn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error__ = __webpack_require__(523);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__instrument__ = __webpack_require__(2302);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__instrument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__is__ = __webpack_require__(234);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_5__is__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logger__ = __webpack_require__(524);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_6__logger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__memo__ = __webpack_require__(986);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__misc__ = __webpack_require__(279);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_8__misc__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node__ = __webpack_require__(525);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_9__node__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__object__ = __webpack_require__(985);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_10__object__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__path__ = __webpack_require__(2303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__promisebuffer__ = __webpack_require__(2304);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_12__promisebuffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__stacktrace__ = __webpack_require__(527);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__stacktrace__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__string__ = __webpack_require__(526);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_14__string__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_14__string__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_14__string__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__supports__ = __webpack_require__(987);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_15__supports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_15__supports__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__syncpromise__ = __webpack_require__(988);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_16__syncpromise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__time__ = __webpack_require__(2305);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_17__time__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_17__time__["b"]; });


















//# sourceMappingURL=index.js.map

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BrowserCacheLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BrowserConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CacheLookupPolicy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DB_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DB_TABLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DB_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HTTP_REQUEST_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return InMemoryCacheKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return InteractionStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return InteractionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return KEY_FORMAT_JWK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NativeConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return NativeExtensionMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return StaticCacheKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TemporaryCacheKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return WrapperSKU; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__ = __webpack_require__(31);
/*! @azure/msal-browser v2.38.3 2023-10-27 */



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Constants
 */
var BrowserConstants = {
    /**
     * Interaction in progress cache value
     */
    INTERACTION_IN_PROGRESS_VALUE: "interaction_in_progress",
    /**
     * Invalid grant error code
     */
    INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */
    POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */
    POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */
    POPUP_NAME_PREFIX: "msal",
    /**
     * Default popup monitor poll interval in milliseconds
     */
    DEFAULT_POLL_INTERVAL_MS: 30,
    /**
     * Msal-browser SKU
     */
    MSAL_SKU: "msal.js.browser",
};
var NativeConstants = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS"
};
var NativeExtensionMethod;
(function (NativeExtensionMethod) {
    NativeExtensionMethod["HandshakeRequest"] = "Handshake";
    NativeExtensionMethod["HandshakeResponse"] = "HandshakeResponse";
    NativeExtensionMethod["GetToken"] = "GetToken";
    NativeExtensionMethod["Response"] = "Response";
})(NativeExtensionMethod || (NativeExtensionMethod = {}));
var BrowserCacheLocation;
(function (BrowserCacheLocation) {
    BrowserCacheLocation["LocalStorage"] = "localStorage";
    BrowserCacheLocation["SessionStorage"] = "sessionStorage";
    BrowserCacheLocation["MemoryStorage"] = "memoryStorage";
})(BrowserCacheLocation || (BrowserCacheLocation = {}));
/**
 * HTTP Request types supported by MSAL.
 */
var HTTP_REQUEST_TYPE;
(function (HTTP_REQUEST_TYPE) {
    HTTP_REQUEST_TYPE["GET"] = "GET";
    HTTP_REQUEST_TYPE["POST"] = "POST";
})(HTTP_REQUEST_TYPE || (HTTP_REQUEST_TYPE = {}));
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */
var TemporaryCacheKeys;
(function (TemporaryCacheKeys) {
    TemporaryCacheKeys["AUTHORITY"] = "authority";
    TemporaryCacheKeys["ACQUIRE_TOKEN_ACCOUNT"] = "acquireToken.account";
    TemporaryCacheKeys["SESSION_STATE"] = "session.state";
    TemporaryCacheKeys["REQUEST_STATE"] = "request.state";
    TemporaryCacheKeys["NONCE_IDTOKEN"] = "nonce.id_token";
    TemporaryCacheKeys["ORIGIN_URI"] = "request.origin";
    TemporaryCacheKeys["RENEW_STATUS"] = "token.renew.status";
    TemporaryCacheKeys["URL_HASH"] = "urlHash";
    TemporaryCacheKeys["REQUEST_PARAMS"] = "request.params";
    TemporaryCacheKeys["SCOPES"] = "scopes";
    TemporaryCacheKeys["INTERACTION_STATUS_KEY"] = "interaction.status";
    TemporaryCacheKeys["CCS_CREDENTIAL"] = "ccs.credential";
    TemporaryCacheKeys["CORRELATION_ID"] = "request.correlationId";
    TemporaryCacheKeys["NATIVE_REQUEST"] = "request.native";
    TemporaryCacheKeys["REDIRECT_CONTEXT"] = "request.redirect.context";
})(TemporaryCacheKeys || (TemporaryCacheKeys = {}));
var StaticCacheKeys;
(function (StaticCacheKeys) {
    StaticCacheKeys["ACCOUNT_KEYS"] = "msal.account.keys";
    StaticCacheKeys["TOKEN_KEYS"] = "msal.token.keys";
})(StaticCacheKeys || (StaticCacheKeys = {}));
/**
 * Cache keys stored in-memory
 */
var InMemoryCacheKeys;
(function (InMemoryCacheKeys) {
    InMemoryCacheKeys["WRAPPER_SKU"] = "wrapper.sku";
    InMemoryCacheKeys["WRAPPER_VER"] = "wrapper.version";
})(InMemoryCacheKeys || (InMemoryCacheKeys = {}));
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 */
var ApiId;
(function (ApiId) {
    ApiId[ApiId["acquireTokenRedirect"] = 861] = "acquireTokenRedirect";
    ApiId[ApiId["acquireTokenPopup"] = 862] = "acquireTokenPopup";
    ApiId[ApiId["ssoSilent"] = 863] = "ssoSilent";
    ApiId[ApiId["acquireTokenSilent_authCode"] = 864] = "acquireTokenSilent_authCode";
    ApiId[ApiId["handleRedirectPromise"] = 865] = "handleRedirectPromise";
    ApiId[ApiId["acquireTokenByCode"] = 866] = "acquireTokenByCode";
    ApiId[ApiId["acquireTokenSilent_silentFlow"] = 61] = "acquireTokenSilent_silentFlow";
    ApiId[ApiId["logout"] = 961] = "logout";
    ApiId[ApiId["logoutPopup"] = 962] = "logoutPopup";
})(ApiId || (ApiId = {}));
/*
 * Interaction type of the API - used for state and telemetry
 */
var InteractionType;
(function (InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})(InteractionType || (InteractionType = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */
var InteractionStatus;
(function (InteractionStatus) {
    /**
     * Initial status before interaction occurs
     */
    InteractionStatus["Startup"] = "startup";
    /**
     * Status set when all login calls occuring
     */
    InteractionStatus["Login"] = "login";
    /**
     * Status set when logout call occuring
     */
    InteractionStatus["Logout"] = "logout";
    /**
     * Status set for acquireToken calls
     */
    InteractionStatus["AcquireToken"] = "acquireToken";
    /**
     * Status set for ssoSilent calls
     */
    InteractionStatus["SsoSilent"] = "ssoSilent";
    /**
     * Status set when handleRedirect in progress
     */
    InteractionStatus["HandleRedirect"] = "handleRedirect";
    /**
     * Status set when interaction is complete
     */
    InteractionStatus["None"] = "none";
})(InteractionStatus || (InteractionStatus = {}));
var DEFAULT_REQUEST = {
    scopes: __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["G" /* OIDC_DEFAULT_SCOPES */]
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */
var KEY_FORMAT_JWK = "jwk";
// Supported wrapper SKUs
var WrapperSKU;
(function (WrapperSKU) {
    WrapperSKU["React"] = "@azure/msal-react";
    WrapperSKU["Angular"] = "@azure/msal-angular";
})(WrapperSKU || (WrapperSKU = {}));
// DatabaseStorage Constants
var DB_NAME = "msal.db";
var DB_VERSION = 1;
var DB_TABLE_NAME = DB_NAME + ".keys";
var CacheLookupPolicy;
(function (CacheLookupPolicy) {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */
    CacheLookupPolicy[CacheLookupPolicy["Default"] = 0] = "Default";
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */
    CacheLookupPolicy[CacheLookupPolicy["AccessToken"] = 1] = "AccessToken";
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */
    CacheLookupPolicy[CacheLookupPolicy["AccessTokenAndRefreshToken"] = 2] = "AccessTokenAndRefreshToken";
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */
    CacheLookupPolicy[CacheLookupPolicy["RefreshToken"] = 3] = "RefreshToken";
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */
    CacheLookupPolicy[CacheLookupPolicy["RefreshTokenAndNetwork"] = 4] = "RefreshTokenAndNetwork";
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */
    CacheLookupPolicy[CacheLookupPolicy["Skip"] = 5] = "Skip";
})(CacheLookupPolicy || (CacheLookupPolicy = {}));


//# sourceMappingURL=BrowserConstants.js.map


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Dialog = __webpack_require__(477);

var _overlay = __webpack_require__(879);

var _button = __webpack_require__(8);

var _theme = __webpack_require__(1803);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dialog = (0, _Dialog.dialogFactory)(_overlay.Overlay, _button.Button);
var ThemedDialog = (0, _reactCssThemr.themr)(_identifiers.DIALOG, _theme2.default)(Dialog);

exports.default = ThemedDialog;
exports.Dialog = ThemedDialog;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1913);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./flat-card.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./flat-card.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserAuthError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BrowserAuthErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */
var BrowserAuthErrorMessage = {
    pkceNotGenerated: {
        code: "pkce_not_created",
        desc: "The PKCE code challenge and verifier could not be generated."
    },
    cryptoDoesNotExist: {
        code: "crypto_nonexistent",
        desc: "The crypto object or function is not available."
    },
    httpMethodNotImplementedError: {
        code: "http_method_not_implemented",
        desc: "The HTTP method given has not been implemented in this library."
    },
    emptyNavigateUriError: {
        code: "empty_navigate_uri",
        desc: "Navigation URI is empty. Please check stack trace for more info."
    },
    hashEmptyError: {
        code: "hash_empty_error",
        desc: "Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash. For more visit: aka.ms/msaljs/browser-errors."
    },
    hashDoesNotContainStateError: {
        code: "no_state_in_hash",
        desc: "Hash does not contain state. Please verify that the request originated from msal."
    },
    hashDoesNotContainKnownPropertiesError: {
        code: "hash_does_not_contain_known_properties",
        desc: "Hash does not contain known properites. Please verify that your redirectUri is not changing the hash. For more visit: aka.ms/msaljs/browser-errors."
    },
    unableToParseStateError: {
        code: "unable_to_parse_state",
        desc: "Unable to parse state. Please verify that the request originated from msal."
    },
    stateInteractionTypeMismatchError: {
        code: "state_interaction_type_mismatch",
        desc: "Hash contains state but the interaction type does not match the caller."
    },
    interactionInProgress: {
        code: "interaction_in_progress",
        desc: "Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.  For more visit: aka.ms/msaljs/browser-errors."
    },
    popupWindowError: {
        code: "popup_window_error",
        desc: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser."
    },
    emptyWindowError: {
        code: "empty_window_error",
        desc: "window.open returned null or undefined window object."
    },
    userCancelledError: {
        code: "user_cancelled",
        desc: "User cancelled the flow."
    },
    monitorPopupTimeoutError: {
        code: "monitor_window_timeout",
        desc: "Token acquisition in popup failed due to timeout. For more visit: aka.ms/msaljs/browser-errors."
    },
    monitorIframeTimeoutError: {
        code: "monitor_window_timeout",
        desc: "Token acquisition in iframe failed due to timeout. For more visit: aka.ms/msaljs/browser-errors."
    },
    redirectInIframeError: {
        code: "redirect_in_iframe",
        desc: "Redirects are not supported for iframed or brokered applications. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs."
    },
    blockTokenRequestsInHiddenIframeError: {
        code: "block_iframe_reload",
        desc: "Request was blocked inside an iframe because MSAL detected an authentication response. For more visit: aka.ms/msaljs/browser-errors"
    },
    blockAcquireTokenInPopupsError: {
        code: "block_nested_popups",
        desc: "Request was blocked inside a popup because MSAL detected it was running in a popup."
    },
    iframeClosedPrematurelyError: {
        code: "iframe_closed_prematurely",
        desc: "The iframe being monitored was closed prematurely."
    },
    silentLogoutUnsupportedError: {
        code: "silent_logout_unsupported",
        desc: "Silent logout not supported. Please call logoutRedirect or logoutPopup instead."
    },
    noAccountError: {
        code: "no_account_error",
        desc: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request."
    },
    silentPromptValueError: {
        code: "silent_prompt_value_error",
        desc: "The value given for the prompt value is not valid for silent requests - must be set to 'none' or 'no_session'."
    },
    noTokenRequestCacheError: {
        code: "no_token_request_cache_error",
        desc: "No token request found in cache."
    },
    unableToParseTokenRequestCacheError: {
        code: "unable_to_parse_token_request_cache_error",
        desc: "The cached token request could not be parsed."
    },
    noCachedAuthorityError: {
        code: "no_cached_authority_error",
        desc: "No cached authority found."
    },
    authRequestNotSet: {
        code: "auth_request_not_set_error",
        desc: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler"
    },
    invalidCacheType: {
        code: "invalid_cache_type",
        desc: "Invalid cache type"
    },
    notInBrowserEnvironment: {
        code: "non_browser_environment",
        desc: "Login and token requests are not supported in non-browser environments."
    },
    databaseNotOpen: {
        code: "database_not_open",
        desc: "Database is not open!"
    },
    noNetworkConnectivity: {
        code: "no_network_connectivity",
        desc: "No network connectivity. Check your internet connection."
    },
    postRequestFailed: {
        code: "post_request_failed",
        desc: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'"
    },
    getRequestFailed: {
        code: "get_request_failed",
        desc: "Network request failed. Please check the network trace to determine root cause."
    },
    failedToParseNetworkResponse: {
        code: "failed_to_parse_response",
        desc: "Failed to parse network response. Check network trace."
    },
    unableToLoadTokenError: {
        code: "unable_to_load_token",
        desc: "Error loading token to cache."
    },
    signingKeyNotFoundInStorage: {
        code: "crypto_key_not_found",
        desc: "Cryptographic Key or Keypair not found in browser storage."
    },
    authCodeRequired: {
        code: "auth_code_required",
        desc: "An authorization code must be provided (as the `code` property on the request) to this flow."
    },
    authCodeOrNativeAccountRequired: {
        code: "auth_code_or_nativeAccountId_required",
        desc: "An authorization code or nativeAccountId must be provided to this flow."
    },
    spaCodeAndNativeAccountPresent: {
        code: "spa_code_and_nativeAccountId_present",
        desc: "Request cannot contain both spa code and native account id."
    },
    databaseUnavailable: {
        code: "database_unavailable",
        desc: "IndexedDB, which is required for persistent cryptographic key storage, is unavailable. This may be caused by browser privacy features which block persistent storage in third-party contexts."
    },
    unableToAcquireTokenFromNativePlatform: {
        code: "unable_to_acquire_token_from_native_platform",
        desc: "Unable to acquire token from native platform. For a list of possible reasons visit aka.ms/msaljs/browser-errors."
    },
    nativeHandshakeTimeout: {
        code: "native_handshake_timeout",
        desc: "Timed out while attempting to establish connection to browser extension"
    },
    nativeExtensionNotInstalled: {
        code: "native_extension_not_installed",
        desc: "Native extension is not installed. If you think this is a mistake call the initialize function."
    },
    nativeConnectionNotEstablished: {
        code: "native_connection_not_established",
        desc: "Connection to native platform has not been established. Please install a compatible browser extension and run initialize(). For more please visit aka.ms/msaljs/browser-errors."
    },
    nativeBrokerCalledBeforeInitialize: {
        code: "native_broker_called_before_initialize",
        desc: "You must call and await the initialize function before attempting to call any other MSAL API when native brokering is enabled. For more please visit aka.ms/msaljs/browser-errors."
    },
    nativePromptNotSupported: {
        code: "native_prompt_not_supported",
        desc: "The provided prompt is not supported by the native platform. This request should be routed to the web based flow."
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */
var BrowserAuthError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(BrowserAuthError, _super);
    function BrowserAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        Object.setPrototypeOf(_this, BrowserAuthError.prototype);
        _this.name = "BrowserAuthError";
        return _this;
    }
    /**
     * Creates an error thrown when PKCE is not implemented.
     * @param errDetail
     */
    BrowserAuthError.createPkceNotGeneratedError = function (errDetail) {
        return new BrowserAuthError(BrowserAuthErrorMessage.pkceNotGenerated.code, BrowserAuthErrorMessage.pkceNotGenerated.desc + " Detail:" + errDetail);
    };
    /**
     * Creates an error thrown when the crypto object is unavailable.
     * @param errDetail
     */
    BrowserAuthError.createCryptoNotAvailableError = function (errDetail) {
        return new BrowserAuthError(BrowserAuthErrorMessage.cryptoDoesNotExist.code, BrowserAuthErrorMessage.cryptoDoesNotExist.desc + " Detail:" + errDetail);
    };
    /**
     * Creates an error thrown when an HTTP method hasn't been implemented by the browser class.
     * @param method
     */
    BrowserAuthError.createHttpMethodNotImplementedError = function (method) {
        return new BrowserAuthError(BrowserAuthErrorMessage.httpMethodNotImplementedError.code, BrowserAuthErrorMessage.httpMethodNotImplementedError.desc + " Given Method: " + method);
    };
    /**
     * Creates an error thrown when the navigation URI is empty.
     */
    BrowserAuthError.createEmptyNavigationUriError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.emptyNavigateUriError.code, BrowserAuthErrorMessage.emptyNavigateUriError.desc);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     * @param hashValue
     */
    BrowserAuthError.createEmptyHashError = function (hashValue) {
        return new BrowserAuthError(BrowserAuthErrorMessage.hashEmptyError.code, BrowserAuthErrorMessage.hashEmptyError.desc + " Given Url: " + hashValue);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     */
    BrowserAuthError.createHashDoesNotContainStateError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.hashDoesNotContainStateError.code, BrowserAuthErrorMessage.hashDoesNotContainStateError.desc);
    };
    /**
     * Creates an error thrown when the hash string value does not contain known properties
     */
    BrowserAuthError.createHashDoesNotContainKnownPropertiesError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.hashDoesNotContainKnownPropertiesError.code, BrowserAuthErrorMessage.hashDoesNotContainKnownPropertiesError.desc);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     */
    BrowserAuthError.createUnableToParseStateError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.unableToParseStateError.code, BrowserAuthErrorMessage.unableToParseStateError.desc);
    };
    /**
     * Creates an error thrown when the state value in the hash does not match the interaction type of the API attempting to consume it.
     */
    BrowserAuthError.createStateInteractionTypeMismatchError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.stateInteractionTypeMismatchError.code, BrowserAuthErrorMessage.stateInteractionTypeMismatchError.desc);
    };
    /**
     * Creates an error thrown when a browser interaction (redirect or popup) is in progress.
     */
    BrowserAuthError.createInteractionInProgressError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.interactionInProgress.code, BrowserAuthErrorMessage.interactionInProgress.desc);
    };
    /**
     * Creates an error thrown when the popup window could not be opened.
     * @param errDetail
     */
    BrowserAuthError.createPopupWindowError = function (errDetail) {
        var errorMessage = BrowserAuthErrorMessage.popupWindowError.desc;
        errorMessage = !__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(errDetail) ? errorMessage + " Details: " + errDetail : errorMessage;
        return new BrowserAuthError(BrowserAuthErrorMessage.popupWindowError.code, errorMessage);
    };
    /**
     * Creates an error thrown when window.open returns an empty window object.
     * @param errDetail
     */
    BrowserAuthError.createEmptyWindowCreatedError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.emptyWindowError.code, BrowserAuthErrorMessage.emptyWindowError.desc);
    };
    /**
     * Creates an error thrown when the user closes a popup.
     */
    BrowserAuthError.createUserCancelledError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.userCancelledError.code, BrowserAuthErrorMessage.userCancelledError.desc);
    };
    /**
     * Creates an error thrown when monitorPopupFromHash times out for a given popup.
     */
    BrowserAuthError.createMonitorPopupTimeoutError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.monitorPopupTimeoutError.code, BrowserAuthErrorMessage.monitorPopupTimeoutError.desc);
    };
    /**
     * Creates an error thrown when monitorIframeFromHash times out for a given iframe.
     */
    BrowserAuthError.createMonitorIframeTimeoutError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.monitorIframeTimeoutError.code, BrowserAuthErrorMessage.monitorIframeTimeoutError.desc);
    };
    /**
     * Creates an error thrown when navigateWindow is called inside an iframe or brokered applications.
     * @param windowParentCheck
     */
    BrowserAuthError.createRedirectInIframeError = function (windowParentCheck) {
        return new BrowserAuthError(BrowserAuthErrorMessage.redirectInIframeError.code, BrowserAuthErrorMessage.redirectInIframeError.desc + " (window.parent !== window) => " + windowParentCheck);
    };
    /**
     * Creates an error thrown when an auth reload is done inside an iframe.
     */
    BrowserAuthError.createBlockReloadInHiddenIframeError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.blockTokenRequestsInHiddenIframeError.code, BrowserAuthErrorMessage.blockTokenRequestsInHiddenIframeError.desc);
    };
    /**
     * Creates an error thrown when a popup attempts to call an acquireToken API
     * @returns
     */
    BrowserAuthError.createBlockAcquireTokenInPopupsError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.blockAcquireTokenInPopupsError.code, BrowserAuthErrorMessage.blockAcquireTokenInPopupsError.desc);
    };
    /**
     * Creates an error thrown when an iframe is found to be closed before the timeout is reached.
     */
    BrowserAuthError.createIframeClosedPrematurelyError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.iframeClosedPrematurelyError.code, BrowserAuthErrorMessage.iframeClosedPrematurelyError.desc);
    };
    /**
     * Creates an error thrown when the logout API is called on any of the silent interaction clients
     */
    BrowserAuthError.createSilentLogoutUnsupportedError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.silentLogoutUnsupportedError.code, BrowserAuthErrorMessage.silentLogoutUnsupportedError.desc);
    };
    /**
     * Creates an error thrown when the account object is not provided in the acquireTokenSilent API.
     */
    BrowserAuthError.createNoAccountError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.noAccountError.code, BrowserAuthErrorMessage.noAccountError.desc);
    };
    /**
     * Creates an error thrown when a given prompt value is invalid for silent requests.
     */
    BrowserAuthError.createSilentPromptValueError = function (givenPrompt) {
        return new BrowserAuthError(BrowserAuthErrorMessage.silentPromptValueError.code, BrowserAuthErrorMessage.silentPromptValueError.desc + " Given value: " + givenPrompt);
    };
    /**
     * Creates an error thrown when the cached token request could not be retrieved from the cache
     */
    BrowserAuthError.createUnableToParseTokenRequestCacheError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.unableToParseTokenRequestCacheError.code, BrowserAuthErrorMessage.unableToParseTokenRequestCacheError.desc);
    };
    /**
     * Creates an error thrown when the token request could not be retrieved from the cache
     */
    BrowserAuthError.createNoTokenRequestCacheError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.noTokenRequestCacheError.code, BrowserAuthErrorMessage.noTokenRequestCacheError.desc);
    };
    /**
     * Creates an error thrown when handleCodeResponse is called before initiateAuthRequest (InteractionHandler)
     */
    BrowserAuthError.createAuthRequestNotSetError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.authRequestNotSet.code, BrowserAuthErrorMessage.authRequestNotSet.desc);
    };
    /**
     * Creates an error thrown when the authority could not be retrieved from the cache
     */
    BrowserAuthError.createNoCachedAuthorityError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.noCachedAuthorityError.code, BrowserAuthErrorMessage.noCachedAuthorityError.desc);
    };
    /**
     * Creates an error thrown if cache type is invalid.
     */
    BrowserAuthError.createInvalidCacheTypeError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.invalidCacheType.code, "" + BrowserAuthErrorMessage.invalidCacheType.desc);
    };
    /**
     * Create an error thrown when login and token requests are made from a non-browser environment
     */
    BrowserAuthError.createNonBrowserEnvironmentError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.notInBrowserEnvironment.code, BrowserAuthErrorMessage.notInBrowserEnvironment.desc);
    };
    /**
     * Create an error thrown when indexDB database is not open
     */
    BrowserAuthError.createDatabaseNotOpenError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.databaseNotOpen.code, BrowserAuthErrorMessage.databaseNotOpen.desc);
    };
    /**
     * Create an error thrown when token fetch fails due to no internet
     */
    BrowserAuthError.createNoNetworkConnectivityError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.noNetworkConnectivity.code, BrowserAuthErrorMessage.noNetworkConnectivity.desc);
    };
    /**
     * Create an error thrown when token fetch fails due to reasons other than internet connectivity
     */
    BrowserAuthError.createPostRequestFailedError = function (errorDesc, endpoint) {
        return new BrowserAuthError(BrowserAuthErrorMessage.postRequestFailed.code, BrowserAuthErrorMessage.postRequestFailed.desc + " | Network client threw: " + errorDesc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when get request fails due to reasons other than internet connectivity
     */
    BrowserAuthError.createGetRequestFailedError = function (errorDesc, endpoint) {
        return new BrowserAuthError(BrowserAuthErrorMessage.getRequestFailed.code, BrowserAuthErrorMessage.getRequestFailed.desc + " | Network client threw: " + errorDesc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when network client fails to parse network response
     */
    BrowserAuthError.createFailedToParseNetworkResponseError = function (endpoint) {
        return new BrowserAuthError(BrowserAuthErrorMessage.failedToParseNetworkResponse.code, BrowserAuthErrorMessage.failedToParseNetworkResponse.desc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when the necessary information is not available to sideload tokens
     */
    BrowserAuthError.createUnableToLoadTokenError = function (errorDetail) {
        return new BrowserAuthError(BrowserAuthErrorMessage.unableToLoadTokenError.code, BrowserAuthErrorMessage.unableToLoadTokenError.desc + " | " + errorDetail);
    };
    /**
     * Create an error thrown when the queried cryptographic key is not found in IndexedDB
     */
    BrowserAuthError.createSigningKeyNotFoundInStorageError = function (keyId) {
        return new BrowserAuthError(BrowserAuthErrorMessage.signingKeyNotFoundInStorage.code, BrowserAuthErrorMessage.signingKeyNotFoundInStorage.desc + " | No match found for KeyId: " + keyId);
    };
    /**
     * Create an error when an authorization code is required but not provided
     */
    BrowserAuthError.createAuthCodeRequiredError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.authCodeRequired.code, BrowserAuthErrorMessage.authCodeRequired.desc);
    };
    /**
     * Create an error when an authorization code or native account ID is required but not provided
     */
    BrowserAuthError.createAuthCodeOrNativeAccountIdRequiredError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.authCodeOrNativeAccountRequired.code, BrowserAuthErrorMessage.authCodeOrNativeAccountRequired.desc);
    };
    /**
     * Create an error when both authorization code and native account ID are provided
     */
    BrowserAuthError.createSpaCodeAndNativeAccountIdPresentError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.spaCodeAndNativeAccountPresent.code, BrowserAuthErrorMessage.spaCodeAndNativeAccountPresent.desc);
    };
    /**
     * Create an error when IndexedDB is unavailable
     */
    BrowserAuthError.createDatabaseUnavailableError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.databaseUnavailable.code, BrowserAuthErrorMessage.databaseUnavailable.desc);
    };
    /**
     * Create an error when native token acquisition is not possible
     */
    BrowserAuthError.createUnableToAcquireTokenFromNativePlatformError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.unableToAcquireTokenFromNativePlatform.code, BrowserAuthErrorMessage.unableToAcquireTokenFromNativePlatform.desc);
    };
    /**
     * Create an error thrown when Handshake with browser extension times out
     */
    BrowserAuthError.createNativeHandshakeTimeoutError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.nativeHandshakeTimeout.code, BrowserAuthErrorMessage.nativeHandshakeTimeout.desc);
    };
    /**
     * Create an error thrown when browser extension is not installed
     */
    BrowserAuthError.createNativeExtensionNotInstalledError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.nativeExtensionNotInstalled.code, BrowserAuthErrorMessage.nativeExtensionNotInstalled.desc);
    };
    /**
     * Create an error when native connection has not been established
     * @returns
     */
    BrowserAuthError.createNativeConnectionNotEstablishedError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.nativeConnectionNotEstablished.code, BrowserAuthErrorMessage.nativeConnectionNotEstablished.desc);
    };
    /**
     * Create an error thrown when the initialize function hasn't been called
     */
    BrowserAuthError.createNativeBrokerCalledBeforeInitialize = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.nativeBrokerCalledBeforeInitialize.code, BrowserAuthErrorMessage.nativeBrokerCalledBeforeInitialize.desc);
    };
    /**
     * Create an error thrown when requesting a token directly from the native platform with an unsupported prompt parameter e.g. select_account, login or create
     * These requests must go through eSTS to ensure eSTS is aware of the new account
     */
    BrowserAuthError.createNativePromptParameterNotSupportedError = function () {
        return new BrowserAuthError(BrowserAuthErrorMessage.nativePromptNotSupported.code, BrowserAuthErrorMessage.nativePromptNotSupported.desc);
    };
    return BrowserAuthError;
}(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */]));


//# sourceMappingURL=BrowserAuthError.js.map


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _dialog = __webpack_require__(47);

var _dialog2 = _interopRequireDefault(_dialog);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/web/components/comfirm-dialog.jsx

function ConfirmDialog(props) {
  var t = props.t,
      _props$open = props.open,
      open = _props$open === undefined ? false : _props$open,
      title = props.title,
      description = props.description,
      yesLabel = props.yesLabel,
      noLabel = props.noLabel,
      onYes = props.onYes,
      yesHref = props.yesHref,
      noHref = props.noHref,
      onNo = props.onNo,
      reTrialMessage = props.reTrialMessage,
      centeredTitle = props.centeredTitle,
      configBaseUrl = props.configBaseUrl,
      trialDatesMessage = props.trialDatesMessage;


  return _react2.default.createElement(
    _dialog2.default,
    { active: open,
      onEscKeyDown: onNo,
      onOverlayClick: onNo,
      title: centeredTitle ? _react2.default.createElement(
        'div',
        { style: { textAlign: 'center', fontWeight: 'bold' } },
        title
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_font_icon2.default, { value: 'warning' }),
        '\xA0\xA0',
        title
      ),
      actions: [{ label: noLabel || t('label:いいえ'), onClick: onNo, href: noHref, raised: true }, { label: yesLabel || t('label:はい'), onClick: onYes, href: yesHref, raised: true, primary: true, target: yesHref && '_blank' || undefined, rel: yesHref && "noopener noreferrer" || undefined }] },
    reTrialMessage ? _react2.default.createElement(
      'div',
      { style: { whiteSpace: "pre-line" } },
      description,
      _react2.default.createElement(
        'div',
        { style: { fontSize: 14, marginTop: 10 } },
        t('label:ご契約を希望のお客様'),
        _react2.default.createElement(
          'a',
          { href: configBaseUrl + 'v3/contract', target: '_blank', rel: 'noopener noreferrer' },
          t('label:こちら')
        ),
        t('label:お申し込みください')
      )
    ) : description,
    trialDatesMessage && _react2.default.createElement(
      'div',
      { style: { whiteSpace: "pre-line" } },
      _react2.default.createElement(
        'div',
        { style: { fontSize: 16 } },
        t('label:gamba!をご利用いただきありがとうございました'),
        t('label:ご契約を希望のお客様'),
        _react2.default.createElement(
          'a',
          { href: configBaseUrl + 'v3/contract', target: '_blank', rel: 'noopener noreferrer' },
          t('label:こちら')
        ),
        t('label:お申し込みください')
      )
    )
  );
}

exports.default = (0, _reactI18next.translate)()(ConfirmDialog);

/***/ }),
/* 51 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(274)('wks');
var uid = __webpack_require__(190);
var Symbol = __webpack_require__(34).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(764),
    baseFilter = __webpack_require__(1741),
    baseIteratee = __webpack_require__(139),
    isArray = __webpack_require__(62);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _ripple = __webpack_require__(162);

var _ripple2 = _interopRequireDefault(_ripple);

var _Checkbox = __webpack_require__(339);

var _Check = __webpack_require__(880);

var _Check2 = _interopRequireDefault(_Check);

var _theme = __webpack_require__(1809);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedCheck = (0, _Check2.default)((0, _ripple2.default)({ centered: true, spread: 2.6 }));
var ThemedCheckbox = (0, _reactCssThemr.themr)(_identifiers.CHECKBOX, _theme2.default)((0, _Checkbox.checkboxFactory)(ThemedCheck));

exports.default = ThemedCheckbox;
exports.Checkbox = ThemedCheckbox;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(107);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(37)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientAuthError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClientAuthErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthError_js__ = __webpack_require__(112);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */
var ClientAuthErrorMessage = {
    clientInfoDecodingError: {
        code: "client_info_decoding_error",
        desc: "The client info could not be parsed/decoded correctly. Please review the trace to determine the root cause."
    },
    clientInfoEmptyError: {
        code: "client_info_empty_error",
        desc: "The client info was empty. Please review the trace to determine the root cause."
    },
    tokenParsingError: {
        code: "token_parsing_error",
        desc: "Token cannot be parsed. Please review stack trace to determine root cause."
    },
    nullOrEmptyToken: {
        code: "null_or_empty_token",
        desc: "The token is null or empty. Please review the trace to determine the root cause."
    },
    endpointResolutionError: {
        code: "endpoints_resolution_error",
        desc: "Error: could not resolve endpoints. Please check network and try again."
    },
    networkError: {
        code: "network_error",
        desc: "Network request failed. Please check network trace to determine root cause."
    },
    unableToGetOpenidConfigError: {
        code: "openid_config_error",
        desc: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints."
    },
    hashNotDeserialized: {
        code: "hash_not_deserialized",
        desc: "The hash parameters could not be deserialized. Please review the trace to determine the root cause."
    },
    blankGuidGenerated: {
        code: "blank_guid_generated",
        desc: "The guid generated was blank. Please review the trace to determine the root cause."
    },
    invalidStateError: {
        code: "invalid_state",
        desc: "State was not the expected format. Please check the logs to determine whether the request was sent using ProtocolUtils.setRequestState()."
    },
    stateMismatchError: {
        code: "state_mismatch",
        desc: "State mismatch error. Please check your network. Continued requests may cause cache overflow."
    },
    stateNotFoundError: {
        code: "state_not_found",
        desc: "State not found"
    },
    nonceMismatchError: {
        code: "nonce_mismatch",
        desc: "Nonce mismatch error. This may be caused by a race condition in concurrent requests."
    },
    nonceNotFoundError: {
        code: "nonce_not_found",
        desc: "nonce not found"
    },
    authTimeNotFoundError: {
        code: "auth_time_not_found",
        desc: "Max Age was requested and the ID token is missing the auth_time variable." +
            " auth_time is an optional claim and is not enabled by default - it must be enabled." +
            " See https://aka.ms/msaljs/optional-claims for more information."
    },
    maxAgeTranspiredError: {
        code: "max_age_transpired",
        desc: "Max Age is set to 0, or too much time has elapsed since the last end-user authentication."
    },
    noTokensFoundError: {
        code: "no_tokens_found",
        desc: "No tokens were found for the given scopes, and no authorization code was passed to acquireToken. You must retrieve an authorization code before making a call to acquireToken()."
    },
    multipleMatchingTokens: {
        code: "multiple_matching_tokens",
        desc: "The cache contains multiple tokens satisfying the requirements. " +
            "Call AcquireToken again providing more requirements such as authority or account."
    },
    multipleMatchingAccounts: {
        code: "multiple_matching_accounts",
        desc: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account"
    },
    multipleMatchingAppMetadata: {
        code: "multiple_matching_appMetadata",
        desc: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata"
    },
    tokenRequestCannotBeMade: {
        code: "request_cannot_be_made",
        desc: "Token request cannot be made without authorization code or refresh token."
    },
    appendEmptyScopeError: {
        code: "cannot_append_empty_scope",
        desc: "Cannot append null or empty scope to ScopeSet. Please check the stack trace for more info."
    },
    removeEmptyScopeError: {
        code: "cannot_remove_empty_scope",
        desc: "Cannot remove null or empty scope from ScopeSet. Please check the stack trace for more info."
    },
    appendScopeSetError: {
        code: "cannot_append_scopeset",
        desc: "Cannot append ScopeSet due to error."
    },
    emptyInputScopeSetError: {
        code: "empty_input_scopeset",
        desc: "Empty input ScopeSet cannot be processed."
    },
    DeviceCodePollingCancelled: {
        code: "device_code_polling_cancelled",
        desc: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true."
    },
    DeviceCodeExpired: {
        code: "device_code_expired",
        desc: "Device code is expired."
    },
    DeviceCodeUnknownError: {
        code: "device_code_unknown_error",
        desc: "Device code stopped polling for unknown reasons."
    },
    NoAccountInSilentRequest: {
        code: "no_account_in_silent_request",
        desc: "Please pass an account object, silent flow is not supported without account information"
    },
    invalidCacheRecord: {
        code: "invalid_cache_record",
        desc: "Cache record object was null or undefined."
    },
    invalidCacheEnvironment: {
        code: "invalid_cache_environment",
        desc: "Invalid environment when attempting to create cache entry"
    },
    noAccountFound: {
        code: "no_account_found",
        desc: "No account found in cache for given key."
    },
    CachePluginError: {
        code: "no cache plugin set on CacheManager",
        desc: "ICachePlugin needs to be set before using readFromStorage or writeFromStorage"
    },
    noCryptoObj: {
        code: "no_crypto_object",
        desc: "No crypto object detected. This is required for the following operation: "
    },
    invalidCacheType: {
        code: "invalid_cache_type",
        desc: "Invalid cache type"
    },
    unexpectedAccountType: {
        code: "unexpected_account_type",
        desc: "Unexpected account type."
    },
    unexpectedCredentialType: {
        code: "unexpected_credential_type",
        desc: "Unexpected credential type."
    },
    invalidAssertion: {
        code: "invalid_assertion",
        desc: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515"
    },
    invalidClientCredential: {
        code: "invalid_client_credential",
        desc: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential"
    },
    tokenRefreshRequired: {
        code: "token_refresh_required",
        desc: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired."
    },
    userTimeoutReached: {
        code: "user_timeout_reached",
        desc: "User defined timeout for device code polling reached",
    },
    tokenClaimsRequired: {
        code: "token_claims_cnf_required_for_signedjwt",
        desc: "Cannot generate a POP jwt if the token_claims are not populated"
    },
    noAuthorizationCodeFromServer: {
        code: "authorization_code_missing_from_server_response",
        desc: "Server response does not contain an authorization code to proceed"
    },
    noAzureRegionDetected: {
        code: "no_azure_region_detected",
        desc: "No azure region was detected and no fallback was made available"
    },
    accessTokenEntityNullError: {
        code: "access_token_entity_null",
        desc: "Access token entity is null, please check logs and cache to ensure a valid access token is present."
    },
    bindingKeyNotRemovedError: {
        code: "binding_key_not_removed",
        desc: "Could not remove the credential's binding key from storage."
    },
    logoutNotSupported: {
        code: "end_session_endpoint_not_supported",
        desc: "Provided authority does not support logout."
    },
    keyIdMissing: {
        code: "key_id_missing",
        desc: "A keyId value is missing from the requested bound token's cache record and is required to match the token to it's stored binding key."
    },
    noNetworkConnectivity: {
        code: "no_network_connectivity",
        desc: "No network connectivity. Check your internet connection."
    },
    userCanceledError: {
        code: "user_canceled",
        desc: "User canceled the flow."
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */
var ClientAuthError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(ClientAuthError, _super);
    function ClientAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ClientAuthError";
        Object.setPrototypeOf(_this, ClientAuthError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when client info object doesn't decode correctly.
     * @param caughtError
     */
    ClientAuthError.createClientInfoDecodingError = function (caughtError) {
        return new ClientAuthError(ClientAuthErrorMessage.clientInfoDecodingError.code, ClientAuthErrorMessage.clientInfoDecodingError.desc + " Failed with error: " + caughtError);
    };
    /**
     * Creates an error thrown if the client info is empty.
     * @param rawClientInfo
     */
    ClientAuthError.createClientInfoEmptyError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.clientInfoEmptyError.code, "" + ClientAuthErrorMessage.clientInfoEmptyError.desc);
    };
    /**
     * Creates an error thrown when the id token extraction errors out.
     * @param err
     */
    ClientAuthError.createTokenParsingError = function (caughtExtractionError) {
        return new ClientAuthError(ClientAuthErrorMessage.tokenParsingError.code, ClientAuthErrorMessage.tokenParsingError.desc + " Failed with error: " + caughtExtractionError);
    };
    /**
     * Creates an error thrown when the id token string is null or empty.
     * @param invalidRawTokenString
     */
    ClientAuthError.createTokenNullOrEmptyError = function (invalidRawTokenString) {
        return new ClientAuthError(ClientAuthErrorMessage.nullOrEmptyToken.code, ClientAuthErrorMessage.nullOrEmptyToken.desc + " Raw Token Value: " + invalidRawTokenString);
    };
    /**
     * Creates an error thrown when the endpoint discovery doesn't complete correctly.
     */
    ClientAuthError.createEndpointDiscoveryIncompleteError = function (errDetail) {
        return new ClientAuthError(ClientAuthErrorMessage.endpointResolutionError.code, ClientAuthErrorMessage.endpointResolutionError.desc + " Detail: " + errDetail);
    };
    /**
     * Creates an error thrown when the fetch client throws
     */
    ClientAuthError.createNetworkError = function (endpoint, errDetail) {
        return new ClientAuthError(ClientAuthErrorMessage.networkError.code, ClientAuthErrorMessage.networkError.desc + " | Fetch client threw: " + errDetail + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Creates an error thrown when the openid-configuration endpoint cannot be reached or does not contain the required data
     */
    ClientAuthError.createUnableToGetOpenidConfigError = function (errDetail) {
        return new ClientAuthError(ClientAuthErrorMessage.unableToGetOpenidConfigError.code, ClientAuthErrorMessage.unableToGetOpenidConfigError.desc + " Attempted to retrieve endpoints from: " + errDetail);
    };
    /**
     * Creates an error thrown when the hash cannot be deserialized.
     * @param hashParamObj
     */
    ClientAuthError.createHashNotDeserializedError = function (hashParamObj) {
        return new ClientAuthError(ClientAuthErrorMessage.hashNotDeserialized.code, ClientAuthErrorMessage.hashNotDeserialized.desc + " Given Object: " + hashParamObj);
    };
    /**
     * Creates an error thrown when the state cannot be parsed.
     * @param invalidState
     */
    ClientAuthError.createInvalidStateError = function (invalidState, errorString) {
        return new ClientAuthError(ClientAuthErrorMessage.invalidStateError.code, ClientAuthErrorMessage.invalidStateError.desc + " Invalid State: " + invalidState + ", Root Err: " + errorString);
    };
    /**
     * Creates an error thrown when two states do not match.
     */
    ClientAuthError.createStateMismatchError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.stateMismatchError.code, ClientAuthErrorMessage.stateMismatchError.desc);
    };
    /**
     * Creates an error thrown when the state is not present
     * @param missingState
     */
    ClientAuthError.createStateNotFoundError = function (missingState) {
        return new ClientAuthError(ClientAuthErrorMessage.stateNotFoundError.code, ClientAuthErrorMessage.stateNotFoundError.desc + ":  " + missingState);
    };
    /**
     * Creates an error thrown when the nonce does not match.
     */
    ClientAuthError.createNonceMismatchError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.nonceMismatchError.code, ClientAuthErrorMessage.nonceMismatchError.desc);
    };
    /**
     * Creates an error thrown when max_age was provided in the request, but auth_time is not in the token claims
     * @param missingNonce
     */
    ClientAuthError.createAuthTimeNotFoundError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.authTimeNotFoundError.code, ClientAuthErrorMessage.authTimeNotFoundError.desc);
    };
    /**
     * Creates an error thrown when too much time has elapsed since the last end-user authentication
     */
    ClientAuthError.createMaxAgeTranspiredError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.maxAgeTranspiredError.code, ClientAuthErrorMessage.maxAgeTranspiredError.desc);
    };
    /**
     * Creates an error thrown when the mnonce is not present
     * @param missingNonce
     */
    ClientAuthError.createNonceNotFoundError = function (missingNonce) {
        return new ClientAuthError(ClientAuthErrorMessage.nonceNotFoundError.code, ClientAuthErrorMessage.nonceNotFoundError.desc + ":  " + missingNonce);
    };
    /**
     * Throws error when multiple tokens are in cache.
     */
    ClientAuthError.createMultipleMatchingTokensInCacheError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.multipleMatchingTokens.code, ClientAuthErrorMessage.multipleMatchingTokens.desc + ".");
    };
    /**
     * Throws error when multiple accounts are in cache for the given params
     */
    ClientAuthError.createMultipleMatchingAccountsInCacheError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.multipleMatchingAccounts.code, ClientAuthErrorMessage.multipleMatchingAccounts.desc);
    };
    /**
     * Throws error when multiple appMetada are in cache for the given clientId.
     */
    ClientAuthError.createMultipleMatchingAppMetadataInCacheError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.multipleMatchingAppMetadata.code, ClientAuthErrorMessage.multipleMatchingAppMetadata.desc);
    };
    /**
     * Throws error when no auth code or refresh token is given to ServerTokenRequestParameters.
     */
    ClientAuthError.createTokenRequestCannotBeMadeError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.tokenRequestCannotBeMade.code, ClientAuthErrorMessage.tokenRequestCannotBeMade.desc);
    };
    /**
     * Throws error when attempting to append a null, undefined or empty scope to a set
     * @param givenScope
     */
    ClientAuthError.createAppendEmptyScopeToSetError = function (givenScope) {
        return new ClientAuthError(ClientAuthErrorMessage.appendEmptyScopeError.code, ClientAuthErrorMessage.appendEmptyScopeError.desc + " Given Scope: " + givenScope);
    };
    /**
     * Throws error when attempting to append a null, undefined or empty scope to a set
     * @param givenScope
     */
    ClientAuthError.createRemoveEmptyScopeFromSetError = function (givenScope) {
        return new ClientAuthError(ClientAuthErrorMessage.removeEmptyScopeError.code, ClientAuthErrorMessage.removeEmptyScopeError.desc + " Given Scope: " + givenScope);
    };
    /**
     * Throws error when attempting to append null or empty ScopeSet.
     * @param appendError
     */
    ClientAuthError.createAppendScopeSetError = function (appendError) {
        return new ClientAuthError(ClientAuthErrorMessage.appendScopeSetError.code, ClientAuthErrorMessage.appendScopeSetError.desc + " Detail Error: " + appendError);
    };
    /**
     * Throws error if ScopeSet is null or undefined.
     * @param givenScopeSet
     */
    ClientAuthError.createEmptyInputScopeSetError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.emptyInputScopeSetError.code, "" + ClientAuthErrorMessage.emptyInputScopeSetError.desc);
    };
    /**
     * Throws error if user sets CancellationToken.cancel = true during polling of token endpoint during device code flow
     */
    ClientAuthError.createDeviceCodeCancelledError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.DeviceCodePollingCancelled.code, "" + ClientAuthErrorMessage.DeviceCodePollingCancelled.desc);
    };
    /**
     * Throws error if device code is expired
     */
    ClientAuthError.createDeviceCodeExpiredError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.DeviceCodeExpired.code, "" + ClientAuthErrorMessage.DeviceCodeExpired.desc);
    };
    /**
     * Throws error if device code is expired
     */
    ClientAuthError.createDeviceCodeUnknownError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.DeviceCodeUnknownError.code, "" + ClientAuthErrorMessage.DeviceCodeUnknownError.desc);
    };
    /**
     * Throws error when silent requests are made without an account object
     */
    ClientAuthError.createNoAccountInSilentRequestError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.NoAccountInSilentRequest.code, "" + ClientAuthErrorMessage.NoAccountInSilentRequest.desc);
    };
    /**
     * Throws error when cache record is null or undefined.
     */
    ClientAuthError.createNullOrUndefinedCacheRecord = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidCacheRecord.code, ClientAuthErrorMessage.invalidCacheRecord.desc);
    };
    /**
     * Throws error when provided environment is not part of the CloudDiscoveryMetadata object
     */
    ClientAuthError.createInvalidCacheEnvironmentError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidCacheEnvironment.code, ClientAuthErrorMessage.invalidCacheEnvironment.desc);
    };
    /**
     * Throws error when account is not found in cache.
     */
    ClientAuthError.createNoAccountFoundError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.noAccountFound.code, ClientAuthErrorMessage.noAccountFound.desc);
    };
    /**
     * Throws error if ICachePlugin not set on CacheManager.
     */
    ClientAuthError.createCachePluginError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.CachePluginError.code, "" + ClientAuthErrorMessage.CachePluginError.desc);
    };
    /**
     * Throws error if crypto object not found.
     * @param operationName
     */
    ClientAuthError.createNoCryptoObjectError = function (operationName) {
        return new ClientAuthError(ClientAuthErrorMessage.noCryptoObj.code, "" + ClientAuthErrorMessage.noCryptoObj.desc + operationName);
    };
    /**
     * Throws error if cache type is invalid.
     */
    ClientAuthError.createInvalidCacheTypeError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidCacheType.code, "" + ClientAuthErrorMessage.invalidCacheType.desc);
    };
    /**
     * Throws error if unexpected account type.
     */
    ClientAuthError.createUnexpectedAccountTypeError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.unexpectedAccountType.code, "" + ClientAuthErrorMessage.unexpectedAccountType.desc);
    };
    /**
     * Throws error if unexpected credential type.
     */
    ClientAuthError.createUnexpectedCredentialTypeError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.unexpectedCredentialType.code, "" + ClientAuthErrorMessage.unexpectedCredentialType.desc);
    };
    /**
     * Throws error if client assertion is not valid.
     */
    ClientAuthError.createInvalidAssertionError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidAssertion.code, "" + ClientAuthErrorMessage.invalidAssertion.desc);
    };
    /**
     * Throws error if client assertion is not valid.
     */
    ClientAuthError.createInvalidCredentialError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.invalidClientCredential.code, "" + ClientAuthErrorMessage.invalidClientCredential.desc);
    };
    /**
     * Throws error if token cannot be retrieved from cache due to refresh being required.
     */
    ClientAuthError.createRefreshRequiredError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.tokenRefreshRequired.code, ClientAuthErrorMessage.tokenRefreshRequired.desc);
    };
    /**
     * Throws error if the user defined timeout is reached.
     */
    ClientAuthError.createUserTimeoutReachedError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.userTimeoutReached.code, ClientAuthErrorMessage.userTimeoutReached.desc);
    };
    /*
     * Throws error if token claims are not populated for a signed jwt generation
     */
    ClientAuthError.createTokenClaimsRequiredError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.tokenClaimsRequired.code, ClientAuthErrorMessage.tokenClaimsRequired.desc);
    };
    /**
     * Throws error when the authorization code is missing from the server response
     */
    ClientAuthError.createNoAuthCodeInServerResponseError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.noAuthorizationCodeFromServer.code, ClientAuthErrorMessage.noAuthorizationCodeFromServer.desc);
    };
    ClientAuthError.createBindingKeyNotRemovedError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.bindingKeyNotRemovedError.code, ClientAuthErrorMessage.bindingKeyNotRemovedError.desc);
    };
    /**
     * Thrown when logout is attempted for an authority that doesnt have an end_session_endpoint
     */
    ClientAuthError.createLogoutNotSupportedError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.logoutNotSupported.code, ClientAuthErrorMessage.logoutNotSupported.desc);
    };
    /**
     * Create an error when kid attribute is missing from a PoP token's cache record
     */
    ClientAuthError.createKeyIdMissingError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.keyIdMissing.code, ClientAuthErrorMessage.keyIdMissing.desc);
    };
    /**
     * Create an error when the client does not have network connectivity
     */
    ClientAuthError.createNoNetworkConnectivityError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.noNetworkConnectivity.code, ClientAuthErrorMessage.noNetworkConnectivity.desc);
    };
    /**
     * Create an error when the user cancels the flow
     */
    ClientAuthError.createUserCanceledError = function () {
        return new ClientAuthError(ClientAuthErrorMessage.userCanceledError.code, ClientAuthErrorMessage.userCanceledError.desc);
    };
    return ClientAuthError;
}(__WEBPACK_IMPORTED_MODULE_1__AuthError_js__["a" /* AuthError */]));


//# sourceMappingURL=ClientAuthError.js.map


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1740);


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Input = __webpack_require__(223);

var _FontIcon = __webpack_require__(81);

var _theme = __webpack_require__(1839);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (0, _Input.inputFactory)(_FontIcon.FontIcon);
var ThemedInput = (0, _reactCssThemr.themr)(_identifiers.INPUT, _theme2.default)(Input);

exports.default = ThemedInput;
exports.Input = ThemedInput;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(29);
var IE8_DOM_DEFINE = __webpack_require__(946);
var toPrimitive = __webpack_require__(124);
var dP = Object.defineProperty;

exports.f = __webpack_require__(56) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconMenu = exports.Menu = exports.MenuItem = exports.MenuDivider = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _button = __webpack_require__(8);

var _MenuDivider = __webpack_require__(1882);

var _MenuItem = __webpack_require__(905);

var _Menu = __webpack_require__(906);

var _IconMenu = __webpack_require__(1885);

var _ripple = __webpack_require__(162);

var _ripple2 = _interopRequireDefault(_ripple);

var _theme = __webpack_require__(1886);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applyTheme = function applyTheme(Component) {
  return (0, _reactCssThemr.themr)(_identifiers.MENU, _theme2.default)(Component);
};
var ThemedMenuDivider = applyTheme(_MenuDivider.MenuDivider);
var ThemedMenuItem = applyTheme((0, _MenuItem.menuItemFactory)((0, _ripple2.default)({})));
var ThemedMenu = applyTheme((0, _Menu.menuFactory)(ThemedMenuItem));
var ThemedIconMenu = applyTheme((0, _IconMenu.iconMenuFactory)(_button.IconButton, ThemedMenu));

exports.MenuDivider = ThemedMenuDivider;
exports.MenuItem = ThemedMenuItem;
exports.Menu = ThemedMenu;
exports.IconMenu = ThemedIconMenu;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(123);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StringUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__ = __webpack_require__(57);
/*! @azure/msal-common v13.3.1 2023-10-27 */



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var StringUtils = /** @class */ (function () {
    function StringUtils() {
    }
    /**
     * decode a JWT
     *
     * @param authToken
     */
    StringUtils.decodeAuthToken = function (authToken) {
        if (StringUtils.isEmpty(authToken)) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__["a" /* ClientAuthError */].createTokenNullOrEmptyError(authToken);
        }
        var tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
        var matches = tokenPartsRegex.exec(authToken);
        if (!matches || matches.length < 4) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__["a" /* ClientAuthError */].createTokenParsingError("Given token is malformed: " + JSON.stringify(authToken));
        }
        var crackedToken = {
            header: matches[1],
            JWSPayload: matches[2],
            JWSSig: matches[3]
        };
        return crackedToken;
    };
    /**
     * Check if a string is empty.
     *
     * @param str
     */
    StringUtils.isEmpty = function (str) {
        return (typeof str === "undefined" || !str || 0 === str.length);
    };
    /**
     * Check if stringified object is empty
     * @param strObj
     */
    StringUtils.isEmptyObj = function (strObj) {
        if (strObj && !StringUtils.isEmpty(strObj)) {
            try {
                var obj = JSON.parse(strObj);
                return Object.keys(obj).length === 0;
            }
            catch (e) { }
        }
        return true;
    };
    StringUtils.startsWith = function (str, search) {
        return str.indexOf(search) === 0;
    };
    StringUtils.endsWith = function (str, search) {
        return (str.length >= search.length) && (str.lastIndexOf(search) === (str.length - search.length));
    };
    /**
     * Parses string into an object.
     *
     * @param query
     */
    StringUtils.queryStringToObject = function (query) {
        var obj = {};
        var params = query.split("&");
        var decode = function (s) { return decodeURIComponent(s.replace(/\+/g, " ")); };
        params.forEach(function (pair) {
            if (pair.trim()) {
                var _a = pair.split(/=(.+)/g, 2), key = _a[0], value = _a[1]; // Split on the first occurence of the '=' character
                if (key && value) {
                    obj[decode(key)] = decode(value);
                }
            }
        });
        return obj;
    };
    /**
     * Trims entries in an array.
     *
     * @param arr
     */
    StringUtils.trimArrayEntries = function (arr) {
        return arr.map(function (entry) { return entry.trim(); });
    };
    /**
     * Removes empty strings from array
     * @param arr
     */
    StringUtils.removeEmptyStringsFromArray = function (arr) {
        return arr.filter(function (entry) {
            return !StringUtils.isEmpty(entry);
        });
    };
    /**
     * Attempts to parse a string into JSON
     * @param str
     */
    StringUtils.jsonParseHelper = function (str) {
        try {
            return JSON.parse(str);
        }
        catch (e) {
            return null;
        }
    };
    /**
     * Tests if a given string matches a given pattern, with support for wildcards and queries.
     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards and "?" for queries
     * @param input String to match against
     */
    StringUtils.matchPattern = function (pattern, input) {
        /**
         * Wildcard support: https://stackoverflow.com/a/3117248/4888559
         * Queries: replaces "?" in string with escaped "\?" for regex test
         */
        var regex = new RegExp(pattern.replace(/\\/g, "\\\\").replace(/\*/g, "[^ ]*").replace(/\?/g, "\\\?")); // eslint-disable-line security/detect-non-literal-regexp
        return regex.test(input);
    };
    return StringUtils;
}());


//# sourceMappingURL=StringUtils.js.map


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._findRoute = _findRoute;
exports.findRoute = findRoute;
exports.pushRoute = pushRoute;
exports.replaceRoute = replaceRoute;
exports.directRoute = directRoute;

var _reactRouter = __webpack_require__(245);

var _routes = __webpack_require__(748);

var _routes2 = _interopRequireDefault(_routes);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/route.js

function _findRoute(route, name, params, path) {
  if (route.props.name == name) {
    var restParams = {};
    if (params) (0, _each2.default)(params, function (value, key) {
      if (path.match(':' + key)) path = path.replace(':' + key, value);else restParams[key] = value;
    });
    var param = (0, _map2.default)(restParams, function (value, key) {
      return key + '=' + encodeURIComponent(value);
    }).join('&');

    return path.replace(/\/+/g, '/') + (param ? '?' + param : '');
  }

  var children = route.props.children;
  if (children && !(children instanceof Array)) {
    children = [children];
  }
  for (var i = 0; children && i < children.length; i++) {
    var _path = children[i].props.path || path;
    if (_path.slice(0, 1) != '/') {
      _path = path + '/' + children[i].props.path;
    }
    var result = _findRoute(children[i], name, params, _path);
    if (result) return result;
  }
}

function findRoute(name, params) {
  return _findRoute(_routes2.default, name, params, '/');
}

function pushRoute(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var path = findRoute(name, params);
  if (path) _reactRouter.hashHistory.push(findRoute(name, params));
}

function replaceRoute(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var path = findRoute(name, params);
  if (path) _reactRouter.hashHistory.replace(findRoute(name, params));
}

function directRoute(path) {
  _reactRouter.hashHistory.replace(path);
}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/* eslint guard-for-in:0 */
var AWS;

/**
 * A set of utility methods for use with the AWS SDK.
 *
 * @!attribute abort
 *   Return this value from an iterator function {each} or {arrayEach}
 *   to break out of the iteration.
 *   @example Breaking out of an iterator function
 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
 *       if (key == 'b') return AWS.util.abort;
 *     });
 *   @see each
 *   @see arrayEach
 * @api private
 */
var util = {
  environment: 'nodejs',
  engine: function engine() {
    if (util.isBrowser() && typeof navigator !== 'undefined') {
      return navigator.userAgent;
    } else {
      var engine = process.platform + '/' + process.version;
      if (Object({"NODE_ENV":"production","RAILS_ENV":"production","BUILD_NO":"202507040022","REACT_NATIVE":false}).AWS_EXECUTION_ENV) {
        engine += ' exec-env/' + Object({"NODE_ENV":"production","RAILS_ENV":"production","BUILD_NO":"202507040022","REACT_NATIVE":false}).AWS_EXECUTION_ENV;
      }
      return engine;
    }
  },

  userAgent: function userAgent() {
    var name = util.environment;
    var agent = 'aws-sdk-' + name + '/' + __webpack_require__(7).VERSION;
    if (name === 'nodejs') agent += ' ' + util.engine();
    return agent;
  },

  isBrowser: function isBrowser() { return process && process.browser; },
  isNode: function isNode() { return !util.isBrowser(); },
  uriEscape: function uriEscape(string) {
    var output = encodeURIComponent(string);
    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);

    // AWS percent-encodes some extra non-standard characters in a URI
    output = output.replace(/[*]/g, function(ch) {
      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
    });

    return output;
  },

  uriEscapePath: function uriEscapePath(string) {
    var parts = [];
    util.arrayEach(string.split('/'), function (part) {
      parts.push(util.uriEscape(part));
    });
    return parts.join('/');
  },

  urlParse: function urlParse(url) {
    return util.url.parse(url);
  },

  urlFormat: function urlFormat(url) {
    return util.url.format(url);
  },

  queryStringParse: function queryStringParse(qs) {
    return util.querystring.parse(qs);
  },

  queryParamsToString: function queryParamsToString(params) {
    var items = [];
    var escape = util.uriEscape;
    var sortedKeys = Object.keys(params).sort();

    util.arrayEach(sortedKeys, function(name) {
      var value = params[name];
      var ename = escape(name);
      var result = ename + '=';
      if (Array.isArray(value)) {
        var vals = [];
        util.arrayEach(value, function(item) { vals.push(escape(item)); });
        result = ename + '=' + vals.sort().join('&' + ename + '=');
      } else if (value !== undefined && value !== null) {
        result = ename + '=' + escape(value);
      }
      items.push(result);
    });

    return items.join('&');
  },

  readFileSync: function readFileSync(path) {
    if (util.isBrowser()) return null;
    return __webpack_require__(456).readFileSync(path, 'utf-8');
  },

  base64: {
    encode: function encode64(string) {
      if (typeof string === 'number') {
        throw util.error(new Error('Cannot base64 encode number ' + string));
      }
      if (string === null || typeof string === 'undefined') {
        return string;
      }
      var buf = (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ? util.Buffer.from(string) : new util.Buffer(string);
      return buf.toString('base64');
    },

    decode: function decode64(string) {
      if (typeof string === 'number') {
        throw util.error(new Error('Cannot base64 decode number ' + string));
      }
      if (string === null || typeof string === 'undefined') {
        return string;
      }
      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ? util.Buffer.from(string, 'base64') : new util.Buffer(string, 'base64');
    }

  },

  buffer: {
    toStream: function toStream(buffer) {
      if (!util.Buffer.isBuffer(buffer)) buffer = new util.Buffer(buffer);

      var readable = new (util.stream.Readable)();
      var pos = 0;
      readable._read = function(size) {
        if (pos >= buffer.length) return readable.push(null);

        var end = pos + size;
        if (end > buffer.length) end = buffer.length;
        readable.push(buffer.slice(pos, end));
        pos = end;
      };

      return readable;
    },

    /**
     * Concatenates a list of Buffer objects.
     */
    concat: function(buffers) {
      var length = 0,
          offset = 0,
          buffer = null, i;

      for (i = 0; i < buffers.length; i++) {
        length += buffers[i].length;
      }

      buffer = new util.Buffer(length);

      for (i = 0; i < buffers.length; i++) {
        buffers[i].copy(buffer, offset);
        offset += buffers[i].length;
      }

      return buffer;
    }
  },

  string: {
    byteLength: function byteLength(string) {
      if (string === null || string === undefined) return 0;
      if (typeof string === 'string') string = new util.Buffer(string);

      if (typeof string.byteLength === 'number') {
        return string.byteLength;
      } else if (typeof string.length === 'number') {
        return string.length;
      } else if (typeof string.size === 'number') {
        return string.size;
      } else if (typeof string.path === 'string') {
        return __webpack_require__(456).lstatSync(string.path).size;
      } else {
        throw util.error(new Error('Cannot determine length of ' + string),
          { object: string });
      }
    },

    upperFirst: function upperFirst(string) {
      return string[0].toUpperCase() + string.substr(1);
    },

    lowerFirst: function lowerFirst(string) {
      return string[0].toLowerCase() + string.substr(1);
    }
  },

  ini: {
    parse: function string(ini) {
      var currentSection, map = {};
      util.arrayEach(ini.split(/\r?\n/), function(line) {
        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
        if (section) {
          currentSection = section[1];
        } else if (currentSection) {
          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
          if (item) {
            map[currentSection] = map[currentSection] || {};
            map[currentSection][item[1]] = item[2];
          }
        }
      });

      return map;
    }
  },

  fn: {
    noop: function() {},

    /**
     * Turn a synchronous function into as "async" function by making it call
     * a callback. The underlying function is called with all but the last argument,
     * which is treated as the callback. The callback is passed passed a first argument
     * of null on success to mimick standard node callbacks.
     */
    makeAsync: function makeAsync(fn, expectedArgs) {
      if (expectedArgs && expectedArgs <= fn.length) {
        return fn;
      }

      return function() {
        var args = Array.prototype.slice.call(arguments, 0);
        var callback = args.pop();
        var result = fn.apply(null, args);
        callback(result);
      };
    }
  },

  /**
   * Date and time utility functions.
   */
  date: {

    /**
     * @return [Date] the current JavaScript date object. Since all
     *   AWS services rely on this date object, you can override
     *   this function to provide a special time value to AWS service
     *   requests.
     */
    getDate: function getDate() {
      if (!AWS) AWS = __webpack_require__(7);
      if (AWS.config.systemClockOffset) { // use offset when non-zero
        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
      } else {
        return new Date();
      }
    },

    /**
     * @return [String] the date in ISO-8601 format
     */
    iso8601: function iso8601(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
    },

    /**
     * @return [String] the date in RFC 822 format
     */
    rfc822: function rfc822(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.toUTCString();
    },

    /**
     * @return [Integer] the UNIX timestamp value for the current time
     */
    unixTimestamp: function unixTimestamp(date) {
      if (date === undefined) { date = util.date.getDate(); }
      return date.getTime() / 1000;
    },

    /**
     * @param [String,number,Date] date
     * @return [Date]
     */
    from: function format(date) {
      if (typeof date === 'number') {
        return new Date(date * 1000); // unix timestamp
      } else {
        return new Date(date);
      }
    },

    /**
     * Given a Date or date-like value, this function formats the
     * date into a string of the requested value.
     * @param [String,number,Date] date
     * @param [String] formatter Valid formats are:
     #   * 'iso8601'
     #   * 'rfc822'
     #   * 'unixTimestamp'
     * @return [String]
     */
    format: function format(date, formatter) {
      if (!formatter) formatter = 'iso8601';
      return util.date[formatter](util.date.from(date));
    },

    parseTimestamp: function parseTimestamp(value) {
      if (typeof value === 'number') { // unix timestamp (number)
        return new Date(value * 1000);
      } else if (value.match(/^\d+$/)) { // unix timestamp
        return new Date(value * 1000);
      } else if (value.match(/^\d{4}/)) { // iso8601
        return new Date(value);
      } else if (value.match(/^\w{3},/)) { // rfc822
        return new Date(value);
      } else {
        throw util.error(
          new Error('unhandled timestamp format: ' + value),
          {code: 'TimestampParserError'});
      }
    }

  },

  crypto: {
    crc32Table: [
     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
     0x2D02EF8D],

    crc32: function crc32(data) {
      var tbl = util.crypto.crc32Table;
      var crc = 0 ^ -1;

      if (typeof data === 'string') {
        data = new util.Buffer(data);
      }

      for (var i = 0; i < data.length; i++) {
        var code = data.readUInt8(i);
        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
      }
      return (crc ^ -1) >>> 0;
    },

    hmac: function hmac(key, string, digest, fn) {
      if (!digest) digest = 'binary';
      if (digest === 'buffer') { digest = undefined; }
      if (!fn) fn = 'sha256';
      if (typeof string === 'string') string = new util.Buffer(string);
      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
    },

    md5: function md5(data, digest, callback) {
      return util.crypto.hash('md5', data, digest, callback);
    },

    sha256: function sha256(data, digest, callback) {
      return util.crypto.hash('sha256', data, digest, callback);
    },

    hash: function(algorithm, data, digest, callback) {
      var hash = util.crypto.createHash(algorithm);
      if (!digest) { digest = 'binary'; }
      if (digest === 'buffer') { digest = undefined; }
      if (typeof data === 'string') data = new util.Buffer(data);
      var sliceFn = util.arraySliceFn(data);
      var isBuffer = util.Buffer.isBuffer(data);
      //Identifying objects with an ArrayBuffer as buffers
      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;

      if (callback && typeof data === 'object' &&
          typeof data.on === 'function' && !isBuffer) {
        data.on('data', function(chunk) { hash.update(chunk); });
        data.on('error', function(err) { callback(err); });
        data.on('end', function() { callback(null, hash.digest(digest)); });
      } else if (callback && sliceFn && !isBuffer &&
                 typeof FileReader !== 'undefined') {
        // this might be a File/Blob
        var index = 0, size = 1024 * 512;
        var reader = new FileReader();
        reader.onerror = function() {
          callback(new Error('Failed to read data.'));
        };
        reader.onload = function() {
          var buf = new util.Buffer(new Uint8Array(reader.result));
          hash.update(buf);
          index += buf.length;
          reader._continueReading();
        };
        reader._continueReading = function() {
          if (index >= data.size) {
            callback(null, hash.digest(digest));
            return;
          }

          var back = index + size;
          if (back > data.size) back = data.size;
          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
        };

        reader._continueReading();
      } else {
        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
          data = new util.Buffer(new Uint8Array(data));
        }
        var out = hash.update(data).digest(digest);
        if (callback) callback(null, out);
        return out;
      }
    },

    toHex: function toHex(data) {
      var out = [];
      for (var i = 0; i < data.length; i++) {
        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
      }
      return out.join('');
    },

    createHash: function createHash(algorithm) {
      return util.crypto.lib.createHash(algorithm);
    }

  },

  /** @!ignore */

  /* Abort constant */
  abort: {},

  each: function each(object, iterFunction) {
    for (var key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        var ret = iterFunction.call(this, key, object[key]);
        if (ret === util.abort) break;
      }
    }
  },

  arrayEach: function arrayEach(array, iterFunction) {
    for (var idx in array) {
      if (Object.prototype.hasOwnProperty.call(array, idx)) {
        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
        if (ret === util.abort) break;
      }
    }
  },

  update: function update(obj1, obj2) {
    util.each(obj2, function iterator(key, item) {
      obj1[key] = item;
    });
    return obj1;
  },

  merge: function merge(obj1, obj2) {
    return util.update(util.copy(obj1), obj2);
  },

  copy: function copy(object) {
    if (object === null || object === undefined) return object;
    var dupe = {};
    // jshint forin:false
    for (var key in object) {
      dupe[key] = object[key];
    }
    return dupe;
  },

  isEmpty: function isEmpty(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  },

  arraySliceFn: function arraySliceFn(obj) {
    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
    return typeof fn === 'function' ? fn : null;
  },

  isType: function isType(obj, type) {
    // handle cross-"frame" objects
    if (typeof type === 'function') type = util.typeName(type);
    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
  },

  typeName: function typeName(type) {
    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
    var str = type.toString();
    var match = str.match(/^\s*function (.+)\(/);
    return match ? match[1] : str;
  },

  error: function error(err, options) {
    var originalError = null;
    if (typeof err.message === 'string' && err.message !== '') {
      if (typeof options === 'string' || (options && options.message)) {
        originalError = util.copy(err);
        originalError.message = err.message;
      }
    }
    err.message = err.message || null;

    if (typeof options === 'string') {
      err.message = options;
    } else if (typeof options === 'object' && options !== null) {
      util.update(err, options);
      if (options.message)
        err.message = options.message;
      if (options.code || options.name)
        err.code = options.code || options.name;
      if (options.stack)
        err.stack = options.stack;
    }

    if (typeof Object.defineProperty === 'function') {
      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
      Object.defineProperty(err, 'message', {enumerable: true});
    }

    err.name = options && options.name || err.name || err.code || 'Error';
    err.time = new Date();

    if (originalError) err.originalError = originalError;

    return err;
  },

  /**
   * @api private
   */
  inherit: function inherit(klass, features) {
    var newObject = null;
    if (features === undefined) {
      features = klass;
      klass = Object;
      newObject = {};
    } else {
      var ctor = function ConstructorWrapper() {};
      ctor.prototype = klass.prototype;
      newObject = new ctor();
    }

    // constructor not supplied, create pass-through ctor
    if (features.constructor === Object) {
      features.constructor = function() {
        if (klass !== Object) {
          return klass.apply(this, arguments);
        }
      };
    }

    features.constructor.prototype = newObject;
    util.update(features.constructor.prototype, features);
    features.constructor.__super__ = klass;
    return features.constructor;
  },

  /**
   * @api private
   */
  mixin: function mixin() {
    var klass = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
      // jshint forin:false
      for (var prop in arguments[i].prototype) {
        var fn = arguments[i].prototype[prop];
        if (prop !== 'constructor') {
          klass.prototype[prop] = fn;
        }
      }
    }
    return klass;
  },

  /**
   * @api private
   */
  hideProperties: function hideProperties(obj, props) {
    if (typeof Object.defineProperty !== 'function') return;

    util.arrayEach(props, function (key) {
      Object.defineProperty(obj, key, {
        enumerable: false, writable: true, configurable: true });
    });
  },

  /**
   * @api private
   */
  property: function property(obj, name, value, enumerable, isValue) {
    var opts = {
      configurable: true,
      enumerable: enumerable !== undefined ? enumerable : true
    };
    if (typeof value === 'function' && !isValue) {
      opts.get = value;
    }
    else {
      opts.value = value; opts.writable = true;
    }

    Object.defineProperty(obj, name, opts);
  },

  /**
   * @api private
   */
  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
    var cachedValue = null;

    // build enumerable attribute for each value with lazy accessor.
    util.property(obj, name, function() {
      if (cachedValue === null) {
        cachedValue = get();
      }
      return cachedValue;
    }, enumerable);
  },

  /**
   * TODO Remove in major version revision
   * This backfill populates response data without the
   * top-level payload name.
   *
   * @api private
   */
  hoistPayloadMember: function hoistPayloadMember(resp) {
    var req = resp.request;
    var operation = req.operation;
    var output = req.service.api.operations[operation].output;
    if (output.payload) {
      var payloadMember = output.members[output.payload];
      var responsePayload = resp.data[output.payload];
      if (payloadMember.type === 'structure') {
        util.each(responsePayload, function(key, value) {
          util.property(resp.data, key, value, false);
        });
      }
    }
  },

  /**
   * Compute SHA-256 checksums of streams
   *
   * @api private
   */
  computeSha256: function computeSha256(body, done) {
    if (util.isNode()) {
      var Stream = util.stream.Stream;
      var fs = __webpack_require__(456);
      if (body instanceof Stream) {
        if (typeof body.path === 'string') { // assume file object
          var settings = {};
          if (typeof body.start === 'number') {
            settings.start = body.start;
          }
          if (typeof body.end === 'number') {
            settings.end = body.end;
          }
          body = fs.createReadStream(body.path, settings);
        } else { // TODO support other stream types
          return done(new Error('Non-file stream objects are ' +
                                'not supported with SigV4'));
        }
      }
    }

    util.crypto.sha256(body, 'hex', function(err, sha) {
      if (err) done(err);
      else done(null, sha);
    });
  },

  /**
   * @api private
   */
  isClockSkewed: function isClockSkewed(serverTime) {
    if (serverTime) {
      util.property(AWS.config, 'isClockSkewed',
        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
      return AWS.config.isClockSkewed;
    }
  },

  applyClockOffset: function applyClockOffset(serverTime) {
    if (serverTime)
      AWS.config.systemClockOffset = serverTime - new Date().getTime();
  },

  /**
   * @api private
   */
  extractRequestId: function extractRequestId(resp) {
    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
                     resp.httpResponse.headers['x-amzn-requestid'];

    if (!requestId && resp.data && resp.data.ResponseMetadata) {
      requestId = resp.data.ResponseMetadata.RequestId;
    }

    if (requestId) {
      resp.requestId = requestId;
    }

    if (resp.error) {
      resp.error.requestId = requestId;
    }
  },

  /**
   * @api private
   */
  addPromises: function addPromises(constructors, PromiseDependency) {
    if (PromiseDependency === undefined && AWS && AWS.config) {
      PromiseDependency = AWS.config.getPromisesDependency();
    }
    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
      PromiseDependency = Promise;
    }
    if (typeof PromiseDependency !== 'function') var deletePromises = true;
    if (!Array.isArray(constructors)) constructors = [constructors];

    for (var ind = 0; ind < constructors.length; ind++) {
      var constructor = constructors[ind];
      if (deletePromises) {
        if (constructor.deletePromisesFromClass) {
          constructor.deletePromisesFromClass();
        }
      } else if (constructor.addPromisesToClass) {
        constructor.addPromisesToClass(PromiseDependency);
      }
    }
  },

  /**
   * @api private
   */
  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
    return function promise() {
      var self = this;
      return new PromiseDependency(function(resolve, reject) {
        self[methodName](function(err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        });
      });
    };
  },

  /**
   * @api private
   */
  isDualstackAvailable: function isDualstackAvailable(service) {
    if (!service) return false;
    var metadata = __webpack_require__(1478);
    if (typeof service !== 'string') service = service.serviceIdentifier;
    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
    return !!metadata[service].dualstackAvailable;
  },

  /**
   * @api private
   */
  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions) {
    if (!retryDelayOptions) retryDelayOptions = {};
    var customBackoff = retryDelayOptions.customBackoff || null;
    if (typeof customBackoff === 'function') {
      return customBackoff(retryCount);
    }
    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
    var delay = Math.random() * (Math.pow(2, retryCount) * base);
    return delay;
  },

  /**
   * @api private
   */
  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
    if (!options) options = {};
    var http = AWS.HttpClient.getInstance();
    var httpOptions = options.httpOptions || {};
    var retryCount = 0;

    var errCallback = function(err) {
      var maxRetries = options.maxRetries || 0;
      if (err && err.code === 'TimeoutError') err.retryable = true;
      if (err && err.retryable && retryCount < maxRetries) {
        retryCount++;
        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions);
        setTimeout(sendRequest, delay + (err.retryAfter || 0));
      } else {
        cb(err);
      }
    };

    var sendRequest = function() {
      var data = '';
      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
        httpResponse.on('end', function() {
          var statusCode = httpResponse.statusCode;
          if (statusCode < 300) {
            cb(null, data);
          } else {
            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
            var err = util.error(new Error(),
              { retryable: statusCode >= 500 || statusCode === 429 }
            );
            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
            errCallback(err);
          }
        });
      }, errCallback);
    };

    AWS.util.defer(sendRequest);
  },

  /**
   * @api private
   */
  uuid: {
    v4: function uuidV4() {
      return __webpack_require__(1479).v4();
    }
  },

  /**
   * @api private
   */
  convertPayloadToString: function convertPayloadToString(resp) {
    var req = resp.request;
    var operation = req.operation;
    var rules = req.service.api.operations[operation].output || {};
    if (rules.payload && resp.data[rules.payload]) {
      resp.data[rules.payload] = resp.data[rules.payload].toString();
    }
  },

  /**
   * @api private
   */
  defer: function defer(callback) {
    if (typeof process === 'object' && typeof process.nextTick === 'function') {
      process.nextTick(callback);
    } else if (typeof setImmediate === 'function') {
      setImmediate(callback);
    } else {
      setTimeout(callback, 0);
    }
  },

  /**
   * @api private
   */
  defaultProfile: 'default',

  /**
   * @api private
   */
  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',

  /**
   * @api private
   */
  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',

  /**
   * @api private
   */
  sharedConfigFileEnv: 'AWS_CONFIG_FILE'
};

module.exports = util;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66), __webpack_require__(439).setImmediate))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1934);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./success-button.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./success-button.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2506);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawRightSidePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rightSidePage = __webpack_require__(2553);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _navigation = __webpack_require__(147);

var _button = __webpack_require__(8);

var _app_bar = __webpack_require__(122);

var _app_bar2 = _interopRequireDefault(_app_bar);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _rightSidePageAppBar = __webpack_require__(559);

var _rightSidePageAppBar2 = _interopRequireDefault(_rightSidePageAppBar);

var _theme = __webpack_require__(878);

var _theme2 = _interopRequireDefault(_theme);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/right-side-page.jsx

var RightSidePage = function (_React$Component) {
  _inherits(RightSidePage, _React$Component);

  function RightSidePage(props) {
    _classCallCheck(this, RightSidePage);

    var _this = _possibleConstructorReturn(this, (RightSidePage.__proto__ || Object.getPrototypeOf(RightSidePage)).call(this));

    _this.scrollTo = function (offset) {
      offset ? _reactDom2.default.findDOMNode(_this.refs.scrollBase).scrollTop += offset : _reactDom2.default.findDOMNode(_this.refs.scrollBase).scrollTop = 0;
    };

    _this.kpiScrollPosition = function () {
      return _reactDom2.default.findDOMNode(_this.refs.scrollBase).scrollTop;
    };

    _this.renderGroupMemberIcon = function () {
      var members = _this.props.members;

      var renderItem = members && _react2.default.createElement(_avatar2.default, { key: members[0].user_id, image: members[0].icon_image.thumb_url, theme: _rightSidePageAppBar2.default });
      return renderItem;
    };

    if (props.innerRef) props.innerRef(_this);
    return _this;
  }

  _createClass(RightSidePage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          title = _props.title,
          subTitle = _props.subTitle,
          image = _props.image,
          icon = _props.icon,
          icon_image = _props.icon_image,
          members = _props.members,
          children = _props.children,
          closeRightSidePage = _props.closeRightSidePage,
          rightAction = _props.rightAction,
          key = _props.key,
          absoluteFooter = _props.absoluteFooter,
          childrenNotScroll = _props.childrenNotScroll,
          profile = _props.profile;


      return _react2.default.createElement(
        'div',
        { className: _rightSidePageAppBar2.default.baseDiv, key: key },
        _react2.default.createElement(
          _app_bar2.default,
          {
            flat: true,
            theme: _rightSidePageAppBar2.default,
            leftIcon: icon_image ? _react2.default.createElement(_avatar2.default, { icon: icon, image: icon_image.thumb_url }) : !members && _react2.default.createElement(_avatar2.default, { icon: icon, image: image }) || this.renderGroupMemberIcon()
          },
          _react2.default.createElement(
            'div',
            { className: _rightSidePageAppBar2.default.titleDiv },
            !subTitle && _react2.default.createElement(
              'h1',
              { className: _theme2.default.title },
              _lodash2.default.unescape(title)
            ),
            subTitle && _react2.default.createElement(
              'div',
              { className: _rightSidePageAppBar2.default.subTitleDiv },
              _react2.default.createElement(
                'h1',
                { className: _theme2.default.title, style: { marginBottom: 0 } },
                title
              ),
              _react2.default.createElement(
                'span',
                { className: _rightSidePageAppBar2.default.subTitle },
                subTitle
              )
            )
          ),
          _react2.default.createElement(
            _navigation.Navigation,
            { type: 'horizontal', style: { whiteSpace: 'nowrap' }, theme: _rightSidePageAppBar2.default },
            rightAction,
            _react2.default.createElement(_button.IconButton, { icon: 'close', onClick: function onClick() {
                return closeRightSidePage(_this2.props);
              } })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _rightSidePageAppBar2.default.childrenDiv },
          _react2.default.createElement(
            'div',
            { className: _rightSidePageAppBar2.default.childrenScroll, ref: 'scrollBase' },
            children
          )
        ),
        absoluteFooter && _react2.default.createElement(
          'div',
          { className: _rightSidePageAppBar2.default.absoluteFooter },
          absoluteFooter
        )
      );
    }
  }]);

  return RightSidePage;
}(_react2.default.Component);

var RawRightSidePage = exports.RawRightSidePage = RightSidePage;
exports.default = (0, _rightSidePage2.default)(RightSidePage);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isSpace = exports.isString = exports.isNum = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.info = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__webpack_require__(2437);

var _streams_polyfill = __webpack_require__(2445);

var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
var NativeImageDecoding = {
  NONE: 'none',
  DECODE: 'decode',
  DISPLAY: 'display'
};
var TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
};
var ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
};
var AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
};
var AnnotationFlag = {
  INVISIBLE: 0x01,
  HIDDEN: 0x02,
  PRINT: 0x04,
  NOZOOM: 0x08,
  NOROTATE: 0x10,
  NOVIEW: 0x20,
  READONLY: 0x40,
  LOCKED: 0x80,
  TOGGLENOVIEW: 0x100,
  LOCKEDCONTENTS: 0x200
};
var AnnotationFieldFlag = {
  READONLY: 0x0000001,
  REQUIRED: 0x0000002,
  NOEXPORT: 0x0000004,
  MULTILINE: 0x0001000,
  PASSWORD: 0x0002000,
  NOTOGGLETOOFF: 0x0004000,
  RADIO: 0x0008000,
  PUSHBUTTON: 0x0010000,
  COMBO: 0x0020000,
  EDIT: 0x0040000,
  SORT: 0x0080000,
  FILESELECT: 0x0100000,
  MULTISELECT: 0x0200000,
  DONOTSPELLCHECK: 0x0400000,
  DONOTSCROLL: 0x0800000,
  COMB: 0x1000000,
  RICHTEXT: 0x2000000,
  RADIOSINUNISON: 0x2000000,
  COMMITONSELCHANGE: 0x4000000
};
var AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
};
var StreamType = {
  UNKNOWN: 0,
  FLATE: 1,
  LZW: 2,
  DCT: 3,
  JPX: 4,
  JBIG: 5,
  A85: 6,
  AHX: 7,
  CCF: 8,
  RL: 9
};
var FontType = {
  UNKNOWN: 0,
  TYPE1: 1,
  TYPE1C: 2,
  CIDFONTTYPE0: 3,
  CIDFONTTYPE0C: 4,
  TRUETYPE: 5,
  CIDFONTTYPE2: 6,
  TYPE3: 7,
  OPENTYPE: 8,
  TYPE0: 9,
  MMTYPE1: 10
};
var VERBOSITY_LEVELS = {
  errors: 0,
  warnings: 1,
  infos: 5
};
var CMapCompressionType = {
  NONE: 0,
  BINARY: 1,
  STREAM: 2
};
var OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotations: 78,
  endAnnotations: 79,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintJpegXObject: 82,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91
};
var verbosity = VERBOSITY_LEVELS.warnings;
function setVerbosityLevel(level) {
  verbosity = level;
}
function getVerbosityLevel() {
  return verbosity;
}
function info(msg) {
  if (verbosity >= VERBOSITY_LEVELS.infos) {
    console.log('Info: ' + msg);
  }
}
function warn(msg) {
  if (verbosity >= VERBOSITY_LEVELS.warnings) {
    console.log('Warning: ' + msg);
  }
}
function deprecated(details) {
  console.log('Deprecated API usage: ' + details);
}
function unreachable(msg) {
  throw new Error(msg);
}
function assert(cond, msg) {
  if (!cond) {
    unreachable(msg);
  }
}
var UNSUPPORTED_FEATURES = {
  unknown: 'unknown',
  forms: 'forms',
  javaScript: 'javaScript',
  smask: 'smask',
  shadingPattern: 'shadingPattern',
  font: 'font'
};
function isSameOrigin(baseUrl, otherUrl) {
  try {
    var base = new URL(baseUrl);
    if (!base.origin || base.origin === 'null') {
      return false;
    }
  } catch (e) {
    return false;
  }
  var other = new URL(otherUrl, base);
  return base.origin === other.origin;
}
function isValidProtocol(url) {
  if (!url) {
    return false;
  }
  switch (url.protocol) {
    case 'http:':
    case 'https:':
    case 'ftp:':
    case 'mailto:':
    case 'tel:':
      return true;
    default:
      return false;
  }
}
function createValidAbsoluteUrl(url, baseUrl) {
  if (!url) {
    return null;
  }
  try {
    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
    if (isValidProtocol(absoluteUrl)) {
      return absoluteUrl;
    }
  } catch (ex) {}
  return null;
}
function shadow(obj, prop, value) {
  Object.defineProperty(obj, prop, {
    value: value,
    enumerable: true,
    configurable: true,
    writable: false
  });
  return value;
}
function getLookupTableFactory(initializer) {
  var lookup;
  return function () {
    if (initializer) {
      lookup = Object.create(null);
      initializer(lookup);
      initializer = null;
    }
    return lookup;
  };
}
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
var PasswordException = function PasswordExceptionClosure() {
  function PasswordException(msg, code) {
    this.name = 'PasswordException';
    this.message = msg;
    this.code = code;
  }
  PasswordException.prototype = new Error();
  PasswordException.constructor = PasswordException;
  return PasswordException;
}();
var UnknownErrorException = function UnknownErrorExceptionClosure() {
  function UnknownErrorException(msg, details) {
    this.name = 'UnknownErrorException';
    this.message = msg;
    this.details = details;
  }
  UnknownErrorException.prototype = new Error();
  UnknownErrorException.constructor = UnknownErrorException;
  return UnknownErrorException;
}();
var InvalidPDFException = function InvalidPDFExceptionClosure() {
  function InvalidPDFException(msg) {
    this.name = 'InvalidPDFException';
    this.message = msg;
  }
  InvalidPDFException.prototype = new Error();
  InvalidPDFException.constructor = InvalidPDFException;
  return InvalidPDFException;
}();
var MissingPDFException = function MissingPDFExceptionClosure() {
  function MissingPDFException(msg) {
    this.name = 'MissingPDFException';
    this.message = msg;
  }
  MissingPDFException.prototype = new Error();
  MissingPDFException.constructor = MissingPDFException;
  return MissingPDFException;
}();
var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
  function UnexpectedResponseException(msg, status) {
    this.name = 'UnexpectedResponseException';
    this.message = msg;
    this.status = status;
  }
  UnexpectedResponseException.prototype = new Error();
  UnexpectedResponseException.constructor = UnexpectedResponseException;
  return UnexpectedResponseException;
}();
var NotImplementedException = function NotImplementedExceptionClosure() {
  function NotImplementedException(msg) {
    this.message = msg;
  }
  NotImplementedException.prototype = new Error();
  NotImplementedException.prototype.name = 'NotImplementedException';
  NotImplementedException.constructor = NotImplementedException;
  return NotImplementedException;
}();
var MissingDataException = function MissingDataExceptionClosure() {
  function MissingDataException(begin, end) {
    this.begin = begin;
    this.end = end;
    this.message = 'Missing data [' + begin + ', ' + end + ')';
  }
  MissingDataException.prototype = new Error();
  MissingDataException.prototype.name = 'MissingDataException';
  MissingDataException.constructor = MissingDataException;
  return MissingDataException;
}();
var XRefParseException = function XRefParseExceptionClosure() {
  function XRefParseException(msg) {
    this.message = msg;
  }
  XRefParseException.prototype = new Error();
  XRefParseException.prototype.name = 'XRefParseException';
  XRefParseException.constructor = XRefParseException;
  return XRefParseException;
}();
var FormatError = function FormatErrorClosure() {
  function FormatError(msg) {
    this.message = msg;
  }
  FormatError.prototype = new Error();
  FormatError.prototype.name = 'FormatError';
  FormatError.constructor = FormatError;
  return FormatError;
}();
var AbortException = function AbortExceptionClosure() {
  function AbortException(msg) {
    this.name = 'AbortException';
    this.message = msg;
  }
  AbortException.prototype = new Error();
  AbortException.constructor = AbortException;
  return AbortException;
}();
var NullCharactersRegExp = /\x00/g;
function removeNullCharacters(str) {
  if (typeof str !== 'string') {
    warn('The argument for removeNullCharacters must be a string.');
    return str;
  }
  return str.replace(NullCharactersRegExp, '');
}
function bytesToString(bytes) {
  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
  var length = bytes.length;
  var MAX_ARGUMENT_COUNT = 8192;
  if (length < MAX_ARGUMENT_COUNT) {
    return String.fromCharCode.apply(null, bytes);
  }
  var strBuf = [];
  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
    var chunk = bytes.subarray(i, chunkEnd);
    strBuf.push(String.fromCharCode.apply(null, chunk));
  }
  return strBuf.join('');
}
function stringToBytes(str) {
  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
  var length = str.length;
  var bytes = new Uint8Array(length);
  for (var i = 0; i < length; ++i) {
    bytes[i] = str.charCodeAt(i) & 0xFF;
  }
  return bytes;
}
function arrayByteLength(arr) {
  if (arr.length !== undefined) {
    return arr.length;
  }
  assert(arr.byteLength !== undefined);
  return arr.byteLength;
}
function arraysToBytes(arr) {
  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
    return arr[0];
  }
  var resultLength = 0;
  var i,
      ii = arr.length;
  var item, itemLength;
  for (i = 0; i < ii; i++) {
    item = arr[i];
    itemLength = arrayByteLength(item);
    resultLength += itemLength;
  }
  var pos = 0;
  var data = new Uint8Array(resultLength);
  for (i = 0; i < ii; i++) {
    item = arr[i];
    if (!(item instanceof Uint8Array)) {
      if (typeof item === 'string') {
        item = stringToBytes(item);
      } else {
        item = new Uint8Array(item);
      }
    }
    itemLength = item.byteLength;
    data.set(item, pos);
    pos += itemLength;
  }
  return data;
}
function string32(value) {
  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function log2(x) {
  if (x <= 0) {
    return 0;
  }
  return Math.ceil(Math.log2(x));
}
function readInt8(data, start) {
  return data[start] << 24 >> 24;
}
function readUint16(data, offset) {
  return data[offset] << 8 | data[offset + 1];
}
function readUint32(data, offset) {
  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
}
function isLittleEndian() {
  var buffer8 = new Uint8Array(4);
  buffer8[0] = 1;
  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
  return view32[0] === 1;
}
function isEvalSupported() {
  try {
    new Function('');
    return true;
  } catch (e) {
    return false;
  }
}
var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
var Util = function UtilClosure() {
  function Util() {}
  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
    rgbBuf[1] = r;
    rgbBuf[3] = g;
    rgbBuf[5] = b;
    return rgbBuf.join('');
  };
  Util.transform = function Util_transform(m1, m2) {
    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
  };
  Util.applyTransform = function Util_applyTransform(p, m) {
    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
    return [xt, yt];
  };
  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
    var d = m[0] * m[3] - m[1] * m[2];
    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    return [xt, yt];
  };
  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
    var p1 = Util.applyTransform(r, m);
    var p2 = Util.applyTransform(r.slice(2, 4), m);
    var p3 = Util.applyTransform([r[0], r[3]], m);
    var p4 = Util.applyTransform([r[2], r[1]], m);
    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
  };
  Util.inverseTransform = function Util_inverseTransform(m) {
    var d = m[0] * m[3] - m[1] * m[2];
    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
  };
  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
  };
  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
    var transpose = [m[0], m[2], m[1], m[3]];
    var a = m[0] * transpose[0] + m[1] * transpose[2];
    var b = m[0] * transpose[1] + m[1] * transpose[3];
    var c = m[2] * transpose[0] + m[3] * transpose[2];
    var d = m[2] * transpose[1] + m[3] * transpose[3];
    var first = (a + d) / 2;
    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
    var sx = first + second || 1;
    var sy = first - second || 1;
    return [Math.sqrt(sx), Math.sqrt(sy)];
  };
  Util.normalizeRect = function Util_normalizeRect(rect) {
    var r = rect.slice(0);
    if (rect[0] > rect[2]) {
      r[0] = rect[2];
      r[2] = rect[0];
    }
    if (rect[1] > rect[3]) {
      r[1] = rect[3];
      r[3] = rect[1];
    }
    return r;
  };
  Util.intersect = function Util_intersect(rect1, rect2) {
    function compare(a, b) {
      return a - b;
    }
    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
        result = [];
    rect1 = Util.normalizeRect(rect1);
    rect2 = Util.normalizeRect(rect2);
    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
      result[0] = orderedX[1];
      result[2] = orderedX[2];
    } else {
      return false;
    }
    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
      result[1] = orderedY[1];
      result[3] = orderedY[2];
    } else {
      return false;
    }
    return result;
  };
  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
  Util.toRoman = function Util_toRoman(number, lowerCase) {
    assert(Number.isInteger(number) && number > 0, 'The number should be a positive integer.');
    var pos,
        romanBuf = [];
    while (number >= 1000) {
      number -= 1000;
      romanBuf.push('M');
    }
    pos = number / 100 | 0;
    number %= 100;
    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
    pos = number / 10 | 0;
    number %= 10;
    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
    var romanStr = romanBuf.join('');
    return lowerCase ? romanStr.toLowerCase() : romanStr;
  };
  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
    Array.prototype.push.apply(arr1, arr2);
  };
  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
    Array.prototype.unshift.apply(arr1, arr2);
  };
  Util.extendObj = function extendObj(obj1, obj2) {
    for (var key in obj2) {
      obj1[key] = obj2[key];
    }
  };
  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
    while (dict && !dict.has(name)) {
      dict = dict.get('Parent');
    }
    if (!dict) {
      return null;
    }
    return getArray ? dict.getArray(name) : dict.get(name);
  };
  Util.inherit = function Util_inherit(sub, base, prototype) {
    sub.prototype = Object.create(base.prototype);
    sub.prototype.constructor = sub;
    for (var prop in prototype) {
      sub.prototype[prop] = prototype[prop];
    }
  };
  Util.loadScript = function Util_loadScript(src, callback) {
    var script = document.createElement('script');
    var loaded = false;
    script.setAttribute('src', src);
    if (callback) {
      script.onload = function () {
        if (!loaded) {
          callback();
        }
        loaded = true;
      };
    }
    document.getElementsByTagName('head')[0].appendChild(script);
  };
  return Util;
}();
var PageViewport = function PageViewportClosure() {
  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
    this.viewBox = viewBox;
    this.scale = scale;
    this.rotation = rotation;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    var centerX = (viewBox[2] + viewBox[0]) / 2;
    var centerY = (viewBox[3] + viewBox[1]) / 2;
    var rotateA, rotateB, rotateC, rotateD;
    rotation = rotation % 360;
    rotation = rotation < 0 ? rotation + 360 : rotation;
    switch (rotation) {
      case 180:
        rotateA = -1;
        rotateB = 0;
        rotateC = 0;
        rotateD = 1;
        break;
      case 90:
        rotateA = 0;
        rotateB = 1;
        rotateC = 1;
        rotateD = 0;
        break;
      case 270:
        rotateA = 0;
        rotateB = -1;
        rotateC = -1;
        rotateD = 0;
        break;
      default:
        rotateA = 1;
        rotateB = 0;
        rotateC = 0;
        rotateD = -1;
        break;
    }
    if (dontFlip) {
      rotateC = -rotateC;
      rotateD = -rotateD;
    }
    var offsetCanvasX, offsetCanvasY;
    var width, height;
    if (rotateA === 0) {
      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
    } else {
      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
    }
    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
    this.width = width;
    this.height = height;
    this.fontScale = scale;
  }
  PageViewport.prototype = {
    clone: function PageViewPort_clone(args) {
      args = args || {};
      var scale = 'scale' in args ? args.scale : this.scale;
      var rotation = 'rotation' in args ? args.rotation : this.rotation;
      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
    },
    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
      return Util.applyTransform([x, y], this.transform);
    },
    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
      return [tl[0], tl[1], br[0], br[1]];
    },
    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
      return Util.applyInverseTransform([x, y], this.transform);
    }
  };
  return PageViewport;
}();
var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
function stringToPDFString(str) {
  var i,
      n = str.length,
      strBuf = [];
  if (str[0] === '\xFE' && str[1] === '\xFF') {
    for (i = 2; i < n; i += 2) {
      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
    }
  } else {
    for (i = 0; i < n; ++i) {
      var code = PDFStringTranslateTable[str.charCodeAt(i)];
      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
  }
  return strBuf.join('');
}
function stringToUTF8String(str) {
  return decodeURIComponent(escape(str));
}
function utf8StringToString(str) {
  return unescape(encodeURIComponent(str));
}
function isEmptyObj(obj) {
  for (var key in obj) {
    return false;
  }
  return true;
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isNum(v) {
  return typeof v === 'number';
}
function isString(v) {
  return typeof v === 'string';
}
function isArrayBuffer(v) {
  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
}
function isSpace(ch) {
  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
}
function createPromiseCapability() {
  var capability = {};
  capability.promise = new Promise(function (resolve, reject) {
    capability.resolve = resolve;
    capability.reject = reject;
  });
  return capability;
}
var createBlob = function createBlob(data, contentType) {
  if (typeof Blob !== 'undefined') {
    return new Blob([data], { type: contentType });
  }
  throw new Error('The "Blob" constructor is not supported.');
};
var createObjectURL = function createObjectURLClosure() {
  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  return function createObjectURL(data, contentType) {
    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!forceDataSchema && URL.createObjectURL) {
      var blob = createBlob(data, contentType);
      return URL.createObjectURL(blob);
    }
    var buffer = 'data:' + contentType + ';base64,';
    for (var i = 0, ii = data.length; i < ii; i += 3) {
      var b1 = data[i] & 0xFF;
      var b2 = data[i + 1] & 0xFF;
      var b3 = data[i + 2] & 0xFF;
      var d1 = b1 >> 2,
          d2 = (b1 & 3) << 4 | b2 >> 4;
      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
    }
    return buffer;
  };
}();
function resolveCall(fn, args) {
  var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!fn) {
    return Promise.resolve(undefined);
  }
  return new Promise(function (resolve, reject) {
    resolve(fn.apply(thisArg, args));
  });
}
function wrapReason(reason) {
  if ((typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object') {
    return reason;
  }
  switch (reason.name) {
    case 'AbortException':
      return new AbortException(reason.message);
    case 'MissingPDFException':
      return new MissingPDFException(reason.message);
    case 'UnexpectedResponseException':
      return new UnexpectedResponseException(reason.message, reason.status);
    default:
      return new UnknownErrorException(reason.message, reason.details);
  }
}
function makeReasonSerializable(reason) {
  if (!(reason instanceof Error) || reason instanceof AbortException || reason instanceof MissingPDFException || reason instanceof UnexpectedResponseException || reason instanceof UnknownErrorException) {
    return reason;
  }
  return new UnknownErrorException(reason.message, reason.toString());
}
function resolveOrReject(capability, success, reason) {
  if (success) {
    capability.resolve();
  } else {
    capability.reject(reason);
  }
}
function finalize(promise) {
  return Promise.resolve(promise).catch(function () {});
}
function MessageHandler(sourceName, targetName, comObj) {
  var _this = this;

  this.sourceName = sourceName;
  this.targetName = targetName;
  this.comObj = comObj;
  this.callbackId = 1;
  this.streamId = 1;
  this.postMessageTransfers = true;
  this.streamSinks = Object.create(null);
  this.streamControllers = Object.create(null);
  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
  var ah = this.actionHandler = Object.create(null);
  this._onComObjOnMessage = function (event) {
    var data = event.data;
    if (data.targetName !== _this.sourceName) {
      return;
    }
    if (data.stream) {
      _this._processStreamMessage(data);
    } else if (data.isReply) {
      var callbackId = data.callbackId;
      if (data.callbackId in callbacksCapabilities) {
        var callback = callbacksCapabilities[callbackId];
        delete callbacksCapabilities[callbackId];
        if ('error' in data) {
          callback.reject(wrapReason(data.error));
        } else {
          callback.resolve(data.data);
        }
      } else {
        throw new Error('Cannot resolve callback ' + callbackId);
      }
    } else if (data.action in ah) {
      var action = ah[data.action];
      if (data.callbackId) {
        var _sourceName = _this.sourceName;
        var _targetName = data.sourceName;
        Promise.resolve().then(function () {
          return action[0].call(action[1], data.data);
        }).then(function (result) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            data: result
          });
        }, function (reason) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            error: makeReasonSerializable(reason)
          });
        });
      } else if (data.streamId) {
        _this._createStreamSink(data);
      } else {
        action[0].call(action[1], data.data);
      }
    } else {
      throw new Error('Unknown action from worker: ' + data.action);
    }
  };
  comObj.addEventListener('message', this._onComObjOnMessage);
}
MessageHandler.prototype = {
  on: function on(actionName, handler, scope) {
    var ah = this.actionHandler;
    if (ah[actionName]) {
      throw new Error('There is already an actionName called "' + actionName + '"');
    }
    ah[actionName] = [handler, scope];
  },
  send: function send(actionName, data, transfers) {
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data
    };
    this.postMessage(message, transfers);
  },
  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
    var callbackId = this.callbackId++;
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data,
      callbackId: callbackId
    };
    var capability = createPromiseCapability();
    this.callbacksCapabilities[callbackId] = capability;
    try {
      this.postMessage(message, transfers);
    } catch (e) {
      capability.reject(e);
    }
    return capability.promise;
  },
  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
    var _this2 = this;

    var streamId = this.streamId++;
    var sourceName = this.sourceName;
    var targetName = this.targetName;
    return new _streams_polyfill.ReadableStream({
      start: function start(controller) {
        var startCapability = createPromiseCapability();
        _this2.streamControllers[streamId] = {
          controller: controller,
          startCall: startCapability,
          isClosed: false
        };
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          action: actionName,
          streamId: streamId,
          data: data,
          desiredSize: controller.desiredSize
        });
        return startCapability.promise;
      },
      pull: function pull(controller) {
        var pullCapability = createPromiseCapability();
        _this2.streamControllers[streamId].pullCall = pullCapability;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'pull',
          streamId: streamId,
          desiredSize: controller.desiredSize
        });
        return pullCapability.promise;
      },
      cancel: function cancel(reason) {
        var cancelCapability = createPromiseCapability();
        _this2.streamControllers[streamId].cancelCall = cancelCapability;
        _this2.streamControllers[streamId].isClosed = true;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'cancel',
          reason: reason,
          streamId: streamId
        });
        return cancelCapability.promise;
      }
    }, queueingStrategy);
  },
  _createStreamSink: function _createStreamSink(data) {
    var _this3 = this;

    var self = this;
    var action = this.actionHandler[data.action];
    var streamId = data.streamId;
    var desiredSize = data.desiredSize;
    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var capability = createPromiseCapability();
    var sendStreamRequest = function sendStreamRequest(_ref) {
      var stream = _ref.stream,
          chunk = _ref.chunk,
          transfers = _ref.transfers,
          success = _ref.success,
          reason = _ref.reason;

      _this3.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        streamId: streamId,
        chunk: chunk,
        success: success,
        reason: reason
      }, transfers);
    };
    var streamSink = {
      enqueue: function enqueue(chunk) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var transfers = arguments[2];

        if (this.isCancelled) {
          return;
        }
        var lastDesiredSize = this.desiredSize;
        this.desiredSize -= size;
        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
          this.sinkCapability = createPromiseCapability();
          this.ready = this.sinkCapability.promise;
        }
        sendStreamRequest({
          stream: 'enqueue',
          chunk: chunk,
          transfers: transfers
        });
      },
      close: function close() {
        if (this.isCancelled) {
          return;
        }
        this.isCancelled = true;
        sendStreamRequest({ stream: 'close' });
        delete self.streamSinks[streamId];
      },
      error: function error(reason) {
        if (this.isCancelled) {
          return;
        }
        this.isCancelled = true;
        sendStreamRequest({
          stream: 'error',
          reason: reason
        });
      },

      sinkCapability: capability,
      onPull: null,
      onCancel: null,
      isCancelled: false,
      desiredSize: desiredSize,
      ready: null
    };
    streamSink.sinkCapability.resolve();
    streamSink.ready = streamSink.sinkCapability.promise;
    this.streamSinks[streamId] = streamSink;
    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
      sendStreamRequest({
        stream: 'start_complete',
        success: true
      });
    }, function (reason) {
      sendStreamRequest({
        stream: 'start_complete',
        success: false,
        reason: reason
      });
    });
  },
  _processStreamMessage: function _processStreamMessage(data) {
    var _this4 = this;

    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var streamId = data.streamId;
    var sendStreamResponse = function sendStreamResponse(_ref2) {
      var stream = _ref2.stream,
          success = _ref2.success,
          reason = _ref2.reason;

      _this4.comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        success: success,
        streamId: streamId,
        reason: reason
      });
    };
    var deleteStreamController = function deleteStreamController() {
      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
        return capability && finalize(capability.promise);
      })).then(function () {
        delete _this4.streamControllers[data.streamId];
      });
    };
    switch (data.stream) {
      case 'start_complete':
        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
        break;
      case 'pull_complete':
        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
        break;
      case 'pull':
        if (!this.streamSinks[data.streamId]) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
          break;
        }
        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
          this.streamSinks[data.streamId].sinkCapability.resolve();
        }
        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: false,
            reason: reason
          });
        });
        break;
      case 'enqueue':
        assert(this.streamControllers[data.streamId], 'enqueue should have stream controller');
        if (!this.streamControllers[data.streamId].isClosed) {
          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
        }
        break;
      case 'close':
        assert(this.streamControllers[data.streamId], 'close should have stream controller');
        if (this.streamControllers[data.streamId].isClosed) {
          break;
        }
        this.streamControllers[data.streamId].isClosed = true;
        this.streamControllers[data.streamId].controller.close();
        deleteStreamController();
        break;
      case 'error':
        assert(this.streamControllers[data.streamId], 'error should have stream controller');
        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
        deleteStreamController();
        break;
      case 'cancel_complete':
        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
        deleteStreamController();
        break;
      case 'cancel':
        if (!this.streamSinks[data.streamId]) {
          break;
        }
        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: false,
            reason: reason
          });
        });
        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
        this.streamSinks[data.streamId].isCancelled = true;
        delete this.streamSinks[data.streamId];
        break;
      default:
        throw new Error('Unexpected stream case');
    }
  },
  postMessage: function postMessage(message, transfers) {
    if (transfers && this.postMessageTransfers) {
      this.comObj.postMessage(message, transfers);
    } else {
      this.comObj.postMessage(message);
    }
  },
  destroy: function destroy() {
    this.comObj.removeEventListener('message', this._onComObjOnMessage);
  }
};
function loadJpegStream(id, imageUrl, objs) {
  var img = new Image();
  img.onload = function loadJpegStream_onloadClosure() {
    objs.resolve(id, img);
  };
  img.onerror = function loadJpegStream_onerrorClosure() {
    objs.resolve(id, null);
    warn('Error during JPEG image loading');
  };
  img.src = imageUrl;
}
exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
exports.OPS = OPS;
exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
exports.AnnotationFieldFlag = AnnotationFieldFlag;
exports.AnnotationFlag = AnnotationFlag;
exports.AnnotationType = AnnotationType;
exports.FontType = FontType;
exports.ImageKind = ImageKind;
exports.CMapCompressionType = CMapCompressionType;
exports.AbortException = AbortException;
exports.InvalidPDFException = InvalidPDFException;
exports.MessageHandler = MessageHandler;
exports.MissingDataException = MissingDataException;
exports.MissingPDFException = MissingPDFException;
exports.NativeImageDecoding = NativeImageDecoding;
exports.NotImplementedException = NotImplementedException;
exports.PageViewport = PageViewport;
exports.PasswordException = PasswordException;
exports.PasswordResponses = PasswordResponses;
exports.StreamType = StreamType;
exports.TextRenderingMode = TextRenderingMode;
exports.UnexpectedResponseException = UnexpectedResponseException;
exports.UnknownErrorException = UnknownErrorException;
exports.Util = Util;
exports.XRefParseException = XRefParseException;
exports.FormatError = FormatError;
exports.arrayByteLength = arrayByteLength;
exports.arraysToBytes = arraysToBytes;
exports.assert = assert;
exports.bytesToString = bytesToString;
exports.createBlob = createBlob;
exports.createPromiseCapability = createPromiseCapability;
exports.createObjectURL = createObjectURL;
exports.deprecated = deprecated;
exports.getLookupTableFactory = getLookupTableFactory;
exports.getVerbosityLevel = getVerbosityLevel;
exports.info = info;
exports.isArrayBuffer = isArrayBuffer;
exports.isBool = isBool;
exports.isEmptyObj = isEmptyObj;
exports.isNum = isNum;
exports.isString = isString;
exports.isSpace = isSpace;
exports.isSameOrigin = isSameOrigin;
exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
exports.isLittleEndian = isLittleEndian;
exports.isEvalSupported = isEvalSupported;
exports.loadJpegStream = loadJpegStream;
exports.log2 = log2;
exports.readInt8 = readInt8;
exports.readUint16 = readUint16;
exports.readUint32 = readUint32;
exports.removeNullCharacters = removeNullCharacters;
exports.ReadableStream = _streams_polyfill.ReadableStream;
exports.setVerbosityLevel = setVerbosityLevel;
exports.shadow = shadow;
exports.string32 = string32;
exports.stringToBytes = stringToBytes;
exports.stringToPDFString = stringToPDFString;
exports.stringToUTF8String = stringToUTF8String;
exports.utf8StringToString = utf8StringToString;
exports.warn = warn;
exports.unreachable = unreachable;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Dropdown = __webpack_require__(1910);

var _input = __webpack_require__(59);

var _theme = __webpack_require__(1911);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dropdown = (0, _Dropdown.dropdownFactory)(_input.Input);
var ThemedDropdown = (0, _reactCssThemr.themr)(_identifiers.DROPDOWN, _theme2.default)(Dropdown);

exports.default = ThemedDropdown;
exports.Dropdown = ThemedDropdown;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InviewSensor = exports.InfiniteScroll = undefined;

var _InfiniteScroll2 = __webpack_require__(2004);

var _InfiniteScroll3 = _interopRequireDefault(_InfiniteScroll2);

var _InviewSensor2 = __webpack_require__(2005);

var _InviewSensor3 = _interopRequireDefault(_InviewSensor2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfiniteScroll = exports.InfiniteScroll = _InfiniteScroll3.default;
var InviewSensor = exports.InviewSensor = _InviewSensor3.default;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1483)
var ieee754 = __webpack_require__(1484)
var isArray = __webpack_require__(457)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _ProgressBar = __webpack_require__(913);

var _theme = __webpack_require__(1918);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedProgressBar = (0, _reactCssThemr.themr)(_identifiers.PROGRESS_BAR, _theme2.default)(_ProgressBar.ProgressBar);

exports.default = ThemedProgressBar;
exports.ProgressBar = ThemedProgressBar;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FontIcon = function FontIcon(_ref // eslint-disable-line
) {
  var alt = _ref.alt,
      children = _ref.children,
      className = _ref.className,
      theme = _ref.theme,
      value = _ref.value,
      other = _objectWithoutProperties(_ref, ['alt', 'children', 'className', 'theme', 'value']);

  return _react2.default.createElement(
    'span',
    _extends({
      'data-react-toolbox': 'font-icon',
      'aria-label': alt,
      className: (0, _classnames2.default)({
        'material-icons': typeof value === 'string' || typeof children === 'string'
      }, className)
    }, other),
    value,
    children
  );
};

FontIcon.propTypes = {
  alt: _propTypes2.default.string,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.object, // eslint-disable-line
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};

FontIcon.defaultProps = {
  alt: '',
  className: ''
};

exports.default = FontIcon;
exports.FontIcon = FontIcon;

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tileProps = exports.tileGroupProps = exports.isView = exports.isClassName = exports.isViews = exports.isValue = exports.isMaxDate = exports.isMinDate = exports.isCalendarType = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(79));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var calendarTypes = ['ISO 8601', 'US', 'Arabic', 'Hebrew'];
var allViews = ['century', 'decade', 'year', 'month'];

var isCalendarType = _propTypes["default"].oneOf(calendarTypes);

exports.isCalendarType = isCalendarType;

var isMinDate = function isMinDate(props, propName, componentName) {
  var minDate = props[propName];

  if (minDate) {
    if (!(minDate instanceof Date)) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    }

    var maxDate = props.maxDate;

    if (maxDate && minDate > maxDate) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
    }
  } // Everything is fine


  return null;
};

exports.isMinDate = isMinDate;

var isMaxDate = function isMaxDate(props, propName, componentName) {
  var maxDate = props[propName];

  if (maxDate) {
    if (!(maxDate instanceof Date)) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    }

    var minDate = props.minDate;

    if (minDate && maxDate < minDate) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
    }
  } // Everything is fine


  return null;
};

exports.isMaxDate = isMaxDate;

var isValue = _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Date))]);

exports.isValue = isValue;

var isViews = _propTypes["default"].arrayOf(_propTypes["default"].oneOf(allViews));

exports.isViews = isViews;

var isClassName = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]);

exports.isClassName = isClassName;

var isView = function isView(props, propName, componentName) {
  var view = props[propName];
  var views = props.views;
  var allowedViews = views || allViews;

  if (view !== undefined && allowedViews.indexOf(view) === -1) {
    return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function (a) {
      return "\"".concat(a, "\"");
    }).join(', '), "]."));
  } // Everything is fine


  return null;
};

exports.isView = isView;

isView.isRequired = function (props, propName, componentName) {
  var view = props[propName];

  if (!view) {
    return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
  }

  return isView(props, propName, componentName);
};

var tileGroupProps = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  hover: _propTypes["default"].instanceOf(Date),
  locale: _propTypes["default"].string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: _propTypes["default"].func,
  onMouseOver: _propTypes["default"].func,
  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, isClassName]),
  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  value: isValue,
  valueType: _propTypes["default"].string
};
exports.tileGroupProps = tileGroupProps;
var tileProps = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  classes: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  date: _propTypes["default"].instanceOf(Date).isRequired,
  locale: _propTypes["default"].string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: _propTypes["default"].func,
  onMouseOver: _propTypes["default"].func,
  style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, isClassName]),
  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  tileDisabled: _propTypes["default"].func
};
exports.tileProps = tileProps;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Panel = exports.NavDrawer = exports.Sidebar = exports.Layout = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Layout = __webpack_require__(1780);

var _Sidebar = __webpack_require__(877);

var _NavDrawer = __webpack_require__(876);

var _Panel = __webpack_require__(1795);

var _app_bar = __webpack_require__(122);

var _drawer = __webpack_require__(476);

var _theme = __webpack_require__(1801);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var injectTheme = function injectTheme(component) {
  return (0, _reactCssThemr.themr)(_identifiers.LAYOUT, _theme2.default)(component);
};
var ThemedNavDrawer = injectTheme((0, _NavDrawer.navDrawerFactory)(_drawer.Drawer));
var ThemedSidebar = injectTheme((0, _Sidebar.sidebarFactory)(_drawer.Drawer));
var ThemedPanel = injectTheme(_Panel.Panel);
var ThemedLayout = injectTheme((0, _Layout.layoutFactory)(_app_bar.AppBar, ThemedNavDrawer, ThemedSidebar));

exports.default = ThemedLayout;
exports.Layout = ThemedLayout;
exports.Sidebar = ThemedSidebar;
exports.NavDrawer = ThemedNavDrawer;
exports.Panel = ThemedPanel;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.PureComponent = PureComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowEqual = __webpack_require__(264);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _some = __webpack_require__(161);

var _some2 = _interopRequireDefault(_some);

var _uniq = __webpack_require__(486);

var _uniq2 = _interopRequireDefault(_uniq);

var _concat = __webpack_require__(908);

var _concat2 = _interopRequireDefault(_concat);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/helpers/pure-component.js

function PureComponent() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['ui'];
  var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return function (_React$Component) {
    _inherits(ExPureComponent, _React$Component);

    function ExPureComponent() {
      _classCallCheck(this, ExPureComponent);

      return _possibleConstructorReturn(this, (ExPureComponent.__proto__ || Object.getPrototypeOf(ExPureComponent)).apply(this, arguments));
    }

    _createClass(ExPureComponent, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
        keys = (0, _concat2.default)(keys);
        var otherProps = Object.assign({}, this.props);
        var nextOtherProps = Object.assign({}, nextProps);
        (0, _each2.default)(ignore, function (key) {
          var paths = key.split('.');
          if (paths.length == 1) {
            delete otherProps[key];
            delete nextOtherProps[key];
          } else {
            keys.push(paths[0]);
            otherProps[paths[0]] = Object.assign({}, otherProps[paths[0]]);
            nextOtherProps[paths[0]] = Object.assign({}, nextOtherProps[paths[0]]);
            delete otherProps[paths[0]][paths[1]];
            delete nextOtherProps[paths[0]][paths[1]];
          }
        });
        var changedProps = []; // for performance debug
        if ((0, _some2.default)((0, _uniq2.default)(keys), function (key) {
          var prop = otherProps[key];
          var nextProp = nextOtherProps[key];
          delete otherProps[key];
          delete nextOtherProps[key];
          if (!(0, _shallowEqual2.default)(prop, nextProp)) {
            //if ((!prop || !nextProp) && (prop || nextProp)) changedProps.push(`${key}.*`)
            //else changedProps = changedProps.concat(filter(Object.keys(nextProp), (_key)=> prop[_key] !== nextProp[_key]).map((_key)=> `${key}.${_key}`))
            return true;
          }
          return false;
        })) {
          //console.log(`shouldUpdate ${this.constructor.name} by props:${changedProps}`)
          return true;
        }
        if (!(0, _shallowEqual2.default)(otherProps, nextOtherProps)) {
          //console.log(`shouldUpdate ${this.constructor.name} by props:${filter(Object.keys(nextOtherProps), (_key)=> typeof nextOtherProps[_key] != 'function' && otherProps[_key] !== nextOtherProps[_key]).map((_key)=> `${_key}`)}`)
          return true;
        }
        if (!(0, _shallowEqual2.default)(this.state, nextState)) {
          //console.log(`shouldUpdate ${this.constructor.name} by state:${filter(Object.keys(nextState), (_key)=> this.state[_key] !== nextState[_key])}`)
          return true;
        }
        if (!(0, _shallowEqual2.default)(this.context, nextContext)) {
          //console.log(`shouldUpdate ${this.constructor.name} by context`)
          return true;
        }
        return false;
      }
    }]);

    return ExPureComponent;
  }(_react2.default.Component);
}

exports.default = PureComponent();

/***/ }),
/* 87 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(542)('wks');
var uid = __webpack_require__(377);
var Symbol = __webpack_require__(88).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssign = __webpack_require__(1380),
    baseCreate = __webpack_require__(1381);

/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = baseCreate(prototype);
  return properties == null ? result : baseAssign(result, properties);
}

module.exports = create;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chip = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Chip = __webpack_require__(929);

var _avatar = __webpack_require__(26);

var _theme = __webpack_require__(2002);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chip = (0, _Chip.chipFactory)(_avatar.Avatar);
var ThemedChip = (0, _reactCssThemr.themr)(_identifiers.CHIP, _theme2.default)(Chip);

exports.default = ThemedChip;
exports.Chip = ThemedChip;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(61);
var createDesc = __webpack_require__(189);
module.exports = __webpack_require__(56) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var hide = __webpack_require__(92);
var has = __webpack_require__(99);
var SRC = __webpack_require__(190)('src');
var $toString = __webpack_require__(2225);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(51).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__ = __webpack_require__(982);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2308);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__api__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseclient__ = __webpack_require__(2309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__baseclient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basebackend__ = __webpack_require__(2311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__basebackend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__(2312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__request__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_5__request__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sdk__ = __webpack_require__(2313);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__sdk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transports_noop__ = __webpack_require__(990);
/* unused harmony reexport NoopTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__version__ = __webpack_require__(2314);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__version__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__integrations__ = __webpack_require__(2315);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9__integrations__; });











//# sourceMappingURL=index.js.map

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule React
 */

module.exports = __webpack_require__(0);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYear = getYear;
exports.getMonth = getMonth;
exports.getMonthIndex = getMonthIndex;
exports.getDay = getDay;
exports.getDayOfWeek = getDayOfWeek;
exports.getBeginOfCenturyYear = getBeginOfCenturyYear;
exports.getBeginOfCentury = getBeginOfCentury;
exports.getEndOfCentury = getEndOfCentury;
exports.getCenturyRange = getCenturyRange;
exports.getBeginOfPreviousCentury = getBeginOfPreviousCentury;
exports.getEndOfPreviousCentury = getEndOfPreviousCentury;
exports.getBeginOfNextCentury = getBeginOfNextCentury;
exports.getBeginOfDecadeYear = getBeginOfDecadeYear;
exports.getBeginOfDecade = getBeginOfDecade;
exports.getEndOfDecade = getEndOfDecade;
exports.getDecadeRange = getDecadeRange;
exports.getBeginOfPreviousDecade = getBeginOfPreviousDecade;
exports.getEndOfPreviousDecade = getEndOfPreviousDecade;
exports.getBeginOfNextDecade = getBeginOfNextDecade;
exports.getBeginOfYear = getBeginOfYear;
exports.getEndOfYear = getEndOfYear;
exports.getYearRange = getYearRange;
exports.getBeginOfPreviousYear = getBeginOfPreviousYear;
exports.getEndOfPreviousYear = getEndOfPreviousYear;
exports.getBeginOfNextYear = getBeginOfNextYear;
exports.getBeginOfMonth = getBeginOfMonth;
exports.getEndOfMonth = getEndOfMonth;
exports.getBeginOfWeek = getBeginOfWeek;
exports.getMonthRange = getMonthRange;
exports.getBeginOfPreviousMonth = getBeginOfPreviousMonth;
exports.getEndOfPreviousMonth = getEndOfPreviousMonth;
exports.getBeginOfNextMonth = getBeginOfNextMonth;
exports.getBeginOfDay = getBeginOfDay;
exports.getEndOfDay = getEndOfDay;
exports.getDayRange = getDayRange;
exports.getWeekNumber = getWeekNumber;
exports.getBegin = getBegin;
exports.getBeginPrevious = getBeginPrevious;
exports.getBeginNext = getBeginNext;
exports.getEnd = getEnd;
exports.getEndPrevious = getEndPrevious;
exports.getRange = getRange;
exports.getValueRange = getValueRange;
exports.getDaysInMonth = getDaysInMonth;
exports.getCenturyLabel = getCenturyLabel;
exports.getDecadeLabel = getDecadeLabel;
exports.isWeekend = isWeekend;
exports.getISOLocalMonth = getISOLocalMonth;
exports.getISOLocalDate = getISOLocalDate;
exports.getEndPrevious2 = exports.getBeginNext2 = exports.getBeginPrevious2 = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _map = _toConsumableArray(Array(7)).map(function (el, index) {
  return index;
}),
    _map2 = _slicedToArray(_map, 7),
    // eslint-disable-next-line no-unused-vars
SUNDAY = _map2[0],
    MONDAY = _map2[1],
    TUESDAY = _map2[2],
    WEDNESDAY = _map2[3],
    THURSDAY = _map2[4],
    FRIDAY = _map2[5],
    SATURDAY = _map2[6];
/* Simple getters - getting a property of a given point in time */


function getYear(date) {
  if (date instanceof Date) {
    return date.getFullYear();
  }

  if (typeof date === 'number') {
    return date;
  }

  var year = parseInt(date, 10);

  if (typeof date === 'string' && !isNaN(year)) {
    return year;
  }

  throw new Error("Failed to get year from date: ".concat(date, "."));
}

function getMonth(date) {
  return date.getMonth() + 1;
}

function getMonthIndex(date) {
  return date.getMonth();
}

function getDay(date) {
  return date.getDate();
}

function getDayOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var weekday = date.getDay();

  switch (calendarType) {
    case 'ISO 8601':
      // Shifts days of the week so that Monday is 0, Sunday is 6
      return (weekday + 6) % 7;

    case 'Arabic':
      return (weekday + 1) % 7;

    case 'Hebrew':
    case 'US':
      return weekday;

    default:
      throw new Error('Unsupported calendar type.');
  }
}
/* Complex getters - getting a property somehow related to a given point in time */


function getBeginOfCenturyYear(date) {
  var year = getYear(date) - 1;
  return year + -year % 100 + 1;
}

function getBeginOfCentury(date) {
  var beginOfCenturyYear = getBeginOfCenturyYear(date);
  return new Date(beginOfCenturyYear, 0, 1);
}

function getEndOfCentury(date) {
  var beginOfCenturyYear = getBeginOfCenturyYear(date);
  return new Date(beginOfCenturyYear + 100, 0, 1, 0, 0, 0, -1);
}

function getCenturyRange(date) {
  return [getBeginOfCentury(date), getEndOfCentury(date)];
}

function getBeginOfPreviousCentury(date) {
  var previousCenturyYear = getYear(date) - 100;
  return getBeginOfCentury(previousCenturyYear);
}

function getEndOfPreviousCentury(date) {
  var previousCenturyYear = getYear(date) - 100;
  return getEndOfCentury(previousCenturyYear);
}

function getBeginOfNextCentury(date) {
  var nextCenturyYear = getYear(date) + 100;
  return getBeginOfCentury(nextCenturyYear);
}

function getBeginOfDecadeYear(date) {
  var year = getYear(date) - 1;
  return year + -year % 10 + 1;
}

function getBeginOfDecade(date) {
  var beginOfDecadeYear = getBeginOfDecadeYear(date);
  return new Date(beginOfDecadeYear, 0, 1);
}

function getEndOfDecade(date) {
  var beginOfDecadeYear = getBeginOfDecadeYear(date);
  return new Date(beginOfDecadeYear + 10, 0, 1, 0, 0, 0, -1);
}

function getDecadeRange(date) {
  return [getBeginOfDecade(date), getEndOfDecade(date)];
}

function getBeginOfPreviousDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
  return getBeginOfDecade(previousDecadeYear);
}

function getEndOfPreviousDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
  return getEndOfDecade(previousDecadeYear);
}

function getBeginOfNextDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var nextDecadeYear = getBeginOfDecadeYear(date) + offset;
  return getBeginOfDecade(nextDecadeYear);
}
/**
 * Returns the beginning of a given year.
 *
 * @param {Date} date Date.
 */


function getBeginOfYear(date) {
  var year = getYear(date);
  return new Date(year, 0, 1);
}
/**
 * Returns the end of a given year.
 *
 * @param {Date} date Date.
 */


function getEndOfYear(date) {
  var year = getYear(date);
  return new Date(year + 1, 0, 1, 0, 0, 0, -1);
}
/**
 * Returns an array with the beginning and the end of a given year.
 *
 * @param {Date} date Date.
 */


function getYearRange(date) {
  return [getBeginOfYear(date), getEndOfYear(date)];
}

function getBeginOfPreviousYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousYear = getYear(date) - offset;
  return getBeginOfYear(previousYear);
}

function getEndOfPreviousYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousYear = getYear(date) - offset;
  return getEndOfYear(previousYear);
}

function getBeginOfNextYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var nextYear = getYear(date) + offset;
  return getBeginOfYear(nextYear);
}
/**
 * Returns the beginning of a given month.
 *
 * @param {Date} date Date.
 */


function getBeginOfMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex, 1);
}
/**
 * Returns the end of a given month.
 *
 * @param {Date} date Date.
 */


function getEndOfMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex + 1, 1, 0, 0, 0, -1);
}
/**
 * Returns the beginning of a given week.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */


function getBeginOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = date.getDate() - getDayOfWeek(date, calendarType);
  return new Date(year, monthIndex, day);
}
/**
 * Returns an array with the beginning and the end of a given month.
 *
 * @param {Date} date Date.
 */


function getMonthRange(date) {
  return [getBeginOfMonth(date), getEndOfMonth(date)];
}

function getDifferentMonth(date, offset) {
  var year = getYear(date);
  var previousMonthIndex = getMonthIndex(date) + offset;
  return new Date(year, previousMonthIndex, 1);
}

function getBeginOfPreviousMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousMonth = getDifferentMonth(date, -offset);
  return getBeginOfMonth(previousMonth);
}

function getEndOfPreviousMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousMonth = getDifferentMonth(date, -offset);
  return getEndOfMonth(previousMonth);
}

function getBeginOfNextMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var nextMonth = getDifferentMonth(date, offset);
  return getBeginOfMonth(nextMonth);
}

function getBeginOfDay(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = getDay(date);
  return new Date(year, monthIndex, day);
}

function getEndOfDay(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = getDay(date);
  return new Date(year, monthIndex, day + 1, 0, 0, 0, -1);
}
/**
 * Returns an array with the beginning and the end of a given day.
 *
 * @param {Date} date Date.
 */


function getDayRange(date) {
  return [getBeginOfDay(date), getEndOfDay(date)];
}
/**
 * Gets week number according to ISO 8601 or US standard.
 * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
 * In US calendar week 1 is the one with January 1.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */


function getWeekNumber(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var calendarTypeForWeekNumber = calendarType === 'US' ? 'US' : 'ISO 8601';
  var beginOfWeek = getBeginOfWeek(date, calendarTypeForWeekNumber);
  var year = getYear(date) + 1;
  var dayInWeekOne;
  var beginOfFirstWeek; // Look for the first week one that does not come after a given date

  do {
    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === 'ISO 8601' ? 4 : 1);
    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarTypeForWeekNumber);
    year -= 1;
  } while (date - beginOfFirstWeek < 0);

  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
}
/**
 * Returns the beginning of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */


function getBegin(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfCentury(date);

    case 'decade':
      return getBeginOfDecade(date);

    case 'year':
      return getBeginOfYear(date);

    case 'month':
      return getBeginOfMonth(date);

    case 'day':
      return getBeginOfDay(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

function getBeginPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfPreviousCentury(date);

    case 'decade':
      return getBeginOfPreviousDecade(date);

    case 'year':
      return getBeginOfPreviousYear(date);

    case 'month':
      return getBeginOfPreviousMonth(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

function getBeginNext(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfNextCentury(date);

    case 'decade':
      return getBeginOfNextDecade(date);

    case 'year':
      return getBeginOfNextYear(date);

    case 'month':
      return getBeginOfNextMonth(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getBeginOfPreviousDecade(date, 100);

    case 'year':
      return getBeginOfPreviousYear(date, 10);

    case 'month':
      return getBeginOfPreviousMonth(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};

exports.getBeginPrevious2 = getBeginPrevious2;

var getBeginNext2 = function getBeginNext2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getBeginOfNextDecade(date, 100);

    case 'year':
      return getBeginOfNextYear(date, 10);

    case 'month':
      return getBeginOfNextMonth(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
/**
 * Returns the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */


exports.getBeginNext2 = getBeginNext2;

function getEnd(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getEndOfCentury(date);

    case 'decade':
      return getEndOfDecade(date);

    case 'year':
      return getEndOfYear(date);

    case 'month':
      return getEndOfMonth(date);

    case 'day':
      return getEndOfDay(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

function getEndPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getEndOfPreviousCentury(date);

    case 'decade':
      return getEndOfPreviousDecade(date);

    case 'year':
      return getEndOfPreviousYear(date);

    case 'month':
      return getEndOfPreviousMonth(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getEndOfPreviousDecade(date, 100);

    case 'year':
      return getEndOfPreviousYear(date, 10);

    case 'month':
      return getEndOfPreviousMonth(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
/**
 * Returns an array with the beginning and the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */


exports.getEndPrevious2 = getEndPrevious2;

function getRange(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyRange(date);

    case 'decade':
      return getDecadeRange(date);

    case 'year':
      return getYearRange(date);

    case 'month':
      return getMonthRange(date);

    case 'day':
      return getDayRange(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
/**
 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date1 First date.
 * @param {Date} date2 Second date.
 */


function getValueRange(rangeType, date1, date2) {
  var rawNextValue = [date1, date2].sort(function (a, b) {
    return a - b;
  });
  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
}
/**
 * Returns a number of days in a month of a given date.
 *
 * @param {Date} date Date.
 */


function getDaysInMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex + 1, 0).getDate();
}

function toYearLabel(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      start = _ref2[0],
      end = _ref2[1];

  return "".concat(getYear(start), " \u2013 ").concat(getYear(end));
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2001-2100.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */


function getCenturyLabel(date) {
  return toYearLabel(getCenturyRange(date));
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2011-2020.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */


function getDecadeLabel(date) {
  return toYearLabel(getDecadeRange(date));
}
/**
 * Returns a boolean determining whether a given date is on Saturday or Sunday.
 *
 * @param {Date} date Date.
 */


function isWeekend(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var weekday = date.getDay();

  switch (calendarType) {
    case 'Arabic':
    case 'Hebrew':
      return weekday === FRIDAY || weekday === SATURDAY;

    case 'ISO 8601':
    case 'US':
      return weekday === SATURDAY || weekday === SUNDAY;

    default:
      throw new Error('Unsupported calendar type.');
  }
}
/**
 * Returns local month in ISO-like format (YYYY-MM).
 */


function getISOLocalMonth(value) {
  if (!value) {
    return value;
  }

  var date = new Date(value);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  var year = getYear(date);
  var month = "0".concat(getMonth(date)).slice(-2);
  return "".concat(year, "-").concat(month);
}
/**
 * Returns local date in ISO-like format (YYYY-MM-DD).
 */


function getISOLocalDate(value) {
  if (!value) {
    return value;
  }

  var date = new Date(value);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  var year = getYear(date);
  var month = "0".concat(getMonth(date)).slice(-2);
  var day = "0".concat(getDay(date)).slice(-2);
  return "".concat(year, "-").concat(month, "-").concat(day);
}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var fails = __webpack_require__(37);
var defined = __webpack_require__(123);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(275);
var defined = __webpack_require__(123);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(99);
var toObject = __webpack_require__(64);
var IE_PROTO = __webpack_require__(509)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(277);
var createDesc = __webpack_require__(189);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(124);
var has = __webpack_require__(99);
var IE8_DOM_DEFINE = __webpack_require__(946);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(56) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(84);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(744);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnimationModule = exports.removeNamespace = exports.transformKeys = exports.prepareValueForInput = exports.inputTypeForPrototype = exports.cloneObject = exports.getViewport = exports.round = exports.range = exports.angle360FromPositions = exports.angleFromPositions = undefined;

var _assoc = __webpack_require__(1781);

var _assoc2 = _interopRequireDefault(_assoc);

var _compose = __webpack_require__(1782);

var _compose2 = _interopRequireDefault(_compose);

var _keys = __webpack_require__(866);

var _keys2 = _interopRequireDefault(_keys);

var _reduce = __webpack_require__(870);

var _reduce2 = _interopRequireDefault(_reduce);

var _pickBy = __webpack_require__(1792);

var _pickBy2 = _interopRequireDefault(_pickBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var angleFromPositions = exports.angleFromPositions = function angleFromPositions(cx, cy, ex, ey) {
  var theta = Math.atan2(ey - cy, ex - cx) + Math.PI / 2;
  return theta * 180 / Math.PI;
};

var angle360FromPositions = exports.angle360FromPositions = function angle360FromPositions(cx, cy, ex, ey) {
  var angle = angleFromPositions(cx, cy, ex, ey);
  return angle < 0 ? 360 + angle : angle;
};

var range = exports.range = function range() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var _start = 0,
      _stop = start;

  if (stop !== null) {
    _start = start;
    _stop = stop;
  }
  var length = Math.max(Math.ceil((_stop - _start) / step), 0);
  var _range = Array(length);

  for (var idx = 0; idx < length; idx += 1, _start += step) {
    _range[idx] = _start;
  }

  return _range;
};

var round = exports.round = function round(number, decimals) {
  if (!isNaN(parseFloat(number)) && isFinite(number)) {
    var decimalPower = Math.pow(10, decimals);
    return Math.round(parseFloat(number) * decimalPower) / decimalPower;
  }
  return NaN;
};

var getViewport = exports.getViewport = function getViewport() {
  return {
    height: window.innerHeight || document.documentElement.offsetHeight,
    width: window.innerWidth || document.documentElement.offsetWidth
  };
};

var cloneObject = exports.cloneObject = function cloneObject(object) {
  return JSON.parse(JSON.stringify(object));
};

var inputTypeForPrototype = exports.inputTypeForPrototype = function inputTypeForPrototype(prototype) {
  if (prototype === Date) return 'date';
  if (prototype === Number) return 'number';
  if (prototype === Boolean) return 'checkbox';
  return 'text';
};

var prepareValueForInput = exports.prepareValueForInput = function prepareValueForInput(value, type) {
  if (type === 'date') return new Date(value).toISOString().slice(0, 10);
  if (type === 'checkbox') {
    return value ? 'on' : '';
  }
  return value;
};

var transformKeys = exports.transformKeys = function transformKeys(fn) {
  return function (obj) {
    var addTransformedKey = function addTransformedKey(result, key) {
      return (0, _assoc2.default)(fn(key), obj[key], result);
    };
    return (0, _reduce2.default)(addTransformedKey, {}, (0, _keys2.default)(obj));
  };
};

var removeNamespace = exports.removeNamespace = function removeNamespace(namespace) {
  return function (key) {
    var capitalized = key.substr(namespace.length);
    return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
  };
};

var getAnimationModule = exports.getAnimationModule = function getAnimationModule(animation, theme) {
  return (0, _compose2.default)(transformKeys(removeNamespace(animation)), (0, _pickBy2.default)(function (v, k) {
    return k.startsWith(animation);
  }))(theme);
};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(82);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2629)();
}


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AuthErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */
var AuthErrorMessage = {
    unexpectedError: {
        code: "unexpected_error",
        desc: "Unexpected error in authentication."
    },
    postRequestFailed: {
        code: "post_request_failed",
        desc: "Post request failed from the network, could be a 4xx/5xx or a network unavailability. Please check the exact error code for details."
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */
var AuthError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(AuthError, _super);
    function AuthError(errorCode, errorMessage, suberror) {
        var _this = this;
        var errorString = errorMessage ? errorCode + ": " + errorMessage : errorCode;
        _this = _super.call(this, errorString) || this;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.errorCode = errorCode || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        _this.errorMessage = errorMessage || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        _this.subError = suberror || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        _this.name = "AuthError";
        return _this;
    }
    AuthError.prototype.setCorrelationId = function (correlationId) {
        this.correlationId = correlationId;
    };
    /**
     * Creates an error that is thrown when something unexpected happens in the library.
     * @param errDesc
     */
    AuthError.createUnexpectedError = function (errDesc) {
        return new AuthError(AuthErrorMessage.unexpectedError.code, AuthErrorMessage.unexpectedError.desc + ": " + errDesc);
    };
    /**
     * Creates an error for post request failures.
     * @param errDesc
     * @returns
     */
    AuthError.createPostRequestFailed = function (errDesc) {
        return new AuthError(AuthErrorMessage.postRequestFailed.code, AuthErrorMessage.postRequestFailed.desc + ": " + errDesc);
    };
    return AuthError;
}(Error));


//# sourceMappingURL=AuthError.js.map


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientConfigurationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClientConfigurationErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientAuthError_js__ = __webpack_require__(57);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
 */
var ClientConfigurationErrorMessage = {
    redirectUriNotSet: {
        code: "redirect_uri_empty",
        desc: "A redirect URI is required for all calls, and none has been set."
    },
    postLogoutUriNotSet: {
        code: "post_logout_uri_empty",
        desc: "A post logout redirect has not been set."
    },
    claimsRequestParsingError: {
        code: "claims_request_parsing_error",
        desc: "Could not parse the given claims request object."
    },
    authorityUriInsecure: {
        code: "authority_uri_insecure",
        desc: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options"
    },
    urlParseError: {
        code: "url_parse_error",
        desc: "URL could not be parsed into appropriate segments."
    },
    urlEmptyError: {
        code: "empty_url_error",
        desc: "URL was empty or null."
    },
    emptyScopesError: {
        code: "empty_input_scopes_error",
        desc: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token."
    },
    nonArrayScopesError: {
        code: "nonarray_input_scopes_error",
        desc: "Scopes cannot be passed as non-array."
    },
    clientIdSingleScopeError: {
        code: "clientid_input_scopes_error",
        desc: "Client ID can only be provided as a single scope."
    },
    invalidPrompt: {
        code: "invalid_prompt_value",
        desc: "Supported prompt values are 'login', 'select_account', 'consent', 'create', 'none' and 'no_session'.  Please see here for valid configuration options: https://azuread.github.io/microsoft-authentication-library-for-js/ref/modules/_azure_msal_common.html#commonauthorizationurlrequest",
    },
    invalidClaimsRequest: {
        code: "invalid_claims",
        desc: "Given claims parameter must be a stringified JSON object."
    },
    tokenRequestEmptyError: {
        code: "token_request_empty",
        desc: "Token request was empty and not found in cache."
    },
    logoutRequestEmptyError: {
        code: "logout_request_empty",
        desc: "The logout request was null or undefined."
    },
    invalidCodeChallengeMethod: {
        code: "invalid_code_challenge_method",
        desc: "code_challenge_method passed is invalid. Valid values are \"plain\" and \"S256\"."
    },
    invalidCodeChallengeParams: {
        code: "pkce_params_missing",
        desc: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request"
    },
    invalidCloudDiscoveryMetadata: {
        code: "invalid_cloud_discovery_metadata",
        desc: "Invalid cloudDiscoveryMetadata provided. Must be a stringified JSON object containing tenant_discovery_endpoint and metadata fields"
    },
    invalidAuthorityMetadata: {
        code: "invalid_authority_metadata",
        desc: "Invalid authorityMetadata provided. Must by a stringified JSON object containing authorization_endpoint, token_endpoint, issuer fields."
    },
    untrustedAuthority: {
        code: "untrusted_authority",
        desc: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter."
    },
    invalidAzureCloudInstance: {
        code: "invalid_azure_cloud_instance",
        desc: "Invalid AzureCloudInstance provided. Please refer MSAL JS docs: aks.ms/msaljs/azure_cloud_instance for valid values"
    },
    missingSshJwk: {
        code: "missing_ssh_jwk",
        desc: "Missing sshJwk in SSH certificate request. A stringified JSON Web Key is required when using the SSH authentication scheme."
    },
    missingSshKid: {
        code: "missing_ssh_kid",
        desc: "Missing sshKid in SSH certificate request. A string that uniquely identifies the public SSH key is required when using the SSH authentication scheme."
    },
    missingNonceAuthenticationHeader: {
        code: "missing_nonce_authentication_header",
        desc: "Unable to find an authentication header containing server nonce. Either the Authentication-Info or WWW-Authenticate headers must be present in order to obtain a server nonce."
    },
    invalidAuthenticationHeader: {
        code: "invalid_authentication_header",
        desc: "Invalid authentication header provided"
    },
    authorityMismatch: {
        code: "authority_mismatch",
        desc: "Authority mismatch error. Authority provided in login request or PublicClientApplication config does not match the environment of the provided account. Please use a matching account or make an interactive request to login to this authority."
    }
};
/**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */
var ClientConfigurationError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(ClientConfigurationError, _super);
    function ClientConfigurationError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ClientConfigurationError";
        Object.setPrototypeOf(_this, ClientConfigurationError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when the redirect uri is empty (not set by caller)
     */
    ClientConfigurationError.createRedirectUriEmptyError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.redirectUriNotSet.code, ClientConfigurationErrorMessage.redirectUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the post-logout redirect uri is empty (not set by caller)
     */
    ClientConfigurationError.createPostLogoutRedirectUriEmptyError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.postLogoutUriNotSet.code, ClientConfigurationErrorMessage.postLogoutUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the claims request could not be successfully parsed
     */
    ClientConfigurationError.createClaimsRequestParsingError = function (claimsRequestParseError) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.claimsRequestParsingError.code, ClientConfigurationErrorMessage.claimsRequestParsingError.desc + " Given value: " + claimsRequestParseError);
    };
    /**
     * Creates an error thrown if authority uri is given an insecure protocol.
     * @param urlString
     */
    ClientConfigurationError.createInsecureAuthorityUriError = function (urlString) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.authorityUriInsecure.code, ClientConfigurationErrorMessage.authorityUriInsecure.desc + " Given URI: " + urlString);
    };
    /**
     * Creates an error thrown if URL string does not parse into separate segments.
     * @param urlString
     */
    ClientConfigurationError.createUrlParseError = function (urlParseError) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.urlParseError.code, ClientConfigurationErrorMessage.urlParseError.desc + " Given Error: " + urlParseError);
    };
    /**
     * Creates an error thrown if URL string is empty or null.
     * @param urlString
     */
    ClientConfigurationError.createUrlEmptyError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.urlEmptyError.code, ClientConfigurationErrorMessage.urlEmptyError.desc);
    };
    /**
     * Error thrown when scopes are empty.
     * @param scopesValue
     */
    ClientConfigurationError.createEmptyScopesArrayError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.emptyScopesError.code, "" + ClientConfigurationErrorMessage.emptyScopesError.desc);
    };
    /**
     * Error thrown when client id scope is not provided as single scope.
     * @param inputScopes
     */
    ClientConfigurationError.createClientIdSingleScopeError = function (inputScopes) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.clientIdSingleScopeError.code, ClientConfigurationErrorMessage.clientIdSingleScopeError.desc + " Given Scopes: " + inputScopes);
    };
    /**
     * Error thrown when prompt is not an allowed type.
     * @param promptValue
     */
    ClientConfigurationError.createInvalidPromptError = function (promptValue) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidPrompt.code, ClientConfigurationErrorMessage.invalidPrompt.desc + " Given value: " + promptValue);
    };
    /**
     * Creates error thrown when claims parameter is not a stringified JSON object
     */
    ClientConfigurationError.createInvalidClaimsRequestError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidClaimsRequest.code, ClientConfigurationErrorMessage.invalidClaimsRequest.desc);
    };
    /**
     * Throws error when token request is empty and nothing cached in storage.
     */
    ClientConfigurationError.createEmptyLogoutRequestError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.logoutRequestEmptyError.code, ClientConfigurationErrorMessage.logoutRequestEmptyError.desc);
    };
    /**
     * Throws error when token request is empty and nothing cached in storage.
     */
    ClientConfigurationError.createEmptyTokenRequestError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.tokenRequestEmptyError.code, ClientConfigurationErrorMessage.tokenRequestEmptyError.desc);
    };
    /**
     * Throws error when an invalid code_challenge_method is passed by the user
     */
    ClientConfigurationError.createInvalidCodeChallengeMethodError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCodeChallengeMethod.code, ClientConfigurationErrorMessage.invalidCodeChallengeMethod.desc);
    };
    /**
     * Throws error when both params: code_challenge and code_challenge_method are not passed together
     */
    ClientConfigurationError.createInvalidCodeChallengeParamsError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCodeChallengeParams.code, ClientConfigurationErrorMessage.invalidCodeChallengeParams.desc);
    };
    /**
     * Throws an error when the user passes invalid cloudDiscoveryMetadata
     */
    ClientConfigurationError.createInvalidCloudDiscoveryMetadataError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCloudDiscoveryMetadata.code, ClientConfigurationErrorMessage.invalidCloudDiscoveryMetadata.desc);
    };
    /**
     * Throws an error when the user passes invalid cloudDiscoveryMetadata
     */
    ClientConfigurationError.createInvalidAuthorityMetadataError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidAuthorityMetadata.code, ClientConfigurationErrorMessage.invalidAuthorityMetadata.desc);
    };
    /**
     * Throws error when provided authority is not a member of the trusted host list
     */
    ClientConfigurationError.createUntrustedAuthorityError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.untrustedAuthority.code, ClientConfigurationErrorMessage.untrustedAuthority.desc);
    };
    /**
     * Throws error when the AzureCloudInstance is set to an invalid value
     */
    ClientConfigurationError.createInvalidAzureCloudInstanceError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidAzureCloudInstance.code, ClientConfigurationErrorMessage.invalidAzureCloudInstance.desc);
    };
    /**
     * Throws an error when the authentication scheme is set to SSH but the SSH public key is omitted from the request
     */
    ClientConfigurationError.createMissingSshJwkError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.missingSshJwk.code, ClientConfigurationErrorMessage.missingSshJwk.desc);
    };
    /**
     * Throws an error when the authentication scheme is set to SSH but the SSH public key ID is omitted from the request
     */
    ClientConfigurationError.createMissingSshKidError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.missingSshKid.code, ClientConfigurationErrorMessage.missingSshKid.desc);
    };
    /**
     * Throws error when provided headers don't contain a header that a server nonce can be extracted from
     */
    ClientConfigurationError.createMissingNonceAuthenticationHeadersError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.missingNonceAuthenticationHeader.code, ClientConfigurationErrorMessage.missingNonceAuthenticationHeader.desc);
    };
    /**
     * Throws error when a provided header is invalid in any way
     */
    ClientConfigurationError.createInvalidAuthenticationHeaderError = function (invalidHeaderName, details) {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidAuthenticationHeader.code, ClientConfigurationErrorMessage.invalidAuthenticationHeader.desc + ". Invalid header: " + invalidHeaderName + ". Details: " + details);
    };
    /**
     * Create an error when the authority provided in request does not match authority provided in account or MSAL.js configuration.
     */
    ClientConfigurationError.createAuthorityMismatchError = function () {
        return new ClientConfigurationError(ClientConfigurationErrorMessage.authorityMismatch.code, ClientConfigurationErrorMessage.authorityMismatch.desc);
    };
    return ClientConfigurationError;
}(__WEBPACK_IMPORTED_MODULE_1__ClientAuthError_js__["a" /* ClientAuthError */]));


//# sourceMappingURL=ClientConfigurationError.js.map


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeUtils; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Utility class which exposes functions for managing date and time operations.
 */
var TimeUtils = /** @class */ (function () {
    function TimeUtils() {
    }
    /**
     * return the current time in Unix time (seconds).
     */
    TimeUtils.nowSeconds = function () {
        // Date.getTime() returns in milliseconds.
        return Math.round(new Date().getTime() / 1000.0);
    };
    /**
     * check if a token is expired based on given UTC time in seconds.
     * @param expiresOn
     */
    TimeUtils.isTokenExpired = function (expiresOn, offset) {
        // check for access token expiry
        var expirationSec = Number(expiresOn) || 0;
        var offsetCurrentTimeSec = TimeUtils.nowSeconds() + offset;
        // If current time + offset is greater than token expiration time, then token is expired.
        return (offsetCurrentTimeSec > expirationSec);
    };
    /**
     * If the current time is earlier than the time that a token was cached at, we must discard the token
     * i.e. The system clock was turned back after acquiring the cached token
     * @param cachedAt
     * @param offset
     */
    TimeUtils.wasClockTurnedBack = function (cachedAt) {
        var cachedAtSec = Number(cachedAt);
        return cachedAtSec > TimeUtils.nowSeconds();
    };
    /**
     * Waits for t number of milliseconds
     * @param t number
     * @param value T
     */
    TimeUtils.delay = function (t, value) {
        return new Promise(function (resolve) { return setTimeout(function () { return resolve(value); }, t); });
    };
    return TimeUtils;
}());


//# sourceMappingURL=TimeUtils.js.map


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(37);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1167)();
}


/***/ }),
/* 117 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (key) {
  var defaut_value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  return {
    get: function get(callback) {
      var value = localStorage.getItem(key);
      callback(value && json_parse(value) || defaut_value);
    },

    set: function set(value, callback) {
      localStorage.setItem(key, JSON.stringify(value));
      if (callback) callback(value);
    },

    clear: function clear() {
      localStorage.removeItem(key);
    }
  };
};

// src/actions/permanent-store.js

function json_parse(value) {
  try {
    return JSON.parse(value);
  } catch (e) {
    return JSON.parse("\"" + value + "\"");
  }
}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _dissoc = __webpack_require__(1769);

var _dissoc2 = _interopRequireDefault(_dissoc);

var _identifiers = __webpack_require__(16);

var _events = __webpack_require__(143);

var _events2 = _interopRequireDefault(_events);

var _prefixer = __webpack_require__(336);

var _prefixer2 = _interopRequireDefault(_prefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaults = {
  centered: false,
  className: '',
  multiple: true,
  passthrough: true,
  spread: 2,
  theme: {}
};

var rippleFactory = function rippleFactory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaults$options = _extends({}, defaults, options),
      defaultCentered = _defaults$options.centered,
      defaultClassName = _defaults$options.className,
      defaultMultiple = _defaults$options.multiple,
      defaultPassthrough = _defaults$options.passthrough,
      defaultSpread = _defaults$options.spread,
      defaultTheme = _defaults$options.theme,
      props = _objectWithoutProperties(_defaults$options, ['centered', 'className', 'multiple', 'passthrough', 'spread', 'theme']);

  return function (ComposedComponent) {
    var RippledComponent = function (_Component) {
      _inherits(RippledComponent, _Component);

      function RippledComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RippledComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RippledComponent.__proto__ || Object.getPrototypeOf(RippledComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          ripples: {}
        }, _this.rippleNodes = {}, _this.doRipple = function () {
          return !_this.props.disabled && _this.props.ripple;
        }, _this.handleMouseDown = function (event) {
          if (_this.props.onMouseDown) _this.props.onMouseDown(event);
          if (_this.doRipple()) {
            var _events$getMousePosit = _events2.default.getMousePosition(event),
                x = _events$getMousePosit.x,
                y = _events$getMousePosit.y;

            _this.animateRipple(x, y, false);
          }
        }, _this.handleTouchStart = function (event) {
          if (_this.props.onTouchStart) _this.props.onTouchStart(event);
          if (_this.doRipple()) {
            var _events$getTouchPosit = _events2.default.getTouchPosition(event),
                x = _events$getTouchPosit.x,
                y = _events$getTouchPosit.y;

            _this.animateRipple(x, y, true);
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(RippledComponent, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
          // If a new ripple was just added, add a remove event listener to its animation
          if (Object.keys(prevState.ripples).length < Object.keys(this.state.ripples).length) {
            this.addRippleRemoveEventListener(this.getLastKey());
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this2 = this;

          // Remove document event listeners for ripple if they still exists
          Object.keys(this.state.ripples).forEach(function (key) {
            _this2.state.ripples[key].endRipple();
          });
        }

        /**
         * Find out a descriptor object for the ripple element being created depending on
         * the position where the it was triggered and the component's dimensions.
         *
         * @param {Number} x Coordinate x in the viewport where ripple was triggered
         * @param {Number} y Coordinate y in the viewport where ripple was triggered
         * @return {Object} Descriptor element including position and size of the element
         */

      }, {
        key: 'getDescriptor',
        value: function getDescriptor(x, y) {
          var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this).getBoundingClientRect(),
              left = _ReactDOM$findDOMNode.left,
              top = _ReactDOM$findDOMNode.top,
              height = _ReactDOM$findDOMNode.height,
              width = _ReactDOM$findDOMNode.width;

          var _props = this.props,
              centered = _props.rippleCentered,
              spread = _props.rippleSpread;

          return {
            left: centered ? 0 : x - left - width / 2,
            top: centered ? 0 : y - top - height / 2,
            width: width * spread
          };
        }

        /**
         * Increments and internal counter and returns the next value as a string. It
         * is used to assign key references to new ripple elements.
         *
         * @return {String} Key to be assigned to a ripple.
         */

      }, {
        key: 'getNextKey',
        value: function getNextKey() {
          this.currentCount = this.currentCount ? this.currentCount + 1 : 1;
          return 'ripple' + this.currentCount;
        }

        /**
         * Return the last generated key for a ripple element. When there is only one ripple
         * and to get the reference when a ripple was just created.
         *
         * @return {String} The last generated ripple key.
         */

      }, {
        key: 'getLastKey',
        value: function getLastKey() {
          return 'ripple' + this.currentCount;
        }

        /**
         * Variable to store the ripple references
         */

      }, {
        key: 'rippleShouldTrigger',


        /**
         * Determine if a ripple should start depending if its a touch event. For mobile both
         * touchStart and mouseDown are launched so in case is touch we should always trigger
         * but if its not we should check if a touch was already triggered to decide.
         *
         * @param {Boolean} isTouch True in case a touch event triggered the ripple false otherwise.
         * @return {Boolean} True in case the ripple should trigger or false if it shouldn't.
         */
        value: function rippleShouldTrigger(isTouch) {
          var shouldStart = isTouch ? true : !this.touchCache;
          this.touchCache = isTouch;
          return shouldStart;
        }

        /**
         * Start a ripple animation on an specific point with touch or mouse events. First
         * decides if the animation should trigger. If the ripple is multiple or there is no
         * ripple present, it creates a new key. If it's a simple ripple and already exists,
         * it just restarts the current ripple. The animation happens in two state changes
         * to allow triggering via css.
         *
         * @param {Number} x Coordinate X on the screen where animation should start
         * @param {Number} y Coordinate Y on the screen where animation should start
         * @param {Boolean} isTouch Use events from touch or mouse.
         */

      }, {
        key: 'animateRipple',
        value: function animateRipple(x, y, isTouch) {
          var _this3 = this;

          if (this.rippleShouldTrigger(isTouch)) {
            var _getDescriptor = this.getDescriptor(x, y),
                top = _getDescriptor.top,
                left = _getDescriptor.left,
                width = _getDescriptor.width;

            var noRipplesActive = Object.keys(this.state.ripples).length === 0;
            var key = this.props.rippleMultiple || noRipplesActive ? this.getNextKey() : this.getLastKey();
            var endRipple = this.addRippleDeactivateEventListener(isTouch, key);
            var initialState = {
              active: false,
              restarting: true,
              top: top,
              left: left,
              width: width,
              endRipple: endRipple
            };
            var runningState = { active: true, restarting: false };
            var ripples = _extends({}, this.state.ripples, _defineProperty({}, key, initialState));
            this.setState({ ripples: ripples }, function () {
              if (_this3.rippleNodes[key]) _this3.rippleNodes[key].offsetWidth; // eslint-disable-line
              _this3.setState({
                ripples: _extends({}, _this3.state.ripples, _defineProperty({}, key, Object.assign({}, _this3.state.ripples[key], runningState)))
              });
            });
          }
        }

        /**
         * Add an event listener to the reference with given key so when the animation transition
         * ends we can be sure that it finished and it can be safely removed from the state.
         * This function is called whenever a new ripple is added to the component.
         *
         * @param {String} rippleKey Is the key of the ripple to add the event.
         */

      }, {
        key: 'addRippleRemoveEventListener',
        value: function addRippleRemoveEventListener(rippleKey) {
          var self = this;
          var rippleNode = this.rippleNodes[rippleKey];
          _events2.default.addEventListenerOnTransitionEnded(rippleNode, function onOpacityEnd(e) {
            if (e.propertyName === 'opacity') {
              if (self.props.onRippleEnded) self.props.onRippleEnded(e);
              _events2.default.removeEventListenerOnTransitionEnded(self.rippleNodes[rippleKey], onOpacityEnd);
              delete self.rippleNodes[rippleKey];
              self.setState({ ripples: (0, _dissoc2.default)(rippleKey, self.state.ripples) });
            }
          });
        }

        /**
         * Add an event listener to the document needed to deactivate a ripple and make it dissappear.
         * Deactivation can happen with a touchend or mouseup depending on the trigger type. The
         * ending function is created from a factory function and returned.
         *
         * @param {Boolean} isTouch True in case the trigger was a touch event false otherwise.
         * @param {String} rippleKey It's a key to identify the ripple that should be deactivated.
         * @return {Function} Callback function that deactivates the ripple and removes the listener
         */

      }, {
        key: 'addRippleDeactivateEventListener',
        value: function addRippleDeactivateEventListener(isTouch, rippleKey) {
          var eventType = isTouch ? 'touchend' : 'mouseup';
          var endRipple = this.createRippleDeactivateCallback(eventType, rippleKey);
          document.addEventListener(eventType, endRipple);
          return endRipple;
        }

        /**
         * Generates a function that can be called to deactivate a ripple and remove its finishing
         * event listener. If is generated because we need to store it to be called on unmount in case
         * the ripple is still running.
         *
         * @param {String} eventType Is the event type that can be touchend or mouseup
         * @param {String} rippleKey Is the key representing the ripple
         * @return {Function} Callback function that deactivates the ripple and removes the listener
         */

      }, {
        key: 'createRippleDeactivateCallback',
        value: function createRippleDeactivateCallback(eventType, rippleKey) {
          var self = this;
          return function endRipple() {
            document.removeEventListener(eventType, endRipple);
            self.setState({
              ripples: _extends({}, self.state.ripples, _defineProperty({}, rippleKey, Object.assign({}, self.state.ripples[rippleKey], {
                active: false
              })))
            });
          };
        }
      }, {
        key: 'renderRipple',
        value: function renderRipple(key, className, _ref2) {
          var _classnames,
              _this4 = this;

          var active = _ref2.active,
              left = _ref2.left,
              restarting = _ref2.restarting,
              top = _ref2.top,
              width = _ref2.width;

          var scale = restarting ? 0 : 1;
          var transform = 'translate3d(' + (-width / 2 + left) + 'px, ' + (-width / 2 + top) + 'px, 0) scale(' + scale + ')';
          var _className = (0, _classnames3.default)(this.props.theme.ripple, (_classnames = {}, _defineProperty(_classnames, this.props.theme.rippleActive, active), _defineProperty(_classnames, this.props.theme.rippleRestarting, restarting), _classnames), className);
          return _react2.default.createElement(
            'span',
            _extends({
              key: key,
              'data-react-toolbox': 'ripple',
              className: this.props.theme.rippleWrapper
            }, props),
            _react2.default.createElement('span', {
              className: _className,
              ref: function ref(node) {
                if (node) _this4.rippleNodes[key] = node;
              },
              style: (0, _prefixer2.default)({ transform: transform }, { width: width, height: width })
            })
          );
        }
      }, {
        key: 'render',
        value: function render() {
          var _this5 = this;

          var _props2 = this.props,
              children = _props2.children,
              disabled = _props2.disabled,
              ripple = _props2.ripple,
              onRippleEnded = _props2.onRippleEnded,
              rippleCentered = _props2.rippleCentered,
              rippleClassName = _props2.rippleClassName,
              rippleMultiple = _props2.rippleMultiple,
              rippleSpread = _props2.rippleSpread,
              theme = _props2.theme,
              other = _objectWithoutProperties(_props2, ['children', 'disabled', 'ripple', 'onRippleEnded', 'rippleCentered', 'rippleClassName', 'rippleMultiple', 'rippleSpread', 'theme']);

          var ripples = this.state.ripples;

          var childRipples = Object.keys(ripples).map(function (key) {
            return _this5.renderRipple(key, rippleClassName, ripples[key]);
          });
          var childProps = _extends({
            onMouseDown: this.handleMouseDown,
            onTouchStart: this.handleTouchStart
          }, other);
          var finalProps = defaultPassthrough ? _extends({}, childProps, { theme: theme, disabled: disabled }) : childProps;

          return !ripple ? _react2.default.createElement(ComposedComponent, finalProps, children) : _react2.default.createElement(ComposedComponent, finalProps, [children, childRipples]);
        }
      }]);

      return RippledComponent;
    }(_react.Component);

    RippledComponent.propTypes = {
      children: _propTypes2.default.node,
      disabled: _propTypes2.default.bool,
      onMouseDown: _propTypes2.default.func,
      onRippleEnded: _propTypes2.default.func,
      onTouchStart: _propTypes2.default.func,
      ripple: _propTypes2.default.bool,
      rippleCentered: _propTypes2.default.bool,
      rippleClassName: _propTypes2.default.string,
      rippleMultiple: _propTypes2.default.bool,
      rippleSpread: _propTypes2.default.number,
      theme: _propTypes2.default.shape({
        ripple: _propTypes2.default.string,
        rippleActive: _propTypes2.default.string,
        rippleRestarting: _propTypes2.default.string,
        rippleWrapper: _propTypes2.default.string
      })
    };
    RippledComponent.defaultProps = {
      disabled: false,
      ripple: true,
      rippleCentered: defaultCentered,
      rippleClassName: defaultClassName,
      rippleMultiple: defaultMultiple,
      rippleSpread: defaultSpread
    };


    return (0, _reactCssThemr.themr)(_identifiers.RIPPLE, defaultTheme)(RippledComponent);
  };
};

exports.default = rippleFactory;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppBar = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _AppBar = __webpack_require__(875);

var _button = __webpack_require__(8);

var _theme = __webpack_require__(878);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppBar = (0, _AppBar.appBarFactory)(_button.IconButton);
var ThemedAppBar = (0, _reactCssThemr.themr)(_identifiers.APP_BAR, _theme2.default)(AppBar);

exports.default = ThemedAppBar;
exports.AppBar = ThemedAppBar;

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(40);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(108);
var IObject = __webpack_require__(275);
var toObject = __webpack_require__(64);
var toLength = __webpack_require__(55);
var asc = __webpack_require__(515);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loglevel__ = __webpack_require__(2294);
/* unused harmony reexport LogLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__session__ = __webpack_require__(2295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__session__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__severity__ = __webpack_require__(2296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__severity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__status__ = __webpack_require__(2297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__status__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__transaction__ = __webpack_require__(2298);
/* unused harmony reexport TransactionSamplingMethod */





//# sourceMappingURL=index.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(88);
var core = __webpack_require__(70);
var ctx = __webpack_require__(281);
var hide = __webpack_require__(202);
var has = __webpack_require__(203);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(170);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2420), __esModule: true };

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(2422);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(379);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(2425);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(2429);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(379);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2432)();
}


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePageCallback = exports.cancelRunningTask = exports.makeCancellable = exports.displayCORSWarning = exports.errorOnDev = exports.warnOnDev = exports.getPixelRatio = exports.callIfDefined = exports.dataURItoUint8Array = exports.isParamObject = exports.isDataURI = exports.isFile = exports.isBlob = exports.isArrayBuffer = exports.isString = exports.isProvided = exports.isDefined = exports.isProduction = exports.isLocalFileSystem = exports.isBrowser = undefined;

var _promise = __webpack_require__(548);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(129);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(132);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks if we're running in a browser environment.
 */
var isBrowser = exports.isBrowser = typeof window !== 'undefined';

/**
 * Checks whether we're running from a local file system.
 */
var isLocalFileSystem = exports.isLocalFileSystem = isBrowser && window.location.protocol === 'file:';

/**
 * Checks whether we're running on a production build or not.
 */
var isProduction = exports.isProduction = "production" === 'production';

/**
 * Checks whether a variable is defined.
 *
 * @param {*} variable Variable to check
 */
var isDefined = exports.isDefined = function isDefined(variable) {
  return typeof variable !== 'undefined';
};

/**
 * Checks whether a variable is defined and not null.
 *
 * @param {*} variable Variable to check
 */
var isProvided = exports.isProvided = function isProvided(variable) {
  return isDefined(variable) && variable !== null;
};

/**
 * Checkes whether a variable provided is a string.
 *
 * @param {*} variable Variable to check
 */
var isString = exports.isString = function isString(variable) {
  return typeof variable === 'string';
};

/**
 * Checks whether a variable provided is an ArrayBuffer.
 *
 * @param {*} variable Variable to check
 */
var isArrayBuffer = exports.isArrayBuffer = function isArrayBuffer(variable) {
  return variable instanceof ArrayBuffer;
};

/**
 * Checkes whether a variable provided is a Blob.
 *
 * @param {*} variable Variable to check
 */
var isBlob = exports.isBlob = function isBlob(variable) {
  if (!isBrowser) {
    throw new Error('Attempted to check if a variable is a Blob on a non-browser environment.');
  }

  return variable instanceof Blob;
};

/**
 * Checkes whether a variable provided is a File.
 *
 * @param {*} variable Variable to check
 */
var isFile = exports.isFile = function isFile(variable) {
  if (!isBrowser) {
    throw new Error('Attempted to check if a variable is a File on a non-browser environment.');
  }

  return variable instanceof File;
};

/**
 * Checks whether a string provided is a data URI.
 *
 * @param {String} str String to check
 */
var isDataURI = exports.isDataURI = function isDataURI(str) {
  return isString(str) && /^data:/.test(str);
};

var isParamObject = exports.isParamObject = function isParamObject(file) {
  return file instanceof Object && ('data' in file || 'range' in file || 'url' in file);
};

var dataURItoUint8Array = exports.dataURItoUint8Array = function dataURItoUint8Array(dataURI) {
  if (!isDataURI(dataURI)) {
    throw new Error('dataURItoUint8Array was provided with an argument which is not a valid data URI.');
  }

  var byteString = void 0;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }

  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }

  return ia;
};

/**
 * Calls a function, if it's defined, with specified arguments
 * @param {Function} fn
 * @param {Object} args
 */
var callIfDefined = exports.callIfDefined = function callIfDefined(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (fn && typeof fn === 'function') {
    fn.apply(undefined, args);
  }
};

var getPixelRatio = exports.getPixelRatio = function getPixelRatio() {
  return isBrowser && window.devicePixelRatio || 1;
};

var consoleOnDev = function consoleOnDev(method) {
  for (var _len2 = arguments.length, message = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    message[_key2 - 1] = arguments[_key2];
  }

  if (!isProduction) {
    var _console;

    // eslint-disable-next-line no-console
    (_console = console)[method].apply(_console, message);
  }
};

var warnOnDev = exports.warnOnDev = function warnOnDev() {
  for (var _len3 = arguments.length, message = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    message[_key3] = arguments[_key3];
  }

  return consoleOnDev.apply(undefined, ['warn'].concat(message));
};

var errorOnDev = exports.errorOnDev = function errorOnDev() {
  for (var _len4 = arguments.length, message = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    message[_key4] = arguments[_key4];
  }

  return consoleOnDev.apply(undefined, ['error'].concat(message));
};

var displayCORSWarning = exports.displayCORSWarning = function displayCORSWarning() {
  if (isLocalFileSystem) {
    // eslint-disable-next-line no-console
    warnOnDev('Loading PDF as base64 strings/URLs might not work on protocols other than HTTP/HTTPS. On Google Chrome, you can use --allow-file-access-from-files flag for debugging purposes.');
  }
};

var PromiseCancelledException = function (_Error) {
  (0, _inherits3.default)(PromiseCancelledException, _Error);

  function PromiseCancelledException(message, type) {
    (0, _classCallCheck3.default)(this, PromiseCancelledException);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PromiseCancelledException.__proto__ || (0, _getPrototypeOf2.default)(PromiseCancelledException)).call(this, message, type));

    _this.name = 'PromiseCancelledException';
    _this.message = message;
    _this.type = type;
    return _this;
  }

  return PromiseCancelledException;
}(Error);

var makeCancellable = exports.makeCancellable = function makeCancellable(promise) {
  var isCancelled = false;

  var wrappedPromise = new _promise2.default(function (resolve, reject) {
    promise.then(function () {
      return isCancelled ? reject(new PromiseCancelledException('Promise cancelled')) : resolve.apply(undefined, arguments);
    }, function (error) {
      return isCancelled ? reject(new PromiseCancelledException('Promise cancelled')) : reject(error);
    });
  });

  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      isCancelled = true;
    }
  };
};

var cancelRunningTask = exports.cancelRunningTask = function cancelRunningTask(runningTask) {
  if (!runningTask || !runningTask.cancel) {
    return;
  }

  runningTask.cancel();
};

var makePageCallback = exports.makePageCallback = function makePageCallback(page, scale) {
  Object.defineProperty(page, 'width', {
    get: function get() {
      return this.view[2] * scale;
    },
    configurable: true });
  Object.defineProperty(page, 'height', {
    get: function get() {
      return this.view[3] * scale;
    },
    configurable: true });
  Object.defineProperty(page, 'originalWidth', {
    get: function get() {
      return this.view[2];
    },
    configurable: true });
  Object.defineProperty(page, 'originalHeight', {
    get: function get() {
      return this.view[3];
    },
    configurable: true });
  return page;
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(3);
var core = __webpack_require__(51);
var fails = __webpack_require__(37);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(406);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(754),
    baseKeys = __webpack_require__(1297),
    isArrayLike = __webpack_require__(159);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1301),
    baseMatchesProperty = __webpack_require__(1335),
    identity = __webpack_require__(250),
    isArray = __webpack_require__(62),
    property = __webpack_require__(1344);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(782);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// src/helpers/agent-type.js

var isSmartPhone = exports.isSmartPhone = false;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(866);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getMousePosition: function getMousePosition(event) {
    return {
      x: event.pageX - (window.scrollX || window.pageXOffset),
      y: event.pageY - (window.scrollY || window.pageYOffset)
    };
  },
  getTouchPosition: function getTouchPosition(event) {
    return {
      x: event.touches[0].pageX - (window.scrollX || window.pageXOffset),
      y: event.touches[0].pageY - (window.scrollY || window.pageYOffset)
    };
  },
  pauseEvent: function pauseEvent(event) {
    event.stopPropagation();
    event.preventDefault();
  },
  addEventsToDocument: function addEventsToDocument(eventMap) {
    Object.keys(eventMap).forEach(function (key) {
      document.addEventListener(key, eventMap[key], false);
    });
  },
  removeEventsFromDocument: function removeEventsFromDocument(eventMap) {
    Object.keys(eventMap).forEach(function (key) {
      document.removeEventListener(key, eventMap[key], false);
    });
  },
  targetIsDescendant: function targetIsDescendant(event, parent) {
    var node = event.target;
    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }
    return false;
  },
  addEventListenerOnTransitionEnded: function addEventListenerOnTransitionEnded(element, fn) {
    var eventName = transitionEventNamesFor(element);
    if (!eventName) return false;
    element.addEventListener(eventName, fn);
    return true;
  },
  removeEventListenerOnTransitionEnded: function removeEventListenerOnTransitionEnded(element, fn) {
    var eventName = transitionEventNamesFor(element);
    if (!eventName) return false;
    element.removeEventListener(eventName, fn);
    return true;
  }
};


var TRANSITIONS = {
  transition: 'transitionend',
  OTransition: 'oTransitionEnd',
  MozTransition: 'transitionend',
  WebkitTransition: 'webkitTransitionEnd'
};

function transitionEventNamesFor(element) {
  return (0, _keys2.default)(TRANSITIONS).reduce(function (result, transition) {
    return !result && element && element.style[transition] !== undefined ? TRANSITIONS[transition] : result;
  }, null);
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.emitSocket = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.provideRsync = provideRsync;
exports.requireSocketEmit = requireSocketEmit;

exports.default = function () {
  var message_types = arguments;

  return function (Component) {
    var RsyncedComponent = function (_React$PureComponent) {
      _inherits(RsyncedComponent, _React$PureComponent);

      function RsyncedComponent() {
        _classCallCheck(this, RsyncedComponent);

        return _possibleConstructorReturn(this, (RsyncedComponent.__proto__ || Object.getPrototypeOf(RsyncedComponent)).apply(this, arguments));
      }

      _createClass(RsyncedComponent, [{
        key: 'render',
        value: function render() {
          var _props = this.props,
              socketMessages = _props.socketMessages,
              otherProps = _objectWithoutProperties(_props, ['socketMessages']);

          return _react2.default.createElement(Component, otherProps);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState, snapshot) {
          var _this3 = this;

          if (message_types.length > 0 && prevProps.socketMessages != this.props.socketMessages) {
            (0, _map2.default)(message_types, function (message_type) {
              var current_messages = prevProps.socketMessages[message_type] || [];
              var next_messages = _this3.props.socketMessages[message_type] || [];

              if (next_messages.length > current_messages.length) {
                var new_messages = next_messages.slice(current_messages.length);
                (0, _each2.default)(new_messages, function (message) {
                  return _this3.props.receiveSocket && _this3.props.receiveSocket(message, message_type, _this3.props);
                });
              }
            });
          }

          if (prevProps.socketStatus != this.props.socketStatus && this.props.socketStatus == 'connected' && this.props.requestSync) {
            this.props.requestSync(this.props);
          }
        }
      }]);

      return RsyncedComponent;
    }(_react2.default.PureComponent);

    return (0, _reactRedux.connect)(function (state) {
      return {
        socketMessages: state.socket.items,
        socketStatus: state.socket.status
      };
    })(RsyncedComponent);
  };
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _accessToken = __webpack_require__(220);

var _accessToken2 = _interopRequireDefault(_accessToken);

var _alertMessage = __webpack_require__(13);

var _socket = __webpack_require__(1848);

var _socket2 = _interopRequireDefault(_socket);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _socket3 = __webpack_require__(484);

var _socket4 = _interopRequireDefault(_socket3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/helpers/socket-rsync.js

var MESSAGE_TYPES = {
  notification: 'notification_id',
  diary: 'diary_id',
  group: 'group_id',
  diary_delete: 'diary_id',
  group_delete: 'group_id',
  chat: 'message_id',
  chat_room: 'chat_room_id',
  chat_meta_info: 'chat_meta_info',
  template: 'template_id',
  kpi: 'kpi_id',
  division: 'division_id',
  division_delete: 'division_id'
};

var socketStore = {
  socket: undefined,
  status: undefined
};

var emitSocket = exports.emitSocket = function emitSocket(event, params) {
  if (socketStore.socket && socketStore.status == 'connected') {
    try {
      socketStore.socket.emit(event, params);
      return true;
    } catch (e) {
      return undefined;
    }
  } else return undefined;
};

/*
 * provideRsync(Component):
 *   Componentに対して以下の関数を提供します
 *     - props.initializeSocket(user): userに対するWebsocketのコネクションを確立します
 *     - props.refreshSocket: Websocketのコネクションを再確立します
 *   ComponentがUnmountされる時に以下の機能を実行します
 *     - Websocketのコネクションを削除します
 *   Componentの子孫に対して以下の関数をcontextに埋め込みます
 *     - emitSocket(event, params): Websocketにメッセージを送信します
 */

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    socketStatus: state.socket.status
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  function _initializeSocket(user) {
    socketStore.socket = (0, _socket2.default)(_config2.default.webSocketUrl, { forceNew: true, transports: ['websocket'] });
    socketStore.socket.on('reconnecting', function (num) {
      socketStore.status = 'reconnecting';
      if (num > 3) {
        dispatch(_actions2.default.socketReconnecting());
        dispatch((0, _alertMessage.emitAlertMessage)('error:サーバ切断', 'error'));
      }
    });
    socketStore.socket.on('connect', function () {
      _accessToken2.default.get(function (token) {
        socketStore.socket.emit('authenticate', {
          user_id: user.user_id,
          access_token: token
        });
        socketStore.status = 'connected';
        dispatch((0, _alertMessage.clearAlertMessage)());
        dispatch(_actions2.default.socketConnect());
      });
    });
    socketStore.socket.on('reconnect_failed', function () {
      _destroySocket();
      setTimeout(function () {
        return _initializeSocket(user);
      }, 5000);
    });
    socketStore.socket.on('request_authenticate', function () {
      _accessToken2.default.get(function (token) {
        socketStore.socket.emit('authenticate', {
          user_id: user.user_id,
          access_token: token
        });
        socketStore.status = 'connected';
        dispatch((0, _alertMessage.clearAlertMessage)());
        dispatch(_actions2.default.socketConnect());
      });
    });
    (0, _each2.default)(MESSAGE_TYPES, function (dummy, message_type) {
      socketStore.socket.on(message_type, function (param) {
        param = JSON.parse(param);
        dispatch(_actions2.default.socketReceive(message_type, param));
      });
    });
  }

  function _destroySocket() {
    if (socketStore.socket) {
      dispatch(_actions2.default.socketDisconnect());
      socketStore.socket.disconnect();
      socketStore.socket = null;
      socketStore.status = undefined;
    }
  }

  return {
    initializeSocket: _initializeSocket,
    destroySocket: _destroySocket,
    refreshSocket: function refreshSocket() {
      dispatch(_actions2.default.socketReconnecting());
      setTimeout(function () {
        return dispatch(_actions2.default.socketReconnect());
      }, 0);
    },
    emitSocket: emitSocket
  };
};

function provideRsync(Component) {
  var RsyncProviderComponent = function (_React$Component) {
    _inherits(RsyncProviderComponent, _React$Component);

    function RsyncProviderComponent() {
      _classCallCheck(this, RsyncProviderComponent);

      return _possibleConstructorReturn(this, (RsyncProviderComponent.__proto__ || Object.getPrototypeOf(RsyncProviderComponent)).apply(this, arguments));
    }

    _createClass(RsyncProviderComponent, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, this.props);
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          emitSocket: this.props.emitSocket
        };
      }
    }]);

    return RsyncProviderComponent;
  }(_react2.default.Component);

  RsyncProviderComponent.childContextTypes = { emitSocket: _propTypes2.default.func };
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RsyncProviderComponent);
}

/*
 * requireSocketEmit(Component):
 *   Componentに対して以下の関数を提供します
 *     - props.emitSocket(event, params): Websocketにメッセージを送信します
 */

function requireSocketEmit(Component) {
  return (0, _context2.default)({ emitSocket: _propTypes2.default.func })(Component);
}

/*
 * default(message_types)(Component):
 *   Componentに対して以下のコールバックを呼び出します
 *     - props.reseiveSocket(message, message_type): Websocketでmessage_typeのメッセージmessageを受信した場合に呼び出されます
 *     - props.requestSync(props): Websocketのコネクションが確立・再確立した場合に呼び出されます
 */

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hasOwnProperty = __webpack_require__(1884);

var _hasOwnProperty2 = _interopRequireDefault(_hasOwnProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateLocales = {
  de: {
    months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan_Feb_März_Apr_Mai_Juni_Juli_Aug_Sept_Okt_Nov_Dez'.split('_'),
    weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysLetter: 'S_M_D_M_D_F_S'.split('_')
  },
  no: {
    months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort: 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysLetter: []
  },
  en: {
    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysLetter: []
  },
  es: {
    months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort: 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
    weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysLetter: 'D_L_M_X_J_V_S'.split('_')
  },
  af: {
    months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysLetter: []
  },
  ar: {
    months: ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'],
    monthsShort: ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'],
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysLetter: []
  },
  be: {
    months: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_'),
    monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
    weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysLetter: []
  },
  bg: {
    months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort: 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysLetter: []
  },
  bn: {
    months: 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort: 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
    weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্র_শনি'.split('_'),
    weekdaysLetter: []
  },
  bo: {
    months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysLetter: []
  },
  br: {
    months: "Genver_C'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split('_'),
    monthsShort: "Gen_C'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split('_'),
    weekdays: "Sul_Lun_Meurzh_Merc'her_Yaou_Gwener_Sadorn".split('_'),
    weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysLetter: []
  },
  bs: {
    months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysLetter: []
  },
  ca: {
    months: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
    monthsShort: 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
    weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysLetter: 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_')
  },
  gl: {
    months: 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
    monthsShort: 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
    weekdays: 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
    weekdaysShort: 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
    weekdaysLetter: 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_')
  },
  eu: {
    months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysLetter: 'ig_al_ar_az_og_ol_lr'.split('_')
  },
  pt: {
    months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
    weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysLetter: []
  },
  it: {
    months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays: 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
    weekdaysShort: 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
    weekdaysLetter: []
  },
  fr: {
    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysLetter: []
  },
  ru: {
    months: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_'),
    monthsShort: 'Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек'.split('_'),
    weekdays: 'Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота'.split('_'),
    weekdaysShort: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
    weekdaysLetter: []
  },
  ua: {
    months: 'Січень_Лютий_Березень_Квітень_Травень_Червень_Липень_Серпень_Вересень_Жовтень_Листопад_Грудень'.split('_'),
    monthsShort: 'Січ_Лют_Берез_Квіт_Трав_Черв_Лип_Серп_Верес_Жовт_Листоп_Груд'.split('_'),
    weekdays: 'Неділя_Понеділок_Вівторок_Середа_Четвер_П’ятниця_Субота'.split('_'),
    weekdaysShort: 'Нд_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
    weekdaysLetter: []
  },
  'zh-cn': {
    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
  },
  'zh-hk': {
    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
  },
  'zh-tw': {
    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
  }
};

var time = {
  getDaysInMonth: function getDaysInMonth(d) {
    var resultDate = this.getFirstDayOfMonth(d);
    resultDate.setMonth(resultDate.getMonth() + 1);
    resultDate.setDate(resultDate.getDate() - 1);
    return resultDate.getDate();
  },
  getFirstDayOfMonth: function getFirstDayOfMonth(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1);
  },
  getFirstWeekDay: function getFirstWeekDay(d) {
    return this.getFirstDayOfMonth(d).getDay();
  },
  getTimeMode: function getTimeMode(d) {
    return d.getHours() >= 12 ? 'pm' : 'am';
  },
  getFullMonth: function getFullMonth(d) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

    var month = d.getMonth();
    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
    return (0, _hasOwnProperty2.default)(l, 'months') ? l.months[month] || 'Unknown' : 'Unknown';
  },
  getShortMonth: function getShortMonth(d) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

    var month = d.getMonth();
    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
    return (0, _hasOwnProperty2.default)(l, 'monthsShort') ? l.monthsShort[month] || 'Unknown' : 'Unknown';
  },
  getFullDayOfWeek: function getFullDayOfWeek(day) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
    return (0, _hasOwnProperty2.default)(l, 'weekdays') ? l.weekdays[day] || 'Unknown' : 'Unknown';
  },
  getShortDayOfWeek: function getShortDayOfWeek(day) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
    return (0, _hasOwnProperty2.default)(l, 'weekdaysShort') ? l.weekdaysShort[day] || 'Unknown' : 'Unknown';
  },
  getDayOfWeekLetter: function getDayOfWeekLetter(day) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
    return (0, _hasOwnProperty2.default)(l, 'weekdaysLetter') ? l.weekdaysLetter[day] || this.getFullDayOfWeek(day, locale).charAt(0) : 'Unknown';
  },
  clone: function clone(d) {
    return new Date(d.getTime());
  },
  cloneAsDate: function cloneAsDate(d) {
    var clonedDate = this.clone(d);
    clonedDate.setHours(0, 0, 0, 0);
    return clonedDate;
  },
  isDateObject: function isDateObject(d) {
    return d instanceof Date;
  },
  addDays: function addDays(d, days) {
    var newDate = this.clone(d);
    newDate.setDate(d.getDate() + days);
    return newDate;
  },
  addMonths: function addMonths(d, months) {
    var newDate = this.clone(d);
    newDate.setMonth(d.getMonth() + months, 1);
    return newDate;
  },
  addYears: function addYears(d, years) {
    var newDate = this.clone(d);
    newDate.setFullYear(d.getFullYear() + years);
    return newDate;
  },
  setDay: function setDay(d, day) {
    var newDate = this.clone(d);
    newDate.setDate(day);
    return newDate;
  },
  setMonth: function setMonth(d, month) {
    var newDate = this.clone(d);
    newDate.setMonth(month);
    return newDate;
  },
  setYear: function setYear(d, year) {
    var newDate = this.clone(d);
    newDate.setFullYear(year);
    return newDate;
  },
  setHours: function setHours(d, hours) {
    var newDate = this.clone(d);
    newDate.setHours(hours);
    return newDate;
  },
  setMinutes: function setMinutes(d, minutes) {
    var newDate = this.clone(d);
    newDate.setMinutes(minutes);
    return newDate;
  },
  toggleTimeMode: function toggleTimeMode(d) {
    var newDate = this.clone(d);
    var hours = newDate.getHours();

    newDate.setHours(hours - (hours > 12 ? -12 : 12));
    return newDate;
  },
  formatTime: function formatTime(date, format) {
    var hours = date.getHours();
    var mins = date.getMinutes().toString();

    if (format === 'ampm') {
      var isAM = hours < 12;
      var additional = isAM ? ' am' : ' pm';

      hours %= 12;
      hours = (hours || 12).toString();
      if (mins.length < 2) mins = '0' + mins;

      return hours + (mins === '00' ? '' : ':' + mins) + additional;
    }

    hours = hours.toString();
    if (hours.length < 2) hours = '0' + hours;
    if (mins.length < 2) mins = '0' + mins;
    return hours + ':' + mins;
  },
  dateOutOfRange: function dateOutOfRange(date, minDate, maxDate) {
    return minDate && !(date >= minDate) || maxDate && !(date <= maxDate);
  },
  closestDate: function closestDate(to, date1, date2) {
    var toTime = to.getTime();

    var diff1 = Math.abs(toTime - date1.getTime());
    var diff2 = Math.abs(toTime - date2.getTime());

    return diff1 < diff2 ? date1 : date2;
  },
  formatDate: function formatDate(date) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

    if (locale === 'en') {
      return date.getDate() + ' ' + time.getFullMonth(date, locale) + ' ' + date.getFullYear();
    }
    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
  }
};

exports.default = time;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertEmojiHTML = convertEmojiHTML;
exports.convertEmojiChar = convertEmojiChar;
exports.encodeEmojiTag = encodeEmojiTag;

var _emojione = __webpack_require__(1921);

var _emojione2 = _interopRequireDefault(_emojione);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function convertEmojiHTML(html) {
  return html.replace(/ ?:emoji-([-0-9a-f]+): ?/ig, function (match, unicode) {
    return '<img src="' + _config2.default.emojiPNG + unicode.toLowerCase() + '.png" style="width: 18px; height: 18px; vertical-align: middle"/>';
  }).replace(/\uFE0F/g, '');
}

function convertEmojiChar(text) {
  return text.replace(/ ?:emoji-([-0-9a-f]+): ?/ig, function (match, unicode) {
    var buf = '';
    (0, _each2.default)(unicode.split('-').map(function (code) {
      return parseInt(code, 16);
    }), function (code) {
      if (code < 0x10000) {
        buf += String.fromCharCode(code);
      } else {
        code -= 0x10000;
        buf += String.fromCharCode(0xD800 + (code >> 10), 0xDC00 + (code & 0x3FF));
      }
    });
    return buf;
  });
}

function encodeEmojiTag(html) {
  return html.replace(/<img [^>]*src="[.:\/\w\d]+emojione[.:\/\d\w]*\/([-0-9a-f]+).png"[^>]*>/g, " :emoji-$1: ");
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Navigation = __webpack_require__(1924);

var _button = __webpack_require__(8);

var _link = __webpack_require__(183);

var _theme = __webpack_require__(1927);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedNavigation = (0, _reactCssThemr.themr)(_identifiers.NAVIGATION, _theme2.default)((0, _Navigation.navigationFactory)(_button.Button, _link.Link));
exports.default = ThemedNavigation;
exports.Navigation = ThemedNavigation;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76).Buffer))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(235)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRotate = exports.isPdf = exports.isPageNumber = exports.isPageIndex = exports.isPage = exports.isLinkService = exports.isFile = exports.isClassName = exports.eventsProps = undefined;

var _typeof2 = __webpack_require__(379);

var _typeof3 = _interopRequireDefault(_typeof2);

var _propTypes = __webpack_require__(133);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(1043);

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = __webpack_require__(134);

var _events = __webpack_require__(385);

var _LinkService = __webpack_require__(1015);

var _LinkService2 = _interopRequireDefault(_LinkService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventsProps = exports.eventsProps = (0, _lodash2.default)(function () {
  var eventProps = {};

  [].concat(_events.mouseEvents, _events.touchEvents).forEach(function (eventName) {
    eventProps[eventName] = _propTypes2.default.func;
  });

  return eventProps;
});

var fileTypes = [_propTypes2.default.string, _propTypes2.default.instanceOf(ArrayBuffer), _propTypes2.default.shape({
  data: _propTypes2.default.object,
  httpHeaders: _propTypes2.default.object,
  range: _propTypes2.default.object,
  url: _propTypes2.default.string,
  withCredentials: _propTypes2.default.bool
})];
if (typeof File !== 'undefined') {
  fileTypes.push(_propTypes2.default.instanceOf(File));
}
if (typeof Blob !== 'undefined') {
  fileTypes.push(_propTypes2.default.instanceOf(Blob));
}

var isClassName = exports.isClassName = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]);

var isFile = exports.isFile = _propTypes2.default.oneOfType(fileTypes);

var isLinkService = exports.isLinkService = _propTypes2.default.instanceOf(_LinkService2.default);

var isPage = exports.isPage = _propTypes2.default.shape({
  commonObjs: _propTypes2.default.shape({
    objs: _propTypes2.default.object.isRequired
  }).isRequired,
  getAnnotations: _propTypes2.default.func.isRequired,
  getTextContent: _propTypes2.default.func.isRequired,
  getViewport: _propTypes2.default.func.isRequired,
  render: _propTypes2.default.func.isRequired,
  transport: _propTypes2.default.shape({
    fontLoader: _propTypes2.default.object.isRequired
  }).isRequired
});

var isPageIndex = exports.isPageIndex = function isPageIndex(props, propName, componentName) {
  var pageIndex = props[propName];
  var pageNumber = props.pageNumber,
      pdf = props.pdf;


  if (!(0, _utils.isDefined)(pdf)) {
    return null;
  }

  if ((0, _utils.isDefined)(pageIndex)) {
    if (typeof pageIndex !== 'number') {
      return new Error('`' + propName + '` of type `' + (typeof pageIndex === 'undefined' ? 'undefined' : (0, _typeof3.default)(pageIndex)) + '` supplied to `' + componentName + '`, expected `number`.');
    }

    if (pageIndex < 0) {
      return new Error('Expected `' + propName + '` to be greater or equal to 0.');
    }

    var numPages = pdf.pdfInfo.numPages;


    if (pageIndex + 1 > numPages) {
      return new Error('Expected `' + propName + '` to be less or equal to ' + (numPages - 1) + '.');
    }
  } else if (!(0, _utils.isDefined)(pageNumber)) {
    return new Error('`' + propName + '` not supplied. Either pageIndex or pageNumber must be supplied to `' + componentName + '`.');
  }

  // Everything is fine
  return null;
};

var isPageNumber = exports.isPageNumber = function isPageNumber(props, propName, componentName) {
  var pageNumber = props[propName];
  var pageIndex = props.pageIndex,
      pdf = props.pdf;


  if (!(0, _utils.isDefined)(pdf)) {
    return null;
  }

  if ((0, _utils.isDefined)(pageNumber)) {
    if (typeof pageNumber !== 'number') {
      return new Error('`' + propName + '` of type `' + (typeof pageNumber === 'undefined' ? 'undefined' : (0, _typeof3.default)(pageNumber)) + '` supplied to `' + componentName + '`, expected `number`.');
    }

    if (pageNumber < 1) {
      return new Error('Expected `' + propName + '` to be greater or equal to 1.');
    }

    var numPages = pdf.pdfInfo.numPages;


    if (pageNumber > numPages) {
      return new Error('Expected `' + propName + '` to be less or equal to ' + numPages + '.');
    }
  } else if (!(0, _utils.isDefined)(pageIndex)) {
    return new Error('`' + propName + '` not supplied. Either pageIndex or pageNumber must be supplied to `' + componentName + '`.');
  }

  // Everything is fine
  return null;
};

var isPdf = exports.isPdf = _propTypes2.default.oneOfType([_propTypes2.default.shape({
  getDestination: _propTypes2.default.func.isRequired,
  getOutline: _propTypes2.default.func.isRequired,
  getPage: _propTypes2.default.func.isRequired,
  numPages: _propTypes2.default.number.isRequired
}), _propTypes2.default.bool]);

var isRotate = exports.isRotate = _propTypes2.default.oneOf([0, 90, 180, 270]);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule cx
 */

var slashReplaceRegex = /\//g;
var cache = {};

function getClassName(className) {
  if (cache[className]) {
    return cache[className];
  }

  cache[className] = className.replace(slashReplaceRegex, '_');
  return cache[className];
}

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx(classNames) {
  var classNamesArray;
  if ((typeof classNames === 'undefined' ? 'undefined' : _typeof(classNames)) == 'object') {
    classNamesArray = Object.keys(classNames).filter(function (className) {
      return classNames[className];
    });
  } else {
    classNamesArray = Array.prototype.slice.call(arguments);
  }

  return classNamesArray.map(getClassName).join(' ');
}

module.exports = cx;

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UrlString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */






/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Url object class which can perform various transformations on url strings.
 */
var UrlString = /** @class */ (function () {
    function UrlString(url) {
        this._urlString = url;
        if (__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(this._urlString)) {
            // Throws error if url is empty
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createUrlEmptyError();
        }
        if (__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(this.getHash())) {
            this._urlString = UrlString.canonicalizeUri(url);
        }
    }
    Object.defineProperty(UrlString.prototype, "urlString", {
        get: function () {
            return this._urlString;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */
    UrlString.canonicalizeUri = function (url) {
        if (url) {
            var lowerCaseUrl = url.toLowerCase();
            if (__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].endsWith(lowerCaseUrl, "?")) {
                lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            }
            else if (__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].endsWith(lowerCaseUrl, "?/")) {
                lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            }
            if (!__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].endsWith(lowerCaseUrl, "/")) {
                lowerCaseUrl += "/";
            }
            return lowerCaseUrl;
        }
        return url;
    };
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */
    UrlString.prototype.validateAsUri = function () {
        // Attempts to parse url for uri components
        var components;
        try {
            components = this.getUrlComponents();
        }
        catch (e) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createUrlParseError(e);
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createUrlParseError("Given url string: " + this.urlString);
        }
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") {
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInsecureAuthorityUriError(this.urlString);
        }
    };
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */
    UrlString.appendQueryString = function (url, queryString) {
        if (__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(queryString)) {
            return url;
        }
        return url.indexOf("?") < 0 ? url + "?" + queryString : url + "&" + queryString;
    };
    /**
     * Returns a url with the hash removed
     * @param url
     */
    UrlString.removeHashFromUrl = function (url) {
        return UrlString.canonicalizeUri(url.split("#")[0]);
    };
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */
    UrlString.prototype.replaceTenantPath = function (tenantId) {
        var urlObject = this.getUrlComponents();
        var pathArray = urlObject.PathSegments;
        if (tenantId && (pathArray.length !== 0 && (pathArray[0] === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["a" /* AADAuthorityConstants */].COMMON || pathArray[0] === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["a" /* AADAuthorityConstants */].ORGANIZATIONS))) {
            pathArray[0] = tenantId;
        }
        return UrlString.constructAuthorityUriFromObject(urlObject);
    };
    /**
     * Returns the anchor part(#) of the URL
     */
    UrlString.prototype.getHash = function () {
        return UrlString.parseHash(this.urlString);
    };
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */
    UrlString.prototype.getUrlComponents = function () {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        var regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        var match = this.urlString.match(regEx);
        if (!match) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createUrlParseError("Given url string: " + this.urlString);
        }
        // Url component object
        var urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        var pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter(function (val) { return val && val.length > 0; }); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (!__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(urlComponents.QueryString) && urlComponents.QueryString.endsWith("/")) {
            urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        }
        return urlComponents;
    };
    UrlString.getDomainFromUrl = function (url) {
        var regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        var match = url.match(regEx);
        if (!match) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createUrlParseError("Given url string: " + url);
        }
        return match[2];
    };
    UrlString.getAbsoluteUrl = function (relativeUrl, baseUrl) {
        if (relativeUrl[0] === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["m" /* Constants */].FORWARD_SLASH) {
            var url = new UrlString(baseUrl);
            var baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    };
    /**
     * Parses hash string from given string. Returns empty string if no hash symbol is found.
     * @param hashString
     */
    UrlString.parseHash = function (hashString) {
        var hashIndex1 = hashString.indexOf("#");
        var hashIndex2 = hashString.indexOf("#/");
        if (hashIndex2 > -1) {
            return hashString.substring(hashIndex2 + 2);
        }
        else if (hashIndex1 > -1) {
            return hashString.substring(hashIndex1 + 1);
        }
        return __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
    };
    /**
     * Parses query string from given string. Returns empty string if no query symbol is found.
     * @param queryString
     */
    UrlString.parseQueryString = function (queryString) {
        var queryIndex1 = queryString.indexOf("?");
        var queryIndex2 = queryString.indexOf("/?");
        if (queryIndex2 > -1) {
            return queryString.substring(queryIndex2 + 2);
        }
        else if (queryIndex1 > -1) {
            return queryString.substring(queryIndex1 + 1);
        }
        return __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
    };
    UrlString.constructAuthorityUriFromObject = function (urlObject) {
        return new UrlString(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    };
    /**
     * Returns URL hash as server auth code response object.
     */
    UrlString.getDeserializedHash = function (hash) {
        // Check if given hash is empty
        if (__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(hash)) {
            return {};
        }
        // Strip the # symbol if present
        var parsedHash = UrlString.parseHash(hash);
        // If # symbol was not present, above will return empty string, so give original hash value
        var deserializedHash = __WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].queryStringToObject(__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(parsedHash) ? hash : parsedHash);
        // Check if deserialization didn't work
        if (!deserializedHash) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_ClientAuthError_js__["a" /* ClientAuthError */].createHashNotDeserializedError(JSON.stringify(deserializedHash));
        }
        return deserializedHash;
    };
    /**
     * Returns URL query string as server auth code response object.
     */
    UrlString.getDeserializedQueryString = function (query) {
        // Check if given query is empty
        if (__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(query)) {
            return {};
        }
        // Strip the ? symbol if present
        var parsedQueryString = UrlString.parseQueryString(query);
        // If ? symbol was not present, above will return empty string, so give original query value
        var deserializedQueryString = __WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].queryStringToObject(__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(parsedQueryString) ? query : parsedQueryString);
        // Check if deserialization didn't work
        if (!deserializedQueryString) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_ClientAuthError_js__["a" /* ClientAuthError */].createHashNotDeserializedError(JSON.stringify(deserializedQueryString));
        }
        return deserializedQueryString;
    };
    /**
     * Check if the hash of the URL string contains known properties
     */
    UrlString.hashContainsKnownProperties = function (hash) {
        if (__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(hash) || hash.indexOf("=") < 0) {
            // Hash doesn't contain key/value pairs
            return false;
        }
        var parameters = UrlString.getDeserializedHash(hash);
        return !!(parameters.code ||
            parameters.error_description ||
            parameters.error ||
            parameters.state);
    };
    return UrlString;
}());


//# sourceMappingURL=UrlString.js.map


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PerformanceEventStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PerformanceEvents; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Enumeration of operations that are instrumented by have their performance measured by the PerformanceClient.
 *
 * @export
 * @enum {number}
 */
var PerformanceEvents;
(function (PerformanceEvents) {
    /**
     * acquireTokenByCode API (msal-browser and msal-node).
     * Used to acquire tokens by trading an authorization code against the token endpoint.
     */
    PerformanceEvents["AcquireTokenByCode"] = "acquireTokenByCode";
    /**
     * acquireTokenByRefreshToken API (msal-browser and msal-node).
     * Used to renew an access token using a refresh token against the token endpoint.
     */
    PerformanceEvents["AcquireTokenByRefreshToken"] = "acquireTokenByRefreshToken";
    /**
     * acquireTokenSilent API (msal-browser and msal-node).
     * Used to silently acquire a new access token (from the cache or the network).
     */
    PerformanceEvents["AcquireTokenSilent"] = "acquireTokenSilent";
    /**
     * acquireTokenSilentAsync (msal-browser).
     * Internal API for acquireTokenSilent.
     */
    PerformanceEvents["AcquireTokenSilentAsync"] = "acquireTokenSilentAsync";
    /**
     * acquireTokenPopup (msal-browser).
     * Used to acquire a new access token interactively through pop ups
     */
    PerformanceEvents["AcquireTokenPopup"] = "acquireTokenPopup";
    /**
     * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
     * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
     */
    PerformanceEvents["CryptoOptsGetPublicKeyThumbprint"] = "cryptoOptsGetPublicKeyThumbprint";
    /**
     * signJwt API in CryptoOpts class (msal-browser).
     * Used to signed a pop token.
     */
    PerformanceEvents["CryptoOptsSignJwt"] = "cryptoOptsSignJwt";
    /**
     * acquireToken API in the SilentCacheClient class (msal-browser).
     * Used to read access tokens from the cache.
     */
    PerformanceEvents["SilentCacheClientAcquireToken"] = "silentCacheClientAcquireToken";
    /**
     * acquireToken API in the SilentIframeClient class (msal-browser).
     * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
     */
    PerformanceEvents["SilentIframeClientAcquireToken"] = "silentIframeClientAcquireToken";
    /**
     * acquireToken API in SilentRereshClient (msal-browser).
     * Used to acquire a new set of tokens from the token endpoint using a refresh token.
     */
    PerformanceEvents["SilentRefreshClientAcquireToken"] = "silentRefreshClientAcquireToken";
    /**
     * ssoSilent API (msal-browser).
     * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
     */
    PerformanceEvents["SsoSilent"] = "ssoSilent";
    /**
     * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
     * Used to load authority metadata for a request.
     */
    PerformanceEvents["StandardInteractionClientGetDiscoveredAuthority"] = "standardInteractionClientGetDiscoveredAuthority";
    /**
     * acquireToken APIs in msal-browser.
     * Used to make an /authorize endpoint call with native brokering enabled.
     */
    PerformanceEvents["FetchAccountIdWithNativeBroker"] = "fetchAccountIdWithNativeBroker";
    /**
     * acquireToken API in NativeInteractionClient class (msal-browser).
     * Used to acquire a token from Native component when native brokering is enabled.
     */
    PerformanceEvents["NativeInteractionClientAcquireToken"] = "nativeInteractionClientAcquireToken";
    /**
     * Time spent creating default headers for requests to token endpoint
     */
    PerformanceEvents["BaseClientCreateTokenRequestHeaders"] = "baseClientCreateTokenRequestHeaders";
    /**
     * Used to measure the time taken for completing embedded-broker handshake (PW-Broker).
     */
    PerformanceEvents["BrokerHandhshake"] = "brokerHandshake";
    /**
     * acquireTokenByRefreshToken API in BrokerClientApplication (PW-Broker) .
     */
    PerformanceEvents["AcquireTokenByRefreshTokenInBroker"] = "acquireTokenByRefreshTokenInBroker";
    /**
     * Time taken for token acquisition by broker
     */
    PerformanceEvents["AcquireTokenByBroker"] = "acquireTokenByBroker";
    /**
     * Time spent on the network for refresh token acquisition
     */
    PerformanceEvents["RefreshTokenClientExecuteTokenRequest"] = "refreshTokenClientExecuteTokenRequest";
    /**
     * Time taken for acquiring refresh token , records RT size
     */
    PerformanceEvents["RefreshTokenClientAcquireToken"] = "refreshTokenClientAcquireToken";
    /**
     * Time taken for acquiring cached refresh token
     */
    PerformanceEvents["RefreshTokenClientAcquireTokenWithCachedRefreshToken"] = "refreshTokenClientAcquireTokenWithCachedRefreshToken";
    /**
     * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
     */
    PerformanceEvents["RefreshTokenClientAcquireTokenByRefreshToken"] = "refreshTokenClientAcquireTokenByRefreshToken";
    /**
     * Helper function to create token request body in RefreshTokenClient (msal-common).
     */
    PerformanceEvents["RefreshTokenClientCreateTokenRequestBody"] = "refreshTokenClientCreateTokenRequestBody";
    /**
     * acquireTokenFromCache (msal-browser).
     * Internal API for acquiring token from cache
     */
    PerformanceEvents["AcquireTokenFromCache"] = "acquireTokenFromCache";
    /**
     * acquireTokenBySilentIframe (msal-browser).
     * Internal API for acquiring token by silent Iframe
     */
    PerformanceEvents["AcquireTokenBySilentIframe"] = "acquireTokenBySilentIframe";
    /**
     * Internal API for initializing base request in BaseInteractionClient (msal-browser)
     */
    PerformanceEvents["InitializeBaseRequest"] = "initializeBaseRequest";
    /**
     * Internal API for initializing silent request in SilentCacheClient (msal-browser)
     */
    PerformanceEvents["InitializeSilentRequest"] = "initializeSilentRequest";
    PerformanceEvents["InitializeClientApplication"] = "initializeClientApplication";
    /**
     * Helper function in SilentIframeClient class (msal-browser).
     */
    PerformanceEvents["SilentIframeClientTokenHelper"] = "silentIframeClientTokenHelper";
    /**
     * SilentHandler
     */
    PerformanceEvents["SilentHandlerInitiateAuthRequest"] = "silentHandlerInitiateAuthRequest";
    PerformanceEvents["SilentHandlerMonitorIframeForHash"] = "silentHandlerMonitorIframeForHash";
    PerformanceEvents["SilentHandlerLoadFrame"] = "silentHandlerLoadFrame";
    /**
     * Helper functions in StandardInteractionClient class (msal-browser)
     */
    PerformanceEvents["StandardInteractionClientCreateAuthCodeClient"] = "standardInteractionClientCreateAuthCodeClient";
    PerformanceEvents["StandardInteractionClientGetClientConfiguration"] = "standardInteractionClientGetClientConfiguration";
    PerformanceEvents["StandardInteractionClientInitializeAuthorizationRequest"] = "standardInteractionClientInitializeAuthorizationRequest";
    PerformanceEvents["StandardInteractionClientInitializeAuthorizationCodeRequest"] = "standardInteractionClientInitializeAuthorizationCodeRequest";
    /**
     * getAuthCodeUrl API (msal-browser and msal-node).
     */
    PerformanceEvents["GetAuthCodeUrl"] = "getAuthCodeUrl";
    /**
     * Functions from InteractionHandler (msal-browser)
     */
    PerformanceEvents["HandleCodeResponseFromServer"] = "handleCodeResponseFromServer";
    PerformanceEvents["HandleCodeResponseFromHash"] = "handleCodeResponseFromHash";
    PerformanceEvents["UpdateTokenEndpointAuthority"] = "updateTokenEndpointAuthority";
    /**
     * APIs in Authorization Code Client (msal-common)
     */
    PerformanceEvents["AuthClientAcquireToken"] = "authClientAcquireToken";
    PerformanceEvents["AuthClientExecuteTokenRequest"] = "authClientExecuteTokenRequest";
    PerformanceEvents["AuthClientCreateTokenRequestBody"] = "authClientCreateTokenRequestBody";
    PerformanceEvents["AuthClientCreateQueryString"] = "authClientCreateQueryString";
    /**
     * Generate functions in PopTokenGenerator (msal-common)
     */
    PerformanceEvents["PopTokenGenerateCnf"] = "popTokenGenerateCnf";
    PerformanceEvents["PopTokenGenerateKid"] = "popTokenGenerateKid";
    /**
     * handleServerTokenResponse API in ResponseHandler (msal-common)
     */
    PerformanceEvents["HandleServerTokenResponse"] = "handleServerTokenResponse";
    /**
     * Authority functions
     */
    PerformanceEvents["AuthorityFactoryCreateDiscoveredInstance"] = "authorityFactoryCreateDiscoveredInstance";
    PerformanceEvents["AuthorityResolveEndpointsAsync"] = "authorityResolveEndpointsAsync";
    PerformanceEvents["AuthorityGetCloudDiscoveryMetadataFromNetwork"] = "authorityGetCloudDiscoveryMetadataFromNetwork";
    PerformanceEvents["AuthorityUpdateCloudDiscoveryMetadata"] = "authorityUpdateCloudDiscoveryMetadata";
    PerformanceEvents["AuthorityGetEndpointMetadataFromNetwork"] = "authorityGetEndpointMetadataFromNetwork";
    PerformanceEvents["AuthorityUpdateEndpointMetadata"] = "authorityUpdateEndpointMetadata";
    PerformanceEvents["AuthorityUpdateMetadataWithRegionalInformation"] = "authorityUpdateMetadataWithRegionalInformation";
    /**
     * Region Discovery functions
     */
    PerformanceEvents["RegionDiscoveryDetectRegion"] = "regionDiscoveryDetectRegion";
    PerformanceEvents["RegionDiscoveryGetRegionFromIMDS"] = "regionDiscoveryGetRegionFromIMDS";
    PerformanceEvents["RegionDiscoveryGetCurrentVersion"] = "regionDiscoveryGetCurrentVersion";
    PerformanceEvents["AcquireTokenByCodeAsync"] = "acquireTokenByCodeAsync";
    PerformanceEvents["GetEndpointMetadataFromNetwork"] = "getEndpointMetadataFromNetwork";
    PerformanceEvents["GetCloudDiscoveryMetadataFromNetworkMeasurement"] = "getCloudDiscoveryMetadataFromNetworkMeasurement";
    PerformanceEvents["HandleRedirectPromiseMeasurement"] = "handleRedirectPromiseMeasurement";
    PerformanceEvents["UpdateCloudDiscoveryMetadataMeasurement"] = "updateCloudDiscoveryMetadataMeasurement";
    PerformanceEvents["UsernamePasswordClientAcquireToken"] = "usernamePasswordClientAcquireToken";
    PerformanceEvents["NativeMessageHandlerHandshake"] = "nativeMessageHandlerHandshake";
    /**
     * Cache operations
     */
    PerformanceEvents["ClearTokensAndKeysWithClaims"] = "clearTokensAndKeysWithClaims";
})(PerformanceEvents || (PerformanceEvents = {}));
/**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */
var PerformanceEventStatus;
(function (PerformanceEventStatus) {
    PerformanceEventStatus[PerformanceEventStatus["NotStarted"] = 0] = "NotStarted";
    PerformanceEventStatus[PerformanceEventStatus["InProgress"] = 1] = "InProgress";
    PerformanceEventStatus[PerformanceEventStatus["Completed"] = 2] = "Completed";
})(PerformanceEventStatus || (PerformanceEventStatus = {}));
var IntFields = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "queuedTimeMs",
    "startTimeMs",
    "status",
]);


//# sourceMappingURL=PerformanceEvent.js.map


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(56)) {
  var LIBRARY = __webpack_require__(166);
  var global = __webpack_require__(34);
  var fails = __webpack_require__(37);
  var $export = __webpack_require__(3);
  var $typed = __webpack_require__(403);
  var $buffer = __webpack_require__(595);
  var ctx = __webpack_require__(108);
  var anInstance = __webpack_require__(195);
  var propertyDesc = __webpack_require__(189);
  var hide = __webpack_require__(92);
  var redefineAll = __webpack_require__(194);
  var toInteger = __webpack_require__(107);
  var toLength = __webpack_require__(55);
  var toIndex = __webpack_require__(1153);
  var toAbsoluteIndex = __webpack_require__(193);
  var toPrimitive = __webpack_require__(124);
  var has = __webpack_require__(99);
  var classof = __webpack_require__(230);
  var isObject = __webpack_require__(40);
  var toObject = __webpack_require__(64);
  var isArrayIter = __webpack_require__(512);
  var create = __webpack_require__(191);
  var getPrototypeOf = __webpack_require__(101);
  var gOPN = __webpack_require__(199).f;
  var getIterFn = __webpack_require__(514);
  var uid = __webpack_require__(190);
  var wks = __webpack_require__(52);
  var createArrayMethod = __webpack_require__(125);
  var createArrayIncludes = __webpack_require__(357);
  var speciesConstructor = __webpack_require__(288);
  var ArrayIterators = __webpack_require__(359);
  var Iterators = __webpack_require__(228);
  var $iterDetect = __webpack_require__(358);
  var setSpecies = __webpack_require__(197);
  var arrayFill = __webpack_require__(592);
  var arrayCopyWithin = __webpack_require__(1149);
  var $DP = __webpack_require__(61);
  var $GOPD = __webpack_require__(102);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(516);
var $export = __webpack_require__(3);
var shared = __webpack_require__(274)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(554))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(137);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Logger());

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(424),
    isLength = __webpack_require__(427);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(1299),
    baseEach = __webpack_require__(252),
    baseIteratee = __webpack_require__(139),
    baseReduce = __webpack_require__(772),
    isArray = __webpack_require__(62);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(760),
    baseIteratee = __webpack_require__(139),
    baseSome = __webpack_require__(1745),
    isArray = __webpack_require__(62),
    isIterateeCall = __webpack_require__(426);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Ripple = __webpack_require__(121);

var _Ripple2 = _interopRequireDefault(_Ripple);

var _theme = __webpack_require__(1772);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (options) {
  return (0, _Ripple2.default)(_extends({}, options, { theme: _theme2.default }));
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    { style: { overflow: 'scroll', marginTop: 4, height: 'calc(100vh - 165px ' + (props.extraHeight ? '- ' + props.extraHeight + 'px' : '') + ')' } },
    props.children
  );
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Component) {
  var IdComponent = function (_React$Component) {
    _inherits(IdComponent, _React$Component);

    function IdComponent() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, IdComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IdComponent.__proto__ || Object.getPrototypeOf(IdComponent)).call.apply(_ref, [this].concat(args))), _this), _this.componentId = Math.random().toString().slice(-12), _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(IdComponent, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { componentId: this.componentId }));
      }
    }]);

    return IdComponent;
  }(_react2.default.Component);

  IdComponent.displayName = 'ComponentId(' + Component.displayName + ')';
  return IdComponent;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/helpers/component-id.js

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _date_picker = __webpack_require__(354);

var _datePicker = __webpack_require__(2190);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = {
  months: _moment2.default.months(),
  monthsShort: _moment2.default.monthsShort(),
  weekdays: _moment2.default.weekdays(),
  weekdaysShort: _moment2.default.weekdaysShort(),
  weekdaysLetter: _moment2.default.weekdaysShort()
};
// src/web/components/date-picker.jsx

function _DatePicker(props) {
  var t = props.t,
      label = props.label,
      value = props.value,
      maxDate = props.maxDate,
      minDate = props.minDate,
      onChange = props.onChange,
      onDismiss = props.onDismiss,
      okLabel = props.okLabel,
      cancelLabel = props.cancelLabel,
      inputFormat = props.inputFormat,
      color = props.color;


  return _react2.default.createElement(_date_picker.DatePicker, { label: !value && label,
    autoOk: true,
    locale: locale,
    inputFormat: inputFormat || function (date) {
      return date && (0, _moment2.default)(date).format('LLLL') || '';
    },
    value: value,
    maxDate: maxDate,
    minDate: minDate,
    onChange: onChange,
    onDismiss: onDismiss,
    okLabel: okLabel || t('label:了解'),
    cancelLabel: cancelLabel || t('label:取り消し'),
    theme: _datePicker2.default,
    sundayFirstDayOfWeek: true,
    style: { color: color } });
}

exports.default = (0, _reactI18next.translate)()(_DatePicker);

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(52)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(92)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(190)('meta');
var isObject = __webpack_require__(40);
var has = __webpack_require__(99);
var setDesc = __webpack_require__(61).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(37)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(128);
var IE8_DOM_DEFINE = __webpack_require__(998);
var toPrimitive = __webpack_require__(538);
var dP = Object.defineProperty;

exports.f = __webpack_require__(149) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDiary = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary.jsx

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _reactCssThemr = __webpack_require__(10);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _diary3 = __webpack_require__(2507);

var _diary4 = _interopRequireDefault(_diary3);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _cardTitleRightActions = __webpack_require__(910);

var _cardTitleRightActions2 = _interopRequireDefault(_cardTitleRightActions);

var _infiniteScroller = __webpack_require__(75);

var _diaryTitle = __webpack_require__(2508);

var _diaryTitle2 = _interopRequireDefault(_diaryTitle);

var _diaryDropdownMenu = __webpack_require__(2509);

var _diaryDropdownMenu2 = _interopRequireDefault(_diaryDropdownMenu);

var _diaryTimestamp = __webpack_require__(238);

var _diaryTimestamp2 = _interopRequireDefault(_diaryTimestamp);

var _diaryUser = __webpack_require__(560);

var _diaryUser2 = _interopRequireDefault(_diaryUser);

var _diaryLikes = __webpack_require__(561);

var _diaryLikes2 = _interopRequireDefault(_diaryLikes);

var _diaryReaders = __webpack_require__(2511);

var _diaryReaders2 = _interopRequireDefault(_diaryReaders);

var _diaryMentionsBy = __webpack_require__(2512);

var _diaryMentionsBy2 = _interopRequireDefault(_diaryMentionsBy);

var _diaryMentionsTo = __webpack_require__(562);

var _diaryMentionsTo2 = _interopRequireDefault(_diaryMentionsTo);

var _diaryActions = __webpack_require__(563);

var _diaryActions2 = _interopRequireDefault(_diaryActions);

var _diaryCommentCount = __webpack_require__(1048);

var _diaryCommentCount2 = _interopRequireDefault(_diaryCommentCount);

var _diaryReportGraph = __webpack_require__(2518);

var _diaryReportGraph2 = _interopRequireDefault(_diaryReportGraph);

var _diaryReportActiveUserBar = __webpack_require__(2521);

var _diaryReportActiveUserBar2 = _interopRequireDefault(_diaryReportActiveUserBar);

var _diaryKpi = __webpack_require__(2523);

var _diaryKpi2 = _interopRequireDefault(_diaryKpi);

var _diaryContent = __webpack_require__(239);

var _diaryContent2 = _interopRequireDefault(_diaryContent);

var _diaryAttachments = __webpack_require__(566);

var _diaryAttachments2 = _interopRequireDefault(_diaryAttachments);

var _diaryFields = __webpack_require__(2536);

var _diaryFields2 = _interopRequireDefault(_diaryFields);

var _diaryComment = __webpack_require__(2538);

var _diaryComment2 = _interopRequireDefault(_diaryComment);

var _diaryCommentForm = __webpack_require__(568);

var _diaryCommentForm2 = _interopRequireDefault(_diaryCommentForm);

var _diaryV2ProgressChart = __webpack_require__(2544);

var _diaryV2ProgressChart2 = _interopRequireDefault(_diaryV2ProgressChart);

var _diaryCalendarData = __webpack_require__(2545);

var _diaryCalendarData2 = _interopRequireDefault(_diaryCalendarData);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _toggleButton = __webpack_require__(388);

var _toggleButton2 = _interopRequireDefault(_toggleButton);

var _reviewCard = __webpack_require__(1059);

var _reviewCard2 = _interopRequireDefault(_reviewCard);

var _i18n = __webpack_require__(173);

var _i18n2 = _interopRequireDefault(_i18n);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _diaryFormButton = __webpack_require__(290);

var _diaryFormButton2 = _interopRequireDefault(_diaryFormButton);

var _userIcon = __webpack_require__(2547);

var _userIcon2 = _interopRequireDefault(_userIcon);

var _newBadge = __webpack_require__(1060);

var _newBadge2 = _interopRequireDefault(_newBadge);

var _emoji = __webpack_require__(187);

var _emoji2 = _interopRequireDefault(_emoji);

var _urlRegexp = __webpack_require__(182);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_COMMENT_DISPLAY_COUNT = 3;

var assets = {
  icons: {
    success: __webpack_require__(472)
  }
};

function TimelineUserIcon(props) {
  var diary = props.diary;


  return _react2.default.createElement(
    'div',
    { className: 'newBadgeField', theme: _userIcon2.default },
    _react2.default.createElement('img', { className: 'newBadgeIcon', src: diary.user.icon_image.thumb_url }),
    _react2.default.createElement(_newBadge2.default, { created_at: diary.user.created_at })
  );
}
function TimelineReportIcon(props) {
  var diary = props.diary;


  return _react2.default.createElement(
    'div',
    { className: 'newBadgeField', theme: _userIcon2.default },
    _react2.default.createElement('img', { className: 'reportUserIcon', src: assets.icons.success }),
    _react2.default.createElement(_newBadge2.default, { created_at: diary.user.created_at })
  );
}

var Diary = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_PureComponent) {
  _inherits(Diary, _PureComponent);

  function Diary() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Diary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Diary.__proto__ || Object.getPrototypeOf(Diary)).call.apply(_ref, [this].concat(args))), _this), _this.state = { translated: undefined }, _this.onDeleteConfirm = function () {
      return _this.setState({ deleteConfirm: true });
    }, _this.onStamp = function () {
      var parent = _this.props.diary;
      _this.props.showStampPalette(function (code) {
        return _this.props.submitStamp(code, { parent: parent });
      });
    }, _this.onComment = function () {
      return _this.setState({ showCommentForm: true });
    }, _this.onCommentClose = function () {
      return _this.setState({ showCommentForm: false });
    }, _this.showAllComments = function () {
      return _this.setState({ showAllComments: !_this.state.showAllComments });
    }, _this.showAllKpis = function () {
      return _this.setState({ showAllKpis: !_this.state.showAllKpis });
    }, _this.onDeleteConfirmYes = function () {
      _this.setState({ deleteConfirm: false });_this.props.deleteDiary();
    }, _this.onDeleteConfirmNo = function () {
      return _this.setState({ deleteConfirm: false });
    }, _this.readDiary = _lodash2.default.throttle(function (visible) {
      return visible && _this.props.readDiary();
    }, 1000), _this.onUnBlockConfirm = function () {
      return _this.setState({ unblockConfirm: true });
    }, _this.onUnBlockConfirmYes = function () {
      _this.setState({ unblockConfirm: false });_this.props.updateBlockDiary(_this.props.diary, false);
    }, _this.onUnBlockConfirmNo = function () {
      return _this.setState({ unblockConfirm: false });
    }, _this.onShowTranslate = function () {
      var lang = _i18n2.default.language;
      var attach_json = _this.props.diary.attach_json && typeof _this.props.diary.attach_json == 'string' && JSON.parse(_this.props.diary.attach_json) || _this.props.diary.attach_json;
      var translated = attach_json && attach_json.translations && attach_json.translations[lang] || undefined;
      if (translated) _this.setState({ translated: translated });else _this.props.translateDiary();
    }, _this.onShowOriginal = function () {
      _this.setState({ translated: undefined });
    }, _this.onSendChatGPT = function () {
      _this.props.askGpt(_this.props.diary.content);
    }, _this.onOpenReview = function () {
      _this.props.onOpenReview();
      _this.props.setReviewTarget(_this.props.diary.diary_id);
    }, _this.onCloseReview = function () {
      _this.props.onCloseReview();
      _this.props.setReviewTarget(undefined);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Diary, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      var lang = _i18n2.default.language;
      var attach_json = this.props.diary.attach_json && typeof this.props.diary.attach_json == 'string' && JSON.parse(this.props.diary.attach_json) || this.props.diary.attach_json;
      var translated = attach_json && attach_json.translations && attach_json.translations[lang] || undefined;
      if (translated) this.setState({ translated: translated });
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var lang = _i18n2.default.language;
      var attach_json = this.props.diary.attach_json && typeof this.props.diary.attach_json == 'string' && JSON.parse(this.props.diary.attach_json) || this.props.diary.attach_json;
      var next_attach_json = nextProps.diary.attach_json && typeof nextProps.diary.attach_json == 'string' && JSON.parse(nextProps.diary.attach_json) || nextProps.diary.attach_json;
      var translated = attach_json && attach_json.translations && attach_json.translations[lang] || undefined;
      var nextTranslated = next_attach_json && next_attach_json.translations && next_attach_json.translations[lang] || undefined;
      if (translated != nextTranslated && nextTranslated) this.setState({ translated: nextTranslated });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          diary = _props.diary,
          searchHits = _props.searchHits,
          user = _props.user,
          isPhone = _props.isPhone,
          deleteDiary = _props.deleteDiary,
          editDiary = _props.editDiary,
          likeDiary = _props.likeDiary,
          reactionDiary = _props.reactionDiary,
          unlikeDiary = _props.unlikeDiary,
          pinDiary = _props.pinDiary,
          unpinDiary = _props.unpinDiary,
          pickupDiary = _props.pickupDiary,
          readDiary = _props.readDiary,
          showGroup = _props.showGroup,
          showUser = _props.showUser,
          showReaders = _props.showReaders,
          showAttachments = _props.showAttachments,
          isPickup = _props.isPickup,
          isLikeFetching = _props.isLikeFetching,
          access_token = _props.access_token,
          isAttachment = _props.isAttachment,
          showStampPalette = _props.showStampPalette,
          translateDiary = _props.translateDiary,
          isShowAllComments = _props.isShowAllComments,
          onReplyScrollFrom = _props.onReplyScrollFrom,
          openSidePage = _props.openSidePage,
          likeConfig = _props.likeConfig,
          showImagesView = _props.showImagesView,
          updateBlockDiary = _props.updateBlockDiary,
          blockUser = _props.blockUser,
          blockDiary = _props.blockDiary,
          isBlockDisable = _props.isBlockDisable,
          review = _props.review,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          reviewTarget = _props.reviewTarget,
          isReviewCompleted = _props.isReviewCompleted,
          query = _props.query,
          isReviewEnable = _props.isReviewEnable,
          isReviewButtonDisplay = _props.isReviewButtonDisplay,
          isShowTimeStamp = _props.isShowTimeStamp;


      var group = this.props.group || diary.group;
      var myself = diary && diary.user && diary.user.user_id == user.user_id;
      var like = diary.likes && _lodash2.default.find(diary.likes, function (like) {
        return like.user.user_id == user.user_id;
      });
      var pin = diary.pin;
      var read = diary.user.user_id == user.user_id || diary.readers && _lodash2.default.find(diary.readers, function (reader) {
        return reader.user.user_id == user.user_id;
      });
      var attach_json = diary.attach_json && typeof diary.attach_json == 'string' && JSON.parse(diary.attach_json) || diary.attach_json;
      var kpiDisplayCount = openSidePage ? 2 : 4;

      //ブロックされたユーザ・投稿の場合は中身を表示しないように
      if (!isBlockDisable && (blockUser || blockDiary)) return _react2.default.createElement('div', null);

      var timeLineIcon = null;
      var showUserAction = null;
      var diaryUserName = null;
      var isReportDiary = false;
      if (diary.category === 'report') {
        timeLineIcon = _react2.default.createElement(TimelineReportIcon, { diary: diary });
        diaryUserName = _react2.default.createElement(
          'span',
          { style: { fontSize: '14px', fontWeight: 'bold', color: '#000000', marginLeft: 3 } },
          'gamba!'
        );
        isReportDiary = true;
      } else {
        timeLineIcon = _react2.default.createElement(TimelineUserIcon, { diary: diary });
        showUserAction = showUser;
        diaryUserName = _react2.default.createElement(_diaryUser2.default, { key: 'user', user: diary.user, showUser: showUserAction });
      }

      return _react2.default.createElement(
        _card.Card,
        { theme: theme },
        pin && _react2.default.createElement(
          'div',
          { style: { marginTop: 15, marginLeft: 15 } },
          _react2.default.createElement('img', { src: _emoji2.default["1f4cc-pin"], style: { width: 25, height: 25, verticalAlign: 'top' } }),
          _react2.default.createElement(
            'span',
            { style: { fontSize: 16.5, marginLeft: 8, fontWeight: 'bold' } },
            t('label:ピン留めされた投稿')
          )
        ),
        blockDiary && _react2.default.createElement(
          'div',
          { style: { marginTop: 8 } },
          _react2.default.createElement(
            'span',
            { style: { marginLeft: 16 } },
            _react2.default.createElement(_font_icon2.default, { value: 'info', style: { color: 'gray', fontSize: 12 } })
          ),
          _react2.default.createElement(
            'span',
            { style: { fontSize: 11, marginLeft: 8, color: 'gray' } },
            t('label:投稿ブロックされています')
          )
        ),
        _react2.default.createElement(_cardTitleRightActions2.default, {
          avatar: timeLineIcon,
          onAvatarClick: showUserAction,
          title: _react2.default.createElement(_diaryTitle2.default, { diary: diary, showGroup: showGroup, unread: !read }),
          subtitle: [diaryUserName, isShowTimeStamp ? _react2.default.createElement(_diaryTimestamp2.default, { key: 'timestamp', timestamp: diary.created_at, updated: diary.updated_at }) : null, _react2.default.createElement(
            'span',
            { key: 'span', style: { fontSize: '12px' } },
            this.state.translated ? t('label:翻訳') : ''
          )],
          rightActions: [_react2.default.createElement(_diaryDropdownMenu2.default, { key: 'dropdown', diary: diary,
            access_token: access_token,
            group: group,
            user: user,
            translated: this.state.translated,
            onShowTranslate: this.onShowTranslate,
            onShowOriginal: this.onShowOriginal,
            deleteDiary: this.onDeleteConfirm,
            editDiary: editDiary,
            pin: pin,
            onPin: pin ? unpinDiary : pinDiary,
            updateBlockDiary: updateBlockDiary,
            onUnBlockConfirm: this.onUnBlockConfirm,
            blockDiary: blockDiary }), !isPhone && !isPickup && _react2.default.createElement(_button.IconButton, { key: 'pickup', icon: 'arrow_forward', onClick: pickupDiary })] }),
        attach_json && attach_json.kpi_status && _react2.default.createElement(
          _card.CardText,
          { theme: theme },
          _lodash2.default.map(attach_json.kpi_status.slice(0, !this.state.showAllKpis ? kpiDisplayCount : attach_json.kpi_status.length), function (kpi) {
            return _react2.default.createElement(_diaryKpi2.default, { kpi: kpi, group: group, key: kpi.kpi_id, showAllKpis: _this2.state.showAllKpis });
          })
        ),
        attach_json && attach_json.kpi_status && attach_json.kpi_status.length > kpiDisplayCount && _react2.default.createElement(
          _card.CardText,
          { theme: theme },
          _react2.default.createElement(_toggleButton2.default, {
            flag: !this.state.showAllKpis,
            className: 'fluid',
            trueLabel: '' + t('label:他n件のKPIをすべて表示', { n: attach_json.kpi_status.length - kpiDisplayCount }),
            falseLabel: t('label:隠す'),
            onClick: this.showAllKpis })
        ),
        _react2.default.createElement(_diaryV2ProgressChart2.default, { attach_json: attach_json }),
        _react2.default.createElement(_diaryContent2.default, { content: this.state.translated || diary.content, isPhone: isPhone, searchHits: searchHits, urlLinks: attach_json && attach_json.links }),
        _react2.default.createElement(_diaryFields2.default, { fields: attach_json && attach_json.fields, query: query }),
        _react2.default.createElement(_diaryCalendarData2.default, { attach_json: attach_json }),
        _react2.default.createElement(_diaryAttachments2.default, { diary_id: diary.diary_id, files: diary.files, showAttachments: showAttachments, showImagesView: showImagesView }),
        _react2.default.createElement(_diaryReportActiveUserBar2.default, { attach_json: attach_json, group: group, diary: diary, lang: this.props.i18n.language }),
        _react2.default.createElement(_diaryReportGraph2.default, { user: user, diary: diary, group: group, attach_json: attach_json }),
        _react2.default.createElement(
          _card.CardText,
          { theme: theme, className: 'interaction' },
          _react2.default.createElement(_diaryLikes2.default, { key: 'likes', myself: myself, likes: diary.likes, showReaders: showReaders, likes_count: diary.likes_count, likeConfig: likeConfig }),
          _react2.default.createElement(_diaryCommentCount2.default, { key: 'comments', myself: myself, comments: diary.comments, showReaders: showReaders }),
          _react2.default.createElement(_diaryMentionsBy2.default, { key: 'mentions', mentions: diary.mentions, showReaders: showReaders }),
          _react2.default.createElement(_diaryMentionsTo2.default, { key: 'mention_users', mentions: diary.mention_users, showReaders: showReaders }),
          _react2.default.createElement(_diaryReaders2.default, { key: 'readers', myself: myself, readers: diary.readers, showReaders: showReaders, readers_count: diary.readers_count })
        ),
        diary.diary_id == reviewTarget && this.props.isOpenReviewPanel && _react2.default.createElement(_reviewCard2.default, { t: t, theme: theme, isReviewCompleted: isReviewCompleted, onSendChatGPT: this.onSendChatGPT, onCloseReview: this.onCloseReview, review: review, isFetching: isFetching, isFetchFailed: isFetchFailed }),
        likeConfig && _react2.default.createElement(_diaryActions2.default, {
          like: like,
          onLike: !isLikeFetching && (like && unlikeDiary || likeDiary) || undefined,
          onReaction: reactionDiary,
          onComment: this.onComment,
          onStamp: this.onStamp,
          onOpenReview: this.onOpenReview,
          isFetching: isFetching,
          isReviewEnable: isReviewEnable && !isReportDiary,
          isReviewButtonDisplay: isReviewButtonDisplay,
          isComment: false,
          likeConfig: likeConfig }),
        !isShowAllComments && diary.comments && diary.comments.length > 3 && _react2.default.createElement(
          _card.CardText,
          { theme: theme },
          _react2.default.createElement(_toggleButton2.default, {
            flag: !this.state.showAllComments,
            className: 'fluid',
            trueLabel: '' + t('label:件のコメントをすべて表示', { count: diary.comments.length - DEFAULT_COMMENT_DISPLAY_COUNT }),
            falseLabel: t('label:コメントを隠す'),
            isAttachment: !this.state.showAllComments ? isAttachment : undefined,
            onClick: this.showAllComments })
        ),
        this.state.showCommentForm && _react2.default.createElement(_diaryCommentForm2.default, {
          diary: diary,
          group: group,
          user: user,
          parent: diary,
          onClose: this.onCommentClose }),
        diary.comments && diary.comments.length > 0 && _lodash2.default.map(diary.comments.slice(this.state.showAllComments || isShowAllComments ? 0 : -3), function (comment, i) {
          return _react2.default.createElement(_diaryComment2.default, { key: comment.comment_id,
            user: user,
            group: group,
            diary: diary,
            comment: comment,
            onReplyScrollFrom: onReplyScrollFrom,
            searchHits: searchHits,
            cont: comment.comment_id != diary.comments[diary.comments.length - 1].comment_id,
            isComment: true,
            isShowAllComments: isShowAllComments,
            likeConfig: likeConfig });
        }),
        !read && _react2.default.createElement(_infiniteScroller.InviewSensor, { onChange: this.readDiary }),
        _react2.default.createElement(_confirmDialog2.default, { open: this.state.deleteConfirm,
          title: t('label:日報を削除してもいいですか'),
          description: t('label:この操作は取り消せません'),
          yesLabel: t('label:削除'),
          noLabel: t('label:取り消し'),
          onYes: this.onDeleteConfirmYes,
          onNo: this.onDeleteConfirmNo }),
        _react2.default.createElement(_confirmDialog2.default, { key: 'confirm' + user.user_id,
          title: t('label:投稿のブロック解除'),
          description: t('label:投稿のブロック解除説明'),
          open: this.state.unblockConfirm,
          onYes: this.onUnBlockConfirmYes,
          onNo: this.onUnBlockConfirmNo,
          yesLabel: t('label:ブロック解除'),
          noLabel: t('label:取り消し') })
      );
    }
  }]);

  return Diary;
}(_pureComponent2.default)) || _class);
var RawDiary = exports.RawDiary = Diary;
exports.default = (0, _diary4.default)(Diary);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__network_FetchClient_js__ = __webpack_require__(2745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__network_XhrClient_js__ = __webpack_require__(2746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BrowserConstants_js__ = __webpack_require__(46);
/*! @azure/msal-browser v2.38.3 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Utility class for browser specific functions
 */
var BrowserUtils = /** @class */ (function () {
    function BrowserUtils() {
    }
    // #region Window Navigation and URL management
    /**
     * Clears hash from window url.
     */
    BrowserUtils.clearHash = function (contentWindow) {
        // Office.js sets history.replaceState to null
        contentWindow.location.hash = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
        if (typeof contentWindow.history.replaceState === "function") {
            // Full removes "#" from url
            contentWindow.history.replaceState(null, __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING, "" + contentWindow.location.origin + contentWindow.location.pathname + contentWindow.location.search);
        }
    };
    /**
     * Replaces current hash with hash from provided url
     */
    BrowserUtils.replaceHash = function (url) {
        var urlParts = url.split("#");
        urlParts.shift(); // Remove part before the hash
        window.location.hash = urlParts.length > 0 ? urlParts.join("#") : __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
    };
    /**
     * Returns boolean of whether the current window is in an iframe or not.
     */
    BrowserUtils.isInIframe = function () {
        return window.parent !== window;
    };
    /**
     * Returns boolean of whether or not the current window is a popup opened by msal
     */
    BrowserUtils.isInPopup = function () {
        return typeof window !== "undefined" && !!window.opener &&
            window.opener !== window &&
            typeof window.name === "string" &&
            window.name.indexOf(__WEBPACK_IMPORTED_MODULE_4__BrowserConstants_js__["c" /* BrowserConstants */].POPUP_NAME_PREFIX + ".") === 0;
    };
    // #endregion
    /**
     * Returns current window URL as redirect uri
     */
    BrowserUtils.getCurrentUri = function () {
        return window.location.href.split("?")[0].split("#")[0];
    };
    /**
     * Gets the homepage url for the current window location.
     */
    BrowserUtils.getHomepage = function () {
        var currentUrl = new __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["_2" /* UrlString */](window.location.href);
        var urlComponents = currentUrl.getUrlComponents();
        return urlComponents.Protocol + "//" + urlComponents.HostNameAndPort + "/";
    };
    /**
     * Returns best compatible network client object.
     */
    BrowserUtils.getBrowserNetworkClient = function () {
        if (window.fetch && window.Headers) {
            return new __WEBPACK_IMPORTED_MODULE_1__network_FetchClient_js__["a" /* FetchClient */]();
        }
        else {
            return new __WEBPACK_IMPORTED_MODULE_2__network_XhrClient_js__["a" /* XhrClient */]();
        }
    };
    /**
     * Throws error if we have completed an auth and are
     * attempting another auth request inside an iframe.
     */
    BrowserUtils.blockReloadInHiddenIframes = function () {
        var isResponseHash = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["_2" /* UrlString */].hashContainsKnownProperties(window.location.hash);
        // return an error if called from the hidden iframe created by the msal js silent calls
        if (isResponseHash && BrowserUtils.isInIframe()) {
            throw __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createBlockReloadInHiddenIframeError();
        }
    };
    /**
     * Block redirect operations in iframes unless explicitly allowed
     * @param interactionType Interaction type for the request
     * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
     */
    BrowserUtils.blockRedirectInIframe = function (interactionType, allowRedirectInIframe) {
        var isIframedApp = BrowserUtils.isInIframe();
        if (interactionType === __WEBPACK_IMPORTED_MODULE_4__BrowserConstants_js__["l" /* InteractionType */].Redirect && isIframedApp && !allowRedirectInIframe) {
            // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
            throw __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createRedirectInIframeError(isIframedApp);
        }
    };
    /**
     * Block redirectUri loaded in popup from calling AcquireToken APIs
     */
    BrowserUtils.blockAcquireTokenInPopups = function () {
        // Popups opened by msal popup APIs are given a name that starts with "msal."
        if (BrowserUtils.isInPopup()) {
            throw __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createBlockAcquireTokenInPopupsError();
        }
    };
    /**
     * Throws error if token requests are made in non-browser environment
     * @param isBrowserEnvironment Flag indicating if environment is a browser.
     */
    BrowserUtils.blockNonBrowserEnvironment = function (isBrowserEnvironment) {
        if (!isBrowserEnvironment) {
            throw __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNonBrowserEnvironmentError();
        }
    };
    /**
     * Throws error if native brokering is enabled but initialize hasn't been called
     * @param allowNativeBroker
     * @param initialized
     */
    BrowserUtils.blockNativeBrokerCalledBeforeInitialized = function (allowNativeBroker, initialized) {
        if (allowNativeBroker && !initialized) {
            throw __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNativeBrokerCalledBeforeInitialize();
        }
    };
    /**
     * Returns boolean of whether current browser is an Internet Explorer or Edge browser.
     */
    BrowserUtils.detectIEOrEdge = function () {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        var msie11 = ua.indexOf("Trident/");
        var msedge = ua.indexOf("Edge/");
        var isIE = msie > 0 || msie11 > 0;
        var isEdge = msedge > 0;
        return isIE || isEdge;
    };
    return BrowserUtils;
}());


//# sourceMappingURL=BrowserUtils.js.map


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18next = __webpack_require__(1234);

var _i18next2 = _interopRequireDefault(_i18next);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _messageJa = __webpack_require__(1245);

var _messageJa2 = _interopRequireDefault(_messageJa);

var _messageEn = __webpack_require__(1246);

var _messageEn2 = _interopRequireDefault(_messageEn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/i18n/index.js

function initializeLang(lang) {
  switch (lang) {
    case 'ja':
      _messageJa2.default.initialize();
      break;
    case 'en':
    default:
      _messageEn2.default.initialize();
      break;
  }
}

_i18next2.default.init({
  lng: 'ja',
  fallbackLng: 'en',
  resources: {
    ja: _messageJa2.default,
    en: _messageEn2.default
  },
  react: {
    wait: true
  },
  ns: ['default'],
  defaultNS: 'default',
  appendNamespaceToMissingKey: true,
  interpolation: {
    format: function format(value, _format, lng) {
      if (_format === 'date') {
        var lastYear = (0, _moment2.default)().subtract(1, 'year').year();
        var reportedYear = (0, _moment2.default)(value).year();
        return (0, _moment2.default)(value).format(reportedYear > lastYear ? 'llll' : 'LLLL');
      }
      if (_format === 'datetime') return (0, _moment2.default)(value).format('LLLL HH:mm:ss');
      if (_format === 'fromNow') {
        var lastHalfYear = (0, _moment2.default)().subtract(6, 'month');
        var yesterday = (0, _moment2.default)().subtract(1, 'day');
        if (lastHalfYear.isAfter(value)) return (0, _moment2.default)(value).format('LLLL');else if (yesterday.isAfter(value)) return (0, _moment2.default)(value).format('llll');else return (0, _moment2.default)(value).format('l');
      } else return value;
    }
  }
});

_i18next2.default.on('initialized', initializeLang);
_i18next2.default.on('languageChanged', initializeLang);

exports.default = _i18next2.default;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(217),
    getRawTag = __webpack_require__(1275),
    objectToString = __webpack_require__(1276);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1286),
    getValue = __webpack_require__(1289);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1355),
    getValue = __webpack_require__(1360);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_USER_MENU_ITEMS_FAILED = exports.UPDATE_USER_MENU_ITEMS_COMPLETED = exports.UPDATE_USER_MENU_ITEMS_REQUESTED = exports.SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED = exports.SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED = exports.SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED = exports.SAVE_ANNOUNCE_LAST_SEEN_TIME = exports.REQUEST_CONFIRMATION_MAIL_FAILED = exports.REQUEST_CONFIRMATION_MAIL_COMPLETED = exports.REQUEST_CONFIRMATION_MAIL_REQUESTED = exports.REQUEST_CONFIRMATION_MAIL = exports.UPDATE_EMAIL_FAILED = exports.UPDATE_EMAIL_COMPLETED = exports.UPDATE_EMAIL_REQUESTED = exports.UPDATE_EMAIL = exports.UPDATE_PASSWORD_FAILED = exports.UPDATE_PASSWORD_COMPLETED = exports.UPDATE_PASSWORD_REQUESTED = exports.UPDATE_PASSWORD = exports.UPDATE_USER_PROFILE_FAILED = exports.UPDATE_USER_PROFILE_COMPLETED = exports.UPDATE_USER_PROFILE_REQUESTED = exports.UPDATE_USER_PROFILE = exports.FETCH_CURRENT_USER_FAILED = exports.FETCH_CURRENT_USER_COMPLETED = exports.FETCH_CURRENT_USER_REQUESTED = exports.FETCH_CURRENT_USER = exports.UPDATE_CUSTOM_SCHEDULE_FAILED = exports.UPDATE_CUSTOM_SCHEDULE_COMPLETED = exports.UPDATE_CUSTOM_SCHEDULE_REQUESTED = exports.UPDATE_CUSTOM_SCHEDULE = exports.UPDATE_DAY_SCHEDULE_FAILED = exports.UPDATE_DAY_SCHEDULE_COMPLETED = exports.UPDATE_DAY_SCHEDULE_REQUESTED = exports.UPDATE_DAY_SCHEDULE = exports.UPDATE_SCHEDULE_ACTIVE_FAILED = exports.UPDATE_SCHEDULE_ACTIVE_COMPLETED = exports.UPDATE_SCHEDULE_ACTIVE_REQUESTED = exports.UPDATE_SCHEDULE_ACTIVE = exports.UPDATE_SCHEDULE_TYPE_FAILED = exports.UPDATE_SCHEDULE_TYPE_COMPLETED = exports.UPDATE_SCHEDULE_TYPE_REQUESTED = exports.UPDATE_SCHEDULE_TYPE = exports.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED = exports.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED = exports.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED = exports.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS = exports.UPDATE_NOTIFICATION_SETTINGS_FAILED = exports.UPDATE_NOTIFICATION_SETTINGS_COMPLETED = exports.UPDATE_NOTIFICATION_SETTINGS_REQUESTED = exports.UPDATE_NOTIFICATION_SETTINGS = exports.FETCH_NOTIFICATION_SETTINGS_FAILED = exports.FETCH_NOTIFICATION_SETTINGS_COMPLETED = exports.FETCH_NOTIFICATION_SETTINGS_REQUESTED = exports.FETCH_NOTIFICATION_SETTINGS = undefined;
exports.fetchNotificationSettingsRequested = fetchNotificationSettingsRequested;
exports.fetchNotificationSettings = fetchNotificationSettings;
exports.fetchNotificationSettingsCompleted = fetchNotificationSettingsCompleted;
exports.fetchNotificationSettingsFailed = fetchNotificationSettingsFailed;
exports.updateNotificationSettingsRequested = updateNotificationSettingsRequested;
exports.updateNotificationSettings = updateNotificationSettings;
exports.updateNotificationSettingsCompleted = updateNotificationSettingsCompleted;
exports.updateNotificationSettingsFailed = updateNotificationSettingsFailed;
exports.updateNotificationCollectiveSettingsRequested = updateNotificationCollectiveSettingsRequested;
exports.updateNotificationCollectiveSetting = updateNotificationCollectiveSetting;
exports.updateNotificationCollectiveSettingsCompleted = updateNotificationCollectiveSettingsCompleted;
exports.updateNotificationCollectiveSettingsFailed = updateNotificationCollectiveSettingsFailed;
exports.updateScheduleTypeRequested = updateScheduleTypeRequested;
exports.updateScheduleType = updateScheduleType;
exports.updateScheduleTypeCompleted = updateScheduleTypeCompleted;
exports.updateScheduleTypeFailed = updateScheduleTypeFailed;
exports.updateScheduleActiveRequested = updateScheduleActiveRequested;
exports.updateScheduleActive = updateScheduleActive;
exports.updateScheduleActiveCompleted = updateScheduleActiveCompleted;
exports.updateScheduleActiveFailed = updateScheduleActiveFailed;
exports.updateDayScheduleRequested = updateDayScheduleRequested;
exports.updateDaySchedule = updateDaySchedule;
exports.updateDayScheduleCompleted = updateDayScheduleCompleted;
exports.updateDayScheduleFailed = updateDayScheduleFailed;
exports.updateCustomScheduleRequested = updateCustomScheduleRequested;
exports.updateCustomSchedule = updateCustomSchedule;
exports.updateCustomScheduleCompleted = updateCustomScheduleCompleted;
exports.updateCustomScheduleFailed = updateCustomScheduleFailed;
exports.fetchCurrentUserRequested = fetchCurrentUserRequested;
exports.fetchCurrentUser = fetchCurrentUser;
exports.fetchCurrentUserCompleted = fetchCurrentUserCompleted;
exports.fetchCurrentUserFailed = fetchCurrentUserFailed;
exports.updateUserProfileRequested = updateUserProfileRequested;
exports.updateUserProfile = updateUserProfile;
exports.updateUserProfileCompleted = updateUserProfileCompleted;
exports.updateUserProfileFailed = updateUserProfileFailed;
exports.updatePasswordRequested = updatePasswordRequested;
exports.updatePassword = updatePassword;
exports.updatePasswordCompleted = updatePasswordCompleted;
exports.updatePasswordFailed = updatePasswordFailed;
exports.updateEmailRequested = updateEmailRequested;
exports.updateEmail = updateEmail;
exports.updateEmailCompleted = updateEmailCompleted;
exports.updateEmailFailed = updateEmailFailed;
exports.requestConfirmationMailRequested = requestConfirmationMailRequested;
exports.requestConfirmationMail = requestConfirmationMail;
exports.requestConfirmationMailCompleted = requestConfirmationMailCompleted;
exports.requestConfirmationMailFailed = requestConfirmationMailFailed;
exports.saveAnnounceLastSeenTimeRequested = saveAnnounceLastSeenTimeRequested;
exports.saveAnnounceLastSeenTime = saveAnnounceLastSeenTime;
exports.saveAnnounceLastSeenTimeCompleted = saveAnnounceLastSeenTimeCompleted;
exports.saveAnnounceLastSeenTimeFailed = saveAnnounceLastSeenTimeFailed;
exports.updateUserMenuItemsRequested = updateUserMenuItemsRequested;
exports.updateUserMenuItems = updateUserMenuItems;
exports.updateUserMenuItemsCompleted = updateUserMenuItemsCompleted;
exports.updateUserMenuItemsFailed = updateUserMenuItemsFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _accessToken = __webpack_require__(220);

var _accessToken2 = _interopRequireDefault(_accessToken);

var _alertMessage = __webpack_require__(13);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/user.js

var FETCH_NOTIFICATION_SETTINGS = exports.FETCH_NOTIFICATION_SETTINGS = "FETCH_NOTIFICATION_SETTINGS";
var FETCH_NOTIFICATION_SETTINGS_REQUESTED = exports.FETCH_NOTIFICATION_SETTINGS_REQUESTED = "FETCH_NOTIFICATION_SETTINGS_REQUESTED";
var FETCH_NOTIFICATION_SETTINGS_COMPLETED = exports.FETCH_NOTIFICATION_SETTINGS_COMPLETED = "FETCH_NOTIFICATION_SETTINGS_COMPLETED";
var FETCH_NOTIFICATION_SETTINGS_FAILED = exports.FETCH_NOTIFICATION_SETTINGS_FAILED = "FETCH_NOTIFICATION_SETTINGS_FAILED";

function fetchNotificationSettingsRequested() {
  return {
    type: FETCH_NOTIFICATION_SETTINGS_REQUESTED
  };
}

function fetchNotificationSettings() {
  return function (dispatch) {
    dispatch(fetchNotificationSettingsRequested());
    return _gambaApi2.default.get('/notification_settings').then(function (results) {
      dispatch(fetchNotificationSettingsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchNotificationSettingsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchNotificationSettingsCompleted(results) {
  return {
    type: FETCH_NOTIFICATION_SETTINGS_COMPLETED,
    results: results
  };
}

function fetchNotificationSettingsFailed(error) {
  return {
    type: FETCH_NOTIFICATION_SETTINGS_FAILED,
    error: error
  };
}

var UPDATE_NOTIFICATION_SETTINGS = exports.UPDATE_NOTIFICATION_SETTINGS = "UPDATE_NOTIFICATION_SETTINGS";
var UPDATE_NOTIFICATION_SETTINGS_REQUESTED = exports.UPDATE_NOTIFICATION_SETTINGS_REQUESTED = "UPDATE_NOTIFICATION_SETTINGS_REQUESTED";
var UPDATE_NOTIFICATION_SETTINGS_COMPLETED = exports.UPDATE_NOTIFICATION_SETTINGS_COMPLETED = "UPDATE_NOTIFICATION_SETTINGS_COMPLETED";
var UPDATE_NOTIFICATION_SETTINGS_FAILED = exports.UPDATE_NOTIFICATION_SETTINGS_FAILED = "UPDATE_NOTIFICATION_SETTINGS_FAILED";

function updateNotificationSettingsRequested() {
  return {
    type: UPDATE_NOTIFICATION_SETTINGS_REQUESTED
  };
}

function updateNotificationSettings(target_type, notification_type, notification_media) {
  var group_id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

  return function (dispatch) {
    dispatch(updateNotificationSettingsRequested());
    return _gambaApi2.default.put('/notification_settings', { target_type: target_type, notification_type: notification_type, notification_media: notification_media, group_id: group_id }).then(function (results) {
      dispatch(updateNotificationSettingsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateNotificationSettingsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateNotificationSettingsCompleted(results) {
  return {
    type: UPDATE_NOTIFICATION_SETTINGS_COMPLETED,
    results: results
  };
}

function updateNotificationSettingsFailed(error) {
  return {
    type: UPDATE_NOTIFICATION_SETTINGS_FAILED,
    error: error
  };
}

var UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS = exports.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS = "UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS";
var UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED = exports.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED = "UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED";
var UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED = exports.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED = "UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED";
var UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED = exports.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED = "UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED";

function updateNotificationCollectiveSettingsRequested() {
  return {
    type: UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED
  };
}

function updateNotificationCollectiveSetting(media_type, notify_all) {
  return function (dispatch) {
    dispatch(updateNotificationCollectiveSettingsRequested());
    return _gambaApi2.default.put('/notification_settings/updateAll', { media_type: media_type, notify_all: notify_all }).then(function (results) {
      dispatch(updateNotificationCollectiveSettingsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateNotificationCollectiveSettingsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateNotificationCollectiveSettingsCompleted(results) {
  return {
    type: UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED,
    results: results
  };
}

function updateNotificationCollectiveSettingsFailed(error) {
  return {
    type: UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED,
    error: error
  };
}

var UPDATE_SCHEDULE_TYPE = exports.UPDATE_SCHEDULE_TYPE = "UPDATE_SCHEDULE_TYPE";
var UPDATE_SCHEDULE_TYPE_REQUESTED = exports.UPDATE_SCHEDULE_TYPE_REQUESTED = "UPDATE_SCHEDULE_TYPE_REQUESTED";
var UPDATE_SCHEDULE_TYPE_COMPLETED = exports.UPDATE_SCHEDULE_TYPE_COMPLETED = "UPDATE_SCHEDULE_TYPE_COMPLETED";
var UPDATE_SCHEDULE_TYPE_FAILED = exports.UPDATE_SCHEDULE_TYPE_FAILED = "UPDATE_SCHEDULE_TYPE_FAILED";

function updateScheduleTypeRequested() {
  return {
    type: UPDATE_SCHEDULE_TYPE_REQUESTED
  };
}

function updateScheduleType(schedule_type) {
  return function (dispatch) {
    dispatch(updateScheduleTypeRequested());
    return _gambaApi2.default.put('/notification_settings/schedule_type', { schedule_type: schedule_type }).then(function (results) {
      dispatch(updateScheduleTypeCompleted(results));
      dispatch(_actions2.default.fetchCurrentUser());
    }).catch(function (error) {
      Promise.all([dispatch(updateScheduleTypeFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateScheduleTypeCompleted(results) {
  return {
    type: UPDATE_SCHEDULE_TYPE_COMPLETED,
    results: results
  };
}

function updateScheduleTypeFailed(error) {
  return {
    type: UPDATE_SCHEDULE_TYPE_FAILED,
    error: error
  };
}

var UPDATE_SCHEDULE_ACTIVE = exports.UPDATE_SCHEDULE_ACTIVE = "UPDATE_SCHEDULE_ACTIVE";
var UPDATE_SCHEDULE_ACTIVE_REQUESTED = exports.UPDATE_SCHEDULE_ACTIVE_REQUESTED = "UPDATE_SCHEDULE_ACTIVE_REQUESTED";
var UPDATE_SCHEDULE_ACTIVE_COMPLETED = exports.UPDATE_SCHEDULE_ACTIVE_COMPLETED = "UPDATE_SCHEDULE_ACTIVE_COMPLETED";
var UPDATE_SCHEDULE_ACTIVE_FAILED = exports.UPDATE_SCHEDULE_ACTIVE_FAILED = "UPDATE_SCHEDULE_ACTIVE_FAILED";

function updateScheduleActiveRequested() {
  return {
    type: UPDATE_SCHEDULE_ACTIVE_REQUESTED
  };
}

function updateScheduleActive(schedule_active) {
  return function (dispatch) {
    dispatch(updateScheduleActiveRequested());
    return _gambaApi2.default.put('/notification_settings/schedule_active', { schedule_active: schedule_active }).then(function (results) {
      dispatch(updateScheduleActiveCompleted(results));
      dispatch(_actions2.default.fetchCurrentUser());
    }).catch(function (error) {
      Promise.all([dispatch(updateScheduleActiveFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateScheduleActiveCompleted(results) {
  return {
    type: UPDATE_SCHEDULE_ACTIVE_COMPLETED,
    results: results
  };
}

function updateScheduleActiveFailed(error) {
  return {
    type: UPDATE_SCHEDULE_ACTIVE_FAILED,
    error: error
  };
}

var UPDATE_DAY_SCHEDULE = exports.UPDATE_DAY_SCHEDULE = "UPDATE_DAY_SCHEDULE";
var UPDATE_DAY_SCHEDULE_REQUESTED = exports.UPDATE_DAY_SCHEDULE_REQUESTED = "UPDATE_DAY_SCHEDULE_REQUESTED";
var UPDATE_DAY_SCHEDULE_COMPLETED = exports.UPDATE_DAY_SCHEDULE_COMPLETED = "UPDATE_DAY_SCHEDULE_COMPLETED";
var UPDATE_DAY_SCHEDULE_FAILED = exports.UPDATE_DAY_SCHEDULE_FAILED = "UPDATE_DAY_SCHEDULE_FAILED";

function updateDayScheduleRequested() {
  return {
    type: UPDATE_DAY_SCHEDULE_REQUESTED
  };
}

function updateDaySchedule(schedule_type, time_type, time_value) {
  return function (dispatch) {
    dispatch(updateDayScheduleRequested());
    return _gambaApi2.default.put('/notification_settings/day_schedule', { schedule_type: schedule_type, time_type: time_type, time_value: time_value }).then(function (results) {
      dispatch(updateDayScheduleCompleted(results));
      dispatch(_actions2.default.fetchCurrentUser());
    }).catch(function (error) {
      Promise.all([dispatch(updateDayScheduleFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateDayScheduleCompleted(results) {
  return {
    type: UPDATE_DAY_SCHEDULE_COMPLETED,
    results: results
  };
}

function updateDayScheduleFailed(error) {
  return {
    type: UPDATE_DAY_SCHEDULE_FAILED,
    error: error
  };
}

var UPDATE_CUSTOM_SCHEDULE = exports.UPDATE_CUSTOM_SCHEDULE = "UPDATE_CUSTOM_SCHEDULE";
var UPDATE_CUSTOM_SCHEDULE_REQUESTED = exports.UPDATE_CUSTOM_SCHEDULE_REQUESTED = "UPDATE_CUSTOM_SCHEDULE_REQUESTED";
var UPDATE_CUSTOM_SCHEDULE_COMPLETED = exports.UPDATE_CUSTOM_SCHEDULE_COMPLETED = "UPDATE_CUSTOM_SCHEDULE_COMPLETED";
var UPDATE_CUSTOM_SCHEDULE_FAILED = exports.UPDATE_CUSTOM_SCHEDULE_FAILED = "UPDATE_CUSTOM_SCHEDULE_FAILED";

function updateCustomScheduleRequested() {
  return {
    type: UPDATE_CUSTOM_SCHEDULE_REQUESTED
  };
}

function updateCustomSchedule(day_of_week, time_type, time_value) {
  return function (dispatch) {
    dispatch(updateCustomScheduleRequested());
    return _gambaApi2.default.put('/notification_settings/custom_schedule', { day_of_week: day_of_week, time_type: time_type, time_value: time_value }).then(function (results) {
      dispatch(updateCustomScheduleCompleted(results));
      dispatch(_actions2.default.fetchCurrentUser());
    }).catch(function (error) {
      Promise.all([dispatch(updateCustomScheduleFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateCustomScheduleCompleted(results) {
  return {
    type: UPDATE_CUSTOM_SCHEDULE_COMPLETED,
    results: results
  };
}

function updateCustomScheduleFailed(error) {
  return {
    type: UPDATE_CUSTOM_SCHEDULE_FAILED,
    error: error
  };
}

var FETCH_CURRENT_USER = exports.FETCH_CURRENT_USER = "FETCH_CURRENT_USER";
var FETCH_CURRENT_USER_REQUESTED = exports.FETCH_CURRENT_USER_REQUESTED = "FETCH_CURRENT_USER_REQUESTED";
var FETCH_CURRENT_USER_COMPLETED = exports.FETCH_CURRENT_USER_COMPLETED = "FETCH_CURRENT_USER_COMPLETED";
var FETCH_CURRENT_USER_FAILED = exports.FETCH_CURRENT_USER_FAILED = "FETCH_CURRENT_USER_FAILED";

function fetchCurrentUserRequested() {
  return {
    type: FETCH_CURRENT_USER_REQUESTED
  };
}

function fetchCurrentUser() {
  return function (dispatch) {
    dispatch(fetchCurrentUserRequested());
    return _gambaApi2.default.get('/user').then(function (results) {
      dispatch(fetchCurrentUserCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchCurrentUserFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchCurrentUserCompleted(results) {
  return {
    type: FETCH_CURRENT_USER_COMPLETED,
    results: results
  };
}

function fetchCurrentUserFailed(error) {
  return {
    type: FETCH_CURRENT_USER_FAILED,
    error: error
  };
}

var UPDATE_USER_PROFILE = exports.UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
var UPDATE_USER_PROFILE_REQUESTED = exports.UPDATE_USER_PROFILE_REQUESTED = "UPDATE_USER_PROFILE_REQUESTED";
var UPDATE_USER_PROFILE_COMPLETED = exports.UPDATE_USER_PROFILE_COMPLETED = "UPDATE_USER_PROFILE_COMPLETED";
var UPDATE_USER_PROFILE_FAILED = exports.UPDATE_USER_PROFILE_FAILED = "UPDATE_USER_PROFILE_FAILED";

function updateUserProfileRequested() {
  return {
    type: UPDATE_USER_PROFILE_REQUESTED
  };
}

function updateUserProfile(name, uploadable_file_id, employment_number, department_id, birthday, is_update_birthday, crop, description) {
  return function (dispatch) {
    dispatch(updateUserProfileRequested());
    return _gambaApi2.default.put('/user', { name: name, uploadable_file_id: uploadable_file_id, employment_number: employment_number, department_id: department_id, birthday: birthday, is_update_birthday: is_update_birthday, crop: crop, description: description }).then(function (results) {
      dispatch(updateUserProfileCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateUserProfileFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateUserProfileCompleted(results) {
  return {
    type: UPDATE_USER_PROFILE_COMPLETED,
    results: results
  };
}

function updateUserProfileFailed(error) {
  return {
    type: UPDATE_USER_PROFILE_FAILED,
    error: error
  };
}

var UPDATE_PASSWORD = exports.UPDATE_PASSWORD = "UPDATE_PASSWORD";
var UPDATE_PASSWORD_REQUESTED = exports.UPDATE_PASSWORD_REQUESTED = "UPDATE_PASSWORD_REQUESTED";
var UPDATE_PASSWORD_COMPLETED = exports.UPDATE_PASSWORD_COMPLETED = "UPDATE_PASSWORD_COMPLETED";
var UPDATE_PASSWORD_FAILED = exports.UPDATE_PASSWORD_FAILED = "UPDATE_PASSWORD_FAILED";

function updatePasswordRequested() {
  return {
    type: UPDATE_PASSWORD_REQUESTED
  };
}

function updatePassword(current_password, password, password_confirmation) {
  return function (dispatch) {
    dispatch(updatePasswordRequested());
    return _gambaApi2.default.put('/user/password', { current_password: current_password, password: password, password_confirmation: password_confirmation }).then(function (results) {
      _accessToken2.default.set(results.access_token, function () {
        return dispatch(updatePasswordCompleted(results));
      });
    }).catch(function (error) {
      Promise.all([dispatch(updatePasswordFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updatePasswordCompleted(results) {
  return {
    type: UPDATE_PASSWORD_COMPLETED,
    results: results
  };
}

function updatePasswordFailed(error) {
  return {
    type: UPDATE_PASSWORD_FAILED,
    error: error
  };
}

var UPDATE_EMAIL = exports.UPDATE_EMAIL = "UPDATE_EMAIL";
var UPDATE_EMAIL_REQUESTED = exports.UPDATE_EMAIL_REQUESTED = "UPDATE_EMAIL_REQUESTED";
var UPDATE_EMAIL_COMPLETED = exports.UPDATE_EMAIL_COMPLETED = "UPDATE_EMAIL_COMPLETED";
var UPDATE_EMAIL_FAILED = exports.UPDATE_EMAIL_FAILED = "UPDATE_EMAIL_FAILED";

function updateEmailRequested() {
  return {
    type: UPDATE_EMAIL_REQUESTED
  };
}

function updateEmail(email) {
  return function (dispatch) {
    dispatch(updateEmailRequested());
    return _gambaApi2.default.put('/user/email', { email: email }).then(function (results) {
      dispatch(updateEmailCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateEmailFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateEmailCompleted(results) {
  return {
    type: UPDATE_EMAIL_COMPLETED,
    results: results
  };
}

function updateEmailFailed(error) {
  return {
    type: UPDATE_EMAIL_FAILED,
    error: error
  };
}

var REQUEST_CONFIRMATION_MAIL = exports.REQUEST_CONFIRMATION_MAIL = "REQUEST_CONFIRMATION_MAIL";
var REQUEST_CONFIRMATION_MAIL_REQUESTED = exports.REQUEST_CONFIRMATION_MAIL_REQUESTED = "REQUEST_CONFIRMATION_MAIL_REQUESTED";
var REQUEST_CONFIRMATION_MAIL_COMPLETED = exports.REQUEST_CONFIRMATION_MAIL_COMPLETED = "REQUEST_CONFIRMATION_MAIL_COMPLETED";
var REQUEST_CONFIRMATION_MAIL_FAILED = exports.REQUEST_CONFIRMATION_MAIL_FAILED = "REQUEST_CONFIRMATION_MAIL_FAILED";

function requestConfirmationMailRequested() {
  return {
    type: REQUEST_CONFIRMATION_MAIL_REQUESTED
  };
}

function requestConfirmationMail() {
  return function (dispatch) {
    dispatch(requestConfirmationMailRequested());
    return _gambaApi2.default.get('/user/resend_confirmation').then(function (results) {
      dispatch(requestConfirmationMailCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(requestConfirmationMailFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function requestConfirmationMailCompleted(results) {
  return {
    type: REQUEST_CONFIRMATION_MAIL_COMPLETED,
    results: results
  };
}

function requestConfirmationMailFailed(error) {
  return {
    type: REQUEST_CONFIRMATION_MAIL_FAILED,
    error: error
  };
}

var SAVE_ANNOUNCE_LAST_SEEN_TIME = exports.SAVE_ANNOUNCE_LAST_SEEN_TIME = "SAVE_ANNOUNCE_LAST_SEEN_TIME";
var SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED = exports.SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED = "SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED";
var SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED = exports.SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED = "SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED";
var SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED = exports.SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED = "SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED";

function saveAnnounceLastSeenTimeRequested() {
  return {
    type: SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED
  };
}

function saveAnnounceLastSeenTime(announce_last_seen_at) {
  return function (dispatch) {
    dispatch(saveAnnounceLastSeenTimeRequested());
    return _gambaApi2.default.put('/announce/announce_last_seen_at', { announce_last_seen_at: announce_last_seen_at }).then(function (results) {
      dispatch(saveAnnounceLastSeenTimeCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(saveAnnounceLastSeenTimeFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function saveAnnounceLastSeenTimeCompleted(results) {
  return {
    type: SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED,
    results: results
  };
}

function saveAnnounceLastSeenTimeFailed(error) {
  return {
    type: SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED,
    error: error
  };
}

var UPDATE_USER_MENU_ITEMS_REQUESTED = exports.UPDATE_USER_MENU_ITEMS_REQUESTED = "UPDATE_USER_MENU_ITEMS_REQUESTED";
var UPDATE_USER_MENU_ITEMS_COMPLETED = exports.UPDATE_USER_MENU_ITEMS_COMPLETED = "UPDATE_USER_MENU_ITEMS_COMPLETED";
var UPDATE_USER_MENU_ITEMS_FAILED = exports.UPDATE_USER_MENU_ITEMS_FAILED = "UPDATE_USER_MENU_ITEMS_FAILED";

function updateUserMenuItemsRequested() {
  return {
    type: UPDATE_USER_MENU_ITEMS_REQUESTED
  };
}

function updateUserMenuItems(menuItems) {
  return function (dispatch) {
    dispatch(updateUserMenuItemsRequested());
    return _gambaApi2.default.put('/user/menu_items', { menu_items: menuItems }).then(function (results) {
      dispatch(updateUserMenuItemsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateUserMenuItemsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateUserMenuItemsCompleted(results) {
  return {
    type: UPDATE_USER_MENU_ITEMS_COMPLETED,
    results: results
  };
}

function updateUserMenuItemsFailed(error) {
  return {
    type: UPDATE_USER_MENU_ITEMS_FAILED,
    error: error
  };
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _input = __webpack_require__(59);

var _input2 = _interopRequireDefault(_input);

var _compactInput = __webpack_require__(909);

var _compactInput2 = _interopRequireDefault(_compactInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/compact-input.jsx

var CompactInput = function (_React$Component) {
  _inherits(CompactInput, _React$Component);

  function CompactInput() {
    _classCallCheck(this, CompactInput);

    return _possibleConstructorReturn(this, (CompactInput.__proto__ || Object.getPrototypeOf(CompactInput)).apply(this, arguments));
  }

  _createClass(CompactInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hasFocus = _props.hasFocus,
          props = _objectWithoutProperties(_props, ['hasFocus']);

      return _react2.default.createElement(_input2.default, _extends({ ref: 'input' }, props, { autoFocus: hasFocus, theme: _compactInput2.default }));
    }
  }]);

  return CompactInput;
}(_react2.default.Component);

exports.default = CompactInput;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (files, dispatch, id, type, componentId) {
  var singleImage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  if (!Object.prototype.toString.call(files).match(/File/)) return;

  if (singleImage) {
    if (!files[0].type.match(/^image/)) return;
  }

  for (var i = 0; singleImage && i < 1 || !singleImage && files[i]; i++) {
    var file = files[i];
    if (file.type && file.type.match(/^(video|audio)/)) {
      var _id = type == 'user' ? undefined : id;
      dispatch(_actions2.default.uploadVideo(_id, file.name, file.type.match(/^video/) ? 'video' : 'audio', file, componentId));
    } else {
      dispatch(_actions2.default.uploadFile(id, type, file, componentId, singleImage));
    }
  }
};

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _button = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/file-upload-button.jsx

var FileUploadButton = function (_React$Component) {
  _inherits(FileUploadButton, _React$Component);

  function FileUploadButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FileUploadButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileUploadButton.__proto__ || Object.getPrototypeOf(FileUploadButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      return _reactDom2.default.findDOMNode(_this.refs.input).click();
    }, _this.onChange = function (e) {
      if (e.target.files.length > 0) {
        _this.props.onChange(e.target.files);
        _reactDom2.default.findDOMNode(_this.refs.input).value = '';
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FileUploadButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _button.Button,
        _extends({}, this.props, { onClick: this.onClick }),
        _react2.default.createElement('input', { type: 'file', style: { display: 'none' },
          ref: 'input',
          multiple: !this.props.single,
          onChange: this.onChange })
      );
    }
  }]);

  return FileUploadButton;
}(_react2.default.Component);

exports.default = FileUploadButton;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/rich-text-editor.js

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(4);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _squireRte = __webpack_require__(1920);

var _squireRte2 = _interopRequireDefault(_squireRte);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _reactCssThemr = __webpack_require__(10);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _analytics = __webpack_require__(27);

var _emojiHelpers = __webpack_require__(146);

var _sanitizeHtml = __webpack_require__(1922);

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

var _googleDoc = __webpack_require__(269);

var _googleDoc2 = _interopRequireDefault(_googleDoc);

var _gambaUrl = __webpack_require__(350);

var _gambaUrl2 = _interopRequireDefault(_gambaUrl);

var _urlRegexp = __webpack_require__(182);

var _navigation = __webpack_require__(147);

var _button = __webpack_require__(8);

var _richTextEditorTemplateSelectionDialog = __webpack_require__(1929);

var _richTextEditorTemplateSelectionDialog2 = _interopRequireDefault(_richTextEditorTemplateSelectionDialog);

var _richTextEditorToolbarNavigation = __webpack_require__(1930);

var _richTextEditorToolbarNavigation2 = _interopRequireDefault(_richTextEditorToolbarNavigation);

var _richTextEditor = __webpack_require__(1932);

var _richTextEditor2 = _interopRequireDefault(_richTextEditor);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _richTextEditorIframeHtml = __webpack_require__(1935);

var _richTextEditorIframeHtml2 = _interopRequireDefault(_richTextEditorIframeHtml);

var _animationCss = __webpack_require__(184);

var _animationCss2 = _interopRequireDefault(_animationCss);

var _parseAttributes = __webpack_require__(1963);

var _parseAttributes2 = _interopRequireDefault(_parseAttributes);

var _purgeHtml = __webpack_require__(1964);

var _purgeHtml2 = _interopRequireDefault(_purgeHtml);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UrlRegex = (0, _urlRegexp.urlRegex)();
var DEFAULT_HEIGHT_TEXT_EDITOR = 88;

function toggleFormat(format, editor) {
  switch (format) {
    case 'bold':
      if (editor.hasFormat('B')) editor.removeAllFormatting();else editor.bold();
      break;

    case 'italic':
      if (editor.hasFormat('I')) editor.removeAllFormatting();else editor.italic();
      break;

    case 'underline':
      if (editor.hasFormat('U')) editor.removeAllFormatting();else editor.underline();
      break;

    case 'redText':
      if (editor.hasFormat('SPAN', { style: "color:rgb(255,0,0)" })) editor.removeAllFormatting();else editor.setTextColour('rgb(255,0,0)');
      break;

    case 'highlightText':
      if (editor.hasFormat('SPAN', { style: "background:rgb(255,255,119)" }) || editor.hasFormat('SPAN', { style: "background-color:rgb(255,255,119)" })) editor.removeAllFormatting();else editor.setHighlightColour('rgb(255,255,119)');
      break;

    case 'unorderedList':
      if (editor.hasFormat('UL')) editor.removeList();else editor.makeUnorderedList();
      break;

    case 'orderedList':
      if (editor.hasFormat('OL')) editor.removeList();else editor.makeOrderedList();
      break;
  }
}

function selectTemplate(template_id) {
  var templateHistory = JSON.parse(localStorage.getItem('gambaApp.templateHistory') || '[]');
  var index = _lodash2.default.findIndex(templateHistory, function (item) {
    return item.template_id == template_id;
  });
  if (index >= 0) templateHistory.splice(index, 1);
  templateHistory.unshift({ template_id: template_id, used_at: new Date().getTime() });
  localStorage.setItem('gambaApp.templateHistory', JSON.stringify(templateHistory));
}

function sortTemplates(templates) {
  var templateHistory = JSON.parse(localStorage.getItem('gambaApp.templateHistory') || '[]');
  var sortedTemplates = _lodash2.default.sortBy(_lodash2.default.map(templates, function (template) {
    var history = _lodash2.default.find(templateHistory, function (item) {
      return item.template_id == template.template_id;
    });
    if (history) return Object.assign({}, template, { used_at: history.used_at });else return Object.assign({}, template, { used_at: 0 });
  }), ['used_at']).reverse();
  return sortedTemplates;
}

var RichTextEditor = (_dec = (0, _reactCssThemr.themr)('RichTextEditor', _richTextEditor2.default), _dec(_class = function (_PureComponent) {
  _inherits(RichTextEditor, _PureComponent);

  function RichTextEditor(props) {
    _classCallCheck(this, RichTextEditor);

    var _this = _possibleConstructorReturn(this, (RichTextEditor.__proto__ || Object.getPrototypeOf(RichTextEditor)).call(this, props));

    _this.state = {};

    _this.insertEmoji = function (shortname, unicode) {
      if (_this.props.ui.editor) {
        _this.props.ui.editor.insertImage('' + _config2.default.emojiPNG + unicode + '.png', { style: "width: 18px; height: 18px;" });
      }
    };

    _this.getValue = function (callback) {
      var no_strip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // Return if Editor is not initialized or getHTML is not a function
      if (!_this.props.ui || !_this.props.ui.editor || typeof _this.props.ui.editor.getHTML !== 'function') {
        return;
      }
      var html = (0, _emojiHelpers.encodeEmojiTag)(_this.props.ui.editor.getHTML()).replace(/&nbsp;/g, ' ').replace(/class="colour"/g, '').replace(/class="highlight"/g, '').replace(/<a([^>]*)>.*?<\/a>/g, function (match, attr) {
        var attrs = (0, _parseAttributes2.default)(attr.trim());
        var href = attrs && attrs['href'] || '';
        return href.replace(/^mailto:/, '') + ' ';
      }).replace(/<input[^>]*>/g, function (tag) {
        // HTML中にinputタグがあった場合valueを正しく設定する
        var attrs = (0, _parseAttributes2.default)(tag.slice('<input'.length, tag.length - 1).trim());
        var element = _this.props.ui.body.ownerDocument.getElementById(attrs['id']);
        delete attrs['contenteditable'];
        if (element) {
          if (element.type == 'checkbox') {
            delete attrs['value'];
            delete attrs['checked'];
            attrs['disabled'] = 'true';
            if (element.checked) attrs['checked'] = 'true';
          }
          delete attrs['id'];
          return '<input ' + _lodash2.default.map(attrs, function (val, key) {
            return key + '="' + val + '"';
          }).join(' ') + '>';
        } else return '';
      }).replace(/<span contenteditable="false">(<input[^>]*>)<\/span>/g, '$1');

      if (!no_strip) html = html.replace(/^(<(div|p)>(<br\/?>)?<\/(div|p)>)+/, '').replace(/(<(div|p)>(<br\/?>)?<\/(div|p)>)+$/, '');

      if (html.length > 0 && !html.match(/^<.*>$/i)) html = '<div>' + html + '</div>';

      callback && callback(html);
    };

    _this.clearValue = function () {
      _this.props.ui.editor.setHTML('');
      _this.props.ui.editor.blur();
      _this.props.updateUI({ focus: false });
      _this.resetIframe();
    };

    _this.insertValue = function (html) {
      var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      _this.props.ui.editor && _this.props.ui.editor[reset ? 'setHTML' : 'insertHTML']((0, _purgeHtml2.default)((0, _emojiHelpers.convertEmojiHTML)(html.replace(UrlRegex, function (match) {
        _this.props.onAddLink && _this.props.onAddLink(match);
        return _this.props.showGoogleDoc && (0, _googleDoc2.default)(match) && '<a contenteditable=false target="_blank" rel="noopener noreferrer" class="googleDoc" href="' + match + '">' + _this.props.t('label:Googleドキュメント') + '</a>' || _this.props.showGambaUrl && (0, _gambaUrl2.default)(match) && '<a contenteditable=false href="' + match + '" target="_blank" rel="noopener noreferrer" class="gambaUrl">' + _this.props.t('label:gambaで開く') + '</a>' || '<a contenteditable=false target="_blank" rel="noopener noreferrer" href="' + (match.match(/^http/i) ? match : 'http://' + match) + '">' + (match.length > 80 ? match.slice(0, 30) + '...' + match.slice(match.length - 20, match.length) : match) + '</a>';
      }))));
      if (_this.refs.iframe) {
        var scrollHeight = _this.props.ui.body && _this.props.ui.body.scrollHeight || DEFAULT_HEIGHT_TEXT_EDITOR;
        _reactDom2.default.findDOMNode(_this.refs.iframe).style.height = scrollHeight + 5 + 'px';
      }
      _this.setGoogleDocHrefHandler();
      _this.setGabmaHrefHandler();
      _this.props.updateUI({ focus: true });
      _this.props.onFocus && _this.props.onFocus();
    };

    _this.setGoogleDocHrefHandler = function () {
      if (!_this.props.showGoogleDoc || !_this.props.ui.body) return;
      _lodash2.default.each(_reactDom2.default.findDOMNode(_this.props.ui.body).getElementsByClassName('googleDoc'), function (element) {
        if (element.onclick) return;
        element.onclick = function (event) {
          event.preventDefault();
          _this.props.showGoogleDoc(element.href);
        };
      });
    };

    _this.setGabmaHrefHandler = function () {
      if (!_this.props.showGambaUrl || !_this.props.ui.body) return;
      _lodash2.default.each(_reactDom2.default.findDOMNode(_this.props.ui.body).getElementsByClassName('gambaUrl'), function (element) {
        if (element.onclick) return;
        element.onclick = function (event) {
          event.preventDefault();
          _this.props.showGambaUrl(element.href);
        };
      });
    };

    _this.setFocus = function () {
      _this.props.ui.editor.focus();
      _this.props.updateUI({ focus: true });
      _this.props.onFocus && _this.props.onFocus();
    };

    _this.onDrop = function (e) {
      e.preventDefault && e.preventDefault();
      _this.props.updateUI({ dragEnter: false });
      _this.props.onDrop && _this.props.onDrop(e.dataTransfer.files);
      return false;
    };

    _this.onDragEnter = function () {
      return _this.props.updateUI({ dragEnter: true });
    };

    _this.onDragLeave = function () {
      return _this.props.updateUI({ dragEnter: false });
    };

    _this.onLoadIframe = function () {
      var iframe = _reactDom2.default.findDOMNode(_this.refs.iframe);
      _this.initSquireEditor(iframe.contentWindow.document);
      var body = iframe.contentWindow.document.getElementsByTagName('body')[0];
      body.ondragenter = function () {
        return _this.props.updateUI({ dragEnter: true });
      };
      body.ondragleave = function () {
        return _this.props.updateUI({ dragEnter: false });
      };
      body.ondrop = _this.onDrop;
      body.onclick = function () {
        if (!_this.props.ui.focus) {
          _this.props.updateUI({ focus: true });
          _this.props.onFocus && _this.props.onFocus();
        }
      };
    };

    _this.initIframe = function () {
      if (_this.refs.iframe) {
        _reactDom2.default.findDOMNode(_this.refs.iframe).style.height = '100px';
        var idoc = _reactDom2.default.findDOMNode(_this.refs.iframe).contentWindow.document;
        idoc.open();
        idoc.write(_richTextEditorIframeHtml2.default);
        idoc.close();
      }
    };

    _this.resetIframe = function () {
      if (_this.refs.iframe) {
        _reactDom2.default.findDOMNode(_this.refs.iframe).style.height = '100px';
      }
    };

    _this.initSquireEditor = function (doc) {
      var maxScrollHeight = DEFAULT_HEIGHT_TEXT_EDITOR;
      var editor = new _squireRte2.default(doc, {
        sanitizeToDOMFragment: _sanitizeHtml2.default,
        tagAttributes: {
          a: { contenteditable: false, target: '_blank', rel: "noopener noreferrer" }
        }
      });
      _this.props.updateUI({ editor: editor, body: doc.getElementsByTagName('body') && doc.getElementsByTagName('body')[0] || doc });

      editor.addEventListener('focus', function () {
        _this.props.updateUI({ focus: true });
        _this.props.onFocus && _this.props.onFocus();
      });
      editor.addEventListener('input', function () {
        if (_this.refs.iframe) {
          var iframe = _reactDom2.default.findDOMNode(_this.refs.iframe);
          var currentScrollHeight = _this.props.ui.body && _this.props.ui.body.scrollHeight || DEFAULT_HEIGHT_TEXT_EDITOR;
          var iframeDoc = iframe.contentWindow.document;

          // Update maxScrollHeight if the current is larger
          if (currentScrollHeight > maxScrollHeight) {
            maxScrollHeight = currentScrollHeight;
          }

          iframe.style.height = maxScrollHeight + 5 + 'px';
          if (iframeDoc) {
            if (maxScrollHeight > 300) {
              iframeDoc.body.style.overflowY = "auto";
            } else {
              iframeDoc.body.style.overflowY = "hidden";
            }
          }
        }
        _this.props.onChange && _this.props.onChange();
      });
      editor.addEventListener('addLink', function (event) {
        return _this.props.onAddLink(event.link);
      });
      editor.addEventListener('paste', function (event) {
        var text = (event.clipboardData || window.clipboardData).getData('text');
        if (text) text.replace(UrlRegex, function (_match) {
          return _this.props.onAddLink(_match);
        });
      });

      _this.props.hasFocus && editor.focus();
      _this.props.onEditorInitialized && _this.props.onEditorInitialized({
        getValue: _this.getValue,
        clearValue: _this.clearValue,
        insertValue: _this.insertValue
      });
    };

    _this.showTemplateDialog = function () {
      _this.props.updateUI({ showTemplateDialog: true });
      (0, _analytics.track)('show_templates');
    };

    _this.importDialog = function () {
      return _this.props.updateUI({ importConfirm: !_this.props.ui.importConfirm });
    };

    _this.importUserProfileTemplate = function () {
      _this.props.updateUI({ importConfirm: !_this.props.ui.importConfirm });
      _this.props.importUserProfileTemplate();
    };

    _this.clearUserProfileTemplate = function () {
      _this.props.updateUI({ importConfirm: !_this.props.ui.importConfirm });
      _this.props.clearUserProfileTemplate();
    };

    _this.insertCheckbox = function () {
      _this.insertValue('<input type="checkbox">&#x200B;');
      _this.props.ui.editor.focus();
    };

    _this.hideTemplateDialog = function () {
      return _this.props.updateUI({ showTemplateDialog: false });
    };

    _this.editDialogRef = function (c) {
      return _this.editDialog = c;
    };

    _this.inputDialogRef = function (c) {
      return _this.inputDialog = c;
    };

    if (!_this.props.noToolbar) {
      if (!_this.props.compact) {
        _this.actions = [{ icon: 'format_bold', onClick: function onClick() {
            return toggleFormat('bold', _this.props.ui.editor);
          }, style: { color: 'white' } }, { icon: 'format_underline', onClick: function onClick() {
            return toggleFormat('underline', _this.props.ui.editor);
          }, style: { color: 'white' } }, { icon: 'format_italic', onClick: function onClick() {
            return toggleFormat('italic', _this.props.ui.editor);
          }, style: { color: 'white' } }, { icon: 'format_color_text', onClick: function onClick() {
            return toggleFormat('redText', _this.props.ui.editor);
          }, style: { color: 'red' } }, { icon: 'format_color_text', onClick: function onClick() {
            return toggleFormat('highlightText', _this.props.ui.editor);
          }, style: { color: '#FF0' } }, { icon: 'format_list_bulleted', onClick: function onClick() {
            return toggleFormat('unorderedList', _this.props.ui.editor);
          }, style: { color: 'white' } }, { icon: 'format_list_numbered', onClick: function onClick() {
            return toggleFormat('orderedList', _this.props.ui.editor);
          }, style: { color: 'white' } }, { icon: 'check_box', onClick: _this.insertCheckbox, style: { color: 'white' } }, { icon: 'sentiment_satisfied', onClick: function onClick() {
            return _this.props.showEmojiPalette(_this.insertEmoji);
          }, style: { color: 'white' } }];
      } else _this.actions = [{ icon: 'format_bold', onClick: function onClick() {
          return toggleFormat('bold', _this.props.ui.editor);
        }, style: { color: 'white' } }, { icon: 'format_bold', onClick: function onClick() {
          return toggleFormat('redText', _this.props.ui.editor);
        }, style: { color: 'red' } }, { icon: 'format_color_text', onClick: function onClick() {
          return toggleFormat('highlightText', _this.props.ui.editor);
        }, style: { color: '#FF0' } }, { icon: 'sentiment_satisfied', onClick: function onClick() {
          return _this.props.showEmojiPalette(_this.insertEmoji);
        }, style: { color: 'white' } }];
      if (_this.props.templates) _this.actions.push({ label: _this.props.t('label:テンプレート'), onClick: function onClick() {
          return props.updateUI({ showTemplateDialog: true });
        }, style: { color: 'white', fontWeight: 'bold', fontSize: 12 } });
      if (_this.props.userDescription) _this.actions.push({ label: _this.props.t('label:テンプレート'), onClick: function onClick() {
          props.updateUI({ importConfirm: !_this.props.ui.importConfirm });props.importUserProfileTemplate();
        }, style: { color: 'white', fontWeight: 'bold', fontSize: 12 } });
    }
    return _this;
  }

  _createClass(RichTextEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initIframe();
      this.refs.editor && this.initSquireEditor(_reactDom2.default.findDOMNode(this.refs.editor));
      if (this.refs.iframe) {
        _reactDom2.default.findDOMNode(this.refs.iframe).style.height = '100px';
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.ui.editor && delete this.props.ui.editor;
    }
  }, {
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps) {
      if (this.actions && !this.props.templates && nextProps.templates && !_lodash2.default.some(this.actions, function (action) {
        return action.label == 'テンプレート';
      })) this.actions.push({ label: this.props.t('label:テンプレート'), onClick: function onClick() {
          return nextProps.updateUI({ showTemplateDialog: true });
        }, style: { color: 'white', fontWeight: 'bold', fontSize: 12 } });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          value = _props.value,
          compact = _props.compact,
          theme = _props.theme,
          templates = _props.templates,
          templateActions = _props.templateActions,
          noToolbar = _props.noToolbar,
          onFocus = _props.onFocus,
          onTemplateSelect = _props.onTemplateSelect,
          onEditorInitialized = _props.onEditorInitialized,
          onDrop = _props.onDrop,
          placeholder = _props.placeholder,
          updateUI = _props.updateUI,
          showEmojiPalette = _props.showEmojiPalette,
          blinking = _props.blinking,
          editTemplate = _props.editTemplate,
          category = _props.category,
          chatMessage = _props.chatMessage,
          userDescription = _props.userDescription,
          importUserProfileTemplate = _props.importUserProfileTemplate,
          userProfileTemplate = _props.userProfileTemplate,
          clearUserProfileTemplate = _props.clearUserProfileTemplate;


      return _react2.default.createElement(
        'div',
        { onDrop: this.onDrop,
          onDragEnter: this.onDragEnter,
          onDragLeave: this.onDragLeave,
          style: { position: 'relative' } },
        ui.focus && this.actions && _react2.default.createElement(_navigation.Navigation, { type: 'horizontal', theme: _richTextEditorToolbarNavigation2.default, actions: this.actions }),
        _react2.default.createElement('iframe', _extends({ ref: 'iframe', scrolling: chatMessage ? 'auto' : 'no'
        }, (0, _animationCss2.default)(blinking && !ui.focus, {
          from: { borderColor: '#CCC', borderLeftWidth: 1, borderRightWidth: 1 },
          to: { borderColor: '#3399FF', borderLeftWidth: 3, borderRightWidth: 3 }
        }), {
          className: (0, _classnames2.default)(chatMessage ? 'chat_message' : '', theme.editor, ui.focus && this.actions && theme.withToolbar, ui.dragEnter && theme.dragEntered),
          onLoad: this.onLoadIframe,
          style: { width: '100%' } })),
        !ui.focus && !value && placeholder && _react2.default.createElement(
          'div',
          { onClick: this.setFocus,
            style: {
              position: 'absolute',
              top: 0, left: 0,
              padding: '10px',
              color: 'rgba(0,0,0,0.5)'
            } },
          placeholder
        ),
        templates && !ui.focus && !value && _react2.default.createElement(_button.Button, _extends({ raised: true, primary: true, icon: 'mode_edit'
        }, (0, _animationCss2.default)(blinking, {
          duration: '0.5s',
          delay: '3s',
          iterationCount: 2
        }), {
          onClick: this.showTemplateDialog,
          label: t('diary:' + category + '\u3092\u66F8\u304F'),
          style: {
            position: 'absolute',
            top: 0, bottom: 0, left: 0, right: 0,
            margin: 'auto',
            width: '340px'
          } })),
        userDescription && !ui.focus && !value && _react2.default.createElement(_button.Button, _extends({ raised: true, primary: true, icon: 'mode_edit'
        }, (0, _animationCss2.default)(blinking, {
          duration: '0.5s',
          delay: '3s',
          iterationCount: 2
        }), {
          onClick: this.importUserProfileTemplate,
          label: t('label:\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3092\u767B\u9332\u3059\u308B'),
          style: {
            position: 'absolute',
            top: 0, bottom: 0, left: 0, right: 0,
            margin: 'auto',
            width: '360px'
          } })),
        _react2.default.createElement(_richTextEditorTemplateSelectionDialog2.default, {
          active: ui.showTemplateDialog,
          onClose: this.hideTemplateDialog,
          onSelect: function onSelect(id, name, template, fields) {
            selectTemplate(id);
            _this2.insertValue(template);
            onTemplateSelect && onTemplateSelect(name, fields, id);
          },
          templates: sortTemplates(templates),
          actions: templateActions }),
        _react2.default.createElement(_confirmDialog2.default, {
          open: ui.importConfirm,
          title: t('label:プロフィールテンプレート'),
          yesLabel: t('label:OK'),
          noLabel: t('label:取り消し'),
          onNo: this.clearUserProfileTemplate,
          onYes: function onYes() {
            updateUI({ importConfirm: !ui.importConfirm });
            userProfileTemplate && _this2.insertValue(userProfileTemplate.template);
          }
        })
      );
    }
  }]);

  return RichTextEditor;
}(_pureComponent2.default)) || _class);
exports.default = (0, _reactI18next.translate)()((0, _uiState2.default)({
  state: {
    editor: undefined,
    body: undefined,
    focus: function focus(props) {
      return props.hasFocus;
    },
    dragEnter: false,
    showTemplateDialog: false,
    importConfirm: false
  } })((0, _context2.default)({ showEmojiPalette: _propTypes.PropTypes.func })(RichTextEditor)));

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlRegex = urlRegex;
exports.textUrl = textUrl;

// src/helpers/url-regexp.js

function urlRegex(opts) {
  opts = opts || {};

  var protocol = '(?:(?:(http|https|ftp|mailto)+:)?//)';
  var auth = '(?:[^/\\s"\'()<>{}\\[\\]]+(?::[^/\\s"\'()<>{}\\[\\]]*)?@)?';
  var host = '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)';
  var domain = '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*';
  var tld = '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?';
  var port = '(?::\\d{2,5})?';
  var path = '(?:[/?#][^\\s"\'()<>{}\\[\\]]*)?';
  var phonenumber = '0[-0-9]{9,16}';
  var email = '(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})';
  var regex = ['(?:' + protocol + '|www\\.)' + auth, '(?:localhost|' + host + domain + tld + ')', port, path].join('');
  if (opts.phoneNumber) regex = '(' + regex + '|' + phonenumber + ')';
  if (opts.email) regex = '(' + regex + '|' + email + ')';

  return opts.exact ? new RegExp('(?:^' + regex + '$)', 'i') : new RegExp(regex, 'ig');
};

function textUrl(value) {
  var match = void 0;
  var matchObj = {};
  var count = 0;
  var regex = urlRegex(value);

  while ((match = value.match(regex)) != null) {
    count += 1;
    matchObj['[' + count + ']'] = match[0];
    value = value.replace(match[0], '[' + count + ']');
  }
  var keys = Object.keys(matchObj);
  keys.forEach(function (key) {
    value = value.replace(key, ',' + matchObj[key] + ',');
  });

  var fieldsValueText_split = value.split(',');
  return fieldsValueText_split;
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Link = __webpack_require__(914);

var _theme = __webpack_require__(1925);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedLink = (0, _reactCssThemr.themr)(_identifiers.LINK, _theme2.default)(_Link.Link);

exports.default = ThemedLink;
exports.Link = ThemedLink;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (animate) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _opts$from = opts.from,
      from = _opts$from === undefined ? { opacity: 1 } : _opts$from,
      _opts$to = opts.to,
      to = _opts$to === undefined ? { opacity: 0.3 } : _opts$to,
      _opts$duration = opts.duration,
      duration = _opts$duration === undefined ? '1.5s' : _opts$duration,
      _opts$delay = opts.delay,
      delay = _opts$delay === undefined ? 0 : _opts$delay,
      _opts$iterationCount = opts.iterationCount,
      iterationCount = _opts$iterationCount === undefined ? 'infinite' : _opts$iterationCount;


  if (!animate) return undefined;

  return (0, _glamor.css)({
    animationName: '' + _glamor.css.keyframes({ '0%, 100%': from, '50%': to }),
    animationDuration: duration,
    animationDelay: delay,
    animationIterationCount: iterationCount
  });
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _glamor = __webpack_require__(915);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(351);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(148);
util.inherits = __webpack_require__(87);
/*</replacement>*/

var Readable = __webpack_require__(924);
var Writable = __webpack_require__(497);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Effect = undefined;

var _NotificationBadge = __webpack_require__(2006);

var _NotificationBadge2 = _interopRequireDefault(_NotificationBadge);

var _Effect = __webpack_require__(930);

var _Effect2 = _interopRequireDefault(_Effect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NotificationBadge2.default;
exports.Effect = _Effect2.default;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _$2122$2195$2196$;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var baseURL="https://gamba-v1-devel.s3.ap-northeast-1.amazonaws.com/emoji/";exports.default=(_$2122$2195$2196$={"2139":baseURL+"2139.png","2122":baseURL+"2122.png","2195":baseURL+"2195.png","2196":baseURL+"2196.png","2198":baseURL+"2198.png","2197":baseURL+"2197.png","2199":baseURL+"2199.png","2049":baseURL+"2049.png","2328":baseURL+"2328.png","2602":"data:image/png;base64,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","2601":"data:image/png;base64,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","2194":baseURL+"2194.png","2614":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAwGSURBVHic7Zt7cFzVfcc/595d7a5e1molv+SHkLGELbCNbYyNsfADQ+rCtA2DMpRx3LS4pAzgGtp4Cm0Se0qmhnYaSBhmUtqMS8pDbTNNhjgBB4xfsmXZxi9ZxriykfBLz11J+9DuvefXP9aW9djVW2gy1ffMGa3uvb/v73e+v3PPPefcXRjHOH6n8WCVlK6ukkeHaq9GMpivGr/3ueTe7eZsAKy9IYqPFqnGwXIYIxXMurPy+rIqyR4pvoFgXgovz0kjO9/FxCKTvxsKx4gIsPG8/Mn8dJ6a6+GHI8E3EEw9IjMK3ayfYIDXAdkOnuSQTBssz7AFWFYuniUT+KfZbsh3s375CVk6XM6BQMMGr4lpA4YCU+EyLNYPlmfYArgm8FSRg+xMRzwTXhdbh8s5EARjPOy3oUlDuw2tNmj4g8HyDFsAE/7MrYB4FjAUazko+cPl7Q9tNoUnwnAhApc64FIEgKLB8gxPgP1SFNbMqbPiWWi3oc1CYfPQQMwf37hp44LiezZ2PfZAtbyyrFw8AzBv/6AFzgTjtSoIQNtgm+AYrEE3CIUXI3AsBGlOqI/Gs8EAM6GU5KFu5uBPa+SbuU7+6koKxkF4vh/zHWeDvBC0wRK4Evf71mCb0EuAov2S0QQ03qsGombb5Q7Y3wbTXHEBzoXixwcbyLJy8SxL45+VCR6DTYtOyr8cnafOJjXwspUWVF2EDdeP7MA7+PGnlwCLJvOPFugy+It+rS0O4eRcuZ/C6W64GgUghubdgThfes/yOd6MCRw/vZ/ULJ4pcpFdDwQ1ps/J94DHkhoXqyjwwvXaL249JJl+C+mZ2G4zwdLzsqoknY8abTgcYOXOuWpvv8z7pADFj4HlQA3C37BC/SbRpWWUmcXZhbdhsDyGvSowJ7g4Fo65fRczz//gVwvmbbnNkX0RuBaFnU3EfhVgCnerpoE0sD88dl5+YmvsskLVLbHdesACN6/NSEE5NUxx8woiS1FK+mReoWqAdYlOCWJU+Y4vEoO1Cu5DWCpIZlQ6rvlpnaSrNABHb4lNa85wUBeDoAHB+GDqXHKs9ZkKZJtC6WE2fvXydJ5otGHdGXmna2I7BZhaKfcXpHB7igFpCtJNljgOsNKC3YNxVp1R4bPczj80RD1QpY6vQfDdlFBF/NofDRGa1NXm4lQ3NWE4EQa3E652wOUorPos/L2q3Jqnq+TYb7VilyMS+585bXcPukfc4ebVZIntFMASHjcVhARsiY+sFjzOAAQoo8y8PXf2g1rzLVvxsBJcAtCl71hitdTT6LWxetmbMYsL4fhgOtUVF+B8CO63NVq0D/gGwjdiLsfrJ13Hfonip2cbzn9YSqndX2xTK2XtrD4S2ylAU4ySuhikCMQEmmKAoqQv8t3sduTmZH1LkL+1RWYkW1v+5o99kcL3TnkdscTxFlc1kt0S4aDpJs8Vf6Q5LGFNeQtCtzvQBfIowqNFOQW1J1TltuaG9h2rWNVb1euwhMeNPhLb+RC2hcn7W+Mzq4sRuBAGhLxkxCcnHbkjOyejwsb+iUbP0CQuZ5ekBOufn+E+9WQhdpLiDkb47raDTPmshc/bhbRLQbZsP0zeF03hZLwaPUOLvOnNST90wlt5e7I4m6x4Yi/HoDnWO7E3c7ZfjvicLJqfHu8BFa0Q1RzlXrW4J+nx3MOliPopkJrMMUCHaYeOfDgv1TnVw+WQMO2hD8j+su8pgu0wMK34mGegmGRO6UjB6erTCCKI2rioacnPep3ZL6Gv5+K5xRPP/sEAHG4lxL0qLe7jBjRbmmJEPmmBfX6IaiJotvTkO+qreFqLvKvRqX1kBxvb3nW/M3XODA8+B2R7FJ/++dykveBGwYp1fo5hUW9fdWmxtYimj+oW7H8/4jvYe+6iqN7jh0/b4FgbHG8HoPrG6ZsClKiPMFmoha0IWzFZSIn6qCvXEV/FBpDXRESJCH3VFu03Tz2ST5YBygCngstrptOc5cAaRAkRxi8BQyN0rZYBPY4pjbxe6TvQfUncT2IHvCVWmVt+J1od0IbyGLrvqYFG68M514z3/uuP+M4UCBhQH4NfN0H+1nJWfvj5QN0CYGKQb+RrA6MzYb/YWsjdO75kck2o5+URhSpZ0rS8svPIXpmLohQAB++xTHX2gAEthioyKnyirZ+DeD54roBZe5qZXelPen2zbjIu5qVS1wEnO8Blxmd3lzvAnJ6JJUkH7YSwgBbxG17lBeDcuom4v57LsQIPD2w4QY+EuEH+e+/kvYtKrpY0AFCizgDfT8Td73K4jDJTUmL/qZH82sWZmOsnU/3dAiIu1bMLdtZGaUYrmy8isDcA1SE4G4KzQdBK+h0HEpVm3YSgiTkh+uIt3OqG9IXpnHwgJ1EU0x0xeVeQftvX7wUzciZtFvQqrTT1W2cxywPZs9wcfXRywua3SxtB2plZfYnMlhCHWqEiAIcCIAJ3HDxPbAilnSDtBDn4+5O4daKTNAMmOODoxplYRsJErC7P3vOXwxJgX86+QlvYphGOLfeRX+ghzYQsB5zZMJ2Qy+jluF43YImFIxhi40vv46r1UxWE9tYopW/spuBULZZYQ6qNdgOH103GqSB2PcbWPDfH52YmTIZW+u/35O6Z3Vcbk44BwveNA1j/KuABKP/aJOYArcRHzugEB/uWeLl/X30XG6FRmrgx3Z1WXcsLG9+kzZtKWiCMoaUz8KHgYlaYMwUZ1FkQNuL7gK0WlN/lY/7plkQmHrS1o4yyFcmmzUl7wN6c+zZrkXs1QsyEQwu8XLag2YaAFXd84C5fN80D0kqiuX5GS6jnQDUkXJucQW0EDgehtgO+jEBtBC5NdicZjTSCXpab7X0mGWdCAfZN+m0BYm+7QdLgc1JjG1QG4w7rOhI7bpGEWRgxpPtDBO34wHq6HU5e3w/M8kfRIkmrIC/tzvp1/oAFsC15VZBUIV4yWqMYWtgdgNPBeD0VBG8gyo1rNEJAB0ZVgJwrfoorL3C0DQ74Yb8fTFtY90FdXz0AQaeKod5IxGn2PPBx9q5SQV4U4qtZARyWpj7XzYHpmTTH4PMwdNjw1JufMfVKCAHCEqJBGkZVAIDiQ+fJSPHR7HBS8L+tPP+j09x2zk/XeJPUW7/pWX/6rfDPqrvydZsJ7szemenCPAPSaxVoOQ3eeeQWDiydSEZ7jEd+8QVLK282+Jqu55pcG/EGJ0KumkiukTMU0yuGpMxZ27K2s6t2E2CXd+ePUOrpoTDX6BpC0mtaOipIJZWZ5swh2SrktQebH9504//Ox+D2vO1rJKwXIOotpVQYQJSkIviI7/PPJMEtA6DR0bCEU/rxfAWhFkUjWjWgpPFqQWBta7OfIv/MdzTKVEgmkCVK5SmR6cBsEiy5w4SxsKIGRjKfNkpdROScKJqUEAJQgkcrFr6Ut33Ni5e2fNRNgP+Y8MvolktbViSLf3f+bnck0L7YMNR9IqwESoAUgCDhJkGmdOqBVCnUPkF9ipYqTEf1Zv/mXouH0nnffvvCqXPqjS9+vD2RzzLKzNqM2tmGkoVKySpQa4GZghCRcL1Hpd54GxwF9oiSPYZWn9DiPLKOdR3J2jJv7vIVXIp/HvIXJN6f8L7XYcojgjx2Ta5l+bX/hCj1PpgfJ2psIpRuiAtQeezj5Pv/PfBD7yvzRLM+08wqmUhOu8Dbhu38+UOBh0b3GZwMxcUr0xfPX3bnUGxLN3z77bsWrn5nKLaL5y+7s7h4ZfpQbLtieO8GgaqqT9qBT4fLM1gcOXFwRHyO2FdkflcxLsBYBzDWGBdgrAMYa4wLMNYBjDXGBRjrAMYa4wKMdQBjjXEBxjqAscaY/WDi1cxXZ6Osc4KgRBduav3O4F4ZjxD+3/eAcQHGOoCxxrB3hPpDZc7+zS06UGQ1q019bVSOFUa9BwjqH4AnQ962Nd0cm7b7xmdt2MN5aTwsfBW3QF38j3T7OYvWcv1HFSpk+tOufAVxJMSo3wKgdgDbgI07sv7N6JCOXTFiS2ysZwVBIe8+y7NjdmuMugDeLP/L/ia1Glip4AmUPNH55WnFGVsbfz3aMfSFUb8FZp9f12G18DVBXgQ5R/wtzkVBXnar2D3PtT7XPNoxjGMcyfF/rI+X2ykyhT8AAAAASUVORK5CYII=","2603":"data:image/png;base64,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","2604":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAABDlSURBVHic7Zp7tBXVfcc/vz1znvfNS7gCQhBBiCBcQ1AUNdpYaYxVjIlJXG1eNbFpGhsTmya16kqMaVNWa9UmTWwSm2gWDcTUFaORBLkiD3kEoxBEVBDkeYH7POfMOTP71z9m5txz4XK5F+7VZC2/a82aM3v27Pn9fvv3+O59Bt7G2/ijw4qcjluR1/kn9fBydVmtZ8eXZtCkehMhhodEWLE8rxMG9GCzjnRT3MURXo2b3MEW7s2AwjeMsOxgil39fSa7Wmf7ygOu5Vp/gXhDKd8fHKpW60cyq/RIZpXOeatleXOxXN2a1XpP1WrV7Gr95FstTp9Y4elXmwt6y2CNV7NeR9St0V/XrlatXq33Dta4J4fvrB/R121VleaCtjcXtGdML9kx5mReN/I5PXfYGn2tfo1q/RpdyWZNHq/v0FeB7z832nFL7+qri4ioo5zjWubGbe7SXRcnjDNuoK87ba3eoMqzIkwwyut+wLVMl+Lx+g+5AVzLlwNrtla2bVZNLldNV7bNy8jOC7LyBkDy0Z3THPTvSteMey6+31zQTzd72rIyp3PpDYvVGb1O70F42EBWoCAO13XOkwN9yTekBsg+uLHRGPkAn5yzI25r9vRDhzyOOB4dzQX94jHPLNkxJoF53HXkPyvbVcmjdKhL6ehnTl+rw0+fyBOi3CaACIhy86E5su5EMsrJqdY/pL6/4dsYnez9xXmXxW3NBd0KTIkuC0GKmktFfIDGx/Zkuwh+Yy3pjvePnYWInugdEzfoDN/yqMJEBayCCov2vUu+0B8Zh8wD0j/eeIYx8jGDbOxxQ2kv/xa6LoEAgMXqeBI8bJB3G+Tr/VF+0gb9oCqrjDBRCGfTCL/e18lt/ZVzyAzgqNxhRJJGzG8r28XhM8BKYIMoH5VI0dOye/7NYK52hO1t3ulL+xx8sTpnrdd7gEeMUBUpDrAzcLiBS0OP6g+GhArX/vi3k1XNR9UoYkwPD7goKRuAiyrbGn+594uq9rOiECB3c70Exxv7zDVa6yb5kYWrjIIlVN4qeWNYuG+2HByIrENiABHnTsAV6Grfds62vvqOf3LvdWr1HhXBwu7hnUd+fDwNZjyvUwLlUatMNQpWIDKCOoaP75gtGwYq66CHwLCHN08XkQ8aEYwxm7hD7PH6Tnxi7xwHfuiIGCPgCv+y+frpvdbsGc/rVShrRZlqCDN9fHaEb74yW35yMvIOfg5w5S4jxogRRNh4vG5nLdv/DteRx4yQNQJG5JBnzIPHdFSVWb/T2xx4VKDOSJTsKBvhqW3b+eqzHTpqRUEfby7ozhV5/Vp/xR1UA4z4yZbZBq4REYwIQs8EGGPqst3DHfilgVFO1NcVWbT/itFdlf3mbdWa815gqaPcI2DKyncbYYe1fJjrJQgS3CpwJTBehK88k9N390fmQc0BjiN3WRARUAVH7TEeMGH5a+mkJn4eKGcJgkURaPfc1AOV/S7cpGf5JX7mwLSKWI8THkboRLhq8yxpiR7pwSxVel4fD4PmAaOXvPQujFlgRAg9wHgH2gpbenRSlQbJPigi88KZB0cER7h/x6UNrXG3+Vt0gTqsNTCtMtYNZQ9QgU/8bqa8GD/jwL8LbAWsKA9flOaZ/sg9aB4gRu4WRRRBUFR4gZvO60Fbm5pb/hnMhw3Kn46v4szaBNvaSv4T+3P3AaAql2zmS9ZytxGM1VDpsgdE50D42vMzZXHl2PPS8gpw9nrVxHkix9Dl42FQDNC49JULL2qsvvzdo6v49osH6PB8RHsmwLnNBz+lyK0W5dwRaa4YmwVgUm3CvXJ89vzbN+uTzhZ+YIWFhrKbc4wRDE+e+XvuXKTqpqD2ApHDle8ZiPIwSCHgOPq1c0ZmmD2qioaUixGDEcoJcN7Kw1c6Ig/ELl+T6PnagwXOSQprJFK+R6KrzPqGbSWfD/3v9RIYj6W+x56VXdrYm0yJn+2a05/9hFP2gImPvfreQLn4e5tbeOSlw7QXA8QIWHcjwHtWt84ObLDYIq5oGKAvHi4yf3SGYSlDSdnzyH4+L0LdUeSmMuFhlQ5HuHbTLGklNNJTCn46S2ulPJmlOy9UkZt95SEWTniuF5F74JRXgxMe27EadG68clFVgMCXdO3U4ckGMGsUxlpVNFJMVRHBTh9T/9A+37mxZHGU8B4KroFCEPUFbPjoB555pyzpVYg71DQ07fmzQO1XA6uno+Z9XdeM3dQf+U/JA97xi53vA+YqIBoKG1l0y8yRKTfAPK7K2LDUCRaiBGmorqvZs893/rIy1mscmJyFje1R1o8M5gh3LJ/ei/Lr1ydGHRh9g7Vv/L1Vzhb4nQ3M3PzCsbv7q8PJ5wBVcYzcXiY98dkINQnnRTHOTx1hhhFwiEseJByHhvoa0gl3bGWMN6bg8gZ4ORdasaL0/fziafRgdmc+/nJq/C/3/FXjgcbtRuWHBjlbjP7KcbMXxcqvV832R42TDoHJT+xaCPxUy6v20E8/clY972ms1h9s75SDBRu6vSoKOK5LVU0VhAsfNHKZKVmYVgXPtsLrhcjtAbVstWnmLpskbQBTVh6sKeWCj1vV26zqGKsQqGKV7+3PNn4mXgY35/VuhFuN4YILk7K+Lz0GFALrVbO5Ah+2IH+7at/n8n6AEAoco6MEewtWikE4u+E9IZlOkMlmy8oZhbQD59bAiARsz8EbXo/S115KcO2ySdI2q3nvSM8zfx0U7OcMNIRDCoqqA3ftXXD6HUeJugVhXSmghRNgQB7QXNBHgasBnj9U4P7Nh0MFFRSlIeUyriZSMkp6KpDJpnGTyTihocCIJLyzCpICXQE83Qq+lu9btbx/3+EjL/i+/wVr+aRVzQaRN0Uz76mVj+24cvQjA9HhaAw0CV4S/5han0JEyh5Qk3CYUBuGXZjsBIyQrcogrlNW3jVwRgrGp8OcEChs6AjDIc4JRd9fdLil7b2oLjFKKrJxvOuDwmGs/vmOK8f0i+72hQEZQKFZ4CqAbW1FjAgKZFzD5LoMxgg2UkRcQzabQY2Uy1+VC5PTUO10j7klF3pAnPWLfvB62+G2WxCcMEMLimKQOGm8qo6/4LU/Of2lU1V+wAbYmuPGzQe6Xi4GduS6lgIihpSBKfUZEsZE8a4kEglS2VR51q3ACBfOyPR84Z4i7PW6lS8FAR2t7eMFwaBh8ZRQ+ehqjevbqx+6rLGztVNPu7xa9p+qAQZUBh94vuWGFfvyI1cdKFCy4DiGs+oyZFwHJ/R4qrJpslWp8srNFZiQDo944gUo2LDkxTQXlM6OTkDD0hiNV0GNl1anvfc8cPFpTTmP/UmXfSs8PXYDZYDodxK8ZPlr6TZTs01hXJjyYGpNmrqkE16JkMqkMI4JZx1ISVjfUyZ8kSPdL3yhC9r9qORZaOvowvOKWMqlDatKmPi4d9384bcgYpsL+hRweSyXWsZfnJV+fydwNPodAh1u7U0C42LGN6kqyfC0EyYvxyGVSYb1PWJ2tQZGJruJjsSaC+wqhHEfl7xCvkBQKjFjeAovsGw5UiI0sgQG/fzai0fcVxZEaamYNs9m6DhZ5fttgPNX7cqUrPmSRDM/LuvSmE2ggJtwSKQT5USXEKhPQJU51r1EoM2H/cVoiQv4xRJFz8MReP+4LHlr2drahgpdEsgNq+cPf6xyjED5oiMkgNEqLLpUpJWj8d21Ex1jpwZ+Yh03ndcnF+iXAQKp+RsRGgFGJR0mVidBIZF2cV0n/juKpEC9G5a6KCqI/7ERoGRhZ6HbI9QPKOQKGCBAePiVToqqCOwT61y18qL6Y1jcpVnZDVwXX2cf2dhIyWlC/aZAtSmwzFK1vwgI7uSm809IhE5ogEuWH6jOI18QgRrXMKUuiSNCKusiYuLFCmkDWac7aZWP8I9KEHg937281UDJ5wqAhusIlN25AKu6RVUWPH1h/c4egixf7g47NGqK+NKkqk2B2mmq2mQD26BisSolEX7iYucXPjHn1aP1OGkDeJnMLQYdlXaEmXVJEq6QTrsoIQcwClkXkseZ9RgHPchZotmGQi6PBrZchjQ05G9SSRa2PPdK1/j/e3l6YKXJWttkVZv0kM62VjMqNiqJMXkSqyJLrPH/wbuxaXt/FY/RZxVoWn+4Lh0kX3OFhqb6BNVJh0TKCbkqoTIZp+dMS1TCsJTLmRfATo9ydcjnPPJeqZLW0lXy17x6uGNDoPbcwHKeqqasKjOHZ7hyQh0PvniANzq9kGJbxapaxS6xvv5jx40zT5oU9ekBGZu61Tg0zKpzaci4uE5IdqxAWiDRixXLyT7yBKuwr9RNc33Pp1T0w5kPFzQczpfY3Z6bq8hcxSBiy9R4Yn2aGSOrGJ1NsqfTC2deWIbKl9pumNHr/w4DwXE94LK17cN9x31tRq1TM7YmgYmXsITuLgA2SmaRchrFN5E3GGB/CTqDsI8fWDo78wS2u9bvbM9zMO9hraIaHrbybC3VCUOb52PVLrPIl1uum9rnEncgOK4HWDd528xaUzOhJgESuq6rYcKLLacxsYna4pofN3X4IeMzhAoXch4S0VtV4dX2HK2FEkRtRAau3F1SETp8+yxivnJg4ZQVg6V4jF494JLnOkfPGpHeNbHacWM+bwDMUcJpT4KDdq/YShYOlsLVngJdXR4l3xKo4gXK1tYc88ekqXENj7zcWp71Sg8IrF2lltvfuGbSrwdb8RjHeMAdqq67W58ZlhY3EdX2eNZ9woRWLFug2xNMdCZspi36RMEIFPIlrLWIQMG3/L41j+db5o7MUJ90WPxKG2ojDwjHXGvRr+++elIPEjQU6OEB31FNmEM8hnBFjQmXrSkTsjsIFS8E0GFDHu9rzxCIB2v3IW9Dzyn6Afl8CatwqODzUnsB31qsKmknLKPtxSCceXQT1t6+fcEZQ654jB4e4B7hX0W4ot6FOjfcpc2acEUHUFLIBZAJwkTY4oUVoWI3GM+GhhIAtRQLPiJwoOCzvcPDljfJIO+Hro7we5R7tq8Z+6O+vicYCpQN8D8HdUoAn6l1ocENKW29C5mjFsw5A4mI7pUstPrdytvIQCEnUryCjxHY2eWzszP+7kHKlUNgh0W/8dKRxgf7+ixmKFE2gBhuTglutRPOfG/KQ0h3kdAbCg7kK3JCLlrhBQpFz0ctvNRRYn+h1B0mCir6uihfH2FO+++nB/BB01CgOwQMl6dMGPMZp3flY2RNuNpLR0fRhq4fh0JQCij6lhc6ShwpBkQ7hAjsDkS+letq/fb2BZP/IL7ZLxvAwHhXwoSX7Mc2SdKE/VwJNzT8qFT6gaWjGLCprUSXH4azCC2qfCvp5u5dfcG4/FApczLoNkDF9tNAoIThYABflZZ8wKY2H88CIoeM5T51gkXr5g1vP8FQbwm6c4DyugrTrIazeSKUbLiqK8VkyMKeTp9NbSV8qx0gD5Tc0jc2zB3WNnTinzoqQ2BZyTKtaMJ4LtgwvntD3oZHLgjPAuzO+WxqD7osch/p0jdXzag/8ibpcEooG8Bx+W4Q8NmCxXRZcKOidLQRchEJag/CfT1fYVdXYH/bFnyPIPin5jnV+95MBU4VPUJ+SZvej3JzjQtVTpjpU70QofYgpLqHfDjgseNXRzj/6enyR6V4jB5MMKjlFtPB2Z0+lwYKxYgGOxFx8TUMjc4AWgNQ5cniGN73dONbW8tPBcck/cWqSdPOIlU+7QqOa6IvswgJTsGCp/hW+Y/SMG67aYAfJf2h4bhV76cdOh3LpwLlMoUJVlELOxSewue/bhwpg/Lf3Nt4G28t/h/xf9oanDTwqwAAAABJRU5ErkJggg==","2622":baseURL+"2622.png","2620":baseURL+"2620.png","2640":baseURL+"2640.png","2618":baseURL+"2618.png","2623":baseURL+"2623.png","2638":baseURL+"2638.png","2642":baseURL+"2642.png","2639":"data:image/png;base64,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","2611":baseURL+"2611.png","2600":"data:image/png;base64,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","2649":baseURL+"2649.png","2615":"data:image/png;base64,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","2648":baseURL+"2648.png","2652":baseURL+"2652.png","2651":baseURL+"2651.png","2660":baseURL+"2660.png","2653":baseURL+"2653.png","2665":baseURL+"2665.png","2666":baseURL+"2666.png","2626":baseURL+"2626.png","2668":baseURL+"2668.png","2692":baseURL+"2692.png","2693":baseURL+"2693.png","2650":baseURL+"2650.png","2695":baseURL+"2695.png","2663":baseURL+"2663.png","2702":baseURL+"2702.png","2696":baseURL+"2696.png","2697":baseURL+"2697.png","2699":baseURL+"2699.png","2709":baseURL+"2709.png","2708":"data:image/png;base64,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","2694":baseURL+"2694.png","2712":baseURL+"2712.png","2721":baseURL+"2721.png","2714":baseURL+"2714.png","2728":"data:image/png;base64,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","2733":baseURL+"2733.png","2744":"data:image/png;base64,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","2734":baseURL+"2734.png","2747":baseURL+"2747.png","2755":baseURL+"2755.png","2754":baseURL+"2754.png","2757":baseURL+"2757.png","2753":baseURL+"2753.png","2763":baseURL+"2763.png","2795":baseURL+"2795.png","2764":"data:image/png;base64,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","2934":baseURL+"2934.png","2935":baseURL+"2935.png","3299":baseURL+"3299.png","3297":baseURL+"3297.png","1f49b":baseURL+"1f49b.png","1f49a":baseURL+"1f49a.png","1f9e1":baseURL+"1f9e1.png","1f499":baseURL+"1f499.png","1f49c":baseURL+"1f49c.png","1f495":baseURL+"1f495.png","1f494":baseURL+"1f494.png","1f49e":baseURL+"1f49e.png","2797":baseURL+"2797.png","1f493":baseURL+"1f493.png","2796":baseURL+"2796.png","1f49f":baseURL+"1f49f.png","1f496":baseURL+"1f496.png","2705":baseURL+"2705.png","1f5a4":baseURL+"1f5a4.png","1f49d":baseURL+"1f49d.png","271d":baseURL+"271d.png","262e":baseURL+"262e.png","1f549":baseURL+"1f549.png","262f":baseURL+"262f.png","1f52f":baseURL+"1f52f.png","2716":baseURL+"2716.png","1f54e":baseURL+"1f54e.png","1f6d0":baseURL+"1f6d0.png","264a":baseURL+"264a.png","262a":baseURL+"262a.png","264b":baseURL+"264b.png","264c":baseURL+"264c.png","264e":baseURL+"264e.png","264d":baseURL+"264d.png","267e":baseURL+"267e.png","264f":baseURL+"264f.png","269b":baseURL+"269b.png","1f497":baseURL+"1f497.png","1f4f3":baseURL+"1f4f3.png","1f251":baseURL+"1f251.png","26ce":baseURL+"26ce.png","1f21a":baseURL+"1f21a.png","1f238":baseURL+"1f238.png","1f236":baseURL+"1f236.png","1f237":baseURL+"1f237.png","1f23a":baseURL+"1f23a.png","1f19a":baseURL+"1f19a.png","1f4ae":baseURL+"1f4ae.png","1f234":baseURL+"1f234.png","1f250":baseURL+"1f250.png","1f4f4":baseURL+"1f4f4.png","1f235":baseURL+"1f235.png","1f239":baseURL+"1f239.png","1f232":baseURL+"1f232.png","1f170":baseURL+"1f170.png","1f18e":baseURL+"1f18e.png","1f17e":baseURL+"1f17e.png","1f171":baseURL+"1f171.png","1f191":baseURL+"1f191.png","274c":baseURL+"274c.png","1f198":baseURL+"1f198.png","2b55":baseURL+"2b55.png","1f6ab":baseURL+"1f6ab.png","3030":baseURL+"3030.png","1f4db":baseURL+"1f4db.png","1f6d1":baseURL+"1f6d1.png","1f4a2":baseURL+"1f4a2.png","1f6b7":baseURL+"1f6b7.png","1f6af":baseURL+"1f6af.png","1f6b1":baseURL+"1f6b1.png","1f51e":baseURL+"1f51e.png","1f6b3":baseURL+"1f6b3.png","1f6ad":baseURL+"1f6ad.png","1f4af":baseURL+"1f4af.png","1f4f5":baseURL+"1f4f5.png","203c":baseURL+"203c.png","1f506":baseURL+"1f506.png","1f6b8":baseURL+"1f6b8.png","1f505":baseURL+"1f505.png","303d":baseURL+"303d.png","26a0":baseURL+"26a0.png","269c":baseURL+"269c.png","1f531":baseURL+"1f531.png","1f530":baseURL+"1f530.png","1f22f":baseURL+"1f22f.png","267b":baseURL+"267b.png","1f4b9":baseURL+"1f4b9.png","1f4a0":baseURL+"1f4a0.png","274e":baseURL+"274e.png","24c2":baseURL+"24c2.png","1f310":baseURL+"1f310.png","1f300":baseURL+"1f300.png","1f6be":baseURL+"1f6be.png","1f4a4":"data:image/png;base64,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","1f498":baseURL+"1f498.png","1f233":baseURL+"1f233.png","267f":baseURL+"267f.png","1f202":baseURL+"1f202.png","1f6c2":baseURL+"1f6c2.png","1f6c3":baseURL+"1f6c3.png","1f6c5":baseURL+"1f6c5.png","1f6b9":baseURL+"1f6b9.png","1f6c4":baseURL+"1f6c4.png","1f6bc":baseURL+"1f6bc.png","1f6ba":baseURL+"1f6ba.png","1f6bb":baseURL+"1f6bb.png","26d4":baseURL+"26d4.png","1f194":baseURL+"1f194.png","1f17f":baseURL+"1f17f.png","1f6ae":baseURL+"1f6ae.png","1f3a6":baseURL+"1f3a6.png","1f201":baseURL+"1f201.png","1f3e7":baseURL+"1f3e7.png","1f524":baseURL+"1f524.png","1f196":baseURL+"1f196.png","1f520":baseURL+"1f520.png","1f197":baseURL+"1f197.png","1f195":baseURL+"1f195.png","1f192":baseURL+"1f192.png","1f199":baseURL+"1f199.png","1f193":baseURL+"1f193.png","0030-20e3":baseURL+"0030-20e3.png","0031-20e3":baseURL+"0031-20e3.png","0032-20e3":baseURL+"0032-20e3.png","0033-20e3":baseURL+"0033-20e3.png","0035-20e3":baseURL+"0035-20e3.png","0034-20e3":baseURL+"0034-20e3.png","0036-20e3":baseURL+"0036-20e3.png","0037-20e3":baseURL+"0037-20e3.png","0038-20e3":baseURL+"0038-20e3.png","0039-20e3":baseURL+"0039-20e3.png","1f51f":baseURL+"1f51f.png","1f522":baseURL+"1f522.png","0023-20e3":baseURL+"0023-20e3.png","002a-20e3":baseURL+"002a-20e3.png","25b6":baseURL+"25b6.png","23cf":baseURL+"23cf.png","23f8":baseURL+"23f8.png","23f9":baseURL+"23f9.png","23fa":baseURL+"23fa.png","23ef":baseURL+"23ef.png","23ed":baseURL+"23ed.png","23ee":baseURL+"23ee.png","23e9":baseURL+"23e9.png","23eb":baseURL+"23eb.png","23ec":baseURL+"23ec.png","23ea":baseURL+"23ea.png","1f4f6":baseURL+"1f4f6.png","25c0":baseURL+"25c0.png","1f53d":baseURL+"1f53d.png","2b05":baseURL+"2b05.png","27a1":baseURL+"27a1.png","2b06":baseURL+"2b06.png","21a9":baseURL+"21a9.png","2b07":baseURL+"2b07.png","21aa":baseURL+"21aa.png","1f500":baseURL+"1f500.png","1f502":baseURL+"1f502.png","1f504":baseURL+"1f504.png","1f501":baseURL+"1f501.png","1f503":baseURL+"1f503.png","1f3b6":baseURL+"1f3b6.png","1f4b2":baseURL+"1f4b2.png","1f3b5":baseURL+"1f3b5.png","1f4b1":baseURL+"1f4b1.png","00ae":baseURL+"00ae.png","27bf":baseURL+"27bf.png","27b0":baseURL+"27b0.png","00a9":baseURL+"00a9.png","1f51a":baseURL+"1f51a.png","1f519":baseURL+"1f519.png","1f51d":baseURL+"1f51d.png","1f51b":baseURL+"1f51b.png","1f51c":baseURL+"1f51c.png","1f518":baseURL+"1f518.png","26aa":baseURL+"26aa.png","26ab":baseURL+"26ab.png","1f534":baseURL+"1f534.png","1f53a":baseURL+"1f53a.png","1f53b":baseURL+"1f53b.png","1f535":baseURL+"1f535.png","1f539":baseURL+"1f539.png","1f536":baseURL+"1f536.png","1f533":baseURL+"1f533.png","1f537":baseURL+"1f537.png","1f532":baseURL+"1f532.png","25aa":baseURL+"25aa.png","25ab":baseURL+"25ab.png","25fd":baseURL+"25fd.png","25fe":baseURL+"25fe.png","25fc":baseURL+"25fc.png","25fb":baseURL+"25fb.png","1f53c":baseURL+"1f53c.png","2b1b":baseURL+"2b1b.png","1f538":baseURL+"1f538.png","2b1c":baseURL+"2b1c.png","1f523":baseURL+"1f523.png","1f507":baseURL+"1f507.png","1f509":baseURL+"1f509.png","1f508":baseURL+"1f508.png","1f521":baseURL+"1f521.png","1f50a":baseURL+"1f50a.png","1f514":baseURL+"1f514.png","1f515":baseURL+"1f515.png","1f4e2":baseURL+"1f4e2.png","1f4e3":baseURL+"1f4e3.png","1f5e8":baseURL+"1f5e8.png","1f441-1f5e8":baseURL+"1f441-1f5e8.png","1f4ac":baseURL+"1f4ac.png","1f0cf":baseURL+"1f0cf.png","1f4ad":baseURL+"1f4ad.png","1f5ef":baseURL+"1f5ef.png","1f004":baseURL+"1f004.png","1f550":baseURL+"1f550.png","1f3b4":baseURL+"1f3b4.png","1f551":baseURL+"1f551.png","1f552":baseURL+"1f552.png","1f553":baseURL+"1f553.png","1f555":baseURL+"1f555.png","1f554":baseURL+"1f554.png","1f557":baseURL+"1f557.png","1f558":baseURL+"1f558.png","1f556":baseURL+"1f556.png","1f55b":baseURL+"1f55b.png","1f559":baseURL+"1f559.png","1f55a":baseURL+"1f55a.png","1f55d":baseURL+"1f55d.png","1f55f":baseURL+"1f55f.png","1f55c":baseURL+"1f55c.png","1f560":baseURL+"1f560.png","1f55e":baseURL+"1f55e.png","1f562":baseURL+"1f562.png","1f563":baseURL+"1f563.png","1f561":baseURL+"1f561.png","1f566":baseURL+"1f566.png","1f565":baseURL+"1f565.png","1f567":baseURL+"1f567.png","1f564":baseURL+"1f564.png","0032":baseURL+"0032.png","0030":baseURL+"0030.png","0033":baseURL+"0033.png","0031":baseURL+"0031.png","0034":baseURL+"0034.png","0036":baseURL+"0036.png","0035":baseURL+"0035.png","0037":baseURL+"0037.png","0038":baseURL+"0038.png","0039":baseURL+"0039.png","0023":baseURL+"0023.png","002a":baseURL+"002a.png","26bd":baseURL+"26bd.png","1f3c0":baseURL+"1f3c0.png","1f3c8":baseURL+"1f3c8.png","26be":baseURL+"26be.png","1f94e":baseURL+"1f94e.png","1f3be":baseURL+"1f3be.png","1f3d0":baseURL+"1f3d0.png","1f3c9":baseURL+"1f3c9.png","1f3d3":baseURL+"1f3d3.png","1f3f8":baseURL+"1f3f8.png","1f3b1":baseURL+"1f3b1.png","1f945":baseURL+"1f945.png","1f3d2":baseURL+"1f3d2.png","1f3d1":baseURL+"1f3d1.png","1f3cf":baseURL+"1f3cf.png","1f94d":baseURL+"1f94d.png","26f3":baseURL+"26f3.png","1f3f9":baseURL+"1f3f9.png","1f3a3":baseURL+"1f3a3.png","1f94a":baseURL+"1f94a.png","1f94f":baseURL+"1f94f.png","1f3bd":baseURL+"1f3bd.png","1f94b":baseURL+"1f94b.png","1f3bf":baseURL+"1f3bf.png","1f6f7":baseURL+"1f6f7.png","26f7":baseURL+"26f7.png","1f3c2-1f3fb":baseURL+"1f3c2-1f3fb.png","1f6f9":baseURL+"1f6f9.png","1f94c":baseURL+"1f94c.png","1f3c2":baseURL+"1f3c2.png","1f3c2-1f3fe":baseURL+"1f3c2-1f3fe.png","1f3c2-1f3ff":baseURL+"1f3c2-1f3ff.png","1f3cb":baseURL+"1f3cb.png","1f3cb-1f3fb":baseURL+"1f3cb-1f3fb.png","1f3c2-1f3fd":baseURL+"1f3c2-1f3fd.png","1f3cb-1f3fd":baseURL+"1f3cb-1f3fd.png","1f3cb-1f3fc":baseURL+"1f3cb-1f3fc.png","1f3cb-1f3fe":baseURL+"1f3cb-1f3fe.png","1f3cb-2640":baseURL+"1f3cb-2640.png","1f3cb-1f3fb-2640":baseURL+"1f3cb-1f3fb-2640.png","1f3cb-1f3ff":baseURL+"1f3cb-1f3ff.png","1f3cb-1f3fc-2640":baseURL+"1f3cb-1f3fc-2640.png","1f3cb-1f3fd-2640":baseURL+"1f3cb-1f3fd-2640.png","26f8":baseURL+"26f8.png","1f3cb-1f3fe-2640":baseURL+"1f3cb-1f3fe-2640.png","1f3c2-1f3fc":baseURL+"1f3c2-1f3fc.png","1f3cb-1f3ff-2640":baseURL+"1f3cb-1f3ff-2640.png","1f3cb-2642":baseURL+"1f3cb-2642.png","1f3cb-1f3fb-2642":baseURL+"1f3cb-1f3fb-2642.png","1f3cb-1f3fd-2642":baseURL+"1f3cb-1f3fd-2642.png","1f3cb-1f3ff-2642":baseURL+"1f3cb-1f3ff-2642.png","1f3cb-1f3fe-2642":baseURL+"1f3cb-1f3fe-2642.png","1f93c":baseURL+"1f93c.png","1f93c-2642":baseURL+"1f93c-2642.png","1f93c-2640":baseURL+"1f93c-2640.png","1f938-1f3fc":baseURL+"1f938-1f3fc.png","1f938":baseURL+"1f938.png","1f938-1f3fb":baseURL+"1f938-1f3fb.png","1f938-1f3fd":baseURL+"1f938-1f3fd.png","1f938-1f3fe":baseURL+"1f938-1f3fe.png","1f938-1f3ff":baseURL+"1f938-1f3ff.png","1f3cb-1f3fc-2642":baseURL+"1f3cb-1f3fc-2642.png","1f938-1f3fc-2640":baseURL+"1f938-1f3fc-2640.png","1f938-1f3fb-2640":baseURL+"1f938-1f3fb-2640.png","1f938-1f3fd-2640":baseURL+"1f938-1f3fd-2640.png","1f938-1f3ff-2640":baseURL+"1f938-1f3ff-2640.png","1f938-1f3fe-2640":baseURL+"1f938-1f3fe-2640.png","1f938-2640":baseURL+"1f938-2640.png","1f938-1f3fc-2642":baseURL+"1f938-1f3fc-2642.png","1f938-1f3fb-2642":baseURL+"1f938-1f3fb-2642.png","1f938-1f3fd-2642":baseURL+"1f938-1f3fd-2642.png","1f938-2642":baseURL+"1f938-2642.png","1f938-1f3ff-2642":baseURL+"1f938-1f3ff-2642.png","1f938-1f3fe-2642":baseURL+"1f938-1f3fe-2642.png","26f9-1f3fc":baseURL+"26f9-1f3fc.png","26f9-1f3fb":baseURL+"26f9-1f3fb.png","26f9":baseURL+"26f9.png","26f9-1f3fe":baseURL+"26f9-1f3fe.png","26f9-1f3ff":baseURL+"26f9-1f3ff.png","26f9-1f3fd":baseURL+"26f9-1f3fd.png","26f9-2640":baseURL+"26f9-2640.png","26f9-1f3fc-2640":baseURL+"26f9-1f3fc-2640.png","26f9-1f3fe-2640":baseURL+"26f9-1f3fe-2640.png","26f9-1f3fb-2640":baseURL+"26f9-1f3fb-2640.png","26f9-1f3fd-2640":baseURL+"26f9-1f3fd-2640.png","26f9-1f3ff-2640":baseURL+"26f9-1f3ff-2640.png","26f9-1f3fb-2642":baseURL+"26f9-1f3fb-2642.png","26f9-1f3fc-2642":baseURL+"26f9-1f3fc-2642.png","26f9-2642":baseURL+"26f9-2642.png","26f9-1f3fe-2642":baseURL+"26f9-1f3fe-2642.png","26f9-1f3fd-2642":baseURL+"26f9-1f3fd-2642.png","1f93a":baseURL+"1f93a.png","1f93e-1f3fb":baseURL+"1f93e-1f3fb.png","1f93e":baseURL+"1f93e.png","1f93e-1f3fc":baseURL+"1f93e-1f3fc.png","26f9-1f3ff-2642":baseURL+"26f9-1f3ff-2642.png","1f93e-1f3ff":baseURL+"1f93e-1f3ff.png","1f93e-1f3fd":baseURL+"1f93e-1f3fd.png","1f93e-1f3fe":baseURL+"1f93e-1f3fe.png","1f93e-2640":baseURL+"1f93e-2640.png","1f93e-1f3fd-2640":baseURL+"1f93e-1f3fd-2640.png","1f93e-1f3fc-2640":baseURL+"1f93e-1f3fc-2640.png","1f93e-1f3fb-2640":baseURL+"1f93e-1f3fb-2640.png","1f93e-1f3fe-2640":baseURL+"1f93e-1f3fe-2640.png","1f93e-1f3ff-2640":baseURL+"1f93e-1f3ff-2640.png","1f93e-1f3fb-2642":baseURL+"1f93e-1f3fb-2642.png","1f93e-2642":baseURL+"1f93e-2642.png","1f93e-1f3fc-2642":baseURL+"1f93e-1f3fc-2642.png","1f93e-1f3fd-2642":baseURL+"1f93e-1f3fd-2642.png","1f93e-1f3fe-2642":baseURL+"1f93e-1f3fe-2642.png","1f3cc-1f3fb":baseURL+"1f3cc-1f3fb.png","1f93e-1f3ff-2642":baseURL+"1f93e-1f3ff-2642.png","1f3cc":baseURL+"1f3cc.png","1f3cc-1f3fc":baseURL+"1f3cc-1f3fc.png","1f3cc-1f3fe":baseURL+"1f3cc-1f3fe.png","1f3cc-1f3fd":baseURL+"1f3cc-1f3fd.png","1f3cc-1f3ff":baseURL+"1f3cc-1f3ff.png","1f3cc-2640":baseURL+"1f3cc-2640.png","1f3cc-1f3fb-2640":baseURL+"1f3cc-1f3fb-2640.png","1f3cc-1f3fc-2640":baseURL+"1f3cc-1f3fc-2640.png","1f3cc-1f3fd-2640":baseURL+"1f3cc-1f3fd-2640.png","1f3cc-1f3fe-2640":baseURL+"1f3cc-1f3fe-2640.png","1f3cc-1f3ff-2640":baseURL+"1f3cc-1f3ff-2640.png","1f3cc-2642":baseURL+"1f3cc-2642.png","1f3cc-1f3fe-2642":baseURL+"1f3cc-1f3fe-2642.png","1f3cc-1f3fd-2642":baseURL+"1f3cc-1f3fd-2642.png","1f3cc-1f3fc-2642":baseURL+"1f3cc-1f3fc-2642.png","1f3cc-1f3fb-2642":baseURL+"1f3cc-1f3fb-2642.png","1f3cc-1f3ff-2642":baseURL+"1f3cc-1f3ff-2642.png","1f3c7":baseURL+"1f3c7.png","1f3c7-1f3fb":baseURL+"1f3c7-1f3fb.png","1f3c7-1f3fe":baseURL+"1f3c7-1f3fe.png","1f3c7-1f3fc":baseURL+"1f3c7-1f3fc.png","1f3c7-1f3ff":baseURL+"1f3c7-1f3ff.png","1f9d8":baseURL+"1f9d8.png","1f9d8-1f3ff":baseURL+"1f9d8-1f3ff.png","1f9d8-1f3fe":baseURL+"1f9d8-1f3fe.png","1f9d8-1f3fb":baseURL+"1f9d8-1f3fb.png","1f9d8-2640":baseURL+"1f9d8-2640.png","1f9d8-1f3fd-2640":baseURL+"1f9d8-1f3fd-2640.png","1f3c7-1f3fd":baseURL+"1f3c7-1f3fd.png","1f9d8-1f3fc":baseURL+"1f9d8-1f3fc.png","1f9d8-1f3fb-2640":baseURL+"1f9d8-1f3fb-2640.png","1f9d8-1f3fc-2640":baseURL+"1f9d8-1f3fc-2640.png","1f9d8-1f3fd":baseURL+"1f9d8-1f3fd.png","1f9d8-1f3fe-2640":baseURL+"1f9d8-1f3fe-2640.png","1f9d8-1f3fc-2642":baseURL+"1f9d8-1f3fc-2642.png","1f9d8-1f3ff-2640":baseURL+"1f9d8-1f3ff-2640.png","1f9d8-1f3fb-2642":baseURL+"1f9d8-1f3fb-2642.png","1f9d8-2642":baseURL+"1f9d8-2642.png","1f9d8-1f3ff-2642":baseURL+"1f9d8-1f3ff-2642.png","1f9d8-1f3fe-2642":baseURL+"1f9d8-1f3fe-2642.png","1f9d8-1f3fd-2642":baseURL+"1f9d8-1f3fd-2642.png","1f3c4-1f3fd":baseURL+"1f3c4-1f3fd.png","1f3c4-1f3fb":baseURL+"1f3c4-1f3fb.png","1f3c4-1f3fc":baseURL+"1f3c4-1f3fc.png","1f3c4-1f3fe":baseURL+"1f3c4-1f3fe.png","1f3c4-1f3ff":baseURL+"1f3c4-1f3ff.png","1f3c4-2640":baseURL+"1f3c4-2640.png","1f3c4-1f3fb-2640":baseURL+"1f3c4-1f3fb-2640.png","1f3c4-1f3fc-2640":baseURL+"1f3c4-1f3fc-2640.png","1f3c4":baseURL+"1f3c4.png","1f3c4-2642":baseURL+"1f3c4-2642.png","1f3c4-1f3fb-2642":baseURL+"1f3c4-1f3fb-2642.png","1f3ca":baseURL+"1f3ca.png","1f3c4-1f3fc-2642":baseURL+"1f3c4-1f3fc-2642.png","1f3c4-1f3ff-2642":baseURL+"1f3c4-1f3ff-2642.png","1f3c4-1f3fe-2642":baseURL+"1f3c4-1f3fe-2642.png","1f3ca-1f3fb":baseURL+"1f3ca-1f3fb.png","1f3ca-1f3fe":baseURL+"1f3ca-1f3fe.png","1f3c4-1f3fd-2642":baseURL+"1f3c4-1f3fd-2642.png","1f3ca-1f3fd":baseURL+"1f3ca-1f3fd.png","1f3ca-1f3fb-2640":baseURL+"1f3ca-1f3fb-2640.png","1f3ca-1f3fc":baseURL+"1f3ca-1f3fc.png","1f3ca-1f3fc-2640":baseURL+"1f3ca-1f3fc-2640.png","1f3ca-2640":baseURL+"1f3ca-2640.png","1f3ca-1f3ff":baseURL+"1f3ca-1f3ff.png","1f3ca-1f3fd-2640":baseURL+"1f3ca-1f3fd-2640.png","1f3ca-1f3fe-2640":baseURL+"1f3ca-1f3fe-2640.png","1f3ca-1f3ff-2640":baseURL+"1f3ca-1f3ff-2640.png","1f3ca-1f3fc-2642":baseURL+"1f3ca-1f3fc-2642.png","1f3ca-2642":baseURL+"1f3ca-2642.png","1f3ca-1f3fb-2642":baseURL+"1f3ca-1f3fb-2642.png","1f3ca-1f3fd-2642":baseURL+"1f3ca-1f3fd-2642.png","1f3ca-1f3ff-2642":baseURL+"1f3ca-1f3ff-2642.png","1f3c4-1f3fe-2640":baseURL+"1f3c4-1f3fe-2640.png","1f93d":baseURL+"1f93d.png","1f3ca-1f3fe-2642":baseURL+"1f3ca-1f3fe-2642.png","1f93d-1f3fe":baseURL+"1f93d-1f3fe.png","1f93d-1f3fd":baseURL+"1f93d-1f3fd.png","1f93d-1f3fc":baseURL+"1f93d-1f3fc.png","1f93d-1f3fd-2640":baseURL+"1f93d-1f3fd-2640.png","1f93d-2640":baseURL+"1f93d-2640.png","1f93d-1f3fb-2640":baseURL+"1f93d-1f3fb-2640.png","1f93d-1f3ff":baseURL+"1f93d-1f3ff.png","1f93d-1f3fe-2640":baseURL+"1f93d-1f3fe-2640.png","1f93d-2642":baseURL+"1f93d-2642.png","1f93d-1f3fc-2640":baseURL+"1f93d-1f3fc-2640.png","1f93d-1f3ff-2640":baseURL+"1f93d-1f3ff-2640.png","1f93d-1f3fb-2642":baseURL+"1f93d-1f3fb-2642.png","1f93d-1f3fb":baseURL+"1f93d-1f3fb.png","1f93d-1f3fe-2642":baseURL+"1f93d-1f3fe-2642.png","1f6a3":baseURL+"1f6a3.png","1f93d-1f3fd-2642":baseURL+"1f93d-1f3fd-2642.png","1f6a3-1f3fb":baseURL+"1f6a3-1f3fb.png","1f6a3-1f3fc":baseURL+"1f6a3-1f3fc.png","1f93d-1f3ff-2642":baseURL+"1f93d-1f3ff-2642.png","1f6a3-1f3fd":baseURL+"1f6a3-1f3fd.png","1f6a3-1f3fe":baseURL+"1f6a3-1f3fe.png","1f6a3-1f3ff":baseURL+"1f6a3-1f3ff.png","1f6a3-2640":baseURL+"1f6a3-2640.png","1f6a3-1f3fc-2640":baseURL+"1f6a3-1f3fc-2640.png","1f6a3-1f3fb-2640":baseURL+"1f6a3-1f3fb-2640.png","1f6a3-1f3fd-2640":baseURL+"1f6a3-1f3fd-2640.png","1f6a3-1f3fe-2640":baseURL+"1f6a3-1f3fe-2640.png","1f6a3-2642":baseURL+"1f6a3-2642.png","1f6a3-1f3fb-2642":baseURL+"1f6a3-1f3fb-2642.png","1f6a3-1f3ff-2640":baseURL+"1f6a3-1f3ff-2640.png","1f6a3-1f3fc-2642":baseURL+"1f6a3-1f3fc-2642.png","1f6a3-1f3ff-2642":baseURL+"1f6a3-1f3ff-2642.png","1f6a3-1f3fd-2642":baseURL+"1f6a3-1f3fd-2642.png","1f6a3-1f3fe-2642":baseURL+"1f6a3-1f3fe-2642.png","1f9d7":baseURL+"1f9d7.png","1f9d7-1f3fd":baseURL+"1f9d7-1f3fd.png","1f9d7-1f3fb":baseURL+"1f9d7-1f3fb.png","1f9d7-1f3fc":baseURL+"1f9d7-1f3fc.png","1f9d7-1f3fe":baseURL+"1f9d7-1f3fe.png","1f9d7-1f3ff":baseURL+"1f9d7-1f3ff.png","1f9d7-2640":baseURL+"1f9d7-2640.png","1f9d7-1f3fb-2640":baseURL+"1f9d7-1f3fb-2640.png","1f9d7-1f3fc-2640":baseURL+"1f9d7-1f3fc-2640.png","1f9d7-1f3fd-2640":baseURL+"1f9d7-1f3fd-2640.png","1f9d7-1f3ff-2640":baseURL+"1f9d7-1f3ff-2640.png","1f9d7-1f3fe-2640":baseURL+"1f9d7-1f3fe-2640.png","1f9d7-1f3fb-2642":baseURL+"1f9d7-1f3fb-2642.png","1f9d7-2642":baseURL+"1f9d7-2642.png","1f9d7-1f3fd-2642":baseURL+"1f9d7-1f3fd-2642.png","1f9d7-1f3fc-2642":baseURL+"1f9d7-1f3fc-2642.png","1f9d7-1f3fe-2642":baseURL+"1f9d7-1f3fe-2642.png","1f9d7-1f3ff-2642":baseURL+"1f9d7-1f3ff-2642.png","1f6b5":baseURL+"1f6b5.png","1f6b5-1f3fb":baseURL+"1f6b5-1f3fb.png","1f6b5-1f3fc":baseURL+"1f6b5-1f3fc.png","1f3c4-1f3ff-2640":baseURL+"1f3c4-1f3ff-2640.png","1f6b5-1f3fe":baseURL+"1f6b5-1f3fe.png","1f6b5-2640":baseURL+"1f6b5-2640.png","1f6b5-1f3ff":baseURL+"1f6b5-1f3ff.png","1f6b5-1f3fb-2640":baseURL+"1f6b5-1f3fb-2640.png","1f6b5-1f3fc-2640":baseURL+"1f6b5-1f3fc-2640.png","1f6b5-1f3fd-2640":baseURL+"1f6b5-1f3fd-2640.png","1f6b5-1f3fe-2640":baseURL+"1f6b5-1f3fe-2640.png","1f6b5-2642":baseURL+"1f6b5-2642.png","1f6b5-1f3ff-2640":baseURL+"1f6b5-1f3ff-2640.png","1f6b5-1f3fd-2642":baseURL+"1f6b5-1f3fd-2642.png","1f6b5-1f3fb-2642":baseURL+"1f6b5-1f3fb-2642.png","1f6b5-1f3fe-2642":baseURL+"1f6b5-1f3fe-2642.png","1f6b5-1f3fc-2642":baseURL+"1f6b5-1f3fc-2642.png","1f6b4":baseURL+"1f6b4.png","1f6b5-1f3ff-2642":baseURL+"1f6b5-1f3ff-2642.png","1f6b4-1f3fb":baseURL+"1f6b4-1f3fb.png","1f6b4-1f3fd":baseURL+"1f6b4-1f3fd.png","1f6b4-1f3fc":baseURL+"1f6b4-1f3fc.png","1f6b4-1f3fe":baseURL+"1f6b4-1f3fe.png","1f6b4-2640":baseURL+"1f6b4-2640.png","1f6b4-1f3ff":baseURL+"1f6b4-1f3ff.png","1f6b4-1f3fc-2640":baseURL+"1f6b4-1f3fc-2640.png","1f6b4-1f3fd-2640":baseURL+"1f6b4-1f3fd-2640.png","1f6b4-1f3fb-2640":baseURL+"1f6b4-1f3fb-2640.png","1f6b4-1f3fe-2640":baseURL+"1f6b4-1f3fe-2640.png","1f6b4-1f3ff-2640":baseURL+"1f6b4-1f3ff-2640.png","1f6b4-1f3fb-2642":baseURL+"1f6b4-1f3fb-2642.png","1f6b4-1f3fc-2642":baseURL+"1f6b4-1f3fc-2642.png","1f6b4-2642":baseURL+"1f6b4-2642.png","1f6b4-1f3fd-2642":baseURL+"1f6b4-1f3fd-2642.png","1f93d-1f3fc-2642":baseURL+"1f93d-1f3fc-2642.png","1f6b4-1f3ff-2642":baseURL+"1f6b4-1f3ff-2642.png","1f948":baseURL+"1f948.png","1f6b4-1f3fe-2642":baseURL+"1f6b4-1f3fe-2642.png","1f3c5":baseURL+"1f3c5.png","1f949":baseURL+"1f949.png","1f396":baseURL+"1f396.png","1f3f5":baseURL+"1f3f5.png","1f3ab":baseURL+"1f3ab.png","1f397":baseURL+"1f397.png","1f3aa":baseURL+"1f3aa.png","1f39f":baseURL+"1f39f.png","1f939":baseURL+"1f939.png","1f939-1f3fd":baseURL+"1f939-1f3fd.png","1f939-1f3fc":baseURL+"1f939-1f3fc.png","1f939-1f3fe":baseURL+"1f939-1f3fe.png","1f939-2640":baseURL+"1f939-2640.png","1f947":baseURL+"1f947.png","1f939-1f3fb":baseURL+"1f939-1f3fb.png","1f3c4-1f3fd-2640":baseURL+"1f3c4-1f3fd-2640.png","1f939-1f3fb-2640":baseURL+"1f939-1f3fb-2640.png","1f3c6":baseURL+"1f3c6.png","1f939-1f3ff":baseURL+"1f939-1f3ff.png","1f6b5-1f3fd":baseURL+"1f6b5-1f3fd.png","1f939-1f3fd-2640":baseURL+"1f939-1f3fd-2640.png","1f939-1f3fc-2640":baseURL+"1f939-1f3fc-2640.png","1f939-1f3ff-2640":baseURL+"1f939-1f3ff-2640.png","1f939-1f3fd-2642":baseURL+"1f939-1f3fd-2642.png","1f939-1f3fc-2642":baseURL+"1f939-1f3fc-2642.png","1f939-1f3ff-2642":baseURL+"1f939-1f3ff-2642.png","1f939-2642":baseURL+"1f939-2642.png","1f939-1f3fb-2642":baseURL+"1f939-1f3fb-2642.png","1f939-1f3fe-2640":baseURL+"1f939-1f3fe-2640.png","1f3ad":baseURL+"1f3ad.png","1f3ac":baseURL+"1f3ac.png","1f3a8":baseURL+"1f3a8.png","1f939-1f3fe-2642":baseURL+"1f939-1f3fe-2642.png","1f3a4":baseURL+"1f3a4.png","1f3a7":baseURL+"1f3a7.png","1f3bc":baseURL+"1f3bc.png","1f3b9":baseURL+"1f3b9.png","1f941":baseURL+"1f941.png","1f3b7":baseURL+"1f3b7.png","1f3ba":baseURL+"1f3ba.png","1f3b2":baseURL+"1f3b2.png","1f3b8":baseURL+"1f3b8.png","1f3bb":baseURL+"1f3bb.png","1f3af":baseURL+"1f3af.png","1f3ae":baseURL+"1f3ae.png","1f3b0":baseURL+"1f3b0.png","231a":baseURL+"231a.png","1f4f2":baseURL+"1f4f2.png","1f4f1":baseURL+"1f4f1.png","1f3b3":baseURL+"1f3b3.png","1f4bb":baseURL+"1f4bb.png","1f5a8":baseURL+"1f5a8.png","1f5a5":baseURL+"1f5a5.png","1f5b2":baseURL+"1f5b2.png","265f":baseURL+"265f.png","1f9e9":baseURL+"1f9e9.png","1f4be":baseURL+"1f4be.png","1f5b1":baseURL+"1f5b1.png","1f4bd":baseURL+"1f4bd.png","1f5dc":baseURL+"1f5dc.png","1f4fc":baseURL+"1f4fc.png","1f4c0":baseURL+"1f4c0.png","1f4bf":baseURL+"1f4bf.png","1f4f7":baseURL+"1f4f7.png","1f3a5":baseURL+"1f3a5.png","1f579":baseURL+"1f579.png","1f4fd":baseURL+"1f4fd.png","1f4f8":baseURL+"1f4f8.png","1f4f9":baseURL+"1f4f9.png","1f39e":baseURL+"1f39e.png","260e":baseURL+"260e.png","1f4de":baseURL+"1f4de.png","1f4fa":baseURL+"1f4fa.png","1f4df":baseURL+"1f4df.png","1f4e0":baseURL+"1f4e0.png","1f399":baseURL+"1f399.png","1f4fb":baseURL+"1f4fb.png","1f39a":baseURL+"1f39a.png","23f1":baseURL+"23f1.png","1f39b":baseURL+"1f39b.png","1f4e1":baseURL+"1f4e1.png","23f2":baseURL+"23f2.png","231b":baseURL+"231b.png","1f9ed":baseURL+"1f9ed.png","1f570":baseURL+"1f570.png","23f3":baseURL+"23f3.png","1f9f2":baseURL+"1f9f2.png","1f50b":baseURL+"1f50b.png","1f50c":baseURL+"1f50c.png","1f526":baseURL+"1f526.png","1f9ef":baseURL+"1f9ef.png","1f4a1":baseURL+"1f4a1.png","1f5d1":baseURL+"1f5d1.png","1f56f":baseURL+"1f56f.png","1f4b5":baseURL+"1f4b5.png","23f0":baseURL+"23f0.png","1f4b4":baseURL+"1f4b4.png","1f4b8":baseURL+"1f4b8.png","1f6e2":baseURL+"1f6e2.png","1f4b0":baseURL+"1f4b0.png","1f4b7":baseURL+"1f4b7.png","1f4b6":baseURL+"1f4b6.png","1f48e":baseURL+"1f48e.png","1f9f1":baseURL+"1f9f1.png","1f9ff":baseURL+"1f9ff.png","1f4b3":baseURL+"1f4b3.png","1f527":baseURL+"1f527.png","1f9f0":baseURL+"1f9f0.png","1f528":baseURL+"1f528.png","1f6e0":baseURL+"1f6e0.png","26cf":baseURL+"26cf.png","1f529":baseURL+"1f529.png","1f4a3":baseURL+"1f4a3.png","1f52b":baseURL+"1f52b.png","1f5e1":baseURL+"1f5e1.png","26d3":baseURL+"26d3.png","1f6e1":baseURL+"1f6e1.png","1f6ac":baseURL+"1f6ac.png","1f52a":baseURL+"1f52a.png","26b0":baseURL+"26b0.png","1f3fa":baseURL+"1f3fa.png","26b1":baseURL+"26b1.png","1f52e":baseURL+"1f52e.png","1f4ff":baseURL+"1f4ff.png","1f488":baseURL+"1f488.png","1f9ea":baseURL+"1f9ea.png","1f9eb":baseURL+"1f9eb.png","1f9ec":baseURL+"1f9ec.png","1f9ee":baseURL+"1f9ee.png","1f52d":baseURL+"1f52d.png","1f489":baseURL+"1f489.png","1f573":baseURL+"1f573.png","1f48a":baseURL+"1f48a.png","1f6bd":baseURL+"1f6bd.png","1f52c":baseURL+"1f52c.png","1f6b0":baseURL+"1f6b0.png","1f6c1":baseURL+"1f6c1.png","1f6c0":baseURL+"1f6c0.png","1f6bf":baseURL+"1f6bf.png","1f6c0-1f3fb":baseURL+"1f6c0-1f3fb.png","1f6c0-1f3fc":baseURL+"1f6c0-1f3fc.png","1f321":baseURL+"1f321.png","1f6c0-1f3fd":baseURL+"1f6c0-1f3fd.png","1f6c0-1f3fe":baseURL+"1f6c0-1f3fe.png","1f9f9":baseURL+"1f9f9.png","1f6c0-1f3ff":baseURL+"1f6c0-1f3ff.png","1f9fa":baseURL+"1f9fa.png","1f9fb":baseURL+"1f9fb.png","1f9fc":baseURL+"1f9fc.png","1f9f4":baseURL+"1f9f4.png","1f9f5":baseURL+"1f9f5.png","1f9fd":baseURL+"1f9fd.png","1f6aa":baseURL+"1f6aa.png","1f6cb":baseURL+"1f6cb.png","1f5dd":baseURL+"1f5dd.png","1f6cf":baseURL+"1f6cf.png","1f6cc-1f3fc":baseURL+"1f6cc-1f3fc.png","1f6cc":baseURL+"1f6cc.png","1f6cc-1f3fe":baseURL+"1f6cc-1f3fe.png","1f6cc-1f3fb":baseURL+"1f6cc-1f3fb.png","1f6cc-1f3fd":baseURL+"1f6cc-1f3fd.png","1f6cc-1f3ff":baseURL+"1f6cc-1f3ff.png","1f6ce":baseURL+"1f6ce.png","1f9f8":baseURL+"1f9f8.png","1f381":baseURL+"1f381.png","1f6cd":baseURL+"1f6cd.png","1f388":baseURL+"1f388.png","1f6d2":baseURL+"1f6d2.png","1f5bc":baseURL+"1f5bc.png","1f380":baseURL+"1f380.png","1f9f6":baseURL+"1f9f6.png","1f38a":baseURL+"1f38a.png","1f389":baseURL+"1f389.png","1f3ee":baseURL+"1f3ee.png","1f511":baseURL+"1f511.png","1f38e":baseURL+"1f38e.png","1f9e7":baseURL+"1f9e7.png","1f48c":baseURL+"1f48c.png","1f4e8":baseURL+"1f4e8.png","1f4e5":baseURL+"1f4e5.png","1f4e7":baseURL+"1f4e7.png","1f4e9":baseURL+"1f4e9.png","1f4eb":baseURL+"1f4eb.png","1f4e4":baseURL+"1f4e4.png","1f4e6":baseURL+"1f4e6.png","1f3f7":baseURL+"1f3f7.png","1f4ea":baseURL+"1f4ea.png","1f4ec":baseURL+"1f4ec.png","1f4ed":baseURL+"1f4ed.png","1f4ee":baseURL+"1f4ee.png","1f38f":baseURL+"1f38f.png","1f4dc":baseURL+"1f4dc.png","1f4c3":baseURL+"1f4c3.png","1f4ef":baseURL+"1f4ef.png","1f390":baseURL+"1f390.png","1f9fe":baseURL+"1f9fe.png","1f4d1":baseURL+"1f4d1.png","1f4c4":baseURL+"1f4c4.png","1f4c9":baseURL+"1f4c9.png","1f4c8":baseURL+"1f4c8.png","1f4ca":baseURL+"1f4ca.png","1f5d2":baseURL+"1f5d2.png","1f5d3":baseURL+"1f5d3.png","1f4c6":baseURL+"1f4c6.png","1f4c7":baseURL+"1f4c7.png","1f4c5":baseURL+"1f4c5.png","1f5f3":baseURL+"1f5f3.png","1f4c1":baseURL+"1f4c1.png","1f5c4":baseURL+"1f5c4.png","1f5c2":baseURL+"1f5c2.png","1f4c2":baseURL+"1f4c2.png","1f4cb":baseURL+"1f4cb.png","1f5c3":baseURL+"1f5c3.png","1f4f0":baseURL+"1f4f0.png","1f4d3":baseURL+"1f4d3.png","1f4d4":baseURL+"1f4d4.png","1f4d5":baseURL+"1f4d5.png","1f5de":baseURL+"1f5de.png","1f4d2":baseURL+"1f4d2.png","1f4d7":baseURL+"1f4d7.png","1f4d9":baseURL+"1f4d9.png","1f4d8":baseURL+"1f4d8.png","1f4da":baseURL+"1f4da.png","1f4d6":baseURL+"1f4d6.png","1f9f7":baseURL+"1f9f7.png","1f4cf":baseURL+"1f4cf.png","1f4cc":baseURL+"1f4cc.png","1f4d0":baseURL+"1f4d0.png","1f517":baseURL+"1f517.png","1f4ce":baseURL+"1f4ce.png","1f516":baseURL+"1f516.png","1f4cd":baseURL+"1f4cd.png","1f587":baseURL+"1f587.png","1f58a":baseURL+"1f58a.png","1f58b":baseURL+"1f58b.png","1f58c":baseURL+"1f58c.png","1f58d":baseURL+"1f58d.png","1f50d":baseURL+"1f50d.png","270f":baseURL+"270f.png","1f50f":baseURL+"1f50f.png","1f50e":baseURL+"1f50e.png","1f4dd":baseURL+"1f4dd.png","1f510":baseURL+"1f510.png","1f436":"data:image/png;base64,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","1f431":"data:image/png;base64,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","1f439":"data:image/png;base64,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","1f42d":"data:image/png;base64,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","1f430":"data:image/png;base64,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","1f98a":baseURL+"1f98a.png","1f43b":"data:image/png;base64,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","1f99d":baseURL+"1f99d.png","1f43c":"data:image/png;base64,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","1f998":baseURL+"1f998.png","1f9a1":baseURL+"1f9a1.png","1f428":"data:image/png;base64,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","1f42f":"data:image/png;base64,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","1f42e":"data:image/png;base64,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","1f981":"data:image/png;base64,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","1f437":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAyLSURBVHic7ZtpkFXHdcd/5y5vnY3ZgRnEIgYGGBYBAmGCQqIgETm241QRV1xeojhVSSVxEtmpVFyVRC67knxwUolLdr44iSJZkY1KiRNZFhjZSGJfDBpgEBow28AszL68mffevbc7H94s7828lRnEB/Ov6qr7pk+fPuff3adP970DD/AAD/AAv8CQiQd9tOWHiN4JDKNpRTiKoQ/h2O/K9pXD99HGu4Y+fKkY29mBkh1oHkNoAIrRHJBtaz4ByQQcu9BJV1+NFkHKisBnT1S5oE+DHEX0WcQ6KVsaW++DPzmhDzevwDI2o2UDIo+h9WbAAtBxBwZGEg5Xl9+Wx1bXMVE5jud1z8DX1MAwSiuYV4JRW4FZXmohshXYihbQHvrYhTZgP1q+x2OrDoqI+rCdBdB795rUr9kJ+lOgdwH16IlKDVrj9Q2iOnpgYBhDDIyyYqS67NsTOqZmwOnTNv36gnfucoPyPJTn4bouOuDHv+Ih7KryTHa0IfofCarvyLp1kXvn7hR0c3OYiPn7CF8C6tLJON19xFqvI2NxTMvCNE0M08Rc2/AB82iSTZscSCIAQJ84v0m39Z5wr7YZnufhuS6u6+K5LkZ5KcUbVmEG/ZnsuoU2/kS2rfrBnHo7DfrY+U+C8U3QC9PVe9Eow2feR/UNYloWlmVNEmAtXaikvmqLbGk6PSEv0xXow+f/1T1z8Q/cyNgkAa7r4joOyjSpfHwzdmlxFhPlm7S1PCt79ngpeo8316GspzH040AjmnogDKKBEeAmoltA3sZz35CPrLuT0v7gQQt/1T8j/FGmnuMDQ/QeOoXhKizbxkoiwAqHsB5Z+S3ZvvaPU6ydSUDzCtXVdyneemNy9CcIcOJxlGWxYPcOrFAwCwn6Zbau+YyIaH38/FoUzwEfA8wsjVJ8QdiLNr4q21Zf0VoLx1v+C/hUpgZuZIz2fe9guB62zzdJwMQs8DUsxphftVy2rb6SlQAA/e57bdEj79W5jpMyC5x4nLjjYJWVUP/rv4wYRmYXFH+N6BI0zxbg+HTEQP8thmEDX8skpLXm1ptv4/QN4rPtBAHJo2/bBD6y/obsWL94etv0Htj220ZJOKF8qpfEs9ZEu3vpPduS3XThq2j+grt3HsAP8g8o/Vw2oZ7T5xnr6kmxMdl2o7QIbOtgurbpCdDqnJSlrnM9TaTv/AdE2jrSW6QUKGVMbEVzUEzUdAsSiLR10N+SmpZMl5TSIoBz+RNgSJtRlGaNa53y3PnuSZyRaTufUjMtmAtozXQS3MgonYdOpY64ntm5URQGkbZ0ajMsYrklwcBUTpFix9QvLx6n/SfHUI6TauTcjXxqSSJXxR1uv3UELxZLIWm6zRqQkB+QW/kT4LrdRigww4B0Axvr6+f2W0dQcRc8nejxXhbPQ8Vdbr91mFjfQFrz9TS7jWAAPK87fwKU14dpIn7flNKE5rTiY53dRG7cAq3usfcJhwZbryaCXnrvU35KwAemAWL050+AN9gPaCPgnzHq6Siwi4ooql9470d/vJQtewgzaXAy2aYBI+AHUNxqGcybANm50wV6JTntnbbFJKNi3UrESJtS3BOIaVK+ZsXMijQ2jhNwZ3pmOlmfpZsOIxhI6CX9yAPYxWFKFtXdu8CXoZQtX4IZSH8u0TAZrCXhQ4b9OisB+pZRHJzqFNKOfmVTY1KvH14RMahYnX4WJD8bxSGAtDtADgLkrFlSlEb/VAd2cZjiRQs/fO/HS+nyxZiBQFrbJmCWhEE4WzgBWk4ZwQDY1oT21GUgQs2m9eN196cIQs3GNalmj9sKgG0ltkClTxVOgM88jIjjq62aqRiYt3wJoZqK++f9eCmqX0DxoqQ7kaSB8s2vBpE4GEcLJkA2regBXg8uWwSSGuH9pSVUrl11v32fLDWbmrBCwRkzNLisHpD/kW2r+womAABT/sYIB2Ilm5sQc/xQZwi1WzYktr0POfJnKoZlMX/rI8g4J2KalDzahBEKRNHec9lczLl562Mtnwe+40WjZuRmO3bAT7B8Xq5m9wWRrm48z6PooYUYfr+H1s/ItjUvZmuTV/aij5/fhTa+gec1MRYjda5NwVOKSCxKSTBUuPU5EIlGudLZwUOV1ZQVhTMLhgNgyDlEf1m2Nh3Ipbeg9E3/+OQZNBvS1Z283MpXXv4uvcPDrFu8hG987vNUlpQUoj4jzl69yp+/8O8MRiIEbB9f//Sn+dWmtemFRX4suzY/ma/u7DEgCXrfiadRekO6Ndg10M/Xf7If3/jVefP1a3zphf+Yk/Udc+L83YF91K1PbHdRJ85XXn6JroH+9G2U2qXfPLl5zglA82ymKPzq0aOEykopq66aFD934zrnb9yYdYQ/eO4Cg2MRTGvK1Ljj8qOf/SxzO/Sf5uuWlVsE9Bsna0E9nqn+SmcHrRcvzvh7a0c7TYsW5WtLWtzo6aK7rZ3utvaUv1+7c4eMwQg+ofc3h+XJ3C9q8psB4v0mWpuZpqnftNBaz0hFA5Y16yVQEkh//V4WDGVrF0aN5hUH8iNA663ZjFxTP3OURYTVdbM/JW5cugyRmbF649KlOdry6NwRoGjKtk4/+egWakrLUprsXreBxZXV6duMxaFnEDp6EqV3CGJOWtmG2vl8fOOmFN1bHl7OjpWN2eOHpzNsE6nILw94/cgokO1VEB39/fz9//2Amz3d/NKKRr64eze2OS3ExOLoO30wFkuvJBRAqsuTX80DoLTiu4cPcfrqVVYuWMAXdj6Bz8r1ukGuyW9sW5pDKI9MUGvh9SOzfv2t+4fQPf1Z4taERYLUlCNpjuIFoks+tr02l1DuXeDVizb+XFZnh+ruR/cP5SesNbqjB8PxkPJZJVIzLw3TIDcBwTGLtLdp+UH1D6H60t5HZoXX3YdpmUhxlrQ3O/IiIHcQ/OjGMdDRu4ngejSK29WDUgrXdRkYGsb1PJRSaYvjugwMDU3KOO130DHnbneQjEfgZOScASKi9WvvdCAsyUdhMpyubpRSxONx3m+7ybWhfkL+ADsbVmFPC2Jj8TgHLl1AeR4N8yppqKvHsiycrm58dTmXcjpkvAdMRl6ZIJpzUBgB3kgEZ2QUrTWdXZ3cHhniwmA/vbEYjsBTDauS9Gteu9DMiTvtLAiGCJk2pXf81NbU4A0OY1XMm7jezh+a5nzE8jwLqOOFTkGnfxClFLFolGjcYSAe59LQAMd7u/j+5Uv0RUYmp37bYD//ff0yp/u6+fnwECOuQzQaJR6PJZbCwGDhS0DUibkjQBlvZM86Zpb4SATP83AcZ/ymRtMfT+z/l0cGabnTied5eJ7HmY52OqKjAAy7iRetAjiOk9AxHCmob0DhsW/OCJA9j59H65a82VcaNxZHKYUYBpZhUGL7qPZP5VK3hocmZ8DNoaldotofpMiyMQ0DEUkE0GissNFX6qeyZ2fnnBEAgNbfKmQQlFZ4nodhGPgsm0p/gMbSeVT6A9QGQoRNa3IGzPP7qQkEqQ8VsaKkjAp/ANu2AcHzPBS6wAmgv02eyC8IAtD7b6iKLyPkTC8BrFCI6EBiZIPhIPOVx+qSeZgiOErRWF6B5yUSjHUVVXRGhgmbFitKSqkOhQmGQpP1/nA4MbL5oZn3D/1vvsKFXYm98tZvI3wvH1k3GqP74gcodyqLcjyPUSeObZqE7NQ8JRKP4ylF2OfDTPr4yrR9VK1pwLRTzwcZoDDUr8ieXe/k5RAFEgCgXznwfWBPPrLxyCg9l6/ijEUL7QYAXzhMVcNSrHy3QC3/Ir/zxJ8V0kcBS2Aco8EvEIyuAL0ul6gvFGJ+0yqGOru4ee0aYZ1fyBkRzZKHl1FUXZW4C8hv9h+iLP6XeUkm4a5e6utX9tej5KfAw/m2efXMKf7z8CGWhYtYGAxT7vMTMEyUQMzz6I1HuTUa4frYCF984il2Na4uwCI5g+39mux5Kq/0N6VloQ0moF/aNx+RN4GcM2EC7YMDvPbeGY5e+zmtXZ2o8cBmGSaNtbVsX7ac31q/kYpwQQegd3F8H5ff3Zn+g6EcmNVnHXrv3iDRkucRnrmb9kPRKIZAkT+QW3gmFOh/oi7wV+NftNwV5uS7Fv3im0+CPE8BS2KWaEbrP5TP7T42W0X5J0JZIJ/dvZ+xylVo9Xto3Trbi9As5SzoPVw9/shcOA9zNAOSobUWXti/HUN9Bs1TQP0sVV4B/SMMXpLPPn06t3hhuOefdukXf9iIJ5tAHkH0wyT+T2A+YANlJDa5QSAG3EbLbUR/APoMmpPyzEev3msbH+ABHuABfmHx/3kyvXB+e/NPAAAAAElFTkSuQmCC","1f43d":"data:image/png;base64,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","1f438":"data:image/png;base64,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","1f435":"data:image/png;base64,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","1f648":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAABDESURBVHic7Zp7kBxHecB/3TM7M7t3u3tPvU466/Q4nwUytozABmELW0hgYTBOnewULydAkiKVVFFU+RFSqUuKgGyTkFSSqpQJIQmhsO6wrTzAkrGNLcsGi3KwsSVZknWS9Trd+27vbm93Z6Y7f8w+T6e7nZMMf8BXNTszvf11f6/++vu+Hvgt/GaD+HVN/JXOj7b4wvsM6A+D2LOze8/Xfx10mL/qCbvu3uxk0naXj/slwAIwpPoUwL2dW5JSmO/XWi0HMAye+OtHnjz9dtLzK7WArk9+JJFx/f8GcVNZc87QkVW+dL+O5i4gkiftmzu793wZ0G8nTW+7ALpuuy02UUvsb77/P0P379j6fY24a5Zuw0Bj2Xvf1IRsa6yt1QfB7+np8d8u+t42AXR2dhqrZerv0PwxINAijdCxKtGHhBantNDvCnD5uRbiHx/o3vM9LrNFyMs5WDn09PT4vlI/AI6B1ggdE4AQonjJ/FXeltdIkxZ6A2AAEqGvFlqd6+rquuwKe1uc4D2d294jhX4QxE0BUwIhoGBw4iJsaF34U6N1oGodNE4ixURXV5e63LReVol23b3ZyUzbOwXiTwTIQKvBNAX+BRUPJdDBT/6Wt/O8ILRGg6/Qf59OyT/7hyeeyF4umi+bAL7S+dEWZXiPCc17CowXTFqIguaL7M8KhcUdaL3IeHAvCkK/5At1x4OP/Pjc5aD7sgjg3s4trYY0nxFCrC4yXsZ8pRDmmjZgFGYwX7iXBPGW8rybdz76VO+l0n7JAvjy797WZGv3gBSirZzxgnODgkAqzf8iK4DCMihoHIK7miEIpfVxnXXf+/XHnx6+FPovaRfo7Ow0HO31SCHbZJlXN6REytKzIQVSSGS+3RDl7xIpZNAmReld5sfJtxefi5dcLW1rV1dX1yXxcEnI7cbkl6QQm2WBoUoC8wwVBFEunDyDIn/lGS8wWehbwp9l7OD5FvfIS396KTwseAl03fWhZb6MHBNCxCr3c6jY2ylfAjO3wcJDwdQLbxXev9zsi+2q8K70lOGxpqvnR+cXwseC4wAf634hqGC+dK8MeBYvqae5qZ6xkTHOnx9lph/QiEAGQrNkSR11DfUMDo7S3z9aEkJeYBqNomS6SlLjm+pe4EsL4WNBFnBv55akHbH7pBTRCgFIQUfHFWzceCWpoSGe2XeYrR9+L2vbVwAwNTbOvude4c3j5ytnz2u+fc0SNm2+hppEEoBjR0/z5J6XuPnGq0g0NXHgwBGOHHkLpXSFFSilp6RQy7q+90QqLC8LsgDbtO4qMC/KmF+/fhXbt78PhMDIpvjMZ7cSTyZKeLEoba0N9J4YqBwwL4grWhuxnWixeW37CpYsTjI11M+S5Yv5RMsifvhDg9de60WpAE0CSGqUkp3At8PysiAnKKS4vbDfF5xVY2OCbduuByFwMxmcmtoK5gGmxkdJNjRwy9aNNDXF855e0Nyc4JatG0nW1zM1NlaBE08mcGpqcbMZEIJt266noSFRdK5lQdftC+HFCIvQtXmzKZP2P0kp7ICAwNvf/okbqW8IGJ4YGiS5aHExDgBwsxmEkNQvaqapuY5ax6C3tx8hBDfdtJ41HSuJ1yXQvhcQZpaM04rFmBwexqmNIw1JY2MdBw+eAAKvkF9CS9uvj3/j5Zf7QuULcy6Bezq3fkgKsQP4ALAcICfEgCNEPEhwAoe3etUyWluX5BnNYto2QpYblyabTlNb31BssSMGRl5AllXSQzSRZHJ4GNNyiruFlAamZeFmM0Rsh5VtS2hrW8qJ3nMoikFWvHG8+eh9O7Y15yVzWmueF9C9s3vvUxfjcVYneP+dt7Zr7X8LuHHmf4YUOFaktM8Lwe99bjvNzfUAjA8MkGhurtB+OjWOU1OLNEqMjpw5xxtH+vA9xbp3tNC4fFnxP+X7ZKcmieadIQRb38TQIInmRQAMDozynX/9YcEJorRiOuei1GzlAv2c7+svPPToj49dwM/Mhnt3bL0R9FNAB4BpGDTW1dCQcIjHbECgNcUA5boNa1l/9Zoi4b6bw46V6h5aKfycixUtOTc3kyE9PkFTYwPNTUmU72LF7KLZCylxs1mMSAQhAksSQuBmM5hWYF01NVGmUmnO949SSB8d26QpGSNRa2NHTHKuQgXp9EpDik9+YP2an+5//fipiwrg/jtvbc8zXy+AVSsWcfWVy1nclKAuHiMRj+K5HtNZL3B8dXFuu20TpmXmNZ0iGk8gy8w/nRonGo9XWMRo3zm8rELKAM/3fNxMmliypHEzYpGZmCDiOCViIxaZqUmsfFvL0iaOHnmLTNYFoCEZZcWSOhrr4yxpTtK6rBEpJWOpNBqiQvPxTevWPLb/0PGRwpgVu4DS/j8D9VLAdetX0bF6GU7UIRKJYNkWjc313HTLRtZ1tATO633rcWIlAoWodF4AUsoKf+Dlsng5FyENlO+jfB8hBJ6bw8vlSmNJWSE0CMYub3FqHDZvehdCCK7qaGHzLe+mcVEjtmVjWRaOY3Pl6hY2vHMlQZmFBoT+l4oxCw/37di2RcBfALSvamFV6+JislIgZsXKZaxe20rr8mZilqS9YyURxyox57lELLv4npueJmLbSFkytNG+8yhPIKUZbGFSFM3czU0TS5S2TikNfDeHYUZmn0NALGoRs+D9m65hybLF+L5iYnwSwzCKV6I2BhqGxyYAsXLTutXP7z90/MRMC7gTIGKatK9aipASaRj5bE5iGAa2HTAbS8S5oqUep6a0rrVSFcznWyuI912XbHoKw7Tz40ukNPLPNtmpSTzXLWknEimmxAWIWBa6zNE5NVFaW+qJ1tYG77aFYZqYphkIIK/E9rZlWGagCCHYURRycSTBJoAlzXWYhhEkMfneBUuo2JsdG2FUxlGmZVW8lzMPMDk6TCTiFKPHUo0weDetKFNjIxU4csaSMi2b8sKwMGTRJwRCMwKrFaJouUIIzIhBc1MdABpR3N1KHOhgn68pW9NQ2ieFkMSTJe8+U9uV+/7sxKfHU8wVewltkh4fr2ibKcTZ5iqnpTZRW1GJKod4TZG3liKNZf/ritsMyPk+jlOaaCZzs0FFJJiZRvk+yDnwpIHyvCDsnWWMi6KV0RKN2rhq9mBQz/JYvgTOAkymKwuuhXzcmzGYaV2ombkgNz2NGbG4UC8lEAjMiE1uOh1qbDNSSYt7EVVOThUFe7bwUBSA1jwP0D84huf6pSKkUvQPjmEYlaZ7ocObG3zfA1FF6iElvhvuJCxiV9JimAb9g2NQVkvwXJ/BoWKita84XRFJil0Arudx9OQ5lFL4SuH7PsdO9pGaqNRKNUugHJTnI2UV5iwkyp9pb/PgzKBlIpXmzZN9+EqhfB+tFEdOnCPnBYKV0F3ELTx87ZE9T4N4BuBo7znOnh/C8zwGh1OkJqcZGQ1da6gApRRKzc+Yrzz0RdZwtTA8kmJsIs3QyDie53Hm/DDHTuSPETTPfq17708KfStEZ2r1eU+IAxqa/u/1k7QtbybnBUSfOT2A63pEIguroinfQ/kKY55VoHw/WC4LBNf1OHt2EIAz54bpHxzjxOnBoOIGIxq+UN6/Yj/5as+TJ4TkjnxHes8Mcm5gDK2DgQ8eOoHnLUw7biaD1hp3DnzXU6CDlHoh4Hk+r7/ei+t6aA1nB0bpLWNeafHxnT173yzHuUAf+18/fuqGjlWPSyHWI1gJ+SIngtTENEePnaN9bQumWX0txc1mmBgeJp3TfPqrP8K2Ta5c0Vjc4rTW7H7+KH/+rZ+w/YY2DHyiieQFecVcMJ3J0d2zj7dOnic1kQ6Kp8VtQDzjC/mxB7v3vDoTb1YuXjzcO7L/0PF/f987O16TqDsLp7vpqQxZV3Hq1AAdV66oWggTw0PkpqeJRmvo7Zvg0Z+8Qe/5cTZfcwUAf/mdfezed4Qb1q/g5g2tKN9FComTD2/ng0wmR8+jz9M/MMboyBhKq/zpsgYt7tjZs+f+Fw++OTob7pxu+Z6PfSwunWyqeDghBfF4HI1g8eJ6dvzOB3Aci+GRFP/5vWd4x7qVfHDz1RhGefaXo//EcbRSWE4SKSNkcj6+8qnJJ1JTmRyGNHAsA61cspnxoJy+eg1mpBRe+77PM8++yqHDp/j0J7fQUF8baP4H+xgYCLa4yYlUsUCilMazde03vvvk1MV4nLMoGtuwYQqCmkIhLnDzyUp//yi7evYxMZHm8Bunybkev3j1TR7/rxdw3bwT0zDadxatFJ6SSBkELI5lFJkHqHEsnHxZTMgInhJorRntO1uMZlzX47HdL/LKq73kch6H33iLVCrNru7nisx7rltxiAr43/juk3NGVfNuzPft2HYaWF6wAsexsexSvmCaEhB4Xil4Wd7SxB23v5/0yCBTY6Nkch6/PDbKjRuvmm86AJ47cIh3tTfgWCY1dQ1E6xt5bPcLnD1XOgeNREy0VhVOOZfJkMlmi9oHTu7s3ts211zzexnNawiWF9aU71d68dl2hTNnh/j2vz3BNWubiUZNfnF4gNZli+adqgCJ2lr2vXyWa69q5lRfileO/pypdK6iT9HKysDXqlz7gHhtvrmqyGj0SyA+Un5OVw1MTeV44ZViyM2kHufpV3/G4FiaqYxLNusxnQuWU9SKYNsmNU6E5voYSxtiZFNpnvrpW1XNVQClVHEJAGg4MB/OvALQQuwWmi7IH0qq8F+spaZd/nf/L0PhbL92KcmacAlXQQBFMPTj8+HMezL0wK69r4J+DQJ/5M9adp4bTg+Fy+4Azo5Oh8ZRSpc+s4FXHvj+3oPz4VR1NKa12Fl6Dh8JDk7k5u80A4YmwkeD5doXQnytGpyqBNBLYhfon+WHDk3YurbFoXHeuXppaJwSiBecq65/tJqeVQmgp6fHV1reDUxVU6EpB9uO8PnbNtCYjFa0N1smiYhBImLQbFW6oua6GL//0WuwQxZd8sqZQOu7q/2msOrT4Qd79hyRUnxco935e5cgUePQmIzy0Be30Lo4iQC+0Jpk14al7L5uGbuvW8Yj1y7lcyuC/1YuTfLQF7dQH4+W1/CqAgGeRnTOTHjmwQkHf/XZ2+9xotEHqu1/xbJGbr5hHQCer3jyQC/P/uIkx04OUetl0QjSkQhrVy7ig9euZMvGNsx8KP3Uiwc53Tcy1/AVkE5nvtz1H4//bRh+Qif3dix6NMznytGykNc0JLfesIZbbwjOEqezQTATtWcnoxy3GqiJOhccfs4HoQUgEIvCfLAddS6+ji/GeAFiIQUAovpwMw/hBaB1c5hI4NCxM6AUixfVs6ghfkFxdSZ4nmJwZJz+wVEOH+8LRZuWhN5uFlLfWhum8/BIiqf7hwDyJ8q1xKIOtm3h5L18JueSzeSYymQYGZssnvFbVoTa2nj1k2kVijZYgAC0oCOMD9CoEaABgkhtcGQCmKgKVyk9DiTn7VgEcWX1fQMI/5GUItQkUcu5FbgPOBMC7TRwX9KJfSTMXBCONggpgG/+waeWIqgLgyPsSP/O7r0PjNQNrRKI7Qj9EIgXgFNAOn+dAvYj9EMCsX2kbmj1zu69D3h2pD/MXEDDQ3/06VCOMNQSyJmqQ4RMBWzXTwE8/PDLLvCj/FUVRHydUiFtVGi/AxiYt2MeQg0vVPDdUBhIrRhc8IlKnPj4/L0qQQtdXdkpD+EEoPXGUNQIprq6nl3wKccfPvywC4TKizW8O0z/UALQgveG6q+5tPO0AMJawfWXYc7fwm8M/D9JKa+mhSwj7wAAAABJRU5ErkJggg==","1f64a":"data:image/png;base64,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","1f649":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAABGESURBVHic7Zt5cN1Xdcc/9/7epsV62i3JmxzbMbYhrqPETnAAxzi4WWegVRpCQzOUpUNaJhSGwMCAJi0kIWwtFAaYoQ00hdhkIaFxHIfEkNAQL3E2r3KMN1m79Cy9p7f9fvf0j9/vbXrvSfIG0yln5un3u/fd5XzPPffcc859gj/R/29Sf6yJP995wxyb1G1KqWsFtt63aetX/hh8+P7QE3bdvi6UmAh2OaQ/qVABAMS5DeCuzg1hrXxrRcxcAMtiy5d/9vSJC8nPH1QDPnPTTbN0KPEEqHflVact8S90dPoehFsAv8faN+/d9NSnALmQPF1wAXTdeGPleDWVX//pE0OfvXnjfwHvL9FsGGjIK/fGxvXChupq2QvO5s2bnQvF3wUTQFdXl07u+923BPl7QCFqAiWVM+krqCENxwVZ6fZlpyj1nfs2PfUg51kjrPM5WD5t375drly+cEIrtRakHkVAAUqp7Ed7T/LqvBWpBFoBDSiUNCiR72+4+bZj27dvP68CuCBG8DOdG1drJV8F9S4XlEIpyCicKqN3IpkvBRF3qcWtjKLVeFdXlznfvJ7XLdB1+7pQIh68V6H+QYF2V9WdJoNfUfCSI3H/eA9Pzz1BiCDgiPCvsXH1uW9v2ZI8XzyfNwF8vvOGOcayH1HC6gzwjEorlVn5LPySlNFtd9WzwN1nVhDykqPM+776s22nzgff50UAd3VumG9p37NKqUVZ4HngC4Uw1bQuUJgEPvPMCeKYse319z78zJFz5f2cBfCp99/YGJT0Dq3UwnzgWQNHRiCF6l9mB5DZBpkVB/dpJgnCiByRZHr1PY/+avhc+Nfn0rmzs9MKib1ZK71Qe1ZdK4WlNVrn3i2t0EqjvXpL5Zc1Wmm3TqtcWXvjePXZ9+xHX6SDgU1dXV3nhOGcOl9sRT+plVqnM4AKGfQAZQSRLxwPoPI+HvAMyEzbXP8SY7vv69MHX/rEuWA46y3Qdcs1bY72dyulKjOMZVQ9955nB1T2LMg7BjMvGVXPlAqsf77aZ+tNpmwkZtks7tr8ZN/Z4DhrDXAIfG4y+JKakN0OnvrnbQdL51Y/o/b5bXWx2k+aS6G0qnJ8ctfZ4jgrDbirc0M46A/2aq0qCgSg8z08d+U1uXfInQoFs0vuUXAEChhy1t9kNMFIgRYYIzGtTFvXg1vGzhTLjD1BOfDwWrT6yMR45OT933jkJIqKfFXP7HVVoBHFRyJ5zyx5RREBpVzA3lMJGFTGRXL/ajDG7abdchX4bo7t+o+2ynD1XIz6oVr6FzvPmwDk0MPXA4+B+MQxrO5YvH/nnsM5VdSTt0GxJhTYgbLHoPL2v8rtfzzX2GtncqDBuGWFsKZj0Z1i7BWIAsXt0r35BrWk8+lzFoAc+cVsbPuBTNuJsdNYllqkmbTCHmCfZTG7uZbW5nqqqoKEggFsxyGRSBGJROkfjJBMpIoDAhGCoQDNTbXU1VUTCgXwWRaJZIrYRILevlEGBiOkHccD7Q6hERCFZekl8fExqmrrAPyIflAOPrFMLb1x6JwEgGP/C16sPj4yjJO2GRgcC6g8NddKEQz4Wb5kLsuWzicY8JcXKNDbO8zB7pOMjcUACNdUcfHFc2mbXV82UlqxdAHJZJp9h06wv/sEyVQalGA8G9PbHwm8dXEz0dERquvqARoh9Q3gg1PBm9IIyuGHr8bwLEByIkZ0ZIT6tjmcOnmKB/7zuSz4poYw697+NmZVVyAi2KkkxrYxjnGVV4FlWWjtw/L70ZaFiND9Zg/plM2ytyxAa4VxbJy0jXEcHGPjdlVoS6N9PnyBIEopYhMJtv/P6/QPRjJHIbd9YD1t89oY6T3JrIZGghVe6kHUO9TS971QDmPZY1BEFIZ7ABzbJhaJUD9nLkprwjVV1MwKoFDMaW3g+g2XMau6gnQqSSI6jp1KYYyBvCNOBBzHJp1MkE4mALh48VxWLG9HKbz6JI5jI0j2qEQrjDHYqRSJ6DjpZJKqyhDXru+gbXYDCkU4HKKurhptaRrmzCM2OoqxbW+J5Z6pFrm8H9D96PXAGoDY6Ah1rW1Z6z0+eppk0qG+tor1ay9BKU06HsdJpVBao7RGawvtvSvL8vwBC6U1CNipJOIdZ3Yq6a52fj/L8sq5fkprnHSKdDyO1pp3v2MldeEqEgmbaOS0i1cp6lpaiUZGMkiuku6fbzxzAcCdAKl4nGBVVRa8nU4RHY9ipx2uvGwZfr8PJ53EiEHpPKDWZEFYripnhKI1xnEwjp0nNI22dOE4WqOswnGMGOxUEr/fYu3q5aRtQ3RsHCeddoWgNYGKSlIJV9Mw6s4zEoB0/3wFyHoAO5UiWFmV/S7S3y9vHOhhTmsDLc11iDEYY1wGPeaV1sRTDr9+tYfuU5FCbcgKwkJplRNSXt8M+EM9EX79Wg/xlFPU1xiDGMPsplraZtfzxsFeRgcGsumyUFU1trfVUGyU/Y9cXApr6VNA1AfxDKS2cmnDdCJO7PSYdL85qN5xxXJXuMZBayszEQrF8Ficz3z/OXoGoyiluOO9Hdy4dnE2FshY+kxuIOP9qYwXiPD4C91897GXERHmNFVz/9+tp35WyDWqrl3FGIOlNRctaOG3O/axavkcSTc2KH8w5K6ulYWnsOSvgS9OhlqkASKigE5wjV+goiL7XXRk2Lx2oFcbhKbG2uzYylPdjMr+eOteUhVhghXuqfD9X+whEs3Zh8wRmssRer6E9/3oeIqfPPcm9a3NAPQMRvnx029M0pYc67MbwxgRXj/Yq6OjI9m8YaCiImcM4ZbilS61BQ4/vBxYCGD5rJwGCMTGorK/2w26qiqCIGRj+oz6itLsPDbGsjUdzF/ual3acdi+51ip+UvS9j3HaF+5nBVr1+APuJdHz758DPK3kTcvCFWV7orvO9TLRGQsuw20ZaF9WQ1eIgc2LZ08V/EWELU+V8i5CXY6SSxpW7Zj0Fq5rqkCpQplOBSJEhke4ejeAwz35CLUU0PjMxZAz9A4x7uPMXyqj3QqBUAq7TA4OsHses8e5TlMmTA6bRuXx1QSXyBYhAHtuxo4mD9XKSO4phRTju2QfycRmyiTmBWFcQzH9x0idjoXnKmpfa4C0goiA0P0dBem/JQuPUYsnshNj+A45S6SpAhbKQG8pWRXcQj6cwaxf3C05BRNdZUE/cWKNbd5VhmmimluU3HbUMCiMVxRojX05fES8lmIU/b6YNnkilICaCvVU6HxKcHn7akjx0onYLRSXHP5woI6v0/zzj+bX46pIlp3aTsBf+Gl1XtWX4QuEyccOdafncfSUlZTKIGtlABCpXpmjMmCeQ0g0DcwSk9v6UDr9utW0t4advspxZ03r6FuVunVK0W11SE+8ZeXZwEvbKnlbzauLNm2p2+E/oFREFgwr9Gd0yp741fERCk/oB+om1xp+dwIb/HCZo4cHUBQ/G73QW54T7go+gtXBfn2ndey51AvbY2zWNASLsdQWdq4ehFvmd/IqeEoq5a0EAoUg0qm0ry4a7+XNxAWtzcX8FqCilasSAOe3f56SfFpy0IpRUO4wkteCGPROL96/lVsu3jPhQIWV751bgH4ZNomXdZAuVY8lc59v6AlzJUr5pQEb9uGZ59/lfFoHLzkSX1tyA3Ry2jAb37zehHeoooDB483H/X2VFFjnw+/FrRS2fzdwFCEXa90lwWVT9t2/p5bvvgoj71wMOv94Y3zi+cP8ldffJhtu34/7TiCsOvVbvqHItnMkVYavy6/+sdPDLB3//HmIkyTK4xjYlu37WZgMAJAPJ7EGJfZTBxfF67IJirDs6q4dOWiGQngmssXcunSFr73yG7ufiAXot/978/z3Ud307GsjWsuWzjFCC4pFB2XLKK2pjqbJq+vdXnK2CpjhFTKDY6GhsfY8tQujHFik8cqsgGJVGoonpC2B37yDH6/j3TaZs3qpbzzqrdlT/KamkqGRydQFlx91SUEShx7pSjo9/H5D17Fp25xcExO1T996xVY2iqp6uXI7/ex7u1v5ZEnX0QM1IQLf3vxwm/f4KWdBwkG/SSTriC0moENECNZryKddv3oSMQVnDG5vS4iLFrQSm1NFWdKoYBFVSiQLVeFAmcEPkO14Woumj/b3U6ZQMrjMXLa5TkDHsCIxCePUeIYlPTkmkQihRiDnUyxZ/8AA8NRjAiLFrScMdPnmxa1t2JEGBiK8tqhQexkAhEhHi/lqaoibEW6q5TKt08A9PaOcHD/EV559SQn+sZJJZKICI31NecNyNlSU2MYEWE8lmLvm0NEJ9KspIq+vmJPVfJ9eY9mtHlTaZsntr6SLTvGIAKBKbK/2UlF2H2gj8O9o/QMjjE4OkEskSaZtIl7Rqoi4CcY9FEV8tNUV8mcphraZ4dZvbytrPeXoYDf7+YbPdU/1nuaY727S7ZVMxGASHGjyeQ4BkRIJFNUVgSnbLtj/ym+8MPt0w1Zkv75I+tYs3zOlG3iiRTGzbjOZMgibGd8OSoiGMdBROjzjsqpyCrvl09LPmt69voGRxFxI8CivTsDKjGDmtKsp20bx7uU3N89/a9Yly5oPCshWFqxdH7jtO32HTqRvSS1c9mf0qSKY4FSp8CUcatj29mb2cPH+ujtLx0WZ2hWRYB1q9qnZqwEvfuyhVRXTG1jTvWPcOREf/bWeFoBCEVWu9gPgOqpxsgkG0QExxh++atdRGOJqbrw0ZtW0TjJUWkK+KjxW9T4LRqDhaaoqbaSD1+/asoxY/EETz632zPIUsDbFFS0uEUCUKpYSvlkxMmepSLC+MQEjz+zg3gyVbZPfU0F99+xgQUtYRTw4XlhHrq0lcc62niso41Nq1r523nud+2tYe7/+AbqakpG5YDrlzz29EuMRScmxxTTqECxAAo2Z1fXOl9lX2tqcn0+JeOJf4zFJ/4JKLAV4epKbthwGS1NRZF0lmzHsG3nEZ57+SjdR4eosl2hTfj9LGlv5upV7Wy4fOGUxm9w+DSPP7OTyFiRWx8NhSq/VFkZ+nrZzuBMtCwN5P/itED3gn0tc5nmwjQQCr4Wn4heZZR+EFieqT8dneChX/6Wyy9ZTMfbFpW8IfZZmmuvWMy1VywGIJ50F6wiOL07kkyl2fXaYXa9/ia2PUnVhb3ap24NVVa0TvNbaqumb28r0JOpKBC1D9qnY0Qr1fCVzdteiY3rS0X4EpBN99q2w4svH+RHm55hx6vd09qGiqBvWvDRWIIdr3Tzo03P8Ls9hyaDHxPhS7Go7vjKT596zSqRyJlMKeMrCDcLZhd0+7S/RhfmAni/1737c+99978Zn+8OpfgwMA9gIp7i+R37eGHHPua1NbGkvZXZzXU018/CKp+uAtxEx+DIafoHIxw6eoqTp4ZKcXQC+KFK29+9N++HkgaZM92Ba1m0A9lYfJIAaJ9uAFFcml/2fql5d2dn55eXqLF3OnCTgvcAywTU8VODHD81CIDWiobaaiorQgSDAULeNkmk0iQTKSYSCYYj0Wz+oYA1YZ8otlnweLfU/KbUP1Eo6JiGfQRpzy8XCEAj7TPwpUpO4jH0nPfhk50b64OaWxH5AqjZ4CYpBkfGyds10zDLkFb6ywljfvzNzVtHpm0vdEwTOoCoBfnFAhsgSNHVUQm6uOvjnVP6CgDf3Lx15N6Htn4nFA9eBHwWODmDsTN0AvhsRTyw4J6HtnxrJuDv+9CHZinF4unaKVV475GV16bOTutog38Mpv+3Fq3MdZ/+3kNbpmuXTx/9aIe/IdJ0jSizDtFvB5kHZHzdIeA4Sl5UorcP1w5u+8EPdhfF7lPRVz9263Uo+e/p2imIxlqWhjNHYXYLHGvQy2YCHsAY63rgjATgAXrS+1wIum4mjQSqK/oPL8G7I8xtAbFK3gmWJMWNZ8jchSclfz7zxs4VmbecABTvKtm2JMn8e+94/4qZt7+w9LWPfWA5MLPUNKBNDmtWAMKZCAC0w/Vn0v5CkqPNGfEiiqsvFC9/ov9r9L+xcIPB0lA3RwAAAABJRU5ErkJggg==","1f414":"data:image/png;base64,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","1f427":"data:image/png;base64,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","1f426":"data:image/png;base64,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","1f424":"data:image/png;base64,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","1f986":baseURL+"1f986.png","1f412":"data:image/png;base64,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","1f423":"data:image/png;base64,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","1f425":"data:image/png;base64,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","1f985":baseURL+"1f985.png","1f9a2":baseURL+"1f9a2.png","1f99c":baseURL+"1f99c.png","1f989":baseURL+"1f989.png","1f99a":baseURL+"1f99a.png","1f987":baseURL+"1f987.png","1f43a":"data:image/png;base64,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","1f417":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAA8sSURBVHic7ZtrcFzFlcd/3ffOjEYvyw9JNrKNTYiBAszyDAnJAvEmEAoHbMBkH2FTu7WV7IewyQILRUKVKg7ZVAJeCPvKbmWTbCqVgMHAQngTaiFQ2V0CsWNHlm2wLGHJes+M5nUf3Wc/jCQ00p0ZWQbMB/5T/WFun+57+t+nT3ef7gsf4AO853j0nq2nPP69O28VEXW8ddHH46Wvp8x+QW5//L47H31g27bk8dBhCseFgM7OTgv8HthY7+QffeGHnXVTeb/4x2+tey91OS4EAAiqH0AUn8pOuP8J8NS2ziXW2lcfv/fOS98rPabH4I6777hBhM8DiwErMKigVykOikiPFUZccVOi6N98S+fQ0byks7NTn7MkdoMGbTR9zQ3BS9mM8wOU+pMpGRF1PUrOUnA7MOYQnnXFjZ1vHc17Hr3n9vbAOCeIlUVasUyEtUqpNQKrFbRT6vAxhfrx5pu/8dMyAh66+47cUidW76DI2ICilYovEsgo1G4FLxuxT+zJuS9OmnVFPP69rfcLasvk3wyQB5bPEDk0+T9R+qse3Hjj166rVF9nZ6de3xBeIkpfAfIx4AygqZJ8UmuatEuIMBYG6Wtu3tpSRsDDd93x7OVLWv9IWUsYGtJhyFDgM2gDclKZjEm8pYTv1iVS37/ixvu8mRkiop6451tnWW2uR+nbJp9WqGZKHQGUqJhaf+Vff233TIkHtn016dqGLwnqJqCjmlKNaNq1S2s8ziLXxXUdrFY8lRr9xea//caVZQQ89J3Oc1Yl4/+7PlnvhKEhNJYgNITGMG4MhwnJqFpEyG7lsGXzV7/Z9dh93zpVrPkzUH8MclKNgtG1QUrBP4nwk6u+ckf3I9vuONNYHgBOrVauWRQd4rDYdXEdh5jr4Doa13XYWciFh/3ieZtv2rqzjACAHd/9+q1nNzZ/u1U5ZQSEoSUwhiMYjsQq918JKu047rNKsQlwFtLwCAjwnDHhhSJS0cwVsCKAdhxijoPr6jIChmzIbwvZWzbftPWuqTJls0B4Yvddewu5fZUauCyENq9y87VWOI5eBPZaEeuIWN6hpETsp7TWTUpVnrjaPWFpGJ1nBfZ6+d27JpxtZTrP/LNly3aTM/a+IRNUfMniQGj2Z/s7RUkxjQjvalJKofRcEpp9S0tQuXMGTUDB2PtmO2t3tqDWvDQY+CyNVV6gtRYMRQd8p6SIUgCC1HaW7xiUUiCCAPFQaC0YcCqPuMHQRzny0uzncwhYPOHsGWsOC0BFBpRAWyakf1EMq9V72vBIXbIBiurbinETTuyacLtnP59jS5d2doaelT6/RqMcEZSVkns6jkkbi66yZgHwRPBEeqLWKnMsYBKjBbHUV6l0pN4h1IBUXf+86wg1jNY7rChWJqFgLQpGovIqETDmiVBfwawmXMVETNeaD98zTMQ0jaFlcYX8IhaB8ai8SgTki2KJmsYtMJg4vuM+CkMJRbMHsYi8oghayEeViyZAKPgiRBnAoGsJkfdN708hAIZczeoIvXyxiKIYVa6CBaiCz9yxHShhTAvvs86fxqi2LDfOnEaVHLoqRJWJJkCTCqzMGQFDWOz7tfWUjHJYhZw4S/FABIRUVJloAqxNF5xy+zcIwwTv296fwjDCSqTMF3hYUDYdJV/BAtRAwQrivN3aUWsI3+eNBwgRRq2hwyk1zQJ5a0HUQJR8JAFa2d9b0RR526uOWB85znP+fDFifTom4yqFyeWy0uyJko0kYMJ4expU0qSscVpReGJJ2/C4Ov7QCHkvoCkZK+0DqiAtIZ5YXDQpCQGCulhqb5RsxZp23HXHc/VKb1ivYvQVi+wLIqfRaYxPFHnutYMcHs3S0pjgkvUnsmb5ototmwd2vjHIi7/rww8MLQ0JLr/gZDqWNVYtsy5Wz6q6JLvEIyvy5LU3b70iSq7i5toq2ZYTy5sSMmr8qvv1IAx57LU+MiQwxjKaLvDwy90MjmWPORZwaDDFnjQkW1oASOU8Hv5VN/lidZ1Gjc+bUgrnKZFtldpZcf/4wDMv7r/+U5e057Dnp7181YXP6weG0B1rWHnKyfTt3Q+U9u4TBZ/TVi2pXHAeeOrVg5z0kfOJ1yUY7jsMgLEWR2tWt1YMDlEQix+LoZS695pbtv5zJbmqIav7n/nvJ3a+eGGdCczHq8n9umuAwaEUE2Pj5FKZ6efZfMD5pyynykirCgF++foh0sOjjLw1QOi/HahxtOK01Usrly15vr/fctudt1R7R9WDEaUQP5/vrWWm2YJPemSUwZ6+svKhteSLwYLNv1D0MVZIDY9SyObK6s7WGAIiFr+YrXmuUPNkSESfVytM1ZiMR5Z1taYu7iw4/FUXd0nEoo20pSExjzr0ecdMgBVzjohlzanrKjK9qjXaI69sbaQUKlu4E1zbHj2TnNTeXLHMlK5WzLER0NnZqUVknYjQ1nECJ595OiIyJ51x4hKa6sutQCvFhacuj5Q/mnTBqe3E3XIraF2U5NRViyPlP3TG6bSt7Jj6v+6B666r6ueqErAyGF4lQlIE+nt6uejyy2lftWqOqTlas+nCk1jd2oSrNcuaklz5kbUsa04u2PynUnMyzrUfP5kPrVjE0uY61q9ZxtUf/RCg5si2ndDBRZdfRv/BQ1PPEpl1bSurtbFSQAQACcJ1Spc8+EBPDwCf3HQV//XDH5FNZ8pkm+tjfPYja2ZV8M4snZc0xvnMuaur1t24qJkN125CKVXSdTJfG/VhSueOkajuAzRrp0zLKxY50ttLsqGeyz63BTcWOwbTtoRBSOD7BL5PGIST43dh9Tmuw4bNm0g21DPQewivWJzOM9iqx3LVCbCyYqaJ9ewrLXJali3j4qs2EmWG1ZIxFq9QIJeZoJibwMvn8PI5irkJcpkJvEIBY+zRDRMUf3jllSw7YQUAh7r3l+VjZcWCCbAiK2Z6157u7slaYc0p6/iDj3+soicuTwbfK1DMpgm8ImLN3J60hsArUsym8Yt5rJ3fLHH2RR/lpNNPKyksQk93d1m+lWMgQKB9ppIT4ymOvPX22uLciz/BCWvXVDdRaylks/iFAtbWNmdrBb9YpJibQGz1YbF89SrOvfgT0/oc6XuLiVR6ttzyiKbNkwBjl85+6b6du6bzlVJs2HQ1yYaGSAWNMRRyWYwxR33mUVY2ou66+iQbNl9ddk64b+euiA6QqpuRGhYgzbMr3L9rN2Hw9po82djAhms2ldbNsxxdMZ8jDEOstQtKYRhSzGUnh8OMuoGLP7uRhubmaT1MGHJg9565BCDNEU2bHwGIbZ7tdfxikZ7ufWViHWvXcPZFHyuTK+TyhEGItXJMKQwNxXy+rO6zL/ooa04pv0zW092NVyhEeEm7cAJEpCnK/Ha98us5sud/8hLaV65ERPA8D8/zMNZirGUiX2RgLE3e86efVUoFz2dgLEUmX5h+NlWfiNDW0cEFGz455/27XvmfCr6CYyAAEsLc30BfLwO9veUVac0lV28EDfl8flr5oVSG/YeHeGNghNfe6COdK1RsfDpX4NUDfbwxMMqB/mGGUpnpvFw+D0px8VUb0bPuBwwcOkR/76EITQVBondq8yJAcCrNv6+99PIc+SVtbSxpXV4yfWPJ5ouMZnLk/YBU3mMoXeD1N/vx/VL+zOQHIa+90c9QJk8q75H3AsYyObL5ItZYTBCyuL2NZcvb57z3tV+9EqnjZIo6LZtG9aWw2Ir5B7u6GBseZklra9nz0ZERjC0tQ9O5AqGxFIKQ8ZxHplBKbYvGOKm93DkfHByjdzRNwQ9pTiZIxByajCWTL5CIldQYGx6do8fY8DAHu7oQqRiyqkpALR+gKs/XlpeffLpMfnjgCP19fYTG4AcBZtJ7B8YyUfTxAsNYtsi+/lH8MCxdwDIGPwjp7h8hlfPwAkO26BMai6UUVPGDgNAY+vv6GOovD++//OTTc2eJ8lS1jTVmAQarTdYHu/ZyaMaMMND3FmFoCENDYAxKTd7pAeyMSwzjeY9Mrjgtm8kXGc+9fb3QWkEphaYUTAuMmZY9dODAtFzP3n0c7Npba1EReSAyLwJEbFetpeizD+2gWCiFzEeHh6d71VoBVYoKxVyHuhmRHWstmYI3LZspeGUE1cVdYo7GmbyDZI2dlh0bGQPAKxb55SMPV9VtMnUtnADsz2stXbPpNE//fDtiLcaUej6YVFajiLma+rhLS0Md7qT3TsRcQmunZY210wTFHE1LQ4L6eIyYo9FKlckqrRFreepn95MZT1XVTURA+Fm1NlZ1gvVB7uc5p+HrwNpqcm92dfHsgztoX3MioTFleY5W1MdjtNQnsCJ4gaGpLkbC1dOycVezqD6BozWJmENLfYJk3MXRGpCyOttPWM6z2x/iza6qHTuFnnqTrUpA1XDR47/ZF1x2weldIvwpNWLbQ/39BH6R8VSGXDZX2vjY0iB0HQ1K4TqaZMxhaVOSpoSLTK72HKVQjsbViqZknOZkgsY6F4VMy1grLFq8mLiCA3sij/lmwyrN5778rzsij8SmMK+A/V1f3PIl4F/mI5vNFzh0+EjEPQJVuqkjgq5wticioKIvvGmlOLFjOY318/3ARL5y8/e331tLal53eZ/5zZ5XP33OacMCl1HDb8RjpVvZqXRpJzdzcyPWTvZopQ1QdB4CK1e00tzYMB91Q0HdeMu/bb9vPsJHdWRz9xev3WAtP6bGNXUAzw/oHRhkfCI3HUQ5aijF4qYGVq9oJxGvup6ZwmGt+fObvv/g8/N+xdHq9A9fuLrFd9zvKMVfMA8LKnoeQ6NpBsbGCYKg5gsFiMVirFi6mLYli6hLJOajlhHhP+Im/Luv/uiRyKswlbDgz9a+/YWrzlSO801g43zr+b83BvjtmwPEtcJVMBlwxgqEAr4Vzl67gvNOrhrFmgkBHhNjvn7bjx793QKasXACpvDtv7rmdIz9G2ALUPNCQCrrsbN3mL6RCTL50uqvKRln9bJm1q9pZXHDvHo8rRTbRet7bvv3h+Y1JVTCO/bh4ve+/JlEfiL+adHq8whXAVW3oQuAAV5QSn7iBIWHbvnJM7maJeaBd+XLzc6/vG5JIgwuFewGlNoALPRbwH2IPK/Qz3tu7IXOH2wfeyf1hHeJgNn45g1XdqCdc5TIGcB64MNAGzB1wD8KDAH7gV2i1O5Y4Lx+6093HNVncx/gAxw9/h/lzBAfaZsfWwAAAABJRU5ErkJggg==","1f434":"data:image/png;base64,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","1f984":"data:image/png;base64,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","1f41b":"data:image/png;base64,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","1f41d":"data:image/png;base64,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","1f98b":baseURL+"1f98b.png","1f41a":baseURL+"1f41a.png","1f40c":"data:image/png;base64,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","1f41e":"data:image/png;base64,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","1f997":baseURL+"1f997.png","1f99f":baseURL+"1f99f.png","1f578":baseURL+"1f578.png","1f982":"data:image/png;base64,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","1f40d":"data:image/png;base64,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","1f996":baseURL+"1f996.png","1f419":"data:image/png;base64,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","1f98e":baseURL+"1f98e.png","1f422":"data:image/png;base64,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","1f990":baseURL+"1f990.png","1f991":baseURL+"1f991.png","1f980":"data:image/png;base64,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","1f99e":baseURL+"1f99e.png","1f995":baseURL+"1f995.png","1f41f":"data:image/png;base64,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","1f577":"data:image/png;base64,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","1f41c":"data:image/png;base64,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","1f421":"data:image/png;base64,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","1f420":"data:image/png;base64,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","1f42c":"data:image/png;base64,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","1f9a0":baseURL+"1f9a0.png","1f433":"data:image/png;base64,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","1f40b":"data:image/png;base64,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","1f405":"data:image/png;base64,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","1f40a":"data:image/png;base64,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","1f993":baseURL+"1f993.png","1f406":"data:image/png;base64,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","1f988":baseURL+"1f988.png","1f98f":baseURL+"1f98f.png","1f418":"data:image/png;base64,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","1f98d":baseURL+"1f98d.png","1f99b":baseURL+"1f99b.png","1f42a":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAptSURBVHic7Zp7cNTVFcc/57ePPDYbwpsAkoBSSRiqMj5qZ9rS6kih4BQ6RJ6OdizjYG2LQzsVg+5ooLXt6IzaaqcVLSEIQaoVFHBKbRVKccCKGp7KW2LAhLyzj9/+Tv9I9pFkd8lvhe10mu8/e3/nfM/53Xv2Ps699wf96Ec/+tGPfvSjH/3oRz/60Y//P4hdA/X5jAPjQ88bInmmwcOT5lYcvNSVUkWOvvTwrWG17gJpmDD/sR+JoJf6PZBGAA5Wlk9Rgy2ABzBFWVKysOIPADVrfGMMMceVLKr4e7oVqqn25UkoVA0yDQAlhMhHhoTvmjB/1Qfp+k2GhAE4Wv3gUNN0XqWWNUaFKwyVMZZIsVrmaIdhDFBkgCAeRbO73Oy40HBhcktT48AhQ4Yeu/7eJ69MpzKnq5fmtJieN1Cm9FCpwAkc4W+XzP3FkXR8J4Mz/qGm2pfX3Ni2ocNvTHM6VBBBut5eX1dH84VGcjweRowe2S10Z898esvn5+sZ4PWQ681+IZ2K1FT73C2h0Cbo1XjofNtgKyy56fhOBSNS0Oo5DgmF1wYC4elOQ3r1jI9r/bz+QRPvf1JPR1t7VG5ZFp/VnsPryWXoiBH71ZX1KzsVUEVqqh66kVBoW7TbJ+JBvoGxvaZyxdfs+L8Yog09sLa8EmFhMuLJM+fZsuc0k8fmccOksThdLgBCoRCNFxopKCh4Pp+cH4692+fvy4sPVpZPUWExwq3AUJv1flswVpUseHS7TbteiAZg13M/3e4PmLe5nILXk0WWy2HPk+rc0oUrN1yM9uG65cMdOJ5FdZb96vbCXoSVJfMq/pLuKhEdAoO8WQMLh3go8GbjD4RoaPLT0h4kEDT75EjUGnUxTs3aB0sdauy5RI0HuB7llYNV5TsPrl0xKR0HsTlAWCXKMqchsws82csHFWR/5M11k+V2prKPQh3GxFT6mqrl14o4dgJF6VQ0JYSvqui+mqqHlts3TYEDlcsn43DcgepNwGTAm4L+dumCim8kUtSs8Y0Rh7kbGGm3gnahlvVxadaqCVJGuC98W4mQKnJg3Yqtgk5NoD5euqBiXE/h/jW+YS5H+C3QUjvv+iLwdwTqrrvn14XCxecF42KEeIigAslm+dF7f7/YFS/Yv9Y3OtONB8jOyRr+zlP3/bUvXNup8IGq8k3A7EQ6Fb5vqHwAWqTwdeAHwCVPXvoCy1Le//f+Wxc+sWVHKp6tHgAgSNKxJcpqRfcqbAJ+zGVufKr+bRjCoMGD1z91/7SsVD5sB8DCarNrc7lgBoMp9V5v3hCvyr2pOLYDgEitbZvLhEAgkFKfn+8FdGn1nDlJszr7Q0D1ku//00XQnzoALpeTnNycorbhrTOTcWwHQF2u14G+pYeXGWHTJHiRXuDJy0Xh/mR62wGYWOZrALbYtbMsy65Jn3y2tbSm5Hg8HoApLyyZPiKR3v4cAIQdLAMa7diYpokZukjHsbmdCQaDtDa3pLTzeLIBVA0SbrXTCsCkuRWfqOhM7ARBlfO1n6VsY8hMPavHIxgIEAoGCQWDtLW2JOXl5uSowDlRBibSpxUAgInzV+4EvZbO4dCzXX7QHcDDin63vrZu/fnaOsywSXND8ph1tLYn1cVDVfm8rg4UDMOgKYVPh9MpLperUA09lUjft61eEpQuWHkSmFlT6bvKcIRuUMWpwvF8Z/u+K8qe7Ijwtvtm7Q6FXbOArAv19XgHeDEcvVemluZmvAMGIEbyBDUcDlP3aW17wB80BfIty8Lf0UFHezs5uYnzLk9eLsELTbOAl3vqbKfC6WLzijmbBZkBkJvnYcSoUb3efvqTE2TlZDGssLB3zRSam5sONzc0feoP+n/nP6iv5kyQNwW+BeDOcjO6uDhhi86cqQ2fOX22/u5nto7ouUFKewjYhdGZHgPQ3tpGS3NzfU+OO8td29baZp0+cdJqbmw2zVDoLMI7ovpIU0PD7aeOfnbdbeVrbrn90epNZRs3hsUyVkRsg4EgF+p7uQRgQH5eAzBs9f1Tv9xT94WGgB1YDv4Wv4toOH/+iHdA/tXAoIhs+OhRD5QseGzD6z+fX9Bg1oe/cl9VcyqfM1au/+fmFXO2StdhauPn9biz3Hi83Y8t8rx5XhFB1XEzsD9el7EeMNO38RQQTaNN02wU0ZXxHBGrWEBn/HLdhem+1I2P2qg8ESkrUHe2llAw+F53v5I9ePCgbaKU9LTPWAC6UBMpCHRYTtczwNGIzFLjersOv1NRvQPkWFSgcObUyTWKbI7njb+q6AiGHu1pn9kAKMdjD2JOLPMFFX0oKkFtB6BrUlvb7TUhzXYPbJwDvBsjytzxI4uretpnNAAqEpullBBA6VHXJuCTLmnRoTXlY+36dTjkBSCaa4shheOnPx0QZElErjBscNGQ7/W0zWgARK1Y4i4SAhCfzwJ+GxGr0/6R+TTf+hPAnqhAdRxAyYLH9qFxa7+yVLX7QpnZHgDxO5doOcsVWh15VkvK0nIuRM8AFa6Olh2xSRK09FDVinnxZpntASItsbJGy1eWPd4kwrZOBTcdXLfiZtvOLd6Oexq/2TdvCMDEeY/tAXbHKqFPHnr+Z9F1MrM9QDW2tFkEuuu6AgCopT+x69vlDMV/OyBYZtwlqj4bLcEwK9sd1WV2FRAjmqyrIcPjVYq1L8bjNvX5bNVtqu+Vc0BT5NnAiF7SeF3tLxO3c1XUE+NlECIaS0UtzY/XmWH3WWInTQXvF9FN30ecj7nX0ZFy18bspShLrWg+kukhcDZSFtE34nXX3Ok7h/J45NntoW97426Q2ImL6jvdVJb1x65S6NyorOhXJhkeAtFEqDnX4flzT3WJ+/AjCmcAgm3p3CloxOaUo6n1uXhN6aJV7wHHAaf3yNnoUpjpTDByhf7aN30v9rpik7KNYYFdAG5XwNZF6hudFyAjAURl1fSntyY6LT0ISF7+yOgHGZleBsd1FV5LztEDnb8OWwEI5+ddAzhBTrY5rcTfKYkEAMJWcFhElOkecDWgLiP4j6QUjeQKYisAhkS+L7JWlfk2JjxcFEtzAAw1Mh8A7TyruQnk464lKyEE6bp608K++t67eLFLhXuAT9sdvJiMZ0nn9w2WIZkPwFbfnBJgsGIdTsWzsPIBxEYPqB3RVAaMVqQy2b/f6ZNxAAbWf6EHhGU2gIj02pPHQ1QKOg30S33xW710To6oVgDgMP+UjHd0rS8fKARQjCsi8owFwEI7A2BFt77JMB5AhRt77twSIdcjS4Bi0D0zfZsOJeMFDTN21qBaHClmJACbfXdMFuQ6ACSWrSWCSvRQZNDhyvLiVNxty2cXIjzQ6ZZXU3Gl++e3Ub+X9VB0+7JFnmBu8BEJ65KITJWGRNxDa8rHWg5+Q9c4BQgbMhV4rid32/LZhabDtdxE74TOlFkdRsL7yppqn5tQaBmwLE5cHClctgAcO7CryGptO/Dxm1W5ZiB6R2IZTrNXNz324c4yWhsr/cf+5Y6XG0Kvj66P7tq2KBhoWX38rY3xdd89w7fho57cQ4d2erPbQ8f9x98dbPm7XZ9d+pvafvyP4j8wZOty7B6OtQAAAABJRU5ErkJggg==","1f403":"data:image/png;base64,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","1f42b":"data:image/png;base64,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","1f992":baseURL+"1f992.png","1f40f":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAx3SURBVHic7Zt7dNXVlcc/53efeZEbyANMggZ5KwUKahk7GgaXCAJ26ARYtbUibXGcqp1ZLqczU+pdA9RWZs3MWk4pwijWaatIxVUREbGLDNIRC3QUSIk8k5AEEpKbx7039/X7/fb8EXK9ubkh3EcoXdPvH1n57bP32fvs3zn7t88+58Kf8P8bKlXBqnvuybcqY4au2Y/9xcyKG01Dvq4Ud4OaCGQHQ2GP02H7RBTvaIZ65a//ZVNrBu3OGFJywIp7K59S4HbYrDnjy0qMkfl5lnBEp6GlnfFlJQCcqGuivKSQ3CwH4bDeY7fZ1hfWtf1o2fbtRkZHkCa0ZAVW3Dv3CQUb8rKdOdMnjMVqtVoAbDYr7V1e2jq7exkFOr0+AGobmrMjprH+UsWo3Rue+lpOBu1PG5ZkmB9cUFmGsCPLYbdPnzAWm81GzbkmNA1ys5wYpsnFtg4ihkFPMEw4rGO1Wjjf0s6YwgIQuTkSMud+ceFf/rS6utocrkElA2syzGLwJJA7vmw0wXCEnCwL40qLOH6mkfOtHgLBMAD+C5foW10erx8UNLW2EwpHKBqZP6c40LIGeCbDY0kJySwBNXaU4+vzpo3BlZfF78810eLpou5CGyISHfxl1v6SAs1tHXi6fYhpouvG0z/+u8fKMzGAdHHVDnj9u1Wbvjg+v6jACaAoLynk1PkLeP2Bq5CW6N/TTS0cP93gVDbjWylZnGFc1RLYuWbZ0wq+BeDQDPIsIU50+xD5jCfbrlHqclCYYyXbbjHPdxttDZ5gQTAUscXOCMMw8QdDILIIWJPZ4SSPIWfAzu+vmKfgB7E0l9WPzdIbw0pdduZNKWD+Lfl0dPs4ddGLP2Rot93ofGTmrOLC8uJRjfF9miJ0eoNTJI08JFO4ogPe+d7ym5WYrwKWSz6T5s4I0Gt15fgclswopHKSCysmP99fh25q5DodlLiczT0ae59w/7x7XGnhohuKCgb03d7ltQ/HgJLFoA54a82XbxEl+4AigBqfi437Wtl1tLNXUEGeQ8MEdh5ppDA/B1e2k3HFWWQ7+Moy9/YwwKM/euGT8uKRn2pan6redeMLBnXV9/AHREIH7PzeikoNywGBaKT2tTQwMtfKxBJnP94uXxilYOKYfKaV5zLGZSdo4cNYHrvNdmpETp9c76wXU7ozOpIUMSAI7lpT9RXBfAlwxNIXTXcl7KAg187DlTfHkkJ9bz8GeTZrf1VWm/WDVAzONPrNgJqfrXnWmZ3zM+IGnwxE5GLs84tPP5IH3B4IfeYTTWnitFieSFVHJhF1QMObz62dfMv071bOv1+NnzwFVGoBWilG7nJXje57DmJ/xusPZPl6glGeUQW5G//1tV+dT8fwTCE6yp4P/0t3ZmVF9wb1Z89Q879HUu32LIasv2iOmNMVMFcdP3teBUO9X5DRrrxPl0wdNWOu++XgEJ1cE0QdcOn9zR3P/eJ/XO7V95Hl6F2vxw7/lvP1dUl12OSFsKHRHVK0eQO0dnRjmiZKKSbdkM+sMjtAQJBqlHrTqml7F7hfS07JZexzV1rnuqv1VGT7EHVAw682PF92Y8W3Yxt93m72v/duUh22+YUj5/20dwcQETSlKMrPZkZ5DoXZg4o1CHIUpeqV0IwQrRkIaEpRjFCCRqkIJQqKgb7kosVi0c6Mmzi10W5VWyuWrUnK4KgDTm/7wZ3jJk08ANDY0kltXSvjSguo/WhfUg7ogyHgDws5doVlmPO9W2fNZuxN40AET3v7BV9Xy4M3ffmZqzK8n2mntq1bvK/Gs6OivNh614wKTtYcvVR/5vQukBoRqVOaakdTl8QwFynUs8MznORgs9m5Z/ESlPrsg2boujTWnd1U8Vf/+NhQ8gPezdlfrl9mszqW+Lq7tkx5aO1/JxJ6+/vLfojw92lZniGMLCriC3fNHdggQs2xo12HPzryz/h7Nq58uTph0E1pcr69Ztk2YFkqsplG0egx3HbnnyduFOHD3xygtvbkSc1Uy1dufOfjeJaka4K9ULNTk8s8wqErfE2V4o45f8ZIV/5E0eTAi48vuDeeJWkHvOn+kgukIlm54YLf60Vk8PKiZrFw+5wvAOQo4c2tj8/vN12SdoDdcE7iOtjH90HXdTxtbVfkGVNaxuiSYoBsEe3trd+576a+tqQdIJgTkpUZbtSdPjUkz7jx0Q3bCNHV830PyccAoSRpmWFGS3MT9WdOX5GntLzcVKhzlx/H9NGTKotfz6j5+Hd0etqZPG06DqdzQHtWdo42bVrZrbNXb+6JpSc9A5SSC2nYOaxoaqhn/97dXGweUIZE0zQKnDeUDaAnrcWiHU7NPLgWFbBIOMLvDn7I6drf96MbhkGDr6Y5nj/FRGj5SZDrLhjG49bPz2JsRW/w83Z1hvLv/saAtZFSIqREfpKmbdcEtceOouu9u+V2T1vCElxKDvD7ZRNQl7Jl1wh6JEKnp41gICBhj2dpIp6UHLDs37YHEHnyD17TvgooFB2eSx9PXvWcN1F7insBWLRu+1t6xLguKruDQSnIy3cR6PH9+2A8KTsAoNMb+mEoklZFalgxwlWA0jTp9JS8OhhPWg6wGOHD3f4gYf26uvUShatgJD1+v3f26tWRwXjScsBDm95rFZGmTm8PofDwzwSh93T5ahHoCaCHw11X4kk/FVZyGFGlXf4AeeIky2FLu8to13DIhE8UqqbbF1gR0iN3iMCIHCdO+9B6WlsuYHc46q/Ek74DTO0jlDwA4O0J0hMKk+t04LBfuWsFIqCEwbMxE/XNxWu3fQKw5fEFv7QIB4FSf08Iu82KNtThjQiNDeeueAqd1hIAEIs6GPscvQAxlBxqC4CCvQoORelKbQB6j6Axo8WLbz6/u1ETcz7gMUSIPWkaQtG0fe6HB+6OLiNtB+C0HAb6RUHdMDFNBr07o+DQ/Wu3PSrwn0poVBZ9KXAEQGm8MrrFVWxYLNMRc0+s3MM/3lMjpjwAdAXDOqHwoLEtFlk+079gsMa0HbDqube8oqiJp+uG7h9UyOQpBXLEMnU1GrsWunc0ap3eOxXyD6Kb82Zv3hx5wP3q0cXr3hhQ6Vi18d0DhqnNAU50+4MYxtBfICXqa4O2DSl9FXjpbxa8iOKRWFq2wxbKzXYmOmU+sWjt61PT1bn14UoneVnPakr7TsGI7KHiga5Z9IqF7h0D9snpLwEATc7Fk8IRfbBMec8g9KSw8uXq4Mrnd/+tIeahLl9gqI22VXTrqkQNGXGACAOSAN2UZ4CmBNwdmdAZo7spoht0dPsxZXA3iOIbr1dVDbgZmxEHKFRpHOHAyv/YvQGhOgF3XiZ0fqaKidAbeDt9AUyRhJseoCxrkjYvnpiZJQBz4ox6RYEopaoT8M7KkE5++uiiUiAaT3Td8FvEmAYkPBhVSpbH09J2wJYnl5QAM/pTzVoATcxEu8VZbrc7I47XLeaXYp9Fceb+9Tvq71/7+jxEHgPi7yo9EK87bUMsZqSKuFvnysQD4LVyjrgcARhxOzWT09ULoCke6q9XfNCbZS5at/0nCl6LExl1h17Tr5SXtgP2n2ibYwr98m1dIwegyr09UaZi6PrgSdLV4p7bpo070+oLEPOWRVO5sTwCvjgxXbf2152WA+793OeKmzoCy3f8tqm4tTO0P6apCGCPu6qAAb9JUE8sWbd9wGczaZiy9KMznrvfPdbSoJvmKQAlFPdnkn7xRon69mL39oZYWloOMO3GfYAlYppZvz7Retfhuo6DJhwELgHouvp8nEh7T635Qjo6Y7AQoMMXHr/jUHNpmzf8AahozNn5T1WloG6P4b90yDplS3wn6e0GTWbE5pKnLvhmnm7xTXjv0PHeK3CK+JsLJzP1myEF0/v+N0zJ3nu8xbv3yPHonQWl1ApiM13Fp263e0AxIb0YoFS/KSewNzr4XoaqOIn4NZkSKisrrcDIfrqVvNTftv6pOZJYd1oz4P0jx78KfDVR2/yZt0yvbe5smnxD/k2ArddIMpIEVVdX61xhH7Ng9tSZtY1drZPL8if06YbEujOVCA2AqbF0z8dNlW8crD+tG1IHoK7RyXJELEv3HG2qfONg/SnDjJ5fJNQ9bA5A1AKARo9/yuZff1rU2hX6AFTCS1fDoHzhZd1TX3i/tqitK3AASax7WG56uEH7zaxb/UC0EiOKbe8fPr5iOPTFoqqqytJ59oSfmAvfCvnFe0dqHkzEPywzoHrGjBHEDB5ACS8Nwp5ReOqPuYi77W5q2tZroftP+GPE/wHqoNLpaNpvZgAAAABJRU5ErkJggg==","1f402":"data:image/png;base64,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","1f404":"data:image/png;base64,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","1f415":"data:image/png;base64,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","1f411":"data:image/png;base64,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","1f98c":baseURL+"1f98c.png","1f410":"data:image/png;base64,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","1f408":"data:image/png;base64,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","1f983":"data:image/png;base64,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","1f413":"data:image/png;base64,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","1f429":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAA1kSURBVHic7Vt7dFXVmf99+9xHkpsnr0BMKDECgqIEsKAzjgU7KNK6pLgupFZb2ppAlbJGyghjRzNrOWuhM2NbpJgESm0LJlxIwNKiUhXfDxjkIZhAiAFCyBNIbnIfOfec/c0feXCTe2/uuSehzh/+1rprnXP23r/9nW/v/e3v+86+wNf4GjFhw7599qIdFcsB4Helr2YU7djz3a9apqGAjFYsdrlSCpzO9pIdFevBmM1C/BxSvg3wB5rQH1akZY0Cfu3RpYs/uZYCDzeMK6Bs93ZFBFbq0nIBgB3AWQDXA2gH0AogURfKXRYpH2PwPGL+9/y8xbuvidTDCEMK2FhRMdKqopkZu4jgjFCtBeAEgBwE2pe/dNHCYZTzmsGQAop2lP8TMb1rmJVxCYREAB5mLliet3iXWQGvNSyDFW5xvXqDLvV/A2NeTKyEkT1XlY1jR+wxK9zfA2KwQje66kF0DsB4U+yE9HFNV0pKynYvYGbD9ubviYgzoLh0z2xIuRPgLNPsjHEAvi+ZtS07dp8FUGma6xohogI0RT1pkcp/AlQ0xD5qANSoQqsbIo8hbHbtnimZv8eMWwCMAqFBAK91krbtCafTN7B+xGm52fXnbCm1YwCShkm2OhJ0f75z0dFh4uuHzWUVUyTwIoC7I1Q5KwUtWeFcdDD4YUQbQGAFoCdBaAYAItE6ZuSIUxMyr9MS4uNjla8JzEVgTLoWtqCkrOIhCRxG5JcHgAlC8pvFZeUzgh9GFWZr+Z8Pp48cNaK17sKE5pZLuOuf54EE4UTVaagB1aiMAWLKz89b9LLRBkZRsqPix8zYAuNO3Sm0t0wrKCgIAIPMgCOnau47UlnzSe5NN83IGJs+4Y19f8P2rdvw4YH3YFEUZGWMjUVOKxOXDNT+UFFSuucOZhQhBo8WwGRKHf1w700/I8jMdKzqy4VMeBqM24JpFy1djLsXzMf0WdMBACPT0qCqAdQ1NBjt2ArQswDui0HYiNiwb5+d3f7fd/PGBmbKA7AVCJoBP3rop3MW3uvscHd07AVw28BGN0yeiBnfnAEhrk6atg634U4leJNVaD+MVdhIsHX4lwGYZKoxc27vZd/bxCcnNTc2NDq8Hm9I9frz9d43//q3ywFVa+99WFVTA3enx3CfXo9vhSqthZu3lWeaEnoAiPG4+cZw9F72KeCll3715Zw7b9+QPi79cs+jmv/96NOPn3x8Df3yiXUJr+/96wgQEsCM2ro6XLjYGNPCs9tspGvaz6SFPi8pq3jItPAASsoqJgG4aQgU53sv+hnBTb99fpXeeWWsTtro3Btzbtj/q42rx19qwndnTuNn/utZj8WiWM+cO4/G5hbYrLEtPavVAq/PCwCpDGwrKq140qz0zDzLbNtu0N7eqxBPcNasWYGamTMDtQsW/AGdnQ+2PbjEg3sWOJjZUV1b625zdyS7PV6kJsfuH6kB7aoIhPVFpeVnl+ct3mHiBdJjb9PbFM1WCjzXexuyDdbedttdIsFxHh2dj3h+sTaO5997tK6hYcfhz0+cbHN3JANAV5ca0/TvhZR6f1mIXtzico2ImYgoYKJ7AKiTUt77Y6ezpfdBvxlQO3v2UmL+A7r8irzllsePQ7zfcez4VgBLgutpmgYz0HUGM4OoT32jdWm5VFxWXsugPyWojucfeeSeqJaVGZUUywgwLgG80RYnfr1s0YNtwUV9M6B2zpxvEfMfAdhAtGr//O8c6PD53gEwcyBfDB5gPwR0Dbouw5RQNgFP+2yew8UuV9TQm9zN76E7DWcA9CcoWk5B3uLCZYsWtQ0s7VMASbkRADHzugNr124nqf8FQFrYF1E1sLHe+8AAfD4/oozcZEjL3hdcrkGDjYKCggAYhQb63J6/5IEfFjid7ZHqXLUBUq5hISZmHzq0Xu2S6wDKjthIELy+kMhyUHg8XkhdQihKtKq3jLYn/ZqZB03W5C9dtCnJkXAwcg3+SE2O+wkRDTpWIeOxaftf0hRFrQcQcRTqLjaAJWN8ZsZg3FdFAXCurh4MIDvruqj1rRYLpt889aIgUS4Ju3InZn9ARP3WzrGqM/MkaH9TSyvO11/0M9gRVHzIKrSFwcYuEkK2QcWi3g+O/PIAkJyUiAsXG9Hm7jC0Hba2XoLH60VG+piodQEgoGno9HgzkhyOlcRYefRU7aWjVWf2EYudAc/l1yk+9RsSVAZASR8z6rFzbc0vo1N9gEFZgnAuVWgVTqfTkKEKzQgxzUeUFZ6SmIhWux31jU2QUiItNSXstsjMaGxpwZUr7bDbbEhJSTYiEwDA6/UhydE7qDySQQ8z8cNKYlozAZKB0QwUz5ics6mn0iuGyYMQLiU2JWorImRmjEXtuQtoaGrGlbZ2pKUmw263wyIUBDQdHq8X7W43ApoGRQhkZoyFiGHvCkTeasf0Dg+B3jJMGAGhCiC+zoiJt9tsyJkwHhcaGuD1+dHQFH65xcXZkTluLOw2W0yCGVMWb/2suvrkjIkTv4iJPAhhloDx+NpqtWDC+Cx0dnaizd2Bri4VmqbDYlFgt9uQkpyMpESHKa/RbjeksETooszFnOsk0qNXD0W4JdAVCwEBSEpMRFJiopn+w3MSIclhjI+AaZNO1eYB2Gamr5C9lvhqqPhVISUpCTab8WiTwavN9hXqbBCqzJINB4QQyMow5l8E4daTJ+tiD6oQXgHGP4IOM4gI14/PQnycPeamXZaAqS9YITZAJ+0NwRYdQFSfdTgRZ7cjOyvTtC0hnUNyeUYQMgNWOJ31DLxmSgqTSEtJwbQbJw/FkLZVT7n+SzMNwwYcCovnzUoSK4gImePGdecIGF8A2K5r8jlvpx8+jx+qGj33QOC9ZrfBsAp4NO+B95nhMkMYK0amptXFx8c9SqRl5k7JuSn3xpwftF12v9LlU+H3qvC0e+Hp8A9OQlRitv+IX4ctirZCl5aZAHLMkkcDCVHpvlg7I/eebw14Q+o37AG/Ck60B2eSgnF8+uScD8zKEDHm/qnTeRlSfgfdh6GuBSoDUOctW7YsZHgTLP5aBEVkDEDXwmWSAAZeGooQgyYdCr7/YJVUMTvREW/KwEQCMQ4Kqcx9zOlsDFd+xx13+ACcDH4m9fBL3CL0/UORZdAzQgCw4pHvNR+trFnV6fPtbXe74fF6QULA71fh6/KBOabk2GUQPXcxPfWFwrlzo1g33g/Qzb13msYIFx34A1ZT218voioAAEh1HEhMgN+REB/X+8zn8cPr8cPj98Ht6Tjt7fJ1ALgZ3WcIgxqjmRkHBWG3PxC36+c/uM/QB0UpqExIPNF7rwW0EGoAsCn6FABhZ5IRGA7UjlTVvAFgfu+92hWAx92XFzw+787cW5mZfrdzZ5oaUFKtVitbrPqVcJlYo3j7/SNHAdzaLSkhdYQDJPqvWgLWTr8x57kwzQ3B0Azo6f915qsKGJDcnMjM1JOAvNzzGzIY/D8E+mP3DaPLryEuof9CkMBDAEwrYFAjGAwNop93aFFEsFmOf+vTE8YSfjFAaO2l6D5kBQDo8qtgoJ81JGDakVM1IZ/zDfdhtOKsydlVwcKAIEhcXUEiICeYFSIS5s6dqzGwDgDADHdHB7yd/tDPYsy/NNuHYQX09HQg+E4RAnrP9kTEE8wKMRjuvjN3p8fv+/idQ5/izU8+xJ79b8T5/P4BGV+6/7PK6tvN8MekAIbodxT+RM1p7H33Lbx3+CDON13MjdRuqHjn4Mfuts7uzUMNBPDWBx/ZZND+q+s6GptbdhWXVawpcu2ZGgt3TOm6z6qrp6o+7aTH50NCXBw+rzyNE6dOAQAEkcrQ//E3T687FAtnNKws3JBM5GvFgLNA2eOzcNecb0Iy4+Tpavj9fQ6lBHiLzedeFc7LHIiYZsDhIyduP/5FJc7UnsXxyiooCvVpUDLbJIvylYUbjCf/DYDhm4QwB6Fqz9fhk8+Oorn1Ege9PAAIgPLVuJS3N2zbF1UWwwoocu2ZKiVvCvb7NF1HxtirZxUIyCL4nzLKaQQKOC5SWdWZGpyruxC+kHC73eLf43K5Bk0vG58BUl8DhHqjqSnJSE4KSmQQ/+xfCl8wlZ8LB10g4pddAJAY9OTp3CvSOqiPYEgBLpdLIdD9kcrTx4wODlUTpQgsNcJrBJ3SXw0gYtwgRLRX4FUlO3bdE7G9ESGuwDYVQMRRtVksSA5KZzEjzwivEbxcWOgH6FikcgPBGDGL4t+6XGHzbYYUQMxRDySmpfazN3Py169PMcJtBExYjQjutR4hTB6Ab1h05RfhCgwpgCVHPRickJAARemjs9hUk/8yCYMXn/7Xd8miTQXwHwAOAmgC4ANQq+uy3hAJ0erNr7wacrrMWDAkyIEoU40AOOITpLvTc5iZn9/4zNrPDXEbxG+eeqoJQGHPrw/FpeWFAJ4xQJEoFbkc3UrsgyEFsM7HSYAxmOPErI8aM2rJs6sfKzfCOVzQFP2/LdL6DwB/O3ptPjvwiWFPsKh01yyCeByEOQDGAEgG0ALQBRC/DxK/L3A+MKyjbhTMTMWlu78NgYUE3AkgA90HvDwAGgD+kAnbly9Z/N5XId/X+P+M/wOjxTDOX82MigAAAABJRU5ErkJggg==","1f401":"data:image/png;base64,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","1f54a":"data:image/png;base64,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","1f994":baseURL+"1f994.png","1f407":"data:image/png;base64,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","1f400":"data:image/png;base64,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","1f43f":"data:image/png;base64,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","1f409":baseURL+"1f409.png","1f43e":"data:image/png;base64,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","1f384":baseURL+"1f384.png","1f335":baseURL+"1f335.png","1f333":baseURL+"1f333.png","1f334":baseURL+"1f334.png","1f432":baseURL+"1f432.png","1f332":baseURL+"1f332.png","1f33f":baseURL+"1f33f.png","1f340":baseURL+"1f340.png","1f331":baseURL+"1f331.png","1f343":baseURL+"1f343.png","1f342":baseURL+"1f342.png","1f38b":baseURL+"1f38b.png","1f38d":baseURL+"1f38d.png","1f341":baseURL+"1f341.png","1f344":baseURL+"1f344.png","1f337":baseURL+"1f337.png","1f339":baseURL+"1f339.png","1f999":baseURL+"1f999.png","1f416":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAlDSURBVHic7Zp7jJTVFcB/55vnMvvksQtbQNtC8YFWq9EUMXUbIvJQqikjCqzF1mhti6yp0BqDW1sL1MhubdFqk1ZEA6wK0sZ2iwgo1kglPsBYNMrDRVBxYd+zM9/j9I9hZmd2Zx9TZmdrOr9kkjtnzr3nfGfOfXz3XsiRI0eOHDly5MiRI0eO/xN01ZaCWNkYSkeGDF+4PFZ0D6Ufg42u3jAHYT4QwdCH5Y4bXtWVdUXgFMZ0ZAj9G1S0dsNylOUg24HJoCNRZmNoCeWuZyQYtGEQAqC/3zQCKzwNlSLUeI+quS+LiGbaTp8+PLjhaxj8G5grVfM26cq6InzOSyiFCCulat5jMd2MjQFaXW1ozcb7MCMfo7IBeBRxdlK7sT5x0MkKot8F3S1V8zYByM+CzQj3IHwZ5VCi6mmNAS0/XDVJcL6Fco7lLrvSZdtnmy1tOOEI3uFFGF4PwJV4Q9v1gSdmyV2Vn52OvYFjlKH6bpLIpgEDMPQsYGtMnHYAOm7/1TjLcf0NmIA6fgXc+cPAVtoPNKCOA4ArzxcLAMDFuL17tXZ9Der6B83v7pXqaue/e7gBYOgRHL6n1TvcUl1h6Zq6fCK6GhTUGJmkmm7btm0UAJMBf0zmyssj9Mln8YcHcMJm96plqKwE502Kz1qQrt20MNiEMJHiT7dqzcb7iDh7EDYAoJo0HqWdAZ2mq8HndSzAbQzz4/1SKdaxRug2zNnhcO+NOEQGYkvXbhuBKzIRZAJKKSrlCEWIFHUpaTPQguphDNd+THOvLJr1odZsmAPchTAZR29BFUQAPk20kXYARv1pWWvrbSv+5RlbNsU3vhwErOMnez5jZ4QEo8mUBKbqunoHeA8fDZiWYrrLMfQ8hItALkY5H7GGowlJGmtKU0wqIqAOuF2q6+rfBv6KYy6Um67+GEBr1z+CAobzSlK1dAMAYK55dpe7MDA19l3DETr2vo8TSU77vLFjcAf8yZVdBpQUkiVMYC1NLeuxnedR9kvVvAsTFdLOAF1Xfx8wNVEmPi/DvnEO1rHjWM2tqGVHI5tqhPF50zV5OniAH1BUcCPNbX5MZ3l3hQEHQB/d4yHv898cOtG4ZFxxCS4j+enEZeAZW4ZnbFlCJYXG5gQlAb8v/cc4XUSGUZwfQenRVwc0C+ja+mkEPn+z3YwsWf7aTuY8toYPPh/AlC4CeQldIJAHxlCtvsWLSJ2u3TYiURrPAH2qvgKbK/C3rJRgMKRPvDAerO8gUglchMLx1hb27YuuL3Z9+AETRpb2bzfgB5eAYUDXumCoGINhrQRuiQnif0fbY8+9HMjzXw40Ai6guHtt07ZZvWMbpfn53HTpFIxUI/z/Pp2Yzni5eeZxSMiAQx8fPe+MMaPJDwwb0VtNj8vFsmnTs+HkYOLHK3OBhyFhDOiMmPkHjhwbMq+yijIlVowHQJTO4yebhsahrCPxtUA8AKOGl+z3ul0p1UOmSXMolAXHskZ89I4HYFx52S8uv/iCD7trHmw8zurtWynw+7v/9MVFJD7O9RjGV8xf/OtDTSd+Pszr5UjTSbxuNyuvuY6xxSXZdXJQUWThDIHU7wKyqnLJm18ZNerrk0pHM3lMOfLFnO76wpaFV7kh9VJYl1bMuQJ3+FXg7Oz6lTWsWCHlUlgWVTShcgWwK1seZRWhPVbs9V1AKqd/hq+lAqEKaMmKY9lCOREr9vkyJMGgLQuuqsWyJ4E+NfieZZK+duK7NkwH9DYoi2Z9IgtnLEB1EQn9J227WaWPgVt0W6yY1qaoVM54HNEg0NmrkmOn0+TQoMZbsWLau8KyYMZm4ErQAykV7DRSwB6SYHWi8kbsy391MiQLr9qFr3Uy6FLgcNKPVt89JInBOxnoHWWbVE7vfxboDwkGQ7JwxgP4Wr5Ke+cqwhHo6AQ7jadynMxmgTmAtgzZnPT1dG1KMGgT8d5La8dxOjrTywDbBiuDadB/MNvAfiZRkJHDUVk8MwyyNuqEM/AsCJtkdNroL/jKelkwM2lNk7kbIob8jtgU2fNYrCdhM/qPZXLajFjRbtUrTo+1TMYCIHcEPwJ9OupIPydfqtBxan8hU2OA40Q/kV6zwGFc3j+7CzN7R0hZDYBlRz+pdaC1o6ubhE1wMpAGoTB43I2I3NKLRrtUVPSITkYDIHfesAfYAkRnhJRK1GGZ56HyU0TeQNWipU17DVhfKBAxobU9GgDTKqQjtAXkpRTaBbqufkJ3YeYvSYmxDHVmETHdmDZ4um+z6XNyx7x3gHeAB7V6h5uRJyvoiFyDxzgTj6ccQ8owZDTR7fkY7cAR4ADK61iRo7SEfotq4lGTB8uZiyFLcHQ3kHwOJ8wGapNFg4DWbPgDcGvKg1DVoFTOeLrfNnbscHO0PXq1xhMwJVjR1kOnduMCVB8nKVBaJ1U3XK/r6u8G7u9W5Sgd5kS59eqOmGBw7gkapwZD24n296TfjKkpavRAKiosmT/7pMyffTLVwwPIkuufBF5MEqq0ArBg+gqENd2qlBPwLk5yZyDOpI3KtHg5HAHVrmlBdWbGzNRsLgYuTRC9TSCwGEBElPnTfwL6THIlXap/3hE/9cp4APShulEoP4oLPC4bkUE6E+9cChQlCF5LTO9T1/MakqoIzbgi8R3ezGeA5awACmLWyM9POB/nML6WczNhRmvrJoHcmSiz2zuSAq119cNBvt8l4ASOTJbK6QdjoowGQGvWn4mwKC4I+BSXDO9SUEuCwQHdD+oXx74HiM8AVlu7Ezry6cEknbD8EkgYhTWU+CYIGZ4GN+/ec22BP69hVGFhaNyYUQUlI4vKE6YZpT30SSbsVJ8711v/1r5LCvy+98eUFOvo4SUlNDaFVXRf3Njav58PeluXdYW2nvYzGoC9hxtmo5wBMOfbl1NkOyGXy5UHQCRyhFD4YJ8NDJR8mbb7/Q8m0JXBf6y68IJjhfaI52MqJ1tblxUV5IcMwwgAYNkfETZ72M9oAAzbqHYM53UMZMuOV27fsn1Xvt/rY3x5Wfv137xkpyH8JRN2xljFLxzzNt2PnlroOLq16JG7tyeoyENPPnsZaMDn8zK+rDQ0d8ol2z0iL3Zva1AWQtWXzSvH1p2gE0+J6u+98bofc2L/wUG9IRqzP+XaUhzvS6BnRSW68975c2+mjI9it8Rz5IjyH2g+cDltFtfPAAAAAElFTkSuQmCC","1f490":baseURL+"1f490.png","1f33e":baseURL+"1f33e.png","1f40e":"data:image/png;base64,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","1f940":baseURL+"1f940.png","1f33b":baseURL+"1f33b.png","1f33a":baseURL+"1f33a.png","1f338":baseURL+"1f338.png","1f31a":baseURL+"1f31a.png","1f31d":baseURL+"1f31d.png","1f31c":baseURL+"1f31c.png","1f33c":baseURL+"1f33c.png","1f315":baseURL+"1f315.png","1f31e":"data:image/png;base64,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","1f316":baseURL+"1f316.png","1f31b":baseURL+"1f31b.png","1f318":baseURL+"1f318.png","1f311":baseURL+"1f311.png","1f317":baseURL+"1f317.png","1f312":baseURL+"1f312.png","1f313":baseURL+"1f313.png","1f314":baseURL+"1f314.png","1f30d":baseURL+"1f30d.png","1f30e":baseURL+"1f30e.png","1f30f":baseURL+"1f30f.png","1f4ab":"data:image/png;base64,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","1f319":"data:image/png;base64,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","2b50":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAUZSURBVHic7ZtdaB1FFMd/597khn6o1aYfaoUqIvqg8SOSD5K0aU3SFGuTNqBRqS+K4IP0zcc2AV98a3xQpFCwldaK+OIHsUgCRpOUIAYba/HBWkypl0itsU3T3LvHhzRNbpq7uTs7O1swfxi4uzvnzP/MnjNzZmYvLGEJS4gLOsJxHeFY3Dxigf7Mk3oK1VOojvBEXDwScTVMlhfnXLXHRSO+DoBWFFDAoy0uErF0wHWXf2DOrfv1FGVxcInHA7Jz3v6sF+yKg0pcIbCQsbF0gLhuUH/kIYQzeR4/LGV5n0UC9x4gPgOe0uqQCRBPCNwc/zMF9x3gNAR0mA0o53zaVTJslHLOueLk1gM82lAkrwcoQoIWl5Rch8DiLi5uw8BZCOgwa8lyHkguUjVLknukjLQLXu48IEMLStLH/WdKkgw7XdFyGQJBXNtZGDgJAR3iDiANpAoUmSLFOnmMixHSAlx5gLCDwo0HKGaK7VHRmQs3HeD5JD/5iucmDCIPAR1iOUoaWBFQ9Aop1koZl6PgNYPoPcBjG8qKwB6gLOcqjVHTu+EBOkgTUIdQarmNCjDe7BgGBi1yAWWMBL3yNCcgtwPGgNVWG7t1kZYK1sHcEFDagStxMXKICRK8NHORMwhqP48gfAw86pyWG5xBeF4qGJ65kTMIShWn8agAupxTix6HmaB8rvHgMw3qALuBgyirIqcWLcYR3pBKjiz00DcP0H42AkeBygiIucAPCC9IJb/mq+CbB0gVZymmDo8OFM9gLo+zfMBFqv2MhwCZoPazA+UQt/5UeQl4Tar5pJDKgVJhHWADWT4C6kyYRQ5hkCnaZRO/FSoSKBWWSv5glC1AB5ANyi9CKNBFitogxkOIxZB+y2aEI8C9pjosIU2CPVJNt4mw8WJIaulliseBL0x1hIbwDVOUmRo/rSIkVBH6eBN4h2CbHmGQAd6mhk4RvDCKrO0HaB/leBxFeNCWzjw4h0e7bOJ7G8qs7QdIDUMo70c+v3u8a8t4sL0h4uJQQ+yeHNkLgR7Wk2CU6HeZPJLcJzWct6HMHllhl1V9+ZGweXBik3DwnV/TYvFrEishoD2sQkgDxTb0FYAMyt1Sz1hYRbY8oAWl2OFKrwh41gZxOx2gDt1/tliZccJngj2sZPrgY5kFPkEwSYo1UsN4GCXhPcCjGWWZwRvMAp1AJ0rWQL6EazSHpR++A4TdBlJ/AttlC/tkC/sQtgKjgbVYCINQIaBfUkKKNHB7ALETJNkj9VzI0dVDKVkOEWxw+5cka6SeqwFkchDOA0popHDjMygd9LFtvvEAUs8YW3kO2AtcK1DnSrI8U2DdBVEURjjAEfbvCO3SQL9fJZn+fuyAdtNHgmNQ0MqyFfi8QB43t2kqqMdJcicXYNHD1E8p4lWp5+9A+vu4jQneg9ljrDz4iyLWSz2ZIPpnYB4Cq9iMUuozSk+g7JUG2oIaDyA1jEsDLwOvoFz2aWc118w3acOMAX7ufxqhQho5EEI/ANLAhyjlkHuklVvJfG1g1AE6/bXnzjwLlcNMUi4N/GRKaj6kiV8ophKlK19WqPvNbDEaA7SbauC7ebf/AV6Xpmj/BaZf04pyELgr54FHtTT7D7ILwTQEWua99QE8yqI2HkAa+QyPp4CBHA4Js6TIrAOUqhu/hC4usUmaOWukywDSzFlS1KJ0wPVdYaXCRJdZHqBMAieBt2QbvUY6QuL6tLdfv6KX6S1542xwCUv4H+M/JbU3s19pCtcAAAAASUVORK5CYII=","1f31f":"data:image/png;base64,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","26a1":"data:image/png;base64,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","1f4a5":"data:image/png;base64,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","1f525":"data:image/png;base64,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","1f324":"data:image/png;base64,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","26c5":"data:image/png;base64,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","1f325":"data:image/png;base64,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","1f32a":"data:image/png;base64,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","1f326":"data:image/png;base64,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","1f329":"data:image/png;base64,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","1f328":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAo5SURBVHic7Zp7jNTVFcc/5/ebmd2Z2d3ZFw+BZUFWFnbFKia1FRukVmyqNpUqsSlN6gOtQVMsULGBhJQ0RVBaG2uTpqmJqTVFq6nW9KGW9JGqKUWkLMuyymsRFthll33Mzut3T//YHZhdZ3ZmfrO71NRvcpOZe88593vP79z7O/feH3yC/2/IxSawc6d6uqd1LrZEb1FlIVAPhFAMwgmBdlXeVuW18vbqfyxZIomx7P+iOeCZw4eLyyMlqxBdDczIUe20ijyWCER+trymZmAseFwUB7x0oOPzgvk5MMeNvsKHonr3bfOn/LlQLhPugJebz6xB9DHATq23RajwewgVeSiyLVQhagw9UYezAzGMfsSUg7LxK/MmbRGRj7bmiAl1wMsH2jeoyubUOr/Hoq4yyIxQMV4rPZ2EUY73RGg9G2Yg7gxvVPnBsobJG9xymjAHvHTg9B2o7kitqwkVc/nkUjwZBj4Sjir7z/RxpGvE9Be5Z9m8yb90w2vMHLBD1babTy8BXYxwrShTFaqAKGgnSB1QmpSvry7hsuqgq76OdIXZd6o3tWoAzPyvNkw7mq8tjysGKXh114lALGh9m+ZT3wJmAqAwfFLKzNR/teUB6qqCqMuZW1seIBI3vH+2P1nlB2sL8LV8bRUUAb/df/JmVX4K1Oaq47GEJXMm4bOtQrpGFf5+pIPe6Pm0QC2jjcsWTGvOx44rFqoqL+w7uVGVVxkxeEuEioCPmeUB5lQFmV0ZZFppMQHf4KKfMMpbx87SF3NQcF0QqJ9Umtq1OCK35zsWV1PgxaZT20VYnVoX8NnMrggyrcyfcVHrjSU41hXm+LkB3jrWyWdqKgn63M/C6mARPtsi5hgARLgN2Dy61nDkHQEv7ju5CsxqVSVZZlUEWFRbTU15ANuSjE+txOehYUoZ186qwmdZ/Ot4Fwmj7qMAqAr6SOHSqKp5Teu8HLCjqa1O0cdT6xqnhpg7uQyxBAM5lYDPwzW1VRR7LFo6enPWS1f83mH5lO/5facn5zOm/CLA2E+qanHS43XVJUwPBVAl72KJcOX0Sjr6okRijisbquC1rNQIwKvOF/IZUs7h8uLeE/MczP6kTqjYxzWzJxWcSHQPxOgKR5ldVZpdeAhxx3CmL0JPJM7Z/ii90fiwdoEXSNirli+85Ew2WzlHgKPOPaoqSU/PGVqBC1nJFQj5fTnL9scT7G/vZndbJx9299PVH2UgnhgWAaqKUb3D2Il3duw+2pBtXDkvwUZ1WfK3ZQmCkHAUO8c0djSUFfmyJkWRhEM4mqB+cjmS0qUCPQMx2rr6OHGuP9XObMeSN57be/S6r19ReyiT3azsn32vPegx0R8BK0e2WSJUlRRzaXUZ5YGibKYyIuEYLEuwpDBndoWj7G3rIJK4sGFSZbe3qO+zyxsbY+l0Ru1xR9Ppklg0/Edg0cg2yxKKbJuEMcQdw5SyAAtmVI9JRBSCeMLhrUPtDMRSD4700RULZ29JJ5+R7c6dOz3HQ7NeR7k+tf6SUJCaqlJCgaLzTyyeMLT39NPZO8C86VUUe+x0JicMfZEYb3/QjmMGEyQVzhYXhWuXNzb2jZTNuAa0lc16EKPXJ/97PRZXzpxMZdB/XiY53zy2xYyKUqaFSjjdE2ZKKIAUGM6FIFjko6aihMMd54aIUhkN+5cBz46UTfsW+MU/2yrVmO8nV1URuHrWVCqC/lFXabGEKeVB4o777G6sSk112eDYk28G+FK6saaNAI83ervqhb37pZMrKPUXjdjiZobHY+UsO14o8nooLfZyLhwdrFC9Op1cWgeoGf7Km1EZcr13v5jw+7x090cAEJiaTia9A1QvS/4O+f3YtoUZF4rji2T4A+iIQ9gkMjlgWvJ3kde+6OHsFpFY4rwDgNPpZDI5IAIUw2CS8nEMf2OU7v6BVAe0pJPLtAYcQygHOBce+FhGwMmuHhLOhYxQhNfTyaV9DSr8NTl/wpEYZ/vCF/21lk+JO4b3T55J3SDFUX0hdweoec4YQ7IcONqOMep6zz6RxSg0HTlB/0D0PH/HmF/fu6gh7ZF5Wgfc/7nGd1TNX5Ie7O4Ps+fQcZzBhOJ/tsQdw3sftHGiszv16XdYWI+mGyeMkgo7lnlAHGs3EAQ42dlNOBJlfu00QiWBTGoXBarKybPn+ODDU4QjwzZ9DujdDyxecDKT7qgJ+1M799wC8jIjHFUa8FNZFqTY58W2L87GR1WJxGIMRGJ09vQRTzgjRRwRvrHq+k89P5qdrDuWp95490YVfgNUFMB3YiHaJsqKB29Y+LesornY2/7mnuk2ZivKnbi8TJkgnAN+YmzZ/vCSq7pzUchrz/rUm7tr40ZXiMpiRBuBasDnguhYoQfVNix5V5RXI/6BPzxy3XW92dU+QWF4qFWLHmpV94eAY4xC+Liaz4EYdb6Yu+97xgOF8HF3O2xRL0K9G93xQCF8cnbAmhatPt8hzLWEeena8sGmw1rsNnRH9DnMAfnwyflixCuUrW3WrcRYj6FegYebtNIrbFSHp4GOXG0l0TdAnd/BAfL6qGEkH6PUIxg3fHKOgC1z5RDKXvHSjLAUYalHOKhwbFuDtOY7AAAR6rHdhW4Kn/0CN4pyk0doNXA0Hz5ZI2BTk/p6PVxqJ5irigchAFQONUdQ7LXNeqtatJYmOLSpUdLewCSxpkWrn6iXDgCBuSoXjhtS27LxEcNlYvAgBBn8GAsgYgn2uma9RYTWgMPhbHxGTYTWN2ldAm4Yml+XDZU6LpyvOcD7QCvQqkqLB97c0ijvZ7R5UC9NOGwgxnq8bEUwjmGtV9io8PRoT288+OSVCX6nSa+yhXe4EDkJR7lme6O8m4+dtft1tcAGYOjMmmKFzY83yI8L5YPy6W2NsidXGzk74L5d6g35+RPC71BuYPCDkJdQvhmEL2YLtRGhW4+wmaFzRyAiwgaFllxDt1A+SeS8CJYGuUJsVmxrkCdV2K9wYFuDPCs2K3otFoymu75J6/rgLsvhPlHuQ7gX8KaIeFVZiXK/Gu7vg7vWN2mdWz79wuW5jsvVBd66Jr1bQLc2yjNu9McidMeKj7utrU2LWOmPmbPhvl3qteEJYB3K74FXgHuB7Zua1N3OsgA+rhxghJaExcF0bZt2aWDTLs14ZuY2dEezOxqfbHD1leJo7+p+P3Otwcvh99Lqzpd/J3+LcpChW7et8+QEcMKN3Wy5w2gYs9Od7/1Hp8DgPsEZysuTdRlh06IZbmwKspsHCv5aPIm4haxr1l+JEgZYt19vDcN3R9MxQotPR794cmM3H4xJBKxp0WoRZoliK6xUWCng8SgzH23Wqkx6T9RLxw/nS+dY280HBTtgfZPWiWGpCktVqUnWq1IjFjfF4aZs7/SJtDsSY/Yhz6Ym9fULrwHJ/X00qNyca0Y20XaTGLM1IGyY4/Fwp2P4MoBt8UrYYQ4u9voTYXfcsO6ALnqkWa/9uNgdswhIwggtZhy+kBsvu5/g/x3/BbqyIkESizIyAAAAAElFTkSuQmCC","1f327":"data:image/png;base64,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","1f4a8":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAA7XSURBVHic7ZppbFzXdcd/5743wyE5lEiRcmmaWrxIouI6jmPZWmrHTmDDhdugQIo4iSW7NRDUSFO0/VKgSdHCQFqgQRo0QIM0H9oG8IIY/pQCRZC0qd26ilwbimS1kStqtTZSIsV9ZjjLe/f0w9vuDEmJskxFRXUE8W333XvO//7PueeeN3BTbspN+f8s8otWYDF5bf+J1fV6sAfk06D3Ab3ABOgJkB95Vv/uCw8NjXwYY91wALzy1tHfVqvfQOhbqo1CzSjfLLXNvfD8tm2NaxnvhgHgBVVz51tH/1bgdwDa8z533bKavq4CRoRGaBmdLnNmokQtCAFQZa945tf27Ng0+0HHvWEAeGXf0W8p+gciMNhT5GPr+ygWchhpVrEehLx7ZoLjF6dRIhAqbXOf+qBMuCEAeOWnR35DjPmBCAhCdIyk2Jajp7NAf3c7t/UUyXkGgP8+O8HPz0+iKKr85Z5dW77yQca+rgC8/J/HBtWGvynIJmAQpWo8hgV51iAbRUBEkEQxBwgFfGPY0NfF1oEe8r7H6++dY3yuilWta8DW3Q9vPnm1Ol0XAF7ad/wuIfxr4EnAJPc9EYxEM54cWxnQKgrkPI/7N67FGOHNIyNYFFX7nc/v2PLlq9VtxQF4+a3h30L5LlBIBhxcU2RwTZHV7XkAyrUGo9MVLk6XU40SIFxRANX4CPduWMu7p8cJrGJVL/kEQ5/ZvnXiavRbUQBe3jf8ZeBv3HEEKOR9+ooF1q0psm5NET/269n5OgfeH6NcbaTGuy6QHjW7bsv5WKvM1wMCawmVo1b17+dyxW8/v22gciUdVwyAl/YOPyyG1wHfHcwYSalvRGjPeWy9rYcNfasAaISWt4+PUnJASCU2XIGB7k7u6u+msy0HQGiVizMV/mdkikulKlY5ioSffXrH0H9dTs8VAeB7b5wq5NpqwyDr3fueCJ7JjDex7xuBgZ5OPrp+LZ4RStUGb58YRa029eu6gMZg9HS2sb5vFbd2dxI/5vC5CQ6PTBKqTkhoHnn6oU2Hl9LVLPXgWiRfqD3XarwRafkPnhE8E7FibLbCoffHUFWKhRwb+7riNsRtwJOorRGJjzBVrnHw/TH2HRulUg8QgV9e18vm/m6MSK819rXvvXGqcF0BUJXfd68lAcAks45zLpFhIkxVqhy7MAXAQE9XE1sS9kRHmtjjiTBTrrJ3eISpcg2Aj67ro7ujDSPyEb+t/sXrBsCLbx+5HRhqGkQcwxehvwvC6FSJmUqN9rxPsT2ftpd0uSQFxJiIRcZE94Iw5J0TFyhVG3hG+MjAmuh9midkRQGQwDzadO0aTbMRix1F4NTYNAAdOT/KCZJ3SIDIZj59NwYhtJb9J8ewqtzW00mbbzDCpld/euzO6wIAYgebB5DUCJHF2NDsDoJQqtaZrdTI+36UDyT/HDAyRiwEslyrc/zCNJ4R+rraERFCo/deFwBEZW16DvFsSZPh0goCNFMcYXy2gmKddllfUb9ZsuQan/RxcnyWILR05P3oXWXtYvr6i928JjHUkywlMTRJbV36un6dHpM2wEylSs73EScZkGjjE3WogChoZJ0gGImXyNgVzk6WyPseIoLn6aJb5g8fAOVSqnC6uclmxjXSLGG8iNAILI2wjnEyFVWJN0hJLiDYGASDojGbVCKgLkyXKeR8DBCg564LAIq+G5kc+z84/k0T9ZNdX6vxKSAt20GRzHAkopnE50oMgmbAT5VrtOUCRKh45eDgigLwgqr5+MHTTyjhH89VA4feLUams02zC+C4DFFUL+R8PGOwqtQaIaG1i1A/BifWQ0SQGCxUqdQaiPBPT33y7tJiel9zKvzDA8fWGvGfC9HnrXKHolTqFlXFN4JnDJ4hPncTGjdGZNvigu8z2NdFT7F9QTWoVK0zPlNmYm4eq9FsW1VWdxRY01Wgoy0HCPP1BmOz84xMlmhYJbB2REPz5Ge233HomgF44+Cp7tA3D1hlJ+gTVnW7Kp5VxSooShBCPQzxjIkMj7O3FATjLl2Ja2QRHaLZ7y4W6O3qoD3fTNRytc6JC9PMNxqoKiKGzjafNcV21q7uTKtGlVqDA++PM1GqElodbxjd+fltm04sG4B9wyNDquGXrDJoVQdU2WhV+1WJixA0zUQCgFWoBzbK2Iw4s5+B4BpsHCYk7pLVBWB1Z4HB3lW05TIggtBy5PwlytVGOrZVxYiwrm8V63pXIRLtEt86PsrY7Dyh1Z9NeTM73frhZfOAXVsGjpRqua8KMiuwA+hfqq1VqIeWasNSqYc0Qtvsm0QGupCnxrZei/tMmCnXeO/sJcamMzf2PcOWgV5yvhe1iuNNqJaTF6c5cOoi9SDEM8L9G28hH7Hi/mKw6ndpGfOK8uNDFzrbc/UZm1DdKjVraQRKPbQE1tKycwWiVaA9b8gZk1LfN1EKKyIsTIOlpRYoCwoivV3trF/bndYKpkpVhkcupQxI2BBapbOQ54E7+vGMcOziDIdOXyKw4QVvVbDhqbvvrkc6XkH+/fj5dR1tjZcBDyCwllqoqCqegYJv6Mz7FPMenTmfzrxHR96nI+/RljOEVglidGTB38Xnosl4cQGBibkKZy5Np217igW62tucdzPQZis1Dp0ZB2B9bzGOL9Jfm/GfTNovWAYPHb9wSy0M7rHoA1Z5XAP7iNXIeIgqs56ARZaIAZE7qEbpihK5RmiVQs7QbrzMqKZEYOlJEKJVL6HBpdkKbb5Pf08RgFt7isxUaou+e2G6zOh0mVu7O+lbVWBkuoxExdkfNAFw8Njoo1bs1+oaPqStI16lJG4SqKI2Coy+7+GbxQlXyPkUcj5WlWo9iuxXkpHJOVZ3ttGez9HdWcAYwYaLv/fe+Un6V3em5TNU70+epQDct+nWfwMe3n/07HbEfBvVbVdSIrRKw1oCqynVw5ZgYETozPnko21prEB08DzDut4u+lZ1kI+DmaoyXa4yMlmi3giy5i22qSrvj82wdbAvGqMttyQLKrUGo9Nl2nNe3I+5PdWvtfG2zevePn3XwA7g9eSeVaiFlrlawMx8g/FynYulGhOVOrPVgEo9pBbYJuNFomDXnvPwYsu15W8QWk6Pz3Dw5AWOnLvEbKWGiNBTbGfrYB+rOgtpFbTJ/vi6VK0zVaoC0J7PxY+0uYIcy5mJUhqLQLuS+0umwoLUky6MQJsXRfPE50ONAmFggTj6aqpAHB9slKq6iiRV3QwSQYHZ+RqlkTprigU23NKDZ4Q7fqmb4fMTVGqN9O1WIEanSvQUC/hNu6aoOOqOOTZbYXVHPnk/XU8XMGD/0bPbNx47/xNFf3UpcCDL5ZOipjFZtQYgCDU1NjVcm6fSfZ5cT5aqHDk3TiMMERE23tIdu072QSTrU5mbr1GpNeLA2/LcASKwlrHZ+WSoi8lJyoADJ0c+oVb/1CqPLScItUqoShBGcaCh0bLhiXEUibZpidERT2IeaHQFiogwXw84PjLJltv6KOR9VncWmCzNN4OnWT+TpSqN5JN52p861xkw8bT8bAEAH79j4E3g8X1nz7bnqmbIKr8i6KMKnwbyztAEVqlbjffs0XULOVGRqIavgkpGdXdWUoViYBLDRKLPZecmZli/tpverg4m5+ab2RRbpArTpSq1MEj9PxvHAcEZW5z4dsVM8J3Dp/prxntJlceSbCvKci2hbc6+rFUwUG1YVLO835dsE+SZ5g8kyX6gdTucZHpDg32053McPDnqzLymRxtbFsYGh3EWGGq0IkX/IVCNPp1ZrTZq+Vuf++Tt07CMTPDBu2+/YDB/5t4zqf8n6W206/M9gydCaKMAmSCezYBm1+pcp197YiDRNNiOTpVisExK7SYQFCwtY9A6dqYPyHcT45cFwN7DI+ut6reu1C4Rl6Y2pmTCnOwcZ9VwFacJOIsyVZqn1ggwJnu32cDYMCcTbQYVt+1Fk9e/aJrMyxnzH8Pn7jVe8A2EDmD+cm1TAJwAmimSpMvNxlqXBa0gOO9MlqrUA5vOZAqi6wokDEpYRNO5ooEVeebpbVsuufpeVUFk75EzA/WGvc+K2a6q21X1Qava7e4FrCpztSDtPC2KxPWAxPeTWNC0E2ypBSbK5X2PehA6gdL9QJrtRUIbrUbWLogFQUPtM7t3bHm11aZrLon96N3Td1vsr6vqY1Z5RNHcXDVIlfXcAOiUw7LP5HEeAWkOkZUNWtVzsrwW45MtsHUMtxEg50Ls7s89uPnNxfS/ZgBc+eGBY2tD9Z6aa4Rfs9b2JMb4YlIATDLzCRAtHzWSDx7Juy32Z8lT6kYZ85JVKTkG6F9VcuUXnr333vJSOn+oACTy0r7h35PolyHAQhYYF4iWgkjy7SAribXsI5xA55blbEL/Jnfgsc8+eOe/Xk7XFfk8Lsa8CDKVXFs3cLmBylU4PSbnOPTOljHrtLM2pr1l0T6DZei6IgDs2bFpFuGbyXVKVesAYRcab11j4iQmASBNbFKKO77v9pH2rYjoxcuouXIAANxWPf91YF9ync18c90utLHCSeRODSVuQ9yG6F4Cim0xepGjadSu+IPqFYkBiXx/75GB0MhPgK3JYK0/kmr9YpxWj7l8EHRdIkmJm2OBHnl65+atV9JxxRgA8IWHhkZMnk+I8i+x/vHMNbMh9f94lhPqh1YzdiT0d1wp6aeZRWka/ePl6LiiDHDl5beGPwf8IcqOhAkOC6wgJvmUHil2+R9KutnjQhdQBLbv3rXlnSvpdd0ASOTFvSfWi4T3GLH9BjOP5x0Vo1VfeVcEbzk/lV24GcrYFGXi+s97dg09sRx9rjsAS8mrbx/7joEvXe7H0snJYnlAkh4DDWt117MPDe1fzrgrGgOuRuqFyh8FqsOuryerROLjTft8tenRqpMiI3+yXOPhBmIARD+x86zsFWRgKQYkm01nxh2Rf9i9c9MXRWThoyXkhgIAIhBMKP8I3HMVrynw9d07N3/1aoyHG8gFEnl2+9Cpcr5rB6J/zrJqEPJztTyyZ9eWr1yt8XADMsCV1/YdXlPDe0aQx4GPKfQBs4KeVWQ/Yr9/YsfQmy+I2F+0rjflptyU/5vyv1STOm7+yXeiAAAAAElFTkSuQmCC","26c8":"data:image/png;base64,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","1f308":baseURL+"1f308.png","1f32c":"data:image/png;base64,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","1f4a6":"data:image/png;base64,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","1f4a7":"data:image/png;base64,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","1f30a":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAABQ3SURBVHic7ZtpdB3Flcd/Vd1v0dPTk2RZ1mp5xcZ4A9sECOCFnSRwkjBAyDqE5LCFMGEmJycBEoWczJwZYELgJISchASyAgkJhAA2GGNjsDHYRrbxLmNbtrXvek9v66750N2vu5+ebMkQvkzuOXW6VF3dVf//vXXr1u0n+Kf8/xbxYQyyNqXuEorbgC1Lw+Jyp/35QVWZEXwTxXUKYib8IRvl69cIkf4w5gWgfxiDCMW5ChSw2ml7ZVhdqBSPh6AWrJtKcaM5zE7gwQ9jXvABWUCjUsHKXi4NChaHBTVBQSIoWR+K8tzHhEi9nFTTNcVSTTFJCsolLBKCi73j2wRgwBNKcDBrcKUpkIbivsuKxS8+iHkWkvdFQKNSemk33yzSuD0MVSEJIQlBYRUddgY0fqIpfqwJdE2AtAeVeSMr20RMSJmKkAFkFRgK0zRYuKJE7Hg/cx1NTpqA/2xVlcU6TxdpnBeWEJYQFhYBAWEV3b5qgANeCmvQQgPbBDiWgKFsEuCWc8Li4ULzWJdSpwnFHcLgu+cVi2PjxXFSPuBJpbTWbv4akXy0yAEvISQgaBNgWwC6sMF7tC8KkKBwl4EpwLSvhoKM4q43k+rqjKI5a/L08mLxgvOcDNJiJulQAaqBcRNwUhbwQJf6fETym4gELwGO6QdtzR/og6wJM0ohFhyp/XwCnKupLEswlFV3lkPaIoOU4uHlReKWk5l7vsiTeahIcpUXuKP9sLCJkBCQUBWxQA6lLUvQsaxBE65lFCrO0nHe41hUWOTGufnlAVXxQRAw7iXwoFKhUD9LQ3ngQ/b614VbaiJQF3FN/nhse63BAAbSEA1Y4KUAqUAoECYIQYdewkD+O5RScl2Ky1DsWlYk3hsLnnFbQHEfd4YFExxtOCbvdX5O0bAmr41zoM5h2NYNTd3WczoexyohCAEtw8qNKXX3a32q3Hlu7TBnCfi7EOxel1SXjmWscRHwSLe6OiS4K+hsd86692je8f7S4/jGK1URmB6DWMD/Ht0loTwAKwJwjwyxY01KnQqwPCI2oPgq8Lww6RvLWGN2gg/2qmVReKFYo6hYQuQ4W5+j9Q9SFLZTxHKEGdO6Jk1ImjStLmJRoxDmeN87JgXd263OCSr+FhQU5YIcAQFcU3ecWiqr6Ej4J75qb8d45zVCnODJsQTHYdoWsfD8FBedzHtP6ATv6VSLg4rnA5ISr4k7V69Hl8CwIXhieydvv3eE6pIgTW0DlIQDXDJr0snMzycSQFixgi4sa3AUETRZCqwa7zuPS0Bju1oQUKzUJWUOaKEUb+1pZ8ehLiIhjTk1pZxRP4HKaJj+tOLeV/fy9LaD7uIVgnBAoz+ZpTT8/s9eAms30ARoCgz7qgu+uCahZg0piBswZJAczHJgwGBzWOPVb1WKwdHeVxh8h5qJyevFGpNKNIhK2LztEI+t2k5PMg2ahtAlX162gIvnTqG1P869q7dybHDY47ksApCCC6ZW8NClc6go0jEVtCdh94AV6KyoGnk2GE16UrCjx4oPppZCRLcCpGHTKgkFQ4ZdTBjIQkYxjOLXQYO7v1Mvuk9IwL1tqjgOG4F5MQ0C2Yx69E8bxdbmdtA10CVCl3xl2UIuPK2BnW093L/mHeJZ0wYufSTMrqrknGkNTIoWU6RD2rAiO0dKRZoLagTTSwNjImCbDUGXsKDScojDHhKGTJeEAcNylLYc0g3Ov6tOtDgNBW0yDr8E5kkgEU9mHvnt2kBL12AOPJrkqjNnc+FpDTQd6eL+tU2klbLuecBXlES5aNYMGspLAcshJrKglKLlWCe7DrTQcqyL3qE4CMHH59fSeMV8JpdHRiVgQggWVkDrMBTr9vnCDpScw5bEX/fIlKzkAeCqUQn4fqu6XsG1AJlMdvhnv1xd1DkwbNmcDf6cWXVctWQWu9t7uW9tExkAXePyObUUh3X+tLOVuTVVXDx7BgHpTiGdybJ1x36a9r5HfzwJmkDTJIR0hBS0pgSrDia5NhohehxjKA9BacjaFtN2hOgQIfKJyLdxgS9A8hHQ2K1iKsP/AJhKpR777auhzv4EBDTQLPBV5VG+umwBbQNx7l/bREZg3ZOSr5w1lVgoQJ8Z4Yzamtx7DdNky/b9bHp3H4l0BjRBoDjIjz5/DqfWlPH3pqPUxMpomFDC4Z5BVu3r4tOnTRydAR8ezwlTjTxtFljj8VEJIM1NCCYCrFq5tf3wsZ4GdBe80CS3XHA6mhD86NVtDGYN0Jz7gubeBA1lUR/4Y+3drFy/ha6BIWsJ2WSeN6eWBZMnAHDlosn8dUsbj27aze6OPv7jvBnA2AjIJ2MMbY+OTgDcANDZNbBr41v75rjgLce2fM5kZleV8/MNOzk8mMgtCef+Ky1pFqQt21VK8frb77Jx+z6ULiGo54gsiYS48ozpvkk+tHEXJkBQp7asaEyAsyYMZiBko1AF+ij/H3uDBvcVJKCxU83CYBZKxX/z+KuVVjwrcuBCYZ3rzjyVHa09rGludR2efX/x5FrmV1WhsNb682s2se9Iu7t8bLIWT6nipvPmMZRJ5Saxu3MAU9dy9juYHVtE256Ag4NQFobqqAs4v9gyhOLi/G0wR4AwmauAvfvbNg3Eh1fkJm579YtPm0okpPOLN3ejNJHTJlJSVxZj+fSpACTTGZ58bi3t/YMWeF2CriE0ybVLZvGJuVP4XVMzL+4/xhVza1lQU8rj77RYfQXMmVRJcclI808aEPYcMBRQE7WiQVO4iRQnq6Tsc4OHgCga9ymlrhVC5JpzBChFBTDwzF82zvcFMlKg6zqfmD+Nl/ccoS0+bK1l+56maVw6ayZSCFLpDH96bh3tfQ54iwA9GODm8+cxt3oCP1y7jV09A6BrPLuvg2ebO0EIJsaiXDxzOvWxEjrSsG8ATolZc+tKZHl2VxdfXlztatmGUBmBtAlJG7CTTXLqhncNKK7+fgevAD8baQGCVEdn/1vxZOpCAg5AS/uLp1VRFNR5+t2Dnn3eup7dUE9FpAhlKp5ZtYHW3n4IOpqXyIDObcsXUFdazLdf3kxvNush0HrHwuoqLpjagG5vmRnD4AevthBKDSJUhrXNXQgBn5ozgfJIMGfaXrBGXt3wEOITxe0FCVAGu9a/trvYCV2R0t5PBMtn1bOuuZWBVMadvIBwIMCSesvjv7H5XQ61dUJAt3cGywKu/+gc6kqLuWfdNgacXUNaS0hqkkumT2N+pWXypmmyZc9B3tzVTCKbcckWgBLc+Mx2HvnkAmLhACbwk9ebOWfaRGZMKvVlkbOePGI2nwA49b8OqfJvTxG9PgL+/Nj65l1Hjy3Kxe/CiiSKQgHm1VXwrb9tJH9pLK6vJahpHG3tYsPW3e6at53eitn1nNVQxV2vbLXBu7uGrutcccoMZpaVAdDS3s2qzTvoiSesPqGARxGWib7TM8xn/7KLhdUlJLImA8NZSqLDTJlUmtN6Nq8UcqepELkwK0fA9sOHF4MMuuZvDTqvfiLNnQMcG0xY2rfJkVJyRk01SilWr9+KsrVq7QySibEIX1wymwc37qQjmfaAt84RV54ykxllpSil2LBjH2/sbkbZUWEutpCCCcVhLppew5LaChpixa4lK2sqJSEXbMYu3noBOfS9Kjob8wnAZBkarvbtMre2gtcOHPNYhXWdUl5GUUBn+673aO/p8+zz1tb5hTNn88bhdrZ29vna0QQXTp3CjLJSsobJs69vprm9y+M0LSsqCQe5Zu5ULmiooj2RZFNbD7/bc5jDfQkG0mkMQ4FpsqKhgh9cNCcHOFdMyznmiSEE3yi4CyDk6f4vFlYMNa0ixl/ePegSYMvsSisrvXnb3pzWHZOtKy9hfs0EvrHy7dx6t9azZF5VJWdUVpLOZHl63SZaevotvxHQciScVlXG1xfNpi+d5t6te2nq6kfZYzfEwkyUIfZ1x8GUvNkxQFsiTSQUJK0s0Gnr20F+YGQiWPq9KvGGt9ETCarJ4IC0iJCaJGsq+pNp2/xdC6mPxWjt7KWzp9/SvserXzqngRf3HaU/nfFtmdGiECvq61FK8dzrW2jpti0noNk7h8ai2gruOPNUnjlwjKffa8MQWH2ABZVRfrz0FDQh+P6GA6w+2E3CNLnphe18/JRqFtZOIFpcRMqE1EjtS0xuBN7wN7rSkP/JpqwoxJ6OXrfBlqCmURYOs3v3e/7EhxBITbKkvpJVzcfwO1TBJQ1TCGs667bspLmt0zV5W/MN5SX825LZ/Gr3IZ461IahS3dpBDQumVqBZlvC5TMqs+haCk3SlTZ4rKmFdzsGSRXWvoPri43t6pOjETAiAK8sKWJPu5NdFjkeJkSKEAKOtXX7/AIS6sujHOoboi+dybUhBNXRKDPKSjnS3s2mPQdyEaJThC655YyZrDzcweq2Hl/uwSkTwvpRZ24fmVTyMl9YHOZfPyJQ6rtI4oFQgGRh7XvloXvbVM6begkYQVpZJMT+zpHp9ZCuYZgm7V29HodpAZ06IcZbRzt9bQg4r64WwzRZtaHJ9Rm5M4JgcU0FEV3nyUNtPtBWH6GQ5vlLq0q/mpun4onchG44+wd85ZzoUMZYP2wcFzwo6uOCmwsRkMnvO5TMEE9nXX5sigJSI55MYZjK86XTqpQXh9jZ0e80AlAcDDI1FmPvgaN0Dw3lHKLXOZ5fV8kzh9vs/IIn3tAEmMGz+PTp688LixdMk3OV4sKlReLX+fOdUzvxX7KK3hNQAIovjSRA0WIBdIF2DCbck4Wno0JhGB47E27FMBTtQ8O+tpnlZQgheGf3AXfJ5JVTyqO83tnr8xn2aXMNV81+y3nb8ojYsKxIvFII151Vol2XrABeOi4BgrqRBEgO2PhyoHuGhv3fre2fcQwmU34CPHKobzDHo/Pg5GgJieEURzp7RoIXgqCm0TGctpKXTh7LIWHzaZcdF0yefLdKNAnBY8fpMojinpEEKPFOTtv2acMw7IqvXTGYTBEJhwocuhUHuwe9DQCUBoO0tnf74ohcwCEgqEta4o7VuO0IlaBx/L8YU4qz/A08HBBUo1FHFRMaq8UDzi03DpDmGkxxt+9A7QHt/Xs4nSFtGITDAZLK9FtHKm0FNp7+sXCQll7na7aHBLsazxh0J/NwCgHInvGCt2V/3t+v3Fkl2gt1dC0gkd4ADFlZBU/JnTmVW5TiYE8PFeUx90c9Dgm+v626QKCc93qtw+6nUByNJz3TcvqaJ/WNtdhK6zsBzyZ6eHa0vi4Bv74+CTzpgs4jIldMUIoDvf3MmF5fuE/e8/FUGimF/4dADkm2023uj+dZHZBVJWMFvS6p7l2XUt8B+Ga1iFPF+ZpgJlWc2zh39GXk/24gxS99ms4Vc0Tbga4eamonWoQU7Ou2d8TjTCyPjSTI06dnOOWS5tyHKGvWRE8E/kmlNOB2pcj9bqhRCPPuKtHcKET2OI/mEfDT695AqXWFSfBM2DBRhsmerh7qqyaCYeaR5Cfhvf5+6morEaMQZNVN6z2GQ4J9v7vibyci4BohDAUvCjhh3+MTAGByZ25CpunRsAve+XtHewfzFp7iJt+8oAwzR8z+jm5MoG5iudvP8PTx1U13DMME1HJ+33TBiYAsC4srl4bFzSfqd2ICfv7Z9SjziVyKxSikNWuS2YzB9q5upk+uHgnAU7KZLG8eOsKihbMga9jthlXP2nWnv9OWNV2iNF7iV5tOHy+4kyMAwBBfwzTbc2aZ06jym6ppcrR/gOLqcnQhChNgg9ly5Chl5TFqK8pdgFkHsFG4LeMQZEpCgS08/vbXP2gCxKh3bvz9ZQTkc+ialjuSej5wWElPq64FdGbqYfbsPeSe7z3ZHedaHoty+fRpPPX8a2Q0YfV1+jtJEe8hKO+oDUDWaCOjrubGs9f/YwkAuPn3d6Br97tndg94hwz7UKMHJCX9KXp7B3PJDT9x1vO1ZTHmxsp5acNWC3TQA1739M8nwCtKQSYbJ2uuJJ74d759+cF/DAEAt/7xQTR5G05yQssjwfOVSJMaZlsfKpu1NKt7LMUDbFIsytRghE3b94xIh/kI0Lz5SXu6zsHM2TINEzKGSTo7SDrTSVYdJJVtxci0kcoMYpqAHgBzMlCD0Fbx8Gf+d+wEoAS3PPEjAvL2QkkKbyY4p63uQWv96iPBOyUSDDItUsyuvYcwdeEHr3veKwsQ4BSvT8p6HGgmC2m7KB+ULjKJ6Tx6Q+73QmMgwCbh1ifuRpeN6JrwkeAF70mMMpCARMoGlU+Amz+MCsFQW7/9c7M8gr2nwtx0leezkOnfch3HmTEs8H4ML/Gzz12Sj2yMBNhy6x8+ha49jiaj+Z/OfeCdtZs2LCLAr9X8viYwnIJUJi+LLEaxADwRY54FZOwt1ZU0Qn6ehz/zVCFI4yMA4LY/zkDKx5DyXD+oPPBe7cVTkLRzhHkW4EuAKCwSMln3y4fPCXoswIkWnSDKMX+/vIxQ1/Dw50bNEo2fAICrn9So4Xak+B6ajI3w2lKAcABiAVBAMm2ZZn5WKN/RgaXdbNb6zKMM+xu4vaALnSf8chClbuWRzz1/IignR4AjNz0+iVDoHqR2A5rUR2jWa77evdxxUs7E8/d6r4zm9Jzw25uuU3SB+G96tAd56poxJVLeHwGO3PrnKejmHUhxA5ooHkkCvg8u7sjKifQ8hyBFztTtLrn2/KsrbQj1AEbsIX5+RYJxyAdDgCM3/66cgH4tmvgSQjvbNXH8Gi40qic3kPPsXsBO3dV6CsSzYDxOdd2LNK447rF3NPlgCfDK156chiYuR/AxhFiKFFZyQ4iRo3rB53t5r7dXHAVWAisJp1bxwPVj+p+A48k/jgCvNDZK+k6djdLORKk5CDUVxDSgEogBURQ6SlkBiqk6MdUxMFswxX5gK5p4h59e1zL6IP+Uf8rJyP8BdHyJQMhdO64AAAAASUVORK5CYII=","1f34e":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAA3DSURBVHic7ZtdrF3Fdcd/a2af62v7+oNrG9tEKRCFKuBGQE0iimycpKoKFeElQFU1QrQQSJ6qtuqHKlXqQ5u+JVRVI0IqUZr2pRApiZQqSkiJItKkiuMAEUpCIlCDDcKc++n7ec6eWX2YmX1m77PP8b2+N3WlMtLW/jj7zJ7/f9b6rzVrnwNvt//fTS73ADbSPvL0oessnES5EeUmDL+Esg/Yr+hcr7f2vRmWfue532Vus30Xv4Dxbku7+0sH9+zsyQMefUSUY9UHAigA3rn+jxZXFq9V75efe2jz4OH/IgGK3PeFQ79Hj08qHJYWI3WufHVl9cLhvitvABD41KU+7rK7wJ/c+1tHdlDu/Ounvvbqvf92aEqEJ4B72u716PmVlQu7e/313emaCE9//UHuvdTnX1YLePjh4x274L9dqkze/aWD75GePAP6/qEbVZeX15bcem/tysYnC+L5062M4bIScGDh0IdV9V2q/NNkT77QBK+g/f763Mrq0rRXP/R9VR762sd4dStjMFv58laboh8EmDl+dh74jfwz793c0vK8LK0stoJHefQbH+PprY7hshKAyg2gbyy+6/yD2dWV5dWl5fkLs1f0y3771+AfT5zjj7djCJc5CujRtYMr5xBuASjL/ptLq4uHvW+Z8dC8CH/5zO/zt9+QGAy32C6vBcDu5avmrgFWVlaXZhaX50eCF3jJe05+/UE+yTaBh0u0AIXOIntvNvhfBXMj6FUGDirsiIMFdBbkDeCsIOfX0Z8b5If7WPxZ1Y/RordnjfmlOeNdeaD5HFE4et7M3PXMxFsfeq5YN04e10ImFN5y0C2tnPXC887w/atXFl4QcL9QAhbY+35jeGBJ9T6DHhCViFZQ1UZSITiBUsCnPcpZ9iyr6CtW+clj5frkrrOLq0f2+sJZYybXpLNnSeTIW8I1r1lufslyeMYcMMoBFfAQQgNcZwSsV1RCqvTKzv1v/NjwlIMnji3PP79RTBtKhBbYe50Y/kZU78EYEQOCgEi9E1VQxang8JRAKUoJOFFKBI/iUBzwzVuv54aXz3Hl7CIGMAgWoUCxCBboqCAKHQVFUYIQeEAFSjMgujRC34j2jTzdE/fn71tYeGXLBMwzdY8R+WcxZqdYAWMQCTMvIqELSeBBNQyyVKXvHasofVVKlH4EX0ZyXr7unexeWuUdb3QpAIuhg1CkTWCHDyRYBVHFC2hGQAAvOBP2fQM9I/StLK9b+ehtMzNfHIfPjgVv9vyZEfNZKUxHCgvWYKxFCoPYArEmHqdNEGswIliBCQyTCKLKunrWxNMjHK+rQ3s9Zqf3MNWdC+Ydp2NChSkPU17Y4QngqbwtTl2mhPFY494bwYtMKHLf/VM7F59YWf3uKIwjLWDeTD0imMdMYRBrEStgLSIBJCLBAyR1oWFKVFHvwXtwijoPzqPOse48S+K5II5VVdbEc2HfFIfmV9glhj1qmFJDJ9N4zUaoccutwCcrMEIp4IzQqzboWcHBA6dmZp7cMAFdpq4vjJyx1k5SWExhwuwbA9aCEcQIGKl5AABeA3ifgS/DnrIMxxtoeZxLJFSPiIKoIgMCmm5gB0SUhhVBbj7Z7b7cfE5rFLAi/2CsGYCPVkAydWMCeGMqu5QozwG8Qb1HjASVlgSiAErYIAmjWnIHjawkQxSNe+KxVjO8S+HvgDubfQ0lQnPF1Cmx8kGMGZi9tdHfLRQWOmGTjkU6BTIR9x2LTBTQKeK98VpRINGKxNpA3AZAjrymdSICYB1c0/x69aU7vjk9/WvNPocsQL35uCmin9tEwgB8EjxssgCJ0SBEALxHjKIGxHgQjTNlkRglRBXta+Y3FyFD61qQgGrjXMIggk7lwpnusfJx4Dt5P7WpeBUmRbgbY5Dk5xXgqPJFmv18xnOLyI6TxcTIUfWVXOgSWy3voGEJ1GdfGCRoonzk39/97h0jCdhb7P2AGNkVfDzzdSvhuNKBaA0J6EQRto6tzF+KAoqGFSXLieFyw0A3eo+2XNfcDdg9NTd3YiQBwK1B1WOWJwF4AC9VnKcI8Z+iaMx8BN8JwJN+YG1NOGsiuoU2kqBKI5rpOYjh1vy8rgGq70XMQE7NgIiwmZo1BBLsICX2CsYN1Fk96gXxgroEXlHjY//EBP9/r6nnpvy8RoCoXBOPEFGqIJ8ISIQYomsMfBsIMR/AK+I9agwYBfHR730Wp4J4btu6dqNNuDo/rRGgwtF4U7qSfzHuZaD8hgCsKEKspwzgnQTw4gPIyoJoBOtLF8LG6Jog4+etBL8jP2k64d7wRU3LzsFTqr2S35NfGxqB5KfJH9NnjX1L24h11O6Rlusy1M+e/KSZB+xQHYAXpVriohrSXE2prq3SXSGsy3HhHq2+k49m+8w9XwSl89GbNHOInSMJUKSPUqCgPiQsaXEj3oB61Jto5i4kO4D6GHnVRxJ8XBPEhVFFSExfErFk+3GAW4yk+a0EuCIlpt8tva+NJAB0QVV2eu+xasAnFbdhVp3G7E6qSox6EBd8WpOVlD4shHxmNarh5qZVjQI97lq2OKq2zBq85NeHupkdSYAKc6p6JJhxNtveoy4tapIIhvGLVzRFh0hAWAW6ioSwj8deq9HpBlPhNiJqPi4DsHVSWi3l/EgCgJ8pXO+9Ik5RiSs644KaGwmmH9e/4kFTJEjNe/DU6gCBhOQaPnOR0QCrYxn+LJl6G1iVWDLL6gV5E6RWL2xogP5QkA+rxlkTM0haxFUrEIkagY/xPYW7XCy9BvBlqge4QILLCiaj6/9D4LVxrWn+wfRjqSwREusFNQJUfzCSANS8oKKIgnceMQ5TUk9aog+L16APRuvlKY1m7jUD7YI4OhfAu3hPG+hxhDQAJ/NP9cHk/6lg0gQPgLXfHkmAc+5ZWxivMT/wZZhZKUOHRlOIsyGr8ya4SUp08qKIag28li5UhfJtDPCLzX7aJ/AJsBfBZZWiRvvvk+fPvzCSgKMsvfUme3+gwvFg5h5fhicZwqQa1SDmRhDjETFRGLMwl5Tf+TDTzg1KY2UUx0sAn8++SlYbrPx+YAGuxfxRvtxkZKgg4g1fEc/xSmicjy8kFOMV7w3iieIoIc/PH5Q0IiVMyecrHfBV+GsNdW3gm1s145LVB9Psh5lvM38Pn29eG7rttR17r+t4fmI1rIeEMOtiBGNSTTCuCFNNULIfsqSER1PYi8mR8zXw44APga9ASuXnLs5yKoSWBvqxCNo3Qs82CZYXb+92b2w+d2hB/s71xZ96w3O5sKgI6hVfOnzfof20LyFu2i+hV0Lfof0+Gu+j79AybG3gU8Y2Dnyb6fvKzwd7VxHTGv8/00Z8a0XCCY9X2VSDffW+Aq+9MgDtRVLKsAXA5YCEps/LaOBt4H0Onhx8OHe5RURraLTX/dTUk21YW5dip6FzZGLfT63q1dVbmSiEEl+CZiXn0R1tsLWJ4CCe18E7IzXAyfT78X1A30qL+usf3t6dfbTt2a0WcAv0ncink1kNsc9AbduEajPAtXHux4HPBG4geHFvBuQ0nnFu18Tk46PGMLIo11nf9TknnE0PGNKETJByIppkjNvye/MEJu8/+bwzgjN1fy/DW58ggtEChgAqf3HL66+vjMI51nJfmdx/v0WftBoqW1a19sal2rLyNNSqsEMPqBHVSGtr+X0ts5Nq5nPwfaleidM3raHvzMnuzPtkTOVxbFn22rX5fylFziTTK6P45Gvt5BbVK2syq8gSk7Zrbd/PLaHy85rI1cGXBsp28KVBHhkH/qIECHhneNCJ9HMS0o8SaoDIVmEJUAJF/XPN7vMNV6re+EaTrwmeJMEbgO9Lm+gB8KkT3e7pcfguSgDALy/PP18ij9bEpjEzadDanNkGKTUyGCbQReBl7Dv96sOZgdqHGZdK+V07gpeLyZ1/dTFssMHodZqrdk3tXj5tVa43cT1giBXvi4TH/CFNoSQjKxfVtnhfRmJy8Rsx8+sgt93e7Z7ZNgIAXpqaPibo96zqTpuAR9AmyxWSMDL0o6kMfLOYmQleUwsqS0s/gIixv3WpG3r9o9u7s5/eKK5N5S8v7pt+2Hj9rE1WoDl4HXolPZKAtJechMHvfuqp7cD1Us4/Bs5TJ7vd325E5bFtUwQAnNl34DNW/SdSaExENC0gWUFbq1lAHu6Q2szni57xsw6KPr9mOyd+8803lzeDZ9MEnIaO3z/91UL5UJseCOGcFi0YDLaeVOUz7xmO+SOELu/vnHX+thNzcz/fLJ5NEwDw3enpvSD/YbweT+BNBN/+64zGgKXu/z6+vPA5CaNFrtkWxNhTzUrPRtslEQDwrSNHDpl+/1tGeY9RMDn4XAxh4JEyOG1b7SWTb3sRMqJdUKN3nDo/+5+XiuOSCQB45sorD3d8+VVBbhqEwzoJzTYkgFnusMm24L3e+YHZ2e9c/NbRbUsEADy7f//+ojBfVuTkVvvaRHsD5K6NxvpxbcsEALwEE92D038vyMPb0d/4Ji+q93edmp19bTt625b/CxyD3qnu7COi3A/Mb0efI9pjxeTkrdsFHrb5DxMnZ2Y+77y+F/hXxq/CfqTIRye87rOlu0bRxxkjAwI/xugdt3dnPnHb2bOr2znmbXGBtvbc9PQxb8xDoHcC1wLzCv9lkM+d6Ha/0lymPnvFFb9irf0D4NdBjyIsA99XlSd3d7tP3QLtfyB6u73dttT+B+ZbLf8QL8wsAAAAAElFTkSuQmCC","1f32b":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASjSURBVHic7ZnbbhxFEIa/qu7Z2HJwcBSEOFzwDIAUHgBxyQUSQuL9eANegITDLQEBElIkJCROQUqwgd2d7q7iomd2fVjHh/V6l2Q+adzrnvV09+/urr9rYGBgYGBgYGBgYGBgYOD5Q0678Yf7ze3J5C0vfhfRt8FfxXkJ4WXgFsIBLhm8deQXwX4W5ydTfajiD9J46+vbt+WvaxzLpTgiwP7+/h0Jo48c/xi4C4Qln/8Q4UucewS5t7u19eOSz7tyZgLs/zP+FHgPaFbY3m/u3EPlfjD5bGdn9J2I2ArbO8GjR/7CaHvy/q2b25/AUQH8OjvS8TfwAJHPcb4o7fj+3t7ek6tuxN23D/6dvov4hzgfADu7O9sC6xfgOFmQbwz7StFvUf/BU/p+d3f3z4s85PF4/EZ0fwfjHRe5C7wJjA5/Z1MFOAV/AvIrziNEfgd/fOSu86IIrwGvA69wbLCL+J8JcPX0AsR1d+Q8mDvujpnXz+aYG15vAuAIIo6giIKKIKoEFVT11Hi/gQI42RwrRjHHSuF8U9NxB8egQAH6nwAqSoxKDIqqzupnArRtJsaA6qneaCWYO2ZGKV1pq4mK5kabjDbV2dEzFyBn2pxREUIIxCBoCKdbxUvg7hQzzJxSDDM753/3ajGft3piCZg7ljMpAyREpVtHAUUQ6RQUEDkmjzteC9ytW7PUgbofaXhTOHMPcKtrEq7VsF0bZwvgTi4Fs0Kxbgfu7ikgAiJKCErQenF8ZmwwJwRwoG2nTNtMyply7l24IiIEVZomEkOgibU8sVw2hPkmmBKTacukbfEl1mo/Y3KZhyARYRQjTdMwaiJNDDzlJL5yDo9uJsDj/YPVNejONCWmKQF16E0TaXpRQkRWHH4dSCkxbVsm0zSrX4sRcqBNmTZlGE9qR2KgCVWUURMJYdlUBBQrpFRIuQ682MmZvTFOMOdCzoXxdArUWVL9SL1ElSCCBl349/0mXYrNBm5+duTaGAGO43BiL1kFi+V8jhgEWHcH1s0zI8Blg+jGboI9QZUYAqG7omp3QFNkQaLD3LqESWfIcunKvPAwtlECxKDEGImhusUY45Gz+3lQUQj1hUYTI9yo9b1DnaaW6TTP2+w/3NnbI6VEm1ralBaahqtCBGKoZ4QYu8Gu+LwgItV5xsjN7Xn9TICgQrgxYutGTaj2Uyd106eeCC92JFadnxBDUJoYCKEhhNNzdNfNqUsgxkCMga1DdTWp0Sc7DBwO53RU+gRkV27KKJ/ChfYAESEI1EW2vFffBJ6ZMHhZBgHW3YF1c+YeYO6UUsjF8M5kFGpZw1bd6QTQzqCoKBqUoGHjN8IjAszNQiLlTM4XD33H0c7JHY754YrfNyzDTIAn+we0OS+VD1yEmdGa0aZ5Gqo3Qk2MNRMUY7W21zBdSjGmqZ39PhNgeqiDq8YdUq5Z5x6BaoNjpOktcQzIknPF3UmlkNrEpE3kko/c35izgDMXZdzVVd+haFRi5yirwdKF7zCt9G+jjGyFlAvljIzSxgiwCHcne4G20J799Uvx3IfBQYB1d2DdDAKsuwPrZhBg3R1YN4MA6+7AwMB6+Q/VNE2S6PQiEAAAAABJRU5ErkJggg==","1f34f":"data:image/png;base64,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","1f350":"data:image/png;base64,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","1f349":"data:image/png;base64,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","26c4":"data:image/png;base64,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","1f34a":"data:image/png;base64,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","1f34c":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAqhSURBVHic7ZtrcFVXFcd/a99zz715AKERGkpNWlorLVCltQToQ2mhVaqi04dvq6Oodcb6GMfpTC0+Ouo4zviqOtqpzmjVGWnHEUoZaYJordCWythSfFFoiDxCgEByk5B77zl7+SEG7vOcfQPEWvv/dM/ea639X+vssx9r7wsv4/8bMl7F3h2rGxvq6+8VkaXpVLJJRAKUJ/HkDpm29J+nk+SZxLgCkNm5dg5G/igwtb4+jRRaEd2LF8yR5uUDp4njGYWpVeHY39eer0b+pKpTU+lksfMAKueS9z54mvidcdQUANXVCePxK1SnGDF4iUQVSXnbaeA2IagpAJld6fcBVwAkk9WcB2CB6hdr7l3/DTiTVFUB7hp7TiQiVes5cPUrT4HXhME5AIM7114NXHhC0cSoJvSicbOaQLh3U5G3n/wp5YNfKSyvGi+piYRzAKzw+hNKsd4DohfGC/334RQA3bk+JXDp2LO4he2l0wMG1c4CTg776rR+eun0AGvCtsJndbN9vurqyLnyxQCnABhlUnGJUwhSHJj6op8J3MYAkYaiZ8cugLCwZkYTDMdZoNhla62bmmh7rYQmGk4BECFTWqbWpRvISyMAYYUAhE4BYJ72bmqsldREwikAiSCxt7QstKGTKja3pFZSEwmnADQmG14Aij78MHQcBzBvqZXURMJtDDh/yYhAUS8IQ4u6TQdveTGvB9y3w7CttCxw6wUt9Ex9Yy2kJhKes6TqU0hxpiefy5P0nF7uB4FHykzuWO1zVtMKhBtALgWagRywF3QrYh5m+nVPiIjryqNmOCdFM8+vvVZhY2l5fV0qLjkCkMMzs+QV1+0DUN3k0RN+BNEvANOjGcqfsfoFmbGsLICnA86fQKN6fwIGS8tHcjmXpaFPaD8JoPs7WjkYPI7o94lzHkD1coR12tPxuB7snOXK1xU1pcUHnn94DehbS8tTfhLfj/2aMgThCjzzINCE9Pdijx0HQBt8ZGoz4tXF2OhHdaXMuP7BWnhHocYArFkJcl+lunTajxwPwjBLwgwPE3QmNL85peRXm0RyM0oGaEbMRZgLbsRcMZnEZWmomnIGkVVy9tJ7auFeDc6DoPb+9kLyZnAkCEJVTaCDEGYIbQo1UxgZyWF9Dz/pIQUZI2uVfP4YfuIpGHmkPhjowY4MYFJN2xOvPfKd4laeRV/YtRCv8y7MkjeTaKfiO1L9svZ0pqVl6V3llbUhsgfo/o6LET6BcDMw7WRFlrB/NTazHg370EQrYXoJYfpGxKQwxiAy6ry1OeqTP8Hk/07Q143aYLTh1KT7/fn9K6u23TV3MebiB/BvnQVN1cQ+Ly3LvlKz1wWoGADduT7FpOTXgDsozAQBGh4l6LkTzXeV65lpBJM/h/VOZsNS5lGS0klwaPcJ5wFMqmFLcn5mcRQ53XlhivTM7+G968PIBRVFUH3HqYwJZQHQ/Q/XY9JrgesqtZfv+Sw68lyERZ/85FXY5FyEQRqS38AO/ItwqK9YzEv1+a873uxCUvcs+ATeiu+QWFDphWUwerlMv36ni61SlE+DJn0/FZ0HO/RYtPMAmsPLfANsH0mzDSEPqnjNbfgts/FbZuOd1QrKFN08+SwXktL21L0Ev7yVcGOlHdgkQvnxeE+iipS0p2MF8K5qwnawA+CZOKNi+0kOP4RntgOQmDID4zeMppPFYFKNJJvbEnayf5srUWnb8RDB+hsINubLK7mansW3u9oqRGnU7qwuqmh2Z2dqoX2twHdjDWc7MNpdXSDhYRpbljryBEDant1I+Mhy7KagvFJWac+Ghgpq0TzHfuj+jouheg5P8/uweuxRgCT2bkT6Iy1rHjt8LLp14U3adelltRCWtu2d5NavIHyydCc2HZGP1WILCntAQm+JlAyPQjjap2UhA1j9dpxxO3RUYzLIAvoD1dpOqeW8v6wn+PUK7I7iMUHlA7XYgcIAWLk0Qg61WQzBiaHcN/ZeKuwNinVyYoejOwqi7XTP+awL2SK1tm3rCH51I/ZvhUGYq/s21HQqfTIAwpxo0Tx45E6It3NE4EdxDYSZXtC4vIF8Vbvn3BBnq0yrdcsGggcWEa4/BNn/lCbra7FR2PVmRDaWaETtyQAA5AP7TWAkSk9tQDh4OI5HApWHtHveNXGCZbxat27lwGMzyf3o3djffVJmXvuPmvRPEO3pyABVM7ia7yLYv/IKv52nC8tHnjDfF/h4XDPJabMQLxXHZwh4p7Q9ty5O8HTBVPldBklMxYbeK0rLU9berRDzipXg6F6HT4EGYK3umfMl1Te4Z6tOAYVOR49WZgrGbz2vtFgW02eEu+Ma0iBL0L/fhZOArKL7yFPaPecKF4VTQWEA9sQJS90lsyuVJxfY+0D+HKdvjw8QDh5ypKbzUXlC98x7UP81b56jUs0oCIB2xQmL11JxphDBiglvB8qXqSUIM4dcBsUCfnozVp/RPXP/oHvmvF93XT7FVdmxgTFI7BrfeC2vrlbnL2ArwuddGg0zvTX0hFFywDUgP8XLHtbuuZu0a97d2jVvuXZdHDl7uRgGQA92LkJ1c5Sw5nbnTOtHqw7lqkjuSfkNSFnesBJMuhGvaSbIKZ+bHAe6EQ6gBKBDo0a1DqQJOAiyD7T1r9tThzds9Fd+5ltbjkNhSmx609McPDrE6EhcEeK3JXXbLdPksgcrvj4RVB/TD+d82QacG8fajgySP9yFN+UcxI/Lh0aiDng1yn966Nh7LUwfjC7JL7rgiG59YnoI3AYFn4DI6/IoG6LbSQiNrTdFScg1HMLa5cBRF+YaZMkfeYFg4ACo04HrOKGE/QdD29/NlfN3XTJWWjz3G/15rBmvaUWcTGox20Xtm4jZKxTCDh0ld3An4UAPGpbvdk8FNjtEvndXPhw+kgC6z205cvNYXXEABoL1QB8REP88p3s//iKeVMxNjH6fblBLONRH/tDzBMf2YbODOF/JqmDLDh8lf3i3Dfr2oGEuCQxj7Rvrrjw55ZfnBHs6vkZUYkQ0T65xirxysZNjuS20I2aNwtnjcANMAuPXIV494tchnoeYZPFlRVU0zKFhHs0fR7ND2OC4Yovv84nKSn9ReH9RWWl7urezGU+7iNgXhNnnbvHaPv2Qqw/Ht3CeEbMO4nacNWAsAPHL6zHck1poV5UWlq3/5dylR1B+GGUpkZz9GtdWAeoW0eUHdpGO2j09J71qXZ0fFpHbKjkP1TZAfv4eYF9VkyYZmc+vBLmKTHqRvd2IfT0wrhR2rVDkMRU7328Pf1ZNpmIApHn5AMIdEaYX6Y7V/nhIJdv5o2/taxQ+BRwYjw0HPIPKTan28A3pdiL/wBV9NNbT8XPgPZU1zZVy9nWRK8c46GbqsgnzIVH5AOjlp2ILyCP6W7Xm/tTC8GERt08tOgAvbEpTF/weKL/vp3qnzLj+6+OiWgHZzczGmFsFvUpH7xdOdlDrATaJyqasDddMupLeWtuNPR7XQ4+eQyiPA+eXVK2RlmVn5M9Rqpjs07xKQ+8cg85U1bOMyAiACoOi4e5syO7xOFwKp/sB2rupBQ3XoUXd9G/SsuySqkr/I3C7Jjd9SQ8mvQT4BSenMadzvRc7nA8kZNpVGWlZ9l6UaxG2gT57Jom9jJcxMfg3TKX3be38FeYAAAAASUVORK5CYII=","1f34b":"data:image/png;base64,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","1f353":"data:image/png;base64,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","1f347":"data:image/png;base64,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","1f352":"data:image/png;base64,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","1f96d":baseURL+"1f96d.png","1f351":"data:image/png;base64,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","1f348":"data:image/png;base64,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","1f34d":"data:image/png;base64,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","1f965":baseURL+"1f965.png","1f346":"data:image/png;base64,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","1f951":baseURL+"1f951.png","1f95d":baseURL+"1f95d.png","1f345":"data:image/png;base64,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","1f966":baseURL+"1f966.png","1f96c":baseURL+"1f96c.png","1f33d":"data:image/png;base64,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","1f336":"data:image/png;base64,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","1f955":baseURL+"1f955.png","1f952":baseURL+"1f952.png","1f35e":"data:image/png;base64,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","1f954":baseURL+"1f954.png","1f360":"data:image/png;base64,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","1f956":baseURL+"1f956.png","1f950":baseURL+"1f950.png","1f968":baseURL+"1f968.png","1f96f":baseURL+"1f96f.png","1f9c0":"data:image/png;base64,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","1f95a":baseURL+"1f95a.png","1f373":baseURL+"1f373.png","1f357":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAyOSURBVHic7Vp7rF5Vlf+ttff5vnvbyy2UAg5THwEMYAXNqHSiVaeiCWKMDwJRiREThBI1ZpzxEaNJUaKOUZmJM+MLFcSoKT4xYKqlLSBYWqG8iiBoMW2hcNvbe3uf3zl7r+Uf+zz2Od+9t8Xe75bJsJqdc3ru+b5v/377t9Zea50DPGf/v40O98a7t9x2dsu0/s1Y+0ZmPomIniTwLUL81TPOOuv+Xk6yl3ZYBGy/89YP2qR1tU2ShNmAmEFEYQAC0itPPfPsz/Z6sr2wQxJwz22b3mXarR8mSYuMtWBmEDOYuflVnznljJdc1aN59szmJOCuDRuOb/UnD9tWe1nSaoGZwcbk4AkUfVoVTpX+6dQzz3ygx3OeV2suY81M21xKzMuYGSCKVr4AT+UgggXLRxdgzvNqsxKw7daN5xPRxwrwEAVUAaC28rVzpbf2bKY9si4X+P3GjSsTqzca2zrRWgtjLdiYMugxM4y1iFWgqgACOdbp8c9fsWJ4QVEcgdn4P1s3bTqPjdzExrKxBlyAZwbnLkAARATMDFVCARwIAum0ncX/ISsn++jNNw+OGv0FEbMxBmwMTAE+H0RNwWjz/77TsSO9n/b8WUnAyED7GwS0iRnEBsxB9pzLPoCPIr824Sugev+KFS9NF3D+R2xlECTw+QDAVF9xmgk8KI8eWg5VhajfucDzP2KLCMBguEKV1EOmV5xWd+ZHUYH3vhpO3vzwffedviAznycrCVBVAggECmgL8DW/D+dhRwBUFOJ9NUT6XTZ93Y4dO1oLC+Pvt0oBjDSW9OGYeA/vHJzL4LIMWdqBy9KVU/uf/q8ezXferSRAgIeAPNfRcKLlhcLCuaqGLW9qGlnaQdZJA/g0hcsyALrm7ttu+cD333HqiQuG5O+0kgAmfwWINICTkNyo5kkOymOhkKwzjbQzhSxN4bIU0weG4L0vv1iA/+5Pknt/ctFpz+rssCTgFavetIVUP60qKiL5KufRXQRAtfIuyzB+8GDtiw48uA2Pfu9zSEf3AwDSfXtahOwfjKWf/+q9p//Hpkte1LeAuA7bulLhrXdufH2i9ltJu32asZaLLVFVO+rlYa/+21NjU7eruutAeHnxuae3/AZP/uZ69C0ZxD++5VLI5AGM/O7HMJZhLcMY2sWWr7GEWxLih1779QcOLCzUmW3OcvieO+54obGW7cDk0IoVq8fjv923fv3itK/1IyJ9KwDs334b9tx0DZKWgW0ZtAeWgLJx2IRzEghsGIYJHMZTRPQoG9pFjCcIvIsMniDlPQzZ/Ze/nLLnohtu8DPPbP7ssFtiM9m6devMKc9b9h0A7xv768N4/AdfCAQkYdXjo7EUwBsuCCgHMRU7b5x7dAA8SsAjXul+ALdOtBfftXrt5ukjBR3bEREAhPxhy/ob/2f0j3+4Yu/6aysCGiQYm6++6VICiENugTwTmWlWISijo4rfQ3H9eN/UutVrd4x33/nM7IgJWHchzL4nTtqQtM2/JC2DVtvkwOtEBAUw2BCMyYlgBnOVWJUkEIUWUycF51VpTgDC5qRQ1XEVukGc//I/f2X7Q0eNAAD431UvOC5puTuTljmj1TYl+CR2AcMlcGM4JyBXACF3g6re6IyOYXp0FOoFg8tPBic2z0tCBhpqD0BFvTj9ftrRT7zua9uHjgoBAPDN1ctXttt0R6ttjE1MAB+NgoACvDGx/0dElCoIYKdHxkAEtI89Jl/9ioDiXMLY552uec1Xt//0qBAAANe++fnfTVrm/QF8RUKScPB7Q2ACWB1sf18IiJTHAA6ld6GG2UxVoYI8P2mQ4FXFyX/u3v3ijx3uDjJnU/QZm6PvzFROVDmkwh88gHR0GJ2hXK35qhc91hh8oYjYNUq1NN0nBFgiS/968vLH1t384dPahzPleSWgM3zCVlVNQ7zSqK4osBLsscej78TnIRlcAorrDKJa4Vn0IKIrFRGELhKYKnKY8c4BXvSzP1z2iuRQc55XAi6/++5MBX+uInblq9CohaQE09dulNqVNbvOZY4QrpT9ijKGlAOFEmAMnz/Z769bu3ZujPPrAgBE5Y+qqPxTqxoi8KBo8jGbNfmJiYhdYsbBBCJ99+r9L7tyrt+YdwK8p8eawamLCC0Sm6jinJMRmtElgLpCysHIe5kEInxq4xUvfcts3zzvBEBlj1RbUx61o21LtUFE/jFEHqL149ToGIYe2YmpA6Ml6K5jcV78KxIsBrPFtevXnD1jb2LeCXCZ3yNe462pIiNSRt0tUMvycvjld/YvGcDiE5ZiYl/zeUvVn6RCJaUSqryCwMus8VcvDAEqe7wX+Ah4QUKlhpwEidURBUx0q6D/2EG0Bwcav9btM7WwUUoEIPB71l9+5uua988/AbC7xSvESwnc5yTUSKm5SJ0QkXoXqlDKwInLam5zKMuLyzLPsMSfb94z7wQMY89e70S8CyrwORnh2E2ASHdM6CZhJsQaEaHodpyGEaCg1/z6shWr4svzTsDazXDOy1POKWYloekevooRc+8gM7uKKpCOT2Di6X3IJibmnB+LXt5TAgDAZ/KYd4Jy5CR4L3BeIBK5R+aQTk7ATXdqJEgcI0RnlH1MBlsLYsbUvv3wWRb+HimjOFHgnesuXN7fUwKc0z85J3BO4LOICCfwTuFdsfoCUYJMTaGzfwjp6EgEHDO6S811otjBSYK+pcehb+lSqPgoA+3aWRb1L160uqcEeO8fcZmHywIJ4ag5+PyaK3YKQBctATEjGx+HZDIL2OAqzWBZT7AUdtFicNKug49zDlVA6fXFXHvyLN91ZHsoTHyUkFSFTJmx5fcbMKi1CJgeh/MehhG6RQC0UQs00+MSKCIyCoLi4Fo+1AGgVTe7JwR0uLWF0swxkQ11fkFEs7CJzCRg24IoAU6hRqCaV3ocxEsUCKkzgPIJVhk8NYohUZwodhyInlp8vCcusHbH0Hgn9fdkWZB/lgmyVOBSH7lE9TfnBF4NfN8gQhIVB1DJY4aUu4abnEI6PgHJXBQ4o5jRyD4lVoUAXnFCMdeevc7iOm5jyjgnlm7R9o4tzv+tDe8bqal8lkShTCAhEClABHEe6egIOgS0lx4Psu1SAQXYIkiKoCugqmjZLOkdAam/npg+WeXkjRviVLf0XYaxgFGCchjEBBHNKzsCSEFJH8wxg/AHR5EdHINdknQFw4qARjoeRqfnBHxhb/rQJ0/GXSBamReuNfC1voACqlT2+lTyrrEhsFQk1Nrnth9kJ6Eacoxm2zxWQpmC+zwtF93bcwIAIJ3S7wFuZXXFBPxx1C4DFQc/1gDWCIM9le3zsJNoXvVp4DPpBxASLETRPm6alglXlIl6wc4FIWD4QHbdcWw/DWA5gNqKI5arKqwAasPqiyGI0dA1jkjg8vkBEBqDuSu74Ee1tDny+RJ4WaRhS31JemT3Au6VJBNA/AZpqMziPkAtHqAuZcRBTVFG+xDdZ8kWy1VHJH8pSXBOr/z5n0YeB3qsAABYNolrhuDep9BXVwpQiJoylS0mbj1DPMNaLZ8jSPQApVLAzIG1XjjVvztyhb3t/r/eXnympwoAgM2AruzDnT7TSxRoxatdLnhjSK4KKZKY2oojT3TQXV77xhCtCrHi3MnXLr7x4IYFIwAAtqbYd04bO8XrBSpKNeAzklBEcZTAC/nHDRQRQLsivNQI8aIQV4KfRMde/MvHR8qnygtCAABsS/HgOQkyUT1XJPdzqUsWUdqqEdhydaMUt+b/vjiXSAl51K/Awzm96tLNu26K57VgBADAtgy3n9NCvypWOSe1DlABFI1rtTTXR6vqpWuPlxyoj5sxVU/iwRbal/zy8RF31AjISdjwqhY6BJwrXknyJEa6pF/IPt7SqpWuOk3FaodRRPpi388JGHMpzltzx+4nm/NZcAJyEn63soU/AzhPVRPnZNYGSNEN6mqjRVtbBbqQu0JyJTivqc/c2z+ybeiumeYyr4/Hn6l9eDFe5oEbCHgxEFLc+ntFDGvC2yXl43Xm2ms1ZWrcsDyWjKnoBf9+7/BvZ5vDUVFAYVszPLUqwzWuhTYBKwFw3D7XyNfr0q6kLvm1IuhF8t8hGZ338QeGt8w1h6OqgNg+OIAVClxFircB1XvaxuQvWJnoDbMyNY5esEKRGNE0VL80MD3+xY/uxtShfvdZQ0BhH1qMs6BYo4SLASwprhfAixetqEEAEfYR9NqMzNVf2jX5xOH+3rOOgMIuA5LWAF4rwBtY8XINceIkAIuJMEZMw8TYSWS2WsLmY4bdprWAO8TXPmfPWcP+BuJFXjvOPrdIAAAAAElFTkSuQmCC","1f95e":baseURL+"1f95e.png","1f356":"data:image/png;base64,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","1f953":baseURL+"1f953.png","1f32d":"data:image/png;base64,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","1f969":baseURL+"1f969.png","1f96a":baseURL+"1f96a.png","1f959":baseURL+"1f959.png","1f35f":"data:image/png;base64,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","1f355":"data:image/png;base64,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","1f32e":"data:image/png;base64,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","1f32f":"data:image/png;base64,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","1f96b":baseURL+"1f96b.png","1f958":baseURL+"1f958.png","1f35d":"data:image/png;base64,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","1f957":baseURL+"1f957.png","1f371":"data:image/png;base64,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","1f35c":"data:image/png;base64,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","1f35b":"data:image/png;base64,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","1f363":"data:image/png;base64,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","1f364":"data:image/png;base64,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","1f358":"data:image/png;base64,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","1f365":"data:image/png;base64,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","1f372":"data:image/png;base64,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","1f35a":"data:image/png;base64,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","1f960":baseURL+"1f960.png","1f359":"data:image/png;base64,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","1f362":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAA2ZSURBVHic7Vp9sF5Fef89u+e89yOXm5CbcBOTIglJiKl85cuSAk1CIjAxaYrGGSBi29CYCKSmDOK0pc04jjPOdAAZW/RSUTFOaVE+kiIDlqhAbalKGUDzBSgoBYSMUAn3vmf3eZ7+sXs+3ve+uclNcu91rM+d5+6e3T3n7O+3z+4+z54X+K38/xaqXly68dpJaZvdYBKznMjMtdb0EFEHEb0JMiDCGwAOqOIFAC+qygsA9uiAf/IfP/vpV8cEwTFKQcDl11wz3aD9BzYxvcZYGGNAxoCIQgqAKDRXAFCF5ioCEXlZmJ9klsfh+eF2/6vH+/r63NjAOnIpCFh/9dYbrU232iQpwJsqARE8EUFVCwKkJAAqAmYGew9m/5b3/rvq/dfryL6x4/bbfzVmKIcQU2btsgJwRU2VCDIAQko5SXm7pvaGTJchswpkvmTZvrL60g9/9aL3X3rGmCE9hBQEGGtnUoWAYgqYHDSBCBWl0jqq06Uoo1KJOsnQejLmv1es/cDfjiHeQVIQQIRxTQgrZg+UJFDDdKheV+8jIhR/RRkMwWxbsWbd1aMN9FBSEgAwhTR2HhVwVJDQqMW9FdBlKREBhOIZiFYE0s+sWL3u5JGHd3gp1wDCgZBWRrNB8ilAg6ub2tKgewdJpxrZMPzuHn8pCFDVAzGDhrQQRVj8dXB1U1sddO9gIdDvDb+7x1+SMkuvK8Ier6pFCoQBViUQNaBuyBU+QaU0bJf5c/KtM6+l9hHCNCwpLUDwfBziWKBNo507PlUrKJ2homHVQcr/tLw3J46ge0cJ45BS8QP4RypS9eygUavgq1Mhb1toQ5mWqnkqBVkTu2v3/uctl3ePBeiqFFOAlZ8hCft5g6cnUtkZFIoWnmA1jeSJSgQcyBENpADASV2Wt5zbcT+g+N6tfwIR+QWzPCaeH3FO7nrv9Xf+z2gRUCzXV2zaOk1T+3ObWBibBM9ueLFA0NIVBnsP7z28c/Aug3MOUMGm88Zj5qQEKoCIgEXAPrjR3rFznu+QLLvhor+6++WRJqCYAnd8/qaXRPgl4QCiOgU0XldBNlxXwTNDpFofrzk869zZnZg7rQO1Woq0lgRNE6SpRZIkSFKbpondYNLa09/81PtXjxoBAKDiH2PmCLAFyKKuBQnV+7hyXSmfObmGdQtPRBqAIk1tBN9Igk0sbGJ6TGrv2fnJS64cNQLY8yPCufnmpnwIwHmZ90W7nDwWLq5zPXGcwVUrT0J7ewSfWCRpkyYWSWJCai2stdYm5vP3bVuzZlQIEOcfDeEsBxKKeewCyEMpV9NIApf13W3AtRdNwYSuNI66RZImJWBr4qhHtQbGGlhDMMZYMsmX7tu25h0jTsBdX+57hpl/Vu18Vb138N6DY+q9g6+Cj8C9c0VZR6LYenEvpk6sBcA5+Dji1gbA1piQ5uAtwdgYWhua6L1+asQJAKDeZTtag8/zJQmD27kGa6kZwZ+/dxKm97TBJhXAiUGSmIbRNpZgTKlE+Q6Ul5kPbf/4xdNHmgCoz+7zLh/hOMquOuoe7AaTE7Y6B3aBhBQeW1b04JTJ7TBxdI3JTTv4G+UoV0PmHHgeYSIPsZPUmMtHnICXTuj8jnPugHcZgjp4nxUAfQSY511WaRc1BeOjy3vwzkltFRAhpjAmgq6G2eV5Qal59IkYYgcX5LwRJ+CHfX3OZ9mXfebgsuDA+MzBuQw+C+qyDM5lBfiinXNISfCR88fjlJ4U1YCpyOZudHN5Y7a1EM7RppPsY5VBBAAAg2713kkOzlVIcC4HnRXenXcZmBltFtiw5AScPDEt4qoyDlCIRFeZK2WV+oKcahpjjxhyTvyna5f2jDgBu+795+cUdH/oNJc7QMXM870/BEtAewr88aIOTB9vghcZgeWgmaWScplniW1KLQIobSJKASem7XgSkByqgoy5HsIrAHQc7iHj24F1707R24UCBLPAGAJzeZymqsWxmSoaSeDSwWKR0loqRIgo1KMdAN7+2cPTiMxKVfRCuJ+Zn+ya8R+PEW2T4RAw5HxauWbdGiW9cygSpncpVs0hTOhMmvz74OYm1a3OUENAFb4jKIQZ3gu8Zzjn4TKPLPNwLqRZ3SGrO9TrDgtX/eHcGe+a/5dKsh6qRoWhylBhgP1zItn1J5y65htHSkDLKZDLt3bctUNEzgXwVHOdJby5pDfD+2ZkaDcxostdX8/gCKhBXVTP8M7Du9DW55Ggz73QYBFV62AWKNFrp56+eBclyRXGpoZMArIJyCQgYwFjTwXZr/9y372fVdUjWiwPOQVy2bXz7ie2bdt29qNP/OgCgi5RUmOBH1wy7X97O9vMbcIJ2AusFbARGC8g4vJgNC5oRjR+IwAAqpw3hOlSEhXzHIhgLgnpmXbyRJjEUjxegzGAUjAnUigJiCwMuS2/3Psv/QA+cTh8R72lfPGjSy+3abK9VktRa0tQq5VRXRnY2MYpUHw3KHcHFoWwBMCRBBctpWEKZB5nrViNeUuWxu0lP4FiqHgIOyg7CDuwr0PcgHo3sGzyGVd8dygch7WAQ4mA+uEFbBjelJ/GqkfiqoCownJJQMUwioUtHIhwkyWUUyYEWIKZZywMn+co7AgkAsBAyYDIQHPnKryCiPBpAL8/FI4h14ChRMk8o6pFZ53L1cN5houLWJk6ZFkYyTCqMc1cbBPu9ZXRdy53xxm9p8xGZ/eJ0VU2IJjiewQ1GbLm/1WXvPT9fzhtRAjY+PcP7wPwCrOUi5uLQLJK2gy4nhPhSvBVddV8JNUL5l+4tvSTUUkHIW88mU4M/mAoHEc9BeKrHiHgg95zvI7eW9zDk8SCOUZ6TVOk+JaQ7/eiYQ3ICfU+rgUes856D076nRnxDYMQl0fvyE+ec2Uo0YyRI8DgdhJ8EAC854J1EYEVC2GpxvRlYITyW0PVcZIWa0BHVzcWXXxJ/nWm8vLoOiMsiLmqCKAcF0mGAkP+SOOopwAAbPzctx+E4t/za2YpzT06LlUnpqpZ3aE+0HQdV3uXhbXAWIvll12Jzu4JwawDZzGvUEjIS3n8ruqjq+2Dc6R4figMx2QBAEAJrlLBf0FRA4L5O/Fgzk934o8m4uFGVYopoFo4O8zRkyXCkrWXoXfmnNLwY1Sk+WiroOoJqngo+5CKD2OSJP82ZP+PlQAAuG3zso1E+ELLFxAafklSvDGP9HIfv2LeNklx3gfWY+aZi5q6qE2AGcJZUJ+B/QDYDUDcALx7GwBtn7Jg04eG6vsxTYFc/uzWb/cBdB1ahPSqKOZ24wofXWGWBvAdXd24aMPVmHHG/DjiAkAKhyek4VrEBVPn0hEKzlAGAK8kVkfOE2wlX7xq+R+p6m0Ahh2zG2Nw2qIlOHP5hWjv7ALINDlVWpq9MoR9ATaMfh3iBoIV+IG3ycjK3rOv+t7h3ntcCQCAL2xcOskm5q8B3QCg63Dt07Y2nDx3Huadcz4mTJkKoiROleIwLC5+FdeXPVQchH0koB5M39fhXX8/oO+bsmDzriPp73EnIJft11zcXZf6Bap6HhSLQZiMsOh6MvTTd86be/rUGbOmTp8zF2mtI0Z1FkQ2RHaorhdabHGqPox+9P/F1wMBgYS6sFwyddGmbx5pP0eMgKHkwDNf+6RJajeYpAZjazA2DeBNEn39VuYf576UwU8x+r4O5voA2K/tXbD5weH0ZdQJ+Pnjn+tp7+x+wdjauEBAGgmogi/9/OKHGsrFtieVuS+cQdyAY5a1wxn5XI7ZDxiu2MSuVvHjlAyUDSSOAanGKWCgTVsfirA3B++hnIXQNzuIg3t2sH/9ubeOpj/HZRscjhDoHGEPEQ+RuG15F0bTV0aVMwjXiwUuaH9c7MJq77K3cHD3TrjXn2sX4IHdN81aOtz+jDoBCu0J25grTblwZupgHxwZKUAPFA5OnveuH971o3/P/XAHngUAENBpiP51382zzx9Of0bfAlTfABAWMl8CzxeznIQSdH+hPqYqnuvPf+fH7vX9zY8fp8DOfTfPfs+R9mfUCQDM03lOlcMKXoDPQTebfT/YDxT+PQjr33xh72JVtDru6lbCg3tvnLP4iHpznFAdsQjoHgBcLQtTIotEDIB9ACxcD66uFkf9TMCHp8zffOeZ1z11sO47VoHw6KCXKMbD6kN7b56z6HD9GXUC3rHwIy8C+MpR3CpE9Ke9CzZ/LS8487qnDib9vBrA44NaK8YD+tCeG09bONRDx2AKAN7zx4Gh4/QmYYVe2Tt/0x3NFad+4vk3kwG+EMD3W9w3wRh9aP9Ns+Yf6sFj4gkCwGtP9s1h5gcAzDxM07cAumzKgk07h2r0k5tOmZBR8i2AWo34ayL2gnf9xZ6nmyvGxAIAYPJZG/d5z4sB6gPgW7VR6N0GcvbhwAPAjK0/faOmfiWBftjqdcbww/tvnPW7zRVjZgFVefmJWyZD01VEOA0KIeBFVvNAXC+GJXv/bs4kpLILSqe3qP6FMbps9pZnf5wX/FoQcLxl/y2zJqvQLgXe3aL6VVIsm7N1/25gDKfASMrsLc++lsCvALC7RXWvEu7KL34jCQCAmR/7yausyQUAWv0sv/jc/xtLAADM27r7ZbVmOQENPjMRbijyo9+t0Zf9t8yaLoJ7AOpR6N/M/diz28e6T7+VXxf5P6Djt87BLZmeAAAAAElFTkSuQmCC","1f367":"data:image/png;base64,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","1f361":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAnHSURBVHic7ZtrjF1VFcd/a597Zzodaqelqa01SqEtJShVoKUaK5RCojwkBqhFjbEmgEI1VixENPHGEDFpoYg0CPH1QYKKD4IoCMXWBJBaMGDU0kILFGrte0o7nc49e+/lh/O8594Z5namc5vKSlbO3uvsfe7+//c6+7XOhbfl/1skSbx057R3eG9uVbRDS8Gy05a8uCdf8EDlR+8j0CtEgnNBp6rqZKDHe7/Lq65zzq62vYd+M2nFsp4RRzEESQnY+P1pd6FyPQDKCzi54NSvb9q9/zv3nBNIsFyMmSciiERVVDVV7z3ee6y1O52zyye277tDKhXbGkjNiUkSgnSQZWZJIE9037Lqx4Ep/dUEwbwgCGikxphUgyCYaEywfPuhrsf+c8OKCS1B1KSkBLgguBF4HkC0nXGHrjwj0PYvGGMkD3JwKvO98NRrX7p1XMuQDVJSAk5b8uIeXwouEDUvjO25lHb3XowxiEh6LWoedNEmYmb4dvmlXvmroJUA30pMPnPakhf3dO295rl2e1JDwEUFBrxvRC7c8s6Nn2sJskFKDQHbb7x9jvj2xXlbArQZyaoIinxzTaVSOuIWHmWpIUBhBbmZYeiiAKdM2cF5w/fM4ZWUgNeXfu/9qszLT2+J5qU/W20eYvBReWHB0Wn+0CV1Tat6eVl9DcD8PG+MqavciCzvPZp7TvQsOWvEEDUpKQHq9FxvskWN9x4RwXufFi6SEIHN6uTTeRvCMTsdpgQ476Yab/De4Fw2teVFVetWgnmwzrn4mtmiwnRwjEpKgPd+UgJCpH/wAy2FnXM4Z/HexWkX15bXRwxRk5Kfnnqcc+3ZPB4ZVZUgCOrm/yIBzlmszYBn4KFzenu3bvvJVYhMxaug+iZOt9DT9xc5/fqDI4i3TvIE7PXej488IAGZAPWImHQMEJECeIf3LibAYq1FOoQJc7sYc3on5XGlRcCiuHL0YKMwZlSoW+59DGdvkenXPTPC2IEaAvQZkGlJz2U97PHexAQI2TIhIUBjl49fAbWMndvJ+I+MxXQEUfH866QKKhCND2UILgYu1o0/vJ/DB66WWSO7nc4N67I6STnnCMMQay1hGL6FVuOyIT6wTLpiHBMWdEXgjUBg6tUImOSalJGraOt8Wp+/e0pLCDjcOfrXwM4kr6p1YKvVBHC17p4zlimfnUDntNFRjyfgRDIvSK4J+Hy5SM8gcL/TNT8dNeIEzFqxrEdElhcLxAcdKfBqtVattXg8ky8dT/vEtghkCjyv1KdN0S5gZDZdb9424gQAbJvo7wDW9Fe4vyXy+LM76TylPc7F44RQ0KJNCmUlGytErtFn7zxleCAOLDUEzK9ULE4XApsG+4CgwzB+TmeDOzJgtoaMmvsCSAnvbhhsG4YidQv8U++t7O6jbS7Io4N5wLgPdGDKRXRKshnKslpjSvOau19j4OLBwzhyqd/hAGfc/Y19M3bPvEREFgOb+60tMGZ6ey2IRsD6zWsGvA4/7xmJ16Dfgwp5YKEDframUvn5lB2cp8ICVXOmQU9U6ADZ2vnuoLvcKYtQBa85AjSe5+PRPun6xAN8obwv2Hxc0PspDNQBwyBDOvzQ9bcvoly+n3IAZQPlAEr5ub4wC0AGMFUP1kPoIIyvVReVE7lMZn/1oWHA2a8M7ahKZSreg5dInY/B5nrckOUTW54EpxEBTqP6LnktAK9HfZ/QcAwYvEiQNtr6GIDP0j5n60/z9RISEim7zQCVNecdtTPFob0C61Z+GeFOjGTuXyoueRP3j8cCJdf7ORJiVevZ4Q+y2Xb3bgh3b0Q4SZUu0Kr3ukdVn1anqw/0HbjvpsseOtBaAtav/DjKH4EIcB58UFgOp5UK7p8j4fW+bv4WbqdbDxe25PkDmGQH6ve40N6274Sdyyvz1x5xGG5oBPxr1Qn0VPcCZSACO9AgmJ/6cl5gQ8va3ld41b2ZRJbiLXmjnWdy2qRY67ChXdt7mIU3L3xg14gTAKDrVz6MFhYteQ+QBh6QvgaenvAwjx7azD76UvD5c4eoSjQoJsCTYzfnHDZ0WGs3GXXnLP3kg93Ntn+IgyDg/C0NbNFU1q9aqFrC0PJIz8vs8YnLF8NwCX+N7knkKZG3zKg67qtUKk3jGTIBMveGZ1Dub3gzGeisy9T5dKHzxMEt7Ha9NUDT5zYIw2X2xKnyZbioNPPZq5pt/9A9AGCUvRrhH81UebVvH5ure3OWfI9nAPu3x7Vym6gA+XazU+awECCzlvUQ6kXA+sGUV4UnD77W7710ixBvDDS3NqqvUJOcXto+Zm4zbR8eDwDkw1/bRs/+jwKrgHCgstuq+9lV7UFzra8PuWmBiNrpMFcqek5q9+c30+5hIwBA5lcOy5ylSxBmAnejNOzmDYd29qoq6utDa5nST7qgvvY5CGc20+ajssSU2Uu3ANcB6PqVJ+N1CkIXXg/Splv+vv+N35bKpTOTKS0axKJ5HpQGYcjcOkBr0mk+i2d2NdPWox63j8nYkrd99xeXTPXO443H+2h6i8BH+wBViY/gM8mA+1zaZTHIeGYRMe00ISP+4cI995xV3uV1nPce7zzOCCJJFMkAPg681BJQvxSOYhE+UZ+Qp1ubac+wjgGDkWuvfS4E+tJAis00W+HVBliLtnydhIhERHi5mfa05NMVgT2q+i6XnB+QjfDGmGR1V4hDEkWpXLYMTkipmT28/qmZtoy4B8TyNBD3psVZh7VRTDG0NlnfY8NY43SYpOM6idfk5L/2pTlPNtOQlniAR1cLcgUkg5vDxO+3MT4Oz9PYA5IdYbHnAZCVlUrFF39vIGmJB7hS531Aun1V1cgLkh4Pw7THwzDnCbE661BVTu7dz7zubbSpQ+CN0aWOHzTblpZ8xLj2gX9Xz798egByQfFefqTX3NY3/dwmlpN793PWgR2c4EImVw/pvrZRn//Kpx/+Z7NtadUYgJ18aAUDhOGg8RdpiUzpy85Lx9o+WbB7a2XDXTNPbLYdLSOgMn+tNSX/KZCNR1J/3dhJ7Cu3Z+wIs0zonti4YkZTH2m3jACAmxc+ssv2leYCf2i2blWC154fPfEy0GdTozCLQFc3Q0JLCQCoLH6w226a/QkR/QywYRBVtoPcZPt6Zn5x8Z9/36b2wqGQMOQzweGUSqVi2qat+5A3ZoGgH1RkLCIdqrpVhJcNPFrdOPup4lT3ysqTuqpSehzk7NSY+9PHQL95TBEwFDlSEo4bAuDISDiuCIDmSTjuCIDmSDguCYDBk3DcEgCDI6Hl64CjKVOXvtrtS6WPEf8bDojWCWVNAznHNQGQ/RuOPAlK6hHHPQFQQ8LjQDcq32p1m96WY0X+B/VwUetqnK5HAAAAAElFTkSuQmCC","1f967":baseURL+"1f967.png","1f366":"data:image/png;base64,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","1f370":"data:image/png;base64,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","1f382":"data:image/png;base64,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","1f96e":baseURL+"1f96e.png","1f36e":"data:image/png;base64,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","1f36d":"data:image/png;base64,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","1f37f":"data:image/png;base64,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","1f36c":"data:image/png;base64,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","1f368":"data:image/png;base64,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","1f9c2":baseURL+"1f9c2.png","1f95c":baseURL+"1f95c.png","1f36b":"data:image/png;base64,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","1f369":"data:image/png;base64,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","1f330":baseURL+"1f330.png","1f95f":baseURL+"1f95f.png","1f9c1":baseURL+"1f9c1.png","1f964":baseURL+"1f964.png","1f376":"data:image/png;base64,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","1f37c":"data:image/png;base64,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","1f354":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAABYiSURBVHic7Zt7kF3VdeZ/a+9zH/1Wt9SSkNQSCFlI6AWSMAg8RNiAgdiuzAQnLiaZqYynMnZcebkySWDipCeZhCqTymCcTFVScY3jxJlUMhNXYgowccXmYQx6QUsgGUm0hJ7dUrdarX7dx9l7zR/ncc+5t1vGBP8V76qj87inz97ft7+91tprb8GPyr/uIj/sCkYeu7ejEsgNxsh6jL4Pb1YgugLRZagsAW0HOlS1G5hR1ZqqoupHFT3nnT+j6FEXhnvrmL1bH35x4r1s33tOwIn/ed+1gZV7RNilIrcaYQMiRpKqJFutgiZXCqqoQkRAcnhUFe893ntQf8g5/49K/WsbfvOVAyLJF95deU8IOPWFezeLsT8rIh8TkQ0iQvZAYvgiuUrTlqtG1zngeRK8T87J4fDeH/Gh/2MNi1/ZNPjt6XfT9ndNwL4/3VHoryx+yFr7iyJmh4ggxmBEEDGtBMQ9P58AxBhMuYtweqIVuCrqGypoJsE5h6q/HIbu0Y6w/MR1g9+u/FAJ0MFBc6r3pf9sjP0tY8yAGMGIicEbxEQEFNq6sKUO6lMXIyKQBWuz5R7a1+1k6s2X8JXpCGwif6949aj38VmbVOBwLiXjpPP+M1s/98pTPxQC3v7CvTtE5E+NsTuMiUHHh0hyFgqdfXSs3Ymbm2LuxN4MeGmpUON/g55rCKcu4sM6oJke1xQ8xmLauqlOXEjBZ5UQH+qc+5PpTvvrt3/2u3PvCQGqyKkn7vklEft5Y00xAm1T8KkCYgJMUCToXIybHgf1sQLi6uZlILIBqrEhJG8DvI8UIMV2ejbezpUTh5i9eDIC77JKaBw+DPfUK+FHtj/66sV/EQH6tx+3p85e/pJY8x+NsRibBZ8hweTHfSL71A7QsAPNDGhCQgKaVkOYyF4xeB/iwnoEPCXAx+DDDBHhEafu7u2Dr557VwTo4KA52fPi/zHW/pTNAratBEhs/ExKQDMhV6vuKu5vHleYSt9lhkB8nychxDk3VCG487bBV67MV7O5GgFvdT/3eyLyU6llN5Iau9aej8GntkFyv9NCSNZLxEMn/WbmOxkys3Umwy4xuib3TZM9bysR/rXq/OwvSMDxz+++z4p5uOHGhGJHL70bP4AtlJuknT+SRpuOXszAVsQEaRwwb4xQbMcObINS2zxKyhxBiULnkgVIjOs28/ym+uNDv7vz598xAceeuL+EMU+ASNaFday8AVvuQNURybnZv8fvJqT0roqeq88HQ5kj+t1BUMJ09hO9En+DzDsIQUcf7Wu3U+xd0SAzbltib/IdAumwU31saPD2pe+IADc7/Z9A35d/KkyfPszlIy+i3qUY0irShjae+4vH8ecON4x/Egmm6on/Lqzhz72OXj6feaf12+HUKLXxU9AS/aY1s2rXT9CzakN6n3wH6IL6f31HBIjwmdZKFFeZxlfnyBotkuYk4Wxq1YFaBbzLhbrRSdO/TX+rzYEPM+/E38q+o0rl3JvUJkbIziMaF0p9ZpKua9am92lbol749NBjWzuyqIJm8G88uutmVd2Us8pxZQ0XlQcjoiiCaHRGNH4u6RlVND63lMy3UoIy9TSIzZCmpO6SzPXooedQMXHbs+QAQoetdX4U+JvkUYsCNHS7s26o2S1lY/RC7wraVm/Lx+2Z8NWrTxueBDnzHQ1FNP5OfbZOnwLK1TNP27wLCauzuefReI0YUOWBqyrAK7cZ9aia+AOCesGLIOpRH80/VYTikjVoWG30DB6PQfAYHxkJlwmIFipZAlIgCxEfT4g0jg5NsQ2xlnByPH43T5r3PmMcDcaYm65KQGj8euMFEZ9zJeoFH+so0dP0ySE0rCDexT7XYCSy+D7jmiQ2RqarH7t4DeGp/Y0hnEaBWUnHQ6hQxod1vKvmZ4Gucd219Do6Vqzj7J6vE85OZYKlOH9Aph3GgDHXXZ0A628I6gK4FGjjyBIAtanxzIQosgUYg2im0thFIYLtXAKAC136jXxOIGNcVWkf2IyrzTFz4kAjFG4COHX+GEFXL6qCc74xF4h/FzFRB6QBWlBakIAv7t/+Qf2mtDkXNbCh2kSeNr5rSNVkxrBIJL1cGJzx09WRo9Ffe5+Hr0lGKP/t2pWL2HJXCigHPh4G4ewVzu3/RgZ4Y2KUBkhp2B5ggmJ1YQV4fsbbqNcSErJGO7GqRi1qMsDjKasYg/eSyQvkgxMqM2R9c9ZKN9sA9cr06cM0psPaICDJD+RzASkBDfBJuBwgJsAGRWyxMLwgAV71nnpZaJsRBI2zLY2GGaOoRnI3xqDGoGoQb/BGMD7qeW8M4rMKuHpGKPXXzTPBJBOU8Qr5Md4gIAGeyL7R8wHGBthCCVsoc7kvH+CkBKgij7/C8iuLDIsmBFUHaiLmwxBjFGs9qhZjfOtU2As+6XmfNX75nOD86YBMwNNCwnyzwcyMMENCkl6LlGcxNsBYiw1K2GKZoNjG8LLRFfMSIIL+4Xf10qnl9aXXnu5AneC9i7tJcS6Me9/HoH0uE5QmQ9LZX5YAUluQ0UES5+VtQBp4ZZIhGfANFbgcIVm7Y4xFbNTzQdzzQbGNuS7hTPvkwQWHgHqenyq5B08MeNaeKSI+jJj1HlRQ9YRhGFeSEJH61/jcmg+ICG71IhkN5KPAnB/P+3+f5gQdSZQpxqZuzhjbGO+FErZQIii1YQsl9vYd9W2T/pEFCfCij6nXnxxaMS2dlV6WT5QRV0e9wzuHqqTRm/NRwiEPvEkF6cws7vfvmxHKG8M0J9iUFk/Vlc1FWIsYi7GFDPgyhVIZMZaX+06x+pWKufPZrjWfhj3zEvAbtw/tefb3dpx/+Y7aihdWj3NLYQnXX+rAhTXEhKh3ERneR1GhRI326nBOM4FTNvmRgG8Az3uB5DoB3qqCJJxNQRNZ+CgxmwCPet3E4INiGRsUCEV5cdFbDHde4hOnOsCYTcDfzUsAwO4XxOqM4aW7HC8uvcCZth52jS2mWHNxVFbHeI+qS2UpuVAWVF1u9tc6DJo00DQZyuYAyBCaXEcKs5HkbQETxL0eFLExcICRwjTPdQ8zWaoQqHDy+pDr3wyWZevOEVB9ko18dW7pB77VSenwGC9+osBbPZMMFyfZONPHtqleOuptMREh3oUR2IxUiXtNYgIanZy5Ti5yCYQkamxIpJEuM+kYb1j3ABMUIskXigSFEmKiQG3MzLK3/SzDbeNYK9hYiefWOICFp8NnJ9t/YaC/IuZkN+uPFmj77CivPVDkxMf6eK1jjAOFcTbW+thQ7WFltTsyks5FRHiH+jAv24wysunvbMmny/PprXQ4mSCVuViLMQVsIep1YyMIFUKO2lGOFMc4X7oSATcS5yajo3/U4jvquRlwjoDhke6PrVozid23jO7ubvpmZtj4lyOsfGqC4z/Tz+k7unnDjPFacIFSMWCd62N92MNq30XJaewxEkX42Hv4Bhmxe8szkA2WMtFbGsXZKOawhbTXk6E0xiynGGPYTjBcmEACJQgMgZWUgOiAohdue67IzKaR+3imuQOAT9x95813brlw4JMfPIr9wk7CGcvM7CznR0YYHR0FYPKGNoY+u5Ir/QH1UAmdEoaKc8oi18ZK7WSALpbRTi9FetSAT9TgM9Pm/BjIZY0zoBP35lQZ01ku+FnGmeOcTHHaXmHOhgSBUAiEwApBkAEekxBYwRi47+/b2Lq3QPjQIf7hYudtD/72mVdyChBrP3rg+BIe2n2czp0XCF5YSUd7O0v7+/HOcXFsjJ4357j9syd47q9uIChD6CLwYajMuCpHXIXX/cXomVNwsEjL9Ekb7aZAO5ayBLRLgbIEmJiKOQ3THpnRGtNhyKyvM2fqzEidK6YKRhs9GwNrtwYbg7dGMCl4ckNg5wsFtu4tQMnhB65wfGjg56CJAFS3zlYDntq7hgd3nqZwYDnMWLq7uiLfbi2jo6PU+wIKnQbjoeAU5xXvwcVkOB8/c+C8UtUaZ30t9uuNRFDWQApJojSyf9H6AtHYFWi3UZzRDC4CTQo0dy8gRlj7PcuPPV0GwG0eZbpuOfx236YWG6Cw3Ah889UBtqy5xIb7jhN8bSMA3Z2dFItFSsUiF8fH2Pj4OUY+upjJ95Xxnig6iwFGAQspMVF6jHhSQxJZ58xhY8qcZMsj2RohY8Syz+NzPL5b3omJbJ8TPvy3ZYwHig5/2xme3reaupOeFgIMOiAY1MOXntnML/+7V1m9bRQ7tAwRoa1UYtXKlXR0dtK1Z4zlzwxzeUuZ4d9czdw1BdSTkpCAVZ/E9pmeJ+Pv87aQrCtMiEhVYSRVhzFR75qsYpqvjXDzSwU6ZiKj7+58m0MTnfzTgQGARfMqIB2HlQJPfG0Hn3pgiHVVi/nekmg9UITFvb30dHfT29vLxLnLdD58hte+shYfSCrrRr5TM9fRfflCiBYMld58PjaJktNZ4wJESBwk5e6bwCeEDrwVxQV+zSSH+qv82VNb8CqA9rUQAOIjRyVMVWp4CvyvJ2/ik/e+ziZRzJF+rDEYVYwI/YsX09fXx9LpaU5MKDPLDBplXTORXTzrU1j+9cus+7/T9FXKdHV2omvbOXKHcuiOOvUglUDDLQn0fK+CE2V2fRmxJgXWICcPOK+oKLjyK6d4eu00X39qCzWfqjBJSeXigIuqDGj8x/XQU7MBf/7sNh54/zAfWnWC4J+vRZwQiKDGYL2np7cbv6SKtVlZSyp3O6fc9MVpVr9WoFReTrm3jUIQYC4Ld46f56bpEb5V2cDZgQZwAXpHhfsfL1KpVLjSM8XJe4qc+VCZWo9pAdsAnL2HyvJZHh8pcWT/tZFNIrU9Iy0ECLyuMOAVgsBSCgxeIXTCky9fz9FVE/zsTx+m57nVyNkuBLDGcGGtJyyDSeb4afwPi0aFD/55gd7zS5Al2V4T5OZR3N0n6BL4iHmDvYdu5ODNjWEhgaG7s5Oujg76gbXfAvcCHLvdMXSvZ6Y3Y0Tnn2LwpVoXl8YKzNbqzNRCyoHFWIvC4RYCPPKMoPc7rwRG8B7ERMZMEI6d7eWxS118fPdhNs+CfX4AGW9nbMDnGiAimBBu+mbA9m8UMCFgM2F/yeM+eAK3/TzJU9NW59blB+nbu54XdnTgLcwshqBgEZefQ2z9jmXLHuHN94cM3VXn8rJWgxq9K0yeDvAK7cWAuvfUQkfZWkR5OnnNJhdbrr3+JEY/AxQSSZh4HCUZnbozDA0v54wpsPojRyneMI7MFHjrugLeQtcl4cbvFrj7L0qsPRRgNVoqNyLQV0W3j+J+4hi6ZpJctl0AA4sXjbP0cp1THd24Atz43YBSJTsviDM+HvpPG7a8WGDFcYMrKxP9mlvnGttTYvJwAa9K6BUwhN4TWDsdBu5Th4+fmoVGxwDw0L27H1P4NYh8cMEIgZGG35Vo/W+2HtJVFj78/hHu2n4asYqfKFE60w6TBaRioWrRzjraU0WXzqLLkm18mjnN33uXbZl9nSvY/eokpVMdyKV2ZLLUeN14dPEcl8ue/bNdPHtxMa4ApWvqSFmpXDLMnLV4H4EPPbjEMIv+wd9847n/lio2W/HHd+1qC7pKLwE3JSQEJjJ6xoAVoRpG21GqoWd5dxvLF1f4tx86w/WrriQhXm7NL3ufXs+3sps0sOk+fScmbHquxNDxZew7eg3nLnWmn/Zx7JEEZU4hjKNSF38qsBzBFW/5y2efnZmXAICH7r57bWdb/Y2pqpSTF6wRgpiArBpMxvfe82+muf+uiXg5PJkFeuJwMCbEp781k5WbLTb9Vq1bDp/o49Wjyzh2ZhHOk8YbCXDNEJCAD1VTHnvKsKbfb3/4S8+/msU7r/186Xc+8NVnjgYPHRtvPDMSERAYwUojEksIMAL3f9hz/70h2fk93qWHqsvfe99KWHLtPcdPdrDvjUW8fqybat0wV482ZhSsbQBWTYmohtF6ZrbXAa7rhQc3+8vbP/d8bzPWlpQYQE/Rv/zvb3IPvX7R8vcHldlaHSOGYmBxGmVYrIIVMKJp/P3k04aeLs+uW+LZXTYTbAOEIEdOI/vTiGbUe/YfEJ79p4ALY5FVS+YO1dAxW3X0dZZapO9UqYWRpQ+CAGuE3nbhrrWwZZkH9a/Nh3VeArznKe/9E1uWGjp2WL56AOo+amDCeug1nXVVajUCY2gvBfz13xVZ3F1j/fX1HDAg2iDR9CzJ+wGcPhPw//6xyPDJBHgSWkfnYhDlIWarjsCadKy7WAViDH2dhg1LDZuWW9YvVlTDaNHU+9T1ZcsCIQQc/oPbD1lrNxtjmaxa/uGwcnzMz/uu90qlVqOjVKQYGLo6lIc/fYll/ZkV5mRIZK/js3p4+lvtPP3PbdGIILF5+bmFJ5F9A3RSetuFu9eX2DEQ7WNobJx0OBcqWt+w8ZE9R5vbbpsfJOVTu1fVRPgYCO1FYftKy7Iuw6U5mKq2ZvZC57DW4BHmqnDoaMCurVMUbAjeId6BumgfUHrtmJtT/uQvunl+T5nQQaiJ64rcV+ih7pV66s4iApKyqM3w45vLfOLmEqt6gNzKkYuXzPxTNz7yyhfnw7mgAo49sa5Um1py0Bi73tooRWWtRcTw1ji8fMrxvQuOZKm/WqtTKhZy39hw3Ry//h/OU0gf55UwOWP5/P9eyqnzxXnbUA8jUk1znA+s6w+4Y22RTdcYhMzKceuqsfNhfdfm39679wciAOD1/37rXRLIN42xJiHBGJMSUfOGw6OOIyOO4XHPlUrrELn1xkl+4cHziGhj3IswWzE8+uXVvH2+1PI3ALUwBIViITJTRmB1X8DWFUVuHiiwqNxYNc6uGTb2CKTXj2/+rVd+dSGMVyUAYOh3dz5iTfD7NrM/2NpkDa6xPdaIYWxWeXvcMzKtjE17Lkw5xqcdd2wd5+ceOJMa/Hpo+P2vrGP4XNuCjeppM6xcFLBiUcCaPsO6JQHlAk1L5s3/kyS7XO5xzn2n3DP+off90vHqvBW9EwIU5ODgLX9kA/MrC+0SN2kaO47Vm/YF1z3YjrP0XnMEEc/ImS3MTa4ksFC0MFuLLH3oobMotJdAYteXWybzmc1Smtk/kALOLZvvqzp3/87B/WNXw/d9CUjK0OAtv2asPGqMCVq3ybeSkDviBQ9bmqZQmqA6tWb+mpNEafbcciz032cyKvD+yVKp+NCG3/jO1PfD9Y4JABj63I5bCeTLxtgN8xGQXSFu2bCcXR2WNAzK48/sE0r2CkCegOx+gXkImPbqHtn2O/v/WBaaaf1LCADY9/M7CsEK/S9GzCNizDXNCrg6Cc2Zm+x1kkaLqUjP2T2C8ylA8d5XvfdfriGD7x/cO8IPUH5gApLyxuCmYo3yg8aYTwr8mDHG5ndpmKbe/377BLLZ4ixwcuuNTeDfVPV/JdT/bNvgwQvvBse7JiBbhga3LlXsR0TsbhHZLSIDLf91DhZQQb607hRpDAPvdUrR76j6bzvVp3cMHji44IfeYXlPCGgu+wZ3LDHebzPGbhR0jRizGmSJCD0g7SK0gfQA7UARuCwwq/iKqlwWdNYpk6L6NqKnvPpjYV0O7vgf+4ff6dj+UflReWfl/wMltN4rd+xpYQAAAABJRU5ErkJggg==","1f37a":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAtxSURBVHic7ZtbbGzXWcd/39prz33GYzvHPe5pk5wkTaNUiDZp1Cgooa0ScgGKeEE0LZcXBBIC8YKEBELwUvWBm4AneEAgCFIJNwmJ9pCqCJTSk0QU2rRNTts0IcmJj499xh7fZmavtT4e9vgynvHM3jN2eCB/acn2uq///m7rYngH/78hs3agqoad1x8G80lU7wdu7/f7CvAN0G+B+S98+E9p3vzdg3Z7V28m0e9HdBkNCbCOMa9RvfA1EdFZ55UVUxOQLvzNT4H+NsrFjKPtoNxAWECpnlBrFdV/xpjfl9p7/nva+WVFbgJ0dbVGpfsJlF8FPjjYm4CtgS1CdzP92xTARIABFEICvgvBTRwK+Ds0+gVpvHst7zyzIhMBuvHqRYz9RUQex5g7Cd6m89vvxYCtQKEOEoH6fn6U/gwO3C64vZSAfHgD4QmpvffreRtmwUQCdGtlSdHvSGmuji1Bsp1+3ZG9GYgKIDb9+qrgexB6M00yKCsmhLuleUtrpo5GwEyq0PPu56TcrGNi2Fs7efEAGsB1UpJ6W+nPaRevAfweqgEjnO9hfn66jsbDTqoQGb2L7gb4JBXj0IWolIr8WcF1oNcCVQThrXCBhYqfaDSmwUQCVHllpR04b1YPddt1AAVbPaiE202Nm7EQ11J1OLFTgDC6jk+gd+OIiVG+txlxtVf4qxzryoyJBPzHqv3jyMlvnp/3gwXdNgQPCPjd/u+AJyWovHhoBPfhu5DspFKkChiwpUPjCZC0B+zrPnYT938jASdDUx0fWeSgsw7F+dQF+h70RtmD0FerBMo3ATKzwcyL/AQYy4DzOMmtBQd717P1GRLwDqJ45Nc/S+QnoDDXJ6GP3VVOZ9YeiE+hn3yY6AaHcVafqC9VJhpf7ZSRWQJ2d9pod4uovIdEhVTEg6N79YXUZwNowHd3BtqF3jaqiohgCrWBsqhYPfAE1fc/QVQu0m29QbKzDiZGClWkWE/H39j6p88/f2WYHVUPtBXdE2Rd0OeMiZ965MO3jwlYDjExEvy3b791LnKyOv/XdyC+R+39j2Prywflm1/9S9TPbrju+OXnsJVF1v79D1h79o8O8jUq0vrkt9nebqOaWfpuiMhPPnrfnf8yqWJmFTCFMiZS0ARwB8lYMJHOnGzjZgDiufODZcVy1ikexYJq+IdLz1354KSK2W1AXMYYEByCP0hGwJgZUxSlO0gx2MrCQBnxVAQAUgnoH06qldkGSKGM6YJognAYFJlIyC6ZJ8ETdtcwkcXvXEsX3kcopCH36tpVvHNo3wirBjSkv0eRpVyuMNdYPN7xg1+4/NLFRz9y1/dOGjk7AXEllQB1iB4hwAg6hS85jhvP/BrN+3+J7RefGiBA4pQAMXI5svbLImbloCwEG4SbCFzY3tn6WK3WPBcd9yLCA8DsBGhc6RtsB0ckQAxTOdPj2Hn5aXZefvqwz330Cbj5tjt/9KH3LZ8YWf35M5cXk173zahUKQ6WyAfGjZt56hJXMKIYTfpSkCZjSPPPKKnNZgN+5uGPrBsjXzuerxMIyC4B9lAC5Awk4ETE2bfdYuyrwH2DmVwY1ya/Dehb/32clg04ETm8QIR5cygz6Ny4NpkJCHEZ6bvBkTZAIUkEGysy82H7ITTHwYuJzM5QptAY1yb7ZihKbUAqAYdbcyOKipIkwtaGUCpDrREyd5tl3KxQMR0Z3qucDgFq9yXAj7QBtqhUqoFiScceBuWF5gmEVO2I4H6sPGaXgINI8JgEGFCTakG9efo7xTwqwKivrcGPqHeA7DYgqiCSEsCRQEiEU7hgOxmaQwWMoXE8KlVk7FFadhWIKv2FDhLACQR09oS9HSGOlVpDpyYp5JAAVepDeTDWIOWUAIXjNkAUjt1l+kTYXDeoQndPEBOmNox5JIARKqAhtMc1yCUBAojqoAqM2Al5z8AGyScytZYEMyMB6scejExhA8LAZiiVAEDBOSGySrGkxAUl6QkiUKmFqWMDjXJth989NG+4Ma5BdgJsPSVAdMALQBr4bLQM221DZJXzFzxLy55eT7AWomh67+DjsYHcAV544YV4LfDeoQING+PaZSbA27m+IdP+MVwffSPY66Wf2DshqBBFqSTMCm+zEbAmzVvAD50ZagjXxrXLQUAj/foyGAeIBBClueBptwylElh7epFgsGMDuQOYRG8LIwKwoPrGuHa5VAATIeigDSC1AaWyUiqPjTlyQ8USMnoBNf72Ub62s9sdezuT42JEUFtDxDOwGTrDQMjHjeydKxePV02SHsGEr4xrlitq93Yu9W/qDtMZ3mUF28xcV0U+dDzP+aT15CMPjH1nlI+AqG+Qgj9MIwjodYWdbYNLZhMNl1H/Lz3/0g8AHz+eH4L/xqQXZ7nuBn3cQHs6EAkeD4U3WxEb6wY0VY+bznsqtemMYhYPcOkr33xfUPlbRnzMbnfvtUntc6pAs68C/kgaJHjzhjkQClXYbE2/N57kAS5dfunDwURfBN51vGx3d1uNRH8xaYxcEhBsY8gLHIUqQxqhYXob6U+wAZ/7nEaNW6/8SoDPAIWhdt7R3m6t/OyPPHxp0hhT2IBjEnBkxSJQrQ+Ke7U+QxQYHUpAZ3vnh39L1Xz+8pUnG7deeRH4HUYsvtvtsHLtdY0j+9ksY+SzAbYOGtAxjxwXlzzFktLrQakM1er0QVGwh7tbdeHP7n/+yp8io+fsnGOjvcZWe4NavfHUpx7/6MRrMchJgCuc6299j6rA4F5fBOrN04kEk3jpeNbQfL33bGyu0d5qIcaEWmP+sz/12EO/nnWMiQSYnpYx6QqTwnLq+ga2dmcXByTF8yeW+eDZ3Fhnc6uFaqBcrr5WrTYf/YmP3/dynjEmP5PDLO8vN52QDln+s0JSOHyHYIzB9w8aNrdbtFprhOCJC8VOtVT7jScfe/B3pxlj8kNJkeX9G9kkXp5Q+3RxlABEcM5x7fqbdLu7mCgKjXrz6QXd/eknHnuwO+0YGWxAuLCv5C5eINg5Ipfp9clM8HZ+IBDSELj61qu44KiUqy8K1cc+/fgDwzdBOTFZBYy5+1Dkhfb8DzG/9jezjjsR7YVHBv7udPfwwVGvz38mj5GbhIkEiOrdRzX+f+74PdrNH6TReobyztcpdV7hVAyhGDrFi+xVv4/NhUfYXPzEQHGxUKJWa/7JaS4eMgRpz35r5Row5I/2YfwWpb1XsMl1bLKOdWvYJD2FikacR+5vqFzcxMXncPEiLj5Hp3QbIaoN1d+H84k+9IH3WBE5xXu3CQQ8+52VJRKuAYQQ6HR2iaylEBeQU7r/Ug0kzuGSLolLSHo9rLXUanNYO/hw0ltdGvdIYhqMVQH1eu/+gbYxhnK5SnurxcrK6+x2dohMRGwLWGsRY4hMhDERciROUA2EEPDe9VP6e1CPcx7n0id2UWRpNhdZnF+iXB7970TWmXuAL5zS2tM+xxWKyj0Df4sw11hgrrGA946trQ02Nm+wsbFO0PySGVlLoz5PqVQmjgsE79nYXGf9xjVKpQqNxjyF+PDFS0Dv5e0lQO/RE7TEmIhSqULNO6rVOr1el16vQ6e7h0t6hBHBkqTXy+mDR1W8c7S3WmkYK4ZqtUa93mRx8V0DCz9oj94zlDkjxqsAcu9JZSJCqVShUCixvbOJcwmqqa0YtXhI1QEFRIjjAuVylUq5SrlcpVZtYCa8Exbk7SVAYEXhlnF1jDE06vM06vMHeSF4EpfgXEIIh6oRmYg4LhDbmGmuihTGnvFPg7GzUFXz5ZdWfxwJPwbyUXTEzctZQ3gd9F9R848P3LX092+rGzyOL3211SyWeneD3opwTpUlYBk4h7IkQk2hJCCK9I9ztAIUgS7IbjqobiioQEeVbYRV4DrwlgirKNdBXu12Ct/82Ifmx15tvYN3MBv+F6QI5cfosrbZAAAAAElFTkSuQmCC","1f377":"data:image/png;base64,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","1f37b":"data:image/png;base64,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","1f942":baseURL+"1f942.png","1f378":"data:image/png;base64,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","1f943":baseURL+"1f943.png","1f944":baseURL+"1f944.png","1f37e":"data:image/png;base64,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","1f379":"data:image/png;base64,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","1f37d":"data:image/png;base64,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","1f95b":baseURL+"1f95b.png","1f963":baseURL+"1f963.png","1f374":"data:image/png;base64,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","1f961":baseURL+"1f961.png","1f962":baseURL+"1f962.png","1f601":"data:image/png;base64,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","1f603":"data:image/png;base64,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","1f604":"data:image/png;base64,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","1f605":"data:image/png;base64,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","1f923":baseURL+"1f923.png","1f602":"data:image/png;base64,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","1f600":"data:image/png;base64,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","1f606":"data:image/png;base64,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","1f60a":"data:image/png;base64,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","263a":"data:image/png;base64,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","1f609":"data:image/png;base64,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","1f607":"data:image/png;base64,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","1f618":"data:image/png;base64,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","1f642":"data:image/png;base64,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","1f60c":"data:image/png;base64,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","1f619":"data:image/png;base64,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","1f36f":"data:image/png;base64,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","1f970":baseURL+"1f970.png","1f61a":"data:image/png;base64,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","1f60b":"data:image/png;base64,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","1f61c":"data:image/png;base64,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","1f61b":"data:image/png;base64,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","1f643":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAduSURBVHic7Zp/bFXlGcc/zzm3t6UUBBQo0zhJccUtjBYqKPKjQEFoDIEiTAXMNjOZzmQZgS1mERwu+4Ukc2YG0W1GUBBGOwa0lF+rrWILKWAXDOhQ5sj44QatbW9p7z3n2R+17W1723vvuef2wuSbvMk5533f7/t9n/Oc98fzHriBLzck3g3ohWX98ZtTUMahkolqJsJQYDDQ/4tijcAVlM8QToGcRjiGN/COpG9qjKe+uBhAzy4dAcbD2HYBIhOAJIdUfoQqlEIwt8jI1y64qRNcNoCefWQ6aqxE9X7AdJMbsIC9iDwvIzeXuUXqigH0zCN5qP4MmOQGXwQtvguyWkZtORQrU0wG0A8KRmAm/RrRZbEKcahgN4b5pIza+i+nDI4NoKcffAjlZWCgUw6XUAd8T0b/ebuTylEbQD/5dgpX634LLHfSYNwg+hJm8wq5s6Q5qmrRFNaTi9LAXwg6Kzp1fQShjGTvfMnYXhd5lQih7y8YhmGVgmY5U9dHUI6jnjkytuhSJMUjMoBWzh1IP/4GMi42dX2Gv2N7p0r2X2rDFQxrAP0kN4W6lBIg1w1lfYhD9Jf8cGOCJyxNrecF1Mp1S1UfYgYNrAee6q1Qrx6g1XmLUX3LTVWXriin/qlc+K9S71MABqQKI26B0bcbDB3s9upclkjOgTd7zO0pQw/PuBWPfoAL8/y5z5SdFTb7jlp8erH3snekC7PuNpg/1eArN7tijDqMwF2SU3E+VGbPBqia9hawOJaW/1MLLxba7HnPxrKjq+sx4YF7hacKTG6+KRYVALwpE99eEiojpAH0aG4eNvtjabH0iM0vN9vUNWosNNyUJvx0mcmsnBi9wWa63FtW1vWxEbKwxbMoOE1/KrF5eqMVc+cB6hqUn2wIsGGn7VgPCgi/CMXfzaxaOXM62I53Wb8vsnh1jxUyz+uBzNuFYYOEQWkwaEBr87X1Sm0DXKpVTn+qtARCcy+fZ/L9eTHssg2ZJhMOlQc/CjEN6kqne6TiKos/FHfufMatQv5Ek+w7hW/cYeANExpp8cPJszbHP1L2VFp8/O8OL9q4y2JkunD/BIdGsFgFdDJAp55q5czhoOeIZH3QBRevKAufaaHxausANmeiwcKpHrJGxfbtHv/IZke5RekRm4AF/fsJRc8lMXSQI94AyG1yz8H2uajLGKDLUPGgQrRp/dYAjVfhnq8bbH/Wy3Pf8ZKVYUTN0zVljzL5+Xe9bFvjZeJdBo1NyrotAad8HuCh4B53ftPKfCdm9QeU85dh/ZNeZmSHHldjxcgRBhtWeDl4zOK1vRYBq9XTHKAAeKHtpt2P9P3Z/fHZlwFvzGqvbbSQagyRsfsaIdgDGu3JIP/vnQfw0sQkaF3ndPiryPhEKepzWNq+re/wAJXMhIhJBAxt72vQIPglMoDK6LbLIA8gPSFiEgIZ3nYV7AEDEiElQWjf4gdP2mkJEJIotL/sYA9IhJCEI3gWaACGxEJ24ozFK8XNnPiHH4CsUR4ez09mbEbUW4u48AWhvu2iYyX4Tv5Z4KtOGfcf8/P0q75ukR/TgF89lkre+OhOyN3m64KPZXJxBnQaA4zzrfaIPn3ug7WbmkKGvSwb1m5uor6JhPF1Syrt/xl0GEDtD51GWypqAjQ09Rz9qW9SKmr8CePrltDTbVzBY8BpxNlAePFK+IjnhcutcalE8IVACANAtVPC4YPD70vTh5hEyu82X3eY1W1XHZ9AqlEBtDihmzImibSUnuMAA1OFKWMiH7Tc5uuCFvrZh9tu2luRnF0+VI44ibQM7GewZmkqZgjNHlNYvSSNASmRR4fc5uuS3pOcXb52vk7sQhHKZCdmzRuXzB8Hm2ws9nHiTGtYNzsjicfz+zFmZPTzttt87RAp7HQbfKMH5g3HK46CotcJArTobZL319BB0S8ySh3Pr9d6UikJ7nw3AwBgyfMxncBc00nXde1uyHlEyxdUOB0LrmG8LdOKcrs+DP2t+wNrMIyD8VbUh1BsXR0qo8eVhB58YAtdDhGuY2ySmbsfDZXR82jv96/ANOcCsZ/OJxa1ePhxT5m9riV135xFqG5zX1MfQnlQ5pTu6Ck77GJa985+CdUn3FXVZ/idzN3/w94KhF/w2OaP0OZMYIZbqvoGeoDGW1aFKxXRdkp33jcAw1MGXC8/StaQkjRVZh0I+8tsxPtJLZw0DNPcC2THJC3eEKoJWPlScNi9X2XboNty00hq2QHMdiQu/jhEsrVA8qs+j7RC1BEFLZ6bjK92PaI/iLZunPEiVv1KWXwyqpiG45iSbp+wCPQVEr9OqAUek0VHC8OWDAHHBgDQbXenY1u/QWRprFyOIOzG9DwhC6vOOadwAbolKxdkLegUN/jCN0g5pjwj3zpeHr5w73D1rekbY6aCrAKdg/tBlQBoCbaxTpbVVLhFGhe31de/OQyxHwYKQCcCyQ6pmoFKVArB2CqP1kQ0tUWDuH+3+vL4VFJ996E6HuVrwGiE4SiD6DiRbkCoRbkInEL4EJFqfKnvyvJqX8/sN3ADseJ/pwVAxzW5lCcAAAAASUVORK5CYII=","1f617":"data:image/png;base64,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","1f61d":"data:image/png;base64,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","1f92a":baseURL+"1f92a.png","1f928":baseURL+"1f928.png","1f929":baseURL+"1f929.png","1f60e":"data:image/png;base64,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","1f913":"data:image/png;base64,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","1f9d0":baseURL+"1f9d0.png","1f973":baseURL+"1f973.png","1f60f":"data:image/png;base64,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","1f61e":"data:image/png;base64,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","1f612":"data:image/png;base64,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","1f614":"data:image/png;base64,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","1f61f":"data:image/png;base64,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","1f641":"data:image/png;base64,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","1f616":"data:image/png;base64,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","1f623":"data:image/png;base64,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","1f615":"data:image/png;base64,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","1f629":"data:image/png;base64,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","1f36a":"data:image/png;base64,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","1f62b":"data:image/png;base64,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","1f375":"data:image/png;base64,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","1f624":"data:image/png;base64,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","1f620":"data:image/png;base64,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","1f60d":"data:image/png;base64,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","1f62d":"data:image/png;base64,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","1f622":"data:image/png;base64,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","1f631":"data:image/png;base64,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","1f621":"data:image/png;base64,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","1f633":"data:image/png;base64,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","1f630":"data:image/png;base64,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","1f97a":baseURL+"1f97a.png","1f976":baseURL+"1f976.png","1f975":baseURL+"1f975.png","1f625":"data:image/png;base64,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","1f613":"data:image/png;base64,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","1f92d":baseURL+"1f92d.png","1f917":"data:image/png;base64,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","1f92c":baseURL+"1f92c.png","1f92b":baseURL+"1f92b.png","1f914":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAzUSURBVHic7Zt5bFxFnsc/9V7fttsd33ac07kIR4InIEJCJheBhGMgMBFDCCLS7CIxu/PHDLMrrTTsITTaaLLsMiOhGY3QjDTAZGCTTBKGDITcBznWIXZIYmPHzkFit690u+/jvdo/2rG77e52d7u9rHb5SiW1X/3qV7/6vl+9+tWvyvAN/n9DTHQHsmtTARH1IST1SDEXKeciKAcmAQWDYj7gFpIeBM0gWhCcxRQ9Jqp+75tI+yaEAHnlhWpQvoeur0eI+wFjjqoiCE4h2QHqH8SM33Xl007IMwHyyvMrkMqrSPkIoOZTN6ABf0GIrWLGO4fypTQvBMjLz69Gyn8GHsyHvgx6PA7iNTHrDwfGq2lcBMiL66tRjVsQctN4DcnRgg9R1FfErG3Xc9WQMwGy5dnnkPwasOeqI09wA38l5v3nB7k0zpoA2fGShaD7P4CXXe4Qfa4Qbk+IUFhH1yQmo4rNpuKwm6kss2IwKLnYlT2EfAs19CMxe28oq2bZCMsL3y2EyI72awMPHzx5E58/mlZeVQTTagtZOL+U2qqCtLJ5geAQZtNTou4Dd+ZNMoRsfLoCRfsY5MLTTb0EAhoOuwmLJfaxD4U0vP4ozr4And0Bopqe0H7N0hrmzSzOtLvcIfkcaXhULNjZnYl4RgTIk2vtWDkIoj4TeU2XOHuDNHcM0NzuIarpLK0vo35+SSbN84Hz6KZl4t4/ucYSHJMA2bHcgtuyF1ieiyXBkM75VjezpxbgsJuyauv1R/EHo4TCEoNBYDIoFBcZMKgZfVcOUCDWjfVNMIypxmV4E6ktz8zk0bAY4b75gwuFro0p39kTpLF1gGtdAYIhfbSAAEeRkZoyCzNrbUyrtqIqSd/jSrz8G/A36fpL6wGyYfUGpPzjmFbnCf6Qxtu7biClTHguhKDQqmIyKiAlwYiOL6iBhJJiIxsfqUaIVEMRG8WiT99L1WdKD5AnVk5G036T7SB8QSiwZNsqBj2qI6XEoAqmV1uYWWOj1G5kkt2AQU0cYCQq6XGFud4dRNf0VF4A8Jb8r4cOikVHO5NVpp4CqvYGMrMgJxCCt3bq7Dmh4/ZBcQE8uUThlacVLFlM+0KL4PElpUypMGNMGLCEEV5hVKGm1EhNqTFpfRyK0ZStwMZklUlpk2eWr0ZnXyZGR6KSv96qca51tAH1swW//okBQ763RblAZ4VYfOjQyMfJPUDjnzLVu+uoTDp4gLOtkl3HdJ5Zll006AtIfvsXycHPddw+SV2N4MVHVJbcNY6ti+BnJNmsjbJMnly1AsSSmHOMXY40pXQ9AI42yoz03C7eAGzeovH2nzXab0r63HD6kuRv34zyzid6VrpGlMXy9MplYxIA8tVsFPuD6QnwBcnK0F/t1mn9arROKeHN7Rpf9WSnL6Fo/CQtAfLkqkpgTdoRjcCcKende+7U7Nx235kka/8gohrsb0hdPyYEjw6OcQgjrJebkMKAFGRanl9lwGpO3p/NDN9bachYF1Lg8qb3qFsestI3ohiA51ITIHkqMyqHUVsueOMVE46ixOeTCgVv/MDE5LLsPGBaZXqPml417iTW+vg/hrTJxjUF+PV+ILuAfRC+gORwk47zlqSqRLDsboUCa/bGbj+i8frvw0nrSoth1+vWnAOtQYSxKSViwSc+iF8GffpSEDkNHqDAIlh3/8gZlb2e9UsNtN3Q2XYgMdcwqVDw76+YKTCLnPTGwUSAByEW5wwTIMS3xqk4LxAC/v45E2vvN7D/bBRPAGbVKDy+WMVuy1MSW5P1jCJAirn50Z4f3DNT5Z6ZExRCKnJorHGR4P8uAiYUUsy7/TPOA6j6Woz5WiCGYoF4DyhKJvp/FEO73PjPduHXYMjXhaGXHe8BE9ZbIAR9Hp0ii8BqEZjGTsT9jyF+FfACeUnbNrVHOfZFlJOXorR36vhGbJhKigTzphq4Y6rCt+8xctd0lZQZrYmB5/aP4Ujw2LorwLRk0tcCU2j03ENvpAyjEmGa5RqL7A1Y1UCC3KnmKL/aE+Tc5bGTn/GoKVV4aomJ51eYcooec0C7WPpRHSQQ8PhnIB8YKdnin8Ph/qWMnCJ2g5cnyvdQoPoB0HXJ6+8FqHAo1JYpmE0xeZdHx+WDjs4orTd02js19BQBl90meOkRCy8+bCazzHeOkJwQD/15CSRMAf1LEKMIaBi4FxDMqK3hjroZeP1+TjdeYCBcyHHXEtaUxDJnihC8ttGWptfYlnHALznVHOVwU5hPz0YJRYbZGPBLfrEzwMFzYX62uYDa8oliQbbc/jXcgxQtIxMIUWnAG40tDg8tWkhtVQXzZk5n5eL7ALgSmEp/pIRskhJ2m8LD9SZef6mQfVuKefVZG6X2xIGe79B4YYuHrlvZZZOyKEkIgIaRggm59rjftVUVlDpi53xXgtNTdtQdruAL7500ee+iK1yJREmoL7IqbFxlYfe/FPP9tdYEt3f7JOc7tAkiwNBwu5/hKWBTjhIgTNx2WEXDrIQJ6SY8Xh+WkuHN4pTqSvpcbrojFcQjqFto9s2hJTAHdyQxtrKpAebY2phjbcVhHD7AtZkFP3jSyuL5Rv7hbS9Ol06FQ+H+ubleLUqLMFb9xO0/hggQi/b45ZEnTwNL46WLVA8hvRSfP0B5yaSh5yXFsWDKr9uRusAZqaTFP4u24Cw0PeYtNquFqrJSrBYzfbfcOPv6Oee5m3Oeu6kw9TDbepkplpvY1QEA6uuMbP+pg5MtEb41y0ixbdxb32T4TCza7R9FQIwFdiJHE9AbKcXrT1zyrJbYR80VLuC9nufwRWNZCiEEM2qruXN2HTUVZQltfP4ArVev03b1Ot1u6A6XgxtsaogqUxf3FjZSau1n1cKc0xJjQ4gd8X8mEhDiXUxiS/zzAjUIgKYnJiONhph7RqVCNGrBZDQwd+Z07ppdR1FB8tWgwGZl4R1zWHjHHPpcbq7d7KKn/xa9LjftPjPXgrU8VvYxlcae8Q80OaKEEs86EwgQq3c75ZHvfAziseGnMR80GRO5kkgURWFKVQV106YwfXI1BjXz/Xupo3joQwpwrKGRi23tnHHX83jZJ5kPKRtI9orVu5zxj0ZH5ZrYisIQAQNabK6XOBJvd0yyF7HpO2sxmzJzV11K/IEghTZr0vpSh32wv6KJmPcxSPnzkY9GRRpixZ8OIcQxEOhSwRmpQFUUykYQYDIaMx48xAIlj8/H3iMn+KL1Mpo2HC5HolEutnUAYFHCTNDaf1gs33V0pF3J92WR6D+iKPudkUpCmpHq8hLULNw7FarLy3AUFbFz30E+v9gyOG0MXL3ZyYA3diV4ga0J9HEcfiSHRJevJatIGmuKVXsOoGvbesKxzWH88jdeWC1m7pxdRyAY4tLlK5z/so0Brw+zEmVZ0XHqTJdjN0nyW94Rq3YfSWZP6p15JPIjd6R4PWBK9VXPFcbBD+oCaxMO1U2h4qXK0IUqNMj7y8eFgb9LVZlytyEe/bjzRrS6AcBsGn9E1tXbR0vHVXQpcfb0ATDN0MFc40Umq9dQZXgi3jxo2vfFio9S3jJPm5txR+3XhWDxuEcPVJWVEgiG+Ojwcbp7+zGJKGVK90TM93j8Qqzdtz2dwFjJKTeAPxjMizUzamu44ezhprOHB82fYdCzutWaJeSn+MpGHYePRFoChKAd4Jbbk04sK1SXl3KxrZ1C3Bldm8sRTViMz4rHPkh+yBiH9B4g5Cmk4GZ3/kJT10CMzIC0TIz7CxqIauvEE4czui+clgCTf+CzsNUx4PH57Tec3UyurEgnnhS6rnP1ZhfO3j7mz5rJhcGAp0i6JsIDDmDWnhZPnhrItEHanNPmzZuDEt4BONN0cdQFxow6UBRm1NZQU1HOHz/aRzAUolB4qOZqzAPyV35JxL1WrMt88GMSACCUyBaECHX336LhQnPWBNzG1JoqHPZYgmSp2Iuq523Zc6Frz4hnTv5QbLgw5pwfiTEJeHnDhmvAawBnLzTT8MWlnDwhHiXSmZ+3LvUPUZS7xXfP7Bi71+TIKO3aealxq4R3ARouNLNr/2GudzqTEuHx+WlqaRuK7Yd09PRyyz2AWQSx6p7xBjdHQP+22NDwhHjm1Fe5Dh6yOA97//331X5p+Fch+fHtdiajkRKHHZvFQjgSwe3x4vH5qakoY0n9AoqLCglHIrRfv8HppouEIxHulUe4T9+fi61RkHvRlZ+LTU2jdnW5IutjmN9s2/6ARPmpRK4hk+v2cajTz7NS+wCR+YY/BJxEih2gbBMvNmX0XyDZIOdzqLfe/XCSQY08APoMUIy6xKtK2aFJ/Tqq8oKAp4DZAgas0n1lvnamtV47EAHmIahE4mD4RNqLwIXECTQj+BIhGvDbjouXG/wpjfgG32Dc+G9n/aqp36KLoAAAAABJRU5ErkJggg==","1f636":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAZDSURBVHic7ZpbbBRVGMd/38y2lHLxSoFIowS0EEWuIkqFUgpC44MUigXBmBhDUBORAG/i5cFEAYOYEI0vxlsVsKgQ7mAtlIukElEQSBQEooBRW6DV0p35fGi33e7OdndnZ3cp8ktOMjPnzP985z9n5sycM3Cd/zeS7Ar03NxuNJkPoYxAJQ/VPIRewE1At5Zi9cDfKH8gHAM5jvAdmf490ufD+mTGlxQD9NScvmDMwrZLEBkNZLiUakI4gFIBZrn0f/+cl3GCxwboqdkTUGMRqg8DppfagAVsQWS59P+o0itRTwzQn2cXofoK8KAXejHUWA2yVAaW70pUKSED9GhJX8yM1xGdm2ggLiPYiGE+IwM/PeNWwbUBenxGGcq7QE+3Gh5RBzwtg9atdXNy3AboySez+LduJTDPTYVJQ3Q1ZuNCuXNzY1ynxVNYj5R2h6YK0EnxRZcihEq6ZD4qA9bWxX5KjOj303IwrK2gw9xFlyKUQ6hvigxdfyGW4jEZoPun9qQrX4OMSCy6lPEDduY4Gf5FbbSCUQ3QkwVZ1GVtBgq8iCyF7KKbFEd7JviiytT63kKtAq+iSiGFXGYF8FxHhTrsAVpTNBPVzzwNK+XI4zJqxycRcyNl6N7C2/DpUdI/zidKHYZ/sIza/btTZuRbwLTeRDt94wFuwDKWA487ZTr2AD1YUITN9qSGlWpsJsgDlZWhhw3HwhYvo3BNJeE1p6aG9QDdP3EC2Al/ZV2VGDJeRu+qancovJQuavblGkwWi0Nb264H6P6JvUHPEsv7QefED9JPxuw8HzgQ0lCdi0pCjT99Xqn+0QIgf4hJbk5icy4e6/kQyoC3Agfa94B9hXtAxrpV/2CrxaqKJiy7ed80YMEMH3MmufPUaz0AhCoZs3N8224L+v3kbjTYfwGZbnS311gseeeKY96KZzIpHB7fFKHXekFcIdu4WYZuq4fgh2C9nY9KJirEm2wLVq71R6xx5To/tkXa9EJSJv+0zV22GSAy0q2lP5y0+e1PO2L+mQs2R3+NnJ9svTAsbf2sbzNAJc/t8PLTaY1a57HTmja9sGSQF9AJeppIHi651BC9zMUGiHUCymu9MFQGBTbbDFD6uFODHtnRA+mZLc2vpGnQC0d6B7aCe0APt3KDc6M/kQflmsR6xbzWc6D1Kzf4Vbi7W7Uh/Q1uuyVyMLk5BnffEfuw5bWeA60XO8gA9+/YhmGwYHqWY00isKAkC5H06TmnUANULrscV0GFohGZLJyRhRlkqWnAotKuFA7LSLteSLoUfNmb27+n+BRwu6PtcXDmgk31kSYA8u/JoF8v5ymHdOm18IvkbxoA7R6Cxu+gCRuQm2NSluPdyrjXegAorf8ZBA2D9gmQMd7WdLWixwNbQQbIccT1sNLZcDAAahIYVzsZZk1gq+2Jkm3sBpy/P68trtDV3hvYaTVARm1oQOXbBIeXzpD2yagNDWEGNLvA+pRcg3QiUhG8296ARj4G8ad0pja1yU9j+7XOdgZI0Vfnga1XQaDJSSqbW9robAAAlixP+ypO0pIuC22uhBkAaNW03Sj5TnmdmG9k/PqC0IPO88tN/pcwjJ3JjiiFKLYudcpw7AEAuvORcqAsaSGllg9l4sYnnDIirzA0NS3ENKcCNyQrqhRRi48lkTIj9gAA3TalFNU13seUQpQZMmXr55GyOzQAQLdMXo3qfG+jShmrZOr25zsqEH2RzTZfQBvzgEKvokoNuoP6W8OWw0OJ2gMA9MuxPTB8lUBn+VHyMFkZ42TSjqi/zMZkAIBWPJiDaW4BhicUWrIRavBbxVKy17tfZQPomoLuZFz5HJjsKrjks4su1jQpPnAx1hPiMgBAN03tQkPtCkSfjffcJPM21qVFMvNIXHMacRsQQNeOLgV9j/S/J9QCT0npwYqoJR1wbQCArrmvD7b1BiJzEtVyhbAR0zdfph84617CA7R8WAHIq6APeaEXvUKqMOVFeexQVfTCHePpVdOPh4wDWQw6Be//NPODbsY2lsncw7u9Ek1Kt9UP7s1B7FlACej9QBeXUo3AflQqwPhUnjgc09AWD0m/b/XdkdlkN4xFdSTKXcAghN4oN9K2In0ZoRblPHAM4QQiNTRkV8u8mhh+l7jOddzyHy094/fl/GVlAAAAAElFTkSuQmCC","1f925":baseURL+"1f925.png","1f610":"data:image/png;base64,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","1f62c":"data:image/png;base64,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","1f62f":"data:image/png;base64,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","1f644":"data:image/png;base64,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","1f611":"data:image/png;base64,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","1f62e":"data:image/png;base64,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","1f632":"data:image/png;base64,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","1f92f":baseURL+"1f92f.png","1f628":"data:image/png;base64,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","1f627":"data:image/png;base64,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","1f634":"data:image/png;base64,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","1f626":"data:image/png;base64,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","1f635":"data:image/png;base64,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","1f910":"data:image/png;base64,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","1f62a":"data:image/png;base64,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","1f924":baseURL+"1f924.png","1f922":baseURL+"1f922.png","1f974":baseURL+"1f974.png","1f637":"data:image/png;base64,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","1f927":baseURL+"1f927.png","1f912":"data:image/png;base64,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","1f92e":baseURL+"1f92e.png","1f915":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAyySURBVHic7Zt7cFzVfcc/v3PvviWvJOttEHZ4+EFpCimPMgxgaHCABIKncVpCMu20SWk6mdIZkikppiEzmbaQCTNJpp1CMlMKcXg0Th3A5pFAsTFgYqgDJrZlbGMjv2RjSdaudrX33vPrH7srraxdPVYrQSb5zhzt1b3n/M7v972/3zm/e+658Dv8dkNmu4P3D7+6LGy7l0f1jTY3GDgDdAnQAjQAdYACaaAPoRdlJ0g3Yl/HjbwknfcPzaZ+s0LAob3PXC4Sudsz7RcHMj8mIogIjgwR0vcJyTHCdj9hu5uQPUyeg7LIAVuAtQSskbMe6q21rjUjQFXl0DtPrB6WzttytDcWjRYRhJLjMQUcyRKx+4joLmL+Nhw9UakLH2QDcK985OFNtdK7JgT0dD/yjyl/0dc9WuKnGkk5w8sSAiJCRN8jZrcR87bh6tFKWm8kkNVyzpqNM9V9RgT0vLNu+UB6/qMZ29RiVRBRVBVHDBbFEQfHdXAcB2NMeUImJGMfdf5m4t4vEbwyGuiTSPA3cvbanmptqIqArVs11NWy6SEvvGQVJiIighQMNKZohMFqgOf5+J6P73nkcjl8z8P3PayCESEcieA4zgSEgCMZ6vzXqPNeJGSPnKpOHyJ/KYsf/+mcEHDgwFtnOsjmwO1sK97VSgSIGTVkpMPCsYhgrSUzlCGdTpHNZPFyHogQjZaQMoYQJWG3k/Q2EAn2lqqloN/Hhm6Xcx/PzRoBB/a+cbl1mp7DqQsbY5gpAaW/qvmZwFrL4MmTDJ5Mkc1mQCEWj+I47hhC4vbXNHobiAbdpeY8T3j4Jjl7w8maE/DenldWek7n45iYKRo/GwSUHqsqNggY6B8glU6Tyw4TjkQIh0MjchPBTppzjxG2B4vNtxLmWln8xPGaEbBv92tXBE7r85joGOPngoDSX2stQ+k0/X0D5LIZ3HCESCSMEUsyeJnm4XU4ejJPgju0XM7939SMCdi3b+uSwCbftJIInWr8B0GAqqJWUbWkU2kG+vrxrU88FseVIdq9R5nnbwF4llD9pyYbE8zExu+LauBuspIITUbUB4F4Ik57ZwcdnZ0ocDINe+0tHAj9Lb7WX0Ou718mkzEhAY5/+H9809pcM41nCSKGhoYG2js6SNQl6B0+kx1yBymW3aavX3XTRG0rEnBw54YbsqZrRe3VnV1EIhGaW1qI1Lexi1ulR2/4kW6+prVS/bIEqKoz7C54CJnQQT7UcF2XZEMjQw2fju2J31rx2aGshYd3PnmPb5rnzZ56cwcxYWzyknMOv7329nLXxxGgqiYbWvTl2VdtbpENn/UNVR1nr3vqiZ5f/efX/PjFUc31IF4KDQYRAvAzWECNYMVgRqa/ELhRTKge48ZwIkmcaBPiJubEsKnCc5oTh3c8cQfwrdLz4/IAffWqp4DrJhOoClYhCMC3YC0EgZLzwfPAlwi+acRGOnBjHTjxdpz4aYSTC3HrTsMYJ6/ADPKA4rFVRQvXrLVjSqncSNBz/IyzL2qpSIC+enUbaA9lPKNaWIVcDrIeZHNKNqtkvBA22kWkcTHR+cuINC0hnFyIFAbd2SIAlLrc1gs7l9y4tXjmFEP186jUzHgAIxANQSQE9TGBpGJtQM7bSya9h8HepzgxpAxrjHjzBSQ6LyTReTHh+vZaqlGAoNa9E/h08cxYY3X0Qs2g5P1MwRhBFYyBSBjCLtTFhLbA4vkZTqZeIvXWRo5usdjYIkJn/Tn17efSNL8R161NMuq7zVeU/j8SAvrClXVE3RPArKa9SsGlNU9G3k0hsIr1LUGgBNaSzSpH+iy95mJyrdeTbGikuaWV5pb5CKbKEADUMi/1dlv7R1f0QqkHRJzLUJn1nF/ID3yF6MaIQSV/LC6IUcQXYlFLV4sQ7dtC/7FeTNOXOXTwPd7Z1U1DYwPtne0kkw1VKGBAjn8OuA9KCRD5WOXV6anhjd0BDzzl86s9AQL8wdmGWz8V5rxF4/OtwrMgYkALcSLGQQKLoIgIb70b8OBzhu3799PcfC+3fe3vWHD6AjJDGfbu3oMNAlra2mhrb8dxnCnrad26qykQMBoCL1/zIPCFao3f8JrPnT8cxp5CouvAv34pylXnV1ZQtRAaFFw6UJ7eGnD3g94YedFYlK/8/VdYdt4yrLX4vk8qlWJwIMW8hjoWdJ5ONBadOASA2PCO7tOXXr0YxmSCsrjgoNMu/YPwrYdz44wH8AP45n8Nk8pQWYYIplDECCeHDPc84o2Tl81kue+e77D11VdxHIdQKEQymWTB6R24rss7u7vZuWMnqdRgRbIBAmdeW/F4lAClvXAbpl1efNMnna0cPwNpZfP2oGJ7KTbV/JrfS9t90tnysjw/4N++ez8H33wC13VxXRfHcYnHE7S0tTIvWcfBnoPs3t1NarA8EYHE48XjkmlQ6itaMAl6+yavc+REcT6sAC36g9DbX7mekJ9F/m/jWhY0ejgLVyFiEbEYYzHG0DS/iSAIOH78GL1Hj9LR0Uo0PmqemthIPJbmAXWTm1EebU2TLy22T6HOdOou7TLYQ09hDLgLP4u1grWjS3DGCMmGJNZajp/ohxP9dLY2YcIJVNwRzy/1gCkreCquOC9EIjZMOlM+DJJ1wmXnhqbcx2Ty5iWEy3/fxXWU/YfWI9bDOfMLI15QHACLnlFXl8Bay5HjfcSdQzQ1nzYiuGQMkBQqVFOSCcPqz8VwyqwuhFzhG5+PkYiamsm765YI9XGHSMhhUYeD9j5HsG8NbuE1nOO4I6U4RjiOSywWJ3Ab6X9/f1CUVxoCg0DTlG5RGaz4wxDtjQkeWD/Mtr35POCCsxy+dH2UcxdOfY6eSN75Zzl88boIy84wWNV80mRgYYdw4MgzeOEE4a6VBU+QsmFhreBK2Bb7Gc0DXvrkK6CXVEvAnEDyA6BqPnVC82mwDSx+APt7LdJ1M+6Ca8elxaqjx1F/f9+yC65pgjEhYLurnQbnrNj8lCkYTOEVmRHBGIeQKyxsM3BgDf6xLfkNGY6D6zqF0BgNhYjxRjZajIaAyi6k+oFw7iAlQ6mAgGM079qu5YxWw7vvPIBGW5D6jyBicBxTGBDzYRD20r8uSigdZl6vNhP8YIqBUk8wghFDKGToag3wd30XvP4R44wxIwNiKOjfMJ6AuNlEfk/Obwxk5K/J32ljMEaIhg1djYP4u76PWjumjYMP7sCasTIK0I03bAIum33VZwGiI2sNxQegzLDlUPhapOtPRqpFc++e6Fpy6fzi/2NnWqGqXRYfCqggOjowCkIsYmjLPQuDO0aqhf3ep0ubjSVgmB+B+B98fFdfBIPg5N9OY6iPQNPxh0E9hADHCd1davK4YV833vgkyPWTET4TWIVtezze3Oux90jA/qMBWU8ZyiquA60NDq2NwjkLXC5ZGubszmrWaXU0b0A5UrcSG1/03ulLruwqrTVeciDfxjArBOzq8fnxCxle3D5Mf6ry4/O7R4uZ6jCQpr3RsPrmei5dFp5Gb5LnQACF1tTTDDgrVpepNR668aZNaO0Gwz2HfL73sxQbt+cos0AzJSxsc/npXVVm6gJq7c/Nles+fuql8r5lg7tQeb663kahCo9uzHDfujS5U7b5JeOG9ibD/HpDIpo/l8rAiZTlQK9P5pQJeV5c8q+fqoFgxXJn+UuVlP/FJ38M/Gl1PYJV5Z/WDPHka3lLFrU5XLY0xEWLXRYvcGhJTvzqff8xy6btOV7Z5TOYUe74TJylp03/oaqAH8jVT36x3IXKBDy9ogPH2QEkp9ubKvzzTzKs25LjhovCrPyj8EyUnymO4zpLZXn5XWMTJv/67Cc+g+pj0+2xL618b32Ov/rjEJ2NH+gmC0W5ST7xzLpKFSZ9+tH1H/93hFtrq9dcQb4t1z771YlqTGGCdW/DDi8GltdIq7nCBtoGvj5ZpSk9/+r6i+cRRF8ALpixWnODX5KRq2RVDTZKFqFrL23FcZ4Gzp+RarMN4TX88HWy8hfvT636NKCPXVlHKPcT4JqqlJt1yM8xrJQbN0/8aqi0xXS70PXXRsj0fQf4MG2kUoT7OOb9g/z16+W+rKiIqtfA9L8vXIVyP1XkCTXGCVT/QlZt/Vk1jWe0CKiPXdiODe5B5JaZyqqme1QfJuzfLivfrPprspoorY9+dDlWvslcrSYpL+CwWj67bfNMRdX0ruma867A8lWEFdRwp1kBHrAetffKLW/P2PAiZsVtdc3vtWH1z1C5qfCyZToP8qXIoryCsBbHe0Ru7p7SVyDTwazHrf7Hx+JE0pdhuADLYoQlCK3oyKezAIMIAyhHQHYC3ahsJX7yZVnVk5ltHX+H32b8P7Op1a79UoobAAAAAElFTkSuQmCC","1f911":"data:image/png;base64,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","1f47f":baseURL+"1f47f.png","1f920":baseURL+"1f920.png","1f608":baseURL+"1f608.png","1f47b":"data:image/png;base64,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","1f47a":baseURL+"1f47a.png","1f479":baseURL+"1f479.png","1f4a9":baseURL+"1f4a9.png","1f921":baseURL+"1f921.png","1f480":"data:image/png;base64,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","1f47d":"data:image/png;base64,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","1f383":baseURL+"1f383.png","1f63a":"data:image/png;base64,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","1f638":"data:image/png;base64,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","1f916":"data:image/png;base64,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","1f47e":baseURL+"1f47e.png","1f639":"data:image/png;base64,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","1f63c":"data:image/png;base64,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","1f63d":"data:image/png;base64,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","1f640":"data:image/png;base64,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","1f63b":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAABGHSURBVHic7Zt5sGRVfcc/v3OX7tdvf7O8YWYY3uzDACMzgIAChihiUiRmELcYNSFaIqSwjIiaGCsRhQoaiFlKkwkBrVRpERRxiQtEhAEFnBkcBmZjNmZ/s7x96e577/nlj9vL7e773rw3Dkmlil/Vqe577jm/5Xt+5/zOduE1eo1SSTfg/V/rcKZoMlsktcKzzCgWzWGEl1TZZGCTNfYn2Tey+9VT88xR/hcsMZF5q4U1IqxBOc/37Vy5lJP1ZVMByK93rkP1+9L49gXgO4h9KHMFL5151U+fCk9zPtbcgHA9ygXJd6oAcl32quiH9fXcNGai+vrBPoegKHTMjHA9Lb9aBaxCzV8X1+vjquYf/Cuj74lgz7A9UyJ9EKc413m7Krdi9U1xZvV9FMHQSQfjQntXdAkwNQAwurKYh5FBYeC4R/ssy4zuEGMSwpGrEb26+JTZW3xS7vKi6H65mvCMWjgB6eO4gevcWBT9DKo99Y6qCv0nHPp6DY6BlnYLsDKNl0nLRGVlsRC/shZ6DzjseN5neCC1+EIV/deia14srHfeqZrerc4U5de7byl6ZpOi/4LSU/9+eMCwbZPP4b0uNoxVKRYMCCvS+DVYpIpYy0Ib1eaPjwlbN/nsfNElDFJtXA76YPCU/Cz/BEunYszQ95k59H1mTqVsfj3L8uudnwv20fo+DhCFsGeHy0ubfPJjtfrZCDRiURrfBkv0WWaMDDsneve7hAEERaFYFIoFKBaFQgGMA+ddVKRr5oRdPw/8rd9l72QlYd8jXC/GXNXcTTewFKXnyGbbaYO4sPHgrNeZfmAvwq6RYxxF7ZNdv8d3+DlOwTW3CHwRaE4T1n/C8OIGH2shkwHfV/zSr+crrgdzzglptlGHXMPgpAAUnub8woiz5dihiQEoFIQggEXLQ5avCjBpDiGgcPzYVtsVFnE6Fwq5GdWCx7ZagrH4v98Ms86tOuNYn9K/R3F8otkrzQmjdKcZbhV2bXXZtdXDdSGT0QkB6J4f4meilZk3sS3Jo7ELWHeO6hS6sSrbNrs8/sMs4+OJ8kI8tLpgLbPCIo4IZDtqeTp+9dl4te+yHYIIREUclG68Es9EsUJeeOLHWV7c6KFWORVZFazjzqnPbwBAVFt0GkHteK/hR9/O0H/SgFOraFSKCZl2wTi19ZxE/HH8OqVMXAcgCsqKlXg7MNBn+OFDGXoPp4/haaQWRLWhCzWGQUNmIkC9jNLZbcm1WZqalVyz4paUj0Ia4NQwZtTU0cjLJIx2UoJxtgPyA2BDpabpDeTaLde9rwAKYRHGRoXxUWFsyDDSnw6KtSBKpj6/QbRAVm1jF2ibaelZGeK6KegoNLKOR1+AbHsjPycxOzd+w2ua2oUBlPpoBOBniYO9gJ+BXGtZp4gwEPZtc8kP1wKhChiy9bwasVcyYhqNHDpheP7xDJ1zIhYsC/EziTITDBlqwcvFo3yD4ARgbgoAxgOvqTyNTaE6mcWC8MoOl4FeB8eJB8GGKike0OgvQpRmj+cprV0WBI7ud1JKNJIqZNrS0UkOgsn/Scq0CVOdZB/d7yAGWjttcupeodK6pmGm2uABqgzVL4Lm9ITMmBed1hQv05Kenxz4nJTWAsi0ktoF0mjB0qptqnDykEPfkWpDGQMKw/X1UgCQIanzi979LpkmS2vXqcMNAKMGsy2Lf8DgKtBTRJcHSHO1vphq16gHXEcE2emR3esTGjBnR9iVBchNzR1G+oXe/S5ewhNEwKoM1ZdtAMBxwiExtdlq4ZXtHuddVqQenBoqCM63OnF+2hb/V0sURVgbYU2AXj2G86HxChD1fV9HhHBdFnm8GRcPYxyyxsEYAxkletsQ0bv7wZ+4IVRjXakrIhLbdkoAbMSgONXaLZ2W2WdHuKFgnm5GDvrggM4vYi8cr7bKmMH7/BxkV9KfBREBBAJD9F8+wa+V7D15pFNxM9Wm15PC+CeymCMZPFfiOQWU6pfAfaQdszVD8LleaCrJHTWY55uQwz5EoGcXOX/1OIGrHD/gUBiN6xtXUZlCF/ANB6yrleBbOORgHm7BebYVo05VIYCsJVo7SLR2AHfdzDrj00iw+w1jd7o0fymo6fujX3ThgEnMCaRWVjn35SzuuhmEf3Yc5+EOnIfbIV91S1VFJEIvG6Hw+jGIl8I4jqpf4OApAZArGC6s5yjCWd5Rw6z7WjF5DzUKTt2kJG9wvtmJvNSE2dIQYlMo9qzgOSF4UXDmlJ5fgHAjuG7ScxVVLdWpBcKsb8EdcDEvpMvUUJEns8zb4NB74zCcbTEOh+RKRurLpvZoQXd4EXTc72NGqCiiEwRl80K2oc9BXC9Zt/QPUIrrFS8DblYorC/ZqQpaKydVpDKx8YkKZgi67s/ghrFNqbqnZVpkR+YJwZwEVVsxRHViEFK1JFnP1vCKDoKTEVwf7KEYmHo505VZlVOtZ05A9inBIlMHAGWH+ZWi1saphqkltbnryFrFWlurlE0YFSqOG68DbDEJUJystTWgTQ2AqjxrLVbjZJ4DYOoAqJrN9pDGDKyNw5i1NWkypWwNaAkeWgXU6SHu2gJuTwkwTcjUJHhx3kTAq2pCr3L5OPyqtegRRbEvTBmAbHP4jFJVPCr9Vo2pglLrqlXByXJRxfioYmDmEsq9hMwlpdarq1fPxzZ4o9a8L+tXmXsk6mWbeC7N1vRt8YsZ611hA7sn8iIRJBLKM1JjHEARMYhoTahKDngV46MIW0plIJ0exVtdxd67WDALLPagRWyEFVOSWeUtYihHhHqZyQaIohjwqARgZC1mblSUixmbsgfoU7R6V6qxFSaxIVEUllJUaaHk//jZJspGRDasUchaS8tNJQPKUQ5ouUlKvGypfJiQF1Z4J2XVptrysQ7xO/8qNfo4qauSVAACzPuabhBH2xOG25CwwjwgjIJKfo3BUVBKCeWjMPYCG+FfAf4bGyc4mSsF/41Sa0CNUWW+USJV34dhSBgGdTJDtCMke4O4gee8e+oeIHzYNEPbpwUrJWXCkqBSisoCw4AwmcrKRGEJpCqAdFlab5dqy9el9k8J0qWl1q6Vl+RZI6+kR6VBEuBbE9H2GcHkQOEjabY27go/ySqM2Vx+zj+mDN+pSOTgOA5GDGJM/CuJuX55ilMeucthqNRN1Cid9wre6skX1cFGpf/PFVGJ5ZlamYggFbXLMi1qtSIvXnxFtH1WyPx2Qp6152WuYmtSXsqeoHlHcvqVfTM43cLgX0WEfTZWyBqsiY0XJF5qaUkdjcNZMvwBtN4ieBcyyRZPTN4aaL1ZGP4nJQxDjFGMMbFMiWVVBkFNTqCqYZAuS8cdgndenTzDO6AWgEYPWC9bgPPr8+0gjHxFyT9GpeXjSFBlUx8FytR0HbHrT4OG71LGf5TQ3ZhawEtUO9NUsm+FllsF05bK9teZK3V1MqNGq/wTLBUjOydTrPg0DP+jEh2emiHeGuj4kiDTvG6hAQzcpgTPT628Mw9abxX8y0/B1+iS5D2HmkFQ4B0TDVDl5L8Bur4uNN8oyCkWgG4PtN8hiDs5z7QkblzXWTC5DMlC858KXQ8I/mVT4B2yts7mKhWelF8Ap8CwSvYEjH5dGf8BDZuXph06vyo486p5A32GY4cd8mOGMISgdMjqeYrrQjZnmT0voqOzyiw6Cv03Kba/TriB7DXQ8hHBzJiqxqDwdPYqvaL8XAFg4Ad0uo4ctxanvBFZHj9cD9wmau4HJCl8BUa+phR/WWKagY57Ba/uRP6XP8tWjJ6IPF+5/Op8TV6wAwY+pmgp27sIWj8quEvSeVgL4TiEpVOl8pBhHDAOYTCuszrXMgCJKDA2zC35k+pAvELLNEOmVci01B5ipJF7DnTcJQQbYfirSvMHG42H+KJC/4nJt9Rb2xs3Pr3l0P45YWRdzDvzW5PrY0x84OoEUBiB/JBSGK0c1bm5GdwM3AkJAHxXVvvd8Va0n6G2c0xxC8BbA13rEtPcOlp6bsDzz5gJvcD3lSXLg9S6/uXQdfnEvNPIcSHXAbmOOEwXC1AYBiyry0wqTi3CCseLd4DD4JTh+rQo26S87vVFcs2NrZxrsay6pEg2d+YFq5ZssrE3G696W6TiAcPH9dz6QwjHBePGlVwPHE9wvPhQw/HBmdoBUQ3lcpbVlxbY+7LH0cMuotA9L2Th0iDmdxr2RxFExfgkOf5VwiB+tmH1lLpM4nBe+X8FAMdjyEa0VwqVZrjGlAY/AzggTiIvQR//6rkUQ8OlKwZZs3SQcxeM4KScMUIM3JIVAYuXxaPUpGcNQGSFF/e1smFnO7/a3k5TJuLej1bvORgDasCaEi+TyCtPVBOquF71lkgFgJZO7hBXvuy4cWub1J2COkowfemVVgZHXTbsjDFszkYsmjPGorljLJozzqKzxpjdXqCrLaAtFzeJSC2foTGXviGPY4MZdh/Osbe3id2Hc+w5kmOsUHW39uawRrYQH7K4PqVLNI1jjA3jbhCFEEX6+QYAOq7nnqFH+LAqy+U0XHt2R4HBUZeP3X4bx3uPsuXXm9m+dTtb9rWmlm/ORhUPiawwmk8X6nkeK1au4IILX8es7jl85e4v091ZmLZ+4oAWAcu2rrX8fTm/egwhaN839RODffxAJA4j2WbBbwbvVOcdwJqlg7x8qJmhwSHe9Yfv4YM3vh9syP59+9izZy+7X97N7l17OXK4lxMnTjBaG+rxfY+ZM2dy1txuFi9ZyOKli1m0aCELenrAuIznA777ne8BcNGSwUYFUigoQHEU8iNKcSy+U9TSwW0iVf9p8JWhR7gTkc+Un62NJxB+dvK+umVfKx+69wJmd3fzz//2NY4dPUxHeyuLFi/Acw1GareyioUi+ULcktlMBj9TPSjU0oqyGERs374Lq0J7xwxu+dBNHOvt5b6Pb+H8noZTrmp9C8V87PbJqzlhpJ/qWsvdybINPb3t7fxF4b9lDuifTGxuI13QM8xl5w7wzDZ4YN19nDx5kmee/iXd3bNZvWYVS5ctZsnSxSw4Zz6dHe20trXSVjLaWsvgwCD9A4Ps2/sKu17ew84du9i4YTN9fX1c+zvX4noex3p7uWTZwKTGQ9xQmVwdKMjX2t6sdzeUTWOgD+IUO839iL5/OiDsPZrjA19eRRDFZ4jJJXEatbTE23QjIw0nVjVkjEFV8ZyI/7h9M+fMHp+OWoB8y3fs+9Ou8k44MT9dEJ7YMoNP//sybMpVu4wRLunKMT/rk7fKpoF4o/aiziYyYjiYL/KrvjEKKbe0jMAXPriTN194YjrqAPItv8/+kbyL1KsWk65M9EGcoMPco6K3Tkfk957t5ksPLaQYVgeNd85r4wPzO2n3Jg/6A0HENw4M8NDh6lG+71o+ecNefv/S3umogSD3ev32kxMZH5eZAhV+ynsR1jHBVdU02n6whc9+YxkHjjcB0GzgylaXNU2GxVlDtwumNChaVXpD2J23bBy3PDUcMlrqPQtmjXPHB3ayYv7k3aSOxkW52X8rD5yq4JT3qQqPsQrLN5ng2nkaBZHw6KZZPPDYfF4pAZEUnCttIoxhGmbAc7vyvOeqI6y9/Ci+N63PEbYivCdzDVumUnhaG3W6Aa/Qx80CX4D0g4Y0sips2dfKxl3tbHi5nYMnsgyMehSCuDtkPEtHc8D8mXkuXjrIRUsGuaBnGCPTWhiMo9ztR9wlv8uUZ0qndbc//xiLRPk7lLefLg+gMr3NZaZ4FSydFHjYKrc1Xcve6Vb+jT5uKPyE8xFuR3kvE3198uqRBb6N8jeZt53+90tn5OuO8UdZIBHvBP5AhDcw0b2D35wihV8gfNcq/5m7lgO/KcMz/nnL8E+Y7cGlKMsMzFX4Y6DrNNn1Cdxv4QjCjgCea72WY2dQ3Vf3+x4A/TFdAfylwo1Ayr3xVBoQuM+DO+Vt9L2a+r3qAJRJH6Sp2ML1CG8h3npfCJRXQAVgL/AMwqP+EA/Lu5jufPf/H+kjtOojpG8YvEav0f8K/Q+kiuQPPob6SgAAAABJRU5ErkJggg==","1f63f":"data:image/png;base64,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","1f932-1f3fb":baseURL+"1f932-1f3fb.png","1f932-1f3fd":baseURL+"1f932-1f3fd.png","1f450-1f3fb":baseURL+"1f450-1f3fb.png","1f932-1f3fe":baseURL+"1f932-1f3fe.png","1f450":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAA3CSURBVHic7VlrjCTXVf7Oraqu6nfP9Lt6xmuzO94HOIiHFBIlZnbXgG0SfkRkvV4bREiMY/FQYJFQfiAs8YcoikBBITIKWVuxd9drIkWsZCvxenZiI4iAJApkX551FpOZfkz3vHr6Ud11H/zo7pmq7pnZtYl/0Z+mplvn3nvuPd8599xzq4ExxhhjjDHGGGOMMcYYY4wxxvh/B3onnRcuHHsKCn8JhSCB/slkrd+dPvGv7fdqcXeCW2dmLRHUziio3wChAajPzjxy+at3On5XAm68MHtSN/RPSKEWCe7TEtqHDSPw5ampQkzTdFSry+3Nev07+6/PPUBPQ/5kzHlnUE+DvXXk2KvRcOwD6Uw6yLnA0tJinXf4p4jx75Bm/AUAW3bx1ZnHX/vHnXTsSMDC+eNfCJiBJ1LJZNTturK6Ul2FUs3p6bv2maa51a+4VGy02q1nZk7O/el7Y+LeuPni0c8Fg+GnbNuODmSO42Bx8ce3QBRNJVOTRsBgK7WVzW6Xf2nm5KXPDutgw4IrF35tkgifnJ6aioZCIcQTcWbbdlJJTCulfH3zdi6i6/oT188ePfGeWLgHFp4//psaMz6dz+ejw21KYp+dzycTiQQLh8KYnp6OEqmnbp2ZTQz3HSGASZ7SdZ0TbQdHKBiidCYtarWqUtgmgYhhamoqpmv099fPHn/fT868vXHt+fvvI0N9ZWp6KuZdJwDUalWVSqdEKBTeaiAi6LrGeZAlh3Xpw4JyVvxoehnNTsdJmqa1JU8kEkan00GtWkU6ndlWoOuw7UK8uLT0zRtnZ+87eGq+ttfi1YWPawvd6kNg6ggUfUtppCDVAwq4cvDN+W/dLp9ce+540jDwTTtvx3Xdv/zqchWGEaCJiQnDK+90HHAumgdY8r+H9Y1EQK6MDwkpriwuLjWEEL62TCYLx+lgY2PDJw8Gg0il00mN0SuXL8+OkDrAjbOzqZui9gMzZJ2Nx6N/BcIbTKo3ErHI54OW+eLCwWPfv/bc8REvDXD58qyuW+rlZDKZCoaCvrb6xgacjoNMJuuTCyGwuLTUEFL+15ti+YN7ErDw4rG/tozAN9LpzINBK8iKxaLw7nsiwLZtrK2uot32n37xeNwIR6OHpyrsyzst/taZWYsx9vpkcvKgnc9E47EogTGAEeKJGNn5bCyVmjysm+rbCy8/ZO6kY7qifSkSjhxJJBI+D7cdB6tra7DzNrw7QimFUrEkLNNi6VTy4YBuXrx5/ujndiTgzfP3H9YY+519+/bFJxIJsgt2yDQtbbm67FuEpmnI2wWUy2Vwzn1t2UwubAQCJ26e++Unhhcvgux0JBK9O5GI6yBClwsQ1E0GuuW6AiBCPB4zotHIPdhof2Z4/MK52U/qAf1kNpuLeOWcuyiXSsjn89B0zTdmebmKgBnQCoVCaGJikvbdvS9OTHvy6gv3z4wQIAX9TCgUJm9SSWdScLsu1tfXfYpNM4B0Ko2lpSVI6Y+QKbsQI834/MLzs7/kG0T0R8nkRBAgEAhu1wWAOUFqvuu6IBAAwmRyMkSM/bF36Jvnjr6fafoXpgpTsWEPLy0VkU6n4T2eAWB9fQOu20U6k/YsgRAKhaCTtpWwtwjQNO17zWYDvpAHIW/bWF9fR6vV8k0QiUYQiURRKZd9ck3XUCgU4tDZxevnfsUGgBsXjhWIMVPXdRARQATXFW0l5Q8lV//pum4HRL1srekgYtaVC7M5ALj6tQ/nieiibRfimub3cLlcRiQSQSTiCwq0Wi2sr68hb9t9YrcJa7WagNK+P0LAzMm5t6RSZ8rlcsNnEGOwbRuVSgWu6/omSiYnAQJWVlZ8ctM0kc1kJzQSl26dmbWYRNbQ9K2MSgCklBxgdRBtKqlc72Gma7owXOQWXn7INAzj1UwmM2lZfg+vrKwCCkgm/TnTdV1UKhXYeRsa8+f4cqncUArP3fvYpR+NEAAAB67NnW62WlfX1lY7XnkgEEAmk0GxWISU/lMql8uh0Wig0fDxhmgsqsXj8X0iqD3LhSL/eb1TAeqRaYyISaJN90wsFr8nFov5XN/YbKDR2EQ2l/NpkFKiWFxCJp1BwAz42tbWVjutVuvafpr8E698i4CFs0d/+ubhY28TqcO1ai3QbDR9ZV84HEY0FkOpXAJ8JwOhULBRrVbR6fh4QzqVCpmW+SBjdFY39G0XEkAaCyiSk0whQUwLeO03A4ahoJ01zcDDmXQq5NXZ6XRRrVVRKBTAmC8hoFQuIxqNIRwJ+9bRbDVVrVoLKFKH3pIrb904O3to0LZ9ZmvsJTufmwqFwnDaDkqVkioECggEtpmcnJhA2emgtrKCVCq1Jdd1A7l8HqViEXftu3t7YUQIBq045zye9PQHgIChm4y0I9CgBwK6z12Tk6lIu9U+FAoF4T3XpFQoFZeQy+UwXATVVlagMYbJyUmfvNvtYnl5GdPTd5EVtKLNViNSLpZfAnAf4N0CSk2HQiEAClbQQjaTpWKpiOFiKJvLotVqoV7f9MmDloXC1JTfK+hl41wuC92bwBRg6AaI4ecYo581dB2eChu6xpDLZrC+vuGLNsYIhcIUgkF/EbS5uYlWq4VsdrQIKpaKyGayZAUtAArhUJgUcPeWzsEXIiy1HWdrcCgUQiKeQKlUhr/+J9i2jZXVGhxPfwAwDF99gk63A8YYLMvCMIyAASUxoxQOGAFjpN0KBkFE6A4l3uG+juOgVqvBtgvw5hkFhVKphEQ8gZ5je2g7DsCwOEIA5+KpcqlcF0Ji4I5EIgEjoKNWrfom1XUd+VwepVIJnPsjxAvucgSDFoYukVBQ0DUGgOJKyajGmI9koOd4y7Lguv5iy6efC5T6RZA+VATVqjUYhoFEYnABVBBColwq1wXH748QcOixb18WrvybSrlcHwwAgEw6C6czWv9bloVMJrvnKyWlFHTdGJENGNEZcV3vH49KYfi6bRgG1B53IyIgk8mMRNhGvQ7H8d4LenrL5UpDCvG3h07NzY0QAAAHHn3t6Xa7/e+11bXOYCARYOd3rv/D4dBI+ekxFZquecJS+T6VUiCdGYahGduGD3+inzuGQqgPTdMQDvszfrvdxtrKCmx7cC/ojV2trXadTuvf9j8y9+fe/j4CiKAUNz+2vrZaaTVb/XUpaBrbtf7fzXgAMAMBKKl8Bqi+p5VSIEBjxHSvzKdDKc8ptDMJXnDOUS6Xkcvb0DQGQEEpoNVqq9X1tSqBfYzIr2jkOjzz+Ct1pfiDpUp5w3X51v41TQPpdGok8e1mPNB7YcI070Eje6EOBSUFmILGCLqSopcDlOr1GSyuVxbvqHsnOI6DdDoFywr05+uRUiyV6uD0q/tPXNoYHjNCAADce/L1a5LTp4rFpY2eZ3rKenV3uL+Q3R7As81hmqbP60opQEooJcGhJJdCKCX7Mn8/0zRG9O01dyQSRiQS2eqvlMLS4lJdSvHkzOOvXd3J1h0JAIB7T136uuD82Uql0hg2bDir796mEAoFwV0OqIGBElIKKCmguHK4y9tKiJ6s3wdKwnVdDOqSvefYrU2hUqk0hODPHXx0/sXd7NyVAADYz5Knm83mlfX1ddfr4eEJRxfkjQYFXaMtw5SUUFJACA6hBLqugpC8R4iUW0QZGoM/OY4ek7uRDihs1DfcZqt5dT9L+q7W74gAOvGS6DLj4dXVldr2CbBX+A+T1At12f8upYCUHFJwNJuOJOAVIvVqq+lIKXivbRAJnvGjxO49t+M4WKmurkohf51OvLR7oYI7/GVo4fyxnyeiuenpqXjvTr/H0H6SG5zr24+AFD3jBe+iUmvUpVLvFwx6gOifMxORuGYEwDS9n/x6R+jgAfVepPjeeY1MrcAFx/+8vVjnQh47/Njl797Otj0jYICZk3PfU1KcLhZL9Z6nBvtY+h4pBWQ/zGXfez3Pc0juQores7HZbhPDswdPzV8/cnL+h1Kqc/Wm0x60S+5CSr493qNz13llj+BiqVSHFKfvxPg7JgAAZh6d/wfO+ddr1ZXGYL/2DO4/WwsTkIOFib7hfNuwdrsj2h3+ttZSfzbQHYlET7cdd7HtdIW3b+87788lcbt5q7WVlnDFN2ZOzX/lTu26YwIAoMuSn262WjfW1tYcKdz+fha9x7O/pXAheBeC9z4l70LwLpyuq+qNbk3COH7PJ+a3Cgr7oxdbBHl8veGsdrqu8o7Z0iF6ZGzlia15e/Otra05zWbzeocmR17I7oV39OswACw8/1AMuvMvkZB1IB4Lm/730L1/g+NO9Y87AHC6XNU3u8vg6kMHfmv+5k66r50/fq+u5BvxWCBtGXov0zCt9xDrl9U0+BtMh416o7PZdG6SsD448/gr9feUAAD48YUPBNvSvGBo+v2JmBXTPdXecDUHABuNTttxxLLg4uih33791l66F84f26+UvBwy9VQ0HAh6r7hEzJcEuZBYrzt1LuTrFmufeDc/1b8rAga4cW72EQb6omGwYDhoRA1NA2ODbKzQ7nC33XE7UHQuHIl8xv7oxdbttQJXLsxGApK+CIWPhyzdsixd1xkDESCVgsslWo672ekKRwF/uFehczv8nwgAgP945heMaCzyEQ30e5LofUoiTgwuQZUIdLEr6O+OPDb39rvR/eYLD/wUMfEHgPoIQFkQdChsgvADJfBMvVG/+ItPfte9vaYxxhhjjDHGGGOMMcYYY4wxxhjDg/8FF+Go1eeocVEAAAAASUVORK5CYII=","1f932-1f3ff":baseURL+"1f932-1f3ff.png","1f63e":"data:image/png;base64,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","1f450-1f3fe":baseURL+"1f450-1f3fe.png","1f450-1f3ff":baseURL+"1f450-1f3ff.png","1f450-1f3fc":baseURL+"1f450-1f3fc.png","1f64c":"data:image/png;base64,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","1f64c-1f3fc":baseURL+"1f64c-1f3fc.png","1f64c-1f3fb":baseURL+"1f64c-1f3fb.png","1f64c-1f3fd":baseURL+"1f64c-1f3fd.png","1f64c-1f3fe":baseURL+"1f64c-1f3fe.png","1f64c-1f3ff":baseURL+"1f64c-1f3ff.png","1f44f-1f3fb":baseURL+"1f44f-1f3fb.png","1f44f":"data:image/png;base64,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","1f44f-1f3fc":baseURL+"1f44f-1f3fc.png","1f44f-1f3fd":baseURL+"1f44f-1f3fd.png","1f44f-1f3ff":baseURL+"1f44f-1f3ff.png","1f91d":baseURL+"1f91d.png","1f44d-1f3fb":baseURL+"1f44d-1f3fb.png","1f44d":"data:image/png;base64,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","1f44d-1f3fc":baseURL+"1f44d-1f3fc.png","1f44d-1f3fd":baseURL+"1f44d-1f3fd.png","1f44d-1f3ff":baseURL+"1f44d-1f3ff.png","1f44d-1f3fe":baseURL+"1f44d-1f3fe.png","1f44e":"data:image/png;base64,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","1f44e-1f3fb":baseURL+"1f44e-1f3fb.png","1f44e-1f3fc":baseURL+"1f44e-1f3fc.png","1f44e-1f3fd":baseURL+"1f44e-1f3fd.png","1f44e-1f3fe":baseURL+"1f44e-1f3fe.png","1f44e-1f3ff":baseURL+"1f44e-1f3ff.png","1f44a-1f3fb":baseURL+"1f44a-1f3fb.png","1f932":baseURL+"1f932.png","1f44a":"data:image/png;base64,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","1f450-1f3fd":baseURL+"1f450-1f3fd.png","1f44a-1f3fd":baseURL+"1f44a-1f3fd.png","1f932-1f3fc":baseURL+"1f932-1f3fc.png","1f44a-1f3fc":baseURL+"1f44a-1f3fc.png","1f44a-1f3ff":baseURL+"1f44a-1f3ff.png","1f44a-1f3fe":baseURL+"1f44a-1f3fe.png","270a":"data:image/png;base64,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","1f44f-1f3fe":baseURL+"1f44f-1f3fe.png","270a-1f3fc":baseURL+"270a-1f3fc.png","270a-1f3fb":baseURL+"270a-1f3fb.png","270a-1f3fd":baseURL+"270a-1f3fd.png","270a-1f3fe":baseURL+"270a-1f3fe.png","270a-1f3ff":baseURL+"270a-1f3ff.png","1f91b-1f3fb":baseURL+"1f91b-1f3fb.png","1f91b":baseURL+"1f91b.png","1f91b-1f3fc":baseURL+"1f91b-1f3fc.png","1f91b-1f3fe":baseURL+"1f91b-1f3fe.png","1f91b-1f3fd":baseURL+"1f91b-1f3fd.png","1f91b-1f3ff":baseURL+"1f91b-1f3ff.png","1f91c":baseURL+"1f91c.png","1f91c-1f3fb":baseURL+"1f91c-1f3fb.png","1f91c-1f3fc":baseURL+"1f91c-1f3fc.png","1f91c-1f3fe":baseURL+"1f91c-1f3fe.png","1f91c-1f3fd":baseURL+"1f91c-1f3fd.png","1f91c-1f3ff":baseURL+"1f91c-1f3ff.png","1f91e":baseURL+"1f91e.png","1f91e-1f3fc":baseURL+"1f91e-1f3fc.png","1f91e-1f3fb":baseURL+"1f91e-1f3fb.png","1f91e-1f3fe":baseURL+"1f91e-1f3fe.png","1f91e-1f3ff":baseURL+"1f91e-1f3ff.png","1f91e-1f3fd":baseURL+"1f91e-1f3fd.png","270c":"data:image/png;base64,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","270c-1f3fc":baseURL+"270c-1f3fc.png","270c-1f3fe":baseURL+"270c-1f3fe.png","270c-1f3fb":baseURL+"270c-1f3fb.png","270c-1f3ff":baseURL+"270c-1f3ff.png","270c-1f3fd":baseURL+"270c-1f3fd.png","1f91f":baseURL+"1f91f.png","1f91f-1f3fc":baseURL+"1f91f-1f3fc.png","1f91f-1f3fb":baseURL+"1f91f-1f3fb.png","1f91f-1f3ff":baseURL+"1f91f-1f3ff.png","1f91f-1f3fe":baseURL+"1f91f-1f3fe.png","1f91f-1f3fd":baseURL+"1f91f-1f3fd.png","1f918":baseURL+"1f918.png","1f918-1f3fb":baseURL+"1f918-1f3fb.png","1f918-1f3fc":baseURL+"1f918-1f3fc.png","1f918-1f3fd":baseURL+"1f918-1f3fd.png","1f918-1f3fe":baseURL+"1f918-1f3fe.png","1f44c":"data:image/png;base64,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","1f918-1f3ff":baseURL+"1f918-1f3ff.png","1f44c-1f3fb":baseURL+"1f44c-1f3fb.png","1f44c-1f3fd":baseURL+"1f44c-1f3fd.png","1f44c-1f3fe":baseURL+"1f44c-1f3fe.png","1f44c-1f3fc":baseURL+"1f44c-1f3fc.png","1f44c-1f3ff":baseURL+"1f44c-1f3ff.png","1f448-1f3fb":baseURL+"1f448-1f3fb.png","1f448":"data:image/png;base64,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","1f448-1f3fd":baseURL+"1f448-1f3fd.png","1f448-1f3ff":baseURL+"1f448-1f3ff.png","1f45a":"data:image/png;base64,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","1f448-1f3fe":baseURL+"1f448-1f3fe.png","1f448-1f3fc":baseURL+"1f448-1f3fc.png","1f449-1f3fc":baseURL+"1f449-1f3fc.png","1f449-1f3fd":baseURL+"1f449-1f3fd.png","1f449-1f3fe":baseURL+"1f449-1f3fe.png","1f449-1f3fb":baseURL+"1f449-1f3fb.png","1f449-1f3ff":baseURL+"1f449-1f3ff.png","1f446":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAi0SURBVHic7VtbbFxXFV37nDsPP8ZJGjtOpk7SxnWcyKAikABRJGLTH1SCkCrcxIFKSEhAPwCBEKrEIyUfVHxEQip8IP4QcVskJBSUkrRKnAiVjzT5ABWwnagQ2bEzfs34NTP3nrM3HzPjedp3HHtmItXLOhp77j7nrL32eZ9rYAcfblA9Khl/feDjIvyKCPpB5EDkplLqXM+pq1fqUf9GqLkAo8P9nwdwydFat0UiGkRYWV7htJsmEvrW0TPXfltrDhuhpgKMX/pCiOPJD0LBUGdXV5fSjgIAiABT0/dleXnVg6YjvYNXJ2vJYyOoWhbOi6sDAA60d7SvOQ8ARMC+jk4ikQCMvFBLDn6oqQAk1AcATU3h0idwHAfBYNAK8JFacvBDTQUAqE0pZZXKVUMo7HVKaUXEu2rLYWPUWAAABMn98iii9gIAeFSdB+omwKOLHQEaTaDR2BGg0QQajR0BGk2g0dgRoNEEGo0dARpNoNH40AvgNJoAhEL/Hj5xQgOfZYZHSu4r2/znnq++tViP6hsvAPCcEjxHpKx2IGzZYZ1Kj17oP7+0tPizvcGIdoM0AMIxEbFEuHV0bORdOgvejsobKwBBRVojvOexPSocCmkQwRgP8XgitDC/8KO2tsiXPME+QDqAzFEaAIz3nrg7/rp6aTtOlRsqQGdnJ4LBYNE45DgBtLe3o6W1VU1OTBwPh8PY274X4XAYgGB1NYm5ubknUunkX8eGT/xShJqJsF+EZ4TU5d7Ra3/ZTOuo+qTiX38YOKzBX4eSj4LVLpDMENE4WG5MRjHS3z9iSvOMDff/nBS9/FT3Uw8ltDEGjlM5aywWQzweh9baBAIB8own1liHhG5bJc8fPz3y32rqqEqA0Qv9LwHyK0VEoVCIlFbKGmbXc4WZNYFiLPxa2obOP/3ilZVcvq0KsCFEkEyl0NTUtPbV6uoKpqYfGGvthNHBT/QNXp73K8Z3Ghy9cOLLgLwWibQ4hw536Wh0vzpwYD8OHupS3d1H9MGDXYi0RfYpUmfDAffOfy4MDGzRtepAVOQ8ADQ3N+PQwS6HgIMBk/5JNcX4CkCEc+FgUNr37oYiAiCZm43sWWc4HEZnZycOPXFYNYebOgj27dELn3tFztZ7jZHhEwgEsHv3bg3gm++/+ZWgXy5fkgLqCYWDSiRfiSCrQQGCgQCiXY/rPXseUxD66XjvwBsQDm3Wja1CBGhpaYUATY6NfcrP3j9KJG8lFlc4Hl8CixRKUFhtxhSEjo527D+wHwA/L6DvPowTW0UwlA280BE/W18BIi2RMwB+HU8keGJy2rjpdIHvUmYvArS1RRCNPk5aaacp3FyHriBrdQOAVgpExAAO+OX0JRc9eXG1d+jad1jUJ61nPpicfMBLS0uASEk3KBajpaUZR7qf1NHogRoLUB4EQKC1tiKydQFyOH7m2q3WSORjgAzHYnOYX4ivU3k+EkQEovpcipSOSY7jKEUU9cu3qehET15c7Tk98jWQnJ+fX8DszFxJzZWjUTusX5/jaA1Cl18Jm26eRJDeoes/APByPJGQufnKa42Nusf2IF9mafQBQGsHADr9Snno/tk7NPIqQK/Ozy1gcXGpCmLbKYJ/HUQECLX4lbSlAero2LUfE+FiLBbjdDpdJcGtCFGcf32BBUoRhKTZr8QtCUBnwZ6DIYjcnZqatrLOeFDeRB9GhOI8G7UuEcnsnQWlb2aUYctTVN/gyDIpdcp4BrOzcyVP/UQoTNU/93VeBGABAWU71FJsyxzdc+rqbRb5RTyxIMlksuRpsQiVBqy83UaCVMov5QaQ7A8DhDR8sG2LFBvoOAehsdiDGStc6kB5BNcXohyV7cudFwhEGBCB8QwgNOVX9rYJ0Df4RxfAN1zPVQsLC5AyxpWbcjXJv5yc85JdoQpSrmtY+LYf721dpvYOjfwNoN/NLyyw67kVRAAefiaonE9yzV4YEIaIgJlhXKOI6J9+pW77Ot1x9A8hPDvzYIYzhLgi8a0Mgrnnead5LfIiglQ6BYEoBfq7H99tF6B78J0EgO8lUykVTyTWSOUitT78B8GcXWGZ5YmRSqYAgmmJtN7041uTndrRoevDIPn93Ny8pJPJoubpL8R6KBByLeoMQf5vEYawRSrpMgluRk9eXPUrtWZb1ZQX+rYAo1OxGeO53lp08kIUCCKl0ZeiJp2zzTtaKoasOW+tQdpNA4RL1fCsmQBPv3hlRZH6Ilv7YHJq2rhpt8AZriBIeUKJbcV8nHE8l9LJFASkxMrlhgoAAD2nrt7V2vkMG3NvcnraeOl0kTMoc640lTTvoogLRCyYs8lmPldTLoiwcPTO9VsNFwAAugffuec59Axbe286NmtYbHnTFc5EstLvlWzFgq2BWFsUfWGLlGeMiLxd7e1QXY6u+wZHpoXoBc94enFxOUu22MlMc86mor7PRc2crV1znNnkWwBbGM+D9dgB0Y1qudXt7P7Y6ZH3wOrdpaUVKzZPei16UpJyDufsbN4+53jGxkCsgbCFayxAAFuuWoC6Xo4S8RueK894xoXWGgSCFJwZUvamTgqnyewyN7cuzi95c10lb+t6DAISx+7ceL9aTnUVgK26QlqQTrloCgfXnM8dnJbtHnLOFYiQnwXK1xLGCAtwczO3w3UVYKpL7kanxLie54QCCsieGhccZGU/C7fQUtwKNoCx1gIythlOdb2/6+8fMSDcsza/amNrCpKXTfnvMuND5YiXghkawMRmODXgJSma28xZQLXI7gkVhJZ8jQtQdwGIZdr1rE26BmXnJg8BEcAzjOVVN/fV7Gby1/0VGcX0fUMIJhbdZwVpTYpMQClSGlplxwSi/IyQQ25mYBYwAywiltlaZp0ZTSkB0G9MoP1Pm+HTsH/mufvms7tcz35aEfoIcgjAERCeFGAPCYUFEgIkDJBDQBKAEWCFFLkQuS+COyC5R6z+R5rem+jkf1R6TWcHO9gY/wd/MQ4/WXhb1gAAAABJRU5ErkJggg==","1f446-1f3fb":baseURL+"1f446-1f3fb.png","1f446-1f3fe":baseURL+"1f446-1f3fe.png","1f446-1f3fd":baseURL+"1f446-1f3fd.png","1f446-1f3fc":baseURL+"1f446-1f3fc.png","1f447":"data:image/png;base64,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","1f446-1f3ff":baseURL+"1f446-1f3ff.png","1f447-1f3fc":baseURL+"1f447-1f3fc.png","1f447-1f3fb":baseURL+"1f447-1f3fb.png","1f447-1f3fe":baseURL+"1f447-1f3fe.png","1f447-1f3ff":baseURL+"1f447-1f3ff.png","1f447-1f3fd":baseURL+"1f447-1f3fd.png","261d":"data:image/png;base64,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","261d-1f3fd":baseURL+"261d-1f3fd.png","261d-1f3fb":baseURL+"261d-1f3fb.png","261d-1f3ff":baseURL+"261d-1f3ff.png","261d-1f3fe":baseURL+"261d-1f3fe.png","270b-1f3fc":baseURL+"270b-1f3fc.png","270b":"data:image/png;base64,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","270b-1f3fb":baseURL+"270b-1f3fb.png","270b-1f3ff":baseURL+"270b-1f3ff.png","270b-1f3fe":baseURL+"270b-1f3fe.png","270b-1f3fd":baseURL+"270b-1f3fd.png","1f91a-1f3fb":baseURL+"1f91a-1f3fb.png","1f91a-1f3fc":baseURL+"1f91a-1f3fc.png","1f91a-1f3ff":baseURL+"1f91a-1f3ff.png","1f91a-1f3fd":baseURL+"1f91a-1f3fd.png","1f91a":baseURL+"1f91a.png","1f590":baseURL+"1f590.png","1f91a-1f3fe":baseURL+"1f91a-1f3fe.png","1f590-1f3fb":baseURL+"1f590-1f3fb.png","1f590-1f3fc":baseURL+"1f590-1f3fc.png","1f590-1f3fd":baseURL+"1f590-1f3fd.png","261d-1f3fc":baseURL+"261d-1f3fc.png","1f590-1f3ff":baseURL+"1f590-1f3ff.png","1f590-1f3fe":baseURL+"1f590-1f3fe.png","1f596-1f3fb":baseURL+"1f596-1f3fb.png","1f596-1f3fd":baseURL+"1f596-1f3fd.png","1f596-1f3fc":baseURL+"1f596-1f3fc.png","1f596-1f3ff":baseURL+"1f596-1f3ff.png","1f596-1f3fe":baseURL+"1f596-1f3fe.png","1f44b-1f3fb":baseURL+"1f44b-1f3fb.png","1f596":baseURL+"1f596.png","1f44b-1f3fd":baseURL+"1f44b-1f3fd.png","1f44b":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAABIpSURBVHic7Vt7cJzVdf+d+z32IWl39djVStrFAQwy2CaQOJmkCSABCQTbmSRTDLZDkja0BJjpI0OapHkMnaZJmleZaUgpNGUIlUxNG8LYcngEy2Ya0pnApMTIRpY76Yz07cqSH1pp3/t99/SPb9+Pb1fEk8y0OTPr9d577rn3/O455577EPA7+v9NdCGFze4bvxGQ9xLENoAtBr/ApvjOpjunZ9cjxzc1cwsxP0WMxy1oD6ztHD1zIcdZTeJCCZqdHPsWmF9QSPmQt8t7kdfbdTFBuUso/IvZfWO3r0cWS/UVAj/DhHsECjP+A8fW1X49dEEsYHbf2H1gfNfv8yEYGoQQtljTNBGLxWU2myaw+MTo3ukfVLcLHHz94wx8DqAfKqZ8+NyHts7X1B+auYYt/j4I1wB4NBHO3odt2woXYswl6giAmf1j3WqB/gTEHyZBIWaeB/jxWJge27ic09Kma97r8fRGIhEBqhUppYSxYMhMNg0iceflu6cnS3W9zxy7Sir0IIAxAAUCHkGh8KWVD1+zUhawf0b3e/ghEO4i8MTKK1s+hgdIXhDt0QEAp54Y22gJPA/CxZqmsu5yUz6Xk4VCQRDoKDO+AeKpoeEh9HT3NJUhpcTCwoLMZbMsQXs27ZneX13fffDYFQrTF0HYDWBJEt+1tn3rwWoe/8GZbwJ8PxhfT+zc8vlfR+lqcgQgdmCnN5lMvkagSwbDg6Knp6ggM1YSCSwvLTEDKQDdGzZsgMvlainLsiwszC/IXCEnSdLtl++d/mE9T2Dq+HXM8lEAl4Hxt4lXN3+hPNvM5J+amQSwi4CbVnZsmX7TWleRYxBcS67ezcwbQ+FQRXkAIEIgEEB4aIgI6AKAbC7n2JGiKIhEI8Kl6YKJn3xj3/gH63lWtl/5kmap2wD8Kwif82+bmcD0tFrsk4Ur+ykAC0x4EMwXJH45Cjk5OTYtFHH9pZdubMm3traG+GKcNVXniy6KCkVRHDu0TAvzC/Myn89bYPrQ6N7pQw1MzOSfOv4NgO8HeH/ilS27S5YQOHjsDxn0fWL+yMrOrU/XNgPNTd5wLQvr7WCRU8g6sHH3S/MN8qvI0QIYCLt0tyNIPT09CA8OUaGQF0YsBimd45Oi2pag67oA4ekTE+M3NzARcWLH5s8A9FWAdgW2zTxQqloJ554g4LgUiFY3mZu8/t0n9429xiSPguk7AD9kMp16Y+L6cafxOCo3OzF2SFXUmy/eeLGgNvFydW0Vi4uL8Lg9GBkZgRDOKYZpmpifn7cKBdMEYfvo7ukXG5iYyX/o+D4w7wLhtsT2Lf/eTNYbk+O7CHhCVYXi9/cobl2HZRawfDYhLUs+N7r3yK2txtHOAiZMaYqVlRUnNgCAr8eHcCiMTDYDwzAgJTvyq6qKaDSqaKqqQvLBE/vGxhqYiFhP4S6AZ8B42PfsTF89y9yTN7yfiCfcLl0dGR5WfD0+aJoG3aXbk9Bm5hwBGJ07sg+gn5xZWua15JqjQgDg8/swGBpEJptBzDDA3B6ESDSiqJqqKZKmZifH3lvPs7xrcxLgTwDoEyb/VXXd3P5rg5LlhK5qFB4OC1VVQASQIIAETMskMJ1wGoOznV55GxHhi2AkFuNxTq4lHdkBwO/3YzA0iHQmDcNYaAuCpmmIRCKKogkXQM/OTV7/7nqexI6rXgXoMQY+1fvMsatK5WyK+wH0D4YHFbUcfAkAwTRNMINA/JpT/y0BmJ0Yv3XOXD7BzP/JhAAzKL4Y52SyMxBCgyGk07Y7MDsHRl3XEYlEFUURbsn03ImJ8bfX81ia+ZcAVlmImwA7OwWJT/V0d5Pb7bYVJ/tDRCgU7D4l0+vrBuDk5PV/AJIHVU29JBQKYmRkBAMD/RCCEI/HkOoAhIA/gFAohHQ6jVgs1tYSdF1HJBpRFFXxKoJfOPEv122trk/e/NYllc2rXLr5jwCgFPgDzOzz+f0AirqXHZ4gS6ALPrsuAOaevOFSZvqex+3hDRveogQCvejq6kJfXz82bNhAuu5CLB5HKpVqD0LABiGVSiNmtAfBpbsQiUQUgvALRbz4xhPjo9X1Z3debZy++a3FjumdRMQet7tYS0Xrt7/Ly3FecQxeDQCwtP4YAq5weEjUL2WqqiEyEoGmaYjFYh2DEAwFkUqnipbgzO9yuTASjQgB0U8KT5+cuOmSZnwksElRVKaazVdp/gmljvx93oxTf40AEN7rcrmg6VrTBoqqIBqNlkFIp9POGgHoDfQiGAwilUohHjPaguBxuzE8MiKIKAxhTZ/ad120gYnZq6mKqE5l7PBn/y5NXvp8rtuprwYAiOs3tI1UzOuhaRoMo0MQensxEAwimUohHm/vDl6vB8PDwwRwVEKZPv7EtUM1DEws64VQxQ2EsFcFkwq9Tv00ACCZfprN5WCapuMAVUVFJBKFpiowDAPptKOlAQD6ensx0D+AZDKJeDwOhjMIXV1dCA8NEYMvURTl8Nz+a4OlOgafliytxlZFCygui6TKkFMfjS6gKI+CkYsvxrh9IqMgEo1C1VQYxgIymQ5A6O9Df38/kskkFuOLbUHo6e5BeDBMADZJU3nxxOM39gOAIFqyrCb6F0mvuPAmJ/kNAFxxx4snCXxvJp2lWDzWDgM7pY1Eoaqdg9Df34/+/n6sra1hMb7Ylt/n8yEcDoOALYpmvfCrx8YCzEhANk9zCQRNVUEEJqYrnWQ3zQMu33P0MQL/RSqZoni8E0tQEY1GoSgqDMPoGIS+viIIi/G2/D6fD0PDwwTC1Xk3fgbiDwilNPyqQEilb4KuuRiMdznJbZkJXr7n6DcBfD6ZTFJn7mDHBEURMAwD2Q5AGBjoR19fH1ZXi5bQpo/u7m6Ew2EC0yaA3unz9TQ/fCiC4PG6BAtsm9k/1nIlaAnAf++/6SKA8gCM5FqKFhcXuZ2/apoNghACC4aBbDbryA8AAwMD6OvttbfTS6fbgmAHW0agtxf9/QNNOCrW4Ha7AYaqmGjYZJWoKQCzk2N3maY1B/C3AYwAwNraGi3G2vurpmmIRqMQQsGCsdAZCMEgent7sZpYxXmHrTczI5lMAgT09QachRLB7XaDCAzQDa3Y1PqCE/tu+D2wfMTjcSEUCkPXdeRyWZw5cwZryTUgDgwNDTWTVSZN0xCNRDC/MA/DMDAyEoHb3frAFACCwSB0XYfP1/xkGQCy2Swsy4LX64Wqqm0TKkEEXXdxPpu/sSVPY4F1v6Iocnh4mFwuDUS2KUUiEfT19RWDVgeWoGuIRKMgAoyFeeRy7S3B7/eDqPUOPV+w70Q8HndLnnryetyCSV49s//mhsMUoGkmKN7h9XiUZoebAwMDxaBlH3+1mwJd0xCJREEksLBgINfm5LgdWaYNgMtdDwA3/r84NtvySChWrqkbNMJNyMqa/XutkgMDA7a/rq7i9On2Qau4zQUALCws/FoglLrSnMyfa4fscrsgiCwCv68Ze2MmyHwkk8nKQk0qXNtbMBhEb6AXidVVnF5aajtwXdcRjUYBskHI5/Nt2zQdbHGRFw5uUo8LAXC73QpB3NJUZmMn8nssJZ8+vVSHch0IoSACgQASiYRtCW1I13VERmxLmJ+ff1MglBIfEs7btcpyXXQDjw5mvmjuyRsubZBZX3DZ7pd+wUxfTqdSOLO87AhCKBQqg7C01B4El8uFSCQCt8sNVW1YgNoQl6/eTNOqKa/nqy1luHQdACAtfk+91Bap8PTXQPzI+ZUVnD17tiMQVlYSON0hCCOR9vcGrdoSESyr1RljYzBkBnRNAUCSiK+pb9F0FETgy5XQvUT01Llz53B+ZaUtCP6AH4mVBJaXl9ehUqfExXER3C4XCoXmTwS4FACZAS4FTQYzQ9cUZsbW+jYtp4F2PWWtrq7uBfGPzywvI5FINAGhUjAYGoTfH8D58+cvMAi1YHf7fMhlM03rbO+v9v8yChCKUACK1Et3tMNtd79a6On2/T4IP11aXuJkMtlk+akAMRgKwuf32SCcuRDPemo7Y7bvIpveRBdn3W5VyQWYbRAUQSCBcH2zto44vPNAWlieW4nxX4uLcU6lU+AKsLWDJSAcGoTP58P5c+d+DUuoW8xR6U8RAh6PpyGztFtwlflz+TezBBiQUjbk4x1Foss++uNVYeq3ADi1GIvLTHGD0zQZISAcHoTP14NUOtX2triWGhVv1k9fXy+qL2i4aka4SgaXlbfBEEI0mI4jAN3PvRbCoTkXAGz82PNLAvJGZo7FYoaVy+fKg2sGRDgcRjQSKT6Yaq5Ypby14s0sTVEUaLoO+0isNPfVs4+i4tKuYYYlJRhouNFxBEApKEcCMvet0u+Nu1+aFxbG2eKzxoJhVSczzI0DbtxPOCtcr3yT0vL/fD09yOXyxcjP5VmuDn4ly2BmmKa0wHy8XmIbF+BjDLpz+MAr3lLJxjuPnGKB90spkzHDsEyzcUlqBkYn5NyusdDtdkFKqwJnUVlmWflICWlZsKQlAD5WL6MNAMqjAPvTwn13denoHdOvWaBbTcvMGwslEJprW61Uu09zauUeXLwCoIoFFK2Bpa04pAQzI5svAEzERD9bFwCJHVf+hIH/YMaXvM8erzkFuWL34Zclix35gmkahmFV+2M78+6MWscNrjb5kqmXYkH17DOD2UImlwfAmVxB/3G9tLargAJxD4AuzeTHyy+2irRpz+HDYHwkny9IYyEma8/pO/f3jvm5tfLMDJaWPftl5SUsy0IuJyUznn7rx55vuMxsAMB/cGbBPzVTNvnzO658nQmfBvh9vlTwn+pBGN07fQjEt+fzOTaMuGz9NKZewfUAxOV1vWZpq1G+1u/tj4VkOg8GCxbKQ80kNzsQOQXmrwSe/kX51HF1+5aHQPgGAR/3p4LPdk3N1GRUo7uPPi0Jd+RzWY4ZhpQONzbronJQY3tJq5r9GkCkBLNVVtoGwoIlLaQzpgT40BW7D7/cEQCS+AsA+llXv1Ndnti+5bMA3wvgOpX5lP/gzN/4D/6yfHW9afeRfwP4jzLZLMUWF1lKq2rwnbsBc2WWbTOXNXIq38UgJ60q5UsWYIGlhbVkHgwmyeLLrXpserIQOPD6d5lwH8B3JXZs/X51Xe/UL7daLL5CQPGlJ/2Kwc+s7tjy5wDwxsTYJ4nwqNfrRjgcJqLiu41O33VyKZsr/ebyEleuKS919uyDK74vi8pn8xbOr2ZBRP9w+e7pe9cFAKZ/5fYnk9MgehuxuH1l55U/agBpauZqZtwGwnvAnEl0Le/E+LhZBOFPifBgV5eXBweDVH6p1vbivaRoCYvSBqcKhGrlWdb5vq28lIwzKxnLYp43FWzdvOtIyzc9LUfUNTUTVpkPA7gMoPsSOzY/0n70FTq5b+yLzPjr7u4uhAb6qy7tnJRv/FG6kquOA5UgWGf2LMEAVlaznMtbksDXXrbnaMPaX03Oz2APzA4IKkwBeCeIf2RC3JPavrn9pUCRZifHvwrw53t6ujDQ3wdUuUJ9x1z7T5XyFd+vUbw6DrBVBiqRzCGdNQHg/tE9R77dboztbfLQnMtv5R4A0WcA5AH5A0WKvz/3wc0zbdsCODk59ncM/FmX14uBgd4qL2gKQcXky0scypuaShAs+b896yVKZQpYTeXBjIc37T1yTyfj6/jJuf/A8beBrM8C9BEAKgFxZrxMoKmVnZsfa9WOGTT35NjXmPFZt9stB/p8Qghhd1zqvaw7lxvZX5V1vpL8VJSvpkzWxEoqy5B4NjZMHxwfP+L8xGW9AJQoMHV8A0veA+IbAbwNwNnEK5tH2/0Zy8nJ6z/DwNc1VeX+Pp+iqS2e1ZeifjEA1h5qcM2MlyiZLmAtlQcE/5zT5o2bPvnT9u96i3RB/2yuHc1OjN8K4kkA3f4ej9Ltrb7iql/6KvlDq7cJzIxEqoBMtgACjspMYed6lAd+wwAA9ruDQqHwKBG9X1VE3tfl0l16yRo630RlcxbW0nnLtKQCwnfXVtc+ve3uV9f9F2W/cQAAOy7MTo7tIYGvgPEWRVC2y6O53S4VisOtjyUZ2byFTKZgFSypAPgfIcTdl91x+Pk3O5bfCgAlmtl/m66ZS3uZ6R4Q3gEAiqC0qgihqMItilt9SzIXLCtvFdgF+4RtlgUetJTgP2/e9dSbu2gs0m8VgGo69cTYRlPBDmK8C4QtAMIA+glYYfA5MM2SwMts8XOjHz3689/2eH9H/1fofwHWFeL1W8JyVwAAAABJRU5ErkJggg==","1f44b-1f3fc":baseURL+"1f44b-1f3fc.png","1f919":baseURL+"1f919.png","1f919-1f3fb":baseURL+"1f919-1f3fb.png","1f44b-1f3fe":baseURL+"1f44b-1f3fe.png","1f919-1f3fc":baseURL+"1f919-1f3fc.png","1f44b-1f3ff":baseURL+"1f44b-1f3ff.png","1f919-1f3fd":baseURL+"1f919-1f3fd.png","1f919-1f3ff":baseURL+"1f919-1f3ff.png","1f4aa":"data:image/png;base64,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","1f4aa-1f3fb":baseURL+"1f4aa-1f3fb.png","1f4aa-1f3fc":baseURL+"1f4aa-1f3fc.png","1f4aa-1f3fd":baseURL+"1f4aa-1f3fd.png","1f4aa-1f3ff":baseURL+"1f4aa-1f3ff.png","1f9b5":baseURL+"1f9b5.png","1f4aa-1f3fe":baseURL+"1f4aa-1f3fe.png","1f9b5-1f3fb":baseURL+"1f9b5-1f3fb.png","1f9b5-1f3fe":baseURL+"1f9b5-1f3fe.png","1f9b5-1f3fc":baseURL+"1f9b5-1f3fc.png","1f9b5-1f3fd":baseURL+"1f9b5-1f3fd.png","1f9b6":baseURL+"1f9b6.png","1f9b6-1f3fb":baseURL+"1f9b6-1f3fb.png","1f595":baseURL+"1f595.png","1f9b6-1f3fd":baseURL+"1f9b6-1f3fd.png","1f9b6-1f3fc":baseURL+"1f9b6-1f3fc.png","1f9b6-1f3ff":baseURL+"1f9b6-1f3ff.png","1f9b6-1f3fe":baseURL+"1f9b6-1f3fe.png","1f9b5-1f3ff":baseURL+"1f9b5-1f3ff.png","1f595-1f3fe":baseURL+"1f595-1f3fe.png","1f595-1f3fc":baseURL+"1f595-1f3fc.png","1f595-1f3fb":baseURL+"1f595-1f3fb.png","1f595-1f3fd":baseURL+"1f595-1f3fd.png","1f919-1f3fe":baseURL+"1f919-1f3fe.png","270d":baseURL+"270d.png","1f595-1f3ff":baseURL+"1f595-1f3ff.png","270d-1f3fd":baseURL+"270d-1f3fd.png","270d-1f3fb":baseURL+"270d-1f3fb.png","270d-1f3fc":baseURL+"270d-1f3fc.png","270d-1f3fe":baseURL+"270d-1f3fe.png","270d-1f3ff":baseURL+"270d-1f3ff.png","1f64f":"data:image/png;base64,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","1f64f-1f3fb":baseURL+"1f64f-1f3fb.png","1f64f-1f3fc":baseURL+"1f64f-1f3fc.png","1f64f-1f3fd":baseURL+"1f64f-1f3fd.png","1f64f-1f3ff":baseURL+"1f64f-1f3ff.png","1f64f-1f3fe":baseURL+"1f64f-1f3fe.png","1f48d":baseURL+"1f48d.png","1f445":baseURL+"1f445.png","1f48b":baseURL+"1f48b.png","1f442-1f3fb":baseURL+"1f442-1f3fb.png","1f442":baseURL+"1f442.png","1f442-1f3fc":baseURL+"1f442-1f3fc.png","1f444":baseURL+"1f444.png","1f442-1f3fd":baseURL+"1f442-1f3fd.png","1f443-1f3fc":baseURL+"1f443-1f3fc.png","1f443":baseURL+"1f443.png","1f443-1f3fb":baseURL+"1f443-1f3fb.png","1f443-1f3fe":baseURL+"1f443-1f3fe.png","1f443-1f3fd":baseURL+"1f443-1f3fd.png","1f443-1f3ff":baseURL+"1f443-1f3ff.png","1f441":baseURL+"1f441.png","1f463":baseURL+"1f463.png","1f442-1f3ff":baseURL+"1f442-1f3ff.png","1f9b4":baseURL+"1f9b4.png","1f9b7":baseURL+"1f9b7.png","1f9e0":baseURL+"1f9e0.png","1f464":baseURL+"1f464.png","1f5e3":baseURL+"1f5e3.png","1f465":baseURL+"1f465.png","1f476":baseURL+"1f476.png","1f476-1f3fb":baseURL+"1f476-1f3fb.png","1f476-1f3fd":baseURL+"1f476-1f3fd.png","1f476-1f3fc":baseURL+"1f476-1f3fc.png","1f476-1f3ff":baseURL+"1f476-1f3ff.png","1f442-1f3fe":baseURL+"1f442-1f3fe.png","1f467-1f3fd":baseURL+"1f467-1f3fd.png","1f467-1f3fc":baseURL+"1f467-1f3fc.png","1f467-1f3fb":baseURL+"1f467-1f3fb.png","1f9d2":baseURL+"1f9d2.png","1f467-1f3ff":baseURL+"1f467-1f3ff.png","1f467-1f3fe":baseURL+"1f467-1f3fe.png","1f9d2-1f3fb":baseURL+"1f9d2-1f3fb.png","1f9d2-1f3fd":baseURL+"1f9d2-1f3fd.png","1f466":baseURL+"1f466.png","1f9d2-1f3fc":baseURL+"1f9d2-1f3fc.png","1f9d2-1f3fe":baseURL+"1f9d2-1f3fe.png","1f466-1f3fb":baseURL+"1f466-1f3fb.png","1f466-1f3fc":baseURL+"1f466-1f3fc.png","1f466-1f3fd":baseURL+"1f466-1f3fd.png","1f466-1f3ff":baseURL+"1f466-1f3ff.png","1f9d2-1f3ff":baseURL+"1f9d2-1f3ff.png","1f466-1f3fe":baseURL+"1f466-1f3fe.png","1f469":baseURL+"1f469.png","1f476-1f3fe":baseURL+"1f476-1f3fe.png","1f469-1f3fc":baseURL+"1f469-1f3fc.png","1f469-1f3fb":baseURL+"1f469-1f3fb.png","1f469-1f3fd":baseURL+"1f469-1f3fd.png","1f469-1f3fe":baseURL+"1f469-1f3fe.png","1f469-1f3ff":baseURL+"1f469-1f3ff.png","1f9d1-1f3fc":baseURL+"1f9d1-1f3fc.png","1f9d1-1f3fb":baseURL+"1f9d1-1f3fb.png","1f467":baseURL+"1f467.png","1f9d1":baseURL+"1f9d1.png","1f440":baseURL+"1f440.png","1f468-1f3fc":baseURL+"1f468-1f3fc.png","1f9d1-1f3ff":baseURL+"1f9d1-1f3ff.png","1f468":baseURL+"1f468.png","1f9d1-1f3fe":baseURL+"1f9d1-1f3fe.png","1f468-1f3fb":baseURL+"1f468-1f3fb.png","1f468-1f3fe":baseURL+"1f468-1f3fe.png","1f471":baseURL+"1f471.png","1f471-1f3fb":baseURL+"1f471-1f3fb.png","1f471-1f3fd":baseURL+"1f471-1f3fd.png","1f471-1f3fe":baseURL+"1f471-1f3fe.png","1f471-1f3fc":baseURL+"1f471-1f3fc.png","1f471-1f3ff":baseURL+"1f471-1f3ff.png","1f471-1f3fb-2640":baseURL+"1f471-1f3fb-2640.png","1f471-1f3fd-2640":baseURL+"1f471-1f3fd-2640.png","1f468-1f3fd":baseURL+"1f468-1f3fd.png","1f471-2640":baseURL+"1f471-2640.png","1f471-1f3fc-2640":baseURL+"1f471-1f3fc-2640.png","1f471-1f3fe-2640":baseURL+"1f471-1f3fe-2640.png","1f471-1f3fb-2642":baseURL+"1f471-1f3fb-2642.png","1f471-2642":baseURL+"1f471-2642.png","1f471-1f3ff-2640":baseURL+"1f471-1f3ff-2640.png","1f471-1f3fc-2642":baseURL+"1f471-1f3fc-2642.png","1f471-1f3fd-2642":baseURL+"1f471-1f3fd-2642.png","1f484":baseURL+"1f484.png","1f471-1f3fe-2642":baseURL+"1f471-1f3fe-2642.png","1f468-1f3ff":baseURL+"1f468-1f3ff.png","1f469-1f3fb-1f9b0":baseURL+"1f469-1f3fb-1f9b0.png","1f469-1f9b0":baseURL+"1f469-1f9b0.png","1f9d1-1f3fd":baseURL+"1f9d1-1f3fd.png","1f469-1f3fc-1f9b0":baseURL+"1f469-1f3fc-1f9b0.png","1f471-1f3ff-2642":baseURL+"1f471-1f3ff-2642.png","1f469-1f3fd-1f9b0":baseURL+"1f469-1f3fd-1f9b0.png","1f469-1f3fe-1f9b0":baseURL+"1f469-1f3fe-1f9b0.png","1f468-1f3fb-1f9b0":baseURL+"1f468-1f3fb-1f9b0.png","1f469-1f3ff-1f9b0":baseURL+"1f469-1f3ff-1f9b0.png","1f468-1f3fd-1f9b0":baseURL+"1f468-1f3fd-1f9b0.png","1f468-1f3fc-1f9b0":baseURL+"1f468-1f3fc-1f9b0.png","1f468-1f3fe-1f9b0":baseURL+"1f468-1f3fe-1f9b0.png","1f468-1f3ff-1f9b0":baseURL+"1f468-1f3ff-1f9b0.png","1f468-1f9b0":baseURL+"1f468-1f9b0.png","1f469-1f3fb-1f9b1":baseURL+"1f469-1f3fb-1f9b1.png","1f469-1f9b1":baseURL+"1f469-1f9b1.png","1f469-1f3fc-1f9b1":baseURL+"1f469-1f3fc-1f9b1.png","1f469-1f3ff-1f9b1":baseURL+"1f469-1f3ff-1f9b1.png","1f468-1f9b1":baseURL+"1f468-1f9b1.png","1f469-1f3fe-1f9b1":baseURL+"1f469-1f3fe-1f9b1.png","1f468-1f3fc-1f9b1":baseURL+"1f468-1f3fc-1f9b1.png","1f468-1f3fb-1f9b1":baseURL+"1f468-1f3fb-1f9b1.png","1f468-1f3fd-1f9b1":baseURL+"1f468-1f3fd-1f9b1.png","1f468-1f3fe-1f9b1":baseURL+"1f468-1f3fe-1f9b1.png","1f469-1f3fd-1f9b1":baseURL+"1f469-1f3fd-1f9b1.png","1f468-1f3ff-1f9b1":baseURL+"1f468-1f3ff-1f9b1.png","1f469-1f9b3":baseURL+"1f469-1f9b3.png","1f469-1f3fd-1f9b3":baseURL+"1f469-1f3fd-1f9b3.png","1f469-1f3fc-1f9b3":baseURL+"1f469-1f3fc-1f9b3.png","1f469-1f3fe-1f9b3":baseURL+"1f469-1f3fe-1f9b3.png","1f468-1f9b3":baseURL+"1f468-1f9b3.png","1f469-1f3fb-1f9b3":baseURL+"1f469-1f3fb-1f9b3.png","1f468-1f3fb-1f9b3":baseURL+"1f468-1f3fb-1f9b3.png","1f468-1f3fe-1f9b3":baseURL+"1f468-1f3fe-1f9b3.png","1f468-1f3ff-1f9b3":baseURL+"1f468-1f3ff-1f9b3.png","1f469-1f9b2":baseURL+"1f469-1f9b2.png","1f469-1f3fb-1f9b2":baseURL+"1f469-1f3fb-1f9b2.png","1f469-1f3fd-1f9b2":baseURL+"1f469-1f3fd-1f9b2.png","1f469-1f3fe-1f9b2":baseURL+"1f469-1f3fe-1f9b2.png","1f469-1f3fc-1f9b2":baseURL+"1f469-1f3fc-1f9b2.png","1f469-1f3ff-1f9b2":baseURL+"1f469-1f3ff-1f9b2.png","1f468-1f9b2":baseURL+"1f468-1f9b2.png","1f468-1f3fc-1f9b2":baseURL+"1f468-1f3fc-1f9b2.png","1f468-1f3fd-1f9b2":baseURL+"1f468-1f3fd-1f9b2.png","1f468-1f3fb-1f9b2":baseURL+"1f468-1f3fb-1f9b2.png","1f468-1f3fe-1f9b2":baseURL+"1f468-1f3fe-1f9b2.png","1f468-1f3ff-1f9b2":baseURL+"1f468-1f3ff-1f9b2.png","1f9d4":baseURL+"1f9d4.png","1f9d4-1f3fc":baseURL+"1f9d4-1f3fc.png","1f9d4-1f3fd":baseURL+"1f9d4-1f3fd.png","1f9d4-1f3fe":baseURL+"1f9d4-1f3fe.png","1f9d4-1f3ff":baseURL+"1f9d4-1f3ff.png","1f475":baseURL+"1f475.png","1f475-1f3fb":baseURL+"1f475-1f3fb.png","1f475-1f3fc":baseURL+"1f475-1f3fc.png","1f469-1f3ff-1f9b3":baseURL+"1f469-1f3ff-1f9b3.png","1f475-1f3fe":baseURL+"1f475-1f3fe.png","1f468-1f3fc-1f9b3":baseURL+"1f468-1f3fc-1f9b3.png","1f9d3":baseURL+"1f9d3.png","1f475-1f3fd":baseURL+"1f475-1f3fd.png","1f475-1f3ff":baseURL+"1f475-1f3ff.png","1f468-1f3fd-1f9b3":baseURL+"1f468-1f3fd-1f9b3.png","1f9d3-1f3fc":baseURL+"1f9d3-1f3fc.png","1f9d3-1f3fe":baseURL+"1f9d3-1f3fe.png","1f9d3-1f3fb":baseURL+"1f9d3-1f3fb.png","1f9d4-1f3fb":baseURL+"1f9d4-1f3fb.png","1f9d3-1f3ff":baseURL+"1f9d3-1f3ff.png","1f474-1f3fe":baseURL+"1f474-1f3fe.png","1f474-1f3ff":baseURL+"1f474-1f3ff.png","1f474-1f3fd":baseURL+"1f474-1f3fd.png","1f472":baseURL+"1f472.png","1f472-1f3fb":baseURL+"1f472-1f3fb.png","1f474-1f3fc":baseURL+"1f474-1f3fc.png","1f472-1f3fc":baseURL+"1f472-1f3fc.png","1f472-1f3fd":baseURL+"1f472-1f3fd.png","1f472-1f3ff":baseURL+"1f472-1f3ff.png","1f473-1f3fb":baseURL+"1f473-1f3fb.png","1f474":baseURL+"1f474.png","1f474-1f3fb":baseURL+"1f474-1f3fb.png","1f473-1f3fd":baseURL+"1f473-1f3fd.png","1f473-1f3fc":baseURL+"1f473-1f3fc.png","1f473":baseURL+"1f473.png","1f473-1f3fe":baseURL+"1f473-1f3fe.png","1f472-1f3fe":baseURL+"1f472-1f3fe.png","1f473-1f3ff":baseURL+"1f473-1f3ff.png","1f473-2640":baseURL+"1f473-2640.png","1f9d3-1f3fd":baseURL+"1f9d3-1f3fd.png","1f473-1f3fb-2640":baseURL+"1f473-1f3fb-2640.png","1f473-1f3fc-2640":baseURL+"1f473-1f3fc-2640.png","1f473-1f3fd-2640":baseURL+"1f473-1f3fd-2640.png","1f473-1f3fe-2640":baseURL+"1f473-1f3fe-2640.png","1f473-1f3ff-2640":baseURL+"1f473-1f3ff-2640.png","1f473-2642":baseURL+"1f473-2642.png","1f473-1f3fd-2642":baseURL+"1f473-1f3fd-2642.png","1f473-1f3fb-2642":baseURL+"1f473-1f3fb-2642.png","1f473-1f3fc-2642":baseURL+"1f473-1f3fc-2642.png","1f473-1f3ff-2642":baseURL+"1f473-1f3ff-2642.png","1f473-1f3fe-2642":baseURL+"1f473-1f3fe-2642.png","1f9d5-1f3fc":baseURL+"1f9d5-1f3fc.png","1f46e-1f3fb":baseURL+"1f46e-1f3fb.png","1f9d5-1f3ff":baseURL+"1f9d5-1f3ff.png","1f46e":baseURL+"1f46e.png","1f9d5-1f3fe":baseURL+"1f9d5-1f3fe.png","1f46e-1f3fd":baseURL+"1f46e-1f3fd.png","1f46e-1f3fc":baseURL+"1f46e-1f3fc.png","1f46e-1f3fe":baseURL+"1f46e-1f3fe.png","1f46e-1f3ff":baseURL+"1f46e-1f3ff.png","1f46e-2640":baseURL+"1f46e-2640.png","1f46e-1f3fc-2640":baseURL+"1f46e-1f3fc-2640.png","1f46e-1f3fb-2640":baseURL+"1f46e-1f3fb-2640.png","1f46e-1f3fd-2640":baseURL+"1f46e-1f3fd-2640.png","1f46e-1f3fe-2640":baseURL+"1f46e-1f3fe-2640.png","1f46e-2642":baseURL+"1f46e-2642.png","1f46e-1f3fb-2642":baseURL+"1f46e-1f3fb-2642.png","1f46e-1f3ff-2640":baseURL+"1f46e-1f3ff-2640.png","1f46e-1f3fc-2642":baseURL+"1f46e-1f3fc-2642.png","1f46e-1f3fd-2642":baseURL+"1f46e-1f3fd-2642.png","1f46e-1f3ff-2642":baseURL+"1f46e-1f3ff-2642.png","1f477-1f3fb":baseURL+"1f477-1f3fb.png","1f477-1f3fc":baseURL+"1f477-1f3fc.png","1f477":baseURL+"1f477.png","1f477-1f3fe":baseURL+"1f477-1f3fe.png","1f46e-1f3fe-2642":baseURL+"1f46e-1f3fe-2642.png","1f477-1f3ff":baseURL+"1f477-1f3ff.png","1f477-2640":baseURL+"1f477-2640.png","1f9d5":baseURL+"1f9d5.png","1f477-1f3fc-2640":baseURL+"1f477-1f3fc-2640.png","1f477-1f3fe-2640":baseURL+"1f477-1f3fe-2640.png","1f477-1f3fd-2640":baseURL+"1f477-1f3fd-2640.png","1f477-1f3ff-2640":baseURL+"1f477-1f3ff-2640.png","1f477-2642":baseURL+"1f477-2642.png","1f477-1f3fd-2642":baseURL+"1f477-1f3fd-2642.png","1f477-1f3fc-2642":baseURL+"1f477-1f3fc-2642.png","1f477-1f3ff-2642":baseURL+"1f477-1f3ff-2642.png","1f477-1f3fb-2642":baseURL+"1f477-1f3fb-2642.png","1f477-1f3fe-2642":baseURL+"1f477-1f3fe-2642.png","1f482-1f3fc":baseURL+"1f482-1f3fc.png","1f482":baseURL+"1f482.png","1f482-1f3fb":baseURL+"1f482-1f3fb.png","1f482-1f3fe":baseURL+"1f482-1f3fe.png","1f477-1f3fd":baseURL+"1f477-1f3fd.png","1f482-1f3ff":baseURL+"1f482-1f3ff.png","1f482-1f3fd":baseURL+"1f482-1f3fd.png","1f482-2640":baseURL+"1f482-2640.png","1f482-1f3fc-2640":baseURL+"1f482-1f3fc-2640.png","1f482-1f3fd-2640":baseURL+"1f482-1f3fd-2640.png","1f482-1f3fb-2640":baseURL+"1f482-1f3fb-2640.png","1f482-1f3ff-2640":baseURL+"1f482-1f3ff-2640.png","1f482-2642":baseURL+"1f482-2642.png","1f482-1f3fe-2640":baseURL+"1f482-1f3fe-2640.png","1f482-1f3fb-2642":baseURL+"1f482-1f3fb-2642.png","1f9d5-1f3fd":baseURL+"1f9d5-1f3fd.png","1f482-1f3fc-2642":baseURL+"1f482-1f3fc-2642.png","1f482-1f3ff-2642":baseURL+"1f482-1f3ff-2642.png","1f482-1f3fe-2642":baseURL+"1f482-1f3fe-2642.png","1f575":baseURL+"1f575.png","1f575-1f3fb":baseURL+"1f575-1f3fb.png","1f575-1f3fe":baseURL+"1f575-1f3fe.png","1f575-1f3fd":baseURL+"1f575-1f3fd.png","1f575-1f3fc":baseURL+"1f575-1f3fc.png","1f575-1f3ff":baseURL+"1f575-1f3ff.png","1f575-1f3fb-2640":baseURL+"1f575-1f3fb-2640.png","1f575-2640":baseURL+"1f575-2640.png","1f575-1f3fd-2640":baseURL+"1f575-1f3fd-2640.png","1f575-1f3fc-2640":baseURL+"1f575-1f3fc-2640.png","1f575-1f3fe-2640":baseURL+"1f575-1f3fe-2640.png","1f575-1f3ff-2640":baseURL+"1f575-1f3ff-2640.png","1f575-2642":baseURL+"1f575-2642.png","1f575-1f3fc-2642":baseURL+"1f575-1f3fc-2642.png","1f575-1f3fd-2642":baseURL+"1f575-1f3fd-2642.png","1f575-1f3fb-2642":baseURL+"1f575-1f3fb-2642.png","1f575-1f3fe-2642":baseURL+"1f575-1f3fe-2642.png","1f575-1f3ff-2642":baseURL+"1f575-1f3ff-2642.png","1f469-1f3fb-2695":baseURL+"1f469-1f3fb-2695.png","1f469-1f3fd-2695":baseURL+"1f469-1f3fd-2695.png","1f469-1f3fc-2695":baseURL+"1f469-1f3fc-2695.png","1f469-1f3fe-2695":baseURL+"1f469-1f3fe-2695.png","1f468-2695":baseURL+"1f468-2695.png","1f469-1f3ff-2695":baseURL+"1f469-1f3ff-2695.png","1f468-1f3fb-2695":baseURL+"1f468-1f3fb-2695.png","1f477-1f3fb-2640":baseURL+"1f477-1f3fb-2640.png","1f468-1f3fd-2695":baseURL+"1f468-1f3fd-2695.png","1f468-1f3ff-2695":baseURL+"1f468-1f3ff-2695.png","1f469-1f3fb-1f33e":baseURL+"1f469-1f3fb-1f33e.png","1f469-2695":baseURL+"1f469-2695.png","1f468-1f3fe-2695":baseURL+"1f468-1f3fe-2695.png","1f469-1f3fc-1f33e":baseURL+"1f469-1f3fc-1f33e.png","1f469-1f3fe-1f33e":baseURL+"1f469-1f3fe-1f33e.png","1f469-1f33e":baseURL+"1f469-1f33e.png","1f469-1f3fd-1f33e":baseURL+"1f469-1f3fd-1f33e.png","1f468-1f33e":baseURL+"1f468-1f33e.png","1f469-1f3ff-1f33e":baseURL+"1f469-1f3ff-1f33e.png","1f468-1f3fc-1f33e":baseURL+"1f468-1f3fc-1f33e.png","1f468-1f3fd-1f33e":baseURL+"1f468-1f3fd-1f33e.png","1f468-1f3fb-1f33e":baseURL+"1f468-1f3fb-1f33e.png","1f468-1f3fe-1f33e":baseURL+"1f468-1f3fe-1f33e.png","1f468-1f3ff-1f33e":baseURL+"1f468-1f3ff-1f33e.png","1f469-1f3fb-1f373":baseURL+"1f469-1f3fb-1f373.png","1f469-1f373":baseURL+"1f469-1f373.png","1f482-1f3fd-2642":baseURL+"1f482-1f3fd-2642.png","1f469-1f3fd-1f373":baseURL+"1f469-1f3fd-1f373.png","1f469-1f3fe-1f373":baseURL+"1f469-1f3fe-1f373.png","1f469-1f3ff-1f373":baseURL+"1f469-1f3ff-1f373.png","1f468-1f373":baseURL+"1f468-1f373.png","1f468-1f3fb-1f373":baseURL+"1f468-1f3fb-1f373.png","1f468-1f3fc-1f373":baseURL+"1f468-1f3fc-1f373.png","1f468-1f3fd-1f373":baseURL+"1f468-1f3fd-1f373.png","1f468-1f3fe-1f373":baseURL+"1f468-1f3fe-1f373.png","1f468-1f3ff-1f373":baseURL+"1f468-1f3ff-1f373.png","1f469-1f393":baseURL+"1f469-1f393.png","1f469-1f3fb-1f393":baseURL+"1f469-1f3fb-1f393.png","1f469-1f3fd-1f393":baseURL+"1f469-1f3fd-1f393.png","1f469-1f3fc-1f393":baseURL+"1f469-1f3fc-1f393.png","1f469-1f3fe-1f393":baseURL+"1f469-1f3fe-1f393.png","1f468-1f393":baseURL+"1f468-1f393.png","1f468-1f3fb-1f393":baseURL+"1f468-1f3fb-1f393.png","1f469-1f3ff-1f393":baseURL+"1f469-1f3ff-1f393.png","1f468-1f3fc-1f393":baseURL+"1f468-1f3fc-1f393.png","1f468-1f3ff-1f393":baseURL+"1f468-1f3ff-1f393.png","1f468-1f3fe-1f393":baseURL+"1f468-1f3fe-1f393.png","1f469-1f3fc-1f3a4":baseURL+"1f469-1f3fc-1f3a4.png","1f469-1f3fd-1f3a4":baseURL+"1f469-1f3fd-1f3a4.png","1f469-1f3fb-1f3a4":baseURL+"1f469-1f3fb-1f3a4.png","1f469-1f3fe-1f3a4":baseURL+"1f469-1f3fe-1f3a4.png","1f469-1f3ff-1f3a4":baseURL+"1f469-1f3ff-1f3a4.png","1f468-1f3a4":baseURL+"1f468-1f3a4.png","1f468-1f3fc-1f3a4":baseURL+"1f468-1f3fc-1f3a4.png","1f468-1f3fb-1f3a4":baseURL+"1f468-1f3fb-1f3a4.png","1f469-1f3a4":baseURL+"1f469-1f3a4.png","1f468-1f3fe-1f3a4":baseURL+"1f468-1f3fe-1f3a4.png","1f468-1f3ff-1f3a4":baseURL+"1f468-1f3ff-1f3a4.png","1f469-1f3eb":baseURL+"1f469-1f3eb.png","1f468-1f3fd-1f3a4":baseURL+"1f468-1f3fd-1f3a4.png","1f469-1f3fb-1f3eb":baseURL+"1f469-1f3fb-1f3eb.png","1f469-1f3fc-1f3eb":baseURL+"1f469-1f3fc-1f3eb.png","1f469-1f3fd-1f3eb":baseURL+"1f469-1f3fd-1f3eb.png","1f469-1f3ff-1f3eb":baseURL+"1f469-1f3ff-1f3eb.png","1f468-1f3eb":baseURL+"1f468-1f3eb.png","1f468-1f3fb-1f3eb":baseURL+"1f468-1f3fb-1f3eb.png","1f469-1f3fe-1f3eb":baseURL+"1f469-1f3fe-1f3eb.png","1f468-1f3fc-1f3eb":baseURL+"1f468-1f3fc-1f3eb.png","1f468-1f3fd-1f3eb":baseURL+"1f468-1f3fd-1f3eb.png","1f468-1f3fe-1f3eb":baseURL+"1f468-1f3fe-1f3eb.png","1f469-1f3ed":baseURL+"1f469-1f3ed.png","1f468-1f3ff-1f3eb":baseURL+"1f468-1f3ff-1f3eb.png","1f469-1f3fb-1f3ed":baseURL+"1f469-1f3fb-1f3ed.png","1f469-1f3fc-1f3ed":baseURL+"1f469-1f3fc-1f3ed.png","1f469-1f3fd-1f3ed":baseURL+"1f469-1f3fd-1f3ed.png","1f469-1f3fe-1f3ed":baseURL+"1f469-1f3fe-1f3ed.png","1f468-1f3ed":baseURL+"1f468-1f3ed.png","1f468-1f3fc-1f3ed":baseURL+"1f468-1f3fc-1f3ed.png","1f469-1f3ff-1f3ed":baseURL+"1f469-1f3ff-1f3ed.png","1f468-1f3fb-1f3ed":baseURL+"1f468-1f3fb-1f3ed.png","1f468-1f3fd-1f3ed":baseURL+"1f468-1f3fd-1f3ed.png","1f468-1f3fe-1f3ed":baseURL+"1f468-1f3fe-1f3ed.png","1f469-1f3fc-1f4bb":baseURL+"1f469-1f3fc-1f4bb.png","1f468-1f3ff-1f3ed":baseURL+"1f468-1f3ff-1f3ed.png","1f469-1f3fb-1f4bb":baseURL+"1f469-1f3fb-1f4bb.png","1f469-1f4bb":baseURL+"1f469-1f4bb.png","1f469-1f3fe-1f4bb":baseURL+"1f469-1f3fe-1f4bb.png","1f468-1f4bb":baseURL+"1f468-1f4bb.png","1f469-1f3ff-1f4bb":baseURL+"1f469-1f3ff-1f4bb.png","1f469-1f3fd-1f4bb":baseURL+"1f469-1f3fd-1f4bb.png","1f468-1f3fc-1f4bb":baseURL+"1f468-1f3fc-1f4bb.png","1f468-1f3fb-1f4bb":baseURL+"1f468-1f3fb-1f4bb.png","1f468-1f3fd-1f4bb":baseURL+"1f468-1f3fd-1f4bb.png","1f468-1f3fe-1f4bb":baseURL+"1f468-1f3fe-1f4bb.png","1f469-1f4bc":baseURL+"1f469-1f4bc.png","1f468-1f3ff-1f4bb":baseURL+"1f468-1f3ff-1f4bb.png","1f469-1f3fb-1f4bc":baseURL+"1f469-1f3fb-1f4bc.png","1f469-1f3fc-1f4bc":baseURL+"1f469-1f3fc-1f4bc.png","1f469-1f3fe-1f4bc":baseURL+"1f469-1f3fe-1f4bc.png","1f469-1f3fd-1f4bc":baseURL+"1f469-1f3fd-1f4bc.png","1f468-1f4bc":baseURL+"1f468-1f4bc.png","1f468-1f3fc-1f4bc":baseURL+"1f468-1f3fc-1f4bc.png","1f468-1f3fd-1f4bc":baseURL+"1f468-1f3fd-1f4bc.png","1f469-1f3ff-1f4bc":baseURL+"1f469-1f3ff-1f4bc.png","1f468-1f3fb-1f4bc":baseURL+"1f468-1f3fb-1f4bc.png","1f468-1f3fe-1f4bc":baseURL+"1f468-1f3fe-1f4bc.png","1f468-1f3fd-1f393":baseURL+"1f468-1f3fd-1f393.png","1f468-1f3ff-1f4bc":baseURL+"1f468-1f3ff-1f4bc.png","1f469-1f3fb-1f527":baseURL+"1f469-1f3fb-1f527.png","1f469-1f527":baseURL+"1f469-1f527.png","1f469-1f3fc-1f527":baseURL+"1f469-1f3fc-1f527.png","1f469-1f3fd-1f527":baseURL+"1f469-1f3fd-1f527.png","1f469-1f3fe-1f527":baseURL+"1f469-1f3fe-1f527.png","1f469-1f3ff-1f527":baseURL+"1f469-1f3ff-1f527.png","1f468-1f3fc-1f527":baseURL+"1f468-1f3fc-1f527.png","1f468-1f3fb-1f527":baseURL+"1f468-1f3fb-1f527.png","1f468-1f3fd-1f527":baseURL+"1f468-1f3fd-1f527.png","1f469-1f52c":baseURL+"1f469-1f52c.png","1f468-1f3fe-1f527":baseURL+"1f468-1f3fe-1f527.png","1f468-1f3ff-1f527":baseURL+"1f468-1f3ff-1f527.png","1f469-1f3fd-1f52c":baseURL+"1f469-1f3fd-1f52c.png","1f468-1f527":baseURL+"1f468-1f527.png","1f469-1f3fb-1f52c":baseURL+"1f469-1f3fb-1f52c.png","1f469-1f3fc-1f52c":baseURL+"1f469-1f3fc-1f52c.png","1f469-1f3fe-1f52c":baseURL+"1f469-1f3fe-1f52c.png","1f469-1f3ff-1f52c":baseURL+"1f469-1f3ff-1f52c.png","1f468-1f3fd-1f52c":baseURL+"1f468-1f3fd-1f52c.png","1f468-1f52c":baseURL+"1f468-1f52c.png","1f468-1f3fc-1f52c":baseURL+"1f468-1f3fc-1f52c.png","1f468-1f3fb-1f52c":baseURL+"1f468-1f3fb-1f52c.png","1f468-1f3ff-1f52c":baseURL+"1f468-1f3ff-1f52c.png","1f469-1f3fc-1f3a8":baseURL+"1f469-1f3fc-1f3a8.png","1f468-1f3fe-1f52c":baseURL+"1f468-1f3fe-1f52c.png","1f469-1f3fb-1f3a8":baseURL+"1f469-1f3fb-1f3a8.png","1f468-1f3a8":baseURL+"1f468-1f3a8.png","1f469-1f3fe-1f3a8":baseURL+"1f469-1f3fe-1f3a8.png","1f469-1f3fd-1f3a8":baseURL+"1f469-1f3fd-1f3a8.png","1f469-1f3ff-1f3a8":baseURL+"1f469-1f3ff-1f3a8.png","1f468-1f3fb-1f3a8":baseURL+"1f468-1f3fb-1f3a8.png","1f468-1f3fc-1f3a8":baseURL+"1f468-1f3fc-1f3a8.png","1f468-1f3fd-1f3a8":baseURL+"1f468-1f3fd-1f3a8.png","1f469-1f3a8":baseURL+"1f469-1f3a8.png","1f468-1f3ff-1f3a8":baseURL+"1f468-1f3ff-1f3a8.png","1f469-1f692":baseURL+"1f469-1f692.png","1f469-1f3fc-1f692":baseURL+"1f469-1f3fc-1f692.png","1f469-1f3fd-1f692":baseURL+"1f469-1f3fd-1f692.png","1f469-1f3fb-1f692":baseURL+"1f469-1f3fb-1f692.png","1f469-1f3ff-1f692":baseURL+"1f469-1f3ff-1f692.png","1f468-1f692":baseURL+"1f468-1f692.png","1f469-1f3fe-1f692":baseURL+"1f469-1f3fe-1f692.png","1f468-1f3fe-1f3a8":baseURL+"1f468-1f3fe-1f3a8.png","1f468-1f3fb-1f692":baseURL+"1f468-1f3fb-1f692.png","1f468-1f3fd-1f692":baseURL+"1f468-1f3fd-1f692.png","1f468-1f3fe-1f692":baseURL+"1f468-1f3fe-1f692.png","1f468-1f3fc-1f692":baseURL+"1f468-1f3fc-1f692.png","1f469-2708":baseURL+"1f469-2708.png","1f469-1f3fd-2708":baseURL+"1f469-1f3fd-2708.png","1f468-1f3ff-1f692":baseURL+"1f468-1f3ff-1f692.png","1f469-1f3fe-2708":baseURL+"1f469-1f3fe-2708.png","1f469-1f3fc-2708":baseURL+"1f469-1f3fc-2708.png","1f468-1f3fb-2708":baseURL+"1f468-1f3fb-2708.png","1f469-1f3ff-2708":baseURL+"1f469-1f3ff-2708.png","1f468-2708":baseURL+"1f468-2708.png","1f468-1f3fc-2708":baseURL+"1f468-1f3fc-2708.png","1f468-1f3ff-2708":baseURL+"1f468-1f3ff-2708.png","1f468-1f3fc-2695":baseURL+"1f468-1f3fc-2695.png","1f9d5-1f3fb":baseURL+"1f9d5-1f3fb.png","1f469-1f3fc-1f373":baseURL+"1f469-1f3fc-1f373.png","1f468-1f3fe-2708":baseURL+"1f468-1f3fe-2708.png","1f469-1f3fb-1f680":baseURL+"1f469-1f3fb-1f680.png","1f469-1f3fd-1f680":baseURL+"1f469-1f3fd-1f680.png","1f469-1f3fe-1f680":baseURL+"1f469-1f3fe-1f680.png","1f469-1f3ff-1f680":baseURL+"1f469-1f3ff-1f680.png","1f468-1f3fb-1f680":baseURL+"1f468-1f3fb-1f680.png","1f468-1f680":baseURL+"1f468-1f680.png","1f468-1f3fd-1f680":baseURL+"1f468-1f3fd-1f680.png","1f468-1f3fc-1f680":baseURL+"1f468-1f3fc-1f680.png","1f469-2696":baseURL+"1f469-2696.png","1f469-1f3fb-2696":baseURL+"1f469-1f3fb-2696.png","1f468-1f3fe-1f680":baseURL+"1f468-1f3fe-1f680.png","1f468-1f3ff-1f680":baseURL+"1f468-1f3ff-1f680.png","1f469-1f3fd-2696":baseURL+"1f469-1f3fd-2696.png","1f469-1f3fe-2696":baseURL+"1f469-1f3fe-2696.png","1f469-1f3fc-2696":baseURL+"1f469-1f3fc-2696.png","1f468-2696":baseURL+"1f468-2696.png","1f468-1f3fb-2696":baseURL+"1f468-1f3fb-2696.png","1f469-1f3ff-2696":baseURL+"1f469-1f3ff-2696.png","1f468-1f3fd-2696":baseURL+"1f468-1f3fd-2696.png","1f468-1f3fe-2696":baseURL+"1f468-1f3fe-2696.png","1f468-1f3fc-2696":baseURL+"1f468-1f3fc-2696.png","1f468-1f3ff-2696":baseURL+"1f468-1f3ff-2696.png","1f470":baseURL+"1f470.png","1f470-1f3fe":baseURL+"1f470-1f3fe.png","1f470-1f3fb":baseURL+"1f470-1f3fb.png","1f470-1f3fc":baseURL+"1f470-1f3fc.png","1f470-1f3fd":baseURL+"1f470-1f3fd.png","1f935-1f3fc":baseURL+"1f935-1f3fc.png","1f470-1f3ff":baseURL+"1f470-1f3ff.png","1f935":baseURL+"1f935.png","1f935-1f3fd":baseURL+"1f935-1f3fd.png","1f935-1f3fb":baseURL+"1f935-1f3fb.png","1f478-1f3fb":baseURL+"1f478-1f3fb.png","1f935-1f3ff":baseURL+"1f935-1f3ff.png","1f935-1f3fe":baseURL+"1f935-1f3fe.png","1f478":baseURL+"1f478.png","1f478-1f3fc":baseURL+"1f478-1f3fc.png","1f478-1f3ff":baseURL+"1f478-1f3ff.png","1f469-1f3fc-1f680":baseURL+"1f469-1f3fc-1f680.png","1f469-1f3fb-2708":baseURL+"1f469-1f3fb-2708.png","1f478-1f3fe":baseURL+"1f478-1f3fe.png","1f934":baseURL+"1f934.png","1f934-1f3fd":baseURL+"1f934-1f3fd.png","1f934-1f3fb":baseURL+"1f934-1f3fb.png","1f934-1f3fc":baseURL+"1f934-1f3fc.png","1f934-1f3ff":baseURL+"1f934-1f3ff.png","1f936":baseURL+"1f936.png","1f936-1f3fb":baseURL+"1f936-1f3fb.png","1f936-1f3fd":baseURL+"1f936-1f3fd.png","1f936-1f3fe":baseURL+"1f936-1f3fe.png","1f936-1f3fc":baseURL+"1f936-1f3fc.png","1f936-1f3ff":baseURL+"1f936-1f3ff.png","1f385-1f3fb":baseURL+"1f385-1f3fb.png","1f385":baseURL+"1f385.png","1f469-1f680":baseURL+"1f469-1f680.png","1f385-1f3fe":baseURL+"1f385-1f3fe.png","1f385-1f3fc":baseURL+"1f385-1f3fc.png","1f385-1f3ff":baseURL+"1f385-1f3ff.png","1f9b8":baseURL+"1f9b8.png","1f9b8-1f3fc":baseURL+"1f9b8-1f3fc.png","1f9b8-1f3fb":baseURL+"1f9b8-1f3fb.png","1f9b8-1f3fe":baseURL+"1f9b8-1f3fe.png","1f9b8-1f3fd":baseURL+"1f9b8-1f3fd.png","1f9b8-2640":baseURL+"1f9b8-2640.png","1f9b8-1f3ff":baseURL+"1f9b8-1f3ff.png","1f9b8-1f3fb-2640":baseURL+"1f9b8-1f3fb-2640.png","1f9b8-1f3fd-2640":baseURL+"1f9b8-1f3fd-2640.png","1f9b8-1f3fc-2640":baseURL+"1f9b8-1f3fc-2640.png","1f9b8-1f3fe-2640":baseURL+"1f9b8-1f3fe-2640.png","1f9b8-1f3ff-2640":baseURL+"1f9b8-1f3ff-2640.png","1f9b8-2642":baseURL+"1f9b8-2642.png","1f9b8-1f3fb-2642":baseURL+"1f9b8-1f3fb-2642.png","1f9b8-1f3fc-2642":baseURL+"1f9b8-1f3fc-2642.png","1f9b8-1f3fd-2642":baseURL+"1f9b8-1f3fd-2642.png","1f9b8-1f3ff-2642":baseURL+"1f9b8-1f3ff-2642.png","1f9b8-1f3fe-2642":baseURL+"1f9b8-1f3fe-2642.png","1f9b9":baseURL+"1f9b9.png","1f9b9-1f3fc":baseURL+"1f9b9-1f3fc.png","1f9b9-1f3fb":baseURL+"1f9b9-1f3fb.png","1f9b9-1f3fd":baseURL+"1f9b9-1f3fd.png","1f9b9-1f3ff":baseURL+"1f9b9-1f3ff.png","1f9b9-1f3fb-2640":baseURL+"1f9b9-1f3fb-2640.png","1f385-1f3fd":baseURL+"1f385-1f3fd.png","1f478-1f3fd":baseURL+"1f478-1f3fd.png","1f9b9-2640":baseURL+"1f9b9-2640.png","1f9b9-1f3fc-2640":baseURL+"1f9b9-1f3fc-2640.png","1f9b9-1f3fe-2640":baseURL+"1f9b9-1f3fe-2640.png","1f9b9-1f3fe":baseURL+"1f9b9-1f3fe.png","1f9b9-1f3fc-2642":baseURL+"1f9b9-1f3fc-2642.png","1f934-1f3fe":baseURL+"1f934-1f3fe.png","1f468-1f3fd-2708":baseURL+"1f468-1f3fd-2708.png","1f9b9-1f3fd-2640":baseURL+"1f9b9-1f3fd-2640.png","1f9b9-2642":baseURL+"1f9b9-2642.png","1f9b9-1f3fb-2642":baseURL+"1f9b9-1f3fb-2642.png","1f9b9-1f3fd-2642":baseURL+"1f9b9-1f3fd-2642.png","1f9b9-1f3ff-2642":baseURL+"1f9b9-1f3ff-2642.png","1f9d9-1f3fb":baseURL+"1f9d9-1f3fb.png","1f9b9-1f3fe-2642":baseURL+"1f9b9-1f3fe-2642.png","1f9d9-1f3fe":baseURL+"1f9d9-1f3fe.png","1f9d9-1f3fc":baseURL+"1f9d9-1f3fc.png","1f9d9-1f3ff":baseURL+"1f9d9-1f3ff.png","1f9d9-1f3fd":baseURL+"1f9d9-1f3fd.png","1f9d9-1f3fb-2640":baseURL+"1f9d9-1f3fb-2640.png","1f9d9-2640":baseURL+"1f9d9-2640.png","1f9d9-1f3fc-2640":baseURL+"1f9d9-1f3fc-2640.png","1f9d9-1f3fd-2640":baseURL+"1f9d9-1f3fd-2640.png","1f9d9-1f3fe-2640":baseURL+"1f9d9-1f3fe-2640.png","1f9d9-2642":baseURL+"1f9d9-2642.png","1f9d9-1f3fc-2642":baseURL+"1f9d9-1f3fc-2642.png","1f9d9-1f3ff-2640":baseURL+"1f9d9-1f3ff-2640.png","1f9d9-1f3fb-2642":baseURL+"1f9d9-1f3fb-2642.png","1f9d9-1f3fe-2642":baseURL+"1f9d9-1f3fe-2642.png","1f9d9-1f3fd-2642":baseURL+"1f9d9-1f3fd-2642.png","1f9dd":baseURL+"1f9dd.png","1f9d9-1f3ff-2642":baseURL+"1f9d9-1f3ff-2642.png","1f9dd-1f3fb":baseURL+"1f9dd-1f3fb.png","1f9dd-1f3fc":baseURL+"1f9dd-1f3fc.png","1f9dd-1f3fd":baseURL+"1f9dd-1f3fd.png","1f9dd-1f3fe":baseURL+"1f9dd-1f3fe.png","1f9dd-1f3ff":baseURL+"1f9dd-1f3ff.png","1f9dd-2640":baseURL+"1f9dd-2640.png","1f9dd-1f3fe-2640":baseURL+"1f9dd-1f3fe-2640.png","1f9dd-1f3fb-2640":baseURL+"1f9dd-1f3fb-2640.png","1f9dd-1f3fd-2640":baseURL+"1f9dd-1f3fd-2640.png","1f9d9":baseURL+"1f9d9.png","1f9dd-1f3fc-2640":baseURL+"1f9dd-1f3fc-2640.png","1f9dd-1f3ff-2640":baseURL+"1f9dd-1f3ff-2640.png","1f9dd-1f3fb-2642":baseURL+"1f9dd-1f3fb-2642.png","1f9dd-1f3fc-2642":baseURL+"1f9dd-1f3fc-2642.png","1f9dd-2642":baseURL+"1f9dd-2642.png","1f9dd-1f3fd-2642":baseURL+"1f9dd-1f3fd-2642.png","1f9dd-1f3ff-2642":baseURL+"1f9dd-1f3ff-2642.png","1f9b9-1f3ff-2640":baseURL+"1f9b9-1f3ff-2640.png","1f9dd-1f3fe-2642":baseURL+"1f9dd-1f3fe-2642.png","1f9db-1f3fe":baseURL+"1f9db-1f3fe.png","1f9db-1f3fd":baseURL+"1f9db-1f3fd.png","1f9db-1f3fc-2640":baseURL+"1f9db-1f3fc-2640.png","1f9db-1f3fc":baseURL+"1f9db-1f3fc.png","1f9db-1f3fb-2640":baseURL+"1f9db-1f3fb-2640.png","1f9db-2640":baseURL+"1f9db-2640.png","1f9db-1f3fd-2640":baseURL+"1f9db-1f3fd-2640.png","1f9db-1f3fe-2640":baseURL+"1f9db-1f3fe-2640.png","1f9db-1f3ff-2640":baseURL+"1f9db-1f3ff-2640.png","1f9db-1f3fe-2642":baseURL+"1f9db-1f3fe-2642.png","1f9db":baseURL+"1f9db.png","1f9db-1f3fd-2642":baseURL+"1f9db-1f3fd-2642.png","1f9db-1f3ff":baseURL+"1f9db-1f3ff.png","1f9db-1f3fb":baseURL+"1f9db-1f3fb.png","1f9df":baseURL+"1f9df.png","1f9db-1f3ff-2642":baseURL+"1f9db-1f3ff-2642.png","1f9df-2642":baseURL+"1f9df-2642.png","1f9de-2640":baseURL+"1f9de-2640.png","1f9db-1f3fc-2642":baseURL+"1f9db-1f3fc-2642.png","1f9db-1f3fb-2642":baseURL+"1f9db-1f3fb-2642.png","1f9df-2640":baseURL+"1f9df-2640.png","1f9de-2642":baseURL+"1f9de-2642.png","1f9de":baseURL+"1f9de.png","1f9dc-1f3fb":baseURL+"1f9dc-1f3fb.png","1f9dc":baseURL+"1f9dc.png","1f9dc-1f3ff":baseURL+"1f9dc-1f3ff.png","1f9dc-1f3fc":baseURL+"1f9dc-1f3fc.png","1f9dc-1f3fd":baseURL+"1f9dc-1f3fd.png","1f9dc-2640":baseURL+"1f9dc-2640.png","1f9dc-1f3fe":baseURL+"1f9dc-1f3fe.png","1f9dc-1f3fb-2640":baseURL+"1f9dc-1f3fb-2640.png","1f9dc-1f3fd-2640":baseURL+"1f9dc-1f3fd-2640.png","1f9dc-1f3fc-2640":baseURL+"1f9dc-1f3fc-2640.png","1f9dc-1f3fe-2640":baseURL+"1f9dc-1f3fe-2640.png","1f9db-2642":baseURL+"1f9db-2642.png","1f9dc-1f3ff-2640":baseURL+"1f9dc-1f3ff-2640.png","1f9dc-1f3fb-2642":baseURL+"1f9dc-1f3fb-2642.png","1f9dc-2642":baseURL+"1f9dc-2642.png","1f9dc-1f3fe-2642":baseURL+"1f9dc-1f3fe-2642.png","1f9dc-1f3fc-2642":baseURL+"1f9dc-1f3fc-2642.png","1f9dc-1f3ff-2642":baseURL+"1f9dc-1f3ff-2642.png","1f9dc-1f3fd-2642":baseURL+"1f9dc-1f3fd-2642.png","1f9da":baseURL+"1f9da.png","1f9da-1f3fb":baseURL+"1f9da-1f3fb.png","1f9da-1f3ff":baseURL+"1f9da-1f3ff.png","1f9da-1f3fc":baseURL+"1f9da-1f3fc.png","1f9da-1f3fd":baseURL+"1f9da-1f3fd.png","1f9da-2640":baseURL+"1f9da-2640.png","1f9da-1f3fe":baseURL+"1f9da-1f3fe.png","1f9da-1f3fd-2640":baseURL+"1f9da-1f3fd-2640.png","1f9da-1f3fb-2640":baseURL+"1f9da-1f3fb-2640.png","1f9da-1f3fe-2640":baseURL+"1f9da-1f3fe-2640.png","1f9da-1f3ff-2640":baseURL+"1f9da-1f3ff-2640.png","1f9da-2642":baseURL+"1f9da-2642.png","1f9da-1f3fb-2642":baseURL+"1f9da-1f3fb-2642.png","1f9da-1f3fd-2642":baseURL+"1f9da-1f3fd-2642.png","1f9da-1f3fe-2642":baseURL+"1f9da-1f3fe-2642.png","1f9da-1f3fc-2642":baseURL+"1f9da-1f3fc-2642.png","1f9da-1f3ff-2642":baseURL+"1f9da-1f3ff-2642.png","1f47c":baseURL+"1f47c.png","1f47c-1f3fe":baseURL+"1f47c-1f3fe.png","1f47c-1f3fb":baseURL+"1f47c-1f3fb.png","1f47c-1f3fc":baseURL+"1f47c-1f3fc.png","1f47c-1f3fd":baseURL+"1f47c-1f3fd.png","1f47c-1f3ff":baseURL+"1f47c-1f3ff.png","1f930-1f3fb":baseURL+"1f930-1f3fb.png","1f930-1f3fd":baseURL+"1f930-1f3fd.png","1f930":baseURL+"1f930.png","1f930-1f3fc":baseURL+"1f930-1f3fc.png","1f930-1f3fe":baseURL+"1f930-1f3fe.png","1f930-1f3ff":baseURL+"1f930-1f3ff.png","1f931":baseURL+"1f931.png","1f931-1f3fc":baseURL+"1f931-1f3fc.png","1f931-1f3fb":baseURL+"1f931-1f3fb.png","1f931-1f3fe":baseURL+"1f931-1f3fe.png","1f931-1f3fd":baseURL+"1f931-1f3fd.png","1f931-1f3ff":baseURL+"1f931-1f3ff.png","1f647":baseURL+"1f647.png","1f647-1f3fc":baseURL+"1f647-1f3fc.png","1f647-1f3fb":baseURL+"1f647-1f3fb.png","1f647-1f3fd":baseURL+"1f647-1f3fd.png","1f647-1f3fe":baseURL+"1f647-1f3fe.png","1f647-2640":baseURL+"1f647-2640.png","1f647-1f3fe-2640":baseURL+"1f647-1f3fe-2640.png","1f647-1f3fc-2640":baseURL+"1f647-1f3fc-2640.png","1f647-1f3fb-2640":baseURL+"1f647-1f3fb-2640.png","1f647-1f3ff":baseURL+"1f647-1f3ff.png","1f647-1f3fd-2640":baseURL+"1f647-1f3fd-2640.png","1f647-1f3ff-2640":baseURL+"1f647-1f3ff-2640.png","1f647-2642":baseURL+"1f647-2642.png","1f647-1f3fb-2642":baseURL+"1f647-1f3fb-2642.png","1f647-1f3fc-2642":baseURL+"1f647-1f3fc-2642.png","1f647-1f3fd-2642":baseURL+"1f647-1f3fd-2642.png","1f647-1f3ff-2642":baseURL+"1f647-1f3ff-2642.png","1f481":baseURL+"1f481.png","1f481-1f3fb":baseURL+"1f481-1f3fb.png","1f481-1f3fc":baseURL+"1f481-1f3fc.png","1f647-1f3fe-2642":baseURL+"1f647-1f3fe-2642.png","1f481-1f3fd":baseURL+"1f481-1f3fd.png","1f481-1f3ff":baseURL+"1f481-1f3ff.png","1f481-1f3fe":baseURL+"1f481-1f3fe.png","1f481-2640":baseURL+"1f481-2640.png","1f481-1f3fb-2640":baseURL+"1f481-1f3fb-2640.png","1f481-2642":baseURL+"1f481-2642.png","1f481-1f3ff-2640":baseURL+"1f481-1f3ff-2640.png","1f481-1f3fd-2640":baseURL+"1f481-1f3fd-2640.png","1f481-1f3fc-2642":baseURL+"1f481-1f3fc-2642.png","1f481-1f3fd-2642":baseURL+"1f481-1f3fd-2642.png","1f481-1f3fe-2642":baseURL+"1f481-1f3fe-2642.png","1f481-1f3fb-2642":baseURL+"1f481-1f3fb-2642.png","1f481-1f3fe-2640":baseURL+"1f481-1f3fe-2640.png","1f481-1f3fc-2640":baseURL+"1f481-1f3fc-2640.png","1f481-1f3ff-2642":baseURL+"1f481-1f3ff-2642.png","1f645-1f3fc":baseURL+"1f645-1f3fc.png","1f645-1f3fe":baseURL+"1f645-1f3fe.png","1f645-1f3ff":baseURL+"1f645-1f3ff.png","1f645-1f3fb-2640":baseURL+"1f645-1f3fb-2640.png","1f645-1f3fe-2640":baseURL+"1f645-1f3fe-2640.png","1f645-2640":baseURL+"1f645-2640.png","1f645-1f3fc-2640":baseURL+"1f645-1f3fc-2640.png","1f645-1f3fd":baseURL+"1f645-1f3fd.png","1f645-1f3fb-2642":baseURL+"1f645-1f3fb-2642.png","1f645-1f3fd-2642":baseURL+"1f645-1f3fd-2642.png","1f645-1f3ff-2640":baseURL+"1f645-1f3ff-2640.png","1f645-1f3fe-2642":baseURL+"1f645-1f3fe-2642.png","1f645-1f3ff-2642":baseURL+"1f645-1f3ff-2642.png","1f646-1f3fb":baseURL+"1f646-1f3fb.png","1f646":baseURL+"1f646.png","1f646-1f3fc":baseURL+"1f646-1f3fc.png","1f645-2642":baseURL+"1f645-2642.png","1f646-1f3fd":baseURL+"1f646-1f3fd.png","1f645-1f3fc-2642":baseURL+"1f645-1f3fc-2642.png","1f646-1f3ff":baseURL+"1f646-1f3ff.png","1f646-1f3fe":baseURL+"1f646-1f3fe.png","1f646-1f3fb-2640":baseURL+"1f646-1f3fb-2640.png","1f646-2640":baseURL+"1f646-2640.png","1f646-1f3fc-2640":baseURL+"1f646-1f3fc-2640.png","1f9da-1f3fc-2640":baseURL+"1f9da-1f3fc-2640.png","1f646-2642":baseURL+"1f646-2642.png","1f646-1f3fe-2640":baseURL+"1f646-1f3fe-2640.png","1f646-1f3fd-2640":baseURL+"1f646-1f3fd-2640.png","1f646-1f3ff-2640":baseURL+"1f646-1f3ff-2640.png","1f646-1f3fb-2642":baseURL+"1f646-1f3fb-2642.png","1f646-1f3fc-2642":baseURL+"1f646-1f3fc-2642.png","1f646-1f3fd-2642":baseURL+"1f646-1f3fd-2642.png","1f646-1f3fe-2642":baseURL+"1f646-1f3fe-2642.png","1f64b-1f3fb":baseURL+"1f64b-1f3fb.png","1f646-1f3ff-2642":baseURL+"1f646-1f3ff-2642.png","1f64b":baseURL+"1f64b.png","1f64b-1f3fc":baseURL+"1f64b-1f3fc.png","1f645":baseURL+"1f645.png","1f64b-1f3ff":baseURL+"1f64b-1f3ff.png","1f64b-1f3fd":baseURL+"1f64b-1f3fd.png","1f64b-1f3fb-2640":baseURL+"1f64b-1f3fb-2640.png","1f64b-1f3fd-2640":baseURL+"1f64b-1f3fd-2640.png","1f645-1f3fb":baseURL+"1f645-1f3fb.png","1f64b-1f3fc-2640":baseURL+"1f64b-1f3fc-2640.png","1f64b-1f3ff-2640":baseURL+"1f64b-1f3ff-2640.png","1f64b-1f3fc-2642":baseURL+"1f64b-1f3fc-2642.png","1f64b-1f3fe-2640":baseURL+"1f64b-1f3fe-2640.png","1f645-1f3fd-2640":baseURL+"1f645-1f3fd-2640.png","1f64b-1f3fe":baseURL+"1f64b-1f3fe.png","1f64b-2640":baseURL+"1f64b-2640.png","1f64b-2642":baseURL+"1f64b-2642.png","1f64b-1f3fd-2642":baseURL+"1f64b-1f3fd-2642.png","1f64b-1f3fb-2642":baseURL+"1f64b-1f3fb-2642.png","1f64b-1f3fe-2642":baseURL+"1f64b-1f3fe-2642.png","1f64b-1f3ff-2642":baseURL+"1f64b-1f3ff-2642.png","1f926":baseURL+"1f926.png","1f926-1f3fb-2640":baseURL+"1f926-1f3fb-2640.png","1f926-2640":baseURL+"1f926-2640.png","1f926-1f3fe":baseURL+"1f926-1f3fe.png","1f926-1f3fd":baseURL+"1f926-1f3fd.png","1f926-1f3fb":baseURL+"1f926-1f3fb.png","1f926-1f3fc":baseURL+"1f926-1f3fc.png","1f926-1f3ff":baseURL+"1f926-1f3ff.png","1f926-1f3fc-2640":baseURL+"1f926-1f3fc-2640.png","1f926-1f3ff-2640":baseURL+"1f926-1f3ff-2640.png","1f926-1f3fe-2640":baseURL+"1f926-1f3fe-2640.png","1f926-1f3fd-2640":baseURL+"1f926-1f3fd-2640.png","1f926-2642":baseURL+"1f926-2642.png","1f926-1f3fb-2642":baseURL+"1f926-1f3fb-2642.png","1f926-1f3ff-2642":baseURL+"1f926-1f3ff-2642.png","1f926-1f3fe-2642":baseURL+"1f926-1f3fe-2642.png","1f926-1f3fd-2642":baseURL+"1f926-1f3fd-2642.png","1f926-1f3fc-2642":baseURL+"1f926-1f3fc-2642.png","1f937-1f3fb":baseURL+"1f937-1f3fb.png","1f937-1f3fc":baseURL+"1f937-1f3fc.png","1f937-1f3fe":baseURL+"1f937-1f3fe.png","1f937-1f3fd":baseURL+"1f937-1f3fd.png","1f937-2640":baseURL+"1f937-2640.png","1f937-1f3fb-2640":baseURL+"1f937-1f3fb-2640.png","1f937-1f3fd-2640":baseURL+"1f937-1f3fd-2640.png","1f937-1f3fe-2640":baseURL+"1f937-1f3fe-2640.png","1f937":baseURL+"1f937.png","1f937-1f3ff-2640":baseURL+"1f937-1f3ff-2640.png","1f937-1f3ff":baseURL+"1f937-1f3ff.png","1f937-1f3fc-2640":baseURL+"1f937-1f3fc-2640.png","1f937-1f3fb-2642":baseURL+"1f937-1f3fb-2642.png","1f937-1f3fd-2642":baseURL+"1f937-1f3fd-2642.png","1f937-1f3fe-2642":baseURL+"1f937-1f3fe-2642.png","1f937-1f3fc-2642":baseURL+"1f937-1f3fc-2642.png","1f64e-1f3fd":baseURL+"1f64e-1f3fd.png","1f64e":baseURL+"1f64e.png","1f64e-1f3fe":baseURL+"1f64e-1f3fe.png","1f64e-1f3fb":baseURL+"1f64e-1f3fb.png","1f64e-1f3ff":baseURL+"1f64e-1f3ff.png","1f64e-1f3fb-2640":baseURL+"1f64e-1f3fb-2640.png","1f64e-2640":baseURL+"1f64e-2640.png","1f64e-1f3fc-2640":baseURL+"1f64e-1f3fc-2640.png","1f64e-1f3fd-2640":baseURL+"1f64e-1f3fd-2640.png","1f64e-2642":baseURL+"1f64e-2642.png","1f64e-1f3fb-2642":baseURL+"1f64e-1f3fb-2642.png","1f64e-1f3fe-2640":baseURL+"1f64e-1f3fe-2640.png","1f64e-1f3fc-2642":baseURL+"1f64e-1f3fc-2642.png","1f64e-1f3ff-2640":baseURL+"1f64e-1f3ff-2640.png","1f64e-1f3fd-2642":baseURL+"1f64e-1f3fd-2642.png","1f64d-1f3fb":baseURL+"1f64d-1f3fb.png","1f64e-1f3ff-2642":baseURL+"1f64e-1f3ff-2642.png","1f64d-1f3fc":baseURL+"1f64d-1f3fc.png","1f64d-1f3ff":baseURL+"1f64d-1f3ff.png","1f64d-1f3fb-2640":baseURL+"1f64d-1f3fb-2640.png","1f64e-1f3fe-2642":baseURL+"1f64e-1f3fe-2642.png","1f64d-2640":baseURL+"1f64d-2640.png","1f64d-1f3fe":baseURL+"1f64d-1f3fe.png","1f64e-1f3fc":baseURL+"1f64e-1f3fc.png","1f64d-1f3fd-2640":baseURL+"1f64d-1f3fd-2640.png","1f64d-1f3ff-2640":baseURL+"1f64d-1f3ff-2640.png","1f64d-1f3fe-2640":baseURL+"1f64d-1f3fe-2640.png","1f64d-2642":baseURL+"1f64d-2642.png","1f64d-1f3fe-2642":baseURL+"1f64d-1f3fe-2642.png","1f64d-1f3fd":baseURL+"1f64d-1f3fd.png","1f64d-1f3ff-2642":baseURL+"1f64d-1f3ff-2642.png","1f937-2642":baseURL+"1f937-2642.png","1f937-1f3ff-2642":baseURL+"1f937-1f3ff-2642.png","1f64d-1f3fb-2642":baseURL+"1f64d-1f3fb-2642.png","1f64d-1f3fd-2642":baseURL+"1f64d-1f3fd-2642.png","1f64d-1f3fc-2642":baseURL+"1f64d-1f3fc-2642.png","1f487-1f3fb":baseURL+"1f487-1f3fb.png","1f487":baseURL+"1f487.png","1f487-1f3fc":baseURL+"1f487-1f3fc.png","1f487-1f3fe":baseURL+"1f487-1f3fe.png","1f487-1f3fc-2640":baseURL+"1f487-1f3fc-2640.png","1f487-1f3fb-2640":baseURL+"1f487-1f3fb-2640.png","1f487-1f3ff":baseURL+"1f487-1f3ff.png","1f64d-1f3fc-2640":baseURL+"1f64d-1f3fc-2640.png","1f487-2640":baseURL+"1f487-2640.png","1f487-1f3ff-2640":baseURL+"1f487-1f3ff-2640.png","1f64d":baseURL+"1f64d.png","1f487-1f3fb-2642":baseURL+"1f487-1f3fb-2642.png","1f487-1f3fd":baseURL+"1f487-1f3fd.png","1f487-2642":baseURL+"1f487-2642.png","1f487-1f3fe-2640":baseURL+"1f487-1f3fe-2640.png","1f487-1f3fd-2642":baseURL+"1f487-1f3fd-2642.png","1f487-1f3ff-2642":baseURL+"1f487-1f3ff-2642.png","1f487-1f3fc-2642":baseURL+"1f487-1f3fc-2642.png","1f487-1f3fe-2642":baseURL+"1f487-1f3fe-2642.png","1f486-1f3fc":baseURL+"1f486-1f3fc.png","1f486-1f3fd":baseURL+"1f486-1f3fd.png","1f486-1f3fe":baseURL+"1f486-1f3fe.png","1f486-1f3fb":baseURL+"1f486-1f3fb.png","1f486-2640":baseURL+"1f486-2640.png","1f486":baseURL+"1f486.png","1f486-1f3ff":baseURL+"1f486-1f3ff.png","1f487-1f3fd-2640":baseURL+"1f487-1f3fd-2640.png","1f486-1f3fb-2640":baseURL+"1f486-1f3fb-2640.png","1f486-1f3fd-2640":baseURL+"1f486-1f3fd-2640.png","1f486-1f3fc-2640":baseURL+"1f486-1f3fc-2640.png","1f486-1f3ff-2640":baseURL+"1f486-1f3ff-2640.png","1f486-1f3fe-2640":baseURL+"1f486-1f3fe-2640.png","1f486-1f3fb-2642":baseURL+"1f486-1f3fb-2642.png","1f486-1f3fc-2642":baseURL+"1f486-1f3fc-2642.png","1f486-1f3fd-2642":baseURL+"1f486-1f3fd-2642.png","1f486-1f3fe-2642":baseURL+"1f486-1f3fe-2642.png","1f9d6":baseURL+"1f9d6.png","1f9d6-1f3fc":baseURL+"1f9d6-1f3fc.png","1f486-1f3ff-2642":baseURL+"1f486-1f3ff-2642.png","1f9d6-1f3fb":baseURL+"1f9d6-1f3fb.png","1f9d6-1f3fe":baseURL+"1f9d6-1f3fe.png","1f9d6-1f3ff":baseURL+"1f9d6-1f3ff.png","1f9d6-1f3fc-2640":baseURL+"1f9d6-1f3fc-2640.png","1f486-2642":baseURL+"1f486-2642.png","1f9d6-2640":baseURL+"1f9d6-2640.png","1f9d6-1f3fd-2640":baseURL+"1f9d6-1f3fd-2640.png","1f9d6-1f3fb-2640":baseURL+"1f9d6-1f3fb-2640.png","1f9d6-1f3ff-2640":baseURL+"1f9d6-1f3ff-2640.png","1f9d6-1f3fe-2640":baseURL+"1f9d6-1f3fe-2640.png","1f9d6-2642":baseURL+"1f9d6-2642.png","1f485":baseURL+"1f485.png","1f9d6-1f3ff-2642":baseURL+"1f9d6-1f3ff-2642.png","1f485-1f3fb":baseURL+"1f485-1f3fb.png","1f9d6-1f3fb-2642":baseURL+"1f9d6-1f3fb-2642.png","1f9d6-1f3fe-2642":baseURL+"1f9d6-1f3fe-2642.png","1f9d6-1f3fd-2642":baseURL+"1f9d6-1f3fd-2642.png","1f9d6-1f3fc-2642":baseURL+"1f9d6-1f3fc-2642.png","1f485-1f3fd":baseURL+"1f485-1f3fd.png","1f485-1f3fe":baseURL+"1f485-1f3fe.png","1f9d6-1f3fd":baseURL+"1f9d6-1f3fd.png","1f485-1f3fc":baseURL+"1f485-1f3fc.png","1f933":baseURL+"1f933.png","1f933-1f3fb":baseURL+"1f933-1f3fb.png","1f485-1f3ff":baseURL+"1f485-1f3ff.png","1f933-1f3fc":baseURL+"1f933-1f3fc.png","1f933-1f3fd":baseURL+"1f933-1f3fd.png","1f933-1f3fe":baseURL+"1f933-1f3fe.png","1f933-1f3ff":baseURL+"1f933-1f3ff.png","1f483-1f3fc":baseURL+"1f483-1f3fc.png","1f483-1f3fe":baseURL+"1f483-1f3fe.png","1f483-1f3fd":baseURL+"1f483-1f3fd.png","1f483-1f3ff":baseURL+"1f483-1f3ff.png","1f483":baseURL+"1f483.png","1f483-1f3fb":baseURL+"1f483-1f3fb.png","1f57a":baseURL+"1f57a.png","1f57a-1f3fb":baseURL+"1f57a-1f3fb.png","1f46f":baseURL+"1f46f.png","1f57a-1f3fe":baseURL+"1f57a-1f3fe.png","1f574":baseURL+"1f574.png","1f57a-1f3fc":baseURL+"1f57a-1f3fc.png","1f46f-2640":baseURL+"1f46f-2640.png","1f57a-1f3ff":baseURL+"1f57a-1f3ff.png","1f46f-2642":baseURL+"1f46f-2642.png","1f57a-1f3fd":baseURL+"1f57a-1f3fd.png","1f574-1f3fc":baseURL+"1f574-1f3fc.png","1f574-1f3fb":baseURL+"1f574-1f3fb.png","1f574-1f3fe":baseURL+"1f574-1f3fe.png","1f574-1f3ff":baseURL+"1f574-1f3ff.png","1f6b6-1f3fc":baseURL+"1f6b6-1f3fc.png","1f574-1f3fd":baseURL+"1f574-1f3fd.png","1f6b6-1f3fb":baseURL+"1f6b6-1f3fb.png","1f6b6-1f3ff":baseURL+"1f6b6-1f3ff.png","1f6b6-2640":baseURL+"1f6b6-2640.png","1f6b6-1f3fc-2640":baseURL+"1f6b6-1f3fc-2640.png","1f6b6-1f3fd":baseURL+"1f6b6-1f3fd.png","1f6b6-1f3fe":baseURL+"1f6b6-1f3fe.png","1f6b6":baseURL+"1f6b6.png","1f6b6-1f3fe-2640":baseURL+"1f6b6-1f3fe-2640.png","1f6b6-1f3ff-2640":baseURL+"1f6b6-1f3ff-2640.png","1f6b6-1f3fd-2640":baseURL+"1f6b6-1f3fd-2640.png","1f6b6-1f3fb-2640":baseURL+"1f6b6-1f3fb-2640.png","1f6b6-1f3fb-2642":baseURL+"1f6b6-1f3fb-2642.png","1f6b6-1f3fc-2642":baseURL+"1f6b6-1f3fc-2642.png","1f6b6-1f3fd-2642":baseURL+"1f6b6-1f3fd-2642.png","1f6b6-1f3ff-2642":baseURL+"1f6b6-1f3ff-2642.png","1f6b6-1f3fe-2642":baseURL+"1f6b6-1f3fe-2642.png","1f3c3-1f3fc":baseURL+"1f3c3-1f3fc.png","1f3c3":baseURL+"1f3c3.png","1f3c3-1f3fc-2640":baseURL+"1f3c3-1f3fc-2640.png","1f3c3-1f3ff":baseURL+"1f3c3-1f3ff.png","1f3c3-2640":baseURL+"1f3c3-2640.png","1f3c3-1f3fb-2640":baseURL+"1f3c3-1f3fb-2640.png","1f3c3-1f3fe-2640":baseURL+"1f3c3-1f3fe-2640.png","1f3c3-1f3fd-2640":baseURL+"1f3c3-1f3fd-2640.png","1f3c3-1f3ff-2640":baseURL+"1f3c3-1f3ff-2640.png","1f3c3-1f3fc-2642":baseURL+"1f3c3-1f3fc-2642.png","1f3c3-1f3fd-2642":baseURL+"1f3c3-1f3fd-2642.png","1f3c3-2642":baseURL+"1f3c3-2642.png","1f3c3-1f3fd":baseURL+"1f3c3-1f3fd.png","1f3c3-1f3fe-2642":baseURL+"1f3c3-1f3fe-2642.png","1f3c3-1f3fe":baseURL+"1f3c3-1f3fe.png","1f3c3-1f3ff-2642":baseURL+"1f3c3-1f3ff-2642.png","1f3c3-1f3fb":baseURL+"1f3c3-1f3fb.png","1f46c":baseURL+"1f46c.png","1f46d":baseURL+"1f46d.png","1f3c3-1f3fb-2642":baseURL+"1f3c3-1f3fb-2642.png","1f469-2764-1f468":baseURL+"1f469-2764-1f468.png","1f491":baseURL+"1f491.png","1f468-2764-1f468":baseURL+"1f468-2764-1f468.png","1f6b6-2642":baseURL+"1f6b6-2642.png","1f48f":baseURL+"1f48f.png","1f469-2764-1f48b-1f469":baseURL+"1f469-2764-1f48b-1f469.png","1f468-1f469-1f466":baseURL+"1f468-1f469-1f466.png","1f469-2764-1f48b-1f468":baseURL+"1f469-2764-1f48b-1f468.png","1f468-2764-1f48b-1f468":baseURL+"1f468-2764-1f48b-1f468.png","1f468-1f469-1f467-1f466":baseURL+"1f468-1f469-1f467-1f466.png","1f468-1f469-1f467":baseURL+"1f468-1f469-1f467.png","1f46a":baseURL+"1f46a.png","1f468-1f469-1f467-1f467":baseURL+"1f468-1f469-1f467-1f467.png","1f46b":baseURL+"1f46b.png","1f469-1f469-1f467":baseURL+"1f469-1f469-1f467.png","1f469-1f469-1f467-1f466":baseURL+"1f469-1f469-1f467-1f466.png","1f469-1f469-1f466":baseURL+"1f469-1f469-1f466.png","1f469-1f469-1f466-1f466":baseURL+"1f469-1f469-1f466-1f466.png","1f468-1f468-1f466":baseURL+"1f468-1f468-1f466.png","1f468-1f468-1f467-1f466":baseURL+"1f468-1f468-1f467-1f466.png","1f468-1f468-1f467":baseURL+"1f468-1f468-1f467.png","1f468-1f468-1f467-1f467":baseURL+"1f468-1f468-1f467-1f467.png","1f469-2764-1f469":baseURL+"1f469-2764-1f469.png","1f468-1f468-1f466-1f466":baseURL+"1f468-1f468-1f466-1f466.png","1f469-1f466-1f466":baseURL+"1f469-1f466-1f466.png","1f468-1f466":baseURL+"1f468-1f466.png","1f469-1f467-1f466":baseURL+"1f469-1f467-1f466.png","1f469-1f467":baseURL+"1f469-1f467.png","1f468-1f467-1f466":baseURL+"1f468-1f467-1f466.png","1f469-1f467-1f467":baseURL+"1f469-1f467-1f467.png","1f468-1f467-1f467":baseURL+"1f468-1f467-1f467.png","1f468-1f469-1f466-1f466":baseURL+"1f468-1f469-1f466-1f466.png","1f9e5":baseURL+"1f9e5.png"},_defineProperty(_$2122$2195$2196$,"1f45a","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f455","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f468-1f466-1f466",baseURL+"1f468-1f466-1f466.png"),_defineProperty(_$2122$2195$2196$,"1f457","data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAqSSURBVHic7Zt/rGVXVcc/a619zntv3nQ6/UGnzAxpScvYiFQaaKRUfsWGisZGJDYQWkHEQRTakiASFTMR2xiLTRFs7Fg10lEQTI2JJfwIv2piR1NCsCFQi7YaOu3Yzsx7M+/Nuz/O3ss/zrnn/nj3zdx33z3EBFZy8u6+75y11/e7vmvtfc+5F35oP9gmTTn2/YeeBi4G/z05ePOHp/Nx/4dAfh94Wg7etHu2EZamTTj1/fdmwEXlgJPTe5JT1Ytdlc+ZWyMEELfvrn3rFgjok6ew8PytB7beQhNOi9TeI15x63UWN20xdU/hZZW6p73A/8wivkFrhIBWq72391pSmloBrbXWSfd6uPcMp05tjRCwfOz4HqTqrzo9AUvHT5ykR4D7nhmEts4a6QEiuqvb6cbVlRW8SHPT+vEizq2urNDtdKOIXTzLGHvWiAJ2X/KCFwFWDb/q+w8tAYeBz0N6QA7+0tha9l/5m0swfgH89cA1wLnVvwzksiZibYQA8BeObDF2Aj9dHvrH/q5D/0iU2+W+t34dwN/1iZfj9jvgN7ChKv2FTUTaEAFypg2W4rwR9Rt8/6E7cRdc3g9uZ7imMWuIAJ4GXnqWcwz44Jm5GjDhyBZjGmvNbITc/70Br4824LMpAnjQU2KWB8n/qYlQmymB5bl/STvWngBm1bj+0/b+1+EZ+Rqyxj4Ntt72l+8T97tm4ctFbp3/63f8ySx8jVpTTZC5FA6uFqc/AGx1A/P04orcN4uYxlljCgB47o133yLw0a34cPw9F/7D+/50VjGNWmMKADgalv5sx6n522T6Tcx/r8liY9mHhhUA8B8/+bu3AndPdbFwy75//oOPzTaiYWtUAQCt5WOfiJp/ZIq5uojc30RMg9a4AgAeuvymxwiyT1VBBEHWz+zgOLiTUoLoj7368UNXNB1b4woAaL/mwWLvj1/K+Xt2s/28neQLC1gIiPTu9jixKGivrbG6tMSx7x3he48+GXm8+dia2QmOmMx1lzZ9UT7FNVPY94WA/8/2fSmB4vi22DoSfLVw8RORbK5AQ0Kl7AmIk7qR1lpk7ZTTPho8Hd9WwErjsTXaBA9wQH8sP3y7iX4w4ZgZIoqTsBCwYJgFLARCMDqtNqdXVokxoohHj3e8qfP5Dwn42Webzhq7CeEgy3Pb7gkhuw2FLMvIsgzECXlGyDKyLCfLM7JqPL+wQOxGpLo+aHj1t/Xy5/1dfPyzTcXZGAEvW/y5u7KQv9cNspCR5zmoYGY18JKIvCQj7/+N3W65QoiQWbj6Rtu3+KnisS82EWcjBDy44+c/nGf5b4kJwQJ5nhNCjguEPNTAs6yf/WCGhcDc/DxFu1u2BhFUhBDs2jeHH/G/7Xzna7OOdeY94HPnvek3MgsfFxGSgFkghEAikQSCVbUfAmaGmmJqqFk9Xls5zcqJZYqiIMYC9XKv0OnGX3vD8t/fO8t4Z0rAl85/8yst6FfMQl6QMDNCCKgZ3VSUYGvghpmi2gfee18cnjvyDLGINQkBJcbYbXtx3fXPfvqhWcU8MwIeuvCm50vQRyzo7oQjVUbLzi90JdXjGrxZlf0+eFNFzFg++hyt02vEGIkx4uXKQIzxaKfTetlPHfvMU7OIeyYEPML+rLOn/RUzuxbVSvpWKcCIQBJfB77Mvvblr1ofrdXTnDp2gqKINQnqAimSYjx8YmHHa3/mux9rbzX2mWyEihcUd2eWXxvM6JLIQz/7ZoZ7RFWHpT4AXkfAqyrbzjmH1skVVJUYyyPFREhGofEV57VXPgK8d6uxb1kBhy95x+vykH3JzASFJFJubgaaWisVG4OvAMsIAarK8tHn6LRaQyqQlBCHGKPHFK+/+on7trQ8bomAb+66eTHt2P7NzOwys0Cnbnz97BeeKIR1NT8KdhwBrZVVVk8s1+CLIpJSJHMlxoIixiezXF7y4m/dM/WeeUsloDvP/aPM7LJgRlIh12HpqyrRE5myrs7HAR58T0SYW5infWp16JwYFUlOrjmq8dJYFLcDt06LYWoFPHrFba/Ng3zZzMTU6KhjtcR7gIwOBTKmxseRIAPge/cKlp46SkqRlBIppVoNWVJSisQYU4zpdT/67Y9OtTRORcC3Xnwgz+3Uo2a2T1VxFdykX9sVEFToiE+ccVGpdn99ElaePU633R4gIJFSRKIjyXukfGc5O3Xly79+sLtZLFOVwHy28uumYZ9qmdkigNVg+tmOClYRcCYSemB7BAwe+cI8qYiIpOqIpCQkTYQCkiRU9Irz47n7gU3fPt+0Ap546W07LSx8V1UvKLOspCAjwEoSOppwkQ0JGAU7joDY7nD6+MlKAf1SSCmhhUN//Gzb5i5/0b8e2NRXcjatgJAt3mIVeKuzv0GNCxvKfh34MSQAWJ7Xu8nySPUBiRCVKIkk6Xkau+8B7tgMnk0p4Jkr37/o27c9aWIXqipiSmGsk34v2Jb5+oyPyfJgzYtWIYnUwa09u0RKCa/uGA+qIUTwWPWHFI/ZnF560VcPTLwsbu6e4OI578w0XBjMCGagWm16wrqtLCrlR9zRba6M6wNSH/SI6JEgguVh6PzSZzkvqvTiySxcQEd+eTOQNlUCWWb7rcqkiuJZqYI6kwPZTypY2EDqY1RQ4u1nH6hJsBDwolSAiJBSqudzTVinP44pvRuY+GnSxCVw/DV3vMpUHqrBq5ByG5byAAExCG5nJ2AIeAW4B7wXYGx1KVbXcPe6DHqv3R3txHJJ9PL9IvkrL/jabz88Ca6JFRCC3SRQ12sKw/U+2tiSCYzJdI9AhKE6H309SIxWc/UA91RQjwNokRAXkieC+M3ARARM1AMcFxX52brbmyLBhmpyXLMbtzKUj8dYV+d11kfKAqj3CqN9oJ7PtP58YWqY6g3e+5LxLAg4ff2dV5nanjoAs3LSM67r65fGoZrvgR0Ezkg51FGOKGjUb7ChVcjU9py+7q6zfUsNmLAEjPCqobodkLxqyeFwPUupEh3I5Di5D2Z5HPDB81XBhx8PmFldCqIJYbBM/FrgGzMhQFWuEtE66GTrP7QMgVD64Ces87OZqOCxrP9eHyhjq0CroZ7KZwoiuHPVJH4nIkCwl9SJBMS0rtVBEPXT3lFyRpa1wXMnNhUkDV8zSATBkFhuvct30pWTuJ2MAOWiumFRsb5B9sus05f3mGWNzYKnbIRIfxUYAl/G2B+7g+hFk/idjACR86EfvOvG2a8Gm6/zCW3UR01Ib2Vx76nggkn8TbYVFh4QKHrLlfQm20DOMpr1EbVMZWPmGPQt2l9FBArwByZyO+n8/vo7F8nnr0bkJ3xx7g8Hg1h3bm6Qh6nlPtbaBXSK8fNVq4OstD+A6L/RXn1EvvCbq5O43XR0/oufNsLy50Cu2/Ck3GBuxr9y60Ron/GGzxcpdrxBPnNj3IzbqdPjb/nzXSDXAFeVv+fRXSi7cD+X+exiMtsxre+x1o0naXWfAZZw+V9IRxF5CvgG+MPyyV89Oo3bmT8cBfD9978T5B5gVjLoIvJuufetfzEjf7U1QgCAv/2vdpJl16C8giSXIn4xsJvyd0Dbq9POq/6eqP6uAMvAEVyeQdITCIfxuYfl4I3LTcX6Q/tBtv8DEkUc+AOqr70AAAAASUVORK5CYII="),_defineProperty(_$2122$2195$2196$,"1f456","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f459",baseURL+"1f459.png"),_defineProperty(_$2122$2195$2196$,"1f458",baseURL+"1f458.png"),_defineProperty(_$2122$2195$2196$,"1f454","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f460",baseURL+"1f460.png"),_defineProperty(_$2122$2195$2196$,"1f461",baseURL+"1f461.png"),_defineProperty(_$2122$2195$2196$,"1f97c",baseURL+"1f97c.png"),_defineProperty(_$2122$2195$2196$,"1f97e",baseURL+"1f97e.png"),_defineProperty(_$2122$2195$2196$,"1f469-1f469-1f467-1f467",baseURL+"1f469-1f469-1f467-1f467.png"),_defineProperty(_$2122$2195$2196$,"1f45e",baseURL+"1f45e.png"),_defineProperty(_$2122$2195$2196$,"1f45f",baseURL+"1f45f.png"),_defineProperty(_$2122$2195$2196$,"1f9e6",baseURL+"1f9e6.png"),_defineProperty(_$2122$2195$2196$,"1f9e3",baseURL+"1f9e3.png"),_defineProperty(_$2122$2195$2196$,"1f97f",baseURL+"1f97f.png"),_defineProperty(_$2122$2195$2196$,"1f9e4",baseURL+"1f9e4.png"),_defineProperty(_$2122$2195$2196$,"1f9e2",baseURL+"1f9e2.png"),_defineProperty(_$2122$2195$2196$,"26d1",baseURL+"26d1.png"),_defineProperty(_$2122$2195$2196$,"1f3a9",baseURL+"1f3a9.png"),_defineProperty(_$2122$2195$2196$,"1f393",baseURL+"1f393.png"),_defineProperty(_$2122$2195$2196$,"1f452",baseURL+"1f452.png"),_defineProperty(_$2122$2195$2196$,"1f451",baseURL+"1f451.png"),_defineProperty(_$2122$2195$2196$,"1f45d",baseURL+"1f45d.png"),_defineProperty(_$2122$2195$2196$,"1f45b",baseURL+"1f45b.png"),_defineProperty(_$2122$2195$2196$,"1f45c",baseURL+"1f45c.png"),_defineProperty(_$2122$2195$2196$,"1f392",baseURL+"1f392.png"),_defineProperty(_$2122$2195$2196$,"1f576",baseURL+"1f576.png"),_defineProperty(_$2122$2195$2196$,"1f453",baseURL+"1f453.png"),_defineProperty(_$2122$2195$2196$,"1f469-1f466",baseURL+"1f469-1f466.png"),_defineProperty(_$2122$2195$2196$,"1f9b0",baseURL+"1f9b0.png"),_defineProperty(_$2122$2195$2196$,"1f462",baseURL+"1f462.png"),_defineProperty(_$2122$2195$2196$,"1f9b3",baseURL+"1f9b3.png"),_defineProperty(_$2122$2195$2196$,"1f9b2",baseURL+"1f9b2.png"),_defineProperty(_$2122$2195$2196$,"1f1ff",baseURL+"1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1fa",baseURL+"1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1fd",baseURL+"1f1fd.png"),_defineProperty(_$2122$2195$2196$,"1f4bc",baseURL+"1f4bc.png"),_defineProperty(_$2122$2195$2196$,"1f1fc",baseURL+"1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1fb",baseURL+"1f1fb.png"),_defineProperty(_$2122$2195$2196$,"1f1f9",baseURL+"1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1f8",baseURL+"1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1f5",baseURL+"1f1f5.png"),_defineProperty(_$2122$2195$2196$,"1f302",baseURL+"1f302.png"),_defineProperty(_$2122$2195$2196$,"1f1f6",baseURL+"1f1f6.png"),_defineProperty(_$2122$2195$2196$,"1f1f2",baseURL+"1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f97d",baseURL+"1f97d.png"),_defineProperty(_$2122$2195$2196$,"1f9b1",baseURL+"1f9b1.png"),_defineProperty(_$2122$2195$2196$,"1f1f1",baseURL+"1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1f7",baseURL+"1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1ef",baseURL+"1f1ef.png"),_defineProperty(_$2122$2195$2196$,"1f1ee",baseURL+"1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1ed",baseURL+"1f1ed.png"),_defineProperty(_$2122$2195$2196$,"1f1eb",baseURL+"1f1eb.png"),_defineProperty(_$2122$2195$2196$,"1f468-1f467",baseURL+"1f468-1f467.png"),_defineProperty(_$2122$2195$2196$,"1f1f3",baseURL+"1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1f4",baseURL+"1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1e9",baseURL+"1f1e9.png"),_defineProperty(_$2122$2195$2196$,"1f1e8",baseURL+"1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1f0",baseURL+"1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1e7",baseURL+"1f1e7.png"),_defineProperty(_$2122$2195$2196$,"1f697","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f1ec",baseURL+"1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f68e","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f695","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f68c","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f1ea",baseURL+"1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1e6",baseURL+"1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f693","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f3ce","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f691","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f69a","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f692","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f690","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f6b2","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f3cd","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f6f4",baseURL+"1f6f4.png"),_defineProperty(_$2122$2195$2196$,"1f6a8","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f69c","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f694","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f699","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f1fe",baseURL+"1f1fe.png"),_defineProperty(_$2122$2195$2196$,"1f6f5",baseURL+"1f6f5.png"),_defineProperty(_$2122$2195$2196$,"1f6a1","data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAvRSURBVHic7ZtrcFXXdcd/65z70PuFHuiBsGSQha6EBLISHMcJjpkm1O407Uw9bdN2pnbjJJPppM64r6Q1tGnjiesOybRua0ycjhO3NjSBCTF24xiwUXjElgFJVyAh3kIvEDIIpPs456x+uLpCEhcG3XMFH+r/zJq52uestdf5n7XW3mfvLfgI/78h8R9lJTUXUboEgo5IlzjaZhtpB4eG2q/eSQfnG1MEVOY25Fu+cEANaTZU6xQCICtAL6G0YRAUpcs2nLbBwd6jgH0H/U4Z5OaXV3tKSvorTZwAajQj1KEEgGrghECbqgQx7C4bIzg01HMikZWvrX/2ERsd9OZ4gxu+/vWJ1D9G8pgioLy45rhCu6p0GtDheJyOgYHyY7Dbmq0UCAR8IyPhpaZjNKtQh0MA4V4E/1QameaRqiV392lG+s41az/TExqf8ISjUR/QB9oeHvmwXAyz28hK+8757vaeLVu23JGIukZAYW0NostVtF6gQWE5SBlwVNFOQTtBD5uO2Xn2Qnd/ImPxNKq856419R9r+bI/K7PEcND6+loJhUKRnW++vTcSCh3KLMjue2jNmucc2+Fob+/RiqLi2itjV6xL4dCrKtIJ2mV67Pe/+81vDtw2AhLhBm+6GUgHgtMLZkTl8IUL3WMAW3ftOWWIsXh0dJTx8QlM0yQSierRnmOCGLpvx1tDTSsbF4Yj0eiv9ux958m//8aacChkHQ52rcvOzSs1TGMFaLNgjH73b58qu2ME3AjXCiZ1ggRQbQaagMtAsHFVS6jlwU8+YhpQUlyMiJCRmUFebg7btr/BUO/JN/qOnVxrOfb2aDh6Ljs788vhSHRoaXNjbl5xoc+wnYstq+4tvDgyevoX2/933ene01t7ew9cTumTT8KTjNKZSx2jQOukTGFR4T1ltmk3H973fp14zdKi8tI6jdpppRVl0tN7XEdGRsXvS9MLA+e9AB7D3GOmmQWWZVNYUXowv6zkc4vLS8nIyCwEwJSKe1oa/7NiadVL4R+PDdtR6/1Uj0ZJRcBc8O1/e+mcz+8t63zv0CuXx69Wnzt+xijMz2nKys7yH2g9EMzKzMz2eMzKsurF75QtW/LplpVN+H1+wuEwuTnZhCIRJkITWOHIj575i6c345h1IhpQaGZyNEIIonQhTtvNRqNESCoC5oLBCyOvmoZ8Mqe0aE0Oxb6Ku6s6aqoW+zANBgaGAp/9zbX40tJ56Xv/UVBcVel0HukxqhZV2JmZGWbP8ROoo5SUFLOwtCyjf6h3O7A9bvv6GmU8YQr3lhXXpDGrRkXxHjp/Pnhltn/zHgHT8WfrN+TZ9lijPR5eh6Mrr0QiuY0N9fjS/fScPr3TcKRzfHxssG5Z7d+lpaV7dv98d7fp8y46e+yE73hn17EEb/okoLP7KSoKLPRKpEGQ5Qr1CA2oLAMdADpAO/qHjz192wmYjsb6+18TeFRESMvO2tny2Yf+FZx60EbDMO8Twbvhb/68GBKPRiLUKSxA6BWlyxFpEzSIyaH+/p4LCbo0ywrvWSJCg4o29A/3rIM7REBzc3OuHUrvFchRUVW46ogs6ehoHY3fs379es/69euvm4RNxw1Go0ZgDAgi0iWqbY5jBP1ZoeCpU6dCs23cEQKa6u9/EfgTlC+CCiIbEXnxUEfrEykwb1QU3V1ti7FckHpFGwRpACqBboFORTr6h7ufhTtAwIqGBz6t6uwCffdQ594HAZrq7/858JCI/NrBjtZfzEe/FRUV6XYoq84Qu0FF6vuHe56C20jAC69t/fyVi6PWD5///gag3FBn+QfBfb0ATcs+tRTTPgzal56tjfv27bttH0zzPgwC/PvmzeU4+oNDvzpoADmZC/J3FyyueLy8uXHqnotn+g5cvTC6OnSZdcBf3Q6/4DZEgKrKxte2vj4ydP5zWzb90FbVoOkPtbS1tUWn37d69WrPhxei+4FGQ2TVBx2tbfPtG4Ax3x1sfO0nT6jjrH1j87bzqooh8vjshwfYvXu3JSqPA+qofr+5udk7377BPBOwftcuD8iT77XuHxm7dLlYVP/5Zm/2YLD1MCIbgEY75H9yPn2LY95TYO3aP1ox0Hdiv2EaVysCNS+Jad50bFfb9vQFjz3mWHaGoXZ9vFDOF+a7CMrA2ePPAl61nUd/+sqmWxriVjQ8sB10lyOyCXiQBNPdVMGcL8MATYFPfBGRryGy6VBH6/duVW9w+MzphcWVFSC/vbCosm/w/NkP5svHeasBLYHVCxH5jsKgDX85V33TH3oKOIfIc42N95XPg4vAPBHw8GNfqc65q+SdvPKF+UXVi7ZNn+PfKtra2i4VVi/anldekltYUbnz4ce+Uj0fvqa8COpFcgnxNtDsTH59G1nJ2ZqhL7Rj8aAs4mIq/IwjpRGgiocQW4mt1qQWynI8bFZNbd1KaQRoP/8IfKPnhI9f//3FTIRSY97vU3a8cobapWGAb0kZT6fEMCkkQPtoxOC9SFS8j/xBJUeOpeM4DgC/9cdfSMrm1h+8AoBhmNRUj7Pjv87g96kFrJIyUjJVTkkKqCIYbAS8//T8AoLdfmoaAlPXHdtJSuJYUl/L0V4/G15YALG5y/Op8BtSVQP6+Q3gY6fOennxR/lkZmVxd6B26rLjOElJHEvr68jIzOSFl/M53ecF+LgO8HAqXE8NAcI6gA0bFxC1hKrapaDXJm+ObSclU1ClqnYpkajwL5sKJttifbqFawJ0gBZg5eCwh21vZuP1eSlbXDnjDbqNAMdxKK+qxOf38T8/y2Fw2APQon00ufXffQQoXwDY/NMcrKhQUV0FKLZ17ZvHtqykZLo+ChVVi4lawo9fz4l7/4du3XdFgCoG8LsAP5l0qqRsYcIHcEuAbVkUlS4k1ld2/NLvqbobydx9DQ5SC5ScG/Rw7KSPtIwM0tLTsa2Z23Wz/54r4vrpk/aP9sLAkIfSEquUfmqA7mRtu0sBh1UArQcyAMgtyMO2rSmJY3rbXCSRfk5BHtP7xIj5kCzcESB8HKD9SBoAWVmZ2JY9JXFMb5uLJNLPyo6Ff8fRWJ9ozIdk4XZBpAag94QPAF9a2ozcjSNR21wwXd/njy0V9p70xZvq3dh2S8ACFM6ciznl8XgT5nuqagCA1xt78FNnvfF1ogo3tt0R4LAA4PJYLJNEdEbuxpGobS6YoT9Z869cNeIEFLix7YoA1VjnV8cnS4kmftupjID46uDYFSM+2cxwY9ttCiiAaULUAsuKInJ9XU1lDdDJGaKZolUBdwQoF4Hy/DybgSEPkXAEj+d6k6kkwIrGfhfk2fFoGHdj220NGEEoz8+JERCNRBJOy1JJQCQSBiA/d4qAETe23UeAwoK8WI6GQ2EM4/rYtFzWgOn6kXAEgIJcG2LZcM6NbXdF0KFbYHWgJsye9zIIjYfweX3X3WdHXUbANP3QeOyQR2BpGBxQ6HBj2x0BNgeAL62smwDyCYdC2JnXF+VUpkA4HCNgZWACtUGVA25suyLAhP2OA/fWx84zTExMcK7v+ohM1DYXJNJfURsCB0xlvxvbrj4lVTGcI/QDJYmuO5NHkoy05Ozfgv6AsYxykeT3Dl19DIng/Ok/BIY3vHxXrCDNFp2URNduRW6iv+Hlu/jqtwLn3Tw8pGBFaPhD397/3lHGyIgvdmp3usQdnt1+q3ID/YujXl59o4zhUf+Ms8rJwDUBx0+mP6Mq7PhlYawoTZO4w7Pbb1VupP/6u8XYjtDbn/XcHSfg4JG9pwtyIx3b3ykBi5kSf4jZ7bcqN9D/2Z4iCnKi7e3t7550639KdoZUEWs/+2Dm4oROjl6S5FhzE/393vu4LzmrM5GSfQERVC2+hE30NtQAS6N8NRV+Qwp3h30PcNiJ8qxasTen1rS8tZKUBPqOxbd9nyJlJ0ZSuzu8C0/U4U3gIbi2OSRJ9pJA/y3vCGvl0dT9z2LqD0i8RW7E4e1t+0uan9myJCU2//p3evn8qqF2X5TV8ghzPm1yM8zbMbmmwCdaENkJJHk+ZApjAp852PnL91Ph10f4CDPxfxWEKT2phCstAAAAAElFTkSuQmCC"),_defineProperty(_$2122$2195$2196$,"1f68d","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f696","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f6a0","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f69b","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f69e","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f68b","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f69f","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f683","data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASjSURBVHic7ZrfTxxVFMe/d2Z2ll0WFkgx4PJjVZAIGDWIabWa9aGpVfHB9sFoW33Q6Is++C+0iU9i1CcwUVtSo42xYaOoiYkPpmraGrVFGyhtlB9LhJSyP2d3fuz1AQoM3J0OlJ3Zdu/n6c6dc+459ztn7p3JDMDhcDgcDofD4XA4HA6n3CBuJ/DmSJu3iqonANoHQN7iMCoojSaFioMfPj2R24yjsMWA20YVzR4C6H5sffIAIIOQA1XIvbRZR1MFfHCpzUuhnSDAzVyNUkUFEAU8B99qX60Saa3FQjx5CJTudzw1Z5ABHAAy3wL4+HqnSYDFa0oTdTothyFAy9pjkwCJhApKbm8JCDWv+yYBUlnV0WRKAZMAQ3V5t/JwlJNr2q5vg25jqgCxqTkiVgfdysURjEQ8AkytHPMKsDqZTyWhT00C1MbOQAik5hYIgartys0RLAWgigKhMgCpuQUgFq8NlEKfmgRVFOB2EgAAiM9nPXkAIGTJbh2j/zTio5Fd0PPsO00SDby271d0h2cdsWfaWE5s/WS+exTGmmCSaODVp35Bdys7wOXpAFIpxXLcy9MBdIedsWdhW4ArsWpk0uYHpRyAKzPVBQVoD81jX69mOW57aNExexa2BTB0DTllo9qGXjiB8+N+fP79DstxX9irovOuRUfsWdgWQNd05JQss78QmqpBSactx9VUzdQupj2LTVQAWwBDLyyArmlQ0hnLcXVNM7WLac/CfgXoOnJZRgVYCNDemoGhilA19i4ieyg6wmnH7FnYr4ACt4BhcQvs7lFx+uRVuyGKbs9icxXAWAStKuBWwLYAHeEsqC6Zyk32UNx3t/U+XOrYFmD3wyp+/nKhmLm4Qtm/DXIB3E7AbbgAbifgNlwAtxNwGy7A9QallAgQaAn8MlBECAQIlNLV72MrT4KDX5zKA+8BAF4JPr/iItbfYXt4Y34OxvzctqRaDD6NfwUAEfx1Ko/lK818FKbr2nY+l9q1KzWYArw4EV49mACAlI2h/ADCNzJylb31G/vKfhFkvw3eirW8RUxL/oPdj5XF1P8YPb0y77K/BZib/nOHX09O//l3IG/kEbq/A6LHc1NBdE1D7MIYBFFAY9e9+P2Hn5h2D+15ArOjYyhG3KYHOhPR4wMbvv07WgEUxJX1hS5dZ2Zk9nMAxTlvoDKixJO4+u8M6lpDAAWuTcagJJLw1wYR6mw703hn6JG1fpdGLyI++x8yiwlUVAdQ1xICACxMzgAAfFWVyCSSBRPNxJPwBiphFTfYWI/2rk6T3+x07OzMxfFeq7gEOGdbAAHor2lqiORSGWQTKcQujK2ekyTUNDVAV9UjAI4DqF0+tejz+15GqGE4l0ov+Y2u+omSiGCoAbIsPxObGx9hxe2tfbKvotIXtYrrrZD71sc1VPVo8AZxQdHPiimyOsfO/zbe1bNT9tcFHzdUDbqmgwgC/DXV2HFPCyTJc3T42MDArsieMSqQH0HI1wLFZ5+8/85wV89O2VfAzyN7j0SHBgZZMd2Ka/nm03f4jWcJ6NsAepe7zoDQ/uixwW824UcBnCUU7w4PDTCvfKnE5ZQj/wNNcmBSu0/dOgAAAABJRU5ErkJggg=="),_defineProperty(_$2122$2195$2196$,"1f688","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f69d","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f684","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f685","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f682","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f686","data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAA0lSURBVHic7Zt7cFz1dcc/v3v3obdkWZYfwrZksDHyA4yBEruxkwlgYGyg7dTpTEviTEuBTEvSJpNO02HapE/StANtpiXOZIo7SWeStgFjUgohyLawLWOhl22sh0GWX5JlvVbSarW7ur/TP3b37t2HbN3Vo51pzszde+/v/n7nd873d875PRd+Qf+/Sc13Bc3d3WV+Zf6maPYYyrzdNFhsGkYBKEPF6xcQAa21NWFpBrVYHcrgUFisH26pqRmZT/nmBQARMc6cv/C8YRhf8BjGamWYGEqhlEIpQKl4xYnqBYkVRAREBC2CaIsprXu01v+y8bbqP1dK6bmWdU4BEBGjtbP7JY9pPmUYym8oA8NQKGWkAKBUXP34XUTsewoAotFa0KKxtA5HLb1/y7qaL88lEHMGQOP58582LeNVj2GUGkZM8SQAsed0ANIpFQAdu8cB0FrQWqO1HlGG9cTmtWuPzIXccwJAS0fXXyPGHymllGmaKcobhhEHIAZENBplMhQmHI0SjoQB8Pv8+L1e8vL9eL1ehwUklE6CYFkWWkRE9N/cfcfar89W9lkD0NTx8QEl8jkA0zAwDQMjfoFw5UovV/uu0X99gP6BQYLBiRvyKywsoHJJBZUVi1mxbClVVcsBlWh9rPgFIKIO3H3Hmn2zkX9WALR2nn9Ra/UliJl1QvmJUIjWtjN8eK6TcCQymyrw+31sWL+OOzdvJD8/3wYhETfAeHHL+po/yJV/zgA0n+16HFO9lmBhKIVpmrSd/pCGk41Ep6ZyZZ2VPF4v2+7byqZNtQk3SH401d4ta9f8ey58cwJARDwtHd0BkAJbBsPgRMMpmlracmE5Y9q6ZTP3/9K9thvEaeKu29eUKqVco27kIkRrx8f/6FQeYGQkwAdNrWhLz+vV+EErgcBoukgFLR0f/0MuurgGoK6uLk+Q33GmKaXovnAxZprxYDVfl2VZXOi5mKUrlafq6ury5h2AkqqVz4HypAAAXL3ahzVlLch19WpfFt9VnrKq1b/nVh/PzbOkkiHGPpDURKUIjAxjWXMb+KajQCAASsVmEE6y9BeAb7vh5RoAEalJR18BwfEQespyyy4nmhgLZo/eStW45eUaAAX+zHoVk+FJLGthAAhHwtMNp13HANcAME3XqUSw5rjvn45Ey3SfXHfruQCQWmN8aquUWjALkPhCglLKMSLMjWYNAABKke/3L1gMKPDnxYLgHJBrAAaDYRYXJsNAQoyi4sIF6wWKiwrtup3tPzA+6ZqXawA6r43yiTVLkgnxliguKcZaIAsoLilO1u1wgfa+jBHiTck1AB3XAqkAEGuJkuKSBYsBJSUlWaNdx7UFAKC9N7USFf8pKytdsF6gtLQEVGbI7+gLuOblGoCWS4OIpMcgRdUtKxbMBapuqSJdfRFouTTkmpdrAIaCEXpGQlQvyk9JX1K5hLw8P8HxoGsh3FBhUSEVSxanrgcA3UMTjEy4X3zJqRtsvjyaAYBSiurqVbS1nM6F5YypunpVbBSYBkDzFff+DzmuB9R3D2ZN3/XoQ4jW8zYLFK3ZtXvXNDK5N3/IdUGkd4zhycyAt2HzBp597ml8fi+WNTWnlz/Px7PPPcOGjbUZ9Q5PTnG6bywXVXJzAa2FExfHeHTdooxv23ds5+57tnDsyHFaW1o5d6adkZHcdrfKFpVSu7GWzXduZvvObeQXFKQvhQFwrGcMPf384IaU81C4/sJoVgAACouKeXjPwzzy2CP2eH18bIyJidCMeBcU5FNUXGyXtTdIdPZepv5Cbv4PswCgrT9EYNKivCC2/g+xmyQeHN2UoRSlpaWUlpbOmL+IpC27JPYPk+8AgbDmbP+N9xpuRDnFAIi5Qf2liRShshrhbGZrWco69Rfg6MUg1iyqcA3AfTUV9vObH43ZQkk6CiKzUz5BTj72LWkdb3+UDH7pQ/SZkGsAvvxALV5PrNjl0SjtgxGHcEko5kB1m5L84k9x5u0DYS6ORgHweQy+9EBmD3Ezcg3AbUuK5as71thD4be7kyM/ScgmKeLmBEZG2XhMcBrVWxdivm8oxVd3rmFNRZHrqnKJAZMP3V7BV7atwGsqTlwNEZnSGb6ZTm5WbrLlTY81kSlNw5UQXlPxle3LeXBdBcDMuhkH5dIL9AOrP3NrKesrC/hRe5Cu4SibKk1s75S0fiBz9nRzcoCQUN52LhG6hqNsXZbHb9xRwYoiW41+t8q43xcw5LXEjnBVsZc/vLcMj2mmmKckTv0kSCnbNaY7HJGglO4vEQAlGfYSblZb4WPdorKUskqp/3Stj9sC0dGCv0g3cqfJiiNOpfixmx5BJEv5VBaZbiKoyYJvzbySGLkG4J57VgyA6nKmWVYEPd6CiCbpBinSxkW8cSzIaH3HcwISEY0eb8Gy0qa+Queddy5z7QK5DYTE3Od8nbzwOrfqxyif2odYlsNyJaU1bSCyBTnbf1LzJ88NgWjN4ujnudV6jFDPGynltZifz0WVnADYckf1caAl8R5ZdD99XcspHHmXietHSVhBti4wOU6SlItp8jpHFhP9deQH6ug7v4Jo2X3JjIrGrbU1DbnokvNQ+ProyEuJRisqWUb38h/Q3Ps8AWpSWt9WJmHekglMSouTZiEOKwjIGlp6n6d7+Q8oKllml+0fGXo5Vz1y2l342c8aSyf9kbYARas2VMbW6E2liFoWPq8Xn9cbPy+UPCWW2EFKHpLMpHQQnKfELK2JRKNEolE8Hg86Pi1u7uljSZ66ogxr0+5PfnLYrS45WUDIH/0OsCoUGqd9OGIL7/f5MM3keMC2BIdiM7EAZ6wQR/9vmiZ+n8/+3tQzQGRyEhRVIuZLuejiGoBDR48/oZDfAliWD/98vJf+CSul1RKKO0GwfT+hYHpwTMvjVD6FZzzf1eEgLxxsoCq5NvnkG/XHf31eAfjJsWOVwHcT7+FwhPyLDfz+O0P0B6eSUT9d4CzBLgUwkhaRrUxKjyLClaFxfu3ln7M8dJlwOGzLJyL/9NO695fNGwBeS30fqEy8NzW14B/uoXD4PM++PcCHA2E7aieVS576tEHINhZIy6NtC0ryEaDp4iC/+t3DLLNGKLVGaW52nkpTFdqcekVEZhzbZgzAoaPHngJ2J97HxsY4d64DgKrrzSc00vnHRwc50DbClJVm/s6+PC3IpVhBej6HG1ha+F59F0//8CRa017rGToOcPZcB6OjKQuiu96ob/jtOQXg9SMna0D9nTPt/VNN9gKlGQ5+Q5ueh4He/+gY53ff7OVs/6Sj5ad3B7KBkVamvW+UJ/bXs//YeRB6TcN6xGtFvwmgLYtTp5rSJJYXD9Ydv20mut3UVP5MxNhaf+JdYGci7fr1AQ6+/l+ICFYkwpUznQDosqUEd+xDF5cjAmvLPTy1pZxNlYV4zeRp8Zn8XyBqaVouDfH3h7to7wugLQtPcJgVHXX4Q7E9wKoN6zD9PpRS7Nn9MEuX2t6JgmMTfZd37t2794b7dTcF4NDRE18DeSEl7Y3/pq/vGgCDFy4THEoue4s3j9C2zxKpqo0pJoJHaXauLuKBmmJWlfopL/Tisw9Ug6U1Ua0ZHA/TPRjizfZrvN1xDWtKI9pCa4v8gR6WdR7BmErOAQrLy1hcfQsASyuXsGfPI+mzza/t2bHtb3MG4LWjDbUm+gMch4+6L/TwzjuHgZj5XWlrzxzbK4PIrfcS2rwL7c+H+Nl/0ZJ8ttNiSorWsf8IJJ7jdyMcpOzjk5T0dWQJnoqVm29HeWKz+gcf+DTV1aucGcIa477Hd9w/7fndaWNAY2Oj1xB9wKm81kJjY7OdJ9Dbn3Vig2h8509SeugF8pt/ijE2MF0105JnYpjyruOsbPg3Snrbp5lOC4G+JO/3TzXZI8Q4+Q3RB3589qxv2nqm+9A7EfmGUtzjTDvX3sHISMz/lFKji6orbql/9/Ub70k1vwvA6m8e2SJq6jNKuF9gLbASKIznCqK4hEgnohoMzc+v7/9iy/UbMo7RQ08+WagUl0UoCwQCtLd3Ulu7PplBcVfe4MifAn+SrXxWFzh0+NgnMFQ9YCbSotEoP/rxq4RCoXhB9VcH//XlrEwXmh7/3DN/KcjXAfLz8tj72V/B501pdK20/tTuT/1yfXrZDBd4663WQgxewaE8QEvLaYfyREytvzOHOsyKDOElFJMAoclJ2lrPZmYxjFcOvvdecfqHDBeI5Ae/DWqdMy0YnODM2XP2+9jAkG/o4tWrd23cPicKzJa6m09TvmoFRRXlALSdOcv69esoKip0ZltjaPUC8EVnYooFHDzc8CDwdHoFjY3NTDnO/4z157YXP580di0ZDK0piw+aWrLkUs8cOvLeo84UG4BX6+rKDMP6PmlxYWhomM7zH9nvocAY0Un35/Hmm6LhCKFAMh53dn3EwEDGQQ6FMr73k3dOLk4k2AB4TN/LoFamlzh5sjGlCxrtm0ls/t+hFNlEOPl+Y7ZsKzx+a/9CyfQL+r9O/wPXqctiUhisrQAAAABJRU5ErkJggg=="),_defineProperty(_$2122$2195$2196$,"1f687","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f6eb","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f68a","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f6e9","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f6ec","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f689","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f9f3",baseURL+"1f9f3.png"),_defineProperty(_$2122$2195$2196$,"1f681","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f4ba",baseURL+"1f4ba.png"),_defineProperty(_$2122$2195$2196$,"1f6f0",baseURL+"1f6f0.png"),_defineProperty(_$2122$2195$2196$,"1f6f8",baseURL+"1f6f8.png"),_defineProperty(_$2122$2195$2196$,"1f6f6",baseURL+"1f6f6.png"),_defineProperty(_$2122$2195$2196$,"1f6e5","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"26f4","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f6a4","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f6f3","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"26fd",baseURL+"26fd.png"),_defineProperty(_$2122$2195$2196$,"1f6a6",baseURL+"1f6a6.png"),_defineProperty(_$2122$2195$2196$,"1f5ff",baseURL+"1f5ff.png"),_defineProperty(_$2122$2195$2196$,"1f6a7",baseURL+"1f6a7.png"),_defineProperty(_$2122$2195$2196$,"1f698","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f68f",baseURL+"1f68f.png"),_defineProperty(_$2122$2195$2196$,"1f6a5",baseURL+"1f6a5.png"),_defineProperty(_$2122$2195$2196$,"1f3f0",baseURL+"1f3f0.png"),_defineProperty(_$2122$2195$2196$,"1f5fc",baseURL+"1f5fc.png"),_defineProperty(_$2122$2195$2196$,"1f6a2",baseURL+"1f6a2.png"),_defineProperty(_$2122$2195$2196$,"1f5fd",baseURL+"1f5fd.png"),_defineProperty(_$2122$2195$2196$,"1f3a2",baseURL+"1f3a2.png"),_defineProperty(_$2122$2195$2196$,"1f3df",baseURL+"1f3df.png"),_defineProperty(_$2122$2195$2196$,"26f1",baseURL+"26f1.png"),_defineProperty(_$2122$2195$2196$,"1f3a1",baseURL+"1f3a1.png"),_defineProperty(_$2122$2195$2196$,"1f3a0",baseURL+"1f3a0.png"),_defineProperty(_$2122$2195$2196$,"1f3ef",baseURL+"1f3ef.png"),_defineProperty(_$2122$2195$2196$,"26f2",baseURL+"26f2.png"),_defineProperty(_$2122$2195$2196$,"26f5","data:image/png;base64,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"),_defineProperty(_$2122$2195$2196$,"1f5fa",baseURL+"1f5fa.png"),_defineProperty(_$2122$2195$2196$,"1f3dd",baseURL+"1f3dd.png"),_defineProperty(_$2122$2195$2196$,"1f680",baseURL+"1f680.png"),_defineProperty(_$2122$2195$2196$,"1f30b",baseURL+"1f30b.png"),_defineProperty(_$2122$2195$2196$,"1f3d6",baseURL+"1f3d6.png"),_defineProperty(_$2122$2195$2196$,"1f3dc",baseURL+"1f3dc.png"),_defineProperty(_$2122$2195$2196$,"26f0",baseURL+"26f0.png"),_defineProperty(_$2122$2195$2196$,"1f5fb",baseURL+"1f5fb.png"),_defineProperty(_$2122$2195$2196$,"1f3d4",baseURL+"1f3d4.png"),_defineProperty(_$2122$2195$2196$,"1f3d5",baseURL+"1f3d5.png"),_defineProperty(_$2122$2195$2196$,"1f3e0",baseURL+"1f3e0.png"),_defineProperty(_$2122$2195$2196$,"1f3d7",baseURL+"1f3d7.png"),_defineProperty(_$2122$2195$2196$,"1f3da",baseURL+"1f3da.png"),_defineProperty(_$2122$2195$2196$,"1f3e1",baseURL+"1f3e1.png"),_defineProperty(_$2122$2195$2196$,"1f3d8",baseURL+"1f3d8.png"),_defineProperty(_$2122$2195$2196$,"1f3ed",baseURL+"1f3ed.png"),_defineProperty(_$2122$2195$2196$,"1f3ec",baseURL+"1f3ec.png"),_defineProperty(_$2122$2195$2196$,"1f3e4",baseURL+"1f3e4.png"),_defineProperty(_$2122$2195$2196$,"1f3e6",baseURL+"1f3e6.png"),_defineProperty(_$2122$2195$2196$,"26fa",baseURL+"26fa.png"),_defineProperty(_$2122$2195$2196$,"1f3e5",baseURL+"1f3e5.png"),_defineProperty(_$2122$2195$2196$,"1f3e9",baseURL+"1f3e9.png"),_defineProperty(_$2122$2195$2196$,"1f3e8",baseURL+"1f3e8.png"),_defineProperty(_$2122$2195$2196$,"1f492",baseURL+"1f492.png"),_defineProperty(_$2122$2195$2196$,"26ea",baseURL+"26ea.png"),_defineProperty(_$2122$2195$2196$,"1f54b",baseURL+"1f54b.png"),_defineProperty(_$2122$2195$2196$,"1f54c",baseURL+"1f54c.png"),_defineProperty(_$2122$2195$2196$,"1f54d",baseURL+"1f54d.png"),_defineProperty(_$2122$2195$2196$,"1f3ea",baseURL+"1f3ea.png"),_defineProperty(_$2122$2195$2196$,"1f3db",baseURL+"1f3db.png"),_defineProperty(_$2122$2195$2196$,"1f6e3",baseURL+"1f6e3.png"),_defineProperty(_$2122$2195$2196$,"1f3eb",baseURL+"1f3eb.png"),_defineProperty(_$2122$2195$2196$,"26e9",baseURL+"26e9.png"),_defineProperty(_$2122$2195$2196$,"1f6e4",baseURL+"1f6e4.png"),_defineProperty(_$2122$2195$2196$,"1f5fe",baseURL+"1f5fe.png"),_defineProperty(_$2122$2195$2196$,"1f3de",baseURL+"1f3de.png"),_defineProperty(_$2122$2195$2196$,"1f391",baseURL+"1f391.png"),_defineProperty(_$2122$2195$2196$,"1f304",baseURL+"1f304.png"),_defineProperty(_$2122$2195$2196$,"1f9e8",baseURL+"1f9e8.png"),_defineProperty(_$2122$2195$2196$,"1f305",baseURL+"1f305.png"),_defineProperty(_$2122$2195$2196$,"1f320",baseURL+"1f320.png"),_defineProperty(_$2122$2195$2196$,"1f387",baseURL+"1f387.png"),_defineProperty(_$2122$2195$2196$,"1f386",baseURL+"1f386.png"),_defineProperty(_$2122$2195$2196$,"1f3d9",baseURL+"1f3d9.png"),_defineProperty(_$2122$2195$2196$,"1f30c",baseURL+"1f30c.png"),_defineProperty(_$2122$2195$2196$,"1f306",baseURL+"1f306.png"),_defineProperty(_$2122$2195$2196$,"1f301",baseURL+"1f301.png"),_defineProperty(_$2122$2195$2196$,"1f307",baseURL+"1f307.png"),_defineProperty(_$2122$2195$2196$,"1f303",baseURL+"1f303.png"),_defineProperty(_$2122$2195$2196$,"1f512",baseURL+"1f512.png"),_defineProperty(_$2122$2195$2196$,"1f513",baseURL+"1f513.png"),_defineProperty(_$2122$2195$2196$,"1f309",baseURL+"1f309.png"),_defineProperty(_$2122$2195$2196$,"1f3c1",baseURL+"1f3c1.png"),_defineProperty(_$2122$2195$2196$,"1f3f4-2620",baseURL+"1f3f4-2620.png"),_defineProperty(_$2122$2195$2196$,"1f6a9",baseURL+"1f6a9.png"),_defineProperty(_$2122$2195$2196$,"1f3f3-1f308",baseURL+"1f3f3-1f308.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1f1",baseURL+"1f1e6-1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1eb",baseURL+"1f1e6-1f1eb.png"),_defineProperty(_$2122$2195$2196$,"1f3f4",baseURL+"1f3f4.png"),_defineProperty(_$2122$2195$2196$,"1f3f3",baseURL+"1f3f3.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1fd",baseURL+"1f1e6-1f1fd.png"),_defineProperty(_$2122$2195$2196$,"1f1e9-1f1ff",baseURL+"1f1e9-1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1f4",baseURL+"1f1e6-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1ee",baseURL+"1f1e6-1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1e9",baseURL+"1f1e6-1f1e9.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1f7",baseURL+"1f1e6-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1f8",baseURL+"1f1e6-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1ec",baseURL+"1f1e6-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f3e3",baseURL+"1f3e3.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1f2",baseURL+"1f1e6-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f3e2",baseURL+"1f3e2.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1f6",baseURL+"1f1e6-1f1f6.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1fa",baseURL+"1f1e6-1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1fc",baseURL+"1f1e6-1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1e7",baseURL+"1f1e7-1f1e7.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1f8",baseURL+"1f1e7-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1f9",baseURL+"1f1e6-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1ff",baseURL+"1f1e6-1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1ed",baseURL+"1f1e7-1f1ed.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1fe",baseURL+"1f1e7-1f1fe.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1e9",baseURL+"1f1e7-1f1e9.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1ea",baseURL+"1f1e7-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1ff",baseURL+"1f1e7-1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1f2",baseURL+"1f1e7-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1f9",baseURL+"1f1e7-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1ef",baseURL+"1f1e7-1f1ef.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1f4",baseURL+"1f1e7-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1e6",baseURL+"1f1e7-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1f4",baseURL+"1f1ee-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1f3",baseURL+"1f1e7-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1fc",baseURL+"1f1e7-1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1f7",baseURL+"1f1e7-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1ec",baseURL+"1f1e7-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1eb",baseURL+"1f1e7-1f1eb.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1f6",baseURL+"1f1e7-1f1f6.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1f2",baseURL+"1f1e8-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1e6",baseURL+"1f1e8-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1ee",baseURL+"1f1e7-1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1fe",baseURL+"1f1f0-1f1fe.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1e9",baseURL+"1f1f9-1f1e9.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1e8",baseURL+"1f1ee-1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1fd",baseURL+"1f1e8-1f1fd.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1f3",baseURL+"1f1e8-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1fb",baseURL+"1f1e8-1f1fb.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1e8",baseURL+"1f1e8-1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1f1",baseURL+"1f1e8-1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1f4",baseURL+"1f1e8-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1ec",baseURL+"1f1e8-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1eb",baseURL+"1f1e8-1f1eb.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1f2",baseURL+"1f1f0-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1ed-1f1f7",baseURL+"1f1ed-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1f7",baseURL+"1f1e8-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1ee",baseURL+"1f1e8-1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1fe",baseURL+"1f1e8-1f1fe.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1f0",baseURL+"1f1e8-1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1fc",baseURL+"1f1e8-1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1ff",baseURL+"1f1e8-1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1e9-1f1f0",baseURL+"1f1e9-1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1e9-1f1ef",baseURL+"1f1e9-1f1ef.png"),_defineProperty(_$2122$2195$2196$,"1f1e9-1f1f4",baseURL+"1f1e9-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1fa",baseURL+"1f1e8-1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1e9-1f1f2",baseURL+"1f1e9-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1fb-1f1ec",baseURL+"1f1fb-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1ed",baseURL+"1f1f0-1f1ed.png"),_defineProperty(_$2122$2195$2196$,"1f1ea-1f1ec",baseURL+"1f1ea-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1f6",baseURL+"1f1ec-1f1f6.png"),_defineProperty(_$2122$2195$2196$,"1f1ea-1f1e8",baseURL+"1f1ea-1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1fb",baseURL+"1f1f8-1f1fb.png"),_defineProperty(_$2122$2195$2196$,"1f1ea-1f1f7",baseURL+"1f1ea-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1ea-1f1ea",baseURL+"1f1ea-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1ea-1f1f9",baseURL+"1f1ea-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1ea-1f1fa",baseURL+"1f1ea-1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1eb-1f1f4",baseURL+"1f1eb-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1eb-1f1f0",baseURL+"1f1eb-1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1eb-1f1ee",baseURL+"1f1eb-1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1eb-1f1ef",baseURL+"1f1eb-1f1ef.png"),_defineProperty(_$2122$2195$2196$,"1f1eb-1f1f7",baseURL+"1f1eb-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1e9",baseURL+"1f1e8-1f1e9.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1eb",baseURL+"1f1ec-1f1eb.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1e6",baseURL+"1f1ec-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1eb",baseURL+"1f1f9-1f1eb.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1ea",baseURL+"1f1ec-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1eb",baseURL+"1f1f5-1f1eb.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1f2",baseURL+"1f1ec-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1e9-1f1ea",baseURL+"1f1e9-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1ee",baseURL+"1f1ec-1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1f7",baseURL+"1f1ec-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1f1",baseURL+"1f1ec-1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1ed",baseURL+"1f1ec-1f1ed.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1e9",baseURL+"1f1ec-1f1e9.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1f5",baseURL+"1f1ec-1f1f5.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1fa",baseURL+"1f1ec-1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1f9",baseURL+"1f1ec-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1ec",baseURL+"1f1ec-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1f3",baseURL+"1f1ec-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1fc",baseURL+"1f1ec-1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1fe",baseURL+"1f1ec-1f1fe.png"),_defineProperty(_$2122$2195$2196$,"1f1ed-1f1f9",baseURL+"1f1ed-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1ed-1f1f0",baseURL+"1f1ed-1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1f3",baseURL+"1f1ee-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1ed-1f1f3",baseURL+"1f1ed-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1f8",baseURL+"1f1ee-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1ed-1f1fa",baseURL+"1f1ed-1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1e9",baseURL+"1f1ee-1f1e9.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1f1",baseURL+"1f1ee-1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1ef-1f1f5",baseURL+"1f1ef-1f1f5.png"),_defineProperty(_$2122$2195$2196$,"1f1ef-1f1f2",baseURL+"1f1ef-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1f9",baseURL+"1f1ee-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1ef-1f1f4",baseURL+"1f1ef-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1f7",baseURL+"1f1ee-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1ff",baseURL+"1f1f0-1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1f2",baseURL+"1f1ee-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1f6",baseURL+"1f1ee-1f1f6.png"),_defineProperty(_$2122$2195$2196$,"1f1ef-1f1ea",baseURL+"1f1ef-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f38c",baseURL+"1f38c.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1ea",baseURL+"1f1f0-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1fd-1f1f0",baseURL+"1f1fd-1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1ec",baseURL+"1f1f0-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1ee",baseURL+"1f1f0-1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1e6",baseURL+"1f1f1-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1f8",baseURL+"1f1f1-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1fb",baseURL+"1f1f1-1f1fb.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1e7",baseURL+"1f1f1-1f1e7.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1fc",baseURL+"1f1f0-1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1fe",baseURL+"1f1f1-1f1fe.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1f9",baseURL+"1f1f1-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1f7",baseURL+"1f1f1-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1fa",baseURL+"1f1f1-1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1f0",baseURL+"1f1f2-1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1ee",baseURL+"1f1f1-1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1f4",baseURL+"1f1f2-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1fc",baseURL+"1f1f2-1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1ec",baseURL+"1f1f2-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1f1",baseURL+"1f1f2-1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1fe",baseURL+"1f1f2-1f1fe.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1fa",baseURL+"1f1f2-1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1f6",baseURL+"1f1f2-1f1f6.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1f7",baseURL+"1f1f2-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1fd",baseURL+"1f1f2-1f1fd.png"),_defineProperty(_$2122$2195$2196$,"1f1fe-1f1f9",baseURL+"1f1fe-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1f9",baseURL+"1f1f2-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1ed",baseURL+"1f1f2-1f1ed.png"),_defineProperty(_$2122$2195$2196$,"1f1ee-1f1ea",baseURL+"1f1ee-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1f8",baseURL+"1f1f2-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1f3",baseURL+"1f1f2-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1e6",baseURL+"1f1f2-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1ea",baseURL+"1f1f2-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1ff",baseURL+"1f1f2-1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1e6",baseURL+"1f1f3-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1f2",baseURL+"1f1f2-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1f7",baseURL+"1f1f3-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1e8",baseURL+"1f1f3-1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1fb",baseURL+"1f1f2-1f1fb.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1f5",baseURL+"1f1f3-1f1f5.png"),_defineProperty(_$2122$2195$2196$,"1f1eb-1f1f2",baseURL+"1f1eb-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1e9",baseURL+"1f1f2-1f1e9.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1ff",baseURL+"1f1f3-1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1f1",baseURL+"1f1f3-1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1ee",baseURL+"1f1f3-1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1ec",baseURL+"1f1f3-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1ea",baseURL+"1f1f3-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1fa",baseURL+"1f1f3-1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1f5",baseURL+"1f1f0-1f1f5.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1f4",baseURL+"1f1f3-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1f5",baseURL+"1f1f2-1f1f5.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1f0",baseURL+"1f1f5-1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1f3-1f1eb",baseURL+"1f1f3-1f1eb.png"),_defineProperty(_$2122$2195$2196$,"1f1f4-1f1f2",baseURL+"1f1f4-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1f8",baseURL+"1f1f5-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1fc",baseURL+"1f1f5-1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1ec",baseURL+"1f1f5-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1e6",baseURL+"1f1f5-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1ea",baseURL+"1f1f5-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1fe",baseURL+"1f1f5-1f1fe.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1ed",baseURL+"1f1f5-1f1ed.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1f3",baseURL+"1f1f5-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1e8",baseURL+"1f1f2-1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1f1",baseURL+"1f1f5-1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1f7",baseURL+"1f1f5-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1f9",baseURL+"1f1f5-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1f7-1f1ea",baseURL+"1f1f7-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1f7-1f1fa",baseURL+"1f1f7-1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1fc-1f1f8",baseURL+"1f1fc-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1f9",baseURL+"1f1f8-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1e6",baseURL+"1f1f8-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1f2",baseURL+"1f1f8-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1f7-1f1f8",baseURL+"1f1f7-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1f7-1f1f4",baseURL+"1f1f7-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1e8",baseURL+"1f1f8-1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1f0",baseURL+"1f1f8-1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1f6-1f1e6",baseURL+"1f1f6-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1f3",baseURL+"1f1f8-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1f7-1f1fc",baseURL+"1f1f7-1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1f1",baseURL+"1f1f8-1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1ec",baseURL+"1f1f8-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1fd",baseURL+"1f1f8-1f1fd.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1e7",baseURL+"1f1f8-1f1e7.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1ee",baseURL+"1f1f8-1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1f8",baseURL+"1f1ec-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1f4",baseURL+"1f1f8-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1ea-1f1f8",baseURL+"1f1ea-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1f0",baseURL+"1f1f1-1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1f1-1f1e8",baseURL+"1f1f1-1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1ed",baseURL+"1f1f8-1f1ed.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1f3",baseURL+"1f1f0-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1f1",baseURL+"1f1e7-1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1e9",baseURL+"1f1f8-1f1e9.png"),_defineProperty(_$2122$2195$2196$,"1f1f0-1f1f7",baseURL+"1f1f0-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1fb-1f1e8",baseURL+"1f1fb-1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1f7",baseURL+"1f1f8-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1ea",baseURL+"1f1f8-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1ff",baseURL+"1f1f8-1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1fc",baseURL+"1f1f9-1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1ed",baseURL+"1f1e8-1f1ed.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1fe",baseURL+"1f1f8-1f1fe.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1ed",baseURL+"1f1f9-1f1ed.png"),_defineProperty(_$2122$2195$2196$,"1f1ff-1f1e6",baseURL+"1f1ff-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1ff",baseURL+"1f1f9-1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1f5-1f1f2",baseURL+"1f1f5-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1ec",baseURL+"1f1f9-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1f0",baseURL+"1f1f9-1f1f0.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1f4",baseURL+"1f1f9-1f1f4.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1f9",baseURL+"1f1f9-1f1f9.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1f2",baseURL+"1f1f9-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1f3",baseURL+"1f1f9-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1fb",baseURL+"1f1f9-1f1fb.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1e8",baseURL+"1f1f9-1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1f7",baseURL+"1f1f9-1f1f7.png"),_defineProperty(_$2122$2195$2196$,"1f1fb-1f1ee",baseURL+"1f1fb-1f1ee.png"),_defineProperty(_$2122$2195$2196$,"1f1fa-1f1e6",baseURL+"1f1fa-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1fa-1f1ec",baseURL+"1f1fa-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1ea",baseURL+"1f1e6-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",baseURL+"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f.png"),_defineProperty(_$2122$2195$2196$,"1f1ec-1f1e7",baseURL+"1f1ec-1f1e7.png"),_defineProperty(_$2122$2195$2196$,"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",baseURL+"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f.png"),_defineProperty(_$2122$2195$2196$,"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",baseURL+"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f.png"),_defineProperty(_$2122$2195$2196$,"1f1fa-1f1fe",baseURL+"1f1fa-1f1fe.png"),_defineProperty(_$2122$2195$2196$,"1f1fa-1f1f8",baseURL+"1f1fa-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1fa-1f1ff",baseURL+"1f1fa-1f1ff.png"),_defineProperty(_$2122$2195$2196$,"1f1fb-1f1ea",baseURL+"1f1fb-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1f8",baseURL+"1f1f8-1f1f8.png"),_defineProperty(_$2122$2195$2196$,"1f1fb-1f1e6",baseURL+"1f1fb-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1f1",baseURL+"1f1f9-1f1f1.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1ef",baseURL+"1f1f9-1f1ef.png"),_defineProperty(_$2122$2195$2196$,"1f1ea-1f1ed",baseURL+"1f1ea-1f1ed.png"),_defineProperty(_$2122$2195$2196$,"1f1ff-1f1f2",baseURL+"1f1ff-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1fb-1f1fa",baseURL+"1f1fb-1f1fa.png"),_defineProperty(_$2122$2195$2196$,"1f1fb-1f1f3",baseURL+"1f1fb-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1ff-1f1fc",baseURL+"1f1ff-1f1fc.png"),_defineProperty(_$2122$2195$2196$,"1f1fc-1f1eb",baseURL+"1f1fc-1f1eb.png"),_defineProperty(_$2122$2195$2196$,"1f1fe-1f1ea",baseURL+"1f1fe-1f1ea.png"),_defineProperty(_$2122$2195$2196$,"1f1e6-1f1e8",baseURL+"1f1e6-1f1e8.png"),_defineProperty(_$2122$2195$2196$,"1f1e9-1f1ec",baseURL+"1f1e9-1f1ec.png"),_defineProperty(_$2122$2195$2196$,"1f1ed-1f1f2",baseURL+"1f1ed-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f1f2-1f1eb",baseURL+"1f1f2-1f1eb.png"),_defineProperty(_$2122$2195$2196$,"1f1e8-1f1f5",baseURL+"1f1e8-1f1f5.png"),_defineProperty(_$2122$2195$2196$,"1f1fa-1f1f3",baseURL+"1f1fa-1f1f3.png"),_defineProperty(_$2122$2195$2196$,"1f1ea-1f1e6",baseURL+"1f1ea-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1e7-1f1fb",baseURL+"1f1e7-1f1fb.png"),_defineProperty(_$2122$2195$2196$,"1f1f9-1f1e6",baseURL+"1f1f9-1f1e6.png"),_defineProperty(_$2122$2195$2196$,"1f1f8-1f1ef",baseURL+"1f1f8-1f1ef.png"),_defineProperty(_$2122$2195$2196$,"1f1fa-1f1f2",baseURL+"1f1fa-1f1f2.png"),_defineProperty(_$2122$2195$2196$,"1f3fd",baseURL+"1f3fd.png"),_defineProperty(_$2122$2195$2196$,"1f3fb",baseURL+"1f3fb.png"),_defineProperty(_$2122$2195$2196$,"1f3fc",baseURL+"1f3fc.png"),_defineProperty(_$2122$2195$2196$,"1f3fe",baseURL+"1f3fe.png"),_defineProperty(_$2122$2195$2196$,"1f3ff",baseURL+"1f3ff.png"),_defineProperty(_$2122$2195$2196$,"1f4cc-pin",baseURL+"1f4cc-pin.png"),_defineProperty(_$2122$2195$2196$,"1f4cc-unpin",baseURL+"1f4cc-unpin.png"),_$2122$2195$2196$);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = exports.Tab = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Tabs = __webpack_require__(2015);

var _TabContent = __webpack_require__(933);

var _Tab = __webpack_require__(932);

var _ripple = __webpack_require__(162);

var _ripple2 = _interopRequireDefault(_ripple);

var _FontIcon = __webpack_require__(81);

var _theme = __webpack_require__(2016);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applyTheme = function applyTheme(Component) {
  return (0, _reactCssThemr.themr)(_identifiers.TABS, _theme2.default)(Component);
};
var ThemedTabContent = applyTheme(_TabContent.TabContent);
var ThemedTab = applyTheme((0, _Tab.tabFactory)((0, _ripple2.default)({ centered: false })));
var ThemedTabs = applyTheme((0, _Tabs.tabsFactory)(ThemedTab, ThemedTabContent, _FontIcon.FontIcon));

exports.Tab = ThemedTab;
exports.Tabs = ThemedTabs;

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 190 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(29);
var dPs = __webpack_require__(947);
var enumBugKeys = __webpack_require__(510);
var IE_PROTO = __webpack_require__(509)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(507)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(511).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(948);
var enumBugKeys = __webpack_require__(510);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(107);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(93);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(108);
var call = __webpack_require__(950);
var isArrayIter = __webpack_require__(512);
var anObject = __webpack_require__(29);
var toLength = __webpack_require__(55);
var getIterFn = __webpack_require__(514);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(34);
var dP = __webpack_require__(61);
var DESCRIPTORS = __webpack_require__(56);
var SPECIES = __webpack_require__(52)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(948);
var hiddenKeys = __webpack_require__(510).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.GoogleLogin = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _button = __webpack_require__(8);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _analytics = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/google-signin-provider.jsx

var MAX_TIMEOUT = 200;
var GOOGLE_GSI_CLIENT = "https://accounts.google.com/gsi/client";
var GOOGLE_API_CLIENT = "https://apis.google.com/js/api.js";
var GOOGLE_API_TOKEN = "Google_API_Token";
var GSIClient = void 0;
var GSIOnSuccess = void 0;
var GSI_retry = 0;
var GAPI_retry = 0;
var GSCode = void 0;
var GSC_retry = 0;
var GSCOnSuccess = void 0;

var GoogleSigninProvider = function (_React$PureComponent) {
	_inherits(GoogleSigninProvider, _React$PureComponent);

	function GoogleSigninProvider() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, GoogleSigninProvider);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GoogleSigninProvider.__proto__ || Object.getPrototypeOf(GoogleSigninProvider)).call.apply(_ref, [this].concat(args))), _this), _this.onGSIload = function () {
			if (typeof google === 'undefined' || typeof google.accounts === 'undefined' || typeof google.accounts.oauth2 == 'undefined') {
				GSI_retry += 1;
				if (GSI_retry <= 3) setTimeout(_this.onGSIload, MAX_TIMEOUT);
				return;
			}
			GSIClient = google.accounts.oauth2.initTokenClient({
				client_id: _config2.default.integrationKeys.google.clientId,
				scope: _config2.default.integrationKeys.google.scope.join(' '),
				prompt: '',
				callback: function callback(response) {
					if (response && response.access_token) {
						response.expires_at = new Date().valueOf() + response.expires_in * 1000;
						localStorage.setItem(GOOGLE_API_TOKEN, JSON.stringify(response));
						gapi.client.setToken(response);
						GSIOnSuccess && GSIOnSuccess();
						GSIOnSuccess = undefined;
					}
				}
			});
		}, _this.onGAPILoad = function () {
			if (typeof gapi === 'undefined') {
				GAPI_retry += 1;
				if (GAPI_retry <= 3) setTimeout(_this.onGAPILoad, MAX_TIMEOUT);
				return;
			}
			gapi.load('client', function () {
				var token = JSON.parse(localStorage.getItem(GOOGLE_API_TOKEN) || '{}');
				if (token && token.access_token && token.expires_at && token.expires_at > new Date().valueOf()) {
					gapi.client.setToken(token);
				}
				gapi.client.setApiKey(_config2.default.integrationKeys.apiKey);
				gapi.client.load('drive', 'v3', function () {
					return undefined;
				});
				gapi.client.load('calendar', 'v3', function () {
					return undefined;
				});
			});
		}, _this.onGSCode = function () {
			if (typeof google === 'undefined' || typeof google.accounts === 'undefined' || typeof google.accounts.oauth2 == 'undefined') {
				GSC_retry += 1;
				if (GSC_retry <= 3) setTimeout(_this.onGSCode, MAX_TIMEOUT);
				return;
			}
			GSCode = google.accounts.oauth2.initCodeClient({
				client_id: _config2.default.integrationKeys.google.clientId,
				scope: _config2.default.integrationKeys.google.scope.join(' '),
				response_type: 'code',
				callback: function callback(response) {
					if (response && response.code) {
						localStorage.setItem("Google_Auth_Code", response.code);
						GSCOnSuccess && GSCOnSuccess();
						GSCOnSuccess = undefined;
					}
				}
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(GoogleSigninProvider, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var firstScript = document.getElementsByTagName('script')[0];
			var gsiScript = document.createElement('script');
			var gapiScript = document.createElement('script');
			var gscScript = document.createElement('script');

			gsiScript.src = GOOGLE_GSI_CLIENT;
			gsiScript.onload = this.onGSIload;
			gapiScript.src = GOOGLE_API_CLIENT;
			gapiScript.onload = this.onGAPILoad;
			gscScript.src = GOOGLE_GSI_CLIENT;
			gscScript.onload = this.onGSCode;

			firstScript.parentNode.insertBefore(gsiScript, firstScript);
			firstScript.parentNode.insertBefore(gapiScript, firstScript);
			firstScript.parentNode.insertBefore(gscScript, firstScript);
		}
	}, {
		key: 'render',
		value: function render() {
			var children = this.props.children;


			return _react2.default.createElement(
				'div',
				null,
				children
			);
		}
	}]);

	return GoogleSigninProvider;
}(_react2.default.PureComponent);

var googleLoginButtonStyle = {
	display: 'inline-block',
	background: '#303fa8',
	color: '#fff',
	width: '100%',
	fontWeight: 'bold'
};

var googleLoginButtonStyleSecond = {
	display: 'block',
	background: 'rgb(63 81 181)',
	color: '#fff',
	width: '50%'
};

var GoogleLogin = exports.GoogleLogin = function (_React$PureComponent2) {
	_inherits(GoogleLogin, _React$PureComponent2);

	function GoogleLogin() {
		var _ref2;

		var _temp2, _this2, _ret2;

		_classCallCheck(this, GoogleLogin);

		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = GoogleLogin.__proto__ || Object.getPrototypeOf(GoogleLogin)).call.apply(_ref2, [this].concat(args))), _this2), _this2.onSuccess = function () {
			_this2.props.onSuccess && _this2.props.onSuccess();
		}, _this2.onCodeSuccess = function () {
			_this2.props.onCodeSuccess && _this2.props.onCodeSuccess();
		}, _this2.onClick = function (type) {
			(0, _analytics.track)('onGoogleSigninClick');
			if (type == 'refresh_token') {
				GSCOnSuccess = _this2.onCodeSuccess;
				GSCode && GSCode.requestCode();
			} else {
				GSIOnSuccess = _this2.onSuccess;
				GSIClient && GSIClient.requestAccessToken();
			}
		}, _temp2), _possibleConstructorReturn(_this2, _ret2);
	}

	_createClass(GoogleLogin, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var token = JSON.parse(localStorage.getItem(GOOGLE_API_TOKEN) || '{}');
			if (token && token.access_token && token.expires_at && token.expires_at > new Date().valueOf()) this.onSuccess();
			var auth_code = localStorage.getItem("Google_Auth_Code");
			if (auth_code) this.onCodeSuccess();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var token = JSON.parse(localStorage.getItem(GOOGLE_API_TOKEN) || '{}');
			if (token && token.access_token && token.expires_at && token.expires_at > new Date().valueOf() && this.props.type != 'refresh_token') return null;else return _react2.default.createElement(_button.Button, { primary: true, style: this.props.type && (this.props.type == 'google_drive' || this.props.type == 'refresh_token') ? googleLoginButtonStyleSecond : googleLoginButtonStyle, onClick: function onClick() {
					return _this3.onClick(_this3.props.type);
				}, label: this.props.label });
		}
	}], [{
		key: 'signOut',
		value: function signOut() {
			localStorage.removeItem(GOOGLE_API_TOKEN);
			localStorage.removeItem("Google_Auth_Code");
			google.accounts.oauth2.revoke();
		}
	}]);

	return GoogleLogin;
}(_react2.default.PureComponent);

exports.default = GoogleSigninProvider;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNumber = formatNumber;
exports.percent = percent;

// src/helpers/format-number.js

// format: signed separate_1000 decimal_1 decimal_2 decimal_3 thousand million prepend_unit
// decimal_1: 小数点以下1桁, decimal_2: 小数点以下2桁, decimal_3: 小数点以下3桁

function rightString(str, len) {
  return str.substr(str.length - len, len);
}

function formatNumber(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof value == 'undefined') return '-';
  if (format.thousand) value = value / 1000;
  if (format.million) value = value / 1000000;

  var truncated = Math.floor(Math.abs(value));
  var fraction = Math.abs(value) - Math.floor(Math.abs(value)) + 0.0001;
  var text = '';
  var fraction_text = '';
  if (format.signed || value < 0) text = value >= 0 ? '+' : '-';

  if (format.decimal_1) fraction_text = '.' + (fraction * 10.0).toString().substr(0, 1);else if (format.decimal_2) fraction_text = '.' + rightString('0' + Math.round(fraction * 100.0, 1), 2);else if (format.decimal_3) fraction_text = '.' + rightString('00' + Math.round(fraction * 1000.0), 3);else if (fraction >= 0.5) truncated += 1;

  if (format.separate_1000) text = text + truncated.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + fraction_text;else text = text + truncated.toString() + fraction_text;

  return text;
}

function percent(value) {
  if (value == Infinity || typeof value != 'number' || function (x) {
    return x != x;
  }(value)) return '-';else return formatNumber(Math.round(value * 1000) / 10, { decimal_1: true });
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(169);
var createDesc = __webpack_require__(376);
module.exports = __webpack_require__(149) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 203 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DummyStatTimer = exports.StatTimer = exports.SimpleXMLParser = exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__(73);

var _global_scope = __webpack_require__(287);

var _global_scope2 = _interopRequireDefault(_global_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
var SVG_NS = 'http://www.w3.org/2000/svg';

var DOMCanvasFactory = function () {
  function DOMCanvasFactory() {
    _classCallCheck(this, DOMCanvasFactory);
  }

  _createClass(DOMCanvasFactory, [{
    key: 'create',
    value: function create(width, height) {
      if (width <= 0 || height <= 0) {
        throw new Error('invalid canvas size');
      }
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      return {
        canvas: canvas,
        context: context
      };
    }
  }, {
    key: 'reset',
    value: function reset(canvasAndContext, width, height) {
      if (!canvasAndContext.canvas) {
        throw new Error('canvas is not specified');
      }
      if (width <= 0 || height <= 0) {
        throw new Error('invalid canvas size');
      }
      canvasAndContext.canvas.width = width;
      canvasAndContext.canvas.height = height;
    }
  }, {
    key: 'destroy',
    value: function destroy(canvasAndContext) {
      if (!canvasAndContext.canvas) {
        throw new Error('canvas is not specified');
      }
      canvasAndContext.canvas.width = 0;
      canvasAndContext.canvas.height = 0;
      canvasAndContext.canvas = null;
      canvasAndContext.context = null;
    }
  }]);

  return DOMCanvasFactory;
}();

var DOMCMapReaderFactory = function () {
  function DOMCMapReaderFactory(_ref) {
    var _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
        _ref$isCompressed = _ref.isCompressed,
        isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;

    _classCallCheck(this, DOMCMapReaderFactory);

    this.baseUrl = baseUrl;
    this.isCompressed = isCompressed;
  }

  _createClass(DOMCMapReaderFactory, [{
    key: 'fetch',
    value: function fetch(_ref2) {
      var _this = this;

      var name = _ref2.name;

      if (!this.baseUrl) {
        return Promise.reject(new Error('CMap baseUrl must be specified, ' + 'see "PDFJS.cMapUrl" (and also "PDFJS.cMapPacked").'));
      }
      if (!name) {
        return Promise.reject(new Error('CMap name must be specified.'));
      }
      return new Promise(function (resolve, reject) {
        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        if (_this.isCompressed) {
          request.responseType = 'arraybuffer';
        }
        request.onreadystatechange = function () {
          if (request.readyState !== XMLHttpRequest.DONE) {
            return;
          }
          if (request.status === 200 || request.status === 0) {
            var data = void 0;
            if (_this.isCompressed && request.response) {
              data = new Uint8Array(request.response);
            } else if (!_this.isCompressed && request.responseText) {
              data = (0, _util.stringToBytes)(request.responseText);
            }
            if (data) {
              resolve({
                cMapData: data,
                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
              });
              return;
            }
          }
          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
        };
        request.send(null);
      });
    }
  }]);

  return DOMCMapReaderFactory;
}();

var DOMSVGFactory = function () {
  function DOMSVGFactory() {
    _classCallCheck(this, DOMSVGFactory);
  }

  _createClass(DOMSVGFactory, [{
    key: 'create',
    value: function create(width, height) {
      (0, _util.assert)(width > 0 && height > 0, 'Invalid SVG dimensions');
      var svg = document.createElementNS(SVG_NS, 'svg:svg');
      svg.setAttribute('version', '1.1');
      svg.setAttribute('width', width + 'px');
      svg.setAttribute('height', height + 'px');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
      return svg;
    }
  }, {
    key: 'createElement',
    value: function createElement(type) {
      (0, _util.assert)(typeof type === 'string', 'Invalid SVG element type');
      return document.createElementNS(SVG_NS, type);
    }
  }]);

  return DOMSVGFactory;
}();

var SimpleDOMNode = function () {
  function SimpleDOMNode(nodeName, nodeValue) {
    _classCallCheck(this, SimpleDOMNode);

    this.nodeName = nodeName;
    this.nodeValue = nodeValue;
    Object.defineProperty(this, 'parentNode', {
      value: null,
      writable: true
    });
  }

  _createClass(SimpleDOMNode, [{
    key: 'hasChildNodes',
    value: function hasChildNodes() {
      return this.childNodes && this.childNodes.length > 0;
    }
  }, {
    key: 'firstChild',
    get: function get() {
      return this.childNodes[0];
    }
  }, {
    key: 'nextSibling',
    get: function get() {
      var index = this.parentNode.childNodes.indexOf(this);
      return this.parentNode.childNodes[index + 1];
    }
  }, {
    key: 'textContent',
    get: function get() {
      if (!this.childNodes) {
        return this.nodeValue || '';
      }
      return this.childNodes.map(function (child) {
        return child.textContent;
      }).join('');
    }
  }]);

  return SimpleDOMNode;
}();

var SimpleXMLParser = function () {
  function SimpleXMLParser() {
    _classCallCheck(this, SimpleXMLParser);
  }

  _createClass(SimpleXMLParser, [{
    key: 'parseFromString',
    value: function parseFromString(data) {
      var _this2 = this;

      var nodes = [];
      data = data.replace(/<\?[\s\S]*?\?>|<!--[\s\S]*?-->/g, '').trim();
      data = data.replace(/<!DOCTYPE[^>\[]+(\[[^\]]+)?[^>]+>/g, '').trim();
      data = data.replace(/>([^<][\s\S]*?)</g, function (all, text) {
        var length = nodes.length;
        var node = new SimpleDOMNode('#text', _this2._decodeXML(text));
        nodes.push(node);
        if (node.textContent.trim().length === 0) {
          return '><';
        }
        return '>' + length + ',<';
      });
      data = data.replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, function (all, text) {
        var length = nodes.length;
        var node = new SimpleDOMNode('#text', text);
        nodes.push(node);
        return length + ',';
      });
      var regex = /<([\w\:]+)((?:[\s\w:=]|'[^']*'|"[^"]*")*)(?:\/>|>([\d,]*)<\/[^>]+>)/g;
      var lastLength = void 0;
      do {
        lastLength = nodes.length;
        data = data.replace(regex, function (all, name, attrs, data) {
          var length = nodes.length;
          var node = new SimpleDOMNode(name);
          var children = [];
          if (data) {
            data = data.split(',');
            data.pop();
            data.forEach(function (child) {
              var childNode = nodes[+child];
              childNode.parentNode = node;
              children.push(childNode);
            });
          }
          node.childNodes = children;
          nodes.push(node);
          return length + ',';
        });
      } while (lastLength < nodes.length);
      return { documentElement: nodes.pop() };
    }
  }, {
    key: '_decodeXML',
    value: function _decodeXML(text) {
      if (text.indexOf('&') < 0) {
        return text;
      }
      return text.replace(/&(#(x[0-9a-f]+|\d+)|\w+);/gi, function (all, entityName, number) {
        if (number) {
          if (number[0] === 'x') {
            number = parseInt(number.substring(1), 16);
          } else {
            number = +number;
          }
          return String.fromCharCode(number);
        }
        switch (entityName) {
          case 'amp':
            return '&';
          case 'lt':
            return '<';
          case 'gt':
            return '>';
          case 'quot':
            return '\"';
          case 'apos':
            return '\'';
        }
        return '&' + entityName + ';';
      });
    }
  }]);

  return SimpleXMLParser;
}();

var RenderingCancelledException = function RenderingCancelledException() {
  function RenderingCancelledException(msg, type) {
    this.message = msg;
    this.type = type;
  }
  RenderingCancelledException.prototype = new Error();
  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
  RenderingCancelledException.constructor = RenderingCancelledException;
  return RenderingCancelledException;
}();
var LinkTarget = {
  NONE: 0,
  SELF: 1,
  BLANK: 2,
  PARENT: 3,
  TOP: 4
};
var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
function addLinkAttributes(link, params) {
  var url = params && params.url;
  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
  if (url) {
    var target = params.target;
    if (typeof target === 'undefined') {
      target = getDefaultSetting('externalLinkTarget');
    }
    link.target = LinkTargetStringMap[target];
    var rel = params.rel;
    if (typeof rel === 'undefined') {
      rel = getDefaultSetting('externalLinkRel');
    }
    link.rel = rel;
  }
}
function getFilenameFromUrl(url) {
  var anchor = url.indexOf('#');
  var query = url.indexOf('?');
  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
  return url.substring(url.lastIndexOf('/', end) + 1, end);
}
function getDefaultSetting(id) {
  var globalSettings = _global_scope2.default.PDFJS;
  switch (id) {
    case 'pdfBug':
      return globalSettings ? globalSettings.pdfBug : false;
    case 'disableAutoFetch':
      return globalSettings ? globalSettings.disableAutoFetch : false;
    case 'disableStream':
      return globalSettings ? globalSettings.disableStream : false;
    case 'disableRange':
      return globalSettings ? globalSettings.disableRange : false;
    case 'disableFontFace':
      return globalSettings ? globalSettings.disableFontFace : false;
    case 'disableCreateObjectURL':
      return globalSettings ? globalSettings.disableCreateObjectURL : false;
    case 'disableWebGL':
      return globalSettings ? globalSettings.disableWebGL : true;
    case 'cMapUrl':
      return globalSettings ? globalSettings.cMapUrl : null;
    case 'cMapPacked':
      return globalSettings ? globalSettings.cMapPacked : false;
    case 'postMessageTransfers':
      return globalSettings ? globalSettings.postMessageTransfers : true;
    case 'workerPort':
      return globalSettings ? globalSettings.workerPort : null;
    case 'workerSrc':
      return globalSettings ? globalSettings.workerSrc : null;
    case 'disableWorker':
      return globalSettings ? globalSettings.disableWorker : false;
    case 'maxImageSize':
      return globalSettings ? globalSettings.maxImageSize : -1;
    case 'imageResourcesPath':
      return globalSettings ? globalSettings.imageResourcesPath : '';
    case 'isEvalSupported':
      return globalSettings ? globalSettings.isEvalSupported : true;
    case 'externalLinkTarget':
      if (!globalSettings) {
        return LinkTarget.NONE;
      }
      switch (globalSettings.externalLinkTarget) {
        case LinkTarget.NONE:
        case LinkTarget.SELF:
        case LinkTarget.BLANK:
        case LinkTarget.PARENT:
        case LinkTarget.TOP:
          return globalSettings.externalLinkTarget;
      }
      (0, _util.warn)('PDFJS.externalLinkTarget is invalid: ' + globalSettings.externalLinkTarget);
      globalSettings.externalLinkTarget = LinkTarget.NONE;
      return LinkTarget.NONE;
    case 'externalLinkRel':
      return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
    case 'enableStats':
      return !!(globalSettings && globalSettings.enableStats);
    default:
      throw new Error('Unknown default setting: ' + id);
  }
}
function isExternalLinkTargetSet() {
  var externalLinkTarget = getDefaultSetting('externalLinkTarget');
  switch (externalLinkTarget) {
    case LinkTarget.NONE:
      return false;
    case LinkTarget.SELF:
    case LinkTarget.BLANK:
    case LinkTarget.PARENT:
    case LinkTarget.TOP:
      return true;
  }
}

var StatTimer = function () {
  function StatTimer() {
    var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    _classCallCheck(this, StatTimer);

    this.enabled = !!enable;
    this.started = Object.create(null);
    this.times = [];
  }

  _createClass(StatTimer, [{
    key: 'time',
    value: function time(name) {
      if (!this.enabled) {
        return;
      }
      if (name in this.started) {
        (0, _util.warn)('Timer is already running for ' + name);
      }
      this.started[name] = Date.now();
    }
  }, {
    key: 'timeEnd',
    value: function timeEnd(name) {
      if (!this.enabled) {
        return;
      }
      if (!(name in this.started)) {
        (0, _util.warn)('Timer has not been started for ' + name);
      }
      this.times.push({
        'name': name,
        'start': this.started[name],
        'end': Date.now()
      });
      delete this.started[name];
    }
  }, {
    key: 'toString',
    value: function toString() {
      var times = this.times;
      var out = '',
          longest = 0;
      for (var i = 0, ii = times.length; i < ii; ++i) {
        var name = times[i]['name'];
        if (name.length > longest) {
          longest = name.length;
        }
      }
      for (var _i = 0, _ii = times.length; _i < _ii; ++_i) {
        var span = times[_i];
        var duration = span.end - span.start;
        out += span['name'].padEnd(longest) + ' ' + duration + 'ms\n';
      }
      return out;
    }
  }]);

  return StatTimer;
}();

var DummyStatTimer = function () {
  function DummyStatTimer() {
    _classCallCheck(this, DummyStatTimer);

    (0, _util.unreachable)('Cannot initialize DummyStatTimer.');
  }

  _createClass(DummyStatTimer, null, [{
    key: 'time',
    value: function time(name) {}
  }, {
    key: 'timeEnd',
    value: function timeEnd(name) {}
  }, {
    key: 'toString',
    value: function toString() {
      return '';
    }
  }]);

  return DummyStatTimer;
}();

exports.RenderingCancelledException = RenderingCancelledException;
exports.addLinkAttributes = addLinkAttributes;
exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
exports.getFilenameFromUrl = getFilenameFromUrl;
exports.LinkTarget = LinkTarget;
exports.getDefaultSetting = getDefaultSetting;
exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
exports.DOMCanvasFactory = DOMCanvasFactory;
exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
exports.DOMSVGFactory = DOMSVGFactory;
exports.SimpleXMLParser = SimpleXMLParser;
exports.StatTimer = StatTimer;
exports.DummyStatTimer = DummyStatTimer;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2504);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./two-column-layout.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./two-column-layout.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(2628);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule emptyFunction
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
function emptyFunction() {}

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_ClientConfiguration_js__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__network_NetworkManager_js__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger_Logger_js__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packageMetadata_js__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_CcsCredential_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__account_ClientInfo_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__request_RequestParameterBuilder_js__ = __webpack_require__(209);
/*! @azure/msal-common v13.3.1 2023-10-27 */












/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
 */
var BaseClient = /** @class */ (function () {
    function BaseClient(configuration, performanceClient) {
        // Set the configuration
        this.config = Object(__WEBPACK_IMPORTED_MODULE_1__config_ClientConfiguration_js__["b" /* buildClientConfiguration */])(configuration);
        // Initialize the logger
        this.logger = new __WEBPACK_IMPORTED_MODULE_3__logger_Logger_js__["b" /* Logger */](this.config.loggerOptions, __WEBPACK_IMPORTED_MODULE_5__packageMetadata_js__["a" /* name */], __WEBPACK_IMPORTED_MODULE_5__packageMetadata_js__["b" /* version */]);
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set the NetworkManager
        this.networkManager = new __WEBPACK_IMPORTED_MODULE_2__network_NetworkManager_js__["a" /* NetworkManager */](this.networkClient, this.cacheManager);
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Creates default headers for requests to token endpoint
     */
    BaseClient.prototype.createTokenRequestHeaders = function (ccsCred) {
        var headers = {};
        headers[__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["q" /* HeaderNames */].CONTENT_TYPE] = __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].URL_FORM_CONTENT_TYPE;
        if (!this.config.systemOptions.preventCorsPreflight && ccsCred) {
            switch (ccsCred.type) {
                case __WEBPACK_IMPORTED_MODULE_7__account_CcsCredential_js__["a" /* CcsCredentialType */].HOME_ACCOUNT_ID:
                    try {
                        var clientInfo = Object(__WEBPACK_IMPORTED_MODULE_8__account_ClientInfo_js__["b" /* buildClientInfoFromHomeAccountId */])(ccsCred.credential);
                        headers[__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["q" /* HeaderNames */].CCS_HEADER] = "Oid:" + clientInfo.uid + "@" + clientInfo.utid;
                    }
                    catch (e) {
                        this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_7__account_CcsCredential_js__["a" /* CcsCredentialType */].UPN:
                    headers[__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["q" /* HeaderNames */].CCS_HEADER] = "UPN: " + ccsCred.credential;
                    break;
            }
        }
        return headers;
    };
    /**
     * Http post to token endpoint
     * @param tokenEndpoint
     * @param queryString
     * @param headers
     * @param thumbprint
     */
    BaseClient.prototype.executePostToTokenEndpoint = function (tokenEndpoint, queryString, headers, thumbprint) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var response;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.networkManager.sendPostRequest(thumbprint, tokenEndpoint, { body: queryString, headers: headers })];
                    case 1:
                        response = _a.sent();
                        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) {
                            // Telemetry data successfully logged by server, clear Telemetry cache
                            this.config.serverTelemetryManager.clearTelemetryCache();
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Updates the authority object of the client. Endpoint discovery must be completed.
     * @param updatedAuthority
     */
    BaseClient.prototype.updateAuthority = function (updatedAuthority) {
        if (!updatedAuthority.discoveryComplete()) {
            throw __WEBPACK_IMPORTED_MODULE_6__error_ClientAuthError_js__["a" /* ClientAuthError */].createEndpointDiscoveryIncompleteError("Updated authority has not completed endpoint discovery.");
        }
        this.authority = updatedAuthority;
    };
    /**
     * Creates query string for the /token request
     * @param request
     */
    BaseClient.prototype.createTokenQueryParameters = function (request) {
        var parameterBuilder = new __WEBPACK_IMPORTED_MODULE_9__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
        if (request.tokenQueryParameters) {
            parameterBuilder.addExtraQueryParameters(request.tokenQueryParameters);
        }
        return parameterBuilder.createQueryString();
    };
    return BaseClient;
}());


//# sourceMappingURL=BaseClient.js.map


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestParameterBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScopeSet_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RequestValidator_js__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__ = __webpack_require__(65);
/*! @azure/msal-common v13.3.1 2023-10-27 */








/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var RequestParameterBuilder = /** @class */ (function () {
    function RequestParameterBuilder() {
        this.parameters = new Map();
    }
    /**
     * add response_type = code
     */
    RequestParameterBuilder.prototype.addResponseTypeCode = function () {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].RESPONSE_TYPE, encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].CODE_RESPONSE_TYPE));
    };
    /**
     * add response_type = token id_token
     */
    RequestParameterBuilder.prototype.addResponseTypeForTokenAndIdToken = function () {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].RESPONSE_TYPE, encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].TOKEN_RESPONSE_TYPE + " " + __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].ID_TOKEN_RESPONSE_TYPE));
    };
    /**
     * add response_mode. defaults to query.
     * @param responseMode
     */
    RequestParameterBuilder.prototype.addResponseMode = function (responseMode) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].RESPONSE_MODE, encodeURIComponent((responseMode) ? responseMode : __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["A" /* ResponseMode */].QUERY));
    };
    /**
     * Add flag to indicate STS should attempt to use WAM if available
     */
    RequestParameterBuilder.prototype.addNativeBroker = function () {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].NATIVE_BROKER, encodeURIComponent("1"));
    };
    /**
     * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
     * @param scopeSet
     * @param addOidcScopes
     */
    RequestParameterBuilder.prototype.addScopes = function (scopes, addOidcScopes) {
        if (addOidcScopes === void 0) { addOidcScopes = true; }
        var requestScopes = addOidcScopes ? Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["e" /* __spreadArrays */])(scopes || [], __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["s" /* OIDC_DEFAULT_SCOPES */]) : scopes || [];
        var scopeSet = new __WEBPACK_IMPORTED_MODULE_2__ScopeSet_js__["a" /* ScopeSet */](requestScopes);
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].SCOPE, encodeURIComponent(scopeSet.printScopes()));
    };
    /**
     * add clientId
     * @param clientId
     */
    RequestParameterBuilder.prototype.addClientId = function (clientId) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].CLIENT_ID, encodeURIComponent(clientId));
    };
    /**
     * add redirect_uri
     * @param redirectUri
     */
    RequestParameterBuilder.prototype.addRedirectUri = function (redirectUri) {
        __WEBPACK_IMPORTED_MODULE_4__RequestValidator_js__["a" /* RequestValidator */].validateRedirectUri(redirectUri);
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].REDIRECT_URI, encodeURIComponent(redirectUri));
    };
    /**
     * add post logout redirectUri
     * @param redirectUri
     */
    RequestParameterBuilder.prototype.addPostLogoutRedirectUri = function (redirectUri) {
        __WEBPACK_IMPORTED_MODULE_4__RequestValidator_js__["a" /* RequestValidator */].validateRedirectUri(redirectUri);
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].POST_LOGOUT_URI, encodeURIComponent(redirectUri));
    };
    /**
     * add id_token_hint to logout request
     * @param idTokenHint
     */
    RequestParameterBuilder.prototype.addIdTokenHint = function (idTokenHint) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].ID_TOKEN_HINT, encodeURIComponent(idTokenHint));
    };
    /**
     * add domain_hint
     * @param domainHint
     */
    RequestParameterBuilder.prototype.addDomainHint = function (domainHint) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["C" /* SSOTypes */].DOMAIN_HINT, encodeURIComponent(domainHint));
    };
    /**
     * add login_hint
     * @param loginHint
     */
    RequestParameterBuilder.prototype.addLoginHint = function (loginHint) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["C" /* SSOTypes */].LOGIN_HINT, encodeURIComponent(loginHint));
    };
    /**
     * Adds the CCS (Cache Credential Service) query parameter for login_hint
     * @param loginHint
     */
    RequestParameterBuilder.prototype.addCcsUpn = function (loginHint) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["q" /* HeaderNames */].CCS_HEADER, encodeURIComponent("UPN:" + loginHint));
    };
    /**
     * Adds the CCS (Cache Credential Service) query parameter for account object
     * @param loginHint
     */
    RequestParameterBuilder.prototype.addCcsOid = function (clientInfo) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["q" /* HeaderNames */].CCS_HEADER, encodeURIComponent("Oid:" + clientInfo.uid + "@" + clientInfo.utid));
    };
    /**
     * add sid
     * @param sid
     */
    RequestParameterBuilder.prototype.addSid = function (sid) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["C" /* SSOTypes */].SID, encodeURIComponent(sid));
    };
    /**
     * add claims
     * @param claims
     */
    RequestParameterBuilder.prototype.addClaims = function (claims, clientCapabilities) {
        var mergedClaims = this.addClientCapabilitiesToClaims(claims, clientCapabilities);
        __WEBPACK_IMPORTED_MODULE_4__RequestValidator_js__["a" /* RequestValidator */].validateClaims(mergedClaims);
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].CLAIMS, encodeURIComponent(mergedClaims));
    };
    /**
     * add correlationId
     * @param correlationId
     */
    RequestParameterBuilder.prototype.addCorrelationId = function (correlationId) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].CLIENT_REQUEST_ID, encodeURIComponent(correlationId));
    };
    /**
     * add library info query params
     * @param libraryInfo
     */
    RequestParameterBuilder.prototype.addLibraryInfo = function (libraryInfo) {
        // Telemetry Info
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].X_CLIENT_SKU, libraryInfo.sku);
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].X_CLIENT_VER, libraryInfo.version);
        if (libraryInfo.os) {
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].X_CLIENT_OS, libraryInfo.os);
        }
        if (libraryInfo.cpu) {
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].X_CLIENT_CPU, libraryInfo.cpu);
        }
    };
    /**
     * Add client telemetry parameters
     * @param appTelemetry
     */
    RequestParameterBuilder.prototype.addApplicationTelemetry = function (appTelemetry) {
        if (appTelemetry === null || appTelemetry === void 0 ? void 0 : appTelemetry.appName) {
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].X_APP_NAME, appTelemetry.appName);
        }
        if (appTelemetry === null || appTelemetry === void 0 ? void 0 : appTelemetry.appVersion) {
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].X_APP_VER, appTelemetry.appVersion);
        }
    };
    /**
     * add prompt
     * @param prompt
     */
    RequestParameterBuilder.prototype.addPrompt = function (prompt) {
        __WEBPACK_IMPORTED_MODULE_4__RequestValidator_js__["a" /* RequestValidator */].validatePrompt(prompt);
        this.parameters.set("" + __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].PROMPT, encodeURIComponent(prompt));
    };
    /**
     * add state
     * @param state
     */
    RequestParameterBuilder.prototype.addState = function (state) {
        if (!__WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(state)) {
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].STATE, encodeURIComponent(state));
        }
    };
    /**
     * add nonce
     * @param nonce
     */
    RequestParameterBuilder.prototype.addNonce = function (nonce) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].NONCE, encodeURIComponent(nonce));
    };
    /**
     * add code_challenge and code_challenge_method
     * - throw if either of them are not passed
     * @param codeChallenge
     * @param codeChallengeMethod
     */
    RequestParameterBuilder.prototype.addCodeChallengeParams = function (codeChallenge, codeChallengeMethod) {
        __WEBPACK_IMPORTED_MODULE_4__RequestValidator_js__["a" /* RequestValidator */].validateCodeChallengeParams(codeChallenge, codeChallengeMethod);
        if (codeChallenge && codeChallengeMethod) {
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].CODE_CHALLENGE, encodeURIComponent(codeChallenge));
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].CODE_CHALLENGE_METHOD, encodeURIComponent(codeChallengeMethod));
        }
        else {
            throw __WEBPACK_IMPORTED_MODULE_3__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInvalidCodeChallengeParamsError();
        }
    };
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */
    RequestParameterBuilder.prototype.addAuthorizationCode = function (code) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].CODE, encodeURIComponent(code));
    };
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */
    RequestParameterBuilder.prototype.addDeviceCode = function (code) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].DEVICE_CODE, encodeURIComponent(code));
    };
    /**
     * add the `refreshToken` passed by the user
     * @param refreshToken
     */
    RequestParameterBuilder.prototype.addRefreshToken = function (refreshToken) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].REFRESH_TOKEN, encodeURIComponent(refreshToken));
    };
    /**
     * add the `code_verifier` passed by the user to exchange for a token
     * @param codeVerifier
     */
    RequestParameterBuilder.prototype.addCodeVerifier = function (codeVerifier) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].CODE_VERIFIER, encodeURIComponent(codeVerifier));
    };
    /**
     * add client_secret
     * @param clientSecret
     */
    RequestParameterBuilder.prototype.addClientSecret = function (clientSecret) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].CLIENT_SECRET, encodeURIComponent(clientSecret));
    };
    /**
     * add clientAssertion for confidential client flows
     * @param clientAssertion
     */
    RequestParameterBuilder.prototype.addClientAssertion = function (clientAssertion) {
        if (!__WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(clientAssertion)) {
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].CLIENT_ASSERTION, encodeURIComponent(clientAssertion));
        }
    };
    /**
     * add clientAssertionType for confidential client flows
     * @param clientAssertionType
     */
    RequestParameterBuilder.prototype.addClientAssertionType = function (clientAssertionType) {
        if (!__WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(clientAssertionType)) {
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].CLIENT_ASSERTION_TYPE, encodeURIComponent(clientAssertionType));
        }
    };
    /**
     * add OBO assertion for confidential client flows
     * @param clientAssertion
     */
    RequestParameterBuilder.prototype.addOboAssertion = function (oboAssertion) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].OBO_ASSERTION, encodeURIComponent(oboAssertion));
    };
    /**
     * add grant type
     * @param grantType
     */
    RequestParameterBuilder.prototype.addRequestTokenUse = function (tokenUse) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].REQUESTED_TOKEN_USE, encodeURIComponent(tokenUse));
    };
    /**
     * add grant type
     * @param grantType
     */
    RequestParameterBuilder.prototype.addGrantType = function (grantType) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].GRANT_TYPE, encodeURIComponent(grantType));
    };
    /**
     * add client info
     *
     */
    RequestParameterBuilder.prototype.addClientInfo = function () {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["g" /* CLIENT_INFO */], "1");
    };
    /**
     * add extraQueryParams
     * @param eQParams
     */
    RequestParameterBuilder.prototype.addExtraQueryParameters = function (eQParams) {
        var _this = this;
        var sanitizedEQParams = __WEBPACK_IMPORTED_MODULE_4__RequestValidator_js__["a" /* RequestValidator */].sanitizeEQParams(eQParams, this.parameters);
        Object.keys(sanitizedEQParams).forEach(function (key) {
            _this.parameters.set(key, eQParams[key]);
        });
    };
    RequestParameterBuilder.prototype.addClientCapabilitiesToClaims = function (claims, clientCapabilities) {
        var mergedClaims;
        // Parse provided claims into JSON object or initialize empty object
        if (!claims) {
            mergedClaims = {};
        }
        else {
            try {
                mergedClaims = JSON.parse(claims);
            }
            catch (e) {
                throw __WEBPACK_IMPORTED_MODULE_3__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInvalidClaimsRequestError();
            }
        }
        if (clientCapabilities && clientCapabilities.length > 0) {
            if (!mergedClaims.hasOwnProperty(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["k" /* ClaimsRequestKeys */].ACCESS_TOKEN)) {
                // Add access_token key to claims object
                mergedClaims[__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["k" /* ClaimsRequestKeys */].ACCESS_TOKEN] = {};
            }
            // Add xms_cc claim with provided clientCapabilities to access_token key
            mergedClaims[__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["k" /* ClaimsRequestKeys */].ACCESS_TOKEN][__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["k" /* ClaimsRequestKeys */].XMS_CC] = {
                values: clientCapabilities
            };
        }
        return JSON.stringify(mergedClaims);
    };
    /**
     * adds `username` for Password Grant flow
     * @param username
     */
    RequestParameterBuilder.prototype.addUsername = function (username) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["u" /* PasswordGrantConstants */].username, encodeURIComponent(username));
    };
    /**
     * adds `password` for Password Grant flow
     * @param password
     */
    RequestParameterBuilder.prototype.addPassword = function (password) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["u" /* PasswordGrantConstants */].password, encodeURIComponent(password));
    };
    /**
     * add pop_jwk to query params
     * @param cnfString
     */
    RequestParameterBuilder.prototype.addPopToken = function (cnfString) {
        if (!__WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(cnfString)) {
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].TOKEN_TYPE, __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["e" /* AuthenticationScheme */].POP);
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].REQ_CNF, encodeURIComponent(cnfString));
        }
    };
    /**
     * add SSH JWK and key ID to query params
     */
    RequestParameterBuilder.prototype.addSshJwk = function (sshJwkString) {
        if (!__WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(sshJwkString)) {
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].TOKEN_TYPE, __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["e" /* AuthenticationScheme */].SSH);
            this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].REQ_CNF, encodeURIComponent(sshJwkString));
        }
    };
    /**
     * add server telemetry fields
     * @param serverTelemetryManager
     */
    RequestParameterBuilder.prototype.addServerTelemetry = function (serverTelemetryManager) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].X_CLIENT_CURR_TELEM, serverTelemetryManager.generateCurrentRequestHeaderValue());
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].X_CLIENT_LAST_TELEM, serverTelemetryManager.generateLastRequestHeaderValue());
    };
    /**
     * Adds parameter that indicates to the server that throttling is supported
     */
    RequestParameterBuilder.prototype.addThrottling = function () {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].X_MS_LIB_CAPABILITY, __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["F" /* ThrottlingConstants */].X_MS_LIB_CAPABILITY_VALUE);
    };
    /**
     * Adds logout_hint parameter for "silent" logout which prevent server account picker
     */
    RequestParameterBuilder.prototype.addLogoutHint = function (logoutHint) {
        this.parameters.set(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["b" /* AADServerParamKeys */].LOGOUT_HINT, encodeURIComponent(logoutHint));
    };
    /**
     * Utility to create a URL from the params map
     */
    RequestParameterBuilder.prototype.createQueryString = function () {
        var queryParameterArray = new Array();
        this.parameters.forEach(function (value, key) {
            queryParameterArray.push(key + "=" + value);
        });
        return queryParameterArray.join("&");
    };
    return RequestParameterBuilder;
}());


//# sourceMappingURL=RequestParameterBuilder.js.map


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResponseHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__account_ClientInfo_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_ServerError_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_AuthToken_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__request_ScopeSet_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cache_entities_AccountEntity_js__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__authority_AuthorityType_js__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cache_entities_IdTokenEntity_js__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cache_entities_AccessTokenEntity_js__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cache_entities_RefreshTokenEntity_js__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__error_InteractionRequiredAuthError_js__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cache_entities_CacheRecord_js__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ProtocolUtils_js__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__crypto_PopTokenGenerator_js__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cache_entities_AppMetadataEntity_js__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__cache_persistence_TokenCacheContext_js__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__telemetry_performance_PerformanceEvent_js__ = __webpack_require__(153);
/*! @azure/msal-common v13.3.1 2023-10-27 */






















/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Class that handles response parsing.
 */
var ResponseHandler = /** @class */ (function () {
    function ResponseHandler(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin, performanceClient) {
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
        this.performanceClient = performanceClient;
    }
    /**
     * Function which validates server authorization code response.
     * @param serverResponseHash
     * @param cachedState
     * @param cryptoObj
     */
    ResponseHandler.prototype.validateServerAuthorizationCodeResponse = function (serverResponseHash, cachedState, cryptoObj) {
        if (!serverResponseHash.state || !cachedState) {
            throw !serverResponseHash.state ? __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createStateNotFoundError("Server State") : __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createStateNotFoundError("Cached State");
        }
        if (decodeURIComponent(serverResponseHash.state) !== decodeURIComponent(cachedState)) {
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createStateMismatchError();
        }
        // Check for error
        if (serverResponseHash.error || serverResponseHash.error_description || serverResponseHash.suberror) {
            if (__WEBPACK_IMPORTED_MODULE_12__error_InteractionRequiredAuthError_js__["a" /* InteractionRequiredAuthError */].isInteractionRequiredError(serverResponseHash.error, serverResponseHash.error_description, serverResponseHash.suberror)) {
                throw new __WEBPACK_IMPORTED_MODULE_12__error_InteractionRequiredAuthError_js__["a" /* InteractionRequiredAuthError */](serverResponseHash.error || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, serverResponseHash.error_description, serverResponseHash.suberror, serverResponseHash.timestamp || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, serverResponseHash.trace_id || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, serverResponseHash.correlation_id || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, serverResponseHash.claims || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING);
            }
            throw new __WEBPACK_IMPORTED_MODULE_4__error_ServerError_js__["a" /* ServerError */](serverResponseHash.error || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, serverResponseHash.error_description, serverResponseHash.suberror);
        }
        if (serverResponseHash.client_info) {
            Object(__WEBPACK_IMPORTED_MODULE_1__account_ClientInfo_js__["a" /* buildClientInfo */])(serverResponseHash.client_info, cryptoObj);
        }
    };
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     */
    ResponseHandler.prototype.validateTokenResponse = function (serverResponse) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            if (__WEBPACK_IMPORTED_MODULE_12__error_InteractionRequiredAuthError_js__["a" /* InteractionRequiredAuthError */].isInteractionRequiredError(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) {
                throw new __WEBPACK_IMPORTED_MODULE_12__error_InteractionRequiredAuthError_js__["a" /* InteractionRequiredAuthError */](serverResponse.error, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, serverResponse.trace_id || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, serverResponse.correlation_id || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, serverResponse.claims || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING);
            }
            var errString = serverResponse.error_codes + " - [" + serverResponse.timestamp + "]: " + serverResponse.error_description + " - Correlation ID: " + serverResponse.correlation_id + " - Trace ID: " + serverResponse.trace_id;
            throw new __WEBPACK_IMPORTED_MODULE_4__error_ServerError_js__["a" /* ServerError */](serverResponse.error, errString, serverResponse.suberror);
        }
    };
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */
    ResponseHandler.prototype.handleServerTokenResponse = function (serverTokenResponse, authority, reqTimestamp, request, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var idTokenObj, authTime, requestStateObj, cacheRecord, cacheContext, key, account;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_19__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].HandleServerTokenResponse, serverTokenResponse.correlation_id);
                        if (serverTokenResponse.id_token) {
                            idTokenObj = new __WEBPACK_IMPORTED_MODULE_5__account_AuthToken_js__["a" /* AuthToken */](serverTokenResponse.id_token || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, this.cryptoObj);
                            // token nonce check (TODO: Add a warning if no nonce is given?)
                            if (authCodePayload && !__WEBPACK_IMPORTED_MODULE_3__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(authCodePayload.nonce)) {
                                if (idTokenObj.claims.nonce !== authCodePayload.nonce) {
                                    throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createNonceMismatchError();
                                }
                            }
                            // token max_age check
                            if (request.maxAge || (request.maxAge === 0)) {
                                authTime = idTokenObj.claims.auth_time;
                                if (!authTime) {
                                    throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createAuthTimeNotFoundError();
                                }
                                __WEBPACK_IMPORTED_MODULE_5__account_AuthToken_js__["a" /* AuthToken */].checkMaxAge(authTime, request.maxAge);
                            }
                        }
                        // generate homeAccountId
                        this.homeAccountIdentifier = __WEBPACK_IMPORTED_MODULE_7__cache_entities_AccountEntity_js__["a" /* AccountEntity */].generateHomeAccountId(serverTokenResponse.client_info || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenObj);
                        if (!!authCodePayload && !!authCodePayload.state) {
                            requestStateObj = __WEBPACK_IMPORTED_MODULE_14__utils_ProtocolUtils_js__["a" /* ProtocolUtils */].parseRequestState(this.cryptoObj, authCodePayload.state);
                        }
                        // Add keyId from request to serverTokenResponse if defined
                        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
                        cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenObj, userAssertionHash, authCodePayload);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 5, 8]);
                        if (!(this.persistencePlugin && this.serializableCache)) return [3 /*break*/, 3];
                        this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
                        cacheContext = new __WEBPACK_IMPORTED_MODULE_18__cache_persistence_TokenCacheContext_js__["a" /* TokenCacheContext */](this.serializableCache, true);
                        return [4 /*yield*/, this.persistencePlugin.beforeCacheAccess(cacheContext)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        /*
                         * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
                         * If not present, we should return null, as it's the case that another application called removeAccount in between
                         * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
                         * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
                         */
                        if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                            key = cacheRecord.account.generateAccountKey();
                            account = this.cacheStorage.getAccount(key);
                            if (!account) {
                                this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
                                return [2 /*return*/, ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenObj, requestStateObj, undefined, serverRequestId)];
                            }
                        }
                        return [4 /*yield*/, this.cacheStorage.saveCacheRecord(cacheRecord)];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 5:
                        if (!(this.persistencePlugin && this.serializableCache && cacheContext)) return [3 /*break*/, 7];
                        this.logger.verbose("Persistence enabled, calling afterCacheAccess");
                        return [4 /*yield*/, this.persistencePlugin.afterCacheAccess(cacheContext)];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7: return [7 /*endfinally*/];
                    case 8: return [2 /*return*/, ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenObj, requestStateObj, serverTokenResponse, serverRequestId)];
                }
            });
        });
    };
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */
    ResponseHandler.prototype.generateCacheRecord = function (serverTokenResponse, authority, reqTimestamp, request, idTokenObj, userAssertionHash, authCodePayload) {
        var env = authority.getPreferredCache();
        if (__WEBPACK_IMPORTED_MODULE_3__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(env)) {
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createInvalidCacheEnvironmentError();
        }
        // IdToken: non AAD scenarios can have empty realm
        var cachedIdToken;
        var cachedAccount;
        if (!__WEBPACK_IMPORTED_MODULE_3__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(serverTokenResponse.id_token) && !!idTokenObj) {
            cachedIdToken = __WEBPACK_IMPORTED_MODULE_9__cache_entities_IdTokenEntity_js__["a" /* IdTokenEntity */].createIdTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.id_token || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, this.clientId, idTokenObj.claims.tid || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING);
            cachedAccount = this.generateAccountEntity(serverTokenResponse, idTokenObj, authority, authCodePayload);
        }
        // AccessToken
        var cachedAccessToken = null;
        if (!__WEBPACK_IMPORTED_MODULE_3__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(serverTokenResponse.access_token)) {
            // If scopes not returned in server response, use request scopes
            var responseScopes = serverTokenResponse.scope ? __WEBPACK_IMPORTED_MODULE_6__request_ScopeSet_js__["a" /* ScopeSet */].fromString(serverTokenResponse.scope) : new __WEBPACK_IMPORTED_MODULE_6__request_ScopeSet_js__["a" /* ScopeSet */](request.scopes || []);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */
            var expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            var extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            var refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            var tokenExpirationSeconds = reqTimestamp + expiresIn;
            var extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            var refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = __WEBPACK_IMPORTED_MODULE_10__cache_entities_AccessTokenEntity_js__["a" /* AccessTokenEntity */].createAccessTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.access_token || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, this.clientId, idTokenObj ? idTokenObj.claims.tid || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING : authority.tenant, responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, request.claims, request.requestedClaimsHash);
        }
        // refreshToken
        var cachedRefreshToken = null;
        if (!__WEBPACK_IMPORTED_MODULE_3__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(serverTokenResponse.refresh_token)) {
            cachedRefreshToken = __WEBPACK_IMPORTED_MODULE_11__cache_entities_RefreshTokenEntity_js__["a" /* RefreshTokenEntity */].createRefreshTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, this.clientId, serverTokenResponse.foci, userAssertionHash);
        }
        // appMetadata
        var cachedAppMetadata = null;
        if (!__WEBPACK_IMPORTED_MODULE_3__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(serverTokenResponse.foci)) {
            cachedAppMetadata = __WEBPACK_IMPORTED_MODULE_17__cache_entities_AppMetadataEntity_js__["a" /* AppMetadataEntity */].createAppMetadataEntity(this.clientId, env, serverTokenResponse.foci);
        }
        return new __WEBPACK_IMPORTED_MODULE_13__cache_entities_CacheRecord_js__["a" /* CacheRecord */](cachedAccount, cachedIdToken, cachedAccessToken, cachedRefreshToken, cachedAppMetadata);
    };
    /**
     * Generate Account
     * @param serverTokenResponse
     * @param idToken
     * @param authority
     */
    ResponseHandler.prototype.generateAccountEntity = function (serverTokenResponse, idToken, authority, authCodePayload) {
        var authorityType = authority.authorityType;
        var cloudGraphHostName = authCodePayload ? authCodePayload.cloud_graph_host_name : __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        var msGraphhost = authCodePayload ? authCodePayload.msgraph_host : __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        // ADFS does not require client_info in the response
        if (authorityType === __WEBPACK_IMPORTED_MODULE_8__authority_AuthorityType_js__["a" /* AuthorityType */].Adfs) {
            this.logger.verbose("Authority type is ADFS, creating ADFS account");
            return __WEBPACK_IMPORTED_MODULE_7__cache_entities_AccountEntity_js__["a" /* AccountEntity */].createGenericAccount(this.homeAccountIdentifier, idToken, authority, cloudGraphHostName, msGraphhost);
        }
        // This fallback applies to B2C as well as they fall under an AAD account type.
        if (__WEBPACK_IMPORTED_MODULE_3__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(serverTokenResponse.client_info) && authority.protocolMode === "AAD") {
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createClientInfoEmptyError();
        }
        return serverTokenResponse.client_info ?
            __WEBPACK_IMPORTED_MODULE_7__cache_entities_AccountEntity_js__["a" /* AccountEntity */].createAccount(serverTokenResponse.client_info, this.homeAccountIdentifier, idToken, authority, cloudGraphHostName, msGraphhost) :
            __WEBPACK_IMPORTED_MODULE_7__cache_entities_AccountEntity_js__["a" /* AccountEntity */].createGenericAccount(this.homeAccountIdentifier, idToken, authority, cloudGraphHostName, msGraphhost);
    };
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */
    ResponseHandler.generateAuthenticationResult = function (cryptoObj, authority, cacheRecord, fromTokenCache, request, idTokenObj, requestState, serverTokenResponse, requestId) {
        var _a, _b, _c;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var accessToken, responseScopes, expiresOn, extExpiresOn, familyId, popTokenGenerator, _d, secret, keyId, uid, tid;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        accessToken = __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
                        responseScopes = [];
                        expiresOn = null;
                        familyId = __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
                        if (!cacheRecord.accessToken) return [3 /*break*/, 4];
                        if (!(cacheRecord.accessToken.tokenType === __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["e" /* AuthenticationScheme */].POP)) return [3 /*break*/, 2];
                        popTokenGenerator = new __WEBPACK_IMPORTED_MODULE_16__crypto_PopTokenGenerator_js__["a" /* PopTokenGenerator */](cryptoObj);
                        _d = cacheRecord.accessToken, secret = _d.secret, keyId = _d.keyId;
                        if (!keyId) {
                            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createKeyIdMissingError();
                        }
                        return [4 /*yield*/, popTokenGenerator.signPopToken(secret, keyId, request)];
                    case 1:
                        accessToken = _e.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        accessToken = cacheRecord.accessToken.secret;
                        _e.label = 3;
                    case 3:
                        responseScopes = __WEBPACK_IMPORTED_MODULE_6__request_ScopeSet_js__["a" /* ScopeSet */].fromString(cacheRecord.accessToken.target).asArray();
                        expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
                        extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
                        _e.label = 4;
                    case 4:
                        if (cacheRecord.appMetadata) {
                            familyId = cacheRecord.appMetadata.familyId === __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["E" /* THE_FAMILY_ID */] ? __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["E" /* THE_FAMILY_ID */] : __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
                        }
                        uid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.oid) || (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.sub) || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
                        tid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.tid) || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
                        // for hybrid + native bridge enablement, send back the native account Id
                        if ((serverTokenResponse === null || serverTokenResponse === void 0 ? void 0 : serverTokenResponse.spa_accountid) && !!cacheRecord.account) {
                            cacheRecord.account.nativeAccountId = serverTokenResponse === null || serverTokenResponse === void 0 ? void 0 : serverTokenResponse.spa_accountid;
                        }
                        return [2 /*return*/, {
                                authority: authority.canonicalAuthority,
                                uniqueId: uid,
                                tenantId: tid,
                                scopes: responseScopes,
                                account: cacheRecord.account ? cacheRecord.account.getAccountInfo() : null,
                                idToken: idTokenObj ? idTokenObj.rawToken : __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
                                idTokenClaims: idTokenObj ? idTokenObj.claims : {},
                                accessToken: accessToken,
                                fromCache: fromTokenCache,
                                expiresOn: expiresOn,
                                correlationId: request.correlationId,
                                requestId: requestId || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
                                extExpiresOn: extExpiresOn,
                                familyId: familyId,
                                tokenType: ((_a = cacheRecord.accessToken) === null || _a === void 0 ? void 0 : _a.tokenType) || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
                                state: requestState ? requestState.userRequestState : __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
                                cloudGraphHostName: ((_b = cacheRecord.account) === null || _b === void 0 ? void 0 : _b.cloudGraphHostName) || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
                                msGraphHost: ((_c = cacheRecord.account) === null || _c === void 0 ? void 0 : _c.msGraphHost) || __WEBPACK_IMPORTED_MODULE_15__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
                                code: serverTokenResponse === null || serverTokenResponse === void 0 ? void 0 : serverTokenResponse.spa_code,
                                fromNativeBroker: false,
                            }];
                }
            });
        });
    };
    return ResponseHandler;
}());


//# sourceMappingURL=ResponseHandler.js.map


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StandardInteractionClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseInteractionClient_js__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packageMetadata_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_BrowserProtocolUtils_js__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_BrowserUtils_js__ = __webpack_require__(172);
/*! @azure/msal-browser v2.38.3 2023-10-27 */










/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */
var StandardInteractionClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(StandardInteractionClient, _super);
    function StandardInteractionClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Generates an auth code request tied to the url request.
     * @param request
     */
    StandardInteractionClient.prototype.initializeAuthorizationCodeRequest = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var generatedPkceParams, authCodeRequest;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientInitializeAuthorizationCodeRequest, request.correlationId);
                        this.logger.verbose("initializeAuthorizationRequest called", request.correlationId);
                        return [4 /*yield*/, this.browserCrypto.generatePkceCodes()];
                    case 1:
                        generatedPkceParams = _a.sent();
                        authCodeRequest = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request), { redirectUri: request.redirectUri, code: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING, codeVerifier: generatedPkceParams.verifier });
                        request.codeChallenge = generatedPkceParams.challenge;
                        request.codeChallengeMethod = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].S256_CODE_CHALLENGE_METHOD;
                        return [2 /*return*/, authCodeRequest];
                }
            });
        });
    };
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */
    StandardInteractionClient.prototype.initializeLogoutRequest = function (logoutRequest) {
        this.logger.verbose("initializeLogoutRequest called", logoutRequest === null || logoutRequest === void 0 ? void 0 : logoutRequest.correlationId);
        var validLogoutRequest = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({ correlationId: this.correlationId || this.browserCrypto.createNewGuid() }, logoutRequest);
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */
        if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    var logoutHint = this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("Setting logoutHint to login_hint ID Token Claim value for the account provided");
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                }
                else {
                    this.logger.verbose("logoutHint was not set and account was not passed into logout request, logoutHint will not be set");
                }
            }
            else {
                this.logger.verbose("logoutHint has already been set in logoutRequest");
            }
        }
        else {
            this.logger.verbose("logoutHint will not be set since no logout request was configured");
        }
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */
        if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, __WEBPACK_IMPORTED_MODULE_7__utils_BrowserUtils_js__["a" /* BrowserUtils */].getCurrentUri());
            }
            else if (this.config.auth.postLogoutRedirectUri === null) {
                this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", validLogoutRequest.correlationId);
            }
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to configured uri", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, __WEBPACK_IMPORTED_MODULE_7__utils_BrowserUtils_js__["a" /* BrowserUtils */].getCurrentUri());
            }
            else {
                this.logger.verbose("Setting postLogoutRedirectUri to current page", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].getAbsoluteUrl(__WEBPACK_IMPORTED_MODULE_7__utils_BrowserUtils_js__["a" /* BrowserUtils */].getCurrentUri(), __WEBPACK_IMPORTED_MODULE_7__utils_BrowserUtils_js__["a" /* BrowserUtils */].getCurrentUri());
            }
        }
        else {
            this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", validLogoutRequest.correlationId);
        }
        return validLogoutRequest;
    };
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */
    StandardInteractionClient.prototype.getLogoutHintFromIdTokenClaims = function (account) {
        var idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) {
                return idTokenClaims.login_hint;
            }
            else {
                this.logger.verbose("The ID Token Claims tied to the provided account do not contain a login_hint claim, logoutHint will not be added to logout request");
            }
        }
        else {
            this.logger.verbose("The provided account does not contain ID Token Claims, logoutHint will not be added to logout request");
        }
        return null;
    };
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */
    StandardInteractionClient.prototype.createAuthCodeClient = function (serverTelemetryManager, authorityUrl, requestAzureCloudOptions) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var clientConfig;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientCreateAuthCodeClient, this.correlationId);
                        // Create auth module.
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientGetClientConfiguration, this.correlationId);
                        return [4 /*yield*/, this.getClientConfiguration(serverTelemetryManager, authorityUrl, requestAzureCloudOptions)];
                    case 1:
                        clientConfig = _a.sent();
                        return [2 /*return*/, new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["m" /* AuthorizationCodeClient */](clientConfig, this.performanceClient)];
                }
            });
        });
    };
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param serverTelemetryManager
     * @param requestAuthority
     * @param requestCorrelationId
     */
    StandardInteractionClient.prototype.getClientConfiguration = function (serverTelemetryManager, requestAuthority, requestAzureCloudOptions) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var discoveredAuthority, logger;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientGetClientConfiguration, this.correlationId);
                        this.logger.verbose("getClientConfiguration called", this.correlationId);
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
                        return [4 /*yield*/, this.getDiscoveredAuthority(requestAuthority, requestAzureCloudOptions)];
                    case 1:
                        discoveredAuthority = _a.sent();
                        logger = this.config.system.loggerOptions;
                        return [2 /*return*/, {
                                authOptions: {
                                    clientId: this.config.auth.clientId,
                                    authority: discoveredAuthority,
                                    clientCapabilities: this.config.auth.clientCapabilities
                                },
                                systemOptions: {
                                    tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                                    preventCorsPreflight: true
                                },
                                loggerOptions: {
                                    loggerCallback: logger.loggerCallback,
                                    piiLoggingEnabled: logger.piiLoggingEnabled,
                                    logLevel: logger.logLevel,
                                    correlationId: this.correlationId
                                },
                                cacheOptions: {
                                    claimsBasedCachingEnabled: this.config.cache.claimsBasedCachingEnabled
                                },
                                cryptoInterface: this.browserCrypto,
                                networkInterface: this.networkClient,
                                storageInterface: this.browserStorage,
                                serverTelemetryManager: serverTelemetryManager,
                                libraryInfo: {
                                    sku: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["c" /* BrowserConstants */].MSAL_SKU,
                                    version: __WEBPACK_IMPORTED_MODULE_4__packageMetadata_js__["b" /* version */],
                                    cpu: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
                                    os: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING
                                },
                                telemetry: this.config.telemetry
                            }];
                }
            });
        });
    };
    /**
     * @param hash
     * @param interactionType
     */
    StandardInteractionClient.prototype.validateAndExtractStateFromHash = function (serverParams, interactionType, requestCorrelationId) {
        this.logger.verbose("validateAndExtractStateFromHash called", requestCorrelationId);
        if (!serverParams.state) {
            throw __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createHashDoesNotContainStateError();
        }
        var platformStateObj = __WEBPACK_IMPORTED_MODULE_6__utils_BrowserProtocolUtils_js__["a" /* BrowserProtocolUtils */].extractBrowserRequestState(this.browserCrypto, serverParams.state);
        if (!platformStateObj) {
            throw __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToParseStateError();
        }
        if (platformStateObj.interactionType !== interactionType) {
            throw __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createStateInteractionTypeMismatchError();
        }
        this.logger.verbose("Returning state from hash", requestCorrelationId);
        return serverParams.state;
    };
    /**
     * Used to get a discovered version of the default authority.
     * @param requestAuthority
     * @param requestCorrelationId
     */
    StandardInteractionClient.prototype.getDiscoveredAuthority = function (requestAuthority, requestAzureCloudOptions) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var getAuthorityMeasurement, authorityOptions, userAuthority, builtAuthority;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
                        this.logger.verbose("getDiscoveredAuthority called", this.correlationId);
                        getAuthorityMeasurement = (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.startMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
                        authorityOptions = {
                            protocolMode: this.config.auth.protocolMode,
                            knownAuthorities: this.config.auth.knownAuthorities,
                            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                            authorityMetadata: this.config.auth.authorityMetadata,
                            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
                        };
                        userAuthority = requestAuthority ? requestAuthority : this.config.auth.authority;
                        builtAuthority = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["i" /* Authority */].generateAuthority(userAuthority, requestAzureCloudOptions || this.config.auth.azureCloudOptions);
                        this.logger.verbose("Creating discovered authority with configured authority", this.correlationId);
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].AuthorityFactoryCreateDiscoveredInstance, this.correlationId);
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["j" /* AuthorityFactory */].createDiscoveredInstance(builtAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger, this.performanceClient, this.correlationId)
                                .then(function (result) {
                                getAuthorityMeasurement.endMeasurement({
                                    success: true,
                                });
                                return result;
                            })
                                .catch(function (error) {
                                getAuthorityMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
     * @param request
     * @param interactionType
     */
    StandardInteractionClient.prototype.initializeAuthorizationRequest = function (request, interactionType) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var redirectUri, browserState, state, validatedRequest, _a, account, legacyLoginHint;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientInitializeAuthorizationRequest, this.correlationId);
                        this.logger.verbose("initializeAuthorizationRequest called", this.correlationId);
                        redirectUri = this.getRedirectUri(request.redirectUri);
                        browserState = {
                            interactionType: interactionType
                        };
                        state = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["N" /* ProtocolUtils */].setRequestState(this.browserCrypto, (request && request.state) || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING, browserState);
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].InitializeBaseRequest, this.correlationId);
                        _a = [{}];
                        return [4 /*yield*/, this.initializeBaseRequest(request)];
                    case 1:
                        validatedRequest = __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */].apply(void 0, _a.concat([_b.sent()])), { redirectUri: redirectUri, state: state, nonce: request.nonce || this.browserCrypto.createNewGuid(), responseMode: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["Q" /* ResponseMode */].FRAGMENT }]);
                        account = request.account || this.browserStorage.getActiveAccount();
                        if (account) {
                            this.logger.verbose("Setting validated request account", this.correlationId);
                            this.logger.verbosePii("Setting validated request account: " + account.homeAccountId, this.correlationId);
                            validatedRequest.account = account;
                        }
                        // Check for ADAL/MSAL v1 SSO
                        if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(validatedRequest.loginHint) && !account) {
                            legacyLoginHint = this.browserStorage.getLegacyLoginHint();
                            if (legacyLoginHint) {
                                validatedRequest.loginHint = legacyLoginHint;
                            }
                        }
                        return [2 /*return*/, validatedRequest];
                }
            });
        });
    };
    return StandardInteractionClient;
}(__WEBPACK_IMPORTED_MODULE_2__BaseInteractionClient_js__["a" /* BaseInteractionClient */]));


//# sourceMappingURL=StandardInteractionClient.js.map


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventType; });
/*! @azure/msal-browser v2.38.3 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var EventType;
(function (EventType) {
    EventType["INITIALIZE_START"] = "msal:initializeStart";
    EventType["INITIALIZE_END"] = "msal:initializeEnd";
    EventType["ACCOUNT_ADDED"] = "msal:accountAdded";
    EventType["ACCOUNT_REMOVED"] = "msal:accountRemoved";
    EventType["LOGIN_START"] = "msal:loginStart";
    EventType["LOGIN_SUCCESS"] = "msal:loginSuccess";
    EventType["LOGIN_FAILURE"] = "msal:loginFailure";
    EventType["ACQUIRE_TOKEN_START"] = "msal:acquireTokenStart";
    EventType["ACQUIRE_TOKEN_SUCCESS"] = "msal:acquireTokenSuccess";
    EventType["ACQUIRE_TOKEN_FAILURE"] = "msal:acquireTokenFailure";
    EventType["ACQUIRE_TOKEN_NETWORK_START"] = "msal:acquireTokenFromNetworkStart";
    EventType["SSO_SILENT_START"] = "msal:ssoSilentStart";
    EventType["SSO_SILENT_SUCCESS"] = "msal:ssoSilentSuccess";
    EventType["SSO_SILENT_FAILURE"] = "msal:ssoSilentFailure";
    EventType["ACQUIRE_TOKEN_BY_CODE_START"] = "msal:acquireTokenByCodeStart";
    EventType["ACQUIRE_TOKEN_BY_CODE_SUCCESS"] = "msal:acquireTokenByCodeSuccess";
    EventType["ACQUIRE_TOKEN_BY_CODE_FAILURE"] = "msal:acquireTokenByCodeFailure";
    EventType["HANDLE_REDIRECT_START"] = "msal:handleRedirectStart";
    EventType["HANDLE_REDIRECT_END"] = "msal:handleRedirectEnd";
    EventType["POPUP_OPENED"] = "msal:popupOpened";
    EventType["LOGOUT_START"] = "msal:logoutStart";
    EventType["LOGOUT_SUCCESS"] = "msal:logoutSuccess";
    EventType["LOGOUT_FAILURE"] = "msal:logoutFailure";
    EventType["LOGOUT_END"] = "msal:logoutEnd";
    EventType["RESTORE_FROM_BFCACHE"] = "msal:restoreFromBFCache";
})(EventType || (EventType = {}));


//# sourceMappingURL=EventType.js.map


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(77);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(137);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(157);

var _Actions = __webpack_require__(304);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(80);

var ReactCurrentOwner = __webpack_require__(738);

var warning = __webpack_require__(104);
var canDefineProperty = __webpack_require__(737);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(739);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(105);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(422),
    baseAssignValue = __webpack_require__(423);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(174),
    isObjectLike = __webpack_require__(117);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _permanentStore = __webpack_require__(118);

var _permanentStore2 = _interopRequireDefault(_permanentStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOKEN_KEY = 'gambaApp.authentication_token';
// src/actions/access-token.js

var accessTokenStore = (0, _permanentStore2.default)(TOKEN_KEY);

exports.default = {
  get: function get(callback) {
    accessTokenStore.get(function (token) {
      // sessionStorageにも同じtokenを保存しておき、
      // 現在のlocalStorageの値と比べることで、
      // 別のwindow/tabで別ユーザとしてgamba!にログインしたことを検出する
      var session_token = sessionStorage.getItem(TOKEN_KEY);
      if (session_token && session_token != token) token = undefined;else if (!session_token && token) sessionStorage.setItem(TOKEN_KEY, token);
      callback(token);
    });
  },

  set: function set(token, callback) {
    sessionStorage.setItem(TOKEN_KEY, token);
    accessTokenStore.set(token, callback);
  },

  clear: function clear() {
    accessTokenStore.clear();
    sessionStorage.removeItem(TOKEN_KEY);
  }
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLElement, XMLNode, XMLRaw, XMLText, isEmpty, isFunction, isObject,
    hasProp = {}.hasOwnProperty;

  isObject = __webpack_require__(119);

  isFunction = __webpack_require__(322);

  isEmpty = __webpack_require__(1382);

  XMLElement = null;

  XMLCData = null;

  XMLComment = null;

  XMLDeclaration = null;

  XMLDocType = null;

  XMLRaw = null;

  XMLText = null;

  module.exports = XMLNode = (function() {
    function XMLNode(parent) {
      this.parent = parent;
      this.options = this.parent.options;
      this.stringify = this.parent.stringify;
      if (XMLElement === null) {
        XMLElement = __webpack_require__(789);
        XMLCData = __webpack_require__(798);
        XMLComment = __webpack_require__(799);
        XMLDeclaration = __webpack_require__(787);
        XMLDocType = __webpack_require__(800);
        XMLRaw = __webpack_require__(1457);
        XMLText = __webpack_require__(1458);
      }
    }

    XMLNode.prototype.element = function(name, attributes, text) {
      var childNode, item, j, k, key, lastChild, len, len1, ref, val;
      lastChild = null;
      if (attributes == null) {
        attributes = {};
      }
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref = [attributes, text], text = ref[0], attributes = ref[1];
      }
      if (name != null) {
        name = name.valueOf();
      }
      if (Array.isArray(name)) {
        for (j = 0, len = name.length; j < len; j++) {
          item = name[j];
          lastChild = this.element(item);
        }
      } else if (isFunction(name)) {
        lastChild = this.element(name.apply());
      } else if (isObject(name)) {
        for (key in name) {
          if (!hasProp.call(name, key)) continue;
          val = name[key];
          if (isFunction(val)) {
            val = val.apply();
          }
          if ((isObject(val)) && (isEmpty(val))) {
            val = null;
          }
          if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
            lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
          } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && key.indexOf(this.stringify.convertPIKey) === 0) {
            lastChild = this.instruction(key.substr(this.stringify.convertPIKey.length), val);
          } else if (!this.options.separateArrayItems && Array.isArray(val)) {
            for (k = 0, len1 = val.length; k < len1; k++) {
              item = val[k];
              childNode = {};
              childNode[key] = item;
              lastChild = this.element(childNode);
            }
          } else if (isObject(val)) {
            lastChild = this.element(key);
            lastChild.element(val);
          } else {
            lastChild = this.element(key, val);
          }
        }
      } else {
        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
          lastChild = this.text(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
          lastChild = this.cdata(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
          lastChild = this.comment(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
          lastChild = this.raw(text);
        } else {
          lastChild = this.node(name, attributes, text);
        }
      }
      if (lastChild == null) {
        throw new Error("Could not create any elements with: " + name);
      }
      return lastChild;
    };

    XMLNode.prototype.insertBefore = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level");
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.insertAfter = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level");
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.remove = function() {
      var i, ref;
      if (this.isRoot) {
        throw new Error("Cannot remove the root element");
      }
      i = this.parent.children.indexOf(this);
      [].splice.apply(this.parent.children, [i, i - i + 1].concat(ref = [])), ref;
      return this.parent;
    };

    XMLNode.prototype.node = function(name, attributes, text) {
      var child, ref;
      if (name != null) {
        name = name.valueOf();
      }
      if (attributes == null) {
        attributes = {};
      }
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref = [attributes, text], text = ref[0], attributes = ref[1];
      }
      child = new XMLElement(this, name, attributes);
      if (text != null) {
        child.text(text);
      }
      this.children.push(child);
      return child;
    };

    XMLNode.prototype.text = function(value) {
      var child;
      child = new XMLText(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.cdata = function(value) {
      var child;
      child = new XMLCData(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.comment = function(value) {
      var child;
      child = new XMLComment(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.raw = function(value) {
      var child;
      child = new XMLRaw(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.declaration = function(version, encoding, standalone) {
      var doc, xmldec;
      doc = this.document();
      xmldec = new XMLDeclaration(doc, version, encoding, standalone);
      doc.xmldec = xmldec;
      return doc.root();
    };

    XMLNode.prototype.doctype = function(pubID, sysID) {
      var doc, doctype;
      doc = this.document();
      doctype = new XMLDocType(doc, pubID, sysID);
      doc.doctype = doctype;
      return doctype;
    };

    XMLNode.prototype.up = function() {
      if (this.isRoot) {
        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
      }
      return this.parent;
    };

    XMLNode.prototype.root = function() {
      var child;
      if (this.isRoot) {
        return this;
      }
      child = this.parent;
      while (!child.isRoot) {
        child = child.parent;
      }
      return child;
    };

    XMLNode.prototype.document = function() {
      return this.root().documentObject;
    };

    XMLNode.prototype.end = function(options) {
      return this.document().toString(options);
    };

    XMLNode.prototype.prev = function() {
      var i;
      if (this.isRoot) {
        throw new Error("Root node has no siblings");
      }
      i = this.parent.children.indexOf(this);
      if (i < 1) {
        throw new Error("Already at the first node");
      }
      return this.parent.children[i - 1];
    };

    XMLNode.prototype.next = function() {
      var i;
      if (this.isRoot) {
        throw new Error("Root node has no siblings");
      }
      i = this.parent.children.indexOf(this);
      if (i === -1 || i === this.parent.children.length - 1) {
        throw new Error("Already at the last node");
      }
      return this.parent.children[i + 1];
    };

    XMLNode.prototype.importXMLBuilder = function(xmlbuilder) {
      var clonedRoot;
      clonedRoot = xmlbuilder.root().clone();
      clonedRoot.parent = this;
      clonedRoot.isRoot = false;
      this.children.push(clonedRoot);
      return this;
    };

    XMLNode.prototype.ele = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.nod = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.txt = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.doc = function() {
      return this.document();
    };

    XMLNode.prototype.dec = function(version, encoding, standalone) {
      return this.declaration(version, encoding, standalone);
    };

    XMLNode.prototype.dtd = function(pubID, sysID) {
      return this.doctype(pubID, sysID);
    };

    XMLNode.prototype.e = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.n = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.t = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.d = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.c = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.r = function(value) {
      return this.raw(value);
    };

    XMLNode.prototype.u = function() {
      return this.up();
    };

    return XMLNode;

  })();

}).call(this);


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var _isPlaceholder = __webpack_require__(471);


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.inputFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames4 = __webpack_require__(14);

var _classnames5 = _interopRequireDefault(_classnames4);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _FontIcon = __webpack_require__(81);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(FontIcon) {
  var Input = function (_React$Component) {
    _inherits(Input, _React$Component);

    function Input() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Input);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            multiline = _this$props.multiline,
            maxLength = _this$props.maxLength;

        var valueFromEvent = event.target.value;

        // Trim value to maxLength if that exists (only on multiline inputs).
        // Note that this is still required even tho we have the onKeyPress filter
        // because the user could paste smt in the textarea.
        var haveToTrim = multiline && maxLength && event.target.value.length > maxLength;
        var value = haveToTrim ? valueFromEvent.substr(0, maxLength) : valueFromEvent;

        // propagate to to store and therefore to the input
        if (onChange) onChange(value, event);
      }, _this.handleAutoresize = function () {
        var element = _this.inputNode;
        var rows = _this.props.rows;

        if (typeof rows === 'number' && !isNaN(rows)) {
          element.style.height = null;
        } else {
          // compute the height difference between inner height and outer height
          var style = getComputedStyle(element, null);
          var heightOffset = style.boxSizing === 'content-box' ? -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)) : parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);

          // resize the input to its content size
          element.style.height = 'auto';
          element.style.height = element.scrollHeight + heightOffset + 'px';
        }
      }, _this.handleKeyPress = function (event) {
        // prevent insertion of more characters if we're a multiline input
        // and maxLength exists
        var _this$props2 = _this.props,
            multiline = _this$props2.multiline,
            maxLength = _this$props2.maxLength,
            onKeyPress = _this$props2.onKeyPress;

        if (multiline && maxLength) {
          // check if smt is selected, in which case the newly added charcter would
          // replace the selected characters, so the length of value doesn't actually
          // increase.
          var isReplacing = event.target.selectionEnd - event.target.selectionStart;
          var value = event.target.value;

          if (!isReplacing && value.length === maxLength) {
            event.preventDefault();
            event.stopPropagation();
            return undefined;
          }
        }

        if (onKeyPress) onKeyPress(event);
        return undefined;
      }, _this.valuePresent = function (value) {
        return value !== null && value !== undefined && value !== '' && !(typeof value === 'number' && isNaN(value));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Input, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.multiline) {
          window.addEventListener('resize', this.handleAutoresize);
          this.handleAutoresize();
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!this.props.multiline && nextProps.multiline) {
          window.addEventListener('resize', this.handleAutoresize);
        } else if (this.props.multiline && !nextProps.multiline) {
          window.removeEventListener('resize', this.handleAutoresize);
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        // resize the textarea, if nessesary
        if (this.props.multiline) this.handleAutoresize();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.props.multiline) window.removeEventListener('resize', this.handleAutoresize);
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.inputNode.blur();
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.inputNode.focus();
      }
    }, {
      key: 'render',
      value: function render() {
        var _classnames2,
            _this2 = this;

        var _props = this.props,
            children = _props.children,
            defaultValue = _props.defaultValue,
            disabled = _props.disabled,
            error = _props.error,
            floating = _props.floating,
            hint = _props.hint,
            icon = _props.icon,
            name = _props.name,
            labelText = _props.label,
            maxLength = _props.maxLength,
            multiline = _props.multiline,
            required = _props.required,
            theme = _props.theme,
            type = _props.type,
            value = _props.value,
            onKeyPress = _props.onKeyPress,
            _props$rows = _props.rows,
            rows = _props$rows === undefined ? 1 : _props$rows,
            others = _objectWithoutProperties(_props, ['children', 'defaultValue', 'disabled', 'error', 'floating', 'hint', 'icon', 'name', 'label', 'maxLength', 'multiline', 'required', 'theme', 'type', 'value', 'onKeyPress', 'rows']);

        var length = maxLength && value ? value.length : 0;
        var labelClassName = (0, _classnames5.default)(theme.label, _defineProperty({}, theme.fixed, !floating));

        var className = (0, _classnames5.default)(theme.input, (_classnames2 = {}, _defineProperty(_classnames2, theme.disabled, disabled), _defineProperty(_classnames2, theme.errored, error), _defineProperty(_classnames2, theme.hidden, type === 'hidden'), _defineProperty(_classnames2, theme.withIcon, icon), _classnames2), this.props.className);

        var valuePresent = this.valuePresent(value) || this.valuePresent(defaultValue);

        var inputElementProps = _extends({}, others, {
          className: (0, _classnames5.default)(theme.inputElement, _defineProperty({}, theme.filled, valuePresent)),
          onChange: this.handleChange,
          ref: function ref(node) {
            _this2.inputNode = node;
          },
          role: 'input',
          name: name,
          defaultValue: defaultValue,
          disabled: disabled,
          required: required,
          type: type,
          value: value
        });
        if (!multiline) {
          inputElementProps.maxLength = maxLength;
          inputElementProps.onKeyPress = onKeyPress;
        } else {
          inputElementProps.rows = rows;
          inputElementProps.onKeyPress = this.handleKeyPress;
        }

        return _react2.default.createElement(
          'div',
          { 'data-react-toolbox': 'input', className: className },
          _react2.default.createElement(multiline ? 'textarea' : 'input', inputElementProps),
          icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null,
          _react2.default.createElement('span', { className: theme.bar }),
          labelText ? _react2.default.createElement(
            'label',
            { className: labelClassName },
            labelText,
            required ? _react2.default.createElement(
              'span',
              { className: theme.required },
              ' * '
            ) : null
          ) : null,
          hint ? _react2.default.createElement(
            'span',
            { hidden: labelText, className: theme.hint },
            hint
          ) : null,
          error ? _react2.default.createElement(
            'span',
            { className: theme.error },
            error
          ) : null,
          maxLength ? _react2.default.createElement(
            'span',
            { className: theme.counter },
            length,
            '/',
            maxLength
          ) : null,
          children
        );
      }
    }]);

    return Input;
  }(_react2.default.Component);

  Input.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    defaultValue: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    floating: _propTypes2.default.bool,
    hint: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    maxLength: _propTypes2.default.number,
    multiline: _propTypes2.default.bool,
    name: _propTypes2.default.string,
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onKeyPress: _propTypes2.default.func,
    required: _propTypes2.default.bool,
    rows: _propTypes2.default.number,
    theme: _propTypes2.default.shape({
      bar: _propTypes2.default.string,
      counter: _propTypes2.default.string,
      disabled: _propTypes2.default.string,
      error: _propTypes2.default.string,
      errored: _propTypes2.default.string,
      hidden: _propTypes2.default.string,
      hint: _propTypes2.default.string,
      icon: _propTypes2.default.string,
      input: _propTypes2.default.string,
      inputElement: _propTypes2.default.string,
      required: _propTypes2.default.string,
      withIcon: _propTypes2.default.string
    }),
    type: _propTypes2.default.string,
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string])
  };
  Input.defaultProps = {
    className: '',
    hint: '',
    disabled: false,
    floating: true,
    multiline: false,
    required: false,
    type: 'text'
  };


  return Input;
};

var Input = factory(_FontIcon2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.INPUT)(Input);
exports.inputFactory = factory;
exports.Input = Input;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1841);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./action-dialog.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./action-dialog.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var keys = __webpack_require__(1864);
var hasBinary = __webpack_require__(898);
var sliceBuffer = __webpack_require__(1866);
var after = __webpack_require__(1867);
var utf8 = __webpack_require__(1868);

var base64encoder;
if (global && global.ArrayBuffer) {
  base64encoder = __webpack_require__(1869);
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = __webpack_require__(1870);

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if ('function' == typeof supportsBinary) {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if ('function' == typeof utf8encode) {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (Blob && data instanceof global.Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    packet.data = fr.result;
    exports.encodePacket(packet, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (Blob && packet.data instanceof global.Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += global.btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data == 'string') {
    if (data.charAt(0) == 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data);
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary == 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data != 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data == '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = ''
    , n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (':' != chr) {
      length += chr;
    } else {
      if ('' == length || (length != (n = Number(length)))) {
        // parser error - ignoring payload
        return callback(err, 0, 1);
      }

      msg = data.substr(i + 1, n);

      if (length != msg.length) {
        // parser error - ignoring payload
        return callback(err, 0, 1);
      }

      if (msg.length) {
        packet = exports.decodePacket(msg, binaryType, true);

        if (err.type == packet.type && err.data == packet.data) {
          // parser error in individual packet - ignoring payload
          return callback(err, 0, 1);
        }

        var ret = callback(packet, i + n, l);
        if (false === ret) return;
      }

      // advance cursor
      i += n;
      length = '';
    }
  }

  if (length != '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  var numberTooLong = false;
  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] == 255) break;

      if (msgLength.length > 310) {
        numberTooLong = true;
        break;
      }

      msgLength += tailArray[i];
    }

    if(numberTooLong) return callback(err, 0, 1);

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(433);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = undefined;

var _reactCssThemr = __webpack_require__(10);

var _Switch = __webpack_require__(2210);

var _identifiers = __webpack_require__(16);

var _Thumb = __webpack_require__(940);

var _Thumb2 = _interopRequireDefault(_Thumb);

var _ripple = __webpack_require__(162);

var _ripple2 = _interopRequireDefault(_ripple);

var _theme = __webpack_require__(2211);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applyTheme = function applyTheme(Component) {
  return (0, _reactCssThemr.themr)(_identifiers.SWITCH, _theme2.default)(Component);
};
var ripple = (0, _ripple2.default)({ centered: true, spread: 2.6 });
var ThemedThumb = applyTheme((0, _Thumb2.default)(ripple));
var ThemedSwitch = applyTheme((0, _Switch.switchFactory)(ThemedThumb));

exports.default = ThemedSwitch;
exports.Switch = ThemedSwitch;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(61).f;
var has = __webpack_require__(99);
var TAG = __webpack_require__(52)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(109);
var TAG = __webpack_require__(52)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortableContainer", function() { return sortableContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortableContainer", function() { return sortableContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortableElement", function() { return sortableElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortableElement", function() { return sortableElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortableHandle", function() { return sortableHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortableHandle", function() { return sortableHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMove", function() { return arrayMove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(2242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(2244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(2246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_invariant__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(2253);
















var Manager = function () {
  function Manager() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Manager);

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(this, "refs", {});
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(Manager, [{
    key: "add",
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: "remove",
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var _this = this;

      return this.refs[this.active.collection].find(function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: "getOrderedRefs",
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
      return this.refs[collection].sort(sortByIndex);
    }
  }]);

  return Manager;
}();

function sortByIndex(_ref2, _ref3) {
  var index1 = _ref2.node.sortableInfo.index;
  var index2 = _ref3.node.sortableInfo.index;
  return index1 - index2;
}

function arrayMove(array, from, to) {
  if (false) {
    if (typeof console !== 'undefined') {
      console.warn("Deprecation warning: arrayMove will no longer be exported by 'react-sortable-hoc' in the next major release. Please install the `array-move` package locally instead. https://www.npmjs.com/package/array-move");
    }
  }

  array = array.slice();
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  return array;
}
function omit(obj, keysToOmit) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}
var events = {
  end: ['touchend', 'touchcancel', 'mouseup'],
  move: ['touchmove', 'mousemove'],
  start: ['touchstart', 'mousedown']
};
var vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return '';
  }

  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';

    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();
function setInlineStyles(node, styles) {
  Object.keys(styles).forEach(function (key) {
    node.style[key] = styles[key];
  });
}
function setTranslate3d(node, translate) {
  node.style["".concat(vendorPrefix, "Transform")] = translate == null ? '' : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
}
function setTransitionDuration(node, duration) {
  node.style["".concat(vendorPrefix, "TransitionDuration")] = duration == null ? '' : "".concat(duration, "ms");
}
function closest(el, fn) {
  while (el) {
    if (fn(el)) {
      return el;
    }

    el = el.parentNode;
  }

  return null;
}
function limit(min, max, value) {
  return Math.max(min, Math.min(value, max));
}

function getPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }

  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);
  return {
    bottom: getPixelValue(style.marginBottom),
    left: getPixelValue(style.marginLeft),
    right: getPixelValue(style.marginRight),
    top: getPixelValue(style.marginTop)
  };
}
function provideDisplayName(prefix, Component$$1) {
  var componentName = Component$$1.displayName || Component$$1.name;
  return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
}
function getScrollAdjustedBoundingClientRect(node, scrollDelta) {
  var boundingClientRect = node.getBoundingClientRect();
  return {
    top: boundingClientRect.top + scrollDelta.top,
    left: boundingClientRect.left + scrollDelta.left
  };
}
function getPosition(event) {
  if (event.touches && event.touches.length) {
    return {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  } else if (event.changedTouches && event.changedTouches.length) {
    return {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
  } else {
    return {
      x: event.pageX,
      y: event.pageY
    };
  }
}
function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function getEdgeOffset(node, parent) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    left: 0,
    top: 0
  };

  if (!node) {
    return undefined;
  }

  var nodeOffset = {
    left: offset.left + node.offsetLeft,
    top: offset.top + node.offsetTop
  };

  if (node.parentNode === parent) {
    return nodeOffset;
  }

  return getEdgeOffset(node.parentNode, parent, nodeOffset);
}
function getTargetIndex(newIndex, prevIndex, oldIndex) {
  if (newIndex < oldIndex && newIndex > prevIndex) {
    return newIndex - 1;
  } else if (newIndex > oldIndex && newIndex < prevIndex) {
    return newIndex + 1;
  } else {
    return newIndex;
  }
}
function getLockPixelOffset(_ref) {
  var lockOffset = _ref.lockOffset,
      width = _ref.width,
      height = _ref.height;
  var offsetX = lockOffset;
  var offsetY = lockOffset;
  var unit = 'px';

  if (typeof lockOffset === 'string') {
    var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
    __WEBPACK_IMPORTED_MODULE_13_invariant___default()(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);
    offsetX = parseFloat(lockOffset);
    offsetY = parseFloat(lockOffset);
    unit = match[1];
  }

  __WEBPACK_IMPORTED_MODULE_13_invariant___default()(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

  if (unit === '%') {
    offsetX = offsetX * width / 100;
    offsetY = offsetY * height / 100;
  }

  return {
    x: offsetX,
    y: offsetY
  };
}
function getLockPixelOffsets(_ref2) {
  var height = _ref2.height,
      width = _ref2.width,
      lockOffset = _ref2.lockOffset;
  var offsets = Array.isArray(lockOffset) ? lockOffset : [lockOffset, lockOffset];
  __WEBPACK_IMPORTED_MODULE_13_invariant___default()(offsets.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

  var _offsets = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(offsets, 2),
      minLockOffset = _offsets[0],
      maxLockOffset = _offsets[1];

  return [getLockPixelOffset({
    height: height,
    lockOffset: minLockOffset,
    width: width
  }), getLockPixelOffset({
    height: height,
    lockOffset: maxLockOffset,
    width: width
  })];
}

function isScrollable(el) {
  var computedStyle = window.getComputedStyle(el);
  var overflowRegex = /(auto|scroll)/;
  var properties = ['overflow', 'overflowX', 'overflowY'];
  return properties.find(function (property) {
    return overflowRegex.test(computedStyle[property]);
  });
}

function getScrollingParent(el) {
  if (!(el instanceof HTMLElement)) {
    return null;
  } else if (isScrollable(el)) {
    return el;
  } else {
    return getScrollingParent(el.parentNode);
  }
}
function getContainerGridGap(element) {
  var style = window.getComputedStyle(element);

  if (style.display === 'grid') {
    return {
      x: getPixelValue(style.gridColumnGap),
      y: getPixelValue(style.gridRowGap)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var KEYCODE = {
  TAB: 9,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
var NodeType = {
  Anchor: 'A',
  Button: 'BUTTON',
  Canvas: 'CANVAS',
  Input: 'INPUT',
  Option: 'OPTION',
  Textarea: 'TEXTAREA',
  Select: 'SELECT'
};
function cloneNode(node) {
  var selector = 'input, textarea, select, canvas, [contenteditable]';
  var fields = node.querySelectorAll(selector);
  var clonedNode = node.cloneNode(true);

  var clonedFields = Object(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(clonedNode.querySelectorAll(selector));

  clonedFields.forEach(function (field, i) {
    if (field.type !== 'file') {
      field.value = fields[i].value;
    }

    if (field.type === 'radio' && field.name) {
      field.name = "__sortableClone__".concat(field.name);
    }

    if (field.tagName === NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
      var destCtx = field.getContext('2d');
      destCtx.drawImage(fields[i], 0, 0);
    }
  });
  return clonedNode;
}

function sortableHandle(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(WithSortableHandle, _React$Component);

    function WithSortableHandle() {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, WithSortableHandle);

      return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(WithSortableHandle).apply(this, arguments));
    }

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(WithSortableHandle, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var node = Object(__WEBPACK_IMPORTED_MODULE_12_react_dom__["findDOMNode"])(this);
        node.sortableHandle = true;
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_13_invariant___default()(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: "render",
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;
        return Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          ref: ref
        }, this.props));
      }
    }]);

    return WithSortableHandle;
  }(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "displayName", provideDisplayName('sortableHandle', WrappedComponent)), _temp;
}
function isSortableHandle(node) {
  return node.sortableHandle != null;
}

var AutoScroller = function () {
  function AutoScroller(container, onScrollCallback) {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, AutoScroller);

    this.container = container;
    this.onScrollCallback = onScrollCallback;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(AutoScroller, [{
    key: "clear",
    value: function clear() {
      if (this.interval == null) {
        return;
      }

      clearInterval(this.interval);
      this.interval = null;
    }
  }, {
    key: "update",
    value: function update(_ref) {
      var _this = this;

      var translate = _ref.translate,
          minTranslate = _ref.minTranslate,
          maxTranslate = _ref.maxTranslate,
          width = _ref.width,
          height = _ref.height;
      var direction = {
        x: 0,
        y: 0
      };
      var speed = {
        x: 1,
        y: 1
      };
      var acceleration = {
        x: 10,
        y: 10
      };
      var _this$container = this.container,
          scrollTop = _this$container.scrollTop,
          scrollLeft = _this$container.scrollLeft,
          scrollHeight = _this$container.scrollHeight,
          scrollWidth = _this$container.scrollWidth,
          clientHeight = _this$container.clientHeight,
          clientWidth = _this$container.clientWidth;
      var isTop = scrollTop === 0;
      var isBottom = scrollHeight - scrollTop - clientHeight === 0;
      var isLeft = scrollLeft === 0;
      var isRight = scrollWidth - scrollLeft - clientWidth === 0;

      if (translate.y >= maxTranslate.y - height / 2 && !isBottom) {
        direction.y = 1;
        speed.y = acceleration.y * Math.abs((maxTranslate.y - height / 2 - translate.y) / height);
      } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
        direction.x = 1;
        speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
      } else if (translate.y <= minTranslate.y + height / 2 && !isTop) {
        direction.y = -1;
        speed.y = acceleration.y * Math.abs((translate.y - height / 2 - minTranslate.y) / height);
      } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
        direction.x = -1;
        speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
      }

      if (this.interval) {
        this.clear();
        this.isAutoScrolling = false;
      }

      if (direction.x !== 0 || direction.y !== 0) {
        this.interval = setInterval(function () {
          _this.isAutoScrolling = true;
          var offset = {
            left: speed.x * direction.x,
            top: speed.y * direction.y
          };
          _this.container.scrollTop += offset.top;
          _this.container.scrollLeft += offset.left;

          _this.onScrollCallback(offset);
        }, 5);
      }
    }
  }]);

  return AutoScroller;
}();

function defaultGetHelperDimensions(_ref) {
  var node = _ref.node;
  return {
    height: node.offsetHeight,
    width: node.offsetWidth
  };
}

function defaultShouldCancelStart(event) {
  var interactiveElements = [NodeType.Input, NodeType.Textarea, NodeType.Select, NodeType.Option, NodeType.Button];

  if (interactiveElements.indexOf(event.target.tagName) !== -1) {
    return true;
  }

  if (closest(event.target, function (el) {
    return el.contentEditable === 'true';
  })) {
    return true;
  }

  return false;
}

var propTypes = {
  axis: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOf(['x', 'y', 'xy']),
  contentWindow: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.any,
  disableAutoscroll: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,
  distance: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number,
  getContainer: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  getHelperDimensions: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  helperClass: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,
  helperContainer: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func, typeof HTMLElement === 'undefined' ? __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.any : __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.instanceOf(HTMLElement)]),
  hideSortableGhost: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,
  keyboardSortingTransitionDuration: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number,
  lockAxis: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,
  lockOffset: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string]))]),
  lockToContainerEdges: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,
  onSortEnd: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  onSortMove: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  onSortOver: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  onSortStart: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  pressDelay: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number,
  pressThreshold: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number,
  keyCodes: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape({
    lift: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number),
    drop: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number),
    cancel: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number),
    up: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number),
    down: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number)
  }),
  shouldCancelStart: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  transitionDuration: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number,
  updateBeforeSortStart: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,
  useDragHandle: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,
  useWindowAsScrollContainer: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool
};
var defaultKeyCodes = {
  lift: [KEYCODE.SPACE],
  drop: [KEYCODE.SPACE],
  cancel: [KEYCODE.ESC],
  up: [KEYCODE.UP, KEYCODE.LEFT],
  down: [KEYCODE.DOWN, KEYCODE.RIGHT]
};
var defaultProps = {
  axis: 'y',
  disableAutoscroll: false,
  distance: 0,
  getHelperDimensions: defaultGetHelperDimensions,
  hideSortableGhost: true,
  lockOffset: '50%',
  lockToContainerEdges: false,
  pressDelay: 0,
  pressThreshold: 5,
  keyCodes: defaultKeyCodes,
  shouldCancelStart: defaultShouldCancelStart,
  transitionDuration: 300,
  useWindowAsScrollContainer: false
};
var omittedProps = Object.keys(propTypes);
function validateProps(props) {
  __WEBPACK_IMPORTED_MODULE_13_invariant___default()(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
}

function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, value);
}
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(WithSortableContainer, _React$Component);

    function WithSortableContainer(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, WithSortableContainer);

      _this = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(WithSortableContainer).call(this, props));

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {});

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleStart", function (event) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;

        if (event.button === 2 || shouldCancelStart(event)) {
          return;
        }

        _this.touched = true;
        _this.position = getPosition(event);
        var node = closest(event.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection,
              disabled = _node$sortableInfo.disabled;

          if (disabled) {
            return;
          }

          if (useDragHandle && !closest(event.target, isSortableHandle)) {
            return;
          }

          _this.manager.active = {
            collection: collection,
            index: index
          };

          if (!isTouchEvent(event) && event.target.tagName === NodeType.Anchor) {
            event.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(event);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(event);
              }, _this.props.pressDelay);
            }
          }
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "nodeIsChild", function (node) {
        return node.sortableInfo.manager === _this.manager;
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleMove", function (event) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;

        if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
          var position = getPosition(event);
          var delta = {
            x: _this.position.x - position.x,
            y: _this.position.y - position.y
          };
          var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
          _this.delta = delta;

          if (!distance && (!pressThreshold || combinedDelta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && combinedDelta >= distance && _this.manager.isActive()) {
            _this.handlePress(event);
          }
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleEnd", function () {
        _this.touched = false;

        _this.cancel();
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "cancel", function () {
        var distance = _this.props.distance;
        var sorting = _this.state.sorting;

        if (!sorting) {
          if (!distance) {
            clearTimeout(_this.pressTimer);
          }

          _this.manager.active = null;
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handlePress", function (event) {
        try {
          var active = _this.manager.getActive();

          var _temp6 = function () {
            if (active) {
              var _temp7 = function _temp7() {
                var index = _node.sortableInfo.index;
                var margin = getElementMargin(_node);
                var gridGap = getContainerGridGap(_this.container);

                var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();

                var dimensions = _getHelperDimensions({
                  index: index,
                  node: _node,
                  collection: _collection
                });

                _this.node = _node;
                _this.margin = margin;
                _this.gridGap = gridGap;
                _this.width = dimensions.width;
                _this.height = dimensions.height;
                _this.marginOffset = {
                  x: _this.margin.left + _this.margin.right + _this.gridGap.x,
                  y: Math.max(_this.margin.top, _this.margin.bottom, _this.gridGap.y)
                };
                _this.boundingClientRect = _node.getBoundingClientRect();
                _this.containerBoundingRect = containerBoundingRect;
                _this.index = index;
                _this.newIndex = index;
                _this.axis = {
                  x: _axis.indexOf('x') >= 0,
                  y: _axis.indexOf('y') >= 0
                };
                _this.offsetEdge = getEdgeOffset(_node, _this.container);

                if (_isKeySorting) {
                  _this.initialOffset = getPosition(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, event, {
                    pageX: _this.boundingClientRect.left,
                    pageY: _this.boundingClientRect.top
                  }));
                } else {
                  _this.initialOffset = getPosition(event);
                }

                _this.initialScroll = {
                  left: _this.scrollContainer.scrollLeft,
                  top: _this.scrollContainer.scrollTop
                };
                _this.initialWindowScroll = {
                  left: window.pageXOffset,
                  top: window.pageYOffset
                };
                _this.helper = _this.helperContainer.appendChild(cloneNode(_node));
                setInlineStyles(_this.helper, {
                  boxSizing: 'border-box',
                  height: "".concat(_this.height, "px"),
                  left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                  pointerEvents: 'none',
                  position: 'fixed',
                  top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                  width: "".concat(_this.width, "px")
                });

                if (_isKeySorting) {
                  _this.helper.focus();
                }

                if (_hideSortableGhost) {
                  _this.sortableGhost = _node;
                  setInlineStyles(_node, {
                    opacity: 0,
                    visibility: 'hidden'
                  });
                }

                _this.minTranslate = {};
                _this.maxTranslate = {};

                if (_isKeySorting) {
                  var _ref = _useWindowAsScrollContainer ? {
                    top: 0,
                    left: 0,
                    width: _this.contentWindow.innerWidth,
                    height: _this.contentWindow.innerHeight
                  } : _this.containerBoundingRect,
                      containerTop = _ref.top,
                      containerLeft = _ref.left,
                      containerWidth = _ref.width,
                      containerHeight = _ref.height;

                  var containerBottom = containerTop + containerHeight;
                  var containerRight = containerLeft + containerWidth;

                  if (_this.axis.x) {
                    _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                    _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                  }

                  if (_this.axis.y) {
                    _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                    _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                  }
                } else {
                  if (_this.axis.x) {
                    _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                    _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                  }

                  if (_this.axis.y) {
                    _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                    _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                  }
                }

                if (_helperClass) {
                  _helperClass.split(' ').forEach(function (className) {
                    return _this.helper.classList.add(className);
                  });
                }

                _this.listenerNode = event.touches ? _node : _this.contentWindow;

                if (_isKeySorting) {
                  _this.listenerNode.addEventListener('wheel', _this.handleKeyEnd, true);

                  _this.listenerNode.addEventListener('mousedown', _this.handleKeyEnd, true);

                  _this.listenerNode.addEventListener('keydown', _this.handleKeyDown);
                } else {
                  events.move.forEach(function (eventName) {
                    return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                  });
                  events.end.forEach(function (eventName) {
                    return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                  });
                }

                _this.setState({
                  sorting: true,
                  sortingIndex: index
                });

                if (_onSortStart) {
                  _onSortStart({
                    node: _node,
                    index: index,
                    collection: _collection,
                    isKeySorting: _isKeySorting,
                    nodes: _this.manager.getOrderedRefs(),
                    helper: _this.helper
                  }, event);
                }

                if (_isKeySorting) {
                  _this.keyMove(0);
                }
              };

              var _this$props3 = _this.props,
                  _axis = _this$props3.axis,
                  _getHelperDimensions = _this$props3.getHelperDimensions,
                  _helperClass = _this$props3.helperClass,
                  _hideSortableGhost = _this$props3.hideSortableGhost,
                  updateBeforeSortStart = _this$props3.updateBeforeSortStart,
                  _onSortStart = _this$props3.onSortStart,
                  _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
              var _node = active.node,
                  _collection = active.collection;
              var _isKeySorting = _this.manager.isKeySorting;

              var _temp8 = function () {
                if (typeof updateBeforeSortStart === 'function') {
                  _this._awaitingUpdateBeforeSortStart = true;

                  var _temp9 = _finallyRethrows(function () {
                    var index = _node.sortableInfo.index;
                    return Promise.resolve(updateBeforeSortStart({
                      collection: _collection,
                      index: index,
                      node: _node,
                      isKeySorting: _isKeySorting
                    }, event)).then(function () {});
                  }, function (_wasThrown, _result) {
                    _this._awaitingUpdateBeforeSortStart = false;
                    if (_wasThrown) throw _result;
                    return _result;
                  });

                  if (_temp9 && _temp9.then) return _temp9.then(function () {});
                }
              }();

              return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
            }
          }();

          return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleSortMove", function (event) {
        var onSortMove = _this.props.onSortMove;

        if (typeof event.preventDefault === 'function') {
          event.preventDefault();
        }

        _this.updateHelperPosition(event);

        _this.animateNodes();

        _this.autoscroll();

        if (onSortMove) {
          onSortMove(event);
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleSortEnd", function (event) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var _this$manager = _this.manager,
            collection = _this$manager.active.collection,
            isKeySorting = _this$manager.isKeySorting;

        var nodes = _this.manager.getOrderedRefs();

        if (_this.listenerNode) {
          if (isKeySorting) {
            _this.listenerNode.removeEventListener('wheel', _this.handleKeyEnd, true);

            _this.listenerNode.removeEventListener('mousedown', _this.handleKeyEnd, true);

            _this.listenerNode.removeEventListener('keydown', _this.handleKeyDown);
          } else {
            events.move.forEach(function (eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
            });
            events.end.forEach(function (eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
            });
          }
        }

        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          setInlineStyles(_this.sortableGhost, {
            opacity: '',
            visibility: ''
          });
        }

        for (var i = 0, len = nodes.length; i < len; i++) {
          var _node2 = nodes[i];
          var el = _node2.node;
          _node2.edgeOffset = null;
          _node2.boundingClientRect = null;
          setTranslate3d(el, null);
          setTransitionDuration(el, null);
          _node2.translate = null;
        }

        _this.autoScroller.clear();

        _this.manager.active = null;
        _this.manager.isKeySorting = false;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            collection: collection,
            newIndex: _this.newIndex,
            oldIndex: _this.index,
            isKeySorting: isKeySorting,
            nodes: nodes
          }, event);
        }

        _this.touched = false;
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "autoscroll", function () {
        var disableAutoscroll = _this.props.disableAutoscroll;
        var isKeySorting = _this.manager.isKeySorting;

        if (disableAutoscroll) {
          _this.autoScroller.clear();

          return;
        }

        if (isKeySorting) {
          var translate = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, _this.translate);

          var scrollX = 0;
          var scrollY = 0;

          if (_this.axis.x) {
            translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
            scrollX = _this.translate.x - translate.x;
          }

          if (_this.axis.y) {
            translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
            scrollY = _this.translate.y - translate.y;
          }

          _this.translate = translate;
          setTranslate3d(_this.helper, _this.translate);
          _this.scrollContainer.scrollLeft += scrollX;
          _this.scrollContainer.scrollTop += scrollY;
          return;
        }

        _this.autoScroller.update({
          height: _this.height,
          maxTranslate: _this.maxTranslate,
          minTranslate: _this.minTranslate,
          translate: _this.translate,
          width: _this.width
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onAutoScroll", function (offset) {
        _this.translate.x += offset.left;
        _this.translate.y += offset.top;

        _this.animateNodes();
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleKeyDown", function (event) {
        var keyCode = event.keyCode;
        var _this$props5 = _this.props,
            shouldCancelStart = _this$props5.shouldCancelStart,
            _this$props5$keyCodes = _this$props5.keyCodes,
            customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;

        var keyCodes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, defaultKeyCodes, customKeyCodes);

        if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) {
          return;
        }

        event.stopPropagation();
        event.preventDefault();

        if (keyCodes.lift.includes(keyCode) && !_this.manager.active) {
          _this.keyLift(event);
        } else if (keyCodes.drop.includes(keyCode) && _this.manager.active) {
          _this.keyDrop(event);
        } else if (keyCodes.cancel.includes(keyCode)) {
          _this.newIndex = _this.manager.active.index;

          _this.keyDrop(event);
        } else if (keyCodes.up.includes(keyCode)) {
          _this.keyMove(-1);
        } else if (keyCodes.down.includes(keyCode)) {
          _this.keyMove(1);
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "keyLift", function (event) {
        var target = event.target;
        var node = closest(target, function (el) {
          return el.sortableInfo != null;
        });
        var _node$sortableInfo2 = node.sortableInfo,
            index = _node$sortableInfo2.index,
            collection = _node$sortableInfo2.collection;
        _this.initialFocusedNode = target;
        _this.manager.isKeySorting = true;
        _this.manager.active = {
          index: index,
          collection: collection
        };

        _this.handlePress(event);
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "keyMove", function (shift) {
        var nodes = _this.manager.getOrderedRefs();

        var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
        var newIndex = _this.newIndex + shift;
        var prevIndex = _this.newIndex;

        if (newIndex < 0 || newIndex > lastIndex) {
          return;
        }

        _this.prevIndex = prevIndex;
        _this.newIndex = newIndex;
        var targetIndex = getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
        var target = nodes.find(function (_ref2) {
          var node = _ref2.node;
          return node.sortableInfo.index === targetIndex;
        });
        var targetNode = target.node;
        var scrollDelta = _this.containerScrollDelta;
        var targetBoundingClientRect = target.boundingClientRect || getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
        var targetTranslate = target.translate || {
          x: 0,
          y: 0
        };
        var targetPosition = {
          top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
          left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
        };
        var shouldAdjustForSize = prevIndex < newIndex;
        var sizeAdjustment = {
          x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
          y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
        };

        _this.handleSortMove({
          pageX: targetPosition.left + sizeAdjustment.x,
          pageY: targetPosition.top + sizeAdjustment.y,
          ignoreTransition: shift === 0
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "keyDrop", function (event) {
        _this.handleSortEnd(event);

        if (_this.initialFocusedNode) {
          _this.initialFocusedNode.focus();
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleKeyEnd", function (event) {
        if (_this.manager.active) {
          _this.keyDrop(event);
        }
      });

      Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "isValidSortingTarget", function (event) {
        var useDragHandle = _this.props.useDragHandle;
        var target = event.target;
        var node = closest(target, function (el) {
          return el.sortableInfo != null;
        });
        return node && node.sortableInfo && !node.sortableInfo.disabled && (useDragHandle ? isSortableHandle(target) : target.sortableInfo);
      });

      validateProps(props);
      _this.manager = new Manager();
      _this.events = {
        end: _this.handleEnd,
        move: _this.handleMove,
        start: _this.handleStart
      };
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(WithSortableContainer, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          manager: this.manager
        };
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
        var container = this.getContainer();
        Promise.resolve(container).then(function (containerNode) {
          _this2.container = containerNode;
          _this2.document = _this2.container.ownerDocument || document;
          var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
          _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
          _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : getScrollingParent(_this2.container) || _this2.container;
          _this2.autoScroller = new AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
          Object.keys(_this2.events).forEach(function (key) {
            return events[key].forEach(function (eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          });

          _this2.container.addEventListener('keydown', _this2.handleKeyDown);
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this3 = this;

        if (this.helper && this.helper.parentNode) {
          this.helper.parentNode.removeChild(this.helper);
        }

        if (!this.container) {
          return;
        }

        Object.keys(this.events).forEach(function (key) {
          return events[key].forEach(function (eventName) {
            return _this3.container.removeEventListener(eventName, _this3.events[key]);
          });
        });
        this.container.removeEventListener('keydown', this.handleKeyDown);
      }
    }, {
      key: "updateHelperPosition",
      value: function updateHelperPosition(event) {
        var _this$props6 = this.props,
            lockAxis = _this$props6.lockAxis,
            lockOffset = _this$props6.lockOffset,
            lockToContainerEdges = _this$props6.lockToContainerEdges,
            transitionDuration = _this$props6.transitionDuration,
            _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration,
            keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
        var isKeySorting = this.manager.isKeySorting;
        var ignoreTransition = event.ignoreTransition;
        var offset = getPosition(event);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;
        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = getLockPixelOffsets({
            height: this.height,
            lockOffset: lockOffset,
            width: this.width
          }),
              _getLockPixelOffsets2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };
          translate.x = limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) {
          setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
        }

        setTranslate3d(this.helper, translate);
      }
    }, {
      key: "animateNodes",
      value: function animateNodes() {
        var _this$props7 = this.props,
            transitionDuration = _this$props7.transitionDuration,
            hideSortableGhost = _this$props7.hideSortableGhost,
            onSortOver = _this$props7.onSortOver;
        var containerScrollDelta = this.containerScrollDelta,
            windowScrollDelta = this.windowScrollDelta;
        var nodes = this.manager.getOrderedRefs();
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
          top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
        };
        var isKeySorting = this.manager.isKeySorting;
        var prevIndex = this.newIndex;
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var _node3 = nodes[i].node;
          var index = _node3.sortableInfo.index;
          var width = _node3.offsetWidth;
          var height = _node3.offsetHeight;
          var offset = {
            height: this.height > height ? height / 2 : this.height / 2,
            width: this.width > width ? width / 2 : this.width / 2
          };
          var mustShiftBackward = isKeySorting && index > this.index && index <= prevIndex;
          var mustShiftForward = isKeySorting && index < this.index && index >= prevIndex;
          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          if (!edgeOffset) {
            edgeOffset = getEdgeOffset(_node3, this.container);
            nodes[i].edgeOffset = edgeOffset;

            if (isKeySorting) {
              nodes[i].boundingClientRect = getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
            }
          }

          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = getEdgeOffset(nextNode.node, this.container);

            if (isKeySorting) {
              nextNode.boundingClientRect = getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
            }
          }

          if (index === this.index) {
            if (hideSortableGhost) {
              this.sortableGhost = _node3;
              setInlineStyles(_node3, {
                opacity: 0,
                visibility: 'hidden'
              });
            }

            continue;
          }

          if (transitionDuration) {
            setTransitionDuration(_node3, transitionDuration);
          }

          if (this.axis.x) {
            if (this.axis.y) {
              if (mustShiftForward || index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                translate.x = this.width + this.marginOffset.x;

                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  if (nextNode) {
                    translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                    translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                  }
                }

                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (mustShiftBackward || index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                translate.x = -(this.width + this.marginOffset.x);

                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  if (prevNode) {
                    translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                    translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                  }
                }

                this.newIndex = index;
              }
            } else {
              if (mustShiftBackward || index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (mustShiftForward || index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;

                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (mustShiftBackward || index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (mustShiftForward || index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;

              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }

          setTranslate3d(_node3, translate);
          nodes[i].translate = translate;
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }

        if (isKeySorting) {
          this.newIndex = prevIndex;
        }

        var oldIndex = isKeySorting ? this.prevIndex : prevIndex;

        if (onSortOver && this.newIndex !== oldIndex) {
          onSortOver({
            collection: this.manager.active.collection,
            index: this.index,
            newIndex: this.newIndex,
            oldIndex: oldIndex,
            isKeySorting: isKeySorting,
            nodes: nodes,
            helper: this.helper
          });
        }
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_13_invariant___default()(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: "getContainer",
      value: function getContainer() {
        var getContainer = this.props.getContainer;

        if (typeof getContainer !== 'function') {
          return Object(__WEBPACK_IMPORTED_MODULE_12_react_dom__["findDOMNode"])(this);
        }

        return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
      }
    }, {
      key: "render",
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;
        return Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          ref: ref
        }, omit(this.props, omittedProps)));
      }
    }, {
      key: "helperContainer",
      get: function get() {
        var helperContainer = this.props.helperContainer;

        if (typeof helperContainer === 'function') {
          return helperContainer();
        }

        return this.props.helperContainer || this.document.body;
      }
    }, {
      key: "containerScrollDelta",
      get: function get() {
        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;

        if (useWindowAsScrollContainer) {
          return {
            left: 0,
            top: 0
          };
        }

        return {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
      }
    }, {
      key: "windowScrollDelta",
      get: function get() {
        return {
          left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
          top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
        };
      }
    }]);

    return WithSortableContainer;
  }(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "displayName", provideDisplayName('sortableList', WrappedComponent)), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "defaultProps", defaultProps), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "propTypes", propTypes), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "childContextTypes", {
    manager: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired
  }), _temp;
}

var propTypes$1 = {
  index: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number.isRequired,
  collection: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool
};
var omittedProps$1 = Object.keys(propTypes$1);
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(WithSortableElement, _React$Component);

    function WithSortableElement() {
      Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, WithSortableElement);

      return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(WithSortableElement).apply(this, arguments));
    }

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(WithSortableElement, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.register();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.node) {
          if (prevProps.index !== this.props.index) {
            this.node.sortableInfo.index = this.props.index;
          }

          if (prevProps.disabled !== this.props.disabled) {
            this.node.sortableInfo.disabled = this.props.disabled;
          }
        }

        if (prevProps.collection !== this.props.collection) {
          this.unregister(prevProps.collection);
          this.register();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unregister();
      }
    }, {
      key: "register",
      value: function register() {
        var _this$props = this.props,
            collection = _this$props.collection,
            disabled = _this$props.disabled,
            index = _this$props.index;
        var node = Object(__WEBPACK_IMPORTED_MODULE_12_react_dom__["findDOMNode"])(this);
        node.sortableInfo = {
          collection: collection,
          disabled: disabled,
          index: index,
          manager: this.context.manager
        };
        this.node = node;
        this.ref = {
          node: node
        };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: "unregister",
      value: function unregister() {
        var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.collection;
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_13_invariant___default()(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.refs.wrappedInstance;
      }
    }, {
      key: "render",
      value: function render() {
        var ref = config.withRef ? 'wrappedInstance' : null;
        return Object(__WEBPACK_IMPORTED_MODULE_10_react__["createElement"])(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          ref: ref
        }, omit(this.props, omittedProps$1)));
      }
    }]);

    return WithSortableElement;
  }(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "displayName", provideDisplayName('sortableElement', WrappedComponent)), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "contextTypes", {
    manager: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired
  }), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "propTypes", propTypes$1), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "defaultProps", {
    collection: 0
  }), _temp;
}




/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(80);

var ReactCurrentOwner = __webpack_require__(978);

var warning = __webpack_require__(104);
var canDefineProperty = __webpack_require__(977);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(979);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scope__ = __webpack_require__(983);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__session__ = __webpack_require__(989);
/* unused harmony reexport Session */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hub__ = __webpack_require__(2307);
/* unused harmony reexport getActiveDomain */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__hub__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__hub__["c"]; });
/* unused harmony reexport getMainCarrier */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__hub__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__hub__["d"]; });
/* unused harmony reexport setHubOnCarrier */



//# sourceMappingURL=index.js.map

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = isError;
/* harmony export (immutable) */ __webpack_exports__["e"] = isErrorEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDOMError;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDOMException;
/* harmony export (immutable) */ __webpack_exports__["k"] = isString;
/* harmony export (immutable) */ __webpack_exports__["i"] = isPrimitive;
/* harmony export (immutable) */ __webpack_exports__["h"] = isPlainObject;
/* harmony export (immutable) */ __webpack_exports__["f"] = isEvent;
/* harmony export (immutable) */ __webpack_exports__["c"] = isElement;
/* harmony export (immutable) */ __webpack_exports__["j"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["m"] = isThenable;
/* harmony export (immutable) */ __webpack_exports__["l"] = isSyntheticEvent;
/* harmony export (immutable) */ __webpack_exports__["g"] = isInstanceOf;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(1000);
var defined = __webpack_require__(539);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-timestamp.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = __webpack_require__(10);

var _reactI18next = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _button = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipButton = (0, _tooltip2.default)(_button.Button);

var DiaryTimestamp = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryTimestamp, _React$Component);

  function DiaryTimestamp() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DiaryTimestamp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiaryTimestamp.__proto__ || Object.getPrototypeOf(DiaryTimestamp)).call.apply(_ref, [this].concat(args))), _this), _this.state = { update: undefined }, _this.setTimer = function (timestamp) {
      var interval;
      var elapsed = (0, _moment2.default)().diff((0, _moment2.default)(timestamp), 'seconds');
      _this.timer && clearInterval(_this.timer);
      if (elapsed < 60) // 1分未満
        interval = 30; // 30秒ごと
      else if (elapsed < 10 * 60) // 10分未満
          interval = 2 * 60; // 2分ごと
        else if (elapsed < 60 * 60) // 1時間未満
            interval = 10 * 60; // 10分ごと
          else if (elapsed < 24 * 60 * 60) // 24時間未満
              return;else // それ以降
              return;
      _this.timer = setInterval(_this.update, interval * 1000);
    }, _this.update = function () {
      _this.setState({ update: new Date() });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DiaryTimestamp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setTimer(this.props.timestamp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.timer && clearInterval(this.timer);
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setTimer(nextProps.timestamp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          timestamp = _props.timestamp,
          updated = _props.updated,
          theme = _props.theme;


      var edited = updated && !(0, _moment2.default)(timestamp).isSame(updated, 'minutes');
      var is_pastDay = (0, _moment2.default)().diff((0, _moment2.default)(timestamp), 'second') > 24 * 60 * 60;
      var is_pastYear = (0, _moment2.default)().diff((0, _moment2.default)(timestamp), 'years') >= 1;

      return _react2.default.createElement(TooltipButton, { neutral: false, ripple: false,
        theme: theme, className: 'touchable',
        tooltip: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            (0, _moment2.default)(timestamp).format('LLLL HH:mm')
          ),
          edited && _react2.default.createElement(
            'div',
            null,
            t('label:編集時刻', { updated: (0, _moment2.default)(updated).format('LLLL HH:mm') })
          )
        ),
        tooltipPosition: 'bottom',
        label: t('format:timestamp', { timestamp: timestamp }) + (edited && t('label:編集済み') || '') });
    }
  }]);

  return DiaryTimestamp;
}(_react2.default.Component)) || _class);
exports.default = (0, _reactI18next.translate)()(DiaryTimestamp);

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-content.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _diaryContent = __webpack_require__(2526);

var _diaryContent2 = _interopRequireDefault(_diaryContent);

var _reactCssThemr = __webpack_require__(10);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _reactI18next = __webpack_require__(2);

var _pureRenderDecorator = __webpack_require__(2527);

var _pureRenderDecorator2 = _interopRequireDefault(_pureRenderDecorator);

var _toggleButton = __webpack_require__(388);

var _toggleButton2 = _interopRequireDefault(_toggleButton);

var _card = __webpack_require__(28);

var _emojiHelpers = __webpack_require__(146);

var _urlRegexp = __webpack_require__(182);

var _googleDoc = __webpack_require__(269);

var _googleDoc2 = _interopRequireDefault(_googleDoc);

var _gambaUrl = __webpack_require__(350);

var _gambaUrl2 = _interopRequireDefault(_gambaUrl);

var _googleIcons = __webpack_require__(565);

var _googleIcons2 = _interopRequireDefault(_googleIcons);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UrlRegex = (0, _urlRegexp.urlRegex)();
var MAX_LINES = { isPhone: 10, isPC: 30 };

var DiaryContent = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryContent, _React$Component);

  function DiaryContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DiaryContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiaryContent.__proto__ || Object.getPrototypeOf(DiaryContent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.setContentHeight = function (props) {
      if (props.content && props.content.match(/<span class=['"]stamp [-a-zA-Z0-9]+["']><\/span>/)) return;

      var content = _reactDom2.default.findDOMNode(_this.contentRef);

      // Check if there is searchHits, view all content
      if (props.searchHits) {
        _this.setState({ showAll: 'show' });
        content.style.maxHeight = 'none';
        return;
      }

      var maxHeight = 10 * (props.profile ? 10 : props.comment ? 3 : MAX_LINES[props.isPhone ? 'isPhone' : 'isPC']);
      if (content != null && content.clientHeight >= maxHeight) {
        _this.setState({ showAll: 'hide' });
        content.style.maxHeight = maxHeight + 'px';
      } else {
        _this.setState({ showAll: undefined });
      }
    }, _this.toggleShow = function () {
      return _this.setState({ showAll: _this.state.showAll == 'hide' ? 'show' : 'hide' });
    }, _this.renderGoogleDocUrl = function (url) {
      var urlLink = _this.props.urlLinks && _this.props.urlLinks[url];
      var image_url = urlLink && (urlLink.image_url || _googleIcons2.default[urlLink.mime_type || 'default'] || _googleIcons2.default['default']);
      var title = urlLink && urlLink.title || _this.props.t('label:Googleドキュメント');
      title = title && title.length > 20 ? title.slice(0, 20) + "..." : title;
      return '<div><a class=' + (image_url ? "googleDoc" : "googleDocIcon") + ' style="background: #E8E8E8; border-radius: 5px; padding: 3px 7px; text-decoration: none; font-size: 90%; display: inline-block; vertical-align: middle; height: 24px; margin-top: 1px;" href="' + url + '">' + (image_url ? '<img src=' + image_url + ' style="height: 18px; vertical-align: middle;">' : '') + ('&nbsp;' + title + '</a></div>');
    }, _this.renderLink = function (url) {
      var urlLink = _this.props.urlLinks && _this.props.urlLinks[url];
      var image_url = urlLink && urlLink.image_url;
      var title = urlLink && urlLink.title || (0, _gambaUrl2.default)(url) && _this.props.t('label:gambaで開く');
      title = title && title.length > 20 ? title.slice(0, 20) + "..." : title;
      var disp_url = (url.length > 40 ? url.slice(0, 40) + "..." : url).replace(/^https?:\/\/(www\.)?/, '');
      var target = (0, _gambaUrl2.default)(url) ? '' : 'target="_blank"';
      if (!title) {
        title = disp_url;
        disp_url = undefined;
      }
      if ((0, _gambaUrl2.default)(url)) disp_url = undefined;
      return '<div style="display: ' + (!image_url && "inline-block;") + '"><a ' + target + ' class=' + (image_url ? "image" : "materialIcon") + ' rel="noopener noreferrer" style="background: #E8E8E8; border-radius: 5px; margin-top: 10px; margin-bottom: 10px; display: ' + (image_url ? "inline-block" : "flex") + '; vertical-align: middle; text-decoration: none; padding: 0px 5px 0px 0px; height: ' + (disp_url ? '32px' : '24px') + ';" href="' + url + '">' + '<div style="display: flex; align-items: center;">' + (image_url ? '<img src="' + image_url + '" style="height: ' + (disp_url ? '32px' : '24px') + '; border-radius: 5px; margin-right: 3px 5px;"/>' : '') + '<div style="display: flex; flex-direction: column; margin-left: 2px; text-indent: initial; line-height: 95%;">' + ('<div style="font-size: 90%">' + title + '</div>') + (disp_url ? '<div style="font-size: 80%; color: #666;">' + disp_url + '</div>' : '') + '</div>' + '</div>' + '</a></div>';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DiaryContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.setContentHeight(this.props);
      var googleDocElements = _reactDom2.default.findDOMNode(this.component).querySelectorAll('.googleDoc, .googleDocIcon');
      _lodash2.default.each(googleDocElements, function (element) {
        element.onclick = function (event) {
          event.preventDefault();
          _this2.props.showGoogleDoc(element.href);
        };
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (this.props.content != prevProps.content) {
        this.setContentHeight(this.props);
      }
      var googleDocElements = _reactDom2.default.findDOMNode(this.component).querySelectorAll('.googleDoc, .googleDocIcon');
      _lodash2.default.each(googleDocElements, function (element) {
        !element.onclick && (element.onclick = function (event) {
          event.preventDefault();
          _this3.props.showGoogleDoc(element.href);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          t = _props.t,
          content = _props.content,
          isPhone = _props.isPhone,
          theme = _props.theme,
          comment = _props.comment,
          searchHits = _props.searchHits,
          showGoogleDoc = _props.showGoogleDoc,
          urlLinks = _props.urlLinks,
          modalContent = _props.modalContent,
          profile = _props.profile;


      var className = (0, _classnames2.default)(theme.content, { all: this.state.showAll == 'show', comment: this.props.comment, profile: this.props.profile });
      var modalClassName = (0, _classnames2.default)(theme.content, { modal: this.state.showAll == 'show' });

      var htmlContent = (0, _emojiHelpers.convertEmojiHTML)(content.replace(UrlRegex, function (match) {
        return (0, _googleDoc2.default)(match) && _this4.renderGoogleDocUrl(match) || _this4.renderLink(match);
      }));

      searchHits && _lodash2.default.each(searchHits, function (hit) {
        // Escaping any special regex characters in the hit string to prevent regex errors
        var escapedHit = hit.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // Regex pattern to avoid matching `hit` inside HTML tags while performing a global case-insensitive search
        var regexPattern = new RegExp('(?!<[^>]*?)(' + escapedHit + ')(?![^<]*?>)', 'gi');

        htmlContent = htmlContent.replace(regexPattern, '<em>$1</em>');
      });

      var Component = this.props.component || _card.CardText;

      return _react2.default.createElement(
        Component,
        { theme: _diary2.default, ref: function ref(component) {
            return _this4.component = component;
          } },
        _react2.default.createElement(
          'div',
          { ref: function ref(content) {
              return _this4.contentRef = content;
            }, className: modalContent ? modalClassName : className },
          _react2.default.createElement('div', { className: _diary2.default.itemText, dangerouslySetInnerHTML: { __html: htmlContent } })
        ),
        !searchHits && this.state.showAll && _react2.default.createElement(_toggleButton2.default, {
          className: 'fluid',
          flag: this.state.showAll == 'hide',
          onClick: this.toggleShow })
      );
    }
  }]);

  return DiaryContent;
}(_react2.default.Component)) || _class);
exports.default = (0, _diaryContent2.default)(DiaryContent);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScopeSet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */
var ScopeSet = /** @class */ (function () {
    function ScopeSet(inputScopes) {
        var _this = this;
        // Filter empty string and null/undefined array items
        var scopeArr = inputScopes ? __WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].trimArrayEntries(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["e" /* __spreadArrays */])(inputScopes)) : [];
        var filteredInput = scopeArr ? __WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].removeEmptyStringsFromArray(scopeArr) : [];
        // Validate and filter scopes (validate function throws if validation fails)
        this.validateInputScopes(filteredInput);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach(function (scope) { return _this.scopes.add(scope); });
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */
    ScopeSet.fromString = function (inputScopeString) {
        var scopeString = inputScopeString || __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        var inputScopes = scopeString.split(" ");
        return new ScopeSet(inputScopes);
    };
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */
    ScopeSet.createSearchScopes = function (inputScopeString) {
        var scopeSet = new ScopeSet(inputScopeString);
        if (!scopeSet.containsOnlyOIDCScopes()) {
            scopeSet.removeOIDCScopes();
        }
        else {
            scopeSet.removeScope(__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].OFFLINE_ACCESS_SCOPE);
        }
        return scopeSet;
    };
    /**
     * Used to validate the scopes input parameter requested  by the developer.
     * @param {Array<string>} inputScopes - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
     * @param {boolean} scopesRequired - Boolean indicating whether the scopes array is required or not
     */
    ScopeSet.prototype.validateInputScopes = function (inputScopes) {
        // Check if scopes are required but not given or is an empty array
        if (!inputScopes || inputScopes.length < 1) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createEmptyScopesArrayError();
        }
    };
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */
    ScopeSet.prototype.containsScope = function (scope) {
        var lowerCaseScopes = this.printScopesLowerCase().split(" ");
        var lowerCaseScopesSet = new ScopeSet(lowerCaseScopes);
        // compare lowercase scopes
        return !__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(scope) ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    };
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */
    ScopeSet.prototype.containsScopeSet = function (scopeSet) {
        var _this = this;
        if (!scopeSet || scopeSet.scopes.size <= 0) {
            return false;
        }
        return (this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every(function (scope) { return _this.containsScope(scope); }));
    };
    /**
     * Check if set of scopes contains only the defaults
     */
    ScopeSet.prototype.containsOnlyOIDCScopes = function () {
        var _this = this;
        var defaultScopeCount = 0;
        __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["t" /* OIDC_SCOPES */].forEach(function (defaultScope) {
            if (_this.containsScope(defaultScope)) {
                defaultScopeCount += 1;
            }
        });
        return this.scopes.size === defaultScopeCount;
    };
    /**
     * Appends single scope if passed
     * @param newScope
     */
    ScopeSet.prototype.appendScope = function (newScope) {
        if (!__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(newScope)) {
            this.scopes.add(newScope.trim());
        }
    };
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */
    ScopeSet.prototype.appendScopes = function (newScopes) {
        var _this = this;
        try {
            newScopes.forEach(function (newScope) { return _this.appendScope(newScope); });
        }
        catch (e) {
            throw __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__["a" /* ClientAuthError */].createAppendScopeSetError(e);
        }
    };
    /**
     * Removes element from set of scopes.
     * @param scope
     */
    ScopeSet.prototype.removeScope = function (scope) {
        if (__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(scope)) {
            throw __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__["a" /* ClientAuthError */].createRemoveEmptyScopeFromSetError(scope);
        }
        this.scopes.delete(scope.trim());
    };
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */
    ScopeSet.prototype.removeOIDCScopes = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["t" /* OIDC_SCOPES */].forEach(function (defaultScope) {
            _this.scopes.delete(defaultScope);
        });
    };
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */
    ScopeSet.prototype.unionScopeSets = function (otherScopes) {
        if (!otherScopes) {
            throw __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__["a" /* ClientAuthError */].createEmptyInputScopeSetError();
        }
        var unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach(function (scope) { return unionScopes.add(scope.toLowerCase()); });
        this.scopes.forEach(function (scope) { return unionScopes.add(scope.toLowerCase()); });
        return unionScopes;
    };
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */
    ScopeSet.prototype.intersectingScopeSets = function (otherScopes) {
        if (!otherScopes) {
            throw __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__["a" /* ClientAuthError */].createEmptyInputScopeSetError();
        }
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) {
            otherScopes.removeOIDCScopes();
        }
        var unionScopes = this.unionScopeSets(otherScopes);
        var sizeOtherScopes = otherScopes.getScopeCount();
        var sizeThisScopes = this.getScopeCount();
        var sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < (sizeThisScopes + sizeOtherScopes);
    };
    /**
     * Returns size of set of scopes.
     */
    ScopeSet.prototype.getScopeCount = function () {
        return this.scopes.size;
    };
    /**
     * Returns the scopes as an array of string values
     */
    ScopeSet.prototype.asArray = function () {
        var array = [];
        this.scopes.forEach(function (val) { return array.push(val); });
        return array;
    };
    /**
     * Prints scopes into a space-delimited string
     */
    ScopeSet.prototype.printScopes = function () {
        if (this.scopes) {
            var scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
    };
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */
    ScopeSet.prototype.printScopesLowerCase = function () {
        return this.printScopes().toLowerCase();
    };
    return ScopeSet;
}());


//# sourceMappingURL=ScopeSet.js.map


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildClientInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildClientInfoFromHomeAccountId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */
function buildClientInfo(rawClientInfo, crypto) {
    if (__WEBPACK_IMPORTED_MODULE_1__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(rawClientInfo)) {
        throw __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__["a" /* ClientAuthError */].createClientInfoEmptyError();
    }
    try {
        var decodedClientInfo = crypto.base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    }
    catch (e) {
        throw __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__["a" /* ClientAuthError */].createClientInfoDecodingError(e.message);
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */
function buildClientInfoFromHomeAccountId(homeAccountId) {
    if (__WEBPACK_IMPORTED_MODULE_1__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(homeAccountId)) {
        throw __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__["a" /* ClientAuthError */].createClientInfoDecodingError("Home account ID was empty.");
    }
    var clientInfoParts = homeAccountId.split(__WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["D" /* Separators */].CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["m" /* Constants */].EMPTY_STRING : clientInfoParts[1]
    };
}


//# sourceMappingURL=ClientInfo.js.map


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_StringUtils_js__ = __webpack_require__(65);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * JWT Token representation class. Parses token string and generates claims object.
 */
var AuthToken = /** @class */ (function () {
    function AuthToken(rawToken, crypto) {
        if (__WEBPACK_IMPORTED_MODULE_1__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(rawToken)) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__["a" /* ClientAuthError */].createTokenNullOrEmptyError(rawToken);
        }
        this.rawToken = rawToken;
        this.claims = AuthToken.extractTokenClaims(rawToken, crypto);
    }
    /**
     * Extract token by decoding the rawToken
     *
     * @param encodedToken
     */
    AuthToken.extractTokenClaims = function (encodedToken, crypto) {
        var decodedToken = __WEBPACK_IMPORTED_MODULE_1__utils_StringUtils_js__["a" /* StringUtils */].decodeAuthToken(encodedToken);
        // token will be decoded to get the username
        try {
            var base64TokenPayload = decodedToken.JWSPayload;
            // base64Decode() should throw an error if there is an issue
            var base64Decoded = crypto.base64Decode(base64TokenPayload);
            return JSON.parse(base64Decoded);
        }
        catch (err) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__["a" /* ClientAuthError */].createTokenParsingError(err);
        }
    };
    /**
     * Determine if the token's max_age has transpired
     */
    AuthToken.checkMaxAge = function (authTime, maxAge) {
        /*
         * per https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
         * To force an immediate re-authentication: If an app requires that a user re-authenticate prior to access,
         * provide a value of 0 for the max_age parameter and the AS will force a fresh login.
         */
        var fiveMinuteSkew = 300000; // five minutes in milliseconds
        if ((maxAge === 0) || ((Date.now() - fiveMinuteSkew) > (authTime + maxAge))) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientAuthError_js__["a" /* ClientAuthError */].createMaxAgeTranspiredError();
        }
    };
    return AuthToken;
}());


//# sourceMappingURL=AuthToken.js.map


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NativeMessageHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_NativeAuthError_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_BrowserAuthError_js__ = __webpack_require__(49);
/*! @azure/msal-browser v2.38.3 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var NativeMessageHandler = /** @class */ (function () {
    function NativeMessageHandler(logger, handshakeTimeoutMs, performanceClient, extensionId) {
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.responseId = 0;
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].NativeMessageHandlerHandshake);
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param body
     */
    NativeMessageHandler.prototype.sendMessage = function (body) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var req;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                this.logger.trace("NativeMessageHandler - sendMessage called.");
                req = {
                    channel: __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["n" /* NativeConstants */].CHANNEL_ID,
                    extensionId: this.extensionId,
                    responseId: this.responseId++,
                    body: body
                };
                this.logger.trace("NativeMessageHandler - Sending request to browser extension");
                this.logger.tracePii("NativeMessageHandler - Sending request to browser extension: " + JSON.stringify(req));
                this.messageChannel.port1.postMessage(req);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.resolvers.set(req.responseId, { resolve: resolve, reject: reject });
                    })];
            });
        });
    };
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     */
    NativeMessageHandler.createProvider = function (logger, handshakeTimeoutMs, performanceClient) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var preferredProvider, backupProvider;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.trace("NativeMessageHandler - createProvider called.");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 5]);
                        preferredProvider = new NativeMessageHandler(logger, handshakeTimeoutMs, performanceClient, __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["n" /* NativeConstants */].PREFERRED_EXTENSION_ID);
                        return [4 /*yield*/, preferredProvider.sendHandshakeRequest()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, preferredProvider];
                    case 3:
                        _a.sent();
                        backupProvider = new NativeMessageHandler(logger, handshakeTimeoutMs, performanceClient);
                        return [4 /*yield*/, backupProvider.sendHandshakeRequest()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, backupProvider];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Send handshake request helper.
     */
    NativeMessageHandler.prototype.sendHandshakeRequest = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var req;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                this.logger.trace("NativeMessageHandler - sendHandshakeRequest called.");
                // Register this event listener before sending handshake
                window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
                req = {
                    channel: __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["n" /* NativeConstants */].CHANNEL_ID,
                    extensionId: this.extensionId,
                    responseId: this.responseId++,
                    body: {
                        method: __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["o" /* NativeExtensionMethod */].HandshakeRequest
                    }
                };
                this.handshakeEvent.addStaticFields({
                    extensionId: this.extensionId,
                    extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
                });
                this.messageChannel.port1.onmessage = function (event) {
                    _this.onChannelMessage(event);
                };
                window.postMessage(req, window.origin, [this.messageChannel.port2]);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.handshakeResolvers.set(req.responseId, { resolve: resolve, reject: reject });
                        _this.timeoutId = window.setTimeout(function () {
                            /*
                             * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                             * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                             */
                            window.removeEventListener("message", _this.windowListener, false);
                            _this.messageChannel.port1.close();
                            _this.messageChannel.port2.close();
                            _this.handshakeEvent.endMeasurement({ extensionHandshakeTimedOut: true, success: false });
                            reject(__WEBPACK_IMPORTED_MODULE_4__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNativeHandshakeTimeoutError());
                            _this.handshakeResolvers.delete(req.responseId);
                        }, _this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
                    })];
            });
        });
    };
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */
    NativeMessageHandler.prototype.onWindowMessage = function (event) {
        this.logger.trace("NativeMessageHandler - onWindowMessage called");
        // We only accept messages from ourselves
        if (event.source !== window) {
            return;
        }
        var request = event.data;
        if (!request.channel || request.channel !== __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["n" /* NativeConstants */].CHANNEL_ID) {
            return;
        }
        if (request.extensionId && request.extensionId !== this.extensionId) {
            return;
        }
        if (request.body.method === __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["o" /* NativeExtensionMethod */].HandshakeRequest) {
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? "Extension with id: " + request.extensionId + " not installed" : "No extension installed");
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            var handshakeResolver = this.handshakeResolvers.get(request.responseId);
            if (handshakeResolver) {
                this.handshakeEvent.endMeasurement({ success: false, extensionInstalled: false });
                handshakeResolver.reject(__WEBPACK_IMPORTED_MODULE_4__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNativeExtensionNotInstalledError());
            }
        }
    };
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */
    NativeMessageHandler.prototype.onChannelMessage = function (event) {
        this.logger.trace("NativeMessageHandler - onChannelMessage called.");
        var request = event.data;
        var resolver = this.resolvers.get(request.responseId);
        var handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            var method = request.body.method;
            if (method === __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["o" /* NativeExtensionMethod */].Response) {
                if (!resolver) {
                    return;
                }
                var response = request.body.response;
                this.logger.trace("NativeMessageHandler - Received response from browser extension");
                this.logger.tracePii("NativeMessageHandler - Received response from browser extension: " + JSON.stringify(response));
                if (response.status !== "Success") {
                    resolver.reject(__WEBPACK_IMPORTED_MODULE_3__error_NativeAuthError_js__["a" /* NativeAuthError */].createError(response.code, response.description, response.ext));
                }
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) {
                        resolver.reject(__WEBPACK_IMPORTED_MODULE_3__error_NativeAuthError_js__["a" /* NativeAuthError */].createError(response.result["code"], response.result["description"], response.result["ext"]));
                    }
                    else {
                        resolver.resolve(response.result);
                    }
                }
                else {
                    throw __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["d" /* AuthError */].createUnexpectedError("Event does not contain result.");
                }
                this.resolvers.delete(request.responseId);
            }
            else if (method === __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["o" /* NativeExtensionMethod */].HandshakeResponse) {
                if (!handshakeResolver) {
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose("NativeMessageHandler - Received HandshakeResponse from extension: " + this.extensionId);
                this.handshakeEvent.endMeasurement({ extensionInstalled: true, success: true });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
            // Do nothing if method is not Response or HandshakeResponse
        }
        catch (err) {
            this.logger.error("Error parsing response from WAM Extension");
            this.logger.errorPii("Error parsing response from WAM Extension: " + err.toString());
            this.logger.errorPii("Unable to parse " + event);
            if (resolver) {
                resolver.reject(err);
            }
            else if (handshakeResolver) {
                handshakeResolver.reject(err);
            }
        }
    };
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */
    NativeMessageHandler.prototype.getExtensionId = function () {
        return this.extensionId;
    };
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */
    NativeMessageHandler.prototype.getExtensionVersion = function () {
        return this.extensionVersion;
    };
    /**
     * Returns boolean indicating whether or not the request should attempt to use native broker
     * @param logger
     * @param config
     * @param nativeExtensionProvider
     * @param authenticationScheme
     */
    NativeMessageHandler.isNativeAvailable = function (config, logger, nativeExtensionProvider, authenticationScheme) {
        logger.trace("isNativeAvailable called");
        if (!config.system.allowNativeBroker) {
            logger.trace("isNativeAvailable: allowNativeBroker is not enabled, returning false");
            // Developer disabled WAM
            return false;
        }
        if (!nativeExtensionProvider) {
            logger.trace("isNativeAvailable: WAM extension provider is not initialized, returning false");
            // Extension is not available
            return false;
        }
        if (authenticationScheme) {
            switch (authenticationScheme) {
                case __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["h" /* AuthenticationScheme */].BEARER:
                case __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["h" /* AuthenticationScheme */].POP:
                    logger.trace("isNativeAvailable: authenticationScheme is supported, returning true");
                    return true;
                default:
                    logger.trace("isNativeAvailable: authenticationScheme is not supported, returning false");
                    return false;
            }
        }
        return true;
    };
    return NativeMessageHandler;
}());


//# sourceMappingURL=NativeMessageHandler.js.map


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var defined = __webpack_require__(123);
var fails = __webpack_require__(37);
var spaces = __webpack_require__(588);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(1166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(599);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(1175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(1176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(1177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(1178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(600);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(1179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(1180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(604);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(1185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(1186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(1189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(601);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(614);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        var _ref;

        observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventEmitter);

/***/ }),
/* 249 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1300),
    createBaseEach = __webpack_require__(758);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var Collection = __webpack_require__(776);

var util = __webpack_require__(68);

function property(obj, name, value) {
  if (value !== null && value !== undefined) {
    util.property.apply(this, arguments);
  }
}

function memoizedProperty(obj, name) {
  if (!obj.constructor.prototype[name]) {
    util.memoizedProperty.apply(this, arguments);
  }
}

function Shape(shape, options, memberName) {
  options = options || {};

  property(this, 'shape', shape.shape);
  property(this, 'api', options.api, false);
  property(this, 'type', shape.type);
  property(this, 'enum', shape.enum);
  property(this, 'min', shape.min);
  property(this, 'max', shape.max);
  property(this, 'pattern', shape.pattern);
  property(this, 'location', shape.location || this.location || 'body');
  property(this, 'name', this.name || shape.xmlName || shape.queryName ||
    shape.locationName || memberName);
  property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
  property(this, 'isComposite', shape.isComposite || false);
  property(this, 'isShape', true, false);
  property(this, 'isQueryName', Boolean(shape.queryName), false);
  property(this, 'isLocationName', Boolean(shape.locationName), false);
  property(this, 'isIdempotent', shape.idempotencyToken === true);
  property(this, 'isJsonValue', shape.jsonvalue === true);

  if (options.documentation) {
    property(this, 'documentation', shape.documentation);
    property(this, 'documentationUrl', shape.documentationUrl);
  }

  if (shape.xmlAttribute) {
    property(this, 'isXmlAttribute', shape.xmlAttribute || false);
  }

  // type conversion and parsing
  property(this, 'defaultValue', null);
  this.toWireFormat = function(value) {
    if (value === null || value === undefined) return '';
    return value;
  };
  this.toType = function(value) { return value; };
}

/**
 * @api private
 */
Shape.normalizedTypes = {
  character: 'string',
  double: 'float',
  long: 'integer',
  short: 'integer',
  biginteger: 'integer',
  bigdecimal: 'float',
  blob: 'binary'
};

/**
 * @api private
 */
Shape.types = {
  'structure': StructureShape,
  'list': ListShape,
  'map': MapShape,
  'boolean': BooleanShape,
  'timestamp': TimestampShape,
  'float': FloatShape,
  'integer': IntegerShape,
  'string': StringShape,
  'base64': Base64Shape,
  'binary': BinaryShape
};

Shape.resolve = function resolve(shape, options) {
  if (shape.shape) {
    var refShape = options.api.shapes[shape.shape];
    if (!refShape) {
      throw new Error('Cannot find shape reference: ' + shape.shape);
    }

    return refShape;
  } else {
    return null;
  }
};

Shape.create = function create(shape, options, memberName) {
  if (shape.isShape) return shape;

  var refShape = Shape.resolve(shape, options);
  if (refShape) {
    var filteredKeys = Object.keys(shape);
    if (!options.documentation) {
      filteredKeys = filteredKeys.filter(function(name) {
        return !name.match(/documentation/);
      });
    }

    // create an inline shape with extra members
    var InlineShape = function() {
      refShape.constructor.call(this, shape, options, memberName);
    };
    InlineShape.prototype = refShape;
    return new InlineShape();
  } else {
    // set type if not set
    if (!shape.type) {
      if (shape.members) shape.type = 'structure';
      else if (shape.member) shape.type = 'list';
      else if (shape.key) shape.type = 'map';
      else shape.type = 'string';
    }

    // normalize types
    var origType = shape.type;
    if (Shape.normalizedTypes[shape.type]) {
      shape.type = Shape.normalizedTypes[shape.type];
    }

    if (Shape.types[shape.type]) {
      return new Shape.types[shape.type](shape, options, memberName);
    } else {
      throw new Error('Unrecognized shape type: ' + origType);
    }
  }
};

function CompositeShape(shape) {
  Shape.apply(this, arguments);
  property(this, 'isComposite', true);

  if (shape.flattened) {
    property(this, 'flattened', shape.flattened || false);
  }
}

function StructureShape(shape, options) {
  var requiredMap = null, firstInit = !this.isShape;

  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return {}; });
    property(this, 'members', {});
    property(this, 'memberNames', []);
    property(this, 'required', []);
    property(this, 'isRequired', function() { return false; });
  }

  if (shape.members) {
    property(this, 'members', new Collection(shape.members, options, function(name, member) {
      return Shape.create(member, options, name);
    }));
    memoizedProperty(this, 'memberNames', function() {
      return shape.xmlOrder || Object.keys(shape.members);
    });
  }

  if (shape.required) {
    property(this, 'required', shape.required);
    property(this, 'isRequired', function(name) {
      if (!requiredMap) {
        requiredMap = {};
        for (var i = 0; i < shape.required.length; i++) {
          requiredMap[shape.required[i]] = true;
        }
      }

      return requiredMap[name];
    }, false, true);
  }

  property(this, 'resultWrapper', shape.resultWrapper || null);

  if (shape.payload) {
    property(this, 'payload', shape.payload);
  }

  if (typeof shape.xmlNamespace === 'string') {
    property(this, 'xmlNamespaceUri', shape.xmlNamespace);
  } else if (typeof shape.xmlNamespace === 'object') {
    property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
    property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
  }
}

function ListShape(shape, options) {
  var self = this, firstInit = !this.isShape;
  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return []; });
  }

  if (shape.member) {
    memoizedProperty(this, 'member', function() {
      return Shape.create(shape.member, options);
    });
  }

  if (this.flattened) {
    var oldName = this.name;
    memoizedProperty(this, 'name', function() {
      return self.member.name || oldName;
    });
  }
}

function MapShape(shape, options) {
  var firstInit = !this.isShape;
  CompositeShape.apply(this, arguments);

  if (firstInit) {
    property(this, 'defaultValue', function() { return {}; });
    property(this, 'key', Shape.create({type: 'string'}, options));
    property(this, 'value', Shape.create({type: 'string'}, options));
  }

  if (shape.key) {
    memoizedProperty(this, 'key', function() {
      return Shape.create(shape.key, options);
    });
  }
  if (shape.value) {
    memoizedProperty(this, 'value', function() {
      return Shape.create(shape.value, options);
    });
  }
}

function TimestampShape(shape) {
  var self = this;
  Shape.apply(this, arguments);

  if (this.location === 'header') {
    property(this, 'timestampFormat', 'rfc822');
  } else if (shape.timestampFormat) {
    property(this, 'timestampFormat', shape.timestampFormat);
  } else if (!this.timestampFormat && this.api) {
    if (this.api.timestampFormat) {
      property(this, 'timestampFormat', this.api.timestampFormat);
    } else {
      switch (this.api.protocol) {
        case 'json':
        case 'rest-json':
          property(this, 'timestampFormat', 'unixTimestamp');
          break;
        case 'rest-xml':
        case 'query':
        case 'ec2':
          property(this, 'timestampFormat', 'iso8601');
          break;
      }
    }
  }

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    if (typeof value.toUTCString === 'function') return value;
    return typeof value === 'string' || typeof value === 'number' ?
           util.date.parseTimestamp(value) : null;
  };

  this.toWireFormat = function(value) {
    return util.date.format(value, self.timestampFormat);
  };
}

function StringShape() {
  Shape.apply(this, arguments);

  var nullLessProtocols = ['rest-xml', 'query', 'ec2'];
  this.toType = function(value) {
    value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ?
      value || '' : value;
    if (this.isJsonValue) {
      return JSON.parse(value);
    }

    return value && typeof value.toString === 'function' ?
      value.toString() : value;
  };

  this.toWireFormat = function(value) {
    return this.isJsonValue ? JSON.stringify(value) : value;
  };
}

function FloatShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    return parseFloat(value);
  };
  this.toWireFormat = this.toType;
}

function IntegerShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (value === null || value === undefined) return null;
    return parseInt(value, 10);
  };
  this.toWireFormat = this.toType;
}

function BinaryShape() {
  Shape.apply(this, arguments);
  this.toType = util.base64.decode;
  this.toWireFormat = util.base64.encode;
}

function Base64Shape() {
  BinaryShape.apply(this, arguments);
}

function BooleanShape() {
  Shape.apply(this, arguments);

  this.toType = function(value) {
    if (typeof value === 'boolean') return value;
    if (value === null || value === undefined) return null;
    return value === 'true';
  };
}

/**
 * @api private
 */
Shape.shapes = {
  StructureShape: StructureShape,
  ListShape: ListShape,
  MapShape: MapShape,
  StringShape: StringShape,
  BooleanShape: BooleanShape,
  Base64Shape: Base64Shape
};

module.exports = Shape;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(323),
    getRawTag = __webpack_require__(1356),
    objectToString = __webpack_require__(1357);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(322),
    isLength = __webpack_require__(444);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1369),
    baseKeys = __webpack_require__(786),
    isArrayLike = __webpack_require__(255);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sts'] = {};
AWS.STS = Service.defineService('sts', ['2011-06-15']);
__webpack_require__(1492);
Object.defineProperty(apiLoader.services['sts'], '2011-06-15', {
  get: function get() {
    var model = __webpack_require__(1493);
    model.paginators = __webpack_require__(1494).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.STS;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MERGE_NEW_DIARIES = exports.LOAD_DIARY = exports.CLEAR_DIARIES = exports.MARK_DIARY_READ_FAILED = exports.MARK_DIARY_READ_COMPLETED = exports.MARK_DIARY_READ_REQUESTED = exports.MARK_DIARY_READ = exports.DELETE_DIARY_FAILED = exports.DELETE_DIARY_COMPLETED = exports.DELETE_DIARY_REQUESTED = exports.DELETE_DIARY = exports.POST_OR_UPDATE_DIARY_FAILED = exports.POST_OR_UPDATE_DIARY_COMPLETED = exports.POST_OR_UPDATE_DIARY_REQUESTED = exports.POST_OR_UPDATE_DIARY = exports.FLUSH_UNREAD_DIARIES_FAILED = exports.FLUSH_UNREAD_DIARIES_COMPLETED = exports.FLUSH_UNREAD_DIARIES_REQUESTED = exports.FLUSH_UNREAD_DIARIES = exports.FETCH_DIARIES_FAILED = exports.FETCH_DIARIES_COMPLETED = exports.FETCH_DIARIES_REQUESTED = exports.FETCH_DIARIES = undefined;
exports.fetchDiariesRequested = fetchDiariesRequested;
exports.fetchDiaries = fetchDiaries;
exports.fetchDiariesCompleted = fetchDiariesCompleted;
exports.fetchDiariesFailed = fetchDiariesFailed;
exports.flushUnreadDiariesRequested = flushUnreadDiariesRequested;
exports.flushUnreadDiaries = flushUnreadDiaries;
exports.flushUnreadDiariesCompleted = flushUnreadDiariesCompleted;
exports.flushUnreadDiariesFailed = flushUnreadDiariesFailed;
exports.postOrUpdateDiaryRequested = postOrUpdateDiaryRequested;
exports.postOrUpdateDiary = postOrUpdateDiary;
exports.postOrUpdateDiaryCompleted = postOrUpdateDiaryCompleted;
exports.postOrUpdateDiaryFailed = postOrUpdateDiaryFailed;
exports.deleteDiaryRequested = deleteDiaryRequested;
exports.deleteDiary = deleteDiary;
exports.deleteDiaryCompleted = deleteDiaryCompleted;
exports.deleteDiaryFailed = deleteDiaryFailed;
exports.markDiaryReadRequested = markDiaryReadRequested;
exports.markDiaryRead = markDiaryRead;
exports.markDiaryReadCompleted = markDiaryReadCompleted;
exports.markDiaryReadFailed = markDiaryReadFailed;
exports.clearDiaries = clearDiaries;
exports.loadDiary = loadDiary;
exports.mergeNewDiaries = mergeNewDiaries;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _agentType = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/diaries.js

var FETCH_DIARIES = exports.FETCH_DIARIES = "FETCH_DIARIES";
var FETCH_DIARIES_REQUESTED = exports.FETCH_DIARIES_REQUESTED = "FETCH_DIARIES_REQUESTED";
var FETCH_DIARIES_COMPLETED = exports.FETCH_DIARIES_COMPLETED = "FETCH_DIARIES_COMPLETED";
var FETCH_DIARIES_FAILED = exports.FETCH_DIARIES_FAILED = "FETCH_DIARIES_FAILED";

function fetchDiariesRequested(group_id) {
  return {
    type: FETCH_DIARIES_REQUESTED,
    group_id: group_id
  };
}

function fetchDiaries(group_id, offset) {
  return function (dispatch) {
    dispatch(fetchDiariesRequested(group_id));
    return _gambaApi2.default.get('/diaries', { group_id: group_id, offset: offset }).then(function (results) {
      dispatch(fetchDiariesCompleted(results, offset, group_id));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDiariesFailed(error, group_id)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchDiariesCompleted(results, offset, group_id) {
  return {
    type: FETCH_DIARIES_COMPLETED,
    results: results, offset: offset, group_id: group_id
  };
}

function fetchDiariesFailed(error, group_id) {
  return {
    type: FETCH_DIARIES_FAILED,
    error: error, group_id: group_id
  };
}

var FLUSH_UNREAD_DIARIES = exports.FLUSH_UNREAD_DIARIES = "FLUSH_UNREAD_DIARIES";
var FLUSH_UNREAD_DIARIES_REQUESTED = exports.FLUSH_UNREAD_DIARIES_REQUESTED = "FLUSH_UNREAD_DIARIES_REQUESTED";
var FLUSH_UNREAD_DIARIES_COMPLETED = exports.FLUSH_UNREAD_DIARIES_COMPLETED = "FLUSH_UNREAD_DIARIES_COMPLETED";
var FLUSH_UNREAD_DIARIES_FAILED = exports.FLUSH_UNREAD_DIARIES_FAILED = "FLUSH_UNREAD_DIARIES_FAILED";

function flushUnreadDiariesRequested() {
  return {
    type: FLUSH_UNREAD_DIARIES_REQUESTED
  };
}

function flushUnreadDiaries(group_id) {
  return function (dispatch) {
    dispatch(flushUnreadDiariesRequested());
    return _gambaApi2.default.get('/diaries/flush', { group_id: group_id }).then(function (results) {
      dispatch(flushUnreadDiariesCompleted(results, group_id));
    }).catch(function (error) {
      Promise.all([dispatch(flushUnreadDiariesFailed(error, group_id)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function flushUnreadDiariesCompleted(results, group_id) {
  return {
    type: FLUSH_UNREAD_DIARIES_COMPLETED,
    results: results, group_id: group_id
  };
}

function flushUnreadDiariesFailed(error, group_id) {
  return {
    type: FLUSH_UNREAD_DIARIES_FAILED,
    error: error, group_id: group_id
  };
}

var POST_OR_UPDATE_DIARY = exports.POST_OR_UPDATE_DIARY = "POST_OR_UPDATE_DIARY";
var POST_OR_UPDATE_DIARY_REQUESTED = exports.POST_OR_UPDATE_DIARY_REQUESTED = "POST_OR_UPDATE_DIARY_REQUESTED";
var POST_OR_UPDATE_DIARY_COMPLETED = exports.POST_OR_UPDATE_DIARY_COMPLETED = "POST_OR_UPDATE_DIARY_COMPLETED";
var POST_OR_UPDATE_DIARY_FAILED = exports.POST_OR_UPDATE_DIARY_FAILED = "POST_OR_UPDATE_DIARY_FAILED";

function postOrUpdateDiaryRequested(group_id) {
  return {
    type: POST_OR_UPDATE_DIARY_REQUESTED,
    group_id: group_id
  };
}

function postOrUpdateDiary(group_id, diary_id, category, reported_at, subject, content, upload_files, upload_videos, attach_json, mentions) {
  return function (dispatch) {
    dispatch(postOrUpdateDiaryRequested(group_id));
    return (diary_id && _gambaApi2.default.put('/diaries/' + diary_id, {
      saved: false, category: category, reported_at: (0, _moment2.default)(reported_at).format('YYYY-MM-DD'), subject: subject, content: content, upload_files: upload_files, upload_videos: upload_videos, attach_json: attach_json, mentions: mentions
    }) || _gambaApi2.default.post('/diaries', {
      group_id: group_id, category: category, saved: false, reported_at: (0, _moment2.default)(reported_at).format('YYYY-MM-DD'), subject: subject, content: content, upload_files: upload_files, upload_videos: upload_videos, attach_json: attach_json, mentions: mentions
    })).then(function (results) {
      dispatch(postOrUpdateDiaryCompleted(results, group_id));
    }).catch(function (error) {
      Promise.all([dispatch(postOrUpdateDiaryFailed(error, group_id)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function postOrUpdateDiaryCompleted(results, group_id) {
  return {
    type: POST_OR_UPDATE_DIARY_COMPLETED,
    results: results, group_id: group_id
  };
}

function postOrUpdateDiaryFailed(error, group_id) {
  return {
    type: POST_OR_UPDATE_DIARY_FAILED,
    error: error, group_id: group_id
  };
}

var DELETE_DIARY = exports.DELETE_DIARY = "DELETE_DIARY";
var DELETE_DIARY_REQUESTED = exports.DELETE_DIARY_REQUESTED = "DELETE_DIARY_REQUESTED";
var DELETE_DIARY_COMPLETED = exports.DELETE_DIARY_COMPLETED = "DELETE_DIARY_COMPLETED";
var DELETE_DIARY_FAILED = exports.DELETE_DIARY_FAILED = "DELETE_DIARY_FAILED";

function deleteDiaryRequested() {
  return {
    type: DELETE_DIARY_REQUESTED
  };
}

function deleteDiary(diary_id) {
  return function (dispatch) {
    dispatch(deleteDiaryRequested());
    return _gambaApi2.default.delete('/diaries/' + diary_id).then(function (results) {
      dispatch(deleteDiaryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deleteDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteDiaryCompleted(results) {
  return {
    type: DELETE_DIARY_COMPLETED,
    results: results
  };
}

function deleteDiaryFailed(error) {
  return {
    type: DELETE_DIARY_FAILED,
    error: error
  };
}

var MARK_DIARY_READ = exports.MARK_DIARY_READ = "MARK_DIARY_READ";
var MARK_DIARY_READ_REQUESTED = exports.MARK_DIARY_READ_REQUESTED = "MARK_DIARY_READ_REQUESTED";
var MARK_DIARY_READ_COMPLETED = exports.MARK_DIARY_READ_COMPLETED = "MARK_DIARY_READ_COMPLETED";
var MARK_DIARY_READ_FAILED = exports.MARK_DIARY_READ_FAILED = "MARK_DIARY_READ_FAILED";

function markDiaryReadRequested() {
  return {
    type: MARK_DIARY_READ_REQUESTED
  };
}

function markDiaryRead(diary_id) {
  return function (dispatch) {
    dispatch(markDiaryReadRequested());
    return _gambaApi2.default.post('/readers/' + diary_id).then(function (results) {
      dispatch(markDiaryReadCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(markDiaryReadFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function markDiaryReadCompleted(results) {
  return {
    type: MARK_DIARY_READ_COMPLETED,
    results: results
  };
}

function markDiaryReadFailed(error) {
  return {
    type: MARK_DIARY_READ_FAILED,
    error: error
  };
}

var CLEAR_DIARIES = exports.CLEAR_DIARIES = "CLEAR_DIARIES";

function clearDiaries() {
  var group_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  return {
    type: CLEAR_DIARIES,
    group_id: group_id
  };
}

var LOAD_DIARY = exports.LOAD_DIARY = "LOAD_DIARY";

function loadDiary(diary) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: LOAD_DIARY,
    diary: diary,
    appending: opt.appending,
    own_post: opt.own_post,
    deleted: opt.deleted,
    group_id: opt.group_id
  };
}

var MERGE_NEW_DIARIES = exports.MERGE_NEW_DIARIES = "MERGE_NEW_DIARIES";

function mergeNewDiaries(group_id) {
  return {
    type: MERGE_NEW_DIARIES,
    group_id: group_id
  };
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHECK_LOGIN_STATUS_COMPLETED = exports.CHECK_LOGIN_STATUS_REQUESTED = exports.CHECK_LOGIN_STATUS = exports.LOGOUT_FAILED = exports.LOGOUT_COMPLETED = exports.LOGOUT_REQUESTED = exports.LOGOUT = exports.CLEAR_LOGIN_STATUS = exports.LOGIN_FAILED = exports.LOGIN_COMPLETED = exports.LOGIN_REQUESTED = exports.LOGIN = undefined;
exports.loginRequested = loginRequested;
exports.login = login;
exports.loginCompleted = loginCompleted;
exports.loginFailed = loginFailed;
exports.clearLoginStatus = clearLoginStatus;
exports.logoutRequested = logoutRequested;
exports.logout = logout;
exports.logoutCompleted = logoutCompleted;
exports.logoutFailed = logoutFailed;
exports.checkLoginStatusRequested = checkLoginStatusRequested;
exports.checkLoginStatusCompleted = checkLoginStatusCompleted;
exports.checkLoginStatus = checkLoginStatus;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _accessToken = __webpack_require__(220);

var _accessToken2 = _interopRequireDefault(_accessToken);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGIN = exports.LOGIN = "LOGIN";
// src/actions/sessions.js

var LOGIN_REQUESTED = exports.LOGIN_REQUESTED = "LOGIN_REQUESTED";
var LOGIN_COMPLETED = exports.LOGIN_COMPLETED = "LOGIN_COMPLETED";
var LOGIN_FAILED = exports.LOGIN_FAILED = "LOGIN_FAILED";
var CLEAR_LOGIN_STATUS = exports.CLEAR_LOGIN_STATUS = "CLEAR_LOGIN_STATUS";

function loginRequested() {
  return {
    type: LOGIN_REQUESTED
  };
}

function login(email) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var password = opts.password,
      passcode = opts.passcode,
      new_password = opts.new_password,
      password_confirmation = opts.password_confirmation;


  return function (dispatch) {
    dispatch(loginRequested());
    return _gambaApi2.default.post('/sessions', { email: email, password: password, new_password: new_password, password_confirmation: password_confirmation, passcode: passcode }).then(function (results) {
      if (results.access_token) _accessToken2.default.set(results.access_token, function () {
        return dispatch(loginCompleted(results));
      });else dispatch(loginCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(loginFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function loginCompleted(results) {
  return {
    type: LOGIN_COMPLETED,
    results: results
  };
}

function loginFailed(error) {
  return {
    type: LOGIN_FAILED,
    error: error
  };
}

function clearLoginStatus() {
  return {
    type: CLEAR_LOGIN_STATUS
  };
}

var LOGOUT = exports.LOGOUT = "LOGOUT";
var LOGOUT_REQUESTED = exports.LOGOUT_REQUESTED = "LOGOUT_REQUESTED";
var LOGOUT_COMPLETED = exports.LOGOUT_COMPLETED = "LOGOUT_COMPLETED";
var LOGOUT_FAILED = exports.LOGOUT_FAILED = "LOGOUT_FAILED";

function logoutRequested() {
  return {
    type: LOGOUT_REQUESTED
  };
}

function logout(all_logout) {
  return function (dispatch) {
    dispatch(logoutRequested());
    return _gambaApi2.default.delete('/sessions', { all_logout: all_logout }).then(function (results) {
      _accessToken2.default.clear();
      dispatch(logoutCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(logoutFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function logoutCompleted(results) {
  return {
    type: LOGOUT_COMPLETED,
    results: results
  };
}

function logoutFailed(error) {
  return {
    type: LOGOUT_FAILED,
    error: error
  };
}

var CHECK_LOGIN_STATUS = exports.CHECK_LOGIN_STATUS = "CHECK_LOGIN_STATUS";
var CHECK_LOGIN_STATUS_REQUESTED = exports.CHECK_LOGIN_STATUS_REQUESTED = "CHECK_LOGIN_STATUS_REQUESTED";
var CHECK_LOGIN_STATUS_COMPLETED = exports.CHECK_LOGIN_STATUS_COMPLETED = "CHECK_LOGIN_STATUS_COMPLETED";

function checkLoginStatusRequested() {
  return {
    type: CHECK_LOGIN_STATUS_REQUESTED
  };
}

function checkLoginStatusCompleted(access_token) {
  return {
    type: CHECK_LOGIN_STATUS_COMPLETED,
    access_token: access_token
  };
}

function checkLoginStatus() {
  return function (dispatch) {
    dispatch(checkLoginStatusRequested());
    _accessToken2.default.get(function (token) {
      return dispatch(checkLoginStatusCompleted(token));
    });
  };
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_UPLOAD_FILES_AND_VIDEOS = exports.CANCEL_UPLOAD_FILE = exports.UPLOAD_FILE_PROGRESS = exports.UPLOAD_FILE_FAILED = exports.UPLOAD_FILE_COMPLETED = exports.UPLOAD_FILE_REQUESTED = exports.UPLOAD_FILE = undefined;
exports.uploadFileRequested = uploadFileRequested;
exports.uploadFileProgress = uploadFileProgress;
exports.uploadFile = uploadFile;
exports.uploadFileCompleted = uploadFileCompleted;
exports.uploadFileFailed = uploadFileFailed;
exports.cancelUploadFile = cancelUploadFile;
exports.clearUploadFilesAndVideos = clearUploadFilesAndVideos;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/actions/upload-file.js

var UPLOAD_FILE = exports.UPLOAD_FILE = "UPLOAD_FILE";
var UPLOAD_FILE_REQUESTED = exports.UPLOAD_FILE_REQUESTED = "UPLOAD_FILE_REQUESTED";
var UPLOAD_FILE_COMPLETED = exports.UPLOAD_FILE_COMPLETED = "UPLOAD_FILE_COMPLETED";
var UPLOAD_FILE_FAILED = exports.UPLOAD_FILE_FAILED = "UPLOAD_FILE_FAILED";
var UPLOAD_FILE_PROGRESS = exports.UPLOAD_FILE_PROGRESS = "UPLOAD_FILE_PROGRESS";
var CANCEL_UPLOAD_FILE = exports.CANCEL_UPLOAD_FILE = "CANCEL_UPLOAD_FILE";
var CLEAR_UPLOAD_FILES_AND_VIDEOS = exports.CLEAR_UPLOAD_FILES_AND_VIDEOS = "CLEAR_UPLOAD_FILES_AND_VIDEOS";

// 最大アップロードファイルサイズを設定します。この値はnginxの制限に依存しています。
// 現在nginxの最大アップロードファイルサイズは1000MBに設定されています。
var MAX_FILE_SIZE = 1 * 1024 * 1024 * 1024; // 1000MB in bytes
var MAX_FILE_SIZE_TITLE = "1000MB"; // Max file size displayed in error message

function uploadFileRequested(componentId, uploadId) {
  return {
    type: UPLOAD_FILE_REQUESTED,
    componentId: componentId, uploadId: uploadId
  };
}

function uploadFileProgress(loaded, total, componentId, uploadId) {
  return {
    type: UPLOAD_FILE_PROGRESS,
    loaded: loaded, total: total, componentId: componentId, uploadId: uploadId
  };
}

function uploadFile(id, type, file, componentId) {
  var single = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var uploadId = Math.random().toString().slice(-12);
  return function (dispatch) {
    dispatch(uploadFileRequested(componentId, uploadId));
    return _gambaApi2.default.upload('/upload_file', _defineProperty({}, type + '_id', id), file, function (progress) {
      dispatch(uploadFileProgress(progress.loaded, progress.total, componentId, uploadId));
    }).then(function (results) {
      dispatch(uploadFileCompleted(results, componentId, uploadId, single));
    }).catch(function (error) {
      // Check if file size is over MAX_FILE_SIZE
      if (file.size > MAX_FILE_SIZE) {
        Promise.all([dispatch(uploadFileFailed(error, componentId, uploadId)), dispatch((0, _alertMessage.emitAlertMessage)({ message: 'error:ファイルサイズが制限を超えています', max_file_size: MAX_FILE_SIZE_TITLE }, 'error'))]);
      } else {
        Promise.all([dispatch(uploadFileFailed(error, componentId, uploadId)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
      }
    });
  };
}

function uploadFileCompleted(results, componentId, uploadId, single) {
  return {
    type: UPLOAD_FILE_COMPLETED,
    results: results, componentId: componentId, uploadId: uploadId, single: single
  };
}

function uploadFileFailed(error, componentId, uploadId) {
  return {
    type: UPLOAD_FILE_FAILED,
    error: error, componentId: componentId, uploadId: uploadId
  };
}

function cancelUploadFile(componentId, uploadId) {
  return {
    type: CANCEL_UPLOAD_FILE,
    componentId: componentId, uploadId: uploadId
  };
}

function clearUploadFilesAndVideos(componentId) {
  return {
    type: CLEAR_UPLOAD_FILES_AND_VIDEOS,
    componentId: componentId
  };
}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATE_MESSAGE_FAILED = exports.TRANSLATE_MESSAGE_COMPLETED = exports.TRANSLATE_MESSAGE_REQUESTED = exports.TRANSLATE_MESSAGE = exports.TRANSLATE_COMMENT_FAILED = exports.TRANSLATE_COMMENT_COMPLETED = exports.TRANSLATE_COMMENT_REQUESTED = exports.TRANSLATE_COMMENT = exports.TRANSLATE_DIARY_FAILED = exports.TRANSLATE_DIARY_COMPLETED = exports.TRANSLATE_DIARY_REQUESTED = exports.TRANSLATE_DIARY = undefined;
exports.translateDiaryRequested = translateDiaryRequested;
exports.translateDiary = translateDiary;
exports.translateDiaryCompleted = translateDiaryCompleted;
exports.translateDiaryFailed = translateDiaryFailed;
exports.translateCommentRequested = translateCommentRequested;
exports.translateComment = translateComment;
exports.translateCommentCompleted = translateCommentCompleted;
exports.translateCommentFailed = translateCommentFailed;
exports.translateMessageRequested = translateMessageRequested;
exports.translateMessage = translateMessage;
exports.translateMessageCompleted = translateMessageCompleted;
exports.translateMessageFailed = translateMessageFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/translate.js

var TRANSLATE_DIARY = exports.TRANSLATE_DIARY = "TRANSLATE_DIARY";
var TRANSLATE_DIARY_REQUESTED = exports.TRANSLATE_DIARY_REQUESTED = "TRANSLATE_DIARY_REQUESTED";
var TRANSLATE_DIARY_COMPLETED = exports.TRANSLATE_DIARY_COMPLETED = "TRANSLATE_DIARY_COMPLETED";
var TRANSLATE_DIARY_FAILED = exports.TRANSLATE_DIARY_FAILED = "TRANSLATE_DIARY_FAILED";

function translateDiaryRequested(group_id, diary_id) {
  return {
    type: TRANSLATE_DIARY_REQUESTED,
    group_id: group_id, diary_id: diary_id
  };
}

function translateDiary(group_id, diary_id) {
  var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return function (dispatch) {
    dispatch(translateDiaryRequested(group_id, diary_id));
    return _gambaApi2.default.get('/translate/diaries/' + diary_id, { lang: lang }).then(function (results) {
      dispatch(translateDiaryCompleted(group_id, diary_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(translateDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function translateDiaryCompleted(group_id, diary_id, results) {
  return {
    type: TRANSLATE_DIARY_COMPLETED,
    group_id: group_id, diary_id: diary_id, results: results
  };
}

function translateDiaryFailed(error) {
  return {
    type: TRANSLATE_DIARY_FAILED,
    error: error
  };
}

var TRANSLATE_COMMENT = exports.TRANSLATE_COMMENT = "TRANSLATE_COMMENT";
var TRANSLATE_COMMENT_REQUESTED = exports.TRANSLATE_COMMENT_REQUESTED = "TRANSLATE_COMMENT_REQUESTED";
var TRANSLATE_COMMENT_COMPLETED = exports.TRANSLATE_COMMENT_COMPLETED = "TRANSLATE_COMMENT_COMPLETED";
var TRANSLATE_COMMENT_FAILED = exports.TRANSLATE_COMMENT_FAILED = "TRANSLATE_COMMENT_FAILED";

function translateCommentRequested(group_id, diary_id, comment_id) {
  return {
    type: TRANSLATE_COMMENT_REQUESTED,
    group_id: group_id, diary_id: diary_id, comment_id: comment_id
  };
}

function translateComment(group_id, diary_id, comment_id) {
  var lang = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

  return function (dispatch) {
    dispatch(translateCommentRequested(group_id, diary_id, comment_id));
    return _gambaApi2.default.get('/translate/comments/' + comment_id, { lang: lang }).then(function (results) {
      dispatch(translateCommentCompleted(group_id, diary_id, comment_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(translateCommentFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function translateCommentCompleted(group_id, diary_id, comment_id, results) {
  return {
    type: TRANSLATE_COMMENT_COMPLETED,
    group_id: group_id, diary_id: diary_id, comment_id: comment_id, results: results
  };
}

function translateCommentFailed(error) {
  return {
    type: TRANSLATE_COMMENT_FAILED,
    error: error
  };
}

var TRANSLATE_MESSAGE = exports.TRANSLATE_MESSAGE = "TRANSLATE_MESSAGE";
var TRANSLATE_MESSAGE_REQUESTED = exports.TRANSLATE_MESSAGE_REQUESTED = "TRANSLATE_MESSAGE_REQUESTED";
var TRANSLATE_MESSAGE_COMPLETED = exports.TRANSLATE_MESSAGE_COMPLETED = "TRANSLATE_MESSAGE_COMPLETED";
var TRANSLATE_MESSAGE_FAILED = exports.TRANSLATE_MESSAGE_FAILED = "TRANSLATE_MESSAGE_FAILED";

function translateMessageRequested(chat_room_id, message_id) {
  return {
    type: TRANSLATE_MESSAGE_REQUESTED,
    chat_room_id: chat_room_id, message_id: message_id
  };
}

function translateMessage(chat_room_id, message_id) {
  var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return function (dispatch) {
    dispatch(translateMessageRequested(chat_room_id, message_id));
    return _gambaApi2.default.get('/translate/chat_messages/' + message_id, { lang: lang }).then(function (results) {
      dispatch(translateMessageCompleted(chat_room_id, message_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(translateMessageFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function translateMessageCompleted(chat_room_id, message_id, results) {
  return {
    type: TRANSLATE_MESSAGE_COMPLETED,
    chat_room_id: chat_room_id, message_id: message_id, results: results
  };
}

function translateMessageFailed(error) {
  return {
    type: TRANSLATE_MESSAGE_FAILED,
    error: error
  };
}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(853),
    baseIteratee = __webpack_require__(139),
    toInteger = __webpack_require__(854);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
// src/helpers/shallow-equal.js

exports.default = shallowEqual;

var _some = __webpack_require__(161);

var _some2 = _interopRequireDefault(_some);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function shallowEqual(objA, objB) {
  if (objA === objB) return true;

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || !objA || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || !objB) return false;

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length || (0, _some2.default)(keysA, function (key, i) {
    return key !== keysB[i];
  })) return false;

  return !(0, _some2.default)(objA, function (value, key) {
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) != _typeof(objB[key])) return true;
    if (value instanceof Array) {
      if (value.length != objB[key].length || Object.keys(value).length != Object.keys(objB[key]).length) return true;
      return (0, _some2.default)(Object.keys(value), function (_key) {
        return value[_key] !== objB[key][_key];
      });
    }
    if (typeof value == 'function') return false;
    if (value !== objB[key]) return true;
    return false;
  });
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overrideComponentTypeChecker = overrideComponentTypeChecker;
exports.defaultChecker = defaultChecker;
exports.default = isComponentOfType;
var customChecker = void 0;

/**
 *  Sets customChecker which will be used for all components.
 *
 * @param providedChecker {Function} - Checker function
 */
function overrideComponentTypeChecker(providedChecker) {
  customChecker = providedChecker;
}

/**
 * Returns true if the provided element is a component of the provided type.
 *
 * @param classType {ReactElement class} - the class of a React Element
 * @param reactElement {ReactElement} - any React Element (not a real DOM node)
 */
function defaultChecker(classType, reactElement) {
  return reactElement && reactElement.type === classType;
}

/**
 * Executes customChecker if it's set or defaultChecker.
 *
 * @param classType {ReactElement class} - the class of a React Element
 * @param reactElement {ReactElement} - any React Element (not a real DOM node)
 */
function isComponentOfType(classType, reactElement) {
  return customChecker ? customChecker(classType, reactElement) : defaultChecker(classType, reactElement);
}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1831);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsPage = exports.RawSettingsPage = exports.SettingsPanel = exports.LinkPanel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _settingsPage = __webpack_require__(1902);

var _settingsPage2 = _interopRequireDefault(_settingsPage);

var _app_bar = __webpack_require__(122);

var _dialog = __webpack_require__(47);

var _layout = __webpack_require__(85);

var _list = __webpack_require__(25);

var _button = __webpack_require__(8);

var _settingsDialog = __webpack_require__(1903);

var _settingsDialog2 = _interopRequireDefault(_settingsDialog);

var _inactiveListItem = __webpack_require__(1905);

var _inactiveListItem2 = _interopRequireDefault(_inactiveListItem);

var _activeListItem = __webpack_require__(1907);

var _activeListItem2 = _interopRequireDefault(_activeListItem);

var _userAgent = __webpack_require__(491);

var _userAgent2 = _interopRequireDefault(_userAgent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/settings-page.jsx

var LinkPanel = exports.LinkPanel = function (_React$Component) {
  _inherits(LinkPanel, _React$Component);

  function LinkPanel() {
    _classCallCheck(this, LinkPanel);

    return _possibleConstructorReturn(this, (LinkPanel.__proto__ || Object.getPrototypeOf(LinkPanel)).apply(this, arguments));
  }

  _createClass(LinkPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          icon = _props.icon,
          url = _props.url,
          onClose = _props.onClose;


      return _react2.default.createElement(
        'a',
        { href: url, target: '_blank', rel: 'noopener noreferrer', style: { textDecoration: 'none' }, onClick: onClose },
        _react2.default.createElement(_list.ListItem, { selectable: true,
          caption: label,
          leftIcon: icon,
          theme: _inactiveListItem2.default })
      );
    }
  }]);

  return LinkPanel;
}(_react2.default.Component);

var SettingsPanel = exports.SettingsPanel = function (_React$Component2) {
  _inherits(SettingsPanel, _React$Component2);

  function SettingsPanel() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, SettingsPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = SettingsPanel.__proto__ || Object.getPrototypeOf(SettingsPanel)).call.apply(_ref, [this].concat(args))), _this2), _this2.onClick = function () {
      _this2.props.selectPanel(_this2.props.name, undefined, _this2.props.params);
      _this2.props.onCloseDrawer();
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(SettingsPanel, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          name = _props2.name,
          currentName = _props2.currentName,
          label = _props2.label,
          icon = _props2.icon,
          params = _props2.params,
          children = _props2.children,
          component = _props2.component,
          subComponents = _props2.subComponents,
          selectPanel = _props2.selectPanel;


      return _react2.default.createElement(_list.ListItem, { selectable: true,
        caption: label,
        leftIcon: icon,
        theme: name == currentName && _activeListItem2.default || _inactiveListItem2.default,
        onMouseDown: this.onClick /* firefoxでなぜかonClickが動作しない不具合のため */,
        onTouchStart: this.onClick });
    }
  }]);

  return SettingsPanel;
}(_react2.default.Component);

var _SettingsPage = function (_React$Component3) {
  _inherits(_SettingsPage, _React$Component3);

  function _SettingsPage() {
    _classCallCheck(this, _SettingsPage);

    return _possibleConstructorReturn(this, (_SettingsPage.__proto__ || Object.getPrototypeOf(_SettingsPage)).apply(this, arguments));
  }

  _createClass(_SettingsPage, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props3 = this.props,
          t = _props3.t,
          ui = _props3.ui,
          title = _props3.title,
          active = _props3.active,
          isPhone = _props3.isPhone,
          children = _props3.children,
          updateUI = _props3.updateUI,
          selectPanel = _props3.selectPanel,
          onCloseDrawer = _props3.onCloseDrawer,
          onOpenDrawer = _props3.onOpenDrawer,
          onCloseDialog = _props3.onCloseDialog;


      var newProps = {
        currentName: ui.name,
        selectPanel: selectPanel, onCloseDrawer: onCloseDrawer
      };
      var _children = _react2.default.Children.map(children, function (child) {
        return child && _react2.default.cloneElement(child, newProps);
      });
      var childrenArray = _react2.default.Children.toArray(_children);
      var panel = childrenArray[0];
      if (ui.name) panel = _.find(childrenArray, function (child) {
        return child.props.name == ui.name;
      });

      var Component = panel.props.component;
      var label = panel.props.label;
      var params = panel.props.params;
      var leftIcon = isPhone && 'menu' || '';
      var onLeftIconClick = function onLeftIconClick() {
        return onOpenDrawer(_this4.props);
      };
      if (ui.subName && panel && panel.props.subPanel && panel.props.subPanel[ui.subName]) {
        Component = panel.props.subPanel[ui.subName].component;
        label = label + ' / ' + panel.props.subPanel[ui.subName].label;
        leftIcon = "arrow_back";
        onLeftIconClick = function onLeftIconClick() {
          return selectPanel(ui.name, undefined, undefined);
        };
      }

      return _react2.default.createElement(
        _dialog.Dialog,
        { active: active,
          type: 'large',
          onEscKeyDown: onCloseDialog,
          onOverlayClick: onCloseDialog,
          theme: _settingsDialog2.default },
        _react2.default.createElement(
          _layout.Layout,
          null,
          _react2.default.createElement(
            _layout.NavDrawer,
            { ref: 'navDrawer',
              active: ui.active,
              pinned: !isPhone,
              onOverlayClick: function onOverlayClick() {
                return onCloseDrawer(_this4.props);
              },
              className: 'setting-nav-drawer' },
            _react2.default.createElement(
              _list.List,
              null,
              _react2.default.createElement(_list.ListItem, { caption: title, ripple: false, selectable: false,
                rightActions: [_react2.default.createElement(_button.IconButton, { flat: true, key: 'close', icon: 'close', onClick: onCloseDialog })] }),
              _children
            )
          ),
          _react2.default.createElement(
            _layout.Panel,
            null,
            _react2.default.createElement(_app_bar.AppBar, { title: label, flat: true,
              leftIcon: leftIcon,
              onLeftIconClick: onLeftIconClick,
              rightIcon: 'close',
              onRightIconClick: onCloseDialog,
              className: 'setting-nav-appbar'
            }),
            _react2.default.createElement(
              'div',
              {
                style: {
                  marginTop: '56px',
                  height: 'calc(100vh - 64px)',
                  overflowY: 'auto'
                }
              },
              _react2.default.createElement(Component, _extends({}, ui.params, params, { selectPanel: selectPanel, onCloseDialog: onCloseDialog }))
            )
          )
        )
      );
    }
  }]);

  return _SettingsPage;
}(_react2.default.Component);

var RawSettingsPage = exports.RawSettingsPage = _SettingsPage;
var SettingsPage = exports.SettingsPage = (0, _settingsPage2.default)(_SettingsPage);

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (url) {
  return url.match(/^https:\/\/docs\.google\.com/);
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;

var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Parser = __webpack_require__(918),
    DomHandler = __webpack_require__(1967);

function defineProp(name, value){
	delete module.exports[name];
	module.exports[name] = value;
	return value;
}

module.exports = {
	Parser: Parser,
	Tokenizer: __webpack_require__(919),
	ElementType: __webpack_require__(272),
	DomHandler: DomHandler,
	get FeedHandler(){
		return defineProp("FeedHandler", __webpack_require__(1969));
	},
	get Stream(){
		return defineProp("Stream", __webpack_require__(1970));
	},
	get WritableStream(){
		return defineProp("WritableStream", __webpack_require__(923));
	},
	get ProxyHandler(){
		return defineProp("ProxyHandler", __webpack_require__(1980));
	},
	get DomUtils(){
		return defineProp("DomUtils", __webpack_require__(1981));
	},
	get CollectingHandler(){
		return defineProp("CollectingHandler", __webpack_require__(1993));
	},
	// For legacy support
	DefaultHandler: DomHandler,
	get RssHandler(){
		return defineProp("RssHandler", this.FeedHandler);
	},
	//helper methods
	parseDOM: function(data, options){
		var handler = new DomHandler(options);
		new Parser(handler, options).end(data);
		return handler.dom;
	},
	parseFeed: function(feed, options){
		var handler = new module.exports.FeedHandler(options);
		new Parser(handler, options).end(feed);
		return handler.dom;
	},
	createDomStream: function(cb, options, elementCb){
		var handler = new DomHandler(cb, options, elementCb);
		return new Parser(handler, options);
	},
	// List of all events that the parser emits
	EVENTS: { /* Format: eventname: number of arguments */
		attribute: 2,
		cdatastart: 0,
		cdataend: 0,
		text: 1,
		processinginstruction: 2,
		comment: 1,
		commentend: 0,
		closetag: 1,
		opentag: 2,
		opentagname: 1,
		error: 1,
		end: 0
	}
};


/***/ }),
/* 272 */
/***/ (function(module, exports) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>
	Doctype: "doctype",

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Buffer = __webpack_require__(76).Buffer;

var isBufferEncoding = Buffer.isEncoding
  || function(encoding) {
       switch (encoding && encoding.toLowerCase()) {
         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
         default: return false;
       }
     }


function assertEncoding(encoding) {
  if (encoding && !isBufferEncoding(encoding)) {
    throw new Error('Unknown encoding: ' + encoding);
  }
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
var StringDecoder = exports.StringDecoder = function(encoding) {
  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
  assertEncoding(encoding);
  switch (this.encoding) {
    case 'utf8':
      // CESU-8 represents each of Surrogate Pair by 3-bytes
      this.surrogateSize = 3;
      break;
    case 'ucs2':
    case 'utf16le':
      // UTF-16 represents each of Surrogate Pair by 2-bytes
      this.surrogateSize = 2;
      this.detectIncompleteChar = utf16DetectIncompleteChar;
      break;
    case 'base64':
      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
      this.surrogateSize = 3;
      this.detectIncompleteChar = base64DetectIncompleteChar;
      break;
    default:
      this.write = passThroughWrite;
      return;
  }

  // Enough space to store all bytes of a single character. UTF-8 needs 4
  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
  this.charBuffer = new Buffer(6);
  // Number of bytes received for the current incomplete multi-byte character.
  this.charReceived = 0;
  // Number of bytes expected for the current incomplete multi-byte character.
  this.charLength = 0;
};


// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
  var charStr = '';
  // if our last write ended with an incomplete multibyte character
  while (this.charLength) {
    // determine how many remaining bytes this buffer has to offer for this char
    var available = (buffer.length >= this.charLength - this.charReceived) ?
        this.charLength - this.charReceived :
        buffer.length;

    // add the new bytes to the char buffer
    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    this.charReceived += available;

    if (this.charReceived < this.charLength) {
      // still not enough chars in this buffer? wait for more ...
      return '';
    }

    // remove bytes belonging to the current character from the buffer
    buffer = buffer.slice(available, buffer.length);

    // get the character that was split
    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    var charCode = charStr.charCodeAt(charStr.length - 1);
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      this.charLength += this.surrogateSize;
      charStr = '';
      continue;
    }
    this.charReceived = this.charLength = 0;

    // if there are no more bytes in this buffer, just emit our char
    if (buffer.length === 0) {
      return charStr;
    }
    break;
  }

  // determine and set charLength / charReceived
  this.detectIncompleteChar(buffer);

  var end = buffer.length;
  if (this.charLength) {
    // buffer the incomplete character bytes we got
    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    end -= this.charReceived;
  }

  charStr += buffer.toString(this.encoding, 0, end);

  var end = charStr.length - 1;
  var charCode = charStr.charCodeAt(end);
  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    var size = this.surrogateSize;
    this.charLength += size;
    this.charReceived += size;
    this.charBuffer.copy(this.charBuffer, size, 0, size);
    buffer.copy(this.charBuffer, 0, 0, size);
    return charStr.substring(0, end);
  }

  // or just emit the charStr
  return charStr;
};

// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
  // determine how many bytes we have to check at the end of this buffer
  var i = (buffer.length >= 3) ? 3 : buffer.length;

  // Figure out if one of the last i bytes of our buffer announces an
  // incomplete char.
  for (; i > 0; i--) {
    var c = buffer[buffer.length - i];

    // See http://en.wikipedia.org/wiki/UTF-8#Description

    // 110XXXXX
    if (i == 1 && c >> 5 == 0x06) {
      this.charLength = 2;
      break;
    }

    // 1110XXXX
    if (i <= 2 && c >> 4 == 0x0E) {
      this.charLength = 3;
      break;
    }

    // 11110XXX
    if (i <= 3 && c >> 3 == 0x1E) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = i;
};

StringDecoder.prototype.end = function(buffer) {
  var res = '';
  if (buffer && buffer.length)
    res = this.write(buffer);

  if (this.charReceived) {
    var cr = this.charReceived;
    var buf = this.charBuffer;
    var enc = this.encoding;
    res += buf.slice(0, cr).toString(enc);
  }

  return res;
};

function passThroughWrite(buffer) {
  return buffer.toString(this.encoding);
}

function utf16DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 2;
  this.charLength = this.charReceived ? 2 : 0;
}

function base64DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 3;
  this.charLength = this.charReceived ? 3 : 0;
}


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(51);
var global = __webpack_require__(34);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(166) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(109);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(230);
var test = {};
test[__webpack_require__(52)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(93)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 277 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2263);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./sortable.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./sortable.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["e"] = getGlobalObject;
/* harmony export (immutable) */ __webpack_exports__["i"] = uuid4;
/* harmony export (immutable) */ __webpack_exports__["h"] = parseUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = getEventDescription;
/* harmony export (immutable) */ __webpack_exports__["c"] = consoleSandbox;
/* harmony export (immutable) */ __webpack_exports__["b"] = addExceptionTypeValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = addExceptionMechanism;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLocationHref;
/* unused harmony export parseSemver */
/* harmony export (immutable) */ __webpack_exports__["g"] = parseRetryAfterHeader;
/* unused harmony export addContextToFrame */
/* unused harmony export stripUrlQueryAndFragment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__string__ = __webpack_require__(526);


var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (Object(__WEBPACK_IMPORTED_MODULE_0__node__["b" /* isNodeEnv */])()
        ? global
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        return exception.type || exception.value || event.event_id || '<unknown>';
    }
    return event.event_id || '<unknown>';
}
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (level in global.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || '';
    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
}
/**
 * Adds exception mechanism to a given event.
 * @param event The event to modify.
 * @param mechanism Mechanism of the mechanism.
 * @hidden
 */
function addExceptionMechanism(event, mechanism) {
    if (mechanism === void 0) { mechanism = {}; }
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function (key) {
            // @ts-ignore Mechanism has no index signature
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    }
    catch (_oO) {
        // no-empty
    }
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    try {
        return document.location.href;
    }
    catch (oO) {
        return '';
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
var defaultRetryAfter = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */
function parseRetryAfterHeader(now, header) {
    if (!header) {
        return defaultRetryAfter;
    }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return defaultRetryAfter;
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(line, 0); });
    frame.context_line = Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(line, 0); });
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
//# sourceMappingURL=misc.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = shouldIgnoreOnError;
/* unused harmony export ignoreNextOnError */
/* harmony export (immutable) */ __webpack_exports__["c"] = wrap;
/* harmony export (immutable) */ __webpack_exports__["a"] = injectReportDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);



var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means the sentry.javascript SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["A" /* withScope */])(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event);
                    if (options.mechanism) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["f" /* addExceptionTypeValue */])(processedEvent, undefined, undefined);
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["e" /* addExceptionMechanism */])(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, processedEvent.extra), { arguments: args });
                    return processedEvent;
                });
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["k" /* captureException */])(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped,
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true,
        },
        __sentry_original__: {
            enumerable: false,
            value: fn,
        },
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].error("Missing eventId option in showReportDialog call");
        return;
    }
    if (!options.dsn) {
        __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].error("Missing dsn option in showReportDialog call");
        return;
    }
    var script = document.createElement('script');
    script.async = true;
    script.src = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](options.dsn).getReportDialogEndpoint(options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    (document.head || document.body).appendChild(script);
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(375);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(999);
var enumBugKeys = __webpack_require__(543);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 283 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(539);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = mergeClassNames;
function mergeClassNames() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (classList, arg) {
    return typeof arg === 'string' || arg instanceof Array ? classList.concat(arg) : classList;
  }, []).filter(Boolean).join(' ');
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


module.exports = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : {};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(29);
var aFunction = __webpack_require__(82);
var SPECIES = __webpack_require__(52)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var processNextTick = __webpack_require__(555);
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(148);
util.inherits = __webpack_require__(87);
/*</replacement>*/

var Readable = __webpack_require__(2455);
var Writable = __webpack_require__(2458);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2517);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary-form-button.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary-form-button.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2549);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./new-badge.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./new-badge.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule invariant
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule joinClasses
 * @typechecks static-only
 */



/**
 * Combines multiple className strings into one.
 * http://jsperf.com/joinclasses-args-vs-array
 *
 * @param {...?string} className
 * @return {string}
 */

function joinClasses(className /*, ... */) {
  if (!className) {
    className = '';
  }
  var nextClass;
  var argLength = arguments.length;
  if (argLength > 1) {
    for (var ii = 1; ii < argLength; ii++) {
      nextClass = arguments[ii];
      if (nextClass) {
        className = (className ? className + ' ' : '') + nextClass;
      }
    }
  }
  return className;
}

module.exports = joinClasses;

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthError_js__ = __webpack_require__(112);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */
var ServerError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(ServerError, _super);
    function ServerError(errorCode, errorMessage, subError) {
        var _this = _super.call(this, errorCode, errorMessage, subError) || this;
        _this.name = "ServerError";
        Object.setPrototypeOf(_this, ServerError.prototype);
        return _this;
    }
    return ServerError;
}(__WEBPACK_IMPORTED_MODULE_1__AuthError_js__["a" /* AuthError */]));


//# sourceMappingURL=ServerError.js.map


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CcsCredentialType; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var CcsCredentialType;
(function (CcsCredentialType) {
    CcsCredentialType["HOME_ACCOUNT_ID"] = "home_account_id";
    CcsCredentialType["UPN"] = "UPN";
})(CcsCredentialType || (CcsCredentialType = {}));


//# sourceMappingURL=CcsCredential.js.map


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserConfigurationAuthError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BrowserConfigurationAuthErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */
var BrowserConfigurationAuthErrorMessage = {
    redirectUriNotSet: {
        code: "redirect_uri_empty",
        desc: "A redirect URI is required for all calls, and none has been set."
    },
    postLogoutUriNotSet: {
        code: "post_logout_uri_empty",
        desc: "A post logout redirect has not been set."
    },
    storageNotSupportedError: {
        code: "storage_not_supported",
        desc: "Given storage configuration option was not supported."
    },
    noRedirectCallbacksSet: {
        code: "no_redirect_callbacks",
        desc: "No redirect callbacks have been set. Please call setRedirectCallbacks() with the appropriate function arguments before continuing. " +
            "More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    invalidCallbackObject: {
        code: "invalid_callback_object",
        desc: "The object passed for the callback was invalid. " +
            "More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    stubPcaInstanceCalled: {
        code: "stubbed_public_client_application_called",
        desc: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors"
    },
    inMemRedirectUnavailable: {
        code: "in_mem_redirect_unavailable",
        desc: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
    },
    entropyNotProvided: {
        code: "entropy_not_provided",
        desc: "The available browser crypto interface requires entropy set via system.cryptoOptions.entropy configuration option."
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */
var BrowserConfigurationAuthError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(BrowserConfigurationAuthError, _super);
    function BrowserConfigurationAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(_this, BrowserConfigurationAuthError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when the redirect uri is empty (not set by caller)
     */
    BrowserConfigurationAuthError.createRedirectUriEmptyError = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.redirectUriNotSet.code, BrowserConfigurationAuthErrorMessage.redirectUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the post-logout redirect uri is empty (not set by caller)
     */
    BrowserConfigurationAuthError.createPostLogoutRedirectUriEmptyError = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.postLogoutUriNotSet.code, BrowserConfigurationAuthErrorMessage.postLogoutUriNotSet.desc);
    };
    /**
     * Creates error thrown when given storage location is not supported.
     * @param givenStorageLocation
     */
    BrowserConfigurationAuthError.createStorageNotSupportedError = function (givenStorageLocation) {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.storageNotSupportedError.code, BrowserConfigurationAuthErrorMessage.storageNotSupportedError.desc + " Given Location: " + givenStorageLocation);
    };
    /**
     * Creates error thrown when redirect callbacks are not set before calling loginRedirect() or acquireTokenRedirect().
     */
    BrowserConfigurationAuthError.createRedirectCallbacksNotSetError = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.noRedirectCallbacksSet.code, BrowserConfigurationAuthErrorMessage.noRedirectCallbacksSet.desc);
    };
    /**
     * Creates error thrown when the stub instance of PublicClientApplication is called.
     */
    BrowserConfigurationAuthError.createStubPcaInstanceCalledError = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.stubPcaInstanceCalled.code, BrowserConfigurationAuthErrorMessage.stubPcaInstanceCalled.desc);
    };
    /*
     * Create an error thrown when in-memory storage is used and storeAuthStateInCookie=false.
     */
    BrowserConfigurationAuthError.createInMemoryRedirectUnavailableError = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.inMemRedirectUnavailable.code, BrowserConfigurationAuthErrorMessage.inMemRedirectUnavailable.desc);
    };
    /**
     * Creates an error thrown when a crypto interface that requires entropy is initialized without entropy
     */
    BrowserConfigurationAuthError.createEntropyNotProvided = function () {
        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.entropyNotProvided.code, BrowserConfigurationAuthErrorMessage.entropyNotProvided.desc);
    };
    return BrowserConfigurationAuthError;
}(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */]));


//# sourceMappingURL=BrowserConfigurationAuthError.js.map


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return version; });
/*! @azure/msal-browser v2.38.3 2023-10-27 */

/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.38.3";


//# sourceMappingURL=packageMetadata.js.map


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NativeInteractionClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseInteractionClient_js__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_NativeAuthError_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SilentCacheClient_js__ = __webpack_require__(582);
/*! @azure/msal-browser v2.38.3 2023-10-27 */









/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var NativeInteractionClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(NativeInteractionClient, _super);
    function NativeInteractionClient(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId) {
        var _this = _super.call(this, config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId) || this;
        _this.apiId = apiId;
        _this.accountId = accountId;
        _this.nativeMessageHandler = provider;
        _this.nativeStorageManager = nativeStorageImpl;
        _this.silentCacheClient = new __WEBPACK_IMPORTED_MODULE_6__SilentCacheClient_js__["a" /* SilentCacheClient */](config, _this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        return _this;
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */
    NativeInteractionClient.prototype.acquireToken = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var nativeATMeasurement, reqTimestamp, nativeRequest, result, messageBody, response, validatedResponse;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.trace("NativeInteractionClient - acquireToken called.");
                        nativeATMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].NativeInteractionClientAcquireToken, request.correlationId);
                        reqTimestamp = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_1" /* TimeUtils */].nowSeconds();
                        return [4 /*yield*/, this.initializeNativeRequest(request)];
                    case 1:
                        nativeRequest = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.acquireTokensFromCache(this.accountId, nativeRequest)];
                    case 3:
                        result = _a.sent();
                        nativeATMeasurement.endMeasurement({
                            success: true,
                            isNativeBroker: false,
                            fromCache: true
                        });
                        return [2 /*return*/, result];
                    case 4:
                        _a.sent();
                        // continue with a native call for any and all errors
                        this.logger.info("MSAL internal Cache does not contain tokens, proceed to make a native call");
                        return [3 /*break*/, 5];
                    case 5:
                        messageBody = {
                            method: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["o" /* NativeExtensionMethod */].GetToken,
                            request: nativeRequest
                        };
                        return [4 /*yield*/, this.nativeMessageHandler.sendMessage(messageBody)];
                    case 6:
                        response = _a.sent();
                        validatedResponse = this.validateNativeResponse(response);
                        return [2 /*return*/, this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp)
                                .then(function (result) {
                                nativeATMeasurement.endMeasurement({
                                    success: true,
                                    isNativeBroker: true,
                                    requestId: result.requestId
                                });
                                return result;
                            })
                                .catch(function (error) {
                                nativeATMeasurement.endMeasurement({
                                    success: false,
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    isNativeBroker: true
                                });
                                throw error;
                            })];
                }
            });
        });
    };
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */
    NativeInteractionClient.prototype.createSilentCacheRequest = function (request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["R" /* ScopeSet */].fromString(request.scope).asArray(),
            account: cachedAccount,
            forceRefresh: false,
        };
    };
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */
    NativeInteractionClient.prototype.acquireTokensFromCache = function (nativeAccountId, request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var account, silentRequest, result, e_2;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nativeAccountId) {
                            this.logger.warning("NativeInteractionClient:acquireTokensFromCache - No nativeAccountId provided");
                            throw __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["r" /* ClientAuthError */].createNoAccountFoundError();
                        }
                        account = this.browserStorage.getAccountInfoFilteredBy({ nativeAccountId: nativeAccountId });
                        if (!account) {
                            throw __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["r" /* ClientAuthError */].createNoAccountFoundError();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        silentRequest = this.createSilentCacheRequest(request, account);
                        return [4 /*yield*/, this.silentCacheClient.acquireToken(silentRequest)];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 3:
                        e_2 = _a.sent();
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param request
     */
    NativeInteractionClient.prototype.acquireTokenRedirect = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var nativeRequest, messageBody, response, e_3, navigationOptions, redirectUri;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.trace("NativeInteractionClient - acquireTokenRedirect called.");
                        return [4 /*yield*/, this.initializeNativeRequest(request)];
                    case 1:
                        nativeRequest = _a.sent();
                        messageBody = {
                            method: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["o" /* NativeExtensionMethod */].GetToken,
                            request: nativeRequest
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.nativeMessageHandler.sendMessage(messageBody)];
                    case 3:
                        response = _a.sent();
                        this.validateNativeResponse(response);
                        return [3 /*break*/, 5];
                    case 4:
                        e_3 = _a.sent();
                        // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
                        if (e_3 instanceof __WEBPACK_IMPORTED_MODULE_4__error_NativeAuthError_js__["a" /* NativeAuthError */] && e_3.isFatal()) {
                            throw e_3;
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        this.browserStorage.setTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
                        navigationOptions = {
                            apiId: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenRedirect,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        redirectUri = this.config.auth.navigateToLoginRequestUrl ? window.location.href : this.getRedirectUri(request.redirectUri);
                        return [4 /*yield*/, this.navigationClient.navigateExternal(redirectUri, navigationOptions)];
                    case 6:
                        _a.sent(); // Need to treat this as external to ensure handleRedirectPromise is run again
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     */
    NativeInteractionClient.prototype.handleRedirectPromise = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var cachedRequest, prompt, request, messageBody, reqTimestamp, response, result, e_4;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.trace("NativeInteractionClient - handleRedirectPromise called.");
                        if (!this.browserStorage.isInteractionInProgress(true)) {
                            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
                            return [2 /*return*/, null];
                        }
                        cachedRequest = this.browserStorage.getCachedNativeRequest();
                        if (!cachedRequest) {
                            this.logger.verbose("NativeInteractionClient - handleRedirectPromise called but there is no cached request, returning null.");
                            return [2 /*return*/, null];
                        }
                        prompt = cachedRequest.prompt, request = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["e" /* __rest */])(cachedRequest, ["prompt"]);
                        if (prompt) {
                            this.logger.verbose("NativeInteractionClient - handleRedirectPromise called and prompt was included in the original request, removing prompt from cached request to prevent second interaction with native broker window.");
                        }
                        this.browserStorage.removeItem(this.browserStorage.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].NATIVE_REQUEST));
                        messageBody = {
                            method: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["o" /* NativeExtensionMethod */].GetToken,
                            request: request
                        };
                        reqTimestamp = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_1" /* TimeUtils */].nowSeconds();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.logger.verbose("NativeInteractionClient - handleRedirectPromise sending message to native broker.");
                        return [4 /*yield*/, this.nativeMessageHandler.sendMessage(messageBody)];
                    case 2:
                        response = _a.sent();
                        this.validateNativeResponse(response);
                        result = this.handleNativeResponse(response, request, reqTimestamp);
                        this.browserStorage.setInteractionInProgress(false);
                        return [2 /*return*/, result];
                    case 3:
                        e_4 = _a.sent();
                        this.browserStorage.setInteractionInProgress(false);
                        throw e_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Logout from native platform via browser extension
     * @param request
     */
    NativeInteractionClient.prototype.logout = function () {
        this.logger.trace("NativeInteractionClient - logout called.");
        return Promise.reject("Logout not implemented yet");
    };
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */
    NativeInteractionClient.prototype.handleNativeResponse = function (response, request, reqTimestamp) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var authority, authorityPreferredCache, idTokenObj, homeAccountIdentifier, accountEntity, result;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.trace("NativeInteractionClient - handleNativeResponse called.");
                        if (response.account.id !== request.accountId) {
                            // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
                            throw __WEBPACK_IMPORTED_MODULE_4__error_NativeAuthError_js__["a" /* NativeAuthError */].createUserSwitchError();
                        }
                        return [4 /*yield*/, this.getDiscoveredAuthority(request.authority)];
                    case 1:
                        authority = _a.sent();
                        authorityPreferredCache = authority.getPreferredCache();
                        idTokenObj = this.createIdTokenObj(response);
                        homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenObj);
                        accountEntity = this.createAccountEntity(response, homeAccountIdentifier, idTokenObj, authorityPreferredCache);
                        return [4 /*yield*/, this.generateAuthenticationResult(response, request, idTokenObj, accountEntity, authority.canonicalAuthority, reqTimestamp)];
                    case 2:
                        result = _a.sent();
                        // cache accounts and tokens in the appropriate storage
                        this.cacheAccount(accountEntity);
                        this.cacheNativeTokens(response, request, homeAccountIdentifier, accountEntity, idTokenObj, result.accessToken, result.tenantId, reqTimestamp);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Create an idToken Object (not entity)
     * @param response
     * @returns
     */
    NativeInteractionClient.prototype.createIdTokenObj = function (response) {
        return new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["f" /* AuthToken */](response.id_token || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING, this.browserCrypto);
    };
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */
    NativeInteractionClient.prototype.createHomeAccountIdentifier = function (response, idTokenObj) {
        // Save account in browser storage
        var homeAccountIdentifier = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["b" /* AccountEntity */].generateHomeAccountId(response.client_info || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["l" /* AuthorityType */].Default, this.logger, this.browserCrypto, idTokenObj);
        return homeAccountIdentifier;
    };
    /**
     * Creates account entity
     * @param response
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param authority
     * @returns
     */
    NativeInteractionClient.prototype.createAccountEntity = function (response, homeAccountIdentifier, idTokenObj, authority) {
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["b" /* AccountEntity */].createAccount(response.client_info, homeAccountIdentifier, idTokenObj, undefined, undefined, undefined, authority, response.account.id);
    };
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */
    NativeInteractionClient.prototype.generateScopes = function (response, request) {
        return response.scope ? __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["R" /* ScopeSet */].fromString(response.scope) : __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["R" /* ScopeSet */].fromString(request.scope);
    };
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */
    NativeInteractionClient.prototype.generatePopAccessToken = function (response, request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var popTokenGenerator, shrParameters;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(request.tokenType === __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["h" /* AuthenticationScheme */].POP)) return [3 /*break*/, 2];
                        /**
                         * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
                         * is still received, SHR is calculated locally
                         */
                        // Check if native layer returned an SHR token
                        if (response.shr) {
                            this.logger.trace("handleNativeServerResponse: SHR is enabled in native layer");
                            return [2 /*return*/, response.shr];
                        }
                        popTokenGenerator = new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["K" /* PopTokenGenerator */](this.browserCrypto);
                        shrParameters = {
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            shrNonce: request.shrNonce
                        };
                        /**
                         * KeyID must be present in the native request from when the PoP key was generated in order for
                         * PopTokenGenerator to query the full key for signing
                         */
                        if (!request.keyId) {
                            throw __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["r" /* ClientAuthError */].createKeyIdMissingError();
                        }
                        return [4 /*yield*/, popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, response.access_token];
                }
            });
        });
    };
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */
    NativeInteractionClient.prototype.generateAuthenticationResult = function (response, request, idTokenObj, accountEntity, authority, reqTimestamp) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var mats, responseScopes, accountProperties, uid, tid, responseAccessToken, tokenType, result;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mats = this.addTelemetryFromNativeResponse(response);
                        responseScopes = response.scope ? __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["R" /* ScopeSet */].fromString(response.scope) : __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["R" /* ScopeSet */].fromString(request.scope);
                        accountProperties = response.account.properties || {};
                        uid = accountProperties["UID"] || idTokenObj.claims.oid || idTokenObj.claims.sub || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                        tid = accountProperties["TenantId"] || idTokenObj.claims.tid || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                        return [4 /*yield*/, this.generatePopAccessToken(response, request)];
                    case 1:
                        responseAccessToken = _a.sent();
                        tokenType = (request.tokenType === __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["h" /* AuthenticationScheme */].POP) ? __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["h" /* AuthenticationScheme */].POP : __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["h" /* AuthenticationScheme */].BEARER;
                        result = {
                            authority: authority,
                            uniqueId: uid,
                            tenantId: tid,
                            scopes: responseScopes.asArray(),
                            account: accountEntity.getAccountInfo(),
                            idToken: response.id_token,
                            idTokenClaims: idTokenObj.claims,
                            accessToken: responseAccessToken,
                            fromCache: mats ? this.isResponseFromCache(mats) : false,
                            expiresOn: new Date(Number(reqTimestamp + response.expires_in) * 1000),
                            tokenType: tokenType,
                            correlationId: this.correlationId,
                            state: response.state,
                            fromNativeBroker: true
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */
    NativeInteractionClient.prototype.cacheAccount = function (accountEntity) {
        var _this = this;
        // Store the account info and hence `nativeAccountId` in browser cache
        this.browserStorage.setAccount(accountEntity);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext(accountEntity).catch(function (e) {
            _this.logger.error("Error occurred while removing account context from browser storage. " + e);
        });
    };
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */
    NativeInteractionClient.prototype.cacheNativeTokens = function (response, request, homeAccountIdentifier, accountEntity, idTokenObj, responseAccessToken, tenantId, reqTimestamp) {
        var cachedIdToken = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["A" /* IdTokenEntity */].createIdTokenEntity(homeAccountIdentifier, request.authority, response.id_token || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING, request.clientId, idTokenObj.claims.tid || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING);
        // cache accessToken in inmemory storage
        var expiresIn = (request.tokenType === __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["h" /* AuthenticationScheme */].POP)
            ? __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].SHR_NONCE_VALIDITY
            : (typeof response.expires_in === "string"
                ? parseInt(response.expires_in, 10)
                : response.expires_in) || 0;
        var tokenExpirationSeconds = reqTimestamp + expiresIn;
        var responseScopes = this.generateScopes(response, request);
        var cachedAccessToken = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["a" /* AccessTokenEntity */].createAccessTokenEntity(homeAccountIdentifier, request.authority, responseAccessToken, request.clientId, idTokenObj
            ? idTokenObj.claims.tid || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING
            : tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, this.browserCrypto);
        var nativeCacheRecord = new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["p" /* CacheRecord */](accountEntity, cachedIdToken, cachedAccessToken);
        this.nativeStorageManager.saveCacheRecord(nativeCacheRecord);
    };
    NativeInteractionClient.prototype.addTelemetryFromNativeResponse = function (response) {
        var mats = this.getMATSFromResponse(response);
        if (!mats) {
            return null;
        }
        this.performanceClient.addStaticFields({
            extensionId: this.nativeMessageHandler.getExtensionId(),
            extensionVersion: this.nativeMessageHandler.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    };
    /**
     * Validates native platform response before processing
     * @param response
     */
    NativeInteractionClient.prototype.validateNativeResponse = function (response) {
        if (response.hasOwnProperty("access_token") &&
            response.hasOwnProperty("id_token") &&
            response.hasOwnProperty("client_info") &&
            response.hasOwnProperty("account") &&
            response.hasOwnProperty("scope") &&
            response.hasOwnProperty("expires_in")) {
            return response;
        }
        else {
            throw __WEBPACK_IMPORTED_MODULE_4__error_NativeAuthError_js__["a" /* NativeAuthError */].createUnexpectedError("Response missing expected properties.");
        }
    };
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */
    NativeInteractionClient.prototype.getMATSFromResponse = function (response) {
        if (response.properties.MATS) {
            try {
                return JSON.parse(response.properties.MATS);
            }
            catch (e) {
                this.logger.error("NativeInteractionClient - Error parsing MATS telemetry, returning null instead");
            }
        }
        return null;
    };
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */
    NativeInteractionClient.prototype.isResponseFromCache = function (mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("NativeInteractionClient - MATS telemetry does not contain field indicating if response was served from cache. Returning false.");
            return false;
        }
        return !!mats.is_cached;
    };
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */
    NativeInteractionClient.prototype.initializeNativeRequest = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var authority, canonicalAuthority, scopes, remainingProperties, scopeSet, getPrompt, validatedRequest, shrParameters, popTokenGenerator, reqCnfData;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.trace("NativeInteractionClient - initializeNativeRequest called");
                        authority = request.authority || this.config.auth.authority;
                        if (!request.account) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validateRequestAuthority(authority, request.account)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        canonicalAuthority = new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */](authority);
                        canonicalAuthority.validateAsUri();
                        scopes = request.scopes, remainingProperties = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["e" /* __rest */])(request, ["scopes"]);
                        scopeSet = new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["R" /* ScopeSet */](scopes || []);
                        scopeSet.appendScopes(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["G" /* OIDC_DEFAULT_SCOPES */]);
                        getPrompt = function () {
                            // If request is silent, prompt is always none
                            switch (_this.apiId) {
                                case __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].ssoSilent:
                                case __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenSilent_silentFlow:
                                    _this.logger.trace("initializeNativeRequest: silent request sets prompt to none");
                                    return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["L" /* PromptValue */].NONE;
                            }
                            // Prompt not provided, request may proceed and native broker decides if it needs to prompt
                            if (!request.prompt) {
                                _this.logger.trace("initializeNativeRequest: prompt was not provided");
                                return undefined;
                            }
                            // If request is interactive, check if prompt provided is allowed to go directly to native broker
                            switch (request.prompt) {
                                case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["L" /* PromptValue */].NONE:
                                case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["L" /* PromptValue */].CONSENT:
                                case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["L" /* PromptValue */].LOGIN:
                                    _this.logger.trace("initializeNativeRequest: prompt is compatible with native flow");
                                    return request.prompt;
                                default:
                                    _this.logger.trace("initializeNativeRequest: prompt = " + request.prompt + " is not compatible with native flow");
                                    throw __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNativePromptParameterNotSupportedError();
                            }
                        };
                        validatedRequest = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, remainingProperties), { accountId: this.accountId, clientId: this.config.auth.clientId, authority: canonicalAuthority.urlString, scope: scopeSet.printScopes(), redirectUri: this.getRedirectUri(request.redirectUri), prompt: getPrompt(), correlationId: this.correlationId, tokenType: request.authenticationScheme, windowTitleSubstring: document.title, extraParameters: Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request.extraQueryParameters), request.tokenQueryParameters), { telemetry: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["n" /* NativeConstants */].MATS_TELEMETRY }), extendedExpiryToken: false // Make this configurable?
                         });
                        if (!(request.authenticationScheme === __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["h" /* AuthenticationScheme */].POP)) return [3 /*break*/, 4];
                        shrParameters = {
                            resourceRequestUri: request.resourceRequestUri,
                            resourceRequestMethod: request.resourceRequestMethod,
                            shrClaims: request.shrClaims,
                            shrNonce: request.shrNonce
                        };
                        popTokenGenerator = new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["K" /* PopTokenGenerator */](this.browserCrypto);
                        return [4 /*yield*/, popTokenGenerator.generateCnf(shrParameters)];
                    case 3:
                        reqCnfData = _a.sent();
                        // to reduce the URL length, it is recommended to send the short form of the req_cnf 
                        validatedRequest.reqCnf = reqCnfData.reqCnfString;
                        validatedRequest.keyId = reqCnfData.kid;
                        _a.label = 4;
                    case 4: return [2 /*return*/, validatedRequest];
                }
            });
        });
    };
    return NativeInteractionClient;
}(__WEBPACK_IMPORTED_MODULE_2__BaseInteractionClient_js__["a" /* BaseInteractionClient */]));


//# sourceMappingURL=NativeInteractionClient.js.map


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NativeAuthError; });
/* unused harmony export NativeAuthErrorMessage */
/* unused harmony export NativeStatusCode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BrowserAuthError_js__ = __webpack_require__(49);
/*! @azure/msal-browser v2.38.3 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var NativeStatusCode;
(function (NativeStatusCode) {
    NativeStatusCode["USER_INTERACTION_REQUIRED"] = "USER_INTERACTION_REQUIRED";
    NativeStatusCode["USER_CANCEL"] = "USER_CANCEL";
    NativeStatusCode["NO_NETWORK"] = "NO_NETWORK";
    NativeStatusCode["TRANSIENT_ERROR"] = "TRANSIENT_ERROR";
    NativeStatusCode["PERSISTENT_ERROR"] = "PERSISTENT_ERROR";
    NativeStatusCode["DISABLED"] = "DISABLED";
    NativeStatusCode["ACCOUNT_UNAVAILABLE"] = "ACCOUNT_UNAVAILABLE";
})(NativeStatusCode || (NativeStatusCode = {}));
var NativeAuthErrorMessage = {
    extensionError: {
        code: "ContentError"
    },
    userSwitch: {
        code: "user_switch",
        desc: "User attempted to switch accounts in the native broker, which is not allowed. All new accounts must sign-in through the standard web flow first, please try again."
    },
    tokensNotFoundInCache: {
        code: "tokens_not_found_in_internal_memory_cache",
        desc: "Tokens not cached in MSAL JS internal memory, please make the WAM request"
    }
};
var NativeAuthError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(NativeAuthError, _super);
    function NativeAuthError(errorCode, description, ext) {
        var _this = _super.call(this, errorCode, description) || this;
        Object.setPrototypeOf(_this, NativeAuthError.prototype);
        _this.name = "NativeAuthError";
        _this.ext = ext;
        return _this;
    }
    /**
     * These errors should result in a fallback to the 'standard' browser based auth flow.
     */
    NativeAuthError.prototype.isFatal = function () {
        if (this.ext && this.ext.status && (this.ext.status === NativeStatusCode.PERSISTENT_ERROR || this.ext.status === NativeStatusCode.DISABLED)) {
            return true;
        }
        switch (this.errorCode) {
            case NativeAuthErrorMessage.extensionError.code:
                return true;
            default:
                return false;
        }
    };
    /**
     * Create the appropriate error object based on the WAM status code.
     * @param code
     * @param description
     * @param ext
     * @returns
     */
    NativeAuthError.createError = function (code, description, ext) {
        if (ext && ext.status) {
            switch (ext.status) {
                case NativeStatusCode.ACCOUNT_UNAVAILABLE:
                    return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["B" /* InteractionRequiredAuthError */].createNativeAccountUnavailableError();
                case NativeStatusCode.USER_INTERACTION_REQUIRED:
                    return new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["B" /* InteractionRequiredAuthError */](code, description);
                case NativeStatusCode.USER_CANCEL:
                    return __WEBPACK_IMPORTED_MODULE_2__BrowserAuthError_js__["a" /* BrowserAuthError */].createUserCancelledError();
                case NativeStatusCode.NO_NETWORK:
                    return __WEBPACK_IMPORTED_MODULE_2__BrowserAuthError_js__["a" /* BrowserAuthError */].createNoNetworkConnectivityError();
            }
        }
        return new NativeAuthError(code, description, ext);
    };
    /**
     * Creates user switch error when the user chooses a different account in the native broker prompt
     * @returns
     */
    NativeAuthError.createUserSwitchError = function () {
        return new NativeAuthError(NativeAuthErrorMessage.userSwitch.code, NativeAuthErrorMessage.userSwitch.desc);
    };
    /**
     * Creates a tokens not found error when the internal cache look up fails
     * @returns NativeAuthError: tokensNotFoundInCache
     */
    NativeAuthError.createTokensNotFoundInCacheError = function () {
        return new NativeAuthError(NativeAuthErrorMessage.tokensNotFoundInCache.code, NativeAuthErrorMessage.tokensNotFoundInCache.desc);
    };
    return NativeAuthError;
}(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */]));


//# sourceMappingURL=NativeAuthError.js.map


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserStringUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__ = __webpack_require__(31);
/*! @azure/msal-browser v2.38.3 2023-10-27 */



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Utility functions for strings in a browser. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */
var BrowserStringUtils = /** @class */ (function () {
    function BrowserStringUtils() {
    }
    /**
     * Converts string to Uint8Array
     * @param sDOMStr
     */
    BrowserStringUtils.stringToUtf8Arr = function (sDOMStr) {
        var nChr;
        var nArrLen = 0;
        var nStrLen = sDOMStr.length;
        /* mapping... */
        for (var nMapIdx = 0; nMapIdx < nStrLen; nMapIdx++) {
            nChr = sDOMStr.charCodeAt(nMapIdx);
            nArrLen += nChr < 0x80 ? 1 : nChr < 0x800 ? 2 : nChr < 0x10000 ? 3 : nChr < 0x200000 ? 4 : nChr < 0x4000000 ? 5 : 6;
        }
        var aBytes = new Uint8Array(nArrLen);
        /* transcription... */
        for (var nIdx = 0, nChrIdx = 0; nIdx < nArrLen; nChrIdx++) {
            nChr = sDOMStr.charCodeAt(nChrIdx);
            if (nChr < 128) {
                /* one byte */
                aBytes[nIdx++] = nChr;
            }
            else if (nChr < 0x800) {
                /* two bytes */
                aBytes[nIdx++] = 192 + (nChr >>> 6);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
            else if (nChr < 0x10000) {
                /* three bytes */
                aBytes[nIdx++] = 224 + (nChr >>> 12);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
            else if (nChr < 0x200000) {
                /* four bytes */
                aBytes[nIdx++] = 240 + (nChr >>> 18);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
            else if (nChr < 0x4000000) {
                /* five bytes */
                aBytes[nIdx++] = 248 + (nChr >>> 24);
                aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
            else /* if (nChr <= 0x7fffffff) */ {
                /* six bytes */
                aBytes[nIdx++] = 252 + (nChr >>> 30);
                aBytes[nIdx++] = 128 + (nChr >>> 24 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
        }
        return aBytes;
    };
    /**
     * Converst string to ArrayBuffer
     * @param dataString
     */
    BrowserStringUtils.stringToArrayBuffer = function (dataString) {
        var data = new ArrayBuffer(dataString.length);
        var dataView = new Uint8Array(data);
        for (var i = 0; i < dataString.length; i++) {
            dataView[i] = dataString.charCodeAt(i);
        }
        return data;
    };
    /**
     * Converts Uint8Array to a string
     * @param aBytes
     */
    BrowserStringUtils.utf8ArrToString = function (aBytes) {
        var sView = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
        for (var nPart = void 0, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++) {
            nPart = aBytes[nIdx];
            sView += String.fromCharCode(nPart > 251 && nPart < 254 && nIdx + 5 < nLen ? /* six bytes */
                /* (nPart - 252 << 30) may be not so safe in ECMAScript! So...: */
                (nPart - 252) * 1073741824 + (aBytes[++nIdx] - 128 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                : nPart > 247 && nPart < 252 && nIdx + 4 < nLen ? /* five bytes */
                    (nPart - 248 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                    : nPart > 239 && nPart < 248 && nIdx + 3 < nLen ? /* four bytes */
                        (nPart - 240 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                        : nPart > 223 && nPart < 240 && nIdx + 2 < nLen ? /* three bytes */
                            (nPart - 224 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
                            : nPart > 191 && nPart < 224 && nIdx + 1 < nLen ? /* two bytes */
                                (nPart - 192 << 6) + aBytes[++nIdx] - 128
                                : /* nPart < 127 ? */ /* one byte */
                                    nPart);
        }
        return sView;
    };
    /**
     * Returns stringified jwk.
     * @param jwk
     */
    BrowserStringUtils.getSortedObjectString = function (obj) {
        return JSON.stringify(obj, Object.keys(obj).sort());
    };
    return BrowserStringUtils;
}());


//# sourceMappingURL=BrowserStringUtils.js.map


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(29);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = makeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["h"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["f"] = pushPath;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = deepExtend;
/* harmony export (immutable) */ __webpack_exports__["g"] = regexEscape;
/* harmony export (immutable) */ __webpack_exports__["c"] = escape;
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 308 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1294),
    isObjectLike = __webpack_require__(117);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(105),
    stubFalse = __webpack_require__(1295);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(312),
    stackClear = __webpack_require__(1308),
    stackDelete = __webpack_require__(1309),
    stackGet = __webpack_require__(1310),
    stackHas = __webpack_require__(1311),
    stackSet = __webpack_require__(1312);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1303),
    listCacheDelete = __webpack_require__(1304),
    listCacheGet = __webpack_require__(1305),
    listCacheHas = __webpack_require__(1306),
    listCacheSet = __webpack_require__(1307);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(249);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(175);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1321);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1331),
    Map = __webpack_require__(431),
    Promise = __webpack_require__(1332),
    Set = __webpack_require__(766),
    WeakMap = __webpack_require__(1333),
    baseGetTag = __webpack_require__(174),
    toSource = __webpack_require__(750);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(219);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1347);
exports.encode = exports.stringify = __webpack_require__(1348);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(68);

function populateMethod(req) {
  req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
}

function generateURI(endpointPath, operationPath, input, params) {
  var uri = [endpointPath, operationPath].join('/');
  uri = uri.replace(/\/+/g, '/');

  var queryString = {}, queryStringSet = false;
  util.each(input.members, function (name, member) {
    var paramValue = params[name];
    if (paramValue === null || paramValue === undefined) return;
    if (member.location === 'uri') {
      var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
      uri = uri.replace(regex, function(_, plus) {
        var fn = plus ? util.uriEscapePath : util.uriEscape;
        return fn(String(paramValue));
      });
    } else if (member.location === 'querystring') {
      queryStringSet = true;

      if (member.type === 'list') {
        queryString[member.name] = paramValue.map(function(val) {
          return util.uriEscape(String(val));
        });
      } else if (member.type === 'map') {
        util.each(paramValue, function(key, value) {
          if (Array.isArray(value)) {
            queryString[key] = value.map(function(val) {
              return util.uriEscape(String(val));
            });
          } else {
            queryString[key] = util.uriEscape(String(value));
          }
        });
      } else {
        queryString[member.name] = util.uriEscape(String(paramValue));
      }
    }
  });

  if (queryStringSet) {
    uri += (uri.indexOf('?') >= 0 ? '&' : '?');
    var parts = [];
    util.arrayEach(Object.keys(queryString).sort(), function(key) {
      if (!Array.isArray(queryString[key])) {
        queryString[key] = [queryString[key]];
      }
      for (var i = 0; i < queryString[key].length; i++) {
        parts.push(util.uriEscape(String(key)) + '=' + queryString[key][i]);
      }
    });
    uri += parts.join('&');
  }

  return uri;
}

function populateURI(req) {
  var operation = req.service.api.operations[req.operation];
  var input = operation.input;

  var uri = generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
  req.httpRequest.path = uri;
}

function populateHeaders(req) {
  var operation = req.service.api.operations[req.operation];
  util.each(operation.input.members, function (name, member) {
    var value = req.params[name];
    if (value === null || value === undefined) return;

    if (member.location === 'headers' && member.type === 'map') {
      util.each(value, function(key, memberValue) {
        req.httpRequest.headers[member.name + key] = memberValue;
      });
    } else if (member.location === 'header') {
      value = member.toWireFormat(value).toString();
      if (member.isJsonValue) {
        value = util.base64.encode(value);
      }
      req.httpRequest.headers[member.name] = value;
    }
  });
}

function buildRequest(req) {
  populateMethod(req);
  populateURI(req);
  populateHeaders(req);
}

function extractError() {
}

function extractData(resp) {
  var req = resp.request;
  var data = {};
  var r = resp.httpResponse;
  var operation = req.service.api.operations[req.operation];
  var output = operation.output;

  // normalize headers names to lower-cased keys for matching
  var headers = {};
  util.each(r.headers, function (k, v) {
    headers[k.toLowerCase()] = v;
  });

  util.each(output.members, function(name, member) {
    var header = (member.name || name).toLowerCase();
    if (member.location === 'headers' && member.type === 'map') {
      data[name] = {};
      var location = member.isLocationName ? member.name : '';
      var pattern = new RegExp('^' + location + '(.+)', 'i');
      util.each(r.headers, function (k, v) {
        var result = k.match(pattern);
        if (result !== null) {
          data[name][result[1]] = v;
        }
      });
    } else if (member.location === 'header') {
      if (headers[header] !== undefined) {
        var value = member.isJsonValue ?
          util.base64.decode(headers[header]) :
          headers[header];
        data[name] = member.toType(value);
      }
    } else if (member.location === 'statusCode') {
      data[name] = parseInt(r.statusCode, 10);
    }
  });

  resp.data = data;
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData,
  generateURI: generateURI
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(254),
    isObject = __webpack_require__(119);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(140);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1398),
    listCacheDelete = __webpack_require__(1399),
    listCacheGet = __webpack_require__(1400),
    listCacheHas = __webpack_require__(1401),
    listCacheSet = __webpack_require__(1402);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(324);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(176);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1416);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(453);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_COMMENT_FAILED = exports.DELETE_COMMENT_COMPLETED = exports.DELETE_COMMENT_REQUESTED = exports.DELETE_COMMENT = exports.PUT_COMMENT_FAILED = exports.PUT_COMMENT_COMPLETED = exports.PUT_COMMENT_REQUESTED = exports.PUT_COMMENT = exports.POST_COMMENT_FAILED = exports.POST_COMMENT_COMPLETED = exports.POST_COMMENT_REQUESTED = exports.POST_COMMENT = undefined;
exports.postCommentRequested = postCommentRequested;
exports.postComment = postComment;
exports.postCommentCompleted = postCommentCompleted;
exports.postCommentFailed = postCommentFailed;
exports.putCommentRequested = putCommentRequested;
exports.putComment = putComment;
exports.putCommentCompleted = putCommentCompleted;
exports.putCommentFailed = putCommentFailed;
exports.deleteCommentRequested = deleteCommentRequested;
exports.deleteComment = deleteComment;
exports.deleteCommentCompleted = deleteCommentCompleted;
exports.deleteCommentFailed = deleteCommentFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/actions/comments.js

var POST_COMMENT = exports.POST_COMMENT = "POST_COMMENT";
var POST_COMMENT_REQUESTED = exports.POST_COMMENT_REQUESTED = "POST_COMMENT_REQUESTED";
var POST_COMMENT_COMPLETED = exports.POST_COMMENT_COMPLETED = "POST_COMMENT_COMPLETED";
var POST_COMMENT_FAILED = exports.POST_COMMENT_FAILED = "POST_COMMENT_FAILED";

function postCommentRequested() {
  return {
    type: POST_COMMENT_REQUESTED
  };
}

function postComment(type, id, comment, upload_files, upload_videos, mentions, reply_requested) {
  return function (dispatch) {
    var _api$post;

    dispatch(postCommentRequested());
    return _gambaApi2.default.post('/comments', (_api$post = {}, _defineProperty(_api$post, type, id), _defineProperty(_api$post, 'comment', comment), _defineProperty(_api$post, 'upload_files', upload_files), _defineProperty(_api$post, 'upload_videos', upload_videos), _defineProperty(_api$post, 'mentions', mentions), _defineProperty(_api$post, 'reply_requested', reply_requested), _api$post)).then(function (results) {
      dispatch(postCommentCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(postCommentFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function postCommentCompleted(results) {
  return {
    type: POST_COMMENT_COMPLETED,
    results: results
  };
}

function postCommentFailed(error) {
  return {
    type: POST_COMMENT_FAILED,
    error: error
  };
}

var PUT_COMMENT = exports.PUT_COMMENT = "PUT_COMMENT";
var PUT_COMMENT_REQUESTED = exports.PUT_COMMENT_REQUESTED = "PUT_COMMENT_REQUESTED";
var PUT_COMMENT_COMPLETED = exports.PUT_COMMENT_COMPLETED = "PUT_COMMENT_COMPLETED";
var PUT_COMMENT_FAILED = exports.PUT_COMMENT_FAILED = "PUT_COMMENT_FAILED";

function putCommentRequested() {
  return {
    type: PUT_COMMENT_REQUESTED
  };
}

function putComment(comment_id, comment, upload_files, upload_videos, mentions, reply_requested) {
  return function (dispatch) {
    dispatch(putCommentRequested());
    return _gambaApi2.default.put('/comments/' + comment_id, { comment: comment, upload_files: upload_files, upload_videos: upload_videos, mentions: mentions, reply_requested: reply_requested }).then(function (results) {
      dispatch(putCommentCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(putCommentFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function putCommentCompleted(results) {
  return {
    type: PUT_COMMENT_COMPLETED,
    results: results
  };
}

function putCommentFailed(error) {
  return {
    type: PUT_COMMENT_FAILED,
    error: error
  };
}

var DELETE_COMMENT = exports.DELETE_COMMENT = "DELETE_COMMENT";
var DELETE_COMMENT_REQUESTED = exports.DELETE_COMMENT_REQUESTED = "DELETE_COMMENT_REQUESTED";
var DELETE_COMMENT_COMPLETED = exports.DELETE_COMMENT_COMPLETED = "DELETE_COMMENT_COMPLETED";
var DELETE_COMMENT_FAILED = exports.DELETE_COMMENT_FAILED = "DELETE_COMMENT_FAILED";

function deleteCommentRequested() {
  return {
    type: DELETE_COMMENT_REQUESTED
  };
}

function deleteComment(comment_id) {
  return function (dispatch) {
    dispatch(deleteCommentRequested());
    return _gambaApi2.default.delete('/comments/' + comment_id).then(function (results) {
      dispatch(deleteCommentCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deleteCommentFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteCommentCompleted(results) {
  return {
    type: DELETE_COMMENT_COMPLETED,
    results: results
  };
}

function deleteCommentFailed(error) {
  return {
    type: DELETE_COMMENT_FAILED,
    error: error
  };
}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_LIKE_CONFIG_FAILED = exports.FETCH_LIKE_CONFIG_COMPLETED = exports.FETCH_LIKE_CONFIG_REQUESTED = exports.FETCH_LIKE_CONFIG = exports.DELETE_LIKE_FAILED = exports.DELETE_LIKE_COMPLETED = exports.DELETE_LIKE_REQUESTED = exports.DELETE_LIKE = exports.LIKE_COMMENT_FAILED = exports.LIKE_COMMENT_COMPLETED = exports.LIKE_COMMENT_REQUESTED = exports.LIKE_COMMENT = exports.LIKE_DIARY_FAILED = exports.LIKE_DIARY_COMPLETED = exports.LIKE_DIARY_REQUESTED = exports.LIKE_DIARY = undefined;
exports.likeDiaryRequested = likeDiaryRequested;
exports.likeDiary = likeDiary;
exports.likeDiaryCompleted = likeDiaryCompleted;
exports.likeDiaryFailed = likeDiaryFailed;
exports.likeCommentRequested = likeCommentRequested;
exports.likeComment = likeComment;
exports.likeCommentCompleted = likeCommentCompleted;
exports.likeCommentFailed = likeCommentFailed;
exports.deleteLikeRequested = deleteLikeRequested;
exports.deleteLike = deleteLike;
exports.deleteLikeCompleted = deleteLikeCompleted;
exports.deleteLikeFailed = deleteLikeFailed;
exports.fetchLikeConfigRequested = fetchLikeConfigRequested;
exports.fetchLikeConfig = fetchLikeConfig;
exports.fetchLikeConfigCompleted = fetchLikeConfigCompleted;
exports.fetchLikeConfigFailed = fetchLikeConfigFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/likes.js

var LIKE_DIARY = exports.LIKE_DIARY = "LIKE_DIARY";
var LIKE_DIARY_REQUESTED = exports.LIKE_DIARY_REQUESTED = "LIKE_DIARY_REQUESTED";
var LIKE_DIARY_COMPLETED = exports.LIKE_DIARY_COMPLETED = "LIKE_DIARY_COMPLETED";
var LIKE_DIARY_FAILED = exports.LIKE_DIARY_FAILED = "LIKE_DIARY_FAILED";

function likeDiaryRequested() {
  return {
    type: LIKE_DIARY_REQUESTED
  };
}

function likeDiary(diary_id, like_type) {
  return function (dispatch) {
    dispatch(likeDiaryRequested());
    return _gambaApi2.default.post('/likes', { diary_id: diary_id, like_type: like_type }).then(function (results) {
      dispatch(likeDiaryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(likeDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function likeDiaryCompleted(results) {
  return {
    type: LIKE_DIARY_COMPLETED,
    results: results
  };
}

function likeDiaryFailed(error) {
  return {
    type: LIKE_DIARY_FAILED,
    error: error
  };
}

var LIKE_COMMENT = exports.LIKE_COMMENT = "LIKE_COMMENT";
var LIKE_COMMENT_REQUESTED = exports.LIKE_COMMENT_REQUESTED = "LIKE_COMMENT_REQUESTED";
var LIKE_COMMENT_COMPLETED = exports.LIKE_COMMENT_COMPLETED = "LIKE_COMMENT_COMPLETED";
var LIKE_COMMENT_FAILED = exports.LIKE_COMMENT_FAILED = "LIKE_COMMENT_FAILED";

function likeCommentRequested() {
  return {
    type: LIKE_COMMENT_REQUESTED
  };
}

function likeComment(comment_id, like_type) {
  return function (dispatch) {
    dispatch(likeCommentRequested());
    return _gambaApi2.default.post('/likes', { comment_id: comment_id, like_type: like_type }).then(function (results) {
      dispatch(likeCommentCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(likeCommentFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function likeCommentCompleted(results) {
  return {
    type: LIKE_COMMENT_COMPLETED,
    results: results
  };
}

function likeCommentFailed(error) {
  return {
    type: LIKE_COMMENT_FAILED,
    error: error
  };
}

var DELETE_LIKE = exports.DELETE_LIKE = "DELETE_LIKE";
var DELETE_LIKE_REQUESTED = exports.DELETE_LIKE_REQUESTED = "DELETE_LIKE_REQUESTED";
var DELETE_LIKE_COMPLETED = exports.DELETE_LIKE_COMPLETED = "DELETE_LIKE_COMPLETED";
var DELETE_LIKE_FAILED = exports.DELETE_LIKE_FAILED = "DELETE_LIKE_FAILED";

function deleteLikeRequested() {
  return {
    type: DELETE_LIKE_REQUESTED
  };
}

function deleteLike(like_id) {
  return function (dispatch) {
    dispatch(deleteLikeRequested());
    return _gambaApi2.default.delete('/likes/' + like_id).then(function (results) {
      dispatch(deleteLikeCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deleteLikeFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteLikeCompleted(results) {
  return {
    type: DELETE_LIKE_COMPLETED,
    results: results
  };
}

function deleteLikeFailed(error) {
  return {
    type: DELETE_LIKE_FAILED,
    error: error
  };
}

var FETCH_LIKE_CONFIG = exports.FETCH_LIKE_CONFIG = "FETCH_LIKE_CONFIG";
var FETCH_LIKE_CONFIG_REQUESTED = exports.FETCH_LIKE_CONFIG_REQUESTED = "FETCH_LIKE_CONFIG_REQUESTED";
var FETCH_LIKE_CONFIG_COMPLETED = exports.FETCH_LIKE_CONFIG_COMPLETED = "FETCH_LIKE_CONFIG_COMPLETED";
var FETCH_LIKE_CONFIG_FAILED = exports.FETCH_LIKE_CONFIG_FAILED = "FETCH_LIKE_CONFIG_FAILED";

function fetchLikeConfigRequested() {
  return {
    type: FETCH_LIKE_CONFIG_REQUESTED
  };
}

function fetchLikeConfig() {
  return function (dispatch) {
    dispatch(fetchLikeConfigRequested());
    return _gambaApi2.default.get('/likes/config').then(function (results) {
      dispatch(fetchLikeConfigCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchLikeConfigFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchLikeConfigCompleted(results) {
  return {
    type: FETCH_LIKE_CONFIG_COMPLETED,
    results: results
  };
}

function fetchLikeConfigFailed(error) {
  return {
    type: FETCH_LIKE_CONFIG_FAILED,
    error: error
  };
}

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _permanentStore = __webpack_require__(118);

var _permanentStore2 = _interopRequireDefault(_permanentStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOKEN_KEY = 'gambaApp.outlook_authentication_token';
// src/actions/outlook-access-token.js

var accessTokenStore = (0, _permanentStore2.default)(TOKEN_KEY);

exports.default = {
  get: function get(callback) {
    accessTokenStore.get(function (token) {
      // sessionStorageにも同じtokenを保存しておき、
      // 現在のlocalStorageの値と比べることで、
      // 別のwindow/tabで別ユーザとしてgamba!にログインしたことを検出する
      var session_token = sessionStorage.getItem(TOKEN_KEY);
      if (session_token && session_token != token) token = undefined;else if (!session_token && token) sessionStorage.setItem(TOKEN_KEY, token);
      callback(token);
    });
  },

  set: function set(token, callback) {
    sessionStorage.setItem(TOKEN_KEY, token);
    accessTokenStore.set(token, callback);
  },

  clear: function clear() {
    accessTokenStore.clear();
    sessionStorage.removeItem(TOKEN_KEY);
  }
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1755)();
}


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.buttonFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _FontIcon = __webpack_require__(81);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Ripple = __webpack_require__(121);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(ripple, FontIcon) {
  var Button = function (_Component) {
    _inherits(Button, _Component);

    function Button() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Button);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
        if (_this.props.primary) return 'primary';
        if (_this.props.accent) return 'accent';
        return 'neutral';
      }, _this.getShape = function () {
        if (_this.props.raised) return 'raised';
        if (_this.props.floating) return 'floating';
        return 'flat';
      }, _this.handleMouseUp = function (event) {
        _this.buttonNode.blur();
        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
      }, _this.handleMouseLeave = function (event) {
        _this.buttonNode.blur();
        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Button, [{
      key: 'render',
      value: function render() {
        var _classnames,
            _this2 = this;

        var _props = this.props,
            accent = _props.accent,
            children = _props.children,
            className = _props.className,
            flat = _props.flat,
            floating = _props.floating,
            href = _props.href,
            icon = _props.icon,
            inverse = _props.inverse,
            label = _props.label,
            mini = _props.mini,
            neutral = _props.neutral,
            primary = _props.primary,
            raised = _props.raised,
            theme = _props.theme,
            type = _props.type,
            others = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'flat', 'floating', 'href', 'icon', 'inverse', 'label', 'mini', 'neutral', 'primary', 'raised', 'theme', 'type']);

        var element = href ? 'a' : 'button';
        var level = this.getLevel();
        var shape = this.getShape();

        var classes = (0, _classnames3.default)(theme.button, [theme[shape]], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.mini, mini), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);

        var props = _extends({}, others, {
          href: href,
          ref: function ref(node) {
            _this2.buttonNode = node;
          },
          className: classes,
          disabled: this.props.disabled,
          onMouseUp: this.handleMouseUp,
          onMouseLeave: this.handleMouseLeave,
          type: !href ? type : null,
          'data-react-toolbox': 'button'
        });

        return _react2.default.createElement(element, props, icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null, label, children);
      }
    }]);

    return Button;
  }(_react.Component);

  Button.propTypes = {
    accent: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    flat: _propTypes2.default.bool,
    floating: _propTypes2.default.bool,
    href: _propTypes2.default.string,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    inverse: _propTypes2.default.bool,
    label: _propTypes2.default.string,
    mini: _propTypes2.default.bool,
    neutral: _propTypes2.default.bool,
    onMouseLeave: _propTypes2.default.func,
    onMouseUp: _propTypes2.default.func,
    primary: _propTypes2.default.bool,
    raised: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      accent: _propTypes2.default.string,
      button: _propTypes2.default.string,
      flat: _propTypes2.default.string,
      floating: _propTypes2.default.string,
      icon: _propTypes2.default.string,
      inverse: _propTypes2.default.string,
      mini: _propTypes2.default.string,
      neutral: _propTypes2.default.string,
      primary: _propTypes2.default.string,
      raised: _propTypes2.default.string,
      rippleWrapper: _propTypes2.default.string,
      toggle: _propTypes2.default.string
    }),
    type: _propTypes2.default.string
  };
  Button.defaultProps = {
    accent: false,
    className: '',
    flat: false,
    floating: false,
    mini: false,
    neutral: true,
    primary: false,
    raised: false,
    type: 'button'
  };


  return ripple(Button);
};

var Button = factory((0, _Ripple2.default)({ centered: false }), _FontIcon2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(Button);
exports.buttonFactory = factory;
exports.Button = Button;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(222);
var _isPlaceholder = __webpack_require__(471);


/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2
             : _curry1(function(_b) { return fn(a, _b); });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
             : fn(a, b);
    }
  };
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WEBKIT = 'Webkit';
var MICROSOFT = 'Ms';

var properties = {
  transform: [WEBKIT, MICROSOFT]
};

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.substr(1);
}

function getPrefixes(property, value) {
  return properties[property].reduce(function (acc, item) {
    acc['' + item + capitalize(property)] = value; // eslint-disable-line no-param-reassign
    return acc;
  }, {});
}

function addPrefixesTo(style, property, value) {
  var vendor = getPrefixes(property, value);
  for (var prefix in vendor) {
    // eslint-disable-line no-restricted-syntax
    if ({}.hasOwnProperty.call(vendor, prefix)) {
      style[prefix] = vendor[prefix]; // eslint-disable-line no-param-reassign
    }
  }

  return style;
}

function prefixer(style) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _style = defaultValue;
  for (var property in style) {
    // eslint-disable-line no-restricted-syntax
    if ({}.hasOwnProperty.call(style, property)) {
      _style[property] = style[property];
      if (properties[property]) {
        addPrefixesTo(_style, property, style[property]);
      }
    }
  }

  return _style;
}

exports.default = prefixer;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._renderOverlay();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this._overlayTarget && nextProps.container !== this.props.container) {
        this._portalContainerNode.removeChild(this._overlayTarget);
        this._portalContainerNode = getContainer(nextProps.container);
        this._portalContainerNode.appendChild(this._overlayTarget);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._renderOverlay();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unrenderOverlay();
      this._unmountOverlayTarget();
    }
  }, {
    key: 'getMountNode',
    value: function getMountNode() {
      return this._overlayTarget;
    }
  }, {
    key: 'getOverlayDOMNode',
    value: function getOverlayDOMNode() {
      if (!this.isMounted()) {
        // eslint-disable-line
        throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
      }

      if (this._overlayInstance) {
        if (this._overlayInstance.getWrappedDOMNode) {
          return this._overlayInstance.getWrappedDOMNode();
        }
        return _reactDom2.default.findDOMNode(this._overlayInstance);
      }

      return null;
    }
  }, {
    key: '_getOverlay',
    value: function _getOverlay() {
      if (!this.props.children) return null;
      return _react2.default.createElement(
        'div',
        { className: this.props.className },
        this.props.children
      );
    }
  }, {
    key: '_renderOverlay',
    value: function _renderOverlay() {
      var overlay = this._getOverlay();
      if (overlay !== null) {
        this._mountOverlayTarget();
        this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
      } else {
        this._unrenderOverlay();
        this._unmountOverlayTarget();
      }
    }
  }, {
    key: '_unrenderOverlay',
    value: function _unrenderOverlay() {
      if (this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
        this._overlayInstance = null;
      }
    }
  }, {
    key: '_mountOverlayTarget',
    value: function _mountOverlayTarget() {
      if (!this._overlayTarget) {
        this._overlayTarget = document.createElement('div');
        this._portalContainerNode = getContainer(this.props.container);
        this._portalContainerNode.appendChild(this._overlayTarget);
      }
    }
  }, {
    key: '_unmountOverlayTarget',
    value: function _unmountOverlayTarget() {
      if (this._overlayTarget) {
        this._portalContainerNode.removeChild(this._overlayTarget);
        this._overlayTarget = null;
      }
      this._portalContainerNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(_react.Component);

Portal.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  container: _propTypes2.default.node
};
Portal.defaultProps = {
  className: ''
};


function getContainer(container) {
  var _container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(_container) || document.body;
}

exports.default = Portal;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = exports.iconButtonFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _FontIcon = __webpack_require__(81);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Ripple = __webpack_require__(121);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(ripple, FontIcon) {
  var IconButton = function (_Component) {
    _inherits(IconButton, _Component);

    function IconButton() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, IconButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconButton.__proto__ || Object.getPrototypeOf(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
        if (_this.props.primary) return 'primary';
        if (_this.props.accent) return 'accent';
        return 'neutral';
      }, _this.handleMouseUp = function (event) {
        _this.buttonNode.blur();
        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
      }, _this.handleMouseLeave = function (event) {
        _this.buttonNode.blur();
        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(IconButton, [{
      key: 'render',
      value: function render() {
        var _classnames,
            _this2 = this;

        var _props = this.props,
            accent = _props.accent,
            children = _props.children,
            className = _props.className,
            href = _props.href,
            icon = _props.icon,
            inverse = _props.inverse,
            neutral = _props.neutral,
            primary = _props.primary,
            theme = _props.theme,
            type = _props.type,
            others = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'href', 'icon', 'inverse', 'neutral', 'primary', 'theme', 'type']);

        var element = href ? 'a' : 'button';
        var level = this.getLevel();
        var classes = (0, _classnames3.default)([theme.toggle], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);

        var props = _extends({}, others, {
          href: href,
          ref: function ref(node) {
            _this2.buttonNode = node;
          },
          className: classes,
          disabled: this.props.disabled,
          onMouseUp: this.handleMouseUp,
          onMouseLeave: this.handleMouseLeave,
          type: !href ? type : null,
          'data-react-toolbox': 'button'
        });

        var iconElement = typeof icon === 'string' ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : icon;

        return _react2.default.createElement(element, props, icon && iconElement, children);
      }
    }]);

    return IconButton;
  }(_react.Component);

  IconButton.propTypes = {
    accent: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    href: _propTypes2.default.string,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    inverse: _propTypes2.default.bool,
    neutral: _propTypes2.default.bool,
    onMouseLeave: _propTypes2.default.func,
    onMouseUp: _propTypes2.default.func,
    primary: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      accent: _propTypes2.default.string,
      button: _propTypes2.default.string,
      flat: _propTypes2.default.string,
      floating: _propTypes2.default.string,
      icon: _propTypes2.default.string,
      inverse: _propTypes2.default.string,
      mini: _propTypes2.default.string,
      neutral: _propTypes2.default.string,
      primary: _propTypes2.default.string,
      raised: _propTypes2.default.string,
      rippleWrapper: _propTypes2.default.string,
      toggle: _propTypes2.default.string
    }),
    type: _propTypes2.default.string
  };
  IconButton.defaultProps = {
    accent: false,
    className: '',
    neutral: true,
    primary: false,
    type: 'button'
  };


  return ripple(IconButton);
};

var IconButton = factory((0, _Ripple2.default)({ centered: true }), _FontIcon2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(IconButton);
exports.iconButtonFactory = factory;
exports.IconButton = IconButton;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = exports.checkboxFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactStyleProptype = __webpack_require__(478);

var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Ripple = __webpack_require__(121);

var _Ripple2 = _interopRequireDefault(_Ripple);

var _Check = __webpack_require__(880);

var _Check2 = _interopRequireDefault(_Check);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(Check) {
  var Checkbox = function (_Component) {
    _inherits(Checkbox, _Component);

    function Checkbox() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Checkbox);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.handleToggle = function (event) {
        if (event.pageX !== 0 && event.pageY !== 0) _this.blur();
        if (!_this.props.disabled && _this.props.onChange) {
          _this.props.onChange(!_this.props.checked, event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Checkbox, [{
      key: 'blur',
      value: function blur() {
        if (this.inputNode) {
          this.inputNode.blur();
        }
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (this.inputNode) {
          this.inputNode.focus();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            checked = _props.checked,
            children = _props.children,
            disabled = _props.disabled,
            label = _props.label,
            name = _props.name,
            style = _props.style,
            onChange = _props.onChange,
            onMouseEnter = _props.onMouseEnter,
            onMouseLeave = _props.onMouseLeave,
            theme = _props.theme,
            others = _objectWithoutProperties(_props, ['checked', 'children', 'disabled', 'label', 'name', 'style', 'onChange', 'onMouseEnter', 'onMouseLeave', 'theme']);

        var className = (0, _classnames3.default)(theme.field, _defineProperty({}, theme.disabled, this.props.disabled), this.props.className);

        return _react2.default.createElement(
          'label',
          {
            'data-react-toolbox': 'checkbox',
            className: className,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
          },
          _react2.default.createElement('input', _extends({}, others, {
            checked: checked,
            className: theme.input,
            disabled: disabled,
            name: name,
            onChange: function onChange() {},
            onClick: this.handleToggle,
            ref: function ref(node) {
              _this2.inputNode = node;
            },
            type: 'checkbox'
          })),
          _react2.default.createElement(Check, {
            checked: checked,
            disabled: disabled,
            rippleClassName: theme.ripple,
            style: style,
            theme: theme
          }),
          label ? _react2.default.createElement(
            'span',
            { 'data-react-toolbox': 'label', className: theme.text },
            label
          ) : null,
          children
        );
      }
    }]);

    return Checkbox;
  }(_react.Component);

  Checkbox.propTypes = {
    checked: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    name: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    onMouseEnter: _propTypes2.default.func,
    onMouseLeave: _propTypes2.default.func,
    style: _reactStyleProptype2.default,
    theme: _propTypes2.default.shape({
      disabled: _propTypes2.default.string,
      field: _propTypes2.default.string,
      input: _propTypes2.default.string,
      ripple: _propTypes2.default.string
    })
  };
  Checkbox.defaultProps = {
    checked: false,
    className: '',
    disabled: false
  };


  return Checkbox;
};

var Check = (0, _Check2.default)((0, _Ripple2.default)({ centered: true, spread: 2.6 }));
var Checkbox = factory(Check);
exports.default = (0, _reactCssThemr.themr)(_identifiers.CHECKBOX)(Checkbox);
exports.checkboxFactory = factory;
exports.Checkbox = Checkbox;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(316),
    isFlattenable = __webpack_require__(1817);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _permanentStore = __webpack_require__(118);

var _permanentStore2 = _interopRequireDefault(_permanentStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY = "gambaApp.group_id"; /**
                                * src/actions/group-id-store.js
                                */

exports.default = (0, _permanentStore2.default)(KEY);

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = exports.avatarFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _FontIcon = __webpack_require__(81);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var factory = function factory(FontIcon) {
  var Avatar = function Avatar(_ref) {
    var alt = _ref.alt,
        children = _ref.children,
        className = _ref.className,
        cover = _ref.cover,
        icon = _ref.icon,
        image = _ref.image,
        theme = _ref.theme,
        title = _ref.title,
        other = _objectWithoutProperties(_ref, ['alt', 'children', 'className', 'cover', 'icon', 'image', 'theme', 'title']);

    return _react2.default.createElement(
      'div',
      _extends({
        'data-react-toolbox': 'avatar',
        className: (0, _classnames2.default)(theme.avatar, className)
      }, other),
      children,
      cover && typeof image === 'string' && _react2.default.createElement('span', {
        'aria-label': alt,
        className: theme.image,
        style: { backgroundImage: 'url(' + image + ')' }
      }),
      !cover && (typeof image === 'string' ? _react2.default.createElement('img', { alt: alt, className: theme.image, src: image }) : image),
      typeof icon === 'string' ? _react2.default.createElement(FontIcon, { className: theme.letter, value: icon, alt: alt }) : icon,
      title ? _react2.default.createElement(
        'span',
        { className: theme.letter },
        title[0]
      ) : null
    );
  };

  Avatar.propTypes = {
    alt: _propTypes2.default.string,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    cover: _propTypes2.default.bool,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    image: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    theme: _propTypes2.default.shape({
      avatar: _propTypes2.default.string,
      image: _propTypes2.default.string,
      letter: _propTypes2.default.string
    }),
    title: _propTypes2.default.string
  };

  Avatar.defaultProps = {
    alt: '',
    cover: false
  };

  return Avatar;
};

var Avatar = factory(_FontIcon2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.AVATAR)(Avatar);
exports.avatarFactory = factory;
exports.Avatar = Avatar;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemContent = exports.listItemContentFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _ListItemText = __webpack_require__(887);

var _ListItemText2 = _interopRequireDefault(_ListItemText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var types = ['auto', 'normal', 'large'];

var factory = function factory(ListItemText) {
  var ListItemContent = function (_Component) {
    _inherits(ListItemContent, _Component);

    function ListItemContent() {
      _classCallCheck(this, ListItemContent);

      return _possibleConstructorReturn(this, (ListItemContent.__proto__ || Object.getPrototypeOf(ListItemContent)).apply(this, arguments));
    }

    _createClass(ListItemContent, [{
      key: 'getType',
      value: function getType() {
        var _props = this.props,
            type = _props.type,
            children = _props.children,
            caption = _props.caption,
            legend = _props.legend;


        var count = _react2.default.Children.count(children);
        [caption, legend].forEach(function (s) {
          count += s ? 1 : 0;
        });
        var typeIndex = Math.min(count, types.length);

        return type || types[typeIndex];
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            children = _props2.children,
            caption = _props2.caption,
            legend = _props2.legend,
            theme = _props2.theme;

        var contentType = this.getType();
        var className = (0, _classnames3.default)(theme.itemContentRoot, _defineProperty({}, theme[contentType], theme[contentType]));

        return _react2.default.createElement(
          'span',
          { className: className },
          caption && _react2.default.createElement(
            ListItemText,
            { theme: theme, primary: true },
            caption
          ),
          legend && _react2.default.createElement(
            ListItemText,
            { theme: theme },
            legend
          ),
          children
        );
      }
    }]);

    return ListItemContent;
  }(_react.Component);

  ListItemContent.propTypes = {
    caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    children: _propTypes2.default.node,
    legend: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
      auto: _propTypes2.default.string,
      itemContentRoot: _propTypes2.default.string,
      large: _propTypes2.default.string,
      normal: _propTypes2.default.string
    }),
    type: _propTypes2.default.oneOf(types)
  };


  return ListItemContent;
};

var ListItemContent = factory(_ListItemText2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItemContent);
exports.listItemContentFactory = factory;
exports.ListItemContent = ListItemContent;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1850);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    return exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (typeof process !== 'undefined' && 'env' in process) {
    return Object({"NODE_ENV":"production","RAILS_ENV":"production","BUILD_NO":"202507040022","REACT_NATIVE":false}).DEBUG;
  }
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 345 */
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1871);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    return exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (typeof process !== 'undefined' && 'env' in process) {
    return Object({"NODE_ENV":"production","RAILS_ENV":"production","BUILD_NO":"202507040022","REACT_NATIVE":false}).DEBUG;
  }
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1895);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./left-sidebar-group-list-item.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./left-sidebar-group-list-item.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rangeslider = __webpack_require__(1914);

var _Rangeslider2 = _interopRequireDefault(_Rangeslider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Rangeslider2.default;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1917);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js?importLoaders=1!../../postcss-loader/lib/index.js!./index.css", function() {
			var newContent = require("!!../../css-loader/index.js?importLoaders=1!../../postcss-loader/lib/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (url) {
  return url.match(_config2.default.baseUrl + 'n');
};

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(1994),__webpack_require__(0),__webpack_require__(21)):"function"==typeof define&&define.amd?define(["prop-types","react","react-dom"],t):e.AvatarEditor=t(e.PropTypes,e.React,e.ReactDOM)}(this,function(e,t,i){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function n(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}e=e&&e.hasOwnProperty("default")?e.default:e,t=t&&t.hasOwnProperty("default")?t.default:t,i=i&&i.hasOwnProperty("default")?i.default:i;var r=function(e){var t="undefined"==typeof DOMParser?null:new DOMParser;return t?t.parseFromString(e,"text/html"):null},s=function(e,t){for(var i=0;i<e.length;i++){var a=e[i];if("text/html"===a.type){a.getAsString(function(e){var i=r(e).querySelector("img");i&&i.src&&t(i.src)});break}}},h=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var a in i)Object.prototype.hasOwnProperty.call(i,a)&&(e[a]=i[a])}return e},u=function(){function e(e,t){var i=[],a=!0,n=!1,o=void 0;try{for(var r,s=e[Symbol.iterator]();!(a=(r=s.next()).done)&&(i.push(r.value),!t||i.length!==t);a=!0);}catch(e){n=!0,o=e}finally{try{!a&&s.return&&s.return()}finally{if(n)throw o}}return i}return function(t,i){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,i);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),d=function(){function e(e,t){for(var i=0;i<t.length;i++){var a=t[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(e,a.key,a)}}return function(t,i,a){return i&&e(t.prototype,i),a&&e(t,a),t}}(),c=!("undefined"==typeof window||"undefined"==typeof navigator||!("ontouchstart"in window||navigator.msMaxTouchPoints>0)),l="undefined"!=typeof File,p={touch:{react:{down:"onTouchStart",mouseDown:"onMouseDown",drag:"onTouchMove",drop:"onTouchEnd",move:"onTouchMove",mouseMove:"onMouseMove",up:"onTouchEnd",mouseUp:"onMouseUp"},native:{down:"touchstart",mouseDown:"mousedown",drag:"touchmove",drop:"touchend",move:"touchmove",mouseMove:"mousemove",up:"touchend",mouseUp:"mouseup"}},desktop:{react:{down:"onMouseDown",drag:"onDragOver",drop:"onDrop",move:"onMouseMove",up:"onMouseUp"},native:{down:"mousedown",drag:"dragStart",drop:"drop",move:"mousemove",up:"mouseup"}}},g=c?p.touch:p.desktop,v="undefined"!=typeof window&&window.devicePixelRatio?window.devicePixelRatio:1,m=function(e,t,i,a,n,o){if(0===o)e.rect(t,i,a,n);else{var r=a-o,s=n-o;e.translate(t,i),e.arc(o,o,o,Math.PI,1.5*Math.PI),e.lineTo(r,0),e.arc(r,o,o,1.5*Math.PI,2*Math.PI),e.lineTo(a,s),e.arc(r,s,o,2*Math.PI,.5*Math.PI),e.lineTo(o,n),e.arc(o,s,o,.5*Math.PI,Math.PI),e.translate(-t,-i)}},f=function(e){function r(e){a(this,r);var t=n(this,(r.__proto__||Object.getPrototypeOf(r)).call(this,e));return t.state={drag:!1,my:null,mx:null,image:{x:.5,y:.5}},t.setCanvas=t.setCanvas.bind(t),t.handleMouseMove=t.handleMouseMove.bind(t),t.handleMouseDown=t.handleMouseDown.bind(t),t.handleMouseUp=t.handleMouseUp.bind(t),t.handleDragOver=t.handleDragOver.bind(t),t.handleDrop=t.handleDrop.bind(t),t}return o(r,t.Component),d(r,[{key:"isVertical",value:function(){return this.props.rotate%180!=0}},{key:"getBorders",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.props.border;return Array.isArray(e)?e:[e,e]}},{key:"getDimensions",value:function(){var e=this.props,t=e.width,i=e.height,a=e.rotate,n=e.border,o={},r=this.getBorders(n),s=u(r,2),h=s[0],d=s[1],c=t,l=i;return this.isVertical()?(o.width=l,o.height=c):(o.width=c,o.height=l),o.width+=2*h,o.height+=2*d,{canvas:o,rotate:a,width:t,height:i,border:n}}},{key:"getImage",value:function(){var e=this.getCroppingRect(),t=this.state.image;e.x*=t.resource.width,e.y*=t.resource.height,e.width*=t.resource.width,e.height*=t.resource.height;var i=document.createElement("canvas");this.isVertical()?(i.width=e.height,i.height=e.width):(i.width=e.width,i.height=e.height);var a=i.getContext("2d");return a.translate(i.width/2,i.height/2),a.rotate(this.props.rotate*Math.PI/180),a.translate(-i.width/2,-i.height/2),this.isVertical()&&a.translate((i.width-i.height)/2,(i.height-i.width)/2),a.drawImage(t.resource,-e.x,-e.y),i}},{key:"getImageScaledToCanvas",value:function(){var e=this.getDimensions(),t=e.width,i=e.height,a=document.createElement("canvas");return this.isVertical()?(a.width=i,a.height=t):(a.width=t,a.height=i),this.paintImage(a.getContext("2d"),this.state.image,0,1),a}},{key:"getXScale",value:function(){var e=this.props.width/this.props.height,t=this.state.image.width/this.state.image.height;return Math.min(1,e/t)}},{key:"getYScale",value:function(){var e=this.props.height/this.props.width,t=this.state.image.height/this.state.image.width;return Math.min(1,e/t)}},{key:"getCroppingRect",value:function(){var e=this.props.position||{x:this.state.image.x,y:this.state.image.y},t=1/this.props.scale*this.getXScale(),i=1/this.props.scale*this.getYScale(),a={x:e.x-t/2,y:e.y-i/2,width:t,height:i},n=0,o=1-a.width,r=0,s=1-a.height;return(t>1||i>1)&&(n=-a.width,o=1,r=-a.height,s=1),h({},a,{x:Math.max(n,Math.min(a.x,o)),y:Math.max(r,Math.min(a.y,s))})}},{key:"isDataURL",value:function(e){if(null===e)return!1;var t=/^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@/?%\s]*\s*$/i;return!!e.match(t)}},{key:"loadImage",value:function(e){l&&e instanceof File?this.loadImageFile(e):"string"==typeof e&&this.loadImageURL(e)}},{key:"loadImageURL",value:function(e){var t=new Image;t.onload=this.handleImageReady.bind(this,t),t.onerror=this.props.onLoadFailure,!this.isDataURL(e)&&this.props.crossOrigin&&(t.crossOrigin=this.props.crossOrigin),t.src=e}},{key:"loadImageFile",value:function(e){var t=this,i=new FileReader;i.onload=function(e){return t.loadImageURL(e.target.result)},i.readAsDataURL(e)}},{key:"componentDidMount",value:function(){var e=i.findDOMNode(this.canvas).getContext("2d");if(this.props.image&&this.loadImage(this.props.image),this.paint(e),document){var t=g.native;document.addEventListener(t.move,this.handleMouseMove,!1),document.addEventListener(t.up,this.handleMouseUp,!1),c&&(document.addEventListener(t.mouseMove,this.handleMouseMove,!1),document.addEventListener(t.mouseUp,this.handleMouseUp,!1))}}},{key:"componentWillUnmount",value:function(){if(document){var e=g.native;document.removeEventListener(e.move,this.handleMouseMove,!1),document.removeEventListener(e.up,this.handleMouseUp,!1),c&&(document.removeEventListener(e.mouseMove,this.handleMouseMove,!1),document.removeEventListener(e.mouseUp,this.handleMouseUp,!1))}}},{key:"componentDidUpdate",value:function(e,t){var a=i.findDOMNode(this.canvas),n=a.getContext("2d");n.clearRect(0,0,a.width,a.height),this.paint(n),this.paintImage(n,this.state.image,this.props.border),e.image===this.props.image&&e.width===this.props.width&&e.height===this.props.height&&e.position===this.props.position&&e.scale===this.props.scale&&e.rotate===this.props.rotate&&t.my===this.state.my&&t.mx===this.state.mx&&t.image.x===this.state.image.x&&t.image.y===this.state.image.y||this.props.onImageChange()}},{key:"handleImageReady",value:function(e){var t=this.getInitialSize(e.width,e.height);t.resource=e,t.x=.5,t.y=.5,this.setState({drag:!1,image:t},this.props.onImageReady),this.props.onLoadSuccess(t)}},{key:"getInitialSize",value:function(e,t){var i=void 0,a=void 0,n=this.getDimensions();return n.height/n.width>t/e?a=e*((i=this.getDimensions().height)/t):i=t*((a=this.getDimensions().width)/e),{height:i,width:a}}},{key:"componentWillReceiveProps",value:function(e){(e.image&&this.props.image!==e.image||this.props.width!==e.width||this.props.height!==e.height)&&this.loadImage(e.image)}},{key:"paintImage",value:function(e,t,i){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:v;if(t.resource){var n=this.calculatePosition(t,i);e.save(),e.translate(e.canvas.width/2,e.canvas.height/2),e.rotate(this.props.rotate*Math.PI/180),e.translate(-e.canvas.width/2,-e.canvas.height/2),this.isVertical()&&e.translate((e.canvas.width-e.canvas.height)/2,(e.canvas.height-e.canvas.width)/2),e.scale(a,a),e.globalCompositeOperation="destination-over",e.drawImage(t.resource,n.x,n.y,n.width,n.height),e.restore()}}},{key:"calculatePosition",value:function(e,t){e=e||this.state.image;var i=this.getBorders(t),a=u(i,2),n=a[0],o=a[1],r=this.getCroppingRect(),s=e.width*this.props.scale,h=e.height*this.props.scale,d=-r.x*s,c=-r.y*h;return this.isVertical()?(d+=o,c+=n):(d+=n,c+=o),{x:d,y:c,height:h,width:s}}},{key:"paint",value:function(e){e.save(),e.scale(v,v),e.translate(0,0),e.fillStyle="rgba("+this.props.color.slice(0,4).join(",")+")";var t=this.props.borderRadius,i=this.getDimensions(),a=this.getBorders(i.border),n=u(a,2),o=n[0],r=n[1],s=i.canvas.height,h=i.canvas.width;t=Math.max(t,0),t=Math.min(t,h/2-o,s/2-r),e.beginPath(),m(e,o,r,h-2*o,s-2*r,t),e.rect(h,0,-h,s),e.fill("evenodd"),e.restore()}},{key:"handleMouseDown",value:function(e){(e=e||window.event).preventDefault(),this.setState({drag:!0,mx:null,my:null})}},{key:"handleMouseUp",value:function(){this.state.drag&&(this.setState({drag:!1}),this.props.onMouseUp())}},{key:"handleMouseMove",value:function(e){if(e=e||window.event,!1!==this.state.drag){var t=e.targetTouches?e.targetTouches[0].pageX:e.clientX,i=e.targetTouches?e.targetTouches[0].pageY:e.clientY,a={mx:t,my:i},n=this.props.rotate;if(n%=360,n=n<0?n+360:n,this.state.mx&&this.state.my){var o=this.state.mx-t,r=this.state.my-i,s=this.state.image.width*this.props.scale,u=this.state.image.height*this.props.scale,d=this.getCroppingRect(),c=d.x,l=d.y;c*=s,l*=u;var p=function(e){return e*(Math.PI/180)},g=Math.cos(p(n)),v=Math.sin(p(n)),m=l+-o*v+r*g,f={x:(c+o*g+r*v)/s+1/this.props.scale*this.getXScale()/2,y:m/u+1/this.props.scale*this.getYScale()/2};this.props.onPositionChange(f),a.image=h({},this.state.image,f)}this.setState(a),this.props.onMouseMove(e)}}},{key:"handleDragOver",value:function(e){(e=e||window.event).preventDefault()}},{key:"handleDrop",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.event;if(t.stopPropagation(),t.preventDefault(),t.dataTransfer){var i=t.dataTransfer,a=i.files,n=i.items;a&&a.length?(this.props.onDropFile(t),this.loadImageFile(a[0])):n&&n.length&&s(n,function(t){return e.loadImage(t)})}}},{key:"setCanvas",value:function(e){this.canvas=e}},{key:"render",value:function(){var e=this.getDimensions(),i={width:e.canvas.width,height:e.canvas.height,cursor:this.state.drag?"grabbing":"grab"},a={width:e.canvas.width*v,height:e.canvas.height*v,style:h({},i,this.props.style)};return a[g.react.down]=this.handleMouseDown,a[g.react.drag]=this.handleDragOver,this.props.disableDrop||(a[g.react.drop]=this.handleDrop),c&&(a[g.react.mouseDown]=this.handleMouseDown),t.createElement("canvas",h({ref:this.setCanvas},a))}}]),r}();return f.propTypes={scale:e.number,rotate:e.number,image:e.oneOfType([e.string].concat(function(e){if(Array.isArray(e)){for(var t=0,i=Array(e.length);t<e.length;t++)i[t]=e[t];return i}return Array.from(e)}(l?[e.instanceOf(File)]:[]))),border:e.oneOfType([e.number,e.arrayOf(e.number)]),borderRadius:e.number,width:e.number,height:e.number,position:e.shape({x:e.number,y:e.number}),color:e.arrayOf(e.number),style:e.object,crossOrigin:e.oneOf(["","anonymous","use-credentials"]),onDropFile:e.func,onLoadFailure:e.func,onLoadSuccess:e.func,onImageReady:e.func,onImageChange:e.func,onMouseUp:e.func,onMouseMove:e.func,onPositionChange:e.func,disableDrop:e.bool},f.defaultProps={disableDrop:!1,scale:1,rotate:0,border:25,borderRadius:0,width:200,height:200,color:[0,0,0,.5],style:{},onDropFile:function(){},onLoadFailure:function(){},onLoadSuccess:function(){},onImageReady:function(){},onImageChange:function(){},onMouseUp:function(){},onMouseMove:function(){},onPositionChange:function(){}},f});
//# sourceMappingURL=index.js.map


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactI18next = __webpack_require__(2);

var _propTypes = __webpack_require__(4);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _hls = __webpack_require__(2169);

var _hls2 = _interopRequireDefault(_hls);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _videoViewer = __webpack_require__(934);

var _videoViewer2 = _interopRequireDefault(_videoViewer);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/video-viewer.jsx

var TooltipAvatar = (0, _tooltip2.default)(_avatar2.default);

var VideoViewer = function (_React$Component) {
  _inherits(VideoViewer, _React$Component);

  function VideoViewer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VideoViewer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VideoViewer.__proto__ || Object.getPrototypeOf(VideoViewer)).call.apply(_ref, [this].concat(args))), _this), _this.state = { played: false }, _this.videoPlay = function () {
      return _this.setState({ played: true });
    }, _this.videoPause = function () {
      return _this.setState({ played: false });
    }, _this.videoEnd = function () {
      return _this.props.parent_component == 'CHAT_MESSAGE' && _this.props.onEnd();
    }, _this.onPlay = function (ev) {
      if (!_this.state.played) {
        ev.preventDefault();ev.target.play();
      } else {
        ev.preventDefault();ev.target.pause();
      }
    }, _this.showImagesView = function (video) {
      _this.props.showImagesView('GROUP_TIMELINE', _this.props.params.diary_id, video);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VideoViewer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.refs.video) {
        var hls = new _hls2.default();
        hls.loadSource(this.props.video.file.url);
        hls.attachMedia(_reactDom2.default.findDOMNode(this.refs.video));

        _reactDom2.default.findDOMNode(this.refs.video).addEventListener('play', this.videoPlay);
        _reactDom2.default.findDOMNode(this.refs.video).addEventListener('pause', this.videoPause);
        _reactDom2.default.findDOMNode(this.refs.video).addEventListener('ended', this.videoEnd);
      }
    }
  }, {
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps) {
      if (this.props.video != nextProps.video) {
        if (this.refs.video) {
          var hls = new _hls2.default();
          hls.loadSource(nextProps.video.file.url);
          hls.attachMedia(_reactDom2.default.findDOMNode(this.refs.video));
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _reactDom2.default.findDOMNode(this.refs.video).removeEventListener('play', this.videoPlay);
      _reactDom2.default.findDOMNode(this.refs.video).removeEventListener('pause', this.videoPause);
      _reactDom2.default.findDOMNode(this.refs.video).removeEventListener('ended', this.videoEnd);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var userAgent = window.navigator.userAgent.toLowerCase();
      var _props = this.props,
          t = _props.t,
          video = _props.video,
          parent_component = _props.parent_component,
          params = _props.params,
          onEnd = _props.onEnd,
          showImagesView = _props.showImagesView;


      if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) return _react2.default.createElement(
        'div',
        { style: { padding: '10px', fontSize: '80%' } },
        '\u304A\u4F7F\u3044\u306EWeb\u30D6\u30E9\u30A6\u30B6\u306F\u30D3\u30C7\u30AA\u518D\u751F\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u305B\u3093\u3002 Google Chrome\u3084Firefox\u30D6\u30E9\u30A6\u30B6\u306A\u3069\u306E\u3054\u5229\u7528\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002'
      );

      return _react2.default.createElement(
        'div',
        { className: _videoViewer2.default.baseDiv,
          style: { padding: parent_component == 'CHAT_MESSAGE' ? '0px' : undefined } },
        parent_component == 'ATTACHMENTS_PAGE' && !params.isAudio && _react2.default.createElement(
          'div',
          { className: _videoViewer2.default.iconDiv },
          _react2.default.createElement(
            'span',
            { style: { width: '80%', marginTop: '10px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } },
            video.name
          ),
          _react2.default.createElement(_avatar2.default, { className: _videoViewer2.default.avatar,
            icon: 'fullscreen',
            onClick: function onClick() {
              return _this2.showImagesView(video);
            } }),
          _react2.default.createElement(
            'a',
            { key: video.video_id, style: { float: 'right' },
              href: video.file.orig_url },
            _react2.default.createElement(_avatar2.default, { className: _videoViewer2.default.avatar,
              icon: 'file_download' })
          )
        ),
        parent_component == 'TIMELINE_PAGE' && video.content_type.match(/^video/) && _react2.default.createElement(
          'div',
          { className: _videoViewer2.default.iconDiv },
          _react2.default.createElement(
            'a',
            { key: video.video_id, style: { float: 'right' }, href: video.file.orig_url },
            _react2.default.createElement(TooltipAvatar, { className: _videoViewer2.default.tooltipAvatar, icon: 'file_download', tooltip: t('label:ダウンロード') })
          )
        ),
        parent_component == 'TIMELINE_PAGE' && video.content_type.match(/^audio/) && _react2.default.createElement(
          'div',
          { className: _videoViewer2.default.audioArea },
          _react2.default.createElement(
            _chip2.default,
            { className: _videoViewer2.default.audioChip },
            _react2.default.createElement(_avatar2.default, { icon: 'audiotrack', className: video.status && video.status != 'committed' ? undefined : (0, _classnames2.default)(_videoViewer2.default.avatar, 'audiotrack') }),
            _react2.default.createElement(
              'span',
              null,
              video.name
            )
          )
        ),
        parent_component != 'CHAT_MESSAGE' && _react2.default.createElement('video', { className: video.content_type.match(/^video/) ? parent_component == 'TIMELINE_PAGE' ? _videoViewer2.default.video : _videoViewer2.default.dialogVideo : parent_component == 'TIMELINE_PAGE' ? _videoViewer2.default.audio : _videoViewer2.default.dialogAudio,
          onClick: function onClick(ev) {
            return _this2.onPlay(ev);
          },
          controls: true, ref: 'video' }),
        parent_component == 'CHAT_MESSAGE' && _react2.default.createElement('audio', {
          onClick: function onClick(ev) {
            return _this2.onPlay(ev);
          },
          controls: true, ref: 'video' })
      );
    }
  }]);

  return VideoViewer;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)()((0, _context2.default)({ showImagesView: _propTypes.PropTypes.func })(VideoViewer));

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerDialog = exports.DatePicker = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _DatePicker = __webpack_require__(2185);

var _DatePickerDialog = __webpack_require__(936);

var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);

var _Calendar = __webpack_require__(935);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _button = __webpack_require__(8);

var _input = __webpack_require__(59);

var _dialog = __webpack_require__(47);

var _theme = __webpack_require__(2188);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Calendar = (0, _Calendar2.default)(_button.IconButton);
var DatePickerDialog = (0, _DatePickerDialog2.default)(_dialog.Dialog, Calendar);
var DatePicker = (0, _DatePicker.datePickerFactory)(_input.Input, DatePickerDialog);

var ThemedDatePicker = (0, _reactCssThemr.themr)(_identifiers.DATE_PICKER, _theme2.default)(DatePicker);
exports.default = ThemedDatePicker;
exports.DatePicker = ThemedDatePicker;


var ThemedDatePickerDialog = (0, _reactCssThemr.themr)(_identifiers.DIALOG, _theme2.default)(DatePickerDialog);
exports.DatePickerDialog = ThemedDatePickerDialog;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(356)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(506)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(107);
var defined = __webpack_require__(123);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(100);
var toLength = __webpack_require__(55);
var toAbsoluteIndex = __webpack_require__(193);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(52)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(167);
var step = __webpack_require__(951);
var Iterators = __webpack_require__(228);
var toIObject = __webpack_require__(100);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(506)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(109);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(359);
var getKeys = __webpack_require__(192);
var redefine = __webpack_require__(93);
var global = __webpack_require__(34);
var hide = __webpack_require__(92);
var Iterators = __webpack_require__(228);
var wks = __webpack_require__(52);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(34);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(93);
var redefineAll = __webpack_require__(194);
var meta = __webpack_require__(168);
var forOf = __webpack_require__(196);
var anInstance = __webpack_require__(195);
var isObject = __webpack_require__(40);
var fails = __webpack_require__(37);
var $iterDetect = __webpack_require__(358);
var setToStringTag = __webpack_require__(229);
var inheritIfRequired = __webpack_require__(517);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(3);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(82);
var ctx = __webpack_require__(108);
var forOf = __webpack_require__(196);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(40);
var cof = __webpack_require__(109);
var MATCH = __webpack_require__(52)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 366 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INTEGRATIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports__ = __webpack_require__(2293);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["I"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["J"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(993);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__transports__; });






var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["o" /* getGlobalObject */])();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
var INTEGRATIONS = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, windowIntegrations), __WEBPACK_IMPORTED_MODULE_2__sentry_core__["e" /* Integrations */]), __WEBPACK_IMPORTED_MODULE_4__integrations__);

//# sourceMappingURL=index.js.map

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2348);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./light-button.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./light-button.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawSearchDrawer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _searchDrawer = __webpack_require__(2372);

var _searchDrawer2 = _interopRequireDefault(_searchDrawer);

var _compactInput = __webpack_require__(178);

var _compactInput2 = _interopRequireDefault(_compactInput);

var _list = __webpack_require__(25);

var _drawer = __webpack_require__(476);

var _drawer2 = _interopRequireDefault(_drawer);

var _button = __webpack_require__(8);

var _datePicker = __webpack_require__(165);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _reactNotificationBadge = __webpack_require__(186);

var _reactNotificationBadge2 = _interopRequireDefault(_reactNotificationBadge);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _searchDrawer3 = __webpack_require__(2373);

var _searchDrawer4 = _interopRequireDefault(_searchDrawer3);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/search-drawer.jsx

var SearchDrawer = function (_React$Component) {
  _inherits(SearchDrawer, _React$Component);

  function SearchDrawer() {
    _classCallCheck(this, SearchDrawer);

    return _possibleConstructorReturn(this, (SearchDrawer.__proto__ || Object.getPrototypeOf(SearchDrawer)).apply(this, arguments));
  }

  _createClass(SearchDrawer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          active = _props.active,
          group = _props.group,
          onClose = _props.onClose,
          isFetching = _props.isFetching,
          preservedQueries = _props.preservedQueries,
          submitQuery = _props.submitQuery,
          selectPreservedQuery = _props.selectPreservedQuery,
          deletePreservedQuery = _props.deletePreservedQuery,
          showUserSelectionDialog = _props.showUserSelectionDialog,
          updateUI = _props.updateUI,
          user = _props.user,
          clearSearchQuery = _props.clearSearchQuery;


      return _react2.default.createElement(
        _drawer2.default,
        { type: 'right', active: active, onOverlayClick: onClose, theme: _searchDrawer4.default, className: 'search_drawer' },
        _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(ev) {
              return submitQuery(_this2.props, ev);
            } },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', padding: 5 } },
            _react2.default.createElement(_compactInput2.default, { hasFocus: true, className: 'fluid', hint: t('label:検索キーワード'), value: ui.queryText, onChange: function onChange(value) {
                return updateUI({ queryText: value });
              } }),
            _react2.default.createElement(_button.IconButton, { icon: 'close', onClick: function onClick() {
                return clearSearchQuery(_this2.props);
              } }),
            _react2.default.createElement(_button.IconButton, { icon: 'search', type: 'submit', primary: true })
          ),
          _react2.default.createElement(
            _list.List,
            null,
            preservedQueries && preservedQueries.length > 0 && _react2.default.createElement(_list.ListSubHeader, { caption: t('label:保存された検索条件') }),
            preservedQueries && preservedQueries.length > 0 && _.map(preservedQueries, function (query) {
              return _react2.default.createElement(_list.ListItem, { key: query.query_id,
                theme: _searchDrawer4.default,
                className: 'search_text_ellipsis',
                selectable: true,
                caption: query.name,
                onClick: function onClick() {
                  return selectPreservedQuery(_this2.props, query);
                },
                avatar: _react2.default.createElement(_avatar2.default, { icon: 'search', className: 'searchIcon', theme: _searchDrawer4.default }),
                rightActions: [_react2.default.createElement(_button.IconButton, { icon: 'close', key: 'icon', onClick: function onClick() {
                    return updateUI({ deleteConfirm: true, deleteQuery: query, deleteQueryName: query.name });
                  }
                })] });
            }),
            _react2.default.createElement(_list.ListDivider, null),
            _react2.default.createElement(_list.ListItem, { selectable: true,
              caption: _react2.default.createElement(
                'span',
                null,
                t('label:ユーザで絞り込み'),
                _react2.default.createElement(_reactNotificationBadge2.default, { count: ui.users && ui.users.length || undefined,
                  containerStyle: { top: '-18px', left: '-10px' },
                  effect: _reactNotificationBadge.Effect.SCALE })
              ),
              leftIcon: 'people',
              onClick: function onClick() {
                showUserSelectionDialog(t('label:ユーザで絞り込み'), true, group && group.group_id != 'home' && 'GROUP_MEMBERS' || 'ACCOUNT_MEMBERS', group && group.group_id != 'home' && group || undefined, ui.users && ui.users, function (users) {
                  return updateUI({
                    users: (0, _store.mergeArray)('user_id', [], users)
                  });
                });
              } }),
            _react2.default.createElement(_list.ListCheckbox, { caption: t('label:すべての投稿種別'), checked: ui.category == 'all', onChange: function onChange() {
                return updateUI({ category: 'all' });
              } }),
            _react2.default.createElement(_list.ListCheckbox, { caption: t('label:日報のみ'), checked: ui.category == 'diary', onChange: function onChange() {
                return updateUI({ category: 'diary' });
              } }),
            _react2.default.createElement(_list.ListCheckbox, { caption: t('label:KPIのみ'), checked: ui.category == 'kpi', onChange: function onChange() {
                return updateUI({ category: 'kpi' });
              } }),
            _react2.default.createElement(_list.ListCheckbox, { caption: t('label:ノートのみ'), checked: ui.category == 'memo', onChange: function onChange() {
                return updateUI({ category: 'memo' });
              } }),
            _react2.default.createElement(_list.ListDivider, null),
            _react2.default.createElement(_list.ListSubHeader, { caption: t('label:オプション') }),
            _react2.default.createElement(_list.ListCheckbox, { caption: t('label:添付ファイル付き'), checked: ui.files_attached, onChange: function onChange() {
                return updateUI({ files_attached: !ui.files_attached });
              } }),
            _react2.default.createElement(_list.ListCheckbox, { caption: t('label:いいねした投稿'), checked: ui.liked_by ? true : false, onChange: function onChange() {
                return updateUI({ liked_by: ui.liked_by ? undefined : user.user_id });
              } }),
            _react2.default.createElement(_list.ListItem, {
              caption: _react2.default.createElement(_datePicker2.default, {
                label: t('label:日付の選択'),
                inputFormat: function inputFormat(date) {
                  return date && t('label:より後の投稿', { reported_at: (0, _moment2.default)(date).format('LLLL') }) || '';
                },
                value: ui.reported_at && (0, _moment2.default)(ui.reported_at).toDate() || undefined,
                maxDate: (0, _moment2.default)().toDate(),
                onChange: function onChange(date) {
                  return updateUI({ reported_at: (0, _moment2.default)(date) });
                },
                onDismiss: function onDismiss() {
                  return updateUI({ reported_at: undefined });
                } }) })
          ),
          _react2.default.createElement(_button.Button, { primary: true, raised: true,
            style: { width: '100%' },
            icon: 'search',
            label: t('label:検索'),
            type: 'submit' })
        ),
        _react2.default.createElement(_confirmDialog2.default, { open: ui.deleteConfirm,
          title: t('label:検索条件を削除してもいいですか', { name: ui.deleteQueryName }),
          description: t('label:この操作は取り消せません'),
          yesLabel: t('label:削除'),
          noLabel: t('label:取り消し'),
          onYes: function onYes() {
            updateUI({ deleteConfirm: false });deletePreservedQuery(ui.deleteQuery, true);
          },
          onNo: function onNo() {
            return updateUI({ deleteConfirm: false, deleteQuery: undefined, deleteQueryName: undefined });
          } })
      );
    }
  }]);

  return SearchDrawer;
}(_react2.default.Component);

var RawSearchDrawer = exports.RawSearchDrawer = SearchDrawer;
exports.default = (0, _searchDrawer2.default)(SearchDrawer);

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2376);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./no-wrapped-navigation.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./no-wrapped-navigation.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2377);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./app-bar.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./app-bar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _dialog = __webpack_require__(47);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _reactPdf = __webpack_require__(996);

var _pdfPreview = __webpack_require__(558);

var _pdfPreview2 = _interopRequireDefault(_pdfPreview);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app_bar = __webpack_require__(122);

var _app_bar2 = _interopRequireDefault(_app_bar);

var _navigation = __webpack_require__(147);

var _rightSidePageAppBar = __webpack_require__(559);

var _rightSidePageAppBar2 = _interopRequireDefault(_rightSidePageAppBar);

var _i18n = __webpack_require__(173);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * src/web/components/pdf-preview-dialog.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


(0, _reactPdf.setOptions)({
  cMapUrl: '//cdn.jsdelivr.net/npm/pdfjs-dist@2.0.305/cmaps/',
  cMapPacked: true,
  workerSrc: '//cdn.jsdelivr.net/npm/pdfjs-dist@2.0.305/build/pdf.worker.js'
});

var MAX_PDF_PAGES = 50;
var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);

var styles = {
  errorContainer: {
    display: 'flex',
    fontSize: 12,
    overflow: 'auto'
  }
};

var pdfPreviewDialog = function (_React$Component) {
  _inherits(pdfPreviewDialog, _React$Component);

  function pdfPreviewDialog(props) {
    _classCallCheck(this, pdfPreviewDialog);

    var _this = _possibleConstructorReturn(this, (pdfPreviewDialog.__proto__ || Object.getPrototypeOf(pdfPreviewDialog)).call(this, props));

    _this.closeDialog = function () {
      _this.setState({ isLoadError: false });
      _this.props.onClose();
    };

    _this.onZoomIn = function () {
      var scale = _this.state.scale * 1.3;
      _this.setState({ scale: scale >= 3 ? 3 : scale });
    };

    _this.onZoomOut = function () {
      var scale = _this.state.scale * 0.7;
      _this.setState({ scale: scale <= 1 ? 1 : scale });
    };

    _this.onDocumentLoadSuccess = function (document) {
      var containerElement = _reactDom2.default.findDOMNode(_this.ref);
      if (containerElement && containerElement.clientWidth) {
        setTimeout(function () {
          return _this.setState({ width: containerElement.clientWidth });
        }, 0);
      }
      _this.setState({ numPages: document.numPages, isLoadError: false });
    };

    _this.onLoadError = function () {
      return _this.setState({ isLoadError: true });
    };

    _this.state = {
      width: 0,
      numPages: 0,
      scale: 1,
      isLoadError: false
    };
    return _this;
  }

  _createClass(pdfPreviewDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          file = _props.file,
          open = _props.open,
          onClose = _props.onClose;
      var numPages = this.state.numPages;

      var fontIconStyle = {
        fontSize: 18,
        position: 'absolute',
        left: _i18n2.default.language == 'ja' ? 235 : 280
      };
      return _react2.default.createElement(
        _dialog.Dialog,
        {
          className: _pdfPreview2.default.pdfDialog,
          active: open,
          nEscKeyDown: this.closeDialog,
          onOverlayClick: this.closeDialog },
        _react2.default.createElement(
          _app_bar2.default,
          { flat: true, title: file.name, theme: _rightSidePageAppBar2.default },
          _react2.default.createElement(
            _navigation.Navigation,
            { type: 'horizontal', style: { whiteSpace: 'nowrap' } },
            _react2.default.createElement(TooltipIconButton, { icon: 'open_in_new', href: file.file.url, target: '_blank', rel: 'noopener noreferrer', tooltip: t('label:別ウィンドウで表示') }),
            _react2.default.createElement(_button.IconButton, { icon: 'close', onClick: this.closeDialog })
          )
        ),
        _react2.default.createElement(
          'div',
          { ref: function ref(c) {
              return _this2.ref = c;
            } },
          this.state.isLoadError && _react2.default.createElement(
            'div',
            { style: { marginTop: 8 } },
            _react2.default.createElement(
              'div',
              null,
              t('error:画像の読み込みに失敗しました')
            ),
            _react2.default.createElement(
              'div',
              { style: styles.errorContainer },
              t('error:暗号化PDF説明'),
              _react2.default.createElement(_font_icon2.default, { value: 'open_in_new', style: fontIconStyle })
            )
          ),
          _react2.default.createElement(
            _reactPdf.Document,
            { file: file.file.url, className: _pdfPreview2.default.pdfView,
              error: _react2.default.createElement('div', null),
              loading: t('label:読み込み中'),
              onLoadSuccess: this.onDocumentLoadSuccess,
              onLoadError: this.onLoadError },
            Array.from(new Array(Math.min(numPages, MAX_PDF_PAGES)), function (el, index) {
              return _react2.default.createElement(_reactPdf.Page, { key: 'page_' + (index + 1), pageNumber: index + 1, width: _this2.state.width * _this2.state.scale });
            }),
            numPages > MAX_PDF_PAGES && _react2.default.createElement(
              'div',
              { style: { fontSize: '80%' } },
              t('label:MAXページまでを表示しています')
            )
          )
        ),
        _react2.default.createElement(
          'nav',
          { className: _pdfPreview2.default.nav },
          _react2.default.createElement(
            'div',
            { style: { display: 'inline' }, onClick: this.onZoomIn },
            _react2.default.createElement(TooltipIconButton, { className: _pdfPreview2.default.navCenter, icon: 'add_circle_outline', tooltip: t('label:拡大') })
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'inline' }, onClick: this.onZoomOut },
            _react2.default.createElement(TooltipIconButton, { className: _pdfPreview2.default.navCenter, icon: 'remove_circle_outline', tooltip: t('label:縮小') })
          )
        )
      );
    }
  }]);

  return pdfPreviewDialog;
}(_react2.default.Component);

exports.default = pdfPreviewDialog;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(997);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 377 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 378 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(2389);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(2397);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(2391)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(1002)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(169).f;
var has = __webpack_require__(203);
var TAG = __webpack_require__(89)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2394);
var global = __webpack_require__(88);
var hide = __webpack_require__(202);
var Iterators = __webpack_require__(237);
var TO_STRING_TAG = __webpack_require__(89)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');


exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (source.hasOwnProperty(p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// As defined on the list of supported mouse events: https://facebook.github.io/react/docs/events.html#mouse-events
var mouseEvents = exports.mouseEvents = ['onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp'];
// As defined on the list of supported touch events: https://facebook.github.io/react/docs/events.html#touch-events
var touchEvents = exports.touchEvents = ['onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];

/**
 * Returns an object with on-event callback props curried with provided args.
 * @param {Object} props Props passed to a component.
 * @param {*} args Argument(s) that on-event callbacks shall be curried with.
 */
var makeEventProps = exports.makeEventProps = function makeEventProps(props, getArgs) {
  var eventProps = {};

  [].concat(mouseEvents, touchEvents).forEach(function (eventName) {
    if (props[eventName]) {
      eventProps[eventName] = function (event) {
        return props[eventName](event, getArgs());
      };
    }
  });

  return eventProps;
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2505);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./one-column-layout.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./one-column-layout.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(0),__webpack_require__(974)):"function"==typeof define&&define.amd?define(["react","highcharts"],e):"object"==typeof exports?exports.ReactHighcharts=e(require("react"),require("highcharts")):t.ReactHighcharts=e(t.React,t.Highcharts)}("undefined"!=typeof self?self:this,function(t,e){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=4)}([function(e,r){e.exports=t},function(t,e,r){"use strict";(function(n){Object.defineProperty(e,"__esModule",{value:!0});var o,i=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var r=arguments[e];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(t[n]=r[n])}return t},a=function(){function t(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),e}}(),c=r(0),u=(o=c)&&o.__esModule?o:{default:o};var s=void 0===n?window:n;e.default=function(e,r){var n=function(t){function n(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,n);var t=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return t.chartType=e,t.Highcharts=r,t.displayName="Highcharts"+e,t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(n,c.Component),a(n,[{key:"setChartRef",value:function(t){this.chartRef=t}},{key:"renderChart",value:function(t){var e=this;if(!t)throw new Error("Config must be specified for the "+this.displayName+" component");var r=t.chart;this.chart&&this.chart.destroy(),this.chart=new this.Highcharts[this.chartType](i({},t,{chart:i({},r,{renderTo:this.chartRef})}),this.props.callback),this.props.neverReflow||s&&s.requestAnimationFrame&&requestAnimationFrame(function(){e.chart&&e.chart.options&&e.chart.reflow()})}},{key:"shouldComponentUpdate",value:function(t){return!!(t.neverReflow||t.isPureConfig&&this.props.config===t.config)||(this.renderChart(t.config),!1)}},{key:"getChart",value:function(){if(!this.chart)throw new Error("getChart() should not be called before the component is mounted");return this.chart}},{key:"componentDidMount",value:function(){this.renderChart(this.props.config)}},{key:"componentWillUnmount",value:function(){this.chart.destroy()}},{key:"render",value:function(){return u.default.createElement("div",i({ref:this.setChartRef.bind(this)},this.props.domProps))}}]),n}();n.defaultProps={callback:function(){},domProps:{}};var o=n;return o.Highcharts=r,o.withHighcharts=function(r){return t.exports(e,r)},o},t.exports=e.default}).call(e,r(2))},function(t,e){var r;r=function(){return this}();try{r=r||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(r=window)}t.exports=r},,function(t,e,r){t.exports=r(5)},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=i(r(1)),o=i(r(6));function i(t){return t&&t.__esModule?t:{default:t}}e.default=(0,n.default)("Chart",o.default),t.exports=e.default},function(t,r){t.exports=e}])});

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _button = __webpack_require__(8);

var _avatar = __webpack_require__(26);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _toggleButton = __webpack_require__(2529);

var _toggleButton2 = _interopRequireDefault(_toggleButton);

var _reactI18next = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
// src/web/components/toggle-button.jsx

function ToggleButton(props) {
  var t = props.t,
      flag = props.flag,
      _props$trueIcon = props.trueIcon,
      trueIcon = _props$trueIcon === undefined ? 'arrow_drop_down' : _props$trueIcon,
      _props$falseIcon = props.falseIcon,
      falseIcon = _props$falseIcon === undefined ? 'arrow_drop_up' : _props$falseIcon,
      _props$trueLabel = props.trueLabel,
      trueLabel = _props$trueLabel === undefined ? t('label:すべて表示') : _props$trueLabel,
      _props$falseLabel = props.falseLabel,
      falseLabel = _props$falseLabel === undefined ? t('label:隠す') : _props$falseLabel,
      i18nLoadedAt = props.i18nLoadedAt,
      i18n = props.i18n,
      isAttachment = props.isAttachment,
      image = props.image,
      others = _objectWithoutProperties(props, ['t', 'flag', 'trueIcon', 'falseIcon', 'trueLabel', 'falseLabel', 'i18nLoadedAt', 'i18n', 'isAttachment', 'image']);

  if (image) return _react2.default.createElement(
    _button.Button,
    _extends({ theme: _toggleButton2.default
    }, others),
    flag && _react2.default.createElement(_font_icon2.default, { className: _toggleButton2.default.fontIcon, value: 'arrow_drop_down' }) || _react2.default.createElement(_font_icon2.default, { className: _toggleButton2.default.fontIcon, value: 'arrow_drop_up' }),
    flag && _react2.default.createElement(_avatar.Avatar, { theme: _toggleButton2.default, image: image }),
    flag && trueLabel || falseLabel,
    isAttachment && _react2.default.createElement(_font_icon2.default, { className: _toggleButton2.default.fontIcon, value: 'attachment' })
  );else return _react2.default.createElement(
    _button.Button,
    _extends({ theme: _toggleButton2.default,
      icon: flag && trueIcon || falseIcon,
      label: flag && trueLabel || falseLabel
    }, others),
    isAttachment && _react2.default.createElement(_font_icon2.default, { className: _toggleButton2.default.fontIcon, value: 'attachment' })
  );
}

exports.default = (0, _reactI18next.translate)()(ToggleButton);

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawRightSidebar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rightSidebar = __webpack_require__(2551);

var _rightSidebar2 = _interopRequireDefault(_rightSidebar);

var _layout = __webpack_require__(85);

var _twoColumnLayout = __webpack_require__(205);

var _twoColumnLayout2 = _interopRequireDefault(_twoColumnLayout);

var _pickupDiariesPage = __webpack_require__(1062);

var _pickupDiariesPage2 = _interopRequireDefault(_pickupDiariesPage);

var _notificationsPage = __webpack_require__(2555);

var _notificationsPage2 = _interopRequireDefault(_notificationsPage);

var _attachmentsPage = __webpack_require__(2567);

var _attachmentsPage2 = _interopRequireDefault(_attachmentsPage);

var _userTimelinePage = __webpack_require__(2569);

var _userTimelinePage2 = _interopRequireDefault(_userTimelinePage);

var _searchTimelinePage = __webpack_require__(2581);

var _searchTimelinePage2 = _interopRequireDefault(_searchTimelinePage);

var _unreadTimelinePage = __webpack_require__(2586);

var _unreadTimelinePage2 = _interopRequireDefault(_unreadTimelinePage);

var _membersPage = __webpack_require__(2588);

var _membersPage2 = _interopRequireDefault(_membersPage);

var _likesReadersPage = __webpack_require__(2595);

var _likesReadersPage2 = _interopRequireDefault(_likesReadersPage);

var _kpiPage = __webpack_require__(2601);

var _kpiPage2 = _interopRequireDefault(_kpiPage);

var _kpiChartPage = __webpack_require__(2604);

var _kpiChartPage2 = _interopRequireDefault(_kpiChartPage);

var _reportStatusPage = __webpack_require__(2621);

var _reportStatusPage2 = _interopRequireDefault(_reportStatusPage);

var _dashboardPage = __webpack_require__(2659);

var _dashboardPage2 = _interopRequireDefault(_dashboardPage);

var _subGroupTimelinePage = __webpack_require__(2663);

var _subGroupTimelinePage2 = _interopRequireDefault(_subGroupTimelinePage);

var _chatRoomsPage = __webpack_require__(2665);

var _chatRoomsPage2 = _interopRequireDefault(_chatRoomsPage);

var _chatMessagesPage = __webpack_require__(1088);

var _chatMessagesPage2 = _interopRequireDefault(_chatMessagesPage);

var _googleCalendarPage = __webpack_require__(2691);

var _googleCalendarPage2 = _interopRequireDefault(_googleCalendarPage);

var _pdfPreviewPage = __webpack_require__(2764);

var _pdfPreviewPage2 = _interopRequireDefault(_pdfPreviewPage);

var _googleDocPage = __webpack_require__(2765);

var _googleDocPage2 = _interopRequireDefault(_googleDocPage);

var _reactRouter = __webpack_require__(245);

var _route = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/right-sidebar.jsx

var RightSidebar = function (_React$Component) {
  _inherits(RightSidebar, _React$Component);

  function RightSidebar() {
    _classCallCheck(this, RightSidebar);

    return _possibleConstructorReturn(this, (RightSidebar.__proto__ || Object.getPrototypeOf(RightSidebar)).apply(this, arguments));
  }

  _createClass(RightSidebar, [{
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps) {
      if (this.props.name != nextProps.name && nextProps.route && nextProps.route.locationBeforeTransitions) {
        var pathname = nextProps.route.locationBeforeTransitions.pathname;
        var paths = pathname.split('/');
        if (!_.isNaN(parseInt(paths[paths.length - 1]))) paths.pop();
        if (paths[paths.length - 1] == 'pickup') paths.pop();
        if (paths[paths.length - 1] == 'messages') paths.pop();
        _reactRouter.hashHistory.push(paths.join('/'));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          user = _props.user,
          group = _props.group,
          name = _props.name,
          params = _props.params,
          children = _props.children;


      var Component;
      switch (name) {
        case 'pickup_diaries':
          Component = _pickupDiariesPage2.default;
          break;
        case 'notifications':
          Component = _notificationsPage2.default;
          break;
        case 'attachments':
        case 'voice_player':
          Component = _attachmentsPage2.default;
          break;
        case 'user_timeline':
          Component = _userTimelinePage2.default;
          break;
        case 'search_timeline':
          Component = _searchTimelinePage2.default;
          break;
        case 'unread_timeline':
          Component = _unreadTimelinePage2.default;
          break;
        case 'group_members':
          Component = _membersPage2.default;
          break;
        case 'likes_readers':
          Component = _likesReadersPage2.default;
          break;
        case 'kpi_page':
          Component = _kpiPage2.default;
          break;
        case 'kpi_chart':
          Component = _kpiChartPage2.default;
          break;
        case 'report_status':
          Component = _reportStatusPage2.default;
          break;
        case 'dashboard':
          Component = _dashboardPage2.default;
          break;
        case 'group_timeline':
          Component = _subGroupTimelinePage2.default;
          break;
        case 'chat_rooms':
          Component = _chatRoomsPage2.default;
          break;
        case 'chat_messages':
          Component = _chatMessagesPage2.default;
          break;
        case 'google_calendar':
          Component = _googleCalendarPage2.default;
          break;
        case 'pdf_preview':
          Component = _pdfPreviewPage2.default;
          break;
        case 'google_doc':
          Component = _googleDocPage2.default;
          break;
      }

      if (!children && !Component) return null;

      return children || Component && _react2.default.createElement(Component, { params: params, user: user, group: group });
    }
  }]);

  return RightSidebar;
}(_react2.default.Component);

var RawRightSidebar = exports.RawRightSidebar = RightSidebar;
exports.default = (0, _rightSidebar2.default)(RightSidebar);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */



/**
 * Performs equality by iterating through keys on an object and returning
 * false when any key has values which are not strictly equal between
 * objA and objB. Returns true when the values of all keys are strictly equal.
 *
 * @return {boolean}
 */

function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }
  var key;
  // Test for A's keys different from B.
  for (key in objA) {
    if (objA.hasOwnProperty(key) && (!objB.hasOwnProperty(key) || objA[key] !== objB[key])) {
      return false;
    }
  }
  // Test for B's keys missing from A.
  for (key in objB) {
    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}

/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this Mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 */
var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
  }
};

module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _translateDOMPositionXY = __webpack_require__(2642);

var _translateDOMPositionXY2 = _interopRequireDefault(_translateDOMPositionXY);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FixedDataTableTranslateDOMPosition( /*object*/style, /*number*/x, /*number*/y) {
  var initialRender = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (initialRender) {
    style.left = x + 'px';
    style.top = y + 'px';
  } else {
    (0, _translateDOMPositionXY2.default)(style, x, y);
  }
} /**
   * Copyright Schrodinger, LLC
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * @providesModule FixedDataTableTranslateDOMPosition
   * @typechecks
   */

module.exports = FixedDataTableTranslateDOMPosition;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule clamp
 * @typechecks
 */

/**
 * Clamps (or clips or confines) the value to be between min and max.
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

module.exports = clamp;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatShortWeekday = exports.formatWeekday = exports.formatMonth = exports.formatMonthYear = exports.formatLongDate = exports.formatDate = void 0;

var _getUserLocale = _interopRequireDefault(__webpack_require__(2707));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getFormatter(options) {
  return function (locale, date) {
    return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
  };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 */


function toSafeHour(date) {
  var safeDate = new Date(date);
  return new Date(safeDate.setHours(12));
}

function getSafeFormatter(options) {
  return function (locale, date) {
    return getFormatter(options)(locale, toSafeHour(date));
  };
}

var formatDateOptions = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric'
};
var formatLongDateOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
};
var formatMonthYearOptions = {
  month: 'long',
  year: 'numeric'
};
var formatMonthOptions = {
  month: 'long'
};
var formatWeekdayOptions = {
  weekday: 'long'
};
var formatShortWeekdayOptions = {
  weekday: 'short'
};
var formatDate = getSafeFormatter(formatDateOptions);
exports.formatDate = formatDate;
var formatLongDate = getSafeFormatter(formatLongDateOptions);
exports.formatLongDate = formatLongDate;
var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
exports.formatMonthYear = formatMonthYear;
var formatMonth = getSafeFormatter(formatMonthOptions);
exports.formatMonth = formatMonth;
var formatWeekday = getSafeFormatter(formatWeekdayOptions);
exports.formatWeekday = formatWeekday;
var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
exports.formatShortWeekday = formatShortWeekday;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TileGroup;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _Flex = _interopRequireDefault(__webpack_require__(576));

var _utils = __webpack_require__(1094);

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TileGroup(_ref) {
  var className = _ref.className,
      count = _ref.count,
      dateTransform = _ref.dateTransform,
      dateType = _ref.dateType,
      end = _ref.end,
      hover = _ref.hover,
      offset = _ref.offset,
      start = _ref.start,
      step = _ref.step,
      Tile = _ref.tile,
      value = _ref.value,
      valueType = _ref.valueType,
      tileProps = _objectWithoutProperties(_ref, ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"]);

  var tiles = [];

  for (var point = start; point <= end; point += step) {
    var date = dateTransform(point);
    tiles.push(_react["default"].createElement(Tile, _extends({
      key: date.getTime(),
      classes: (0, _utils.getTileClasses)({
        value: value,
        valueType: valueType,
        date: date,
        dateType: dateType,
        hover: hover
      }),
      date: date,
      point: point
    }, tileProps)));
  }

  return _react["default"].createElement(_Flex["default"], {
    className: className,
    count: count,
    offset: offset,
    wrap: true
  }, tiles);
}

TileGroup.propTypes = _objectSpread({}, _propTypes2.tileGroupProps, {
  activeStartDate: _propTypes["default"].instanceOf(Date),
  count: _propTypes["default"].number,
  dateTransform: _propTypes["default"].func.isRequired,
  offset: _propTypes["default"].number,
  step: _propTypes["default"].number,
  tile: _propTypes["default"].func.isRequired
});
TileGroup.defaultProps = {
  count: 3,
  step: 1
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _mergeClassNames = _interopRequireDefault(__webpack_require__(286));

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tile =
/*#__PURE__*/
function (_Component) {
  _inherits(Tile, _Component);

  function Tile() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(Tile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeStartDate = _this$props.activeStartDate,
          children = _this$props.children,
          classes = _this$props.classes,
          date = _this$props.date,
          formatAbbr = _this$props.formatAbbr,
          locale = _this$props.locale,
          maxDate = _this$props.maxDate,
          maxDateTransform = _this$props.maxDateTransform,
          minDate = _this$props.minDate,
          minDateTransform = _this$props.minDateTransform,
          onClick = _this$props.onClick,
          onMouseOver = _this$props.onMouseOver,
          style = _this$props.style,
          tileDisabled = _this$props.tileDisabled,
          view = _this$props.view;
      var _this$state = this.state,
          tileClassName = _this$state.tileClassName,
          tileContent = _this$state.tileContent;
      return _react["default"].createElement("button", {
        className: (0, _mergeClassNames["default"])(classes, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
          activeStartDate: activeStartDate,
          date: date,
          view: view
        }),
        onClick: onClick && function () {
          return onClick(date);
        },
        onFocus: onMouseOver && function () {
          return onMouseOver(date);
        },
        onMouseOver: onMouseOver && function () {
          return onMouseOver(date);
        },
        style: style,
        type: "button"
      }, formatAbbr ? _react["default"].createElement("abbr", {
        "aria-label": formatAbbr(locale, date)
      }, children) : children, tileContent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var date = nextProps.date,
          tileClassName = nextProps.tileClassName,
          tileContent = nextProps.tileContent,
          view = nextProps.view;
      var nextState = {};

      if (tileClassName !== prevState.tileClassNameProps) {
        nextState.tileClassName = typeof tileClassName === 'function' ? tileClassName({
          date: date,
          view: view
        }) : tileClassName;
        nextState.tileClassNameProps = tileClassName;
      }

      if (tileContent !== prevState.tileContentProps) {
        nextState.tileContent = typeof tileContent === 'function' ? tileContent({
          date: date,
          view: view
        }) : tileContent;
        nextState.tileContentProps = tileContent;
      }

      return nextState;
    }
  }]);

  return Tile;
}(_react.Component);

exports["default"] = Tile;
Tile.propTypes = _objectSpread({}, _propTypes2.tileProps, {
  children: _propTypes["default"].node.isRequired,
  formatAbbr: _propTypes["default"].func,
  maxDateTransform: _propTypes["default"].func.isRequired,
  minDateTransform: _propTypes["default"].func.isRequired
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return version; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "13.3.1";


//# sourceMappingURL=packageMetadata.js.map


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthorityType; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Authority types supported by MSAL.
 */
var AuthorityType;
(function (AuthorityType) {
    AuthorityType[AuthorityType["Default"] = 0] = "Default";
    AuthorityType[AuthorityType["Adfs"] = 1] = "Adfs";
    AuthorityType[AuthorityType["Dsts"] = 2] = "Dsts";
    AuthorityType[AuthorityType["Ciam"] = 3] = "Ciam";
})(AuthorityType || (AuthorityType = {}));


//# sourceMappingURL=AuthorityType.js.map


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CredentialEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_ClientAuthError_js__ = __webpack_require__(57);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Base type for credentials to be stored in the cache: eg: ACCESS_TOKEN, ID_TOKEN etc
 *
 * Key:Value Schema:
 *
 * Key: <home_account_id*>-<environment>-<credential_type>-<client_id>-<realm*>-<target*>-<requestedClaims*>-<scheme*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, usually only used for refresh tokens
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 *      tokenType: Matches the authentication scheme for which the token was issued (i.e. Bearer or pop)
 *      requestedClaimsHash: Matches the SHA 256 hash of the claims object included in the token request
 *      userAssertionHash: Matches the SHA 256 hash of the obo_assertion for the OBO flow
 * }
 */
var CredentialEntity = /** @class */ (function () {
    function CredentialEntity() {
    }
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */
    CredentialEntity.prototype.generateAccountId = function () {
        return CredentialEntity.generateAccountIdForCacheKey(this.homeAccountId, this.environment);
    };
    /**
     * Generate Credential Id key component as per the schema: <credential_type>-<client_id>-<realm>
     */
    CredentialEntity.prototype.generateCredentialId = function () {
        return CredentialEntity.generateCredentialIdForCacheKey(this.credentialType, this.clientId, this.realm, this.familyId);
    };
    /**
     * Generate target key component as per schema: <target>
     */
    CredentialEntity.prototype.generateTarget = function () {
        return CredentialEntity.generateTargetForCacheKey(this.target);
    };
    /**
     * generates credential key
     */
    CredentialEntity.prototype.generateCredentialKey = function () {
        return CredentialEntity.generateCredentialCacheKey(this.homeAccountId, this.environment, this.credentialType, this.clientId, this.realm, this.target, this.familyId, this.tokenType, this.requestedClaimsHash);
    };
    /**
     * returns the type of the cache (in this case credential)
     */
    CredentialEntity.prototype.generateType = function () {
        switch (this.credentialType) {
            case __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["n" /* CredentialType */].ID_TOKEN:
                return __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["j" /* CacheType */].ID_TOKEN;
            case __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN:
            case __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN_WITH_AUTH_SCHEME:
                return __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["j" /* CacheType */].ACCESS_TOKEN;
            case __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["n" /* CredentialType */].REFRESH_TOKEN:
                return __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["j" /* CacheType */].REFRESH_TOKEN;
            default: {
                throw __WEBPACK_IMPORTED_MODULE_1__error_ClientAuthError_js__["a" /* ClientAuthError */].createUnexpectedCredentialTypeError();
            }
        }
    };
    /**
     * generates credential key
     * <home_account_id*>-\<environment>-<credential_type>-<client_id>-<realm\*>-<target\*>-<scheme\*>
     */
    CredentialEntity.generateCredentialCacheKey = function (homeAccountId, environment, credentialType, clientId, realm, target, familyId, tokenType, requestedClaimsHash) {
        var credentialKey = [
            this.generateAccountIdForCacheKey(homeAccountId, environment),
            this.generateCredentialIdForCacheKey(credentialType, clientId, realm, familyId),
            this.generateTargetForCacheKey(target),
            this.generateClaimsHashForCacheKey(requestedClaimsHash),
            this.generateSchemeForCacheKey(tokenType)
        ];
        return credentialKey.join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * generates Account Id for keys
     * @param homeAccountId
     * @param environment
     */
    CredentialEntity.generateAccountIdForCacheKey = function (homeAccountId, environment) {
        var accountId = [homeAccountId, environment];
        return accountId.join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generates Credential Id for keys
     * @param credentialType
     * @param realm
     * @param clientId
     * @param familyId
     */
    CredentialEntity.generateCredentialIdForCacheKey = function (credentialType, clientId, realm, familyId) {
        var clientOrFamilyId = credentialType === __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["n" /* CredentialType */].REFRESH_TOKEN
            ? familyId || clientId
            : clientId;
        var credentialId = [
            credentialType,
            clientOrFamilyId,
            realm || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
        ];
        return credentialId.join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generate target key component as per schema: <target>
     */
    CredentialEntity.generateTargetForCacheKey = function (scopes) {
        return (scopes || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING).toLowerCase();
    };
    /**
     * Generate requested claims key component as per schema: <requestedClaims>
     */
    CredentialEntity.generateClaimsHashForCacheKey = function (requestedClaimsHash) {
        return (requestedClaimsHash || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING).toLowerCase();
    };
    /**
     * Generate scheme key componenet as per schema: <scheme>
     */
    CredentialEntity.generateSchemeForCacheKey = function (tokenType) {
        /*
         * PoP Tokens and SSH certs include scheme in cache key
         * Cast to lowercase to handle "bearer" from ADFS
         */
        return (tokenType && tokenType.toLowerCase() !== __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["e" /* AuthenticationScheme */].BEARER.toLowerCase()) ? tokenType.toLowerCase() : __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
    };
    return CredentialEntity;
}());


//# sourceMappingURL=CredentialEntity.js.map


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopTokenGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_TimeUtils_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_UrlString_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__telemetry_performance_PerformanceEvent_js__ = __webpack_require__(153);
/*! @azure/msal-common v13.3.1 2023-10-27 */






/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var KeyLocation;
(function (KeyLocation) {
    KeyLocation["SW"] = "sw";
    KeyLocation["UHW"] = "uhw";
})(KeyLocation || (KeyLocation = {}));
var PopTokenGenerator = /** @class */ (function () {
    function PopTokenGenerator(cryptoUtils, performanceClient) {
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */
    PopTokenGenerator.prototype.generateCnf = function (request) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var reqCnf, reqCnfString, _c;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_3__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].PopTokenGenerateCnf, request.correlationId);
                        (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_3__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].PopTokenGenerateKid, request.correlationId);
                        return [4 /*yield*/, this.generateKid(request)];
                    case 1:
                        reqCnf = _d.sent();
                        reqCnfString = this.cryptoUtils.base64Encode(JSON.stringify(reqCnf));
                        _c = {
                            kid: reqCnf.kid,
                            reqCnfString: reqCnfString
                        };
                        return [4 /*yield*/, this.cryptoUtils.hashString(reqCnfString)];
                    case 2: return [2 /*return*/, (_c.reqCnfHash = _d.sent(),
                            _c)];
                }
            });
        });
    };
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */
    PopTokenGenerator.prototype.generateKid = function (request) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var kidThumbprint;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_3__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].PopTokenGenerateKid, request.correlationId);
                        return [4 /*yield*/, this.cryptoUtils.getPublicKeyThumbprint(request)];
                    case 1:
                        kidThumbprint = _b.sent();
                        return [2 /*return*/, {
                                kid: kidThumbprint,
                                xms_ksl: KeyLocation.SW
                            }];
                }
            });
        });
    };
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */
    PopTokenGenerator.prototype.signPopToken = function (accessToken, keyId, request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.signPayload(accessToken, keyId, request)];
            });
        });
    };
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */
    PopTokenGenerator.prototype.signPayload = function (payload, keyId, request, claims) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var resourceRequestMethod, resourceRequestUri, shrClaims, shrNonce, resourceUrlString, resourceUrlComponents;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resourceRequestMethod = request.resourceRequestMethod, resourceRequestUri = request.resourceRequestUri, shrClaims = request.shrClaims, shrNonce = request.shrNonce;
                        resourceUrlString = (resourceRequestUri) ? new __WEBPACK_IMPORTED_MODULE_2__url_UrlString_js__["a" /* UrlString */](resourceRequestUri) : undefined;
                        resourceUrlComponents = resourceUrlString === null || resourceUrlString === void 0 ? void 0 : resourceUrlString.getUrlComponents();
                        return [4 /*yield*/, this.cryptoUtils.signJwt(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({ at: payload, ts: __WEBPACK_IMPORTED_MODULE_1__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds(), m: resourceRequestMethod === null || resourceRequestMethod === void 0 ? void 0 : resourceRequestMethod.toUpperCase(), u: resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.HostNameAndPort, nonce: shrNonce || this.cryptoUtils.createNewGuid(), p: resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.AbsolutePath, q: (resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.QueryString) ? [[], resourceUrlComponents.QueryString] : undefined, client_claims: shrClaims || undefined }, claims), keyId, request.correlationId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return PopTokenGenerator;
}());


//# sourceMappingURL=PopTokenGenerator.js.map


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(754),
    baseKeysIn = __webpack_require__(2847),
    isArrayLike = __webpack_require__(159);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(230);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(1150);
var redefine = __webpack_require__(93);
var hide = __webpack_require__(92);
var fails = __webpack_require__(37);
var defined = __webpack_require__(123);
var wks = __webpack_require__(52);
var regexpExec = __webpack_require__(593);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var hide = __webpack_require__(92);
var uid = __webpack_require__(190);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(166) || !__webpack_require__(37)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(34)[K];
});


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function isNodeJS() {
  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(80);

var emptyObject = __webpack_require__(302);
var _invariant = __webpack_require__(60);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(156);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(137);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(1184);

var _PathUtils = __webpack_require__(157);

var _runTransitionHook = __webpack_require__(411);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(304);

var _LocationUtils = __webpack_require__(215);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(215);

var _DOMUtils = __webpack_require__(305);

var _DOMStateStorage = __webpack_require__(605);

var _PathUtils = __webpack_require__(157);

var _ExecutionEnvironment = __webpack_require__(413);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(607);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(608);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(1192);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(1193);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(1214);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1254);


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1269)();
}


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(745);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(423),
    eq = __webpack_require__(249);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(749);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(174),
    isObject = __webpack_require__(98);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(250),
    overRest = __webpack_require__(752),
    setToString = __webpack_require__(753);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(249),
    isArrayLike = __webpack_require__(159),
    isIndex = __webpack_require__(428),
    isObject = __webpack_require__(98);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 427 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 428 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1296),
    baseUnary = __webpack_require__(251),
    nodeUtil = __webpack_require__(430);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(744);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(175),
    root = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1313),
    mapCacheDelete = __webpack_require__(1320),
    mapCacheGet = __webpack_require__(1322),
    mapCacheHas = __webpack_require__(1323),
    mapCacheSet = __webpack_require__(1324);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1325),
    isObjectLike = __webpack_require__(117);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(432),
    setCacheAdd = __webpack_require__(1326),
    setCacheHas = __webpack_require__(1327);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 436 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(764),
    stubArray = __webpack_require__(765);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(62),
    isSymbol = __webpack_require__(219);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1350);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(68);
var JsonBuilder = __webpack_require__(441);
var JsonParser = __webpack_require__(442);

function buildRequest(req) {
  var httpRequest = req.httpRequest;
  var api = req.service.api;
  var target = api.targetPrefix + '.' + api.operations[req.operation].name;
  var version = api.jsonVersion || '1.0';
  var input = api.operations[req.operation].input;
  var builder = new JsonBuilder();

  if (version === 1) version = '1.0';
  httpRequest.body = builder.build(req.params || {}, input);
  httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
  httpRequest.headers['X-Amz-Target'] = target;
}

function extractError(resp) {
  var error = {};
  var httpResponse = resp.httpResponse;

  error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
  if (typeof error.code === 'string') {
    error.code = error.code.split(':')[0];
  }

  if (httpResponse.body.length > 0) {
    try {
      var e = JSON.parse(httpResponse.body.toString());
      if (e.__type || e.code) {
        error.code = (e.__type || e.code).split('#').pop();
      }
      if (error.code === 'RequestEntityTooLarge') {
        error.message = 'Request body must be less than 1 MB';
      } else {
        error.message = (e.message || e.Message || null);
      }
    } catch (e) {
      error.statusCode = httpResponse.statusCode;
      error.message = httpResponse.statusMessage;
    }
  } else {
    error.statusCode = httpResponse.statusCode;
    error.message = httpResponse.statusCode.toString();
  }

  resp.error = util.error(new Error(), error);
}

function extractData(resp) {
  var body = resp.httpResponse.body.toString() || '{}';
  if (resp.request.service.config.convertResponseTypes === false) {
    resp.data = JSON.parse(body);
  } else {
    var operation = resp.request.service.api.operations[resp.request.operation];
    var shape = operation.output || {};
    var parser = new JsonParser();
    resp.data = parser.parse(body, shape);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(68);

function JsonBuilder() { }

JsonBuilder.prototype.build = function(value, shape) {
  return JSON.stringify(translate(value, shape));
};

function translate(value, shape) {
  if (!shape || value === undefined || value === null) return undefined;

  switch (shape.type) {
    case 'structure': return translateStructure(value, shape);
    case 'map': return translateMap(value, shape);
    case 'list': return translateList(value, shape);
    default: return translateScalar(value, shape);
  }
}

function translateStructure(structure, shape) {
  var struct = {};
  util.each(structure, function(name, value) {
    var memberShape = shape.members[name];
    if (memberShape) {
      if (memberShape.location !== 'body') return;
      var locationName = memberShape.isLocationName ? memberShape.name : name;
      var result = translate(value, memberShape);
      if (result !== undefined) struct[locationName] = result;
    }
  });
  return struct;
}

function translateList(list, shape) {
  var out = [];
  util.arrayEach(list, function(value) {
    var result = translate(value, shape.member);
    if (result !== undefined) out.push(result);
  });
  return out;
}

function translateMap(map, shape) {
  var out = {};
  util.each(map, function(key, value) {
    var result = translate(value, shape.value);
    if (result !== undefined) out[key] = result;
  });
  return out;
}

function translateScalar(value, shape) {
  return shape.toWireFormat(value);
}

module.exports = JsonBuilder;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(68);

function JsonParser() { }

JsonParser.prototype.parse = function(value, shape) {
  return translate(JSON.parse(value), shape);
};

function translate(value, shape) {
  if (!shape || value === undefined) return undefined;

  switch (shape.type) {
    case 'structure': return translateStructure(value, shape);
    case 'map': return translateMap(value, shape);
    case 'list': return translateList(value, shape);
    default: return translateScalar(value, shape);
  }
}

function translateStructure(structure, shape) {
  if (structure == null) return undefined;

  var struct = {};
  var shapeMembers = shape.members;
  util.each(shapeMembers, function(name, memberShape) {
    var locationName = memberShape.isLocationName ? memberShape.name : name;
    if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
      var value = structure[locationName];
      var result = translate(value, memberShape);
      if (result !== undefined) struct[name] = result;
    }
  });
  return struct;
}

function translateList(list, shape) {
  if (list == null) return undefined;

  var out = [];
  util.arrayEach(list, function(value) {
    var result = translate(value, shape.member);
    if (result === undefined) out.push(null);
    else out.push(result);
  });
  return out;
}

function translateMap(map, shape) {
  if (map == null) return undefined;

  var out = {};
  util.each(map, function(key, value) {
    var result = translate(value, shape.value);
    if (result === undefined) out[key] = null;
    else out[key] = result;
  });
  return out;
}

function translateScalar(value, shape) {
  return shape.toType(value);
}

module.exports = JsonParser;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 444 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 445 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1371),
    isObjectLike = __webpack_require__(257);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(140),
    stubFalse = __webpack_require__(1372);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1373),
    baseUnary = __webpack_require__(1374),
    nodeUtil = __webpack_require__(1375);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(176),
    root = __webpack_require__(140);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1408),
    mapCacheDelete = __webpack_require__(1415),
    mapCacheGet = __webpack_require__(1417),
    mapCacheHas = __webpack_require__(1418),
    mapCacheSet = __webpack_require__(1419);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(120),
    isSymbol = __webpack_require__(453);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(254),
    isObjectLike = __webpack_require__(257);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","RAILS_ENV":"production","BUILD_NO":"202507040022","REACT_NATIVE":false}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1465);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1466);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(66)))

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

(function(exports) {
  "use strict";

  function isArray(obj) {
    if (obj !== null) {
      return Object.prototype.toString.call(obj) === "[object Array]";
    } else {
      return false;
    }
  }

  function isObject(obj) {
    if (obj !== null) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    } else {
      return false;
    }
  }

  function strictDeepEqual(first, second) {
    // Check the scalar case first.
    if (first === second) {
      return true;
    }

    // Check if they are the same type.
    var firstType = Object.prototype.toString.call(first);
    if (firstType !== Object.prototype.toString.call(second)) {
      return false;
    }
    // We know that first and second have the same type so we can just check the
    // first type from now on.
    if (isArray(first) === true) {
      // Short circuit if they're not the same length;
      if (first.length !== second.length) {
        return false;
      }
      for (var i = 0; i < first.length; i++) {
        if (strictDeepEqual(first[i], second[i]) === false) {
          return false;
        }
      }
      return true;
    }
    if (isObject(first) === true) {
      // An object is equal if it has the same key/value pairs.
      var keysSeen = {};
      for (var key in first) {
        if (hasOwnProperty.call(first, key)) {
          if (strictDeepEqual(first[key], second[key]) === false) {
            return false;
          }
          keysSeen[key] = true;
        }
      }
      // Now check that there aren't any keys in second that weren't
      // in first.
      for (var key2 in second) {
        if (hasOwnProperty.call(second, key2)) {
          if (keysSeen[key2] !== true) {
            return false;
          }
        }
      }
      return true;
    }
    return false;
  }

  function isFalse(obj) {
    // From the spec:
    // A false value corresponds to the following values:
    // Empty list
    // Empty object
    // Empty string
    // False boolean
    // null value

    // First check the scalar values.
    if (obj === "" || obj === false || obj === null) {
        return true;
    } else if (isArray(obj) && obj.length === 0) {
        // Check for an empty array.
        return true;
    } else if (isObject(obj)) {
        // Check for an empty object.
        for (var key in obj) {
            // If there are any keys, then
            // the object is not empty so the object
            // is not false.
            if (obj.hasOwnProperty(key)) {
              return false;
            }
        }
        return true;
    } else {
        return false;
    }
  }

  function objValues(obj) {
    var keys = Object.keys(obj);
    var values = [];
    for (var i = 0; i < keys.length; i++) {
      values.push(obj[keys[i]]);
    }
    return values;
  }

  function merge(a, b) {
      var merged = {};
      for (var key in a) {
          merged[key] = a[key];
      }
      for (var key2 in b) {
          merged[key2] = b[key2];
      }
      return merged;
  }

  var trimLeft;
  if (typeof String.prototype.trimLeft === "function") {
    trimLeft = function(str) {
      return str.trimLeft();
    };
  } else {
    trimLeft = function(str) {
      return str.match(/^\s*(.*)/)[1];
    };
  }

  // Type constants used to define functions.
  var TYPE_NUMBER = 0;
  var TYPE_ANY = 1;
  var TYPE_STRING = 2;
  var TYPE_ARRAY = 3;
  var TYPE_OBJECT = 4;
  var TYPE_BOOLEAN = 5;
  var TYPE_EXPREF = 6;
  var TYPE_NULL = 7;
  var TYPE_ARRAY_NUMBER = 8;
  var TYPE_ARRAY_STRING = 9;

  var TOK_EOF = "EOF";
  var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
  var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
  var TOK_RBRACKET = "Rbracket";
  var TOK_RPAREN = "Rparen";
  var TOK_COMMA = "Comma";
  var TOK_COLON = "Colon";
  var TOK_RBRACE = "Rbrace";
  var TOK_NUMBER = "Number";
  var TOK_CURRENT = "Current";
  var TOK_EXPREF = "Expref";
  var TOK_PIPE = "Pipe";
  var TOK_OR = "Or";
  var TOK_AND = "And";
  var TOK_EQ = "EQ";
  var TOK_GT = "GT";
  var TOK_LT = "LT";
  var TOK_GTE = "GTE";
  var TOK_LTE = "LTE";
  var TOK_NE = "NE";
  var TOK_FLATTEN = "Flatten";
  var TOK_STAR = "Star";
  var TOK_FILTER = "Filter";
  var TOK_DOT = "Dot";
  var TOK_NOT = "Not";
  var TOK_LBRACE = "Lbrace";
  var TOK_LBRACKET = "Lbracket";
  var TOK_LPAREN= "Lparen";
  var TOK_LITERAL= "Literal";

  // The "&", "[", "<", ">" tokens
  // are not in basicToken because
  // there are two token variants
  // ("&&", "[?", "<=", ">=").  This is specially handled
  // below.

  var basicTokens = {
    ".": TOK_DOT,
    "*": TOK_STAR,
    ",": TOK_COMMA,
    ":": TOK_COLON,
    "{": TOK_LBRACE,
    "}": TOK_RBRACE,
    "]": TOK_RBRACKET,
    "(": TOK_LPAREN,
    ")": TOK_RPAREN,
    "@": TOK_CURRENT
  };

  var operatorStartToken = {
      "<": true,
      ">": true,
      "=": true,
      "!": true
  };

  var skipChars = {
      " ": true,
      "\t": true,
      "\n": true
  };


  function isAlpha(ch) {
      return (ch >= "a" && ch <= "z") ||
             (ch >= "A" && ch <= "Z") ||
             ch === "_";
  }

  function isNum(ch) {
      return (ch >= "0" && ch <= "9") ||
             ch === "-";
  }
  function isAlphaNum(ch) {
      return (ch >= "a" && ch <= "z") ||
             (ch >= "A" && ch <= "Z") ||
             (ch >= "0" && ch <= "9") ||
             ch === "_";
  }

  function Lexer() {
  }
  Lexer.prototype = {
      tokenize: function(stream) {
          var tokens = [];
          this._current = 0;
          var start;
          var identifier;
          var token;
          while (this._current < stream.length) {
              if (isAlpha(stream[this._current])) {
                  start = this._current;
                  identifier = this._consumeUnquotedIdentifier(stream);
                  tokens.push({type: TOK_UNQUOTEDIDENTIFIER,
                               value: identifier,
                               start: start});
              } else if (basicTokens[stream[this._current]] !== undefined) {
                  tokens.push({type: basicTokens[stream[this._current]],
                              value: stream[this._current],
                              start: this._current});
                  this._current++;
              } else if (isNum(stream[this._current])) {
                  token = this._consumeNumber(stream);
                  tokens.push(token);
              } else if (stream[this._current] === "[") {
                  // No need to increment this._current.  This happens
                  // in _consumeLBracket
                  token = this._consumeLBracket(stream);
                  tokens.push(token);
              } else if (stream[this._current] === "\"") {
                  start = this._current;
                  identifier = this._consumeQuotedIdentifier(stream);
                  tokens.push({type: TOK_QUOTEDIDENTIFIER,
                               value: identifier,
                               start: start});
              } else if (stream[this._current] === "'") {
                  start = this._current;
                  identifier = this._consumeRawStringLiteral(stream);
                  tokens.push({type: TOK_LITERAL,
                               value: identifier,
                               start: start});
              } else if (stream[this._current] === "`") {
                  start = this._current;
                  var literal = this._consumeLiteral(stream);
                  tokens.push({type: TOK_LITERAL,
                               value: literal,
                               start: start});
              } else if (operatorStartToken[stream[this._current]] !== undefined) {
                  tokens.push(this._consumeOperator(stream));
              } else if (skipChars[stream[this._current]] !== undefined) {
                  // Ignore whitespace.
                  this._current++;
              } else if (stream[this._current] === "&") {
                  start = this._current;
                  this._current++;
                  if (stream[this._current] === "&") {
                      this._current++;
                      tokens.push({type: TOK_AND, value: "&&", start: start});
                  } else {
                      tokens.push({type: TOK_EXPREF, value: "&", start: start});
                  }
              } else if (stream[this._current] === "|") {
                  start = this._current;
                  this._current++;
                  if (stream[this._current] === "|") {
                      this._current++;
                      tokens.push({type: TOK_OR, value: "||", start: start});
                  } else {
                      tokens.push({type: TOK_PIPE, value: "|", start: start});
                  }
              } else {
                  var error = new Error("Unknown character:" + stream[this._current]);
                  error.name = "LexerError";
                  throw error;
              }
          }
          return tokens;
      },

      _consumeUnquotedIdentifier: function(stream) {
          var start = this._current;
          this._current++;
          while (this._current < stream.length && isAlphaNum(stream[this._current])) {
              this._current++;
          }
          return stream.slice(start, this._current);
      },

      _consumeQuotedIdentifier: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (stream[this._current] !== "\"" && this._current < maxLength) {
              // You can escape a double quote and you can escape an escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "\"")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          this._current++;
          return JSON.parse(stream.slice(start, this._current));
      },

      _consumeRawStringLiteral: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (stream[this._current] !== "'" && this._current < maxLength) {
              // You can escape a single quote and you can escape an escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "'")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          this._current++;
          var literal = stream.slice(start + 1, this._current - 1);
          return literal.replace("\\'", "'");
      },

      _consumeNumber: function(stream) {
          var start = this._current;
          this._current++;
          var maxLength = stream.length;
          while (isNum(stream[this._current]) && this._current < maxLength) {
              this._current++;
          }
          var value = parseInt(stream.slice(start, this._current));
          return {type: TOK_NUMBER, value: value, start: start};
      },

      _consumeLBracket: function(stream) {
          var start = this._current;
          this._current++;
          if (stream[this._current] === "?") {
              this._current++;
              return {type: TOK_FILTER, value: "[?", start: start};
          } else if (stream[this._current] === "]") {
              this._current++;
              return {type: TOK_FLATTEN, value: "[]", start: start};
          } else {
              return {type: TOK_LBRACKET, value: "[", start: start};
          }
      },

      _consumeOperator: function(stream) {
          var start = this._current;
          var startingChar = stream[start];
          this._current++;
          if (startingChar === "!") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_NE, value: "!=", start: start};
              } else {
                return {type: TOK_NOT, value: "!", start: start};
              }
          } else if (startingChar === "<") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_LTE, value: "<=", start: start};
              } else {
                  return {type: TOK_LT, value: "<", start: start};
              }
          } else if (startingChar === ">") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_GTE, value: ">=", start: start};
              } else {
                  return {type: TOK_GT, value: ">", start: start};
              }
          } else if (startingChar === "=") {
              if (stream[this._current] === "=") {
                  this._current++;
                  return {type: TOK_EQ, value: "==", start: start};
              }
          }
      },

      _consumeLiteral: function(stream) {
          this._current++;
          var start = this._current;
          var maxLength = stream.length;
          var literal;
          while(stream[this._current] !== "`" && this._current < maxLength) {
              // You can escape a literal char or you can escape the escape.
              var current = this._current;
              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
                                               stream[current + 1] === "`")) {
                  current += 2;
              } else {
                  current++;
              }
              this._current = current;
          }
          var literalString = trimLeft(stream.slice(start, this._current));
          literalString = literalString.replace("\\`", "`");
          if (this._looksLikeJSON(literalString)) {
              literal = JSON.parse(literalString);
          } else {
              // Try to JSON parse it as "<literal>"
              literal = JSON.parse("\"" + literalString + "\"");
          }
          // +1 gets us to the ending "`", +1 to move on to the next char.
          this._current++;
          return literal;
      },

      _looksLikeJSON: function(literalString) {
          var startingChars = "[{\"";
          var jsonLiterals = ["true", "false", "null"];
          var numberLooking = "-0123456789";

          if (literalString === "") {
              return false;
          } else if (startingChars.indexOf(literalString[0]) >= 0) {
              return true;
          } else if (jsonLiterals.indexOf(literalString) >= 0) {
              return true;
          } else if (numberLooking.indexOf(literalString[0]) >= 0) {
              try {
                  JSON.parse(literalString);
                  return true;
              } catch (ex) {
                  return false;
              }
          } else {
              return false;
          }
      }
  };

      var bindingPower = {};
      bindingPower[TOK_EOF] = 0;
      bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
      bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
      bindingPower[TOK_RBRACKET] = 0;
      bindingPower[TOK_RPAREN] = 0;
      bindingPower[TOK_COMMA] = 0;
      bindingPower[TOK_RBRACE] = 0;
      bindingPower[TOK_NUMBER] = 0;
      bindingPower[TOK_CURRENT] = 0;
      bindingPower[TOK_EXPREF] = 0;
      bindingPower[TOK_PIPE] = 1;
      bindingPower[TOK_OR] = 2;
      bindingPower[TOK_AND] = 3;
      bindingPower[TOK_EQ] = 5;
      bindingPower[TOK_GT] = 5;
      bindingPower[TOK_LT] = 5;
      bindingPower[TOK_GTE] = 5;
      bindingPower[TOK_LTE] = 5;
      bindingPower[TOK_NE] = 5;
      bindingPower[TOK_FLATTEN] = 9;
      bindingPower[TOK_STAR] = 20;
      bindingPower[TOK_FILTER] = 21;
      bindingPower[TOK_DOT] = 40;
      bindingPower[TOK_NOT] = 45;
      bindingPower[TOK_LBRACE] = 50;
      bindingPower[TOK_LBRACKET] = 55;
      bindingPower[TOK_LPAREN] = 60;

  function Parser() {
  }

  Parser.prototype = {
      parse: function(expression) {
          this._loadTokens(expression);
          this.index = 0;
          var ast = this.expression(0);
          if (this._lookahead(0) !== TOK_EOF) {
              var t = this._lookaheadToken(0);
              var error = new Error(
                  "Unexpected token type: " + t.type + ", value: " + t.value);
              error.name = "ParserError";
              throw error;
          }
          return ast;
      },

      _loadTokens: function(expression) {
          var lexer = new Lexer();
          var tokens = lexer.tokenize(expression);
          tokens.push({type: TOK_EOF, value: "", start: expression.length});
          this.tokens = tokens;
      },

      expression: function(rbp) {
          var leftToken = this._lookaheadToken(0);
          this._advance();
          var left = this.nud(leftToken);
          var currentToken = this._lookahead(0);
          while (rbp < bindingPower[currentToken]) {
              this._advance();
              left = this.led(currentToken, left);
              currentToken = this._lookahead(0);
          }
          return left;
      },

      _lookahead: function(number) {
          return this.tokens[this.index + number].type;
      },

      _lookaheadToken: function(number) {
          return this.tokens[this.index + number];
      },

      _advance: function() {
          this.index++;
      },

      nud: function(token) {
        var left;
        var right;
        var expression;
        switch (token.type) {
          case TOK_LITERAL:
            return {type: "Literal", value: token.value};
          case TOK_UNQUOTEDIDENTIFIER:
            return {type: "Field", name: token.value};
          case TOK_QUOTEDIDENTIFIER:
            var node = {type: "Field", name: token.value};
            if (this._lookahead(0) === TOK_LPAREN) {
                throw new Error("Quoted identifier not allowed for function names.");
            } else {
                return node;
            }
            break;
          case TOK_NOT:
            right = this.expression(bindingPower.Not);
            return {type: "NotExpression", children: [right]};
          case TOK_STAR:
            left = {type: "Identity"};
            right = null;
            if (this._lookahead(0) === TOK_RBRACKET) {
                // This can happen in a multiselect,
                // [a, b, *]
                right = {type: "Identity"};
            } else {
                right = this._parseProjectionRHS(bindingPower.Star);
            }
            return {type: "ValueProjection", children: [left, right]};
          case TOK_FILTER:
            return this.led(token.type, {type: "Identity"});
          case TOK_LBRACE:
            return this._parseMultiselectHash();
          case TOK_FLATTEN:
            left = {type: TOK_FLATTEN, children: [{type: "Identity"}]};
            right = this._parseProjectionRHS(bindingPower.Flatten);
            return {type: "Projection", children: [left, right]};
          case TOK_LBRACKET:
            if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
                right = this._parseIndexExpression();
                return this._projectIfSlice({type: "Identity"}, right);
            } else if (this._lookahead(0) === TOK_STAR &&
                       this._lookahead(1) === TOK_RBRACKET) {
                this._advance();
                this._advance();
                right = this._parseProjectionRHS(bindingPower.Star);
                return {type: "Projection",
                        children: [{type: "Identity"}, right]};
            } else {
                return this._parseMultiselectList();
            }
            break;
          case TOK_CURRENT:
            return {type: TOK_CURRENT};
          case TOK_EXPREF:
            expression = this.expression(bindingPower.Expref);
            return {type: "ExpressionReference", children: [expression]};
          case TOK_LPAREN:
            var args = [];
            while (this._lookahead(0) !== TOK_RPAREN) {
              if (this._lookahead(0) === TOK_CURRENT) {
                expression = {type: TOK_CURRENT};
                this._advance();
              } else {
                expression = this.expression(0);
              }
              args.push(expression);
            }
            this._match(TOK_RPAREN);
            return args[0];
          default:
            this._errorToken(token);
        }
      },

      led: function(tokenName, left) {
        var right;
        switch(tokenName) {
          case TOK_DOT:
            var rbp = bindingPower.Dot;
            if (this._lookahead(0) !== TOK_STAR) {
                right = this._parseDotRHS(rbp);
                return {type: "Subexpression", children: [left, right]};
            } else {
                // Creating a projection.
                this._advance();
                right = this._parseProjectionRHS(rbp);
                return {type: "ValueProjection", children: [left, right]};
            }
            break;
          case TOK_PIPE:
            right = this.expression(bindingPower.Pipe);
            return {type: TOK_PIPE, children: [left, right]};
          case TOK_OR:
            right = this.expression(bindingPower.Or);
            return {type: "OrExpression", children: [left, right]};
          case TOK_AND:
            right = this.expression(bindingPower.And);
            return {type: "AndExpression", children: [left, right]};
          case TOK_LPAREN:
            var name = left.name;
            var args = [];
            var expression, node;
            while (this._lookahead(0) !== TOK_RPAREN) {
              if (this._lookahead(0) === TOK_CURRENT) {
                expression = {type: TOK_CURRENT};
                this._advance();
              } else {
                expression = this.expression(0);
              }
              if (this._lookahead(0) === TOK_COMMA) {
                this._match(TOK_COMMA);
              }
              args.push(expression);
            }
            this._match(TOK_RPAREN);
            node = {type: "Function", name: name, children: args};
            return node;
          case TOK_FILTER:
            var condition = this.expression(0);
            this._match(TOK_RBRACKET);
            if (this._lookahead(0) === TOK_FLATTEN) {
              right = {type: "Identity"};
            } else {
              right = this._parseProjectionRHS(bindingPower.Filter);
            }
            return {type: "FilterProjection", children: [left, right, condition]};
          case TOK_FLATTEN:
            var leftNode = {type: TOK_FLATTEN, children: [left]};
            var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
            return {type: "Projection", children: [leftNode, rightNode]};
          case TOK_EQ:
          case TOK_NE:
          case TOK_GT:
          case TOK_GTE:
          case TOK_LT:
          case TOK_LTE:
            return this._parseComparator(left, tokenName);
          case TOK_LBRACKET:
            var token = this._lookaheadToken(0);
            if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
                right = this._parseIndexExpression();
                return this._projectIfSlice(left, right);
            } else {
                this._match(TOK_STAR);
                this._match(TOK_RBRACKET);
                right = this._parseProjectionRHS(bindingPower.Star);
                return {type: "Projection", children: [left, right]};
            }
            break;
          default:
            this._errorToken(this._lookaheadToken(0));
        }
      },

      _match: function(tokenType) {
          if (this._lookahead(0) === tokenType) {
              this._advance();
          } else {
              var t = this._lookaheadToken(0);
              var error = new Error("Expected " + tokenType + ", got: " + t.type);
              error.name = "ParserError";
              throw error;
          }
      },

      _errorToken: function(token) {
          var error = new Error("Invalid token (" +
                                token.type + "): \"" +
                                token.value + "\"");
          error.name = "ParserError";
          throw error;
      },


      _parseIndexExpression: function() {
          if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) {
              return this._parseSliceExpression();
          } else {
              var node = {
                  type: "Index",
                  value: this._lookaheadToken(0).value};
              this._advance();
              this._match(TOK_RBRACKET);
              return node;
          }
      },

      _projectIfSlice: function(left, right) {
          var indexExpr = {type: "IndexExpression", children: [left, right]};
          if (right.type === "Slice") {
              return {
                  type: "Projection",
                  children: [indexExpr, this._parseProjectionRHS(bindingPower.Star)]
              };
          } else {
              return indexExpr;
          }
      },

      _parseSliceExpression: function() {
          // [start:end:step] where each part is optional, as well as the last
          // colon.
          var parts = [null, null, null];
          var index = 0;
          var currentToken = this._lookahead(0);
          while (currentToken !== TOK_RBRACKET && index < 3) {
              if (currentToken === TOK_COLON) {
                  index++;
                  this._advance();
              } else if (currentToken === TOK_NUMBER) {
                  parts[index] = this._lookaheadToken(0).value;
                  this._advance();
              } else {
                  var t = this._lookahead(0);
                  var error = new Error("Syntax error, unexpected token: " +
                                        t.value + "(" + t.type + ")");
                  error.name = "Parsererror";
                  throw error;
              }
              currentToken = this._lookahead(0);
          }
          this._match(TOK_RBRACKET);
          return {
              type: "Slice",
              children: parts
          };
      },

      _parseComparator: function(left, comparator) {
        var right = this.expression(bindingPower[comparator]);
        return {type: "Comparator", name: comparator, children: [left, right]};
      },

      _parseDotRHS: function(rbp) {
          var lookahead = this._lookahead(0);
          var exprTokens = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER, TOK_STAR];
          if (exprTokens.indexOf(lookahead) >= 0) {
              return this.expression(rbp);
          } else if (lookahead === TOK_LBRACKET) {
              this._match(TOK_LBRACKET);
              return this._parseMultiselectList();
          } else if (lookahead === TOK_LBRACE) {
              this._match(TOK_LBRACE);
              return this._parseMultiselectHash();
          }
      },

      _parseProjectionRHS: function(rbp) {
          var right;
          if (bindingPower[this._lookahead(0)] < 10) {
              right = {type: "Identity"};
          } else if (this._lookahead(0) === TOK_LBRACKET) {
              right = this.expression(rbp);
          } else if (this._lookahead(0) === TOK_FILTER) {
              right = this.expression(rbp);
          } else if (this._lookahead(0) === TOK_DOT) {
              this._match(TOK_DOT);
              right = this._parseDotRHS(rbp);
          } else {
              var t = this._lookaheadToken(0);
              var error = new Error("Sytanx error, unexpected token: " +
                                    t.value + "(" + t.type + ")");
              error.name = "ParserError";
              throw error;
          }
          return right;
      },

      _parseMultiselectList: function() {
          var expressions = [];
          while (this._lookahead(0) !== TOK_RBRACKET) {
              var expression = this.expression(0);
              expressions.push(expression);
              if (this._lookahead(0) === TOK_COMMA) {
                  this._match(TOK_COMMA);
                  if (this._lookahead(0) === TOK_RBRACKET) {
                    throw new Error("Unexpected token Rbracket");
                  }
              }
          }
          this._match(TOK_RBRACKET);
          return {type: "MultiSelectList", children: expressions};
      },

      _parseMultiselectHash: function() {
        var pairs = [];
        var identifierTypes = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER];
        var keyToken, keyName, value, node;
        for (;;) {
          keyToken = this._lookaheadToken(0);
          if (identifierTypes.indexOf(keyToken.type) < 0) {
            throw new Error("Expecting an identifier token, got: " +
                            keyToken.type);
          }
          keyName = keyToken.value;
          this._advance();
          this._match(TOK_COLON);
          value = this.expression(0);
          node = {type: "KeyValuePair", name: keyName, value: value};
          pairs.push(node);
          if (this._lookahead(0) === TOK_COMMA) {
            this._match(TOK_COMMA);
          } else if (this._lookahead(0) === TOK_RBRACE) {
            this._match(TOK_RBRACE);
            break;
          }
        }
        return {type: "MultiSelectHash", children: pairs};
      }
  };


  function TreeInterpreter(runtime) {
    this.runtime = runtime;
  }

  TreeInterpreter.prototype = {
      search: function(node, value) {
          return this.visit(node, value);
      },

      visit: function(node, value) {
          var matched, current, result, first, second, field, left, right, collected, i;
          switch (node.type) {
            case "Field":
              if (value === null ) {
                  return null;
              } else if (isObject(value)) {
                  field = value[node.name];
                  if (field === undefined) {
                      return null;
                  } else {
                      return field;
                  }
              } else {
                return null;
              }
              break;
            case "Subexpression":
              result = this.visit(node.children[0], value);
              for (i = 1; i < node.children.length; i++) {
                  result = this.visit(node.children[1], result);
                  if (result === null) {
                      return null;
                  }
              }
              return result;
            case "IndexExpression":
              left = this.visit(node.children[0], value);
              right = this.visit(node.children[1], left);
              return right;
            case "Index":
              if (!isArray(value)) {
                return null;
              }
              var index = node.value;
              if (index < 0) {
                index = value.length + index;
              }
              result = value[index];
              if (result === undefined) {
                result = null;
              }
              return result;
            case "Slice":
              if (!isArray(value)) {
                return null;
              }
              var sliceParams = node.children.slice(0);
              var computed = this.computeSliceParams(value.length, sliceParams);
              var start = computed[0];
              var stop = computed[1];
              var step = computed[2];
              result = [];
              if (step > 0) {
                  for (i = start; i < stop; i += step) {
                      result.push(value[i]);
                  }
              } else {
                  for (i = start; i > stop; i += step) {
                      result.push(value[i]);
                  }
              }
              return result;
            case "Projection":
              // Evaluate left child.
              var base = this.visit(node.children[0], value);
              if (!isArray(base)) {
                return null;
              }
              collected = [];
              for (i = 0; i < base.length; i++) {
                current = this.visit(node.children[1], base[i]);
                if (current !== null) {
                  collected.push(current);
                }
              }
              return collected;
            case "ValueProjection":
              // Evaluate left child.
              base = this.visit(node.children[0], value);
              if (!isObject(base)) {
                return null;
              }
              collected = [];
              var values = objValues(base);
              for (i = 0; i < values.length; i++) {
                current = this.visit(node.children[1], values[i]);
                if (current !== null) {
                  collected.push(current);
                }
              }
              return collected;
            case "FilterProjection":
              base = this.visit(node.children[0], value);
              if (!isArray(base)) {
                return null;
              }
              var filtered = [];
              var finalResults = [];
              for (i = 0; i < base.length; i++) {
                matched = this.visit(node.children[2], base[i]);
                if (!isFalse(matched)) {
                  filtered.push(base[i]);
                }
              }
              for (var j = 0; j < filtered.length; j++) {
                current = this.visit(node.children[1], filtered[j]);
                if (current !== null) {
                  finalResults.push(current);
                }
              }
              return finalResults;
            case "Comparator":
              first = this.visit(node.children[0], value);
              second = this.visit(node.children[1], value);
              switch(node.name) {
                case TOK_EQ:
                  result = strictDeepEqual(first, second);
                  break;
                case TOK_NE:
                  result = !strictDeepEqual(first, second);
                  break;
                case TOK_GT:
                  result = first > second;
                  break;
                case TOK_GTE:
                  result = first >= second;
                  break;
                case TOK_LT:
                  result = first < second;
                  break;
                case TOK_LTE:
                  result = first <= second;
                  break;
                default:
                  throw new Error("Unknown comparator: " + node.name);
              }
              return result;
            case TOK_FLATTEN:
              var original = this.visit(node.children[0], value);
              if (!isArray(original)) {
                return null;
              }
              var merged = [];
              for (i = 0; i < original.length; i++) {
                current = original[i];
                if (isArray(current)) {
                  merged.push.apply(merged, current);
                } else {
                  merged.push(current);
                }
              }
              return merged;
            case "Identity":
              return value;
            case "MultiSelectList":
              if (value === null) {
                return null;
              }
              collected = [];
              for (i = 0; i < node.children.length; i++) {
                  collected.push(this.visit(node.children[i], value));
              }
              return collected;
            case "MultiSelectHash":
              if (value === null) {
                return null;
              }
              collected = {};
              var child;
              for (i = 0; i < node.children.length; i++) {
                child = node.children[i];
                collected[child.name] = this.visit(child.value, value);
              }
              return collected;
            case "OrExpression":
              matched = this.visit(node.children[0], value);
              if (isFalse(matched)) {
                  matched = this.visit(node.children[1], value);
              }
              return matched;
            case "AndExpression":
              first = this.visit(node.children[0], value);

              if (isFalse(first) === true) {
                return first;
              }
              return this.visit(node.children[1], value);
            case "NotExpression":
              first = this.visit(node.children[0], value);
              return isFalse(first);
            case "Literal":
              return node.value;
            case TOK_PIPE:
              left = this.visit(node.children[0], value);
              return this.visit(node.children[1], left);
            case TOK_CURRENT:
              return value;
            case "Function":
              var resolvedArgs = [];
              for (i = 0; i < node.children.length; i++) {
                  resolvedArgs.push(this.visit(node.children[i], value));
              }
              return this.runtime.callFunction(node.name, resolvedArgs);
            case "ExpressionReference":
              var refNode = node.children[0];
              // Tag the node with a specific attribute so the type
              // checker verify the type.
              refNode.jmespathType = TOK_EXPREF;
              return refNode;
            default:
              throw new Error("Unknown node type: " + node.type);
          }
      },

      computeSliceParams: function(arrayLength, sliceParams) {
        var start = sliceParams[0];
        var stop = sliceParams[1];
        var step = sliceParams[2];
        var computed = [null, null, null];
        if (step === null) {
          step = 1;
        } else if (step === 0) {
          var error = new Error("Invalid slice, step cannot be 0");
          error.name = "RuntimeError";
          throw error;
        }
        var stepValueNegative = step < 0 ? true : false;

        if (start === null) {
            start = stepValueNegative ? arrayLength - 1 : 0;
        } else {
            start = this.capSliceRange(arrayLength, start, step);
        }

        if (stop === null) {
            stop = stepValueNegative ? -1 : arrayLength;
        } else {
            stop = this.capSliceRange(arrayLength, stop, step);
        }
        computed[0] = start;
        computed[1] = stop;
        computed[2] = step;
        return computed;
      },

      capSliceRange: function(arrayLength, actualValue, step) {
          if (actualValue < 0) {
              actualValue += arrayLength;
              if (actualValue < 0) {
                  actualValue = step < 0 ? -1 : 0;
              }
          } else if (actualValue >= arrayLength) {
              actualValue = step < 0 ? arrayLength - 1 : arrayLength;
          }
          return actualValue;
      }

  };

  function Runtime(interpreter) {
    this._interpreter = interpreter;
    this.functionTable = {
        // name: [function, <signature>]
        // The <signature> can be:
        //
        // {
        //   args: [[type1, type2], [type1, type2]],
        //   variadic: true|false
        // }
        //
        // Each arg in the arg list is a list of valid types
        // (if the function is overloaded and supports multiple
        // types.  If the type is "any" then no type checking
        // occurs on the argument.  Variadic is optional
        // and if not provided is assumed to be false.
        abs: {_func: this._functionAbs, _signature: [{types: [TYPE_NUMBER]}]},
        avg: {_func: this._functionAvg, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
        ceil: {_func: this._functionCeil, _signature: [{types: [TYPE_NUMBER]}]},
        contains: {
            _func: this._functionContains,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]},
                        {types: [TYPE_ANY]}]},
        "ends_with": {
            _func: this._functionEndsWith,
            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
        floor: {_func: this._functionFloor, _signature: [{types: [TYPE_NUMBER]}]},
        length: {
            _func: this._functionLength,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY, TYPE_OBJECT]}]},
        map: {
            _func: this._functionMap,
            _signature: [{types: [TYPE_EXPREF]}, {types: [TYPE_ARRAY]}]},
        max: {
            _func: this._functionMax,
            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
        "merge": {
            _func: this._functionMerge,
            _signature: [{types: [TYPE_OBJECT], variadic: true}]
        },
        "max_by": {
          _func: this._functionMaxBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        sum: {_func: this._functionSum, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
        "starts_with": {
            _func: this._functionStartsWith,
            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
        min: {
            _func: this._functionMin,
            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
        "min_by": {
          _func: this._functionMinBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        type: {_func: this._functionType, _signature: [{types: [TYPE_ANY]}]},
        keys: {_func: this._functionKeys, _signature: [{types: [TYPE_OBJECT]}]},
        values: {_func: this._functionValues, _signature: [{types: [TYPE_OBJECT]}]},
        sort: {_func: this._functionSort, _signature: [{types: [TYPE_ARRAY_STRING, TYPE_ARRAY_NUMBER]}]},
        "sort_by": {
          _func: this._functionSortBy,
          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
        },
        join: {
            _func: this._functionJoin,
            _signature: [
                {types: [TYPE_STRING]},
                {types: [TYPE_ARRAY_STRING]}
            ]
        },
        reverse: {
            _func: this._functionReverse,
            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]}]},
        "to_array": {_func: this._functionToArray, _signature: [{types: [TYPE_ANY]}]},
        "to_string": {_func: this._functionToString, _signature: [{types: [TYPE_ANY]}]},
        "to_number": {_func: this._functionToNumber, _signature: [{types: [TYPE_ANY]}]},
        "not_null": {
            _func: this._functionNotNull,
            _signature: [{types: [TYPE_ANY], variadic: true}]
        }
    };
  }

  Runtime.prototype = {
    callFunction: function(name, resolvedArgs) {
      var functionEntry = this.functionTable[name];
      if (functionEntry === undefined) {
          throw new Error("Unknown function: " + name + "()");
      }
      this._validateArgs(name, resolvedArgs, functionEntry._signature);
      return functionEntry._func.call(this, resolvedArgs);
    },

    _validateArgs: function(name, args, signature) {
        // Validating the args requires validating
        // the correct arity and the correct type of each arg.
        // If the last argument is declared as variadic, then we need
        // a minimum number of args to be required.  Otherwise it has to
        // be an exact amount.
        var pluralized;
        if (signature[signature.length - 1].variadic) {
            if (args.length < signature.length) {
                pluralized = signature.length === 1 ? " argument" : " arguments";
                throw new Error("ArgumentError: " + name + "() " +
                                "takes at least" + signature.length + pluralized +
                                " but received " + args.length);
            }
        } else if (args.length !== signature.length) {
            pluralized = signature.length === 1 ? " argument" : " arguments";
            throw new Error("ArgumentError: " + name + "() " +
                            "takes " + signature.length + pluralized +
                            " but received " + args.length);
        }
        var currentSpec;
        var actualType;
        var typeMatched;
        for (var i = 0; i < signature.length; i++) {
            typeMatched = false;
            currentSpec = signature[i].types;
            actualType = this._getTypeName(args[i]);
            for (var j = 0; j < currentSpec.length; j++) {
                if (this._typeMatches(actualType, currentSpec[j], args[i])) {
                    typeMatched = true;
                    break;
                }
            }
            if (!typeMatched) {
                throw new Error("TypeError: " + name + "() " +
                                "expected argument " + (i + 1) +
                                " to be type " + currentSpec +
                                " but received type " + actualType +
                                " instead.");
            }
        }
    },

    _typeMatches: function(actual, expected, argValue) {
        if (expected === TYPE_ANY) {
            return true;
        }
        if (expected === TYPE_ARRAY_STRING ||
            expected === TYPE_ARRAY_NUMBER ||
            expected === TYPE_ARRAY) {
            // The expected type can either just be array,
            // or it can require a specific subtype (array of numbers).
            //
            // The simplest case is if "array" with no subtype is specified.
            if (expected === TYPE_ARRAY) {
                return actual === TYPE_ARRAY;
            } else if (actual === TYPE_ARRAY) {
                // Otherwise we need to check subtypes.
                // I think this has potential to be improved.
                var subtype;
                if (expected === TYPE_ARRAY_NUMBER) {
                  subtype = TYPE_NUMBER;
                } else if (expected === TYPE_ARRAY_STRING) {
                  subtype = TYPE_STRING;
                }
                for (var i = 0; i < argValue.length; i++) {
                    if (!this._typeMatches(
                            this._getTypeName(argValue[i]), subtype,
                                             argValue[i])) {
                        return false;
                    }
                }
                return true;
            }
        } else {
            return actual === expected;
        }
    },
    _getTypeName: function(obj) {
        switch (Object.prototype.toString.call(obj)) {
            case "[object String]":
              return TYPE_STRING;
            case "[object Number]":
              return TYPE_NUMBER;
            case "[object Array]":
              return TYPE_ARRAY;
            case "[object Boolean]":
              return TYPE_BOOLEAN;
            case "[object Null]":
              return TYPE_NULL;
            case "[object Object]":
              // Check if it's an expref.  If it has, it's been
              // tagged with a jmespathType attr of 'Expref';
              if (obj.jmespathType === TOK_EXPREF) {
                return TYPE_EXPREF;
              } else {
                return TYPE_OBJECT;
              }
        }
    },

    _functionStartsWith: function(resolvedArgs) {
        return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
    },

    _functionEndsWith: function(resolvedArgs) {
        var searchStr = resolvedArgs[0];
        var suffix = resolvedArgs[1];
        return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
    },

    _functionReverse: function(resolvedArgs) {
        var typeName = this._getTypeName(resolvedArgs[0]);
        if (typeName === TYPE_STRING) {
          var originalStr = resolvedArgs[0];
          var reversedStr = "";
          for (var i = originalStr.length - 1; i >= 0; i--) {
              reversedStr += originalStr[i];
          }
          return reversedStr;
        } else {
          var reversedArray = resolvedArgs[0].slice(0);
          reversedArray.reverse();
          return reversedArray;
        }
    },

    _functionAbs: function(resolvedArgs) {
      return Math.abs(resolvedArgs[0]);
    },

    _functionCeil: function(resolvedArgs) {
        return Math.ceil(resolvedArgs[0]);
    },

    _functionAvg: function(resolvedArgs) {
        var sum = 0;
        var inputArray = resolvedArgs[0];
        for (var i = 0; i < inputArray.length; i++) {
            sum += inputArray[i];
        }
        return sum / inputArray.length;
    },

    _functionContains: function(resolvedArgs) {
        return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
    },

    _functionFloor: function(resolvedArgs) {
        return Math.floor(resolvedArgs[0]);
    },

    _functionLength: function(resolvedArgs) {
       if (!isObject(resolvedArgs[0])) {
         return resolvedArgs[0].length;
       } else {
         // As far as I can tell, there's no way to get the length
         // of an object without O(n) iteration through the object.
         return Object.keys(resolvedArgs[0]).length;
       }
    },

    _functionMap: function(resolvedArgs) {
      var mapped = [];
      var interpreter = this._interpreter;
      var exprefNode = resolvedArgs[0];
      var elements = resolvedArgs[1];
      for (var i = 0; i < elements.length; i++) {
          mapped.push(interpreter.visit(exprefNode, elements[i]));
      }
      return mapped;
    },

    _functionMerge: function(resolvedArgs) {
      var merged = {};
      for (var i = 0; i < resolvedArgs.length; i++) {
        var current = resolvedArgs[i];
        for (var key in current) {
          merged[key] = current[key];
        }
      }
      return merged;
    },

    _functionMax: function(resolvedArgs) {
      if (resolvedArgs[0].length > 0) {
        var typeName = this._getTypeName(resolvedArgs[0][0]);
        if (typeName === TYPE_NUMBER) {
          return Math.max.apply(Math, resolvedArgs[0]);
        } else {
          var elements = resolvedArgs[0];
          var maxElement = elements[0];
          for (var i = 1; i < elements.length; i++) {
              if (maxElement.localeCompare(elements[i]) < 0) {
                  maxElement = elements[i];
              }
          }
          return maxElement;
        }
      } else {
          return null;
      }
    },

    _functionMin: function(resolvedArgs) {
      if (resolvedArgs[0].length > 0) {
        var typeName = this._getTypeName(resolvedArgs[0][0]);
        if (typeName === TYPE_NUMBER) {
          return Math.min.apply(Math, resolvedArgs[0]);
        } else {
          var elements = resolvedArgs[0];
          var minElement = elements[0];
          for (var i = 1; i < elements.length; i++) {
              if (elements[i].localeCompare(minElement) < 0) {
                  minElement = elements[i];
              }
          }
          return minElement;
        }
      } else {
        return null;
      }
    },

    _functionSum: function(resolvedArgs) {
      var sum = 0;
      var listToSum = resolvedArgs[0];
      for (var i = 0; i < listToSum.length; i++) {
        sum += listToSum[i];
      }
      return sum;
    },

    _functionType: function(resolvedArgs) {
        switch (this._getTypeName(resolvedArgs[0])) {
          case TYPE_NUMBER:
            return "number";
          case TYPE_STRING:
            return "string";
          case TYPE_ARRAY:
            return "array";
          case TYPE_OBJECT:
            return "object";
          case TYPE_BOOLEAN:
            return "boolean";
          case TYPE_EXPREF:
            return "expref";
          case TYPE_NULL:
            return "null";
        }
    },

    _functionKeys: function(resolvedArgs) {
        return Object.keys(resolvedArgs[0]);
    },

    _functionValues: function(resolvedArgs) {
        var obj = resolvedArgs[0];
        var keys = Object.keys(obj);
        var values = [];
        for (var i = 0; i < keys.length; i++) {
            values.push(obj[keys[i]]);
        }
        return values;
    },

    _functionJoin: function(resolvedArgs) {
        var joinChar = resolvedArgs[0];
        var listJoin = resolvedArgs[1];
        return listJoin.join(joinChar);
    },

    _functionToArray: function(resolvedArgs) {
        if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) {
            return resolvedArgs[0];
        } else {
            return [resolvedArgs[0]];
        }
    },

    _functionToString: function(resolvedArgs) {
        if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) {
            return resolvedArgs[0];
        } else {
            return JSON.stringify(resolvedArgs[0]);
        }
    },

    _functionToNumber: function(resolvedArgs) {
        var typeName = this._getTypeName(resolvedArgs[0]);
        var convertedValue;
        if (typeName === TYPE_NUMBER) {
            return resolvedArgs[0];
        } else if (typeName === TYPE_STRING) {
            convertedValue = +resolvedArgs[0];
            if (!isNaN(convertedValue)) {
                return convertedValue;
            }
        }
        return null;
    },

    _functionNotNull: function(resolvedArgs) {
        for (var i = 0; i < resolvedArgs.length; i++) {
            if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) {
                return resolvedArgs[i];
            }
        }
        return null;
    },

    _functionSort: function(resolvedArgs) {
        var sortedArray = resolvedArgs[0].slice(0);
        sortedArray.sort();
        return sortedArray;
    },

    _functionSortBy: function(resolvedArgs) {
        var sortedArray = resolvedArgs[0].slice(0);
        if (sortedArray.length === 0) {
            return sortedArray;
        }
        var interpreter = this._interpreter;
        var exprefNode = resolvedArgs[1];
        var requiredType = this._getTypeName(
            interpreter.visit(exprefNode, sortedArray[0]));
        if ([TYPE_NUMBER, TYPE_STRING].indexOf(requiredType) < 0) {
            throw new Error("TypeError");
        }
        var that = this;
        // In order to get a stable sort out of an unstable
        // sort algorithm, we decorate/sort/undecorate (DSU)
        // by creating a new list of [index, element] pairs.
        // In the cmp function, if the evaluated elements are
        // equal, then the index will be used as the tiebreaker.
        // After the decorated list has been sorted, it will be
        // undecorated to extract the original elements.
        var decorated = [];
        for (var i = 0; i < sortedArray.length; i++) {
          decorated.push([i, sortedArray[i]]);
        }
        decorated.sort(function(a, b) {
          var exprA = interpreter.visit(exprefNode, a[1]);
          var exprB = interpreter.visit(exprefNode, b[1]);
          if (that._getTypeName(exprA) !== requiredType) {
              throw new Error(
                  "TypeError: expected " + requiredType + ", received " +
                  that._getTypeName(exprA));
          } else if (that._getTypeName(exprB) !== requiredType) {
              throw new Error(
                  "TypeError: expected " + requiredType + ", received " +
                  that._getTypeName(exprB));
          }
          if (exprA > exprB) {
            return 1;
          } else if (exprA < exprB) {
            return -1;
          } else {
            // If they're equal compare the items by their
            // order to maintain relative order of equal keys
            // (i.e. to get a stable sort).
            return a[0] - b[0];
          }
        });
        // Undecorate: extract out the original list elements.
        for (var j = 0; j < decorated.length; j++) {
          sortedArray[j] = decorated[j][1];
        }
        return sortedArray;
    },

    _functionMaxBy: function(resolvedArgs) {
      var exprefNode = resolvedArgs[1];
      var resolvedArray = resolvedArgs[0];
      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
      var maxNumber = -Infinity;
      var maxRecord;
      var current;
      for (var i = 0; i < resolvedArray.length; i++) {
        current = keyFunction(resolvedArray[i]);
        if (current > maxNumber) {
          maxNumber = current;
          maxRecord = resolvedArray[i];
        }
      }
      return maxRecord;
    },

    _functionMinBy: function(resolvedArgs) {
      var exprefNode = resolvedArgs[1];
      var resolvedArray = resolvedArgs[0];
      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
      var minNumber = Infinity;
      var minRecord;
      var current;
      for (var i = 0; i < resolvedArray.length; i++) {
        current = keyFunction(resolvedArray[i]);
        if (current < minNumber) {
          minNumber = current;
          minRecord = resolvedArray[i];
        }
      }
      return minRecord;
    },

    createKeyFunction: function(exprefNode, allowedTypes) {
      var that = this;
      var interpreter = this._interpreter;
      var keyFunc = function(x) {
        var current = interpreter.visit(exprefNode, x);
        if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
          var msg = "TypeError: expected one of " + allowedTypes +
                    ", received " + that._getTypeName(current);
          throw new Error(msg);
        }
        return current;
      };
      return keyFunc;
    }

  };

  function compile(stream) {
    var parser = new Parser();
    var ast = parser.parse(stream);
    return ast;
  }

  function tokenize(stream) {
      var lexer = new Lexer();
      return lexer.tokenize(stream);
  }

  function search(data, expression) {
      var parser = new Parser();
      // This needs to be improved.  Both the interpreter and runtime depend on
      // each other.  The runtime needs the interpreter to support exprefs.
      // There's likely a clean way to avoid the cyclic dependency.
      var runtime = new Runtime();
      var interpreter = new TreeInterpreter(runtime);
      runtime._interpreter = interpreter;
      var node = parser.parse(expression);
      return interpreter.search(node, data);
  }

  exports.tokenize = tokenize;
  exports.compile = compile;
  exports.search = search;
  exports.strictDeepEqual = strictDeepEqual;
})( false ? this.jmespath = {} : exports);


/***/ }),
/* 456 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 457 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(76).Buffer;
var intSize = 4;
var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
var chrsz = 8;

function toArray(buf, bigEndian) {
  if ((buf.length % intSize) !== 0) {
    var len = buf.length + (intSize - (buf.length % intSize));
    buf = Buffer.concat([buf, zeroBuffer], len);
  }

  var arr = [];
  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
  for (var i = 0; i < buf.length; i += intSize) {
    arr.push(fn.call(buf, i));
  }
  return arr;
}

function toBuffer(arr, size, bigEndian) {
  var buf = new Buffer(size);
  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
  for (var i = 0; i < arr.length; i++) {
    fn.call(buf, arr[i], i * 4, true);
  }
  return buf;
}

function hash(buf, fn, hashSize, bigEndian) {
  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
  return toBuffer(arr, hashSize, bigEndian);
}

module.exports = { hash: hash };


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(1489);
var util = __webpack_require__(1490);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(320);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_FAVORITE_USERS = exports.UPDATE_FAVORITE_USER_FAILED = exports.UPDATE_FAVORITE_USER_COMPLETED = exports.UPDATE_FAVORITE_USER_REQUESTED = exports.UPDATE_FAVORITE_USER = exports.UPDATE_FAVORITE_GROUP_FAILED = exports.UPDATE_FAVORITE_GROUP_COMPLETED = exports.UPDATE_FAVORITE_GROUP_REQUESTED = exports.UPDATE_FAVORITE_GROUP = exports.FETCH_FAVORITE_USERS_FAILED = exports.FETCH_FAVORITE_USERS_COMPLETED = exports.FETCH_FAVORITE_USERS_REQUESTED = exports.FETCH_FAVORITE_USERS = exports.FETCH_FAVORITE_GROUPS_FAILED = exports.FETCH_FAVORITE_GROUPS_COMPLETED = exports.FETCH_FAVORITE_GROUPS_REQUESTED = exports.FETCH_FAVORITE_GROUPS = undefined;
exports.fetchFavoriteGroupsRequested = fetchFavoriteGroupsRequested;
exports.fetchFavoriteGroups = fetchFavoriteGroups;
exports.fetchFavoriteGroupsCompleted = fetchFavoriteGroupsCompleted;
exports.fetchFavoriteGroupsFailed = fetchFavoriteGroupsFailed;
exports.fetchFavoriteUsersRequested = fetchFavoriteUsersRequested;
exports.fetchFavoriteUsers = fetchFavoriteUsers;
exports.fetchFavoriteUsersCompleted = fetchFavoriteUsersCompleted;
exports.fetchFavoriteUsersFailed = fetchFavoriteUsersFailed;
exports.updateFavoriteGroupRequested = updateFavoriteGroupRequested;
exports.updateFavoriteGroup = updateFavoriteGroup;
exports.updateFavoriteGroupCompleted = updateFavoriteGroupCompleted;
exports.updateFavoriteGroupFailed = updateFavoriteGroupFailed;
exports.updateFavoriteUserRequested = updateFavoriteUserRequested;
exports.updateFavoriteUser = updateFavoriteUser;
exports.updateFavoriteUserCompleted = updateFavoriteUserCompleted;
exports.updateFavoriteUserFailed = updateFavoriteUserFailed;
exports.clearFavoriteUsers = clearFavoriteUsers;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/favorite.js

var FETCH_FAVORITE_GROUPS = exports.FETCH_FAVORITE_GROUPS = "FETCH_FAVORITE_GROUPS";
var FETCH_FAVORITE_GROUPS_REQUESTED = exports.FETCH_FAVORITE_GROUPS_REQUESTED = "FETCH_FAVORITE_GROUPS_REQUESTED";
var FETCH_FAVORITE_GROUPS_COMPLETED = exports.FETCH_FAVORITE_GROUPS_COMPLETED = "FETCH_FAVORITE_GROUPS_COMPLETED";
var FETCH_FAVORITE_GROUPS_FAILED = exports.FETCH_FAVORITE_GROUPS_FAILED = "FETCH_FAVORITE_GROUPS_FAILED";

function fetchFavoriteGroupsRequested() {
  return {
    type: FETCH_FAVORITE_GROUPS_REQUESTED
  };
}

function fetchFavoriteGroups() {
  return function (dispatch) {
    dispatch(fetchFavoriteGroupsRequested());
    return _gambaApi2.default.get('/favorite/groups').then(function (results) {
      dispatch(fetchFavoriteGroupsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchFavoriteGroupsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchFavoriteGroupsCompleted(results) {
  return {
    type: FETCH_FAVORITE_GROUPS_COMPLETED,
    results: results
  };
}

function fetchFavoriteGroupsFailed(error) {
  return {
    type: FETCH_FAVORITE_GROUPS_FAILED,
    error: error
  };
}

var FETCH_FAVORITE_USERS = exports.FETCH_FAVORITE_USERS = "FETCH_FAVORITE_USERS";
var FETCH_FAVORITE_USERS_REQUESTED = exports.FETCH_FAVORITE_USERS_REQUESTED = "FETCH_FAVORITE_USERS_REQUESTED";
var FETCH_FAVORITE_USERS_COMPLETED = exports.FETCH_FAVORITE_USERS_COMPLETED = "FETCH_FAVORITE_USERS_COMPLETED";
var FETCH_FAVORITE_USERS_FAILED = exports.FETCH_FAVORITE_USERS_FAILED = "FETCH_FAVORITE_USERS_FAILED";

function fetchFavoriteUsersRequested() {
  return {
    type: FETCH_FAVORITE_USERS_REQUESTED
  };
}

function fetchFavoriteUsers() {
  return function (dispatch) {
    dispatch(fetchFavoriteUsersRequested());
    return _gambaApi2.default.get('/favorite/users').then(function (results) {
      dispatch(fetchFavoriteUsersCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchFavoriteUsersFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchFavoriteUsersCompleted(results) {
  return {
    type: FETCH_FAVORITE_USERS_COMPLETED,
    results: results
  };
}

function fetchFavoriteUsersFailed(error) {
  return {
    type: FETCH_FAVORITE_USERS_FAILED,
    error: error
  };
}

var UPDATE_FAVORITE_GROUP = exports.UPDATE_FAVORITE_GROUP = "UPDATE_FAVORITE_GROUP";
var UPDATE_FAVORITE_GROUP_REQUESTED = exports.UPDATE_FAVORITE_GROUP_REQUESTED = "UPDATE_FAVORITE_GROUP_REQUESTED";
var UPDATE_FAVORITE_GROUP_COMPLETED = exports.UPDATE_FAVORITE_GROUP_COMPLETED = "UPDATE_FAVORITE_GROUP_COMPLETED";
var UPDATE_FAVORITE_GROUP_FAILED = exports.UPDATE_FAVORITE_GROUP_FAILED = "UPDATE_FAVORITE_GROUP_FAILED";

function updateFavoriteGroupRequested() {
  return {
    type: UPDATE_FAVORITE_GROUP_REQUESTED
  };
}

function updateFavoriteGroup(group_id, favorite) {
  return function (dispatch) {
    dispatch(updateFavoriteGroupRequested());
    return _gambaApi2.default.put('/favorite/groups/' + group_id, { favorite: favorite }).then(function (results) {
      dispatch(updateFavoriteGroupCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateFavoriteGroupFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateFavoriteGroupCompleted(results) {
  return {
    type: UPDATE_FAVORITE_GROUP_COMPLETED,
    results: results
  };
}

function updateFavoriteGroupFailed(error) {
  return {
    type: UPDATE_FAVORITE_GROUP_FAILED,
    error: error
  };
}

var UPDATE_FAVORITE_USER = exports.UPDATE_FAVORITE_USER = "UPDATE_FAVORITE_USER";
var UPDATE_FAVORITE_USER_REQUESTED = exports.UPDATE_FAVORITE_USER_REQUESTED = "UPDATE_FAVORITE_USER_REQUESTED";
var UPDATE_FAVORITE_USER_COMPLETED = exports.UPDATE_FAVORITE_USER_COMPLETED = "UPDATE_FAVORITE_USER_COMPLETED";
var UPDATE_FAVORITE_USER_FAILED = exports.UPDATE_FAVORITE_USER_FAILED = "UPDATE_FAVORITE_USER_FAILED";

function updateFavoriteUserRequested() {
  return {
    type: UPDATE_FAVORITE_USER_REQUESTED
  };
}

function updateFavoriteUser(user_id, favorite) {
  return function (dispatch) {
    dispatch(updateFavoriteUserRequested());
    return _gambaApi2.default.put('/favorite/users/' + user_id, { favorite: favorite }).then(function (results) {
      dispatch(updateFavoriteUserCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateFavoriteUserFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateFavoriteUserCompleted(results) {
  return {
    type: UPDATE_FAVORITE_USER_COMPLETED,
    results: results
  };
}

function updateFavoriteUserFailed(error) {
  return {
    type: UPDATE_FAVORITE_USER_FAILED,
    error: error
  };
}

var CLEAR_FAVORITE_USERS = exports.CLEAR_FAVORITE_USERS = "CLEAR_FAVORITE_USERS";

function clearFavoriteUsers() {
  return {
    type: CLEAR_FAVORITE_USERS
  };
}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEEP_SCROLL_POSITION = exports.CLEAR_CLOSED_KPIS = exports.CLEAR_DIARY_KPI = exports.CLEAR_KPIS = exports.SORT_KPIS_FAILED = exports.SORT_KPIS_COMPLETED = exports.SORT_KPIS_REQUESTED = exports.SORT_KPIS = exports.DELETE_KPI_FAILED = exports.DELETE_KPI_COMPLETED = exports.DELETE_KPI_REQUESTED = exports.DELETE_KPI = exports.UPDATE_KPI_FAILED = exports.UPDATE_KPI_COMPLETED = exports.UPDATE_KPI_REQUESTED = exports.UPDATE_KPI = exports.CREATE_KPI_FAILED = exports.CREATE_KPI_COMPLETED = exports.CREATE_KPI_REQUESTED = exports.CREATE_KPI = exports.FETCH_KPI_FAILED = exports.FETCH_KPI_COMPLETED = exports.FETCH_KPI_REQUESTED = exports.FETCH_KPI = exports.FETCH_COMPARISON_KPIS_FAILED = exports.FETCH_COMPARISON_KPIS_COMPLETED = exports.FETCH_COMPARISON_KPIS_REQUESTED = exports.FETCH_COMPARISON_KPIS = exports.FETCH_GROUP_KPIS_FAILED = exports.FETCH_GROUP_KPIS_COMPLETED = exports.FETCH_GROUP_KPIS_REQUESTED = exports.FETCH_GROUP_KPIS = exports.FETCH_CHART_KPIS_FAILED = exports.FETCH_CHART_KPIS_COMPLETED = exports.FETCH_CHART_KPIS_REQUESTED = exports.FETCH_CHART_KPIS = exports.FETCH_KPIS_FAILED = exports.FETCH_KPIS_COMPLETED = exports.FETCH_KPIS_REQUESTED = exports.FETCH_KPIS = exports.FETCH_CLOSED_KPIS_FAILED = exports.FETCH_CLOSED_KPIS_COMPLETED = exports.FETCH_CLOSED_KPIS_REQUESTED = exports.FETCH_CLOSED_KPIS = exports.FETCH_DIARY_KPI_FAILED = exports.FETCH_DIARY_KPI_COMPLETED = exports.FETCH_DIARY_KPI_REQUESTED = exports.FETCH_DIARY_KPI = undefined;
exports.fetchDiaryKpiRequested = fetchDiaryKpiRequested;
exports.fetchDiaryKpi = fetchDiaryKpi;
exports.fetchDiaryKpiCompleted = fetchDiaryKpiCompleted;
exports.fetchDiaryKpiFailed = fetchDiaryKpiFailed;
exports.fetchClosedKpisRequested = fetchClosedKpisRequested;
exports.fetchClosedKpis = fetchClosedKpis;
exports.fetchClosedKpisCompleted = fetchClosedKpisCompleted;
exports.fetchClosedKpisFailed = fetchClosedKpisFailed;
exports.fetchKpisRequested = fetchKpisRequested;
exports.fetchKpis = fetchKpis;
exports.fetchKpisCompleted = fetchKpisCompleted;
exports.fetchKpisFailed = fetchKpisFailed;
exports.fetchChartKpisRequested = fetchChartKpisRequested;
exports.fetchChartKpis = fetchChartKpis;
exports.fetchChartKpisCompleted = fetchChartKpisCompleted;
exports.fetchChartKpisFailed = fetchChartKpisFailed;
exports.fetchGroupKpisRequested = fetchGroupKpisRequested;
exports.fetchGroupKpis = fetchGroupKpis;
exports.fetchGroupKpisCompleted = fetchGroupKpisCompleted;
exports.fetchGroupKpisFailed = fetchGroupKpisFailed;
exports.fetchComparisonKpisRequested = fetchComparisonKpisRequested;
exports.fetchComparisonKpis = fetchComparisonKpis;
exports.fetchComparisonKpisCompleted = fetchComparisonKpisCompleted;
exports.fetchComparisonKpisFailed = fetchComparisonKpisFailed;
exports.fetchKpiRequested = fetchKpiRequested;
exports.fetchKpi = fetchKpi;
exports.fetchKpiCompleted = fetchKpiCompleted;
exports.fetchKpiFailed = fetchKpiFailed;
exports.createKpiRequested = createKpiRequested;
exports.createKpi = createKpi;
exports.createKpiCompleted = createKpiCompleted;
exports.createKpiFailed = createKpiFailed;
exports.updateKpiRequested = updateKpiRequested;
exports.updateKpi = updateKpi;
exports.updateKpiCompleted = updateKpiCompleted;
exports.updateKpiFailed = updateKpiFailed;
exports.deleteKpiRequested = deleteKpiRequested;
exports.deleteKpi = deleteKpi;
exports.deleteKpiCompleted = deleteKpiCompleted;
exports.deleteKpiFailed = deleteKpiFailed;
exports.sortKpisRequested = sortKpisRequested;
exports.sortKpis = sortKpis;
exports.sortKpisCompleted = sortKpisCompleted;
exports.sortKpisFailed = sortKpisFailed;
exports.clearKpis = clearKpis;
exports.clearDiaryKpi = clearDiaryKpi;
exports.clearClosedKpis = clearClosedKpis;
exports.keepScrollPosition = keepScrollPosition;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_DIARY_KPI = exports.FETCH_DIARY_KPI = "FETCH_DIARY_KPI";
// src/actions/kpi.js

var FETCH_DIARY_KPI_REQUESTED = exports.FETCH_DIARY_KPI_REQUESTED = "FETCH_DIARY_KPI_REQUESTED";
var FETCH_DIARY_KPI_COMPLETED = exports.FETCH_DIARY_KPI_COMPLETED = "FETCH_DIARY_KPI_COMPLETED";
var FETCH_DIARY_KPI_FAILED = exports.FETCH_DIARY_KPI_FAILED = "FETCH_DIARY_KPI_FAILED";

function fetchDiaryKpiRequested() {
  return {
    type: FETCH_DIARY_KPI_REQUESTED
  };
}

function fetchDiaryKpi(group_id, reported_at) {
  return function (dispatch) {
    dispatch(fetchDiaryKpiRequested());
    return _gambaApi2.default.get('/kpi_status', { group_id: group_id, reported_at: (0, _moment2.default)(reported_at).format('YYYY-MM-DD') }).then(function (results) {
      dispatch(fetchDiaryKpiCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDiaryKpiFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchDiaryKpiCompleted(results) {
  return {
    type: FETCH_DIARY_KPI_COMPLETED,
    results: results
  };
}

function fetchDiaryKpiFailed(error) {
  return {
    type: FETCH_DIARY_KPI_FAILED,
    error: error
  };
}

var FETCH_CLOSED_KPIS = exports.FETCH_CLOSED_KPIS = "FETCH_CLOSED_KPIS";
var FETCH_CLOSED_KPIS_REQUESTED = exports.FETCH_CLOSED_KPIS_REQUESTED = "FETCH_CLOSED_KPIS_REQUESTED";
var FETCH_CLOSED_KPIS_COMPLETED = exports.FETCH_CLOSED_KPIS_COMPLETED = "FETCH_CLOSED_KPIS_COMPLETED";
var FETCH_CLOSED_KPIS_FAILED = exports.FETCH_CLOSED_KPIS_FAILED = "FETCH_CLOSED_KPIS_FAILED";

function fetchClosedKpisRequested() {
  return {
    type: FETCH_CLOSED_KPIS_REQUESTED
  };
}

function fetchClosedKpis(group_id, offset) {
  return function (dispatch) {
    dispatch(fetchClosedKpisRequested());
    return _gambaApi2.default.get('/kpi', { group_id: group_id, offset: offset, status: 'closed' }).then(function (results) {
      dispatch(fetchClosedKpisCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchClosedKpisFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchClosedKpisCompleted(results, offset) {
  return {
    type: FETCH_CLOSED_KPIS_COMPLETED,
    results: results, offset: offset
  };
}

function fetchClosedKpisFailed(error) {
  return {
    type: FETCH_CLOSED_KPIS_FAILED,
    error: error
  };
}

var FETCH_KPIS = exports.FETCH_KPIS = "FETCH_KPIS";
var FETCH_KPIS_REQUESTED = exports.FETCH_KPIS_REQUESTED = "FETCH_KPIS_REQUESTED";
var FETCH_KPIS_COMPLETED = exports.FETCH_KPIS_COMPLETED = "FETCH_KPIS_COMPLETED";
var FETCH_KPIS_FAILED = exports.FETCH_KPIS_FAILED = "FETCH_KPIS_FAILED";

function fetchKpisRequested() {
  return {
    type: FETCH_KPIS_REQUESTED
  };
}

function fetchKpis(group_id) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'working';


  return function (dispatch) {
    dispatch(fetchKpisRequested());
    return _gambaApi2.default.get('/kpi', { group_id: group_id, status: status, length: 500 }).then(function (results) {
      dispatch(fetchKpisCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchKpisFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchKpisCompleted(results) {
  return {
    type: FETCH_KPIS_COMPLETED,
    results: results
  };
}

function fetchKpisFailed(error) {
  return {
    type: FETCH_KPIS_FAILED,
    error: error
  };
}

var FETCH_CHART_KPIS = exports.FETCH_CHART_KPIS = "FETCH_CHART_KPIS";
var FETCH_CHART_KPIS_REQUESTED = exports.FETCH_CHART_KPIS_REQUESTED = "FETCH_CHART_KPIS_REQUESTED";
var FETCH_CHART_KPIS_COMPLETED = exports.FETCH_CHART_KPIS_COMPLETED = "FETCH_CHART_KPIS_COMPLETED";
var FETCH_CHART_KPIS_FAILED = exports.FETCH_CHART_KPIS_FAILED = "FETCH_CHART_KPIS_FAILED";

function fetchChartKpisRequested() {
  return {
    type: FETCH_CHART_KPIS_REQUESTED
  };
}

function fetchChartKpis(group_id) {
  var start_date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)().format('YYYY-MM-DD');
  var end_date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _moment2.default)().format('YYYY-MM-DD');
  var selected_kpis = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];


  return function (dispatch) {
    dispatch(fetchChartKpisRequested());
    // Flatten selected_kpis into multiple query parameters
    var selectedKpisQuery = selected_kpis.map(function (kpi, index) {
      return 'selected_kpis[' + index + '][kpi_id]=' + kpi.kpi_id;
    }).join('&');

    var queryParams = 'group_id=' + group_id + '&start_date=' + start_date + '&end_date=' + end_date + '&' + selectedKpisQuery;

    return _gambaApi2.default.get('/kpi/chart_kpis?' + queryParams).then(function (results) {
      dispatch(fetchChartKpisCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchChartKpisFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchChartKpisCompleted(results) {
  return {
    type: FETCH_CHART_KPIS_COMPLETED,
    results: results
  };
}

function fetchChartKpisFailed(error) {
  return {
    type: FETCH_CHART_KPIS_FAILED,
    error: error
  };
}

var FETCH_GROUP_KPIS = exports.FETCH_GROUP_KPIS = "FETCH_GROUP_KPIS";
var FETCH_GROUP_KPIS_REQUESTED = exports.FETCH_GROUP_KPIS_REQUESTED = "FETCH_GROUP_KPIS_REQUESTED";
var FETCH_GROUP_KPIS_COMPLETED = exports.FETCH_GROUP_KPIS_COMPLETED = "FETCH_GROUP_KPIS_COMPLETED";
var FETCH_GROUP_KPIS_FAILED = exports.FETCH_GROUP_KPIS_FAILED = "FETCH_GROUP_KPIS_FAILED";

function fetchGroupKpisRequested() {
  return {
    type: FETCH_GROUP_KPIS_REQUESTED
  };
}

function fetchGroupKpis(group_id) {

  return function (dispatch) {
    dispatch(fetchGroupKpisRequested());
    return _gambaApi2.default.get('/kpi/group_kpis', { group_id: group_id }).then(function (results) {
      dispatch(fetchGroupKpisCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchGroupKpisFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchGroupKpisCompleted(results) {
  return {
    type: FETCH_GROUP_KPIS_COMPLETED,
    results: results
  };
}

function fetchGroupKpisFailed(error) {
  return {
    type: FETCH_GROUP_KPIS_FAILED,
    error: error
  };
}

var FETCH_COMPARISON_KPIS = exports.FETCH_COMPARISON_KPIS = "FETCH_COMPARISON_KPIS";
var FETCH_COMPARISON_KPIS_REQUESTED = exports.FETCH_COMPARISON_KPIS_REQUESTED = "FETCH_COMPARISON_KPIS_REQUESTED";
var FETCH_COMPARISON_KPIS_COMPLETED = exports.FETCH_COMPARISON_KPIS_COMPLETED = "FETCH_COMPARISON_KPIS_COMPLETED";
var FETCH_COMPARISON_KPIS_FAILED = exports.FETCH_COMPARISON_KPIS_FAILED = "FETCH_COMPARISON_KPIS_FAILED";

function fetchComparisonKpisRequested() {
  return {
    type: FETCH_COMPARISON_KPIS_REQUESTED
  };
}

function fetchComparisonKpis() {
  var selected_kpis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var group_id = arguments[1];


  return function (dispatch) {
    dispatch(fetchComparisonKpisRequested());
    // Flatten selected_kpis into multiple query parameters
    var selectedKpisQuery = selected_kpis.map(function (kpi, index) {
      return 'selected_kpis[' + index + '][kpi_id]=' + kpi.kpi_id + '&selected_kpis[' + index + '][year]=' + kpi.year;
    }).join('&');

    var queryParams = 'group_id=' + group_id + '&' + selectedKpisQuery;

    return _gambaApi2.default.get('/kpi/comparison_kpis?' + queryParams).then(function (results) {
      dispatch(fetchComparisonKpisCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchComparisonKpisFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchComparisonKpisCompleted(results) {
  return {
    type: FETCH_COMPARISON_KPIS_COMPLETED,
    results: results
  };
}

function fetchComparisonKpisFailed(error) {
  return {
    type: FETCH_COMPARISON_KPIS_FAILED,
    error: error
  };
}

var FETCH_KPI = exports.FETCH_KPI = "FETCH_KPI";
var FETCH_KPI_REQUESTED = exports.FETCH_KPI_REQUESTED = "FETCH_KPI_REQUESTED";
var FETCH_KPI_COMPLETED = exports.FETCH_KPI_COMPLETED = "FETCH_KPI_COMPLETED";
var FETCH_KPI_FAILED = exports.FETCH_KPI_FAILED = "FETCH_KPI_FAILED";

function fetchKpiRequested() {
  return {
    type: FETCH_KPI_REQUESTED
  };
}

function fetchKpi(kpi_id) {
  return function (dispatch) {
    dispatch(fetchKpiRequested());
    return _gambaApi2.default.get('/kpi/' + kpi_id, {}).then(function (results) {
      dispatch(fetchKpiCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchKpiFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchKpiCompleted(results) {
  return {
    type: FETCH_KPI_COMPLETED,
    results: results
  };
}

function fetchKpiFailed(error) {
  return {
    type: FETCH_KPI_FAILED,
    error: error
  };
}

var CREATE_KPI = exports.CREATE_KPI = "CREATE_KPI";
var CREATE_KPI_REQUESTED = exports.CREATE_KPI_REQUESTED = "CREATE_KPI_REQUESTED";
var CREATE_KPI_COMPLETED = exports.CREATE_KPI_COMPLETED = "CREATE_KPI_COMPLETED";
var CREATE_KPI_FAILED = exports.CREATE_KPI_FAILED = "CREATE_KPI_FAILED";

function createKpiRequested() {
  return {
    type: CREATE_KPI_REQUESTED
  };
}

function createKpi(name, unit, group_id, start_date, end_date, generate_next_at_days, display_format, prepend_unit, accumulated_total, assignments) {
  return function (dispatch) {
    dispatch(createKpiRequested());
    return _gambaApi2.default.post('/kpi', { name: name, unit: unit, group_id: group_id, start_date: start_date, end_date: end_date, generate_next_at_days: generate_next_at_days, display_format: display_format, prepend_unit: prepend_unit, accumulated_total: accumulated_total, assignments: assignments }).then(function (results) {
      dispatch(createKpiCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(createKpiFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function createKpiCompleted(results) {
  return {
    type: CREATE_KPI_COMPLETED,
    results: results
  };
}

function createKpiFailed(error) {
  return {
    type: CREATE_KPI_FAILED,
    error: error
  };
}

var UPDATE_KPI = exports.UPDATE_KPI = "UPDATE_KPI";
var UPDATE_KPI_REQUESTED = exports.UPDATE_KPI_REQUESTED = "UPDATE_KPI_REQUESTED";
var UPDATE_KPI_COMPLETED = exports.UPDATE_KPI_COMPLETED = "UPDATE_KPI_COMPLETED";
var UPDATE_KPI_FAILED = exports.UPDATE_KPI_FAILED = "UPDATE_KPI_FAILED";

function updateKpiRequested() {
  return {
    type: UPDATE_KPI_REQUESTED
  };
}

function updateKpi(kpi_id, name, unit, group_id, start_date, end_date, generate_next_at_days, display_format, prepend_unit, accumulated_total, assignments) {
  return function (dispatch) {
    dispatch(updateKpiRequested());
    return _gambaApi2.default.put('/kpi/' + kpi_id, { name: name, unit: unit, group_id: group_id, start_date: start_date, end_date: end_date, generate_next_at_days: generate_next_at_days, display_format: display_format, prepend_unit: prepend_unit, accumulated_total: accumulated_total, assignments: assignments }).then(function (results) {
      dispatch(updateKpiCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateKpiFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateKpiCompleted(results) {
  return {
    type: UPDATE_KPI_COMPLETED,
    results: results
  };
}

function updateKpiFailed(error) {
  return {
    type: UPDATE_KPI_FAILED,
    error: error
  };
}

var DELETE_KPI = exports.DELETE_KPI = "DELETE_KPI";
var DELETE_KPI_REQUESTED = exports.DELETE_KPI_REQUESTED = "DELETE_KPI_REQUESTED";
var DELETE_KPI_COMPLETED = exports.DELETE_KPI_COMPLETED = "DELETE_KPI_COMPLETED";
var DELETE_KPI_FAILED = exports.DELETE_KPI_FAILED = "DELETE_KPI_FAILED";

function deleteKpiRequested() {
  return {
    type: DELETE_KPI_REQUESTED
  };
}

function deleteKpi(kpi_id) {
  return function (dispatch) {
    dispatch(deleteKpiRequested());
    return _gambaApi2.default.delete('/kpi/' + kpi_id).then(function (results) {
      dispatch(deleteKpiCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deleteKpiFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteKpiCompleted(results) {
  return {
    type: DELETE_KPI_COMPLETED,
    results: results
  };
}

function deleteKpiFailed(error) {
  return {
    type: DELETE_KPI_FAILED,
    error: error
  };
}

var SORT_KPIS = exports.SORT_KPIS = "SORT_KPIS";
var SORT_KPIS_REQUESTED = exports.SORT_KPIS_REQUESTED = "SORT_KPIS_REQUESTED";
var SORT_KPIS_COMPLETED = exports.SORT_KPIS_COMPLETED = "SORT_KPIS_COMPLETED";
var SORT_KPIS_FAILED = exports.SORT_KPIS_FAILED = "SORT_KPIS_FAILED";

function sortKpisRequested() {
  return {
    type: SORT_KPIS_REQUESTED
  };
}

function sortKpis(sort_order, group_id) {
  return function (dispatch) {
    dispatch(sortKpisRequested());
    return _gambaApi2.default.put('/kpi/sort', { sort_order: sort_order, group_id: group_id, length: sort_order.length }).then(function (results) {
      dispatch(sortKpisCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(sortKpisFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function sortKpisCompleted(results) {
  return {
    type: SORT_KPIS_COMPLETED,
    results: results
  };
}

function sortKpisFailed(error) {
  return {
    type: SORT_KPIS_FAILED,
    error: error
  };
}

var CLEAR_KPIS = exports.CLEAR_KPIS = "CLEAR_KPIS";

function clearKpis() {
  return {
    type: CLEAR_KPIS
  };
}

var CLEAR_DIARY_KPI = exports.CLEAR_DIARY_KPI = "CLEAR_DIARY_KPI";

function clearDiaryKpi() {
  return {
    type: CLEAR_DIARY_KPI
  };
}

var CLEAR_CLOSED_KPIS = exports.CLEAR_CLOSED_KPIS = "CLEAR_CLOSED_KPIS";

function clearClosedKpis() {
  return {
    type: CLEAR_CLOSED_KPIS
  };
}

var KEEP_SCROLL_POSITION = exports.KEEP_SCROLL_POSITION = "KEEP_SCROLL_POSITION";

function keepScrollPosition(offset) {
  return {
    type: KEEP_SCROLL_POSITION,
    offset: offset
  };
}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_REACT_CHAT_FAILED = exports.DELETE_REACT_CHAT_COMPLETED = exports.DELETE_REACT_CHAT_REQUESTED = exports.DELETE_REACT_CHAT = exports.REACT_CHAT_FAILED = exports.REACT_CHAT_COMPLETED = exports.REACT_CHAT_REQUESTED = exports.REACT_CHAT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/actions/react-chat.js

exports.reactChatRequested = reactChatRequested;
exports.reactChat = reactChat;
exports.reactChatCompleted = reactChatCompleted;
exports.reactChatFailed = reactChatFailed;
exports.deleteReactChatRequested = deleteReactChatRequested;
exports.deleteReactChat = deleteReactChat;
exports.deleteReactChatCompleted = deleteReactChatCompleted;
exports.deleteReactChatFailed = deleteReactChatFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REACT_CHAT = exports.REACT_CHAT = "REACT_CHAT";
var REACT_CHAT_REQUESTED = exports.REACT_CHAT_REQUESTED = "REACT_CHAT_REQUESTED";
var REACT_CHAT_COMPLETED = exports.REACT_CHAT_COMPLETED = "REACT_CHAT_COMPLETED";
var REACT_CHAT_FAILED = exports.REACT_CHAT_FAILED = "REACT_CHAT_FAILED";
var DELETE_REACT_CHAT = exports.DELETE_REACT_CHAT = "DELETE_REACT_CHAT";
var DELETE_REACT_CHAT_REQUESTED = exports.DELETE_REACT_CHAT_REQUESTED = "DELETE_REACT_CHAT_REQUESTED";
var DELETE_REACT_CHAT_COMPLETED = exports.DELETE_REACT_CHAT_COMPLETED = "DELETE_REACT_CHAT_COMPLETED";
var DELETE_REACT_CHAT_FAILED = exports.DELETE_REACT_CHAT_FAILED = "DELETE_REACT_CHAT_FAILED";

function reactChatRequested() {
  return {
    type: REACT_CHAT_REQUESTED
  };
}

function reactChat(chat_room_id, message_id, like_type) {
  return function (dispatch) {
    dispatch(reactChatRequested());
    return _gambaApi2.default.post('/react_chat', { chat_room_id: chat_room_id, message_id: message_id, like_type: like_type }).then(function (result) {
      dispatch(reactChatCompleted(result, chat_room_id, message_id));
    }).catch(function (error) {
      Promise.all([dispatch(reactChatFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function reactChatCompleted(result, chat_room_id, message_id) {
  var offset = message_id;
  var results = [_extends({}, result)];
  return {
    type: REACT_CHAT_COMPLETED,
    results: results,
    offset: offset,
    chat_room_id: chat_room_id
  };
}

function reactChatFailed(error) {
  return {
    type: REACT_CHAT_FAILED,
    error: error
  };
}

function deleteReactChatRequested() {
  return {
    type: DELETE_REACT_CHAT_REQUESTED
  };
}

function deleteReactChat(chat_room_id, message_id, like_id) {
  return function (dispatch) {
    dispatch(deleteReactChatRequested());
    return _gambaApi2.default.delete('/react_chat/' + like_id).then(function (results) {
      dispatch(deleteReactChatCompleted(results, chat_room_id, message_id));
    }).catch(function (error) {
      Promise.all([dispatch(deleteReactChatFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteReactChatCompleted(result, chat_room_id, message_id) {
  var offset = message_id;
  var results = [_extends({}, result)];
  return {
    type: DELETE_REACT_CHAT_COMPLETED,
    results: results,
    offset: offset,
    chat_room_id: chat_room_id
  };
}

function deleteReactChatFailed(error) {
  return {
    type: DELETE_REACT_CHAT_FAILED,
    error: error
  };
}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_USER_PROFILE_TEMPLATE = exports.IMPORT_USER_PROFILE_TEMPLATE_FAILED = exports.IMPORT_USER_PROFILE_TEMPLATE_COMPLETED = exports.IMPORT_USER_PROFILE_TEMPLATE_REQUESTED = exports.IMPORT_USER_PROFILE_TEMPLATE = exports.CLEAR_DIARY_TEMPLATES = exports.CLEAR_TEMPLATES = exports.FETCH_TEMPLATE_FIELDS_FAILED = exports.FETCH_TEMPLATE_ALL_FIELDS_COMPLETED = exports.FETCH_TEMPLATE_FIELDS_COMPLETED = exports.FETCH_TEMPLATE_FIELDS_REQUESTED = exports.FETCH_TEMPLATE_FIELDS = exports.DELETE_TEMPLATE_FAILED = exports.DELETE_TEMPLATE_COMPLETED = exports.DELETE_TEMPLATE_REQUESTED = exports.DELETE_TEMPLATE = exports.UPDATE_TEMPLATE_FAILED = exports.UPDATE_TEMPLATE_COMPLETED = exports.UPDATE_TEMPLATE_REQUESTED = exports.UPDATE_TEMPLATE = exports.CREATE_TEMPLATE_FAILED = exports.CREATE_TEMPLATE_COMPLETED = exports.CREATE_TEMPLATE_REQUESTED = exports.CREATE_TEMPLATE = exports.FETCH_TEMPLATE_FAILED = exports.FETCH_TEMPLATE_COMPLETED = exports.FETCH_TEMPLATE_REQUESTED = exports.FETCH_TEMPLATE = exports.FETCH_TEMPLATE_LIST_FAILED = exports.FETCH_TEMPLATE_LIST_COMPLETED = exports.FETCH_TEMPLATE_LIST_REQUESTED = exports.FETCH_TEMPLATE_LIST = exports.FETCH_TEMPLATES_FAILED = exports.FETCH_TEMPLATES_COMPLETED = exports.FETCH_TEMPLATES_REQUESTED = exports.FETCH_TEMPLATES = exports.FETCH_DIARY_TEMPLATES_FAILED = exports.FETCH_DIARY_TEMPLATES_COMPLETED = exports.FETCH_DIARY_TEMPLATES_REQUESTED = exports.FETCH_DIARY_TEMPLATES = undefined;
exports.fetchDiaryTemplatesRequested = fetchDiaryTemplatesRequested;
exports.fetchDiaryTemplates = fetchDiaryTemplates;
exports.fetchDiaryTemplatesCompleted = fetchDiaryTemplatesCompleted;
exports.fetchDiaryTemplatesFailed = fetchDiaryTemplatesFailed;
exports.fetchTemplatesRequested = fetchTemplatesRequested;
exports.fetchTemplates = fetchTemplates;
exports.fetchTemplatesCompleted = fetchTemplatesCompleted;
exports.fetchTemplatesFailed = fetchTemplatesFailed;
exports.fetchTemplateListRequested = fetchTemplateListRequested;
exports.fetchTemplateList = fetchTemplateList;
exports.fetchTemplateListCompleted = fetchTemplateListCompleted;
exports.fetchTemplateListFailed = fetchTemplateListFailed;
exports.fetchTemplateRequested = fetchTemplateRequested;
exports.fetchTemplate = fetchTemplate;
exports.fetchTemplateCompleted = fetchTemplateCompleted;
exports.fetchTemplateFailed = fetchTemplateFailed;
exports.createTemplateRequested = createTemplateRequested;
exports.createTemplate = createTemplate;
exports.createTemplateCompleted = createTemplateCompleted;
exports.createTemplateFailed = createTemplateFailed;
exports.updateTemplateRequested = updateTemplateRequested;
exports.updateTemplate = updateTemplate;
exports.updateTemplateCompleted = updateTemplateCompleted;
exports.updateTemplateFailed = updateTemplateFailed;
exports.deleteTemplateRequested = deleteTemplateRequested;
exports.deleteTemplate = deleteTemplate;
exports.deleteTemplateCompleted = deleteTemplateCompleted;
exports.deleteTemplateFailed = deleteTemplateFailed;
exports.fetchTemplateFieldsRequested = fetchTemplateFieldsRequested;
exports.fetchTemplateFields = fetchTemplateFields;
exports.fetchTemplateAllFieldsCompleted = fetchTemplateAllFieldsCompleted;
exports.fetchTemplateFieldsCompleted = fetchTemplateFieldsCompleted;
exports.fetchTemplateFieldsFailed = fetchTemplateFieldsFailed;
exports.clearTemplates = clearTemplates;
exports.clearDiaryTemplates = clearDiaryTemplates;
exports.importUserProfileTemplateRequested = importUserProfileTemplateRequested;
exports.importUserProfileTemplate = importUserProfileTemplate;
exports.importUserProfileTemplateCompleted = importUserProfileTemplateCompleted;
exports.importUserProfileTemplateFailed = importUserProfileTemplateFailed;
exports.clearUserProfileTemplate = clearUserProfileTemplate;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/actions/templates.js

var FETCH_DIARY_TEMPLATES = exports.FETCH_DIARY_TEMPLATES = "FETCH_DIARY_TEMPLATES";
var FETCH_DIARY_TEMPLATES_REQUESTED = exports.FETCH_DIARY_TEMPLATES_REQUESTED = "FETCH_DIARY_TEMPLATES_REQUESTED";
var FETCH_DIARY_TEMPLATES_COMPLETED = exports.FETCH_DIARY_TEMPLATES_COMPLETED = "FETCH_DIARY_TEMPLATES_COMPLETED";
var FETCH_DIARY_TEMPLATES_FAILED = exports.FETCH_DIARY_TEMPLATES_FAILED = "FETCH_DIARY_TEMPLATES_FAILED";

function fetchDiaryTemplatesRequested() {
  return {
    type: FETCH_DIARY_TEMPLATES_REQUESTED
  };
}

function fetchDiaryTemplates(group_id, user_id) {
  return function (dispatch) {
    dispatch(fetchDiaryTemplatesRequested());
    return _gambaApi2.default.get('/templates', { group_id: group_id, user_id: user_id, with_last_diary: true, with_organizational: true }).then(function (results) {
      dispatch(fetchDiaryTemplatesCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDiaryTemplatesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchDiaryTemplatesCompleted(results) {
  return {
    type: FETCH_DIARY_TEMPLATES_COMPLETED,
    results: results
  };
}

function fetchDiaryTemplatesFailed(error) {
  return {
    type: FETCH_DIARY_TEMPLATES_FAILED,
    error: error
  };
}

var FETCH_TEMPLATES = exports.FETCH_TEMPLATES = "FETCH_TEMPLATES";
var FETCH_TEMPLATES_REQUESTED = exports.FETCH_TEMPLATES_REQUESTED = "FETCH_TEMPLATES_REQUESTED";
var FETCH_TEMPLATES_COMPLETED = exports.FETCH_TEMPLATES_COMPLETED = "FETCH_TEMPLATES_COMPLETED";
var FETCH_TEMPLATES_FAILED = exports.FETCH_TEMPLATES_FAILED = "FETCH_TEMPLATES_FAILED";

function fetchTemplatesRequested() {
  return {
    type: FETCH_TEMPLATES_REQUESTED
  };
}

function fetchTemplates(id, type) {
  return function (dispatch) {
    dispatch(fetchTemplatesRequested());
    return _gambaApi2.default.get('/templates', _defineProperty({}, type + '_id', id)).then(function (results) {
      dispatch(fetchTemplatesCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchTemplatesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchTemplatesCompleted(results) {
  return {
    type: FETCH_TEMPLATES_COMPLETED,
    results: results
  };
}

function fetchTemplatesFailed(error) {
  return {
    type: FETCH_TEMPLATES_FAILED,
    error: error
  };
}

var FETCH_TEMPLATE_LIST = exports.FETCH_TEMPLATE_LIST = "FETCH_TEMPLATE_LIST";
var FETCH_TEMPLATE_LIST_REQUESTED = exports.FETCH_TEMPLATE_LIST_REQUESTED = "FETCH_TEMPLATE_LIST_REQUESTED";
var FETCH_TEMPLATE_LIST_COMPLETED = exports.FETCH_TEMPLATE_LIST_COMPLETED = "FETCH_TEMPLATE_LIST_COMPLETED";
var FETCH_TEMPLATE_LIST_FAILED = exports.FETCH_TEMPLATE_LIST_FAILED = "FETCH_TEMPLATE_LIST_FAILED";

function fetchTemplateListRequested() {
  return {
    type: FETCH_TEMPLATE_LIST_REQUESTED
  };
}

function fetchTemplateList(id, type) {
  return function (dispatch) {
    dispatch(fetchTemplateListRequested());
    return _gambaApi2.default.get('/templates', _defineProperty({}, type + '_id', id)).then(function (results) {
      dispatch(fetchTemplateListCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchTemplateListFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchTemplateListCompleted(results) {
  return {
    type: FETCH_TEMPLATE_LIST_COMPLETED,
    results: results
  };
}

function fetchTemplateListFailed(error) {
  return {
    type: FETCH_TEMPLATE_LIST_FAILED,
    error: error
  };
}

var FETCH_TEMPLATE = exports.FETCH_TEMPLATE = "FETCH_TEMPLATE";
var FETCH_TEMPLATE_REQUESTED = exports.FETCH_TEMPLATE_REQUESTED = "FETCH_TEMPLATE_REQUESTED";
var FETCH_TEMPLATE_COMPLETED = exports.FETCH_TEMPLATE_COMPLETED = "FETCH_TEMPLATE_COMPLETED";
var FETCH_TEMPLATE_FAILED = exports.FETCH_TEMPLATE_FAILED = "FETCH_TEMPLATE_FAILED";

function fetchTemplateRequested() {
  return {
    type: FETCH_TEMPLATE_REQUESTED
  };
}

function fetchTemplate(template_id) {
  return function (dispatch) {
    dispatch(fetchTemplateRequested());
    return _gambaApi2.default.get('/templates/' + template_id, {}).then(function (results) {
      dispatch(fetchTemplateCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchTemplateFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchTemplateCompleted(results) {
  return {
    type: FETCH_TEMPLATE_COMPLETED,
    results: results
  };
}

function fetchTemplateFailed(error) {
  return {
    type: FETCH_TEMPLATE_FAILED,
    error: error
  };
}

var CREATE_TEMPLATE = exports.CREATE_TEMPLATE = "CREATE_TEMPLATE";
var CREATE_TEMPLATE_REQUESTED = exports.CREATE_TEMPLATE_REQUESTED = "CREATE_TEMPLATE_REQUESTED";
var CREATE_TEMPLATE_COMPLETED = exports.CREATE_TEMPLATE_COMPLETED = "CREATE_TEMPLATE_COMPLETED";
var CREATE_TEMPLATE_FAILED = exports.CREATE_TEMPLATE_FAILED = "CREATE_TEMPLATE_FAILED";

function createTemplateRequested() {
  return {
    type: CREATE_TEMPLATE_REQUESTED
  };
}

function createTemplate(name, template, id, type, attach_json) {
  return function (dispatch) {
    var _api$post;

    dispatch(createTemplateRequested());
    return _gambaApi2.default.post('/templates', (_api$post = { name: name, template: template }, _defineProperty(_api$post, type + '_id', id), _defineProperty(_api$post, 'attach_json', attach_json), _api$post)).then(function (results) {
      dispatch(createTemplateCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(createTemplateFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function createTemplateCompleted(results) {
  return {
    type: CREATE_TEMPLATE_COMPLETED,
    results: results
  };
}

function createTemplateFailed(error) {
  return {
    type: CREATE_TEMPLATE_FAILED,
    error: error
  };
}

var UPDATE_TEMPLATE = exports.UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
var UPDATE_TEMPLATE_REQUESTED = exports.UPDATE_TEMPLATE_REQUESTED = "UPDATE_TEMPLATE_REQUESTED";
var UPDATE_TEMPLATE_COMPLETED = exports.UPDATE_TEMPLATE_COMPLETED = "UPDATE_TEMPLATE_COMPLETED";
var UPDATE_TEMPLATE_FAILED = exports.UPDATE_TEMPLATE_FAILED = "UPDATE_TEMPLATE_FAILED";

function updateTemplateRequested() {
  return {
    type: UPDATE_TEMPLATE_REQUESTED
  };
}

function updateTemplate(template_id, name, template, attach_json) {
  return function (dispatch) {
    dispatch(updateTemplateRequested());
    return _gambaApi2.default.put('/templates/' + template_id, { name: name, template: template, attach_json: attach_json }).then(function (results) {
      dispatch(updateTemplateCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateTemplateFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateTemplateCompleted(results) {
  return {
    type: UPDATE_TEMPLATE_COMPLETED,
    results: results
  };
}

function updateTemplateFailed(error) {
  return {
    type: UPDATE_TEMPLATE_FAILED,
    error: error
  };
}

var DELETE_TEMPLATE = exports.DELETE_TEMPLATE = "DELETE_TEMPLATE";
var DELETE_TEMPLATE_REQUESTED = exports.DELETE_TEMPLATE_REQUESTED = "DELETE_TEMPLATE_REQUESTED";
var DELETE_TEMPLATE_COMPLETED = exports.DELETE_TEMPLATE_COMPLETED = "DELETE_TEMPLATE_COMPLETED";
var DELETE_TEMPLATE_FAILED = exports.DELETE_TEMPLATE_FAILED = "DELETE_TEMPLATE_FAILED";

function deleteTemplateRequested() {
  return {
    type: DELETE_TEMPLATE_REQUESTED
  };
}

function deleteTemplate(template_id) {
  return function (dispatch) {
    dispatch(deleteTemplateRequested());
    return _gambaApi2.default.delete('/templates/' + template_id).then(function (results) {
      dispatch(deleteTemplateCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deleteTemplateFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteTemplateCompleted(results) {
  return {
    type: DELETE_TEMPLATE_COMPLETED,
    results: results
  };
}

function deleteTemplateFailed(error) {
  return {
    type: DELETE_TEMPLATE_FAILED,
    error: error
  };
}

var FETCH_TEMPLATE_FIELDS = exports.FETCH_TEMPLATE_FIELDS = "FETCH_TEMPLATE_FIELDS";
var FETCH_TEMPLATE_FIELDS_REQUESTED = exports.FETCH_TEMPLATE_FIELDS_REQUESTED = "FETCH_TEMPLATE_FIELDS_REQUESTED";
var FETCH_TEMPLATE_FIELDS_COMPLETED = exports.FETCH_TEMPLATE_FIELDS_COMPLETED = "FETCH_TEMPLATE_FIELDS_COMPLETED";
var FETCH_TEMPLATE_ALL_FIELDS_COMPLETED = exports.FETCH_TEMPLATE_ALL_FIELDS_COMPLETED = "FETCH_TEMPLATE_ALL_COMPLETED";
var FETCH_TEMPLATE_FIELDS_FAILED = exports.FETCH_TEMPLATE_FIELDS_FAILED = "FETCH_TEMPLATE_FIELDS_FAILED";

function fetchTemplateFieldsRequested() {
  return {
    type: FETCH_TEMPLATE_FIELDS_REQUESTED
  };
}

function fetchTemplateFields(group_id, user_id) {
  var isDivision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return function (dispatch) {
    dispatch(fetchTemplateFieldsRequested());
    var query = isDivision ? { group_ids: group_id, user_id: user_id, with_organizational: true } : { group_id: group_id, user_id: user_id, with_organizational: true };
    return _gambaApi2.default.get('/templates', query).then(function (results) {
      isDivision ? dispatch(fetchTemplateAllFieldsCompleted(results)) : dispatch(fetchTemplateFieldsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchTemplateFieldsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchTemplateAllFieldsCompleted(results) {
  return {
    type: FETCH_TEMPLATE_ALL_FIELDS_COMPLETED,
    results: results
  };
}

function fetchTemplateFieldsCompleted(results) {
  return {
    type: FETCH_TEMPLATE_FIELDS_COMPLETED,
    results: results
  };
}

function fetchTemplateFieldsFailed(error) {
  return {
    type: FETCH_TEMPLATE_FIELDS_FAILED,
    error: error
  };
}

var CLEAR_TEMPLATES = exports.CLEAR_TEMPLATES = "CLEAR_TEMPLATES";

function clearTemplates() {
  return {
    type: CLEAR_TEMPLATES
  };
}

var CLEAR_DIARY_TEMPLATES = exports.CLEAR_DIARY_TEMPLATES = "CLEAR_DIARY_TEMPLATES";

function clearDiaryTemplates() {
  return {
    type: CLEAR_DIARY_TEMPLATES
  };
}

var IMPORT_USER_PROFILE_TEMPLATE = exports.IMPORT_USER_PROFILE_TEMPLATE = "IMPORT_USER_PROFILE_TEMPLATE";
var IMPORT_USER_PROFILE_TEMPLATE_REQUESTED = exports.IMPORT_USER_PROFILE_TEMPLATE_REQUESTED = "IMPORT_USER_PROFILE_TEMPLATE_REQUESTED";
var IMPORT_USER_PROFILE_TEMPLATE_COMPLETED = exports.IMPORT_USER_PROFILE_TEMPLATE_COMPLETED = "IMPORT_USER_PROFILE_TEMPLATE_COMPLETED";
var IMPORT_USER_PROFILE_TEMPLATE_FAILED = exports.IMPORT_USER_PROFILE_TEMPLATE_FAILED = "IMPORT_USER_PROFILE_TEMPLATE_FAILED";

function importUserProfileTemplateRequested() {
  return {
    type: IMPORT_USER_PROFILE_TEMPLATE_REQUESTED
  };
}

function importUserProfileTemplate() {
  return function (dispatch) {
    dispatch(importUserProfileTemplateRequested());
    return _gambaApi2.default.get('/templates/user_profile').then(function (results) {
      dispatch(importUserProfileTemplateCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(importUserProfileTemplateFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function importUserProfileTemplateCompleted(results) {
  return {
    type: IMPORT_USER_PROFILE_TEMPLATE_COMPLETED,
    results: results
  };
}

function importUserProfileTemplateFailed(error) {
  return {
    type: IMPORT_USER_PROFILE_TEMPLATE_FAILED,
    error: error
  };
}

var CLEAR_USER_PROFILE_TEMPLATE = exports.CLEAR_USER_PROFILE_TEMPLATE = "CLEAR_USER_PROFILE_TEMPLATE";

function clearUserProfileTemplate() {
  return {
    type: CLEAR_USER_PROFILE_TEMPLATE
  };
}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_UPLOAD_VIDEOS = exports.CANCEL_UPLOAD_VIDEO = exports.UPLOAD_VIDEO_PROGRESS = exports.UPLOAD_VIDEO_FAILED = exports.UPLOAD_VIDEO_COMPLETED = exports.UPLOAD_VIDEO_REQUESTED = exports.UPLOAD_VIDEO = undefined;
exports.uploadVideoRequested = uploadVideoRequested;
exports.uploadVideoProgress = uploadVideoProgress;
exports.uploadVideo = uploadVideo;
exports.uploadVideoCompleted = uploadVideoCompleted;
exports.uploadVideoFailed = uploadVideoFailed;
exports.cancelUploadVideo = cancelUploadVideo;
exports.clearUploadVideos = clearUploadVideos;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/upload-video.js

var UPLOAD_VIDEO = exports.UPLOAD_VIDEO = "UPLOAD_VIDEO";
var UPLOAD_VIDEO_REQUESTED = exports.UPLOAD_VIDEO_REQUESTED = "UPLOAD_VIDEO_REQUESTED";
var UPLOAD_VIDEO_COMPLETED = exports.UPLOAD_VIDEO_COMPLETED = "UPLOAD_VIDEO_COMPLETED";
var UPLOAD_VIDEO_FAILED = exports.UPLOAD_VIDEO_FAILED = "UPLOAD_VIDEO_FAILED";
var UPLOAD_VIDEO_PROGRESS = exports.UPLOAD_VIDEO_PROGRESS = "UPLOAD_VIDEO_PROGRESS";
var CANCEL_UPLOAD_VIDEO = exports.CANCEL_UPLOAD_VIDEO = "CANCEL_UPLOAD_VIDEO";
var CLEAR_UPLOAD_VIDEOS = exports.CLEAR_UPLOAD_VIDEOS = "CLEAR_UPLOAD_VIDEOS";

// 最大Videoアップロードファイルサイズを設定します。この値はAWSの制限に依存しています。
// 現在AWSでは最大アップロードファイルサイズを5000MBに制限しています。
var MAX_VIDEO_FILE_SIZE = 5 * 1024 * 1024 * 1024; // 5000MB in bytes
var MAX_VIDEO_FILE_SIZE_TITLE = "5000MB"; // Max file size displayed in error message

function uploadVideoRequested(componentId, uploadId) {
  return {
    type: UPLOAD_VIDEO_REQUESTED,
    componentId: componentId, uploadId: uploadId
  };
}

function uploadVideoProgress(loaded, total, componentId, uploadId) {
  return {
    type: UPLOAD_VIDEO_PROGRESS,
    loaded: loaded, total: total, componentId: componentId, uploadId: uploadId
  };
}

function uploadVideo(group_id, name, type, file, componentId) {
  var uploadId = Math.random().toString().slice(-12);
  return function (dispatch) {
    dispatch(uploadVideoRequested(componentId, uploadId));
    return _gambaApi2.default.upload('/upload_video', { group_id: group_id, name: name, type: type }).then(function (results) {
      _gambaApi2.default.s3upload(results.credentials, results.video_id, results.s3_key, file, function (progress) {
        dispatch(uploadVideoProgress(progress.loaded, progress.total, componentId, uploadId));
      }).then(function (video_id) {
        dispatch(uploadVideoCompleted(results, componentId, uploadId));
      }).catch(function (error) {
        Promise.all([dispatch(uploadVideoFailed(error, componentId, uploadId)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
      });
    }).catch(function (error) {
      // Check if video file size is over MAX_VIDEO_FILE_SIZE
      if (file.size > MAX_VIDEO_FILE_SIZE) {
        Promise.all([dispatch(uploadVideoFailed(error, componentId, uploadId)), dispatch((0, _alertMessage.emitAlertMessage)({ message: 'error:ファイルサイズが制限を超えています', max_file_size: MAX_VIDEO_FILE_SIZE_TITLE }, 'error'))]);
      } else {
        Promise.all([dispatch(uploadVideoFailed(error, componentId, uploadId)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
      }
    });
  };
}

function uploadVideoCompleted(results, componentId, uploadId) {
  return {
    type: UPLOAD_VIDEO_COMPLETED,
    results: results, componentId: componentId, uploadId: uploadId
  };
}

function uploadVideoFailed(error, componentId, uploadId) {
  return {
    type: UPLOAD_VIDEO_FAILED,
    error: error, componentId: componentId, uploadId: uploadId
  };
}

function cancelUploadVideo(componentId, uploadId) {
  return {
    type: CANCEL_UPLOAD_VIDEO,
    componentId: componentId, uploadId: uploadId
  };
}

function clearUploadVideos(componentId) {
  return {
    type: CLEAR_UPLOAD_VIDEOS,
    componentId: componentId
  };
}

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_GOOGLE_DRIVE_FOLDERS = exports.CLEAR_GOOGLE_CALENDAR_CALENDARS = exports.CLEAR_GOOGLE_CALENDAR_EVENTS = exports.FETCH_GOOGLE_CALENDAR_CALENDARS_FAILED = exports.FETCH_GOOGLE_CALENDAR_CALENDARS_COMPLETED = exports.FETCH_GOOGLE_CALENDAR_CALENDARS_REQUESTED = exports.FETCH_GOOGLE_CALENDAR_CALENDARS = exports.FETCH_GOOGLE_CALENDAR_EVENTS_FAILED = exports.FETCH_GOOGLE_CALENDAR_EVENTS_COMPLETED = exports.FETCH_GOOGLE_CALENDAR_EVENTS_REQUESTED = exports.FETCH_GOOGLE_CALENDAR_EVENTS = exports.UPLOAD_GOOGLE_DRIVE_FILE_FAILED = exports.UPLOAD_GOOGLE_DRIVE_FILE_COMPLETED = exports.UPLOAD_GOOGLE_DRIVE_FILE_REQUESTED = exports.UPLOAD_GOOGLE_DRIVE_FILE = exports.FETCH_REFRESH_TOKEN_FAILED = exports.FETCH_REFRESH_TOKEN_COMPLETED = exports.FETCH_REFRESH_TOKEN_REQUESTED = exports.FETCH_REFRESH_TOKEN = exports.FETCH_GOOGLE_DRIVE_USERINFO_FAILED = exports.FETCH_GOOGLE_DRIVE_USERINFO_COMPLETED = exports.FETCH_GOOGLE_DRIVE_USERINFO_REQUESTED = exports.FETCH_GOOGLE_DRIVE_USERINFO = exports.FETCH_GOOGLE_DRIVE_FOLDERS_FAILED = exports.FETCH_GOOGLE_DRIVE_FOLDERS_COMPLETED = exports.FETCH_GOOGLE_DRIVE_FOLDERS_REQUESTED = exports.FETCH_GOOGLE_DRIVE_FOLDERS = exports.FETCH_GOOGLE_DRIVE_FILE_FAILED = exports.FETCH_GOOGLE_DRIVE_FILE_COMPLETED = exports.FETCH_GOOGLE_DRIVE_FILE_REQUESTED = exports.FETCH_GOOGLE_DRIVE_FILE = undefined;
exports.fetchGoogleDriveFileRequested = fetchGoogleDriveFileRequested;
exports.fetchGoogleDriveFile = fetchGoogleDriveFile;
exports.fetchGoogleDriveFileCompleted = fetchGoogleDriveFileCompleted;
exports.fetchGoogleDriveFileFailed = fetchGoogleDriveFileFailed;
exports.fetchGoogleDriveFoldersRequested = fetchGoogleDriveFoldersRequested;
exports.fetchGoogleDriveFolders = fetchGoogleDriveFolders;
exports.fetchGoogleDriveFoldersCompleted = fetchGoogleDriveFoldersCompleted;
exports.fetchGoogleDriveFoldersFailed = fetchGoogleDriveFoldersFailed;
exports.fetchGoogleDriveUserInfoRequested = fetchGoogleDriveUserInfoRequested;
exports.fetchGoogleDriveUserInfo = fetchGoogleDriveUserInfo;
exports.fetchGoogleDriveUserInfoCompleted = fetchGoogleDriveUserInfoCompleted;
exports.fetchGoogleDriveUserInfoFailed = fetchGoogleDriveUserInfoFailed;
exports.fetchRefreshTokenRequested = fetchRefreshTokenRequested;
exports.fetchRefreshToken = fetchRefreshToken;
exports.fetchRefreshTokenCompleted = fetchRefreshTokenCompleted;
exports.fetchRefreshTokenFailed = fetchRefreshTokenFailed;
exports.uploadGoogleDriveFileRequested = uploadGoogleDriveFileRequested;
exports.uploadGoogleDriveFile = uploadGoogleDriveFile;
exports.uploadGoogleDriveFileCompleted = uploadGoogleDriveFileCompleted;
exports.uploadGoogleDriveFileFailed = uploadGoogleDriveFileFailed;
exports.fetchGoogleCalendarEventsRequested = fetchGoogleCalendarEventsRequested;
exports.fetchGoogleCalendarEvents = fetchGoogleCalendarEvents;
exports.fetchGoogleCalendarEventsCompleted = fetchGoogleCalendarEventsCompleted;
exports.fetchGoogleCalendarEventsFailed = fetchGoogleCalendarEventsFailed;
exports.fetchGoogleCalendarCalendarsRequested = fetchGoogleCalendarCalendarsRequested;
exports.fetchGoogleCalendarCalendars = fetchGoogleCalendarCalendars;
exports.fetchGoogleCalendarCalendarsCompleted = fetchGoogleCalendarCalendarsCompleted;
exports.fetchGoogleCalendarCalendarsFailed = fetchGoogleCalendarCalendarsFailed;
exports.clearGoogleCalendarEvents = clearGoogleCalendarEvents;
exports.clearGoogleCalendarCalendars = clearGoogleCalendarCalendars;
exports.clearGoogleDriveFolders = clearGoogleDriveFolders;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_GOOGLE_DRIVE_FILE = exports.FETCH_GOOGLE_DRIVE_FILE = "FETCH_GOOGLE_DRIVE_FILE";
// src/actions/google-api.js

var FETCH_GOOGLE_DRIVE_FILE_REQUESTED = exports.FETCH_GOOGLE_DRIVE_FILE_REQUESTED = "FETCH_GOOGLE_DRIVE_FILE_REQUESTED";
var FETCH_GOOGLE_DRIVE_FILE_COMPLETED = exports.FETCH_GOOGLE_DRIVE_FILE_COMPLETED = "FETCH_GOOGLE_DRIVE_FILE_COMPLETED";
var FETCH_GOOGLE_DRIVE_FILE_FAILED = exports.FETCH_GOOGLE_DRIVE_FILE_FAILED = "FETCH_GOOGLE_DRIVE_FILE_FAILED";

function fetchGoogleDriveFileRequested(url, componentId) {
  return {
    type: FETCH_GOOGLE_DRIVE_FILE_REQUESTED,
    url: url, componentId: componentId
  };
}

function fetchGoogleDriveFile(url, componentId) {
  return function (dispatch) {
    var file_id = url.replace(/^https:\/\/[a-z]+\.google\.com\/[a-z]+\/[a-z]+\/([-_0-9a-zA-Z]+).*$/, '$1');
    dispatch(fetchGoogleDriveFileRequested(url, componentId));
    var gapi = global.gapi;
    return gapi.client.drive.files.get({ fileId: file_id }).then(function (results) {
      dispatch(fetchGoogleDriveFileCompleted(url, results, componentId));
    }).catch(function (error) {
      dispatch(fetchGoogleDriveFileFailed(error, url, componentId));
    });
  };
}

function fetchGoogleDriveFileCompleted(url, results, componentId) {
  return {
    type: FETCH_GOOGLE_DRIVE_FILE_COMPLETED,
    results: {
      title: results.result.name,
      url: url,
      mime_type: results.result.mimeType
    },
    url: url, componentId: componentId
  };
}

function fetchGoogleDriveFileFailed(error, url, componentId) {
  return {
    type: FETCH_GOOGLE_DRIVE_FILE_FAILED,
    error: error, url: url, componentId: componentId
  };
}

var FETCH_GOOGLE_DRIVE_FOLDERS = exports.FETCH_GOOGLE_DRIVE_FOLDERS = "FETCH_GOOGLE_DRIVE_FOLDERS";
var FETCH_GOOGLE_DRIVE_FOLDERS_REQUESTED = exports.FETCH_GOOGLE_DRIVE_FOLDERS_REQUESTED = "FETCH_GOOGLE_DRIVE_FOLDERS_REQUESTED";
var FETCH_GOOGLE_DRIVE_FOLDERS_COMPLETED = exports.FETCH_GOOGLE_DRIVE_FOLDERS_COMPLETED = "FETCH_GOOGLE_DRIVE_FOLDERS_COMPLETED";
var FETCH_GOOGLE_DRIVE_FOLDERS_FAILED = exports.FETCH_GOOGLE_DRIVE_FOLDERS_FAILED = "FETCH_GOOGLE_DRIVE_FOLDERS_FAILED";

function fetchGoogleDriveFoldersRequested() {
  return {
    type: FETCH_GOOGLE_DRIVE_FOLDERS_REQUESTED
  };
}

function fetchGoogleDriveFolders() {
  return function (dispatch) {
    dispatch(fetchGoogleDriveFoldersRequested());

    // Get folder list from Google Drive
    var gapi = global.gapi;
    return gapi.client.drive.files.list({
      'fields': "files(id, name)",
      'q': "mimeType='application/vnd.google-apps.folder' and trashed=false and 'me' in owners"
    }).then(function (results) {
      var files = results.result && results.result.files ? results.result.files : [];
      if (files == 0) {
        dispatch(fetchGoogleDriveFoldersCompleted([]));
      } else {
        var fileData = files.map(function (file) {
          return {
            id: file.id,
            name: file.name
          };
        });
        dispatch(fetchGoogleDriveFoldersCompleted(fileData));
      }
    }, function (error) {
      Promise.all([dispatch(fetchGoogleDriveFoldersFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)('error: google-drive-folders', 'error'))]);
    });
  };
}

function fetchGoogleDriveFoldersCompleted(results) {
  return {
    type: FETCH_GOOGLE_DRIVE_FOLDERS_COMPLETED,
    results: results
  };
}

function fetchGoogleDriveFoldersFailed(error) {
  return {
    type: FETCH_GOOGLE_DRIVE_FOLDERS_FAILED,
    error: error
  };
}

var FETCH_GOOGLE_DRIVE_USERINFO = exports.FETCH_GOOGLE_DRIVE_USERINFO = "FETCH_GOOGLE_DRIVE_USERINFO";
var FETCH_GOOGLE_DRIVE_USERINFO_REQUESTED = exports.FETCH_GOOGLE_DRIVE_USERINFO_REQUESTED = "FETCH_GOOGLE_DRIVE_USERINFO_REQUESTED";
var FETCH_GOOGLE_DRIVE_USERINFO_COMPLETED = exports.FETCH_GOOGLE_DRIVE_USERINFO_COMPLETED = "FETCH_GOOGLE_DRIVE_USERINFO_COMPLETED";
var FETCH_GOOGLE_DRIVE_USERINFO_FAILED = exports.FETCH_GOOGLE_DRIVE_USERINFO_FAILED = "FETCH_GOOGLE_DRIVE_USERINFO_FAILED";

function fetchGoogleDriveUserInfoRequested() {
  return {
    type: FETCH_GOOGLE_DRIVE_USERINFO_REQUESTED
  };
}

function fetchGoogleDriveUserInfo() {
  return function (dispatch) {
    dispatch(fetchGoogleDriveUserInfoRequested());

    // Get User info from Google Drive
    var gapi = global.gapi;
    return gapi.client.drive.about.get({
      'fields': "user(emailAddress, displayName)"
    }).then(function (results) {
      var userInfo = results.result && results.result.user ? results.result.user : {};
      dispatch(fetchGoogleDriveUserInfoCompleted(userInfo));
    }, function (error) {
      Promise.all([dispatch(fetchGoogleDriveUserInfoFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)('error: google-drive-userinfo', 'error'))]);
    });
  };
}

function fetchGoogleDriveUserInfoCompleted(results) {
  return {
    type: FETCH_GOOGLE_DRIVE_USERINFO_COMPLETED,
    results: results
  };
}

function fetchGoogleDriveUserInfoFailed(error) {
  return {
    type: FETCH_GOOGLE_DRIVE_USERINFO_FAILED,
    error: error
  };
}

var FETCH_REFRESH_TOKEN = exports.FETCH_REFRESH_TOKEN = "FETCH_REFRESH_TOKEN";
var FETCH_REFRESH_TOKEN_REQUESTED = exports.FETCH_REFRESH_TOKEN_REQUESTED = "FETCH_REFRESH_TOKEN_REQUESTED";
var FETCH_REFRESH_TOKEN_COMPLETED = exports.FETCH_REFRESH_TOKEN_COMPLETED = "FETCH_REFRESH_TOKEN_COMPLETED";
var FETCH_REFRESH_TOKEN_FAILED = exports.FETCH_REFRESH_TOKEN_FAILED = "FETCH_REFRESH_TOKEN_FAILED";

function fetchRefreshTokenRequested() {
  return {
    type: FETCH_REFRESH_TOKEN_REQUESTED
  };
}

function fetchRefreshToken() {
  return function (dispatch) {
    var auth_code = localStorage.getItem("Google_Auth_Code");
    localStorage.removeItem("Google_Auth_Code");
    dispatch(fetchRefreshTokenRequested());

    // Get refresh token from authorization code.
    var data = {
      code: auth_code,
      client_id: _config2.default.integrationKeys.google.clientId,
      client_secret: _config2.default.integrationKeys.google.clientSecret,
      redirect_uri: "postmessage",
      grant_type: 'authorization_code'
    };

    fetch('https://oauth2.googleapis.com/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(data).toString()
    }).then(function (response) {
      return response.json();
    }).then(function (results) {
      dispatch(fetchRefreshTokenCompleted(results));
      dispatch((0, _alertMessage.emitAlertMessage)('refresh tokenが正常に取得されました。', 'success'));
    }).catch(function (error) {
      dispatch(fetchRefreshTokenFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)('error:google-refresh-token', 'error'));
    });
  };
}

function fetchRefreshTokenCompleted(results) {
  return {
    type: FETCH_REFRESH_TOKEN_COMPLETED,
    results: results
  };
}

function fetchRefreshTokenFailed(error) {
  return {
    type: FETCH_REFRESH_TOKEN_FAILED,
    error: error
  };
}

var UPLOAD_GOOGLE_DRIVE_FILE = exports.UPLOAD_GOOGLE_DRIVE_FILE = "UPLOAD_GOOGLE_DRIVE_FILE";
var UPLOAD_GOOGLE_DRIVE_FILE_REQUESTED = exports.UPLOAD_GOOGLE_DRIVE_FILE_REQUESTED = "UPLOAD_GOOGLE_DRIVE_FILE_REQUESTED";
var UPLOAD_GOOGLE_DRIVE_FILE_COMPLETED = exports.UPLOAD_GOOGLE_DRIVE_FILE_COMPLETED = "UPLOAD_GOOGLE_DRIVE_FILE_COMPLETED";
var UPLOAD_GOOGLE_DRIVE_FILE_FAILED = exports.UPLOAD_GOOGLE_DRIVE_FILE_FAILED = "UPLOAD_GOOGLE_DRIVE_FILE_FAILED";

function uploadGoogleDriveFileRequested() {
  return {
    type: UPLOAD_GOOGLE_DRIVE_FILE_REQUESTED
  };
}

function uploadGoogleDriveFile(folder_id, file_name, file_url) {
  return function (dispatch) {
    var token = JSON.parse(localStorage.getItem("Google_API_Token"));
    var accessToken = token.access_token;

    dispatch(uploadGoogleDriveFileRequested());

    // Get the file content from file URL
    fetch(file_url).then(function (response) {
      return response.blob();
    }).then(function (blob) {
      // Create the file metadata
      var formData = new FormData();
      formData.append('metadata', new Blob([JSON.stringify({
        'name': file_name,
        'mimeType': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'parents': [folder_id]
      })], { type: 'application/json' }));
      formData.append('file', blob);

      // Send the request for uploading file to Google Drive
      fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id', {
        method: 'POST',
        headers: new Headers({ 'Authorization': 'Bearer ' + accessToken }),
        body: formData
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        dispatch(uploadGoogleDriveFileCompleted());
        dispatch((0, _alertMessage.emitAlertMessage)('\u300C' + file_name + '\u300D\u30D5\u30A1\u30A4\u30EB\u304CGoogle\u30C9\u30E9\u30A4\u30D6\u30D5\u30A9\u30EB\u30C0\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002', 'success'));
      }).catch(function (error) {
        dispatch(uploadGoogleDriveFileFailed(error));
        dispatch((0, _alertMessage.emitAlertMessage)('error: upload-google-drive-file', 'error'));
      });
    });
  };
}

function uploadGoogleDriveFileCompleted(results) {
  return {
    type: UPLOAD_GOOGLE_DRIVE_FILE_COMPLETED,
    results: results
  };
}

function uploadGoogleDriveFileFailed(error) {
  return {
    type: UPLOAD_GOOGLE_DRIVE_FILE_FAILED,
    error: error
  };
}

var FETCH_GOOGLE_CALENDAR_EVENTS = exports.FETCH_GOOGLE_CALENDAR_EVENTS = "FETCH_GOOGLE_CALENDAR_EVENTS";
var FETCH_GOOGLE_CALENDAR_EVENTS_REQUESTED = exports.FETCH_GOOGLE_CALENDAR_EVENTS_REQUESTED = "FETCH_GOOGLE_CALENDAR_EVENTS_REQUESTED";
var FETCH_GOOGLE_CALENDAR_EVENTS_COMPLETED = exports.FETCH_GOOGLE_CALENDAR_EVENTS_COMPLETED = "FETCH_GOOGLE_CALENDAR_EVENTS_COMPLETED";
var FETCH_GOOGLE_CALENDAR_EVENTS_FAILED = exports.FETCH_GOOGLE_CALENDAR_EVENTS_FAILED = "FETCH_GOOGLE_CALENDAR_EVENTS_FAILED";

function fetchGoogleCalendarEventsRequested(selectDate) {
  return {
    type: FETCH_GOOGLE_CALENDAR_EVENTS_REQUESTED,
    selectDate: selectDate
  };
}

function fetchGoogleCalendarEvents(selectDate, calendar) {
  var startDate = (0, _moment2.default)(selectDate).startOf('day');
  var endDate = (0, _moment2.default)(selectDate).endOf('day');

  return function (dispatch) {
    dispatch(fetchGoogleCalendarEventsRequested(selectDate));
    var gapi = global.gapi;
    if (gapi && gapi.client && gapi.client.calendar && gapi.client.calendar.events) {
      return gapi.client.calendar.events.list({
        calendarId: calendar,
        timeMin: startDate.toISOString(),
        timeMax: endDate.toISOString(),
        orderBy: 'startTime',
        singleEvents: true,
        maxResults: 1000
      }).then(function (results) {
        dispatch(fetchGoogleCalendarEventsCompleted(selectDate, calendar, results.result.items.map(function (item) {
          //gapi.client.calendar.events.listで20日~25日のような予定がある場合、end.dateには26日と取得されるため1日マイナスをしてreducerに渡す
          var endItem = item.end.date && (0, _moment2.default)(new Date(item.end.date).setDate(new Date(item.end.date).getDate() - 1)).format("YYYY-MM-DD");

          return {
            event_id: item.id,
            title: item.summary,
            date: item.start.date || item.start.dateTime.slice(0, 10),
            endDate: endItem ? endItem : null,
            startTime: item.start.date ? null : item.start.dateTime,
            endTime: item.start.date ? null : item.end.dateTime,
            description: item.description
          };
        })));
      }, function (error) {
        Promise.all([dispatch(fetchGoogleCalendarEventsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)('error:google-calendar-events', 'error'))]);
      });
    } else {
      dispatch((0, _alertMessage.emitAlertMessage)('error:google-calendar-events', 'error'));
    }
  };
}

function fetchGoogleCalendarEventsCompleted(selectDate, calendar, results) {
  return {
    type: FETCH_GOOGLE_CALENDAR_EVENTS_COMPLETED,
    selectDate: selectDate, calendar: calendar, results: results
  };
}

function fetchGoogleCalendarEventsFailed(error) {
  return {
    type: FETCH_GOOGLE_CALENDAR_EVENTS_FAILED,
    error: error
  };
}

var FETCH_GOOGLE_CALENDAR_CALENDARS = exports.FETCH_GOOGLE_CALENDAR_CALENDARS = "FETCH_GOOGLE_CALENDAR_CALENDARS";
var FETCH_GOOGLE_CALENDAR_CALENDARS_REQUESTED = exports.FETCH_GOOGLE_CALENDAR_CALENDARS_REQUESTED = "FETCH_GOOGLE_CALENDAR_CALENDARS_REQUESTED";
var FETCH_GOOGLE_CALENDAR_CALENDARS_COMPLETED = exports.FETCH_GOOGLE_CALENDAR_CALENDARS_COMPLETED = "FETCH_GOOGLE_CALENDAR_CALENDARS_COMPLETED";
var FETCH_GOOGLE_CALENDAR_CALENDARS_FAILED = exports.FETCH_GOOGLE_CALENDAR_CALENDARS_FAILED = "FETCH_GOOGLE_CALENDAR_CALENDARS_FAILED";

function fetchGoogleCalendarCalendarsRequested() {
  return {
    type: FETCH_GOOGLE_CALENDAR_CALENDARS_REQUESTED
  };
}

function fetchGoogleCalendarCalendars() {
  return function (dispatch) {
    dispatch(fetchGoogleCalendarCalendarsRequested());
    var gapi = global.gapi;
    if (gapi && gapi.client && gapi.client.calendar && gapi.client.calendar.calendarList) {
      return gapi.client.calendar.calendarList.list({ minAccessRole: 'owner', maxResults: 250 }).then(function (results) {
        if (!results.result.items || results.result.items.length == 0) dispatch(fetchGoogleCalendarCalendarsCompleted([]));else dispatch(fetchGoogleCalendarCalendarsCompleted(results.result.items.map(function (item) {
          return {
            id: item.primary && 'primary' || item.id,
            name: item.summary
          };
        })));
      }, function (error) {
        Promise.all([dispatch(fetchGoogleCalendarCalendarsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)('error:google-calendar-list', 'error'))]);
      });
    } else {
      dispatch((0, _alertMessage.emitAlertMessage)('error:google-calendar-list', 'error'));
    }
  };
}

function fetchGoogleCalendarCalendarsCompleted(results) {
  return {
    type: FETCH_GOOGLE_CALENDAR_CALENDARS_COMPLETED,
    results: results
  };
}

function fetchGoogleCalendarCalendarsFailed(error) {
  return {
    type: FETCH_GOOGLE_CALENDAR_CALENDARS_FAILED,
    error: error
  };
}

var CLEAR_GOOGLE_CALENDAR_EVENTS = exports.CLEAR_GOOGLE_CALENDAR_EVENTS = "CLEAR_GOOGLE_CALENDAR_EVENTS";

function clearGoogleCalendarEvents() {
  return {
    type: CLEAR_GOOGLE_CALENDAR_EVENTS
  };
}

var CLEAR_GOOGLE_CALENDAR_CALENDARS = exports.CLEAR_GOOGLE_CALENDAR_CALENDARS = "CLEAR_GOOGLE_CALENDAR_CALENDARS";

function clearGoogleCalendarCalendars() {
  return {
    type: CLEAR_GOOGLE_CALENDAR_CALENDARS
  };
}

var CLEAR_GOOGLE_DRIVE_FOLDERS = exports.CLEAR_GOOGLE_DRIVE_FOLDERS = "CLEAR_GOOGLE_DRIVE_FOLDERS";

function clearGoogleDriveFolders() {
  return {
    type: CLEAR_GOOGLE_DRIVE_FOLDERS
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDIT_DIARY_FAILED = exports.EDIT_DIARY_COMPLETED = exports.EDIT_DIARY_REQUESTED = exports.EDIT_DIARY = undefined;
exports.editDiaryRequested = editDiaryRequested;
exports.editDiary = editDiary;
exports.editDiaryCompleted = editDiaryCompleted;
exports.editDiaryFailed = editDiaryFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

var _uploadFile = __webpack_require__(261);

var _uploadVideo = __webpack_require__(464);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/edit-diary.js

var EDIT_DIARY = exports.EDIT_DIARY = "EDIT_DIARY";
var EDIT_DIARY_REQUESTED = exports.EDIT_DIARY_REQUESTED = "EDIT_DIARY_REQUESTED";
var EDIT_DIARY_COMPLETED = exports.EDIT_DIARY_COMPLETED = "EDIT_DIARY_COMPLETED";
var EDIT_DIARY_FAILED = exports.EDIT_DIARY_FAILED = "EDIT_DIARY_FAILED";

function editDiaryRequested() {
  return {
    type: EDIT_DIARY_REQUESTED
  };
}

function editDiary(diary_id) {
  return function (dispatch) {
    dispatch(editDiaryRequested());
    return _gambaApi2.default.get('/diaries/' + diary_id, {}).then(function (results) {
      dispatch(editDiaryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(editDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function editDiaryCompleted(results) {
  return {
    type: EDIT_DIARY_COMPLETED,
    results: results
  };
}

function editDiaryFailed(error) {
  return {
    type: EDIT_DIARY_FAILED,
    error: error
  };
}

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POST_DIARY_REPORT_FAILED = exports.POST_DIARY_REPORT_COMPLETED = exports.POST_DIARY_REPORT_REQUESTED = exports.POST_DIARY_REPORT = exports.FETCH_DIARY_REPORT_FAILED = exports.FETCH_DIARY_REPORT_COMPLETED = exports.FETCH_DIARY_REPORT_REQUESTED = exports.FETCH_DIARY_REPORT = undefined;
exports.fetchDiaryReportRequested = fetchDiaryReportRequested;
exports.fetchDiary = fetchDiary;
exports.fetchDiaryReportCompleted = fetchDiaryReportCompleted;
exports.fetchDiaryReportFailed = fetchDiaryReportFailed;
exports.putDiaryReportRequested = putDiaryReportRequested;
exports.putDiaryReportReport = putDiaryReportReport;
exports.putDiaryReportCompleted = putDiaryReportCompleted;
exports.putDiaryReportFailed = putDiaryReportFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/diary-report.js

var FETCH_DIARY_REPORT = exports.FETCH_DIARY_REPORT = "FETCH_DIARY_REPORT";
var FETCH_DIARY_REPORT_REQUESTED = exports.FETCH_DIARY_REPORT_REQUESTED = "FETCH_DIARY_REPORT_REQUESTED";
var FETCH_DIARY_REPORT_COMPLETED = exports.FETCH_DIARY_REPORT_COMPLETED = "FETCH_DIARY_REPORT_COMPLETED";
var FETCH_DIARY_REPORT_FAILED = exports.FETCH_DIARY_REPORT_FAILED = "FETCH_DIARY_REPORT_FAILED";

function fetchDiaryReportRequested() {
  return {
    type: FETCH_DIARY_REPORT_REQUESTED
  };
}

function fetchDiary(group_id) {
  return function (dispatch) {
    dispatch(fetchDiaryReportRequested());
    return _gambaApi2.default.get('/diary_report_settings/' + group_id).then(function (results) {
      dispatch(fetchDiaryReportCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDiaryReportFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchDiaryReportCompleted(results) {
  return {
    type: FETCH_DIARY_REPORT_COMPLETED,
    results: results
  };
}

function fetchDiaryReportFailed(error) {
  return {
    type: FETCH_DIARY_REPORT_FAILED,
    error: error
  };
}

var POST_DIARY_REPORT = exports.POST_DIARY_REPORT = "POST_DIARY_REPORT";
var POST_DIARY_REPORT_REQUESTED = exports.POST_DIARY_REPORT_REQUESTED = "POST_DIARY_REPORT_REQUESTED";
var POST_DIARY_REPORT_COMPLETED = exports.POST_DIARY_REPORT_COMPLETED = "POST_DIARY_REPORT_COMPLETED";
var POST_DIARY_REPORT_FAILED = exports.POST_DIARY_REPORT_FAILED = "POST_DIARY_REPORT_FAILED";

function putDiaryReportRequested(group_id, is_weekly_report, is_monthly_report, weekly_report_start_date, monthly_report_start_date, input_diary_user_count) {
  return {
    type: POST_DIARY_REPORT_REQUESTED,
    group_id: group_id, is_weekly_report: is_weekly_report, is_monthly_report: is_monthly_report, weekly_report_start_date: weekly_report_start_date, monthly_report_start_date: monthly_report_start_date, input_diary_user_count: input_diary_user_count
  };
}

function putDiaryReportReport(group_id, is_weekly_report, is_monthly_report, weekly_report_start_date, monthly_report_start_date, input_diary_user_count) {
  return function (dispatch) {
    dispatch(putDiaryReportRequested(group_id, is_weekly_report, is_monthly_report, weekly_report_start_date, monthly_report_start_date, input_diary_user_count));
    return _gambaApi2.default.put('/diary_report_settings', { group_id: group_id, is_weekly_report: is_weekly_report, is_monthly_report: is_monthly_report, weekly_report_start_date: weekly_report_start_date, monthly_report_start_date: monthly_report_start_date, input_diary_user_count: input_diary_user_count }).then(function (results) {
      dispatch(putDiaryReportCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(putDiaryReportFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function putDiaryReportCompleted(results) {
  return {
    type: POST_DIARY_REPORT_COMPLETED,
    results: results
  };
}

function putDiaryReportFailed(error) {
  return {
    type: POST_DIARY_REPORT_FAILED,
    error: error
  };
}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_DIVISION_FAILED = exports.DELETE_DIVISION_COMPLETED = exports.DELETE_DIVISION_REQUESTED = exports.UPDATE_DIVISION_GROUP_FAILED = exports.UPDATE_DIVISION_GROUP_COMPLETED = exports.UPDATE_DIVISION_GROUP_REQUESTED = exports.UPDATE_DIVISION_COMPLETED = exports.SET_CURRENT_DIVISION = exports.SET_CURRENT_ID = exports.FETCH_DIVISIONS_FAILED = exports.FETCH_DIVISIONS_COMPLETED = exports.FETCH_DIVISIONS_REQUESTED = exports.FETCH_DIVISIONS = undefined;
exports.fetchDivisionsRequested = fetchDivisionsRequested;
exports.fetchDivisionsCompleted = fetchDivisionsCompleted;
exports.fetchDivisionsFailed = fetchDivisionsFailed;
exports.setCurrentDivisionId = setCurrentDivisionId;
exports.setCurrentDivision = setCurrentDivision;
exports.fetchDivisions = fetchDivisions;
exports.reloadDivision = reloadDivision;
exports.updateDivisionGroupRequested = updateDivisionGroupRequested;
exports.updateDivisionGroupCompleted = updateDivisionGroupCompleted;
exports.updateDivisionGroupFailed = updateDivisionGroupFailed;
exports.updateDivisionGroup = updateDivisionGroup;
exports.deleteDivisionRequested = deleteDivisionRequested;
exports.deleteDivision = deleteDivision;
exports.deleteDivisionCompleted = deleteDivisionCompleted;
exports.deleteDivisionFailed = deleteDivisionFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_DIVISIONS = exports.FETCH_DIVISIONS = "FETCH_DIVISIONS";
// src/actions/divisions.js

var FETCH_DIVISIONS_REQUESTED = exports.FETCH_DIVISIONS_REQUESTED = "FETCH_DIVISIONS_REQUESTED";
var FETCH_DIVISIONS_COMPLETED = exports.FETCH_DIVISIONS_COMPLETED = "FETCH_DIVISIONS_COMPLETED";
var FETCH_DIVISIONS_FAILED = exports.FETCH_DIVISIONS_FAILED = "FETCH_DIVISIONS_FAILED";
var SET_CURRENT_ID = exports.SET_CURRENT_ID = "SET_CURRENT_ID";
var SET_CURRENT_DIVISION = exports.SET_CURRENT_DIVISION = "SET_CURRENT_DIVISION";

var UPDATE_DIVISION_COMPLETED = exports.UPDATE_DIVISION_COMPLETED = "UPDATE_DIVISION_COMPLETED";

function fetchDivisionsRequested() {
  return {
    type: FETCH_DIVISIONS_REQUESTED
  };
}

function fetchDivisionsCompleted(results) {
  return {
    type: FETCH_DIVISIONS_COMPLETED,
    results: results
  };
}
function fetchDivisionsFailed(error) {
  return {
    type: FETCH_DIVISIONS_FAILED,
    error: error
  };
}
function setCurrentDivisionId(currentId) {
  return {
    type: SET_CURRENT_ID,
    currentId: currentId === 'new' ? 0 : parseInt(currentId)
  };
}
function setCurrentDivision(currentDivision) {
  return {
    type: SET_CURRENT_DIVISION,
    currentDivision: currentDivision
  };
}

function fetchDivisions() {
  return function (dispatch) {
    dispatch(fetchDivisionsRequested());
    return _gambaApi2.default.get('/divisions').then(function (results) {
      dispatch(fetchDivisionsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDivisionsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function reloadDivision(results) {
  return {
    type: UPDATE_DIVISION_COMPLETED,
    results: results
  };
}

var UPDATE_DIVISION_GROUP_REQUESTED = exports.UPDATE_DIVISION_GROUP_REQUESTED = "UPDATE_DIVISION_GROUP_REQUESTED";
var UPDATE_DIVISION_GROUP_COMPLETED = exports.UPDATE_DIVISION_GROUP_COMPLETED = "UPDATE_DIVISION_GROUP_COMPLETED";
var UPDATE_DIVISION_GROUP_FAILED = exports.UPDATE_DIVISION_GROUP_FAILED = "UPDATE_DIVISION_GROUP_FAILED";

function updateDivisionGroupRequested() {
  return {
    type: UPDATE_DIVISION_GROUP_REQUESTED
  };
}

function updateDivisionGroupCompleted(results) {
  return {
    type: UPDATE_DIVISION_GROUP_COMPLETED,
    results: results
  };
}

function updateDivisionGroupFailed(error) {
  return {
    type: UPDATE_DIVISION_GROUP_FAILED,
    error: error
  };
}

function updateDivisionGroup(division_id, group_id) {
  var membership = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'add';
  // 'add', 'remove'
  return function (dispatch) {
    dispatch(updateDivisionGroupRequested());
    return _gambaApi2.default.put('/division_groups/' + division_id + '/groups/' + group_id, { membership: membership }).then(function (results) {
      dispatch(updateDivisionGroupCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateDivisionGroupFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

var DELETE_DIVISION_REQUESTED = exports.DELETE_DIVISION_REQUESTED = "DELETE_DIVISION_REQUESTED";
var DELETE_DIVISION_COMPLETED = exports.DELETE_DIVISION_COMPLETED = "DELETE_DIVISION_COMPLETED";
var DELETE_DIVISION_FAILED = exports.DELETE_DIVISION_FAILED = "DELETE_DIVISION_FAILED";

function deleteDivisionRequested() {
  return {
    type: DELETE_DIVISION_REQUESTED
  };
}

function deleteDivision(group_id) {
  return function (dispatch) {
    dispatch(deleteDivisionRequested());
    return _gambaApi2.default.delete('/divisions/' + group_id).then(function (results) {
      dispatch(deleteDivisionCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deleteDivisionFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteDivisionCompleted(results) {
  return {
    type: DELETE_DIVISION_COMPLETED,
    results: results
  };
}

function deleteDivisionFailed(error) {
  return {
    type: DELETE_DIVISION_FAILED,
    error: error
  };
}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(333);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(862);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(1759);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(864);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActivableRendererFactory = function ActivableRendererFactory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { delay: 500 };
  return function (ActivableComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(ActivableRenderer, _Component);

      function ActivableRenderer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ActivableRenderer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivableRenderer.__proto__ || Object.getPrototypeOf(ActivableRenderer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          active: _this.props.active,
          rendered: _this.props.active
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(ActivableRenderer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (nextProps.active && !this.props.active) this.renderAndActivate();
          if (!nextProps.active && this.props.active) this.deactivateAndUnrender();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          clearTimeout(this.activateTimeout);
          clearTimeout(this.unrenderTimeout);
        }
      }, {
        key: 'renderAndActivate',
        value: function renderAndActivate() {
          var _this2 = this;

          if (this.unrenderTimeout) clearTimeout(this.unrenderTimeout);
          this.setState({ rendered: true, active: false }, function () {
            _this2.activateTimeout = setTimeout(function () {
              return _this2.setState({ active: true });
            }, 20);
          });
        }
      }, {
        key: 'deactivateAndUnrender',
        value: function deactivateAndUnrender() {
          var _this3 = this;

          this.setState({ rendered: true, active: false }, function () {
            _this3.unrenderTimeout = setTimeout(function () {
              _this3.setState({ rendered: false });
              _this3.unrenderTimeout = null;
            }, _this3.props.delay);
          });
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              delay = _props.delay,
              others = _objectWithoutProperties(_props, ['delay']); // eslint-disable-line no-unused-vars


          var _state = this.state,
              active = _state.active,
              rendered = _state.rendered;

          return rendered ? _react2.default.createElement(ActivableComponent, _extends({}, others, { active: active })) : null;
        }
      }]);

      return ActivableRenderer;
    }(_react.Component), _class.propTypes = {
      active: _propTypes2.default.bool.isRequired,
      children: _propTypes2.default.node,
      delay: _propTypes2.default.number
    }, _class.defaultProps = {
      delay: options.delay
    }, _temp2;
  };
};

exports.default = ActivableRendererFactory;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = function _isPlaceholder(a) {
  return a != null &&
         typeof a === 'object' &&
         a['@@functional/placeholder'] === true;
};


/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAADAFBMVEVHcEwEAABRUQAGAQEEAAAFAQEEAAAEAAAEAAAEAAD65+AGAgIEAAAIBgYAAAAAAAD55t8EAAAMCgv65+AEAAB/fwD65+AGAgIGAQEIBAMEAAAEAABAODb61QAJBwgJAwMIBQUjHRxaUU8FAAAEAAAQDxF+cm8AAAAqJCP55985MzGAvd8NBwcEAAAZFBMuJyYSDg4EAAARFBgLBgaEeHQEAAAFAAB6tNQEAAB2amgXEBD45d4lHh4DAAAEAAAEAAAWGh8pIyIDAAADAAD51gD71QDy39iml5N/u9wGAACilJE1LSxORUIAAAAnNT7p2NDz4doFAACShoEEAAAyRlP61QD/2ABGZniLf3tZT00EAAAEAAAFAAAEAADx39gDAAADAADNvbfZxsAEAABqmrZxZ2NSSkkjMDnu3NX35N2zpJ/249zJuLJAODcgGhksPUcdFxb61QD61gCuoJttn7wgGRj45t8EAAA+V2cSDQzj0sy0paDr2dP35d4EAADNvLbRwLpnW1kcFhWcjotfVlPm1c7XxsBRSEbq2dIgLDRFPjxNb4Nxp8X61QD71QDi0ctCXm/61QD51QD61QB0rMoDAAAGAAB3sNDezcdRdovx3tgDAACtn5rDtK5DAABjWlfHtbHgzsgAAAC/r6nbysRij6lgi6VtYl9UepCUh4MzLSxpXlycj4r71gD61QD/zwD61QD61QD61QDDs60IAAAaIijUwryYi4foAAEEAAAEAABeh6APCQn249zz4dq5q6VfVVM3Tl0bFBPu3dVnl7L/zgD71QD61QD61QBZgZgFAADu3NWEAAF5bWrLAAHEAAG4qqRxAAGompUZHiNIQUB9udn/0wD61QD51QD/1QD71QDbysS/r6qkAAEEAAAwAACtAAEnAADTwr1mlK8VK0NMRUP20QD51QD/1gBjkaqnmJMgAABcAAHhAAHtAAHdAAHTAAHn1s9QSEUgR20bPFwrZJru7u7MysomWoz65+AEAACBvuD61QDvAAEGAAErZZwBvJdhAAAA+XRSTlMA7gHs9un0/vj9/uX83QQN/TbU9/IC9OLn+7d8wf3b3+Hmvy920MMSxfDZ/ti+zt/Srsv4w4hu9CDE7/zI2tVDx+JKVCY627/7JsvDwBjA7/inx4/AowzFxM3EyWU99ppQxOOz3cW/wNXm0eLB1srA65dkv+Ho7KHC8+zA8unR3d/BzMm/z8fP0sLTx+jlq8zE2lbz6pUr78rK2FvP18DJ2ukIwcjV08LLwNzIwHxsCskuvMHNw+HC+HGE0PX73sDLwOzX2gV0TLPOM/TFw+Hd1MHNxcD4FJGIGEXm1c/Fw9LGxdnBuByKGdbHyb/y/e3n7s7QyPzx2ul5LTOtAAALuElEQVQYGe3BBViU+doH4Adm4J1hhqFh6I4hJQQUFUwMxDUxsQM7VzHX7m6sVdd2U90ydnV1262jpzu+rv36+f1f3O+dggGkBs51ru863Dd16NChQ4cOf7UevUZ/EQEjR1KLGWInxJ6jthi1qA9ZuC6SX6UWyl/uD0CTWUht8Gr4nj5E5LpIlg9Qy4zXAAvnLQOQlk9Oe323HL6nj+siWZbfpBYJBc5UMfOcK9nw70XOcn1NluXwN2RZDn+dWmISpA/YqmIr9LnkrEf7Zavd1LyAXoddUMx2Hu9AiissHExOWSxb7e9DzTmyFkC0HysCq5i5YlUlzG76kBMe7Zatwkf2oSb5+KNrT7zDCo+5KL6XEAyg5455d+AygBo3uDA3Li7uxBGq51W5RviePtQ4ryBsNZ3BZDbrp5WCIY2ZbGJm0xiMM9DzxXbuDhvj4Vhy8KrsKHzkz6gxcUj24zH4PZu9UgnpWhVbmRYilJ7DtddYOJJCjpDdx3KN3W/9ZHHfUdSom9jCPB2rmPnF6cDVbVxjC9SDqQGfcahP39lAFh/LivCDsiyHj6ImufposIZ5CR4zV0UjuNiPHWxFZ6rH67AWzzFuMCleO/jGTxb3HfVzWQ7fT03yWQvAg3kbunrfe4Ces7iOvXAzUB2x3fF8QUeIaBRZvSXLn1JTfNzRVYKJ2SMaW5Kx1cRWgVfGVLDCIxqF5OiEBo1xO0I1+obLP6UmGLpjemAGtjHzEjxApYmtTFsRHchmOXifHIRKaJxbPtX4VF5MTSjEMj9+jOvMbHoAzPNgi6oMdJ3FFnMxlWq4dkaTeiSS3ZvhfakJochhPoZoP2aeC6DLGmauytEDS9jqGMaSnethNCPElez2/Jia8D6uM3tHYy4ze1wDoE+etwyQeiKBrbZhLdm4dkaz4siuDzUlFAnMfAMLTcwcmAGLO9M/mosP2eoYxpJV/lQ0Lzg0kZo3OFOPq8zsnYzprLi3DF3PvzIrkPk8rrHVKqin5k743OfEUA1axP/9RGrGuR4IDkY/Zp6VjVWsmJOBO8VrmNck4wO2+hCtZpxETXsPPe91QRdWTIb0AStePAMEZyRnI9rEFi9mo/WkzgZqShomc1WwdjMrioEuJlZsyYbi3+ewVTGcMtRATeiOWcxXsGwOK85no/LKK3tXZSD4g80VbHMvG85ZTk1Yi83MfjsQPYsVH+2ARfReruG9A86Ko8YtRzEzv5iM7BverDgPzLs2N5BrvQOnaQZQo3qhawUzm8YAGUv2zjr/AJe4jiWQxsJZadQo17GY58fMHjcWwmKriR14LwHiDGlwlg81aoALPjSxInDyQiwbM9mba3m8chVA0OHxbnDScmrcBHdkVLFZMo6xA+8t89BWLgHUuM910CfMYTZVoh/XWJOzEO0glpqQOBTA1THLkOzBdnN6AkGpaLPx1KQJmRoA2m1sd+wBPC+mHHJDyxkHuqOhUGqGV2FnPe5cr2CzNTkS4o8KIY5LaCnPKRyDhoZT8z4fB2h3FP9+bpdsaEufCrMRaKENq5nLo9DARGqJwhA9LLIuCptStIQ+poAVG9FAZ2oZr94TJ4YgS9QaIaFZkbPZaj7qy6WWS1RJF0WtnS5omuZP5Wzztgb19KZWyIVviqi1q0hC46RuL3GtEtSTT61g6IEy4ehCloTnk7qdYkdf6FCHjlqlF3R5oo6lpSo0pCtZxzVWJ2wIYx6NOoZS62RipqhnJ6I8JTiIHHSygO0KBiapkXqS2TsejsZT6+T76/9e1HUfM/j7gTFhSRtUAFQzfsEOyqPg9uQUm72sRy13L2qlXKT2F3XMRAJbfTHwia8e6eygYNPAu2wThlrLqbUM43Bf1PEjDORaQ945yY0YokKNCdRqsRr1NOEoC7O5ZRJg18OVWi8Uqf2Fg3icYotB6QO9+TnKc+afZbMCX9j0JicYxmGBcOCLl9hiZYlL6ui7bPGLdWwzpUSlmvECW/xSC4seAeSMAergC6JWBKaw4m63boPCjM+ihrGiIDWdLWZ302u6Pb4Uc5ItBsFiEjknF555wm6EFuvYLCfmSZL6mft6ViRgI1v4Pnv2zC3Sd0MOm3ms9Ieiuys5xzUEt4TNCgCn2GLlDFXU+iGsKNfFs1XBPyQFe65fyXZBgDswiZyUqMM+YZHnr3fDbLaISd9YwBabpG+4xtlNke7lbPWF5PZ2wWiMJWdN0KsfCrPL6NYN33FdK/2T2JH3FLY5hXRmbzdtIjkrFJ55QrETYWEYzXVtRPzb/FyjEcbMnTCAnGVIQ1GKEOIhPGOwievJUanXF/BzzMBjZvbFAHJaYiRGCIUvUhHG9a1Mwndss3o119iA2czlGn8DOS9Wrb0shLigATpxQ+u82eKLGP9ObHfXXVPOnIAQaosTcFkqhFghwb2A7Yakl7zNtabEqIBItvsG6cyro1BIbTIcnkeFEPv0+CXbrQMQUTJs3dkhZ9cNK+kkwfhPxki224T1fHc+QqhtDCGIfyqE2I5LbPc9PH/nDzv1P375brXKk+1S8fKpeEQmUht5rcUtIcRxbOAaxsjqd3/77enf/O43p7/91bvVCk0ntlkHuAFr86nN8o0YIUSeRrOa7bpJ/1Zdx7uYzzYlgNTjvXPUDnzUUpkQRejCdgn4trqOrxHGVuUq/QAvaieT9Prj4jOkst0QTWp1HV/iMVtNRya1n/GS+nZKJAayXRJ+W+3oNL5hixeCJB9qR6Hw/0MZUgvY5mXpZrWjVJe7bLEJmdSuhsO4NAIJbJeEL6trfSUlscUUNSTdr5fn+gRQOwkYCt0+yX8K25x1cfmqusZpDGOzu+nQqfRQuE30ofZhyERQEeJfYJthUuS/Vtt8rYkqYLMSxPcXT5fuLPWVgF/7ULswTIXOBUkFbBODyK+rLf45FRvZLEcyHhJWu+7roB1uoPZwLgQaYNBdtlmv1Zz+qrr6X34ViSdsNkyvvi1q9F+hRqaB2sO5NHjqkP4923wXAbgFuUA/w5sVj/Xqz4S4XaQy3pomzKZFYTi1Cy8X6XgE3DayTcGwQZ5Rvk9eYkV5GPQ7VyzYrpcyoqHZJ8yWuuuPULsIRdbRHwHzT3F9JyOB7REAMj5iPrZQe1mYLcBwahdeQdgpjrtB2jD6BXYwez4A35lISNZWsKJfsGeKUPwBN8kZP/6E6ukN4yExzQ2A+/xLs79ns5cuRQCe/v7TXBb6Ze9gZo/NgQm4LBR50JFTdh8gxaPFr5PdVMT3F7sioNFAoYqITzdCYSzD/YsY7Z191bRmcjJWVaFIKHahOznlrfDFRJ/sX0Q1EnUoFSIvCzMve0Kth8IY8wRlR42pI7CFz0CRPdrEPf2fCiFWYCg55W/l8J++IYf3oVo+aowQov9MFC2NUv3PDO1/+Eb+t1t8itgOFWaZFlaOuXa+gpmv4DMhjgahFznD9YBsNpIc9dZjgRBihZS1S2f09P3hP9FJ//BoEbJKsXcyVjGz37EbHsdwX+RlIc2VnPF3I2WzN6mOE3qU9helKBVLjfjjD/+lw8zPdOoVKRek7EpUBW6ZXongNRUo2heFyMHkhNc/PihbLAqgOnqrkXXolqS+dXuaKvJ/f/B12a6NeCiE2OcLRN8BMq73Y28tgLTB5IS++2W7kY+oDh9/qMqmzXRBxC199z9CkrY/FYqUmYCUXNyP2Zs5WzO00JWcM+rNT96S5YMHZXnPI3I0WA/A9/bTsk4wUx0XZnlFAG4wVy1J1m7zQwi1xWuy/HP6Wd8DfclRHCx8y/Iebg8KKtolFIdGqKCIvt4TyD6zZjOGU1v0ld9wpQZuwkwFaLJWXHiacuhi2YJOethUTt8SyB4fopDaYlT4AWogUQtFd0PvTDVqqNSw2rHZZNp2BiHUNp8GUAO9YTaJiLwmdU5T6XqkTXwvNiAXFkZYhHhR2/wNNRQKRSbVYwiB2cQJ72cOHV5Ifw5xAMZ6UX1ea6GYSH8++WvHvWeghhIzAZygv4TY3FwDdejQoUOH/+f+Dxm58qLKsJ6LAAAAAElFTkSuQmCC"

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(222);
var _curry2 = __webpack_require__(335);
var _isPlaceholder = __webpack_require__(471);


/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3
             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
             : _curry1(function(_c) { return fn(a, b, _c); });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
             : fn(a, b, c);
    }
  };
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = exports.drawerFactory = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Portal = __webpack_require__(337);

var _Portal2 = _interopRequireDefault(_Portal);

var _identifiers = __webpack_require__(16);

var _ActivableRenderer = __webpack_require__(470);

var _ActivableRenderer2 = _interopRequireDefault(_ActivableRenderer);

var _Overlay = __webpack_require__(475);

var _Overlay2 = _interopRequireDefault(_Overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var factory = function factory(Overlay) {
  var Drawer = function Drawer(_ref) {
    var active = _ref.active,
        children = _ref.children,
        className = _ref.className,
        insideTree = _ref.insideTree,
        onOverlayClick = _ref.onOverlayClick,
        onEscKeyDown = _ref.onEscKeyDown,
        theme = _ref.theme,
        type = _ref.type,
        withOverlay = _ref.withOverlay;

    var _className = (0, _classnames3.default)([theme.drawer, theme[type]], _defineProperty({}, theme.active, active), className);

    var content = _react2.default.createElement(
      'aside',
      { 'data-react-toolbox': 'drawer', className: _className },
      children
    );

    return _react2.default.createElement(insideTree ? 'div' : _Portal2.default, { className: theme.wrapper }, withOverlay && _react2.default.createElement(Overlay, {
      active: active,
      onClick: onOverlayClick,
      onEscKeyDown: onEscKeyDown,
      theme: theme,
      themeNamespace: 'overlay'
    }), content);
  };

  Drawer.propTypes = {
    active: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    insideTree: _propTypes2.default.bool,
    onEscKeyDown: _propTypes2.default.func,
    onOverlayClick: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      active: _propTypes2.default.string,
      drawer: _propTypes2.default.string,
      left: _propTypes2.default.string,
      right: _propTypes2.default.string
    }),
    type: _propTypes2.default.oneOf(['left', 'right']),
    withOverlay: _propTypes2.default.bool
  };

  Drawer.defaultProps = {
    active: false,
    className: '',
    insideTree: false,
    type: 'left',
    withOverlay: true
  };

  return (0, _ActivableRenderer2.default)()(Drawer);
};

var Drawer = factory(_Overlay2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.DRAWER)(Drawer);
exports.drawerFactory = factory;
exports.Drawer = Drawer;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Overlay = function (_Component) {
  _inherits(Overlay, _Component);

  function Overlay() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Overlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.handleEscKey = function (e) {
      if (_this.props.active && _this.props.onEscKeyDown && e.which === 27) {
        _this.props.onEscKeyDown(e);
      }
    }, _this.handleClick = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Overlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          active = _props.active,
          lockScroll = _props.lockScroll,
          onEscKeyDown = _props.onEscKeyDown;

      if (onEscKeyDown) document.body.addEventListener('keydown', this.handleEscKey);
      if (active && lockScroll) document.body.style.overflow = 'hidden';
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (this.props.lockScroll) {
        var becomingActive = nextProps.active && !this.props.active;
        var becomingUnactive = !nextProps.active && this.props.active;

        if (becomingActive) {
          document.body.style.overflow = 'hidden';
        }

        if (becomingUnactive && !document.querySelectorAll('[data-react-toolbox="overlay"]')[1]) {
          document.body.style.overflow = '';
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.onEscKeyDown) {
        if (this.props.active && !prevProps.active) {
          document.body.addEventListener('keydown', this.handleEscKey);
        } else if (!this.props.active && prevProps.active) {
          document.body.removeEventListener('keydown', this.handleEscKey);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.active && this.props.lockScroll) {
        if (!document.querySelectorAll('[data-react-toolbox="overlay"]')[1]) {
          document.body.style.overflow = '';
        }
      }

      if (this.props.onEscKeyDown) {
        document.body.removeEventListener('keydown', this.handleEscKey);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          active = _props2.active,
          className = _props2.className,
          lockScroll = _props2.lockScroll,
          theme = _props2.theme,
          onEscKeyDown = _props2.onEscKeyDown,
          other = _objectWithoutProperties(_props2, ['active', 'className', 'lockScroll', 'theme', 'onEscKeyDown']); // eslint-disable-line


      return _react2.default.createElement('div', _extends({}, other, {
        onClick: this.handleClick,
        className: (0, _classnames3.default)(theme.overlay, _defineProperty({}, theme.active, active), className)
      }));
    }
  }]);

  return Overlay;
}(_react.Component);

Overlay.propTypes = {
  active: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  lockScroll: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onEscKeyDown: _propTypes2.default.func,
  theme: _propTypes2.default.shape({
    active: _propTypes2.default.string,
    backdrop: _propTypes2.default.string,
    overlay: _propTypes2.default.string
  })
};
Overlay.defaultProps = {
  lockScroll: true
};
exports.default = (0, _reactCssThemr.themr)(_identifiers.OVERLAY)(Overlay);
exports.Overlay = Overlay;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _overlay = __webpack_require__(879);

var _Drawer = __webpack_require__(474);

var _theme = __webpack_require__(1799);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Drawer = (0, _Drawer.drawerFactory)(_overlay.Overlay);
var ThemedDrawer = (0, _reactCssThemr.themr)(_identifiers.DRAWER, _theme2.default)(Drawer);

exports.default = ThemedDrawer;
exports.Drawer = ThemedDrawer;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dialogFactory = exports.Dialog = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _classnames3 = __webpack_require__(14);

var _classnames4 = _interopRequireDefault(_classnames3);

var _identifiers = __webpack_require__(16);

var _Portal = __webpack_require__(337);

var _Portal2 = _interopRequireDefault(_Portal);

var _ActivableRenderer = __webpack_require__(470);

var _ActivableRenderer2 = _interopRequireDefault(_ActivableRenderer);

var _Button = __webpack_require__(334);

var _Button2 = _interopRequireDefault(_Button);

var _Overlay = __webpack_require__(475);

var _Overlay2 = _interopRequireDefault(_Overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable jsx-a11y/aria-role */


var factory = function factory(Overlay, Button) {
  var Dialog = function Dialog(props) {
    var actions = props.actions.map(function (action, idx) {
      var className = (0, _classnames4.default)(props.theme.button, _defineProperty({}, action.className, action.className));
      return _react2.default.createElement(Button, _extends({ key: idx }, action, { className: className })); // eslint-disable-line
    });

    var className = (0, _classnames4.default)([props.theme.dialog, props.theme[props.type]], _defineProperty({}, props.theme.active, props.active), props.className);

    return _react2.default.createElement(
      _Portal2.default,
      { className: props.theme.wrapper },
      _react2.default.createElement(Overlay, {
        active: props.active,
        className: props.theme.overlay,
        onClick: props.onOverlayClick,
        onEscKeyDown: props.onEscKeyDown,
        onMouseDown: props.onOverlayMouseDown,
        onMouseMove: props.onOverlayMouseMove,
        onMouseUp: props.onOverlayMouseUp,
        theme: props.theme,
        themeNamespace: 'overlay'
      }),
      _react2.default.createElement(
        'div',
        { 'data-react-toolbox': 'dialog', className: className },
        _react2.default.createElement(
          'section',
          { role: 'body', className: props.theme.body },
          props.title ? _react2.default.createElement(
            'h6',
            { className: props.theme.title },
            props.title
          ) : null,
          props.children
        ),
        actions.length ? _react2.default.createElement(
          'nav',
          { className: props.theme.navigation },
          actions
        ) : null
      )
    );
  };

  Dialog.propTypes = {
    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      className: _propTypes2.default.string,
      label: _propTypes2.default.string,
      children: _propTypes2.default.node
    })),
    active: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    onEscKeyDown: _propTypes2.default.func,
    onOverlayClick: _propTypes2.default.func,
    onOverlayMouseDown: _propTypes2.default.func,
    onOverlayMouseMove: _propTypes2.default.func,
    onOverlayMouseUp: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      active: _propTypes2.default.string,
      body: _propTypes2.default.string,
      button: _propTypes2.default.string,
      dialog: _propTypes2.default.string,
      navigation: _propTypes2.default.string,
      overflow: _propTypes2.default.string,
      overlay: _propTypes2.default.string,
      title: _propTypes2.default.string,
      wrapper: _propTypes2.default.string
    }),
    title: _propTypes2.default.string,
    type: _propTypes2.default.string
  };

  Dialog.defaultProps = {
    actions: [],
    active: false,
    type: 'normal'
  };

  return (0, _ActivableRenderer2.default)()(Dialog);
};

var Dialog = factory(_Overlay2.default, _Button2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.DIALOG)(Dialog);
exports.Dialog = Dialog;
exports.dialogFactory = factory;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var properties = __webpack_require__(1805);
var PropTypes = __webpack_require__(1806);

module.exports = function(props, propName, componentName) {
  var styles = props[propName];
  if (!styles) {
    return;
  }

  var failures = [];
  Object.keys(styles).forEach(function(styleKey){
    if (properties.indexOf(styleKey) === -1) {
      failures.push(styleKey);
    }
  });
  if (failures.length) {
    throw new Error('Prop ' + propName + ' passed to ' + componentName + '. Has invalid keys ' + failures.join(', '));
  }
};

module.exports.isRequired = function(props, propName, componentName) {
  if (!props[propName]) {
    throw new Error('Prop ' + propName + ' passed to ' + componentName + ' is required');
  }
  return module.exports(props, propName, componentName);
};

module.exports.supportingArrays = PropTypes.oneOfType([
  PropTypes.arrayOf(module.exports),
  module.exports
]);


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(340);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__(1852)('socket.io-parser');
var json = __webpack_require__(1855);
var Emitter = __webpack_require__(1856);
var binary = __webpack_require__(1857);
var isBuf = __webpack_require__(894);

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
    encodeAsBinary(obj, callback);
  }
  else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {
  var str = '';
  var nsp = false;

  // first is type
  str += obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
    str += obj.attachments;
    str += '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' != obj.nsp) {
    nsp = true;
    str += obj.nsp;
  }

  // immediately followed by the id
  if (null != obj.id) {
    if (nsp) {
      str += ',';
      nsp = false;
    }
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    if (nsp) str += ',';
    str += json.stringify(obj.data);
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an ecoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if ('string' == typeof obj) {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  }
  else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  }
  else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var p = {};
  var i = 0;

  // look up type
  p.type = Number(str.charAt(0));
  if (null == exports.types[p.type]) return error();

  // look up attachments if type binary
  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
    var buf = '';
    while (str.charAt(++i) != '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) != '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' == str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' == c) break;
      p.nsp += c;
      if (i == str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i == str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    p = tryParse(p, str.substr(i));
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(p, str) {
  try {
    p.data = json.parse(str);
  } catch(e){
    return error();
  }
  return p; 
};

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(data){
  return {
    type: exports.ERROR,
    data: 'parser error'
  };
}


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module

var hasCORS = __webpack_require__(1862);

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var parser = __webpack_require__(225);
var Emitter = __webpack_require__(267);

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};


/***/ }),
/* 483 */
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parser = __webpack_require__(480);
var Emitter = __webpack_require__(267);
var toArray = __webpack_require__(1877);
var on = __webpack_require__(901);
var bind = __webpack_require__(902);
var debug = __webpack_require__(344)('socket.io-client:socket');
var hasBin = __webpack_require__(898);

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var parserType = parser.EVENT; // default
  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
  var packet = { type: parserType, data: args };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  delete this.flags;

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      this.packet({type: parser.CONNECT, query: this.query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  if (packet.nsp !== this.nsp) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
    self.packet({
      type: type,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags = this.flags || {};
  this.flags.compress = compress;
  return this;
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _permanentStore = __webpack_require__(118);

var _permanentStore2 = _interopRequireDefault(_permanentStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY = "gambaApp.announceReadDate"; // src/helpers/announce-unread-flag.js

exports.default = (0, _permanentStore2.default)(KEY);

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(907);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _permanentStore = __webpack_require__(118);

var _permanentStore2 = _interopRequireDefault(_permanentStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY = "gambaApp.savedSearchQuery"; // src/helpers/save-search-query-temp.js

exports.default = (0, _permanentStore2.default)(KEY);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1894);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./compact-list.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./compact-list.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var userAgent = window.navigator.userAgent.toLowerCase();

  if (userAgent.indexOf('opera') != -1) {
    return 'opera';
  } else if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1 || userAgent.indexOf('edge') != -1) {
    return 'ie';
  } else if (userAgent.indexOf('chrome') != -1) {
    return 'chrome';
  } else if (userAgent.indexOf('iphone') != -1 || userAgent.indexOf('ipad') != -1) {
    return 'ios-app';
  } else if (userAgent.indexOf('safari') != -1) {
    return 'safari';
  } else if (userAgent.indexOf('firefox') != -1) {
    return 'firefox';
  } else if (userAgent.indexOf('gecko') != -1) {
    return 'gecko';
  } else {
    return false;
  }
};

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Abreve": "Ă",
	"abreve": "ă",
	"ac": "∾",
	"acd": "∿",
	"acE": "∾̳",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"Acy": "А",
	"acy": "а",
	"AElig": "Æ",
	"aelig": "æ",
	"af": "⁡",
	"Afr": "𝔄",
	"afr": "𝔞",
	"Agrave": "À",
	"agrave": "à",
	"alefsym": "ℵ",
	"aleph": "ℵ",
	"Alpha": "Α",
	"alpha": "α",
	"Amacr": "Ā",
	"amacr": "ā",
	"amalg": "⨿",
	"amp": "&",
	"AMP": "&",
	"andand": "⩕",
	"And": "⩓",
	"and": "∧",
	"andd": "⩜",
	"andslope": "⩘",
	"andv": "⩚",
	"ang": "∠",
	"ange": "⦤",
	"angle": "∠",
	"angmsdaa": "⦨",
	"angmsdab": "⦩",
	"angmsdac": "⦪",
	"angmsdad": "⦫",
	"angmsdae": "⦬",
	"angmsdaf": "⦭",
	"angmsdag": "⦮",
	"angmsdah": "⦯",
	"angmsd": "∡",
	"angrt": "∟",
	"angrtvb": "⊾",
	"angrtvbd": "⦝",
	"angsph": "∢",
	"angst": "Å",
	"angzarr": "⍼",
	"Aogon": "Ą",
	"aogon": "ą",
	"Aopf": "𝔸",
	"aopf": "𝕒",
	"apacir": "⩯",
	"ap": "≈",
	"apE": "⩰",
	"ape": "≊",
	"apid": "≋",
	"apos": "'",
	"ApplyFunction": "⁡",
	"approx": "≈",
	"approxeq": "≊",
	"Aring": "Å",
	"aring": "å",
	"Ascr": "𝒜",
	"ascr": "𝒶",
	"Assign": "≔",
	"ast": "*",
	"asymp": "≈",
	"asympeq": "≍",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"awconint": "∳",
	"awint": "⨑",
	"backcong": "≌",
	"backepsilon": "϶",
	"backprime": "‵",
	"backsim": "∽",
	"backsimeq": "⋍",
	"Backslash": "∖",
	"Barv": "⫧",
	"barvee": "⊽",
	"barwed": "⌅",
	"Barwed": "⌆",
	"barwedge": "⌅",
	"bbrk": "⎵",
	"bbrktbrk": "⎶",
	"bcong": "≌",
	"Bcy": "Б",
	"bcy": "б",
	"bdquo": "„",
	"becaus": "∵",
	"because": "∵",
	"Because": "∵",
	"bemptyv": "⦰",
	"bepsi": "϶",
	"bernou": "ℬ",
	"Bernoullis": "ℬ",
	"Beta": "Β",
	"beta": "β",
	"beth": "ℶ",
	"between": "≬",
	"Bfr": "𝔅",
	"bfr": "𝔟",
	"bigcap": "⋂",
	"bigcirc": "◯",
	"bigcup": "⋃",
	"bigodot": "⨀",
	"bigoplus": "⨁",
	"bigotimes": "⨂",
	"bigsqcup": "⨆",
	"bigstar": "★",
	"bigtriangledown": "▽",
	"bigtriangleup": "△",
	"biguplus": "⨄",
	"bigvee": "⋁",
	"bigwedge": "⋀",
	"bkarow": "⤍",
	"blacklozenge": "⧫",
	"blacksquare": "▪",
	"blacktriangle": "▴",
	"blacktriangledown": "▾",
	"blacktriangleleft": "◂",
	"blacktriangleright": "▸",
	"blank": "␣",
	"blk12": "▒",
	"blk14": "░",
	"blk34": "▓",
	"block": "█",
	"bne": "=⃥",
	"bnequiv": "≡⃥",
	"bNot": "⫭",
	"bnot": "⌐",
	"Bopf": "𝔹",
	"bopf": "𝕓",
	"bot": "⊥",
	"bottom": "⊥",
	"bowtie": "⋈",
	"boxbox": "⧉",
	"boxdl": "┐",
	"boxdL": "╕",
	"boxDl": "╖",
	"boxDL": "╗",
	"boxdr": "┌",
	"boxdR": "╒",
	"boxDr": "╓",
	"boxDR": "╔",
	"boxh": "─",
	"boxH": "═",
	"boxhd": "┬",
	"boxHd": "╤",
	"boxhD": "╥",
	"boxHD": "╦",
	"boxhu": "┴",
	"boxHu": "╧",
	"boxhU": "╨",
	"boxHU": "╩",
	"boxminus": "⊟",
	"boxplus": "⊞",
	"boxtimes": "⊠",
	"boxul": "┘",
	"boxuL": "╛",
	"boxUl": "╜",
	"boxUL": "╝",
	"boxur": "└",
	"boxuR": "╘",
	"boxUr": "╙",
	"boxUR": "╚",
	"boxv": "│",
	"boxV": "║",
	"boxvh": "┼",
	"boxvH": "╪",
	"boxVh": "╫",
	"boxVH": "╬",
	"boxvl": "┤",
	"boxvL": "╡",
	"boxVl": "╢",
	"boxVL": "╣",
	"boxvr": "├",
	"boxvR": "╞",
	"boxVr": "╟",
	"boxVR": "╠",
	"bprime": "‵",
	"breve": "˘",
	"Breve": "˘",
	"brvbar": "¦",
	"bscr": "𝒷",
	"Bscr": "ℬ",
	"bsemi": "⁏",
	"bsim": "∽",
	"bsime": "⋍",
	"bsolb": "⧅",
	"bsol": "\\",
	"bsolhsub": "⟈",
	"bull": "•",
	"bullet": "•",
	"bump": "≎",
	"bumpE": "⪮",
	"bumpe": "≏",
	"Bumpeq": "≎",
	"bumpeq": "≏",
	"Cacute": "Ć",
	"cacute": "ć",
	"capand": "⩄",
	"capbrcup": "⩉",
	"capcap": "⩋",
	"cap": "∩",
	"Cap": "⋒",
	"capcup": "⩇",
	"capdot": "⩀",
	"CapitalDifferentialD": "ⅅ",
	"caps": "∩︀",
	"caret": "⁁",
	"caron": "ˇ",
	"Cayleys": "ℭ",
	"ccaps": "⩍",
	"Ccaron": "Č",
	"ccaron": "č",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"Ccirc": "Ĉ",
	"ccirc": "ĉ",
	"Cconint": "∰",
	"ccups": "⩌",
	"ccupssm": "⩐",
	"Cdot": "Ċ",
	"cdot": "ċ",
	"cedil": "¸",
	"Cedilla": "¸",
	"cemptyv": "⦲",
	"cent": "¢",
	"centerdot": "·",
	"CenterDot": "·",
	"cfr": "𝔠",
	"Cfr": "ℭ",
	"CHcy": "Ч",
	"chcy": "ч",
	"check": "✓",
	"checkmark": "✓",
	"Chi": "Χ",
	"chi": "χ",
	"circ": "ˆ",
	"circeq": "≗",
	"circlearrowleft": "↺",
	"circlearrowright": "↻",
	"circledast": "⊛",
	"circledcirc": "⊚",
	"circleddash": "⊝",
	"CircleDot": "⊙",
	"circledR": "®",
	"circledS": "Ⓢ",
	"CircleMinus": "⊖",
	"CirclePlus": "⊕",
	"CircleTimes": "⊗",
	"cir": "○",
	"cirE": "⧃",
	"cire": "≗",
	"cirfnint": "⨐",
	"cirmid": "⫯",
	"cirscir": "⧂",
	"ClockwiseContourIntegral": "∲",
	"CloseCurlyDoubleQuote": "”",
	"CloseCurlyQuote": "’",
	"clubs": "♣",
	"clubsuit": "♣",
	"colon": ":",
	"Colon": "∷",
	"Colone": "⩴",
	"colone": "≔",
	"coloneq": "≔",
	"comma": ",",
	"commat": "@",
	"comp": "∁",
	"compfn": "∘",
	"complement": "∁",
	"complexes": "ℂ",
	"cong": "≅",
	"congdot": "⩭",
	"Congruent": "≡",
	"conint": "∮",
	"Conint": "∯",
	"ContourIntegral": "∮",
	"copf": "𝕔",
	"Copf": "ℂ",
	"coprod": "∐",
	"Coproduct": "∐",
	"copy": "©",
	"COPY": "©",
	"copysr": "℗",
	"CounterClockwiseContourIntegral": "∳",
	"crarr": "↵",
	"cross": "✗",
	"Cross": "⨯",
	"Cscr": "𝒞",
	"cscr": "𝒸",
	"csub": "⫏",
	"csube": "⫑",
	"csup": "⫐",
	"csupe": "⫒",
	"ctdot": "⋯",
	"cudarrl": "⤸",
	"cudarrr": "⤵",
	"cuepr": "⋞",
	"cuesc": "⋟",
	"cularr": "↶",
	"cularrp": "⤽",
	"cupbrcap": "⩈",
	"cupcap": "⩆",
	"CupCap": "≍",
	"cup": "∪",
	"Cup": "⋓",
	"cupcup": "⩊",
	"cupdot": "⊍",
	"cupor": "⩅",
	"cups": "∪︀",
	"curarr": "↷",
	"curarrm": "⤼",
	"curlyeqprec": "⋞",
	"curlyeqsucc": "⋟",
	"curlyvee": "⋎",
	"curlywedge": "⋏",
	"curren": "¤",
	"curvearrowleft": "↶",
	"curvearrowright": "↷",
	"cuvee": "⋎",
	"cuwed": "⋏",
	"cwconint": "∲",
	"cwint": "∱",
	"cylcty": "⌭",
	"dagger": "†",
	"Dagger": "‡",
	"daleth": "ℸ",
	"darr": "↓",
	"Darr": "↡",
	"dArr": "⇓",
	"dash": "‐",
	"Dashv": "⫤",
	"dashv": "⊣",
	"dbkarow": "⤏",
	"dblac": "˝",
	"Dcaron": "Ď",
	"dcaron": "ď",
	"Dcy": "Д",
	"dcy": "д",
	"ddagger": "‡",
	"ddarr": "⇊",
	"DD": "ⅅ",
	"dd": "ⅆ",
	"DDotrahd": "⤑",
	"ddotseq": "⩷",
	"deg": "°",
	"Del": "∇",
	"Delta": "Δ",
	"delta": "δ",
	"demptyv": "⦱",
	"dfisht": "⥿",
	"Dfr": "𝔇",
	"dfr": "𝔡",
	"dHar": "⥥",
	"dharl": "⇃",
	"dharr": "⇂",
	"DiacriticalAcute": "´",
	"DiacriticalDot": "˙",
	"DiacriticalDoubleAcute": "˝",
	"DiacriticalGrave": "`",
	"DiacriticalTilde": "˜",
	"diam": "⋄",
	"diamond": "⋄",
	"Diamond": "⋄",
	"diamondsuit": "♦",
	"diams": "♦",
	"die": "¨",
	"DifferentialD": "ⅆ",
	"digamma": "ϝ",
	"disin": "⋲",
	"div": "÷",
	"divide": "÷",
	"divideontimes": "⋇",
	"divonx": "⋇",
	"DJcy": "Ђ",
	"djcy": "ђ",
	"dlcorn": "⌞",
	"dlcrop": "⌍",
	"dollar": "$",
	"Dopf": "𝔻",
	"dopf": "𝕕",
	"Dot": "¨",
	"dot": "˙",
	"DotDot": "⃜",
	"doteq": "≐",
	"doteqdot": "≑",
	"DotEqual": "≐",
	"dotminus": "∸",
	"dotplus": "∔",
	"dotsquare": "⊡",
	"doublebarwedge": "⌆",
	"DoubleContourIntegral": "∯",
	"DoubleDot": "¨",
	"DoubleDownArrow": "⇓",
	"DoubleLeftArrow": "⇐",
	"DoubleLeftRightArrow": "⇔",
	"DoubleLeftTee": "⫤",
	"DoubleLongLeftArrow": "⟸",
	"DoubleLongLeftRightArrow": "⟺",
	"DoubleLongRightArrow": "⟹",
	"DoubleRightArrow": "⇒",
	"DoubleRightTee": "⊨",
	"DoubleUpArrow": "⇑",
	"DoubleUpDownArrow": "⇕",
	"DoubleVerticalBar": "∥",
	"DownArrowBar": "⤓",
	"downarrow": "↓",
	"DownArrow": "↓",
	"Downarrow": "⇓",
	"DownArrowUpArrow": "⇵",
	"DownBreve": "̑",
	"downdownarrows": "⇊",
	"downharpoonleft": "⇃",
	"downharpoonright": "⇂",
	"DownLeftRightVector": "⥐",
	"DownLeftTeeVector": "⥞",
	"DownLeftVectorBar": "⥖",
	"DownLeftVector": "↽",
	"DownRightTeeVector": "⥟",
	"DownRightVectorBar": "⥗",
	"DownRightVector": "⇁",
	"DownTeeArrow": "↧",
	"DownTee": "⊤",
	"drbkarow": "⤐",
	"drcorn": "⌟",
	"drcrop": "⌌",
	"Dscr": "𝒟",
	"dscr": "𝒹",
	"DScy": "Ѕ",
	"dscy": "ѕ",
	"dsol": "⧶",
	"Dstrok": "Đ",
	"dstrok": "đ",
	"dtdot": "⋱",
	"dtri": "▿",
	"dtrif": "▾",
	"duarr": "⇵",
	"duhar": "⥯",
	"dwangle": "⦦",
	"DZcy": "Џ",
	"dzcy": "џ",
	"dzigrarr": "⟿",
	"Eacute": "É",
	"eacute": "é",
	"easter": "⩮",
	"Ecaron": "Ě",
	"ecaron": "ě",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"ecir": "≖",
	"ecolon": "≕",
	"Ecy": "Э",
	"ecy": "э",
	"eDDot": "⩷",
	"Edot": "Ė",
	"edot": "ė",
	"eDot": "≑",
	"ee": "ⅇ",
	"efDot": "≒",
	"Efr": "𝔈",
	"efr": "𝔢",
	"eg": "⪚",
	"Egrave": "È",
	"egrave": "è",
	"egs": "⪖",
	"egsdot": "⪘",
	"el": "⪙",
	"Element": "∈",
	"elinters": "⏧",
	"ell": "ℓ",
	"els": "⪕",
	"elsdot": "⪗",
	"Emacr": "Ē",
	"emacr": "ē",
	"empty": "∅",
	"emptyset": "∅",
	"EmptySmallSquare": "◻",
	"emptyv": "∅",
	"EmptyVerySmallSquare": "▫",
	"emsp13": " ",
	"emsp14": " ",
	"emsp": " ",
	"ENG": "Ŋ",
	"eng": "ŋ",
	"ensp": " ",
	"Eogon": "Ę",
	"eogon": "ę",
	"Eopf": "𝔼",
	"eopf": "𝕖",
	"epar": "⋕",
	"eparsl": "⧣",
	"eplus": "⩱",
	"epsi": "ε",
	"Epsilon": "Ε",
	"epsilon": "ε",
	"epsiv": "ϵ",
	"eqcirc": "≖",
	"eqcolon": "≕",
	"eqsim": "≂",
	"eqslantgtr": "⪖",
	"eqslantless": "⪕",
	"Equal": "⩵",
	"equals": "=",
	"EqualTilde": "≂",
	"equest": "≟",
	"Equilibrium": "⇌",
	"equiv": "≡",
	"equivDD": "⩸",
	"eqvparsl": "⧥",
	"erarr": "⥱",
	"erDot": "≓",
	"escr": "ℯ",
	"Escr": "ℰ",
	"esdot": "≐",
	"Esim": "⩳",
	"esim": "≂",
	"Eta": "Η",
	"eta": "η",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"euro": "€",
	"excl": "!",
	"exist": "∃",
	"Exists": "∃",
	"expectation": "ℰ",
	"exponentiale": "ⅇ",
	"ExponentialE": "ⅇ",
	"fallingdotseq": "≒",
	"Fcy": "Ф",
	"fcy": "ф",
	"female": "♀",
	"ffilig": "ﬃ",
	"fflig": "ﬀ",
	"ffllig": "ﬄ",
	"Ffr": "𝔉",
	"ffr": "𝔣",
	"filig": "ﬁ",
	"FilledSmallSquare": "◼",
	"FilledVerySmallSquare": "▪",
	"fjlig": "fj",
	"flat": "♭",
	"fllig": "ﬂ",
	"fltns": "▱",
	"fnof": "ƒ",
	"Fopf": "𝔽",
	"fopf": "𝕗",
	"forall": "∀",
	"ForAll": "∀",
	"fork": "⋔",
	"forkv": "⫙",
	"Fouriertrf": "ℱ",
	"fpartint": "⨍",
	"frac12": "½",
	"frac13": "⅓",
	"frac14": "¼",
	"frac15": "⅕",
	"frac16": "⅙",
	"frac18": "⅛",
	"frac23": "⅔",
	"frac25": "⅖",
	"frac34": "¾",
	"frac35": "⅗",
	"frac38": "⅜",
	"frac45": "⅘",
	"frac56": "⅚",
	"frac58": "⅝",
	"frac78": "⅞",
	"frasl": "⁄",
	"frown": "⌢",
	"fscr": "𝒻",
	"Fscr": "ℱ",
	"gacute": "ǵ",
	"Gamma": "Γ",
	"gamma": "γ",
	"Gammad": "Ϝ",
	"gammad": "ϝ",
	"gap": "⪆",
	"Gbreve": "Ğ",
	"gbreve": "ğ",
	"Gcedil": "Ģ",
	"Gcirc": "Ĝ",
	"gcirc": "ĝ",
	"Gcy": "Г",
	"gcy": "г",
	"Gdot": "Ġ",
	"gdot": "ġ",
	"ge": "≥",
	"gE": "≧",
	"gEl": "⪌",
	"gel": "⋛",
	"geq": "≥",
	"geqq": "≧",
	"geqslant": "⩾",
	"gescc": "⪩",
	"ges": "⩾",
	"gesdot": "⪀",
	"gesdoto": "⪂",
	"gesdotol": "⪄",
	"gesl": "⋛︀",
	"gesles": "⪔",
	"Gfr": "𝔊",
	"gfr": "𝔤",
	"gg": "≫",
	"Gg": "⋙",
	"ggg": "⋙",
	"gimel": "ℷ",
	"GJcy": "Ѓ",
	"gjcy": "ѓ",
	"gla": "⪥",
	"gl": "≷",
	"glE": "⪒",
	"glj": "⪤",
	"gnap": "⪊",
	"gnapprox": "⪊",
	"gne": "⪈",
	"gnE": "≩",
	"gneq": "⪈",
	"gneqq": "≩",
	"gnsim": "⋧",
	"Gopf": "𝔾",
	"gopf": "𝕘",
	"grave": "`",
	"GreaterEqual": "≥",
	"GreaterEqualLess": "⋛",
	"GreaterFullEqual": "≧",
	"GreaterGreater": "⪢",
	"GreaterLess": "≷",
	"GreaterSlantEqual": "⩾",
	"GreaterTilde": "≳",
	"Gscr": "𝒢",
	"gscr": "ℊ",
	"gsim": "≳",
	"gsime": "⪎",
	"gsiml": "⪐",
	"gtcc": "⪧",
	"gtcir": "⩺",
	"gt": ">",
	"GT": ">",
	"Gt": "≫",
	"gtdot": "⋗",
	"gtlPar": "⦕",
	"gtquest": "⩼",
	"gtrapprox": "⪆",
	"gtrarr": "⥸",
	"gtrdot": "⋗",
	"gtreqless": "⋛",
	"gtreqqless": "⪌",
	"gtrless": "≷",
	"gtrsim": "≳",
	"gvertneqq": "≩︀",
	"gvnE": "≩︀",
	"Hacek": "ˇ",
	"hairsp": " ",
	"half": "½",
	"hamilt": "ℋ",
	"HARDcy": "Ъ",
	"hardcy": "ъ",
	"harrcir": "⥈",
	"harr": "↔",
	"hArr": "⇔",
	"harrw": "↭",
	"Hat": "^",
	"hbar": "ℏ",
	"Hcirc": "Ĥ",
	"hcirc": "ĥ",
	"hearts": "♥",
	"heartsuit": "♥",
	"hellip": "…",
	"hercon": "⊹",
	"hfr": "𝔥",
	"Hfr": "ℌ",
	"HilbertSpace": "ℋ",
	"hksearow": "⤥",
	"hkswarow": "⤦",
	"hoarr": "⇿",
	"homtht": "∻",
	"hookleftarrow": "↩",
	"hookrightarrow": "↪",
	"hopf": "𝕙",
	"Hopf": "ℍ",
	"horbar": "―",
	"HorizontalLine": "─",
	"hscr": "𝒽",
	"Hscr": "ℋ",
	"hslash": "ℏ",
	"Hstrok": "Ħ",
	"hstrok": "ħ",
	"HumpDownHump": "≎",
	"HumpEqual": "≏",
	"hybull": "⁃",
	"hyphen": "‐",
	"Iacute": "Í",
	"iacute": "í",
	"ic": "⁣",
	"Icirc": "Î",
	"icirc": "î",
	"Icy": "И",
	"icy": "и",
	"Idot": "İ",
	"IEcy": "Е",
	"iecy": "е",
	"iexcl": "¡",
	"iff": "⇔",
	"ifr": "𝔦",
	"Ifr": "ℑ",
	"Igrave": "Ì",
	"igrave": "ì",
	"ii": "ⅈ",
	"iiiint": "⨌",
	"iiint": "∭",
	"iinfin": "⧜",
	"iiota": "℩",
	"IJlig": "Ĳ",
	"ijlig": "ĳ",
	"Imacr": "Ī",
	"imacr": "ī",
	"image": "ℑ",
	"ImaginaryI": "ⅈ",
	"imagline": "ℐ",
	"imagpart": "ℑ",
	"imath": "ı",
	"Im": "ℑ",
	"imof": "⊷",
	"imped": "Ƶ",
	"Implies": "⇒",
	"incare": "℅",
	"in": "∈",
	"infin": "∞",
	"infintie": "⧝",
	"inodot": "ı",
	"intcal": "⊺",
	"int": "∫",
	"Int": "∬",
	"integers": "ℤ",
	"Integral": "∫",
	"intercal": "⊺",
	"Intersection": "⋂",
	"intlarhk": "⨗",
	"intprod": "⨼",
	"InvisibleComma": "⁣",
	"InvisibleTimes": "⁢",
	"IOcy": "Ё",
	"iocy": "ё",
	"Iogon": "Į",
	"iogon": "į",
	"Iopf": "𝕀",
	"iopf": "𝕚",
	"Iota": "Ι",
	"iota": "ι",
	"iprod": "⨼",
	"iquest": "¿",
	"iscr": "𝒾",
	"Iscr": "ℐ",
	"isin": "∈",
	"isindot": "⋵",
	"isinE": "⋹",
	"isins": "⋴",
	"isinsv": "⋳",
	"isinv": "∈",
	"it": "⁢",
	"Itilde": "Ĩ",
	"itilde": "ĩ",
	"Iukcy": "І",
	"iukcy": "і",
	"Iuml": "Ï",
	"iuml": "ï",
	"Jcirc": "Ĵ",
	"jcirc": "ĵ",
	"Jcy": "Й",
	"jcy": "й",
	"Jfr": "𝔍",
	"jfr": "𝔧",
	"jmath": "ȷ",
	"Jopf": "𝕁",
	"jopf": "𝕛",
	"Jscr": "𝒥",
	"jscr": "𝒿",
	"Jsercy": "Ј",
	"jsercy": "ј",
	"Jukcy": "Є",
	"jukcy": "є",
	"Kappa": "Κ",
	"kappa": "κ",
	"kappav": "ϰ",
	"Kcedil": "Ķ",
	"kcedil": "ķ",
	"Kcy": "К",
	"kcy": "к",
	"Kfr": "𝔎",
	"kfr": "𝔨",
	"kgreen": "ĸ",
	"KHcy": "Х",
	"khcy": "х",
	"KJcy": "Ќ",
	"kjcy": "ќ",
	"Kopf": "𝕂",
	"kopf": "𝕜",
	"Kscr": "𝒦",
	"kscr": "𝓀",
	"lAarr": "⇚",
	"Lacute": "Ĺ",
	"lacute": "ĺ",
	"laemptyv": "⦴",
	"lagran": "ℒ",
	"Lambda": "Λ",
	"lambda": "λ",
	"lang": "⟨",
	"Lang": "⟪",
	"langd": "⦑",
	"langle": "⟨",
	"lap": "⪅",
	"Laplacetrf": "ℒ",
	"laquo": "«",
	"larrb": "⇤",
	"larrbfs": "⤟",
	"larr": "←",
	"Larr": "↞",
	"lArr": "⇐",
	"larrfs": "⤝",
	"larrhk": "↩",
	"larrlp": "↫",
	"larrpl": "⤹",
	"larrsim": "⥳",
	"larrtl": "↢",
	"latail": "⤙",
	"lAtail": "⤛",
	"lat": "⪫",
	"late": "⪭",
	"lates": "⪭︀",
	"lbarr": "⤌",
	"lBarr": "⤎",
	"lbbrk": "❲",
	"lbrace": "{",
	"lbrack": "[",
	"lbrke": "⦋",
	"lbrksld": "⦏",
	"lbrkslu": "⦍",
	"Lcaron": "Ľ",
	"lcaron": "ľ",
	"Lcedil": "Ļ",
	"lcedil": "ļ",
	"lceil": "⌈",
	"lcub": "{",
	"Lcy": "Л",
	"lcy": "л",
	"ldca": "⤶",
	"ldquo": "“",
	"ldquor": "„",
	"ldrdhar": "⥧",
	"ldrushar": "⥋",
	"ldsh": "↲",
	"le": "≤",
	"lE": "≦",
	"LeftAngleBracket": "⟨",
	"LeftArrowBar": "⇤",
	"leftarrow": "←",
	"LeftArrow": "←",
	"Leftarrow": "⇐",
	"LeftArrowRightArrow": "⇆",
	"leftarrowtail": "↢",
	"LeftCeiling": "⌈",
	"LeftDoubleBracket": "⟦",
	"LeftDownTeeVector": "⥡",
	"LeftDownVectorBar": "⥙",
	"LeftDownVector": "⇃",
	"LeftFloor": "⌊",
	"leftharpoondown": "↽",
	"leftharpoonup": "↼",
	"leftleftarrows": "⇇",
	"leftrightarrow": "↔",
	"LeftRightArrow": "↔",
	"Leftrightarrow": "⇔",
	"leftrightarrows": "⇆",
	"leftrightharpoons": "⇋",
	"leftrightsquigarrow": "↭",
	"LeftRightVector": "⥎",
	"LeftTeeArrow": "↤",
	"LeftTee": "⊣",
	"LeftTeeVector": "⥚",
	"leftthreetimes": "⋋",
	"LeftTriangleBar": "⧏",
	"LeftTriangle": "⊲",
	"LeftTriangleEqual": "⊴",
	"LeftUpDownVector": "⥑",
	"LeftUpTeeVector": "⥠",
	"LeftUpVectorBar": "⥘",
	"LeftUpVector": "↿",
	"LeftVectorBar": "⥒",
	"LeftVector": "↼",
	"lEg": "⪋",
	"leg": "⋚",
	"leq": "≤",
	"leqq": "≦",
	"leqslant": "⩽",
	"lescc": "⪨",
	"les": "⩽",
	"lesdot": "⩿",
	"lesdoto": "⪁",
	"lesdotor": "⪃",
	"lesg": "⋚︀",
	"lesges": "⪓",
	"lessapprox": "⪅",
	"lessdot": "⋖",
	"lesseqgtr": "⋚",
	"lesseqqgtr": "⪋",
	"LessEqualGreater": "⋚",
	"LessFullEqual": "≦",
	"LessGreater": "≶",
	"lessgtr": "≶",
	"LessLess": "⪡",
	"lesssim": "≲",
	"LessSlantEqual": "⩽",
	"LessTilde": "≲",
	"lfisht": "⥼",
	"lfloor": "⌊",
	"Lfr": "𝔏",
	"lfr": "𝔩",
	"lg": "≶",
	"lgE": "⪑",
	"lHar": "⥢",
	"lhard": "↽",
	"lharu": "↼",
	"lharul": "⥪",
	"lhblk": "▄",
	"LJcy": "Љ",
	"ljcy": "љ",
	"llarr": "⇇",
	"ll": "≪",
	"Ll": "⋘",
	"llcorner": "⌞",
	"Lleftarrow": "⇚",
	"llhard": "⥫",
	"lltri": "◺",
	"Lmidot": "Ŀ",
	"lmidot": "ŀ",
	"lmoustache": "⎰",
	"lmoust": "⎰",
	"lnap": "⪉",
	"lnapprox": "⪉",
	"lne": "⪇",
	"lnE": "≨",
	"lneq": "⪇",
	"lneqq": "≨",
	"lnsim": "⋦",
	"loang": "⟬",
	"loarr": "⇽",
	"lobrk": "⟦",
	"longleftarrow": "⟵",
	"LongLeftArrow": "⟵",
	"Longleftarrow": "⟸",
	"longleftrightarrow": "⟷",
	"LongLeftRightArrow": "⟷",
	"Longleftrightarrow": "⟺",
	"longmapsto": "⟼",
	"longrightarrow": "⟶",
	"LongRightArrow": "⟶",
	"Longrightarrow": "⟹",
	"looparrowleft": "↫",
	"looparrowright": "↬",
	"lopar": "⦅",
	"Lopf": "𝕃",
	"lopf": "𝕝",
	"loplus": "⨭",
	"lotimes": "⨴",
	"lowast": "∗",
	"lowbar": "_",
	"LowerLeftArrow": "↙",
	"LowerRightArrow": "↘",
	"loz": "◊",
	"lozenge": "◊",
	"lozf": "⧫",
	"lpar": "(",
	"lparlt": "⦓",
	"lrarr": "⇆",
	"lrcorner": "⌟",
	"lrhar": "⇋",
	"lrhard": "⥭",
	"lrm": "‎",
	"lrtri": "⊿",
	"lsaquo": "‹",
	"lscr": "𝓁",
	"Lscr": "ℒ",
	"lsh": "↰",
	"Lsh": "↰",
	"lsim": "≲",
	"lsime": "⪍",
	"lsimg": "⪏",
	"lsqb": "[",
	"lsquo": "‘",
	"lsquor": "‚",
	"Lstrok": "Ł",
	"lstrok": "ł",
	"ltcc": "⪦",
	"ltcir": "⩹",
	"lt": "<",
	"LT": "<",
	"Lt": "≪",
	"ltdot": "⋖",
	"lthree": "⋋",
	"ltimes": "⋉",
	"ltlarr": "⥶",
	"ltquest": "⩻",
	"ltri": "◃",
	"ltrie": "⊴",
	"ltrif": "◂",
	"ltrPar": "⦖",
	"lurdshar": "⥊",
	"luruhar": "⥦",
	"lvertneqq": "≨︀",
	"lvnE": "≨︀",
	"macr": "¯",
	"male": "♂",
	"malt": "✠",
	"maltese": "✠",
	"Map": "⤅",
	"map": "↦",
	"mapsto": "↦",
	"mapstodown": "↧",
	"mapstoleft": "↤",
	"mapstoup": "↥",
	"marker": "▮",
	"mcomma": "⨩",
	"Mcy": "М",
	"mcy": "м",
	"mdash": "—",
	"mDDot": "∺",
	"measuredangle": "∡",
	"MediumSpace": " ",
	"Mellintrf": "ℳ",
	"Mfr": "𝔐",
	"mfr": "𝔪",
	"mho": "℧",
	"micro": "µ",
	"midast": "*",
	"midcir": "⫰",
	"mid": "∣",
	"middot": "·",
	"minusb": "⊟",
	"minus": "−",
	"minusd": "∸",
	"minusdu": "⨪",
	"MinusPlus": "∓",
	"mlcp": "⫛",
	"mldr": "…",
	"mnplus": "∓",
	"models": "⊧",
	"Mopf": "𝕄",
	"mopf": "𝕞",
	"mp": "∓",
	"mscr": "𝓂",
	"Mscr": "ℳ",
	"mstpos": "∾",
	"Mu": "Μ",
	"mu": "μ",
	"multimap": "⊸",
	"mumap": "⊸",
	"nabla": "∇",
	"Nacute": "Ń",
	"nacute": "ń",
	"nang": "∠⃒",
	"nap": "≉",
	"napE": "⩰̸",
	"napid": "≋̸",
	"napos": "ŉ",
	"napprox": "≉",
	"natural": "♮",
	"naturals": "ℕ",
	"natur": "♮",
	"nbsp": " ",
	"nbump": "≎̸",
	"nbumpe": "≏̸",
	"ncap": "⩃",
	"Ncaron": "Ň",
	"ncaron": "ň",
	"Ncedil": "Ņ",
	"ncedil": "ņ",
	"ncong": "≇",
	"ncongdot": "⩭̸",
	"ncup": "⩂",
	"Ncy": "Н",
	"ncy": "н",
	"ndash": "–",
	"nearhk": "⤤",
	"nearr": "↗",
	"neArr": "⇗",
	"nearrow": "↗",
	"ne": "≠",
	"nedot": "≐̸",
	"NegativeMediumSpace": "​",
	"NegativeThickSpace": "​",
	"NegativeThinSpace": "​",
	"NegativeVeryThinSpace": "​",
	"nequiv": "≢",
	"nesear": "⤨",
	"nesim": "≂̸",
	"NestedGreaterGreater": "≫",
	"NestedLessLess": "≪",
	"NewLine": "\n",
	"nexist": "∄",
	"nexists": "∄",
	"Nfr": "𝔑",
	"nfr": "𝔫",
	"ngE": "≧̸",
	"nge": "≱",
	"ngeq": "≱",
	"ngeqq": "≧̸",
	"ngeqslant": "⩾̸",
	"nges": "⩾̸",
	"nGg": "⋙̸",
	"ngsim": "≵",
	"nGt": "≫⃒",
	"ngt": "≯",
	"ngtr": "≯",
	"nGtv": "≫̸",
	"nharr": "↮",
	"nhArr": "⇎",
	"nhpar": "⫲",
	"ni": "∋",
	"nis": "⋼",
	"nisd": "⋺",
	"niv": "∋",
	"NJcy": "Њ",
	"njcy": "њ",
	"nlarr": "↚",
	"nlArr": "⇍",
	"nldr": "‥",
	"nlE": "≦̸",
	"nle": "≰",
	"nleftarrow": "↚",
	"nLeftarrow": "⇍",
	"nleftrightarrow": "↮",
	"nLeftrightarrow": "⇎",
	"nleq": "≰",
	"nleqq": "≦̸",
	"nleqslant": "⩽̸",
	"nles": "⩽̸",
	"nless": "≮",
	"nLl": "⋘̸",
	"nlsim": "≴",
	"nLt": "≪⃒",
	"nlt": "≮",
	"nltri": "⋪",
	"nltrie": "⋬",
	"nLtv": "≪̸",
	"nmid": "∤",
	"NoBreak": "⁠",
	"NonBreakingSpace": " ",
	"nopf": "𝕟",
	"Nopf": "ℕ",
	"Not": "⫬",
	"not": "¬",
	"NotCongruent": "≢",
	"NotCupCap": "≭",
	"NotDoubleVerticalBar": "∦",
	"NotElement": "∉",
	"NotEqual": "≠",
	"NotEqualTilde": "≂̸",
	"NotExists": "∄",
	"NotGreater": "≯",
	"NotGreaterEqual": "≱",
	"NotGreaterFullEqual": "≧̸",
	"NotGreaterGreater": "≫̸",
	"NotGreaterLess": "≹",
	"NotGreaterSlantEqual": "⩾̸",
	"NotGreaterTilde": "≵",
	"NotHumpDownHump": "≎̸",
	"NotHumpEqual": "≏̸",
	"notin": "∉",
	"notindot": "⋵̸",
	"notinE": "⋹̸",
	"notinva": "∉",
	"notinvb": "⋷",
	"notinvc": "⋶",
	"NotLeftTriangleBar": "⧏̸",
	"NotLeftTriangle": "⋪",
	"NotLeftTriangleEqual": "⋬",
	"NotLess": "≮",
	"NotLessEqual": "≰",
	"NotLessGreater": "≸",
	"NotLessLess": "≪̸",
	"NotLessSlantEqual": "⩽̸",
	"NotLessTilde": "≴",
	"NotNestedGreaterGreater": "⪢̸",
	"NotNestedLessLess": "⪡̸",
	"notni": "∌",
	"notniva": "∌",
	"notnivb": "⋾",
	"notnivc": "⋽",
	"NotPrecedes": "⊀",
	"NotPrecedesEqual": "⪯̸",
	"NotPrecedesSlantEqual": "⋠",
	"NotReverseElement": "∌",
	"NotRightTriangleBar": "⧐̸",
	"NotRightTriangle": "⋫",
	"NotRightTriangleEqual": "⋭",
	"NotSquareSubset": "⊏̸",
	"NotSquareSubsetEqual": "⋢",
	"NotSquareSuperset": "⊐̸",
	"NotSquareSupersetEqual": "⋣",
	"NotSubset": "⊂⃒",
	"NotSubsetEqual": "⊈",
	"NotSucceeds": "⊁",
	"NotSucceedsEqual": "⪰̸",
	"NotSucceedsSlantEqual": "⋡",
	"NotSucceedsTilde": "≿̸",
	"NotSuperset": "⊃⃒",
	"NotSupersetEqual": "⊉",
	"NotTilde": "≁",
	"NotTildeEqual": "≄",
	"NotTildeFullEqual": "≇",
	"NotTildeTilde": "≉",
	"NotVerticalBar": "∤",
	"nparallel": "∦",
	"npar": "∦",
	"nparsl": "⫽⃥",
	"npart": "∂̸",
	"npolint": "⨔",
	"npr": "⊀",
	"nprcue": "⋠",
	"nprec": "⊀",
	"npreceq": "⪯̸",
	"npre": "⪯̸",
	"nrarrc": "⤳̸",
	"nrarr": "↛",
	"nrArr": "⇏",
	"nrarrw": "↝̸",
	"nrightarrow": "↛",
	"nRightarrow": "⇏",
	"nrtri": "⋫",
	"nrtrie": "⋭",
	"nsc": "⊁",
	"nsccue": "⋡",
	"nsce": "⪰̸",
	"Nscr": "𝒩",
	"nscr": "𝓃",
	"nshortmid": "∤",
	"nshortparallel": "∦",
	"nsim": "≁",
	"nsime": "≄",
	"nsimeq": "≄",
	"nsmid": "∤",
	"nspar": "∦",
	"nsqsube": "⋢",
	"nsqsupe": "⋣",
	"nsub": "⊄",
	"nsubE": "⫅̸",
	"nsube": "⊈",
	"nsubset": "⊂⃒",
	"nsubseteq": "⊈",
	"nsubseteqq": "⫅̸",
	"nsucc": "⊁",
	"nsucceq": "⪰̸",
	"nsup": "⊅",
	"nsupE": "⫆̸",
	"nsupe": "⊉",
	"nsupset": "⊃⃒",
	"nsupseteq": "⊉",
	"nsupseteqq": "⫆̸",
	"ntgl": "≹",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"ntlg": "≸",
	"ntriangleleft": "⋪",
	"ntrianglelefteq": "⋬",
	"ntriangleright": "⋫",
	"ntrianglerighteq": "⋭",
	"Nu": "Ν",
	"nu": "ν",
	"num": "#",
	"numero": "№",
	"numsp": " ",
	"nvap": "≍⃒",
	"nvdash": "⊬",
	"nvDash": "⊭",
	"nVdash": "⊮",
	"nVDash": "⊯",
	"nvge": "≥⃒",
	"nvgt": ">⃒",
	"nvHarr": "⤄",
	"nvinfin": "⧞",
	"nvlArr": "⤂",
	"nvle": "≤⃒",
	"nvlt": "<⃒",
	"nvltrie": "⊴⃒",
	"nvrArr": "⤃",
	"nvrtrie": "⊵⃒",
	"nvsim": "∼⃒",
	"nwarhk": "⤣",
	"nwarr": "↖",
	"nwArr": "⇖",
	"nwarrow": "↖",
	"nwnear": "⤧",
	"Oacute": "Ó",
	"oacute": "ó",
	"oast": "⊛",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"ocir": "⊚",
	"Ocy": "О",
	"ocy": "о",
	"odash": "⊝",
	"Odblac": "Ő",
	"odblac": "ő",
	"odiv": "⨸",
	"odot": "⊙",
	"odsold": "⦼",
	"OElig": "Œ",
	"oelig": "œ",
	"ofcir": "⦿",
	"Ofr": "𝔒",
	"ofr": "𝔬",
	"ogon": "˛",
	"Ograve": "Ò",
	"ograve": "ò",
	"ogt": "⧁",
	"ohbar": "⦵",
	"ohm": "Ω",
	"oint": "∮",
	"olarr": "↺",
	"olcir": "⦾",
	"olcross": "⦻",
	"oline": "‾",
	"olt": "⧀",
	"Omacr": "Ō",
	"omacr": "ō",
	"Omega": "Ω",
	"omega": "ω",
	"Omicron": "Ο",
	"omicron": "ο",
	"omid": "⦶",
	"ominus": "⊖",
	"Oopf": "𝕆",
	"oopf": "𝕠",
	"opar": "⦷",
	"OpenCurlyDoubleQuote": "“",
	"OpenCurlyQuote": "‘",
	"operp": "⦹",
	"oplus": "⊕",
	"orarr": "↻",
	"Or": "⩔",
	"or": "∨",
	"ord": "⩝",
	"order": "ℴ",
	"orderof": "ℴ",
	"ordf": "ª",
	"ordm": "º",
	"origof": "⊶",
	"oror": "⩖",
	"orslope": "⩗",
	"orv": "⩛",
	"oS": "Ⓢ",
	"Oscr": "𝒪",
	"oscr": "ℴ",
	"Oslash": "Ø",
	"oslash": "ø",
	"osol": "⊘",
	"Otilde": "Õ",
	"otilde": "õ",
	"otimesas": "⨶",
	"Otimes": "⨷",
	"otimes": "⊗",
	"Ouml": "Ö",
	"ouml": "ö",
	"ovbar": "⌽",
	"OverBar": "‾",
	"OverBrace": "⏞",
	"OverBracket": "⎴",
	"OverParenthesis": "⏜",
	"para": "¶",
	"parallel": "∥",
	"par": "∥",
	"parsim": "⫳",
	"parsl": "⫽",
	"part": "∂",
	"PartialD": "∂",
	"Pcy": "П",
	"pcy": "п",
	"percnt": "%",
	"period": ".",
	"permil": "‰",
	"perp": "⊥",
	"pertenk": "‱",
	"Pfr": "𝔓",
	"pfr": "𝔭",
	"Phi": "Φ",
	"phi": "φ",
	"phiv": "ϕ",
	"phmmat": "ℳ",
	"phone": "☎",
	"Pi": "Π",
	"pi": "π",
	"pitchfork": "⋔",
	"piv": "ϖ",
	"planck": "ℏ",
	"planckh": "ℎ",
	"plankv": "ℏ",
	"plusacir": "⨣",
	"plusb": "⊞",
	"pluscir": "⨢",
	"plus": "+",
	"plusdo": "∔",
	"plusdu": "⨥",
	"pluse": "⩲",
	"PlusMinus": "±",
	"plusmn": "±",
	"plussim": "⨦",
	"plustwo": "⨧",
	"pm": "±",
	"Poincareplane": "ℌ",
	"pointint": "⨕",
	"popf": "𝕡",
	"Popf": "ℙ",
	"pound": "£",
	"prap": "⪷",
	"Pr": "⪻",
	"pr": "≺",
	"prcue": "≼",
	"precapprox": "⪷",
	"prec": "≺",
	"preccurlyeq": "≼",
	"Precedes": "≺",
	"PrecedesEqual": "⪯",
	"PrecedesSlantEqual": "≼",
	"PrecedesTilde": "≾",
	"preceq": "⪯",
	"precnapprox": "⪹",
	"precneqq": "⪵",
	"precnsim": "⋨",
	"pre": "⪯",
	"prE": "⪳",
	"precsim": "≾",
	"prime": "′",
	"Prime": "″",
	"primes": "ℙ",
	"prnap": "⪹",
	"prnE": "⪵",
	"prnsim": "⋨",
	"prod": "∏",
	"Product": "∏",
	"profalar": "⌮",
	"profline": "⌒",
	"profsurf": "⌓",
	"prop": "∝",
	"Proportional": "∝",
	"Proportion": "∷",
	"propto": "∝",
	"prsim": "≾",
	"prurel": "⊰",
	"Pscr": "𝒫",
	"pscr": "𝓅",
	"Psi": "Ψ",
	"psi": "ψ",
	"puncsp": " ",
	"Qfr": "𝔔",
	"qfr": "𝔮",
	"qint": "⨌",
	"qopf": "𝕢",
	"Qopf": "ℚ",
	"qprime": "⁗",
	"Qscr": "𝒬",
	"qscr": "𝓆",
	"quaternions": "ℍ",
	"quatint": "⨖",
	"quest": "?",
	"questeq": "≟",
	"quot": "\"",
	"QUOT": "\"",
	"rAarr": "⇛",
	"race": "∽̱",
	"Racute": "Ŕ",
	"racute": "ŕ",
	"radic": "√",
	"raemptyv": "⦳",
	"rang": "⟩",
	"Rang": "⟫",
	"rangd": "⦒",
	"range": "⦥",
	"rangle": "⟩",
	"raquo": "»",
	"rarrap": "⥵",
	"rarrb": "⇥",
	"rarrbfs": "⤠",
	"rarrc": "⤳",
	"rarr": "→",
	"Rarr": "↠",
	"rArr": "⇒",
	"rarrfs": "⤞",
	"rarrhk": "↪",
	"rarrlp": "↬",
	"rarrpl": "⥅",
	"rarrsim": "⥴",
	"Rarrtl": "⤖",
	"rarrtl": "↣",
	"rarrw": "↝",
	"ratail": "⤚",
	"rAtail": "⤜",
	"ratio": "∶",
	"rationals": "ℚ",
	"rbarr": "⤍",
	"rBarr": "⤏",
	"RBarr": "⤐",
	"rbbrk": "❳",
	"rbrace": "}",
	"rbrack": "]",
	"rbrke": "⦌",
	"rbrksld": "⦎",
	"rbrkslu": "⦐",
	"Rcaron": "Ř",
	"rcaron": "ř",
	"Rcedil": "Ŗ",
	"rcedil": "ŗ",
	"rceil": "⌉",
	"rcub": "}",
	"Rcy": "Р",
	"rcy": "р",
	"rdca": "⤷",
	"rdldhar": "⥩",
	"rdquo": "”",
	"rdquor": "”",
	"rdsh": "↳",
	"real": "ℜ",
	"realine": "ℛ",
	"realpart": "ℜ",
	"reals": "ℝ",
	"Re": "ℜ",
	"rect": "▭",
	"reg": "®",
	"REG": "®",
	"ReverseElement": "∋",
	"ReverseEquilibrium": "⇋",
	"ReverseUpEquilibrium": "⥯",
	"rfisht": "⥽",
	"rfloor": "⌋",
	"rfr": "𝔯",
	"Rfr": "ℜ",
	"rHar": "⥤",
	"rhard": "⇁",
	"rharu": "⇀",
	"rharul": "⥬",
	"Rho": "Ρ",
	"rho": "ρ",
	"rhov": "ϱ",
	"RightAngleBracket": "⟩",
	"RightArrowBar": "⇥",
	"rightarrow": "→",
	"RightArrow": "→",
	"Rightarrow": "⇒",
	"RightArrowLeftArrow": "⇄",
	"rightarrowtail": "↣",
	"RightCeiling": "⌉",
	"RightDoubleBracket": "⟧",
	"RightDownTeeVector": "⥝",
	"RightDownVectorBar": "⥕",
	"RightDownVector": "⇂",
	"RightFloor": "⌋",
	"rightharpoondown": "⇁",
	"rightharpoonup": "⇀",
	"rightleftarrows": "⇄",
	"rightleftharpoons": "⇌",
	"rightrightarrows": "⇉",
	"rightsquigarrow": "↝",
	"RightTeeArrow": "↦",
	"RightTee": "⊢",
	"RightTeeVector": "⥛",
	"rightthreetimes": "⋌",
	"RightTriangleBar": "⧐",
	"RightTriangle": "⊳",
	"RightTriangleEqual": "⊵",
	"RightUpDownVector": "⥏",
	"RightUpTeeVector": "⥜",
	"RightUpVectorBar": "⥔",
	"RightUpVector": "↾",
	"RightVectorBar": "⥓",
	"RightVector": "⇀",
	"ring": "˚",
	"risingdotseq": "≓",
	"rlarr": "⇄",
	"rlhar": "⇌",
	"rlm": "‏",
	"rmoustache": "⎱",
	"rmoust": "⎱",
	"rnmid": "⫮",
	"roang": "⟭",
	"roarr": "⇾",
	"robrk": "⟧",
	"ropar": "⦆",
	"ropf": "𝕣",
	"Ropf": "ℝ",
	"roplus": "⨮",
	"rotimes": "⨵",
	"RoundImplies": "⥰",
	"rpar": ")",
	"rpargt": "⦔",
	"rppolint": "⨒",
	"rrarr": "⇉",
	"Rrightarrow": "⇛",
	"rsaquo": "›",
	"rscr": "𝓇",
	"Rscr": "ℛ",
	"rsh": "↱",
	"Rsh": "↱",
	"rsqb": "]",
	"rsquo": "’",
	"rsquor": "’",
	"rthree": "⋌",
	"rtimes": "⋊",
	"rtri": "▹",
	"rtrie": "⊵",
	"rtrif": "▸",
	"rtriltri": "⧎",
	"RuleDelayed": "⧴",
	"ruluhar": "⥨",
	"rx": "℞",
	"Sacute": "Ś",
	"sacute": "ś",
	"sbquo": "‚",
	"scap": "⪸",
	"Scaron": "Š",
	"scaron": "š",
	"Sc": "⪼",
	"sc": "≻",
	"sccue": "≽",
	"sce": "⪰",
	"scE": "⪴",
	"Scedil": "Ş",
	"scedil": "ş",
	"Scirc": "Ŝ",
	"scirc": "ŝ",
	"scnap": "⪺",
	"scnE": "⪶",
	"scnsim": "⋩",
	"scpolint": "⨓",
	"scsim": "≿",
	"Scy": "С",
	"scy": "с",
	"sdotb": "⊡",
	"sdot": "⋅",
	"sdote": "⩦",
	"searhk": "⤥",
	"searr": "↘",
	"seArr": "⇘",
	"searrow": "↘",
	"sect": "§",
	"semi": ";",
	"seswar": "⤩",
	"setminus": "∖",
	"setmn": "∖",
	"sext": "✶",
	"Sfr": "𝔖",
	"sfr": "𝔰",
	"sfrown": "⌢",
	"sharp": "♯",
	"SHCHcy": "Щ",
	"shchcy": "щ",
	"SHcy": "Ш",
	"shcy": "ш",
	"ShortDownArrow": "↓",
	"ShortLeftArrow": "←",
	"shortmid": "∣",
	"shortparallel": "∥",
	"ShortRightArrow": "→",
	"ShortUpArrow": "↑",
	"shy": "­",
	"Sigma": "Σ",
	"sigma": "σ",
	"sigmaf": "ς",
	"sigmav": "ς",
	"sim": "∼",
	"simdot": "⩪",
	"sime": "≃",
	"simeq": "≃",
	"simg": "⪞",
	"simgE": "⪠",
	"siml": "⪝",
	"simlE": "⪟",
	"simne": "≆",
	"simplus": "⨤",
	"simrarr": "⥲",
	"slarr": "←",
	"SmallCircle": "∘",
	"smallsetminus": "∖",
	"smashp": "⨳",
	"smeparsl": "⧤",
	"smid": "∣",
	"smile": "⌣",
	"smt": "⪪",
	"smte": "⪬",
	"smtes": "⪬︀",
	"SOFTcy": "Ь",
	"softcy": "ь",
	"solbar": "⌿",
	"solb": "⧄",
	"sol": "/",
	"Sopf": "𝕊",
	"sopf": "𝕤",
	"spades": "♠",
	"spadesuit": "♠",
	"spar": "∥",
	"sqcap": "⊓",
	"sqcaps": "⊓︀",
	"sqcup": "⊔",
	"sqcups": "⊔︀",
	"Sqrt": "√",
	"sqsub": "⊏",
	"sqsube": "⊑",
	"sqsubset": "⊏",
	"sqsubseteq": "⊑",
	"sqsup": "⊐",
	"sqsupe": "⊒",
	"sqsupset": "⊐",
	"sqsupseteq": "⊒",
	"square": "□",
	"Square": "□",
	"SquareIntersection": "⊓",
	"SquareSubset": "⊏",
	"SquareSubsetEqual": "⊑",
	"SquareSuperset": "⊐",
	"SquareSupersetEqual": "⊒",
	"SquareUnion": "⊔",
	"squarf": "▪",
	"squ": "□",
	"squf": "▪",
	"srarr": "→",
	"Sscr": "𝒮",
	"sscr": "𝓈",
	"ssetmn": "∖",
	"ssmile": "⌣",
	"sstarf": "⋆",
	"Star": "⋆",
	"star": "☆",
	"starf": "★",
	"straightepsilon": "ϵ",
	"straightphi": "ϕ",
	"strns": "¯",
	"sub": "⊂",
	"Sub": "⋐",
	"subdot": "⪽",
	"subE": "⫅",
	"sube": "⊆",
	"subedot": "⫃",
	"submult": "⫁",
	"subnE": "⫋",
	"subne": "⊊",
	"subplus": "⪿",
	"subrarr": "⥹",
	"subset": "⊂",
	"Subset": "⋐",
	"subseteq": "⊆",
	"subseteqq": "⫅",
	"SubsetEqual": "⊆",
	"subsetneq": "⊊",
	"subsetneqq": "⫋",
	"subsim": "⫇",
	"subsub": "⫕",
	"subsup": "⫓",
	"succapprox": "⪸",
	"succ": "≻",
	"succcurlyeq": "≽",
	"Succeeds": "≻",
	"SucceedsEqual": "⪰",
	"SucceedsSlantEqual": "≽",
	"SucceedsTilde": "≿",
	"succeq": "⪰",
	"succnapprox": "⪺",
	"succneqq": "⪶",
	"succnsim": "⋩",
	"succsim": "≿",
	"SuchThat": "∋",
	"sum": "∑",
	"Sum": "∑",
	"sung": "♪",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"sup": "⊃",
	"Sup": "⋑",
	"supdot": "⪾",
	"supdsub": "⫘",
	"supE": "⫆",
	"supe": "⊇",
	"supedot": "⫄",
	"Superset": "⊃",
	"SupersetEqual": "⊇",
	"suphsol": "⟉",
	"suphsub": "⫗",
	"suplarr": "⥻",
	"supmult": "⫂",
	"supnE": "⫌",
	"supne": "⊋",
	"supplus": "⫀",
	"supset": "⊃",
	"Supset": "⋑",
	"supseteq": "⊇",
	"supseteqq": "⫆",
	"supsetneq": "⊋",
	"supsetneqq": "⫌",
	"supsim": "⫈",
	"supsub": "⫔",
	"supsup": "⫖",
	"swarhk": "⤦",
	"swarr": "↙",
	"swArr": "⇙",
	"swarrow": "↙",
	"swnwar": "⤪",
	"szlig": "ß",
	"Tab": "\t",
	"target": "⌖",
	"Tau": "Τ",
	"tau": "τ",
	"tbrk": "⎴",
	"Tcaron": "Ť",
	"tcaron": "ť",
	"Tcedil": "Ţ",
	"tcedil": "ţ",
	"Tcy": "Т",
	"tcy": "т",
	"tdot": "⃛",
	"telrec": "⌕",
	"Tfr": "𝔗",
	"tfr": "𝔱",
	"there4": "∴",
	"therefore": "∴",
	"Therefore": "∴",
	"Theta": "Θ",
	"theta": "θ",
	"thetasym": "ϑ",
	"thetav": "ϑ",
	"thickapprox": "≈",
	"thicksim": "∼",
	"ThickSpace": "  ",
	"ThinSpace": " ",
	"thinsp": " ",
	"thkap": "≈",
	"thksim": "∼",
	"THORN": "Þ",
	"thorn": "þ",
	"tilde": "˜",
	"Tilde": "∼",
	"TildeEqual": "≃",
	"TildeFullEqual": "≅",
	"TildeTilde": "≈",
	"timesbar": "⨱",
	"timesb": "⊠",
	"times": "×",
	"timesd": "⨰",
	"tint": "∭",
	"toea": "⤨",
	"topbot": "⌶",
	"topcir": "⫱",
	"top": "⊤",
	"Topf": "𝕋",
	"topf": "𝕥",
	"topfork": "⫚",
	"tosa": "⤩",
	"tprime": "‴",
	"trade": "™",
	"TRADE": "™",
	"triangle": "▵",
	"triangledown": "▿",
	"triangleleft": "◃",
	"trianglelefteq": "⊴",
	"triangleq": "≜",
	"triangleright": "▹",
	"trianglerighteq": "⊵",
	"tridot": "◬",
	"trie": "≜",
	"triminus": "⨺",
	"TripleDot": "⃛",
	"triplus": "⨹",
	"trisb": "⧍",
	"tritime": "⨻",
	"trpezium": "⏢",
	"Tscr": "𝒯",
	"tscr": "𝓉",
	"TScy": "Ц",
	"tscy": "ц",
	"TSHcy": "Ћ",
	"tshcy": "ћ",
	"Tstrok": "Ŧ",
	"tstrok": "ŧ",
	"twixt": "≬",
	"twoheadleftarrow": "↞",
	"twoheadrightarrow": "↠",
	"Uacute": "Ú",
	"uacute": "ú",
	"uarr": "↑",
	"Uarr": "↟",
	"uArr": "⇑",
	"Uarrocir": "⥉",
	"Ubrcy": "Ў",
	"ubrcy": "ў",
	"Ubreve": "Ŭ",
	"ubreve": "ŭ",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ucy": "У",
	"ucy": "у",
	"udarr": "⇅",
	"Udblac": "Ű",
	"udblac": "ű",
	"udhar": "⥮",
	"ufisht": "⥾",
	"Ufr": "𝔘",
	"ufr": "𝔲",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uHar": "⥣",
	"uharl": "↿",
	"uharr": "↾",
	"uhblk": "▀",
	"ulcorn": "⌜",
	"ulcorner": "⌜",
	"ulcrop": "⌏",
	"ultri": "◸",
	"Umacr": "Ū",
	"umacr": "ū",
	"uml": "¨",
	"UnderBar": "_",
	"UnderBrace": "⏟",
	"UnderBracket": "⎵",
	"UnderParenthesis": "⏝",
	"Union": "⋃",
	"UnionPlus": "⊎",
	"Uogon": "Ų",
	"uogon": "ų",
	"Uopf": "𝕌",
	"uopf": "𝕦",
	"UpArrowBar": "⤒",
	"uparrow": "↑",
	"UpArrow": "↑",
	"Uparrow": "⇑",
	"UpArrowDownArrow": "⇅",
	"updownarrow": "↕",
	"UpDownArrow": "↕",
	"Updownarrow": "⇕",
	"UpEquilibrium": "⥮",
	"upharpoonleft": "↿",
	"upharpoonright": "↾",
	"uplus": "⊎",
	"UpperLeftArrow": "↖",
	"UpperRightArrow": "↗",
	"upsi": "υ",
	"Upsi": "ϒ",
	"upsih": "ϒ",
	"Upsilon": "Υ",
	"upsilon": "υ",
	"UpTeeArrow": "↥",
	"UpTee": "⊥",
	"upuparrows": "⇈",
	"urcorn": "⌝",
	"urcorner": "⌝",
	"urcrop": "⌎",
	"Uring": "Ů",
	"uring": "ů",
	"urtri": "◹",
	"Uscr": "𝒰",
	"uscr": "𝓊",
	"utdot": "⋰",
	"Utilde": "Ũ",
	"utilde": "ũ",
	"utri": "▵",
	"utrif": "▴",
	"uuarr": "⇈",
	"Uuml": "Ü",
	"uuml": "ü",
	"uwangle": "⦧",
	"vangrt": "⦜",
	"varepsilon": "ϵ",
	"varkappa": "ϰ",
	"varnothing": "∅",
	"varphi": "ϕ",
	"varpi": "ϖ",
	"varpropto": "∝",
	"varr": "↕",
	"vArr": "⇕",
	"varrho": "ϱ",
	"varsigma": "ς",
	"varsubsetneq": "⊊︀",
	"varsubsetneqq": "⫋︀",
	"varsupsetneq": "⊋︀",
	"varsupsetneqq": "⫌︀",
	"vartheta": "ϑ",
	"vartriangleleft": "⊲",
	"vartriangleright": "⊳",
	"vBar": "⫨",
	"Vbar": "⫫",
	"vBarv": "⫩",
	"Vcy": "В",
	"vcy": "в",
	"vdash": "⊢",
	"vDash": "⊨",
	"Vdash": "⊩",
	"VDash": "⊫",
	"Vdashl": "⫦",
	"veebar": "⊻",
	"vee": "∨",
	"Vee": "⋁",
	"veeeq": "≚",
	"vellip": "⋮",
	"verbar": "|",
	"Verbar": "‖",
	"vert": "|",
	"Vert": "‖",
	"VerticalBar": "∣",
	"VerticalLine": "|",
	"VerticalSeparator": "❘",
	"VerticalTilde": "≀",
	"VeryThinSpace": " ",
	"Vfr": "𝔙",
	"vfr": "𝔳",
	"vltri": "⊲",
	"vnsub": "⊂⃒",
	"vnsup": "⊃⃒",
	"Vopf": "𝕍",
	"vopf": "𝕧",
	"vprop": "∝",
	"vrtri": "⊳",
	"Vscr": "𝒱",
	"vscr": "𝓋",
	"vsubnE": "⫋︀",
	"vsubne": "⊊︀",
	"vsupnE": "⫌︀",
	"vsupne": "⊋︀",
	"Vvdash": "⊪",
	"vzigzag": "⦚",
	"Wcirc": "Ŵ",
	"wcirc": "ŵ",
	"wedbar": "⩟",
	"wedge": "∧",
	"Wedge": "⋀",
	"wedgeq": "≙",
	"weierp": "℘",
	"Wfr": "𝔚",
	"wfr": "𝔴",
	"Wopf": "𝕎",
	"wopf": "𝕨",
	"wp": "℘",
	"wr": "≀",
	"wreath": "≀",
	"Wscr": "𝒲",
	"wscr": "𝓌",
	"xcap": "⋂",
	"xcirc": "◯",
	"xcup": "⋃",
	"xdtri": "▽",
	"Xfr": "𝔛",
	"xfr": "𝔵",
	"xharr": "⟷",
	"xhArr": "⟺",
	"Xi": "Ξ",
	"xi": "ξ",
	"xlarr": "⟵",
	"xlArr": "⟸",
	"xmap": "⟼",
	"xnis": "⋻",
	"xodot": "⨀",
	"Xopf": "𝕏",
	"xopf": "𝕩",
	"xoplus": "⨁",
	"xotime": "⨂",
	"xrarr": "⟶",
	"xrArr": "⟹",
	"Xscr": "𝒳",
	"xscr": "𝓍",
	"xsqcup": "⨆",
	"xuplus": "⨄",
	"xutri": "△",
	"xvee": "⋁",
	"xwedge": "⋀",
	"Yacute": "Ý",
	"yacute": "ý",
	"YAcy": "Я",
	"yacy": "я",
	"Ycirc": "Ŷ",
	"ycirc": "ŷ",
	"Ycy": "Ы",
	"ycy": "ы",
	"yen": "¥",
	"Yfr": "𝔜",
	"yfr": "𝔶",
	"YIcy": "Ї",
	"yicy": "ї",
	"Yopf": "𝕐",
	"yopf": "𝕪",
	"Yscr": "𝒴",
	"yscr": "𝓎",
	"YUcy": "Ю",
	"yucy": "ю",
	"yuml": "ÿ",
	"Yuml": "Ÿ",
	"Zacute": "Ź",
	"zacute": "ź",
	"Zcaron": "Ž",
	"zcaron": "ž",
	"Zcy": "З",
	"zcy": "з",
	"Zdot": "Ż",
	"zdot": "ż",
	"zeetrf": "ℨ",
	"ZeroWidthSpace": "​",
	"Zeta": "Ζ",
	"zeta": "ζ",
	"zfr": "𝔷",
	"Zfr": "ℨ",
	"ZHcy": "Ж",
	"zhcy": "ж",
	"zigrarr": "⇝",
	"zopf": "𝕫",
	"Zopf": "ℤ",
	"Zscr": "𝒵",
	"zscr": "𝓏",
	"zwj": "‍",
	"zwnj": "‌"
};

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(141).EventEmitter;
var inherits = __webpack_require__(87);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(495);
Stream.Writable = __webpack_require__(1975);
Stream.Duplex = __webpack_require__(1976);
Stream.Transform = __webpack_require__(1977);
Stream.PassThrough = __webpack_require__(1978);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(924);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(497);
exports.Duplex = __webpack_require__(185);
exports.Transform = __webpack_require__(928);
exports.PassThrough = __webpack_require__(1974);


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(76)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(351);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(148);
util.inherits = __webpack_require__(87);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(927)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(925);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(496).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(926);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(185);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(185);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66), __webpack_require__(439).setImmediate, __webpack_require__(24)))

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1999);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./no-scrollbar.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./no-scrollbar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePicker = exports.Tooltip = exports.Switch = exports.Snackbar = exports.Slider = exports.Ripple = exports.ProgressBar = exports.Navigation = exports.Link = exports.Input = exports.FontIcon = exports.Dropdown = exports.Drawer = exports.Dialog = exports.DatePicker = exports.Checkbox = exports.Chip = exports.Avatar = exports.Autocomplete = exports.AppBar = exports.overrideComponentTypeChecker = undefined;

var _isComponentOfType = __webpack_require__(265);

Object.defineProperty(exports, 'overrideComponentTypeChecker', {
  enumerable: true,
  get: function get() {
    return _isComponentOfType.overrideComponentTypeChecker;
  }
});

var _app_bar = __webpack_require__(122);

Object.defineProperty(exports, 'AppBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_app_bar).default;
  }
});

var _autocomplete = __webpack_require__(2199);

Object.defineProperty(exports, 'Autocomplete', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_autocomplete).default;
  }
});

var _avatar = __webpack_require__(26);

Object.defineProperty(exports, 'Avatar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_avatar).default;
  }
});

var _button = __webpack_require__(8);

Object.keys(_button).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _button[key];
    }
  });
});

var _card = __webpack_require__(28);

Object.keys(_card).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _card[key];
    }
  });
});

var _chip = __webpack_require__(91);

Object.defineProperty(exports, 'Chip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_chip).default;
  }
});

var _checkbox = __webpack_require__(54);

Object.defineProperty(exports, 'Checkbox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_checkbox).default;
  }
});

var _date_picker = __webpack_require__(354);

Object.defineProperty(exports, 'DatePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_date_picker).default;
  }
});

var _dialog = __webpack_require__(47);

Object.defineProperty(exports, 'Dialog', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dialog).default;
  }
});

var _drawer = __webpack_require__(476);

Object.defineProperty(exports, 'Drawer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_drawer).default;
  }
});

var _dropdown = __webpack_require__(74);

Object.defineProperty(exports, 'Dropdown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dropdown).default;
  }
});

var _font_icon = __webpack_require__(23);

Object.defineProperty(exports, 'FontIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_font_icon).default;
  }
});

var _input = __webpack_require__(59);

Object.defineProperty(exports, 'Input', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_input).default;
  }
});

var _layout = __webpack_require__(85);

Object.keys(_layout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _layout[key];
    }
  });
});

var _link = __webpack_require__(183);

Object.defineProperty(exports, 'Link', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_link).default;
  }
});

var _list = __webpack_require__(25);

Object.keys(_list).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _list[key];
    }
  });
});

var _menu = __webpack_require__(63);

Object.keys(_menu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _menu[key];
    }
  });
});

var _navigation = __webpack_require__(147);

Object.defineProperty(exports, 'Navigation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_navigation).default;
  }
});

var _progress_bar = __webpack_require__(78);

Object.defineProperty(exports, 'ProgressBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_progress_bar).default;
  }
});

var _radio = __webpack_require__(503);

Object.keys(_radio).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _radio[key];
    }
  });
});

var _slider = __webpack_require__(2206);

Object.defineProperty(exports, 'Slider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_slider).default;
  }
});

var _snackbar = __webpack_require__(865);

Object.defineProperty(exports, 'Snackbar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_snackbar).default;
  }
});

var _switch = __webpack_require__(227);

Object.defineProperty(exports, 'Switch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_switch).default;
  }
});

var _table = __webpack_require__(504);

Object.keys(_table).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _table[key];
    }
  });
});

var _tabs = __webpack_require__(188);

Object.keys(_tabs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tabs[key];
    }
  });
});

var _time_picker = __webpack_require__(2216);

Object.defineProperty(exports, 'TimePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_time_picker).default;
  }
});

__webpack_require__(2223);

var _ripple = __webpack_require__(162);

var _ripple2 = _interopRequireDefault(_ripple);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Ripple = _ripple2.default;
exports.Tooltip = _tooltip2.default;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = exports.RadioButton = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _ripple = __webpack_require__(162);

var _ripple2 = _interopRequireDefault(_ripple);

var _Radio = __webpack_require__(938);

var _Radio2 = _interopRequireDefault(_Radio);

var _RadioButton = __webpack_require__(939);

var _RadioGroup = __webpack_require__(2203);

var _theme = __webpack_require__(2204);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedRadio = (0, _Radio2.default)((0, _ripple2.default)({ centered: true, spread: 2.6 }));
var ThemedRadioButton = (0, _reactCssThemr.themr)(_identifiers.RADIO, _theme2.default)((0, _RadioButton.radioButtonFactory)(ThemedRadio));
var ThemedRadioGroup = (0, _reactCssThemr.themr)(_identifiers.RADIO, _theme2.default)((0, _RadioGroup.radioGroupFactory)(ThemedRadioButton));

exports.default = ThemedRadioButton;
exports.RadioButton = ThemedRadioButton;
exports.RadioGroup = ThemedRadioGroup;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCell = exports.TableRow = exports.TableHead = exports.Table = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _checkbox = __webpack_require__(54);

var _font_icon = __webpack_require__(23);

var _Table = __webpack_require__(2213);

var _TableHead = __webpack_require__(941);

var _TableRow = __webpack_require__(942);

var _TableCell = __webpack_require__(505);

var _theme = __webpack_require__(2214);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applyTheme = function applyTheme(Component) {
  return (0, _reactCssThemr.themr)(_identifiers.TABLE, _theme2.default)(Component);
};
var ThemedTableCell = applyTheme((0, _TableCell.tableCellFactory)(_font_icon.FontIcon));
var ThemedTableHead = applyTheme((0, _TableHead.tableHeadFactory)(_checkbox.Checkbox, ThemedTableCell));
var ThemedTableRow = applyTheme((0, _TableRow.tableRowFactory)(_checkbox.Checkbox, ThemedTableCell));
var ThemedTable = applyTheme((0, _Table.tableFactory)(ThemedTableHead, ThemedTableRow));

exports.default = ThemedTable;
exports.Table = ThemedTable;
exports.TableHead = ThemedTableHead;
exports.TableRow = ThemedTableRow;
exports.TableCell = ThemedTableCell;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCell = exports.tableCellFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = __webpack_require__(14);

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _FontIcon = __webpack_require__(81);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ASC = 'asc';
var DESC = 'desc';

var factory = function factory(FontIcon) {
  var TableCell = function (_Component) {
    _inherits(TableCell, _Component);

    function TableCell() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TableCell);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableCell.__proto__ || Object.getPrototypeOf(TableCell)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
        var _this$props = _this.props,
            onClick = _this$props.onClick,
            row = _this$props.row,
            column = _this$props.column;

        if (onClick) onClick(event, column, row);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TableCell, [{
      key: 'render',
      value: function render() {
        var _classnames;

        var _props = this.props,
            children = _props.children,
            className = _props.className,
            numeric = _props.numeric,
            row = _props.row,
            column = _props.column,
            sorted = _props.sorted,
            tagName = _props.tagName,
            theme = _props.theme,
            other = _objectWithoutProperties(_props, ['children', 'className', 'numeric', 'row', 'column', 'sorted', 'tagName', 'theme']);

        var _className = (0, _classnames4.default)(theme.tableCell, (_classnames = {}, _defineProperty(_classnames, theme.headCell, tagName === 'th'), _defineProperty(_classnames, theme.rowCell, tagName === 'td'), _defineProperty(_classnames, theme.sorted, sorted), _defineProperty(_classnames, theme.numeric, numeric), _classnames), className);

        var props = _extends({}, other, {
          className: _className,
          onClick: this.handleClick
        });

        return _react2.default.createElement(tagName, props, [sorted && _react2.default.createElement(FontIcon, {
          className: (0, _classnames4.default)(theme.sortIcon, _defineProperty({}, theme.asc, sorted === ASC)),
          key: 'icon',
          value: 'arrow_downward'
        }), children]);
      }
    }]);

    return TableCell;
  }(_react.Component);

  TableCell.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    column: _propTypes2.default.number,
    numeric: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    row: _propTypes2.default.number,
    sorted: _propTypes2.default.oneOf([ASC, DESC]),
    tagName: _propTypes2.default.oneOf(['td', 'th']),
    theme: _propTypes2.default.shape({
      asc: _propTypes2.default.string,
      headCell: _propTypes2.default.string,
      numeric: _propTypes2.default.string,
      rowCell: _propTypes2.default.string,
      sorted: _propTypes2.default.string,
      sortIcon: _propTypes2.default.string,
      tableCell: _propTypes2.default.string
    })
  };
  TableCell.defaultProps = {
    children: _propTypes2.default.node,
    className: '',
    numeric: false,
    tagName: 'td'
  };


  return TableCell;
};

var TableCell = factory(_FontIcon2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.TABLE)(TableCell);
exports.tableCellFactory = factory;
exports.TableCell = TableCell;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(166);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(93);
var hide = __webpack_require__(92);
var Iterators = __webpack_require__(228);
var $iterCreate = __webpack_require__(508);
var setToStringTag = __webpack_require__(229);
var getPrototypeOf = __webpack_require__(101);
var ITERATOR = __webpack_require__(52)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40);
var document = __webpack_require__(34).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(191);
var descriptor = __webpack_require__(189);
var setToStringTag = __webpack_require__(229);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(92)(IteratorPrototype, __webpack_require__(52)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(274)('keys');
var uid = __webpack_require__(190);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 510 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(34).document;
module.exports = document && document.documentElement;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(228);
var ITERATOR = __webpack_require__(52)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(61);
var createDesc = __webpack_require__(189);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(230);
var ITERATOR = __webpack_require__(52)('iterator');
var Iterators = __webpack_require__(228);
module.exports = __webpack_require__(51).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(2228);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(953);
var validate = __webpack_require__(198);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(362)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40);
var setPrototypeOf = __webpack_require__(518).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(40);
var anObject = __webpack_require__(29);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(108)(Function.call, __webpack_require__(102).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(365);
var defined = __webpack_require__(123);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(52)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var core = __webpack_require__(51);
var LIBRARY = __webpack_require__(166);
var wksExt = __webpack_require__(962);
var defineProperty = __webpack_require__(61).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// src/helpers/field-icons.js

var FIELD_ICONS = {
  'time': 'access_time',
  'date': 'date_range',
  'text': 'create',
  'string': 'create',
  'numeric': 'create',
  'dropdown': 'arrow_drop_down'
};

exports.default = FIELD_ICONS;

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentryError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfill__ = __webpack_require__(2301);


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        Object(__WEBPACK_IMPORTED_MODULE_1__polyfill__["a" /* setPrototypeOf */])(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(279);
/* eslint-disable @typescript-eslint/no-explicit-any */

// TODO: Implement different loggers for different environments
var global = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["e" /* getGlobalObject */])();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' '));
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["b"] = isNodeEnv;
/* harmony export (immutable) */ __webpack_exports__["a"] = dynamicRequire;
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
//# sourceMappingURL=node.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(66)))

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = truncate;
/* harmony export (immutable) */ __webpack_exports__["c"] = snipLine;
/* harmony export (immutable) */ __webpack_exports__["b"] = safeJoin;
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatchingPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(234);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        // eslint-disable-next-line no-param-reassign
        colno = ll;
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(value)) {
        return false;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["j" /* isRegExp */])(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFunctionName;
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
//# sourceMappingURL=stacktrace.js.map

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromException;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = eventFromUnknownInput;
/* unused harmony export eventFromString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracekit__ = __webpack_require__(529);





/**
 * Builds and Event from a Exception
 * @hidden
 */
function eventFromException(options, exception, hint) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["e" /* addExceptionMechanism */])(event, {
        handled: true,
        type: 'generic',
    });
    event.level = __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Severity */].Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */].resolve(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(options, message, level, hint) {
    if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Severity */].Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */].resolve(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["u" /* isErrorEvent */])(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        // eslint-disable-next-line no-param-reassign
        exception = errorEvent.error;
        event = Object(__WEBPACK_IMPORTED_MODULE_3__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_4__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["r" /* isDOMError */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["s" /* isDOMException */])(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name, code, and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["r" /* isDOMError */])(domException) ? 'DOMError' : 'DOMException');
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = eventFromString(message, syntheticException, options);
        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["f" /* addExceptionTypeValue */])(event, message);
        if ('code' in domException) {
            event.tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* isError */])(exception)) {
        // we have a real Error object, do nothing
        event = Object(__WEBPACK_IMPORTED_MODULE_3__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_4__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["z" /* isPlainObject */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isEvent */])(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = Object(__WEBPACK_IMPORTED_MODULE_3__parsers__["a" /* eventFromPlainObject */])(objectException, syntheticException, options.rejection);
        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["e" /* addExceptionMechanism */])(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["f" /* addExceptionTypeValue */])(event, "" + exception, undefined);
    Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["e" /* addExceptionMechanism */])(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event = {
        message: input,
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_4__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = Object(__WEBPACK_IMPORTED_MODULE_3__parsers__["d" /* prepareFramesForEvent */])(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeStackTrace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/**
 * This was originally forked from https://github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 */

// global reference to slice
var UNKNOWN_FUNCTION = '?';
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function computeStackTrace(ex) {
    var stack = null;
    var popSize = 0;
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            popSize = ex.framesToPop;
        }
        else if (reactMinifiedRegexp.test(ex.message)) {
            popSize = 1;
        }
    }
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = computeStackTraceFromStacktraceProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    try {
        stack = computeStackTraceFromStackProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    return {
        message: extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true,
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
function computeStackTraceFromStackProp(ex) {
    if (!ex || !ex.stack) {
        return null;
    }
    var stack = [];
    var lines = ex.stack.split('\n');
    var isEval;
    var submatch;
    var parts;
    var element;
    for (var i = 0; i < lines.length; ++i) {
        if ((parts = chrome.exec(lines[i]))) {
            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
                // prefix here seems like the quickest solution for now.
                url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: isNative ? [parts[2]] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = winjs.exec(lines[i]))) {
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: [],
                line: +parts[3],
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = gecko.exec(lines[i]))) {
            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ''; // no column when eval
            }
            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                // NOTE: this hack doesn't work if top-most frame is eval
                stack[0].column = ex.columnNumber + 1;
            }
            element = {
                url: parts[3],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(',') : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null,
            };
        }
        else {
            continue;
        }
        if (!element.func && element.line) {
            element.func = UNKNOWN_FUNCTION;
        }
        stack.push(element);
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) {
        return null;
    }
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split('\n');
    var stack = [];
    var parts;
    for (var line = 0; line < lines.length; line += 2) {
        var element = null;
        if ((parts = opera10Regex.exec(lines[line]))) {
            element = {
                url: parts[2],
                func: parts[3],
                args: [],
                line: +parts[1],
                column: null,
            };
        }
        else if ((parts = opera11Regex.exec(lines[line]))) {
            element = {
                url: parts[6],
                func: parts[3] || parts[4],
                args: parts[5] ? parts[5].split(',') : [],
                line: +parts[1],
                column: +parts[2],
            };
        }
        if (element) {
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            stack.push(element);
        }
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** Remove N number of frames from the stack */
function popFrames(stacktrace, popSize) {
    try {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
    }
    catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(45);




/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["b" /* PromiseBuffer */](30);
        /** Locks transport after receiving rate limits in a response */
        this._rateLimits = {};
        this._api = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](options.dsn, options._metadata);
        // eslint-disable-next-line deprecation/deprecation
        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */
    BaseTransport.prototype._handleResponse = function (_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["c" /* Status */].fromHttpCode(response.status);
        /**
         * "The name is case-insensitive."
         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
         */
        var limited = this._handleRateLimit(headers);
        if (limited)
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* logger */].warn("Too many requests, backing off until: " + this._disabledUntil(requestType));
        if (status === __WEBPACK_IMPORTED_MODULE_2__sentry_types__["c" /* Status */].Success) {
            resolve({ status: status });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     */
    BaseTransport.prototype._disabledUntil = function (category) {
        return this._rateLimits[category] || this._rateLimits.all;
    };
    /**
     * Checks if a category is rate limited
     */
    BaseTransport.prototype._isRateLimited = function (category) {
        return this._disabledUntil(category) > new Date(Date.now());
    };
    /**
     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
     */
    BaseTransport.prototype._handleRateLimit = function (headers) {
        var e_1, _a, e_2, _b;
        var now = Date.now();
        var rlHeader = headers['x-sentry-rate-limits'];
        var raHeader = headers['retry-after'];
        if (rlHeader) {
            try {
                // rate limit headers are of the form
                //     <header>,<header>,..
                // where each <header> is of the form
                //     <retry_after>: <categories>: <scope>: <reason_code>
                // where
                //     <retry_after> is a delay in ms
                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
                //         <category>;<category>;...
                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
                for (var _c = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var limit = _d.value;
                    var parameters = limit.split(':', 2);
                    var headerDelay = parseInt(parameters[0], 10);
                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                    try {
                        for (var _e = (e_2 = void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var category = _f.value;
                            this._rateLimits[category || 'all'] = new Date(now + delay);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        }
        else if (raHeader) {
            this._rateLimits.all = new Date(now + Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* parseRetryAfterHeader */])(now, raHeader));
            return true;
        }
        return false;
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalhandlers__ = __webpack_require__(2321);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalHandlers", function() { return __WEBPACK_IMPORTED_MODULE_0__globalhandlers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trycatch__ = __webpack_require__(2322);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TryCatch", function() { return __WEBPACK_IMPORTED_MODULE_1__trycatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__ = __webpack_require__(2323);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkederrors__ = __webpack_require__(2324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_3__linkederrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useragent__ = __webpack_require__(2325);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UserAgent", function() { return __WEBPACK_IMPORTED_MODULE_4__useragent__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(2330);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _guideMessage = __webpack_require__(2346);

var _guideMessage2 = _interopRequireDefault(_guideMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/guide-message.jsx

var GuideMessage = function (_React$PureComponent) {
  _inherits(GuideMessage, _React$PureComponent);

  function GuideMessage() {
    _classCallCheck(this, GuideMessage);

    return _possibleConstructorReturn(this, (GuideMessage.__proto__ || Object.getPrototypeOf(GuideMessage)).apply(this, arguments));
  }

  _createClass(GuideMessage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showMessage = _props.showMessage,
          message = _props.message,
          style = _props.style,
          diaryGuidance = _props.diaryGuidance;


      if (!showMessage) return null;

      return _react2.default.createElement(
        'div',
        { className: diaryGuidance ? _guideMessage2.default.diaryGuidance : _guideMessage2.default.message, style: style },
        message
      );
    }
  }]);

  return GuideMessage;
}(_react2.default.PureComponent);

exports.default = GuideMessage;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2349);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./group-members-sorting.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./group-members-sorting.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2357);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./reported-date-picker.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./reported-date-picker.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2375);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./z-index-menu.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./z-index-menu.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(170);
var document = __webpack_require__(88).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(170);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 539 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 540 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(542)('keys');
var uid = __webpack_require__(377);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(70);
var global = __webpack_require__(88);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(284) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 543 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 544 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(128);
var dPs = __webpack_require__(2393);
var enumBugKeys = __webpack_require__(543);
var IE_PROTO = __webpack_require__(541)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(537)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1004).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(89);


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(88);
var core = __webpack_require__(70);
var LIBRARY = __webpack_require__(284);
var wksExt = __webpack_require__(546);
var defineProperty = __webpack_require__(169).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2406), __esModule: true };

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(283);
var TAG = __webpack_require__(89)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(375);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(108);
var invoke = __webpack_require__(1023);
var html = __webpack_require__(511);
var cel = __webpack_require__(507);
var global = __webpack_require__(34);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(109)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var macrotask = __webpack_require__(551).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(109)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(82);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(34);
var each = __webpack_require__(125)(0);
var redefine = __webpack_require__(93);
var meta = __webpack_require__(168);
var assign = __webpack_require__(1028);
var weak = __webpack_require__(1029);
var isObject = __webpack_require__(40);
var validate = __webpack_require__(198);
var NATIVE_WEAK_MAP = __webpack_require__(198);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(362)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var buffer = __webpack_require__(76);
var Buffer = buffer.Buffer;
var SlowBuffer = buffer.SlowBuffer;
var MAX_LEN = buffer.kMaxLength || 2147483647;
exports.alloc = function alloc(size, fill, encoding) {
  if (typeof Buffer.alloc === 'function') {
    return Buffer.alloc(size, fill, encoding);
  }
  if (typeof encoding === 'number') {
    throw new TypeError('encoding must not be number');
  }
  if (typeof size !== 'number') {
    throw new TypeError('size must be a number');
  }
  if (size > MAX_LEN) {
    throw new RangeError('size is too large');
  }
  var enc = encoding;
  var _fill = fill;
  if (_fill === undefined) {
    enc = undefined;
    _fill = 0;
  }
  var buf = new Buffer(size);
  if (typeof _fill === 'string') {
    var fillBuf = new Buffer(_fill, enc);
    var flen = fillBuf.length;
    var i = -1;
    while (++i < size) {
      buf[i] = fillBuf[i % flen];
    }
  } else {
    buf.fill(_fill);
  }
  return buf;
}
exports.allocUnsafe = function allocUnsafe(size) {
  if (typeof Buffer.allocUnsafe === 'function') {
    return Buffer.allocUnsafe(size);
  }
  if (typeof size !== 'number') {
    throw new TypeError('size must be a number');
  }
  if (size > MAX_LEN) {
    throw new RangeError('size is too large');
  }
  return new Buffer(size);
}
exports.from = function from(value, encodingOrOffset, length) {
  if (typeof Buffer.from === 'function' && (!global.Uint8Array || Uint8Array.from !== Buffer.from)) {
    return Buffer.from(value, encodingOrOffset, length);
  }
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }
  if (typeof value === 'string') {
    return new Buffer(value, encodingOrOffset);
  }
  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    var offset = encodingOrOffset;
    if (arguments.length === 1) {
      return new Buffer(value);
    }
    if (typeof offset === 'undefined') {
      offset = 0;
    }
    var len = length;
    if (typeof len === 'undefined') {
      len = value.byteLength - offset;
    }
    if (offset >= value.byteLength) {
      throw new RangeError('\'offset\' is out of bounds');
    }
    if (len > value.byteLength - offset) {
      throw new RangeError('\'length\' is out of bounds');
    }
    return new Buffer(value.slice(offset, offset + len));
  }
  if (Buffer.isBuffer(value)) {
    var out = new Buffer(value.length);
    value.copy(out, 0, 0, value.length);
    return out;
  }
  if (value) {
    if (Array.isArray(value) || (typeof ArrayBuffer !== 'undefined' && value.buffer instanceof ArrayBuffer) || 'length' in value) {
      return new Buffer(value);
    }
    if (value.type === 'Buffer' && Array.isArray(value.data)) {
      return new Buffer(value.data);
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ' + 'ArrayBuffer, Array, or array-like object.');
}
exports.allocUnsafeSlow = function allocUnsafeSlow(size) {
  if (typeof Buffer.allocUnsafeSlow === 'function') {
    return Buffer.allocUnsafeSlow(size);
  }
  if (typeof size !== 'number') {
    throw new TypeError('size must be a number');
  }
  if (size >= MAX_LEN) {
    throw new RangeError('size is too large');
  }
  return new SlowBuffer(size);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateResponseStatus = exports.validateRangeRequestCapabilities = exports.extractFilenameFromHeader = exports.createResponseStatusError = undefined;

var _util = __webpack_require__(73);

var _content_disposition = __webpack_require__(2469);

function validateRangeRequestCapabilities(_ref) {
  var getResponseHeader = _ref.getResponseHeader,
      isHttp = _ref.isHttp,
      rangeChunkSize = _ref.rangeChunkSize,
      disableRange = _ref.disableRange;

  (0, _util.assert)(rangeChunkSize > 0, 'Range chunk size must be larger than zero');
  var returnValues = {
    allowRangeRequests: false,
    suggestedLength: undefined
  };
  if (disableRange || !isHttp) {
    return returnValues;
  }
  if (getResponseHeader('Accept-Ranges') !== 'bytes') {
    return returnValues;
  }
  var contentEncoding = getResponseHeader('Content-Encoding') || 'identity';
  if (contentEncoding !== 'identity') {
    return returnValues;
  }
  var length = parseInt(getResponseHeader('Content-Length'), 10);
  if (!Number.isInteger(length)) {
    return returnValues;
  }
  returnValues.suggestedLength = length;
  if (length <= 2 * rangeChunkSize) {
    return returnValues;
  }
  returnValues.allowRangeRequests = true;
  return returnValues;
}
function extractFilenameFromHeader(getResponseHeader) {
  var contentDisposition = getResponseHeader('Content-Disposition');
  if (contentDisposition) {
    var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
    if (/\.pdf$/i.test(filename)) {
      return filename;
    }
  }
  return null;
}
function createResponseStatusError(status, url) {
  if (status === 404 || status === 0 && /^file:/.test(url)) {
    return new _util.MissingPDFException('Missing PDF "' + url + '".');
  }
  return new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
}
function validateResponseStatus(status) {
  return status === 200 || status === 206;
}
exports.createResponseStatusError = createResponseStatusError;
exports.extractFilenameFromHeader = extractFilenameFromHeader;
exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
exports.validateResponseStatus = validateResponseStatus;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2500);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./pdf-preview.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./pdf-preview.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2501);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./right-side-page-app-bar.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./right-side-page-app-bar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-user.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = __webpack_require__(10);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _button = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiaryUser = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryUser, _React$Component);

  function DiaryUser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DiaryUser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiaryUser.__proto__ || Object.getPrototypeOf(DiaryUser)).call.apply(_ref, [this].concat(args))), _this), _this.showUser = function () {
      return _this.props.showUser(_this.props.user.user_id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DiaryUser, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          theme = _props.theme,
          showUser = _props.showUser;


      return _react2.default.createElement(_button.Button, { neutral: false, ripple: false, theme: theme, className: 'user',
        label: user.name, onClick: this.showUser });
    }
  }]);

  return DiaryUser;
}(_react2.default.Component)) || _class);
exports.default = DiaryUser;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-likes.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactCssThemr = __webpack_require__(10);

var _reactI18next = __webpack_require__(2);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _button = __webpack_require__(8);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _font_icon = __webpack_require__(23);

var _emoji = __webpack_require__(187);

var _emoji2 = _interopRequireDefault(_emoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipButton = (0, _tooltip2.default)(_button.Button);

var DiaryLikes = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryLikes, _React$Component);

  function DiaryLikes() {
    _classCallCheck(this, DiaryLikes);

    return _possibleConstructorReturn(this, (DiaryLikes.__proto__ || Object.getPrototypeOf(DiaryLikes)).apply(this, arguments));
  }

  _createClass(DiaryLikes, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          likes = _props.likes,
          user = _props.user,
          likes_count = _props.likes_count,
          myself = _props.myself,
          theme = _props.theme,
          showReaders = _props.showReaders,
          comment_id = _props.comment_id,
          likeConfig = _props.likeConfig;

      //issues/5432

      var count = typeof likes_count != 'undefined' ? likes_count : likes.length;

      /* 同じlike_typeが配列内にある場合は除外する */
      var likesArray = likes && likes.reduce(function (prev, current) {
        if (!prev.some(function (e) {
          return e.like_type === current.like_type;
        })) {
          prev.push(current);
        }
        return prev;
      }, []);

      if (!likes || likes.length == 0) return null;

      var tooltip = likes.map(function (like) {
        return _react2.default.createElement(
          'div',
          { key: like.like_id },
          _react2.default.createElement(_avatar2.default, { image: like.user.icon_image.thumb_url, theme: theme }),
          '\xA0',
          like.user.name,
          ' \xA0',
          _react2.default.createElement('img', { style: { height: 16, width: 16 }, src: likeConfig && _emoji2.default[likeConfig[like.like_type].icon.replace('\\u', '')] })
        );
      });

      if (likes_count && likes_count > likes.length) tooltip.push(_react2.default.createElement(
        'div',
        { key: 'count' },
        '...',
        t('label:他n人', { n: likes_count - likes.length })
      ));

      return _react2.default.createElement(
        TooltipButton,
        { neutral: false, ripple: false,
          theme: theme,
          className: 'touchable',
          tooltipPosition: 'vertical',
          tooltip: tooltip,
          onClick: function onClick() {
            return comment_id ? showReaders({ comment_id: comment_id, types: 'likes' }) : showReaders({ types: 'likes' });
          } },
        likesArray.length > 3 ? likesArray.slice(likesArray.length - 3, likesArray.length).map(function (like) {
          return _react2.default.createElement('img', { style: { height: 16, width: 16 }, src: likeConfig && _emoji2.default[likeConfig[like.like_type].icon.replace('\\u', '')] });
        }) : likesArray.slice(0, 3).map(function (like) {
          return _react2.default.createElement('img', { style: { height: 16, width: 16 }, src: likeConfig && _emoji2.default[likeConfig[like.like_type].icon.replace('\\u', '')] });
        }),
        '\xA0',
        count && t('label:n', { n: count })
      );
    }
  }]);

  return DiaryLikes;
}(_react2.default.Component)) || _class);
exports.default = (0, _reactI18next.translate)()(DiaryLikes);

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-mentions-to.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = __webpack_require__(10);

var _reactI18next = __webpack_require__(2);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _button = __webpack_require__(8);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _font_icon = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipButton = (0, _tooltip2.default)(_button.Button);

var DiaryMentionsTo = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryMentionsTo, _React$Component);

  function DiaryMentionsTo() {
    _classCallCheck(this, DiaryMentionsTo);

    return _possibleConstructorReturn(this, (DiaryMentionsTo.__proto__ || Object.getPrototypeOf(DiaryMentionsTo)).apply(this, arguments));
  }

  _createClass(DiaryMentionsTo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          mentions = _props.mentions,
          reply_requested = _props.reply_requested,
          showReaders = _props.showReaders,
          theme = _props.theme,
          comment_id = _props.comment_id;


      if (!mentions || mentions.length == 0) return null;

      var tooltip = mentions.map(function (mention) {
        return _react2.default.createElement(
          'div',
          { key: mention.user_id },
          _react2.default.createElement(_avatar2.default, { key: mention.user_id, image: mention.icon_image.thumb_url, theme: theme }),
          '\xA0',
          mention.name,
          '\xA0',
          mention.delivered_at && _react2.default.createElement(_font_icon.FontIcon, { value: 'check', style: { color: 'green', fontSize: '12px', lineHeight: '10x' } })
        );
      });

      return _react2.default.createElement(
        TooltipButton,
        { neutral: false, ripple: false,
          theme: theme,
          className: 'touchable',
          onClick: function onClick() {
            return comment_id ? showReaders({ comment_id: comment_id, types: 'mentions' }) : showReaders({ types: 'mentions' });
          },
          tooltipPosition: 'vertical',
          tooltip: tooltip },
        mentions.slice(0, 3).map(function (mention) {
          return _react2.default.createElement(_avatar2.default, { key: mention.user_id, image: mention.icon_image.thumb_url, theme: theme });
        }),
        '\xA0',
        mentions.length > 3 && t('label:他n人', { n: mentions.length - 3 }),
        t('label:に読んでみて'),
        ' \xA0',
        reply_requested && t('label:返信要求付き')
      );
    }
  }]);

  return DiaryMentionsTo;
}(_react2.default.Component)) || _class);
exports.default = (0, _reactI18next.translate)()(DiaryMentionsTo);

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-actions.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = __webpack_require__(10);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactI18next = __webpack_require__(2);

var _diaryActions = __webpack_require__(2513);

var _diaryActions2 = _interopRequireDefault(_diaryActions);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _diaryLike = __webpack_require__(2514);

var _diaryLike2 = _interopRequireDefault(_diaryLike);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _button = __webpack_require__(8);

var _card = __webpack_require__(28);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _debounce = __webpack_require__(1047);

var _debounce2 = _interopRequireDefault(_debounce);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _emoji = __webpack_require__(187);

var _emoji2 = _interopRequireDefault(_emoji);

var _diaryFormButton = __webpack_require__(290);

var _diaryFormButton2 = _interopRequireDefault(_diaryFormButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipButton = (0, _tooltip2.default)(_button.Button);

var buttonStyle = {
  minWidth: '0',
  padding: '0 8px',
  height: '36px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto'
};

var iconStyle = {
  marginRight: '4px',
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center'
};

var DiaryActions = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryActions, _React$Component);

  function DiaryActions(props) {
    _classCallCheck(this, DiaryActions);

    var _this = _possibleConstructorReturn(this, (DiaryActions.__proto__ || Object.getPrototypeOf(DiaryActions)).call(this, props));

    _this.changeWindowDisplay = function () {
      if (_this._isMounted && _this.containerRef.current) {
        _this.props.updateUI({ innerWidth: _this.containerRef.current.clientWidth });
      }
    };

    _this.reactionMouseOver = function () {
      if (_this.props.ui.timer) {
        _this.props.updateUI({ timer: false });
        clearTimeout(_this.setMouseOutTimer);
      } else {
        _this.setMouseOverTimer = setTimeout(function () {
          return _this.props.updateUI({ reactionFocus: true });
        }, 500);
      }
    };

    _this.reactionMouseOut = function (e) {
      if (!_this._isMounted) return;

      var likeFieldOut = _this.likeFieldRef.current;
      var reactionFieldOut = _this.reactionFieldRef.current;

      /* 一定時間、いいねボタンとリアクションボタン上にマウスが当たっていない場合はsetTimeOutでリアクションボタンを非表示にする*/
      if (reactionFieldOut != null && likeFieldOut && !likeFieldOut.contains(e.relatedTarget) && !reactionFieldOut.contains(e.relatedTarget)) {
        _this.props.updateUI({ timer: true });
        _this.setMouseOutTimer = setTimeout(function () {
          if (_this._isMounted && _this.props.ui.timer) {
            _this.props.updateUI({ reactionFocus: false, timer: false });
          }
        }, 800);
      } else {
        /* いいねボタンにマウスが当たってすぐに要素を抜けるとreactionFieldOutがnullで返ってくるため、nullの場合はMounceOverで設定したSetTimeOutを無効にする */
        clearTimeout(_this.setMouseOverTimer);
      }
    };

    _this.onClick = function (like_type) {
      _this.props.onReaction(like_type);
      _this.props.updateUI({ reactionFocus: false });
    };

    _this.onLike = function () {
      if (!_this.props.ui.disableLike) {
        _this.props.updateUI({ disableLike: true });
        _this.props.onLike();
        setTimeout(function () {
          return _this.props.updateUI({ disableLike: false });
        }, 1000);
      }
      /* reactionFocusがtrue状態でいいねボタンを押下した場合はfalseにしてreactionFieldを非表示にする */
      _this.props.ui.reactionFocus && _this.props.updateUI({ reactionFocus: false });
    };

    _this.changeWindowDisplay = _this.changeWindowDisplay.bind(_this);
    // issues/5434への対応コードを改善
    _this.debounce = (0, _debounce2.default)(_this.changeWindowDisplay, 200, {
      leading: false, // 最初のイベントをスキップ
      trailing: true, // 最後のイベントを実行
      maxWait: 1000
    });
    // Refs for DOM elements
    _this.containerRef = _react2.default.createRef();
    _this.likeFieldRef = _react2.default.createRef();
    _this.reactionFieldRef = _react2.default.createRef();
    // Track mounted state
    _this._isMounted = false;
    return _this;
  }

  _createClass(DiaryActions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this._isMounted = true;
      // issues/5434への対応コードを改善
      // RAF内でDOM操作を行い、レイアウトスラッシングを防ぐ
      requestAnimationFrame(function () {
        if (_this2._isMounted && _this2.containerRef.current) {
          _this2.props.updateUI({ innerWidth: _this2.containerRef.current.clientWidth });
        }
      });
      window.addEventListener('resize', this.debounce);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      // issues/5434への対応コードを改善
      if (this.debounce) {
        this.debounce.cancel(); // debounceのキャンセル
        window.removeEventListener('resize', this.debounce);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          like = _props.like,
          onLike = _props.onLike,
          onReaction = _props.onReaction,
          onComment = _props.onComment,
          onStamp = _props.onStamp,
          theme = _props.theme,
          isComment = _props.isComment,
          likeConfig = _props.likeConfig,
          onOpenReview = _props.onOpenReview,
          isFetching = _props.isFetching,
          isReviewEnable = _props.isReviewEnable,
          _props$isReviewButton = _props.isReviewButtonDisplay,
          isReviewButtonDisplay = _props$isReviewButton === undefined ? true : _props$isReviewButton;


      return _react2.default.createElement(
        'div',
        { ref: this.containerRef, style: { position: 'relative' } },
        !isComment && _react2.default.createElement(
          _card.CardText,
          { theme: theme, className: 'actions' },
          _react2.default.createElement(
            'div',
            { ref: this.likeFieldRef, onMouseOver: (!this.props.ui.reactionFocus || this.props.ui.timer) && this.reactionMouseOver, onMouseOut: this.reactionMouseOut },
            this.props.ui.reactionFocus && _react2.default.createElement(
              'div',
              { ref: this.reactionFieldRef, theme: theme, className: 'reactionField' },
              likeConfig && (0, _map2.default)(likeConfig, function (item, type) {
                return _react2.default.createElement(TooltipButton, { theme: _diaryLike2.default, className: 'reaction', neutral: false, ripple: false,
                  tooltipPosition: 'top',
                  tooltip: item.label,
                  icon: _react2.default.createElement('img', { className: _this3.props.ui.innerWidth >= 500 ? _diaryLike2.default.image : _diaryLike2.default.minImage, src: _emoji2.default[item.icon.replace('\\u', '')] }),
                  onClick: function onClick() {
                    return _this3.onClick(type);
                  } });
              })
            ),
            _react2.default.createElement(_button.Button, {
              theme: theme,
              className: 'diary',
              neutral: false,
              icon: like ? _react2.default.createElement('img', {
                src: likeConfig && _emoji2.default[likeConfig[like.like_type].icon.replace('\\u', '')],
                style: iconStyle
              }) : _react2.default.createElement(_font_icon2.default, { value: 'favorite_border', style: _extends({}, iconStyle, { color: 'gray' }) }),
              onClick: this.onLike,
              style: _extends({}, buttonStyle, { color: like && 'red' || 'gray' }),
              label: like ? likeConfig && likeConfig[like.like_type].label : t('label:いいね')
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center' } },
            _react2.default.createElement(_button.Button, {
              theme: theme,
              className: 'diary',
              neutral: false,
              icon: _react2.default.createElement(_font_icon2.default, { value: 'comment', style: _extends({}, iconStyle, { color: 'blue' }) }),
              onClick: onComment,
              style: buttonStyle,
              label: t('label:コメント')
            }),
            _react2.default.createElement(_button.Button, {
              theme: theme,
              className: 'diary',
              neutral: false,
              icon: _react2.default.createElement(_font_icon2.default, { value: 'tag_faces', style: _extends({}, iconStyle, { color: 'orange' }) }),
              onClick: onStamp,
              style: buttonStyle,
              label: t('label:スタンプ')
            }),
            !isComment && isReviewEnable && isReviewButtonDisplay && _react2.default.createElement(_button.Button, {
              disabled: isFetching,
              theme: theme,
              className: 'diary',
              neutral: false,
              icon: _react2.default.createElement(_font_icon2.default, { value: 'auto_awesome', style: _extends({}, iconStyle, { color: 'purple' }) }),
              onClick: onOpenReview,
              style: buttonStyle,
              label: isFetching ? 'AIレビュー(処理中...)' : 'AIレビュー'
            })
          )
        ),
        isComment && _react2.default.createElement(
          _card.CardText,
          { theme: theme, className: 'subactions' },
          _react2.default.createElement(
            'div',
            { ref: this.likeFieldRef, onMouseOver: (!this.props.ui.reactionFocus || this.props.ui.timer) && this.reactionMouseOver, onMouseOut: this.reactionMouseOut },
            this.props.ui.reactionFocus && _react2.default.createElement(
              'div',
              { ref: this.reactionFieldRef, theme: theme, className: 'reactionCommentField' },
              likeConfig && (0, _map2.default)(likeConfig, function (item, type) {
                return _react2.default.createElement(TooltipButton, { theme: _diaryLike2.default, className: _this3.props.ui.innerWidth >= 500 ? "reaction" : "ShrinkReaction", neutral: false, ripple: false,
                  tooltipPosition: 'top',
                  tooltip: item.label,
                  icon: _react2.default.createElement('img', { className: _this3.props.ui.innerWidth >= 500 ? _diaryLike2.default.image : _diaryLike2.default.minImage, src: _emoji2.default[item.icon.replace('\\u', '')] }),
                  onClick: function onClick() {
                    return _this3.onClick(type);
                  } });
              })
            ),
            _react2.default.createElement(_button.Button, { theme: theme, className: 'comment', neutral: false,
              onClick: this.onLike,
              style: { color: like && 'red' || 'gray' },
              label: like ? likeConfig && likeConfig[like.like_type].label : t('label:いいね') })
          ),
          _react2.default.createElement(_button.Button, { theme: theme, className: 'comment', neutral: false,
            onClick: onComment,
            label: t('label:返信') }),
          _react2.default.createElement(_button.Button, { theme: theme, className: 'comment', neutral: false,
            onClick: onStamp,
            label: t('label:スタンプ') })
        )
      );
    }
  }]);

  return DiaryActions;
}(_react2.default.Component)) || _class);
exports.default = (0, _diaryActions2.default)(DiaryActions);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2525);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary-kpi.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary-kpi.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// src/assets/google-icons.js

var GoogleIcons = {
  'application/vnd.google-apps.document': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABFklEQVRYw2NgGAUDDBhxSeTMemnFwcXrysjISJRBAlwMD6oDOReS6gAWXBIffvNs+/b6Pz8Dw3+iDNKUZmJYevSnYrQ1ewNVHPDtFwM/GSFav/ToTwZSHMFCg2glyREsNEpbRDuChYYJnChHUM8B//+T5QiqOeDlp/8Mqn/+M7CyYGTb+kWHf/yPs+VoJKkcCOr/+p+a8bGukJuR3mmAYSBzAfUdoC3DxKAtw0yU2qtP/jJcffKP2g5gZgi3YCVK7coTDNR3wKoTvxlWnfg9GgWjUTAaBYM3CkgJdppEASnBPjSjgO6V0e8fnz+zcvDyUsOS3z8+fybZASfmRcQJK1l5MOJptBDVUmNg+P/u/vEdo33AQQsA1eqFWE3bpWAAAAAASUVORK5CYII=',
  'application/vnd.google-apps.spreadsheet': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADuklEQVR42s2X70sUQRjHn8W00npjUIaWnEFwqUG9qDtfRBS9KDXMn6emvggiNe+EenN/QHFEphlmllpaekVmeWoQJFRgGVRQVC8if0T3RlF8U2TentPs7O7s7O2ujgjVcLvzzMw638/zY/ZOAf5xE/5LgHX+8hjcleMrERDgD7nhC+lseazYuMVGxYBtfULwTc6FtpUC+HHnohNIFrUCQQqAZDs32cEev8XX5DjhXQFAhSgIEIUYcSKves7aSLFBtp0JdnJhKN/53a4lIcwB7lYgdYHd3BIANFsFUJrv3K4i7/IB/OUIBEEXflnUKgVMBHAKnJvt7HaLQlgDsE0nYlEDyroJAPz6Pee75Kjw8gN0lyFtKaIAI2pBdlxbc2CAjAgAqU1OT/laD9V4uQDiusoQyYC6LyNuPA1a/qXBwrwIaGIWYD4MaGEBTyh1gk2xaVjgBDiupQAxRoS4rG2sESRBjM+SnjyHxREG4Qe4U0pTkLt1D+Qm7zU+RAHMdkAQnhOh7UkPDI2/o3UiXuEFuF1Kt62xH4bE2Hjo/faabt61rxZKnjdo6joYOQp5NicEZyehPtCJIxEm82IjJ0BsZwkFcO84QvrGz4+p0Nf8Jth2v8qkLjTbk5ZNxg1vH8KCUhPLACimKXBLEYjbAL0TI9TL7v04As/q9aeCqRPplmfLgOCPaWj4ECARkApTrHvBCdBRrItAbrIDgj9n6Lpj43YYmfpiyDsw9ZCEoXvGhjFAv1wDGCLkDvABrL3lYgAylRQMUu9GC5sh5V4lLHY8PenZZF4FkK75ykecADeLtBSkZpKNGj8NUkdHiySAU+biSu9JzyKPN7wP0PUQN0A7BhC0CJCKNk2BPuyUUE3B6EtSA+qrPFTFCbCmvZBu60nNIkX4YPwVFfAfOAPFQ3V0TItQMyA/RSrCGRyBPvq2DFX1cQK0FSgpkI6THMrLHweot2PFLWDzn9S8Z9+Kyrh251HS1ysRkJ4NVfMCtBZoEUgzicDBs+B6elELueEYAonAd+kY4gioUKFqzlOw+kY+3TIvxQn5+EwbG7KeUr6kekaHyaV+Y4qnuQHykOXmVAOxA+YZ/Q9V+nWNGz/AdRMAxjM9FCPEHsUIcelvxZp+PoCYllxzgEiPDV5TEjA7HfwA144tAaAZOmEWSAejRMA9wA2Af0lAlF5MGyDd0ExYHwnlEw67B1ZxAUQ353SA/J+RpedLp8CQhs6wZ7CCD+BqTrQCkGSirhuiiAjo5jXxIL5LACEugL/Z/jnAH0wFsT8uD5uEAAAAAElFTkSuQmCC',
  'default': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAG7ElEQVR42sVXaXAURRR+3T0zu8mGBJYr4cZABQKJQARLEYgHYBIpBAoQBC0vUPAoFKVARcKhQFmIqFQJ+gMopcDCApVDUREKDzQcAQlQQIhAiAEkELJJNjsz7euentnlFBDLqep9nWxPf9/73tG9BP7nh1zrwlZtApCk8StscOk2uw+Fbh4B0qUFDJrY9fklLU/eTQmJvopzoqz8T3S3zWNmHZy/bF35TSCgM9Dz89JIMH73mhZlrHdiHZNvEYqAcuJYEqMFh7ryM3WZGcN/PVAZsv4dAe2BDGADMzYgTP8OkSprc+fTVEMZiEtAWKkCxKjAgXP4esHyY/e/8u6hGydAggHwzRgwkBhstZQ7VAezmp+zxqbUMELphSrEknAoQCRiP9h91LY1+46EboyA75nefprVai8uukUChE1IMuvsbV3OQiMDqCDhyh9LQLivJsXfbvurU+6z22uvmwDrmAz+l/u+htMZRHlILBt4VRhGNQlb76RWM1AEvHB4MUAC3JZEOOevD3tl18zVm8qvgwAlED99QEvavP4+3DhA1VIiHKsMA8Vd12Wet7vWs5kDTp2i8FTgThBsQcIOHSmt7pg5bOux2rB9bQSMfh3BN7L7CgQfRojrvwJABcDkkJVgWl9mhCg+xFHBUUJJjwPVQhW4bQkiK6d/eGj4zI8O/zMBkuiHhDmDsknA+F7lOsSSgBpT5oLAmJ9aaw1ramJCRsPgRsIBN6UF2+LVNeY9GUO3/nD0z9qrE4h74k6m9Wm/Ex3LEODUBReW4/II1nUoIl9M1u2Kn7NCVKckyVNBVIeMfSwBUyixZ9V35V1HTN5tXZEAa9sQAtPyngNGFwhg5m4K1AsBEWE8Vyv/9hF4saBbCJIMPi/qfTQJObecYavB7edzxu94b1NBxeUJxE/NbczaNz6A3jdAXTHJFbjILa6UEOE9j4loQVFtQUmX/KaVfOzQtoX4VTrx4g9ODsgkVCQsaSuKiqvSuo/+9ZRlXURAuysV/GN6LsJ4PiXAGaOO/G4IuEpEEYbqCKdVdf3Lpq7amIjy7v8i575gEvvG2Y/HlKFKRCQAjgJCicUvzz805v2VpTEE/Dr45w7MYvXjtzFKmfAcPxwFCPWAhfdUWJN/fv6TX4acW18oXx8zNBXmTcxcpWl8MJURcKrADYMXDqmIaZ2tjNye+VDB9lNnTYeANrwb0XPSf8SSuoNRkXixCsQQAEmgBsqr0k+8tLwE93LaBr6zfmGvNumpgSI8u+J8BgGfjjlF+WVUkER+XvLVnz3HzSnmhKQk4mmX+wjV2RLHawQXJMTcLS0Ve2HxKMyvmLthWvWOkguqp0fnIHz2dvdphNhvqA6ITnDwaZisOgeNRRNTELFt+9Hsp/cuJdqEu+vRzikH0NuUC8CVEjSmBFGBErOwNP307LU1l2tgCyZlxg3MbrIPgVo7J6LjvQAmGBJDF4Q4Wtlsy34rqkojxuIRkxBhtgChTMlPiSe/2wdEj0ss7bE0UNJuIwlzSZBpOmj++tw9B+J8FPq1Kejf0n94pFDA5k4loLeyDKWVCYpEdIGnTSbatJx2pHn93zH7fQLMkZ54Q5IQeXqutdVk/2DKGNYI5ocAN+KCaDVwLyUi92z8sGwxbLAstFhvpinmJg4kw73DMmxWlnQmJK0JaBPvfRPfnyxVIK78zqayG3LGk/eMsn3hxoxqDDTNACMQxLjqqlJUB1AEbEQxEcyUJHBgsppIxBJEbO9e+Vbp2ienyDfZ2J4BPPf340YtCI313iGQWJZlBY9lM3QfNMOvwDWvUpyGJaIMUmaPgDcsSUIOh8Dx0NEtHY6vGRFyqAfjQZueN4IY2qckBlwMLRKwmxU+BjrEUc2IB12BayJfRCgI9ZJWxF3I7nrugpuuCqbKAysysmR53+V1FQejnZDmdcK7X+ZmnPaWda+INCzOsRJOd2K6LwGM+AYgQyCAqdMrpFXlKwi4Xosc8BQQnisVkMCWMzsX9Tm1Nf+iswA7iJafeytplFAgepM8bKqaWclFD1NmJBAjLhEBGSYduwDYBfeS0FbgioCrhOWQMCNV5bcdWdar0K47f+lhJO7/2rheH+B0nKiX5L2j7fhIe8ZQehF/CSwtU+DRqpEnllcFTrK5BKT3OGzLWnhi44TxlftWXPk+wF7IDtJOKQcCJzMbNC4dilkfJ/emSnLqEYg2LLdbymNIVUFsGUpVLOt0ddn2tD9W5J256oUEkhPBN2XI480PT3hVtxtSbyGuFMCCgAT2KkAd1+CEQDQaQcAlIatCem/OLFmR93Ft+a6r34hkOrRqD4bWRvW/mMXeLyHwat+7Dcc8LhHwLJIJV0L18Z8uWXvNP07/q+d/J/A36uZuVWgBkLoAAAAASUVORK5CYII='
};

exports.default = GoogleIcons;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDiaryAttachments = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-attachments.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactCssThemr = __webpack_require__(10);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _diaryAttachments = __webpack_require__(2531);

var _diaryAttachments2 = _interopRequireDefault(_diaryAttachments);

var _button = __webpack_require__(8);

var _card = __webpack_require__(28);

var _attachments = __webpack_require__(567);

var _attachments2 = _interopRequireDefault(_attachments);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _attachmentFile = __webpack_require__(1052);

var _attachmentFile2 = _interopRequireDefault(_attachmentFile);

var _videoViewer = __webpack_require__(353);

var _videoViewer2 = _interopRequireDefault(_videoViewer);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _font_icon = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isImageVideo(file) {
  return file.content_type.match(/^image/) || file.content_type.match(/^video|audio/);
}

var DiaryAttachments = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryAttachments, _React$Component);

  function DiaryAttachments() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DiaryAttachments);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiaryAttachments.__proto__ || Object.getPrototypeOf(DiaryAttachments)).call.apply(_ref, [this].concat(args))), _this), _this.showImagesView = function (image) {
      _this.props.showImagesView(_this.props.comment ? 'GROUP_COMMENT' : 'GROUP_TIMELINE', _this.props.comment ? _this.props.comment_id : _this.props.diary_id, image);
    }, _this.showPrevImage = function (images) {
      if (_this.props.ui.imgIndex > 0) {
        var index = _this.props.ui.imgIndex - 1;
        _this.props.updateUI({
          imgIndex: index,
          isVideo: !!images[index].content_type.match(/^video|audio/)
        });
      }
    }, _this.showNextImage = function (images) {
      if (images.length - 1 > _this.props.ui.imgIndex) {
        var index = _this.props.ui.imgIndex + 1;
        _this.props.updateUI({
          imgIndex: index,
          isVideo: !!images[index].content_type.match(/^video|audio/)
        });
      }
    }, _this.selectDots = function (images, index) {
      _this.props.updateUI({
        imgIndex: index,
        isVideo: !!images[index].content_type.match(/^video|audio/)
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DiaryAttachments, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          diary_id = _props.diary_id,
          comment_id = _props.comment_id,
          files = _props.files,
          theme = _props.theme,
          showAttachments = _props.showAttachments,
          showImagesView = _props.showImagesView,
          comment = _props.comment;


      var images = _lodash2.default.filter(files, function (file) {
        return isImageVideo(file);
      });
      var otherfiles = _lodash2.default.filter(files, function (file) {
        return !isImageVideo(file);
      });

      var left_btn = ui && ui.imgIndex == 0 ? true : false;
      var right_btn = ui && ui.imgIndex + 1 == images.length ? true : false;

      return _react2.default.createElement(
        'div',
        null,
        images.length > 0 && ui && images[ui.imgIndex] && _react2.default.createElement(
          'nav',
          { className: _attachments2.default.nav },
          _react2.default.createElement(
            'div',
            { className: !comment ? _attachments2.default.navAttachmentsArea : _attachments2.default.navAttachmentsCommentArea },
            _react2.default.createElement(
              'div',
              { className: _attachments2.default.navAttachmentsField },
              !images[ui.imgIndex].content_type.match(/^video|audio/) ? _react2.default.createElement(
                'div',
                { style: { height: 280, position: "relative" } },
                _react2.default.createElement('img', { src: images[ui.imgIndex].file.url, className: _attachments2.default.navImage, style: { marginBottom: images.length > 1 ? 0 : 20 }, onClick: function onClick() {
                    return _this2.showImagesView(images[ui.imgIndex]);
                  } })
              ) : images[ui.imgIndex].status == 'committed' ? _react2.default.createElement(_videoViewer2.default, { video: images[ui.imgIndex], t: t, parent_component: 'TIMELINE_PAGE' }) : _react2.default.createElement(
                'div',
                { style: { height: 280, position: "relative" } },
                images[ui.imgIndex].status == 'prepared' ? _react2.default.createElement(
                  'div',
                  { style: { position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, margin: 'auto', width: '90%', height: '3.2rem' } },
                  _react2.default.createElement(_progress_bar2.default, { type: 'circular', mode: 'indeterminate', multicolor: true }),
                  _react2.default.createElement(
                    'p',
                    { style: { fontSize: 16 } },
                    t('label:ファイルはまだ処理中')
                  )
                ) : _react2.default.createElement(
                  'div',
                  { style: { position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, margin: 'auto', width: '90%', height: '3.2rem' } },
                  _react2.default.createElement(_font_icon.FontIcon, { value: 'close', style: { fontSize: 40, color: 'red' } }),
                  _react2.default.createElement(
                    'p',
                    { style: { fontSize: 16 } },
                    t('label:ファイルが読み込めない')
                  )
                )
              ),
              images.length > 1 && _react2.default.createElement(
                'div',
                { style: { display: 'flex' } },
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)(_attachments2.default.navArea, _attachments2.default.navPrev), onClick: function onClick() {
                      return _this2.showPrevImage(images);
                    } },
                  _react2.default.createElement(_button.IconButton, { icon: 'keyboard_arrow_left', disabled: left_btn })
                ),
                _react2.default.createElement(
                  'ul',
                  { className: _attachments2.default.navDots },
                  images.map(function (image, i) {
                    return _react2.default.createElement(
                      'li',
                      { key: i, style: { display: 'inline-block' } },
                      _react2.default.createElement(_button.IconButton, { icon: 'circle',
                        onClick: function onClick() {
                          return _this2.selectDots(images, i);
                        },
                        className: ui.imgIndex == i ? _attachments2.default.navSelectDots : _attachments2.default.navNotSelectDots })
                    );
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)(_attachments2.default.navArea, _attachments2.default.navNext), onClick: function onClick() {
                      return _this2.showNextImage(images);
                    } },
                  _react2.default.createElement(_button.IconButton, { icon: 'keyboard_arrow_right', disabled: right_btn })
                )
              )
            )
          )
        ),
        otherfiles.length > 0 && _react2.default.createElement(
          'div',
          { style: { marginLeft: 10 } },
          otherfiles.map(function (file) {
            return _react2.default.createElement(_attachmentFile2.default, { key: file.file_id || file.video_id, t: t, file: file, showAttachments: showAttachments, diary_id: diary_id, comment_id: comment_id });
          })
        )
      );
    }
  }]);

  return DiaryAttachments;
}(_react2.default.Component)) || _class);
var RawDiaryAttachments = exports.RawDiaryAttachments = DiaryAttachments;
exports.default = (0, _diaryAttachments2.default)(DiaryAttachments);

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2532);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./attachments.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./attachments.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDiaryCommentForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-comment-form.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _diaryCommentForm = __webpack_require__(2542);

var _diaryCommentForm2 = _interopRequireDefault(_diaryCommentForm);

var _reactCssThemr = __webpack_require__(10);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _button = __webpack_require__(8);

var _card = __webpack_require__(28);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _richTextEditor = __webpack_require__(181);

var _richTextEditor2 = _interopRequireDefault(_richTextEditor);

var _diaryUploadFiles = __webpack_require__(569);

var _diaryUploadFiles2 = _interopRequireDefault(_diaryUploadFiles);

var _fileUploadButton = __webpack_require__(180);

var _fileUploadButton2 = _interopRequireDefault(_fileUploadButton);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _store = __webpack_require__(18);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiaryCommentForm = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryCommentForm, _React$Component);

  function DiaryCommentForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DiaryCommentForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiaryCommentForm.__proto__ || Object.getPrototypeOf(DiaryCommentForm)).call.apply(_ref, [this].concat(args))), _this), _this.showUserSelectionDialog = function () {
      return _this.props.showUserSelectionDialog(_this.props.t('label:読んでみての宛先を追加'), true,
      // すべての投稿から開いた時にはgroup.membersは存在しないため、MENTION_TO_USERSを渡す。github pull/5755#issuecomment-1264972956
      _this.props.group && _this.props.group.members ? 'GROUP_MEMBERS_MENTION' : 'MENTION_TO_USERS', _this.props.group && _this.props.group, _this.props.ui.mentions, function (users) {
        return _this.props.updateUI({
          mentions: (0, _store.mergeArray)('user_id', [], users)
        });
      });
    }, _this.onEditorInitialized = function (handlers) {
      return _this.props.updateUI({ handlers: handlers });
    }, _this.submitComment = function () {
      return _this.props.submitComment(_this.props);
    }, _this.toggleReplyRequested = function () {
      return _this.props.updateUI({ reply_requested: !_this.props.ui.reply_requested });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DiaryCommentForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          theme = _props.theme,
          diary = _props.diary,
          group = _props.group,
          user = _props.user,
          isPosting = _props.isPosting,
          isPostFailed = _props.isPostFailed,
          isUploading = _props.isUploading,
          onClose = _props.onClose,
          submitComment = _props.submitComment,
          uploadFiles = _props.uploadFiles,
          uploadedFiles = _props.uploadedFiles,
          uploadedVideos = _props.uploadedVideos,
          updateUI = _props.updateUI,
          componentId = _props.componentId,
          showUserSelectionDialog = _props.showUserSelectionDialog,
          parent = _props.parent;


      var isChild = parent.diary_id ? false : true;

      return _react2.default.createElement(
        _card.CardText,
        { theme: theme, className: isChild ? "replyCommentForm" : "diaryCommentForm" },
        _react2.default.createElement(_avatar2.default, { theme: theme, className: 'avatar', image: user.icon_image.thumb_url }),
        _react2.default.createElement(
          _card.Card,
          { theme: theme, className: isChild ? "replyCommentForm" : "diaryCommentForm" },
          _react2.default.createElement(
            'div',
            { style: { padding: '5px' } },
            _react2.default.createElement(_button.Button, { theme: _successButton2.default,
              raised: !(ui.mentions && ui.mentions.length > 0),
              floating: ui.mentions && ui.mentions.length > 0,
              mini: ui.mentions && ui.mentions.length > 0,
              onClick: this.showUserSelectionDialog,
              icon: 'person_add',
              label: !(ui.mentions && ui.mentions.length > 0) && t('label:読んでみての宛先を追加'),
              style: { verticalAlign: 'top', marginRight: '10px' } }),
            ui.mentions && _lodash2.default.map(ui.mentions.slice(0, 10), function (mention, i) {
              return _react2.default.createElement(_avatar2.default, { image: mention.icon_image.thumb_url, style: { marginLeft: 2 } });
            }),
            ui.mentions && ui.mentions.length > 10 && _react2.default.createElement(_button.Button, {
              primary: true,
              onClick: this.showUserSelectionDialog,
              icon: 'arrow_forward',
              label: t('label:他n人', { n: ui.mentions.length - 10 }) + 'を' + t('label:すべて表示') }),
            ui.mentions && ui.mentions.length > 0 && _react2.default.createElement(
              'div',
              { style: { marginTop: '10px', marginLeft: '10px' } },
              _react2.default.createElement(_checkbox2.default, { checked: ui.reply_requested, label: t('label:返信を要求'), onChange: this.toggleReplyRequested })
            )
          ),
          _react2.default.createElement(_richTextEditor2.default, { compact: true, hasFocus: true,
            onDrop: uploadFiles,
            onEditorInitialized: this.onEditorInitialized,
            placeholder: t('label:コメントを入力してください') }),
          _react2.default.createElement(_diaryUploadFiles2.default, { componentId: componentId }),
          _react2.default.createElement(
            _card.CardActions,
            { theme: theme },
            _react2.default.createElement(_button.Button, { raised: true, primary: true,
              disabled: isPosting || isUploading,
              icon: 'send',
              onClick: this.submitComment,
              label: t('label:返信') }),
            _react2.default.createElement(_fileUploadButton2.default, { raised: true,
              icon: 'add_a_photo',
              onChange: uploadFiles,
              label: t('label:添付') }),
            _react2.default.createElement(_button.Button, {
              style: { marginLeft: 'auto' },
              icon: 'close',
              onClick: onClose,
              label: t('label:取り消し') })
          )
        )
      );
    }
  }]);

  return DiaryCommentForm;
}(_react2.default.Component)) || _class);
var RawDiaryCommentForm = exports.RawDiaryCommentForm = DiaryCommentForm;
exports.default = (0, _diaryCommentForm2.default)(DiaryCommentForm);

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDiaryUploadFiles = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-upload-files.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _diaryUploadFiles = __webpack_require__(1056);

var _diaryUploadFiles2 = _interopRequireDefault(_diaryUploadFiles);

var _reactCssThemr = __webpack_require__(10);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _card = __webpack_require__(28);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _imageChip = __webpack_require__(1057);

var _imageChip2 = _interopRequireDefault(_imageChip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiaryUploadFiles = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryUploadFiles, _React$Component);

  function DiaryUploadFiles() {
    _classCallCheck(this, DiaryUploadFiles);

    return _possibleConstructorReturn(this, (DiaryUploadFiles.__proto__ || Object.getPrototypeOf(DiaryUploadFiles)).apply(this, arguments));
  }

  _createClass(DiaryUploadFiles, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          uploadFiles = _props.uploadFiles,
          uploadVideos = _props.uploadVideos,
          cancelUploadFile = _props.cancelUploadFile,
          cancelUploadVideo = _props.cancelUploadVideo,
          componentId = _props.componentId;


      if ((!uploadVideos || Object.keys(uploadVideos).length == 0 || _.filter(uploadVideos, function (value) {
        return value;
      }).length == 0) && (!uploadFiles || Object.keys(uploadFiles).length == 0 || _.filter(uploadFiles, function (value) {
        return value;
      }).length == 0)) return null;

      return _react2.default.createElement(
        _card.CardText,
        { theme: theme, className: 'uploads' },
        uploadVideos && Object.keys(uploadVideos).length > 0 && _.map(uploadVideos, function (video, key) {
          return video && _react2.default.createElement(
            _chip2.default,
            { key: key, deletable: true,
              onDeleteClick: function onDeleteClick() {
                return cancelUploadVideo(key);
              } },
            _react2.default.createElement(_avatar2.default, { icon: 'attachment' }),
            video.isUploading && _react2.default.createElement(_progress_bar2.default, { type: 'circular', theme: theme, multicolor: true,
              mode: video.total && "determinate" || "indeterminate",
              value: video.total && video.loaded && video.loaded * 100 / video.total }),
            video.item && video.item.name
          );
        }),
        uploadFiles && Object.keys(uploadFiles).length > 0 && _.map(uploadFiles, function (file, key) {
          if (!file) return null;
          var thumb_url = file.item && file.item.content_type && file.item.content_type.match(/image/) && file.item.file.thumb_url || undefined;
          return _react2.default.createElement(
            _chip2.default,
            { key: key, deletable: true, onDeleteClick: function onDeleteClick() {
                return cancelUploadFile(key);
              }, theme: thumb_url && _imageChip2.default },
            thumb_url && _react2.default.createElement('img', { className: _imageChip2.default.image, src: thumb_url }) || _react2.default.createElement(_avatar2.default, { icon: 'attachment' }),
            file.isUploading && _react2.default.createElement(_progress_bar2.default, { type: 'circular', theme: theme, multicolor: true,
              mode: file.total && "determinate" || "indeterminate",
              value: file.total && file.loaded && file.loaded * 100 / file.total }),
            file.item && file.item.name
          );
        })
      );
    }
  }]);

  return DiaryUploadFiles;
}(_react2.default.Component)) || _class);
var RawDiaryUploadFiles = exports.RawDiaryUploadFiles = DiaryUploadFiles;
exports.default = (0, _diaryUploadFiles2.default)(DiaryUploadFiles);

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2557);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary-forms-tab.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary-forms-tab.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _emptyFunction = __webpack_require__(207);

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _nativeRequestAnimationFrame = __webpack_require__(2634);

var _nativeRequestAnimationFrame2 = _interopRequireDefault(_nativeRequestAnimationFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule requestAnimationFramePolyfill
 */

var lastTime = 0;

/**
 * Here is the native and polyfill version of requestAnimationFrame.
 * Please don't use it directly and use requestAnimationFrame module instead.
 */
var requestAnimationFrame = _nativeRequestAnimationFrame2.default || function (callback) {
  var currTime = Date.now();
  var timeDelay = Math.max(0, 16 - (currTime - lastTime));
  lastTime = currTime + timeDelay;
  return global.setTimeout(function () {
    callback(Date.now());
  }, timeDelay);
};

// Works around a rare bug in Safari 6 where the first request is never invoked.
requestAnimationFrame(_emptyFunction2.default);

module.exports = requestAnimationFrame;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * This class listens to events on the document and then updates a react
 * component through callbacks.
 * Please note that captureMouseMove must be called in
 * order to initialize listeners on mousemove and mouseup.
 * releaseMouseMove must be called to remove them. It is important to
 * call releaseMouseMoves since mousemove is expensive to listen to.
 *
 * @providesModule DOMMouseMoveTracker
 * @typechecks
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EventListener = __webpack_require__(2637);

var _EventListener2 = _interopRequireDefault(_EventListener);

var _cancelAnimationFramePolyfill = __webpack_require__(2638);

var _cancelAnimationFramePolyfill2 = _interopRequireDefault(_cancelAnimationFramePolyfill);

var _requestAnimationFramePolyfill = __webpack_require__(571);

var _requestAnimationFramePolyfill2 = _interopRequireDefault(_requestAnimationFramePolyfill);

var _FixedDataTableEventHelper = __webpack_require__(573);

var _FixedDataTableEventHelper2 = _interopRequireDefault(_FixedDataTableEventHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DOMMouseMoveTracker = function () {
  /**
   * onMove is the callback that will be called on every mouse move.
   * onMoveEnd is called on mouse up when movement has ended.
   */
  function DOMMouseMoveTracker(
  /*function*/onMove,
  /*function*/onMoveEnd,
  /*DOMElement*/domNode,
  /*boolean*/touchEnabled) {
    _classCallCheck(this, DOMMouseMoveTracker);

    this._isDragging = false;
    this._isTouchEnabled = touchEnabled;
    this._animationFrameID = null;
    this._domNode = domNode;
    this._onMove = onMove;
    this._onMoveEnd = onMoveEnd;
    this._onMouseEnd = this._onMouseEnd.bind(this);
    this._onMouseMove = this._onMouseMove.bind(this);
    this._onMouseUp = this._onMouseUp.bind(this);
    this._didMouseMove = this._didMouseMove.bind(this);
  }

  /**
   * This is to set up the listeners for listening to mouse move
   * and mouse up signaling the movement has ended. Please note that these
   * listeners are added at the document.body level. It takes in an event
   * in order to grab inital state.
   */


  _createClass(DOMMouseMoveTracker, [{
    key: 'captureMouseMoves',
    value: function captureMouseMoves( /*object*/event) {
      if (!this._eventMoveToken && !this._eventUpToken && !this._eventLeaveToken && !this._eventOutToken) {
        this._eventMoveToken = _EventListener2.default.listen(this._domNode, 'mousemove', this._onMouseMove);
        this._eventUpToken = _EventListener2.default.listen(this._domNode, 'mouseup', this._onMouseUp);
        this._eventLeaveToken = _EventListener2.default.listen(this._domNode, 'mouseleave', this._onMouseEnd);
        this._eventOutToken = _EventListener2.default.listen(this._domNode, 'mouseout', this.onMouseEnd);
      }

      if (this._isTouchEnabled && !this._eventTouchStartToken && !this._eventTouchMoveToken && !this._eventTouchEndToken) {
        this._eventTouchStartToken = _EventListener2.default.listen(this._domNode, 'touchstart', this._onMouseMove);
        this._eventTouchMoveToken = _EventListener2.default.listen(this._domNode, 'touchmove', this._onMouseMove);
        this._eventTouchEndToken = _EventListener2.default.listen(this._domNode, 'touchend', this._onMouseUp);
      }

      if (!this._isDragging) {
        this._deltaX = 0;
        this._deltaY = 0;
        this._isDragging = true;
        var coordinates = _FixedDataTableEventHelper2.default.getCoordinatesFromEvent(event);
        var x = coordinates.x;
        var y = coordinates.y;
        this._x = x;
        this._y = y;
      }
      event.preventDefault();
    }

    /**
     * These releases all of the listeners on document.body.
     */

  }, {
    key: 'releaseMouseMoves',
    value: function releaseMouseMoves() {
      if (this._eventMoveToken && this._eventUpToken && this._eventLeaveToken && this._eventOutToken) {
        this._eventMoveToken.remove();
        this._eventMoveToken = null;
        this._eventUpToken.remove();
        this._eventUpToken = null;
        this._eventLeaveToken.remove();
        this._eventLeaveToken = null;
        this._eventOutToken.remove();
        this._eventOutToken = null;
      }

      if (this._isTouchEnabled && this._eventTouchStartToken && this._eventTouchMoveToken && this._eventTouchEndToken) {
        this._eventTouchStartToken.remove();
        this._eventTouchStartToken = null;
        this._eventTouchMoveToken.remove();
        this._eventTouchMoveToken = null;
        this._eventTouchEndToken.remove();
        this._eventTouchEndToken = null;
      }

      if (this._animationFrameID !== null) {
        (0, _cancelAnimationFramePolyfill2.default)(this._animationFrameID);
        this._animationFrameID = null;
      }

      if (this._isDragging) {
        this._isDragging = false;
        this._x = null;
        this._y = null;
      }
    }

    /**
     * Returns whether or not if the mouse movement is being tracked.
     */

  }, {
    key: 'isDragging',
    value: function isDragging() /*boolean*/{
      return this._isDragging;
    }

    /**
     * Calls onMove passed into constructor and updates internal state.
     */

  }, {
    key: '_onMouseMove',
    value: function _onMouseMove( /*object*/event) {
      var coordinates = _FixedDataTableEventHelper2.default.getCoordinatesFromEvent(event);
      var x = coordinates.x;
      var y = coordinates.y;

      this._deltaX += x - this._x;
      this._deltaY += y - this._y;

      if (this._animationFrameID === null) {
        // The mouse may move faster then the animation frame does.
        // Use `requestAnimationFramePolyfill` to avoid over-updating.
        this._animationFrameID = (0, _requestAnimationFramePolyfill2.default)(this._didMouseMove);
      }

      this._x = x;
      this._y = y;
      event.preventDefault();
    }
  }, {
    key: '_didMouseMove',
    value: function _didMouseMove() {
      this._animationFrameID = null;
      this._onMove(this._deltaX, this._deltaY);
      this._deltaX = 0;
      this._deltaY = 0;
    }

    /**
     * Calls onMoveEnd passed into constructor and updates internal state.
     */

  }, {
    key: '_onMouseUp',
    value: function _onMouseUp() {
      if (this._animationFrameID) {
        this._didMouseMove();
      }
      this._onMoveEnd(false);
    }

    /**
     * Calls onMoveEnd passed into the constructor, updates internal state, and cancels the move.
     */

  }, {
    key: '_onMouseEnd',
    value: function _onMouseEnd() {
      this._onMoveEnd(true);
    }
  }]);

  return DOMMouseMoveTracker;
}();

module.exports = DOMMouseMoveTracker;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FixedDataTableEventHelper
 * @typechecks
 */



/**
 * Gets the horizontal and vertical coordinates from a mouse or touch event.
 */

function getCoordinatesFromEvent( /*object*/event) /*object*/{
    var x = 0;
    var y = 0;

    if (!event.clientX || !event.clientY) {
        if (event.touches && event.touches.length > 0) {
            var touch = event.touches[0];
            x = touch.clientX;
            y = touch.clientY;
        }
    } else {
        x = event.clientX;
        y = event.clientY;
    }

    return { x: x, y: y };
}

var FixedDataTableEventHelper = {
    getCoordinatesFromEvent: getCoordinatesFromEvent
};

module.exports = FixedDataTableEventHelper;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Locale
 */



// Hard code this for now.

var Locale = {
  isRTL: function isRTL() {
    return false;
  },
  getDirection: function getDirection() {
    return 'LTR';
  }
};

module.exports = Locale;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2699);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./google-calendar-list.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./google-calendar-list.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Flex;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function toPercent(num) {
  return "".concat(num, "%");
}

function Flex(_ref) {
  var children = _ref.children,
      className = _ref.className,
      direction = _ref.direction,
      count = _ref.count,
      offset = _ref.offset,
      style = _ref.style,
      wrap = _ref.wrap,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "direction", "count", "offset", "style", "wrap"]);

  return _react["default"].createElement("div", _extends({
    className: className,
    style: _objectSpread({
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap ? 'wrap' : 'no-wrap'
    }, style)
  }, otherProps), _react["default"].Children.map(children, function (child, index) {
    return _react["default"].cloneElement(child, _objectSpread({}, child.props, {
      style: {
        flexBasis: toPercent(100 / count),
        maxWidth: toPercent(100 / count),
        overflow: 'hidden',
        marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
      }
    }));
  }));
}

Flex.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  count: _propTypes["default"].number.isRequired,
  direction: _propTypes["default"].string,
  offset: _propTypes["default"].number,
  style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  wrap: _propTypes["default"].bool
};

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Log message level.
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})(LogLevel || (LogLevel = {}));
/**
 * Class which facilitates logging of messages to a specific place.
 */
var Logger = /** @class */ (function () {
    function Logger(loggerOptions, packageName, packageVersion) {
        // Current log level, defaults to info.
        this.level = LogLevel.Info;
        var defaultLoggerCallback = function () {
            return;
        };
        var setLoggerOptions = loggerOptions || Logger.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof (setLoggerOptions.logLevel) === "number" ? setLoggerOptions.logLevel : LogLevel.Info;
        this.correlationId = setLoggerOptions.correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        this.packageName = packageName || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        this.packageVersion = packageVersion || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
    }
    Logger.createDefaultLoggerOptions = function () {
        return {
            loggerCallback: function () {
                // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: LogLevel.Info
        };
    };
    /**
     * Create new Logger with existing configurations.
     */
    Logger.prototype.clone = function (packageName, packageVersion, correlationId) {
        return new Logger({ loggerCallback: this.localCallback, piiLoggingEnabled: this.piiLoggingEnabled, logLevel: this.level, correlationId: correlationId || this.correlationId }, packageName, packageVersion);
    };
    /**
     * Log message with required options.
     */
    Logger.prototype.logMessage = function (logMessage, options) {
        if ((options.logLevel > this.level) || (!this.piiLoggingEnabled && options.containsPii)) {
            return;
        }
        var timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        var logHeader;
        if (!__WEBPACK_IMPORTED_MODULE_0__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(options.correlationId)) {
            logHeader = "[" + timestamp + "] : [" + options.correlationId + "]";
        }
        else if (!__WEBPACK_IMPORTED_MODULE_0__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(this.correlationId)) {
            logHeader = "[" + timestamp + "] : [" + this.correlationId + "]";
        }
        else {
            logHeader = "[" + timestamp + "]";
        }
        var log = logHeader + " : " + this.packageName + "@" + this.packageVersion + " : " + LogLevel[options.logLevel] + " - " + logMessage;
        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": Constants.EMPTY_STRING}${options.context ? `:${options.context}` : Constants.EMPTY_STRING}`)(logMessage);
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    };
    /**
     * Execute callback with message.
     */
    Logger.prototype.executeCallback = function (level, message, containsPii) {
        if (this.localCallback) {
            this.localCallback(level, message, containsPii);
        }
    };
    /**
     * Logs error messages.
     */
    Logger.prototype.error = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Error,
            containsPii: false,
            correlationId: correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
        });
    };
    /**
     * Logs error messages with PII.
     */
    Logger.prototype.errorPii = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Error,
            containsPii: true,
            correlationId: correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
        });
    };
    /**
     * Logs warning messages.
     */
    Logger.prototype.warning = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Warning,
            containsPii: false,
            correlationId: correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
        });
    };
    /**
     * Logs warning messages with PII.
     */
    Logger.prototype.warningPii = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Warning,
            containsPii: true,
            correlationId: correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
        });
    };
    /**
     * Logs info messages.
     */
    Logger.prototype.info = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Info,
            containsPii: false,
            correlationId: correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
        });
    };
    /**
     * Logs info messages with PII.
     */
    Logger.prototype.infoPii = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Info,
            containsPii: true,
            correlationId: correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
        });
    };
    /**
     * Logs verbose messages.
     */
    Logger.prototype.verbose = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Verbose,
            containsPii: false,
            correlationId: correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
        });
    };
    /**
     * Logs verbose messages with PII.
     */
    Logger.prototype.verbosePii = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Verbose,
            containsPii: true,
            correlationId: correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
        });
    };
    /**
     * Logs trace messages.
     */
    Logger.prototype.trace = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Trace,
            containsPii: false,
            correlationId: correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
        });
    };
    /**
     * Logs trace messages with PII.
     */
    Logger.prototype.tracePii = function (message, correlationId) {
        this.logMessage(message, {
            logLevel: LogLevel.Trace,
            containsPii: true,
            correlationId: correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
        });
    };
    /**
     * Returns whether PII Logging is enabled or not.
     */
    Logger.prototype.isPiiLoggingEnabled = function () {
        return this.piiLoggingEnabled || false;
    };
    return Logger;
}());


//# sourceMappingURL=Logger.js.map


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AzureCloudInstance; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var AzureCloudInstance;
(function (AzureCloudInstance) {
    // AzureCloudInstance is not specified.
    AzureCloudInstance[AzureCloudInstance["None"] = 0] = "None";
    // Microsoft Azure public cloud
    AzureCloudInstance["AzurePublic"] = "https://login.microsoftonline.com";
    // Microsoft PPE
    AzureCloudInstance["AzurePpe"] = "https://login.windows-ppe.net";
    // Microsoft Chinese national cloud
    AzureCloudInstance["AzureChina"] = "https://login.chinacloudapi.cn";
    // Microsoft German national cloud ("Black Forest")
    AzureCloudInstance["AzureGermany"] = "https://login.microsoftonline.de";
    // US Government cloud
    AzureCloudInstance["AzureUsGovernment"] = "https://login.microsoftonline.us";
})(AzureCloudInstance || (AzureCloudInstance = {}));


//# sourceMappingURL=AuthorityOptions.js.map


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__account_ClientInfo_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authority_AuthorityType_js__ = __webpack_require__(397);
/*! @azure/msal-common v13.3.1 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
 *
 * Key : Value Schema
 *
 * Key: <home_account_id>-<environment>-<realm*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
 *      authorityType: Accounts authority type as a string
 *      name: Full name for the account, including given name and family name,
 *      clientInfo: Full base64 encoded client info received from ESTS
 *      lastModificationTime: last time this entity was modified in the cache
 *      lastModificationApp:
 *      idTokenClaims: Object containing claims parsed from ID token
 *      nativeAccountId: Account identifier on the native device
 * }
 */
var AccountEntity = /** @class */ (function () {
    function AccountEntity() {
    }
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */
    AccountEntity.prototype.generateAccountId = function () {
        var accountId = [this.homeAccountId, this.environment];
        return accountId.join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generate Account Cache Key as per the schema: <home_account_id>-<environment>-<realm*>
     */
    AccountEntity.prototype.generateAccountKey = function () {
        return AccountEntity.generateAccountCacheKey({
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId
        });
    };
    /**
     * returns the type of the cache (in this case account)
     */
    AccountEntity.prototype.generateType = function () {
        switch (this.authorityType) {
            case __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["h" /* CacheAccountType */].ADFS_ACCOUNT_TYPE:
                return __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["j" /* CacheType */].ADFS;
            case __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["h" /* CacheAccountType */].MSAV1_ACCOUNT_TYPE:
                return __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["j" /* CacheType */].MSA;
            case __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["h" /* CacheAccountType */].MSSTS_ACCOUNT_TYPE:
                return __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["j" /* CacheType */].MSSTS;
            case __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["h" /* CacheAccountType */].GENERIC_ACCOUNT_TYPE:
                return __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["j" /* CacheType */].GENERIC;
            default: {
                throw __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__["a" /* ClientAuthError */].createUnexpectedAccountTypeError();
            }
        }
    };
    /**
     * Returns the AccountInfo interface for this account.
     */
    AccountEntity.prototype.getAccountInfo = function () {
        return {
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId,
            name: this.name,
            idTokenClaims: this.idTokenClaims,
            nativeAccountId: this.nativeAccountId
        };
    };
    /**
     * Generates account key from interface
     * @param accountInterface
     */
    AccountEntity.generateAccountCacheKey = function (accountInterface) {
        var accountKey = [
            accountInterface.homeAccountId,
            accountInterface.environment || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
            accountInterface.tenantId || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
        ];
        return accountKey.join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
     * @param clientInfo
     * @param authority
     * @param idToken
     * @param policy
     */
    AccountEntity.createAccount = function (clientInfo, homeAccountId, idToken, authority, cloudGraphHostName, msGraphHost, environment, nativeAccountId) {
        var _a, _b, _c, _d, _e, _f;
        var account = new AccountEntity();
        account.authorityType = __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["h" /* CacheAccountType */].MSSTS_ACCOUNT_TYPE;
        account.clientInfo = clientInfo;
        account.homeAccountId = homeAccountId;
        account.nativeAccountId = nativeAccountId;
        var env = environment || (authority && authority.getPreferredCache());
        if (!env) {
            throw __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__["a" /* ClientAuthError */].createInvalidCacheEnvironmentError();
        }
        account.environment = env;
        // non AAD scenarios can have empty realm
        account.realm = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.tid) || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        if (idToken) {
            account.idTokenClaims = idToken.claims;
            // How do you account for MSA CID here?
            account.localAccountId = ((_b = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _b === void 0 ? void 0 : _b.oid) || ((_c = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _c === void 0 ? void 0 : _c.sub) || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
            /*
             * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
             * In most cases it will contain a single email. This field should not be relied upon if a custom
             * policy is configured to return more than 1 email.
             */
            var preferredUsername = (_d = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _d === void 0 ? void 0 : _d.preferred_username;
            var email = ((_e = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _e === void 0 ? void 0 : _e.emails) ? idToken.claims.emails[0] : null;
            account.username = preferredUsername || email || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
            account.name = (_f = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _f === void 0 ? void 0 : _f.name;
        }
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        return account;
    };
    /**
     * Builds non-AAD/ADFS account.
     * @param authority
     * @param idToken
     */
    AccountEntity.createGenericAccount = function (homeAccountId, idToken, authority, cloudGraphHostName, msGraphHost, environment) {
        var _a, _b, _c, _d;
        var account = new AccountEntity();
        account.authorityType = (authority &&
            authority.authorityType === __WEBPACK_IMPORTED_MODULE_4__authority_AuthorityType_js__["a" /* AuthorityType */].Adfs) ? __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["h" /* CacheAccountType */].ADFS_ACCOUNT_TYPE : __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["h" /* CacheAccountType */].GENERIC_ACCOUNT_TYPE;
        account.homeAccountId = homeAccountId;
        // non AAD scenarios can have empty realm
        account.realm = __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        var env = environment || authority && authority.getPreferredCache();
        if (!env) {
            throw __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__["a" /* ClientAuthError */].createInvalidCacheEnvironmentError();
        }
        if (idToken) {
            // How do you account for MSA CID here?
            account.localAccountId = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.oid) || ((_b = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _b === void 0 ? void 0 : _b.sub) || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
            // upn claim for most ADFS scenarios
            account.username = ((_c = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _c === void 0 ? void 0 : _c.upn) || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
            account.name = ((_d = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _d === void 0 ? void 0 : _d.name) || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
            account.idTokenClaims = idToken === null || idToken === void 0 ? void 0 : idToken.claims;
        }
        account.environment = env;
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        /*
         * add uniqueName to claims
         * account.name = idToken.claims.uniqueName;
         */
        return account;
    };
    /**
     * Generate HomeAccountId from server response
     * @param serverClientInfo
     * @param authType
     */
    AccountEntity.generateHomeAccountId = function (serverClientInfo, authType, logger, cryptoObj, idToken) {
        var _a;
        var accountId = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.sub) ? idToken.claims.sub : __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        // since ADFS does not have tid and does not set client_info
        if (authType === __WEBPACK_IMPORTED_MODULE_4__authority_AuthorityType_js__["a" /* AuthorityType */].Adfs || authType === __WEBPACK_IMPORTED_MODULE_4__authority_AuthorityType_js__["a" /* AuthorityType */].Dsts) {
            return accountId;
        }
        // for cases where there is clientInfo
        if (serverClientInfo) {
            try {
                var clientInfo = Object(__WEBPACK_IMPORTED_MODULE_1__account_ClientInfo_js__["a" /* buildClientInfo */])(serverClientInfo, cryptoObj);
                if (!__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(clientInfo.uid) && !__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(clientInfo.utid)) {
                    return "" + clientInfo.uid + __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["D" /* Separators */].CLIENT_INFO_SEPARATOR + clientInfo.utid;
                }
            }
            catch (e) { }
        }
        // default to "sub" claim
        logger.verbose("No client info in response");
        return accountId;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    AccountEntity.isAccountEntity = function (entity) {
        if (!entity) {
            return false;
        }
        return (entity.hasOwnProperty("homeAccountId") &&
            entity.hasOwnProperty("environment") &&
            entity.hasOwnProperty("realm") &&
            entity.hasOwnProperty("localAccountId") &&
            entity.hasOwnProperty("username") &&
            entity.hasOwnProperty("authorityType"));
    };
    /**
     * Helper function to determine whether 2 accountInfo objects represent the same account
     * @param accountA
     * @param accountB
     * @param compareClaims - If set to true idTokenClaims will also be compared to determine account equality
     */
    AccountEntity.accountInfoIsEqual = function (accountA, accountB, compareClaims) {
        if (!accountA || !accountB) {
            return false;
        }
        var claimsMatch = true; // default to true so as to not fail comparison below if compareClaims: false
        if (compareClaims) {
            var accountAClaims = (accountA.idTokenClaims || {});
            var accountBClaims = (accountB.idTokenClaims || {});
            // issued at timestamp and nonce are expected to change each time a new id token is acquired
            claimsMatch = (accountAClaims.iat === accountBClaims.iat) &&
                (accountAClaims.nonce === accountBClaims.nonce);
        }
        return (accountA.homeAccountId === accountB.homeAccountId) &&
            (accountA.localAccountId === accountB.localAccountId) &&
            (accountA.username === accountB.username) &&
            (accountA.tenantId === accountB.tenantId) &&
            (accountA.environment === accountB.environment) &&
            (accountA.nativeAccountId === accountB.nativeAccountId) &&
            claimsMatch;
    };
    return AccountEntity;
}());


//# sourceMappingURL=AccountEntity.js.map


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InteractionRequiredAuthError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InteractionRequiredAuthErrorMessage; });
/* unused harmony export InteractionRequiredAuthSubErrorMessage */
/* unused harmony export InteractionRequiredServerErrorMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthError_js__ = __webpack_require__(112);
/*! @azure/msal-common v13.3.1 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */
var InteractionRequiredServerErrorMessage = [
    "interaction_required",
    "consent_required",
    "login_required"
];
var InteractionRequiredAuthSubErrorMessage = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required"
];
/**
 * Interaction required errors defined by the SDK
 */
var InteractionRequiredAuthErrorMessage = {
    noTokensFoundError: {
        code: "no_tokens_found",
        desc: "No refresh token found in the cache. Please sign-in."
    },
    native_account_unavailable: {
        code: "native_account_unavailable",
        desc: "The requested account is not available in the native broker. It may have been deleted or logged out. Please sign-in again using an interactive API."
    }
};
/**
 * Error thrown when user interaction is required.
 */
var InteractionRequiredAuthError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(InteractionRequiredAuthError, _super);
    function InteractionRequiredAuthError(errorCode, errorMessage, subError, timestamp, traceId, correlationId, claims) {
        var _this = _super.call(this, errorCode, errorMessage, subError) || this;
        Object.setPrototypeOf(_this, InteractionRequiredAuthError.prototype);
        _this.timestamp = timestamp || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        _this.traceId = traceId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        _this.correlationId = correlationId || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        _this.claims = claims || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        _this.name = "InteractionRequiredAuthError";
        return _this;
    }
    /**
     * Helper function used to determine if an error thrown by the server requires interaction to resolve
     * @param errorCode
     * @param errorString
     * @param subError
     */
    InteractionRequiredAuthError.isInteractionRequiredError = function (errorCode, errorString, subError) {
        var isInteractionRequiredErrorCode = !!errorCode && InteractionRequiredServerErrorMessage.indexOf(errorCode) > -1;
        var isInteractionRequiredSubError = !!subError && InteractionRequiredAuthSubErrorMessage.indexOf(subError) > -1;
        var isInteractionRequiredErrorDesc = !!errorString && InteractionRequiredServerErrorMessage.some(function (irErrorCode) {
            return errorString.indexOf(irErrorCode) > -1;
        });
        return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
    };
    /**
     * Creates an error thrown when the authorization code required for a token request is null or empty.
     */
    InteractionRequiredAuthError.createNoTokensFoundError = function () {
        return new InteractionRequiredAuthError(InteractionRequiredAuthErrorMessage.noTokensFoundError.code, InteractionRequiredAuthErrorMessage.noTokensFoundError.desc);
    };
    /**
     * Creates an error thrown when the native broker returns ACCOUNT_UNAVAILABLE status, indicating that the account was removed and interactive sign-in is required
     * @returns
     */
    InteractionRequiredAuthError.createNativeAccountUnavailableError = function () {
        return new InteractionRequiredAuthError(InteractionRequiredAuthErrorMessage.native_account_unavailable.code, InteractionRequiredAuthErrorMessage.native_account_unavailable.desc);
    };
    return InteractionRequiredAuthError;
}(__WEBPACK_IMPORTED_MODULE_2__AuthError_js__["a" /* AuthError */]));


//# sourceMappingURL=InteractionRequiredAuthError.js.map


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InteractionHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/*! @azure/msal-browser v2.38.3 2023-10-27 */






/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Abstract class which defines operations for a browser interaction handling class.
 */
var InteractionHandler = /** @class */ (function () {
    function InteractionHandler(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient) {
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */
    InteractionHandler.prototype.handleCodeResponseFromHash = function (locationHash, state, authority, networkModule) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var stateKey, requestState, authCodeResponse;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].HandleCodeResponseFromHash, this.authCodeRequest.correlationId);
                this.logger.verbose("InteractionHandler.handleCodeResponse called");
                // Check that location hash isn't empty.
                if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(locationHash)) {
                    throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createEmptyHashError(locationHash);
                }
                stateKey = this.browserStorage.generateStateKey(state);
                requestState = this.browserStorage.getTemporaryCache(stateKey);
                if (!requestState) {
                    throw __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["r" /* ClientAuthError */].createStateNotFoundError("Cached State");
                }
                try {
                    authCodeResponse = this.authModule.handleFragmentResponse(locationHash, requestState);
                }
                catch (e) {
                    if (e instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["S" /* ServerError */] && e.subError === __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["b" /* BrowserAuthErrorMessage */].userCancelledError.code) {
                        // Translate server error caused by user closing native prompt to corresponding first class MSAL error
                        throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUserCancelledError();
                    }
                    else {
                        throw e;
                    }
                }
                this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].HandleCodeResponseFromServer, this.authCodeRequest.correlationId);
                return [2 /*return*/, this.handleCodeResponseFromServer(authCodeResponse, state, authority, networkModule)];
            });
        });
    };
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param state
     * @param authority
     * @param networkModule
     * @returns
     */
    InteractionHandler.prototype.handleCodeResponseFromServer = function (authCodeResponse, state, authority, networkModule, validateNonce) {
        if (validateNonce === void 0) { validateNonce = true; }
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var stateKey, requestState, nonceKey, cachedNonce, cachedCcsCred, tokenResponse;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].HandleCodeResponseFromServer, this.authCodeRequest.correlationId);
                        this.logger.trace("InteractionHandler.handleCodeResponseFromServer called");
                        stateKey = this.browserStorage.generateStateKey(state);
                        requestState = this.browserStorage.getTemporaryCache(stateKey);
                        if (!requestState) {
                            throw __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["r" /* ClientAuthError */].createStateNotFoundError("Cached State");
                        }
                        nonceKey = this.browserStorage.generateNonceKey(requestState);
                        cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
                        // Assign code to request
                        this.authCodeRequest.code = authCodeResponse.code;
                        if (!authCodeResponse.cloud_instance_host_name) return [3 /*break*/, 2];
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].UpdateTokenEndpointAuthority, this.authCodeRequest.correlationId);
                        return [4 /*yield*/, this.updateTokenEndpointAuthority(authCodeResponse.cloud_instance_host_name, authority, networkModule)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
                        if (validateNonce) {
                            authCodeResponse.nonce = cachedNonce || undefined;
                        }
                        authCodeResponse.state = requestState;
                        // Add CCS parameters if available
                        if (authCodeResponse.client_info) {
                            this.authCodeRequest.clientInfo = authCodeResponse.client_info;
                        }
                        else {
                            cachedCcsCred = this.checkCcsCredentials();
                            if (cachedCcsCred) {
                                this.authCodeRequest.ccsCredential = cachedCcsCred;
                            }
                        }
                        // Acquire token with retrieved code.
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].AuthClientAcquireToken, this.authCodeRequest.correlationId);
                        return [4 /*yield*/, this.authModule.acquireToken(this.authCodeRequest, authCodeResponse)];
                    case 3:
                        tokenResponse = _a.sent();
                        this.browserStorage.cleanRequestByState(state);
                        return [2 /*return*/, tokenResponse];
                }
            });
        });
    };
    /**
     * Updates authority based on cloudInstanceHostname
     * @param cloudInstanceHostname
     * @param authority
     * @param networkModule
     */
    InteractionHandler.prototype.updateTokenEndpointAuthority = function (cloudInstanceHostname, authority, networkModule) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var cloudInstanceAuthorityUri, cloudInstanceAuthority;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].UpdateTokenEndpointAuthority, this.authCodeRequest.correlationId);
                        cloudInstanceAuthorityUri = "https://" + cloudInstanceHostname + "/" + authority.tenant + "/";
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["j" /* AuthorityFactory */].createDiscoveredInstance(cloudInstanceAuthorityUri, networkModule, this.browserStorage, authority.options, this.logger, this.performanceClient, this.authCodeRequest.correlationId)];
                    case 1:
                        cloudInstanceAuthority = _a.sent();
                        this.authModule.updateAuthority(cloudInstanceAuthority);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Looks up ccs creds in the cache
     */
    InteractionHandler.prototype.checkCcsCredentials = function () {
        // Look up ccs credential in temp cache
        var cachedCcsCred = this.browserStorage.getTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].CCS_CREDENTIAL, true);
        if (cachedCcsCred) {
            try {
                return JSON.parse(cachedCcsCred);
            }
            catch (e) {
                this.authModule.logger.error("Cache credential could not be parsed");
                this.authModule.logger.errorPii("Cache credential could not be parsed: " + cachedCcsCred);
            }
        }
        return null;
    };
    return InteractionHandler;
}());


//# sourceMappingURL=InteractionHandler.js.map


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SilentCacheClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StandardInteractionClient_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_BrowserAuthError_js__ = __webpack_require__(49);
/*! @azure/msal-browser v2.38.3 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var SilentCacheClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(SilentCacheClient, _super);
    function SilentCacheClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */
    SilentCacheClient.prototype.acquireToken = function (silentRequest) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var acquireTokenMeasurement, serverTelemetryManager, silentAuthClient, cachedToken, error_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        acquireTokenMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].SilentCacheClientAcquireToken, silentRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenSilent_silentFlow);
                        return [4 /*yield*/, this.createSilentFlowClient(serverTelemetryManager, silentRequest.authority, silentRequest.azureCloudOptions)];
                    case 1:
                        silentAuthClient = _a.sent();
                        this.logger.verbose("Silent auth client created");
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, silentAuthClient.acquireCachedToken(silentRequest)];
                    case 3:
                        cachedToken = _a.sent();
                        acquireTokenMeasurement.endMeasurement({
                            success: true,
                            fromCache: true
                        });
                        return [2 /*return*/, cachedToken];
                    case 4:
                        error_1 = _a.sent();
                        if (error_1 instanceof __WEBPACK_IMPORTED_MODULE_4__error_BrowserAuthError_js__["a" /* BrowserAuthError */] && error_1.errorCode === __WEBPACK_IMPORTED_MODULE_4__error_BrowserAuthError_js__["b" /* BrowserAuthErrorMessage */].signingKeyNotFoundInStorage.code) {
                            this.logger.verbose("Signing keypair for bound access token not found. Refreshing bound access token and generating a new crypto keypair.");
                        }
                        acquireTokenMeasurement.endMeasurement({
                            errorCode: error_1 instanceof __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["d" /* AuthError */] && error_1.errorCode || undefined,
                            subErrorCode: error_1 instanceof __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["d" /* AuthError */] && error_1.subError || undefined,
                            success: false
                        });
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */
    SilentCacheClient.prototype.logout = function () {
        // Synchronous so we must reject
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_4__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createSilentLogoutUnsupportedError());
    };
    /**
     * Creates an Silent Flow Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */
    SilentCacheClient.prototype.createSilentFlowClient = function (serverTelemetryManager, authorityUrl, azureCloudOptions) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var clientConfig;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Create auth module.
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientGetClientConfiguration, this.correlationId);
                        return [4 /*yield*/, this.getClientConfiguration(serverTelemetryManager, authorityUrl, azureCloudOptions)];
                    case 1:
                        clientConfig = _a.sent();
                        return [2 /*return*/, new __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["V" /* SilentFlowClient */](clientConfig, this.performanceClient)];
                }
            });
        });
    };
    SilentCacheClient.prototype.initializeSilentRequest = function (request, account) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _a;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].InitializeSilentRequest, this.correlationId);
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].InitializeBaseRequest, this.correlationId);
                        _a = [Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request)];
                        return [4 /*yield*/, this.initializeBaseRequest(request, account)];
                    case 1: return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */].apply(void 0, _a.concat([_b.sent()])), { account: account, forceRefresh: request.forceRefresh || false }])];
                }
            });
        });
    };
    return SilentCacheClient;
}(__WEBPACK_IMPORTED_MODULE_1__StandardInteractionClient_js__["a" /* StandardInteractionClient */]));


//# sourceMappingURL=SilentCacheClient.js.map


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_IFRAME_TIMEOUT_MS; });
/* unused harmony export DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS */
/* unused harmony export DEFAULT_POPUP_TIMEOUT_MS */
/* unused harmony export DEFAULT_REDIRECT_TIMEOUT_MS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildConfiguration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_BrowserUtils_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__navigation_NavigationClient_js__ = __webpack_require__(1126);
/*! @azure/msal-browser v2.38.3 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
// Default timeout for popup windows and iframes in milliseconds
var DEFAULT_POPUP_TIMEOUT_MS = 60000;
var DEFAULT_IFRAME_TIMEOUT_MS = 6000;
var DEFAULT_REDIRECT_TIMEOUT_MS = 30000;
var DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */
function buildConfiguration(_a, isBrowserEnvironment) {
    var userInputAuth = _a.auth, userInputCache = _a.cache, userInputSystem = _a.system, userInputTelemetry = _a.telemetry;
    // Default auth options for browser
    var DEFAULT_AUTH_OPTIONS = {
        clientId: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
        authority: "" + __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].DEFAULT_AUTHORITY,
        knownAuthorities: [],
        cloudDiscoveryMetadata: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
        authorityMetadata: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
        redirectUri: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
        postLogoutRedirectUri: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
        navigateToLoginRequestUrl: true,
        clientCapabilities: [],
        protocolMode: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["M" /* ProtocolMode */].AAD,
        azureCloudOptions: {
            azureCloudInstance: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["n" /* AzureCloudInstance */].None,
            tenant: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING
        },
        skipAuthorityMetadataCache: false,
    };
    // Default cache options for browser
    var DEFAULT_CACHE_OPTIONS = {
        cacheLocation: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].SessionStorage,
        temporaryCacheLocation: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].SessionStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        // Default cache migration to true if cache location is localStorage since entries are preserved across tabs/windows. Migration has little to no benefit in sessionStorage and memoryStorage
        cacheMigrationEnabled: userInputCache && userInputCache.cacheLocation === __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].LocalStorage ? true : false,
        claimsBasedCachingEnabled: true
    };
    // Default logger options for browser
    var DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: function () {
            // allow users to not set logger call back 
        },
        logLevel: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["E" /* LogLevel */].Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    var DEFAULT_BROWSER_SYSTEM_OPTIONS = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["y" /* DEFAULT_SYSTEM_OPTIONS */]), { loggerOptions: DEFAULT_LOGGER_OPTIONS, networkClient: isBrowserEnvironment ? __WEBPACK_IMPORTED_MODULE_2__utils_BrowserUtils_js__["a" /* BrowserUtils */].getBrowserNetworkClient() : __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["Y" /* StubbedNetworkModule */], navigationClient: new __WEBPACK_IMPORTED_MODULE_4__navigation_NavigationClient_js__["a" /* NavigationClient */](), loadFrameTimeout: 0, 
        // If loadFrameTimeout is provided, use that as default.
        windowHashTimeout: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.loadFrameTimeout) || DEFAULT_POPUP_TIMEOUT_MS, iframeHashTimeout: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.loadFrameTimeout) || DEFAULT_IFRAME_TIMEOUT_MS, navigateFrameWait: isBrowserEnvironment && __WEBPACK_IMPORTED_MODULE_2__utils_BrowserUtils_js__["a" /* BrowserUtils */].detectIEOrEdge() ? 500 : 0, redirectNavigationTimeout: DEFAULT_REDIRECT_TIMEOUT_MS, asyncPopups: false, allowRedirectInIframe: false, allowNativeBroker: false, nativeBrokerHandshakeTimeout: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.nativeBrokerHandshakeTimeout) || DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS, pollIntervalMilliseconds: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["c" /* BrowserConstants */].DEFAULT_POLL_INTERVAL_MS, cryptoOptions: {
            useMsrCrypto: false,
            entropy: undefined
        } });
    var providedSystemOptions = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, userInputSystem), { loggerOptions: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.loggerOptions) || DEFAULT_LOGGER_OPTIONS });
    var DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
            appVersion: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING
        }
    };
    var overlayedConfig = {
        auth: Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, DEFAULT_AUTH_OPTIONS), userInputAuth),
        cache: Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, DEFAULT_CACHE_OPTIONS), userInputCache),
        system: Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, DEFAULT_BROWSER_SYSTEM_OPTIONS), providedSystemOptions),
        telemetry: Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, DEFAULT_TELEMETRY_OPTIONS), userInputTelemetry)
    };
    return overlayedConfig;
}


//# sourceMappingURL=Configuration.js.map


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CryptoOps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GuidGenerator_js__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__encode_Base64Encode_js__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__encode_Base64Decode_js__ = __webpack_require__(2748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PkceGenerator_js__ = __webpack_require__(2749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BrowserCrypto_js__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_BrowserStringUtils_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cache_CryptoKeyStore_js__ = __webpack_require__(2753);
/*! @azure/msal-browser v2.38.3 2023-10-27 */












/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */
var CryptoOps = /** @class */ (function () {
    function CryptoOps(logger, performanceClient, cryptoConfig) {
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        this.browserCrypto = new __WEBPACK_IMPORTED_MODULE_6__BrowserCrypto_js__["a" /* BrowserCrypto */](this.logger, cryptoConfig);
        this.b64Encode = new __WEBPACK_IMPORTED_MODULE_3__encode_Base64Encode_js__["a" /* Base64Encode */]();
        this.b64Decode = new __WEBPACK_IMPORTED_MODULE_4__encode_Base64Decode_js__["a" /* Base64Decode */]();
        this.guidGenerator = new __WEBPACK_IMPORTED_MODULE_2__GuidGenerator_js__["a" /* GuidGenerator */](this.browserCrypto);
        this.pkceGenerator = new __WEBPACK_IMPORTED_MODULE_5__PkceGenerator_js__["a" /* PkceGenerator */](this.browserCrypto);
        this.cache = new __WEBPACK_IMPORTED_MODULE_9__cache_CryptoKeyStore_js__["a" /* CryptoKeyStore */](this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */
    CryptoOps.prototype.createNewGuid = function () {
        return this.guidGenerator.generateGuid();
    };
    /**
     * Encodes input string to base64.
     * @param input
     */
    CryptoOps.prototype.base64Encode = function (input) {
        return this.b64Encode.encode(input);
    };
    /**
     * Decodes input string from base64.
     * @param input
     */
    CryptoOps.prototype.base64Decode = function (input) {
        return this.b64Decode.decode(input);
    };
    /**
     * Generates PKCE codes used in Authorization Code Flow.
     */
    CryptoOps.prototype.generatePkceCodes = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.pkceGenerator.generateCodes()];
            });
        });
    };
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */
    CryptoOps.prototype.getPublicKeyThumbprint = function (request) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var publicKeyThumbMeasurement, keyPair, publicKeyJwk, pubKeyThumprintObj, publicJwkString, publicJwkHash, privateKeyJwk, unextractablePrivateKey;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        publicKeyThumbMeasurement = (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.startMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].CryptoOptsGetPublicKeyThumbprint, request.correlationId);
                        return [4 /*yield*/, this.browserCrypto.generateKeyPair(CryptoOps.EXTRACTABLE, CryptoOps.POP_KEY_USAGES)];
                    case 1:
                        keyPair = _b.sent();
                        return [4 /*yield*/, this.browserCrypto.exportJwk(keyPair.publicKey)];
                    case 2:
                        publicKeyJwk = _b.sent();
                        pubKeyThumprintObj = {
                            e: publicKeyJwk.e,
                            kty: publicKeyJwk.kty,
                            n: publicKeyJwk.n
                        };
                        publicJwkString = __WEBPACK_IMPORTED_MODULE_7__utils_BrowserStringUtils_js__["a" /* BrowserStringUtils */].getSortedObjectString(pubKeyThumprintObj);
                        return [4 /*yield*/, this.hashString(publicJwkString)];
                    case 3:
                        publicJwkHash = _b.sent();
                        return [4 /*yield*/, this.browserCrypto.exportJwk(keyPair.privateKey)];
                    case 4:
                        privateKeyJwk = _b.sent();
                        return [4 /*yield*/, this.browserCrypto.importJwk(privateKeyJwk, false, ["sign"])];
                    case 5:
                        unextractablePrivateKey = _b.sent();
                        // Store Keypair data in keystore
                        return [4 /*yield*/, this.cache.asymmetricKeys.setItem(publicJwkHash, {
                                privateKey: unextractablePrivateKey,
                                publicKey: keyPair.publicKey,
                                requestMethod: request.resourceRequestMethod,
                                requestUri: request.resourceRequestUri
                            })];
                    case 6:
                        // Store Keypair data in keystore
                        _b.sent();
                        if (publicKeyThumbMeasurement) {
                            publicKeyThumbMeasurement.endMeasurement({
                                success: true
                            });
                        }
                        return [2 /*return*/, publicJwkHash];
                }
            });
        });
    };
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     */
    CryptoOps.prototype.removeTokenBindingKey = function (kid) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var keyFound;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cache.asymmetricKeys.removeItem(kid)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.cache.asymmetricKeys.containsKey(kid)];
                    case 2:
                        keyFound = _a.sent();
                        return [2 /*return*/, !keyFound];
                }
            });
        });
    };
    /**
     * Removes all cryptographic keys from IndexedDB storage
     */
    CryptoOps.prototype.clearKeystore = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cache.clear()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */
    CryptoOps.prototype.signJwt = function (payload, kid, correlationId) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var signJwtMeasurement, cachedKeyPair, publicKeyJwk, publicKeyJwkString, encodedKeyIdThumbprint, shrHeader, encodedShrHeader, encodedPayload, tokenString, tokenBuffer, signatureBuffer, encodedSignature, signedJwt;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        signJwtMeasurement = (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.startMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].CryptoOptsSignJwt, correlationId);
                        return [4 /*yield*/, this.cache.asymmetricKeys.getItem(kid)];
                    case 1:
                        cachedKeyPair = _b.sent();
                        if (!cachedKeyPair) {
                            throw __WEBPACK_IMPORTED_MODULE_8__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createSigningKeyNotFoundInStorageError(kid);
                        }
                        return [4 /*yield*/, this.browserCrypto.exportJwk(cachedKeyPair.publicKey)];
                    case 2:
                        publicKeyJwk = _b.sent();
                        publicKeyJwkString = __WEBPACK_IMPORTED_MODULE_7__utils_BrowserStringUtils_js__["a" /* BrowserStringUtils */].getSortedObjectString(publicKeyJwk);
                        encodedKeyIdThumbprint = this.b64Encode.urlEncode(JSON.stringify({ kid: kid }));
                        shrHeader = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["D" /* JoseHeader */].getShrHeaderString({ kid: encodedKeyIdThumbprint, alg: publicKeyJwk.alg });
                        encodedShrHeader = this.b64Encode.urlEncode(shrHeader);
                        // Generate payload
                        payload.cnf = {
                            jwk: JSON.parse(publicKeyJwkString)
                        };
                        encodedPayload = this.b64Encode.urlEncode(JSON.stringify(payload));
                        tokenString = encodedShrHeader + "." + encodedPayload;
                        tokenBuffer = __WEBPACK_IMPORTED_MODULE_7__utils_BrowserStringUtils_js__["a" /* BrowserStringUtils */].stringToArrayBuffer(tokenString);
                        return [4 /*yield*/, this.browserCrypto.sign(cachedKeyPair.privateKey, tokenBuffer)];
                    case 3:
                        signatureBuffer = _b.sent();
                        encodedSignature = this.b64Encode.urlEncodeArr(new Uint8Array(signatureBuffer));
                        signedJwt = tokenString + "." + encodedSignature;
                        if (signJwtMeasurement) {
                            signJwtMeasurement.endMeasurement({
                                success: true
                            });
                        }
                        return [2 /*return*/, signedJwt];
                }
            });
        });
    };
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */
    CryptoOps.prototype.hashString = function (plainText) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var hashBuffer, hashBytes;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.browserCrypto.sha256Digest(plainText)];
                    case 1:
                        hashBuffer = _a.sent();
                        hashBytes = new Uint8Array(hashBuffer);
                        return [2 /*return*/, this.b64Encode.urlEncodeArr(hashBytes)];
                }
            });
        });
    };
    CryptoOps.POP_KEY_USAGES = ["sign", "verify"];
    CryptoOps.EXTRACTABLE = true;
    return CryptoOps;
}());


//# sourceMappingURL=CryptoOps.js.map


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(2844);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(761);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(2862),
    createAssigner = __webpack_require__(751);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(107);
var defined = __webpack_require__(123);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 590 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 591 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(64);
var toAbsoluteIndex = __webpack_require__(193);
var toLength = __webpack_require__(55);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(301);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(356)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(34);
var DESCRIPTORS = __webpack_require__(56);
var LIBRARY = __webpack_require__(166);
var $typed = __webpack_require__(403);
var hide = __webpack_require__(92);
var redefineAll = __webpack_require__(194);
var fails = __webpack_require__(37);
var anInstance = __webpack_require__(195);
var toInteger = __webpack_require__(107);
var toLength = __webpack_require__(55);
var toIndex = __webpack_require__(1153);
var gOPN = __webpack_require__(199).f;
var dP = __webpack_require__(61).f;
var arrayFill = __webpack_require__(592);
var setToStringTag = __webpack_require__(229);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(1173);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(409);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(246);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(1181);

var _runTransitionHook = __webpack_require__(411);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(215);

var _PathUtils = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(411);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(137);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(604);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1200)();
}


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(610);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(1208);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(617);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(416);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reducer = reducer;
exports.mediaChanged = mediaChanged;
exports.mediaQueryTracker = mediaQueryTracker;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var listeners = [];
var MEDIA_CHANGED = exports.MEDIA_CHANGED = '@@rdx-mqt/MEDIA_CHANGED';

// Reducer
function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	var action = arguments[1];

	switch (action.type) {
		case MEDIA_CHANGED:
			return Object.assign({}, state, action.data);
		default:
			return state;
	}
}

// Actions
function mediaChanged(data) {
	return {
		type: MEDIA_CHANGED,
		data: data
	};
}

var trackInnerWidth = false;
var trackInnerHeight = false;
var onResize = void 0;
var getSizes = function getSizes(data) {
	if (trackInnerWidth) {
		data.innerWidth = global.innerWidth;
	}
	if (trackInnerHeight) {
		data.innerHeight = global.innerHeight;
	}
};
var makeOnResize = function makeOnResize(dispatch) {
	return function () {
		var data = {};
		getSizes(data);
		dispatch(mediaChanged(data));
	};
};
function trackMediaQuery(label, query, dispatch, initData) {
	// special queries
	if (label === 'innerWidth' || label === 'innerHeight') {
		if (label === 'innerWidth') {
			trackInnerWidth = true;
		}
		if (label === 'innerHeight') {
			trackInnerHeight = true;
		}
		if (!onResize) {
			onResize = makeOnResize(dispatch);
			if (global.addEventListener) {
				global.addEventListener('resize', onResize, true);
			}
		}
		getSizes(initData);
	}

	var mq = global.matchMedia(query);

	var listener = function listener() {
		return dispatch(mediaChanged(_defineProperty({}, label, mq.matches)));
	};
	mq.addListener(listener);

	initData[label] = mq.matches;
	return;
}

function mediaQueryTracker(queries) {
	return function (dispatch) {
		var initData = {};
		if (global.matchMedia) {
			for (var label in queries) {
				trackMediaQuery(label, queries[label], dispatch, initData);
			}
			dispatch(mediaChanged(initData));
		}
	};
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = convertAPIOptions;
/* harmony export (immutable) */ __webpack_exports__["c"] = convertJSONOptions;
/* harmony export (immutable) */ __webpack_exports__["d"] = convertTOptions;
/* harmony export (immutable) */ __webpack_exports__["a"] = appendBackwardsAPI;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(158);
/* eslint no-param-reassign: 0 */


function convertInterpolation(options) {

  options.interpolation = {
    unescapeSuffix: 'HTML'
  };

  options.interpolation.prefix = options.interpolationPrefix || '__';
  options.interpolation.suffix = options.interpolationSuffix || '__';
  options.interpolation.escapeValue = options.escapeInterpolation || false;

  options.interpolation.nestingPrefix = options.reusePrefix || '$t(';
  options.interpolation.nestingSuffix = options.reuseSuffix || ')';

  return options;
}

function convertAPIOptions(options) {
  if (options.resStore) options.resources = options.resStore;

  if (options.ns && options.ns.defaultNs) {
    options.defaultNS = options.ns.defaultNs;
    options.ns = options.ns.namespaces;
  } else {
    options.defaultNS = options.ns || 'translation';
  }

  if (options.fallbackToDefaultNS && options.defaultNS) options.fallbackNS = options.defaultNS;

  options.saveMissing = options.sendMissing;
  options.saveMissingTo = options.sendMissingTo || 'current';
  options.returnNull = !options.fallbackOnNull;
  options.returnEmptyString = !options.fallbackOnEmpty;
  options.returnObjects = options.returnObjectTrees;
  options.joinArrays = '\n';

  options.returnedObjectHandler = options.objectTreeKeyHandler;
  options.parseMissingKeyHandler = options.parseMissingKey;
  options.appendNamespaceToMissingKey = true;

  options.nsSeparator = options.nsseparator || ':';
  options.keySeparator = options.keyseparator || '.';

  if (options.shortcutFunction === 'sprintf') {
    options.overloadTranslationOptionHandler = function handle(args) {
      var values = [];

      for (var i = 1; i < args.length; i++) {
        values.push(args[i]);
      }

      return {
        postProcess: 'sprintf',
        sprintf: values
      };
    };
  }

  options.whitelist = options.lngWhitelist;
  options.preload = options.preload;
  if (options.load === 'current') options.load = 'currentOnly';
  if (options.load === 'unspecific') options.load = 'languageOnly';

  // backend
  options.backend = options.backend || {};
  options.backend.loadPath = options.resGetPath || 'locales/__lng__/__ns__.json';
  options.backend.addPath = options.resPostPath || 'locales/add/__lng__/__ns__';
  options.backend.allowMultiLoading = options.dynamicLoad;

  // cache
  options.cache = options.cache || {};
  options.cache.prefix = 'res_';
  options.cache.expirationTime = 7 * 24 * 60 * 60 * 1000;
  options.cache.enabled = options.useLocalStorage;

  options = convertInterpolation(options);
  if (options.defaultVariables) options.interpolation.defaultVariables = options.defaultVariables;

  // COMPATIBILITY: deprecation
  // if (options.getAsync === false) throw deprecation error

  return options;
}

function convertJSONOptions(options) {
  options = convertInterpolation(options);
  options.joinArrays = '\n';

  return options;
}

function convertTOptions(options) {
  if (options.interpolationPrefix || options.interpolationSuffix || options.escapeInterpolation !== undefined) {
    options = convertInterpolation(options);
  }

  options.nsSeparator = options.nsseparator;
  options.keySeparator = options.keyseparator;

  options.returnObjects = options.returnObjectTrees;

  return options;
}

function appendBackwardsAPI(i18n) {
  i18n.lng = function () {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].deprecate('i18next.lng() can be replaced by i18next.language for detected language or i18next.languages for languages ordered by translation lookup.');
    return i18n.services.languageUtils.toResolveHierarchy(i18n.language)[0];
  };

  i18n.preload = function (lngs, cb) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].deprecate('i18next.preload() can be replaced with i18next.loadLanguages()');
    i18n.loadLanguages(lngs, cb);
  };

  i18n.setLng = function (lng, options, callback) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].deprecate('i18next.setLng() can be replaced with i18next.changeLanguage() or i18next.getFixedT() to get a translation function with fixed language or namespace.');
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options) options = {};

    if (options.fixLng === true) {
      if (callback) return callback(null, i18n.getFixedT(lng));
    }

    return i18n.changeLanguage(lng, callback);
  };

  i18n.addPostProcessor = function (name, fc) {
    __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].deprecate('i18next.addPostProcessor() can be replaced by i18next.use({ type: \'postProcessor\', name: \'name\', process: fc })');
    i18n.use({
      type: 'postProcessor',
      name: name,
      process: fc
    });
  };
}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'كانون الثاني يناير',
    'شباط فبراير',
    'آذار مارس',
    'نيسان أبريل',
    'أيار مايو',
    'حزيران يونيو',
    'تموز يوليو',
    'آب أغسطس',
    'أيلول سبتمبر',
    'تشرين الأول أكتوبر',
    'تشرين الثاني نوفمبر',
    'كانون الأول ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : '[el] D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH.mm',
        LLLL : 'dddd, D. MMMM YYYY HH.mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number,
        suffix;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}일/,
    ordinal : '%d일',
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: '[W] dddd [o] LT',
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[haftaya] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen hafta] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日Ah点mm分',
        LLLL : 'YYYY年MMMD日ddddAh点mm分',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(307),
    _assign = __webpack_require__(80);

var ReactNoopUpdateQueue = __webpack_require__(736);

var canDefineProperty = __webpack_require__(737);
var emptyObject = __webpack_require__(302);
var invariant = __webpack_require__(60);
var lowPriorityWarning = __webpack_require__(1255);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(104);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(420);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _propTypes2["default"].shape({
  subscribe: _propTypes2["default"].func.isRequired,
  dispatch: _propTypes2["default"].func.isRequired,
  getState: _propTypes2["default"].func.isRequired
});

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(174),
    getPrototype = __webpack_require__(421),
    isObjectLike = __webpack_require__(117);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 745 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducerEnhancer = exports.defaultState = exports.SET_DEFAULT_UI_STATE = exports.UPDATE_UI_STATE = exports.MASS_UPDATE_UI_STATE = undefined;
exports.default = reducer;
exports.updateUI = updateUI;
exports.massUpdateUI = massUpdateUI;
exports.setDefaultUI = setDefaultUI;
exports.unmountUI = unmountUI;
exports.mountUI = mountUI;

var _immutable = __webpack_require__(1278);

var _invariant = __webpack_require__(746);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// For updating multiple UI variables at once.  Each variable might be part of
// a different context; this means that we need to either call updateUI on each
// key of the object to update or do transformations within one action in the
// reducer. The latter only triggers one store change event and is more
// performant.
var MASS_UPDATE_UI_STATE = exports.MASS_UPDATE_UI_STATE = '@@redux-ui/MASS_UPDATE_UI_STATE';
var UPDATE_UI_STATE = exports.UPDATE_UI_STATE = '@@redux-ui/UPDATE_UI_STATE';
var SET_DEFAULT_UI_STATE = exports.SET_DEFAULT_UI_STATE = '@@redux-ui/SET_DEFAULT_UI_STATE';

// These are private consts used in actions only given to the UI decorator.
var MOUNT_UI_STATE = '@@redux-ui/MOUNT_UI_STATE';
var UNMOUNT_UI_STATE = '@@redux-ui/UNMOUNT_UI_STATE';

var defaultState = exports.defaultState = new _immutable.Map({
  __reducers: new _immutable.Map({
    // This contains a map of component paths (joined by '.') to an object
    // containing the fully qualified path and the reducer function:
    // 'parent.child': {
    //   path: ['parent', 'child'],
    //   func: (state, action) => { ... }
    // }
  })
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];

  var key = action.payload && (action.payload.key || []);

  if (!Array.isArray(key)) {
    key = [key];
  }

  switch (action.type) {
    case UPDATE_UI_STATE:
      var _action$payload = action.payload,
          name = _action$payload.name,
          value = _action$payload.value;

      if (typeof value === 'function') {
        state = state.updateIn(key.concat(name), value);
      } else {
        state = state.setIn(key.concat(name), value);
      }
      break;

    case MASS_UPDATE_UI_STATE:
      var _action$payload2 = action.payload,
          uiVars = _action$payload2.uiVars,
          transforms = _action$payload2.transforms;

      state = state.withMutations(function (s) {
        Object.keys(transforms).forEach(function (k) {
          var path = uiVars[k];
          (0, _invariant2.default)(path, 'Couldn\'t find variable ' + k + ' within your component\'s UI state ' + ('context. Define ' + k + ' before using it in the @ui decorator'));

          s.setIn(path.concat(k), transforms[k]);
        });
      });
      break;

    case SET_DEFAULT_UI_STATE:
      // Replace all UI under a key with the given values
      state = state.setIn(key, new _immutable.Map(action.payload.value));
      break;

    case MOUNT_UI_STATE:
      var _action$payload3 = action.payload,
          defaults = _action$payload3.defaults,
          customReducer = _action$payload3.customReducer;

      state = state.withMutations(function (s) {
        // Set the defaults for the component
        s.setIn(key, new _immutable.Map(defaults));

        // If this component has a custom reducer add it to the list.
        // We store the reducer func and UI path for the current component
        // inside the __reducers map.
        if (customReducer) {
          var path = key.join('.');
          s.setIn(['__reducers', path], {
            path: key,
            func: customReducer
          });
        }

        return s;
      });
      break;

    case UNMOUNT_UI_STATE:
      // We have to use deleteIn as react unmounts root components first;
      // this means that using setIn in child contexts will fail as the root
      // context will be stored as undefined in our state
      state = state.withMutations(function (s) {
        s.deleteIn(key);
        // Remove any custom reducers
        s.deleteIn(['__reducers', key.join('.')]);
      });
      break;
  }

  var customReducers = state.get('__reducers');
  if (customReducers.size > 0) {
    state = state.withMutations(function (mut) {
      customReducers.forEach(function (r) {
        // This calls each custom reducer with the UI state for each custom
        // reducer with the component's UI state tree passed into it.
        //
        // NOTE: Each component's reducer gets its own UI state: not the entire
        // UI reducer's state. Whatever is returned from this reducer is set
        // within the **components** UI scope.
        //
        // This is because it's the only way to update UI state for components
        // without keys - you need to know the path in advance to update state
        // from a reducer.  If you have list of components with no UI keys in
        // the component heirarchy, any children will not be able to use custom
        // reducers as the path is random.
        //
        // TODO: Potentially add the possibility for a global UI state reducer?
        //       Though why wouldn't you just add a custom reducer to the
        //       top-level component?
        var path = r.path,
            func = r.func;

        var newState = func(mut.getIn(path), action);
        if (newState === undefined) {
          throw new Error('Your custom UI reducer at path ' + path.join('.') + ' must return some state');
        }
        mut.setIn(path, newState);
      });
      return mut;
    });
  }

  return state;
}

var reducerEnhancer = exports.reducerEnhancer = function reducerEnhancer(customReducer) {
  return function (state, action) {
    state = reducer(state, action);
    if (typeof customReducer === 'function') {
      state = customReducer(state, action);
    }
    return state;
  };
};

function updateUI(key, name, value) {
  return {
    type: UPDATE_UI_STATE,
    payload: {
      key: key,
      name: name,
      value: value
    }
  };
};

function massUpdateUI(uiVars, transforms) {
  return {
    type: MASS_UPDATE_UI_STATE,
    payload: {
      uiVars: uiVars,
      transforms: transforms
    }
  };
}

// Exposed to components, allowing them to reset their and all child scopes to
// the default variables set up
function setDefaultUI(key, value) {
  return {
    type: SET_DEFAULT_UI_STATE,
    payload: {
      key: key,
      value: value
    }
  };
};

/** Private, decorator only actions **/

// This is not exposed to your components; it's only used in the decorator.
function unmountUI(key) {
  return {
    type: UNMOUNT_UI_STATE,
    payload: {
      key: key
    }
  };
};

/**
 * Given the key/path, set of defaults and custom reducer for a UI component
 * during construction prepare the state of the UI reducer
 *
 */
function mountUI(key, defaults, customReducer) {
  return {
    type: MOUNT_UI_STATE,
    payload: {
      key: key,
      defaults: defaults,
      customReducer: customReducer
    }
  };
}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(245);

var _app = __webpack_require__(1282);

var _app2 = _interopRequireDefault(_app);

var _loginPage = __webpack_require__(1812);

var _loginPage2 = _interopRequireDefault(_loginPage);

var _mainPage = __webpack_require__(1846);

var _mainPage2 = _interopRequireDefault(_mainPage);

var _groupsPage = __webpack_require__(2338);

var _groupsPage2 = _interopRequireDefault(_groupsPage);

var _groupTimelinePage = __webpack_require__(2502);

var _groupTimelinePage2 = _interopRequireDefault(_groupTimelinePage);

var _homeGroupsPage = __webpack_require__(2794);

var _homeGroupsPage2 = _interopRequireDefault(_homeGroupsPage);

var _divisionGroupsPage = __webpack_require__(2798);

var _divisionGroupsPage2 = _interopRequireDefault(_divisionGroupsPage);

var _divisionNotSetGroupsPage = __webpack_require__(2812);

var _divisionNotSetGroupsPage2 = _interopRequireDefault(_divisionNotSetGroupsPage);

var _unavailablePage = __webpack_require__(2816);

var _unavailablePage2 = _interopRequireDefault(_unavailablePage);

var _pickupDiariesPage = __webpack_require__(1062);

var _pickupDiariesPage2 = _interopRequireDefault(_pickupDiariesPage);

var _chatMessagesPage = __webpack_require__(1088);

var _chatMessagesPage2 = _interopRequireDefault(_chatMessagesPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createElement(
  _reactRouter.Route,
  { component: _app2.default },
  _react2.default.createElement(_reactRouter.Route, { component: _loginPage2.default, path: '/login', name: 'login' }),
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _mainPage2.default, path: '/', name: 'main' },
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _homeGroupsPage2.default, path: '/groups/home', name: 'home_group' },
      _react2.default.createElement(_reactRouter.Route, { component: _pickupDiariesPage2.default, path: '/groups/home/pickup', name: 'home_pickup' }),
      _react2.default.createElement(_reactRouter.Route, { component: _chatMessagesPage2.default, path: '/groups/home/messages/:chat_room_id', name: 'chat_messages' })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _groupsPage2.default, path: '/groups/:group_id', name: 'group' },
      _react2.default.createElement(
        _reactRouter.Route,
        { component: _groupTimelinePage2.default, path: 'timeline', name: 'group_timeline' },
        _react2.default.createElement(_reactRouter.Route, { component: _pickupDiariesPage2.default, path: 'pickup', name: 'group_pickup' })
      ),
      _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'timeline' })
    ),
    _react2.default.createElement(_reactRouter.Route, { component: _divisionGroupsPage2.default, path: '/section/:division_id', name: 'division_group' }),
    _react2.default.createElement(_reactRouter.Route, { component: _divisionNotSetGroupsPage2.default, path: '/section-new/:division_id', name: 'division_not_set_group' })
  ),
  _react2.default.createElement(_reactRouter.Route, { component: _unavailablePage2.default, path: '/unavailable', name: 'unavailable' })
);
// src/web/routes

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(175);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 750 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(425),
    isIterateeCall = __webpack_require__(426);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1290);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1291),
    shortOut = __webpack_require__(1293);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(755),
    isArguments = __webpack_require__(309),
    isArray = __webpack_require__(62),
    isBuffer = __webpack_require__(310),
    isIndex = __webpack_require__(428),
    isTypedArray = __webpack_require__(429);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 755 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(757);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 757 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(159);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(434),
    arraySome = __webpack_require__(760),
    cacheHas = __webpack_require__(435);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 760 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(105);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(763),
    getSymbols = __webpack_require__(437),
    keys = __webpack_require__(138);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(316),
    isArray = __webpack_require__(62);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 764 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 765 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(175),
    root = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(98);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 768 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(770);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(771),
    toKey = __webpack_require__(319);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(62),
    isKey = __webpack_require__(438),
    stringToPath = __webpack_require__(1336),
    toString = __webpack_require__(1339);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 772 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED = exports.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED = exports.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED = exports.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS = exports.FETCH_OTHER_MEMBERS_COUNT_FAILED = exports.FETCH_OTHER_MEMBERS_COUNT_COMPLETED = exports.FETCH_OTHER_MEMBERS_COUNT_REQUESTED = exports.FETCH_OTHER_MEMBERS_COUNT = exports.FETCH_GROUP_MEMBERS_USERS = exports.CLEAR_FETCHED_USERS = exports.FETCH_OTHER_MEMBERS_FAILED = exports.FETCH_OTHER_MEMBERS_COMPLETED = exports.FETCH_OTHER_MEMBERS_REQUESTED = exports.FETCH_OTHER_MEMBERS = exports.FETCH_MENTION_TO_USERS_FAILED = exports.FETCH_MENTION_TO_USERS_COMPLETED = exports.FETCH_MENTION_TO_USERS_REQUESTED = exports.FETCH_MENTION_TO_USERS = exports.FETCH_ACCOUNT_MEMBERS_FAILED = exports.FETCH_ACCOUNT_MEMBERS_COMPLETED = exports.FETCH_ACCOUNT_MEMBERS_REQUESTED = exports.FETCH_ACCOUNT_MEMBERS = exports.FETCH_USERS_LENGTH = undefined;
exports.fetchAccountMembersRequested = fetchAccountMembersRequested;
exports.fetchAccountMembers = fetchAccountMembers;
exports.fetchAccountMembersCompleted = fetchAccountMembersCompleted;
exports.fetchAccountMembersFailed = fetchAccountMembersFailed;
exports.fetchMentionToUsersRequested = fetchMentionToUsersRequested;
exports.fetchMentionToUsers = fetchMentionToUsers;
exports.fetchMentionToUsersCompleted = fetchMentionToUsersCompleted;
exports.fetchMentionToUsersFailed = fetchMentionToUsersFailed;
exports.fetchOtherMembersRequested = fetchOtherMembersRequested;
exports.fetchOtherMembers = fetchOtherMembers;
exports.fetchOtherMembersCompleted = fetchOtherMembersCompleted;
exports.fetchOtherMembersFailed = fetchOtherMembersFailed;
exports.clearFetchedUsers = clearFetchedUsers;
exports.fetchGroupMembersUsers = fetchGroupMembersUsers;
exports.fetchOtherMembersCountRequested = fetchOtherMembersCountRequested;
exports.fetchOtherMembersCount = fetchOtherMembersCount;
exports.fetchOtherMembersCountCompleted = fetchOtherMembersCountCompleted;
exports.fetchOtherMembersCountFailed = fetchOtherMembersCountFailed;
exports.fetchGroupMembersOnlyResignedMembersRequested = fetchGroupMembersOnlyResignedMembersRequested;
exports.fetchGroupMembersOnlyResignedMembers = fetchGroupMembersOnlyResignedMembers;
exports.fetchGroupMembersOnlyResignedMembersCompleted = fetchGroupMembersOnlyResignedMembersCompleted;
exports.fetchGroupMembersOnlyResignedMembersFailed = fetchGroupMembersOnlyResignedMembersFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_USERS_LENGTH = exports.FETCH_USERS_LENGTH = 99999999;
// src/actions/account.js

var FETCH_ACCOUNT_MEMBERS = exports.FETCH_ACCOUNT_MEMBERS = "FETCH_ACCOUNT_MEMBERS";
var FETCH_ACCOUNT_MEMBERS_REQUESTED = exports.FETCH_ACCOUNT_MEMBERS_REQUESTED = "FETCH_ACCOUNT_MEMBERS_REQUESTED";
var FETCH_ACCOUNT_MEMBERS_COMPLETED = exports.FETCH_ACCOUNT_MEMBERS_COMPLETED = "FETCH_ACCOUNT_MEMBERS_COMPLETED";
var FETCH_ACCOUNT_MEMBERS_FAILED = exports.FETCH_ACCOUNT_MEMBERS_FAILED = "FETCH_ACCOUNT_MEMBERS_FAILED";

function fetchAccountMembersRequested() {
  return {
    type: FETCH_ACCOUNT_MEMBERS_REQUESTED
  };
}

function fetchAccountMembers(offset) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  return function (dispatch) {
    dispatch(fetchAccountMembersRequested());
    return _gambaApi2.default.get('/account/members', { offset: offset, query: query, length: FETCH_USERS_LENGTH }).then(function (results) {
      dispatch(fetchAccountMembersCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAccountMembersFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAccountMembersCompleted(results, offset) {
  return {
    type: FETCH_ACCOUNT_MEMBERS_COMPLETED,
    results: results, offset: offset
  };
}

function fetchAccountMembersFailed(error) {
  return {
    type: FETCH_ACCOUNT_MEMBERS_FAILED,
    error: error
  };
}

var FETCH_MENTION_TO_USERS = exports.FETCH_MENTION_TO_USERS = "FETCH_MENTION_TO_USERS";
var FETCH_MENTION_TO_USERS_REQUESTED = exports.FETCH_MENTION_TO_USERS_REQUESTED = "FETCH_MENTION_TO_USERS_REQUESTED";
var FETCH_MENTION_TO_USERS_COMPLETED = exports.FETCH_MENTION_TO_USERS_COMPLETED = "FETCH_MENTION_TO_USERS_COMPLETED";
var FETCH_MENTION_TO_USERS_FAILED = exports.FETCH_MENTION_TO_USERS_FAILED = "FETCH_MENTION_TO_USERS_FAILED";

function fetchMentionToUsersRequested() {
  return {
    type: FETCH_MENTION_TO_USERS_REQUESTED
  };
}

function fetchMentionToUsers(offset, mention_group_id, mentions_ids) {
  var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

  return function (dispatch) {
    dispatch(fetchMentionToUsersRequested());
    return _gambaApi2.default.get('/account/members', { offset: offset, query: query, mention_group_id: mention_group_id, mentions_ids: mentions_ids, length: FETCH_USERS_LENGTH }).then(function (results) {
      dispatch(fetchMentionToUsersCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchMentionToUsersFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchMentionToUsersCompleted(results, offset) {
  return {
    type: FETCH_MENTION_TO_USERS_COMPLETED,
    results: results, offset: offset
  };
}

function fetchMentionToUsersFailed(error) {
  return {
    type: FETCH_MENTION_TO_USERS_FAILED,
    error: error
  };
}

var FETCH_OTHER_MEMBERS = exports.FETCH_OTHER_MEMBERS = "FETCH_OTHER_MEMBERS";
var FETCH_OTHER_MEMBERS_REQUESTED = exports.FETCH_OTHER_MEMBERS_REQUESTED = "FETCH_OTHER_MEMBERS_REQUESTED";
var FETCH_OTHER_MEMBERS_COMPLETED = exports.FETCH_OTHER_MEMBERS_COMPLETED = "FETCH_OTHER_MEMBERS_COMPLETED";
var FETCH_OTHER_MEMBERS_FAILED = exports.FETCH_OTHER_MEMBERS_FAILED = "FETCH_OTHER_MEMBERS_FAILED";

function fetchOtherMembersRequested() {
  return {
    type: FETCH_OTHER_MEMBERS_REQUESTED
  };
}

function fetchOtherMembers(offset, exclude_group_id) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return function (dispatch) {
    dispatch(fetchOtherMembersRequested());
    return _gambaApi2.default.get('/account/members', { offset: offset, query: query, exclude_group_id: exclude_group_id, length: FETCH_USERS_LENGTH }).then(function (results) {
      dispatch(fetchOtherMembersCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchOtherMembersFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchOtherMembersCompleted(results, offset) {
  return {
    type: FETCH_OTHER_MEMBERS_COMPLETED,
    results: results, offset: offset
  };
}

function fetchOtherMembersFailed(error) {
  return {
    type: FETCH_OTHER_MEMBERS_FAILED,
    error: error
  };
}

var CLEAR_FETCHED_USERS = exports.CLEAR_FETCHED_USERS = "CLEAR_FETCHED_USERS";

function clearFetchedUsers() {
  return {
    type: CLEAR_FETCHED_USERS
  };
}

var FETCH_GROUP_MEMBERS_USERS = exports.FETCH_GROUP_MEMBERS_USERS = "FETCH_GROUP_MEMBERS_USERS";

function fetchGroupMembersUsers(members, query) {
  return {
    type: FETCH_GROUP_MEMBERS_USERS,
    users: query && (0, _filter2.default)(members, function (member) {
      return member.name.match(query) || member.email.match(query);
    }) || members
  };
}

var FETCH_OTHER_MEMBERS_COUNT = exports.FETCH_OTHER_MEMBERS_COUNT = "FETCH_OTHER_MEMBERS_COUNT";
var FETCH_OTHER_MEMBERS_COUNT_REQUESTED = exports.FETCH_OTHER_MEMBERS_COUNT_REQUESTED = "FETCH_OTHER_MEMBERS_COUNT_REQUESTED";
var FETCH_OTHER_MEMBERS_COUNT_COMPLETED = exports.FETCH_OTHER_MEMBERS_COUNT_COMPLETED = "FETCH_OTHER_MEMBERS_COUNT_COMPLETED";
var FETCH_OTHER_MEMBERS_COUNT_FAILED = exports.FETCH_OTHER_MEMBERS_COUNT_FAILED = "FETCH_OTHER_MEMBERS_COUNT_FAILED";

function fetchOtherMembersCountRequested() {
  return {
    type: FETCH_OTHER_MEMBERS_COUNT_REQUESTED
  };
}

function fetchOtherMembersCount(exclude_group_id) {
  return function (dispatch) {
    dispatch(fetchOtherMembersCountRequested());
    return _gambaApi2.default.get('/account/members', { offset: 0, exclude_group_id: exclude_group_id, length: 1 }).then(function (results) {
      dispatch(fetchOtherMembersCountCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchOtherMembersCountFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchOtherMembersCountCompleted(results) {
  return {
    type: FETCH_OTHER_MEMBERS_COUNT_COMPLETED,
    results: results
  };
}

function fetchOtherMembersCountFailed(error) {
  return {
    type: FETCH_OTHER_MEMBERS_COUNT_FAILED,
    error: error
  };
}

var FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS = exports.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS = "FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS";
var FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED = exports.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED = "FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED";
var FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED = exports.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED = "FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED";
var FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED = exports.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED = "FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED";

function fetchGroupMembersOnlyResignedMembersRequested() {
  return {
    type: FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED
  };
}

function fetchGroupMembersOnlyResignedMembers(offset, group_id) {
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return function (dispatch) {
    dispatch(fetchGroupMembersOnlyResignedMembersRequested());
    return _gambaApi2.default.get('/groups/' + group_id + '/members', { offset: offset, query: query, length: FETCH_USERS_LENGTH, only_resigned_members: true }).then(function (results) {
      dispatch(fetchGroupMembersOnlyResignedMembersCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchGroupMembersOnlyResignedMembersFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchGroupMembersOnlyResignedMembersCompleted(results, offset) {
  return {
    type: FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED,
    results: results, offset: offset
  };
}

function fetchGroupMembersOnlyResignedMembersFailed(error) {
  return {
    type: FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED,
    error: error
  };
}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);

var AWS = __webpack_require__(7);

if (typeof window !== 'undefined') window.AWS = AWS;
if (true) module.exports = AWS;
if (typeof self !== 'undefined') self.AWS = AWS;

/**
 * @private
 * DO NOT REMOVE
 * browser builder will strip out this line if services are supplied on the command line.
 */
__webpack_require__(1503);

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var util = __webpack_require__(68);
var QueryParamSerializer = __webpack_require__(1351);
var Shape = __webpack_require__(253);

function buildRequest(req) {
  var operation = req.service.api.operations[req.operation];
  var httpRequest = req.httpRequest;
  httpRequest.headers['Content-Type'] =
    'application/x-www-form-urlencoded; charset=utf-8';
  httpRequest.params = {
    Version: req.service.api.apiVersion,
    Action: operation.name
  };

  // convert the request parameters into a list of query params,
  // e.g. Deeply.NestedParam.0.Name=value
  var builder = new QueryParamSerializer();
  builder.serialize(req.params, operation.input, function(name, value) {
    httpRequest.params[name] = value;
  });
  httpRequest.body = util.queryParamsToString(httpRequest.params);
}

function extractError(resp) {
  var data, body = resp.httpResponse.body.toString();
  if (body.match('<UnknownOperationException')) {
    data = {
      Code: 'UnknownOperation',
      Message: 'Unknown operation ' + resp.request.operation
    };
  } else {
    try {
      data = new AWS.XML.Parser().parse(body);
    } catch (e) {
      data = {
        Code: resp.httpResponse.statusCode,
        Message: resp.httpResponse.statusMessage
      };
    }
  }

  if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
  if (data.Errors) data = data.Errors;
  if (data.Error) data = data.Error;
  if (data.Code) {
    resp.error = util.error(new Error(), {
      code: data.Code,
      message: data.Message
    });
  } else {
    resp.error = util.error(new Error(), {
      code: resp.httpResponse.statusCode,
      message: null
    });
  }
}

function extractData(resp) {
  var req = resp.request;
  var operation = req.service.api.operations[req.operation];
  var shape = operation.output || {};
  var origRules = shape;

  if (origRules.resultWrapper) {
    var tmp = Shape.create({type: 'structure'});
    tmp.members[origRules.resultWrapper] = shape;
    tmp.memberNames = [origRules.resultWrapper];
    util.property(shape, 'name', shape.resultWrapper);
    shape = tmp;
  }

  var parser = new AWS.XML.Parser();

  // TODO: Refactor XML Parser to parse RequestId from response.
  if (shape && shape.members && !shape.members._XAMZRequestId) {
    var requestIdShape = Shape.create(
      { type: 'string' },
      { api: { protocol: 'query' } },
      'requestId'
    );
    shape.members._XAMZRequestId = requestIdShape;
  }

  var data = parser.parse(resp.httpResponse.body.toString(), shape);
  resp.requestId = data._XAMZRequestId || data.requestId;

  if (data._XAMZRequestId) delete data._XAMZRequestId;

  if (origRules.resultWrapper) {
    if (data[origRules.resultWrapper]) {
      util.update(data, data[origRules.resultWrapper]);
      delete data[origRules.resultWrapper];
    }
  }

  resp.data = data;
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var memoizedProperty = __webpack_require__(68).memoizedProperty;

function memoize(name, value, fn, nameTr) {
  memoizedProperty(this, nameTr(name), function() {
    return fn(name, value);
  });
}

function Collection(iterable, options, fn, nameTr) {
  nameTr = nameTr || String;
  var self = this;

  for (var id in iterable) {
    if (Object.prototype.hasOwnProperty.call(iterable, id)) {
      memoize.call(self, id, iterable[id], fn, nameTr);
    }
  }
}

module.exports = Collection;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(68);
var Rest = __webpack_require__(321);
var Json = __webpack_require__(440);
var JsonBuilder = __webpack_require__(441);
var JsonParser = __webpack_require__(442);

function populateBody(req) {
  var builder = new JsonBuilder();
  var input = req.service.api.operations[req.operation].input;

  if (input.payload) {
    var params = {};
    var payloadShape = input.members[input.payload];
    params = req.params[input.payload];
    if (params === undefined) return;

    if (payloadShape.type === 'structure') {
      req.httpRequest.body = builder.build(params, payloadShape);
      applyContentTypeHeader(req);
    } else { // non-JSON payload
      req.httpRequest.body = params;
    }
  } else {
    req.httpRequest.body = builder.build(req.params, input);
    applyContentTypeHeader(req);
  }
}

function applyContentTypeHeader(req) {
  if (!req.httpRequest.headers['Content-Type']) {
    req.httpRequest.headers['Content-Type'] = 'application/json';
  }
}

function buildRequest(req) {
  Rest.buildRequest(req);

  // never send body payload on GET/HEAD/DELETE
  if (['GET', 'HEAD', 'DELETE'].indexOf(req.httpRequest.method) < 0) {
    populateBody(req);
  }
}

function extractError(resp) {
  Json.extractError(resp);
}

function extractData(resp) {
  Rest.extractData(resp);

  var req = resp.request;
  var rules = req.service.api.operations[req.operation].output || {};
  if (rules.payload) {
    var payloadMember = rules.members[rules.payload];
    var body = resp.httpResponse.body;
    if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
      var parser = new JsonParser();
      resp.data[rules.payload] = parser.parse(body, payloadMember);
    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
      resp.data[rules.payload] = body;
    } else {
      resp.data[rules.payload] = payloadMember.toType(body);
    }
  } else {
    var data = resp.data;
    Json.extractData(resp);
    resp.data = util.merge(data, resp.data);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var util = __webpack_require__(68);
var Rest = __webpack_require__(321);

function populateBody(req) {
  var input = req.service.api.operations[req.operation].input;
  var builder = new AWS.XML.Builder();
  var params = req.params;

  var payload = input.payload;
  if (payload) {
    var payloadMember = input.members[payload];
    params = params[payload];
    if (params === undefined) return;

    if (payloadMember.type === 'structure') {
      var rootElement = payloadMember.name;
      req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
    } else { // non-xml payload
      req.httpRequest.body = params;
    }
  } else {
    req.httpRequest.body = builder.toXML(params, input, input.name ||
      input.shape || util.string.upperFirst(req.operation) + 'Request');
  }
}

function buildRequest(req) {
  Rest.buildRequest(req);

  // never send body payload on GET/HEAD
  if (['GET', 'HEAD'].indexOf(req.httpRequest.method) < 0) {
    populateBody(req);
  }
}

function extractError(resp) {
  Rest.extractError(resp);

  var data;
  try {
    data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
  } catch (e) {
    data = {
      Code: resp.httpResponse.statusCode,
      Message: resp.httpResponse.statusMessage
    };
  }

  if (data.Errors) data = data.Errors;
  if (data.Error) data = data.Error;
  if (data.Code) {
    resp.error = util.error(new Error(), {
      code: data.Code,
      message: data.Message
    });
  } else {
    resp.error = util.error(new Error(), {
      code: resp.httpResponse.statusCode,
      message: null
    });
  }
}

function extractData(resp) {
  Rest.extractData(resp);

  var parser;
  var req = resp.request;
  var body = resp.httpResponse.body;
  var operation = req.service.api.operations[req.operation];
  var output = operation.output;

  var payload = output.payload;
  if (payload) {
    var payloadMember = output.members[payload];
    if (payloadMember.type === 'structure') {
      parser = new AWS.XML.Parser();
      resp.data[payload] = parser.parse(body.toString(), payloadMember);
    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
      resp.data[payload] = body;
    } else {
      resp.data[payload] = payloadMember.toType(body);
    }
  } else if (body.length > 0) {
    parser = new AWS.XML.Parser();
    var data = parser.parse(body.toString(), output);
    util.update(resp.data, data);
  }
}

module.exports = {
  buildRequest: buildRequest,
  extractError: extractError,
  extractData: extractData
};


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(780),
    eq = __webpack_require__(324);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(781);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(176);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 783 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(779),
    baseAssignValue = __webpack_require__(780);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(324),
    isArrayLike = __webpack_require__(255),
    isIndex = __webpack_require__(445),
    isObject = __webpack_require__(119);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(446),
    nativeKeys = __webpack_require__(1376);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDeclaration, XMLNode, create, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(90);

  isObject = __webpack_require__(119);

  XMLNode = __webpack_require__(221);

  module.exports = XMLDeclaration = (function(superClass) {
    extend(XMLDeclaration, superClass);

    function XMLDeclaration(parent, version, encoding, standalone) {
      var ref;
      XMLDeclaration.__super__.constructor.call(this, parent);
      if (isObject(version)) {
        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
      }
      if (!version) {
        version = '1.0';
      }
      this.version = this.stringify.xmlVersion(version);
      if (encoding != null) {
        this.encoding = this.stringify.xmlEncoding(encoding);
      }
      if (standalone != null) {
        this.standalone = this.stringify.xmlStandalone(standalone);
      }
    }

    XMLDeclaration.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<?xml';
      r += ' version="' + this.version + '"';
      if (this.encoding != null) {
        r += ' encoding="' + this.encoding + '"';
      }
      if (this.standalone != null) {
        r += ' standalone="' + this.standalone + '"';
      }
      r += '?>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDeclaration;

  })(XMLNode);

}).call(this);


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1383),
    Map = __webpack_require__(450),
    Promise = __webpack_require__(1384),
    Set = __webpack_require__(1385),
    WeakMap = __webpack_require__(1386),
    baseGetTag = __webpack_require__(254),
    toSource = __webpack_require__(783);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLAttribute, XMLElement, XMLNode, XMLProcessingInstruction, create, every, isFunction, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(90);

  isObject = __webpack_require__(119);

  isFunction = __webpack_require__(322);

  every = __webpack_require__(1387);

  XMLNode = __webpack_require__(221);

  XMLAttribute = __webpack_require__(1452);

  XMLProcessingInstruction = __webpack_require__(797);

  module.exports = XMLElement = (function(superClass) {
    extend(XMLElement, superClass);

    function XMLElement(parent, name, attributes) {
      XMLElement.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing element name");
      }
      this.name = this.stringify.eleName(name);
      this.children = [];
      this.instructions = [];
      this.attributes = {};
      if (attributes != null) {
        this.attribute(attributes);
      }
    }

    XMLElement.prototype.clone = function() {
      var att, attName, clonedSelf, i, len, pi, ref, ref1;
      clonedSelf = create(XMLElement.prototype, this);
      if (clonedSelf.isRoot) {
        clonedSelf.documentObject = null;
      }
      clonedSelf.attributes = {};
      ref = this.attributes;
      for (attName in ref) {
        if (!hasProp.call(ref, attName)) continue;
        att = ref[attName];
        clonedSelf.attributes[attName] = att.clone();
      }
      clonedSelf.instructions = [];
      ref1 = this.instructions;
      for (i = 0, len = ref1.length; i < len; i++) {
        pi = ref1[i];
        clonedSelf.instructions.push(pi.clone());
      }
      clonedSelf.children = [];
      this.children.forEach(function(child) {
        var clonedChild;
        clonedChild = child.clone();
        clonedChild.parent = clonedSelf;
        return clonedSelf.children.push(clonedChild);
      });
      return clonedSelf;
    };

    XMLElement.prototype.attribute = function(name, value) {
      var attName, attValue;
      if (name != null) {
        name = name.valueOf();
      }
      if (isObject(name)) {
        for (attName in name) {
          if (!hasProp.call(name, attName)) continue;
          attValue = name[attName];
          this.attribute(attName, attValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        if (!this.options.skipNullAttributes || (value != null)) {
          this.attributes[name] = new XMLAttribute(this, name, value);
        }
      }
      return this;
    };

    XMLElement.prototype.removeAttribute = function(name) {
      var attName, i, len;
      if (name == null) {
        throw new Error("Missing attribute name");
      }
      name = name.valueOf();
      if (Array.isArray(name)) {
        for (i = 0, len = name.length; i < len; i++) {
          attName = name[i];
          delete this.attributes[attName];
        }
      } else {
        delete this.attributes[name];
      }
      return this;
    };

    XMLElement.prototype.instruction = function(target, value) {
      var i, insTarget, insValue, instruction, len;
      if (target != null) {
        target = target.valueOf();
      }
      if (value != null) {
        value = value.valueOf();
      }
      if (Array.isArray(target)) {
        for (i = 0, len = target.length; i < len; i++) {
          insTarget = target[i];
          this.instruction(insTarget);
        }
      } else if (isObject(target)) {
        for (insTarget in target) {
          if (!hasProp.call(target, insTarget)) continue;
          insValue = target[insTarget];
          this.instruction(insTarget, insValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        instruction = new XMLProcessingInstruction(this, target, value);
        this.instructions.push(instruction);
      }
      return this;
    };

    XMLElement.prototype.toString = function(options, level) {
      var att, child, i, indent, instruction, j, len, len1, name, newline, offset, pretty, r, ref, ref1, ref2, ref3, ref4, ref5, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      ref3 = this.instructions;
      for (i = 0, len = ref3.length; i < len; i++) {
        instruction = ref3[i];
        r += instruction.toString(options, level);
      }
      if (pretty) {
        r += space;
      }
      r += '<' + this.name;
      ref4 = this.attributes;
      for (name in ref4) {
        if (!hasProp.call(ref4, name)) continue;
        att = ref4[name];
        r += att.toString(options);
      }
      if (this.children.length === 0 || every(this.children, function(e) {
        return e.value === '';
      })) {
        r += '/>';
        if (pretty) {
          r += newline;
        }
      } else if (pretty && this.children.length === 1 && (this.children[0].value != null)) {
        r += '>';
        r += this.children[0].value;
        r += '</' + this.name + '>';
        r += newline;
      } else {
        r += '>';
        if (pretty) {
          r += newline;
        }
        ref5 = this.children;
        for (j = 0, len1 = ref5.length; j < len1; j++) {
          child = ref5[j];
          r += child.toString(options, level + 1);
        }
        if (pretty) {
          r += space;
        }
        r += '</' + this.name + '>';
        if (pretty) {
          r += newline;
        }
      }
      return r;
    };

    XMLElement.prototype.att = function(name, value) {
      return this.attribute(name, value);
    };

    XMLElement.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLElement.prototype.a = function(name, value) {
      return this.attribute(name, value);
    };

    XMLElement.prototype.i = function(target, value) {
      return this.instruction(target, value);
    };

    return XMLElement;

  })(XMLNode);

}).call(this);


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(325),
    stackClear = __webpack_require__(1403),
    stackDelete = __webpack_require__(1404),
    stackGet = __webpack_require__(1405),
    stackHas = __webpack_require__(1406),
    stackSet = __webpack_require__(1407);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1420),
    isObjectLike = __webpack_require__(257);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1421),
    arraySome = __webpack_require__(1424),
    cacheHas = __webpack_require__(1425);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(119);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(796),
    toKey = __webpack_require__(329);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(120),
    isKey = __webpack_require__(452),
    stringToPath = __webpack_require__(1440),
    toString = __webpack_require__(1443);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLProcessingInstruction, create;

  create = __webpack_require__(90);

  module.exports = XMLProcessingInstruction = (function() {
    function XMLProcessingInstruction(parent, target, value) {
      this.stringify = parent.stringify;
      if (target == null) {
        throw new Error("Missing instruction target");
      }
      this.target = this.stringify.insTarget(target);
      if (value) {
        this.value = this.stringify.insValue(value);
      }
    }

    XMLProcessingInstruction.prototype.clone = function() {
      return create(XMLProcessingInstruction.prototype, this);
    };

    XMLProcessingInstruction.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<?';
      r += this.target;
      if (this.value) {
        r += ' ' + this.value;
      }
      r += '?>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLProcessingInstruction;

  })();

}).call(this);


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLCData, XMLNode, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(90);

  XMLNode = __webpack_require__(221);

  module.exports = XMLCData = (function(superClass) {
    extend(XMLCData, superClass);

    function XMLCData(parent, text) {
      XMLCData.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing CDATA text");
      }
      this.text = this.stringify.cdata(text);
    }

    XMLCData.prototype.clone = function() {
      return create(XMLCData.prototype, this);
    };

    XMLCData.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<![CDATA[' + this.text + ']]>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLCData;

  })(XMLNode);

}).call(this);


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLComment, XMLNode, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(90);

  XMLNode = __webpack_require__(221);

  module.exports = XMLComment = (function(superClass) {
    extend(XMLComment, superClass);

    function XMLComment(parent, text) {
      XMLComment.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing comment text");
      }
      this.text = this.stringify.comment(text);
    }

    XMLComment.prototype.clone = function() {
      return create(XMLComment.prototype, this);
    };

    XMLComment.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!-- ' + this.text + ' -->';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLComment;

  })(XMLNode);

}).call(this);


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLProcessingInstruction, create, isObject;

  create = __webpack_require__(90);

  isObject = __webpack_require__(119);

  XMLCData = __webpack_require__(798);

  XMLComment = __webpack_require__(799);

  XMLDTDAttList = __webpack_require__(1453);

  XMLDTDEntity = __webpack_require__(1454);

  XMLDTDElement = __webpack_require__(1455);

  XMLDTDNotation = __webpack_require__(1456);

  XMLProcessingInstruction = __webpack_require__(797);

  module.exports = XMLDocType = (function() {
    function XMLDocType(parent, pubID, sysID) {
      var ref, ref1;
      this.documentObject = parent;
      this.stringify = this.documentObject.stringify;
      this.children = [];
      if (isObject(pubID)) {
        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
      }
      if (sysID == null) {
        ref1 = [pubID, sysID], sysID = ref1[0], pubID = ref1[1];
      }
      if (pubID != null) {
        this.pubID = this.stringify.dtdPubID(pubID);
      }
      if (sysID != null) {
        this.sysID = this.stringify.dtdSysID(sysID);
      }
    }

    XMLDocType.prototype.element = function(name, value) {
      var child;
      child = new XMLDTDElement(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      var child;
      child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.entity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, false, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.pEntity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, true, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.notation = function(name, value) {
      var child;
      child = new XMLDTDNotation(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.cdata = function(value) {
      var child;
      child = new XMLCData(this, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.comment = function(value) {
      var child;
      child = new XMLComment(this, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.instruction = function(target, value) {
      var child;
      child = new XMLProcessingInstruction(this, target, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.root = function() {
      return this.documentObject.root();
    };

    XMLDocType.prototype.document = function() {
      return this.documentObject;
    };

    XMLDocType.prototype.toString = function(options, level) {
      var child, i, indent, len, newline, offset, pretty, r, ref, ref1, ref2, ref3, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!DOCTYPE ' + this.root().name;
      if (this.pubID && this.sysID) {
        r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
      } else if (this.sysID) {
        r += ' SYSTEM "' + this.sysID + '"';
      }
      if (this.children.length > 0) {
        r += ' [';
        if (pretty) {
          r += newline;
        }
        ref3 = this.children;
        for (i = 0, len = ref3.length; i < len; i++) {
          child = ref3[i];
          r += child.toString(options, level + 1);
        }
        r += ']';
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    XMLDocType.prototype.ele = function(name, value) {
      return this.element(name, value);
    };

    XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
    };

    XMLDocType.prototype.ent = function(name, value) {
      return this.entity(name, value);
    };

    XMLDocType.prototype.pent = function(name, value) {
      return this.pEntity(name, value);
    };

    XMLDocType.prototype.not = function(name, value) {
      return this.notation(name, value);
    };

    XMLDocType.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLDocType.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLDocType.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLDocType.prototype.up = function() {
      return this.root();
    };

    XMLDocType.prototype.doc = function() {
      return this.document();
    };

    return XMLDocType;

  })();

}).call(this);


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var Collection = __webpack_require__(776);
var Operation = __webpack_require__(802);
var Shape = __webpack_require__(253);
var Paginator = __webpack_require__(803);
var ResourceWaiter = __webpack_require__(804);

var util = __webpack_require__(68);
var property = util.property;
var memoizedProperty = util.memoizedProperty;

function Api(api, options) {
  api = api || {};
  options = options || {};
  options.api = this;

  api.metadata = api.metadata || {};

  property(this, 'isApi', true, false);
  property(this, 'apiVersion', api.metadata.apiVersion);
  property(this, 'endpointPrefix', api.metadata.endpointPrefix);
  property(this, 'signingName', api.metadata.signingName);
  property(this, 'globalEndpoint', api.metadata.globalEndpoint);
  property(this, 'signatureVersion', api.metadata.signatureVersion);
  property(this, 'jsonVersion', api.metadata.jsonVersion);
  property(this, 'targetPrefix', api.metadata.targetPrefix);
  property(this, 'protocol', api.metadata.protocol);
  property(this, 'timestampFormat', api.metadata.timestampFormat);
  property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
  property(this, 'abbreviation', api.metadata.serviceAbbreviation);
  property(this, 'fullName', api.metadata.serviceFullName);

  memoizedProperty(this, 'className', function() {
    var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
    if (!name) return null;

    name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
    if (name === 'ElasticLoadBalancing') name = 'ELB';
    return name;
  });

  property(this, 'operations', new Collection(api.operations, options, function(name, operation) {
    return new Operation(name, operation, options);
  }, util.string.lowerFirst));

  property(this, 'shapes', new Collection(api.shapes, options, function(name, shape) {
    return Shape.create(shape, options);
  }));

  property(this, 'paginators', new Collection(api.paginators, options, function(name, paginator) {
    return new Paginator(name, paginator, options);
  }));

  property(this, 'waiters', new Collection(api.waiters, options, function(name, waiter) {
    return new ResourceWaiter(name, waiter, options);
  }, util.string.lowerFirst));

  if (options.documentation) {
    property(this, 'documentation', api.documentation);
    property(this, 'documentationUrl', api.documentationUrl);
  }
}

module.exports = Api;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var Shape = __webpack_require__(253);

var util = __webpack_require__(68);
var property = util.property;
var memoizedProperty = util.memoizedProperty;

function Operation(name, operation, options) {
  var self = this;
  options = options || {};

  property(this, 'name', operation.name || name);
  property(this, 'api', options.api, false);

  operation.http = operation.http || {};
  property(this, 'httpMethod', operation.http.method || 'POST');
  property(this, 'httpPath', operation.http.requestUri || '/');
  property(this, 'authtype', operation.authtype || '');

  memoizedProperty(this, 'input', function() {
    if (!operation.input) {
      return new Shape.create({type: 'structure'}, options);
    }
    return Shape.create(operation.input, options);
  });

  memoizedProperty(this, 'output', function() {
    if (!operation.output) {
      return new Shape.create({type: 'structure'}, options);
    }
    return Shape.create(operation.output, options);
  });

  memoizedProperty(this, 'errors', function() {
    var list = [];
    if (!operation.errors) return null;

    for (var i = 0; i < operation.errors.length; i++) {
      list.push(Shape.create(operation.errors[i], options));
    }

    return list;
  });

  memoizedProperty(this, 'paginator', function() {
    return options.api.paginators[name];
  });

  if (options.documentation) {
    property(this, 'documentation', operation.documentation);
    property(this, 'documentationUrl', operation.documentationUrl);
  }

  // idempotentMembers only tracks top-level input shapes
  memoizedProperty(this, 'idempotentMembers', function() {
    var idempotentMembers = [];
    var input = self.input;
    var members = input.members;
    if (!input.members) {
      return idempotentMembers;
    }
    for (var name in members) {
      if (!members.hasOwnProperty(name)) {
        continue;
      }
      if (members[name].isIdempotent === true) {
        idempotentMembers.push(name);
      }
    }
    return idempotentMembers;
  });

}

module.exports = Operation;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var property = __webpack_require__(68).property;

function Paginator(name, paginator) {
  property(this, 'inputToken', paginator.input_token);
  property(this, 'limitKey', paginator.limit_key);
  property(this, 'moreResults', paginator.more_results);
  property(this, 'outputToken', paginator.output_token);
  property(this, 'resultKey', paginator.result_key);
}

module.exports = Paginator;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(68);
var property = util.property;

function ResourceWaiter(name, waiter, options) {
  options = options || {};
  property(this, 'name', name);
  property(this, 'api', options.api, false);

  if (waiter.operation) {
    property(this, 'operation', util.string.lowerFirst(waiter.operation));
  }

  var self = this;
  var keys = [
    'type',
    'description',
    'delay',
    'maxAttempts',
    'acceptors'
  ];

  keys.forEach(function(key) {
    var value = waiter[key];
    if (value) {
      property(self, key, value);
    }
  });
}

module.exports = ResourceWaiter;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

/**
 * Represents your AWS security credentials, specifically the
 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
 * Creating a `Credentials` object allows you to pass around your
 * security information to configuration and service objects.
 *
 * Note that this class typically does not need to be constructed manually,
 * as the {AWS.Config} and {AWS.Service} classes both accept simple
 * options hashes with the three keys. These structures will be converted
 * into Credentials objects automatically.
 *
 * ## Expiring and Refreshing Credentials
 *
 * Occasionally credentials can expire in the middle of a long-running
 * application. In this case, the SDK will automatically attempt to
 * refresh the credentials from the storage location if the Credentials
 * class implements the {refresh} method.
 *
 * If you are implementing a credential storage location, you
 * will want to create a subclass of the `Credentials` class and
 * override the {refresh} method. This method allows credentials to be
 * retrieved from the backing store, be it a file system, database, or
 * some network storage. The method should reset the credential attributes
 * on the object.
 *
 * @!attribute expired
 *   @return [Boolean] whether the credentials have been expired and
 *     require a refresh. Used in conjunction with {expireTime}.
 * @!attribute expireTime
 *   @return [Date] a time when credentials should be considered expired. Used
 *     in conjunction with {expired}.
 * @!attribute accessKeyId
 *   @return [String] the AWS access key ID
 * @!attribute secretAccessKey
 *   @return [String] the AWS secret access key
 * @!attribute sessionToken
 *   @return [String] an optional AWS session token
 */
AWS.Credentials = AWS.util.inherit({
  /**
   * A credentials object can be created using positional arguments or an options
   * hash.
   *
   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
   *   Creates a Credentials object with a given set of credential information
   *   as positional arguments.
   *   @param accessKeyId [String] the AWS access key ID
   *   @param secretAccessKey [String] the AWS secret access key
   *   @param sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
   * @overload AWS.Credentials(options)
   *   Creates a Credentials object with a given set of credential information
   *   as an options hash.
   *   @option options accessKeyId [String] the AWS access key ID
   *   @option options secretAccessKey [String] the AWS secret access key
   *   @option options sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials({
   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
   *     });
   */
  constructor: function Credentials() {
    // hide secretAccessKey from being displayed with util.inspect
    AWS.util.hideProperties(this, ['secretAccessKey']);

    this.expired = false;
    this.expireTime = null;
    if (arguments.length === 1 && typeof arguments[0] === 'object') {
      var creds = arguments[0].credentials || arguments[0];
      this.accessKeyId = creds.accessKeyId;
      this.secretAccessKey = creds.secretAccessKey;
      this.sessionToken = creds.sessionToken;
    } else {
      this.accessKeyId = arguments[0];
      this.secretAccessKey = arguments[1];
      this.sessionToken = arguments[2];
    }
  },

  /**
   * @return [Integer] the number of seconds before {expireTime} during which
   *   the credentials will be considered expired.
   */
  expiryWindow: 15,

  /**
   * @return [Boolean] whether the credentials object should call {refresh}
   * @note Subclasses should override this method to provide custom refresh
   *   logic.
   */
  needsRefresh: function needsRefresh() {
    var currentTime = AWS.util.date.getDate().getTime();
    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);

    if (this.expireTime && adjustedTime > this.expireTime) {
      return true;
    } else {
      return this.expired || !this.accessKeyId || !this.secretAccessKey;
    }
  },

  /**
   * Gets the existing credentials, refreshing them if they are not yet loaded
   * or have expired. Users should call this method before using {refresh},
   * as this will not attempt to reload credentials when they are already
   * loaded into the object.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means either credentials
   *   do not need to be refreshed or refreshed credentials information has
   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
   *   and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   */
  get: function get(callback) {
    var self = this;
    if (this.needsRefresh()) {
      this.refresh(function(err) {
        if (!err) self.expired = false; // reset expired flag
        if (callback) callback(err);
      });
    } else if (callback) {
      callback();
    }
  },

  /**
   * @!method  getPromise()
   *   Returns a 'thenable' promise.
   *   Gets the existing credentials, refreshing them if they are not yet loaded
   *   or have expired. Users should call this method before using {refresh},
   *   as this will not attempt to reload credentials when they are already
   *   loaded into the object.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means either credentials do not need to be refreshed or refreshed
   *     credentials information has been loaded into the object (as the
   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `get` call.
   *   @example Calling the `getPromise` method.
   *     var promise = credProvider.getPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */

  /**
   * @!method  refreshPromise()
   *   Returns a 'thenable' promise.
   *   Refreshes the credentials. Users should call {get} before attempting
   *   to forcibly refresh credentials.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means refreshed credentials information has been loaded into the object
   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `refresh` call.
   *   @example Calling the `refreshPromise` method.
   *     var promise = credProvider.refreshPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */

  /**
   * Refreshes the credentials. Users should call {get} before attempting
   * to forcibly refresh credentials.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means refreshed
   *   credentials information has been loaded into the object (as the
   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @note Subclasses should override this class to reset the
   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
   *   on the credentials object and then call the callback with
   *   any error information.
   * @see get
   */
  refresh: function refresh(callback) {
    this.expired = false;
    callback();
  }
});

/**
 * @api private
 */
AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
};

/**
 * @api private
 */
AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.getPromise;
  delete this.prototype.refreshPromise;
};

AWS.util.addPromises(AWS.Credentials);


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

/**
 * Creates a credential provider chain that searches for AWS credentials
 * in a list of credential providers specified by the {providers} property.
 *
 * By default, the chain will use the {defaultProviders} to resolve credentials.
 * These providers will look in the environment using the
 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
 *
 * ## Setting Providers
 *
 * Each provider in the {providers} list should be a function that returns
 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
 * form allows for delayed execution of the credential construction.
 *
 * ## Resolving Credentials from a Chain
 *
 * Call {resolve} to return the first valid credential object that can be
 * loaded by the provider chain.
 *
 * For example, to resolve a chain with a custom provider that checks a file
 * on disk after the set of {defaultProviders}:
 *
 * ```javascript
 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
 * var chain = new AWS.CredentialProviderChain();
 * chain.providers.push(diskProvider);
 * chain.resolve();
 * ```
 *
 * The above code will return the `diskProvider` object if the
 * file contains credentials and the `defaultProviders` do not contain
 * any credential settings.
 *
 * @!attribute providers
 *   @return [Array<AWS.Credentials, Function>]
 *     a list of credentials objects or functions that return credentials
 *     objects. If the provider is a function, the function will be
 *     executed lazily when the provider needs to be checked for valid
 *     credentials. By default, this object will be set to the
 *     {defaultProviders}.
 *   @see defaultProviders
 */
AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {

  /**
   * Creates a new CredentialProviderChain with a default set of providers
   * specified by {defaultProviders}.
   */
  constructor: function CredentialProviderChain(providers) {
    if (providers) {
      this.providers = providers;
    } else {
      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
    }
  },

  /**
   * @!method  resolvePromise()
   *   Returns a 'thenable' promise.
   *   Resolves the provider chain by searching for the first set of
   *   credentials in {providers}.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(credentials)
   *     Called if the promise is fulfilled and the provider resolves the chain
   *     to a credentials object
   *     @param credentials [AWS.Credentials] the credentials object resolved
   *       by the provider chain.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param err [Error] the error object returned if no credentials are found.
   *   @return [Promise] A promise that represents the state of the `resolve` method call.
   *   @example Calling the `resolvePromise` method.
   *     var promise = chain.resolvePromise();
   *     promise.then(function(credentials) { ... }, function(err) { ... });
   */

  /**
   * Resolves the provider chain by searching for the first set of
   * credentials in {providers}.
   *
   * @callback callback function(err, credentials)
   *   Called when the provider resolves the chain to a credentials object
   *   or null if no credentials can be found.
   *
   *   @param err [Error] the error object returned if no credentials are
   *     found.
   *   @param credentials [AWS.Credentials] the credentials object resolved
   *     by the provider chain.
   * @return [AWS.CredentialProviderChain] the provider, for chaining.
   */
  resolve: function resolve(callback) {
    if (this.providers.length === 0) {
      callback(new Error('No providers'));
      return this;
    }

    var index = 0;
    var providers = this.providers.slice(0);

    function resolveNext(err, creds) {
      if ((!err && creds) || index === providers.length) {
        callback(err, creds);
        return;
      }

      var provider = providers[index++];
      if (typeof provider === 'function') {
        creds = provider.call();
      } else {
        creds = provider;
      }

      if (creds.get) {
        creds.get(function(getErr) {
          resolveNext(getErr, getErr ? null : creds);
        });
      } else {
        resolveNext(null, creds);
      }
    }

    resolveNext();
    return this;
  }
});

/**
 * The default set of providers used by a vanilla CredentialProviderChain.
 *
 * In the browser:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = []
 * ```
 *
 * In Node.js:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = [
 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
 *   function () { return new AWS.SharedIniFileCredentials(); },
 *   function () {
 *     // if AWS_CONTAINER_CREDENTIALS_RELATIVE_URI is set
 *       return new AWS.ECSCredentials();
 *     // else
 *       return new AWS.EC2MetadataCredentials();
 *   }
 * ]
 * ```
 */
AWS.CredentialProviderChain.defaultProviders = [];

/**
 * @api private
 */
AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
};

/**
 * @api private
 */
AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.resolvePromise;
};

AWS.util.addPromises(AWS.CredentialProviderChain);


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var inherit = AWS.util.inherit;

/**
 * The endpoint that a service will talk to, for example,
 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
 * you need to override an endpoint for a service, you can
 * set the endpoint on a service by passing the endpoint
 * object with the `endpoint` option key:
 *
 * ```javascript
 * var ep = new AWS.Endpoint('awsproxy.example.com');
 * var s3 = new AWS.S3({endpoint: ep});
 * s3.service.endpoint.hostname == 'awsproxy.example.com'
 * ```
 *
 * Note that if you do not specify a protocol, the protocol will
 * be selected based on your current {AWS.config} configuration.
 *
 * @!attribute protocol
 *   @return [String] the protocol (http or https) of the endpoint
 *     URL
 * @!attribute hostname
 *   @return [String] the host portion of the endpoint, e.g.,
 *     example.com
 * @!attribute host
 *   @return [String] the host portion of the endpoint including
 *     the port, e.g., example.com:80
 * @!attribute port
 *   @return [Integer] the port of the endpoint
 * @!attribute href
 *   @return [String] the full URL of the endpoint
 */
AWS.Endpoint = inherit({

  /**
   * @overload Endpoint(endpoint)
   *   Constructs a new endpoint given an endpoint URL. If the
   *   URL omits a protocol (http or https), the default protocol
   *   set in the global {AWS.config} will be used.
   *   @param endpoint [String] the URL to construct an endpoint from
   */
  constructor: function Endpoint(endpoint, config) {
    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);

    if (typeof endpoint === 'undefined' || endpoint === null) {
      throw new Error('Invalid endpoint: ' + endpoint);
    } else if (typeof endpoint !== 'string') {
      return AWS.util.copy(endpoint);
    }

    if (!endpoint.match(/^http/)) {
      var useSSL = config && config.sslEnabled !== undefined ?
        config.sslEnabled : AWS.config.sslEnabled;
      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
    }

    AWS.util.update(this, AWS.util.urlParse(endpoint));

    // Ensure the port property is set as an integer
    if (this.port) {
      this.port = parseInt(this.port, 10);
    } else {
      this.port = this.protocol === 'https:' ? 443 : 80;
    }
  }

});

/**
 * The low level HTTP request object, encapsulating all HTTP header
 * and body data sent by a service request.
 *
 * @!attribute method
 *   @return [String] the HTTP method of the request
 * @!attribute path
 *   @return [String] the path portion of the URI, e.g.,
 *     "/list/?start=5&num=10"
 * @!attribute headers
 *   @return [map<String,String>]
 *     a map of header keys and their respective values
 * @!attribute body
 *   @return [String] the request body payload
 * @!attribute endpoint
 *   @return [AWS.Endpoint] the endpoint for the request
 * @!attribute region
 *   @api private
 *   @return [String] the region, for signing purposes only.
 */
AWS.HttpRequest = inherit({

  /**
   * @api private
   */
  constructor: function HttpRequest(endpoint, region) {
    endpoint = new AWS.Endpoint(endpoint);
    this.method = 'POST';
    this.path = endpoint.path || '/';
    this.headers = {};
    this.body = '';
    this.endpoint = endpoint;
    this.region = region;
    this._userAgent = '';
    this.setUserAgent();
  },

  /**
   * @api private
   */
  setUserAgent: function setUserAgent() {
    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
  },

  getUserAgentHeaderName: function getUserAgentHeaderName() {
    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
    return prefix + 'User-Agent';
  },

  /**
   * @api private
   */
  appendToUserAgent: function appendToUserAgent(agentPartial) {
    if (typeof agentPartial === 'string' && agentPartial) {
      this._userAgent += ' ' + agentPartial;
    }
    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
  },

  /**
   * @api private
   */
  getUserAgent: function getUserAgent() {
    return this._userAgent;
  },

  /**
   * @return [String] the part of the {path} excluding the
   *   query string
   */
  pathname: function pathname() {
    return this.path.split('?', 1)[0];
  },

  /**
   * @return [String] the query string portion of the {path}
   */
  search: function search() {
    var query = this.path.split('?', 2)[1];
    if (query) {
      query = AWS.util.queryStringParse(query);
      return AWS.util.queryParamsToString(query);
    }
    return '';
  }

});

/**
 * The low level HTTP response object, encapsulating all HTTP header
 * and body data returned from the request.
 *
 * @!attribute statusCode
 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
 * @!attribute headers
 *   @return [map<String,String>]
 *      a map of response header keys and their respective values
 * @!attribute body
 *   @return [String] the response body payload
 * @!attribute [r] streaming
 *   @return [Boolean] whether this response is being streamed at a low-level.
 *     Defaults to `false` (buffered reads). Do not modify this manually, use
 *     {createUnbufferedStream} to convert the stream to unbuffered mode
 *     instead.
 */
AWS.HttpResponse = inherit({

  /**
   * @api private
   */
  constructor: function HttpResponse() {
    this.statusCode = undefined;
    this.headers = {};
    this.body = undefined;
    this.streaming = false;
    this.stream = null;
  },

  /**
   * Disables buffering on the HTTP response and returns the stream for reading.
   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
   *   Use this object to directly read data off of the stream.
   * @note This object is only available after the {AWS.Request~httpHeaders}
   *   event has fired. This method must be called prior to
   *   {AWS.Request~httpData}.
   * @example Taking control of a stream
   *   request.on('httpHeaders', function(statusCode, headers) {
   *     if (statusCode < 300) {
   *       if (headers.etag === 'xyz') {
   *         // pipe the stream, disabling buffering
   *         var stream = this.response.httpResponse.createUnbufferedStream();
   *         stream.pipe(process.stdout);
   *       } else { // abort this request and set a better error message
   *         this.abort();
   *         this.response.error = new Error('Invalid ETag');
   *       }
   *     }
   *   }).send(console.log);
   */
  createUnbufferedStream: function createUnbufferedStream() {
    this.streaming = true;
    return this.stream;
  }
});


AWS.HttpClient = inherit({});

/**
 * @api private
 */
AWS.HttpClient.getInstance = function getInstance() {
  if (this.singleton === undefined) {
    this.singleton = new this();
  }
  return this.singleton;
};


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

/**
 * @api private
 * @!method on(eventName, callback)
 *   Registers an event listener callback for the event given by `eventName`.
 *   Parameters passed to the callback function depend on the individual event
 *   being triggered. See the event documentation for those parameters.
 *
 *   @param eventName [String] the event name to register the listener for
 *   @param callback [Function] the listener callback function
 *   @return [AWS.SequentialExecutor] the same object for chaining
 */
AWS.SequentialExecutor = AWS.util.inherit({

  constructor: function SequentialExecutor() {
    this._events = {};
  },

  /**
   * @api private
   */
  listeners: function listeners(eventName) {
    return this._events[eventName] ? this._events[eventName].slice(0) : [];
  },

  on: function on(eventName, listener) {
    if (this._events[eventName]) {
      this._events[eventName].push(listener);
    } else {
      this._events[eventName] = [listener];
    }
    return this;
  },

  /**
   * @api private
   */
  onAsync: function onAsync(eventName, listener) {
    listener._isAsync = true;
    return this.on(eventName, listener);
  },

  removeListener: function removeListener(eventName, listener) {
    var listeners = this._events[eventName];
    if (listeners) {
      var length = listeners.length;
      var position = -1;
      for (var i = 0; i < length; ++i) {
        if (listeners[i] === listener) {
          position = i;
        }
      }
      if (position > -1) {
        listeners.splice(position, 1);
      }
    }
    return this;
  },

  removeAllListeners: function removeAllListeners(eventName) {
    if (eventName) {
      delete this._events[eventName];
    } else {
      this._events = {};
    }
    return this;
  },

  /**
   * @api private
   */
  emit: function emit(eventName, eventArgs, doneCallback) {
    if (!doneCallback) doneCallback = function() { };
    var listeners = this.listeners(eventName);
    var count = listeners.length;
    this.callListeners(listeners, eventArgs, doneCallback);
    return count > 0;
  },

  /**
   * @api private
   */
  callListeners: function callListeners(listeners, args, doneCallback, prevError) {
    var self = this;
    var error = prevError || null;

    function callNextListener(err) {
      if (err) {
        error = AWS.util.error(error || new Error(), err);
        if (self._haltHandlersOnError) {
          return doneCallback.call(self, error);
        }
      }
      self.callListeners(listeners, args, doneCallback, error);
    }

    while (listeners.length > 0) {
      var listener = listeners.shift();
      if (listener._isAsync) { // asynchronous listener
        listener.apply(self, args.concat([callNextListener]));
        return; // stop here, callNextListener will continue
      } else { // synchronous listener
        try {
          listener.apply(self, args);
        } catch (err) {
          error = AWS.util.error(error || new Error(), err);
        }
        if (error && self._haltHandlersOnError) {
          doneCallback.call(self, error);
          return;
        }
      }
    }
    doneCallback.call(self, error);
  },

  /**
   * Adds or copies a set of listeners from another list of
   * listeners or SequentialExecutor object.
   *
   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
   *   a list of events and callbacks, or an event emitter object
   *   containing listeners to add to this emitter object.
   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
   * @example Adding listeners from a map of listeners
   *   emitter.addListeners({
   *     event1: [function() { ... }, function() { ... }],
   *     event2: [function() { ... }]
   *   });
   *   emitter.emit('event1'); // emitter has event1
   *   emitter.emit('event2'); // emitter has event2
   * @example Adding listeners from another emitter object
   *   var emitter1 = new AWS.SequentialExecutor();
   *   emitter1.on('event1', function() { ... });
   *   emitter1.on('event2', function() { ... });
   *   var emitter2 = new AWS.SequentialExecutor();
   *   emitter2.addListeners(emitter1);
   *   emitter2.emit('event1'); // emitter2 has event1
   *   emitter2.emit('event2'); // emitter2 has event2
   */
  addListeners: function addListeners(listeners) {
    var self = this;

    // extract listeners if parameter is an SequentialExecutor object
    if (listeners._events) listeners = listeners._events;

    AWS.util.each(listeners, function(event, callbacks) {
      if (typeof callbacks === 'function') callbacks = [callbacks];
      AWS.util.arrayEach(callbacks, function(callback) {
        self.on(event, callback);
      });
    });

    return self;
  },

  /**
   * Registers an event with {on} and saves the callback handle function
   * as a property on the emitter object using a given `name`.
   *
   * @param name [String] the property name to set on this object containing
   *   the callback function handle so that the listener can be removed in
   *   the future.
   * @param (see on)
   * @return (see on)
   * @example Adding a named listener DATA_CALLBACK
   *   var listener = function() { doSomething(); };
   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
   *
   *   // the following prints: true
   *   console.log(emitter.DATA_CALLBACK == listener);
   */
  addNamedListener: function addNamedListener(name, eventName, callback) {
    this[name] = callback;
    this.addListener(eventName, callback);
    return this;
  },

  /**
   * @api private
   */
  addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback) {
    callback._isAsync = true;
    return this.addNamedListener(name, eventName, callback);
  },

  /**
   * Helper method to add a set of named listeners using
   * {addNamedListener}. The callback contains a parameter
   * with a handle to the `addNamedListener` method.
   *
   * @callback callback function(add)
   *   The callback function is called immediately in order to provide
   *   the `add` function to the block. This simplifies the addition of
   *   a large group of named listeners.
   *   @param add [Function] the {addNamedListener} function to call
   *     when registering listeners.
   * @example Adding a set of named listeners
   *   emitter.addNamedListeners(function(add) {
   *     add('DATA_CALLBACK', 'data', function() { ... });
   *     add('OTHER', 'otherEvent', function() { ... });
   *     add('LAST', 'lastEvent', function() { ... });
   *   });
   *
   *   // these properties are now set:
   *   emitter.DATA_CALLBACK;
   *   emitter.OTHER;
   *   emitter.LAST;
   */
  addNamedListeners: function addNamedListeners(callback) {
    var self = this;
    callback(
      function() {
        self.addNamedListener.apply(self, arguments);
      },
      function() {
        self.addNamedAsyncListener.apply(self, arguments);
      }
    );
    return this;
  }
});

/**
 * {on} is the prefered method.
 * @api private
 */
AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;

module.exports = AWS.SequentialExecutor;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
  addAuthorization: function addAuthorization(credentials, date) {

    var datetime = AWS.util.date.rfc822(date);

    this.request.headers['X-Amz-Date'] = datetime;

    if (credentials.sessionToken) {
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }

    this.request.headers['X-Amzn-Authorization'] =
      this.authorization(credentials, datetime);

  },

  authorization: function authorization(credentials) {
    return 'AWS3 ' +
      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
      'Algorithm=HmacSHA256,' +
      'SignedHeaders=' + this.signedHeaders() + ',' +
      'Signature=' + this.signature(credentials);
  },

  signedHeaders: function signedHeaders() {
    var headers = [];
    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
      headers.push(h.toLowerCase());
    });
    return headers.sort().join(';');
  },

  canonicalHeaders: function canonicalHeaders() {
    var headers = this.request.headers;
    var parts = [];
    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
      parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
    });
    return parts.sort().join('\n') + '\n';
  },

  headersToSign: function headersToSign() {
    var headers = [];
    AWS.util.each(this.request.headers, function iterator(k) {
      if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) {
        headers.push(k);
      }
    });
    return headers;
  },

  signature: function signature(credentials) {
    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
  },

  stringToSign: function stringToSign() {
    var parts = [];
    parts.push(this.request.method);
    parts.push('/');
    parts.push('');
    parts.push(this.canonicalHeaders());
    parts.push(this.request.body);
    return AWS.util.crypto.sha256(parts.join('\n'));
  }

});

module.exports = AWS.Signers.V3;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

/**
 * @api private
 */
var cachedSecret = {};

/**
 * @api private
 */
var cacheQueue = [];

/**
 * @api private
 */
var maxCacheEntries = 50;

/**
 * @api private
 */
var v4Identifier = 'aws4_request';

module.exports = {
  /**
   * @api private
   *
   * @param date [String]
   * @param region [String]
   * @param serviceName [String]
   * @return [String]
   */
  createScope: function createScope(date, region, serviceName) {
    return [
      date.substr(0, 8),
      region,
      serviceName,
      v4Identifier
    ].join('/');
  },

  /**
   * @api private
   *
   * @param credentials [Credentials]
   * @param date [String]
   * @param region [String]
   * @param service [String]
   * @param shouldCache [Boolean]
   * @return [String]
   */
  getSigningKey: function getSigningKey(
    credentials,
    date,
    region,
    service,
    shouldCache
  ) {
    var credsIdentifier = AWS.util.crypto
      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
    var cacheKey = [credsIdentifier, date, region, service].join('_');
    shouldCache = shouldCache !== false;
    if (shouldCache && (cacheKey in cachedSecret)) {
      return cachedSecret[cacheKey];
    }

    var kDate = AWS.util.crypto.hmac(
      'AWS4' + credentials.secretAccessKey,
      date,
      'buffer'
    );
    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');

    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
    if (shouldCache) {
      cachedSecret[cacheKey] = signingKey;
      cacheQueue.push(cacheKey);
      if (cacheQueue.length > maxCacheEntries) {
        // remove the oldest entry (not the least recently used)
        delete cachedSecret[cacheQueue.shift()];
      }
    }

    return signingKey;
  },

  /**
   * @api private
   *
   * Empties the derived signing key cache. Made available for testing purposes
   * only.
   */
  emptyCache: function emptyCache() {
    cachedSecret = {};
    cacheQueue = [];
  }
};


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 812 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitoidentity'] = {};
AWS.CognitoIdentity = Service.defineService('cognitoidentity', ['2014-06-30']);
__webpack_require__(1497);
Object.defineProperty(apiLoader.services['cognitoidentity'], '2014-06-30', {
  get: function get() {
    var model = __webpack_require__(1498);
    model.paginators = __webpack_require__(1499).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoIdentity;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(7).util;

function typeOf(data) {
  if (data === null && typeof data === 'object') {
    return 'null';
  } else if (data !== undefined && isBinary(data)) {
    return 'Binary';
  } else if (data !== undefined && data.constructor) {
    return util.typeName(data.constructor);
  } else if (data !== undefined && typeof data === 'object') {
    // this object is the result of Object.create(null), hence the absence of a
    // defined constructor
    return 'Object';
  } else {
    return 'undefined';
  }
}

function isBinary(data) {
  var types = [
    'Buffer', 'File', 'Blob', 'ArrayBuffer', 'DataView',
    'Int8Array', 'Uint8Array', 'Uint8ClampedArray',
    'Int16Array', 'Uint16Array', 'Int32Array', 'Uint32Array',
    'Float32Array', 'Float64Array'
  ];
  if (util.isNode()) {
    var Stream = util.stream.Stream;
    if (util.Buffer.isBuffer(data) || data instanceof Stream) {
      return true;
    }
  }

  for (var i = 0; i < types.length; i++) {
    if (data !== undefined && data.constructor) {
      if (util.isType(data, types[i])) return true;
      if (util.typeName(data.constructor) === types[i]) return true;
    }
  }

  return false;
}

module.exports = {
  typeOf: typeOf,
  isBinary: isBinary
};


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(7).util;
var typeOf = __webpack_require__(814).typeOf;

var memberTypeToSetType = {
  'String': 'String',
  'Number': 'Number',
  'NumberValue': 'Number',
  'Binary': 'Binary'
};

/**
 * @api private
 */
var DynamoDBSet = util.inherit({

  constructor: function Set(list, options) {
    options = options || {};
    this.initialize(list, options.validate);
  },

  initialize: function(list, validate) {
    var self = this;
    self.values = [].concat(list);
    self.detectType();
    if (validate) {
      self.validate();
    }
  },

  detectType: function() {
    this.type = memberTypeToSetType[typeOf(this.values[0])];
    if (!this.type) {
      throw util.error(new Error(), {
        code: 'InvalidSetType',
        message: 'Sets can contain string, number, or binary values'
      });
    }
  },

  validate: function() {
    var self = this;
    var length = self.values.length;
    var values = self.values;
    for (var i = 0; i < length; i++) {
      if (memberTypeToSetType[typeOf(values[i])] !== self.type) {
        throw util.error(new Error(), {
          code: 'InvalidType',
          message: self.type + ' Set contains ' + typeOf(values[i]) + ' value'
        });
      }
    }
  }

});

module.exports = DynamoDBSet;


/***/ }),
/* 816 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(250);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_MONTHLY_ACTIVITY_REPORTS = exports.CLEAR_ACTIVITY_REPORTS = exports.FETCH_MONTHLY_ACTIVITY_REPORT_FAILED = exports.FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED = exports.FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED = exports.FETCH_MONTHLY_ACTIVITY_REPORT = exports.FETCH_ACTIVITY_REPORTS_FAILED = exports.FETCH_ACTIVITY_REPORTS_COMPLETED = exports.FETCH_ACTIVITY_REPORTS_REQUESTED = exports.FETCH_ACTIVITY_REPORTS = undefined;
exports.fetchActivityReportsRequested = fetchActivityReportsRequested;
exports.fetchActivityReports = fetchActivityReports;
exports.fetchActivityReportsCompleted = fetchActivityReportsCompleted;
exports.fetchActivityReportsFailed = fetchActivityReportsFailed;
exports.fetchMonthlyActivityReportRequested = fetchMonthlyActivityReportRequested;
exports.fetchMonthlyActivityReport = fetchMonthlyActivityReport;
exports.fetchMonthlyActivityReportCompleted = fetchMonthlyActivityReportCompleted;
exports.fetchMonthlyActivityReportFailed = fetchMonthlyActivityReportFailed;
exports.clearActivityReports = clearActivityReports;
exports.clearMonthlyActivityReport = clearMonthlyActivityReport;
exports.saveSelectSubmissionScheduleRequested = saveSelectSubmissionScheduleRequested;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/activity-report.js

var FETCH_ACTIVITY_REPORTS = exports.FETCH_ACTIVITY_REPORTS = "FETCH_ACTIVITY_REPORTS";
var FETCH_ACTIVITY_REPORTS_REQUESTED = exports.FETCH_ACTIVITY_REPORTS_REQUESTED = "FETCH_ACTIVITY_REPORTS_REQUESTED";
var FETCH_ACTIVITY_REPORTS_COMPLETED = exports.FETCH_ACTIVITY_REPORTS_COMPLETED = "FETCH_ACTIVITY_REPORTS_COMPLETED";
var FETCH_ACTIVITY_REPORTS_FAILED = exports.FETCH_ACTIVITY_REPORTS_FAILED = "FETCH_ACTIVITY_REPORTS_FAILED";
var FETCH_MONTHLY_ACTIVITY_REPORT = exports.FETCH_MONTHLY_ACTIVITY_REPORT = "FETCH_MONTHLY_ACTIVITY_REPORT";
var FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED = exports.FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED = "FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED";
var FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED = exports.FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED = "FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED";
var FETCH_MONTHLY_ACTIVITY_REPORT_FAILED = exports.FETCH_MONTHLY_ACTIVITY_REPORT_FAILED = "FETCH_MONTHLY_ACTIVITY_REPORT_FAILED";

function fetchActivityReportsRequested() {
  return {
    type: FETCH_ACTIVITY_REPORTS_REQUESTED
  };
}

function fetchActivityReports(group_id, date) {
  var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;

  return function (dispatch) {
    dispatch(fetchActivityReportsRequested());
    return _gambaApi2.default.get('/activity_report/' + group_id, { date: date, length: length }).then(function (results) {
      dispatch(fetchActivityReportsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchActivityReportsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchActivityReportsCompleted(results) {
  return {
    type: FETCH_ACTIVITY_REPORTS_COMPLETED,
    results: results
  };
}

function fetchActivityReportsFailed(error) {
  return {
    type: FETCH_ACTIVITY_REPORTS_FAILED,
    error: error
  };
}

function fetchMonthlyActivityReportRequested() {
  return {
    type: FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED
  };
}

function fetchMonthlyActivityReport(group_id, user_id, date) {
  return function (dispatch) {
    dispatch(fetchMonthlyActivityReportRequested());
    return _gambaApi2.default.get('/activity_report/' + group_id, { user_id: user_id, date: date }).then(function (results) {
      dispatch(fetchMonthlyActivityReportCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchMonthlyActivityReportFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchMonthlyActivityReportCompleted(results) {
  return {
    type: FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED,
    results: results
  };
}

function fetchMonthlyActivityReportFailed(error) {
  return {
    type: FETCH_MONTHLY_ACTIVITY_REPORT_FAILED,
    error: error
  };
}

var CLEAR_ACTIVITY_REPORTS = exports.CLEAR_ACTIVITY_REPORTS = "CLEAR_ACTIVITY_REPORTS";
var CLEAR_MONTHLY_ACTIVITY_REPORTS = exports.CLEAR_MONTHLY_ACTIVITY_REPORTS = "CLEAR_MONTHLY_ACTIVITY_REPORTS";

function clearActivityReports() {
  return {
    type: CLEAR_ACTIVITY_REPORTS
  };
}

function clearMonthlyActivityReport() {
  return {
    type: CLEAR_MONTHLY_ACTIVITY_REPORTS
  };
}

function saveSelectSubmissionScheduleRequested() {
  return {
    type: SAVE_SELECT_SUBMISSION_SCHEDULE_REQUESTED
  };
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_ANNOUNCE = exports.OPEN_ANNOUNCE = exports.CLOSE_ANNOUNCE = exports.FETCH_ANNOUNCE_FAILED = exports.FETCH_ANNOUNCE_COMPLETED = exports.FETCH_ANNOUNCE_REQUESTED = exports.FETCH_ANNOUNCE = undefined;
exports.fetchAnnounceRequested = fetchAnnounceRequested;
exports.fetchAnnounce = fetchAnnounce;
exports.fetchAnnounceCompleted = fetchAnnounceCompleted;
exports.fetchAnnounceFailed = fetchAnnounceFailed;
exports.closeAnnounce = closeAnnounce;
exports.openAnnounce = openAnnounce;
exports.clearAnnounce = clearAnnounce;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/announce.js

var FETCH_ANNOUNCE = exports.FETCH_ANNOUNCE = "FETCH_ANNOUNCE";
var FETCH_ANNOUNCE_REQUESTED = exports.FETCH_ANNOUNCE_REQUESTED = "FETCH_ANNOUNCE_REQUESTED";
var FETCH_ANNOUNCE_COMPLETED = exports.FETCH_ANNOUNCE_COMPLETED = "FETCH_ANNOUNCE_COMPLETED";
var FETCH_ANNOUNCE_FAILED = exports.FETCH_ANNOUNCE_FAILED = "FETCH_ANNOUNCE_FAILED";
var CLOSE_ANNOUNCE = exports.CLOSE_ANNOUNCE = "CLOSE_ANNOUNCE";
var OPEN_ANNOUNCE = exports.OPEN_ANNOUNCE = "OPEN_ANNOUNCE";
var CLEAR_ANNOUNCE = exports.CLEAR_ANNOUNCE = "CLEAR_ANNOUNCE";

function fetchAnnounceRequested() {
  return {
    type: FETCH_ANNOUNCE_REQUESTED
  };
}

function fetchAnnounce() {
  return function (dispatch) {
    dispatch(fetchAnnounceRequested());
    return _gambaApi2.default.get('/announce').then(function (results) {
      dispatch(fetchAnnounceCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAnnounceFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAnnounceCompleted(results) {
  return {
    type: FETCH_ANNOUNCE_COMPLETED,
    results: results
  };
}

function fetchAnnounceFailed(error) {
  return {
    type: FETCH_ANNOUNCE_FAILED,
    error: error
  };
}

function closeAnnounce() {
  return {
    type: CLOSE_ANNOUNCE
  };
}

function openAnnounce() {
  return {
    type: OPEN_ANNOUNCE
  };
}

function clearAnnounce() {
  return {
    type: CLEAR_ANNOUNCE
  };
}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_ATTACHMENTS = exports.FETCH_ATTACHMENTS_FAILED = exports.FETCH_ATTACHMENTS_COMPLETED = exports.FETCH_ATTACHMENTS_REQUESTED = exports.FETCH_COMMENT_ATTACHMENTS = exports.FETCH_DIARY_ATTACHMENTS = undefined;
exports.fetchAttachmentsRequested = fetchAttachmentsRequested;
exports.fetchDiaryAttachments = fetchDiaryAttachments;
exports.fetchCommentAttachments = fetchCommentAttachments;
exports.fetchAttachmentsCompleted = fetchAttachmentsCompleted;
exports.fetchAttachmentsFailed = fetchAttachmentsFailed;
exports.clearAttachments = clearAttachments;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/attachments.js

var FETCH_DIARY_ATTACHMENTS = exports.FETCH_DIARY_ATTACHMENTS = "FETCH_DIARY_ATTACHMENTS";
var FETCH_COMMENT_ATTACHMENTS = exports.FETCH_COMMENT_ATTACHMENTS = "FETCH_COMMENT_ATTACHMENTS";
var FETCH_ATTACHMENTS_REQUESTED = exports.FETCH_ATTACHMENTS_REQUESTED = "FETCH_ATTACHMENTS_REQUESTED";
var FETCH_ATTACHMENTS_COMPLETED = exports.FETCH_ATTACHMENTS_COMPLETED = "FETCH_ATTACHMENTS_COMPLETED";
var FETCH_ATTACHMENTS_FAILED = exports.FETCH_ATTACHMENTS_FAILED = "FETCH_ATTACHMENTS_FAILED";
var CLEAR_ATTACHMENTS = exports.CLEAR_ATTACHMENTS = "CLEAR_ATTACHMENTS";

function fetchAttachmentsRequested() {
  return {
    type: FETCH_ATTACHMENTS_REQUESTED
  };
}

function fetchDiaryAttachments(diary_id) {
  return function (dispatch) {
    dispatch(fetchAttachmentsRequested());
    return _gambaApi2.default.get('/attachments', { diary_id: diary_id }).then(function (results) {
      dispatch(fetchAttachmentsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAttachmentsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchCommentAttachments(comment_id) {
  return function (dispatch) {
    dispatch(fetchAttachmentsRequested());
    return _gambaApi2.default.get('/attachments', { comment_id: comment_id }).then(function (results) {
      dispatch(fetchAttachmentsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAttachmentsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAttachmentsCompleted(results) {
  return {
    type: FETCH_ATTACHMENTS_COMPLETED,
    results: results
  };
}

function fetchAttachmentsFailed(error) {
  return {
    type: FETCH_ATTACHMENTS_FAILED,
    error: error
  };
}

function clearAttachments() {
  return {
    type: CLEAR_ATTACHMENTS
  };
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_BUILD_NO_FAILED = exports.FETCH_BUILD_NO_COMPLETED = exports.FETCH_BUILD_NO_REQUESTED = exports.FETCH_BUILD_NO = undefined;
exports.fetchBuildNoRequested = fetchBuildNoRequested;
exports.fetchBuildNo = fetchBuildNo;
exports.fetchBuildNoCompleted = fetchBuildNoCompleted;
exports.fetchBuildNoFailed = fetchBuildNoFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/build-no.js

var FETCH_BUILD_NO = exports.FETCH_BUILD_NO = "FETCH_BUILD_NO";
var FETCH_BUILD_NO_REQUESTED = exports.FETCH_BUILD_NO_REQUESTED = "FETCH_BUILD_NO_REQUESTED";
var FETCH_BUILD_NO_COMPLETED = exports.FETCH_BUILD_NO_COMPLETED = "FETCH_BUILD_NO_COMPLETED";
var FETCH_BUILD_NO_FAILED = exports.FETCH_BUILD_NO_FAILED = "FETCH_BUILD_NO_FAILED";

function fetchBuildNoRequested() {
  return {
    type: FETCH_BUILD_NO_REQUESTED
  };
}

function fetchBuildNo() {
  return function (dispatch) {
    dispatch(fetchBuildNoRequested());
    return _gambaApi2.default.get('/build_no').then(function (results) {
      dispatch(fetchBuildNoCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchBuildNoFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchBuildNoCompleted(results) {
  return {
    type: FETCH_BUILD_NO_COMPLETED,
    results: results
  };
}

function fetchBuildNoFailed(error) {
  return {
    type: FETCH_BUILD_NO_FAILED,
    error: error
  };
}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_CHAT_MESSAGE = exports.LOAD_CHAT_MESSAGE = exports.CLEAR_CHAT_MESSAGES = exports.DELETE_CHAT_MESSAGE_FAILED = exports.DELETE_CHAT_MESSAGE_COMPLETED = exports.DELETE_CHAT_MESSAGE_REQUESTED = exports.DELETE_CHAT_MESSAGE = exports.POST_CHAT_MESSAGE_FAILED = exports.POST_CHAT_MESSAGE_COMPLETED = exports.POST_CHAT_MESSAGE_REQUESTED = exports.POST_CHAT_MESSAGE = exports.FETCH_CHAT_MESSAGES_FAILED = exports.FETCH_CHAT_MESSAGES_COMPLETED = exports.FETCH_CHAT_MESSAGES_REQUESTED = exports.FETCH_CHAT_MESSAGES = undefined;
exports.fetchChatMessagesRequested = fetchChatMessagesRequested;
exports.fetchChatMessages = fetchChatMessages;
exports.fetchChatMessagesCompleted = fetchChatMessagesCompleted;
exports.fetchChatMessagesFailed = fetchChatMessagesFailed;
exports.postChatMessageRequested = postChatMessageRequested;
exports.postChatMessage = postChatMessage;
exports.postChatMessageCompleted = postChatMessageCompleted;
exports.postChatMessageFailed = postChatMessageFailed;
exports.deleteChatMessageRequested = deleteChatMessageRequested;
exports.deleteChatMessage = deleteChatMessage;
exports.deleteChatMessageCompleted = deleteChatMessageCompleted;
exports.deleteChatMessageFailed = deleteChatMessageFailed;
exports.clearChatMessages = clearChatMessages;
exports.loadChatMessage = loadChatMessage;
exports.removeChatMessage = removeChatMessage;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/chat-messages.js

var FETCH_CHAT_MESSAGES = exports.FETCH_CHAT_MESSAGES = "FETCH_CHAT_MESSAGES";
var FETCH_CHAT_MESSAGES_REQUESTED = exports.FETCH_CHAT_MESSAGES_REQUESTED = "FETCH_CHAT_MESSAGES_REQUESTED";
var FETCH_CHAT_MESSAGES_COMPLETED = exports.FETCH_CHAT_MESSAGES_COMPLETED = "FETCH_CHAT_MESSAGES_COMPLETED";
var FETCH_CHAT_MESSAGES_FAILED = exports.FETCH_CHAT_MESSAGES_FAILED = "FETCH_CHAT_MESSAGES_FAILED";

function fetchChatMessagesRequested(chat_room_id) {
  return {
    type: FETCH_CHAT_MESSAGES_REQUESTED,
    chat_room_id: chat_room_id
  };
}

function fetchChatMessages(chat_room_id, offset) {
  return function (dispatch) {
    dispatch(fetchChatMessagesRequested(chat_room_id));
    return _gambaApi2.default.get('/chat_messages/' + chat_room_id, { offset: offset, with_meta_info: true }).then(function (results) {
      dispatch(fetchChatMessagesCompleted(chat_room_id, results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchChatMessagesFailed(chat_room_id, error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchChatMessagesCompleted(chat_room_id, results, offset) {
  return {
    type: FETCH_CHAT_MESSAGES_COMPLETED,
    results: results, offset: offset, chat_room_id: chat_room_id
  };
}

function fetchChatMessagesFailed(chat_room_id, error) {
  return {
    type: FETCH_CHAT_MESSAGES_FAILED,
    error: error, chat_room_id: chat_room_id
  };
}

var POST_CHAT_MESSAGE = exports.POST_CHAT_MESSAGE = "POST_CHAT_MESSAGE";
var POST_CHAT_MESSAGE_REQUESTED = exports.POST_CHAT_MESSAGE_REQUESTED = "POST_CHAT_MESSAGE_REQUESTED";
var POST_CHAT_MESSAGE_COMPLETED = exports.POST_CHAT_MESSAGE_COMPLETED = "POST_CHAT_MESSAGE_COMPLETED";
var POST_CHAT_MESSAGE_FAILED = exports.POST_CHAT_MESSAGE_FAILED = "POST_CHAT_MESSAGE_FAILED";

function postChatMessageRequested(chat_room_id, withFiles) {
  return {
    type: POST_CHAT_MESSAGE_REQUESTED,
    chat_room_id: chat_room_id, withFiles: withFiles
  };
}

function postChatMessage(chat_room_id, message) {
  var upload_files = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var upload_videos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  var attach_json = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

  return function (dispatch) {
    dispatch(postChatMessageRequested(chat_room_id, !!upload_files || !!upload_videos || !!attach_json));
    return _gambaApi2.default.post('/chat_messages/' + chat_room_id, { message: message, upload_files: upload_files, upload_videos: upload_videos, attach_json: attach_json }).then(function (results) {
      dispatch(postChatMessageCompleted(chat_room_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(postChatMessageFailed(chat_room_id, error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function postChatMessageCompleted(chat_room_id, results) {
  return {
    type: POST_CHAT_MESSAGE_COMPLETED,
    chat_room_id: chat_room_id, results: results
  };
}

function postChatMessageFailed(chat_room_id, error) {
  return {
    type: POST_CHAT_MESSAGE_FAILED,
    chat_room_id: chat_room_id, error: error
  };
}

var DELETE_CHAT_MESSAGE = exports.DELETE_CHAT_MESSAGE = "DELETE_CHAT_MESSAGE";
var DELETE_CHAT_MESSAGE_REQUESTED = exports.DELETE_CHAT_MESSAGE_REQUESTED = "DELETE_CHAT_MESSAGE_REQUESTED";
var DELETE_CHAT_MESSAGE_COMPLETED = exports.DELETE_CHAT_MESSAGE_COMPLETED = "DELETE_CHAT_MESSAGE_COMPLETED";
var DELETE_CHAT_MESSAGE_FAILED = exports.DELETE_CHAT_MESSAGE_FAILED = "DELETE_CHAT_MESSAGE_FAILED";

function deleteChatMessageRequested() {
  return {
    type: DELETE_CHAT_MESSAGE_REQUESTED
  };
}

function deleteChatMessage(chat_room_id, message_id) {
  return function (dispatch) {
    dispatch(deleteChatMessageRequested());
    return _gambaApi2.default.delete('/chat_messages/' + message_id).then(function (results) {
      dispatch(deleteChatMessageCompleted(results, chat_room_id));
    }).catch(function (error) {
      Promise.all([dispatch(deleteChatMessageFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteChatMessageCompleted(results, chat_room_id) {
  return {
    type: DELETE_CHAT_MESSAGE_COMPLETED,
    chat_room_id: chat_room_id, results: results
  };
}

function deleteChatMessageFailed(error) {
  return {
    type: DELETE_CHAT_MESSAGE_FAILED,
    error: error
  };
}

var CLEAR_CHAT_MESSAGES = exports.CLEAR_CHAT_MESSAGES = "CLEAR_CHAT_MESSAGES";

function clearChatMessages() {
  return {
    type: CLEAR_CHAT_MESSAGES
  };
}

var LOAD_CHAT_MESSAGE = exports.LOAD_CHAT_MESSAGE = "LOAD_CHAT_MESSAGE";

function loadChatMessage(chat, appending) {
  return {
    type: LOAD_CHAT_MESSAGE,
    chat: chat, appending: appending
  };
}

var REMOVE_CHAT_MESSAGE = exports.REMOVE_CHAT_MESSAGE = "REMOVE_CHAT_MESSAGE";

function removeChatMessage(chat_room_id, message_id) {
  return {
    type: REMOVE_CHAT_MESSAGE,
    chat_room_id: chat_room_id, message_id: message_id
  };
}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAKE_CHAT_MESSAGE_READ_FAILED = exports.MAKE_CHAT_MESSAGE_READ_COMPLETED = exports.MAKE_CHAT_MESSAGE_READ_REQUESTED = exports.MAKE_CHAT_MESSAGE_READ = exports.CLEAR_CHAT_ALBUM = exports.FETCH_ALBUM_CHAT_VIDEO_FAILED = exports.FETCH_ALBUM_CHAT_VIDEO_COMPLETED = exports.FETCH_ALBUM_CHAT_VIDEO_REQUESTED = exports.FETCH_ALBUM_CHAT_VIDEO = exports.FETCH_ALBUM_CHAT_FILE_FAILED = exports.FETCH_ALBUM_CHAT_FILE_COMPLETED = exports.FETCH_ALBUM_CHAT_FILE_REQUESTED = exports.FETCH_ALBUM_CHAT_FILE = exports.FETCH_ALBUM_CHAT_IMAGE_FAILED = exports.FETCH_ALBUM_CHAT_IMAGE_COMPLETED = exports.FETCH_ALBUM_CHAT_IMAGE_REQUESTED = exports.FETCH_ALBUM_CHAT_IMAGE = exports.FETCH_ALBUM_LENGTH = exports.LOAD_CHAT_ROOM_UNREAD_COUNT = exports.LOAD_CHAT_ROOM = exports.EXCLUDE_CHAT_ROOM_FAILED = exports.EXCLUDE_CHAT_ROOM_COMPLETED = exports.EXCLUDE_CHAT_ROOM_REQUESTED = exports.EXCLUDE_CHAT_ROOM = exports.CLEAR_CHAT_ROOMS = exports.UPDATE_CHAT_ROOM_FAILED = exports.UPDATE_CHAT_ROOM_COMPLETED = exports.UPDATE_CHAT_ROOM_REQUESTED = exports.UPDATE_CHAT_ROOM = exports.LEAVE_CHAT_ROOM_FAILED = exports.LEAVE_CHAT_ROOM_COMPLETED = exports.LEAVE_CHAT_ROOM_REQUESTED = exports.LEAVE_CHAT_ROOM = exports.JOIN_CHAT_ROOM_FAILED = exports.JOIN_CHAT_ROOM_COMPLETED = exports.JOIN_CHAT_ROOM_REQUESTED = exports.JOIN_CHAT_ROOM = exports.DELETE_CHAT_ROOM_FAILED = exports.DELETE_CHAT_ROOM_COMPLETED = exports.DELETE_CHAT_ROOM_REQUESTED = exports.DELETE_CHAT_ROOM = exports.CLEAR_CHAT_ROOM_UNREAD_COUNT = exports.FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED = exports.FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED = exports.FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED = exports.FETCH_CHAT_ROOM_UNREAD_COUNT = exports.FETCH_CHAT_ROOM_FAILED = exports.FETCH_CHAT_ROOM_COMPLETED = exports.FETCH_CHAT_ROOM_REQUESTED = exports.FETCH_CHAT_ROOM = exports.CREATE_CHAT_ROOM_FAILED = exports.CREATE_CHAT_ROOM_COMPLETED = exports.CREATE_CHAT_ROOM_REQUESTED = exports.CREATE_CHAT_ROOM = exports.FETCH_CHAT_ROOMS_FAILED = exports.FETCH_CHAT_ROOMS_COMPLETED = exports.FETCH_CHAT_ROOMS_REQUESTED = exports.FETCH_CHAT_ROOMS = exports.FETCH_CHAT_ROOMS_LENGTH = undefined;
exports.fetchChatRoomsRequested = fetchChatRoomsRequested;
exports.fetchChatRooms = fetchChatRooms;
exports.fetchChatRoomsCompleted = fetchChatRoomsCompleted;
exports.fetchChatRoomsFailed = fetchChatRoomsFailed;
exports.createChatRoomRequested = createChatRoomRequested;
exports.createChatRoom = createChatRoom;
exports.createChatRoomCompleted = createChatRoomCompleted;
exports.createChatRoomFailed = createChatRoomFailed;
exports.fetchChatRoomRequested = fetchChatRoomRequested;
exports.fetchChatRoom = fetchChatRoom;
exports.fetchChatRoomCompleted = fetchChatRoomCompleted;
exports.fetchChatRoomFailed = fetchChatRoomFailed;
exports.fetchChatRoomUnreadCountRequested = fetchChatRoomUnreadCountRequested;
exports.fetchChatRoomUnreadCount = fetchChatRoomUnreadCount;
exports.fetchChatRoomUnreadCountCompleted = fetchChatRoomUnreadCountCompleted;
exports.fetchChatRoomUnreadCountFailed = fetchChatRoomUnreadCountFailed;
exports.clearChatRoomUnreadCount = clearChatRoomUnreadCount;
exports.deleteChatRoomRequested = deleteChatRoomRequested;
exports.deleteChatRoom = deleteChatRoom;
exports.deleteChatRoomCompleted = deleteChatRoomCompleted;
exports.deleteChatRoomFailed = deleteChatRoomFailed;
exports.joinChatRoomRequested = joinChatRoomRequested;
exports.joinChatRoom = joinChatRoom;
exports.joinChatRoomCompleted = joinChatRoomCompleted;
exports.joinChatRoomFailed = joinChatRoomFailed;
exports.leaveChatRoomRequested = leaveChatRoomRequested;
exports.leaveChatRoom = leaveChatRoom;
exports.leaveChatRoomCompleted = leaveChatRoomCompleted;
exports.leaveChatRoomFailed = leaveChatRoomFailed;
exports.updateChatRoomRequested = updateChatRoomRequested;
exports.updateChatRoom = updateChatRoom;
exports.updateChatRoomCompleted = updateChatRoomCompleted;
exports.updateChatRoomFailed = updateChatRoomFailed;
exports.clearChatRooms = clearChatRooms;
exports.excludeChatRoomRequested = excludeChatRoomRequested;
exports.excludeChatRoom = excludeChatRoom;
exports.excludeChatRoomCompleted = excludeChatRoomCompleted;
exports.excludeChatRoomFailed = excludeChatRoomFailed;
exports.loadChatRoom = loadChatRoom;
exports.loadChatRoomUnreadCount = loadChatRoomUnreadCount;
exports.fetchAlbumChatImageRequested = fetchAlbumChatImageRequested;
exports.fetchAlbumChatImage = fetchAlbumChatImage;
exports.fetchAlbumChatImageCompleted = fetchAlbumChatImageCompleted;
exports.fetchAlbumChatImageFailed = fetchAlbumChatImageFailed;
exports.fetchAlbumChatFileRequested = fetchAlbumChatFileRequested;
exports.fetchAlbumChatFile = fetchAlbumChatFile;
exports.fetchAlbumChatFileCompleted = fetchAlbumChatFileCompleted;
exports.fetchAlbumChatFileFailed = fetchAlbumChatFileFailed;
exports.fetchAlbumChatVideoRequested = fetchAlbumChatVideoRequested;
exports.fetchAlbumChatVideo = fetchAlbumChatVideo;
exports.fetchAlbumChatVideoCompleted = fetchAlbumChatVideoCompleted;
exports.fetchAlbumChatVideoFailed = fetchAlbumChatVideoFailed;
exports.clearChatAlbum = clearChatAlbum;
exports.makeChatMessageReadRequested = makeChatMessageReadRequested;
exports.makeChatMessageRead = makeChatMessageRead;
exports.makeChatMessageReadCompleted = makeChatMessageReadCompleted;
exports.makeChatMessageReadFailed = makeChatMessageReadFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/chat-rooms.js

var FETCH_CHAT_ROOMS_LENGTH = exports.FETCH_CHAT_ROOMS_LENGTH = 10;

var FETCH_CHAT_ROOMS = exports.FETCH_CHAT_ROOMS = "FETCH_CHAT_ROOMS";
var FETCH_CHAT_ROOMS_REQUESTED = exports.FETCH_CHAT_ROOMS_REQUESTED = "FETCH_CHAT_ROOMS_REQUESTED";
var FETCH_CHAT_ROOMS_COMPLETED = exports.FETCH_CHAT_ROOMS_COMPLETED = "FETCH_CHAT_ROOMS_COMPLETED";
var FETCH_CHAT_ROOMS_FAILED = exports.FETCH_CHAT_ROOMS_FAILED = "FETCH_CHAT_ROOMS_FAILED";

function fetchChatRoomsRequested() {
  return {
    type: FETCH_CHAT_ROOMS_REQUESTED
  };
}

function fetchChatRooms(offset) {
  return function (dispatch) {
    dispatch(fetchChatRoomsRequested());
    return _gambaApi2.default.get('/chat_rooms', { offset: offset, length: FETCH_CHAT_ROOMS_LENGTH }).then(function (results) {
      dispatch(fetchChatRoomsCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchChatRoomsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchChatRoomsCompleted(results, offset) {
  return {
    type: FETCH_CHAT_ROOMS_COMPLETED,
    results: results, offset: offset
  };
}

function fetchChatRoomsFailed(error) {
  return {
    type: FETCH_CHAT_ROOMS_FAILED,
    error: error
  };
}

var CREATE_CHAT_ROOM = exports.CREATE_CHAT_ROOM = "CREATE_CHAT_ROOM";
var CREATE_CHAT_ROOM_REQUESTED = exports.CREATE_CHAT_ROOM_REQUESTED = "CREATE_CHAT_ROOM_REQUESTED";
var CREATE_CHAT_ROOM_COMPLETED = exports.CREATE_CHAT_ROOM_COMPLETED = "CREATE_CHAT_ROOM_COMPLETED";
var CREATE_CHAT_ROOM_FAILED = exports.CREATE_CHAT_ROOM_FAILED = "CREATE_CHAT_ROOM_FAILED";

function createChatRoomRequested() {
  return {
    type: CREATE_CHAT_ROOM_REQUESTED
  };
}

function createChatRoom(users) {
  return function (dispatch) {
    dispatch(createChatRoomRequested());
    return _gambaApi2.default.post('/chat_rooms', { users: users }).then(function (results) {
      dispatch(createChatRoomCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(createChatRoomFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function createChatRoomCompleted(results) {
  return {
    type: CREATE_CHAT_ROOM_COMPLETED,
    results: results
  };
}

function createChatRoomFailed(error) {
  return {
    type: CREATE_CHAT_ROOM_FAILED,
    error: error
  };
}

var FETCH_CHAT_ROOM = exports.FETCH_CHAT_ROOM = "FETCH_CHAT_ROOM";
var FETCH_CHAT_ROOM_REQUESTED = exports.FETCH_CHAT_ROOM_REQUESTED = "FETCH_CHAT_ROOM_REQUESTED";
var FETCH_CHAT_ROOM_COMPLETED = exports.FETCH_CHAT_ROOM_COMPLETED = "FETCH_CHAT_ROOM_COMPLETED";
var FETCH_CHAT_ROOM_FAILED = exports.FETCH_CHAT_ROOM_FAILED = "FETCH_CHAT_ROOM_FAILED";

function fetchChatRoomRequested() {
  return {
    type: FETCH_CHAT_ROOM_REQUESTED
  };
}

function fetchChatRoom(chat_room_id) {
  return function (dispatch) {
    dispatch(fetchChatRoomRequested());
    return _gambaApi2.default.get('/chat_rooms/' + chat_room_id).then(function (results) {
      dispatch(fetchChatRoomCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchChatRoomFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchChatRoomCompleted(results) {
  return {
    type: FETCH_CHAT_ROOM_COMPLETED,
    results: results
  };
}

function fetchChatRoomFailed(error) {
  return {
    type: FETCH_CHAT_ROOM_FAILED,
    error: error
  };
}

var FETCH_CHAT_ROOM_UNREAD_COUNT = exports.FETCH_CHAT_ROOM_UNREAD_COUNT = "FETCH_CHAT_ROOM_UNREAD_COUNT";
var FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED = exports.FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED = "FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED";
var FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED = exports.FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED = "FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED";
var FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED = exports.FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED = "FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED";

function fetchChatRoomUnreadCountRequested() {
  return {
    type: FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED
  };
}

function fetchChatRoomUnreadCount(page) {
  return function (dispatch) {
    dispatch(fetchChatRoomUnreadCountRequested());
    return _gambaApi2.default.get('/chat_rooms/unread_count').then(function (results) {
      dispatch(fetchChatRoomUnreadCountCompleted(results));
      if (page && results.unread_count) {
        dispatch((0, _alertMessage.emitAlertMessage)(results.unread_count + '\u4EF6\u306E\u65B0\u7740\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u5C4A\u3044\u3066\u3044\u307E\u3059\u3002', 'messageAlert'));
      }
    }).catch(function (error) {
      Promise.all([dispatch(fetchChatRoomUnreadCountFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchChatRoomUnreadCountCompleted(results) {
  return {
    type: FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED,
    results: results
  };
}

function fetchChatRoomUnreadCountFailed(error) {
  return {
    type: FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED,
    error: error
  };
}

var CLEAR_CHAT_ROOM_UNREAD_COUNT = exports.CLEAR_CHAT_ROOM_UNREAD_COUNT = "CLEAR_CHAT_ROOM_UNREAD_COUNT";

function clearChatRoomUnreadCount() {
  return {
    type: CLEAR_CHAT_ROOM_UNREAD_COUNT
  };
}

var DELETE_CHAT_ROOM = exports.DELETE_CHAT_ROOM = "DELETE_CHAT_ROOM";
var DELETE_CHAT_ROOM_REQUESTED = exports.DELETE_CHAT_ROOM_REQUESTED = "DELETE_CHAT_ROOM_REQUESTED";
var DELETE_CHAT_ROOM_COMPLETED = exports.DELETE_CHAT_ROOM_COMPLETED = "DELETE_CHAT_ROOM_COMPLETED";
var DELETE_CHAT_ROOM_FAILED = exports.DELETE_CHAT_ROOM_FAILED = "DELETE_CHAT_ROOM_FAILED";

function deleteChatRoomRequested() {
  return {
    type: DELETE_CHAT_ROOM_REQUESTED
  };
}

function deleteChatRoom(chat_room_id) {
  return function (dispatch) {
    dispatch(deleteChatRoomRequested());
    return _gambaApi2.default.delete('/chat_rooms/' + chat_room_id).then(function (results) {
      dispatch(deleteChatRoomCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deleteChatRoomFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteChatRoomCompleted(results) {
  return {
    type: DELETE_CHAT_ROOM_COMPLETED,
    results: results
  };
}

function deleteChatRoomFailed(error) {
  return {
    type: DELETE_CHAT_ROOM_FAILED,
    error: error
  };
}

var JOIN_CHAT_ROOM = exports.JOIN_CHAT_ROOM = "JOIN_CHAT_ROOM";
var JOIN_CHAT_ROOM_REQUESTED = exports.JOIN_CHAT_ROOM_REQUESTED = "JOIN_CHAT_ROOM_REQUESTED";
var JOIN_CHAT_ROOM_COMPLETED = exports.JOIN_CHAT_ROOM_COMPLETED = "JOIN_CHAT_ROOM_COMPLETED";
var JOIN_CHAT_ROOM_FAILED = exports.JOIN_CHAT_ROOM_FAILED = "JOIN_CHAT_ROOM_FAILED";

function joinChatRoomRequested() {
  return {
    type: JOIN_CHAT_ROOM_REQUESTED
  };
}

function joinChatRoom(chat_room_id, user_id) {
  return function (dispatch) {
    dispatch(joinChatRoomRequested());
    return _gambaApi2.default.put('/chat_rooms/' + chat_room_id, { user_id: user_id, mode: 'join' }).then(function (results) {
      dispatch(joinChatRoomCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(joinChatRoomFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function joinChatRoomCompleted(results) {
  return {
    type: JOIN_CHAT_ROOM_COMPLETED,
    results: results
  };
}

function joinChatRoomFailed(error) {
  return {
    type: JOIN_CHAT_ROOM_FAILED,
    error: error
  };
}

var LEAVE_CHAT_ROOM = exports.LEAVE_CHAT_ROOM = "LEAVE_CHAT_ROOM";
var LEAVE_CHAT_ROOM_REQUESTED = exports.LEAVE_CHAT_ROOM_REQUESTED = "LEAVE_CHAT_ROOM_REQUESTED";
var LEAVE_CHAT_ROOM_COMPLETED = exports.LEAVE_CHAT_ROOM_COMPLETED = "LEAVE_CHAT_ROOM_COMPLETED";
var LEAVE_CHAT_ROOM_FAILED = exports.LEAVE_CHAT_ROOM_FAILED = "LEAVE_CHAT_ROOM_FAILED";

function leaveChatRoomRequested() {
  return {
    type: LEAVE_CHAT_ROOM_REQUESTED
  };
}

function leaveChatRoom(chat_room_id, user_id) {
  return function (dispatch) {
    dispatch(leaveChatRoomRequested());
    return _gambaApi2.default.put('/chat_rooms/' + chat_room_id, { user_id: user_id, mode: 'leave' }).then(function (results) {
      dispatch(leaveChatRoomCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(leaveChatRoomFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function leaveChatRoomCompleted(results) {
  return {
    type: LEAVE_CHAT_ROOM_COMPLETED,
    results: results
  };
}

function leaveChatRoomFailed(error) {
  return {
    type: LEAVE_CHAT_ROOM_FAILED,
    error: error
  };
}

var UPDATE_CHAT_ROOM = exports.UPDATE_CHAT_ROOM = "UPDATE_CHAT_ROOM";
var UPDATE_CHAT_ROOM_REQUESTED = exports.UPDATE_CHAT_ROOM_REQUESTED = "UPDATE_CHAT_ROOM_REQUESTED";
var UPDATE_CHAT_ROOM_COMPLETED = exports.UPDATE_CHAT_ROOM_COMPLETED = "UPDATE_CHAT_ROOM_COMPLETED";
var UPDATE_CHAT_ROOM_FAILED = exports.UPDATE_CHAT_ROOM_FAILED = "UPDATE_CHAT_ROOM_FAILED";

function updateChatRoomRequested() {
  return {
    type: UPDATE_CHAT_ROOM_REQUESTED
  };
}

function updateChatRoom(chat_room_id, name, uploadable_file_id, crop) {
  return function (dispatch) {
    dispatch(updateChatRoomRequested());
    return _gambaApi2.default.put('/chat_rooms/' + chat_room_id, { name: name, mode: 'update', uploadable_file_id: uploadable_file_id, crop: crop }).then(function (results) {
      dispatch(updateChatRoomCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateChatRoomFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateChatRoomCompleted(results) {
  return {
    type: UPDATE_CHAT_ROOM_COMPLETED,
    results: results
  };
}

function updateChatRoomFailed(error) {
  return {
    type: UPDATE_CHAT_ROOM_FAILED,
    error: error
  };
}

var CLEAR_CHAT_ROOMS = exports.CLEAR_CHAT_ROOMS = "CLEAR_CHAT_ROOMS";

function clearChatRooms() {
  return {
    type: CLEAR_CHAT_ROOMS
  };
}

var EXCLUDE_CHAT_ROOM = exports.EXCLUDE_CHAT_ROOM = "EXCLUDE_CHAT_ROOM";
var EXCLUDE_CHAT_ROOM_REQUESTED = exports.EXCLUDE_CHAT_ROOM_REQUESTED = "EXCLUDE_CHAT_ROOM_REQUESTED";
var EXCLUDE_CHAT_ROOM_COMPLETED = exports.EXCLUDE_CHAT_ROOM_COMPLETED = "EXCLUDE_CHAT_ROOM_COMPLETED";
var EXCLUDE_CHAT_ROOM_FAILED = exports.EXCLUDE_CHAT_ROOM_FAILED = "EXCLUDE_CHAT_ROOM_FAILED";

function excludeChatRoomRequested() {
  return {
    type: EXCLUDE_CHAT_ROOM_REQUESTED
  };
}

function excludeChatRoom(chat_room_id, user_id) {
  return function (dispatch) {
    dispatch(excludeChatRoomRequested());
    return _gambaApi2.default.put('/chat_rooms/' + chat_room_id, { user_id: user_id, mode: 'leave' }).then(function (results) {
      dispatch(excludeChatRoomCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(excludeChatRoomFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function excludeChatRoomCompleted(results) {
  return {
    type: EXCLUDE_CHAT_ROOM_COMPLETED,
    results: results
  };
}

function excludeChatRoomFailed(error) {
  return {
    type: EXCLUDE_CHAT_ROOM_FAILED,
    error: error
  };
}

var LOAD_CHAT_ROOM = exports.LOAD_CHAT_ROOM = "LOAD_CHAT_ROOM";

function loadChatRoom(chat_room, deleted) {
  return {
    type: LOAD_CHAT_ROOM,
    chat_room: chat_room,
    deleted: deleted
  };
}

var LOAD_CHAT_ROOM_UNREAD_COUNT = exports.LOAD_CHAT_ROOM_UNREAD_COUNT = "LOAD_CHAT_ROOM_UNREAD_COUNT";

function loadChatRoomUnreadCount(unread_count) {
  return {
    type: LOAD_CHAT_ROOM_UNREAD_COUNT,
    unread_count: unread_count
  };
}

var FETCH_ALBUM_LENGTH = exports.FETCH_ALBUM_LENGTH = 20;

var FETCH_ALBUM_CHAT_IMAGE = exports.FETCH_ALBUM_CHAT_IMAGE = "FETCH_ALBUM_CHAT_IMAGE";
var FETCH_ALBUM_CHAT_IMAGE_REQUESTED = exports.FETCH_ALBUM_CHAT_IMAGE_REQUESTED = "FETCH_ALBUM_CHAT_IMAGE_REQUESTED";
var FETCH_ALBUM_CHAT_IMAGE_COMPLETED = exports.FETCH_ALBUM_CHAT_IMAGE_COMPLETED = "FETCH_ALBUM_CHAT_IMAGE_COMPLETED";
var FETCH_ALBUM_CHAT_IMAGE_FAILED = exports.FETCH_ALBUM_CHAT_IMAGE_FAILED = "FETCH_ALBUM_CHAT_IMAGE_FAILED";

function fetchAlbumChatImageRequested() {
  return {
    type: FETCH_ALBUM_CHAT_IMAGE_REQUESTED
  };
}

function fetchAlbumChatImage(chat_room_id, file_type, offset) {
  return function (dispatch) {
    dispatch(fetchAlbumChatImageRequested());
    return _gambaApi2.default.get('/chat_rooms/' + chat_room_id + '/files', { file_type: file_type, offset: offset, length: FETCH_ALBUM_LENGTH }).then(function (results) {
      dispatch(fetchAlbumChatImageCompleted(results, file_type, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAlbumChatImageFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAlbumChatImageCompleted(results, file_type, offset) {
  return {
    type: FETCH_ALBUM_CHAT_IMAGE_COMPLETED,
    results: results, file_type: file_type, offset: offset
  };
}

function fetchAlbumChatImageFailed(error) {
  return {
    type: FETCH_ALBUM_CHAT_IMAGE_FAILED,
    error: error
  };
}

var FETCH_ALBUM_CHAT_FILE = exports.FETCH_ALBUM_CHAT_FILE = "FETCH_ALBUM_CHAT_FILE";
var FETCH_ALBUM_CHAT_FILE_REQUESTED = exports.FETCH_ALBUM_CHAT_FILE_REQUESTED = "FETCH_ALBUM_CHAT_FILE_REQUESTED";
var FETCH_ALBUM_CHAT_FILE_COMPLETED = exports.FETCH_ALBUM_CHAT_FILE_COMPLETED = "FETCH_ALBUM_CHAT_FILE_COMPLETED";
var FETCH_ALBUM_CHAT_FILE_FAILED = exports.FETCH_ALBUM_CHAT_FILE_FAILED = "FETCH_ALBUM_CHAT_FILE_FAILED";

function fetchAlbumChatFileRequested() {
  return {
    type: FETCH_ALBUM_CHAT_FILE_REQUESTED
  };
}

function fetchAlbumChatFile(chat_room_id, file_type, offset) {
  return function (dispatch) {
    dispatch(fetchAlbumChatFileRequested());
    return _gambaApi2.default.get('/chat_rooms/' + chat_room_id + '/files', { file_type: file_type, offset: offset, length: FETCH_ALBUM_LENGTH }).then(function (results) {
      dispatch(fetchAlbumChatFileCompleted(results, file_type, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAlbumChatFileFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAlbumChatFileCompleted(results, file_type, offset) {
  return {
    type: FETCH_ALBUM_CHAT_FILE_COMPLETED,
    results: results, file_type: file_type, offset: offset
  };
}

function fetchAlbumChatFileFailed(error) {
  return {
    type: FETCH_ALBUM_CHAT_FILE_FAILED,
    error: error
  };
}

var FETCH_ALBUM_CHAT_VIDEO = exports.FETCH_ALBUM_CHAT_VIDEO = "FETCH_ALBUM_CHAT_VIDEO";
var FETCH_ALBUM_CHAT_VIDEO_REQUESTED = exports.FETCH_ALBUM_CHAT_VIDEO_REQUESTED = "FETCH_ALBUM_CHAT_VIDEO_REQUESTED";
var FETCH_ALBUM_CHAT_VIDEO_COMPLETED = exports.FETCH_ALBUM_CHAT_VIDEO_COMPLETED = "FETCH_ALBUM_CHAT_VIDEO_COMPLETED";
var FETCH_ALBUM_CHAT_VIDEO_FAILED = exports.FETCH_ALBUM_CHAT_VIDEO_FAILED = "FETCH_ALBUM_CHAT_VIDEO_FAILED";

function fetchAlbumChatVideoRequested() {
  return {
    type: FETCH_ALBUM_CHAT_VIDEO_REQUESTED
  };
}

function fetchAlbumChatVideo(chat_room_id, offset) {
  return function (dispatch) {
    dispatch(fetchAlbumChatVideoRequested());
    return _gambaApi2.default.get('/chat_rooms/' + chat_room_id + '/videos', { offset: offset, length: FETCH_ALBUM_LENGTH }).then(function (results) {
      dispatch(fetchAlbumChatVideoCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAlbumChatVideoFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAlbumChatVideoCompleted(results, offset) {
  return {
    type: FETCH_ALBUM_CHAT_VIDEO_COMPLETED,
    results: results, offset: offset
  };
}

function fetchAlbumChatVideoFailed(error) {
  return {
    type: FETCH_ALBUM_CHAT_VIDEO_FAILED,
    error: error
  };
}

var CLEAR_CHAT_ALBUM = exports.CLEAR_CHAT_ALBUM = "CLEAR_CHAT_ALBUM";

function clearChatAlbum() {
  return {
    type: CLEAR_CHAT_ALBUM
  };
}

var MAKE_CHAT_MESSAGE_READ = exports.MAKE_CHAT_MESSAGE_READ = "MAKE_CHAT_MESSAGE_READ";
var MAKE_CHAT_MESSAGE_READ_REQUESTED = exports.MAKE_CHAT_MESSAGE_READ_REQUESTED = "MAKE_CHAT_MESSAGE_READ_REQUESTED";
var MAKE_CHAT_MESSAGE_READ_COMPLETED = exports.MAKE_CHAT_MESSAGE_READ_COMPLETED = "MAKE_CHAT_MESSAGE_READ_COMPLETED";
var MAKE_CHAT_MESSAGE_READ_FAILED = exports.MAKE_CHAT_MESSAGE_READ_FAILED = "MAKE_CHAT_MESSAGE_READ_FAILED";

function makeChatMessageReadRequested() {
  return {
    type: MAKE_CHAT_MESSAGE_READ_REQUESTED
  };
}

function makeChatMessageRead(chat_room_id) {
  return function (dispatch) {
    dispatch(makeChatMessageReadRequested());
    return _gambaApi2.default.get('/chat_rooms/' + chat_room_id + '/flush').then(function (results) {
      dispatch(makeChatMessageReadCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(makeChatMessageReadFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function makeChatMessageReadCompleted(results) {
  return {
    type: MAKE_CHAT_MESSAGE_READ_COMPLETED,
    results: results
  };
}

function makeChatMessageReadFailed(error) {
  return {
    type: MAKE_CHAT_MESSAGE_READ_FAILED,
    error: error
  };
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_BLOCK_USERS = exports.UPDATE_BLOCK_USER_FAILED = exports.UPDATE_BLOCK_USER_COMPLETED = exports.UPDATE_BLOCK_USER_REQUESTED = exports.UPDATE_BLOCK_USER = exports.UPDATE_BLOCK_DIARY_FAILED = exports.UPDATE_BLOCK_DIARY_COMPLETED = exports.UPDATE_BLOCK_DIARY_REQUESTED = exports.UPDATE_BLOCK_DIARY = exports.FETCH_BLOCK_USERS_FAILED = exports.FETCH_BLOCK_USERS_COMPLETED = exports.FETCH_BLOCK_USERS_REQUESTED = exports.FETCH_BLOCK_USERS = exports.FETCH_BLOCK_DIARIES_FAILED = exports.FETCH_BLOCK_DIARIES_COMPLETED = exports.FETCH_BLOCK_DIARIES_REQUESTED = exports.FETCH_BLOCK_DIARIES = undefined;
exports.fetchBlockDiariesRequested = fetchBlockDiariesRequested;
exports.fetchBlockDiaries = fetchBlockDiaries;
exports.fetchBlockDiariesCompleted = fetchBlockDiariesCompleted;
exports.fetchBlockDiariesFailed = fetchBlockDiariesFailed;
exports.fetchBlockUsersRequested = fetchBlockUsersRequested;
exports.fetchBlockUsers = fetchBlockUsers;
exports.fetchBlockUsersCompleted = fetchBlockUsersCompleted;
exports.fetchBlockUsersFailed = fetchBlockUsersFailed;
exports.updateBlockDiaryRequested = updateBlockDiaryRequested;
exports.updateBlockDiary = updateBlockDiary;
exports.updateBlockDiaryCompleted = updateBlockDiaryCompleted;
exports.updateBlockDiaryFailed = updateBlockDiaryFailed;
exports.updateBlockUserRequested = updateBlockUserRequested;
exports.updateBlockUser = updateBlockUser;
exports.updateBlockUserCompleted = updateBlockUserCompleted;
exports.updateBlockUserFailed = updateBlockUserFailed;
exports.clearBlockUsers = clearBlockUsers;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/block.js

var FETCH_BLOCK_DIARIES = exports.FETCH_BLOCK_DIARIES = "FETCH_BLOCK_DIARIES";
var FETCH_BLOCK_DIARIES_REQUESTED = exports.FETCH_BLOCK_DIARIES_REQUESTED = "FETCH_BLOCK_DIARIES_REQUESTED";
var FETCH_BLOCK_DIARIES_COMPLETED = exports.FETCH_BLOCK_DIARIES_COMPLETED = "FETCH_BLOCK_DIARIES_COMPLETED";
var FETCH_BLOCK_DIARIES_FAILED = exports.FETCH_BLOCK_DIARIES_FAILED = "FETCH_BLOCK_DIARIES_FAILED";

function fetchBlockDiariesRequested() {
  return {
    type: FETCH_BLOCK_DIARIES_REQUESTED
  };
}

function fetchBlockDiaries() {
  return function (dispatch) {
    dispatch(fetchBlockDiariesRequested());
    return _gambaApi2.default.get('/block/diaries').then(function (results) {
      dispatch(fetchBlockDiariesCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchBlockDiariesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchBlockDiariesCompleted(results) {
  return {
    type: FETCH_BLOCK_DIARIES_COMPLETED,
    results: results
  };
}

function fetchBlockDiariesFailed(error) {
  return {
    type: FETCH_BLOCK_DIARIES_FAILED,
    error: error
  };
}

var FETCH_BLOCK_USERS = exports.FETCH_BLOCK_USERS = "FETCH_BLOCK_USERS";
var FETCH_BLOCK_USERS_REQUESTED = exports.FETCH_BLOCK_USERS_REQUESTED = "FETCH_BLOCK_USERS_REQUESTED";
var FETCH_BLOCK_USERS_COMPLETED = exports.FETCH_BLOCK_USERS_COMPLETED = "FETCH_BLOCK_USERS_COMPLETED";
var FETCH_BLOCK_USERS_FAILED = exports.FETCH_BLOCK_USERS_FAILED = "FETCH_BLOCK_USERS_FAILED";

function fetchBlockUsersRequested() {
  return {
    type: FETCH_BLOCK_USERS_REQUESTED
  };
}

function fetchBlockUsers() {
  return function (dispatch) {
    dispatch(fetchBlockUsersRequested());
    return _gambaApi2.default.get('/block/users').then(function (results) {
      dispatch(fetchBlockUsersCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchBlockUsersFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchBlockUsersCompleted(results) {
  return {
    type: FETCH_BLOCK_USERS_COMPLETED,
    results: results
  };
}

function fetchBlockUsersFailed(error) {
  return {
    type: FETCH_BLOCK_USERS_FAILED,
    error: error
  };
}

var UPDATE_BLOCK_DIARY = exports.UPDATE_BLOCK_DIARY = "UPDATE_BLOCK_DIARY";
var UPDATE_BLOCK_DIARY_REQUESTED = exports.UPDATE_BLOCK_DIARY_REQUESTED = "UPDATE_BLOCK_DIARY_REQUESTED";
var UPDATE_BLOCK_DIARY_COMPLETED = exports.UPDATE_BLOCK_DIARY_COMPLETED = "UPDATE_BLOCK_DIARY_COMPLETED";
var UPDATE_BLOCK_DIARY_FAILED = exports.UPDATE_BLOCK_DIARY_FAILED = "UPDATE_BLOCK_DIARY_FAILED";

function updateBlockDiaryRequested() {
  return {
    type: UPDATE_BLOCK_DIARY_REQUESTED
  };
}

function updateBlockDiary(diary_id, block) {
  return function (dispatch) {
    dispatch(updateBlockDiaryRequested());
    return _gambaApi2.default.put('/block/diaries/' + diary_id, { block: block }).then(function (results) {
      dispatch(updateBlockDiaryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateBlockDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateBlockDiaryCompleted(results) {
  return {
    type: UPDATE_BLOCK_DIARY_COMPLETED,
    results: results
  };
}

function updateBlockDiaryFailed(error) {
  return {
    type: UPDATE_BLOCK_DIARY_FAILED,
    error: error
  };
}

var UPDATE_BLOCK_USER = exports.UPDATE_BLOCK_USER = "UPDATE_BLOCK_USER";
var UPDATE_BLOCK_USER_REQUESTED = exports.UPDATE_BLOCK_USER_REQUESTED = "UPDATE_BLOCK_USER_REQUESTED";
var UPDATE_BLOCK_USER_COMPLETED = exports.UPDATE_BLOCK_USER_COMPLETED = "UPDATE_BLOCK_USER_COMPLETED";
var UPDATE_BLOCK_USER_FAILED = exports.UPDATE_BLOCK_USER_FAILED = "UPDATE_BLOCK_USER_FAILED";

function updateBlockUserRequested() {
  return {
    type: UPDATE_BLOCK_USER_REQUESTED
  };
}

function updateBlockUser(user_id, block) {
  return function (dispatch) {
    dispatch(updateBlockUserRequested());
    return _gambaApi2.default.put('/block/users/' + user_id, { block: block }).then(function (results) {
      dispatch(updateBlockUserCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateBlockUserFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateBlockUserCompleted(results) {
  return {
    type: UPDATE_BLOCK_USER_COMPLETED,
    results: results
  };
}

function updateBlockUserFailed(error) {
  return {
    type: UPDATE_BLOCK_USER_FAILED,
    error: error
  };
}

var CLEAR_BLOCK_USERS = exports.CLEAR_BLOCK_USERS = "CLEAR_BLOCK_USERS";

function clearBlockUsers() {
  return {
    type: CLEAR_BLOCK_USERS
  };
}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_GROUP_ALBUM = exports.FETCH_ALBUM_GROUP_VIDEO_FAILED = exports.FETCH_ALBUM_GROUP_VIDEO_COMPLETED = exports.FETCH_ALBUM_GROUP_VIDEO_REQUESTED = exports.FETCH_ALBUM_GROUP_VIDEO = exports.FETCH_ALBUM_GROUP_FILE_FAILED = exports.FETCH_ALBUM_GROUP_FILE_COMPLETED = exports.FETCH_ALBUM_GROUP_FILE_REQUESTED = exports.FETCH_ALBUM_GROUP_FILE = exports.FETCH_ALBUM_GROUP_IMAGE_FAILED = exports.FETCH_ALBUM_GROUP_IMAGE_COMPLETED = exports.FETCH_ALBUM_GROUP_IMAGE_REQUESTED = exports.FETCH_ALBUM_GROUP_IMAGE = exports.FETCH_ALBUM_LENGTH = exports.LOAD_GROUP_UNREAD_COUNT = exports.LOAD_GROUP = exports.SEARCH_GROUPS = exports.UPDATE_REMIND_MAIL_SCHEDULE_FAILED = exports.UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED = exports.UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED = exports.UPDATE_REMIND_MAIL_SCHEDULE = exports.UPDATE_REMIND_MAIL_SETTING_FAILED = exports.UPDATE_REMIND_MAIL_SETTING_COMPLETED = exports.UPDATE_REMIND_MAIL_SETTING_REQUESTED = exports.UPDATE_REMIND_MAIL_SETTING = exports.FETCH_REMIND_MAIL_SETTINGS_FAILED = exports.FETCH_REMIND_MAIL_SETTINGS_COMPLETED = exports.FETCH_REMIND_MAIL_SETTINGS_REQUESTED = exports.FETCH_REMIND_MAIL_SETTINGS = exports.MERGE_GROUP_FAILED = exports.MERGE_GROUP_COMPLETED = exports.MERGE_GROUP_REQUESTED = exports.MERGE_GROUP = exports.DELETE_GROUP_FAILED = exports.DELETE_GROUP_COMPLETED = exports.DELETE_GROUP_REQUESTED = exports.DELETE_GROUP = exports.SORT_GROUPS_FAILED = exports.SORT_GROUPS_COMPLETED = exports.SORT_GROUPS_REQUESTED = exports.SORT_GROUPS = exports.SORT_GROUP_MEMBERS_FAILED = exports.SORT_GROUP_MEMBERS_COMPLETED = exports.SORT_GROUP_MEMBERS_REQUESTED = exports.SORT_GROUP_MEMBERS = exports.UPDATE_GROUP_MEMBERSHIP_FAILED = exports.UPDATE_GROUP_MEMBERSHIP_COMPLETED = exports.UPDATE_GROUP_MEMBERSHIP_REQUESTED = exports.UPDATE_GROUP_MEMBERSHIP = exports.UPDATE_SCHEDULED_SETTINGS_FAILED = exports.UPDATE_SCHEDULED_SETTINGS_COMPLETED = exports.UPDATE_SCHEDULED_SETTINGS_REQUESTED = exports.UPDATE_SCHEDULED_SETTINGS = exports.CLEAR_SCHEDULED_SETTINGS = exports.FETCH_SCHEDULED_SETTINGS_FAILED = exports.FETCH_SCHEDULED_SETTINGS_COMPLETED = exports.FETCH_SCHEDULED_SETTINGS_REQUESTED = exports.FETCH_SCHEDULED_SETTINGS = exports.UPDATE_GROUP_FAILED = exports.UPDATE_GROUP_COMPLETED = exports.UPDATE_GROUP_REQUESTED = exports.UPDATE_GROUP = exports.CREATE_GROUP_FAILED = exports.CREATE_GROUP_COMPLETED = exports.CREATE_GROUP_REQUESTED = exports.CREATE_GROUP = exports.FETCH_GROUP_FAILED = exports.FETCH_GROUP_COMPLETED = exports.FETCH_GROUP_REQUESTED = exports.FETCH_GROUP = exports.FETCH_ALL_UNREAD_COUNT_FAILED = exports.FETCH_ALL_UNREAD_COUNT_COMPLETED = exports.FETCH_ALL_UNREAD_COUNT_REQUESTED = exports.FETCH_ALL_UNREAD_COUNT = exports.FETCH_GROUP_UNREAD_COUNT_FAILED = exports.FETCH_GROUP_UNREAD_COUNT_COMPLETED = exports.FETCH_GROUP_UNREAD_COUNT_REQUESTED = exports.FETCH_GROUP_UNREAD_COUNT = exports.FETCH_GROUPS_FAILED = exports.FETCH_GROUPS_COMPLETED = exports.FETCH_GROUPS_REQUESTED = exports.FETCH_GROUPS = undefined;
exports.fetchGroupsRequested = fetchGroupsRequested;
exports.fetchGroups = fetchGroups;
exports.fetchGroupsCompleted = fetchGroupsCompleted;
exports.fetchGroupsFailed = fetchGroupsFailed;
exports.fetchGroupUnreadCountRequested = fetchGroupUnreadCountRequested;
exports.fetchGroupUnreadCount = fetchGroupUnreadCount;
exports.fetchGroupUnreadCountCompleted = fetchGroupUnreadCountCompleted;
exports.fetchGroupUnreadCountFailed = fetchGroupUnreadCountFailed;
exports.fetchAllUnreadCountRequested = fetchAllUnreadCountRequested;
exports.fetchAllUnreadCount = fetchAllUnreadCount;
exports.fetchAllUnreadCountCompleted = fetchAllUnreadCountCompleted;
exports.fetchAllUnreadCountFailed = fetchAllUnreadCountFailed;
exports.fetchGroupRequested = fetchGroupRequested;
exports.fetchGroup = fetchGroup;
exports.fetchGroupCompleted = fetchGroupCompleted;
exports.fetchGroupFailed = fetchGroupFailed;
exports.createGroupRequested = createGroupRequested;
exports.createGroup = createGroup;
exports.createGroupCompleted = createGroupCompleted;
exports.createGroupFailed = createGroupFailed;
exports.updateGroupRequested = updateGroupRequested;
exports.updateGroup = updateGroup;
exports.updateGroupCompleted = updateGroupCompleted;
exports.updateGroupFailed = updateGroupFailed;
exports.fetchScheduledSettingsRequested = fetchScheduledSettingsRequested;
exports.fetchScheduledSettings = fetchScheduledSettings;
exports.fetchScheduledSettingsCompleted = fetchScheduledSettingsCompleted;
exports.fetchScheduledSettingsFailed = fetchScheduledSettingsFailed;
exports.clearScheduledSettings = clearScheduledSettings;
exports.updateScheduledSettingsRequested = updateScheduledSettingsRequested;
exports.updateScheduledSettings = updateScheduledSettings;
exports.updateScheduledSettingsCompleted = updateScheduledSettingsCompleted;
exports.updateScheduledSettingsFailed = updateScheduledSettingsFailed;
exports.updateGroupMembershipRequested = updateGroupMembershipRequested;
exports.updateGroupMembership = updateGroupMembership;
exports.updateGroupMembershipCompleted = updateGroupMembershipCompleted;
exports.updateGroupMembershipFailed = updateGroupMembershipFailed;
exports.sortGroupMembersRequested = sortGroupMembersRequested;
exports.sortGroupMembers = sortGroupMembers;
exports.sortGroupMembersCompleted = sortGroupMembersCompleted;
exports.sortGroupMembersFailed = sortGroupMembersFailed;
exports.sortGroupsRequested = sortGroupsRequested;
exports.sortGroups = sortGroups;
exports.sortGroupsCompleted = sortGroupsCompleted;
exports.sortGroupsFailed = sortGroupsFailed;
exports.deleteGroupRequested = deleteGroupRequested;
exports.deleteGroup = deleteGroup;
exports.deleteGroupCompleted = deleteGroupCompleted;
exports.deleteGroupFailed = deleteGroupFailed;
exports.mergeGroupRequested = mergeGroupRequested;
exports.mergeGroup = mergeGroup;
exports.mergeGroupCompleted = mergeGroupCompleted;
exports.mergeGroupFailed = mergeGroupFailed;
exports.fetchRemindMailSettingsRequested = fetchRemindMailSettingsRequested;
exports.fetchRemindMailSettings = fetchRemindMailSettings;
exports.fetchRemindMailSettingsCompleted = fetchRemindMailSettingsCompleted;
exports.fetchRemindMailSettingsFailed = fetchRemindMailSettingsFailed;
exports.updateRemindMailSettingRequested = updateRemindMailSettingRequested;
exports.updateRemindMailSetting = updateRemindMailSetting;
exports.updateRemindMailSettingCompleted = updateRemindMailSettingCompleted;
exports.updateRemindMailSettingFailed = updateRemindMailSettingFailed;
exports.updateRemindMailScheduleRequested = updateRemindMailScheduleRequested;
exports.updateRemindMailSchedule = updateRemindMailSchedule;
exports.updateRemindMailScheduleCompleted = updateRemindMailScheduleCompleted;
exports.updateRemindMailScheduleFailed = updateRemindMailScheduleFailed;
exports.searchGroups = searchGroups;
exports.loadGroup = loadGroup;
exports.loadGroupUnreadCount = loadGroupUnreadCount;
exports.fetchAlbumGroupImageRequested = fetchAlbumGroupImageRequested;
exports.fetchAlbumGroupImage = fetchAlbumGroupImage;
exports.fetchAlbumGroupImageCompleted = fetchAlbumGroupImageCompleted;
exports.fetchAlbumGroupImageFailed = fetchAlbumGroupImageFailed;
exports.fetchAlbumGroupFileRequested = fetchAlbumGroupFileRequested;
exports.fetchAlbumGroupFile = fetchAlbumGroupFile;
exports.fetchAlbumGroupFileCompleted = fetchAlbumGroupFileCompleted;
exports.fetchAlbumGroupFileFailed = fetchAlbumGroupFileFailed;
exports.fetchAlbumGroupVideoRequested = fetchAlbumGroupVideoRequested;
exports.fetchAlbumGroupVideo = fetchAlbumGroupVideo;
exports.fetchAlbumGroupVideoCompleted = fetchAlbumGroupVideoCompleted;
exports.fetchAlbumGroupVideoFailed = fetchAlbumGroupVideoFailed;
exports.clearGroupAlbum = clearGroupAlbum;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/groups.js

var FETCH_GROUPS = exports.FETCH_GROUPS = "FETCH_GROUPS";
var FETCH_GROUPS_REQUESTED = exports.FETCH_GROUPS_REQUESTED = "FETCH_GROUPS_REQUESTED";
var FETCH_GROUPS_COMPLETED = exports.FETCH_GROUPS_COMPLETED = "FETCH_GROUPS_COMPLETED";
var FETCH_GROUPS_FAILED = exports.FETCH_GROUPS_FAILED = "FETCH_GROUPS_FAILED";

function fetchGroupsRequested() {
  return {
    type: FETCH_GROUPS_REQUESTED
  };
}

function fetchGroups() {
  return function (dispatch) {
    dispatch(fetchGroupsRequested());
    return _gambaApi2.default.get('/groups').then(function (results) {
      dispatch(fetchGroupsCompleted(results));
      dispatch(fetchAllUnreadCount());
      // 取得したグループのうち、所属グループとお気に入りの未読件数を取得する
    }).catch(function (error) {
      Promise.all([dispatch(fetchGroupsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchGroupsCompleted(results) {
  return {
    type: FETCH_GROUPS_COMPLETED,
    results: results
  };
}

function fetchGroupsFailed(error) {
  return {
    type: FETCH_GROUPS_FAILED,
    error: error
  };
}

var FETCH_GROUP_UNREAD_COUNT = exports.FETCH_GROUP_UNREAD_COUNT = "FETCH_GROUP_UNREAD_COUNT";
var FETCH_GROUP_UNREAD_COUNT_REQUESTED = exports.FETCH_GROUP_UNREAD_COUNT_REQUESTED = "FETCH_GROUP_UNREAD_COUNT_REQUESTED";
var FETCH_GROUP_UNREAD_COUNT_COMPLETED = exports.FETCH_GROUP_UNREAD_COUNT_COMPLETED = "FETCH_GROUP_UNREAD_COUNT_COMPLETED";
var FETCH_GROUP_UNREAD_COUNT_FAILED = exports.FETCH_GROUP_UNREAD_COUNT_FAILED = "FETCH_GROUP_UNREAD_COUNT_FAILED";

function fetchGroupUnreadCountRequested() {
  return {
    type: FETCH_GROUP_UNREAD_COUNT_REQUESTED
  };
}

function fetchGroupUnreadCount(group_id) {
  return function (dispatch) {
    dispatch(fetchGroupUnreadCountRequested());
    return _gambaApi2.default.get('/diaries/unreads', { group_id: group_id }).then(function (results) {
      dispatch(fetchGroupUnreadCountCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchGroupUnreadCountFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchGroupUnreadCountCompleted(results) {
  return {
    type: FETCH_GROUP_UNREAD_COUNT_COMPLETED,
    results: results
  };
}

function fetchGroupUnreadCountFailed(error) {
  return {
    type: FETCH_GROUP_UNREAD_COUNT_FAILED,
    error: error
  };
}

var FETCH_ALL_UNREAD_COUNT = exports.FETCH_ALL_UNREAD_COUNT = "FETCH_ALL_UNREAD_COUNT";
var FETCH_ALL_UNREAD_COUNT_REQUESTED = exports.FETCH_ALL_UNREAD_COUNT_REQUESTED = "FETCH_ALL_UNREAD_COUNT_REQUESTED";
var FETCH_ALL_UNREAD_COUNT_COMPLETED = exports.FETCH_ALL_UNREAD_COUNT_COMPLETED = "FETCH_ALL_UNREAD_COUNT_COMPLETED";
var FETCH_ALL_UNREAD_COUNT_FAILED = exports.FETCH_ALL_UNREAD_COUNT_FAILED = "FETCH_ALL_UNREAD_COUNT_FAILED";

function fetchAllUnreadCountRequested() {
  return {
    type: FETCH_ALL_UNREAD_COUNT_REQUESTED
  };
}

function fetchAllUnreadCount() {
  return function (dispatch) {
    dispatch(fetchAllUnreadCountRequested());
    return _gambaApi2.default.get('/home_diaries/unreads').then(function (results) {
      dispatch(fetchAllUnreadCountCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAllUnreadCountFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAllUnreadCountCompleted(results) {
  return {
    type: FETCH_ALL_UNREAD_COUNT_COMPLETED,
    results: results
  };
}

function fetchAllUnreadCountFailed(error) {
  return {
    type: FETCH_ALL_UNREAD_COUNT_FAILED,
    error: error
  };
}

var FETCH_GROUP = exports.FETCH_GROUP = "FETCH_GROUP";
var FETCH_GROUP_REQUESTED = exports.FETCH_GROUP_REQUESTED = "FETCH_GROUP_REQUESTED";
var FETCH_GROUP_COMPLETED = exports.FETCH_GROUP_COMPLETED = "FETCH_GROUP_COMPLETED";
var FETCH_GROUP_FAILED = exports.FETCH_GROUP_FAILED = "FETCH_GROUP_FAILED";

function fetchGroupRequested() {
  return {
    type: FETCH_GROUP_REQUESTED
  };
}

function fetchGroup(group_id) {
  return function (dispatch) {
    dispatch(fetchGroupRequested());
    return _gambaApi2.default.get('/groups/' + group_id).then(function (results) {
      dispatch(fetchGroupCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchGroupFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchGroupCompleted(results) {
  return {
    type: FETCH_GROUP_COMPLETED,
    results: results
  };
}

function fetchGroupFailed(error) {
  return {
    type: FETCH_GROUP_FAILED,
    error: error
  };
}

var CREATE_GROUP = exports.CREATE_GROUP = "CREATE_GROUP";
var CREATE_GROUP_REQUESTED = exports.CREATE_GROUP_REQUESTED = "CREATE_GROUP_REQUESTED";
var CREATE_GROUP_COMPLETED = exports.CREATE_GROUP_COMPLETED = "CREATE_GROUP_COMPLETED";
var CREATE_GROUP_FAILED = exports.CREATE_GROUP_FAILED = "CREATE_GROUP_FAILED";

function createGroupRequested() {
  return {
    type: CREATE_GROUP_REQUESTED
  };
}

function createGroup(name, access_type, uploadable_file_id, crop, description, organization_id, cancel_remind_mail, locale) {
  return function (dispatch) {
    dispatch(createGroupRequested());
    return _gambaApi2.default.post('/groups', { name: name, access_type: access_type, uploadable_file_id: uploadable_file_id, crop: crop, description: description, organization_id: organization_id, cancel_remind_mail: cancel_remind_mail, locale: locale }).then(function (results) {
      dispatch(createGroupCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(createGroupFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function createGroupCompleted(results) {
  return {
    type: CREATE_GROUP_COMPLETED,
    results: results
  };
}

function createGroupFailed(error) {
  return {
    type: CREATE_GROUP_FAILED,
    error: error
  };
}

var UPDATE_GROUP = exports.UPDATE_GROUP = "UPDATE_GROUP";
var UPDATE_GROUP_REQUESTED = exports.UPDATE_GROUP_REQUESTED = "UPDATE_GROUP_REQUESTED";
var UPDATE_GROUP_COMPLETED = exports.UPDATE_GROUP_COMPLETED = "UPDATE_GROUP_COMPLETED";
var UPDATE_GROUP_FAILED = exports.UPDATE_GROUP_FAILED = "UPDATE_GROUP_FAILED";

function updateGroupRequested() {
  return {
    type: UPDATE_GROUP_REQUESTED
  };
}

function updateGroup(group_id, name, access_type, uploadable_file_id, crop, description, locale) {
  return function (dispatch) {
    dispatch(updateGroupRequested());
    return _gambaApi2.default.put('/groups/' + group_id, { name: name, access_type: access_type, uploadable_file_id: uploadable_file_id, crop: crop, description: description, locale: locale }).then(function (results) {
      dispatch(updateGroupCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateGroupFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateGroupCompleted(results) {
  return {
    type: UPDATE_GROUP_COMPLETED,
    results: results
  };
}

function updateGroupFailed(error) {
  return {
    type: UPDATE_GROUP_FAILED,
    error: error
  };
}

var FETCH_SCHEDULED_SETTINGS = exports.FETCH_SCHEDULED_SETTINGS = "FETCH_SCHEDULED_SETTINGS";
var FETCH_SCHEDULED_SETTINGS_REQUESTED = exports.FETCH_SCHEDULED_SETTINGS_REQUESTED = "FETCH_SCHEDULED_SETTINGS_REQUESTED";
var FETCH_SCHEDULED_SETTINGS_COMPLETED = exports.FETCH_SCHEDULED_SETTINGS_COMPLETED = "FETCH_SCHEDULED_SETTINGS_COMPLETED";
var FETCH_SCHEDULED_SETTINGS_FAILED = exports.FETCH_SCHEDULED_SETTINGS_FAILED = "FETCH_SCHEDULED_SETTINGS_FAILED";

function fetchScheduledSettingsRequested() {
  return {
    type: FETCH_SCHEDULED_SETTINGS_REQUESTED
  };
}

function fetchScheduledSettings(group_id) {
  return function (dispatch) {
    dispatch(fetchScheduledSettingsRequested());

    // Get the scheduled settings
    return _gambaApi2.default.get('/group_memberships/settings/' + group_id).then(function (results) {
      dispatch(fetchScheduledSettingsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchScheduledSettingsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)('error:fetch-scheduled-settings', 'error'))]);
    });
  };
}

function fetchScheduledSettingsCompleted(results) {
  return {
    type: FETCH_SCHEDULED_SETTINGS_COMPLETED,
    results: results
  };
}

function fetchScheduledSettingsFailed(error) {
  return {
    type: FETCH_SCHEDULED_SETTINGS_FAILED,
    error: error
  };
}

var CLEAR_SCHEDULED_SETTINGS = exports.CLEAR_SCHEDULED_SETTINGS = "CLEAR_SCHEDULED_SETTINGS";

function clearScheduledSettings() {
  return {
    type: CLEAR_SCHEDULED_SETTINGS
  };
}

var UPDATE_SCHEDULED_SETTINGS = exports.UPDATE_SCHEDULED_SETTINGS = "UPDATE_SCHEDULED_SETTINGS";
var UPDATE_SCHEDULED_SETTINGS_REQUESTED = exports.UPDATE_SCHEDULED_SETTINGS_REQUESTED = "UPDATE_SCHEDULED_SETTINGS_REQUESTED";
var UPDATE_SCHEDULED_SETTINGS_COMPLETED = exports.UPDATE_SCHEDULED_SETTINGS_COMPLETED = "UPDATE_SCHEDULED_SETTINGS_COMPLETED";
var UPDATE_SCHEDULED_SETTINGS_FAILED = exports.UPDATE_SCHEDULED_SETTINGS_FAILED = "UPDATE_SCHEDULED_SETTINGS_FAILED";

function updateScheduledSettingsRequested() {
  return {
    type: UPDATE_SCHEDULED_SETTINGS_REQUESTED
  };
}

function updateScheduledSettings(group_id, refresh_token, is_active, folder_id, interval, generate_next_at, access_token) {
  return function (dispatch) {
    dispatch(updateScheduledSettingsRequested());

    // Update the scheduled settings
    return _gambaApi2.default.post('/group_memberships/settings/' + group_id, { refresh_token: refresh_token, is_active: is_active, folder_id: folder_id, interval: interval, generate_next_at: generate_next_at, access_token: access_token }).then(function (results) {
      dispatch(updateScheduledSettingsCompleted(results));
      dispatch((0, _alertMessage.emitAlertMessage)('定期実行設定が更新されました。', 'success'));
    }).catch(function (error) {
      Promise.all([dispatch(updateScheduledSettingsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)('error:update-scheduled-settings', 'error'))]);
    });
  };
}

function updateScheduledSettingsCompleted(results) {
  return {
    type: UPDATE_SCHEDULED_SETTINGS_COMPLETED,
    results: results
  };
}

function updateScheduledSettingsFailed(error) {
  return {
    type: UPDATE_SCHEDULED_SETTINGS_FAILED,
    error: error
  };
}

var UPDATE_GROUP_MEMBERSHIP = exports.UPDATE_GROUP_MEMBERSHIP = "UPDATE_GROUP_MEMBERSHIP";
var UPDATE_GROUP_MEMBERSHIP_REQUESTED = exports.UPDATE_GROUP_MEMBERSHIP_REQUESTED = "UPDATE_GROUP_MEMBERSHIP_REQUESTED";
var UPDATE_GROUP_MEMBERSHIP_COMPLETED = exports.UPDATE_GROUP_MEMBERSHIP_COMPLETED = "UPDATE_GROUP_MEMBERSHIP_COMPLETED";
var UPDATE_GROUP_MEMBERSHIP_FAILED = exports.UPDATE_GROUP_MEMBERSHIP_FAILED = "UPDATE_GROUP_MEMBERSHIP_FAILED";

function updateGroupMembershipRequested() {
  return {
    type: UPDATE_GROUP_MEMBERSHIP_REQUESTED
  };
}

function updateGroupMembership(group_id, user_id, membership) {
  return function (dispatch) {
    dispatch(updateGroupMembershipRequested());
    return _gambaApi2.default.put('/group_memberships/' + group_id + '/members/' + user_id, { membership: membership }).then(function (results) {
      dispatch(updateGroupMembershipCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateGroupMembershipFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateGroupMembershipCompleted(results) {
  return {
    type: UPDATE_GROUP_MEMBERSHIP_COMPLETED,
    results: results
  };
}

function updateGroupMembershipFailed(error) {
  return {
    type: UPDATE_GROUP_MEMBERSHIP_FAILED,
    error: error
  };
}

var SORT_GROUP_MEMBERS = exports.SORT_GROUP_MEMBERS = "SORT_GROUP_MEMBERS";
var SORT_GROUP_MEMBERS_REQUESTED = exports.SORT_GROUP_MEMBERS_REQUESTED = "SORT_GROUP_MEMBERS_REQUESTED";
var SORT_GROUP_MEMBERS_COMPLETED = exports.SORT_GROUP_MEMBERS_COMPLETED = "SORT_GROUP_MEMBERS_COMPLETED";
var SORT_GROUP_MEMBERS_FAILED = exports.SORT_GROUP_MEMBERS_FAILED = "SORT_GROUP_MEMBERS_FAILED";

function sortGroupMembersRequested() {
  return {
    type: SORT_GROUP_MEMBERS_REQUESTED
  };
}

function sortGroupMembers(group_id, sort_order) {
  return function (dispatch) {
    dispatch(sortGroupMembersRequested());
    return _gambaApi2.default.put('/group_memberships/sort/' + group_id, { sort_order: sort_order }).then(function (results) {
      dispatch(sortGroupMembersCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(sortGroupMembersFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function sortGroupMembersCompleted(results) {
  return {
    type: SORT_GROUP_MEMBERS_COMPLETED,
    results: results
  };
}

function sortGroupMembersFailed(error) {
  return {
    type: SORT_GROUP_MEMBERS_FAILED,
    error: error
  };
}

var SORT_GROUPS = exports.SORT_GROUPS = "SORT_GROUPS";
var SORT_GROUPS_REQUESTED = exports.SORT_GROUPS_REQUESTED = "SORT_GROUPS_REQUESTED";
var SORT_GROUPS_COMPLETED = exports.SORT_GROUPS_COMPLETED = "SORT_GROUPS_COMPLETED";
var SORT_GROUPS_FAILED = exports.SORT_GROUPS_FAILED = "SORT_GROUPS_FAILED";

function sortGroupsRequested() {
  return {
    type: SORT_GROUPS_REQUESTED
  };
}

function sortGroups(sort_order) {
  return function (dispatch) {
    dispatch(sortGroupsRequested());
    return _gambaApi2.default.put('/groups/sort', { sort_order: sort_order }).then(function (results) {
      dispatch(sortGroupsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(sortGroupsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function sortGroupsCompleted(results) {
  return {
    type: SORT_GROUPS_COMPLETED,
    results: results
  };
}

function sortGroupsFailed(error) {
  return {
    type: SORT_GROUPS_FAILED,
    error: error
  };
}

var DELETE_GROUP = exports.DELETE_GROUP = "DELETE_GROUP";
var DELETE_GROUP_REQUESTED = exports.DELETE_GROUP_REQUESTED = "DELETE_GROUP_REQUESTED";
var DELETE_GROUP_COMPLETED = exports.DELETE_GROUP_COMPLETED = "DELETE_GROUP_COMPLETED";
var DELETE_GROUP_FAILED = exports.DELETE_GROUP_FAILED = "DELETE_GROUP_FAILED";

function deleteGroupRequested() {
  return {
    type: DELETE_GROUP_REQUESTED
  };
}

function deleteGroup(group_id) {
  return function (dispatch) {
    dispatch(deleteGroupRequested());
    return _gambaApi2.default.delete('/groups/' + group_id).then(function (results) {
      dispatch(deleteGroupCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deleteGroupFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteGroupCompleted(results) {
  return {
    type: DELETE_GROUP_COMPLETED,
    results: results
  };
}

function deleteGroupFailed(error) {
  return {
    type: DELETE_GROUP_FAILED,
    error: error
  };
}

var MERGE_GROUP = exports.MERGE_GROUP = "MERGE_GROUP";
var MERGE_GROUP_REQUESTED = exports.MERGE_GROUP_REQUESTED = "MERGE_GROUP_REQUESTED";
var MERGE_GROUP_COMPLETED = exports.MERGE_GROUP_COMPLETED = "MERGE_GROUP_COMPLETED";
var MERGE_GROUP_FAILED = exports.MERGE_GROUP_FAILED = "MERGE_GROUP_FAILED";

function mergeGroupRequested() {
  return {
    type: MERGE_GROUP_REQUESTED
  };
}

function mergeGroup(group_id, to_group_id) {
  return function (dispatch) {
    dispatch(mergeGroupRequested());
    return _gambaApi2.default.put('/groups/' + group_id + '/merge/' + to_group_id).then(function (results) {
      dispatch(mergeGroupCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(mergeGroupFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function mergeGroupCompleted(results) {
  return {
    type: MERGE_GROUP_COMPLETED,
    results: results
  };
}

function mergeGroupFailed(error) {
  return {
    type: MERGE_GROUP_FAILED,
    error: error
  };
}

var FETCH_REMIND_MAIL_SETTINGS = exports.FETCH_REMIND_MAIL_SETTINGS = "FETCH_REMIND_MAIL_SETTINGS";
var FETCH_REMIND_MAIL_SETTINGS_REQUESTED = exports.FETCH_REMIND_MAIL_SETTINGS_REQUESTED = "FETCH_REMIND_MAIL_SETTINGS_REQUESTED";
var FETCH_REMIND_MAIL_SETTINGS_COMPLETED = exports.FETCH_REMIND_MAIL_SETTINGS_COMPLETED = "FETCH_REMIND_MAIL_SETTINGS_COMPLETED";
var FETCH_REMIND_MAIL_SETTINGS_FAILED = exports.FETCH_REMIND_MAIL_SETTINGS_FAILED = "FETCH_REMIND_MAIL_SETTINGS_FAILED";

function fetchRemindMailSettingsRequested() {
  return {
    type: FETCH_REMIND_MAIL_SETTINGS_REQUESTED
  };
}

function fetchRemindMailSettings(group_id) {
  return function (dispatch) {
    dispatch(fetchRemindMailSettingsRequested());
    return _gambaApi2.default.get('/remind_mail_settings', { group_id: group_id }).then(function (results) {
      dispatch(fetchRemindMailSettingsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchRemindMailSettingsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchRemindMailSettingsCompleted(results) {
  return {
    type: FETCH_REMIND_MAIL_SETTINGS_COMPLETED,
    results: results
  };
}

function fetchRemindMailSettingsFailed(error) {
  return {
    type: FETCH_REMIND_MAIL_SETTINGS_FAILED,
    error: error
  };
}

var UPDATE_REMIND_MAIL_SETTING = exports.UPDATE_REMIND_MAIL_SETTING = "UPDATE_REMIND_MAIL_SETTING";
var UPDATE_REMIND_MAIL_SETTING_REQUESTED = exports.UPDATE_REMIND_MAIL_SETTING_REQUESTED = "UPDATE_REMIND_MAIL_SETTING_REQUESTED";
var UPDATE_REMIND_MAIL_SETTING_COMPLETED = exports.UPDATE_REMIND_MAIL_SETTING_COMPLETED = "UPDATE_REMIND_MAIL_SETTING_COMPLETED";
var UPDATE_REMIND_MAIL_SETTING_FAILED = exports.UPDATE_REMIND_MAIL_SETTING_FAILED = "UPDATE_REMIND_MAIL_SETTING_FAILED";

function updateRemindMailSettingRequested() {
  return {
    type: UPDATE_REMIND_MAIL_SETTING_REQUESTED
  };
}

function updateRemindMailSetting(group_id, user_id, delivery) {
  return function (dispatch) {
    dispatch(updateRemindMailSettingRequested());
    return _gambaApi2.default.put('/remind_mail_settings/' + user_id, { group_id: group_id, delivery: delivery }).then(function (results) {
      dispatch(updateRemindMailSettingCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateRemindMailSettingFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateRemindMailSettingCompleted(results) {
  return {
    type: UPDATE_REMIND_MAIL_SETTING_COMPLETED,
    results: results
  };
}

function updateRemindMailSettingFailed(error) {
  return {
    type: UPDATE_REMIND_MAIL_SETTING_FAILED,
    error: error
  };
}

var UPDATE_REMIND_MAIL_SCHEDULE = exports.UPDATE_REMIND_MAIL_SCHEDULE = "UPDATE_REMIND_MAIL_SCHEDULE";
var UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED = exports.UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED = "UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED";
var UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED = exports.UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED = "UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED";
var UPDATE_REMIND_MAIL_SCHEDULE_FAILED = exports.UPDATE_REMIND_MAIL_SCHEDULE_FAILED = "UPDATE_REMIND_MAIL_SCHEDULE_FAILED";

function updateRemindMailScheduleRequested() {
  return {
    type: UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED
  };
}

function updateRemindMailSchedule(group_id, send_on_sun, send_on_mon, send_on_tue, send_on_wed, send_on_thu, send_on_fri, send_on_sat, send_on_holiday, send_at, timezone) {
  return function (dispatch) {
    dispatch(updateRemindMailScheduleRequested());
    return _gambaApi2.default.put('/remind_mail_settings/schedule', { group_id: group_id, send_on_sun: send_on_sun, send_on_mon: send_on_mon, send_on_tue: send_on_tue, send_on_wed: send_on_wed, send_on_thu: send_on_thu, send_on_fri: send_on_fri, send_on_sat: send_on_sat, send_on_holiday: send_on_holiday, send_at: send_at, timezone: timezone }).then(function (results) {
      dispatch(updateRemindMailScheduleCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateRemindMailScheduleFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateRemindMailScheduleCompleted(results) {
  return {
    type: UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED,
    results: results
  };
}

function updateRemindMailScheduleFailed(error) {
  return {
    type: UPDATE_REMIND_MAIL_SCHEDULE_FAILED,
    error: error
  };
}

var SEARCH_GROUPS = exports.SEARCH_GROUPS = "SEARCH_GROUPS";

function searchGroups(query) {
  return {
    type: SEARCH_GROUPS,
    query: query && query.length > 0 ? query : undefined
  };
}

var LOAD_GROUP = exports.LOAD_GROUP = "LOAD_GROUP";

function loadGroup(group) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    type: LOAD_GROUP,
    group: group,
    deleted: opt.deleted
  };
}

var LOAD_GROUP_UNREAD_COUNT = exports.LOAD_GROUP_UNREAD_COUNT = "LOAD_GROUP_UNREAD_COUNT";

function loadGroupUnreadCount(group_id, unreads) {
  return {
    type: LOAD_GROUP_UNREAD_COUNT,
    group_id: group_id, unreads: unreads
  };
}

var FETCH_ALBUM_LENGTH = exports.FETCH_ALBUM_LENGTH = 20;

var FETCH_ALBUM_GROUP_IMAGE = exports.FETCH_ALBUM_GROUP_IMAGE = "FETCH_ALBUM_GROUP_IMAGE";
var FETCH_ALBUM_GROUP_IMAGE_REQUESTED = exports.FETCH_ALBUM_GROUP_IMAGE_REQUESTED = "FETCH_ALBUM_GROUP_IMAGE_REQUESTED";
var FETCH_ALBUM_GROUP_IMAGE_COMPLETED = exports.FETCH_ALBUM_GROUP_IMAGE_COMPLETED = "FETCH_ALBUM_GROUP_IMAGE_COMPLETED";
var FETCH_ALBUM_GROUP_IMAGE_FAILED = exports.FETCH_ALBUM_GROUP_IMAGE_FAILED = "FETCH_ALBUM_GROUP_IMAGE_FAILED";

function fetchAlbumGroupImageRequested() {
  return {
    type: FETCH_ALBUM_GROUP_IMAGE_REQUESTED
  };
}

function fetchAlbumGroupImage(group_id, file_type, offset) {
  return function (dispatch) {
    dispatch(fetchAlbumGroupImageRequested());
    return _gambaApi2.default.get('/groups/' + group_id + '/files', { file_type: file_type, offset: offset, length: FETCH_ALBUM_LENGTH }).then(function (results) {
      dispatch(fetchAlbumGroupImageCompleted(results, file_type, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAlbumGroupImageFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAlbumGroupImageCompleted(results, file_type, offset) {
  return {
    type: FETCH_ALBUM_GROUP_IMAGE_COMPLETED,
    results: results, file_type: file_type, offset: offset
  };
}

function fetchAlbumGroupImageFailed(error) {
  return {
    type: FETCH_ALBUM_GROUP_IMAGE_FAILED,
    error: error
  };
}

var FETCH_ALBUM_GROUP_FILE = exports.FETCH_ALBUM_GROUP_FILE = "FETCH_ALBUM_GROUP_FILE";
var FETCH_ALBUM_GROUP_FILE_REQUESTED = exports.FETCH_ALBUM_GROUP_FILE_REQUESTED = "FETCH_ALBUM_GROUP_FILE_REQUESTED";
var FETCH_ALBUM_GROUP_FILE_COMPLETED = exports.FETCH_ALBUM_GROUP_FILE_COMPLETED = "FETCH_ALBUM_GROUP_FILE_COMPLETED";
var FETCH_ALBUM_GROUP_FILE_FAILED = exports.FETCH_ALBUM_GROUP_FILE_FAILED = "FETCH_ALBUM_GROUP_FILE_FAILED";

function fetchAlbumGroupFileRequested() {
  return {
    type: FETCH_ALBUM_GROUP_FILE_REQUESTED
  };
}

function fetchAlbumGroupFile(group_id, file_type, offset) {
  return function (dispatch) {
    dispatch(fetchAlbumGroupFileRequested());
    return _gambaApi2.default.get('/groups/' + group_id + '/files', { file_type: file_type, offset: offset, length: FETCH_ALBUM_LENGTH }).then(function (results) {
      dispatch(fetchAlbumGroupFileCompleted(results, file_type, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAlbumGroupFileFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAlbumGroupFileCompleted(results, file_type, offset) {
  return {
    type: FETCH_ALBUM_GROUP_FILE_COMPLETED,
    results: results, file_type: file_type, offset: offset
  };
}

function fetchAlbumGroupFileFailed(error) {
  return {
    type: FETCH_ALBUM_GROUP_FILE_FAILED,
    error: error
  };
}

var FETCH_ALBUM_GROUP_VIDEO = exports.FETCH_ALBUM_GROUP_VIDEO = "FETCH_ALBUM_GROUP_VIDEO";
var FETCH_ALBUM_GROUP_VIDEO_REQUESTED = exports.FETCH_ALBUM_GROUP_VIDEO_REQUESTED = "FETCH_ALBUM_GROUP_VIDEO_REQUESTED";
var FETCH_ALBUM_GROUP_VIDEO_COMPLETED = exports.FETCH_ALBUM_GROUP_VIDEO_COMPLETED = "FETCH_ALBUM_GROUP_VIDEO_COMPLETED";
var FETCH_ALBUM_GROUP_VIDEO_FAILED = exports.FETCH_ALBUM_GROUP_VIDEO_FAILED = "FETCH_ALBUM_GROUP_VIDEO_FAILED";

function fetchAlbumGroupVideoRequested() {
  return {
    type: FETCH_ALBUM_GROUP_VIDEO_REQUESTED
  };
}

function fetchAlbumGroupVideo(group_id, offset) {
  return function (dispatch) {
    dispatch(fetchAlbumGroupVideoRequested());
    return _gambaApi2.default.get('/groups/' + group_id + '/videos', { offset: offset, length: FETCH_ALBUM_LENGTH }).then(function (results) {
      dispatch(fetchAlbumGroupVideoCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAlbumGroupVideoFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAlbumGroupVideoCompleted(results, offset) {
  return {
    type: FETCH_ALBUM_GROUP_VIDEO_COMPLETED,
    results: results, offset: offset
  };
}

function fetchAlbumGroupVideoFailed(error) {
  return {
    type: FETCH_ALBUM_GROUP_VIDEO_FAILED,
    error: error
  };
}

var CLEAR_GROUP_ALBUM = exports.CLEAR_GROUP_ALBUM = "CLEAR_GROUP_ALBUM";

function clearGroupAlbum() {
  return {
    type: CLEAR_GROUP_ALBUM
  };
}

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_HOME_DIARIES_FAILED = exports.FETCH_HOME_DIARIES_COMPLETED = exports.FETCH_HOME_DIARIES_REQUESTED = exports.FETCH_HOME_DIARIES = undefined;
exports.fetchHomeDiariesRequested = fetchHomeDiariesRequested;
exports.fetchHomeDiaries = fetchHomeDiaries;
exports.fetchHomeDiariesCompleted = fetchHomeDiariesCompleted;
exports.fetchHomeDiariesFailed = fetchHomeDiariesFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/home-diaries.js

var FETCH_HOME_DIARIES = exports.FETCH_HOME_DIARIES = "FETCH_HOME_DIARIES";
var FETCH_HOME_DIARIES_REQUESTED = exports.FETCH_HOME_DIARIES_REQUESTED = "FETCH_HOME_DIARIES_REQUESTED";
var FETCH_HOME_DIARIES_COMPLETED = exports.FETCH_HOME_DIARIES_COMPLETED = "FETCH_HOME_DIARIES_COMPLETED";
var FETCH_HOME_DIARIES_FAILED = exports.FETCH_HOME_DIARIES_FAILED = "FETCH_HOME_DIARIES_FAILED";

function fetchHomeDiariesRequested() {
  return {
    type: FETCH_HOME_DIARIES_REQUESTED,
    group_id: 'home'
  };
}

function fetchHomeDiaries(offset, division_id) {
  return function (dispatch) {
    dispatch(fetchHomeDiariesRequested());
    return _gambaApi2.default.get('/home_diaries', { offset: offset, division_id: division_id == 'new' ? 0 : division_id }).then(function (results) {
      dispatch(fetchHomeDiariesCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchHomeDiariesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchHomeDiariesCompleted(results, offset) {
  return {
    type: FETCH_HOME_DIARIES_COMPLETED,
    group_id: 'home',
    results: results, offset: offset
  };
}

function fetchHomeDiariesFailed(error) {
  return {
    type: FETCH_HOME_DIARIES_FAILED,
    group_id: 'home',
    error: error
  };
}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_HOME_NOTIFICATIONS = exports.FLUSH_UNREAD_HOME_NOTIFICATIONS_FAILED = exports.FLUSH_UNREAD_HOME_NOTIFICATIONS_COMPLETED = exports.FLUSH_UNREAD_HOME_NOTIFICATIONS_REQUESTED = exports.FLUSH_UNREAD_HOME_NOTIFICATIONS = exports.LOAD_HOME_NOTIFICATION_UNREAD_COUNT = exports.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_FAILED = exports.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_COMPLETED = exports.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_REQUESTED = exports.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT = exports.FETCH_HOME_NOTIFICATIONS_FAILED = exports.FETCH_HOME_NOTIFICATIONS_COMPLETED = exports.FETCH_HOME_NOTIFICATIONS_REQUESTED = exports.FETCH_HOME_NOTIFICATIONS = undefined;
exports.fetchHomeNotificationsRequested = fetchHomeNotificationsRequested;
exports.fetchHomeNotifications = fetchHomeNotifications;
exports.fetchHomeNotificationsCompleted = fetchHomeNotificationsCompleted;
exports.fetchHomeNotificationsFailed = fetchHomeNotificationsFailed;
exports.fetchHomeNotificationsUnreadCountRequested = fetchHomeNotificationsUnreadCountRequested;
exports.fetchHomeNotificationsUnreadCount = fetchHomeNotificationsUnreadCount;
exports.fetchHomeNotificationsUnreadCountCompleted = fetchHomeNotificationsUnreadCountCompleted;
exports.fetchHomeNotificationsUnreadCountFailed = fetchHomeNotificationsUnreadCountFailed;
exports.loadHomeNotificationUnreadCount = loadHomeNotificationUnreadCount;
exports.flushUnreadHomeNotificationsRequested = flushUnreadHomeNotificationsRequested;
exports.flushUnreadHomeNotifications = flushUnreadHomeNotifications;
exports.flushUnreadHomeNotificationsCompleted = flushUnreadHomeNotificationsCompleted;
exports.flushUnreadHomeNotificationsFailed = flushUnreadHomeNotificationsFailed;
exports.clearHomeNotifications = clearHomeNotifications;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/home-notifications.js

var FETCH_HOME_NOTIFICATIONS = exports.FETCH_HOME_NOTIFICATIONS = "FETCH_HOME_NOTIFICATIONS";
var FETCH_HOME_NOTIFICATIONS_REQUESTED = exports.FETCH_HOME_NOTIFICATIONS_REQUESTED = "FETCH_HOME_NOTIFICATIONS_REQUESTED";
var FETCH_HOME_NOTIFICATIONS_COMPLETED = exports.FETCH_HOME_NOTIFICATIONS_COMPLETED = "FETCH_HOME_NOTIFICATIONS_COMPLETED";
var FETCH_HOME_NOTIFICATIONS_FAILED = exports.FETCH_HOME_NOTIFICATIONS_FAILED = "FETCH_HOME_NOTIFICATIONS_FAILED";

function fetchHomeNotificationsRequested() {
  return {
    type: FETCH_HOME_NOTIFICATIONS_REQUESTED,
    group_id: 'home'
  };
}

function fetchHomeNotifications(offset, division_id) {
  return function (dispatch) {
    dispatch(fetchHomeNotificationsRequested());
    return _gambaApi2.default.get('/home_notifications', { offset: offset, division_id: division_id == 'new' ? 0 : division_id }).then(function (results) {
      dispatch(fetchHomeNotificationsCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchHomeNotificationsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchHomeNotificationsCompleted(results, offset) {
  return {
    type: FETCH_HOME_NOTIFICATIONS_COMPLETED,
    results: results, offset: offset,
    group_id: 'home'
  };
}

function fetchHomeNotificationsFailed(error) {
  return {
    type: FETCH_HOME_NOTIFICATIONS_FAILED,
    error: error,
    group_id: 'home'
  };
}

var FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT = exports.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT = "FETCH_NOTIFICATION_UNREAD_COUNT";
var FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_REQUESTED = exports.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_REQUESTED = "FETCH_NOTIFICATION_UNREAD_COUNT_REQUESTED";
var FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_COMPLETED = exports.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_COMPLETED = "FETCH_NOTIFICATION_UNREAD_COUNT_COMPLETED";
var FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_FAILED = exports.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_FAILED = "FETCH_NOTIFICATION_UNREAD_COUNT_FAILED";

function fetchHomeNotificationsUnreadCountRequested() {
  return {
    type: FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_REQUESTED
  };
}

function fetchHomeNotificationsUnreadCount(division_id) {
  return function (dispatch) {
    dispatch(fetchHomeNotificationsUnreadCountRequested());
    return _gambaApi2.default.get('/home_notifications/count', { division_id: division_id == 'new' ? 0 : division_id }).then(function (results) {
      dispatch(fetchHomeNotificationsUnreadCountCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchHomeNotificationsUnreadCountFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchHomeNotificationsUnreadCountCompleted(results) {
  return {
    type: FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_COMPLETED,
    results: results,
    group_id: 'home'
  };
}

function fetchHomeNotificationsUnreadCountFailed(error) {
  return {
    type: FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_FAILED,
    error: error
  };
}

var LOAD_HOME_NOTIFICATION_UNREAD_COUNT = exports.LOAD_HOME_NOTIFICATION_UNREAD_COUNT = "LOAD_HOME_NOTIFICATION_UNREAD_COUNT";

function loadHomeNotificationUnreadCount(count) {
  return {
    type: LOAD_HOME_NOTIFICATION_UNREAD_COUNT, count: count,
    group_id: 'home'
  };
}

var FLUSH_UNREAD_HOME_NOTIFICATIONS = exports.FLUSH_UNREAD_HOME_NOTIFICATIONS = "FLUSH_UNREAD_HOME_NOTIFICATIONS";
var FLUSH_UNREAD_HOME_NOTIFICATIONS_REQUESTED = exports.FLUSH_UNREAD_HOME_NOTIFICATIONS_REQUESTED = "FLUSH_UNREAD_HOME_NOTIFICATIONS_REQUESTED";
var FLUSH_UNREAD_HOME_NOTIFICATIONS_COMPLETED = exports.FLUSH_UNREAD_HOME_NOTIFICATIONS_COMPLETED = "FLUSH_UNREAD_HOME_NOTIFICATIONS_COMPLETED";
var FLUSH_UNREAD_HOME_NOTIFICATIONS_FAILED = exports.FLUSH_UNREAD_HOME_NOTIFICATIONS_FAILED = "FLUSH_UNREAD_HOME_NOTIFICATIONS_FAILED";

function flushUnreadHomeNotificationsRequested() {
  return {
    type: FLUSH_UNREAD_HOME_NOTIFICATIONS_REQUESTED
  };
}

function flushUnreadHomeNotifications(division_id) {
  return function (dispatch) {
    dispatch(flushUnreadHomeNotificationsRequested());
    return _gambaApi2.default.get('/home_notifications/flush', { division_id: division_id == 'new' ? 0 : division_id }).then(function (results) {
      dispatch(flushUnreadHomeNotificationsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(flushUnreadHomeNotificationsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function flushUnreadHomeNotificationsCompleted(results) {
  return {
    type: FLUSH_UNREAD_HOME_NOTIFICATIONS_COMPLETED,
    group_id: 'home',
    results: results
  };
}

function flushUnreadHomeNotificationsFailed(error) {
  return {
    type: FLUSH_UNREAD_HOME_NOTIFICATIONS_FAILED,
    error: error
  };
}

var CLEAR_HOME_NOTIFICATIONS = exports.CLEAR_HOME_NOTIFICATIONS = "CLEAR_HOME_NOTIFICATIONS";

function clearHomeNotifications() {
  return {
    type: CLEAR_HOME_NOTIFICATIONS
  };
}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_HOME_DIARIES_FAILED = exports.SEARCH_HOME_DIARIES_COMPLETED = exports.SEARCH_HOME_DIARIES_REQUESTED = exports.SEARCH_HOME_DIARIES = exports.FETCH_HOME_SUB_USER_DIARIES_FAILED = exports.FETCH_HOME_SUB_USER_DIARIES_COMPLETED = exports.FETCH_HOME_SUB_USER_DIARIES_REQUESTED = exports.FETCH_HOME_SUB_USER_DIARIES = exports.FETCH_HOME_SUB_DIARIES_FAILED = exports.FETCH_HOME_SUB_DIARIES_COMPLETED = exports.FETCH_HOME_SUB_DIARIES_REQUESTED = exports.FETCH_HOME_SUB_DIARIES = undefined;
exports.fetchHomeSubDiariesRequested = fetchHomeSubDiariesRequested;
exports.fetchHomeSubDiaries = fetchHomeSubDiaries;
exports.fetchHomeSubDiariesCompleted = fetchHomeSubDiariesCompleted;
exports.fetchHomeSubDiariesFailed = fetchHomeSubDiariesFailed;
exports.fetchHomeSubUserDiariesRequested = fetchHomeSubUserDiariesRequested;
exports.fetchHomeSubUserDiaries = fetchHomeSubUserDiaries;
exports.fetchHomeSubUserDiariesCompleted = fetchHomeSubUserDiariesCompleted;
exports.fetchHomeSubUserDiariesFailed = fetchHomeSubUserDiariesFailed;
exports.searchHomeDiariesRequested = searchHomeDiariesRequested;
exports.searchHomeDiaries = searchHomeDiaries;
exports.searchHomeDiariesCompleted = searchHomeDiariesCompleted;
exports.searchHomeDiariesFailed = searchHomeDiariesFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/home-sub-diaries.js

var FETCH_HOME_SUB_DIARIES = exports.FETCH_HOME_SUB_DIARIES = "FETCH_HOME_SUB_DIARIES";
var FETCH_HOME_SUB_DIARIES_REQUESTED = exports.FETCH_HOME_SUB_DIARIES_REQUESTED = "FETCH_HOME_SUB_DIARIES_REQUESTED";
var FETCH_HOME_SUB_DIARIES_COMPLETED = exports.FETCH_HOME_SUB_DIARIES_COMPLETED = "FETCH_HOME_SUB_DIARIES_COMPLETED";
var FETCH_HOME_SUB_DIARIES_FAILED = exports.FETCH_HOME_SUB_DIARIES_FAILED = "FETCH_HOME_SUB_DIARIES_FAILED";

function fetchHomeSubDiariesRequested() {
  return {
    type: FETCH_HOME_SUB_DIARIES_REQUESTED
  };
}

// conditions:
//   diary_ids: 投稿idのリスト
function fetchHomeSubDiaries(offset) {
  var conditions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch) {
    dispatch(fetchHomeSubDiariesRequested());
    conditions = Object.assign(conditions, { offset: offset });
    return _gambaApi2.default.get('/home_diaries', conditions).then(function (results) {
      dispatch(fetchHomeSubDiariesCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchHomeSubDiariesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchHomeSubDiariesCompleted(results, offset) {
  return {
    type: FETCH_HOME_SUB_DIARIES_COMPLETED,
    results: results, offset: offset
  };
}

function fetchHomeSubDiariesFailed(error) {
  return {
    type: FETCH_HOME_SUB_DIARIES_FAILED,
    error: error
  };
}

var FETCH_HOME_SUB_USER_DIARIES = exports.FETCH_HOME_SUB_USER_DIARIES = "FETCH_HOME_SUB_USER_DIARIES";
var FETCH_HOME_SUB_USER_DIARIES_REQUESTED = exports.FETCH_HOME_SUB_USER_DIARIES_REQUESTED = "FETCH_HOME_SUB_USER_DIARIES_REQUESTED";
var FETCH_HOME_SUB_USER_DIARIES_COMPLETED = exports.FETCH_HOME_SUB_USER_DIARIES_COMPLETED = "FETCH_HOME_SUB_USER_DIARIES_COMPLETED";
var FETCH_HOME_SUB_USER_DIARIES_FAILED = exports.FETCH_HOME_SUB_USER_DIARIES_FAILED = "FETCH_HOME_SUB_USER_DIARIES_FAILED";

function fetchHomeSubUserDiariesRequested() {
  return {
    type: FETCH_HOME_SUB_USER_DIARIES_REQUESTED
  };
}

function fetchHomeSubUserDiaries(offset, user_id) {
  return function (dispatch) {
    dispatch(fetchHomeSubUserDiariesRequested());
    return _gambaApi2.default.get('/home_diaries/users/' + user_id, { offset: offset }).then(function (results) {
      dispatch(fetchHomeSubUserDiariesCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchHomeSubUserDiariesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchHomeSubUserDiariesCompleted(results, offset) {
  return {
    type: FETCH_HOME_SUB_USER_DIARIES_COMPLETED,
    results: results, offset: offset
  };
}

function fetchHomeSubUserDiariesFailed(error) {
  return {
    type: FETCH_HOME_SUB_USER_DIARIES_FAILED,
    error: error
  };
}

var SEARCH_HOME_DIARIES = exports.SEARCH_HOME_DIARIES = "SEARCH_HOME_DIARIES";
var SEARCH_HOME_DIARIES_REQUESTED = exports.SEARCH_HOME_DIARIES_REQUESTED = "SEARCH_HOME_DIARIES_REQUESTED";
var SEARCH_HOME_DIARIES_COMPLETED = exports.SEARCH_HOME_DIARIES_COMPLETED = "SEARCH_HOME_DIARIES_COMPLETED";
var SEARCH_HOME_DIARIES_FAILED = exports.SEARCH_HOME_DIARIES_FAILED = "SEARCH_HOME_DIARIES_FAILED";

function searchHomeDiariesRequested() {
  return {
    type: SEARCH_HOME_DIARIES_REQUESTED
  };
}

// conditions:
//   user_ids: ユーザidのリスト
//   category: 投稿種別(diary, memo, kpi)
//   start_date, end_date: 投稿日の期間指定
//   files_attached: 添付ファイルがあるものに限定
//   query: 検索キーワード
function searchHomeDiaries(offset) {
  var conditions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch) {
    dispatch(searchHomeDiariesRequested());
    conditions = Object.assign(conditions, { offset: offset });
    return _gambaApi2.default.get('/home_diaries/search', conditions).then(function (results) {
      dispatch(searchHomeDiariesCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(searchHomeDiariesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function searchHomeDiariesCompleted(results, offset) {
  return {
    type: SEARCH_HOME_DIARIES_COMPLETED,
    results: results, offset: offset
  };
}

function searchHomeDiariesFailed(error) {
  return {
    type: SEARCH_HOME_DIARIES_FAILED,
    error: error
  };
}

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_KPI_LIST_FAILED = exports.FETCH_KPI_LIST_COMPLETED = exports.FETCH_KPI_LIST_REQUESTED = exports.FETCH_KPI_LIST = exports.UPDATE_KPI_ACTUAL_RECORD_FAILED = exports.UPDATE_KPI_ACTUAL_RECORD_COMPLETED = exports.UPDATE_KPI_ACTUAL_RECORD_REQUESTED = exports.UPDATE_KPI_ACTUAL_RECORD = exports.CLEAR_KPI_CHART = exports.FETCH_KPI_CHART_FAILED = exports.FETCH_KPI_CHART_COMPLETED = exports.FETCH_KPI_CHART_REQUESTED = exports.FETCH_KPI_CHART = undefined;
exports.clearKpiChart = clearKpiChart;
exports.fetchKpiChartRequested = fetchKpiChartRequested;
exports.fetchKpiChart = fetchKpiChart;
exports.fetchKpiChartCompleted = fetchKpiChartCompleted;
exports.fetchKpiChartFailed = fetchKpiChartFailed;
exports.updateKpiActualRecordRequested = updateKpiActualRecordRequested;
exports.updateKpiActualRecord = updateKpiActualRecord;
exports.updateKpiActualRecordCompleted = updateKpiActualRecordCompleted;
exports.updateKpiActualRecordFailed = updateKpiActualRecordFailed;
exports.fetchKpiListRequested = fetchKpiListRequested;
exports.fetchKpiList = fetchKpiList;
exports.fetchKpiListCompleted = fetchKpiListCompleted;
exports.fetchKpiListFailed = fetchKpiListFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/kpi-chart.js

var FETCH_KPI_CHART = exports.FETCH_KPI_CHART = "FETCH_KPI_CHART";
var FETCH_KPI_CHART_REQUESTED = exports.FETCH_KPI_CHART_REQUESTED = "FETCH_KPI_CHART_REQUESTED";
var FETCH_KPI_CHART_COMPLETED = exports.FETCH_KPI_CHART_COMPLETED = "FETCH_KPI_CHART_COMPLETED";
var FETCH_KPI_CHART_FAILED = exports.FETCH_KPI_CHART_FAILED = "FETCH_KPI_CHART_FAILED";
var CLEAR_KPI_CHART = exports.CLEAR_KPI_CHART = "CLEAR_KPI_CHART";

function clearKpiChart() {
  return {
    type: CLEAR_KPI_CHART
  };
}

function fetchKpiChartRequested() {
  return {
    type: FETCH_KPI_CHART_REQUESTED
  };
}

function fetchKpiChart(kpi_id, group_id) {
  return function (dispatch) {
    dispatch(fetchKpiChartRequested());
    return _gambaApi2.default.get('/kpi_status/' + kpi_id, { group_id: group_id }).then(function (results) {
      dispatch(fetchKpiChartCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchKpiChartFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchKpiChartCompleted(results) {
  return {
    type: FETCH_KPI_CHART_COMPLETED,
    results: results
  };
}

function fetchKpiChartFailed(error) {
  return {
    type: FETCH_KPI_CHART_FAILED,
    error: error
  };
}

var UPDATE_KPI_ACTUAL_RECORD = exports.UPDATE_KPI_ACTUAL_RECORD = "UPDATE_KPI_ACTUAL_RECORD";
var UPDATE_KPI_ACTUAL_RECORD_REQUESTED = exports.UPDATE_KPI_ACTUAL_RECORD_REQUESTED = "UPDATE_KPI_ACTUAL_RECORD_REQUESTED";
var UPDATE_KPI_ACTUAL_RECORD_COMPLETED = exports.UPDATE_KPI_ACTUAL_RECORD_COMPLETED = "UPDATE_KPI_ACTUAL_RECORD_COMPLETED";
var UPDATE_KPI_ACTUAL_RECORD_FAILED = exports.UPDATE_KPI_ACTUAL_RECORD_FAILED = "UPDATE_KPI_ACTUAL_RECORD_FAILED";

function updateKpiActualRecordRequested() {
  return {
    type: UPDATE_KPI_ACTUAL_RECORD_REQUESTED
  };
}

function updateKpiActualRecord(kpi_id, reported_at, actual, group_id, user_id) {
  return function (dispatch) {
    dispatch(updateKpiActualRecordRequested());
    return _gambaApi2.default.put('/kpi_status/' + kpi_id, { reported_at: reported_at, actual: actual, group_id: group_id, user_id: user_id }).then(function (results) {
      dispatch(updateKpiActualRecordCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateKpiActualRecordFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateKpiActualRecordCompleted(results) {
  return {
    type: UPDATE_KPI_ACTUAL_RECORD_COMPLETED,
    results: results
  };
}

function updateKpiActualRecordFailed(error) {
  return {
    type: UPDATE_KPI_ACTUAL_RECORD_FAILED,
    error: error
  };
}

var FETCH_KPI_LIST = exports.FETCH_KPI_LIST = "FETCH_KPI_LIST";
var FETCH_KPI_LIST_REQUESTED = exports.FETCH_KPI_LIST_REQUESTED = "FETCH_KPI_LIST_REQUESTED";
var FETCH_KPI_LIST_COMPLETED = exports.FETCH_KPI_LIST_COMPLETED = "FETCH_KPI_LIST_COMPLETED";
var FETCH_KPI_LIST_FAILED = exports.FETCH_KPI_LIST_FAILED = "FETCH_KPI_LIST_FAILED";

function fetchKpiListRequested() {
  return {
    type: FETCH_KPI_LIST_REQUESTED
  };
}

function fetchKpiList(group_id) {
  var reported_at = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  return function (dispatch) {
    dispatch(fetchKpiListRequested());
    return _gambaApi2.default.get('/kpi_status', { group_id: group_id, reported_at: reported_at }).then(function (results) {
      dispatch(fetchKpiListCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchKpiListFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchKpiListCompleted(results) {
  return {
    type: FETCH_KPI_LIST_COMPLETED,
    results: results
  };
}

function fetchKpiListFailed(error) {
  return {
    type: FETCH_KPI_LIST_FAILED,
    error: error
  };
}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNPIN_DIARY_FAILED = exports.UNPIN_DIARY_COMPLETED = exports.UNPIN_DIARY_REQUESTED = exports.UNPIN_DIARY = exports.PIN_DIARY_FAILED = exports.PIN_DIARY_COMPLETED = exports.PIN_DIARY_REQUESTED = exports.PIN_DIARY = undefined;
exports.pinDiaryRequested = pinDiaryRequested;
exports.pinDiary = pinDiary;
exports.pinDiaryCompleted = pinDiaryCompleted;
exports.pinDiaryFailed = pinDiaryFailed;
exports.unpinDiaryRequested = unpinDiaryRequested;
exports.unpinDiary = unpinDiary;
exports.unpinDiaryCompleted = unpinDiaryCompleted;
exports.unpinDiaryFailed = unpinDiaryFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PIN_DIARY = exports.PIN_DIARY = "PIN_DIARY";
// src/actions/pins.js

var PIN_DIARY_REQUESTED = exports.PIN_DIARY_REQUESTED = "PIN_DIARY_REQUESTED";
var PIN_DIARY_COMPLETED = exports.PIN_DIARY_COMPLETED = "PIN_DIARY_COMPLETED";
var PIN_DIARY_FAILED = exports.PIN_DIARY_FAILED = "PIN_DIARY_FAILED";

function pinDiaryRequested() {
  return {
    type: PIN_DIARY_REQUESTED
  };
}

function pinDiary(diary_id) {
  return function (dispatch) {
    dispatch(pinDiaryRequested());
    return _gambaApi2.default.post('/pins', { diary_id: diary_id }).then(function (results) {
      dispatch(pinDiaryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(pinDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function pinDiaryCompleted(results) {
  return {
    type: PIN_DIARY_COMPLETED,
    results: results
  };
}

function pinDiaryFailed(error) {
  return {
    type: PIN_DIARY_FAILED,
    error: error
  };
}

var UNPIN_DIARY = exports.UNPIN_DIARY = "UNPIN_DIARY";
var UNPIN_DIARY_REQUESTED = exports.UNPIN_DIARY_REQUESTED = "UNPIN_DIARY_REQUESTED";
var UNPIN_DIARY_COMPLETED = exports.UNPIN_DIARY_COMPLETED = "UNPIN_DIARY_COMPLETED";
var UNPIN_DIARY_FAILED = exports.UNPIN_DIARY_FAILED = "UNPIN_DIARY_FAILED";

function unpinDiaryRequested() {
  return {
    type: UNPIN_DIARY_REQUESTED
  };
}

function unpinDiary(diary_id, group_id) {
  return function (dispatch) {
    dispatch(unpinDiaryRequested());
    return _gambaApi2.default.delete('/pins/' + diary_id).then(function (results) {
      dispatch(unpinDiaryCompleted(results));
      dispatch(_actions2.default.fetchDiaries(group_id, 0));
    }).catch(function (error) {
      Promise.all([dispatch(unpinDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function unpinDiaryCompleted(results) {
  return {
    type: UNPIN_DIARY_COMPLETED,
    results: results
  };
}

function unpinDiaryFailed(error) {
  return {
    type: UNPIN_DIARY_FAILED,
    error: error
  };
}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_NOTIFICATIONS = exports.UPDATE_NOTIFICATION_STATUS_FAILED = exports.UPDATE_NOTIFICATION_STATUS_COMPLETED = exports.UPDATE_NOTIFICATION_STATUS_REQUESTED = exports.UPDATE_NOTIFICATION_STATUS = exports.FLUSH_UNREAD_NOTIFICATIONS_FAILED = exports.FLUSH_UNREAD_NOTIFICATIONS_COMPLETED = exports.FLUSH_UNREAD_NOTIFICATIONS_REQUESTED = exports.FLUSH_UNREAD_NOTIFICATIONS = exports.LOAD_NOTIFICATION_UNREAD_COUNT = exports.FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED = exports.FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED = exports.FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED = exports.FETCH_NOTIFICATIONS_UNREAD_COUNT = exports.FETCH_NOTIFICATIONS_FAILED = exports.FETCH_NOTIFICATIONS_COMPLETED = exports.FETCH_NOTIFICATIONS_REQUESTED = exports.FETCH_NOTIFICATIONS = undefined;
exports.fetchNotificationsRequested = fetchNotificationsRequested;
exports.fetchNotifications = fetchNotifications;
exports.fetchNotificationsCompleted = fetchNotificationsCompleted;
exports.fetchNotificationsFailed = fetchNotificationsFailed;
exports.fetchNotificationsUnreadCountRequested = fetchNotificationsUnreadCountRequested;
exports.fetchNotificationsUnreadCount = fetchNotificationsUnreadCount;
exports.fetchNotificationsUnreadCountCompleted = fetchNotificationsUnreadCountCompleted;
exports.fetchNotificationsUnreadCountFailed = fetchNotificationsUnreadCountFailed;
exports.loadNotificationUnreadCount = loadNotificationUnreadCount;
exports.flushUnreadNotificationsRequested = flushUnreadNotificationsRequested;
exports.flushUnreadNotifications = flushUnreadNotifications;
exports.flushUnreadNotificationsCompleted = flushUnreadNotificationsCompleted;
exports.flushUnreadNotificationsFailed = flushUnreadNotificationsFailed;
exports.updateNotificationStatusRequested = updateNotificationStatusRequested;
exports.updateNotificationStatus = updateNotificationStatus;
exports.updateNotificationStatusCompleted = updateNotificationStatusCompleted;
exports.updateNotificationStatusFailed = updateNotificationStatusFailed;
exports.clearNotifications = clearNotifications;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/notifications.js

var FETCH_NOTIFICATIONS = exports.FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
var FETCH_NOTIFICATIONS_REQUESTED = exports.FETCH_NOTIFICATIONS_REQUESTED = "FETCH_NOTIFICATIONS_REQUESTED";
var FETCH_NOTIFICATIONS_COMPLETED = exports.FETCH_NOTIFICATIONS_COMPLETED = "FETCH_NOTIFICATIONS_COMPLETED";
var FETCH_NOTIFICATIONS_FAILED = exports.FETCH_NOTIFICATIONS_FAILED = "FETCH_NOTIFICATIONS_FAILED";

function fetchNotificationsRequested(group_id) {
  return {
    type: FETCH_NOTIFICATIONS_REQUESTED,
    group_id: group_id
  };
}

function fetchNotifications(group_id, offset) {
  return function (dispatch) {
    dispatch(fetchNotificationsRequested(group_id));
    return _gambaApi2.default.get('/notifications', { group_id: group_id, offset: offset }).then(function (results) {
      dispatch(fetchNotificationsCompleted(group_id, results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchNotificationsFailed(group_id, error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchNotificationsCompleted(group_id, results, offset) {
  return {
    type: FETCH_NOTIFICATIONS_COMPLETED,
    results: results, offset: offset, group_id: group_id
  };
}

function fetchNotificationsFailed(group_id, error) {
  return {
    type: FETCH_NOTIFICATIONS_FAILED,
    error: error, group_id: group_id
  };
}

var FETCH_NOTIFICATIONS_UNREAD_COUNT = exports.FETCH_NOTIFICATIONS_UNREAD_COUNT = "FETCH_NOTIFICATIONS_UNREAD_COUNT";
var FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED = exports.FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED = "FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED";
var FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED = exports.FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED = "FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED";
var FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED = exports.FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED = "FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED";

function fetchNotificationsUnreadCountRequested() {
  return {
    type: FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED
  };
}

function fetchNotificationsUnreadCount(group_id) {
  return function (dispatch) {
    dispatch(fetchNotificationsUnreadCountRequested());
    return _gambaApi2.default.get('/notifications/count', { group_id: group_id }).then(function (results) {
      dispatch(fetchNotificationsUnreadCountCompleted(results, group_id));
    }).catch(function (error) {
      Promise.all([dispatch(fetchNotificationsUnreadCountFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchNotificationsUnreadCountCompleted(results, group_id) {
  return {
    type: FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED,
    results: results, group_id: group_id
  };
}

function fetchNotificationsUnreadCountFailed(error) {
  return {
    type: FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED,
    error: error
  };
}

var LOAD_NOTIFICATION_UNREAD_COUNT = exports.LOAD_NOTIFICATION_UNREAD_COUNT = "LOAD_NOTIFICATION_UNREAD_COUNT";

function loadNotificationUnreadCount(group_id, count) {
  return {
    type: LOAD_NOTIFICATION_UNREAD_COUNT, count: count, group_id: group_id
  };
}

var FLUSH_UNREAD_NOTIFICATIONS = exports.FLUSH_UNREAD_NOTIFICATIONS = "FLUSH_UNREAD_NOTIFICATIONS";
var FLUSH_UNREAD_NOTIFICATIONS_REQUESTED = exports.FLUSH_UNREAD_NOTIFICATIONS_REQUESTED = "FLUSH_UNREAD_NOTIFICATIONS_REQUESTED";
var FLUSH_UNREAD_NOTIFICATIONS_COMPLETED = exports.FLUSH_UNREAD_NOTIFICATIONS_COMPLETED = "FLUSH_UNREAD_NOTIFICATIONS_COMPLETED";
var FLUSH_UNREAD_NOTIFICATIONS_FAILED = exports.FLUSH_UNREAD_NOTIFICATIONS_FAILED = "FLUSH_UNREAD_NOTIFICATIONS_FAILED";

function flushUnreadNotificationsRequested() {
  return {
    type: FLUSH_UNREAD_NOTIFICATIONS_REQUESTED
  };
}

function flushUnreadNotifications(group_id) {
  return function (dispatch) {
    dispatch(flushUnreadNotificationsRequested());
    return _gambaApi2.default.get('/notifications/flush', { group_id: group_id }).then(function (results) {
      dispatch(flushUnreadNotificationsCompleted(results, group_id));
    }).catch(function (error) {
      Promise.all([dispatch(flushUnreadNotificationsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function flushUnreadNotificationsCompleted(results, group_id) {
  return {
    type: FLUSH_UNREAD_NOTIFICATIONS_COMPLETED,
    results: results, group_id: group_id
  };
}

function flushUnreadNotificationsFailed(error) {
  return {
    type: FLUSH_UNREAD_NOTIFICATIONS_FAILED,
    error: error
  };
}

var UPDATE_NOTIFICATION_STATUS = exports.UPDATE_NOTIFICATION_STATUS = "UPDATE_NOTIFICATION_STATUS";
var UPDATE_NOTIFICATION_STATUS_REQUESTED = exports.UPDATE_NOTIFICATION_STATUS_REQUESTED = "UPDATE_NOTIFICATION_STATUS_REQUESTED";
var UPDATE_NOTIFICATION_STATUS_COMPLETED = exports.UPDATE_NOTIFICATION_STATUS_COMPLETED = "UPDATE_NOTIFICATION_STATUS_COMPLETED";
var UPDATE_NOTIFICATION_STATUS_FAILED = exports.UPDATE_NOTIFICATION_STATUS_FAILED = "UPDATE_NOTIFICATION_STATUS_FAILED";

function updateNotificationStatusRequested() {
  return {
    type: UPDATE_NOTIFICATION_STATUS_REQUESTED
  };
}

function updateNotificationStatus(notification_id) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch) {
    dispatch(updateNotificationStatusRequested());
    return _gambaApi2.default.put('/notifications/' + notification_id + '/status', opt).then(function (results) {
      dispatch(updateNotificationStatusCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateNotificationStatusFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateNotificationStatusCompleted(results) {
  return {
    type: UPDATE_NOTIFICATION_STATUS_COMPLETED,
    results: results
  };
}

function updateNotificationStatusFailed(error) {
  return {
    type: UPDATE_NOTIFICATION_STATUS_FAILED,
    error: error
  };
}

var CLEAR_NOTIFICATIONS = exports.CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";

function clearNotifications() {
  return {
    type: CLEAR_NOTIFICATIONS
  };
}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_ORGANIZATION_GROUPS_FAILED = exports.FETCH_ORGANIZATION_GROUPS_COMPLETED = exports.FETCH_ORGANIZATION_GROUPS_REQUESTED = exports.FETCH_ORGANIZATION_GROUPS = exports.UPDATE_ORGANIZATION_MEMBERSHIP_FAILED = exports.UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED = exports.UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED = exports.UPDATE_ORGANIZATION_MEMBERSHIP = exports.FETCH_ORGANIZATION_MEMBERS_FAILED = exports.FETCH_ORGANIZATION_MEMBERS_COMPLETED = exports.FETCH_ORGANIZATION_MEMBERS_REQUESTED = exports.FETCH_ORGANIZATION_MEMBERS = exports.FETCH_ORGANIZATION_FAILED = exports.FETCH_ORGANIZATION_COMPLETED = exports.FETCH_ORGANIZATION_REQUESTED = exports.FETCH_ORGANIZATION = exports.FETCH_ORGANIZATIONS_FAILED = exports.FETCH_ORGANIZATIONS_COMPLETED = exports.FETCH_ORGANIZATIONS_REQUESTED = exports.FETCH_ORGANIZATIONS = undefined;
exports.fetchOrganizationsRequested = fetchOrganizationsRequested;
exports.fetchOrganizations = fetchOrganizations;
exports.fetchOrganizationsCompleted = fetchOrganizationsCompleted;
exports.fetchOrganizationsFailed = fetchOrganizationsFailed;
exports.fetchOrganizationRequested = fetchOrganizationRequested;
exports.fetchOrganization = fetchOrganization;
exports.fetchOrganizationCompleted = fetchOrganizationCompleted;
exports.fetchOrganizationFailed = fetchOrganizationFailed;
exports.fetchOrganizationMembersRequested = fetchOrganizationMembersRequested;
exports.fetchOrganizationMembers = fetchOrganizationMembers;
exports.fetchOrganizationMembersCompleted = fetchOrganizationMembersCompleted;
exports.fetchOrganizationMembersFailed = fetchOrganizationMembersFailed;
exports.updateOrganizationMembershipRequested = updateOrganizationMembershipRequested;
exports.updateOrganizationMembership = updateOrganizationMembership;
exports.updateOrganizationMembershipCompleted = updateOrganizationMembershipCompleted;
exports.updateOrganizationMembershipFailed = updateOrganizationMembershipFailed;
exports.fetchOrganizationGroupsRequested = fetchOrganizationGroupsRequested;
exports.fetchOrganizationGroups = fetchOrganizationGroups;
exports.fetchOrganizationGroupsCompleted = fetchOrganizationGroupsCompleted;
exports.fetchOrganizationGroupsFailed = fetchOrganizationGroupsFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/organizations.js

var FETCH_ORGANIZATIONS = exports.FETCH_ORGANIZATIONS = "FETCH_ORGANIZATIONS";
var FETCH_ORGANIZATIONS_REQUESTED = exports.FETCH_ORGANIZATIONS_REQUESTED = "FETCH_ORGANIZATIONS_REQUESTED";
var FETCH_ORGANIZATIONS_COMPLETED = exports.FETCH_ORGANIZATIONS_COMPLETED = "FETCH_ORGANIZATIONS_COMPLETED";
var FETCH_ORGANIZATIONS_FAILED = exports.FETCH_ORGANIZATIONS_FAILED = "FETCH_ORGANIZATIONS_FAILED";

function fetchOrganizationsRequested() {
  return {
    type: FETCH_ORGANIZATIONS_REQUESTED
  };
}

function fetchOrganizations() {
  return function (dispatch) {
    dispatch(fetchOrganizationsRequested());
    return _gambaApi2.default.get('/organizations').then(function (results) {
      dispatch(fetchOrganizationsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchOrganizationsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchOrganizationsCompleted(results) {
  return {
    type: FETCH_ORGANIZATIONS_COMPLETED,
    results: results
  };
}

function fetchOrganizationsFailed(error) {
  return {
    type: FETCH_ORGANIZATIONS_FAILED,
    error: error
  };
}

var FETCH_ORGANIZATION = exports.FETCH_ORGANIZATION = "FETCH_ORGANIZATION";
var FETCH_ORGANIZATION_REQUESTED = exports.FETCH_ORGANIZATION_REQUESTED = "FETCH_ORGANIZATION_REQUESTED";
var FETCH_ORGANIZATION_COMPLETED = exports.FETCH_ORGANIZATION_COMPLETED = "FETCH_ORGANIZATION_COMPLETED";
var FETCH_ORGANIZATION_FAILED = exports.FETCH_ORGANIZATION_FAILED = "FETCH_ORGANIZATION_FAILED";

function fetchOrganizationRequested() {
  return {
    type: FETCH_ORGANIZATION_REQUESTED
  };
}

function fetchOrganization(organization_id) {
  return function (dispatch) {
    dispatch(fetchOrganizationRequested());
    return _gambaApi2.default.get('/organizations/' + organization_id).then(function (results) {
      dispatch(fetchOrganizationCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchOrganizationFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchOrganizationCompleted(results) {
  return {
    type: FETCH_ORGANIZATION_COMPLETED,
    results: results
  };
}

function fetchOrganizationFailed(error) {
  return {
    type: FETCH_ORGANIZATION_FAILED,
    error: error
  };
}

var FETCH_ORGANIZATION_MEMBERS = exports.FETCH_ORGANIZATION_MEMBERS = "FETCH_ORGANIZATION_MEMBERS";
var FETCH_ORGANIZATION_MEMBERS_REQUESTED = exports.FETCH_ORGANIZATION_MEMBERS_REQUESTED = "FETCH_ORGANIZATION_MEMBERS_REQUESTED";
var FETCH_ORGANIZATION_MEMBERS_COMPLETED = exports.FETCH_ORGANIZATION_MEMBERS_COMPLETED = "FETCH_ORGANIZATION_MEMBERS_COMPLETED";
var FETCH_ORGANIZATION_MEMBERS_FAILED = exports.FETCH_ORGANIZATION_MEMBERS_FAILED = "FETCH_ORGANIZATION_MEMBERS_FAILED";

function fetchOrganizationMembersRequested() {
  return {
    type: FETCH_ORGANIZATION_MEMBERS_REQUESTED
  };
}

function fetchOrganizationMembers(organization_id) {
  return function (dispatch) {
    dispatch(fetchOrganizationMembersRequested());
    return _gambaApi2.default.get('/organizations/' + organization_id + '/members').then(function (results) {
      dispatch(fetchOrganizationMembersCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchOrganizationMembersFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchOrganizationMembersCompleted(results) {
  return {
    type: FETCH_ORGANIZATION_MEMBERS_COMPLETED,
    results: results
  };
}

function fetchOrganizationMembersFailed(error) {
  return {
    type: FETCH_ORGANIZATION_MEMBERS_FAILED,
    error: error
  };
}

var UPDATE_ORGANIZATION_MEMBERSHIP = exports.UPDATE_ORGANIZATION_MEMBERSHIP = "UPDATE_ORGANIZATION_MEMBERSHIP";
var UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED = exports.UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED = "UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED";
var UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED = exports.UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED = "UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED";
var UPDATE_ORGANIZATION_MEMBERSHIP_FAILED = exports.UPDATE_ORGANIZATION_MEMBERSHIP_FAILED = "UPDATE_ORGANIZATION_MEMBERSHIP_FAILED";

function updateOrganizationMembershipRequested() {
  return {
    type: UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED
  };
}

function updateOrganizationMembership(organization_id, user_id, role) {
  return function (dispatch) {
    dispatch(updateOrganizationMembershipRequested());
    return _gambaApi2.default.put('/organizations/' + organization_id + '/members/' + user_id, { role: role }).then(function (results) {
      dispatch(updateOrganizationMembershipCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateOrganizationMembershipFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateOrganizationMembershipCompleted(results) {
  return {
    type: UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED,
    results: results
  };
}

function updateOrganizationMembershipFailed(error) {
  return {
    type: UPDATE_ORGANIZATION_MEMBERSHIP_FAILED,
    error: error
  };
}

var FETCH_ORGANIZATION_GROUPS = exports.FETCH_ORGANIZATION_GROUPS = "FETCH_ORGANIZATION_GROUPS";
var FETCH_ORGANIZATION_GROUPS_REQUESTED = exports.FETCH_ORGANIZATION_GROUPS_REQUESTED = "FETCH_ORGANIZATION_GROUPS_REQUESTED";
var FETCH_ORGANIZATION_GROUPS_COMPLETED = exports.FETCH_ORGANIZATION_GROUPS_COMPLETED = "FETCH_ORGANIZATION_GROUPS_COMPLETED";
var FETCH_ORGANIZATION_GROUPS_FAILED = exports.FETCH_ORGANIZATION_GROUPS_FAILED = "FETCH_ORGANIZATION_GROUPS_FAILED";

function fetchOrganizationGroupsRequested() {
  return {
    type: FETCH_ORGANIZATION_GROUPS_REQUESTED
  };
}

function fetchOrganizationGroups(organization_id) {
  return function (dispatch) {
    dispatch(fetchOrganizationGroupsRequested());
    return _gambaApi2.default.get('/organizations/' + organization_id + '/groups').then(function (results) {
      dispatch(fetchOrganizationGroupsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchOrganizationGroupsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchOrganizationGroupsCompleted(results) {
  return {
    type: FETCH_ORGANIZATION_GROUPS_COMPLETED,
    results: results
  };
}

function fetchOrganizationGroupsFailed(error) {
  return {
    type: FETCH_ORGANIZATION_GROUPS_FAILED,
    error: error
  };
}

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_PRESERVED_QUERIES = exports.DELETE_PRESERVED_QUERY_FAILED = exports.DELETE_PRESERVED_QUERY_COMPLETED = exports.DELETE_PRESERVED_QUERY_REQUESTED = exports.DELETE_PRESERVED_QUERY = exports.CREATE_PRESERVED_QUERY_FAILED = exports.CREATE_PRESERVED_QUERY_COMPLETED = exports.CREATE_PRESERVED_QUERY_REQUESTED = exports.CREATE_PRESERVED_QUERY = exports.FETCH_PRESERVED_QUERIES_FAILED = exports.FETCH_PRESERVED_QUERIES_COMPLETED = exports.FETCH_PRESERVED_QUERIES_REQUESTED = exports.FETCH_PRESERVED_QUERIES = undefined;
exports.fetchPreservedQueriesRequested = fetchPreservedQueriesRequested;
exports.fetchPreservedQueries = fetchPreservedQueries;
exports.fetchPreservedQueriesCompleted = fetchPreservedQueriesCompleted;
exports.fetchPreservedQueriesFailed = fetchPreservedQueriesFailed;
exports.createPreservedQueryRequested = createPreservedQueryRequested;
exports.createPreservedQuery = createPreservedQuery;
exports.createPreservedQueryCompleted = createPreservedQueryCompleted;
exports.createPreservedQueryFailed = createPreservedQueryFailed;
exports.deletePreservedQueryRequested = deletePreservedQueryRequested;
exports.deletePreservedQuery = deletePreservedQuery;
exports.deletePreservedQueryCompleted = deletePreservedQueryCompleted;
exports.deletePreservedQueryFailed = deletePreservedQueryFailed;
exports.clearPreservedQueries = clearPreservedQueries;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/preserved-queries.js

var FETCH_PRESERVED_QUERIES = exports.FETCH_PRESERVED_QUERIES = "FETCH_PRESERVED_QUERIES";
var FETCH_PRESERVED_QUERIES_REQUESTED = exports.FETCH_PRESERVED_QUERIES_REQUESTED = "FETCH_PRESERVED_QUERIES_REQUESTED";
var FETCH_PRESERVED_QUERIES_COMPLETED = exports.FETCH_PRESERVED_QUERIES_COMPLETED = "FETCH_PRESERVED_QUERIES_COMPLETED";
var FETCH_PRESERVED_QUERIES_FAILED = exports.FETCH_PRESERVED_QUERIES_FAILED = "FETCH_PRESERVED_QUERIES_FAILED";

function fetchPreservedQueriesRequested() {
  return {
    type: FETCH_PRESERVED_QUERIES_REQUESTED
  };
}

function fetchPreservedQueries() {
  var group_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  return function (dispatch) {
    dispatch(fetchPreservedQueriesRequested());
    return _gambaApi2.default.get('/preserved_queries', group_id && { group_id: group_id } || {}).then(function (results) {
      dispatch(fetchPreservedQueriesCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchPreservedQueriesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchPreservedQueriesCompleted(results) {
  return {
    type: FETCH_PRESERVED_QUERIES_COMPLETED,
    results: results
  };
}

function fetchPreservedQueriesFailed(error) {
  return {
    type: FETCH_PRESERVED_QUERIES_FAILED,
    error: error
  };
}

var CREATE_PRESERVED_QUERY = exports.CREATE_PRESERVED_QUERY = "CREATE_PRESERVED_QUERY";
var CREATE_PRESERVED_QUERY_REQUESTED = exports.CREATE_PRESERVED_QUERY_REQUESTED = "CREATE_PRESERVED_QUERY_REQUESTED";
var CREATE_PRESERVED_QUERY_COMPLETED = exports.CREATE_PRESERVED_QUERY_COMPLETED = "CREATE_PRESERVED_QUERY_COMPLETED";
var CREATE_PRESERVED_QUERY_FAILED = exports.CREATE_PRESERVED_QUERY_FAILED = "CREATE_PRESERVED_QUERY_FAILED";

function createPreservedQueryRequested() {
  return {
    type: CREATE_PRESERVED_QUERY_REQUESTED
  };
}

function createPreservedQuery(name, query_text) {
  var group_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return function (dispatch) {
    dispatch(createPreservedQueryRequested());
    return _gambaApi2.default.post('/preserved_queries', { name: name, query_text: query_text, group_id: group_id }).then(function (results) {
      dispatch(createPreservedQueryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(createPreservedQueryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function createPreservedQueryCompleted(results) {
  return {
    type: CREATE_PRESERVED_QUERY_COMPLETED,
    results: results
  };
}

function createPreservedQueryFailed(error) {
  return {
    type: CREATE_PRESERVED_QUERY_FAILED,
    error: error
  };
}

var DELETE_PRESERVED_QUERY = exports.DELETE_PRESERVED_QUERY = "DELETE_PRESERVED_QUERY";
var DELETE_PRESERVED_QUERY_REQUESTED = exports.DELETE_PRESERVED_QUERY_REQUESTED = "DELETE_PRESERVED_QUERY_REQUESTED";
var DELETE_PRESERVED_QUERY_COMPLETED = exports.DELETE_PRESERVED_QUERY_COMPLETED = "DELETE_PRESERVED_QUERY_COMPLETED";
var DELETE_PRESERVED_QUERY_FAILED = exports.DELETE_PRESERVED_QUERY_FAILED = "DELETE_PRESERVED_QUERY_FAILED";

function deletePreservedQueryRequested() {
  return {
    type: DELETE_PRESERVED_QUERY_REQUESTED
  };
}

function deletePreservedQuery(query_id) {
  return function (dispatch) {
    dispatch(deletePreservedQueryRequested());
    return _gambaApi2.default.delete('/preserved_queries/' + query_id).then(function (results) {
      dispatch(deletePreservedQueryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deletePreservedQueryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deletePreservedQueryCompleted(results) {
  return {
    type: DELETE_PRESERVED_QUERY_COMPLETED,
    results: results
  };
}

function deletePreservedQueryFailed(error) {
  return {
    type: DELETE_PRESERVED_QUERY_FAILED,
    error: error
  };
}

var CLEAR_PRESERVED_QUERIES = exports.CLEAR_PRESERVED_QUERIES = "CLEAR_PRESERVED_QUERIES";

function clearPreservedQueries() {
  return {
    type: CLEAR_PRESERVED_QUERIES
  };
}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_SAVED_DIARIES = exports.DELETE_ALL_SAVED_DIARY_FAILED = exports.DELETE_ALL_SAVED_DIARY_COMPLETED = exports.DELETE_ALL_SAVED_DIARY_REQUESTED = exports.DELETE_ALL_SAVED_DIARY = exports.DELETE_SAVED_DIARY_FAILED = exports.DELETE_SAVED_DIARY_COMPLETED = exports.DELETE_SAVED_DIARY_REQUESTED = exports.DELETE_SAVED_DIARY = exports.FETCH_SAVED_DIARIES_FAILED = exports.FETCH_SAVED_DIARIES_COMPLETED = exports.FETCH_SAVED_DIARIES_REQUESTED = exports.FETCH_SAVED_DIARIES = exports.CLEAR_SAVED_DIARY = exports.SAVE_DIARY_FAILED = exports.SAVE_DIARY_COMPLETED = exports.SAVE_DIARY_REQUESTED = exports.SAVE_DIARY = undefined;
exports.saveDiaryRequested = saveDiaryRequested;
exports.saveDiary = saveDiary;
exports.saveDiaryCompleted = saveDiaryCompleted;
exports.saveDiaryFailed = saveDiaryFailed;
exports.clearSavedDiary = clearSavedDiary;
exports.fetchSavedDiariesRequested = fetchSavedDiariesRequested;
exports.fetchSavedDiaries = fetchSavedDiaries;
exports.fetchSavedDiariesCompleted = fetchSavedDiariesCompleted;
exports.fetchSavedDiariesFailed = fetchSavedDiariesFailed;
exports.deleteSavedDiaryRequested = deleteSavedDiaryRequested;
exports.deleteSavedDiary = deleteSavedDiary;
exports.deleteSavedDiaryCompleted = deleteSavedDiaryCompleted;
exports.deleteSavedDiaryFailed = deleteSavedDiaryFailed;
exports.deleteAllSavedDiaryRequested = deleteAllSavedDiaryRequested;
exports.deleteAllSavedDiary = deleteAllSavedDiary;
exports.deleteAllSavedDiaryCompleted = deleteAllSavedDiaryCompleted;
exports.deleteAllSavedDiaryFailed = deleteAllSavedDiaryFailed;
exports.clearSavedDiaries = clearSavedDiaries;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SAVE_DIARY = exports.SAVE_DIARY = "SAVE_DIARY";
// src/actions/saved-diaries.js

var SAVE_DIARY_REQUESTED = exports.SAVE_DIARY_REQUESTED = "SAVE_DIARY_REQUESTED";
var SAVE_DIARY_COMPLETED = exports.SAVE_DIARY_COMPLETED = "SAVE_DIARY_COMPLETED";
var SAVE_DIARY_FAILED = exports.SAVE_DIARY_FAILED = "SAVE_DIARY_FAILED";

function saveDiaryRequested() {
  return {
    type: SAVE_DIARY_REQUESTED
  };
}

function saveDiary(group_id, diary_id, category, reported_at, subject, content, upload_files, upload_videos, attach_json, mentions) {
  return function (dispatch) {
    dispatch(saveDiaryRequested());
    return (diary_id && _gambaApi2.default.put('/diaries/' + diary_id, {
      saved: true, category: category, reported_at: (0, _moment2.default)(reported_at).format('YYYY-MM-DD'), subject: subject, content: content, upload_files: upload_files, upload_videos: upload_videos, attach_json: attach_json, mentions: mentions
    }) || _gambaApi2.default.post('/diaries', {
      group_id: group_id, category: category, saved: true, reported_at: (0, _moment2.default)(reported_at).format('YYYY-MM-DD'), subject: subject, content: content, upload_files: upload_files, upload_videos: upload_videos, attach_json: attach_json, mentions: mentions
    })).then(function (results) {
      dispatch(saveDiaryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(saveDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function saveDiaryCompleted(results) {
  return {
    type: SAVE_DIARY_COMPLETED,
    results: results
  };
}

function saveDiaryFailed(error) {
  return {
    type: SAVE_DIARY_FAILED,
    error: error
  };
}

var CLEAR_SAVED_DIARY = exports.CLEAR_SAVED_DIARY = "CLEAR_SAVED_DIARY";

function clearSavedDiary() {
  return {
    type: CLEAR_SAVED_DIARY
  };
}

var FETCH_SAVED_DIARIES = exports.FETCH_SAVED_DIARIES = "FETCH_SAVED_DIARIES";
var FETCH_SAVED_DIARIES_REQUESTED = exports.FETCH_SAVED_DIARIES_REQUESTED = "FETCH_SAVED_DIARIES_REQUESTED";
var FETCH_SAVED_DIARIES_COMPLETED = exports.FETCH_SAVED_DIARIES_COMPLETED = "FETCH_SAVED_DIARIES_COMPLETED";
var FETCH_SAVED_DIARIES_FAILED = exports.FETCH_SAVED_DIARIES_FAILED = "FETCH_SAVED_DIARIES_FAILED";

function fetchSavedDiariesRequested() {
  return {
    type: FETCH_SAVED_DIARIES_REQUESTED
  };
}

function fetchSavedDiaries(group_id, user_id) {
  return function (dispatch) {
    dispatch(fetchSavedDiariesRequested());
    return _gambaApi2.default.get('/diaries', { group_id: group_id, user_id: user_id, saved: true, length: 20 }).then(function (results) {
      dispatch(fetchSavedDiariesCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchSavedDiariesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchSavedDiariesCompleted(results) {
  return {
    type: FETCH_SAVED_DIARIES_COMPLETED,
    results: results
  };
}

function fetchSavedDiariesFailed(error) {
  return {
    type: FETCH_SAVED_DIARIES_FAILED,
    error: error
  };
}

var DELETE_SAVED_DIARY = exports.DELETE_SAVED_DIARY = "DELETE_SAVED_DIARY";
var DELETE_SAVED_DIARY_REQUESTED = exports.DELETE_SAVED_DIARY_REQUESTED = "DELETE_SAVED_DIARY_REQUESTED";
var DELETE_SAVED_DIARY_COMPLETED = exports.DELETE_SAVED_DIARY_COMPLETED = "DELETE_SAVED_DIARY_COMPLETED";
var DELETE_SAVED_DIARY_FAILED = exports.DELETE_SAVED_DIARY_FAILED = "DELETE_SAVED_DIARY_FAILED";

function deleteSavedDiaryRequested() {
  return {
    type: DELETE_SAVED_DIARY_REQUESTED
  };
}

function deleteSavedDiary(diary_id) {
  return function (dispatch) {
    dispatch(deleteSavedDiaryRequested());
    return _gambaApi2.default.delete('/diaries/' + diary_id, { saved: true }).then(function (results) {
      dispatch(deleteSavedDiaryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deleteSavedDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteSavedDiaryCompleted(results) {
  return {
    type: DELETE_SAVED_DIARY_COMPLETED,
    results: results
  };
}

function deleteSavedDiaryFailed(error) {
  return {
    type: DELETE_SAVED_DIARY_FAILED,
    error: error
  };
}

var DELETE_ALL_SAVED_DIARY = exports.DELETE_ALL_SAVED_DIARY = "DELETE_ALL_SAVED_DIARY";
var DELETE_ALL_SAVED_DIARY_REQUESTED = exports.DELETE_ALL_SAVED_DIARY_REQUESTED = "DELETE_ALL_SAVED_DIARY_REQUESTED";
var DELETE_ALL_SAVED_DIARY_COMPLETED = exports.DELETE_ALL_SAVED_DIARY_COMPLETED = "DELETE_ALL_SAVED_DIARY_COMPLETED";
var DELETE_ALL_SAVED_DIARY_FAILED = exports.DELETE_ALL_SAVED_DIARY_FAILED = "DELETE_ALL_SAVED_DIARY_FAILED";

function deleteAllSavedDiaryRequested() {
  return {
    type: DELETE_ALL_SAVED_DIARY_REQUESTED
  };
}

function deleteAllSavedDiary(group_id) {
  return function (dispatch) {
    dispatch(deleteAllSavedDiaryRequested());
    return _gambaApi2.default.delete('/diaries/saved', { group_id: group_id }).then(function (results) {
      dispatch(deleteAllSavedDiaryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(deleteAllSavedDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function deleteAllSavedDiaryCompleted(results) {
  return {
    type: DELETE_ALL_SAVED_DIARY_COMPLETED,
    results: results
  };
}

function deleteAllSavedDiaryFailed(error) {
  return {
    type: DELETE_ALL_SAVED_DIARY_FAILED,
    error: error
  };
}

var CLEAR_SAVED_DIARIES = exports.CLEAR_SAVED_DIARIES = "CLEAR_SAVED_DIARIES";

function clearSavedDiaries() {
  return {
    type: CLEAR_SAVED_DIARIES
  };
}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_DIARY_TO_SUB_DIARIES = exports.CLEAR_SUB_DIARIES = exports.SEARCH_DIARIES_FAILED = exports.SEARCH_DIARIES_COMPLETED = exports.SEARCH_DIARIES_REQUESTED = exports.SEARCH_DIARIES = exports.FETCH_SUB_DIARY_FAILED = exports.FETCH_SUB_DIARY_COMPLETED = exports.FETCH_SUB_DIARY_REQUESTED = exports.FETCH_SUB_DIARY = exports.FETCH_SUB_DIARIES_FAILED = exports.FETCH_SUB_DIARIES_COMPLETED = exports.FETCH_SUB_DIARIES_REQUESTED = exports.FETCH_SUB_DIARIES = undefined;
exports.fetchSubDiariesRequested = fetchSubDiariesRequested;
exports.fetchSubDiaries = fetchSubDiaries;
exports.fetchSubDiariesCompleted = fetchSubDiariesCompleted;
exports.fetchSubDiariesFailed = fetchSubDiariesFailed;
exports.fetchSubDiaryRequested = fetchSubDiaryRequested;
exports.fetchSubDiary = fetchSubDiary;
exports.fetchSubDiaryCompleted = fetchSubDiaryCompleted;
exports.fetchSubDiaryFailed = fetchSubDiaryFailed;
exports.searchDiariesRequested = searchDiariesRequested;
exports.searchDiaries = searchDiaries;
exports.searchDiariesCompleted = searchDiariesCompleted;
exports.searchDiariesFailed = searchDiariesFailed;
exports.clearSubDiaries = clearSubDiaries;
exports.loadDiaryToSubDiaries = loadDiaryToSubDiaries;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/sub-diaries.js

var FETCH_SUB_DIARIES = exports.FETCH_SUB_DIARIES = "FETCH_SUB_DIARIES";
var FETCH_SUB_DIARIES_REQUESTED = exports.FETCH_SUB_DIARIES_REQUESTED = "FETCH_SUB_DIARIES_REQUESTED";
var FETCH_SUB_DIARIES_COMPLETED = exports.FETCH_SUB_DIARIES_COMPLETED = "FETCH_SUB_DIARIES_COMPLETED";
var FETCH_SUB_DIARIES_FAILED = exports.FETCH_SUB_DIARIES_FAILED = "FETCH_SUB_DIARIES_FAILED";

function fetchSubDiariesRequested() {
  return {
    type: FETCH_SUB_DIARIES_REQUESTED
  };
}

// conditions:
//   user_id: ユーザid
//   diary_ids: 投稿idのリスト
//   unread: 未読の投稿のみ
//   category: 投稿種別(diary, memo, kpi)
//   reported_at_only: 投稿日指定
function fetchSubDiaries(group_id, offset) {
  var conditions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return function (dispatch) {
    dispatch(fetchSubDiariesRequested());
    conditions = Object.assign(conditions, { group_id: group_id, offset: offset });
    return _gambaApi2.default.get('/diaries', conditions).then(function (results) {
      dispatch(fetchSubDiariesCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(fetchSubDiariesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchSubDiariesCompleted(results, offset) {
  return {
    type: FETCH_SUB_DIARIES_COMPLETED,
    results: results, offset: offset
  };
}

function fetchSubDiariesFailed(error) {
  return {
    type: FETCH_SUB_DIARIES_FAILED,
    error: error
  };
}

var FETCH_SUB_DIARY = exports.FETCH_SUB_DIARY = "FETCH_SUB_DIARY";
var FETCH_SUB_DIARY_REQUESTED = exports.FETCH_SUB_DIARY_REQUESTED = "FETCH_SUB_DIARY_REQUESTED";
var FETCH_SUB_DIARY_COMPLETED = exports.FETCH_SUB_DIARY_COMPLETED = "FETCH_SUB_DIARY_COMPLETED";
var FETCH_SUB_DIARY_FAILED = exports.FETCH_SUB_DIARY_FAILED = "FETCH_SUB_DIARY_FAILED";

function fetchSubDiaryRequested() {
  return {
    type: FETCH_SUB_DIARY_REQUESTED
  };
}

function fetchSubDiary(diary_id) {
  var with_all_likes_readers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return function (dispatch) {
    dispatch(fetchSubDiaryRequested());
    return _gambaApi2.default.get('/diaries/' + diary_id, { with_all_likes_readers: with_all_likes_readers }).then(function (results) {
      dispatch(fetchSubDiaryCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchSubDiaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchSubDiaryCompleted(results) {
  return {
    type: FETCH_SUB_DIARY_COMPLETED,
    results: results
  };
}

function fetchSubDiaryFailed(error) {
  return {
    type: FETCH_SUB_DIARY_FAILED,
    error: error
  };
}

var SEARCH_DIARIES = exports.SEARCH_DIARIES = "SEARCH_DIARIES";
var SEARCH_DIARIES_REQUESTED = exports.SEARCH_DIARIES_REQUESTED = "SEARCH_DIARIES_REQUESTED";
var SEARCH_DIARIES_COMPLETED = exports.SEARCH_DIARIES_COMPLETED = "SEARCH_DIARIES_COMPLETED";
var SEARCH_DIARIES_FAILED = exports.SEARCH_DIARIES_FAILED = "SEARCH_DIARIES_FAILED";

function searchDiariesRequested() {
  return {
    type: SEARCH_DIARIES_REQUESTED
  };
}

// conditions:
//   user_ids: ユーザidのリスト
//   category: 投稿種別(diary, memo, kpi)
//   start_date, end_date: 投稿日の期間指定
//   files_attached: 添付ファイルがあるものに限定
//   query: 検索キーワード
function searchDiaries(group_id, offset) {
  var conditions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return function (dispatch) {
    dispatch(searchDiariesRequested());
    conditions = Object.assign(conditions, { group_id: group_id, offset: offset });
    return _gambaApi2.default.get('/diaries/search', conditions).then(function (results) {
      dispatch(searchDiariesCompleted(results, offset));
    }).catch(function (error) {
      Promise.all([dispatch(searchDiariesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function searchDiariesCompleted(results, offset) {
  return {
    type: SEARCH_DIARIES_COMPLETED,
    results: results, offset: offset
  };
}

function searchDiariesFailed(error) {
  return {
    type: SEARCH_DIARIES_FAILED,
    error: error
  };
}

var CLEAR_SUB_DIARIES = exports.CLEAR_SUB_DIARIES = "CLEAR_SUB_DIARIES";

function clearSubDiaries() {
  return {
    type: CLEAR_SUB_DIARIES
  };
}

var LOAD_DIARY_TO_SUB_DIARIES = exports.LOAD_DIARY_TO_SUB_DIARIES = "LOAD_DIARY_TO_SUB_DIARIES";

function loadDiaryToSubDiaries(diary) {
  return {
    type: LOAD_DIARY_TO_SUB_DIARIES,
    diary: diary
  };
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIBE_DEVICE_TOKEN_FAILED = exports.SUBSCRIBE_DEVICE_TOKEN_COMPLETED = exports.SUBSCRIBE_DEVICE_TOKEN_REQUESTED = exports.SUBSCRIBE_DEVICE_TOKEN = undefined;
exports.subscribeDeviceTokenRequested = subscribeDeviceTokenRequested;
exports.subscribeDeviceToken = subscribeDeviceToken;
exports.subscribeDeviceTokenCompleted = subscribeDeviceTokenCompleted;
exports.subscribeDeviceTokenFailed = subscribeDeviceTokenFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/subscribe.js

var SUBSCRIBE_DEVICE_TOKEN = exports.SUBSCRIBE_DEVICE_TOKEN = "SUBSCRIBE_DEVICE_TOKEN";
var SUBSCRIBE_DEVICE_TOKEN_REQUESTED = exports.SUBSCRIBE_DEVICE_TOKEN_REQUESTED = "SUBSCRIBE_DEVICE_TOKEN_REQUESTED";
var SUBSCRIBE_DEVICE_TOKEN_COMPLETED = exports.SUBSCRIBE_DEVICE_TOKEN_COMPLETED = "SUBSCRIBE_DEVICE_TOKEN_COMPLETED";
var SUBSCRIBE_DEVICE_TOKEN_FAILED = exports.SUBSCRIBE_DEVICE_TOKEN_FAILED = "SUBSCRIBE_DEVICE_TOKEN_FAILED";

function subscribeDeviceTokenRequested() {
  return {
    type: SUBSCRIBE_DEVICE_TOKEN_REQUESTED
  };
}

function subscribeDeviceToken(subscription_id, subscription_type) {
  var endpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  return function (dispatch) {
    dispatch(subscribeDeviceTokenRequested());
    return _gambaApi2.default.post('/subscribe', { subscription_id: subscription_id, subscription_type: subscription_type, endpoint: endpoint }).then(function (results) {
      dispatch(subscribeDeviceTokenCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(subscribeDeviceTokenFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function subscribeDeviceTokenCompleted(results) {
  return {
    type: SUBSCRIBE_DEVICE_TOKEN_COMPLETED,
    results: results
  };
}

function subscribeDeviceTokenFailed(error) {
  return {
    type: SUBSCRIBE_DEVICE_TOKEN_FAILED,
    error: error
  };
}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_USER_INFO_FAILED = exports.FETCH_USER_INFO_COMPLETED = exports.FETCH_USER_INFO_REQUESTED = exports.FETCH_USER_INFO = undefined;
exports.fetchUserInfoRequested = fetchUserInfoRequested;
exports.fetchUserInfo = fetchUserInfo;
exports.fetchUserInfoCompleted = fetchUserInfoCompleted;
exports.fetchUserInfoFailed = fetchUserInfoFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/users.js

var FETCH_USER_INFO = exports.FETCH_USER_INFO = "FETCH_USER_INFO";
var FETCH_USER_INFO_REQUESTED = exports.FETCH_USER_INFO_REQUESTED = "FETCH_USER_INFO_REQUESTED";
var FETCH_USER_INFO_COMPLETED = exports.FETCH_USER_INFO_COMPLETED = "FETCH_USER_INFO_COMPLETED";
var FETCH_USER_INFO_FAILED = exports.FETCH_USER_INFO_FAILED = "FETCH_USER_INFO_FAILED";

function fetchUserInfoRequested() {
  return {
    type: FETCH_USER_INFO_REQUESTED
  };
}

function fetchUserInfo(user_id) {
  return function (dispatch) {
    dispatch(fetchUserInfoRequested());
    return _gambaApi2.default.get('/users/' + user_id).then(function (results) {
      dispatch(fetchUserInfoCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchUserInfoFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchUserInfoCompleted(results) {
  return {
    type: FETCH_USER_INFO_COMPLETED,
    results: results
  };
}

function fetchUserInfoFailed(error) {
  return {
    type: FETCH_USER_INFO_FAILED,
    error: error
  };
}

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openSidebar = openSidebar;
exports.closeSidebar = closeSidebar;
exports.dockSidebar = dockSidebar;
exports.undockSidebar = undockSidebar;

// src/actions/sidebar.js

var OPEN_SIDEBAR = exports.OPEN_SIDEBAR = "OPEN_SIDEBAR";
var CLOSE_SIDEBAR = exports.CLOSE_SIDEBAR = "CLOSE_SIDEBAR";
var DOCK_SIDEBAR = exports.DOCK_SIDEBAR = "DOCK_SIDEBAR";
var UNDOCK_SIDEBAR = exports.UNDOCK_SIDEBAR = "UNDOCK_SIDEBAR";

function openSidebar() {
  return {
    type: OPEN_SIDEBAR
  };
}

function closeSidebar() {
  return {
    type: CLOSE_SIDEBAR
  };
}

function dockSidebar() {
  return {
    type: DOCK_SIDEBAR
  };
}

function undockSidebar() {
  return {
    type: UNDOCK_SIDEBAR
  };
}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCKET_DISCONNECT = exports.SOCKET_RECEIVE = exports.SOCKET_RECONNECTING = exports.SOCKET_RECONNECT = exports.SOCKET_CONNECT = undefined;
exports.socketConnect = socketConnect;
exports.socketReconnect = socketReconnect;
exports.socketReconnecting = socketReconnecting;
exports.socketDisconnect = socketDisconnect;
exports.socketReceive = socketReceive;

var _alertMessage = __webpack_require__(13);

var SOCKET_CONNECT = exports.SOCKET_CONNECT = "SOCKET_CONNECT";
// src/actions/socket.js

var SOCKET_RECONNECT = exports.SOCKET_RECONNECT = "SOCKET_RECONNECT";
var SOCKET_RECONNECTING = exports.SOCKET_RECONNECTING = "SOCKET_RECONNECTING";
var SOCKET_RECEIVE = exports.SOCKET_RECEIVE = "SOCKET_RECEIVE";
var SOCKET_DISCONNECT = exports.SOCKET_DISCONNECT = "SOCKET_DISCONNECT";

function socketConnect() {
  return {
    type: SOCKET_CONNECT
  };
}

function socketReconnect() {
  return {
    type: SOCKET_RECONNECT
  };
}

function socketReconnecting() {
  return {
    type: SOCKET_RECONNECTING
  };
}

function socketDisconnect() {
  return {
    type: SOCKET_DISCONNECT
  };
}

function socketReceive(message_type, params) {
  return {
    type: SOCKET_RECEIVE,
    message_type: message_type, params: params
  };
}

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openRightSidePage = openRightSidePage;
exports.closeRightSidePage = closeRightSidePage;

// src/actions/right-sidebar.js

var OPEN_RIGHT_SIDE_PAGE = exports.OPEN_RIGHT_SIDE_PAGE = "OPEN_RIGHT_SIDE_PAGE";

function openRightSidePage(name, params, push) {
  return {
    type: OPEN_RIGHT_SIDE_PAGE,
    name: name, params: params, push: push
  };
}

var CLOSE_RIGHT_SIDE_PAGE = exports.CLOSE_RIGHT_SIDE_PAGE = "CLOSE_RIGHT_SIDE_PAGE";

function closeRightSidePage() {
  var forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return {
    type: CLOSE_RIGHT_SIDE_PAGE, forced: forced
  };
}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_OUTLOOK_CALENDAR_EVENTS = exports.FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED = exports.FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED = exports.FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED = exports.FETCH_OUTLOOK_CALENDAR_EVENTS = exports.CLEAR_OUTLOOK_CALENDARS = exports.FETCH_OUTLOOK_CALENDARS_FAILED = exports.FETCH_OUTLOOK_CALENDARS_COMPLETED = exports.FETCH_OUTLOOK_CALENDARS_REQUESTED = exports.FETCH_OUTLOOK_CALENDARS = undefined;
exports.fetchOutlookCalendarsRequested = fetchOutlookCalendarsRequested;
exports.fetchOutlookCalendars = fetchOutlookCalendars;
exports.fetchOutlookCalendarsCompleted = fetchOutlookCalendarsCompleted;
exports.fetchOutlookCalendarsFailed = fetchOutlookCalendarsFailed;
exports.clearOutlookCalendars = clearOutlookCalendars;
exports.fetchOutlookCalendarEventsRequested = fetchOutlookCalendarEventsRequested;
exports.fetchOutlookCalendarEvents = fetchOutlookCalendarEvents;
exports.fetchOutlookCalendarEventsCompleted = fetchOutlookCalendarEventsCompleted;
exports.fetchOutlookCalendarEventsFailed = fetchOutlookCalendarEventsFailed;
exports.clearOutlookCalendarEvents = clearOutlookCalendarEvents;

var _outlookApi = __webpack_require__(1742);

var _outlookApi2 = _interopRequireDefault(_outlookApi);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/outlook-calendar.js

var FETCH_OUTLOOK_CALENDARS = exports.FETCH_OUTLOOK_CALENDARS = "FETCH_OUTLOOK_CALENDARS";
var FETCH_OUTLOOK_CALENDARS_REQUESTED = exports.FETCH_OUTLOOK_CALENDARS_REQUESTED = "FETCH_OUTLOOK_CALENDARS_REQUESTED";
var FETCH_OUTLOOK_CALENDARS_COMPLETED = exports.FETCH_OUTLOOK_CALENDARS_COMPLETED = "FETCH_OUTLOOK_CALENDARS_COMPLETED";
var FETCH_OUTLOOK_CALENDARS_FAILED = exports.FETCH_OUTLOOK_CALENDARS_FAILED = "FETCH_OUTLOOK_CALENDARS_FAILED";

function fetchOutlookCalendarsRequested() {
  return {
    type: FETCH_OUTLOOK_CALENDARS_REQUESTED
  };
}

function fetchOutlookCalendars() {
  return function (dispatch) {
    dispatch(fetchOutlookCalendarsRequested());
    return _outlookApi2.default.get('/calendars').then(function (results) {
      dispatch(fetchOutlookCalendarsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchOutlookCalendarsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchOutlookCalendarsCompleted(results) {
  return {
    type: FETCH_OUTLOOK_CALENDARS_COMPLETED,
    results: results
  };
}

function fetchOutlookCalendarsFailed(error) {
  return {
    type: FETCH_OUTLOOK_CALENDARS_FAILED,
    error: error
  };
}

var CLEAR_OUTLOOK_CALENDARS = exports.CLEAR_OUTLOOK_CALENDARS = "CLEAR_OUTLOOK_CALENDARS";

function clearOutlookCalendars() {
  return {
    type: CLEAR_OUTLOOK_CALENDARS
  };
}

var FETCH_OUTLOOK_CALENDAR_EVENTS = exports.FETCH_OUTLOOK_CALENDAR_EVENTS = "FETCH_OUTLOOK_CALENDAR_EVENTS";
var FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED = exports.FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED = "FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED";
var FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED = exports.FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED = "FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED";
var FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED = exports.FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED = "FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED";

function fetchOutlookCalendarEventsRequested(selectDate) {
  return {
    type: FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED,
    selectDate: selectDate
  };
}

function fetchOutlookCalendarEvents(selectDate, calendar) {
  var startDateTime = (0, _moment2.default)(selectDate).startOf('day').toISOString();
  var endDateTime = (0, _moment2.default)(selectDate).endOf('day').toISOString();
  return function (dispatch) {
    dispatch(fetchOutlookCalendarEventsRequested(selectDate));
    var query = calendar != 'primary' && '/calendars/' + calendar + '/calendarview' || '/calendarview';
    return _outlookApi2.default.get('' + query, { startDateTime: startDateTime, endDateTime: endDateTime }).then(function (results) {
      dispatch(fetchOutlookCalendarEventsCompleted(selectDate, calendar, results.map(function (item) {
        // isOneDay: １日に収まる予定を判定
        var isOneDay = (0, _moment2.default)(item.start.startTime).format('YYYY-MM-DD') == (0, _moment2.default)(item.end.endTime).format('YYYY-MM-DD');
        var title = !item.subject ? '件名なし' : item.subject;
        return {
          event_id: item.id,
          title: title,
          date: item.start.dateTime.slice(0, 10),
          endDate: isOneDay && !item.isAllDay ? null : item.end.dateTime, // 終日とそれ以外の予定を判定
          startTime: item.isAllDay ? null : item.start.dateTime,
          endTime: item.isAllDay ? null : item.end.dateTime,
          description: item.body.content
        };
      })));
    }).catch(function (error) {
      Promise.all([dispatch(fetchOutlookCalendarEventsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}
function fetchOutlookCalendarEventsCompleted(selectDate, calendar, results) {
  return {
    type: FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED,
    selectDate: selectDate, calendar: calendar, results: results
  };
}

function fetchOutlookCalendarEventsFailed(error) {
  return {
    type: FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED,
    error: error
  };
}

var CLEAR_OUTLOOK_CALENDAR_EVENTS = exports.CLEAR_OUTLOOK_CALENDAR_EVENTS = "CLEAR_OUTLOOK_CALENDARS_EVENTS";

function clearOutlookCalendarEvents() {
  return {
    type: CLEAR_OUTLOOK_CALENDAR_EVENTS
  };
}

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertDiaryForm = insertDiaryForm;
exports.clearInsertDiaryForm = clearInsertDiaryForm;

// src/actions/diary-form.js

var INSERT_DIARY_FORM = exports.INSERT_DIARY_FORM = "INSERT_DIARY_FORM";
var CLEAR_INSERT_DIARY_FORM = exports.CLEAR_INSERT_DIARY_FORM = "CLEAR_INSERT_DIARY_FORM";

function insertDiaryForm(html) {
  return {
    type: INSERT_DIARY_FORM,
    html: html
  };
}

function clearInsertDiaryForm() {
  return {
    type: CLEAR_INSERT_DIARY_FORM
  };
}

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openGroupSettingsPage = openGroupSettingsPage;
exports.closeGroupSettingsPage = closeGroupSettingsPage;

// src/actions/group-settings.js

var OPEN_GROUP_SETTINGS_PAGE = exports.OPEN_GROUP_SETTINGS_PAGE = "OPEN_GROUP_SETTINGS_PAGE";

function openGroupSettingsPage(name) {
  return {
    type: OPEN_GROUP_SETTINGS_PAGE,
    name: name
  };
}

var CLOSE_GROUP_SETTINGS_PAGE = exports.CLOSE_GROUP_SETTINGS_PAGE = "CLOSE_GROUP_SETTINGS_PAGE";

function closeGroupSettingsPage() {
  return {
    type: CLOSE_GROUP_SETTINGS_PAGE
  };
}

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openUserSettingsPage = openUserSettingsPage;
exports.closeUserSettingsPage = closeUserSettingsPage;

// src/actions/user-settings.js

var OPEN_USER_SETTINGS_PAGE = exports.OPEN_USER_SETTINGS_PAGE = "OPEN_USER_SETTINGS_PAGE";

function openUserSettingsPage(name) {
  return {
    type: OPEN_USER_SETTINGS_PAGE,
    name: name
  };
}

var CLOSE_USER_SETTINGS_PAGE = exports.CLOSE_USER_SETTINGS_PAGE = "CLOSE_USER_SETTINGS_PAGE";

function closeUserSettingsPage() {
  return {
    type: CLOSE_USER_SETTINGS_PAGE
  };
}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_PRODUCT_TOUR_STATE = undefined;
exports.fetchProductTourState = fetchProductTourState;
exports.hideProductTour = hideProductTour;

var _permanentStore = __webpack_require__(118);

var _permanentStore2 = _interopRequireDefault(_permanentStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY = "gambaApp.productTour";
// src/actions/product-tour.native.js

var FETCH_PRODUCT_TOUR_STATE = exports.FETCH_PRODUCT_TOUR_STATE = "FETCH_PRODUCT_TOUR_STATE";
var store = (0, _permanentStore2.default)(KEY, {});

function fetchProductTourState() {
  return function (dispatch) {
    store.get(function (state) {
      if (typeof state == 'boolean') state = {};
      dispatch({ type: FETCH_PRODUCT_TOUR_STATE, state: state });
    });
  };
}

function hideProductTour(key) {
  return function (dispatch) {
    store.get(function (state) {
      if (typeof state == 'boolean') state = {};
      state[key] = 'hide';
      store.set(state, function () {
        dispatch({ type: FETCH_PRODUCT_TOUR_STATE, state: state });
      });
    });
  };
}

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_REGISTRATION_URL_FAILED = exports.GET_REGISTRATION_URL_COMPLETED = exports.GET_REGISTRATION_URL_REQUESTED = exports.GET_REGISTRATION_URL = undefined;
exports.getRegistrationUrlRequested = getRegistrationUrlRequested;
exports.getRegistrationUrl = getRegistrationUrl;
exports.getRegistrationUrlCompleted = getRegistrationUrlCompleted;
exports.getRegistrationUrlFailed = getRegistrationUrlFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/registration-url.js

var GET_REGISTRATION_URL = exports.GET_REGISTRATION_URL = "GET_REGISTRATION_URL";
var GET_REGISTRATION_URL_REQUESTED = exports.GET_REGISTRATION_URL_REQUESTED = "GET_REGISTRATION_URL_REQUESTED";
var GET_REGISTRATION_URL_COMPLETED = exports.GET_REGISTRATION_URL_COMPLETED = "GET_REGISTRATION_URL_COMPLETED";
var GET_REGISTRATION_URL_FAILED = exports.GET_REGISTRATION_URL_FAILED = "GET_REGISTRATION_URL_FAILED";

function getRegistrationUrlRequested() {
  return {
    type: GET_REGISTRATION_URL_REQUESTED
  };
}

function getRegistrationUrl(group_id) {
  return function (dispatch) {
    dispatch(getRegistrationUrlRequested());
    return _gambaApi2.default.get('/registration_url', { group_id: group_id }).then(function (results) {
      dispatch(getRegistrationUrlCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(getRegistrationUrlFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function getRegistrationUrlCompleted(results) {
  return {
    type: GET_REGISTRATION_URL_COMPLETED,
    results: results
  };
}

function getRegistrationUrlFailed(error) {
  return {
    type: GET_REGISTRATION_URL_FAILED,
    error: error
  };
}

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_FAILED = exports.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_COMPLETED = exports.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_REQUESTED = exports.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT = exports.FETCH_OTHER_MEMBERS_LENGTH = undefined;
exports.fetchAccountOtherMembersCountRequested = fetchAccountOtherMembersCountRequested;
exports.fetchAccountOtherMembersCount = fetchAccountOtherMembersCount;
exports.fetchAccountOtherMembersCountCompleted = fetchAccountOtherMembersCountCompleted;
exports.fetchAccountOtherMembersCountFailed = fetchAccountOtherMembersCountFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/account-other-members-count.js

var FETCH_OTHER_MEMBERS_LENGTH = exports.FETCH_OTHER_MEMBERS_LENGTH = 1;

var FETCH_ACCOUNT_OTHER_MEMBERS_COUNT = exports.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT = "FETCH_ACCOUNT_OTHER_MEMBERS_COUNT";
var FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_REQUESTED = exports.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_REQUESTED = "FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_REQUESTED";
var FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_COMPLETED = exports.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_COMPLETED = "FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_COMPLETED";
var FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_FAILED = exports.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_FAILED = "FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_FAILED";

function fetchAccountOtherMembersCountRequested() {
  return {
    type: FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_REQUESTED
  };
}

function fetchAccountOtherMembersCount(exclude_group_id) {
  return function (dispatch) {
    dispatch(fetchAccountOtherMembersCountRequested());
    return _gambaApi2.default.get('/account/members', { offset: 0, exclude_group_id: exclude_group_id, length: FETCH_OTHER_MEMBERS_LENGTH }).then(function (results) {
      dispatch(fetchAccountOtherMembersCountCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchAccountOtherMembersCountFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchAccountOtherMembersCountCompleted(results) {
  return {
    type: FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_COMPLETED,
    results: results
  };
}

function fetchAccountOtherMembersCountFailed(error) {
  return {
    type: FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_FAILED,
    error: error
  };
}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_URL_INFO = exports.FETCH_URL_INFO_FAILED = exports.FETCH_URL_INFO_COMPLETED = exports.FETCH_URL_INFO_REQUESTED = exports.FETCH_URL_INFO = undefined;
exports.fetchUrlInfoRequested = fetchUrlInfoRequested;
exports.fetchUrlInfo = fetchUrlInfo;
exports.fetchUrlInfoCompleted = fetchUrlInfoCompleted;
exports.fetchUrlInfoFailed = fetchUrlInfoFailed;
exports.clearUrlInfo = clearUrlInfo;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/url-info.js

var FETCH_URL_INFO = exports.FETCH_URL_INFO = "FETCH_URL_INFO";
var FETCH_URL_INFO_REQUESTED = exports.FETCH_URL_INFO_REQUESTED = "FETCH_URL_INFO_REQUESTED";
var FETCH_URL_INFO_COMPLETED = exports.FETCH_URL_INFO_COMPLETED = "FETCH_URL_INFO_COMPLETED";
var FETCH_URL_INFO_FAILED = exports.FETCH_URL_INFO_FAILED = "FETCH_URL_INFO_FAILED";
var CLEAR_URL_INFO = exports.CLEAR_URL_INFO = "CLEAR_URL_INFO";

function fetchUrlInfoRequested(url, componentId) {
  return {
    type: FETCH_URL_INFO_REQUESTED,
    url: url, componentId: componentId
  };
}

function fetchUrlInfo(url, componentId) {
  url = url.replace(/^http/i, 'http');
  if (!url.match(/^http/)) return { type: FETCH_URL_INFO };
  return function (dispatch) {
    dispatch(fetchUrlInfoRequested(url, componentId));
    return _gambaApi2.default.get('/url_info', { url: url }).then(function (results) {
      dispatch(fetchUrlInfoCompleted(url, results, componentId));
    }).catch(function (error) {
      Promise.all([dispatch(fetchUrlInfoFailed(error, componentId, url)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchUrlInfoCompleted(url, results, componentId) {
  return {
    type: FETCH_URL_INFO_COMPLETED,
    url: url, results: results, componentId: componentId
  };
}

function fetchUrlInfoFailed(error, componentId, url) {
  return {
    type: FETCH_URL_INFO_FAILED,
    error: error, componentId: componentId, url: url
  };
}

function clearUrlInfo(componentId) {
  return {
    type: CLEAR_URL_INFO,
    componentId: componentId
  };
}

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_IMAGES_VIEW = exports.FETCH_IMAGES_VIEW_FAILED = exports.FETCH_IMAGES_VIEW_COMPLETED = exports.FETCH_IMAGES_VIEW_REQUESTED = exports.FETCH_GROUP_TIMELINE_COMMENT_IMAGES_VIEW = exports.FETCH_GROUP_TIMELINE_IMAGES_VIEW = exports.FETCH_CHAT_IMAGES_VIEW = undefined;
exports.fetchImagesViewRequested = fetchImagesViewRequested;
exports.fetchChatImagesView = fetchChatImagesView;
exports.fetchGroupTimelineImagesView = fetchGroupTimelineImagesView;
exports.fetchGroupTimelineCommentImagesView = fetchGroupTimelineCommentImagesView;
exports.fetchImagesViewCompleted = fetchImagesViewCompleted;
exports.fetchImagesViewFailed = fetchImagesViewFailed;
exports.clearImagesView = clearImagesView;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/images-view.js

var FETCH_CHAT_IMAGES_VIEW = exports.FETCH_CHAT_IMAGES_VIEW = "FETCH_CHAT_IMAGES_VIEW";
var FETCH_GROUP_TIMELINE_IMAGES_VIEW = exports.FETCH_GROUP_TIMELINE_IMAGES_VIEW = "FETCH_GROUP_TIMELINE_IMAGES_VIEW";
var FETCH_GROUP_TIMELINE_COMMENT_IMAGES_VIEW = exports.FETCH_GROUP_TIMELINE_COMMENT_IMAGES_VIEW = "FETCH_GROUP_TIMELINE_COMMENT_IMAGES_VIEW";
var FETCH_IMAGES_VIEW_REQUESTED = exports.FETCH_IMAGES_VIEW_REQUESTED = "FETCH_IMAGES_VIEW_REQUESTED";
var FETCH_IMAGES_VIEW_COMPLETED = exports.FETCH_IMAGES_VIEW_COMPLETED = "FETCH_IMAGES_VIEW_COMPLETED";
var FETCH_IMAGES_VIEW_FAILED = exports.FETCH_IMAGES_VIEW_FAILED = "FETCH_IMAGES_VIEW_FAILED";
var CLEAR_IMAGES_VIEW = exports.CLEAR_IMAGES_VIEW = "CLEAR_IMAGES_VIEW";

var FETCH_IMAGES_VIEW_LENGTH = 100;

function fetchImagesViewRequested() {
  return {
    type: FETCH_IMAGES_VIEW_REQUESTED
  };
}

function fetchChatImagesView(chat_room_id) {
  return function (dispatch) {
    dispatch(fetchImagesViewRequested());
    return _gambaApi2.default.get('/attachments', { chat_room_id: chat_room_id, length: FETCH_IMAGES_VIEW_LENGTH }).then(function (results) {
      dispatch(fetchImagesViewCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchImagesViewFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchGroupTimelineImagesView(diary_id, all_file) {
  return function (dispatch) {
    dispatch(fetchImagesViewRequested());
    return _gambaApi2.default.get('/attachments', { diary_id: diary_id, length: FETCH_IMAGES_VIEW_LENGTH, all_files: all_file }).then(function (results) {
      dispatch(fetchImagesViewCompleted(results.reverse()));
    }).catch(function (error) {
      Promise.all([dispatch(fetchImagesViewFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchGroupTimelineCommentImagesView(comment_id) {
  return function (dispatch) {
    dispatch(fetchImagesViewRequested());
    return _gambaApi2.default.get('/attachments', { comment_id: comment_id, length: FETCH_IMAGES_VIEW_LENGTH }).then(function (results) {
      dispatch(fetchImagesViewCompleted(results.reverse()));
    }).catch(function (error) {
      Promise.all([dispatch(fetchImagesViewFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchImagesViewCompleted(results) {
  return {
    type: FETCH_IMAGES_VIEW_COMPLETED,
    results: results
  };
}

function fetchImagesViewFailed(error) {
  return {
    type: FETCH_IMAGES_VIEW_FAILED,
    error: error
  };
}

function clearImagesView() {
  return {
    type: CLEAR_IMAGES_VIEW
  };
}

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_DASHBOARD_DETAILS = exports.CLEAR_DASHBOARD_DATA = exports.FETCH_DASHBOARD_DETAILS_FAILED = exports.FETCH_DASHBOARD_DETAILS_COMPLETED = exports.FETCH_DASHBOARD_DETAILS_REQUESTED = exports.FETCH_DASHBOARD_DETAILS = exports.FETCH_DASHBOARD_RECEIVES_FAILED = exports.FETCH_DASHBOARD_RECEIVES_COMPLETED = exports.FETCH_DASHBOARD_RECEIVES_REQUESTED = exports.FETCH_DASHBOARD_RECEIVES = exports.FETCH_DASHBOARD_REPLIES_FAILED = exports.FETCH_DASHBOARD_REPLIES_COMPLETED = exports.FETCH_DASHBOARD_REPLIES_REQUESTED = exports.FETCH_DASHBOARD_REPLIES = exports.FETCH_DASHBOARD_POSTS_FAILED = exports.FETCH_DASHBOARD_POSTS_COMPLETED = exports.FETCH_DASHBOARD_POSTS_REQUESTED = exports.FETCH_DASHBOARD_POSTS = exports.FETCH_DASHBOARD_SUMMARY_FAILED = exports.FETCH_DASHBOARD_SUMMARY_COMPLETED = exports.FETCH_DASHBOARD_SUMMARY_REQUESTED = exports.FETCH_DASHBOARD_SUMMARY = undefined;
exports.fetchDashboardSummaryRequested = fetchDashboardSummaryRequested;
exports.fetchDashboardSummary = fetchDashboardSummary;
exports.fetchDashboardSummaryCompleted = fetchDashboardSummaryCompleted;
exports.fetchDashboardSummaryFailed = fetchDashboardSummaryFailed;
exports.fetchDashboardPostsRequested = fetchDashboardPostsRequested;
exports.fetchDashboardPosts = fetchDashboardPosts;
exports.fetchDashboardPostsCompleted = fetchDashboardPostsCompleted;
exports.fetchDashboardPostsFailed = fetchDashboardPostsFailed;
exports.fetchDashboardRepliesRequested = fetchDashboardRepliesRequested;
exports.fetchDashboardReplies = fetchDashboardReplies;
exports.fetchDashboardRepliesCompleted = fetchDashboardRepliesCompleted;
exports.fetchDashboardRepliesFailed = fetchDashboardRepliesFailed;
exports.fetchDashboardReceivesRequested = fetchDashboardReceivesRequested;
exports.fetchDashboardReceives = fetchDashboardReceives;
exports.fetchDashboardReceivesCompleted = fetchDashboardReceivesCompleted;
exports.fetchDashboardReceivesFailed = fetchDashboardReceivesFailed;
exports.fetchDashboardDetailsRequested = fetchDashboardDetailsRequested;
exports.fetchDashboardDetails = fetchDashboardDetails;
exports.fetchDashboardDetailsCompleted = fetchDashboardDetailsCompleted;
exports.fetchDashboardDetailsFailed = fetchDashboardDetailsFailed;
exports.clearDashboardData = clearDashboardData;
exports.clearDashboardDetails = clearDashboardDetails;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/dashboard.js

var FETCH_DASHBOARD_SUMMARY = exports.FETCH_DASHBOARD_SUMMARY = "FETCH_DASHBOARD_SUMMARY";
var FETCH_DASHBOARD_SUMMARY_REQUESTED = exports.FETCH_DASHBOARD_SUMMARY_REQUESTED = "FETCH_DASHBOARD_SUMMARY_REQUESTED";
var FETCH_DASHBOARD_SUMMARY_COMPLETED = exports.FETCH_DASHBOARD_SUMMARY_COMPLETED = "FETCH_DASHBOARD_SUMMARY_COMPLETED";
var FETCH_DASHBOARD_SUMMARY_FAILED = exports.FETCH_DASHBOARD_SUMMARY_FAILED = "FETCH_DASHBOARD_SUMMARY_FAILED";

function fetchDashboardSummaryRequested() {
  return {
    type: FETCH_DASHBOARD_SUMMARY_REQUESTED
  };
}

function fetchDashboardSummary(group_id, start_date, end_date) {
  return function (dispatch) {
    dispatch(fetchDashboardSummaryRequested());
    return _gambaApi2.default.get('/dashboard/summary/' + group_id, { start_date: start_date, end_date: end_date }).then(function (results) {
      dispatch(fetchDashboardSummaryCompleted(group_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDashboardSummaryFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchDashboardSummaryCompleted(group_id, results) {
  return {
    type: FETCH_DASHBOARD_SUMMARY_COMPLETED,
    group_id: group_id, results: results
  };
}

function fetchDashboardSummaryFailed(error) {
  return {
    type: FETCH_DASHBOARD_SUMMARY_FAILED,
    error: error
  };
}

var FETCH_DASHBOARD_POSTS = exports.FETCH_DASHBOARD_POSTS = "FETCH_DASHBOARD_POSTS";
var FETCH_DASHBOARD_POSTS_REQUESTED = exports.FETCH_DASHBOARD_POSTS_REQUESTED = "FETCH_DASHBOARD_POSTS_REQUESTED";
var FETCH_DASHBOARD_POSTS_COMPLETED = exports.FETCH_DASHBOARD_POSTS_COMPLETED = "FETCH_DASHBOARD_POSTS_COMPLETED";
var FETCH_DASHBOARD_POSTS_FAILED = exports.FETCH_DASHBOARD_POSTS_FAILED = "FETCH_DASHBOARD_POSTS_FAILED";

function fetchDashboardPostsRequested() {
  return {
    type: FETCH_DASHBOARD_POSTS_REQUESTED
  };
}

function fetchDashboardPosts(group_id, start_date, end_date) {
  return function (dispatch) {
    dispatch(fetchDashboardPostsRequested());
    return _gambaApi2.default.get('/dashboard/posts/' + group_id, { start_date: start_date, end_date: end_date }).then(function (results) {
      dispatch(fetchDashboardPostsCompleted(group_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDashboardPostsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchDashboardPostsCompleted(group_id, results) {
  return {
    type: FETCH_DASHBOARD_POSTS_COMPLETED,
    group_id: group_id, results: results
  };
}

function fetchDashboardPostsFailed(error) {
  return {
    type: FETCH_DASHBOARD_POSTS_FAILED,
    error: error
  };
}

var FETCH_DASHBOARD_REPLIES = exports.FETCH_DASHBOARD_REPLIES = "FETCH_DASHBOARD_REPLIES";
var FETCH_DASHBOARD_REPLIES_REQUESTED = exports.FETCH_DASHBOARD_REPLIES_REQUESTED = "FETCH_DASHBOARD_REPLIES_REQUESTED";
var FETCH_DASHBOARD_REPLIES_COMPLETED = exports.FETCH_DASHBOARD_REPLIES_COMPLETED = "FETCH_DASHBOARD_REPLIES_COMPLETED";
var FETCH_DASHBOARD_REPLIES_FAILED = exports.FETCH_DASHBOARD_REPLIES_FAILED = "FETCH_DASHBOARD_REPLIES_FAILED";

function fetchDashboardRepliesRequested() {
  return {
    type: FETCH_DASHBOARD_REPLIES_REQUESTED
  };
}

function fetchDashboardReplies(group_id, start_date, end_date) {
  return function (dispatch) {
    dispatch(fetchDashboardRepliesRequested());
    return _gambaApi2.default.get('/dashboard/replies/' + group_id, { start_date: start_date, end_date: end_date }).then(function (results) {
      dispatch(fetchDashboardRepliesCompleted(group_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDashboardRepliesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchDashboardRepliesCompleted(group_id, results) {
  return {
    type: FETCH_DASHBOARD_REPLIES_COMPLETED,
    group_id: group_id, results: results
  };
}

function fetchDashboardRepliesFailed(error) {
  return {
    type: FETCH_DASHBOARD_REPLIES_FAILED,
    error: error
  };
}

var FETCH_DASHBOARD_RECEIVES = exports.FETCH_DASHBOARD_RECEIVES = "FETCH_DASHBOARD_RECEIVES";
var FETCH_DASHBOARD_RECEIVES_REQUESTED = exports.FETCH_DASHBOARD_RECEIVES_REQUESTED = "FETCH_DASHBOARD_RECEIVES_REQUESTED";
var FETCH_DASHBOARD_RECEIVES_COMPLETED = exports.FETCH_DASHBOARD_RECEIVES_COMPLETED = "FETCH_DASHBOARD_RECEIVES_COMPLETED";
var FETCH_DASHBOARD_RECEIVES_FAILED = exports.FETCH_DASHBOARD_RECEIVES_FAILED = "FETCH_DASHBOARD_RECEIVES_FAILED";

function fetchDashboardReceivesRequested() {
  return {
    type: FETCH_DASHBOARD_RECEIVES_REQUESTED
  };
}

function fetchDashboardReceives(group_id, start_date, end_date) {
  return function (dispatch) {
    dispatch(fetchDashboardReceivesRequested());
    return _gambaApi2.default.get('/dashboard/receives/' + group_id, { start_date: start_date, end_date: end_date }).then(function (results) {
      dispatch(fetchDashboardReceivesCompleted(group_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDashboardReceivesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchDashboardReceivesCompleted(group_id, results) {
  return {
    type: FETCH_DASHBOARD_RECEIVES_COMPLETED,
    group_id: group_id, results: results
  };
}

function fetchDashboardReceivesFailed(error) {
  return {
    type: FETCH_DASHBOARD_RECEIVES_FAILED,
    error: error
  };
}

var FETCH_DASHBOARD_DETAILS = exports.FETCH_DASHBOARD_DETAILS = "FETCH_DASHBOARD_DETAILS";
var FETCH_DASHBOARD_DETAILS_REQUESTED = exports.FETCH_DASHBOARD_DETAILS_REQUESTED = "FETCH_DASHBOARD_DETAILS_REQUESTED";
var FETCH_DASHBOARD_DETAILS_COMPLETED = exports.FETCH_DASHBOARD_DETAILS_COMPLETED = "FETCH_DASHBOARD_DETAILS_COMPLETED";
var FETCH_DASHBOARD_DETAILS_FAILED = exports.FETCH_DASHBOARD_DETAILS_FAILED = "FETCH_DASHBOARD_DETAILS_FAILED";

function fetchDashboardDetailsRequested() {
  return {
    type: FETCH_DASHBOARD_DETAILS_REQUESTED
  };
}

function fetchDashboardDetails(group_id, user_id, start_date, end_date) {
  return function (dispatch) {
    dispatch(fetchDashboardDetailsRequested());
    return _gambaApi2.default.get('/dashboard/details/' + group_id + '/' + user_id, { start_date: start_date, end_date: end_date }).then(function (results) {
      dispatch(fetchDashboardDetailsCompleted(group_id, user_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDashboardDetailsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchDashboardDetailsCompleted(group_id, user_id, results) {
  return {
    type: FETCH_DASHBOARD_DETAILS_COMPLETED,
    group_id: group_id, user_id: user_id, results: results
  };
}

function fetchDashboardDetailsFailed(error) {
  return {
    type: FETCH_DASHBOARD_DETAILS_FAILED,
    error: error
  };
}

var CLEAR_DASHBOARD_DATA = exports.CLEAR_DASHBOARD_DATA = "CLEAR_DASHBOARD_DATA";
function clearDashboardData() {
  return {
    type: CLEAR_DASHBOARD_DATA
  };
}

var CLEAR_DASHBOARD_DETAILS = exports.CLEAR_DASHBOARD_DETAILS = "CLEAR_DASHBOARD_DETAILS";
function clearDashboardDetails() {
  return {
    type: CLEAR_DASHBOARD_DETAILS
  };
}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SAVE_SUBMISSION_SCHEDULES_FAILED = exports.SAVE_SUBMISSION_SCHEDULES_COMPLETED = exports.SAVE_SUBMISSION_SCHEDULES_REQUESTED = exports.SAVE_SUBMISSION_SCHEDULES = undefined;
exports.saveSubmissionSchedulesRequested = saveSubmissionSchedulesRequested;
exports.saveSubmissionSchedules = saveSubmissionSchedules;
exports.saveSubmissionSchedulesCompleted = saveSubmissionSchedulesCompleted;
exports.saveSubmissionSchedulesFailed = saveSubmissionSchedulesFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/submission_schedules.js

var SAVE_SUBMISSION_SCHEDULES = exports.SAVE_SUBMISSION_SCHEDULES = "SAVE_SUBMISSION_SCHEDULES";
var SAVE_SUBMISSION_SCHEDULES_REQUESTED = exports.SAVE_SUBMISSION_SCHEDULES_REQUESTED = "SAVE_SUBMISSION_SCHEDULES_REQUESTED";
var SAVE_SUBMISSION_SCHEDULES_COMPLETED = exports.SAVE_SUBMISSION_SCHEDULES_COMPLETED = "SAVE_SUBMISSION_SCHEDULES_COMPLETED";
var SAVE_SUBMISSION_SCHEDULES_FAILED = exports.SAVE_SUBMISSION_SCHEDULES_FAILED = "SAVE_SUBMISSION_SCHEDULES_FAILED";

function saveSubmissionSchedulesRequested() {
  return {
    type: SAVE_SUBMISSION_SCHEDULES_REQUESTED
  };
}

function saveSubmissionSchedules(group_id, start_date, end_date, schedules, user_id) {
  return function (dispatch) {
    dispatch(saveSubmissionSchedulesRequested());
    return _gambaApi2.default.put('/submission_schedules', { group_id: group_id, start_date: start_date, end_date: end_date, schedules: schedules, user_id: user_id }).then(function (results) {
      dispatch(saveSubmissionSchedulesCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(saveSubmissionSchedulesFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function saveSubmissionSchedulesCompleted(results) {
  return {
    type: SAVE_SUBMISSION_SCHEDULES_COMPLETED,
    results: results
  };
}

function saveSubmissionSchedulesFailed(error) {
  return {
    type: SAVE_SUBMISSION_SCHEDULES_FAILED,
    error: error
  };
}

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POST_CONTENT_REPORT_FAILED = exports.POST_CONTENT_REPORT_COMPLETED = exports.POST_CONTENT_REPORT_REQUESTED = exports.POST_CONTENT_REPORT = exports.POST_USER_REPORT_FAILED = exports.POST_USER_REPORT_COMPLETED = exports.POST_USER_REPORT_REQUESTED = exports.POST_USER_REPORT = undefined;
exports.postUserReportRequested = postUserReportRequested;
exports.postUserReport = postUserReport;
exports.postUserReportCompleted = postUserReportCompleted;
exports.postUserReportFailed = postUserReportFailed;
exports.postContentReportRequested = postContentReportRequested;
exports.postContentReport = postContentReport;
exports.postContentReportCompleted = postContentReportCompleted;
exports.postContentReportFailed = postContentReportFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/report.js

var POST_USER_REPORT = exports.POST_USER_REPORT = "POST_USER_REPORT";
var POST_USER_REPORT_REQUESTED = exports.POST_USER_REPORT_REQUESTED = "POST_USER_REPORT_REQUESTED";
var POST_USER_REPORT_COMPLETED = exports.POST_USER_REPORT_COMPLETED = "POST_USER_REPORT_COMPLETED";
var POST_USER_REPORT_FAILED = exports.POST_USER_REPORT_FAILED = "POST_USER_REPORT_FAILED";

function postUserReportRequested(user_id, target_user_id) {
  return {
    type: POST_USER_REPORT_REQUESTED,
    user_id: user_id, target_user_id: target_user_id
  };
}

function postUserReport(user_id, target_user_id) {
  return function (dispatch) {
    dispatch(postUserReportRequested(user_id, target_user_id));
    return _gambaApi2.default.post('/user/user_report', { user_id: user_id, target_user_id: target_user_id }).then(function (results) {
      dispatch(postUserReportCompleted(user_id, target_user_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(postUserReportFailed(user_id, target_user_id, error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function postUserReportCompleted(user_id, target_user_id, results) {
  return {
    type: POST_USER_REPORT_COMPLETED,
    user_id: user_id, target_user_id: target_user_id, results: results
  };
}

function postUserReportFailed(user_id, target_user_id, error) {
  return {
    type: POST_USER_REPORT_FAILED,
    user_id: user_id, target_user_id: target_user_id, error: error
  };
}

var POST_CONTENT_REPORT = exports.POST_CONTENT_REPORT = "POST_CONTENT_REPORT";
var POST_CONTENT_REPORT_REQUESTED = exports.POST_CONTENT_REPORT_REQUESTED = "POST_CONTENT_REPORT_REQUESTED";
var POST_CONTENT_REPORT_COMPLETED = exports.POST_CONTENT_REPORT_COMPLETED = "POST_CONTENT_REPORT_COMPLETED";
var POST_CONTENT_REPORT_FAILED = exports.POST_CONTENT_REPORT_FAILED = "POST_CONTENT_REPORT_FAILED";

function postContentReportRequested(user_id, diary_id, comment_id) {
  return {
    type: POST_CONTENT_REPORT_REQUESTED,
    user_id: user_id, diary_id: diary_id, comment_id: comment_id
  };
}

function postContentReport(user_id, diary_id, comment_id) {
  return function (dispatch) {
    dispatch(postContentReportRequested(user_id, diary_id, comment_id));
    return _gambaApi2.default.post('/user/content_report', { user_id: user_id, diary_id: diary_id, comment_id: comment_id }).then(function (results) {
      dispatch(postContentReportCompleted(user_id, diary_id, comment_id, results));
    }).catch(function (error) {
      Promise.all([dispatch(postContentReportFailed(user_id, diary_id, comment_id, error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function postContentReportCompleted(user_id, diary_id, comment_id, results) {
  return {
    type: POST_CONTENT_REPORT_COMPLETED,
    user_id: user_id, diary_id: diary_id, comment_id: comment_id, results: results
  };
}

function postContentReportFailed(user_id, diary_id, comment_id, error) {
  return {
    type: POST_CONTENT_REPORT_FAILED,
    user_id: user_id, diary_id: diary_id, comment_id: comment_id, error: error
  };
}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1744);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(98),
    isSymbol = __webpack_require__(219);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREATE_DIVISION_FAILED = exports.CREATE_DIVISION_COMPLETED = exports.CREATE_DIVISION_REQUESTED = exports.CREATE_DIVISION = exports.UPDATE_DIVISION_FAILED = exports.UPDATE_DIVISION_COMPLETED = exports.UPDATE_DIVISION_REQUESTED = exports.UPDATE_DIVISION = exports.CLOSE_DIVISION_SETTINGS_PAGE = exports.OPEN_DIVISION_SETTINGS_PAGE = undefined;
exports.openDivisionSettingsPage = openDivisionSettingsPage;
exports.closeDivisionSettingsPage = closeDivisionSettingsPage;
exports.updateDivision = updateDivision;
exports.updateDivisionRequested = updateDivisionRequested;
exports.updateDivisionCompleted = updateDivisionCompleted;
exports.updateDivisionFailed = updateDivisionFailed;
exports.createDivisionRequested = createDivisionRequested;
exports.createDivision = createDivision;
exports.createDivisionCompleted = createDivisionCompleted;
exports.createDivisionFailed = createDivisionFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

var _divisions = __webpack_require__(468);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPEN_DIVISION_SETTINGS_PAGE = exports.OPEN_DIVISION_SETTINGS_PAGE = "OPEN_DIVISION_SETTINGS_PAGE";
// src/actions/divisions-settings.js
function openDivisionSettingsPage(name) {
  return {
    type: OPEN_DIVISION_SETTINGS_PAGE,
    name: name
  };
}

var CLOSE_DIVISION_SETTINGS_PAGE = exports.CLOSE_DIVISION_SETTINGS_PAGE = "CLOSE_DIVISION_SETTINGS_PAGE";

function closeDivisionSettingsPage() {
  return {
    type: CLOSE_DIVISION_SETTINGS_PAGE
  };
}

var UPDATE_DIVISION = exports.UPDATE_DIVISION = "UPDATE_DIVISION";
var UPDATE_DIVISION_REQUESTED = exports.UPDATE_DIVISION_REQUESTED = "UPDATE_DIVISION_REQUESTED";
var UPDATE_DIVISION_COMPLETED = exports.UPDATE_DIVISION_COMPLETED = "UPDATE_DIVISION_COMPLETED";
var UPDATE_DIVISION_FAILED = exports.UPDATE_DIVISION_FAILED = "UPDATE_DIVISION_FAILED";

function updateDivision(division_id, name, access_type, uploadable_file_id, crop) {

  return function (dispatch) {
    dispatch(updateDivisionRequested({}));
    return _gambaApi2.default.put('/divisions/' + division_id, { name: name, access_type: access_type, uploadable_file_id: uploadable_file_id, crop: crop }).then(function (results) {
      dispatch(updateDivisionCompleted(results));
      dispatch((0, _divisions.reloadDivision)(results));
    }).catch(function (error) {
      Promise.all([dispatch(updateDivisionFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function updateDivisionRequested() {
  return {
    type: UPDATE_DIVISION_REQUESTED
  };
}

function updateDivisionCompleted(results) {
  return {
    type: UPDATE_DIVISION_COMPLETED,
    results: results
  };
}

function updateDivisionFailed(error) {
  return {
    type: UPDATE_DIVISION_FAILED,
    error: error
  };
}

var CREATE_DIVISION = exports.CREATE_DIVISION = "CREATE_DIVISION";
var CREATE_DIVISION_REQUESTED = exports.CREATE_DIVISION_REQUESTED = "CREATE_DIVISION_REQUESTED";
var CREATE_DIVISION_COMPLETED = exports.CREATE_DIVISION_COMPLETED = "CREATE_DIVISION_COMPLETED";
var CREATE_DIVISION_FAILED = exports.CREATE_DIVISION_FAILED = "CREATE_DIVISION_FAILED";

function createDivisionRequested() {
  return {
    type: CREATE_DIVISION_REQUESTED
  };
}

function createDivision(name, access_type, uploadable_file_id, crop) {
  return function (dispatch) {
    //dispatch(createDivisionRequested())
    return dispatch(createDivisionCompleted(results));
    return _gambaApi2.default.post('/divisions', { name: name, access_type: access_type, uploadable_file_id: uploadable_file_id, crop: crop }).then(function (results) {
      dispatch(createDivisionCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(createDivisionFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function createDivisionCompleted(results) {
  return {
    type: CREATE_DIVISION_COMPLETED,
    results: results
  };
}

function createDivisionFailed(error) {
  return {
    type: CREATE_DIVISION_FAILED,
    error: error
  };
}

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_DIVISION_GROUP_FAILED = exports.FETCH_DIVISION_GROUP_COMPLETED = exports.FETCH_DIVISION_GROUP_REQUESTED = exports.FETCH_DIVISION_GROUP = undefined;
exports.fetchDivisionGroup = fetchDivisionGroup;
exports.fetchDivisionsCompleted = fetchDivisionsCompleted;
exports.fetchDivisionsFailed = fetchDivisionsFailed;
exports.fetchDivisionGroupRequested = fetchDivisionGroupRequested;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_DIVISION_GROUP = exports.FETCH_DIVISION_GROUP = "FETCH_DIVISION_GROUP";
// src/actions/divisions-settings.js
var FETCH_DIVISION_GROUP_REQUESTED = exports.FETCH_DIVISION_GROUP_REQUESTED = "FETCH_DIVISION_GROUP_REQUESTED";
var FETCH_DIVISION_GROUP_COMPLETED = exports.FETCH_DIVISION_GROUP_COMPLETED = "FETCH_DIVISION_GROUP_COMPLETED";
var FETCH_DIVISION_GROUP_FAILED = exports.FETCH_DIVISION_GROUP_FAILED = "FETCH_DIVISION_GROUP_FAILED";

function fetchDivisionGroup() {
  return function (dispatch) {
    dispatch(fetchDivisionGroupRequested());
    return _gambaApi2.default.get('/divisionshuwfehuwfeu').then(function (results) {
      dispatch(fetchDivisionsCompleted(results));
    }).catch(function (error) {
      Promise.all([dispatch(fetchDivisionsFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchDivisionsCompleted(results) {
  return {
    type: FETCH_DIVISION_GROUP_COMPLETED,
    results: results
  };
}

function fetchDivisionsFailed(error) {
  return {
    type: FETCH_DIVISION_GROUP_FAILED,
    error: error
  };
}

function fetchDivisionGroupRequested() {
  return {
    type: FETCH_DIVISION_GROUP_REQUESTED
  };
}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SORTING_MENU_POSITION = exports.EXPAND_DIVISION_SORT_NOT_SET_GROUP = exports.EXPAND_DIVISION_NOT_SET_GROUP = exports.COLLAPSE_DIVISION_SORT = exports.COLLAPSE_DIVISION = exports.EXPAND_DIVISION_SORT = exports.EXPAND_DIVISION = exports.SET_FLASH_NEW_FREE_GROUP_ID = exports.SET_NOT_FREE_MENU = exports.SET_FREE_MENU = exports.SORT_MENU = exports.INIT_MENU = undefined;
exports.initMenus = initMenus;
exports.applyMenuPosition = applyMenuPosition;
exports.setNewMenuPositions = setNewMenuPositions;
exports.sortMenu = sortMenu;
exports.setFreeMenu = setFreeMenu;
exports.setNotFreeMenu = setNotFreeMenu;
exports.setFlashNewFreeGroupId = setFlashNewFreeGroupId;
exports.expandDivision = expandDivision;
exports.expandDivisionSort = expandDivisionSort;
exports.collapseDivision = collapseDivision;
exports.collapseDivisionSort = collapseDivisionSort;
exports.expandDivisionNotSetGroup = expandDivisionNotSetGroup;
exports.expandDivisionSortNotSetGroup = expandDivisionSortNotSetGroup;
exports.setSortingMenuPosition = setSortingMenuPosition;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INIT_MENU = exports.INIT_MENU = "INIT_MENU";
// src/actions/menus.js

var SORT_MENU = exports.SORT_MENU = "SORT_MENU";
var SET_FREE_MENU = exports.SET_FREE_MENU = "SET_FREE_MENU";
var SET_NOT_FREE_MENU = exports.SET_NOT_FREE_MENU = "SET_NOT_FREE_MENU";
var SET_FLASH_NEW_FREE_GROUP_ID = exports.SET_FLASH_NEW_FREE_GROUP_ID = "SET_FLASH_NEW_FREE_GROUP_ID";
var EXPAND_DIVISION = exports.EXPAND_DIVISION = "EXPAND_DIVISION";
var EXPAND_DIVISION_SORT = exports.EXPAND_DIVISION_SORT = "EXPAND_DIVISION_SORT";
var COLLAPSE_DIVISION = exports.COLLAPSE_DIVISION = "COLLAPSE_DIVISION";
var COLLAPSE_DIVISION_SORT = exports.COLLAPSE_DIVISION_SORT = "COLLAPSE_DIVISION_SORT";

var EXPAND_DIVISION_NOT_SET_GROUP = exports.EXPAND_DIVISION_NOT_SET_GROUP = "EXPAND_DIVISION_NOT_SET_GROUP";
var EXPAND_DIVISION_SORT_NOT_SET_GROUP = exports.EXPAND_DIVISION_SORT_NOT_SET_GROUP = "EXPAND_DIVISION_SORT_NOT_SET_GROUP";
var SET_SORTING_MENU_POSITION = exports.SET_SORTING_MENU_POSITION = "SET_SORTING_MENU_POSITION";

var MaxItemPerMenu = 100;
var MaxDivisionPerMenu = 500;

function initMenus(userMenus, divisions, allgroups) {
  var menuItems = userMenus && userMenus.length > 0 ? defaultUserMenuItems(userMenus, divisions, allgroups) : defaultMenuItems(divisions, allgroups);

  return {
    type: INIT_MENU,
    results: menuItems
  };
}

function defaultUserMenuItems(userMenus, divisions, groups) {
  if (!divisions || !groups) return [];
  var divisionMenu = getBlankDivisionMenu(divisions);
  var oldDivisionMenu = userMenus.filter(function (item) {
    return item.type == 'division';
  });
  var freeGroupsMenu = getBlankFreeGroupMenu(groups);
  var oldFreeGroupsMenu = userMenus.filter(function (item) {
    return item.type == 'group' && item.is_free;
  });
  freeGroupsMenu = applyOldFreeGroupsToNewFreeGroup(oldFreeGroupsMenu, freeGroupsMenu);
  var oldFreeMenu = userMenus.filter(function (item) {
    return item.is_free;
  });
  var newFreeMenu = [].concat(divisionMenu, freeGroupsMenu);

  var nonFreeGroupsMenu = getBlankNonFreeGroupMenu(divisions, groups);
  var oldNonFreeGroupsMenu = userMenus.filter(function (item) {
    return item.type == 'group' && !item.is_free;
  });
  nonFreeGroupsMenu = applyOldFreeGroupsToNewNonFreeGroup(oldFreeGroupsMenu, nonFreeGroupsMenu);

  sortNewMenuWithOldPosition(oldFreeMenu, newFreeMenu);
  sortNewMenuWithOldPosition(oldNonFreeGroupsMenu, nonFreeGroupsMenu);

  var menuItems = [].concat(newFreeMenu, nonFreeGroupsMenu);
  return applyMenuPosition(menuItems);
}

function defaultMenuItems(divisions, groups) {
  if (!divisions || !groups) return [];
  var divisionMenu = getBlankDivisionMenu(divisions);
  var freeGroupsMenu = getBlankFreeGroupMenu(groups);
  var nonFreeGroupsMenu = getBlankNonFreeGroupMenu(divisions, groups);
  var menuItems = [].concat(divisionMenu, freeGroupsMenu, nonFreeGroupsMenu);

  return applyMenuPosition(menuItems);
}

function applyOldFreeGroupsToNewFreeGroup(oldFreeGroupsMenu, menuItems) {
  oldFreeGroupsMenu.forEach(function (oldMenu) {
    if (oldMenu.is_free_group) return;
    if (menuItems.find(function (item) {
      return item.type == 'group' && item.item_id == oldMenu.item_id && item.is_free;
    })) return;
    menuItems.push({
      item_id: oldMenu.item_id,
      type: 'group',
      is_free: true,
      is_free_group: false
    });
  });
  return menuItems;
}
function applyOldFreeGroupsToNewNonFreeGroup(oldFreeGroupsMenu, menuItems) {
  oldFreeGroupsMenu.forEach(function (oldMenu) {
    if (oldMenu.is_free_group) return;
    menuItems = menuItems.filter(function (item) {
      return item.type != 'group' || item.item_id != oldMenu.item_id || item.is_free;
    });
  });
  return menuItems;
}

function sortNewMenuWithOldPosition(oldMenuItems, newMenuItems) {
  newMenuItems.sort(function (item1, item2) {
    var oldItem1 = oldMenuItems.find(function (item) {
      return item.item_id == item1.item_id && item.parent_id == item1.parent_id;
    });
    var oldItem2 = oldMenuItems.find(function (item) {
      return item.item_id == item2.item_id && item.parent_id == item2.parent_id;
    });
    if (!oldItem1 && !oldItem2) return 0;
    if (!oldItem2) return -1;
    if (!oldItem1) return 1;
    return oldItem1.position - oldItem2.position;
  });
}

function getBlankDivisionMenu(divisions) {
  var menuItems = [];
  divisions.forEach(function (division) {
    menuItems.push({
      item_id: division.division_id,
      type: 'division',
      is_free: true
    });
  });
  return menuItems;
}

function getBlankFreeGroupMenu(groups) {
  var menuItems = [];
  var freeGroups = groups.filter(function (group) {
    return group.is_free_group;
  });
  freeGroups.forEach(function (group) {
    menuItems.push({
      item_id: group.group_id,
      type: 'group',
      is_free: true,
      is_free_group: group.is_free_group
    });
  });
  return menuItems;
}

function getBlankNonFreeGroupMenu(divisions, groups) {
  var menuItems = [];
  var nonFreeGroups = groups.filter(function (group) {
    return !group.is_free_group;
  });
  divisions.forEach(function (division) {
    var divisionGroups = nonFreeGroups.filter(function (group) {
      return division.groups.map(function (g) {
        return g.id;
      }).includes(group.group_id);
    });
    divisionGroups.forEach(function (group) {
      menuItems.push({
        item_id: group.group_id,
        type: 'group',
        is_free: false,
        is_free_group: group.is_free_group,
        parent_id: division.division_id
      });
    });
  });
  return menuItems;
}

function applyMenuPosition(menuItems) {
  menuItems.filter(function (menuItem) {
    return menuItem.type == 'division' && menuItem.is_free;
  }).forEach(function (menuItem, index) {
    menuItem.position = (index + 1) * MaxItemPerMenu;
  });
  menuItems.filter(function (menuItem) {
    return menuItem.type == 'group' && menuItem.is_free;
  }).forEach(function (menuItem, index) {
    menuItem.position = MaxDivisionPerMenu * MaxItemPerMenu + index + 1;
  });
  menuItems.filter(function (menuItem) {
    return menuItem.type == 'division';
  }).forEach(function (divisionMenu) {
    var groupMenus = menuItems.filter(function (menuItem) {
      return menuItem.parent_id == divisionMenu.item_id;
    });
    groupMenus.forEach(function (groupMenu, index) {
      groupMenu.position = divisionMenu.position + index + 1;
    });
  });
  return menuItems.sort(function (item1, item2) {
    return item1.position - item2.position;
  });
}

function setNewMenuPositions(newPositions) {
  var changeIndex = void 0;
  newPositions.forEach(function (item, index) {
    if (index == 0) return;
    if (newPositions[index - 1] > item) {
      changeIndex = index - 1;
    }
  });
  var oldPosition = void 0,
      newPosition = void 0;
  if (newPositions[changeIndex - 1] != newPositions[changeIndex] - 1 && newPositions[changeIndex + 1] != newPositions[changeIndex] + 1 && newPositions[changeIndex - 1] != newPositions[changeIndex] - MaxItemPerMenu && newPositions[changeIndex + 1] != newPositions[changeIndex] + MaxItemPerMenu) {
    oldPosition = newPositions[changeIndex];
    newPosition = newPositions[changeIndex + 1];
  } else {
    oldPosition = newPositions[changeIndex + 1];
    newPosition = newPositions[changeIndex];
  }
  return {
    type: SORT_MENU,
    results: {
      oldPosition: oldPosition, newPosition: newPosition
    }
  };
}

function sortMenu(oldPosition, newPosition) {
  return {
    type: SORT_MENU,
    results: {
      oldPosition: oldPosition, newPosition: newPosition
    }
  };
}

function setFreeMenu(position) {
  return {
    type: SET_FREE_MENU,
    results: {
      position: position
    }
  };
}

function setNotFreeMenu(position, groupDivisionIds) {
  return {
    type: SET_NOT_FREE_MENU,
    results: {
      position: position,
      groupDivisionIds: groupDivisionIds
    }
  };
}

function setFlashNewFreeGroupId(item_id) {
  return {
    type: SET_FLASH_NEW_FREE_GROUP_ID,
    results: item_id
  };
}

function expandDivision(item_id) {
  return {
    type: EXPAND_DIVISION,
    results: item_id
  };
}

function expandDivisionSort(item_id) {
  return {
    type: EXPAND_DIVISION_SORT,
    results: item_id
  };
}

function collapseDivision(item_id) {
  return {
    type: COLLAPSE_DIVISION,
    results: item_id
  };
}

function collapseDivisionSort(item_id) {
  return {
    type: COLLAPSE_DIVISION_SORT,
    results: item_id
  };
}

function expandDivisionNotSetGroup() {
  return {
    type: EXPAND_DIVISION_NOT_SET_GROUP
  };
}

function expandDivisionSortNotSetGroup() {
  return {
    type: EXPAND_DIVISION_SORT_NOT_SET_GROUP
  };
}

function setSortingMenuPosition(position) {
  return {
    type: SET_SORTING_MENU_POSITION,
    results: position
  };
}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOSE_REVIEW_PANEL = exports.OPEN_REVIEW_PANEL = exports.INITIALIZE_REVIEW = exports.CLEAR_REVIEW = exports.FETCH_REVIEW_FAILED = exports.FETCH_REVIEW_COMPLETED = exports.FETCH_REVIEW_STREAMING = exports.FETCH_REVIEW_REQUESTED = exports.FETCH_REVIEW = undefined;
exports.fetchReviewRequested = fetchReviewRequested;
exports.fetchReviewStreaming = fetchReviewStreaming;
exports.fetchReview = fetchReview;
exports.fetchReviewCompleted = fetchReviewCompleted;
exports.fetchReviewFailed = fetchReviewFailed;
exports.clearReview = clearReview;
exports.initReview = initReview;
exports.openReviewPanel = openReviewPanel;
exports.closeReviewPanel = closeReviewPanel;

var _lambdaApi = __webpack_require__(1747);

var _lambdaApi2 = _interopRequireDefault(_lambdaApi);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/review.js

var FETCH_REVIEW = exports.FETCH_REVIEW = "FETCH_REVIEW";
var FETCH_REVIEW_REQUESTED = exports.FETCH_REVIEW_REQUESTED = "FETCH_REVIEW_REQUESTED";
var FETCH_REVIEW_STREAMING = exports.FETCH_REVIEW_STREAMING = "FETCH_REVIEW_STREAMING";
var FETCH_REVIEW_COMPLETED = exports.FETCH_REVIEW_COMPLETED = "FETCH_REVIEW_COMPLETED";
var FETCH_REVIEW_FAILED = exports.FETCH_REVIEW_FAILED = "FETCH_REVIEW_FAILED";

function fetchReviewRequested() {
  return {
    type: FETCH_REVIEW_REQUESTED
  };
}

function fetchReviewStreaming(results) {
  return {
    type: FETCH_REVIEW_STREAMING,
    results: results
  };
}

function getReader(dispatch, res) {
  if (res.body) {
    var reader = res.body.getReader();
    var parseData = function parseData(input) {
      var regex = /data:\s*/g;
      var data = input.replace(regex, "").replace(/\s/g, "");
      return data;
    };

    var processStream = function processStream() {
      reader.read().then(function (_ref) {
        var done = _ref.done,
            value = _ref.value;

        if (done) {
          dispatch(fetchReviewCompleted());
          return;
        }
        var text = new TextDecoder("utf-8").decode(value);
        dispatch(fetchReviewStreaming(parseData(text)));
        processStream();
      }).catch(function (error) {
        console.error('読み取り中にエラーが発生しました:', error);
        reader.releaseLock();
      });
    };

    processStream();
  }
}

function fetchReview(user_message) {
  return function (dispatch) {
    dispatch(fetchReviewRequested());
    return _lambdaApi2.default.post('/chatgpt_review', user_message).then(function (results) {
      getReader(dispatch, results);
    }).catch(function (error) {
      Promise.all([dispatch(fetchReviewFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchReviewCompleted(results) {
  return {
    type: FETCH_REVIEW_COMPLETED,
    results: results
  };
}

function fetchReviewFailed(error) {
  return {
    type: FETCH_REVIEW_FAILED,
    error: error
  };
}

var CLEAR_REVIEW = exports.CLEAR_REVIEW = "CLEAR_REVIEW";

function clearReview() {
  return {
    type: CLEAR_REVIEW
  };
}

var INITIALIZE_REVIEW = exports.INITIALIZE_REVIEW = "INITIALIZE_REVIEW";

function initReview() {
  return {
    type: INITIALIZE_REVIEW
  };
}

var OPEN_REVIEW_PANEL = exports.OPEN_REVIEW_PANEL = "OPEN_REVIEW_PANEL";

function openReviewPanel() {
  return {
    type: OPEN_REVIEW_PANEL
  };
}

var CLOSE_REVIEW_PANEL = exports.CLOSE_REVIEW_PANEL = "CLOSE_REVIEW_PANEL";
function closeReviewPanel() {
  return {
    type: CLOSE_REVIEW_PANEL
  };
}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_REVIEW_SETTING_FAILED = exports.FETCH_REVIEW_SETTING_COMPLETED = exports.FETCH_REVIEW_SETTING_REQUESTED = exports.FETCH_REVIEW_SETTING = undefined;
exports.fetchReviewSettingRequested = fetchReviewSettingRequested;
exports.fetchReviewSetting = fetchReviewSetting;
exports.fetchReviewSettingCompleted = fetchReviewSettingCompleted;
exports.fetchReviewSettingFailed = fetchReviewSettingFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_REVIEW_SETTING = exports.FETCH_REVIEW_SETTING = "FETCH_REVIEW_SETTING"; // src/actions/review-setting.js

var FETCH_REVIEW_SETTING_REQUESTED = exports.FETCH_REVIEW_SETTING_REQUESTED = "FETCH_REVIEW_SETTING_REQUESTED";
var FETCH_REVIEW_SETTING_COMPLETED = exports.FETCH_REVIEW_SETTING_COMPLETED = "FETCH_REVIEW_SETTING_COMPLETED";
var FETCH_REVIEW_SETTING_FAILED = exports.FETCH_REVIEW_SETTING_FAILED = "FETCH_REVIEW_SETTING_FAILED";

function fetchReviewSettingRequested() {
  return {
    type: FETCH_REVIEW_SETTING_REQUESTED
  };
}

function fetchReviewSetting() {
  return function (dispatch) {
    dispatch(fetchReviewSettingRequested());
    return _gambaApi2.default.get('/account/review_setting').then(function (results) {
      dispatch(fetchReviewSettingCompleted(results));
    }).catch(function (error) {
      console.log(error);
      Promise.all([dispatch(fetchReviewSettingFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchReviewSettingCompleted(results) {
  return {
    type: FETCH_REVIEW_SETTING_COMPLETED,
    results: results
  };
}

function fetchReviewSettingFailed(error) {
  return {
    type: FETCH_REVIEW_SETTING_FAILED,
    error: error
  };
}

// export const UPDATE_REVIEW_SETTING = "UPDATE_REVIEW_SETTING"
// export const UPDATE_REVIEW_SETTING_REQUESTED = "UPDATE_REVIEW_SETTING_REQUESTED"
// export const UPDATE_REVIEW_SETTING_COMPLETED = "UPDATE_REVIEW_SETTING_COMPLETED"
// export const UPDATE_REVIEW_SETTING_FAILED = "UPDATE_REVIEW_SETTING_FAILED"

// export function updateReviewSettingRequested() {
//   return {
//     type: UPDATE_REVIEW_SETTING_REQUESTED
//   }
// }

// export function updateReviewSetting() {
//   return function(dispatch) {
//     dispatch(updateReviewSettingRequested())
//     return api.post(`/review_settting`, user_id)
//         .then((results)=> {
//           dispatch(updateReviewSettingCompleted(results))
//         })
//         .catch((error)=> {
//           Promise.all([
//             dispatch(updateReviewSettingFailed(user_id, error)),
//             dispatch(emitAlertMessage(error, 'error'))
//           ])
//         })
//   }
// }

// export function updateReviewSettingCompleted(results) {
//   return {
//     type: UPDATE_REVIEW_SETTING_COMPLETED,
//     results
//   }
// }

// export function updateReviewSettingFailed() {
//   return {
//     type: UPDATE_REVIEW_SETTING_FAILED,
//     error,
//   }
// }

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_SHOW_TIMESTAMP_SETTING_FAILED = exports.FETCH_SHOW_TIMESTAMP_SETTING_COMPLETED = exports.FETCH_SHOW_TIMESTAMP_SETTING_REQUESTED = exports.FETCH_SHOW_TIMESTAMP_SETTING = undefined;
exports.fetchShowTimestampSettingRequested = fetchShowTimestampSettingRequested;
exports.fetchShowTimestampSetting = fetchShowTimestampSetting;
exports.fetchShowTimestampSettingCompleted = fetchShowTimestampSettingCompleted;
exports.fetchShowTimestampSettingFailed = fetchShowTimestampSettingFailed;

var _gambaApi = __webpack_require__(22);

var _gambaApi2 = _interopRequireDefault(_gambaApi);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_SHOW_TIMESTAMP_SETTING = exports.FETCH_SHOW_TIMESTAMP_SETTING = "FETCH_SHOW_TIMESTAMP_SETTING"; // src/actions/review-setting.js

var FETCH_SHOW_TIMESTAMP_SETTING_REQUESTED = exports.FETCH_SHOW_TIMESTAMP_SETTING_REQUESTED = "FETCH_SHOW_TIMESTAMP_SETTING_REQUESTED";
var FETCH_SHOW_TIMESTAMP_SETTING_COMPLETED = exports.FETCH_SHOW_TIMESTAMP_SETTING_COMPLETED = "FETCH_SHOW_TIMESTAMP_SETTING_COMPLETED";
var FETCH_SHOW_TIMESTAMP_SETTING_FAILED = exports.FETCH_SHOW_TIMESTAMP_SETTING_FAILED = "FETCH_SHOW_TIMESTAMP_SETTING_FAILED";

function fetchShowTimestampSettingRequested() {
  return {
    type: FETCH_SHOW_TIMESTAMP_SETTING_REQUESTED
  };
}

function fetchShowTimestampSetting() {
  return function (dispatch) {
    dispatch(fetchShowTimestampSettingRequested());
    return _gambaApi2.default.get('/account/timestamp_setting').then(function (results) {
      dispatch(fetchShowTimestampSettingCompleted(results));
    }).catch(function (error) {
      console.log(error);
      Promise.all([dispatch(fetchShowTimestampSettingFailed(error)), dispatch((0, _alertMessage.emitAlertMessage)(error, 'error'))]);
    });
  };
}

function fetchShowTimestampSettingCompleted(results) {
  return {
    type: FETCH_SHOW_TIMESTAMP_SETTING_COMPLETED,
    results: results
  };
}

function fetchShowTimestampSettingFailed(error) {
  return {
    type: FETCH_SHOW_TIMESTAMP_SETTING_FAILED,
    error: error
  };
}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(1757);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(333);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(137);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1758);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(333);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Snackbar = __webpack_require__(1768);

var _button = __webpack_require__(8);

var _theme = __webpack_require__(1775);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedSnackbar = (0, _reactCssThemr.themr)(_identifiers.SNACKBAR, _theme2.default)((0, _Snackbar.snackbarFactory)(_button.Button));

exports.default = ThemedSnackbar;
exports.Snackbar = ThemedSnackbar;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(222);
var _has = __webpack_require__(867);
var _isArguments = __webpack_require__(1770);


/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
module.exports = (function() {
  // cover IE < 9 keys issues
  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
  // Safari bug
  var hasArgsEnumBug = (function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
  }());

  var contains = function contains(list, item) {
    var idx = 0;
    while (idx < list.length) {
      if (list[idx] === item) {
        return true;
      }
      idx += 1;
    }
    return false;
  };

  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
    _curry1(function keys(obj) {
      return Object(obj) !== obj ? [] : Object.keys(obj);
    }) :
    _curry1(function keys(obj) {
      if (Object(obj) !== obj) {
        return [];
      }
      var prop, nIdx;
      var ks = [];
      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
      for (prop in obj) {
        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
          ks[ks.length] = prop;
        }
      }
      if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
        while (nIdx >= 0) {
          prop = nonEnumerableProps[nIdx];
          if (_has(prop, obj) && !contains(ks, prop)) {
            ks[ks.length] = prop;
          }
          nIdx -= 1;
        }
      }
      return ks;
    });
}());


/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1774);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0: return function() { return fn.apply(this, arguments); };
    case 1: return function(a0) { return fn.apply(this, arguments); };
    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(473);
var _reduce = __webpack_require__(1785);


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * `R.reduced` to shortcut the iteration.
 *
 * The arguments' order of `reduceRight`'s iterator function is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *                -               -10
 *               / \              / \
 *              -   4           -6   4
 *             / \              / \
 *            -   3   ==>     -3   3
 *           / \              / \
 *          -   2           -1   2
 *         / \              / \
 *        0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */
module.exports = _curry3(_reduce);


/***/ }),
/* 871 */
/***/ (function(module, exports) {

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
module.exports = Array.isArray || function _isArray(val) {
  return (val != null &&
          val.length >= 0 &&
          Object.prototype.toString.call(val) === '[object Array]');
};


/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var _isArray = __webpack_require__(871);


/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */
module.exports = function _checkForMethod(methodname, fn) {
  return function() {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
      fn.apply(this, arguments) :
      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
};


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (children, predicate) {
  var _this = this;

  if (children) {
    var result = [];
    _react2.default.Children.forEach(children, function (entry, idx) {
      if (predicate && predicate.call(_this, entry, idx)) {
        result.push(entry);
      }
    });
    return result;
  }

  return undefined;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppBar = exports.appBarFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _IconButton = __webpack_require__(338);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(IconButton) {
  var AppBar = function (_React$Component) {
    _inherits(AppBar, _React$Component);

    function AppBar() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, AppBar);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppBar.__proto__ || Object.getPrototypeOf(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hidden: false, height: 0 }, _this.handleScroll = function () {
        var scrollDiff = _this.curScroll - window.scrollY;
        var hidden = scrollDiff < 0 && window.scrollY !== undefined && window.scrollY > _this.state.height;
        _this.setState({ hidden: hidden });
        _this.curScroll = window.scrollY;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AppBar, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.scrollHide) {
          this.initializeScroll();
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!this.props.scrollHide && nextProps.scrollHide) {
          this.initializeScroll();
        }

        if (this.props.scrollHide && !nextProps.scrollHide) {
          this.endScroll();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.props.scrollHide) {
          this.endScroll();
        }
      }
    }, {
      key: 'initializeScroll',
      value: function initializeScroll() {
        window.addEventListener('scroll', this.handleScroll);

        var _rootNode$getBounding = this.rootNode.getBoundingClientRect(),
            height = _rootNode$getBounding.height;

        this.curScroll = window.scrollY;
        this.setState({ height: height });
      }
    }, {
      key: 'endScroll',
      value: function endScroll() {
        window.removeEventListener('scroll', this.handleScroll);
      }
    }, {
      key: 'render',
      value: function render() {
        var _cn,
            _this2 = this;

        var _props = this.props,
            children = _props.children,
            leftIcon = _props.leftIcon,
            onLeftIconClick = _props.onLeftIconClick,
            onRightIconClick = _props.onRightIconClick,
            rightIcon = _props.rightIcon,
            theme = _props.theme,
            title = _props.title;


        var className = (0, _classnames2.default)(theme.appBar, (_cn = {}, _defineProperty(_cn, theme.fixed, this.props.fixed), _defineProperty(_cn, theme.flat, this.props.flat), _defineProperty(_cn, theme.scrollHide, this.state.hidden), _cn), this.props.className);

        var renderedTitle = typeof title === 'string' ? _react2.default.createElement(
          'h1',
          { className: (0, _classnames2.default)(theme.title) },
          title
        ) : title;

        var renderedLeftIcon = leftIcon && _react2.default.createElement(IconButton, {
          inverse: true,
          className: (0, _classnames2.default)(theme.leftIcon),
          onClick: onLeftIconClick,
          icon: leftIcon
        });

        var renderedRightIcon = rightIcon && _react2.default.createElement(IconButton, {
          inverse: true,
          className: (0, _classnames2.default)(theme.rightIcon),
          onClick: onRightIconClick,
          icon: rightIcon
        });

        return _react2.default.createElement(
          'header',
          {
            className: className,
            'data-react-toolbox': 'app-bar',
            ref: function ref(node) {
              _this2.rootNode = node;
            }
          },
          _react2.default.createElement(
            'div',
            { className: theme.inner },
            renderedLeftIcon,
            renderedTitle,
            children,
            renderedRightIcon
          )
        );
      }
    }]);

    return AppBar;
  }(_react2.default.Component);

  AppBar.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    fixed: _propTypes2.default.bool,
    flat: _propTypes2.default.bool,
    leftIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    onLeftIconClick: _propTypes2.default.func,
    onRightIconClick: _propTypes2.default.func,
    rightIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    scrollHide: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      appBar: _propTypes2.default.string,
      inner: _propTypes2.default.string,
      fixed: _propTypes2.default.string,
      flat: _propTypes2.default.string,
      leftIcon: _propTypes2.default.string,
      rightIcon: _propTypes2.default.string,
      scrollHide: _propTypes2.default.string,
      title: _propTypes2.default.string
    }),
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
  };
  AppBar.defaultProps = {
    className: '',
    fixed: false,
    flat: false,
    scrollHide: false
  };


  return AppBar;
};

var AppBar = factory(_IconButton2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.APP_BAR)(AppBar);
exports.appBarFactory = factory;
exports.AppBar = AppBar;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavDrawer = exports.navDrawerFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _Drawer = __webpack_require__(474);

var _Drawer2 = _interopRequireDefault(_Drawer);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var factory = function factory(Drawer) {
  var NavDrawer = function NavDrawer(_ref) {
    var _classnames;

    var active = _ref.active,
        className = _ref.className,
        clipped = _ref.clipped,
        permanentAt = _ref.permanentAt,
        pinned = _ref.pinned,
        theme = _ref.theme,
        rest = _objectWithoutProperties(_ref, ['active', 'className', 'clipped', 'permanentAt', 'pinned', 'theme']);

    var _className = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, theme.pinned, pinned), _defineProperty(_classnames, theme.clipped, clipped), _classnames), className);

    return _react2.default.createElement(Drawer, _extends({}, rest, {
      active: active || pinned,
      className: _className,
      insideTree: true,
      theme: theme,
      themeNamespace: 'navDrawer',
      withOverlay: !pinned
    }));
  };

  NavDrawer.propTypes = {
    active: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    clipped: _propTypes2.default.bool,
    permanentAt: _propTypes2.default.oneOf(['sm', 'smTablet', 'md', 'lg', 'lgTablet', 'xl', 'xxl', 'xxxl']),
    pinned: _propTypes2.default.bool,
    right: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      clipped: _propTypes2.default.string,
      pinned: _propTypes2.default.string
    })
  };

  NavDrawer.defaultProps = {
    className: '',
    pinned: false
  };

  return NavDrawer;
};

var NavDrawer = factory(_Drawer2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.LAYOUT)(NavDrawer);
exports.navDrawerFactory = factory;
exports.NavDrawer = NavDrawer;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = exports.sidebarFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _Drawer = __webpack_require__(474);

var _Drawer2 = _interopRequireDefault(_Drawer);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var factory = function factory(Drawer) {
  var Sidebar = function Sidebar(_ref) {
    var _classnames;

    var active = _ref.active,
        className = _ref.className,
        clipped = _ref.clipped,
        permanentAt = _ref.permanentAt,
        pinned = _ref.pinned,
        theme = _ref.theme,
        rest = _objectWithoutProperties(_ref, ['active', 'className', 'clipped', 'permanentAt', 'pinned', 'theme']);

    var _className = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, theme.pinned, pinned), _defineProperty(_classnames, theme.clipped, clipped), _classnames), className);

    return _react2.default.createElement(Drawer, _extends({}, rest, {
      active: active || pinned,
      className: _className,
      insideTree: true,
      theme: theme,
      themeNamespace: 'sidebar',
      type: 'right',
      withOverlay: !pinned
    }));
  };

  Sidebar.propTypes = {
    active: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    clipped: _propTypes2.default.bool,
    permanentAt: _propTypes2.default.oneOf(['sm', 'smTablet', 'md', 'lg', 'lgTablet', 'xl', 'xxl', 'xxxl']),
    pinned: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      clipped: _propTypes2.default.string,
      pinned: _propTypes2.default.string
    }),
    width: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 25, 33, 50, 66, 75, 100])
  };

  Sidebar.defaultProps = {
    className: '',
    pinned: false,
    right: false
  };

  return Sidebar;
};

var Sidebar = factory(_Drawer2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.LAYOUT)(Sidebar);
exports.sidebarFactory = factory;
exports.Sidebar = Sidebar;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1796);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Overlay = __webpack_require__(475);

var _theme = __webpack_require__(1797);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedOverlay = (0, _reactCssThemr.themr)(_identifiers.OVERLAY, _theme2.default)(_Overlay.Overlay);
exports.default = ThemedOverlay;
exports.Overlay = ThemedOverlay;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactStyleProptype = __webpack_require__(478);

var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var factory = function factory(ripple) {
  var Check = function Check(_ref) {
    var checked = _ref.checked,
        children = _ref.children,
        onMouseDown = _ref.onMouseDown,
        theme = _ref.theme,
        style = _ref.style;
    return _react2.default.createElement(
      'div',
      {
        'data-react-toolbox': 'check',
        className: (0, _classnames3.default)(theme.check, _defineProperty({}, theme.checked, checked)),
        onMouseDown: onMouseDown,
        style: style
      },
      children
    );
  };

  Check.propTypes = {
    checked: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    onMouseDown: _propTypes2.default.func,
    style: _reactStyleProptype2.default,
    theme: _propTypes2.default.shape({
      check: _propTypes2.default.string,
      checked: _propTypes2.default.string
    })
  };

  return ripple(Check);
};

exports.default = factory;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1811);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./app-button.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./app-button.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _permanentStore = __webpack_require__(118);

var _permanentStore2 = _interopRequireDefault(_permanentStore);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/login-history.js

var KEY = 'gambaApp.login_history';
var store = (0, _permanentStore2.default)(KEY, []);

exports.default = {
  get: store.get,
  set: function set(user) {
    if (!user.email.match(/demo.*@getgamba.com/)) // デモ用アカウントは履歴に残さない
      store.get(function (histories) {
        var item = (0, _find2.default)(histories, function (item) {
          return item.email == user.email;
        });
        if (!item) {
          histories.push({ email: user.email, name: user.name });
          store.set(histories);
        }
      });
  }
};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _permanentStore = __webpack_require__(118);

var _permanentStore2 = _interopRequireDefault(_permanentStore);

var _difference = __webpack_require__(1820);

var _difference2 = _interopRequireDefault(_difference);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY = "gambaApp.mentions"; /**
                                * src/actions/mentions-store.js
                                * localStorageに対し、「読んでみて！」のリストを格納、取得、クリア
                                */

var store = (0, _permanentStore2.default)(KEY, []);

exports.default = {
  get: store.get,
  clear: store.clear,

  /**
   * 渡された「読んでみて」リストに、Storageから取得したリスト（前回Storageに格納しておいた「読んでみて」リスト）を
   * 追加したものを、Storageに格納する。
   */
  set: function set(mentions_list) {
    store.get(function (storage_list) {
      var storage_ids = (0, _difference2.default)(storage_list, mentions_list);
      (0, _each2.default)(storage_ids, function (user) {
        return mentions_list.push(user);
      });
      store.set(mentions_list);
    });
  }
};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1822);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 885 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(159),
    isObjectLike = __webpack_require__(117);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemText = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ListItemText = function ListItemText(_ref) {
  var className = _ref.className,
      primary = _ref.primary,
      children = _ref.children,
      theme = _ref.theme,
      other = _objectWithoutProperties(_ref, ['className', 'primary', 'children', 'theme']);

  var _className = (0, _classnames3.default)(theme.itemText, _defineProperty({}, theme.primary, primary), className);
  return _react2.default.createElement(
    'span',
    _extends({ 'data-react-toolbox': 'list-item-text', className: _className }, other),
    children
  );
};

ListItemText.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  primary: _propTypes2.default.bool,
  theme: _propTypes2.default.shape({
    itemText: _propTypes2.default.string,
    primary: _propTypes2.default.string
  })
};

ListItemText.defaultProps = {
  primary: false
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItemText);
exports.ListItemText = ListItemText;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemAction = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItemAction = function ListItemAction(_ref) {
  var action = _ref.action,
      theme = _ref.theme;
  var _action$props = action.props,
      onClick = _action$props.onClick,
      onMouseDown = _action$props.onMouseDown;

  var stopRipple = onClick && !onMouseDown;
  var stop = function stop(e) {
    return e.stopPropagation();
  };
  return _react2.default.createElement(
    'span',
    {
      className: theme.itemAction,
      onMouseDown: stopRipple && stop,
      onClick: onClick && stop
    },
    action
  );
};

ListItemAction.propTypes = {
  action: _propTypes2.default.node,
  theme: _propTypes2.default.shape({
    itemAction: _propTypes2.default.string
  })
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItemAction);
exports.ListItemAction = ListItemAction;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = exports.listItemFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _ListItemContent = __webpack_require__(343);

var _ListItemContent2 = _interopRequireDefault(_ListItemContent);

var _ListItemLayout = __webpack_require__(890);

var _ListItemLayout2 = _interopRequireDefault(_ListItemLayout);

var _Ripple = __webpack_require__(121);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(ripple, ListItemLayout, ListItemContent) {
  var ListItem = function (_Component) {
    _inherits(ListItem, _Component);

    function ListItem() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ListItem);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
        if (_this.props.onClick && !_this.props.disabled) {
          _this.props.onClick(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ListItem, [{
      key: 'groupChildren',
      value: function groupChildren() {
        var children = {
          leftActions: [],
          rightActions: [],
          ignored: []
        };

        _react2.default.Children.forEach(this.props.children, function (child, i) {
          if (!_react2.default.isValidElement(child)) {
            return undefined;
          }

          var _child$props = child.props,
              listItemIgnore = _child$props.listItemIgnore,
              rest = _objectWithoutProperties(_child$props, ['listItemIgnore']);

          var strippedChild = _extends({}, child, { props: rest });

          if (listItemIgnore) {
            children.ignored.push(strippedChild);
            return undefined;
          }
          if (child.type === ListItemContent) {
            children.itemContent = strippedChild;
            return undefined;
          }
          var bucket = children.itemContent ? 'rightActions' : 'leftActions';
          children[bucket].push(_extends({}, strippedChild, { key: i }));
          return undefined;
        });

        return children;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            hasRipple = _props.ripple,
            onClick = _props.onClick,
            onMouseDown = _props.onMouseDown,
            onTouchStart = _props.onTouchStart,
            theme = _props.theme,
            to = _props.to,
            other = _objectWithoutProperties(_props, ['className', 'ripple', 'onClick', 'onMouseDown', 'onTouchStart', 'theme', 'to']);

        var children = this.groupChildren();
        var content = _react2.default.createElement(ListItemLayout, _extends({ theme: theme }, children, other));
        return _react2.default.createElement(
          'li',
          {
            className: theme.listItem + ' ' + className,
            onClick: this.handleClick,
            onMouseDown: onMouseDown,
            onTouchStart: onTouchStart
          },
          to ? _react2.default.createElement(
            'a',
            { href: this.props.to },
            content
          ) : content,
          children.ignored
        );
      }
    }]);

    return ListItem;
  }(_react.Component);

  ListItem.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    hasRipple: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    onMouseDown: _propTypes2.default.func,
    onTouchStart: _propTypes2.default.func,
    ripple: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      listItem: _propTypes2.default.string
    }),
    to: _propTypes2.default.string
  };
  ListItem.defaultProps = {
    className: '',
    disabled: false,
    ripple: false
  };


  return ripple(ListItem);
};

var ripple = (0, _Ripple2.default)({ centered: false, listItemIgnore: true });
var ListItem = factory(ripple, _ListItemLayout2.default, _ListItemContent2.default);

exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItem);
exports.listItemFactory = factory;
exports.ListItem = ListItem;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemLayout = exports.listItemLayoutFactory = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _FontIcon = __webpack_require__(81);

var _Avatar = __webpack_require__(342);

var _Avatar2 = _interopRequireDefault(_Avatar);

var _ListItemContent = __webpack_require__(343);

var _ListItemContent2 = _interopRequireDefault(_ListItemContent);

var _ListItemActions = __webpack_require__(891);

var _ListItemActions2 = _interopRequireDefault(_ListItemActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var factory = function factory(Avatar, ListItemContent, ListItemActions) {
  var ListItemLayout = function ListItemLayout(props) {
    var _classnames;

    var className = (0, _classnames3.default)(props.theme.item, (_classnames = {}, _defineProperty(_classnames, props.theme.disabled, props.disabled), _defineProperty(_classnames, props.theme.selectable, props.selectable), _classnames), props.className);

    var leftActions = [props.leftIcon && _react2.default.createElement(_FontIcon.FontIcon, { value: props.leftIcon, key: 'leftIcon' }), props.avatar && _react2.default.createElement(Avatar, { image: props.avatar, key: 'avatar' })].concat(_toConsumableArray(props.leftActions));
    var rightActions = [props.rightIcon && _react2.default.createElement(_FontIcon.FontIcon, { value: props.rightIcon, key: 'rightIcon' })].concat(_toConsumableArray(props.rightActions));
    var emptyActions = function emptyActions(item) {
      return !item[0] && !item[1] && !item[2];
    };
    var content = props.itemContent || _react2.default.createElement(ListItemContent, {
      theme: props.theme,
      caption: props.caption,
      legend: props.legend
    });

    return _react2.default.createElement(
      'span',
      { className: className },
      !emptyActions(leftActions) > 0 && _react2.default.createElement(
        ListItemActions,
        { type: 'left', theme: props.theme },
        leftActions
      ),
      content,
      !emptyActions(rightActions) > 0 && _react2.default.createElement(
        ListItemActions,
        { type: 'right', theme: props.theme },
        rightActions
      )
    );
  };

  ListItemLayout.propTypes = {
    avatar: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    caption: _propTypes2.default.string,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    itemContent: _propTypes2.default.element,
    leftActions: _propTypes2.default.arrayOf(_propTypes2.default.node),
    leftIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    legend: _propTypes2.default.string,
    rightActions: _propTypes2.default.arrayOf(_propTypes2.default.node),
    rightIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    selectable: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      disabled: _propTypes2.default.string,
      item: _propTypes2.default.string,
      selectable: _propTypes2.default.string
    })
  };

  ListItemLayout.defaultProps = {
    disabled: false,
    selectable: false
  };

  return ListItemLayout;
};

var ListItemLayout = factory(_Avatar2.default, _ListItemContent2.default, _ListItemActions2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItemLayout);
exports.listItemLayoutFactory = factory;
exports.ListItemLayout = ListItemLayout;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemActions = exports.listItemActionsFactory = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _ListItemAction = __webpack_require__(888);

var _ListItemAction2 = _interopRequireDefault(_ListItemAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var factory = function factory(ListItemAction) {
  var ListItemActions = function ListItemActions(_ref) {
    var type = _ref.type,
        children = _ref.children,
        theme = _ref.theme;

    var validChildren = _react2.default.Children.toArray(children).filter(function (c) {
      return _react2.default.isValidElement(c);
    });

    return _react2.default.createElement(
      'span',
      { className: theme[type] },
      validChildren.map(function (action, i) {
        return _react2.default.createElement(ListItemAction, { key: i, theme: theme, action: action });
      }) // eslint-disable-line

    );
  };

  ListItemActions.propTypes = {
    children: _propTypes2.default.node,
    theme: _propTypes2.default.shape({
      left: _propTypes2.default.string,
      right: _propTypes2.default.string
    }),
    type: _propTypes2.default.oneOf(['left', 'right'])
  };

  return ListItemActions;
};

var ListItemActions = factory(_ListItemAction2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItemActions);
exports.listItemActionsFactory = factory;
exports.ListItemActions = ListItemActions;

/***/ }),
/* 892 */
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};


/***/ }),
/* 893 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
module.exports = isBuf;

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var eio = __webpack_require__(1859);
var Socket = __webpack_require__(484);
var Emitter = __webpack_require__(267);
var parser = __webpack_require__(480);
var on = __webpack_require__(901);
var bind = __webpack_require__(902);
var debug = __webpack_require__(344)('socket.io-client:manager');
var indexOf = __webpack_require__(900);
var Backoff = __webpack_require__(1878);

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  this.encoder = new parser.Encoder();
  this.decoder = new parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.engine.id;
    }
  }
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.engine.id;
    });

    if (this.autoConnect) {
      // manually call here since connecting evnet is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies
 */

var XMLHttpRequest = __webpack_require__(481);
var XHR = __webpack_require__(1863);
var JSONP = __webpack_require__(1873);
var websocket = __webpack_require__(1874);

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (global.location) {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Transport = __webpack_require__(482);
var parseqs = __webpack_require__(483);
var parser = __webpack_require__(225);
var inherit = __webpack_require__(345);
var yeast = __webpack_require__(899);
var debug = __webpack_require__(346)('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = __webpack_require__(481);
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/*
 * Module requirements.
 */

var isArray = __webpack_require__(1865);

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Right now only Buffer and ArrayBuffer are supported..
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary(data) {

  function _hasBinary(obj) {
    if (!obj) return false;

    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
         (global.Blob && obj instanceof Blob) ||
         (global.File && obj instanceof File)
        ) {
      return true;
    }

    if (isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
          if (_hasBinary(obj[i])) {
              return true;
          }
      }
    } else if (obj && 'object' == typeof obj) {
      // see: https://github.com/Automattic/has-binary/pull/4
      if (obj.toJSON && 'function' == typeof obj.toJSON) {
        obj = obj.toJSON();
      }

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
          return true;
        }
      }
    }

    return false;
  }

  return _hasBinary(data);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;


/***/ }),
/* 900 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 901 */
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}


/***/ }),
/* 902 */
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(252),
    isArrayLike = __webpack_require__(159);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Component) {
  var WindowFocusComponent = function (_React$Component) {
    _inherits(WindowFocusComponent, _React$Component);

    function WindowFocusComponent() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WindowFocusComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WindowFocusComponent.__proto__ || Object.getPrototypeOf(WindowFocusComponent)).call.apply(_ref, [this].concat(args))), _this), _this.lastTime = new Date().getTime(), _this.lastFocus = new Date().getTime(), _this.timer = setInterval(function () {
        var currentTime = new Date().getTime();
        if (currentTime > _this.lastTime + WAKEUP_INTERVAL * 1.5) {
          // 本来ならcurrentTimeとlastTimeとの差はWAKEUP_INTERVAL秒以内になるはず、
          // PCがスリープして復帰するとWAKEUP_INTERVAL秒よりも時間が長くになることを検出する
          _this.props.onWindowFocus && setTimeout(function () {
            return _this.props.onWindowFocus(_this.props);
          }, 5000);
        }
        _this.lastTime = currentTime;
      }, WAKEUP_INTERVAL), _this.onWindowFocus = function () {
        var currentTime = new Date().getTime();
        if (currentTime - _this.lastFocus > RESUME_INTERVAL) _this.props.onWindowFocus && setTimeout(function () {
          return _this.props.onWindowFocus(_this.props);
        }, 5000);
      }, _this.onWindowBlur = function () {
        _this.lastFocus = new Date().getTime();
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WindowFocusComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('focus', this.onWindowFocus);
        window.addEventListener('blur', this.onWindowBlur);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.timer && clearInterval(this.timer);
        window.removeEventListener('focus', this.onWindowFocus);
        window.removeEventListener('blur', this.onWindowBlur);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, this.props);
      }
    }]);

    return WindowFocusComponent;
  }(_react2.default.Component);

  WindowFocusComponent.displayName = 'WindowFocus(' + Component.displayName + ')';
  return WindowFocusComponent;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/helpers/window-focus.js

var WAKEUP_INTERVAL = 3 * 60 * 1000;
var RESUME_INTERVAL = 3 * 60 * 1000;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = exports.menuItemFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _FontIcon = __webpack_require__(81);

var _Ripple = __webpack_require__(121);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(ripple) {
  var MenuItem = function (_Component) {
    _inherits(MenuItem, _Component);

    function MenuItem() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, MenuItem);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
        if (_this.props.onClick && !_this.props.disabled) {
          _this.props.onClick(event, _this);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MenuItem, [{
      key: 'render',
      value: function render() {
        var _classnames;

        var _props = this.props,
            caption = _props.caption,
            children = _props.children,
            disabled = _props.disabled,
            icon = _props.icon,
            selected = _props.selected,
            shortcut = _props.shortcut,
            theme = _props.theme,
            others = _objectWithoutProperties(_props, ['caption', 'children', 'disabled', 'icon', 'selected', 'shortcut', 'theme']);

        var className = (0, _classnames3.default)(theme.menuItem, (_classnames = {}, _defineProperty(_classnames, theme.selected, selected), _defineProperty(_classnames, theme.disabled, disabled), _classnames), this.props.className);

        return _react2.default.createElement(
          'li',
          _extends({}, others, {
            'data-react-toolbox': 'menu-item',
            className: className,
            onClick: this.handleClick
          }),
          icon ? _react2.default.createElement(_FontIcon.FontIcon, { value: icon, className: theme.icon }) : null,
          _react2.default.createElement(
            'span',
            { className: theme.caption },
            caption
          ),
          shortcut ? _react2.default.createElement(
            'small',
            { className: theme.shortcut },
            shortcut
          ) : null,
          children
        );
      }
    }]);

    return MenuItem;
  }(_react.Component);

  MenuItem.propTypes = {
    caption: _propTypes2.default.string,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    onClick: _propTypes2.default.func,
    selected: _propTypes2.default.bool,
    shortcut: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
      caption: _propTypes2.default.string,
      disabled: _propTypes2.default.string,
      icon: _propTypes2.default.string,
      menuItem: _propTypes2.default.string,
      selected: _propTypes2.default.string,
      shortcut: _propTypes2.default.string
    })
  };
  MenuItem.defaultProps = {
    className: '',
    disabled: false,
    selected: false
  };


  return ripple(MenuItem);
};

var MenuItem = factory((0, _Ripple2.default)({}));
exports.default = (0, _reactCssThemr.themr)(_identifiers.MENU)(MenuItem);
exports.menuItemFactory = factory;
exports.MenuItem = MenuItem;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = exports.menuFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _utils = __webpack_require__(1883);

var _utils2 = __webpack_require__(106);

var _MenuItem = __webpack_require__(905);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POSITION = {
  AUTO: 'auto',
  STATIC: 'static',
  TOP_LEFT: 'topLeft',
  TOP_RIGHT: 'topRight',
  BOTTOM_LEFT: 'bottomLeft',
  BOTTOM_RIGHT: 'bottomRight'
};

var factory = function factory(MenuItem) {
  var Menu = function (_Component) {
    _inherits(Menu, _Component);

    function Menu() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Menu);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: _this.props.active,
        rippled: false
      }, _this.handleDocumentClick = function (event) {
        if (_this.state.active && !_utils.events.targetIsDescendant(event, _reactDom2.default.findDOMNode(_this))) {
          _this.setState({ active: false, rippled: false });
        }
      }, _this.handleSelect = function (item, event) {
        var _item$props = item.props,
            value = _item$props.value,
            onClick = _item$props.onClick;

        if (onClick) event.persist();
        _this.setState({ active: false, rippled: _this.props.ripple }, function () {
          if (onClick) onClick(event);
          if (_this.props.onSelect) _this.props.onSelect(value);
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Menu, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.positionTimeoutHandle = setTimeout(function () {
          var _menuNode$getBounding = _this2.menuNode.getBoundingClientRect(),
              width = _menuNode$getBounding.width,
              height = _menuNode$getBounding.height;

          var position = _this2.props.position === POSITION.AUTO ? _this2.calculatePosition() : _this2.props.position;
          _this2.setState({ position: position, width: width, height: height });
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        if (this.props.position !== nextProps.position) {
          var position = nextProps.position === POSITION.AUTO ? this.calculatePosition() : nextProps.position;
          this.setState({ position: position });
        }

        /**
         * If the menu is going to be activated via props and its not active, verify
         * the position is appropriated and then show it recalculating position if its
         * wrong. It should be shown in two consecutive setState.
         */
        if (!this.props.active && nextProps.active && !this.state.active) {
          if (nextProps.position === POSITION.AUTO) {
            var _position = this.calculatePosition();
            if (this.state.position !== _position) {
              this.setState({ position: _position, active: false }, function () {
                _this3.activateTimeoutHandle = setTimeout(function () {
                  _this3.show();
                }, 20);
              });
            } else {
              this.show();
            }
          } else {
            this.show();
          }
        }

        /**
         * If the menu is being deactivated via props and the current state is
         * active, it should be hid.
         */
        if (this.props.active && !nextProps.active && this.state.active) {
          this.hide();
        }
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        if (!this.state.active && nextState.active) {
          _utils.events.addEventsToDocument({
            click: this.handleDocumentClick,
            touchstart: this.handleDocumentClick
          });
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevState.active && !this.state.active) {
          if (this.props.onHide) this.props.onHide();
          _utils.events.removeEventsFromDocument({
            click: this.handleDocumentClick,
            touchstart: this.handleDocumentClick
          });
        } else if (!prevState.active && this.state.active && this.props.onShow) {
          this.props.onShow();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.state.active) {
          _utils.events.removeEventsFromDocument({
            click: this.handleDocumentClick,
            touchstart: this.handleDocumentClick
          });
        }
        clearTimeout(this.positionTimeoutHandle);
        clearTimeout(this.activateTimeoutHandle);
      }
    }, {
      key: 'getMenuStyle',
      value: function getMenuStyle() {
        var _state = this.state,
            width = _state.width,
            height = _state.height,
            position = _state.position;

        if (position !== POSITION.STATIC) {
          if (this.state.active) {
            return { clip: 'rect(0 ' + width + 'px ' + height + 'px 0)' };
          } else if (position === POSITION.TOP_RIGHT) {
            return { clip: 'rect(0 ' + width + 'px 0 ' + width + 'px)' };
          } else if (position === POSITION.BOTTOM_RIGHT) {
            return {
              clip: 'rect(' + height + 'px ' + width + 'px ' + height + 'px ' + width + 'px)'
            };
          } else if (position === POSITION.BOTTOM_LEFT) {
            return { clip: 'rect(' + height + 'px 0 ' + height + 'px 0)' };
          } else if (position === POSITION.TOP_LEFT) {
            return { clip: 'rect(0 0 0 0)' };
          }
        }

        return undefined;
      }
    }, {
      key: 'getRootStyle',
      value: function getRootStyle() {
        return this.state.position !== POSITION.STATIC ? { width: this.state.width, height: this.state.height } : undefined;
      }
    }, {
      key: 'calculatePosition',
      value: function calculatePosition() {
        var parentNode = _reactDom2.default.findDOMNode(this).parentNode;
        if (!parentNode) return undefined;

        var _parentNode$getBoundi = parentNode.getBoundingClientRect(),
            top = _parentNode$getBoundi.top,
            left = _parentNode$getBoundi.left,
            height = _parentNode$getBoundi.height,
            width = _parentNode$getBoundi.width;

        var _getViewport = (0, _utils2.getViewport)(),
            wh = _getViewport.height,
            ww = _getViewport.width;

        var toTop = top < wh / 2 - height / 2;
        var toLeft = left < ww / 2 - width / 2;
        return '' + (toTop ? 'top' : 'bottom') + (toLeft ? 'Left' : 'Right');
      }
    }, {
      key: 'show',
      value: function show() {
        var _menuNode$getBounding2 = this.menuNode.getBoundingClientRect(),
            width = _menuNode$getBounding2.width,
            height = _menuNode$getBounding2.height;

        this.setState({ active: true, width: width, height: height });
      }
    }, {
      key: 'hide',
      value: function hide() {
        this.setState({ active: false });
      }
    }, {
      key: 'renderItems',
      value: function renderItems() {
        var _this4 = this;

        return _react2.default.Children.map(this.props.children, function (item) {
          if (!item) return item;
          if (item.type === MenuItem) {
            return _react2.default.cloneElement(item, {
              ripple: item.props.ripple || _this4.props.ripple,
              selected: typeof item.props.value !== 'undefined' && _this4.props.selectable && item.props.value === _this4.props.selected,
              onClick: _this4.handleSelect.bind(_this4, item)
            });
          }
          return _react2.default.cloneElement(item);
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _classnames,
            _this5 = this;

        var theme = this.props.theme;

        var outlineStyle = {
          width: this.state.width,
          height: this.state.height
        };
        var className = (0, _classnames3.default)([theme.menu, theme[this.state.position]], (_classnames = {}, _defineProperty(_classnames, theme.active, this.state.active), _defineProperty(_classnames, theme.rippled, this.state.rippled), _classnames), this.props.className);

        return _react2.default.createElement(
          'div',
          {
            'data-react-toolbox': 'menu',
            className: className,
            style: this.getRootStyle()
          },
          this.props.outline ? _react2.default.createElement('div', { className: theme.outline, style: outlineStyle }) : null,
          _react2.default.createElement(
            'ul',
            {
              ref: function ref(node) {
                _this5.menuNode = node;
              },
              className: theme.menuInner,
              style: this.getMenuStyle()
            },
            this.renderItems()
          )
        );
      }
    }]);

    return Menu;
  }(_react.Component);

  Menu.propTypes = {
    active: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    onHide: _propTypes2.default.func,
    onSelect: _propTypes2.default.func,
    onShow: _propTypes2.default.func,
    outline: _propTypes2.default.bool,
    position: _propTypes2.default.oneOf(Object.keys(POSITION).map(function (key) {
      return POSITION[key];
    })),
    ripple: _propTypes2.default.bool,
    selectable: _propTypes2.default.bool,
    selected: _propTypes2.default.node,
    theme: _propTypes2.default.shape({
      active: _propTypes2.default.string,
      bottomLeft: _propTypes2.default.string,
      bottomRight: _propTypes2.default.string,
      menu: _propTypes2.default.string,
      menuInner: _propTypes2.default.string,
      outline: _propTypes2.default.string,
      rippled: _propTypes2.default.string,
      static: _propTypes2.default.string,
      topLeft: _propTypes2.default.string,
      topRight: _propTypes2.default.string
    })
  };
  Menu.defaultProps = {
    active: false,
    outline: true,
    position: POSITION.STATIC,
    ripple: true,
    selectable: true
  };


  return Menu;
};

var Menu = factory(_MenuItem2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.MENU)(Menu);
exports.menuFactory = factory;
exports.Menu = Menu;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(434),
    arrayIncludes = __webpack_require__(884),
    arrayIncludesWith = __webpack_require__(885),
    cacheHas = __webpack_require__(435),
    createSet = __webpack_require__(1889),
    setToArray = __webpack_require__(436);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(316),
    baseFlatten = __webpack_require__(340),
    copyArray = __webpack_require__(487),
    isArray = __webpack_require__(62);

/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}

module.exports = concat;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1893);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./compact-input.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./compact-input.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _avatar = __webpack_require__(26);

var _cardTitleRightActions = __webpack_require__(911);

var _cardTitleRightActions2 = _interopRequireDefault(_cardTitleRightActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CardTitleRightActions = function CardTitleRightActions(_ref) {
  var avatar = _ref.avatar,
      onAvatarClick = _ref.onAvatarClick,
      children = _ref.children,
      rightActions = _ref.rightActions,
      className = _ref.className,
      subtitle = _ref.subtitle,
      theme = _ref.theme,
      title = _ref.title,
      other = _objectWithoutProperties(_ref, ['avatar', 'onAvatarClick', 'children', 'rightActions', 'className', 'subtitle', 'theme', 'title']);

  var classes = (0, _classnames2.default)(theme.cardTitle, className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, other),
    _react2.default.createElement(_avatar.Avatar, { image: avatar, theme: theme, onClick: onAvatarClick }),
    _react2.default.createElement(
      'div',
      { className: theme.content },
      title && _react2.default.createElement(
        'h5',
        { className: theme.title },
        title
      ),
      children && typeof children === 'string' && _react2.default.createElement(
        'h5',
        { className: theme.title },
        children
      ),
      subtitle && _react2.default.createElement(
        'div',
        { className: theme.subtitle },
        subtitle
      ),
      children && typeof children !== 'string' && children
    ),
    _react2.default.createElement(
      'div',
      { className: theme.rightIcons },
      rightActions
    )
  );
};

CardTitleRightActions.propTypes = {
  avatar: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.array]),
  className: _propTypes2.default.string,
  subtitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.array]),
  theme: _propTypes2.default.shape({
    large: _propTypes2.default.string,
    title: _propTypes2.default.string,
    small: _propTypes2.default.string,
    subtitle: _propTypes2.default.string
  }),
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};

exports.default = (0, _reactCssThemr.themr)('CardTitleRightActions', _cardTitleRightActions2.default)(CardTitleRightActions);

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1896);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./card-title-right-actions.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./card-title-right-actions.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupFormPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupFormPanel = __webpack_require__(1909);

var _groupFormPanel2 = _interopRequireDefault(_groupFormPanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _input = __webpack_require__(59);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _reactRangeslider = __webpack_require__(348);

var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);

__webpack_require__(349);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _fileUploadButton = __webpack_require__(180);

var _fileUploadButton2 = _interopRequireDefault(_fileUploadButton);

var _richTextEditor = __webpack_require__(181);

var _richTextEditor2 = _interopRequireDefault(_richTextEditor);

var _formValidator = __webpack_require__(41);

var _reactAvatarEditor = __webpack_require__(352);

var _reactAvatarEditor2 = _interopRequireDefault(_reactAvatarEditor);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-form-panel.jsx

// import Slider from 'react-toolbox/lib/slider' Slide in React Toolbx is buggy...


function calcCrop(avatar) {
  if (!avatar) return undefined;

  var rect = avatar.getCroppingRect();
  var width = avatar.state.image.resource.width;
  var height = avatar.state.image.resource.height;
  //console.log(`rect x:${rect.x} y:${rect.y} w:${rect.width} h:${rect.height}, image: w:${width} h:${height}`)
  //console.log(`calc x:${width * rect.x} y:${height * rect.y} w:${width * rect.width} h:${height * rect.height}`)

  return {
    x: width * rect.x,
    y: height * rect.y,
    width: width * rect.width,
    height: height * rect.height
  };
}

function dropdownTemplate(item) {
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', flexDirection: 'row' } },
    _react2.default.createElement(_font_icon2.default, { value: item.icon, style: { verticalAlign: 'middle' } }),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', flexDirection: 'column', marginLeft: 5 } },
      _react2.default.createElement(
        'strong',
        null,
        item.label
      ),
      _react2.default.createElement(
        'small',
        null,
        item.description
      )
    )
  );
}

var GroupFormPanel = function (_React$Component) {
  _inherits(GroupFormPanel, _React$Component);

  function GroupFormPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GroupFormPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupFormPanel.__proto__ || Object.getPrototypeOf(GroupFormPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = { scale: 1.5 }, _this.onChange = function () {
      return _this.props.updateUI({ cancelRemindMail: !_this.props.ui.cancelRemindMail });
    }, _this.onChangeLocale = function (locale) {
      return _this.props.updateUI({ locale: locale });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GroupFormPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          isUpdating = _props.isUpdating,
          group = _props.group,
          updateUI = _props.updateUI,
          uploadFile = _props.uploadFile,
          uploadedFile = _props.uploadedFile,
          validateAndSubmit = _props.validateAndSubmit,
          isUploading = _props.isUploading;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return validateAndSubmit(_this2.props, calcCrop(_this2.refs.avatar), e);
            } },
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:グループ名')
              )
            ),
            _react2.default.createElement(_input.Input, { name: 'groupName', required: true,
              label: t('label:グループ名'),
              value: ui.name,
              icon: 'person',
              error: ui.nameError && t('error:グループ名を入力してください'),
              onChange: (0, _formValidator.linkUI)(this, 'name') })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:グループの公開範囲')
              )
            ),
            _react2.default.createElement(_dropdown2.default, { auto: true,
              source: [{ value: 'public_access', icon: 'lock_open', label: t('label:公開グループ'), description: t('label:公開グループの説明') }, { value: 'private_access', icon: 'lock_outline', label: t('label:非公開グループ'), description: t('label:非公開グループの説明') }],
              template: dropdownTemplate,
              value: ui.access_type,
              onChange: function onChange(access_type) {
                return updateUI({ access_type: access_type });
              } })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:言語')
              )
            ),
            _react2.default.createElement(_dropdown2.default, { auto: true,
              source: [{ value: 'ja' }, { value: 'en' }],
              template: function template(item) {
                return _react2.default.createElement(
                  'span',
                  null,
                  t('language:' + item.value)
                );
              },
              value: ui.locale,
              onChange: this.onChangeLocale })
          ),
          !group && _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(_checkbox2.default, { className: _flatCard2.default.checkbox,
              checked: ui.cancelRemindMail,
              label: t('label:すべてのリマインド通知を送らない'),
              onChange: this.onChange })
          ),
          group && _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:アイコン画像')
              )
            ),
            _react2.default.createElement('br', null),
            !uploadedFile && !isUploading && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('img', { style: { width: 100, height: 100, borderRadius: '50%' }, src: group.icon_image.thumb_url })
            ),
            uploadedFile && !isUploading && uploadedFile.file && _react2.default.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'column', width: 210 } },
              _react2.default.createElement(_reactAvatarEditor2.default, { ref: 'avatar',
                image: uploadedFile.file.thumb_url,
                width: 200,
                height: 200,
                border: 5,
                scale: this.state.scale,
                style: { cursor: 'move' } }),
              _react2.default.createElement(_reactRangeslider2.default, {
                min: 1,
                max: 5,
                step: 0.05,
                tooltip: false,
                value: this.state.scale,
                onChange: function onChange(value) {
                  return _this2.setState({ scale: value });
                } })
            ),
            isUploading && _react2.default.createElement(
              'div',
              { style: { height: '100%', width: '100%', display: 'flex', justifyContent: 'flex-start', marginLeft: '10px' } },
              _react2.default.createElement(_progress_bar2.default, { type: 'circular', multicolor: true, mode: 'indeterminate' })
            ),
            _react2.default.createElement(_fileUploadButton2.default, { raised: true,
              icon: 'add_a_photo',
              label: '\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E',
              single: true,
              onChange: function onChange(file) {
                return uploadFile(_this2.props, file);
              } })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:グループのミッション')
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_richTextEditor2.default, {
              placeholder: t('label:ミッションを入力してください'),
              onEditorInitialized: function onEditorInitialized(handlers) {
                updateUI({ handlers: handlers });
                group && group.description && setTimeout(function () {
                  return handlers.insertValue(group.description);
                }, 0);
              } })
          ),
          _react2.default.createElement(
            _card.CardActions,
            null,
            _react2.default.createElement(_button.Button, { raised: true, primary: true,
              type: 'submit',
              disabled: isUpdating,
              style: { width: '100%' },
              label: t(group ? 'label:更新' : 'label:新規作成') })
          )
        )
      );
    }
  }]);

  return GroupFormPanel;
}(_react2.default.Component);

var RawGroupFormPanel = exports.RawGroupFormPanel = GroupFormPanel;
exports.default = (0, _groupFormPanel2.default)(GroupFormPanel);

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _prefixer = __webpack_require__(336);

var _prefixer2 = _interopRequireDefault(_prefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressBar = function (_Component) {
  _inherits(ProgressBar, _Component);

  function ProgressBar() {
    _classCallCheck(this, ProgressBar);

    return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).apply(this, arguments));
  }

  _createClass(ProgressBar, [{
    key: 'calculateRatio',
    value: function calculateRatio(value) {
      if (value < this.props.min) return 0;
      if (value > this.props.max) return 1;
      return (value - this.props.min) / (this.props.max - this.props.min);
    }
  }, {
    key: 'circularStyle',
    value: function circularStyle() {
      return this.props.mode !== 'indeterminate' ? {
        strokeDasharray: 2 * Math.PI * 25 * this.calculateRatio(this.props.value) + ', 400'
      } : undefined;
    }
  }, {
    key: 'linearStyle',
    value: function linearStyle() {
      if (this.props.mode !== 'indeterminate') {
        return {
          buffer: (0, _prefixer2.default)({
            transform: 'scaleX(' + this.calculateRatio(this.props.buffer) + ')'
          }),
          value: (0, _prefixer2.default)({
            transform: 'scaleX(' + this.calculateRatio(this.props.value) + ')'
          })
        };
      }
      return {};
    }
  }, {
    key: 'renderCircular',
    value: function renderCircular() {
      return _react2.default.createElement(
        'svg',
        { className: this.props.theme.circle, viewBox: '0 0 60 60' },
        _react2.default.createElement('circle', {
          className: this.props.theme.path,
          style: this.circularStyle(),
          cx: '30',
          cy: '30',
          r: '25'
        })
      );
    }
  }, {
    key: 'renderLinear',
    value: function renderLinear() {
      var _linearStyle = this.linearStyle(),
          buffer = _linearStyle.buffer,
          value = _linearStyle.value;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('span', {
          'data-ref': 'buffer',
          className: this.props.theme.buffer,
          style: buffer
        }),
        _react2.default.createElement('span', {
          'data-ref': 'value',
          className: this.props.theme.value,
          style: value
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          max = _props.max,
          min = _props.min,
          mode = _props.mode,
          multicolor = _props.multicolor,
          type = _props.type,
          theme = _props.theme,
          value = _props.value;

      var _className = (0, _classnames3.default)(theme[type], (_classnames = {}, _defineProperty(_classnames, theme[mode], mode), _defineProperty(_classnames, theme.multicolor, multicolor), _classnames), className);

      return _react2.default.createElement(
        'div',
        {
          disabled: disabled,
          'data-react-toolbox': 'progress-bar',
          'aria-valuenow': value,
          'aria-valuemin': min,
          'aria-valuemax': max,
          className: _className
        },
        type === 'circular' ? this.renderCircular() : this.renderLinear()
      );
    }
  }]);

  return ProgressBar;
}(_react.Component);

ProgressBar.propTypes = {
  buffer: _propTypes2.default.number,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  max: _propTypes2.default.number,
  min: _propTypes2.default.number,
  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
  multicolor: _propTypes2.default.bool,
  theme: _propTypes2.default.shape({
    buffer: _propTypes2.default.string,
    circle: _propTypes2.default.string,
    circular: _propTypes2.default.string,
    indeterminate: _propTypes2.default.string,
    linear: _propTypes2.default.string,
    multicolor: _propTypes2.default.string,
    path: _propTypes2.default.string,
    value: _propTypes2.default.string
  }),
  type: _propTypes2.default.oneOf(['linear', 'circular']),
  value: _propTypes2.default.number
};
ProgressBar.defaultProps = {
  buffer: 0,
  className: '',
  max: 100,
  min: 0,
  mode: 'indeterminate',
  multicolor: false,
  type: 'linear',
  value: 0
};
exports.default = (0, _reactCssThemr.themr)(_identifiers.PROGRESS_BAR)(ProgressBar);
exports.ProgressBar = ProgressBar;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _FontIcon = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Link = function Link(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      count = _ref.count,
      icon = _ref.icon,
      label = _ref.label,
      theme = _ref.theme,
      others = _objectWithoutProperties(_ref, ['active', 'children', 'className', 'count', 'icon', 'label', 'theme']);

  var _className = (0, _classnames3.default)(theme.link, _defineProperty({}, theme.active, active), className);

  return _react2.default.createElement(
    'a',
    _extends({ 'data-react-toolbox': 'link', className: _className }, others),
    icon ? _react2.default.createElement(_FontIcon.FontIcon, { className: theme.icon, value: icon }) : null,
    label ? _react2.default.createElement(
      'abbr',
      null,
      label
    ) : null,
    count && parseInt(count, 10) !== 0 ? _react2.default.createElement(
      'small',
      null,
      count
    ) : null,
    children
  );
};

Link.propTypes = {
  active: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  count: _propTypes2.default.number,
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  label: _propTypes2.default.string,
  theme: _propTypes2.default.shape({
    active: _propTypes2.default.string,
    icon: _propTypes2.default.string,
    link: _propTypes2.default.string
  })
};

Link.defaultProps = {
  active: false,
  className: ''
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.LINK)(Link);
exports.Link = Link;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = exports.merge = exports.$ = exports.style = exports.presets = exports.keyframes = exports.fontFace = exports.insertGlobal = exports.insertRule = exports.plugins = exports.styleSheet = undefined;
exports.speedy = speedy;
exports.simulations = simulations;
exports.simulate = simulate;
exports.cssLabels = cssLabels;
exports.isLikeRule = isLikeRule;
exports.idFor = idFor;
exports.css = css;
exports.rehydrate = rehydrate;
exports.flush = flush;
exports.select = select;
exports.parent = parent;
exports.media = media;
exports.pseudo = pseudo;
exports.active = active;
exports.any = any;
exports.checked = checked;
exports.disabled = disabled;
exports.empty = empty;
exports.enabled = enabled;
exports._default = _default;
exports.first = first;
exports.firstChild = firstChild;
exports.firstOfType = firstOfType;
exports.fullscreen = fullscreen;
exports.focus = focus;
exports.hover = hover;
exports.indeterminate = indeterminate;
exports.inRange = inRange;
exports.invalid = invalid;
exports.lastChild = lastChild;
exports.lastOfType = lastOfType;
exports.left = left;
exports.link = link;
exports.onlyChild = onlyChild;
exports.onlyOfType = onlyOfType;
exports.optional = optional;
exports.outOfRange = outOfRange;
exports.readOnly = readOnly;
exports.readWrite = readWrite;
exports.required = required;
exports.right = right;
exports.root = root;
exports.scope = scope;
exports.target = target;
exports.valid = valid;
exports.visited = visited;
exports.dir = dir;
exports.lang = lang;
exports.not = not;
exports.nthChild = nthChild;
exports.nthLastChild = nthLastChild;
exports.nthLastOfType = nthLastOfType;
exports.nthOfType = nthOfType;
exports.after = after;
exports.before = before;
exports.firstLetter = firstLetter;
exports.firstLine = firstLine;
exports.selection = selection;
exports.backdrop = backdrop;
exports.placeholder = placeholder;
exports.cssFor = cssFor;
exports.attribsFor = attribsFor;

var _objectAssign = __webpack_require__(80);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _sheet = __webpack_require__(1936);

var _CSSPropertyOperations = __webpack_require__(916);

var _clean = __webpack_require__(1944);

var _clean2 = _interopRequireDefault(_clean);

var _plugins = __webpack_require__(1945);

var _hash = __webpack_require__(1962);

var _hash2 = _interopRequireDefault(_hash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* stylesheet */


var styleSheet = exports.styleSheet = new _sheet.StyleSheet();
// an isomorphic StyleSheet shim. hides all the nitty gritty.

// /**************** LIFTOFF IN 3... 2... 1... ****************/
styleSheet.inject(); //eslint-disable-line indent
// /****************      TO THE MOOOOOOON     ****************/

// convenience function to toggle speedy
function speedy(bool) {
  return styleSheet.speedy(bool);
}

// plugins
// we include these by default
var plugins = exports.plugins = styleSheet.plugins = new _plugins.PluginSet([_plugins.prefixes, _plugins.contentWrap, _plugins.fallbacks]);
plugins.media = new _plugins.PluginSet(); // neat! media, font-face, keyframes
plugins.fontFace = new _plugins.PluginSet();
plugins.keyframes = new _plugins.PluginSet([_plugins.prefixes, _plugins.fallbacks]);

// define some constants

var isDev = "production" === 'development' || !"production";
var isTest = "production" === 'test';
var isBrowser = typeof window !== 'undefined';

/**** simulations  ****/

// a flag to enable simulation meta tags on dom nodes
// defaults to true in dev mode. recommend *not* to
// toggle often.
var canSimulate = isDev;

// we use these flags for issuing warnings when simulate is called
// in prod / in incorrect order
var warned1 = false,
    warned2 = false;

// toggles simulation activity. shouldn't be needed in most cases
function simulations() {
  var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  canSimulate = !!bool;
}

// use this on dom nodes to 'simulate' pseudoclasses
// <div {...hover({ color: 'red' })} {...simulate('hover', 'visited')}>...</div>
// you can even send in some weird ones, as long as it's in simple format
// and matches an existing rule on the element
// eg simulate('nthChild2', ':hover:active') etc
function simulate() {
  for (var _len = arguments.length, pseudos = Array(_len), _key = 0; _key < _len; _key++) {
    pseudos[_key] = arguments[_key];
  }

  pseudos = (0, _clean2.default)(pseudos);
  if (!pseudos) return {};
  if (!canSimulate) {
    if (!warned1) {
      console.warn('can\'t simulate without once calling simulations(true)'); //eslint-disable-line no-console
      warned1 = true;
    }
    if (!isDev && !isTest && !warned2) {
      console.warn('don\'t use simulation outside dev'); //eslint-disable-line no-console
      warned2 = true;
    }
    return {};
  }
  return pseudos.reduce(function (o, p) {
    return o['data-simulate-' + simple(p)] = '', o;
  }, {});
}

/**** labels ****/
// toggle for debug labels.
// *shouldn't* have to mess with this manually
var hasLabels = isDev;

function cssLabels(bool) {
  hasLabels = !!bool;
}

// takes a string, converts to lowercase, strips out nonalphanumeric.
function simple(str) {
  var char = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return str.toLowerCase().replace(/[^a-z0-9]/g, char);
}

// hashes a string to something 'unique'
// we use this to generate ids for styles


function hashify(obj) {
  var str = JSON.stringify(obj);
  var toRet = (0, _hash2.default)(str).toString(36);
  if (obj.label && obj.label.length > 0 && isDev) {
    return simple(obj.label.join('.'), '-') + '-' + toRet;
  }
  return toRet;
}

// of shape { 'data-css-<id>': '' }
function isLikeRule(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) {
    return false;
  }
  return !!/data\-css\-([a-zA-Z0-9\-_]+)/.exec(keys[0]);
}

// extracts id from a { 'data-css-<id>': ''} like object
function idFor(rule) {
  var keys = Object.keys(rule).filter(function (x) {
    return x !== 'toString';
  });
  if (keys.length !== 1) throw new Error('not a rule');
  var regex = /data\-css\-([a-zA-Z0-9\-_]+)/;
  var match = regex.exec(keys[0]);
  if (!match) throw new Error('not a rule');
  return match[1];
}

// from https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61

// "Tokenizes" the selectors into parts relevant for the next function.
// Strings and comments are matched, but ignored afterwards.
// This is not a full tokenizers. It only recognizes comas, parentheses,
// strings and comments.
// regexp generated by scripts/regexps.js then trimmed by hand
var selectorTokenizer = /[(),]|"(?:\\.|[^"\n])*"|'(?:\\.|[^'\n])*'|\/\*[\s\S]*?\*\//g;

/**
 * This will split a coma-separated selector list into individual selectors,
 * ignoring comas in strings, comments and in :pseudo-selectors(parameter, lists).
 *
 * @param {string} selector
 * @return {string[]}
 */

function splitSelector(selector) {
  if (selector.indexOf(',') === -1) {
    return [selector];
  }

  var indices = [],
      res = [],
      inParen = 0,
      o;
  /*eslint-disable no-cond-assign*/
  while (o = selectorTokenizer.exec(selector)) {
    /*eslint-enable no-cond-assign*/
    switch (o[0]) {
      case '(':
        inParen++;break;
      case ')':
        inParen--;break;
      case ',':
        if (inParen) break;indices.push(o.index);
    }
  }
  for (o = indices.length; o--;) {
    res.unshift(selector.slice(indices[o] + 1));
    selector = selector.slice(0, indices[o]);
  }
  res.unshift(selector);
  return res;
}

function selector(id, path) {
  if (!id) {
    return path.replace(/\&/g, '');
  }
  if (!path) return '.css-' + id + ',[data-css-' + id + ']';

  var x = splitSelector(path).map(function (x) {
    return x.indexOf('&') >= 0 ? [x.replace(/\&/mg, '.css-' + id), x.replace(/\&/mg, '[data-css-' + id + ']')].join(',') // todo - make sure each sub selector has an &
    : '.css-' + id + x + ',[data-css-' + id + ']' + x;
  }).join(',');

  if (canSimulate && /^\&\:/.exec(path) && !/\s/.exec(path)) {
    x += ',.css-' + id + '[data-simulate-' + simple(path) + '],[data-css-' + id + '][data-simulate-' + simple(path) + ']';
  }
  return x;
}

// end https://github.com/j2css/j2c/blob/5d381c2d721d04b54fabe6a165d587247c3087cb/src/helpers.js#L28-L61


function toCSS(_ref) {
  var selector = _ref.selector,
      style = _ref.style;

  var result = plugins.transform({ selector: selector, style: style });
  return result.selector + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
}

function deconstruct(style) {
  // we can be sure it's not infinitely nested here
  var plain = void 0,
      selects = void 0,
      medias = void 0,
      supports = void 0;
  Object.keys(style).forEach(function (key) {
    if (key.indexOf('&') >= 0) {
      selects = selects || {};
      selects[key] = style[key];
    } else if (key.indexOf('@media') === 0) {
      medias = medias || {};
      medias[key] = deconstruct(style[key]);
    } else if (key.indexOf('@supports') === 0) {
      supports = supports || {};
      supports[key] = deconstruct(style[key]);
    } else if (key === 'label') {
      if (style.label.length > 0) {
        plain = plain || {};
        plain.label = hasLabels ? style.label.join('.') : '';
      }
    } else {
      plain = plain || {};
      plain[key] = style[key];
    }
  });
  return { plain: plain, selects: selects, medias: medias, supports: supports };
}

function deconstructedStyleToCSS(id, style) {
  var css = [];

  // plugins here
  var plain = style.plain,
      selects = style.selects,
      medias = style.medias,
      supports = style.supports;

  if (plain) {
    css.push(toCSS({ style: plain, selector: selector(id) }));
  }
  if (selects) {
    Object.keys(selects).forEach(function (key) {
      return css.push(toCSS({ style: selects[key], selector: selector(id, key) }));
    });
  }
  if (medias) {
    Object.keys(medias).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, medias[key]).join('') + '}');
    });
  }
  if (supports) {
    Object.keys(supports).forEach(function (key) {
      return css.push(key + '{' + deconstructedStyleToCSS(id, supports[key]).join('') + '}');
    });
  }
  return css;
}

// this cache to track which rules have
// been inserted into the stylesheet
var inserted = styleSheet.inserted = {};

// and helpers to insert rules into said styleSheet
function insert(spec) {
  if (!inserted[spec.id]) {
    inserted[spec.id] = true;
    var deconstructed = deconstruct(spec.style);
    var rules = deconstructedStyleToCSS(spec.id, deconstructed);
    inserted[spec.id] = isBrowser ? true : rules;
    rules.forEach(function (cssRule) {
      return styleSheet.insert(cssRule);
    });
  }
}

// a simple cache to store generated rules
var registered = styleSheet.registered = {};
function register(spec) {
  if (!registered[spec.id]) {
    registered[spec.id] = spec;
  }
}

function _getRegistered(rule) {
  if (isLikeRule(rule)) {
    var ret = registered[idFor(rule)];
    if (ret == null) {
      throw new Error('[glamor] an unexpected rule cache miss occurred. This is probably a sign of multiple glamor instances in your app. See https://github.com/threepointone/glamor/issues/79');
    }
    return ret;
  }
  return rule;
}

// todo - perf
var ruleCache = {};
function toRule(spec) {
  register(spec);
  insert(spec);

  if (ruleCache[spec.id]) {
    return ruleCache[spec.id];
  }

  var ret = _defineProperty({}, 'data-css-' + spec.id, hasLabels ? spec.label || '' : '');
  Object.defineProperty(ret, 'toString', {
    enumerable: false, value: function value() {
      return 'css-' + spec.id;
    }
  });
  ruleCache[spec.id] = ret;
  return ret;
}

function log() {
  //eslint-disable-line no-unused-vars
  console.log(this); //eslint-disable-line no-console
  return this;
}

function isSelector(key) {
  var possibles = [':', '.', '[', '>', ' '],
      found = false,
      ch = key.charAt(0);
  for (var i = 0; i < possibles.length; i++) {
    if (ch === possibles[i]) {
      found = true;
      break;
    }
  }
  return found || key.indexOf('&') >= 0;
}

function joinSelectors(a, b) {
  var as = splitSelector(a).map(function (a) {
    return !(a.indexOf('&') >= 0) ? '&' + a : a;
  });
  var bs = splitSelector(b).map(function (b) {
    return !(b.indexOf('&') >= 0) ? '&' + b : b;
  });

  return bs.reduce(function (arr, b) {
    return arr.concat(as.map(function (a) {
      return b.replace(/\&/g, a);
    }));
  }, []).join(',');
}

function joinMediaQueries(a, b) {
  return a ? '@media ' + a.substring(6) + ' and ' + b.substring(6) : b;
}

function isMediaQuery(key) {
  return key.indexOf('@media') === 0;
}

function isSupports(key) {
  return key.indexOf('@supports') === 0;
}

function joinSupports(a, b) {
  return a ? '@supports ' + a.substring(9) + ' and ' + b.substring(9) : b;
}

// flatten a nested array
function flatten(inArr) {
  var arr = [];
  for (var i = 0; i < inArr.length; i++) {
    if (Array.isArray(inArr[i])) arr = arr.concat(flatten(inArr[i]));else arr = arr.concat(inArr[i]);
  }
  return arr;
}

var prefixedPseudoSelectors = {
  '::placeholder': ['::-webkit-input-placeholder', '::-moz-placeholder', '::-ms-input-placeholder'],
  ':fullscreen': [':-webkit-full-screen', ':-moz-full-screen', ':-ms-fullscreen']

  // mutable! modifies dest.
};function build(dest, _ref2) {
  var _ref2$selector = _ref2.selector,
      selector = _ref2$selector === undefined ? '' : _ref2$selector,
      _ref2$mq = _ref2.mq,
      mq = _ref2$mq === undefined ? '' : _ref2$mq,
      _ref2$supp = _ref2.supp,
      supp = _ref2$supp === undefined ? '' : _ref2$supp,
      _ref2$src = _ref2.src,
      src = _ref2$src === undefined ? {} : _ref2$src;


  if (!Array.isArray(src)) {
    src = [src];
  }
  src = flatten(src);

  src.forEach(function (_src) {
    if (isLikeRule(_src)) {
      var reg = _getRegistered(_src);
      if (reg.type !== 'css') {
        throw new Error('cannot merge this rule');
      }
      _src = reg.style;
    }
    _src = (0, _clean2.default)(_src);
    if (_src && _src.composes) {
      build(dest, { selector: selector, mq: mq, supp: supp, src: _src.composes });
    }
    Object.keys(_src || {}).forEach(function (key) {
      if (isSelector(key)) {

        if (prefixedPseudoSelectors[key]) {
          prefixedPseudoSelectors[key].forEach(function (p) {
            return build(dest, { selector: joinSelectors(selector, p), mq: mq, supp: supp, src: _src[key] });
          });
        }

        build(dest, { selector: joinSelectors(selector, key), mq: mq, supp: supp, src: _src[key] });
      } else if (isMediaQuery(key)) {
        build(dest, { selector: selector, mq: joinMediaQueries(mq, key), supp: supp, src: _src[key] });
      } else if (isSupports(key)) {
        build(dest, { selector: selector, mq: mq, supp: joinSupports(supp, key), src: _src[key] });
      } else if (key === 'composes') {
        // ignore, we already dealth with it
      } else {
        var _dest = dest;
        if (supp) {
          _dest[supp] = _dest[supp] || {};
          _dest = _dest[supp];
        }
        if (mq) {
          _dest[mq] = _dest[mq] || {};
          _dest = _dest[mq];
        }
        if (selector) {
          _dest[selector] = _dest[selector] || {};
          _dest = _dest[selector];
        }

        if (key === 'label') {
          if (hasLabels) {
            dest.label = dest.label.concat(_src.label);
          }
        } else {
          _dest[key] = _src[key];
        }
      }
    });
  });
}

function _css(rules) {
  var style = { label: [] };
  build(style, { src: rules }); // mutative! but worth it.

  var spec = {
    id: hashify(style),
    style: style, label: hasLabels ? style.label.join('.') : '',
    type: 'css'
  };
  return toRule(spec);
}

var nullrule = {
  // 'data-css-nil': ''
};
Object.defineProperty(nullrule, 'toString', {
  enumerable: false, value: function value() {
    return 'css-nil';
  }
});

var inputCaches = typeof WeakMap !== 'undefined' ? [nullrule, new WeakMap(), new WeakMap(), new WeakMap()] : [nullrule];

var warnedWeakMapError = false;
function multiIndexCache(fn) {
  return function (args) {
    if (inputCaches[args.length]) {
      var coi = inputCaches[args.length];
      var ctr = 0;
      while (ctr < args.length - 1) {
        if (!coi.has(args[ctr])) {
          coi.set(args[ctr], new WeakMap());
        }
        coi = coi.get(args[ctr]);
        ctr++;
      }
      if (coi.has(args[args.length - 1])) {
        var ret = coi.get(args[ctr]);

        if (registered[ret.toString().substring(4)]) {
          // make sure it hasn't been flushed
          return ret;
        }
      }
    }
    var value = fn(args);
    if (inputCaches[args.length]) {
      var _ctr = 0,
          _coi = inputCaches[args.length];
      while (_ctr < args.length - 1) {
        _coi = _coi.get(args[_ctr]);
        _ctr++;
      }
      try {
        _coi.set(args[_ctr], value);
      } catch (err) {
        if (isDev && !warnedWeakMapError) {
          var _console;

          warnedWeakMapError = true;
          (_console = console).warn.apply(_console, ['failed setting the WeakMap cache for args:'].concat(_toConsumableArray(args))); // eslint-disable-line no-console
          console.warn('this should NOT happen, please file a bug on the github repo.'); // eslint-disable-line no-console
        }
      }
    }
    return value;
  };
}

var cachedCss = typeof WeakMap !== 'undefined' ? multiIndexCache(_css) : _css;

function css() {
  for (var _len2 = arguments.length, rules = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    rules[_key2] = arguments[_key2];
  }

  if (rules[0] && rules[0].length && rules[0].raw) {
    throw new Error('you forgot to include glamor/babel in your babel plugins.');
  }

  rules = (0, _clean2.default)(rules);
  if (!rules) {
    return nullrule;
  }

  return cachedCss(rules);
}

css.insert = function (css) {
  var spec = {
    id: hashify(css),
    css: css,
    type: 'raw'
  };
  register(spec);
  if (!inserted[spec.id]) {
    styleSheet.insert(spec.css);
    inserted[spec.id] = isBrowser ? true : [spec.css];
  }
};

var insertRule = exports.insertRule = css.insert;

css.global = function (selector, style) {
  style = (0, _clean2.default)(style);
  if (style) {
    return css.insert(toCSS({ selector: selector, style: style }));
  }
};

var insertGlobal = exports.insertGlobal = css.global;

function insertKeyframe(spec) {
  if (!inserted[spec.id]) {
    var inner = Object.keys(spec.keyframes).map(function (kf) {
      var result = plugins.keyframes.transform({ id: spec.id, name: kf, style: spec.keyframes[kf] });
      return result.name + '{' + (0, _CSSPropertyOperations.createMarkupForStyles)(result.style) + '}';
    }).join('');

    var rules = ['-webkit-', '-moz-', '-o-', ''].map(function (prefix) {
      return '@' + prefix + 'keyframes ' + (spec.name + '_' + spec.id) + '{' + inner + '}';
    });
    rules.forEach(function (rule) {
      return styleSheet.insert(rule);
    });

    inserted[spec.id] = isBrowser ? true : rules;
  }
}
css.keyframes = function (name, kfs) {
  if (!kfs) {
    kfs = name, name = 'animation';
  }

  // do not ignore empty keyframe definitions for now.
  kfs = (0, _clean2.default)(kfs) || {};
  var spec = {
    id: hashify({ name: name, kfs: kfs }),
    type: 'keyframes',
    name: name,
    keyframes: kfs
  };
  register(spec);
  insertKeyframe(spec);
  return name + '_' + spec.id;
};

// we don't go all out for fonts as much, giving a simple font loading strategy
// use a fancier lib if you need moar power
css.fontFace = function (font) {
  font = (0, _clean2.default)(font);
  var spec = {
    id: hashify(font),
    type: 'font-face',
    font: font
  };
  register(spec);
  insertFontFace(spec);

  return font.fontFamily;
};

var fontFace = exports.fontFace = css.fontFace;
var keyframes = exports.keyframes = css.keyframes;

function insertFontFace(spec) {
  if (!inserted[spec.id]) {
    var rule = '@font-face{' + (0, _CSSPropertyOperations.createMarkupForStyles)(spec.font) + '}';
    styleSheet.insert(rule);
    inserted[spec.id] = isBrowser ? true : [rule];
  }
}

// rehydrate the insertion cache with ids sent from
// renderStatic / renderStaticOptimized
function rehydrate(ids) {
  // load up ids
  (0, _objectAssign2.default)(inserted, ids.reduce(function (o, i) {
    return o[i] = true, o;
  }, {}));
  // assume css loaded separately
}

// clears out the cache and empties the stylesheet
// best for tests, though there might be some value for SSR.

function flush() {
  inserted = styleSheet.inserted = {};
  registered = styleSheet.registered = {};
  ruleCache = {};
  styleSheet.flush();
  styleSheet.inject();
}

var presets = exports.presets = {
  mobile: '(min-width: 400px)',
  Mobile: '@media (min-width: 400px)',
  phablet: '(min-width: 550px)',
  Phablet: '@media (min-width: 550px)',
  tablet: '(min-width: 750px)',
  Tablet: '@media (min-width: 750px)',
  desktop: '(min-width: 1000px)',
  Desktop: '@media (min-width: 1000px)',
  hd: '(min-width: 1200px)',
  Hd: '@media (min-width: 1200px)'
};

var style = exports.style = css;

function select(selector) {
  for (var _len3 = arguments.length, styles = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    styles[_key3 - 1] = arguments[_key3];
  }

  if (!selector) {
    return style(styles);
  }
  return css(_defineProperty({}, selector, styles));
}
var $ = exports.$ = select;

function parent(selector) {
  for (var _len4 = arguments.length, styles = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    styles[_key4 - 1] = arguments[_key4];
  }

  return css(_defineProperty({}, selector + ' &', styles));
}

var merge = exports.merge = css;
var compose = exports.compose = css;

function media(query) {
  for (var _len5 = arguments.length, rules = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    rules[_key5 - 1] = arguments[_key5];
  }

  return css(_defineProperty({}, '@media ' + query, rules));
}

function pseudo(selector) {
  for (var _len6 = arguments.length, styles = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    styles[_key6 - 1] = arguments[_key6];
  }

  return css(_defineProperty({}, selector, styles));
}

// allllll the pseudoclasses

function active(x) {
  return pseudo(':active', x);
}

function any(x) {
  return pseudo(':any', x);
}

function checked(x) {
  return pseudo(':checked', x);
}

function disabled(x) {
  return pseudo(':disabled', x);
}

function empty(x) {
  return pseudo(':empty', x);
}

function enabled(x) {
  return pseudo(':enabled', x);
}

function _default(x) {
  return pseudo(':default', x); // note '_default' name
}

function first(x) {
  return pseudo(':first', x);
}

function firstChild(x) {
  return pseudo(':first-child', x);
}

function firstOfType(x) {
  return pseudo(':first-of-type', x);
}

function fullscreen(x) {
  return pseudo(':fullscreen', x);
}

function focus(x) {
  return pseudo(':focus', x);
}

function hover(x) {
  return pseudo(':hover', x);
}

function indeterminate(x) {
  return pseudo(':indeterminate', x);
}

function inRange(x) {
  return pseudo(':in-range', x);
}

function invalid(x) {
  return pseudo(':invalid', x);
}

function lastChild(x) {
  return pseudo(':last-child', x);
}

function lastOfType(x) {
  return pseudo(':last-of-type', x);
}

function left(x) {
  return pseudo(':left', x);
}

function link(x) {
  return pseudo(':link', x);
}

function onlyChild(x) {
  return pseudo(':only-child', x);
}

function onlyOfType(x) {
  return pseudo(':only-of-type', x);
}

function optional(x) {
  return pseudo(':optional', x);
}

function outOfRange(x) {
  return pseudo(':out-of-range', x);
}

function readOnly(x) {
  return pseudo(':read-only', x);
}

function readWrite(x) {
  return pseudo(':read-write', x);
}

function required(x) {
  return pseudo(':required', x);
}

function right(x) {
  return pseudo(':right', x);
}

function root(x) {
  return pseudo(':root', x);
}

function scope(x) {
  return pseudo(':scope', x);
}

function target(x) {
  return pseudo(':target', x);
}

function valid(x) {
  return pseudo(':valid', x);
}

function visited(x) {
  return pseudo(':visited', x);
}

// parameterized pseudoclasses
function dir(p, x) {
  return pseudo(':dir(' + p + ')', x);
}
function lang(p, x) {
  return pseudo(':lang(' + p + ')', x);
}
function not(p, x) {
  // should this be a plugin?
  var selector = p.split(',').map(function (x) {
    return x.trim();
  }).map(function (x) {
    return ':not(' + x + ')';
  });
  if (selector.length === 1) {
    return pseudo(':not(' + p + ')', x);
  }
  return select(selector.join(''), x);
}
function nthChild(p, x) {
  return pseudo(':nth-child(' + p + ')', x);
}
function nthLastChild(p, x) {
  return pseudo(':nth-last-child(' + p + ')', x);
}
function nthLastOfType(p, x) {
  return pseudo(':nth-last-of-type(' + p + ')', x);
}
function nthOfType(p, x) {
  return pseudo(':nth-of-type(' + p + ')', x);
}

// pseudoelements
function after(x) {
  return pseudo('::after', x);
}
function before(x) {
  return pseudo('::before', x);
}
function firstLetter(x) {
  return pseudo('::first-letter', x);
}
function firstLine(x) {
  return pseudo('::first-line', x);
}
function selection(x) {
  return pseudo('::selection', x);
}
function backdrop(x) {
  return pseudo('::backdrop', x);
}
function placeholder(x) {
  // https://github.com/threepointone/glamor/issues/14
  return css({ '::placeholder': x });
}

/*** helpers for web components ***/
// https://github.com/threepointone/glamor/issues/16

function cssFor() {
  for (var _len7 = arguments.length, rules = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    rules[_key7] = arguments[_key7];
  }

  rules = (0, _clean2.default)(rules);
  return rules ? rules.map(function (r) {
    var style = { label: [] };
    build(style, { src: r }); // mutative! but worth it.
    return deconstructedStyleToCSS(hashify(style), deconstruct(style)).join('');
  }).join('') : '';
}

function attribsFor() {
  for (var _len8 = arguments.length, rules = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    rules[_key8] = arguments[_key8];
  }

  rules = (0, _clean2.default)(rules);
  var htmlAttributes = rules ? rules.map(function (rule) {
    idFor(rule); // throwaway check for rule
    var key = Object.keys(rule)[0],
        value = rule[key];
    return key + '="' + (value || '') + '"';
  }).join(' ') : '';

  return htmlAttributes;
}

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processStyleName = undefined;
exports.createMarkupForStyles = createMarkupForStyles;

var _camelizeStyleName = __webpack_require__(1937);

var _camelizeStyleName2 = _interopRequireDefault(_camelizeStyleName);

var _dangerousStyleValue = __webpack_require__(1939);

var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);

var _hyphenateStyleName = __webpack_require__(1941);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _memoizeStringOnly = __webpack_require__(1943);

var _memoizeStringOnly2 = _interopRequireDefault(_memoizeStringOnly);

var _warning = __webpack_require__(104);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var processStyleName = exports.processStyleName = (0, _memoizeStringOnly2.default)(_hyphenateStyleName2.default); /**
                                                                                                                   * Copyright 2013-present, Facebook, Inc.
                                                                                                                   * All rights reserved.
                                                                                                                   *
                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                   *
                                                                                                                   * @providesModule CSSPropertyOperations
                                                                                                                   */

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported style property %s. Did you mean %s?%s', name, (0, _camelizeStyleName2.default)(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function checkRenderMessage(owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function warnValidStyle(name, value, component) {
    //eslint-disable-line no-var
    var owner = void 0;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */

function createMarkupForStyles(styles, component) {
  var serialized = '';
  for (var styleName in styles) {
    var isCustomProp = styleName.indexOf('--') === 0;
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }
    if (styleName === 'label') {
      continue;
    }
    var styleValue = styles[styleName];
    if (false) {
      warnValidStyle(styleName, styleValue, component);
    }
    if (styleValue != null) {
      if (isCustomProp) {
        serialized += styleName + ':' + styleValue + ';';
      } else {
        serialized += processStyleName(styleName) + ':';
        serialized += (0, _dangerousStyleValue2.default)(styleName, styleValue, component) + ';';
      }
    }
  }
  return serialized || null;
}

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var Tokenizer = __webpack_require__(919);

/*
	Options:

	xmlMode: Disables the special behavior for script/style tags (false by default)
	lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
	lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
*/

/*
	Callbacks:

	oncdataend,
	oncdatastart,
	onclosetag,
	oncomment,
	oncommentend,
	onerror,
	onopentag,
	onprocessinginstruction,
	onreset,
	ontext
*/

var formTags = {
	input: true,
	option: true,
	optgroup: true,
	select: true,
	button: true,
	datalist: true,
	textarea: true
};

var openImpliesClose = {
	tr      : { tr:true, th:true, td:true },
	th      : { th:true },
	td      : { thead:true, th:true, td:true },
	body    : { head:true, link:true, script:true },
	li      : { li:true },
	p       : { p:true },
	h1      : { p:true },
	h2      : { p:true },
	h3      : { p:true },
	h4      : { p:true },
	h5      : { p:true },
	h6      : { p:true },
	select  : formTags,
	input   : formTags,
	output  : formTags,
	button  : formTags,
	datalist: formTags,
	textarea: formTags,
	option  : { option:true },
	optgroup: { optgroup:true }
};

var voidElements = {
	__proto__: null,
	area: true,
	base: true,
	basefont: true,
	br: true,
	col: true,
	command: true,
	embed: true,
	frame: true,
	hr: true,
	img: true,
	input: true,
	isindex: true,
	keygen: true,
	link: true,
	meta: true,
	param: true,
	source: true,
	track: true,
	wbr: true,

	//common self closing svg elements
	path: true,
	circle: true,
	ellipse: true,
	line: true,
	rect: true,
	use: true,
	stop: true,
	polyline: true,
	polygon: true
};

var re_nameEnd = /\s|\//;

function Parser(cbs, options){
	this._options = options || {};
	this._cbs = cbs || {};

	this._tagname = "";
	this._attribname = "";
	this._attribvalue = "";
	this._attribs = null;
	this._stack = [];

	this.startIndex = 0;
	this.endIndex = null;

	this._lowerCaseTagNames = "lowerCaseTags" in this._options ?
									!!this._options.lowerCaseTags :
									!this._options.xmlMode;
	this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ?
									!!this._options.lowerCaseAttributeNames :
									!this._options.xmlMode;

	if(this._options.Tokenizer) {
		Tokenizer = this._options.Tokenizer;
	}
	this._tokenizer = new Tokenizer(this._options, this);

	if(this._cbs.onparserinit) this._cbs.onparserinit(this);
}

__webpack_require__(87)(Parser, __webpack_require__(141).EventEmitter);

Parser.prototype._updatePosition = function(initialOffset){
	if(this.endIndex === null){
		if(this._tokenizer._sectionStart <= initialOffset){
			this.startIndex = 0;
		} else {
			this.startIndex = this._tokenizer._sectionStart - initialOffset;
		}
	}
	else this.startIndex = this.endIndex + 1;
	this.endIndex = this._tokenizer.getAbsoluteIndex();
};

//Tokenizer event handlers
Parser.prototype.ontext = function(data){
	this._updatePosition(1);
	this.endIndex--;

	if(this._cbs.ontext) this._cbs.ontext(data);
};

Parser.prototype.onopentagname = function(name){
	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	this._tagname = name;

	if(!this._options.xmlMode && name in openImpliesClose) {
		for(
			var el;
			(el = this._stack[this._stack.length - 1]) in openImpliesClose[name];
			this.onclosetag(el)
		);
	}

	if(this._options.xmlMode || !(name in voidElements)){
		this._stack.push(name);
	}

	if(this._cbs.onopentagname) this._cbs.onopentagname(name);
	if(this._cbs.onopentag) this._attribs = {};
};

Parser.prototype.onopentagend = function(){
	this._updatePosition(1);

	if(this._attribs){
		if(this._cbs.onopentag) this._cbs.onopentag(this._tagname, this._attribs);
		this._attribs = null;
	}

	if(!this._options.xmlMode && this._cbs.onclosetag && this._tagname in voidElements){
		this._cbs.onclosetag(this._tagname);
	}

	this._tagname = "";
};

Parser.prototype.onclosetag = function(name){
	this._updatePosition(1);

	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	if(this._stack.length && (!(name in voidElements) || this._options.xmlMode)){
		var pos = this._stack.lastIndexOf(name);
		if(pos !== -1){
			if(this._cbs.onclosetag){
				pos = this._stack.length - pos;
				while(pos--) this._cbs.onclosetag(this._stack.pop());
			}
			else this._stack.length = pos;
		} else if(name === "p" && !this._options.xmlMode){
			this.onopentagname(name);
			this._closeCurrentTag();
		}
	} else if(!this._options.xmlMode && (name === "br" || name === "p")){
		this.onopentagname(name);
		this._closeCurrentTag();
	}
};

Parser.prototype.onselfclosingtag = function(){
	if(this._options.xmlMode || this._options.recognizeSelfClosing){
		this._closeCurrentTag();
	} else {
		this.onopentagend();
	}
};

Parser.prototype._closeCurrentTag = function(){
	var name = this._tagname;

	this.onopentagend();

	//self-closing tags will be on the top of the stack
	//(cheaper check than in onclosetag)
	if(this._stack[this._stack.length - 1] === name){
		if(this._cbs.onclosetag){
			this._cbs.onclosetag(name);
		}
		this._stack.pop();
	}
};

Parser.prototype.onattribname = function(name){
	if(this._lowerCaseAttributeNames){
		name = name.toLowerCase();
	}
	this._attribname = name;
};

Parser.prototype.onattribdata = function(value){
	this._attribvalue += value;
};

Parser.prototype.onattribend = function(){
	if(this._cbs.onattribute) this._cbs.onattribute(this._attribname, this._attribvalue);
	if(
		this._attribs &&
		!Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	){
		this._attribs[this._attribname] = this._attribvalue;
	}
	this._attribname = "";
	this._attribvalue = "";
};

Parser.prototype._getInstructionName = function(value){
	var idx = value.search(re_nameEnd),
	    name = idx < 0 ? value : value.substr(0, idx);

	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	return name;
};

Parser.prototype.ondeclaration = function(value){
	if(this._cbs.onprocessinginstruction){
		var name = this._getInstructionName(value);
		this._cbs.onprocessinginstruction("!" + name, "!" + value);
	}
};

Parser.prototype.onprocessinginstruction = function(value){
	if(this._cbs.onprocessinginstruction){
		var name = this._getInstructionName(value);
		this._cbs.onprocessinginstruction("?" + name, "?" + value);
	}
};

Parser.prototype.oncomment = function(value){
	this._updatePosition(4);

	if(this._cbs.oncomment) this._cbs.oncomment(value);
	if(this._cbs.oncommentend) this._cbs.oncommentend();
};

Parser.prototype.oncdata = function(value){
	this._updatePosition(1);

	if(this._options.xmlMode || this._options.recognizeCDATA){
		if(this._cbs.oncdatastart) this._cbs.oncdatastart();
		if(this._cbs.ontext) this._cbs.ontext(value);
		if(this._cbs.oncdataend) this._cbs.oncdataend();
	} else {
		this.oncomment("[CDATA[" + value + "]]");
	}
};

Parser.prototype.onerror = function(err){
	if(this._cbs.onerror) this._cbs.onerror(err);
};

Parser.prototype.onend = function(){
	if(this._cbs.onclosetag){
		for(
			var i = this._stack.length;
			i > 0;
			this._cbs.onclosetag(this._stack[--i])
		);
	}
	if(this._cbs.onend) this._cbs.onend();
};


//Resets the parser to a blank state, ready to parse a new HTML document
Parser.prototype.reset = function(){
	if(this._cbs.onreset) this._cbs.onreset();
	this._tokenizer.reset();

	this._tagname = "";
	this._attribname = "";
	this._attribs = null;
	this._stack = [];

	if(this._cbs.onparserinit) this._cbs.onparserinit(this);
};

//Parses a complete HTML document and pushes it to the handler
Parser.prototype.parseComplete = function(data){
	this.reset();
	this.end(data);
};

Parser.prototype.write = function(chunk){
	this._tokenizer.write(chunk);
};

Parser.prototype.end = function(chunk){
	this._tokenizer.end(chunk);
};

Parser.prototype.pause = function(){
	this._tokenizer.pause();
};

Parser.prototype.resume = function(){
	this._tokenizer.resume();
};

//alias for backwards compat
Parser.prototype.parseChunk = Parser.prototype.write;
Parser.prototype.done = Parser.prototype.end;

module.exports = Parser;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Tokenizer;

var decodeCodePoint = __webpack_require__(920),
    entityMap = __webpack_require__(492),
    legacyMap = __webpack_require__(921),
    xmlMap    = __webpack_require__(493),

    i = 0,

    TEXT                      = i++,
    BEFORE_TAG_NAME           = i++, //after <
    IN_TAG_NAME               = i++,
    IN_SELF_CLOSING_TAG       = i++,
    BEFORE_CLOSING_TAG_NAME   = i++,
    IN_CLOSING_TAG_NAME       = i++,
    AFTER_CLOSING_TAG_NAME    = i++,

    //attributes
    BEFORE_ATTRIBUTE_NAME     = i++,
    IN_ATTRIBUTE_NAME         = i++,
    AFTER_ATTRIBUTE_NAME      = i++,
    BEFORE_ATTRIBUTE_VALUE    = i++,
    IN_ATTRIBUTE_VALUE_DQ     = i++, // "
    IN_ATTRIBUTE_VALUE_SQ     = i++, // '
    IN_ATTRIBUTE_VALUE_NQ     = i++,

    //declarations
    BEFORE_DECLARATION        = i++, // !
    IN_DECLARATION            = i++,

    //processing instructions
    IN_PROCESSING_INSTRUCTION = i++, // ?

    //comments
    BEFORE_COMMENT            = i++,
    IN_COMMENT                = i++,
    AFTER_COMMENT_1           = i++,
    AFTER_COMMENT_2           = i++,

    //cdata
    BEFORE_CDATA_1            = i++, // [
    BEFORE_CDATA_2            = i++, // C
    BEFORE_CDATA_3            = i++, // D
    BEFORE_CDATA_4            = i++, // A
    BEFORE_CDATA_5            = i++, // T
    BEFORE_CDATA_6            = i++, // A
    IN_CDATA                  = i++, // [
    AFTER_CDATA_1             = i++, // ]
    AFTER_CDATA_2             = i++, // ]

    //special tags
    BEFORE_SPECIAL            = i++, //S
    BEFORE_SPECIAL_END        = i++,   //S

    BEFORE_SCRIPT_1           = i++, //C
    BEFORE_SCRIPT_2           = i++, //R
    BEFORE_SCRIPT_3           = i++, //I
    BEFORE_SCRIPT_4           = i++, //P
    BEFORE_SCRIPT_5           = i++, //T
    AFTER_SCRIPT_1            = i++, //C
    AFTER_SCRIPT_2            = i++, //R
    AFTER_SCRIPT_3            = i++, //I
    AFTER_SCRIPT_4            = i++, //P
    AFTER_SCRIPT_5            = i++, //T

    BEFORE_STYLE_1            = i++, //T
    BEFORE_STYLE_2            = i++, //Y
    BEFORE_STYLE_3            = i++, //L
    BEFORE_STYLE_4            = i++, //E
    AFTER_STYLE_1             = i++, //T
    AFTER_STYLE_2             = i++, //Y
    AFTER_STYLE_3             = i++, //L
    AFTER_STYLE_4             = i++, //E

    BEFORE_ENTITY             = i++, //&
    BEFORE_NUMERIC_ENTITY     = i++, //#
    IN_NAMED_ENTITY           = i++,
    IN_NUMERIC_ENTITY         = i++,
    IN_HEX_ENTITY             = i++, //X

    j = 0,

    SPECIAL_NONE              = j++,
    SPECIAL_SCRIPT            = j++,
    SPECIAL_STYLE             = j++;

function whitespace(c){
	return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}

function characterState(char, SUCCESS){
	return function(c){
		if(c === char) this._state = SUCCESS;
	};
}

function ifElseState(upper, SUCCESS, FAILURE){
	var lower = upper.toLowerCase();

	if(upper === lower){
		return function(c){
			if(c === lower){
				this._state = SUCCESS;
			} else {
				this._state = FAILURE;
				this._index--;
			}
		};
	} else {
		return function(c){
			if(c === lower || c === upper){
				this._state = SUCCESS;
			} else {
				this._state = FAILURE;
				this._index--;
			}
		};
	}
}

function consumeSpecialNameChar(upper, NEXT_STATE){
	var lower = upper.toLowerCase();

	return function(c){
		if(c === lower || c === upper){
			this._state = NEXT_STATE;
		} else {
			this._state = IN_TAG_NAME;
			this._index--; //consume the token again
		}
	};
}

function Tokenizer(options, cbs){
	this._state = TEXT;
	this._buffer = "";
	this._sectionStart = 0;
	this._index = 0;
	this._bufferOffset = 0; //chars removed from _buffer
	this._baseState = TEXT;
	this._special = SPECIAL_NONE;
	this._cbs = cbs;
	this._running = true;
	this._ended = false;
	this._xmlMode = !!(options && options.xmlMode);
	this._decodeEntities = !!(options && options.decodeEntities);
}

Tokenizer.prototype._stateText = function(c){
	if(c === "<"){
		if(this._index > this._sectionStart){
			this._cbs.ontext(this._getSection());
		}
		this._state = BEFORE_TAG_NAME;
		this._sectionStart = this._index;
	} else if(this._decodeEntities && this._special === SPECIAL_NONE && c === "&"){
		if(this._index > this._sectionStart){
			this._cbs.ontext(this._getSection());
		}
		this._baseState = TEXT;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeTagName = function(c){
	if(c === "/"){
		this._state = BEFORE_CLOSING_TAG_NAME;
	} else if(c === "<"){
		this._cbs.ontext(this._getSection());
		this._sectionStart = this._index;
	} else if(c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
		this._state = TEXT;
	} else if(c === "!"){
		this._state = BEFORE_DECLARATION;
		this._sectionStart = this._index + 1;
	} else if(c === "?"){
		this._state = IN_PROCESSING_INSTRUCTION;
		this._sectionStart = this._index + 1;
	} else {
		this._state = (!this._xmlMode && (c === "s" || c === "S")) ?
						BEFORE_SPECIAL : IN_TAG_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInTagName = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._emitToken("onopentagname");
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateBeforeCloseingTagName = function(c){
	if(whitespace(c));
	else if(c === ">"){
		this._state = TEXT;
	} else if(this._special !== SPECIAL_NONE){
		if(c === "s" || c === "S"){
			this._state = BEFORE_SPECIAL_END;
		} else {
			this._state = TEXT;
			this._index--;
		}
	} else {
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInCloseingTagName = function(c){
	if(c === ">" || whitespace(c)){
		this._emitToken("onclosetag");
		this._state = AFTER_CLOSING_TAG_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateAfterCloseingTagName = function(c){
	//skip everything until ">"
	if(c === ">"){
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateBeforeAttributeName = function(c){
	if(c === ">"){
		this._cbs.onopentagend();
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c === "/"){
		this._state = IN_SELF_CLOSING_TAG;
	} else if(!whitespace(c)){
		this._state = IN_ATTRIBUTE_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInSelfClosingTag = function(c){
	if(c === ">"){
		this._cbs.onselfclosingtag();
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(!whitespace(c)){
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateInAttributeName = function(c){
	if(c === "=" || c === "/" || c === ">" || whitespace(c)){
		this._cbs.onattribname(this._getSection());
		this._sectionStart = -1;
		this._state = AFTER_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateAfterAttributeName = function(c){
	if(c === "="){
		this._state = BEFORE_ATTRIBUTE_VALUE;
	} else if(c === "/" || c === ">"){
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	} else if(!whitespace(c)){
		this._cbs.onattribend();
		this._state = IN_ATTRIBUTE_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeAttributeValue = function(c){
	if(c === "\""){
		this._state = IN_ATTRIBUTE_VALUE_DQ;
		this._sectionStart = this._index + 1;
	} else if(c === "'"){
		this._state = IN_ATTRIBUTE_VALUE_SQ;
		this._sectionStart = this._index + 1;
	} else if(!whitespace(c)){
		this._state = IN_ATTRIBUTE_VALUE_NQ;
		this._sectionStart = this._index;
		this._index--; //reconsume token
	}
};

Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c){
	if(c === "\""){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c){
	if(c === "'"){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c){
	if(whitespace(c) || c === ">"){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeDeclaration = function(c){
	this._state = c === "[" ? BEFORE_CDATA_1 :
					c === "-" ? BEFORE_COMMENT :
						IN_DECLARATION;
};

Tokenizer.prototype._stateInDeclaration = function(c){
	if(c === ">"){
		this._cbs.ondeclaration(this._getSection());
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateInProcessingInstruction = function(c){
	if(c === ">"){
		this._cbs.onprocessinginstruction(this._getSection());
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateBeforeComment = function(c){
	if(c === "-"){
		this._state = IN_COMMENT;
		this._sectionStart = this._index + 1;
	} else {
		this._state = IN_DECLARATION;
	}
};

Tokenizer.prototype._stateInComment = function(c){
	if(c === "-") this._state = AFTER_COMMENT_1;
};

Tokenizer.prototype._stateAfterComment1 = function(c){
	if(c === "-"){
		this._state = AFTER_COMMENT_2;
	} else {
		this._state = IN_COMMENT;
	}
};

Tokenizer.prototype._stateAfterComment2 = function(c){
	if(c === ">"){
		//remove 2 trailing chars
		this._cbs.oncomment(this._buffer.substring(this._sectionStart, this._index - 2));
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c !== "-"){
		this._state = IN_COMMENT;
	}
	// else: stay in AFTER_COMMENT_2 (`--->`)
};

Tokenizer.prototype._stateBeforeCdata1 = ifElseState("C", BEFORE_CDATA_2, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata2 = ifElseState("D", BEFORE_CDATA_3, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata3 = ifElseState("A", BEFORE_CDATA_4, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata4 = ifElseState("T", BEFORE_CDATA_5, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata5 = ifElseState("A", BEFORE_CDATA_6, IN_DECLARATION);

Tokenizer.prototype._stateBeforeCdata6 = function(c){
	if(c === "["){
		this._state = IN_CDATA;
		this._sectionStart = this._index + 1;
	} else {
		this._state = IN_DECLARATION;
		this._index--;
	}
};

Tokenizer.prototype._stateInCdata = function(c){
	if(c === "]") this._state = AFTER_CDATA_1;
};

Tokenizer.prototype._stateAfterCdata1 = characterState("]", AFTER_CDATA_2);

Tokenizer.prototype._stateAfterCdata2 = function(c){
	if(c === ">"){
		//remove 2 trailing chars
		this._cbs.oncdata(this._buffer.substring(this._sectionStart, this._index - 2));
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c !== "]") {
		this._state = IN_CDATA;
	}
	//else: stay in AFTER_CDATA_2 (`]]]>`)
};

Tokenizer.prototype._stateBeforeSpecial = function(c){
	if(c === "c" || c === "C"){
		this._state = BEFORE_SCRIPT_1;
	} else if(c === "t" || c === "T"){
		this._state = BEFORE_STYLE_1;
	} else {
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	}
};

Tokenizer.prototype._stateBeforeSpecialEnd = function(c){
	if(this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")){
		this._state = AFTER_SCRIPT_1;
	} else if(this._special === SPECIAL_STYLE && (c === "t" || c === "T")){
		this._state = AFTER_STYLE_1;
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar("R", BEFORE_SCRIPT_2);
Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar("I", BEFORE_SCRIPT_3);
Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar("P", BEFORE_SCRIPT_4);
Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar("T", BEFORE_SCRIPT_5);

Tokenizer.prototype._stateBeforeScript5 = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._special = SPECIAL_SCRIPT;
	}
	this._state = IN_TAG_NAME;
	this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);

Tokenizer.prototype._stateAfterScript5 = function(c){
	if(c === ">" || whitespace(c)){
		this._special = SPECIAL_NONE;
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index - 6;
		this._index--; //reconsume the token
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar("Y", BEFORE_STYLE_2);
Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar("L", BEFORE_STYLE_3);
Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar("E", BEFORE_STYLE_4);

Tokenizer.prototype._stateBeforeStyle4 = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._special = SPECIAL_STYLE;
	}
	this._state = IN_TAG_NAME;
	this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);

Tokenizer.prototype._stateAfterStyle4 = function(c){
	if(c === ">" || whitespace(c)){
		this._special = SPECIAL_NONE;
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index - 5;
		this._index--; //reconsume the token
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeEntity = ifElseState("#", BEFORE_NUMERIC_ENTITY, IN_NAMED_ENTITY);
Tokenizer.prototype._stateBeforeNumericEntity = ifElseState("X", IN_HEX_ENTITY, IN_NUMERIC_ENTITY);

//for entities terminated with a semicolon
Tokenizer.prototype._parseNamedEntityStrict = function(){
	//offset = 1
	if(this._sectionStart + 1 < this._index){
		var entity = this._buffer.substring(this._sectionStart + 1, this._index),
		    map = this._xmlMode ? xmlMap : entityMap;

		if(map.hasOwnProperty(entity)){
			this._emitPartial(map[entity]);
			this._sectionStart = this._index + 1;
		}
	}
};


//parses legacy entities (without trailing semicolon)
Tokenizer.prototype._parseLegacyEntity = function(){
	var start = this._sectionStart + 1,
	    limit = this._index - start;

	if(limit > 6) limit = 6; //the max length of legacy entities is 6

	while(limit >= 2){ //the min length of legacy entities is 2
		var entity = this._buffer.substr(start, limit);

		if(legacyMap.hasOwnProperty(entity)){
			this._emitPartial(legacyMap[entity]);
			this._sectionStart += limit + 1;
			return;
		} else {
			limit--;
		}
	}
};

Tokenizer.prototype._stateInNamedEntity = function(c){
	if(c === ";"){
		this._parseNamedEntityStrict();
		if(this._sectionStart + 1 < this._index && !this._xmlMode){
			this._parseLegacyEntity();
		}
		this._state = this._baseState;
	} else if((c < "a" || c > "z") && (c < "A" || c > "Z") && (c < "0" || c > "9")){
		if(this._xmlMode);
		else if(this._sectionStart + 1 === this._index);
		else if(this._baseState !== TEXT){
			if(c !== "="){
				this._parseNamedEntityStrict();
			}
		} else {
			this._parseLegacyEntity();
		}

		this._state = this._baseState;
		this._index--;
	}
};

Tokenizer.prototype._decodeNumericEntity = function(offset, base){
	var sectionStart = this._sectionStart + offset;

	if(sectionStart !== this._index){
		//parse entity
		var entity = this._buffer.substring(sectionStart, this._index);
		var parsed = parseInt(entity, base);

		this._emitPartial(decodeCodePoint(parsed));
		this._sectionStart = this._index;
	} else {
		this._sectionStart--;
	}

	this._state = this._baseState;
};

Tokenizer.prototype._stateInNumericEntity = function(c){
	if(c === ";"){
		this._decodeNumericEntity(2, 10);
		this._sectionStart++;
	} else if(c < "0" || c > "9"){
		if(!this._xmlMode){
			this._decodeNumericEntity(2, 10);
		} else {
			this._state = this._baseState;
		}
		this._index--;
	}
};

Tokenizer.prototype._stateInHexEntity = function(c){
	if(c === ";"){
		this._decodeNumericEntity(3, 16);
		this._sectionStart++;
	} else if((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")){
		if(!this._xmlMode){
			this._decodeNumericEntity(3, 16);
		} else {
			this._state = this._baseState;
		}
		this._index--;
	}
};

Tokenizer.prototype._cleanup = function (){
	if(this._sectionStart < 0){
		this._buffer = "";
		this._bufferOffset += this._index;
		this._index = 0;
	} else if(this._running){
		if(this._state === TEXT){
			if(this._sectionStart !== this._index){
				this._cbs.ontext(this._buffer.substr(this._sectionStart));
			}
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else if(this._sectionStart === this._index){
			//the section just started
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else {
			//remove everything unnecessary
			this._buffer = this._buffer.substr(this._sectionStart);
			this._index -= this._sectionStart;
			this._bufferOffset += this._sectionStart;
		}

		this._sectionStart = 0;
	}
};

//TODO make events conditional
Tokenizer.prototype.write = function(chunk){
	if(this._ended) this._cbs.onerror(Error(".write() after done!"));

	this._buffer += chunk;
	this._parse();
};

Tokenizer.prototype._parse = function(){
	while(this._index < this._buffer.length && this._running){
		var c = this._buffer.charAt(this._index);
		if(this._state === TEXT) {
			this._stateText(c);
		} else if(this._state === BEFORE_TAG_NAME){
			this._stateBeforeTagName(c);
		} else if(this._state === IN_TAG_NAME) {
			this._stateInTagName(c);
		} else if(this._state === BEFORE_CLOSING_TAG_NAME){
			this._stateBeforeCloseingTagName(c);
		} else if(this._state === IN_CLOSING_TAG_NAME){
			this._stateInCloseingTagName(c);
		} else if(this._state === AFTER_CLOSING_TAG_NAME){
			this._stateAfterCloseingTagName(c);
		} else if(this._state === IN_SELF_CLOSING_TAG){
			this._stateInSelfClosingTag(c);
		}

		/*
		*	attributes
		*/
		else if(this._state === BEFORE_ATTRIBUTE_NAME){
			this._stateBeforeAttributeName(c);
		} else if(this._state === IN_ATTRIBUTE_NAME){
			this._stateInAttributeName(c);
		} else if(this._state === AFTER_ATTRIBUTE_NAME){
			this._stateAfterAttributeName(c);
		} else if(this._state === BEFORE_ATTRIBUTE_VALUE){
			this._stateBeforeAttributeValue(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_DQ){
			this._stateInAttributeValueDoubleQuotes(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_SQ){
			this._stateInAttributeValueSingleQuotes(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_NQ){
			this._stateInAttributeValueNoQuotes(c);
		}

		/*
		*	declarations
		*/
		else if(this._state === BEFORE_DECLARATION){
			this._stateBeforeDeclaration(c);
		} else if(this._state === IN_DECLARATION){
			this._stateInDeclaration(c);
		}

		/*
		*	processing instructions
		*/
		else if(this._state === IN_PROCESSING_INSTRUCTION){
			this._stateInProcessingInstruction(c);
		}

		/*
		*	comments
		*/
		else if(this._state === BEFORE_COMMENT){
			this._stateBeforeComment(c);
		} else if(this._state === IN_COMMENT){
			this._stateInComment(c);
		} else if(this._state === AFTER_COMMENT_1){
			this._stateAfterComment1(c);
		} else if(this._state === AFTER_COMMENT_2){
			this._stateAfterComment2(c);
		}

		/*
		*	cdata
		*/
		else if(this._state === BEFORE_CDATA_1){
			this._stateBeforeCdata1(c);
		} else if(this._state === BEFORE_CDATA_2){
			this._stateBeforeCdata2(c);
		} else if(this._state === BEFORE_CDATA_3){
			this._stateBeforeCdata3(c);
		} else if(this._state === BEFORE_CDATA_4){
			this._stateBeforeCdata4(c);
		} else if(this._state === BEFORE_CDATA_5){
			this._stateBeforeCdata5(c);
		} else if(this._state === BEFORE_CDATA_6){
			this._stateBeforeCdata6(c);
		} else if(this._state === IN_CDATA){
			this._stateInCdata(c);
		} else if(this._state === AFTER_CDATA_1){
			this._stateAfterCdata1(c);
		} else if(this._state === AFTER_CDATA_2){
			this._stateAfterCdata2(c);
		}

		/*
		* special tags
		*/
		else if(this._state === BEFORE_SPECIAL){
			this._stateBeforeSpecial(c);
		} else if(this._state === BEFORE_SPECIAL_END){
			this._stateBeforeSpecialEnd(c);
		}

		/*
		* script
		*/
		else if(this._state === BEFORE_SCRIPT_1){
			this._stateBeforeScript1(c);
		} else if(this._state === BEFORE_SCRIPT_2){
			this._stateBeforeScript2(c);
		} else if(this._state === BEFORE_SCRIPT_3){
			this._stateBeforeScript3(c);
		} else if(this._state === BEFORE_SCRIPT_4){
			this._stateBeforeScript4(c);
		} else if(this._state === BEFORE_SCRIPT_5){
			this._stateBeforeScript5(c);
		}

		else if(this._state === AFTER_SCRIPT_1){
			this._stateAfterScript1(c);
		} else if(this._state === AFTER_SCRIPT_2){
			this._stateAfterScript2(c);
		} else if(this._state === AFTER_SCRIPT_3){
			this._stateAfterScript3(c);
		} else if(this._state === AFTER_SCRIPT_4){
			this._stateAfterScript4(c);
		} else if(this._state === AFTER_SCRIPT_5){
			this._stateAfterScript5(c);
		}

		/*
		* style
		*/
		else if(this._state === BEFORE_STYLE_1){
			this._stateBeforeStyle1(c);
		} else if(this._state === BEFORE_STYLE_2){
			this._stateBeforeStyle2(c);
		} else if(this._state === BEFORE_STYLE_3){
			this._stateBeforeStyle3(c);
		} else if(this._state === BEFORE_STYLE_4){
			this._stateBeforeStyle4(c);
		}

		else if(this._state === AFTER_STYLE_1){
			this._stateAfterStyle1(c);
		} else if(this._state === AFTER_STYLE_2){
			this._stateAfterStyle2(c);
		} else if(this._state === AFTER_STYLE_3){
			this._stateAfterStyle3(c);
		} else if(this._state === AFTER_STYLE_4){
			this._stateAfterStyle4(c);
		}

		/*
		* entities
		*/
		else if(this._state === BEFORE_ENTITY){
			this._stateBeforeEntity(c);
		} else if(this._state === BEFORE_NUMERIC_ENTITY){
			this._stateBeforeNumericEntity(c);
		} else if(this._state === IN_NAMED_ENTITY){
			this._stateInNamedEntity(c);
		} else if(this._state === IN_NUMERIC_ENTITY){
			this._stateInNumericEntity(c);
		} else if(this._state === IN_HEX_ENTITY){
			this._stateInHexEntity(c);
		}

		else {
			this._cbs.onerror(Error("unknown _state"), this._state);
		}

		this._index++;
	}

	this._cleanup();
};

Tokenizer.prototype.pause = function(){
	this._running = false;
};
Tokenizer.prototype.resume = function(){
	this._running = true;

	if(this._index < this._buffer.length){
		this._parse();
	}
	if(this._ended){
		this._finish();
	}
};

Tokenizer.prototype.end = function(chunk){
	if(this._ended) this._cbs.onerror(Error(".end() after done!"));
	if(chunk) this.write(chunk);

	this._ended = true;

	if(this._running) this._finish();
};

Tokenizer.prototype._finish = function(){
	//if there is remaining data, emit it in a reasonable way
	if(this._sectionStart < this._index){
		this._handleTrailingData();
	}

	this._cbs.onend();
};

Tokenizer.prototype._handleTrailingData = function(){
	var data = this._buffer.substr(this._sectionStart);

	if(this._state === IN_CDATA || this._state === AFTER_CDATA_1 || this._state === AFTER_CDATA_2){
		this._cbs.oncdata(data);
	} else if(this._state === IN_COMMENT || this._state === AFTER_COMMENT_1 || this._state === AFTER_COMMENT_2){
		this._cbs.oncomment(data);
	} else if(this._state === IN_NAMED_ENTITY && !this._xmlMode){
		this._parseLegacyEntity();
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(this._state === IN_NUMERIC_ENTITY && !this._xmlMode){
		this._decodeNumericEntity(2, 10);
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(this._state === IN_HEX_ENTITY && !this._xmlMode){
		this._decodeNumericEntity(3, 16);
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(
		this._state !== IN_TAG_NAME &&
		this._state !== BEFORE_ATTRIBUTE_NAME &&
		this._state !== BEFORE_ATTRIBUTE_VALUE &&
		this._state !== AFTER_ATTRIBUTE_NAME &&
		this._state !== IN_ATTRIBUTE_NAME &&
		this._state !== IN_ATTRIBUTE_VALUE_SQ &&
		this._state !== IN_ATTRIBUTE_VALUE_DQ &&
		this._state !== IN_ATTRIBUTE_VALUE_NQ &&
		this._state !== IN_CLOSING_TAG_NAME
	){
		this._cbs.ontext(data);
	}
	//else, ignore remaining data
	//TODO add a way to remove current tag
};

Tokenizer.prototype.reset = function(){
	Tokenizer.call(this, {xmlMode: this._xmlMode, decodeEntities: this._decodeEntities}, this._cbs);
};

Tokenizer.prototype.getAbsoluteIndex = function(){
	return this._bufferOffset + this._index;
};

Tokenizer.prototype._getSection = function(){
	return this._buffer.substring(this._sectionStart, this._index);
};

Tokenizer.prototype._emitToken = function(name){
	this._cbs[name](this._getSection());
	this._sectionStart = -1;
};

Tokenizer.prototype._emitPartial = function(value){
	if(this._baseState !== TEXT){
		this._cbs.onattribdata(value); //TODO implement the new event
	} else {
		this._cbs.ontext(value);
	}
};


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(1966);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"AElig": "Æ",
	"aelig": "æ",
	"Agrave": "À",
	"agrave": "à",
	"amp": "&",
	"AMP": "&",
	"Aring": "Å",
	"aring": "å",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"brvbar": "¦",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"cedil": "¸",
	"cent": "¢",
	"copy": "©",
	"COPY": "©",
	"curren": "¤",
	"deg": "°",
	"divide": "÷",
	"Eacute": "É",
	"eacute": "é",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"Egrave": "È",
	"egrave": "è",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"frac12": "½",
	"frac14": "¼",
	"frac34": "¾",
	"gt": ">",
	"GT": ">",
	"Iacute": "Í",
	"iacute": "í",
	"Icirc": "Î",
	"icirc": "î",
	"iexcl": "¡",
	"Igrave": "Ì",
	"igrave": "ì",
	"iquest": "¿",
	"Iuml": "Ï",
	"iuml": "ï",
	"laquo": "«",
	"lt": "<",
	"LT": "<",
	"macr": "¯",
	"micro": "µ",
	"middot": "·",
	"nbsp": " ",
	"not": "¬",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"Oacute": "Ó",
	"oacute": "ó",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"Ograve": "Ò",
	"ograve": "ò",
	"ordf": "ª",
	"ordm": "º",
	"Oslash": "Ø",
	"oslash": "ø",
	"Otilde": "Õ",
	"otilde": "õ",
	"Ouml": "Ö",
	"ouml": "ö",
	"para": "¶",
	"plusmn": "±",
	"pound": "£",
	"quot": "\"",
	"QUOT": "\"",
	"raquo": "»",
	"reg": "®",
	"REG": "®",
	"sect": "§",
	"shy": "­",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"szlig": "ß",
	"THORN": "Þ",
	"thorn": "þ",
	"times": "×",
	"Uacute": "Ú",
	"uacute": "ú",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uml": "¨",
	"Uuml": "Ü",
	"uuml": "ü",
	"Yacute": "Ý",
	"yacute": "ý",
	"yen": "¥",
	"yuml": "ÿ"
};

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// This object will be used as the prototype for Nodes when creating a
// DOM-Level-1-compliant structure.
var NodePrototype = module.exports = {
	get firstChild() {
		var children = this.children;
		return children && children[0] || null;
	},
	get lastChild() {
		var children = this.children;
		return children && children[children.length - 1] || null;
	},
	get nodeType() {
		return nodeTypes[this.type] || nodeTypes.element;
	}
};

var domLvl1 = {
	tagName: "name",
	childNodes: "children",
	parentNode: "parent",
	previousSibling: "prev",
	nextSibling: "next",
	nodeValue: "data"
};

var nodeTypes = {
	element: 1,
	text: 3,
	cdata: 4,
	comment: 8
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(NodePrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(918),
    WritableStream = __webpack_require__(494).Writable || __webpack_require__(1979).Writable,
    StringDecoder = __webpack_require__(273).StringDecoder,
    Buffer = __webpack_require__(76).Buffer;

function Stream(cbs, options){
	var parser = this._parser = new Parser(cbs, options);
	var decoder = this._decoder = new StringDecoder();

	WritableStream.call(this, {decodeStrings: false});

	this.once("finish", function(){
		parser.end(decoder.end());
	});
}

__webpack_require__(87)(Stream, WritableStream);

WritableStream.prototype._write = function(chunk, encoding, cb){
	if(chunk instanceof Buffer) chunk = this._decoder.write(chunk);
	this._parser.write(chunk);
	cb();
};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(351);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(457);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(141).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(925);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(496).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(148);
util.inherits = __webpack_require__(87);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(1971);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(1972);
var destroyImpl = __webpack_require__(926);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(185);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(273).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(185);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(273).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(66)))

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(141).EventEmitter;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(351);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(185);

/*<replacement>*/
var util = __webpack_require__(148);
util.inherits = __webpack_require__(87);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chip = exports.chipFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Avatar = __webpack_require__(342);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var factory = function factory(Avatar) {
  var Chip = function Chip(_ref) {
    var _classnames;

    var children = _ref.children,
        className = _ref.className,
        deletable = _ref.deletable,
        onDeleteClick = _ref.onDeleteClick,
        theme = _ref.theme,
        other = _objectWithoutProperties(_ref, ['children', 'className', 'deletable', 'onDeleteClick', 'theme']);

    var hasAvatar = false;
    if (_react2.default.Children.count(children)) {
      var flatChildren = _react2.default.Children.toArray(children);
      var firstChild = flatChildren[0];
      hasAvatar = firstChild && firstChild.type && firstChild.type === Avatar;
    }

    var classes = (0, _classnames3.default)(theme.chip, (_classnames = {}, _defineProperty(_classnames, theme.deletable, !!deletable), _defineProperty(_classnames, theme.avatar, !!hasAvatar), _classnames), className);

    return _react2.default.createElement(
      'div',
      _extends({ 'data-react-toolbox': 'chip', className: classes }, other),
      typeof children === 'string' ? _react2.default.createElement(
        'span',
        null,
        children
      ) : children,
      deletable ? _react2.default.createElement(
        'span',
        { className: theme.delete, onClick: onDeleteClick },
        _react2.default.createElement(
          'svg',
          { viewBox: '0 0 40 40', className: theme.deleteIcon },
          _react2.default.createElement('path', {
            className: theme.deleteX,
            d: 'M 12,12 L 28,28 M 28,12 L 12,28'
          })
        )
      ) : null
    );
  };

  Chip.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    deletable: _propTypes2.default.bool,
    onDeleteClick: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      avatar: _propTypes2.default.string,
      chip: _propTypes2.default.string,
      deletable: _propTypes2.default.string,
      delete: _propTypes2.default.string,
      deleteIcon: _propTypes2.default.string,
      deleteX: _propTypes2.default.string
    })
  };

  Chip.defaultProps = {
    className: '',
    deletable: false
  };

  return Chip;
};

var Chip = factory(_Avatar2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.CHIP)(Chip);
exports.chipFactory = factory;
exports.Chip = Chip;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ROTATE_X: ['rotateX(-180deg)', 'rotateX(0deg)'],
  ROTATE_Y: ['rotateY(-180deg)', 'rotateY(0deg)'],
  SCALE: ['scale(1.8, 1.8)', 'scale(1, 1)']
};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2008);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./no-padding-list.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./no-padding-list.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = exports.tabFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _font_icon = __webpack_require__(23);

var _identifiers = __webpack_require__(16);

var _Ripple = __webpack_require__(121);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(ripple) {
  var Tab = function (_Component) {
    _inherits(Tab, _Component);

    function Tab() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Tab);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tab.__proto__ || Object.getPrototypeOf(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
        if (!_this.props.disabled && _this.props.onClick) {
          _this.props.onClick(event, _this.props.index);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Tab, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (!prevProps.active && this.props.active && this.props.onActive) {
          this.props.onActive();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _classnames;

        var _props = this.props,
            index = _props.index,
            onActive = _props.onActive,
            active = _props.active,
            activeClassName = _props.activeClassName,
            children = _props.children,
            className = _props.className,
            disabled = _props.disabled,
            hidden = _props.hidden,
            label = _props.label,
            icon = _props.icon,
            theme = _props.theme,
            other = _objectWithoutProperties(_props, ['index', 'onActive', 'active', 'activeClassName', 'children', 'className', 'disabled', 'hidden', 'label', 'icon', 'theme']);

        var _className = (0, _classnames3.default)(theme.label, (_classnames = {}, _defineProperty(_classnames, theme.active, active), _defineProperty(_classnames, theme.hidden, hidden), _defineProperty(_classnames, theme.withText, label), _defineProperty(_classnames, theme.withIcon, icon), _defineProperty(_classnames, theme.disabled, disabled), _defineProperty(_classnames, activeClassName, active), _classnames), className);

        return _react2.default.createElement(
          'div',
          _extends({}, other, {
            'data-react-toolbox': 'tab',
            className: _className,
            onClick: this.handleClick
          }),
          icon && _react2.default.createElement(_font_icon.FontIcon, { className: theme.icon, value: icon }),
          label,
          children
        );
      }
    }]);

    return Tab;
  }(_react.Component);

  Tab.propTypes = {
    active: _propTypes2.default.bool,
    activeClassName: _propTypes2.default.string,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    hidden: _propTypes2.default.bool,
    icon: _propTypes2.default.node,
    index: _propTypes2.default.number,
    label: _propTypes2.default.node,
    onActive: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      active: _propTypes2.default.string,
      disabled: _propTypes2.default.string,
      hidden: _propTypes2.default.string,
      label: _propTypes2.default.string,
      rippleWrapper: _propTypes2.default.string,
      withIcon: _propTypes2.default.string,
      withText: _propTypes2.default.string
    })
  };
  Tab.defaultProps = {
    active: false,
    className: '',
    disabled: false,
    hidden: false
  };


  return ripple(Tab);
};

var Tab = factory((0, _Ripple2.default)({ centered: false }));
exports.default = (0, _reactCssThemr.themr)(_identifiers.TABS)(Tab);
exports.tabFactory = factory;
exports.Tab = Tab;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabContent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabContent = function (_Component) {
  _inherits(TabContent, _Component);

  function TabContent() {
    _classCallCheck(this, TabContent);

    return _possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
  }

  _createClass(TabContent, [{
    key: 'render',
    value: function render() {
      var className = (0, _classnames3.default)(this.props.theme.tab, _defineProperty({}, this.props.theme.active, this.props.active), this.props.className);

      return _react2.default.createElement(
        'section',
        { className: className, tabIndex: this.props.tabIndex },
        this.props.children
      );
    }
  }]);

  return TabContent;
}(_react.Component);

TabContent.propTypes = {
  active: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  tabIndex: _propTypes2.default.number,
  theme: _propTypes2.default.shape({
    active: _propTypes2.default.string,
    tab: _propTypes2.default.string
  })
};
TabContent.defaultProps = {
  active: false,
  className: ''
};
exports.default = (0, _reactCssThemr.themr)(_identifiers.TABS)(TabContent);
exports.TabContent = TabContent;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2170);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./video-viewer.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./video-viewer.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSTransitionGroup = __webpack_require__(469);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _utils = __webpack_require__(106);

var _time = __webpack_require__(145);

var _time2 = _interopRequireDefault(_time);

var _CalendarMonth = __webpack_require__(2186);

var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DIRECTION_STEPS = { left: -1, right: 1 };

var factory = function factory(IconButton) {
  var Calendar = function (_Component) {
    _inherits(Calendar, _Component);

    function Calendar() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Calendar);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        viewDate: _this.props.selectedDate
      }, _this.handleDayClick = function (day) {
        _this.props.onChange(_time2.default.setDay(_this.state.viewDate, day), true);
      }, _this.handleYearClick = function (event) {
        var year = parseInt(event.currentTarget.id, 10);
        var viewDate = _time2.default.setYear(_this.props.selectedDate, year);
        _this.setState({ viewDate: viewDate });
        _this.props.onChange(viewDate, false);
      }, _this.handleKeys = function (e) {
        var selectedDate = _this.props.selectedDate;


        if (e.which === 37 || e.which === 38 || e.which === 39 || e.which === 40 || e.which === 13) {
          e.preventDefault();
        }

        switch (e.which) {
          case 13:
            _this.props.handleSelect();
            break; // enter
          case 37:
            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, -1));
            break; // left
          case 38:
            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, -7));
            break; // up
          case 39:
            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, 1));
            break; // right
          case 40:
            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, 7));
            break; // down
          default:
            break;
        }
      }, _this.handleDayArrowKey = function (date) {
        _this.setState({ viewDate: date });
        _this.props.onChange(date, false);
      }, _this.changeViewMonth = function (event) {
        var direction = event.currentTarget.id;
        _this.setState({
          direction: direction,
          viewDate: _time2.default.addMonths(_this.state.viewDate, DIRECTION_STEPS[direction])
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Calendar, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        document.body.addEventListener('keydown', this.handleKeys);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        if (this.activeYearNode) {
          this.scrollToActive();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.body.removeEventListener('keydown', this.handleKeys);
      }
    }, {
      key: 'scrollToActive',
      value: function scrollToActive() {
        var offset = this.yearsNode.offsetHeight / 2 + this.activeYearNode.offsetHeight / 2;
        this.yearsNode.scrollTop = this.activeYearNode.offsetTop - offset;
      }
    }, {
      key: 'renderYears',
      value: function renderYears() {
        var _this2 = this;

        return _react2.default.createElement(
          'ul',
          {
            'data-react-toolbox': 'years',
            className: this.props.theme.years,
            ref: function ref(node) {
              _this2.yearsNode = node;
            }
          },
          (0, _utils.range)(1900, 2100).map(function (year) {
            return _react2.default.createElement(
              'li',
              {
                className: year === _this2.state.viewDate.getFullYear() ? _this2.props.theme.active : '',
                id: year,
                key: year,
                onClick: _this2.handleYearClick,
                ref: function ref(node) {
                  if (year === _this2.state.viewDate.getFullYear()) {
                    _this2.activeYearNode = node;
                  }
                }
              },
              year
            );
          })
        );
      }
    }, {
      key: 'renderMonths',
      value: function renderMonths() {
        var theme = this.props.theme;

        var animation = this.state.direction === 'left' ? 'slideLeft' : 'slideRight';
        var animationModule = (0, _utils.getAnimationModule)(animation, theme);
        return _react2.default.createElement(
          'div',
          { 'data-react-toolbox': 'calendar' },
          _react2.default.createElement(IconButton, {
            id: 'left',
            className: theme.prev,
            icon: 'chevron_left',
            onClick: this.changeViewMonth
          }),
          _react2.default.createElement(IconButton, {
            id: 'right',
            className: theme.next,
            icon: 'chevron_right',
            onClick: this.changeViewMonth
          }),
          _react2.default.createElement(
            _CSSTransitionGroup2.default,
            {
              transitionName: animationModule,
              transitionEnterTimeout: 350,
              transitionLeaveTimeout: 350
            },
            _react2.default.createElement(_CalendarMonth2.default, {
              enabledDates: this.props.enabledDates,
              disabledDates: this.props.disabledDates,
              key: this.state.viewDate.getMonth(),
              locale: this.props.locale,
              maxDate: this.props.maxDate,
              minDate: this.props.minDate,
              onDayClick: this.handleDayClick,
              selectedDate: this.props.selectedDate,
              sundayFirstDayOfWeek: this.props.sundayFirstDayOfWeek,
              theme: this.props.theme,
              viewDate: this.state.viewDate
            })
          )
        );
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          { className: this.props.theme.calendar },
          this.props.display === 'months' ? this.renderMonths() : this.renderYears()
        );
      }
    }]);

    return Calendar;
  }(_react.Component);

  Calendar.propTypes = {
    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
    display: _propTypes2.default.oneOf(['months', 'years']),
    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
    handleSelect: _propTypes2.default.func,
    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    maxDate: _propTypes2.default.instanceOf(Date),
    minDate: _propTypes2.default.instanceOf(Date),
    onChange: _propTypes2.default.func,
    selectedDate: _propTypes2.default.instanceOf(Date),
    sundayFirstDayOfWeek: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      active: _propTypes2.default.string,
      calendar: _propTypes2.default.string,
      next: _propTypes2.default.string,
      prev: _propTypes2.default.string,
      years: _propTypes2.default.string
    })
  };
  Calendar.defaultProps = {
    display: 'months',
    selectedDate: new Date()
  };


  return Calendar;
};

exports.default = factory;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _time = __webpack_require__(145);

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(Dialog, Calendar) {
  var CalendarDialog = function (_Component) {
    _inherits(CalendarDialog, _Component);

    function CalendarDialog() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, CalendarDialog);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CalendarDialog.__proto__ || Object.getPrototypeOf(CalendarDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        display: 'months',
        date: _this.props.value
      }, _this.handleNewDate = function (value, dayClick) {
        var state = { display: 'months', date: value };
        if (_time2.default.dateOutOfRange(value, _this.props.minDate, _this.props.maxDate)) {
          if (_this.props.maxDate && _this.props.minDate) {
            state.date = _time2.default.closestDate(value, _this.props.maxDate, _this.props.minDate);
          } else {
            state.date = _this.props.maxDate || _this.props.minDate;
          }
        }
        _this.setState(state);
        if (dayClick && _this.props.autoOk && _this.props.onSelect) {
          _this.props.onSelect(value);
        }
      }, _this.handleSelect = function (event) {
        if (_this.props.onSelect) _this.props.onSelect(_this.state.date, event);
      }, _this.handleSwitchDisplay = function (event) {
        _this.setState({ display: event.target.id });
      }, _this.updateStateDate = function (date) {
        if (Object.prototype.toString.call(date) === '[object Date]') {
          _this.handleNewDate(date, false);
        }
      }, _this.actions = [{
        label: _this.props.cancelLabel,
        className: _this.props.theme.button,
        onClick: _this.props.onDismiss
      }, {
        label: _this.props.okLabel,
        className: _this.props.theme.button,
        name: _this.props.name,
        onClick: _this.handleSelect
      }], _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CalendarDialog, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.updateStateDate(this.props.value);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.updateStateDate(nextProps.value);
      }
    }, {
      key: 'render',
      value: function render() {
        var theme = this.props.theme;

        var display = this.state.display + 'Display';
        var className = (0, _classnames2.default)(theme.dialog, this.props.className);
        var headerClassName = (0, _classnames2.default)(theme.header, theme[display]);
        var shortDayOfWeek = _time2.default.getShortDayOfWeek(this.state.date.getDay(), this.props.locale);
        var shortMonth = _time2.default.getShortMonth(this.state.date, this.props.locale);
        var date = this.state.date.getDate();

        return _react2.default.createElement(
          Dialog,
          {
            actions: this.actions,
            active: this.props.active,
            className: className,
            onEscKeyDown: this.props.onEscKeyDown,
            onOverlayClick: this.props.onOverlayClick,
            type: 'custom'
          },
          _react2.default.createElement(
            'header',
            { className: headerClassName },
            _react2.default.createElement(
              'span',
              {
                id: 'years',
                className: theme.year,
                onClick: this.handleSwitchDisplay
              },
              this.state.date.getFullYear()
            ),
            _react2.default.createElement(
              'h3',
              {
                id: 'months',
                className: theme.date,
                onClick: this.handleSwitchDisplay
              },
              shortDayOfWeek,
              ', ',
              shortMonth,
              ' ',
              date
            )
          ),
          _react2.default.createElement(
            'div',
            { className: theme.calendarWrapper },
            _react2.default.createElement(Calendar, {
              disabledDates: this.props.disabledDates,
              display: this.state.display,
              enabledDates: this.props.enabledDates,
              handleSelect: this.handleSelect,
              maxDate: this.props.maxDate,
              minDate: this.props.minDate,
              onChange: this.handleNewDate,
              selectedDate: this.state.date,
              theme: this.props.theme,
              locale: this.props.locale,
              sundayFirstDayOfWeek: this.props.sundayFirstDayOfWeek
            })
          )
        );
      }
    }]);

    return CalendarDialog;
  }(_react.Component);

  CalendarDialog.propTypes = {
    active: _propTypes2.default.bool,
    autoOk: _propTypes2.default.bool,
    cancelLabel: _propTypes2.default.string,
    className: _propTypes2.default.string,
    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    maxDate: _propTypes2.default.instanceOf(Date),
    minDate: _propTypes2.default.instanceOf(Date),
    name: _propTypes2.default.string,
    okLabel: _propTypes2.default.string,
    onDismiss: _propTypes2.default.func,
    onEscKeyDown: _propTypes2.default.func,
    onOverlayClick: _propTypes2.default.func,
    onSelect: _propTypes2.default.func,
    sundayFirstDayOfWeek: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      button: _propTypes2.default.string,
      calendarWrapper: _propTypes2.default.string,
      date: _propTypes2.default.string,
      dialog: _propTypes2.default.string,
      header: _propTypes2.default.string,
      monthsDisplay: _propTypes2.default.string,
      year: _propTypes2.default.string,
      yearsDisplay: _propTypes2.default.string
    }),
    value: _propTypes2.default.instanceOf(Date)
  };
  CalendarDialog.defaultProps = {
    active: false,
    cancelLabel: 'Cancel',
    className: '',
    okLabel: 'Ok',
    value: new Date()
  };


  return CalendarDialog;
};

exports.default = factory;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _menu = __webpack_require__(63);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _list = __webpack_require__(25);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _templatePanel = __webpack_require__(2193);

var _templatePanel2 = _interopRequireDefault(_templatePanel);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/templates-panel.jsx

var TemplatesPanel = function (_React$Component) {
  _inherits(TemplatesPanel, _React$Component);

  function TemplatesPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TemplatesPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TemplatesPanel.__proto__ || Object.getPrototypeOf(TemplatesPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = { showMenu: false }, _this.cloneTemplate = function (template) {
      if (template) {
        var cloneTemplate = template;
        cloneTemplate.template_id = undefined;
        return cloneTemplate;
      } else {
        return template;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TemplatesPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          templates = _props.templates,
          newTemplate = _props.newTemplate,
          editTemplate = _props.editTemplate,
          deleteTemplate = _props.deleteTemplate,
          isFetching = _props.isFetching;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(_button.Button, { raised: true, theme: _successButton2.default,
            icon: 'add',
            label: t('label:新規作成'),
            onClick: function onClick() {
              return newTemplate(_this2.props);
            } })
        ),
        _react2.default.createElement(
          _card.CardText,
          null,
          isFetching && _react2.default.createElement(_loading2.default, null),
          !isFetching && _react2.default.createElement(
            _list.List,
            { selectable: true },
            !isFetching && (!templates || templates.length == 0) && _react2.default.createElement(_list.ListItem, { caption: t('label:テンプレートは登録されていません'), selectable: false }),
            templates && _lodash2.default.map(templates, function (template) {
              return _react2.default.createElement(_list.ListItem, { key: template.template_id,
                theme: _templatePanel2.default,
                selectable: true,
                ripple: true,
                caption: template.name,
                onClick: function onClick() {
                  return editTemplate(_this2.props, template.template_id);
                },
                rightActions: [_react2.default.createElement(
                  _menu.IconMenu,
                  { key: 'menu', icon: 'more_vert', onClick: function onClick() {
                      return _this2.setState({ showMenu: true });
                    } },
                  _react2.default.createElement(_menu.MenuItem, {
                    icon: 'content_copy',
                    onClick: function onClick() {
                      return newTemplate(_this2.props, _this2.cloneTemplate(template));
                    },
                    caption: t('label:コピーして新規作成') }),
                  _react2.default.createElement(_menu.MenuItem, {
                    icon: 'delete_forever',
                    onClick: function onClick() {
                      return _this2.setState(_defineProperty({}, 'deleteConfirm' + template.template_id, true));
                    },
                    caption: t('label:削除') })
                ), _react2.default.createElement(_confirmDialog2.default, { key: 'dialog',
                  title: t('label:テンプレートを削除してもいいですか', { name: template.name }),
                  description: t('label:この操作は取り消せません'),
                  open: _this2.state['deleteConfirm' + template.template_id],
                  yesLabel: t('label:削除'),
                  noLabel: t('label:取り消し'),
                  onYes: function onYes() {
                    _this2.setState(_defineProperty({}, 'deleteConfirm' + template.template_id, false));deleteTemplate(template);
                  },
                  onNo: function onNo() {
                    return _this2.setState(_defineProperty({}, 'deleteConfirm' + template.template_id, false));
                  } })] });
            })
          )
        )
      );
    }
  }]);

  return TemplatesPanel;
}(_react2.default.Component);

exports.default = TemplatesPanel;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var factory = function factory(ripple) {
  var Radio = function Radio(_ref) {
    var checked = _ref.checked,
        onMouseDown = _ref.onMouseDown,
        theme = _ref.theme,
        other = _objectWithoutProperties(_ref, ['checked', 'onMouseDown', 'theme']);

    return _react2.default.createElement('div', _extends({
      'data-react-toolbox': 'radio',
      className: theme[checked ? 'radioChecked' : 'radio'],
      onMouseDown: onMouseDown
    }, other));
  };

  Radio.propTypes = {
    checked: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    onMouseDown: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      radio: _propTypes2.default.string,
      radioChecked: _propTypes2.default.string,
      ripple: _propTypes2.default.string
    })
  };

  return ripple(Radio);
};

exports.default = factory;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = exports.radioButtonFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Ripple = __webpack_require__(121);

var _Ripple2 = _interopRequireDefault(_Ripple);

var _Radio = __webpack_require__(938);

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(Radio) {
  var RadioButton = function (_Component) {
    _inherits(RadioButton, _Component);

    function RadioButton() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, RadioButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
        var _this$props = _this.props,
            checked = _this$props.checked,
            disabled = _this$props.disabled,
            onChange = _this$props.onChange;

        if (event.pageX !== 0 && event.pageY !== 0) _this.blur();
        if (!disabled && !checked && onChange) onChange(event, _this);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RadioButton, [{
      key: 'blur',
      value: function blur() {
        if (this.inputNode) {
          this.inputNode.blur();
        }
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (this.inputNode) {
          this.inputNode.focus();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            checked = _props.checked,
            children = _props.children,
            className = _props.className,
            disabled = _props.disabled,
            label = _props.label,
            name = _props.name,
            onChange = _props.onChange,
            onMouseEnter = _props.onMouseEnter,
            onMouseLeave = _props.onMouseLeave,
            theme = _props.theme,
            others = _objectWithoutProperties(_props, ['checked', 'children', 'className', 'disabled', 'label', 'name', 'onChange', 'onMouseEnter', 'onMouseLeave', 'theme']);

        var _className = (0, _classnames2.default)(theme[this.props.disabled ? 'disabled' : 'field'], className);
        return _react2.default.createElement(
          'label',
          {
            'data-react-toolbox': 'radio-button',
            className: _className,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
          },
          _react2.default.createElement('input', _extends({}, others, {
            checked: checked,
            className: theme.input,
            disabled: disabled,
            name: name,
            onChange: function onChange() {},
            onClick: this.handleClick,
            ref: function ref(node) {
              _this2.inputNode = node;
            },
            type: 'radio'
          })),
          _react2.default.createElement(Radio, { checked: checked, disabled: disabled, theme: theme }),
          label ? _react2.default.createElement(
            'span',
            { className: theme.text },
            label
          ) : null,
          children
        );
      }
    }]);

    return RadioButton;
  }(_react.Component);

  RadioButton.propTypes = {
    checked: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    name: _propTypes2.default.string,
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onMouseEnter: _propTypes2.default.func,
    onMouseLeave: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      disabled: _propTypes2.default.string,
      field: _propTypes2.default.string,
      input: _propTypes2.default.string,
      text: _propTypes2.default.string
    }),
    value: _propTypes2.default.string
  };
  RadioButton.defaultProps = {
    checked: false,
    className: '',
    disabled: false
  };


  return RadioButton;
};

var Radio = (0, _Radio2.default)((0, _Ripple2.default)({ centered: true, spread: 2.6 }));
var RadioButton = factory(Radio);
exports.default = (0, _reactCssThemr.themr)(_identifiers.RADIO)(RadioButton);
exports.radioButtonFactory = factory;
exports.RadioButton = RadioButton;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var factory = function factory(ripple) {
  var Thumb = function Thumb(_ref) {
    var onMouseDown = _ref.onMouseDown,
        theme = _ref.theme,
        other = _objectWithoutProperties(_ref, ['onMouseDown', 'theme']);

    return _react2.default.createElement('span', _extends({ className: theme.thumb, onMouseDown: onMouseDown }, other));
  };

  Thumb.propTypes = {
    children: _propTypes2.default.node,
    onMouseDown: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      ripple: _propTypes2.default.string,
      thumb: _propTypes2.default.string
    })
  };

  return ripple(Thumb);
};

exports.default = factory;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHead = exports.tableHeadFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Checkbox = __webpack_require__(339);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _TableCell = __webpack_require__(505);

var _TableCell2 = _interopRequireDefault(_TableCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(Checkbox, TableCell) {
  var TableHead = function (_Component) {
    _inherits(TableHead, _Component);

    function TableHead() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TableHead);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableHead.__proto__ || Object.getPrototypeOf(TableHead)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (value, event) {
        _this.props.onSelect(value, event);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TableHead, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            displaySelect = _props.displaySelect,
            multiSelectable = _props.multiSelectable,
            onSelect = _props.onSelect,
            selectable = _props.selectable,
            selected = _props.selected,
            theme = _props.theme,
            other = _objectWithoutProperties(_props, ['children', 'displaySelect', 'multiSelectable', 'onSelect', 'selectable', 'selected', 'theme']);

        return _react2.default.createElement(
          'tr',
          other,
          selectable && _react2.default.createElement(
            TableCell,
            { className: theme.checkboxCell, tagName: 'th' },
            displaySelect && _react2.default.createElement(Checkbox, {
              checked: selected,
              disabled: !multiSelectable,
              onChange: this.handleSelect
            })
          ),
          _react2.default.Children.map(children, function (child, index) {
            if (!child) return null;
            return (0, _react.cloneElement)(child, {
              column: index,
              tagName: 'th'
            });
          })
        );
      }
    }]);

    return TableHead;
  }(_react.Component);

  TableHead.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    displaySelect: _propTypes2.default.bool,
    multiSelectable: _propTypes2.default.bool,
    onSelect: _propTypes2.default.func,
    selectable: _propTypes2.default.bool,
    selected: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      checkboxCell: _propTypes2.default.string
    })
  };
  TableHead.defaultProps = {
    displaySelect: true
  };


  return TableHead;
};

var TableHead = factory(_Checkbox2.default, _TableCell2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.TABLE)(TableHead);
exports.tableHeadFactory = factory;
exports.TableHead = TableHead;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRow = exports.tableRowFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Checkbox = __webpack_require__(339);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _TableCell = __webpack_require__(505);

var _TableCell2 = _interopRequireDefault(_TableCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(Checkbox, TableCell) {
  var TableRow = function (_Component) {
    _inherits(TableRow, _Component);

    function TableRow() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TableRow);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (value) {
        var _this$props = _this.props,
            idx = _this$props.idx,
            onSelect = _this$props.onSelect;

        if (onSelect) onSelect(idx, value);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TableRow, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            className = _props.className,
            selectable = _props.selectable,
            idx = _props.idx,
            selected = _props.selected,
            theme = _props.theme,
            other = _objectWithoutProperties(_props, ['children', 'className', 'selectable', 'idx', 'selected', 'theme']); // eslint-disable-line


        var _className = (0, _classnames3.default)(theme.row, _defineProperty({}, theme.selected, selectable && selected), className);
        return _react2.default.createElement(
          'tr',
          _extends({}, other, { className: _className }),
          selectable && _react2.default.createElement(
            TableCell,
            { className: theme.checkboxCell },
            _react2.default.createElement(Checkbox, { checked: selected, onChange: this.handleSelect })
          ),
          _react2.default.Children.map(children, function (child, index) {
            if (!child) return null;
            return (0, _react.cloneElement)(child, {
              column: index,
              tagName: 'td'
            });
          })
        );
      }
    }]);

    return TableRow;
  }(_react.Component);

  TableRow.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    idx: _propTypes2.default.number,
    onSelect: _propTypes2.default.func,
    selectable: _propTypes2.default.bool,
    selected: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      checkboxCell: _propTypes2.default.string,
      row: _propTypes2.default.string,
      selected: _propTypes2.default.string
    })
  };


  return TableRow;
};

var TableRow = factory(_Checkbox2.default, _TableCell2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.TABLE)(TableRow);
exports.tableRowFactory = factory;
exports.TableRow = TableRow;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _time = __webpack_require__(145);

var _time2 = _interopRequireDefault(_time);

var _Clock = __webpack_require__(2218);

var _Clock2 = _interopRequireDefault(_Clock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(Dialog) {
  var TimePickerDialog = function (_Component) {
    _inherits(TimePickerDialog, _Component);

    function TimePickerDialog() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TimePickerDialog);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePickerDialog.__proto__ || Object.getPrototypeOf(TimePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        display: 'hours',
        displayTime: new Date(_this.props.value.getTime())
      }, _this.handleClockChange = function (value) {
        _this.setState({ displayTime: value });
      }, _this.handleSelect = function (event) {
        _this.props.onSelect(_this.state.displayTime, event);
      }, _this.toggleTimeMode = function () {
        _this.setState({
          displayTime: _time2.default.toggleTimeMode(_this.state.displayTime)
        });
      }, _this.handleHandMoved = function () {
        if (_this.state.display === 'hours') _this.setState({ display: 'minutes' });
      }, _this.switchDisplay = function (event) {
        _this.setState({ display: event.target.id });
      }, _this.actions = [{
        label: _this.props.cancelLabel,
        className: _this.props.theme.button,
        onClick: _this.props.onDismiss
      }, {
        label: _this.props.okLabel,
        className: _this.props.theme.button,
        name: _this.props.name,
        onClick: _this.handleSelect
      }], _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TimePickerDialog, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.value.getTime() !== this.state.displayTime.getTime()) {
          this.setState({ displayTime: new Date(nextProps.value.getTime()) });
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (!prevProps.active && this.props.active) {
          setTimeout(this.clockNode.handleCalculateShape, 1000);
        }
      }
    }, {
      key: 'formatHours',
      value: function formatHours() {
        if (this.props.format === 'ampm') {
          return this.state.displayTime.getHours() % 12 || 12;
        }
        return this.state.displayTime.getHours();
      }
    }, {
      key: 'renderAMPMLabels',
      value: function renderAMPMLabels() {
        var theme = this.props.theme;

        if (this.props.format !== 'ampm') return undefined;
        return _react2.default.createElement(
          'div',
          { className: theme.ampm },
          _react2.default.createElement(
            'span',
            { className: theme.am, onClick: this.toggleTimeMode },
            'AM'
          ),
          _react2.default.createElement(
            'span',
            { className: theme.pm, onClick: this.toggleTimeMode },
            'PM'
          )
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var theme = this.props.theme;

        var display = this.state.display + 'Display';
        var format = _time2.default.getTimeMode(this.state.displayTime) + 'Format';
        var className = (0, _classnames2.default)([theme.dialog, theme[display], theme[format]], this.props.className);
        return _react2.default.createElement(
          Dialog,
          {
            actions: this.actions,
            active: this.props.active,
            className: className,
            onEscKeyDown: this.props.onEscKeyDown,
            onOverlayClick: this.props.onOverlayClick
          },
          _react2.default.createElement(
            'header',
            { className: theme.header },
            _react2.default.createElement(
              'span',
              {
                id: 'hours',
                className: theme.hours,
                onClick: this.switchDisplay
              },
              ('0' + this.formatHours()).slice(-2)
            ),
            _react2.default.createElement(
              'span',
              { className: theme.separator },
              ':'
            ),
            _react2.default.createElement(
              'span',
              {
                id: 'minutes',
                className: theme.minutes,
                onClick: this.switchDisplay
              },
              ('0' + this.state.displayTime.getMinutes()).slice(-2)
            ),
            this.renderAMPMLabels()
          ),
          _react2.default.createElement(_Clock2.default, {
            ref: function ref(node) {
              _this2.clockNode = node;
            },
            display: this.state.display,
            format: this.props.format,
            onChange: this.handleClockChange,
            onHandMoved: this.handleHandMoved,
            theme: this.props.theme,
            time: this.state.displayTime
          })
        );
      }
    }]);

    return TimePickerDialog;
  }(_react.Component);

  TimePickerDialog.propTypes = {
    active: _propTypes2.default.bool,
    cancelLabel: _propTypes2.default.string,
    className: _propTypes2.default.string,
    format: _propTypes2.default.oneOf(['24hr', 'ampm']),
    name: _propTypes2.default.string,
    okLabel: _propTypes2.default.string,
    onDismiss: _propTypes2.default.func,
    onEscKeyDown: _propTypes2.default.func,
    onOverlayClick: _propTypes2.default.func,
    onSelect: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      am: _propTypes2.default.string,
      amFormat: _propTypes2.default.string,
      ampm: _propTypes2.default.string,
      button: _propTypes2.default.string,
      dialog: _propTypes2.default.string,
      header: _propTypes2.default.string,
      hours: _propTypes2.default.string,
      hoursDisplay: _propTypes2.default.string,
      minutes: _propTypes2.default.string,
      minutesDisplay: _propTypes2.default.string,
      pm: _propTypes2.default.string,
      pmFormat: _propTypes2.default.string,
      separator: _propTypes2.default.string
    }),
    value: _propTypes2.default.instanceOf(Date)
  };
  TimePickerDialog.defaultProps = {
    active: false,
    cancelLabel: 'Cancel',
    format: '24hr',
    okLabel: 'Ok',
    value: new Date()
  };


  return TimePickerDialog;
};

exports.default = factory;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(106);

var _events = __webpack_require__(143);

var _events2 = _interopRequireDefault(_events);

var _prefixer = __webpack_require__(336);

var _prefixer2 = _interopRequireDefault(_prefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hand = function (_Component) {
  _inherits(Hand, _Component);

  function Hand() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Hand);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hand.__proto__ || Object.getPrototypeOf(Hand)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      knobWidth: 0
    }, _this.handleMouseMove = function (event) {
      _this.move(_events2.default.getMousePosition(event));
    }, _this.handleTouchMove = function (event) {
      _this.move(_events2.default.getTouchPosition(event));
    }, _this.handleMouseUp = function () {
      _this.end(_this.getMouseEventMap());
    }, _this.handleTouchEnd = function () {
      _this.end(_this.getTouchEventMap());
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hand, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({ knobWidth: _this2.knobNode.offsetWidth });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _events2.default.removeEventsFromDocument(this.getMouseEventMap());
      _events2.default.removeEventsFromDocument(this.getTouchEventMap());
    }
  }, {
    key: 'getMouseEventMap',
    value: function getMouseEventMap() {
      return {
        mousemove: this.handleMouseMove,
        mouseup: this.handleMouseUp
      };
    }
  }, {
    key: 'getTouchEventMap',
    value: function getTouchEventMap() {
      return {
        touchmove: this.handleTouchMove,
        touchend: this.handleTouchEnd
      };
    }
  }, {
    key: 'getPositionRadius',
    value: function getPositionRadius(position) {
      var x = this.props.origin.x - position.x;
      var y = this.props.origin.y - position.y;
      return Math.sqrt(x * x + y * y);
    }
  }, {
    key: 'mouseStart',
    value: function mouseStart(event) {
      _events2.default.addEventsToDocument(this.getMouseEventMap());
      this.move(_events2.default.getMousePosition(event));
    }
  }, {
    key: 'touchStart',
    value: function touchStart(event) {
      _events2.default.addEventsToDocument(this.getTouchEventMap());
      this.move(_events2.default.getTouchPosition(event));
      _events2.default.pauseEvent(event);
    }
  }, {
    key: 'trimAngleToValue',
    value: function trimAngleToValue(angle) {
      return this.props.step * Math.round(angle / this.props.step);
    }
  }, {
    key: 'positionToAngle',
    value: function positionToAngle(position) {
      return (0, _utils.angle360FromPositions)(this.props.origin.x, this.props.origin.y, position.x, position.y);
    }
  }, {
    key: 'end',
    value: function end(evts) {
      if (this.props.onMoved) this.props.onMoved();
      _events2.default.removeEventsFromDocument(evts);
    }
  }, {
    key: 'move',
    value: function move(position) {
      var degrees = this.trimAngleToValue(this.positionToAngle(position));
      var radius = this.getPositionRadius(position);
      if (this.props.onMove) this.props.onMove(degrees === 360 ? 0 : degrees, radius);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var theme = this.props.theme;

      var className = theme.hand + ' ' + this.props.className;
      var handStyle = (0, _prefixer2.default)({
        height: this.props.length - this.state.knobWidth / 2,
        transform: 'rotate(' + this.props.angle + 'deg)'
      });

      return _react2.default.createElement(
        'div',
        { className: className, style: handStyle },
        _react2.default.createElement('div', {
          ref: function ref(node) {
            _this3.knobNode = node;
          },
          className: theme.knob
        })
      );
    }
  }]);

  return Hand;
}(_react.Component);

Hand.propTypes = {
  angle: _propTypes2.default.number,
  className: _propTypes2.default.string,
  length: _propTypes2.default.number,
  onMove: _propTypes2.default.func,
  onMoved: _propTypes2.default.func,
  origin: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),
  step: _propTypes2.default.number,
  theme: _propTypes2.default.shape({
    hand: _propTypes2.default.string,
    knob: _propTypes2.default.string
  })
};
Hand.defaultProps = {
  className: '',
  angle: 0,
  length: 0,
  origin: {}
};
exports.default = Hand;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-mixed-operators */


var Face = function (_Component) {
  _inherits(Face, _Component);

  function Face() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Face);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Face.__proto__ || Object.getPrototypeOf(Face)).call.apply(_ref, [this].concat(args))), _this), _this.renderNumber = function (number, idx) {
      var _this$props = _this.props,
          active = _this$props.active,
          radius = _this$props.radius,
          spacing = _this$props.spacing,
          theme = _this$props.theme,
          twoDigits = _this$props.twoDigits;

      return _react2.default.createElement(
        'span',
        {
          className: (0, _classnames3.default)(theme.number, _defineProperty({}, theme.active, number === active)),
          style: _this.numberStyle(radius - spacing, idx + 1),
          key: number
        },
        twoDigits ? ('0' + number).slice(-2) : number
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Face, [{
    key: 'numberStyle',
    value: function numberStyle(rad, num) {
      return {
        position: 'absolute',
        left: rad + rad * Math.sin(360 * (Math.PI / 180) / 12 * (num - 1)) + this.props.spacing,
        top: rad - rad * Math.cos(360 * (Math.PI / 180) / 12 * (num - 1)) + this.props.spacing
      };
    }
  }, {
    key: 'faceStyle',
    value: function faceStyle() {
      return {
        height: this.props.radius * 2,
        width: this.props.radius * 2
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          numbers = _props.numbers,
          onTouchStart = _props.onTouchStart,
          onMouseDown = _props.onMouseDown,
          theme = _props.theme; // eslint-disable-line

      return _react2.default.createElement(
        'div',
        {
          className: theme.face,
          onTouchStart: onTouchStart,
          onMouseDown: onMouseDown,
          style: this.faceStyle()
        },
        numbers.map(this.renderNumber)
      );
    }
  }]);

  return Face;
}(_react.Component);

Face.propTypes = {
  active: _propTypes2.default.number,
  numbers: _propTypes2.default.arrayOf(_propTypes2.default.number),
  radius: _propTypes2.default.number,
  spacing: _propTypes2.default.number,
  theme: _propTypes2.default.shape({
    active: _propTypes2.default.string,
    face: _propTypes2.default.string,
    number: _propTypes2.default.string
  }),
  twoDigits: _propTypes2.default.bool
};
Face.defaultProps = {
  active: null,
  numbers: [],
  radius: 0,
  twoDigits: false
};
exports.default = Face;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(56) && !__webpack_require__(37)(function () {
  return Object.defineProperty(__webpack_require__(507)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(61);
var anObject = __webpack_require__(29);
var getKeys = __webpack_require__(192);

module.exports = __webpack_require__(56) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(99);
var toIObject = __webpack_require__(100);
var arrayIndexOf = __webpack_require__(357)(false);
var IE_PROTO = __webpack_require__(509)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(108);
var $export = __webpack_require__(3);
var toObject = __webpack_require__(64);
var call = __webpack_require__(950);
var isArrayIter = __webpack_require__(512);
var toLength = __webpack_require__(55);
var createProperty = __webpack_require__(513);
var getIterFn = __webpack_require__(514);

$export($export.S + $export.F * !__webpack_require__(358)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(29);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(125)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(167)(KEY);


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(61).f;
var create = __webpack_require__(191);
var redefineAll = __webpack_require__(194);
var ctx = __webpack_require__(108);
var anInstance = __webpack_require__(195);
var forOf = __webpack_require__(196);
var $iterDefine = __webpack_require__(506);
var step = __webpack_require__(951);
var setSpecies = __webpack_require__(197);
var DESCRIPTORS = __webpack_require__(56);
var fastKey = __webpack_require__(168).fastKey;
var validate = __webpack_require__(198);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(3);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(955)('Map') });


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(230);
var from = __webpack_require__(956);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(196);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(363)('Map');


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(364)('Map');


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(55);
var context = __webpack_require__(519);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(520)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(3);
var context = __webpack_require__(519);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(520)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(34);
var has = __webpack_require__(99);
var DESCRIPTORS = __webpack_require__(56);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(93);
var META = __webpack_require__(168).KEY;
var $fails = __webpack_require__(37);
var shared = __webpack_require__(274);
var setToStringTag = __webpack_require__(229);
var uid = __webpack_require__(190);
var wks = __webpack_require__(52);
var wksExt = __webpack_require__(962);
var wksDefine = __webpack_require__(521);
var enumKeys = __webpack_require__(2233);
var isArray = __webpack_require__(360);
var anObject = __webpack_require__(29);
var isObject = __webpack_require__(40);
var toObject = __webpack_require__(64);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(124);
var createDesc = __webpack_require__(189);
var _create = __webpack_require__(191);
var gOPNExt = __webpack_require__(963);
var $GOPD = __webpack_require__(102);
var $GOPS = __webpack_require__(366);
var $DP = __webpack_require__(61);
var $keys = __webpack_require__(192);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(199).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(277).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(166)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(92)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(52);


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(100);
var gOPN = __webpack_require__(199).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(521)('asyncIterator');


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(521)('observable');


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2234);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./user-notification-list.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./user-notification-list.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawTemplateFormPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _dec, _class2, _dec2, _class4;
// src/web/components/template-form-panel.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _templateFormPanel = __webpack_require__(2235);

var _templateFormPanel2 = _interopRequireDefault(_templateFormPanel);

var _card = __webpack_require__(28);

var _dialog = __webpack_require__(47);

var _button = __webpack_require__(8);

var _list = __webpack_require__(25);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _reactSortableHoc = __webpack_require__(231);

var _timePickerDialog = __webpack_require__(972);

var _timePickerDialog2 = _interopRequireDefault(_timePickerDialog);

var _importTemplateSelectionDialog = __webpack_require__(2259);

var _importTemplateSelectionDialog2 = _interopRequireDefault(_importTemplateSelectionDialog);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _input = __webpack_require__(59);

var _richTextEditor = __webpack_require__(181);

var _richTextEditor2 = _interopRequireDefault(_richTextEditor);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _formValidator = __webpack_require__(41);

var _reactI18next = __webpack_require__(2);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _fieldEditListItem = __webpack_require__(2261);

var _fieldEditListItem2 = _interopRequireDefault(_fieldEditListItem);

var _sortable = __webpack_require__(278);

var _sortable2 = _interopRequireDefault(_sortable);

var _fieldIcons = __webpack_require__(522);

var _fieldIcons2 = _interopRequireDefault(_fieldIcons);

var _numberRegexp = __webpack_require__(973);

var _numberRegexp2 = _interopRequireDefault(_numberRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragHandler = (0, _reactSortableHoc.SortableHandle)(_class = function (_React$Component) {
  _inherits(DragHandler, _React$Component);

  function DragHandler() {
    _classCallCheck(this, DragHandler);

    return _possibleConstructorReturn(this, (DragHandler.__proto__ || Object.getPrototypeOf(DragHandler)).apply(this, arguments));
  }

  _createClass(DragHandler, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_font_icon2.default, { value: 'drag_indicator', style: { cursor: 'move' } });
    }
  }]);

  return DragHandler;
}(_react2.default.Component)) || _class;

var FieldItem = (_dec = (0, _reactI18next.translate)(), _dec(_class2 = (0, _reactSortableHoc.SortableElement)(_class2 = function (_React$Component2) {
  _inherits(FieldItem, _React$Component2);

  function FieldItem() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, FieldItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = FieldItem.__proto__ || Object.getPrototypeOf(FieldItem)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = { editing: false, timepick: false }, _this2.onEdit = function () {
      _this2.setState({ editing: true });
      _this2.props.onStartEdit();
    }, _this2.onOk = function () {
      if (_this2.props.validateField()) {
        _this2.setState({ editing: false });
        _this2.props.onEndEdit();
      }
    }, _this2.onTypeChange = function (value) {
      return _this2.props.updateField(Object.assign({}, _this2.props.field, { type: value, value: undefined, options: [] }));
    }, _this2.onNameChange = function (value) {
      return _this2.props.updateField(Object.assign({}, _this2.props.field, { name: value.trim() }));
    }, _this2.onRequiredChange = function (value) {
      return _this2.props.updateField(Object.assign({}, _this2.props.field, { required: !!value }));
    }, _this2.onOptionsChange = function (value) {
      return _this2.props.updateField(Object.assign({}, _this2.props.field, { options: value.split(/[\n\r]/) }));
    }, _this2.onValueChange = function (value) {
      return _this2.props.updateField(Object.assign({}, _this2.props.field, { value: _this2.props.field.type == 'numeric' ? parseFloat(value || 0) : value }));
    }, _this2.onTimeValueChange = function (value) {
      _this2.toggleTimePicker();
      _this2.props.updateField(Object.assign({}, _this2.props.field, { value: value }));
    }, _this2.toggleTimePicker = function () {
      return _this2.setState({ timepick: !_this2.state.timepick });
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(FieldItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.field.type == 'new') {
        this.setState({ editing: true });
        this.props.onStartEdit();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          index = _props.index,
          field = _props.field,
          fieldError = _props.fieldError,
          updateField = _props.updateField,
          deleteField = _props.deleteField,
          validateField = _props.validateField;


      var TYPES = [{ value: 'string', label: t('label:form-string') }, { value: 'numeric', label: t('label:form-numeric') }, { value: 'text', label: t('label:form-text') }, { value: 'date', label: t('label:form-date') }, { value: 'time', label: t('label:form-time') }, { value: 'dropdown', label: t('label:form-dropdown') }];

      if (this.state.editing) return _react2.default.createElement(
        _list.ListItem,
        { selectable: false, ripple: false, theme: _fieldEditListItem2.default, leftIcon: _react2.default.createElement(DragHandler, null) },
        _react2.default.createElement(
          _list.ListItemContent,
          null,
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', flexDirection: 'row' } },
            _react2.default.createElement(
              'div',
              { style: { width: '200px', marginRight: '10px' } },
              _react2.default.createElement(_dropdown2.default, { key: 1, error: field.type == 'new' && t('error:フィールド種別を選択してください'), label: t('label:フィールド種別'), source: TYPES, value: field.type, onChange: this.onTypeChange })
            ),
            _react2.default.createElement(
              'div',
              { style: { flexGrow: 1 } },
              _react2.default.createElement(_input.Input, { label: t('label:フィールド名'), hint: t('label:新しいフィールド'), value: field.name, error: fieldError.name, onChange: this.onNameChange })
            ),
            field.type == 'dropdown' && field.options && field.options.length > 0 && _react2.default.createElement(
              'div',
              { style: { alignSelf: 'center', flexGrow: 0.5, marginLeft: '10px' } },
              _react2.default.createElement(_dropdown2.default, { label: t('label:初期値を指定します'),
                source: field.options.map(function (option) {
                  return { value: option, label: option };
                }),
                value: field.value,
                onChange: this.onValueChange })
            ),
            field.type == 'time' && _react2.default.createElement(
              'div',
              { style: { alignSelf: 'center', flexGrow: 0.5, marginLeft: '10px' } },
              _react2.default.createElement(_button.Button, { label: field.value && t('label:初期値', { value: field.value }) || t('label:初期値を指定します'),
                onClick: this.toggleTimePicker, style: { width: '100%' }, raised: true })
            )
          ),
          field.type == 'dropdown' && _react2.default.createElement(_input.Input, { multiline: true, rows: 5,
            label: t('label:フィールドの選択肢'),
            hint: t('label:ドロップダウン入力の場合の選択肢を改行で区切って列挙します'),
            error: fieldError.options,
            value: (field.options || []).join('\n'),
            onChange: this.onOptionsChange }),
          (field.type == 'string' || field.type == 'numeric') && _react2.default.createElement(_input.Input, { label: t('label:初期値を指定します'),
            type: field.type == 'string' ? 'text' : 'number',
            value: field.value,
            onChange: this.onValueChange }),
          field.type == 'text' && _react2.default.createElement(_input.Input, { label: t('label:初期値を指定します'),
            multiline: true, rows: 5,
            value: field.value,
            onChange: this.onValueChange }),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' } },
            _react2.default.createElement(_checkbox2.default, { label: t('label:必須'), checked: field.required, theme: _fieldEditListItem2.default, onChange: this.onRequiredChange }),
            _react2.default.createElement(_button.Button, { label: t('label:削除'), mini: true, raised: true, icon: 'delete', onClick: deleteField }),
            '\xA0',
            _react2.default.createElement(_button.Button, { label: t('label:OK'), mini: true, primary: true, raised: true, onClick: this.onOk })
          ),
          _react2.default.createElement(_timePickerDialog2.default, { active: this.state.timepick,
            value: field.value,
            okLabel: t('label:OK'),
            cancelLabel: t('label:取り消し'),
            onSelect: this.onTimeValueChange,
            onCancel: this.toggleTimePicker })
        )
      );else return _react2.default.createElement(_list.ListItem, { leftIcon: _react2.default.createElement(DragHandler, null), ripple: true, selectable: true, theme: _fieldEditListItem2.default, className: 'easyInputText',
        caption: field.name,
        legend: (field.type == 'dropdown' ? field.options.join(', ') : t('label:form-' + field.type)) + (field.value ? field.type == 'numeric' && ' - ' + (0, _numberRegexp2.default)(field.value) || ' - ' + field.value : '') + (field.required ? ' - ' + t('label:必須') : ''),
        onClick: this.onEdit });
    }
  }]);

  return FieldItem;
}(_react2.default.Component)) || _class2) || _class2);
var FieldList = (_dec2 = (0, _reactI18next.translate)(), _dec2(_class4 = (0, _reactSortableHoc.SortableContainer)(_class4 = function (_React$Component3) {
  _inherits(FieldList, _React$Component3);

  function FieldList() {
    var _ref2;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, FieldList);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = FieldList.__proto__ || Object.getPrototypeOf(FieldList)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = { disabled: false }, _this3.onStartEdit = function () {
      return _this3.setState({ disabled: true });
    }, _this3.onEndEdit = function () {
      return _this3.setState({ disabled: false });
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(FieldList, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          fields = _props2.fields,
          fieldsError = _props2.fieldsError,
          _updateField = _props2.updateField,
          _validateField = _props2.validateField,
          _deleteField = _props2.deleteField;


      return _react2.default.createElement(
        _list.List,
        null,
        _.map(fields, function (field, i) {
          return _react2.default.createElement(FieldItem, { key: i, index: i, field: field, fieldError: fieldsError[i] || {},
            disabled: _this4.state.disabled,
            onStartEdit: _this4.onStartEdit,
            onEndEdit: _this4.onEndEdit,
            updateField: function updateField(field) {
              return _updateField(i, field);
            },
            validateField: function validateField() {
              return _validateField(i);
            },
            deleteField: function deleteField() {
              return _deleteField(i);
            } });
        })
      );
    }
  }]);

  return FieldList;
}(_react2.default.Component)) || _class4) || _class4);

var TemplateFormPanel = function (_React$Component4) {
  _inherits(TemplateFormPanel, _React$Component4);

  function TemplateFormPanel() {
    var _ref3;

    var _temp3, _this5, _ret3;

    _classCallCheck(this, TemplateFormPanel);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this5 = _possibleConstructorReturn(this, (_ref3 = TemplateFormPanel.__proto__ || Object.getPrototypeOf(TemplateFormPanel)).call.apply(_ref3, [this].concat(args))), _this5), _this5.state = { templateSelection: false, confirmDialog: false, template: undefined }, _this5.addField = function () {
      return _this5.props.addField(_this5.props, {
        name: '',
        type: 'new',
        required: false
      });
    }, _this5.updateField = function (index, field) {
      return _this5.props.updateField(_this5.props, index, field);
    }, _this5.deleteField = function (index) {
      return _this5.props.deleteField(_this5.props, index);
    }, _this5.validateField = function (index) {
      return _this5.props.validateField(_this5.props, index);
    }, _this5.onSortEnd = function (_ref4) {
      var oldIndex = _ref4.oldIndex,
          newIndex = _ref4.newIndex;

      _this5.props.sortField(_this5.props, (0, _reactSortableHoc.arrayMove)(_this5.props.ui.fields, oldIndex, newIndex), (0, _reactSortableHoc.arrayMove)(_this5.props.ui.fieldsError, oldIndex, newIndex));
    }, _this5.onEditorInitialized = function (handlers) {
      _this5.props.updateUI({ handlers: handlers });
      _this5.props.template && setTimeout(function () {
        return handlers.insertValue(_this5.props.template.template);
      }, 0);
    }, _this5.toggleConfirmDialog = function () {
      return _this5.setState({ confirmDialog: !_this5.state.confirmDialog });
    }, _this5.toggleTemplateSelectionDialog = function () {
      return _this5.setState({ templateSelection: !_this5.state.templateSelection });
    }, _this5.onTemplateSelect = function (template) {
      return _this5.setState({
        templateSelection: false,
        confirmDialog: true,
        template: template
      });
    }, _this5.onTemplateConfirmed = function () {
      _this5.toggleConfirmDialog();
      _this5.props.pasteTemplate(_this5.props, _this5.state.template);
    }, _this5.onChangeCategory = function (category) {
      return _this5.props.onChangeCategory(_this5.props, category);
    }, _temp3), _possibleConstructorReturn(_this5, _ret3);
  }

  _createClass(TemplateFormPanel, [{
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props3 = this.props,
          t = _props3.t,
          ui = _props3.ui,
          template = _props3.template,
          isUpdating = _props3.isUpdating,
          updateUI = _props3.updateUI,
          validateAndSubmit = _props3.validateAndSubmit,
          addField = _props3.addField,
          updateField = _props3.updateField,
          deleteField = _props3.deleteField,
          validateField = _props3.validateField,
          addCategory = _props3.addCategory,
          pasteTemplate = _props3.pasteTemplate,
          onChangeCategory = _props3.onChangeCategory;


      var CATEGORY = [{ value: 'diary', icon: 'event_note' }, { value: 'kpi', icon: 'insert_chart' }, { value: 'memo', icon: 'assignment' }];

      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(_button.Button, { raised: true, theme: _successButton2.default,
            icon: 'get_app',
            onClick: this.toggleTemplateSelectionDialog,
            label: t('label:テンプレートをインポート') })
        ),
        _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return validateAndSubmit(_this6.props, e);
            } },
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:テンプレート名')
              )
            ),
            _react2.default.createElement(_input.Input, { name: 'name', required: true,
              label: t('label:テンプレート名'),
              value: ui.name,
              icon: 'edit',
              error: ui.nameError && t('error:テンプレート名を入力してください'),
              onChange: (0, _formValidator.linkUI)(this, 'name') })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:投稿種別')
              )
            ),
            _react2.default.createElement(_dropdown2.default, {
              source: CATEGORY,
              value: ui.category,
              template: function template(item) {
                return _react2.default.createElement(
                  'span',
                  null,
                  '\xA0',
                  _react2.default.createElement(_font_icon2.default, { value: item.icon, style: { verticalAlign: 'bottom' } }),
                  '\xA0',
                  t('diary:' + item.value)
                );
              },
              onChange: this.onChangeCategory })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:内容')
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_richTextEditor2.default, { editTemplate: true,
              placeholder: t("label:テンプレートを作成しましょう"),
              onEditorInitialized: this.onEditorInitialized })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:入力フィールド')
              )
            ),
            _react2.default.createElement(FieldList, { useDragHandle: true,
              helperClass: _sortable2.default.sortable,
              onSortEnd: this.onSortEnd,
              hideSortableGhost: false,
              fields: ui.fields,
              fieldsError: ui.fieldsError,
              updateField: this.updateField,
              validateField: this.validateField,
              deleteField: this.deleteField }),
            _react2.default.createElement(_button.Button, { label: t('label:フィールドを追加'), style: { width: '100%' },
              icon: 'add_box', onClick: this.addField, raised: true })
          ),
          _react2.default.createElement(
            _card.CardActions,
            null,
            _react2.default.createElement(_button.Button, { raised: true, primary: true,
              disabled: isUpdating,
              type: 'submit',
              style: { width: '100%' },
              label: template && template.template_id ? t('label:更新') : t('label:登録') })
          )
        ),
        _react2.default.createElement(_importTemplateSelectionDialog2.default, { active: this.state.templateSelection,
          onClose: this.toggleTemplateSelectionDialog,
          onTemplateSelect: this.onTemplateSelect }),
        _react2.default.createElement(_confirmDialog2.default, { open: this.state.confirmDialog,
          title: t('label:テンプレートを上書きしていいですか'),
          yesLabel: t('label:上書き'),
          noLabel: t('label:取り消し'),
          onNo: this.toggleConfirmDialog,
          onYes: this.onTemplateConfirmed })
      );
    }
  }]);

  return TemplateFormPanel;
}(_react2.default.Component);

var RawTemplateFormPanel = exports.RawTemplateFormPanel = TemplateFormPanel;
exports.default = (0, _templateFormPanel2.default)(TemplateFormPanel);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__ = __webpack_require__(969);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__["a" /* default */])(o, minLen);
}

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _dialog = __webpack_require__(47);

var _input = __webpack_require__(59);

var _input2 = _interopRequireDefault(_input);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _timePickerDialog = __webpack_require__(2257);

var _timePickerDialog2 = _interopRequireDefault(_timePickerDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/time-picker-dialog.jsx

var TimePickerDialog = function (_React$PureComponent) {
  _inherits(TimePickerDialog, _React$PureComponent);

  function TimePickerDialog(props) {
    _classCallCheck(this, TimePickerDialog);

    var _this = _possibleConstructorReturn(this, (TimePickerDialog.__proto__ || Object.getPrototypeOf(TimePickerDialog)).call(this, props));

    _this.handleHour = function (value) {
      value = parseInt(value);
      if (value < 24 && value >= 0) _this.setState({ hour: ('0' + value).slice(value.toString().length - 1) });
    };

    _this.handleMin = function (value) {
      value = parseInt(value);
      if (value < 60 && value >= 0) _this.setState({ min: ('0' + value).slice(value.toString().length - 1) });
    };

    _this.onSelect = function () {
      _this.props.onSelect && _this.props.onSelect(_this.state.hour + ':' + _this.state.min);
    };

    var time = props.value && props.value.split && props.value.split(':') || ['00', '00'];
    _this.state = { hour: time[0], min: time[1] };
    return _this;
  }

  _createClass(TimePickerDialog, [{
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps) {
      if (this.props.value != nextProps.value) {
        var time = nextProps.value && nextProps.value.split && nextProps.value.split(':') || ['00', '00'];
        this.setState({ hour: time[0], min: time[1] });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          value = _props.value,
          active = _props.active,
          onSelect = _props.onSelect,
          onCancel = _props.onCancel,
          okLabel = _props.okLabel,
          cancelLabel = _props.cancelLabel;


      return _react2.default.createElement(
        _dialog.Dialog,
        { active: active,
          onEscKeyDown: onCancel,
          onOverlayClick: onCancel,
          actions: [{ label: cancelLabel, onClick: onCancel }, { label: okLabel, onClick: this.onSelect }] },
        _react2.default.createElement(
          'div',
          { className: _timePickerDialog2.default.wrapper },
          _react2.default.createElement(_input2.default, { autoFocus: true, type: 'number', step: 1, value: this.state.hour, onChange: this.handleHour, className: _timePickerDialog2.default.input }),
          ':',
          _react2.default.createElement(_input2.default, { type: 'number', step: 1, value: this.state.min, onChange: this.handleMin, className: _timePickerDialog2.default.input })
        )
      );
    }
  }]);

  return TimePickerDialog;
}(_react2.default.PureComponent);

exports.default = TimePickerDialog;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  if (typeof value !== 'number') return value;
  // 整数部分と小数部分に分割
  var numData = value.toString().split('.');
  // 整数部分を3桁カンマ区切りへ
  numData[0] = Number(numData[0]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // 小数部分と結合して返却
  return numData.join('.');
};

;
// src/helpers/number-regexp.js

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v6.2.0 (2018-10-17)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(S,K){"object"===typeof module&&module.exports?module.exports=S.document?K(S):K: true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return K(S)}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):S.Highcharts=K(S)})("undefined"!==typeof window?window:this,function(S){var K=function(){var a="undefined"===typeof S?window:S,C=a.document,F=a.navigator&&a.navigator.userAgent||"",I=C&&C.createElementNS&&!!C.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,n=/(edge|msie|trident)/i.test(F)&&!a.opera,f=-1!==F.indexOf("Firefox"),
e=-1!==F.indexOf("Chrome"),u=f&&4>parseInt(F.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highcharts",version:"6.2.0",deg2rad:2*Math.PI/360,doc:C,hasBidiBug:u,hasTouch:C&&void 0!==C.documentElement.ontouchstart,isMS:n,isWebKit:-1!==F.indexOf("AppleWebKit"),isFirefox:f,isChrome:e,isSafari:!e&&-1!==F.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(F),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:I,win:a,marginNames:["plotTop",
"marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){a.timers=[];var C=a.charts,F=a.doc,I=a.win;a.error=function(n,f){n=a.isNumber(n)?"Highcharts error #"+n+": www.highcharts.com/errors/"+n:n;if(f)throw Error(n);I.console&&console.log(n)};a.Fx=function(a,f,e){this.options=f;this.elem=a;this.prop=e};a.Fx.prototype={dSetter:function(){var a=this.paths[0],f=this.paths[1],e=[],u=this.now,x=a.length,t;if(1===u)e=this.toD;else if(x===f.length&&1>u)for(;x--;)t=parseFloat(a[x]),
e[x]=isNaN(t)?f[x]:u*parseFloat(f[x]-t)+t;else e=f;this.elem.attr("d",e,null,!0)},update:function(){var a=this.elem,f=this.prop,e=this.now,u=this.options.step;if(this[f+"Setter"])this[f+"Setter"]();else a.attr?a.element&&a.attr(f,e,null,!0):a.style[f]=e+this.unit;u&&u.call(a,e,this)},run:function(n,f,e){var u=this,x=u.options,t=function(a){return t.stopped?!1:u.step(a)},w=I.requestAnimationFrame||function(a){setTimeout(a,13)},y=function(){for(var c=0;c<a.timers.length;c++)a.timers[c]()||a.timers.splice(c--,
1);a.timers.length&&w(y)};n!==f||this.elem["forceAnimate:"+this.prop]?(this.startTime=+new Date,this.start=n,this.end=f,this.unit=e,this.now=this.start,this.pos=0,t.elem=this.elem,t.prop=this.prop,t()&&1===a.timers.push(t)&&w(y)):(delete x.curAnim[this.prop],x.complete&&0===a.keys(x.curAnim).length&&x.complete.call(this.elem))},step:function(n){var f=+new Date,e,u=this.options,x=this.elem,t=u.complete,w=u.duration,y=u.curAnim;x.attr&&!x.element?n=!1:n||f>=w+this.startTime?(this.now=this.end,this.pos=
1,this.update(),e=y[this.prop]=!0,a.objectEach(y,function(a){!0!==a&&(e=!1)}),e&&t&&t.call(x),n=!1):(this.pos=u.easing((f-this.startTime)/w),this.now=this.start+(this.end-this.start)*this.pos,this.update(),n=!0);return n},initPath:function(n,f,e){function u(a){var b,k;for(d=a.length;d--;)b="M"===a[d]||"L"===a[d],k=/[a-zA-Z]/.test(a[d+3]),b&&k&&a.splice(d+1,0,a[d+1],a[d+2],a[d+1],a[d+2])}function x(a,h){for(;a.length<k;){a[0]=h[k-a.length];var c=a.slice(0,p);[].splice.apply(a,[0,0].concat(c));b&&(c=
a.slice(a.length-p),[].splice.apply(a,[a.length,0].concat(c)),d--)}a[0]="M"}function t(a,d){for(var c=(k-a.length)/p;0<c&&c--;)q=a.slice().splice(a.length/v-p,p*v),q[0]=d[k-p-c*p],h&&(q[p-6]=q[p-2],q[p-5]=q[p-1]),[].splice.apply(a,[a.length/v,0].concat(q)),b&&c--}f=f||"";var w,y=n.startX,c=n.endX,h=-1<f.indexOf("C"),p=h?7:3,k,q,d;f=f.split(" ");e=e.slice();var b=n.isArea,v=b?2:1,J;h&&(u(f),u(e));if(y&&c){for(d=0;d<y.length;d++)if(y[d]===c[0]){w=d;break}else if(y[0]===c[c.length-y.length+d]){w=d;J=
!0;break}void 0===w&&(f=[])}f.length&&a.isNumber(w)&&(k=e.length+w*v*p,J?(x(f,e),t(e,f)):(x(e,f),t(f,e)));return[f,e]},fillSetter:function(){a.Fx.prototype.strokeSetter.apply(this,arguments)},strokeSetter:function(){this.elem.attr(this.prop,a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)}};a.merge=function(){var n,f=arguments,e,u={},x=function(e,n){"object"!==typeof e&&(e={});a.objectEach(n,function(y,c){!a.isObject(y,!0)||a.isClass(y)||a.isDOMElement(y)?e[c]=n[c]:e[c]=x(e[c]||{},
y)});return e};!0===f[0]&&(u=f[1],f=Array.prototype.slice.call(f,2));e=f.length;for(n=0;n<e;n++)u=x(u,f[n]);return u};a.pInt=function(a,f){return parseInt(a,f||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(n,f){return!!n&&"object"===typeof n&&(!f||!a.isArray(n))};a.isDOMElement=function(n){return a.isObject(n)&&"number"===typeof n.nodeType};a.isClass=function(n){var f=
n&&n.constructor;return!(!a.isObject(n,!0)||a.isDOMElement(n)||!f||!f.name||"Object"===f.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)&&Infinity>a&&-Infinity<a};a.erase=function(a,f){for(var e=a.length;e--;)if(a[e]===f){a.splice(e,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(n,f,e){var u;a.isString(f)?a.defined(e)?n.setAttribute(f,e):n&&n.getAttribute&&((u=n.getAttribute(f))||"class"!==f||(u=n.getAttribute(f+"Name"))):a.defined(f)&&a.isObject(f)&&
a.objectEach(f,function(a,e){n.setAttribute(e,a)});return u};a.splat=function(n){return a.isArray(n)?n:[n]};a.syncTimeout=function(a,f,e){if(f)return setTimeout(a,f,e);a.call(0,e)};a.clearTimeout=function(n){a.defined(n)&&clearTimeout(n)};a.extend=function(a,f){var e;a||(a={});for(e in f)a[e]=f[e];return a};a.pick=function(){var a=arguments,f,e,u=a.length;for(f=0;f<u;f++)if(e=a[f],void 0!==e&&null!==e)return e};a.css=function(n,f){a.isMS&&!a.svg&&f&&void 0!==f.opacity&&(f.filter="alpha(opacity\x3d"+
100*f.opacity+")");a.extend(n.style,f)};a.createElement=function(n,f,e,u,x){n=F.createElement(n);var t=a.css;f&&a.extend(n,f);x&&t(n,{padding:0,border:"none",margin:0});e&&t(n,e);u&&u.appendChild(n);return n};a.extendClass=function(n,f){var e=function(){};e.prototype=new n;a.extend(e.prototype,f);return e};a.pad=function(a,f,e){return Array((f||2)+1-String(a).replace("-","").length).join(e||0)+a};a.relativeLength=function(a,f,e){return/%$/.test(a)?f*parseFloat(a)/100+(e||0):parseFloat(a)};a.wrap=
function(a,f,e){var n=a[f];a[f]=function(){var a=Array.prototype.slice.call(arguments),t=arguments,w=this;w.proceed=function(){n.apply(w,arguments.length?arguments:t)};a.unshift(n);a=e.apply(this,a);w.proceed=null;return a}};a.datePropsToTimestamps=function(n){a.objectEach(n,function(f,e){a.isObject(f)&&"function"===typeof f.getTime?n[e]=f.getTime():(a.isObject(f)||a.isArray(f))&&a.datePropsToTimestamps(f)})};a.formatSingle=function(n,f,e){var u=/\.([0-9])/,x=a.defaultOptions.lang;/f$/.test(n)?(e=
(e=n.match(u))?e[1]:-1,null!==f&&(f=a.numberFormat(f,e,x.decimalPoint,-1<n.indexOf(",")?x.thousandsSep:""))):f=(e||a.time).dateFormat(n,f);return f};a.format=function(n,f,e){for(var u="{",x=!1,t,w,y,c,h=[],p;n;){u=n.indexOf(u);if(-1===u)break;t=n.slice(0,u);if(x){t=t.split(":");w=t.shift().split(".");c=w.length;p=f;for(y=0;y<c;y++)p&&(p=p[w[y]]);t.length&&(p=a.formatSingle(t.join(":"),p,e));h.push(p)}else h.push(t);n=n.slice(u+1);u=(x=!x)?"}":"{"}h.push(n);return h.join("")};a.getMagnitude=function(a){return Math.pow(10,
Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(n,f,e,u,x){var t,w=n;e=a.pick(e,1);t=n/e;f||(f=x?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===u&&(1===e?f=a.grep(f,function(a){return 0===a%1}):.1>=e&&(f=[1/e])));for(u=0;u<f.length&&!(w=f[u],x&&w*e>=n||!x&&t<=(f[u]+(f[u+1]||f[u]))/2);u++);return w=a.correctFloat(w*e,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,f){var e=a.length,n,x;for(x=0;x<e;x++)a[x].safeI=x;a.sort(function(a,e){n=f(a,e);return 0===n?
a.safeI-e.safeI:n});for(x=0;x<e;x++)delete a[x].safeI};a.arrayMin=function(a){for(var f=a.length,e=a[0];f--;)a[f]<e&&(e=a[f]);return e};a.arrayMax=function(a){for(var f=a.length,e=a[0];f--;)a[f]>e&&(e=a[f]);return e};a.destroyObjectProperties=function(n,f){a.objectEach(n,function(a,u){a&&a!==f&&a.destroy&&a.destroy();delete n[u]})};a.discardElement=function(n){var f=a.garbageBin;f||(f=a.createElement("div"));n&&f.appendChild(n);f.innerHTML=""};a.correctFloat=function(a,f){return parseFloat(a.toPrecision(f||
14))};a.setAnimation=function(n,f){f.renderer.globalAnimation=a.pick(n,f.options.chart.animation,!0)};a.animObject=function(n){return a.isObject(n)?a.merge(n):{duration:n?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(n,f,e,u){n=+n||0;f=+f;var x=a.defaultOptions.lang,t=(n.toString().split(".")[1]||"").split("e")[0].length,w,y,c=n.toString().split("e");-1===f?f=Math.min(t,20):a.isNumber(f)?f&&c[1]&&0>c[1]&&
(w=f+ +c[1],0<=w?(c[0]=(+c[0]).toExponential(w).split("e")[0],f=w):(c[0]=c[0].split(".")[0]||0,n=20>f?(c[0]*Math.pow(10,c[1])).toFixed(f):0,c[1]=0)):f=2;y=(Math.abs(c[1]?c[0]:n)+Math.pow(10,-Math.max(f,t)-1)).toFixed(f);t=String(a.pInt(y));w=3<t.length?t.length%3:0;e=a.pick(e,x.decimalPoint);u=a.pick(u,x.thousandsSep);n=(0>n?"-":"")+(w?t.substr(0,w)+u:"");n+=t.substr(w).replace(/(\d{3})(?=\d)/g,"$1"+u);f&&(n+=e+y.slice(-f));c[1]&&0!==+n&&(n+="e"+c[1]);return n};Math.easeInOutSine=function(a){return-.5*
(Math.cos(Math.PI*a)-1)};a.getStyle=function(n,f,e){if("width"===f)return Math.max(0,Math.min(n.offsetWidth,n.scrollWidth)-a.getStyle(n,"padding-left")-a.getStyle(n,"padding-right"));if("height"===f)return Math.max(0,Math.min(n.offsetHeight,n.scrollHeight)-a.getStyle(n,"padding-top")-a.getStyle(n,"padding-bottom"));I.getComputedStyle||a.error(27,!0);if(n=I.getComputedStyle(n,void 0))n=n.getPropertyValue(f),a.pick(e,"opacity"!==f)&&(n=a.pInt(n));return n};a.inArray=function(n,f,e){return(a.indexOfPolyfill||
Array.prototype.indexOf).call(f,n,e)};a.grep=function(n,f){return(a.filterPolyfill||Array.prototype.filter).call(n,f)};a.find=Array.prototype.find?function(a,f){return a.find(f)}:function(a,f){var e,u=a.length;for(e=0;e<u;e++)if(f(a[e],e))return a[e]};a.some=function(n,f,e){return(a.somePolyfill||Array.prototype.some).call(n,f,e)};a.map=function(a,f){for(var e=[],u=0,x=a.length;u<x;u++)e[u]=f.call(a[u],a[u],u,a);return e};a.keys=function(n){return(a.keysPolyfill||Object.keys).call(void 0,n)};a.reduce=
function(n,f,e){return(a.reducePolyfill||Array.prototype.reduce).apply(n,2<arguments.length?[f,e]:[f])};a.offset=function(a){var f=F.documentElement;a=a.parentElement||a.parentNode?a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(I.pageYOffset||f.scrollTop)-(f.clientTop||0),left:a.left+(I.pageXOffset||f.scrollLeft)-(f.clientLeft||0)}};a.stop=function(n,f){for(var e=a.timers.length;e--;)a.timers[e].elem!==n||f&&f!==a.timers[e].prop||(a.timers[e].stopped=!0)};a.each=function(n,f,e){return(a.forEachPolyfill||
Array.prototype.forEach).call(n,f,e)};a.objectEach=function(a,f,e){for(var u in a)a.hasOwnProperty(u)&&f.call(e||a[u],a[u],u,a)};a.addEvent=function(n,f,e,u){var x,t=n.addEventListener||a.addEventListenerPolyfill;x="function"===typeof n&&n.prototype?n.prototype.protoEvents=n.prototype.protoEvents||{}:n.hcEvents=n.hcEvents||{};a.Point&&n instanceof a.Point&&n.series&&n.series.chart&&(n.series.chart.runTrackerClick=!0);t&&t.call(n,f,e,!1);x[f]||(x[f]=[]);x[f].push(e);u&&a.isNumber(u.order)&&(e.order=
u.order,x[f].sort(function(a,e){return a.order-e.order}));return function(){a.removeEvent(n,f,e)}};a.removeEvent=function(n,f,e){function u(e,c){var h=n.removeEventListener||a.removeEventListenerPolyfill;h&&h.call(n,e,c,!1)}function x(e){var c,h;n.nodeName&&(f?(c={},c[f]=!0):c=e,a.objectEach(c,function(a,k){if(e[k])for(h=e[k].length;h--;)u(k,e[k][h])}))}var t,w;a.each(["protoEvents","hcEvents"],function(y){var c=n[y];c&&(f?(t=c[f]||[],e?(w=a.inArray(e,t),-1<w&&(t.splice(w,1),c[f]=t),u(f,e)):(x(c),
c[f]=[])):(x(c),n[y]={}))})};a.fireEvent=function(n,f,e,u){var x,t,w,y,c;e=e||{};F.createEvent&&(n.dispatchEvent||n.fireEvent)?(x=F.createEvent("Events"),x.initEvent(f,!0,!0),a.extend(x,e),n.dispatchEvent?n.dispatchEvent(x):n.fireEvent(f,x)):a.each(["protoEvents","hcEvents"],function(h){if(n[h])for(t=n[h][f]||[],w=t.length,e.target||a.extend(e,{preventDefault:function(){e.defaultPrevented=!0},target:n,type:f}),y=0;y<w;y++)(c=t[y])&&!1===c.call(n,e)&&e.preventDefault()});u&&!e.defaultPrevented&&u.call(n,
e)};a.animate=function(n,f,e){var u,x="",t,w,y;a.isObject(e)||(y=arguments,e={duration:y[2],easing:y[3],complete:y[4]});a.isNumber(e.duration)||(e.duration=400);e.easing="function"===typeof e.easing?e.easing:Math[e.easing]||Math.easeInOutSine;e.curAnim=a.merge(f);a.objectEach(f,function(c,h){a.stop(n,h);w=new a.Fx(n,e,h);t=null;"d"===h?(w.paths=w.initPath(n,n.d,f.d),w.toD=f.d,u=0,t=1):n.attr?u=n.attr(h):(u=parseFloat(a.getStyle(n,h))||0,"opacity"!==h&&(x="px"));t||(t=c);t&&t.match&&t.match("px")&&
(t=t.replace(/px/g,""));w.run(u,t,x)})};a.seriesType=function(n,f,e,u,x){var t=a.getOptions(),w=a.seriesTypes;t.plotOptions[n]=a.merge(t.plotOptions[f],e);w[n]=a.extendClass(w[f]||function(){},u);w[n].prototype.type=n;x&&(w[n].prototype.pointClass=a.extendClass(a.Point,x));return w[n]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),f=0;return function(){return"highcharts-"+a+"-"+f++}}();I.jQuery&&(I.jQuery.fn.highcharts=function(){var n=[].slice.call(arguments);if(this[0])return n[0]?
(new (a[a.isString(n[0])?n.shift():"Chart"])(this[0],n[0],n[1]),this):C[a.attr(this[0],"data-highcharts-chart")]})})(K);(function(a){var C=a.each,F=a.isNumber,I=a.map,n=a.merge,f=a.pInt;a.Color=function(e){if(!(this instanceof a.Color))return new a.Color(e);this.init(e)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[f(a[1]),f(a[2]),f(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
parse:function(a){return[f(a[1]),f(a[2]),f(a[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(e){var f,x,t,w;if((this.input=e=this.names[e&&e.toLowerCase?e.toLowerCase():""]||e)&&e.stops)this.stops=I(e.stops,function(e){return new a.Color(e[1])});else if(e&&e.charAt&&"#"===e.charAt()&&(f=e.length,e=parseInt(e.substr(1),16),7===f?x=[(e&16711680)>>16,(e&65280)>>8,e&255,1]:4===f&&(x=[(e&3840)>>4|(e&3840)>>8,(e&240)>>4|e&240,(e&15)<<4|e&15,1])),!x)for(t=this.parsers.length;t--&&!x;)w=this.parsers[t],
(f=w.regex.exec(e))&&(x=w.parse(f));this.rgba=x||[]},get:function(a){var e=this.input,f=this.rgba,t;this.stops?(t=n(e),t.stops=[].concat(t.stops),C(this.stops,function(e,y){t.stops[y]=[t.stops[y][0],e.get(a)]})):t=f&&F(f[0])?"rgb"===a||!a&&1===f[3]?"rgb("+f[0]+","+f[1]+","+f[2]+")":"a"===a?f[3]:"rgba("+f.join(",")+")":e;return t},brighten:function(a){var e,x=this.rgba;if(this.stops)C(this.stops,function(e){e.brighten(a)});else if(F(a)&&0!==a)for(e=0;3>e;e++)x[e]+=f(255*a),0>x[e]&&(x[e]=0),255<x[e]&&
(x[e]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,f){var e=this.rgba,t=a.rgba;t.length&&e&&e.length?(a=1!==t[3]||1!==e[3],f=(a?"rgba(":"rgb(")+Math.round(t[0]+(e[0]-t[0])*(1-f))+","+Math.round(t[1]+(e[1]-t[1])*(1-f))+","+Math.round(t[2]+(e[2]-t[2])*(1-f))+(a?","+(t[3]+(e[3]-t[3])*(1-f)):"")+")"):f=a.input||"none";return f}};a.color=function(e){return new a.Color(e)}})(K);(function(a){var C,F,I=a.addEvent,n=a.animate,f=a.attr,e=a.charts,u=a.color,x=a.css,
t=a.createElement,w=a.defined,y=a.deg2rad,c=a.destroyObjectProperties,h=a.doc,p=a.each,k=a.extend,q=a.erase,d=a.grep,b=a.hasTouch,v=a.inArray,J=a.isArray,l=a.isFirefox,L=a.isMS,B=a.isObject,D=a.isString,m=a.isWebKit,G=a.merge,A=a.noop,N=a.objectEach,E=a.pick,g=a.pInt,r=a.removeEvent,M=a.stop,O=a.svg,H=a.SVG_NS,R=a.symbolSizes,Q=a.win;C=a.SVGElement=function(){return this};k(C.prototype,{opacity:1,SVG_NS:H,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),
init:function(a,g){this.element="span"===g?t(g):h.createElementNS(this.SVG_NS,g);this.renderer=a},animate:function(z,g,r){g=a.animObject(E(g,this.renderer.globalAnimation,!0));0!==g.duration?(r&&(g.complete=r),n(this,z,g)):(this.attr(z,null,r),g.step&&g.step.call(this));return this},complexColor:function(z,g,r){var b=this.renderer,k,m,d,H,c,h,q,A,v,P,l,O=[],M;a.fireEvent(this.renderer,"complexColor",{args:arguments},function(){z.radialGradient?m="radialGradient":z.linearGradient&&(m="linearGradient");
m&&(d=z[m],c=b.gradients,q=z.stops,P=r.radialReference,J(d)&&(z[m]=d={x1:d[0],y1:d[1],x2:d[2],y2:d[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===m&&P&&!w(d.gradientUnits)&&(H=d,d=G(d,b.getRadialAttr(P,H),{gradientUnits:"userSpaceOnUse"})),N(d,function(a,z){"id"!==z&&O.push(z,a)}),N(q,function(a){O.push(a)}),O=O.join(","),c[O]?l=c[O].attr("id"):(d.id=l=a.uniqueKey(),c[O]=h=b.createElement(m).attr(d).add(b.defs),h.radAttr=H,h.stops=[],p(q,function(z){0===z[1].indexOf("rgba")?(k=a.color(z[1]),
A=k.get("rgb"),v=k.get("a")):(A=z[1],v=1);z=b.createElement("stop").attr({offset:z[0],"stop-color":A,"stop-opacity":v}).add(h);h.stops.push(z)})),M="url("+b.url+"#"+l+")",r.setAttribute(g,M),r.gradient=O,z.toString=function(){return M})})},applyTextOutline:function(z){var g=this.element,r,b,d,m,k;-1!==z.indexOf("contrast")&&(z=z.replace(/contrast/g,this.renderer.getContrast(g.style.fill)));z=z.split(" ");b=z[z.length-1];if((d=z[0])&&"none"!==d&&a.svg){this.fakeTS=!0;z=[].slice.call(g.getElementsByTagName("tspan"));
this.ySetter=this.xSetter;d=d.replace(/(^[\d\.]+)(.*?)$/g,function(a,z,g){return 2*z+g});for(k=z.length;k--;)r=z[k],"highcharts-text-outline"===r.getAttribute("class")&&q(z,g.removeChild(r));m=g.firstChild;p(z,function(a,z){0===z&&(a.setAttribute("x",g.getAttribute("x")),z=g.getAttribute("y"),a.setAttribute("y",z||0),null===z&&g.setAttribute("y",0));a=a.cloneNode(1);f(a,{"class":"highcharts-text-outline",fill:b,stroke:b,"stroke-width":d,"stroke-linejoin":"round"});g.insertBefore(a,m)})}},attr:function(a,
g,r,b){var z,d=this.element,m,k=this,c,H;"string"===typeof a&&void 0!==g&&(z=a,a={},a[z]=g);"string"===typeof a?k=(this[a+"Getter"]||this._defaultGetter).call(this,a,d):(N(a,function(z,g){c=!1;b||M(this,g);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(g)&&(m||(this.symbolAttr(a),m=!0),c=!0);!this.rotation||"x"!==g&&"y"!==g||(this.doTransform=!0);c||(H=this[g+"Setter"]||this._defaultSetter,H.call(this,z,g,d),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(g)&&
this.updateShadows(g,z,H))},this),this.afterSetters());r&&r.call(this);return k},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,g,r){for(var z=this.shadows,d=z.length;d--;)r.call(z[d],"height"===a?Math.max(g-(z[d].cutHeight||0),0):"d"===a?this.d:g,a,z[d])},addClass:function(a,g){var z=this.attr("class")||"";-1===z.indexOf(a)&&(g||(a=(z+(z?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==
v(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var z=this;p("x y r start end width height innerR anchorX anchorY".split(" "),function(g){z[g]=E(a[g],z[g])});z.attr({d:z.renderer.symbols[z.symbolName](z.x,z.y,z.width,z.height,z)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,g){var z;g=g||a.strokeWidth||0;z=Math.round(g)%2/2;
a.x=Math.floor(a.x||this.x||0)+z;a.y=Math.floor(a.y||this.y||0)+z;a.width=Math.floor((a.width||this.width||0)-2*z);a.height=Math.floor((a.height||this.height||0)-2*z);w(a.strokeWidth)&&(a.strokeWidth=g);return a},css:function(a){var z=this.styles,r={},d=this.element,b,m="",c,H=!z,h=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);z&&N(a,function(a,g){a!==z[g]&&(r[g]=a,H=!0)});H&&(z&&(a=k(z,r)),a&&(null===a.width||"auto"===a.width?delete this.textWidth:"text"===d.nodeName.toLowerCase()&&
a.width&&(b=this.textWidth=g(a.width))),this.styles=a,b&&!O&&this.renderer.forExport&&delete a.width,d.namespaceURI===this.SVG_NS?(c=function(a,z){return"-"+z.toLowerCase()},N(a,function(a,z){-1===v(z,h)&&(m+=z.replace(/([A-Z])/g,c)+":"+a+";")}),m&&f(d,"style",m)):x(d,a),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,g){var z=this,r=
z.element;b&&"click"===a?(r.ontouchstart=function(a){z.touchEventFired=Date.now();a.preventDefault();g.call(r,a)},r.onclick=function(a){(-1===Q.navigator.userAgent.indexOf("Android")||1100<Date.now()-(z.touchEventFired||0))&&g.call(r,a)}):r["on"+a]=g;return this},setRadialReference:function(a){var z=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;z&&z.radAttr&&z.animate(this.renderer.getRadialAttr(a,z.radAttr));return this},translate:function(a,g){return this.attr({translateX:a,
translateY:g})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,g=this.translateY||0,r=this.scaleX,d=this.scaleY,b=this.inverted,m=this.rotation,k=this.matrix,c=this.element;b&&(a+=this.width,g+=this.height);a=["translate("+a+","+g+")"];w(k)&&a.push("matrix("+k.join(",")+")");b?a.push("rotate(90) scale(-1,1)"):m&&a.push("rotate("+m+" "+E(this.rotationOriginX,c.getAttribute("x"),0)+" "+E(this.rotationOriginY,c.getAttribute("y")||
0)+")");(w(r)||w(d))&&a.push("scale("+E(r,1)+" "+E(d,1)+")");a.length&&c.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,g,r){var z,d,b,m,k={};d=this.renderer;b=d.alignedObjects;var c,H;if(a){if(this.alignOptions=a,this.alignByTranslate=g,!r||D(r))this.alignTo=z=r||"renderer",q(b,this),b.push(this),r=null}else a=this.alignOptions,g=this.alignByTranslate,z=this.alignTo;r=E(r,d[z],d);z=a.align;d=a.verticalAlign;b=
(r.x||0)+(a.x||0);m=(r.y||0)+(a.y||0);"right"===z?c=1:"center"===z&&(c=2);c&&(b+=(r.width-(a.width||0))/c);k[g?"translateX":"x"]=Math.round(b);"bottom"===d?H=1:"middle"===d&&(H=2);H&&(m+=(r.height-(a.height||0))/H);k[g?"translateY":"y"]=Math.round(m);this[this.placed?"animate":"attr"](k);this.placed=!0;this.alignAttr=k;return this},getBBox:function(a,g){var z,r=this.renderer,d,b=this.element,m=this.styles,c,H=this.textStr,h,q=r.cache,A=r.cacheKeys,v=b.namespaceURI===this.SVG_NS,l;g=E(g,this.rotation);
d=g*y;c=m&&m.fontSize;w(H)&&(l=H.toString(),-1===l.indexOf("\x3c")&&(l=l.replace(/[0-9]/g,"0")),l+=["",g||0,c,this.textWidth,m&&m.textOverflow].join());l&&!a&&(z=q[l]);if(!z){if(v||r.forExport){try{(h=this.fakeTS&&function(a){p(b.querySelectorAll(".highcharts-text-outline"),function(g){g.style.display=a})})&&h("none"),z=b.getBBox?k({},b.getBBox()):{width:b.offsetWidth,height:b.offsetHeight},h&&h("")}catch(X){}if(!z||0>z.width)z={width:0,height:0}}else z=this.htmlGetBBox();r.isSVG&&(a=z.width,r=z.height,
v&&(z.height=r={"11px,17":14,"13px,20":16}[m&&m.fontSize+","+Math.round(r)]||r),g&&(z.width=Math.abs(r*Math.sin(d))+Math.abs(a*Math.cos(d)),z.height=Math.abs(r*Math.cos(d))+Math.abs(a*Math.sin(d))));if(l&&0<z.height){for(;250<A.length;)delete q[A.shift()];q[l]||A.push(l);q[l]=z}}return z},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var g=this;g.animate({opacity:0},{duration:a||150,complete:function(){g.attr({y:-9999})}})},
add:function(a){var g=this.renderer,z=this.element,r;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&g.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)r=this.zIndexSetter();r||(a?a.element:g.box).appendChild(z);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var g=a.parentNode;g&&g.removeChild(a)},destroy:function(){var a=this,g=a.element||{},r=a.renderer.isSVG&&"SPAN"===g.nodeName&&a.parentGroup,d=g.ownerSVGElement,b=a.clipPath;g.onclick=
g.onmouseout=g.onmouseover=g.onmousemove=g.point=null;M(a);b&&d&&(p(d.querySelectorAll("[clip-path],[CLIP-PATH]"),function(a){var g=a.getAttribute("clip-path"),z=b.element.id;(-1<g.indexOf("(#"+z+")")||-1<g.indexOf('("#'+z+'")'))&&a.removeAttribute("clip-path")}),a.clipPath=b.destroy());if(a.stops){for(d=0;d<a.stops.length;d++)a.stops[d]=a.stops[d].destroy();a.stops=null}a.safeRemoveChild(g);for(a.destroyShadows();r&&r.div&&0===r.div.childNodes.length;)g=r.parentGroup,a.safeRemoveChild(r.div),delete r.div,
r=g;a.alignTo&&q(a.renderer.alignedObjects,a);N(a,function(g,z){delete a[z]});return null},shadow:function(a,g,r){var z=[],d,b,m=this.element,k,c,H,h;if(!a)this.destroyShadows();else if(!this.shadows){c=E(a.width,3);H=(a.opacity||.15)/c;h=this.parentInverted?"(-1,-1)":"("+E(a.offsetX,1)+", "+E(a.offsetY,1)+")";for(d=1;d<=c;d++)b=m.cloneNode(0),k=2*c+1-2*d,f(b,{stroke:a.color||"#000000","stroke-opacity":H*d,"stroke-width":k,transform:"translate"+h,fill:"none"}),b.setAttribute("class",(b.getAttribute("class")||
"")+" highcharts-shadow"),r&&(f(b,"height",Math.max(f(b,"height")-k,0)),b.cutHeight=k),g?g.element.appendChild(b):m.parentNode&&m.parentNode.insertBefore(b,m),z.push(b);this.shadows=z}return this},destroyShadows:function(){p(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=E(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):
null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,g,r){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[g]!==a&&(r.setAttribute(g,a),this[g]=a)},dashstyleSetter:function(a){var r,z=this["stroke-width"];"inherit"===z&&(z=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,
"").split(",");for(r=a.length;r--;)a[r]=g(a[r])*z;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.alignValue=a;this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,g,r){this[g]=a;r.setAttribute(g,a)},titleSetter:function(a){var g=this.element.getElementsByTagName("title")[0];g||(g=h.createElementNS(this.SVG_NS,"title"),this.element.appendChild(g));g.firstChild&&g.removeChild(g.firstChild);
g.appendChild(h.createTextNode(String(E(a),"").replace(/<[^>]*>/g,"").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,g,r){"string"===typeof a?r.setAttribute(g,a):a&&this.complexColor(a,g,r)},visibilitySetter:function(a,g,r){"inherit"===a?r.removeAttribute(g):this[g]!==a&&r.setAttribute(g,a);this[g]=a},zIndexSetter:function(a,r){var z=this.renderer,d=this.parentGroup,
b=(d||z).element||z.box,m,k=this.element,c,H,z=b===z.box;m=this.added;var h;w(a)?(k.setAttribute("data-z-index",a),a=+a,this[r]===a&&(m=!1)):w(this[r])&&k.removeAttribute("data-z-index");this[r]=a;if(m){(a=this.zIndex)&&d&&(d.handleZ=!0);r=b.childNodes;for(h=r.length-1;0<=h&&!c;h--)if(d=r[h],m=d.getAttribute("data-z-index"),H=!w(m),d!==k)if(0>a&&H&&!z&&!h)b.insertBefore(k,r[h]),c=!0;else if(g(m)<=a||H&&(!w(a)||0<=a))b.insertBefore(k,r[h+1]||null),c=!0;c||(b.insertBefore(k,r[z?3:0]||null),c=!0)}return c},
_defaultSetter:function(a,g,r){r.setAttribute(g,a)}});C.prototype.yGetter=C.prototype.xGetter;C.prototype.translateXSetter=C.prototype.translateYSetter=C.prototype.rotationSetter=C.prototype.verticalAlignSetter=C.prototype.rotationOriginXSetter=C.prototype.rotationOriginYSetter=C.prototype.scaleXSetter=C.prototype.scaleYSetter=C.prototype.matrixSetter=function(a,g){this[g]=a;this.doTransform=!0};C.prototype["stroke-widthSetter"]=C.prototype.strokeSetter=function(a,g,r){this[g]=a;this.stroke&&this["stroke-width"]?
(C.prototype.fillSetter.call(this,this.stroke,"stroke",r),r.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===g&&0===a&&this.hasStroke&&(r.removeAttribute("stroke"),this.hasStroke=!1)};F=a.SVGRenderer=function(){this.init.apply(this,arguments)};k(F.prototype,{Element:C,SVG_NS:H,init:function(a,g,r,d,b,k){var z;d=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(d));z=d.element;a.appendChild(z);f(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&
f(z,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=z;this.boxWrapper=d;this.alignedObjects=[];this.url=(l||m)&&h.getElementsByTagName("base").length?Q.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(h.createTextNode("Created with Highcharts 6.2.0"));this.defs=this.createElement("defs").add();this.allowHTML=k;this.forExport=b;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(g,
r,!1);var c;l&&a.getBoundingClientRect&&(g=function(){x(a,{left:0,top:0});c=a.getBoundingClientRect();x(a,{left:Math.ceil(c.left)-c.left+"px",top:Math.ceil(c.top)-c.top+"px"})},g(),this.unSubPixelFix=I(Q,"resize",g))},getStyle:function(a){return this.style=k({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=
this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();c(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var g=new this.Element;g.init(this,a);return g},draw:A,getRadialAttr:function(a,g){return{cx:a[0]-a[2]/2+g.cx*a[2],cy:a[1]-a[2]/2+g.cy*a[2],r:g.r*a[2]}},truncate:function(a,g,r,d,b,m,k){var z=this,c=a.rotation,H,q=d?1:0,A=(r||d).length,v=A,p=[],l=function(a){g.firstChild&&
g.removeChild(g.firstChild);a&&g.appendChild(h.createTextNode(a))},O=function(m,c){c=c||m;if(void 0===p[c])if(g.getSubStringLength)try{p[c]=b+g.getSubStringLength(0,d?c+1:c)}catch(Y){}else z.getSpanWidth&&(l(k(r||d,m)),p[c]=b+z.getSpanWidth(a,g));return p[c]},G,M;a.rotation=0;G=O(g.textContent.length);if(M=b+G>m){for(;q<=A;)v=Math.ceil((q+A)/2),d&&(H=k(d,v)),G=O(v,H&&H.length-1),q===A?q=A+1:G>m?A=v-1:q=v;0===A?l(""):r&&A===r.length-1||l(H||k(r||d,v))}d&&d.splice(0,v);a.actualWidth=G;a.rotation=c;
return M},escapes:{"\x26":"\x26amp;","\x3c":"\x26lt;","\x3e":"\x26gt;","'":"\x26#39;",'"':"\x26quot;"},buildText:function(a){var r=a.element,b=this,m=b.forExport,c=E(a.textStr,"").toString(),z=-1!==c.indexOf("\x3c"),k=r.childNodes,q,A=f(r,"x"),l=a.styles,G=a.textWidth,M=l&&l.lineHeight,e=l&&l.textOutline,B=l&&"ellipsis"===l.textOverflow,R=l&&"nowrap"===l.whiteSpace,y=l&&l.fontSize,t,D,J=k.length,l=G&&!a.added&&this.box,w=function(a){var d;d=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:y||
b.style.fontSize||12;return M?g(M):b.fontMetrics(d,a.getAttribute("style")?a:r).h},Q=function(a,g){N(b.escapes,function(r,d){g&&-1!==v(r,g)||(a=a.toString().replace(new RegExp(r,"g"),d))});return a},u=function(a,g){var r;r=a.indexOf("\x3c");a=a.substring(r,a.indexOf("\x3e")-r);r=a.indexOf(g+"\x3d");if(-1!==r&&(r=r+g.length+1,g=a.charAt(r),'"'===g||"'"===g))return a=a.substring(r+1),a.substring(0,a.indexOf(g))};t=[c,B,R,M,e,y,G].join();if(t!==a.textCache){for(a.textCache=t;J--;)r.removeChild(k[J]);
z||e||B||G||-1!==c.indexOf(" ")?(l&&l.appendChild(r),c=z?c.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[c],c=d(c,function(a){return""!==a}),p(c,function(g,d){var c,z=0,k=0;g=g.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");c=g.split("|||");p(c,function(g){if(""!==g||1===
c.length){var v={},l=h.createElementNS(b.SVG_NS,"tspan"),p,M;(p=u(g,"class"))&&f(l,"class",p);if(p=u(g,"style"))p=p.replace(/(;| |^)color([ :])/,"$1fill$2"),f(l,"style",p);(M=u(g,"href"))&&!m&&(f(l,"onclick",'location.href\x3d"'+M+'"'),f(l,"class","highcharts-anchor"),x(l,{cursor:"pointer"}));g=Q(g.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==g){l.appendChild(h.createTextNode(g));z?v.dx=0:d&&null!==A&&(v.x=A);f(l,v);r.appendChild(l);!z&&D&&(!O&&m&&x(l,{display:"block"}),f(l,"dy",w(l)));if(G){var e=
g.replace(/([^\^])-/g,"$1- ").split(" "),v=!R&&(1<c.length||d||1<e.length);M=0;var t=w(l);if(B)q=b.truncate(a,l,g,void 0,0,Math.max(0,G-parseInt(y||12,10)),function(a,g){return a.substring(0,g)+"\u2026"});else if(v)for(;e.length;)e.length&&!R&&0<M&&(l=h.createElementNS(H,"tspan"),f(l,{dy:t,x:A}),p&&f(l,"style",p),l.appendChild(h.createTextNode(e.join(" ").replace(/- /g,"-"))),r.appendChild(l)),b.truncate(a,l,null,e,0===M?k:0,G,function(a,g){return e.slice(0,g).join(" ").replace(/- /g,"-")}),k=a.actualWidth,
M++}z++}}});D=D||r.childNodes.length}),B&&q&&a.attr("title",Q(a.textStr,["\x26lt;","\x26gt;"])),l&&l.removeChild(r),e&&a.applyTextOutline&&a.applyTextOutline(e)):r.appendChild(h.createTextNode(Q(c)))}},getContrast:function(a){a=u(a).rgba;a[0]*=1;a[1]*=1.2;a[2]*=.5;return 459<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,g,r,d,b,c,m,H,h){var z=this.label(a,g,r,h,null,null,null,null,"button"),q=0;z.attr(G({padding:8,r:2},b));var A,v,l,p;b=G({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,
style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},b);A=b.style;delete b.style;c=G(b,{fill:"#e6e6e6"},c);v=c.style;delete c.style;m=G(b,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},m);l=m.style;delete m.style;H=G(b,{style:{color:"#cccccc"}},H);p=H.style;delete H.style;I(z.element,L?"mouseover":"mouseenter",function(){3!==q&&z.setState(1)});I(z.element,L?"mouseout":"mouseleave",function(){3!==q&&z.setState(q)});z.setState=function(a){1!==a&&(z.state=q=a);z.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+
["normal","hover","pressed","disabled"][a||0]);z.attr([b,c,m,H][a||0]).css([A,v,l,p][a||0])};z.attr(b).css(k({cursor:"default"},A));return z.on("click",function(a){3!==q&&d.call(z,a)})},crispLine:function(a,g){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-g%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+g%2/2);return a},path:function(a){var g={fill:"none"};J(a)?g.d=a:B(a)&&k(g,a);return this.createElement("path").attr(g)},circle:function(a,g,r){a=B(a)?a:{x:a,y:g,r:r};g=this.createElement("circle");g.xSetter=
g.ySetter=function(a,g,r){r.setAttribute("c"+g,a)};return g.attr(a)},arc:function(a,g,r,d,b,c){B(a)?(d=a,g=d.y,r=d.r,a=d.x):d={innerR:d,start:b,end:c};a=this.symbol("arc",a,g,r,r,d);a.r=r;return a},rect:function(a,g,r,d,b,c){b=B(a)?a.r:b;var m=this.createElement("rect");a=B(a)?a:void 0===a?{}:{x:a,y:g,width:Math.max(r,0),height:Math.max(d,0)};void 0!==c&&(a.strokeWidth=c,a=m.crisp(a));a.fill="none";b&&(a.r=b);m.rSetter=function(a,g,r){f(r,{rx:a,ry:a})};return m.attr(a)},setSize:function(a,g,r){var d=
this.alignedObjects,b=d.length;this.width=a;this.height=g;for(this.boxWrapper.animate({width:a,height:g},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:E(r,!0)?void 0:0});b--;)d[b].align()},g:function(a){var g=this.createElement("g");return a?g.attr({"class":"highcharts-"+a}):g},image:function(a,g,r,d,b,c){var m={preserveAspectRatio:"none"},H,h=function(a,g){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",g):a.setAttribute("hc-svg-href",
g)},q=function(g){h(H.element,a);c.call(H,g)};1<arguments.length&&k(m,{x:g,y:r,width:d,height:b});H=this.createElement("image").attr(m);c?(h(H.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw\x3d\x3d"),m=new Q.Image,I(m,"load",q),m.src=a,m.complete&&q({})):h(H.element,a);return H},symbol:function(a,g,r,d,b,c){var m=this,H,q=/^url\((.*?)\)$/,A=q.test(a),v=!A&&(this.symbols[a]?a:"circle"),z=v&&this.symbols[v],l=w(g)&&z&&z.call(this.symbols,Math.round(g),Math.round(r),
d,b,c),G,M;z?(H=this.path(l),H.attr("fill","none"),k(H,{symbolName:v,x:g,y:r,width:d,height:b}),c&&k(H,c)):A&&(G=a.match(q)[1],H=this.image(G),H.imgwidth=E(R[G]&&R[G].width,c&&c.width),H.imgheight=E(R[G]&&R[G].height,c&&c.height),M=function(){H.attr({width:H.width,height:H.height})},p(["width","height"],function(a){H[a+"Setter"]=function(a,g){var r={},d=this["img"+g],b="width"===g?"translateX":"translateY";this[g]=a;w(d)&&(this.element&&this.element.setAttribute(g,d),this.alignByTranslate||(r[b]=
((this[g]||0)-d)/2,this.attr(r)))}}),w(g)&&H.attr({x:g,y:r}),H.isImg=!0,w(H.imgwidth)&&w(H.imgheight)?M():(H.attr({width:0,height:0}),t("img",{onload:function(){var a=e[m.chartIndex];0===this.width&&(x(this,{position:"absolute",top:"-999em"}),h.body.appendChild(this));R[G]={width:this.width,height:this.height};H.imgwidth=this.width;H.imgheight=this.height;H.element&&M();this.parentNode&&this.parentNode.removeChild(this);m.imgCount--;if(!m.imgCount&&a&&a.onload)a.onload()},src:G}),this.imgCount++));
return H},symbols:{circle:function(a,g,r,d){return this.arc(a+r/2,g+d/2,r/2,d/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,g,r,d){return["M",a,g,"L",a+r,g,a+r,g+d,a,g+d,"Z"]},triangle:function(a,g,r,d){return["M",a+r/2,g,"L",a+r,g+d,a,g+d,"Z"]},"triangle-down":function(a,g,r,d){return["M",a,g,"L",a+r,g,a+r/2,g+d,"Z"]},diamond:function(a,g,r,d){return["M",a+r/2,g,"L",a+r,g+d/2,a+r/2,g+d,a,g+d/2,"Z"]},arc:function(a,g,r,d,b){var c=b.start,m=b.r||r,H=b.r||d||r,k=b.end-.001;r=b.innerR;d=E(b.open,
.001>Math.abs(b.end-b.start-2*Math.PI));var h=Math.cos(c),q=Math.sin(c),A=Math.cos(k),k=Math.sin(k);b=.001>b.end-c-Math.PI?0:1;m=["M",a+m*h,g+H*q,"A",m,H,0,b,1,a+m*A,g+H*k];w(r)&&m.push(d?"M":"L",a+r*A,g+r*k,"A",r,r,0,b,0,a+r*h,g+r*q);m.push(d?"":"Z");return m},callout:function(a,g,r,d,b){var c=Math.min(b&&b.r||0,r,d),m=c+6,H=b&&b.anchorX;b=b&&b.anchorY;var k;k=["M",a+c,g,"L",a+r-c,g,"C",a+r,g,a+r,g,a+r,g+c,"L",a+r,g+d-c,"C",a+r,g+d,a+r,g+d,a+r-c,g+d,"L",a+c,g+d,"C",a,g+d,a,g+d,a,g+d-c,"L",a,g+c,
"C",a,g,a,g,a+c,g];H&&H>r?b>g+m&&b<g+d-m?k.splice(13,3,"L",a+r,b-6,a+r+6,b,a+r,b+6,a+r,g+d-c):k.splice(13,3,"L",a+r,d/2,H,b,a+r,d/2,a+r,g+d-c):H&&0>H?b>g+m&&b<g+d-m?k.splice(33,3,"L",a,b+6,a-6,b,a,b-6,a,g+c):k.splice(33,3,"L",a,d/2,H,b,a,d/2,a,g+c):b&&b>d&&H>a+m&&H<a+r-m?k.splice(23,3,"L",H+6,g+d,H,g+d+6,H-6,g+d,a+c,g+d):b&&0>b&&H>a+m&&H<a+r-m&&k.splice(3,3,"L",H-6,g,H,g-6,H+6,g,r-c,g);return k}},clipRect:function(g,r,d,b){var c=a.uniqueKey(),m=this.createElement("clipPath").attr({id:c}).add(this.defs);
g=this.rect(g,r,d,b,0).add(m);g.id=c;g.clipPath=m;g.count=0;return g},text:function(a,g,r,d){var b={};if(d&&(this.allowHTML||!this.forExport))return this.html(a,g,r);b.x=Math.round(g||0);r&&(b.y=Math.round(r));w(a)&&(b.text=a);a=this.createElement("text").attr(b);d||(a.xSetter=function(a,g,r){var d=r.getElementsByTagName("tspan"),b,c=r.getAttribute(g),m;for(m=0;m<d.length;m++)b=d[m],b.getAttribute(g)===c&&b.setAttribute(g,a);r.setAttribute(g,a)});return a},fontMetrics:function(a,r){a=a||r&&r.style&&
r.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?g(a):/em/.test(a)?parseFloat(a)*(r?this.fontMetrics(null,r.parentNode).f:16):12;r=24>a?a+3:Math.round(1.2*a);return{h:r,b:Math.round(.8*r),f:a}},rotCorr:function(a,g,r){var d=a;g&&r&&(d=Math.max(d*Math.cos(g*y),4));return{x:-a/3*Math.sin(g*y),y:d}},label:function(g,d,b,c,m,H,h,q,A){var v=this,l=v.g("button"!==A&&"label"),M=l.text=v.text("",0,0,h).attr({zIndex:1}),O,z,e=0,B=3,R=0,f,y,t,D,J,E={},N,x,Q=/^url\((.*?)\)$/.test(c),u=Q,L,n,
P,T;A&&l.addClass("highcharts-"+A);u=Q;L=function(){return(N||0)%2/2};n=function(){var a=M.element.style,g={};z=(void 0===f||void 0===y||J)&&w(M.textStr)&&M.getBBox();l.width=(f||z.width||0)+2*B+R;l.height=(y||z.height||0)+2*B;x=B+v.fontMetrics(a&&a.fontSize,M).b;u&&(O||(l.box=O=v.symbols[c]||Q?v.symbol(c):v.rect(),O.addClass(("button"===A?"":"highcharts-label-box")+(A?" highcharts-"+A+"-box":"")),O.add(l),a=L(),g.x=a,g.y=(q?-x:0)+a),g.width=Math.round(l.width),g.height=Math.round(l.height),O.attr(k(g,
E)),E={})};P=function(){var a=R+B,g;g=q?0:x;w(f)&&z&&("center"===J||"right"===J)&&(a+={center:.5,right:1}[J]*(f-z.width));if(a!==M.x||g!==M.y)M.attr("x",a),M.hasBoxWidthChanged&&(z=M.getBBox(!0),n()),void 0!==g&&M.attr("y",g);M.x=a;M.y=g};T=function(a,g){O?O.attr(a,g):E[a]=g};l.onAdd=function(){M.add(l);l.attr({text:g||0===g?g:"",x:d,y:b});O&&w(m)&&l.attr({anchorX:m,anchorY:H})};l.widthSetter=function(g){f=a.isNumber(g)?g:null};l.heightSetter=function(a){y=a};l["text-alignSetter"]=function(a){J=a};
l.paddingSetter=function(a){w(a)&&a!==B&&(B=l.padding=a,P())};l.paddingLeftSetter=function(a){w(a)&&a!==R&&(R=a,P())};l.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==e&&(e=a,z&&l.attr({x:t}))};l.textSetter=function(a){void 0!==a&&M.textSetter(a);n();P()};l["stroke-widthSetter"]=function(a,g){a&&(u=!0);N=this["stroke-width"]=a;T(g,a)};l.strokeSetter=l.fillSetter=l.rSetter=function(a,g){"r"!==g&&("fill"===g&&a&&(u=!0),l[g]=a);T(g,a)};l.anchorXSetter=function(a,g){m=l.anchorX=a;T(g,Math.round(a)-
L()-t)};l.anchorYSetter=function(a,g){H=l.anchorY=a;T(g,a-D)};l.xSetter=function(a){l.x=a;e&&(a-=e*((f||z.width)+2*B),l["forceAnimate:x"]=!0);t=Math.round(a);l.attr("translateX",t)};l.ySetter=function(a){D=l.y=Math.round(a);l.attr("translateY",D)};var V=l.css;return k(l,{css:function(a){if(a){var g={};a=G(a);p(l.textProps,function(r){void 0!==a[r]&&(g[r]=a[r],delete a[r])});M.css(g);"width"in g&&n()}return V.call(l,a)},getBBox:function(){return{width:z.width+2*B,height:z.height+2*B,x:z.x-B,y:z.y-
B}},shadow:function(a){a&&(n(),O&&O.shadow(a));return l},destroy:function(){r(l.element,"mouseenter");r(l.element,"mouseleave");M&&(M=M.destroy());O&&(O=O.destroy());C.prototype.destroy.call(l);l=v=n=P=T=null}})}});a.Renderer=F})(K);(function(a){var C=a.attr,F=a.createElement,I=a.css,n=a.defined,f=a.each,e=a.extend,u=a.isFirefox,x=a.isMS,t=a.isWebKit,w=a.pick,y=a.pInt,c=a.SVGRenderer,h=a.win,p=a.wrap;e(a.SVGElement.prototype,{htmlCss:function(a){var c="SPAN"===this.element.tagName&&a&&"width"in a,
d=w(c&&a.width,void 0);c&&(delete a.width,this.textWidth=d,this.htmlUpdateTransform());a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=e(this.styles,a);I(this.element,a);return this},htmlGetBBox:function(){var a=this.element;return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,c=this.element,d=this.translateX||0,b=this.translateY||0,h=this.x||0,p=this.y||0,l=this.textAlign||
"left",e={left:0,center:.5,right:1}[l],B=this.styles,t=B&&B.whiteSpace;I(c,{marginLeft:d,marginTop:b});this.shadows&&f(this.shadows,function(a){I(a,{marginLeft:d+1,marginTop:b+1})});this.inverted&&f(c.childNodes,function(d){a.invertChild(d,c)});if("SPAN"===c.tagName){var B=this.rotation,m=this.textWidth&&y(this.textWidth),G=[B,l,c.innerHTML,this.textWidth,this.textAlign].join(),A;(A=m!==this.oldTextWidth)&&!(A=m>this.oldTextWidth)&&((A=this.textPxLength)||(I(c,{width:"",whiteSpace:t||"nowrap"}),A=
c.offsetWidth),A=A>m);A&&/[ \-]/.test(c.textContent||c.innerText)?(I(c,{width:m+"px",display:"block",whiteSpace:t||"normal"}),this.oldTextWidth=m,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;G!==this.cTT&&(t=a.fontMetrics(c.style.fontSize).b,!n(B)||B===(this.oldRotation||0)&&l===this.oldAlign||this.setSpanRotation(B,e,t),this.getSpanCorrection(!n(B)&&this.textPxLength||c.offsetWidth,t,e,B,l));I(c,{left:h+(this.xCorr||0)+"px",top:p+(this.yCorr||0)+"px"});this.cTT=G;this.oldRotation=B;this.oldAlign=
l}}else this.alignOnAdd=!0},setSpanRotation:function(a,c,d){var b={},k=this.renderer.getTransformKey();b[k]=b.transform="rotate("+a+"deg)";b[k+(u?"Origin":"-origin")]=b.transformOrigin=100*c+"% "+d+"px";I(this.element,b)},getSpanCorrection:function(a,c,d){this.xCorr=-a*d;this.yCorr=-c}});e(c.prototype,{getTransformKey:function(){return x&&!/Edge/.test(h.navigator.userAgent)?"-ms-transform":t?"-webkit-transform":u?"MozTransform":h.opera?"-o-transform":""},html:function(a,c,d){var b=this.createElement("span"),
k=b.element,h=b.renderer,l=h.isSVG,q=function(a,d){f(["opacity","visibility"],function(b){p(a,b+"Setter",function(a,b,c,m){a.call(this,b,c,m);d[c]=b})});a.addedSetters=!0};b.textSetter=function(a){a!==k.innerHTML&&delete this.bBox;this.textStr=a;k.innerHTML=w(a,"");b.doTransform=!0};l&&q(b,b.element.style);b.xSetter=b.ySetter=b.alignSetter=b.rotationSetter=function(a,d){"align"===d&&(d="textAlign");b[d]=a;b.doTransform=!0};b.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=
!1)};b.attr({text:a,x:Math.round(c),y:Math.round(d)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});k.style.whiteSpace="nowrap";b.css=b.htmlCss;l&&(b.add=function(a){var d,c=h.box.parentNode,l=[];if(this.parentGroup=a){if(d=a.div,!d){for(;a;)l.push(a),a=a.parentGroup;f(l.reverse(),function(a){function m(g,d){a[d]=g;"translateX"===d?k.left=g+"px":k.top=g+"px";a.doTransform=!0}var k,g=C(a.element,"class");g&&(g={className:g});d=a.div=a.div||F("div",g,{position:"absolute",
left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},d||c);k=d.style;e(a,{classSetter:function(a){return function(g){this.element.setAttribute("class",g);a.className=g}}(d),on:function(){l[0].div&&b.on.apply({element:l[0].div},arguments);return a},translateXSetter:m,translateYSetter:m});a.addedSetters||q(a,k)})}}else d=c;d.appendChild(k);b.added=!0;b.alignOnAdd&&b.htmlUpdateTransform();return b});return b}})})(K);
(function(a){var C=a.defined,F=a.each,I=a.extend,n=a.merge,f=a.pick,e=a.timeUnits,u=a.win;a.Time=function(a){this.update(a,!1)};a.Time.prototype={defaultOptions:{},update:function(a){var e=f(a&&a.useUTC,!0),w=this;this.options=a=n(!0,this.options||{},a);this.Date=a.Date||u.Date;this.timezoneOffset=(this.useUTC=e)&&a.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();(this.variableTimezone=!(e&&!a.getTimezoneOffset&&!a.timezone))||this.timezoneOffset?(this.get=function(a,c){var h=
c.getTime(),p=h-w.getTimezoneOffset(c);c.setTime(p);a=c["getUTC"+a]();c.setTime(h);return a},this.set=function(a,c,h){var p;if("Milliseconds"===a||"Seconds"===a||"Minutes"===a&&0===c.getTimezoneOffset()%60)c["set"+a](h);else p=w.getTimezoneOffset(c),p=c.getTime()-p,c.setTime(p),c["setUTC"+a](h),a=w.getTimezoneOffset(c),p=c.getTime()+a,c.setTime(p)}):e?(this.get=function(a,c){return c["getUTC"+a]()},this.set=function(a,c,h){return c["setUTC"+a](h)}):(this.get=function(a,c){return c["get"+a]()},this.set=
function(a,c,h){return c["set"+a](h)})},makeTime:function(e,t,w,y,c,h){var p,k,q;this.useUTC?(p=this.Date.UTC.apply(0,arguments),k=this.getTimezoneOffset(p),p+=k,q=this.getTimezoneOffset(p),k!==q?p+=q-k:k-36E5!==this.getTimezoneOffset(p-36E5)||a.isSafari||(p-=36E5)):p=(new this.Date(e,t,f(w,1),f(y,0),f(c,0),f(h,0))).getTime();return p},timezoneOffsetFunction:function(){var e=this,f=this.options,w=u.moment;if(!this.useUTC)return function(a){return 6E4*(new Date(a)).getTimezoneOffset()};if(f.timezone){if(w)return function(a){return 6E4*
-w.tz(a,f.timezone).utcOffset()};a.error(25)}return this.useUTC&&f.getTimezoneOffset?function(a){return 6E4*f.getTimezoneOffset(a)}:function(){return 6E4*(e.timezoneOffset||0)}},dateFormat:function(e,f,w){if(!a.defined(f)||isNaN(f))return a.defaultOptions.lang.invalidDate||"";e=a.pick(e,"%Y-%m-%d %H:%M:%S");var t=this,c=new this.Date(f),h=this.get("Hours",c),p=this.get("Day",c),k=this.get("Date",c),q=this.get("Month",c),d=this.get("FullYear",c),b=a.defaultOptions.lang,v=b.weekdays,J=b.shortWeekdays,
l=a.pad,c=a.extend({a:J?J[p]:v[p].substr(0,3),A:v[p],d:l(k),e:l(k,2," "),w:p,b:b.shortMonths[q],B:b.months[q],m:l(q+1),o:q+1,y:d.toString().substr(2,2),Y:d,H:l(h),k:h,I:l(h%12||12),l:h%12||12,M:l(t.get("Minutes",c)),p:12>h?"AM":"PM",P:12>h?"am":"pm",S:l(c.getSeconds()),L:l(Math.floor(f%1E3),3)},a.dateFormats);a.objectEach(c,function(a,d){for(;-1!==e.indexOf("%"+d);)e=e.replace("%"+d,"function"===typeof a?a.call(t,f):a)});return w?e.substr(0,1).toUpperCase()+e.substr(1):e},resolveDTLFormat:function(e){return a.isObject(e,
!0)?e:(e=a.splat(e),{main:e[0],from:e[1],to:e[2]})},getTimeTicks:function(a,t,w,y){var c=this,h=[],p,k={},q;p=new c.Date(t);var d=a.unitRange,b=a.count||1,v;y=f(y,1);if(C(t)){c.set("Milliseconds",p,d>=e.second?0:b*Math.floor(c.get("Milliseconds",p)/b));d>=e.second&&c.set("Seconds",p,d>=e.minute?0:b*Math.floor(c.get("Seconds",p)/b));d>=e.minute&&c.set("Minutes",p,d>=e.hour?0:b*Math.floor(c.get("Minutes",p)/b));d>=e.hour&&c.set("Hours",p,d>=e.day?0:b*Math.floor(c.get("Hours",p)/b));d>=e.day&&c.set("Date",
p,d>=e.month?1:b*Math.floor(c.get("Date",p)/b));d>=e.month&&(c.set("Month",p,d>=e.year?0:b*Math.floor(c.get("Month",p)/b)),q=c.get("FullYear",p));d>=e.year&&c.set("FullYear",p,q-q%b);d===e.week&&(q=c.get("Day",p),c.set("Date",p,c.get("Date",p)-q+y+(q<y?-7:0)));q=c.get("FullYear",p);y=c.get("Month",p);var J=c.get("Date",p),l=c.get("Hours",p);t=p.getTime();c.variableTimezone&&(v=w-t>4*e.month||c.getTimezoneOffset(t)!==c.getTimezoneOffset(w));t=p.getTime();for(p=1;t<w;)h.push(t),t=d===e.year?c.makeTime(q+
p*b,0):d===e.month?c.makeTime(q,y+p*b):!v||d!==e.day&&d!==e.week?v&&d===e.hour&&1<b?c.makeTime(q,y,J,l+p*b):t+d*b:c.makeTime(q,y,J+p*b*(d===e.day?1:7)),p++;h.push(t);d<=e.hour&&1E4>h.length&&F(h,function(a){0===a%18E5&&"000000000"===c.dateFormat("%H%M%S%L",a)&&(k[a]="day")})}h.info=I(a,{higherRanks:k,totalRange:d*b});return h}}})(K);(function(a){var C=a.color,F=a.merge;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle",
"diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:a.Time.prototype.defaultOptions,
chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",
labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",
position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:C("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(C){a.defaultOptions=F(!0,a.defaultOptions,C);
a.time.update(F(a.defaultOptions.global,a.defaultOptions.time),!1);return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;a.time=new a.Time(F(a.defaultOptions.global,a.defaultOptions.time));a.dateFormat=function(C,n,f){return a.time.dateFormat(C,n,f)}})(K);(function(a){var C=a.correctFloat,F=a.defined,I=a.destroyObjectProperties,n=a.fireEvent,f=a.isNumber,e=a.merge,u=a.pick,x=a.deg2rad;a.Tick=function(a,e,f,c,h){this.axis=a;this.pos=
e;this.type=f||"";this.isNewLabel=this.isNew=!0;this.parameters=h||{};this.tickmarkOffset=this.parameters.tickmarkOffset;this.options=this.parameters.options;f||c||this.addLabel()};a.Tick.prototype={addLabel:function(){var f=this,w=f.axis,y=w.options,c=w.chart,h=w.categories,p=w.names,k=f.pos,q=u(f.options&&f.options.labels,y.labels),d=w.tickPositions,b=k===d[0],v=k===d[d.length-1],h=this.parameters.category||(h?u(h[k],p[k],k):k),J=f.label,d=d.info,l,n,B,D;w.isDatetimeAxis&&d&&(n=c.time.resolveDTLFormat(y.dateTimeLabelFormats[!y.grid&&
d.higherRanks[k]||d.unitName]),l=n.main);f.isFirst=b;f.isLast=v;f.formatCtx={axis:w,chart:c,isFirst:b,isLast:v,dateTimeLabelFormat:l,tickPositionInfo:d,value:w.isLog?C(w.lin2log(h)):h,pos:k};y=w.labelFormatter.call(f.formatCtx,this.formatCtx);if(D=n&&n.list)f.shortenLabel=function(){for(B=0;B<D.length;B++)if(J.attr({text:w.labelFormatter.call(a.extend(f.formatCtx,{dateTimeLabelFormat:D[B]}))}),J.getBBox().width<w.getSlotWidth(f)-2*u(q.padding,5))return;J.attr({text:""})};if(F(J))J&&J.textStr!==y&&
(!J.textWidth||q.style&&q.style.width||J.styles.width||J.css({width:null}),J.attr({text:y}));else{if(f.label=J=F(y)&&q.enabled?c.renderer.text(y,0,0,q.useHTML).css(e(q.style)).add(w.labelGroup):null)J.textPxLength=J.getBBox().width;f.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var e=this.axis,f=e.options.labels,c=a.x,h=e.chart.chartWidth,p=e.chart.spacing,k=u(e.labelLeft,Math.min(e.pos,p[3])),p=u(e.labelRight,
Math.max(e.isRadial?0:e.pos+e.len,h-p[1])),q=this.label,d=this.rotation,b={left:0,center:.5,right:1}[e.labelAlign||q.attr("align")],v=q.getBBox().width,J=e.getSlotWidth(this),l=J,t=1,B,D={};if(d||"justify"!==u(f.overflow,"justify"))0>d&&c-b*v<k?B=Math.round(c/Math.cos(d*x)-k):0<d&&c+b*v>p&&(B=Math.round((h-c)/Math.cos(d*x)));else if(h=c+(1-b)*v,c-b*v<k?l=a.x+l*(1-b)-k:h>p&&(l=p-a.x+l*b,t=-1),l=Math.min(J,l),l<J&&"center"===e.labelAlign&&(a.x+=t*(J-l-b*(J-Math.min(v,l)))),v>l||e.autoRotation&&(q.styles||
{}).width)B=l;B&&(this.shortenLabel?this.shortenLabel():(D.width=B,(f.style||{}).textOverflow||(D.textOverflow="ellipsis"),q.css(D)))},getPosition:function(e,f,y,c){var h=this.axis,p=h.chart,k=c&&p.oldChartHeight||p.chartHeight;e={x:e?a.correctFloat(h.translate(f+y,null,null,c)+h.transB):h.left+h.offset+(h.opposite?(c&&p.oldChartWidth||p.chartWidth)-h.right-h.left:0),y:e?k-h.bottom+h.offset-(h.opposite?h.height:0):a.correctFloat(k-h.translate(f+y,null,null,c)-h.transB)};n(this,"afterGetPosition",
{pos:e});return e},getLabelPosition:function(a,e,f,c,h,p,k,q){var d=this.axis,b=d.transA,v=d.reversed,J=d.staggerLines,l=d.tickRotCorr||{x:0,y:0},t=h.y,B=c||d.reserveSpaceDefault?0:-d.labelOffset*("center"===d.labelAlign?.5:1),D={};F(t)||(t=0===d.side?f.rotation?-8:-f.getBBox().height:2===d.side?l.y+8:Math.cos(f.rotation*x)*(l.y-f.getBBox(!1,0).height/2));a=a+h.x+B+l.x-(p&&c?p*b*(v?-1:1):0);e=e+t-(p&&!c?p*b*(v?1:-1):0);J&&(f=k/(q||1)%J,d.opposite&&(f=J-f-1),e+=d.labelOffset/J*f);D.x=a;D.y=Math.round(e);
n(this,"afterGetLabelPosition",{pos:D});return D},getMarkPath:function(a,e,f,c,h,p){return p.crispLine(["M",a,e,"L",a+(h?0:-f),e+(h?f:0)],c)},renderGridLine:function(a,e,f){var c=this.axis,h=c.options,p=this.gridLine,k={},q=this.pos,d=this.type,b=u(this.tickmarkOffset,c.tickmarkOffset),v=c.chart.renderer,J=d?d+"Grid":"grid",l=h[J+"LineWidth"],t=h[J+"LineColor"],h=h[J+"LineDashStyle"];p||(k.stroke=t,k["stroke-width"]=l,h&&(k.dashstyle=h),d||(k.zIndex=1),a&&(e=0),this.gridLine=p=v.path().attr(k).addClass("highcharts-"+
(d?d+"-":"")+"grid-line").add(c.gridGroup));if(p&&(f=c.getPlotLinePath(q+b,p.strokeWidth()*f,a,"pass")))p[a||this.isNew?"attr":"animate"]({d:f,opacity:e})},renderMark:function(a,e,f){var c=this.axis,h=c.options,p=c.chart.renderer,k=this.type,q=k?k+"Tick":"tick",d=c.tickSize(q),b=this.mark,v=!b,J=a.x;a=a.y;var l=u(h[q+"Width"],!k&&c.isXAxis?1:0),h=h[q+"Color"];d&&(c.opposite&&(d[0]=-d[0]),v&&(this.mark=b=p.path().addClass("highcharts-"+(k?k+"-":"")+"tick").add(c.axisGroup),b.attr({stroke:h,"stroke-width":l})),
b[v?"attr":"animate"]({d:this.getMarkPath(J,a,d[0],b.strokeWidth()*f,c.horiz,p),opacity:e}))},renderLabel:function(a,e,y,c){var h=this.axis,p=h.horiz,k=h.options,q=this.label,d=k.labels,b=d.step,h=u(this.tickmarkOffset,h.tickmarkOffset),v=!0,J=a.x;a=a.y;q&&f(J)&&(q.xy=a=this.getLabelPosition(J,a,q,p,d,h,c,b),this.isFirst&&!this.isLast&&!u(k.showFirstLabel,1)||this.isLast&&!this.isFirst&&!u(k.showLastLabel,1)?v=!1:!p||d.step||d.rotation||e||0===y||this.handleOverflow(a),b&&c%b&&(v=!1),v&&f(a.y)?(a.opacity=
y,q[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(q.attr("y",-9999),this.isNewLabel=!0))},render:function(e,f,y){var c=this.axis,h=c.horiz,p=this.pos,k=u(this.tickmarkOffset,c.tickmarkOffset),p=this.getPosition(h,p,k,f),k=p.x,q=p.y,c=h&&k===c.pos+c.len||!h&&q===c.pos?-1:1;y=u(y,1);this.isActive=!0;this.renderGridLine(f,y,c);this.renderMark(p,y,c);this.renderLabel(p,f,y,e);this.isNew=!1;a.fireEvent(this,"afterRender")},destroy:function(){I(this,this.axis)}}})(K);var W=function(a){var C=
a.addEvent,F=a.animObject,I=a.arrayMax,n=a.arrayMin,f=a.color,e=a.correctFloat,u=a.defaultOptions,x=a.defined,t=a.deg2rad,w=a.destroyObjectProperties,y=a.each,c=a.extend,h=a.fireEvent,p=a.format,k=a.getMagnitude,q=a.grep,d=a.inArray,b=a.isArray,v=a.isNumber,J=a.isString,l=a.merge,L=a.normalizeTickInterval,B=a.objectEach,D=a.pick,m=a.removeEvent,G=a.splat,A=a.syncTimeout,N=a.Tick,E=function(){this.init.apply(this,arguments)};a.extend(E.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",
range:!1},second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,labels:{enabled:!0,indentation:10,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",
style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{color:"#000000",fontSize:"11px",fontWeight:"bold",
textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,r){var g=r.isX,b=this;b.chart=a;b.horiz=a.inverted&&!b.isZAxis?!g:g;b.isXAxis=g;b.coll=b.coll||(g?"xAxis":"yAxis");h(this,"init",{userOptions:r});b.opposite=
r.opposite;b.side=r.side||(b.horiz?b.opposite?0:2:b.opposite?1:3);b.setOptions(r);var c=this.options,m=c.type;b.labelFormatter=c.labels.formatter||b.defaultLabelFormatter;b.userOptions=r;b.minPixelPadding=0;b.reversed=c.reversed;b.visible=!1!==c.visible;b.zoomEnabled=!1!==c.zoomEnabled;b.hasNames="category"===m||!0===c.categories;b.categories=c.categories||b.hasNames;b.names||(b.names=[],b.names.keys={});b.plotLinesAndBandsGroups={};b.isLog="logarithmic"===m;b.isDatetimeAxis="datetime"===m;b.positiveValuesOnly=
b.isLog&&!b.allowNegativeLog;b.isLinked=x(c.linkedTo);b.ticks={};b.labelEdge=[];b.minorTicks={};b.plotLinesAndBands=[];b.alternateBands={};b.len=0;b.minRange=b.userMinRange=c.minRange||c.maxZoom;b.range=c.range;b.offset=c.offset||0;b.stacks={};b.oldStacks={};b.stacksTouched=0;b.max=null;b.min=null;b.crosshair=D(c.crosshair,G(a.options.tooltip.crosshairs)[g?0:1],!1);r=b.options.events;-1===d(b,a.axes)&&(g?a.axes.splice(a.xAxis.length,0,b):a.axes.push(b),a[b.coll].push(b));b.series=b.series||[];a.inverted&&
!b.isZAxis&&g&&void 0===b.reversed&&(b.reversed=!0);B(r,function(a,g){C(b,g,a)});b.lin2log=c.linearToLogConverter||b.lin2log;b.isLog&&(b.val2lin=b.log2lin,b.lin2val=b.lin2log);h(this,"afterInit")},setOptions:function(a){this.options=l(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],l(u[this.coll],a));h(this,"afterSetOptions",{userOptions:a})},defaultLabelFormatter:function(){var g=
this.axis,r=this.value,b=g.chart.time,d=g.categories,c=this.dateTimeLabelFormat,m=u.lang,k=m.numericSymbols,m=m.numericSymbolMagnitude||1E3,h=k&&k.length,l,q=g.options.labels.format,g=g.isLog?Math.abs(r):g.tickInterval;if(q)l=p(q,this,b);else if(d)l=r;else if(c)l=b.dateFormat(c,r);else if(h&&1E3<=g)for(;h--&&void 0===l;)b=Math.pow(m,h+1),g>=b&&0===10*r%b&&null!==k[h]&&0!==r&&(l=a.numberFormat(r/b,-1)+k[h]);void 0===l&&(l=1E4<=Math.abs(r)?a.numberFormat(r,-1):a.numberFormat(r,-1,void 0,""));return l},
getSeriesExtremes:function(){var a=this,r=a.chart;h(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();y(a.series,function(g){if(g.visible||!r.options.chart.ignoreHiddenSeries){var b=g.options,d=b.threshold,c;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=d&&(d=null);if(a.isXAxis)b=g.xData,b.length&&(g=n(b),c=I(b),v(g)||g instanceof Date||(b=q(b,v),g=n(b),c=I(b)),b.length&&(a.dataMin=Math.min(D(a.dataMin,
b[0],g),g),a.dataMax=Math.max(D(a.dataMax,b[0],c),c)));else if(g.getExtremes(),c=g.dataMax,g=g.dataMin,x(g)&&x(c)&&(a.dataMin=Math.min(D(a.dataMin,g),g),a.dataMax=Math.max(D(a.dataMax,c),c)),x(d)&&(a.threshold=d),!b.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});h(this,"afterGetSeriesExtremes")},translate:function(a,r,b,d,c,m){var g=this.linkedParent||this,k=1,H=0,l=d?g.oldTransA:g.transA;d=d?g.oldMin:g.min;var h=g.minPixelPadding;c=(g.isOrdinal||g.isBroken||g.isLog&&c)&&g.lin2val;l||
(l=g.transA);b&&(k*=-1,H=g.len);g.reversed&&(k*=-1,H-=k*(g.sector||g.len));r?(a=(a*k+H-h)/l+d,c&&(a=g.lin2val(a))):(c&&(a=g.val2lin(a)),a=v(d)?k*(a-d)*l+H+k*h+(v(m)?l*m:0):void 0);return a},toPixels:function(a,r){return this.translate(a,!1,!this.horiz,null,!0)+(r?0:this.pos)},toValue:function(a,r){return this.translate(a-(r?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,r,b,d,c){var g=this.chart,m=this.left,k=this.top,H,l,h=b&&g.oldChartHeight||g.chartHeight,q=b&&g.oldChartWidth||
g.chartWidth,A;H=this.transB;var e=function(a,g,r){if("pass"!==d&&a<g||a>r)d?a=Math.min(Math.max(g,a),r):A=!0;return a};c=D(c,this.translate(a,null,null,b));c=Math.min(Math.max(-1E5,c),1E5);a=b=Math.round(c+H);H=l=Math.round(h-c-H);v(c)?this.horiz?(H=k,l=h-this.bottom,a=b=e(a,m,m+this.width)):(a=m,b=q-this.right,H=l=e(H,k,k+this.height)):(A=!0,d=!1);return A&&!d?null:g.renderer.crispLine(["M",a,H,"L",b,l],r||1)},getLinearTickPositions:function(a,r,b){var g,d=e(Math.floor(r/a)*a);b=e(Math.ceil(b/a)*
a);var c=[],m;e(d+a)===d&&(m=20);if(this.single)return[r];for(r=d;r<=b;){c.push(r);r=e(r+a,m);if(r===g)break;g=r}return c},getMinorTickInterval:function(){var a=this.options;return!0===a.minorTicks?D(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,r=a.options,b=a.tickPositions,d=a.minorTickInterval,c=[],m=a.pointRangePadding||0,k=a.min-m,m=a.max+m,l=m-k;if(l&&l/d<a.len/3)if(a.isLog)y(this.paddedTicks,function(g,r,b){r&&c.push.apply(c,
a.getLogTickPositions(d,b[r-1],b[r],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())c=c.concat(a.getTimeTicks(a.normalizeTimeTickInterval(d),k,m,r.startOfWeek));else for(r=k+(b[0]-k)%d;r<=m&&r!==c[0];r+=d)c.push(r);0!==c.length&&a.trimTicks(c);return c},adjustForMinRange:function(){var a=this.options,r=this.min,b=this.max,d,c,m,k,l,h,q,v;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(x(a.min)||x(a.max)?this.minRange=null:(y(this.series,function(a){h=a.xData;for(k=q=a.xIncrement?
1:h.length-1;0<k;k--)if(l=h[k]-h[k-1],void 0===m||l<m)m=l}),this.minRange=Math.min(5*m,this.dataMax-this.dataMin)));b-r<this.minRange&&(c=this.dataMax-this.dataMin>=this.minRange,v=this.minRange,d=(v-b+r)/2,d=[r-d,D(a.min,r-d)],c&&(d[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),r=I(d),b=[r+v,D(a.max,r+v)],c&&(b[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),b=n(b),b-r<v&&(d[0]=b-v,d[1]=D(a.min,b-v),r=I(d)));this.min=r;this.max=b},getClosest:function(){var a;this.categories?a=1:y(this.series,
function(g){var r=g.closestPointRange,b=g.visible||!g.chart.options.chart.ignoreHiddenSeries;!g.noSharedTooltip&&x(r)&&b&&(a=x(a)?Math.min(a,r):r)});return a},nameToX:function(a){var g=b(this.categories),c=g?this.categories:this.names,m=a.options.x,k;a.series.requireSorting=!1;x(m)||(m=!1===this.options.uniqueNames?a.series.autoIncrement():g?d(a.name,c):D(c.keys[a.name],-1));-1===m?g||(k=c.length):k=m;void 0!==k&&(this.names[k]=a.name,this.names.keys[a.name]=k);return k},updateNames:function(){var g=
this,r=this.names;0<r.length&&(y(a.keys(r.keys),function(a){delete r.keys[a]}),r.length=0,this.minRange=this.userMinRange,y(this.series||[],function(a){a.xIncrement=null;if(!a.points||a.isDirtyData)a.processData(),a.generatePoints();y(a.points,function(r,b){var d;r.options&&(d=g.nameToX(r),void 0!==d&&d!==r.x&&(r.x=d,a.xData[b]=d))})}))},setAxisTranslation:function(a){var g=this,b=g.max-g.min,d=g.axisPointRange||0,c,m=0,k=0,l=g.linkedParent,q=!!g.categories,v=g.transA,A=g.isXAxis;if(A||q||d)c=g.getClosest(),
l?(m=l.minPointOffset,k=l.pointRangePadding):y(g.series,function(a){var b=q?1:A?D(a.options.pointRange,c,0):g.axisPointRange||0;a=a.options.pointPlacement;d=Math.max(d,b);g.single||(m=Math.max(m,J(a)?0:b/2),k=Math.max(k,"on"===a?0:b))}),l=g.ordinalSlope&&c?g.ordinalSlope/c:1,g.minPointOffset=m*=l,g.pointRangePadding=k*=l,g.pointRange=Math.min(d,b),A&&(g.closestPointRange=c);a&&(g.oldTransA=v);g.translationSlope=g.transA=v=g.staticScale||g.len/(b+k||1);g.transB=g.horiz?g.left:g.bottom;g.minPixelPadding=
v*m;h(this,"afterSetAxisTranslation")},minFromRange:function(){return this.max-this.range},setTickInterval:function(g){var b=this,d=b.chart,c=b.options,m=b.isLog,l=b.isDatetimeAxis,q=b.isXAxis,A=b.isLinked,p=c.maxPadding,f=c.minPadding,G=c.tickInterval,B=c.tickPixelInterval,J=b.categories,E=v(b.threshold)?b.threshold:null,N=b.softThreshold,w,t,u,n;l||J||A||this.getTickAmount();u=D(b.userMin,c.min);n=D(b.userMax,c.max);A?(b.linkedParent=d[b.coll][c.linkedTo],d=b.linkedParent.getExtremes(),b.min=D(d.min,
d.dataMin),b.max=D(d.max,d.dataMax),c.type!==b.linkedParent.options.type&&a.error(11,1)):(!N&&x(E)&&(b.dataMin>=E?(w=E,f=0):b.dataMax<=E&&(t=E,p=0)),b.min=D(u,w,b.dataMin),b.max=D(n,t,b.dataMax));m&&(b.positiveValuesOnly&&!g&&0>=Math.min(b.min,D(b.dataMin,b.min))&&a.error(10,1),b.min=e(b.log2lin(b.min),15),b.max=e(b.log2lin(b.max),15));b.range&&x(b.max)&&(b.userMin=b.min=u=Math.max(b.dataMin,b.minFromRange()),b.userMax=n=b.max,b.range=null);h(b,"foundExtremes");b.beforePadding&&b.beforePadding();
b.adjustForMinRange();!(J||b.axisPointRange||b.usePercentage||A)&&x(b.min)&&x(b.max)&&(d=b.max-b.min)&&(!x(u)&&f&&(b.min-=d*f),!x(n)&&p&&(b.max+=d*p));v(c.softMin)&&!v(b.userMin)&&(b.min=Math.min(b.min,c.softMin));v(c.softMax)&&!v(b.userMax)&&(b.max=Math.max(b.max,c.softMax));v(c.floor)&&(b.min=Math.max(b.min,c.floor));v(c.ceiling)&&(b.max=Math.min(b.max,c.ceiling));N&&x(b.dataMin)&&(E=E||0,!x(u)&&b.min<E&&b.dataMin>=E?b.min=E:!x(n)&&b.max>E&&b.dataMax<=E&&(b.max=E));b.tickInterval=b.min===b.max||
void 0===b.min||void 0===b.max?1:A&&!G&&B===b.linkedParent.options.tickPixelInterval?G=b.linkedParent.tickInterval:D(G,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,J?1:(b.max-b.min)*B/Math.max(b.len,B));q&&!g&&y(b.series,function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();b.postProcessTickInterval&&(b.tickInterval=b.postProcessTickInterval(b.tickInterval));b.pointRange&&!G&&(b.tickInterval=
Math.max(b.pointRange,b.tickInterval));g=D(c.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);!G&&b.tickInterval<g&&(b.tickInterval=g);l||m||G||(b.tickInterval=L(b.tickInterval,null,k(b.tickInterval),D(c.allowDecimals,!(.5<b.tickInterval&&5>b.tickInterval&&1E3<b.max&&9999>b.max)),!!this.tickAmount));this.tickAmount||(b.tickInterval=b.unsquish());this.setTickPositions()},setTickPositions:function(){var g=this.options,b,d=g.tickPositions;b=this.getMinorTickInterval();var c=g.tickPositioner,m=
g.startOnTick,k=g.endOnTick;this.tickmarkOffset=this.categories&&"between"===g.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===b&&this.tickInterval?this.tickInterval/5:b;this.single=this.min===this.max&&x(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==g.allowDecimals);this.tickPositions=b=d&&d.slice();!b&&(!this.ordinalPositions&&(this.max-this.min)/this.tickInterval>Math.max(2*this.len,200)?(b=[this.min,this.max],a.error(19)):b=this.isDatetimeAxis?
this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,g.units),this.min,this.max,g.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()],b[0]===b[1]&&(b.length=1)),this.tickPositions=b,c&&(c=c.apply(this,[this.min,this.max])))&&(this.tickPositions=b=c);this.paddedTicks=b.slice(0);this.trimTicks(b,m,k);this.isLinked||
(this.single&&2>b.length&&(this.min-=.5,this.max+=.5),d||c||this.adjustTickAmount());h(this,"afterSetTickPositions")},trimTicks:function(a,b,d){var g=a[0],c=a[a.length-1],m=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==g)this.min=g;else for(;this.min-m>a[0];)a.shift();if(d)this.max=c;else for(;this.max+m<a[a.length-1];)a.pop();0===a.length&&x(g)&&!this.options.tickPositions&&a.push((c+g)/2)}},alignToOthers:function(){var a={},b,d=this.options;!1===this.chart.options.chart.alignTicks||
!1===d.alignTicks||!1===d.startOnTick||!1===d.endOnTick||this.isLog||y(this.chart[this.coll],function(g){var d=g.options,d=[g.horiz?d.left:d.top,d.width,d.height,d.pane].join();g.series.length&&(a[d]?b=!0:a[d]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,d=a.tickPixelInterval;!x(a.tickInterval)&&this.len<d&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/d)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=
b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,d=this.tickAmount,c=this.finalTickAmt,m=b&&b.length,k=D(this.threshold,this.softThreshold?0:null);if(this.hasData()){if(m<d){for(;b.length<d;)b.length%2||this.min===k?b.push(e(b[b.length-1]+a)):b.unshift(e(b[0]-a));this.transA*=(m-1)/(d-1);this.min=b[0];this.max=b[b.length-1]}else m>d&&(this.tickInterval*=2,this.setTickPositions());if(x(c)){for(a=d=b.length;a--;)(3===c&&1===a%2||2>=c&&0<a&&a<d-1)&&b.splice(a,1);this.finalTickAmt=
void 0}}},setScale:function(){var a,b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;y(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=
this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();h(this,"afterSetScale")},setExtremes:function(a,b,d,m,k){var g=this,r=g.chart;d=D(d,!0);y(g.series,function(a){delete a.kdTree});k=c(k,{min:a,max:b});h(g,"setExtremes",k,function(){g.userMin=a;g.userMax=b;g.eventArgs=k;d&&r.redraw(m)})},zoom:function(a,b){var g=this.dataMin,d=this.dataMax,c=this.options,m=Math.min(g,D(c.min,g)),c=Math.max(d,D(c.max,d));if(a!==this.min||
b!==this.max)this.allowZoomOutside||(x(g)&&(a<m&&(a=m),a>c&&(a=c)),x(d)&&(b<m&&(b=m),b>c&&(b=c))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,d=this.options,c=d.offsets||[0,0,0,0],m=this.horiz,k=this.width=Math.round(a.relativeLength(D(d.width,b.plotWidth-c[3]+c[1]),b.plotWidth)),l=this.height=Math.round(a.relativeLength(D(d.height,b.plotHeight-c[0]+c[2]),b.plotHeight)),h=this.top=Math.round(a.relativeLength(D(d.top,
b.plotTop+c[0]),b.plotHeight,b.plotTop)),d=this.left=Math.round(a.relativeLength(D(d.left,b.plotLeft+c[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-l-h;this.right=b.chartWidth-k-d;this.len=Math.max(m?k:l,0);this.pos=m?d:h},getExtremes:function(){var a=this.isLog;return{min:a?e(this.lin2log(this.min)):this.min,max:a?e(this.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,g=b?this.lin2log(this.min):
this.min,b=b?this.lin2log(this.max):this.max;null===a||-Infinity===a?a=g:Infinity===a?a=b:g>a?a=g:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(D(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,g=b[a+"Length"],d=D(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(d&&g)return"inside"===b[a+"Position"]&&(g=-g),[g,d]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&
this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,d=this.tickInterval,c=d,m=this.len/(((this.categories?1:0)+this.max-this.min)/d),k,l=a.rotation,h=this.labelMetrics(),q,v=Number.MAX_VALUE,A,p=function(a){a/=m||1;a=1<a?Math.ceil(a):1;return e(a*d)};b?(A=!a.staggerLines&&!a.step&&(x(l)?[l]:m<D(a.autoRotationLimit,80)&&a.autoRotation))&&y(A,function(a){var b;if(a===l||a&&-90<=a&&90>=a)q=p(Math.abs(h.h/Math.sin(t*a))),b=
q+Math.abs(a/360),b<v&&(v=b,k=a,c=q)}):a.step||(c=p(h.h));this.autoRotation=A;this.labelRotation=D(k,l);return c},getSlotWidth:function(a){var b=this.chart,g=this.horiz,d=this.options.labels,c=Math.max(this.tickPositions.length-(this.categories?0:1),1),m=b.margin[3];return a&&a.slotWidth||g&&2>(d.step||0)&&!d.rotation&&(this.staggerLines||1)*this.len/c||!g&&(d.style&&parseInt(d.style.width,10)||m&&m-b.spacing[3]||.33*b.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,d=this.tickPositions,
c=this.ticks,m=this.options.labels,k=m&&m.style||{},l=this.horiz,h=this.getSlotWidth(),q=Math.max(1,Math.round(h-2*(m.padding||5))),v={},A=this.labelMetrics(),e=m.style&&m.style.textOverflow,p,f,G=0,B;J(m.rotation)||(v.rotation=m.rotation||0);y(d,function(a){(a=c[a])&&a.label&&a.label.textPxLength>G&&(G=a.label.textPxLength)});this.maxLabelLength=G;if(this.autoRotation)G>q&&G>A.h?v.rotation=this.labelRotation:this.labelRotation=0;else if(h&&(p=q,!e))for(f="clip",q=d.length;!l&&q--;)if(B=d[q],B=c[B].label)B.styles&&
"ellipsis"===B.styles.textOverflow?B.css({textOverflow:"clip"}):B.textPxLength>h&&B.css({width:h+"px"}),B.getBBox().height>this.len/d.length-(A.h-A.f)&&(B.specificTextOverflow="ellipsis");v.rotation&&(p=G>.5*a.chartHeight?.33*a.chartHeight:G,e||(f="ellipsis"));if(this.labelAlign=m.align||this.autoLabelAlign(this.labelRotation))v.align=this.labelAlign;y(d,function(a){var b=(a=c[a])&&a.label,g=k.width,d={};b&&(b.attr(v),a.shortenLabel?a.shortenLabel():p&&!g&&"nowrap"!==k.whiteSpace&&(p<b.textPxLength||
"SPAN"===b.element.tagName)?(d.width=p,e||(d.textOverflow=b.specificTextOverflow||f),b.css(d)):b.styles&&b.styles.width&&!d.width&&!g&&b.css({width:null}),delete b.specificTextOverflow,a.rotation=v.rotation)},this);this.tickRotCorr=b.rotCorr(A.b,this.labelRotation||0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||x(this.min)&&x(this.max)&&this.tickPositions&&0<this.tickPositions.length},addTitle:function(a){var b=this.chart.renderer,g=this.horiz,d=this.opposite,c=this.options.title,
m;this.axisTitle||((m=c.textAlign)||(m=(g?{low:"left",middle:"center",high:"right"}:{low:d?"right":"left",middle:"center",high:d?"left":"right"})[c.align]),this.axisTitle=b.text(c.text,0,0,c.useHTML).attr({zIndex:7,rotation:c.rotation||0,align:m}).addClass("highcharts-axis-title").css(l(c.style)).add(this.axisGroup),this.axisTitle.isNew=!0);c.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():
b[a]=new N(this,a)},getOffset:function(){var a=this,b=a.chart,d=b.renderer,c=a.options,m=a.tickPositions,k=a.ticks,l=a.horiz,q=a.side,v=b.inverted&&!a.isZAxis?[1,0,3,2][q]:q,A,e,p=0,G,f=0,J=c.title,E=c.labels,N=0,w=b.axisOffset,b=b.clipOffset,t=[-1,1,1,-1][q],u=c.className,n=a.axisParent;A=a.hasData();a.showAxis=e=A||D(c.showEmpty,!0);a.staggerLines=a.horiz&&E.staggerLines;a.axisGroup||(a.gridGroup=d.g("grid").attr({zIndex:c.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+
(u||"")).add(n),a.axisGroup=d.g("axis").attr({zIndex:c.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(u||"")).add(n),a.labelGroup=d.g("axis-labels").attr({zIndex:E.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(u||"")).add(n));A||a.isLinked?(y(m,function(b,g){a.generateTick(b,g)}),a.renderUnsquish(),a.reserveSpaceDefault=0===q||2===q||{1:"left",3:"right"}[q]===a.labelAlign,D(E.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&y(m,function(a){N=
Math.max(k[a].getLabelSize(),N)}),a.staggerLines&&(N*=a.staggerLines),a.labelOffset=N*(a.opposite?-1:1)):B(k,function(a,b){a.destroy();delete k[b]});J&&J.text&&!1!==J.enabled&&(a.addTitle(e),e&&!1!==J.reserveSpace&&(a.titleOffset=p=a.axisTitle.getBBox()[l?"height":"width"],G=J.offset,f=x(G)?0:D(J.margin,l?5:10)));a.renderLine();a.offset=t*D(c.offset,w[q]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};d=0===q?-a.labelMetrics().h:2===q?a.tickRotCorr.y:0;f=Math.abs(N)+f;N&&(f=f-d+t*(l?D(E.y,a.tickRotCorr.y+
8*t):E.x));a.axisTitleMargin=D(G,f);a.getMaxLabelDimensions&&(a.maxLabelDimensions=a.getMaxLabelDimensions(k,m));l=this.tickSize("tick");w[q]=Math.max(w[q],a.axisTitleMargin+p+t*a.offset,f,A&&m.length&&l?l[0]+t*a.offset:0);c=c.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[v]=Math.max(b[v],c);h(this,"afterGetOffset")},getLinePath:function(a){var b=this.chart,g=this.opposite,d=this.offset,c=this.horiz,m=this.left+(g?this.width:0)+d,d=b.chartHeight-this.bottom-(g?this.height:0)+d;g&&(a*=-1);return b.renderer.crispLine(["M",
c?this.left:m,c?d:this.top,"L",c?b.chartWidth-this.right:m,c?d:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,d=this.top,c=this.len,m=this.options.title,k=a?b:d,l=this.opposite,h=this.offset,q=m.x||0,v=m.y||0,A=this.axisTitle,e=
this.chart.renderer.fontMetrics(m.style&&m.style.fontSize,A),A=Math.max(A.getBBox(null,0).height-e.h-1,0),c={low:k+(a?0:c),middle:k+c/2,high:k+(a?c:0)}[m.align],b=(a?d+this.height:b)+(a?1:-1)*(l?-1:1)*this.axisTitleMargin+[-A,A,e.f,-A][this.side];return{x:a?c+q:b+(l?this.width:0)+h+q,y:a?b+v-(l?this.height:0)+h:c+v}},renderMinorTick:function(a){var b=this.chart.hasRendered&&v(this.oldMin),d=this.minorTicks;d[a]||(d[a]=new N(this,a,"minor"));b&&d[a].isNew&&d[a].render(null,!0);d[a].render(null,!1,
1)},renderTick:function(a,b){var d=this.isLinked,g=this.ticks,c=this.chart.hasRendered&&v(this.oldMin);if(!d||a>=this.min&&a<=this.max)g[a]||(g[a]=new N(this,a)),c&&g[a].isNew&&g[a].render(b,!0,-1),g[a].render(b)},render:function(){var b=this,d=b.chart,c=b.options,m=b.isLog,k=b.isLinked,l=b.tickPositions,q=b.axisTitle,e=b.ticks,p=b.minorTicks,f=b.alternateBands,G=c.stackLabels,J=c.alternateGridColor,E=b.tickmarkOffset,D=b.axisLine,t=b.showAxis,w=F(d.renderer.globalAnimation),u,n;b.labelEdge.length=
0;b.overlap=!1;y([e,p,f],function(a){B(a,function(a){a.isActive=!1})});if(b.hasData()||k)b.minorTickInterval&&!b.categories&&y(b.getMinorTickPositions(),function(a){b.renderMinorTick(a)}),l.length&&(y(l,function(a,d){b.renderTick(a,d)}),E&&(0===b.min||b.single)&&(e[-1]||(e[-1]=new N(b,-1,null,!0)),e[-1].render(-1))),J&&y(l,function(c,g){n=void 0!==l[g+1]?l[g+1]+E:b.max-E;0===g%2&&c<b.max&&n<=b.max+(d.polar?-E:E)&&(f[c]||(f[c]=new a.PlotLineOrBand(b)),u=c+E,f[c].options={from:m?b.lin2log(u):u,to:m?
b.lin2log(n):n,color:J},f[c].render(),f[c].isActive=!0)}),b._addedPlotLB||(y((c.plotLines||[]).concat(c.plotBands||[]),function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=!0);y([e,p,f],function(a){var b,c=[],g=w.duration;B(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,c.push(b))});A(function(){for(b=c.length;b--;)a[c[b]]&&!a[c[b]].isActive&&(a[c[b]].destroy(),delete a[c[b]])},a!==f&&d.hasRendered&&g?g:0)});D&&(D[D.isPlaced?"animate":"attr"]({d:this.getLinePath(D.strokeWidth())}),D.isPlaced=
!0,D[t?"show":"hide"](!0));q&&t&&(c=b.getTitlePosition(),v(c.y)?(q[q.isNew?"attr":"animate"](c),q.isNew=!1):(q.attr("y",-9999),q.isNew=!0));G&&G.enabled&&b.renderStackTotals();b.isDirty=!1;h(this,"afterRender")},redraw:function(){this.visible&&(this.render(),y(this.plotLinesAndBands,function(a){a.render()}));y(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,c=b.stacks,g=b.plotLinesAndBands,k;h(this,"destroy",
{keepEvents:a});a||m(b);B(c,function(a,b){w(a);c[b]=null});y([b.ticks,b.minorTicks,b.alternateBands],function(a){w(a)});if(g)for(a=g.length;a--;)g[a].destroy();y("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" "),function(a){b[a]&&(b[a]=b[a].destroy())});for(k in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[k]=b.plotLinesAndBandsGroups[k].destroy();B(b,function(a,c){-1===d(c,b.keepProps)&&delete b[c]})},drawCrosshair:function(a,b){var d,c=this.crosshair,
g=D(c.snap,!0),m,k=this.cross;h(this,"drawCrosshair",{e:a,point:b});a||(a=this.cross&&this.cross.e);if(this.crosshair&&!1!==(x(b)||!g)){g?x(b)&&(m=D(b.crosshairPos,this.isXAxis?b.plotX:this.len-b.plotY)):m=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos);x(m)&&(d=this.getPlotLinePath(b&&(this.isXAxis?b.x:D(b.stackY,b.y)),null,null,null,m)||null);if(!x(d)){this.hideCrosshair();return}g=this.categories&&!this.isRadial;k||(this.cross=k=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+
(g?"category ":"thin ")+c.className).attr({zIndex:D(c.zIndex,2)}).add(),k.attr({stroke:c.color||(g?f("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":D(c.width,1)}).css({"pointer-events":"none"}),c.dashStyle&&k.attr({dashstyle:c.dashStyle}));k.show().attr({d:d});g&&!c.width&&k.attr({"stroke-width":this.transA});this.cross.e=a}else this.hideCrosshair();h(this,"afterDrawCrosshair",{e:a,point:b})},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=E}(K);(function(a){var C=
a.Axis,F=a.getMagnitude,I=a.normalizeTickInterval,n=a.timeUnits;C.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};C.prototype.normalizeTimeTickInterval=function(a,e){var f=e||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];e=f[f.length-1];var x=n[e[0]],t=e[1],w;for(w=0;w<f.length&&!(e=f[w],x=n[e[0]],
t=e[1],f[w+1]&&a<=(x*t[t.length-1]+n[f[w+1][0]])/2);w++);x===n.year&&a<5*x&&(t=[1,2,5]);a=I(a/x,t,"year"===e[0]?Math.max(F(a/x),1):1);return{unitRange:x,count:a,unitName:e[0]}}})(K);(function(a){var C=a.Axis,F=a.getMagnitude,I=a.map,n=a.normalizeTickInterval,f=a.pick;C.prototype.getLogTickPositions=function(a,u,x,t){var e=this.options,y=this.len,c=[];t||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),c=this.getLinearTickPositions(a,u,x);else if(.08<=a)for(var y=Math.floor(u),h,p,k,q,d,e=.3<
a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];y<x+1&&!d;y++)for(p=e.length,h=0;h<p&&!d;h++)k=this.log2lin(this.lin2log(y)*e[h]),k>u&&(!t||q<=x)&&void 0!==q&&c.push(q),q>x&&(d=!0),q=k;else u=this.lin2log(u),x=this.lin2log(x),a=t?this.getMinorTickInterval():e.tickInterval,a=f("auto"===a?null:a,this._minorAutoInterval,e.tickPixelInterval/(t?5:1)*(x-u)/((t?y/this.tickPositions.length:y)||1)),a=n(a,null,F(a)),c=I(this.getLinearTickPositions(a,u,x),this.log2lin),t||(this._minorAutoInterval=a/5);t||(this.tickInterval=
a);return c};C.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};C.prototype.lin2log=function(a){return Math.pow(10,a)}})(K);(function(a,C){var F=a.arrayMax,I=a.arrayMin,n=a.defined,f=a.destroyObjectProperties,e=a.each,u=a.erase,x=a.merge,t=a.pick;a.PlotLineOrBand=function(a,e){this.axis=a;e&&(this.options=e,this.id=e.id)};a.PlotLineOrBand.prototype={render:function(){a.fireEvent(this,"render");var e=this,f=e.axis,c=f.horiz,h=e.options,p=h.label,k=e.label,q=h.to,d=h.from,b=h.value,v=n(d)&&
n(q),J=n(b),l=e.svgElem,u=!l,B=[],D=h.color,m=t(h.zIndex,0),G=h.events,B={"class":"highcharts-plot-"+(v?"band ":"line ")+(h.className||"")},A={},N=f.chart.renderer,E=v?"bands":"lines";f.isLog&&(d=f.log2lin(d),q=f.log2lin(q),b=f.log2lin(b));J?(B.stroke=D,B["stroke-width"]=h.width,h.dashStyle&&(B.dashstyle=h.dashStyle)):v&&(D&&(B.fill=D),h.borderWidth&&(B.stroke=h.borderColor,B["stroke-width"]=h.borderWidth));A.zIndex=m;E+="-"+m;(D=f.plotLinesAndBandsGroups[E])||(f.plotLinesAndBandsGroups[E]=D=N.g("plot-"+
E).attr(A).add());u&&(e.svgElem=l=N.path().attr(B).add(D));if(J)B=f.getPlotLinePath(b,l.strokeWidth());else if(v)B=f.getPlotBandPath(d,q,h);else return;u&&B&&B.length?(l.attr({d:B}),G&&a.objectEach(G,function(a,b){l.on(b,function(a){G[b].apply(e,[a])})})):l&&(B?(l.show(),l.animate({d:B})):(l.hide(),k&&(e.label=k=k.destroy())));p&&n(p.text)&&B&&B.length&&0<f.width&&0<f.height&&!B.isFlat?(p=x({align:c&&v&&"center",x:c?!v&&4:10,verticalAlign:!c&&v&&"middle",y:c?v?16:10:v?6:-4,rotation:c&&!v&&90},p),
this.renderLabel(p,B,v,m)):k&&k.hide();return e},renderLabel:function(a,e,c,h){var p=this.label,k=this.axis.chart.renderer;p||(p={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(c?"band":"line")+"-label "+(a.className||"")},p.zIndex=h,this.label=p=k.text(a.text,0,0,a.useHTML).attr(p).add(),p.css(a.style));h=e.xBounds||[e[1],e[4],c?e[6]:e[1]];e=e.yBounds||[e[2],e[5],c?e[7]:e[2]];c=I(h);k=I(e);p.align(a,!1,{x:c,y:k,width:F(h)-c,height:F(e)-k});p.show()},destroy:function(){u(this.axis.plotLinesAndBands,
this);delete this.axis;f(this)}};a.extend(C.prototype,{getPlotBandPath:function(a,e){var c=this.getPlotLinePath(e,null,null,!0),h=this.getPlotLinePath(a,null,null,!0),p=[],k=this.horiz,q=1,d;a=a<this.min&&e<this.min||a>this.max&&e>this.max;if(h&&c)for(a&&(d=h.toString()===c.toString(),q=0),a=0;a<h.length;a+=6)k&&c[a+1]===h[a+1]?(c[a+1]+=q,c[a+4]+=q):k||c[a+2]!==h[a+2]||(c[a+2]+=q,c[a+5]+=q),p.push("M",h[a+1],h[a+2],"L",h[a+4],h[a+5],c[a+4],c[a+5],c[a+1],c[a+2],"z"),p.isFlat=d;return p},addPlotBand:function(a){return this.addPlotBandOrLine(a,
"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(e,f){var c=(new a.PlotLineOrBand(this,e)).render(),h=this.userOptions;c&&(f&&(h[f]=h[f]||[],h[f].push(e)),this.plotLinesAndBands.push(c));return c},removePlotBandOrLine:function(a){for(var f=this.plotLinesAndBands,c=this.options,h=this.userOptions,p=f.length;p--;)f[p].id===a&&f[p].destroy();e([c.plotLines||[],h.plotLines||[],c.plotBands||[],h.plotBands||[]],function(c){for(p=c.length;p--;)c[p].id===
a&&u(c,c[p])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(K,W);(function(a){var C=a.doc,F=a.each,I=a.extend,n=a.format,f=a.isNumber,e=a.map,u=a.merge,x=a.pick,t=a.splat,w=a.syncTimeout,y=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};a.Tooltip.prototype={init:function(a,h){this.chart=a;this.options=h;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=h.split&&!a.inverted;this.shared=h.shared||
this.split;this.outside=h.outside&&!this.split},cleanSplit:function(a){F(this.chart.series,function(c){var h=c&&c.tt;h&&(!h.isActive||a?c.tt=h.destroy():h.isActive=!1)})},getLabel:function(){var c=this.chart.renderer,h=this.options,e;this.label||(this.outside&&(this.container=e=a.doc.createElement("div"),e.className="highcharts-tooltip-container",a.css(e,{position:"absolute",top:"1px",pointerEvents:h.style&&h.style.pointerEvents}),a.doc.body.appendChild(e),this.renderer=c=new a.Renderer(e,0,0)),this.split?
this.label=c.g("tooltip"):(this.label=c.label("",0,0,h.shape||"callout",null,null,h.useHTML,null,"tooltip").attr({padding:h.padding,r:h.borderRadius}),this.label.attr({fill:h.backgroundColor,"stroke-width":h.borderWidth}).css(h.style).shadow(h.shadow)),this.outside&&(this.label.attr({x:this.distance,y:this.distance}),this.label.xSetter=function(a){e.style.left=a+"px"},this.label.ySetter=function(a){e.style.top=a+"px"}),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();
u(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,u(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),a.discardElement(this.container));a.clearTimeout(this.hideTimer);a.clearTimeout(this.tooltipTimeout)},move:function(c,h,e,k){var q=this,d=q.now,b=!1!==q.options.animation&&!q.isHidden&&(1<Math.abs(c-d.x)||1<Math.abs(h-
d.y)),v=q.followPointer||1<q.len;I(d,{x:b?(2*d.x+c)/3:c,y:b?(d.y+h)/2:h,anchorX:v?void 0:b?(2*d.anchorX+e)/3:e,anchorY:v?void 0:b?(d.anchorY+k)/2:k});q.getLabel().attr(d);b&&(a.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){q&&q.move(c,h,e,k)},32))},hide:function(c){var h=this;a.clearTimeout(this.hideTimer);c=x(c,this.options.hideDelay,500);this.isHidden||(this.hideTimer=w(function(){h.getLabel()[c?"fadeOut":"hide"]();h.isHidden=!0},c))},getAnchor:function(a,h){var c=
this.chart,k=c.pointer,q=c.inverted,d=c.plotTop,b=c.plotLeft,v=0,f=0,l,n;a=t(a);this.followPointer&&h?(void 0===h.chartX&&(h=k.normalize(h)),a=[h.chartX-c.plotLeft,h.chartY-d]):a[0].tooltipPos?a=a[0].tooltipPos:(F(a,function(a){l=a.series.yAxis;n=a.series.xAxis;v+=a.plotX+(!q&&n?n.left-b:0);f+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!q&&l?l.top-d:0)}),v/=a.length,f/=a.length,a=[q?c.plotWidth-f:v,this.shared&&!q&&1<a.length&&h?h.chartY-d:q?c.plotHeight-v:f]);return e(a,Math.round)},getPosition:function(a,
h,e){var c=this.chart,q=this.distance,d={},b=c.inverted&&e.h||0,v,f=this.outside,l=f?C.documentElement.clientWidth-2*q:c.chartWidth,p=f?Math.max(C.body.scrollHeight,C.documentElement.scrollHeight,C.body.offsetHeight,C.documentElement.offsetHeight,C.documentElement.clientHeight):c.chartHeight,B=c.pointer.chartPosition,D=["y",p,h,(f?B.top-q:0)+e.plotY+c.plotTop,f?0:c.plotTop,f?p:c.plotTop+c.plotHeight],m=["x",l,a,(f?B.left-q:0)+e.plotX+c.plotLeft,f?0:c.plotLeft,f?l:c.plotLeft+c.plotWidth],G=!this.followPointer&&
x(e.ttBelow,!c.inverted===!!e.negative),A=function(a,c,g,m,k,l){var h=g<m-q,v=m+q+g<c,A=m-q-g;m+=q;if(G&&v)d[a]=m;else if(!G&&h)d[a]=A;else if(h)d[a]=Math.min(l-g,0>A-b?A:A-b);else if(v)d[a]=Math.max(k,m+b+g>c?m:m+b);else return!1},N=function(a,b,c,g){var m;g<q||g>b-q?m=!1:d[a]=g<c/2?1:g>b-c/2?b-c-2:g-c/2;return m},E=function(a){var b=D;D=m;m=b;v=a},g=function(){!1!==A.apply(0,D)?!1!==N.apply(0,m)||v||(E(!0),g()):v?d.x=d.y=0:(E(!0),g())};(c.inverted||1<this.len)&&E();g();return d},defaultFormatter:function(a){var c=
this.points||t(this),e;e=[a.tooltipFooterHeaderFormatter(c[0])];e=e.concat(a.bodyFormatter(c));e.push(a.tooltipFooterHeaderFormatter(c[0],!0));return e},refresh:function(c,h){var e,k=this.options,q,d=c,b,v={},f=[];e=k.formatter||this.defaultFormatter;var v=this.shared,l;k.enabled&&(a.clearTimeout(this.hideTimer),this.followPointer=t(d)[0].series.tooltipOptions.followPointer,b=this.getAnchor(d,h),h=b[0],q=b[1],!v||d.series&&d.series.noSharedTooltip?v=d.getLabelConfig():(F(d,function(a){a.setState("hover");
f.push(a.getLabelConfig())}),v={x:d[0].category,y:d[0].y},v.points=f,d=d[0]),this.len=f.length,v=e.call(v,this),l=d.series,this.distance=x(l.tooltipOptions.distance,16),!1===v?this.hide():(e=this.getLabel(),this.isHidden&&e.attr({opacity:1}).show(),this.split?this.renderSplit(v,t(c)):(k.style.width||e.css({width:this.chart.spacingBox.width}),e.attr({text:v&&v.join?v.join(""):v}),e.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+x(d.colorIndex,l.colorIndex)),e.attr({stroke:k.borderColor||
d.color||l.color||"#666666"}),this.updatePosition({plotX:h,plotY:q,negative:d.negative,ttBelow:d.ttBelow,h:b[2]||0})),this.isHidden=!1))},renderSplit:function(c,h){var e=this,k=[],q=this.chart,d=q.renderer,b=!0,v=this.options,f=0,l,t=this.getLabel(),B=q.plotTop;a.isString(c)&&(c=[!1,c]);F(c.slice(0,h.length+1),function(a,c){if(!1!==a){c=h[c-1]||{isHeader:!0,plotX:h[0].plotX};var m=c.series||e,A=m.tt,p=c.series||{},E="highcharts-color-"+x(c.colorIndex,p.colorIndex,"none");A||(m.tt=A=d.label(null,null,
null,"callout",null,null,v.useHTML).addClass("highcharts-tooltip-box "+E+(c.isHeader?" highcharts-tooltip-header":"")).attr({padding:v.padding,r:v.borderRadius,fill:v.backgroundColor,stroke:v.borderColor||c.color||p.color||"#333333","stroke-width":v.borderWidth}).add(t));A.isActive=!0;A.attr({text:a});A.css(v.style).shadow(v.shadow);a=A.getBBox();p=a.width+A.strokeWidth();c.isHeader?(f=a.height,q.xAxis[0].opposite&&(l=!0,B-=f),p=Math.max(0,Math.min(c.plotX+q.plotLeft-p/2,q.chartWidth+(q.scrollablePixels?
q.scrollablePixels-q.marginRight:0)-p))):p=c.plotX+q.plotLeft-x(v.distance,16)-p;0>p&&(b=!1);a=(c.series&&c.series.yAxis&&c.series.yAxis.pos)+(c.plotY||0);a-=B;c.isHeader&&(a=l?-f:q.plotHeight+f);k.push({target:a,rank:c.isHeader?1:0,size:m.tt.getBBox().height+1,point:c,x:p,tt:A})}});this.cleanSplit();a.distribute(k,q.plotHeight+f);F(k,function(a){var c=a.point,d=c.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:b||c.isHeader?a.x:c.plotX+q.plotLeft+x(v.distance,16),y:a.pos+B,anchorX:c.isHeader?
c.plotX+q.plotLeft:c.plotX+d.xAxis.pos,anchorY:c.isHeader?q.plotTop+q.plotHeight/2:c.plotY+d.yAxis.pos})})},updatePosition:function(a){var c=this.chart,e=this.getLabel(),k=(this.options.positioner||this.getPosition).call(this,e.width,e.height,a),q=a.plotX+c.plotLeft;a=a.plotY+c.plotTop;var d;this.outside&&(d=(this.options.borderWidth||0)+2*this.distance,this.renderer.setSize(e.width+d,e.height+d,!1),q+=c.pointer.chartPosition.left-k.x,a+=c.pointer.chartPosition.top-k.y);this.move(Math.round(k.x),
Math.round(k.y||0),q,a)},getDateFormat:function(a,h,e,k){var c=this.chart.time,d=c.dateFormat("%m-%d %H:%M:%S.%L",h),b,v,f={millisecond:15,second:12,minute:9,hour:6,day:3},l="millisecond";for(v in y){if(a===y.week&&+c.dateFormat("%w",h)===e&&"00:00:00.000"===d.substr(6)){v="week";break}if(y[v]>a){v=l;break}if(f[v]&&d.substr(f[v])!=="01-01 00:00:00.000".substr(f[v]))break;"week"!==v&&(l=v)}v&&(b=c.resolveDTLFormat(k[v]).main);return b},getXDateFormat:function(a,h,e){h=h.dateTimeLabelFormats;var c=
e&&e.closestPointRange;return(c?this.getDateFormat(c,a.x,e.options.startOfWeek,h):h.day)||h.year},tooltipFooterHeaderFormatter:function(a,h){h=h?"footer":"header";var c=a.series,k=c.tooltipOptions,e=k.xDateFormat,d=c.xAxis,b=d&&"datetime"===d.options.type&&f(a.key),v=k[h+"Format"];b&&!e&&(e=this.getXDateFormat(a,k,d));b&&e&&F(a.point&&a.point.tooltipDateKeys||["key"],function(a){v=v.replace("{point."+a+"}","{point."+a+":"+e+"}")});return n(v,{point:a,series:c},this.chart.time)},bodyFormatter:function(a){return e(a,
function(a){var c=a.series.tooltipOptions;return(c[(a.point.formatPrefix||"point")+"Formatter"]||a.point.tooltipFormatter).call(a.point,c[(a.point.formatPrefix||"point")+"Format"])})}}})(K);(function(a){var C=a.addEvent,F=a.attr,I=a.charts,n=a.color,f=a.css,e=a.defined,u=a.each,x=a.extend,t=a.find,w=a.fireEvent,y=a.isNumber,c=a.isObject,h=a.offset,p=a.pick,k=a.splat,q=a.Tooltip;a.Pointer=function(a,b){this.init(a,b)};a.Pointer.prototype={init:function(a,b){this.options=b;this.chart=a;this.runChartClick=
b.chart.events&&!!b.chart.events.click;this.pinchDown=[];this.lastValidTouch={};q&&(a.tooltip=new q(a,b.tooltip),this.followTouchMove=p(b.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,c=b.options.chart,d=c.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(d=p(c.pinchType,d));this.zoomX=a=/x/.test(d);this.zoomY=d=/y/.test(d);this.zoomHor=a&&!b||d&&b;this.zoomVert=d&&!b||a&&b;this.hasZoom=a||d},normalize:function(a,b){var c;c=a.touches?a.touches.length?a.touches.item(0):
a.changedTouches[0]:a;b||(this.chartPosition=b=h(this.chart.container));return x(a,{chartX:Math.round(c.pageX-b.left),chartY:Math.round(c.pageY-b.top)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};u(this.chart.axes,function(c){b[c.isXAxis?"xAxis":"yAxis"].push({axis:c,value:c.toValue(a[c.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,b,k){var d;u(a,function(a){var l=!(a.noSharedTooltip&&b)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(k,l);if((l=c(a,
!0))&&!(l=!c(d,!0)))var l=d.distX-a.distX,e=d.dist-a.dist,h=(a.series.group&&a.series.group.zIndex)-(d.series.group&&d.series.group.zIndex),l=0<(0!==l&&b?l:0!==e?e:0!==h?h:d.series.index>a.series.index?-1:1);l&&(d=a)});return d},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,b){var c=a.series,d=c.xAxis,c=c.yAxis,k=p(a.clientX,a.plotX),e=a.shapeArgs;if(d&&c)return b?{chartX:d.len+d.pos-k,chartY:c.len+c.pos-a.plotY}:
{chartX:k+d.pos,chartY:a.plotY+c.pos};if(e&&e.x&&e.y)return{chartX:e.x,chartY:e.y}},getHoverData:function(d,b,k,e,l,h,q){var v,m=[],f=q&&q.isBoosting;e=!(!e||!d);q=b&&!b.stickyTracking?[b]:a.grep(k,function(a){return a.visible&&!(!l&&a.directTouch)&&p(a.options.enableMouseTracking,!0)&&a.stickyTracking});b=(v=e?d:this.findNearestKDPoint(q,l,h))&&v.series;v&&(l&&!b.noSharedTooltip?(q=a.grep(k,function(a){return a.visible&&!(!l&&a.directTouch)&&p(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),
u(q,function(a){var b=t(a.points,function(a){return a.x===v.x&&!a.isNull});c(b)&&(f&&(b=a.getPoint(b)),m.push(b))})):m.push(v));return{hoverPoint:v,hoverSeries:b,hoverPoints:m}},runPointActions:function(c,b){var d=this.chart,k=d.tooltip&&d.tooltip.options.enabled?d.tooltip:void 0,l=k?k.shared:!1,e=b||d.hoverPoint,h=e&&e.series||d.hoverSeries,h=this.getHoverData(e,h,d.series,"touchmove"!==c.type&&(!!b||h&&h.directTouch&&this.isDirectTouch),l,c,{isBoosting:d.isBoosting}),q,e=h.hoverPoint;q=h.hoverPoints;
b=(h=h.hoverSeries)&&h.tooltipOptions.followPointer;l=l&&h&&!h.noSharedTooltip;if(e&&(e!==d.hoverPoint||k&&k.isHidden)){u(d.hoverPoints||[],function(b){-1===a.inArray(b,q)&&b.setState()});u(q||[],function(a){a.setState("hover")});if(d.hoverSeries!==h)h.onMouseOver();d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");if(!e.series)return;e.firePointEvent("mouseOver");d.hoverPoints=q;d.hoverPoint=e;k&&k.refresh(l?q:e,c)}else b&&k&&!k.isHidden&&(e=k.getAnchor([{}],c),k.updatePosition({plotX:e[0],plotY:e[1]}));
this.unDocMouseMove||(this.unDocMouseMove=C(d.container.ownerDocument,"mousemove",function(b){var c=I[a.hoverChartIndex];if(c)c.pointer.onDocumentMouseMove(b)}));u(d.axes,function(b){var d=p(b.crosshair.snap,!0),m=d?a.find(q,function(a){return a.series[b.coll]===b}):void 0;m||!d?b.drawCrosshair(c,m):b.hideCrosshair()})},reset:function(a,b){var c=this.chart,d=c.hoverSeries,l=c.hoverPoint,e=c.hoverPoints,h=c.tooltip,q=h&&h.shared?e:l;a&&q&&u(k(q),function(b){b.series.isCartesian&&void 0===b.plotX&&
(a=!1)});if(a)h&&q&&(h.refresh(q),h.shared&&e?u(e,function(a){a.setState(a.state,!0);a.series.isCartesian&&(a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a),a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a))}):l&&(l.setState(l.state,!0),u(c.axes,function(a){a.crosshair&&a.drawCrosshair(null,l)})));else{if(l)l.onMouseOut();e&&u(e,function(a){a.setState()});if(d)d.onMouseOut();h&&h.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());u(c.axes,function(a){a.hideCrosshair()});
this.hoverX=c.hoverPoints=c.hoverPoint=null}},scaleGroups:function(a,b){var c=this.chart,d;u(c.series,function(k){d=a||k.getPlotBox();k.xAxis&&k.xAxis.zoomEnabled&&k.group&&(k.group.attr(d),k.markerGroup&&(k.markerGroup.attr(d),k.markerGroup.clip(b?c.clipRect:null)),k.dataLabelsGroup&&k.dataLabelsGroup.attr(d))});c.clipRect.attr(b||c.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=
this.chart,c=b.options.chart,d=a.chartX,k=a.chartY,e=this.zoomHor,h=this.zoomVert,q=b.plotLeft,m=b.plotTop,f=b.plotWidth,A=b.plotHeight,p,E=this.selectionMarker,g=this.mouseDownX,r=this.mouseDownY,t=c.panKey&&a[c.panKey+"Key"];E&&E.touch||(d<q?d=q:d>q+f&&(d=q+f),k<m?k=m:k>m+A&&(k=m+A),this.hasDragged=Math.sqrt(Math.pow(g-d,2)+Math.pow(r-k,2)),10<this.hasDragged&&(p=b.isInsidePlot(g-q,r-m),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&p&&!t&&!E&&(this.selectionMarker=E=b.renderer.rect(q,m,e?1:f,
h?1:A,0).attr({fill:c.selectionMarkerFill||n("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),E&&e&&(d-=g,E.attr({width:Math.abs(d),x:(0<d?0:d)+g})),E&&h&&(d=k-r,E.attr({height:Math.abs(d),y:(0<d?0:d)+r})),p&&!E&&c.panning&&b.pan(a,c.panning)))},drop:function(a){var b=this,c=this.chart,d=this.hasPinched;if(this.selectionMarker){var k={originalEvent:a,xAxis:[],yAxis:[]},h=this.selectionMarker,q=h.attr?h.attr("x"):h.x,p=h.attr?h.attr("y"):h.y,m=h.attr?h.attr("width"):
h.width,G=h.attr?h.attr("height"):h.height,A;if(this.hasDragged||d)u(c.axes,function(c){if(c.zoomEnabled&&e(c.min)&&(d||b[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var h=c.horiz,g="touchend"===a.type?c.minPixelPadding:0,l=c.toValue((h?q:p)+g),h=c.toValue((h?q+m:p+G)-g);k[c.coll].push({axis:c,min:Math.min(l,h),max:Math.max(l,h)});A=!0}}),A&&w(c,"selection",k,function(a){c.zoom(x(a,d?{animation:!1}:null))});y(c.index)&&(this.selectionMarker=this.selectionMarker.destroy());d&&this.scaleGroups()}c&&y(c.index)&&
(f(c.container,{cursor:c._cursor}),c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(c){I[a.hoverChartIndex]&&I[a.hoverChartIndex].pointer.drop(c)},onDocumentMouseMove:function(a){var b=this.chart,c=this.chartPosition;a=this.normalize(a,c);!c||this.inClass(a.target,"highcharts-tracker")||
b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(c){var b=I[a.hoverChartIndex];b&&(c.relatedTarget||c.toElement)&&(b.pointer.reset(),b.pointer.chartPosition=null)},onContainerMouseMove:function(c){var b=this.chart;e(a.hoverChartIndex)&&I[a.hoverChartIndex]&&I[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=b.index);c=this.normalize(c);c.returnValue=!1;"mousedown"===b.mouseIsDown&&this.drag(c);!this.inClass(c.target,"highcharts-tracker")&&!b.isInsidePlot(c.chartX-
b.plotLeft,c.chartY-b.plotTop)||b.openMenu||this.runPointActions(c)},inClass:function(a,b){for(var c;a;){if(c=F(a,"class")){if(-1!==c.indexOf(b))return!0;if(-1!==c.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},
onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,d=b.plotLeft,k=b.plotTop;a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,"highcharts-tracker")?(w(c.series,"click",x(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(x(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-d,a.chartY-k)&&w(b,"click",a)))},setDOMEvents:function(){var c=this,b=c.chart.container,k=b.ownerDocument;b.onmousedown=function(a){c.onContainerMouseDown(a)};b.onmousemove=function(a){c.onContainerMouseMove(a)};
b.onclick=function(a){c.onContainerClick(a)};this.unbindContainerMouseLeave=C(b,"mouseleave",c.onContainerMouseLeave);a.unbindDocumentMouseUp||(a.unbindDocumentMouseUp=C(k,"mouseup",c.onDocumentMouseUp));a.hasTouch&&(b.ontouchstart=function(a){c.onContainerTouchStart(a)},b.ontouchmove=function(a){c.onContainerTouchMove(a)},a.unbindDocumentTouchEnd||(a.unbindDocumentTouchEnd=C(k,"touchend",c.onDocumentTouchEnd)))},destroy:function(){var c=this;c.unDocMouseMove&&c.unDocMouseMove();this.unbindContainerMouseLeave();
a.chartCount||(a.unbindDocumentMouseUp&&(a.unbindDocumentMouseUp=a.unbindDocumentMouseUp()),a.unbindDocumentTouchEnd&&(a.unbindDocumentTouchEnd=a.unbindDocumentTouchEnd()));clearInterval(c.tooltipTimeout);a.objectEach(c,function(a,d){c[d]=null})}}})(K);(function(a){var C=a.charts,F=a.each,I=a.extend,n=a.map,f=a.noop,e=a.pick;I(a.Pointer.prototype,{pinchTranslate:function(a,e,f,n,y,c){this.zoomHor&&this.pinchTranslateDirection(!0,a,e,f,n,y,c);this.zoomVert&&this.pinchTranslateDirection(!1,a,e,f,n,
y,c)},pinchTranslateDirection:function(a,e,f,n,y,c,h,p){var k=this.chart,q=a?"x":"y",d=a?"X":"Y",b="chart"+d,v=a?"width":"height",t=k["plot"+(a?"Left":"Top")],l,u,B=p||1,D=k.inverted,m=k.bounds[a?"h":"v"],G=1===e.length,A=e[0][b],N=f[0][b],E=!G&&e[1][b],g=!G&&f[1][b],r;f=function(){!G&&20<Math.abs(A-E)&&(B=p||Math.abs(N-g)/Math.abs(A-E));u=(t-N)/B+A;l=k["plot"+(a?"Width":"Height")]/B};f();e=u;e<m.min?(e=m.min,r=!0):e+l>m.max&&(e=m.max-l,r=!0);r?(N-=.8*(N-h[q][0]),G||(g-=.8*(g-h[q][1])),f()):h[q]=
[N,g];D||(c[q]=u-t,c[v]=l);c=D?1/B:B;y[v]=l;y[q]=e;n[D?a?"scaleY":"scaleX":"scale"+d]=B;n["translate"+d]=c*t+(N-c*A)},pinch:function(a){var u=this,t=u.chart,w=u.pinchDown,y=a.touches,c=y.length,h=u.lastValidTouch,p=u.hasZoom,k=u.selectionMarker,q={},d=1===c&&(u.inClass(a.target,"highcharts-tracker")&&t.runTrackerClick||u.runChartClick),b={};1<c&&(u.initiated=!0);p&&u.initiated&&!d&&a.preventDefault();n(y,function(a){return u.normalize(a)});"touchstart"===a.type?(F(y,function(a,b){w[b]={chartX:a.chartX,
chartY:a.chartY}}),h.x=[w[0].chartX,w[1]&&w[1].chartX],h.y=[w[0].chartY,w[1]&&w[1].chartY],F(t.axes,function(a){if(a.zoomEnabled){var b=t.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,d=a.toPixels(e(a.options.min,a.dataMin)),k=a.toPixels(e(a.options.max,a.dataMax)),h=Math.max(d,k);b.min=Math.min(a.pos,Math.min(d,k)-c);b.max=Math.max(a.pos+a.len,h+c)}}),u.res=!0):u.followTouchMove&&1===c?this.runPointActions(u.normalize(a)):w.length&&(k||(u.selectionMarker=k=I({destroy:f,touch:!0},t.plotBox)),u.pinchTranslate(w,
y,q,k,b,h),u.hasPinched=p,u.scaleGroups(q,b),u.res&&(u.res=!1,this.reset(!1,0)))},touch:function(f,n){var t=this.chart,u,y;if(t.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=t.index;1===f.touches.length?(f=this.normalize(f),(y=t.isInsidePlot(f.chartX-t.plotLeft,f.chartY-t.plotTop))&&!t.openMenu?(n&&this.runPointActions(f),"touchmove"===f.type&&(n=this.pinchDown,u=n[0]?4<=Math.sqrt(Math.pow(n[0].chartX-f.chartX,2)+Math.pow(n[0].chartY-f.chartY,2)):!1),e(u,
!0)&&this.pinch(f)):n&&this.reset()):2===f.touches.length&&this.pinch(f)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(e){C[a.hoverChartIndex]&&C[a.hoverChartIndex].pointer.drop(e)}})})(K);(function(a){var C=a.addEvent,F=a.charts,I=a.css,n=a.doc,f=a.extend,e=a.noop,u=a.Pointer,x=a.removeEvent,t=a.win,w=a.wrap;if(!a.hasTouch&&(t.PointerEvent||t.MSPointerEvent)){var y={},c=!!t.PointerEvent,h=function(){var c=
[];c.item=function(a){return this[a]};a.objectEach(y,function(a){c.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return c},p=function(c,q,d,b){"touch"!==c.pointerType&&c.pointerType!==c.MSPOINTER_TYPE_TOUCH||!F[a.hoverChartIndex]||(b(c),b=F[a.hoverChartIndex].pointer,b[q]({type:d,target:c.currentTarget,preventDefault:e,touches:h()}))};f(u.prototype,{onContainerPointerDown:function(a){p(a,"onContainerTouchStart","touchstart",function(a){y[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},
onContainerPointerMove:function(a){p(a,"onContainerTouchMove","touchmove",function(a){y[a.pointerId]={pageX:a.pageX,pageY:a.pageY};y[a.pointerId].target||(y[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){p(a,"onDocumentTouchEnd","touchend",function(a){delete y[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,c?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,c?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(n,c?
"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});w(u.prototype,"init",function(a,c,d){a.call(this,c,d);this.hasZoom&&I(c.container,{"-ms-touch-action":"none","touch-action":"none"})});w(u.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(C)});w(u.prototype,"destroy",function(a){this.batchMSEvents(x);a.call(this)})}})(K);(function(a){var C=a.addEvent,F=a.css,I=a.discardElement,n=a.defined,f=a.each,e=a.fireEvent,u=a.isFirefox,x=a.marginNames,
t=a.merge,w=a.pick,y=a.setAnimation,c=a.stableSort,h=a.win,p=a.wrap;a.Legend=function(a,c){this.init(a,c)};a.Legend.prototype={init:function(a,c){this.chart=a;this.setOptions(c);c.enabled&&(this.render(),C(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=C(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())},setOptions:function(a){var c=w(a.padding,8);this.options=
a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=t(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.padding=c;this.initialItemY=c-5;this.symbolWidth=w(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted},update:function(a,c){var d=this.chart;this.setOptions(t(!0,this.options,a));this.destroy();d.isDirtyLegend=d.isDirtyBox=!0;w(c,!0)&&d.redraw();e(this,"afterUpdate")},colorizeItem:function(a,c){a.legendGroup[c?"removeClass":"addClass"]("highcharts-legend-item-hidden");
var d=this.options,b=a.legendItem,k=a.legendLine,h=a.legendSymbol,l=this.itemHiddenStyle.color,d=c?d.itemStyle.color:l,q=c?a.color||l:l,f=a.options&&a.options.marker,p={fill:q};b&&b.css({fill:d,color:d});k&&k.attr({stroke:q});h&&(f&&h.isMarker&&(p=a.pointAttribs(),c||(p.stroke=p.fill=l)),h.attr(p));e(this,"afterColorizeItem",{item:a,visible:c})},positionItems:function(){f(this.allItems,this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(a){var c=this.options,
d=c.symbolPadding,c=!c.rtl,b=a._legendItemPos,e=b[0],b=b[1],h=a.checkbox;if((a=a.legendGroup)&&a.element)a[n(a.translateY)?"animate":"attr"]({translateX:c?e:this.legendWidth-e-2*d-4,translateY:b});h&&(h.x=e,h.y=b)},destroyItem:function(a){var c=a.checkbox;f(["legendItem","legendLine","legendSymbol","legendGroup"],function(c){a[c]&&(a[c]=a[c].destroy())});c&&I(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}f(this.getAllItems(),function(c){f(["legendItem","legendGroup"],
a,c)});f("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,c,d=this.clipHeight||this.legendHeight,b=this.titleHeight;a&&(c=a.translateY,f(this.allItems,function(e){var h=e.checkbox,k;h&&(k=c+b+h.y+(this.scrollOffset||0)+3,F(h,{left:a.translateX+e.checkboxOffset+h.x-20+"px",top:k+"px",display:this.proximate||k>c-6&&k<c+d-6?"":"none"}))},this))},renderTitle:function(){var a=this.options,c=this.padding,
d=a.title,b=0;d.text&&(this.title||(this.title=this.chart.renderer.label(d.text,c-3,c-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(d.style).add(this.group)),a=this.title.getBBox(),b=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:b}));this.titleHeight=b},setText:function(c){var h=this.options;c.legendItem.attr({text:h.labelFormat?a.format(h.labelFormat,c,this.chart.time):h.labelFormatter.call(c)})},renderItem:function(a){var c=this.chart,d=c.renderer,b=
this.options,h=this.symbolWidth,e=b.symbolPadding,l=this.itemStyle,k=this.itemHiddenStyle,f="horizontal"===b.layout?w(b.itemDistance,20):0,p=!b.rtl,m=a.legendItem,G=!a.series,A=!G&&a.series.drawLegendSymbol?a.series:a,n=A.options,n=this.createCheckboxForItem&&n&&n.showCheckbox,f=h+e+f+(n?20:0),E=b.useHTML,g=a.options.className;m||(a.legendGroup=d.g("legend-item").addClass("highcharts-"+A.type+"-series highcharts-color-"+a.colorIndex+(g?" "+g:"")+(G?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),
a.legendItem=m=d.text("",p?h+e:-e,this.baseline||0,E).css(t(a.visible?l:k)).attr({align:p?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(h=l.fontSize,this.fontMetrics=d.fontMetrics(h,m),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,m.attr("y",this.baseline)),this.symbolHeight=b.symbolHeight||this.fontMetrics.f,A.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,m,E),n&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);l.width||m.css({width:(b.itemWidth||
b.width||c.spacingBox.width)-f});this.setText(a);c=m.getBBox();a.itemWidth=a.checkboxOffset=b.itemWidth||a.legendItemWidth||c.width+f;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||c.height||this.symbolHeight)},layoutItem:function(a){var c=this.options,d=this.padding,b="horizontal"===c.layout,h=a.itemHeight,e=c.itemMarginBottom||0,l=this.itemMarginTop,k=b?w(c.itemDistance,20):0,f=c.width,p=f||this.chart.spacingBox.width-
2*d-c.x,c=c.alignColumns&&this.totalItemWidth>p?this.maxItemWidth:a.itemWidth;b&&this.itemX-d+c>p&&(this.itemX=d,this.itemY+=l+this.lastLineHeight+e,this.lastLineHeight=0);this.lastItemY=l+this.itemY+e;this.lastLineHeight=Math.max(h,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];b?this.itemX+=c:(this.itemY+=l+h+e,this.lastLineHeight=h);this.offsetWidth=f||Math.max((b?this.itemX-d-(a.checkbox?0:k):c)+d,this.offsetWidth)},getAllItems:function(){var a=[];f(this.chart.series,function(c){var d=
c&&c.options;c&&w(d.showInLegend,n(d.linkedTo)?!1:void 0,!0)&&(a=a.concat(c.legendItems||("point"===d.legendType?c.data:c)))});e(this,"afterGetAllItems",{allItems:a});return a},getAlignment:function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)},adjustMargins:function(a,c){var d=this.chart,b=this.options,h=this.getAlignment();h&&f([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(e,
l){e.test(h)&&!n(a[l])&&(d[x[l]]=Math.max(d[x[l]],d.legend[(l+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][l]*b[l%2?"x":"y"]+w(b.margin,12)+c[l]+(0===l&&void 0!==d.options.title.margin?d.titleOffset+d.options.title.margin:0)))})},proximatePositions:function(){var c=this.chart,h=[],d="left"===this.options.align;f(this.allItems,function(b){var e,k;e=d;b.xAxis&&b.points&&(b.xAxis.options.reversed&&(e=!e),e=a.find(e?b.points:b.points.slice(0).reverse(),function(b){return a.isNumber(b.plotY)}),k=b.legendGroup.getBBox().height,
h.push({target:b.visible?(e?e.plotY:b.xAxis.height)-.3*k:c.plotHeight,size:k,item:b}))},this);a.distribute(h,c.plotHeight);f(h,function(a){a.item._legendItemPos[1]=c.plotTop-c.spacing[0]+a.pos})},render:function(){var a=this.chart,h=a.renderer,d=this.group,b,e,p,l=this.box,n=this.options,B=this.padding;this.itemX=B;this.itemY=this.initialItemY;this.lastItemY=this.offsetWidth=0;d||(this.group=d=h.g("legend").attr({zIndex:7}).add(),this.contentGroup=h.g().attr({zIndex:1}).add(d),this.scrollGroup=h.g().add(this.contentGroup));
this.renderTitle();b=this.getAllItems();c(b,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});n.reversed&&b.reverse();this.allItems=b;this.display=e=!!b.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;f(b,this.renderItem,this);f(b,this.layoutItem,this);b=(n.width||this.offsetWidth)+B;p=this.lastItemY+this.lastLineHeight+this.titleHeight;p=this.handleOverflow(p);p+=B;l||(this.box=l=h.rect().addClass("highcharts-legend-box").attr({r:n.borderRadius}).add(d),
l.isNew=!0);l.attr({stroke:n.borderColor,"stroke-width":n.borderWidth||0,fill:n.backgroundColor||"none"}).shadow(n.shadow);0<b&&0<p&&(l[l.isNew?"attr":"animate"](l.crisp.call({},{x:0,y:0,width:b,height:p},l.strokeWidth())),l.isNew=!1);l[e?"show":"hide"]();this.legendWidth=b;this.legendHeight=p;e&&(h=a.spacingBox,/(lth|ct|rth)/.test(this.getAlignment())&&(h=t(h,{y:h.y+a.titleOffset+a.options.title.margin})),d.align(t(n,{width:b,height:p,verticalAlign:this.proximate?"top":n.verticalAlign}),!0,h));this.proximate||
this.positionItems()},handleOverflow:function(a){var c=this,d=this.chart,b=d.renderer,h=this.options,e=h.y,l=this.padding,d=d.spacingBox.height+("top"===h.verticalAlign?-e:e)-l,e=h.maxHeight,k,p=this.clipRect,n=h.navigation,m=w(n.animation,!0),G=n.arrowSize||12,A=this.nav,t=this.pages,E,g=this.allItems,r=function(a){"number"===typeof a?p.attr({height:a}):p&&(c.clipRect=p.destroy(),c.contentGroup.clip());c.contentGroup.div&&(c.contentGroup.div.style.clip=a?"rect("+l+"px,9999px,"+(l+a)+"px,0)":"auto")};
"horizontal"!==h.layout||"middle"===h.verticalAlign||h.floating||(d/=2);e&&(d=Math.min(d,e));t.length=0;a>d&&!1!==n.enabled?(this.clipHeight=k=Math.max(d-20-this.titleHeight-l,0),this.currentPage=w(this.currentPage,1),this.fullHeight=a,f(g,function(a,b){var c=a._legendItemPos[1],d=Math.round(a.legendItem.getBBox().height),m=t.length;if(!m||c-t[m-1]>k&&(E||c)!==t[m-1])t.push(E||c),m++;a.pageIx=m-1;E&&(g[b-1].pageIx=m-1);b===g.length-1&&c+d-t[m-1]>k&&(t.push(c),a.pageIx=m);c!==E&&(E=c)}),p||(p=c.clipRect=
b.clipRect(0,l,9999,0),c.contentGroup.clip(p)),r(k),A||(this.nav=A=b.g().attr({zIndex:1}).add(this.group),this.up=b.symbol("triangle",0,0,G,G).on("click",function(){c.scroll(-1,m)}).add(A),this.pager=b.text("",15,10).addClass("highcharts-legend-navigation").css(n.style).add(A),this.down=b.symbol("triangle-down",0,0,G,G).on("click",function(){c.scroll(1,m)}).add(A)),c.scroll(0),a=d):A&&(r(),this.nav=A.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,c){var d=
this.pages,b=d.length;a=this.currentPage+a;var h=this.clipHeight,e=this.options.navigation,l=this.pager,f=this.padding;a>b&&(a=b);0<a&&(void 0!==c&&y(c,this.chart),this.nav.attr({translateX:f,translateY:h+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),l.attr({text:a+"/"+b}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===b?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),
this.up.attr({fill:1===a?e.inactiveColor:e.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===b?e.inactiveColor:e.activeColor}).css({cursor:a===b?"default":"pointer"}),this.scrollOffset=-d[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=a,this.positionCheckboxes())}};a.LegendSymbolMixin={drawRectangle:function(a,c){var d=a.symbolHeight,b=a.options.squareSymbol;c.legendSymbol=this.chart.renderer.rect(b?(a.symbolWidth-d)/2:
0,a.baseline-d+1,b?d:a.symbolWidth,d,w(a.options.symbolRadius,d/2)).addClass("highcharts-point").attr({zIndex:3}).add(c.legendGroup)},drawLineMarker:function(a){var c=this.options,d=c.marker,b=a.symbolWidth,h=a.symbolHeight,e=h/2,l=this.chart.renderer,f=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var k;k={"stroke-width":c.lineWidth||0};c.dashStyle&&(k.dashstyle=c.dashStyle);this.legendLine=l.path(["M",0,a,"L",b,a]).addClass("highcharts-graph").attr(k).add(f);d&&!1!==d.enabled&&b&&
(c=Math.min(w(d.radius,e),e),0===this.symbol.indexOf("url")&&(d=t(d,{width:h,height:h}),c=0),this.legendSymbol=d=l.symbol(this.symbol,b/2-c,a-c,2*c,2*c,d).addClass("highcharts-point").add(f),d.isMarker=!0)}};(/Trident\/7\.0/.test(h.navigator.userAgent)||u)&&p(a.Legend.prototype,"positionItem",function(a,c){var d=this,b=function(){c._legendItemPos&&a.call(d,c)};b();setTimeout(b)})})(K);(function(a){var C=a.addEvent,F=a.animate,I=a.animObject,n=a.attr,f=a.doc,e=a.Axis,u=a.createElement,x=a.defaultOptions,
t=a.discardElement,w=a.charts,y=a.css,c=a.defined,h=a.each,p=a.extend,k=a.find,q=a.fireEvent,d=a.grep,b=a.isNumber,v=a.isObject,J=a.isString,l=a.Legend,L=a.marginNames,B=a.merge,D=a.objectEach,m=a.Pointer,G=a.pick,A=a.pInt,N=a.removeEvent,E=a.seriesTypes,g=a.splat,r=a.syncTimeout,M=a.win,O=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new O(a,b,c)};p(O.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(J(a[0])||a[0].nodeName)this.renderTo=
a.shift();this.init(a[0],a[1])},init:function(b,c){var d,g,m=b.series,h=b.plotOptions||{};q(this,"init",{args:arguments},function(){b.series=null;d=B(x,b);for(g in d.plotOptions)d.plotOptions[g].tooltip=h[g]&&B(h[g].tooltip)||void 0;d.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;d.series=b.series=m;this.userOptions=b;var e=d.chart,l=e.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=c;this.isResizing=0;this.options=
d;this.axes=[];this.series=[];this.time=b.time&&a.keys(b.time).length?new a.Time(b.time):a.time;this.hasCartesianSeries=e.showAxes;var f=this;f.index=w.length;w.push(f);a.chartCount++;l&&D(l,function(a,b){C(f,b,a)});f.xAxis=[];f.yAxis=[];f.pointCount=f.colorCounter=f.symbolCounter=0;q(f,"afterInit");f.firstRender()})},initSeries:function(b){var c=this.options.chart;(c=E[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;
for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,c){var d=c?b:a;a=c?a:b;return 0<=d&&d<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){q(this,"beforeRedraw");var c=this.axes,d=this.series,g=this.pointer,m=this.legend,e=this.userOptions.legend,l=this.isDirtyLegend,f,A,k=this.hasCartesianSeries,r=this.isDirtyBox,G,v=this.renderer,H=v.isHidden(),E=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);H&&this.temporaryDisplay();
this.layOutTitles();for(b=d.length;b--;)if(G=d[b],G.options.stacking&&(f=!0,G.isDirty)){A=!0;break}if(A)for(b=d.length;b--;)G=d[b],G.options.stacking&&(G.isDirty=!0);h(d,function(a){a.isDirty&&("point"===a.options.legendType?(a.updateTotals&&a.updateTotals(),l=!0):e&&(e.labelFormatter||e.labelFormat)&&(l=!0));a.isDirtyData&&q(a,"updatedData")});l&&m&&m.options.enabled&&(m.render(),this.isDirtyLegend=!1);f&&this.getStacks();k&&h(c,function(a){a.updateNames();a.updateYNames&&a.updateYNames();a.setScale()});
this.getMargins();k&&(h(c,function(a){a.isDirty&&(r=!0)}),h(c,function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,E.push(function(){q(a,"afterSetExtremes",p(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(r||f)&&a.redraw()}));r&&this.drawChartBox();q(this,"predraw");h(d,function(a){(r||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});g&&g.reset(!0);v.draw();q(this,"redraw");q(this,"render");H&&this.temporaryDisplay(!0);h(E,function(a){a.call()})},get:function(a){function b(b){return b.id===
a||b.options&&b.options.id===a}var c,d=this.series,g;c=k(this.axes,b)||k(this.series,b);for(g=0;!c&&g<d.length;g++)c=k(d[g].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=g(b.xAxis||{}),b=b.yAxis=g(b.yAxis||{});q(this,"getAxes");h(c,function(a,b){a.index=b;a.isX=!0});h(b,function(a,b){a.index=b});c=c.concat(b);h(c,function(b){new e(a,b)});q(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];h(this.series,function(b){a=a.concat(d(b.data||[],function(a){return a.selected}))});
return a},getSelectedSeries:function(){return d(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var d=this,g=d.options,m;m=g.title=B({style:{color:"#333333",fontSize:g.isStock?"16px":"18px"}},g.title,a);g=g.subtitle=B({style:{color:"#666666"}},g.subtitle,b);h([["title",a,m],["subtitle",b,g]],function(a,b){var c=a[0],g=d[c],m=a[1];a=a[2];g&&m&&(d[c]=g=g.destroy());a&&!g&&(d[c]=d.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),
d[c].update=function(a){d.setTitle(!b&&a,b&&a)},d[c].css(a.style))});d.layOutTitles(c)},layOutTitles:function(a){var b=0,c,d=this.renderer,g=this.spacingBox;h(["title","subtitle"],function(a){var c=this[a],m=this.options[a];a="title"===a?-3:m.verticalAlign?0:b+2;var h;c&&(h=m.style.fontSize,h=d.fontMetrics(h,c).b,c.css({width:(m.width||g.width+m.widthAdjust)+"px"}).align(p({y:a+h},m),!1,"spacingBox"),m.floating||m.verticalAlign||(b=Math.ceil(b+c.getBBox(m.useHTML).height)))},this);c=this.titleOffset!==
b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=this.isDirtyLegend=c,this.hasRendered&&G(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,d=b.width,b=b.height,g=this.renderTo;c(d)||(this.containerWidth=a.getStyle(g,"width"));c(b)||(this.containerHeight=a.getStyle(g,"height"));this.chartWidth=Math.max(0,d||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},
temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),delete c.hcOrigStyle),c.hcOrigDetached&&(f.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){f.body.contains(c)||c.parentNode||(c.hcOrigDetached=!0,f.body.appendChild(c));if("none"===a.getStyle(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},b={display:"block",overflow:"hidden"},c!==this.renderTo&&
(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;if(c===f.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var c,d=this.options,g=d.chart,m,h;c=this.renderTo;var e=a.uniqueKey(),l;c||(this.renderTo=c=g.renderTo);J(c)&&(this.renderTo=c=f.getElementById(c));c||a.error(13,!0);m=A(n(c,"data-highcharts-chart"));b(m)&&w[m]&&w[m].hasRendered&&w[m].destroy();n(c,"data-highcharts-chart",
this.index);c.innerHTML="";g.skipClone||c.offsetWidth||this.temporaryDisplay();this.getChartSize();m=this.chartWidth;h=this.chartHeight;l=p({position:"relative",overflow:"hidden",width:m+"px",height:h+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},g.style);this.container=c=u("div",{id:e},l,c);this._cursor=c.style.cursor;this.renderer=new (a[g.renderer]||a.Renderer)(c,m,h,null,g.forExport,d.exporting&&d.exporting.allowHTML);this.setClassName(g.className);
this.renderer.setStyle(g.style);this.renderer.chartIndex=this.index;q(this,"afterGetContainer")},getMargins:function(a){var b=this.spacing,d=this.margin,g=this.titleOffset;this.resetMargins();g&&!c(d[0])&&(this.plotTop=Math.max(this.plotTop,g+this.options.title.margin+b[0]));this.legend&&this.legend.display&&this.legend.adjustMargins(d,b);q(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],d=a.margin;a.hasCartesianSeries&&h(a.axes,function(a){a.visible&&
a.getOffset()});h(L,function(g,m){c(d[m])||(a[g]+=b[m])});a.setChartSize()},reflow:function(b){var d=this,g=d.options.chart,m=d.renderTo,h=c(g.width)&&c(g.height),e=g.width||a.getStyle(m,"width"),g=g.height||a.getStyle(m,"height"),m=b?b.target:M;if(!h&&!d.isPrinting&&e&&g&&(m===M||m===f)){if(e!==d.containerWidth||g!==d.containerHeight)a.clearTimeout(d.reflowTimeout),d.reflowTimeout=r(function(){d.container&&d.setSize(void 0,void 0,!1)},b?100:0);d.containerWidth=e;d.containerHeight=g}},setReflow:function(a){var b=
this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=C(M,"resize",function(a){b.reflow(a)}),C(this,"destroy",this.unbindReflow))},setSize:function(b,c,d){var g=this,m=g.renderer;g.isResizing+=1;a.setAnimation(d,g);g.oldChartHeight=g.chartHeight;g.oldChartWidth=g.chartWidth;void 0!==b&&(g.options.chart.width=b);void 0!==c&&(g.options.chart.height=c);g.getChartSize();b=m.globalAnimation;(b?F:y)(g.container,{width:g.chartWidth+"px",height:g.chartHeight+
"px"},b);g.setChartSize(!0);m.setSize(g.chartWidth,g.chartHeight,d);h(g.axes,function(a){a.isDirty=!0;a.setScale()});g.isDirtyLegend=!0;g.isDirtyBox=!0;g.layOutTitles();g.getMargins();g.redraw(d);g.oldChartHeight=null;q(g,"resize");r(function(){g&&q(g,"endResize",null,function(){--g.isResizing})},I(b).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,g=this.chartWidth,d=this.chartHeight,m=this.options.chart,e=this.spacing,l=this.clipOffset,f,A,k,r;this.plotLeft=f=Math.round(this.plotLeft);
this.plotTop=A=Math.round(this.plotTop);this.plotWidth=k=Math.max(0,Math.round(g-f-this.marginRight));this.plotHeight=r=Math.max(0,Math.round(d-A-this.marginBottom));this.plotSizeX=b?r:k;this.plotSizeY=b?k:r;this.plotBorderWidth=m.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:e[3],y:e[0],width:g-e[3]-e[1],height:d-e[0]-e[2]};this.plotBox=c.plotBox={x:f,y:A,width:k,height:r};g=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(g,l[3])/2);c=Math.ceil(Math.max(g,l[0])/2);this.clipBox={x:b,
y:c,width:Math.floor(this.plotSizeX-Math.max(g,l[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(g,l[2])/2-c))};a||h(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()});q(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){var a=this,b=a.options.chart;h(["margin","spacing"],function(c){var g=b[c],d=v(g)?g:[g,g,g,g];h(["Top","Right","Bottom","Left"],function(g,m){a[c][m]=G(b[c+g],d[m])})});h(L,function(b,c){a[b]=G(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,
0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,g=this.chartHeight,d=this.chartBackground,m=this.plotBackground,h=this.plotBorder,e,l=this.plotBGImage,f=a.backgroundColor,A=a.plotBackgroundColor,k=a.plotBackgroundImage,r,p=this.plotLeft,G=this.plotTop,v=this.plotWidth,E=this.plotHeight,n=this.plotBox,B=this.clipRect,t=this.clipBox,u="animate";d||(this.chartBackground=d=b.rect().addClass("highcharts-background").add(),u="attr");e=a.borderWidth||
0;r=e+(a.shadow?8:0);f={fill:f||"none"};if(e||d["stroke-width"])f.stroke=a.borderColor,f["stroke-width"]=e;d.attr(f).shadow(a.shadow);d[u]({x:r/2,y:r/2,width:c-r-e%2,height:g-r-e%2,r:a.borderRadius});u="animate";m||(u="attr",this.plotBackground=m=b.rect().addClass("highcharts-plot-background").add());m[u](n);m.attr({fill:A||"none"}).shadow(a.plotShadow);k&&(l?l.animate(n):this.plotBGImage=b.image(k,p,G,v,E).add());B?B.animate({width:t.width,height:t.height}):this.clipRect=b.clipRect(t);u="animate";
h||(u="attr",this.plotBorder=h=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());h.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});h[u](h.crisp({x:p,y:G,width:v,height:E},-h.strokeWidth()));this.isDirtyBox=!1;q(this,"afterDrawChartBox")},propFromSeries:function(){var a=this,b=a.options.chart,c,g=a.options.series,d,m;h(["inverted","angular","polar"],function(h){c=E[b.type||b.defaultSeriesType];m=b[h]||c&&c.prototype[h];for(d=g&&g.length;!m&&d--;)(c=
E[g[d].type])&&c.prototype[h]&&(m=!0);a[h]=m})},linkSeries:function(){var a=this,b=a.series;h(b,function(a){a.linkedSeries.length=0});h(b,function(b){var c=b.options.linkedTo;J(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=G(b.options.visible,c.options.visible,b.visible))});q(this,"afterLinkSeries")},renderSeries:function(){h(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;
b.items&&h(b.items,function(c){var g=p(b.style,c.style),d=A(g.left)+a.plotLeft,m=A(g.top)+a.plotTop+12;delete g.left;delete g.top;a.renderer.text(c.html,d,m).attr({zIndex:2}).css(g).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,g,d,m;this.setTitle();this.legend=new l(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;g=this.plotHeight=Math.max(this.plotHeight-21,0);h(a,function(a){a.setScale()});this.getAxisMargins();
d=1.1<c/this.plotWidth;m=1.05<g/this.plotHeight;if(d||m)h(a,function(a){(a.horiz&&d||!a.horiz&&m)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&h(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=B(!0,this.options.credits,a);a.enabled&&
!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(M.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,g=b.series,d=b.container,m,e=d&&d.parentNode;q(b,"destroy");b.renderer.forExport?a.erase(w,b):w[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");
N(b);for(m=c.length;m--;)c[m]=c[m].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(m=g.length;m--;)g[m]=g[m].destroy();h("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});d&&(d.innerHTML="",N(d),e&&t(d));D(b,function(a,c){delete b[c]})},firstRender:function(){var a=this,b=a.options;if(!a.isReadyToRender||
a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();h(b.series||[],function(b){a.initSeries(b)});a.linkSeries();q(a,"beforeRender");m&&(a.pointer=new m(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){h([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);q(this,"load");q(this,"render");c(this.index)&&this.setReflow(this.options.chart.reflow);
this.onload=null}})})(K);(function(a){var C=a.addEvent,F=a.Chart,I=a.each;C(F,"afterSetChartSize",function(n){var f=this.options.chart.scrollablePlotArea;(f=f&&f.minWidth)&&!this.renderer.forExport&&(this.scrollablePixels=f=Math.max(0,f-this.chartWidth))&&(this.plotWidth+=f,this.clipBox.width+=f,n.skipAxes||I(this.axes,function(e){1===e.side?e.getPlotLinePath=function(){var f=this.right,n;this.right=f-e.chart.scrollablePixels;n=a.Axis.prototype.getPlotLinePath.apply(this,arguments);this.right=f;return n}:
(e.setAxisSize(),e.setAxisTranslation())}))});C(F,"render",function(){this.scrollablePixels?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});F.prototype.setUpScrolling=function(){this.scrollingContainer=a.createElement("div",{className:"highcharts-scrolling"},{overflowX:"auto",WebkitOverflowScrolling:"touch"},this.renderTo);this.innerContainer=a.createElement("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);
this.setUpScrolling=null};F.prototype.applyFixed=function(){var n=this.container,f,e,u=!this.fixedDiv;u&&(this.fixedDiv=a.createElement("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,this.renderTo.firstChild),this.fixedRenderer=f=new a.Renderer(this.fixedDiv,0,0),this.scrollableMask=f.path().attr({fill:a.color(this.options.chart.backgroundColor||"#fff").setOpacity(.85).get(),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),
a.each([this.inverted?".highcharts-xaxis":".highcharts-yaxis",this.inverted?".highcharts-xaxis-labels":".highcharts-yaxis-labels",".highcharts-contextbutton",".highcharts-credits",".highcharts-legend",".highcharts-subtitle",".highcharts-title",".highcharts-legend-checkbox"],function(e){a.each(n.querySelectorAll(e),function(a){(a.namespaceURI===f.SVG_NS?f.box:f.box.parentNode).appendChild(a);a.style.pointerEvents="auto"})}));this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);e=this.chartWidth+
this.scrollablePixels;a.stop(this.container);this.container.style.width=e+"px";this.renderer.boxWrapper.attr({width:e,height:this.chartHeight,viewBox:[0,0,e,this.chartHeight].join(" ")});this.chartBackground.attr({width:e});u&&(e=this.options.chart.scrollablePlotArea,e.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixels*e.scrollPositionX));u=this.axisOffset;e=this.plotTop-u[0]-1;var u=this.plotTop+this.plotHeight+u[2],x=this.plotLeft+this.plotWidth-this.scrollablePixels;this.scrollableMask.attr({d:this.scrollablePixels?
["M",0,e,"L",this.plotLeft-1,e,"L",this.plotLeft-1,u,"L",0,u,"Z","M",x,e,"L",this.chartWidth,e,"L",this.chartWidth,u,"L",x,u,"Z"]:["M",0,0]})}})(K);(function(a){var C,F=a.each,I=a.extend,n=a.erase,f=a.fireEvent,e=a.format,u=a.isArray,x=a.isNumber,t=a.pick,w=a.uniqueKey,y=a.defined,c=a.removeEvent;a.Point=C=function(){};a.Point.prototype={init:function(a,c,e){this.series=a;this.color=a.color;this.applyOptions(c,e);this.id=y(this.id)?this.id:w();a.options.colorByPoint?(c=a.options.colors||a.chart.options.colors,
this.color=this.color||c[a.colorCounter],c=c.length,e=a.colorCounter,a.colorCounter++,a.colorCounter===c&&(a.colorCounter=0)):e=a.colorIndex;this.colorIndex=t(this.colorIndex,e);a.chart.pointCount++;f(this,"afterInit");return this},applyOptions:function(a,c){var e=this.series,h=e.options.pointValKey||e.pointValKey;a=C.prototype.optionsToObject.call(this,a);I(this,a);this.options=this.options?I(this.options,a):a;a.group&&delete this.group;a.dataLabels&&delete this.dataLabels;h&&(this.y=this[h]);this.isNull=
t(this.isValid&&!this.isValid(),null===this.x||!x(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===c&&e.xAxis&&e.xAxis.hasNames&&(this.x=e.xAxis.nameToX(this));void 0===this.x&&e&&(this.x=void 0===c?e.autoIncrement(this):c);return this},setNestedProperty:function(c,e,f){f=f.split(".");a.reduce(f,function(c,d,b,h){c[d]=h.length-1===b?e:a.isObject(c[d],!0)?c[d]:{};return c[d]},c);return c},optionsToObject:function(c){var e={},h=this.series,f=h.options.keys,d=f||h.pointArrayMap||
["y"],b=d.length,v=0,n=0;if(x(c)||null===c)e[d[0]]=c;else if(u(c))for(!f&&c.length>b&&(h=typeof c[0],"string"===h?e.name=c[0]:"number"===h&&(e.x=c[0]),v++);n<b;)f&&void 0===c[v]||(0<d[n].indexOf(".")?a.Point.prototype.setNestedProperty(e,c[v],d[n]):e[d[n]]=c[v]),v++,n++;else"object"===typeof c&&(e=c,c.dataLabels&&(h._hasPointLabels=!0),c.marker&&(h._hasPointMarkers=!0));return e},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":
"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,c=a.zones,a=a.zoneAxis||"y",e=0,f;for(f=c[e];this[a]>=f.value;)f=c[++e];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=f&&f.color&&!this.options.color?f.color:this.nonZonedColor;return f},
destroy:function(){var a=this.series.chart,e=a.hoverPoints,f;a.pointCount--;e&&(this.setState(),n(e,this),e.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel||this.dataLabels)c(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(f in this)this[f]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],c,e=6;e--;)c=a[e],this[c]&&(this[c]=this[c].destroy());this.dataLabels&&
(F(this.dataLabels,function(a){a.element&&a.destroy()}),delete this.dataLabels);this.connectors&&(F(this.connectors,function(a){a.element&&a.destroy()}),delete this.connectors)},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var c=this.series,h=c.tooltipOptions,f=t(h.valueDecimals,""),d=h.valuePrefix||
"",b=h.valueSuffix||"";F(c.pointArrayMap||["y"],function(c){c="{point."+c;if(d||b)a=a.replace(RegExp(c+"}","g"),d+c+"}"+b);a=a.replace(RegExp(c+"}","g"),c+":,."+f+"f}")});return e(a,{point:this,series:this.series},c.chart.time)},firePointEvent:function(a,c,e){var h=this,d=this.series.options;(d.point.events[a]||h.options&&h.options.events&&h.options.events[a])&&this.importEvents();"click"===a&&d.allowPointSelect&&(e=function(a){h.select&&h.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});f(this,a,
c,e)},visible:!0}})(K);(function(a){var C=a.addEvent,F=a.animObject,I=a.arrayMax,n=a.arrayMin,f=a.correctFloat,e=a.defaultOptions,u=a.defaultPlotOptions,x=a.defined,t=a.each,w=a.erase,y=a.extend,c=a.fireEvent,h=a.grep,p=a.isArray,k=a.isNumber,q=a.isString,d=a.merge,b=a.objectEach,v=a.pick,J=a.removeEvent,l=a.splat,L=a.SVGElement,B=a.syncTimeout,D=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",
enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},
hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,d){var m=this,e,h=a.series,g;m.chart=a;m.options=d=m.setOptions(d);m.linkedSeries=[];m.bindAxes();y(m,{name:d.name,state:"",visible:!1!==d.visible,selected:!0===d.selected});
e=d.events;b(e,function(a,b){C(m,b,a)});if(e&&e.click||d.point&&d.point.events&&d.point.events.click||d.allowPointSelect)a.runTrackerClick=!0;m.getColor();m.getSymbol();t(m.parallelArrays,function(a){m[a+"Data"]=[]});m.setData(d.data,!1);m.isCartesian&&(a.hasCartesianSeries=!0);h.length&&(g=h[h.length-1]);m._i=v(g&&g._i,-1)+1;a.orderSeries(this.insert(h));c(this,"afterInit")},insert:function(a){var b=this.options.index,c;if(k(b)){for(c=a.length;c--;)if(b>=v(a[c].options.index,a[c]._i)){a.splice(c+
1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return v(c,a.length-1)},bindAxes:function(){var b=this,c=b.options,d=b.chart,e;t(b.axisTypes||[],function(m){t(d[m],function(a){e=a.options;if(c[m]===e.index||void 0!==c[m]&&c[m]===e.id||void 0===c[m]&&0===e.index)b.insert(a.series),b[m]=a,a.isDirty=!0});b[m]||b.optionalAxis===m||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,d=arguments,m=k(b)?function(g){var d="y"===g&&c.toYData?c.toYData(a):a[g];c[g+"Data"][b]=
d}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,2))};t(c.parallelArrays,m)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,e=this.chart.time,b=v(b,a.pointStart,0);this.pointInterval=c=v(this.pointInterval,a.pointInterval,1);d&&(a=new e.Date(b),"day"===d?e.set("Date",a,e.get("Date",a)+c):"month"===d?e.set("Month",a,e.get("Month",a)+c):"year"===d&&e.set("FullYear",a,e.get("FullYear",a)+c),c=a.getTime()-b);this.xIncrement=b+c;return b},
setOptions:function(a){var b=this.chart,m=b.options,h=m.plotOptions,f=(b.userOptions||{}).plotOptions||{},g=h[this.type];this.userOptions=a;b=d(g,h.series,a);this.tooltipOptions=d(e.tooltip,e.plotOptions.series&&e.plotOptions.series.tooltip,e.plotOptions[this.type].tooltip,m.tooltip.userOptions,h.series&&h.series.tooltip,h[this.type].tooltip,a.tooltip);this.stickyTracking=v(a.stickyTracking,f[this.type]&&f[this.type].stickyTracking,f.series&&f.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?
!0:b.stickyTracking);null===g.marker&&delete b.marker;this.zoneAxis=b.zoneAxis;a=this.zones=(b.zones||[]).slice();!b.negativeColor&&!b.negativeFillColor||b.zones||a.push({value:b[this.zoneAxis+"Threshold"]||b.threshold||0,className:"highcharts-negative",color:b.negativeColor,fillColor:b.negativeFillColor});a.length&&x(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});c(this,"afterSetOptions",{options:b});return b},getName:function(){return this.name||"Series "+(this.index+
1)},getCyclic:function(a,b,c){var d,e=this.chart,g=this.userOptions,m=a+"Index",h=a+"Counter",f=c?c.length:v(e.options.chart[a+"Count"],e[a+"Count"]);b||(d=v(g[m],g["_"+m]),x(d)||(e.series.length||(e[h]=0),g["_"+m]=d=e[h]%f,e[h]+=1),c&&(b=c[d]));void 0!==d&&(this[m]=d);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||u[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,
this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,updateData:function(b){var c=this.options,d=this.points,e=[],m,g,h,f=this.requireSorting;t(b,function(b){var g;g=a.defined(b)&&this.pointClass.prototype.optionsToObject.call({series:this},b).x;k(g)&&(g=a.inArray(g,this.xData,h),-1===g||d[g].touched?e.push(b):b!==c.data[g]?(d[g].update(b,!1,null,!1),d[g].touched=!0,f&&(h=g+1)):d[g]&&(d[g].touched=!0),m=!0)},this);if(m)for(b=d.length;b--;)g=d[b],g.touched||g.remove(!1),
g.touched=!1;else if(b.length===d.length)t(b,function(a,b){d[b].update&&a!==c.data[b]&&d[b].update(a,!1,null,!1)});else return!1;t(e,function(a){this.addPoint(a,!1)},this);return!0},setData:function(b,c,d,e){var m=this,g=m.points,h=g&&g.length||0,f,l=m.options,A=m.chart,G=null,n=m.xAxis,B=l.turboThreshold,u=this.xData,D=this.yData,y=(f=m.pointArrayMap)&&f.length,N;b=b||[];f=b.length;c=v(c,!0);!1!==e&&f&&h&&!m.cropped&&!m.hasGroupedData&&m.visible&&!m.isSeriesBoosting&&(N=this.updateData(b));if(!N){m.xIncrement=
null;m.colorCounter=0;t(this.parallelArrays,function(a){m[a+"Data"].length=0});if(B&&f>B){for(d=0;null===G&&d<f;)G=b[d],d++;if(k(G))for(d=0;d<f;d++)u[d]=this.autoIncrement(),D[d]=b[d];else if(p(G))if(y)for(d=0;d<f;d++)G=b[d],u[d]=G[0],D[d]=G.slice(1,y+1);else for(d=0;d<f;d++)G=b[d],u[d]=G[0],D[d]=G[1];else a.error(12)}else for(d=0;d<f;d++)void 0!==b[d]&&(G={series:m},m.pointClass.prototype.applyOptions.apply(G,[b[d]]),m.updateParallelArrays(G,d));D&&q(D[0])&&a.error(14,!0);m.data=[];m.options.data=
m.userOptions.data=b;for(d=h;d--;)g[d]&&g[d].destroy&&g[d].destroy();n&&(n.minRange=n.userMinRange);m.isDirty=A.isDirtyBox=!0;m.isDirtyData=!!g;d=!1}"point"===l.legendType&&(this.processData(),this.generatePoints());c&&A.redraw(d)},processData:function(b){var c=this.xData,d=this.yData,e=c.length,m;m=0;var g,h,f=this.xAxis,l,k=this.options;l=k.cropThreshold;var p=this.getExtremesFromAll||k.getExtremesFromAll,q=this.isCartesian,k=f&&f.val2lin,v=f&&f.isLog,n=this.requireSorting,B,t;if(q&&!this.isDirty&&
!f.isDirty&&!this.yAxis.isDirty&&!b)return!1;f&&(b=f.getExtremes(),B=b.min,t=b.max);q&&this.sorted&&!p&&(!l||e>l||this.forceCrop)&&(c[e-1]<B||c[0]>t?(c=[],d=[]):this.yData&&(c[0]<B||c[e-1]>t)&&(m=this.cropData(this.xData,this.yData,B,t),c=m.xData,d=m.yData,m=m.start,g=!0));for(l=c.length||1;--l;)e=v?k(c[l])-k(c[l-1]):c[l]-c[l-1],0<e&&(void 0===h||e<h)?h=e:0>e&&n&&(a.error(15),n=!1);this.cropped=g;this.cropStart=m;this.processedXData=c;this.processedYData=d;this.closestPointRange=h},cropData:function(a,
b,c,d,e){var g=a.length,m=0,h=g,f;e=v(e,this.cropShoulder,1);for(f=0;f<g;f++)if(a[f]>=c){m=Math.max(0,f-e);break}for(c=f;c<g;c++)if(a[c]>d){h=c+e;break}return{xData:a.slice(m,h),yData:b.slice(m,h),start:m,end:h}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,d,e=this.processedXData,g=this.processedYData,h=this.pointClass,f=e.length,k=this.cropStart||0,p,q=this.hasGroupedData,a=a.keys,v,n=[],B;c||q||(c=[],c.length=b.length,c=this.data=c);a&&q&&(this.options.keys=!1);for(B=0;B<f;B++)p=
k+B,q?(v=(new h).init(this,[e[B]].concat(l(g[B]))),v.dataGroup=this.groupMap[B],v.dataGroup.options&&(v.options=v.dataGroup.options,y(v,v.dataGroup.options))):(v=c[p])||void 0===b[p]||(c[p]=v=(new h).init(this,b[p],e[B])),v&&(v.index=p,n[B]=v);this.options.keys=a;if(c&&(f!==(d=c.length)||q))for(B=0;B<d;B++)B!==k||q||(B+=f),c[B]&&(c[B].destroyElements(),c[B].plotX=void 0);this.data=c;this.points=n},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,d,e=[],g=0;d=this.xAxis.getExtremes();
var m=d.min,h=d.max,f,l,q=this.requireSorting?1:0,v,B;a=a||this.stackedYData||this.processedYData||[];d=a.length;for(B=0;B<d;B++)if(l=c[B],v=a[B],f=(k(v,!0)||p(v))&&(!b.positiveValuesOnly||v.length||0<v),l=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[B+q]||l)>=m&&(c[B-q]||l)<=h,f&&l)if(f=v.length)for(;f--;)"number"===typeof v[f]&&(e[g++]=v[f]);else e[g++]=v;this.dataMin=n(e);this.dataMax=I(e)},translate:function(){this.processedXData||this.processData();this.generatePoints();
var a=this.options,b=a.stacking,d=this.xAxis,e=d.categories,h=this.yAxis,g=this.points,l=g.length,p=!!this.modifyValue,q=a.pointPlacement,B="between"===q||k(q),n=a.threshold,t=a.startFromThreshold?n:0,u,D,y,w,J=Number.MAX_VALUE;"between"===q&&(q=.5);k(q)&&(q*=v(a.pointRange||d.pointRange));for(a=0;a<l;a++){var L=g[a],C=L.x,F=L.y;D=L.low;var I=b&&h.stacks[(this.negStacks&&F<(t?0:n)?"-":"")+this.stackKey],K;h.positiveValuesOnly&&null!==F&&0>=F&&(L.isNull=!0);L.plotX=u=f(Math.min(Math.max(-1E5,d.translate(C,
0,0,0,1,q,"flags"===this.type)),1E5));b&&this.visible&&!L.isNull&&I&&I[C]&&(w=this.getStackIndicator(w,C,this.index),K=I[C],F=K.points[w.key],D=F[0],F=F[1],D===t&&w.key===I[C].base&&(D=v(k(n)&&n,h.min)),h.positiveValuesOnly&&0>=D&&(D=null),L.total=L.stackTotal=K.total,L.percentage=K.total&&L.y/K.total*100,L.stackY=F,K.setOffset(this.pointXOffset||0,this.barW||0));L.yBottom=x(D)?Math.min(Math.max(-1E5,h.translate(D,0,1,0,1)),1E5):null;p&&(F=this.modifyValue(F,L));L.plotY=D="number"===typeof F&&Infinity!==
F?Math.min(Math.max(-1E5,h.translate(F,0,1,0,1)),1E5):void 0;L.isInside=void 0!==D&&0<=D&&D<=h.len&&0<=u&&u<=d.len;L.clientX=B?f(d.translate(C,0,0,0,1,q)):u;L.negative=L.y<(n||0);L.category=e&&void 0!==e[L.x]?e[L.x]:L.x;L.isNull||(void 0!==y&&(J=Math.min(J,Math.abs(u-y))),y=u);L.zone=this.zones.length&&L.getZone()}this.closestPointRangePx=J;c(this,"afterTranslate")},getValidPoints:function(a,b){var c=this.chart;return h(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?
!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,e=b.inverted,g=this.clipBox,m=g||b.clipBox,h=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,m.height,c.xAxis,c.yAxis].join(),f=b[h],l=b[h+"m"];f||(a&&(m.width=0,e&&(m.x=b.plotSizeX),b[h+"m"]=l=d.clipRect(e?b.plotSizeX+99:-99,e?-b.plotLeft:-b.plotTop,99,e?b.chartWidth:b.chartHeight)),b[h]=f=d.clipRect(m),f.count={length:0});a&&!f.count[this.index]&&(f.count[this.index]=!0,f.count.length+=1);!1!==c.clip&&
(this.group.clip(a||g?f:b.clipRect),this.markerGroup.clip(l),this.sharedClipKey=h);a||(f.count[this.index]&&(delete f.count[this.index],--f.count.length),0===f.count.length&&h&&b[h]&&(g||(b[h]=b[h].destroy()),b[h+"m"]&&(b[h+"m"]=b[h+"m"].destroy())))},animate:function(a){var b=this.chart,c=F(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX,x:0},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99,x:0},c),this.animate=null)},afterAnimate:function(){this.setClip();
c(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,c,d,e,g,h=this.options.marker,f,l,k,p=this[this.specialGroup]||this.markerGroup,q,n=v(h.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=h.enabledThreshold*h.radius);if(!1!==h.enabled||this._hasPointMarkers)for(c=0;c<a.length;c++)d=a[c],g=d.graphic,f=d.marker||{},l=!!d.marker,e=n&&void 0===f.enabled||f.enabled,k=d.isInside,e&&!d.isNull?(e=v(f.symbol,this.symbol),q=this.markerAttribs(d,
d.selected&&"select"),g?g[k?"show":"hide"](!0).animate(q):k&&(0<q.width||d.hasImage)&&(d.graphic=g=b.renderer.symbol(e,q.x,q.y,q.width,q.height,l?f:h).add(p)),g&&g.attr(this.pointAttribs(d,d.selected&&"select")),g&&g.addClass(d.getClassName(),!0)):g&&(d.graphic=g.destroy())},markerAttribs:function(a,b){var c=this.options.marker,d=a.marker||{},e=d.symbol||c.symbol,g=v(d.radius,c.radius);b&&(c=c.states[b],b=d.states&&d.states[b],g=v(b&&b.radius,c&&c.radius,g+(c&&c.radiusPlus||0)));a.hasImage=e&&0===
e.indexOf("url");a.hasImage&&(g=0);a={x:Math.floor(a.plotX)-g,y:a.plotY-g};g&&(a.width=a.height=2*g);return a},pointAttribs:function(a,b){var c=this.options.marker,d=a&&a.options,e=d&&d.marker||{},g=this.color,h=d&&d.color,m=a&&a.color,d=v(e.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;g=h||a||m||g;a=e.fillColor||c.fillColor||g;g=e.lineColor||c.lineColor||g;b&&(c=c.states[b],b=e.states&&e.states[b]||{},d=v(b.lineWidth,c.lineWidth,d+v(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||
a,g=b.lineColor||c.lineColor||g);return{stroke:g,"stroke-width":d,fill:a}},destroy:function(){var d=this,e=d.chart,h=/AppleWebKit\/533/.test(D.navigator.userAgent),f,l,g=d.data||[],k,p;c(d,"destroy");J(d);t(d.axisTypes||[],function(a){(p=d[a])&&p.series&&(w(p.series,d),p.isDirty=p.forceRedraw=!0)});d.legendItem&&d.chart.legend.destroyItem(d);for(l=g.length;l--;)(k=g[l])&&k.destroy&&k.destroy();d.points=null;a.clearTimeout(d.animationTimeout);b(d,function(a,b){a instanceof L&&!a.survive&&(f=h&&"group"===
b?"hide":"destroy",a[f]())});e.hoverSeries===d&&(e.hoverSeries=null);w(e.series,d);e.orderSeries();b(d,function(a,b){delete d[b]})},getGraphPath:function(a,b,c){var d=this,e=d.options,g=e.step,h,m=[],f=[],l;a=a||d.points;(h=a.reversed)&&a.reverse();(g={right:1,center:2}[g]||g&&3)&&h&&(g=4-g);!e.connectNulls||b||c||(a=this.getValidPoints(a));t(a,function(h,k){var r=h.plotX,p=h.plotY,q=a[k-1];(h.leftCliff||q&&q.rightCliff)&&!c&&(l=!0);h.isNull&&!x(b)&&0<k?l=!e.connectNulls:h.isNull&&!b?l=!0:(0===k||
l?k=["M",h.plotX,h.plotY]:d.getPointSpline?k=d.getPointSpline(a,h,k):g?(k=1===g?["L",q.plotX,p]:2===g?["L",(q.plotX+r)/2,q.plotY,"L",(q.plotX+r)/2,p]:["L",r,q.plotY],k.push("L",r,p)):k=["L",r,p],f.push(h.x),g&&(f.push(h.x),2===g&&f.push(h.x)),m.push.apply(m,k),l=!1)});m.xMap=f;return d.graphPath=m},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),d=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]],d=a.getZonesGraphs(d);t(d,function(d,
g){var e=d[0],h=a[e];h?(h.endX=a.preventGraphAnimation?null:c.xMap,h.animate({d:c})):c.length&&(a[e]=a.chart.renderer.path(c).addClass(d[1]).attr({zIndex:1}).add(a.group),h={stroke:d[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},d[3]?h.dashstyle=d[3]:"square"!==b.linecap&&(h["stroke-linecap"]=h["stroke-linejoin"]="round"),h=a[e].attr(h).shadow(2>g&&b.shadow));h&&(h.startX=c.xMap,h.isArea=c.isArea)})},getZonesGraphs:function(a){t(this.zones,function(b,c){a.push(["zone-graph-"+c,
"highcharts-graph highcharts-zone-graph-"+c+" "+(b.className||""),b.color||this.color,b.dashStyle||this.options.dashStyle])},this);return a},applyZones:function(){var a=this,b=this.chart,c=b.renderer,d=this.zones,e,g,h=this.clips||[],f,l=this.graph,k=this.area,p=Math.max(b.chartWidth,b.chartHeight),q=this[(this.zoneAxis||"y")+"Axis"],n,B,u=b.inverted,D,y,w,x,J=!1;d.length&&(l||k)&&q&&void 0!==q.min&&(B=q.reversed,D=q.horiz,l&&!this.showLine&&l.hide(),k&&k.hide(),n=q.getExtremes(),t(d,function(d,m){e=
B?D?b.plotWidth:0:D?0:q.toPixels(n.min);e=Math.min(Math.max(v(g,e),0),p);g=Math.min(Math.max(Math.round(q.toPixels(v(d.value,n.max),!0)),0),p);J&&(e=g=q.toPixels(n.max));y=Math.abs(e-g);w=Math.min(e,g);x=Math.max(e,g);q.isXAxis?(f={x:u?x:w,y:0,width:y,height:p},D||(f.x=b.plotHeight-f.x)):(f={x:0,y:u?x:w,width:p,height:y},D&&(f.y=b.plotWidth-f.y));u&&c.isVML&&(f=q.isXAxis?{x:0,y:B?w:x,height:f.width,width:b.chartWidth}:{x:f.y-b.plotLeft-b.spacingBox.x,y:0,width:f.height,height:b.chartHeight});h[m]?
h[m].animate(f):(h[m]=c.clipRect(f),l&&a["zone-graph-"+m].clip(h[m]),k&&a["zone-area-"+m].clip(h[m]));J=d.value>n.max;a.resetZones&&0===g&&(g=void 0)}),this.clips=h)},invertGroups:function(a){function b(){t(["group","markerGroup"],function(b){c[b]&&(d.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d=c.chart,e;c.xAxis&&(e=C(d,"resize",b),C(c,"destroy",e),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,d,
e){var g=this[a],h=!g;h&&(this[a]=g=this.chart.renderer.g().attr({zIndex:d||.1}).add(e));g.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(x(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(g.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);g.attr({visibility:c})[h?"attr":"animate"](this.getPlotBox());return g},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);
return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,d,e=a.options,h=!!a.animate&&b.renderer.isSVG&&F(e.animation).duration,g=a.visible?"inherit":"hidden",f=e.zIndex,l=a.hasRendered,k=b.seriesGroup,p=b.inverted;d=a.plotGroup("group","series",g,f,k);a.markerGroup=a.plotGroup("markerGroup","markers",g,f,k);h&&a.animate(!0);d.inverted=a.isCartesian?p:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();
a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(p);!1===e.clip||a.sharedClipKey||l||d.clip(b.clipRect);h&&a.animate();l||(a.animationTimeout=B(function(){a.afterAnimate()},h));a.isDirty=!1;a.hasRendered=!0;c(a,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,d=this.xAxis,e=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:v(d&&d.left,a.plotLeft),
translateY:v(e&&e.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,e=this.chart.inverted;return this.searchKDTree({clientX:e?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:e?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(c,d,g){var e,h;if(h=c&&c.length)return e=b.kdAxisArray[d%g],c.sort(function(a,b){return a[e]-b[e]}),h=Math.floor(h/2),{point:c[h],left:a(c.slice(0,
h),d+1,g),right:a(c.slice(h+1),d+1,g)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;B(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,f,l){var m=b.point,k=d.kdAxisArray[f%l],p,q,r=m;q=x(a[e])&&x(m[e])?Math.pow(a[e]-m[e],2):null;p=x(a[g])&&x(m[g])?Math.pow(a[g]-m[g],2):null;p=(q||0)+(p||0);m.dist=x(p)?Math.sqrt(p):Number.MAX_VALUE;m.distX=x(q)?
Math.sqrt(q):Number.MAX_VALUE;k=a[k]-m[k];p=0>k?"left":"right";q=0>k?"right":"left";b[p]&&(p=c(a,b[p],f+1,l),r=p[h]<r[h]?p:m);b[q]&&Math.sqrt(k*k)<r[h]&&(a=c(a,b[q],f+1,l),r=a[h]<r[h]?a:r);return r}var d=this,e=this.kdAxisArray[0],g=this.kdAxisArray[1],h=b?"distX":"dist";b=-1<d.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(K);(function(a){var C=a.Axis,F=a.Chart,I=a.correctFloat,n=a.defined,f=a.destroyObjectProperties,
e=a.each,u=a.format,x=a.objectEach,t=a.pick,w=a.Series;a.StackItem=function(a,c,e,f,k){var h=a.chart.inverted;this.axis=a;this.isNegative=e;this.options=c;this.x=f;this.total=null;this.points={};this.stack=k;this.rightCliff=this.leftCliff=0;this.alignOptions={align:c.align||(h?e?"left":"right":"center"),verticalAlign:c.verticalAlign||(h?"middle":e?"bottom":"top"),y:t(c.y,h?4:e?14:-6),x:t(c.x,h?e?-6:6:0)};this.textAlign=c.textAlign||(h?e?"right":"left":"center")};a.StackItem.prototype={destroy:function(){f(this,
this.axis)},render:function(a){var c=this.axis.chart,e=this.options,f=e.format,f=f?u(f,this,c.time):e.formatter.call(this);this.label?this.label.attr({text:f,visibility:"hidden"}):this.label=c.renderer.text(f,null,null,e.useHTML).css(e.style).attr({align:this.textAlign,rotation:e.rotation,visibility:"hidden"}).add(a);this.label.labelrank=c.plotHeight},setOffset:function(a,c){var e=this.axis,f=e.chart,k=e.translate(e.usePercentage?100:this.total,0,0,0,1),q=e.translate(0),q=n(k)&&Math.abs(k-q);a=f.xAxis[0].translate(this.x)+
a;e=n(k)&&this.getStackBox(f,this,a,k,c,q,e);(c=this.label)&&e&&(c.align(this.alignOptions,null,e),e=c.alignAttr,c[!1===this.options.crop||f.isInsidePlot(e.x,e.y)?"show":"hide"](!0))},getStackBox:function(a,c,e,f,k,q,d){var b=c.axis.reversed,h=a.inverted;a=d.height+d.pos-(h?a.plotLeft:a.plotTop);c=c.isNegative&&!b||!c.isNegative&&b;return{x:h?c?f:f-q:e,y:h?a-e-k:c?a-f-q:a-f,width:h?q:k,height:h?k:q}}};F.prototype.getStacks=function(){var a=this;e(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&
(a.oldStacks=a.stacks)});e(a.series,function(c){!c.options.stacking||!0!==c.visible&&!1!==a.options.chart.ignoreHiddenSeries||(c.stackKey=c.type+t(c.options.stack,""))})};C.prototype.buildStacks=function(){var a=this.series,c=t(this.options.reversedStacks,!0),e=a.length,f;if(!this.isXAxis){this.usePercentage=!1;for(f=e;f--;)a[c?f:e-f-1].setStackedPoints();for(f=0;f<e;f++)a[f].modifyStacks()}};C.prototype.renderStackTotals=function(){var a=this.chart,c=a.renderer,e=this.stacks,f=this.stackTotalGroup;
f||(this.stackTotalGroup=f=c.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());f.translate(a.plotLeft,a.plotTop);x(e,function(a){x(a,function(a){a.render(f)})})};C.prototype.resetStacks=function(){var a=this,c=a.stacks;a.isXAxis||x(c,function(c){x(c,function(e,h){e.touched<a.stacksTouched?(e.destroy(),delete c[h]):(e.total=null,e.cumulative=null)})})};C.prototype.cleanStacks=function(){var a;this.isXAxis||(this.oldStacks&&(a=this.stacks=this.oldStacks),x(a,function(a){x(a,function(a){a.cumulative=
a.total})}))};w.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var e=this.processedXData,c=this.processedYData,h=[],f=c.length,k=this.options,q=k.threshold,d=t(k.startFromThreshold&&q,0),b=k.stack,k=k.stacking,v=this.stackKey,u="-"+v,l=this.negStacks,w=this.yAxis,B=w.stacks,D=w.oldStacks,m,G,A,x,E,g,r;w.stacksTouched+=1;for(E=0;E<f;E++)g=e[E],r=c[E],m=this.getStackIndicator(m,g,this.index),x=m.key,A=(G=l&&r<(d?
0:q))?u:v,B[A]||(B[A]={}),B[A][g]||(D[A]&&D[A][g]?(B[A][g]=D[A][g],B[A][g].total=null):B[A][g]=new a.StackItem(w,w.options.stackLabels,G,g,b)),A=B[A][g],null!==r?(A.points[x]=A.points[this.index]=[t(A.cumulative,d)],n(A.cumulative)||(A.base=x),A.touched=w.stacksTouched,0<m.index&&!1===this.singleStacks&&(A.points[x][0]=A.points[this.index+","+g+",0"][0])):A.points[x]=A.points[this.index]=null,"percent"===k?(G=G?v:u,l&&B[G]&&B[G][g]?(G=B[G][g],A.total=G.total=Math.max(G.total,A.total)+Math.abs(r)||
0):A.total=I(A.total+(Math.abs(r)||0))):A.total=I(A.total+(r||0)),A.cumulative=t(A.cumulative,d)+(r||0),null!==r&&(A.points[x].push(A.cumulative),h[E]=A.cumulative);"percent"===k&&(w.usePercentage=!0);this.stackedYData=h;w.oldStacks={}}};w.prototype.modifyStacks=function(){var a=this,c=a.stackKey,h=a.yAxis.stacks,f=a.processedXData,k,q=a.options.stacking;a[q+"Stacker"]&&e([c,"-"+c],function(c){for(var b=f.length,d,e;b--;)if(d=f[b],k=a.getStackIndicator(k,d,a.index,c),e=(d=h[c]&&h[c][d])&&d.points[k.key])a[q+
"Stacker"](e,d,b)})};w.prototype.percentStacker=function(a,c,e){c=c.total?100/c.total:0;a[0]=I(a[0]*c);a[1]=I(a[1]*c);this.stackedYData[e]=a[1]};w.prototype.getStackIndicator=function(a,c,e,f){!n(a)||a.x!==c||f&&a.key!==f?a={x:c,index:0,key:f}:a.index++;a.key=[e,c,a.index].join();return a}})(K);(function(a){var C=a.addEvent,F=a.animate,I=a.Axis,n=a.createElement,f=a.css,e=a.defined,u=a.each,x=a.erase,t=a.extend,w=a.fireEvent,y=a.inArray,c=a.isNumber,h=a.isObject,p=a.isArray,k=a.merge,q=a.objectEach,
d=a.pick,b=a.Point,v=a.Series,J=a.seriesTypes,l=a.setAnimation,L=a.splat;t(a.Chart.prototype,{addSeries:function(a,b,c){var e,h=this;a&&(b=d(b,!0),w(h,"addSeries",{options:a},function(){e=h.initSeries(a);h.isDirtyLegend=!0;h.linkSeries();w(h,"afterAddSeries");b&&h.redraw(c)}));return e},addAxis:function(a,b,c,e){var h=b?"xAxis":"yAxis",f=this.options;a=k(a,{index:this[h].length,isX:b});b=new I(this,a);f[h]=L(f[h]||{});f[h].push(a);d(c,!0)&&this.redraw(e);return b},showLoading:function(a){var b=this,
c=b.options,d=b.loadingDiv,e=c.loading,h=function(){d&&f(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};d||(b.loadingDiv=d=n("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=n("span",{className:"highcharts-loading-inner"},null,d),C(b,"redraw",h));d.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;f(d,t(e.style,{zIndex:10}));f(b.loadingSpan,e.labelStyle);b.loadingShown||(f(d,{opacity:0,
display:""}),F(d,{opacity:e.style.opacity||.5},{duration:e.showDuration||0}));b.loadingShown=!0;h()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",F(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){f(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),update:function(a,b,h,f){var l=this,m={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},p=a.chart,g,r,v=[];w(l,"update",{options:a});if(p){k(!0,l.options.chart,p);"className"in p&&l.setClassName(p.className);"reflow"in p&&l.setReflow(p.reflow);if("inverted"in p||"polar"in p||"type"in p)l.propFromSeries(),g=!0;"alignTicks"in p&&(g=!0);q(p,function(a,b){-1!==
y("chart."+b,l.propsRequireUpdateSeries)&&(r=!0);-1!==y(b,l.propsRequireDirtyBox)&&(l.isDirtyBox=!0)});"style"in p&&l.renderer.setStyle(p.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&k(!0,this.options.plotOptions,a.plotOptions);q(a,function(a,b){if(l[b]&&"function"===typeof l[b].update)l[b].update(a,!1);else if("function"===typeof l[m[b]])l[m[b]](a);"chart"!==b&&-1!==y(b,l.propsRequireUpdateSeries)&&(r=!0)});u("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){var c;
a[b]&&("series"===b&&(c=[],u(l[b],function(a,b){a.options.isInternal||c.push(b)})),u(L(a[b]),function(a,d){(d=e(a.id)&&l.get(a.id)||l[b][c?c[d]:d])&&d.coll===b&&(d.update(a,!1),h&&(d.touched=!0));if(!d&&h)if("series"===b)l.addSeries(a,!1).touched=!0;else if("xAxis"===b||"yAxis"===b)l.addAxis(a,"xAxis"===b,!1).touched=!0}),h&&u(l[b],function(a){a.touched||a.options.isInternal?delete a.touched:v.push(a)}))});u(v,function(a){a.remove&&a.remove(!1)});g&&u(l.axes,function(a){a.update({},!1)});r&&u(l.series,
function(a){a.update({},!1)});a.loading&&k(!0,l.options.loading,a.loading);g=p&&p.width;p=p&&p.height;c(g)&&g!==l.chartWidth||c(p)&&p!==l.chartHeight?l.setSize(g,p,f):d(b,!0)&&l.redraw(f);w(l,"afterUpdate",{options:a})},setSubtitle:function(a){this.setTitle(void 0,a)}});t(b.prototype,{update:function(a,b,c,e){function f(){l.applyOptions(a);null===l.y&&g&&(l.graphic=g.destroy());h(a,!0)&&(g&&g.element&&a&&a.marker&&void 0!==a.marker.symbol&&(l.graphic=g.destroy()),a&&a.dataLabels&&l.dataLabel&&(l.dataLabel=
l.dataLabel.destroy()),l.connector&&(l.connector=l.connector.destroy()));k=l.index;m.updateParallelArrays(l,k);p.data[k]=h(p.data[k],!0)||h(a,!0)?l.options:d(a,p.data[k]);m.isDirty=m.isDirtyData=!0;!m.fixedBox&&m.hasCartesianSeries&&(q.isDirtyBox=!0);"point"===p.legendType&&(q.isDirtyLegend=!0);b&&q.redraw(c)}var l=this,m=l.series,g=l.graphic,k,q=m.chart,p=m.options;b=d(b,!0);!1===e?f():l.firePointEvent("update",{options:a},f)},remove:function(a,b){this.series.removePoint(y(this,this.series.data),
a,b)}});t(v.prototype,{addPoint:function(a,b,c,e){var h=this.options,f=this.data,l=this.chart,g=this.xAxis,g=g&&g.hasNames&&g.names,m=h.data,k,p,q=this.xData,v,n;b=d(b,!0);k={series:this};this.pointClass.prototype.applyOptions.apply(k,[a]);n=k.x;v=q.length;if(this.requireSorting&&n<q[v-1])for(p=!0;v&&q[v-1]>n;)v--;this.updateParallelArrays(k,"splice",v,0,0);this.updateParallelArrays(k,v);g&&k.name&&(g[n]=k.name);m.splice(v,0,a);p&&(this.data.splice(v,0,null),this.processData());"point"===h.legendType&&
this.generatePoints();c&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(k,"shift"),m.shift()));this.isDirtyData=this.isDirty=!0;b&&l.redraw(e)},removePoint:function(a,b,c){var e=this,h=e.data,f=h[a],m=e.points,g=e.chart,k=function(){m&&m.length===h.length&&m.splice(a,1);h.splice(a,1);e.options.data.splice(a,1);e.updateParallelArrays(f||{series:e},"splice",a,1);f&&f.destroy();e.isDirty=!0;e.isDirtyData=!0;b&&g.redraw()};l(c,g);b=d(b,!0);f?f.firePointEvent("remove",null,k):
k()},remove:function(a,b,c){function e(){h.destroy();h.remove=null;f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();d(a,!0)&&f.redraw(b)}var h=this,f=h.chart;!1!==c?w(h,"remove",null,e):e()},update:function(b,c){var e=this,h=e.chart,f=e.userOptions,l=e.oldType||e.type,q=b.type||f.type||h.options.chart.type,g=J[l].prototype,p,v=["group","markerGroup","dataLabelsGroup"],n=["navigatorSeries","baseSeries"],B=e.finishedAnimating&&{animation:!1},D=["data","name","turboThreshold"],x=a.keys(b),L=0<x.length;
u(x,function(a){-1===y(a,D)&&(L=!1)});if(L)b.data&&this.setData(b.data,!1),b.name&&this.setName(b.name,!1);else{n=v.concat(n);u(n,function(a){n[a]=e[a];delete e[a]});b=k(f,B,{index:e.index,pointStart:d(f.pointStart,e.xData[0])},{data:e.options.data},b);e.remove(!1,null,!1);for(p in g)e[p]=void 0;J[q||l]?t(e,J[q||l].prototype):a.error(17,!0);u(n,function(a){e[a]=n[a]});e.init(h,b);b.zIndex!==f.zIndex&&u(v,function(a){e[a]&&e[a].attr({zIndex:b.zIndex})});e.oldType=l;h.linkSeries()}w(this,"afterUpdate");
d(c,!0)&&h.redraw(L?void 0:!1)},setName:function(a){this.name=this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0}});t(I.prototype,{update:function(a,b){var c=this.chart,e=a&&a.events||{};a=k(this.userOptions,a);c.options[this.coll].indexOf&&(c.options[this.coll][c.options[this.coll].indexOf(this.userOptions)]=a);q(c.options[this.coll].events,function(a,b){"undefined"===typeof e[b]&&(e[b]=void 0)});this.destroy(!0);this.init(c,t(a,{events:e}));c.isDirtyBox=!0;d(b,!0)&&c.redraw()},
remove:function(a){for(var b=this.chart,c=this.coll,e=this.series,h=e.length;h--;)e[h]&&e[h].remove(!1);x(b.axes,this);x(b[c],this);p(b.options[c])?b.options[c].splice(this.options.index,1):delete b.options[c];u(b[c],function(a,b){a.options.index=a.userOptions.index=b});this.destroy();b.isDirtyBox=!0;d(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(K);(function(a){var C=a.color,F=a.each,I=a.map,n=a.pick,f=a.Series,
e=a.seriesType;e("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(e){var f=[],t=[],u=this.xAxis,y=this.yAxis,c=y.stacks[this.stackKey],h={},p=this.index,k=y.series,q=k.length,d,b=n(y.options.reversedStacks,!0)?1:-1,v;e=e||this.points;if(this.options.stacking){for(v=0;v<e.length;v++)e[v].leftNull=e[v].rightNull=null,h[e[v].x]=e[v];a.objectEach(c,function(a,b){null!==a.total&&t.push(b)});t.sort(function(a,b){return a-b});d=I(k,function(){return this.visible});F(t,
function(a,e){var l=0,k,n;if(h[a]&&!h[a].isNull)f.push(h[a]),F([-1,1],function(f){var l=1===f?"rightNull":"leftNull",m=0,u=c[t[e+f]];if(u)for(v=p;0<=v&&v<q;)k=u.points[v],k||(v===p?h[a][l]=!0:d[v]&&(n=c[a].points[v])&&(m-=n[1]-n[0])),v+=b;h[a][1===f?"rightCliff":"leftCliff"]=m});else{for(v=p;0<=v&&v<q;){if(k=c[a].points[v]){l=k[1];break}v+=b}l=y.translate(l,0,1,0,1);f.push({isNull:!0,plotX:u.translate(a,0,0,0,1),x:a,plotY:l,yBottom:l})}})}return f},getGraphPath:function(a){var e=f.prototype.getGraphPath,
t=this.options,u=t.stacking,y=this.yAxis,c,h,p=[],k=[],q=this.index,d,b=y.stacks[this.stackKey],v=t.threshold,J=y.getThreshold(t.threshold),l,t=t.connectNulls||"percent"===u,L=function(c,e,h){var f=a[c];c=u&&b[f.x].points[q];var l=f[h+"Null"]||0;h=f[h+"Cliff"]||0;var m,n,f=!0;h||l?(m=(l?c[0]:c[1])+h,n=c[0]+h,f=!!l):!u&&a[e]&&a[e].isNull&&(m=n=v);void 0!==m&&(k.push({plotX:d,plotY:null===m?J:y.getThreshold(m),isNull:f,isCliff:!0}),p.push({plotX:d,plotY:null===n?J:y.getThreshold(n),doCurve:!1}))};a=
a||this.points;u&&(a=this.getStackPoints(a));for(c=0;c<a.length;c++)if(h=a[c].isNull,d=n(a[c].rectPlotX,a[c].plotX),l=n(a[c].yBottom,J),!h||t)t||L(c,c-1,"left"),h&&!u&&t||(k.push(a[c]),p.push({x:c,plotX:d,plotY:l})),t||L(c,c+1,"right");c=e.call(this,k,!0,!0);p.reversed=!0;h=e.call(this,p,!0,!0);h.length&&(h[0]="L");h=c.concat(h);e=e.call(this,k,!1,t);h.xMap=c.xMap;this.areaPath=h;return e},drawGraph:function(){this.areaPath=[];f.prototype.drawGraph.apply(this);var a=this,e=this.areaPath,t=this.options,
w=[["area","highcharts-area",this.color,t.fillColor]];F(this.zones,function(e,c){w.push(["zone-area-"+c,"highcharts-area highcharts-zone-area-"+c+" "+e.className,e.color||a.color,e.fillColor||t.fillColor])});F(w,function(f){var c=f[0],h=a[c];h?(h.endX=a.preventGraphAnimation?null:e.xMap,h.animate({d:e})):(h=a[c]=a.chart.renderer.path(e).addClass(f[1]).attr({fill:n(f[3],C(f[2]).setOpacity(n(t.fillOpacity,.75)).get()),zIndex:0}).add(a.group),h.isArea=!0);h.startX=e.xMap;h.shiftUnit=t.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);
(function(a){var C=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,I,n){var f=I.plotX,e=I.plotY,u=a[n-1];n=a[n+1];var x,t,w,y;if(u&&!u.isNull&&!1!==u.doCurve&&!I.isCliff&&n&&!n.isNull&&!1!==n.doCurve&&!I.isCliff){a=u.plotY;w=n.plotX;n=n.plotY;var c=0;x=(1.5*f+u.plotX)/2.5;t=(1.5*e+a)/2.5;w=(1.5*f+w)/2.5;y=(1.5*e+n)/2.5;w!==x&&(c=(y-t)*(w-f)/(w-x)+e-y);t+=c;y+=c;t>a&&t>e?(t=Math.max(a,e),y=2*e-t):t<a&&t<e&&(t=Math.min(a,e),y=2*e-t);y>n&&y>e?(y=Math.max(n,e),t=2*e-y):y<n&&y<e&&
(y=Math.min(n,e),t=2*e-y);I.rightContX=w;I.rightContY=y}I=["C",C(u.rightContX,u.plotX),C(u.rightContY,u.plotY),C(x,f),C(t,e),f,e];u.rightContX=u.rightContY=null;return I}})})(K);(function(a){var C=a.seriesTypes.area.prototype,F=a.seriesType;F("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:C.getStackPoints,getGraphPath:C.getGraphPath,drawGraph:C.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(K);(function(a){var C=a.animObject,F=a.color,I=a.each,n=a.extend,f=a.defined,
e=a.isNumber,u=a.merge,x=a.pick,t=a.Series,w=a.seriesType,y=a.svg;w("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group",
"dataLabelsGroup"],negStacks:!0,init:function(){t.prototype.init.apply(this,arguments);var a=this,e=a.chart;e.hasRendered&&I(e.series,function(c){c.type===a.type&&(c.isDirty=!0)})},getColumnMetrics:function(){var a=this,e=a.options,f=a.xAxis,k=a.yAxis,q=f.options.reversedStacks,q=f.reversed&&!q||!f.reversed&&q,d,b={},v=0;!1===e.grouping?v=1:I(a.chart.series,function(c){var e=c.options,f=c.yAxis,h;c.type!==a.type||!c.visible&&a.chart.options.chart.ignoreHiddenSeries||k.len!==f.len||k.pos!==f.pos||
(e.stacking?(d=c.stackKey,void 0===b[d]&&(b[d]=v++),h=b[d]):!1!==e.grouping&&(h=v++),c.columnIndex=h)});var n=Math.min(Math.abs(f.transA)*(f.ordinalSlope||e.pointRange||f.closestPointRange||f.tickInterval||1),f.len),l=n*e.groupPadding,t=(n-2*l)/(v||1),e=Math.min(e.maxPointWidth||f.len,x(e.pointWidth,t*(1-2*e.pointPadding)));a.columnMetrics={width:e,offset:(t-e)/2+(l+((a.columnIndex||0)+(q?1:0))*t-n/2)*(q?-1:1)};return a.columnMetrics},crispCol:function(a,e,f,k){var c=this.chart,d=this.borderWidth,
b=-(d%2?.5:0),d=d%2?.5:1;c.inverted&&c.renderer.isVML&&(d+=1);this.options.crisp&&(f=Math.round(a+f)+b,a=Math.round(a)+b,f-=a);k=Math.round(e+k)+d;b=.5>=Math.abs(e)&&.5<k;e=Math.round(e)+d;k-=e;b&&k&&(--e,k+=1);return{x:a,y:e,width:f,height:k}},translate:function(){var a=this,e=a.chart,p=a.options,k=a.dense=2>a.closestPointRange*a.xAxis.transA,k=a.borderWidth=x(p.borderWidth,k?0:1),q=a.yAxis,d=p.threshold,b=a.translatedThreshold=q.getThreshold(d),v=x(p.minPointLength,5),n=a.getColumnMetrics(),l=n.width,
u=a.barW=Math.max(l,1+2*k),B=a.pointXOffset=n.offset;e.inverted&&(b-=.5);p.pointPadding&&(u=Math.ceil(u));t.prototype.translate.apply(a);I(a.points,function(c){var h=x(c.yBottom,b),k=999+Math.abs(h),p=l,k=Math.min(Math.max(-k,c.plotY),q.len+k),n=c.plotX+B,t=u,g=Math.min(k,h),r,w=Math.max(k,h)-g;v&&Math.abs(w)<v&&(w=v,r=!q.reversed&&!c.negative||q.reversed&&c.negative,c.y===d&&a.dataMax<=d&&q.min<d&&(r=!r),g=Math.abs(g-b)>v?h-v:b-(r?v:0));f(c.options.pointWidth)&&(p=t=Math.ceil(c.options.pointWidth),
n-=Math.round((p-l)/2));c.barX=n;c.pointWidth=p;c.tooltipPos=e.inverted?[q.len+q.pos-e.plotLeft-k,a.xAxis.len-n-t/2,w]:[n+t/2,k+q.pos-e.plotTop,w];c.shapeType="rect";c.shapeArgs=a.crispCol.apply(a,c.isNull?[n,b,t,0]:[n,g,t,w])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,e){var c=this.options,f,h=this.pointAttrToOptions||{};f=h.stroke||"borderColor";var d=
h["stroke-width"]||"borderWidth",b=a&&a.color||this.color,n=a&&a[f]||c[f]||this.color||b,t=a&&a[d]||c[d]||this[d]||0,h=c.dashStyle;a&&this.zones.length&&(b=a.getZone(),b=a.options.color||b&&b.color||this.color);e&&(a=u(c.states[e],a.options.states&&a.options.states[e]||{}),e=a.brightness,b=a.color||void 0!==e&&F(b).brighten(a.brightness).get()||b,n=a[f]||n,t=a[d]||t,h=a.dashStyle||h);f={fill:b,stroke:n,"stroke-width":t};h&&(f.dashstyle=h);return f},drawPoints:function(){var a=this,f=this.chart,p=
a.options,k=f.renderer,q=p.animationLimit||250,d;I(a.points,function(b){var c=b.graphic,h=c&&f.pointCount<q?"animate":"attr";if(e(b.plotY)&&null!==b.y){d=b.shapeArgs;if(c)c[h](u(d));else b.graphic=c=k[b.shapeType](d).add(b.group||a.group);p.borderRadius&&c.attr({r:p.borderRadius});c[h](a.pointAttribs(b,b.selected&&"select")).shadow(p.shadow,null,p.stacking&&!p.borderRadius);c.addClass(b.getClassName(),!0)}else c&&(b.graphic=c.destroy())})},animate:function(a){var c=this,e=this.yAxis,f=c.options,q=
this.chart.inverted,d={},b=q?"translateX":"translateY",v;y&&(a?(d.scaleY=.001,a=Math.min(e.pos+e.len,Math.max(e.pos,e.toPixels(f.threshold))),q?d.translateX=a-e.len:d.translateY=a,c.group.attr(d)):(v=c.group.attr(b),c.group.animate({scaleY:1},n(C(c.options.animation),{step:function(a,f){d[b]=v+f.pos*(e.pos-v);c.group.attr(d)}})),c.animate=null))},remove:function(){var a=this,e=a.chart;e.hasRendered&&I(e.series,function(c){c.type===a.type&&(c.isDirty=!0)});t.prototype.remove.apply(a,arguments)}})})(K);
(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(K);(function(a){var C=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,
trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&C.prototype.drawGraph.call(this)}})})(K);(function(a){var C=a.deg2rad,F=a.isNumber,I=a.pick,n=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,e=this.chart,u=2*(a.slicedOffset||0),x=e.plotWidth-2*u,e=e.plotHeight-2*u,t=a.center,t=[I(t[0],"50%"),I(t[1],"50%"),a.size||"100%",a.innerSize||0],w=Math.min(x,e),y,c;for(y=0;4>y;++y)c=t[y],a=2>y||2===y&&
/%$/.test(c),t[y]=n(c,[x,e,w,t[2]][y])+(a?u:0);t[3]>t[2]&&(t[3]=t[2]);return t},getStartAndEndRadians:function(a,e){a=F(a)?a:0;e=F(e)&&e>a&&360>e-a?e:a+360;return{start:C*(a+-90),end:C*(e+-90)}}}})(K);(function(a){var C=a.addEvent,F=a.CenteredSeriesMixin,I=a.defined,n=a.each,f=a.extend,e=F.getStartAndEndRadians,u=a.inArray,x=a.noop,t=a.pick,w=a.Point,y=a.Series,c=a.seriesType,h=a.setAnimation;c("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,distance:30,enabled:!0,
formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var c=this,e=c.points,
d=c.startAngleRad;a||(n(e,function(a){var b=a.graphic,e=a.shapeArgs;b&&(b.attr({r:a.startR||c.center[3]/2,start:d,end:d}),b.animate({r:e.r,start:e.start,end:e.end},c.options.animation))}),c.animate=null)},updateTotals:function(){var a,c=0,e=this.points,d=e.length,b,f=this.options.ignoreHiddenPoint;for(a=0;a<d;a++)b=e[a],c+=f&&!b.visible?0:b.isNull?0:b.y;this.total=c;for(a=0;a<d;a++)b=e[a],b.percentage=0<c&&(b.visible||!f)?b.y/c*100:0,b.total=c},generatePoints:function(){y.prototype.generatePoints.call(this);
this.updateTotals()},translate:function(a){this.generatePoints();var c=0,f=this.options,d=f.slicedOffset,b=d+(f.borderWidth||0),h,n,l,p=e(f.startAngle,f.endAngle),u=this.startAngleRad=p.start,p=(this.endAngleRad=p.end)-u,w=this.points,m,x=f.dataLabels.distance,f=f.ignoreHiddenPoint,A,y=w.length,E;a||(this.center=a=this.getCenter());this.getX=function(b,c,d){l=Math.asin(Math.min((b-a[1])/(a[2]/2+d.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(l)*(a[2]/2+d.labelDistance)};for(A=0;A<y;A++){E=w[A];
E.labelDistance=t(E.options.dataLabels&&E.options.dataLabels.distance,x);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,E.labelDistance);h=u+c*p;if(!f||E.visible)c+=E.percentage/100;n=u+c*p;E.shapeType="arc";E.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*h)/1E3,end:Math.round(1E3*n)/1E3};l=(n+h)/2;l>1.5*Math.PI?l-=2*Math.PI:l<-Math.PI/2&&(l+=2*Math.PI);E.slicedTranslation={translateX:Math.round(Math.cos(l)*d),translateY:Math.round(Math.sin(l)*d)};n=Math.cos(l)*a[2]/
2;m=Math.sin(l)*a[2]/2;E.tooltipPos=[a[0]+.7*n,a[1]+.7*m];E.half=l<-Math.PI/2||l>Math.PI/2?1:0;E.angle=l;h=Math.min(b,E.labelDistance/5);E.labelPos=[a[0]+n+Math.cos(l)*E.labelDistance,a[1]+m+Math.sin(l)*E.labelDistance,a[0]+n+Math.cos(l)*h,a[1]+m+Math.sin(l)*h,a[0]+n,a[1]+m,0>E.labelDistance?"center":E.half?"right":"left",l]}},drawGraph:null,drawPoints:function(){var a=this,c=a.chart.renderer,e,d,b,h,t=a.options.shadow;t&&!a.shadowGroup&&(a.shadowGroup=c.g("shadow").add(a.group));n(a.points,function(l){d=
l.graphic;if(l.isNull)d&&(l.graphic=d.destroy());else{h=l.shapeArgs;e=l.getTranslate();var k=l.shadowGroup;t&&!k&&(k=l.shadowGroup=c.g("shadow").add(a.shadowGroup));k&&k.attr(e);b=a.pointAttribs(l,l.selected&&"select");d?d.setRadialReference(a.center).attr(b).animate(f(h,e)):(l.graphic=d=c[l.shapeType](h).setRadialReference(a.center).attr(e).add(a.group),d.attr(b).attr({"stroke-linejoin":"round"}).shadow(t,k));d.attr({visibility:l.visible?"inherit":"hidden"});d.addClass(l.getClassName())}})},searchPoint:x,
sortByAngle:function(a,c){a.sort(function(a,d){return void 0!==a.angle&&(d.angle-a.angle)*c})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:F.getCenter,getSymbol:x},{init:function(){w.prototype.init.apply(this,arguments);var a=this,c;a.name=t(a.name,"Slice");c=function(c){a.slice("select"===c.type)};C(a,"select",c);C(a,"unselect",c);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,c){var e=this,d=e.series,b=d.chart,f=d.options.ignoreHiddenPoint;
c=t(c,f);a!==e.visible&&(e.visible=e.options.visible=a=void 0===a?!e.visible:a,d.options.data[u(e,d.data)]=e.options,n(["graphic","dataLabel","connector","shadowGroup"],function(b){if(e[b])e[b][a?"show":"hide"](!0)}),e.legendItem&&b.legend.colorizeItem(e,a),a||"hover"!==e.state||e.setState(""),f&&(d.isDirty=!0),c&&b.redraw())},slice:function(a,c,e){var d=this.series;h(e,d.chart);t(c,!0);this.sliced=this.options.sliced=I(a)?a:!this.sliced;d.options.data[u(this,d.data)]=this.options;this.graphic.animate(this.getTranslate());
this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var c=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(c.x,c.y,c.r+a,c.r+a,{innerR:this.shapeArgs.r-1,start:c.start,end:c.end})}})})(K);(function(a){var C=a.addEvent,F=a.arrayMax,I=a.defined,n=a.each,f=a.extend,e=a.format,u=a.map,x=a.merge,t=a.noop,w=a.pick,y=a.relativeLength,c=
a.Series,h=a.seriesTypes,p=a.some,k=a.stableSort,q=a.isArray,d=a.splat;a.distribute=function(b,c,d){function e(a,b){return a.target-b.target}var f,h=!0,q=b,m=[],v;v=0;var t=q.reducedLen||c;for(f=b.length;f--;)v+=b[f].size;if(v>t){k(b,function(a,b){return(b.rank||0)-(a.rank||0)});for(v=f=0;v<=t;)v+=b[f].size,f++;m=b.splice(f-1,b.length)}k(b,e);for(b=u(b,function(a){return{size:a.size,targets:[a.target],align:w(a.align,.5)}});h;){for(f=b.length;f--;)h=b[f],v=(Math.min.apply(0,h.targets)+Math.max.apply(0,
h.targets))/2,h.pos=Math.min(Math.max(0,v-h.size*h.align),c-h.size);f=b.length;for(h=!1;f--;)0<f&&b[f-1].pos+b[f-1].size>b[f].pos&&(b[f-1].size+=b[f].size,b[f-1].targets=b[f-1].targets.concat(b[f].targets),b[f-1].align=.5,b[f-1].pos+b[f-1].size>c&&(b[f-1].pos=c-b[f-1].size),b.splice(f,1),h=!0)}q.push.apply(q,m);f=0;p(b,function(b){var e=0;if(p(b.targets,function(){q[f].pos=b.pos+e;if(Math.abs(q[f].pos-q[f].target)>d)return n(q.slice(0,f+1),function(a){delete a.pos}),q.reducedLen=(q.reducedLen||c)-
.1*c,q.reducedLen>.1*c&&a.distribute(q,c,d),!0;e+=q[f].size;f++}))return!0});k(q,e)};c.prototype.drawDataLabels=function(){function b(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],c=c.value,"\x3e"===b&&a>c||"\x3c"===b&&a<c||"\x3e\x3d"===b&&a>=c||"\x3c\x3d"===b&&a<=c||"\x3d\x3d"===b&&a==c||"\x3d\x3d\x3d"===b&&a===c?!0:!1):!0}function c(a,b){var c=[],d;if(q(a)&&!q(b))c=u(a,function(a){return x(a,b)});else if(q(b)&&!q(a))c=u(b,function(b){return x(a,b)});else if(q(a)||q(b))for(d=Math.max(a.length,
b.length);d--;)c[d]=x(a[d],b[d]);else c=x(a,b);return c}var f=this,h=f.chart,k=f.options,p=k.dataLabels,t=f.points,m,y=f.hasRendered||0,A,F=w(p.defer,!!k.animation),E=h.renderer,p=c(c(h.options.plotOptions&&h.options.plotOptions.series&&h.options.plotOptions.series.dataLabels,h.options.plotOptions&&h.options.plotOptions[f.type]&&h.options.plotOptions[f.type].dataLabels),p);if(q(p)||p.enabled||f._hasPointLabels)A=f.plotGroup("dataLabelsGroup","data-labels",F&&!y?"hidden":"visible",p.zIndex||6),F&&
(A.attr({opacity:+y}),y||C(f,"afterAnimate",function(){f.visible&&A.show(!0);A[k.animation?"animate":"attr"]({opacity:1},{duration:200})})),n(t,function(g){m=d(c(p,g.dlOptions||g.options&&g.options.dataLabels));n(m,function(c,d){var l=c.enabled&&!g.isNull&&b(g,c),m,n,q,r,p=g.dataLabels?g.dataLabels[d]:g.dataLabel,v=g.connectors?g.connectors[d]:g.connector,t=!p;l&&(m=g.getLabelConfig(),n=c[g.formatPrefix+"Format"]||c.format,m=I(n)?e(n,m,h.time):(c[g.formatPrefix+"Formatter"]||c.formatter).call(m,c),
n=c.style,q=c.rotation,n.color=w(c.color,n.color,f.color,"#000000"),"contrast"===n.color&&(g.contrastColor=E.getContrast(g.color||f.color),n.color=c.inside||0>w(c.distance,g.labelDistance)||k.stacking?g.contrastColor:"#000000"),k.cursor&&(n.cursor=k.cursor),r={fill:c.backgroundColor,stroke:c.borderColor,"stroke-width":c.borderWidth,r:c.borderRadius||0,rotation:q,padding:c.padding,zIndex:1},a.objectEach(r,function(a,b){void 0===a&&delete r[b]}));!p||l&&I(m)?l&&I(m)&&(p?r.text=m:(g.dataLabels=g.dataLabels||
[],p=g.dataLabels[d]=q?E.text(m,0,-9999).addClass("highcharts-data-label"):E.label(m,0,-9999,c.shape,null,null,c.useHTML,null,"data-label"),d||(g.dataLabel=p),p.addClass(" highcharts-data-label-color-"+g.colorIndex+" "+(c.className||"")+(c.useHTML?" highcharts-tracker":""))),p.options=c,p.attr(r),p.css(n).shadow(c.shadow),p.added||p.add(A),f.alignDataLabel(g,p,c,null,t)):(g.dataLabel=g.dataLabel.destroy(),g.dataLabels&&(1===g.dataLabels.length?delete g.dataLabels:delete g.dataLabels[d]),d||delete g.dataLabel,
v&&(g.connector=g.connector.destroy(),g.connectors&&(1===g.connectors.length?delete g.connectors:delete g.connectors[d])))})});a.fireEvent(this,"afterDrawDataLabels")};c.prototype.alignDataLabel=function(a,c,d,e,h){var b=this.chart,l=b.inverted,m=w(a.dlBox&&a.dlBox.centerX,a.plotX,-9999),k=w(a.plotY,-9999),n=c.getBBox(),q,p=d.rotation,g=d.align,r=this.visible&&(a.series.forceDL||b.isInsidePlot(m,Math.round(k),l)||e&&b.isInsidePlot(m,l?e.x+1:e.y+e.height-1,l)),v="justify"===w(d.overflow,"justify");
if(r&&(q=d.style.fontSize,q=b.renderer.fontMetrics(q,c).b,e=f({x:l?this.yAxis.len-k:m,y:Math.round(l?this.xAxis.len-m:k),width:0,height:0},e),f(d,{width:n.width,height:n.height}),p?(v=!1,m=b.renderer.rotCorr(q,p),m={x:e.x+d.x+e.width/2+m.x,y:e.y+d.y+{top:0,middle:.5,bottom:1}[d.verticalAlign]*e.height},c[h?"attr":"animate"](m).attr({align:g}),k=(p+720)%360,k=180<k&&360>k,"left"===g?m.y-=k?n.height:0:"center"===g?(m.x-=n.width/2,m.y-=n.height/2):"right"===g&&(m.x-=n.width,m.y-=k?0:n.height),c.placed=
!0,c.alignAttr=m):(c.align(d,null,e),m=c.alignAttr),v&&0<=e.height?a.isLabelJustified=this.justifyDataLabel(c,d,m,n,e,h):w(d.crop,!0)&&(r=b.isInsidePlot(m.x,m.y)&&b.isInsidePlot(m.x+n.width,m.y+n.height)),d.shape&&!p))c[h?"attr":"animate"]({anchorX:l?b.plotWidth-a.plotY:a.plotX,anchorY:l?b.plotHeight-a.plotX:a.plotY});r||(c.attr({y:-9999}),c.placed=!1)};c.prototype.justifyDataLabel=function(a,c,d,e,f,h){var b=this.chart,l=c.align,k=c.verticalAlign,n,q,p=a.box?0:a.padding||0;n=d.x+p;0>n&&("right"===
l?c.align="left":c.x=-n,q=!0);n=d.x+e.width-p;n>b.plotWidth&&("left"===l?c.align="right":c.x=b.plotWidth-n,q=!0);n=d.y+p;0>n&&("bottom"===k?c.verticalAlign="top":c.y=-n,q=!0);n=d.y+e.height-p;n>b.plotHeight&&("top"===k?c.verticalAlign="bottom":c.y=b.plotHeight-n,q=!0);q&&(a.placed=!h,a.align(c,null,f));return q};h.pie&&(h.pie.prototype.drawDataLabels=function(){var b=this,d=b.data,e,f=b.chart,h=b.options.dataLabels,k=w(h.connectorPadding,10),q=w(h.connectorWidth,1),m=f.plotWidth,p=f.plotHeight,t=
Math.round(f.chartWidth/3),u,x=b.center,g=x[2]/2,r=x[1],y,C,H,K,Q=[[],[]],z,P,T,S,U=[0,0,0,0];b.visible&&(h.enabled||b._hasPointLabels)&&(n(d,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),c.prototype.drawDataLabels.apply(b),n(d,function(a){a.dataLabel&&(a.visible?(Q[a.half].push(a),a.dataLabel._pos=null,!I(h.style.width)&&!I(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&
a.dataLabel.getBBox().width>t&&(a.dataLabel.css({width:.7*t}),a.dataLabel.shortened=!0)):(a.dataLabel=a.dataLabel.destroy(),a.dataLabels&&1===a.dataLabels.length&&delete a.dataLabels))}),n(Q,function(c,d){var l,q,t=c.length,v=[],u;if(t)for(b.sortByAngle(c,d-.5),0<b.maxLabelDistance&&(l=Math.max(0,r-g-b.maxLabelDistance),q=Math.min(r+g+b.maxLabelDistance,f.plotHeight),n(c,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,r-g-a.labelDistance),a.bottom=Math.min(r+g+a.labelDistance,f.plotHeight),
u=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPos[1]-a.top+u/2,size:u,rank:a.y},v.push(a.distributeBox))}),l=q+u-l,a.distribute(v,l,l/5)),S=0;S<t;S++)e=c[S],H=e.labelPos,y=e.dataLabel,T=!1===e.visible?"hidden":"inherit",P=l=H[1],v&&I(e.distributeBox)&&(void 0===e.distributeBox.pos?T="hidden":(K=e.distributeBox.size,P=e.top+e.distributeBox.pos)),delete e.positionIndex,z=h.justify?x[0]+(d?-1:1)*(g+e.labelDistance):b.getX(P<e.top+2||P>e.bottom-2?l:P,d,e),y._attr={visibility:T,align:H[6]},
y._pos={x:z+h.x+({left:k,right:-k}[H[6]]||0),y:P+h.y-10},H.x=z,H.y=P,w(h.crop,!0)&&(C=y.getBBox().width,l=null,z-C<k&&1===d?(l=Math.round(C-z+k),U[3]=Math.max(l,U[3])):z+C>m-k&&0===d&&(l=Math.round(z+C-m+k),U[1]=Math.max(l,U[1])),0>P-K/2?U[0]=Math.max(Math.round(-P+K/2),U[0]):P+K/2>p&&(U[2]=Math.max(Math.round(P+K/2-p),U[2])),y.sideOverflow=l)}),0===F(U)||this.verifyDataLabelOverflow(U))&&(this.placeDataLabels(),q&&n(this.points,function(a){var c;u=a.connector;if((y=a.dataLabel)&&y._pos&&a.visible&&
0<a.labelDistance){T=y._attr.visibility;if(c=!u)a.connector=u=f.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+a.colorIndex+(a.className?" "+a.className:"")).add(b.dataLabelsGroup),u.attr({"stroke-width":q,stroke:h.connectorColor||a.color||"#666666"});u[c?"attr":"animate"]({d:b.connectorPath(a.labelPos)});u.attr("visibility",T)}else u&&(a.connector=u.destroy())}))},h.pie.prototype.connectorPath=function(a){var b=a.x,c=a.y;return w(this.options.dataLabels.softConnector,
!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",a[4],a[5]]},h.pie.prototype.placeDataLabels=function(){n(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=
!0):b&&b.attr({y:-9999}))},this)},h.pie.prototype.alignDataLabel=t,h.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,d=c.center,e=c.minSize||80,f,h=null!==c.size;h||(null!==d[0]?f=Math.max(b[2]-Math.max(a[1],a[3]),e):(f=Math.max(b[2]-a[1]-a[3],e),b[0]+=(a[3]-a[1])/2),null!==d[1]?f=Math.max(Math.min(f,b[2]-Math.max(a[0],a[2])),e):(f=Math.max(Math.min(f,b[2]-a[0]-a[2]),e),b[1]+=(a[0]-a[2])/2),f<b[2]?(b[2]=f,b[3]=Math.min(y(c.innerSize||0,f),f),this.translate(b),this.drawDataLabels&&
this.drawDataLabels()):h=!0);return h});h.column&&(h.column.prototype.alignDataLabel=function(a,d,e,f,h){var b=this.chart.inverted,l=a.series,m=a.dlBox||a.shapeArgs,k=w(a.below,a.plotY>w(this.translatedThreshold,l.yAxis.len)),n=w(e.inside,!!this.options.stacking);m&&(f=x(m),0>f.y&&(f.height+=f.y,f.y=0),m=f.y+f.height-l.yAxis.len,0<m&&(f.height-=m),b&&(f={x:l.yAxis.len-f.y-f.height,y:l.xAxis.len-f.x-f.width,width:f.height,height:f.width}),n||(b?(f.x+=k?0:f.width,f.width=0):(f.y+=k?f.height:0,f.height=
0)));e.align=w(e.align,!b||n?"center":k?"right":"left");e.verticalAlign=w(e.verticalAlign,b||n?"middle":k?"top":"bottom");c.prototype.alignDataLabel.call(this,a,d,e,f,h);a.isLabelJustified&&a.contrastColor&&d.css({color:a.contrastColor})})})(K);(function(a){var C=a.Chart,F=a.each,I=a.isArray,n=a.objectEach,f=a.pick;a=a.addEvent;a(C,"render",function(){var a=[];F(this.labelCollectors||[],function(e){a=a.concat(e())});F(this.yAxis||[],function(e){e.options.stackLabels&&!e.options.stackLabels.allowOverlap&&
n(e.stacks,function(e){n(e,function(e){a.push(e.label)})})});F(this.series||[],function(e){var n=e.options.dataLabels;e.visible&&(!1!==n.enabled||e._hasPointLabels)&&F(e.points,function(e){if(e.visible){var n=I(e.dataLabels)?e.dataLabels:e.dataLabel?[e.dataLabel]:[];F(n,function(n){var c=n.options;n.labelrank=f(c.labelrank,e.labelrank,e.shapeArgs&&e.shapeArgs.height);c.allowOverlap||a.push(n)})}})});this.hideOverlappingLabels(a)});C.prototype.hideOverlappingLabels=function(a){var e=a.length,f=this.renderer,
n,w,y,c,h,p,k=function(a,c,b,e,f,h,k,n){return!(f>a+b||f+k<a||h>c+e||h+n<c)};y=function(a){var c,b,e,h=a.box?0:a.padding||0;e=0;if(a&&(!a.alignAttr||a.placed))return c=a.alignAttr||{x:a.attr("x"),y:a.attr("y")},b=a.parentGroup,a.width||(e=a.getBBox(),a.width=e.width,a.height=e.height,e=f.fontMetrics(null,a.element).h),{x:c.x+(b.translateX||0)+h,y:c.y+(b.translateY||0)+h-e,width:a.width-2*h,height:a.height-2*h}};for(w=0;w<e;w++)if(n=a[w])n.oldOpacity=n.opacity,n.newOpacity=1,n.absoluteBox=y(n);a.sort(function(a,
c){return(c.labelrank||0)-(a.labelrank||0)});for(w=0;w<e;w++)for(p=(y=a[w])&&y.absoluteBox,n=w+1;n<e;++n)if(h=(c=a[n])&&c.absoluteBox,p&&h&&y!==c&&0!==y.newOpacity&&0!==c.newOpacity&&(h=k(p.x,p.y,p.width,p.height,h.x,h.y,h.width,h.height)))(y.labelrank<c.labelrank?y:c).newOpacity=0;F(a,function(a){var c,b;a&&(b=a.newOpacity,a.oldOpacity!==b&&(a.alignAttr&&a.placed?(b?a.show(!0):c=function(){a.hide()},a.alignAttr.opacity=b,a[a.isOld?"animate":"attr"](a.alignAttr,null,c)):a.attr({opacity:b})),a.isOld=
!0)})}})(K);(function(a){var C=a.addEvent,F=a.Chart,I=a.createElement,n=a.css,f=a.defaultOptions,e=a.defaultPlotOptions,u=a.each,x=a.extend,t=a.fireEvent,w=a.hasTouch,y=a.inArray,c=a.isObject,h=a.Legend,p=a.merge,k=a.pick,q=a.Point,d=a.Series,b=a.seriesTypes,v=a.svg,J;J=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,c=function(a){var c=b.getPointFromEvent(a);void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};u(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&
(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(u(a.trackerGroups,function(d){if(a[d]){a[d].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",function(a){b.onTrackerMouseOut(a)});if(w)a[d].on("touchstart",c);a.options.cursor&&a[d].css(n).css({cursor:a.options.cursor})}}),a._hasTracking=!0);t(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),e=d.length,f=a.chart,h=
f.pointer,k=f.renderer,n=f.options.tooltip.snap,g=a.tracker,q,p=function(){if(f.hoverSeries!==a)a.onMouseOver()},x="rgba(192,192,192,"+(v?.0001:.002)+")";if(e&&!c)for(q=e+1;q--;)"M"===d[q]&&d.splice(q+1,0,d[q+1]-n,d[q+2],"L"),(q&&"M"===d[q]||q===e)&&d.splice(q,0,"L",d[q-2]+n,d[q-1]);g?g.attr({d:d}):a.graph&&(a.tracker=k.path(d).attr({"stroke-linejoin":"round",stroke:x,fill:c?x:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*n),visibility:a.visible?"visible":"hidden",zIndex:2}).addClass(c?"highcharts-tracker-area":
"highcharts-tracker-line").add(a.group),u([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",p).on("mouseout",function(a){h.onTrackerMouseOut(a)});b.cursor&&a.css({cursor:b.cursor});if(w)a.on("touchstart",p)}));t(this,"afterDrawTracker")}};b.column&&(b.column.prototype.drawTracker=J.drawTrackerPoint);b.pie&&(b.pie.prototype.drawTracker=J.drawTrackerPoint);b.scatter&&(b.scatter.prototype.drawTracker=J.drawTrackerPoint);f.legend.itemStyle.cursor="pointer";x(h.prototype,
{setItemEvents:function(a,b,c){var d=this,e=d.chart.renderer.boxWrapper,f="highcharts-legend-"+(a instanceof q?"point":"series")+"-active";(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");e.addClass(f);b.css(d.options.itemHoverStyle)}).on("mouseout",function(){b.css(p(a.visible?d.itemStyle:d.itemHiddenStyle));e.removeClass(f);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};e.removeClass(f);b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",
b,c):t(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=I("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){t(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});x(F.prototype,{showResetZoom:function(){function a(){b.zoomOut()}var b=this,c=f.lang,d=b.options.chart.resetZoomButton,e=d.theme,h=
e.states,k="chart"===d.relativeTo?null:"plotBox";t(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,e,h&&h.hover).attr({align:d.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,!1,k)})},zoomOut:function(){t(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var b,d=this.pointer,e=!1,f;!a||a.resetSelection?(u(this.axes,function(a){b=a.zoom()}),d.initiated=!1):u(a.xAxis.concat(a.yAxis),
function(a){var c=a.axis;d[c.isXAxis?"zoomX":"zoomY"]&&(b=c.zoom(a.min,a.max),c.displayBtn&&(e=!0))});f=this.resetZoomButton;e&&!f?this.showResetZoom():!e&&c(f)&&(this.resetZoomButton=f.destroy());b&&this.redraw(k(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&u(d,function(a){a.setState()});u("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",h=c[d],g=(b.pointRange||
0)/2,l=b.reversed&&!c.inverted||!b.reversed&&c.inverted?-1:1,m=b.getExtremes(),k=b.toValue(h-f,!0)+g*l,l=b.toValue(h+b.len-f,!0)-g*l,n=l<k,h=n?l:k,k=n?k:l,l=Math.min(m.dataMin,g?m.min:b.toValue(b.toPixels(m.min)-b.minPixelPadding)),g=Math.max(m.dataMax,g?m.max:b.toValue(b.toPixels(m.max)+b.minPixelPadding)),n=l-h;0<n&&(k+=n,h=l);n=k-g;0<n&&(k=g,h-=n);b.series.length&&h!==m.min&&k!==m.max&&(b.setExtremes(h,k,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);n(c.container,{cursor:"move"})}});x(q.prototype,
{select:function(a,b){var c=this,d=c.series,e=d.chart;a=k(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[y(c,d.data)]=c.options;c.setState(a&&"select");b||u(e.getSelectedPoints(),function(a){a.selected&&a!==c&&(a.selected=a.options.selected=!1,d.options.data[y(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,
b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");u(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,c=p(b.series.options.point,b.options).events;b.events=c;a.objectEach(c,function(a,c){C(b,c,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=Math.floor(this.plotX),d=this.plotY,f=this.series,h=f.options.states[a||"normal"]||{},l=
e[f.type].marker&&f.options.marker,n=l&&!1===l.enabled,q=l&&l.states&&l.states[a||"normal"]||{},g=!1===q.enabled,p=f.stateMarkerGraphic,v=this.marker||{},u=f.chart,w=f.halo,y,C=l&&f.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===h.enabled||a&&(g||n&&!1===q.enabled)||a&&v.states&&v.states[a]&&!1===v.states[a].enabled)){C&&(y=f.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+
a),this.graphic.animate(f.pointAttribs(this,a),k(u.options.chart.animation,h.animation)),y&&this.graphic.animate(y,k(u.options.chart.animation,q.animation,l.animation)),p&&p.hide();else{if(a&&q){l=v.symbol||f.symbol;p&&p.currentSymbol!==l&&(p=p.destroy());if(p)p[b?"animate":"attr"]({x:y.x,y:y.y});else l&&(f.stateMarkerGraphic=p=u.renderer.symbol(l,y.x,y.y,y.width,y.height).add(f.markerGroup),p.currentSymbol=l);p&&p.attr(f.pointAttribs(this,a))}p&&(p[a&&u.isInsidePlot(c,d,u.inverted)?"show":"hide"](),
p.element.point=this)}(c=h.halo)&&c.size?(w||(f.halo=w=u.renderer.path().add((this.graphic||p).parentGroup)),w.show()[b?"animate":"attr"]({d:this.haloPath(c.size)}),w.attr({"class":"highcharts-halo highcharts-color-"+k(this.colorIndex,f.colorIndex)+(this.className?" "+this.className:""),zIndex:-1}),w.point=this,w.attr(x({fill:this.color||f.color,"fill-opacity":c.opacity},c.attributes))):w&&w.point&&w.point.haloPath&&w.animate({d:w.point.haloPath(0)},null,w.hide);this.state=a;t(this,"afterSetState")}},
haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});x(d.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&t(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&t(this,"mouseOut");!c||this.stickyTracking||
c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this,c=b.options,d=b.graph,e=c.states,f=c.lineWidth,c=0;a=a||"";if(b.state!==a&&(u([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!e[a]||!1!==e[a].enabled)&&(a&&(f=e[a].lineWidth||f+(e[a].lineWidthPlus||0)),d&&!d.dashstyle))for(f={"stroke-width":f},d.animate(f,k(e[a||"normal"]&&e[a||"normal"].animation,
b.chart.options.chart.animation));b["zone-graph-"+c];)b["zone-graph-"+c].attr(f),c+=1},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,h=d.options.chart.ignoreHiddenSeries,k=c.visible;f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!k:a)?"show":"hide";u(["group","dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&
u(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});u(c.linkedSeries,function(b){b.setVisible(a,!1)});h&&(d.isDirtyBox=!0);t(c,f);!1!==b&&d.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);t(this,a?"select":"unselect")},drawTracker:J.drawTrackerGraph})})(K);(function(a){var C=a.Chart,F=a.each,I=a.inArray,n=a.isArray,f=a.isObject,e=a.pick,u=a.splat;
C.prototype.setResponsive=function(e){var f=this.options.responsive,n=[],u=this.currentResponsive;f&&f.rules&&F(f.rules,function(c){void 0===c._id&&(c._id=a.uniqueKey());this.matchResponsiveRule(c,n,e)},this);var c=a.merge.apply(0,a.map(n,function(c){return a.find(f.rules,function(a){return a._id===c}).chartOptions})),n=n.toString()||void 0;n!==(u&&u.ruleIds)&&(u&&this.update(u.undoOptions,e),n?(this.currentResponsive={ruleIds:n,mergedOptions:c,undoOptions:this.currentOptions(c)},this.update(c,e)):
this.currentResponsive=void 0)};C.prototype.matchResponsiveRule=function(a,f){var n=a.condition;(n.callback||function(){return this.chartWidth<=e(n.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=e(n.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=e(n.minWidth,0)&&this.chartHeight>=e(n.minHeight,0)}).call(this)&&f.push(a._id)};C.prototype.currentOptions=function(e){function t(e,c,h,p){var k;a.objectEach(e,function(a,d){if(!p&&-1<I(d,["series","xAxis","yAxis"]))for(a=u(a),h[d]=[],k=0;k<a.length;k++)c[d][k]&&
(h[d][k]={},t(a[k],c[d][k],h[d][k],p+1));else f(a)?(h[d]=n(a)?[]:{},t(a,c[d]||{},h[d],p+1)):h[d]=c[d]||null})}var w={};t(e,this.options,w,0);return w}})(K);return K});
//# sourceMappingURL=highcharts.js.map


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(367),
    _assign = __webpack_require__(80);

var ReactNoopUpdateQueue = __webpack_require__(976);

var canDefineProperty = __webpack_require__(977);
var emptyObject = __webpack_require__(302);
var invariant = __webpack_require__(60);
var lowPriorityWarning = __webpack_require__(2277);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(104);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_browser__ = __webpack_require__(368);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Integrations", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Transports", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Severity", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Status", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addGlobalEventProcessor", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addBreadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureException", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureEvent", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureMessage", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "configureScope", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getHubFromCarrier", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCurrentHub", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Hub", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "makeMain", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Scope", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startTransaction", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["J"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SDK_VERSION", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setExtra", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setExtras", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setTag", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setTags", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setUser", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["H"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withScope", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["K"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BrowserClient", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "injectReportDialog", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "eventFromException", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "eventFromMessage", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaultIntegrations", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceLoad", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lastEventId", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "onLoad", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "showReportDialog", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["I"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "close", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["L"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SDK_NAME", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sdk__ = __webpack_require__(2328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return __WEBPACK_IMPORTED_MODULE_1__sdk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profiler__ = __webpack_require__(2329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Profiler", function() { return __WEBPACK_IMPORTED_MODULE_2__profiler__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withProfiler", function() { return __WEBPACK_IMPORTED_MODULE_2__profiler__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useProfiler", function() { return __WEBPACK_IMPORTED_MODULE_2__profiler__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__errorboundary__ = __webpack_require__(2332);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorBoundary", function() { return __WEBPACK_IMPORTED_MODULE_3__errorboundary__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withErrorBoundary", function() { return __WEBPACK_IMPORTED_MODULE_3__errorboundary__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux__ = __webpack_require__(2333);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createReduxEnhancer", function() { return __WEBPACK_IMPORTED_MODULE_4__redux__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactrouterv3__ = __webpack_require__(2334);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV3Instrumentation", function() { return __WEBPACK_IMPORTED_MODULE_5__reactrouterv3__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reactrouter__ = __webpack_require__(2335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV4Instrumentation", function() { return __WEBPACK_IMPORTED_MODULE_6__reactrouter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reactRouterV5Instrumentation", function() { return __WEBPACK_IMPORTED_MODULE_6__reactrouter__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withSentryRouting", function() { return __WEBPACK_IMPORTED_MODULE_6__reactrouter__["c"]; });







//# sourceMappingURL=index.js.map

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = captureException;
/* harmony export (immutable) */ __webpack_exports__["d"] = captureMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = captureEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = configureScope;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBreadcrumb;
/* harmony export (immutable) */ __webpack_exports__["f"] = setContext;
/* harmony export (immutable) */ __webpack_exports__["h"] = setExtras;
/* harmony export (immutable) */ __webpack_exports__["j"] = setTags;
/* harmony export (immutable) */ __webpack_exports__["g"] = setExtra;
/* harmony export (immutable) */ __webpack_exports__["i"] = setTag;
/* harmony export (immutable) */ __webpack_exports__["k"] = setUser;
/* harmony export (immutable) */ __webpack_exports__["m"] = withScope;
/* unused harmony export _callOnClient */
/* harmony export (immutable) */ __webpack_exports__["l"] = startTransaction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(233);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["d" /* getCurrentHub */])();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(context, customSamplingContext) {
    return callOnHub('startTransaction', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, context), customSamplingContext);
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scope; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addGlobalEventProcessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(45);


/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(scope._breadcrumbs);
            newScope._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, scope._tags);
            newScope._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, scope._extra);
            newScope._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        var _a, _b, _c, _d;
        // often, this span will be a transaction, but it's not guaranteed to be
        var span = this.getSpan();
        // try it the new way first
        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
            return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
        }
        // fallback to the old way (known bug: this only finds transactions with sampled = true)
        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
            return span.spanRecorder.spans[0];
        }
        // neither way found a transaction
        return undefined;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), captureContext._tags);
            this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), captureContext._extra);
            this._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["z" /* isPlainObject */])(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), captureContext.tags);
            this._extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), captureContext.extra);
            this._contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var mergedBreadcrumb = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ timestamp: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* dateTimestampInSeconds */])() }, breadcrumb);
        this._breadcrumbs =
            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
                : Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(this._breadcrumbs, [mergedBreadcrumb]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        var _a;
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relys on that.
        if (this._span) {
            event.contexts = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
            if (transactionName) {
                event.tags = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), hint);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* isThenable */])(result)) {
                    result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());

/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getGlobalObject */])();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = htmlTreeAsString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(234);

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
//# sourceMappingURL=browser.js.map

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["c"] = fill;
/* harmony export (immutable) */ __webpack_exports__["f"] = urlEncode;
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizeToSize;
/* unused harmony export walk */
/* harmony export (immutable) */ __webpack_exports__["d"] = normalize;
/* harmony export (immutable) */ __webpack_exports__["b"] = extractExceptionKeysForMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = dropUndefinedKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__browser__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__memo__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stacktrace__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__string__ = __webpack_require__(526);






/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacementFactory A function that should be used to wrap a given method, returning the wrapped method which
 * will be substituted in for `source[name]`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __sentry_original__: {
                    enumerable: false,
                    value: original,
                },
            });
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function getWalkSource(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["d" /* isError */])(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["f" /* isEvent */])(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = Object(__WEBPACK_IMPORTED_MODULE_2__is__["c" /* isElement */])(event_1.target)
                ? Object(__WEBPACK_IMPORTED_MODULE_1__browser__["a" /* htmlTreeAsString */])(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = Object(__WEBPACK_IMPORTED_MODULE_2__is__["c" /* isElement */])(event_1.currentTarget)
                ? Object(__WEBPACK_IMPORTED_MODULE_1__browser__["a" /* htmlTreeAsString */])(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        if (typeof CustomEvent !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_2__is__["g" /* isInstanceOf */])(value, CustomEvent)) {
            source.detail = event_1.detail;
        }
        for (var i in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
                source[i] = event_1;
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/**
 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
 * booleans, null, and undefined.
 *
 * @param value The value to stringify
 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
 *  unchanged.
 */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return Object(__WEBPACK_IMPORTED_MODULE_2__is__["i" /* isPrimitive */])(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["l" /* isSyntheticEvent */])(value)) {
        return '[SyntheticEvent]';
    }
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + Object(__WEBPACK_IMPORTED_MODULE_4__stacktrace__["a" /* getFunctionName */])(value) + "]";
    }
    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
    if (typeof value === 'symbol') {
        return "[" + String(value) + "]";
    }
    if (typeof value === 'bigint') {
        return "[BigInt: " + String(value) + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = new __WEBPACK_IMPORTED_MODULE_3__memo__["a" /* Memo */](); }
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) {
        return serializeValue(value);
    }
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["i" /* isPrimitive */])(normalized)) {
        return normalized;
    }
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function normalize(input, depth) {
    try {
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__string__["d" /* truncate */])(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_5__string__["d" /* truncate */])(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__is__["h" /* isPlainObject */])(val)) {
        var obj = val;
        var rv = {};
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof obj[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(obj[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
//# sourceMappingURL=object.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Memo; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */ (function () {
    function Memo() {
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        }
        else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}());

//# sourceMappingURL=memo.js.map

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsErrorEvent */
/* unused harmony export supportsDOMError */
/* unused harmony export supportsDOMException */
/* harmony export (immutable) */ __webpack_exports__["a"] = supportsFetch;
/* harmony export (immutable) */ __webpack_exports__["c"] = supportsNativeFetch;
/* unused harmony export supportsReportingObserver */
/* harmony export (immutable) */ __webpack_exports__["d"] = supportsReferrerPolicy;
/* harmony export (immutable) */ __webpack_exports__["b"] = supportsHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc__ = __webpack_require__(279);


/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    return 'ReportingObserver' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(234);
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = States.PENDING;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(States.RESOLVED, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(States.REJECTED, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["m" /* isThenable */])(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler.done) {
                    return;
                }
                if (_this._state === States.RESOLVED) {
                    if (handler.onfulfilled) {
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        handler.onfulfilled(_this._value);
                    }
                }
                if (_this._state === States.REJECTED) {
                    if (handler.onrejected) {
                        handler.onrejected(_this._value);
                    }
                }
                handler.done = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */
    SyncPromise.all = function (collection) {
        return new SyncPromise(function (resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function (item, index) {
                SyncPromise.resolve(item)
                    .then(function (value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) {
                        return;
                    }
                    resolve(resolvedCollection);
                })
                    .then(null, reject);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                done: false,
                onfulfilled: function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function (reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return '[object SyncPromise]';
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Session; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(45);


/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["O" /* uuid4 */])();
        this.timestamp = Date.now();
        this.started = Date.now();
        this.duration = 0;
        this.status = __WEBPACK_IMPORTED_MODULE_0__sentry_types__["a" /* SessionStatus */].Ok;
        this.init = true;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || Date.now();
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["O" /* uuid4 */])();
        }
        if (context.init !== undefined) {
            this.init = context.init;
        }
        if (context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            this.duration = this.timestamp - this.started;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === __WEBPACK_IMPORTED_MODULE_0__sentry_types__["a" /* SessionStatus */].Ok) {
            this.update({ status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["a" /* SessionStatus */].Exited });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* dropUndefinedKeys */])({
            sid: "" + this.sid,
            init: this.init,
            started: new Date(this.started).toISOString(),
            timestamp: new Date(this.timestamp).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* dropUndefinedKeys */])({
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            }),
        });
    };
    return Session;
}());

//# sourceMappingURL=session.js.map

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(45);


/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["c" /* Status */].Skipped,
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integrations__ = __webpack_require__(531);






/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: __WEBPACK_IMPORTED_MODULE_1__sentry_core__["f" /* SDK_VERSION */],
                },
            ],
            version: __WEBPACK_IMPORTED_MODULE_1__sentry_core__["f" /* SDK_VERSION */],
        };
        _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* BrowserBackend */], options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["o" /* getGlobalObject */])().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* injectReportDialog */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(__WEBPACK_IMPORTED_MODULE_5__integrations__["Breadcrumbs"]);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["c" /* BaseClient */]));

//# sourceMappingURL=client.js.map

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = exceptionFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromPlainObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareFramesForEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(529);


var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message,
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["v" /* isEvent */])(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["k" /* extractExceptionKeysForMessage */])(exception),
                },
            ],
        },
        extra: {
            __serialized__: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["F" /* normalizeToSize */])(exception),
        },
    };
    if (syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_1__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ({
        colno: frame.column === null ? undefined : frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line === null ? undefined : frame.line,
    }); })
        .reverse();
}
//# sourceMappingURL=parsers.js.map

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BaseTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__base__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(2319);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FetchTransport", function() { return __WEBPACK_IMPORTED_MODULE_1__fetch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xhr__ = __webpack_require__(2320);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "XHRTransport", function() { return __WEBPACK_IMPORTED_MODULE_2__xhr__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2365);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./report-status.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./report-status.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _dialog = __webpack_require__(47);

var _tabs = __webpack_require__(188);

var _infiniteScroller = __webpack_require__(75);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _albumImageItem = __webpack_require__(2379);

var _albumImageItem2 = _interopRequireDefault(_albumImageItem);

var _albumVideoItem = __webpack_require__(2380);

var _albumVideoItem2 = _interopRequireDefault(_albumVideoItem);

var _albumFileItem = __webpack_require__(2381);

var _albumFileItem2 = _interopRequireDefault(_albumFileItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// src/web/components/albumPage.jsx

var AlbumImage = function (_React$Component) {
  _inherits(AlbumImage, _React$Component);

  function AlbumImage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AlbumImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumImage.__proto__ || Object.getPrototypeOf(AlbumImage)).call.apply(_ref, [this].concat(args))), _this), _this.fetchImage = function () {
      !_this.props.isFetching && _this.props.fetchImage(_this.props);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AlbumImage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          images = _props.images,
          hasMoreImage = _props.hasMoreImage,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          fetchImage = _props.fetchImage,
          showImagesView = _props.showImagesView;


      return _react2.default.createElement(
        'div',
        { style: { overflow: 'scroll', height: 'calc(80vh - 52px)' } },
        _react2.default.createElement(
          _infiniteScroller.InfiniteScroll,
          {
            pageStart: 0,
            initialLoad: false,
            loadMore: this.fetchImage,
            hasMore: hasMoreImage && !isFetchFailed,
            loader: isFetching && _react2.default.createElement(_loading2.default, null),
            useWindow: false },
          _react2.default.createElement(
            'div',
            { style: { display: 'grid', minWidth: '350px', gap: 4, gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gridAutoRows: 350 } },
            images && _lodash2.default.map(images, function (image) {
              return _react2.default.createElement(_albumImageItem2.default, { image: image, key: image.file_id, showImagesView: showImagesView });
            })
          ),
          !isFetching && (!images || images.length == 0) && _react2.default.createElement(
            'div',
            { style: { marginTop: '10px', textAlign: 'center' } },
            t('label:データがありません')
          )
        )
      );
    }
  }]);

  return AlbumImage;
}(_react2.default.Component);

var AlbumVideo = function (_React$Component2) {
  _inherits(AlbumVideo, _React$Component2);

  function AlbumVideo() {
    var _ref2;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, AlbumVideo);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = AlbumVideo.__proto__ || Object.getPrototypeOf(AlbumVideo)).call.apply(_ref2, [this].concat(args))), _this2), _this2.fetchVideo = function () {
      !_this2.props.isFetching && _this2.props.fetchVideo(_this2.props);
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(AlbumVideo, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          videos = _props2.videos,
          hasMoreVideo = _props2.hasMoreVideo,
          isFetching = _props2.isFetching,
          isFetchFailed = _props2.isFetchFailed,
          showImagesView = _props2.showImagesView,
          fetchVideo = _props2.fetchVideo;


      return _react2.default.createElement(
        'div',
        { style: { overflow: 'scroll', height: 'calc(80vh - 52px)' } },
        _react2.default.createElement(
          _infiniteScroller.InfiniteScroll,
          {
            pageStart: 0,
            initialLoad: false,
            loadMore: this.fetchVideo,
            hasMore: hasMoreVideo && !isFetchFailed,
            loader: isFetching && _react2.default.createElement(_loading2.default, null),
            useWindow: false },
          _react2.default.createElement(
            'div',
            { style: { display: 'grid', minWidth: '350px', gap: 4, gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gridAutoRows: 350 } },
            videos && _lodash2.default.map(videos, function (video) {
              return _react2.default.createElement(_albumVideoItem2.default, { video: video, key: video.video_id, showImagesView: showImagesView });
            })
          ),
          !isFetching && (!videos || videos.length == 0) && _react2.default.createElement(
            'div',
            { style: { marginTop: '10px', textAlign: 'center' } },
            t('label:データがありません')
          )
        )
      );
    }
  }]);

  return AlbumVideo;
}(_react2.default.Component);

var AlbumFile = function (_React$Component3) {
  _inherits(AlbumFile, _React$Component3);

  function AlbumFile() {
    var _ref3;

    var _temp3, _this3, _ret3;

    _classCallCheck(this, AlbumFile);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = AlbumFile.__proto__ || Object.getPrototypeOf(AlbumFile)).call.apply(_ref3, [this].concat(args))), _this3), _this3.fetchFile = function () {
      !_this3.props.isFetching && _this3.props.fetchFile(_this3.props);
    }, _temp3), _possibleConstructorReturn(_this3, _ret3);
  }

  _createClass(AlbumFile, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          t = _props3.t,
          files = _props3.files,
          hasMoreFile = _props3.hasMoreFile,
          openPdf = _props3.openPdf,
          chatRoomId = _props3.chatRoomId,
          isFetching = _props3.isFetching,
          isFetchFailed = _props3.isFetchFailed,
          fetchFile = _props3.fetchFile;


      return _react2.default.createElement(
        'div',
        { style: { overflow: 'scroll', height: 'calc(80vh - 52px)' } },
        _react2.default.createElement(
          _infiniteScroller.InfiniteScroll,
          {
            pageStart: 0,
            initialLoad: false,
            loadMore: this.fetchFile,
            hasMore: hasMoreFile && !isFetchFailed,
            loader: isFetching && _react2.default.createElement(_loading2.default, null),
            useWindow: false },
          files && _lodash2.default.map(files, function (file) {
            return _react2.default.createElement(_albumFileItem2.default, { file: file, key: file.file_id, openPdf: openPdf });
          }),
          !isFetching && (!files || files.length == 0) && _react2.default.createElement(
            'div',
            { style: { marginTop: '10px', textAlign: 'center' } },
            t('label:データがありません')
          )
        )
      );
    }
  }]);

  return AlbumFile;
}(_react2.default.Component);

var AlbumPage = function (_React$Component4) {
  _inherits(AlbumPage, _React$Component4);

  function AlbumPage() {
    var _ref4;

    var _temp4, _this4, _ret4;

    _classCallCheck(this, AlbumPage);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _ret4 = (_temp4 = (_this4 = _possibleConstructorReturn(this, (_ref4 = AlbumPage.__proto__ || Object.getPrototypeOf(AlbumPage)).call.apply(_ref4, [this].concat(args))), _this4), _this4.changeTab = function (tabIndex) {
      _this4.props.updateUI({ tabIndex: tabIndex });
      _this4.props.onChangeTab(tabIndex, _this4.props);
    }, _temp4), _possibleConstructorReturn(_this4, _ret4);
  }

  _createClass(AlbumPage, [{
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          t = _props4.t,
          ui = _props4.ui,
          isFetching = _props4.isFetching,
          isFetchFailed = _props4.isFetchFailed,
          images = _props4.images,
          files = _props4.files,
          videos = _props4.videos,
          hasMoreImage = _props4.hasMoreImage,
          hasMoreFile = _props4.hasMoreFile,
          hasMoreVideo = _props4.hasMoreVideo,
          closeAlbum = _props4.closeAlbum,
          open = _props4.open,
          onChangeTab = _props4.onChangeTab,
          fetchImage = _props4.fetchImage,
          fetchVideo = _props4.fetchVideo,
          fetchFile = _props4.fetchFile,
          clearGroupAlbum = _props4.clearGroupAlbum,
          showImagesView = _props4.showImagesView,
          openPdf = _props4.openPdf;


      return _react2.default.createElement(
        _dialog.Dialog,
        { active: open,
          onOverlayClick: closeAlbum,
          onEscKeyDown: closeAlbum,
          actions: [{ label: t('label:閉じる'), onClick: closeAlbum, raised: true }] },
        _react2.default.createElement(
          _tabs.Tabs,
          { fixed: true, index: ui.tabIndex, onChange: this.changeTab },
          _react2.default.createElement(
            _tabs.Tab,
            { label: t('label:画像') },
            _react2.default.createElement(AlbumImage, { images: images, t: t,
              fetchImage: fetchImage,
              showImagesView: showImagesView,
              hasMoreImage: hasMoreImage,
              isFetching: isFetching,
              isFetchFailed: isFetchFailed })
          ),
          _react2.default.createElement(
            _tabs.Tab,
            { label: t('label:動画・音声') },
            _react2.default.createElement(AlbumVideo, { videos: videos, t: t,
              fetchVideo: fetchVideo,
              showImagesView: showImagesView,
              hasMoreVideo: hasMoreVideo,
              isFetching: isFetching,
              isFetchFailed: isFetchFailed })
          ),
          _react2.default.createElement(
            _tabs.Tab,
            { label: t('label:ファイル') },
            _react2.default.createElement(AlbumFile, { files: files, t: t,
              fetchFile: fetchFile,
              openPdf: openPdf,
              hasMoreFile: hasMoreFile,
              isFetching: isFetching,
              isFetchFailed: isFetchFailed })
          )
        )
      );
    }
  }]);

  return AlbumPage;
}(_react2.default.Component);

exports.default = AlbumPage;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setOptions = exports.Page = exports.Outline = exports.Document = undefined;

var _Document = __webpack_require__(2383);

var _Document2 = _interopRequireDefault(_Document);

var _Outline = __webpack_require__(2475);

var _Outline2 = _interopRequireDefault(_Outline);

var _Page = __webpack_require__(2486);

var _Page2 = _interopRequireDefault(_Page);

var _setOptions = __webpack_require__(2492);

var _setOptions2 = _interopRequireDefault(_setOptions);

var _utils = __webpack_require__(134);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_utils.isLocalFileSystem) {
  // eslint-disable-next-line no-console
  (0, _utils.warnOnDev)('You are running React-PDF from your local file system. PDF.js Worker may fail to load due to browser\'s security policies. If you\'re on Google Chrome, you can use --allow-file-access-from-files flag for debugging purposes.');
}

var pdfjs = __webpack_require__(2496);

var setOptions = (0, _setOptions2.default)(pdfjs);

setOptions({
  workerSrc: 'pdf.worker.js'
});

exports.Document = _Document2.default;
exports.Outline = _Outline2.default;
exports.Page = _Page2.default;
exports.setOptions = setOptions;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2384), __esModule: true };

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(149) && !__webpack_require__(235)(function () {
  return Object.defineProperty(__webpack_require__(537)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(203);
var toIObject = __webpack_require__(236);
var arrayIndexOf = __webpack_require__(2387)(false);
var IE_PROTO = __webpack_require__(541)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(283);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(540);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(284);
var $export = __webpack_require__(127);
var redefine = __webpack_require__(1003);
var hide = __webpack_require__(202);
var Iterators = __webpack_require__(237);
var $iterCreate = __webpack_require__(2392);
var setToStringTag = __webpack_require__(381);
var getPrototypeOf = __webpack_require__(1005);
var ITERATOR = __webpack_require__(89)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(202);


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(88).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(203);
var toObject = __webpack_require__(285);
var IE_PROTO = __webpack_require__(541)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(999);
var hiddenKeys = __webpack_require__(543).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(378);
var createDesc = __webpack_require__(376);
var toIObject = __webpack_require__(236);
var toPrimitive = __webpack_require__(538);
var has = __webpack_require__(203);
var IE8_DOM_DEFINE = __webpack_require__(998);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(149) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 1008 */
/***/ (function(module, exports) {



/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(549);
var ITERATOR = __webpack_require__(89)('iterator');
var Iterators = __webpack_require__(237);
module.exports = __webpack_require__(70).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(128);
var aFunction = __webpack_require__(375);
var SPECIES = __webpack_require__(89)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(281);
var invoke = __webpack_require__(2412);
var html = __webpack_require__(1004);
var cel = __webpack_require__(537);
var global = __webpack_require__(88);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(283)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(128);
var isObject = __webpack_require__(170);
var newPromiseCapability = __webpack_require__(550);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(127);
var core = __webpack_require__(70);
var fails = __webpack_require__(235);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pdf_link_service = __webpack_require__(2434);

exports.default = _pdf_link_service.PDFLinkService;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitOnEventOrTimeout = exports.WaitOnType = exports.localized = exports.animationStarted = exports.normalizeWheelEventDelta = exports.binarySearchFirstItem = exports.watchScroll = exports.scrollIntoView = exports.getOutputScale = exports.approximateFraction = exports.roundToDivide = exports.getVisibleElements = exports.parseQueryString = exports.noContextMenuHandler = exports.getPDFFileNameFromURL = exports.ProgressBar = exports.EventBus = exports.NullL10n = exports.mozL10n = exports.RendererType = exports.PresentationModeState = exports.cloneObj = exports.isFileSchema = exports.isValidRotation = exports.VERTICAL_PADDING = exports.SCROLLBAR_PADDING = exports.MAX_AUTO_SCALE = exports.UNKNOWN_SCALE = exports.MAX_SCALE = exports.MIN_SCALE = exports.DEFAULT_SCALE = exports.DEFAULT_SCALE_VALUE = exports.CSS_UNITS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _pdf = __webpack_require__(2436);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CSS_UNITS = 96.0 / 72.0;
var DEFAULT_SCALE_VALUE = 'auto';
var DEFAULT_SCALE = 1.0;
var MIN_SCALE = 0.10;
var MAX_SCALE = 10.0;
var UNKNOWN_SCALE = 0;
var MAX_AUTO_SCALE = 1.25;
var SCROLLBAR_PADDING = 40;
var VERTICAL_PADDING = 5;
var PresentationModeState = {
  UNKNOWN: 0,
  NORMAL: 1,
  CHANGING: 2,
  FULLSCREEN: 3
};
var RendererType = {
  CANVAS: 'canvas',
  SVG: 'svg'
};
function formatL10nValue(text, args) {
  if (!args) {
    return text;
  }
  return text.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, name) {
    return name in args ? args[name] : '{{' + name + '}}';
  });
}
var NullL10n = {
  getDirection: function getDirection() {
    return Promise.resolve('ltr');
  },
  get: function get(property, args, fallback) {
    return Promise.resolve(formatL10nValue(fallback, args));
  },
  translate: function translate(element) {
    return Promise.resolve();
  }
};
_pdf.PDFJS.disableFullscreen = _pdf.PDFJS.disableFullscreen === undefined ? false : _pdf.PDFJS.disableFullscreen;
_pdf.PDFJS.useOnlyCssZoom = _pdf.PDFJS.useOnlyCssZoom === undefined ? false : _pdf.PDFJS.useOnlyCssZoom;
_pdf.PDFJS.maxCanvasPixels = _pdf.PDFJS.maxCanvasPixels === undefined ? 16777216 : _pdf.PDFJS.maxCanvasPixels;
_pdf.PDFJS.disableHistory = _pdf.PDFJS.disableHistory === undefined ? false : _pdf.PDFJS.disableHistory;
_pdf.PDFJS.disableTextLayer = _pdf.PDFJS.disableTextLayer === undefined ? false : _pdf.PDFJS.disableTextLayer;
{
  _pdf.PDFJS.locale = _pdf.PDFJS.locale === undefined && typeof navigator !== 'undefined' ? navigator.language : _pdf.PDFJS.locale;
}
function getOutputScale(ctx) {
  var devicePixelRatio = window.devicePixelRatio || 1;
  var backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
  var pixelRatio = devicePixelRatio / backingStoreRatio;
  return {
    sx: pixelRatio,
    sy: pixelRatio,
    scaled: pixelRatio !== 1
  };
}
function scrollIntoView(element, spot) {
  var skipOverflowHiddenElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var parent = element.offsetParent;
  if (!parent) {
    console.error('offsetParent is not set -- cannot scroll');
    return;
  }
  var offsetY = element.offsetTop + element.clientTop;
  var offsetX = element.offsetLeft + element.clientLeft;
  while (parent.clientHeight === parent.scrollHeight || skipOverflowHiddenElements && getComputedStyle(parent).overflow === 'hidden') {
    if (parent.dataset._scaleY) {
      offsetY /= parent.dataset._scaleY;
      offsetX /= parent.dataset._scaleX;
    }
    offsetY += parent.offsetTop;
    offsetX += parent.offsetLeft;
    parent = parent.offsetParent;
    if (!parent) {
      return;
    }
  }
  if (spot) {
    if (spot.top !== undefined) {
      offsetY += spot.top;
    }
    if (spot.left !== undefined) {
      offsetX += spot.left;
      parent.scrollLeft = offsetX;
    }
  }
  parent.scrollTop = offsetY;
}
function watchScroll(viewAreaElement, callback) {
  var debounceScroll = function debounceScroll(evt) {
    if (rAF) {
      return;
    }
    rAF = window.requestAnimationFrame(function viewAreaElementScrolled() {
      rAF = null;
      var currentY = viewAreaElement.scrollTop;
      var lastY = state.lastY;
      if (currentY !== lastY) {
        state.down = currentY > lastY;
      }
      state.lastY = currentY;
      callback(state);
    });
  };
  var state = {
    down: true,
    lastY: viewAreaElement.scrollTop,
    _eventHandler: debounceScroll
  };
  var rAF = null;
  viewAreaElement.addEventListener('scroll', debounceScroll, true);
  return state;
}
function parseQueryString(query) {
  var parts = query.split('&');
  var params = Object.create(null);
  for (var i = 0, ii = parts.length; i < ii; ++i) {
    var param = parts[i].split('=');
    var key = param[0].toLowerCase();
    var value = param.length > 1 ? param[1] : null;
    params[decodeURIComponent(key)] = decodeURIComponent(value);
  }
  return params;
}
function binarySearchFirstItem(items, condition) {
  var minIndex = 0;
  var maxIndex = items.length - 1;
  if (items.length === 0 || !condition(items[maxIndex])) {
    return items.length;
  }
  if (condition(items[minIndex])) {
    return minIndex;
  }
  while (minIndex < maxIndex) {
    var currentIndex = minIndex + maxIndex >> 1;
    var currentItem = items[currentIndex];
    if (condition(currentItem)) {
      maxIndex = currentIndex;
    } else {
      minIndex = currentIndex + 1;
    }
  }
  return minIndex;
}
function approximateFraction(x) {
  if (Math.floor(x) === x) {
    return [x, 1];
  }
  var xinv = 1 / x;
  var limit = 8;
  if (xinv > limit) {
    return [1, limit];
  } else if (Math.floor(xinv) === xinv) {
    return [1, xinv];
  }
  var x_ = x > 1 ? xinv : x;
  var a = 0,
      b = 1,
      c = 1,
      d = 1;
  while (true) {
    var p = a + c,
        q = b + d;
    if (q > limit) {
      break;
    }
    if (x_ <= p / q) {
      c = p;
      d = q;
    } else {
      a = p;
      b = q;
    }
  }
  var result = void 0;
  if (x_ - a / b < c / d - x_) {
    result = x_ === x ? [a, b] : [b, a];
  } else {
    result = x_ === x ? [c, d] : [d, c];
  }
  return result;
}
function roundToDivide(x, div) {
  var r = x % div;
  return r === 0 ? x : Math.round(x - r + div);
}
function getVisibleElements(scrollEl, views) {
  var sortByVisibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var top = scrollEl.scrollTop,
      bottom = top + scrollEl.clientHeight;
  var left = scrollEl.scrollLeft,
      right = left + scrollEl.clientWidth;
  function isElementBottomBelowViewTop(view) {
    var element = view.div;
    var elementBottom = element.offsetTop + element.clientTop + element.clientHeight;
    return elementBottom > top;
  }
  var visible = [],
      view = void 0,
      element = void 0;
  var currentHeight = void 0,
      viewHeight = void 0,
      hiddenHeight = void 0,
      percentHeight = void 0;
  var currentWidth = void 0,
      viewWidth = void 0;
  var firstVisibleElementInd = views.length === 0 ? 0 : binarySearchFirstItem(views, isElementBottomBelowViewTop);
  for (var i = firstVisibleElementInd, ii = views.length; i < ii; i++) {
    view = views[i];
    element = view.div;
    currentHeight = element.offsetTop + element.clientTop;
    viewHeight = element.clientHeight;
    if (currentHeight > bottom) {
      break;
    }
    currentWidth = element.offsetLeft + element.clientLeft;
    viewWidth = element.clientWidth;
    if (currentWidth + viewWidth < left || currentWidth > right) {
      continue;
    }
    hiddenHeight = Math.max(0, top - currentHeight) + Math.max(0, currentHeight + viewHeight - bottom);
    percentHeight = (viewHeight - hiddenHeight) * 100 / viewHeight | 0;
    visible.push({
      id: view.id,
      x: currentWidth,
      y: currentHeight,
      view: view,
      percent: percentHeight
    });
  }
  var first = visible[0];
  var last = visible[visible.length - 1];
  if (sortByVisibility) {
    visible.sort(function (a, b) {
      var pc = a.percent - b.percent;
      if (Math.abs(pc) > 0.001) {
        return -pc;
      }
      return a.id - b.id;
    });
  }
  return {
    first: first,
    last: last,
    views: visible
  };
}
function noContextMenuHandler(evt) {
  evt.preventDefault();
}
function isFileSchema(url) {
  var i = 0,
      ii = url.length;
  while (i < ii && url[i].trim() === '') {
    i++;
  }
  return url.substr(i, 7).toLowerCase() === 'file://';
}
function isDataSchema(url) {
  var i = 0,
      ii = url.length;
  while (i < ii && url[i].trim() === '') {
    i++;
  }
  return url.substr(i, 5).toLowerCase() === 'data:';
}
function getPDFFileNameFromURL(url) {
  var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'document.pdf';

  if (isDataSchema(url)) {
    console.warn('getPDFFileNameFromURL: ' + 'ignoring "data:" URL for performance reasons.');
    return defaultFilename;
  }
  var reURI = /^(?:(?:[^:]+:)?\/\/[^\/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
  var reFilename = /[^\/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
  var splitURI = reURI.exec(url);
  var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
  if (suggestedFilename) {
    suggestedFilename = suggestedFilename[0];
    if (suggestedFilename.indexOf('%') !== -1) {
      try {
        suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
      } catch (ex) {}
    }
  }
  return suggestedFilename || defaultFilename;
}
function normalizeWheelEventDelta(evt) {
  var delta = Math.sqrt(evt.deltaX * evt.deltaX + evt.deltaY * evt.deltaY);
  var angle = Math.atan2(evt.deltaY, evt.deltaX);
  if (-0.25 * Math.PI < angle && angle < 0.75 * Math.PI) {
    delta = -delta;
  }
  var MOUSE_DOM_DELTA_PIXEL_MODE = 0;
  var MOUSE_DOM_DELTA_LINE_MODE = 1;
  var MOUSE_PIXELS_PER_LINE = 30;
  var MOUSE_LINES_PER_PAGE = 30;
  if (evt.deltaMode === MOUSE_DOM_DELTA_PIXEL_MODE) {
    delta /= MOUSE_PIXELS_PER_LINE * MOUSE_LINES_PER_PAGE;
  } else if (evt.deltaMode === MOUSE_DOM_DELTA_LINE_MODE) {
    delta /= MOUSE_LINES_PER_PAGE;
  }
  return delta;
}
function isValidRotation(angle) {
  return Number.isInteger(angle) && angle % 90 === 0;
}
function cloneObj(obj) {
  var result = Object.create(null);
  for (var i in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, i)) {
      result[i] = obj[i];
    }
  }
  return result;
}
var WaitOnType = {
  EVENT: 'event',
  TIMEOUT: 'timeout'
};
function waitOnEventOrTimeout(_ref) {
  var target = _ref.target,
      name = _ref.name,
      _ref$delay = _ref.delay,
      delay = _ref$delay === undefined ? 0 : _ref$delay;

  if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || !(name && typeof name === 'string') || !(Number.isInteger(delay) && delay >= 0)) {
    return Promise.reject(new Error('waitOnEventOrTimeout - invalid paramaters.'));
  }
  var capability = (0, _pdf.createPromiseCapability)();
  function handler(type) {
    if (target instanceof EventBus) {
      target.off(name, eventHandler);
    } else {
      target.removeEventListener(name, eventHandler);
    }
    if (timeout) {
      clearTimeout(timeout);
    }
    capability.resolve(type);
  }
  var eventHandler = handler.bind(null, WaitOnType.EVENT);
  if (target instanceof EventBus) {
    target.on(name, eventHandler);
  } else {
    target.addEventListener(name, eventHandler);
  }
  var timeoutHandler = handler.bind(null, WaitOnType.TIMEOUT);
  var timeout = setTimeout(timeoutHandler, delay);
  return capability.promise;
}
var animationStarted = new Promise(function (resolve) {
  window.requestAnimationFrame(resolve);
});
var mozL10n = void 0;
var localized = Promise.resolve();

var EventBus = function () {
  function EventBus() {
    _classCallCheck(this, EventBus);

    this._listeners = Object.create(null);
  }

  _createClass(EventBus, [{
    key: 'on',
    value: function on(eventName, listener) {
      var eventListeners = this._listeners[eventName];
      if (!eventListeners) {
        eventListeners = [];
        this._listeners[eventName] = eventListeners;
      }
      eventListeners.push(listener);
    }
  }, {
    key: 'off',
    value: function off(eventName, listener) {
      var eventListeners = this._listeners[eventName];
      var i = void 0;
      if (!eventListeners || (i = eventListeners.indexOf(listener)) < 0) {
        return;
      }
      eventListeners.splice(i, 1);
    }
  }, {
    key: 'dispatch',
    value: function dispatch(eventName) {
      var eventListeners = this._listeners[eventName];
      if (!eventListeners || eventListeners.length === 0) {
        return;
      }
      var args = Array.prototype.slice.call(arguments, 1);
      eventListeners.slice(0).forEach(function (listener) {
        listener.apply(null, args);
      });
    }
  }]);

  return EventBus;
}();

function clamp(v, min, max) {
  return Math.min(Math.max(v, min), max);
}

var ProgressBar = function () {
  function ProgressBar(id) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        height = _ref2.height,
        width = _ref2.width,
        units = _ref2.units;

    _classCallCheck(this, ProgressBar);

    this.visible = true;
    this.div = document.querySelector(id + ' .progress');
    this.bar = this.div.parentNode;
    this.height = height || 100;
    this.width = width || 100;
    this.units = units || '%';
    this.div.style.height = this.height + this.units;
    this.percent = 0;
  }

  _createClass(ProgressBar, [{
    key: '_updateBar',
    value: function _updateBar() {
      if (this._indeterminate) {
        this.div.classList.add('indeterminate');
        this.div.style.width = this.width + this.units;
        return;
      }
      this.div.classList.remove('indeterminate');
      var progressSize = this.width * this._percent / 100;
      this.div.style.width = progressSize + this.units;
    }
  }, {
    key: 'setWidth',
    value: function setWidth(viewer) {
      if (!viewer) {
        return;
      }
      var container = viewer.parentNode;
      var scrollbarWidth = container.offsetWidth - viewer.offsetWidth;
      if (scrollbarWidth > 0) {
        this.bar.setAttribute('style', 'width: calc(100% - ' + scrollbarWidth + 'px);');
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (!this.visible) {
        return;
      }
      this.visible = false;
      this.bar.classList.add('hidden');
      document.body.classList.remove('loadingInProgress');
    }
  }, {
    key: 'show',
    value: function show() {
      if (this.visible) {
        return;
      }
      this.visible = true;
      document.body.classList.add('loadingInProgress');
      this.bar.classList.remove('hidden');
    }
  }, {
    key: 'percent',
    get: function get() {
      return this._percent;
    },
    set: function set(val) {
      this._indeterminate = isNaN(val);
      this._percent = clamp(val, 0, 100);
      this._updateBar();
    }
  }]);

  return ProgressBar;
}();

exports.CSS_UNITS = CSS_UNITS;
exports.DEFAULT_SCALE_VALUE = DEFAULT_SCALE_VALUE;
exports.DEFAULT_SCALE = DEFAULT_SCALE;
exports.MIN_SCALE = MIN_SCALE;
exports.MAX_SCALE = MAX_SCALE;
exports.UNKNOWN_SCALE = UNKNOWN_SCALE;
exports.MAX_AUTO_SCALE = MAX_AUTO_SCALE;
exports.SCROLLBAR_PADDING = SCROLLBAR_PADDING;
exports.VERTICAL_PADDING = VERTICAL_PADDING;
exports.isValidRotation = isValidRotation;
exports.isFileSchema = isFileSchema;
exports.cloneObj = cloneObj;
exports.PresentationModeState = PresentationModeState;
exports.RendererType = RendererType;
exports.mozL10n = mozL10n;
exports.NullL10n = NullL10n;
exports.EventBus = EventBus;
exports.ProgressBar = ProgressBar;
exports.getPDFFileNameFromURL = getPDFFileNameFromURL;
exports.noContextMenuHandler = noContextMenuHandler;
exports.parseQueryString = parseQueryString;
exports.getVisibleElements = getVisibleElements;
exports.roundToDivide = roundToDivide;
exports.approximateFraction = approximateFraction;
exports.getOutputScale = getOutputScale;
exports.scrollIntoView = scrollIntoView;
exports.watchScroll = watchScroll;
exports.binarySearchFirstItem = binarySearchFirstItem;
exports.normalizeWheelEventDelta = normalizeWheelEventDelta;
exports.animationStarted = animationStarted;
exports.localized = localized;
exports.WaitOnType = WaitOnType;
exports.waitOnEventOrTimeout = waitOnEventOrTimeout;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(3);
var $includes = __webpack_require__(357)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(167)('includes');


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', { isInteger: __webpack_require__(1021) });


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(40);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(166);
var global = __webpack_require__(34);
var ctx = __webpack_require__(108);
var classof = __webpack_require__(230);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(40);
var aFunction = __webpack_require__(82);
var anInstance = __webpack_require__(195);
var forOf = __webpack_require__(196);
var speciesConstructor = __webpack_require__(288);
var task = __webpack_require__(551).set;
var microtask = __webpack_require__(552)();
var newPromiseCapabilityModule = __webpack_require__(553);
var perform = __webpack_require__(1024);
var userAgent = __webpack_require__(383);
var promiseResolve = __webpack_require__(1025);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(52)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(194)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(229)($Promise, PROMISE);
__webpack_require__(197)(PROMISE);
Wrapper = __webpack_require__(51)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(358)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(29);
var isObject = __webpack_require__(40);
var newPromiseCapability = __webpack_require__(553);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(3);
var core = __webpack_require__(51);
var global = __webpack_require__(34);
var speciesConstructor = __webpack_require__(288);
var promiseResolve = __webpack_require__(1025);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(3);
var newPromiseCapability = __webpack_require__(553);
var perform = __webpack_require__(1024);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(56);
var getKeys = __webpack_require__(192);
var gOPS = __webpack_require__(366);
var pIE = __webpack_require__(277);
var toObject = __webpack_require__(64);
var IObject = __webpack_require__(275);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(37)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(194);
var getWeak = __webpack_require__(168).getWeak;
var anObject = __webpack_require__(29);
var isObject = __webpack_require__(40);
var anInstance = __webpack_require__(195);
var forOf = __webpack_require__(196);
var createArrayMethod = __webpack_require__(125);
var $has = __webpack_require__(99);
var validate = __webpack_require__(198);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(363)('WeakMap');


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(364)('WeakMap');


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $values = __webpack_require__(1033)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(56);
var getKeys = __webpack_require__(192);
var toIObject = __webpack_require__(100);
var isEnum = __webpack_require__(277).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.build = exports.version = exports.setPDFNetworkStreamFactory = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(73);

var _dom_utils = __webpack_require__(204);

var _font_loader = __webpack_require__(2448);

var _canvas = __webpack_require__(2449);

var _global_scope = __webpack_require__(287);

var _global_scope2 = _interopRequireDefault(_global_scope);

var _metadata = __webpack_require__(1035);

var _transport_stream = __webpack_require__(2451);

var _webgl = __webpack_require__(2452);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_RANGE_CHUNK_SIZE = 65536;
var isWorkerDisabled = false;
var workerSrc;
var isPostMessageTransfersDisabled = false;
var pdfjsFilePath = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : null;
var fakeWorkerFilesLoader = null;
var useRequireEnsure = false;
{
  if (typeof window === 'undefined') {
    isWorkerDisabled = true;
    if (false) {
      require.ensure = require('node-ensure');
    }
    useRequireEnsure = true;
  } else if (true) {
    useRequireEnsure = true;
  }
  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
    workerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
  }
  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
  fakeWorkerFilesLoader = useRequireEnsure ? function (callback) {
    __webpack_require__.e/* require.ensure */(1).then((function () {
      var worker;
      worker = __webpack_require__(3084);
      callback(worker.WorkerMessageHandler);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  } : dynamicLoaderSupported ? function (callback) {
    requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
      callback(worker.WorkerMessageHandler);
    });
  } : null;
}
var createPDFNetworkStream;
function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
  createPDFNetworkStream = pdfNetworkStreamFactory;
}
function getDocument(src) {
  var task = new PDFDocumentLoadingTask();
  var source;
  if (typeof src === 'string') {
    source = { url: src };
  } else if ((0, _util.isArrayBuffer)(src)) {
    source = { data: src };
  } else if (src instanceof PDFDataRangeTransport) {
    source = { range: src };
  } else {
    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
    }
    if (!src.url && !src.data && !src.range) {
      throw new Error('Invalid parameter object: need either .data, .range or .url');
    }
    source = src;
  }
  var params = {};
  var rangeTransport = null;
  var worker = null;
  var CMapReaderFactory = _dom_utils.DOMCMapReaderFactory;
  for (var key in source) {
    if (key === 'url' && typeof window !== 'undefined') {
      params[key] = new URL(source[key], window.location).href;
      continue;
    } else if (key === 'range') {
      rangeTransport = source[key];
      continue;
    } else if (key === 'worker') {
      worker = source[key];
      continue;
    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
      var pdfBytes = source[key];
      if (typeof pdfBytes === 'string') {
        params[key] = (0, _util.stringToBytes)(pdfBytes);
      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
        params[key] = new Uint8Array(pdfBytes);
      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
        params[key] = new Uint8Array(pdfBytes);
      } else {
        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
      }
      continue;
    } else if (key === 'CMapReaderFactory') {
      CMapReaderFactory = source[key];
      continue;
    }
    params[key] = source[key];
  }
  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
  params.ignoreErrors = params.stopAtErrors !== true;
  var nativeImageDecoderValues = Object.values(_util.NativeImageDecoding);
  if (params.nativeImageDecoderSupport === undefined || !nativeImageDecoderValues.includes(params.nativeImageDecoderSupport)) {
    params.nativeImageDecoderSupport = _util.NativeImageDecoding.DECODE;
  }
  if (!worker) {
    var workerPort = (0, _dom_utils.getDefaultSetting)('workerPort');
    worker = workerPort ? PDFWorker.fromPort(workerPort) : new PDFWorker();
    task._worker = worker;
  }
  var docId = task.docId;
  worker.promise.then(function () {
    if (task.destroyed) {
      throw new Error('Loading aborted');
    }
    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
      if (task.destroyed) {
        throw new Error('Loading aborted');
      }
      var networkStream = void 0;
      if (rangeTransport) {
        networkStream = new _transport_stream.PDFDataTransportStream(params, rangeTransport);
      } else if (!params.data) {
        networkStream = createPDFNetworkStream(params);
      }
      var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
      messageHandler.postMessageTransfers = worker.postMessageTransfers;
      var transport = new WorkerTransport(messageHandler, task, networkStream, CMapReaderFactory);
      task._transport = transport;
      messageHandler.send('Ready', null);
    });
  }).catch(task._capability.reject);
  return task;
}
function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
  if (worker.destroyed) {
    return Promise.reject(new Error('Worker was destroyed'));
  }
  var apiVersion = '2.0.305';
  source.disableRange = (0, _dom_utils.getDefaultSetting)('disableRange');
  source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)('disableAutoFetch');
  source.disableStream = (0, _dom_utils.getDefaultSetting)('disableStream');
  if (pdfDataRangeTransport) {
    source.length = pdfDataRangeTransport.length;
    source.initialData = pdfDataRangeTransport.initialData;
  }
  return worker.messageHandler.sendWithPromise('GetDocRequest', {
    docId: docId,
    apiVersion: apiVersion,
    source: {
      data: source.data,
      url: source.url,
      password: source.password,
      disableAutoFetch: source.disableAutoFetch,
      rangeChunkSize: source.rangeChunkSize,
      length: source.length
    },
    maxImageSize: (0, _dom_utils.getDefaultSetting)('maxImageSize'),
    disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
    disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)('disableCreateObjectURL'),
    postMessageTransfers: (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled,
    docBaseUrl: source.docBaseUrl,
    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
    ignoreErrors: source.ignoreErrors,
    isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported')
  }).then(function (workerId) {
    if (worker.destroyed) {
      throw new Error('Worker was destroyed');
    }
    return workerId;
  });
}
var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
  var nextDocumentId = 0;
  function PDFDocumentLoadingTask() {
    this._capability = (0, _util.createPromiseCapability)();
    this._transport = null;
    this._worker = null;
    this.docId = 'd' + nextDocumentId++;
    this.destroyed = false;
    this.onPassword = null;
    this.onProgress = null;
    this.onUnsupportedFeature = null;
  }
  PDFDocumentLoadingTask.prototype = {
    get promise() {
      return this._capability.promise;
    },
    destroy: function destroy() {
      var _this = this;

      this.destroyed = true;
      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
      return transportDestroyed.then(function () {
        _this._transport = null;
        if (_this._worker) {
          _this._worker.destroy();
          _this._worker = null;
        }
      });
    },

    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
      return this.promise.then.apply(this.promise, arguments);
    }
  };
  return PDFDocumentLoadingTask;
}();
var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
  function PDFDataRangeTransport(length, initialData) {
    this.length = length;
    this.initialData = initialData;
    this._rangeListeners = [];
    this._progressListeners = [];
    this._progressiveReadListeners = [];
    this._readyCapability = (0, _util.createPromiseCapability)();
  }
  PDFDataRangeTransport.prototype = {
    addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
      this._rangeListeners.push(listener);
    },
    addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
      this._progressListeners.push(listener);
    },
    addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
      this._progressiveReadListeners.push(listener);
    },
    onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
      var listeners = this._rangeListeners;
      for (var i = 0, n = listeners.length; i < n; ++i) {
        listeners[i](begin, chunk);
      }
    },
    onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
      var _this2 = this;

      this._readyCapability.promise.then(function () {
        var listeners = _this2._progressListeners;
        for (var i = 0, n = listeners.length; i < n; ++i) {
          listeners[i](loaded);
        }
      });
    },
    onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
      var _this3 = this;

      this._readyCapability.promise.then(function () {
        var listeners = _this3._progressiveReadListeners;
        for (var i = 0, n = listeners.length; i < n; ++i) {
          listeners[i](chunk);
        }
      });
    },
    transportReady: function PDFDataRangeTransport_transportReady() {
      this._readyCapability.resolve();
    },
    requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
      (0, _util.unreachable)('Abstract method PDFDataRangeTransport.requestDataRange');
    },
    abort: function PDFDataRangeTransport_abort() {}
  };
  return PDFDataRangeTransport;
}();
var PDFDocumentProxy = function PDFDocumentProxyClosure() {
  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
    this.pdfInfo = pdfInfo;
    this.transport = transport;
    this.loadingTask = loadingTask;
  }
  PDFDocumentProxy.prototype = {
    get numPages() {
      return this.pdfInfo.numPages;
    },
    get fingerprint() {
      return this.pdfInfo.fingerprint;
    },
    getPage: function getPage(pageNumber) {
      return this.transport.getPage(pageNumber);
    },

    getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
      return this.transport.getPageIndex(ref);
    },
    getDestinations: function PDFDocumentProxy_getDestinations() {
      return this.transport.getDestinations();
    },
    getDestination: function PDFDocumentProxy_getDestination(id) {
      return this.transport.getDestination(id);
    },
    getPageLabels: function PDFDocumentProxy_getPageLabels() {
      return this.transport.getPageLabels();
    },
    getPageMode: function getPageMode() {
      return this.transport.getPageMode();
    },

    getAttachments: function PDFDocumentProxy_getAttachments() {
      return this.transport.getAttachments();
    },
    getJavaScript: function getJavaScript() {
      return this.transport.getJavaScript();
    },

    getOutline: function PDFDocumentProxy_getOutline() {
      return this.transport.getOutline();
    },
    getMetadata: function PDFDocumentProxy_getMetadata() {
      return this.transport.getMetadata();
    },
    getData: function PDFDocumentProxy_getData() {
      return this.transport.getData();
    },
    getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
      return this.transport.downloadInfoCapability.promise;
    },
    getStats: function PDFDocumentProxy_getStats() {
      return this.transport.getStats();
    },
    cleanup: function PDFDocumentProxy_cleanup() {
      this.transport.startCleanup();
    },
    destroy: function PDFDocumentProxy_destroy() {
      return this.loadingTask.destroy();
    }
  };
  return PDFDocumentProxy;
}();
var PDFPageProxy = function PDFPageProxyClosure() {
  function PDFPageProxy(pageIndex, pageInfo, transport) {
    this.pageIndex = pageIndex;
    this.pageInfo = pageInfo;
    this.transport = transport;
    this._stats = (0, _dom_utils.getDefaultSetting)('enableStats') ? new _dom_utils.StatTimer() : _dom_utils.DummyStatTimer;
    this.commonObjs = transport.commonObjs;
    this.objs = new PDFObjects();
    this.cleanupAfterRender = false;
    this.pendingCleanup = false;
    this.intentStates = Object.create(null);
    this.destroyed = false;
  }
  PDFPageProxy.prototype = {
    get pageNumber() {
      return this.pageIndex + 1;
    },
    get rotate() {
      return this.pageInfo.rotate;
    },
    get ref() {
      return this.pageInfo.ref;
    },
    get userUnit() {
      return this.pageInfo.userUnit;
    },
    get view() {
      return this.pageInfo.view;
    },
    getViewport: function getViewport(scale) {
      var rotate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.rotate;
      var dontFlip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      return new _util.PageViewport(this.view, scale, rotate, 0, 0, dontFlip);
    },

    getAnnotations: function PDFPageProxy_getAnnotations(params) {
      var intent = params && params.intent || null;
      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
        this.annotationsIntent = intent;
      }
      return this.annotationsPromise;
    },
    render: function PDFPageProxy_render(params) {
      var _this4 = this;

      var stats = this._stats;
      stats.time('Overall');
      this.pendingCleanup = false;
      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
      var webGLContext = new _webgl.WebGLContext({ enable: !(0, _dom_utils.getDefaultSetting)('disableWebGL') });
      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }
      var intentState = this.intentStates[renderingIntent];
      if (!intentState.displayReadyCapability) {
        intentState.receivingOperatorList = true;
        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        stats.time('Page Request');
        this.transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageNumber - 1,
          intent: renderingIntent,
          renderInteractiveForms: params.renderInteractiveForms === true
        });
      }
      var complete = function complete(error) {
        var i = intentState.renderTasks.indexOf(internalRenderTask);
        if (i >= 0) {
          intentState.renderTasks.splice(i, 1);
        }
        if (_this4.cleanupAfterRender) {
          _this4.pendingCleanup = true;
        }
        _this4._tryCleanup();
        if (error) {
          internalRenderTask.capability.reject(error);
        } else {
          internalRenderTask.capability.resolve();
        }
        stats.timeEnd('Rendering');
        stats.timeEnd('Overall');
      };
      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory, webGLContext);
      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
      if (!intentState.renderTasks) {
        intentState.renderTasks = [];
      }
      intentState.renderTasks.push(internalRenderTask);
      var renderTask = internalRenderTask.task;
      intentState.displayReadyCapability.promise.then(function (transparency) {
        if (_this4.pendingCleanup) {
          complete();
          return;
        }
        stats.time('Rendering');
        internalRenderTask.initializeGraphics(transparency);
        internalRenderTask.operatorListChanged();
      }).catch(complete);
      return renderTask;
    },
    getOperatorList: function PDFPageProxy_getOperatorList() {
      function operatorListChanged() {
        if (intentState.operatorList.lastChunk) {
          intentState.opListReadCapability.resolve(intentState.operatorList);
          var i = intentState.renderTasks.indexOf(opListTask);
          if (i >= 0) {
            intentState.renderTasks.splice(i, 1);
          }
        }
      }
      var renderingIntent = 'oplist';
      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }
      var intentState = this.intentStates[renderingIntent];
      var opListTask;
      if (!intentState.opListReadCapability) {
        opListTask = {};
        opListTask.operatorListChanged = operatorListChanged;
        intentState.receivingOperatorList = true;
        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
        intentState.renderTasks = [];
        intentState.renderTasks.push(opListTask);
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        this.transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageIndex,
          intent: renderingIntent
        });
      }
      return intentState.opListReadCapability.promise;
    },
    streamTextContent: function streamTextContent() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var TEXT_CONTENT_CHUNK_SIZE = 100;
      return this.transport.messageHandler.sendWithStream('GetTextContent', {
        pageIndex: this.pageNumber - 1,
        normalizeWhitespace: params.normalizeWhitespace === true,
        combineTextItems: params.disableCombineTextItems !== true
      }, {
        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
        size: function size(textContent) {
          return textContent.items.length;
        }
      });
    },

    getTextContent: function PDFPageProxy_getTextContent(params) {
      params = params || {};
      var readableStream = this.streamTextContent(params);
      return new Promise(function (resolve, reject) {
        function pump() {
          reader.read().then(function (_ref) {
            var value = _ref.value,
                done = _ref.done;

            if (done) {
              resolve(textContent);
              return;
            }
            _util.Util.extendObj(textContent.styles, value.styles);
            _util.Util.appendToArray(textContent.items, value.items);
            pump();
          }, reject);
        }
        var reader = readableStream.getReader();
        var textContent = {
          items: [],
          styles: Object.create(null)
        };
        pump();
      });
    },
    _destroy: function PDFPageProxy_destroy() {
      this.destroyed = true;
      this.transport.pageCache[this.pageIndex] = null;
      var waitOn = [];
      Object.keys(this.intentStates).forEach(function (intent) {
        if (intent === 'oplist') {
          return;
        }
        var intentState = this.intentStates[intent];
        intentState.renderTasks.forEach(function (renderTask) {
          var renderCompleted = renderTask.capability.promise.catch(function () {});
          waitOn.push(renderCompleted);
          renderTask.cancel();
        });
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      this.pendingCleanup = false;
      return Promise.all(waitOn);
    },
    cleanup: function cleanup() {
      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.pendingCleanup = true;
      this._tryCleanup(resetStats);
    },
    _tryCleanup: function _tryCleanup() {
      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
        var intentState = this.intentStates[intent];
        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
      }, this)) {
        return;
      }
      Object.keys(this.intentStates).forEach(function (intent) {
        delete this.intentStates[intent];
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      if (resetStats && this._stats instanceof _dom_utils.StatTimer) {
        this._stats = new _dom_utils.StatTimer();
      }
      this.pendingCleanup = false;
    },

    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
      var intentState = this.intentStates[intent];
      if (intentState.displayReadyCapability) {
        intentState.displayReadyCapability.resolve(transparency);
      }
    },
    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
      var intentState = this.intentStates[intent];
      var i, ii;
      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
      }
      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
      for (i = 0; i < intentState.renderTasks.length; i++) {
        intentState.renderTasks[i].operatorListChanged();
      }
      if (operatorListChunk.lastChunk) {
        intentState.receivingOperatorList = false;
        this._tryCleanup();
      }
    },
    get stats() {
      return this._stats instanceof _dom_utils.StatTimer ? this._stats : null;
    }
  };
  return PDFPageProxy;
}();

var LoopbackPort = function () {
  function LoopbackPort(defer) {
    _classCallCheck(this, LoopbackPort);

    this._listeners = [];
    this._defer = defer;
    this._deferred = Promise.resolve(undefined);
  }

  _createClass(LoopbackPort, [{
    key: 'postMessage',
    value: function postMessage(obj, transfers) {
      var _this5 = this;

      function cloneValue(value) {
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
          return value;
        }
        if (cloned.has(value)) {
          return cloned.get(value);
        }
        var result;
        var buffer;
        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
          var transferable = transfers && transfers.indexOf(buffer) >= 0;
          if (value === buffer) {
            result = value;
          } else if (transferable) {
            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
          } else {
            result = new value.constructor(value);
          }
          cloned.set(value, result);
          return result;
        }
        result = Array.isArray(value) ? [] : {};
        cloned.set(value, result);
        for (var i in value) {
          var desc,
              p = value;
          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
            p = Object.getPrototypeOf(p);
          }
          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
            continue;
          }
          result[i] = cloneValue(desc.value);
        }
        return result;
      }
      if (!this._defer) {
        this._listeners.forEach(function (listener) {
          listener.call(this, { data: obj });
        }, this);
        return;
      }
      var cloned = new WeakMap();
      var e = { data: cloneValue(obj) };
      this._deferred.then(function () {
        _this5._listeners.forEach(function (listener) {
          listener.call(this, e);
        }, _this5);
      });
    }
  }, {
    key: 'addEventListener',
    value: function addEventListener(name, listener) {
      this._listeners.push(listener);
    }
  }, {
    key: 'removeEventListener',
    value: function removeEventListener(name, listener) {
      var i = this._listeners.indexOf(listener);
      this._listeners.splice(i, 1);
    }
  }, {
    key: 'terminate',
    value: function terminate() {
      this._listeners = [];
    }
  }]);

  return LoopbackPort;
}();

var PDFWorker = function PDFWorkerClosure() {
  var nextFakeWorkerId = 0;
  function getWorkerSrc() {
    if (typeof workerSrc !== 'undefined') {
      return workerSrc;
    }
    if ((0, _dom_utils.getDefaultSetting)('workerSrc')) {
      return (0, _dom_utils.getDefaultSetting)('workerSrc');
    }
    if (pdfjsFilePath) {
      return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
    }
    throw new Error('No PDFJS.workerSrc specified');
  }
  var fakeWorkerFilesLoadedCapability = void 0;
  function setupFakeWorkerGlobal() {
    var WorkerMessageHandler;
    if (fakeWorkerFilesLoadedCapability) {
      return fakeWorkerFilesLoadedCapability.promise;
    }
    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
    var loader = fakeWorkerFilesLoader || function (callback) {
      _util.Util.loadScript(getWorkerSrc(), function () {
        callback(window.pdfjsDistBuildPdfWorker.WorkerMessageHandler);
      });
    };
    loader(fakeWorkerFilesLoadedCapability.resolve);
    return fakeWorkerFilesLoadedCapability.promise;
  }
  function createCDNWrapper(url) {
    var wrapper = 'importScripts(\'' + url + '\');';
    return URL.createObjectURL(new Blob([wrapper]));
  }
  var pdfWorkerPorts = new WeakMap();
  function PDFWorker(name, port) {
    if (port && pdfWorkerPorts.has(port)) {
      throw new Error('Cannot use more than one PDFWorker per port');
    }
    this.name = name;
    this.destroyed = false;
    this.postMessageTransfers = true;
    this._readyCapability = (0, _util.createPromiseCapability)();
    this._port = null;
    this._webWorker = null;
    this._messageHandler = null;
    if (port) {
      pdfWorkerPorts.set(port, this);
      this._initializeFromPort(port);
      return;
    }
    this._initialize();
  }
  PDFWorker.prototype = {
    get promise() {
      return this._readyCapability.promise;
    },
    get port() {
      return this._port;
    },
    get messageHandler() {
      return this._messageHandler;
    },
    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
      this._port = port;
      this._messageHandler = new _util.MessageHandler('main', 'worker', port);
      this._messageHandler.on('ready', function () {});
      this._readyCapability.resolve();
    },
    _initialize: function PDFWorker_initialize() {
      var _this6 = this;

      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker') && typeof Worker !== 'undefined') {
        var workerSrc = getWorkerSrc();
        try {
          if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
            workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
          }
          var worker = new Worker(workerSrc);
          var messageHandler = new _util.MessageHandler('main', 'worker', worker);
          var terminateEarly = function terminateEarly() {
            worker.removeEventListener('error', onWorkerError);
            messageHandler.destroy();
            worker.terminate();
            if (_this6.destroyed) {
              _this6._readyCapability.reject(new Error('Worker was destroyed'));
            } else {
              _this6._setupFakeWorker();
            }
          };
          var onWorkerError = function onWorkerError() {
            if (!_this6._webWorker) {
              terminateEarly();
            }
          };
          worker.addEventListener('error', onWorkerError);
          messageHandler.on('test', function (data) {
            worker.removeEventListener('error', onWorkerError);
            if (_this6.destroyed) {
              terminateEarly();
              return;
            }
            var supportTypedArray = data && data.supportTypedArray;
            if (supportTypedArray) {
              _this6._messageHandler = messageHandler;
              _this6._port = worker;
              _this6._webWorker = worker;
              if (!data.supportTransfers) {
                _this6.postMessageTransfers = false;
                isPostMessageTransfersDisabled = true;
              }
              _this6._readyCapability.resolve();
              messageHandler.send('configure', { verbosity: (0, _util.getVerbosityLevel)() });
            } else {
              _this6._setupFakeWorker();
              messageHandler.destroy();
              worker.terminate();
            }
          });
          messageHandler.on('ready', function (data) {
            worker.removeEventListener('error', onWorkerError);
            if (_this6.destroyed) {
              terminateEarly();
              return;
            }
            try {
              sendTest();
            } catch (e) {
              _this6._setupFakeWorker();
            }
          });
          var sendTest = function sendTest() {
            var postMessageTransfers = (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled;
            var testObj = new Uint8Array([postMessageTransfers ? 255 : 0]);
            try {
              messageHandler.send('test', testObj, [testObj.buffer]);
            } catch (ex) {
              (0, _util.info)('Cannot use postMessage transfers');
              testObj[0] = 0;
              messageHandler.send('test', testObj);
            }
          };
          sendTest();
          return;
        } catch (e) {
          (0, _util.info)('The worker has been disabled.');
        }
      }
      this._setupFakeWorker();
    },
    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
      var _this7 = this;

      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker')) {
        (0, _util.warn)('Setting up fake worker.');
        isWorkerDisabled = true;
      }
      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
        if (_this7.destroyed) {
          _this7._readyCapability.reject(new Error('Worker was destroyed'));
          return;
        }
        var isTypedArraysPresent = Uint8Array !== Float32Array;
        var port = new LoopbackPort(isTypedArraysPresent);
        _this7._port = port;
        var id = 'fake' + nextFakeWorkerId++;
        var workerHandler = new _util.MessageHandler(id + '_worker', id, port);
        WorkerMessageHandler.setup(workerHandler, port);
        var messageHandler = new _util.MessageHandler(id, id + '_worker', port);
        _this7._messageHandler = messageHandler;
        _this7._readyCapability.resolve();
      });
    },
    destroy: function PDFWorker_destroy() {
      this.destroyed = true;
      if (this._webWorker) {
        this._webWorker.terminate();
        this._webWorker = null;
      }
      pdfWorkerPorts.delete(this._port);
      this._port = null;
      if (this._messageHandler) {
        this._messageHandler.destroy();
        this._messageHandler = null;
      }
    }
  };
  PDFWorker.fromPort = function (port) {
    if (pdfWorkerPorts.has(port)) {
      return pdfWorkerPorts.get(port);
    }
    return new PDFWorker(null, port);
  };
  return PDFWorker;
}();
var WorkerTransport = function WorkerTransportClosure() {
  function WorkerTransport(messageHandler, loadingTask, networkStream, CMapReaderFactory) {
    this.messageHandler = messageHandler;
    this.loadingTask = loadingTask;
    this.commonObjs = new PDFObjects();
    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
    this.CMapReaderFactory = new CMapReaderFactory({
      baseUrl: (0, _dom_utils.getDefaultSetting)('cMapUrl'),
      isCompressed: (0, _dom_utils.getDefaultSetting)('cMapPacked')
    });
    this.destroyed = false;
    this.destroyCapability = null;
    this._passwordCapability = null;
    this._networkStream = networkStream;
    this._fullReader = null;
    this._lastProgress = null;
    this.pageCache = [];
    this.pagePromises = [];
    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
    this.setupMessageHandler();
  }
  WorkerTransport.prototype = {
    destroy: function WorkerTransport_destroy() {
      var _this8 = this;

      if (this.destroyCapability) {
        return this.destroyCapability.promise;
      }
      this.destroyed = true;
      this.destroyCapability = (0, _util.createPromiseCapability)();
      if (this._passwordCapability) {
        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
      }
      var waitOn = [];
      this.pageCache.forEach(function (page) {
        if (page) {
          waitOn.push(page._destroy());
        }
      });
      this.pageCache = [];
      this.pagePromises = [];
      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
      waitOn.push(terminated);
      Promise.all(waitOn).then(function () {
        _this8.fontLoader.clear();
        if (_this8._networkStream) {
          _this8._networkStream.cancelAllRequests();
        }
        if (_this8.messageHandler) {
          _this8.messageHandler.destroy();
          _this8.messageHandler = null;
        }
        _this8.destroyCapability.resolve();
      }, this.destroyCapability.reject);
      return this.destroyCapability.promise;
    },
    setupMessageHandler: function WorkerTransport_setupMessageHandler() {
      var messageHandler = this.messageHandler;
      var loadingTask = this.loadingTask;
      messageHandler.on('GetReader', function (data, sink) {
        var _this9 = this;

        (0, _util.assert)(this._networkStream);
        this._fullReader = this._networkStream.getFullReader();
        this._fullReader.onProgress = function (evt) {
          _this9._lastProgress = {
            loaded: evt.loaded,
            total: evt.total
          };
        };
        sink.onPull = function () {
          _this9._fullReader.read().then(function (_ref2) {
            var value = _ref2.value,
                done = _ref2.done;

            if (done) {
              sink.close();
              return;
            }
            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          }).catch(function (reason) {
            sink.error(reason);
          });
        };
        sink.onCancel = function (reason) {
          _this9._fullReader.cancel(reason);
        };
      }, this);
      messageHandler.on('ReaderHeadersReady', function (data) {
        var _this10 = this;

        var headersCapability = (0, _util.createPromiseCapability)();
        var fullReader = this._fullReader;
        fullReader.headersReady.then(function () {
          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
            if (_this10._lastProgress) {
              var _loadingTask = _this10.loadingTask;
              if (_loadingTask.onProgress) {
                _loadingTask.onProgress(_this10._lastProgress);
              }
            }
            fullReader.onProgress = function (evt) {
              var loadingTask = _this10.loadingTask;
              if (loadingTask.onProgress) {
                loadingTask.onProgress({
                  loaded: evt.loaded,
                  total: evt.total
                });
              }
            };
          }
          headersCapability.resolve({
            isStreamingSupported: fullReader.isStreamingSupported,
            isRangeSupported: fullReader.isRangeSupported,
            contentLength: fullReader.contentLength
          });
        }, headersCapability.reject);
        return headersCapability.promise;
      }, this);
      messageHandler.on('GetRangeReader', function (data, sink) {
        (0, _util.assert)(this._networkStream);
        var _rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
        sink.onPull = function () {
          _rangeReader.read().then(function (_ref3) {
            var value = _ref3.value,
                done = _ref3.done;

            if (done) {
              sink.close();
              return;
            }
            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          }).catch(function (reason) {
            sink.error(reason);
          });
        };
        sink.onCancel = function (reason) {
          _rangeReader.cancel(reason);
        };
      }, this);
      messageHandler.on('GetDoc', function transportDoc(_ref4) {
        var pdfInfo = _ref4.pdfInfo;

        this.numPages = pdfInfo.numPages;
        var loadingTask = this.loadingTask;
        var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
        this.pdfDocument = pdfDocument;
        loadingTask._capability.resolve(pdfDocument);
      }, this);
      messageHandler.on('PasswordRequest', function transportPasswordRequest(exception) {
        var _this11 = this;

        this._passwordCapability = (0, _util.createPromiseCapability)();
        if (loadingTask.onPassword) {
          var updatePassword = function updatePassword(password) {
            _this11._passwordCapability.resolve({ password: password });
          };
          loadingTask.onPassword(updatePassword, exception.code);
        } else {
          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
        }
        return this._passwordCapability.promise;
      }, this);
      messageHandler.on('PasswordException', function transportPasswordException(exception) {
        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
      }, this);
      messageHandler.on('InvalidPDF', function transportInvalidPDF(exception) {
        this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
      }, this);
      messageHandler.on('MissingPDF', function transportMissingPDF(exception) {
        this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
      }, this);
      messageHandler.on('UnexpectedResponse', function transportUnexpectedResponse(exception) {
        this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
      }, this);
      messageHandler.on('UnknownError', function transportUnknownError(exception) {
        this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
      }, this);
      messageHandler.on('DataLoaded', function transportPage(data) {
        this.downloadInfoCapability.resolve(data);
      }, this);
      messageHandler.on('PDFManagerReady', function transportPage(data) {}, this);
      messageHandler.on('StartRenderPage', function transportRender(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageIndex];
        page._stats.timeEnd('Page Request');
        page._startRenderPage(data.transparency, data.intent);
      }, this);
      messageHandler.on('RenderPageChunk', function transportRender(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageIndex];
        page._renderPageChunk(data.operatorList, data.intent);
      }, this);
      messageHandler.on('commonobj', function transportObj(data) {
        var _this12 = this;

        if (this.destroyed) {
          return;
        }
        var id = data[0];
        var type = data[1];
        if (this.commonObjs.hasData(id)) {
          return;
        }
        switch (type) {
          case 'Font':
            var exportedData = data[2];
            if ('error' in exportedData) {
              var exportedError = exportedData.error;
              (0, _util.warn)('Error during font loading: ' + exportedError);
              this.commonObjs.resolve(id, exportedError);
              break;
            }
            var fontRegistry = null;
            if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.FontInspector && _global_scope2.default['FontInspector'].enabled) {
              fontRegistry = {
                registerFont: function registerFont(font, url) {
                  _global_scope2.default['FontInspector'].fontAdded(font, url);
                }
              };
            }
            var font = new _font_loader.FontFaceObject(exportedData, {
              isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported'),
              disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
              fontRegistry: fontRegistry
            });
            var fontReady = function fontReady(fontObjs) {
              _this12.commonObjs.resolve(id, font);
            };
            this.fontLoader.bind([font], fontReady);
            break;
          case 'FontPath':
            this.commonObjs.resolve(id, data[2]);
            break;
          default:
            throw new Error('Got unknown common object type ' + type);
        }
      }, this);
      messageHandler.on('obj', function transportObj(data) {
        if (this.destroyed) {
          return;
        }
        var id = data[0];
        var pageIndex = data[1];
        var type = data[2];
        var pageProxy = this.pageCache[pageIndex];
        var imageData;
        if (pageProxy.objs.hasData(id)) {
          return;
        }
        switch (type) {
          case 'JpegStream':
            imageData = data[3];
            (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
            break;
          case 'Image':
            imageData = data[3];
            pageProxy.objs.resolve(id, imageData);
            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
              pageProxy.cleanupAfterRender = true;
            }
            break;
          default:
            throw new Error('Got unknown object type ' + type);
        }
      }, this);
      messageHandler.on('DocProgress', function transportDocProgress(data) {
        if (this.destroyed) {
          return;
        }
        var loadingTask = this.loadingTask;
        if (loadingTask.onProgress) {
          loadingTask.onProgress({
            loaded: data.loaded,
            total: data.total
          });
        }
      }, this);
      messageHandler.on('PageError', function transportError(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageNum - 1];
        var intentState = page.intentStates[data.intent];
        if (intentState.displayReadyCapability) {
          intentState.displayReadyCapability.reject(data.error);
        } else {
          throw new Error(data.error);
        }
        if (intentState.operatorList) {
          intentState.operatorList.lastChunk = true;
          for (var i = 0; i < intentState.renderTasks.length; i++) {
            intentState.renderTasks[i].operatorListChanged();
          }
        }
      }, this);
      messageHandler.on('UnsupportedFeature', function (data) {
        if (this.destroyed) {
          return;
        }
        var loadingTask = this.loadingTask;
        if (loadingTask.onUnsupportedFeature) {
          loadingTask.onUnsupportedFeature(data.featureId);
        }
      }, this);
      messageHandler.on('JpegDecode', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }
        if (typeof document === 'undefined') {
          return Promise.reject(new Error('"document" is not defined.'));
        }
        var imageUrl = data[0];
        var components = data[1];
        if (components !== 3 && components !== 1) {
          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
        }
        return new Promise(function (resolve, reject) {
          var img = new Image();
          img.onload = function () {
            var width = img.width;
            var height = img.height;
            var size = width * height;
            var rgbaLength = size * 4;
            var buf = new Uint8Array(size * components);
            var tmpCanvas = document.createElement('canvas');
            tmpCanvas.width = width;
            tmpCanvas.height = height;
            var tmpCtx = tmpCanvas.getContext('2d');
            tmpCtx.drawImage(img, 0, 0);
            var data = tmpCtx.getImageData(0, 0, width, height).data;
            var i, j;
            if (components === 3) {
              for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
                buf[j] = data[i];
                buf[j + 1] = data[i + 1];
                buf[j + 2] = data[i + 2];
              }
            } else if (components === 1) {
              for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
                buf[j] = data[i];
              }
            }
            resolve({
              data: buf,
              width: width,
              height: height
            });
          };
          img.onerror = function () {
            reject(new Error('JpegDecode failed to load image'));
          };
          img.src = imageUrl;
        });
      }, this);
      messageHandler.on('FetchBuiltInCMap', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }
        return this.CMapReaderFactory.fetch({ name: data.name });
      }, this);
    },
    getData: function WorkerTransport_getData() {
      return this.messageHandler.sendWithPromise('GetData', null);
    },
    getPage: function getPage(pageNumber) {
      var _this13 = this;

      if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
        return Promise.reject(new Error('Invalid page request'));
      }
      var pageIndex = pageNumber - 1;
      if (pageIndex in this.pagePromises) {
        return this.pagePromises[pageIndex];
      }
      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
        if (_this13.destroyed) {
          throw new Error('Transport destroyed');
        }
        var page = new PDFPageProxy(pageIndex, pageInfo, _this13);
        _this13.pageCache[pageIndex] = page;
        return page;
      });
      this.pagePromises[pageIndex] = promise;
      return promise;
    },

    getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
        return Promise.reject(new Error(reason));
      });
    },
    getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
      return this.messageHandler.sendWithPromise('GetAnnotations', {
        pageIndex: pageIndex,
        intent: intent
      });
    },
    getDestinations: function WorkerTransport_getDestinations() {
      return this.messageHandler.sendWithPromise('GetDestinations', null);
    },
    getDestination: function WorkerTransport_getDestination(id) {
      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
    },
    getPageLabels: function WorkerTransport_getPageLabels() {
      return this.messageHandler.sendWithPromise('GetPageLabels', null);
    },
    getPageMode: function getPageMode() {
      return this.messageHandler.sendWithPromise('GetPageMode', null);
    },

    getAttachments: function WorkerTransport_getAttachments() {
      return this.messageHandler.sendWithPromise('GetAttachments', null);
    },
    getJavaScript: function WorkerTransport_getJavaScript() {
      return this.messageHandler.sendWithPromise('GetJavaScript', null);
    },
    getOutline: function WorkerTransport_getOutline() {
      return this.messageHandler.sendWithPromise('GetOutline', null);
    },
    getMetadata: function WorkerTransport_getMetadata() {
      var _this14 = this;

      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function (results) {
        return {
          info: results[0],
          metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
          contentDispositionFilename: _this14._fullReader ? _this14._fullReader.filename : null
        };
      });
    },
    getStats: function WorkerTransport_getStats() {
      return this.messageHandler.sendWithPromise('GetStats', null);
    },
    startCleanup: function WorkerTransport_startCleanup() {
      var _this15 = this;

      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
        for (var i = 0, ii = _this15.pageCache.length; i < ii; i++) {
          var page = _this15.pageCache[i];
          if (page) {
            page.cleanup();
          }
        }
        _this15.commonObjs.clear();
        _this15.fontLoader.clear();
      });
    }
  };
  return WorkerTransport;
}();
var PDFObjects = function PDFObjectsClosure() {
  function PDFObjects() {
    this.objs = Object.create(null);
  }
  PDFObjects.prototype = {
    ensureObj: function PDFObjects_ensureObj(objId) {
      if (this.objs[objId]) {
        return this.objs[objId];
      }
      var obj = {
        capability: (0, _util.createPromiseCapability)(),
        data: null,
        resolved: false
      };
      this.objs[objId] = obj;
      return obj;
    },
    get: function PDFObjects_get(objId, callback) {
      if (callback) {
        this.ensureObj(objId).capability.promise.then(callback);
        return null;
      }
      var obj = this.objs[objId];
      if (!obj || !obj.resolved) {
        throw new Error('Requesting object that isn\'t resolved yet ' + objId);
      }
      return obj.data;
    },
    resolve: function PDFObjects_resolve(objId, data) {
      var obj = this.ensureObj(objId);
      obj.resolved = true;
      obj.data = data;
      obj.capability.resolve(data);
    },
    isResolved: function PDFObjects_isResolved(objId) {
      var objs = this.objs;
      if (!objs[objId]) {
        return false;
      }
      return objs[objId].resolved;
    },
    hasData: function PDFObjects_hasData(objId) {
      return this.isResolved(objId);
    },
    getData: function PDFObjects_getData(objId) {
      var objs = this.objs;
      if (!objs[objId] || !objs[objId].resolved) {
        return null;
      }
      return objs[objId].data;
    },
    clear: function PDFObjects_clear() {
      this.objs = Object.create(null);
    }
  };
  return PDFObjects;
}();
var RenderTask = function RenderTaskClosure() {
  function RenderTask(internalRenderTask) {
    this._internalRenderTask = internalRenderTask;
    this.onContinue = null;
  }
  RenderTask.prototype = {
    get promise() {
      return this._internalRenderTask.capability.promise;
    },
    cancel: function RenderTask_cancel() {
      this._internalRenderTask.cancel();
    },
    then: function RenderTask_then(onFulfilled, onRejected) {
      return this.promise.then.apply(this.promise, arguments);
    }
  };
  return RenderTask;
}();
var InternalRenderTask = function InternalRenderTaskClosure() {
  var canvasInRendering = new WeakMap();
  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory, webGLContext) {
    this.callback = callback;
    this.params = params;
    this.objs = objs;
    this.commonObjs = commonObjs;
    this.operatorListIdx = null;
    this.operatorList = operatorList;
    this.pageNumber = pageNumber;
    this.canvasFactory = canvasFactory;
    this.webGLContext = webGLContext;
    this.running = false;
    this.graphicsReadyCallback = null;
    this.graphicsReady = false;
    this.useRequestAnimationFrame = false;
    this.cancelled = false;
    this.capability = (0, _util.createPromiseCapability)();
    this.task = new RenderTask(this);
    this._continueBound = this._continue.bind(this);
    this._scheduleNextBound = this._scheduleNext.bind(this);
    this._nextBound = this._next.bind(this);
    this._canvas = params.canvasContext.canvas;
  }
  InternalRenderTask.prototype = {
    initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
      if (this._canvas) {
        if (canvasInRendering.has(this._canvas)) {
          throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
        }
        canvasInRendering.set(this._canvas, this);
      }
      if (this.cancelled) {
        return;
      }
      if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.StepperManager && _global_scope2.default.StepperManager.enabled) {
        this.stepper = _global_scope2.default.StepperManager.create(this.pageNumber - 1);
        this.stepper.init(this.operatorList);
        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
      }
      var params = this.params;
      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext, params.imageLayer);
      this.gfx.beginDrawing({
        transform: params.transform,
        viewport: params.viewport,
        transparency: transparency,
        background: params.background
      });
      this.operatorListIdx = 0;
      this.graphicsReady = true;
      if (this.graphicsReadyCallback) {
        this.graphicsReadyCallback();
      }
    },
    cancel: function InternalRenderTask_cancel() {
      this.running = false;
      this.cancelled = true;
      if (this._canvas) {
        canvasInRendering.delete(this._canvas);
      }
      this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
    },
    operatorListChanged: function InternalRenderTask_operatorListChanged() {
      if (!this.graphicsReady) {
        if (!this.graphicsReadyCallback) {
          this.graphicsReadyCallback = this._continueBound;
        }
        return;
      }
      if (this.stepper) {
        this.stepper.updateOperatorList(this.operatorList);
      }
      if (this.running) {
        return;
      }
      this._continue();
    },
    _continue: function InternalRenderTask__continue() {
      this.running = true;
      if (this.cancelled) {
        return;
      }
      if (this.task.onContinue) {
        this.task.onContinue(this._scheduleNextBound);
      } else {
        this._scheduleNext();
      }
    },
    _scheduleNext: function InternalRenderTask__scheduleNext() {
      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
        window.requestAnimationFrame(this._nextBound);
      } else {
        Promise.resolve(undefined).then(this._nextBound);
      }
    },
    _next: function InternalRenderTask__next() {
      if (this.cancelled) {
        return;
      }
      this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
      if (this.operatorListIdx === this.operatorList.argsArray.length) {
        this.running = false;
        if (this.operatorList.lastChunk) {
          this.gfx.endDrawing();
          if (this._canvas) {
            canvasInRendering.delete(this._canvas);
          }
          this.callback();
        }
      }
    }
  };
  return InternalRenderTask;
}();
var version, build;
{
  exports.version = version = '2.0.305';
  exports.build = build = '9c6a8801';
}
exports.getDocument = getDocument;
exports.LoopbackPort = LoopbackPort;
exports.PDFDataRangeTransport = PDFDataRangeTransport;
exports.PDFWorker = PDFWorker;
exports.PDFDocumentProxy = PDFDocumentProxy;
exports.PDFPageProxy = PDFPageProxy;
exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
exports.version = version;
exports.build = build;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__(73);

var _dom_utils = __webpack_require__(204);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Metadata = function () {
  function Metadata(data) {
    _classCallCheck(this, Metadata);

    (0, _util.assert)(typeof data === 'string', 'Metadata: input is not a string');
    data = this._repair(data);
    var parser = new _dom_utils.SimpleXMLParser();
    data = parser.parseFromString(data);
    this._metadata = Object.create(null);
    this._parse(data);
  }

  _createClass(Metadata, [{
    key: '_repair',
    value: function _repair(data) {
      return data.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
        var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
          return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
        }).replace(/&(amp|apos|gt|lt|quot);/g, function (str, name) {
          switch (name) {
            case 'amp':
              return '&';
            case 'apos':
              return '\'';
            case 'gt':
              return '>';
            case 'lt':
              return '<';
            case 'quot':
              return '\"';
          }
          throw new Error('_repair: ' + name + ' isn\'t defined.');
        });
        var chars = '';
        for (var i = 0, ii = bytes.length; i < ii; i += 2) {
          var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
          if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
            chars += String.fromCharCode(code);
          } else {
            chars += '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
          }
        }
        return '>' + chars;
      });
    }
  }, {
    key: '_parse',
    value: function _parse(domDocument) {
      var rdf = domDocument.documentElement;
      if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
        rdf = rdf.firstChild;
        while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
          rdf = rdf.nextSibling;
        }
      }
      var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
      if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
        return;
      }
      var children = rdf.childNodes;
      for (var i = 0, ii = children.length; i < ii; i++) {
        var desc = children[i];
        if (desc.nodeName.toLowerCase() !== 'rdf:description') {
          continue;
        }
        for (var j = 0, jj = desc.childNodes.length; j < jj; j++) {
          if (desc.childNodes[j].nodeName.toLowerCase() !== '#text') {
            var entry = desc.childNodes[j];
            var name = entry.nodeName.toLowerCase();
            this._metadata[name] = entry.textContent.trim();
          }
        }
      }
    }
  }, {
    key: 'get',
    value: function get(name) {
      return this._metadata[name] || null;
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      return this._metadata;
    }
  }, {
    key: 'has',
    value: function has(name) {
      return typeof this._metadata[name] !== 'undefined';
    }
  }]);

  return Metadata;
}();

exports.Metadata = Metadata;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationLayer = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom_utils = __webpack_require__(204);

var _util = __webpack_require__(73);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnnotationElementFactory = function () {
  function AnnotationElementFactory() {
    _classCallCheck(this, AnnotationElementFactory);
  }

  _createClass(AnnotationElementFactory, null, [{
    key: 'create',
    value: function create(parameters) {
      var subtype = parameters.data.annotationType;
      switch (subtype) {
        case _util.AnnotationType.LINK:
          return new LinkAnnotationElement(parameters);
        case _util.AnnotationType.TEXT:
          return new TextAnnotationElement(parameters);
        case _util.AnnotationType.WIDGET:
          var fieldType = parameters.data.fieldType;
          switch (fieldType) {
            case 'Tx':
              return new TextWidgetAnnotationElement(parameters);
            case 'Btn':
              if (parameters.data.radioButton) {
                return new RadioButtonWidgetAnnotationElement(parameters);
              } else if (parameters.data.checkBox) {
                return new CheckboxWidgetAnnotationElement(parameters);
              }
              return new PushButtonWidgetAnnotationElement(parameters);
            case 'Ch':
              return new ChoiceWidgetAnnotationElement(parameters);
          }
          return new WidgetAnnotationElement(parameters);
        case _util.AnnotationType.POPUP:
          return new PopupAnnotationElement(parameters);
        case _util.AnnotationType.LINE:
          return new LineAnnotationElement(parameters);
        case _util.AnnotationType.SQUARE:
          return new SquareAnnotationElement(parameters);
        case _util.AnnotationType.CIRCLE:
          return new CircleAnnotationElement(parameters);
        case _util.AnnotationType.POLYLINE:
          return new PolylineAnnotationElement(parameters);
        case _util.AnnotationType.POLYGON:
          return new PolygonAnnotationElement(parameters);
        case _util.AnnotationType.HIGHLIGHT:
          return new HighlightAnnotationElement(parameters);
        case _util.AnnotationType.UNDERLINE:
          return new UnderlineAnnotationElement(parameters);
        case _util.AnnotationType.SQUIGGLY:
          return new SquigglyAnnotationElement(parameters);
        case _util.AnnotationType.STRIKEOUT:
          return new StrikeOutAnnotationElement(parameters);
        case _util.AnnotationType.STAMP:
          return new StampAnnotationElement(parameters);
        case _util.AnnotationType.FILEATTACHMENT:
          return new FileAttachmentAnnotationElement(parameters);
        default:
          return new AnnotationElement(parameters);
      }
    }
  }]);

  return AnnotationElementFactory;
}();

var AnnotationElement = function () {
  function AnnotationElement(parameters) {
    var isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, AnnotationElement);

    this.isRenderable = isRenderable;
    this.data = parameters.data;
    this.layer = parameters.layer;
    this.page = parameters.page;
    this.viewport = parameters.viewport;
    this.linkService = parameters.linkService;
    this.downloadManager = parameters.downloadManager;
    this.imageResourcesPath = parameters.imageResourcesPath;
    this.renderInteractiveForms = parameters.renderInteractiveForms;
    this.svgFactory = parameters.svgFactory;
    if (isRenderable) {
      this.container = this._createContainer(ignoreBorder);
    }
  }

  _createClass(AnnotationElement, [{
    key: '_createContainer',
    value: function _createContainer() {
      var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var data = this.data,
          page = this.page,
          viewport = this.viewport;
      var container = document.createElement('section');
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      container.setAttribute('data-annotation-id', data.id);
      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
      container.style.transform = 'matrix(' + viewport.transform.join(',') + ')';
      container.style.transformOrigin = -rect[0] + 'px ' + -rect[1] + 'px';
      if (!ignoreBorder && data.borderStyle.width > 0) {
        container.style.borderWidth = data.borderStyle.width + 'px';
        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
          width = width - 2 * data.borderStyle.width;
          height = height - 2 * data.borderStyle.width;
        }
        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
        var verticalRadius = data.borderStyle.verticalCornerRadius;
        if (horizontalRadius > 0 || verticalRadius > 0) {
          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
          container.style.borderRadius = radius;
        }
        switch (data.borderStyle.style) {
          case _util.AnnotationBorderStyleType.SOLID:
            container.style.borderStyle = 'solid';
            break;
          case _util.AnnotationBorderStyleType.DASHED:
            container.style.borderStyle = 'dashed';
            break;
          case _util.AnnotationBorderStyleType.BEVELED:
            (0, _util.warn)('Unimplemented border style: beveled');
            break;
          case _util.AnnotationBorderStyleType.INSET:
            (0, _util.warn)('Unimplemented border style: inset');
            break;
          case _util.AnnotationBorderStyleType.UNDERLINE:
            container.style.borderBottomStyle = 'solid';
            break;
          default:
            break;
        }
        if (data.color) {
          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
        } else {
          container.style.borderWidth = 0;
        }
      }
      container.style.left = rect[0] + 'px';
      container.style.top = rect[1] + 'px';
      container.style.width = width + 'px';
      container.style.height = height + 'px';
      return container;
    }
  }, {
    key: '_createPopup',
    value: function _createPopup(container, trigger, data) {
      if (!trigger) {
        trigger = document.createElement('div');
        trigger.style.height = container.style.height;
        trigger.style.width = container.style.width;
        container.appendChild(trigger);
      }
      var popupElement = new PopupElement({
        container: container,
        trigger: trigger,
        color: data.color,
        title: data.title,
        contents: data.contents,
        hideWrapper: true
      });
      var popup = popupElement.render();
      popup.style.left = container.style.width;
      container.appendChild(popup);
    }
  }, {
    key: 'render',
    value: function render() {
      (0, _util.unreachable)('Abstract method `AnnotationElement.render` called');
    }
  }]);

  return AnnotationElement;
}();

var LinkAnnotationElement = function (_AnnotationElement) {
  _inherits(LinkAnnotationElement, _AnnotationElement);

  function LinkAnnotationElement(parameters) {
    _classCallCheck(this, LinkAnnotationElement);

    var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action);
    return _possibleConstructorReturn(this, (LinkAnnotationElement.__proto__ || Object.getPrototypeOf(LinkAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(LinkAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'linkAnnotation';
      var link = document.createElement('a');
      (0, _dom_utils.addLinkAttributes)(link, {
        url: this.data.url,
        target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
      });
      if (!this.data.url) {
        if (this.data.action) {
          this._bindNamedAction(link, this.data.action);
        } else {
          this._bindLink(link, this.data.dest);
        }
      }
      this.container.appendChild(link);
      return this.container;
    }
  }, {
    key: '_bindLink',
    value: function _bindLink(link, destination) {
      var _this2 = this;

      link.href = this.linkService.getDestinationHash(destination);
      link.onclick = function () {
        if (destination) {
          _this2.linkService.navigateTo(destination);
        }
        return false;
      };
      if (destination) {
        link.className = 'internalLink';
      }
    }
  }, {
    key: '_bindNamedAction',
    value: function _bindNamedAction(link, action) {
      var _this3 = this;

      link.href = this.linkService.getAnchorUrl('');
      link.onclick = function () {
        _this3.linkService.executeNamedAction(action);
        return false;
      };
      link.className = 'internalLink';
    }
  }]);

  return LinkAnnotationElement;
}(AnnotationElement);

var TextAnnotationElement = function (_AnnotationElement2) {
  _inherits(TextAnnotationElement, _AnnotationElement2);

  function TextAnnotationElement(parameters) {
    _classCallCheck(this, TextAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (TextAnnotationElement.__proto__ || Object.getPrototypeOf(TextAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(TextAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'textAnnotation';
      var image = document.createElement('img');
      image.style.height = this.container.style.height;
      image.style.width = this.container.style.width;
      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
      image.alt = '[{{type}} Annotation]';
      image.dataset.l10nId = 'text_annotation_type';
      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
      if (!this.data.hasPopup) {
        this._createPopup(this.container, image, this.data);
      }
      this.container.appendChild(image);
      return this.container;
    }
  }]);

  return TextAnnotationElement;
}(AnnotationElement);

var WidgetAnnotationElement = function (_AnnotationElement3) {
  _inherits(WidgetAnnotationElement, _AnnotationElement3);

  function WidgetAnnotationElement() {
    _classCallCheck(this, WidgetAnnotationElement);

    return _possibleConstructorReturn(this, (WidgetAnnotationElement.__proto__ || Object.getPrototypeOf(WidgetAnnotationElement)).apply(this, arguments));
  }

  _createClass(WidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      return this.container;
    }
  }]);

  return WidgetAnnotationElement;
}(AnnotationElement);

var TextWidgetAnnotationElement = function (_WidgetAnnotationElem) {
  _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);

  function TextWidgetAnnotationElement(parameters) {
    _classCallCheck(this, TextWidgetAnnotationElement);

    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
    return _possibleConstructorReturn(this, (TextWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(TextWidgetAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(TextWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      var TEXT_ALIGNMENT = ['left', 'center', 'right'];
      this.container.className = 'textWidgetAnnotation';
      var element = null;
      if (this.renderInteractiveForms) {
        if (this.data.multiLine) {
          element = document.createElement('textarea');
          element.textContent = this.data.fieldValue;
        } else {
          element = document.createElement('input');
          element.type = 'text';
          element.setAttribute('value', this.data.fieldValue);
        }
        element.disabled = this.data.readOnly;
        if (this.data.maxLen !== null) {
          element.maxLength = this.data.maxLen;
        }
        if (this.data.comb) {
          var fieldWidth = this.data.rect[2] - this.data.rect[0];
          var combWidth = fieldWidth / this.data.maxLen;
          element.classList.add('comb');
          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
        }
      } else {
        element = document.createElement('div');
        element.textContent = this.data.fieldValue;
        element.style.verticalAlign = 'middle';
        element.style.display = 'table-cell';
        var font = null;
        if (this.data.fontRefName) {
          font = this.page.commonObjs.getData(this.data.fontRefName);
        }
        this._setTextStyle(element, font);
      }
      if (this.data.textAlignment !== null) {
        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
      }
      this.container.appendChild(element);
      return this.container;
    }
  }, {
    key: '_setTextStyle',
    value: function _setTextStyle(element, font) {
      var style = element.style;
      style.fontSize = this.data.fontSize + 'px';
      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
      if (!font) {
        return;
      }
      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
      style.fontStyle = font.italic ? 'italic' : 'normal';
      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
      style.fontFamily = fontFamily + fallbackName;
    }
  }]);

  return TextWidgetAnnotationElement;
}(WidgetAnnotationElement);

var CheckboxWidgetAnnotationElement = function (_WidgetAnnotationElem2) {
  _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);

  function CheckboxWidgetAnnotationElement(parameters) {
    _classCallCheck(this, CheckboxWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (CheckboxWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(CheckboxWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(CheckboxWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'buttonWidgetAnnotation checkBox';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'checkbox';
      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
        element.setAttribute('checked', true);
      }
      this.container.appendChild(element);
      return this.container;
    }
  }]);

  return CheckboxWidgetAnnotationElement;
}(WidgetAnnotationElement);

var RadioButtonWidgetAnnotationElement = function (_WidgetAnnotationElem3) {
  _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);

  function RadioButtonWidgetAnnotationElement(parameters) {
    _classCallCheck(this, RadioButtonWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (RadioButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(RadioButtonWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(RadioButtonWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'buttonWidgetAnnotation radioButton';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'radio';
      element.name = this.data.fieldName;
      if (this.data.fieldValue === this.data.buttonValue) {
        element.setAttribute('checked', true);
      }
      this.container.appendChild(element);
      return this.container;
    }
  }]);

  return RadioButtonWidgetAnnotationElement;
}(WidgetAnnotationElement);

var PushButtonWidgetAnnotationElement = function (_LinkAnnotationElemen) {
  _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);

  function PushButtonWidgetAnnotationElement() {
    _classCallCheck(this, PushButtonWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (PushButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(PushButtonWidgetAnnotationElement)).apply(this, arguments));
  }

  _createClass(PushButtonWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      var container = _get(PushButtonWidgetAnnotationElement.prototype.__proto__ || Object.getPrototypeOf(PushButtonWidgetAnnotationElement.prototype), 'render', this).call(this);
      container.className = 'buttonWidgetAnnotation pushButton';
      return container;
    }
  }]);

  return PushButtonWidgetAnnotationElement;
}(LinkAnnotationElement);

var ChoiceWidgetAnnotationElement = function (_WidgetAnnotationElem4) {
  _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);

  function ChoiceWidgetAnnotationElement(parameters) {
    _classCallCheck(this, ChoiceWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (ChoiceWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(ChoiceWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(ChoiceWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'choiceWidgetAnnotation';
      var selectElement = document.createElement('select');
      selectElement.disabled = this.data.readOnly;
      if (!this.data.combo) {
        selectElement.size = this.data.options.length;
        if (this.data.multiSelect) {
          selectElement.multiple = true;
        }
      }
      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
        var option = this.data.options[i];
        var optionElement = document.createElement('option');
        optionElement.textContent = option.displayValue;
        optionElement.value = option.exportValue;
        if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
          optionElement.setAttribute('selected', true);
        }
        selectElement.appendChild(optionElement);
      }
      this.container.appendChild(selectElement);
      return this.container;
    }
  }]);

  return ChoiceWidgetAnnotationElement;
}(WidgetAnnotationElement);

var PopupAnnotationElement = function (_AnnotationElement4) {
  _inherits(PopupAnnotationElement, _AnnotationElement4);

  function PopupAnnotationElement(parameters) {
    _classCallCheck(this, PopupAnnotationElement);

    var isRenderable = !!(parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (PopupAnnotationElement.__proto__ || Object.getPrototypeOf(PopupAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(PopupAnnotationElement, [{
    key: 'render',
    value: function render() {
      var IGNORE_TYPES = ['Line', 'Square', 'Circle', 'PolyLine', 'Polygon'];
      this.container.className = 'popupAnnotation';
      if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
        return this.container;
      }
      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
      var parentElement = this.layer.querySelector(selector);
      if (!parentElement) {
        return this.container;
      }
      var popup = new PopupElement({
        container: this.container,
        trigger: parentElement,
        color: this.data.color,
        title: this.data.title,
        contents: this.data.contents
      });
      var parentLeft = parseFloat(parentElement.style.left);
      var parentWidth = parseFloat(parentElement.style.width);
      this.container.style.transformOrigin = -(parentLeft + parentWidth) + 'px -' + parentElement.style.top;
      this.container.style.left = parentLeft + parentWidth + 'px';
      this.container.appendChild(popup.render());
      return this.container;
    }
  }]);

  return PopupAnnotationElement;
}(AnnotationElement);

var PopupElement = function () {
  function PopupElement(parameters) {
    _classCallCheck(this, PopupElement);

    this.container = parameters.container;
    this.trigger = parameters.trigger;
    this.color = parameters.color;
    this.title = parameters.title;
    this.contents = parameters.contents;
    this.hideWrapper = parameters.hideWrapper || false;
    this.pinned = false;
  }

  _createClass(PopupElement, [{
    key: 'render',
    value: function render() {
      var BACKGROUND_ENLIGHT = 0.7;
      var wrapper = document.createElement('div');
      wrapper.className = 'popupWrapper';
      this.hideElement = this.hideWrapper ? wrapper : this.container;
      this.hideElement.setAttribute('hidden', true);
      var popup = document.createElement('div');
      popup.className = 'popup';
      var color = this.color;
      if (color) {
        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
      }
      var contents = this._formatContents(this.contents);
      var title = document.createElement('h1');
      title.textContent = this.title;
      this.trigger.addEventListener('click', this._toggle.bind(this));
      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
      popup.addEventListener('click', this._hide.bind(this, true));
      popup.appendChild(title);
      popup.appendChild(contents);
      wrapper.appendChild(popup);
      return wrapper;
    }
  }, {
    key: '_formatContents',
    value: function _formatContents(contents) {
      var p = document.createElement('p');
      var lines = contents.split(/(?:\r\n?|\n)/);
      for (var i = 0, ii = lines.length; i < ii; ++i) {
        var line = lines[i];
        p.appendChild(document.createTextNode(line));
        if (i < ii - 1) {
          p.appendChild(document.createElement('br'));
        }
      }
      return p;
    }
  }, {
    key: '_toggle',
    value: function _toggle() {
      if (this.pinned) {
        this._hide(true);
      } else {
        this._show(true);
      }
    }
  }, {
    key: '_show',
    value: function _show() {
      var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (pin) {
        this.pinned = true;
      }
      if (this.hideElement.hasAttribute('hidden')) {
        this.hideElement.removeAttribute('hidden');
        this.container.style.zIndex += 1;
      }
    }
  }, {
    key: '_hide',
    value: function _hide() {
      var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (unpin) {
        this.pinned = false;
      }
      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
        this.hideElement.setAttribute('hidden', true);
        this.container.style.zIndex -= 1;
      }
    }
  }]);

  return PopupElement;
}();

var LineAnnotationElement = function (_AnnotationElement5) {
  _inherits(LineAnnotationElement, _AnnotationElement5);

  function LineAnnotationElement(parameters) {
    _classCallCheck(this, LineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (LineAnnotationElement.__proto__ || Object.getPrototypeOf(LineAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(LineAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'lineAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var line = this.svgFactory.createElement('svg:line');
      line.setAttribute('x1', data.rect[2] - data.lineCoordinates[0]);
      line.setAttribute('y1', data.rect[3] - data.lineCoordinates[1]);
      line.setAttribute('x2', data.rect[2] - data.lineCoordinates[2]);
      line.setAttribute('y2', data.rect[3] - data.lineCoordinates[3]);
      line.setAttribute('stroke-width', data.borderStyle.width);
      line.setAttribute('stroke', 'transparent');
      svg.appendChild(line);
      this.container.append(svg);
      this._createPopup(this.container, line, data);
      return this.container;
    }
  }]);

  return LineAnnotationElement;
}(AnnotationElement);

var SquareAnnotationElement = function (_AnnotationElement6) {
  _inherits(SquareAnnotationElement, _AnnotationElement6);

  function SquareAnnotationElement(parameters) {
    _classCallCheck(this, SquareAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (SquareAnnotationElement.__proto__ || Object.getPrototypeOf(SquareAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(SquareAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'squareAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var borderWidth = data.borderStyle.width;
      var square = this.svgFactory.createElement('svg:rect');
      square.setAttribute('x', borderWidth / 2);
      square.setAttribute('y', borderWidth / 2);
      square.setAttribute('width', width - borderWidth);
      square.setAttribute('height', height - borderWidth);
      square.setAttribute('stroke-width', borderWidth);
      square.setAttribute('stroke', 'transparent');
      square.setAttribute('fill', 'none');
      svg.appendChild(square);
      this.container.append(svg);
      this._createPopup(this.container, square, data);
      return this.container;
    }
  }]);

  return SquareAnnotationElement;
}(AnnotationElement);

var CircleAnnotationElement = function (_AnnotationElement7) {
  _inherits(CircleAnnotationElement, _AnnotationElement7);

  function CircleAnnotationElement(parameters) {
    _classCallCheck(this, CircleAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (CircleAnnotationElement.__proto__ || Object.getPrototypeOf(CircleAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(CircleAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'circleAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var borderWidth = data.borderStyle.width;
      var circle = this.svgFactory.createElement('svg:ellipse');
      circle.setAttribute('cx', width / 2);
      circle.setAttribute('cy', height / 2);
      circle.setAttribute('rx', width / 2 - borderWidth / 2);
      circle.setAttribute('ry', height / 2 - borderWidth / 2);
      circle.setAttribute('stroke-width', borderWidth);
      circle.setAttribute('stroke', 'transparent');
      circle.setAttribute('fill', 'none');
      svg.appendChild(circle);
      this.container.append(svg);
      this._createPopup(this.container, circle, data);
      return this.container;
    }
  }]);

  return CircleAnnotationElement;
}(AnnotationElement);

var PolylineAnnotationElement = function (_AnnotationElement8) {
  _inherits(PolylineAnnotationElement, _AnnotationElement8);

  function PolylineAnnotationElement(parameters) {
    _classCallCheck(this, PolylineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);

    var _this15 = _possibleConstructorReturn(this, (PolylineAnnotationElement.__proto__ || Object.getPrototypeOf(PolylineAnnotationElement)).call(this, parameters, isRenderable, true));

    _this15.containerClassName = 'polylineAnnotation';
    _this15.svgElementName = 'svg:polyline';
    return _this15;
  }

  _createClass(PolylineAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = this.containerClassName;
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var vertices = data.vertices;
      var points = [];
      for (var i = 0, ii = vertices.length; i < ii; i++) {
        var x = vertices[i].x - data.rect[0];
        var y = data.rect[3] - vertices[i].y;
        points.push(x + ',' + y);
      }
      points = points.join(' ');
      var borderWidth = data.borderStyle.width;
      var polyline = this.svgFactory.createElement(this.svgElementName);
      polyline.setAttribute('points', points);
      polyline.setAttribute('stroke-width', borderWidth);
      polyline.setAttribute('stroke', 'transparent');
      polyline.setAttribute('fill', 'none');
      svg.appendChild(polyline);
      this.container.append(svg);
      this._createPopup(this.container, polyline, data);
      return this.container;
    }
  }]);

  return PolylineAnnotationElement;
}(AnnotationElement);

var PolygonAnnotationElement = function (_PolylineAnnotationEl) {
  _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);

  function PolygonAnnotationElement(parameters) {
    _classCallCheck(this, PolygonAnnotationElement);

    var _this16 = _possibleConstructorReturn(this, (PolygonAnnotationElement.__proto__ || Object.getPrototypeOf(PolygonAnnotationElement)).call(this, parameters));

    _this16.containerClassName = 'polygonAnnotation';
    _this16.svgElementName = 'svg:polygon';
    return _this16;
  }

  return PolygonAnnotationElement;
}(PolylineAnnotationElement);

var HighlightAnnotationElement = function (_AnnotationElement9) {
  _inherits(HighlightAnnotationElement, _AnnotationElement9);

  function HighlightAnnotationElement(parameters) {
    _classCallCheck(this, HighlightAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (HighlightAnnotationElement.__proto__ || Object.getPrototypeOf(HighlightAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(HighlightAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'highlightAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return HighlightAnnotationElement;
}(AnnotationElement);

var UnderlineAnnotationElement = function (_AnnotationElement10) {
  _inherits(UnderlineAnnotationElement, _AnnotationElement10);

  function UnderlineAnnotationElement(parameters) {
    _classCallCheck(this, UnderlineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (UnderlineAnnotationElement.__proto__ || Object.getPrototypeOf(UnderlineAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(UnderlineAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'underlineAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return UnderlineAnnotationElement;
}(AnnotationElement);

var SquigglyAnnotationElement = function (_AnnotationElement11) {
  _inherits(SquigglyAnnotationElement, _AnnotationElement11);

  function SquigglyAnnotationElement(parameters) {
    _classCallCheck(this, SquigglyAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (SquigglyAnnotationElement.__proto__ || Object.getPrototypeOf(SquigglyAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(SquigglyAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'squigglyAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return SquigglyAnnotationElement;
}(AnnotationElement);

var StrikeOutAnnotationElement = function (_AnnotationElement12) {
  _inherits(StrikeOutAnnotationElement, _AnnotationElement12);

  function StrikeOutAnnotationElement(parameters) {
    _classCallCheck(this, StrikeOutAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (StrikeOutAnnotationElement.__proto__ || Object.getPrototypeOf(StrikeOutAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(StrikeOutAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'strikeoutAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return StrikeOutAnnotationElement;
}(AnnotationElement);

var StampAnnotationElement = function (_AnnotationElement13) {
  _inherits(StampAnnotationElement, _AnnotationElement13);

  function StampAnnotationElement(parameters) {
    _classCallCheck(this, StampAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (StampAnnotationElement.__proto__ || Object.getPrototypeOf(StampAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(StampAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'stampAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return StampAnnotationElement;
}(AnnotationElement);

var FileAttachmentAnnotationElement = function (_AnnotationElement14) {
  _inherits(FileAttachmentAnnotationElement, _AnnotationElement14);

  function FileAttachmentAnnotationElement(parameters) {
    _classCallCheck(this, FileAttachmentAnnotationElement);

    var _this22 = _possibleConstructorReturn(this, (FileAttachmentAnnotationElement.__proto__ || Object.getPrototypeOf(FileAttachmentAnnotationElement)).call(this, parameters, true));

    var file = _this22.data.file;
    _this22.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
    _this22.content = file.content;
    _this22.linkService.onFileAttachmentAnnotation({
      id: (0, _util.stringToPDFString)(file.filename),
      filename: file.filename,
      content: file.content
    });
    return _this22;
  }

  _createClass(FileAttachmentAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'fileAttachmentAnnotation';
      var trigger = document.createElement('div');
      trigger.style.height = this.container.style.height;
      trigger.style.width = this.container.style.width;
      trigger.addEventListener('dblclick', this._download.bind(this));
      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
        this._createPopup(this.container, trigger, this.data);
      }
      this.container.appendChild(trigger);
      return this.container;
    }
  }, {
    key: '_download',
    value: function _download() {
      if (!this.downloadManager) {
        (0, _util.warn)('Download cannot be started due to unavailable download manager');
        return;
      }
      this.downloadManager.downloadData(this.content, this.filename, '');
    }
  }]);

  return FileAttachmentAnnotationElement;
}(AnnotationElement);

var AnnotationLayer = function () {
  function AnnotationLayer() {
    _classCallCheck(this, AnnotationLayer);
  }

  _createClass(AnnotationLayer, null, [{
    key: 'render',
    value: function render(parameters) {
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        if (!data) {
          continue;
        }
        var element = AnnotationElementFactory.create({
          data: data,
          layer: parameters.div,
          page: parameters.page,
          viewport: parameters.viewport,
          linkService: parameters.linkService,
          downloadManager: parameters.downloadManager,
          imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)('imageResourcesPath'),
          renderInteractiveForms: parameters.renderInteractiveForms || false,
          svgFactory: new _dom_utils.DOMSVGFactory()
        });
        if (element.isRenderable) {
          parameters.div.appendChild(element.render());
        }
      }
    }
  }, {
    key: 'update',
    value: function update(parameters) {
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
        if (element) {
          element.style.transform = 'matrix(' + parameters.viewport.transform.join(',') + ')';
        }
      }
      parameters.div.removeAttribute('hidden');
    }
  }]);

  return AnnotationLayer;
}();

exports.AnnotationLayer = AnnotationLayer;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTextLayer = undefined;

var _util = __webpack_require__(73);

var _dom_utils = __webpack_require__(204);

var renderTextLayer = function renderTextLayerClosure() {
  var MAX_TEXT_DIVS_TO_RENDER = 100000;
  var NonWhitespaceRegexp = /\S/;
  function isAllWhitespace(str) {
    return !NonWhitespaceRegexp.test(str);
  }
  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
  function appendText(task, geom, styles) {
    var textDiv = document.createElement('div');
    var textDivProperties = {
      style: null,
      angle: 0,
      canvasWidth: 0,
      isWhitespace: false,
      originalTransform: null,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      scale: 1
    };
    task._textDivs.push(textDiv);
    if (isAllWhitespace(geom.str)) {
      textDivProperties.isWhitespace = true;
      task._textDivProperties.set(textDiv, textDivProperties);
      return;
    }
    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
    var angle = Math.atan2(tx[1], tx[0]);
    var style = styles[geom.fontName];
    if (style.vertical) {
      angle += Math.PI / 2;
    }
    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
    var fontAscent = fontHeight;
    if (style.ascent) {
      fontAscent = style.ascent * fontAscent;
    } else if (style.descent) {
      fontAscent = (1 + style.descent) * fontAscent;
    }
    var left;
    var top;
    if (angle === 0) {
      left = tx[4];
      top = tx[5] - fontAscent;
    } else {
      left = tx[4] + fontAscent * Math.sin(angle);
      top = tx[5] - fontAscent * Math.cos(angle);
    }
    styleBuf[1] = left;
    styleBuf[3] = top;
    styleBuf[5] = fontHeight;
    styleBuf[7] = style.fontFamily;
    textDivProperties.style = styleBuf.join('');
    textDiv.setAttribute('style', textDivProperties.style);
    textDiv.textContent = geom.str;
    if ((0, _dom_utils.getDefaultSetting)('pdfBug')) {
      textDiv.dataset.fontName = geom.fontName;
    }
    if (angle !== 0) {
      textDivProperties.angle = angle * (180 / Math.PI);
    }
    if (geom.str.length > 1) {
      if (style.vertical) {
        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
      } else {
        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
      }
    }
    task._textDivProperties.set(textDiv, textDivProperties);
    if (task._textContentStream) {
      task._layoutText(textDiv);
    }
    if (task._enhanceTextSelection) {
      var angleCos = 1,
          angleSin = 0;
      if (angle !== 0) {
        angleCos = Math.cos(angle);
        angleSin = Math.sin(angle);
      }
      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
      var divHeight = fontHeight;
      var m, b;
      if (angle !== 0) {
        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
      } else {
        b = [left, top, left + divWidth, top + divHeight];
      }
      task._bounds.push({
        left: b[0],
        top: b[1],
        right: b[2],
        bottom: b[3],
        div: textDiv,
        size: [divWidth, divHeight],
        m: m
      });
    }
  }
  function render(task) {
    if (task._canceled) {
      return;
    }
    var textDivs = task._textDivs;
    var capability = task._capability;
    var textDivsLength = textDivs.length;
    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
      task._renderingDone = true;
      capability.resolve();
      return;
    }
    if (!task._textContentStream) {
      for (var i = 0; i < textDivsLength; i++) {
        task._layoutText(textDivs[i]);
      }
    }
    task._renderingDone = true;
    capability.resolve();
  }
  function expand(task) {
    var bounds = task._bounds;
    var viewport = task._viewport;
    var expanded = expandBounds(viewport.width, viewport.height, bounds);
    for (var i = 0; i < expanded.length; i++) {
      var div = bounds[i].div;
      var divProperties = task._textDivProperties.get(div);
      if (divProperties.angle === 0) {
        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
        divProperties.paddingTop = bounds[i].top - expanded[i].top;
        divProperties.paddingRight = expanded[i].right - bounds[i].right;
        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
        task._textDivProperties.set(div, divProperties);
        continue;
      }
      var e = expanded[i],
          b = bounds[i];
      var m = b.m,
          c = m[0],
          s = m[1];
      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
      var ts = new Float64Array(64);
      points.forEach(function (p, i) {
        var t = _util.Util.applyTransform(p, m);
        ts[i + 0] = c && (e.left - t[0]) / c;
        ts[i + 4] = s && (e.top - t[1]) / s;
        ts[i + 8] = c && (e.right - t[0]) / c;
        ts[i + 12] = s && (e.bottom - t[1]) / s;
        ts[i + 16] = s && (e.left - t[0]) / -s;
        ts[i + 20] = c && (e.top - t[1]) / c;
        ts[i + 24] = s && (e.right - t[0]) / -s;
        ts[i + 28] = c && (e.bottom - t[1]) / c;
        ts[i + 32] = c && (e.left - t[0]) / -c;
        ts[i + 36] = s && (e.top - t[1]) / -s;
        ts[i + 40] = c && (e.right - t[0]) / -c;
        ts[i + 44] = s && (e.bottom - t[1]) / -s;
        ts[i + 48] = s && (e.left - t[0]) / s;
        ts[i + 52] = c && (e.top - t[1]) / -c;
        ts[i + 56] = s && (e.right - t[0]) / s;
        ts[i + 60] = c && (e.bottom - t[1]) / -c;
      });
      var findPositiveMin = function findPositiveMin(ts, offset, count) {
        var result = 0;
        for (var i = 0; i < count; i++) {
          var t = ts[offset++];
          if (t > 0) {
            result = result ? Math.min(t, result) : t;
          }
        }
        return result;
      };
      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
      task._textDivProperties.set(div, divProperties);
    }
  }
  function expandBounds(width, height, boxes) {
    var bounds = boxes.map(function (box, i) {
      return {
        x1: box.left,
        y1: box.top,
        x2: box.right,
        y2: box.bottom,
        index: i,
        x1New: undefined,
        x2New: undefined
      };
    });
    expandBoundsLTR(width, bounds);
    var expanded = new Array(boxes.length);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i] = {
        left: b.x1New,
        top: 0,
        right: b.x2New,
        bottom: 0
      };
    });
    boxes.map(function (box, i) {
      var e = expanded[i],
          b = bounds[i];
      b.x1 = box.top;
      b.y1 = width - e.right;
      b.x2 = box.bottom;
      b.y2 = width - e.left;
      b.index = i;
      b.x1New = undefined;
      b.x2New = undefined;
    });
    expandBoundsLTR(height, bounds);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i].top = b.x1New;
      expanded[i].bottom = b.x2New;
    });
    return expanded;
  }
  function expandBoundsLTR(width, bounds) {
    bounds.sort(function (a, b) {
      return a.x1 - b.x1 || a.index - b.index;
    });
    var fakeBoundary = {
      x1: -Infinity,
      y1: -Infinity,
      x2: 0,
      y2: Infinity,
      index: -1,
      x1New: 0,
      x2New: 0
    };
    var horizon = [{
      start: -Infinity,
      end: Infinity,
      boundary: fakeBoundary
    }];
    bounds.forEach(function (boundary) {
      var i = 0;
      while (i < horizon.length && horizon[i].end <= boundary.y1) {
        i++;
      }
      var j = horizon.length - 1;
      while (j >= 0 && horizon[j].start >= boundary.y2) {
        j--;
      }
      var horizonPart, affectedBoundary;
      var q,
          k,
          maxXNew = -Infinity;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var xNew;
        if (affectedBoundary.x2 > boundary.x1) {
          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
        } else if (affectedBoundary.x2New === undefined) {
          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
        } else {
          xNew = affectedBoundary.x2New;
        }
        if (xNew > maxXNew) {
          maxXNew = xNew;
        }
      }
      boundary.x1New = maxXNew;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        if (affectedBoundary.x2New === undefined) {
          if (affectedBoundary.x2 > boundary.x1) {
            if (affectedBoundary.index > boundary.index) {
              affectedBoundary.x2New = affectedBoundary.x2;
            }
          } else {
            affectedBoundary.x2New = maxXNew;
          }
        } else if (affectedBoundary.x2New > maxXNew) {
          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
        }
      }
      var changedHorizon = [],
          lastBoundary = null;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
        if (lastBoundary === useBoundary) {
          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
        } else {
          changedHorizon.push({
            start: horizonPart.start,
            end: horizonPart.end,
            boundary: useBoundary
          });
          lastBoundary = useBoundary;
        }
      }
      if (horizon[i].start < boundary.y1) {
        changedHorizon[0].start = boundary.y1;
        changedHorizon.unshift({
          start: horizon[i].start,
          end: boundary.y1,
          boundary: horizon[i].boundary
        });
      }
      if (boundary.y2 < horizon[j].end) {
        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
        changedHorizon.push({
          start: boundary.y2,
          end: horizon[j].end,
          boundary: horizon[j].boundary
        });
      }
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        if (affectedBoundary.x2New !== undefined) {
          continue;
        }
        var used = false;
        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
          used = horizon[k].boundary === affectedBoundary;
        }
        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
          used = horizon[k].boundary === affectedBoundary;
        }
        for (k = 0; !used && k < changedHorizon.length; k++) {
          used = changedHorizon[k].boundary === affectedBoundary;
        }
        if (!used) {
          affectedBoundary.x2New = maxXNew;
        }
      }
      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
    });
    horizon.forEach(function (horizonPart) {
      var affectedBoundary = horizonPart.boundary;
      if (affectedBoundary.x2New === undefined) {
        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
      }
    });
  }
  function TextLayerRenderTask(_ref) {
    var textContent = _ref.textContent,
        textContentStream = _ref.textContentStream,
        container = _ref.container,
        viewport = _ref.viewport,
        textDivs = _ref.textDivs,
        textContentItemsStr = _ref.textContentItemsStr,
        enhanceTextSelection = _ref.enhanceTextSelection;

    this._textContent = textContent;
    this._textContentStream = textContentStream;
    this._container = container;
    this._viewport = viewport;
    this._textDivs = textDivs || [];
    this._textContentItemsStr = textContentItemsStr || [];
    this._enhanceTextSelection = !!enhanceTextSelection;
    this._reader = null;
    this._layoutTextLastFontSize = null;
    this._layoutTextLastFontFamily = null;
    this._layoutTextCtx = null;
    this._textDivProperties = new WeakMap();
    this._renderingDone = false;
    this._canceled = false;
    this._capability = (0, _util.createPromiseCapability)();
    this._renderTimer = null;
    this._bounds = [];
  }
  TextLayerRenderTask.prototype = {
    get promise() {
      return this._capability.promise;
    },
    cancel: function TextLayer_cancel() {
      if (this._reader) {
        this._reader.cancel(new _util.AbortException('text layer task cancelled'));
        this._reader = null;
      }
      this._canceled = true;
      if (this._renderTimer !== null) {
        clearTimeout(this._renderTimer);
        this._renderTimer = null;
      }
      this._capability.reject('canceled');
    },
    _processItems: function _processItems(items, styleCache) {
      for (var i = 0, len = items.length; i < len; i++) {
        this._textContentItemsStr.push(items[i].str);
        appendText(this, items[i], styleCache);
      }
    },
    _layoutText: function _layoutText(textDiv) {
      var textLayerFrag = this._container;
      var textDivProperties = this._textDivProperties.get(textDiv);
      if (textDivProperties.isWhitespace) {
        return;
      }
      var fontSize = textDiv.style.fontSize;
      var fontFamily = textDiv.style.fontFamily;
      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
        this._lastFontSize = fontSize;
        this._lastFontFamily = fontFamily;
      }
      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
      var transform = '';
      if (textDivProperties.canvasWidth !== 0 && width > 0) {
        textDivProperties.scale = textDivProperties.canvasWidth / width;
        transform = 'scaleX(' + textDivProperties.scale + ')';
      }
      if (textDivProperties.angle !== 0) {
        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
      }
      if (transform !== '') {
        textDivProperties.originalTransform = transform;
        textDiv.style.transform = transform;
      }
      this._textDivProperties.set(textDiv, textDivProperties);
      textLayerFrag.appendChild(textDiv);
    },

    _render: function TextLayer_render(timeout) {
      var _this = this;

      var capability = (0, _util.createPromiseCapability)();
      var styleCache = Object.create(null);
      var canvas = document.createElement('canvas');
      canvas.mozOpaque = true;
      this._layoutTextCtx = canvas.getContext('2d', { alpha: false });
      if (this._textContent) {
        var textItems = this._textContent.items;
        var textStyles = this._textContent.styles;
        this._processItems(textItems, textStyles);
        capability.resolve();
      } else if (this._textContentStream) {
        var pump = function pump() {
          _this._reader.read().then(function (_ref2) {
            var value = _ref2.value,
                done = _ref2.done;

            if (done) {
              capability.resolve();
              return;
            }
            _util.Util.extendObj(styleCache, value.styles);
            _this._processItems(value.items, styleCache);
            pump();
          }, capability.reject);
        };
        this._reader = this._textContentStream.getReader();
        pump();
      } else {
        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
      }
      capability.promise.then(function () {
        styleCache = null;
        if (!timeout) {
          render(_this);
        } else {
          _this._renderTimer = setTimeout(function () {
            render(_this);
            _this._renderTimer = null;
          }, timeout);
        }
      }, this._capability.reject);
    },
    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
      if (!this._enhanceTextSelection || !this._renderingDone) {
        return;
      }
      if (this._bounds !== null) {
        expand(this);
        this._bounds = null;
      }
      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
        var div = this._textDivs[i];
        var divProperties = this._textDivProperties.get(div);
        if (divProperties.isWhitespace) {
          continue;
        }
        if (expandDivs) {
          var transform = '',
              padding = '';
          if (divProperties.scale !== 1) {
            transform = 'scaleX(' + divProperties.scale + ')';
          }
          if (divProperties.angle !== 0) {
            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
          }
          if (divProperties.paddingLeft !== 0) {
            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
          }
          if (divProperties.paddingTop !== 0) {
            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
          }
          if (divProperties.paddingRight !== 0) {
            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
          }
          if (divProperties.paddingBottom !== 0) {
            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
          }
          if (padding !== '') {
            div.setAttribute('style', divProperties.style + padding);
          }
          if (transform !== '') {
            div.style.transform = transform;
          }
        } else {
          div.style.padding = 0;
          div.style.transform = divProperties.originalTransform || '';
        }
      }
    }
  };
  function renderTextLayer(renderParameters) {
    var task = new TextLayerRenderTask({
      textContent: renderParameters.textContent,
      textContentStream: renderParameters.textContentStream,
      container: renderParameters.container,
      viewport: renderParameters.viewport,
      textDivs: renderParameters.textDivs,
      textContentItemsStr: renderParameters.textContentItemsStr,
      enhanceTextSelection: renderParameters.enhanceTextSelection
    });
    task._render(renderParameters.timeout);
    return task;
  }
  return renderTextLayer;
}();
exports.renderTextLayer = renderTextLayer;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, Buffer) {/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVGGraphics = undefined;

var _util = __webpack_require__(73);

var _dom_utils = __webpack_require__(204);

var _is_node = __webpack_require__(405);

var _is_node2 = _interopRequireDefault(_is_node);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVGGraphics = function SVGGraphics() {
  throw new Error('Not implemented: SVGGraphics');
};
{
  var SVG_DEFAULTS = {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fillColor: '#000000'
  };
  var convertImgDataToPng = function convertImgDataToPngClosure() {
    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
    var CHUNK_WRAPPER_SIZE = 12;
    var crcTable = new Int32Array(256);
    for (var i = 0; i < 256; i++) {
      var c = i;
      for (var h = 0; h < 8; h++) {
        if (c & 1) {
          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
        } else {
          c = c >> 1 & 0x7fffffff;
        }
      }
      crcTable[i] = c;
    }
    function crc32(data, start, end) {
      var crc = -1;
      for (var i = start; i < end; i++) {
        var a = (crc ^ data[i]) & 0xff;
        var b = crcTable[a];
        crc = crc >>> 8 ^ b;
      }
      return crc ^ -1;
    }
    function writePngChunk(type, body, data, offset) {
      var p = offset;
      var len = body.length;
      data[p] = len >> 24 & 0xff;
      data[p + 1] = len >> 16 & 0xff;
      data[p + 2] = len >> 8 & 0xff;
      data[p + 3] = len & 0xff;
      p += 4;
      data[p] = type.charCodeAt(0) & 0xff;
      data[p + 1] = type.charCodeAt(1) & 0xff;
      data[p + 2] = type.charCodeAt(2) & 0xff;
      data[p + 3] = type.charCodeAt(3) & 0xff;
      p += 4;
      data.set(body, p);
      p += body.length;
      var crc = crc32(data, offset + 4, p);
      data[p] = crc >> 24 & 0xff;
      data[p + 1] = crc >> 16 & 0xff;
      data[p + 2] = crc >> 8 & 0xff;
      data[p + 3] = crc & 0xff;
    }
    function adler32(data, start, end) {
      var a = 1;
      var b = 0;
      for (var i = start; i < end; ++i) {
        a = (a + (data[i] & 0xff)) % 65521;
        b = (b + a) % 65521;
      }
      return b << 16 | a;
    }
    function deflateSync(literals) {
      if (!(0, _is_node2.default)()) {
        return deflateSyncUncompressed(literals);
      }
      try {
        var input;
        if (parseInt(process.versions.node) >= 8) {
          input = literals;
        } else {
          input = new Buffer(literals);
        }
        var output = __webpack_require__(1039).deflateSync(input, { level: 9 });
        return output instanceof Uint8Array ? output : new Uint8Array(output);
      } catch (e) {
        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
      }
      return deflateSyncUncompressed(literals);
    }
    function deflateSyncUncompressed(literals) {
      var len = literals.length;
      var maxBlockLength = 0xFFFF;
      var deflateBlocks = Math.ceil(len / maxBlockLength);
      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
      var pi = 0;
      idat[pi++] = 0x78;
      idat[pi++] = 0x9c;
      var pos = 0;
      while (len > maxBlockLength) {
        idat[pi++] = 0x00;
        idat[pi++] = 0xff;
        idat[pi++] = 0xff;
        idat[pi++] = 0x00;
        idat[pi++] = 0x00;
        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
        pi += maxBlockLength;
        pos += maxBlockLength;
        len -= maxBlockLength;
      }
      idat[pi++] = 0x01;
      idat[pi++] = len & 0xff;
      idat[pi++] = len >> 8 & 0xff;
      idat[pi++] = ~len & 0xffff & 0xff;
      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
      idat.set(literals.subarray(pos), pi);
      pi += literals.length - pos;
      var adler = adler32(literals, 0, literals.length);
      idat[pi++] = adler >> 24 & 0xff;
      idat[pi++] = adler >> 16 & 0xff;
      idat[pi++] = adler >> 8 & 0xff;
      idat[pi++] = adler & 0xff;
      return idat;
    }
    function encode(imgData, kind, forceDataSchema, isMask) {
      var width = imgData.width;
      var height = imgData.height;
      var bitDepth, colorType, lineSize;
      var bytes = imgData.data;
      switch (kind) {
        case _util.ImageKind.GRAYSCALE_1BPP:
          colorType = 0;
          bitDepth = 1;
          lineSize = width + 7 >> 3;
          break;
        case _util.ImageKind.RGB_24BPP:
          colorType = 2;
          bitDepth = 8;
          lineSize = width * 3;
          break;
        case _util.ImageKind.RGBA_32BPP:
          colorType = 6;
          bitDepth = 8;
          lineSize = width * 4;
          break;
        default:
          throw new Error('invalid format');
      }
      var literals = new Uint8Array((1 + lineSize) * height);
      var offsetLiterals = 0,
          offsetBytes = 0;
      var y, i;
      for (y = 0; y < height; ++y) {
        literals[offsetLiterals++] = 0;
        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
        offsetBytes += lineSize;
        offsetLiterals += lineSize;
      }
      if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
        offsetLiterals = 0;
        for (y = 0; y < height; y++) {
          offsetLiterals++;
          for (i = 0; i < lineSize; i++) {
            literals[offsetLiterals++] ^= 0xFF;
          }
        }
      }
      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
      var idat = deflateSync(literals);
      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
      var data = new Uint8Array(pngLength);
      var offset = 0;
      data.set(PNG_HEADER, offset);
      offset += PNG_HEADER.length;
      writePngChunk('IHDR', ihdr, data, offset);
      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
      writePngChunk('IDATA', idat, data, offset);
      offset += CHUNK_WRAPPER_SIZE + idat.length;
      writePngChunk('IEND', new Uint8Array(0), data, offset);
      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
    }
    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
      return encode(imgData, kind, forceDataSchema, isMask);
    };
  }();
  var SVGExtraState = function SVGExtraStateClosure() {
    function SVGExtraState() {
      this.fontSizeScale = 1;
      this.fontWeight = SVG_DEFAULTS.fontWeight;
      this.fontSize = 0;
      this.textMatrix = _util.IDENTITY_MATRIX;
      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
      this.leading = 0;
      this.x = 0;
      this.y = 0;
      this.lineX = 0;
      this.lineY = 0;
      this.charSpacing = 0;
      this.wordSpacing = 0;
      this.textHScale = 1;
      this.textRise = 0;
      this.fillColor = SVG_DEFAULTS.fillColor;
      this.strokeColor = '#000000';
      this.fillAlpha = 1;
      this.strokeAlpha = 1;
      this.lineWidth = 1;
      this.lineJoin = '';
      this.lineCap = '';
      this.miterLimit = 0;
      this.dashArray = [];
      this.dashPhase = 0;
      this.dependencies = [];
      this.activeClipUrl = null;
      this.clipGroup = null;
      this.maskId = '';
    }
    SVGExtraState.prototype = {
      clone: function SVGExtraState_clone() {
        return Object.create(this);
      },
      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
        this.x = x;
        this.y = y;
      }
    };
    return SVGExtraState;
  }();
  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
    function opListToTree(opList) {
      var opTree = [];
      var tmp = [];
      var opListLen = opList.length;
      for (var x = 0; x < opListLen; x++) {
        if (opList[x].fn === 'save') {
          opTree.push({
            'fnId': 92,
            'fn': 'group',
            'items': []
          });
          tmp.push(opTree);
          opTree = opTree[opTree.length - 1].items;
          continue;
        }
        if (opList[x].fn === 'restore') {
          opTree = tmp.pop();
        } else {
          opTree.push(opList[x]);
        }
      }
      return opTree;
    }
    function pf(value) {
      if (Number.isInteger(value)) {
        return value.toString();
      }
      var s = value.toFixed(10);
      var i = s.length - 1;
      if (s[i] !== '0') {
        return s;
      }
      do {
        i--;
      } while (s[i] === '0');
      return s.substr(0, s[i] === '.' ? i : i + 1);
    }
    function pm(m) {
      if (m[4] === 0 && m[5] === 0) {
        if (m[1] === 0 && m[2] === 0) {
          if (m[0] === 1 && m[3] === 1) {
            return '';
          }
          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
        }
        if (m[0] === m[3] && m[1] === -m[2]) {
          var a = Math.acos(m[0]) * 180 / Math.PI;
          return 'rotate(' + pf(a) + ')';
        }
      } else {
        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
        }
      }
      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
    }
    function SVGGraphics(commonObjs, objs, forceDataSchema) {
      this.svgFactory = new _dom_utils.DOMSVGFactory();
      this.current = new SVGExtraState();
      this.transformMatrix = _util.IDENTITY_MATRIX;
      this.transformStack = [];
      this.extraStack = [];
      this.commonObjs = commonObjs;
      this.objs = objs;
      this.pendingClip = null;
      this.pendingEOFill = false;
      this.embedFonts = false;
      this.embeddedFonts = Object.create(null);
      this.cssStyle = null;
      this.forceDataSchema = !!forceDataSchema;
    }
    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
    var XLINK_NS = 'http://www.w3.org/1999/xlink';
    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
    var clipCount = 0;
    var maskCount = 0;
    SVGGraphics.prototype = {
      save: function SVGGraphics_save() {
        this.transformStack.push(this.transformMatrix);
        var old = this.current;
        this.extraStack.push(old);
        this.current = old.clone();
      },
      restore: function SVGGraphics_restore() {
        this.transformMatrix = this.transformStack.pop();
        this.current = this.extraStack.pop();
        this.pendingClip = null;
        this.tgrp = null;
      },
      group: function SVGGraphics_group(items) {
        this.save();
        this.executeOpTree(items);
        this.restore();
      },
      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
        var _this = this;

        var fnArray = operatorList.fnArray;
        var fnArrayLen = fnArray.length;
        var argsArray = operatorList.argsArray;
        for (var i = 0; i < fnArrayLen; i++) {
          if (_util.OPS.dependency === fnArray[i]) {
            var deps = argsArray[i];
            for (var n = 0, nn = deps.length; n < nn; n++) {
              var obj = deps[n];
              var common = obj.substring(0, 2) === 'g_';
              var promise;
              if (common) {
                promise = new Promise(function (resolve) {
                  _this.commonObjs.get(obj, resolve);
                });
              } else {
                promise = new Promise(function (resolve) {
                  _this.objs.get(obj, resolve);
                });
              }
              this.current.dependencies.push(promise);
            }
          }
        }
        return Promise.all(this.current.dependencies);
      },
      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
        var transformMatrix = [a, b, c, d, e, f];
        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
        this.tgrp = null;
      },
      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
        var _this2 = this;

        this.viewport = viewport;
        var svgElement = this._initialize(viewport);
        return this.loadDependencies(operatorList).then(function () {
          _this2.transformMatrix = _util.IDENTITY_MATRIX;
          var opTree = _this2.convertOpList(operatorList);
          _this2.executeOpTree(opTree);
          return svgElement;
        });
      },
      convertOpList: function SVGGraphics_convertOpList(operatorList) {
        var argsArray = operatorList.argsArray;
        var fnArray = operatorList.fnArray;
        var fnArrayLen = fnArray.length;
        var REVOPS = [];
        var opList = [];
        for (var op in _util.OPS) {
          REVOPS[_util.OPS[op]] = op;
        }
        for (var x = 0; x < fnArrayLen; x++) {
          var fnId = fnArray[x];
          opList.push({
            'fnId': fnId,
            'fn': REVOPS[fnId],
            'args': argsArray[x]
          });
        }
        return opListToTree(opList);
      },
      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
        var opTreeLen = opTree.length;
        for (var x = 0; x < opTreeLen; x++) {
          var fn = opTree[x].fn;
          var fnId = opTree[x].fnId;
          var args = opTree[x].args;
          switch (fnId | 0) {
            case _util.OPS.beginText:
              this.beginText();
              break;
            case _util.OPS.setLeading:
              this.setLeading(args);
              break;
            case _util.OPS.setLeadingMoveText:
              this.setLeadingMoveText(args[0], args[1]);
              break;
            case _util.OPS.setFont:
              this.setFont(args);
              break;
            case _util.OPS.showText:
              this.showText(args[0]);
              break;
            case _util.OPS.showSpacedText:
              this.showText(args[0]);
              break;
            case _util.OPS.endText:
              this.endText();
              break;
            case _util.OPS.moveText:
              this.moveText(args[0], args[1]);
              break;
            case _util.OPS.setCharSpacing:
              this.setCharSpacing(args[0]);
              break;
            case _util.OPS.setWordSpacing:
              this.setWordSpacing(args[0]);
              break;
            case _util.OPS.setHScale:
              this.setHScale(args[0]);
              break;
            case _util.OPS.setTextMatrix:
              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
              break;
            case _util.OPS.setTextRise:
              this.setTextRise(args[0]);
              break;
            case _util.OPS.setLineWidth:
              this.setLineWidth(args[0]);
              break;
            case _util.OPS.setLineJoin:
              this.setLineJoin(args[0]);
              break;
            case _util.OPS.setLineCap:
              this.setLineCap(args[0]);
              break;
            case _util.OPS.setMiterLimit:
              this.setMiterLimit(args[0]);
              break;
            case _util.OPS.setFillRGBColor:
              this.setFillRGBColor(args[0], args[1], args[2]);
              break;
            case _util.OPS.setStrokeRGBColor:
              this.setStrokeRGBColor(args[0], args[1], args[2]);
              break;
            case _util.OPS.setDash:
              this.setDash(args[0], args[1]);
              break;
            case _util.OPS.setGState:
              this.setGState(args[0]);
              break;
            case _util.OPS.fill:
              this.fill();
              break;
            case _util.OPS.eoFill:
              this.eoFill();
              break;
            case _util.OPS.stroke:
              this.stroke();
              break;
            case _util.OPS.fillStroke:
              this.fillStroke();
              break;
            case _util.OPS.eoFillStroke:
              this.eoFillStroke();
              break;
            case _util.OPS.clip:
              this.clip('nonzero');
              break;
            case _util.OPS.eoClip:
              this.clip('evenodd');
              break;
            case _util.OPS.paintSolidColorImageMask:
              this.paintSolidColorImageMask();
              break;
            case _util.OPS.paintJpegXObject:
              this.paintJpegXObject(args[0], args[1], args[2]);
              break;
            case _util.OPS.paintImageXObject:
              this.paintImageXObject(args[0]);
              break;
            case _util.OPS.paintInlineImageXObject:
              this.paintInlineImageXObject(args[0]);
              break;
            case _util.OPS.paintImageMaskXObject:
              this.paintImageMaskXObject(args[0]);
              break;
            case _util.OPS.paintFormXObjectBegin:
              this.paintFormXObjectBegin(args[0], args[1]);
              break;
            case _util.OPS.paintFormXObjectEnd:
              this.paintFormXObjectEnd();
              break;
            case _util.OPS.closePath:
              this.closePath();
              break;
            case _util.OPS.closeStroke:
              this.closeStroke();
              break;
            case _util.OPS.closeFillStroke:
              this.closeFillStroke();
              break;
            case _util.OPS.closeEOFillStroke:
              this.closeEOFillStroke();
              break;
            case _util.OPS.nextLine:
              this.nextLine();
              break;
            case _util.OPS.transform:
              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
              break;
            case _util.OPS.constructPath:
              this.constructPath(args[0], args[1]);
              break;
            case _util.OPS.endPath:
              this.endPath();
              break;
            case 92:
              this.group(opTree[x].items);
              break;
            default:
              (0, _util.warn)('Unimplemented operator ' + fn);
              break;
          }
        }
      },
      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
        this.current.wordSpacing = wordSpacing;
      },
      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
        this.current.charSpacing = charSpacing;
      },
      nextLine: function SVGGraphics_nextLine() {
        this.moveText(0, this.current.leading);
      },
      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
        var current = this.current;
        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        current.xcoords = [];
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.txtElement = this.svgFactory.createElement('svg:text');
        current.txtElement.appendChild(current.tspan);
      },
      beginText: function SVGGraphics_beginText() {
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        this.current.textMatrix = _util.IDENTITY_MATRIX;
        this.current.lineMatrix = _util.IDENTITY_MATRIX;
        this.current.tspan = this.svgFactory.createElement('svg:tspan');
        this.current.txtElement = this.svgFactory.createElement('svg:text');
        this.current.txtgrp = this.svgFactory.createElement('svg:g');
        this.current.xcoords = [];
      },
      moveText: function SVGGraphics_moveText(x, y) {
        var current = this.current;
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
        current.xcoords = [];
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
      },
      showText: function SVGGraphics_showText(glyphs) {
        var current = this.current;
        var font = current.font;
        var fontSize = current.fontSize;
        if (fontSize === 0) {
          return;
        }
        var charSpacing = current.charSpacing;
        var wordSpacing = current.wordSpacing;
        var fontDirection = current.fontDirection;
        var textHScale = current.textHScale * fontDirection;
        var glyphsLength = glyphs.length;
        var vertical = font.vertical;
        var widthAdvanceScale = fontSize * current.fontMatrix[0];
        var x = 0,
            i;
        for (i = 0; i < glyphsLength; ++i) {
          var glyph = glyphs[i];
          if (glyph === null) {
            x += fontDirection * wordSpacing;
            continue;
          } else if ((0, _util.isNum)(glyph)) {
            x += -glyph * fontSize * 0.001;
            continue;
          }
          var width = glyph.width;
          var character = glyph.fontChar;
          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
          if (!glyph.isInFont && !font.missingFile) {
            x += charWidth;
            continue;
          }
          current.xcoords.push(current.x + x * textHScale);
          current.tspan.textContent += character;
          x += charWidth;
        }
        if (vertical) {
          current.y -= x * textHScale;
        } else {
          current.x += x * textHScale;
        }
        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
        }
        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
        }
        if (current.fillColor !== SVG_DEFAULTS.fillColor) {
          current.tspan.setAttributeNS(null, 'fill', current.fillColor);
        }
        var textMatrix = current.textMatrix;
        if (current.textRise !== 0) {
          textMatrix = textMatrix.slice();
          textMatrix[5] += current.textRise;
        }
        current.txtElement.setAttributeNS(null, 'transform', pm(textMatrix) + ' scale(1, -1)');
        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
        current.txtElement.appendChild(current.tspan);
        current.txtgrp.appendChild(current.txtElement);
        this._ensureTransformGroup().appendChild(current.txtElement);
      },
      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
        this.setLeading(-y);
        this.moveText(x, y);
      },
      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
        if (!this.cssStyle) {
          this.cssStyle = this.svgFactory.createElement('svg:style');
          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
          this.defs.appendChild(this.cssStyle);
        }
        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
      },
      setFont: function SVGGraphics_setFont(details) {
        var current = this.current;
        var fontObj = this.commonObjs.get(details[0]);
        var size = details[1];
        this.current.font = fontObj;
        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
          this.addFontStyle(fontObj);
          this.embeddedFonts[fontObj.loadedName] = fontObj;
        }
        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
        var italic = fontObj.italic ? 'italic' : 'normal';
        if (size < 0) {
          size = -size;
          current.fontDirection = -1;
        } else {
          current.fontDirection = 1;
        }
        current.fontSize = size;
        current.fontFamily = fontObj.loadedName;
        current.fontWeight = bold;
        current.fontStyle = italic;
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.xcoords = [];
      },
      endText: function SVGGraphics_endText() {},
      setLineWidth: function SVGGraphics_setLineWidth(width) {
        this.current.lineWidth = width;
      },
      setLineCap: function SVGGraphics_setLineCap(style) {
        this.current.lineCap = LINE_CAP_STYLES[style];
      },
      setLineJoin: function SVGGraphics_setLineJoin(style) {
        this.current.lineJoin = LINE_JOIN_STYLES[style];
      },
      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
        this.current.miterLimit = limit;
      },
      setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
        this.current.strokeAlpha = strokeAlpha;
      },
      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
        var color = _util.Util.makeCssRgb(r, g, b);
        this.current.strokeColor = color;
      },
      setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
        this.current.fillAlpha = fillAlpha;
      },
      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
        var color = _util.Util.makeCssRgb(r, g, b);
        this.current.fillColor = color;
        this.current.tspan = this.svgFactory.createElement('svg:tspan');
        this.current.xcoords = [];
      },
      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
        this.current.dashArray = dashArray;
        this.current.dashPhase = dashPhase;
      },
      constructPath: function SVGGraphics_constructPath(ops, args) {
        var current = this.current;
        var x = current.x,
            y = current.y;
        current.path = this.svgFactory.createElement('svg:path');
        var d = [];
        var opLength = ops.length;
        for (var i = 0, j = 0; i < opLength; i++) {
          switch (ops[i] | 0) {
            case _util.OPS.rectangle:
              x = args[j++];
              y = args[j++];
              var width = args[j++];
              var height = args[j++];
              var xw = x + width;
              var yh = y + height;
              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
              break;
            case _util.OPS.moveTo:
              x = args[j++];
              y = args[j++];
              d.push('M', pf(x), pf(y));
              break;
            case _util.OPS.lineTo:
              x = args[j++];
              y = args[j++];
              d.push('L', pf(x), pf(y));
              break;
            case _util.OPS.curveTo:
              x = args[j + 4];
              y = args[j + 5];
              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
              j += 6;
              break;
            case _util.OPS.curveTo2:
              x = args[j + 2];
              y = args[j + 3];
              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
              j += 4;
              break;
            case _util.OPS.curveTo3:
              x = args[j + 2];
              y = args[j + 3];
              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
              j += 4;
              break;
            case _util.OPS.closePath:
              d.push('Z');
              break;
          }
        }
        current.path.setAttributeNS(null, 'd', d.join(' '));
        current.path.setAttributeNS(null, 'fill', 'none');
        this._ensureTransformGroup().appendChild(current.path);
        current.element = current.path;
        current.setCurrentPoint(x, y);
      },
      endPath: function SVGGraphics_endPath() {
        if (!this.pendingClip) {
          return;
        }
        var current = this.current;
        var clipId = 'clippath' + clipCount;
        clipCount++;
        var clipPath = this.svgFactory.createElement('svg:clipPath');
        clipPath.setAttributeNS(null, 'id', clipId);
        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
        var clipElement = current.element.cloneNode();
        if (this.pendingClip === 'evenodd') {
          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
        } else {
          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
        }
        this.pendingClip = null;
        clipPath.appendChild(clipElement);
        this.defs.appendChild(clipPath);
        if (current.activeClipUrl) {
          current.clipGroup = null;
          this.extraStack.forEach(function (prev) {
            prev.clipGroup = null;
          });
        }
        current.activeClipUrl = 'url(#' + clipId + ')';
        this.tgrp = null;
      },
      clip: function SVGGraphics_clip(type) {
        this.pendingClip = type;
      },
      closePath: function SVGGraphics_closePath() {
        var current = this.current;
        if (current.path) {
          var d = current.path.getAttributeNS(null, 'd');
          d += 'Z';
          current.path.setAttributeNS(null, 'd', d);
        }
      },
      setLeading: function SVGGraphics_setLeading(leading) {
        this.current.leading = -leading;
      },
      setTextRise: function SVGGraphics_setTextRise(textRise) {
        this.current.textRise = textRise;
      },
      setHScale: function SVGGraphics_setHScale(scale) {
        this.current.textHScale = scale / 100;
      },
      setGState: function SVGGraphics_setGState(states) {
        for (var i = 0, ii = states.length; i < ii; i++) {
          var state = states[i];
          var key = state[0];
          var value = state[1];
          switch (key) {
            case 'LW':
              this.setLineWidth(value);
              break;
            case 'LC':
              this.setLineCap(value);
              break;
            case 'LJ':
              this.setLineJoin(value);
              break;
            case 'ML':
              this.setMiterLimit(value);
              break;
            case 'D':
              this.setDash(value[0], value[1]);
              break;
            case 'Font':
              this.setFont(value);
              break;
            case 'CA':
              this.setStrokeAlpha(value);
              break;
            case 'ca':
              this.setFillAlpha(value);
              break;
            default:
              (0, _util.warn)('Unimplemented graphic state ' + key);
              break;
          }
        }
      },
      fill: function SVGGraphics_fill() {
        var current = this.current;
        if (current.element) {
          current.element.setAttributeNS(null, 'fill', current.fillColor);
          current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
        }
      },
      stroke: function SVGGraphics_stroke() {
        var current = this.current;
        if (current.element) {
          current.element.setAttributeNS(null, 'stroke', current.strokeColor);
          current.element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
          current.element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
          current.element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
          current.element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
          current.element.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
          current.element.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
          current.element.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
          current.element.setAttributeNS(null, 'fill', 'none');
        }
      },
      eoFill: function SVGGraphics_eoFill() {
        if (this.current.element) {
          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        }
        this.fill();
      },
      fillStroke: function SVGGraphics_fillStroke() {
        this.stroke();
        this.fill();
      },
      eoFillStroke: function SVGGraphics_eoFillStroke() {
        if (this.current.element) {
          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        }
        this.fillStroke();
      },
      closeStroke: function SVGGraphics_closeStroke() {
        this.closePath();
        this.stroke();
      },
      closeFillStroke: function SVGGraphics_closeFillStroke() {
        this.closePath();
        this.fillStroke();
      },
      closeEOFillStroke: function closeEOFillStroke() {
        this.closePath();
        this.eoFillStroke();
      },

      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
        var current = this.current;
        var rect = this.svgFactory.createElement('svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', '1px');
        rect.setAttributeNS(null, 'height', '1px');
        rect.setAttributeNS(null, 'fill', current.fillColor);
        this._ensureTransformGroup().appendChild(rect);
      },
      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
        var imgObj = this.objs.get(objId);
        var imgEl = this.svgFactory.createElement('svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
        imgEl.setAttributeNS(null, 'width', pf(w));
        imgEl.setAttributeNS(null, 'height', pf(h));
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-h));
        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
        this._ensureTransformGroup().appendChild(imgEl);
      },
      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
        var imgData = this.objs.get(objId);
        if (!imgData) {
          (0, _util.warn)('Dependent image isn\'t ready yet');
          return;
        }
        this.paintInlineImageXObject(imgData);
      },
      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
        var width = imgData.width;
        var height = imgData.height;
        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
        var cliprect = this.svgFactory.createElement('svg:rect');
        cliprect.setAttributeNS(null, 'x', '0');
        cliprect.setAttributeNS(null, 'y', '0');
        cliprect.setAttributeNS(null, 'width', pf(width));
        cliprect.setAttributeNS(null, 'height', pf(height));
        this.current.element = cliprect;
        this.clip('nonzero');
        var imgEl = this.svgFactory.createElement('svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-height));
        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
        if (mask) {
          mask.appendChild(imgEl);
        } else {
          this._ensureTransformGroup().appendChild(imgEl);
        }
      },
      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
        var current = this.current;
        var width = imgData.width;
        var height = imgData.height;
        var fillColor = current.fillColor;
        current.maskId = 'mask' + maskCount++;
        var mask = this.svgFactory.createElement('svg:mask');
        mask.setAttributeNS(null, 'id', current.maskId);
        var rect = this.svgFactory.createElement('svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', pf(width));
        rect.setAttributeNS(null, 'height', pf(height));
        rect.setAttributeNS(null, 'fill', fillColor);
        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
        this.defs.appendChild(mask);
        this._ensureTransformGroup().appendChild(rect);
        this.paintInlineImageXObject(imgData, mask);
      },
      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
        if (Array.isArray(matrix) && matrix.length === 6) {
          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
        }
        if (Array.isArray(bbox) && bbox.length === 4) {
          var width = bbox[2] - bbox[0];
          var height = bbox[3] - bbox[1];
          var cliprect = this.svgFactory.createElement('svg:rect');
          cliprect.setAttributeNS(null, 'x', bbox[0]);
          cliprect.setAttributeNS(null, 'y', bbox[1]);
          cliprect.setAttributeNS(null, 'width', pf(width));
          cliprect.setAttributeNS(null, 'height', pf(height));
          this.current.element = cliprect;
          this.clip('nonzero');
          this.endPath();
        }
      },
      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
      _initialize: function _initialize(viewport) {
        var svg = this.svgFactory.create(viewport.width, viewport.height);
        var definitions = this.svgFactory.createElement('svg:defs');
        svg.appendChild(definitions);
        this.defs = definitions;
        var rootGroup = this.svgFactory.createElement('svg:g');
        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
        svg.appendChild(rootGroup);
        this.svg = rootGroup;
        return svg;
      },

      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
        if (!this.current.clipGroup) {
          var clipGroup = this.svgFactory.createElement('svg:g');
          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
          this.svg.appendChild(clipGroup);
          this.current.clipGroup = clipGroup;
        }
        return this.current.clipGroup;
      },
      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
        if (!this.tgrp) {
          this.tgrp = this.svgFactory.createElement('svg:g');
          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
          if (this.current.activeClipUrl) {
            this._ensureClipGroup().appendChild(this.tgrp);
          } else {
            this.svg.appendChild(this.tgrp);
          }
        }
        return this.tgrp;
      }
    };
    return SVGGraphics;
  }();
}
exports.SVGGraphics = SVGGraphics;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66), __webpack_require__(76).Buffer))

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Transform = __webpack_require__(2453);

var binding = __webpack_require__(2459);
var util = __webpack_require__(454);
var assert = __webpack_require__(2467).ok;

// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
binding.Z_MIN_WINDOWBITS = 8;
binding.Z_MAX_WINDOWBITS = 15;
binding.Z_DEFAULT_WINDOWBITS = 15;

// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
binding.Z_MIN_CHUNK = 64;
binding.Z_MAX_CHUNK = Infinity;
binding.Z_DEFAULT_CHUNK = (16 * 1024);

binding.Z_MIN_MEMLEVEL = 1;
binding.Z_MAX_MEMLEVEL = 9;
binding.Z_DEFAULT_MEMLEVEL = 8;

binding.Z_MIN_LEVEL = -1;
binding.Z_MAX_LEVEL = 9;
binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;

// expose all the zlib constants
Object.keys(binding).forEach(function(k) {
  if (k.match(/^Z/)) exports[k] = binding[k];
});

// translation table for return codes.
exports.codes = {
  Z_OK: binding.Z_OK,
  Z_STREAM_END: binding.Z_STREAM_END,
  Z_NEED_DICT: binding.Z_NEED_DICT,
  Z_ERRNO: binding.Z_ERRNO,
  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
  Z_DATA_ERROR: binding.Z_DATA_ERROR,
  Z_MEM_ERROR: binding.Z_MEM_ERROR,
  Z_BUF_ERROR: binding.Z_BUF_ERROR,
  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
};

Object.keys(exports.codes).forEach(function(k) {
  exports.codes[exports.codes[k]] = k;
});

exports.Deflate = Deflate;
exports.Inflate = Inflate;
exports.Gzip = Gzip;
exports.Gunzip = Gunzip;
exports.DeflateRaw = DeflateRaw;
exports.InflateRaw = InflateRaw;
exports.Unzip = Unzip;

exports.createDeflate = function(o) {
  return new Deflate(o);
};

exports.createInflate = function(o) {
  return new Inflate(o);
};

exports.createDeflateRaw = function(o) {
  return new DeflateRaw(o);
};

exports.createInflateRaw = function(o) {
  return new InflateRaw(o);
};

exports.createGzip = function(o) {
  return new Gzip(o);
};

exports.createGunzip = function(o) {
  return new Gunzip(o);
};

exports.createUnzip = function(o) {
  return new Unzip(o);
};


// Convenience methods.
// compress/decompress a string or buffer in one step.
exports.deflate = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Deflate(opts), buffer, callback);
};

exports.deflateSync = function(buffer, opts) {
  return zlibBufferSync(new Deflate(opts), buffer);
};

exports.gzip = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gzip(opts), buffer, callback);
};

exports.gzipSync = function(buffer, opts) {
  return zlibBufferSync(new Gzip(opts), buffer);
};

exports.deflateRaw = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
};

exports.deflateRawSync = function(buffer, opts) {
  return zlibBufferSync(new DeflateRaw(opts), buffer);
};

exports.unzip = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Unzip(opts), buffer, callback);
};

exports.unzipSync = function(buffer, opts) {
  return zlibBufferSync(new Unzip(opts), buffer);
};

exports.inflate = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Inflate(opts), buffer, callback);
};

exports.inflateSync = function(buffer, opts) {
  return zlibBufferSync(new Inflate(opts), buffer);
};

exports.gunzip = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gunzip(opts), buffer, callback);
};

exports.gunzipSync = function(buffer, opts) {
  return zlibBufferSync(new Gunzip(opts), buffer);
};

exports.inflateRaw = function(buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new InflateRaw(opts), buffer, callback);
};

exports.inflateRawSync = function(buffer, opts) {
  return zlibBufferSync(new InflateRaw(opts), buffer);
};

function zlibBuffer(engine, buffer, callback) {
  var buffers = [];
  var nread = 0;

  engine.on('error', onError);
  engine.on('end', onEnd);

  engine.end(buffer);
  flow();

  function flow() {
    var chunk;
    while (null !== (chunk = engine.read())) {
      buffers.push(chunk);
      nread += chunk.length;
    }
    engine.once('readable', flow);
  }

  function onError(err) {
    engine.removeListener('end', onEnd);
    engine.removeListener('readable', flow);
    callback(err);
  }

  function onEnd() {
    var buf = Buffer.concat(buffers, nread);
    buffers = [];
    callback(null, buf);
    engine.close();
  }
}

function zlibBufferSync(engine, buffer) {
  if (typeof buffer === 'string')
    buffer = new Buffer(buffer);
  if (!Buffer.isBuffer(buffer))
    throw new TypeError('Not a string or buffer');

  var flushFlag = binding.Z_FINISH;

  return engine._processChunk(buffer, flushFlag);
}

// generic zlib
// minimal 2-byte header
function Deflate(opts) {
  if (!(this instanceof Deflate)) return new Deflate(opts);
  Zlib.call(this, opts, binding.DEFLATE);
}

function Inflate(opts) {
  if (!(this instanceof Inflate)) return new Inflate(opts);
  Zlib.call(this, opts, binding.INFLATE);
}



// gzip - bigger header, same deflate compression
function Gzip(opts) {
  if (!(this instanceof Gzip)) return new Gzip(opts);
  Zlib.call(this, opts, binding.GZIP);
}

function Gunzip(opts) {
  if (!(this instanceof Gunzip)) return new Gunzip(opts);
  Zlib.call(this, opts, binding.GUNZIP);
}



// raw - no header
function DeflateRaw(opts) {
  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
  Zlib.call(this, opts, binding.DEFLATERAW);
}

function InflateRaw(opts) {
  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
  Zlib.call(this, opts, binding.INFLATERAW);
}


// auto-detect header.
function Unzip(opts) {
  if (!(this instanceof Unzip)) return new Unzip(opts);
  Zlib.call(this, opts, binding.UNZIP);
}


// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.

function Zlib(opts, mode) {
  this._opts = opts = opts || {};
  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;

  Transform.call(this, opts);

  if (opts.flush) {
    if (opts.flush !== binding.Z_NO_FLUSH &&
        opts.flush !== binding.Z_PARTIAL_FLUSH &&
        opts.flush !== binding.Z_SYNC_FLUSH &&
        opts.flush !== binding.Z_FULL_FLUSH &&
        opts.flush !== binding.Z_FINISH &&
        opts.flush !== binding.Z_BLOCK) {
      throw new Error('Invalid flush flag: ' + opts.flush);
    }
  }
  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;

  if (opts.chunkSize) {
    if (opts.chunkSize < exports.Z_MIN_CHUNK ||
        opts.chunkSize > exports.Z_MAX_CHUNK) {
      throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
  }

  if (opts.windowBits) {
    if (opts.windowBits < exports.Z_MIN_WINDOWBITS ||
        opts.windowBits > exports.Z_MAX_WINDOWBITS) {
      throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
  }

  if (opts.level) {
    if (opts.level < exports.Z_MIN_LEVEL ||
        opts.level > exports.Z_MAX_LEVEL) {
      throw new Error('Invalid compression level: ' + opts.level);
    }
  }

  if (opts.memLevel) {
    if (opts.memLevel < exports.Z_MIN_MEMLEVEL ||
        opts.memLevel > exports.Z_MAX_MEMLEVEL) {
      throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
  }

  if (opts.strategy) {
    if (opts.strategy != exports.Z_FILTERED &&
        opts.strategy != exports.Z_HUFFMAN_ONLY &&
        opts.strategy != exports.Z_RLE &&
        opts.strategy != exports.Z_FIXED &&
        opts.strategy != exports.Z_DEFAULT_STRATEGY) {
      throw new Error('Invalid strategy: ' + opts.strategy);
    }
  }

  if (opts.dictionary) {
    if (!Buffer.isBuffer(opts.dictionary)) {
      throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
  }

  this._binding = new binding.Zlib(mode);

  var self = this;
  this._hadError = false;
  this._binding.onerror = function(message, errno) {
    // there is no way to cleanly recover.
    // continuing only obscures problems.
    self._binding = null;
    self._hadError = true;

    var error = new Error(message);
    error.errno = errno;
    error.code = exports.codes[errno];
    self.emit('error', error);
  };

  var level = exports.Z_DEFAULT_COMPRESSION;
  if (typeof opts.level === 'number') level = opts.level;

  var strategy = exports.Z_DEFAULT_STRATEGY;
  if (typeof opts.strategy === 'number') strategy = opts.strategy;

  this._binding.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS,
                     level,
                     opts.memLevel || exports.Z_DEFAULT_MEMLEVEL,
                     strategy,
                     opts.dictionary);

  this._buffer = new Buffer(this._chunkSize);
  this._offset = 0;
  this._closed = false;
  this._level = level;
  this._strategy = strategy;

  this.once('end', this.close);
}

util.inherits(Zlib, Transform);

Zlib.prototype.params = function(level, strategy, callback) {
  if (level < exports.Z_MIN_LEVEL ||
      level > exports.Z_MAX_LEVEL) {
    throw new RangeError('Invalid compression level: ' + level);
  }
  if (strategy != exports.Z_FILTERED &&
      strategy != exports.Z_HUFFMAN_ONLY &&
      strategy != exports.Z_RLE &&
      strategy != exports.Z_FIXED &&
      strategy != exports.Z_DEFAULT_STRATEGY) {
    throw new TypeError('Invalid strategy: ' + strategy);
  }

  if (this._level !== level || this._strategy !== strategy) {
    var self = this;
    this.flush(binding.Z_SYNC_FLUSH, function() {
      self._binding.params(level, strategy);
      if (!self._hadError) {
        self._level = level;
        self._strategy = strategy;
        if (callback) callback();
      }
    });
  } else {
    process.nextTick(callback);
  }
};

Zlib.prototype.reset = function() {
  return this._binding.reset();
};

// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
Zlib.prototype._flush = function(callback) {
  this._transform(new Buffer(0), '', callback);
};

Zlib.prototype.flush = function(kind, callback) {
  var ws = this._writableState;

  if (typeof kind === 'function' || (kind === void 0 && !callback)) {
    callback = kind;
    kind = binding.Z_FULL_FLUSH;
  }

  if (ws.ended) {
    if (callback)
      process.nextTick(callback);
  } else if (ws.ending) {
    if (callback)
      this.once('end', callback);
  } else if (ws.needDrain) {
    var self = this;
    this.once('drain', function() {
      self.flush(callback);
    });
  } else {
    this._flushFlag = kind;
    this.write(new Buffer(0), '', callback);
  }
};

Zlib.prototype.close = function(callback) {
  if (callback)
    process.nextTick(callback);

  if (this._closed)
    return;

  this._closed = true;

  this._binding.close();

  var self = this;
  process.nextTick(function() {
    self.emit('close');
  });
};

Zlib.prototype._transform = function(chunk, encoding, cb) {
  var flushFlag;
  var ws = this._writableState;
  var ending = ws.ending || ws.ended;
  var last = ending && (!chunk || ws.length === chunk.length);

  if (!chunk === null && !Buffer.isBuffer(chunk))
    return cb(new Error('invalid input'));

  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag.
  // If it's explicitly flushing at some other time, then we use
  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
  // goodness.
  if (last)
    flushFlag = binding.Z_FINISH;
  else {
    flushFlag = this._flushFlag;
    // once we've flushed the last of the queue, stop flushing and
    // go back to the normal behavior.
    if (chunk.length >= ws.length) {
      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
    }
  }

  var self = this;
  this._processChunk(chunk, flushFlag, cb);
};

Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
  var availInBefore = chunk && chunk.length;
  var availOutBefore = this._chunkSize - this._offset;
  var inOff = 0;

  var self = this;

  var async = typeof cb === 'function';

  if (!async) {
    var buffers = [];
    var nread = 0;

    var error;
    this.on('error', function(er) {
      error = er;
    });

    do {
      var res = this._binding.writeSync(flushFlag,
                                        chunk, // in
                                        inOff, // in_off
                                        availInBefore, // in_len
                                        this._buffer, // out
                                        this._offset, //out_off
                                        availOutBefore); // out_len
    } while (!this._hadError && callback(res[0], res[1]));

    if (this._hadError) {
      throw error;
    }

    var buf = Buffer.concat(buffers, nread);
    this.close();

    return buf;
  }

  var req = this._binding.write(flushFlag,
                                chunk, // in
                                inOff, // in_off
                                availInBefore, // in_len
                                this._buffer, // out
                                this._offset, //out_off
                                availOutBefore); // out_len

  req.buffer = chunk;
  req.callback = callback;

  function callback(availInAfter, availOutAfter) {
    if (self._hadError)
      return;

    var have = availOutBefore - availOutAfter;
    assert(have >= 0, 'have should not go down');

    if (have > 0) {
      var out = self._buffer.slice(self._offset, self._offset + have);
      self._offset += have;
      // serve some output to the consumer.
      if (async) {
        self.push(out);
      } else {
        buffers.push(out);
        nread += out.length;
      }
    }

    // exhausted the output buffer, or used all the input create a new one.
    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
      availOutBefore = self._chunkSize;
      self._offset = 0;
      self._buffer = new Buffer(self._chunkSize);
    }

    if (availOutAfter === 0) {
      // Not actually done.  Need to reprocess.
      // Also, update the availInBefore to the availInAfter value,
      // so that if we have to hit it a third (fourth, etc.) time,
      // it'll have the correct byte counts.
      inOff += (availInBefore - availInAfter);
      availInBefore = availInAfter;

      if (!async)
        return true;

      var newReq = self._binding.write(flushFlag,
                                       chunk,
                                       inOff,
                                       availInBefore,
                                       self._buffer,
                                       self._offset,
                                       self._chunkSize);
      newReq.callback = callback; // this same function
      newReq.buffer = chunk;
      return;
    }

    if (!async)
      return false;

    // finished with the chunk.
    cb();
  }
};

util.inherits(Deflate, Zlib);
util.inherits(Inflate, Zlib);
util.inherits(Gzip, Zlib);
util.inherits(Gunzip, Zlib);
util.inherits(DeflateRaw, Zlib);
util.inherits(InflateRaw, Zlib);
util.inherits(Unzip, Zlib);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76).Buffer, __webpack_require__(66)))

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It doesn't worth to make additional optimizationa as in original.
// Small size is preferable.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.


// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = once;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(2477);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(2480);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2483);


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(548);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(98),
    now = __webpack_require__(2516),
    toNumber = __webpack_require__(855);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-comment-count.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = __webpack_require__(10);

var _reactI18next = __webpack_require__(2);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _button = __webpack_require__(8);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _font_icon = __webpack_require__(23);

var _uniqWith = __webpack_require__(1049);

var _uniqWith2 = _interopRequireDefault(_uniqWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipButton = (0, _tooltip2.default)(_button.Button);
var MAX_USER_DISPLAY_COUNT = 20;
var DEFAULT_USER_DISPLAY_COUNT = 1;

var DiaryCommentCount = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryCommentCount, _React$Component);

  function DiaryCommentCount() {
    _classCallCheck(this, DiaryCommentCount);

    return _possibleConstructorReturn(this, (DiaryCommentCount.__proto__ || Object.getPrototypeOf(DiaryCommentCount)).apply(this, arguments));
  }

  _createClass(DiaryCommentCount, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          comments = _props.comments,
          user = _props.user,
          myself = _props.myself,
          theme = _props.theme,
          showReaders = _props.showReaders;

      if (!comments || comments.length == 0) return null;

      var users = comments.map(function (item) {
        return item.user;
      });
      var uniq_users = (0, _uniqWith2.default)(users, function (user1, user2) {
        return user1.user_id == user2.user_id;
      });
      var tooltip = uniq_users.map(function (user, index) {
        return _react2.default.createElement(
          'div',
          { key: 'tooltip-' + index },
          _react2.default.createElement(_avatar2.default, { key: 'avatar-' + user.user_id, image: user.icon_image.thumb_url, theme: theme }),
          '\xA0',
          user.name,
          ' \xA0'
        );
      });
      if (uniq_users.length > MAX_USER_DISPLAY_COUNT) tooltip.push(_react2.default.createElement(
        'div',
        { key: 'count-' + uniq_users.user_id },
        '...',
        t('label:他n人', { n: uniq_users.length - MAX_USER_DISPLAY_COUNT })
      ));
      return _react2.default.createElement(
        TooltipButton,
        { neutral: false, ripple: false,
          theme: theme,
          className: 'touchable',
          tooltipPosition: 'vertical',
          tooltip: tooltip,
          onClick: function onClick() {
            return showReaders({ types: 'comments' });
          } },
        _react2.default.createElement(_font_icon.FontIcon, { value: 'comment', style: { fontSize: 16, color: 'blue', lineHeight: 1 } }),
        '\xA0',
        t('label:n', { n: uniq_users.length })
      );
    }
  }]);

  return DiaryCommentCount;
}(_react2.default.Component)) || _class);
exports.default = (0, _reactI18next.translate)()(DiaryCommentCount);

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(907);

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2520);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary-report.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary-report.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventEmitter = undefined;

var _events = __webpack_require__(141);

var eventEmitter = exports.eventEmitter = new _events.EventEmitter();

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _attachmentFile = __webpack_require__(2533);

var _attachmentFile2 = _interopRequireDefault(_attachmentFile);

var _attachments = __webpack_require__(567);

var _attachments2 = _interopRequireDefault(_attachments);

var _attachmentsThumbnail = __webpack_require__(2534);

var _attachmentsThumbnail2 = _interopRequireDefault(_attachmentsThumbnail);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _link = __webpack_require__(183);

var _link2 = _interopRequireDefault(_link);

var _uploadFile = __webpack_require__(261);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _pdfPreviewDialog = __webpack_require__(373);

var _pdfPreviewDialog2 = _interopRequireDefault(_pdfPreviewDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * src/web/components/attachment-file.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * 画像ファイル以外のファイル(例：exls, pdf, 音声ファイル)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var TooltipLink = (0, _tooltip2.default)(_link2.default);

var AttachmentFile = function (_React$Component) {
  _inherits(AttachmentFile, _React$Component);

  function AttachmentFile(props) {
    _classCallCheck(this, AttachmentFile);

    var _this = _possibleConstructorReturn(this, (AttachmentFile.__proto__ || Object.getPrototypeOf(AttachmentFile)).call(this, props));

    _this.onTooltipImgError = function () {
      return _this.setState({ tooltipImg: false });
    };

    _this.onClick = function () {
      if (_this.props.file.content_type.match(/^audio/)) _this.props.showVoicePlayer(_this.props.file, _this.props.diary_id, _this.props.comment_id);else if (_this.props.chat && _this.props.file.content_type == 'application/pdf') _this.props.updateUI({ openDialog: true });else if (!_this.props.chat && _this.props.file.content_type == 'application/pdf') _this.props.showPdfPreview(_this.props.file);
    };

    _this.onClose = function () {
      _this.props.updateUI({ openDialog: false });
    };

    _this.state = { tooltipImg: _this.props.file.file.thumb_url && _this.props.file.content_type == 'application/pdf' };
    return _this;
  }

  // PDFのサムネイル画像を表示しようとしてエラーになった場合はTooltipを消す


  _createClass(AttachmentFile, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          file = _props.file,
          ui = _props.ui,
          showPdfPreview = _props.showPdfPreview,
          showAttachments = _props.showAttachments,
          showVoicePlayer = _props.showVoicePlayer,
          noTooltip = _props.noTooltip,
          chat = _props.chat,
          diary_id = _props.diary_id,
          comment_id = _props.comment_id;


      var num = file && file.name.lastIndexOf('.');
      var basename = num != -1 && file.name.slice(0, num) || file.name;
      var extension = num != -1 && file.name.slice(num + 1, file.name.length).toLowerCase() || '';
      // ファイル名が長い場合は途中を...で省略する
      var filename = basename.length > 10 ? basename.slice(0, 10) + '...' + extension : file.name;

      var isPdf = extension == 'pdf' ? true : false;
      var isAudio = file.content_type.match(/^audio/) ? true : false;
      var icon = isPdf && 'picture_as_pdf' || isAudio && file.status == 'committed' && 'audiotrack' || 'attach_file';

      if (!noTooltip && this.state.tooltipImg) // Tooltipでサムネイルを表示する
        return _react2.default.createElement(
          TooltipLink,
          { tooltipPosition: 'vertical',
            theme: _attachmentsThumbnail2.default,
            style: { display: 'inline', cursor: 'pointer' },
            tooltip: _react2.default.createElement('img', { src: file.file.thumb_url, style: { width: '100%' }, onError: this.onTooltipImgError }),
            onClick: this.onClick },
          _react2.default.createElement(
            _chip2.default,
            { className: _attachments2.default.chip },
            _react2.default.createElement(_avatar2.default, { className: (0, _classnames2.default)(_attachments2.default.avatar, icon), icon: icon }),
            filename
          )
        );
      if (basename.length > 10) // Tooltipにファイル名全体を表示する
        return _react2.default.createElement(
          'div',
          null,
          chat && ui.openDialog && _react2.default.createElement(_pdfPreviewDialog2.default, { open: ui.openDialog, onClose: this.onClose, t: t, file: file }),
          _react2.default.createElement(
            TooltipLink,
            { tooltipPosition: 'vertical',
              href: isPdf || isAudio ? undefined : file.file.url,
              target: "_blank",
              rel: "noopener noreferrer",
              style: { display: 'inline', cursor: 'pointer' },
              tooltip: file.name,
              theme: _attachments2.default,
              download: !file.status && true || false,
              onClick: this.onClick },
            _react2.default.createElement(
              _chip2.default,
              { className: _attachments2.default.chip },
              _react2.default.createElement(_avatar2.default, { className: file.status && file.status != 'committed' ? undefined : (0, _classnames2.default)(_attachments2.default.avatar, icon), icon: icon }),
              filename
            )
          )
        );else // それ以外の場合はLinkで表示する
        return _react2.default.createElement(
          'div',
          null,
          chat && ui.openDialog && _react2.default.createElement(_pdfPreviewDialog2.default, { open: ui.openDialog, onClose: this.onClose, t: t, file: file }),
          _react2.default.createElement(
            _link2.default,
            {
              href: isPdf || isAudio ? undefined : file.file.url,
              target: "_blank",
              rel: "noopener noreferrer",
              style: { display: 'inline', cursor: 'pointer' },
              theme: _attachments2.default,
              download: !file.status && true || false,
              onClick: this.onClick },
            _react2.default.createElement(
              _chip2.default,
              { className: _attachments2.default.chip },
              _react2.default.createElement(_avatar2.default, { className: file.status && file.status != 'committed' ? undefined : (0, _classnames2.default)(_attachments2.default.avatar, icon), icon: icon }),
              filename
            )
          )
        );
    }
  }]);

  return AttachmentFile;
}(_react2.default.Component);

exports.default = (0, _attachmentFile2.default)(AttachmentFile);

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2537);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./field-list-item.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./field-list-item.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _route = __webpack_require__(67);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isShowTimeStamp: state.showTimeStamp.isEnable
  };
};
// src/connects/diary-comment.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    deleteComment: function deleteComment() {
      return dispatch(_actions2.default.deleteComment(ownProps.comment.comment_id));
    },
    likeComment: function likeComment() {
      return dispatch(_actions2.default.likeComment(ownProps.comment.comment_id));
    },
    unlikeComment: function unlikeComment() {
      var like = (0, _find2.default)(ownProps.comment.likes, function (_like) {
        return _like.user.user_id == ownProps.user.user_id;
      });
      like && dispatch(_actions2.default.deleteLike(like.like_id));
    },
    reactionComment: function reactionComment(like_type) {
      return dispatch(_actions2.default.likeComment(ownProps.comment.comment_id, like_type));
    },

    submitStamp: function submitStamp(code, props) {
      if (!code) return;
      dispatch(_actions2.default.postComment('comment_id', props.comment.comment_id, '<div><span class="stamp ' + code + '"></span></div>'));
    },

    showUser: function showUser() {
      return dispatch(_actions2.default.openRightSidePage('user_timeline', { group_id: !ownProps.diary.group && ownProps.group && ownProps.group.group_id || undefined, user_id: ownProps.comment.user.user_id }));
    },
    showAttachments: function showAttachments() {
      return dispatch(_actions2.default.openRightSidePage('attachments', { diary_id: ownProps.diary.diary_id, comment_id: ownProps.comment.comment_id }, true));
    },
    showReaders: function showReaders(props) {
      return dispatch(_actions2.default.openRightSidePage('likes_readers', { diary_id: ownProps.diary.diary_id, comment_id: props.comment_id ? props.comment_id : ownProps.comment.comment_id, tab: props.types }, true));
    },
    showMentions: function showMentions(props) {
      return dispatch(_actions2.default.openRightSidePage('likes_readers', { diary_id: ownProps.diary.diary_id, comment_id: props.comment_id ? props.comment_id : ownProps.comment.comment_id, tab: props.types }, true));
    },
    showComments: function showComments() {
      return dispatch(_actions2.default.openRightSidePage('likes_readers', { diary_id: ownProps.diary.diary_id, comment_id: ownProps.comment.comment_id, tab: 'comments' }, true));
    },
    postContentReport: function postContentReport() {
      dispatch(_actions2.default.postContentReport(ownProps.user.user_id, ownProps.diary.diary_id, ownProps.comment.comment_id));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _uiState2.default)({
  state: {
    openCommentReaction: false,
    openReplyReaction: false
  }
}), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)(), (0, _context2.default)({ showImagesView: _propTypes2.default.func, showStampPalette: _propTypes2.default.func }));

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _cardTitleRightActionsComment = __webpack_require__(2539);

var _cardTitleRightActionsComment2 = _interopRequireDefault(_cardTitleRightActionsComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CardTitleRightActionsComment = function CardTitleRightActionsComment(_ref) {
  var children = _ref.children,
      rightActions = _ref.rightActions,
      className = _ref.className,
      subtitle = _ref.subtitle,
      theme = _ref.theme,
      title = _ref.title,
      other = _objectWithoutProperties(_ref, ['children', 'rightActions', 'className', 'subtitle', 'theme', 'title']);

  var classes = (0, _classnames2.default)(theme.cardTitle, className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, other),
    _react2.default.createElement(
      'div',
      { className: theme.content },
      title && _react2.default.createElement(
        'h5',
        { className: theme.title },
        title
      ),
      children && typeof children === 'string' && _react2.default.createElement(
        'h5',
        { className: theme.title },
        children
      ),
      subtitle && _react2.default.createElement(
        'div',
        { className: theme.subtitle },
        subtitle
      ),
      children && typeof children !== 'string' && children
    ),
    _react2.default.createElement(
      'div',
      { className: theme.rightIcons },
      rightActions
    )
  );
};

CardTitleRightActionsComment.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.array]),
  className: _propTypes2.default.string,
  subtitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.array]),
  theme: _propTypes2.default.shape({
    large: _propTypes2.default.string,
    title: _propTypes2.default.string,
    small: _propTypes2.default.string,
    subtitle: _propTypes2.default.string
  }),
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};

exports.default = (0, _reactCssThemr.themr)('CardTitleRightActionsComment', _cardTitleRightActionsComment2.default)(CardTitleRightActionsComment);

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/diary-upload-files.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    uploadFiles: state.uploadFile[ownProps.componentId],
    uploadVideos: state.uploadVideo[ownProps.componentId]
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    cancelUploadFile: function cancelUploadFile(uploadId) {
      return dispatch(_actions2.default.cancelUploadFile(ownProps.componentId, uploadId));
    },
    cancelUploadVideo: function cancelUploadVideo(uploadId) {
      return dispatch(_actions2.default.cancelUploadVideo(ownProps.componentId, uploadId));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2543);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./image-chip.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./image-chip.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.isCommentStamp = isCommentStamp;

// src/helpers/is-stamp.js

// commentの内容がスタンプかどうかを判定します
function isCommentStamp(comment) {
	return !!comment.match(/<span class=[\'\"]stamp[^"]+[\"\']><\/span>/i);
}

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reviewCard = __webpack_require__(2546);

var _reviewCard2 = _interopRequireDefault(_reviewCard);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _diaryFormButton = __webpack_require__(290);

var _diaryFormButton2 = _interopRequireDefault(_diaryFormButton);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _analytics = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // src/web/components/review-card.jsx

var ReviewCard = function (_React$Component) {
  _inherits(ReviewCard, _React$Component);

  function ReviewCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReviewCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReviewCard.__proto__ || Object.getPrototypeOf(ReviewCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isReported: undefined }, _this.onReport = function (report) {
      if (report === 'good') (0, _analytics.track)('review_report_good', { report: report });
      if (report === 'bad') (0, _analytics.track)('review_report_bad', { report: report });
      _this.setState({ isReported: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReviewCard, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          review = _props.review,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          onSendChatGPT = _props.onSendChatGPT,
          onCloseReview = _props.onCloseReview,
          onOpenReview = _props.onOpenReview,
          isReviewCompleted = _props.isReviewCompleted,
          openSettingsPage = _props.openSettingsPage,
          isEnable = _props.isEnable;


      return _react2.default.createElement(
        _card.Card,
        { raised: true,
          className: _diaryFormButton2.default.reviewCard,
          style: { marginBottom: 8, marginTop: 8, marginLeft: 8, width: '80%' } },
        _react2.default.createElement(
          _card.CardTitle,
          {
            avatar: _react2.default.createElement(_font_icon2.default, { style: { fontSize: 18, marginRight: 4, color: 'purple' }, key: 'chatgpt', value: 'auto_awesome' }) },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold' } },
            t('label:AIレビュー')
          )
        ),
        _react2.default.createElement(
          _card.CardText,
          null,
          review.length > 0 && _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: review.join('') } }),
          isFetching && _react2.default.createElement('span', { className: _diaryFormButton2.default.circle }),
          isReviewCompleted && !this.state.isReported && _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold', fontSize: 14, marginTop: 8, paddingLeft: 16, background: '#f4f4f4', height: 40 } },
            _react2.default.createElement(_button.IconButton, { style: { marginRight: 16 }, icon: 'thumb_up', onClick: function onClick() {
                return _this2.onReport('good');
              } }),
            _react2.default.createElement(_button.IconButton, { style: { marginRight: 16 }, icon: 'thumb_down', onClick: function onClick() {
                return _this2.onReport('bad');
              } }),
            _react2.default.createElement(
              'span',
              null,
              t('label:この情報は役に立ちましたか')
            )
          ),
          isReviewCompleted && this.state.isReported && _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold', fontSize: 14, marginTop: 8, paddingTop: 8, paddingLeft: 16, background: '#f4f4f4', height: 40 } },
            _react2.default.createElement(
              'div',
              { styel: { marginTop: 8, marginLeft: 16 } },
              t('label:レポートお礼')
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: 8 } },
            isEnable && _react2.default.createElement(_button.Button, {
              icon: 'send',
              disabled: isFetching,
              style: { width: '150px' },
              onClick: onSendChatGPT,
              label: t('label:レビューする') }) || _react2.default.createElement(
              _card.CardText,
              { style: { fontSize: 12, width: 600, color: 'gray' } },
              _react2.default.createElement(_font_icon2.default, { value: 'info', style: { fontSize: 14, paddingRight: 8, color: 'gray' } }),
              _react2.default.createElement(
                'span',
                null,
                t('label:レビュー機能OFF')
              )
            ),
            _react2.default.createElement(_button.Button, {
              icon: 'close',
              disabled: isFetching,
              style: { width: '150px' },
              onClick: onCloseReview,
              label: t('label:閉じる') })
          )
        ),
        _react2.default.createElement(
          _card.CardText,
          { className: _diaryFormButton2.default.warningFooter },
          _react2.default.createElement(
            'div',
            { className: _diaryFormButton2.default.warningContent },
            _react2.default.createElement(
              'div',
              { className: _diaryFormButton2.default.warningTextGroup },
              _react2.default.createElement(_font_icon2.default, { value: 'warning', style: { fontSize: 12 } }),
              _react2.default.createElement(
                'span',
                null,
                t('label:レビュー注意')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _diaryFormButton2.default.warningActionGroup },
              _react2.default.createElement(
                'a',
                { href: t('label:注意URL'), target: '_blank' },
                t('label:利用規約')
              ),
              _react2.default.createElement(_button.IconButton, {
                icon: 'settings',
                className: _diaryFormButton2.default.settingsIcon,
                onClick: function onClick() {
                  return openSettingsPage();
                }
              })
            )
          )
        )
      );
    }
  }]);

  return ReviewCard;
}(_react2.default.Component);

exports.default = (0, _reviewCard2.default)(ReviewCard);

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NewBadge;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _newBadge = __webpack_require__(291);

var _newBadge2 = _interopRequireDefault(_newBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewBadge(_ref) {
  var key = _ref.key,
      created_at = _ref.created_at;

  var currentDate = (0, _moment2.default)(new Date());
  var createdDate = (0, _moment2.default)(created_at, "YYYY-MM-DD HH:mm:ss");
  return currentDate.diff(createdDate, 'days') <= 3 ? _react2.default.createElement(
    'div',
    { key: key, className: _newBadge2.default.badge },
    'NEW'
  ) : null;
}

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/web/components/group-member-icons.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupMemberIcons = __webpack_require__(2550);

var _groupMemberIcons2 = _interopRequireDefault(_groupMemberIcons);

var _animationCss = __webpack_require__(184);

var _animationCss2 = _interopRequireDefault(_animationCss);

var _reactI18next = __webpack_require__(2);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _toggleButton = __webpack_require__(388);

var _toggleButton2 = _interopRequireDefault(_toggleButton);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _newBadge = __webpack_require__(291);

var _newBadge2 = _interopRequireDefault(_newBadge);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _theme = __webpack_require__(868);

var _theme2 = _interopRequireDefault(_theme);

var _newBadge3 = __webpack_require__(1060);

var _newBadge4 = _interopRequireDefault(_newBadge3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TooltipAvatar = (0, _tooltip2.default)(_avatar2.default);

function GroupMemberIcons(props) {
  var showUserTimeLine = function showUserTimeLine(user) {
    return props.showUser(user);
  };

  var t = props.t,
      ui = props.ui,
      user = props.user,
      users = props.users,
      group = props.group,
      updateUI = props.updateUI,
      showUser = props.showUser,
      openGroupMembersPanel = props.openGroupMembersPanel,
      usersAdminUrl = props.usersAdminUrl,
      firstLogin = props.firstLogin,
      productTour = props.productTour;


  if (!users || users.length == 0) return null;

  var anim = (0, _animationCss2.default)(firstLogin && (!productTour || productTour.openGroupMemberPanel != 'hide'));
  var href = firstLogin && (!productTour || productTour.openGroupMemberPanel != 'hide') && usersAdminUrl || undefined;

  return _react2.default.createElement(
    'div',
    null,
    user.trial && group.is_admin && _react2.default.createElement(_button.Button, { onClick: openGroupMembersPanel, theme: _successButton2.default, raised: true,
      href: href, target: href && '_blank', rel: href && "noopener noreferrer",
      style: { margin: '0 5px' },
      icon: _react2.default.createElement(_font_icon2.default, _extends({ value: 'person_add', className: _theme2.default.icon
      }, anim)),
      label: _react2.default.createElement(
        'span',
        anim,
        t('label:ユーザ追加')
      ) }),
    !user.trial && group.is_admin && users.length > 1 && _react2.default.createElement(_button.Button, { onClick: openGroupMembersPanel, floating: true, mini: true,
      theme: _successButton2.default, icon: 'person_add' }),
    !user.trial && group.is_admin && users.length == 1 && _react2.default.createElement(_button.Button, { onClick: openGroupMembersPanel, theme: _successButton2.default, raised: true,
      href: href, target: href && '_blank', rel: href && "noopener noreferrer",
      style: { margin: '0 5px' },
      icon: _react2.default.createElement(_font_icon2.default, _extends({ value: 'person_add', className: _theme2.default.icon
      }, anim)),
      label: _react2.default.createElement(
        'span',
        anim,
        t('label:ユーザ追加')
      ) }),
    (ui.showAll ? users : users.slice(0, 10)).map(function (user) {
      return _react2.default.createElement(
        'div',
        { key: user.user_id, className: _newBadge2.default.box },
        _react2.default.createElement(TooltipAvatar, { key: user.user_id,
          style: { cursor: 'pointer' },
          tooltip: user.name,
          onClick: function onClick() {
            return showUserTimeLine(user);
          },
          image: user.icon_image.thumb_url }),
        _react2.default.createElement(_newBadge4.default, { created_at: user.created_at })
      );
    }),
    users.length > 10 && _react2.default.createElement(_toggleButton2.default, {
      flag: !ui.showAll,
      onClick: function onClick() {
        return updateUI({ showAll: !ui.showAll });
      },
      style: { marginLeft: 10 } })
  );
}

exports.default = (0, _groupMemberIcons2.default)(GroupMemberIcons);

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawPickupDiariesPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _pickupDiariesPage = __webpack_require__(2552);

var _pickupDiariesPage2 = _interopRequireDefault(_pickupDiariesPage);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _diary = __webpack_require__(171);

var _diary2 = _interopRequireDefault(_diary);

var _infiniteScroller = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/pickup-diaries-page.jsx

var PickupDiariesPage = function (_PureComponent) {
  _inherits(PickupDiariesPage, _PureComponent);

  function PickupDiariesPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PickupDiariesPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PickupDiariesPage.__proto__ || Object.getPrototypeOf(PickupDiariesPage)).call.apply(_ref, [this].concat(args))), _this), _this.onReplyScrollFrom = function (offset) {
      //COMMENT_FORM_HEIGHTはコメントフォームの高さ
      var COMMENT_FORM_HEIGHT = 222;
      //返信コメントへの返信の場合、コメントフォームまでスクロールする
      _this.rightSidePage.scrollTo(offset += COMMENT_FORM_HEIGHT);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PickupDiariesPage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          diary_ids = _props.diary_ids,
          diaries = _props.diaries,
          user = _props.user,
          group = _props.group,
          readDiary = _props.readDiary,
          fetchDiaries = _props.fetchDiaries,
          hasMore = _props.hasMore,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          likeConfig = _props.likeConfig,
          rightSidePage = _props.rightSidePage;


      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: t('label:ピックアップ'), icon: 'bookmark', innerRef: function innerRef(c) {
            return _this2.rightSidePage = c;
          } },
        !isFetchFailed && _react2.default.createElement(
          _infiniteScroller.InfiniteScroll,
          { pageStart: 0,
            hasMore: hasMore && !isFetchFailed,
            loadMore: function loadMore() {
              return !isFetching && fetchDiaries(_this2.props);
            },
            loader: diaries && _react2.default.createElement(_loading2.default, null),
            useWindow: false },
          _.map(diaries, function (diary) {
            return _react2.default.createElement(_diary2.default, { key: diary.diary_id, diary: diary, user: user, group: group, isPickup: true, isShowAllComments: true, onReplyScrollFrom: _this2.onReplyScrollFrom, likeConfig: likeConfig, openSidePage: rightSidePage, isReviewButtonDisplay: false });
          })
        ),
        !isFetchFailed && !diaries && isFetching && _react2.default.createElement(_loading2.default, null),
        isFetchFailed && _react2.default.createElement(
          'div',
          { style: { marginTop: '10px', textAlign: 'center' } },
          t('label:投稿の取得に失敗しました')
        ),
        !isFetching && !isFetchFailed && (!diaries || diaries && diaries.length == 0) && _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'center' } },
          t('label:投稿がありません')
        )
      );
    }
  }]);

  return PickupDiariesPage;
}(_pureComponent2.default);

var RawPickupDiariesPage = exports.RawPickupDiariesPage = PickupDiariesPage;
exports.default = (0, _pickupDiariesPage2.default)(PickupDiariesPage);

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(2554);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2560);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./wraped-list.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./wraped-list.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2562);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./announces-list.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./announces-list.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userMonthlySummaryPage = __webpack_require__(2571);

var _userMonthlySummaryPage2 = _interopRequireDefault(_userMonthlySummaryPage);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _dialog = __webpack_require__(47);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _userMonthlySummaryPage3 = __webpack_require__(1067);

var _userMonthlySummaryPage4 = _interopRequireDefault(_userMonthlySummaryPage3);

var _userMonthlyActivitiesTable = __webpack_require__(1068);

var _userMonthlyActivitiesTable2 = _interopRequireDefault(_userMonthlyActivitiesTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
* src/web/components/user-monthly-summary-page.jsx
* ユーザの月間サマリーページ（ポップアップ）
*/


var UserMonthlySummaryPage = function (_React$Component) {
  _inherits(UserMonthlySummaryPage, _React$Component);

  function UserMonthlySummaryPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserMonthlySummaryPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserMonthlySummaryPage.__proto__ || Object.getPrototypeOf(UserMonthlySummaryPage)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (isAdd) {
      var num = isAdd && 1 || -1;
      var dt = (0, _moment2.default)(_this.props.ui.date.clone().add(num, 'month'));
      _this.props.updateUI({ date: dt });
    }, _this.onClose = function () {
      _this.props.onClose();
      _this.props.updateUI({ date: (0, _moment2.default)(), edit: false });
      _this.props.startDate && _this.props.fetchActivityReports(_this.props.group, _this.props.startDate);
    }, _this.onEdit = function () {
      return _this.props.updateUI({ edit: !_this.props.ui.edit });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserMonthlySummaryPage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          user = _props.user,
          group = _props.group,
          onClose = _props.onClose,
          open = _props.open,
          monthlySummaryExportUrl = _props.monthlySummaryExportUrl,
          currentUser = _props.currentUser,
          reportDate = _props.reportDate;


      return _react2.default.createElement(
        _dialog.Dialog,
        { theme: _userMonthlySummaryPage4.default,
          active: open,
          onEscKeyDown: this.onClose,
          onOverlayClick: this.onClose,
          title: ui.edit ? t('label:月間サマリー編集モード', { name: user.name }) : t('label:月間サマリー', { name: user.name }),
          actions: [!ui.edit && { label: t('label:閉じる'), onClick: this.onClose, raised: true }] },
        _react2.default.createElement(
          'div',
          { className: _userMonthlySummaryPage4.default.displayMonth },
          _react2.default.createElement(
            'div',
            { className: !ui.edit ? _userMonthlySummaryPage4.default.cursor : _userMonthlySummaryPage4.default.notAllowed, onClick: function onClick() {
                return !ui.edit && _this2.onClick(false);
              } },
            _react2.default.createElement(_font_icon2.default, { value: 'navigate_before' })
          ),
          _react2.default.createElement(
            'span',
            null,
            t('label:年月', { year: ui.date.year(), month: ui.date.month() + 1 })
          ),
          _react2.default.createElement(
            'div',
            { className: !ui.edit ? _userMonthlySummaryPage4.default.cursor : _userMonthlySummaryPage4.default.notAllowed, onClick: function onClick() {
                return !ui.edit && _this2.onClick(true);
              } },
            _react2.default.createElement(_font_icon2.default, { value: 'navigate_next' })
          )
        ),
        !ui.edit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: _userMonthlySummaryPage4.default.icons },
            _react2.default.createElement(
              'div',
              { className: _userMonthlySummaryPage4.default.icon },
              _react2.default.createElement(_font_icon2.default, { value: 'event_note', className: _userMonthlySummaryPage4.default.descFontIcon }),
              _react2.default.createElement(
                'span',
                { className: _userMonthlySummaryPage4.default.descText },
                t('label:日報アイコン')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _userMonthlySummaryPage4.default.icon },
              _react2.default.createElement(_font_icon2.default, { value: 'insert_chart', className: _userMonthlySummaryPage4.default.descFontIcon }),
              _react2.default.createElement(
                'span',
                { className: _userMonthlySummaryPage4.default.descText },
                t('label:KPIアイコン')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _userMonthlySummaryPage4.default.icon },
              _react2.default.createElement(_font_icon2.default, { value: 'assignment', className: _userMonthlySummaryPage4.default.descFontIcon }),
              _react2.default.createElement(
                'span',
                { className: _userMonthlySummaryPage4.default.descText },
                t('label:ノートアイコン')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _userMonthlySummaryPage4.default.icon },
              _react2.default.createElement(_font_icon2.default, { value: 'event_available', className: _userMonthlySummaryPage4.default.scheduleIcon }),
              _react2.default.createElement(
                'span',
                { className: _userMonthlySummaryPage4.default.descText },
                t('label:提出予定')
              )
            )
          )
        ),
        _react2.default.createElement(_userMonthlyActivitiesTable2.default, {
          reportDate: reportDate,
          group_id: group.group_id,
          user_id: user.user_id,
          current_user_id: currentUser.user_id,
          changeEdit: this.onEdit,
          edit: ui.edit,
          date: ui.date,
          group_admin: group.is_admin
        })
      );
    }
  }]);

  return UserMonthlySummaryPage;
}(_react2.default.Component);

exports.default = (0, _userMonthlySummaryPage2.default)(UserMonthlySummaryPage);

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2572);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./user-monthly-summary-page.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./user-monthly-summary-page.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserMonthlyActivitiesTable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/**
* src/web/components/user-monthly-activities-table.jsx
* ユーザの月間の日報提出状況テーブル（カレンダー）
*/


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userMonthlyActivitiesTable = __webpack_require__(2573);

var _userMonthlyActivitiesTable2 = _interopRequireDefault(_userMonthlyActivitiesTable);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _userMonthlyActivitiesTable3 = __webpack_require__(2577);

var _userMonthlyActivitiesTable4 = _interopRequireDefault(_userMonthlyActivitiesTable3);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _button = __webpack_require__(8);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipCheckbox = (0, _tooltip2.default)(_checkbox2.default);
/**
 * 日報提出状況テーブル
 * 　ウィンドウの幅に応じて、２列に並べて表示するか、１列に表示するかを切り替えるため、
 * 　半月分の日報提出状況テーブルを２つ作成し、その固まりを横並び、縦並びで表示する
 */
function ReportStatusTable(props) {
  var t = props.t,
      ui = props.ui,
      updateUI = props.updateUI,
      report_two_rows = props.report_two_rows,
      activityReport = props.activityReport,
      edit = props.edit,
      check = props.check,
      onChange = props.onChange,
      user_id = props.user_id,
      group_id = props.group_id,
      current_user_id = props.current_user_id,
      saveSchedules = props.saveSchedules,
      report_status = props.report_status;


  return _react2.default.createElement(
    'div',
    { className: _userMonthlyActivitiesTable4.default.activeTable },
    _react2.default.createElement(
      'div',
      { className: _userMonthlyActivitiesTable4.default.table },
      _lodash2.default.map(report_two_rows, function (report, i) {
        return _react2.default.createElement(DateReportStatus, { key: i, index: i,
          date_status: report.first_half,
          onChange: onChange,
          check: check,
          user_id: user_id,
          edit: edit,
          ui: ui,
          group_id: group_id,
          saveSchedules: saveSchedules,
          report_status: report_status,
          updateUI: updateUI });
      })
    ),
    _react2.default.createElement(
      'div',
      { className: _userMonthlyActivitiesTable4.default.table },
      _lodash2.default.map(report_two_rows.slice(0, report_two_rows.length - 1), function (report, i) {
        return _react2.default.createElement(DateReportStatus, { key: i, index: i,
          date_status: report.latter_half,
          onChange: onChange,
          check: check,
          edit: edit,
          ui: ui,
          user_id: user_id,
          group_id: group_id,
          saveSchedules: saveSchedules,
          report_status: report_status,
          updateUI: updateUI });
      }),
      _react2.default.createElement(TotalMonthlyActivities, { activityReport: activityReport, t: t })
    )
  );
}

/**
 * 1日の日報・KPI・ノートの投稿件数表示セル
 */

function DateReportStatus(props) {
  var ui = props.ui,
      updateUI = props.updateUI,
      index = props.index,
      date_status = props.date_status,
      edit = props.edit,
      check = props.check,
      onChange = props.onChange,
      report_status = props.report_status;


  var onChangeDate = function onChangeDate(status) {
    var updatedStatus = _lodash2.default.map(props.report_status, function (item) {
      if (item.reported_at === status.reported_at) {
        return _extends({}, status, {
          submission: !status.submission
        });
      }
      return item;
    });
    props.saveSchedules(props.group_id, updatedStatus, props.user_id);
  };

  var day_theme = _userMonthlyActivitiesTable4.default.default;
  var border_theme = undefined;

  if (index == 0 || index == 15) {
    border_theme = _userMonthlyActivitiesTable4.default.borderAll;
  } else if (index < 14) {
    border_theme = _userMonthlyActivitiesTable4.default.borderNoTop;
  } else {
    border_theme = _userMonthlyActivitiesTable4.default.border;
  }

  if (!date_status) {
    day_theme = _userMonthlyActivitiesTable4.default.empty;
  } else {
    switch (date_status.theme) {
      case 'holiday':
        day_theme = _userMonthlyActivitiesTable4.default.holiday;
        break;
      case 'saturday':
        day_theme = _userMonthlyActivitiesTable4.default.saturday;
        break;
      case 'default':
        day_theme = _userMonthlyActivitiesTable4.default.default;
        break;
    }
  }

  if (date_status) {
    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_userMonthlyActivitiesTable4.default.rows, border_theme, day_theme) },
      _react2.default.createElement(
        'div',
        { className: _userMonthlyActivitiesTable4.default.date },
        date_status && date_status.date
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_userMonthlyActivitiesTable4.default.borderLeft, _userMonthlyActivitiesTable4.default.date) },
        date_status && date_status.day
      ),
      _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_userMonthlyActivitiesTable4.default.borderLeft, _userMonthlyActivitiesTable4.default.activitiesCell) },
        date_status && !edit && date_status.activity && _react2.default.createElement(DateActivitiesCount, { activity: date_status.activity, submission: date_status.submission, reported_at: date_status.reported_at }) || _react2.default.createElement(TooltipCheckbox, { checked: date_status.submission, tooltip: "提出予定を登録する",
          theme: _userMonthlyActivitiesTable4.default, className: 'userMonthly',
          onChange: function onChange() {
            return onChangeDate(date_status);
          }
        })
      )
    );
  } else {
    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_userMonthlyActivitiesTable4.default.noStatus, day_theme) },
      ''
    );
  }
}

/**
 * 日報・KPI・ノートの投稿件数取得関数
 */
function DateActivitiesCount(props) {
  var activity = props.activity,
      submission = props.submission,
      reported_at = props.reported_at;
  var diary = activity.diary,
      memo = activity.memo,
      kpi = activity.kpi,
      like = activity.like,
      comment = activity.comment;


  var diary_ids = diary && diary.split(',').map(function (id) {
    return parseInt(id);
  }) || [];
  var kpi_ids = kpi && kpi.split(',').map(function (id) {
    return parseInt(id);
  }) || [];
  var memo_ids = memo && memo.split(',').map(function (id) {
    return parseInt(id);
  }) || [];

  var count_diary = diary_ids.length || 0;
  var count_kpi = kpi_ids.length || 0;
  var count_memo = memo_ids.length || 0;

  if (count_diary == 0 && count_kpi == 0 && submission) {
    return _react2.default.createElement(
      'div',
      { className: _userMonthlyActivitiesTable4.default.empty },
      submission && _react2.default.createElement(ActivitiesCount, { icon: "event_available", insubmission: true }),
      count_memo != 0 && _react2.default.createElement(ActivitiesCount, { icon: 'assignment', count: count_memo })
    );
  } else if (count_diary == 0 && count_kpi == 0 && count_memo == 0) {
    return _react2.default.createElement('div', { className: _userMonthlyActivitiesTable4.default.empty });
  } else {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(ActivitiesCount, { icon: 'event_note', count: count_diary }),
      _react2.default.createElement(ActivitiesCount, { icon: 'insert_chart', count: count_kpi }),
      _react2.default.createElement(ActivitiesCount, { icon: 'assignment', count: count_memo })
    );
  }
}

function ActivitiesCount(props) {
  var icon = props.icon,
      count = props.count,
      insubmission = props.insubmission;


  if (count == 0) return _react2.default.createElement('div', { className: _userMonthlyActivitiesTable4.default.status });else return _react2.default.createElement(
    'div',
    { className: insubmission ? _userMonthlyActivitiesTable4.default.scheduleStatus : _userMonthlyActivitiesTable4.default.status },
    _react2.default.createElement(_font_icon2.default, { className: insubmission ? _userMonthlyActivitiesTable4.default.scheduleIcon : _userMonthlyActivitiesTable4.default.fontIcon, value: icon }),
    count > 1 && _react2.default.createElement(
      'span',
      { className: _userMonthlyActivitiesTable4.default.text },
      count
    ),
    count == 1 && _react2.default.createElement('span', { className: _userMonthlyActivitiesTable4.default.text })
  );
}

/**
 * 合計表示セル
 */
function TotalMonthlyActivities(props) {
  var t = props.t,
      activityReport = props.activityReport;


  var total_diary = 0;
  var total_kpi = 0;
  var total_memo = 0;

  _lodash2.default.each(activityReport.activity, function (activity, i) {
    var diary_ids = activity.diary && activity.diary.split(',').map(function (id) {
      return parseInt(id);
    }) || [];
    var kpi_ids = activity.kpi && activity.kpi.split(',').map(function (id) {
      return parseInt(id);
    }) || [];
    var memo_ids = activity.memo && activity.memo.split(',').map(function (id) {
      return parseInt(id);
    }) || [];

    total_diary += diary_ids && diary_ids.length || 0;
    total_kpi += kpi_ids && kpi_ids.length || 0;
    total_memo += memo_ids && memo_ids.length || 0;
  });

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_userMonthlyActivitiesTable4.default.borderAll, _userMonthlyActivitiesTable4.default.default) },
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_userMonthlyActivitiesTable4.default.totalTitle, _userMonthlyActivitiesTable4.default.totalText) },
      _react2.default.createElement(
        'span',
        null,
        t('label:合計')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)(_userMonthlyActivitiesTable4.default.borderLeft, _userMonthlyActivitiesTable4.default.activitiesCell) },
      _react2.default.createElement(
        'div',
        { className: _userMonthlyActivitiesTable4.default.status },
        _react2.default.createElement(_font_icon2.default, { value: 'event_note', className: _userMonthlyActivitiesTable4.default.fontIcon }),
        _react2.default.createElement(
          'span',
          { className: (0, _classnames2.default)(_userMonthlyActivitiesTable4.default.totalText, _userMonthlyActivitiesTable4.default.text) },
          total_diary
        )
      ),
      _react2.default.createElement(
        'div',
        { className: _userMonthlyActivitiesTable4.default.status },
        _react2.default.createElement(_font_icon2.default, { value: 'insert_chart', className: _userMonthlyActivitiesTable4.default.fontIcon }),
        _react2.default.createElement(
          'span',
          { className: (0, _classnames2.default)(_userMonthlyActivitiesTable4.default.totalText, _userMonthlyActivitiesTable4.default.text) },
          total_kpi
        )
      ),
      _react2.default.createElement(
        'div',
        { className: _userMonthlyActivitiesTable4.default.status },
        _react2.default.createElement(_font_icon2.default, { value: 'assignment', className: _userMonthlyActivitiesTable4.default.fontIcon }),
        _react2.default.createElement(
          'span',
          { className: (0, _classnames2.default)(_userMonthlyActivitiesTable4.default.totalText, _userMonthlyActivitiesTable4.default.text) },
          total_memo
        )
      )
    )
  );
}

var UserMonthlyActivitiesTable = function (_React$Component) {
  _inherits(UserMonthlyActivitiesTable, _React$Component);

  function UserMonthlyActivitiesTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserMonthlyActivitiesTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserMonthlyActivitiesTable.__proto__ || Object.getPrototypeOf(UserMonthlyActivitiesTable)).call.apply(_ref, [this].concat(args))), _this), _this.onWeekdaySelect = function () {
      _this.props.updateUI({ weekdaySelect: !_this.props.ui.weekdaySelect });
      var updateDates = _lodash2.default.map(_this.props.report_status, function (item) {
        if (item.theme === "default") {
          return _extends({}, item, {
            submission: !_this.props.ui.weekdaySelect
          });
        }
        return item;
      });
      _this.props.saveSchedules(_this.props.group_id, updateDates, _this.props.user_id);
    }, _this.onEdit = function () {
      return _this.props.changeEdit();
    }, _this.onCancel = function () {
      _this.props.changeEdit();
      _this.props.updateUI({ weekdaySelect: false, save: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserMonthlyActivitiesTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          isMonthlyFetchFailed = _props.isMonthlyFetchFailed,
          activityReport = _props.activityReport,
          user_id = _props.user_id,
          current_user_id = _props.current_user_id,
          group_id = _props.group_id,
          date = _props.date,
          edit = _props.edit,
          fetchMonthlyActivityReport = _props.fetchMonthlyActivityReport,
          report_status = _props.report_status,
          changeEdit = _props.changeEdit,
          schedules = _props.schedules,
          report_two_rows = _props.report_two_rows,
          saveSchedules = _props.saveSchedules,
          group_admin = _props.group_admin;


      return _react2.default.createElement(
        'div',
        null,
        user_id && current_user_id && (user_id == current_user_id || group_admin) && _react2.default.createElement(
          'div',
          { style: { margin: '1% 5%', display: 'flex', justifyContent: 'flex-end' } },
          edit && _react2.default.createElement(
            'div',
            { style: { margin: '15px auto 0px 10px' } },
            ui.save && _react2.default.createElement(_font_icon2.default, { value: 'check_circle', className: _userMonthlyActivitiesTable4.default.save_msg }),
            _react2.default.createElement(
              'span',
              { style: { fontSize: 14 } },
              ui.save ? t('label:提出予定登録') : t('label:提出予定登録説明')
            )
          ),
          edit && _react2.default.createElement(_checkbox2.default, { className: _userMonthlyActivitiesTable4.default.checkbox, checked: ui.weekdaySelect, label: t('label:平日をすべて選択'), onChange: this.onWeekdaySelect }),
          _react2.default.createElement(_button.Button, { raised: true, primary: !edit,
            icon: edit ? "" : "edit",
            label: edit ? "完了" : "編集",
            onClick: edit ? this.onCancel : this.onEdit,
            style: { verticalAlign: 'bottom', margin: '4px 6px 6px' } })
        ),
        !isMonthlyFetchFailed && report_two_rows && report_two_rows.length > 0 && _react2.default.createElement(ReportStatusTable, { t: t,
          report_two_rows: report_two_rows,
          activityReport: activityReport,
          check: ui.check,
          edit: edit,
          ui: ui,
          group_id: group_id,
          user_id: user_id,
          saveSchedules: saveSchedules,
          report_status: report_status,
          updateUI: updateUI }),
        isMonthlyFetchFailed && _react2.default.createElement(
          'div',
          { style: { marginTop: '10px', textAlign: 'center' } },
          t('label:データの取得に失敗しました')
        )
      );
    }
  }]);

  return UserMonthlyActivitiesTable;
}(_react2.default.Component);

var RawUserMonthlyActivitiesTable = exports.RawUserMonthlyActivitiesTable = UserMonthlyActivitiesTable;
exports.default = (0, _userMonthlyActivitiesTable2.default)(UserMonthlyActivitiesTable);

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2594);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./favorite-button.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./favorite-button.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(2599),
    baseGt = __webpack_require__(2600),
    baseIteratee = __webpack_require__(139);

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
    : undefined;
}

module.exports = maxBy;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2603);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./kpi.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./kpi.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var circle_1 = __webpack_require__(1073);
exports.default = circle_1.Circle;
__export(__webpack_require__(1073));


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_1 = __webpack_require__(0);
var radius = 175;
var diameter = Math.round(Math.PI * radius * 2);
var getOffset = function (val) {
    if (val === void 0) { val = 0; }
    return Math.round((100 - val) / 100 * diameter);
};
var Circle = (function (_super) {
    __extends(Circle, _super);
    function Circle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Circle.prototype, "text", {
        get: function () {
            var _a = this.props, progress = _a.progress, showPercentage = _a.showPercentage, textColor = _a.textColor, textStyle = _a.textStyle, percentSpacing = _a.percentSpacing, showPercentageSymbol = _a.showPercentageSymbol;
            if (!showPercentage)
                return;
            return (React.createElement("text", { style: textStyle, fill: textColor, x: "50%", y: "50%", dx: "-25", textAnchor: "middle" },
                progress,
                showPercentageSymbol && React.createElement("tspan", { dx: percentSpacing }, "%")));
        },
        enumerable: true,
        configurable: true
    });
    Circle.prototype.render = function () {
        var text = this.text;
        var _a = this.props, progress = Math.min(_a.progress, 100), size = _a.size, bgColor = _a.bgColor, progressColor = _a.progressColor, lineWidth = _a.lineWidth, animate = _a.animate, animationDuration = _a.animationDuration, roundedStroke = _a.roundedStroke, responsive = _a.responsive, onAnimationEnd = _a.onAnimationEnd;
        var strokeDashoffset = getOffset(progress);
        var transition = animate ? "stroke-dashoffset " + animationDuration + " ease-out" : null;
        var strokeLinecap = roundedStroke ? 'round' : 'butt';
        var svgSize = responsive ? '100%' : size;
        return (React.createElement("svg", { width: svgSize, height: svgSize, viewBox: "-25 -25 400 400" },
            React.createElement("circle", { stroke: bgColor, cx: "175", cy: "175", r: "175", strokeWidth: lineWidth, fill: "none" }),
            React.createElement("circle", { stroke: progressColor, transform: "rotate(-90 175 175)", cx: "175", cy: "175", r: "175", strokeDasharray: "1100", strokeWidth: lineWidth, strokeDashoffset: "1100", strokeLinecap: strokeLinecap, fill: "none", style: { strokeDashoffset: strokeDashoffset, transition: transition }, onTransitionEnd: onAnimationEnd }),
            text));
    };
    Circle.defaultProps = {
        progress: 0,
        animate: true,
        animationDuration: '1s',
        showPercentage: true,
        showPercentageSymbol: true,
        progressColor: 'rgb(76, 154, 255)',
        bgColor: '#ecedf0',
        textColor: '#6b778c',
        size: '100',
        lineWidth: '25',
        percentSpacing: 10,
        textStyle: { font: 'bold 4rem Helvetica, Arial, sans-serif' }
    };
    return Circle;
}(react_1.Component));
exports.Circle = Circle;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2613);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./kpi-chart-table.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./kpi-chart-table.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));
//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * This is utility that handles onWheel events and calls provided wheel
 * callback with correct frame rate.
 *
 * @providesModule ReactWheelHandler
 * @typechecks
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _emptyFunction = __webpack_require__(207);

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _normalizeWheel = __webpack_require__(2631);

var _normalizeWheel2 = _interopRequireDefault(_normalizeWheel);

var _requestAnimationFramePolyfill = __webpack_require__(571);

var _requestAnimationFramePolyfill2 = _interopRequireDefault(_requestAnimationFramePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactWheelHandler = function () {
  /**
   * onWheel is the callback that will be called with right frame rate if
   * any wheel events happened
   * onWheel should is to be called with two arguments: deltaX and deltaY in
   * this order
   */
  function ReactWheelHandler(
  /*function*/onWheel,
  /*boolean|function*/handleScrollX,
  /*boolean|function*/handleScrollY,
  /*?boolean|?function*/stopPropagation) {
    _classCallCheck(this, ReactWheelHandler);

    this._animationFrameID = null;
    this._deltaX = 0;
    this._deltaY = 0;
    this._didWheel = this._didWheel.bind(this);
    if (typeof handleScrollX !== 'function') {
      handleScrollX = handleScrollX ? _emptyFunction2.default.thatReturnsTrue : _emptyFunction2.default.thatReturnsFalse;
    }

    if (typeof handleScrollY !== 'function') {
      handleScrollY = handleScrollY ? _emptyFunction2.default.thatReturnsTrue : _emptyFunction2.default.thatReturnsFalse;
    }

    if (typeof stopPropagation !== 'function') {
      stopPropagation = stopPropagation ? _emptyFunction2.default.thatReturnsTrue : _emptyFunction2.default.thatReturnsFalse;
    }

    this._handleScrollX = handleScrollX;
    this._handleScrollY = handleScrollY;
    this._stopPropagation = stopPropagation;
    this._onWheelCallback = onWheel;
    this.onWheel = this.onWheel.bind(this);
  }

  _createClass(ReactWheelHandler, [{
    key: 'onWheel',
    value: function onWheel( /*object*/event) {
      var normalizedEvent = (0, _normalizeWheel2.default)(event);
      var deltaX = this._deltaX + normalizedEvent.pixelX;
      var deltaY = this._deltaY + normalizedEvent.pixelY;
      var handleScrollX = this._handleScrollX(deltaX, deltaY);
      var handleScrollY = this._handleScrollY(deltaY, deltaX);
      if (!handleScrollX && !handleScrollY) {
        return;
      }

      this._deltaX += handleScrollX ? normalizedEvent.pixelX : 0;
      this._deltaY += handleScrollY ? normalizedEvent.pixelY : 0;
      event.preventDefault();

      var changed;
      if (this._deltaX !== 0 || this._deltaY !== 0) {
        if (this._stopPropagation()) {
          event.stopPropagation();
        }
        changed = true;
      }

      if (changed === true && this._animationFrameID === null) {
        this._animationFrameID = (0, _requestAnimationFramePolyfill2.default)(this._didWheel);
      }
    }
  }, {
    key: '_didWheel',
    value: function _didWheel() {
      this._animationFrameID = null;
      this._onWheelCallback(this._deltaX, this._deltaY);
      this._deltaX = 0;
      this._deltaY = 0;
    }
  }]);

  return ReactWheelHandler;
}();

module.exports = ReactWheelHandler;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */

/*jslint evil: true */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ExecutionEnvironment = __webpack_require__(1079);

var _ExecutionEnvironment2 = _interopRequireDefault(_ExecutionEnvironment);

var _camelize = __webpack_require__(2644);

var _camelize2 = _interopRequireDefault(_camelize);

var _invariant = __webpack_require__(292);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var memoized = {}; /**
                    * Copyright Schrodinger, LLC
                    * All rights reserved.
                    *
                    * This source code is licensed under the BSD-style license found in the
                    * LICENSE file in the root directory of this source tree. An additional grant
                    * of patent rights can be found in the PATENTS file in the same directory.
                    *
                    * @providesModule getVendorPrefixedName
                    * @typechecks
                    */

var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
var prefixRegex = new RegExp('^(' + prefixes.join('|') + ')');
var testStyle = _ExecutionEnvironment2.default.canUseDOM ? document.createElement('div').style : {};

function getWithPrefix(name) {
  for (var i = 0; i < prefixes.length; i++) {
    var prefixedName = prefixes[i] + name;
    if (prefixedName in testStyle) {
      return prefixedName;
    }
  }
  return null;
}

/**
 * @param {string} property Name of a css property to check for.
 * @return {?string} property name supported in the browser, or null if not
 * supported.
 */
function getVendorPrefixedName(property) {
  var name = (0, _camelize2.default)(property);
  if (memoized[name] === undefined) {
    var capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
    if (prefixRegex.test(capitalizedName)) {
      (0, _invariant2.default)(false, 'getVendorPrefixedName must only be called with unprefixed' + 'CSS property names. It was called with %s', property);
    }
    memoized[name] = name in testStyle ? name : getWithPrefix(capitalizedName);
  }
  return memoized[name];
}

module.exports = getVendorPrefixedName;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FixedDataTableRow
 * @typechecks
 */



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FixedDataTableCellGroup = __webpack_require__(2649);

var _FixedDataTableCellGroup2 = _interopRequireDefault(_FixedDataTableCellGroup);

var _cx = __webpack_require__(151);

var _cx2 = _interopRequireDefault(_cx);

var _joinClasses = __webpack_require__(293);

var _joinClasses2 = _interopRequireDefault(_joinClasses);

var _FixedDataTableTranslateDOMPosition = __webpack_require__(391);

var _FixedDataTableTranslateDOMPosition2 = _interopRequireDefault(_FixedDataTableTranslateDOMPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// .fixedDataTableLayout/header border-bottom-width
var HEADER_BORDER_BOTTOM_WIDTH = 1;

/**
 * Component that renders the row for <FixedDataTable />.
 * This component should not be used directly by developer. Instead,
 * only <FixedDataTable /> should use the component internally.
 */

var FixedDataTableRowImpl = function (_React$Component) {
  _inherits(FixedDataTableRowImpl, _React$Component);

  function FixedDataTableRowImpl() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FixedDataTableRowImpl);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FixedDataTableRowImpl.__proto__ || Object.getPrototypeOf(FixedDataTableRowImpl)).call.apply(_ref, [this].concat(args))), _this), _this.mouseLeaveIndex = null, _this._getColumnsWidth = function ( /*array*/columns) /*number*/{
      var width = 0;
      for (var i = 0; i < columns.length; ++i) {
        width += columns[i].props.width;
      }
      return width;
    }, _this._getRowExpanded = function ( /*number*/subRowHeight) /*?object*/{
      if (_this.props.rowExpanded) {
        var rowExpandedProps = {
          rowIndex: _this.props.index,
          height: subRowHeight,
          width: _this.props.width
        };

        var rowExpanded;
        if (_React2.default.isValidElement(_this.props.rowExpanded)) {
          rowExpanded = _React2.default.cloneElement(_this.props.rowExpanded, rowExpandedProps);
        } else if (typeof _this.props.rowExpanded === 'function') {
          rowExpanded = _this.props.rowExpanded(rowExpandedProps);
        }

        return rowExpanded;
      }
    }, _this._renderColumnsLeftShadow = function ( /*number*/left) /*?object*/{
      var className = (0, _cx2.default)({
        'fixedDataTableRowLayout/fixedColumnsDivider': left > 0,
        'fixedDataTableRowLayout/columnsShadow': _this.props.scrollLeft > 0,
        'public/fixedDataTableRow/fixedColumnsDivider': left > 0,
        'public/fixedDataTableRow/columnsShadow': _this.props.scrollLeft > 0
      });
      var dividerHeight = _this.props.cellGroupWrapperHeight ? _this.props.cellGroupWrapperHeight - HEADER_BORDER_BOTTOM_WIDTH : _this.props.height;
      var style = {
        left: left,
        height: dividerHeight
      };
      return _React2.default.createElement('div', { className: className, style: style });
    }, _this._renderFixedRightColumnsShadow = function ( /*number*/left) /*?object*/{
      var className = (0, _cx2.default)('fixedDataTableRowLayout/columnsShadow', 'fixedDataTableRowLayout/columnsRightShadow', 'fixedDataTableRowLayout/fixedColumnsDivider', 'public/fixedDataTableRow/columnsShadow', 'public/fixedDataTableRow/columnsRightShadow', 'public/fixedDataTableRow/fixedColumnsDivider');
      var style = {
        height: _this.props.height,
        left: left
      };
      return _React2.default.createElement('div', { className: className, style: style });
    }, _this._renderColumnsRightShadow = function ( /*number*/totalWidth) /*?object*/{
      if (Math.ceil(_this.props.scrollLeft + _this.props.width) < Math.floor(totalWidth)) {
        var className = (0, _cx2.default)('fixedDataTableRowLayout/columnsShadow', 'fixedDataTableRowLayout/columnsRightShadow', 'public/fixedDataTableRow/columnsShadow', 'public/fixedDataTableRow/columnsRightShadow');
        var style = {
          height: _this.props.height
        };
        return _React2.default.createElement('div', { className: className, style: style });
      }
    }, _this._onClick = function ( /*object*/event) {
      _this.props.onClick(event, _this.props.index);
    }, _this._onDoubleClick = function ( /*object*/event) {
      _this.props.onDoubleClick(event, _this.props.index);
    }, _this._onMouseUp = function ( /*object*/event) {
      _this.props.onMouseUp(event, _this.props.index);
    }, _this._onMouseDown = function ( /*object*/event) {
      _this.props.onMouseDown(event, _this.props.index);
    }, _this._onMouseEnter = function ( /*object*/event) {
      /**
       * This is necessary so that onMouseLeave is fired with the initial
       * row index since this row could be updated with a different index
       * when scrolling.
       */
      _this.mouseLeaveIndex = _this.props.index;
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event, _this.props.index);
      }
    }, _this._onMouseLeave = function ( /*object*/event) {
      if (_this.mouseLeaveIndex === null) {
        _this.mouseLeaveIndex = _this.props.index;
      }
      _this.props.onMouseLeave(event, _this.mouseLeaveIndex);
      _this.mouseLeaveIndex = null;
    }, _this._onTouchStart = function ( /*object*/event) {
      _this.props.onTouchStart(event, _this.props.index);
    }, _this._onTouchEnd = function ( /*object*/event) {
      _this.props.onTouchEnd(event, _this.props.index);
    }, _this._onTouchMove = function ( /*object*/event) {
      _this.props.onTouchMove(event, _this.props.index);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * The index of a row for which to fire the onMouseLeave event.
   */


  _createClass(FixedDataTableRowImpl, [{
    key: 'render',
    value: function render() /*object*/{
      var subRowHeight = this.props.subRowHeight || 0;
      var style = {
        width: this.props.width,
        height: this.props.height + subRowHeight
      };
      var className = (0, _cx2.default)({
        'fixedDataTableRowLayout/main': true,
        'public/fixedDataTableRow/main': true,
        'public/fixedDataTableRow/highlighted': this.props.index % 2 === 1,
        'public/fixedDataTableRow/odd': this.props.index % 2 === 1,
        'public/fixedDataTableRow/even': this.props.index % 2 === 0
      });
      var fixedColumnsWidth = this._getColumnsWidth(this.props.fixedColumns);
      var fixedColumns = _React2.default.createElement(_FixedDataTableCellGroup2.default, {
        key: 'fixed_cells',
        isScrolling: this.props.isScrolling,
        height: this.props.height,
        cellGroupWrapperHeight: this.props.cellGroupWrapperHeight,
        left: 0,
        width: fixedColumnsWidth,
        zIndex: 2,
        columns: this.props.fixedColumns,
        touchEnabled: this.props.touchEnabled,
        onColumnResize: this.props.onColumnResize,
        onColumnReorder: this.props.onColumnReorder,
        onColumnReorderMove: this.props.onColumnReorderMove,
        onColumnReorderEnd: this.props.onColumnReorderEnd,
        isColumnReordering: this.props.isColumnReordering,
        columnReorderingData: this.props.columnReorderingData,
        rowHeight: this.props.height,
        rowIndex: this.props.index
      });
      var columnsLeftShadow = this._renderColumnsLeftShadow(fixedColumnsWidth);
      var fixedRightColumnsWidth = this._getColumnsWidth(this.props.fixedRightColumns);
      var fixedRightColumns = _React2.default.createElement(_FixedDataTableCellGroup2.default, {
        key: 'fixed_right_cells',
        isScrolling: this.props.isScrolling,
        height: this.props.height,
        cellGroupWrapperHeight: this.props.cellGroupWrapperHeight,
        offsetLeft: this.props.width - fixedRightColumnsWidth,
        width: fixedRightColumnsWidth,
        zIndex: 2,
        columns: this.props.fixedRightColumns,
        touchEnabled: this.props.touchEnabled,
        onColumnResize: this.props.onColumnResize,
        onColumnReorder: this.props.onColumnReorder,
        onColumnReorderMove: this.props.onColumnReorderMove,
        onColumnReorderEnd: this.props.onColumnReorderEnd,
        isColumnReordering: this.props.isColumnReordering,
        columnReorderingData: this.props.columnReorderingData,
        rowHeight: this.props.height,
        rowIndex: this.props.index
      });
      var fixedRightColumnsShdadow = fixedRightColumnsWidth ? this._renderFixedRightColumnsShadow(this.props.width - fixedRightColumnsWidth - 5) : null;
      var scrollableColumns = _React2.default.createElement(_FixedDataTableCellGroup2.default, {
        key: 'scrollable_cells',
        isScrolling: this.props.isScrolling,
        height: this.props.height,
        cellGroupWrapperHeight: this.props.cellGroupWrapperHeight,
        align: 'right',
        left: this.props.scrollLeft,
        offsetLeft: fixedColumnsWidth,
        width: this.props.width - fixedColumnsWidth - fixedRightColumnsWidth,
        zIndex: 0,
        columns: this.props.scrollableColumns,
        touchEnabled: this.props.touchEnabled,
        onColumnResize: this.props.onColumnResize,
        onColumnReorder: this.props.onColumnReorder,
        onColumnReorderMove: this.props.onColumnReorderMove,
        onColumnReorderEnd: this.props.onColumnReorderEnd,
        isColumnReordering: this.props.isColumnReordering,
        columnReorderingData: this.props.columnReorderingData,
        rowHeight: this.props.height,
        rowIndex: this.props.index
      });
      var scrollableColumnsWidth = this._getColumnsWidth(this.props.scrollableColumns);
      var columnsRightShadow = this._renderColumnsRightShadow(fixedColumnsWidth + scrollableColumnsWidth);
      var rowExpanded = this._getRowExpanded(subRowHeight);
      var rowExpandedStyle = {
        height: subRowHeight,
        top: this.props.height,
        width: this.props.width
      };

      return _React2.default.createElement(
        'div',
        {
          className: (0, _joinClasses2.default)(className, this.props.className),
          onClick: this.props.onClick ? this._onClick : null,
          onDoubleClick: this.props.onDoubleClick ? this._onDoubleClick : null,
          onMouseDown: this.props.onMouseDown ? this._onMouseDown : null,
          onMouseUp: this.props.onMouseUp ? this._onMouseUp : null,
          onMouseEnter: this.props.onMouseEnter || this.props.onMouseLeave ? this._onMouseEnter : null,
          onMouseLeave: this.props.onMouseLeave ? this._onMouseLeave : null,
          onTouchStart: this.props.onTouchStart ? this._onTouchStart : null,
          onTouchEnd: this.props.onTouchEnd ? this._onTouchEnd : null,
          onTouchMove: this.props.onTouchMove ? this._onTouchMove : null,
          style: style },
        _React2.default.createElement(
          'div',
          { className: (0, _cx2.default)('fixedDataTableRowLayout/body') },
          fixedColumns,
          scrollableColumns,
          columnsLeftShadow,
          fixedRightColumns,
          fixedRightColumnsShdadow
        ),
        rowExpanded && _React2.default.createElement(
          'div',
          {
            className: (0, _cx2.default)('fixedDataTableRowLayout/rowExpanded'),
            style: rowExpandedStyle },
          rowExpanded
        ),
        columnsRightShadow
      );
    }
  }]);

  return FixedDataTableRowImpl;
}(_React2.default.Component);

FixedDataTableRowImpl.propTypes = {

  isScrolling: _propTypes2.default.bool,

  /**
   * Array of <FixedDataTableColumn /> for the fixed columns.
   */
  fixedColumns: _propTypes2.default.array.isRequired,

  /**
   * Array of <FixedDataTableColumn /> for the fixed columns positioned at end of the table.
   */
  fixedRightColumns: _propTypes2.default.array.isRequired,

  /**
   * Height of the row.
   */
  height: _propTypes2.default.number.isRequired,

  /**
   * Height of fixedDataTableCellGroupLayout/cellGroupWrapper.
   */
  cellGroupWrapperHeight: _propTypes2.default.number,

  /**
   * Height of the content to be displayed below the row.
   */
  subRowHeight: _propTypes2.default.number,

  /**
   * the row expanded.
   */
  rowExpanded: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),

  /**
   * The row index.
   */
  index: _propTypes2.default.number.isRequired,

  /**
   * Array of <FixedDataTableColumn /> for the scrollable columns.
   */
  scrollableColumns: _propTypes2.default.array.isRequired,

  /**
   * The distance between the left edge of the table and the leftmost portion
   * of the row currently visible in the table.
   */
  scrollLeft: _propTypes2.default.number.isRequired,

  /**
   * Width of the row.
   */
  width: _propTypes2.default.number.isRequired,

  /**
   * Fire when a row is clicked.
   */
  onClick: _propTypes2.default.func,

  /**
   * Fire when a row is double clicked.
   */
  onDoubleClick: _propTypes2.default.func,

  /**
   * Callback for when resizer knob (in FixedDataTableCell) is clicked
   * to initialize resizing. Please note this is only on the cells
   * in the header.
   * @param number combinedWidth
   * @param number leftOffset
   * @param number cellWidth
   * @param number|string columnKey
   * @param object event
   */
  onColumnResize: _propTypes2.default.func,

  isColumnReordering: _propTypes2.default.bool,
  /**
   * Callback for when reorder handle (in FixedDataTableCell) is clicked
   * to initialize reordering. Please note this is only on the cells
   * in the header.
   * @param number|string columnKey
   * @param number cellWidth
   * @param number leftOffset
   * @param object event
   */
  onColumnReorder: _propTypes2.default.func,

  /**
   * Callback for when a cell is moved while reordering.
   * @param number distance
   */
  onColumnReorderMove: _propTypes2.default.func,

  /**
   * Callback for when the mouse is released to complete reordering.
   * @param number distance
   */
  onColumnReorderEnd: _propTypes2.default.func,

  touchEnabled: _propTypes2.default.bool
};

var FixedDataTableRow = function (_React$Component2) {
  _inherits(FixedDataTableRow, _React$Component2);

  function FixedDataTableRow() {
    _classCallCheck(this, FixedDataTableRow);

    return _possibleConstructorReturn(this, (FixedDataTableRow.__proto__ || Object.getPrototypeOf(FixedDataTableRow)).apply(this, arguments));
  }

  _createClass(FixedDataTableRow, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._initialRender = true;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._initialRender = false;
    }
  }, {
    key: 'render',
    value: function render() /*object*/{
      var style = {
        width: this.props.width,
        height: this.props.height,
        zIndex: this.props.zIndex ? this.props.zIndex : 0
      };
      (0, _FixedDataTableTranslateDOMPosition2.default)(style, 0, this.props.offsetTop, this._initialRender);

      return _React2.default.createElement(
        'div',
        {
          style: style,
          className: (0, _cx2.default)('fixedDataTableRowLayout/rowWrapper') },
        _React2.default.createElement(FixedDataTableRowImpl, _extends({}, this.props, {
          offsetTop: undefined,
          zIndex: undefined
        }))
      );
    }
  }]);

  return FixedDataTableRow;
}(_React2.default.Component);

FixedDataTableRow.propTypes = {

  isScrolling: _propTypes2.default.bool,

  /**
   * Height of the row.
   */
  height: _propTypes2.default.number.isRequired,

  /**
   * Z-index on which the row will be displayed. Used e.g. for keeping
   * header and footer in front of other rows.
   */
  zIndex: _propTypes2.default.number,

  /**
   * The vertical position where the row should render itself
   */
  offsetTop: _propTypes2.default.number.isRequired,

  /**
   * Width of the row.
   */
  width: _propTypes2.default.number.isRequired
};


module.exports = FixedDataTableRow;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FixedDataTableHelper
 * @typechecks
 */



var _Locale = __webpack_require__(574);

var _Locale2 = _interopRequireDefault(_Locale);

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _FixedDataTableColumnGroup = __webpack_require__(1083);

var _FixedDataTableColumnGroup2 = _interopRequireDefault(_FixedDataTableColumnGroup);

var _FixedDataTableColumn = __webpack_require__(1084);

var _FixedDataTableColumn2 = _interopRequireDefault(_FixedDataTableColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DIR_SIGN = _Locale2.default.isRTL() ? -1 : +1;
// A cell up to 5px outside of the visible area will still be considered visible
var CELL_VISIBILITY_TOLERANCE = 5; // used for flyouts

function renderToString(value) /*string*/{
  if (value === null || value === undefined) {
    return '';
  } else {
    return String(value);
  }
}

/**
 * Helper method to execute a callback against all columns given the children
 * of a table.
 * @param {?object|array} children
 *    Children of a table.
 * @param {function} callback
 *    Function to excecute for each column. It is passed the column.
 */
function forEachColumn(children, callback) {
  _React2.default.Children.forEach(children, function (child) {
    if (child.type === _FixedDataTableColumnGroup2.default) {
      forEachColumn(child.props.children, callback);
    } else if (child.type === _FixedDataTableColumn2.default) {
      callback(child);
    }
  });
}

/**
 * Helper method to map columns to new columns. This takes into account column
 * groups and will generate a new column group if its columns change.
 * @param {?object|array} children
 *    Children of a table.
 * @param {function} callback
 *    Function to excecute for each column. It is passed the column and should
 *    return a result column.
 */
function mapColumns(children, callback) {
  var newChildren = [];
  _React2.default.Children.forEach(children, function (originalChild) {
    var newChild = originalChild;

    // The child is either a column group or a column. If it is a column group
    // we need to iterate over its columns and then potentially generate a
    // new column group
    if (originalChild.type === _FixedDataTableColumnGroup2.default) {
      var haveColumnsChanged = false;
      var newColumns = [];

      forEachColumn(originalChild.props.children, function (originalcolumn) {
        var newColumn = callback(originalcolumn);
        if (newColumn !== originalcolumn) {
          haveColumnsChanged = true;
        }
        newColumns.push(newColumn);
      });

      // If the column groups columns have changed clone the group and supply
      // new children
      if (haveColumnsChanged) {
        newChild = _React2.default.cloneElement(originalChild, {
          children: newColumns
        });
      }
    } else if (originalChild.type === _FixedDataTableColumn2.default) {
      newChild = callback(originalChild);
    }

    newChildren.push(newChild);
  });

  return newChildren;
}

var FixedDataTableHelper = {
  DIR_SIGN: DIR_SIGN,
  CELL_VISIBILITY_TOLERANCE: CELL_VISIBILITY_TOLERANCE,
  renderToString: renderToString,
  forEachColumn: forEachColumn,
  mapColumns: mapColumns
};

module.exports = FixedDataTableHelper;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Schrodinger, LLC
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @providesModule FixedDataTableColumnGroup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @typechecks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * Component that defines the attributes of a table column group.
 */
var FixedDataTableColumnGroup = function (_React$Component) {
  _inherits(FixedDataTableColumnGroup, _React$Component);

  function FixedDataTableColumnGroup() {
    _classCallCheck(this, FixedDataTableColumnGroup);

    return _possibleConstructorReturn(this, (FixedDataTableColumnGroup.__proto__ || Object.getPrototypeOf(FixedDataTableColumnGroup)).apply(this, arguments));
  }

  _createClass(FixedDataTableColumnGroup, [{
    key: 'render',
    value: function render() {
      if (false) {
        throw new Error('Component <FixedDataTableColumnGroup /> should never render');
      }
      return null;
    }
  }]);

  return FixedDataTableColumnGroup;
}(_React2.default.Component);

FixedDataTableColumnGroup.__TableColumnGroup__ = true;
FixedDataTableColumnGroup.propTypes = {
  /**
   * The horizontal alignment of the table cell content.
   */
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),

  /**
   * Controls if the column group is fixed when scrolling in the X axis.
   */
  fixed: _propTypes2.default.bool,

  /**
   * This is the header cell for this column group.
   * This can either be a string or a React element. Passing in a string
   * will render a default footer cell with that string. By default, the React
   * element passed in can expect to receive the following props:
   *
   * ```
   * props: {
   *   height: number // (supplied from the groupHeaderHeight)
   *   width: number // (supplied from the Column)
   * }
   * ```
   *
   * Because you are passing in your own React element, you can feel free to
   * pass in whatever props you may want or need.
   *
   * You can also pass in a function that returns a react elemnt, with the
   * props object above passed in as the first parameter.
   */
  header: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])

};
FixedDataTableColumnGroup.defaultProps = {
  fixed: false
};


module.exports = FixedDataTableColumnGroup;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Schrodinger, LLC
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @providesModule FixedDataTableColumn
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @typechecks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * Component that defines the attributes of table column.
 */
var FixedDataTableColumn = function (_React$Component) {
  _inherits(FixedDataTableColumn, _React$Component);

  function FixedDataTableColumn() {
    _classCallCheck(this, FixedDataTableColumn);

    return _possibleConstructorReturn(this, (FixedDataTableColumn.__proto__ || Object.getPrototypeOf(FixedDataTableColumn)).apply(this, arguments));
  }

  _createClass(FixedDataTableColumn, [{
    key: 'render',
    value: function render() {
      if (false) {
        throw new Error('Component <FixedDataTableColumn /> should never render');
      }
      return null;
    }
  }]);

  return FixedDataTableColumn;
}(_React2.default.Component);

FixedDataTableColumn.__TableColumn__ = true;
FixedDataTableColumn.propTypes = {
  /**
   * The horizontal alignment of the table cell content.
   */
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),

  /**
   * Controls if the column is fixed when scrolling in the X axis.
   */
  fixed: _propTypes2.default.bool,

  /**
   * Controls if the column is fixed to the right side of the table when scrolling in the X axis.
   */
  fixedRight: _propTypes2.default.bool,

  /**
   * The header cell for this column.
   * This can either be a string a React element, or a function that generates
   * a React Element. Passing in a string will render a default header cell
   * with that string. By default, the React element passed in can expect to
   * receive the following props:
   *
   * ```
   * props: {
   *   columnKey: string // (of the column, if given)
   *   height: number // (supplied from the Table or rowHeightGetter)
   *   width: number // (supplied from the Column)
   * }
   * ```
   *
   * Because you are passing in your own React element, you can feel free to
   * pass in whatever props you may want or need.
   *
   * If you pass in a function, you will receive the same props object as the
   * first argument.
   */
  header: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),

  /**
   * This is the body cell that will be cloned for this column.
   * This can either be a string a React element, or a function that generates
   * a React Element. Passing in a string will render a default header cell
   * with that string. By default, the React element passed in can expect to
   * receive the following props:
   *
   * ```
   * props: {
   *   rowIndex; number // (the row index of the cell)
   *   columnKey: string // (of the column, if given)
   *   height: number // (supplied from the Table or rowHeightGetter)
   *   width: number // (supplied from the Column)
   * }
   * ```
   *
   * Because you are passing in your own React element, you can feel free to
   * pass in whatever props you may want or need.
   *
   * If you pass in a function, you will receive the same props object as the
   * first argument.
   */
  cell: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),

  /**
   * This is the footer cell for this column.
   * This can either be a string a React element, or a function that generates
   * a React Element. Passing in a string will render a default header cell
   * with that string. By default, the React element passed in can expect to
   * receive the following props:
   *
   * ```
   * props: {
   *   columnKey: string // (of the column, if given)
   *   height: number // (supplied from the Table or rowHeightGetter)
   *   width: number // (supplied from the Column)
   * }
   * ```
   *
   * Because you are passing in your own React element, you can feel free to
   * pass in whatever props you may want or need.
   *
   * If you pass in a function, you will receive the same props object as the
   * first argument.
   */
  footer: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),

  /**
   * This is used to uniquely identify the column, and is not required unless
   * you a resizing columns. This will be the key given in the
   * `onColumnResizeEndCallback` on the Table.
   */
  columnKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * The pixel width of the column.
   */
  width: _propTypes2.default.number.isRequired,

  /**
   * If this is a resizable column this is its minimum pixel width.
   */
  minWidth: _propTypes2.default.number,

  /**
   * If this is a resizable column this is its maximum pixel width.
   */
  maxWidth: _propTypes2.default.number,

  /**
   * The grow factor relative to other columns. Same as the flex-grow API
   * from http://www.w3.org/TR/css3-flexbox/. Basically, take any available
   * extra width and distribute it proportionally according to all columns'
   * flexGrow values. Defaults to zero (no-flexing).
   */
  flexGrow: _propTypes2.default.number,

  /**
   * Whether the column can be resized with the
   * FixedDataTableColumnResizeHandle. Please note that if a column
   * has a flex grow, once you resize the column this will be set to 0.
   *
   * This property only provides the UI for the column resizing. If this
   * is set to true, you will need to set the onColumnResizeEndCallback table
   * property and render your columns appropriately.
   */
  isResizable: _propTypes2.default.bool,

  /**
   * Whether the column can be dragged to reorder.
   */
  isReorderable: _propTypes2.default.bool,

  /**
   * Whether cells in this column can be removed from document when outside
   * of viewport as a result of horizontal scrolling.
   * Setting this property to true allows the table to not render cells in
   * particular column that are outside of viewport for visible rows. This
   * allows to create table with many columns and not have vertical scrolling
   * performance drop.
   * Setting the property to false will keep previous behaviour and keep
   * cell rendered if the row it belongs to is visible.
   */
  allowCellsRecycling: _propTypes2.default.bool,

  /**
   * Flag to enable performance check when rendering. Stops the component from
   * rendering if none of it's passed in props have changed
   */
  pureRendering: _propTypes2.default.bool
};
FixedDataTableColumn.defaultProps = {
  allowCellsRecycling: false,
  fixed: false,
  fixedRight: false
};


module.exports = FixedDataTableColumn;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cx = __webpack_require__(151);

var _cx2 = _interopRequireDefault(_cx);

var _joinClasses = __webpack_require__(293);

var _joinClasses2 = _interopRequireDefault(_joinClasses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright Schrodinger, LLC
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @providesModule FixedDataTableCellDefault
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @typechecks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * Component that handles default cell layout and styling.
 *
 * All props unless specified below will be set onto the top level `div`
 * rendered by the cell.
 *
 * Example usage via from a `Column`:
 * ```
 * const MyColumn = (
 *   <Column
 *     cell={({rowIndex, width, height}) => (
 *       <Cell
 *         width={width}
 *         height={height}
 *         className="my-class">
 *         Cell number: <span>{rowIndex}</span>
*        </Cell>
 *     )}
 *     width={100}
 *   />
 * );
 * ```
 */
var FixedDataTableCellDefault = function (_React$Component) {
  _inherits(FixedDataTableCellDefault, _React$Component);

  function FixedDataTableCellDefault() {
    _classCallCheck(this, FixedDataTableCellDefault);

    return _possibleConstructorReturn(this, (FixedDataTableCellDefault.__proto__ || Object.getPrototypeOf(FixedDataTableCellDefault)).apply(this, arguments));
  }

  _createClass(FixedDataTableCellDefault, [{
    key: 'render',
    value: function render() {
      //Remove some props like columnKey and rowIndex so we don't pass it into the div
      var _props = this.props,
          height = _props.height,
          width = _props.width,
          style = _props.style,
          className = _props.className,
          children = _props.children,
          columnKey = _props.columnKey,
          rowIndex = _props.rowIndex,
          props = _objectWithoutProperties(_props, ['height', 'width', 'style', 'className', 'children', 'columnKey', 'rowIndex']);

      var innerStyle = _extends({
        height: height,
        width: width
      }, style);

      return _React2.default.createElement(
        'div',
        _extends({}, props, {
          className: (0, _joinClasses2.default)((0, _cx2.default)('fixedDataTableCellLayout/wrap1'), (0, _cx2.default)('public/fixedDataTableCell/wrap1'), className),
          style: innerStyle }),
        _React2.default.createElement(
          'div',
          {
            className: (0, _joinClasses2.default)((0, _cx2.default)('fixedDataTableCellLayout/wrap2'), (0, _cx2.default)('public/fixedDataTableCell/wrap2')) },
          _React2.default.createElement(
            'div',
            {
              className: (0, _joinClasses2.default)((0, _cx2.default)('fixedDataTableCellLayout/wrap3'), (0, _cx2.default)('public/fixedDataTableCell/wrap3')) },
            _React2.default.createElement(
              'div',
              { className: (0, _cx2.default)('public/fixedDataTableCell/cellContent') },
              children
            )
          )
        )
      );
    }
  }]);

  return FixedDataTableCellDefault;
}(_React2.default.Component);

FixedDataTableCellDefault.propTypes = {

  /**
   * Outer height of the cell.
   */
  height: _propTypes2.default.number,

  /**
   * Outer width of the cell.
   */
  width: _propTypes2.default.number,

  /**
   * Optional prop that if specified on the `Column` will be passed to the
   * cell. It can be used to uniquely identify which column is the cell is in.
   */
  columnKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Optional prop that represents the rows index in the table.
   * For the 'cell' prop of a Column, this parameter will exist for any
   * cell in a row with a positive index.
   *
   * Below that entry point the user is welcome to consume or
   * pass the prop through at their discretion.
   */
  rowIndex: _propTypes2.default.number
};


module.exports = FixedDataTableCellDefault;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */



/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawChatRoomSettingsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _chatRoomSettingsPage = __webpack_require__(2669);

var _chatRoomSettingsPage2 = _interopRequireDefault(_chatRoomSettingsPage);

var _settingsPage = __webpack_require__(268);

var _chatRoomFormPanel = __webpack_require__(2670);

var _chatRoomFormPanel2 = _interopRequireDefault(_chatRoomFormPanel);

var _chatRoomMembersPanel = __webpack_require__(2672);

var _chatRoomMembersPanel2 = _interopRequireDefault(_chatRoomMembersPanel);

var _chatRoomDeletePanel = __webpack_require__(2674);

var _chatRoomDeletePanel2 = _interopRequireDefault(_chatRoomDeletePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * src/web/components/chat-room-settings-page.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ChatRoomSettingsPage = function (_React$Component) {
  _inherits(ChatRoomSettingsPage, _React$Component);

  function ChatRoomSettingsPage() {
    _classCallCheck(this, ChatRoomSettingsPage);

    return _possibleConstructorReturn(this, (ChatRoomSettingsPage.__proto__ || Object.getPrototypeOf(ChatRoomSettingsPage)).apply(this, arguments));
  }

  _createClass(ChatRoomSettingsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          chatRoom = _props.chatRoom,
          chatRoomName = _props.chatRoomName,
          user = _props.user,
          onClose = _props.onClose,
          name = _props.name,
          _props$open = _props.open,
          open = _props$open === undefined ? false : _props$open;


      return _react2.default.createElement(
        _settingsPage.SettingsPage,
        { title: t('label:チャットルーム設定'),
          active: open,
          onCloseDialog: onClose,
          name: name,
          initialName: 'chat_room_members' },
        _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'chat_room_profile',
          params: { chatRoom: chatRoom, user: user },
          label: t('label:基本設定'),
          icon: 'group_work',
          component: _chatRoomFormPanel2.default }),
        _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'chat_room_members',
          params: { chatRoom: chatRoom, user: user },
          label: t('label:メンバー管理'),
          icon: 'people',
          component: _chatRoomMembersPanel2.default }),
        _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'chat_room_delete',
          params: { chatRoomName: chatRoomName },
          label: t('label:削除'),
          icon: 'remove_circle',
          component: _chatRoomDeletePanel2.default })
      );
    }
  }]);

  return ChatRoomSettingsPage;
}(_react2.default.Component);

var RawChatRoomSettingsPage = exports.RawChatRoomSettingsPage = ChatRoomSettingsPage;
exports.default = (0, _chatRoomSettingsPage2.default)(ChatRoomSettingsPage);

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawChatMessagesPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _chatMessagesPage = __webpack_require__(2676);

var _chatMessagesPage2 = _interopRequireDefault(_chatMessagesPage);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _infiniteScroller = __webpack_require__(75);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _menu = __webpack_require__(63);

var _chatMessageItem = __webpack_require__(2677);

var _chatMessageItem2 = _interopRequireDefault(_chatMessageItem);

var _chatMessageForm = __webpack_require__(2686);

var _chatMessageForm2 = _interopRequireDefault(_chatMessageForm);

var _chatMessage = __webpack_require__(1089);

var _chatMessage2 = _interopRequireDefault(_chatMessage);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _button = __webpack_require__(8);

var _chatRoomSettingsPage = __webpack_require__(1087);

var _chatRoomSettingsPage2 = _interopRequireDefault(_chatRoomSettingsPage);

var _googleDocDialog = __webpack_require__(2688);

var _googleDocDialog2 = _interopRequireDefault(_googleDocDialog);

var _pdfPreviewDialog = __webpack_require__(373);

var _pdfPreviewDialog2 = _interopRequireDefault(_pdfPreviewDialog);

var _chatAlbum = __webpack_require__(2689);

var _chatAlbum2 = _interopRequireDefault(_chatAlbum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/chat-messages-page.jsx

var ChatMessagesPage = function (_React$Component) {
  _inherits(ChatMessagesPage, _React$Component);

  function ChatMessagesPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChatMessagesPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatMessagesPage.__proto__ || Object.getPrototypeOf(ChatMessagesPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clientWidth: 0,
      clientHeight: 0,
      viewportHeight: window.innerHeight,
      isMobile: window.innerWidth <= 768,
      isKeyboardVisible: false
    }, _this.delayScrollBottom = function () {
      setTimeout(function () {
        var div = _reactDom2.default.findDOMNode(_this.scrollDiv);
        if (div) div.scrollTop = div.scrollHeight;
      }, 600);
    }, _this.scrollBottom = function () {
      return setTimeout(function () {
        var div = _reactDom2.default.findDOMNode(_this.scrollDiv);
        if (div) div.scrollTop = div.scrollHeight;
      }, 200);
    }, _this.handleFocusIn = function (e) {
      if (e.target.tagName.toLowerCase() === 'input' || e.target.tagName.toLowerCase() === 'textarea') {
        _this.setState({ isKeyboardVisible: true });
        setTimeout(_this.scrollBottom, 100);
      }
    }, _this.handleFocusOut = function () {
      _this.setState({ isKeyboardVisible: false });
    }, _this.handleViewportResize = function () {
      if (_this.state.isMobile && window.visualViewport) {
        _this.setState({
          viewportHeight: window.visualViewport.height,
          isKeyboardVisible: window.visualViewport.height < window.innerHeight
        });
      }
    }, _this.handleResize = function () {
      var isMobile = window.innerWidth <= 768;
      _this.setState({
        isMobile: isMobile,
        viewportHeight: window.innerHeight
      });
    }, _this.setClientWidth = function () {
      var element = _reactDom2.default.findDOMNode(_this.component);
      if (element) {
        _this.setState({ clientWidth: element.clientWidth, clientHeight: element.clientHeight });
      }
    }, _this.fetchMessages = function () {
      return !_this.props.isFetching && _this.props.fetchMessages(_this.props);
    }, _this.deleteChatMessage = function (message_id) {
      return _this.props.deleteChatMessage(message_id);
    }, _this.openPdf = function (pdf, open) {
      _this.props.updateUI({ pdf: pdf, openPdf: open });
    }, _this.closePdf = function () {
      _this.props.updateUI({ pdf: false, openPdf: false });
    }, _this.openDoc = function (url, open) {
      _this.props.updateUI({ url: url, openDoc: open });
    }, _this.closeDoc = function () {
      _this.props.updateUI({ url: false, openDoc: false });
    }, _this.openAlbum = function () {
      _this.props.updateUI({ openAlbum: true });
    }, _this.closeAlbum = function () {
      _this.props.updateUI({ openAlbum: false });
    }, _this.reactChat = function (message_id, reaction_type) {
      _this.props.reactChat(message_id, reaction_type);
    }, _this.reactionChat = function (message, user_id) {
      var likeExisting = message.likes.some(function (like) {
        return like.user.user_id === user_id;
      });

      if (likeExisting) {
        var like = message.likes.find(function (like) {
          return like.user.user_id === user_id;
        });
        _this.props.unLikeChat(message.message_id, like.like_id);
      } else {
        _this.reactChat(message.message_id, 'good_job');
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChatMessagesPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      setTimeout(this.setClientWidth, 200);
      window.addEventListener('resize', this.setClientWidth);
      if (this.state.isMobile) {
        if ('visualViewport' in window) {
          window.visualViewport.addEventListener('resize', this.handleViewportResize);
        }
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('focusin', this.handleFocusIn);
        document.addEventListener('focusout', this.handleFocusOut);
      }
      this.scrollBottom();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setClientWidth);
      if (this.state.isMobile) {
        if ('visualViewport' in window) {
          window.visualViewport.removeEventListener('resize', this.handleViewportResize);
        }
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('focusin', this.handleFocusIn);
        document.removeEventListener('focusout', this.handleFocusOut);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var prevIds = prevProps.messageData && _lodash2.default.map(prevProps.messageData.slice(0, 3), function (msg) {
        return msg.message_id;
      }) || [];
      var propIds = this.props.messageData && _lodash2.default.map(this.props.messageData.slice(0, 10), function (msg) {
        return msg.message_id;
      }) || [];

      var chatRoomMembers = this.props.chatRoom && this.props.chatRoom.members && this.props.chatRoom.members;
      var prevChatRoomMembers = prevProps.chatRoom && prevProps.chatRoom.members && prevProps.chatRoom.members;

      if (prevIds.length == 0 && propIds.length > 0 || this.props.chatRoom && !prevProps.chatRoom) {
        return this.delayScrollBottom();
      }

      // messageDataの先頭に要素が追加されていたらスクロール位置を末尾に移動する
      _lodash2.default.each(propIds, function (id, i) {
        if (i > 0 && id == prevIds[0] && !_lodash2.default.some(prevIds, function (_id, j) {
          return propIds[i + j] != prevIds[j];
        })) {
          _this2.scrollBottom();
          return false;
        }
      });

      if (chatRoomMembers && prevChatRoomMembers) {
        //メンバーが3名以下になった場合、ダイアログからチャットができないようにする
        //現在のチャットルームのメンバー数が3名以下の場合の条件
        if (chatRoomMembers.length == prevChatRoomMembers.length) {
          if (chatRoomMembers.length < 3 && !this.props.ui.individualChatRoom) {
            this.props.updateUI({ individualChatRoom: true });
          }
        }
        //現在のチャットルームと過去のチャットルームのメンバー数が異なりなおかつ、member数が3名以上/以下の判定
        if (chatRoomMembers.length != prevChatRoomMembers.length) {
          if (chatRoomMembers.length < 3) {
            this.props.updateUI({ individualChatRoom: true });
          } else {
            this.props.updateUI({ individualChatRoom: false });
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          isMobile = _state.isMobile,
          viewportHeight = _state.viewportHeight,
          isKeyboardVisible = _state.isKeyboardVisible;
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          isFetchFailed = _props.isFetchFailed,
          isFetching = _props.isFetching,
          hasMore = _props.hasMore,
          chatRoom = _props.chatRoom,
          chatRoomName = _props.chatRoomName,
          chatMessages = _props.chatMessages,
          user = _props.user,
          readMessage = _props.readMessage,
          otherMembers = _props.otherMembers,
          name = _props.name,
          messageData = _props.messageData,
          likeConfig = _props.likeConfig;


      var rightSidePageStyle = isMobile ? {
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      } : {};

      var containerStyle = isMobile ? {
        display: 'flex',
        height: isKeyboardVisible ? viewportHeight - 45 + 'px' : 'calc(100vh - 135px)',
        flexDirection: 'column',
        position: 'relative',
        flex: 1,
        minHeight: 0
      } : {
        display: 'flex',
        height: 'calc(100vh - 135px)',
        flexDirection: 'column'
      };

      var scrollDivStyle = isMobile ? {
        flexGrow: 1,
        overflow: 'auto',
        background: '#BAD3FF',
        WebkitOverflowScrolling: 'touch',
        paddingBottom: isKeyboardVisible ? '10px' : '60px',
        maxHeight: '100%'
      } : {
        flexGrow: 1,
        overflow: 'auto',
        background: '#BAD3FF'
      };

      var formContainerStyle = isMobile ? {
        position: 'sticky',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'white',
        zIndex: 1000,
        borderTop: '1px solid #e0e0e0',
        paddingBottom: isKeyboardVisible ? 0 : 'env(safe-area-inset-bottom)'
      } : {};
      var sequence = chatRoom && chatRoom.sequence_id ? ' (' + chatRoom.sequence_id + ')' : '';
      return _react2.default.createElement(
        'div',
        { ref: function ref(c) {
            return _this3.component = c;
          }, style: { height: '100%' } },
        ui.openPdf && _react2.default.createElement(_pdfPreviewDialog2.default, { file: ui.pdf, open: ui.openPdf, onClose: this.closePdf, t: t }),
        ui.openAlbum && _react2.default.createElement(_chatAlbum2.default, { chatRoom: chatRoom, open: ui.openAlbum, closeAlbum: this.closeAlbum, openPdf: this.openPdf, t: t }),
        _react2.default.createElement(
          _rightSidePage2.default,
          { title: (!chatRoom || !chatRoom.name) && t('label:ユーザとのチャット', { name: name }) + sequence || chatRoom.name,
            style: rightSidePageStyle,
            image: otherMembers && otherMembers.length == 1 && otherMembers[0].icon_image.thumb_url || undefined,
            members: otherMembers && otherMembers.length > 1 && otherMembers || undefined,
            icon: !otherMembers || otherMembers.length != 1 && "people",
            icon_image: chatRoom && chatRoom.icon_image ? chatRoom.icon_image : undefined,
            rightAction: [_react2.default.createElement(_button.IconButton, { icon: 'photo_library', key: 'menu',
              onClick: function onClick() {
                chatRoom && _this3.openAlbum();
              } }), _react2.default.createElement(_button.IconButton, { icon: 'more_vert', key: 'more',
              onClick: function onClick() {
                chatRoom && _this3.setState(_defineProperty({}, chatRoom.chat_room_id, true) || undefined);
              } })] },
          chatRoom && _react2.default.createElement(_chatRoomSettingsPage2.default, { key: 'page',
            open: this.state[chatRoom.chat_room_id] || false,
            chatRoom: chatRoom,
            chatRoomName: chatRoomName,
            user: user,
            onClose: function onClose() {
              return _this3.setState(_defineProperty({}, chatRoom.chat_room_id, false));
            } }),
          !isFetchFailed && _react2.default.createElement(
            'div',
            { style: containerStyle },
            _react2.default.createElement(
              'div',
              { style: scrollDivStyle, ref: function ref(c) {
                  return _this3.scrollDiv = c;
                } },
              _react2.default.createElement(
                _infiniteScroller.InfiniteScroll,
                { isReverse: true,
                  pageStart: 0,
                  initialLoad: false,
                  loadMore: this.fetchMessages,
                  hasMore: hasMore && !isFetchFailed,
                  loaderHeight: 0,
                  loader: isFetching && _react2.default.createElement(_loading2.default, null),
                  useWindow: false },
                _lodash2.default.reduceRight(messageData, function (result, item) {
                  return result.concat(item.message && _react2.default.createElement(_chatMessageItem2.default, _extends({
                    withName: item.withName,
                    key: item.message_id,
                    message: item.message,
                    readMessage: readMessage,
                    user: user,
                    chatRoomMember: chatRoom && chatRoom.members,
                    individualChatRoom: ui.individualChatRoom,
                    direction: item.message.user.user_id == user.user_id,
                    deleteChatMessage: _this3.deleteChatMessage,
                    chatPageWidth: _this3.state.clientWidth,
                    openPdf: _this3.openPdf,
                    openDoc: _this3.openDoc,
                    likeConfig: likeConfig
                  }, item.message.user.user_id !== user.user_id && {
                    reactionChat: function reactionChat() {
                      return _this3.reactionChat(item.message, user.user_id);
                    }
                  })) || _react2.default.createElement(
                    'div',
                    { key: item.message_id, className: _chatMessage2.default.divider },
                    _react2.default.createElement(
                      'span',
                      { className: _chatMessage2.default.span },
                      item.created_at.format('lll')
                    )
                  ));
                }, []),
                !isFetching && (!chatMessages || chatMessages.length == 0) && _react2.default.createElement(
                  'div',
                  { style: { marginTop: '10px', textAlign: 'center' } },
                  t('label:メッセージがありません')
                )
              )
            ),
            chatRoom && !chatRoom.obsoleted && _react2.default.createElement(
              'div',
              { style: formContainerStyle },
              _react2.default.createElement(_chatMessageForm2.default, { chatRoom: chatRoom })
            ),
            chatRoom && chatRoom.obsoleted && t('label:このチャットは終了しました')
          ),
          isFetchFailed && _react2.default.createElement(
            'div',
            { style: { marginTop: '10px', textAlign: 'center' } },
            t('label:メッセージの取得に失敗しました')
          )
        )
      );
    }
  }]);

  return ChatMessagesPage;
}(_react2.default.Component);

var RawChatMessagesPage = exports.RawChatMessagesPage = ChatMessagesPage;
exports.default = (0, _chatMessagesPage2.default)(ChatMessagesPage);

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2679);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./chat-message.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./chat-message.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

// src/helpers/message-storage.js

exports.default = {
    setItem: function setItem(key, value) {
        return localStorage.setItem(key, value);
    },
    getItem: function getItem(key) {
        return new Promise(function (resolve, reject) {
            resolve(localStorage.getItem(key));
        });
    }
};

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-url-links.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _diaryUploadFiles = __webpack_require__(1056);

var _diaryUploadFiles2 = _interopRequireDefault(_diaryUploadFiles);

var _reactCssThemr = __webpack_require__(10);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _card = __webpack_require__(28);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _googleIcons = __webpack_require__(565);

var _googleIcons2 = _interopRequireDefault(_googleIcons);

var _imageChip = __webpack_require__(1057);

var _imageChip2 = _interopRequireDefault(_imageChip);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiaryUrlLinks = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryUrlLinks, _React$Component);

  function DiaryUrlLinks() {
    _classCallCheck(this, DiaryUrlLinks);

    return _possibleConstructorReturn(this, (DiaryUrlLinks.__proto__ || Object.getPrototypeOf(DiaryUrlLinks)).apply(this, arguments));
  }

  _createClass(DiaryUrlLinks, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          urlLinks = _props.urlLinks,
          onDeleteLink = _props.onDeleteLink,
          isChat = _props.isChat;


      if (!urlLinks || Object.keys(urlLinks).length == 0) return null;

      return _react2.default.createElement(
        _card.CardText,
        { theme: theme, className: isChat ? "chatLinks" : "links" },
        _lodash2.default.map(urlLinks, function (link, url) {
          return link.title && _react2.default.createElement(
            _chip2.default,
            { key: url, theme: link.image_url && _imageChip2.default || undefined, deletable: true, onDeleteClick: function onDeleteClick() {
                return onDeleteLink(url);
              } },
            link.image_url && _react2.default.createElement('img', { className: _imageChip2.default.image, src: link.image_url }),
            link.mime_type && _react2.default.createElement('img', { className: _imageChip2.default.image, src: _googleIcons2.default[link.mime_type] || _googleIcons2.default['default'] }),
            link.title && _react2.default.createElement(
              'span',
              null,
              link.title.length > 30 ? link.title.slice(0, 30) + '...' : link.title
            )
          );
        })
      );
    }
  }]);

  return DiaryUrlLinks;
}(_react2.default.Component)) || _class);
exports.default = DiaryUrlLinks;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _dialog = __webpack_require__(47);

var _dialog2 = _interopRequireDefault(_dialog);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _googleSigninProvider = __webpack_require__(200);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/web/components/confirm-google-login.jsx

function ConfirmGoogleLogin(props) {
  var t = props.t,
      _props$open = props.open,
      open = _props$open === undefined ? false : _props$open,
      onSuccess = props.onSuccess,
      onClose = props.onClose;


  return _react2.default.createElement(
    _dialog2.default,
    { active: open,
      onEscKeyDown: onClose,
      onOverlayClick: onClose,
      title: t('label:Googleドキュメントに接続'),
      actions: [{ label: t('label:取り消し'), onClick: onClose, raised: true }] },
    _react2.default.createElement(_googleSigninProvider.GoogleLogin, { label: t('label:Googleドキュメントに接続'), onSuccess: onSuccess })
  );
}

exports.default = (0, _reactI18next.translate)()(ConfirmGoogleLogin);

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CenturyView;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Decades = _interopRequireDefault(__webpack_require__(2708));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function CenturyView(props) {
  function renderDecades() {
    return _react["default"].createElement(_Decades["default"], props);
  }

  return _react["default"].createElement("div", {
    className: "react-calendar__century-view"
  }, renderDecades());
}

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTileClasses = exports.between = exports.doRangesOverlap = exports.isRangeWithinRange = exports.isValueWithinRange = exports.callIfDefined = exports.mergeFunctions = void 0;

var _dates = __webpack_require__(96);

/**
 * Returns a function that, when called, calls all the functions
 * passed to it, applying its arguments to them.
 *
 * @param {Function[]} functions
 */
var mergeFunctions = function mergeFunctions() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return functions.filter(Boolean).forEach(function (f) {
      return f.apply(void 0, args);
    });
  };
};
/**
 * Calls a function, if it's defined, with specified arguments
 * @param {Function} fn
 * @param {Object} args
 */


exports.mergeFunctions = mergeFunctions;

var callIfDefined = function callIfDefined(fn) {
  if (fn && typeof fn === 'function') {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    fn.apply(void 0, args);
  }
};

exports.callIfDefined = callIfDefined;

var isValueWithinRange = function isValueWithinRange(value, range) {
  return range[0] <= value && range[1] >= value;
};

exports.isValueWithinRange = isValueWithinRange;

var isRangeWithinRange = function isRangeWithinRange(greaterRange, smallerRange) {
  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
};

exports.isRangeWithinRange = isRangeWithinRange;

var doRangesOverlap = function doRangesOverlap(range1, range2) {
  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
};
/**
 * Returns a value no smaller than min and no larger than max.
 *
 * @param {*} value Value to return.
 * @param {*} min Minimum return value.
 * @param {*} max Maximum return value.
 */


exports.doRangesOverlap = doRangesOverlap;

var between = function between(value, min, max) {
  if (min && min > value) {
    return min;
  }

  if (max && max < value) {
    return max;
  }

  return value;
};

exports.between = between;

var getTileClasses = function getTileClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref.value,
      valueType = _ref.valueType,
      date = _ref.date,
      dateType = _ref.dateType,
      hover = _ref.hover;

  var className = 'react-calendar__tile';
  var classes = [className];

  if (!date) {
    return classes;
  }

  if (!(date instanceof Array) && !dateType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var now = new Date();
  var dateRange = date instanceof Array ? date : (0, _dates.getRange)(dateType, date);

  if (isValueWithinRange(now, dateRange)) {
    classes.push("".concat(className, "--now"));
  }

  if (!value) {
    return classes;
  }

  if (!(value instanceof Array) && !valueType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var valueRange = value instanceof Array ? value : (0, _dates.getRange)(valueType, value);

  if (isRangeWithinRange(valueRange, dateRange)) {
    classes.push("".concat(className, "--active"));
  } else if (doRangesOverlap(valueRange, dateRange)) {
    classes.push("".concat(className, "--hasActive"));
  } else if (hover && ( // Date before value
  dateRange[1] < valueRange[0] && doRangesOverlap(dateRange, [hover, valueRange[0]]) || // Date after value
  dateRange[0] > valueRange[1] && doRangesOverlap(dateRange, [valueRange[1], hover]))) {
    classes.push("".concat(className, "--hover"));
  }

  var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
  var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);

  if (isRangeStart) {
    classes.push("".concat(className, "--rangeStart"));
  }

  if (isRangeEnd) {
    classes.push("".concat(className, "--rangeEnd"));
  }

  if (isRangeStart && isRangeEnd) {
    classes.push("".concat(className, "--rangeBothEnds"));
  }

  return classes;
};

exports.getTileClasses = getTileClasses;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DecadeView;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Years = _interopRequireDefault(__webpack_require__(2710));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function DecadeView(props) {
  function renderYears() {
    return _react["default"].createElement(_Years["default"], props);
  }

  return _react["default"].createElement("div", {
    className: "react-calendar__decade-view"
  }, renderYears());
}

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = YearView;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Months = _interopRequireDefault(__webpack_require__(2712));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function YearView(props) {
  function renderMonths() {
    return _react["default"].createElement(_Months["default"], props);
  }

  return _react["default"].createElement("div", {
    className: "react-calendar__year-view"
  }, renderMonths());
}

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MonthView;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _Days = _interopRequireDefault(__webpack_require__(2714));

var _Weekdays = _interopRequireDefault(__webpack_require__(2716));

var _WeekNumbers = _interopRequireDefault(__webpack_require__(2717));

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function MonthView(props) {
  var activeStartDate = props.activeStartDate,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

  var calendarTypeProps = props.calendarType,
      formatShortWeekday = props.formatShortWeekday,
      onClickWeekNumber = props.onClickWeekNumber,
      showWeekNumbers = props.showWeekNumbers,
      childProps = _objectWithoutProperties(props, ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers"]);

  var calendarType = function () {
    if (calendarTypeProps) {
      return calendarTypeProps;
    }

    switch (locale) {
      case 'en-CA':
      case 'en-US':
      case 'es-AR':
      case 'es-BO':
      case 'es-CL':
      case 'es-CO':
      case 'es-CR':
      case 'es-DO':
      case 'es-EC':
      case 'es-GT':
      case 'es-HN':
      case 'es-MX':
      case 'es-NI':
      case 'es-PA':
      case 'es-PE':
      case 'es-PR':
      case 'es-SV':
      case 'es-VE':
      case 'pt-BR':
        return 'US';
      // ar-LB, ar-MA intentionally missing

      case 'ar':
      case 'ar-AE':
      case 'ar-BH':
      case 'ar-DZ':
      case 'ar-EG':
      case 'ar-IQ':
      case 'ar-JO':
      case 'ar-KW':
      case 'ar-LY':
      case 'ar-OM':
      case 'ar-QA':
      case 'ar-SA':
      case 'ar-SD':
      case 'ar-SY':
      case 'ar-YE':
      case 'dv':
      case 'dv-MV':
      case 'ps':
      case 'ps-AR':
        return 'Arabic';

      case 'he':
      case 'he-IL':
        return 'Hebrew';

      default:
        return 'ISO 8601';
    }
  }();

  function renderWeekdays() {
    return _react["default"].createElement(_Weekdays["default"], {
      calendarType: calendarType,
      formatShortWeekday: formatShortWeekday,
      locale: locale,
      onMouseLeave: onMouseLeave
    });
  }

  function renderWeekNumbers() {
    if (!showWeekNumbers) {
      return null;
    }

    return _react["default"].createElement(_WeekNumbers["default"], {
      activeStartDate: activeStartDate,
      calendarType: calendarType,
      onClickWeekNumber: onClickWeekNumber,
      onMouseLeave: onMouseLeave,
      showFixedNumberOfWeeks: showFixedNumberOfWeeks
    });
  }

  function renderDays() {
    return _react["default"].createElement(_Days["default"], _extends({
      calendarType: calendarType
    }, childProps));
  }

  var className = 'react-calendar__month-view';
  return _react["default"].createElement("div", {
    className: [className, showWeekNumbers ? "".concat(className, "--weekNumbers") : ''].join(' ')
  }, _react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, renderWeekNumbers(), _react["default"].createElement("div", {
    style: {
      flexGrow: 1,
      width: '100%'
    }
  }, renderWeekdays(), renderDays())));
}

MonthView.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  calendarType: _propTypes2.isCalendarType,
  formatShortWeekday: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  maxDate: _propTypes2.isMaxDate,
  minDate: _propTypes2.isMinDate,
  onChange: _propTypes["default"].func,
  onClickWeekNumber: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  setActiveRange: _propTypes["default"].func,
  showFixedNumberOfWeeks: _propTypes["default"].bool,
  showNeighboringMonth: _propTypes["default"].bool,
  showWeekNumbers: _propTypes["default"].bool,
  value: _propTypes2.isValue,
  valueType: _propTypes["default"].string
};

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserCacheManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_BROWSER_CACHE_MANAGER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BrowserStorage_js__ = __webpack_require__(2744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MemoryStorage_js__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_BrowserProtocolUtils_js__ = __webpack_require__(1119);
/*! @azure/msal-browser v2.38.3 2023-10-27 */









/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
 * parameters such as state and nonce, generally.
 */
var BrowserCacheManager = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(BrowserCacheManager, _super);
    function BrowserCacheManager(clientId, cacheConfig, cryptoImpl, logger) {
        var _this = _super.call(this, clientId, cryptoImpl, logger) || this;
        // Cookie life calculation (hours * minutes * seconds * ms)
        _this.COOKIE_LIFE_MULTIPLIER = 24 * 60 * 60 * 1000;
        _this.cacheConfig = cacheConfig;
        _this.logger = logger;
        _this.internalStorage = new __WEBPACK_IMPORTED_MODULE_5__MemoryStorage_js__["a" /* MemoryStorage */]();
        _this.browserStorage = _this.setupBrowserStorage(_this.cacheConfig.cacheLocation);
        _this.temporaryCacheStorage = _this.setupTemporaryCacheStorage(_this.cacheConfig.temporaryCacheLocation, _this.cacheConfig.cacheLocation);
        // Migrate cache entries from older versions of MSAL.
        if (cacheConfig.cacheMigrationEnabled) {
            _this.migrateCacheEntries();
            _this.createKeyMaps();
        }
        return _this;
    }
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
     * @param cacheLocation
     */
    BrowserCacheManager.prototype.setupBrowserStorage = function (cacheLocation) {
        switch (cacheLocation) {
            case __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].LocalStorage:
            case __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].SessionStorage:
                try {
                    return new __WEBPACK_IMPORTED_MODULE_4__BrowserStorage_js__["a" /* BrowserStorage */](cacheLocation);
                }
                catch (e) {
                    this.logger.verbose(e);
                    break;
                }
        }
        this.cacheConfig.cacheLocation = __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].MemoryStorage;
        return new __WEBPACK_IMPORTED_MODULE_5__MemoryStorage_js__["a" /* MemoryStorage */]();
    };
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured temporaryCacheLocation.
     * @param temporaryCacheLocation
     * @param cacheLocation
     */
    BrowserCacheManager.prototype.setupTemporaryCacheStorage = function (temporaryCacheLocation, cacheLocation) {
        switch (cacheLocation) {
            case __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].LocalStorage:
            case __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].SessionStorage:
                try {
                    /*
                     * When users do not explicitly choose their own temporaryCacheLocation,
                     * temporary cache items will always be stored in session storage to mitigate problems caused by multiple tabs
                     */
                    return new __WEBPACK_IMPORTED_MODULE_4__BrowserStorage_js__["a" /* BrowserStorage */](temporaryCacheLocation || __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].SessionStorage);
                }
                catch (e) {
                    this.logger.verbose(e);
                    return this.internalStorage;
                }
            case __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].MemoryStorage:
            default:
                return this.internalStorage;
        }
    };
    /**
     * Migrate all old cache entries to new schema. No rollback supported.
     * @param storeAuthStateInCookie
     */
    BrowserCacheManager.prototype.migrateCacheEntries = function () {
        var _this = this;
        var idTokenKey = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].CACHE_PREFIX + "." + __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ID_TOKEN;
        var clientInfoKey = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].CACHE_PREFIX + "." + __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].CLIENT_INFO;
        var errorKey = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].CACHE_PREFIX + "." + __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ERROR;
        var errorDescKey = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].CACHE_PREFIX + "." + __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ERROR_DESC;
        var idTokenValue = this.browserStorage.getItem(idTokenKey);
        var clientInfoValue = this.browserStorage.getItem(clientInfoKey);
        var errorValue = this.browserStorage.getItem(errorKey);
        var errorDescValue = this.browserStorage.getItem(errorDescKey);
        var values = [idTokenValue, clientInfoValue, errorValue, errorDescValue];
        var keysToMigrate = [__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ID_TOKEN, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].CLIENT_INFO, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ERROR, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ERROR_DESC];
        keysToMigrate.forEach(function (cacheKey, index) { return _this.migrateCacheEntry(cacheKey, values[index]); });
    };
    /**
     * Utility function to help with migration.
     * @param newKey
     * @param value
     * @param storeAuthStateInCookie
     */
    BrowserCacheManager.prototype.migrateCacheEntry = function (newKey, value) {
        if (value) {
            this.setTemporaryCache(newKey, value, true);
        }
    };
    /**
     * Searches all cache entries for MSAL accounts and creates the account key map
     * This is used to migrate users from older versions of MSAL which did not create the map.
     * @returns
     */
    BrowserCacheManager.prototype.createKeyMaps = function () {
        var _this = this;
        this.logger.trace("BrowserCacheManager - createKeyMaps called.");
        var accountKeys = this.getItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["p" /* StaticCacheKeys */].ACCOUNT_KEYS);
        var tokenKeys = this.getItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["p" /* StaticCacheKeys */].TOKEN_KEYS + "." + this.clientId);
        if (accountKeys && tokenKeys) {
            this.logger.verbose("BrowserCacheManager:createKeyMaps - account and token key maps already exist, skipping migration.");
            // Key maps already exist, no need to iterate through cache
            return;
        }
        var allKeys = this.browserStorage.getKeys();
        allKeys.forEach(function (key) {
            if (_this.isCredentialKey(key)) {
                // Get item, parse, validate and write key to map
                var value = _this.getItem(key);
                if (value) {
                    var credObj = _this.validateAndParseJson(value);
                    if (credObj && credObj.hasOwnProperty("credentialType")) {
                        switch (credObj["credentialType"]) {
                            case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ID_TOKEN:
                                if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["A" /* IdTokenEntity */].isIdTokenEntity(credObj)) {
                                    _this.logger.trace("BrowserCacheManager:createKeyMaps - idToken found, saving key to token key map");
                                    _this.logger.tracePii("BrowserCacheManager:createKeyMaps - idToken with key: " + key + " found, saving key to token key map");
                                    var idTokenEntity = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["A" /* IdTokenEntity */](), credObj);
                                    var newKey = _this.updateCredentialCacheKey(key, idTokenEntity);
                                    _this.addTokenKey(newKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ID_TOKEN);
                                    return;
                                }
                                else {
                                    _this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching idToken schema with value containing idToken credentialType field but value failed IdTokenEntity validation, skipping.");
                                    _this.logger.tracePii("BrowserCacheManager:createKeyMaps - failed idToken validation on key: " + key);
                                }
                                break;
                            case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ACCESS_TOKEN:
                            case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ACCESS_TOKEN_WITH_AUTH_SCHEME:
                                if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["a" /* AccessTokenEntity */].isAccessTokenEntity(credObj)) {
                                    _this.logger.trace("BrowserCacheManager:createKeyMaps - accessToken found, saving key to token key map");
                                    _this.logger.tracePii("BrowserCacheManager:createKeyMaps - accessToken with key: " + key + " found, saving key to token key map");
                                    var accessTokenEntity = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["a" /* AccessTokenEntity */](), credObj);
                                    var newKey = _this.updateCredentialCacheKey(key, accessTokenEntity);
                                    _this.addTokenKey(newKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ACCESS_TOKEN);
                                    return;
                                }
                                else {
                                    _this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching accessToken schema with value containing accessToken credentialType field but value failed AccessTokenEntity validation, skipping.");
                                    _this.logger.tracePii("BrowserCacheManager:createKeyMaps - failed accessToken validation on key: " + key);
                                }
                                break;
                            case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].REFRESH_TOKEN:
                                if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["P" /* RefreshTokenEntity */].isRefreshTokenEntity(credObj)) {
                                    _this.logger.trace("BrowserCacheManager:createKeyMaps - refreshToken found, saving key to token key map");
                                    _this.logger.tracePii("BrowserCacheManager:createKeyMaps - refreshToken with key: " + key + " found, saving key to token key map");
                                    var refreshTokenEntity = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["P" /* RefreshTokenEntity */](), credObj);
                                    var newKey = _this.updateCredentialCacheKey(key, refreshTokenEntity);
                                    _this.addTokenKey(newKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].REFRESH_TOKEN);
                                    return;
                                }
                                else {
                                    _this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching refreshToken schema with value containing refreshToken credentialType field but value failed RefreshTokenEntity validation, skipping.");
                                    _this.logger.tracePii("BrowserCacheManager:createKeyMaps - failed refreshToken validation on key: " + key);
                                }
                                break;
                            // If credentialType isn't one of our predefined ones, it may not be an MSAL cache value. Ignore.
                        }
                    }
                }
            }
            if (_this.isAccountKey(key)) {
                var value = _this.getItem(key);
                if (value) {
                    var accountObj = _this.validateAndParseJson(value);
                    if (accountObj && __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["b" /* AccountEntity */].isAccountEntity(accountObj)) {
                        _this.logger.trace("BrowserCacheManager:createKeyMaps - account found, saving key to account key map");
                        _this.logger.tracePii("BrowserCacheManager:createKeyMaps - account with key: " + key + " found, saving key to account key map");
                        _this.addAccountKeyToMap(key);
                    }
                }
            }
        });
    };
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */
    BrowserCacheManager.prototype.validateAndParseJson = function (jsonValue) {
        try {
            var parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */
            return (parsedJson && typeof parsedJson === "object") ? parsedJson : null;
        }
        catch (error) {
            return null;
        }
    };
    /**
     * fetches the entry from the browser storage based off the key
     * @param key
     */
    BrowserCacheManager.prototype.getItem = function (key) {
        return this.browserStorage.getItem(key);
    };
    /**
     * sets the entry in the browser storage
     * @param key
     * @param value
     */
    BrowserCacheManager.prototype.setItem = function (key, value) {
        this.browserStorage.setItem(key, value);
    };
    /**
     * fetch the account entity from the platform cache
     * @param accountKey
     */
    BrowserCacheManager.prototype.getAccount = function (accountKey) {
        this.logger.trace("BrowserCacheManager.getAccount called");
        var account = this.getItem(accountKey);
        if (!account) {
            this.removeAccountKeyFromMap(accountKey);
            return null;
        }
        var parsedAccount = this.validateAndParseJson(account);
        if (!parsedAccount || !__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["b" /* AccountEntity */].isAccountEntity(parsedAccount)) {
            this.removeAccountKeyFromMap(accountKey);
            return null;
        }
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["b" /* AccountEntity */](), parsedAccount);
    };
    /**
     * set account entity in the platform cache
     * @param key
     * @param value
     */
    BrowserCacheManager.prototype.setAccount = function (account) {
        this.logger.trace("BrowserCacheManager.setAccount called");
        var key = account.generateAccountKey();
        this.setItem(key, JSON.stringify(account));
        this.addAccountKeyToMap(key);
    };
    /**
     * Returns the array of account keys currently cached
     * @returns
     */
    BrowserCacheManager.prototype.getAccountKeys = function () {
        this.logger.trace("BrowserCacheManager.getAccountKeys called");
        var accountKeys = this.getItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["p" /* StaticCacheKeys */].ACCOUNT_KEYS);
        if (accountKeys) {
            return JSON.parse(accountKeys);
        }
        this.logger.verbose("BrowserCacheManager.getAccountKeys - No account keys found");
        return [];
    };
    /**
     * Add a new account to the key map
     * @param key
     */
    BrowserCacheManager.prototype.addAccountKeyToMap = function (key) {
        this.logger.trace("BrowserCacheManager.addAccountKeyToMap called");
        this.logger.tracePii("BrowserCacheManager.addAccountKeyToMap called with key: " + key);
        var accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["p" /* StaticCacheKeys */].ACCOUNT_KEYS, JSON.stringify(accountKeys));
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key added");
        }
        else {
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key already exists in map");
        }
    };
    /**
     * Remove an account from the key map
     * @param key
     */
    BrowserCacheManager.prototype.removeAccountKeyFromMap = function (key) {
        this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap called");
        this.logger.tracePii("BrowserCacheManager.removeAccountKeyFromMap called with key: " + key);
        var accountKeys = this.getAccountKeys();
        var removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.setItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["p" /* StaticCacheKeys */].ACCOUNT_KEYS, JSON.stringify(accountKeys));
            this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap account key removed");
        }
        else {
            this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap key not found in existing map");
        }
    };
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */
    BrowserCacheManager.prototype.removeAccount = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                _super.prototype.removeAccount.call(this, key);
                this.removeAccountKeyFromMap(key);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */
    BrowserCacheManager.prototype.removeIdToken = function (key) {
        _super.prototype.removeIdToken.call(this, key);
        this.removeTokenKey(key, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ID_TOKEN);
    };
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */
    BrowserCacheManager.prototype.removeAccessToken = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                _super.prototype.removeAccessToken.call(this, key);
                this.removeTokenKey(key, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ACCESS_TOKEN);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */
    BrowserCacheManager.prototype.removeRefreshToken = function (key) {
        _super.prototype.removeRefreshToken.call(this, key);
        this.removeTokenKey(key, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].REFRESH_TOKEN);
    };
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */
    BrowserCacheManager.prototype.getTokenKeys = function () {
        this.logger.trace("BrowserCacheManager.getTokenKeys called");
        var item = this.getItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["p" /* StaticCacheKeys */].TOKEN_KEYS + "." + this.clientId);
        if (item) {
            var tokenKeys = this.validateAndParseJson(item);
            if (tokenKeys &&
                tokenKeys.hasOwnProperty("idToken") &&
                tokenKeys.hasOwnProperty("accessToken") &&
                tokenKeys.hasOwnProperty("refreshToken")) {
                return tokenKeys;
            }
            else {
                this.logger.error("BrowserCacheManager.getTokenKeys - Token keys found but in an unknown format. Returning empty key map.");
            }
        }
        else {
            this.logger.verbose("BrowserCacheManager.getTokenKeys - No token keys found");
        }
        return {
            idToken: [],
            accessToken: [],
            refreshToken: []
        };
    };
    /**
     * Adds the given key to the token key map
     * @param key
     * @param type
     */
    BrowserCacheManager.prototype.addTokenKey = function (key, type) {
        this.logger.trace("BrowserCacheManager addTokenKey called");
        var tokenKeys = this.getTokenKeys();
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ID_TOKEN:
                if (tokenKeys.idToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - idToken added to map");
                    tokenKeys.idToken.push(key);
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ACCESS_TOKEN:
                if (tokenKeys.accessToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - accessToken added to map");
                    tokenKeys.accessToken.push(key);
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].REFRESH_TOKEN:
                if (tokenKeys.refreshToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - refreshToken added to map");
                    tokenKeys.refreshToken.push(key);
                }
                break;
            default:
                this.logger.error("BrowserCacheManager:addTokenKey - CredentialType provided invalid. CredentialType: " + type);
                __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["r" /* ClientAuthError */].createUnexpectedCredentialTypeError();
        }
        this.setItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["p" /* StaticCacheKeys */].TOKEN_KEYS + "." + this.clientId, JSON.stringify(tokenKeys));
    };
    /**
     * Removes the given key from the token key map
     * @param key
     * @param type
     */
    BrowserCacheManager.prototype.removeTokenKey = function (key, type) {
        this.logger.trace("BrowserCacheManager removeTokenKey called");
        var tokenKeys = this.getTokenKeys();
        switch (type) {
            case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ID_TOKEN:
                this.logger.infoPii("BrowserCacheManager: removeTokenKey - attempting to remove idToken with key: " + key + " from map");
                var idRemoval = tokenKeys.idToken.indexOf(key);
                if (idRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - idToken removed from map");
                    tokenKeys.idToken.splice(idRemoval, 1);
                }
                else {
                    this.logger.info("BrowserCacheManager: removeTokenKey - idToken does not exist in map. Either it was previously removed or it was never added.");
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ACCESS_TOKEN:
                this.logger.infoPii("BrowserCacheManager: removeTokenKey - attempting to remove accessToken with key: " + key + " from map");
                var accessRemoval = tokenKeys.accessToken.indexOf(key);
                if (accessRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - accessToken removed from map");
                    tokenKeys.accessToken.splice(accessRemoval, 1);
                }
                else {
                    this.logger.info("BrowserCacheManager: removeTokenKey - accessToken does not exist in map. Either it was previously removed or it was never added.");
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].REFRESH_TOKEN:
                this.logger.infoPii("BrowserCacheManager: removeTokenKey - attempting to remove refreshToken with key: " + key + " from map");
                var refreshRemoval = tokenKeys.refreshToken.indexOf(key);
                if (refreshRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken removed from map");
                    tokenKeys.refreshToken.splice(refreshRemoval, 1);
                }
                else {
                    this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken does not exist in map. Either it was previously removed or it was never added.");
                }
                break;
            default:
                this.logger.error("BrowserCacheManager:removeTokenKey - CredentialType provided invalid. CredentialType: " + type);
                __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["r" /* ClientAuthError */].createUnexpectedCredentialTypeError();
        }
        this.setItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["p" /* StaticCacheKeys */].TOKEN_KEYS + "." + this.clientId, JSON.stringify(tokenKeys));
    };
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */
    BrowserCacheManager.prototype.getIdTokenCredential = function (idTokenKey) {
        var value = this.getItem(idTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeTokenKey(idTokenKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ID_TOKEN);
            return null;
        }
        var parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["A" /* IdTokenEntity */].isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeTokenKey(idTokenKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ID_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit");
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["A" /* IdTokenEntity */](), parsedIdToken);
    };
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */
    BrowserCacheManager.prototype.setIdTokenCredential = function (idToken) {
        this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
        var idTokenKey = idToken.generateCredentialKey();
        this.setItem(idTokenKey, JSON.stringify(idToken));
        this.addTokenKey(idTokenKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ID_TOKEN);
    };
    /**
     * generates accessToken entity from a string
     * @param key
     */
    BrowserCacheManager.prototype.getAccessTokenCredential = function (accessTokenKey) {
        var value = this.getItem(accessTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ACCESS_TOKEN);
            return null;
        }
        var parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["a" /* AccessTokenEntity */].isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ACCESS_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit");
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["a" /* AccessTokenEntity */](), parsedAccessToken);
    };
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */
    BrowserCacheManager.prototype.setAccessTokenCredential = function (accessToken) {
        this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
        var accessTokenKey = accessToken.generateCredentialKey();
        this.setItem(accessTokenKey, JSON.stringify(accessToken));
        this.addTokenKey(accessTokenKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].ACCESS_TOKEN);
    };
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */
    BrowserCacheManager.prototype.getRefreshTokenCredential = function (refreshTokenKey) {
        var value = this.getItem(refreshTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].REFRESH_TOKEN);
            return null;
        }
        var parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["P" /* RefreshTokenEntity */].isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].REFRESH_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit");
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["P" /* RefreshTokenEntity */](), parsedRefreshToken);
    };
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */
    BrowserCacheManager.prototype.setRefreshTokenCredential = function (refreshToken) {
        this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
        var refreshTokenKey = refreshToken.generateCredentialKey();
        this.setItem(refreshTokenKey, JSON.stringify(refreshToken));
        this.addTokenKey(refreshTokenKey, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["w" /* CredentialType */].REFRESH_TOKEN);
    };
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     */
    BrowserCacheManager.prototype.getAppMetadata = function (appMetadataKey) {
        var value = this.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["c" /* AppMetadataEntity */].isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit");
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["c" /* AppMetadataEntity */](), parsedMetadata);
    };
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     */
    BrowserCacheManager.prototype.setAppMetadata = function (appMetadata) {
        this.logger.trace("BrowserCacheManager.setAppMetadata called");
        var appMetadataKey = appMetadata.generateAppMetadataKey();
        this.setItem(appMetadataKey, JSON.stringify(appMetadata));
    };
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     */
    BrowserCacheManager.prototype.getServerTelemetry = function (serverTelemetryKey) {
        var value = this.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["T" /* ServerTelemetryEntity */].isServerTelemetryEntity(serverTelemetryKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit");
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["T" /* ServerTelemetryEntity */](), parsedMetadata);
    };
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */
    BrowserCacheManager.prototype.setServerTelemetry = function (serverTelemetryKey, serverTelemetry) {
        this.logger.trace("BrowserCacheManager.setServerTelemetry called");
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry));
    };
    /**
     *
     */
    BrowserCacheManager.prototype.getAuthorityMetadata = function (key) {
        var value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["k" /* AuthorityMetadataEntity */].isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit");
            return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["k" /* AuthorityMetadataEntity */](), parsedMetadata);
        }
        return null;
    };
    /**
     *
     */
    BrowserCacheManager.prototype.getAuthorityMetadataKeys = function () {
        var _this = this;
        var allKeys = this.internalStorage.getKeys();
        return allKeys.filter(function (key) {
            return _this.isAuthorityMetadata(key);
        });
    };
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */
    BrowserCacheManager.prototype.setWrapperMetadata = function (wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["j" /* InMemoryCacheKeys */].WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["j" /* InMemoryCacheKeys */].WRAPPER_VER, wrapperVersion);
    };
    /**
     * Returns wrapper metadata from in-memory storage
     */
    BrowserCacheManager.prototype.getWrapperMetadata = function () {
        var sku = this.internalStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["j" /* InMemoryCacheKeys */].WRAPPER_SKU) || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
        var version = this.internalStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["j" /* InMemoryCacheKeys */].WRAPPER_VER) || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
        return [sku, version];
    };
    /**
     *
     * @param entity
     */
    BrowserCacheManager.prototype.setAuthorityMetadata = function (key, entity) {
        this.logger.trace("BrowserCacheManager.setAuthorityMetadata called");
        this.internalStorage.setItem(key, JSON.stringify(entity));
    };
    /**
     * Gets the active account
     */
    BrowserCacheManager.prototype.getActiveAccount = function () {
        var activeAccountKeyFilters = this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ACTIVE_ACCOUNT_FILTERS);
        var activeAccountValueFilters = this.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            // if new active account cache type isn't found, it's an old version, so look for that instead
            this.logger.trace("BrowserCacheManager.getActiveAccount: No active account filters cache schema found, looking for legacy schema");
            var activeAccountKeyLocal = this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ACTIVE_ACCOUNT);
            var activeAccountValueLocal = this.getItem(activeAccountKeyLocal);
            if (!activeAccountValueLocal) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
                return null;
            }
            var activeAccount = this.getAccountInfoByFilter({ localAccountId: activeAccountValueLocal })[0] || null;
            if (activeAccount) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: Legacy active account cache schema found");
                this.logger.trace("BrowserCacheManager.getActiveAccount: Adding active account filters cache schema");
                this.setActiveAccount(activeAccount);
                return activeAccount;
            }
            return null;
        }
        var activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: Active account filters schema found");
            return this.getAccountInfoByFilter({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId
            })[0] || null;
        }
        this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
        return null;
    };
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */
    BrowserCacheManager.prototype.setActiveAccount = function (account) {
        var activeAccountKey = this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ACTIVE_ACCOUNT_FILTERS);
        var activeAccountKeyLocal = this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ACTIVE_ACCOUNT);
        if (account) {
            this.logger.verbose("setActiveAccount: Active account set");
            var activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId
            };
            this.browserStorage.setItem(activeAccountKey, JSON.stringify(activeAccountValue));
            this.browserStorage.setItem(activeAccountKeyLocal, account.localAccountId);
        }
        else {
            this.logger.verbose("setActiveAccount: No account passed, active account not set");
            this.browserStorage.removeItem(activeAccountKey);
            this.browserStorage.removeItem(activeAccountKeyLocal);
        }
    };
    /**
     * Gets a list of accounts that match all of the filters provided
     * @param account
     */
    BrowserCacheManager.prototype.getAccountInfoByFilter = function (accountFilter) {
        var allAccounts = this.getAllAccounts();
        this.logger.trace("BrowserCacheManager.getAccountInfoByFilter: total " + allAccounts.length + " accounts found");
        return allAccounts.filter(function (accountObj) {
            if (accountFilter.username && accountFilter.username.toLowerCase() !== accountObj.username.toLowerCase()) {
                return false;
            }
            if (accountFilter.homeAccountId && accountFilter.homeAccountId !== accountObj.homeAccountId) {
                return false;
            }
            if (accountFilter.localAccountId && accountFilter.localAccountId !== accountObj.localAccountId) {
                return false;
            }
            if (accountFilter.tenantId && accountFilter.tenantId !== accountObj.tenantId) {
                return false;
            }
            if (accountFilter.environment && accountFilter.environment !== accountObj.environment) {
                return false;
            }
            return true;
        });
    };
    /**
     * Checks the cache for accounts matching loginHint or SID
     * @param loginHint
     * @param sid
     */
    BrowserCacheManager.prototype.getAccountInfoByHints = function (loginHint, sid) {
        var matchingAccounts = this.getAllAccounts().filter(function (accountInfo) {
            if (sid) {
                var accountSid = accountInfo.idTokenClaims && accountInfo.idTokenClaims["sid"];
                return sid === accountSid;
            }
            if (loginHint) {
                return loginHint === accountInfo.username;
            }
            return false;
        });
        if (matchingAccounts.length === 1) {
            return matchingAccounts[0];
        }
        else if (matchingAccounts.length > 1) {
            throw __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["r" /* ClientAuthError */].createMultipleMatchingAccountsInCacheError();
        }
        return null;
    };
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     */
    BrowserCacheManager.prototype.getThrottlingCache = function (throttlingCacheKey) {
        var value = this.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        var parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["Z" /* ThrottlingEntity */].isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit");
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["Z" /* ThrottlingEntity */](), parsedThrottlingCache);
    };
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */
    BrowserCacheManager.prototype.setThrottlingCache = function (throttlingCacheKey, throttlingCache) {
        this.logger.trace("BrowserCacheManager.setThrottlingCache called");
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache));
    };
    /**
     * Gets cache item with given key.
     * Will retrieve from cookies if storeAuthStateInCookie is set to true.
     * @param key
     */
    BrowserCacheManager.prototype.getTemporaryCache = function (cacheKey, generateKey) {
        var key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        if (this.cacheConfig.storeAuthStateInCookie) {
            var itemCookie = this.getItemCookie(key);
            if (itemCookie) {
                this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
                return itemCookie;
            }
        }
        var value = this.temporaryCacheStorage.getItem(key);
        if (!value) {
            // If temp cache item not found in session/memory, check local storage for items set by old versions
            if (this.cacheConfig.cacheLocation === __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].LocalStorage) {
                var item = this.browserStorage.getItem(key);
                if (item) {
                    this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage");
                    return item;
                }
            }
            this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned");
        return value;
    };
    /**
     * Sets the cache item with the key and value given.
     * Stores in cookie if storeAuthStateInCookie is set to true.
     * This can cause cookie overflow if used incorrectly.
     * @param key
     * @param value
     */
    BrowserCacheManager.prototype.setTemporaryCache = function (cacheKey, value, generateKey) {
        var key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
            this.setItemCookie(key, value);
        }
    };
    /**
     * Removes the cache item with the given key.
     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
     * @param key
     */
    BrowserCacheManager.prototype.removeItem = function (key) {
        this.browserStorage.removeItem(key);
        this.temporaryCacheStorage.removeItem(key);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
            this.clearItemCookie(key);
        }
    };
    /**
     * Checks whether key is in cache.
     * @param key
     */
    BrowserCacheManager.prototype.containsKey = function (key) {
        return this.browserStorage.containsKey(key) || this.temporaryCacheStorage.containsKey(key);
    };
    /**
     * Gets all keys in window.
     */
    BrowserCacheManager.prototype.getKeys = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["f" /* __spread */])(this.browserStorage.getKeys(), this.temporaryCacheStorage.getKeys());
    };
    /**
     * Clears all cache entries created by MSAL.
     */
    BrowserCacheManager.prototype.clear = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Removes all accounts and their credentials
                    return [4 /*yield*/, this.removeAllAccounts()];
                    case 1:
                        // Removes all accounts and their credentials
                        _a.sent();
                        this.removeAppMetadata();
                        // Removes all remaining MSAL cache items
                        this.getKeys().forEach(function (cacheKey) {
                            // Check if key contains msal prefix; For now, we are clearing all the cache items created by MSAL.js
                            if ((_this.browserStorage.containsKey(cacheKey) || _this.temporaryCacheStorage.containsKey(cacheKey)) && ((cacheKey.indexOf(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].CACHE_PREFIX) !== -1) || (cacheKey.indexOf(_this.clientId) !== -1))) {
                                _this.removeItem(cacheKey);
                            }
                        });
                        this.internalStorage.clear();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Clears all access tokes that have claims prior to saving the current one
     * @param credential
     * @returns
     */
    BrowserCacheManager.prototype.clearTokensAndKeysWithClaims = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var tokenKeys, removedAccessTokens;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.trace("BrowserCacheManager.clearTokensAndKeysWithClaims called");
                        tokenKeys = this.getTokenKeys();
                        removedAccessTokens = [];
                        tokenKeys.accessToken.forEach(function (key) {
                            // if the access token has claims in its key, remove the token key and the token
                            var credential = _this.getAccessTokenCredential(key);
                            if ((credential === null || credential === void 0 ? void 0 : credential.requestedClaimsHash) && key.includes(credential.requestedClaimsHash.toLowerCase())) {
                                removedAccessTokens.push(_this.removeAccessToken(key));
                            }
                        });
                        return [4 /*yield*/, Promise.all(removedAccessTokens)];
                    case 1:
                        _a.sent();
                        // warn if any access tokens are removed
                        if (removedAccessTokens.length > 0) {
                            this.logger.warning(removedAccessTokens.length + " access tokens with claims in the cache keys have been removed from the cache.");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Add value to cookies
     * @param cookieName
     * @param cookieValue
     * @param expires
     */
    BrowserCacheManager.prototype.setItemCookie = function (cookieName, cookieValue, expires) {
        var cookieStr = encodeURIComponent(cookieName) + "=" + encodeURIComponent(cookieValue) + ";path=/;SameSite=Lax;";
        if (expires) {
            var expireTime = this.getCookieExpirationTime(expires);
            cookieStr += "expires=" + expireTime + ";";
        }
        if (this.cacheConfig.secureCookies) {
            cookieStr += "Secure;";
        }
        document.cookie = cookieStr;
    };
    /**
     * Get one item by key from cookies
     * @param cookieName
     */
    BrowserCacheManager.prototype.getItemCookie = function (cookieName) {
        var name = encodeURIComponent(cookieName) + "=";
        var cookieList = document.cookie.split(";");
        for (var i = 0; i < cookieList.length; i++) {
            var cookie = cookieList[i];
            while (cookie.charAt(0) === " ") {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return decodeURIComponent(cookie.substring(name.length, cookie.length));
            }
        }
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
    };
    /**
     * Clear all msal-related cookies currently set in the browser. Should only be used to clear temporary cache items.
     */
    BrowserCacheManager.prototype.clearMsalCookies = function () {
        var _this = this;
        var cookiePrefix = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].CACHE_PREFIX + "." + this.clientId;
        var cookieList = document.cookie.split(";");
        cookieList.forEach(function (cookie) {
            while (cookie.charAt(0) === " ") {
                // eslint-disable-next-line no-param-reassign
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookiePrefix) === 0) {
                var cookieKey = cookie.split("=")[0];
                _this.clearItemCookie(cookieKey);
            }
        });
    };
    /**
     * Clear an item in the cookies by key
     * @param cookieName
     */
    BrowserCacheManager.prototype.clearItemCookie = function (cookieName) {
        this.setItemCookie(cookieName, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING, -1);
    };
    /**
     * Get cookie expiration time
     * @param cookieLifeDays
     */
    BrowserCacheManager.prototype.getCookieExpirationTime = function (cookieLifeDays) {
        var today = new Date();
        var expr = new Date(today.getTime() + cookieLifeDays * this.COOKIE_LIFE_MULTIPLIER);
        return expr.toUTCString();
    };
    /**
     * Gets the cache object referenced by the browser
     */
    BrowserCacheManager.prototype.getCache = function () {
        return this.browserStorage;
    };
    /**
     * interface compat, we cannot overwrite browser cache; Functionality is supported by individual entities in browser
     */
    BrowserCacheManager.prototype.setCache = function () {
        // sets nothing
    };
    /**
     * Prepend msal.<client-id> to each key; Skip for any JSON object as Key (defined schemas do not need the key appended: AccessToken Keys or the upcoming schema)
     * @param key
     * @param addInstanceId
     */
    BrowserCacheManager.prototype.generateCacheKey = function (key) {
        var generatedKey = this.validateAndParseJson(key);
        if (!generatedKey) {
            if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].startsWith(key, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].CACHE_PREFIX) || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].startsWith(key, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ADAL_ID_TOKEN)) {
                return key;
            }
            return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].CACHE_PREFIX + "." + this.clientId + "." + key;
        }
        return JSON.stringify(key);
    };
    /**
     * Create authorityKey to cache authority
     * @param state
     */
    BrowserCacheManager.prototype.generateAuthorityKey = function (stateString) {
        var stateId = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["N" /* ProtocolUtils */].parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].AUTHORITY + "." + stateId);
    };
    /**
     * Create Nonce key to cache nonce
     * @param state
     */
    BrowserCacheManager.prototype.generateNonceKey = function (stateString) {
        var stateId = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["N" /* ProtocolUtils */].parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].NONCE_IDTOKEN + "." + stateId);
    };
    /**
     * Creates full cache key for the request state
     * @param stateString State string for the request
     */
    BrowserCacheManager.prototype.generateStateKey = function (stateString) {
        // Use the library state id to key temp storage for uniqueness for multiple concurrent requests
        var stateId = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["N" /* ProtocolUtils */].parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].REQUEST_STATE + "." + stateId);
    };
    /**
     * Gets the cached authority based on the cached state. Returns empty if no cached state found.
     */
    BrowserCacheManager.prototype.getCachedAuthority = function (cachedState) {
        var stateCacheKey = this.generateStateKey(cachedState);
        var state = this.getTemporaryCache(stateCacheKey);
        if (!state) {
            return null;
        }
        var authorityCacheKey = this.generateAuthorityKey(state);
        return this.getTemporaryCache(authorityCacheKey);
    };
    /**
     * Updates account, authority, and state in cache
     * @param serverAuthenticationRequest
     * @param account
     */
    BrowserCacheManager.prototype.updateCacheEntries = function (state, nonce, authorityInstance, loginHint, account) {
        this.logger.trace("BrowserCacheManager.updateCacheEntries called");
        // Cache the request state
        var stateCacheKey = this.generateStateKey(state);
        this.setTemporaryCache(stateCacheKey, state, false);
        // Cache the nonce
        var nonceCacheKey = this.generateNonceKey(state);
        this.setTemporaryCache(nonceCacheKey, nonce, false);
        // Cache authorityKey
        var authorityCacheKey = this.generateAuthorityKey(state);
        this.setTemporaryCache(authorityCacheKey, authorityInstance, false);
        if (account) {
            var ccsCredential = {
                credential: account.homeAccountId,
                type: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["q" /* CcsCredentialType */].HOME_ACCOUNT_ID
            };
            this.setTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        }
        else if (!__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(loginHint)) {
            var ccsCredential = {
                credential: loginHint,
                type: __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["q" /* CcsCredentialType */].UPN
            };
            this.setTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        }
    };
    /**
     * Reset all temporary cache items
     * @param state
     */
    BrowserCacheManager.prototype.resetRequestCache = function (state) {
        var _this = this;
        this.logger.trace("BrowserCacheManager.resetRequestCache called");
        // check state and remove associated cache items
        if (!__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(state)) {
            this.getKeys().forEach(function (key) {
                if (key.indexOf(state) !== -1) {
                    _this.removeItem(key);
                }
            });
        }
        // delete generic interactive request parameters
        if (state) {
            this.removeItem(this.generateStateKey(state));
            this.removeItem(this.generateNonceKey(state));
            this.removeItem(this.generateAuthorityKey(state));
        }
        this.removeItem(this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].REQUEST_PARAMS));
        this.removeItem(this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].ORIGIN_URI));
        this.removeItem(this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].URL_HASH));
        this.removeItem(this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].CORRELATION_ID));
        this.removeItem(this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].CCS_CREDENTIAL));
        this.removeItem(this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].NATIVE_REQUEST));
        this.setInteractionInProgress(false);
    };
    /**
     * Removes temporary cache for the provided state
     * @param stateString
     */
    BrowserCacheManager.prototype.cleanRequestByState = function (stateString) {
        this.logger.trace("BrowserCacheManager.cleanRequestByState called");
        // Interaction is completed - remove interaction status.
        if (stateString) {
            var stateKey = this.generateStateKey(stateString);
            var cachedState = this.temporaryCacheStorage.getItem(stateKey);
            this.logger.infoPii("BrowserCacheManager.cleanRequestByState: Removing temporary cache items for state: " + cachedState);
            this.resetRequestCache(cachedState || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING);
        }
        this.clearMsalCookies();
    };
    /**
     * Looks in temporary cache for any state values with the provided interactionType and removes all temporary cache items for that state
     * Used in scenarios where temp cache needs to be cleaned but state is not known, such as clicking browser back button.
     * @param interactionType
     */
    BrowserCacheManager.prototype.cleanRequestByInteractionType = function (interactionType) {
        var _this = this;
        this.logger.trace("BrowserCacheManager.cleanRequestByInteractionType called");
        // Loop through all keys to find state key
        this.getKeys().forEach(function (key) {
            // If this key is not the state key, move on
            if (key.indexOf(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].REQUEST_STATE) === -1) {
                return;
            }
            // Retrieve state value, return if not a valid value
            var stateValue = _this.temporaryCacheStorage.getItem(key);
            if (!stateValue) {
                return;
            }
            // Extract state and ensure it matches given InteractionType, then clean request cache
            var parsedState = __WEBPACK_IMPORTED_MODULE_6__utils_BrowserProtocolUtils_js__["a" /* BrowserProtocolUtils */].extractBrowserRequestState(_this.cryptoImpl, stateValue);
            if (parsedState && parsedState.interactionType === interactionType) {
                _this.logger.infoPii("BrowserCacheManager.cleanRequestByInteractionType: Removing temporary cache items for state: " + stateValue);
                _this.resetRequestCache(stateValue);
            }
        });
        this.clearMsalCookies();
        this.setInteractionInProgress(false);
    };
    BrowserCacheManager.prototype.cacheCodeRequest = function (authCodeRequest, browserCrypto) {
        this.logger.trace("BrowserCacheManager.cacheCodeRequest called");
        var encodedValue = browserCrypto.base64Encode(JSON.stringify(authCodeRequest));
        this.setTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].REQUEST_PARAMS, encodedValue, true);
    };
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     */
    BrowserCacheManager.prototype.getCachedRequest = function (state, browserCrypto) {
        this.logger.trace("BrowserCacheManager.getCachedRequest called");
        // Get token request from cache and parse as TokenExchangeParameters.
        var encodedTokenRequest = this.getTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].REQUEST_PARAMS, true);
        if (!encodedTokenRequest) {
            throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNoTokenRequestCacheError();
        }
        var parsedRequest = this.validateAndParseJson(browserCrypto.base64Decode(encodedTokenRequest));
        if (!parsedRequest) {
            throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToParseTokenRequestCacheError();
        }
        this.removeItem(this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].REQUEST_PARAMS));
        // Get cached authority and use if no authority is cached with request.
        if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(parsedRequest.authority)) {
            var authorityCacheKey = this.generateAuthorityKey(state);
            var cachedAuthority = this.getTemporaryCache(authorityCacheKey);
            if (!cachedAuthority) {
                throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNoCachedAuthorityError();
            }
            parsedRequest.authority = cachedAuthority;
        }
        return parsedRequest;
    };
    /**
     * Gets cached native request for redirect flows
     */
    BrowserCacheManager.prototype.getCachedNativeRequest = function () {
        this.logger.trace("BrowserCacheManager.getCachedNativeRequest called");
        var cachedRequest = this.getTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].NATIVE_REQUEST, true);
        if (!cachedRequest) {
            this.logger.trace("BrowserCacheManager.getCachedNativeRequest: No cached native request found");
            return null;
        }
        var parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("BrowserCacheManager.getCachedNativeRequest: Unable to parse native request");
            return null;
        }
        return parsedRequest;
    };
    BrowserCacheManager.prototype.isInteractionInProgress = function (matchClientId) {
        var clientId = this.getInteractionInProgress();
        if (matchClientId) {
            return clientId === this.clientId;
        }
        else {
            return !!clientId;
        }
    };
    BrowserCacheManager.prototype.getInteractionInProgress = function () {
        var key = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].CACHE_PREFIX + "." + __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].INTERACTION_STATUS_KEY;
        return this.getTemporaryCache(key, false);
    };
    BrowserCacheManager.prototype.setInteractionInProgress = function (inProgress) {
        // Ensure we don't overwrite interaction in progress for a different clientId
        var key = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].CACHE_PREFIX + "." + __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].INTERACTION_STATUS_KEY;
        if (inProgress) {
            if (this.getInteractionInProgress()) {
                throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createInteractionInProgressError();
            }
            else {
                // No interaction is in progress
                this.setTemporaryCache(key, this.clientId, false);
            }
        }
        else if (!inProgress && this.getInteractionInProgress() === this.clientId) {
            this.removeItem(key);
        }
    };
    /**
     * Returns username retrieved from ADAL or MSAL v1 idToken
     */
    BrowserCacheManager.prototype.getLegacyLoginHint = function () {
        // Only check for adal/msal token if no SSO params are being used
        var adalIdTokenString = this.getTemporaryCache(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ADAL_ID_TOKEN);
        if (adalIdTokenString) {
            this.browserStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ADAL_ID_TOKEN);
            this.logger.verbose("Cached ADAL id token retrieved.");
        }
        // Check for cached MSAL v1 id token
        var msalIdTokenString = this.getTemporaryCache(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ID_TOKEN, true);
        if (msalIdTokenString) {
            this.removeItem(this.generateCacheKey(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["J" /* PersistentCacheKeys */].ID_TOKEN));
            this.logger.verbose("Cached MSAL.js v1 id token retrieved");
        }
        var cachedIdTokenString = msalIdTokenString || adalIdTokenString;
        if (cachedIdTokenString) {
            var cachedIdToken = new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["z" /* IdToken */](cachedIdTokenString, this.cryptoImpl);
            if (cachedIdToken.claims && cachedIdToken.claims.preferred_username) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 preferred_username as loginHint");
                return cachedIdToken.claims.preferred_username;
            }
            else if (cachedIdToken.claims && cachedIdToken.claims.upn) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 upn as loginHint");
                return cachedIdToken.claims.upn;
            }
            else {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, however, no account hint claim found. Enable preferred_username or upn id token claim to get SSO.");
            }
        }
        return null;
    };
    /**
     * Updates a credential's cache key if the current cache key is outdated
     */
    BrowserCacheManager.prototype.updateCredentialCacheKey = function (currentCacheKey, credential) {
        var updatedCacheKey = credential.generateCredentialKey();
        if (currentCacheKey !== updatedCacheKey) {
            var cacheItem = this.getItem(currentCacheKey);
            if (cacheItem) {
                this.removeItem(currentCacheKey);
                this.setItem(updatedCacheKey, cacheItem);
                this.logger.verbose("Updated an outdated " + credential.credentialType + " cache key");
                return updatedCacheKey;
            }
            else {
                this.logger.error("Attempted to update an outdated " + credential.credentialType + " cache key but no item matching the outdated key was found in storage");
            }
        }
        return currentCacheKey;
    };
    /**
     * Returns application id as redirect context during AcquireTokenRedirect flow.
     */
    BrowserCacheManager.prototype.getRedirectRequestContext = function () {
        return this.getTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].REDIRECT_CONTEXT, true);
    };
    /**
     * Sets application id as the redirect context during AcquireTokenRedirect flow.
     * @param value
     */
    BrowserCacheManager.prototype.setRedirectRequestContext = function (value) {
        this.setTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].REDIRECT_CONTEXT, value, true);
    };
    return BrowserCacheManager;
}(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["o" /* CacheManager */]));
var DEFAULT_BROWSER_CACHE_MANAGER = function (clientId, logger) {
    var cacheOptions = {
        cacheLocation: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].MemoryStorage,
        temporaryCacheLocation: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].MemoryStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        cacheMigrationEnabled: false,
        claimsBasedCachingEnabled: true
    };
    return new BrowserCacheManager(clientId, cacheOptions, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["x" /* DEFAULT_CRYPTO_IMPLEMENTATION */], logger);
};


//# sourceMappingURL=BrowserCacheManager.js.map


/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_SYSTEM_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildClientConfiguration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__crypto_ICrypto_js__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_AuthError_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger_Logger_js__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packageMetadata_js__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authority_AuthorityOptions_js__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cache_CacheManager_js__ = __webpack_require__(1101);
/*! @azure/msal-common v13.3.1 2023-10-27 */










/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
// Token renewal offset default in seconds
var DEFAULT_TOKEN_RENEWAL_OFFSET_SEC = 300;
var DEFAULT_SYSTEM_OPTIONS = {
    tokenRenewalOffsetSeconds: DEFAULT_TOKEN_RENEWAL_OFFSET_SEC,
    preventCorsPreflight: false
};
var DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: function () {
        // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: __WEBPACK_IMPORTED_MODULE_3__logger_Logger_js__["a" /* LogLevel */].Info,
    correlationId: __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
};
var DEFAULT_CACHE_OPTIONS = {
    claimsBasedCachingEnabled: true
};
var DEFAULT_NETWORK_IMPLEMENTATION = {
    sendGetRequestAsync: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var notImplErr;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                notImplErr = "Network interface - sendGetRequestAsync() has not been implemented";
                throw __WEBPACK_IMPORTED_MODULE_2__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
            });
        });
    },
    sendPostRequestAsync: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var notImplErr;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                notImplErr = "Network interface - sendPostRequestAsync() has not been implemented";
                throw __WEBPACK_IMPORTED_MODULE_2__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
            });
        });
    }
};
var DEFAULT_LIBRARY_INFO = {
    sku: __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].SKU,
    version: __WEBPACK_IMPORTED_MODULE_5__packageMetadata_js__["b" /* version */],
    cpu: __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
    os: __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
};
var DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
    clientAssertion: undefined
};
var DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: __WEBPACK_IMPORTED_MODULE_6__authority_AuthorityOptions_js__["a" /* AzureCloudInstance */].None,
    tenant: "" + __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].DEFAULT_COMMON_TENANT
};
var DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 */
function buildClientConfiguration(_a) {
    var userAuthOptions = _a.authOptions, userSystemOptions = _a.systemOptions, userLoggerOption = _a.loggerOptions, userCacheOptions = _a.cacheOptions, storageImplementation = _a.storageInterface, networkImplementation = _a.networkInterface, cryptoImplementation = _a.cryptoInterface, clientCredentials = _a.clientCredentials, libraryInfo = _a.libraryInfo, telemetry = _a.telemetry, serverTelemetryManager = _a.serverTelemetryManager, persistencePlugin = _a.persistencePlugin, serializableCache = _a.serializableCache;
    var loggerOptions = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, DEFAULT_LOGGER_IMPLEMENTATION), userLoggerOption);
    return {
        authOptions: buildAuthOptions(userAuthOptions),
        systemOptions: Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, DEFAULT_SYSTEM_OPTIONS), userSystemOptions),
        loggerOptions: loggerOptions,
        cacheOptions: Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, DEFAULT_CACHE_OPTIONS), userCacheOptions),
        storageInterface: storageImplementation || new __WEBPACK_IMPORTED_MODULE_7__cache_CacheManager_js__["b" /* DefaultStorageClass */](userAuthOptions.clientId, __WEBPACK_IMPORTED_MODULE_1__crypto_ICrypto_js__["a" /* DEFAULT_CRYPTO_IMPLEMENTATION */], new __WEBPACK_IMPORTED_MODULE_3__logger_Logger_js__["b" /* Logger */](loggerOptions)),
        networkInterface: networkImplementation || DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || __WEBPACK_IMPORTED_MODULE_1__crypto_ICrypto_js__["a" /* DEFAULT_CRYPTO_IMPLEMENTATION */],
        clientCredentials: clientCredentials || DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, DEFAULT_LIBRARY_INFO), libraryInfo),
        telemetry: Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, DEFAULT_TELEMETRY_OPTIONS), telemetry),
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null,
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */
function buildAuthOptions(authOptions) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({ clientCapabilities: [], azureCloudOptions: DEFAULT_AZURE_CLOUD_OPTIONS, skipAuthorityMetadataCache: false }, authOptions);
}


//# sourceMappingURL=ClientConfiguration.js.map


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_CRYPTO_IMPLEMENTATION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_AuthError_js__ = __webpack_require__(112);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var DEFAULT_CRYPTO_IMPLEMENTATION = {
    createNewGuid: function () {
        var notImplErr = "Crypto interface - createNewGuid() has not been implemented";
        throw __WEBPACK_IMPORTED_MODULE_1__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    },
    base64Decode: function () {
        var notImplErr = "Crypto interface - base64Decode() has not been implemented";
        throw __WEBPACK_IMPORTED_MODULE_1__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    },
    base64Encode: function () {
        var notImplErr = "Crypto interface - base64Encode() has not been implemented";
        throw __WEBPACK_IMPORTED_MODULE_1__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    },
    generatePkceCodes: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var notImplErr;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                notImplErr = "Crypto interface - generatePkceCodes() has not been implemented";
                throw __WEBPACK_IMPORTED_MODULE_1__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
            });
        });
    },
    getPublicKeyThumbprint: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var notImplErr;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                notImplErr = "Crypto interface - getPublicKeyThumbprint() has not been implemented";
                throw __WEBPACK_IMPORTED_MODULE_1__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
            });
        });
    },
    removeTokenBindingKey: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var notImplErr;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                notImplErr = "Crypto interface - removeTokenBindingKey() has not been implemented";
                throw __WEBPACK_IMPORTED_MODULE_1__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
            });
        });
    },
    clearKeystore: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var notImplErr;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                notImplErr = "Crypto interface - clearKeystore() has not been implemented";
                throw __WEBPACK_IMPORTED_MODULE_1__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
            });
        });
    },
    signJwt: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var notImplErr;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                notImplErr = "Crypto interface - signJwt() has not been implemented";
                throw __WEBPACK_IMPORTED_MODULE_1__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
            });
        });
    },
    hashString: function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var notImplErr;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                notImplErr = "Crypto interface - hashString() has not been implemented";
                throw __WEBPACK_IMPORTED_MODULE_1__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
            });
        });
    }
};


//# sourceMappingURL=ICrypto.js.map


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultStorageClass; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request_ScopeSet_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__entities_AccountEntity_js__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_AuthToken_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packageMetadata_js__ = __webpack_require__(396);
/*! @azure/msal-common v13.3.1 2023-10-27 */










/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 */
var CacheManager = /** @class */ (function () {
    function CacheManager(clientId, cryptoImpl, logger) {
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone(__WEBPACK_IMPORTED_MODULE_7__packageMetadata_js__["a" /* name */], __WEBPACK_IMPORTED_MODULE_7__packageMetadata_js__["b" /* version */]);
    }
    /**
     * Returns all accounts in cache
     */
    CacheManager.prototype.getAllAccounts = function () {
        var _this = this;
        var allAccountKeys = this.getAccountKeys();
        if (allAccountKeys.length < 1) {
            return [];
        }
        var accountEntities = allAccountKeys.reduce(function (accounts, key) {
            var entity = _this.getAccount(key);
            if (!entity) {
                return accounts;
            }
            accounts.push(entity);
            return accounts;
        }, []);
        if (accountEntities.length < 1) {
            return [];
        }
        else {
            var allAccounts = accountEntities.map(function (accountEntity) {
                return _this.getAccountInfoFromEntity(accountEntity);
            });
            return allAccounts;
        }
    };
    /**
     * Gets accountInfo object based on provided filters
     */
    CacheManager.prototype.getAccountInfoFilteredBy = function (accountFilter) {
        var allAccounts = this.getAccountsFilteredBy(accountFilter);
        if (allAccounts.length > 0) {
            return this.getAccountInfoFromEntity(allAccounts[0]);
        }
        else {
            return null;
        }
    };
    CacheManager.prototype.getAccountInfoFromEntity = function (accountEntity) {
        var accountInfo = accountEntity.getAccountInfo();
        var idToken = this.getIdToken(accountInfo);
        if (idToken) {
            accountInfo.idToken = idToken.secret;
            accountInfo.idTokenClaims = new __WEBPACK_IMPORTED_MODULE_6__account_AuthToken_js__["a" /* AuthToken */](idToken.secret, this.cryptoImpl).claims;
        }
        return accountInfo;
    };
    /**
     * saves a cache record
     * @param cacheRecord
     */
    CacheManager.prototype.saveCacheRecord = function (cacheRecord) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!cacheRecord) {
                            throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createNullOrUndefinedCacheRecord();
                        }
                        if (!!cacheRecord.account) {
                            this.setAccount(cacheRecord.account);
                        }
                        if (!!cacheRecord.idToken) {
                            this.setIdTokenCredential(cacheRecord.idToken);
                        }
                        if (!!!cacheRecord.accessToken) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.saveAccessToken(cacheRecord.accessToken)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!!cacheRecord.refreshToken) {
                            this.setRefreshTokenCredential(cacheRecord.refreshToken);
                        }
                        if (!!cacheRecord.appMetadata) {
                            this.setAppMetadata(cacheRecord.appMetadata);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * saves access token credential
     * @param credential
     */
    CacheManager.prototype.saveAccessToken = function (credential) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var accessTokenFilter, tokenKeys, currentScopes, removedAccessTokens;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accessTokenFilter = {
                            clientId: credential.clientId,
                            credentialType: credential.credentialType,
                            environment: credential.environment,
                            homeAccountId: credential.homeAccountId,
                            realm: credential.realm,
                            tokenType: credential.tokenType,
                            requestedClaimsHash: credential.requestedClaimsHash
                        };
                        tokenKeys = this.getTokenKeys();
                        currentScopes = __WEBPACK_IMPORTED_MODULE_2__request_ScopeSet_js__["a" /* ScopeSet */].fromString(credential.target);
                        removedAccessTokens = [];
                        tokenKeys.accessToken.forEach(function (key) {
                            if (!_this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) {
                                return;
                            }
                            var tokenEntity = _this.getAccessTokenCredential(key);
                            if (tokenEntity && _this.credentialMatchesFilter(tokenEntity, accessTokenFilter)) {
                                var tokenScopeSet = __WEBPACK_IMPORTED_MODULE_2__request_ScopeSet_js__["a" /* ScopeSet */].fromString(tokenEntity.target);
                                if (tokenScopeSet.intersectingScopeSets(currentScopes)) {
                                    removedAccessTokens.push(_this.removeAccessToken(key));
                                }
                            }
                        });
                        return [4 /*yield*/, Promise.all(removedAccessTokens)];
                    case 1:
                        _a.sent();
                        this.setAccessTokenCredential(credential);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * retrieve accounts matching all provided filters; if no filter is set, get all accounts
     * not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param homeAccountId
     * @param environment
     * @param realm
     */
    CacheManager.prototype.getAccountsFilteredBy = function (accountFilter) {
        var _this = this;
        var allAccountKeys = this.getAccountKeys();
        var matchingAccounts = [];
        allAccountKeys.forEach(function (cacheKey) {
            if (!_this.isAccountKey(cacheKey, accountFilter.homeAccountId, accountFilter.realm)) {
                // Don't parse value if the key doesn't match the account filters
                return;
            }
            var entity = _this.getAccount(cacheKey);
            if (!entity) {
                return;
            }
            if (!!accountFilter.homeAccountId && !_this.matchHomeAccountId(entity, accountFilter.homeAccountId)) {
                return;
            }
            if (!!accountFilter.localAccountId && !_this.matchLocalAccountId(entity, accountFilter.localAccountId)) {
                return;
            }
            if (!!accountFilter.username && !_this.matchUsername(entity, accountFilter.username)) {
                return;
            }
            if (!!accountFilter.environment && !_this.matchEnvironment(entity, accountFilter.environment)) {
                return;
            }
            if (!!accountFilter.realm && !_this.matchRealm(entity, accountFilter.realm)) {
                return;
            }
            if (!!accountFilter.nativeAccountId && !_this.matchNativeAccountId(entity, accountFilter.nativeAccountId)) {
                return;
            }
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    };
    /**
     * Returns true if the given key matches our account key schema. Also matches homeAccountId and/or tenantId if provided
     * @param key
     * @param homeAccountId
     * @param tenantId
     * @returns
     */
    CacheManager.prototype.isAccountKey = function (key, homeAccountId, tenantId) {
        if (key.split(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR).length < 3) {
            // Account cache keys contain 3 items separated by '-' (each item may also contain '-')
            return false;
        }
        if (homeAccountId && !key.toLowerCase().includes(homeAccountId.toLowerCase())) {
            return false;
        }
        if (tenantId && !key.toLowerCase().includes(tenantId.toLowerCase())) {
            return false;
        }
        // Do not check environment as aliasing can cause false negatives
        return true;
    };
    /**
     * Returns true if the given key matches our credential key schema.
     * @param key
     */
    CacheManager.prototype.isCredentialKey = function (key) {
        if (key.split(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR).length < 6) {
            // Credential cache keys contain 6 items separated by '-' (each item may also contain '-')
            return false;
        }
        var lowerCaseKey = key.toLowerCase();
        // Credential keys must indicate what credential type they represent
        if (lowerCaseKey.indexOf(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].ID_TOKEN.toLowerCase()) === -1 &&
            lowerCaseKey.indexOf(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN.toLowerCase()) === -1 &&
            lowerCaseKey.indexOf(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) === -1 &&
            lowerCaseKey.indexOf(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].REFRESH_TOKEN.toLowerCase()) === -1) {
            return false;
        }
        if (lowerCaseKey.indexOf(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].REFRESH_TOKEN.toLowerCase()) > -1) {
            // Refresh tokens must contain the client id or family id
            var clientIdValidation = "" + __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].REFRESH_TOKEN + __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR + this.clientId + __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR;
            var familyIdValidation = "" + __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].REFRESH_TOKEN + __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR + __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["E" /* THE_FAMILY_ID */] + __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR;
            if (lowerCaseKey.indexOf(clientIdValidation.toLowerCase()) === -1 && lowerCaseKey.indexOf(familyIdValidation.toLowerCase()) === -1) {
                return false;
            }
        }
        else if (lowerCaseKey.indexOf(this.clientId.toLowerCase()) === -1) {
            // Tokens must contain the clientId
            return false;
        }
        return true;
    };
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @returns
     */
    CacheManager.prototype.credentialMatchesFilter = function (entity, filter) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) {
            return false;
        }
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) {
            return false;
        }
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */
        if ((typeof filter.homeAccountId === "string") && !this.matchHomeAccountId(entity, filter.homeAccountId)) {
            return false;
        }
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) {
            return false;
        }
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) {
            return false;
        }
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) {
            return false;
        }
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) {
            return false;
        }
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */
        if (!!filter.target && !this.matchTarget(entity, filter.target)) {
            return false;
        }
        // If request OR cached entity has requested Claims Hash, check if they match
        if (filter.requestedClaimsHash || entity.requestedClaimsHash) {
            // Don't match if either is undefined or they are different
            if (entity.requestedClaimsHash !== filter.requestedClaimsHash) {
                return false;
            }
        }
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) {
                return false;
            }
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["e" /* AuthenticationScheme */].SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) {
                    return false;
                }
            }
        }
        return true;
    };
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     */
    CacheManager.prototype.getAppMetadataFilteredBy = function (filter) {
        return this.getAppMetadataFilteredByInternal(filter.environment, filter.clientId);
    };
    /**
     * Support function to help match appMetadata
     * @param environment
     * @param clientId
     */
    CacheManager.prototype.getAppMetadataFilteredByInternal = function (environment, clientId) {
        var _this = this;
        var allCacheKeys = this.getKeys();
        var matchingAppMetadata = {};
        allCacheKeys.forEach(function (cacheKey) {
            // don't parse any non-appMetadata type cache entities
            if (!_this.isAppMetadata(cacheKey)) {
                return;
            }
            // Attempt retrieval
            var entity = _this.getAppMetadata(cacheKey);
            if (!entity) {
                return;
            }
            if (!!environment && !_this.matchEnvironment(entity, environment)) {
                return;
            }
            if (!!clientId && !_this.matchClientId(entity, clientId)) {
                return;
            }
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    };
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param filter
     */
    CacheManager.prototype.getAuthorityMetadataByAlias = function (host) {
        var _this = this;
        var allCacheKeys = this.getAuthorityMetadataKeys();
        var matchedEntity = null;
        allCacheKeys.forEach(function (cacheKey) {
            // don't parse any non-authorityMetadata type cache entities
            if (!_this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(_this.clientId) === -1) {
                return;
            }
            // Attempt retrieval
            var entity = _this.getAuthorityMetadata(cacheKey);
            if (!entity) {
                return;
            }
            if (entity.aliases.indexOf(host) === -1) {
                return;
            }
            matchedEntity = entity;
        });
        return matchedEntity;
    };
    /**
     * Removes all accounts and related tokens from cache.
     */
    CacheManager.prototype.removeAllAccounts = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var allAccountKeys, removedAccounts;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        allAccountKeys = this.getAccountKeys();
                        removedAccounts = [];
                        allAccountKeys.forEach(function (cacheKey) {
                            removedAccounts.push(_this.removeAccount(cacheKey));
                        });
                        return [4 /*yield*/, Promise.all(removedAccounts)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */
    CacheManager.prototype.removeAccount = function (accountKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var account;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        account = this.getAccount(accountKey);
                        if (!account) {
                            throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createNoAccountFoundError();
                        }
                        return [4 /*yield*/, this.removeAccountContext(account)];
                    case 1:
                        _a.sent();
                        this.removeItem(accountKey);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes credentials associated with the provided account
     * @param account
     */
    CacheManager.prototype.removeAccountContext = function (account) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var allTokenKeys, accountId, removedCredentials;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        allTokenKeys = this.getTokenKeys();
                        accountId = account.generateAccountId();
                        removedCredentials = [];
                        allTokenKeys.idToken.forEach(function (key) {
                            if (key.indexOf(accountId) === 0) {
                                _this.removeIdToken(key);
                            }
                        });
                        allTokenKeys.accessToken.forEach(function (key) {
                            if (key.indexOf(accountId) === 0) {
                                removedCredentials.push(_this.removeAccessToken(key));
                            }
                        });
                        allTokenKeys.refreshToken.forEach(function (key) {
                            if (key.indexOf(accountId) === 0) {
                                _this.removeRefreshToken(key);
                            }
                        });
                        return [4 /*yield*/, Promise.all(removedCredentials)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * returns a boolean if the given credential is removed
     * @param credential
     */
    CacheManager.prototype.removeAccessToken = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var credential, accessTokenWithAuthSchemeEntity, kid;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        credential = this.getAccessTokenCredential(key);
                        if (!credential) {
                            return [2 /*return*/];
                        }
                        if (!(credential.credentialType.toLowerCase() === __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase())) return [3 /*break*/, 4];
                        if (!(credential.tokenType === __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["e" /* AuthenticationScheme */].POP)) return [3 /*break*/, 4];
                        accessTokenWithAuthSchemeEntity = credential;
                        kid = accessTokenWithAuthSchemeEntity.keyId;
                        if (!kid) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.cryptoImpl.removeTokenBindingKey(kid)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a.sent();
                        throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createBindingKeyNotRemovedError();
                    case 4: return [2 /*return*/, this.removeItem(key)];
                }
            });
        });
    };
    /**
     * Removes all app metadata objects from cache.
     */
    CacheManager.prototype.removeAppMetadata = function () {
        var _this = this;
        var allCacheKeys = this.getKeys();
        allCacheKeys.forEach(function (cacheKey) {
            if (_this.isAppMetadata(cacheKey)) {
                _this.removeItem(cacheKey);
            }
        });
        return true;
    };
    /**
     * Retrieve the cached credentials into a cacherecord
     * @param account
     * @param clientId
     * @param scopes
     * @param environment
     * @param authScheme
     */
    CacheManager.prototype.readCacheRecord = function (account, request, environment) {
        var tokenKeys = this.getTokenKeys();
        var cachedAccount = this.readAccountFromCache(account);
        var cachedIdToken = this.getIdToken(account, tokenKeys);
        var cachedAccessToken = this.getAccessToken(account, request, tokenKeys);
        var cachedRefreshToken = this.getRefreshToken(account, false, tokenKeys);
        var cachedAppMetadata = this.readAppMetadataFromCache(environment);
        if (cachedAccount && cachedIdToken) {
            cachedAccount.idTokenClaims = new __WEBPACK_IMPORTED_MODULE_6__account_AuthToken_js__["a" /* AuthToken */](cachedIdToken.secret, this.cryptoImpl).claims;
        }
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata,
        };
    };
    /**
     * Retrieve AccountEntity from cache
     * @param account
     */
    CacheManager.prototype.readAccountFromCache = function (account) {
        var accountKey = __WEBPACK_IMPORTED_MODULE_3__entities_AccountEntity_js__["a" /* AccountEntity */].generateAccountCacheKey(account);
        return this.getAccount(accountKey);
    };
    /**
     * Retrieve IdTokenEntity from cache
     * @param clientId
     * @param account
     * @param inputRealm
     */
    CacheManager.prototype.getIdToken = function (account, tokenKeys) {
        var _this = this;
        this.commonLogger.trace("CacheManager - getIdToken called");
        var idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].ID_TOKEN,
            clientId: this.clientId,
            realm: account.tenantId,
        };
        var idTokens = this.getIdTokensByFilter(idTokenFilter, tokenKeys);
        var numIdTokens = idTokens.length;
        if (numIdTokens < 1) {
            this.commonLogger.info("CacheManager:getIdToken - No token found");
            return null;
        }
        else if (numIdTokens > 1) {
            this.commonLogger.info("CacheManager:getIdToken - Multiple id tokens found, clearing them");
            idTokens.forEach(function (idToken) {
                _this.removeIdToken(idToken.generateCredentialKey());
            });
            return null;
        }
        this.commonLogger.info("CacheManager:getIdToken - Returning id token");
        return idTokens[0];
    };
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */
    CacheManager.prototype.getIdTokensByFilter = function (filter, tokenKeys) {
        var _this = this;
        var idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        var idTokens = [];
        idTokenKeys.forEach(function (key) {
            if (!_this.idTokenKeyMatchesFilter(key, Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({ clientId: _this.clientId }, filter))) {
                return;
            }
            var idToken = _this.getIdTokenCredential(key);
            if (idToken && _this.credentialMatchesFilter(idToken, filter)) {
                idTokens.push(idToken);
            }
        });
        return idTokens;
    };
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */
    CacheManager.prototype.idTokenKeyMatchesFilter = function (inputKey, filter) {
        var key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) {
            return false;
        }
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) {
            return false;
        }
        return true;
    };
    /**
     * Removes idToken from the cache
     * @param key
     */
    CacheManager.prototype.removeIdToken = function (key) {
        this.removeItem(key);
    };
    /**
     * Removes refresh token from the cache
     * @param key
     */
    CacheManager.prototype.removeRefreshToken = function (key) {
        this.removeItem(key);
    };
    /**
     * Retrieve AccessTokenEntity from cache
     * @param clientId
     * @param account
     * @param scopes
     * @param authScheme
     */
    CacheManager.prototype.getAccessToken = function (account, request, tokenKeys) {
        var _this = this;
        this.commonLogger.trace("CacheManager - getAccessToken called");
        var scopes = __WEBPACK_IMPORTED_MODULE_2__request_ScopeSet_js__["a" /* ScopeSet */].createSearchScopes(request.scopes);
        var authScheme = request.authenticationScheme || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["e" /* AuthenticationScheme */].BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */
        var credentialType = (authScheme && authScheme.toLowerCase() !== __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["e" /* AuthenticationScheme */].BEARER.toLowerCase()) ? __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN_WITH_AUTH_SCHEME : __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN;
        var accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid,
            requestedClaimsHash: request.requestedClaimsHash,
        };
        var accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        var accessTokens = [];
        accessTokenKeys.forEach(function (key) {
            // Validate key
            if (_this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                var accessToken = _this.getAccessTokenCredential(key);
                // Validate value
                if (accessToken && _this.credentialMatchesFilter(accessToken, accessTokenFilter)) {
                    accessTokens.push(accessToken);
                }
            }
        });
        var numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("CacheManager:getAccessToken - No token found");
            return null;
        }
        else if (numAccessTokens > 1) {
            this.commonLogger.info("CacheManager:getAccessToken - Multiple access tokens found, clearing them");
            accessTokens.forEach(function (accessToken) {
                _this.removeAccessToken(accessToken.generateCredentialKey());
            });
            return null;
        }
        this.commonLogger.info("CacheManager:getAccessToken - Returning access token");
        return accessTokens[0];
    };
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */
    CacheManager.prototype.accessTokenKeyMatchesFilter = function (inputKey, filter, keyMustContainAllScopes) {
        var key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) {
            return false;
        }
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) {
            return false;
        }
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) {
            return false;
        }
        if (filter.requestedClaimsHash && key.indexOf(filter.requestedClaimsHash.toLowerCase()) === -1) {
            return false;
        }
        if (filter.target) {
            var scopes = filter.target.asArray();
            for (var i = 0; i < scopes.length; i++) {
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) {
                    // When performing a cache lookup a missing scope would be a cache miss
                    return false;
                }
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) {
                    // When performing a cache write, any token with a subset of requested scopes should be replaced
                    return true;
                }
            }
        }
        return true;
    };
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */
    CacheManager.prototype.getAccessTokensByFilter = function (filter) {
        var _this = this;
        var tokenKeys = this.getTokenKeys();
        var accessTokens = [];
        tokenKeys.accessToken.forEach(function (key) {
            if (!_this.accessTokenKeyMatchesFilter(key, filter, true)) {
                return;
            }
            var accessToken = _this.getAccessTokenCredential(key);
            if (accessToken && _this.credentialMatchesFilter(accessToken, filter)) {
                accessTokens.push(accessToken);
            }
        });
        return accessTokens;
    };
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param clientId
     * @param account
     * @param familyRT
     */
    CacheManager.prototype.getRefreshToken = function (account, familyRT, tokenKeys) {
        var _this = this;
        this.commonLogger.trace("CacheManager - getRefreshToken called");
        var id = familyRT ? __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["E" /* THE_FAMILY_ID */] : undefined;
        var refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id,
        };
        var refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        var refreshTokens = [];
        refreshTokenKeys.forEach(function (key) {
            // Validate key
            if (_this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                var refreshToken = _this.getRefreshTokenCredential(key);
                // Validate value
                if (refreshToken && _this.credentialMatchesFilter(refreshToken, refreshTokenFilter)) {
                    refreshTokens.push(refreshToken);
                }
            }
        });
        var numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("CacheManager:getRefreshToken - No refresh token found.");
            return null;
        }
        // address the else case after remove functions address environment aliases
        this.commonLogger.info("CacheManager:getRefreshToken - returning refresh token");
        return refreshTokens[0];
    };
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */
    CacheManager.prototype.refreshTokenKeyMatchesFilter = function (inputKey, filter) {
        var key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) {
            return false;
        }
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) {
            return false;
        }
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) {
            return false;
        }
        return true;
    };
    /**
     * Retrieve AppMetadataEntity from cache
     */
    CacheManager.prototype.readAppMetadataFromCache = function (environment) {
        var appMetadataFilter = {
            environment: environment,
            clientId: this.clientId,
        };
        var appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
        var appMetadataEntries = Object.keys(appMetadata).map(function (key) { return appMetadata[key]; });
        var numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) {
            return null;
        }
        else if (numAppMetadata > 1) {
            throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createMultipleMatchingAppMetadataInCacheError();
        }
        return appMetadataEntries[0];
    };
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */
    CacheManager.prototype.isAppMetadataFOCI = function (environment) {
        var appMetadata = this.readAppMetadataFromCache(environment);
        return !!(appMetadata && appMetadata.familyId === __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["E" /* THE_FAMILY_ID */]);
    };
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */
    CacheManager.prototype.matchHomeAccountId = function (entity, homeAccountId) {
        return !!((typeof entity.homeAccountId === "string") && (homeAccountId === entity.homeAccountId));
    };
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */
    CacheManager.prototype.matchLocalAccountId = function (entity, localAccountId) {
        return !!((typeof entity.localAccountId === "string") && (localAccountId === entity.localAccountId));
    };
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */
    CacheManager.prototype.matchUsername = function (entity, username) {
        return !!((typeof entity.username === "string") && (username.toLowerCase() === entity.username.toLowerCase()));
    };
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */
    CacheManager.prototype.matchUserAssertionHash = function (entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    };
    /**
     * helper to match environment
     * @param value
     * @param environment
     */
    CacheManager.prototype.matchEnvironment = function (entity, environment) {
        var cloudMetadata = this.getAuthorityMetadataByAlias(environment);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) {
            return true;
        }
        return false;
    };
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */
    CacheManager.prototype.matchCredentialType = function (entity, credentialType) {
        return (entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase());
    };
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */
    CacheManager.prototype.matchClientId = function (entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    };
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */
    CacheManager.prototype.matchFamilyId = function (entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    };
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */
    CacheManager.prototype.matchRealm = function (entity, realm) {
        return !!(entity.realm && realm === entity.realm);
    };
    /**
     * helper to match nativeAccountId
     * @param entity
     * @param nativeAccountId
     * @returns boolean indicating the match result
     */
    CacheManager.prototype.matchNativeAccountId = function (entity, nativeAccountId) {
        return !!(entity.nativeAccountId && nativeAccountId === entity.nativeAccountId);
    };
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */
    CacheManager.prototype.matchTarget = function (entity, target) {
        var isNotAccessTokenCredential = (entity.credentialType !== __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN && entity.credentialType !== __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN_WITH_AUTH_SCHEME);
        if (isNotAccessTokenCredential || !entity.target) {
            return false;
        }
        var entityScopeSet = __WEBPACK_IMPORTED_MODULE_2__request_ScopeSet_js__["a" /* ScopeSet */].fromString(entity.target);
        return entityScopeSet.containsScopeSet(target);
    };
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */
    CacheManager.prototype.matchTokenType = function (entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    };
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */
    CacheManager.prototype.matchKeyId = function (entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    };
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */
    CacheManager.prototype.isAppMetadata = function (key) {
        return key.indexOf(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["c" /* APP_METADATA */]) !== -1;
    };
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */
    CacheManager.prototype.isAuthorityMetadata = function (key) {
        return key.indexOf(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["d" /* AUTHORITY_METADATA_CONSTANTS */].CACHE_KEY) !== -1;
    };
    /**
     * returns cache key used for cloud instance metadata
     */
    CacheManager.prototype.generateAuthorityMetadataCacheKey = function (authority) {
        return __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["d" /* AUTHORITY_METADATA_CONSTANTS */].CACHE_KEY + "-" + this.clientId + "-" + authority;
    };
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */
    CacheManager.toObject = function (obj, json) {
        for (var propertyName in json) {
            obj[propertyName] = json[propertyName];
        }
        return obj;
    };
    return CacheManager;
}());
var DefaultStorageClass = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(DefaultStorageClass, _super);
    function DefaultStorageClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultStorageClass.prototype.setAccount = function () {
        var notImplErr = "Storage interface - setAccount() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccount = function () {
        var notImplErr = "Storage interface - getAccount() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setIdTokenCredential = function () {
        var notImplErr = "Storage interface - setIdTokenCredential() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getIdTokenCredential = function () {
        var notImplErr = "Storage interface - getIdTokenCredential() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAccessTokenCredential = function () {
        var notImplErr = "Storage interface - setAccessTokenCredential() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccessTokenCredential = function () {
        var notImplErr = "Storage interface - getAccessTokenCredential() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setRefreshTokenCredential = function () {
        var notImplErr = "Storage interface - setRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getRefreshTokenCredential = function () {
        var notImplErr = "Storage interface - getRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAppMetadata = function () {
        var notImplErr = "Storage interface - setAppMetadata() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAppMetadata = function () {
        var notImplErr = "Storage interface - getAppMetadata() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setServerTelemetry = function () {
        var notImplErr = "Storage interface - setServerTelemetry() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getServerTelemetry = function () {
        var notImplErr = "Storage interface - getServerTelemetry() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAuthorityMetadata = function () {
        var notImplErr = "Storage interface - setAuthorityMetadata() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAuthorityMetadata = function () {
        var notImplErr = "Storage interface - getAuthorityMetadata() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAuthorityMetadataKeys = function () {
        var notImplErr = "Storage interface - getAuthorityMetadataKeys() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setThrottlingCache = function () {
        var notImplErr = "Storage interface - setThrottlingCache() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getThrottlingCache = function () {
        var notImplErr = "Storage interface - getThrottlingCache() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.removeItem = function () {
        var notImplErr = "Storage interface - removeItem() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.containsKey = function () {
        var notImplErr = "Storage interface - containsKey() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getKeys = function () {
        var notImplErr = "Storage interface - getKeys() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccountKeys = function () {
        var notImplErr = "Storage interface - getAccountKeys() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getTokenKeys = function () {
        var notImplErr = "Storage interface - getTokenKeys() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.clear = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var notImplErr;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                notImplErr = "Storage interface - clear() has not been implemented for the cacheStorage interface.";
                throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
            });
        });
    };
    DefaultStorageClass.prototype.updateCredentialCacheKey = function () {
        var notImplErr = "Storage interface - updateCredentialCacheKey() has not been implemented for the cacheStorage interface.";
        throw __WEBPACK_IMPORTED_MODULE_4__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr);
    };
    return DefaultStorageClass;
}(CacheManager));


//# sourceMappingURL=CacheManager.js.map


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NetworkManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ThrottlingUtils_js__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_AuthError_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__ = __webpack_require__(57);
/*! @azure/msal-common v13.3.1 2023-10-27 */






/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var NetworkManager = /** @class */ (function () {
    function NetworkManager(networkClient, cacheManager) {
        this.networkClient = networkClient;
        this.cacheManager = cacheManager;
    }
    /**
     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
     * @param thumbprint
     * @param tokenEndpoint
     * @param options
     */
    NetworkManager.prototype.sendPostRequest = function (thumbprint, tokenEndpoint, options) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var response, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_1__ThrottlingUtils_js__["a" /* ThrottlingUtils */].preProcess(this.cacheManager, thumbprint);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.networkClient.sendPostRequestAsync(tokenEndpoint, options)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1 instanceof __WEBPACK_IMPORTED_MODULE_2__error_AuthError_js__["a" /* AuthError */]) {
                            throw e_1;
                        }
                        else {
                            throw __WEBPACK_IMPORTED_MODULE_3__error_ClientAuthError_js__["a" /* ClientAuthError */].createNetworkError(tokenEndpoint, e_1);
                        }
                    case 4:
                        __WEBPACK_IMPORTED_MODULE_1__ThrottlingUtils_js__["a" /* ThrottlingUtils */].postProcess(this.cacheManager, thumbprint, response);
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return NetworkManager;
}());


//# sourceMappingURL=NetworkManager.js.map


/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThrottlingUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_ServerError_js__ = __webpack_require__(294);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ThrottlingUtils = /** @class */ (function () {
    function ThrottlingUtils() {
    }
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */
    ThrottlingUtils.generateThrottlingStorageKey = function (thumbprint) {
        return __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["F" /* ThrottlingConstants */].THROTTLING_PREFIX + "." + JSON.stringify(thumbprint);
    };
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */
    ThrottlingUtils.preProcess = function (cacheManager, thumbprint) {
        var _a;
        var key = ThrottlingUtils.generateThrottlingStorageKey(thumbprint);
        var value = cacheManager.getThrottlingCache(key);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key);
                return;
            }
            throw new __WEBPACK_IMPORTED_MODULE_1__error_ServerError_js__["a" /* ServerError */](((_a = value.errorCodes) === null || _a === void 0 ? void 0 : _a.join(" ")) || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING, value.errorMessage, value.subError);
        }
    };
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */
    ThrottlingUtils.postProcess = function (cacheManager, thumbprint, response) {
        if (ThrottlingUtils.checkResponseStatus(response) || ThrottlingUtils.checkResponseForRetryAfter(response)) {
            var thumbprintValue = {
                throttleTime: ThrottlingUtils.calculateThrottleTime(parseInt(response.headers[__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["q" /* HeaderNames */].RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache(ThrottlingUtils.generateThrottlingStorageKey(thumbprint), thumbprintValue);
        }
    };
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */
    ThrottlingUtils.checkResponseStatus = function (response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    };
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */
    ThrottlingUtils.checkResponseForRetryAfter = function (response) {
        if (response.headers) {
            return response.headers.hasOwnProperty(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["q" /* HeaderNames */].RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        }
        return false;
    };
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */
    ThrottlingUtils.calculateThrottleTime = function (throttleTime) {
        var time = throttleTime <= 0 ? 0 : throttleTime;
        var currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["F" /* ThrottlingConstants */].DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["F" /* ThrottlingConstants */].DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    };
    ThrottlingUtils.removeThrottle = function (cacheManager, clientId, request, homeAccountIdentifier) {
        var thumbprint = {
            clientId: clientId,
            authority: request.authority,
            scopes: request.scopes,
            homeAccountIdentifier: homeAccountIdentifier,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        var key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key);
    };
    return ThrottlingUtils;
}());


//# sourceMappingURL=ThrottlingUtils.js.map


/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RequestValidator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Validates server consumable params from the "request" objects
 */
var RequestValidator = /** @class */ (function () {
    function RequestValidator() {
    }
    /**
     * Utility to check if the `redirectUri` in the request is a non-null value
     * @param redirectUri
     */
    RequestValidator.validateRedirectUri = function (redirectUri) {
        if (__WEBPACK_IMPORTED_MODULE_0__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(redirectUri)) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createRedirectUriEmptyError();
        }
    };
    /**
     * Utility to validate prompt sent by the user in the request
     * @param prompt
     */
    RequestValidator.validatePrompt = function (prompt) {
        var promptValues = [];
        for (var value in __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["w" /* PromptValue */]) {
            promptValues.push(__WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["w" /* PromptValue */][value]);
        }
        if (promptValues.indexOf(prompt) < 0) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInvalidPromptError(prompt);
        }
    };
    RequestValidator.validateClaims = function (claims) {
        try {
            JSON.parse(claims);
        }
        catch (e) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInvalidClaimsRequestError();
        }
    };
    /**
     * Utility to validate code_challenge and code_challenge_method
     * @param codeChallenge
     * @param codeChallengeMethod
     */
    RequestValidator.validateCodeChallengeParams = function (codeChallenge, codeChallengeMethod) {
        if (__WEBPACK_IMPORTED_MODULE_0__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(codeChallenge) || __WEBPACK_IMPORTED_MODULE_0__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(codeChallengeMethod)) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInvalidCodeChallengeParamsError();
        }
        else {
            this.validateCodeChallengeMethod(codeChallengeMethod);
        }
    };
    /**
     * Utility to validate code_challenge_method
     * @param codeChallengeMethod
     */
    RequestValidator.validateCodeChallengeMethod = function (codeChallengeMethod) {
        if ([
            __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["l" /* CodeChallengeMethodValues */].PLAIN,
            __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["l" /* CodeChallengeMethodValues */].S256
        ].indexOf(codeChallengeMethod) < 0) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInvalidCodeChallengeMethodError();
        }
    };
    /**
     * Removes unnecessary, duplicate, and empty string query parameters from extraQueryParameters
     * @param request
     */
    RequestValidator.sanitizeEQParams = function (eQParams, queryParams) {
        if (!eQParams) {
            return {};
        }
        // Remove any query parameters already included in SSO params
        queryParams.forEach(function (value, key) {
            if (eQParams[key]) {
                delete eQParams[key];
            }
        });
        // remove empty string parameters
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return Object.fromEntries(Object.entries(eQParams).filter(function (_a) {
            var value = _a[1];
            return value !== "";
        }));
    };
    return RequestValidator;
}());


//# sourceMappingURL=RequestValidator.js.map


/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IdTokenEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CredentialEntity_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * ID_TOKEN Cache
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-idtoken-clientId-contoso.com-
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      realm: Full tenant or organizational identifier that the account belongs to
 * }
 */
var IdTokenEntity = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(IdTokenEntity, _super);
    function IdTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create IdTokenEntity
     * @param homeAccountId
     * @param authenticationResult
     * @param clientId
     * @param authority
     */
    IdTokenEntity.createIdTokenEntity = function (homeAccountId, environment, idToken, clientId, tenantId) {
        var idTokenEntity = new IdTokenEntity();
        idTokenEntity.credentialType = __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["n" /* CredentialType */].ID_TOKEN;
        idTokenEntity.homeAccountId = homeAccountId;
        idTokenEntity.environment = environment;
        idTokenEntity.clientId = clientId;
        idTokenEntity.secret = idToken;
        idTokenEntity.realm = tenantId;
        return idTokenEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    IdTokenEntity.isIdTokenEntity = function (entity) {
        if (!entity) {
            return false;
        }
        return (entity.hasOwnProperty("homeAccountId") &&
            entity.hasOwnProperty("environment") &&
            entity.hasOwnProperty("credentialType") &&
            entity.hasOwnProperty("realm") &&
            entity.hasOwnProperty("clientId") &&
            entity.hasOwnProperty("secret") &&
            entity["credentialType"] === __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["n" /* CredentialType */].ID_TOKEN);
    };
    return IdTokenEntity;
}(__WEBPACK_IMPORTED_MODULE_1__CredentialEntity_js__["a" /* CredentialEntity */]));


//# sourceMappingURL=IdTokenEntity.js.map


/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessTokenEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CredentialEntity_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_TimeUtils_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_AuthToken_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_ClientAuthError_js__ = __webpack_require__(57);
/*! @azure/msal-common v13.3.1 2023-10-27 */









/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * ACCESS_TOKEN Credential Type
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-accesstoken-clientId-contoso.com-user.read
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, usually only used for refresh tokens
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 *      cachedAt: Absolute device time when entry was created in the cache.
 *      expiresOn: Token expiry time, calculated based on current UTC time in seconds. Represented as a string.
 *      extendedExpiresOn: Additional extended expiry time until when token is valid in case of server-side outage. Represented as string in UTC seconds.
 *      keyId: used for POP and SSH tokenTypes
 *      tokenType: Type of the token issued. Usually "Bearer"
 * }
 */
var AccessTokenEntity = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(AccessTokenEntity, _super);
    function AccessTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create AccessTokenEntity
     * @param homeAccountId
     * @param environment
     * @param accessToken
     * @param clientId
     * @param tenantId
     * @param scopes
     * @param expiresOn
     * @param extExpiresOn
     */
    AccessTokenEntity.createAccessTokenEntity = function (homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, cryptoUtils, refreshOn, tokenType, userAssertionHash, keyId, requestedClaims, requestedClaimsHash) {
        var _a, _b;
        var atEntity = new AccessTokenEntity();
        atEntity.homeAccountId = homeAccountId;
        atEntity.credentialType = __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN;
        atEntity.secret = accessToken;
        var currentTime = __WEBPACK_IMPORTED_MODULE_3__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds();
        atEntity.cachedAt = currentTime.toString();
        /*
         * Token expiry time.
         * This value should be  calculated based on the current UTC time measured locally and the value  expires_in Represented as a string in JSON.
         */
        atEntity.expiresOn = expiresOn.toString();
        atEntity.extendedExpiresOn = extExpiresOn.toString();
        if (refreshOn) {
            atEntity.refreshOn = refreshOn.toString();
        }
        atEntity.environment = environment;
        atEntity.clientId = clientId;
        atEntity.realm = tenantId;
        atEntity.target = scopes;
        atEntity.userAssertionHash = userAssertionHash;
        atEntity.tokenType = __WEBPACK_IMPORTED_MODULE_4__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(tokenType) ? __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["e" /* AuthenticationScheme */].BEARER : tokenType;
        if (requestedClaims) {
            atEntity.requestedClaims = requestedClaims;
            atEntity.requestedClaimsHash = requestedClaimsHash;
        }
        /*
         * Create Access Token With Auth Scheme instead of regular access token
         * Cast to lower to handle "bearer" from ADFS
         */
        if (((_a = atEntity.tokenType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["e" /* AuthenticationScheme */].BEARER.toLowerCase()) {
            atEntity.credentialType = __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN_WITH_AUTH_SCHEME;
            switch (atEntity.tokenType) {
                case __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["e" /* AuthenticationScheme */].POP:
                    // Make sure keyId is present and add it to credential
                    var tokenClaims = __WEBPACK_IMPORTED_MODULE_5__account_AuthToken_js__["a" /* AuthToken */].extractTokenClaims(accessToken, cryptoUtils);
                    if (!((_b = tokenClaims === null || tokenClaims === void 0 ? void 0 : tokenClaims.cnf) === null || _b === void 0 ? void 0 : _b.kid)) {
                        throw __WEBPACK_IMPORTED_MODULE_6__error_ClientAuthError_js__["a" /* ClientAuthError */].createTokenClaimsRequiredError();
                    }
                    atEntity.keyId = tokenClaims.cnf.kid;
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["e" /* AuthenticationScheme */].SSH:
                    atEntity.keyId = keyId;
            }
        }
        return atEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    AccessTokenEntity.isAccessTokenEntity = function (entity) {
        if (!entity) {
            return false;
        }
        return (entity.hasOwnProperty("homeAccountId") &&
            entity.hasOwnProperty("environment") &&
            entity.hasOwnProperty("credentialType") &&
            entity.hasOwnProperty("realm") &&
            entity.hasOwnProperty("clientId") &&
            entity.hasOwnProperty("secret") &&
            entity.hasOwnProperty("target") &&
            (entity["credentialType"] === __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN || entity["credentialType"] === __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN_WITH_AUTH_SCHEME));
    };
    return AccessTokenEntity;
}(__WEBPACK_IMPORTED_MODULE_1__CredentialEntity_js__["a" /* CredentialEntity */]));


//# sourceMappingURL=AccessTokenEntity.js.map


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RefreshTokenEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CredentialEntity_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * REFRESH_TOKEN Cache
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-refreshtoken-clientId--
 *
 * Value:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, '1' represents Microsoft Family
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 * }
 */
var RefreshTokenEntity = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(RefreshTokenEntity, _super);
    function RefreshTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create RefreshTokenEntity
     * @param homeAccountId
     * @param authenticationResult
     * @param clientId
     * @param authority
     */
    RefreshTokenEntity.createRefreshTokenEntity = function (homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash) {
        var rtEntity = new RefreshTokenEntity();
        rtEntity.clientId = clientId;
        rtEntity.credentialType = __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["n" /* CredentialType */].REFRESH_TOKEN;
        rtEntity.environment = environment;
        rtEntity.homeAccountId = homeAccountId;
        rtEntity.secret = refreshToken;
        rtEntity.userAssertionHash = userAssertionHash;
        if (familyId)
            rtEntity.familyId = familyId;
        return rtEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    RefreshTokenEntity.isRefreshTokenEntity = function (entity) {
        if (!entity) {
            return false;
        }
        return (entity.hasOwnProperty("homeAccountId") &&
            entity.hasOwnProperty("environment") &&
            entity.hasOwnProperty("credentialType") &&
            entity.hasOwnProperty("clientId") &&
            entity.hasOwnProperty("secret") &&
            entity["credentialType"] === __WEBPACK_IMPORTED_MODULE_2__utils_Constants_js__["n" /* CredentialType */].REFRESH_TOKEN);
    };
    return RefreshTokenEntity;
}(__WEBPACK_IMPORTED_MODULE_1__CredentialEntity_js__["a" /* CredentialEntity */]));


//# sourceMappingURL=RefreshTokenEntity.js.map


/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheRecord; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var CacheRecord = /** @class */ (function () {
    function CacheRecord(accountEntity, idTokenEntity, accessTokenEntity, refreshTokenEntity, appMetadataEntity) {
        this.account = accountEntity || null;
        this.idToken = idTokenEntity || null;
        this.accessToken = accessTokenEntity || null;
        this.refreshToken = refreshTokenEntity || null;
        this.appMetadata = appMetadataEntity || null;
    }
    return CacheRecord;
}());


//# sourceMappingURL=CacheRecord.js.map


/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProtocolUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__ = __webpack_require__(57);
/*! @azure/msal-common v13.3.1 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Class which provides helpers for OAuth 2.0 protocol specific values
 */
var ProtocolUtils = /** @class */ (function () {
    function ProtocolUtils() {
    }
    /**
     * Appends user state with random guid, or returns random guid.
     * @param userState
     * @param randomGuid
     */
    ProtocolUtils.setRequestState = function (cryptoObj, userState, meta) {
        var libraryState = ProtocolUtils.generateLibraryState(cryptoObj, meta);
        return !__WEBPACK_IMPORTED_MODULE_0__StringUtils_js__["a" /* StringUtils */].isEmpty(userState) ? "" + libraryState + __WEBPACK_IMPORTED_MODULE_1__Constants_js__["m" /* Constants */].RESOURCE_DELIM + userState : libraryState;
    };
    /**
     * Generates the state value used by the common library.
     * @param randomGuid
     * @param cryptoObj
     */
    ProtocolUtils.generateLibraryState = function (cryptoObj, meta) {
        if (!cryptoObj) {
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createNoCryptoObjectError("generateLibraryState");
        }
        // Create a state object containing a unique id and the timestamp of the request creation
        var stateObj = {
            id: cryptoObj.createNewGuid()
        };
        if (meta) {
            stateObj.meta = meta;
        }
        var stateString = JSON.stringify(stateObj);
        return cryptoObj.base64Encode(stateString);
    };
    /**
     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
     * @param state
     * @param cryptoObj
     */
    ProtocolUtils.parseRequestState = function (cryptoObj, state) {
        if (!cryptoObj) {
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createNoCryptoObjectError("parseRequestState");
        }
        if (__WEBPACK_IMPORTED_MODULE_0__StringUtils_js__["a" /* StringUtils */].isEmpty(state)) {
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createInvalidStateError(state, "Null, undefined or empty state");
        }
        try {
            // Split the state between library state and user passed state and decode them separately
            var splitState = state.split(__WEBPACK_IMPORTED_MODULE_1__Constants_js__["m" /* Constants */].RESOURCE_DELIM);
            var libraryState = splitState[0];
            var userState = splitState.length > 1 ? splitState.slice(1).join(__WEBPACK_IMPORTED_MODULE_1__Constants_js__["m" /* Constants */].RESOURCE_DELIM) : __WEBPACK_IMPORTED_MODULE_1__Constants_js__["m" /* Constants */].EMPTY_STRING;
            var libraryStateString = cryptoObj.base64Decode(libraryState);
            var libraryStateObj = JSON.parse(libraryStateString);
            return {
                userRequestState: !__WEBPACK_IMPORTED_MODULE_0__StringUtils_js__["a" /* StringUtils */].isEmpty(userState) ? userState : __WEBPACK_IMPORTED_MODULE_1__Constants_js__["m" /* Constants */].EMPTY_STRING,
                libraryState: libraryStateObj
            };
        }
        catch (e) {
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createInvalidStateError(state, e);
        }
    };
    return ProtocolUtils;
}());


//# sourceMappingURL=ProtocolUtils.js.map


/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppMetadataEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * APP_METADATA Cache
 *
 * Key:Value Schema:
 *
 * Key: appmetadata-<environment>-<client_id>
 *
 * Value:
 * {
 *      clientId: client ID of the application
 *      environment: entity that issued the token, represented as a full host
 *      familyId: Family ID identifier, '1' represents Microsoft Family
 * }
 */
var AppMetadataEntity = /** @class */ (function () {
    function AppMetadataEntity() {
    }
    /**
     * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
     */
    AppMetadataEntity.prototype.generateAppMetadataKey = function () {
        return AppMetadataEntity.generateAppMetadataCacheKey(this.environment, this.clientId);
    };
    /**
     * Generate AppMetadata Cache Key
     */
    AppMetadataEntity.generateAppMetadataCacheKey = function (environment, clientId) {
        var appMetaDataKeyArray = [
            __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["c" /* APP_METADATA */],
            environment,
            clientId,
        ];
        return appMetaDataKeyArray.join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Creates AppMetadataEntity
     * @param clientId
     * @param environment
     * @param familyId
     */
    AppMetadataEntity.createAppMetadataEntity = function (clientId, environment, familyId) {
        var appMetadata = new AppMetadataEntity();
        appMetadata.clientId = clientId;
        appMetadata.environment = environment;
        if (familyId) {
            appMetadata.familyId = familyId;
        }
        return appMetadata;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    AppMetadataEntity.isAppMetadataEntity = function (key, entity) {
        if (!entity) {
            return false;
        }
        return (key.indexOf(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["c" /* APP_METADATA */]) === 0 &&
            entity.hasOwnProperty("clientId") &&
            entity.hasOwnProperty("environment"));
    };
    return AppMetadataEntity;
}());


//# sourceMappingURL=AppMetadataEntity.js.map


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenCacheContext; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ var TokenCacheContext = /** @class */ (function () {
    function TokenCacheContext(tokenCache, hasChanged) {
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    Object.defineProperty(TokenCacheContext.prototype, "cacheHasChanged", {
        /**
         * boolean which indicates the changes in cache
         */
        get: function () {
            return this.hasChanged;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenCacheContext.prototype, "tokenCache", {
        /**
         * function to retrieve the token cache
         */
        get: function () {
            return this.cache;
        },
        enumerable: false,
        configurable: true
    });
    return TokenCacheContext;
}());


//# sourceMappingURL=TokenCacheContext.js.map


/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RefreshTokenClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseClient_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request_RequestParameterBuilder_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__response_ResponseHandler_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crypto_PopTokenGenerator_js__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__error_ServerError_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_TimeUtils_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__url_UrlString_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__account_CcsCredential_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__account_ClientInfo_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__error_InteractionRequiredAuthError_js__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__ = __webpack_require__(153);
/*! @azure/msal-common v13.3.1 2023-10-27 */


















/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * OAuth2.0 refresh token client
 */
var RefreshTokenClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(RefreshTokenClient, _super);
    function RefreshTokenClient(configuration, performanceClient) {
        return _super.call(this, configuration, performanceClient) || this;
    }
    RefreshTokenClient.prototype.acquireToken = function (request) {
        var _a, _b, _c, _d, _e, _f, _g;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var atsMeasurement, reqTimestamp, response, httpVerToken, requestId, responseHandler;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientAcquireToken, request.correlationId);
                        atsMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientAcquireToken, request.correlationId);
                        this.logger.verbose("RefreshTokenClientAcquireToken called", request.correlationId);
                        reqTimestamp = __WEBPACK_IMPORTED_MODULE_10__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds();
                        (_c = this.performanceClient) === null || _c === void 0 ? void 0 : _c.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientExecuteTokenRequest, request.correlationId);
                        return [4 /*yield*/, this.executeTokenRequest(request, this.authority)];
                    case 1:
                        response = _h.sent();
                        httpVerToken = (_d = response.headers) === null || _d === void 0 ? void 0 : _d[__WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["q" /* HeaderNames */].X_MS_HTTP_VERSION];
                        atsMeasurement === null || atsMeasurement === void 0 ? void 0 : atsMeasurement.addStaticFields({
                            refreshTokenSize: ((_e = response.body.refresh_token) === null || _e === void 0 ? void 0 : _e.length) || 0,
                        });
                        if (httpVerToken) {
                            atsMeasurement === null || atsMeasurement === void 0 ? void 0 : atsMeasurement.addStaticFields({
                                httpVerToken: httpVerToken,
                            });
                        }
                        requestId = (_f = response.headers) === null || _f === void 0 ? void 0 : _f[__WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["q" /* HeaderNames */].X_MS_REQUEST_ID];
                        responseHandler = new __WEBPACK_IMPORTED_MODULE_4__response_ResponseHandler_js__["a" /* ResponseHandler */](this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
                        responseHandler.validateTokenResponse(response.body);
                        (_g = this.performanceClient) === null || _g === void 0 ? void 0 : _g.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].HandleServerTokenResponse, request.correlationId);
                        return [2 /*return*/, responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request, undefined, undefined, true, request.forceCache, requestId).then(function (result) {
                                atsMeasurement === null || atsMeasurement === void 0 ? void 0 : atsMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            })
                                .catch(function (error) {
                                _this.logger.verbose("Error in fetching refresh token", request.correlationId);
                                atsMeasurement === null || atsMeasurement === void 0 ? void 0 : atsMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            })];
                }
            });
        });
    };
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */
    RefreshTokenClient.prototype.acquireTokenByRefreshToken = function (request) {
        var _a, _b, _c, _d;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var isFOCI, noFamilyRTInCache, clientMismatchErrorWithFamilyRT;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_e) {
                // Cannot renew token if no request object is given.
                if (!request) {
                    throw __WEBPACK_IMPORTED_MODULE_7__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createEmptyTokenRequestError();
                }
                (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
                // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
                if (!request.account) {
                    throw __WEBPACK_IMPORTED_MODULE_8__error_ClientAuthError_js__["a" /* ClientAuthError */].createNoAccountInSilentRequestError();
                }
                isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment);
                // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
                if (isFOCI) {
                    try {
                        (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                        return [2 /*return*/, this.acquireTokenWithCachedRefreshToken(request, true)];
                    }
                    catch (e) {
                        noFamilyRTInCache = e instanceof __WEBPACK_IMPORTED_MODULE_14__error_InteractionRequiredAuthError_js__["a" /* InteractionRequiredAuthError */] && e.errorCode === __WEBPACK_IMPORTED_MODULE_14__error_InteractionRequiredAuthError_js__["b" /* InteractionRequiredAuthErrorMessage */].noTokensFoundError.code;
                        clientMismatchErrorWithFamilyRT = e instanceof __WEBPACK_IMPORTED_MODULE_9__error_ServerError_js__["a" /* ServerError */] && e.errorCode === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["o" /* Errors */].INVALID_GRANT_ERROR && e.subError === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["o" /* Errors */].CLIENT_MISMATCH_ERROR;
                        // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
                        if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) {
                            (_c = this.performanceClient) === null || _c === void 0 ? void 0 : _c.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                            return [2 /*return*/, this.acquireTokenWithCachedRefreshToken(request, false)];
                            // throw in all other cases
                        }
                        else {
                            throw e;
                        }
                    }
                }
                // fall back to application refresh token acquisition
                (_d = this.performanceClient) === null || _d === void 0 ? void 0 : _d.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                return [2 /*return*/, this.acquireTokenWithCachedRefreshToken(request, false)];
            });
        });
    };
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */
    RefreshTokenClient.prototype.acquireTokenWithCachedRefreshToken = function (request, foci) {
        var _a, _b, _c;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var atsMeasurement, refreshToken, refreshTokenRequest;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_d) {
                (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                atsMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                this.logger.verbose("RefreshTokenClientAcquireTokenWithCachedRefreshToken called", request.correlationId);
                refreshToken = this.cacheManager.getRefreshToken(request.account, foci);
                if (!refreshToken) {
                    atsMeasurement === null || atsMeasurement === void 0 ? void 0 : atsMeasurement.discardMeasurement();
                    throw __WEBPACK_IMPORTED_MODULE_14__error_InteractionRequiredAuthError_js__["a" /* InteractionRequiredAuthError */].createNoTokensFoundError();
                }
                // attach cached RT size to the current measurement
                atsMeasurement === null || atsMeasurement === void 0 ? void 0 : atsMeasurement.endMeasurement({
                    success: true
                });
                refreshTokenRequest = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request), { refreshToken: refreshToken.secret, authenticationScheme: request.authenticationScheme || __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["e" /* AuthenticationScheme */].BEARER, ccsCredential: {
                        credential: request.account.homeAccountId,
                        type: __WEBPACK_IMPORTED_MODULE_12__account_CcsCredential_js__["a" /* CcsCredentialType */].HOME_ACCOUNT_ID
                    } });
                (_c = this.performanceClient) === null || _c === void 0 ? void 0 : _c.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientAcquireToken, request.correlationId);
                return [2 /*return*/, this.acquireToken(refreshTokenRequest)];
            });
        });
    };
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */
    RefreshTokenClient.prototype.executeTokenRequest = function (request, authority) {
        var _a, _b, _c;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var acquireTokenMeasurement, queryParametersString, endpoint, requestBody, headers, thumbprint;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientExecuteTokenRequest, request.correlationId);
                        acquireTokenMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientExecuteTokenRequest, request.correlationId);
                        (_c = this.performanceClient) === null || _c === void 0 ? void 0 : _c.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientCreateTokenRequestBody, request.correlationId);
                        queryParametersString = this.createTokenQueryParameters(request);
                        endpoint = __WEBPACK_IMPORTED_MODULE_11__url_UrlString_js__["a" /* UrlString */].appendQueryString(authority.tokenEndpoint, queryParametersString);
                        return [4 /*yield*/, this.createTokenRequestBody(request)];
                    case 1:
                        requestBody = _d.sent();
                        headers = this.createTokenRequestHeaders(request.ccsCredential);
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: authority.canonicalAuthority,
                            scopes: request.scopes,
                            claims: request.claims,
                            authenticationScheme: request.authenticationScheme,
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            sshKid: request.sshKid
                        };
                        return [2 /*return*/, this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint)
                                .then(function (result) {
                                acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 ? void 0 : acquireTokenMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            })
                                .catch(function (error) {
                                acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 ? void 0 : acquireTokenMeasurement.endMeasurement({
                                    success: false
                                });
                                throw error;
                            })];
                }
            });
        });
    };
    /**
     * Helper function to create the token request body
     * @param request
     */
    RefreshTokenClient.prototype.createTokenRequestBody = function (request) {
        var _a, _b, _c;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var correlationId, acquireTokenMeasurement, parameterBuilder, clientAssertion, popTokenGenerator, reqCnfData, clientInfo;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RefreshTokenClientCreateTokenRequestBody, request.correlationId);
                        correlationId = request.correlationId;
                        acquireTokenMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].BaseClientCreateTokenRequestHeaders, correlationId);
                        parameterBuilder = new __WEBPACK_IMPORTED_MODULE_2__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        parameterBuilder.addScopes(request.scopes);
                        parameterBuilder.addGrantType(__WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["p" /* GrantType */].REFRESH_TOKEN_GRANT);
                        parameterBuilder.addClientInfo();
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
                        parameterBuilder.addThrottling();
                        if (this.serverTelemetryManager) {
                            parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
                        }
                        parameterBuilder.addCorrelationId(correlationId);
                        parameterBuilder.addRefreshToken(request.refreshToken);
                        if (this.config.clientCredentials.clientSecret) {
                            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
                        }
                        if (this.config.clientCredentials.clientAssertion) {
                            clientAssertion = this.config.clientCredentials.clientAssertion;
                            parameterBuilder.addClientAssertion(clientAssertion.assertion);
                            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
                        }
                        if (!(request.authenticationScheme === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["e" /* AuthenticationScheme */].POP)) return [3 /*break*/, 2];
                        popTokenGenerator = new __WEBPACK_IMPORTED_MODULE_5__crypto_PopTokenGenerator_js__["a" /* PopTokenGenerator */](this.cryptoUtils, this.performanceClient);
                        (_c = this.performanceClient) === null || _c === void 0 ? void 0 : _c.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].PopTokenGenerateCnf, request.correlationId);
                        return [4 /*yield*/, popTokenGenerator.generateCnf(request)];
                    case 1:
                        reqCnfData = _d.sent();
                        // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
                        parameterBuilder.addPopToken(reqCnfData.reqCnfString);
                        return [3 /*break*/, 3];
                    case 2:
                        if (request.authenticationScheme === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["e" /* AuthenticationScheme */].SSH) {
                            if (request.sshJwk) {
                                parameterBuilder.addSshJwk(request.sshJwk);
                            }
                            else {
                                acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 ? void 0 : acquireTokenMeasurement.endMeasurement({
                                    success: false
                                });
                                throw __WEBPACK_IMPORTED_MODULE_7__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createMissingSshJwkError();
                            }
                        }
                        _d.label = 3;
                    case 3:
                        if (!__WEBPACK_IMPORTED_MODULE_6__utils_StringUtils_js__["a" /* StringUtils */].isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
                            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        }
                        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) {
                            switch (request.ccsCredential.type) {
                                case __WEBPACK_IMPORTED_MODULE_12__account_CcsCredential_js__["a" /* CcsCredentialType */].HOME_ACCOUNT_ID:
                                    try {
                                        clientInfo = Object(__WEBPACK_IMPORTED_MODULE_13__account_ClientInfo_js__["b" /* buildClientInfoFromHomeAccountId */])(request.ccsCredential.credential);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    }
                                    catch (e) {
                                        this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                                    }
                                    break;
                                case __WEBPACK_IMPORTED_MODULE_12__account_CcsCredential_js__["a" /* CcsCredentialType */].UPN:
                                    parameterBuilder.addCcsUpn(request.ccsCredential.credential);
                                    break;
                            }
                        }
                        acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 ? void 0 : acquireTokenMeasurement.endMeasurement({
                            success: true
                        });
                        return [2 /*return*/, parameterBuilder.createQueryString()];
                }
            });
        });
    };
    return RefreshTokenClient;
}(__WEBPACK_IMPORTED_MODULE_1__BaseClient_js__["a" /* BaseClient */]));


//# sourceMappingURL=RefreshTokenClient.js.map


/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Authority; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthorityType_js__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OpenIdConfigResponse_js__ = __webpack_require__(2731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__url_UrlString_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthorityMetadata_js__ = __webpack_require__(2732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProtocolMode_js__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cache_entities_AuthorityMetadataEntity_js__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AuthorityOptions_js__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CloudInstanceDiscoveryResponse_js__ = __webpack_require__(2733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CloudInstanceDiscoveryErrorResponse_js__ = __webpack_require__(2734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RegionDiscovery_js__ = __webpack_require__(2735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__error_AuthError_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__ = __webpack_require__(153);
/*! @azure/msal-common v13.3.1 2023-10-27 */


















/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 */
var Authority = /** @class */ (function () {
    function Authority(authority, networkInterface, cacheManager, authorityOptions, logger, performanceClient, correlationId) {
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = { region_used: undefined, region_source: undefined, region_outcome: undefined };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.regionDiscovery = new __WEBPACK_IMPORTED_MODULE_13__RegionDiscovery_js__["a" /* RegionDiscovery */](networkInterface, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType}
     * @param authorityUri {@link IUri}
     * @private
     */
    Authority.prototype.getAuthorityType = function (authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith(__WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].CIAM_AUTH_URL)) {
            return __WEBPACK_IMPORTED_MODULE_1__AuthorityType_js__["a" /* AuthorityType */].Ciam;
        }
        var pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) {
            switch (pathSegments[0].toLowerCase()) {
                case __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].ADFS:
                    return __WEBPACK_IMPORTED_MODULE_1__AuthorityType_js__["a" /* AuthorityType */].Adfs;
                case __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].DSTS:
                    return __WEBPACK_IMPORTED_MODULE_1__AuthorityType_js__["a" /* AuthorityType */].Dsts;
            }
        }
        return __WEBPACK_IMPORTED_MODULE_1__AuthorityType_js__["a" /* AuthorityType */].Default;
    };
    Object.defineProperty(Authority.prototype, "authorityType", {
        // See above for AuthorityType
        get: function () {
            return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "protocolMode", {
        /**
         * ProtocolMode enum representing the way endpoints are constructed.
         */
        get: function () {
            return this.authorityOptions.protocolMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "options", {
        /**
         * Returns authorityOptions which can be used to reinstantiate a new authority instance
         */
        get: function () {
            return this.authorityOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "canonicalAuthority", {
        /**
         * A URL that is the authority set by the developer
         */
        get: function () {
            return this._canonicalAuthority.urlString;
        },
        /**
         * Sets canonical authority.
         */
        set: function (url) {
            this._canonicalAuthority = new __WEBPACK_IMPORTED_MODULE_3__url_UrlString_js__["a" /* UrlString */](url);
            this._canonicalAuthority.validateAsUri();
            this._canonicalAuthorityUrlComponents = null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "canonicalAuthorityUrlComponents", {
        /**
         * Get authority components.
         */
        get: function () {
            if (!this._canonicalAuthorityUrlComponents) {
                this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
            }
            return this._canonicalAuthorityUrlComponents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "hostnameAndPort", {
        /**
         * Get hostname and port i.e. login.microsoftonline.com
         */
        get: function () {
            return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "tenant", {
        /**
         * Get tenant for authority.
         */
        get: function () {
            return this.canonicalAuthorityUrlComponents.PathSegments[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "authorizationEndpoint", {
        /**
         * OAuth /authorize endpoint for requests
         */
        get: function () {
            if (this.discoveryComplete()) {
                return this.replacePath(this.metadata.authorization_endpoint);
            }
            else {
                throw __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__["a" /* ClientAuthError */].createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "tokenEndpoint", {
        /**
         * OAuth /token endpoint for requests
         */
        get: function () {
            if (this.discoveryComplete()) {
                return this.replacePath(this.metadata.token_endpoint);
            }
            else {
                throw __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__["a" /* ClientAuthError */].createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "deviceCodeEndpoint", {
        get: function () {
            if (this.discoveryComplete()) {
                return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
            }
            else {
                throw __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__["a" /* ClientAuthError */].createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "endSessionEndpoint", {
        /**
         * OAuth logout endpoint for requests
         */
        get: function () {
            if (this.discoveryComplete()) {
                // ROPC policies may not have end_session_endpoint set
                if (!this.metadata.end_session_endpoint) {
                    throw __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__["a" /* ClientAuthError */].createLogoutNotSupportedError();
                }
                return this.replacePath(this.metadata.end_session_endpoint);
            }
            else {
                throw __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__["a" /* ClientAuthError */].createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "selfSignedJwtAudience", {
        /**
         * OAuth issuer for requests
         */
        get: function () {
            if (this.discoveryComplete()) {
                return this.replacePath(this.metadata.issuer);
            }
            else {
                throw __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__["a" /* ClientAuthError */].createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "jwksUri", {
        /**
         * Jwks_uri for token signing keys
         */
        get: function () {
            if (this.discoveryComplete()) {
                return this.replacePath(this.metadata.jwks_uri);
            }
            else {
                throw __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__["a" /* ClientAuthError */].createEndpointDiscoveryIncompleteError("Discovery incomplete.");
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */
    Authority.prototype.canReplaceTenant = function (authorityUri) {
        return authorityUri.PathSegments.length === 1
            && !Authority.reservedTenantDomains.has(authorityUri.PathSegments[0])
            && this.getAuthorityType(authorityUri) === __WEBPACK_IMPORTED_MODULE_1__AuthorityType_js__["a" /* AuthorityType */].Default
            && this.protocolMode === __WEBPACK_IMPORTED_MODULE_8__ProtocolMode_js__["a" /* ProtocolMode */].AAD;
    };
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */
    Authority.prototype.replaceTenant = function (urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    };
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */
    Authority.prototype.replacePath = function (urlString) {
        var _this = this;
        var endpoint = urlString;
        var cachedAuthorityUrl = new __WEBPACK_IMPORTED_MODULE_3__url_UrlString_js__["a" /* UrlString */](this.metadata.canonical_authority);
        var cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        var cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        var currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach(function (currentPart, index) {
            var cachedPart = cachedAuthorityParts[index];
            if (index === 0 && _this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                var tenantId = (new __WEBPACK_IMPORTED_MODULE_3__url_UrlString_js__["a" /* UrlString */](_this.metadata.authorization_endpoint)).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */
                if (cachedPart !== tenantId) {
                    _this.logger.verbose("Replacing tenant domain name " + cachedPart + " with id " + tenantId);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) {
                endpoint = endpoint.replace("/" + cachedPart + "/", "/" + currentPart + "/");
            }
        });
        return this.replaceTenant(endpoint);
    };
    Object.defineProperty(Authority.prototype, "defaultOpenIdConfigurationEndpoint", {
        /**
         * The default open id configuration endpoint for any canonical authority.
         */
        get: function () {
            if (this.authorityType === __WEBPACK_IMPORTED_MODULE_1__AuthorityType_js__["a" /* AuthorityType */].Adfs ||
                this.authorityType === __WEBPACK_IMPORTED_MODULE_1__AuthorityType_js__["a" /* AuthorityType */].Dsts ||
                this.protocolMode === __WEBPACK_IMPORTED_MODULE_8__ProtocolMode_js__["a" /* ProtocolMode */].OIDC) {
                return this.canonicalAuthority + ".well-known/openid-configuration";
            }
            return this.canonicalAuthority + "v2.0/.well-known/openid-configuration";
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Boolean that returns whethr or not tenant discovery has been completed.
     */
    Authority.prototype.discoveryComplete = function () {
        return !!this.metadata;
    };
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */
    Authority.prototype.resolveEndpointsAsync = function () {
        var _a, _b, _c;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var metadataEntity, cloudDiscoverySource, endpointSource, cacheKey;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityResolveEndpointsAsync, this.correlationId);
                        metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
                        if (!metadataEntity) {
                            metadataEntity = new __WEBPACK_IMPORTED_MODULE_9__cache_entities_AuthorityMetadataEntity_js__["a" /* AuthorityMetadataEntity */]();
                            metadataEntity.updateCanonicalAuthority(this.canonicalAuthority);
                        }
                        (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
                        return [4 /*yield*/, this.updateCloudDiscoveryMetadata(metadataEntity)];
                    case 1:
                        cloudDiscoverySource = _d.sent();
                        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
                        (_c = this.performanceClient) === null || _c === void 0 ? void 0 : _c.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityUpdateEndpointMetadata, this.correlationId);
                        return [4 /*yield*/, this.updateEndpointMetadata(metadataEntity)];
                    case 2:
                        endpointSource = _d.sent();
                        if (cloudDiscoverySource !== __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["f" /* AuthorityMetadataSource */].CACHE && endpointSource !== __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["f" /* AuthorityMetadataSource */].CACHE) {
                            // Reset the expiration time unless both values came from a successful cache lookup
                            metadataEntity.resetExpiresAt();
                            metadataEntity.updateCanonicalAuthority(this.canonicalAuthority);
                        }
                        cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
                        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
                        this.metadata = metadataEntity;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */
    Authority.prototype.updateEndpointMetadata = function (metadataEntity) {
        var _a, _b, _c, _d, _e, _f;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var metadata, harcodedMetadata;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityUpdateEndpointMetadata, this.correlationId);
                        metadata = this.getEndpointMetadataFromConfig();
                        if (metadata) {
                            metadataEntity.updateEndpointMetadata(metadata, false);
                            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["f" /* AuthorityMetadataSource */].CONFIG];
                        }
                        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntity.isExpired()) {
                            // No need to update
                            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["f" /* AuthorityMetadataSource */].CACHE];
                        }
                        (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
                        return [4 /*yield*/, this.getEndpointMetadataFromNetwork()];
                    case 1:
                        metadata = _g.sent();
                        if (!metadata) return [3 /*break*/, 4];
                        if (!((_c = this.authorityOptions.azureRegionConfiguration) === null || _c === void 0 ? void 0 : _c.azureRegion)) return [3 /*break*/, 3];
                        (_d = this.performanceClient) === null || _d === void 0 ? void 0 : _d.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
                        return [4 /*yield*/, this.updateMetadataWithRegionalInformation(metadata)];
                    case 2:
                        metadata = _g.sent();
                        _g.label = 3;
                    case 3:
                        metadataEntity.updateEndpointMetadata(metadata, true);
                        return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["f" /* AuthorityMetadataSource */].NETWORK];
                    case 4:
                        harcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
                        if (!(harcodedMetadata && !this.authorityOptions.skipAuthorityMetadataCache)) return [3 /*break*/, 7];
                        if (!((_e = this.authorityOptions.azureRegionConfiguration) === null || _e === void 0 ? void 0 : _e.azureRegion)) return [3 /*break*/, 6];
                        (_f = this.performanceClient) === null || _f === void 0 ? void 0 : _f.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
                        return [4 /*yield*/, this.updateMetadataWithRegionalInformation(harcodedMetadata)];
                    case 5:
                        harcodedMetadata = _g.sent();
                        _g.label = 6;
                    case 6:
                        metadataEntity.updateEndpointMetadata(harcodedMetadata, false);
                        return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["f" /* AuthorityMetadataSource */].HARDCODED_VALUES];
                    case 7: throw __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__["a" /* ClientAuthError */].createUnableToGetOpenidConfigError(this.defaultOpenIdConfigurationEndpoint);
                }
            });
        });
    };
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */
    Authority.prototype.isAuthoritySameType = function (metadataEntity) {
        var cachedAuthorityUrl = new __WEBPACK_IMPORTED_MODULE_3__url_UrlString_js__["a" /* UrlString */](metadataEntity.canonical_authority);
        var cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    };
    /**
     * Parse authorityMetadata config option
     */
    Authority.prototype.getEndpointMetadataFromConfig = function () {
        if (this.authorityOptions.authorityMetadata) {
            try {
                return JSON.parse(this.authorityOptions.authorityMetadata);
            }
            catch (e) {
                throw __WEBPACK_IMPORTED_MODULE_7__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInvalidAuthorityMetadataError();
            }
        }
        return null;
    };
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */
    Authority.prototype.getEndpointMetadataFromNetwork = function () {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var options, response;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
                        options = {};
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.networkInterface.
                                sendGetRequestAsync(this.defaultOpenIdConfigurationEndpoint, options)];
                    case 2:
                        response = _b.sent();
                        return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_2__OpenIdConfigResponse_js__["a" /* isOpenIdConfigResponse */])(response.body) ? response.body : null];
                    case 3:
                        _b.sent();
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get OAuth endpoints for common authorities.
     */
    Authority.prototype.getEndpointMetadataFromHardcodedValues = function () {
        if (this.canonicalAuthority in __WEBPACK_IMPORTED_MODULE_6__AuthorityMetadata_js__["a" /* EndpointMetadata */]) {
            return __WEBPACK_IMPORTED_MODULE_6__AuthorityMetadata_js__["a" /* EndpointMetadata */][this.canonicalAuthority];
        }
        return null;
    };
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */
    Authority.prototype.updateMetadataWithRegionalInformation = function (metadata) {
        var _a, _b, _c, _d;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var userConfiguredAzureRegion, autodetectedRegionName;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
                        userConfiguredAzureRegion = (_b = this.authorityOptions.azureRegionConfiguration) === null || _b === void 0 ? void 0 : _b.azureRegion;
                        if (!userConfiguredAzureRegion) return [3 /*break*/, 2];
                        if (userConfiguredAzureRegion !== __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].AZURE_REGION_AUTO_DISCOVER_FLAG) {
                            this.regionDiscoveryMetadata.region_outcome = __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["x" /* RegionDiscoveryOutcomes */].CONFIGURED_NO_AUTO_DETECTION;
                            this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                            return [2 /*return*/, Authority.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion)];
                        }
                        (_c = this.performanceClient) === null || _c === void 0 ? void 0 : _c.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RegionDiscoveryDetectRegion, this.correlationId);
                        return [4 /*yield*/, this.regionDiscovery.detectRegion((_d = this.authorityOptions.azureRegionConfiguration) === null || _d === void 0 ? void 0 : _d.environmentRegion, this.regionDiscoveryMetadata)];
                    case 1:
                        autodetectedRegionName = _e.sent();
                        if (autodetectedRegionName) {
                            this.regionDiscoveryMetadata.region_outcome = __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["x" /* RegionDiscoveryOutcomes */].AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                            this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                            return [2 /*return*/, Authority.replaceWithRegionalInformation(metadata, autodetectedRegionName)];
                        }
                        this.regionDiscoveryMetadata.region_outcome = __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["x" /* RegionDiscoveryOutcomes */].AUTO_DETECTION_REQUESTED_FAILED;
                        _e.label = 2;
                    case 2: return [2 /*return*/, metadata];
                }
            });
        });
    };
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */
    Authority.prototype.updateCloudDiscoveryMetadata = function (metadataEntity) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var metadata, metadataEntityExpired, harcodedMetadata;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
                        // attempt to read metadata from the config
                        this.logger.verbose("Attempting to get cloud discovery metadata in the config");
                        this.logger.verbosePii("Known Authorities: " + (this.authorityOptions.knownAuthorities || __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].NOT_APPLICABLE));
                        this.logger.verbosePii("Authority Metadata: " + (this.authorityOptions.authorityMetadata || __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].NOT_APPLICABLE));
                        this.logger.verbosePii("Canonical Authority: " + (metadataEntity.canonical_authority || __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].NOT_APPLICABLE));
                        metadata = this.getCloudDiscoveryMetadataFromConfig();
                        if (metadata) {
                            this.logger.verbose("Found cloud discovery metadata in the config.");
                            metadataEntity.updateCloudDiscoveryMetadata(metadata, false);
                            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["f" /* AuthorityMetadataSource */].CONFIG];
                        }
                        // If the cached metadata came from config but that config was not passed to this instance, we must go to the network
                        this.logger.verbose("Did not find cloud discovery metadata in the config... Attempting to get cloud discovery metadata from the cache.");
                        metadataEntityExpired = metadataEntity.isExpired();
                        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
                            this.logger.verbose("Found metadata in the cache.");
                            // No need to update
                            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["f" /* AuthorityMetadataSource */].CACHE];
                        }
                        else if (metadataEntityExpired) {
                            this.logger.verbose("The metadata entity is expired.");
                        }
                        this.logger.verbose("Did not find cloud discovery metadata in the cache... Attempting to get cloud discovery metadata from the network.");
                        (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
                        return [4 /*yield*/, this.getCloudDiscoveryMetadataFromNetwork()];
                    case 1:
                        metadata = _c.sent();
                        if (metadata) {
                            this.logger.verbose("cloud discovery metadata was successfully returned from getCloudDiscoveryMetadataFromNetwork()");
                            metadataEntity.updateCloudDiscoveryMetadata(metadata, true);
                            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["f" /* AuthorityMetadataSource */].NETWORK];
                        }
                        this.logger.verbose("Did not find cloud discovery metadata from the network... Attempting to get cloud discovery metadata from hardcoded values.");
                        harcodedMetadata = this.getCloudDiscoveryMetadataFromHarcodedValues();
                        if (harcodedMetadata && !this.options.skipAuthorityMetadataCache) {
                            this.logger.verbose("Found cloud discovery metadata from hardcoded values.");
                            metadataEntity.updateCloudDiscoveryMetadata(harcodedMetadata, false);
                            return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["f" /* AuthorityMetadataSource */].HARDCODED_VALUES];
                        }
                        // Metadata could not be obtained from the config, cache, network or hardcoded values
                        this.logger.error("Did not find cloud discovery metadata from hardcoded values... Metadata could not be obtained from config, cache, network or hardcoded values. Throwing Untrusted Authority Error.");
                        throw __WEBPACK_IMPORTED_MODULE_7__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createUntrustedAuthorityError();
                }
            });
        });
    };
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */
    Authority.prototype.getCloudDiscoveryMetadataFromConfig = function () {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === __WEBPACK_IMPORTED_MODULE_1__AuthorityType_js__["a" /* AuthorityType */].Ciam) {
            this.logger.verbose("CIAM authorities do not support cloud discovery metadata, generate the aliases from authority host.");
            return Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("The cloud discovery metadata has been provided as a network response, in the config.");
            try {
                this.logger.verbose("Attempting to parse the cloud discovery metadata.");
                var parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                var metadata = Authority.getCloudDiscoveryMetadataFromNetworkResponse(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("Parsed the cloud discovery metadata.");
                if (metadata) {
                    this.logger.verbose("There is returnable metadata attached to the parsed cloud discovery metadata.");
                    return metadata;
                }
                else {
                    this.logger.verbose("There is no metadata attached to the parsed cloud discovery metadata.");
                }
            }
            catch (e) {
                this.logger.verbose("Unable to parse the cloud discovery metadata. Throwing Invalid Cloud Discovery Metadata Error.");
                throw __WEBPACK_IMPORTED_MODULE_7__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInvalidCloudDiscoveryMetadataError();
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities()) {
            this.logger.verbose("The host is included in knownAuthorities. Creating new cloud discovery metadata from the host.");
            return Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    };
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */
    Authority.prototype.getCloudDiscoveryMetadataFromNetwork = function () {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var instanceDiscoveryEndpoint, options, match, response, typedResponseBody, metadata, error_1, typedError;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_15__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
                        instanceDiscoveryEndpoint = "" + __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].AAD_INSTANCE_DISCOVERY_ENDPT + this.canonicalAuthority + "oauth2/v2.0/authorize";
                        options = {};
                        match = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options)];
                    case 2:
                        response = _b.sent();
                        typedResponseBody = void 0;
                        metadata = void 0;
                        if (Object(__WEBPACK_IMPORTED_MODULE_11__CloudInstanceDiscoveryResponse_js__["a" /* isCloudInstanceDiscoveryResponse */])(response.body)) {
                            typedResponseBody = response.body;
                            metadata = typedResponseBody.metadata;
                            this.logger.verbosePii("tenant_discovery_endpoint is: " + typedResponseBody.tenant_discovery_endpoint);
                        }
                        else if (Object(__WEBPACK_IMPORTED_MODULE_12__CloudInstanceDiscoveryErrorResponse_js__["a" /* isCloudInstanceDiscoveryErrorResponse */])(response.body)) {
                            this.logger.warning("A CloudInstanceDiscoveryErrorResponse was returned. The cloud instance discovery network request's status code is: " + response.status);
                            typedResponseBody = response.body;
                            if (typedResponseBody.error === __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].INVALID_INSTANCE) {
                                this.logger.error("The CloudInstanceDiscoveryErrorResponse error is invalid_instance.");
                                return [2 /*return*/, null];
                            }
                            this.logger.warning("The CloudInstanceDiscoveryErrorResponse error is " + typedResponseBody.error);
                            this.logger.warning("The CloudInstanceDiscoveryErrorResponse error description is " + typedResponseBody.error_description);
                            this.logger.warning("Setting the value of the CloudInstanceDiscoveryMetadata (returned from the network) to []");
                            metadata = [];
                        }
                        else {
                            this.logger.error("AAD did not return a CloudInstanceDiscoveryResponse or CloudInstanceDiscoveryErrorResponse");
                            return [2 /*return*/, null];
                        }
                        this.logger.verbose("Attempting to find a match between the developer's authority and the CloudInstanceDiscoveryMetadata returned from the network request.");
                        match = Authority.getCloudDiscoveryMetadataFromNetworkResponse(metadata, this.hostnameAndPort);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        if (error_1 instanceof __WEBPACK_IMPORTED_MODULE_14__error_AuthError_js__["a" /* AuthError */]) {
                            this.logger.error("There was a network error while attempting to get the cloud discovery instance metadata.\nError: " + error_1.errorCode + "\nError Description: " + error_1.errorMessage);
                        }
                        else {
                            typedError = error_1;
                            this.logger.error("A non-MSALJS error was thrown while attempting to get the cloud instance discovery metadata.\nError: " + typedError.name + "\nError Description: " + typedError.message);
                        }
                        return [2 /*return*/, null];
                    case 4:
                        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
                        if (!match) {
                            this.logger.warning("The developer's authority was not found within the CloudInstanceDiscoveryMetadata returned from the network request.");
                            this.logger.verbose("Creating custom Authority for custom domain scenario.");
                            match = Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
                        }
                        return [2 /*return*/, match];
                }
            });
        });
    };
    /**
     * Get cloud discovery metadata for common authorities
     */
    Authority.prototype.getCloudDiscoveryMetadataFromHarcodedValues = function () {
        if (this.canonicalAuthority in __WEBPACK_IMPORTED_MODULE_6__AuthorityMetadata_js__["b" /* InstanceDiscoveryMetadata */]) {
            return __WEBPACK_IMPORTED_MODULE_6__AuthorityMetadata_js__["b" /* InstanceDiscoveryMetadata */][this.canonicalAuthority];
        }
        return null;
    };
    /**
     * Helper function to determine if this host is included in the knownAuthorities config option
     */
    Authority.prototype.isInKnownAuthorities = function () {
        var _this = this;
        var matches = this.authorityOptions.knownAuthorities.filter(function (authority) {
            return __WEBPACK_IMPORTED_MODULE_3__url_UrlString_js__["a" /* UrlString */].getDomainFromUrl(authority).toLowerCase() === _this.hostnameAndPort;
        });
        return matches.length > 0;
    };
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */
    Authority.generateAuthority = function (authorityString, azureCloudOptions) {
        var authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== __WEBPACK_IMPORTED_MODULE_10__AuthorityOptions_js__["a" /* AzureCloudInstance */].None) {
            var tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = azureCloudOptions.azureCloudInstance + "/" + tenant + "/";
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    };
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */
    Authority.createCloudDiscoveryMetadataFromHost = function (host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [host]
        };
    };
    /**
     * Searches instance discovery network response for the entry that contains the host in the aliases list
     * @param response
     * @param authority
     */
    Authority.getCloudDiscoveryMetadataFromNetworkResponse = function (response, authority) {
        for (var i = 0; i < response.length; i++) {
            var metadata = response[i];
            if (metadata.aliases.indexOf(authority) > -1) {
                return metadata;
            }
        }
        return null;
    };
    /**
     * helper function to generate environment from authority object
     */
    Authority.prototype.getPreferredCache = function () {
        if (this.discoveryComplete()) {
            return this.metadata.preferred_cache;
        }
        else {
            throw __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__["a" /* ClientAuthError */].createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        }
    };
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */
    Authority.prototype.isAlias = function (host) {
        return this.metadata.aliases.indexOf(host) > -1;
    };
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */
    Authority.isPublicCloudAuthority = function (host) {
        return __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    };
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */
    Authority.buildRegionalAuthorityString = function (host, region, queryString) {
        // Create and validate a Url string object with the initial authority string
        var authorityUrlInstance = new __WEBPACK_IMPORTED_MODULE_3__url_UrlString_js__["a" /* UrlString */](host);
        authorityUrlInstance.validateAsUri();
        var authorityUrlParts = authorityUrlInstance.getUrlComponents();
        var hostNameAndPort = region + "." + authorityUrlParts.HostNameAndPort;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) {
            hostNameAndPort = region + "." + __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX;
        }
        // Include the query string portion of the url
        var url = __WEBPACK_IMPORTED_MODULE_3__url_UrlString_js__["a" /* UrlString */].constructAuthorityUriFromObject(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, authorityUrlInstance.getUrlComponents()), { HostNameAndPort: hostNameAndPort })).urlString;
        // Add the query string if a query string was provided
        if (queryString)
            return url + "?" + queryString;
        return url;
    };
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */
    Authority.replaceWithRegionalInformation = function (metadata, azureRegion) {
        metadata.authorization_endpoint = Authority.buildRegionalAuthorityString(metadata.authorization_endpoint, azureRegion);
        // TODO: Enquire on whether we should leave the query string or remove it before releasing the feature
        metadata.token_endpoint = Authority.buildRegionalAuthorityString(metadata.token_endpoint, azureRegion, __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].REGIONAL_AUTH_NON_MSI_QUERY_STRING);
        if (metadata.end_session_endpoint) {
            metadata.end_session_endpoint = Authority.buildRegionalAuthorityString(metadata.end_session_endpoint, azureRegion);
        }
        return metadata;
    };
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */
    Authority.transformCIAMAuthority = function (authority) {
        var ciamAuthority = authority.endsWith(__WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].FORWARD_SLASH) ? authority : "" + authority + __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].FORWARD_SLASH;
        var authorityUrl = new __WEBPACK_IMPORTED_MODULE_3__url_UrlString_js__["a" /* UrlString */](authority);
        var authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && (authorityUrlComponents.HostNameAndPort.endsWith(__WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].CIAM_AUTH_URL))) {
            var tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = "" + ciamAuthority + tenantIdOrDomain + __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["m" /* Constants */].AAD_TENANT_DOMAIN_SUFFIX;
        }
        return ciamAuthority;
    };
    // Reserved tenant domain names that will not be replaced with tenant id
    Authority.reservedTenantDomains = (new Set([
        "{tenant}",
        "{tenantid}",
        __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["a" /* AADAuthorityConstants */].COMMON,
        __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["a" /* AADAuthorityConstants */].CONSUMERS,
        __WEBPACK_IMPORTED_MODULE_5__utils_Constants_js__["a" /* AADAuthorityConstants */].ORGANIZATIONS
    ]));
    return Authority;
}());


//# sourceMappingURL=Authority.js.map


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProtocolMode; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Protocol modes supported by MSAL.
 */
var ProtocolMode;
(function (ProtocolMode) {
    ProtocolMode["AAD"] = "AAD";
    ProtocolMode["OIDC"] = "OIDC";
})(ProtocolMode || (ProtocolMode = {}));


//# sourceMappingURL=ProtocolMode.js.map


/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthorityMetadataEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_TimeUtils_js__ = __webpack_require__(114);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var AuthorityMetadataEntity = /** @class */ (function () {
    function AuthorityMetadataEntity() {
        this.expiresAt = __WEBPACK_IMPORTED_MODULE_1__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds() + __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["d" /* AUTHORITY_METADATA_CONSTANTS */].REFRESH_TIME_SECONDS;
    }
    /**
     * Update the entity with new aliases, preferred_cache and preferred_network values
     * @param metadata
     * @param fromNetwork
     */
    AuthorityMetadataEntity.prototype.updateCloudDiscoveryMetadata = function (metadata, fromNetwork) {
        this.aliases = metadata.aliases;
        this.preferred_cache = metadata.preferred_cache;
        this.preferred_network = metadata.preferred_network;
        this.aliasesFromNetwork = fromNetwork;
    };
    /**
     * Update the entity with new endpoints
     * @param metadata
     * @param fromNetwork
     */
    AuthorityMetadataEntity.prototype.updateEndpointMetadata = function (metadata, fromNetwork) {
        this.authorization_endpoint = metadata.authorization_endpoint;
        this.token_endpoint = metadata.token_endpoint;
        this.end_session_endpoint = metadata.end_session_endpoint;
        this.issuer = metadata.issuer;
        this.endpointsFromNetwork = fromNetwork;
        this.jwks_uri = metadata.jwks_uri;
    };
    /**
     * Save the authority that was used to create this cache entry
     * @param authority
     */
    AuthorityMetadataEntity.prototype.updateCanonicalAuthority = function (authority) {
        this.canonical_authority = authority;
    };
    /**
     * Reset the exiresAt value
     */
    AuthorityMetadataEntity.prototype.resetExpiresAt = function () {
        this.expiresAt = __WEBPACK_IMPORTED_MODULE_1__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds() + __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["d" /* AUTHORITY_METADATA_CONSTANTS */].REFRESH_TIME_SECONDS;
    };
    /**
     * Returns whether or not the data needs to be refreshed
     */
    AuthorityMetadataEntity.prototype.isExpired = function () {
        return this.expiresAt <= __WEBPACK_IMPORTED_MODULE_1__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds();
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */
    AuthorityMetadataEntity.isAuthorityMetadataEntity = function (key, entity) {
        if (!entity) {
            return false;
        }
        return (key.indexOf(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["d" /* AUTHORITY_METADATA_CONSTANTS */].CACHE_KEY) === 0 &&
            entity.hasOwnProperty("aliases") &&
            entity.hasOwnProperty("preferred_cache") &&
            entity.hasOwnProperty("preferred_network") &&
            entity.hasOwnProperty("canonical_authority") &&
            entity.hasOwnProperty("authorization_endpoint") &&
            entity.hasOwnProperty("token_endpoint") &&
            entity.hasOwnProperty("issuer") &&
            entity.hasOwnProperty("aliasesFromNetwork") &&
            entity.hasOwnProperty("endpointsFromNetwork") &&
            entity.hasOwnProperty("expiresAt") &&
            entity.hasOwnProperty("jwks_uri"));
    };
    return AuthorityMetadataEntity;
}());


//# sourceMappingURL=AuthorityMetadataEntity.js.map


/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerTelemetryEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ServerTelemetryEntity = /** @class */ (function () {
    function ServerTelemetryEntity() {
        this.failedRequests = [];
        this.errors = [];
        this.cacheHits = 0;
    }
    /**
     * validates if a given cache entry is "Telemetry", parses <key,value>
     * @param key
     * @param entity
     */
    ServerTelemetryEntity.isServerTelemetryEntity = function (key, entity) {
        var validateKey = key.indexOf(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].CACHE_KEY) === 0;
        var validateEntity = true;
        if (entity) {
            validateEntity =
                entity.hasOwnProperty("failedRequests") &&
                    entity.hasOwnProperty("errors") &&
                    entity.hasOwnProperty("cacheHits");
        }
        return validateKey && validateEntity;
    };
    return ServerTelemetryEntity;
}());


//# sourceMappingURL=ServerTelemetryEntity.js.map


/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PerformanceClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PerformanceEvent_js__ = __webpack_require__(153);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var PerformanceClient = /** @class */ (function () {
    /**
     * Creates an instance of PerformanceClient,
     * an abstract class containing core performance telemetry logic.
     *
     * @constructor
     * @param {string} clientId Client ID of the application
     * @param {string} authority Authority used by the application
     * @param {Logger} logger Logger used by the application
     * @param {string} libraryName Name of the library
     * @param {string} libraryVersion Version of the library
     */
    function PerformanceClient(clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry) {
        this.authority = authority;
        this.libraryName = libraryName;
        this.libraryVersion = libraryVersion;
        this.applicationTelemetry = applicationTelemetry;
        this.clientId = clientId;
        this.logger = logger;
        this.callbacks = new Map();
        this.eventsByCorrelationId = new Map();
        this.queueMeasurements = new Map();
        this.preQueueTimeByCorrelationId = new Map();
    }
    /**
     * Starts and returns an platform-specific implementation of IPerformanceMeasurement.
     * Note: this function can be changed to abstract at the next major version bump.
     *
     * @param {string} measureName
     * @param {string} correlationId
     * @returns {IPerformanceMeasurement}
     */
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    PerformanceClient.prototype.startPerformanceMeasurement = function (measureName, correlationId) {
        return {};
    };
    /**
     * Starts and returns an platform-specific implementation of IPerformanceMeasurement.
     * Note: this incorrectly-named function will be removed at the next major version bump.
     *
     * @param {string} measureName
     * @param {string} correlationId
     * @returns {IPerformanceMeasurement}
     */
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    PerformanceClient.prototype.startPerformanceMeasuremeant = function (measureName, correlationId) {
        return {};
    };
    /**
     * Get integral fields.
     * Override to change the set.
     */
    PerformanceClient.prototype.getIntFields = function () {
        return __WEBPACK_IMPORTED_MODULE_1__PerformanceEvent_js__["a" /* IntFields */];
    };
    /**
     * Gets map of pre-queue times by correlation Id
     *
     * @param {PerformanceEvents} eventName
     * @param {string} correlationId
     * @returns {number}
     */
    PerformanceClient.prototype.getPreQueueTime = function (eventName, correlationId) {
        var preQueueEvent = this.preQueueTimeByCorrelationId.get(correlationId);
        if (!preQueueEvent) {
            this.logger.trace("PerformanceClient.getPreQueueTime: no pre-queue times found for correlationId: " + correlationId + ", unable to add queue measurement");
            return;
        }
        else if (preQueueEvent.name !== eventName) {
            this.logger.trace("PerformanceClient.getPreQueueTime: no pre-queue time found for " + eventName + ", unable to add queue measurement");
            return;
        }
        return preQueueEvent.time;
    };
    /**
     * Calculates the difference between current time and time when function was queued.
     * Note: It is possible to have 0 as the queue time if the current time and the queued time was the same.
     *
     * @param {number} preQueueTime
     * @param {number} currentTime
     * @returns {number}
     */
    PerformanceClient.prototype.calculateQueuedTime = function (preQueueTime, currentTime) {
        if (preQueueTime < 1) {
            this.logger.trace("PerformanceClient: preQueueTime should be a positive integer and not " + preQueueTime);
            return 0;
        }
        if (currentTime < 1) {
            this.logger.trace("PerformanceClient: currentTime should be a positive integer and not " + currentTime);
            return 0;
        }
        if (currentTime < preQueueTime) {
            this.logger.trace("PerformanceClient: currentTime is less than preQueueTime, check how time is being retrieved");
            return 0;
        }
        return currentTime - preQueueTime;
    };
    /**
     * Adds queue measurement time to QueueMeasurements array for given correlation ID.
     *
     * @param {PerformanceEvents} eventName
     * @param {?string} correlationId
     * @param {?number} queueTime
     * @param {?boolean} manuallyCompleted - indicator for manually completed queue measurements
     * @returns
     */
    PerformanceClient.prototype.addQueueMeasurement = function (eventName, correlationId, queueTime, manuallyCompleted) {
        if (!correlationId) {
            this.logger.trace("PerformanceClient.addQueueMeasurement: correlationId not provided for " + eventName + ", cannot add queue measurement");
            return;
        }
        if (queueTime === 0) {
            // Possible for there to be no queue time after calculation
            this.logger.trace("PerformanceClient.addQueueMeasurement: queue time provided for " + eventName + " is " + queueTime);
        }
        else if (!queueTime) {
            this.logger.trace("PerformanceClient.addQueueMeasurement: no queue time provided for " + eventName);
            return;
        }
        var queueMeasurement = { eventName: eventName, queueTime: queueTime, manuallyCompleted: manuallyCompleted };
        // Adds to existing correlation Id if present in queueMeasurements
        var existingMeasurements = this.queueMeasurements.get(correlationId);
        if (existingMeasurements) {
            existingMeasurements.push(queueMeasurement);
            this.queueMeasurements.set(correlationId, existingMeasurements);
        }
        else {
            // Sets new correlation Id if not present in queueMeasurements
            this.logger.trace("PerformanceClient.addQueueMeasurement: adding correlationId " + correlationId + " to queue measurements");
            var measurementArray = [queueMeasurement];
            this.queueMeasurements.set(correlationId, measurementArray);
        }
        // Delete processed pre-queue event.
        this.preQueueTimeByCorrelationId.delete(correlationId);
    };
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {InProgressPerformanceEvent}
     */
    PerformanceClient.prototype.startMeasurement = function (measureName, correlationId) {
        var _this = this;
        var _a, _b;
        // Generate a placeholder correlation if the request does not provide one
        var eventCorrelationId = correlationId || this.generateId();
        if (!correlationId) {
            this.logger.info("PerformanceClient: No correlation id provided for " + measureName + ", generating", eventCorrelationId);
        }
        // Duplicate code to address spelling error will be removed at the next major version bump.
        this.logger.trace("PerformanceClient: Performance measurement started for " + measureName, eventCorrelationId);
        var performanceMeasurement = this.startPerformanceMeasuremeant(measureName, eventCorrelationId);
        performanceMeasurement.startMeasurement();
        var inProgressEvent = {
            eventId: this.generateId(),
            status: __WEBPACK_IMPORTED_MODULE_1__PerformanceEvent_js__["b" /* PerformanceEventStatus */].InProgress,
            authority: this.authority,
            libraryName: this.libraryName,
            libraryVersion: this.libraryVersion,
            clientId: this.clientId,
            name: measureName,
            startTimeMs: Date.now(),
            correlationId: eventCorrelationId,
            appName: (_a = this.applicationTelemetry) === null || _a === void 0 ? void 0 : _a.appName,
            appVersion: (_b = this.applicationTelemetry) === null || _b === void 0 ? void 0 : _b.appVersion,
        };
        // Store in progress events so they can be discarded if not ended properly
        this.cacheEventByCorrelationId(inProgressEvent);
        // Return the event and functions the caller can use to properly end/flush the measurement
        return {
            endMeasurement: function (event) {
                return _this.endMeasurement(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, inProgressEvent), event), performanceMeasurement);
            },
            discardMeasurement: function () {
                return _this.discardMeasurements(inProgressEvent.correlationId);
            },
            addStaticFields: function (fields) {
                return _this.addStaticFields(fields, inProgressEvent.correlationId);
            },
            increment: function (counters) {
                return _this.increment(counters, inProgressEvent.correlationId);
            },
            measurement: performanceMeasurement,
            event: inProgressEvent
        };
    };
    /**
     * Stops measuring the performance for an operation. Should only be called directly by PerformanceClient classes,
     * as consumers should instead use the function returned by startMeasurement.
     * Adds a new field named as "[event name]DurationMs" for sub-measurements, completes and emits an event
     * otherwise.
     *
     * @param {PerformanceEvent} event
     * @param {IPerformanceMeasurement} measurement
     * @returns {(PerformanceEvent | null)}
     */
    PerformanceClient.prototype.endMeasurement = function (event, measurement) {
        var _this = this;
        var _a, _b;
        var rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (!rootEvent) {
            this.logger.trace("PerformanceClient: Measurement not found for " + event.eventId, event.correlationId);
            return null;
        }
        var isRoot = event.eventId === rootEvent.eventId;
        var queueInfo = {
            totalQueueTime: 0,
            totalQueueCount: 0,
            manuallyCompletedCount: 0
        };
        if (isRoot) {
            queueInfo = this.getQueueInfo(event.correlationId);
            this.discardCache(rootEvent.correlationId);
        }
        else {
            (_a = rootEvent.incompleteSubMeasurements) === null || _a === void 0 ? void 0 : _a.delete(event.eventId);
        }
        measurement === null || measurement === void 0 ? void 0 : measurement.endMeasurement();
        var durationMs = measurement === null || measurement === void 0 ? void 0 : measurement.flushMeasurement();
        // null indicates no measurement was taken (e.g. needed performance APIs not present)
        if (!durationMs) {
            this.logger.trace("PerformanceClient: Performance measurement not taken", rootEvent.correlationId);
            return null;
        }
        this.logger.trace("PerformanceClient: Performance measurement ended for " + event.name + ": " + durationMs + " ms", event.correlationId);
        // Add sub-measurement attribute to root event.
        if (!isRoot) {
            rootEvent[event.name + "DurationMs"] = Math.floor(durationMs);
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, rootEvent);
        }
        var finalEvent = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, rootEvent), event);
        var incompleteSubsCount = 0;
        // Incomplete sub-measurements are discarded. They are likely an instrumentation bug that should be fixed.
        (_b = finalEvent.incompleteSubMeasurements) === null || _b === void 0 ? void 0 : _b.forEach(function (subMeasurement) {
            _this.logger.trace("PerformanceClient: Incomplete submeasurement " + subMeasurement.name + " found for " + event.name, finalEvent.correlationId);
            incompleteSubsCount++;
        });
        finalEvent.incompleteSubMeasurements = undefined;
        finalEvent = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, finalEvent), { durationMs: Math.round(durationMs), queuedTimeMs: queueInfo.totalQueueTime, queuedCount: queueInfo.totalQueueCount, queuedManuallyCompletedCount: queueInfo.manuallyCompletedCount, status: __WEBPACK_IMPORTED_MODULE_1__PerformanceEvent_js__["b" /* PerformanceEventStatus */].Completed, incompleteSubsCount: incompleteSubsCount });
        this.truncateIntegralFields(finalEvent, this.getIntFields());
        this.emitEvents([finalEvent], event.correlationId);
        return finalEvent;
    };
    /**
     * Saves extra information to be emitted when the measurements are flushed
     * @param fields
     * @param correlationId
     */
    PerformanceClient.prototype.addStaticFields = function (fields, correlationId) {
        this.logger.trace("PerformanceClient: Updating static fields");
        var event = this.eventsByCorrelationId.get(correlationId);
        if (event) {
            this.eventsByCorrelationId.set(correlationId, Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, event), fields));
        }
        else {
            this.logger.trace("PerformanceClient: Event not found for", correlationId);
        }
    };
    /**
     * Increment counters to be emitted when the measurements are flushed
     * @param counters {Counters}
     * @param correlationId {string} correlation identifier
     */
    PerformanceClient.prototype.increment = function (counters, correlationId) {
        this.logger.trace("PerformanceClient: Updating counters");
        var event = this.eventsByCorrelationId.get(correlationId);
        if (event) {
            for (var counter in counters) {
                if (!event.hasOwnProperty(counter)) {
                    event[counter] = 0;
                }
                event[counter] += counters[counter];
            }
        }
        else {
            this.logger.trace("PerformanceClient: Event not found for", correlationId);
        }
    };
    /**
     * Upserts event into event cache.
     * First key is the correlation id, second key is the event id.
     * Allows for events to be grouped by correlation id,
     * and to easily allow for properties on them to be updated.
     *
     * @private
     * @param {PerformanceEvent} event
     */
    PerformanceClient.prototype.cacheEventByCorrelationId = function (event) {
        var rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (rootEvent) {
            this.logger.trace("PerformanceClient: Performance measurement for " + event.name + " added/updated", event.correlationId);
            rootEvent.incompleteSubMeasurements = rootEvent.incompleteSubMeasurements || new Map();
            rootEvent.incompleteSubMeasurements.set(event.eventId, { name: event.name, startTimeMs: event.startTimeMs });
        }
        else {
            this.logger.trace("PerformanceClient: Performance measurement for " + event.name + " started", event.correlationId);
            this.eventsByCorrelationId.set(event.correlationId, Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, event));
        }
    };
    PerformanceClient.prototype.getQueueInfo = function (correlationId) {
        var queueMeasurementForCorrelationId = this.queueMeasurements.get(correlationId);
        if (!queueMeasurementForCorrelationId) {
            this.logger.trace("PerformanceClient: no queue measurements found for for correlationId: " + correlationId);
        }
        var totalQueueTime = 0;
        var totalQueueCount = 0;
        var manuallyCompletedCount = 0;
        queueMeasurementForCorrelationId === null || queueMeasurementForCorrelationId === void 0 ? void 0 : queueMeasurementForCorrelationId.forEach(function (measurement) {
            totalQueueTime += measurement.queueTime;
            totalQueueCount++;
            manuallyCompletedCount += measurement.manuallyCompleted ? 1 : 0;
        });
        return {
            totalQueueTime: totalQueueTime,
            totalQueueCount: totalQueueCount,
            manuallyCompletedCount: manuallyCompletedCount
        };
    };
    /**
     * Removes measurements for a given correlation id.
     *
     * @param {string} correlationId
     */
    PerformanceClient.prototype.discardMeasurements = function (correlationId) {
        this.logger.trace("PerformanceClient: Performance measurements discarded", correlationId);
        this.eventsByCorrelationId.delete(correlationId);
    };
    /**
     * Removes cache for a given correlation id.
     *
     * @param {string} correlationId correlation identifier
     */
    PerformanceClient.prototype.discardCache = function (correlationId) {
        this.discardMeasurements(correlationId);
        this.logger.trace("PerformanceClient: QueueMeasurements discarded", correlationId);
        this.queueMeasurements.delete(correlationId);
        this.logger.trace("PerformanceClient: Pre-queue times discarded", correlationId);
        this.preQueueTimeByCorrelationId.delete(correlationId);
    };
    /**
     * Registers a callback function to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */
    PerformanceClient.prototype.addPerformanceCallback = function (callback) {
        var callbackId = this.generateId();
        this.callbacks.set(callbackId, callback);
        this.logger.verbose("PerformanceClient: Performance callback registered with id: " + callbackId);
        return callbackId;
    };
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */
    PerformanceClient.prototype.removePerformanceCallback = function (callbackId) {
        var result = this.callbacks.delete(callbackId);
        if (result) {
            this.logger.verbose("PerformanceClient: Performance callback " + callbackId + " removed.");
        }
        else {
            this.logger.verbose("PerformanceClient: Performance callback " + callbackId + " not removed.");
        }
        return result;
    };
    /**
     * Emits events to all registered callbacks.
     *
     * @param {PerformanceEvent[]} events
     * @param {?string} [correlationId]
     */
    PerformanceClient.prototype.emitEvents = function (events, correlationId) {
        var _this = this;
        this.logger.verbose("PerformanceClient: Emitting performance events", correlationId);
        this.callbacks.forEach(function (callback, callbackId) {
            _this.logger.trace("PerformanceClient: Emitting event to callback " + callbackId, correlationId);
            callback.apply(null, [events]);
        });
    };
    /**
     * Enforce truncation of integral fields in performance event.
     * @param {PerformanceEvent} event performance event to update.
     * @param {Set<string>} intFields integral fields.
     */
    PerformanceClient.prototype.truncateIntegralFields = function (event, intFields) {
        intFields.forEach(function (key) {
            if (key in event && typeof event[key] === "number") {
                event[key] = Math.floor(event[key]);
            }
        });
    };
    return PerformanceClient;
}());


//# sourceMappingURL=PerformanceClient.js.map


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemoryStorage; });
/*! @azure/msal-browser v2.38.3 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache = new Map();
    }
    MemoryStorage.prototype.getItem = function (key) {
        return this.cache.get(key) || null;
    };
    MemoryStorage.prototype.setItem = function (key, value) {
        this.cache.set(key, value);
    };
    MemoryStorage.prototype.removeItem = function (key) {
        this.cache.delete(key);
    };
    MemoryStorage.prototype.getKeys = function () {
        var cacheKeys = [];
        this.cache.forEach(function (value, key) {
            cacheKeys.push(key);
        });
        return cacheKeys;
    };
    MemoryStorage.prototype.containsKey = function (key) {
        return this.cache.has(key);
    };
    MemoryStorage.prototype.clear = function () {
        this.cache.clear();
    };
    return MemoryStorage;
}());


//# sourceMappingURL=MemoryStorage.js.map


/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserProtocolUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__ = __webpack_require__(31);
/*! @azure/msal-browser v2.38.3 2023-10-27 */



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var BrowserProtocolUtils = /** @class */ (function () {
    function BrowserProtocolUtils() {
    }
    /**
     * Extracts the BrowserStateObject from the state string.
     * @param browserCrypto
     * @param state
     */
    BrowserProtocolUtils.extractBrowserRequestState = function (browserCrypto, state) {
        if (__WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["W" /* StringUtils */].isEmpty(state)) {
            return null;
        }
        try {
            var requestStateObj = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["N" /* ProtocolUtils */].parseRequestState(browserCrypto, state);
            return requestStateObj.libraryState.meta;
        }
        catch (e) {
            throw __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["r" /* ClientAuthError */].createInvalidStateError(state, e);
        }
    };
    /**
     * Parses properties of server response from url hash
     * @param locationHash Hash from url
     */
    BrowserProtocolUtils.parseServerResponseFromHash = function (locationHash) {
        if (!locationHash) {
            return {};
        }
        var hashUrlString = new __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["_2" /* UrlString */](locationHash);
        return __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["_2" /* UrlString */].getDeserializedHash(hashUrlString.getHash());
    };
    return BrowserProtocolUtils;
}());


//# sourceMappingURL=BrowserProtocolUtils.js.map


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseInteractionClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packageMetadata_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_BrowserUtils_js__ = __webpack_require__(172);
/*! @azure/msal-browser v2.38.3 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var BaseInteractionClient = /** @class */ (function () {
    function BaseInteractionClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) {
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.nativeMessageHandler = nativeMessageHandler;
        this.correlationId = correlationId || this.browserCrypto.createNewGuid();
        this.logger = logger.clone(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["c" /* BrowserConstants */].MSAL_SKU, __WEBPACK_IMPORTED_MODULE_2__packageMetadata_js__["b" /* version */], this.correlationId);
        this.performanceClient = performanceClient;
    }
    BaseInteractionClient.prototype.clearCacheOnLogout = function (account) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!account) return [3 /*break*/, 5];
                        if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["b" /* AccountEntity */].accountInfoIsEqual(account, this.browserStorage.getActiveAccount(), false)) {
                            this.logger.verbose("Setting active account to null");
                            this.browserStorage.setActiveAccount(null);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.browserStorage.removeAccount(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["b" /* AccountEntity */].generateAccountCacheKey(account))];
                    case 2:
                        _a.sent();
                        this.logger.verbose("Cleared cache items belonging to the account provided in the logout request.");
                        return [3 /*break*/, 4];
                    case 3:
                        _a.sent();
                        this.logger.error("Account provided in logout request was not found. Local cache unchanged.");
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 9];
                    case 5:
                        _a.trys.push([5, 8, , 9]);
                        this.logger.verbose("No account provided in logout request, clearing all cache items.", this.correlationId);
                        // Clear all accounts and tokens
                        return [4 /*yield*/, this.browserStorage.clear()];
                    case 6:
                        // Clear all accounts and tokens
                        _a.sent();
                        // Clear any stray keys from IndexedDB
                        return [4 /*yield*/, this.browserCrypto.clearKeystore()];
                    case 7:
                        // Clear any stray keys from IndexedDB
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        _a.sent();
                        this.logger.error("Attempted to clear all MSAL cache items and failed. Local cache unchanged.");
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initializer function for all request APIs
     * @param request
     */
    BaseInteractionClient.prototype.initializeBaseRequest = function (request, account) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var authority, scopes, validatedRequest, _a;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].InitializeBaseRequest, request.correlationId);
                        this.logger.verbose("Initializing BaseAuthRequest");
                        authority = request.authority || this.config.auth.authority;
                        if (!account) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validateRequestAuthority(authority, account)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        scopes = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["f" /* __spread */])(((request && request.scopes) || []));
                        validatedRequest = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request), { correlationId: this.correlationId, authority: authority,
                            scopes: scopes });
                        // Set authenticationScheme to BEARER if not explicitly set in the request
                        if (!validatedRequest.authenticationScheme) {
                            validatedRequest.authenticationScheme = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["h" /* AuthenticationScheme */].BEARER;
                            this.logger.verbose("Authentication Scheme wasn't explicitly set in request, defaulting to \"Bearer\" request");
                        }
                        else {
                            if (validatedRequest.authenticationScheme === __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["h" /* AuthenticationScheme */].SSH) {
                                if (!request.sshJwk) {
                                    throw __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["t" /* ClientConfigurationError */].createMissingSshJwkError();
                                }
                                if (!request.sshKid) {
                                    throw __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["t" /* ClientConfigurationError */].createMissingSshKidError();
                                }
                            }
                            this.logger.verbose("Authentication Scheme set to \"" + validatedRequest.authenticationScheme + "\" as configured in Auth request");
                        }
                        if (!(this.config.cache.claimsBasedCachingEnabled && request.claims && !__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmptyObj(request.claims))) return [3 /*break*/, 4];
                        _a = validatedRequest;
                        return [4 /*yield*/, this.browserCrypto.hashString(request.claims)];
                    case 3:
                        _a.requestedClaimsHash = _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/, validatedRequest];
                }
            });
        });
    };
    /**
     *
     * Use to get the redirect uri configured in MSAL or null.
     * @param requestRedirectUri
     * @returns Redirect URL
     *
     */
    BaseInteractionClient.prototype.getRedirectUri = function (requestRedirectUri) {
        this.logger.verbose("getRedirectUri called");
        var redirectUri = requestRedirectUri || this.config.auth.redirectUri || __WEBPACK_IMPORTED_MODULE_4__utils_BrowserUtils_js__["a" /* BrowserUtils */].getCurrentUri();
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].getAbsoluteUrl(redirectUri, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserUtils_js__["a" /* BrowserUtils */].getCurrentUri());
    };
    /*
     * If authority provided in the request does not match environment/authority specified
     * in the account or MSAL config, we throw an error.
     */
    BaseInteractionClient.prototype.validateRequestAuthority = function (authority, account) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var discoveredAuthority;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDiscoveredAuthority(authority)];
                    case 1:
                        discoveredAuthority = _a.sent();
                        if (!discoveredAuthority.isAlias(account.environment)) {
                            throw __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["t" /* ClientConfigurationError */].createAuthorityMismatchError();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param apiId
     * @param correlationId
     * @param forceRefresh
     */
    BaseInteractionClient.prototype.initializeServerTelemetryManager = function (apiId, forceRefresh) {
        this.logger.verbose("initializeServerTelemetryManager called");
        var telemetryPayload = {
            clientId: this.config.auth.clientId,
            correlationId: this.correlationId,
            apiId: apiId,
            forceRefresh: forceRefresh || false,
            wrapperSKU: this.browserStorage.getWrapperMetadata()[0],
            wrapperVer: this.browserStorage.getWrapperMetadata()[1]
        };
        return new __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["U" /* ServerTelemetryManager */](telemetryPayload, this.browserStorage);
    };
    /**
     * Used to get a discovered version of the default authority.
     * @param requestAuthority
     * @param requestCorrelationId
     */
    BaseInteractionClient.prototype.getDiscoveredAuthority = function (requestAuthority) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var authorityOptions;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("getDiscoveredAuthority called");
                        authorityOptions = {
                            protocolMode: this.config.auth.protocolMode,
                            knownAuthorities: this.config.auth.knownAuthorities,
                            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                            authorityMetadata: this.config.auth.authorityMetadata
                        };
                        if (!requestAuthority) return [3 /*break*/, 2];
                        this.logger.verbose("Creating discovered authority with request authority");
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["j" /* AuthorityFactory */].createDiscoveredInstance(requestAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        this.logger.verbose("Creating discovered authority with configured authority");
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["j" /* AuthorityFactory */].createDiscoveredInstance(this.config.auth.authority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return BaseInteractionClient;
}());


//# sourceMappingURL=BaseInteractionClient.js.map


/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RedirectClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StandardInteractionClient_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__interaction_handler_RedirectHandler_js__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_BrowserUtils_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event_EventType_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NativeInteractionClient_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__broker_nativeBroker_NativeMessageHandler_js__ = __webpack_require__(243);
/*! @azure/msal-browser v2.38.3 2023-10-27 */












/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var RedirectClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(RedirectClient, _super);
    function RedirectClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        _this.nativeStorage = nativeStorageImpl;
        return _this;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */
    RedirectClient.prototype.acquireToken = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var validRequest, serverTelemetryManager, handleBackButton, authCodeRequest, authClient, interactionHandler, navigateUrl, redirectStartPage, e_1;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [4 /*yield*/, this.initializeAuthorizationRequest(request, __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect)];
                    case 1:
                        validRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(validRequest.state, validRequest.nonce, validRequest.authority, validRequest.loginHint || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING, validRequest.account || null);
                        serverTelemetryManager = this.initializeServerTelemetryManager(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenRedirect);
                        handleBackButton = function (event) {
                            // Clear temporary cache if the back button is clicked during the redirect flow.
                            if (event.persisted) {
                                _this.logger.verbose("Page was restored from back/forward cache. Clearing temporary cache.");
                                _this.browserStorage.cleanRequestByState(validRequest.state);
                                _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_6__event_EventType_js__["a" /* EventType */].RESTORE_FROM_BFCACHE, __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                            }
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 7, , 8]);
                        // Create auth code request and generate PKCE params
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientInitializeAuthorizationCodeRequest, request.correlationId);
                        return [4 /*yield*/, this.initializeAuthorizationCodeRequest(validRequest)];
                    case 3:
                        authCodeRequest = _a.sent();
                        // Initialize the client
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientCreateAuthCodeClient, request.correlationId);
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, validRequest.authority, validRequest.azureCloudOptions)];
                    case 4:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        interactionHandler = new __WEBPACK_IMPORTED_MODULE_4__interaction_handler_RedirectHandler_js__["a" /* RedirectHandler */](authClient, this.browserStorage, authCodeRequest, this.logger, this.browserCrypto, this.performanceClient);
                        return [4 /*yield*/, authClient.getAuthCodeUrl(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, validRequest), { nativeBroker: __WEBPACK_IMPORTED_MODULE_9__broker_nativeBroker_NativeMessageHandler_js__["a" /* NativeMessageHandler */].isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme) }))];
                    case 5:
                        navigateUrl = _a.sent();
                        redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
                        this.logger.verbosePii("Redirect start page: " + redirectStartPage);
                        // Clear temporary cache if the back button is clicked during the redirect flow.
                        window.addEventListener("pageshow", handleBackButton);
                        return [4 /*yield*/, interactionHandler.initiateAuthRequest(navigateUrl, {
                                navigationClient: this.navigationClient,
                                redirectTimeout: this.config.system.redirectNavigationTimeout,
                                redirectStartPage: redirectStartPage,
                                onRedirectNavigate: request.onRedirectNavigate
                            })];
                    case 6: 
                    // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
                    return [2 /*return*/, _a.sent()];
                    case 7:
                        e_1 = _a.sent();
                        if (e_1 instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */]) {
                            e_1.setCorrelationId(this.correlationId);
                        }
                        window.removeEventListener("pageshow", handleBackButton);
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(validRequest.state);
                        throw e_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash
     */
    RedirectClient.prototype.handleRedirectPromise = function (hash) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var serverTelemetryManager, responseHash, state, serverParams, loginRequestUrl, loginRequestUrlNormalized, currentUrlNormalized, handleHashResult, navigationOptions, processHashOnRedirect, homepage, e_2;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        serverTelemetryManager = this.initializeServerTelemetryManager(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].handleRedirectPromise);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 10, , 11]);
                        if (!this.browserStorage.isInteractionInProgress(true)) {
                            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
                            return [2 /*return*/, null];
                        }
                        responseHash = this.getRedirectResponseHash(hash || window.location.hash);
                        if (!responseHash) {
                            // Not a recognized server response hash or hash not associated with a redirect request
                            this.logger.info("handleRedirectPromise did not detect a response hash as a result of a redirect. Cleaning temporary cache.");
                            this.browserStorage.cleanRequestByInteractionType(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                            return [2 /*return*/, null];
                        }
                        state = void 0;
                        try {
                            serverParams = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].getDeserializedHash(responseHash);
                            state = this.validateAndExtractStateFromHash(serverParams, __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                            this.logger.verbose("State extracted from hash");
                        }
                        catch (e) {
                            this.logger.info("handleRedirectPromise was unable to extract state due to: " + e);
                            this.browserStorage.cleanRequestByInteractionType(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                            return [2 /*return*/, null];
                        }
                        loginRequestUrl = this.browserStorage.getTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].ORIGIN_URI, true) || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                        loginRequestUrlNormalized = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].removeHashFromUrl(loginRequestUrl);
                        currentUrlNormalized = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].removeHashFromUrl(window.location.href);
                        if (!(loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl)) return [3 /*break*/, 3];
                        // We are on the page we need to navigate to - handle hash
                        this.logger.verbose("Current page is loginRequestUrl, handling hash");
                        return [4 /*yield*/, this.handleHash(responseHash, state, serverTelemetryManager)];
                    case 2:
                        handleHashResult = _a.sent();
                        if (loginRequestUrl.indexOf("#") > -1) {
                            // Replace current hash with non-msal hash, if present
                            __WEBPACK_IMPORTED_MODULE_5__utils_BrowserUtils_js__["a" /* BrowserUtils */].replaceHash(loginRequestUrl);
                        }
                        return [2 /*return*/, handleHashResult];
                    case 3:
                        if (!!this.config.auth.navigateToLoginRequestUrl) return [3 /*break*/, 4];
                        this.logger.verbose("NavigateToLoginRequestUrl set to false, handling hash");
                        return [2 /*return*/, this.handleHash(responseHash, state, serverTelemetryManager)];
                    case 4:
                        if (!(!__WEBPACK_IMPORTED_MODULE_5__utils_BrowserUtils_js__["a" /* BrowserUtils */].isInIframe() || this.config.system.allowRedirectInIframe)) return [3 /*break*/, 9];
                        /*
                         * Returned from authority using redirect - need to perform navigation before processing response
                         * Cache the hash to be retrieved after the next redirect
                         */
                        this.browserStorage.setTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].URL_HASH, responseHash, true);
                        navigationOptions = {
                            apiId: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].handleRedirectPromise,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: true
                        };
                        processHashOnRedirect = true;
                        if (!(!loginRequestUrl || loginRequestUrl === "null")) return [3 /*break*/, 6];
                        homepage = __WEBPACK_IMPORTED_MODULE_5__utils_BrowserUtils_js__["a" /* BrowserUtils */].getHomepage();
                        // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                        this.browserStorage.setTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].ORIGIN_URI, homepage, true);
                        this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
                        return [4 /*yield*/, this.navigationClient.navigateInternal(homepage, navigationOptions)];
                    case 5:
                        processHashOnRedirect = _a.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        // Navigate to page that initiated the redirect request
                        this.logger.verbose("Navigating to loginRequestUrl: " + loginRequestUrl);
                        return [4 /*yield*/, this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions)];
                    case 7:
                        processHashOnRedirect = _a.sent();
                        _a.label = 8;
                    case 8:
                        // If navigateInternal implementation returns false, handle the hash now
                        if (!processHashOnRedirect) {
                            return [2 /*return*/, this.handleHash(responseHash, state, serverTelemetryManager)];
                        }
                        _a.label = 9;
                    case 9: return [2 /*return*/, null];
                    case 10:
                        e_2 = _a.sent();
                        if (e_2 instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */]) {
                            e_2.setCorrelationId(this.correlationId);
                        }
                        serverTelemetryManager.cacheFailedRequest(e_2);
                        this.browserStorage.cleanRequestByInteractionType(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                        throw e_2;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */
    RedirectClient.prototype.getRedirectResponseHash = function (hash) {
        this.logger.verbose("getRedirectResponseHash called");
        // Get current location hash from window or cache.
        var isResponseHash = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].hashContainsKnownProperties(hash);
        if (isResponseHash) {
            __WEBPACK_IMPORTED_MODULE_5__utils_BrowserUtils_js__["a" /* BrowserUtils */].clearHash(window);
            this.logger.verbose("Hash contains known properties, returning response hash");
            return hash;
        }
        var cachedHash = this.browserStorage.getTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].URL_HASH, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].URL_HASH));
        this.logger.verbose("Hash does not contain known properties, returning cached hash");
        return cachedHash;
    };
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */
    RedirectClient.prototype.handleHash = function (hash, state, serverTelemetryManager) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var cachedRequest, serverParams, nativeInteractionClient, userRequestState, currentAuthority, authClient, interactionHandler;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cachedRequest = this.browserStorage.getCachedRequest(state, this.browserCrypto);
                        this.logger.verbose("handleHash called, retrieved cached request");
                        serverParams = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].getDeserializedHash(hash);
                        if (serverParams.accountId) {
                            this.logger.verbose("Account id found in hash, calling WAM for token");
                            if (!this.nativeMessageHandler) {
                                throw __WEBPACK_IMPORTED_MODULE_7__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNativeConnectionNotEstablishedError();
                            }
                            nativeInteractionClient = new __WEBPACK_IMPORTED_MODULE_8__NativeInteractionClient_js__["a" /* NativeInteractionClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, cachedRequest.correlationId);
                            userRequestState = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["N" /* ProtocolUtils */].parseRequestState(this.browserCrypto, state).userRequestState;
                            return [2 /*return*/, nativeInteractionClient.acquireToken(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, cachedRequest), { state: userRequestState, prompt: undefined // Server should handle the prompt, ideally native broker can do this part silently
                                 })).finally(function () {
                                    _this.browserStorage.cleanRequestByState(state);
                                })];
                        }
                        currentAuthority = this.browserStorage.getCachedAuthority(state);
                        if (!currentAuthority) {
                            throw __WEBPACK_IMPORTED_MODULE_7__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNoCachedAuthorityError();
                        }
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientCreateAuthCodeClient, cachedRequest.correlationId);
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, currentAuthority)];
                    case 1:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_0" /* ThrottlingUtils */].removeThrottle(this.browserStorage, this.config.auth.clientId, cachedRequest);
                        interactionHandler = new __WEBPACK_IMPORTED_MODULE_4__interaction_handler_RedirectHandler_js__["a" /* RedirectHandler */](authClient, this.browserStorage, cachedRequest, this.logger, this.browserCrypto, this.performanceClient);
                        return [4 /*yield*/, interactionHandler.handleCodeResponseFromHash(hash, state, authClient.authority, this.networkClient)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */
    RedirectClient.prototype.logout = function (logoutRequest) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var validLogoutRequest, serverTelemetryManager, navigationOptions, authClient, logoutUri, navigate, e_3;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("logoutRedirect called");
                        validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
                        serverTelemetryManager = this.initializeServerTelemetryManager(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].logout);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 10, , 11]);
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_6__event_EventType_js__["a" /* EventType */].LOGOUT_START, __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, logoutRequest);
                        // Clear cache on logout
                        return [4 /*yield*/, this.clearCacheOnLogout(validLogoutRequest.account)];
                    case 2:
                        // Clear cache on logout
                        _a.sent();
                        navigationOptions = {
                            apiId: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].logout,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientCreateAuthCodeClient, validLogoutRequest.correlationId);
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, logoutRequest && logoutRequest.authority)];
                    case 3:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        logoutUri = authClient.getLogoutUri(validLogoutRequest);
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_6__event_EventType_js__["a" /* EventType */].LOGOUT_SUCCESS, __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, validLogoutRequest);
                        if (!(logoutRequest && typeof logoutRequest.onRedirectNavigate === "function")) return [3 /*break*/, 7];
                        navigate = logoutRequest.onRedirectNavigate(logoutUri);
                        if (!(navigate !== false)) return [3 /*break*/, 5];
                        this.logger.verbose("Logout onRedirectNavigate did not return false, navigating");
                        // Ensure interaction is in progress
                        if (!this.browserStorage.getInteractionInProgress()) {
                            this.browserStorage.setInteractionInProgress(true);
                        }
                        return [4 /*yield*/, this.navigationClient.navigateExternal(logoutUri, navigationOptions)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                    case 5:
                        // Ensure interaction is not in progress
                        this.browserStorage.setInteractionInProgress(false);
                        this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
                        _a.label = 6;
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        // Ensure interaction is in progress
                        if (!this.browserStorage.getInteractionInProgress()) {
                            this.browserStorage.setInteractionInProgress(true);
                        }
                        return [4 /*yield*/, this.navigationClient.navigateExternal(logoutUri, navigationOptions)];
                    case 8:
                        _a.sent();
                        return [2 /*return*/];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        e_3 = _a.sent();
                        if (e_3 instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */]) {
                            e_3.setCorrelationId(this.correlationId);
                        }
                        serverTelemetryManager.cacheFailedRequest(e_3);
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_6__event_EventType_js__["a" /* EventType */].LOGOUT_FAILURE, __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, null, e_3);
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_6__event_EventType_js__["a" /* EventType */].LOGOUT_END, __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                        throw e_3;
                    case 11:
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_6__event_EventType_js__["a" /* EventType */].LOGOUT_END, __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */
    RedirectClient.prototype.getRedirectStartPage = function (requestStartPage) {
        var redirectStartPage = requestStartPage || window.location.href;
        return __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].getAbsoluteUrl(redirectStartPage, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserUtils_js__["a" /* BrowserUtils */].getCurrentUri());
    };
    return RedirectClient;
}(__WEBPACK_IMPORTED_MODULE_2__StandardInteractionClient_js__["a" /* StandardInteractionClient */]));


//# sourceMappingURL=RedirectClient.js.map


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RedirectHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InteractionHandler_js__ = __webpack_require__(581);
/*! @azure/msal-browser v2.38.3 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var RedirectHandler = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(RedirectHandler, _super);
    function RedirectHandler(authCodeModule, storageImpl, authCodeRequest, logger, browserCrypto, performanceClient) {
        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest, logger, performanceClient) || this;
        _this.browserCrypto = browserCrypto;
        return _this;
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     */
    RedirectHandler.prototype.initiateAuthRequest = function (requestUrl, params) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var navigationOptions, navigate;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("RedirectHandler.initiateAuthRequest called");
                        if (!!__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(requestUrl)) return [3 /*break*/, 7];
                        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
                        if (params.redirectStartPage) {
                            this.logger.verbose("RedirectHandler.initiateAuthRequest: redirectStartPage set, caching start page");
                            this.browserStorage.setTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].ORIGIN_URI, params.redirectStartPage, true);
                        }
                        // Set interaction status in the library.
                        this.browserStorage.setTemporaryCache(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].CORRELATION_ID, this.authCodeRequest.correlationId, true);
                        this.browserStorage.cacheCodeRequest(this.authCodeRequest, this.browserCrypto);
                        this.logger.infoPii("RedirectHandler.initiateAuthRequest: Navigate to: " + requestUrl);
                        navigationOptions = {
                            apiId: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenRedirect,
                            timeout: params.redirectTimeout,
                            noHistory: false
                        };
                        if (!(typeof params.onRedirectNavigate === "function")) return [3 /*break*/, 4];
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
                        navigate = params.onRedirectNavigate(requestUrl);
                        if (!(navigate !== false)) return [3 /*break*/, 2];
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
                        return [4 /*yield*/, params.navigationClient.navigateExternal(requestUrl, navigationOptions)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
                        return [2 /*return*/];
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        // Navigate window to request URL
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
                        return [4 /*yield*/, params.navigationClient.navigateExternal(requestUrl, navigationOptions)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        // Throw error if request URL is empty.
                        this.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
                        throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createEmptyNavigationUriError();
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handle authorization code response in the window.
     * @param hash
     */
    RedirectHandler.prototype.handleCodeResponseFromHash = function (locationHash, state, authority, networkModule) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var stateKey, requestState, authCodeResponse, nonceKey, cachedNonce, cachedCcsCred, tokenResponse;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("RedirectHandler.handleCodeResponse called");
                        // Check that location hash isn't empty.
                        if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(locationHash)) {
                            throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createEmptyHashError(locationHash);
                        }
                        // Interaction is completed - remove interaction status.
                        this.browserStorage.setInteractionInProgress(false);
                        stateKey = this.browserStorage.generateStateKey(state);
                        requestState = this.browserStorage.getTemporaryCache(stateKey);
                        if (!requestState) {
                            throw __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["r" /* ClientAuthError */].createStateNotFoundError("Cached State");
                        }
                        try {
                            authCodeResponse = this.authModule.handleFragmentResponse(locationHash, requestState);
                        }
                        catch (e) {
                            if (e instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["S" /* ServerError */] && e.subError === __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["b" /* BrowserAuthErrorMessage */].userCancelledError.code) {
                                // Translate server error caused by user closing native prompt to corresponding first class MSAL error
                                throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUserCancelledError();
                            }
                            else {
                                throw e;
                            }
                        }
                        nonceKey = this.browserStorage.generateNonceKey(requestState);
                        cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
                        // Assign code to request
                        this.authCodeRequest.code = authCodeResponse.code;
                        if (!authCodeResponse.cloud_instance_host_name) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateTokenEndpointAuthority(authCodeResponse.cloud_instance_host_name, authority, networkModule)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        authCodeResponse.nonce = cachedNonce || undefined;
                        authCodeResponse.state = requestState;
                        // Add CCS parameters if available
                        if (authCodeResponse.client_info) {
                            this.authCodeRequest.clientInfo = authCodeResponse.client_info;
                        }
                        else {
                            cachedCcsCred = this.checkCcsCredentials();
                            if (cachedCcsCred) {
                                this.authCodeRequest.ccsCredential = cachedCcsCred;
                            }
                        }
                        return [4 /*yield*/, this.authModule.acquireToken(this.authCodeRequest, authCodeResponse)];
                    case 3:
                        tokenResponse = _a.sent();
                        this.browserStorage.cleanRequestByState(state);
                        return [2 /*return*/, tokenResponse];
                }
            });
        });
    };
    return RedirectHandler;
}(__WEBPACK_IMPORTED_MODULE_4__InteractionHandler_js__["a" /* InteractionHandler */]));


//# sourceMappingURL=RedirectHandler.js.map


/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopupClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StandardInteractionClient_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event_EventType_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_BrowserUtils_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NativeInteractionClient_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__broker_nativeBroker_NativeMessageHandler_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__interaction_handler_InteractionHandler_js__ = __webpack_require__(581);
/*! @azure/msal-browser v2.38.3 2023-10-27 */












/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var PopupClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(PopupClient, _super);
    function PopupClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        // Properly sets this reference for the unload event.
        _this.unloadWindow = _this.unloadWindow.bind(_this);
        _this.nativeStorage = nativeStorageImpl;
        return _this;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     */
    PopupClient.prototype.acquireToken = function (request) {
        try {
            var popupName = this.generatePopupName(request.scopes || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["G" /* OIDC_DEFAULT_SCOPES */], request.authority || this.config.auth.authority);
            var popupWindowAttributes = request.popupWindowAttributes || {};
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true, acquiring token");
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupName, popupWindowAttributes);
            }
            else {
                // asyncPopups flag is set to false. Opens popup before acquiring token.
                this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
                var popup = this.openSizedPopup("about:blank", popupName, popupWindowAttributes);
                return this.acquireTokenPopupAsync(request, popupName, popupWindowAttributes, popup);
            }
        }
        catch (e) {
            return Promise.reject(e);
        }
    };
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */
    PopupClient.prototype.logout = function (logoutRequest) {
        try {
            this.logger.verbose("logoutPopup called");
            var validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            var popupName = this.generateLogoutPopupName(validLogoutRequest);
            var authority = logoutRequest && logoutRequest.authority;
            var mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            var popupWindowAttributes = (logoutRequest === null || logoutRequest === void 0 ? void 0 : logoutRequest.popupWindowAttributes) || {};
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true");
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupName, popupWindowAttributes, authority, undefined, mainWindowRedirectUri);
            }
            else {
                // asyncPopups flag is set to false. Opens popup before logging out.
                this.logger.verbose("asyncPopup set to false, opening popup");
                var popup = this.openSizedPopup("about:blank", popupName, popupWindowAttributes);
                return this.logoutPopupAsync(validLogoutRequest, popupName, popupWindowAttributes, authority, popup, mainWindowRedirectUri);
            }
        }
        catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    };
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param validRequest
     * @param popupName
     * @param popup
     * @param popupWindowAttributes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    PopupClient.prototype.acquireTokenPopupAsync = function (request, popupName, popupWindowAttributes, popup) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var serverTelemetryManager, validRequest, authCodeRequest, authClient, isNativeBroker, fetchNativeAccountIdMeasurement, navigateUrl, interactionHandler, popupParameters, popupWindow, hash, serverParams, state_1, nativeInteractionClient, userRequestState, result, e_1;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("acquireTokenPopupAsync called");
                        serverTelemetryManager = this.initializeServerTelemetryManager(__WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenPopup);
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [4 /*yield*/, this.initializeAuthorizationRequest(request, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Popup)];
                    case 1:
                        validRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(validRequest.state, validRequest.nonce, validRequest.authority, validRequest.loginHint || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING, validRequest.account || null);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 8, , 9]);
                        // Create auth code request and generate PKCE params
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientInitializeAuthorizationCodeRequest, request.correlationId);
                        return [4 /*yield*/, this.initializeAuthorizationCodeRequest(validRequest)];
                    case 3:
                        authCodeRequest = _a.sent();
                        // Initialize the client
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientCreateAuthCodeClient, request.correlationId);
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, validRequest.authority, validRequest.azureCloudOptions)];
                    case 4:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        isNativeBroker = __WEBPACK_IMPORTED_MODULE_7__broker_nativeBroker_NativeMessageHandler_js__["a" /* NativeMessageHandler */].isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme);
                        fetchNativeAccountIdMeasurement = void 0;
                        if (isNativeBroker) {
                            fetchNativeAccountIdMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].FetchAccountIdWithNativeBroker, request.correlationId);
                        }
                        return [4 /*yield*/, authClient.getAuthCodeUrl(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, validRequest), { nativeBroker: isNativeBroker }))];
                    case 5:
                        navigateUrl = _a.sent();
                        interactionHandler = new __WEBPACK_IMPORTED_MODULE_9__interaction_handler_InteractionHandler_js__["a" /* InteractionHandler */](authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
                        popupParameters = {
                            popup: popup,
                            popupName: popupName,
                            popupWindowAttributes: popupWindowAttributes
                        };
                        popupWindow = this.initiateAuthRequest(navigateUrl, popupParameters);
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_3__event_EventType_js__["a" /* EventType */].POPUP_OPENED, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, { popupWindow: popupWindow }, null);
                        return [4 /*yield*/, this.monitorPopupForHash(popupWindow)];
                    case 6:
                        hash = _a.sent();
                        serverParams = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].getDeserializedHash(hash);
                        state_1 = this.validateAndExtractStateFromHash(serverParams, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, validRequest.correlationId);
                        // Remove throttle if it exists
                        __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_0" /* ThrottlingUtils */].removeThrottle(this.browserStorage, this.config.auth.clientId, authCodeRequest);
                        if (serverParams.accountId) {
                            this.logger.verbose("Account id found in hash, calling WAM for token");
                            // end measurement for server call with native brokering enabled
                            if (fetchNativeAccountIdMeasurement) {
                                fetchNativeAccountIdMeasurement.endMeasurement({
                                    success: true,
                                    isNativeBroker: true
                                });
                            }
                            if (!this.nativeMessageHandler) {
                                throw __WEBPACK_IMPORTED_MODULE_8__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNativeConnectionNotEstablishedError();
                            }
                            nativeInteractionClient = new __WEBPACK_IMPORTED_MODULE_6__NativeInteractionClient_js__["a" /* NativeInteractionClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, validRequest.correlationId);
                            userRequestState = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["N" /* ProtocolUtils */].parseRequestState(this.browserCrypto, state_1).userRequestState;
                            return [2 /*return*/, nativeInteractionClient.acquireToken(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, validRequest), { state: userRequestState, prompt: undefined // Server should handle the prompt, ideally native broker can do this part silently
                                 })).finally(function () {
                                    _this.browserStorage.cleanRequestByState(state_1);
                                })];
                        }
                        return [4 /*yield*/, interactionHandler.handleCodeResponseFromHash(hash, state_1, authClient.authority, this.networkClient)];
                    case 7:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 8:
                        e_1 = _a.sent();
                        if (popup) {
                            // Close the synchronous popup if an error is thrown before the window unload event is registered
                            popup.close();
                        }
                        if (e_1 instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */]) {
                            e_1.setCorrelationId(this.correlationId);
                        }
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(validRequest.state);
                        throw e_1;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */
    PopupClient.prototype.logoutPopupAsync = function (validRequest, popupName, popupWindowAttributes, requestAuthority, popup, mainWindowRedirectUri) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var serverTelemetryManager, authClient, logoutUri, popupWindow, navigationOptions, absoluteUrl, e_2;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.verbose("logoutPopupAsync called");
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_3__event_EventType_js__["a" /* EventType */].LOGOUT_START, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, validRequest);
                        serverTelemetryManager = this.initializeServerTelemetryManager(__WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["a" /* ApiId */].logoutPopup);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        // Clear cache on logout
                        return [4 /*yield*/, this.clearCacheOnLogout(validRequest.account)];
                    case 2:
                        // Clear cache on logout
                        _a.sent();
                        // Initialize the client
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientCreateAuthCodeClient, validRequest.correlationId);
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, requestAuthority)];
                    case 3:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        logoutUri = authClient.getLogoutUri(validRequest);
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_3__event_EventType_js__["a" /* EventType */].LOGOUT_SUCCESS, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, validRequest);
                        popupWindow = this.openPopup(logoutUri, { popupName: popupName, popupWindowAttributes: popupWindowAttributes, popup: popup });
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_3__event_EventType_js__["a" /* EventType */].POPUP_OPENED, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, { popupWindow: popupWindow }, null);
                        return [4 /*yield*/, this.waitForLogoutPopup(popupWindow)];
                    case 4:
                        _a.sent();
                        if (mainWindowRedirectUri) {
                            navigationOptions = {
                                apiId: __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["a" /* ApiId */].logoutPopup,
                                timeout: this.config.system.redirectNavigationTimeout,
                                noHistory: false
                            };
                            absoluteUrl = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].getAbsoluteUrl(mainWindowRedirectUri, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserUtils_js__["a" /* BrowserUtils */].getCurrentUri());
                            this.logger.verbose("Redirecting main window to url specified in the request");
                            this.logger.verbosePii("Redirecting main window to: " + absoluteUrl);
                            this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                        }
                        else {
                            this.logger.verbose("No main window navigation requested");
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _a.sent();
                        if (popup) {
                            // Close the synchronous popup if an error is thrown before the window unload event is registered
                            popup.close();
                        }
                        if (e_2 instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */]) {
                            e_2.setCorrelationId(this.correlationId);
                        }
                        this.browserStorage.setInteractionInProgress(false);
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_3__event_EventType_js__["a" /* EventType */].LOGOUT_FAILURE, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, null, e_2);
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_3__event_EventType_js__["a" /* EventType */].LOGOUT_END, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Popup);
                        serverTelemetryManager.cacheFailedRequest(e_2);
                        throw e_2;
                    case 6:
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_3__event_EventType_js__["a" /* EventType */].LOGOUT_END, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Popup);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */
    PopupClient.prototype.initiateAuthRequest = function (requestUrl, params) {
        // Check that request url is not empty.
        if (!__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(requestUrl)) {
            this.logger.infoPii("Navigate to: " + requestUrl);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        }
        else {
            // Throw error if request URL is empty.
            this.logger.error("Navigate url is empty");
            throw __WEBPACK_IMPORTED_MODULE_8__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createEmptyNavigationUriError();
        }
    };
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     * @param timeout - timeout for processing hash once popup is redirected back to application
     */
    PopupClient.prototype.monitorPopupForHash = function (popupWindow) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            /*
             * Polling for popups needs to be tick-based,
             * since a non-trivial amount of time can be spent on interaction (which should not count against the timeout).
             */
            var maxTicks = _this.config.system.windowHashTimeout / _this.config.system.pollIntervalMilliseconds;
            var ticks = 0;
            _this.logger.verbose("PopupHandler.monitorPopupForHash - polling started");
            var intervalId = setInterval(function () {
                // Window is closed
                if (popupWindow.closed) {
                    _this.logger.error("PopupHandler.monitorPopupForHash - window closed");
                    _this.cleanPopup();
                    clearInterval(intervalId);
                    reject(__WEBPACK_IMPORTED_MODULE_8__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUserCancelledError());
                    return;
                }
                var href = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                var hash = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */
                    href = popupWindow.location.href;
                    hash = popupWindow.location.hash;
                }
                catch (e) { }
                // Don't process blank pages or cross domain
                if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(href) || href === "about:blank") {
                    return;
                }
                _this.logger.verbose("PopupHandler.monitorPopupForHash - popup window is on same origin as caller");
                /*
                 * Only run clock when we are on same domain for popups
                 * as popup operations can take a long time.
                 */
                ticks++;
                if (hash) {
                    _this.logger.verbose("PopupHandler.monitorPopupForHash - found hash in url");
                    clearInterval(intervalId);
                    _this.cleanPopup(popupWindow);
                    if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].hashContainsKnownProperties(hash)) {
                        _this.logger.verbose("PopupHandler.monitorPopupForHash - hash contains known properties, returning.");
                        resolve(hash);
                    }
                    else {
                        _this.logger.error("PopupHandler.monitorPopupForHash - found hash in url but it does not contain known properties. Check that your router is not changing the hash prematurely.");
                        _this.logger.errorPii("PopupHandler.monitorPopupForHash - hash found: " + hash);
                        reject(__WEBPACK_IMPORTED_MODULE_8__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createHashDoesNotContainKnownPropertiesError());
                    }
                }
                else if (ticks > maxTicks) {
                    _this.logger.error("PopupHandler.monitorPopupForHash - unable to find hash in url, timing out");
                    clearInterval(intervalId);
                    reject(__WEBPACK_IMPORTED_MODULE_8__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createMonitorPopupTimeoutError());
                }
            }, _this.config.system.pollIntervalMilliseconds);
        });
    };
    /**
     * Waits for user interaction in logout popup window
     * @param popupWindow
     * @returns
     */
    PopupClient.prototype.waitForLogoutPopup = function (popupWindow) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.logger.verbose("PopupHandler.waitForLogoutPopup - polling started");
            var intervalId = setInterval(function () {
                // Window is closed
                if (popupWindow.closed) {
                    _this.logger.error("PopupHandler.waitForLogoutPopup - window closed");
                    _this.cleanPopup();
                    clearInterval(intervalId);
                    resolve();
                }
                var href = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */
                    href = popupWindow.location.href;
                }
                catch (e) { }
                // Don't process blank pages or cross domain
                if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(href) || href === "about:blank") {
                    return;
                }
                _this.logger.verbose("PopupHandler.waitForLogoutPopup - popup window is on same origin as caller, closing.");
                clearInterval(intervalId);
                _this.cleanPopup(popupWindow);
                resolve();
            }, _this.config.system.pollIntervalMilliseconds);
        });
    };
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */
    PopupClient.prototype.openPopup = function (urlNavigate, popupParams) {
        try {
            var popupWindow = void 0;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii("Navigating popup window to: " + urlNavigate);
                popupWindow.location.assign(urlNavigate);
            }
            else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii("Opening popup window to: " + urlNavigate);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams.popupName, popupParams.popupWindowAttributes);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) {
                throw __WEBPACK_IMPORTED_MODULE_8__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createEmptyWindowCreatedError();
            }
            if (popupWindow.focus) {
                popupWindow.focus();
            }
            this.currentWindow = popupWindow;
            window.addEventListener("beforeunload", this.unloadWindow);
            return popupWindow;
        }
        catch (e) {
            this.logger.error("error opening popup " + e.message);
            this.browserStorage.setInteractionInProgress(false);
            throw __WEBPACK_IMPORTED_MODULE_8__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createPopupWindowError(e.toString());
        }
    };
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */
    PopupClient.prototype.openSizedPopup = function (urlNavigate, popupName, popupWindowAttributes) {
        var _a, _b, _c, _d;
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */
        var winLeft = window.screenLeft ? window.screenLeft : window.screenX;
        var winTop = window.screenTop ? window.screenTop : window.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */
        var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        var width = (_a = popupWindowAttributes.popupSize) === null || _a === void 0 ? void 0 : _a.width;
        var height = (_b = popupWindowAttributes.popupSize) === null || _b === void 0 ? void 0 : _b.height;
        var top = (_c = popupWindowAttributes.popupPosition) === null || _c === void 0 ? void 0 : _c.top;
        var left = (_d = popupWindowAttributes.popupPosition) === null || _d === void 0 ? void 0 : _d.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("Default popup window width used. Window width not configured or invalid.");
            width = __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["c" /* BrowserConstants */].POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("Default popup window height used. Window height not configured or invalid.");
            height = __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["c" /* BrowserConstants */].POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("Default popup window top position used. Window top not configured or invalid.");
            top = Math.max(0, ((winHeight / 2) - (__WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["c" /* BrowserConstants */].POPUP_HEIGHT / 2)) + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("Default popup window left position used. Window left not configured or invalid.");
            left = Math.max(0, ((winWidth / 2) - (__WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["c" /* BrowserConstants */].POPUP_WIDTH / 2)) + winLeft);
        }
        return window.open(urlNavigate, popupName, "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left + ", scrollbars=yes");
    };
    /**
     * Event callback to unload main window.
     */
    PopupClient.prototype.unloadWindow = function (e) {
        this.browserStorage.cleanRequestByInteractionType(__WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Popup);
        if (this.currentWindow) {
            this.currentWindow.close();
        }
        // Guarantees browser unload will happen, so no other errors will be thrown.
        e.preventDefault();
    };
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     */
    PopupClient.prototype.cleanPopup = function (popupWindow) {
        if (popupWindow) {
            // Close window.
            popupWindow.close();
        }
        // Remove window unload function
        window.removeEventListener("beforeunload", this.unloadWindow);
        // Interaction is completed - remove interaction status.
        this.browserStorage.setInteractionInProgress(false);
    };
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */
    PopupClient.prototype.generatePopupName = function (scopes, authority) {
        return __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["c" /* BrowserConstants */].POPUP_NAME_PREFIX + "." + this.config.auth.clientId + "." + scopes.join("-") + "." + authority + "." + this.correlationId;
    };
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */
    PopupClient.prototype.generateLogoutPopupName = function (request) {
        var homeAccountId = request.account && request.account.homeAccountId;
        return __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["c" /* BrowserConstants */].POPUP_NAME_PREFIX + "." + this.config.auth.clientId + "." + homeAccountId + "." + this.correlationId;
    };
    return PopupClient;
}(__WEBPACK_IMPORTED_MODULE_2__StandardInteractionClient_js__["a" /* StandardInteractionClient */]));


//# sourceMappingURL=PopupClient.js.map


/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SilentIframeClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StandardInteractionClient_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interaction_handler_SilentHandler_js__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__broker_nativeBroker_NativeMessageHandler_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NativeInteractionClient_js__ = __webpack_require__(298);
/*! @azure/msal-browser v2.38.3 2023-10-27 */










/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var SilentIframeClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(SilentIframeClient, _super);
    function SilentIframeClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        _this.apiId = apiId;
        _this.nativeStorage = nativeStorageImpl;
        return _this;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */
    SilentIframeClient.prototype.acquireToken = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var acquireTokenMeasurement, silentRequest, serverTelemetryManager, authClient, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].SilentIframeClientAcquireToken, request.correlationId);
                        this.logger.verbose("acquireTokenByIframe called");
                        acquireTokenMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].SilentIframeClientAcquireToken, request.correlationId);
                        // Check that we have some SSO data
                        if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(request.loginHint) && __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(request.sid) && (!request.account || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(request.account.username))) {
                            this.logger.warning("No user hint provided. The authorization server may need more information to complete this request.");
                        }
                        // Check that prompt is set to none or no_session, throw error if it is set to anything else.
                        if (request.prompt && (request.prompt !== __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["L" /* PromptValue */].NONE) && (request.prompt !== __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["L" /* PromptValue */].NO_SESSION)) {
                            acquireTokenMeasurement.endMeasurement({
                                success: false
                            });
                            throw __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createSilentPromptValueError(request.prompt);
                        }
                        // Create silent request
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [4 /*yield*/, this.initializeAuthorizationRequest(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request), { prompt: request.prompt || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["L" /* PromptValue */].NONE }), __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Silent)];
                    case 1:
                        silentRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(silentRequest.state, silentRequest.nonce, silentRequest.authority, silentRequest.loginHint || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING, silentRequest.account || null);
                        serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        // Initialize the client
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientCreateAuthCodeClient, request.correlationId);
                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, silentRequest.authority, silentRequest.azureCloudOptions)];
                    case 3:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].SilentIframeClientTokenHelper, request.correlationId);
                        return [4 /*yield*/, this.silentTokenHelper(authClient, silentRequest).then(function (result) {
                                acquireTokenMeasurement.endMeasurement({
                                    success: true,
                                    fromCache: false,
                                    requestId: result.requestId
                                });
                                return result;
                            })];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5:
                        e_1 = _a.sent();
                        if (e_1 instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */]) {
                            e_1.setCorrelationId(this.correlationId);
                        }
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(silentRequest.state);
                        acquireTokenMeasurement.endMeasurement({
                            errorCode: e_1 instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */] && e_1.errorCode || undefined,
                            subErrorCode: e_1 instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */] && e_1.subError || undefined,
                            success: false
                        });
                        throw e_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */
    SilentIframeClient.prototype.logout = function () {
        // Synchronous so we must reject
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createSilentLogoutUnsupportedError());
    };
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */
    SilentIframeClient.prototype.silentTokenHelper = function (authClient, silentRequest) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var authCodeRequest, navigateUrl, silentHandler, msalFrame, hash, serverParams, state, nativeInteractionClient, userRequestState;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].SilentIframeClientTokenHelper, silentRequest.correlationId);
                        // Create auth code request and generate PKCE params
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientInitializeAuthorizationCodeRequest, silentRequest.correlationId);
                        return [4 /*yield*/, this.initializeAuthorizationCodeRequest(silentRequest)];
                    case 1:
                        authCodeRequest = _a.sent();
                        // Create authorize request url
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].GetAuthCodeUrl, silentRequest.correlationId);
                        return [4 /*yield*/, authClient.getAuthCodeUrl(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, silentRequest), { nativeBroker: __WEBPACK_IMPORTED_MODULE_6__broker_nativeBroker_NativeMessageHandler_js__["a" /* NativeMessageHandler */].isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, silentRequest.authenticationScheme) }))];
                    case 2:
                        navigateUrl = _a.sent();
                        silentHandler = new __WEBPACK_IMPORTED_MODULE_5__interaction_handler_SilentHandler_js__["a" /* SilentHandler */](authClient, this.browserStorage, authCodeRequest, this.logger, this.config.system, this.performanceClient);
                        // Get the frame handle for the silent request
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].SilentHandlerInitiateAuthRequest, silentRequest.correlationId);
                        return [4 /*yield*/, silentHandler.initiateAuthRequest(navigateUrl)];
                    case 3:
                        msalFrame = _a.sent();
                        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].SilentHandlerMonitorIframeForHash, silentRequest.correlationId);
                        return [4 /*yield*/, silentHandler.monitorIframeForHash(msalFrame, this.config.system.iframeHashTimeout)];
                    case 4:
                        hash = _a.sent();
                        serverParams = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].getDeserializedHash(hash);
                        state = this.validateAndExtractStateFromHash(serverParams, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, authCodeRequest.correlationId);
                        if (serverParams.accountId) {
                            this.logger.verbose("Account id found in hash, calling WAM for token");
                            if (!this.nativeMessageHandler) {
                                throw __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNativeConnectionNotEstablishedError();
                            }
                            nativeInteractionClient = new __WEBPACK_IMPORTED_MODULE_7__NativeInteractionClient_js__["a" /* NativeInteractionClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.apiId, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.browserStorage, this.correlationId);
                            userRequestState = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["N" /* ProtocolUtils */].parseRequestState(this.browserCrypto, state).userRequestState;
                            return [2 /*return*/, nativeInteractionClient.acquireToken(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, silentRequest), { state: userRequestState, prompt: silentRequest.prompt || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["L" /* PromptValue */].NONE })).finally(function () {
                                    _this.browserStorage.cleanRequestByState(state);
                                })];
                        }
                        // Handle response from hash string
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].HandleCodeResponseFromHash, silentRequest.correlationId);
                        return [2 /*return*/, silentHandler.handleCodeResponseFromHash(hash, state, authClient.authority, this.networkClient)];
                }
            });
        });
    };
    return SilentIframeClient;
}(__WEBPACK_IMPORTED_MODULE_2__StandardInteractionClient_js__["a" /* StandardInteractionClient */]));


//# sourceMappingURL=SilentIframeClient.js.map


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SilentHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InteractionHandler_js__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_Configuration_js__ = __webpack_require__(583);
/*! @azure/msal-browser v2.38.3 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var SilentHandler = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(SilentHandler, _super);
    function SilentHandler(authCodeModule, storageImpl, authCodeRequest, logger, systemOptions, performanceClient) {
        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest, logger, performanceClient) || this;
        _this.navigateFrameWait = systemOptions.navigateFrameWait;
        _this.pollIntervalMilliseconds = systemOptions.pollIntervalMilliseconds;
        return _this;
    }
    /**
     * Creates a hidden iframe to given URL using user-requested scopes as an id.
     * @param urlNavigate
     * @param userRequestScopes
     */
    SilentHandler.prototype.initiateAuthRequest = function (requestUrl) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].SilentHandlerInitiateAuthRequest, this.authCodeRequest.correlationId);
                        if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(requestUrl)) {
                            // Throw error if request URL is empty.
                            this.logger.info("Navigate url is empty");
                            throw __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createEmptyNavigationUriError();
                        }
                        if (!this.navigateFrameWait) return [3 /*break*/, 2];
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].SilentHandlerLoadFrame, this.authCodeRequest.correlationId);
                        return [4 /*yield*/, this.loadFrame(requestUrl)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, this.loadFrameSync(requestUrl)];
                }
            });
        });
    };
    /**
     * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
     * @param iframe
     * @param timeout
     */
    SilentHandler.prototype.monitorIframeForHash = function (iframe, timeout) {
        var _this = this;
        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].SilentHandlerMonitorIframeForHash, this.authCodeRequest.correlationId);
        return new Promise(function (resolve, reject) {
            if (timeout < __WEBPACK_IMPORTED_MODULE_4__config_Configuration_js__["a" /* DEFAULT_IFRAME_TIMEOUT_MS */]) {
                _this.logger.warning("system.loadFrameTimeout or system.iframeHashTimeout set to lower (" + timeout + "ms) than the default (" + __WEBPACK_IMPORTED_MODULE_4__config_Configuration_js__["a" /* DEFAULT_IFRAME_TIMEOUT_MS */] + "ms). This may result in timeouts.");
            }
            /*
             * Polling for iframes can be purely timing based,
             * since we don't need to account for interaction.
             */
            var nowMark = window.performance.now();
            var timeoutMark = nowMark + timeout;
            var intervalId = setInterval(function () {
                if (window.performance.now() > timeoutMark) {
                    _this.removeHiddenIframe(iframe);
                    clearInterval(intervalId);
                    reject(__WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createMonitorIframeTimeoutError());
                    return;
                }
                var href = __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                var contentWindow = iframe.contentWindow;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */
                    href = contentWindow ? contentWindow.location.href : __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                }
                catch (e) { }
                if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["W" /* StringUtils */].isEmpty(href)) {
                    return;
                }
                var contentHash = contentWindow ? contentWindow.location.hash : __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                if (__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["_2" /* UrlString */].hashContainsKnownProperties(contentHash)) {
                    // Success case
                    _this.removeHiddenIframe(iframe);
                    clearInterval(intervalId);
                    resolve(contentHash);
                    return;
                }
            }, _this.pollIntervalMilliseconds);
        });
    };
    /**
     * @hidden
     * Loads iframe with authorization endpoint URL
     * @ignore
     */
    SilentHandler.prototype.loadFrame = function (urlNavigate) {
        var _this = this;
        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].SilentHandlerLoadFrame, this.authCodeRequest.correlationId);
        /*
         * This trick overcomes iframe navigation in IE
         * IE does not load the page consistently in iframe
         */
        return new Promise(function (resolve, reject) {
            var frameHandle = _this.createHiddenIframe();
            setTimeout(function () {
                if (!frameHandle) {
                    reject("Unable to load iframe");
                    return;
                }
                frameHandle.src = urlNavigate;
                resolve(frameHandle);
            }, _this.navigateFrameWait);
        });
    };
    /**
     * @hidden
     * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
     * @param urlNavigate
     * @param frameName
     * @param logger
     */
    SilentHandler.prototype.loadFrameSync = function (urlNavigate) {
        var frameHandle = this.createHiddenIframe();
        frameHandle.src = urlNavigate;
        return frameHandle;
    };
    /**
     * @hidden
     * Creates a new hidden iframe or gets an existing one for silent token renewal.
     * @ignore
     */
    SilentHandler.prototype.createHiddenIframe = function () {
        var authFrame = document.createElement("iframe");
        authFrame.style.visibility = "hidden";
        authFrame.style.position = "absolute";
        authFrame.style.width = authFrame.style.height = "0";
        authFrame.style.border = "0";
        authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
        document.getElementsByTagName("body")[0].appendChild(authFrame);
        return authFrame;
    };
    /**
     * @hidden
     * Removes a hidden iframe from the page.
     * @ignore
     */
    SilentHandler.prototype.removeHiddenIframe = function (iframe) {
        if (document.body === iframe.parentNode) {
            document.body.removeChild(iframe);
        }
    };
    return SilentHandler;
}(__WEBPACK_IMPORTED_MODULE_2__InteractionHandler_js__["a" /* InteractionHandler */]));


//# sourceMappingURL=SilentHandler.js.map


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NavigationClient; });
/*! @azure/msal-browser v2.38.3 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var NavigationClient = /** @class */ (function () {
    function NavigationClient() {
    }
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */
    NavigationClient.prototype.navigateInternal = function (url, options) {
        return NavigationClient.defaultNavigateWindow(url, options);
    };
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */
    NavigationClient.prototype.navigateExternal = function (url, options) {
        return NavigationClient.defaultNavigateWindow(url, options);
    };
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */
    NavigationClient.defaultNavigateWindow = function (url, options) {
        if (options.noHistory) {
            window.location.replace(url);
        }
        else {
            window.location.assign(url);
        }
        return new Promise(function (resolve) {
            setTimeout(function () {
                resolve(true);
            }, options.timeout);
        });
    };
    return NavigationClient;
}());


//# sourceMappingURL=NavigationClient.js.map


/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SilentRefreshClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StandardInteractionClient_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_BrowserAuthError_js__ = __webpack_require__(49);
/*! @azure/msal-browser v2.38.3 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var SilentRefreshClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(SilentRefreshClient, _super);
    function SilentRefreshClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */
    SilentRefreshClient.prototype.acquireToken = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var silentRequest, _a, acquireTokenMeasurement, serverTelemetryManager, refreshTokenClient;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].SilentRefreshClientAcquireToken, request.correlationId);
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].InitializeBaseRequest, request.correlationId);
                        _a = [Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request)];
                        return [4 /*yield*/, this.initializeBaseRequest(request, request.account)];
                    case 1:
                        silentRequest = __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */].apply(void 0, _a.concat([_b.sent()]));
                        acquireTokenMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].SilentRefreshClientAcquireToken, silentRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager(__WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenSilent_silentFlow);
                        return [4 /*yield*/, this.createRefreshTokenClient(serverTelemetryManager, silentRequest.authority, silentRequest.azureCloudOptions)];
                    case 2:
                        refreshTokenClient = _b.sent();
                        this.logger.verbose("Refresh token client created");
                        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
                        return [2 /*return*/, refreshTokenClient.acquireTokenByRefreshToken(silentRequest)
                                .then(function (result) {
                                acquireTokenMeasurement.endMeasurement({
                                    success: true,
                                    fromCache: result.fromCache,
                                    requestId: result.requestId
                                });
                                return result;
                            })
                                .catch(function (e) {
                                if (e instanceof __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["d" /* AuthError */]) {
                                    e.setCorrelationId(_this.correlationId);
                                }
                                serverTelemetryManager.cacheFailedRequest(e);
                                acquireTokenMeasurement.endMeasurement({
                                    errorCode: e.errorCode,
                                    subErrorCode: e.subError,
                                    success: false
                                });
                                throw e;
                            })];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */
    SilentRefreshClient.prototype.logout = function () {
        // Synchronous so we must reject
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_4__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createSilentLogoutUnsupportedError());
    };
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */
    SilentRefreshClient.prototype.createRefreshTokenClient = function (serverTelemetryManager, authorityUrl, azureCloudOptions) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var clientConfig;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Create auth module.
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientGetClientConfiguration, this.correlationId);
                        return [4 /*yield*/, this.getClientConfiguration(serverTelemetryManager, authorityUrl, azureCloudOptions)];
                    case 1:
                        clientConfig = _a.sent();
                        return [2 /*return*/, new __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["O" /* RefreshTokenClient */](clientConfig, this.performanceClient)];
                }
            });
        });
    };
    return SilentRefreshClient;
}(__WEBPACK_IMPORTED_MODULE_1__StandardInteractionClient_js__["a" /* StandardInteractionClient */]));


//# sourceMappingURL=SilentRefreshClient.js.map


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventType_js__ = __webpack_require__(212);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var EventHandler = /** @class */ (function () {
    function EventHandler(logger, browserCrypto) {
        this.eventCallbacks = new Map();
        this.logger = logger;
        this.browserCrypto = browserCrypto;
        this.listeningToStorageEvents = false;
        this.handleAccountCacheChange = this.handleAccountCacheChange.bind(this);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */
    EventHandler.prototype.addEventCallback = function (callback) {
        if (typeof window !== "undefined") {
            var callbackId = this.browserCrypto.createNewGuid();
            this.eventCallbacks.set(callbackId, callback);
            this.logger.verbose("Event callback registered with id: " + callbackId);
            return callbackId;
        }
        return null;
    };
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */
    EventHandler.prototype.removeEventCallback = function (callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose("Event callback " + callbackId + " removed.");
    };
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */
    EventHandler.prototype.enableAccountStorageEvents = function () {
        if (typeof window === "undefined") {
            return;
        }
        if (!this.listeningToStorageEvents) {
            this.logger.verbose("Adding account storage listener.");
            this.listeningToStorageEvents = true;
            window.addEventListener("storage", this.handleAccountCacheChange);
        }
        else {
            this.logger.verbose("Account storage listener already registered.");
        }
    };
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */
    EventHandler.prototype.disableAccountStorageEvents = function () {
        if (typeof window === "undefined") {
            return;
        }
        if (this.listeningToStorageEvents) {
            this.logger.verbose("Removing account storage listener.");
            window.removeEventListener("storage", this.handleAccountCacheChange);
            this.listeningToStorageEvents = false;
        }
        else {
            this.logger.verbose("No account storage listener registered.");
        }
    };
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */
    EventHandler.prototype.emitEvent = function (eventType, interactionType, payload, error) {
        var _this = this;
        if (typeof window !== "undefined") {
            var message_1 = {
                eventType: eventType,
                interactionType: interactionType || null,
                payload: payload || null,
                error: error || null,
                timestamp: Date.now()
            };
            this.logger.info("Emitting event: " + eventType);
            this.eventCallbacks.forEach(function (callback, callbackId) {
                _this.logger.verbose("Emitting event to callback " + callbackId + ": " + eventType);
                callback.apply(null, [message_1]);
            });
        }
    };
    /**
     * Emit account added/removed events when cached accounts are changed in a different tab or frame
     */
    EventHandler.prototype.handleAccountCacheChange = function (e) {
        try {
            var cacheValue = e.newValue || e.oldValue;
            if (!cacheValue) {
                return;
            }
            var parsedValue = JSON.parse(cacheValue);
            if (typeof parsedValue !== "object" || !__WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["b" /* AccountEntity */].isAccountEntity(parsedValue)) {
                return;
            }
            var accountEntity = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["o" /* CacheManager */].toObject(new __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["b" /* AccountEntity */](), parsedValue);
            var accountInfo = accountEntity.getAccountInfo();
            if (!e.oldValue && e.newValue) {
                this.logger.info("Account was added to cache in a different window");
                this.emitEvent(__WEBPACK_IMPORTED_MODULE_1__EventType_js__["a" /* EventType */].ACCOUNT_ADDED, undefined, accountInfo);
            }
            else if (!e.newValue && e.oldValue) {
                this.logger.info("Account was removed from cache in a different window");
                this.emitEvent(__WEBPACK_IMPORTED_MODULE_1__EventType_js__["a" /* EventType */].ACCOUNT_REMOVED, undefined, accountInfo);
            }
        }
        catch (e) {
            return;
        }
    };
    return EventHandler;
}());


//# sourceMappingURL=EventHandler.js.map


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuidGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__ = __webpack_require__(2747);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var GuidGenerator = /** @class */ (function () {
    function GuidGenerator(cryptoObj) {
        this.cryptoObj = cryptoObj;
    }
    /*
     * RFC4122: The version 4 UUID is meant for generating UUIDs from truly-random or
     * pseudo-random numbers.
     * The algorithm is as follows:
     *     Set the two most significant bits (bits 6 and 7) of the
     *        clock_seq_hi_and_reserved to zero and one, respectively.
     *     Set the four most significant bits (bits 12 through 15) of the
     *        time_hi_and_version field to the 4-bit version number from
     *        Section 4.1.3. Version4
     *     Set all the other bits to randomly (or pseudo-randomly) chosen
     *     values.
     * UUID                   = time-low "-" time-mid "-"time-high-and-version "-"clock-seq-reserved and low(2hexOctet)"-" node
     * time-low               = 4hexOctet
     * time-mid               = 2hexOctet
     * time-high-and-version  = 2hexOctet
     * clock-seq-and-reserved = hexOctet:
     * clock-seq-low          = hexOctet
     * node                   = 6hexOctet
     * Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
     * y could be 1000, 1001, 1010, 1011 since most significant two bits needs to be 10
     * y values are 8, 9, A, B
     */
    GuidGenerator.prototype.generateGuid = function () {
        try {
            var buffer = new Uint8Array(16);
            this.cryptoObj.getRandomValues(buffer);
            // buffer[6] and buffer[7] represents the time_hi_and_version field. We will set the four most significant bits (4 through 7) of buffer[6] to represent decimal number 4 (UUID version number).
            buffer[6] |= 0x40; // buffer[6] | 01000000 will set the 6 bit to 1.
            buffer[6] &= 0x4f; // buffer[6] & 01001111 will set the 4, 5, and 7 bit to 0 such that bits 4-7 == 0100 = "4".
            // buffer[8] represents the clock_seq_hi_and_reserved field. We will set the two most significant bits (6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively.
            buffer[8] |= 0x80; // buffer[8] | 10000000 will set the 7 bit to 1.
            buffer[8] &= 0xbf; // buffer[8] & 10111111 will set the 6 bit to 0.
            return __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[0]) + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[1])
                + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[2]) + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[3])
                + "-" + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[4]) + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[5])
                + "-" + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[6]) + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[7])
                + "-" + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[8]) + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[9])
                + "-" + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[10]) + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[11])
                + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[12]) + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[13])
                + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[14]) + __WEBPACK_IMPORTED_MODULE_1__utils_MathUtils_js__["a" /* MathUtils */].decimalToHex(buffer[15]);
        }
        catch (err) {
            var guidHolder = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
            var hex = "0123456789abcdef";
            var r = 0;
            var guidResponse = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
            for (var i = 0; i < 36; i++) {
                if (guidHolder[i] !== "-" && guidHolder[i] !== "4") {
                    // each x and y needs to be random
                    r = Math.random() * 16 | 0;
                }
                if (guidHolder[i] === "x") {
                    guidResponse += hex[r];
                }
                else if (guidHolder[i] === "y") {
                    // clock-seq-and-reserved first hex is filtered and remaining hex values are random
                    r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
                    r |= 0x8; // set pos 3 to 1 as 1???
                    guidResponse += hex[r];
                }
                else {
                    guidResponse += guidHolder[i];
                }
            }
            return guidResponse;
        }
    };
    /**
     * verifies if a string is  GUID
     * @param guid
     */
    GuidGenerator.prototype.isGuid = function (guid) {
        var regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return regexGuid.test(guid);
    };
    return GuidGenerator;
}());


//# sourceMappingURL=GuidGenerator.js.map


/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base64Encode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_BrowserStringUtils_js__ = __webpack_require__(300);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */
var Base64Encode = /** @class */ (function () {
    function Base64Encode() {
    }
    /**
     * Returns URL Safe b64 encoded string from a plaintext string.
     * @param input
     */
    Base64Encode.prototype.urlEncode = function (input) {
        return encodeURIComponent(this.encode(input)
            .replace(/=/g, __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING)
            .replace(/\+/g, "-")
            .replace(/\//g, "_"));
    };
    /**
     * Returns URL Safe b64 encoded string from an int8Array.
     * @param inputArr
     */
    Base64Encode.prototype.urlEncodeArr = function (inputArr) {
        return this.base64EncArr(inputArr)
            .replace(/=/g, __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING)
            .replace(/\+/g, "-")
            .replace(/\//g, "_");
    };
    /**
     * Returns b64 encoded string from plaintext string.
     * @param input
     */
    Base64Encode.prototype.encode = function (input) {
        var inputUtf8Arr = __WEBPACK_IMPORTED_MODULE_1__utils_BrowserStringUtils_js__["a" /* BrowserStringUtils */].stringToUtf8Arr(input);
        return this.base64EncArr(inputUtf8Arr);
    };
    /**
     * Base64 encode byte array
     * @param aBytes
     */
    Base64Encode.prototype.base64EncArr = function (aBytes) {
        var eqLen = (3 - (aBytes.length % 3)) % 3;
        var sB64Enc = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
        for (var nMod3 = void 0, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++) {
            nMod3 = nIdx % 3;
            /* Uncomment the following line in order to split the output in lines 76-character long: */
            /*
             *if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
             */
            nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);
            if (nMod3 === 2 || aBytes.length - nIdx === 1) {
                sB64Enc += String.fromCharCode(this.uint6ToB64(nUint24 >>> 18 & 63), this.uint6ToB64(nUint24 >>> 12 & 63), this.uint6ToB64(nUint24 >>> 6 & 63), this.uint6ToB64(nUint24 & 63));
                nUint24 = 0;
            }
        }
        return eqLen === 0 ? sB64Enc : sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? "=" : "==");
    };
    /**
     * Base64 string to array encoding helper
     * @param nUint6
     */
    Base64Encode.prototype.uint6ToB64 = function (nUint6) {
        return nUint6 < 26 ?
            nUint6 + 65
            : nUint6 < 52 ?
                nUint6 + 71
                : nUint6 < 62 ?
                    nUint6 - 4
                    : nUint6 === 62 ?
                        43
                        : nUint6 === 63 ?
                            47
                            :
                                65;
    };
    return Base64Encode;
}());


//# sourceMappingURL=Base64Encode.js.map


/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserCrypto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_BrowserStringUtils_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModernBrowserCrypto_js__ = __webpack_require__(2750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MsrBrowserCrypto_js__ = __webpack_require__(2751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MsBrowserCrypto_js__ = __webpack_require__(2752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_BrowserConfigurationAuthError_js__ = __webpack_require__(296);
/*! @azure/msal-browser v2.38.3 2023-10-27 */









/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */
// RSA KeyGen Algorithm
var PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
// SHA-256 hashing algorithm
var S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
var MODULUS_LENGTH = 2048;
// Public Exponent
var PUBLIC_EXPONENT = new Uint8Array([0x01, 0x00, 0x01]);
/**
 * This class implements functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */
var BrowserCrypto = /** @class */ (function () {
    function BrowserCrypto(logger, cryptoOptions) {
        var _a, _b;
        this.logger = logger;
        this.cryptoOptions = cryptoOptions;
        if (this.hasBrowserCrypto()) {
            // Use standard modern web crypto if available
            this.logger.verbose("BrowserCrypto: modern crypto interface available");
            this.subtleCrypto = new __WEBPACK_IMPORTED_MODULE_3__ModernBrowserCrypto_js__["a" /* ModernBrowserCrypto */]();
        }
        else if (this.hasIECrypto()) {
            // For IE11, use msCrypto interface
            this.logger.verbose("BrowserCrypto: MS crypto interface available");
            this.subtleCrypto = new __WEBPACK_IMPORTED_MODULE_5__MsBrowserCrypto_js__["a" /* MsBrowserCrypto */]();
        }
        else if (this.hasMsrCrypto() && ((_a = this.cryptoOptions) === null || _a === void 0 ? void 0 : _a.useMsrCrypto)) {
            // For other browsers, use MSR Crypto if found
            this.logger.verbose("BrowserCrypto: MSR crypto interface available");
            this.subtleCrypto = new __WEBPACK_IMPORTED_MODULE_4__MsrBrowserCrypto_js__["a" /* MsrBrowserCrypto */]();
        }
        else {
            if (this.hasMsrCrypto()) {
                this.logger.info("BrowserCrypto: MSR Crypto interface available but system.cryptoOptions.useMsrCrypto not enabled");
            }
            this.logger.error("BrowserCrypto: No crypto interfaces available.");
            throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createCryptoNotAvailableError("Browser crypto, msCrypto, or msrCrypto interfaces not available.");
        }
        // Mainly needed for MSR Crypto: https://github.com/microsoft/MSR-JavaScript-Crypto#random-number-generator-prng
        if (this.subtleCrypto.initPrng) {
            this.logger.verbose("BrowserCrypto: Interface requires entropy");
            if (!((_b = this.cryptoOptions) === null || _b === void 0 ? void 0 : _b.entropy)) {
                this.logger.error("BrowserCrypto: Interface requires entropy but none provided.");
                throw __WEBPACK_IMPORTED_MODULE_6__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createEntropyNotProvided();
            }
            this.logger.verbose("BrowserCrypto: Entropy provided");
            this.subtleCrypto.initPrng(this.cryptoOptions.entropy);
        }
        this.keygenAlgorithmOptions = {
            name: PKCS1_V15_KEYGEN_ALG,
            hash: S256_HASH_ALG,
            modulusLength: MODULUS_LENGTH,
            publicExponent: PUBLIC_EXPONENT
        };
    }
    /**
     * Check whether IE crypto or other browser cryptography is available.
     */
    BrowserCrypto.prototype.hasIECrypto = function () {
        return "msCrypto" in window;
    };
    /**
     * Check whether browser crypto is available.
     */
    BrowserCrypto.prototype.hasBrowserCrypto = function () {
        return "crypto" in window;
    };
    /**
     * Check whether MSR crypto polyfill is available
     */
    BrowserCrypto.prototype.hasMsrCrypto = function () {
        return "msrCrypto" in window;
    };
    /**
     * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
     * @param dataString
     */
    BrowserCrypto.prototype.sha256Digest = function (dataString) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var data;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                data = __WEBPACK_IMPORTED_MODULE_1__utils_BrowserStringUtils_js__["a" /* BrowserStringUtils */].stringToUtf8Arr(dataString);
                // MSR Crypto wants object with name property, instead of string
                return [2 /*return*/, this.subtleCrypto.digest({ name: S256_HASH_ALG }, data)];
            });
        });
    };
    /**
     * Populates buffer with cryptographically random values.
     * @param dataBuffer
     */
    BrowserCrypto.prototype.getRandomValues = function (dataBuffer) {
        return this.subtleCrypto.getRandomValues(dataBuffer);
    };
    /**
     * Generates a keypair based on current keygen algorithm config.
     * @param extractable
     * @param usages
     */
    BrowserCrypto.prototype.generateKeyPair = function (extractable, usages) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.subtleCrypto.generateKey(this.keygenAlgorithmOptions, extractable, usages)];
            });
        });
    };
    /**
     * Export key as Json Web Key (JWK)
     * @param key
     * @param format
     */
    BrowserCrypto.prototype.exportJwk = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.subtleCrypto.exportKey(key)];
            });
        });
    };
    /**
     * Imports key as Json Web Key (JWK), can set extractable and usages.
     * @param key
     * @param format
     * @param extractable
     * @param usages
     */
    BrowserCrypto.prototype.importJwk = function (key, extractable, usages) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.subtleCrypto.importKey(key, this.keygenAlgorithmOptions, extractable, usages)];
            });
        });
    };
    /**
     * Signs given data with given key
     * @param key
     * @param data
     */
    BrowserCrypto.prototype.sign = function (key, data) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.subtleCrypto.sign(this.keygenAlgorithmOptions, key, data)];
            });
        });
    };
    return BrowserCrypto;
}());


//# sourceMappingURL=BrowserCrypto.js.map


/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserPerformanceClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__crypto_BrowserCrypto_js__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__crypto_GuidGenerator_js__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BrowserPerformanceMeasurement_js__ = __webpack_require__(1133);
/*! @azure/msal-browser v2.38.3 2023-10-27 */







/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var BrowserPerformanceClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(BrowserPerformanceClient, _super);
    function BrowserPerformanceClient(clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry, cryptoOptions) {
        var _this = _super.call(this, clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry) || this;
        _this.browserCrypto = new __WEBPACK_IMPORTED_MODULE_2__crypto_BrowserCrypto_js__["a" /* BrowserCrypto */](_this.logger, cryptoOptions);
        _this.guidGenerator = new __WEBPACK_IMPORTED_MODULE_3__crypto_GuidGenerator_js__["a" /* GuidGenerator */](_this.browserCrypto);
        return _this;
    }
    BrowserPerformanceClient.prototype.startPerformanceMeasuremeant = function (measureName, correlationId) {
        return new __WEBPACK_IMPORTED_MODULE_4__BrowserPerformanceMeasurement_js__["a" /* BrowserPerformanceMeasurement */](measureName, correlationId);
    };
    BrowserPerformanceClient.prototype.generateId = function () {
        return this.guidGenerator.generateGuid();
    };
    BrowserPerformanceClient.prototype.getPageVisibility = function () {
        var _a;
        return ((_a = document.visibilityState) === null || _a === void 0 ? void 0 : _a.toString()) || null;
    };
    BrowserPerformanceClient.prototype.deleteIncompleteSubMeasurements = function (inProgressEvent) {
        var rootEvent = this.eventsByCorrelationId.get(inProgressEvent.event.correlationId);
        var isRootEvent = rootEvent && rootEvent.eventId === inProgressEvent.event.eventId;
        var incompleteMeasurements = [];
        if (isRootEvent && (rootEvent === null || rootEvent === void 0 ? void 0 : rootEvent.incompleteSubMeasurements)) {
            rootEvent.incompleteSubMeasurements.forEach(function (subMeasurement) {
                incompleteMeasurements.push(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, subMeasurement));
            });
        }
        // Clean up remaining marks for incomplete sub-measurements
        if (incompleteMeasurements.length > 0) {
            __WEBPACK_IMPORTED_MODULE_4__BrowserPerformanceMeasurement_js__["a" /* BrowserPerformanceMeasurement */].flushMeasurements(inProgressEvent.event.correlationId, incompleteMeasurements);
        }
    };
    BrowserPerformanceClient.prototype.supportsBrowserPerformanceNow = function () {
        return typeof window !== "undefined" &&
            typeof window.performance !== "undefined" &&
            typeof window.performance.now === "function";
    };
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     * Also captures browser page visibilityState.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {((event?: Partial<PerformanceEvent>) => PerformanceEvent| null)}
     */
    BrowserPerformanceClient.prototype.startMeasurement = function (measureName, correlationId) {
        var _this = this;
        // Capture page visibilityState and then invoke start/end measurement
        var startPageVisibility = this.getPageVisibility();
        var inProgressEvent = _super.prototype.startMeasurement.call(this, measureName, correlationId);
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, inProgressEvent), { endMeasurement: function (event) {
                var res = inProgressEvent.endMeasurement(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({ startPageVisibility: startPageVisibility, endPageVisibility: _this.getPageVisibility() }, event));
                _this.deleteIncompleteSubMeasurements(inProgressEvent);
                return res;
            }, discardMeasurement: function () {
                inProgressEvent.discardMeasurement();
                _this.deleteIncompleteSubMeasurements(inProgressEvent);
                inProgressEvent.measurement.flushMeasurement();
            } });
    };
    /**
     * Adds pre-queue time to preQueueTimeByCorrelationId map.
     * @param {PerformanceEvents} eventName
     * @param {?string} correlationId
     * @returns
     */
    BrowserPerformanceClient.prototype.setPreQueueTime = function (eventName, correlationId) {
        if (!this.supportsBrowserPerformanceNow()) {
            this.logger.trace("BrowserPerformanceClient: window performance API not available, unable to set telemetry queue time for " + eventName);
            return;
        }
        if (!correlationId) {
            this.logger.trace("BrowserPerformanceClient: correlationId for " + eventName + " not provided, unable to set telemetry queue time");
            return;
        }
        var preQueueEvent = this.preQueueTimeByCorrelationId.get(correlationId);
        /**
         * Manually complete queue measurement if there is an incomplete pre-queue event.
         * Incomplete pre-queue events are instrumentation bugs that should be fixed.
         */
        if (preQueueEvent) {
            this.logger.trace("BrowserPerformanceClient: Incomplete pre-queue " + preQueueEvent.name + " found", correlationId);
            this.addQueueMeasurement(preQueueEvent.name, correlationId, undefined, true);
        }
        this.preQueueTimeByCorrelationId.set(correlationId, { name: eventName, time: window.performance.now() });
    };
    /**
     * Calculates and adds queue time measurement for given performance event.
     *
     * @param {PerformanceEvents} eventName
     * @param {?string} correlationId
     * @param {?number} queueTime
     * @param {?boolean} manuallyCompleted - indicator for manually completed queue measurements
     * @returns
     */
    BrowserPerformanceClient.prototype.addQueueMeasurement = function (eventName, correlationId, queueTime, manuallyCompleted) {
        if (!this.supportsBrowserPerformanceNow()) {
            this.logger.trace("BrowserPerformanceClient: window performance API not available, unable to add queue measurement for " + eventName);
            return;
        }
        if (!correlationId) {
            this.logger.trace("BrowserPerformanceClient: correlationId for " + eventName + " not provided, unable to add queue measurement");
            return;
        }
        var preQueueTime = _super.prototype.getPreQueueTime.call(this, eventName, correlationId);
        if (!preQueueTime) {
            return;
        }
        var currentTime = window.performance.now();
        var resQueueTime = queueTime || _super.prototype.calculateQueuedTime.call(this, preQueueTime, currentTime);
        return _super.prototype.addQueueMeasurement.call(this, eventName, correlationId, resQueueTime, manuallyCompleted);
    };
    return BrowserPerformanceClient;
}(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["H" /* PerformanceClient */]));


//# sourceMappingURL=BrowserPerformanceClient.js.map


/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserPerformanceMeasurement; });
/*! @azure/msal-browser v2.38.3 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var BrowserPerformanceMeasurement = /** @class */ (function () {
    function BrowserPerformanceMeasurement(name, correlationId) {
        this.correlationId = correlationId;
        this.measureName = BrowserPerformanceMeasurement.makeMeasureName(name, correlationId);
        this.startMark = BrowserPerformanceMeasurement.makeStartMark(name, correlationId);
        this.endMark = BrowserPerformanceMeasurement.makeEndMark(name, correlationId);
    }
    BrowserPerformanceMeasurement.makeMeasureName = function (name, correlationId) {
        return "msal.measure." + name + "." + correlationId;
    };
    BrowserPerformanceMeasurement.makeStartMark = function (name, correlationId) {
        return "msal.start." + name + "." + correlationId;
    };
    BrowserPerformanceMeasurement.makeEndMark = function (name, correlationId) {
        return "msal.end." + name + "." + correlationId;
    };
    BrowserPerformanceMeasurement.supportsBrowserPerformance = function () {
        return typeof window !== "undefined" &&
            typeof window.performance !== "undefined" &&
            typeof window.performance.mark === "function" &&
            typeof window.performance.measure === "function" &&
            typeof window.performance.clearMarks === "function" &&
            typeof window.performance.clearMeasures === "function" &&
            typeof window.performance.getEntriesByName === "function";
    };
    /**
     * Flush browser marks and measurements.
     * @param {string} correlationId
     * @param {SubMeasurement} measurements
     */
    BrowserPerformanceMeasurement.flushMeasurements = function (correlationId, measurements) {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) {
            try {
                measurements.forEach(function (measurement) {
                    var measureName = BrowserPerformanceMeasurement.makeMeasureName(measurement.name, correlationId);
                    var entriesForMeasurement = window.performance.getEntriesByName(measureName, "measure");
                    if (entriesForMeasurement.length > 0) {
                        window.performance.clearMeasures(measureName);
                        window.performance.clearMarks(BrowserPerformanceMeasurement.makeStartMark(measureName, correlationId));
                        window.performance.clearMarks(BrowserPerformanceMeasurement.makeEndMark(measureName, correlationId));
                    }
                });
            }
            catch (e) {
                // Silently catch and return null
            }
        }
    };
    BrowserPerformanceMeasurement.prototype.startMeasurement = function () {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) {
            try {
                window.performance.mark(this.startMark);
            }
            catch (e) {
                // Silently catch
            }
        }
    };
    BrowserPerformanceMeasurement.prototype.endMeasurement = function () {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) {
            try {
                window.performance.mark(this.endMark);
                window.performance.measure(this.measureName, this.startMark, this.endMark);
            }
            catch (e) {
                // Silently catch
            }
        }
    };
    BrowserPerformanceMeasurement.prototype.flushMeasurement = function () {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) {
            try {
                var entriesForMeasurement = window.performance.getEntriesByName(this.measureName, "measure");
                if (entriesForMeasurement.length > 0) {
                    var durationMs = entriesForMeasurement[0].duration;
                    window.performance.clearMeasures(this.measureName);
                    window.performance.clearMarks(this.startMark);
                    window.performance.clearMarks(this.endMark);
                    return durationMs;
                }
            }
            catch (e) {
                // Silently catch and return null
            }
        }
        return null;
    };
    return BrowserPerformanceMeasurement;
}());


//# sourceMappingURL=BrowserPerformanceMeasurement.js.map


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(105);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(316),
    getPrototype = __webpack_require__(421),
    getSymbols = __webpack_require__(437),
    stubArray = __webpack_require__(765);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(586);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(2857),
    getPrototype = __webpack_require__(421),
    isPrototype = __webpack_require__(308);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(423),
    eq = __webpack_require__(249);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 1139 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.19
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.19',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            //var result = {},
            var i = 0, j, k, p, q, matches, match;//, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edga)\/((\d+)?[\w\.]+)/i                              // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /(focus)\/([\w\.]+)/i                                               // Firefox Focus
            ], [[NAME, 'Firefox Focus'], VERSION], [

            /(opt)\/([\w\.]+)/i                                                 // Opera Touch
            ], [[NAME, 'Opera Touch'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(brave)\/([\w\.]+)/i                                              // Brave browser
            ], [[NAME, 'Brave'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
            /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
            ], [NAME, VERSION], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            /android.+aft([bms])\sbuild/i                                       // Fire TV
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel( [23])?( xl)?)\s/i                              // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [
            /(mz)-([\w-]{2,})/i                                                 // Meizu Phone
            ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+;\s(PH-1)\s/i
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };
    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(893)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return UAParser;
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 1141 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(82);
var isObject = __webpack_require__(40);
var invoke = __webpack_require__(1023);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(34).parseInt;
var $trim = __webpack_require__(244).trim;
var ws = __webpack_require__(588);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(34).parseFloat;
var $trim = __webpack_require__(244).trim;

module.exports = 1 / $parseFloat(__webpack_require__(588) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(109);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 1146 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(590);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(82);
var toObject = __webpack_require__(64);
var IObject = __webpack_require__(275);
var toLength = __webpack_require__(55);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(64);
var toAbsoluteIndex = __webpack_require__(193);
var toLength = __webpack_require__(55);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(593);
__webpack_require__(3)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(56) && /./g.flags != 'g') __webpack_require__(61).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(301)
});


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(953);
var validate = __webpack_require__(198);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(362)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(107);
var toLength = __webpack_require__(55);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(199);
var gOPS = __webpack_require__(366);
var anObject = __webpack_require__(29);
var Reflect = __webpack_require__(34).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(360);
var isObject = __webpack_require__(40);
var toLength = __webpack_require__(55);
var ctx = __webpack_require__(108);
var IS_CONCAT_SPREADABLE = __webpack_require__(52)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(55);
var repeat = __webpack_require__(589);
var defined = __webpack_require__(123);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 1158 */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1160);
__webpack_require__(1161);
module.exports = __webpack_require__(2908);


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE={id:"gamba-web@202507040022"};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = __webpack_require__(245);

var _reactRouterRedux = __webpack_require__(415);

var _reactHotLoader = __webpack_require__(1194);

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _reduxMediaquery = __webpack_require__(618);

__webpack_require__(1232);

var _i18n = __webpack_require__(173);

var _i18n2 = _interopRequireDefault(_i18n);

var _configureStore = __webpack_require__(1247);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _routes = __webpack_require__(748);

var _routes2 = _interopRequireDefault(_routes);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

__webpack_require__(2896);

var _smartAppBanner = __webpack_require__(2898);

var _smartAppBanner2 = _interopRequireDefault(_smartAppBanner);

var _outdatedBrowserRework = __webpack_require__(2903);

var _outdatedBrowserRework2 = _interopRequireDefault(_outdatedBrowserRework);

__webpack_require__(2906);

var _react3 = __webpack_require__(981);

var Sentry = _interopRequireWildcard(_react3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/web/index.jsx

var store = (0, _configureStore2.default)(_reactRouter.hashHistory);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.hashHistory, store);

/* 
 * -----------Sentryの初期化-----------
 * dsn: sentryの設定用データ
 * environment: production/staging/(developmment),
 * enableAutoSessionTracking: リリースの状態監視 使用状況/クラッシュの割合など
 * sessionTrackingIntervalMillis: セッションの開始・終了のトラッキング　デフォルトは30秒
 * debug: デバッグモード(Sentry log 出力)
 */
"production" == 'production' && Sentry.init({
  dsn: _config2.default.sentry.dsn,
  release: 'gamba-web@' + "202507040022",
  enableAutoSessionTracking: true,
  sessionTrackingIntervalMillis: 30000,
  debug: false
});

(0, _outdatedBrowserRework2.default)({
  messages: {
    ja: {
      outOfDate: "最新のWebブラウザをインストールしてください。",
      unsupported: "最新のWebブラウザをインストールしてください。",
      update: {
        web: "お客様の環境では一部機能が動作しない可能性があります。",
        googlePlay: "Google PlayよりChromeブラウザをインストールしてください。",
        appStore: "設定アプリよりiOSのバージョンを最新版にアップデートしてください。"
      },
      url: "http://outdatedbrowser.com/ja",
      callToAction: "最新のWebブラウザをインストールする",
      close: "閉じる"
    }
  }
});

var unlisten = (0, _reduxMediaquery.mediaQueryTracker)({
  isPhone: "screen and (max-width: 767px)",
  innerWidth: true,
  innerHeight: true
}, store.dispatch);

store.dispatch((0, _reduxMediaquery.mediaQueryTracker)({
  isPhone: "screen and (max-width: 767px)",
  innerWidth: true,
  innerHeight: true
}));

document.ondragover = function (e) {
  e.preventDefault();return false;
};
document.ondrop = function (e) {
  e.preventDefault();return false;
};

new _smartAppBanner2.default({
  title: _i18n2.default.t('label:gamba'),
  author: _i18n2.default.t('label:株式会社gamba'),
  button: _i18n2.default.t('label:ダウンロード'),
  store: {
    ios: 'App Store',
    android: 'Google Play'
  },
  price: {
    ios: _i18n2.default.t('label:無料'),
    android: _i18n2.default.t('label:無料')
  }
});

var render = function render() {
  var lang_param = document.location.search && document.location.search.match(/lang=([a-z][a-z])/);
  var language = lang_param ? lang_param[1] : navigator.language.replace(/-[a-zA-Z]+$/, '');
  _i18n2.default.changeLanguage(language, function () {
    return _reactDom2.default.render(_react2.default.createElement(
      _reactHotLoader.AppContainer,
      null,
      _react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(
          _reactI18next.I18nextProvider,
          { i18n: _i18n2.default },
          _react2.default.createElement(_reactRouter.Router, { history: history, routes: _routes2.default })
        )
      )
    ), document.querySelector("#app"));
  });
};

render();

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(80),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(80),r=__webpack_require__(1164);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1165);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(213);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var ReactPropTypesSecret = __webpack_require__(1168);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(214);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(407);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(214);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(597);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(156);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(214);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(599);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(410);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(246);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(246);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(246);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(598);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1182);
var objectAssign = __webpack_require__(80);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(137);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(77);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(215);

var _PathUtils = __webpack_require__(157);

var _createHistory = __webpack_require__(412);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(304);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(213);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(606);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(77);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(413);

var _BrowserProtocol = __webpack_require__(414);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(1188);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(305);

var _createHistory = __webpack_require__(412);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(414);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(215);

var _PathUtils = __webpack_require__(157);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(606);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(137);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(77);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(413);

var _DOMUtils = __webpack_require__(305);

var _HashProtocol = __webpack_require__(1191);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(412);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(414);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(137);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(215);

var _DOMUtils = __webpack_require__(305);

var _DOMStateStorage = __webpack_require__(605);

var _PathUtils = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(607);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(608);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1195);


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */



if (true) {
  module.exports = __webpack_require__(1196);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(1197);

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */



if (true) {
  module.exports = __webpack_require__(1198);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable react/prop-types */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(416);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var ReactPropTypesSecret = __webpack_require__(1201);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(1223);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(616);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1211);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(1209);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(613);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1213);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1216);


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(1217);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(103)(module)))

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(614);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(615);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(616);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(617);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(1224);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(416);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = translate;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(303);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

var removedIsInitialSSR = false;

function translate(namespaces) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef,
      _options$bindI18n = options.bindI18n,
      bindI18n = _options$bindI18n === undefined ? 'languageChanged loaded' : _options$bindI18n,
      _options$bindStore = options.bindStore,
      bindStore = _options$bindStore === undefined ? 'added removed' : _options$bindStore,
      _options$translateFun = options.translateFuncName,
      translateFuncName = _options$translateFun === undefined ? 't' : _options$translateFun;
  var _options$wait = options.wait,
      wait = _options$wait === undefined ? false : _options$wait;


  return function Wrapper(WrappedComponent) {
    var _Translate$childConte;

    var Translate = function (_Component) {
      _inherits(Translate, _Component);

      function Translate(props, context) {
        _classCallCheck(this, Translate);

        var _this = _possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).call(this, props, context));

        _this.i18n = context.i18n || props.i18n || options.i18n;
        namespaces = namespaces || _this.i18n.options.defaultNS;
        if (typeof namespaces === 'string') namespaces = [namespaces];

        if (!wait && _this.i18n.options && (_this.i18n.options.wait || _this.i18n.options.react && _this.i18n.options.react.wait)) wait = true;

        _this.nsMode = options.nsMode || _this.i18n.options && _this.i18n.options.react && _this.i18n.options.react.nsMode || 'default';

        // nextjs SSR: getting data from next.js or other ssr stack
        if (props.initialI18nStore) {
          _this.i18n.services.resourceStore.data = props.initialI18nStore;
          wait = false; // we got all passed down already
        }
        if (props.initialLanguage) {
          _this.i18n.changeLanguage(props.initialLanguage);
        }

        // provider SSR: data was set in provider and ssr flag was set
        if (_this.i18n.options.isInitialSSR) {
          wait = false;
        }

        _this.state = {
          i18nLoadedAt: null,
          ready: false
        };

        _this.onI18nChanged = _this.onI18nChanged.bind(_this);
        _this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
        return _this;
      }

      _createClass(Translate, [{
        key: 'getChildContext',
        value: function getChildContext() {
          var _ref;

          return _ref = {}, _defineProperty(_ref, translateFuncName, this[translateFuncName]), _defineProperty(_ref, 'i18n', this.i18n), _ref;
        }
      }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
          this[translateFuncName] = this.i18n.getFixedT(null, this.nsMode === 'fallback' ? namespaces : namespaces[0]);
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          var bind = function bind() {
            if (bindI18n && _this2.i18n) _this2.i18n.on(bindI18n, _this2.onI18nChanged);
            if (bindStore && _this2.i18n.store) _this2.i18n.store.on(bindStore, _this2.onI18nChanged);
          };

          this.mounted = true;
          this.i18n.loadNamespaces(namespaces, function () {
            var ready = function ready() {
              if (_this2.mounted && !_this2.state.ready) _this2.setState({ ready: true });
              if (wait && _this2.mounted) bind();
            };

            if (_this2.i18n.isInitialized) {
              ready();
            } else {
              var initialized = function initialized() {
                // due to emitter removing issue in i18next we need to delay remove
                setTimeout(function () {
                  _this2.i18n.off('initialized', initialized);
                }, 1000);
                ready();
              };

              _this2.i18n.on('initialized', initialized);
            }
          });

          if (!wait) bind();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this3 = this;

          this.mounted = false;
          if (this.onI18nChanged) {
            if (bindI18n) {
              var p = bindI18n.split(' ');
              p.forEach(function (f) {
                return _this3.i18n.off(f, _this3.onI18nChanged);
              });
            }
            if (bindStore) {
              var _p = bindStore.split(' ');
              _p.forEach(function (f) {
                return _this3.i18n.store && _this3.i18n.store.off(f, _this3.onI18nChanged);
              });
            }
          }
        }
      }, {
        key: 'onI18nChanged',
        value: function onI18nChanged() {
          if (!this.mounted) return;

          this.setState({ i18nLoadedAt: new Date() });
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          if (!withRef) {
            // eslint-disable-next-line no-console
            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
          }

          /* eslint react/no-string-refs: 1 */
          return this.refs.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _extraProps,
              _this4 = this;

          var _state = this.state,
              i18nLoadedAt = _state.i18nLoadedAt,
              ready = _state.ready;

          var extraProps = (_extraProps = {
            i18nLoadedAt: i18nLoadedAt
          }, _defineProperty(_extraProps, translateFuncName, this[translateFuncName]), _defineProperty(_extraProps, 'i18n', this.i18n), _extraProps);

          if (withRef) {
            extraProps.ref = 'wrappedInstance';
          }

          if (!ready && wait) return null;

          // remove ssr flag set by provider - first render was done from now on wait if set to wait
          if (this.i18n.options.isInitialSSR && !removedIsInitialSSR) {
            removedIsInitialSSR = true;
            setTimeout(function () {
              delete _this4.i18n.options.isInitialSSR;
            }, 100);
          }

          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, extraProps));
        }
      }]);

      return Translate;
    }(_react.Component);

    Translate.WrappedComponent = WrappedComponent;

    Translate.contextTypes = {
      i18n: _propTypes2.default.object
    };

    Translate.childContextTypes = (_Translate$childConte = {}, _defineProperty(_Translate$childConte, translateFuncName, _propTypes2.default.func.isRequired), _defineProperty(_Translate$childConte, 'i18n', _propTypes2.default.object), _Translate$childConte);

    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';

    Translate.namespaces = namespaces;

    return (0, _hoistNonReactStatics2.default)(Translate, WrappedComponent);
  };
}

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1227);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Interpolate = function (_Component) {
  _inherits(Interpolate, _Component);

  function Interpolate(props, context) {
    _classCallCheck(this, Interpolate);

    var _this = _possibleConstructorReturn(this, (Interpolate.__proto__ || Object.getPrototypeOf(Interpolate)).call(this, props, context));

    _this.i18n = context.i18n;
    _this.t = context.t;
    return _this;
  }

  _createClass(Interpolate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
      var _props = this.props,
          className = _props.className,
          style = _props.style;

      // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = _extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
      var format = this.t(this.props.i18nKey, tOpts);

      if (!format || typeof format !== 'string') return _react2.default.createElement('noscript', null);

      var children = [];

      var handleFormat = function handleFormat(key, props) {
        if (key.indexOf(_this2.i18n.options.interpolation.formatSeparator) < 0) {
          if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + key + ' for interpolating ' + format);
          return props[key];
        }

        var p = key.split(_this2.i18n.options.interpolation.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this2.i18n.options.interpolation.formatSeparator).trim();

        if (props[k] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + k + ' for interpolating ' + format);
        return _this2.i18n.options.interpolation.format(props[k], f, _this2.i18n.language);
      };

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child = void 0;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;
          if (useDangerouslySetInnerHTML) {
            child = _react2.default.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
          } else {
            child = match;
          }
        } else {
          child = handleFormat(match, _this2.props);
        }

        memo.push(child);
        return memo;
      }, children);

      var additionalProps = {};
      if (this.i18n.options.react && this.i18n.options.react.exposeNamespace) {
        var ns = typeof this.t.ns === 'string' ? this.t.ns : this.t.ns[0];
        if (this.props.i18nKey && this.i18n.options.nsSeparator && this.props.i18nKey.indexOf(this.i18n.options.nsSeparator) > -1) {
          var parts = this.props.i18nKey.split(this.i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (this.t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (className) additionalProps.className = className;
      if (style) additionalProps.style = style;

      return _react2.default.createElement.apply(this, [parent, additionalProps].concat(children));
    }
  }]);

  return Interpolate;
}(_react.Component);

Interpolate.propTypes = {
  className: _propTypes2.default.string
};

Interpolate.defaultProps = {
  className: ''
};

Interpolate.contextTypes = {
  i18n: _propTypes2.default.object.isRequired,
  t: _propTypes2.default.func.isRequired
};

exports.default = Interpolate;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  return node && node.children ? node.children : node.props && node.props.children;
}

function nodesToString(mem, children, index) {
  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];

  children.forEach(function (child, i) {
    // const isElement = React.isValidElement(child);
    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
    var elementKey = '' + i;

    if (typeof child === 'string') {
      mem = '' + mem + child;
    } else if (hasChildren(child)) {
      mem = mem + '<' + elementKey + '>' + nodesToString('', getChildren(child), i + 1) + '</' + elementKey + '>';
    } else if (_react2.default.isValidElement(child)) {
      mem = mem + '<' + elementKey + '></' + elementKey + '>';
    } else if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object') {
      var clone = _extends({}, child);
      var format = clone.format;
      delete clone.format;

      var keys = Object.keys(clone);
      if (format && keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + ', ' + format + '}}</' + elementKey + '>';
      } else if (keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + '}}</' + elementKey + '>';
      }
    }
  });

  return mem;
}

var REGEXP = new RegExp('(?:<([^>]*)>(.*?)<\\/\\1>)', 'gi');
function renderNodes(children, targetString, i18n) {

  function parseChildren(nodes, str) {
    if (Object.prototype.toString.call(nodes) !== '[object Array]') nodes = [nodes];

    var toRender = str.split(REGEXP).reduce(function (mem, match, i) {
      if (match) mem.push(match);
      return mem;
    }, []);

    return toRender.reduce(function (mem, part, i) {
      // is a tag
      var isTag = !isNaN(part);
      var previousIsTag = i > 0 ? !isNaN(toRender[i - 1]) : false;
      if (previousIsTag) {
        var child = nodes[parseInt(toRender[i - 1], 10)] || {};
        if (_react2.default.isValidElement(child) && !hasChildren(child)) previousIsTag = false;
      }

      // will be rendered inside child
      if (previousIsTag) return mem;

      if (isTag) {
        var _child = nodes[parseInt(part, 10)] || {};
        var isElement = _react2.default.isValidElement(_child);

        if (typeof _child === 'string') {
          mem.push(_child);
        } else if (hasChildren(_child)) {
          var inner = parseChildren(getChildren(_child), toRender[i + 1]);

          mem.push(_react2.default.cloneElement(_child, _extends({}, _child.props, { key: i }), inner));
        } else if ((typeof _child === 'undefined' ? 'undefined' : _typeof(_child)) === 'object' && !isElement) {
          var interpolated = i18n.services.interpolator.interpolate(toRender[i + 1], _child, i18n.language);
          mem.push(interpolated);
        } else {
          mem.push(_child);
        }
      }

      // no element just a string
      if (!isTag && !previousIsTag) mem.push(part);

      return mem;
    }, []);
  }

  return parseChildren(children, targetString);
}

var Trans = function (_React$Component) {
  _inherits(Trans, _React$Component);

  function Trans(props, context) {
    _classCallCheck(this, Trans);

    var _this = _possibleConstructorReturn(this, (Trans.__proto__ || Object.getPrototypeOf(Trans)).call(this, props, context));

    _this.i18n = context.i18n;
    _this.t = context.t;
    return _this;
  }

  _createClass(Trans, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          count = _props.count,
          parent = _props.parent;


      var defaultValue = nodesToString('', children, 0);
      var key = this.props.i18nKey || defaultValue;
      var translation = this.t(key, { interpolation: { prefix: '#$?', suffix: '?$#' }, defaultValue: defaultValue, count: count });

      var additionalProps = {};
      if (this.i18n.options.react && this.i18n.options.react.exposeNamespace) {
        var ns = typeof this.t.ns === 'string' ? this.t.ns : this.t.ns[0];
        if (this.props.i18nKey && this.i18n.options.nsSeparator && this.props.i18nKey.indexOf(this.i18n.options.nsSeparator) > -1) {
          var parts = this.props.i18nKey.split(this.i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (this.t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      return _react2.default.createElement(parent, additionalProps, renderNodes(children, translation, this.i18n));
    }
  }]);

  return Trans;
}(_react2.default.Component);

exports.default = Trans;


Trans.propTypes = {
  count: _propTypes2.default.number,
  parent: _propTypes2.default.string,
  i18nKey: _propTypes2.default.string
};

Trans.defaultProps = {
  parent: 'div'
};

Trans.contextTypes = {
  i18n: _propTypes2.default.object.isRequired,
  t: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var I18nextProvider = function (_Component) {
  _inherits(I18nextProvider, _Component);

  function I18nextProvider(props, context) {
    _classCallCheck(this, I18nextProvider);

    var _this = _possibleConstructorReturn(this, (I18nextProvider.__proto__ || Object.getPrototypeOf(I18nextProvider)).call(this, props, context));

    _this.i18n = props.i18n;
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.i18n.options.isInitialSSR = true; // if set will be deleted on first render in translate hoc
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }
    return _this;
  }

  _createClass(I18nextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { i18n: this.i18n };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.i18n !== nextProps.i18n) {
        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react.Children.only(children);
    }
  }]);

  return I18nextProvider;
}(_react.Component);

I18nextProvider.propTypes = {
  i18n: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.element.isRequired
};

I18nextProvider.childContextTypes = {
  i18n: _propTypes2.default.object.isRequired
};

exports.default = I18nextProvider;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = loadNamespaces;
// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
function eachComponents(components, iterator) {
  for (var i = 0, l = components.length; i < l; i++) {
    // eslint-disable-line id-length
    if (_typeof(components[i]) === 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          iterator(value, i, key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      iterator(components[i], i);
    }
  }
}

function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (Component) {
    if (Component && Component.namespaces) {

      Component.namespaces.forEach(function (namespace) {
        if (flattened.indexOf(namespace) === -1) {
          flattened.push(namespace);
        }
      });
    }
  });
  return flattened;
}

function loadNamespaces(_ref) {
  var components = _ref.components,
      i18n = _ref.i18n;

  var allNamespaces = filterAndFlattenComponents(components);

  return new Promise(function (resolve) {
    i18n.loadNamespaces(allNamespaces, resolve);
  });
}

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1233);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../shared/rnclient/node_modules/css-loader/index.js?importLoaders=1!../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js!../../../../../../shared/rnclient/node_modules/extract-text-webpack-plugin/loader.js??ref--12-0!../../../../../../shared/rnclient/node_modules/style-loader/index.js!../../../../../../shared/rnclient/node_modules/css-loader/index.js?sourceMap&localIdentName=[local]___[hash:base64:5]!../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js?outputStyle=expanded!./index.scss", function() {
			var newContent = require("!!../../../../../../shared/rnclient/node_modules/css-loader/index.js?importLoaders=1!../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js!../../../../../../shared/rnclient/node_modules/extract-text-webpack-plugin/loader.js??ref--12-0!../../../../../../shared/rnclient/node_modules/style-loader/index.js!../../../../../../shared/rnclient/node_modules/css-loader/index.js?sourceMap&localIdentName=[local]___[hash:base64:5]!../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js?outputStyle=expanded!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneInstance", function() { return cloneInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return use; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18next__ = __webpack_require__(1235);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);

var changeLanguage = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].changeLanguage.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var cloneInstance = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].cloneInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var createInstance = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].createInstance.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var dir = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].dir.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var exists = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].exists.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var getFixedT = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].getFixedT.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var init = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].init.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var loadLanguages = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].loadLanguages.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var loadNamespaces = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].loadNamespaces.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var loadResources = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].loadResources.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var off = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].off.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var on = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].on.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var setDefaultNamespace = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].setDefaultNamespace.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var t = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].t.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);
var use = __WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */].use.bind(__WEBPACK_IMPORTED_MODULE_0__i18next__["a" /* default */]);

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResourceStore__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translator__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguageUtils__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PluralResolver__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Interpolator__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BackendConnector__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CacheConnector__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defaults__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__postProcessor__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__compatibility_v1__ = __webpack_require__(620);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }















function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = Object(__WEBPACK_IMPORTED_MODULE_9__defaults__["b" /* transformOptions */])(options);
    _this.services = {};
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */];
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), _possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init(options, callback) {
    var _this2 = this;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options) options = {};

    if (options.compatibilityAPI === 'v1') {
      this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__defaults__["a" /* get */])(), Object(__WEBPACK_IMPORTED_MODULE_9__defaults__["b" /* transformOptions */])(__WEBPACK_IMPORTED_MODULE_11__compatibility_v1__["b" /* convertAPIOptions */](options)), {});
    } else if (options.compatibilityJSON === 'v1') {
      this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__defaults__["a" /* get */])(), Object(__WEBPACK_IMPORTED_MODULE_9__defaults__["b" /* transformOptions */])(__WEBPACK_IMPORTED_MODULE_11__compatibility_v1__["c" /* convertJSONOptions */](options)), {});
    } else {
      this.options = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__defaults__["a" /* get */])(), this.options, Object(__WEBPACK_IMPORTED_MODULE_9__defaults__["b" /* transformOptions */])(options));
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].init(null, this.options);
      }

      var lu = new __WEBPACK_IMPORTED_MODULE_4__LanguageUtils__["a" /* default */](this.options);
      this.store = new __WEBPACK_IMPORTED_MODULE_2__ResourceStore__["a" /* default */](this.options.resources, this.options);

      var s = this.services;
      s.logger = __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */];
      s.resourceStore = this.store;
      s.resourceStore.on('added removed', function (lng, ns) {
        s.cacheConnector.save();
      });
      s.languageUtils = lu;
      s.pluralResolver = new __WEBPACK_IMPORTED_MODULE_5__PluralResolver__["a" /* default */](lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new __WEBPACK_IMPORTED_MODULE_6__Interpolator__["a" /* default */](this.options);

      s.backendConnector = new __WEBPACK_IMPORTED_MODULE_7__BackendConnector__["a" /* default */](createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      s.backendConnector.on('loaded', function (loaded) {
        s.cacheConnector.save();
      });

      s.cacheConnector = new __WEBPACK_IMPORTED_MODULE_8__CacheConnector__["a" /* default */](createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.cacheConnector.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      this.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator__["a" /* default */](this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    // COMPATIBILITY: remove this
    if (this.options.compatibilityAPI === 'v1') __WEBPACK_IMPORTED_MODULE_11__compatibility_v1__["a" /* appendBackwardsAPI */](this);

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */


  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.cacheConnector.load(toLoad, this.options.ns, function () {
        _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
      });
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    this.services.backendConnector.reload(lngs, ns);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'cache') {
      this.modules.cache = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'postProcessor') {
      __WEBPACK_IMPORTED_MODULE_10__postProcessor__["a" /* default */].addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

        _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var options = _extends({}, opts);
      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */


  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = _extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions, callback);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new __WEBPACK_IMPORTED_MODULE_3__Translator__["a" /* default */](clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);

    return clone;
  };

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new I18n());

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventEmitter__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(306);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    _classCallCheck(this, ResourceStore);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data;
    _this.options = options;
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator || this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getPath */](this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    __WEBPACK_IMPORTED_MODULE_1__utils__["h" /* setPath */](this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = __WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getPath */](this.data, path) || {};

    if (deep) {
      __WEBPACK_IMPORTED_MODULE_1__utils__["b" /* deepExtend */](pack, resources, overwrite);
    } else {
      pack = _extends({}, pack, resources);
    }

    __WEBPACK_IMPORTED_MODULE_1__utils__["h" /* setPath */](this.data, path, pack);

    this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(__WEBPACK_IMPORTED_MODULE_0__EventEmitter__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ResourceStore);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__postProcessor__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compatibility_v1__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(306);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }







var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* copy */](['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);

    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    if (this.options.compatibilityAPI === 'v1') {
      options = __WEBPACK_IMPORTED_MODULE_3__compatibility_v1__["d" /* convertTOptions */](options);
    }

    return this.resolve(key, options) !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    } else if (this.options.compatibilityAPI === 'v1') {
      options = __WEBPACK_IMPORTED_MODULE_3__compatibility_v1__["d" /* convertTOptions */](options);
    }

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator || this.options.keySeparator || '.';

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var res = this.resolve(keys, options);

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    if (res && typeof res !== 'string' && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(key, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (options.keySeparator || this.options.keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            copy[m] = this.translate('' + key + keySeparator + m, _extends({}, options, { joinArrays: false, ns: namespaces }));
          }
        }
        res = copy;
      }
    } else if (joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, key, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;
        res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      if (usedKey || usedDefault) {
        this.logger.log('missingKey', lng, namespace, key, res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        if (this.options.saveMissing) {
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(lngs, namespace, key, res);
          } else if (this.backendConnector && this.backendConnector.saveMissing) {
            this.backendConnector.saveMissing(lngs, namespace, key, res);
          }
        }

        this.emit('missingKey', lngs, namespace, key, res);
      }

      // extend
      res = this.extendTranslation(res, key, options);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
    var _this2 = this;

    if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));

    // interpolate
    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
    if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
    res = this.interpolator.interpolate(res, data, options.lng || this.language);

    // nesting
    if (options.nest !== false) res = this.interpolator.nest(res, function () {
      return _this2.translate.apply(_this2, arguments);
    }, options);

    if (options.interpolation) this.interpolator.reset();

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = __WEBPACK_IMPORTED_MODULE_2__postProcessor__["a" /* default */].handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this3 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this3.isValidLookup(found)) return;

      var extracted = _this3.extractFromKey(k, options);
      var key = extracted.key;
      var namespaces = extracted.namespaces;
      if (_this3.options.fallbackNS) namespaces = namespaces.concat(_this3.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this3.languageUtils.toResolveHierarchy(options.lng || _this3.language);

      namespaces.forEach(function (ns) {
        if (_this3.isValidLookup(found)) return;

        codes.forEach(function (code) {
          if (_this3.isValidLookup(found)) return;

          var finalKey = key;
          var finalKeys = [finalKey];

          var pluralSuffix = void 0;
          if (needsPluralHandling) pluralSuffix = _this3.pluralResolver.getSuffix(code, options.count);

          // fallback for plural if context not found
          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

          // get key for context if needed
          if (needsContextHandling) finalKeys.push(finalKey += '' + _this3.options.contextSeparator + options.context);

          // get key for plural if needed
          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this3.isValidLookup(found)) {
              found = _this3.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return found;
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Translator);

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(158);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (LanguageUtil);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(158);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'es_ar', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt', 'pt_br', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this = this;

    var rule = this.getRule(code);

    if (rule) {
      if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this.options.prepend && suffix.toString() ? _this.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ __webpack_exports__["a"] = (PluralResolver);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(158);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */


  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
      this.escape = options.interpolation && options.interpolation.escape || __WEBPACK_IMPORTED_MODULE_0__utils__["c" /* escape */];
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;

    this.prefix = iOpts.prefix ? __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* regexEscape */](iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* regexEscape */](iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* regexEscape */](iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* regexEscape */]('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* regexEscape */](iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || __WEBPACK_IMPORTED_MODULE_0__utils__["g" /* regexEscape */](')');

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
    var _this = this;

    var match = void 0;
    var value = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getPath */](data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getPath */](data, k), f, lng);
    };

    this.resetRegExp();

    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
    }

    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
        value = '';
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = _extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim()), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = __WEBPACK_IMPORTED_MODULE_0__utils__["e" /* makeString */](value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ __webpack_exports__["a"] = (Interpolator);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventEmitter__ = __webpack_require__(248);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_1__logger__["a" /* default */].create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (_this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _this3 = this;

    var _name$split = name.split('|'),
        _name$split2 = _slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // callback if ready
    this.queue.forEach(function (q) {
      __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* pushPath */](q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        _this3.emit('loaded', q.loaded);
        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this4 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this4.read.call(_this4, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this5 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    var options = _extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this5.logger.log('successfully loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);

        toLoad.toLoad.forEach(function (name) {
          var _name$split3 = name.split('|'),
              _name$split4 = _slicedToArray(_name$split3, 2),
              l = _name$split4[0],
              n = _name$split4[1];

          var bundle = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getPath */](data, [l, n]);
          if (bundle) {
            _this5.loaded(name, err, bundle);
          } else {
            var error = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
            _this5.loaded(name, error);
            _this5.logger.error(error);
          }
        });
      });
    } else {
      toLoad.toLoad.forEach(function (name) {
        _this5.loadOne(name);
      });
    }
  };

  Connector.prototype.reload = function reload(languages, namespaces) {
    var _this6 = this;

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
    }
    var options = _extends({}, this.backend.options, this.options.backend);

    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    // load with multi-load
    if (options.allowMultiLoading && this.backend.readMulti) {
      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
        if (err) _this6.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
        if (!err && data) _this6.logger.log('successfully reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);

        languages.forEach(function (l) {
          namespaces.forEach(function (n) {
            var bundle = __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getPath */](data, [l, n]);
            if (bundle) {
              _this6.loaded(l + '|' + n, err, bundle);
            } else {
              var error = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
              _this6.loaded(l + '|' + n, error);
              _this6.logger.error(error);
            }
          });
        });
      });
    } else {
      languages.forEach(function (l) {
        namespaces.forEach(function (n) {
          _this6.loadOne(l + '|' + n, 're');
        });
      });
    }
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this7 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split5 = name.split('|'),
        _name$split6 = _slicedToArray(_name$split5, 2),
        lng = _name$split6[0],
        ns = _name$split6[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this7.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this7.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this7.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue) {
    if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue);

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_2__EventEmitter__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventEmitter__ = __webpack_require__(248);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }




var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(cache, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.cache = cache;
    _this.store = store;
    _this.services = services;
    _this.options = options;
    _this.logger = __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* default */].create('cacheConnector');

    if (_this.cache && _this.cache.init) _this.cache.init(services, options.cache, options);
    return _this;
  }

  /* eslint consistent-return: 0 */


  Connector.prototype.load = function load(languages, namespaces, callback) {
    var _this2 = this;

    if (!this.cache) return callback && callback();
    var options = _extends({}, this.cache.options, this.options.cache);

    var loadLngs = typeof languages === 'string' ? this.services.languageUtils.toResolveHierarchy(languages) : languages;

    if (options.enabled) {
      this.cache.load(loadLngs, function (err, data) {
        if (err) _this2.logger.error('loading languages ' + loadLngs.join(', ') + ' from cache failed', err);
        if (data) {
          /* eslint no-restricted-syntax: 0 */
          for (var l in data) {
            if (Object.prototype.hasOwnProperty.call(data, l)) {
              for (var n in data[l]) {
                if (Object.prototype.hasOwnProperty.call(data[l], n)) {
                  if (n !== 'i18nStamp') {
                    var bundle = data[l][n];
                    if (bundle) _this2.store.addResourceBundle(l, n, bundle);
                  }
                }
              }
            }
          }
        }
        if (callback) callback();
      });
    } else if (callback) {
      callback();
    }
  };

  Connector.prototype.save = function save() {
    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
  };

  return Connector;
}(__WEBPACK_IMPORTED_MODULE_1__EventEmitter__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Connector);

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* harmony export (immutable) */ __webpack_exports__["b"] = transformOptions;

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    saveMissingTo: 'fallback', // 'current' || 'all'
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      return { defaultValue: args[1] };
    },

    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');

  return options;
}

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 621,
	"./af.js": 621,
	"./ar": 622,
	"./ar-dz": 623,
	"./ar-dz.js": 623,
	"./ar-kw": 624,
	"./ar-kw.js": 624,
	"./ar-ly": 625,
	"./ar-ly.js": 625,
	"./ar-ma": 626,
	"./ar-ma.js": 626,
	"./ar-sa": 627,
	"./ar-sa.js": 627,
	"./ar-tn": 628,
	"./ar-tn.js": 628,
	"./ar.js": 622,
	"./az": 629,
	"./az.js": 629,
	"./be": 630,
	"./be.js": 630,
	"./bg": 631,
	"./bg.js": 631,
	"./bn": 632,
	"./bn.js": 632,
	"./bo": 633,
	"./bo.js": 633,
	"./br": 634,
	"./br.js": 634,
	"./bs": 635,
	"./bs.js": 635,
	"./ca": 636,
	"./ca.js": 636,
	"./cs": 637,
	"./cs.js": 637,
	"./cv": 638,
	"./cv.js": 638,
	"./cy": 639,
	"./cy.js": 639,
	"./da": 640,
	"./da.js": 640,
	"./de": 641,
	"./de-at": 642,
	"./de-at.js": 642,
	"./de-ch": 643,
	"./de-ch.js": 643,
	"./de.js": 641,
	"./dv": 644,
	"./dv.js": 644,
	"./el": 645,
	"./el.js": 645,
	"./en-au": 646,
	"./en-au.js": 646,
	"./en-ca": 647,
	"./en-ca.js": 647,
	"./en-gb": 648,
	"./en-gb.js": 648,
	"./en-ie": 649,
	"./en-ie.js": 649,
	"./en-nz": 650,
	"./en-nz.js": 650,
	"./eo": 651,
	"./eo.js": 651,
	"./es": 652,
	"./es-do": 653,
	"./es-do.js": 653,
	"./es.js": 652,
	"./et": 654,
	"./et.js": 654,
	"./eu": 655,
	"./eu.js": 655,
	"./fa": 656,
	"./fa.js": 656,
	"./fi": 657,
	"./fi.js": 657,
	"./fo": 658,
	"./fo.js": 658,
	"./fr": 659,
	"./fr-ca": 660,
	"./fr-ca.js": 660,
	"./fr-ch": 661,
	"./fr-ch.js": 661,
	"./fr.js": 659,
	"./fy": 662,
	"./fy.js": 662,
	"./gd": 663,
	"./gd.js": 663,
	"./gl": 664,
	"./gl.js": 664,
	"./gom-latn": 665,
	"./gom-latn.js": 665,
	"./he": 666,
	"./he.js": 666,
	"./hi": 667,
	"./hi.js": 667,
	"./hr": 668,
	"./hr.js": 668,
	"./hu": 669,
	"./hu.js": 669,
	"./hy-am": 670,
	"./hy-am.js": 670,
	"./id": 671,
	"./id.js": 671,
	"./is": 672,
	"./is.js": 672,
	"./it": 673,
	"./it.js": 673,
	"./ja": 418,
	"./ja.js": 418,
	"./jv": 674,
	"./jv.js": 674,
	"./ka": 675,
	"./ka.js": 675,
	"./kk": 676,
	"./kk.js": 676,
	"./km": 677,
	"./km.js": 677,
	"./kn": 678,
	"./kn.js": 678,
	"./ko": 679,
	"./ko.js": 679,
	"./ky": 680,
	"./ky.js": 680,
	"./lb": 681,
	"./lb.js": 681,
	"./lo": 682,
	"./lo.js": 682,
	"./lt": 683,
	"./lt.js": 683,
	"./lv": 684,
	"./lv.js": 684,
	"./me": 685,
	"./me.js": 685,
	"./mi": 686,
	"./mi.js": 686,
	"./mk": 687,
	"./mk.js": 687,
	"./ml": 688,
	"./ml.js": 688,
	"./mr": 689,
	"./mr.js": 689,
	"./ms": 690,
	"./ms-my": 691,
	"./ms-my.js": 691,
	"./ms.js": 690,
	"./my": 692,
	"./my.js": 692,
	"./nb": 693,
	"./nb.js": 693,
	"./ne": 694,
	"./ne.js": 694,
	"./nl": 695,
	"./nl-be": 696,
	"./nl-be.js": 696,
	"./nl.js": 695,
	"./nn": 697,
	"./nn.js": 697,
	"./pa-in": 698,
	"./pa-in.js": 698,
	"./pl": 699,
	"./pl.js": 699,
	"./pt": 700,
	"./pt-br": 701,
	"./pt-br.js": 701,
	"./pt.js": 700,
	"./ro": 702,
	"./ro.js": 702,
	"./ru": 703,
	"./ru.js": 703,
	"./sd": 704,
	"./sd.js": 704,
	"./se": 705,
	"./se.js": 705,
	"./si": 706,
	"./si.js": 706,
	"./sk": 707,
	"./sk.js": 707,
	"./sl": 708,
	"./sl.js": 708,
	"./sq": 709,
	"./sq.js": 709,
	"./sr": 710,
	"./sr-cyrl": 711,
	"./sr-cyrl.js": 711,
	"./sr.js": 710,
	"./ss": 712,
	"./ss.js": 712,
	"./sv": 713,
	"./sv.js": 713,
	"./sw": 714,
	"./sw.js": 714,
	"./ta": 715,
	"./ta.js": 715,
	"./te": 716,
	"./te.js": 716,
	"./tet": 717,
	"./tet.js": 717,
	"./th": 718,
	"./th.js": 718,
	"./tl-ph": 719,
	"./tl-ph.js": 719,
	"./tlh": 720,
	"./tlh.js": 720,
	"./tr": 721,
	"./tr.js": 721,
	"./tzl": 722,
	"./tzl.js": 722,
	"./tzm": 723,
	"./tzm-latn": 724,
	"./tzm-latn.js": 724,
	"./tzm.js": 723,
	"./uk": 725,
	"./uk.js": 725,
	"./ur": 726,
	"./ur.js": 726,
	"./uz": 727,
	"./uz-latn": 728,
	"./uz-latn.js": 728,
	"./uz.js": 727,
	"./vi": 729,
	"./vi.js": 729,
	"./x-pseudo": 730,
	"./x-pseudo.js": 730,
	"./yo": 731,
	"./yo.js": 731,
	"./zh-cn": 732,
	"./zh-cn.js": 732,
	"./zh-hk": 733,
	"./zh-hk.js": 733,
	"./zh-tw": 734,
	"./zh-tw.js": 734
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1244;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _label;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(418);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/i18n/message-ja.js

exports.default = {
  initialize: function initialize() {
    _moment2.default.locale('ja');
    _moment2.default.updateLocale('ja', {
      longDateFormat: {
        LLLL: "YYYY年M月D日(ddd)",
        llll: "M月D日(ddd)",
        ll: "YYYY年M月",
        l: "HH:mm"
      }
    });
  },
  message: {
    "ようこそ": "gamba! にようこそ！",
    "ログインしてください": "ログインしてください。",
    "メンテナンス中": "ただいま、メンテナンス中です。\n\ngamba!は機能改善に向けて日夜作業を続けています。\n\nもう少しで、さらに機能アップしたgamba!をご利用いただけるようになります。\nいましばらく、おまちください。\n弊社からのメンテナンスのお知らせは下記をご覧ください。"
  },
  diary: {
    memo: 'ノート',
    diary: '日報',
    kpi: 'KPI',
    "diaryを書く": "日報を投稿する\n(テンプレートを選択する)",
    "kpiを書く": "KPI進捗を投稿する\n(テンプレートを選択する)",
    "memoを書く": "ノートを投稿する\n(テンプレートを選択する)",
    "diaryを投稿": "日報を投稿しました。お疲れ様でした！",
    "kpiを投稿": "KPIを投稿しました。お疲れ様でした！",
    "memoを投稿": "ノートを投稿しました。"
  },
  format: {
    diary_subject: "{{ reported_at, date}}の{{ category }}",
    timestamp: "{{ timestamp, fromNow }}",
    savedAt: "{{ timestamp, fromNow }}に保存",
    month: "YYYY年M月"
  },
  calendar: {
    monthNames: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月',
    monthNamesShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月',
    dayNames: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日',
    dayNamesShort: '日_月_火_水_木_金_土'
  },
  label: (_label = {
    "gamba": "日報アプリgamba!",
    "株式会社gamba": "株式会社gamba",
    "無料": "無料",
    "ピックアップ": "ピックアップ",
    "アプリ名": "gamba!",
    "お問い合わせ": "その他お問い合わせはこちら",
    "ヘルプページを開く": "ヘルプページを開く",
    "入門ガイドを開く": "入門ガイドを開く",
    "問い合わせる": "サポートに問い合わせ",
    "アプリもあります": "便利なスマートフォンアプリはいますぐ！こちらから",
    "お知らせがあります": "お知らせがあります",
    "更新が必要です": "更新が必要です",
    "更新する": "更新する",
    "gambaで開く": "gamba!で開く",
    "サービスが更新されています": "サービスが更新されています。いますぐ、再読み込みを行なってください。",
    "お知らせを開く": "お知らせを開く",
    "新着のお知らせ": "gamba!の新着のお知らせ",
    "新着のメッセージ": "{{ name }}さんからのメッセージ",
    "添付ファイルが届いています": "添付ファイルが届いています。",
    "メールアドレスを確認してください": "メールアドレスを確認ください",
    "メールアドレスの確認が完了していません": "メールアドレスの確認が完了していません",
    "メールアドレスの確認を行ってください": "お客様のメールアドレス宛に「gamba! 登録のお知らせ」メールを送信しております。こちらのメールを開き、メールアドレスの確認を完了してください。もしメールが見当たらない場合は、以下より再送を行なってください。",
    "確認メール再送": "確認メール再送",
    "サービスは現在ご利用いただけません": "サービスは現在ご利用いただけません。",
    "お知らせページを開く": "お知らせページを開く",
    "メニュー": "メニュー",
    "検索結果": "検索結果",
    "新着の通知": "新着の通知",
    "カレンダー": "カレンダー",
    "カレンダー連携": "カレンダー連携",
    "カレンダーを解除": "カレンダーを解除",
    "Googleカレンダー": "Googleカレンダー",
    "Googleカレンダーに接続": "Googleカレンダーに接続",
    "Googleドライブに接続する": "GOOGLEドライブに接続する",
    "Googleカレンダーを解除": "Googleカレンダーを解除",
    "Googleドライブに連携する": "GOOGLEドライブに連携する",
    "Googleドライブを解除": "Googleドライブを解除",
    "日報のエクスポートは最大1年分": "日報のエクスポートは最大1年分をエクスポート可能です。再度、操作を行なってください。",
    "Outlookカレンダー": "Outlookカレンダー (Beta版)",
    "Outlookカレンダーに接続": "Outlookカレンダーに接続 (Beta版)",
    "Outlookカレンダーを解除": "Outlookカレンダーを解除",
    "説明を表示": "説明を表示",
    "時間を表示": "時間を表示",
    "貼付ヒント": "チェックを入れて「貼付け」を押すとその日程の「説明」が追加されます。",
    "カレンダーの予定を貼り付けました": "カレンダーの予定を貼り付けました",
    "予定がありません": "予定がありません。",
    "メンバーリスト": "メンバーリスト",
    "メンバーとミッション": "メンバーとミッション",
    "ミッションが設定されていません": "ミッションが設定されていません。",
    "グループのメンバー": "{{ name }}のメンバー",
    "メンバー": "メンバー",
    "メンバーを追加": "メンバーを追加",
    "設定": "設定",
    "日報提出状況": "日報提出状況",
    "インサイト": "インサイト",
    "アルバム": "アルバム",
    "データがありません": "データがありません",
    "詳細をすべて表示": "詳細をすべて表示",
    "KPI進捗状況": "KPI進捗状況",
    "KPIの進捗状況": "{{ name }}の進捗状況",
    "添付ファイル": "添付ファイル",
    "画像": "画像",
    "動画・音声": "動画・音声",
    "ファイル": "ファイル"
  }, _defineProperty(_label, '\u30A2\u30EB\u30D0\u30E0', "アルバム"), _defineProperty(_label, "ログイン", "ログイン"), _defineProperty(_label, "確認コード", "確認コード"), _defineProperty(_label, "確認コードについて", "本人確認のため、数字6桁の確認コードをメールで送信しましたので、確認してください。"), _defineProperty(_label, "次へ", "次へ"), _defineProperty(_label, "いますぐログイン", "いますぐログイン！"), _defineProperty(_label, "うまくログインできない時", "ログインできない? こちらをご覧ください"), _defineProperty(_label, "無料体験に登録", "初めての利用ですか? 無料登録はこちら"), _defineProperty(_label, "無料体験の登録方法", "無料体験への登録方法はこちら"), _defineProperty(_label, "このアプリについて", "このアプリについて"), _defineProperty(_label, "アプリの説明", "日報共有アプリ gamba!\n開発・運営: 株式会社gamba\nバージョン: {{version}} ({{label}})\nOSバージョン: {{OS}}\nデバイス: {{device}}\nモデル: {{model}}"), _defineProperty(_label, "アプリの説明 モデル無し", "日報共有アプリ gamba!\n開発・運営: 株式会社gamba\nバージョン: {{version}} ({{label}})\nOSバージョン: {{OS}}\nデバイス: {{device}}"), _defineProperty(_label, "アプリの説明(staging)", "日報共有アプリ gamba!\n開発・運営: 株式会社gamba\nバージョン: {{version}} ({{label}})\nOSバージョン: {{OS}}\nデバイス: {{device}}\nモデル: {{model}}\nStaging環境です。"), _defineProperty(_label, "アプリの説明 モデル無し(staging)", "日報共有アプリ gamba!\n開発・運営: 株式会社gamba\nバージョン: {{version}} ({{label}})\nOSバージョン: {{OS}}\nデバイス: {{device}}\nStaging環境です。"), _defineProperty(_label, "メールアドレスを選択", "メールアドレスを選択"), _defineProperty(_label, "パスワードの変更が必要です", "パスワードの変更が必要です。"), _defineProperty(_label, "パスワードを変更してログイン", "パスワードを変更してログイン"), _defineProperty(_label, "シングルサインオン認証を行ってください", "シングルサインオン認証を行ってください。"), _defineProperty(_label, "メールアドレス", "メールアドレス"), _defineProperty(_label, "パスワード", "パスワード"), _defineProperty(_label, "個人設定", "個人設定"), _defineProperty(_label, "グループ設定", "グループ設定"), _defineProperty(_label, "グループ新規作成", "グループ新規作成"), _defineProperty(_label, "プロフィール設定", "プロフィール設定"), _defineProperty(_label, "お気に入り登録", "フォロー設定"), _defineProperty(_label, "フォロー", "フォロー"), _defineProperty(_label, "フォロー中", "フォロー中"), _defineProperty(_label, "お気に入りに追加", "フォローする"), _defineProperty(_label, "お気に入りから削除", "フォローを外す"), _defineProperty(_label, "ブロック", "ブロック"), _defineProperty(_label, "ブロックリスト", "ブロックリスト"), _defineProperty(_label, "ブロック解除", "ブロック解除"), _defineProperty(_label, "ユーザのブロック", "このユーザをブロックをします。"), _defineProperty(_label, "ブロックユーザの解除", "このユーザのブロックを解除します。"), _defineProperty(_label, "ユーザのブロック説明", "ブロックした場合、あなたの「すべての投稿」や「グループのタイムライン」からこのユーザの投稿が表示されなくなります。ブロック解除はブロックしたユーザのタイムラインか 「個人設定」 > 「ブロックリスト」から解除できます。"), _defineProperty(_label, "ブロックユーザの解除説明", "ブロック解除した場合、あなたの「すべての投稿」や「グループのタイムライン」にこのユーザの投稿が表示されるようになります。"), _defineProperty(_label, "投稿のブロック", "この投稿をブロックします。"), _defineProperty(_label, "投稿のブロック解除", "この投稿のブロックを解除します。"), _defineProperty(_label, "投稿のブロック説明", "ブロックした場合、あなたの「すべての投稿」やグループのタイムラインからこの投稿が表示されなくなります。ブロック解除はブロックしたユーザのタイムラインから解除できます。"), _defineProperty(_label, "投稿のブロック解除説明", "ブロック解除した場合、あなたの「すべての投稿」やグループのタイムラインに表示されるようになります。"), _defineProperty(_label, "投稿ブロックされています", "この投稿はブロックされています。"), _defineProperty(_label, "ユーザブロックされています", "このユーザはブロックされています。"), _defineProperty(_label, "パスワード変更", "パスワード変更"), _defineProperty(_label, "パスワード再発行", "パスワードがわからない? 再発行はこちら"), _defineProperty(_label, "gambaについて", "gamba!について知りたい? 詳しくはこちら"), _defineProperty(_label, "通知設定", "通知設定"), _defineProperty(_label, "自分用テンプレート", "自分用テンプレート"), _defineProperty(_label, "共通テンプレート", "共通テンプレート"), _defineProperty(_label, "アカウント管理", "アカウント管理"), _defineProperty(_label, "アカウント管理画面を開く", "アカウント管理画面を開く"), _defineProperty(_label, "ログアウト", "ログアウト"), _defineProperty(_label, "ログアウトします", "ログアウトします"), _defineProperty(_label, "基本設定", "基本設定"), _defineProperty(_label, "メンバー管理", "メンバー管理"), _defineProperty(_label, "KPI設定", "KPI設定"), _defineProperty(_label, "ごみ箱に移動", "ごみ箱に移動"), _defineProperty(_label, "ダウンロード", "ダウンロード"), _defineProperty(_label, "チャット", "チャット"), _defineProperty(_label, "チャットをする", "チャットをする"), _defineProperty(_label, "ご自身のユーザーでチャットを行うことはできません", "ご自身のユーザーでチャットを行うことはできません"), _defineProperty(_label, "対象ユーザーはこのチャットルームには参加していません。", "対象ユーザーはこのチャットルームには参加していません。"), _defineProperty(_label, '\u65E5\u5831\u63D0\u51FA\u72B6\u6CC1', "日報提出状況"), _defineProperty(_label, "未読の投稿", "未読の投稿"), _defineProperty(_label, "未読の投稿があります", "{{ unreadCount }}件の未読の投稿があります。"), _defineProperty(_label, "未読の投稿がたくさんあります", "10件以上の未読の投稿があります。"), _defineProperty(_label, "件", "件"), _defineProperty(_label, "件以上", "件以上"), _defineProperty(_label, "すべて開封にする", "すべて開封"), _defineProperty(_label, "未読の投稿を開く", "未読の投稿を開く"), _defineProperty(_label, "目標", "目標"), _defineProperty(_label, "実績", "実績"), _defineProperty(_label, "合計実績", "合計実績"), _defineProperty(_label, "累計", "累計"), _defineProperty(_label, "達成率", "達成率"), _defineProperty(_label, "合計達成率", "合計達成率"), _defineProperty(_label, "達成ライン", "100%達成ライン"), _defineProperty(_label, "合計", "合計"), _defineProperty(_label, "達成", "達成 !"), _defineProperty(_label, "返信", "返信"), _defineProperty(_label, "内容", "内容"), _defineProperty(_label, "添付", "添付"), _defineProperty(_label, "了解", "了解"), _defineProperty(_label, "完了", "完了"), _defineProperty(_label, "送信", "送信"), _defineProperty(_label, "登録", "登録"), _defineProperty(_label, "更新", "更新"), _defineProperty(_label, "提出", "提出"), _defineProperty(_label, "新規作成", "新規作成"), _defineProperty(_label, "編集", "編集"), _defineProperty(_label, "概要", "概要"), _defineProperty(_label, "詳細", "詳細"), _defineProperty(_label, "戻る", "戻る"), _defineProperty(_label, "操作", "操作"), _defineProperty(_label, "gambaアプリで開く", "このページをgamba!アプリで開く"), _defineProperty(_label, "アプリで開く", "アプリで開く"), _defineProperty(_label, "アプリをダウンロード", "アプリをダウンロード"), _defineProperty(_label, "アプリを使用しない", "gamba!アプリを使用しない"), _defineProperty(_label, "クリックして値を更新", "クリックして値を更新"), _defineProperty(_label, "アイコン画像", "アイコン画像"), _defineProperty(_label, "自分のミッション", "自分のミッション"), _defineProperty(_label, "グループのミッション", "グループのミッション"), _defineProperty(_label, "写真動画を選択", "写真・動画を選択"), _defineProperty(_label, "ドキュメントを選択", "ドキュメントを選択"), _defineProperty(_label, "ファイルを選択", "ファイルを選択"), _defineProperty(_label, "エクスポート", "エクスポート"), _defineProperty(_label, "送信方法", "送信方法"), _defineProperty(_label, "フォルダの選択", "フォルダの選択"), _defineProperty(_label, "保存先", "保存先"), _defineProperty(_label, "メールに送信", "メールに送信"), _defineProperty(_label, "ローカルに保存", "ローカルに保存"), _defineProperty(_label, "Refresh Token", "Refresh Token"), _defineProperty(_label, "Refresh Tokenの取得", "Refresh Tokenの取得"), _defineProperty(_label, "Googleドライブが設定されていません", "Googleドライブが設定されていません"), _defineProperty(_label, "連携済み", "連携済み"), _defineProperty(_label, "定期的にGoogleドライブへ自動保存する", "定期的にGoogleドライブへ自動保存する"), _defineProperty(_label, "定期実行設定", "定期実行設定"), _defineProperty(_label, "定期実行", "定期実行"), _defineProperty(_label, "有効にする", "有効にする"), _defineProperty(_label, "フォルダを選択して下さい1", "フォルダを選択して下さい"), _defineProperty(_label, "フォルダを選択して下さい", "---フォルダを選択して下さい---"), _defineProperty(_label, "期間設定", "期間設定"), _defineProperty(_label, "日付", "日付"), _defineProperty(_label, "間隔", "間隔"), _defineProperty(_label, "週", "週"), _defineProperty(_label, "月次", "月"), _defineProperty(_label, "ユーザ", "ユーザ"), _defineProperty(_label, "ユーザ名", "ユーザ名"), _defineProperty(_label, "社員番号", "社員番号"), _defineProperty(_label, "部署", "部署"), _defineProperty(_label, "誕生日", "誕生日"), _defineProperty(_label, "部署を選択", "部署を選択"), _defineProperty(_label, "誕生日を追加", "誕生日を追加"), _defineProperty(_label, "部署が設定されていません", "部署が設定されていません。設定が必要な場合はアカウント管理者に連絡してください。"), _defineProperty(_label, "グループ名", "グループ名"), _defineProperty(_label, "セクション/グループ名を検索", "セクション/グループ名を検索"), _defineProperty(_label, "並べ替え", "並べ替え"), _defineProperty(_label, "現在のパスワード", "現在のパスワード"), _defineProperty(_label, "新しいパスワード", "新しいパスワード"), _defineProperty(_label, "新しいパスワード(再入力)", "新しいパスワード(再入力)"), _defineProperty(_label, "ミッションを入力してください", "ミッションを入力してください。"), _defineProperty(_label, "メールアドレスを更新しました", "確認のため、新しいメールアドレス宛に確認用のメールを送信しましたので、ご確認ください。"), _defineProperty(_label, "メールアドレス確認待ち", "メールアドレス {{email}} へ変更手続き中です。"), _defineProperty(_label, "パスワードを更新しました", "パスワードを更新しました。"), _defineProperty(_label, "プロフィールを更新しました", "プロフィールを更新しました。"), _defineProperty(_label, "グループの基本設定を更新しました", "グループの基本設定を更新しました。"), _defineProperty(_label, "グループを作成しました", "グループを作成しました。"), _defineProperty(_label, "テンプレートを削除してもいいですか", "{{ name }}を削除してもよろしいですか?"), _defineProperty(_label, "グループの公開範囲", "グループの公開範囲"), _defineProperty(_label, "セクション/グループはありません", "セクション/グループはありません"), _defineProperty(_label, "ユーザ追加", "ユーザを追加"), _defineProperty(_label, "新規ユーザを招待", "新規ユーザを招待"), _defineProperty(_label, "既存ユーザを追加", "既存ユーザを追加"), _defineProperty(_label, "既存ユーザを追加します", "既に他に登録済みのユーザを追加します。"), _defineProperty(_label, "メンバーは登録されていません", "メンバーは登録されていません。"), _defineProperty(_label, "管理者", "管理者"), _defineProperty(_label, "一般ユーザ", "一般ユーザ"), _defineProperty(_label, "一般ユーザに変更", "一般ユーザに変更"), _defineProperty(_label, "管理者に変更", "管理者に変更"), _defineProperty(_label, "管理者に変更します", "{{ name }}をグループ管理者に変更します。"), _defineProperty(_label, "一般ユーザに変更します", "{{ name }}を一般ユーザに変更します。"), _defineProperty(_label, "通知する", "通知する"), _defineProperty(_label, "通知しない", "通知しない"), _defineProperty(_label, "リマインドを通知する", "リマインドを通知する"), _defineProperty(_label, "リマインドを通知しない", "リマインドを通知しない"), _defineProperty(_label, "すべてのリマインド通知を送らない", "すべてのリマインド通知を送らない"), _defineProperty(_label, "リマインドの通知を停止します", "{{ name }}へのリマインド通知を停止します。"), _defineProperty(_label, "リマインドの通知を開始します", "{{ name }}へのリマインド通知を開始します。"), _defineProperty(_label, "ユーザを追加しました", "{{ name }}さんをこのグループのメンバーに追加しました。"), _defineProperty(_label, "グループからユーザを削除しました", "{{ name }}さんをこのグループのメンバーから外しました。"), _defineProperty(_label, "グループの管理権限を付与しました", "{{ name }}さんにこのグループの管理権限を付与しました。"), _defineProperty(_label, "グループの管理権限を削除しました", "{{ name }}さんのグループ管理権限を削除しました。"), _defineProperty(_label, "ユーザへのリマインドメールの送信を開始します", "{{ name }}さんへのリマインドメールの通知を開始しました。"), _defineProperty(_label, "ユーザへのリマインドメールの送信を停止しました", "{{ name }}さんへのリマインドメールの通知を停止しました。"), _defineProperty(_label, "ユーザを削除", "グループメンバーから外す"), _defineProperty(_label, "ユーザを削除してもいいですか", "{{ name }}さんをメンバーから外してもよろしいですか?"), _defineProperty(_label, "ユーザを削除しても過去の投稿は閲覧することができます", "グループから外しても過去の投稿は閲覧することができます。"), _defineProperty(_label, "アカウント管理画面から操作", "退職などで【gamba!】から完全に削除したい場合は、アカウント管理画面からも操作が必要です。"), _defineProperty(_label, "アカウント管理画面へ", "アカウント管理画面へ"), _defineProperty(_label, "ユーザを選択", "ユーザを選択"), _defineProperty(_label, "開始日", "開始日"), _defineProperty(_label, "終了日", "終了日"), _defineProperty(_label, "翌期分自動作成", "翌期分を自動で作成する"), _defineProperty(_label, "Excelダウンロード", "Excel形式でダウンロード"), _defineProperty(_label, "Googleアカウント", "Googleアカウント"), _defineProperty(_label, "アカウント", "アカウント"), _defineProperty(_label, "すべて抽出", "すべての入力項目を抽出"), _defineProperty(_label, "KPIを作成", "KPIを作成"), _defineProperty(_label, "現在のKPI", "現在のKPI"), _defineProperty(_label, "終了したKPI", "終了したKPI"), _defineProperty(_label, "PDFで保存", "PDFで保存"), _defineProperty(_label, "画像で保存", "画像で保存"), _defineProperty(_label, "KPIデータ設定", "KPIデータ設定"), _defineProperty(_label, "データ選択", "データ選択"), _defineProperty(_label, "KPIを追加", "+ KPIを追加"), _defineProperty(_label, "積み上げ", "積み上げ"), _defineProperty(_label, "積み上げ説明", "期間内の各KPIを積み上げグラフで表示し、累計の推移を確認できます。"), _defineProperty(_label, "個人データ", "個人データ"), _defineProperty(_label, "個人データ説明", "個々の社員の目標達成状況と実績をリアルタイムで追跡できます。"), _defineProperty(_label, "歩留まり", "歩留まり"), _defineProperty(_label, "歩留まり説明", "選択したKPI間（面談数→契約数など）の達成率を％で表示し、プロセスの効率を把握できます。"), _defineProperty(_label, "歩留まりライン", "100%歩留まりライン"), _defineProperty(_label, "比較", "比較"), _defineProperty(_label, "比較説明", "前年同期との実績差異を表示し、成長率や改善点を確認できます。"), _defineProperty(_label, "比較説明メッセージ", "選択した年の同期との実績差異1年分を表示します。"), _defineProperty(_label, "使い方", "使い方"), _defineProperty(_label, '\u4E26\u3079\u66FF\u3048', "並べ替え"), _defineProperty(_label, "並べ替えを終了", "並べ替えを終了"), _defineProperty(_label, "並べ替え終了を選択", "KPIを編集する際は「並べ替えを終了する」ボタンを選択してください。"), _defineProperty(_label, "ドラッグして並べ替え", "ドラッグして表示の順序の並べ替えができます。"), _defineProperty(_label, "長押しして並べ替え", "長押しして表示の順序の並べ替えができます。"), _defineProperty(_label, "割り当てられていません", "割り当てられていません"), _defineProperty(_label, "目標値", "目標値: {{ value }}"), _defineProperty(_label, "目標値2", "目標値"), _defineProperty(_label, "担当者", "担当者: {{ assignments }}"), _defineProperty(_label, "担当者の実績", "{{ name }}の実績"), _defineProperty(_label, "KPIは登録されていません", "KPIは登録されていません。"), _defineProperty(_label, "コピーして新規作成", "コピーして新規作成"), _defineProperty(_label, "コピーして翌期分を作成", "コピーして翌期分を作成"), _defineProperty(_label, "コピー", "(コピー)"), _defineProperty(_label, "データごと削除", "データごと削除"), _defineProperty(_label, "KPIを削除しました", "{{ name }}を削除しました"), _defineProperty(_label, "KPIを削除してもいいですか", "{{ name }}を削除してもよろしいですか?"), _defineProperty(_label, "実績値の集計方法", "実績値の集計方法"), _defineProperty(_label, "プレビュー", "プレビュー"), _defineProperty(_label, "プレビュー説明", "* タイムライン上で下記の表が表示されます。"), _defineProperty(_label, "実績値を期間内で累計する", "実績値を期間内で累計する"), _defineProperty(_label, "実績値を日毎に集計する", "実績値を日毎に集計する"), _defineProperty(_label, "実績値を期間内で累計の説明", "入力した実績値を期間内で累計し、目標値に対する達成率を計算します。月間売上目標など、通常はこちらを選択します。"), _defineProperty(_label, "実績値を日毎に集計の説明", "入力した実績値は累計せず、日ごとの目標値に対して達成率を計算します。日ごとの架電件数目標などは、こちらを選択します。"), _defineProperty(_label, "月次グラフ", "月次グラフ"), _defineProperty(_label, "日次グラフ", "日次グラフ"), _defineProperty(_label, "年次", "年次"), _defineProperty(_label, '\u6708\u6B21', "月次"), _defineProperty(_label, "日次", "日次"), _defineProperty(_label, "集計期間", "集計期間"), _defineProperty(_label, "集計日", "集計日"), _defineProperty(_label, "グラフを表示", "グラフを表示"), _defineProperty(_label, "KPI名", "KPI名"), _defineProperty(_label, "その他のKPI", "その他のKPI"), _defineProperty(_label, "KPI名の説明", "売上・利益・契約件数など"), _defineProperty(_label, "期間", "期間"), _defineProperty(_label, "単位", "単位"), _defineProperty(_label, "単位の説明", "円・件・社など"), _defineProperty(_label, "単位の表示位置", "単位の表示位置"), _defineProperty(_label, "値の前に表示", "値の前に表示"), _defineProperty(_label, "値の後に表示", "値の後に表示"), _defineProperty(_label, "表示形式", "値の表示形式"), _defineProperty(_label, "担当者と目標値の割り当て", "担当者と目標値の割り当て"), _defineProperty(_label, "すべて選択", "すべて選択"), _defineProperty(_label, "すべて解除", "すべて解除"), _defineProperty(_label, "同じ値を設定", "同じ値を設定"), _defineProperty(_label, "目標値を入力", "目標値を入力"), _defineProperty(_label, "KPIを更新しました", "{{ name }}を更新しました。"), _defineProperty(_label, "KPIを作成しました", "KPIを作成しました。"), _defineProperty(_label, "KPIがありません", "KPIが登録されていません。"), _defineProperty(_label, "開始日は終了日より前に設定してください", "開始日は終了日より前に設定してください。"), _defineProperty(_label, "自動作成日は開始日より後に設定してください", "自動作成日は開始日より後に設定してください。"), _defineProperty(_label, "自動作成日は終了日より前に設定してください", "自動作成日は終了日より前に設定してください"), _defineProperty(_label, "リマインド通知", "リマインド通知"), _defineProperty(_label, "リマインド", "リマインド"), _defineProperty(_label, "リマインド通知時刻", "リマインドの通知時刻"), _defineProperty(_label, "時ごろに通知", "{{ time }}ごろに通知"), _defineProperty(_label, "リマインド通知日", "リマインド通知の曜日"), _defineProperty(_label, "send_on_sun", "日曜日"), _defineProperty(_label, "send_on_mon", "月曜日"), _defineProperty(_label, "send_on_tue", "火曜日"), _defineProperty(_label, "send_on_wed", "水曜日"), _defineProperty(_label, "send_on_thu", "木曜日"), _defineProperty(_label, "send_on_fri", "金曜日"), _defineProperty(_label, "send_on_sat", "土曜日"), _defineProperty(_label, "send_on_holiday", "祝祭日"), _defineProperty(_label, "個別リマインド通知", "リマインド通知の個別設定"), _defineProperty(_label, "リマインド通知の送信スケジュールを変更しました", "リマインド通知の送信スケジュールを変更しました。"), _defineProperty(_label, "検索キーワード", "検索キーワード"), _defineProperty(_label, "検索", "検索"), _defineProperty(_label, "ユーザで絞り込み", "ユーザで絞り込み"), _defineProperty(_label, "すべての投稿種別", "すべての投稿種別"), _defineProperty(_label, "日報のみ", "日報のみ"), _defineProperty(_label, "KPIのみ", "KPIのみ"), _defineProperty(_label, "ノートのみ", "ノートのみ"), _defineProperty(_label, "オプション", "オプション"), _defineProperty(_label, "添付ファイル付き", "添付ファイル付き"), _defineProperty(_label, "いいねした投稿", "いいねした投稿"), _defineProperty(_label, "すべての期間の投稿", "すべての期間の投稿"), _defineProperty(_label, "日付の選択", "日付の選択"), _defineProperty(_label, "投稿日", "投稿日"), _defineProperty(_label, "より後の投稿", "{{ reported_at }}より後"), _defineProperty(_label, "読み込み中", "読み込み中..."), _defineProperty(_label, "名前で検索", "名前で検索..."), _defineProperty(_label, "選択してください", "選択してください"), _defineProperty(_label, "選択されていません", "選択されていません"), _defineProperty(_label, "選択", "選択"), _defineProperty(_label, "取り消し", "取り消し"), _defineProperty(_label, "閉じる", "閉じる"), _defineProperty(_label, "キャンセル", "キャンセル"), _defineProperty(_label, "はい", "はい!"), _defineProperty(_label, "いいえ", "いいえ"), _defineProperty(_label, "OK", "OK"), _defineProperty(_label, "すべてのグループ", "すべての投稿"), _defineProperty(_label, "グループ", "グループ"), _defineProperty(_label, "公開グループ", "公開グループ"), _defineProperty(_label, "非公開グループ", "非公開グループ"), _defineProperty(_label, "その他", "その他"), _defineProperty(_label, "組織", "組織"), _defineProperty(_label, "公開グループの説明", "アカウント内のすべてのユーザが投稿を閲覧できます。"), _defineProperty(_label, "非公開グループの説明", "グループのメンバーのみが投稿を閲覧できます。"), _defineProperty(_label, "グループを探す", "グループを探す"), _defineProperty(_label, "隠す", "隠す"), _defineProperty(_label, "すべて表示", "すべて表示"), _defineProperty(_label, "表示を隠す", "表示を隠す"), _defineProperty(_label, "もっと見る", "もっと見る"), _defineProperty(_label, "続きを表示", "続きを表示"), _defineProperty(_label, "件のコメントをすべて表示", "以前のコメント{{ count }}件を表示"), _defineProperty(_label, "が返信しました", "が返信しました・返信{{ count }}件"), _defineProperty(_label, "が返信しました(1件)", "が返信しました"), _defineProperty(_label, "コメントを隠す", "コメントを隠す"), _defineProperty(_label, "返信を隠す", "返信を隠す"), _defineProperty(_label, "テンプレートを選択", "テンプレートを選択"), _defineProperty(_label, "テンプレート", "テンプレート"), _defineProperty(_label, "テンプレートを編集", "テンプレートを編集"), _defineProperty(_label, "user_templates_setting", "自分専用テンプレートを編集"), _defineProperty(_label, "group_templates_setting", "グループ共通テンプレートを編集"), _defineProperty(_label, "下書き", "下書き ({{ count }})"), _defineProperty(_label, "下書きを選択", "下書きを選択"), _defineProperty(_label, "全て削除", "すべて削除"), _defineProperty(_label, "入力フィールド", "かんたん入力項目"), _defineProperty(_label, "form-dropdown", "メニューから選択"), _defineProperty(_label, "form-text", "テキスト記述(複数行)"), _defineProperty(_label, "form-string", "テキスト記述(1行)"), _defineProperty(_label, "form-numeric", "数値入力"), _defineProperty(_label, "form-date", "日付入力"), _defineProperty(_label, "form-time", "時刻入力"), _defineProperty(_label, "フィールドを追加", "入力項目を追加"), _defineProperty(_label, "値", "項目の値"), _defineProperty(_label, "必須", "必須入力"), _defineProperty(_label, "フィールド種別", "入力種別"), _defineProperty(_label, "フィールド名", "入力項目名"), _defineProperty(_label, "値を入力してください", "値を入力してください"), _defineProperty(_label, "未入力", "未入力"), _defineProperty(_label, "新しいフィールド", "新しい入力項目"), _defineProperty(_label, "フィールドの選択肢", "メニューの選択肢"), _defineProperty(_label, "ドロップダウン入力の場合の選択肢を改行で区切って列挙します", "メニューの選択肢を1行ごとに列挙します。"), _defineProperty(_label, "初期値を指定します", "初期値を指定します"), _defineProperty(_label, "初期値", "初期値: {{value}}"), _defineProperty(_label, "絵文字を入力", "絵文字を入力"), _defineProperty(_label, "終日", "終日"), _defineProperty(_label, "投稿種別を選択", "投稿種別を選択"), _defineProperty(_label, "日報にコピー", "貼付け"), _defineProperty(_label, "投稿作成", "投稿作成"), _defineProperty(_label, "投稿を編集", "投稿を編集"), _defineProperty(_label, "投稿を報告", "投稿を報告"), _defineProperty(_label, "投稿を削除", "投稿を削除"), _defineProperty(_label, "投稿を印刷", "投稿を印刷"), _defineProperty(_label, "投稿を翻訳", "投稿を翻訳"), _defineProperty(_label, "ピン留めされた投稿", "ピン留めされた投稿"), _defineProperty(_label, "ピン留め", "ピン留め"), _defineProperty(_label, "ピン留め解除", "ピン留め解除"), _defineProperty(_label, "ピン留め説明", "グループタイムラインの一番上に投稿がピン留めされます。ピン留めしますか？"), _defineProperty(_label, "ピン留め解除説明", "ピン留め解除を解除しますか？"), _defineProperty(_label, "元の表示に戻す", "元の表示に戻す"), _defineProperty(_label, "翻訳", "(翻訳)"), _defineProperty(_label, "リンクをコピー", "リンクをコピー"), _defineProperty(_label, "本文をコピー", "本文をコピー"), _defineProperty(_label, "ユーザブロック", "ユーザをブロック"), _defineProperty(_label, "ユーザブロック解除", "ブロック解除"), _defineProperty(_label, "投稿ブロック", "投稿をブロック"), _defineProperty(_label, "投稿ブロック解除", "ブロックを解除"), _defineProperty(_label, "クリップボードにコピー", "クリップボードにコピー"), _defineProperty(_label, "宛先を追加", "宛先を追加"), _defineProperty(_label, "編集済み", "(編集済み)"), _defineProperty(_label, "編集時刻", "({{ updated }}に編集)"), _defineProperty(_label, "他n人", "他{{n}}人"), _defineProperty(_label, "n", "{{ n }}"), _defineProperty(_label, "n人", "{{n}}人"), _defineProperty(_label, "複数n人", "{{n}}人"), _defineProperty(_label, "がいいね", "がいいね！"), _defineProperty(_label, "が開封", "が開封"), _defineProperty(_label, "開封n", "開封 {{ n }}"), _defineProperty(_label, "開封n < 3", "開封 "), _defineProperty(_label, "が読んでみて", "から読んでみて！"), _defineProperty(_label, "に読んでみて", "に読んでみて！"), _defineProperty(_label, "返信要求付き", "(要返信)"), _defineProperty(_label, "がコメント", "がコメント"), _defineProperty(_label, "n件", "{{ n }}件"), _defineProperty(_label, "クリックしてもっと見る", "添付写真をもっと見る..."), _defineProperty(_label, "他n個の添付写真を開く", "他{{ n }}個の添付写真をすべて見る..."), _defineProperty(_label, "開封", "開封"), _defineProperty(_label, "投稿", "投稿"), _defineProperty(_label, "リアクション", "リアクション"), _defineProperty(_label, "投稿数", "投稿数"), _defineProperty(_label, "リアクション数", "リアクション数"), _defineProperty(_label, "1人平均", "1人平均"), _defineProperty(_label, "投稿あたり", "投稿あたり"), _defineProperty(_label, "平均投稿数", "平均投稿数"), _defineProperty(_label, "平均リアクション数", "平均リアクション数"), _defineProperty(_label, "いいね", "いいね！"), _defineProperty(_label, "ピン", "ピン"), _defineProperty(_label, "got_it", "了解！"), _defineProperty(_label, "good_job", "おつかれさま！"), _defineProperty(_label, "thanks", "ありがとう！"), _defineProperty(_label, "good_luck", "がんばれ！"), _defineProperty(_label, "regards", "よろしく！"), _defineProperty(_label, "excellent", "すばらしい！"), _defineProperty(_label, "disappointed", "ざんねん！"), _defineProperty(_label, "いいねを取り消す", "取り消す"), _defineProperty(_label, "いいねといっている人はまだいません", "いいねといっている人はまだいません。"), _defineProperty(_label, "読んでみてといっている人はまだいません", "読んでみてといっている人はまだいません。"), _defineProperty(_label, "開封した人はまだいません", "開封した人はまだいません。"), _defineProperty(_label, "コメントした人はまだいません", "コメントした人はまだいません"), _defineProperty(_label, "返信した人はまだいません", "返信した人はまだいません。"), _defineProperty(_label, "時間前に開封", "{{ timestamp }}に開封"), _defineProperty(_label, "時間前にいいね", "{{ timestamp }}にいいね！"), _defineProperty(_label, "時間前にリアクション", "{{ timestamp }}に{{ n }}"), _defineProperty(_label, "時間前に送信", "{{ timestamp }}に送信"), _defineProperty(_label, "時間前に返信", "{{ timestamp }}に返信済み"), _defineProperty(_label, "時間前にコメント", "{{ timestamp }}にコメント"), _defineProperty(_label, "時間前に返信(tab)", "{{ timestamp }}に返信済み"), _defineProperty(_label, "ユーザのコメント", "{{ name }}のコメント"), _defineProperty(_label, "コメント", "コメント"), _defineProperty(_label, "コメントを削除", "コメントを削除"), _defineProperty(_label, "コメントを編集", "コメントを編集"), _defineProperty(_label, "スタンプ", "スタンプ"), _defineProperty(_label, "スタンプ追加", "スタンプ追加"), _defineProperty(_label, "を削除します", "を削除します"), _defineProperty(_label, "読んでみて", "読んでみて！"), _defineProperty(_label, "読んでみての宛先を追加", "読んでみて！ の宛先を追加"), _defineProperty(_label, "返信を要求", "返信を要求する"), _defineProperty(_label, "保存された投稿を削除してもいいですか", "一時保存されている投稿を削除してもよろしいですか?"), _defineProperty(_label, "保存された全ての投稿を削除してもいいですか", "一時保存されている全ての投稿を削除してもよろしいですか?"), _defineProperty(_label, "この投稿は削除されました", "この投稿は削除されました"), _defineProperty(_label, "日報を削除してもいいですか", "この投稿を削除してもよろしいですか?"), _defineProperty(_label, "コメントを削除してもいいですか", "このコメントを削除してもよろしいですか?"), _defineProperty(_label, "この操作は取り消せません", "この操作は元に戻せません。ご注意ください。"), _defineProperty(_label, "この投稿を通報してもよろしいですか", "この投稿を通報してもよろしいですか?"), _defineProperty(_label, "このコメントを通報してもよろしいですか", "このコメントを通報してもよろしいですか?"), _defineProperty(_label, "このユーザを通報してもよろしいですか", "このユーザを通報してもよろしいですか?"), _defineProperty(_label, "コメントを入力してください", "コメントを入力してください。"), _defineProperty(_label, "投稿がありません", "投稿がありません。"), _defineProperty(_label, "フォルダがありません", "フォルダがありません。"), _defineProperty(_label, "一番最後の投稿です", "これより以前の投稿はありません。"), _defineProperty(_label, "よろしいですか？", "よろしいですか？"), _defineProperty(_label, "テンプレート名", "テンプレート名"), _defineProperty(_label, "テンプレートをインポート", "テンプレートをインポート"), _defineProperty(_label, "テンプレートを上書きしていいですか", "現在編集中の内容を選択したテンプレートで上書きしてもよろしいですか?"), _defineProperty(_label, "テンプレートを作成しましょう", "テンプレートを作成しましょう。"), _defineProperty(_label, "テンプレートを作成しました", "テンプレートを作成しました。"), _defineProperty(_label, "テンプレートを更新しました", "{{ name }}を更新しました。"), _defineProperty(_label, "テンプレートを削除しました", "{{ name }}を削除しました。"), _defineProperty(_label, "テンプレートは登録されていません", "テンプレートは登録されていません。"), _defineProperty(_label, "お気に入りグループに追加しました", "{{ name }}をフォローしました。"), _defineProperty(_label, "お気に入りグループから削除しました", "{{ name }}のフォローを外しました。"), _defineProperty(_label, "お気に入りユーザに追加しました", "{{ name }}をフォローしました。"), _defineProperty(_label, "新着メッセージがあります", "{{name}}さんから新着メッセージがあります。"), _defineProperty(_label, "お気に入りユーザから削除しました", "{{ name }}のフォローを外しました。"), _defineProperty(_label, "投稿をブロックしました", "{{ name }}の投稿をブロックしました。"), _defineProperty(_label, "投稿をブロック解除しました", "{{ name }}の投稿をブロック解除しました。"), _defineProperty(_label, "ユーザをブロックしました", "{{ name }}をブロックしました。"), _defineProperty(_label, "ユーザをブロック解除しました", "{{ name }}をブロック解除しました。"), _defineProperty(_label, "ブロックされたユーザはありません", "ブロックされたユーザはいません。"), _defineProperty(_label, "ブロックされたユーザ", "ブロックされたユーザ"), _defineProperty(_label, "お気に入り登録されたユーザはありません", "フォローしているユーザはいません。"), _defineProperty(_label, "お気に入り登録されたグループはありません", "フォローしているグループはありません。"), _defineProperty(_label, "すでにフォロー設定済みです", "すでにフォロー設定済みです。"), _defineProperty(_label, "自身のフォローはできません", "自身のフォローはできません。"), _defineProperty(_label, "投稿があった時", "日報やKPI・ノートの投稿があった時"), _defineProperty(_label, "コメントがあった時", "自分の投稿にコメントがあった時"), _defineProperty(_label, "いいねがあった時", "自分の投稿にいいね！があった時"), _defineProperty(_label, "投稿があった時app", "投稿"), _defineProperty(_label, "コメントがあった時app", "自分の投稿へのコメント"), _defineProperty(_label, "いいねがあった時app", "自分の投稿へのいいね"), _defineProperty(_label, "返信があった時", "自分のコメントに返信があった時"), _defineProperty(_label, "読んでみてがあった時", "読んでみて！が自分に送られた時"), _defineProperty(_label, "読んでみてが開封された時", "自分の送った読んでみて！が開封された時"), _defineProperty(_label, "お気に入りに投稿があった時", "フォローしているグループ/ユーザに投稿があった時"), _defineProperty(_label, "チャットを受信した時", "チャットを受信した時"), _defineProperty(_label, "返信があった時app", "いいね！やコメント返信"), _defineProperty(_label, "読んでみてがあった時app", "読んでみて！"), _defineProperty(_label, "読んでみてが開封された時app", "読んでみて！の開封通知"), _defineProperty(_label, "お気に入りに投稿があった時app", "フォロー先での投稿"), _defineProperty(_label, "チャットを受信した時app", "チャット"), _defineProperty(_label, "通知none", "通知しない"), _defineProperty(_label, "通知mail", "メール通知"), _defineProperty(_label, "通知push", "アプリ通知"), _defineProperty(_label, "通知all", "すべてに通知"), _defineProperty(_label, "メール", "メール"), _defineProperty(_label, "アプリ", "アプリ"), _defineProperty(_label, "共通設定", "共通設定"), _defineProperty(_label, "通知スケジュールを設定する", "通知スケジュールを設定する"), _defineProperty(_label, "通知スケジュールを設定文言", "ここで設定した時間に通知が届きます。それ以外の時間は通知が一時停止されます。"), _defineProperty(_label, "時間", "時間"), _defineProperty(_label, "各グループの通知設定", "グループの通知設定"), _defineProperty(_label, "グループの通知設定を変更しました", "{{ name }}への通知設定を変更しました。"), _defineProperty(_label, "通知設定を変更しました", "通知設定を変更しました。"), _defineProperty(_label, "一括変更しました", "全グループの通知設定を一括変更しました。"), _defineProperty(_label, "チャット通知設定", "チャット通知設定(トースト表示)"), _defineProperty(_label, "通知を表示", "通知を表示"), _defineProperty(_label, "内容を表示", "内容を表示"), _defineProperty(_label, "通知", "通知"), _defineProperty(_label, "gambaから", "gamba!から"), _defineProperty(_label, "通知がありません", "通知がありません。"), _defineProperty(_label, "一括設定", "一括設定"), _defineProperty(_label, "一括設定説明", "すべてのグループのアプリ通知、メール通知設定を一括で切り替えます。"), _defineProperty(_label, "昨日の日報", "前回の日報をコピー"), _defineProperty(_label, "昨日の投稿内容", "前回の投稿内容をコピー"), _defineProperty(_label, "検索条件", "検索条件"), _defineProperty(_label, "保存された検索条件", "保存された検索条件"), _defineProperty(_label, "検索条件を保存", "この条件を保存"), _defineProperty(_label, "保存", "保存"), _defineProperty(_label, "新しい検索条件", "新しい検索条件"), _defineProperty(_label, "検索条件を削除", "検索条件を削除"), _defineProperty(_label, "検索条件を編集", "検索条件を編集"), _defineProperty(_label, "検索条件を削除してもいいですか", "{{ name }}を削除してもよろしいですか?"), _defineProperty(_label, "ノートのタイトル", "タイトル (例: 議事録・商談記録・業務連絡など)"), _defineProperty(_label, "検索条件を削除しました", "{{ name }}を削除しました。"), _defineProperty(_label, "検索条件を保存しました", "検索条件を保存しました。"), _defineProperty(_label, "チャットの履歴がありません", "チャットの履歴がありません。"), _defineProperty(_label, "チャットを開始", "チャットを開始"), _defineProperty(_label, "チャットの宛先を追加", "チャットの宛先を追加"), _defineProperty(_label, '\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0', "メンバーを追加"), _defineProperty(_label, "メンバーを削除", "{{ name }}をこのチャットから削除します。"), _defineProperty(_label, "チャットルームから削除", "{{ name }}をチャットルームから削除しました。"), _defineProperty(_label, "チャットルームを削除します", "この会話の履歴がすべて削除されます。"), _defineProperty(_label, "チャットルームを削除していいですか", "チャットルームを削除してもよろしいですか？"), _defineProperty(_label, "チャットルームを削除しました", "{{ name }}とのチャットを削除しました。"), _defineProperty(_label, "グループをごみ箱に移動", "このグループがごみ箱に移動されます。"), _defineProperty(_label, "グループをごみ箱に移動してもよろしいですか", "グループをごみ箱に移動してもよろしいですか？"), _defineProperty(_label, "ごみ箱に移動トースト", "{{ name }}のグループをごみ箱に移動しました。"), _defineProperty(_label, "この操作はグループに参加している全てのユーザーに影響します", "この操作はグループに参加している全てのユーザーに影響します。"), _defineProperty(_label, "この操作はグループに参加している全てのユーザーに影響します(復元説明付)", "この操作はグループに参加している全てのユーザーに影響します。\nグループを完全に削除もしくは復元するには、アカウント管理画面で「完全に削除」「ごみ箱から戻す」の操作が必要です。"), _defineProperty(_label, "完全削除復元説明文", "グループを完全に削除もしくは復元するには、アカウント管理画面で「完全に削除」「ごみ箱から戻す」の操作が必要です。"), _defineProperty(_label, "このチャットは終了しました", "このチャットは終了しています。"), _defineProperty(_label, "この操作はチャットルームに参加している全てのユーザーに影響します", "この操作はチャットルームに参加している全てのユーザーに影響します。"), _defineProperty(_label, "ユーザとのチャット", "{{ name }}とのチャット"), _defineProperty(_label, "既読n", "既読{{ n }}"), _defineProperty(_label, "メッセージを削除", "メッセージを削除します。"), _defineProperty(_label, "メッセージをコピー", "メッセージをコピー"), _defineProperty(_label, '\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u524A\u9664', "メッセージを削除"), _defineProperty(_label, "メッセージを入力してください", "メッセージを入力してください。"), _defineProperty(_label, "メッセージがありません", "メッセージがありません。"), _defineProperty(_label, "KPIの実績値を更新しました", "{{ reported_at }}の{{ name }}の実績値を更新しました。"), _defineProperty(_label, "この値は変更できない", "{{ group_name }}グループのメンバーではないので、値を変更することはできません。"), _defineProperty(_label, "アップロード中", "アップロード中..."), _defineProperty(_label, "クリップボードにコピーしました", "クリップボードにコピーしました。"), _defineProperty(_label, "最新版に更新します", "最新版に更新する必要があります。"), _defineProperty(_label, "再読み込み", "再読み込み"), _defineProperty(_label, "ここをクリックして招待してみよう", "ここをクリックして、社員のみなさんをいますぐgamba!に招待しましょう。"), _defineProperty(_label, "ここをクリックして日報を投稿してみよう", "「日報を投稿する」をクリックして、いますぐ日報を投稿してみましょう。"), _defineProperty(_label, "名前を変更", "名前を変更"), _defineProperty(_label, "チャットルーム名を変更", "{{ name }}に変更しました。"), _defineProperty(_label, "チャットルーム名", "チャットルーム名"), _defineProperty(_label, "カレンダーを開く", "カレンダーを開く"), _defineProperty(_label, "ファイルの添付", "ファイルを添付する"), _defineProperty(_label, "カメラで撮影", "カメラで撮影"), _defineProperty(_label, '\u5199\u771F\u52D5\u753B\u3092\u9078\u629E', "写真・動画を選択"), _defineProperty(_label, "削除したメンバーのみを表示", "削除したメンバーのみを表示"), _defineProperty(_label, "Googleドキュメント", "Googleドキュメント"), _defineProperty(_label, "Googleドキュメントに接続", "Googleドキュメントに接続"), _defineProperty(_label, "退室", "退室"), _defineProperty(_label, "削除", "削除"), _defineProperty(_label, '\u30D6\u30ED\u30C3\u30AF', "ブロック"), _defineProperty(_label, '\u30D6\u30ED\u30C3\u30AF\u89E3\u9664', "解除"), _defineProperty(_label, "上書き", "上書き"), _defineProperty(_label, "外す", "外す"), _defineProperty(_label, "チャットルーム設定", "チャットルーム設定"), _defineProperty(_label, "退室してもいいですか", "チャットルームから退室してもよろしいですか?"), _defineProperty(_label, "退室しました", "チャットルームから退室しました。"), _defineProperty(_label, "別ウィンドウで表示", "別ウィンドウで表示"), _defineProperty(_label, "次ページへ", "次ページへ"), _defineProperty(_label, "前ページへ", "前ページへ"), _defineProperty(_label, "拡大", "拡大"), _defineProperty(_label, "縮小", "縮小"), _defineProperty(_label, "元に戻す", "元に戻す"), _defineProperty(_label, "投稿の取得に失敗しました", "投稿の取得に失敗しました。"), _defineProperty(_label, "通知の取得に失敗しました", "通知の取得に失敗しました。"), _defineProperty(_label, "添付ファイルの取得に失敗しました", "添付ファイルの取得に失敗しました。"), _defineProperty(_label, "メンバーの取得に失敗しました", "メンバーの取得に失敗しました。"), _defineProperty(_label, "データの取得に失敗しました", "データの取得に失敗しました。"), _defineProperty(_label, "KPIの取得に失敗しました", "KPIの取得に失敗しました。"), _defineProperty(_label, "日報提出状況の取得に失敗しました", "日報提出状況の取得に失敗しました。"), _defineProperty(_label, "チャットルームの取得に失敗しました", "チャットルームの取得に失敗しました。"), _defineProperty(_label, "メッセージの取得に失敗しました", "メッセージの取得に失敗しました。"), _defineProperty(_label, "Googleカレンダーの取得に失敗しました", "Googleカレンダーの取得に失敗しました。"), _defineProperty(_label, "Outlookカレンダーの取得に失敗しました", "Outlookカレンダーの取得に失敗しました。"), _defineProperty(_label, "予定がないため貼付けできません", "予定がないため貼付けできません。"), _defineProperty(_label, "メンバー入室", "{{ name }}が参加しました。"), _defineProperty(_label, "メンバー退室", "{{ name }}が退室しました。"), _defineProperty(_label, "フォトライブラリに保存しました", "添付画像を保存しました。"), _defineProperty(_label, "LINEで招待", "LINEで招待"), _defineProperty(_label, "メールで招待", "メールで招待"), _defineProperty(_label, "表示しない", "今後、表示しない"), _defineProperty(_label, "招待メッセージ", "「日報共有アプリgamba!」に招待します。\n以下のリンクをクリックして登録してください。(iPhone・Androidをご利用の方はChrome・Safariなどのブラウザ専用アプリを使用してください。)"), _defineProperty(_label, "ウェルカムメッセージ", "無料Webコンサルティング実施中"), _defineProperty(_label, "無料ウェブ説明", "貴社に合った日報テンプレートをお作りします！"), _defineProperty(_label, "ウェブ説明詳細", "基本的な操作説明もOK！\nお気軽にお申込みください。"), _defineProperty(_label, "ウェブ説明予約", "WEBコンサルティングを予約する\n(ブラウザを起動します。)"), _defineProperty(_label, "ウェブ説明予約(WEB版)", "WEBコンサルティングを予約する"), _defineProperty(_label, "メールSubject", "{{name}}さんから「日報共有アプリgamba!」への招待が届いています。"), _defineProperty(_label, "投稿を見る", "投稿を見る"), _defineProperty(_label, "月次提出推移", "日報提出数の月次推移"), _defineProperty(_label, '\u65E5\u5831\u63D0\u51FA\u72B6\u6CC1', "日報提出状況"), _defineProperty(_label, "前月", "前月"), _defineProperty(_label, "翌月", "翌月"), _defineProperty(_label, "月間サマリー", "{{ name }}　日報提出状況"), _defineProperty(_label, "月間日報提出状況を表示", "月間の日報提出状況を見る"), _defineProperty(_label, "月", "月"), _defineProperty(_label, "火", "火"), _defineProperty(_label, "水", "水"), _defineProperty(_label, "木", "木"), _defineProperty(_label, "金", "金"), _defineProperty(_label, "土", "土"), _defineProperty(_label, "日", "日"), _defineProperty(_label, '\u5408\u8A08', "合計"), _defineProperty(_label, "年月", "{{ year }} 年 {{ month }} 月"), _defineProperty(_label, "日報アイコン", "：日報"), _defineProperty(_label, "KPIアイコン", "：KPI"), _defineProperty(_label, "ノートアイコン", "：ノート"), _defineProperty(_label, "トライアル期間が終了しました", "無料トライアル期間が終了しました。"), _defineProperty(_label, "トライアルの有効期限", "トライアルの有効期限"), _defineProperty(_label, "残りX日", "残り{{ dates }}日"), _defineProperty(_label, "プラン変更", "プラン変更"), _defineProperty(_label, "トライアル最終日です", "トライアル最終日です。"), _defineProperty(_label, "gamba!をご利用いただきありがとうございました", "gamba!をご利用いただきありがとうございました。"), _defineProperty(_label, "引き続き利用するには契約が必要です", "引き続きご利用いただくためには、契約のお申し込みが必要です。"), _defineProperty(_label, "契約する", "いますぐ契約を申し込む"), _defineProperty(_label, "タイムゾーン", "タイムゾーン"), _defineProperty(_label, "言語", "言語"), _defineProperty(_label, "通知アイコン", "通知"), _defineProperty(_label, "日報提出状況アイコン", "提出状況"), _defineProperty(_label, "KPI進歩状況アイコン", "KPI"), _defineProperty(_label, "チャットアイコン", "チャット"), _defineProperty(_label, "MAXページまでを表示しています", "1〜50ページまでを表示しています。これ以降はファイルをダウンロードしてご覧ください。"), _defineProperty(_label, "KPIを選択してください", "KPIを選択してください"), _defineProperty(_label, "KPIが選択されていません", "KPIが選択されていません"), _defineProperty(_label, "投稿種別", "投稿種別"), _defineProperty(_label, "文字サイズ変更", "文字サイズ変更"), _defineProperty(_label, "端末設定が開きます。よろしいですか？", "端末設定が開きます。よろしいですか？"), _defineProperty(_label, "プロフィールを編集", "プロフィールを編集"), _defineProperty(_label, "自己紹介", "自己紹介"), _defineProperty(_label, "プロフィールテンプレートを使用する", "プロフィールテンプレートを使用する"), _defineProperty(_label, "プロフィールを登録する", "テンプレートを使用してプロフィールを登録する"), _defineProperty(_label, "プロフィールテンプレート", "プロフィールテンプレートを使用します。よろしいですか？"), _defineProperty(_label, "編集内容破棄タイトル", "編集中の内容が{{ name }}されていません。破棄しますか？"), _defineProperty(_label, "編集内容破棄説明", "登録するには「取り消し」を押して「{{ name }}」ボタンを押してください。"), _defineProperty(_label, "破棄", "破棄"), _defineProperty(_label, "投稿の編集が完了しました", "投稿の編集が完了しました。"), _defineProperty(_label, "投稿しました", "投稿しました。"), _defineProperty(_label, "お客様のトライアル期間は終了しました", "お客様のトライアル期間は終了しました。"), _defineProperty(_label, "再度利用するにはもう一度トライアルをしてください", "gamba!をご利用いただきありがとうございました。改めてご登録いただくことで再び無料トライアルが可能です。下部の「無料トライアルを始める」よりお申し込みください。"), _defineProperty(_label, "【アプリ】再度利用するにはもう一度トライアルをしてください", "gamba!をご利用いただきありがとうございました。改めてご登録いただくことで再び無料トライアルが可能です。"), _defineProperty(_label, "ご契約を希望のお客様", "ご契約を希望のお客様は"), _defineProperty(_label, "こちら", "こちら"), _defineProperty(_label, "お申し込みください", "よりお申し込みください。"), _defineProperty(_label, "無料トライアルを始める", "無料トライアルを始める"), _defineProperty(_label, "全ての端末でログアウト", "全ての端末でログアウトする"), _defineProperty(_label, "入力内容不備", "入力内容に不備があります。"), _defineProperty(_label, '\u30EA\u30A2\u30AF\u30B7\u30E7\u30F3', "リアクション"), _defineProperty(_label, "下書き保存", "下書き保存が完了しました。"), _defineProperty(_label, "他n件のKPIをすべて表示", "他{{ n }}件のKPIをすべて表示"), _defineProperty(_label, "対象ユーザーはこのグループに所属していません", "対象ユーザーはこのグループに所属していません。"), _defineProperty(_label, '\u901A\u77E5\u8A2D\u5B9A', "通知設定"), _defineProperty(_label, "対応するアプリがない", "対応するアプリがないため、ファイルを開くことができません。\n詳細はサポートサイトをご確認ください。"), _defineProperty(_label, "ファイルを開けません", "ファイルを開くことができません"), _defineProperty(_label, "サポートサイトを開く", "サポートサイトを開く"), _defineProperty(_label, "ファイルはまだ処理中", "このファイルはまだ処理中です。しばらくしてからもう一度お試しください。"), _defineProperty(_label, "ファイルが読み込めない", "このファイルは読み込めません。"), _defineProperty(_label, "グループ所属", "グループメンバーのみ表示"), _defineProperty(_label, "グループ(未読)", "グループ(未読)"), _defineProperty(_label, "未読のみ表示", "未読のみ表示"), _defineProperty(_label, "未読グループがありません", "未読グループがありません"), _defineProperty(_label, "提出予定", "提出予定"), _defineProperty(_label, "月間サマリー編集モード", "{{ name }}　日報提出状況/編集"), _defineProperty(_label, "提出予定登録説明", "チェックを入れると提出予定が登録されます。"), _defineProperty(_label, "提出予定登録", "提出予定が登録されました。"), _defineProperty(_label, "平日をすべて選択", "平日をすべて選択"), _defineProperty(_label, "リニューアル", "リニューアル中。\n今しばらく、お待ちください。"), _defineProperty(_label, "リニューアル中", "リニューアル中。"), _defineProperty(_label, "お待ちください", "今しばらく、お待ちください。"), _defineProperty(_label, "レポート", "レポート"), _defineProperty(_label, "日報の提出予定人数", "日報の提出予定人数"), _defineProperty(_label, "週間レポート", "週間レポート"), _defineProperty(_label, "月間レポート", "月間レポート"), _defineProperty(_label, "週間レポートを出力する", "週間レポートを出力する"), _defineProperty(_label, "月間レポートを出力する", "月間レポートを出力する"), _defineProperty(_label, "週間レポート出力開始日", "週間レポート出力開始日"), _defineProperty(_label, "月間レポート出力開始日", "月間レポート出力開始日"), _defineProperty(_label, "レポート設定を更新しました", "レポート設定を更新しました"), _defineProperty(_label, "日報の提出数がなし", "この期間に投稿がありませんでした。運用方法の検討はgamba!運営まで是非ご相談ください！"), _defineProperty(_label, "日報の提出数が90%以上", "素晴らしい投稿率です！この調子で継続していきましょう！"), _defineProperty(_label, "日報の提出数が増加", "前期間より好調です！投稿率90％を目指していきましょう！"), _defineProperty(_label, "日報の提出数が減少", "前期間より投稿が減少しています。皆さんの投稿、お待ちしています！"), _defineProperty(_label, "レスポンスなし", "レスポンスがないようです。まずは「いいね!」からポチッと！"), _defineProperty(_label, "日毎集計", "日毎集計"), _defineProperty(_label, "累計説明", "期間内の実績値を累計グラフで表示します。"), _defineProperty(_label, "文字の大きさ", '文字の大きさ'), _defineProperty(_label, "文字サイズ設定", "文字サイズ設定"), _defineProperty(_label, "文字サイズが保存されました", "文字サイズが保存されました。"), _defineProperty(_label, "グループ内の投稿数", "・投稿数: {{posts}}件"), _defineProperty(_label, "先月との投稿数の変化", "先月との投稿数の変化"), _defineProperty(_label, "投稿なし", "投稿はありませんでした。gamba!に関するご質問やご相談がございましたら、お気軽にサポートまでお声がけください！"), _defineProperty(_label, "投稿数50%未満", "チームの半分以上がまだ投稿していません。今日の出来事、ちょっとした気づきでもOKです！共有してみませんか？"), _defineProperty(_label, "投稿数50-89%", "着実な投稿率です！あと一歩で90%達成です。チーム全員での情報共有を目指しましょう！"), _defineProperty(_label, "投稿数90%以上", "すばらしい投稿率です！チーム全員で情報共有ができています！✨"), _defineProperty(_label, "具体的な提出状況", "具体的な提出状況はこちらからご覧ください。"), _defineProperty(_label, "大幅減少（-20%以上）", "最近投稿が少なめです。短い投稿でもOK！気軽に共有していきましょう！"), _defineProperty(_label, "微減・現状維持（±10%）", "コンスタントな投稿、ありがとうございます。さらなる活性化を目指して、今日も一緒にgamba!していきましょう！"), _defineProperty(_label, "増加（+10%以上）", "投稿数が増加中です！みなさんの積極的な共有に感謝です！この調子で90％達成を目指しましょう！"), _defineProperty(_label, "反応なし", "みんなの投稿に反応してみましょう！まずは簡単な「いいね！」から！"), _defineProperty(_label, "いいねのみ", "「いいね！」ありがとうございます！スタンプやコメントで更にコミュニケーションを広げてみませんか？"), _defineProperty(_label, "多様な反応", "バランスの良い反応をありがとうございます！チームの絆が深まっています！"), _defineProperty(_label, "reaction_compare", "投稿へのリアクション数の先月との比較"), _defineProperty(_label, "反応減少（-20%以上）", "チームの交流が少し減っているようです。同僚の投稿にちょっとした一言を添えてみませんか？"), _defineProperty(_label, "反応現状維持（±10%）", "安定した交流が続いていますね。新しい発見や気づきをコメントで共有してみましょう！"), _defineProperty(_label, "反応増加（+10%以上）", "みなさんの活発な交流が増えています！このチームの雰囲気、素晴らしいですね！✨"), _defineProperty(_label, "投稿率算出", "提出予定日を設定することで、より正確に日報の提出状況を把握できます。"), _defineProperty(_label, "gamba!にご相談", "運用でお困りの際はいつでもgamba!にご相談ください！"), _defineProperty(_label, "gamba!活用サポート予約窓口", "gamba!活用サポート予約窓口"), _defineProperty(_label, "ご予約はこちら", "ご予約はこちら"), _defineProperty(_label, "提出状況", "提出状況"), _defineProperty(_label, "提出状況エクスポート", "提出状況エクスポート"), _defineProperty(_label, "週の投稿", "{{week_number}}週の投稿"), _defineProperty(_label, "こちらの使い方ガイド", "こちらの使い方ガイド"), _defineProperty(_label, "report_collection", "集計期間： {{start_date, date}}〜{{end_date, date}}"), _defineProperty(_label, "report_subject", "【{{month}}度 {{group_name}}グループ 投稿・リアクション レポート】"), _defineProperty(_label, "reaction_subject", "・投稿へのリアクション：いいね {{likes}}件、コメント・スタンプ {{comments}}件"), _defineProperty(_label, "パターン1", "{{posts}}件の投稿がありました。チームの活性度はいかがでしょうか？メンバーが気軽に投稿できる雰囲気づくりのため、管理者からコメントや「いいね」を送ってみましょう！"), _defineProperty(_label, "パターン2", "{{posts}}件の共有がありました。投稿の内容や質に変化は感じられましたか？いつもと違う気づきがある投稿には、特にコメントで反応してみましょう！"), _defineProperty(_label, "パターン3", "{{posts}}件の投稿がありました。普段あまり投稿しないメンバーの投稿にも目を向けてみましょう。その人ならではの視点に気づくかもしれません！"), _defineProperty(_label, "パターン4", "{{posts}}件の活動共有がありました。チーム内で特に反響が大きかった投稿はありましたか？そのような投稿のポイントを他のメンバーにもシェアしてみましょう！"), _defineProperty(_label, "パターン5", "{{posts}}件の投稿が集まりました。メンバー同士の情報共有が活発なトピックを見つけ、それを軸にした声がけをしてみるのはいかがでしょうか？"), _defineProperty(_label, "パターン6", "{{posts}}件の共有がありました。特に有益だった気づきはありましたか？そういった投稿にはコメントで具体的に感想を伝えてみましょう！"), _defineProperty(_label, "パターン7", "{{posts}}件の投稿がありました。チーム内でどんな話題が多かったでしょうか？注目の話題にコメントすることで、さらなる気づきの共有が生まれるかもしれません！"), _defineProperty(_label, "パターン8", "{{posts}}件の共有がありました。メンバー同士のコメントのやり取りは活発でしたか？興味深い議論には、管理者の視点からもコメントを添えてみましょう！"), _defineProperty(_label, "パターン9", "{{posts}}件の投稿がありました。朝一番の投稿や週初めの投稿への反応は、チームの1日、1週間のスタートを後押しします。積極的に声をかけてみましょう！"), _defineProperty(_label, "パターン10", "{{posts}}件の活動報告が集まりました。新しい取り組みや改善の報告には、特に丁寧なフィードバックを心がけてみませんか？"), _defineProperty(_label, "パターン11", "{{posts}}件の投稿がありました。困りごとや課題の共有には、チームの経験やナレッジを活かしたアドバイスで応援してみましょう！"), _defineProperty(_label, "パターン12", "{{posts}}件の共有がありました。他部署との連携や協力の話題には、特に注目してみましょう。横のつながりを広げるきっかけになるかもしれません！"), _defineProperty(_label, "パターン13", "{{posts}}件の投稿がありました。メンバーの成長や気づきが感じられる投稿はありましたか？そんな変化に気づいたら、具体的な言葉で認めてあげましょう！"), _defineProperty(_label, "パターン14", "{{posts}}件の投稿が集まりました。チーム内で共有されている工夫やテクニックを見つけたら、ぜひ「参考になります！」とコメントしてみましょう！"), _defineProperty(_label, "パターン15", "{{posts}}件の共有がありました。投稿の中から、チームの良い変化や成長を見つけ、みんなで共有してみませんか？"), _defineProperty(_label, "パターン16", "{{posts}}件の活動共有を確認しました。投稿時間帯に傾向はありますか？チームの活動リズムを把握して、タイムリーな声がけを心がけてみましょう！"), _defineProperty(_label, "パターン17", "{{posts}}件の投稿がありました。チームの雰囲気は感じ取れましたか？より活発なコミュニケーションのため、まずは管理者から率直な感想を伝えてみましょう！"), _defineProperty(_label, "パターン18", "{{posts}}件の共有がありました。個人の小さな工夫や改善の報告にも目を向けてみましょう。それがチーム全体の財産になるかもしれません！"), _defineProperty(_label, "レスポンスいいねのみ", "コメントやスタンプの活用で気持ちを伝えましょう！"), _defineProperty(_label, "レスポンス量増加", "gamba!が全期間より盛り上がっているようです！"), _defineProperty(_label, "レスポンス量減少", "レスポンスが減少傾向です。みんなで盛り上げていきましょう！"), _defineProperty(_label, "Section preferences have been updated", "セクションを更新しました。"), _defineProperty(_label, "Section", "一覧"), _defineProperty(_label, "Section(unread)", "一覧(未読)"), _defineProperty(_label, "Section name", "セクション名"), _defineProperty(_label, "Division visibility", "Division visibility"), _defineProperty(_label, "Group management", "グループ管理"), _defineProperty(_label, "Download", "ダウンロード"), _defineProperty(_label, "Move to trash", "ごみ箱に移動"), _defineProperty(_label, "persons_count", "{{ value }}人のメンバー"), _defineProperty(_label, "Section settings", "セクション設定"), _defineProperty(_label, "are_you_sure_you_want_to_move_the_division_to_trash", "このセクションがごみ箱に移動されます。\nセクションをごみ箱に移動してもよろしいですか？"), _defineProperty(_label, "this_operation_will_affect_all_users_participating_in_the_division", "この操作はセクションに参加している全てのグループに影響します。"), _defineProperty(_label, "complete_deletion_restoration_explanation", "セクションを完全に削除もしくは復元するには、アカウント管理画面で「完全に削除」「ごみ箱から戻す」の操作が必要です。"), _defineProperty(_label, "export_all_groups", "すべてのグループを抽出"), _defineProperty(_label, "既存グループを追加", "既存グループを追加"), _defineProperty(_label, "Select_group", "グループを選択"), _defineProperty(_label, "division_group_remove_consequence", "セクションから外しても過去の投稿は閲覧することができます。"), _defineProperty(_label, "can_i_remove_group", "{{ name }}をグループから外してもよろしいですか?"), _defineProperty(_label, "Return to linked section", "紐付いたセクションへ戻る"), _defineProperty(_label, "Move to first level", "第一階層へ移動する"), _defineProperty(_label, "選択できるグループがありません", "選択できるグループがありません"), _defineProperty(_label, "セクションなし", "セクションなし"), _defineProperty(_label, "AIレビュー", "AIレビュー(β版)"), _defineProperty(_label, "この情報は役に立ちましたか", "この情報は役に立ちましたか？"), _defineProperty(_label, "レポートお礼", "ご協力ありがとうございました！"), _defineProperty(_label, "レビューする", "レビューする"), _defineProperty(_label, "レビュー注意", "本アプリのAI技術は最善を尽くしておりますが、その応答には不正確さや誤解を招く可能性があります。"), _defineProperty(_label, "注意URL", "https://www.getgamba.com/info/archives/52230/"), _defineProperty(_label, "利用規約", "詳しくはこちら"), _defineProperty(_label, "拡張機能", "拡張機能"), _defineProperty(_label, "レビュー機能", "AIレビュー機能(β版)"), _defineProperty(_label, "レビュー機能ON", "AIレビュー機能(β版)は、現在ONになっています。利用停止するには、アカウント管理者にお問い合わせください。(アカウント管理画面 ＞ 詳細設定 ＞ 拡張機能設定より変更頂けます。)"), _defineProperty(_label, "レビュー機能OFF", "AIレビュー機能(β版)は、現在OFFになっています。利用するには、アカウント管理者にお問い合わせください。(アカウント管理画面 ＞ 詳細設定 ＞ 拡張機能設定より変更頂けます。)"), _label),
  error: {
    "メールアドレスを入力してください": "メールアドレスを入力してください。",
    "パスワードを入力してください": "パスワードを入力してください。",
    "確認コードを入力してください": "確認コードを入力してください",
    "タイトルを入力してください": "タイトルを入力してください。",
    "テンプレート名を入力してください": "テンプレート名を入力してください。",
    "本文を入力してください": "本文を入力してください",
    "ユーザ名を入力してください": "ユーザ名を入力してください。",
    "グループ名を入力してください": "グループ名を入力してください。",
    "KPI名を入力してください": "KPI名を入力してください。",
    "単位を入力してください": "単位を入力してください。",
    "目標値を入力してください": "目標値を入力してください。",
    "実績値を入力してください": "実績値を入力してください。",
    "フィールド種別を選択してください": "入力種別を選択してください。",
    "フィールド名を入力してください": "項目名を入力してください。",
    "フィールドの選択肢を入力してください": "入力項目の選択肢を1つ以上指定してください。",
    "入力されていません": "入力されていません。",
    "チャットルーム名を入力してください": "チャットルーム名を入力してください",
    fetch_error: "サーバに接続できません。ネットワークエラーが発生しました。",
    s3upload: "動画ファイルのアップロードに失敗しました。時間をおいて再度お試しください。",
    invalid_flie: "選択された一部のファイルはサポートされておりません",
    "サーバ切断": "サーバの接続が切断されました。再接続中です。",
    "サーバ接続": "サーバの接続が復旧しました。",
    "google-calendar-events": "Googleカレンダーの予定表が取得できません。",
    "google-calendar-list": "Googleカレンダーの予定表が取得できません。",
    "google-drive-folders": "Googleドライブのフォルダリストを取得できません。",
    "google-drive-userinfo": "Googleドライブのユーザー情報を取得できません。",
    "google-refresh-token": "refresh tokenが取得できません。",
    "fetch-scheduled-settings": "定期実行設定を取り込めません。",
    "update-scheduled-settings": "定期実行設定が更新できません。",
    "upload-google-drive-file": "Googleドライブにファイルをアップロードできません。",
    "画像の読み込みに失敗しました": "存在しないか表示できないファイルです。",
    "暗号化PDF説明": "* 暗号化されたファイルの場合、右上の　「別ウィンドウで表示」のアイコンから開ける可能性があります。",
    "読み込みに失敗しました": "データの読み込みに失敗しました。",
    "ファイルが選択されていません": "ファイルが選択されていないか、写真もしくはカメラへのアクセスが許可されていません。",
    "フォトライブラリに保存できませんでした": "添付画像の保存ができませんでした。",
    "データの送信に失敗しました": "投稿の送信に失敗しました。インターネット接続を確認し、再度お試しください。",
    "インターネット接続に問題があります": "インターネット接続が確認できないため、投稿の一時保存ができません。",
    "インターネット再接続": "インターネット再接続しています。投稿の一時保存まだ完了しておりません。",
    "インターネット接続を確認してください": "インターネットに接続された状態で再度お試しください。",
    "別の投稿を編集中です": "現在別の投稿を編集中のため、開くことができません。",
    "unavailable": "現在、gamba!はご利用いただけません。しばらくお待ちください。",
    "URLが開けません": "URLが開けません",
    "コピーして下さい": "下記より、リンクをコピーしてブラウザからアクセスして下さい。\n\n",
    "ファイルサイズが制限を超えています": "ファイルサイズが制限を超えています。{{ max_file_size }}以上のファイルはアップロードできません。",
    "MSアカウント": "お使いのMicrosoftアカウントはカレンダーに対応しておりません"
  },
  url: {
    "gambaにログインできない": "https://support.getgamba.com/hc/ja/articles/900001776883",
    "無料体験リンク": "https://www.getgamba.com/v3/registration/new",
    "attachmentInfo": "https://support.getgamba.com/hc/ja/articles/900005545463"
  },
  timezone: {
    "UTC-12": "ベーカー島 ハウランド島",
    "UTC-11": "アメリカ領サモア ニウエ",
    "UTC-10": "ハワイ アリューシャン列島西部",
    "UTC-9": "アラスカ",
    "UTC-8": "アメリカ・カナダ・メキシコ(太平洋時間)",
    "UTC-7": "アメリカ・カナダ・メキシコ(山岳部時間)",
    "UTC-6": "アメリカ・カナダ・メキシコ(中部時間) 中央アメリカ",
    "UTC-5": "アメリカ・カナダ(東部時間) キューバ ペルー",
    "UTC-4": "カナダ(大西洋時間) 小アンティル諸島の大部分 ベネズエラ ブラジル(アマゾン時間) チリ",
    "UTC-3": "ブラジル(ブラジル時間) アルゼンチン グリーンランド",
    "UTC-2": "ブラジル(フェルナンド・デ・ノローニャ島)",
    "UTC-1": "アゾレス諸島 カーボベルデ",
    "UTC+0": "イギリス アイルランド ポルトガル アイスランド アフリゃ�ロッコ ガーナ等",
    "UTC+1": "中央ヨーロッパ時間(フランス ドイツ等) 西アフリカ時間(ナイジェリア コンゴ等)",
    "UTC+2": "東ヨーロッパ時間(フィンランド ウクライナ ギリシャ等) 中央アフリカ時間 南アフリカ",
    "UTC+3": "ロシア(モスクワ) ベラルーシ サウジアラビア 東アフリカ時間",
    "UTC+4": "ロシア(サマラ) アゼルバイジャン グルジア アラブ首長国連邦 モーリシャス",
    "UTC+5": "ロシア(エカテリンブルグ) パキスタン",
    "UTC+6": "ロシア(オムスク) カザフスタン バングラディシュ",
    "UTC+7": "ロシア(クラスノヤルスク) タイ ベトナム インドネシア西部時間",
    "UTC+8": "ロシア(イルクーツク) 中国 モンゴル マレーシア オーストラリア西部時間",
    "UTC+9": "日本 ロシア(ヤクーツク) 韓国 パラオ",
    "UTC+10": "ロシア(ウラジオストク) グアム オーストラリア東部時間",
    "UTC+11": "ロシア(マガダン) ソロモン諸島 ニューカレドニア",
    "UTC+12": "ロシア(カムチャッカ) ニュージーランド フィジー キリバス(ギルバート諸島)",
    "UTC+13": "トンガ キリバス(フェニックス諸島) サモア トケラウ",
    "UTC+14": "キリバス(ライン諸島)"
  },
  language: {
    "ja": "日本語",
    "en": "英語"
  }
};

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _label;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/i18n/message-en.js

exports.default = {
  initialize: function initialize() {
    _moment2.default.locale('en');
    _moment2.default.updateLocale('en', {
      longDateFormat: {
        LLLL: "MMM Do YYYY, ddd",
        llll: "MMM Do, ddd",
        ll: "MMM, YYYY",
        l: "HH:mm"
      }
    });
  },
  message: {
    "ようこそ": "Welcome to gamba!", // gamba! にようこそ！
    "ログインしてください": "Please login.", // ログインしてください。
    "メンテナンス中": "Under maintenance now. \n\ngamba! is working day and night to improve its features. \n\nYou will be able to use gamba! \nPlease wait for a while. \nPlease see the following for the notification of maintenance from our company."
  },
  diary: {
    memo: "Note", // 'ノート',
    diary: "Daily", // '日報',
    kpi: "KPI", // 'KPI',
    "diaryを書く": "Post new daily", // 今日はどんな仕事をしましたか? ここをクリックして入力しましょう。
    "kpiを書く": "Post KPI report", // 今日のKPIは順調でしたか? ここをクリックして入力しましょう。
    "memoを書く": "Post new note", // どんな内容でしたか? ここをクリックして入力しましょう。
    "diaryを投稿": "I posted a daily report. good job for today!", //日報を投稿しました。お疲れ様でした！
    "kpiを投稿": "I posted a KPI. good job for today!", //KPIを投稿しました。お疲れ様でした！
    "memoを投稿": "I posted a note" //ノートを投稿しました。
  },
  format: {
    diary_subject: "{{category}} on {{reported_at, date}}", // {{ reported_at, date}}の {{category}}
    timestamp: "{{timestamp, fromNow}}", // {{ timestamp, fromNow }}
    savedAt: "Save to {{timestamp, fromNow}}", // {{ timestamp, fromNow }}に保存
    month: "MMM, YYYY"
  },
  calendar: {
    monthNames: 'January_February_March_April_May_June_July_August_September_October_November_December',
    monthNamesShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec',
    dayNames: 'Sun_Mon_Tue_Web_Thu_Fri_Sat',
    dayNamesShort: 'Sun_Mon_Tue_Web_Thu_Fri_Sat'
  },
  label: (_label = {
    "gamba": "Daily report application gamba!", // 日報アプリgamba!
    "株式会社gamba": "gamba, Inc.", // 株式会社gamba
    "無料": "Free", // 無料
    "ピックアップ": "Pick up", // ピックアップ
    "アプリ名": "gamba!", // gamba!
    "お問い合わせ": "Click here for other inquiries", // その他お問い合わせはこちら
    "ヘルプページを開く": "Open help page", // ヘルプページを開く
    "入門ガイドを開く": "Open Getting Started Guide", // 入門ガイドを開く
    "問い合わせる": "Contact support", // サポートに問い合わせ
    "アプリもあります": "Convenient smartphone app now! From here", // 便利なスマートフォンアプリはいますぐ！こちらから
    "お知らせがあります": "I have news", // お知らせがあります
    "更新が必要です": "Update required", // 更新が必要です
    "更新する": "Update", // 更新する
    "gambaで開く": "Open with gamba!", // gamba!で開く
    "サービスが更新されています": "The service has been updated. Reload now.", // サービスが更新されています。いますぐ、再読み込みを行なってください。
    "お知らせを開く": "Open announcement", // お知らせを開く
    "新着のお知らせ": "News of the latest arrival of gamba!", // gamba!の新着のお知らせ
    "新着のメッセージ": "Message from {{name}}", //  {{name}} さんからのメッセージ
    "添付ファイルが届いています": "The attached file has arrived.", // 添付ファイルが届いています。
    "メールアドレスを確認してください": "Please confirm your email address", // メールアドレスを確認ください
    "メールアドレスの確認が完了していません": "Email address verification not completed", // メールアドレスの確認が完了していません
    "メールアドレスの確認を行ってください": "Confirmation mail has been sent to your email address. Open this email and complete your email address verification. If you do not see the email, please resend it below.", // お客様のメールアドレス宛に「gamba! 登録のお知らせ」メールを送信しております。こちらのメールを開き、メールアドレスの確認を完了してください。もしメールが見当たらない場合は、以下より再送を行なってください。
    "確認メール再送": "Confirmation email resend", // 確認メール再送
    "サービスは現在ご利用いただけません": "Service is currently unavailable.", // サービスは現在ご利用いただけません。
    "お知らせページを開く": "Open notification page", // お知らせページを開く
    "メニュー": "Menu", // メニュー
    "検索結果": "Search results", // 検索結果
    "新着の通知": "New notifications", // 新着の通知
    "カレンダー": "Calendar",
    "カレンダー連携": "Connect to Calendar",
    "カレンダーを解除": "Cancel Calendar",
    "Googleカレンダー": "Google Calendar", // Googleカレンダー
    "Googleカレンダーに接続": "Connect to Google Calendar", // Googleカレンダーに接続
    "Googleドライブに接続する": "Connect to GoogleDrive", // Googleドライブに接続する
    "Googleカレンダーを解除": "Cancel Google Calendar", // Googleカレンダーを解除
    "Googleドライブに連携する": "Link To GoogleDrive", // Googleドライブに連携する
    "Googleドライブを解除": "Cancel GoogleDrive", // Googleドライブを解除
    "日報のエクスポートは最大1年分": "Daily reports can be exported for up to 1 year. Please perform the operation again.", // 日報のエクスポートは最大1年分をエクスポート可能です。再度、操作を行なってください。
    "Outlookカレンダー": "Outlook Calendar (Beta版)", // Outlookカレンダー (Beta版)
    "Outlookカレンダーに接続": "Connect to Outlook Calendar (Beta版))", // Outlookカレンダーに接続 (Beta版)
    "Outlookカレンダーを解除": "Cancel Outlook Calendar", // Outlookカレンダーを解除
    "説明を表示": "show explanation", // 説明を表示
    "時間を表示": "show time", // 時間を表示
    "貼付ヒント": "If you check it and press \"Paste\", the \"explanation\" of the schedule will be added.", //チェックを入れて「貼付け」を押すとその日程の「説明」が追加されます。
    "カレンダーの予定を貼り付けました": "Pasted calendar event", // カレンダーの予定を貼り付けました
    "予定がありません": "There is no plan.", // 予定がありません。
    "メンバーリスト": "Member list", //メンバーリスト
    "メンバーとミッション": "Members and missions", // メンバーとミッション
    "ミッションが設定されていません": "Mission not set.", // ミッションが設定されていません。
    "グループのメンバー": "{{name}} members", //  {{name}} のメンバー
    "メンバー": "member", // メンバー
    "メンバーを追加": "Add member", //メンバーを追加
    "設定": "setting", // 設定
    "日報提出状況": "Submission status", // 日報提出状況
    "インサイト": "Insights", // インサイト
    "アルバム": "album", //アルバム
    "データがありません": "No Data",
    "詳細をすべて表示": "View all details", // 詳細をすべて表示
    "KPI進捗状況": "KPI progress", // KPI進捗状況
    "KPIの進捗状況": "{{name}} progress", //  {{name}} の進捗状況
    "添付ファイル": "Attachments", // 添付ファイル
    "画像": "image", // 画像
    "動画・音声": "video・audio", // 動画
    "ファイル": "file" }, _defineProperty(_label, '\u30A2\u30EB\u30D0\u30E0', "album"), _defineProperty(_label, "ログイン", "Login"), _defineProperty(_label, "確認コード", "Confirmation code"), _defineProperty(_label, "確認コードについて", "6-digit confirmation code has sent to your email to verify your identity. Please check it."), _defineProperty(_label, "次へ", "Next"), _defineProperty(_label, "いますぐログイン", "Login now!"), _defineProperty(_label, "うまくログインできない時", "Can't log in? Have a look at this"), _defineProperty(_label, "無料体験に登録", "Is this your first time to use this app? Register for free trial here"), _defineProperty(_label, "無料体験の登録方法", "Click here to register for a free trial"), _defineProperty(_label, "このアプリについて", "About this app"), _defineProperty(_label, "アプリの説明", "Developed and operated daily report sharing application gamba!\nVersion: {{version}} ({{label}})\nOS: {{OS}}\nDevice: {{device}}\nModel: {{model}}"), _defineProperty(_label, "アプリの説明 モデル無し", "Developed and operated daily report sharing application gamba!\nVersion: {{version}} ({{label}})\nOS: {{OS}}\nDevice: {{device}}"), _defineProperty(_label, "アプリの説明(staging)", "Developed and operated daily report sharing application gamba!\nVersion: {{version}} ({{label}})\nOS: {{OS}}\nDevice: {{device}}\nModel: {{model}}\nStaging"), _defineProperty(_label, "アプリの説明 モデル無し(staging)", "Developed and operated daily report sharing application gamba!\nVersion: {{version}} ({{label}})\nOS: {{OS}}\nDevice: {{device}}\nStaging"), _defineProperty(_label, "メールアドレスを選択", "Select email address"), _defineProperty(_label, "パスワードの変更が必要です", "You need to change your password."), _defineProperty(_label, "パスワードを変更してログイン", "Change password and login"), _defineProperty(_label, "シングルサインオン認証を行ってください", "Authenticate through Single Sign On."), _defineProperty(_label, "メールアドレス", "Mail address"), _defineProperty(_label, "パスワード", "Password"), _defineProperty(_label, "個人設定", "User settings"), _defineProperty(_label, "グループ設定", "Group settings"), _defineProperty(_label, "グループ新規作成", "Create new group"), _defineProperty(_label, "プロフィール設定", "Profile settings"), _defineProperty(_label, "お気に入り登録", "Follow settings"), _defineProperty(_label, "フォロー", "Follow"), _defineProperty(_label, "フォロー中", "Following"), _defineProperty(_label, "お気に入りに追加", "To follow"), _defineProperty(_label, "お気に入りから削除", "Unfollow"), _defineProperty(_label, "ブロック", "block"), _defineProperty(_label, "ブロックリスト", "Block list"), _defineProperty(_label, "ブロック解除", "blocked"), _defineProperty(_label, "ユーザのブロック", "Block this user."), _defineProperty(_label, "ブロックユーザの解除", "Remove {{ name }} from this list."), _defineProperty(_label, "ユーザのブロック説明", "If you block, you will not see this user's posts in your All Posts or group timeline. You can unblock from the blocked user timeline or from \"Preferences\" > \"Block List\"."), _defineProperty(_label, "ブロックユーザの解除説明", "Once unblocked, you'll see this user's posts in your All Posts and group timelines."), _defineProperty(_label, "投稿のブロック", "Block this post."), _defineProperty(_label, "投稿のブロック解除", "Unblock this post."), _defineProperty(_label, "投稿のブロック説明", "If blocked, this post will not appear in your All Posts or group timeline. Unblocking can be done from the blocked user's timeline."), _defineProperty(_label, "投稿のブロック解除説明", "If unblocked, this post will be visible from all posts and group timelines."), _defineProperty(_label, "投稿ブロックされています", "This post has been blocked."), _defineProperty(_label, "ユーザブロックされています", "This user has been blocked."), _defineProperty(_label, "パスワード変更", "Change Password"), _defineProperty(_label, "パスワード再発行", "Don't know password? Click here for reissue"), _defineProperty(_label, "gambaについて", "Want to know more about gamba!"), _defineProperty(_label, "通知設定", "Notification settings"), _defineProperty(_label, "自分用テンプレート", "My template"), _defineProperty(_label, "共通テンプレート", "Common template"), _defineProperty(_label, "アカウント管理", "Account management"), _defineProperty(_label, "アカウント管理画面を開く", "Open account management screen"), _defineProperty(_label, "ログアウト", "Logout"), _defineProperty(_label, "ログアウトします", "Log out"), _defineProperty(_label, "基本設定", "Basic setting"), _defineProperty(_label, "メンバー管理", "Member management"), _defineProperty(_label, "KPI設定", "KPI settings"), _defineProperty(_label, "ごみ箱に移動", "Move to trash"), _defineProperty(_label, "ダウンロード", "Download"), _defineProperty(_label, "チャット", "Chat"), _defineProperty(_label, "チャットをする", "Start Chat"), _defineProperty(_label, "ご自身のユーザーでチャットを行うことはできません", "You cannot chat with your own users"), _defineProperty(_label, "対象ユーザーはこのチャットルームには参加していません。", "Target users are not participating in this chat room"), _defineProperty(_label, '\u65E5\u5831\u63D0\u51FA\u72B6\u6CC1', "Daily report submission status"), _defineProperty(_label, "未読の投稿", "Unread posts"), _defineProperty(_label, "未読の投稿があります", "There are {{unreadCount}} unread posts."), _defineProperty(_label, "未読の投稿がたくさんあります", "There are more than 10 unread posts."), _defineProperty(_label, "件", "Cases"), _defineProperty(_label, "件以上", "More than"), _defineProperty(_label, "すべて開封にする", "All opened"), _defineProperty(_label, "未読の投稿を開く", "Open unread posts"), _defineProperty(_label, "目標", "Goal"), _defineProperty(_label, "実績", "Performance"), _defineProperty(_label, "合計実績", "Total performance"), _defineProperty(_label, "累計", "Cumulative"), _defineProperty(_label, "達成率", "Achievement rate"), _defineProperty(_label, "合計達成率", "Total achievement rate"), _defineProperty(_label, "達成ライン", "100% Achievement line"), _defineProperty(_label, "合計", "Total"), _defineProperty(_label, "達成", "Achieved!"), _defineProperty(_label, "返信", "Reply"), _defineProperty(_label, "内容", "Content"), _defineProperty(_label, "添付", "Attachment"), _defineProperty(_label, "了解", "OK"), _defineProperty(_label, "完了", "Done"), _defineProperty(_label, "送信", "Submit"), _defineProperty(_label, "登録", "Register"), _defineProperty(_label, "更新", "Update"), _defineProperty(_label, "提出", "Submission"), _defineProperty(_label, "新規作成", "Create New"), _defineProperty(_label, "編集", "Edit"), _defineProperty(_label, "概要", "Overview"), _defineProperty(_label, "詳細", "Details"), _defineProperty(_label, "戻る", "Return"), _defineProperty(_label, "操作", "Operation"), _defineProperty(_label, "gambaアプリで開く", "Open this page with gamba!"), _defineProperty(_label, "アプリで開く", "Open with app"), _defineProperty(_label, "アプリをダウンロード", "Download app"), _defineProperty(_label, "アプリを使用しない", "Do not use gamba! app"), _defineProperty(_label, "クリックして値を更新", "Click to update value"), _defineProperty(_label, "アイコン画像", "Icon image"), _defineProperty(_label, "自分のミッション", "Your mission"), _defineProperty(_label, "グループのミッション", "Group Mission"), _defineProperty(_label, "写真動画を選択", "Select Image / Movie"), _defineProperty(_label, "ドキュメントを選択", "Select documents"), _defineProperty(_label, "ファイルを選択", "Select files"), _defineProperty(_label, "エクスポート", "Export"), _defineProperty(_label, "送信方法", "Sending Method"), _defineProperty(_label, "フォルダの選択", "Select Folder"), _defineProperty(_label, "保存先", "Save Location"), _defineProperty(_label, "メールに送信", "Send to Email"), _defineProperty(_label, "ローカルに保存", "Save Local"), _defineProperty(_label, "Refresh Token", "Refresh Token"), _defineProperty(_label, "Refresh Tokenの取得", "Get Refresh Token"), _defineProperty(_label, "Googleドライブが設定されていません", "GoogleDrive is not set up"), _defineProperty(_label, "連携済み", "Already linked"), _defineProperty(_label, "定期的にGoogleドライブへ自動保存する", "Save to GoogleDrive Automatically"), _defineProperty(_label, "定期実行設定", "Scheduled Execution Settings"), _defineProperty(_label, "定期実行", "Scheduled Execution"), _defineProperty(_label, "有効にする", "Activate"), _defineProperty(_label, "フォルダを選択して下さい1", "Select a folder"), _defineProperty(_label, "フォルダを選択して下さい", "---Select a folder---"), _defineProperty(_label, "期間設定", "Period Settings"), _defineProperty(_label, "日付", "Date"), _defineProperty(_label, "間隔", "Interval"), _defineProperty(_label, "週", "Week"), _defineProperty(_label, "月次", "Month"), _defineProperty(_label, "ユーザ", "A user"), _defineProperty(_label, "ユーザ名", "User name"), _defineProperty(_label, "社員番号", "Employee number"), _defineProperty(_label, "部署", "Department"), _defineProperty(_label, "誕生日", "Birthday"), _defineProperty(_label, "部署を選択", "Select department"), _defineProperty(_label, "誕生日を追加", "Add birthday"), _defineProperty(_label, "部署が設定されていません", "Department is not set. Contact your accountadministrator."), _defineProperty(_label, "グループ名", "Group name"), _defineProperty(_label, "セクション/グループ名を検索", "Search groups"), _defineProperty(_label, "並べ替え", "Sort"), _defineProperty(_label, "現在のパスワード", "Current password"), _defineProperty(_label, "新しいパスワード", "New password"), _defineProperty(_label, "新しいパスワード(再入力)", "New password (re-enter)"), _defineProperty(_label, "ミッションを入力してください", "Please enter a mission."), _defineProperty(_label, "メールアドレスを更新しました", "For confirmation, we sent an e-mail to gamba! Please confirm your e-mail address to your new e-mail address."), _defineProperty(_label, "メールアドレス確認待ち", "Changing email address to {{email}}."), _defineProperty(_label, "パスワードを更新しました", "Password updated."), _defineProperty(_label, "プロフィールを更新しました", "Your profile has been updated."), _defineProperty(_label, "グループの基本設定を更新しました", "Group preferences have been updated."), _defineProperty(_label, "グループを作成しました", "Group created."), _defineProperty(_label, "テンプレートを削除してもいいですか", "Are you sure you want to delete {{name}}?"), _defineProperty(_label, "グループの公開範囲", "Group visibility"), _defineProperty(_label, "セクション/グループはありません", "There are no sections/groups"), _defineProperty(_label, "ユーザ追加", "Add user"), _defineProperty(_label, "新規ユーザを招待", "Invite new user"), _defineProperty(_label, "既存ユーザを追加", "Add existing user"), _defineProperty(_label, "既存ユーザを追加します", "Add another registered user."), _defineProperty(_label, "メンバーは登録されていません", "Member is not registered."), _defineProperty(_label, "管理者", "Admin"), _defineProperty(_label, "一般ユーザ", "General user"), _defineProperty(_label, "一般ユーザに変更", "Change to general user"), _defineProperty(_label, "管理者に変更", "Change to admin"), _defineProperty(_label, "管理者に変更します", "Change {{ name }} to a group admin."), _defineProperty(_label, "一般ユーザに変更します", "Change {{ name }} to a general user."), _defineProperty(_label, "通知する", "Notice"), _defineProperty(_label, "通知しない", "Do not notify"), _defineProperty(_label, "リマインドを通知する", "Notify reminders"), _defineProperty(_label, "リマインドを通知しない", "Do not notify reminders"), _defineProperty(_label, "すべてのリマインド通知を送らない", "Do not send all reminders"), _defineProperty(_label, "リマインドの通知を停止します", "Stop reminders for {{name}}."), _defineProperty(_label, "リマインドの通知を開始します", "Start a reminder to {{name}}."), _defineProperty(_label, "ユーザを追加しました", "{{name}} has been added to this group."), _defineProperty(_label, "グループからユーザを削除しました", "{{name}} has been removed from this group."), _defineProperty(_label, "グループの管理権限を付与しました", "You have given {{ name }} control over this group."), _defineProperty(_label, "グループの管理権限を削除しました", "Removed group management permissions for {{name}}."), _defineProperty(_label, "ユーザへのリマインドメールの送信を開始します", "A reminder email has been sent to {{name}}."), _defineProperty(_label, "ユーザへのリマインドメールの送信を停止しました", "You have stopped sending reminders to {{name}}."), _defineProperty(_label, "ユーザを削除", "Remove from group members"), _defineProperty(_label, "ユーザを削除してもいいですか", "Are you sure you want to remove {{ name }} as a member?"), _defineProperty(_label, "ユーザを削除しても過去の投稿は閲覧することができます", "You can still view past posts even if you leave the group."), _defineProperty(_label, "アカウント管理画面から操作", "If you want to completely delete from [gamba!] Due to retirement, you need to operate from the account management screen."), _defineProperty(_label, "アカウント管理画面へ", "Go to account management screen"), _defineProperty(_label, "ユーザを選択", "Select user"), _defineProperty(_label, "開始日", "Start date"), _defineProperty(_label, "終了日", "End date"), _defineProperty(_label, "翌期分自動作成", "Next term copy start"), _defineProperty(_label, "Excelダウンロード", "Download in Excel format"), _defineProperty(_label, "Googleアカウント", "Google Account"), _defineProperty(_label, "アカウント", "Account"), _defineProperty(_label, "すべて抽出", "Extract all fields"), _defineProperty(_label, "KPIを作成", "Create KPI"), _defineProperty(_label, "現在のKPI", "Current KPI"), _defineProperty(_label, "終了したKPI", "Finished KPI"), _defineProperty(_label, "PDFで保存", "Save as PDF"), _defineProperty(_label, "画像で保存", "Save as Image"), _defineProperty(_label, "KPIデータ設定", "KPI Data Settings"), _defineProperty(_label, "データ選択", "Data Selection"), _defineProperty(_label, "KPIを追加", "+ Add KPI"), _defineProperty(_label, "積み上げ", "Stacked"), _defineProperty(_label, "積み上げ説明", "Each KPI within a period can be displayed in a stacked graph to check cumulative trends."), _defineProperty(_label, "個人データ", "Individual"), _defineProperty(_label, "個人データ説明", "Track individual employee goal attainment and performance in real time."), _defineProperty(_label, "歩留まり", "Conversion rate"), _defineProperty(_label, "歩留まり説明", "The percentage of achievement between selected KPIs (e.g., number of interviews to number of contracts) is displayed as a percentage, allowing you to understand the efficiency of the process."), _defineProperty(_label, "歩留まりライン", "100% Conversion line"), _defineProperty(_label, "比較", "Comparison"), _defineProperty(_label, "比較説明", "Displays actual differences from the same period of the previous year, allowing the user to check growth rates and areas for improvement."), _defineProperty(_label, "比較説明メッセージ", "Displays one year of actual differences from the same period in the selected year."), _defineProperty(_label, "使い方", "How To Use"), _defineProperty(_label, '\u4E26\u3079\u66FF\u3048', "Sorting"), _defineProperty(_label, "並べ替えを終了", "Finish sorting"), _defineProperty(_label, "並べ替え終了を選択", "When editing the KPI, select the End Sorting button."), _defineProperty(_label, "ドラッグして並べ替え", "You can rearrange the display order by dragging."), _defineProperty(_label, "長押しして並べ替え", "Press and hold to rearrange the display order"), _defineProperty(_label, "割り当てられていません", "Not assigned"), _defineProperty(_label, "目標値", "Target value: {{ value }}"), _defineProperty(_label, "目標値2", "Target value"), _defineProperty(_label, "担当者", "Rep"), _defineProperty(_label, "担当者の実績", "{{name}} achievements"), _defineProperty(_label, "KPIは登録されていません", "KPI is not registered."), _defineProperty(_label, "コピーして新規作成", "Copy and create new"), _defineProperty(_label, "コピーして翌期分を作成", "Copy to create next period"), _defineProperty(_label, "コピー", "(copy)"), _defineProperty(_label, "データごと削除", "Delete every data"), _defineProperty(_label, "KPIを削除しました", "{{name}} deleted"), _defineProperty(_label, "KPIを削除してもいいですか", "Are you sure you want to delete {{name}}?"), _defineProperty(_label, "実績値の集計方法", "Aggregation method of actual values"), _defineProperty(_label, "プレビュー", "Preview"), _defineProperty(_label, "プレビュー説明", "You will see the below table on the timeline."), _defineProperty(_label, "実績値を期間内で累計する", "Accumulate actual values within a period"), _defineProperty(_label, "実績値を日毎に集計する", "Aggregate actual values daily"), _defineProperty(_label, "実績値を期間内で累計の説明", "The entered actual values are accumulated within the period, and the achievement rate for the target value is calculated. This is usually selected for monthly sales goals."), _defineProperty(_label, "実績値を日毎に集計の説明", "The actual value entered is not accumulated, and the achievement rate is calculated for the daily target value. Select here for the number of calls per day."), _defineProperty(_label, "月次グラフ", "Monthly graph"), _defineProperty(_label, "日次グラフ", "Daily graph"), _defineProperty(_label, "年次", "Yearly"), _defineProperty(_label, '\u6708\u6B21', "Monthly"), _defineProperty(_label, "日次", "Daily"), _defineProperty(_label, "集計期間", "Aggregation period"), _defineProperty(_label, "集計日", "Aggregation date"), _defineProperty(_label, "グラフを表示", "Show graph"), _defineProperty(_label, "KPI名", "KPI name"), _defineProperty(_label, "その他のKPI", "Other KPIs"), _defineProperty(_label, "KPI名の説明", "Sales, profits, contracts, etc."), _defineProperty(_label, "期間", "Period"), _defineProperty(_label, "単位", "Unit"), _defineProperty(_label, "単位の説明", "Yen, matter, company, etc."), _defineProperty(_label, "単位の表示位置", "Unit diplay position"), _defineProperty(_label, "値の前に表示", "Show before value"), _defineProperty(_label, "値の後に表示", "Show after value"), _defineProperty(_label, "表示形式", "Value display format"), _defineProperty(_label, "担当者と目標値の割り当て", "Assign people and goals"), _defineProperty(_label, "すべて選択", "Select all"), _defineProperty(_label, "すべて解除", "Unselect all"), _defineProperty(_label, "同じ値を設定", "Set the same value"), _defineProperty(_label, "目標値を入力", "Enter target value"), _defineProperty(_label, "KPIを更新しました", "{{name}} has been updated."), _defineProperty(_label, "KPIを作成しました", "KPI created."), _defineProperty(_label, "KPIがありません", "KPI is not registered."), _defineProperty(_label, "開始日は終了日より前に設定してください", "Start date must be before end date."), _defineProperty(_label, "自動作成日は開始日より後に設定してください", "Automatic creation date must be before start date."), _defineProperty(_label, "自動作成日は終了日より前に設定してください", "Automatic creation date must be before end date."), _defineProperty(_label, "リマインド通知", "Remind notifications"), _defineProperty(_label, "リマインド", "Remind"), _defineProperty(_label, "リマインド通知時刻", "Reminder notification time"), _defineProperty(_label, "時ごろに通知", "Notify around {{time}}"), _defineProperty(_label, "リマインド通知日", "Day of the reminder notice"), _defineProperty(_label, "send_on_sun", "Sunday"), _defineProperty(_label, "send_on_mon", "Monday"), _defineProperty(_label, "send_on_tue", "Tuesday"), _defineProperty(_label, "send_on_wed", "Wednesday"), _defineProperty(_label, "send_on_thu", "Thursday"), _defineProperty(_label, "send_on_fri", "Friday"), _defineProperty(_label, "send_on_sat", "Saturday"), _defineProperty(_label, "send_on_holiday", "Holidays"), _defineProperty(_label, "個別リマインド通知", "Individual settings"), _defineProperty(_label, "リマインド通知の送信スケジュールを変更しました", "The schedule for sending remind notifications has been changed."), _defineProperty(_label, "検索キーワード", "Search keyword"), _defineProperty(_label, "検索", "Search"), _defineProperty(_label, "ユーザで絞り込み", "Filter by user"), _defineProperty(_label, "すべての投稿種別", "All post types"), _defineProperty(_label, "日報のみ", "Daily report only"), _defineProperty(_label, "KPIのみ", "KPI only"), _defineProperty(_label, "ノートのみ", "Notes only"), _defineProperty(_label, "オプション", "Optional"), _defineProperty(_label, "添付ファイル付き", "With attachment"), _defineProperty(_label, "いいねした投稿", "Liked posts"), _defineProperty(_label, "すべての期間の投稿", "Posts of all periods"), _defineProperty(_label, "日付の選択", "Select date"), _defineProperty(_label, "投稿日", "Posted date"), _defineProperty(_label, "より後の投稿", "After {{report_at}}"), _defineProperty(_label, "読み込み中", "Loading..."), _defineProperty(_label, "名前で検索", "Search by name ..."), _defineProperty(_label, "選択してください", "Please select"), _defineProperty(_label, "選択されていません", "Not selected"), _defineProperty(_label, "選択", "Choice"), _defineProperty(_label, "取り消し", "Cancel"), _defineProperty(_label, "閉じる", "Close"), _defineProperty(_label, "キャンセル", "Cancel"), _defineProperty(_label, "はい", "Yes!"), _defineProperty(_label, "いいえ", "No"), _defineProperty(_label, "OK", "OK"), _defineProperty(_label, "すべてのグループ", "All posts"), _defineProperty(_label, "グループ", "Groups"), _defineProperty(_label, "公開グループ", "Public groups"), _defineProperty(_label, "非公開グループ", "Private groups"), _defineProperty(_label, "その他", "その他"), _defineProperty(_label, "組織", "Organizations"), _defineProperty(_label, "公開グループの説明", "All users in the account can view the post."), _defineProperty(_label, "非公開グループの説明", "Only members of the group can view the post."), _defineProperty(_label, "グループを探す", "Find a group"), _defineProperty(_label, "隠す", "Hide"), _defineProperty(_label, "すべて表示", "View all"), _defineProperty(_label, "表示を隠す", "Hide display"), _defineProperty(_label, "もっと見る", "See more"), _defineProperty(_label, "続きを表示", "Show more"), _defineProperty(_label, "件のコメントをすべて表示", "Show previous {{ count }} comments"), _defineProperty(_label, "が返信しました", " replied・{{ count }} replies"), _defineProperty(_label, "が返信しました(1件)", " replied"), _defineProperty(_label, "件のコメントをすべて表示_plural", "Show {{ count }} comments"), _defineProperty(_label, "件の返信をすべて表示_plural", "Show {{ count }} replies"), _defineProperty(_label, "コメントを隠す", "Hide comments"), _defineProperty(_label, "返信を隠す", "Hide replies"), _defineProperty(_label, "テンプレートを選択", "Select template"), _defineProperty(_label, "テンプレート", "template"), _defineProperty(_label, "テンプレートを編集", "Edit template"), _defineProperty(_label, "user_templates_setting", "Creating Your Own Template"), _defineProperty(_label, "group_templates_setting", "Creating a group common template"), _defineProperty(_label, "下書き", "Draft ({{ count }})"), _defineProperty(_label, "下書きを選択", "Select draft"), _defineProperty(_label, "全て削除", "Delete All"), _defineProperty(_label, "入力フィールド", "Easy input items"), _defineProperty(_label, "form-dropdown", "Select from menu"), _defineProperty(_label, "form-text", "Text description (multiple lines)"), _defineProperty(_label, "form-string", "Text description (1 line)"), _defineProperty(_label, "form-numeric", "Numeric input"), _defineProperty(_label, "form-date", "Date input"), _defineProperty(_label, "form-time", "Time input"), _defineProperty(_label, "フィールドを追加", "Add input item"), _defineProperty(_label, "値", "Item value"), _defineProperty(_label, "必須", "Required input"), _defineProperty(_label, "フィールド種別", "Input type"), _defineProperty(_label, "フィールド名", "Input item name"), _defineProperty(_label, "値を入力してください", "Please fill in the value"), _defineProperty(_label, "未入力", "No value entered"), _defineProperty(_label, "新しいフィールド", "New input item"), _defineProperty(_label, "フィールドの選択肢", "Menu choices"), _defineProperty(_label, "ドロップダウン入力の場合の選択肢を改行で区切って列挙します", "Lists menu options, one per line."), _defineProperty(_label, "初期値を指定します", "Specify the initial value"), _defineProperty(_label, "初期値", "Initial value"), _defineProperty(_label, "絵文字を入力", "Enter emoji"), _defineProperty(_label, "終日", "All day"), _defineProperty(_label, "投稿種別を選択", "Select type"), _defineProperty(_label, "日報にコピー", "Paste"), _defineProperty(_label, "投稿作成", "Create Post"), _defineProperty(_label, "投稿を編集", "Edit post"), _defineProperty(_label, "投稿を報告", "Report post"), _defineProperty(_label, "投稿を削除", "Delete post"), _defineProperty(_label, "投稿を印刷", "Print post"), _defineProperty(_label, "投稿を翻訳", "Translate post"), _defineProperty(_label, "ピン留めされた投稿", "Pinned post"), _defineProperty(_label, "ピン留め", "Pin"), _defineProperty(_label, "ピン留め解除", "Unpin"), _defineProperty(_label, "ピン留め説明", "The post will be pinned to the top of the group timeline. Would you like to pin it?"), _defineProperty(_label, "ピン留め解除説明", "Would you like to undo the unpinning?"), _defineProperty(_label, "元の表示に戻す", "Show original post"), _defineProperty(_label, "翻訳", "(translated)"), _defineProperty(_label, "リンクをコピー", "Copy link"), _defineProperty(_label, "本文をコピー", "Copy text"), _defineProperty(_label, "ユーザブロック", "Block User"), _defineProperty(_label, "ユーザブロック解除", "Unblock User"), _defineProperty(_label, "投稿ブロック", "Block diary"), _defineProperty(_label, "投稿ブロック解除", "Unblock diary"), _defineProperty(_label, "クリップボードにコピー", "Copy to clipboard"), _defineProperty(_label, "宛先を追加", "Add recipient"), _defineProperty(_label, "編集済み", "(Edited)"), _defineProperty(_label, "編集時刻", "(Edit to {{updated}})"), _defineProperty(_label, "他n人", "and {{n}} "), _defineProperty(_label, "n", "{{ n }}"), _defineProperty(_label, "n人", "{{n}}person "), _defineProperty(_label, "複数n人", "{{n}}persons "), _defineProperty(_label, "がいいね", "Like !."), _defineProperty(_label, "が開封", " Opened."), _defineProperty(_label, "開封n", "{{ n }} Opened."), _defineProperty(_label, "開封n < 3", "Opened "), _defineProperty(_label, "が読んでみて", "Read on! from"), _defineProperty(_label, "に読んでみて", "Read on!"), _defineProperty(_label, "返信要求付き", "(Reply required)"), _defineProperty(_label, "がコメント", " comment"), _defineProperty(_label, "n件", "{{ n }} comment"), _defineProperty(_label, "クリックしてもっと見る", "See more attached photos ..."), _defineProperty(_label, "他n個の添付写真を開く", "See all {{ n }} other attached photos ..."), _defineProperty(_label, "開封", "Opened"), _defineProperty(_label, "投稿", "Posts"), _defineProperty(_label, "リアクション", "Reactions"), _defineProperty(_label, "投稿数", "N. of Posts"), _defineProperty(_label, "リアクション数", "N. of Reactions"), _defineProperty(_label, "1人平均", "Per users"), _defineProperty(_label, "投稿あたり", "Per posts"), _defineProperty(_label, "平均投稿数", "Avg. Posts"), _defineProperty(_label, "平均リアクション数", "Avg. Reactions"), _defineProperty(_label, "いいね", "Like !"), _defineProperty(_label, "ピン", "Pin"), _defineProperty(_label, "got_it", "Got it！"), _defineProperty(_label, "good_job", "Good job！"), _defineProperty(_label, "thanks", "Thanks！"), _defineProperty(_label, "good_luck", "Good luck！"), _defineProperty(_label, "regards", "Regards！"), _defineProperty(_label, "excellent", "Excellent！"), _defineProperty(_label, "disappointed", "Disappointed！"), _defineProperty(_label, "いいねを取り消す", "Undo Like !"), _defineProperty(_label, "いいねといっている人はまだいません", "No one likes it yet."), _defineProperty(_label, "読んでみてといっている人はまだいません", "No one has read it on yet."), _defineProperty(_label, "開封した人はまだいません", "No one has opened it yet."), _defineProperty(_label, "コメントした人はまだいません", "No one has comment it yet."), _defineProperty(_label, "返信した人はまだいません", "No one has reply it yet."), _defineProperty(_label, "時間前に開封", "{{timestamp}} opened"), _defineProperty(_label, "時間前にいいね", "Like for {{timestamp}}"), _defineProperty(_label, "時間前にリアクション", "{{ n }} for {{ timestamp }}"), _defineProperty(_label, "時間前に送信", "Sent to {{timestamp}}"), _defineProperty(_label, "時間前に返信", "Replied to {{timestamp}}"), _defineProperty(_label, "時間前にコメント", "Comment to {{ timestamp }}"), _defineProperty(_label, "時間前に返信(tab)", "Replied to {{ timestamp }}"), _defineProperty(_label, "ユーザのコメント", "{{name}} comments"), _defineProperty(_label, "コメント", "Comment"), _defineProperty(_label, "コメントを削除", "Delete Comment"), _defineProperty(_label, "コメントを編集", "Edit Comment"), _defineProperty(_label, "スタンプ", "Stamp"), _defineProperty(_label, "スタンプ追加", "Add stamp"), _defineProperty(_label, "を削除します", "Delete"), _defineProperty(_label, "読んでみて", "Read it!"), _defineProperty(_label, "読んでみての宛先を追加", "Read on! Add recipients"), _defineProperty(_label, "返信を要求", "Request a reply"), _defineProperty(_label, "保存された投稿を削除してもいいですか", "Are you sure you want to delete the temporarily saved post?"), _defineProperty(_label, "保存された全ての投稿を削除してもいいですか", "Are you sure you want to delete the all temporarily saved posts?"), _defineProperty(_label, "この投稿は削除されました", "This post has been deleted"), _defineProperty(_label, "日報を削除してもいいですか", "Are you sure you want to delete this post?"), _defineProperty(_label, "コメントを削除してもいいですか", "Are you sure you want to delete this comment?"), _defineProperty(_label, "この操作は取り消せません", "This operation cannot be undone. Please be careful."), _defineProperty(_label, "この投稿を通報してもよろしいですか", "Are you sure you want to report this post?"), _defineProperty(_label, "このコメントを通報してもよろしいですか", "Are you sure you want to report this comment?"), _defineProperty(_label, "このユーザを通報してもよろしいですか", "Are you sure you want to report this user?"), _defineProperty(_label, "コメントを入力してください", "Please enter a comment."), _defineProperty(_label, "投稿がありません", "There are no posts."), _defineProperty(_label, "フォルダがありません", "There is no folder."), _defineProperty(_label, "一番最後の投稿です", "There are no previous posts."), _defineProperty(_label, "よろしいですか？", "Is it OK?"), _defineProperty(_label, "テンプレート名", "Template name"), _defineProperty(_label, "テンプレートをインポート", "Import"), _defineProperty(_label, "テンプレートを上書きしていいですか", "Overwrite with the template?"), _defineProperty(_label, "テンプレートを作成しましょう", "Let's create a template."), _defineProperty(_label, "テンプレートを作成しました", "Template created."), _defineProperty(_label, "テンプレートを更新しました", "{{name}} has been updated."), _defineProperty(_label, "テンプレートを削除しました", "{{name}} has been deleted."), _defineProperty(_label, "テンプレートは登録されていません", "The template has not been registered."), _defineProperty(_label, "お気に入りグループに追加しました", "I followed {{name}}."), _defineProperty(_label, "お気に入りグループから削除しました", "You have unfollowed {{name}}."), _defineProperty(_label, "お気に入りユーザに追加しました", "I followed {{name}}."), _defineProperty(_label, "新着メッセージがあります", "You have a new message from {{name}}."), _defineProperty(_label, "お気に入りユーザから削除しました", "You have unfollowed {{name}}."), _defineProperty(_label, "投稿をブロックしました", "You block {{ name }}."), _defineProperty(_label, "投稿をブロック解除しました", "You unblock {{ name }}."), _defineProperty(_label, "ユーザをブロックしました", "You block {{ name }}."), _defineProperty(_label, "ユーザをブロック解除しました", "You unblock {{ name }}."), _defineProperty(_label, "ブロックされたユーザはありません", "There are no blocked users."), _defineProperty(_label, "ブロックされたユーザ", "Blocked users"), _defineProperty(_label, "お気に入り登録されたユーザはありません", "There are no followers."), _defineProperty(_label, "お気に入り登録されたグループはありません", "There are no groups you are following."), _defineProperty(_label, "すでにフォロー設定済みです", "You have already set up follow."), _defineProperty(_label, "自身のフォローはできません", "You cannot follow yourself."), _defineProperty(_label, "投稿があった時", "When a daily report, KPI, or note is posted"), _defineProperty(_label, "コメントがあった時", "When there is a comment on my post"), _defineProperty(_label, "いいねがあった時", "When you like something on your post"), _defineProperty(_label, "投稿があった時app", "投稿"), _defineProperty(_label, "コメントがあった時app", "自分の投稿へのコメント"), _defineProperty(_label, "いいねがあった時app", "自分の投稿へのいいね"), _defineProperty(_label, "返信があった時", "When you reply to your likes or comments"), _defineProperty(_label, "読んでみてがあった時", "When you read!"), _defineProperty(_label, "読んでみてが開封された時", "When your mention is opened"), _defineProperty(_label, "お気に入りに投稿があった時", "When a post is made to a group / user that you are following"), _defineProperty(_label, "チャットを受信した時", "When a chat is received"), _defineProperty(_label, "返信があった時app", "いいね！やコメント返信"), _defineProperty(_label, "読んでみてがあった時app", "読んでみて！"), _defineProperty(_label, "読んでみてが開封された時app", "When mention is opened"), _defineProperty(_label, "お気に入りに投稿があった時app", "フォロー先での投稿"), _defineProperty(_label, "チャットを受信した時app", "チャット"), _defineProperty(_label, "通知none", "Do not notify"), _defineProperty(_label, "通知mail", "Notify email"), _defineProperty(_label, "通知push", "Notify app"), _defineProperty(_label, "通知all", "Notify all"), _defineProperty(_label, "メール", "Mail"), _defineProperty(_label, "アプリ", "App"), _defineProperty(_label, "共通設定", "Common setting"), _defineProperty(_label, "通知スケジュールを設定する", "Set up a notification schedule"), _defineProperty(_label, "通知スケジュールを設定文言", "You will receive notifications at the time set here. Notifications will be paused at other times."), _defineProperty(_label, "時間", "Time"), _defineProperty(_label, "各グループの通知設定", "Group notification settings"), _defineProperty(_label, "グループの通知設定を変更しました", "Notification settings for {{ name }} have been changed."), _defineProperty(_label, "通知設定を変更しました", "Notification settings changed."), _defineProperty(_label, "一括変更しました", "Notification settings for all groups have been changed collectively."), _defineProperty(_label, "チャット通知設定", "Chat Notification (toast display)"), _defineProperty(_label, "通知を表示", "New Message"), _defineProperty(_label, "内容を表示", "View Content"), _defineProperty(_label, "通知", "Notification"), _defineProperty(_label, "gambaから", "From gamba!"), _defineProperty(_label, "通知がありません", "You have no notifications."), _defineProperty(_label, "一括設定", "Apply to all groups"), _defineProperty(_label, "一括設定説明", "すべてのグループのアプリ通知、メール通知設定を一括で切り替えます。"), _defineProperty(_label, "昨日の日報", "Copy previous daily report"), _defineProperty(_label, "昨日の投稿内容", "Copy the previous post"), _defineProperty(_label, "検索条件", "Search condition"), _defineProperty(_label, "保存された検索条件", "Saved search conditions"), _defineProperty(_label, "検索条件を保存", "Save this condition"), _defineProperty(_label, "保存", "Save"), _defineProperty(_label, "新しい検索条件", "New search criteria"), _defineProperty(_label, "検索条件を削除", "Delete search criteria"), _defineProperty(_label, "検索条件を編集", "Edit search criteria"), _defineProperty(_label, "検索条件を削除してもいいですか", "Are you sure you want to delete {{name}}?"), _defineProperty(_label, "ノートのタイトル", "Title (example)"), _defineProperty(_label, "検索条件を削除しました", "{{name}} has been deleted."), _defineProperty(_label, "検索条件を保存しました", "The search conditions have been saved."), _defineProperty(_label, "チャットの履歴がありません", "No chat history."), _defineProperty(_label, "チャットを開始", "Start chat"), _defineProperty(_label, "チャットの宛先を追加", "Add chat destination"), _defineProperty(_label, '\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0', "Add member"), _defineProperty(_label, "メンバーを削除", "Remove {{ name }} from this chat."), _defineProperty(_label, "チャットルームから削除", "{{name}} has been removed from the chat room."), _defineProperty(_label, "チャットルームを削除します", "This chat timeline will be deleted."), _defineProperty(_label, "チャットルームを削除していいですか", "Are you sure you want to delete the chat room?"), _defineProperty(_label, "チャットルームを削除しました", "Chat with {{ name }} has been deleted."), _defineProperty(_label, "グループをごみ箱に移動", "This group will be moved to trash."), _defineProperty(_label, "グループをごみ箱に移動してもよろしいですか", "Are you sure you want to move the group to trash?"), _defineProperty(_label, "ごみ箱に移動トースト", "Moved the {{ name }} group to the trash."), _defineProperty(_label, "この操作はグループに参加している全てのユーザーに影響します", "This operation affects all users participating in the group."), _defineProperty(_label, "この操作はグループに参加している全てのユーザーに影響します(復元説明付)", "この操作はグループに参加している全てのユーザーに影響します。グループを完全に削除もしくは復元するには、アカウント管理画面で「完全に削除」「ごみ箱から戻す」の操作が必要です。"), _defineProperty(_label, "完全削除復元説明文", "To delete completely or restore a group, you need to do the operations of \"Permanently delete\" or \"Return from trash\" on the account management screen."), _defineProperty(_label, "このチャットは終了しました", "This chat is over."), _defineProperty(_label, "この操作はチャットルームに参加している全てのユーザーに影響します", "This operation affects all users participating in the chat room"), _defineProperty(_label, "ユーザとのチャット", "Chat with {{name}}"), _defineProperty(_label, "既読n", "Open {{ n }}"), _defineProperty(_label, "メッセージを削除", "Delete the message."), _defineProperty(_label, '\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u524A\u9664', "Delete message"), _defineProperty(_label, "メッセージをコピー", "Copy message"), _defineProperty(_label, "メッセージを入力してください", "Please enter a message"), _defineProperty(_label, "メッセージがありません", "There are no messages."), _defineProperty(_label, "KPIの実績値を更新しました", "{{reported_at}} {{ name }} achievement values have been updated."), _defineProperty(_label, "この値は変更できない", "Since you are not a member of {{ group_name }} group, you cannot change the value."), _defineProperty(_label, "アップロード中", "Uploading ..."), _defineProperty(_label, "クリップボードにコピーしました", "Copied to clipboard."), _defineProperty(_label, "最新版に更新します", "You need to update to the latest version."), _defineProperty(_label, "再読み込み", "Reload"), _defineProperty(_label, "ここをクリックして招待してみよう", "Click here to invite your employees to gamba!"), _defineProperty(_label, "ここをクリックして日報を投稿してみよう", "Click 'Use Template' to post a sample daily report now."), _defineProperty(_label, "名前を変更", "Rename"), _defineProperty(_label, "チャットルーム名を変更", "Changed to {{name}}."), _defineProperty(_label, "チャットルーム名", "Chat room name"), _defineProperty(_label, "カレンダーを開く", "Open calendar"), _defineProperty(_label, "ファイルの添付", "Attach files"), _defineProperty(_label, "カメラで撮影", "Take a photo"), _defineProperty(_label, '\u5199\u771F\u52D5\u753B\u3092\u9078\u629E', "Select Image / Movie"), _defineProperty(_label, "削除したメンバーのみを表示", "Show only deleted members"), _defineProperty(_label, "Googleドキュメント", "Google Docs"), _defineProperty(_label, "Googleドキュメントに接続", "Connect to Google Docs"), _defineProperty(_label, "退室", "Exit"), _defineProperty(_label, "削除", "Delete"), _defineProperty(_label, '\u30D6\u30ED\u30C3\u30AF', "Block"), _defineProperty(_label, '\u30D6\u30ED\u30C3\u30AF\u89E3\u9664', "Unblock"), _defineProperty(_label, "上書き", "Overwrite"), _defineProperty(_label, "外す", "Remove"), _defineProperty(_label, "チャットルーム設定", "Chat room settings"), _defineProperty(_label, "退室してもいいですか", "Are you sure you want to leave the chat room?"), _defineProperty(_label, "退室しました", "You have left the chat room."), _defineProperty(_label, "別ウィンドウで表示", "Display in another window"), _defineProperty(_label, "次ページへ", "To the next page"), _defineProperty(_label, "前ページへ", "To previous page"), _defineProperty(_label, "拡大", "Expansion"), _defineProperty(_label, "縮小", "Reduction"), _defineProperty(_label, "元に戻す", "Undo"), _defineProperty(_label, "投稿の取得に失敗しました", "Post retrieval failed."), _defineProperty(_label, "通知の取得に失敗しました", "Failed to get notification."), _defineProperty(_label, "添付ファイルの取得に失敗しました", "Acquisition of the attached file failed."), _defineProperty(_label, "メンバーの取得に失敗しました", "Failed to get members."), _defineProperty(_label, "データの取得に失敗しました", "Acquisition of data failed."), _defineProperty(_label, "KPIの取得に失敗しました", "KPI acquisition failed."), _defineProperty(_label, "日報提出状況の取得に失敗しました", "Failed to get daily report submission status."), _defineProperty(_label, "チャットルームの取得に失敗しました", "Failed to get chat room."), _defineProperty(_label, "メッセージの取得に失敗しました", "Failed to get message."), _defineProperty(_label, "Googleカレンダーの取得に失敗しました", "Failed to get Google Calendar."), _defineProperty(_label, "Outlookカレンダーの取得に失敗しました", "Failed to get Outlook Calendar."), _defineProperty(_label, "予定がないため貼付けできません", "I can't paste because I have no plans"), _defineProperty(_label, "メンバー入室", "{{name}} has joined."), _defineProperty(_label, "メンバー退室", "{{name}} has left."), _defineProperty(_label, "フォトライブラリに保存しました", "The attached image has been saved."), _defineProperty(_label, "LINEで招待", "Invite with LINE"), _defineProperty(_label, "メールで招待", "Invite by email"), _defineProperty(_label, "表示しない", "Do not show again"), _defineProperty(_label, "招待メッセージ", "Invite to gamba! \nClick the link below to register."), _defineProperty(_label, "ウェルカムメッセージ", "Web Consulting For Free"), _defineProperty(_label, "無料ウェブ説明", "We will create daily report templates that suits your company!"), _defineProperty(_label, "ウェブ説明詳細", "Basic operation explanation is also OK!\nPlease feel free to apply."), _defineProperty(_label, "ウェブ説明予約", "book the web consulting\n(launch browser)"), _defineProperty(_label, "ウェブ説明予約(WEB版)", "book the web consulting"), _defineProperty(_label, "メールSubject", "{{name}} has sent you an invitation to the daily report sharing app gamba !."), _defineProperty(_label, "投稿を見る", "View posts"), _defineProperty(_label, "月次提出推移", "Monthly number of posts"), _defineProperty(_label, '\u65E5\u5831\u63D0\u51FA\u72B6\u6CC1', "Submission status"), _defineProperty(_label, "前月", "Previous"), _defineProperty(_label, "翌月", "Next"), _defineProperty(_label, "月間サマリー", "{{name}} Submission status"), _defineProperty(_label, "月間日報提出状況を表示", "View monthly submission status"), _defineProperty(_label, "月", "Mon"), _defineProperty(_label, "火", "Tue"), _defineProperty(_label, "水", "Wed"), _defineProperty(_label, "木", "Thu"), _defineProperty(_label, "金", "Fri"), _defineProperty(_label, "土", "Sat"), _defineProperty(_label, "日", "Sun"), _defineProperty(_label, '\u5408\u8A08', "Total"), _defineProperty(_label, "年月", "{{ year }} {{ month }}"), _defineProperty(_label, "日報アイコン", ":Daily report"), _defineProperty(_label, "KPIアイコン", ":KPI"), _defineProperty(_label, "ノートアイコン", ":Note"), _defineProperty(_label, "トライアル期間が終了しました", "The free trial period has expired."), _defineProperty(_label, "トライアルの有効期限", "Trial Expiration Date"), _defineProperty(_label, "残りX日", "Remaining {{ dates }} days"), _defineProperty(_label, "プラン変更", "Change Plan"), _defineProperty(_label, "トライアル最終日です", "It is the last day of the free trial period."), _defineProperty(_label, "gamba!をご利用いただきありがとうございました", "Thank you for using gamba !."), _defineProperty(_label, "引き続き利用するには契約が必要です", "To continue using the service, you need to apply for a contract."), _defineProperty(_label, "契約する", "Apply for a contract now"), _defineProperty(_label, "タイムゾーン", "Timezone"), _defineProperty(_label, "言語", "Language"), _defineProperty(_label, "通知アイコン", "Notification"), _defineProperty(_label, "日報提出状況アイコン", "Diaries"), _defineProperty(_label, "KPI進歩状況アイコン", "KPI"), _defineProperty(_label, "チャットアイコン", "Chat"), _defineProperty(_label, "MAXページまでを表示しています", "Showing from 1 to 50 page only."), _defineProperty(_label, "KPIを選択してください", "Please select a KPI"), _defineProperty(_label, "KPIが選択されていません", "KPI not selected"), _defineProperty(_label, "投稿種別", "Post type"), _defineProperty(_label, "文字サイズ変更", "Change the font size"), _defineProperty(_label, "端末設定が開きます。よろしいですか？", "The terminal settings will open. Is it OK ?"), _defineProperty(_label, "プロフィールを編集", "Edit profile"), _defineProperty(_label, "自己紹介", "self-introduction"), _defineProperty(_label, "プロフィールテンプレートを使用する", "Use profile template"), _defineProperty(_label, "プロフィールを登録する", "Register a profile"), _defineProperty(_label, "プロフィールテンプレート", "Use a profile template. Is it OK?"), _defineProperty(_label, "編集内容破棄タイトル", "The content is not {{ name }}. Do you want to discard?"), _defineProperty(_label, "編集内容破棄説明", "To register, press Cancel and press the {{ name }} button."), _defineProperty(_label, "破棄", "Discard"), _defineProperty(_label, "投稿の編集が完了しました", "Post editing is complete"), _defineProperty(_label, "投稿しました", "I posted."), _defineProperty(_label, "お客様のトライアル期間は終了しました", "Your trial period has expired."), _defineProperty(_label, "再度利用するにはもう一度トライアルをしてください", "Thank you for using gamba !. You can try again for free by registering again. Please apply from 「Start Free Trial」 at the bottom."), _defineProperty(_label, "【アプリ】再度利用するにはもう一度トライアルをしてください", "Thank you for using gamba !. You can try again for free by registering again."), _defineProperty(_label, "ご契約を希望のお客様", "If you would like to make a contract, "), _defineProperty(_label, "こちら", " here."), _defineProperty(_label, "お申し込みください", " please apply from"), _defineProperty(_label, "無料トライアルを始める", "Start a free trial"), _defineProperty(_label, "全ての端末でログアウト", "Log out on all devices"), _defineProperty(_label, "入力内容不備", "There is something wrong with the input content."), _defineProperty(_label, '\u30EA\u30A2\u30AF\u30B7\u30E7\u30F3', "Reaction"), _defineProperty(_label, "下書き保存", "Draft saving is complete."), _defineProperty(_label, "他n件のKPIをすべて表示", "Show all other {{ n }} KPIs"), _defineProperty(_label, "対象ユーザーはこのグループに所属していません", "Target user does not belong to this group."), _defineProperty(_label, '\u901A\u77E5\u8A2D\u5B9A', "Notification settings"), _defineProperty(_label, "対応するアプリがない", "I can't open the file because there is no corresponding app. \nPlease check the support site for details."), _defineProperty(_label, "ファイルを開けません", "File cannot be opened"), _defineProperty(_label, "サポートサイトを開く", "Open the support site"), _defineProperty(_label, "ファイルはまだ処理中", "Your file is still being processed. Please try again later."), _defineProperty(_label, "ファイルが読み込めない", "This file cannot read."), _defineProperty(_label, "グループ所属", "Show group members only"), _defineProperty(_label, "グループ(未読)", "Groups (unread)"), _defineProperty(_label, "未読のみ表示", "Show unread only"), _defineProperty(_label, "未読グループがありません", "No unread groups"), _defineProperty(_label, "提出予定", "Submission schedule"), _defineProperty(_label, "月間サマリー編集モード", "{{ name }}　Daily Report Submission Status/Edit"), _defineProperty(_label, "提出予定登録説明", "If you check the box, the submission schedule will be registered."), _defineProperty(_label, "提出予定登録", "Submission schedule has been registered."), _defineProperty(_label, "平日をすべて選択", "Select all weekdays"), _defineProperty(_label, "リニューアル", "Under renewal.\nPlease wait for a while."), _defineProperty(_label, "リニューアル中", "Under renewal."), _defineProperty(_label, "お待ちください", "Please wait for a while"), _defineProperty(_label, "レポート", "Report"), _defineProperty(_label, "日報の提出予定人数", "Number of people expected to submit daily reports"), _defineProperty(_label, "週間レポート", "Weekly report"), _defineProperty(_label, "月間レポート", "Monthly report"), _defineProperty(_label, "週間レポートを出力する", "Print weekly report"), _defineProperty(_label, "月間レポートを出力する", "Print monthly report"), _defineProperty(_label, "週間レポート出力開始日", "Weekly report output start date"), _defineProperty(_label, "月間レポート出力開始日", "Monthly report output start date"), _defineProperty(_label, "レポート設定を更新しました", "Report settings have been updated"), _defineProperty(_label, "日報の提出数がなし", "There were no posts during this period. Please contact gamba! management to consider how to operate it!"), _defineProperty(_label, "日報の提出数が90%以上", "That's a great posting rate! Let's continue like this!"), _defineProperty(_label, "日報の提出数が増加", "It's better than the previous period! Let's aim for a posting rate of 90%!"), _defineProperty(_label, "日報の提出数が減少", "Posts have decreased from the previous period. We look forward to your posts!"), _defineProperty(_label, "レスポンスなし", "There seems to be no response. First, click “Like!”!"), _defineProperty(_label, "日毎集計", "Daily Total"), _defineProperty(_label, "累計説明", "Displays a cumulative graph of actual values during the period."), _defineProperty(_label, "文字の大きさ", 'Font size'), _defineProperty(_label, "文字サイズ設定", "Setting the font size"), _defineProperty(_label, "文字サイズが保存されました", "The font size has been saved."), _defineProperty(_label, "グループ内の投稿数", "・Number of posts in the group: {{posts}} posts"), _defineProperty(_label, "先月との投稿数の変化", "Comparison of submission rates with last month"), _defineProperty(_label, "投稿なし", "No posts found. If you have any questions or concerns about gamba!, please feel free to contact our support team!"), _defineProperty(_label, "投稿数50%未満", "More than half of the team has not posted yet. Even today's events or small realizations are OK! Why not share them?"), _defineProperty(_label, "投稿数50-89%", "The posting rate is steady! We're just one step away from reaching 90%. Let's aim to share information with the whole team!"), _defineProperty(_label, "投稿数90%以上", "Great posting rate! The whole team is able to share information!✨"), _defineProperty(_label, "具体的な提出状況", " Please see here for the specific submission status."), _defineProperty(_label, "大幅減少（-20%以上）", "There have been fewer posts recently. Short posts are OK! Feel free to share them!"), _defineProperty(_label, "微減・現状維持（±10%）", "Thank you for your consistent posts. Let's gamba together today to further activate the site!"), _defineProperty(_label, "増加（+10%以上）", "The number of posts is increasing! Thank you for everyone's active sharing! Let's keep going at this pace and aim to reach 90%!"), _defineProperty(_label, "反応なし", "Let's react to everyone's posts! Start with a simple 'Like!'"), _defineProperty(_label, "いいねのみ", "Thank you for the likes! Why not expand your communication with stamps and comments?"), _defineProperty(_label, "多様な反応", "Thank you for the well-balanced reactions! The team ties are getting stronger!"), _defineProperty(_label, "reaction_compare", "Number of reactions to posts compared to last month"), _defineProperty(_label, "反応減少（-20%以上）", "It seems that team interaction has decreased a little. Why not add a short message to your colleagues' posts?"), _defineProperty(_label, "反応現状維持（±10%）", "Stable interaction continues. Share your new discoveries and realizations in the comments!"), _defineProperty(_label, "反応増加（+10%以上）", "Everyone's active interactions are increasing! The atmosphere in this team is great!✨"), _defineProperty(_label, "投稿率算出", "By setting a submission date, you can get a more accurate grasp of the submission status of daily reports."), _defineProperty(_label, "gamba!にご相談", "If you have any problems with operation, please contact gamba! at any time!"), _defineProperty(_label, "gamba!活用サポート予約窓口", "gamba! Support Reservation."), _defineProperty(_label, "ご予約はこちら", "Reservations can be made here"), _defineProperty(_label, "提出状況", "Submission status"), _defineProperty(_label, "提出状況エクスポート", "Export Submission status"), _defineProperty(_label, "週の投稿", "{{week_number}} week posts"), _defineProperty(_label, "こちらの使い方ガイド", "this guide"), _defineProperty(_label, "report_collection", "Collection period: {{start_date, date}}~{{end_date, date}}"), _defineProperty(_label, "report_subject", "【{{month}} {{group_name}} Group Posts and reactions Report】"), _defineProperty(_label, "reaction_subject", "・Reactions to posts: {{likes}} likes, {{comments}} comments and stamps"), _defineProperty(_label, "パターン1", "There were {{posts}} posts. How active is your team? To create an atmosphere where members can post freely, send comments and 'likes' from the administrator!"), _defineProperty(_label, "パターン2", "{{posts}} posts were shared. Have you noticed any changes in the content or quality of posts? If you notice something different from usual, try responding with a comment!"), _defineProperty(_label, "パターン3", "There were {{posts}} posts. Take a look at posts from members who don't usually post much. You may notice their unique perspective!"), _defineProperty(_label, "パターン4", "There were {{posts}} activity shares. Were there any posts that received a particularly strong response within the team? Try sharing the key points of such posts with other members!"), _defineProperty(_label, "パターン5", "{{posts}} posts were collected. Why not find a topic where members are actively sharing information among themselves and use that as a basis for reaching out to them?"), _defineProperty(_label, "パターン6", "{{posts}} posts were shared. Have you noticed anything particularly useful? Try to give specific feedback on such posts in the comments!"), _defineProperty(_label, "パターン7", "There were {{posts}} posts. What were the most popular topics within the team? Commenting on popular topics may lead to further sharing of ideas!"), _defineProperty(_label, "パターン8", "There were {{posts}} posts. Was there active exchange of comments between members? If there are interesting discussions, try adding comments from the administrator's perspective!"), _defineProperty(_label, "パターン9", "There were {{posts}} posts. Reactions to posts made first thing in the morning or at the beginning of the week will help your team get off to a good start each day and week. Try to reach out to them proactively!"), _defineProperty(_label, "パターン10", "{{posts}} activity reports were collected. Why not try to provide particularly detailed feedback on reports of new initiatives and improvements?"), _defineProperty(_label, "パターン11", "There were {{posts}} posts. When sharing problems or issues, try to support them with advice that makes use of your team's experience and knowledge!"), _defineProperty(_label, "パターン12", "{{posts}} posts were shared. Pay particular attention to topics about collaboration and cooperation with other departments. It may be an opportunity to expand horizontal connections!"), _defineProperty(_label, "パターン13", "There were {{posts}} posts. Were there any posts that made you feel that your team members had grown or realized something? If you notice such a change, acknowledge it with specific words!"), _defineProperty(_label, "パターン14", "There were {{posts}} posts. If you find any ideas or techniques shared within the team, be sure to comment, 'That's helpful!'"), _defineProperty(_label, "パターン15", "{{posts}} posts were shared. Why not find some good changes or growth in your team among the posts and share them with everyone?"), _defineProperty(_label, "パターン16", "{{posts}} activity shares were confirmed. Are there any trends in the time of posting? Try to understand the rhythm of your team's activities and make an effort to speak to them in a timely manner!"), _defineProperty(_label, "パターン17", "There were {{posts}} posts. Did you get a sense of the team's atmosphere? For more active communication, start by expressing your honest thoughts as an administrator!"), _defineProperty(_label, "パターン18", "{{posts}} posts have been shared. Pay attention to reports of small individual ideas and improvements. They may become an asset for the whole team!"), _defineProperty(_label, "レスポンスいいねのみ", "Express your feelings using comments and stamps!"), _defineProperty(_label, "レスポンス量増加", "gamba! seems to be more exciting than the whole period!"), _defineProperty(_label, "レスポンス量減少", "Responses are on the decline. Let's all get excited!"), _defineProperty(_label, "Section preferences have been updated", "Section preferences have been updated."), _defineProperty(_label, "Section", "Section"), _defineProperty(_label, "Section(unread)", "Section(unread)"), _defineProperty(_label, "Section name", "Section name"), _defineProperty(_label, "Division visibility", "Division visibility"), _defineProperty(_label, "Group management", "Group management"), _defineProperty(_label, "Download", "Download"), _defineProperty(_label, "Move to trash", "Move to trash"), _defineProperty(_label, "persons_count", "{{ value }} member(s)"), _defineProperty(_label, "Section settings", "Section settings"), _defineProperty(_label, "are_you_sure_you_want_to_move_the_division_to_trash", "This Section will be moved to trash. \nAre you sure you want to move the Section to trash?"), _defineProperty(_label, "this_operation_will_affect_all_users_participating_in_the_division", "This operation affects all groups participating in the Section."), _defineProperty(_label, "complete_deletion_restoration_explanation", "To delete completely or restore a Section, you need to do the operations of \"Permanently delete\" or \"Return from trash\" on the account management screen."), _defineProperty(_label, "export_all_groups", "Extract all Group"), _defineProperty(_label, "既存グループを追加", "Add existing group"), _defineProperty(_label, "Select_group", "Select group"), _defineProperty(_label, "division_group_remove_consequence", "You can still view past posts even if you leave the section."), _defineProperty(_label, "can_i_remove_group", "Are you sure you want to remove {{ name }} as a group?"), _defineProperty(_label, "Return to linked section", "Return to linked section"), _defineProperty(_label, "Move to first level", "Move to first level"), _defineProperty(_label, "選択できるグループがありません", "There are no groups to select."), _defineProperty(_label, "セクションなし", "No section"), _defineProperty(_label, "AIレビュー", "AI review"), _defineProperty(_label, "この情報は役に立ちましたか", "Was this information helpful?"), _defineProperty(_label, "レポートお礼", "Thank you for your cooperation!"), _defineProperty(_label, "レビューする", "Review"), _defineProperty(_label, "レビュー注意", "While this app's AI technology strives for excellence, its responses may contain inaccuracies or misunderstandings."), _defineProperty(_label, "注意URL", "https://www.getgamba.com/info/archives/52230/"), _defineProperty(_label, "利用規約", "read more"), _defineProperty(_label, "拡張機能", "extensions"), _defineProperty(_label, "レビュー機能", "AI Review feature (Beta)"), _defineProperty(_label, "レビュー機能ON", "AI Review feature (Beta) is currently enabled. To disable it, please contact your account administrator.(You can change this from Account Management Screen > Advanced Settings > Extensions Settings.)"), _defineProperty(_label, "レビュー機能OFF", "AI Review feature (Beta) is currently disabled. To enable it, please contact your account administrator.(You can change this from Account Management Screen > Advanced Settings > Extensions Settings.)"), _label),
  error: {
    "メールアドレスを入力してください": "Please enter your e-mail address.", // メールアドレスを入力してください。
    "パスワードを入力してください": "Please enter your password.", // パスワードを入力してください。
    "確認コードを入力してください": "Please enter pass code.", // 確認コードを入力してください
    "タイトルを入力してください": "Please enter a title.", // タイトルを入力してください。
    "テンプレート名を入力してください": "Please enter a template name.", // テンプレート名を入力してください。
    "本文を入力してください": "Please enter the text", // 本文を入力してください
    "ユーザ名を入力してください": "Please enter your username.", // ユーザ名を入力してください。
    "グループ名を入力してください": "Please enter a group name.", // グループ名を入力してください。
    "KPI名を入力してください": "Please enter a KPI name.", // KPI名を入力してください。
    "単位を入力してください": "Please enter a unit.", // 単位を入力してください。
    "目標値を入力してください": "Please enter a target value.", // 目標値を入力してください。
    "実績値を入力してください": "Please enter the actual value.", // 実績値を入力してください。
    "フィールド種別を選択してください": "Select an input type.", // 入力種別を選択してください。
    "フィールド名を入力してください": "Please enter an item name.", // 項目名を入力してください。
    "フィールドの選択肢を入力してください": "Specify one or more choices for the input item.", // 入力項目の選択肢を1つ以上指定してください。
    "入力されていません": "Not entered.", // 入力されていません。
    "チャットルーム名を入力してください": "Please enter a chat room name", // チャットルーム名を入力してください
    fetch_error: "Unable to connect to server. A network error has occurred.", // サーバに接続できません。ネットワークエラーが発生しました。
    s3upload: "Upload of video file failed. Please try again later.", // 動画ファイルのアップロードに失敗しました。時間をおいて再度お試しください。
    invalid_flie: "Upload some file failed. Not support file included.", // 選択された一部のファイルはサポートされておりません
    "サーバ切断": "The server connection has been disconnected. Reconnecting.", // サーバの接続が切断されました。再接続中です。
    "サーバ接続": "Server connection has been restored.", // サーバの接続が復旧しました。
    "google-calendar-events": "Can't get the calendar for Google Calendar.", // Googleカレンダーの予定表が取得できません。
    "google-calendar-list": "Can't get the calendar for Google Calendar.", // Googleカレンダーの予定表が取得できません。
    "google-drive-folders": "Can't get the folders for GoogleDrive.", // Googleドライブのフォルダリストを取得できません。
    "google-drive-userinfo": "Can't get the user info for GoogleDrive.", // Googleドライブのユーザー情報を取得できません。
    "google-refresh-token": "Can't get the refresh token.", // refresh tokenが取得できません。
    "fetch-scheduled-settings": "Can't get the scheduled execution settings.", // 定期実行設定を取り込めません。
    "update-scheduled-settings": "Can't update the scheduled execution settings.", // 定期実行設定が更新できません。
    "upload-google-drive-file": "Can't upload the file to GoogleDrive.", // Googleドライブにファイルをアップロードできません。
    "画像の読み込みに失敗しました": "The file does not exist or cannot be displayed.", // 存在しないか表示できないファイルです。
    "暗号化PDF説明": "* For encrypted files, you may be able to open it　　from the \"Display in another window\" icon on the upper right.", // * 暗号化されたファイルの場合、右上の　「別ウィンドウで表示」のアイコンから開ける可能性があります。
    "読み込みに失敗しました": "Reading data failed.", // データの読み込みに失敗しました。
    "ファイルが選択されていません": "Either no file has been selected or access to the photo or camera has not been granted.", // ファイルが選択されていないか、写真もしくはカメラへのアクセスが許可されていません。
    "フォトライブラリに保存できませんでした": "The attached image could not be saved.", // 添付画像の保存ができませんでした。
    "データの送信に失敗しました": "Post submission failed. Please check your internet connection and try again.", // 投稿の送信に失敗しました。インターネット接続を確認し、再度お試しください。
    "インターネット接続に問題があります": "The temporary connection cannot be saved because the Internet connection cannot be confirmed.", // インターネット接続が確認できないため、投稿の一時保存ができません。
    "インターネット再接続": "Reconnecting to the internet. Temporary saving of posts have not completed yet.", // インターネット再接続しています。投稿の一時保存まだ完了しておりません。
    "インターネット接続を確認してください": "Please try again while connected to the Internet.", // インターネットに接続された状態で再度お試しください。
    "別の投稿を編集中です": "Cannot open the post because another post is being edited.", // 現在別の投稿を編集中のため開くことができません。
    "unavailable": "gamba! Is currently unavailable. Please wait.", // 現在、gamba!はご利用いただけません。しばらくお待ちください。
    "URLが開けません": "Cannot open the URL", //  URLが開けません
    "コピーして下さい": "Please copy the link from the button below and access it from your browser. \n\n", // 下記ボタンより、リンクをコピーしてブラウザからアクセスして下さい。
    "ファイルサイズが制限を超えています": "The file size has exceeded the limit. You cannot upload a file larger than {{ max_file_size }}.",
    "MSアカウント": "Your Microsoft account does not support calendars."
  },
  url: {
    "gambaにログインできない": "https://support.getgamba.com/hc/ja/articles/900001776883",
    "無料体験リンク": "https://www.getgamba.com/v3/registration/new",
    "attachmentInfo": "https://support.getgamba.com/hc/ja/articles/900005545463"
  },
  timezone: {
    "UTC-12": "Baker Island, Howland Island", // ベーカー島 ハウランド島
    "UTC-11": "American Samoa Niue", // アメリカ領サモア ニウエ
    "UTC-10": "Hawaii Aleutian Islands", // ハワイ アリューシャン列島西部
    "UTC-9": "Alaska", // アラスカ
    "UTC-8": "United States, Canada, Mexico (Pacific Time)", // アメリカ・カナダ・メキシコ（太平洋時間）
    "UTC-7": "United States, Canada, Mexico (mountain time)", // アメリカ・カナダ・メキシコ（山岳部時間）
    "UTC-6": "United States, Canada, Mexico (Central Time), Central America", // アメリカ・カナダ・メキシコ（中部時間） 中央アメリカ
    "UTC-5": "United States and Canada (Eastern Time), Cuba Peru", // アメリカ・カナダ（東部時間） キューバ ペルー
    "UTC-4": "Canada (Atlantic Time), Majority of the Lesser Antilles, Venezuela, Brazil (Amazon Time), Chile", // カナダ（大西洋時間） 小アンティル諸島の大部分 ベネズエラ ブラジル（アマゾン時間） チリ
    "UTC-3": "Brazil (Brazil time), Argentina, Greenland", // ブラジル（ブラジル時間） アルゼンチン グリーンランド
    "UTC-2": "Brazil (Fernando de Noronha)", // ブラジル（フェルナンド・デ・ノローニャ島）
    "UTC-1": "Azores, Cape Verde", // アゾレス諸島 カーボベルデ
    "UTC+0": "United Kingdom, Ireland, Portugal, Iceland, Africa Rocco, Ghana etc.", // イギリス アイルランド ポルトガル アイスランド アフリゃ�ロッコ ガーナ等
    "UTC+1": "Central European Time (France, Germany, etc.), West Africa Time (Nigeria, Congo, etc.)", // 中央ヨーロッパ時間（フランス ドイツ等） 西アフリカ時間（ナイジェリア コンゴ等）
    "UTC+2": "Eastern European Time (Finland Ukraine Greece etc.), Central African Time, South Africa", // 東ヨーロッパ時間（フィンランド ウクライナ ギリシャ等） 中央アフリカ時間 南アフリカ
    "UTC+3": "Russia (Moscow), Belarus, Saudi Arabia, East Africa Time", // ロシア（モスクワ） ベラルーシ サウジアラビア 東アフリカ時間
    "UTC+4": "Russia (Samara), Azerbaijan, Georgia, United Arab Emirates, Mauritius", // ロシア（サマラ） アゼルバイジャン グルジア アラブ首長国連邦 モーリシャス
    "UTC+5": "Russia (Yekaterinburg), Pakistan", // ロシア（エカテリンブルグ） パキスタン
    "UTC+6": "Russia (Omsk), Kazakhstan, Bangladesh", // ロシア（オムスク） カザフスタン バングラディシュ
    "UTC+7": "Russia (Krasnoyarsk), Thailand, Vietnam, Western Indonesia Time", // ロシア（クラスノヤルスク） タイ ベトナム インドネシア西部時間
    "UTC+8": "Russia (Irkutsk), China, Mongolia, Malaysia, Western Australia Time", // ロシア（イルクーツク） 中国 モンゴル マレーシア オーストラリア西部時間
    "UTC+9": "Japan, Russia (Yakutsk), South Korea, Palau", // 日本 ロシア（ヤクーツク） 韓国 パラオ
    "UTC+10": "Russia (Vladivostok), Guam, Eastern Australia Time", // ロシア（ウラジオストク） グアム オーストラリア東部時間
    "UTC+11": "Russia (Magadan), Solomon Islands, New Caledonia", // ロシア（マガダン） ソロモン諸島 ニューカレドニア
    "UTC+12": "Russia (Kamchatka), New Zealand, Fiji, Kiribati (Gilbert Islands)", // ロシア（カムチャッカ） ニュージーランド フィジー キリバス（ギルバート諸島）
    "UTC+13": "Tonga Kiribati (Phoenix Islands), Samoa, Tokelau", // トンガ キリバス（フェニックス諸島） サモア トケラウ
    "UTC+14": "Kiribati (Line Islands)" // キリバス（ライン諸島）
  },
  language: {
    "ja": "Japanese",
    "en": "English"
  }
};

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(247);

var _reactRouterRedux = __webpack_require__(415);

var _reduxThunk = __webpack_require__(1248);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = __webpack_require__(1249);

var _reducers = __webpack_require__(1250);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loggerMiddleware = (0, _reduxLogger.createLogger)();
// src/store/configureStore.js

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;

function configureStore() {
  var history = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  var middlewares = [_reduxThunk2.default];
  if (Object({"NODE_ENV":"production","RAILS_ENV":"production","BUILD_NO":"202507040022","REACT_NATIVE":false}) == 'development') middlewares.push(loggerMiddleware);
  if (history) middlewares.push((0, _reactRouterRedux.routerMiddleware)(history));
  return (0, _redux.createStore)(_reducers2.default, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));
}

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _combineReducers;

var _redux = __webpack_require__(247);

var _reactRouterRedux = __webpack_require__(1251);

var _reactRouterRedux2 = _interopRequireDefault(_reactRouterRedux);

var _reduxUi = __webpack_require__(1252);

var _mediaQuery = __webpack_require__(1280);

var _mediaQuery2 = _interopRequireDefault(_mediaQuery);

var _alertMessageReducer = __webpack_require__(1281);

var _alertMessageReducer2 = _interopRequireDefault(_alertMessageReducer);

var _accountReducer = __webpack_require__(2817);

var _accountReducer2 = _interopRequireDefault(_accountReducer);

var _activityReportReducer = __webpack_require__(2818);

var _activityReportReducer2 = _interopRequireDefault(_activityReportReducer);

var _announceReducer = __webpack_require__(2819);

var _announceReducer2 = _interopRequireDefault(_announceReducer);

var _attachmentsReducer = __webpack_require__(2820);

var _attachmentsReducer2 = _interopRequireDefault(_attachmentsReducer);

var _buildNoReducer = __webpack_require__(2821);

var _buildNoReducer2 = _interopRequireDefault(_buildNoReducer);

var _chatMessagesReducer = __webpack_require__(2822);

var _chatMessagesReducer2 = _interopRequireDefault(_chatMessagesReducer);

var _chatRoomsReducer = __webpack_require__(2823);

var _chatRoomsReducer2 = _interopRequireDefault(_chatRoomsReducer);

var _commentsReducer = __webpack_require__(2824);

var _commentsReducer2 = _interopRequireDefault(_commentsReducer);

var _diariesReducer = __webpack_require__(2825);

var _diariesReducer2 = _interopRequireDefault(_diariesReducer);

var _diaryTemplatesReducer = __webpack_require__(2826);

var _diaryTemplatesReducer2 = _interopRequireDefault(_diaryTemplatesReducer);

var _diaryKpiReducer = __webpack_require__(2827);

var _diaryKpiReducer2 = _interopRequireDefault(_diaryKpiReducer);

var _favoriteReducer = __webpack_require__(2828);

var _favoriteReducer2 = _interopRequireDefault(_favoriteReducer);

var _blockReducer = __webpack_require__(2829);

var _blockReducer2 = _interopRequireDefault(_blockReducer);

var _groupsReducer = __webpack_require__(2830);

var _groupsReducer2 = _interopRequireDefault(_groupsReducer);

var _kpiChartReducer = __webpack_require__(2831);

var _kpiChartReducer2 = _interopRequireDefault(_kpiChartReducer);

var _kpiReducer = __webpack_require__(2832);

var _kpiReducer2 = _interopRequireDefault(_kpiReducer);

var _likesReducer = __webpack_require__(2833);

var _likesReducer2 = _interopRequireDefault(_likesReducer);

var _pinsReducer = __webpack_require__(2834);

var _pinsReducer2 = _interopRequireDefault(_pinsReducer);

var _notificationsReducer = __webpack_require__(2835);

var _notificationsReducer2 = _interopRequireDefault(_notificationsReducer);

var _organizationsReducer = __webpack_require__(2836);

var _organizationsReducer2 = _interopRequireDefault(_organizationsReducer);

var _preservedQueriesReducer = __webpack_require__(2837);

var _preservedQueriesReducer2 = _interopRequireDefault(_preservedQueriesReducer);

var _savedDiariesReducer = __webpack_require__(2838);

var _savedDiariesReducer2 = _interopRequireDefault(_savedDiariesReducer);

var _sessionsReducer = __webpack_require__(2839);

var _sessionsReducer2 = _interopRequireDefault(_sessionsReducer);

var _subDiariesReducer = __webpack_require__(2840);

var _subDiariesReducer2 = _interopRequireDefault(_subDiariesReducer);

var _subscribeReducer = __webpack_require__(2841);

var _subscribeReducer2 = _interopRequireDefault(_subscribeReducer);

var _templatesReducer = __webpack_require__(2842);

var _templatesReducer2 = _interopRequireDefault(_templatesReducer);

var _uploadFileReducer = __webpack_require__(2843);

var _uploadFileReducer2 = _interopRequireDefault(_uploadFileReducer);

var _uploadVideoReducer = __webpack_require__(2865);

var _uploadVideoReducer2 = _interopRequireDefault(_uploadVideoReducer);

var _userReducer = __webpack_require__(2866);

var _userReducer2 = _interopRequireDefault(_userReducer);

var _usersReducer = __webpack_require__(2867);

var _usersReducer2 = _interopRequireDefault(_usersReducer);

var _sidebarReducer = __webpack_require__(2868);

var _sidebarReducer2 = _interopRequireDefault(_sidebarReducer);

var _rightSidebarReducer = __webpack_require__(2869);

var _rightSidebarReducer2 = _interopRequireDefault(_rightSidebarReducer);

var _googleApiReducer = __webpack_require__(2870);

var _googleApiReducer2 = _interopRequireDefault(_googleApiReducer);

var _outlookApiReducer = __webpack_require__(2871);

var _outlookApiReducer2 = _interopRequireDefault(_outlookApiReducer);

var _diaryFormReducer = __webpack_require__(2872);

var _diaryFormReducer2 = _interopRequireDefault(_diaryFormReducer);

var _editDiaryReducer = __webpack_require__(2873);

var _editDiaryReducer2 = _interopRequireDefault(_editDiaryReducer);

var _groupSettingsReducer = __webpack_require__(2874);

var _groupSettingsReducer2 = _interopRequireDefault(_groupSettingsReducer);

var _userSettingsReducer = __webpack_require__(2875);

var _userSettingsReducer2 = _interopRequireDefault(_userSettingsReducer);

var _socketReducer = __webpack_require__(2876);

var _socketReducer2 = _interopRequireDefault(_socketReducer);

var _nativeRouter = __webpack_require__(2877);

var _nativeRouter2 = _interopRequireDefault(_nativeRouter);

var _productTourReducer = __webpack_require__(2878);

var _productTourReducer2 = _interopRequireDefault(_productTourReducer);

var _registrationUrlReducer = __webpack_require__(2879);

var _registrationUrlReducer2 = _interopRequireDefault(_registrationUrlReducer);

var _accountOtherMembersCountReducer = __webpack_require__(2880);

var _accountOtherMembersCountReducer2 = _interopRequireDefault(_accountOtherMembersCountReducer);

var _urlInfoReducer = __webpack_require__(2881);

var _urlInfoReducer2 = _interopRequireDefault(_urlInfoReducer);

var _imagesViewReducer = __webpack_require__(2882);

var _imagesViewReducer2 = _interopRequireDefault(_imagesViewReducer);

var _translateReducer = __webpack_require__(2883);

var _translateReducer2 = _interopRequireDefault(_translateReducer);

var _dashboardReducer = __webpack_require__(2884);

var _dashboardReducer2 = _interopRequireDefault(_dashboardReducer);

var _submissionSchedulesReducer = __webpack_require__(2885);

var _submissionSchedulesReducer2 = _interopRequireDefault(_submissionSchedulesReducer);

var _reportReducer = __webpack_require__(2886);

var _reportReducer2 = _interopRequireDefault(_reportReducer);

var _diaryReportReducer = __webpack_require__(2887);

var _diaryReportReducer2 = _interopRequireDefault(_diaryReportReducer);

var _divisionsReducer = __webpack_require__(2888);

var _divisionsReducer2 = _interopRequireDefault(_divisionsReducer);

var _divisionsSettingsReducer = __webpack_require__(2889);

var _divisionsSettingsReducer2 = _interopRequireDefault(_divisionsSettingsReducer);

var _divisionsGroupManagerReducer = __webpack_require__(2890);

var _divisionsGroupManagerReducer2 = _interopRequireDefault(_divisionsGroupManagerReducer);

var _menusReducer = __webpack_require__(2891);

var _menusReducer2 = _interopRequireDefault(_menusReducer);

var _lambdaApiReducer = __webpack_require__(2892);

var _lambdaApiReducer2 = _interopRequireDefault(_lambdaApiReducer);

var _reviewSettingReducer = __webpack_require__(2893);

var _reviewSettingReducer2 = _interopRequireDefault(_reviewSettingReducer);

var _reactChatReducer = __webpack_require__(2894);

var _reactChatReducer2 = _interopRequireDefault(_reactChatReducer);

var _showTimestampSettingReducer = __webpack_require__(2895);

var _showTimestampSettingReducer2 = _interopRequireDefault(_showTimestampSettingReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/index.js

exports.default = (0, _redux.combineReducers)((_combineReducers = {
  //logger: (state = {}, action)=> { console.log('ACTION', action.type); return state; },
  //logger: (state = {}, action = {})=> { global.nativeLoggingHook(`ACTION: ${action.type}`, 1); return state; },
  alertMessage: _alertMessageReducer2.default,
  routing: _reactRouterRedux2.default,
  ui: _reduxUi.reducer,
  media: _mediaQuery2.default,
  account: _accountReducer2.default,
  activityReport: _activityReportReducer2.default
}, _defineProperty(_combineReducers, 'alertMessage', _alertMessageReducer2.default), _defineProperty(_combineReducers, 'announce', _announceReducer2.default), _defineProperty(_combineReducers, 'attachments', _attachmentsReducer2.default), _defineProperty(_combineReducers, 'buildNo', _buildNoReducer2.default), _defineProperty(_combineReducers, 'chatMessages', _chatMessagesReducer2.default), _defineProperty(_combineReducers, 'chatRooms', _chatRoomsReducer2.default), _defineProperty(_combineReducers, 'comments', _commentsReducer2.default), _defineProperty(_combineReducers, 'diaries', _diariesReducer2.default), _defineProperty(_combineReducers, 'diaryTemplates', _diaryTemplatesReducer2.default), _defineProperty(_combineReducers, 'diaryKPI', _diaryKpiReducer2.default), _defineProperty(_combineReducers, 'favorite', _favoriteReducer2.default), _defineProperty(_combineReducers, 'block', _blockReducer2.default), _defineProperty(_combineReducers, 'groups', _groupsReducer2.default), _defineProperty(_combineReducers, 'kpiChart', _kpiChartReducer2.default), _defineProperty(_combineReducers, 'kpi', _kpiReducer2.default), _defineProperty(_combineReducers, 'likes', _likesReducer2.default), _defineProperty(_combineReducers, 'pins', _pinsReducer2.default), _defineProperty(_combineReducers, 'notifications', _notificationsReducer2.default), _defineProperty(_combineReducers, 'organizations', _organizationsReducer2.default), _defineProperty(_combineReducers, 'preservedQueries', _preservedQueriesReducer2.default), _defineProperty(_combineReducers, 'savedDiaries', _savedDiariesReducer2.default), _defineProperty(_combineReducers, 'sessions', _sessionsReducer2.default), _defineProperty(_combineReducers, 'subDiaries', _subDiariesReducer2.default), _defineProperty(_combineReducers, 'subscribe', _subscribeReducer2.default), _defineProperty(_combineReducers, 'templates', _templatesReducer2.default), _defineProperty(_combineReducers, 'uploadFile', _uploadFileReducer2.default), _defineProperty(_combineReducers, 'uploadVideo', _uploadVideoReducer2.default), _defineProperty(_combineReducers, 'user', _userReducer2.default), _defineProperty(_combineReducers, 'users', _usersReducer2.default), _defineProperty(_combineReducers, 'sidebar', _sidebarReducer2.default), _defineProperty(_combineReducers, 'rightSidePage', _rightSidebarReducer2.default), _defineProperty(_combineReducers, 'googleApi', _googleApiReducer2.default), _defineProperty(_combineReducers, 'outlookApi', _outlookApiReducer2.default), _defineProperty(_combineReducers, 'diaryForm', _diaryFormReducer2.default), _defineProperty(_combineReducers, 'editDiary', _editDiaryReducer2.default), _defineProperty(_combineReducers, 'groupSettings', _groupSettingsReducer2.default), _defineProperty(_combineReducers, 'userSettings', _userSettingsReducer2.default), _defineProperty(_combineReducers, 'socket', _socketReducer2.default), _defineProperty(_combineReducers, 'routes', _nativeRouter2.default), _defineProperty(_combineReducers, 'productTour', _productTourReducer2.default), _defineProperty(_combineReducers, 'registrationUrl', _registrationUrlReducer2.default), _defineProperty(_combineReducers, 'accountOtherMembersCount', _accountOtherMembersCountReducer2.default), _defineProperty(_combineReducers, 'urlInfo', _urlInfoReducer2.default), _defineProperty(_combineReducers, 'imagesView', _imagesViewReducer2.default), _defineProperty(_combineReducers, 'translate', _translateReducer2.default), _defineProperty(_combineReducers, 'dashboard', _dashboardReducer2.default), _defineProperty(_combineReducers, 'submissionSchedules', _submissionSchedulesReducer2.default), _defineProperty(_combineReducers, 'reportReducer', _reportReducer2.default), _defineProperty(_combineReducers, 'diaryReport', _diaryReportReducer2.default), _defineProperty(_combineReducers, 'divisions', _divisionsReducer2.default), _defineProperty(_combineReducers, 'divisionSettings', _divisionsSettingsReducer2.default), _defineProperty(_combineReducers, 'divisionGroupManagers', _divisionsGroupManagerReducer2.default), _defineProperty(_combineReducers, 'menus', _menusReducer2.default), _defineProperty(_combineReducers, 'lambdaApi', _lambdaApiReducer2.default), _defineProperty(_combineReducers, 'reviewSetting', _reviewSettingReducer2.default), _defineProperty(_combineReducers, 'reactChat', _reactChatReducer2.default), _defineProperty(_combineReducers, 'showTimeStamp', _showTimestampSettingReducer2.default), _combineReducers));

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouterRedux = __webpack_require__(415);

exports.default = _reactRouterRedux.routerReducer;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = undefined;

var _ui = __webpack_require__(1253);

var _ui2 = _interopRequireDefault(_ui);

var _actionReducer = __webpack_require__(747);

var _actionReducer2 = _interopRequireDefault(_actionReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ui2.default;
exports.reducer = _actionReducer2.default;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = ui;

var _react = __webpack_require__(419);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(420);

var _redux = __webpack_require__(247);

var _reactRedux = __webpack_require__(1270);

var _invariant = __webpack_require__(746);

var _invariant2 = _interopRequireDefault(_invariant);

var _actionReducer = __webpack_require__(747);

var _utils = __webpack_require__(1279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function ui(key) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object') {
    opts = key;
    key = opts.key;
  }

  var connector = (0, _reactRedux.connect)(function (state) {
    return { ui: (0, _utils.getUIState)(state) };
  }, function (dispatch) {
    return (0, _redux.bindActionCreators)({
      updateUI: _actionReducer.updateUI,
      massUpdateUI: _actionReducer.massUpdateUI,
      setDefaultUI: _actionReducer.setDefaultUI,
      mountUI: _actionReducer.mountUI,
      unmountUI: _actionReducer.unmountUI
    }, dispatch);
  },
  // These allow you to pass 'mergeProps' and 'options' keys into the
  // UI decorator's options which will be passed to @connect().
  // TODO: Document
  opts.mergeProps, opts.options);

  return function (WrappedComponent) {
    var _class, _temp;

    // Return a parent UI class which scopes all UI state to the given key
    return connector((
    /**
     * UI is a wrapper component which:
     *   1. Inherits any parent scopes from parent components that are wrapped
     *      by @UI
     *   2. Sets up a new UI scope for the current component
     *   3. Merges the current UI scope into the parent UI scope (where the
     *      current scope takes precedence over parents)
     *
     * This allows normal block-scoping of UI state:
     *
     *   1. All UI components must define their local state keys
     *   2. Upon updating a state key, if it's not in the current scope
     *      walk up the tree until the variable is set
     *
     * This means that any child component can affect the current browser
     * chrome's UI state whilst maintaining their own local UI state.
     *
     * All state will be blown away on navigation by default.
     */
    _temp = _class = function (_Component) {
      _inherits(UI, _Component);

      function UI(props, ctx, queue) {
        _classCallCheck(this, UI);

        // If the key is undefined generate a new random hex key for the
        // current component's UI scope.
        //
        // We do this in construct() to guarantee a new key at component
        // instantiation time wihch is needed for iterating through a list of
        // components with no explicit key
        var _this = _possibleConstructorReturn(this, (UI.__proto__ || Object.getPrototypeOf(UI)).call(this, props, ctx, queue));

        if (key === undefined) {
          _this.key = (WrappedComponent.displayName || WrappedComponent.name) + Math.floor(Math.random() * (1 << 30)).toString(16);
        } else {
          _this.key = key;
        }

        // Immediately set this.uiPath and this.uiVars based on the incoming
        // context in class instantiation
        _this.getMergedContextVars(ctx);
        return _this;
      }

      // Pass these down in the new context created for this component


      // Get the existing context from a UI parent, if possible


      _createClass(UI, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          // If the component's UI subtree doesn't exist and we have state to
          // set ensure we update our global store with the current state.
          if (this.props.ui.getIn(this.uiPath) === undefined && opts.state) {
            var state = this.getDefaultUIState(opts.state);
            this.context.store.dispatch((0, _actionReducer.mountUI)(this.uiPath, state, opts.reducer));
          }
        }

        // When a parent context calls resetUI it blows away the entire subtree
        // that any child contexts may store state in.
        //
        // We may need to restore default props for this component if a parent
        // has blown away our state.

      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          // We can only see if this component's state is blown away by
          // accessing the current global UI state; the parent will not
          // necessarily always pass down child state.
          var ui = (0, _utils.getUIState)(this.context.store.getState());
          if (ui.getIn(this.uiPath) === undefined && opts.state) {
            var state = this.getDefaultUIState(opts.state, nextProps);
            this.props.setDefaultUI(this.uiPath, state);
          }
        }

        // Get default state by evaluating any functions passed in to the state
        // opts.
        // This is also used within componentWilLReceiveProps and so props
        // also needs to be passed in

      }, {
        key: 'getDefaultUIState',
        value: function getDefaultUIState(uiState) {
          var _this2 = this;

          var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;

          var globalState = this.context.store.getState();
          var state = _extends({}, uiState);
          Object.keys(state).forEach(function (k) {
            if (typeof state[k] === 'function') {
              state[k] = state[k](_this2.props, globalState);
            }
          });
          return state;
        }

        // Blow away all UI state for this component key by setting the
        // state for this key to undefined. This will get reset to the
        // default state in componentWillMount in the future.
        //
        // We use requestAnimationFrame because `@ui()` can be combined with
        // with `@connect()`; if the connect decorator uses selectors based on
        // UI state (such as live filtering) the connect decorator will receive
        // `undefined` as `this.props.ui` before unmounting.
        //
        // requestAnimationFrame avoids this.

      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this3 = this;

          if (opts.persist !== true) {
            if (window && window.requestAnimationFrame) {
              window.requestAnimationFrame(function () {
                return _this3.props.unmountUI(_this3.uiPath);
              });
            } else {
              this.props.unmountUI(this.uiPath);
            }
          }
        }

        // Sets this.uiVars && this.uiPath.
        //
        // Merges this UI context's variables with any parent context's
        // variables defined in uiVars.

      }, {
        key: 'getMergedContextVars',
        value: function getMergedContextVars() {
          var _this4 = this;

          var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;

          if (!this.uiVars || !this.uiPath) {
            var uiPath = ctx.uiPath || [];
            this.uiPath = uiPath.concat(this.key);

            // Keep trackof each UI variable and which path it should be set in
            var state = opts.state || {};
            this.uiVars = _extends({}, ctx.uiVars) || {};
            Object.keys(state).forEach(function (k) {
              return _this4.uiVars[k] = _this4.uiPath;
            }, this);
          }

          return [this.uiVars, this.uiPath];
        }

        // Construct a new context for all child UI components. We need to merge
        // in the vars defined in opts.state to uiVars to explicitly state that
        // this context is in charge of those variables.
        //
        // Pass the uiKey and partially applied updateUI function to all
        // child components that are wrapped in a plain `@ui()` decorator

      }, {
        key: 'getChildContext',
        value: function getChildContext() {
          var _getMergedContextVars = this.getMergedContextVars(),
              _getMergedContextVars2 = _slicedToArray(_getMergedContextVars, 2),
              uiVars = _getMergedContextVars2[0],
              uiPath = _getMergedContextVars2[1];

          return {
            uiKey: this.key,
            uiVars: uiVars,
            uiPath: uiPath,

            updateUI: this.updateUI.bind(this),
            resetUI: this.resetUI.bind(this)
          };
        }

        // Helper function to reset UI for the current context **and all child
        // scopes**.
        //
        // This is the same as exiting scope in programming; all variables
        // defined within the scope are reset.

      }, {
        key: 'resetUI',
        value: function resetUI() {
          this.props.setDefaultUI(this.uiPath, this.getDefaultUIState(opts.state));
          // TODO: Wipe all child contexts
        }
      }, {
        key: 'updateUI',
        value: function updateUI(name, value) {
          // Get a list of all UI variables available to this context (which
          var _getMergedContextVars3 = this.getMergedContextVars(),
              _getMergedContextVars4 = _slicedToArray(_getMergedContextVars3, 1),
              uiVars = _getMergedContextVars4[0];

          var uiVarPath = uiVars[name];

          if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object' && value === undefined) {
            // We're mass updating many UI variables. These may or may not be
            // directly controlled by our context, so we delegate to the
            // reducer which will deeply set each variable according to its
            // uiPath (from uiVars).
            //
            // Doing this means we only trigger one store update.
            this.props.massUpdateUI(this.uiVars, name);
            return;
          }

          (0, _invariant2.default)(uiVarPath, 'The \'' + name + '\' UI variable is not defined in the UI context in "' + (WrappedComponent.displayName || WrappedComponent.name) + '" ' + 'or any parent UI context. Set this variable using the "state" ' + 'option in the @ui decorator before using it.');

          this.props.updateUI(uiVarPath, name, value);
        }

        // Iterate through the list of contexts merging in UI variables from the
        // UI store

      }, {
        key: 'mergeUIProps',
        value: function mergeUIProps() {
          var _this5 = this;

          // WARNING: React has a subtle componentWillMount bug which we're
          // working around here!
          //
          // ## React bug
          //
          // On the first *ever* render of this component we set defaults in
          // componentWillMount. This works; when `render()` is called the
          // wrapped component has the default props within this.props.ui
          //
          // BUT.  Unmount, navigate away then return to this component.  When
          // componentWillMount is called a *second* time, we call updateUI to
          // set default props. **These aren't passed in to render() until the
          // component is mounted a second time**. Even though it worked first
          // time. And even though this is a new instance of the component.
          //
          // ## Workaround.
          //
          // Instead of relying on this.props.ui from our connector we call
          // getState() in the store directly here. We guarantee that this will
          // be the latest set of props, including default props set in
          // componentWillMount.
          //
          // We still use @connect() to connect to the store and listen for
          // changes in other cases.
          var ui = (0, _utils.getUIState)(this.context.store.getState());

          return Object.keys(this.uiVars).reduce(function (props, k) {
            props[k] = ui.getIn(_this5.uiVars[k].concat(k));
            return props;
          }, {}) || {};
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
            uiKey: this.key,
            uiPath: this.uiPath,
            ui: this.mergeUIProps(),
            resetUI: this.resetUI.bind(this),
            updateUI: this.updateUI.bind(this) }));
        }
      }]);

      return UI;
    }(_react.Component), _class.propTypes = {
      // The entire global UI state via react-redux connector
      ui: _propTypes.object.isRequired,
      // These actions are passed via react-redux connector
      setDefaultUI: _propTypes.func.isRequired,
      updateUI: _propTypes.func.isRequired,
      massUpdateUI: _propTypes.func.isRequired
    }, _class.childContextTypes = {
      // uiKey is the name of the parent context's key
      uiKey: _propTypes.string,
      // uiPath is the current path of the UI context
      uiPath: _propTypes.array,
      // uiVars is a map of UI variable names stored in state to the parent
      // context which controls them.
      uiVars: _propTypes.object,

      // Actions to pass to children
      updateUI: _propTypes.func,
      resetUI: _propTypes.func
    }, _class.contextTypes = {
      // This is used in mergeUIProps and construct() to immediately set
      // props.
      store: _propTypes.any,

      uiKey: _propTypes.string,
      uiPath: _propTypes.array,
      uiVars: _propTypes.object,

      updateUI: _propTypes.func,
      resetUI: _propTypes.func
    }, _temp));
  };
}

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(80);

var ReactBaseClasses = __webpack_require__(735);
var ReactChildren = __webpack_require__(1256);
var ReactDOMFactories = __webpack_require__(1261);
var ReactElement = __webpack_require__(216);
var ReactPropTypes = __webpack_require__(1262);
var ReactVersion = __webpack_require__(1266);

var createReactClass = __webpack_require__(1267);
var onlyChild = __webpack_require__(1268);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(1257);
var ReactElement = __webpack_require__(216);

var emptyFunction = __webpack_require__(84);
var traverseAllChildren = __webpack_require__(1258);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(307);

var invariant = __webpack_require__(60);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(307);

var ReactCurrentOwner = __webpack_require__(738);
var REACT_ELEMENT_TYPE = __webpack_require__(739);

var getIteratorFn = __webpack_require__(1259);
var invariant = __webpack_require__(60);
var KeyEscapeUtils = __webpack_require__(1260);
var warning = __webpack_require__(104);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(216);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(216),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(1263);

module.exports = factory(isValidElement);

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1264);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var warning = __webpack_require__(104);

var ReactPropTypesSecret = __webpack_require__(740);
var checkPropTypes = __webpack_require__(1265);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(735),
    Component = _require.Component;

var _require2 = __webpack_require__(216),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(736);
var factory = __webpack_require__(406);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(307);

var ReactElement = __webpack_require__(216);

var invariant = __webpack_require__(60);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var ReactPropTypesSecret = __webpack_require__(740);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.connect = exports.Provider = undefined;

var _Provider = __webpack_require__(1271);

var _Provider2 = _interopRequireDefault(_Provider);

var _connect = __webpack_require__(1272);

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Provider = _Provider2["default"];
exports.connect = _connect2["default"];

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = undefined;

var _react = __webpack_require__(419);

var _propTypes = __webpack_require__(420);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _storeShape = __webpack_require__(741);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _warning = __webpack_require__(742);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return Provider;
}(_react.Component);

exports["default"] = Provider;


if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: _storeShape2["default"].isRequired,
  children: _propTypes2["default"].element.isRequired
};
Provider.childContextTypes = {
  store: _storeShape2["default"].isRequired
};

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = connect;

var _react = __webpack_require__(419);

var _storeShape = __webpack_require__(741);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _shallowEqual = __webpack_require__(1273);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _wrapActionCreators = __webpack_require__(1274);

var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);

var _warning = __webpack_require__(742);

var _warning2 = _interopRequireDefault(_warning);

var _isPlainObject = __webpack_require__(743);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _hoistNonReactStatics = __webpack_require__(303);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(1277);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _extends({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = { value: null };
function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
}

// Helps track hot reloading.
var nextVersion = 0;

function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;

  var mapDispatch = void 0;
  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure,
      pure = _options$pure === undefined ? true : _options$pure,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;

  // Helps track hot reloading.
  var version = nextVersion++;

  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';

    function checkStateShape(props, methodName) {
      if (!(0, _isPlainObject2["default"])(props)) {
        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
      if (false) {
        checkStateShape(mergedProps, 'mergeProps');
      }
      return mergedProps;
    }

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
      };

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.store = props.store || context.store;

        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));

        var storeState = _this.store.getState();
        _this.state = { storeState: storeState };
        _this.clearCache();
        return _this;
      }

      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
        if (!this.finalMapStateToProps) {
          return this.configureFinalMapState(store, props);
        }

        var state = store.getState();
        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

        if (false) {
          checkStateShape(stateProps, 'mapStateToProps');
        }
        return stateProps;
      };

      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
        var mappedState = mapState(store.getState(), props);
        var isFactory = typeof mappedState === 'function';

        this.finalMapStateToProps = isFactory ? mappedState : mapState;
        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

        if (isFactory) {
          return this.computeStateProps(store, props);
        }

        if (false) {
          checkStateShape(mappedState, 'mapStateToProps');
        }
        return mappedState;
      };

      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
        if (!this.finalMapDispatchToProps) {
          return this.configureFinalMapDispatch(store, props);
        }

        var dispatch = store.dispatch;

        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

        if (false) {
          checkStateShape(dispatchProps, 'mapDispatchToProps');
        }
        return dispatchProps;
      };

      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
        var mappedDispatch = mapDispatch(store.dispatch, props);
        var isFactory = typeof mappedDispatch === 'function';

        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

        if (isFactory) {
          return this.computeDispatchProps(store, props);
        }

        if (false) {
          checkStateShape(mappedDispatch, 'mapDispatchToProps');
        }
        return mappedDispatch;
      };

      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        var nextStateProps = this.computeStateProps(this.store, this.props);
        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
          return false;
        }

        this.stateProps = nextStateProps;
        return true;
      };

      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
          return false;
        }

        this.dispatchProps = nextDispatchProps;
        return true;
      };

      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
          return false;
        }

        this.mergedProps = nextMergedProps;
        return true;
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return typeof this.unsubscribe === 'function';
      };

      Connect.prototype.trySubscribe = function trySubscribe() {
        if (shouldSubscribe && !this.unsubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
          this.handleChange();
        }
      };

      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        this.trySubscribe();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
          this.haveOwnPropsChanged = true;
        }
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.tryUnsubscribe();
        this.clearCache();
      };

      Connect.prototype.clearCache = function clearCache() {
        this.dispatchProps = null;
        this.stateProps = null;
        this.mergedProps = null;
        this.haveOwnPropsChanged = true;
        this.hasStoreStateChanged = true;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;
        this.renderedElement = null;
        this.finalMapDispatchToProps = null;
        this.finalMapStateToProps = null;
      };

      Connect.prototype.handleChange = function handleChange() {
        if (!this.unsubscribe) {
          return;
        }

        var storeState = this.store.getState();
        var prevStoreState = this.state.storeState;
        if (pure && prevStoreState === storeState) {
          return;
        }

        if (pure && !this.doStatePropsDependOnOwnProps) {
          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
          if (!haveStatePropsChanged) {
            return;
          }
          if (haveStatePropsChanged === errorObject) {
            this.statePropsPrecalculationError = errorObject.value;
          }
          this.haveStatePropsBeenPrecalculated = true;
        }

        this.hasStoreStateChanged = true;
        this.setState({ storeState: storeState });
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');

        return this.refs.wrappedInstance;
      };

      Connect.prototype.render = function render() {
        var haveOwnPropsChanged = this.haveOwnPropsChanged,
            hasStoreStateChanged = this.hasStoreStateChanged,
            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
            statePropsPrecalculationError = this.statePropsPrecalculationError,
            renderedElement = this.renderedElement;


        this.haveOwnPropsChanged = false;
        this.hasStoreStateChanged = false;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;

        if (statePropsPrecalculationError) {
          throw statePropsPrecalculationError;
        }

        var shouldUpdateStateProps = true;
        var shouldUpdateDispatchProps = true;
        if (pure && renderedElement) {
          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
        }

        var haveStatePropsChanged = false;
        var haveDispatchPropsChanged = false;
        if (haveStatePropsBeenPrecalculated) {
          haveStatePropsChanged = true;
        } else if (shouldUpdateStateProps) {
          haveStatePropsChanged = this.updateStatePropsIfNeeded();
        }
        if (shouldUpdateDispatchProps) {
          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
        }

        var haveMergedPropsChanged = true;
        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
        } else {
          haveMergedPropsChanged = false;
        }

        if (!haveMergedPropsChanged && renderedElement) {
          return renderedElement;
        }

        if (withRef) {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
            ref: 'wrappedInstance'
          }));
        } else {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
        }

        return this.renderedElement;
      };

      return Connect;
    }(_react.Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: _storeShape2["default"]
    };
    Connect.propTypes = {
      store: _storeShape2["default"]
    };

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
  };
}

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = __webpack_require__(247);

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(217);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1276 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * getUIState inspects redux' global state store and returns the UI state node.
 *
 * This checks to see whether state is an immutable map or a POJO.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getUIState = exports.getUIState = function getUIState(state) {
  if (typeof state.get === 'function') {
    return state.get('ui');
  }
  return state.ui;
};

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxMediaquery = __webpack_require__(618);

exports.default = _reduxMediaquery.reducer;
// src/reducers/media-query.js

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = alertMessageReducer;

var _alertMessage = __webpack_require__(13);

var _sessions = __webpack_require__(260);

// src/reducers/alert-message-reducer.js

var initialState = {
  message: undefined,
  category: undefined,
  trial_expired: undefined,
  re_trial: undefined
};

function alertMessageReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _alertMessage.EMIT_ALERT_MESSAGE:
      return Object.assign({}, state, {
        message: action.message,
        category: action.category,
        trial_expired: action.trial_expired,
        re_trial: action.re_trial
      });

    case _sessions.CLEAR_LOGIN_STATUS:
    case _alertMessage.CLEAR_ALERT_MESSAGE:
      return Object.assign({}, state, {
        message: undefined,
        category: undefined,
        trial_expired: undefined,
        re_trial: undefined
      });

    default:
      return state;
  }
}

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawApp = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _alertMessage = __webpack_require__(1283);

var _alertMessage2 = _interopRequireDefault(_alertMessage);

var _app = __webpack_require__(1779);

var _app2 = _interopRequireDefault(_app);

var _layout = __webpack_require__(85);

var _dialog = __webpack_require__(47);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _appButton = __webpack_require__(881);

var _appButton2 = _interopRequireDefault(_appButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/app.jsx

var DisableInvokeApp = 'gambaApp.disableInvokeApp';

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.state = { oldApp: false, invokeApp: undefined }, _this.disableInvokeApp = function () {
      localStorage.setItem(DisableInvokeApp, 'TRUE');
      _this.setState({ invokeApp: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      document.addEventListener('WebViewJavascriptBridgeReady', function () {
        return _this2.setState({ oldApp: true });
      });
      if (window.navigator.userAgent.toLowerCase().match(/(ipad|iphone|ipod)/)) {
        window.WVJBCallbacks = [function () {
          return _this2.setState({ oldApp: true });
        }];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
          document.documentElement.removeChild(WVJBIframe);
        }, 0);
      }

      if (window.navigator.userAgent.toLowerCase().match(/(ipad|iphone|ipod|android)/) && !localStorage.getItem(DisableInvokeApp)) this.setState({ invokeApp: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (this.state.oldApp) return _react2.default.createElement(
        _dialog.Dialog,
        { active: true,
          title: '\u3044\u307E\u3059\u3050\u3001\u30A2\u30D7\u30EA\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044' },
        _react2.default.createElement(
          'div',
          { style: { marginBottom: '10px', color: 'black' } },
          _react2.default.createElement(
            'b',
            null,
            'gamba! \u306E\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u30A2\u30D7\u30EA\u306F\u3001\u6027\u80FD\u5411\u4E0A\u3068\u4F7F\u3044\u52DD\u624B\u6539\u5584\u306E\u305F\u3081',
            _react2.default.createElement(
              'span',
              { style: { color: 'red' } },
              '\u5168\u9762\u7684\u306B\u30EA\u30CB\u30E5\u30FC\u30A2\u30EB'
            ),
            '\u3044\u305F\u3057\u307E\u3057\u305F\uFF01'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          '\u5168\u9762\u30EA\u30CB\u30E5\u30FC\u30A2\u30EB\u3055\u308C\u305F\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u30A2\u30D7\u30EA\u3092\u304A\u4F7F\u3044\u3044\u305F\u3060\u304F\u306B\u306F\u3001 \u4E0B\u8A18\u30EA\u30F3\u30AF\u3088\u308A\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u3066\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002',
          _react2.default.createElement('br', null),
          '\u306A\u304A\u3001\u73FE\u5728\u304A\u4F7F\u3044\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u306E\u30A2\u30D7\u30EA\u306F\u3001\u4ECA\u5F8C\u3001\u304A\u4F7F\u3044\u3044\u305F\u3060\u304F\u3053\u3068\u304C\u3067\u304D\u307E\u305B\u3093\u3002 \u3042\u3057\u304B\u3089\u305A\u3001\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002'
        ),
        _react2.default.createElement(
          'div',
          { style: { margin: '20px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' } },
          _react2.default.createElement(
            'a',
            { href: 'https://itunes.apple.com/jp/app/gamba-ri-bao-gong-younotameno/id1032574463?mt=8', target: '_blank', rel: 'noopener noreferrer' },
            _react2.default.createElement('span', { className: _appButton2.default.itunes })
          ),
          _react2.default.createElement(
            'a',
            { href: 'https://play.google.com/store/apps/details?id=com.rikkeisoft.gamba', target: '_blank', rel: 'noopener noreferrer' },
            _react2.default.createElement('span', { className: _appButton2.default.android })
          )
        )
      );

      return _react2.default.createElement(
        _layout.Layout,
        null,
        _react2.default.createElement(_alertMessage2.default, null),
        this.props.children,
        this.state.invokeApp && _react2.default.createElement(_confirmDialog2.default, { open: true,
          yesHref: 'gamba://getgamba.com/' + document.location.href.replace(/https?:\/\/[^\/]+\//, '').replace(/[#:]/g, ''),
          noHref: window.navigator.userAgent.toLowerCase().match(/(ipad|iphone|ipod)/) ? "https://itunes.apple.com/jp/app/gamba-ri-bao-gong-younotameno/id1032574463?mt=8" : "https://play.google.com/store/apps/details?id=com.rikkeisoft.gamba",
          onNo: function onNo() {
            return _this3.setState({ deeplink: undefined });
          },
          yesLabel: this.props.t('label:アプリで開く'),
          noLabel: this.props.t('label:アプリをダウンロード'),
          description: _react2.default.createElement(_checkbox2.default, { label: this.props.t('label:アプリを使用しない'),
            onChange: this.disableInvokeApp }),
          title: this.props.t('label:gambaアプリで開く') })
      );
    }
  }]);

  return App;
}(_react2.default.Component);

var RawApp = exports.RawApp = App;
exports.default = (0, _app2.default)(App);

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawAlertMessage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _alertMessage = __webpack_require__(1284);

var _alertMessage2 = _interopRequireDefault(_alertMessage);

var _reactTransitionGroup = __webpack_require__(1754);

var _snackbar = __webpack_require__(865);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _snackbar2 = __webpack_require__(1777);

var _snackbar3 = _interopRequireDefault(_snackbar2);

var _gambaKunYattaze = __webpack_require__(472);

var _gambaKunYattaze2 = _interopRequireDefault(_gambaKunYattaze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/alert-message.jsx

function ToastContent(props) {
  var message = props.message,
      type = props.type;


  switch (type) {
    case 'success':
      return _react2.default.createElement(
        'div',
        { className: 'check_circle' },
        _react2.default.createElement(_font_icon2.default, { value: 'check_circle' }),
        message
      );
    case 'postSuccess':
      return _react2.default.createElement(
        'div',
        { className: 'toast_Content' },
        _react2.default.createElement('img', { src: _gambaKunYattaze2.default, className: 'toastImg' }),
        message
      );
    case 'messageAlert':
      return _react2.default.createElement(
        'div',
        { className: 'toast_Content' },
        _react2.default.createElement(_font_icon2.default, { value: 'comment', style: { paddingRight: '10px' } }),
        message
      );
    case 'error':
      return _react2.default.createElement(
        'div',
        { className: 'error_info' },
        _react2.default.createElement(_font_icon2.default, { value: 'cancel' }),
        message
      );
    default:
      return null;
  }
}

var AlertMessage = function (_React$Component) {
  _inherits(AlertMessage, _React$Component);

  function AlertMessage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AlertMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlertMessage.__proto__ || Object.getPrototypeOf(AlertMessage)).call.apply(_ref, [this].concat(args))), _this), _this.clearAlertMessage = function () {
      _this.props.fadeOutAlertMessage(_this.props);
      setTimeout(function () {
        return _this.props.clearAlertMessage(_this.props);
      }, 500);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AlertMessage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          i18n = _props.i18n,
          category = _props.category;


      if (!this.props.message || this.props.message.length == 0) return null;

      var message = (_lodash2.default.isArray(this.props.message) ? this.props.message : [this.props.message]).map(function (msg) {
        if (_lodash2.default.isObject(msg) && _lodash2.default.isString(msg.message) && i18n.exists(msg.message)) return t(msg.message, msg);else if (_lodash2.default.isString(msg) && i18n.exists(msg)) return t(msg);else if (_lodash2.default.isString(msg)) return msg;else return '';
      }).join(' ');

      var toastList = [{ category: 'success', type: 'success', className: 'successToastify' }, { category: 'inputSuccess', type: 'success', className: 'successToastify' }, { category: 'postSuccess', type: 'postSuccess', className: 'successToastify' }, { category: 'messageAlert', type: 'messageAlert', className: 'successToastify' }, { category: 'topSuccess', type: 'success', className: 'successToastify' }, { category: 'error', type: 'error', className: 'errorToastify' }];

      var toastType = function toastType(category) {
        var type = toastList.find(function (t) {
          return t.category === category;
        }).type;
        return type;
      };

      var toastClassName = function toastClassName(category) {
        var type = toastList.find(function (t) {
          return t.category === category;
        }).className;
        return type;
      };

      if (message && message.length > 0) return _react2.default.createElement(_snackbar.Snackbar, {
        label: _react2.default.createElement(ToastContent, { message: message, type: toastType(this.props.category) }),
        active: ui.onAlert,
        timeout: toastType(this.props.category) != 'error' && 3000 || 100000,
        onTimeout: this.clearAlertMessage,
        type: toastType(this.props.category) == 'error' && 'warning' || 'accept',
        action: _react2.default.createElement(
          'div',
          { className: 'closeIcon' },
          _react2.default.createElement(_font_icon2.default, { value: 'close' })
        ),
        onClick: this.clearAlertMessage,
        className: toastClassName(this.props.category),
        theme: _snackbar3.default });else return null;
    }
  }]);

  return AlertMessage;
}(_react2.default.Component);

var RawAlertMessage = exports.RawAlertMessage = AlertMessage;
exports.default = (0, _alertMessage2.default)(AlertMessage);

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _reactI18next = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/alert-message.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    message: state.alertMessage.message,
    category: state.alertMessage.category
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fadeOutAlertMessage: function fadeOutAlertMessage(props) {
      props.updateUI({ onAlert: false });
    },
    clearAlertMessage: function clearAlertMessage(props) {
      props.updateUI({ onAlert: true });
      dispatch(_actions2.default.clearAlertMessage());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    onAlert: true,
    keyboardHeight: undefined
  }
}), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(422),
    copyObject = __webpack_require__(218),
    createAssigner = __webpack_require__(751),
    isArrayLike = __webpack_require__(159),
    isPrototype = __webpack_require__(308),
    keys = __webpack_require__(138);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(424),
    isMasked = __webpack_require__(1287),
    isObject = __webpack_require__(98),
    toSource = __webpack_require__(750);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1288);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(105);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1289 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1290 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1292),
    defineProperty = __webpack_require__(749),
    identity = __webpack_require__(250);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1292 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1293 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(174),
    isObjectLike = __webpack_require__(117);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1295 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(174),
    isLength = __webpack_require__(427),
    isObjectLike = __webpack_require__(117);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(308),
    nativeKeys = __webpack_require__(1298);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(745);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1299 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(756),
    keys = __webpack_require__(138);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1302),
    getMatchData = __webpack_require__(1334),
    matchesStrictComparable = __webpack_require__(768);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(311),
    baseIsEqual = __webpack_require__(433);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1303 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(313);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(313);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(313);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(313);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(312);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1309 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1310 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1311 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(312),
    Map = __webpack_require__(431),
    MapCache = __webpack_require__(432);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1314),
    ListCache = __webpack_require__(312),
    Map = __webpack_require__(431);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1315),
    hashDelete = __webpack_require__(1316),
    hashGet = __webpack_require__(1317),
    hashHas = __webpack_require__(1318),
    hashSet = __webpack_require__(1319);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(314);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1316 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(314);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(314);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(314);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(315);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1321 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(315);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(315);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(315);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(311),
    equalArrays = __webpack_require__(759),
    equalByTag = __webpack_require__(1328),
    equalObjects = __webpack_require__(1330),
    getTag = __webpack_require__(317),
    isArray = __webpack_require__(62),
    isBuffer = __webpack_require__(310),
    isTypedArray = __webpack_require__(429);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1326 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1327 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(217),
    Uint8Array = __webpack_require__(761),
    eq = __webpack_require__(249),
    equalArrays = __webpack_require__(759),
    mapToArray = __webpack_require__(1329),
    setToArray = __webpack_require__(436);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1329 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(762);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(175),
    root = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(175),
    root = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(175),
    root = __webpack_require__(105);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(767),
    keys = __webpack_require__(138);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(433),
    get = __webpack_require__(769),
    hasIn = __webpack_require__(1341),
    isKey = __webpack_require__(438),
    isStrictComparable = __webpack_require__(767),
    matchesStrictComparable = __webpack_require__(768),
    toKey = __webpack_require__(319);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1337);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1338);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(432);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1340);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(217),
    arrayMap = __webpack_require__(318),
    isArray = __webpack_require__(62),
    isSymbol = __webpack_require__(219);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1342),
    hasPath = __webpack_require__(1343);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1342 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(771),
    isArguments = __webpack_require__(309),
    isArray = __webpack_require__(62),
    isIndex = __webpack_require__(428),
    isLength = __webpack_require__(427),
    toKey = __webpack_require__(319);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1345),
    basePropertyDeep = __webpack_require__(1346),
    isKey = __webpack_require__(438),
    toKey = __webpack_require__(319);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1345 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(770);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = s3upload;

var _awsSdk = __webpack_require__(774);

var _awsSdk2 = _interopRequireDefault(_awsSdk);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/actions/s3upload.js

function s3upload(credentials, video_id, s3_key, file, onprogress) {
  var s3 = new _awsSdk2.default.S3({
    accessKeyId: credentials.access_key_id,
    secretAccessKey: credentials.secret_access_key,
    sessionToken: credentials.session_token
  });

  return new Promise(function (resolve, reject) {
    s3.upload({
      Bucket: credentials.bucket_name,
      Key: video_id + '/' + s3_key,
      Body: file
    }, function (err, data) {
      if (err) reject('error:s3upload');else resolve(video_id);
    }).on('httpUploadProgress', onprogress);
  });
}

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(66)))

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(68);

function QueryParamSerializer() {
}

QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
  serializeStructure('', params, shape, fn);
};

function ucfirst(shape) {
  if (shape.isQueryName || shape.api.protocol !== 'ec2') {
    return shape.name;
  } else {
    return shape.name[0].toUpperCase() + shape.name.substr(1);
  }
}

function serializeStructure(prefix, struct, rules, fn) {
  util.each(rules.members, function(name, member) {
    var value = struct[name];
    if (value === null || value === undefined) return;

    var memberName = ucfirst(member);
    memberName = prefix ? prefix + '.' + memberName : memberName;
    serializeMember(memberName, value, member, fn);
  });
}

function serializeMap(name, map, rules, fn) {
  var i = 1;
  util.each(map, function (key, value) {
    var prefix = rules.flattened ? '.' : '.entry.';
    var position = prefix + (i++) + '.';
    var keyName = position + (rules.key.name || 'key');
    var valueName = position + (rules.value.name || 'value');
    serializeMember(name + keyName, key, rules.key, fn);
    serializeMember(name + valueName, value, rules.value, fn);
  });
}

function serializeList(name, list, rules, fn) {
  var memberRules = rules.member || {};

  if (list.length === 0) {
    fn.call(this, name, null);
    return;
  }

  util.arrayEach(list, function (v, n) {
    var suffix = '.' + (n + 1);
    if (rules.api.protocol === 'ec2') {
      // Do nothing for EC2
      suffix = suffix + ''; // make linter happy
    } else if (rules.flattened) {
      if (memberRules.name) {
        var parts = name.split('.');
        parts.pop();
        parts.push(ucfirst(memberRules));
        name = parts.join('.');
      }
    } else {
      suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
    }
    serializeMember(name + suffix, v, memberRules, fn);
  });
}

function serializeMember(name, value, rules, fn) {
  if (value === null || value === undefined) return;
  if (rules.type === 'structure') {
    serializeStructure(name, value, rules, fn);
  } else if (rules.type === 'list') {
    serializeList(name, value, rules, fn);
  } else if (rules.type === 'map') {
    serializeMap(name, value, rules, fn);
  } else {
    fn(name, rules.toWireFormat(value).toString());
  }
}

module.exports = QueryParamSerializer;


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(68);
var builder = __webpack_require__(1353);

function XmlBuilder() { }

XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
  var xml = builder.create(rootElement);
  applyNamespaces(xml, shape);
  serialize(xml, params, shape);
  return xml.children.length > 0 || noEmpty ? xml.root().toString() : '';
};

function serialize(xml, value, shape) {
  switch (shape.type) {
    case 'structure': return serializeStructure(xml, value, shape);
    case 'map': return serializeMap(xml, value, shape);
    case 'list': return serializeList(xml, value, shape);
    default: return serializeScalar(xml, value, shape);
  }
}

function serializeStructure(xml, params, shape) {
  util.arrayEach(shape.memberNames, function(memberName) {
    var memberShape = shape.members[memberName];
    if (memberShape.location !== 'body') return;

    var value = params[memberName];
    var name = memberShape.name;
    if (value !== undefined && value !== null) {
      if (memberShape.isXmlAttribute) {
        xml.att(name, value);
      } else if (memberShape.flattened) {
        serialize(xml, value, memberShape);
      } else {
        var element = xml.ele(name);
        applyNamespaces(element, memberShape);
        serialize(element, value, memberShape);
      }
    }
  });
}

function serializeMap(xml, map, shape) {
  var xmlKey = shape.key.name || 'key';
  var xmlValue = shape.value.name || 'value';

  util.each(map, function(key, value) {
    var entry = xml.ele(shape.flattened ? shape.name : 'entry');
    serialize(entry.ele(xmlKey), key, shape.key);
    serialize(entry.ele(xmlValue), value, shape.value);
  });
}

function serializeList(xml, list, shape) {
  if (shape.flattened) {
    util.arrayEach(list, function(value) {
      var name = shape.member.name || shape.name;
      var element = xml.ele(name);
      serialize(element, value, shape.member);
    });
  } else {
    util.arrayEach(list, function(value) {
      var name = shape.member.name || 'member';
      var element = xml.ele(name);
      serialize(element, value, shape.member);
    });
  }
}

function serializeScalar(xml, value, shape) {
  xml.txt(shape.toWireFormat(value));
}

function applyNamespaces(xml, shape) {
  var uri, prefix = 'xmlns';
  if (shape.xmlNamespaceUri) {
    uri = shape.xmlNamespaceUri;
    if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
  } else if (xml.isRoot && shape.api.xmlNamespaceUri) {
    uri = shape.api.xmlNamespaceUri;
  }

  if (uri) xml.att(prefix, uri);
}

module.exports = XmlBuilder;


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLBuilder, assign;

  assign = __webpack_require__(1354);

  XMLBuilder = __webpack_require__(1378);

  module.exports.create = function(name, xmldec, doctype, options) {
    options = assign({}, xmldec, doctype, options);
    return new XMLBuilder(name, options).root();
  };

}).call(this);


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(779),
    copyObject = __webpack_require__(784),
    createAssigner = __webpack_require__(1361),
    isArrayLike = __webpack_require__(255),
    isPrototype = __webpack_require__(446),
    keys = __webpack_require__(256);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(322),
    isMasked = __webpack_require__(1358),
    isObject = __webpack_require__(119),
    toSource = __webpack_require__(783);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(323);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1357 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1359);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(140);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1360 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(1362),
    isIterateeCall = __webpack_require__(785);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(443),
    overRest = __webpack_require__(1363),
    setToString = __webpack_require__(1365);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1364);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1364 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1366),
    shortOut = __webpack_require__(1368);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1367),
    defineProperty = __webpack_require__(781),
    identity = __webpack_require__(443);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1367 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1368 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1370),
    isArguments = __webpack_require__(447),
    isArray = __webpack_require__(120),
    isBuffer = __webpack_require__(448),
    isIndex = __webpack_require__(445),
    isTypedArray = __webpack_require__(449);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1370 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(254),
    isObjectLike = __webpack_require__(257);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1372 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(254),
    isLength = __webpack_require__(444),
    isObjectLike = __webpack_require__(257);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1374 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(782);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1377);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1377 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLBuilder, XMLDeclaration, XMLDocType, XMLElement, XMLStringifier;

  XMLStringifier = __webpack_require__(1379);

  XMLDeclaration = __webpack_require__(787);

  XMLDocType = __webpack_require__(800);

  XMLElement = __webpack_require__(789);

  module.exports = XMLBuilder = (function() {
    function XMLBuilder(name, options) {
      var root, temp;
      if (name == null) {
        throw new Error("Root element needs a name");
      }
      if (options == null) {
        options = {};
      }
      this.options = options;
      this.stringify = new XMLStringifier(options);
      temp = new XMLElement(this, 'doc');
      root = temp.element(name);
      root.isRoot = true;
      root.documentObject = this;
      this.rootObject = root;
      if (!options.headless) {
        root.declaration(options);
        if ((options.pubID != null) || (options.sysID != null)) {
          root.doctype(options);
        }
      }
    }

    XMLBuilder.prototype.root = function() {
      return this.rootObject;
    };

    XMLBuilder.prototype.end = function(options) {
      return this.toString(options);
    };

    XMLBuilder.prototype.toString = function(options) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      r = '';
      if (this.xmldec != null) {
        r += this.xmldec.toString(options);
      }
      if (this.doctype != null) {
        r += this.doctype.toString(options);
      }
      r += this.rootObject.toString(options);
      if (pretty && r.slice(-newline.length) === newline) {
        r = r.slice(0, -newline.length);
      }
      return r;
    };

    return XMLBuilder;

  })();

}).call(this);


/***/ }),
/* 1379 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLStringifier,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    hasProp = {}.hasOwnProperty;

  module.exports = XMLStringifier = (function() {
    function XMLStringifier(options) {
      this.assertLegalChar = bind(this.assertLegalChar, this);
      var key, ref, value;
      this.allowSurrogateChars = options != null ? options.allowSurrogateChars : void 0;
      this.noDoubleEncoding = options != null ? options.noDoubleEncoding : void 0;
      ref = (options != null ? options.stringify : void 0) || {};
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this[key] = value;
      }
    }

    XMLStringifier.prototype.eleName = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.eleText = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(this.elEscape(val));
    };

    XMLStringifier.prototype.cdata = function(val) {
      val = '' + val || '';
      if (val.match(/]]>/)) {
        throw new Error("Invalid CDATA text: " + val);
      }
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.comment = function(val) {
      val = '' + val || '';
      if (val.match(/--/)) {
        throw new Error("Comment text cannot contain double-hypen: " + val);
      }
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.raw = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.attName = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.attValue = function(val) {
      val = '' + val || '';
      return this.attEscape(val);
    };

    XMLStringifier.prototype.insTarget = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.insValue = function(val) {
      val = '' + val || '';
      if (val.match(/\?>/)) {
        throw new Error("Invalid processing instruction value: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlVersion = function(val) {
      val = '' + val || '';
      if (!val.match(/1\.[0-9]+/)) {
        throw new Error("Invalid version number: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlEncoding = function(val) {
      val = '' + val || '';
      if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-]|-)*$/)) {
        throw new Error("Invalid encoding: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlStandalone = function(val) {
      if (val) {
        return "yes";
      } else {
        return "no";
      }
    };

    XMLStringifier.prototype.dtdPubID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdSysID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdElementValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttType = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttDefault = function(val) {
      if (val != null) {
        return '' + val || '';
      } else {
        return val;
      }
    };

    XMLStringifier.prototype.dtdEntityValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdNData = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.convertAttKey = '@';

    XMLStringifier.prototype.convertPIKey = '?';

    XMLStringifier.prototype.convertTextKey = '#text';

    XMLStringifier.prototype.convertCDataKey = '#cdata';

    XMLStringifier.prototype.convertCommentKey = '#comment';

    XMLStringifier.prototype.convertRawKey = '#raw';

    XMLStringifier.prototype.assertLegalChar = function(str) {
      var chars, chr;
      if (this.allowSurrogateChars) {
        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uFFFE-\uFFFF]/;
      } else {
        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uD800-\uDFFF\uFFFE-\uFFFF]/;
      }
      chr = str.match(chars);
      if (chr) {
        throw new Error("Invalid character (" + chr + ") in string: " + str + " at index " + chr.index);
      }
      return str;
    };

    XMLStringifier.prototype.elEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
    };

    XMLStringifier.prototype.attEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    };

    return XMLStringifier;

  })();

}).call(this);


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(784),
    keys = __webpack_require__(256);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(119);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(786),
    getTag = __webpack_require__(788),
    isArguments = __webpack_require__(447),
    isArray = __webpack_require__(120),
    isArrayLike = __webpack_require__(255),
    isBuffer = __webpack_require__(448),
    isPrototype = __webpack_require__(446),
    isTypedArray = __webpack_require__(449);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(176),
    root = __webpack_require__(140);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(176),
    root = __webpack_require__(140);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(176),
    root = __webpack_require__(140);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(176),
    root = __webpack_require__(140);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(1388),
    baseEvery = __webpack_require__(1389),
    baseIteratee = __webpack_require__(1395),
    isArray = __webpack_require__(120),
    isIterateeCall = __webpack_require__(785);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 1388 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1390);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1391),
    createBaseEach = __webpack_require__(1394);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1392),
    keys = __webpack_require__(256);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1393);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1393 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(255);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1396),
    baseMatchesProperty = __webpack_require__(1438),
    identity = __webpack_require__(443),
    isArray = __webpack_require__(120),
    property = __webpack_require__(1449);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1397),
    getMatchData = __webpack_require__(1437),
    matchesStrictComparable = __webpack_require__(794);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(790),
    baseIsEqual = __webpack_require__(791);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1398 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(326);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(326);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(326);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(326);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(325);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1404 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1405 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1406 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(325),
    Map = __webpack_require__(450),
    MapCache = __webpack_require__(451);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1409),
    ListCache = __webpack_require__(325),
    Map = __webpack_require__(450);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1410),
    hashDelete = __webpack_require__(1411),
    hashGet = __webpack_require__(1412),
    hashHas = __webpack_require__(1413),
    hashSet = __webpack_require__(1414);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(327);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1411 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(327);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(327);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(327);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(328);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1416 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(328);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(328);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(328);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(790),
    equalArrays = __webpack_require__(792),
    equalByTag = __webpack_require__(1426),
    equalObjects = __webpack_require__(1430),
    getTag = __webpack_require__(788),
    isArray = __webpack_require__(120),
    isBuffer = __webpack_require__(448),
    isTypedArray = __webpack_require__(449);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(451),
    setCacheAdd = __webpack_require__(1422),
    setCacheHas = __webpack_require__(1423);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1422 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1423 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1424 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1425 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(323),
    Uint8Array = __webpack_require__(1427),
    eq = __webpack_require__(324),
    equalArrays = __webpack_require__(792),
    mapToArray = __webpack_require__(1428),
    setToArray = __webpack_require__(1429);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(140);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1428 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1429 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1431);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1432),
    getSymbols = __webpack_require__(1434),
    keys = __webpack_require__(256);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1433),
    isArray = __webpack_require__(120);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1433 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1435),
    stubArray = __webpack_require__(1436);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1435 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1436 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(793),
    keys = __webpack_require__(256);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(791),
    get = __webpack_require__(1439),
    hasIn = __webpack_require__(1446),
    isKey = __webpack_require__(452),
    isStrictComparable = __webpack_require__(793),
    matchesStrictComparable = __webpack_require__(794),
    toKey = __webpack_require__(329);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(795);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1441);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1442);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(451);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1444);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(323),
    arrayMap = __webpack_require__(1445),
    isArray = __webpack_require__(120),
    isSymbol = __webpack_require__(453);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1445 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1447),
    hasPath = __webpack_require__(1448);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1447 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(796),
    isArguments = __webpack_require__(447),
    isArray = __webpack_require__(120),
    isIndex = __webpack_require__(445),
    isLength = __webpack_require__(444),
    toKey = __webpack_require__(329);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1450),
    basePropertyDeep = __webpack_require__(1451),
    isKey = __webpack_require__(452),
    toKey = __webpack_require__(329);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1450 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(795);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLAttribute, create;

  create = __webpack_require__(90);

  module.exports = XMLAttribute = (function() {
    function XMLAttribute(parent, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing attribute name of element " + parent.name);
      }
      if (value == null) {
        throw new Error("Missing attribute value for attribute " + name + " of element " + parent.name);
      }
      this.name = this.stringify.attName(name);
      this.value = this.stringify.attValue(value);
    }

    XMLAttribute.prototype.clone = function() {
      return create(XMLAttribute.prototype, this);
    };

    XMLAttribute.prototype.toString = function(options, level) {
      return ' ' + this.name + '="' + this.value + '"';
    };

    return XMLAttribute;

  })();

}).call(this);


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDAttList, create;

  create = __webpack_require__(90);

  module.exports = XMLDTDAttList = (function() {
    function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      this.stringify = parent.stringify;
      if (elementName == null) {
        throw new Error("Missing DTD element name");
      }
      if (attributeName == null) {
        throw new Error("Missing DTD attribute name");
      }
      if (!attributeType) {
        throw new Error("Missing DTD attribute type");
      }
      if (!defaultValueType) {
        throw new Error("Missing DTD attribute default");
      }
      if (defaultValueType.indexOf('#') !== 0) {
        defaultValueType = '#' + defaultValueType;
      }
      if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
      }
      if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
        throw new Error("Default value only applies to #FIXED or #DEFAULT");
      }
      this.elementName = this.stringify.eleName(elementName);
      this.attributeName = this.stringify.attName(attributeName);
      this.attributeType = this.stringify.dtdAttType(attributeType);
      this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
      this.defaultValueType = defaultValueType;
    }

    XMLDTDAttList.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!ATTLIST ' + this.elementName + ' ' + this.attributeName + ' ' + this.attributeType;
      if (this.defaultValueType !== '#DEFAULT') {
        r += ' ' + this.defaultValueType;
      }
      if (this.defaultValue) {
        r += ' "' + this.defaultValue + '"';
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDAttList;

  })();

}).call(this);


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDEntity, create, isObject;

  create = __webpack_require__(90);

  isObject = __webpack_require__(119);

  module.exports = XMLDTDEntity = (function() {
    function XMLDTDEntity(parent, pe, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing entity name");
      }
      if (value == null) {
        throw new Error("Missing entity value");
      }
      this.pe = !!pe;
      this.name = this.stringify.eleName(name);
      if (!isObject(value)) {
        this.value = this.stringify.dtdEntityValue(value);
      } else {
        if (!value.pubID && !value.sysID) {
          throw new Error("Public and/or system identifiers are required for an external entity");
        }
        if (value.pubID && !value.sysID) {
          throw new Error("System identifier is required for a public external entity");
        }
        if (value.pubID != null) {
          this.pubID = this.stringify.dtdPubID(value.pubID);
        }
        if (value.sysID != null) {
          this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        if (value.nData != null) {
          this.nData = this.stringify.dtdNData(value.nData);
        }
        if (this.pe && this.nData) {
          throw new Error("Notation declaration is not allowed in a parameter entity");
        }
      }
    }

    XMLDTDEntity.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!ENTITY';
      if (this.pe) {
        r += ' %';
      }
      r += ' ' + this.name;
      if (this.value) {
        r += ' "' + this.value + '"';
      } else {
        if (this.pubID && this.sysID) {
          r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
        } else if (this.sysID) {
          r += ' SYSTEM "' + this.sysID + '"';
        }
        if (this.nData) {
          r += ' NDATA ' + this.nData;
        }
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDEntity;

  })();

}).call(this);


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDElement, create;

  create = __webpack_require__(90);

  module.exports = XMLDTDElement = (function() {
    function XMLDTDElement(parent, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing DTD element name");
      }
      if (!value) {
        value = '(#PCDATA)';
      }
      if (Array.isArray(value)) {
        value = '(' + value.join(',') + ')';
      }
      this.name = this.stringify.eleName(name);
      this.value = this.stringify.dtdElementValue(value);
    }

    XMLDTDElement.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!ELEMENT ' + this.name + ' ' + this.value + '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDElement;

  })();

}).call(this);


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLDTDNotation, create;

  create = __webpack_require__(90);

  module.exports = XMLDTDNotation = (function() {
    function XMLDTDNotation(parent, name, value) {
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing notation name");
      }
      if (!value.pubID && !value.sysID) {
        throw new Error("Public or system identifiers are required for an external entity");
      }
      this.name = this.stringify.eleName(name);
      if (value.pubID != null) {
        this.pubID = this.stringify.dtdPubID(value.pubID);
      }
      if (value.sysID != null) {
        this.sysID = this.stringify.dtdSysID(value.sysID);
      }
    }

    XMLDTDNotation.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += '<!NOTATION ' + this.name;
      if (this.pubID && this.sysID) {
        r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
      } else if (this.pubID) {
        r += ' PUBLIC "' + this.pubID + '"';
      } else if (this.sysID) {
        r += ' SYSTEM "' + this.sysID + '"';
      }
      r += '>';
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLDTDNotation;

  })();

}).call(this);


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLNode, XMLRaw, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(90);

  XMLNode = __webpack_require__(221);

  module.exports = XMLRaw = (function(superClass) {
    extend(XMLRaw, superClass);

    function XMLRaw(parent, text) {
      XMLRaw.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing raw text");
      }
      this.value = this.stringify.raw(text);
    }

    XMLRaw.prototype.clone = function() {
      return create(XMLRaw.prototype, this);
    };

    XMLRaw.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += this.value;
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLRaw;

  })(XMLNode);

}).call(this);


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.9.1
(function() {
  var XMLNode, XMLText, create,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  create = __webpack_require__(90);

  XMLNode = __webpack_require__(221);

  module.exports = XMLText = (function(superClass) {
    extend(XMLText, superClass);

    function XMLText(parent, text) {
      XMLText.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing element text");
      }
      this.value = this.stringify.eleText(text);
    }

    XMLText.prototype.clone = function() {
      return create(XMLText.prototype, this);
    };

    XMLText.prototype.toString = function(options, level) {
      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
      pretty = (options != null ? options.pretty : void 0) || false;
      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
      level || (level = 0);
      space = new Array(level + offset + 1).join(indent);
      r = '';
      if (pretty) {
        r += space;
      }
      r += this.value;
      if (pretty) {
        r += newline;
      }
      return r;
    };

    return XMLText;

  })(XMLNode);

}).call(this);


/***/ }),
/* 1459 */
/***/ (function(module, exports) {

function apiLoader(svc, version) {
  if (!apiLoader.services.hasOwnProperty(svc)) {
    throw new Error('InvalidService: Failed to load api for ' + svc);
  }
  return apiLoader.services[svc][version];
}

/**
 * This member of AWS.apiLoader is private, but changing it will necessitate a
 * change to ../scripts/services-table-generator.ts
 */
apiLoader.services = {};
module.exports = apiLoader;


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var Api = __webpack_require__(801);
var regionConfig = __webpack_require__(1461);
var inherit = AWS.util.inherit;
var clientCount = 0;

/**
 * The service class representing an AWS service.
 *
 * @abstract
 *
 * @!attribute apiVersions
 *   @return [Array<String>] the list of API versions supported by this service.
 *   @readonly
 */
AWS.Service = inherit({
  /**
   * Create a new service object with a configuration object
   *
   * @param config [map] a map of configuration options
   */
  constructor: function Service(config) {
    if (!this.loadServiceClass) {
      throw AWS.util.error(new Error(),
        'Service must be constructed with `new\' operator');
    }
    var ServiceClass = this.loadServiceClass(config || {});
    if (ServiceClass) {
      var originalConfig = AWS.util.copy(config);
      var svc = new ServiceClass(config);
      Object.defineProperty(svc, '_originalConfig', {
        get: function() { return originalConfig; },
        enumerable: false,
        configurable: true
      });
      svc._clientId = ++clientCount;
      return svc;
    }
    this.initialize(config);
  },

  /**
   * @api private
   */
  initialize: function initialize(config) {
    var svcConfig = AWS.config[this.serviceIdentifier];

    this.config = new AWS.Config(AWS.config);
    if (svcConfig) this.config.update(svcConfig, true);
    if (config) this.config.update(config, true);

    this.validateService();
    if (!this.config.endpoint) regionConfig(this);

    this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
    this.setEndpoint(this.config.endpoint);
  },

  /**
   * @api private
   */
  validateService: function validateService() {
  },

  /**
   * @api private
   */
  loadServiceClass: function loadServiceClass(serviceConfig) {
    var config = serviceConfig;
    if (!AWS.util.isEmpty(this.api)) {
      return null;
    } else if (config.apiConfig) {
      return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
    } else if (!this.constructor.services) {
      return null;
    } else {
      config = new AWS.Config(AWS.config);
      config.update(serviceConfig, true);
      var version = config.apiVersions[this.constructor.serviceIdentifier];
      version = version || config.apiVersion;
      return this.getLatestServiceClass(version);
    }
  },

  /**
   * @api private
   */
  getLatestServiceClass: function getLatestServiceClass(version) {
    version = this.getLatestServiceVersion(version);
    if (this.constructor.services[version] === null) {
      AWS.Service.defineServiceApi(this.constructor, version);
    }

    return this.constructor.services[version];
  },

  /**
   * @api private
   */
  getLatestServiceVersion: function getLatestServiceVersion(version) {
    if (!this.constructor.services || this.constructor.services.length === 0) {
      throw new Error('No services defined on ' +
                      this.constructor.serviceIdentifier);
    }

    if (!version) {
      version = 'latest';
    } else if (AWS.util.isType(version, Date)) {
      version = AWS.util.date.iso8601(version).split('T')[0];
    }

    if (Object.hasOwnProperty(this.constructor.services, version)) {
      return version;
    }

    var keys = Object.keys(this.constructor.services).sort();
    var selectedVersion = null;
    for (var i = keys.length - 1; i >= 0; i--) {
      // versions that end in "*" are not available on disk and can be
      // skipped, so do not choose these as selectedVersions
      if (keys[i][keys[i].length - 1] !== '*') {
        selectedVersion = keys[i];
      }
      if (keys[i].substr(0, 10) <= version) {
        return selectedVersion;
      }
    }

    throw new Error('Could not find ' + this.constructor.serviceIdentifier +
                    ' API to satisfy version constraint `' + version + '\'');
  },

  /**
   * @api private
   */
  api: {},

  /**
   * @api private
   */
  defaultRetryCount: 3,

  /**
   * @api private
   */
  customizeRequests: function customizeRequests(callback) {
    if (!callback) {
      this.customRequestHandler = null;
    } else if (typeof callback === 'function') {
      this.customRequestHandler = callback;
    } else {
      throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
    }
  },

  /**
   * Calls an operation on a service with the given input parameters.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  makeRequest: function makeRequest(operation, params, callback) {
    if (typeof params === 'function') {
      callback = params;
      params = null;
    }

    params = params || {};
    if (this.config.params) { // copy only toplevel bound params
      var rules = this.api.operations[operation];
      if (rules) {
        params = AWS.util.copy(params);
        AWS.util.each(this.config.params, function(key, value) {
          if (rules.input.members[key]) {
            if (params[key] === undefined || params[key] === null) {
              params[key] = value;
            }
          }
        });
      }
    }

    var request = new AWS.Request(this, operation, params);
    this.addAllRequestListeners(request);

    if (callback) request.send(callback);
    return request;
  },

  /**
   * Calls an operation on a service with the given input parameters, without
   * any authentication data. This method is useful for "public" API operations.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
    if (typeof params === 'function') {
      callback = params;
      params = {};
    }

    var request = this.makeRequest(operation, params).toUnauthenticated();
    return callback ? request.send(callback) : request;
  },

  /**
   * Waits for a given state
   *
   * @param state [String] the state on the service to wait for
   * @param params [map] a map of parameters to pass with each request
   * @option params $waiter [map] a map of configuration options for the waiter
   * @option params $waiter.delay [Number] The number of seconds to wait between
   *                                       requests
   * @option params $waiter.maxAttempts [Number] The maximum number of requests
   *                                             to send while waiting
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */
  waitFor: function waitFor(state, params, callback) {
    var waiter = new AWS.ResourceWaiter(this, state);
    return waiter.wait(params, callback);
  },

  /**
   * @api private
   */
  addAllRequestListeners: function addAllRequestListeners(request) {
    var list = [AWS.events, AWS.EventListeners.Core, this.serviceInterface(),
                AWS.EventListeners.CorePost];
    for (var i = 0; i < list.length; i++) {
      if (list[i]) request.addListeners(list[i]);
    }

    // disable parameter validation
    if (!this.config.paramValidation) {
      request.removeListener('validate',
        AWS.EventListeners.Core.VALIDATE_PARAMETERS);
    }

    if (this.config.logger) { // add logging events
      request.addListeners(AWS.EventListeners.Logger);
    }

    this.setupRequestListeners(request);
    // call prototype's customRequestHandler
    if (typeof this.constructor.prototype.customRequestHandler === 'function') {
      this.constructor.prototype.customRequestHandler(request);
    }
    // call instance's customRequestHandler
    if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') {
      this.customRequestHandler(request);
    }
  },

  /**
   * Override this method to setup any custom request listeners for each
   * new request to the service.
   *
   * @abstract
   */
  setupRequestListeners: function setupRequestListeners() {
  },

  /**
   * Gets the signer class for a given request
   * @api private
   */
  getSignerClass: function getSignerClass(request) {
    var version;
    // get operation authtype if present
    var operation = null;
    var authtype = '';
    if (request) {
      var operations = request.service.api.operations || {};
      operation = operations[request.operation] || null;
      authtype = operation ? operation.authtype : '';
    }
    if (this.config.signatureVersion) {
      version = this.config.signatureVersion;
    } else if (authtype === 'v4' || authtype === 'v4-unsigned-body') {
      version = 'v4';
    } else {
      version = this.api.signatureVersion;
    }
    return AWS.Signers.RequestSigner.getVersion(version);
  },

  /**
   * @api private
   */
  serviceInterface: function serviceInterface() {
    switch (this.api.protocol) {
      case 'ec2': return AWS.EventListeners.Query;
      case 'query': return AWS.EventListeners.Query;
      case 'json': return AWS.EventListeners.Json;
      case 'rest-json': return AWS.EventListeners.RestJson;
      case 'rest-xml': return AWS.EventListeners.RestXml;
    }
    if (this.api.protocol) {
      throw new Error('Invalid service `protocol\' ' +
        this.api.protocol + ' in API config');
    }
  },

  /**
   * @api private
   */
  successfulResponse: function successfulResponse(resp) {
    return resp.httpResponse.statusCode < 300;
  },

  /**
   * How many times a failed request should be retried before giving up.
   * the defaultRetryCount can be overriden by service classes.
   *
   * @api private
   */
  numRetries: function numRetries() {
    if (this.config.maxRetries !== undefined) {
      return this.config.maxRetries;
    } else {
      return this.defaultRetryCount;
    }
  },

  /**
   * @api private
   */
  retryDelays: function retryDelays(retryCount) {
    return AWS.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions);
  },

  /**
   * @api private
   */
  retryableError: function retryableError(error) {
    if (this.timeoutError(error)) return true;
    if (this.networkingError(error)) return true;
    if (this.expiredCredentialsError(error)) return true;
    if (this.throttledError(error)) return true;
    if (error.statusCode >= 500) return true;
    return false;
  },

  /**
   * @api private
   */
  networkingError: function networkingError(error) {
    return error.code === 'NetworkingError';
  },

  /**
   * @api private
   */
  timeoutError: function timeoutError(error) {
    return error.code === 'TimeoutError';
  },

  /**
   * @api private
   */
  expiredCredentialsError: function expiredCredentialsError(error) {
    // TODO : this only handles *one* of the expired credential codes
    return (error.code === 'ExpiredTokenException');
  },

  /**
   * @api private
   */
  clockSkewError: function clockSkewError(error) {
    switch (error.code) {
      case 'RequestTimeTooSkewed':
      case 'RequestExpired':
      case 'InvalidSignatureException':
      case 'SignatureDoesNotMatch':
      case 'AuthFailure':
      case 'RequestInTheFuture':
        return true;
      default: return false;
    }
  },

  /**
   * @api private
   */
  throttledError: function throttledError(error) {
    // this logic varies between services
    switch (error.code) {
      case 'ProvisionedThroughputExceededException':
      case 'Throttling':
      case 'ThrottlingException':
      case 'RequestLimitExceeded':
      case 'RequestThrottled':
        return true;
      default:
        return false;
    }
  },

  /**
   * @api private
   */
  endpointFromTemplate: function endpointFromTemplate(endpoint) {
    if (typeof endpoint !== 'string') return endpoint;

    var e = endpoint;
    e = e.replace(/\{service\}/g, this.api.endpointPrefix);
    e = e.replace(/\{region\}/g, this.config.region);
    e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
    return e;
  },

  /**
   * @api private
   */
  setEndpoint: function setEndpoint(endpoint) {
    this.endpoint = new AWS.Endpoint(endpoint, this.config);
  },

  /**
   * @api private
   */
  paginationConfig: function paginationConfig(operation, throwException) {
    var paginator = this.api.operations[operation].paginator;
    if (!paginator) {
      if (throwException) {
        var e = new Error();
        throw AWS.util.error(e, 'No pagination configuration for ' + operation);
      }
      return null;
    }

    return paginator;
  }
});

AWS.util.update(AWS.Service, {

  /**
   * Adds one method for each operation described in the api configuration
   *
   * @api private
   */
  defineMethods: function defineMethods(svc) {
    AWS.util.each(svc.prototype.api.operations, function iterator(method) {
      if (svc.prototype[method]) return;
      var operation = svc.prototype.api.operations[method];
      if (operation.authtype === 'none') {
        svc.prototype[method] = function (params, callback) {
          return this.makeUnauthenticatedRequest(method, params, callback);
        };
      } else {
        svc.prototype[method] = function (params, callback) {
          return this.makeRequest(method, params, callback);
        };
      }
    });
  },

  /**
   * Defines a new Service class using a service identifier and list of versions
   * including an optional set of features (functions) to apply to the class
   * prototype.
   *
   * @param serviceIdentifier [String] the identifier for the service
   * @param versions [Array<String>] a list of versions that work with this
   *   service
   * @param features [Object] an object to attach to the prototype
   * @return [Class<Service>] the service class defined by this function.
   */
  defineService: function defineService(serviceIdentifier, versions, features) {
    AWS.Service._serviceMap[serviceIdentifier] = true;
    if (!Array.isArray(versions)) {
      features = versions;
      versions = [];
    }

    var svc = inherit(AWS.Service, features || {});

    if (typeof serviceIdentifier === 'string') {
      AWS.Service.addVersions(svc, versions);

      var identifier = svc.serviceIdentifier || serviceIdentifier;
      svc.serviceIdentifier = identifier;
    } else { // defineService called with an API
      svc.prototype.api = serviceIdentifier;
      AWS.Service.defineMethods(svc);
    }

    return svc;
  },

  /**
   * @api private
   */
  addVersions: function addVersions(svc, versions) {
    if (!Array.isArray(versions)) versions = [versions];

    svc.services = svc.services || {};
    for (var i = 0; i < versions.length; i++) {
      if (svc.services[versions[i]] === undefined) {
        svc.services[versions[i]] = null;
      }
    }

    svc.apiVersions = Object.keys(svc.services).sort();
  },

  /**
   * @api private
   */
  defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
    var svc = inherit(superclass, {
      serviceIdentifier: superclass.serviceIdentifier
    });

    function setApi(api) {
      if (api.isApi) {
        svc.prototype.api = api;
      } else {
        svc.prototype.api = new Api(api);
      }
    }

    if (typeof version === 'string') {
      if (apiConfig) {
        setApi(apiConfig);
      } else {
        try {
          setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
        } catch (err) {
          throw AWS.util.error(err, {
            message: 'Could not find API configuration ' +
              superclass.serviceIdentifier + '-' + version
          });
        }
      }
      if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) {
        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
      }
      superclass.services[version] = svc;
    } else {
      setApi(version);
    }

    AWS.Service.defineMethods(svc);
    return svc;
  },

  /**
   * @api private
   */
  hasService: function(identifier) {
    return Object.prototype.hasOwnProperty.call(AWS.Service._serviceMap, identifier);
  },

  /**
   * @api private
   */
  _serviceMap: {}
});

module.exports = AWS.Service;


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(68);
var regionConfig = __webpack_require__(1462);

function generateRegionPrefix(region) {
  if (!region) return null;

  var parts = region.split('-');
  if (parts.length < 3) return null;
  return parts.slice(0, parts.length - 2).join('-') + '-*';
}

function derivedKeys(service) {
  var region = service.config.region;
  var regionPrefix = generateRegionPrefix(region);
  var endpointPrefix = service.api.endpointPrefix;

  return [
    [region, endpointPrefix],
    [regionPrefix, endpointPrefix],
    [region, '*'],
    [regionPrefix, '*'],
    ['*', endpointPrefix],
    ['*', '*']
  ].map(function(item) {
    return item[0] && item[1] ? item.join('/') : null;
  });
}

function applyConfig(service, config) {
  util.each(config, function(key, value) {
    if (key === 'globalEndpoint') return;
    if (service.config[key] === undefined || service.config[key] === null) {
      service.config[key] = value;
    }
  });
}

function configureEndpoint(service) {
  var keys = derivedKeys(service);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!key) continue;

    if (Object.prototype.hasOwnProperty.call(regionConfig.rules, key)) {
      var config = regionConfig.rules[key];
      if (typeof config === 'string') {
        config = regionConfig.patterns[config];
      }

      // set dualstack endpoint
      if (service.config.useDualstack && util.isDualstackAvailable(service)) {
        config = util.copy(config);
        config.endpoint = '{service}.dualstack.{region}.amazonaws.com';
      }

      // set global endpoint
      service.isGlobalEndpoint = !!config.globalEndpoint;

      // signature version
      if (!config.signatureVersion) config.signatureVersion = 'v4';

      // merge config
      applyConfig(service, config);
      return;
    }
  }
}

module.exports = configureEndpoint;


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

module.exports = {
	"rules": {
		"*/*": {
			"endpoint": "{service}.{region}.amazonaws.com"
		},
		"cn-*/*": {
			"endpoint": "{service}.{region}.amazonaws.com.cn"
		},
		"*/budgets": "globalSSL",
		"*/cloudfront": "globalSSL",
		"*/iam": "globalSSL",
		"*/sts": "globalSSL",
		"*/importexport": {
			"endpoint": "{service}.amazonaws.com",
			"signatureVersion": "v2",
			"globalEndpoint": true
		},
		"*/route53": {
			"endpoint": "https://{service}.amazonaws.com",
			"signatureVersion": "v3https",
			"globalEndpoint": true
		},
		"*/waf": "globalSSL",
		"us-gov-*/iam": "globalGovCloud",
		"us-gov-*/sts": {
			"endpoint": "{service}.{region}.amazonaws.com"
		},
		"us-gov-west-1/s3": "s3dash",
		"us-west-1/s3": "s3dash",
		"us-west-2/s3": "s3dash",
		"eu-west-1/s3": "s3dash",
		"ap-southeast-1/s3": "s3dash",
		"ap-southeast-2/s3": "s3dash",
		"ap-northeast-1/s3": "s3dash",
		"sa-east-1/s3": "s3dash",
		"us-east-1/s3": {
			"endpoint": "{service}.amazonaws.com",
			"signatureVersion": "s3"
		},
		"us-east-1/sdb": {
			"endpoint": "{service}.amazonaws.com",
			"signatureVersion": "v2"
		},
		"*/sdb": {
			"endpoint": "{service}.{region}.amazonaws.com",
			"signatureVersion": "v2"
		}
	},
	"patterns": {
		"globalSSL": {
			"endpoint": "https://{service}.amazonaws.com",
			"globalEndpoint": true
		},
		"globalGovCloud": {
			"endpoint": "{service}.us-gov.amazonaws.com"
		},
		"s3dash": {
			"endpoint": "{service}-{region}.amazonaws.com",
			"signatureVersion": "s3"
		}
	}
};

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
__webpack_require__(805);
__webpack_require__(806);
var PromisesDependency;

/**
 * The main configuration class used by all service objects to set
 * the region, credentials, and other options for requests.
 *
 * By default, credentials and region settings are left unconfigured.
 * This should be configured by the application before using any
 * AWS service APIs.
 *
 * In order to set global configuration options, properties should
 * be assigned to the global {AWS.config} object.
 *
 * @see AWS.config
 *
 * @!group General Configuration Options
 *
 * @!attribute credentials
 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
 *
 * @!attribute region
 *   @example Set the global region setting to us-west-2
 *     AWS.config.update({region: 'us-west-2'});
 *   @return [AWS.Credentials] The region to send service requests to.
 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
 *     A list of available endpoints for each AWS service
 *
 * @!attribute maxRetries
 *   @return [Integer] the maximum amount of retries to perform for a
 *     service request. By default this value is calculated by the specific
 *     service object that the request is being made to.
 *
 * @!attribute maxRedirects
 *   @return [Integer] the maximum amount of redirects to follow for a
 *     service request. Defaults to 10.
 *
 * @!attribute paramValidation
 *   @return [Boolean|map] whether input parameters should be validated against
 *     the operation description before sending the request. Defaults to true.
 *     Pass a map to enable any of the following specific validation features:
 *
 *     * **min** [Boolean] &mdash; Validates that a value meets the min
 *       constraint. This is enabled by default when paramValidation is set
 *       to `true`.
 *     * **max** [Boolean] &mdash; Validates that a value meets the max
 *       constraint.
 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
 *       regular expression.
 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
 *       of the allowable enum values.
 *
 * @!attribute computeChecksums
 *   @return [Boolean] whether to compute checksums for payload bodies when
 *     the service accepts it (currently supported in S3 only).
 *
 * @!attribute convertResponseTypes
 *   @return [Boolean] whether types are converted when parsing response data.
 *     Currently only supported for JSON based services. Turning this off may
 *     improve performance on large response payloads. Defaults to `true`.
 *
 * @!attribute correctClockSkew
 *   @return [Boolean] whether to apply a clock skew correction and retry
 *     requests that fail because of an skewed client clock. Defaults to
 *     `false`.
 *
 * @!attribute sslEnabled
 *   @return [Boolean] whether SSL is enabled for requests
 *
 * @!attribute s3ForcePathStyle
 *   @return [Boolean] whether to force path style URLs for S3 objects
 *
 * @!attribute s3BucketEndpoint
 *   @note Setting this configuration option requires an `endpoint` to be
 *     provided explicitly to the service constructor.
 *   @return [Boolean] whether the provided endpoint addresses an individual
 *     bucket (false if it addresses the root API endpoint).
 *
 * @!attribute s3DisableBodySigning
 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
 *     Body signing can only be disabled when using https. Defaults to `true`.
 *
 * @!attribute useAccelerateEndpoint
 *   @note This configuration option is only compatible with S3 while accessing
 *     dns-compatible buckets.
 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
 *     Defaults to `false`.
 *
 * @!attribute retryDelayOptions
 *   @example Set the base retry delay for all services to 300 ms
 *     AWS.config.update({retryDelayOptions: {base: 300}});
 *     // Delays with maxRetries = 3: 300, 600, 1200
 *   @example Set a custom backoff function to provide delay values on retries
 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount) {
 *       // returns delay in ms
 *     }}});
 *   @return [map] A set of options to configure the retry delay on retryable errors.
 *     Currently supported options are:
 *
 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
 *       DynamoDB, where it defaults to 50ms.
 *     * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
 *       and returns the amount of time to delay in milliseconds. The `base` option will be
 *       ignored if this option is supplied.
 *
 * @!attribute httpOptions
 *   @return [map] A set of options to pass to the low-level HTTP request.
 *     Currently supported options are:
 *
 *     * **proxy** [String] &mdash; the URL to proxy requests through
 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
 *       HTTP requests with. Used for connection pooling. Defaults to the global
 *       agent (`http.globalAgent`) for non-SSL connections. Note that for
 *       SSL connections, a special Agent object is used in order to enable
 *       peer certificate verification. This feature is only supported in the
 *       Node.js environment.
 *     * **timeout** [Integer] &mdash; The number of milliseconds to wait before
 *       giving up on a connection attempt. Defaults to two minutes (120000).
 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
 *       HTTP requests. Used in the browser environment only. Set to false to
 *       send requests synchronously. Defaults to true (async on).
 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
 *       property of an XMLHttpRequest object. Used in the browser environment
 *       only. Defaults to false.
 * @!attribute logger
 *   @return [#write,#log] an object that responds to .write() (like a stream)
 *     or .log() (like the console object) in order to log information about
 *     requests
 *
 * @!attribute systemClockOffset
 *   @return [Number] an offset value in milliseconds to apply to all signing
 *     times. Use this to compensate for clock skew when your system may be
 *     out of sync with the service time. Note that this configuration option
 *     can only be applied to the global `AWS.config` object and cannot be
 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
 *
 * @!attribute signatureVersion
 *   @return [String] the signature version to sign requests with (overriding
 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
 *
 * @!attribute signatureCache
 *   @return [Boolean] whether the signature to sign requests with (overriding
 *     the API configuration) is cached. Only applies to the signature version 'v4'.
 *     Defaults to `true`.
 */
AWS.Config = AWS.util.inherit({
  /**
   * @!endgroup
   */

  /**
   * Creates a new configuration object. This is the object that passes
   * option data along to service requests, including credentials, security,
   * region information, and some service specific settings.
   *
   * @example Creating a new configuration object with credentials and region
   *   var config = new AWS.Config({
   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
   *   });
   * @option options accessKeyId [String] your AWS access key ID.
   * @option options secretAccessKey [String] your AWS secret access key.
   * @option options sessionToken [AWS.Credentials] the optional AWS
   *   session token to sign requests with.
   * @option options credentials [AWS.Credentials] the AWS credentials
   *   to sign requests with. You can either specify this object, or
   *   specify the accessKeyId and secretAccessKey options directly.
   * @option options credentialProvider [AWS.CredentialProviderChain] the
   *   provider chain used to resolve credentials if no static `credentials`
   *   property is set.
   * @option options region [String] the region to send service requests to.
   *   See {region} for more information.
   * @option options maxRetries [Integer] the maximum amount of retries to
   *   attempt with a request. See {maxRetries} for more information.
   * @option options maxRedirects [Integer] the maximum amount of redirects to
   *   follow with a request. See {maxRedirects} for more information.
   * @option options sslEnabled [Boolean] whether to enable SSL for
   *   requests.
   * @option options paramValidation [Boolean|map] whether input parameters
   *   should be validated against the operation description before sending
   *   the request. Defaults to true. Pass a map to enable any of the
   *   following specific validation features:
   *
   *   * **min** [Boolean] &mdash; Validates that a value meets the min
   *     constraint. This is enabled by default when paramValidation is set
   *     to `true`.
   *   * **max** [Boolean] &mdash; Validates that a value meets the max
   *     constraint.
   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *     regular expression.
   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
   *     of the allowable enum values.
   * @option options computeChecksums [Boolean] whether to compute checksums
   *   for payload bodies when the service accepts it (currently supported
   *   in S3 only)
   * @option options convertResponseTypes [Boolean] whether types are converted
   *     when parsing response data. Currently only supported for JSON based
   *     services. Turning this off may improve performance on large response
   *     payloads. Defaults to `true`.
   * @option options correctClockSkew [Boolean] whether to apply a clock skew
   *     correction and retry requests that fail because of an skewed client
   *     clock. Defaults to `false`.
   * @option options s3ForcePathStyle [Boolean] whether to force path
   *   style URLs for S3 objects.
   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
   *   addresses an individual bucket (false if it addresses the root API
   *   endpoint). Note that setting this configuration option requires an
   *   `endpoint` to be provided explicitly to the service constructor.
   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
   *   should be disabled when using signature version `v4`. Body signing
   *   can only be disabled when using https. Defaults to `true`.
   *
   * @option options retryDelayOptions [map] A set of options to configure
   *   the retry delay on retryable errors. Currently supported options are:
   *
   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
   *     exponential backoff for operation retries. Defaults to 100 ms for all
   *     services except DynamoDB, where it defaults to 50ms.
   *   * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
   *     and returns the amount of time to delay in milliseconds. The `base` option will be
   *     ignored if this option is supplied.
   * @option options httpOptions [map] A set of options to pass to the low-level
   *   HTTP request. Currently supported options are:
   *
   *   * **proxy** [String] &mdash; the URL to proxy requests through
   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
   *     HTTP requests with. Used for connection pooling. Defaults to the global
   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
   *     SSL connections, a special Agent object is used in order to enable
   *     peer certificate verification. This feature is only available in the
   *     Node.js environment.
   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
   *     failing to establish a connection with the server after
   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
   *     connection has been established.
   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
   *     milliseconds of inactivity on the socket. Defaults to two minutes
   *     (120000).
   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
   *     HTTP requests. Used in the browser environment only. Set to false to
   *     send requests synchronously. Defaults to true (async on).
   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
   *     property of an XMLHttpRequest object. Used in the browser environment
   *     only. Defaults to false.
   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
   *   (or a date) that represents the latest possible API version that can be
   *   used in all services (unless overridden by `apiVersions`). Specify
   *   'latest' to use the latest possible version.
   * @option options apiVersions [map<String, String|Date>] a map of service
   *   identifiers (the lowercase service class name) with the API version to
   *   use when instantiating a service. Specify 'latest' for each individual
   *   that can use the latest available version.
   * @option options logger [#write,#log] an object that responds to .write()
   *   (like a stream) or .log() (like the console object) in order to log
   *   information about requests
   * @option options systemClockOffset [Number] an offset value in milliseconds
   *   to apply to all signing times. Use this to compensate for clock skew
   *   when your system may be out of sync with the service time. Note that
   *   this configuration option can only be applied to the global `AWS.config`
   *   object and cannot be overridden in service-specific configuration.
   *   Defaults to 0 milliseconds.
   * @option options signatureVersion [String] the signature version to sign
   *   requests with (overriding the API configuration). Possible values are:
   *   'v2', 'v3', 'v4'.
   * @option options signatureCache [Boolean] whether the signature to sign
   *   requests with (overriding the API configuration) is cached. Only applies
   *   to the signature version 'v4'. Defaults to `true`.
   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
   */
  constructor: function Config(options) {
    if (options === undefined) options = {};
    options = this.extractCredentials(options);

    AWS.util.each.call(this, this.keys, function (key, value) {
      this.set(key, options[key], value);
    });
  },

  /**
   * @!group Managing Credentials
   */

  /**
   * Loads credentials from the configuration object. This is used internally
   * by the SDK to ensure that refreshable {Credentials} objects are properly
   * refreshed and loaded when sending a request. If you want to ensure that
   * your credentials are loaded prior to a request, you can use this method
   * directly to provide accurate credential data stored in the object.
   *
   * @note If you configure the SDK with static or environment credentials,
   *   the credential data should already be present in {credentials} attribute.
   *   This method is primarily necessary to load credentials from asynchronous
   *   sources, or sources that can refresh credentials periodically.
   * @example Getting your access key
   *   AWS.config.getCredentials(function(err) {
   *     if (err) console.log(err.stack); // credentials not loaded
   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
   *   })
   * @callback callback function(err)
   *   Called when the {credentials} have been properly set on the configuration
   *   object.
   *
   *   @param err [Error] if this is set, credentials were not successfully
   *     loaded and this error provides information why.
   * @see credentials
   * @see Credentials
   */
  getCredentials: function getCredentials(callback) {
    var self = this;

    function finish(err) {
      callback(err, err ? null : self.credentials);
    }

    function credError(msg, err) {
      return new AWS.util.error(err || new Error(), {
        code: 'CredentialsError',
        message: msg,
        name: 'CredentialsError'
      });
    }

    function getAsyncCredentials() {
      self.credentials.get(function(err) {
        if (err) {
          var msg = 'Could not load credentials from ' +
            self.credentials.constructor.name;
          err = credError(msg, err);
        }
        finish(err);
      });
    }

    function getStaticCredentials() {
      var err = null;
      if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
        err = credError('Missing credentials');
      }
      finish(err);
    }

    if (self.credentials) {
      if (typeof self.credentials.get === 'function') {
        getAsyncCredentials();
      } else { // static credentials
        getStaticCredentials();
      }
    } else if (self.credentialProvider) {
      self.credentialProvider.resolve(function(err, creds) {
        if (err) {
          err = credError('Could not load credentials from any providers', err);
        }
        self.credentials = creds;
        finish(err);
      });
    } else {
      finish(credError('No credentials to load'));
    }
  },

  /**
   * @!group Loading and Setting Configuration Options
   */

  /**
   * @overload update(options, allowUnknownKeys = false)
   *   Updates the current configuration object with new options.
   *
   *   @example Update maxRetries property of a configuration object
   *     config.update({maxRetries: 10});
   *   @param [Object] options a map of option keys and values.
   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
   *     the configuration object. Defaults to `false`.
   *   @see constructor
   */
  update: function update(options, allowUnknownKeys) {
    allowUnknownKeys = allowUnknownKeys || false;
    options = this.extractCredentials(options);
    AWS.util.each.call(this, options, function (key, value) {
      if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) ||
          AWS.Service.hasService(key)) {
        this.set(key, value);
      }
    });
  },

  /**
   * Loads configuration data from a JSON file into this config object.
   * @note Loading configuration will reset all existing configuration
   *   on the object.
   * @!macro nobrowser
   * @param path [String] the path relative to your process's current
   *    working directory to load configuration from.
   * @return [AWS.Config] the same configuration object
   */
  loadFromPath: function loadFromPath(path) {
    this.clear();

    var options = JSON.parse(AWS.util.readFileSync(path));
    var fileSystemCreds = new AWS.FileSystemCredentials(path);
    var chain = new AWS.CredentialProviderChain();
    chain.providers.unshift(fileSystemCreds);
    chain.resolve(function (err, creds) {
      if (err) throw err;
      else options.credentials = creds;
    });

    this.constructor(options);

    return this;
  },

  /**
   * Clears configuration data on this object
   *
   * @api private
   */
  clear: function clear() {
    /*jshint forin:false */
    AWS.util.each.call(this, this.keys, function (key) {
      delete this[key];
    });

    // reset credential provider
    this.set('credentials', undefined);
    this.set('credentialProvider', undefined);
  },

  /**
   * Sets a property on the configuration object, allowing for a
   * default value
   * @api private
   */
  set: function set(property, value, defaultValue) {
    if (value === undefined) {
      if (defaultValue === undefined) {
        defaultValue = this.keys[property];
      }
      if (typeof defaultValue === 'function') {
        this[property] = defaultValue.call(this);
      } else {
        this[property] = defaultValue;
      }
    } else if (property === 'httpOptions' && this[property]) {
      // deep merge httpOptions
      this[property] = AWS.util.merge(this[property], value);
    } else {
      this[property] = value;
    }
  },

  /**
   * All of the keys with their default values.
   *
   * @constant
   * @api private
   */
  keys: {
    credentials: null,
    credentialProvider: null,
    region: null,
    logger: null,
    apiVersions: {},
    apiVersion: null,
    endpoint: undefined,
    httpOptions: {
      timeout: 120000
    },
    maxRetries: undefined,
    maxRedirects: 10,
    paramValidation: true,
    sslEnabled: true,
    s3ForcePathStyle: false,
    s3BucketEndpoint: false,
    s3DisableBodySigning: true,
    computeChecksums: true,
    convertResponseTypes: true,
    correctClockSkew: false,
    customUserAgent: null,
    dynamoDbCrc32: true,
    systemClockOffset: 0,
    signatureVersion: null,
    signatureCache: true,
    retryDelayOptions: {},
    useAccelerateEndpoint: false
  },

  /**
   * Extracts accessKeyId, secretAccessKey and sessionToken
   * from a configuration hash.
   *
   * @api private
   */
  extractCredentials: function extractCredentials(options) {
    if (options.accessKeyId && options.secretAccessKey) {
      options = AWS.util.copy(options);
      options.credentials = new AWS.Credentials(options);
    }
    return options;
  },

  /**
   * Sets the promise dependency the SDK will use wherever Promises are returned.
   * Passing `null` will force the SDK to use native Promises if they are available.
   * If native Promises are not available, passing `null` will have no effect.
   * @param [Constructor] dep A reference to a Promise constructor
   */
  setPromisesDependency: function setPromisesDependency(dep) {
    PromisesDependency = dep;
    // if null was passed in, we should try to use native promises
    if (dep === null && typeof Promise === 'function') {
      PromisesDependency = Promise;
    }
    var constructors = [AWS.Request, AWS.Credentials, AWS.CredentialProviderChain];
    if (AWS.S3 && AWS.S3.ManagedUpload) constructors.push(AWS.S3.ManagedUpload);
    AWS.util.addPromises(constructors, PromisesDependency);
  },

  /**
   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
   */
  getPromisesDependency: function getPromisesDependency() {
    return PromisesDependency;
  }
});

/**
 * @return [AWS.Config] The global configuration object singleton instance
 * @readonly
 * @see AWS.Config
 */
AWS.config = new AWS.Config();


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var SequentialExecutor = __webpack_require__(808);
/**
 * The namespace used to register global event listeners for request building
 * and sending.
 */
AWS.EventListeners = {
  /**
   * @!attribute VALIDATE_CREDENTIALS
   *   A request listener that validates whether the request is being
   *   sent with credentials.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating credentials
   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_REGION
   *   A request listener that validates whether the region is set
   *   for a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating region configuration
   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_PARAMETERS
   *   A request listener that validates input parameters in a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating parameters
   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
   *     request.removeListener('validate', listener);
   *   @example Disable parameter validation globally
   *     AWS.EventListeners.Core.removeListener('validate',
   *       AWS.EventListeners.Core.VALIDATE_REGION);
   *   @readonly
   *   @return [Function]
   * @!attribute SEND
   *   A request listener that initiates the HTTP connection for a
   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
   *   @example Replacing the HTTP handler
   *     var listener = AWS.EventListeners.Core.SEND;
   *     request.removeListener('send', listener);
   *     request.on('send', function(response) {
   *       customHandler.send(response);
   *     });
   *   @return [Function]
   *   @readonly
   * @!attribute HTTP_DATA
   *   A request listener that reads data from the HTTP connection in order
   *   to build the response data.
   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
   *   Remove this handler if you are overriding the 'httpData' event and
   *   do not want extra data processing and buffering overhead.
   *   @example Disabling default data processing
   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
   *     request.removeListener('httpData', listener);
   *   @return [Function]
   *   @readonly
   */
  Core: {} /* doc hack */
};

/**
 * @api private
 */
function getOperationAuthtype(req) {
  if (!req.service.api.operations) {
    return '';
  }
  var operation = req.service.api.operations[req.operation];
  return operation ? operation.authtype : '';
}

AWS.EventListeners = {
  Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
    addAsync('VALIDATE_CREDENTIALS', 'validate',
        function VALIDATE_CREDENTIALS(req, done) {
      if (!req.service.api.signatureVersion) return done(); // none
      req.service.config.getCredentials(function(err) {
        if (err) {
          req.response.error = AWS.util.error(err,
            {code: 'CredentialsError', message: 'Missing credentials in config'});
        }
        done();
      });
    });

    add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
      if (!req.service.config.region && !req.service.isGlobalEndpoint) {
        req.response.error = AWS.util.error(new Error(),
          {code: 'ConfigError', message: 'Missing region in config'});
      }
    });

    add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
      if (!req.service.api.operations) {
        return;
      }
      var operation = req.service.api.operations[req.operation];
      if (!operation) {
        return;
      }
      var idempotentMembers = operation.idempotentMembers;
      if (!idempotentMembers.length) {
        return;
      }
      // creates a copy of params so user's param object isn't mutated
      var params = AWS.util.copy(req.params);
      for (var i = 0, iLen = idempotentMembers.length; i < iLen; i++) {
        if (!params[idempotentMembers[i]]) {
          // add the member
          params[idempotentMembers[i]] = AWS.util.uuid.v4();
        }
      }
      req.params = params;
    });

    add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
      if (!req.service.api.operations) {
        return;
      }
      var rules = req.service.api.operations[req.operation].input;
      var validation = req.service.config.paramValidation;
      new AWS.ParamValidator(validation).validate(rules, req.params);
    });

    addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
      req.haltHandlersOnError();
      if (!req.service.api.operations) {
        return;
      }
      var operation = req.service.api.operations[req.operation];
      var authtype = operation ? operation.authtype : '';
      if (!req.service.api.signatureVersion && !authtype) return done(); // none
      if (req.service.getSignerClass(req) === AWS.Signers.V4) {
        var body = req.httpRequest.body || '';
        if (authtype.indexOf('unsigned-body') >= 0) {
          req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
          return done();
        }
        AWS.util.computeSha256(body, function(err, sha) {
          if (err) {
            done(err);
          }
          else {
            req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
            done();
          }
        });
      } else {
        done();
      }
    });

    add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
      var authtype = getOperationAuthtype(req);
      if (req.httpRequest.headers['Content-Length'] === undefined
          && authtype.indexOf('unsigned-body') === -1) {
        var length = AWS.util.string.byteLength(req.httpRequest.body);
        req.httpRequest.headers['Content-Length'] = length;
      }
    });

    add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
      req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
    });

    add('RESTART', 'restart', function RESTART() {
      var err = this.response.error;
      if (!err || !err.retryable) return;

      this.httpRequest = new AWS.HttpRequest(
        this.service.endpoint,
        this.service.region
      );

      if (this.response.retryCount < this.service.config.maxRetries) {
        this.response.retryCount++;
      } else {
        this.response.error = null;
      }
    });

    addAsync('SIGN', 'sign', function SIGN(req, done) {
      var service = req.service;
      var operations = req.service.api.operations || {};
      var operation = operations[req.operation];
      var authtype = operation ? operation.authtype : '';
      if (!service.api.signatureVersion && !authtype) return done(); // none

      service.config.getCredentials(function (err, credentials) {
        if (err) {
          req.response.error = err;
          return done();
        }

        try {
          var date = AWS.util.date.getDate();
          var SignerClass = service.getSignerClass(req);
          var signer = new SignerClass(req.httpRequest,
            service.api.signingName || service.api.endpointPrefix,
            {
              signatureCache: service.config.signatureCache,
              operation: operation
            });
          signer.setServiceClientId(service._clientId);

          // clear old authorization headers
          delete req.httpRequest.headers['Authorization'];
          delete req.httpRequest.headers['Date'];
          delete req.httpRequest.headers['X-Amz-Date'];

          // add new authorization
          signer.addAuthorization(credentials, date);
          req.signedAt = date;
        } catch (e) {
          req.response.error = e;
        }
        done();
      });
    });

    add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
      if (this.service.successfulResponse(resp, this)) {
        resp.data = {};
        resp.error = null;
      } else {
        resp.data = null;
        resp.error = AWS.util.error(new Error(),
          {code: 'UnknownError', message: 'An unknown error occurred.'});
      }
    });

    addAsync('SEND', 'send', function SEND(resp, done) {
      resp.httpResponse._abortCallback = done;
      resp.error = null;
      resp.data = null;

      function callback(httpResp) {
        resp.httpResponse.stream = httpResp;
        var stream = resp.request.httpRequest.stream;

        httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
          resp.request.emit(
            'httpHeaders',
            [statusCode, headers, resp, statusMessage]
          );

          if (!resp.httpResponse.streaming) {
            if (AWS.HttpClient.streamsApiVersion === 2) { // streams2 API check
              httpResp.on('readable', function onReadable() {
                var data = httpResp.read();
                if (data !== null) {
                  resp.request.emit('httpData', [data, resp]);
                }
              });
            } else { // legacy streams API
              httpResp.on('data', function onData(data) {
                resp.request.emit('httpData', [data, resp]);
              });
            }
          }
        });

        httpResp.on('end', function onEnd() {
          if (!stream || !stream.didCallback) {
            resp.request.emit('httpDone');
            done();
          }
        });
      }

      function progress(httpResp) {
        httpResp.on('sendProgress', function onSendProgress(value) {
          resp.request.emit('httpUploadProgress', [value, resp]);
        });

        httpResp.on('receiveProgress', function onReceiveProgress(value) {
          resp.request.emit('httpDownloadProgress', [value, resp]);
        });
      }

      function error(err) {
        if (err.code !== 'RequestAbortedError') {
          var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
          err = AWS.util.error(err, {
            code: errCode,
            region: resp.request.httpRequest.region,
            hostname: resp.request.httpRequest.endpoint.hostname,
            retryable: true
          });
        }
        resp.error = err;
        resp.request.emit('httpError', [resp.error, resp], function() {
          done();
        });
      }

      function executeSend() {
        var http = AWS.HttpClient.getInstance();
        var httpOptions = resp.request.service.config.httpOptions || {};
        try {
          var stream = http.handleRequest(resp.request.httpRequest, httpOptions,
                                          callback, error);
          progress(stream);
        } catch (err) {
          error(err);
        }
      }

      var timeDiff = (AWS.util.date.getDate() - this.signedAt) / 1000;
      if (timeDiff >= 60 * 10) { // if we signed 10min ago, re-sign
        this.emit('sign', [this], function(err) {
          if (err) done(err);
          else executeSend();
        });
      } else {
        executeSend();
      }
    });

    add('HTTP_HEADERS', 'httpHeaders',
        function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
      resp.httpResponse.statusCode = statusCode;
      resp.httpResponse.statusMessage = statusMessage;
      resp.httpResponse.headers = headers;
      resp.httpResponse.body = new AWS.util.Buffer('');
      resp.httpResponse.buffers = [];
      resp.httpResponse.numBytes = 0;
      var dateHeader = headers.date || headers.Date;
      if (dateHeader) {
        var serverTime = Date.parse(dateHeader);
        if (resp.request.service.config.correctClockSkew
            && AWS.util.isClockSkewed(serverTime)) {
          AWS.util.applyClockOffset(serverTime);
        }
      }
    });

    add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
      if (chunk) {
        if (AWS.util.isNode()) {
          resp.httpResponse.numBytes += chunk.length;

          var total = resp.httpResponse.headers['content-length'];
          var progress = { loaded: resp.httpResponse.numBytes, total: total };
          resp.request.emit('httpDownloadProgress', [progress, resp]);
        }

        resp.httpResponse.buffers.push(new AWS.util.Buffer(chunk));
      }
    });

    add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
      // convert buffers array into single buffer
      if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
        resp.httpResponse.body = body;
      }
      delete resp.httpResponse.numBytes;
      delete resp.httpResponse.buffers;
    });

    add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
      if (resp.httpResponse.statusCode) {
        resp.error.statusCode = resp.httpResponse.statusCode;
        if (resp.error.retryable === undefined) {
          resp.error.retryable = this.service.retryableError(resp.error, this);
        }
      }
    });

    add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
      if (!resp.error) return;
      switch (resp.error.code) {
        case 'RequestExpired': // EC2 only
        case 'ExpiredTokenException':
        case 'ExpiredToken':
          resp.error.retryable = true;
          resp.request.service.config.credentials.expired = true;
      }
    });

    add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
      var err = resp.error;
      if (!err) return;
      if (typeof err.code === 'string' && typeof err.message === 'string') {
        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
          resp.error.retryable = true;
        }
      }
    });

    add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
      if (!resp.error) return;
      if (this.service.clockSkewError(resp.error)
          && this.service.config.correctClockSkew
          && AWS.config.isClockSkewed) {
        resp.error.retryable = true;
      }
    });

    add('REDIRECT', 'retry', function REDIRECT(resp) {
      if (resp.error && resp.error.statusCode >= 300 &&
          resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
        this.httpRequest.endpoint =
          new AWS.Endpoint(resp.httpResponse.headers['location']);
        this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
        resp.error.redirect = true;
        resp.error.retryable = true;
      }
    });

    add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
      if (resp.error) {
        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
          resp.error.retryDelay = 0;
        } else if (resp.retryCount < resp.maxRetries) {
          resp.error.retryDelay = this.service.retryDelays(resp.retryCount) || 0;
        }
      }
    });

    addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
      var delay, willRetry = false;

      if (resp.error) {
        delay = resp.error.retryDelay || 0;
        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
          resp.retryCount++;
          willRetry = true;
        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
          resp.redirectCount++;
          willRetry = true;
        }
      }

      if (willRetry) {
        resp.error = null;
        setTimeout(done, delay);
      } else {
        done();
      }
    });
  }),

  CorePost: new SequentialExecutor().addNamedListeners(function(add) {
    add('EXTRACT_REQUEST_ID', 'extractData', AWS.util.extractRequestId);
    add('EXTRACT_REQUEST_ID', 'extractError', AWS.util.extractRequestId);

    add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
      if (err.code === 'NetworkingError' && err.errno === 'ENOTFOUND') {
        var message = 'Inaccessible host: `' + err.hostname +
          '\'. This service may not be available in the `' + err.region +
          '\' region.';
        this.response.error = AWS.util.error(new Error(message), {
          code: 'UnknownEndpoint',
          region: err.region,
          hostname: err.hostname,
          retryable: true,
          originalError: err
        });
      }
    });
  }),

  Logger: new SequentialExecutor().addNamedListeners(function(add) {
    add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
      var req = resp.request;
      var logger = req.service.config.logger;
      if (!logger) return;

      function buildMessage() {
        var time = AWS.util.date.getDate().getTime();
        var delta = (time - req.startTime.getTime()) / 1000;
        var ansi = logger.isTTY ? true : false;
        var status = resp.httpResponse.statusCode;
        var params = __webpack_require__(454).inspect(req.params, true, null);

        var message = '';
        if (ansi) message += '\x1B[33m';
        message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
        message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
        if (ansi) message += '\x1B[0;1m';
        message += ' ' + AWS.util.string.lowerFirst(req.operation);
        message += '(' + params + ')';
        if (ansi) message += '\x1B[0m';
        return message;
      }

      var line = buildMessage();
      if (typeof logger.log === 'function') {
        logger.log(line);
      } else if (typeof logger.write === 'function') {
        logger.write(line + '\n');
      }
    });
  }),

  Json: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(440);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  Rest: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(321);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  RestJson: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(777);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  RestXml: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(778);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  }),

  Query: new SequentialExecutor().addNamedListeners(function(add) {
    var svc = __webpack_require__(775);
    add('BUILD', 'build', svc.buildRequest);
    add('EXTRACT_DATA', 'extractData', svc.extractData);
    add('EXTRACT_ERROR', 'extractError', svc.extractError);
  })
};


/***/ }),
/* 1465 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(7);
var AcceptorStateMachine = __webpack_require__(1468);
var inherit = AWS.util.inherit;
var domain = AWS.util.domain;
var jmespath = __webpack_require__(455);

/**
 * @api private
 */
var hardErrorStates = {success: 1, error: 1, complete: 1};

function isTerminalState(machine) {
  return Object.prototype.hasOwnProperty.call(hardErrorStates, machine._asm.currentState);
}

var fsm = new AcceptorStateMachine();
fsm.setupStates = function() {
  var transition = function(_, done) {
    var self = this;
    self._haltHandlersOnError = false;

    self.emit(self._asm.currentState, function(err) {
      if (err) {
        if (isTerminalState(self)) {
          if (domain && self.domain instanceof domain.Domain) {
            err.domainEmitter = self;
            err.domain = self.domain;
            err.domainThrown = false;
            self.domain.emit('error', err);
          } else {
            throw err;
          }
        } else {
          self.response.error = err;
          done(err);
        }
      } else {
        done(self.response.error);
      }
    });

  };

  this.addState('validate', 'build', 'error', transition);
  this.addState('build', 'afterBuild', 'restart', transition);
  this.addState('afterBuild', 'sign', 'restart', transition);
  this.addState('sign', 'send', 'retry', transition);
  this.addState('retry', 'afterRetry', 'afterRetry', transition);
  this.addState('afterRetry', 'sign', 'error', transition);
  this.addState('send', 'validateResponse', 'retry', transition);
  this.addState('validateResponse', 'extractData', 'extractError', transition);
  this.addState('extractError', 'extractData', 'retry', transition);
  this.addState('extractData', 'success', 'retry', transition);
  this.addState('restart', 'build', 'error', transition);
  this.addState('success', 'complete', 'complete', transition);
  this.addState('error', 'complete', 'complete', transition);
  this.addState('complete', null, null, transition);
};
fsm.setupStates();

/**
 * ## Asynchronous Requests
 *
 * All requests made through the SDK are asynchronous and use a
 * callback interface. Each service method that kicks off a request
 * returns an `AWS.Request` object that you can use to register
 * callbacks.
 *
 * For example, the following service method returns the request
 * object as "request", which can be used to register callbacks:
 *
 * ```javascript
 * // request is an AWS.Request object
 * var request = ec2.describeInstances();
 *
 * // register callbacks on request to retrieve response data
 * request.on('success', function(response) {
 *   console.log(response.data);
 * });
 * ```
 *
 * When a request is ready to be sent, the {send} method should
 * be called:
 *
 * ```javascript
 * request.send();
 * ```
 *
 * Since registered callbacks may or may not be idempotent, requests should only
 * be sent once. To perform the same operation multiple times, you will need to
 * create multiple request objects, each with its own registered callbacks.
 *
 * ## Removing Default Listeners for Events
 *
 * Request objects are built with default listeners for the various events,
 * depending on the service type. In some cases, you may want to remove
 * some built-in listeners to customize behaviour. Doing this requires
 * access to the built-in listener functions, which are exposed through
 * the {AWS.EventListeners.Core} namespace. For instance, you may
 * want to customize the HTTP handler used when sending a request. In this
 * case, you can remove the built-in listener associated with the 'send'
 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
 *
 * ## Multiple Callbacks and Chaining
 *
 * You can register multiple callbacks on any request object. The
 * callbacks can be registered for different events, or all for the
 * same event. In addition, you can chain callback registration, for
 * example:
 *
 * ```javascript
 * request.
 *   on('success', function(response) {
 *     console.log("Success!");
 *   }).
 *   on('error', function(response) {
 *     console.log("Error!");
 *   }).
 *   on('complete', function(response) {
 *     console.log("Always!");
 *   }).
 *   send();
 * ```
 *
 * The above example will print either "Success! Always!", or "Error! Always!",
 * depending on whether the request succeeded or not.
 *
 * @!attribute httpRequest
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpRequest] the raw HTTP request object
 *     containing request headers and body information
 *     sent by the service.
 *
 * @!attribute startTime
 *   @readonly
 *   @!group Operation Properties
 *   @return [Date] the time that the request started
 *
 * @!group Request Building Events
 *
 * @!event validate(request)
 *   Triggered when a request is being validated. Listeners
 *   should throw an error if the request should not be sent.
 *   @param request [Request] the request object being sent
 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
 *   @see AWS.EventListeners.Core.VALIDATE_REGION
 *   @example Ensuring that a certain parameter is set before sending a request
 *     var req = s3.putObject(params);
 *     req.on('validate', function() {
 *       if (!req.params.Body.match(/^Hello\s/)) {
 *         throw new Error('Body must start with "Hello "');
 *       }
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event build(request)
 *   Triggered when the request payload is being built. Listeners
 *   should fill the necessary information to send the request
 *   over HTTP.
 *   @param (see AWS.Request~validate)
 *   @example Add a custom HTTP header to a request
 *     var req = s3.putObject(params);
 *     req.on('build', function() {
 *       req.httpRequest.headers['Custom-Header'] = 'value';
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event sign(request)
 *   Triggered when the request is being signed. Listeners should
 *   add the correct authentication headers and/or adjust the body,
 *   depending on the authentication mechanism being used.
 *   @param (see AWS.Request~validate)
 *
 * @!group Request Sending Events
 *
 * @!event send(response)
 *   Triggered when the request is ready to be sent. Listeners
 *   should call the underlying transport layer to initiate
 *   the sending of the request.
 *   @param response [Response] the response object
 *   @context [Request] the request object that was sent
 *   @see AWS.EventListeners.Core.SEND
 *
 * @!event retry(response)
 *   Triggered when a request failed and might need to be retried or redirected.
 *   If the response is retryable, the listener should set the
 *   `response.error.retryable` property to `true`, and optionally set
 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
 *   In the case of a redirect, `response.error.redirect` should be set to
 *   `true` with `retryDelay` set to an optional delay on the next request.
 *
 *   If a listener decides that a request should not be retried,
 *   it should set both `retryable` and `redirect` to false.
 *
 *   Note that a retryable error will be retried at most
 *   {AWS.Config.maxRetries} times (based on the service object's config).
 *   Similarly, a request that is redirected will only redirect at most
 *   {AWS.Config.maxRedirects} times.
 *
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @example Adding a custom retry for a 404 response
 *     request.on('retry', function(response) {
 *       // this resource is not yet available, wait 10 seconds to get it again
 *       if (response.httpResponse.statusCode === 404 && response.error) {
 *         response.error.retryable = true;   // retry this error
 *         response.error.retryDelay = 10000; // wait 10 seconds
 *       }
 *     });
 *
 * @!group Data Parsing Events
 *
 * @!event extractError(response)
 *   Triggered on all non-2xx requests so that listeners can extract
 *   error details from the response body. Listeners to this event
 *   should set the `response.error` property.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event extractData(response)
 *   Triggered in successful requests to allow listeners to
 *   de-serialize the response body into `response.data`.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group Completion Events
 *
 * @!event success(response)
 *   Triggered when the request completed successfully.
 *   `response.data` will contain the response data and
 *   `response.error` will be null.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event error(error, response)
 *   Triggered when an error occurs at any point during the
 *   request. `response.error` will contain details about the error
 *   that occurred. `response.data` will be null.
 *   @param error [Error] the error object containing details about
 *     the error that occurred.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event complete(response)
 *   Triggered whenever a request cycle completes. `response.error`
 *   should be checked, since the request may have failed.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group HTTP Events
 *
 * @!event httpHeaders(statusCode, headers, response, statusMessage)
 *   Triggered when headers are sent by the remote server
 *   @param statusCode [Integer] the HTTP response code
 *   @param headers [map<String,String>] the response headers
 *   @param (see AWS.Request~send)
 *   @param statusMessage [String] A status message corresponding to the HTTP
 *                                 response code
 *   @context (see AWS.Request~send)
 *
 * @!event httpData(chunk, response)
 *   Triggered when data is sent by the remote server
 *   @param chunk [Buffer] the buffer data containing the next data chunk
 *     from the server
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @see AWS.EventListeners.Core.HTTP_DATA
 *
 * @!event httpUploadProgress(progress, response)
 *   Triggered when the HTTP request has uploaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpDownloadProgress(progress, response)
 *   Triggered when the HTTP request has downloaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpError(error, response)
 *   Triggered when the HTTP request failed
 *   @param error [Error] the error object that was thrown
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event httpDone(response)
 *   Triggered when the server is finished sending data
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @see AWS.Response
 */
AWS.Request = inherit({

  /**
   * Creates a request for an operation on a given service with
   * a set of input parameters.
   *
   * @param service [AWS.Service] the service to perform the operation on
   * @param operation [String] the operation to perform on the service
   * @param params [Object] parameters to send to the operation.
   *   See the operation's documentation for the format of the
   *   parameters.
   */
  constructor: function Request(service, operation, params) {
    var endpoint = service.endpoint;
    var region = service.config.region;
    var customUserAgent = service.config.customUserAgent;

    // global endpoints sign as us-east-1
    if (service.isGlobalEndpoint) region = 'us-east-1';

    this.domain = domain && domain.active;
    this.service = service;
    this.operation = operation;
    this.params = params || {};
    this.httpRequest = new AWS.HttpRequest(endpoint, region);
    this.httpRequest.appendToUserAgent(customUserAgent);
    this.startTime = AWS.util.date.getDate();

    this.response = new AWS.Response(this);
    this._asm = new AcceptorStateMachine(fsm.states, 'validate');
    this._haltHandlersOnError = false;

    AWS.SequentialExecutor.call(this);
    this.emit = this.emitEvent;
  },

  /**
   * @!group Sending a Request
   */

  /**
   * @overload send(callback = null)
   *   Sends the request object.
   *
   *   @callback callback function(err, data)
   *     If a callback is supplied, it is called when a response is returned
   *     from the service.
   *     @context [AWS.Request] the request object being sent.
   *     @param err [Error] the error object returned from the request.
   *       Set to `null` if the request is successful.
   *     @param data [Object] the de-serialized data returned from
   *       the request. Set to `null` if a request error occurs.
   *   @example Sending a request with a callback
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.send(function(err, data) { console.log(err, data); });
   *   @example Sending a request with no callback (using event handlers)
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.on('complete', function(response) { ... }); // register a callback
   *     request.send();
   */
  send: function send(callback) {
    if (callback) {
      // append to user agent
      this.httpRequest.appendToUserAgent('callback');
      this.on('complete', function (resp) {
        callback.call(resp, resp.error, resp.data);
      });
    }
    this.runTo();

    return this.response;
  },

  /**
   * @!method  promise()
   *   Sends the request and returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [Object] the de-serialized data returned from the request.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param error [Error] the error object returned from the request.
   *   @return [Promise] A promise that represents the state of the request.
   *   @example Sending a request using promises.
   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     var result = request.promise();
   *     result.then(function(data) { ... }, function(error) { ... });
   */

  /**
   * @api private
   */
  build: function build(callback) {
    return this.runTo('send', callback);
  },

  /**
   * @api private
   */
  runTo: function runTo(state, done) {
    this._asm.runTo(state, done, this);
    return this;
  },

  /**
   * Aborts a request, emitting the error and complete events.
   *
   * @!macro nobrowser
   * @example Aborting a request after sending
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: new Buffer(1024 * 1024 * 5) // 5MB payload
   *   };
   *   var request = s3.putObject(params);
   *   request.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(request.abort.bind(request), 1000);
   *
   *   // prints "Error: RequestAbortedError Request aborted by user"
   * @return [AWS.Request] the same request object, for chaining.
   * @since v1.4.0
   */
  abort: function abort() {
    this.removeAllListeners('validateResponse');
    this.removeAllListeners('extractError');
    this.on('validateResponse', function addAbortedError(resp) {
      resp.error = AWS.util.error(new Error('Request aborted by user'), {
         code: 'RequestAbortedError', retryable: false
      });
    });

    if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) { // abort HTTP stream
      this.httpRequest.stream.abort();
      if (this.httpRequest._abortCallback) {
         this.httpRequest._abortCallback();
      } else {
        this.removeAllListeners('send'); // haven't sent yet, so let's not
      }
    }

    return this;
  },

  /**
   * Iterates over each page of results given a pageable request, calling
   * the provided callback with each page of data. After all pages have been
   * retrieved, the callback is called with `null` data.
   *
   * @note This operation can generate multiple requests to a service.
   * @example Iterating over multiple pages of objects in an S3 bucket
   *   var pages = 1;
   *   s3.listObjects().eachPage(function(err, data) {
   *     if (err) return;
   *     console.log("Page", pages++);
   *     console.log(data);
   *   });
   * @example Iterating over multiple pages with an asynchronous callback
   *   s3.listObjects(params).eachPage(function(err, data, done) {
   *     doSomethingAsyncAndOrExpensive(function() {
   *       // The next page of results isn't fetched until done is called
   *       done();
   *     });
   *   });
   * @callback callback function(err, data, [doneCallback])
   *   Called with each page of resulting data from the request. If the
   *   optional `doneCallback` is provided in the function, it must be called
   *   when the callback is complete.
   *
   *   @param err [Error] an error object, if an error occurred.
   *   @param data [Object] a single page of response data. If there is no
   *     more data, this object will be `null`.
   *   @param doneCallback [Function] an optional done callback. If this
   *     argument is defined in the function declaration, it should be called
   *     when the next page is ready to be retrieved. This is useful for
   *     controlling serial pagination across asynchronous operations.
   *   @return [Boolean] if the callback returns `false`, pagination will
   *     stop.
   *
   * @see AWS.Request.eachItem
   * @see AWS.Response.nextPage
   * @since v1.4.0
   */
  eachPage: function eachPage(callback) {
    // Make all callbacks async-ish
    callback = AWS.util.fn.makeAsync(callback, 3);

    function wrappedCallback(response) {
      callback.call(response, response.error, response.data, function (result) {
        if (result === false) return;

        if (response.hasNextPage()) {
          response.nextPage().on('complete', wrappedCallback).send();
        } else {
          callback.call(response, null, null, AWS.util.fn.noop);
        }
      });
    }

    this.on('complete', wrappedCallback).send();
  },

  /**
   * Enumerates over individual items of a request, paging the responses if
   * necessary.
   *
   * @api experimental
   * @since v1.4.0
   */
  eachItem: function eachItem(callback) {
    var self = this;
    function wrappedCallback(err, data) {
      if (err) return callback(err, null);
      if (data === null) return callback(null, null);

      var config = self.service.paginationConfig(self.operation);
      var resultKey = config.resultKey;
      if (Array.isArray(resultKey)) resultKey = resultKey[0];
      var items = jmespath.search(data, resultKey);
      var continueIteration = true;
      AWS.util.arrayEach(items, function(item) {
        continueIteration = callback(null, item);
        if (continueIteration === false) {
          return AWS.util.abort;
        }
      });
      return continueIteration;
    }

    this.eachPage(wrappedCallback);
  },

  /**
   * @return [Boolean] whether the operation can return multiple pages of
   *   response data.
   * @see AWS.Response.eachPage
   * @since v1.4.0
   */
  isPageable: function isPageable() {
    return this.service.paginationConfig(this.operation) ? true : false;
  },

  /**
   * Sends the request and converts the request object into a readable stream
   * that can be read from or piped into a writable stream.
   *
   * @note The data read from a readable stream contains only
   *   the raw HTTP body contents.
   * @example Manually reading from a stream
   *   request.createReadStream().on('data', function(data) {
   *     console.log("Got data:", data.toString());
   *   });
   * @example Piping a request body into a file
   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
   *   s3.service.getObject(params).createReadStream().pipe(out);
   * @return [Stream] the readable stream object that can be piped
   *   or read from (by registering 'data' event listeners).
   * @!macro nobrowser
   */
  createReadStream: function createReadStream() {
    var streams = AWS.util.stream;
    var req = this;
    var stream = null;

    if (AWS.HttpClient.streamsApiVersion === 2) {
      stream = new streams.PassThrough();
      process.nextTick(function() { req.send(); });
    } else {
      stream = new streams.Stream();
      stream.readable = true;

      stream.sent = false;
      stream.on('newListener', function(event) {
        if (!stream.sent && event === 'data') {
          stream.sent = true;
          process.nextTick(function() { req.send(); });
        }
      });
    }

    this.on('error', function(err) {
      stream.emit('error', err);
    });

    this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
      if (statusCode < 300) {
        req.removeListener('httpData', AWS.EventListeners.Core.HTTP_DATA);
        req.removeListener('httpError', AWS.EventListeners.Core.HTTP_ERROR);
        req.on('httpError', function streamHttpError(error) {
          resp.error = error;
          resp.error.retryable = false;
        });

        var shouldCheckContentLength = false;
        var expectedLen;
        if (req.httpRequest.method !== 'HEAD') {
          expectedLen = parseInt(headers['content-length'], 10);
        }
        if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
          shouldCheckContentLength = true;
          var receivedLen = 0;
        }

        var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
          if (shouldCheckContentLength && receivedLen !== expectedLen) {
            stream.emit('error', AWS.util.error(
              new Error('Stream content length mismatch. Received ' +
                receivedLen + ' of ' + expectedLen + ' bytes.'),
              { code: 'StreamContentLengthMismatch' }
            ));
          } else if (AWS.HttpClient.streamsApiVersion === 2) {
            stream.end();
          } else {
            stream.emit('end');
          }
        };

        var httpStream = resp.httpResponse.createUnbufferedStream();

        if (AWS.HttpClient.streamsApiVersion === 2) {
          if (shouldCheckContentLength) {
            var lengthAccumulator = new streams.PassThrough();
            lengthAccumulator._write = function(chunk) {
              if (chunk && chunk.length) {
                receivedLen += chunk.length;
              }
              return streams.PassThrough.prototype._write.apply(this, arguments);
            };

            lengthAccumulator.on('end', checkContentLengthAndEmit);
            stream.on('error', function(err) {
              shouldCheckContentLength = false;
              httpStream.unpipe(lengthAccumulator);
              lengthAccumulator.emit('end');
              lengthAccumulator.end();
            });
            httpStream.pipe(lengthAccumulator).pipe(stream, { end: false });
          } else {
            httpStream.pipe(stream);
          }
        } else {

          if (shouldCheckContentLength) {
            httpStream.on('data', function(arg) {
              if (arg && arg.length) {
                receivedLen += arg.length;
              }
            });
          }

          httpStream.on('data', function(arg) {
            stream.emit('data', arg);
          });
          httpStream.on('end', checkContentLengthAndEmit);
        }

        httpStream.on('error', function(err) {
          shouldCheckContentLength = false;
          stream.emit('error', err);
        });
      }
    });

    return stream;
  },

  /**
   * @param [Array,Response] args This should be the response object,
   *   or an array of args to send to the event.
   * @api private
   */
  emitEvent: function emit(eventName, args, done) {
    if (typeof args === 'function') { done = args; args = null; }
    if (!done) done = function() { };
    if (!args) args = this.eventParameters(eventName, this.response);

    var origEmit = AWS.SequentialExecutor.prototype.emit;
    origEmit.call(this, eventName, args, function (err) {
      if (err) this.response.error = err;
      done.call(this, err);
    });
  },

  /**
   * @api private
   */
  eventParameters: function eventParameters(eventName) {
    switch (eventName) {
      case 'restart':
      case 'validate':
      case 'sign':
      case 'build':
      case 'afterValidate':
      case 'afterBuild':
        return [this];
      case 'error':
        return [this.response.error, this.response];
      default:
        return [this.response];
    }
  },

  /**
   * @api private
   */
  presign: function presign(expires, callback) {
    if (!callback && typeof expires === 'function') {
      callback = expires;
      expires = null;
    }
    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
  },

  /**
   * @api private
   */
  isPresigned: function isPresigned() {
    return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
  },

  /**
   * @api private
   */
  toUnauthenticated: function toUnauthenticated() {
    this.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
    this.removeListener('sign', AWS.EventListeners.Core.SIGN);
    return this;
  },

  /**
   * @api private
   */
  toGet: function toGet() {
    if (this.service.api.protocol === 'query' ||
        this.service.api.protocol === 'ec2') {
      this.removeListener('build', this.buildAsGet);
      this.addListener('build', this.buildAsGet);
    }
    return this;
  },

  /**
   * @api private
   */
  buildAsGet: function buildAsGet(request) {
    request.httpRequest.method = 'GET';
    request.httpRequest.path = request.service.endpoint.path +
                               '?' + request.httpRequest.body;
    request.httpRequest.body = '';

    // don't need these headers on a GET request
    delete request.httpRequest.headers['Content-Length'];
    delete request.httpRequest.headers['Content-Type'];
  },

  /**
   * @api private
   */
  haltHandlersOnError: function haltHandlersOnError() {
    this._haltHandlersOnError = true;
  }
});

/**
 * @api private
 */
AWS.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.promise = function promise() {
    var self = this;
    // append to user agent
    this.httpRequest.appendToUserAgent('promise');
    return new PromiseDependency(function(resolve, reject) {
      self.on('complete', function(resp) {
        if (resp.error) {
          reject(resp.error);
        } else {
          // define $response property so that it is not enumberable
          // this prevents circular reference errors when stringifying the JSON object
          resolve(Object.defineProperty(
            resp.data || {},
            '$response',
            {value: resp}
          ));
        }
      });
      self.runTo();
    });
  };
};

/**
 * @api private
 */
AWS.Request.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.promise;
};

AWS.util.addPromises(AWS.Request);

AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

function AcceptorStateMachine(states, state) {
  this.currentState = state || null;
  this.states = states || {};
}

AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
  if (typeof finalState === 'function') {
    inputError = bindObject; bindObject = done;
    done = finalState; finalState = null;
  }

  var self = this;
  var state = self.states[self.currentState];
  state.fn.call(bindObject || self, inputError, function(err) {
    if (err) {
      if (state.fail) self.currentState = state.fail;
      else return done ? done.call(bindObject, err) : null;
    } else {
      if (state.accept) self.currentState = state.accept;
      else return done ? done.call(bindObject) : null;
    }
    if (self.currentState === finalState) {
      return done ? done.call(bindObject, err) : null;
    }

    self.runTo(finalState, done, bindObject, err);
  });
};

AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
  if (typeof acceptState === 'function') {
    fn = acceptState; acceptState = null; failState = null;
  } else if (typeof failState === 'function') {
    fn = failState; failState = null;
  }

  if (!this.currentState) this.currentState = name;
  this.states[name] = { accept: acceptState, fail: failState, fn: fn };
  return this;
};

module.exports = AcceptorStateMachine;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var inherit = AWS.util.inherit;
var jmespath = __webpack_require__(455);

/**
 * This class encapsulates the response information
 * from a service request operation sent through {AWS.Request}.
 * The response object has two main properties for getting information
 * back from a request:
 *
 * ## The `data` property
 *
 * The `response.data` property contains the serialized object data
 * retrieved from the service request. For instance, for an
 * Amazon DynamoDB `listTables` method call, the response data might
 * look like:
 *
 * ```
 * > resp.data
 * { TableNames:
 *    [ 'table1', 'table2', ... ] }
 * ```
 *
 * The `data` property can be null if an error occurs (see below).
 *
 * ## The `error` property
 *
 * In the event of a service error (or transfer error), the
 * `response.error` property will be filled with the given
 * error data in the form:
 *
 * ```
 * { code: 'SHORT_UNIQUE_ERROR_CODE',
 *   message: 'Some human readable error message' }
 * ```
 *
 * In the case of an error, the `data` property will be `null`.
 * Note that if you handle events that can be in a failure state,
 * you should always check whether `response.error` is set
 * before attempting to access the `response.data` property.
 *
 * @!attribute data
 *   @readonly
 *   @!group Data Properties
 *   @note Inside of a {AWS.Request~httpData} event, this
 *     property contains a single raw packet instead of the
 *     full de-serialized service response.
 *   @return [Object] the de-serialized response data
 *     from the service.
 *
 * @!attribute error
 *   An structure containing information about a service
 *   or networking error.
 *   @readonly
 *   @!group Data Properties
 *   @note This attribute is only filled if a service or
 *     networking error occurs.
 *   @return [Error]
 *     * code [String] a unique short code representing the
 *       error that was emitted.
 *     * message [String] a longer human readable error message
 *     * retryable [Boolean] whether the error message is
 *       retryable.
 *     * statusCode [Numeric] in the case of a request that reached the service,
 *       this value contains the response status code.
 *     * time [Date] the date time object when the error occurred.
 *     * hostname [String] set when a networking error occurs to easily
 *       identify the endpoint of the request.
 *     * region [String] set when a networking error occurs to easily
 *       identify the region of the request.
 *
 * @!attribute requestId
 *   @readonly
 *   @!group Data Properties
 *   @return [String] the unique request ID associated with the response.
 *     Log this value when debugging requests for AWS support.
 *
 * @!attribute retryCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of retries that were
 *     attempted before the request was completed.
 *
 * @!attribute redirectCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of redirects that were
 *     followed before the request was completed.
 *
 * @!attribute httpResponse
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpResponse] the raw HTTP response object
 *     containing the response headers and body information
 *     from the server.
 *
 * @see AWS.Request
 */
AWS.Response = inherit({

  /**
   * @api private
   */
  constructor: function Response(request) {
    this.request = request;
    this.data = null;
    this.error = null;
    this.retryCount = 0;
    this.redirectCount = 0;
    this.httpResponse = new AWS.HttpResponse();
    if (request) {
      this.maxRetries = request.service.numRetries();
      this.maxRedirects = request.service.config.maxRedirects;
    }
  },

  /**
   * Creates a new request for the next page of response data, calling the
   * callback with the page data if a callback is provided.
   *
   * @callback callback function(err, data)
   *   Called when a page of data is returned from the next request.
   *
   *   @param err [Error] an error object, if an error occurred in the request
   *   @param data [Object] the next page of data, or null, if there are no
   *     more pages left.
   * @return [AWS.Request] the request object for the next page of data
   * @return [null] if no callback is provided and there are no pages left
   *   to retrieve.
   * @since v1.4.0
   */
  nextPage: function nextPage(callback) {
    var config;
    var service = this.request.service;
    var operation = this.request.operation;
    try {
      config = service.paginationConfig(operation, true);
    } catch (e) { this.error = e; }

    if (!this.hasNextPage()) {
      if (callback) callback(this.error, null);
      else if (this.error) throw this.error;
      return null;
    }

    var params = AWS.util.copy(this.request.params);
    if (!this.nextPageTokens) {
      return callback ? callback(null, null) : null;
    } else {
      var inputTokens = config.inputToken;
      if (typeof inputTokens === 'string') inputTokens = [inputTokens];
      for (var i = 0; i < inputTokens.length; i++) {
        params[inputTokens[i]] = this.nextPageTokens[i];
      }
      return service.makeRequest(this.request.operation, params, callback);
    }
  },

  /**
   * @return [Boolean] whether more pages of data can be returned by further
   *   requests
   * @since v1.4.0
   */
  hasNextPage: function hasNextPage() {
    this.cacheNextPageTokens();
    if (this.nextPageTokens) return true;
    if (this.nextPageTokens === undefined) return undefined;
    else return false;
  },

  /**
   * @api private
   */
  cacheNextPageTokens: function cacheNextPageTokens() {
    if (Object.prototype.hasOwnProperty.call(this, 'nextPageTokens')) return this.nextPageTokens;
    this.nextPageTokens = undefined;

    var config = this.request.service.paginationConfig(this.request.operation);
    if (!config) return this.nextPageTokens;

    this.nextPageTokens = null;
    if (config.moreResults) {
      if (!jmespath.search(this.data, config.moreResults)) {
        return this.nextPageTokens;
      }
    }

    var exprs = config.outputToken;
    if (typeof exprs === 'string') exprs = [exprs];
    AWS.util.arrayEach.call(this, exprs, function (expr) {
      var output = jmespath.search(this.data, expr);
      if (output) {
        this.nextPageTokens = this.nextPageTokens || [];
        this.nextPageTokens.push(output);
      }
    });

    return this.nextPageTokens;
  }

});


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You
 * may not use this file except in compliance with the License. A copy of
 * the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 */

var AWS = __webpack_require__(7);
var inherit = AWS.util.inherit;
var jmespath = __webpack_require__(455);

/**
 * @api private
 */
function CHECK_ACCEPTORS(resp) {
  var waiter = resp.request._waiter;
  var acceptors = waiter.config.acceptors;
  var acceptorMatched = false;
  var state = 'retry';

  acceptors.forEach(function(acceptor) {
    if (!acceptorMatched) {
      var matcher = waiter.matchers[acceptor.matcher];
      if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
        acceptorMatched = true;
        state = acceptor.state;
      }
    }
  });

  if (!acceptorMatched && resp.error) state = 'failure';

  if (state === 'success') {
    waiter.setSuccess(resp);
  } else {
    waiter.setError(resp, state === 'retry');
  }
}

/**
 * @api private
 */
AWS.ResourceWaiter = inherit({
  /**
   * Waits for a given state on a service object
   * @param service [Service] the service object to wait on
   * @param state [String] the state (defined in waiter configuration) to wait
   *   for.
   * @example Create a waiter for running EC2 instances
   *   var ec2 = new AWS.EC2;
   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
   */
  constructor: function constructor(service, state) {
    this.service = service;
    this.state = state;
    this.loadWaiterConfig(this.state);
  },

  service: null,

  state: null,

  config: null,

  matchers: {
    path: function(resp, expected, argument) {
      try {
        var result = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      return jmespath.strictDeepEqual(result,expected);
    },

    pathAll: function(resp, expected, argument) {
      try {
        var results = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      if (!Array.isArray(results)) results = [results];
      var numResults = results.length;
      if (!numResults) return false;
      for (var ind = 0 ; ind < numResults; ind++) {
        if (!jmespath.strictDeepEqual(results[ind], expected)) {
          return false;
        }
      }
      return true;
    },

    pathAny: function(resp, expected, argument) {
      try {
        var results = jmespath.search(resp.data, argument);
      } catch (err) {
        return false;
      }

      if (!Array.isArray(results)) results = [results];
      var numResults = results.length;
      for (var ind = 0 ; ind < numResults; ind++) {
        if (jmespath.strictDeepEqual(results[ind], expected)) {
          return true;
        }
      }
      return false;
    },

    status: function(resp, expected) {
      var statusCode = resp.httpResponse.statusCode;
      return (typeof statusCode === 'number') && (statusCode === expected);
    },

    error: function(resp, expected) {
      if (typeof expected === 'string' && resp.error) {
        return expected === resp.error.code;
      }
      // if expected is not string, can be boolean indicating presence of error
      return expected === !!resp.error;
    }
  },

  listeners: new AWS.SequentialExecutor().addNamedListeners(function(add) {
    add('RETRY_CHECK', 'retry', function(resp) {
      var waiter = resp.request._waiter;
      if (resp.error && resp.error.code === 'ResourceNotReady') {
        resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
      }
    });

    add('CHECK_OUTPUT', 'extractData', CHECK_ACCEPTORS);

    add('CHECK_ERROR', 'extractError', CHECK_ACCEPTORS);
  }),

  /**
   * @return [AWS.Request]
   */
  wait: function wait(params, callback) {
    if (typeof params === 'function') {
      callback = params; params = undefined;
    }

    if (params && params.$waiter) {
      params = AWS.util.copy(params);
      if (typeof params.$waiter.delay === 'number') {
        this.config.delay = params.$waiter.delay;
      }
      if (typeof params.$waiter.maxAttempts === 'number') {
        this.config.maxAttempts = params.$waiter.maxAttempts;
      }
      delete params.$waiter;
    }

    var request = this.service.makeRequest(this.config.operation, params);
    request._waiter = this;
    request.response.maxRetries = this.config.maxAttempts;
    request.addListeners(this.listeners);

    if (callback) request.send(callback);
    return request;
  },

  setSuccess: function setSuccess(resp) {
    resp.error = null;
    resp.data = resp.data || {};
    resp.request.removeAllListeners('extractData');
  },

  setError: function setError(resp, retryable) {
    resp.data = null;
    resp.error = AWS.util.error(resp.error || new Error(), {
      code: 'ResourceNotReady',
      message: 'Resource is not in the state ' + this.state,
      retryable: retryable
    });
  },

  /**
   * Loads waiter configuration from API configuration
   *
   * @api private
   */
  loadWaiterConfig: function loadWaiterConfig(state) {
    if (!this.service.api.waiters[state]) {
      throw new AWS.util.error(new Error(), {
        code: 'StateNotFoundError',
        message: 'State ' + state + ' not found.'
      });
    }

    this.config = AWS.util.copy(this.service.api.waiters[state]);
  }
});


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.RequestSigner = inherit({
  constructor: function RequestSigner(request) {
    this.request = request;
  },

  setServiceClientId: function setServiceClientId(id) {
    this.serviceClientId = id;
  },

  getServiceClientId: function getServiceClientId() {
    return this.serviceClientId;
  }
});

AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
  switch (version) {
    case 'v2': return AWS.Signers.V2;
    case 'v3': return AWS.Signers.V3;
    case 'v4': return AWS.Signers.V4;
    case 's3': return AWS.Signers.S3;
    case 'v3https': return AWS.Signers.V3Https;
  }
  throw new Error('Unknown signing version ' + version);
};

__webpack_require__(1472);
__webpack_require__(809);
__webpack_require__(1473);
__webpack_require__(1474);
__webpack_require__(1475);
__webpack_require__(1476);


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
  addAuthorization: function addAuthorization(credentials, date) {

    if (!date) date = AWS.util.date.getDate();

    var r = this.request;

    r.params.Timestamp = AWS.util.date.iso8601(date);
    r.params.SignatureVersion = '2';
    r.params.SignatureMethod = 'HmacSHA256';
    r.params.AWSAccessKeyId = credentials.accessKeyId;

    if (credentials.sessionToken) {
      r.params.SecurityToken = credentials.sessionToken;
    }

    delete r.params.Signature; // delete old Signature for re-signing
    r.params.Signature = this.signature(credentials);

    r.body = AWS.util.queryParamsToString(r.params);
    r.headers['Content-Length'] = r.body.length;
  },

  signature: function signature(credentials) {
    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
  },

  stringToSign: function stringToSign() {
    var parts = [];
    parts.push(this.request.method);
    parts.push(this.request.endpoint.host.toLowerCase());
    parts.push(this.request.pathname());
    parts.push(AWS.util.queryParamsToString(this.request.params));
    return parts.join('\n');
  }

});

module.exports = AWS.Signers.V2;


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var inherit = AWS.util.inherit;

__webpack_require__(809);

/**
 * @api private
 */
AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
  authorization: function authorization(credentials) {
    return 'AWS3-HTTPS ' +
      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
      'Algorithm=HmacSHA256,' +
      'Signature=' + this.signature(credentials);
  },

  stringToSign: function stringToSign() {
    return this.request.headers['X-Amz-Date'];
  }
});

module.exports = AWS.Signers.V3Https;


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var v4Credentials = __webpack_require__(810);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
var expiresHeader = 'presigned-expires';

/**
 * @api private
 */
AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
  constructor: function V4(request, serviceName, options) {
    AWS.Signers.RequestSigner.call(this, request);
    this.serviceName = serviceName;
    options = options || {};
    this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
    this.operation = options.operation;
  },

  algorithm: 'AWS4-HMAC-SHA256',

  addAuthorization: function addAuthorization(credentials, date) {
    var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');

    if (this.isPresigned()) {
      this.updateForPresigned(credentials, datetime);
    } else {
      this.addHeaders(credentials, datetime);
    }

    this.request.headers['Authorization'] =
      this.authorization(credentials, datetime);
  },

  addHeaders: function addHeaders(credentials, datetime) {
    this.request.headers['X-Amz-Date'] = datetime;
    if (credentials.sessionToken) {
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }
  },

  updateForPresigned: function updateForPresigned(credentials, datetime) {
    var credString = this.credentialString(datetime);
    var qs = {
      'X-Amz-Date': datetime,
      'X-Amz-Algorithm': this.algorithm,
      'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
      'X-Amz-Expires': this.request.headers[expiresHeader],
      'X-Amz-SignedHeaders': this.signedHeaders()
    };

    if (credentials.sessionToken) {
      qs['X-Amz-Security-Token'] = credentials.sessionToken;
    }

    if (this.request.headers['Content-Type']) {
      qs['Content-Type'] = this.request.headers['Content-Type'];
    }
    if (this.request.headers['Content-MD5']) {
      qs['Content-MD5'] = this.request.headers['Content-MD5'];
    }
    if (this.request.headers['Cache-Control']) {
      qs['Cache-Control'] = this.request.headers['Cache-Control'];
    }

    // need to pull in any other X-Amz-* headers
    AWS.util.each.call(this, this.request.headers, function(key, value) {
      if (key === expiresHeader) return;
      if (this.isSignableHeader(key)) {
        var lowerKey = key.toLowerCase();
        // Metadata should be normalized
        if (lowerKey.indexOf('x-amz-meta-') === 0) {
          qs[lowerKey] = value;
        } else if (lowerKey.indexOf('x-amz-') === 0) {
          qs[key] = value;
        }
      }
    });

    var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
    this.request.path += sep + AWS.util.queryParamsToString(qs);
  },

  authorization: function authorization(credentials, datetime) {
    var parts = [];
    var credString = this.credentialString(datetime);
    parts.push(this.algorithm + ' Credential=' +
      credentials.accessKeyId + '/' + credString);
    parts.push('SignedHeaders=' + this.signedHeaders());
    parts.push('Signature=' + this.signature(credentials, datetime));
    return parts.join(', ');
  },

  signature: function signature(credentials, datetime) {
    var signingKey = v4Credentials.getSigningKey(
      credentials,
      datetime.substr(0, 8),
      this.request.region,
      this.serviceName,
      this.signatureCache
    );
    return AWS.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
  },

  stringToSign: function stringToSign(datetime) {
    var parts = [];
    parts.push('AWS4-HMAC-SHA256');
    parts.push(datetime);
    parts.push(this.credentialString(datetime));
    parts.push(this.hexEncodedHash(this.canonicalString()));
    return parts.join('\n');
  },

  canonicalString: function canonicalString() {
    var parts = [], pathname = this.request.pathname();
    if (this.serviceName !== 's3') pathname = AWS.util.uriEscapePath(pathname);

    parts.push(this.request.method);
    parts.push(pathname);
    parts.push(this.request.search());
    parts.push(this.canonicalHeaders() + '\n');
    parts.push(this.signedHeaders());
    parts.push(this.hexEncodedBodyHash());
    return parts.join('\n');
  },

  canonicalHeaders: function canonicalHeaders() {
    var headers = [];
    AWS.util.each.call(this, this.request.headers, function (key, item) {
      headers.push([key, item]);
    });
    headers.sort(function (a, b) {
      return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
    });
    var parts = [];
    AWS.util.arrayEach.call(this, headers, function (item) {
      var key = item[0].toLowerCase();
      if (this.isSignableHeader(key)) {
        var value = item[1];
        if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') {
          throw AWS.util.error(new Error('Header ' + key + ' contains invalid value'), {
            code: 'InvalidHeader'
          });
        }
        parts.push(key + ':' +
          this.canonicalHeaderValues(value.toString()));
      }
    });
    return parts.join('\n');
  },

  canonicalHeaderValues: function canonicalHeaderValues(values) {
    return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  },

  signedHeaders: function signedHeaders() {
    var keys = [];
    AWS.util.each.call(this, this.request.headers, function (key) {
      key = key.toLowerCase();
      if (this.isSignableHeader(key)) keys.push(key);
    });
    return keys.sort().join(';');
  },

  credentialString: function credentialString(datetime) {
    return v4Credentials.createScope(
      datetime.substr(0, 8),
      this.request.region,
      this.serviceName
    );
  },

  hexEncodedHash: function hash(string) {
    return AWS.util.crypto.sha256(string, 'hex');
  },

  hexEncodedBodyHash: function hexEncodedBodyHash() {
    var request = this.request;
    if (this.isPresigned() && this.serviceName === 's3' && !request.body) {
      return 'UNSIGNED-PAYLOAD';
    } else if (request.headers['X-Amz-Content-Sha256']) {
      return request.headers['X-Amz-Content-Sha256'];
    } else {
      return this.hexEncodedHash(this.request.body || '');
    }
  },

  unsignableHeaders: [
    'authorization',
    'content-type',
    'content-length',
    'user-agent',
    expiresHeader,
    'expect',
    'x-amzn-trace-id'
  ],

  isSignableHeader: function isSignableHeader(key) {
    if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
    return this.unsignableHeaders.indexOf(key) < 0;
  },

  isPresigned: function isPresigned() {
    return this.request.headers[expiresHeader] ? true : false;
  }

});

module.exports = AWS.Signers.V4;


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
  /**
   * When building the stringToSign, these sub resource params should be
   * part of the canonical resource string with their NON-decoded values
   */
  subResources: {
    'acl': 1,
    'accelerate': 1,
    'analytics': 1,
    'cors': 1,
    'lifecycle': 1,
    'delete': 1,
    'inventory': 1,
    'location': 1,
    'logging': 1,
    'metrics': 1,
    'notification': 1,
    'partNumber': 1,
    'policy': 1,
    'requestPayment': 1,
    'replication': 1,
    'restore': 1,
    'tagging': 1,
    'torrent': 1,
    'uploadId': 1,
    'uploads': 1,
    'versionId': 1,
    'versioning': 1,
    'versions': 1,
    'website': 1
  },

  // when building the stringToSign, these querystring params should be
  // part of the canonical resource string with their NON-encoded values
  responseHeaders: {
    'response-content-type': 1,
    'response-content-language': 1,
    'response-expires': 1,
    'response-cache-control': 1,
    'response-content-disposition': 1,
    'response-content-encoding': 1
  },

  addAuthorization: function addAuthorization(credentials, date) {
    if (!this.request.headers['presigned-expires']) {
      this.request.headers['X-Amz-Date'] = AWS.util.date.rfc822(date);
    }

    if (credentials.sessionToken) {
      // presigned URLs require this header to be lowercased
      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
    }

    var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
    var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;

    this.request.headers['Authorization'] = auth;
  },

  stringToSign: function stringToSign() {
    var r = this.request;

    var parts = [];
    parts.push(r.method);
    parts.push(r.headers['Content-MD5'] || '');
    parts.push(r.headers['Content-Type'] || '');

    // This is the "Date" header, but we use X-Amz-Date.
    // The S3 signing mechanism requires us to pass an empty
    // string for this Date header regardless.
    parts.push(r.headers['presigned-expires'] || '');

    var headers = this.canonicalizedAmzHeaders();
    if (headers) parts.push(headers);
    parts.push(this.canonicalizedResource());

    return parts.join('\n');

  },

  canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {

    var amzHeaders = [];

    AWS.util.each(this.request.headers, function (name) {
      if (name.match(/^x-amz-/i))
        amzHeaders.push(name);
    });

    amzHeaders.sort(function (a, b) {
      return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
    });

    var parts = [];
    AWS.util.arrayEach.call(this, amzHeaders, function (name) {
      parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
    });

    return parts.join('\n');

  },

  canonicalizedResource: function canonicalizedResource() {

    var r = this.request;

    var parts = r.path.split('?');
    var path = parts[0];
    var querystring = parts[1];

    var resource = '';

    if (r.virtualHostedBucket)
      resource += '/' + r.virtualHostedBucket;

    resource += path;

    if (querystring) {

      // collect a list of sub resources and query params that need to be signed
      var resources = [];

      AWS.util.arrayEach.call(this, querystring.split('&'), function (param) {
        var name = param.split('=')[0];
        var value = param.split('=')[1];
        if (this.subResources[name] || this.responseHeaders[name]) {
          var subresource = { name: name };
          if (value !== undefined) {
            if (this.subResources[name]) {
              subresource.value = value;
            } else {
              subresource.value = decodeURIComponent(value);
            }
          }
          resources.push(subresource);
        }
      });

      resources.sort(function (a, b) { return a.name < b.name ? -1 : 1; });

      if (resources.length) {

        querystring = [];
        AWS.util.arrayEach(resources, function (res) {
          if (res.value === undefined) {
            querystring.push(res.name);
          } else {
            querystring.push(res.name + '=' + res.value);
          }
        });

        resource += '?' + querystring.join('&');
      }

    }

    return resource;

  },

  sign: function sign(secret, string) {
    return AWS.util.crypto.hmac(secret, string, 'base64', 'sha1');
  }
});

module.exports = AWS.Signers.S3;


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var inherit = AWS.util.inherit;

/**
 * @api private
 */
var expiresHeader = 'presigned-expires';

/**
 * @api private
 */
function signedUrlBuilder(request) {
  var expires = request.httpRequest.headers[expiresHeader];
  var signerClass = request.service.getSignerClass(request);

  delete request.httpRequest.headers['User-Agent'];
  delete request.httpRequest.headers['X-Amz-User-Agent'];

  if (signerClass === AWS.Signers.V4) {
    if (expires > 604800) { // one week expiry is invalid
      var message = 'Presigning does not support expiry time greater ' +
                    'than a week with SigV4 signing.';
      throw AWS.util.error(new Error(), {
        code: 'InvalidExpiryTime', message: message, retryable: false
      });
    }
    request.httpRequest.headers[expiresHeader] = expires;
  } else if (signerClass === AWS.Signers.S3) {
    request.httpRequest.headers[expiresHeader] = parseInt(
      AWS.util.date.unixTimestamp() + expires, 10).toString();
  } else {
    throw AWS.util.error(new Error(), {
      message: 'Presigning only supports S3 or SigV4 signing.',
      code: 'UnsupportedSigner', retryable: false
    });
  }
}

/**
 * @api private
 */
function signedUrlSigner(request) {
  var endpoint = request.httpRequest.endpoint;
  var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
  var queryParams = {};

  if (parsedUrl.search) {
    queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
  }

  AWS.util.each(request.httpRequest.headers, function (key, value) {
    if (key === expiresHeader) key = 'Expires';
    if (key.indexOf('x-amz-meta-') === 0) {
      // Delete existing, potentially not normalized key
      delete queryParams[key];
      key = key.toLowerCase();
    }
    queryParams[key] = value;
  });
  delete request.httpRequest.headers[expiresHeader];

  var auth = queryParams['Authorization'].split(' ');
  if (auth[0] === 'AWS') {
    auth = auth[1].split(':');
    queryParams['AWSAccessKeyId'] = auth[0];
    queryParams['Signature'] = auth[1];
  } else if (auth[0] === 'AWS4-HMAC-SHA256') { // SigV4 signing
    auth.shift();
    var rest = auth.join(' ');
    var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
    queryParams['X-Amz-Signature'] = signature;
    delete queryParams['Expires'];
  }
  delete queryParams['Authorization'];
  delete queryParams['Host'];

  // build URL
  endpoint.pathname = parsedUrl.pathname;
  endpoint.search = AWS.util.queryParamsToString(queryParams);
}

/**
 * @api private
 */
AWS.Signers.Presign = inherit({
  /**
   * @api private
   */
  sign: function sign(request, expireTime, callback) {
    request.httpRequest.headers[expiresHeader] = expireTime || 3600;
    request.on('build', signedUrlBuilder);
    request.on('sign', signedUrlSigner);
    request.removeListener('afterBuild',
      AWS.EventListeners.Core.SET_CONTENT_LENGTH);
    request.removeListener('afterBuild',
      AWS.EventListeners.Core.COMPUTE_SHA256);

    request.emit('beforePresign', [request]);

    if (callback) {
      request.build(function() {
        if (this.response.error) callback(this.response.error);
        else {
          callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
        }
      });
    } else {
      request.build();
      if (request.response.error) throw request.response.error;
      return AWS.util.urlFormat(request.httpRequest.endpoint);
    }
  }
});

module.exports = AWS.Signers.Presign;


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

/**
 * @api private
 */
AWS.ParamValidator = AWS.util.inherit({
  /**
   * Create a new validator object.
   *
   * @param validation [Boolean|map] whether input parameters should be
   *     validated against the operation description before sending the
   *     request. Pass a map to enable any of the following specific
   *     validation features:
   *
   *     * **min** [Boolean] &mdash; Validates that a value meets the min
   *       constraint. This is enabled by default when paramValidation is set
   *       to `true`.
   *     * **max** [Boolean] &mdash; Validates that a value meets the max
   *       constraint.
   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *       regular expression.
   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
   *       of the allowable enum values.
   */
  constructor: function ParamValidator(validation) {
    if (validation === true || validation === undefined) {
      validation = {'min': true};
    }
    this.validation = validation;
  },

  validate: function validate(shape, params, context) {
    this.errors = [];
    this.validateMember(shape, params || {}, context || 'params');

    if (this.errors.length > 1) {
      var msg = this.errors.join('\n* ');
      msg = 'There were ' + this.errors.length +
        ' validation errors:\n* ' + msg;
      throw AWS.util.error(new Error(msg),
        {code: 'MultipleValidationErrors', errors: this.errors});
    } else if (this.errors.length === 1) {
      throw this.errors[0];
    } else {
      return true;
    }
  },

  fail: function fail(code, message) {
    this.errors.push(AWS.util.error(new Error(message), {code: code}));
  },

  validateStructure: function validateStructure(shape, params, context) {
    this.validateType(params, context, ['object'], 'structure');

    var paramName;
    for (var i = 0; shape.required && i < shape.required.length; i++) {
      paramName = shape.required[i];
      var value = params[paramName];
      if (value === undefined || value === null) {
        this.fail('MissingRequiredParameter',
          'Missing required key \'' + paramName + '\' in ' + context);
      }
    }

    // validate hash members
    for (paramName in params) {
      if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;

      var paramValue = params[paramName],
          memberShape = shape.members[paramName];

      if (memberShape !== undefined) {
        var memberContext = [context, paramName].join('.');
        this.validateMember(memberShape, paramValue, memberContext);
      } else {
        this.fail('UnexpectedParameter',
          'Unexpected key \'' + paramName + '\' found in ' + context);
      }
    }

    return true;
  },

  validateMember: function validateMember(shape, param, context) {
    switch (shape.type) {
      case 'structure':
        return this.validateStructure(shape, param, context);
      case 'list':
        return this.validateList(shape, param, context);
      case 'map':
        return this.validateMap(shape, param, context);
      default:
        return this.validateScalar(shape, param, context);
    }
  },

  validateList: function validateList(shape, params, context) {
    if (this.validateType(params, context, [Array])) {
      this.validateRange(shape, params.length, context, 'list member count');
      // validate array members
      for (var i = 0; i < params.length; i++) {
        this.validateMember(shape.member, params[i], context + '[' + i + ']');
      }
    }
  },

  validateMap: function validateMap(shape, params, context) {
    if (this.validateType(params, context, ['object'], 'map')) {
      // Build up a count of map members to validate range traits.
      var mapCount = 0;
      for (var param in params) {
        if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
        // Validate any map key trait constraints
        this.validateMember(shape.key, param,
                            context + '[key=\'' + param + '\']')
        this.validateMember(shape.value, params[param],
                            context + '[\'' + param + '\']');
        mapCount++;
      }
      this.validateRange(shape, mapCount, context, 'map member count');
    }
  },

  validateScalar: function validateScalar(shape, value, context) {
    switch (shape.type) {
      case null:
      case undefined:
      case 'string':
        return this.validateString(shape, value, context);
      case 'base64':
      case 'binary':
        return this.validatePayload(value, context);
      case 'integer':
      case 'float':
        return this.validateNumber(shape, value, context);
      case 'boolean':
        return this.validateType(value, context, ['boolean']);
      case 'timestamp':
        return this.validateType(value, context, [Date,
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, 'number'],
          'Date object, ISO-8601 string, or a UNIX timestamp');
      default:
        return this.fail('UnkownType', 'Unhandled type ' +
                         shape.type + ' for ' + context);
    }
  },

  validateString: function validateString(shape, value, context) {
    var validTypes = ['string'];
    if (shape.isJsonValue) {
      validTypes = validTypes.concat(['number', 'object', 'boolean']);
    }
    if (value !== null && this.validateType(value, context, validTypes)) {
      this.validateEnum(shape, value, context);
      this.validateRange(shape, value.length, context, 'string length');
      this.validatePattern(shape, value, context);
    }
  },

  validatePattern: function validatePattern(shape, value, context) {
    if (this.validation['pattern'] && shape['pattern'] !== undefined) {
      if (!(new RegExp(shape['pattern'])).test(value)) {
        this.fail('PatternMatchError', 'Provided value "' + value + '" '
          + 'does not match regex pattern /' + shape['pattern'] + '/ for '
          + context);
      }
    }
  },

  validateRange: function validateRange(shape, value, context, descriptor) {
    if (this.validation['min']) {
      if (shape['min'] !== undefined && value < shape['min']) {
        this.fail('MinRangeError', 'Expected ' + descriptor + ' >= '
          + shape['min'] + ', but found ' + value + ' for ' + context);
      }
    }
    if (this.validation['max']) {
      if (shape['max'] !== undefined && value > shape['max']) {
        this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= '
          + shape['max'] + ', but found ' + value + ' for ' + context);
      }
    }
  },

  validateEnum: function validateRange(shape, value, context) {
    if (this.validation['enum'] && shape['enum'] !== undefined) {
      // Fail if the string value is not present in the enum list
      if (shape['enum'].indexOf(value) === -1) {
        this.fail('EnumError', 'Found string value of ' + value + ', but '
          + 'expected ' + shape['enum'].join('|') + ' for ' + context);
      }
    }
  },

  validateType: function validateType(value, context, acceptedTypes, type) {
    // We will not log an error for null or undefined, but we will return
    // false so that callers know that the expected type was not strictly met.
    if (value === null || value === undefined) return false;

    var foundInvalidType = false;
    for (var i = 0; i < acceptedTypes.length; i++) {
      if (typeof acceptedTypes[i] === 'string') {
        if (typeof value === acceptedTypes[i]) return true;
      } else if (acceptedTypes[i] instanceof RegExp) {
        if ((value || '').toString().match(acceptedTypes[i])) return true;
      } else {
        if (value instanceof acceptedTypes[i]) return true;
        if (AWS.util.isType(value, acceptedTypes[i])) return true;
        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
      }
      foundInvalidType = true;
    }

    var acceptedType = type;
    if (!acceptedType) {
      acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
    }

    var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' +
              vowel + ' ' + acceptedType);
    return false;
  },

  validateNumber: function validateNumber(shape, value, context) {
    if (value === null || value === undefined) return;
    if (typeof value === 'string') {
      var castedValue = parseFloat(value);
      if (castedValue.toString() === value) value = castedValue;
    }
    if (this.validateType(value, context, ['number'])) {
      this.validateRange(shape, value, context, 'numeric value');
    }
  },

  validatePayload: function validatePayload(value, context) {
    if (value === null || value === undefined) return;
    if (typeof value === 'string') return;
    if (value && typeof value.byteLength === 'number') return; // typed arrays
    if (AWS.util.isNode()) { // special check for buffer/stream in Node.js
      var Stream = AWS.util.stream.Stream;
      if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
    }

    var types = ['Buffer', 'Stream', 'File', 'Blob', 'ArrayBuffer', 'DataView'];
    if (value) {
      for (var i = 0; i < types.length; i++) {
        if (AWS.util.isType(value, types[i])) return;
        if (AWS.util.typeName(value.constructor) === types[i]) return;
      }
    }

    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' +
      'string, Buffer, Stream, Blob, or typed array object');
  }
});


/***/ }),
/* 1478 */
/***/ (function(module, exports) {

module.exports = {
	"acm": {
		"name": "ACM",
		"cors": true
	},
	"apigateway": {
		"name": "APIGateway",
		"cors": true
	},
	"applicationautoscaling": {
		"prefix": "application-autoscaling",
		"name": "ApplicationAutoScaling",
		"cors": true
	},
	"appstream": {
		"name": "AppStream"
	},
	"autoscaling": {
		"name": "AutoScaling",
		"cors": true
	},
	"batch": {
		"name": "Batch"
	},
	"budgets": {
		"name": "Budgets"
	},
	"clouddirectory": {
		"name": "CloudDirectory"
	},
	"cloudformation": {
		"name": "CloudFormation",
		"cors": true
	},
	"cloudfront": {
		"name": "CloudFront",
		"versions": [
			"2013-05-12*",
			"2013-11-11*",
			"2014-05-31*",
			"2014-10-21*",
			"2014-11-06*",
			"2015-04-17*",
			"2015-07-27*",
			"2015-09-17*",
			"2016-01-13*",
			"2016-01-28*",
			"2016-08-01*",
			"2016-08-20*",
			"2016-09-07*",
			"2016-09-29*",
			"2016-11-25*"
		],
		"cors": true
	},
	"cloudhsm": {
		"name": "CloudHSM",
		"cors": true
	},
	"cloudsearch": {
		"name": "CloudSearch"
	},
	"cloudsearchdomain": {
		"name": "CloudSearchDomain"
	},
	"cloudtrail": {
		"name": "CloudTrail",
		"cors": true
	},
	"cloudwatch": {
		"prefix": "monitoring",
		"name": "CloudWatch",
		"cors": true
	},
	"cloudwatchevents": {
		"prefix": "events",
		"name": "CloudWatchEvents",
		"versions": [
			"2014-02-03*"
		],
		"cors": true
	},
	"cloudwatchlogs": {
		"prefix": "logs",
		"name": "CloudWatchLogs",
		"cors": true
	},
	"codebuild": {
		"name": "CodeBuild"
	},
	"codecommit": {
		"name": "CodeCommit",
		"cors": true
	},
	"codedeploy": {
		"name": "CodeDeploy",
		"cors": true
	},
	"codepipeline": {
		"name": "CodePipeline",
		"cors": true
	},
	"cognitoidentity": {
		"prefix": "cognito-identity",
		"name": "CognitoIdentity",
		"cors": true
	},
	"cognitoidentityserviceprovider": {
		"prefix": "cognito-idp",
		"name": "CognitoIdentityServiceProvider",
		"cors": true
	},
	"cognitosync": {
		"prefix": "cognito-sync",
		"name": "CognitoSync",
		"cors": true
	},
	"configservice": {
		"prefix": "config",
		"name": "ConfigService",
		"cors": true
	},
	"cur": {
		"name": "CUR",
		"cors": true
	},
	"datapipeline": {
		"name": "DataPipeline"
	},
	"devicefarm": {
		"name": "DeviceFarm",
		"cors": true
	},
	"directconnect": {
		"name": "DirectConnect",
		"cors": true
	},
	"directoryservice": {
		"prefix": "ds",
		"name": "DirectoryService"
	},
	"discovery": {
		"name": "Discovery"
	},
	"dms": {
		"name": "DMS"
	},
	"dynamodb": {
		"name": "DynamoDB",
		"cors": true
	},
	"dynamodbstreams": {
		"prefix": "streams.dynamodb",
		"name": "DynamoDBStreams",
		"cors": true
	},
	"ec2": {
		"name": "EC2",
		"versions": [
			"2013-06-15*",
			"2013-10-15*",
			"2014-02-01*",
			"2014-05-01*",
			"2014-06-15*",
			"2014-09-01*",
			"2014-10-01*",
			"2015-03-01*",
			"2015-04-15*",
			"2015-10-01*",
			"2016-04-01*",
			"2016-09-15*"
		],
		"cors": true
	},
	"ecr": {
		"name": "ECR",
		"cors": true
	},
	"ecs": {
		"name": "ECS",
		"cors": true
	},
	"efs": {
		"prefix": "elasticfilesystem",
		"name": "EFS",
		"cors": true
	},
	"elasticache": {
		"name": "ElastiCache",
		"versions": [
			"2012-11-15*",
			"2014-03-24*",
			"2014-07-15*",
			"2014-09-30*"
		],
		"cors": true
	},
	"elasticbeanstalk": {
		"name": "ElasticBeanstalk",
		"cors": true
	},
	"elb": {
		"prefix": "elasticloadbalancing",
		"name": "ELB",
		"cors": true
	},
	"elbv2": {
		"prefix": "elasticloadbalancingv2",
		"name": "ELBv2",
		"cors": true
	},
	"emr": {
		"prefix": "elasticmapreduce",
		"name": "EMR",
		"cors": true
	},
	"es": {
		"name": "ES"
	},
	"elastictranscoder": {
		"name": "ElasticTranscoder",
		"cors": true
	},
	"firehose": {
		"name": "Firehose",
		"cors": true
	},
	"gamelift": {
		"name": "GameLift",
		"cors": true
	},
	"glacier": {
		"name": "Glacier"
	},
	"health": {
		"name": "Health"
	},
	"iam": {
		"name": "IAM"
	},
	"importexport": {
		"name": "ImportExport"
	},
	"inspector": {
		"name": "Inspector",
		"versions": [
			"2015-08-18*"
		],
		"cors": true
	},
	"iot": {
		"name": "Iot",
		"cors": true
	},
	"iotdata": {
		"prefix": "iot-data",
		"name": "IotData",
		"cors": true
	},
	"kinesis": {
		"name": "Kinesis",
		"cors": true
	},
	"kinesisanalytics": {
		"name": "KinesisAnalytics"
	},
	"kms": {
		"name": "KMS",
		"cors": true
	},
	"lambda": {
		"name": "Lambda",
		"cors": true
	},
	"lexruntime": {
		"prefix": "runtime.lex",
		"name": "LexRuntime",
		"cors": true
	},
	"lightsail": {
		"name": "Lightsail"
	},
	"machinelearning": {
		"name": "MachineLearning",
		"cors": true
	},
	"marketplacecommerceanalytics": {
		"name": "MarketplaceCommerceAnalytics",
		"cors": true
	},
	"marketplacemetering": {
		"prefix": "meteringmarketplace",
		"name": "MarketplaceMetering"
	},
	"mturk": {
		"prefix": "mturk-requester",
		"name": "MTurk",
		"cors": true
	},
	"mobileanalytics": {
		"name": "MobileAnalytics",
		"cors": true
	},
	"opsworks": {
		"name": "OpsWorks",
		"cors": true
	},
	"opsworkscm": {
		"name": "OpsWorksCM"
	},
	"organizations": {
		"name": "Organizations"
	},
	"pinpoint": {
		"name": "Pinpoint"
	},
	"polly": {
		"name": "Polly",
		"cors": true
	},
	"rds": {
		"name": "RDS",
		"versions": [
			"2014-09-01*"
		],
		"cors": true
	},
	"redshift": {
		"name": "Redshift",
		"cors": true
	},
	"rekognition": {
		"name": "Rekognition",
		"cors": true
	},
	"resourcegroupstaggingapi": {
		"name": "ResourceGroupsTaggingAPI"
	},
	"route53": {
		"name": "Route53",
		"cors": true
	},
	"route53domains": {
		"name": "Route53Domains",
		"cors": true
	},
	"s3": {
		"name": "S3",
		"dualstackAvailable": true,
		"cors": true
	},
	"servicecatalog": {
		"name": "ServiceCatalog",
		"cors": true
	},
	"ses": {
		"prefix": "email",
		"name": "SES",
		"cors": true
	},
	"shield": {
		"name": "Shield"
	},
	"simpledb": {
		"prefix": "sdb",
		"name": "SimpleDB"
	},
	"sms": {
		"name": "SMS"
	},
	"snowball": {
		"name": "Snowball"
	},
	"sns": {
		"name": "SNS",
		"cors": true
	},
	"sqs": {
		"name": "SQS",
		"cors": true
	},
	"ssm": {
		"name": "SSM",
		"cors": true
	},
	"storagegateway": {
		"name": "StorageGateway",
		"cors": true
	},
	"stepfunctions": {
		"prefix": "states",
		"name": "StepFunctions"
	},
	"sts": {
		"name": "STS",
		"cors": true
	},
	"support": {
		"name": "Support"
	},
	"swf": {
		"name": "SWF"
	},
	"xray": {
		"name": "XRay"
	},
	"waf": {
		"name": "WAF",
		"cors": true
	},
	"wafregional": {
		"prefix": "waf-regional",
		"name": "WAFRegional"
	},
	"workdocs": {
		"name": "WorkDocs",
		"cors": true
	},
	"workspaces": {
		"name": "WorkSpaces"
	},
	"codestar": {
		"name": "CodeStar"
	},
	"lexmodelbuildingservice": {
		"prefix": "lex-models",
		"name": "LexModelBuildingService"
	},
	"marketplaceentitlementservice": {
		"prefix": "entitlement.marketplace",
		"name": "MarketplaceEntitlementService"
	},
	"athena": {
		"name": "Athena"
	},
	"greengrass": {
		"name": "Greengrass"
	},
	"dax": {
		"name": "DAX"
	},
	"migrationhub": {
		"prefix": "AWSMigrationHub",
		"name": "MigrationHub"
	},
	"cloudhsmv2": {
		"name": "CloudHSMV2"
	},
	"glue": {
		"name": "Glue"
	}
};

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1480);
var v4 = __webpack_require__(1481);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var rng = __webpack_require__(811);
var bytesToUuid = __webpack_require__(812);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(811);
var bytesToUuid = __webpack_require__(812);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(76).Buffer
var sha = __webpack_require__(1485)
var sha256 = __webpack_require__(1486)
var rng = __webpack_require__(1487)
var md5 = __webpack_require__(1488)

var algorithms = {
  sha1: sha,
  sha256: sha256,
  md5: md5
}

var blocksize = 64
var zeroBuffer = new Buffer(blocksize); zeroBuffer.fill(0)
function hmac(fn, key, data) {
  if(!Buffer.isBuffer(key)) key = new Buffer(key)
  if(!Buffer.isBuffer(data)) data = new Buffer(data)

  if(key.length > blocksize) {
    key = fn(key)
  } else if(key.length < blocksize) {
    key = Buffer.concat([key, zeroBuffer], blocksize)
  }

  var ipad = new Buffer(blocksize), opad = new Buffer(blocksize)
  for(var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var hash = fn(Buffer.concat([ipad, data]))
  return fn(Buffer.concat([opad, hash]))
}

function hash(alg, key) {
  alg = alg || 'sha1'
  var fn = algorithms[alg]
  var bufs = []
  var length = 0
  if(!fn) error('algorithm:', alg, 'is not yet supported')
  return {
    update: function (data) {
      if(!Buffer.isBuffer(data)) data = new Buffer(data)
        
      bufs.push(data)
      length += data.length
      return this
    },
    digest: function (enc) {
      var buf = Buffer.concat(bufs)
      var r = key ? hmac(fn, key, buf) : fn(buf)
      bufs = null
      return enc ? r.toString(enc) : r
    }
  }
}

function error () {
  var m = [].slice.call(arguments).join(' ')
  throw new Error([
    m,
    'we accept pull requests',
    'http://github.com/dominictarr/crypto-browserify'
    ].join('\n'))
}

exports.createHash = function (alg) { return hash(alg) }
exports.createHmac = function (alg, key) { return hash(alg, key) }
exports.randomBytes = function(size, callback) {
  if (callback && callback.call) {
    try {
      callback.call(this, undefined, new Buffer(rng(size)))
    } catch (err) { callback(err) }
  } else {
    return new Buffer(rng(size))
  }
}

function each(a, f) {
  for(var i in a)
    f(a[i], i)
}

// the least I can do is make error messages for the rest of the node.js/crypto api.
each(['createCredentials'
, 'createCipher'
, 'createCipheriv'
, 'createDecipher'
, 'createDecipheriv'
, 'createSign'
, 'createVerify'
, 'createDiffieHellman'
, 'pbkdf2'], function (name) {
  exports[name] = function () {
    error('sorry,', name, 'is not implemented yet')
  }
})


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 1484 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var helpers = __webpack_require__(458);

/*
 * Calculate the SHA-1 of an array of big-endian words, and a bit length
 */
function core_sha1(x, len)
{
  /* append padding */
  x[len >> 5] |= 0x80 << (24 - len % 32);
  x[((len + 64 >> 9) << 4) + 15] = len;

  var w = Array(80);
  var a =  1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d =  271733878;
  var e = -1009589776;

  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    var olde = e;

    for(var j = 0; j < 80; j++)
    {
      if(j < 16) w[j] = x[i + j];
      else w[j] = rol(w[j-3] ^ w[j-8] ^ w[j-14] ^ w[j-16], 1);
      var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)),
                       safe_add(safe_add(e, w[j]), sha1_kt(j)));
      e = d;
      d = c;
      c = rol(b, 30);
      b = a;
      a = t;
    }

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
    e = safe_add(e, olde);
  }
  return Array(a, b, c, d, e);

}

/*
 * Perform the appropriate triplet combination function for the current
 * iteration
 */
function sha1_ft(t, b, c, d)
{
  if(t < 20) return (b & c) | ((~b) & d);
  if(t < 40) return b ^ c ^ d;
  if(t < 60) return (b & c) | (b & d) | (c & d);
  return b ^ c ^ d;
}

/*
 * Determine the appropriate additive constant for the current iteration
 */
function sha1_kt(t)
{
  return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
         (t < 60) ? -1894007588 : -899497514;
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y)
{
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function rol(num, cnt)
{
  return (num << cnt) | (num >>> (32 - cnt));
}

module.exports = function sha1(buf) {
  return helpers.hash(buf, core_sha1, 20, true);
};


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var helpers = __webpack_require__(458);

var safe_add = function(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
};

var S = function(X, n) {
  return (X >>> n) | (X << (32 - n));
};

var R = function(X, n) {
  return (X >>> n);
};

var Ch = function(x, y, z) {
  return ((x & y) ^ ((~x) & z));
};

var Maj = function(x, y, z) {
  return ((x & y) ^ (x & z) ^ (y & z));
};

var Sigma0256 = function(x) {
  return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
};

var Sigma1256 = function(x) {
  return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
};

var Gamma0256 = function(x) {
  return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
};

var Gamma1256 = function(x) {
  return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
};

var core_sha256 = function(m, l) {
  var K = new Array(0x428A2F98,0x71374491,0xB5C0FBCF,0xE9B5DBA5,0x3956C25B,0x59F111F1,0x923F82A4,0xAB1C5ED5,0xD807AA98,0x12835B01,0x243185BE,0x550C7DC3,0x72BE5D74,0x80DEB1FE,0x9BDC06A7,0xC19BF174,0xE49B69C1,0xEFBE4786,0xFC19DC6,0x240CA1CC,0x2DE92C6F,0x4A7484AA,0x5CB0A9DC,0x76F988DA,0x983E5152,0xA831C66D,0xB00327C8,0xBF597FC7,0xC6E00BF3,0xD5A79147,0x6CA6351,0x14292967,0x27B70A85,0x2E1B2138,0x4D2C6DFC,0x53380D13,0x650A7354,0x766A0ABB,0x81C2C92E,0x92722C85,0xA2BFE8A1,0xA81A664B,0xC24B8B70,0xC76C51A3,0xD192E819,0xD6990624,0xF40E3585,0x106AA070,0x19A4C116,0x1E376C08,0x2748774C,0x34B0BCB5,0x391C0CB3,0x4ED8AA4A,0x5B9CCA4F,0x682E6FF3,0x748F82EE,0x78A5636F,0x84C87814,0x8CC70208,0x90BEFFFA,0xA4506CEB,0xBEF9A3F7,0xC67178F2);
  var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);
    var W = new Array(64);
    var a, b, c, d, e, f, g, h, i, j;
    var T1, T2;
  /* append padding */
  m[l >> 5] |= 0x80 << (24 - l % 32);
  m[((l + 64 >> 9) << 4) + 15] = l;
  for (var i = 0; i < m.length; i += 16) {
    a = HASH[0]; b = HASH[1]; c = HASH[2]; d = HASH[3]; e = HASH[4]; f = HASH[5]; g = HASH[6]; h = HASH[7];
    for (var j = 0; j < 64; j++) {
      if (j < 16) {
        W[j] = m[j + i];
      } else {
        W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
      }
      T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
      T2 = safe_add(Sigma0256(a), Maj(a, b, c));
      h = g; g = f; f = e; e = safe_add(d, T1); d = c; c = b; b = a; a = safe_add(T1, T2);
    }
    HASH[0] = safe_add(a, HASH[0]); HASH[1] = safe_add(b, HASH[1]); HASH[2] = safe_add(c, HASH[2]); HASH[3] = safe_add(d, HASH[3]);
    HASH[4] = safe_add(e, HASH[4]); HASH[5] = safe_add(f, HASH[5]); HASH[6] = safe_add(g, HASH[6]); HASH[7] = safe_add(h, HASH[7]);
  }
  return HASH;
};

module.exports = function sha256(buf) {
  return helpers.hash(buf, core_sha256, 32, true);
};


/***/ }),
/* 1487 */
/***/ (function(module, exports) {

// Original code adapted from Robert Kieffer.
// details at https://github.com/broofa/node-uuid
(function() {
  var _global = this;

  var mathRNG, whatwgRNG;

  // NOTE: Math.random() does not guarantee "cryptographic quality"
  mathRNG = function(size) {
    var bytes = new Array(size);
    var r;

    for (var i = 0, r; i < size; i++) {
      if ((i & 0x03) == 0) r = Math.random() * 0x100000000;
      bytes[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return bytes;
  }

  if (_global.crypto && crypto.getRandomValues) {
    whatwgRNG = function(size) {
      var bytes = new Uint8Array(size);
      crypto.getRandomValues(bytes);
      return bytes;
    }
  }

  module.exports = whatwgRNG || mathRNG;

}())


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

var helpers = __webpack_require__(458);

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test()
{
  return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
function core_md5(x, len)
{
  /* append padding */
  x[len >> 5] |= 0x80 << ((len) % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var a =  1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d =  271733878;

  for(var i = 0; i < x.length; i += 16)
  {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);

    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);

}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t)
{
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
}
function md5_ff(a, b, c, d, x, s, t)
{
  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t)
{
  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t)
{
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t)
{
  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y)
{
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt)
{
  return (num << cnt) | (num >>> (32 - cnt));
}

module.exports = function md5(buf) {
  return helpers.hash(buf, core_md5, 16);
};


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module), __webpack_require__(24)))

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var STS = __webpack_require__(258);

/**
 * Represents temporary credentials retrieved from {AWS.STS}. Without any
 * extra parameters, credentials will be fetched from the
 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
 * role instead.
 *
 * To setup temporary credentials, configure a set of master credentials
 * using the standard credentials providers (environment, EC2 instance metadata,
 * or from the filesystem), then set the global credentials to a new
 * temporary credentials object:
 *
 * ```javascript
 * // Note that environment credentials are loaded by default,
 * // the following line is shown for clarity:
 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
 *
 * // Now set temporary credentials seeded from the master credentials
 * AWS.config.credentials = new AWS.TemporaryCredentials();
 *
 * // subsequent requests will now use temporary credentials from AWS STS.
 * new AWS.S3().listBucket(function(err, data) { ... });
 * ```
 *
 * @!attribute masterCredentials
 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
 *     get and refresh temporary credentials from AWS STS.
 * @note (see constructor)
 */
AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new temporary credentials object.
   *
   * @note In order to create temporary credentials, you first need to have
   *   "master" credentials configured in {AWS.Config.credentials}. These
   *   master credentials are necessary to retrieve the temporary credentials,
   *   as well as refresh the credentials when they expire.
   * @param params [map] a map of options that are passed to the
   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
   *   If a `RoleArn` parameter is passed in, credentials will be based on the
   *   IAM role.
   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
   *  used to get and refresh temporary credentials from AWS STS.
   * @example Creating a new credentials object for generic temporary credentials
   *   AWS.config.credentials = new AWS.TemporaryCredentials();
   * @example Creating a new credentials object for an IAM role
   *   AWS.config.credentials = new AWS.TemporaryCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
   *   });
   * @see AWS.STS.assumeRole
   * @see AWS.STS.getSessionToken
   */
  constructor: function TemporaryCredentials(params, masterCredentials) {
    AWS.Credentials.call(this);
    this.loadMasterCredentials(masterCredentials);
    this.expired = true;

    this.params = params || {};
    if (this.params.RoleArn) {
      this.params.RoleSessionName =
        this.params.RoleSessionName || 'temporary-credentials';
    }
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRole} or
   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
   * to the credentials {constructor}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.masterCredentials.get(function() {
      self.service.config.credentials = self.masterCredentials;
      var operation = self.params.RoleArn ?
        self.service.assumeRole : self.service.getSessionToken;
      operation.call(self.service, function (err, data) {
        if (!err) {
          self.service.credentialsFrom(data, self);
        }
        callback(err);
      });
    });
  },

  /**
   * @api private
   */
  loadMasterCredentials: function loadMasterCredentials(masterCredentials) {
    this.masterCredentials = masterCredentials || AWS.config.credentials;
    while (this.masterCredentials.masterCredentials) {
      this.masterCredentials = this.masterCredentials.masterCredentials;
    }

    if (typeof this.masterCredentials.get !== 'function') {
      this.masterCredentials = new AWS.Credentials(this.masterCredentials);
    }
  },

  /**
   * @api private
   */
  createClients: function() {
    this.service = this.service || new STS({params: this.params});
  }

});


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

AWS.util.update(AWS.STS.prototype, {
  /**
   * @overload credentialsFrom(data, credentials = null)
   *   Creates a credentials object from STS response data containing
   *   credentials information. Useful for quickly setting AWS credentials.
   *
   *   @note This is a low-level utility function. If you want to load temporary
   *     credentials into your process for subsequent requests to AWS resources,
   *     you should use {AWS.TemporaryCredentials} instead.
   *   @param data [map] data retrieved from a call to {getFederatedToken},
   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
   *   @param credentials [AWS.Credentials] an optional credentials object to
   *     fill instead of creating a new object. Useful when modifying an
   *     existing credentials object from a refresh call.
   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
   *     loaded from a raw STS operation response.
   *   @example Using credentialsFrom to load global AWS credentials
   *     var sts = new AWS.STS();
   *     sts.getSessionToken(function (err, data) {
   *       if (err) console.log("Error getting credentials");
   *       else {
   *         AWS.config.credentials = sts.credentialsFrom(data);
   *       }
   *     });
   *   @see AWS.TemporaryCredentials
   */
  credentialsFrom: function credentialsFrom(data, credentials) {
    if (!data) return null;
    if (!credentials) credentials = new AWS.TemporaryCredentials();
    credentials.expired = false;
    credentials.accessKeyId = data.Credentials.AccessKeyId;
    credentials.secretAccessKey = data.Credentials.SecretAccessKey;
    credentials.sessionToken = data.Credentials.SessionToken;
    credentials.expireTime = data.Credentials.Expiration;
    return credentials;
  },

  assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
    return this.makeUnauthenticatedRequest('assumeRoleWithWebIdentity', params, callback);
  },

  assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
    return this.makeUnauthenticatedRequest('assumeRoleWithSAML', params, callback);
  }
});


/***/ }),
/* 1493 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2011-06-15",
		"endpointPrefix": "sts",
		"globalEndpoint": "sts.amazonaws.com",
		"protocol": "query",
		"serviceAbbreviation": "AWS STS",
		"serviceFullName": "AWS Security Token Service",
		"signatureVersion": "v4",
		"uid": "sts-2011-06-15",
		"xmlNamespace": "https://sts.amazonaws.com/doc/2011-06-15/"
	},
	"operations": {
		"AssumeRole": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"RoleSessionName"
				],
				"members": {
					"RoleArn": {},
					"RoleSessionName": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					},
					"ExternalId": {},
					"SerialNumber": {},
					"TokenCode": {}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					}
				}
			}
		},
		"AssumeRoleWithSAML": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"PrincipalArn",
					"SAMLAssertion"
				],
				"members": {
					"RoleArn": {},
					"PrincipalArn": {},
					"SAMLAssertion": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleWithSAMLResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					},
					"Subject": {},
					"SubjectType": {},
					"Issuer": {},
					"Audience": {},
					"NameQualifier": {}
				}
			}
		},
		"AssumeRoleWithWebIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"RoleArn",
					"RoleSessionName",
					"WebIdentityToken"
				],
				"members": {
					"RoleArn": {},
					"RoleSessionName": {},
					"WebIdentityToken": {},
					"ProviderId": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "AssumeRoleWithWebIdentityResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"SubjectFromWebIdentityToken": {},
					"AssumedRoleUser": {
						"shape": "Sf"
					},
					"PackedPolicySize": {
						"type": "integer"
					},
					"Provider": {},
					"Audience": {}
				}
			}
		},
		"DecodeAuthorizationMessage": {
			"input": {
				"type": "structure",
				"required": [
					"EncodedMessage"
				],
				"members": {
					"EncodedMessage": {}
				}
			},
			"output": {
				"resultWrapper": "DecodeAuthorizationMessageResult",
				"type": "structure",
				"members": {
					"DecodedMessage": {}
				}
			}
		},
		"GetCallerIdentity": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"resultWrapper": "GetCallerIdentityResult",
				"type": "structure",
				"members": {
					"UserId": {},
					"Account": {},
					"Arn": {}
				}
			}
		},
		"GetFederationToken": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Policy": {},
					"DurationSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "GetFederationTokenResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					},
					"FederatedUser": {
						"type": "structure",
						"required": [
							"FederatedUserId",
							"Arn"
						],
						"members": {
							"FederatedUserId": {},
							"Arn": {}
						}
					},
					"PackedPolicySize": {
						"type": "integer"
					}
				}
			}
		},
		"GetSessionToken": {
			"input": {
				"type": "structure",
				"members": {
					"DurationSeconds": {
						"type": "integer"
					},
					"SerialNumber": {},
					"TokenCode": {}
				}
			},
			"output": {
				"resultWrapper": "GetSessionTokenResult",
				"type": "structure",
				"members": {
					"Credentials": {
						"shape": "Sa"
					}
				}
			}
		}
	},
	"shapes": {
		"Sa": {
			"type": "structure",
			"required": [
				"AccessKeyId",
				"SecretAccessKey",
				"SessionToken",
				"Expiration"
			],
			"members": {
				"AccessKeyId": {},
				"SecretAccessKey": {},
				"SessionToken": {},
				"Expiration": {
					"type": "timestamp"
				}
			}
		},
		"Sf": {
			"type": "structure",
			"required": [
				"AssumedRoleId",
				"Arn"
			],
			"members": {
				"AssumedRoleId": {},
				"Arn": {}
			}
		}
	}
};

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var STS = __webpack_require__(258);

/**
 * Represents credentials retrieved from STS Web Identity Federation support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given. In addition, the
 * `WebIdentityToken` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn` and `WebIdentityToken` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 */
AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithWebIdentity)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
   *     RoleSessionName: 'web' // optional name, defaults to web-identity
   *   }, {
   *     // optionally provide configuration to apply to the underlying AWS.STS service client
   *     // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *     // specify timeout options
   *     httpOptions: {
   *       timeout: 100
   *     }
   *   });
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.Config
   */
  constructor: function WebIdentityCredentials(params, clientConfig) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
    this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
    this.data = null;
    this._clientConfig = AWS.util.copy(clientConfig || {});
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.service.assumeRoleWithWebIdentity(function (err, data) {
      self.data = null;
      if (!err) {
        self.data = data;
        self.service.credentialsFrom(data, self);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  createClients: function() {
    if (!this.service) {
      var stsConfig = AWS.util.merge({}, this._clientConfig);
      stsConfig.params = this.params;
      this.service = new STS(stsConfig);
    }
  }

});


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var CognitoIdentity = __webpack_require__(813);
var STS = __webpack_require__(258);

/**
 * Represents credentials retrieved from STS Web Identity Federation using
 * the Amazon Cognito Identity service.
 *
 * By default this provider gets credentials using the
 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
 * obtain an `IdentityId`. If the identity or identity pool is not configured in
 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
 * is provided, then this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
 *
 * In addition, if this credential provider is used to provide authenticated
 * login, the `Logins` map may be set to the tokens provided by the respective
 * identity providers. See {constructor} for an example on creating a credentials
 * object with proper property values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.CognitoIdentity.getId},
 *     {AWS.CognitoIdentity.getOpenIdToken}, and
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 * @!attribute identityId
 *   @return [String] the Cognito ID returned by the last call to
 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
 *     final resolved identity ID from Amazon Cognito.
 */
AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * @api private
   */
  localStorageKey: {
    id: 'aws.cognito.identity-id.',
    providers: 'aws.cognito.identity-providers.'
  },

  /**
   * Creates a new credentials object.
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
   *
   *     // either IdentityPoolId or IdentityId is required
   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
   *
   *     // optional, only necessary when the identity pool is not configured
   *     // to use IAM roles in the Amazon Cognito Console
   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
   *
   *     // optional tokens, used for authenticated login
   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
   *     Logins: {
   *       'graph.facebook.com': 'FBTOKEN',
   *       'www.amazon.com': 'AMAZONTOKEN',
   *       'accounts.google.com': 'GOOGLETOKEN',
   *       'api.twitter.com': 'TWITTERTOKEN',
   *       'www.digits.com': 'DIGITSTOKEN'
   *     },
   *
   *     // optional name, defaults to web-identity
   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleSessionName: 'web',
   *
   *     // optional, only necessary when application runs in a browser
   *     // and multiple users are signed in at once, used for caching
   *     LoginId: 'example@gmail.com'
   *
   *   }, {
   *      // optionally provide configuration to apply to the underlying service clients
   *      // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *      // region should match the region your identity pool is located in
   *      region: 'us-east-1',
   *
   *      // specify timeout options
   *      httpOptions: {
   *        timeout: 100
   *      }
   *   });
   * @see AWS.CognitoIdentity.getId
   * @see AWS.CognitoIdentity.getCredentialsForIdentity
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.CognitoIdentity.getOpenIdToken
   * @see AWS.Config
   * @note If a region is not provided in the global AWS.config, or
   *   specified in the `clientConfig` to the CognitoIdentityCredentials
   *   constructor, you may encounter a 'Missing credentials in config' error
   *   when calling making a service call.
   */
  constructor: function CognitoIdentityCredentials(params, clientConfig) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
    this.data = null;
    this._identityId = null;
    this._clientConfig = AWS.util.copy(clientConfig || {});
    this.loadCachedId();
    var self = this;
    Object.defineProperty(this, 'identityId', {
      get: function() {
        self.loadCachedId();
        return self._identityId || self.params.IdentityId;
      },
      set: function(identityId) {
        self._identityId = identityId;
      }
    });
  },

  /**
   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
   * or {AWS.STS.assumeRoleWithWebIdentity}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see AWS.Credentials.get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    self.data = null;
    self._identityId = null;
    self.getId(function(err) {
      if (!err) {
        if (!self.params.RoleArn) {
          self.getCredentialsForIdentity(callback);
        } else {
          self.getCredentialsFromSTS(callback);
        }
      } else {
        self.clearIdOnNotAuthorized(err);
        callback(err);
      }
    });
  },

  /**
   * Clears the cached Cognito ID associated with the currently configured
   * identity pool ID. Use this to manually invalidate your cache if
   * the identity pool ID was deleted.
   */
  clearCachedId: function clearCache() {
    this._identityId = null;
    delete this.params.IdentityId;

    var poolId = this.params.IdentityPoolId;
    var loginId = this.params.LoginId || '';
    delete this.storage[this.localStorageKey.id + poolId + loginId];
    delete this.storage[this.localStorageKey.providers + poolId + loginId];
  },

  /**
   * @api private
   */
  clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
    var self = this;
    if (err.code == 'NotAuthorizedException') {
      self.clearCachedId();
    }
  },

  /**
   * Retrieves a Cognito ID, loading from cache if it was already retrieved
   * on this device.
   *
   * @callback callback function(err, identityId)
   *   @param err [Error, null] an error object if the call failed or null if
   *     it succeeded.
   *   @param identityId [String, null] if successful, the callback will return
   *     the Cognito ID.
   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
   *   localStorage in the browser environment of a device.
   * @api private
   */
  getId: function getId(callback) {
    var self = this;
    if (typeof self.params.IdentityId === 'string') {
      return callback(null, self.params.IdentityId);
    }

    self.cognito.getId(function(err, data) {
      if (!err && data.IdentityId) {
        self.params.IdentityId = data.IdentityId;
        callback(null, data.IdentityId);
      } else {
        callback(err);
      }
    });
  },


  /**
   * @api private
   */
  loadCredentials: function loadCredentials(data, credentials) {
    if (!data || !credentials) return;
    credentials.expired = false;
    credentials.accessKeyId = data.Credentials.AccessKeyId;
    credentials.secretAccessKey = data.Credentials.SecretKey;
    credentials.sessionToken = data.Credentials.SessionToken;
    credentials.expireTime = data.Credentials.Expiration;
  },

  /**
   * @api private
   */
  getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
    var self = this;
    self.cognito.getCredentialsForIdentity(function(err, data) {
      if (!err) {
        self.cacheId(data);
        self.data = data;
        self.loadCredentials(self.data, self);
      } else {
        self.clearIdOnNotAuthorized(err);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
    var self = this;
    self.cognito.getOpenIdToken(function(err, data) {
      if (!err) {
        self.cacheId(data);
        self.params.WebIdentityToken = data.Token;
        self.webIdentityCredentials.refresh(function(webErr) {
          if (!webErr) {
            self.data = self.webIdentityCredentials.data;
            self.sts.credentialsFrom(self.data, self);
          }
          callback(webErr);
        });
      } else {
        self.clearIdOnNotAuthorized(err);
        callback(err);
      }
    });
  },

  /**
   * @api private
   */
  loadCachedId: function loadCachedId() {
    var self = this;

    // in the browser we source default IdentityId from localStorage
    if (AWS.util.isBrowser() && !self.params.IdentityId) {
      var id = self.getStorage('id');
      if (id && self.params.Logins) {
        var actualProviders = Object.keys(self.params.Logins);
        var cachedProviders =
          (self.getStorage('providers') || '').split(',');

        // only load ID if at least one provider used this ID before
        var intersect = cachedProviders.filter(function(n) {
          return actualProviders.indexOf(n) !== -1;
        });
        if (intersect.length !== 0) {
          self.params.IdentityId = id;
        }
      } else if (id) {
        self.params.IdentityId = id;
      }
    }
  },

  /**
   * @api private
   */
  createClients: function() {
    var clientConfig = this._clientConfig;
    this.webIdentityCredentials = this.webIdentityCredentials ||
      new AWS.WebIdentityCredentials(this.params, clientConfig);
    if (!this.cognito) {
      var cognitoConfig = AWS.util.merge({}, clientConfig);
      cognitoConfig.params = this.params;
      this.cognito = new CognitoIdentity(cognitoConfig);
    }
    this.sts = this.sts || new STS(clientConfig);
  },

  /**
   * @api private
   */
  cacheId: function cacheId(data) {
    this._identityId = data.IdentityId;
    this.params.IdentityId = this._identityId;

    // cache this IdentityId in browser localStorage if possible
    if (AWS.util.isBrowser()) {
      this.setStorage('id', data.IdentityId);

      if (this.params.Logins) {
        this.setStorage('providers', Object.keys(this.params.Logins).join(','));
      }
    }
  },

  /**
   * @api private
   */
  getStorage: function getStorage(key) {
    return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
  },

  /**
   * @api private
   */
  setStorage: function setStorage(key, val) {
    try {
      this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
    } catch (_) {}
  },

  /**
   * @api private
   */
  storage: (function() {
    try {
      var storage = AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ?
          window.localStorage : {};

      // Test set/remove which would throw an error in Safari's private browsing
      storage['aws.test-storage'] = 'foobar';
      delete storage['aws.test-storage'];

      return storage;
    } catch (_) {
      return {};
    }
  })()
});


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

AWS.util.update(AWS.CognitoIdentity.prototype, {
  getOpenIdToken: function getOpenIdToken(params, callback) {
    return this.makeUnauthenticatedRequest('getOpenIdToken', params, callback);
  },

  getId: function getId(params, callback) {
    return this.makeUnauthenticatedRequest('getId', params, callback);
  },

  getCredentialsForIdentity: function getCredentialsForIdentity(params, callback) {
    return this.makeUnauthenticatedRequest('getCredentialsForIdentity', params, callback);
  }
});


/***/ }),
/* 1498 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-06-30",
		"endpointPrefix": "cognito-identity",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Cognito Identity",
		"signatureVersion": "v4",
		"targetPrefix": "AWSCognitoIdentityService",
		"uid": "cognito-identity-2014-06-30"
	},
	"operations": {
		"CreateIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolName",
					"AllowUnauthenticatedIdentities"
				],
				"members": {
					"IdentityPoolName": {},
					"AllowUnauthenticatedIdentities": {
						"type": "boolean"
					},
					"SupportedLoginProviders": {
						"shape": "S4"
					},
					"DeveloperProviderName": {},
					"OpenIdConnectProviderARNs": {
						"shape": "S8"
					},
					"CognitoIdentityProviders": {
						"shape": "Sa"
					},
					"SamlProviderARNs": {
						"shape": "Sf"
					}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"DeleteIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityIdsToDelete"
				],
				"members": {
					"IdentityIdsToDelete": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UnprocessedIdentityIds": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IdentityId": {},
								"ErrorCode": {}
							}
						}
					}
				}
			}
		},
		"DeleteIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			}
		},
		"DescribeIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {}
				}
			},
			"output": {
				"shape": "Sr"
			}
		},
		"DescribeIdentityPool": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"GetCredentialsForIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					},
					"CustomRoleArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Credentials": {
						"type": "structure",
						"members": {
							"AccessKeyId": {},
							"SecretKey": {},
							"SessionToken": {},
							"Expiration": {
								"type": "timestamp"
							}
						}
					}
				}
			}
		},
		"GetId": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"AccountId": {},
					"IdentityPoolId": {},
					"Logins": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {}
				}
			}
		},
		"GetIdentityPoolRoles": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"Roles": {
						"shape": "S18"
					},
					"RoleMappings": {
						"shape": "S1a"
					}
				}
			}
		},
		"GetOpenIdToken": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Token": {}
				}
			}
		},
		"GetOpenIdTokenForDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"Logins"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					},
					"TokenDuration": {
						"type": "long"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Token": {}
				}
			}
		},
		"ListIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"MaxResults"
				],
				"members": {
					"IdentityPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"HideDisabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"Identities": {
						"type": "list",
						"member": {
							"shape": "Sr"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListIdentityPools": {
			"input": {
				"type": "structure",
				"required": [
					"MaxResults"
				],
				"members": {
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPools": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IdentityPoolId": {},
								"IdentityPoolName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"LookupDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityId": {},
					"DeveloperUserIdentifier": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"DeveloperUserIdentifierList": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			}
		},
		"MergeDeveloperIdentities": {
			"input": {
				"type": "structure",
				"required": [
					"SourceUserIdentifier",
					"DestinationUserIdentifier",
					"DeveloperProviderName",
					"IdentityPoolId"
				],
				"members": {
					"SourceUserIdentifier": {},
					"DestinationUserIdentifier": {},
					"DeveloperProviderName": {},
					"IdentityPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityId": {}
				}
			}
		},
		"SetIdentityPoolRoles": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"Roles"
				],
				"members": {
					"IdentityPoolId": {},
					"Roles": {
						"shape": "S18"
					},
					"RoleMappings": {
						"shape": "S1a"
					}
				}
			}
		},
		"UnlinkDeveloperIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId",
					"IdentityPoolId",
					"DeveloperProviderName",
					"DeveloperUserIdentifier"
				],
				"members": {
					"IdentityId": {},
					"IdentityPoolId": {},
					"DeveloperProviderName": {},
					"DeveloperUserIdentifier": {}
				}
			}
		},
		"UnlinkIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"IdentityId",
					"Logins",
					"LoginsToRemove"
				],
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sw"
					},
					"LoginsToRemove": {
						"shape": "Ss"
					}
				}
			}
		},
		"UpdateIdentityPool": {
			"input": {
				"shape": "Sg"
			},
			"output": {
				"shape": "Sg"
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S8": {
			"type": "list",
			"member": {}
		},
		"Sa": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ProviderName": {},
					"ClientId": {},
					"ServerSideTokenCheck": {
						"type": "boolean"
					}
				}
			}
		},
		"Sf": {
			"type": "list",
			"member": {}
		},
		"Sg": {
			"type": "structure",
			"required": [
				"IdentityPoolId",
				"IdentityPoolName",
				"AllowUnauthenticatedIdentities"
			],
			"members": {
				"IdentityPoolId": {},
				"IdentityPoolName": {},
				"AllowUnauthenticatedIdentities": {
					"type": "boolean"
				},
				"SupportedLoginProviders": {
					"shape": "S4"
				},
				"DeveloperProviderName": {},
				"OpenIdConnectProviderARNs": {
					"shape": "S8"
				},
				"CognitoIdentityProviders": {
					"shape": "Sa"
				},
				"SamlProviderARNs": {
					"shape": "Sf"
				}
			}
		},
		"Sr": {
			"type": "structure",
			"members": {
				"IdentityId": {},
				"Logins": {
					"shape": "Ss"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				}
			}
		},
		"Ss": {
			"type": "list",
			"member": {}
		},
		"Sw": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S18": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1a": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"Type": {},
					"AmbiguousRoleResolution": {},
					"RulesConfiguration": {
						"type": "structure",
						"required": [
							"Rules"
						],
						"members": {
							"Rules": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"Claim",
										"MatchType",
										"Value",
										"RoleARN"
									],
									"members": {
										"Claim": {},
										"MatchType": {},
										"Value": {},
										"RoleARN": {}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var STS = __webpack_require__(258);

/**
 * Represents credentials retrieved from STS SAML support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given, as well as a `PrincipalArn`
 * representing the ARN for the SAML identity provider. In addition, the
 * `SAMLAssertion` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the SAMLAssertion, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
 *     `params.SAMLAssertion` property.
 */
AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
  /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithSAML)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.SAMLCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
   *   });
   * @see AWS.STS.assumeRoleWithSAML
   */
  constructor: function SAMLCredentials(params) {
    AWS.Credentials.call(this);
    this.expired = true;
    this.params = params;
  },

  /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */
  refresh: function refresh(callback) {
    var self = this;
    self.createClients();
    if (!callback) callback = function(err) { if (err) throw err; };

    self.service.assumeRoleWithSAML(function (err, data) {
      if (!err) {
        self.service.credentialsFrom(data, self);
      }
      callback(err);
    });
  },

  /**
   * @api private
   */
  createClients: function() {
    this.service = this.service || new STS({params: this.params});
  }

});


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(68);
var Shape = __webpack_require__(253);

function DomXmlParser() { }

DomXmlParser.prototype.parse = function(xml, shape) {
  if (xml.replace(/^\s+/, '') === '') return {};

  var result, error;
  try {
    if (window.DOMParser) {
      try {
        var parser = new DOMParser();
        result = parser.parseFromString(xml, 'text/xml');
      } catch (syntaxError) {
        throw util.error(new Error('Parse error in document'),
          {
            originalError: syntaxError,
            code: 'XMLParserError',
            retryable: true
          });
      }

      if (result.documentElement === null) {
        throw util.error(new Error('Cannot parse empty document.'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }

      var isError = result.getElementsByTagName('parsererror')[0];
      if (isError && (isError.parentNode === result ||
          isError.parentNode.nodeName === 'body' ||
          isError.parentNode.parentNode === result ||
          isError.parentNode.parentNode.nodeName === 'body')) {
        var errorElement = isError.getElementsByTagName('div')[0] || isError;
        throw util.error(new Error(errorElement.textContent || 'Parser error in document'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }
    } else if (window.ActiveXObject) {
      result = new window.ActiveXObject('Microsoft.XMLDOM');
      result.async = false;

      if (!result.loadXML(xml)) {
        throw util.error(new Error('Parse error in document'),
          {
            code: 'XMLParserError',
            retryable: true
          });
      }
    } else {
      throw new Error('Cannot load XML parser');
    }
  } catch (e) {
    error = e;
  }

  if (result && result.documentElement && !error) {
    var data = parseXml(result.documentElement, shape);
    var metadata = result.getElementsByTagName('ResponseMetadata')[0];
    if (metadata) {
      data.ResponseMetadata = parseXml(metadata, {});
    }
    return data;
  } else if (error) {
    throw util.error(error || new Error(), {code: 'XMLParserError', retryable: true});
  } else { // empty xml document
    return {};
  }
};

function parseXml(xml, shape) {
  if (!shape) shape = {};
  switch (shape.type) {
    case 'structure': return parseStructure(xml, shape);
    case 'map': return parseMap(xml, shape);
    case 'list': return parseList(xml, shape);
    case undefined: case null: return parseUnknown(xml);
    default: return parseScalar(xml, shape);
  }
}

function parseStructure(xml, shape) {
  var data = {};
  if (xml === null) return data;

  util.each(shape.members, function(memberName, memberShape) {
    if (memberShape.isXmlAttribute) {
      if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
        var value = xml.attributes[memberShape.name].value;
        data[memberName] = parseXml({textContent: value}, memberShape);
      }
    } else {
      var xmlChild = memberShape.flattened ? xml :
        xml.getElementsByTagName(memberShape.name)[0];
      if (xmlChild) {
        data[memberName] = parseXml(xmlChild, memberShape);
      } else if (!memberShape.flattened && memberShape.type === 'list') {
        data[memberName] = memberShape.defaultValue;
      }
    }
  });

  return data;
}

function parseMap(xml, shape) {
  var data = {};
  var xmlKey = shape.key.name || 'key';
  var xmlValue = shape.value.name || 'value';
  var tagName = shape.flattened ? shape.name : 'entry';

  var child = xml.firstElementChild;
  while (child) {
    if (child.nodeName === tagName) {
      var key = child.getElementsByTagName(xmlKey)[0].textContent;
      var value = child.getElementsByTagName(xmlValue)[0];
      data[key] = parseXml(value, shape.value);
    }
    child = child.nextElementSibling;
  }
  return data;
}

function parseList(xml, shape) {
  var data = [];
  var tagName = shape.flattened ? shape.name : (shape.member.name || 'member');

  var child = xml.firstElementChild;
  while (child) {
    if (child.nodeName === tagName) {
      data.push(parseXml(child, shape.member));
    }
    child = child.nextElementSibling;
  }
  return data;
}

function parseScalar(xml, shape) {
  if (xml.getAttribute) {
    var encoding = xml.getAttribute('encoding');
    if (encoding === 'base64') {
      shape = new Shape.create({type: encoding});
    }
  }

  var text = xml.textContent;
  if (text === '') text = null;
  if (typeof shape.toType === 'function') {
    return shape.toType(text);
  } else {
    return text;
  }
}

function parseUnknown(xml) {
  if (xml === undefined || xml === null) return '';

  // empty object
  if (!xml.firstElementChild) {
    if (xml.parentNode.parentNode === null) return {};
    if (xml.childNodes.length === 0) return '';
    else return xml.textContent;
  }

  // object, parse as structure
  var shape = {type: 'structure', members: {}};
  var child = xml.firstElementChild;
  while (child) {
    var tag = child.nodeName;
    if (Object.prototype.hasOwnProperty.call(shape.members, tag)) {
      // multiple tags of the same name makes it a list
      shape.members[tag].type = 'list';
    } else {
      shape.members[tag] = {name: tag};
    }
    child = child.nextElementSibling;
  }
  return parseStructure(xml, shape);
}

module.exports = DomXmlParser;


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var EventEmitter = __webpack_require__(141).EventEmitter;
__webpack_require__(807);

/**
 * @api private
 */
AWS.XHRClient = AWS.util.inherit({
  handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
    var self = this;
    var endpoint = httpRequest.endpoint;
    var emitter = new EventEmitter();
    var href = endpoint.protocol + '//' + endpoint.hostname;
    if (endpoint.port !== 80 && endpoint.port !== 443) {
      href += ':' + endpoint.port;
    }
    href += httpRequest.path;

    var xhr = new XMLHttpRequest(), headersEmitted = false;
    httpRequest.stream = xhr;

    xhr.addEventListener('readystatechange', function() {
      try {
        if (xhr.status === 0) return; // 0 code is invalid
      } catch (e) { return; }

      if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
        emitter.statusCode = xhr.status;
        emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
        emitter.emit(
          'headers',
          emitter.statusCode,
          emitter.headers,
          xhr.statusText
        );
        headersEmitted = true;
      }
      if (this.readyState === this.DONE) {
        self.finishRequest(xhr, emitter);
      }
    }, false);
    xhr.upload.addEventListener('progress', function (evt) {
      emitter.emit('sendProgress', evt);
    });
    xhr.addEventListener('progress', function (evt) {
      emitter.emit('receiveProgress', evt);
    }, false);
    xhr.addEventListener('timeout', function () {
      errCallback(AWS.util.error(new Error('Timeout'), {code: 'TimeoutError'}));
    }, false);
    xhr.addEventListener('error', function () {
      errCallback(AWS.util.error(new Error('Network Failure'), {
        code: 'NetworkingError'
      }));
    }, false);
    xhr.addEventListener('abort', function () {
      errCallback(AWS.util.error(new Error('Request aborted'), {
        code: 'RequestAbortedError'
      }));
    }, false);

    callback(emitter);
    xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
    AWS.util.each(httpRequest.headers, function (key, value) {
      if (key !== 'Content-Length' && key !== 'User-Agent' && key !== 'Host') {
        xhr.setRequestHeader(key, value);
      }
    });

    if (httpOptions.timeout && httpOptions.xhrAsync !== false) {
      xhr.timeout = httpOptions.timeout;
    }

    if (httpOptions.xhrWithCredentials) {
      xhr.withCredentials = true;
    }
    try { xhr.responseType = 'arraybuffer'; } catch (e) {}

    try {
      if (httpRequest.body) {
        xhr.send(httpRequest.body);
      } else {
        xhr.send();
      }
    } catch (err) {
      if (httpRequest.body && typeof httpRequest.body.buffer === 'object') {
        xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
      } else {
        throw err;
      }
    }

    return emitter;
  },

  parseHeaders: function parseHeaders(rawHeaders) {
    var headers = {};
    AWS.util.arrayEach(rawHeaders.split(/\r?\n/), function (line) {
      var key = line.split(':', 1)[0];
      var value = line.substring(key.length + 2);
      if (key.length > 0) headers[key.toLowerCase()] = value;
    });
    return headers;
  },

  finishRequest: function finishRequest(xhr, emitter) {
    var buffer;
    if (xhr.responseType === 'arraybuffer' && xhr.response) {
      var ab = xhr.response;
      buffer = new AWS.util.Buffer(ab.byteLength);
      var view = new Uint8Array(ab);
      for (var i = 0; i < buffer.length; ++i) {
        buffer[i] = view[i];
      }
    }

    try {
      if (!buffer && typeof xhr.responseText === 'string') {
        buffer = new AWS.util.Buffer(xhr.responseText);
      }
    } catch (e) {}

    if (buffer) emitter.emit('data', buffer);
    emitter.emit('end');
  }
});

/**
 * @api private
 */
AWS.HttpClient.prototype = AWS.XHRClient.prototype;

/**
 * @api private
 */
AWS.HttpClient.streamsApiVersion = 1;


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
module.exports = {
  ACM: __webpack_require__(1504),
  APIGateway: __webpack_require__(1507),
  ApplicationAutoScaling: __webpack_require__(1511),
  AutoScaling: __webpack_require__(1514),
  CloudFormation: __webpack_require__(1517),
  CloudFront: __webpack_require__(1521),
  CloudHSM: __webpack_require__(1530),
  CloudTrail: __webpack_require__(1532),
  CloudWatch: __webpack_require__(1535),
  CloudWatchEvents: __webpack_require__(1539),
  CloudWatchLogs: __webpack_require__(1542),
  CodeCommit: __webpack_require__(1545),
  CodeDeploy: __webpack_require__(1548),
  CodePipeline: __webpack_require__(1552),
  CognitoIdentity: __webpack_require__(813),
  CognitoIdentityServiceProvider: __webpack_require__(1555),
  CognitoSync: __webpack_require__(1558),
  ConfigService: __webpack_require__(1560),
  CUR: __webpack_require__(1563),
  DeviceFarm: __webpack_require__(1566),
  DirectConnect: __webpack_require__(1569),
  DynamoDB: __webpack_require__(1572),
  DynamoDBStreams: __webpack_require__(1584),
  EC2: __webpack_require__(1587),
  ECR: __webpack_require__(1592),
  ECS: __webpack_require__(1595),
  EFS: __webpack_require__(1599),
  ElastiCache: __webpack_require__(1602),
  ElasticBeanstalk: __webpack_require__(1606),
  ELB: __webpack_require__(1609),
  ELBv2: __webpack_require__(1613),
  EMR: __webpack_require__(1617),
  ElasticTranscoder: __webpack_require__(1621),
  Firehose: __webpack_require__(1625),
  GameLift: __webpack_require__(1628),
  Inspector: __webpack_require__(1631),
  Iot: __webpack_require__(1634),
  IotData: __webpack_require__(1637),
  Kinesis: __webpack_require__(1640),
  KMS: __webpack_require__(1644),
  Lambda: __webpack_require__(1647),
  LexRuntime: __webpack_require__(1653),
  MachineLearning: __webpack_require__(1656),
  MarketplaceCommerceAnalytics: __webpack_require__(1661),
  MTurk: __webpack_require__(1664),
  MobileAnalytics: __webpack_require__(1667),
  OpsWorks: __webpack_require__(1669),
  Polly: __webpack_require__(1673),
  RDS: __webpack_require__(1678),
  Redshift: __webpack_require__(1693),
  Rekognition: __webpack_require__(1697),
  Route53: __webpack_require__(1700),
  Route53Domains: __webpack_require__(1705),
  S3: __webpack_require__(1708),
  ServiceCatalog: __webpack_require__(1714),
  SES: __webpack_require__(1717),
  SNS: __webpack_require__(1721),
  SQS: __webpack_require__(1724),
  SSM: __webpack_require__(1728),
  StorageGateway: __webpack_require__(1731),
  STS: __webpack_require__(258),
  WAF: __webpack_require__(1734),
  WorkDocs: __webpack_require__(1737)
};

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['acm'] = {};
AWS.ACM = Service.defineService('acm', ['2015-12-08']);
Object.defineProperty(apiLoader.services['acm'], '2015-12-08', {
  get: function get() {
    var model = __webpack_require__(1505);
    model.paginators = __webpack_require__(1506).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ACM;


/***/ }),
/* 1505 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-12-08",
		"endpointPrefix": "acm",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "ACM",
		"serviceFullName": "AWS Certificate Manager",
		"signatureVersion": "v4",
		"targetPrefix": "CertificateManager",
		"uid": "acm-2015-12-08"
	},
	"operations": {
		"AddTagsToCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn",
					"Tags"
				],
				"members": {
					"CertificateArn": {},
					"Tags": {
						"shape": "S3"
					}
				}
			}
		},
		"DeleteCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn"
				],
				"members": {
					"CertificateArn": {}
				}
			}
		},
		"DescribeCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn"
				],
				"members": {
					"CertificateArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Certificate": {
						"type": "structure",
						"members": {
							"CertificateArn": {},
							"DomainName": {},
							"SubjectAlternativeNames": {
								"shape": "Sc"
							},
							"DomainValidationOptions": {
								"shape": "Sd"
							},
							"Serial": {},
							"Subject": {},
							"Issuer": {},
							"CreatedAt": {
								"type": "timestamp"
							},
							"IssuedAt": {
								"type": "timestamp"
							},
							"ImportedAt": {
								"type": "timestamp"
							},
							"Status": {},
							"RevokedAt": {
								"type": "timestamp"
							},
							"RevocationReason": {},
							"NotBefore": {
								"type": "timestamp"
							},
							"NotAfter": {
								"type": "timestamp"
							},
							"KeyAlgorithm": {},
							"SignatureAlgorithm": {},
							"InUseBy": {
								"type": "list",
								"member": {}
							},
							"FailureReason": {},
							"Type": {},
							"RenewalSummary": {
								"type": "structure",
								"required": [
									"RenewalStatus",
									"DomainValidationOptions"
								],
								"members": {
									"RenewalStatus": {},
									"DomainValidationOptions": {
										"shape": "Sd"
									}
								}
							}
						}
					}
				}
			}
		},
		"GetCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn"
				],
				"members": {
					"CertificateArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Certificate": {},
					"CertificateChain": {}
				}
			}
		},
		"ImportCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"Certificate",
					"PrivateKey"
				],
				"members": {
					"CertificateArn": {},
					"Certificate": {
						"type": "blob"
					},
					"PrivateKey": {
						"type": "blob",
						"sensitive": true
					},
					"CertificateChain": {
						"type": "blob"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CertificateArn": {}
				}
			}
		},
		"ListCertificates": {
			"input": {
				"type": "structure",
				"members": {
					"CertificateStatuses": {
						"type": "list",
						"member": {}
					},
					"NextToken": {},
					"MaxItems": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"CertificateSummaryList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"CertificateArn": {},
								"DomainName": {}
							}
						}
					}
				}
			}
		},
		"ListTagsForCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn"
				],
				"members": {
					"CertificateArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Tags": {
						"shape": "S3"
					}
				}
			}
		},
		"RemoveTagsFromCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn",
					"Tags"
				],
				"members": {
					"CertificateArn": {},
					"Tags": {
						"shape": "S3"
					}
				}
			}
		},
		"RequestCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {},
					"SubjectAlternativeNames": {
						"shape": "Sc"
					},
					"IdempotencyToken": {},
					"DomainValidationOptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"DomainName",
								"ValidationDomain"
							],
							"members": {
								"DomainName": {},
								"ValidationDomain": {}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CertificateArn": {}
				}
			}
		},
		"ResendValidationEmail": {
			"input": {
				"type": "structure",
				"required": [
					"CertificateArn",
					"Domain",
					"ValidationDomain"
				],
				"members": {
					"CertificateArn": {},
					"Domain": {},
					"ValidationDomain": {}
				}
			}
		}
	},
	"shapes": {
		"S3": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Sc": {
			"type": "list",
			"member": {}
		},
		"Sd": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {},
					"ValidationEmails": {
						"type": "list",
						"member": {}
					},
					"ValidationDomain": {},
					"ValidationStatus": {}
				}
			}
		}
	}
};

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListCertificates": {
			"input_token": "NextToken",
			"limit_key": "MaxItems",
			"output_token": "NextToken",
			"result_key": "CertificateSummaryList"
		}
	}
};

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['apigateway'] = {};
AWS.APIGateway = Service.defineService('apigateway', ['2015-07-09']);
__webpack_require__(1508);
Object.defineProperty(apiLoader.services['apigateway'], '2015-07-09', {
  get: function get() {
    var model = __webpack_require__(1509);
    model.paginators = __webpack_require__(1510).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.APIGateway;


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

AWS.util.update(AWS.APIGateway.prototype, {
/**
 * Sets the Accept header to application/json.
 *
 * @api private
 */
  setAcceptHeader: function setAcceptHeader(req) {
    var httpRequest = req.httpRequest;
    if (!httpRequest.headers.Accept) {
      httpRequest.headers['Accept'] = 'application/json';
    }
  },

  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('build', this.setAcceptHeader);
    if (request.operation === 'getExport') {
      var params = request.params || {};
      if (params.exportType === 'swagger') {
        request.addListener('extractData', AWS.util.convertPayloadToString);
      }
    }
  }
});



/***/ }),
/* 1509 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-07-09",
		"endpointPrefix": "apigateway",
		"protocol": "rest-json",
		"serviceFullName": "Amazon API Gateway",
		"signatureVersion": "v4",
		"uid": "apigateway-2015-07-09"
	},
	"operations": {
		"CreateApiKey": {
			"http": {
				"requestUri": "/apikeys",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"members": {
					"name": {},
					"description": {},
					"enabled": {
						"type": "boolean"
					},
					"generateDistinctId": {
						"type": "boolean"
					},
					"value": {},
					"stageKeys": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"restApiId": {},
								"stageName": {}
							}
						}
					},
					"customerId": {}
				}
			},
			"output": {
				"shape": "S6"
			}
		},
		"CreateAuthorizer": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/authorizers",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"name",
					"type",
					"identitySource"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"name": {},
					"type": {},
					"providerARNs": {
						"shape": "Sb"
					},
					"authType": {},
					"authorizerUri": {},
					"authorizerCredentials": {},
					"identitySource": {},
					"identityValidationExpression": {},
					"authorizerResultTtlInSeconds": {
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "Se"
			}
		},
		"CreateBasePathMapping": {
			"http": {
				"requestUri": "/domainnames/{domain_name}/basepathmappings",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName",
					"restApiId"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"basePath": {},
					"restApiId": {},
					"stage": {}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"CreateDeployment": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/deployments",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {},
					"stageDescription": {},
					"description": {},
					"cacheClusterEnabled": {
						"type": "boolean"
					},
					"cacheClusterSize": {},
					"variables": {
						"shape": "Sk"
					}
				}
			},
			"output": {
				"shape": "Sl"
			}
		},
		"CreateDocumentationPart": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/documentation/parts",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"location",
					"properties"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"location": {
						"shape": "Sq"
					},
					"properties": {}
				}
			},
			"output": {
				"shape": "St"
			}
		},
		"CreateDocumentationVersion": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/documentation/versions",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationVersion"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationVersion": {},
					"stageName": {},
					"description": {}
				}
			},
			"output": {
				"shape": "Sv"
			}
		},
		"CreateDomainName": {
			"http": {
				"requestUri": "/domainnames",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName"
				],
				"members": {
					"domainName": {},
					"certificateName": {},
					"certificateBody": {},
					"certificatePrivateKey": {},
					"certificateChain": {},
					"certificateArn": {}
				}
			},
			"output": {
				"shape": "Sx"
			}
		},
		"CreateModel": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/models",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"name",
					"contentType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"name": {},
					"description": {},
					"schema": {},
					"contentType": {}
				}
			},
			"output": {
				"shape": "Sz"
			}
		},
		"CreateRequestValidator": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/requestvalidators",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"name": {},
					"validateRequestBody": {
						"type": "boolean"
					},
					"validateRequestParameters": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S11"
			}
		},
		"CreateResource": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/resources/{parent_id}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"parentId",
					"pathPart"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"parentId": {
						"location": "uri",
						"locationName": "parent_id"
					},
					"pathPart": {}
				}
			},
			"output": {
				"shape": "S13"
			}
		},
		"CreateRestApi": {
			"http": {
				"requestUri": "/restapis",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {},
					"description": {},
					"version": {},
					"cloneFrom": {},
					"binaryMediaTypes": {
						"shape": "S8"
					}
				}
			},
			"output": {
				"shape": "S1g"
			}
		},
		"CreateStage": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/stages",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName",
					"deploymentId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {},
					"deploymentId": {},
					"description": {},
					"cacheClusterEnabled": {
						"type": "boolean"
					},
					"cacheClusterSize": {},
					"variables": {
						"shape": "Sk"
					},
					"documentationVersion": {}
				}
			},
			"output": {
				"shape": "S1i"
			}
		},
		"CreateUsagePlan": {
			"http": {
				"requestUri": "/usageplans",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {},
					"description": {},
					"apiStages": {
						"shape": "S1q"
					},
					"throttle": {
						"shape": "S1s"
					},
					"quota": {
						"shape": "S1t"
					}
				}
			},
			"output": {
				"shape": "S1v"
			}
		},
		"CreateUsagePlanKey": {
			"http": {
				"requestUri": "/usageplans/{usageplanId}/keys",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId",
					"keyId",
					"keyType"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"keyId": {},
					"keyType": {}
				}
			},
			"output": {
				"shape": "S1x"
			}
		},
		"DeleteApiKey": {
			"http": {
				"method": "DELETE",
				"requestUri": "/apikeys/{api_Key}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"apiKey"
				],
				"members": {
					"apiKey": {
						"location": "uri",
						"locationName": "api_Key"
					}
				}
			}
		},
		"DeleteAuthorizer": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"authorizerId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"authorizerId": {
						"location": "uri",
						"locationName": "authorizer_id"
					}
				}
			}
		},
		"DeleteBasePathMapping": {
			"http": {
				"method": "DELETE",
				"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName",
					"basePath"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"basePath": {
						"location": "uri",
						"locationName": "base_path"
					}
				}
			}
		},
		"DeleteClientCertificate": {
			"http": {
				"method": "DELETE",
				"requestUri": "/clientcertificates/{clientcertificate_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"clientCertificateId"
				],
				"members": {
					"clientCertificateId": {
						"location": "uri",
						"locationName": "clientcertificate_id"
					}
				}
			}
		},
		"DeleteDeployment": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"deploymentId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"deploymentId": {
						"location": "uri",
						"locationName": "deployment_id"
					}
				}
			}
		},
		"DeleteDocumentationPart": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationPartId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationPartId": {
						"location": "uri",
						"locationName": "part_id"
					}
				}
			}
		},
		"DeleteDocumentationVersion": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationVersion"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationVersion": {
						"location": "uri",
						"locationName": "doc_version"
					}
				}
			}
		},
		"DeleteDomainName": {
			"http": {
				"method": "DELETE",
				"requestUri": "/domainnames/{domain_name}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					}
				}
			}
		},
		"DeleteGatewayResponse": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"responseType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"responseType": {
						"location": "uri",
						"locationName": "response_type"
					}
				}
			}
		},
		"DeleteIntegration": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					}
				}
			}
		},
		"DeleteIntegrationResponse": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					}
				}
			}
		},
		"DeleteMethod": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					}
				}
			}
		},
		"DeleteMethodResponse": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					}
				}
			}
		},
		"DeleteModel": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/models/{model_name}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"modelName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"modelName": {
						"location": "uri",
						"locationName": "model_name"
					}
				}
			}
		},
		"DeleteRequestValidator": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"requestValidatorId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"requestValidatorId": {
						"location": "uri",
						"locationName": "requestvalidator_id"
					}
				}
			}
		},
		"DeleteResource": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					}
				}
			}
		},
		"DeleteRestApi": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					}
				}
			}
		},
		"DeleteStage": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					}
				}
			}
		},
		"DeleteUsagePlan": {
			"http": {
				"method": "DELETE",
				"requestUri": "/usageplans/{usageplanId}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					}
				}
			}
		},
		"DeleteUsagePlanKey": {
			"http": {
				"method": "DELETE",
				"requestUri": "/usageplans/{usageplanId}/keys/{keyId}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId",
					"keyId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"keyId": {
						"location": "uri",
						"locationName": "keyId"
					}
				}
			}
		},
		"FlushStageAuthorizersCache": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					}
				}
			}
		},
		"FlushStageCache": {
			"http": {
				"method": "DELETE",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/cache/data",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					}
				}
			}
		},
		"GenerateClientCertificate": {
			"http": {
				"requestUri": "/clientcertificates",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"members": {
					"description": {}
				}
			},
			"output": {
				"shape": "S2m"
			}
		},
		"GetAccount": {
			"http": {
				"method": "GET",
				"requestUri": "/account"
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"shape": "S2o"
			}
		},
		"GetApiKey": {
			"http": {
				"method": "GET",
				"requestUri": "/apikeys/{api_Key}"
			},
			"input": {
				"type": "structure",
				"required": [
					"apiKey"
				],
				"members": {
					"apiKey": {
						"location": "uri",
						"locationName": "api_Key"
					},
					"includeValue": {
						"location": "querystring",
						"locationName": "includeValue",
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S6"
			}
		},
		"GetApiKeys": {
			"http": {
				"method": "GET",
				"requestUri": "/apikeys"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"nameQuery": {
						"location": "querystring",
						"locationName": "name"
					},
					"customerId": {
						"location": "querystring",
						"locationName": "customerId"
					},
					"includeValues": {
						"location": "querystring",
						"locationName": "includeValues",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"warnings": {
						"shape": "S8"
					},
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S6"
						}
					}
				}
			}
		},
		"GetAuthorizer": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"authorizerId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"authorizerId": {
						"location": "uri",
						"locationName": "authorizer_id"
					}
				}
			},
			"output": {
				"shape": "Se"
			}
		},
		"GetAuthorizers": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/authorizers"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Se"
						}
					}
				}
			}
		},
		"GetBasePathMapping": {
			"http": {
				"method": "GET",
				"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}"
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName",
					"basePath"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"basePath": {
						"location": "uri",
						"locationName": "base_path"
					}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"GetBasePathMappings": {
			"http": {
				"method": "GET",
				"requestUri": "/domainnames/{domain_name}/basepathmappings"
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Sg"
						}
					}
				}
			}
		},
		"GetClientCertificate": {
			"http": {
				"method": "GET",
				"requestUri": "/clientcertificates/{clientcertificate_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"clientCertificateId"
				],
				"members": {
					"clientCertificateId": {
						"location": "uri",
						"locationName": "clientcertificate_id"
					}
				}
			},
			"output": {
				"shape": "S2m"
			}
		},
		"GetClientCertificates": {
			"http": {
				"method": "GET",
				"requestUri": "/clientcertificates"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S2m"
						}
					}
				}
			}
		},
		"GetDeployment": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"deploymentId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"deploymentId": {
						"location": "uri",
						"locationName": "deployment_id"
					},
					"embed": {
						"shape": "S8",
						"location": "querystring",
						"locationName": "embed"
					}
				}
			},
			"output": {
				"shape": "Sl"
			}
		},
		"GetDeployments": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/deployments"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Sl"
						}
					}
				}
			}
		},
		"GetDocumentationPart": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationPartId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationPartId": {
						"location": "uri",
						"locationName": "part_id"
					}
				}
			},
			"output": {
				"shape": "St"
			}
		},
		"GetDocumentationParts": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/documentation/parts"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"type": {
						"location": "querystring",
						"locationName": "type"
					},
					"nameQuery": {
						"location": "querystring",
						"locationName": "name"
					},
					"path": {
						"location": "querystring",
						"locationName": "path"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "St"
						}
					}
				}
			}
		},
		"GetDocumentationVersion": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationVersion"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationVersion": {
						"location": "uri",
						"locationName": "doc_version"
					}
				}
			},
			"output": {
				"shape": "Sv"
			}
		},
		"GetDocumentationVersions": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/documentation/versions"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Sv"
						}
					}
				}
			}
		},
		"GetDomainName": {
			"http": {
				"method": "GET",
				"requestUri": "/domainnames/{domain_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					}
				}
			},
			"output": {
				"shape": "Sx"
			}
		},
		"GetDomainNames": {
			"http": {
				"method": "GET",
				"requestUri": "/domainnames"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Sx"
						}
					}
				}
			}
		},
		"GetExport": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName",
					"exportType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					},
					"exportType": {
						"location": "uri",
						"locationName": "export_type"
					},
					"parameters": {
						"shape": "Sk",
						"location": "querystring"
					},
					"accepts": {
						"location": "header",
						"locationName": "Accept"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"contentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"contentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"body": {
						"type": "blob"
					}
				},
				"payload": "body"
			}
		},
		"GetGatewayResponse": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"responseType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"responseType": {
						"location": "uri",
						"locationName": "response_type"
					}
				}
			},
			"output": {
				"shape": "S3p"
			}
		},
		"GetGatewayResponses": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/gatewayresponses"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S3p"
						}
					}
				}
			}
		},
		"GetIntegration": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					}
				}
			},
			"output": {
				"shape": "S1a"
			}
		},
		"GetIntegrationResponse": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					}
				}
			},
			"output": {
				"shape": "S1e"
			}
		},
		"GetMethod": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					}
				}
			},
			"output": {
				"shape": "S15"
			}
		},
		"GetMethodResponse": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					}
				}
			},
			"output": {
				"shape": "S18"
			}
		},
		"GetModel": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/models/{model_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"modelName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"modelName": {
						"location": "uri",
						"locationName": "model_name"
					},
					"flatten": {
						"location": "querystring",
						"locationName": "flatten",
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "Sz"
			}
		},
		"GetModelTemplate": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/models/{model_name}/default_template"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"modelName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"modelName": {
						"location": "uri",
						"locationName": "model_name"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"value": {}
				}
			}
		},
		"GetModels": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/models"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "Sz"
						}
					}
				}
			}
		},
		"GetRequestValidator": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"requestValidatorId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"requestValidatorId": {
						"location": "uri",
						"locationName": "requestvalidator_id"
					}
				}
			},
			"output": {
				"shape": "S11"
			}
		},
		"GetRequestValidators": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/requestvalidators"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S11"
						}
					}
				}
			}
		},
		"GetResource": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"embed": {
						"shape": "S8",
						"location": "querystring",
						"locationName": "embed"
					}
				}
			},
			"output": {
				"shape": "S13"
			}
		},
		"GetResources": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/resources"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"embed": {
						"shape": "S8",
						"location": "querystring",
						"locationName": "embed"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S13"
						}
					}
				}
			}
		},
		"GetRestApi": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					}
				}
			},
			"output": {
				"shape": "S1g"
			}
		},
		"GetRestApis": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S1g"
						}
					}
				}
			}
		},
		"GetSdk": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName",
					"sdkType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					},
					"sdkType": {
						"location": "uri",
						"locationName": "sdk_type"
					},
					"parameters": {
						"shape": "Sk",
						"location": "querystring"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"contentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"contentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"body": {
						"type": "blob"
					}
				},
				"payload": "body"
			}
		},
		"GetSdkType": {
			"http": {
				"method": "GET",
				"requestUri": "/sdktypes/{sdktype_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"id"
				],
				"members": {
					"id": {
						"location": "uri",
						"locationName": "sdktype_id"
					}
				}
			},
			"output": {
				"shape": "S4i"
			}
		},
		"GetSdkTypes": {
			"http": {
				"method": "GET",
				"requestUri": "/sdktypes"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S4i"
						}
					}
				}
			}
		},
		"GetStage": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					}
				}
			},
			"output": {
				"shape": "S1i"
			}
		},
		"GetStages": {
			"http": {
				"method": "GET",
				"requestUri": "/restapis/{restapi_id}/stages"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"deploymentId": {
						"location": "querystring",
						"locationName": "deploymentId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"item": {
						"type": "list",
						"member": {
							"shape": "S1i"
						}
					}
				}
			}
		},
		"GetUsage": {
			"http": {
				"method": "GET",
				"requestUri": "/usageplans/{usageplanId}/usage"
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId",
					"startDate",
					"endDate"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"keyId": {
						"location": "querystring",
						"locationName": "keyId"
					},
					"startDate": {
						"location": "querystring",
						"locationName": "startDate"
					},
					"endDate": {
						"location": "querystring",
						"locationName": "endDate"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "S4t"
			}
		},
		"GetUsagePlan": {
			"http": {
				"method": "GET",
				"requestUri": "/usageplans/{usageplanId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					}
				}
			},
			"output": {
				"shape": "S1v"
			}
		},
		"GetUsagePlanKey": {
			"http": {
				"method": "GET",
				"requestUri": "/usageplans/{usageplanId}/keys/{keyId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId",
					"keyId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"keyId": {
						"location": "uri",
						"locationName": "keyId"
					}
				}
			},
			"output": {
				"shape": "S1x"
			}
		},
		"GetUsagePlanKeys": {
			"http": {
				"method": "GET",
				"requestUri": "/usageplans/{usageplanId}/keys"
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"nameQuery": {
						"location": "querystring",
						"locationName": "name"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S1x"
						}
					}
				}
			}
		},
		"GetUsagePlans": {
			"http": {
				"method": "GET",
				"requestUri": "/usageplans"
			},
			"input": {
				"type": "structure",
				"members": {
					"position": {
						"location": "querystring",
						"locationName": "position"
					},
					"keyId": {
						"location": "querystring",
						"locationName": "keyId"
					},
					"limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"position": {},
					"items": {
						"locationName": "item",
						"type": "list",
						"member": {
							"shape": "S1v"
						}
					}
				}
			}
		},
		"ImportApiKeys": {
			"http": {
				"requestUri": "/apikeys?mode=import",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"body",
					"format"
				],
				"members": {
					"body": {
						"type": "blob"
					},
					"format": {
						"location": "querystring",
						"locationName": "format"
					},
					"failOnWarnings": {
						"location": "querystring",
						"locationName": "failonwarnings",
						"type": "boolean"
					}
				},
				"payload": "body"
			},
			"output": {
				"type": "structure",
				"members": {
					"ids": {
						"shape": "S8"
					},
					"warnings": {
						"shape": "S8"
					}
				}
			}
		},
		"ImportDocumentationParts": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/documentation/parts"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"body"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"mode": {
						"location": "querystring",
						"locationName": "mode"
					},
					"failOnWarnings": {
						"location": "querystring",
						"locationName": "failonwarnings",
						"type": "boolean"
					},
					"body": {
						"type": "blob"
					}
				},
				"payload": "body"
			},
			"output": {
				"type": "structure",
				"members": {
					"ids": {
						"shape": "S8"
					},
					"warnings": {
						"shape": "S8"
					}
				}
			}
		},
		"ImportRestApi": {
			"http": {
				"requestUri": "/restapis?mode=import",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"body"
				],
				"members": {
					"failOnWarnings": {
						"location": "querystring",
						"locationName": "failonwarnings",
						"type": "boolean"
					},
					"parameters": {
						"shape": "Sk",
						"location": "querystring"
					},
					"body": {
						"type": "blob"
					}
				},
				"payload": "body"
			},
			"output": {
				"shape": "S1g"
			}
		},
		"PutGatewayResponse": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"responseType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"responseType": {
						"location": "uri",
						"locationName": "response_type"
					},
					"statusCode": {},
					"responseParameters": {
						"shape": "Sk"
					},
					"responseTemplates": {
						"shape": "Sk"
					}
				}
			},
			"output": {
				"shape": "S3p"
			}
		},
		"PutIntegration": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"type"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"type": {},
					"integrationHttpMethod": {
						"locationName": "httpMethod"
					},
					"uri": {},
					"credentials": {},
					"requestParameters": {
						"shape": "Sk"
					},
					"requestTemplates": {
						"shape": "Sk"
					},
					"passthroughBehavior": {},
					"cacheNamespace": {},
					"cacheKeyParameters": {
						"shape": "S8"
					},
					"contentHandling": {}
				}
			},
			"output": {
				"shape": "S1a"
			}
		},
		"PutIntegrationResponse": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					},
					"selectionPattern": {},
					"responseParameters": {
						"shape": "Sk"
					},
					"responseTemplates": {
						"shape": "Sk"
					},
					"contentHandling": {}
				}
			},
			"output": {
				"shape": "S1e"
			}
		},
		"PutMethod": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"authorizationType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"authorizationType": {},
					"authorizerId": {},
					"apiKeyRequired": {
						"type": "boolean"
					},
					"operationName": {},
					"requestParameters": {
						"shape": "S16"
					},
					"requestModels": {
						"shape": "Sk"
					},
					"requestValidatorId": {}
				}
			},
			"output": {
				"shape": "S15"
			}
		},
		"PutMethodResponse": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					},
					"responseParameters": {
						"shape": "S16"
					},
					"responseModels": {
						"shape": "Sk"
					}
				}
			},
			"output": {
				"shape": "S18"
			}
		},
		"PutRestApi": {
			"http": {
				"method": "PUT",
				"requestUri": "/restapis/{restapi_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"body"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"mode": {
						"location": "querystring",
						"locationName": "mode"
					},
					"failOnWarnings": {
						"location": "querystring",
						"locationName": "failonwarnings",
						"type": "boolean"
					},
					"parameters": {
						"shape": "Sk",
						"location": "querystring"
					},
					"body": {
						"type": "blob"
					}
				},
				"payload": "body"
			},
			"output": {
				"shape": "S1g"
			}
		},
		"TestInvokeAuthorizer": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"authorizerId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"authorizerId": {
						"location": "uri",
						"locationName": "authorizer_id"
					},
					"headers": {
						"shape": "S5k"
					},
					"pathWithQueryString": {},
					"body": {},
					"stageVariables": {
						"shape": "Sk"
					},
					"additionalContext": {
						"shape": "Sk"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"clientStatus": {
						"type": "integer"
					},
					"log": {},
					"latency": {
						"type": "long"
					},
					"principalId": {},
					"policy": {},
					"authorization": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S8"
						}
					},
					"claims": {
						"shape": "Sk"
					}
				}
			}
		},
		"TestInvokeMethod": {
			"http": {
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"pathWithQueryString": {},
					"body": {},
					"headers": {
						"shape": "S5k"
					},
					"clientCertificateId": {},
					"stageVariables": {
						"shape": "Sk"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"status": {
						"type": "integer"
					},
					"body": {},
					"headers": {
						"shape": "S5k"
					},
					"log": {},
					"latency": {
						"type": "long"
					}
				}
			}
		},
		"UpdateAccount": {
			"http": {
				"method": "PATCH",
				"requestUri": "/account"
			},
			"input": {
				"type": "structure",
				"members": {
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S2o"
			}
		},
		"UpdateApiKey": {
			"http": {
				"method": "PATCH",
				"requestUri": "/apikeys/{api_Key}"
			},
			"input": {
				"type": "structure",
				"required": [
					"apiKey"
				],
				"members": {
					"apiKey": {
						"location": "uri",
						"locationName": "api_Key"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S6"
			}
		},
		"UpdateAuthorizer": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"authorizerId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"authorizerId": {
						"location": "uri",
						"locationName": "authorizer_id"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "Se"
			}
		},
		"UpdateBasePathMapping": {
			"http": {
				"method": "PATCH",
				"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}"
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName",
					"basePath"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"basePath": {
						"location": "uri",
						"locationName": "base_path"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"UpdateClientCertificate": {
			"http": {
				"method": "PATCH",
				"requestUri": "/clientcertificates/{clientcertificate_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"clientCertificateId"
				],
				"members": {
					"clientCertificateId": {
						"location": "uri",
						"locationName": "clientcertificate_id"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S2m"
			}
		},
		"UpdateDeployment": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"deploymentId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"deploymentId": {
						"location": "uri",
						"locationName": "deployment_id"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "Sl"
			}
		},
		"UpdateDocumentationPart": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationPartId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationPartId": {
						"location": "uri",
						"locationName": "part_id"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "St"
			}
		},
		"UpdateDocumentationVersion": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"documentationVersion"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"documentationVersion": {
						"location": "uri",
						"locationName": "doc_version"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "Sv"
			}
		},
		"UpdateDomainName": {
			"http": {
				"method": "PATCH",
				"requestUri": "/domainnames/{domain_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"domainName"
				],
				"members": {
					"domainName": {
						"location": "uri",
						"locationName": "domain_name"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "Sx"
			}
		},
		"UpdateGatewayResponse": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"responseType"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"responseType": {
						"location": "uri",
						"locationName": "response_type"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S3p"
			}
		},
		"UpdateIntegration": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S1a"
			}
		},
		"UpdateIntegrationResponse": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S1e"
			}
		},
		"UpdateMethod": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S15"
			}
		},
		"UpdateMethodResponse": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId",
					"httpMethod",
					"statusCode"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"httpMethod": {
						"location": "uri",
						"locationName": "http_method"
					},
					"statusCode": {
						"location": "uri",
						"locationName": "status_code"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S18"
			}
		},
		"UpdateModel": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/models/{model_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"modelName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"modelName": {
						"location": "uri",
						"locationName": "model_name"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "Sz"
			}
		},
		"UpdateRequestValidator": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"requestValidatorId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"requestValidatorId": {
						"location": "uri",
						"locationName": "requestvalidator_id"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S11"
			}
		},
		"UpdateResource": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/resources/{resource_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"resourceId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"resourceId": {
						"location": "uri",
						"locationName": "resource_id"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S13"
			}
		},
		"UpdateRestApi": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S1g"
			}
		},
		"UpdateStage": {
			"http": {
				"method": "PATCH",
				"requestUri": "/restapis/{restapi_id}/stages/{stage_name}"
			},
			"input": {
				"type": "structure",
				"required": [
					"restApiId",
					"stageName"
				],
				"members": {
					"restApiId": {
						"location": "uri",
						"locationName": "restapi_id"
					},
					"stageName": {
						"location": "uri",
						"locationName": "stage_name"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S1i"
			}
		},
		"UpdateUsage": {
			"http": {
				"method": "PATCH",
				"requestUri": "/usageplans/{usageplanId}/keys/{keyId}/usage"
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId",
					"keyId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"keyId": {
						"location": "uri",
						"locationName": "keyId"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S4t"
			}
		},
		"UpdateUsagePlan": {
			"http": {
				"method": "PATCH",
				"requestUri": "/usageplans/{usageplanId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"usagePlanId"
				],
				"members": {
					"usagePlanId": {
						"location": "uri",
						"locationName": "usageplanId"
					},
					"patchOperations": {
						"shape": "S5q"
					}
				}
			},
			"output": {
				"shape": "S1v"
			}
		}
	},
	"shapes": {
		"S6": {
			"type": "structure",
			"members": {
				"id": {},
				"value": {},
				"name": {},
				"customerId": {},
				"description": {},
				"enabled": {
					"type": "boolean"
				},
				"createdDate": {
					"type": "timestamp"
				},
				"lastUpdatedDate": {
					"type": "timestamp"
				},
				"stageKeys": {
					"shape": "S8"
				}
			}
		},
		"S8": {
			"type": "list",
			"member": {}
		},
		"Sb": {
			"type": "list",
			"member": {}
		},
		"Se": {
			"type": "structure",
			"members": {
				"id": {},
				"name": {},
				"type": {},
				"providerARNs": {
					"shape": "Sb"
				},
				"authType": {},
				"authorizerUri": {},
				"authorizerCredentials": {},
				"identitySource": {},
				"identityValidationExpression": {},
				"authorizerResultTtlInSeconds": {
					"type": "integer"
				}
			}
		},
		"Sg": {
			"type": "structure",
			"members": {
				"basePath": {},
				"restApiId": {},
				"stage": {}
			}
		},
		"Sk": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"Sl": {
			"type": "structure",
			"members": {
				"id": {},
				"description": {},
				"createdDate": {
					"type": "timestamp"
				},
				"apiSummary": {
					"type": "map",
					"key": {},
					"value": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"authorizationType": {},
								"apiKeyRequired": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		},
		"Sq": {
			"type": "structure",
			"required": [
				"type"
			],
			"members": {
				"type": {},
				"path": {},
				"method": {},
				"statusCode": {},
				"name": {}
			}
		},
		"St": {
			"type": "structure",
			"members": {
				"id": {},
				"location": {
					"shape": "Sq"
				},
				"properties": {}
			}
		},
		"Sv": {
			"type": "structure",
			"members": {
				"version": {},
				"createdDate": {
					"type": "timestamp"
				},
				"description": {}
			}
		},
		"Sx": {
			"type": "structure",
			"members": {
				"domainName": {},
				"certificateName": {},
				"certificateArn": {},
				"certificateUploadDate": {
					"type": "timestamp"
				},
				"distributionDomainName": {}
			}
		},
		"Sz": {
			"type": "structure",
			"members": {
				"id": {},
				"name": {},
				"description": {},
				"schema": {},
				"contentType": {}
			}
		},
		"S11": {
			"type": "structure",
			"members": {
				"id": {},
				"name": {},
				"validateRequestBody": {
					"type": "boolean"
				},
				"validateRequestParameters": {
					"type": "boolean"
				}
			}
		},
		"S13": {
			"type": "structure",
			"members": {
				"id": {},
				"parentId": {},
				"pathPart": {},
				"path": {},
				"resourceMethods": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S15"
					}
				}
			}
		},
		"S15": {
			"type": "structure",
			"members": {
				"httpMethod": {},
				"authorizationType": {},
				"authorizerId": {},
				"apiKeyRequired": {
					"type": "boolean"
				},
				"requestValidatorId": {},
				"operationName": {},
				"requestParameters": {
					"shape": "S16"
				},
				"requestModels": {
					"shape": "Sk"
				},
				"methodResponses": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S18"
					}
				},
				"methodIntegration": {
					"shape": "S1a"
				}
			}
		},
		"S16": {
			"type": "map",
			"key": {},
			"value": {
				"type": "boolean"
			}
		},
		"S18": {
			"type": "structure",
			"members": {
				"statusCode": {},
				"responseParameters": {
					"shape": "S16"
				},
				"responseModels": {
					"shape": "Sk"
				}
			}
		},
		"S1a": {
			"type": "structure",
			"members": {
				"type": {},
				"httpMethod": {},
				"uri": {},
				"credentials": {},
				"requestParameters": {
					"shape": "Sk"
				},
				"requestTemplates": {
					"shape": "Sk"
				},
				"passthroughBehavior": {},
				"contentHandling": {},
				"cacheNamespace": {},
				"cacheKeyParameters": {
					"shape": "S8"
				},
				"integrationResponses": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S1e"
					}
				}
			}
		},
		"S1e": {
			"type": "structure",
			"members": {
				"statusCode": {},
				"selectionPattern": {},
				"responseParameters": {
					"shape": "Sk"
				},
				"responseTemplates": {
					"shape": "Sk"
				},
				"contentHandling": {}
			}
		},
		"S1g": {
			"type": "structure",
			"members": {
				"id": {},
				"name": {},
				"description": {},
				"createdDate": {
					"type": "timestamp"
				},
				"version": {},
				"warnings": {
					"shape": "S8"
				},
				"binaryMediaTypes": {
					"shape": "S8"
				}
			}
		},
		"S1i": {
			"type": "structure",
			"members": {
				"deploymentId": {},
				"clientCertificateId": {},
				"stageName": {},
				"description": {},
				"cacheClusterEnabled": {
					"type": "boolean"
				},
				"cacheClusterSize": {},
				"cacheClusterStatus": {},
				"methodSettings": {
					"type": "map",
					"key": {},
					"value": {
						"type": "structure",
						"members": {
							"metricsEnabled": {
								"type": "boolean"
							},
							"loggingLevel": {},
							"dataTraceEnabled": {
								"type": "boolean"
							},
							"throttlingBurstLimit": {
								"type": "integer"
							},
							"throttlingRateLimit": {
								"type": "double"
							},
							"cachingEnabled": {
								"type": "boolean"
							},
							"cacheTtlInSeconds": {
								"type": "integer"
							},
							"cacheDataEncrypted": {
								"type": "boolean"
							},
							"requireAuthorizationForCacheControl": {
								"type": "boolean"
							},
							"unauthorizedCacheControlHeaderStrategy": {}
						}
					}
				},
				"variables": {
					"shape": "Sk"
				},
				"documentationVersion": {},
				"createdDate": {
					"type": "timestamp"
				},
				"lastUpdatedDate": {
					"type": "timestamp"
				}
			}
		},
		"S1q": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"apiId": {},
					"stage": {}
				}
			}
		},
		"S1s": {
			"type": "structure",
			"members": {
				"burstLimit": {
					"type": "integer"
				},
				"rateLimit": {
					"type": "double"
				}
			}
		},
		"S1t": {
			"type": "structure",
			"members": {
				"limit": {
					"type": "integer"
				},
				"offset": {
					"type": "integer"
				},
				"period": {}
			}
		},
		"S1v": {
			"type": "structure",
			"members": {
				"id": {},
				"name": {},
				"description": {},
				"apiStages": {
					"shape": "S1q"
				},
				"throttle": {
					"shape": "S1s"
				},
				"quota": {
					"shape": "S1t"
				},
				"productCode": {}
			}
		},
		"S1x": {
			"type": "structure",
			"members": {
				"id": {},
				"type": {},
				"value": {},
				"name": {}
			}
		},
		"S2m": {
			"type": "structure",
			"members": {
				"clientCertificateId": {},
				"description": {},
				"pemEncodedCertificate": {},
				"createdDate": {
					"type": "timestamp"
				},
				"expirationDate": {
					"type": "timestamp"
				}
			}
		},
		"S2o": {
			"type": "structure",
			"members": {
				"cloudwatchRoleArn": {},
				"throttleSettings": {
					"shape": "S1s"
				},
				"features": {
					"shape": "S8"
				},
				"apiKeyVersion": {}
			}
		},
		"S3p": {
			"type": "structure",
			"members": {
				"responseType": {},
				"statusCode": {},
				"responseParameters": {
					"shape": "Sk"
				},
				"responseTemplates": {
					"shape": "Sk"
				},
				"defaultResponse": {
					"type": "boolean"
				}
			}
		},
		"S4i": {
			"type": "structure",
			"members": {
				"id": {},
				"friendlyName": {},
				"description": {},
				"configurationProperties": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"name": {},
							"friendlyName": {},
							"description": {},
							"required": {
								"type": "boolean"
							},
							"defaultValue": {}
						}
					}
				}
			}
		},
		"S4t": {
			"type": "structure",
			"members": {
				"usagePlanId": {},
				"startDate": {},
				"endDate": {},
				"position": {},
				"items": {
					"locationName": "values",
					"type": "map",
					"key": {},
					"value": {
						"type": "list",
						"member": {
							"type": "list",
							"member": {
								"type": "long"
							}
						}
					}
				}
			}
		},
		"S5k": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S5q": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"op": {},
					"path": {},
					"value": {},
					"from": {}
				}
			}
		}
	}
};

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"GetApiKeys": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		},
		"GetBasePathMappings": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		},
		"GetClientCertificates": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		},
		"GetDeployments": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		},
		"GetDomainNames": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		},
		"GetModels": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		},
		"GetResources": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		},
		"GetRestApis": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		},
		"GetUsage": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		},
		"GetUsagePlanKeys": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		},
		"GetUsagePlans": {
			"input_token": "position",
			"limit_key": "limit",
			"output_token": "position",
			"result_key": "items"
		}
	}
};

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['applicationautoscaling'] = {};
AWS.ApplicationAutoScaling = Service.defineService('applicationautoscaling', ['2016-02-06']);
Object.defineProperty(apiLoader.services['applicationautoscaling'], '2016-02-06', {
  get: function get() {
    var model = __webpack_require__(1512);
    model.paginators = __webpack_require__(1513).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ApplicationAutoScaling;


/***/ }),
/* 1512 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-02-06",
		"endpointPrefix": "autoscaling",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Application Auto Scaling",
		"signatureVersion": "v4",
		"signingName": "application-autoscaling",
		"targetPrefix": "AnyScaleFrontendService",
		"uid": "application-autoscaling-2016-02-06"
	},
	"operations": {
		"DeleteScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"PolicyName",
					"ServiceNamespace",
					"ResourceId",
					"ScalableDimension"
				],
				"members": {
					"PolicyName": {},
					"ServiceNamespace": {},
					"ResourceId": {},
					"ScalableDimension": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeregisterScalableTarget": {
			"input": {
				"type": "structure",
				"required": [
					"ServiceNamespace",
					"ResourceId",
					"ScalableDimension"
				],
				"members": {
					"ServiceNamespace": {},
					"ResourceId": {},
					"ScalableDimension": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeScalableTargets": {
			"input": {
				"type": "structure",
				"required": [
					"ServiceNamespace"
				],
				"members": {
					"ServiceNamespace": {},
					"ResourceIds": {
						"shape": "S9"
					},
					"ScalableDimension": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ScalableTargets": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"ServiceNamespace",
								"ResourceId",
								"ScalableDimension",
								"MinCapacity",
								"MaxCapacity",
								"RoleARN",
								"CreationTime"
							],
							"members": {
								"ServiceNamespace": {},
								"ResourceId": {},
								"ScalableDimension": {},
								"MinCapacity": {
									"type": "integer"
								},
								"MaxCapacity": {
									"type": "integer"
								},
								"RoleARN": {},
								"CreationTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeScalingActivities": {
			"input": {
				"type": "structure",
				"required": [
					"ServiceNamespace"
				],
				"members": {
					"ServiceNamespace": {},
					"ResourceId": {},
					"ScalableDimension": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ScalingActivities": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"ActivityId",
								"ServiceNamespace",
								"ResourceId",
								"ScalableDimension",
								"Description",
								"Cause",
								"StartTime",
								"StatusCode"
							],
							"members": {
								"ActivityId": {},
								"ServiceNamespace": {},
								"ResourceId": {},
								"ScalableDimension": {},
								"Description": {},
								"Cause": {},
								"StartTime": {
									"type": "timestamp"
								},
								"EndTime": {
									"type": "timestamp"
								},
								"StatusCode": {},
								"StatusMessage": {},
								"Details": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeScalingPolicies": {
			"input": {
				"type": "structure",
				"required": [
					"ServiceNamespace"
				],
				"members": {
					"PolicyNames": {
						"shape": "S9"
					},
					"ServiceNamespace": {},
					"ResourceId": {},
					"ScalableDimension": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ScalingPolicies": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"PolicyARN",
								"PolicyName",
								"ServiceNamespace",
								"ResourceId",
								"ScalableDimension",
								"PolicyType",
								"CreationTime"
							],
							"members": {
								"PolicyARN": {},
								"PolicyName": {},
								"ServiceNamespace": {},
								"ResourceId": {},
								"ScalableDimension": {},
								"PolicyType": {},
								"StepScalingPolicyConfiguration": {
									"shape": "St"
								},
								"TargetTrackingScalingPolicyConfiguration": {
									"shape": "S12"
								},
								"Alarms": {
									"shape": "S1f"
								},
								"CreationTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"PutScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"PolicyName",
					"ServiceNamespace",
					"ResourceId",
					"ScalableDimension"
				],
				"members": {
					"PolicyName": {},
					"ServiceNamespace": {},
					"ResourceId": {},
					"ScalableDimension": {},
					"PolicyType": {},
					"StepScalingPolicyConfiguration": {
						"shape": "St"
					},
					"TargetTrackingScalingPolicyConfiguration": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"PolicyARN"
				],
				"members": {
					"PolicyARN": {},
					"Alarms": {
						"shape": "S1f"
					}
				}
			}
		},
		"RegisterScalableTarget": {
			"input": {
				"type": "structure",
				"required": [
					"ServiceNamespace",
					"ResourceId",
					"ScalableDimension"
				],
				"members": {
					"ServiceNamespace": {},
					"ResourceId": {},
					"ScalableDimension": {},
					"MinCapacity": {
						"type": "integer"
					},
					"MaxCapacity": {
						"type": "integer"
					},
					"RoleARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		}
	},
	"shapes": {
		"S9": {
			"type": "list",
			"member": {}
		},
		"St": {
			"type": "structure",
			"members": {
				"AdjustmentType": {},
				"StepAdjustments": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"ScalingAdjustment"
						],
						"members": {
							"MetricIntervalLowerBound": {
								"type": "double"
							},
							"MetricIntervalUpperBound": {
								"type": "double"
							},
							"ScalingAdjustment": {
								"type": "integer"
							}
						}
					}
				},
				"MinAdjustmentMagnitude": {
					"type": "integer"
				},
				"Cooldown": {
					"type": "integer"
				},
				"MetricAggregationType": {}
			}
		},
		"S12": {
			"type": "structure",
			"required": [
				"TargetValue"
			],
			"members": {
				"TargetValue": {
					"type": "double"
				},
				"PredefinedMetricSpecification": {
					"type": "structure",
					"required": [
						"PredefinedMetricType"
					],
					"members": {
						"PredefinedMetricType": {},
						"ResourceLabel": {}
					}
				},
				"CustomizedMetricSpecification": {
					"type": "structure",
					"required": [
						"MetricName",
						"Namespace",
						"Statistic"
					],
					"members": {
						"MetricName": {},
						"Namespace": {},
						"Dimensions": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Name",
									"Value"
								],
								"members": {
									"Name": {},
									"Value": {}
								}
							}
						},
						"Statistic": {},
						"Unit": {}
					}
				},
				"ScaleOutCooldown": {
					"type": "integer"
				},
				"ScaleInCooldown": {
					"type": "integer"
				}
			}
		},
		"S1f": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"AlarmName",
					"AlarmARN"
				],
				"members": {
					"AlarmName": {},
					"AlarmARN": {}
				}
			}
		}
	}
};

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeScalableTargets": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ScalableTargets"
		},
		"DescribeScalingActivities": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ScalingActivities"
		},
		"DescribeScalingPolicies": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ScalingPolicies"
		}
	}
};

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['autoscaling'] = {};
AWS.AutoScaling = Service.defineService('autoscaling', ['2011-01-01']);
Object.defineProperty(apiLoader.services['autoscaling'], '2011-01-01', {
  get: function get() {
    var model = __webpack_require__(1515);
    model.paginators = __webpack_require__(1516).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.AutoScaling;


/***/ }),
/* 1515 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2011-01-01",
		"endpointPrefix": "autoscaling",
		"protocol": "query",
		"serviceFullName": "Auto Scaling",
		"signatureVersion": "v4",
		"uid": "autoscaling-2011-01-01",
		"xmlNamespace": "http://autoscaling.amazonaws.com/doc/2011-01-01/"
	},
	"operations": {
		"AttachInstances": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName"
				],
				"members": {
					"InstanceIds": {
						"shape": "S2"
					},
					"AutoScalingGroupName": {}
				}
			}
		},
		"AttachLoadBalancerTargetGroups": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"TargetGroupARNs"
				],
				"members": {
					"AutoScalingGroupName": {},
					"TargetGroupARNs": {
						"shape": "S6"
					}
				}
			},
			"output": {
				"resultWrapper": "AttachLoadBalancerTargetGroupsResult",
				"type": "structure",
				"members": {}
			}
		},
		"AttachLoadBalancers": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"LoadBalancerNames"
				],
				"members": {
					"AutoScalingGroupName": {},
					"LoadBalancerNames": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "AttachLoadBalancersResult",
				"type": "structure",
				"members": {}
			}
		},
		"CompleteLifecycleAction": {
			"input": {
				"type": "structure",
				"required": [
					"LifecycleHookName",
					"AutoScalingGroupName",
					"LifecycleActionResult"
				],
				"members": {
					"LifecycleHookName": {},
					"AutoScalingGroupName": {},
					"LifecycleActionToken": {},
					"LifecycleActionResult": {},
					"InstanceId": {}
				}
			},
			"output": {
				"resultWrapper": "CompleteLifecycleActionResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateAutoScalingGroup": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"MinSize",
					"MaxSize"
				],
				"members": {
					"AutoScalingGroupName": {},
					"LaunchConfigurationName": {},
					"InstanceId": {},
					"MinSize": {
						"type": "integer"
					},
					"MaxSize": {
						"type": "integer"
					},
					"DesiredCapacity": {
						"type": "integer"
					},
					"DefaultCooldown": {
						"type": "integer"
					},
					"AvailabilityZones": {
						"shape": "Sn"
					},
					"LoadBalancerNames": {
						"shape": "Sa"
					},
					"TargetGroupARNs": {
						"shape": "S6"
					},
					"HealthCheckType": {},
					"HealthCheckGracePeriod": {
						"type": "integer"
					},
					"PlacementGroup": {},
					"VPCZoneIdentifier": {},
					"TerminationPolicies": {
						"shape": "Sr"
					},
					"NewInstancesProtectedFromScaleIn": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "Su"
					}
				}
			}
		},
		"CreateLaunchConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"LaunchConfigurationName"
				],
				"members": {
					"LaunchConfigurationName": {},
					"ImageId": {},
					"KeyName": {},
					"SecurityGroups": {
						"shape": "S11"
					},
					"ClassicLinkVPCId": {},
					"ClassicLinkVPCSecurityGroups": {
						"shape": "S12"
					},
					"UserData": {},
					"InstanceId": {},
					"InstanceType": {},
					"KernelId": {},
					"RamdiskId": {},
					"BlockDeviceMappings": {
						"shape": "S14"
					},
					"InstanceMonitoring": {
						"shape": "S1d"
					},
					"SpotPrice": {},
					"IamInstanceProfile": {},
					"EbsOptimized": {
						"type": "boolean"
					},
					"AssociatePublicIpAddress": {
						"type": "boolean"
					},
					"PlacementTenancy": {}
				}
			}
		},
		"CreateOrUpdateTags": {
			"input": {
				"type": "structure",
				"required": [
					"Tags"
				],
				"members": {
					"Tags": {
						"shape": "Su"
					}
				}
			}
		},
		"DeleteAutoScalingGroup": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"ForceDelete": {
						"type": "boolean"
					}
				}
			}
		},
		"DeleteLaunchConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"LaunchConfigurationName"
				],
				"members": {
					"LaunchConfigurationName": {}
				}
			}
		},
		"DeleteLifecycleHook": {
			"input": {
				"type": "structure",
				"required": [
					"LifecycleHookName",
					"AutoScalingGroupName"
				],
				"members": {
					"LifecycleHookName": {},
					"AutoScalingGroupName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteLifecycleHookResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteNotificationConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"TopicARN"
				],
				"members": {
					"AutoScalingGroupName": {},
					"TopicARN": {}
				}
			}
		},
		"DeletePolicy": {
			"input": {
				"type": "structure",
				"required": [
					"PolicyName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"PolicyName": {}
				}
			}
		},
		"DeleteScheduledAction": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"ScheduledActionName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"ScheduledActionName": {}
				}
			}
		},
		"DeleteTags": {
			"input": {
				"type": "structure",
				"required": [
					"Tags"
				],
				"members": {
					"Tags": {
						"shape": "Su"
					}
				}
			}
		},
		"DescribeAccountLimits": {
			"output": {
				"resultWrapper": "DescribeAccountLimitsResult",
				"type": "structure",
				"members": {
					"MaxNumberOfAutoScalingGroups": {
						"type": "integer"
					},
					"MaxNumberOfLaunchConfigurations": {
						"type": "integer"
					},
					"NumberOfAutoScalingGroups": {
						"type": "integer"
					},
					"NumberOfLaunchConfigurations": {
						"type": "integer"
					}
				}
			}
		},
		"DescribeAdjustmentTypes": {
			"output": {
				"resultWrapper": "DescribeAdjustmentTypesResult",
				"type": "structure",
				"members": {
					"AdjustmentTypes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AdjustmentType": {}
							}
						}
					}
				}
			}
		},
		"DescribeAutoScalingGroups": {
			"input": {
				"type": "structure",
				"members": {
					"AutoScalingGroupNames": {
						"shape": "S22"
					},
					"NextToken": {},
					"MaxRecords": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeAutoScalingGroupsResult",
				"type": "structure",
				"required": [
					"AutoScalingGroups"
				],
				"members": {
					"AutoScalingGroups": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"AutoScalingGroupName",
								"MinSize",
								"MaxSize",
								"DesiredCapacity",
								"DefaultCooldown",
								"AvailabilityZones",
								"HealthCheckType",
								"CreatedTime"
							],
							"members": {
								"AutoScalingGroupName": {},
								"AutoScalingGroupARN": {},
								"LaunchConfigurationName": {},
								"MinSize": {
									"type": "integer"
								},
								"MaxSize": {
									"type": "integer"
								},
								"DesiredCapacity": {
									"type": "integer"
								},
								"DefaultCooldown": {
									"type": "integer"
								},
								"AvailabilityZones": {
									"shape": "Sn"
								},
								"LoadBalancerNames": {
									"shape": "Sa"
								},
								"TargetGroupARNs": {
									"shape": "S6"
								},
								"HealthCheckType": {},
								"HealthCheckGracePeriod": {
									"type": "integer"
								},
								"Instances": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"InstanceId",
											"AvailabilityZone",
											"LifecycleState",
											"HealthStatus",
											"LaunchConfigurationName",
											"ProtectedFromScaleIn"
										],
										"members": {
											"InstanceId": {},
											"AvailabilityZone": {},
											"LifecycleState": {},
											"HealthStatus": {},
											"LaunchConfigurationName": {},
											"ProtectedFromScaleIn": {
												"type": "boolean"
											}
										}
									}
								},
								"CreatedTime": {
									"type": "timestamp"
								},
								"SuspendedProcesses": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ProcessName": {},
											"SuspensionReason": {}
										}
									}
								},
								"PlacementGroup": {},
								"VPCZoneIdentifier": {},
								"EnabledMetrics": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Metric": {},
											"Granularity": {}
										}
									}
								},
								"Status": {},
								"Tags": {
									"shape": "S2f"
								},
								"TerminationPolicies": {
									"shape": "Sr"
								},
								"NewInstancesProtectedFromScaleIn": {
									"type": "boolean"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeAutoScalingInstances": {
			"input": {
				"type": "structure",
				"members": {
					"InstanceIds": {
						"shape": "S2"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeAutoScalingInstancesResult",
				"type": "structure",
				"members": {
					"AutoScalingInstances": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"InstanceId",
								"AutoScalingGroupName",
								"AvailabilityZone",
								"LifecycleState",
								"HealthStatus",
								"LaunchConfigurationName",
								"ProtectedFromScaleIn"
							],
							"members": {
								"InstanceId": {},
								"AutoScalingGroupName": {},
								"AvailabilityZone": {},
								"LifecycleState": {},
								"HealthStatus": {},
								"LaunchConfigurationName": {},
								"ProtectedFromScaleIn": {
									"type": "boolean"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeAutoScalingNotificationTypes": {
			"output": {
				"resultWrapper": "DescribeAutoScalingNotificationTypesResult",
				"type": "structure",
				"members": {
					"AutoScalingNotificationTypes": {
						"shape": "S2m"
					}
				}
			}
		},
		"DescribeLaunchConfigurations": {
			"input": {
				"type": "structure",
				"members": {
					"LaunchConfigurationNames": {
						"type": "list",
						"member": {}
					},
					"NextToken": {},
					"MaxRecords": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeLaunchConfigurationsResult",
				"type": "structure",
				"required": [
					"LaunchConfigurations"
				],
				"members": {
					"LaunchConfigurations": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"LaunchConfigurationName",
								"ImageId",
								"InstanceType",
								"CreatedTime"
							],
							"members": {
								"LaunchConfigurationName": {},
								"LaunchConfigurationARN": {},
								"ImageId": {},
								"KeyName": {},
								"SecurityGroups": {
									"shape": "S11"
								},
								"ClassicLinkVPCId": {},
								"ClassicLinkVPCSecurityGroups": {
									"shape": "S12"
								},
								"UserData": {},
								"InstanceType": {},
								"KernelId": {},
								"RamdiskId": {},
								"BlockDeviceMappings": {
									"shape": "S14"
								},
								"InstanceMonitoring": {
									"shape": "S1d"
								},
								"SpotPrice": {},
								"IamInstanceProfile": {},
								"CreatedTime": {
									"type": "timestamp"
								},
								"EbsOptimized": {
									"type": "boolean"
								},
								"AssociatePublicIpAddress": {
									"type": "boolean"
								},
								"PlacementTenancy": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeLifecycleHookTypes": {
			"output": {
				"resultWrapper": "DescribeLifecycleHookTypesResult",
				"type": "structure",
				"members": {
					"LifecycleHookTypes": {
						"shape": "S2m"
					}
				}
			}
		},
		"DescribeLifecycleHooks": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"LifecycleHookNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeLifecycleHooksResult",
				"type": "structure",
				"members": {
					"LifecycleHooks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"LifecycleHookName": {},
								"AutoScalingGroupName": {},
								"LifecycleTransition": {},
								"NotificationTargetARN": {},
								"RoleARN": {},
								"NotificationMetadata": {},
								"HeartbeatTimeout": {
									"type": "integer"
								},
								"GlobalTimeout": {
									"type": "integer"
								},
								"DefaultResult": {}
							}
						}
					}
				}
			}
		},
		"DescribeLoadBalancerTargetGroups": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"NextToken": {},
					"MaxRecords": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeLoadBalancerTargetGroupsResult",
				"type": "structure",
				"members": {
					"LoadBalancerTargetGroups": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"LoadBalancerTargetGroupARN": {},
								"State": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeLoadBalancers": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"NextToken": {},
					"MaxRecords": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeLoadBalancersResult",
				"type": "structure",
				"members": {
					"LoadBalancers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"LoadBalancerName": {},
								"State": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMetricCollectionTypes": {
			"output": {
				"resultWrapper": "DescribeMetricCollectionTypesResult",
				"type": "structure",
				"members": {
					"Metrics": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Metric": {}
							}
						}
					},
					"Granularities": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Granularity": {}
							}
						}
					}
				}
			}
		},
		"DescribeNotificationConfigurations": {
			"input": {
				"type": "structure",
				"members": {
					"AutoScalingGroupNames": {
						"shape": "S22"
					},
					"NextToken": {},
					"MaxRecords": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeNotificationConfigurationsResult",
				"type": "structure",
				"required": [
					"NotificationConfigurations"
				],
				"members": {
					"NotificationConfigurations": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AutoScalingGroupName": {},
								"TopicARN": {},
								"NotificationType": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribePolicies": {
			"input": {
				"type": "structure",
				"members": {
					"AutoScalingGroupName": {},
					"PolicyNames": {
						"type": "list",
						"member": {}
					},
					"PolicyTypes": {
						"type": "list",
						"member": {}
					},
					"NextToken": {},
					"MaxRecords": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribePoliciesResult",
				"type": "structure",
				"members": {
					"ScalingPolicies": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AutoScalingGroupName": {},
								"PolicyName": {},
								"PolicyARN": {},
								"PolicyType": {},
								"AdjustmentType": {},
								"MinAdjustmentStep": {
									"shape": "S3p"
								},
								"MinAdjustmentMagnitude": {
									"type": "integer"
								},
								"ScalingAdjustment": {
									"type": "integer"
								},
								"Cooldown": {
									"type": "integer"
								},
								"StepAdjustments": {
									"shape": "S3s"
								},
								"MetricAggregationType": {},
								"EstimatedInstanceWarmup": {
									"type": "integer"
								},
								"Alarms": {
									"shape": "S3w"
								},
								"TargetTrackingConfiguration": {
									"shape": "S3y"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeScalingActivities": {
			"input": {
				"type": "structure",
				"members": {
					"ActivityIds": {
						"type": "list",
						"member": {}
					},
					"AutoScalingGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeScalingActivitiesResult",
				"type": "structure",
				"required": [
					"Activities"
				],
				"members": {
					"Activities": {
						"shape": "S4e"
					},
					"NextToken": {}
				}
			}
		},
		"DescribeScalingProcessTypes": {
			"output": {
				"resultWrapper": "DescribeScalingProcessTypesResult",
				"type": "structure",
				"members": {
					"Processes": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"ProcessName"
							],
							"members": {
								"ProcessName": {}
							}
						}
					}
				}
			}
		},
		"DescribeScheduledActions": {
			"input": {
				"type": "structure",
				"members": {
					"AutoScalingGroupName": {},
					"ScheduledActionNames": {
						"type": "list",
						"member": {}
					},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"NextToken": {},
					"MaxRecords": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeScheduledActionsResult",
				"type": "structure",
				"members": {
					"ScheduledUpdateGroupActions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AutoScalingGroupName": {},
								"ScheduledActionName": {},
								"ScheduledActionARN": {},
								"Time": {
									"type": "timestamp"
								},
								"StartTime": {
									"type": "timestamp"
								},
								"EndTime": {
									"type": "timestamp"
								},
								"Recurrence": {},
								"MinSize": {
									"type": "integer"
								},
								"MaxSize": {
									"type": "integer"
								},
								"DesiredCapacity": {
									"type": "integer"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeTags": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Values": {
									"type": "list",
									"member": {}
								}
							}
						}
					},
					"NextToken": {},
					"MaxRecords": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeTagsResult",
				"type": "structure",
				"members": {
					"Tags": {
						"shape": "S2f"
					},
					"NextToken": {}
				}
			}
		},
		"DescribeTerminationPolicyTypes": {
			"output": {
				"resultWrapper": "DescribeTerminationPolicyTypesResult",
				"type": "structure",
				"members": {
					"TerminationPolicyTypes": {
						"shape": "Sr"
					}
				}
			}
		},
		"DetachInstances": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"ShouldDecrementDesiredCapacity"
				],
				"members": {
					"InstanceIds": {
						"shape": "S2"
					},
					"AutoScalingGroupName": {},
					"ShouldDecrementDesiredCapacity": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DetachInstancesResult",
				"type": "structure",
				"members": {
					"Activities": {
						"shape": "S4e"
					}
				}
			}
		},
		"DetachLoadBalancerTargetGroups": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"TargetGroupARNs"
				],
				"members": {
					"AutoScalingGroupName": {},
					"TargetGroupARNs": {
						"shape": "S6"
					}
				}
			},
			"output": {
				"resultWrapper": "DetachLoadBalancerTargetGroupsResult",
				"type": "structure",
				"members": {}
			}
		},
		"DetachLoadBalancers": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"LoadBalancerNames"
				],
				"members": {
					"AutoScalingGroupName": {},
					"LoadBalancerNames": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "DetachLoadBalancersResult",
				"type": "structure",
				"members": {}
			}
		},
		"DisableMetricsCollection": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"Metrics": {
						"shape": "S54"
					}
				}
			}
		},
		"EnableMetricsCollection": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"Granularity"
				],
				"members": {
					"AutoScalingGroupName": {},
					"Metrics": {
						"shape": "S54"
					},
					"Granularity": {}
				}
			}
		},
		"EnterStandby": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"ShouldDecrementDesiredCapacity"
				],
				"members": {
					"InstanceIds": {
						"shape": "S2"
					},
					"AutoScalingGroupName": {},
					"ShouldDecrementDesiredCapacity": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "EnterStandbyResult",
				"type": "structure",
				"members": {
					"Activities": {
						"shape": "S4e"
					}
				}
			}
		},
		"ExecutePolicy": {
			"input": {
				"type": "structure",
				"required": [
					"PolicyName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"PolicyName": {},
					"HonorCooldown": {
						"type": "boolean"
					},
					"MetricValue": {
						"type": "double"
					},
					"BreachThreshold": {
						"type": "double"
					}
				}
			}
		},
		"ExitStandby": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName"
				],
				"members": {
					"InstanceIds": {
						"shape": "S2"
					},
					"AutoScalingGroupName": {}
				}
			},
			"output": {
				"resultWrapper": "ExitStandbyResult",
				"type": "structure",
				"members": {
					"Activities": {
						"shape": "S4e"
					}
				}
			}
		},
		"PutLifecycleHook": {
			"input": {
				"type": "structure",
				"required": [
					"LifecycleHookName",
					"AutoScalingGroupName"
				],
				"members": {
					"LifecycleHookName": {},
					"AutoScalingGroupName": {},
					"LifecycleTransition": {},
					"RoleARN": {},
					"NotificationTargetARN": {},
					"NotificationMetadata": {},
					"HeartbeatTimeout": {
						"type": "integer"
					},
					"DefaultResult": {}
				}
			},
			"output": {
				"resultWrapper": "PutLifecycleHookResult",
				"type": "structure",
				"members": {}
			}
		},
		"PutNotificationConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"TopicARN",
					"NotificationTypes"
				],
				"members": {
					"AutoScalingGroupName": {},
					"TopicARN": {},
					"NotificationTypes": {
						"shape": "S2m"
					}
				}
			}
		},
		"PutScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"PolicyName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"PolicyName": {},
					"PolicyType": {},
					"AdjustmentType": {},
					"MinAdjustmentStep": {
						"shape": "S3p"
					},
					"MinAdjustmentMagnitude": {
						"type": "integer"
					},
					"ScalingAdjustment": {
						"type": "integer"
					},
					"Cooldown": {
						"type": "integer"
					},
					"MetricAggregationType": {},
					"StepAdjustments": {
						"shape": "S3s"
					},
					"EstimatedInstanceWarmup": {
						"type": "integer"
					},
					"TargetTrackingConfiguration": {
						"shape": "S3y"
					}
				}
			},
			"output": {
				"resultWrapper": "PutScalingPolicyResult",
				"type": "structure",
				"members": {
					"PolicyARN": {},
					"Alarms": {
						"shape": "S3w"
					}
				}
			}
		},
		"PutScheduledUpdateGroupAction": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"ScheduledActionName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"ScheduledActionName": {},
					"Time": {
						"type": "timestamp"
					},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Recurrence": {},
					"MinSize": {
						"type": "integer"
					},
					"MaxSize": {
						"type": "integer"
					},
					"DesiredCapacity": {
						"type": "integer"
					}
				}
			}
		},
		"RecordLifecycleActionHeartbeat": {
			"input": {
				"type": "structure",
				"required": [
					"LifecycleHookName",
					"AutoScalingGroupName"
				],
				"members": {
					"LifecycleHookName": {},
					"AutoScalingGroupName": {},
					"LifecycleActionToken": {},
					"InstanceId": {}
				}
			},
			"output": {
				"resultWrapper": "RecordLifecycleActionHeartbeatResult",
				"type": "structure",
				"members": {}
			}
		},
		"ResumeProcesses": {
			"input": {
				"shape": "S5l"
			}
		},
		"SetDesiredCapacity": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName",
					"DesiredCapacity"
				],
				"members": {
					"AutoScalingGroupName": {},
					"DesiredCapacity": {
						"type": "integer"
					},
					"HonorCooldown": {
						"type": "boolean"
					}
				}
			}
		},
		"SetInstanceHealth": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"HealthStatus"
				],
				"members": {
					"InstanceId": {},
					"HealthStatus": {},
					"ShouldRespectGracePeriod": {
						"type": "boolean"
					}
				}
			}
		},
		"SetInstanceProtection": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds",
					"AutoScalingGroupName",
					"ProtectedFromScaleIn"
				],
				"members": {
					"InstanceIds": {
						"shape": "S2"
					},
					"AutoScalingGroupName": {},
					"ProtectedFromScaleIn": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "SetInstanceProtectionResult",
				"type": "structure",
				"members": {}
			}
		},
		"SuspendProcesses": {
			"input": {
				"shape": "S5l"
			}
		},
		"TerminateInstanceInAutoScalingGroup": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"ShouldDecrementDesiredCapacity"
				],
				"members": {
					"InstanceId": {},
					"ShouldDecrementDesiredCapacity": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "TerminateInstanceInAutoScalingGroupResult",
				"type": "structure",
				"members": {
					"Activity": {
						"shape": "S4f"
					}
				}
			}
		},
		"UpdateAutoScalingGroup": {
			"input": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"LaunchConfigurationName": {},
					"MinSize": {
						"type": "integer"
					},
					"MaxSize": {
						"type": "integer"
					},
					"DesiredCapacity": {
						"type": "integer"
					},
					"DefaultCooldown": {
						"type": "integer"
					},
					"AvailabilityZones": {
						"shape": "Sn"
					},
					"HealthCheckType": {},
					"HealthCheckGracePeriod": {
						"type": "integer"
					},
					"PlacementGroup": {},
					"VPCZoneIdentifier": {},
					"TerminationPolicies": {
						"shape": "Sr"
					},
					"NewInstancesProtectedFromScaleIn": {
						"type": "boolean"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "list",
			"member": {}
		},
		"S6": {
			"type": "list",
			"member": {}
		},
		"Sa": {
			"type": "list",
			"member": {}
		},
		"Sn": {
			"type": "list",
			"member": {}
		},
		"Sr": {
			"type": "list",
			"member": {}
		},
		"Su": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"ResourceId": {},
					"ResourceType": {},
					"Key": {},
					"Value": {},
					"PropagateAtLaunch": {
						"type": "boolean"
					}
				}
			}
		},
		"S11": {
			"type": "list",
			"member": {}
		},
		"S12": {
			"type": "list",
			"member": {}
		},
		"S14": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"DeviceName"
				],
				"members": {
					"VirtualName": {},
					"DeviceName": {},
					"Ebs": {
						"type": "structure",
						"members": {
							"SnapshotId": {},
							"VolumeSize": {
								"type": "integer"
							},
							"VolumeType": {},
							"DeleteOnTermination": {
								"type": "boolean"
							},
							"Iops": {
								"type": "integer"
							},
							"Encrypted": {
								"type": "boolean"
							}
						}
					},
					"NoDevice": {
						"type": "boolean"
					}
				}
			}
		},
		"S1d": {
			"type": "structure",
			"members": {
				"Enabled": {
					"type": "boolean"
				}
			}
		},
		"S22": {
			"type": "list",
			"member": {}
		},
		"S2f": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ResourceId": {},
					"ResourceType": {},
					"Key": {},
					"Value": {},
					"PropagateAtLaunch": {
						"type": "boolean"
					}
				}
			}
		},
		"S2m": {
			"type": "list",
			"member": {}
		},
		"S3p": {
			"type": "integer",
			"deprecated": true
		},
		"S3s": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"ScalingAdjustment"
				],
				"members": {
					"MetricIntervalLowerBound": {
						"type": "double"
					},
					"MetricIntervalUpperBound": {
						"type": "double"
					},
					"ScalingAdjustment": {
						"type": "integer"
					}
				}
			}
		},
		"S3w": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"AlarmName": {},
					"AlarmARN": {}
				}
			}
		},
		"S3y": {
			"type": "structure",
			"required": [
				"TargetValue"
			],
			"members": {
				"PredefinedMetricSpecification": {
					"type": "structure",
					"required": [
						"PredefinedMetricType"
					],
					"members": {
						"PredefinedMetricType": {},
						"ResourceLabel": {}
					}
				},
				"CustomizedMetricSpecification": {
					"type": "structure",
					"required": [
						"MetricName",
						"Namespace",
						"Statistic"
					],
					"members": {
						"MetricName": {},
						"Namespace": {},
						"Dimensions": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Name",
									"Value"
								],
								"members": {
									"Name": {},
									"Value": {}
								}
							}
						},
						"Statistic": {},
						"Unit": {}
					}
				},
				"TargetValue": {
					"type": "double"
				},
				"DisableScaleIn": {
					"type": "boolean"
				}
			}
		},
		"S4e": {
			"type": "list",
			"member": {
				"shape": "S4f"
			}
		},
		"S4f": {
			"type": "structure",
			"required": [
				"ActivityId",
				"AutoScalingGroupName",
				"Cause",
				"StartTime",
				"StatusCode"
			],
			"members": {
				"ActivityId": {},
				"AutoScalingGroupName": {},
				"Description": {},
				"Cause": {},
				"StartTime": {
					"type": "timestamp"
				},
				"EndTime": {
					"type": "timestamp"
				},
				"StatusCode": {},
				"StatusMessage": {},
				"Progress": {
					"type": "integer"
				},
				"Details": {}
			}
		},
		"S54": {
			"type": "list",
			"member": {}
		},
		"S5l": {
			"type": "structure",
			"required": [
				"AutoScalingGroupName"
			],
			"members": {
				"AutoScalingGroupName": {},
				"ScalingProcesses": {
					"type": "list",
					"member": {}
				}
			}
		}
	}
};

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeAutoScalingGroups": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "AutoScalingGroups"
		},
		"DescribeAutoScalingInstances": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "AutoScalingInstances"
		},
		"DescribeLaunchConfigurations": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "LaunchConfigurations"
		},
		"DescribeNotificationConfigurations": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "NotificationConfigurations"
		},
		"DescribePolicies": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "ScalingPolicies"
		},
		"DescribeScalingActivities": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "Activities"
		},
		"DescribeScheduledActions": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "ScheduledUpdateGroupActions"
		},
		"DescribeTags": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "Tags"
		}
	}
};

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudformation'] = {};
AWS.CloudFormation = Service.defineService('cloudformation', ['2010-05-15']);
Object.defineProperty(apiLoader.services['cloudformation'], '2010-05-15', {
  get: function get() {
    var model = __webpack_require__(1518);
    model.paginators = __webpack_require__(1519).pagination;
    model.waiters = __webpack_require__(1520).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudFormation;


/***/ }),
/* 1518 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2010-05-15",
		"endpointPrefix": "cloudformation",
		"protocol": "query",
		"serviceFullName": "AWS CloudFormation",
		"signatureVersion": "v4",
		"uid": "cloudformation-2010-05-15",
		"xmlNamespace": "http://cloudformation.amazonaws.com/doc/2010-05-15/"
	},
	"operations": {
		"CancelUpdateStack": {
			"input": {
				"type": "structure",
				"required": [
					"StackName"
				],
				"members": {
					"StackName": {},
					"ClientRequestToken": {}
				}
			}
		},
		"ContinueUpdateRollback": {
			"input": {
				"type": "structure",
				"required": [
					"StackName"
				],
				"members": {
					"StackName": {},
					"RoleARN": {},
					"ResourcesToSkip": {
						"type": "list",
						"member": {}
					},
					"ClientRequestToken": {}
				}
			},
			"output": {
				"resultWrapper": "ContinueUpdateRollbackResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateChangeSet": {
			"input": {
				"type": "structure",
				"required": [
					"StackName",
					"ChangeSetName"
				],
				"members": {
					"StackName": {},
					"TemplateBody": {},
					"TemplateURL": {},
					"UsePreviousTemplate": {
						"type": "boolean"
					},
					"Parameters": {
						"shape": "Se"
					},
					"Capabilities": {
						"shape": "Sj"
					},
					"ResourceTypes": {
						"shape": "Sl"
					},
					"RoleARN": {},
					"NotificationARNs": {
						"shape": "Sn"
					},
					"Tags": {
						"shape": "Sp"
					},
					"ChangeSetName": {},
					"ClientToken": {},
					"Description": {},
					"ChangeSetType": {}
				}
			},
			"output": {
				"resultWrapper": "CreateChangeSetResult",
				"type": "structure",
				"members": {
					"Id": {},
					"StackId": {}
				}
			}
		},
		"CreateStack": {
			"input": {
				"type": "structure",
				"required": [
					"StackName"
				],
				"members": {
					"StackName": {},
					"TemplateBody": {},
					"TemplateURL": {},
					"Parameters": {
						"shape": "Se"
					},
					"DisableRollback": {
						"type": "boolean"
					},
					"TimeoutInMinutes": {
						"type": "integer"
					},
					"NotificationARNs": {
						"shape": "Sn"
					},
					"Capabilities": {
						"shape": "Sj"
					},
					"ResourceTypes": {
						"shape": "Sl"
					},
					"RoleARN": {},
					"OnFailure": {},
					"StackPolicyBody": {},
					"StackPolicyURL": {},
					"Tags": {
						"shape": "Sp"
					},
					"ClientRequestToken": {}
				}
			},
			"output": {
				"resultWrapper": "CreateStackResult",
				"type": "structure",
				"members": {
					"StackId": {}
				}
			}
		},
		"CreateStackInstances": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName",
					"Accounts",
					"Regions"
				],
				"members": {
					"StackSetName": {},
					"Accounts": {
						"shape": "S19"
					},
					"Regions": {
						"shape": "S1b"
					},
					"OperationPreferences": {
						"shape": "S1d"
					},
					"OperationId": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"resultWrapper": "CreateStackInstancesResult",
				"type": "structure",
				"members": {
					"OperationId": {}
				}
			}
		},
		"CreateStackSet": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName"
				],
				"members": {
					"StackSetName": {},
					"Description": {},
					"TemplateBody": {},
					"TemplateURL": {},
					"Parameters": {
						"shape": "Se"
					},
					"Capabilities": {
						"shape": "Sj"
					},
					"Tags": {
						"shape": "Sp"
					},
					"ClientRequestToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"resultWrapper": "CreateStackSetResult",
				"type": "structure",
				"members": {
					"StackSetId": {}
				}
			}
		},
		"DeleteChangeSet": {
			"input": {
				"type": "structure",
				"required": [
					"ChangeSetName"
				],
				"members": {
					"ChangeSetName": {},
					"StackName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteChangeSetResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteStack": {
			"input": {
				"type": "structure",
				"required": [
					"StackName"
				],
				"members": {
					"StackName": {},
					"RetainResources": {
						"type": "list",
						"member": {}
					},
					"RoleARN": {},
					"ClientRequestToken": {}
				}
			}
		},
		"DeleteStackInstances": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName",
					"Accounts",
					"Regions",
					"RetainStacks"
				],
				"members": {
					"StackSetName": {},
					"Accounts": {
						"shape": "S19"
					},
					"Regions": {
						"shape": "S1b"
					},
					"OperationPreferences": {
						"shape": "S1d"
					},
					"RetainStacks": {
						"type": "boolean"
					},
					"OperationId": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"resultWrapper": "DeleteStackInstancesResult",
				"type": "structure",
				"members": {
					"OperationId": {}
				}
			}
		},
		"DeleteStackSet": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName"
				],
				"members": {
					"StackSetName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteStackSetResult",
				"type": "structure",
				"members": {}
			}
		},
		"DescribeAccountLimits": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeAccountLimitsResult",
				"type": "structure",
				"members": {
					"AccountLimits": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Value": {
									"type": "integer"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeChangeSet": {
			"input": {
				"type": "structure",
				"required": [
					"ChangeSetName"
				],
				"members": {
					"ChangeSetName": {},
					"StackName": {},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeChangeSetResult",
				"type": "structure",
				"members": {
					"ChangeSetName": {},
					"ChangeSetId": {},
					"StackId": {},
					"StackName": {},
					"Description": {},
					"Parameters": {
						"shape": "Se"
					},
					"CreationTime": {
						"type": "timestamp"
					},
					"ExecutionStatus": {},
					"Status": {},
					"StatusReason": {},
					"NotificationARNs": {
						"shape": "Sn"
					},
					"Capabilities": {
						"shape": "Sj"
					},
					"Tags": {
						"shape": "Sp"
					},
					"Changes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Type": {},
								"ResourceChange": {
									"type": "structure",
									"members": {
										"Action": {},
										"LogicalResourceId": {},
										"PhysicalResourceId": {},
										"ResourceType": {},
										"Replacement": {},
										"Scope": {
											"type": "list",
											"member": {}
										},
										"Details": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"Target": {
														"type": "structure",
														"members": {
															"Attribute": {},
															"Name": {},
															"RequiresRecreation": {}
														}
													},
													"Evaluation": {},
													"ChangeSource": {},
													"CausingEntity": {}
												}
											}
										}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeStackEvents": {
			"input": {
				"type": "structure",
				"members": {
					"StackName": {},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeStackEventsResult",
				"type": "structure",
				"members": {
					"StackEvents": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"StackId",
								"EventId",
								"StackName",
								"Timestamp"
							],
							"members": {
								"StackId": {},
								"EventId": {},
								"StackName": {},
								"LogicalResourceId": {},
								"PhysicalResourceId": {},
								"ResourceType": {},
								"Timestamp": {
									"type": "timestamp"
								},
								"ResourceStatus": {},
								"ResourceStatusReason": {},
								"ResourceProperties": {},
								"ClientRequestToken": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeStackInstance": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName",
					"StackInstanceAccount",
					"StackInstanceRegion"
				],
				"members": {
					"StackSetName": {},
					"StackInstanceAccount": {},
					"StackInstanceRegion": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeStackInstanceResult",
				"type": "structure",
				"members": {
					"StackInstance": {
						"type": "structure",
						"members": {
							"StackSetId": {},
							"Region": {},
							"Account": {},
							"StackId": {},
							"Status": {},
							"StatusReason": {}
						}
					}
				}
			}
		},
		"DescribeStackResource": {
			"input": {
				"type": "structure",
				"required": [
					"StackName",
					"LogicalResourceId"
				],
				"members": {
					"StackName": {},
					"LogicalResourceId": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeStackResourceResult",
				"type": "structure",
				"members": {
					"StackResourceDetail": {
						"type": "structure",
						"required": [
							"LogicalResourceId",
							"ResourceType",
							"LastUpdatedTimestamp",
							"ResourceStatus"
						],
						"members": {
							"StackName": {},
							"StackId": {},
							"LogicalResourceId": {},
							"PhysicalResourceId": {},
							"ResourceType": {},
							"LastUpdatedTimestamp": {
								"type": "timestamp"
							},
							"ResourceStatus": {},
							"ResourceStatusReason": {},
							"Description": {},
							"Metadata": {}
						}
					}
				}
			}
		},
		"DescribeStackResources": {
			"input": {
				"type": "structure",
				"members": {
					"StackName": {},
					"LogicalResourceId": {},
					"PhysicalResourceId": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeStackResourcesResult",
				"type": "structure",
				"members": {
					"StackResources": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"LogicalResourceId",
								"ResourceType",
								"Timestamp",
								"ResourceStatus"
							],
							"members": {
								"StackName": {},
								"StackId": {},
								"LogicalResourceId": {},
								"PhysicalResourceId": {},
								"ResourceType": {},
								"Timestamp": {
									"type": "timestamp"
								},
								"ResourceStatus": {},
								"ResourceStatusReason": {},
								"Description": {}
							}
						}
					}
				}
			}
		},
		"DescribeStackSet": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName"
				],
				"members": {
					"StackSetName": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeStackSetResult",
				"type": "structure",
				"members": {
					"StackSet": {
						"type": "structure",
						"members": {
							"StackSetName": {},
							"StackSetId": {},
							"Description": {},
							"Status": {},
							"TemplateBody": {},
							"Parameters": {
								"shape": "Se"
							},
							"Capabilities": {
								"shape": "Sj"
							},
							"Tags": {
								"shape": "Sp"
							}
						}
					}
				}
			}
		},
		"DescribeStackSetOperation": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName",
					"OperationId"
				],
				"members": {
					"StackSetName": {},
					"OperationId": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeStackSetOperationResult",
				"type": "structure",
				"members": {
					"StackSetOperation": {
						"type": "structure",
						"members": {
							"OperationId": {},
							"StackSetId": {},
							"Action": {},
							"Status": {},
							"OperationPreferences": {
								"shape": "S1d"
							},
							"RetainStacks": {
								"type": "boolean"
							},
							"CreationTimestamp": {
								"type": "timestamp"
							},
							"EndTimestamp": {
								"type": "timestamp"
							}
						}
					}
				}
			}
		},
		"DescribeStacks": {
			"input": {
				"type": "structure",
				"members": {
					"StackName": {},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeStacksResult",
				"type": "structure",
				"members": {
					"Stacks": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"StackName",
								"CreationTime",
								"StackStatus"
							],
							"members": {
								"StackId": {},
								"StackName": {},
								"ChangeSetId": {},
								"Description": {},
								"Parameters": {
									"shape": "Se"
								},
								"CreationTime": {
									"type": "timestamp"
								},
								"LastUpdatedTime": {
									"type": "timestamp"
								},
								"StackStatus": {},
								"StackStatusReason": {},
								"DisableRollback": {
									"type": "boolean"
								},
								"NotificationARNs": {
									"shape": "Sn"
								},
								"TimeoutInMinutes": {
									"type": "integer"
								},
								"Capabilities": {
									"shape": "Sj"
								},
								"Outputs": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"OutputKey": {},
											"OutputValue": {},
											"Description": {},
											"ExportName": {}
										}
									}
								},
								"RoleARN": {},
								"Tags": {
									"shape": "Sp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"EstimateTemplateCost": {
			"input": {
				"type": "structure",
				"members": {
					"TemplateBody": {},
					"TemplateURL": {},
					"Parameters": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"resultWrapper": "EstimateTemplateCostResult",
				"type": "structure",
				"members": {
					"Url": {}
				}
			}
		},
		"ExecuteChangeSet": {
			"input": {
				"type": "structure",
				"required": [
					"ChangeSetName"
				],
				"members": {
					"ChangeSetName": {},
					"StackName": {},
					"ClientRequestToken": {}
				}
			},
			"output": {
				"resultWrapper": "ExecuteChangeSetResult",
				"type": "structure",
				"members": {}
			}
		},
		"GetStackPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"StackName"
				],
				"members": {
					"StackName": {}
				}
			},
			"output": {
				"resultWrapper": "GetStackPolicyResult",
				"type": "structure",
				"members": {
					"StackPolicyBody": {}
				}
			}
		},
		"GetTemplate": {
			"input": {
				"type": "structure",
				"members": {
					"StackName": {},
					"ChangeSetName": {},
					"TemplateStage": {}
				}
			},
			"output": {
				"resultWrapper": "GetTemplateResult",
				"type": "structure",
				"members": {
					"TemplateBody": {},
					"StagesAvailable": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"GetTemplateSummary": {
			"input": {
				"type": "structure",
				"members": {
					"TemplateBody": {},
					"TemplateURL": {},
					"StackName": {},
					"StackSetName": {}
				}
			},
			"output": {
				"resultWrapper": "GetTemplateSummaryResult",
				"type": "structure",
				"members": {
					"Parameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ParameterKey": {},
								"DefaultValue": {},
								"ParameterType": {},
								"NoEcho": {
									"type": "boolean"
								},
								"Description": {},
								"ParameterConstraints": {
									"type": "structure",
									"members": {
										"AllowedValues": {
											"type": "list",
											"member": {}
										}
									}
								}
							}
						}
					},
					"Description": {},
					"Capabilities": {
						"shape": "Sj"
					},
					"CapabilitiesReason": {},
					"ResourceTypes": {
						"shape": "Sl"
					},
					"Version": {},
					"Metadata": {},
					"DeclaredTransforms": {
						"shape": "S4m"
					}
				}
			}
		},
		"ListChangeSets": {
			"input": {
				"type": "structure",
				"required": [
					"StackName"
				],
				"members": {
					"StackName": {},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListChangeSetsResult",
				"type": "structure",
				"members": {
					"Summaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"StackId": {},
								"StackName": {},
								"ChangeSetId": {},
								"ChangeSetName": {},
								"ExecutionStatus": {},
								"Status": {},
								"StatusReason": {},
								"CreationTime": {
									"type": "timestamp"
								},
								"Description": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListExports": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListExportsResult",
				"type": "structure",
				"members": {
					"Exports": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ExportingStackId": {},
								"Name": {},
								"Value": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListImports": {
			"input": {
				"type": "structure",
				"required": [
					"ExportName"
				],
				"members": {
					"ExportName": {},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListImportsResult",
				"type": "structure",
				"members": {
					"Imports": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			}
		},
		"ListStackInstances": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName"
				],
				"members": {
					"StackSetName": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					},
					"StackInstanceAccount": {},
					"StackInstanceRegion": {}
				}
			},
			"output": {
				"resultWrapper": "ListStackInstancesResult",
				"type": "structure",
				"members": {
					"Summaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"StackSetId": {},
								"Region": {},
								"Account": {},
								"StackId": {},
								"Status": {},
								"StatusReason": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListStackResources": {
			"input": {
				"type": "structure",
				"required": [
					"StackName"
				],
				"members": {
					"StackName": {},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListStackResourcesResult",
				"type": "structure",
				"members": {
					"StackResourceSummaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"LogicalResourceId",
								"ResourceType",
								"LastUpdatedTimestamp",
								"ResourceStatus"
							],
							"members": {
								"LogicalResourceId": {},
								"PhysicalResourceId": {},
								"ResourceType": {},
								"LastUpdatedTimestamp": {
									"type": "timestamp"
								},
								"ResourceStatus": {},
								"ResourceStatusReason": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListStackSetOperationResults": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName",
					"OperationId"
				],
				"members": {
					"StackSetName": {},
					"OperationId": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "ListStackSetOperationResultsResult",
				"type": "structure",
				"members": {
					"Summaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Account": {},
								"Region": {},
								"Status": {},
								"StatusReason": {},
								"AccountGateResult": {
									"type": "structure",
									"members": {
										"Status": {},
										"StatusReason": {}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListStackSetOperations": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName"
				],
				"members": {
					"StackSetName": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "ListStackSetOperationsResult",
				"type": "structure",
				"members": {
					"Summaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"OperationId": {},
								"Action": {},
								"Status": {},
								"CreationTimestamp": {
									"type": "timestamp"
								},
								"EndTimestamp": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListStackSets": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					},
					"Status": {}
				}
			},
			"output": {
				"resultWrapper": "ListStackSetsResult",
				"type": "structure",
				"members": {
					"Summaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"StackSetName": {},
								"StackSetId": {},
								"Description": {},
								"Status": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListStacks": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"StackStatusFilter": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "ListStacksResult",
				"type": "structure",
				"members": {
					"StackSummaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"StackName",
								"CreationTime",
								"StackStatus"
							],
							"members": {
								"StackId": {},
								"StackName": {},
								"TemplateDescription": {},
								"CreationTime": {
									"type": "timestamp"
								},
								"LastUpdatedTime": {
									"type": "timestamp"
								},
								"DeletionTime": {
									"type": "timestamp"
								},
								"StackStatus": {},
								"StackStatusReason": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"SetStackPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"StackName"
				],
				"members": {
					"StackName": {},
					"StackPolicyBody": {},
					"StackPolicyURL": {}
				}
			}
		},
		"SignalResource": {
			"input": {
				"type": "structure",
				"required": [
					"StackName",
					"LogicalResourceId",
					"UniqueId",
					"Status"
				],
				"members": {
					"StackName": {},
					"LogicalResourceId": {},
					"UniqueId": {},
					"Status": {}
				}
			}
		},
		"StopStackSetOperation": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName",
					"OperationId"
				],
				"members": {
					"StackSetName": {},
					"OperationId": {}
				}
			},
			"output": {
				"resultWrapper": "StopStackSetOperationResult",
				"type": "structure",
				"members": {}
			}
		},
		"UpdateStack": {
			"input": {
				"type": "structure",
				"required": [
					"StackName"
				],
				"members": {
					"StackName": {},
					"TemplateBody": {},
					"TemplateURL": {},
					"UsePreviousTemplate": {
						"type": "boolean"
					},
					"StackPolicyDuringUpdateBody": {},
					"StackPolicyDuringUpdateURL": {},
					"Parameters": {
						"shape": "Se"
					},
					"Capabilities": {
						"shape": "Sj"
					},
					"ResourceTypes": {
						"shape": "Sl"
					},
					"RoleARN": {},
					"StackPolicyBody": {},
					"StackPolicyURL": {},
					"NotificationARNs": {
						"shape": "Sn"
					},
					"Tags": {
						"shape": "Sp"
					},
					"ClientRequestToken": {}
				}
			},
			"output": {
				"resultWrapper": "UpdateStackResult",
				"type": "structure",
				"members": {
					"StackId": {}
				}
			}
		},
		"UpdateStackSet": {
			"input": {
				"type": "structure",
				"required": [
					"StackSetName"
				],
				"members": {
					"StackSetName": {},
					"Description": {},
					"TemplateBody": {},
					"TemplateURL": {},
					"UsePreviousTemplate": {
						"type": "boolean"
					},
					"Parameters": {
						"shape": "Se"
					},
					"Capabilities": {
						"shape": "Sj"
					},
					"Tags": {
						"shape": "Sp"
					},
					"OperationPreferences": {
						"shape": "S1d"
					},
					"OperationId": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"resultWrapper": "UpdateStackSetResult",
				"type": "structure",
				"members": {
					"OperationId": {}
				}
			}
		},
		"ValidateTemplate": {
			"input": {
				"type": "structure",
				"members": {
					"TemplateBody": {},
					"TemplateURL": {}
				}
			},
			"output": {
				"resultWrapper": "ValidateTemplateResult",
				"type": "structure",
				"members": {
					"Parameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ParameterKey": {},
								"DefaultValue": {},
								"NoEcho": {
									"type": "boolean"
								},
								"Description": {}
							}
						}
					},
					"Description": {},
					"Capabilities": {
						"shape": "Sj"
					},
					"CapabilitiesReason": {},
					"DeclaredTransforms": {
						"shape": "S4m"
					}
				}
			}
		}
	},
	"shapes": {
		"Se": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ParameterKey": {},
					"ParameterValue": {},
					"UsePreviousValue": {
						"type": "boolean"
					}
				}
			}
		},
		"Sj": {
			"type": "list",
			"member": {}
		},
		"Sl": {
			"type": "list",
			"member": {}
		},
		"Sn": {
			"type": "list",
			"member": {}
		},
		"Sp": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S19": {
			"type": "list",
			"member": {}
		},
		"S1b": {
			"type": "list",
			"member": {}
		},
		"S1d": {
			"type": "structure",
			"members": {
				"RegionOrder": {
					"shape": "S1b"
				},
				"FailureToleranceCount": {
					"type": "integer"
				},
				"FailureTolerancePercentage": {
					"type": "integer"
				},
				"MaxConcurrentCount": {
					"type": "integer"
				},
				"MaxConcurrentPercentage": {
					"type": "integer"
				}
			}
		},
		"S4m": {
			"type": "list",
			"member": {}
		}
	}
};

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeStackEvents": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "StackEvents"
		},
		"DescribeStackResources": {
			"result_key": "StackResources"
		},
		"DescribeStacks": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "Stacks"
		},
		"ListExports": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "Exports"
		},
		"ListImports": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "Imports"
		},
		"ListStackResources": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "StackResourceSummaries"
		},
		"ListStacks": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "StackSummaries"
		}
	}
};

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"StackExists": {
			"delay": 5,
			"operation": "DescribeStacks",
			"maxAttempts": 20,
			"acceptors": [
				{
					"matcher": "status",
					"expected": 200,
					"state": "success"
				},
				{
					"matcher": "error",
					"expected": "ValidationError",
					"state": "retry"
				}
			]
		},
		"StackCreateComplete": {
			"delay": 30,
			"operation": "DescribeStacks",
			"maxAttempts": 120,
			"description": "Wait until stack status is CREATE_COMPLETE.",
			"acceptors": [
				{
					"argument": "Stacks[].StackStatus",
					"expected": "CREATE_COMPLETE",
					"matcher": "pathAll",
					"state": "success"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "CREATE_FAILED",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "DELETE_COMPLETE",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "DELETE_FAILED",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "ROLLBACK_FAILED",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "ROLLBACK_COMPLETE",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"expected": "ValidationError",
					"matcher": "error",
					"state": "failure"
				}
			]
		},
		"StackDeleteComplete": {
			"delay": 30,
			"operation": "DescribeStacks",
			"maxAttempts": 120,
			"description": "Wait until stack status is DELETE_COMPLETE.",
			"acceptors": [
				{
					"argument": "Stacks[].StackStatus",
					"expected": "DELETE_COMPLETE",
					"matcher": "pathAll",
					"state": "success"
				},
				{
					"expected": "ValidationError",
					"matcher": "error",
					"state": "success"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "DELETE_FAILED",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "CREATE_FAILED",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "ROLLBACK_FAILED",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "UPDATE_ROLLBACK_FAILED",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "UPDATE_ROLLBACK_IN_PROGRESS",
					"matcher": "pathAny",
					"state": "failure"
				}
			]
		},
		"StackUpdateComplete": {
			"delay": 30,
			"maxAttempts": 120,
			"operation": "DescribeStacks",
			"description": "Wait until stack status is UPDATE_COMPLETE.",
			"acceptors": [
				{
					"argument": "Stacks[].StackStatus",
					"expected": "UPDATE_COMPLETE",
					"matcher": "pathAll",
					"state": "success"
				},
				{
					"expected": "UPDATE_FAILED",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Stacks[].StackStatus"
				},
				{
					"argument": "Stacks[].StackStatus",
					"expected": "UPDATE_ROLLBACK_FAILED",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"expected": "UPDATE_ROLLBACK_COMPLETE",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Stacks[].StackStatus"
				},
				{
					"expected": "ValidationError",
					"matcher": "error",
					"state": "failure"
				}
			]
		},
		"ChangeSetCreateComplete": {
			"delay": 30,
			"operation": "DescribeChangeSet",
			"maxAttempts": 120,
			"description": "Wait until change set status is CREATE_COMPLETE.",
			"acceptors": [
				{
					"argument": "Status",
					"expected": "CREATE_COMPLETE",
					"matcher": "path",
					"state": "success"
				},
				{
					"argument": "Status",
					"expected": "FAILED",
					"matcher": "path",
					"state": "failure"
				},
				{
					"expected": "ValidationError",
					"matcher": "error",
					"state": "failure"
				}
			]
		}
	}
};

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudfront'] = {};
AWS.CloudFront = Service.defineService('cloudfront', ['2013-05-12*', '2013-11-11*', '2014-05-31*', '2014-10-21*', '2014-11-06*', '2015-04-17*', '2015-07-27*', '2015-09-17*', '2016-01-13*', '2016-01-28*', '2016-08-01*', '2016-08-20*', '2016-09-07*', '2016-09-29*', '2016-11-25', '2016-11-25*', '2017-03-25']);
__webpack_require__(1522);
Object.defineProperty(apiLoader.services['cloudfront'], '2016-11-25', {
  get: function get() {
    var model = __webpack_require__(1524);
    model.paginators = __webpack_require__(1525).pagination;
    model.waiters = __webpack_require__(1526).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['cloudfront'], '2017-03-25', {
  get: function get() {
    var model = __webpack_require__(1527);
    model.paginators = __webpack_require__(1528).pagination;
    model.waiters = __webpack_require__(1529).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudFront;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

// pull in CloudFront signer
__webpack_require__(1523);

AWS.util.update(AWS.CloudFront.prototype, {

  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('extractData', AWS.util.hoistPayloadMember);
  }

});


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7),
    url = AWS.util.url,
    crypto = AWS.util.crypto.lib,
    base64Encode = AWS.util.base64.encode,
    inherit = AWS.util.inherit;

var queryEncode = function (string) {
    var replacements = {
        '+': '-',
        '=': '_',
        '/': '~'
    };
    return string.replace(/[\+=\/]/g, function (match) {
        return replacements[match];
    });
};

var signPolicy = function (policy, privateKey) {
    var sign = crypto.createSign('RSA-SHA1');
    sign.write(policy);
    return queryEncode(sign.sign(privateKey, 'base64'))
};

var signWithCannedPolicy = function (url, expires, keyPairId, privateKey) {
    var policy = JSON.stringify({
        Statement: [
            {
                Resource: url,
                Condition: { DateLessThan: { 'AWS:EpochTime': expires } }
            }
        ]
    });

    return {
        Expires: expires,
        'Key-Pair-Id': keyPairId,
        Signature: signPolicy(policy.toString(), privateKey)
    };
};

var signWithCustomPolicy = function (policy, keyPairId, privateKey) {
    policy = policy.replace(/\s/mg, policy);

    return {
        Policy: queryEncode(base64Encode(policy)),
        'Key-Pair-Id': keyPairId,
        Signature: signPolicy(policy, privateKey)
    }
};

var determineScheme = function (url) {
    var parts = url.split('://');
    if (parts.length < 2) {
        throw new Error('Invalid URL.');
    }

    return parts[0].replace('*', '');
};

var getRtmpUrl = function (rtmpUrl) {
    var parsed = url.parse(rtmpUrl);
    return parsed.path.replace(/^\//, '') + (parsed.hash || '');
};

var getResource = function (url) {
    switch (determineScheme(url)) {
        case 'http':
        case 'https':
            return url;
        case 'rtmp':
            return getRtmpUrl(url);
        default:
            throw new Error('Invalid URI scheme. Scheme must be one of'
                + ' http, https, or rtmp');
    }
};

var handleError = function (err, callback) {
    if (!callback || typeof callback !== 'function') {
        throw err;
    }

    callback(err);
};

var handleSuccess = function (result, callback) {
    if (!callback || typeof callback !== 'function') {
        return result;
    }

    callback(null, result);
};

AWS.CloudFront.Signer = inherit({
    /**
     * A signer object can be used to generate signed URLs and cookies for granting
     * access to content on restricted CloudFront distributions.
     *
     * @see http://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/PrivateContent.html
     *
     * @param keyPairId [String]    (Required) The ID of the CloudFront key pair
     *                              being used.
     * @param privateKey [String]   (Required) A private key in RSA format.
     */
    constructor: function Signer(keyPairId, privateKey) {
        if (keyPairId === void 0 || privateKey === void 0) {
            throw new Error('A key pair ID and private key are required');
        }

        this.keyPairId = keyPairId;
        this.privateKey = privateKey;
    },

    /**
     * Create a signed Amazon CloudFront Cookie.
     *
     * @param options [Object]            The options to create a signed cookie.
     * @option options url [String]     The URL to which the signature will grant
     *                                  access. Required unless you pass in a full
     *                                  policy.
     * @option options expires [Number] A Unix UTC timestamp indicating when the
     *                                  signature should expire. Required unless you
     *                                  pass in a full policy.
     * @option options policy [String]  A CloudFront JSON policy. Required unless
     *                                  you pass in a url and an expiry time.
     *
     * @param cb [Function] if a callback is provided, this function will
     *   pass the hash as the second parameter (after the error parameter) to
     *   the callback function.
     *
     * @return [Object] if called synchronously (with no callback), returns the
     *   signed cookie parameters.
     * @return [null] nothing is returned if a callback is provided.
     */
    getSignedCookie: function (options, cb) {
        var signatureHash = 'policy' in options
            ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
            : signWithCannedPolicy(options.url, options.expires, this.keyPairId, this.privateKey);

        var cookieHash = {};
        for (var key in signatureHash) {
            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
                cookieHash['CloudFront-' + key] = signatureHash[key];
            }
        }

        return handleSuccess(cookieHash, cb);
    },

    /**
     * Create a signed Amazon CloudFront URL.
     *
     * Keep in mind that URLs meant for use in media/flash players may have
     * different requirements for URL formats (e.g. some require that the
     * extension be removed, some require the file name to be prefixed
     * - mp4:<path>, some require you to add "/cfx/st" into your URL).
     *
     * @param options [Object]          The options to create a signed URL.
     * @option options url [String]     The URL to which the signature will grant
     *                                  access. Required.
     * @option options expires [Number] A Unix UTC timestamp indicating when the
     *                                  signature should expire. Required unless you
     *                                  pass in a full policy.
     * @option options policy [String]  A CloudFront JSON policy. Required unless
     *                                  you pass in a url and an expiry time.
     *
     * @param cb [Function] if a callback is provided, this function will
     *   pass the URL as the second parameter (after the error parameter) to
     *   the callback function.
     *
     * @return [String] if called synchronously (with no callback), returns the
     *   signed URL.
     * @return [null] nothing is returned if a callback is provided.
     */
    getSignedUrl: function (options, cb) {
        try {
            var resource = getResource(options.url);
        } catch (err) {
            return handleError(err, cb);
        }

        var parsedUrl = url.parse(options.url, true),
            signatureHash = Object.prototype.hasOwnProperty.call(options, 'policy')
                ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
                : signWithCannedPolicy(resource, options.expires, this.keyPairId, this.privateKey);

        parsedUrl.search = null;
        for (var key in signatureHash) {
            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
                parsedUrl.query[key] = signatureHash[key];
            }
        }

        try {
            var signedUrl = determineScheme(options.url) === 'rtmp'
                    ? getRtmpUrl(url.format(parsedUrl))
                    : url.format(parsedUrl);
        } catch (err) {
            return handleError(err, cb);
        }

        return handleSuccess(signedUrl, cb);
    }
});

module.exports = AWS.CloudFront.Signer;


/***/ }),
/* 1524 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-11-25",
		"endpointPrefix": "cloudfront",
		"globalEndpoint": "cloudfront.amazonaws.com",
		"protocol": "rest-xml",
		"serviceAbbreviation": "CloudFront",
		"serviceFullName": "Amazon CloudFront",
		"signatureVersion": "v4",
		"uid": "cloudfront-2016-11-25"
	},
	"operations": {
		"CreateCloudFrontOriginAccessIdentity": {
			"http": {
				"requestUri": "/2016-11-25/origin-access-identity/cloudfront",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"CloudFrontOriginAccessIdentityConfig"
				],
				"members": {
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2",
						"locationName": "CloudFrontOriginAccessIdentityConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						}
					}
				},
				"payload": "CloudFrontOriginAccessIdentityConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontOriginAccessIdentity": {
						"shape": "S5"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "CloudFrontOriginAccessIdentity"
			}
		},
		"CreateDistribution": {
			"http": {
				"requestUri": "/2016-11-25/distribution",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionConfig"
				],
				"members": {
					"DistributionConfig": {
						"shape": "S7",
						"locationName": "DistributionConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						}
					}
				},
				"payload": "DistributionConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"Distribution": {
						"shape": "S1s"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "Distribution"
			}
		},
		"CreateDistributionWithTags": {
			"http": {
				"requestUri": "/2016-11-25/distribution?WithTags",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionConfigWithTags"
				],
				"members": {
					"DistributionConfigWithTags": {
						"locationName": "DistributionConfigWithTags",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						},
						"type": "structure",
						"required": [
							"DistributionConfig",
							"Tags"
						],
						"members": {
							"DistributionConfig": {
								"shape": "S7"
							},
							"Tags": {
								"shape": "S21"
							}
						}
					}
				},
				"payload": "DistributionConfigWithTags"
			},
			"output": {
				"type": "structure",
				"members": {
					"Distribution": {
						"shape": "S1s"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "Distribution"
			}
		},
		"CreateInvalidation": {
			"http": {
				"requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionId",
					"InvalidationBatch"
				],
				"members": {
					"DistributionId": {
						"location": "uri",
						"locationName": "DistributionId"
					},
					"InvalidationBatch": {
						"shape": "S28",
						"locationName": "InvalidationBatch",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						}
					}
				},
				"payload": "InvalidationBatch"
			},
			"output": {
				"type": "structure",
				"members": {
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"Invalidation": {
						"shape": "S2c"
					}
				},
				"payload": "Invalidation"
			}
		},
		"CreateStreamingDistribution": {
			"http": {
				"requestUri": "/2016-11-25/streaming-distribution",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"StreamingDistributionConfig"
				],
				"members": {
					"StreamingDistributionConfig": {
						"shape": "S2e",
						"locationName": "StreamingDistributionConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						}
					}
				},
				"payload": "StreamingDistributionConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistribution": {
						"shape": "S2i"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "StreamingDistribution"
			}
		},
		"CreateStreamingDistributionWithTags": {
			"http": {
				"requestUri": "/2016-11-25/streaming-distribution?WithTags",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"StreamingDistributionConfigWithTags"
				],
				"members": {
					"StreamingDistributionConfigWithTags": {
						"locationName": "StreamingDistributionConfigWithTags",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						},
						"type": "structure",
						"required": [
							"StreamingDistributionConfig",
							"Tags"
						],
						"members": {
							"StreamingDistributionConfig": {
								"shape": "S2e"
							},
							"Tags": {
								"shape": "S21"
							}
						}
					}
				},
				"payload": "StreamingDistributionConfigWithTags"
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistribution": {
						"shape": "S2i"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "StreamingDistribution"
			}
		},
		"DeleteCloudFrontOriginAccessIdentity": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				}
			}
		},
		"DeleteDistribution": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2016-11-25/distribution/{Id}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				}
			}
		},
		"DeleteStreamingDistribution": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2016-11-25/streaming-distribution/{Id}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				}
			}
		},
		"GetCloudFrontOriginAccessIdentity": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontOriginAccessIdentity": {
						"shape": "S5"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "CloudFrontOriginAccessIdentity"
			}
		},
		"GetCloudFrontOriginAccessIdentityConfig": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "CloudFrontOriginAccessIdentityConfig"
			}
		},
		"GetDistribution": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/distribution/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Distribution": {
						"shape": "S1s"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "Distribution"
			}
		},
		"GetDistributionConfig": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/distribution/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DistributionConfig": {
						"shape": "S7"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "DistributionConfig"
			}
		},
		"GetInvalidation": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionId",
					"Id"
				],
				"members": {
					"DistributionId": {
						"location": "uri",
						"locationName": "DistributionId"
					},
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Invalidation": {
						"shape": "S2c"
					}
				},
				"payload": "Invalidation"
			}
		},
		"GetStreamingDistribution": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/streaming-distribution/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistribution": {
						"shape": "S2i"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "StreamingDistribution"
			}
		},
		"GetStreamingDistributionConfig": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/streaming-distribution/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistributionConfig": {
						"shape": "S2e"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "StreamingDistributionConfig"
			}
		},
		"ListCloudFrontOriginAccessIdentities": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/origin-access-identity/cloudfront"
			},
			"input": {
				"type": "structure",
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontOriginAccessIdentityList": {
						"type": "structure",
						"required": [
							"Marker",
							"MaxItems",
							"IsTruncated",
							"Quantity"
						],
						"members": {
							"Marker": {},
							"NextMarker": {},
							"MaxItems": {
								"type": "integer"
							},
							"IsTruncated": {
								"type": "boolean"
							},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "CloudFrontOriginAccessIdentitySummary",
									"type": "structure",
									"required": [
										"Id",
										"S3CanonicalUserId",
										"Comment"
									],
									"members": {
										"Id": {},
										"S3CanonicalUserId": {},
										"Comment": {}
									}
								}
							}
						}
					}
				},
				"payload": "CloudFrontOriginAccessIdentityList"
			}
		},
		"ListDistributions": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/distribution"
			},
			"input": {
				"type": "structure",
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DistributionList": {
						"shape": "S3a"
					}
				},
				"payload": "DistributionList"
			}
		},
		"ListDistributionsByWebACLId": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/distributionsByWebACLId/{WebACLId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"WebACLId"
				],
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems"
					},
					"WebACLId": {
						"location": "uri",
						"locationName": "WebACLId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DistributionList": {
						"shape": "S3a"
					}
				},
				"payload": "DistributionList"
			}
		},
		"ListInvalidations": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation"
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionId"
				],
				"members": {
					"DistributionId": {
						"location": "uri",
						"locationName": "DistributionId"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InvalidationList": {
						"type": "structure",
						"required": [
							"Marker",
							"MaxItems",
							"IsTruncated",
							"Quantity"
						],
						"members": {
							"Marker": {},
							"NextMarker": {},
							"MaxItems": {
								"type": "integer"
							},
							"IsTruncated": {
								"type": "boolean"
							},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "InvalidationSummary",
									"type": "structure",
									"required": [
										"Id",
										"CreateTime",
										"Status"
									],
									"members": {
										"Id": {},
										"CreateTime": {
											"type": "timestamp"
										},
										"Status": {}
									}
								}
							}
						}
					}
				},
				"payload": "InvalidationList"
			}
		},
		"ListStreamingDistributions": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/streaming-distribution"
			},
			"input": {
				"type": "structure",
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistributionList": {
						"type": "structure",
						"required": [
							"Marker",
							"MaxItems",
							"IsTruncated",
							"Quantity"
						],
						"members": {
							"Marker": {},
							"NextMarker": {},
							"MaxItems": {
								"type": "integer"
							},
							"IsTruncated": {
								"type": "boolean"
							},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "StreamingDistributionSummary",
									"type": "structure",
									"required": [
										"Id",
										"ARN",
										"Status",
										"LastModifiedTime",
										"DomainName",
										"S3Origin",
										"Aliases",
										"TrustedSigners",
										"Comment",
										"PriceClass",
										"Enabled"
									],
									"members": {
										"Id": {},
										"ARN": {},
										"Status": {},
										"LastModifiedTime": {
											"type": "timestamp"
										},
										"DomainName": {},
										"S3Origin": {
											"shape": "S2f"
										},
										"Aliases": {
											"shape": "S8"
										},
										"TrustedSigners": {
											"shape": "Sy"
										},
										"Comment": {},
										"PriceClass": {},
										"Enabled": {
											"type": "boolean"
										}
									}
								}
							}
						}
					}
				},
				"payload": "StreamingDistributionList"
			}
		},
		"ListTagsForResource": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-11-25/tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Resource"
				],
				"members": {
					"Resource": {
						"location": "querystring",
						"locationName": "Resource"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Tags"
				],
				"members": {
					"Tags": {
						"shape": "S21"
					}
				},
				"payload": "Tags"
			}
		},
		"TagResource": {
			"http": {
				"requestUri": "/2016-11-25/tagging?Operation=Tag",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Resource",
					"Tags"
				],
				"members": {
					"Resource": {
						"location": "querystring",
						"locationName": "Resource"
					},
					"Tags": {
						"shape": "S21",
						"locationName": "Tags",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						}
					}
				},
				"payload": "Tags"
			}
		},
		"UntagResource": {
			"http": {
				"requestUri": "/2016-11-25/tagging?Operation=Untag",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Resource",
					"TagKeys"
				],
				"members": {
					"Resource": {
						"location": "querystring",
						"locationName": "Resource"
					},
					"TagKeys": {
						"locationName": "TagKeys",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						},
						"type": "structure",
						"members": {
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Key"
								}
							}
						}
					}
				},
				"payload": "TagKeys"
			}
		},
		"UpdateCloudFrontOriginAccessIdentity": {
			"http": {
				"method": "PUT",
				"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"CloudFrontOriginAccessIdentityConfig",
					"Id"
				],
				"members": {
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2",
						"locationName": "CloudFrontOriginAccessIdentityConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						}
					},
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				},
				"payload": "CloudFrontOriginAccessIdentityConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontOriginAccessIdentity": {
						"shape": "S5"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "CloudFrontOriginAccessIdentity"
			}
		},
		"UpdateDistribution": {
			"http": {
				"method": "PUT",
				"requestUri": "/2016-11-25/distribution/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionConfig",
					"Id"
				],
				"members": {
					"DistributionConfig": {
						"shape": "S7",
						"locationName": "DistributionConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						}
					},
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				},
				"payload": "DistributionConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"Distribution": {
						"shape": "S1s"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "Distribution"
			}
		},
		"UpdateStreamingDistribution": {
			"http": {
				"method": "PUT",
				"requestUri": "/2016-11-25/streaming-distribution/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"StreamingDistributionConfig",
					"Id"
				],
				"members": {
					"StreamingDistributionConfig": {
						"shape": "S2e",
						"locationName": "StreamingDistributionConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
						}
					},
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				},
				"payload": "StreamingDistributionConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistribution": {
						"shape": "S2i"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "StreamingDistribution"
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "structure",
			"required": [
				"CallerReference",
				"Comment"
			],
			"members": {
				"CallerReference": {},
				"Comment": {}
			}
		},
		"S5": {
			"type": "structure",
			"required": [
				"Id",
				"S3CanonicalUserId"
			],
			"members": {
				"Id": {},
				"S3CanonicalUserId": {},
				"CloudFrontOriginAccessIdentityConfig": {
					"shape": "S2"
				}
			}
		},
		"S7": {
			"type": "structure",
			"required": [
				"CallerReference",
				"Origins",
				"DefaultCacheBehavior",
				"Comment",
				"Enabled"
			],
			"members": {
				"CallerReference": {},
				"Aliases": {
					"shape": "S8"
				},
				"DefaultRootObject": {},
				"Origins": {
					"shape": "Sb"
				},
				"DefaultCacheBehavior": {
					"shape": "Sn"
				},
				"CacheBehaviors": {
					"shape": "S1a"
				},
				"CustomErrorResponses": {
					"shape": "S1d"
				},
				"Comment": {},
				"Logging": {
					"type": "structure",
					"required": [
						"Enabled",
						"IncludeCookies",
						"Bucket",
						"Prefix"
					],
					"members": {
						"Enabled": {
							"type": "boolean"
						},
						"IncludeCookies": {
							"type": "boolean"
						},
						"Bucket": {},
						"Prefix": {}
					}
				},
				"PriceClass": {},
				"Enabled": {
					"type": "boolean"
				},
				"ViewerCertificate": {
					"shape": "S1i"
				},
				"Restrictions": {
					"shape": "S1m"
				},
				"WebACLId": {},
				"HttpVersion": {},
				"IsIPV6Enabled": {
					"type": "boolean"
				}
			}
		},
		"S8": {
			"type": "structure",
			"required": [
				"Quantity"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "CNAME"
					}
				}
			}
		},
		"Sb": {
			"type": "structure",
			"required": [
				"Quantity"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "Origin",
						"type": "structure",
						"required": [
							"Id",
							"DomainName"
						],
						"members": {
							"Id": {},
							"DomainName": {},
							"OriginPath": {},
							"CustomHeaders": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "OriginCustomHeader",
											"type": "structure",
											"required": [
												"HeaderName",
												"HeaderValue"
											],
											"members": {
												"HeaderName": {},
												"HeaderValue": {}
											}
										}
									}
								}
							},
							"S3OriginConfig": {
								"type": "structure",
								"required": [
									"OriginAccessIdentity"
								],
								"members": {
									"OriginAccessIdentity": {}
								}
							},
							"CustomOriginConfig": {
								"type": "structure",
								"required": [
									"HTTPPort",
									"HTTPSPort",
									"OriginProtocolPolicy"
								],
								"members": {
									"HTTPPort": {
										"type": "integer"
									},
									"HTTPSPort": {
										"type": "integer"
									},
									"OriginProtocolPolicy": {},
									"OriginSslProtocols": {
										"type": "structure",
										"required": [
											"Quantity",
											"Items"
										],
										"members": {
											"Quantity": {
												"type": "integer"
											},
											"Items": {
												"type": "list",
												"member": {
													"locationName": "SslProtocol"
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"Sn": {
			"type": "structure",
			"required": [
				"TargetOriginId",
				"ForwardedValues",
				"TrustedSigners",
				"ViewerProtocolPolicy",
				"MinTTL"
			],
			"members": {
				"TargetOriginId": {},
				"ForwardedValues": {
					"shape": "So"
				},
				"TrustedSigners": {
					"shape": "Sy"
				},
				"ViewerProtocolPolicy": {},
				"MinTTL": {
					"type": "long"
				},
				"AllowedMethods": {
					"shape": "S12"
				},
				"SmoothStreaming": {
					"type": "boolean"
				},
				"DefaultTTL": {
					"type": "long"
				},
				"MaxTTL": {
					"type": "long"
				},
				"Compress": {
					"type": "boolean"
				},
				"LambdaFunctionAssociations": {
					"shape": "S16"
				}
			}
		},
		"So": {
			"type": "structure",
			"required": [
				"QueryString",
				"Cookies"
			],
			"members": {
				"QueryString": {
					"type": "boolean"
				},
				"Cookies": {
					"type": "structure",
					"required": [
						"Forward"
					],
					"members": {
						"Forward": {},
						"WhitelistedNames": {
							"type": "structure",
							"required": [
								"Quantity"
							],
							"members": {
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "Name"
									}
								}
							}
						}
					}
				},
				"Headers": {
					"type": "structure",
					"required": [
						"Quantity"
					],
					"members": {
						"Quantity": {
							"type": "integer"
						},
						"Items": {
							"type": "list",
							"member": {
								"locationName": "Name"
							}
						}
					}
				},
				"QueryStringCacheKeys": {
					"type": "structure",
					"required": [
						"Quantity"
					],
					"members": {
						"Quantity": {
							"type": "integer"
						},
						"Items": {
							"type": "list",
							"member": {
								"locationName": "Name"
							}
						}
					}
				}
			}
		},
		"Sy": {
			"type": "structure",
			"required": [
				"Enabled",
				"Quantity"
			],
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "AwsAccountNumber"
					}
				}
			}
		},
		"S12": {
			"type": "structure",
			"required": [
				"Quantity",
				"Items"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"shape": "S13"
				},
				"CachedMethods": {
					"type": "structure",
					"required": [
						"Quantity",
						"Items"
					],
					"members": {
						"Quantity": {
							"type": "integer"
						},
						"Items": {
							"shape": "S13"
						}
					}
				}
			}
		},
		"S13": {
			"type": "list",
			"member": {
				"locationName": "Method"
			}
		},
		"S16": {
			"type": "structure",
			"required": [
				"Quantity"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "LambdaFunctionAssociation",
						"type": "structure",
						"members": {
							"LambdaFunctionARN": {},
							"EventType": {}
						}
					}
				}
			}
		},
		"S1a": {
			"type": "structure",
			"required": [
				"Quantity"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "CacheBehavior",
						"type": "structure",
						"required": [
							"PathPattern",
							"TargetOriginId",
							"ForwardedValues",
							"TrustedSigners",
							"ViewerProtocolPolicy",
							"MinTTL"
						],
						"members": {
							"PathPattern": {},
							"TargetOriginId": {},
							"ForwardedValues": {
								"shape": "So"
							},
							"TrustedSigners": {
								"shape": "Sy"
							},
							"ViewerProtocolPolicy": {},
							"MinTTL": {
								"type": "long"
							},
							"AllowedMethods": {
								"shape": "S12"
							},
							"SmoothStreaming": {
								"type": "boolean"
							},
							"DefaultTTL": {
								"type": "long"
							},
							"MaxTTL": {
								"type": "long"
							},
							"Compress": {
								"type": "boolean"
							},
							"LambdaFunctionAssociations": {
								"shape": "S16"
							}
						}
					}
				}
			}
		},
		"S1d": {
			"type": "structure",
			"required": [
				"Quantity"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "CustomErrorResponse",
						"type": "structure",
						"required": [
							"ErrorCode"
						],
						"members": {
							"ErrorCode": {
								"type": "integer"
							},
							"ResponsePagePath": {},
							"ResponseCode": {},
							"ErrorCachingMinTTL": {
								"type": "long"
							}
						}
					}
				}
			}
		},
		"S1i": {
			"type": "structure",
			"members": {
				"CloudFrontDefaultCertificate": {
					"type": "boolean"
				},
				"IAMCertificateId": {},
				"ACMCertificateArn": {},
				"SSLSupportMethod": {},
				"MinimumProtocolVersion": {},
				"Certificate": {
					"deprecated": true
				},
				"CertificateSource": {
					"deprecated": true
				}
			}
		},
		"S1m": {
			"type": "structure",
			"required": [
				"GeoRestriction"
			],
			"members": {
				"GeoRestriction": {
					"type": "structure",
					"required": [
						"RestrictionType",
						"Quantity"
					],
					"members": {
						"RestrictionType": {},
						"Quantity": {
							"type": "integer"
						},
						"Items": {
							"type": "list",
							"member": {
								"locationName": "Location"
							}
						}
					}
				}
			}
		},
		"S1s": {
			"type": "structure",
			"required": [
				"Id",
				"ARN",
				"Status",
				"LastModifiedTime",
				"InProgressInvalidationBatches",
				"DomainName",
				"ActiveTrustedSigners",
				"DistributionConfig"
			],
			"members": {
				"Id": {},
				"ARN": {},
				"Status": {},
				"LastModifiedTime": {
					"type": "timestamp"
				},
				"InProgressInvalidationBatches": {
					"type": "integer"
				},
				"DomainName": {},
				"ActiveTrustedSigners": {
					"shape": "S1u"
				},
				"DistributionConfig": {
					"shape": "S7"
				}
			}
		},
		"S1u": {
			"type": "structure",
			"required": [
				"Enabled",
				"Quantity"
			],
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "Signer",
						"type": "structure",
						"members": {
							"AwsAccountNumber": {},
							"KeyPairIds": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "KeyPairId"
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"S21": {
			"type": "structure",
			"members": {
				"Items": {
					"type": "list",
					"member": {
						"locationName": "Tag",
						"type": "structure",
						"required": [
							"Key"
						],
						"members": {
							"Key": {},
							"Value": {}
						}
					}
				}
			}
		},
		"S28": {
			"type": "structure",
			"required": [
				"Paths",
				"CallerReference"
			],
			"members": {
				"Paths": {
					"type": "structure",
					"required": [
						"Quantity"
					],
					"members": {
						"Quantity": {
							"type": "integer"
						},
						"Items": {
							"type": "list",
							"member": {
								"locationName": "Path"
							}
						}
					}
				},
				"CallerReference": {}
			}
		},
		"S2c": {
			"type": "structure",
			"required": [
				"Id",
				"Status",
				"CreateTime",
				"InvalidationBatch"
			],
			"members": {
				"Id": {},
				"Status": {},
				"CreateTime": {
					"type": "timestamp"
				},
				"InvalidationBatch": {
					"shape": "S28"
				}
			}
		},
		"S2e": {
			"type": "structure",
			"required": [
				"CallerReference",
				"S3Origin",
				"Comment",
				"TrustedSigners",
				"Enabled"
			],
			"members": {
				"CallerReference": {},
				"S3Origin": {
					"shape": "S2f"
				},
				"Aliases": {
					"shape": "S8"
				},
				"Comment": {},
				"Logging": {
					"type": "structure",
					"required": [
						"Enabled",
						"Bucket",
						"Prefix"
					],
					"members": {
						"Enabled": {
							"type": "boolean"
						},
						"Bucket": {},
						"Prefix": {}
					}
				},
				"TrustedSigners": {
					"shape": "Sy"
				},
				"PriceClass": {},
				"Enabled": {
					"type": "boolean"
				}
			}
		},
		"S2f": {
			"type": "structure",
			"required": [
				"DomainName",
				"OriginAccessIdentity"
			],
			"members": {
				"DomainName": {},
				"OriginAccessIdentity": {}
			}
		},
		"S2i": {
			"type": "structure",
			"required": [
				"Id",
				"ARN",
				"Status",
				"DomainName",
				"ActiveTrustedSigners",
				"StreamingDistributionConfig"
			],
			"members": {
				"Id": {},
				"ARN": {},
				"Status": {},
				"LastModifiedTime": {
					"type": "timestamp"
				},
				"DomainName": {},
				"ActiveTrustedSigners": {
					"shape": "S1u"
				},
				"StreamingDistributionConfig": {
					"shape": "S2e"
				}
			}
		},
		"S3a": {
			"type": "structure",
			"required": [
				"Marker",
				"MaxItems",
				"IsTruncated",
				"Quantity"
			],
			"members": {
				"Marker": {},
				"NextMarker": {},
				"MaxItems": {
					"type": "integer"
				},
				"IsTruncated": {
					"type": "boolean"
				},
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "DistributionSummary",
						"type": "structure",
						"required": [
							"Id",
							"ARN",
							"Status",
							"LastModifiedTime",
							"DomainName",
							"Aliases",
							"Origins",
							"DefaultCacheBehavior",
							"CacheBehaviors",
							"CustomErrorResponses",
							"Comment",
							"PriceClass",
							"Enabled",
							"ViewerCertificate",
							"Restrictions",
							"WebACLId",
							"HttpVersion",
							"IsIPV6Enabled"
						],
						"members": {
							"Id": {},
							"ARN": {},
							"Status": {},
							"LastModifiedTime": {
								"type": "timestamp"
							},
							"DomainName": {},
							"Aliases": {
								"shape": "S8"
							},
							"Origins": {
								"shape": "Sb"
							},
							"DefaultCacheBehavior": {
								"shape": "Sn"
							},
							"CacheBehaviors": {
								"shape": "S1a"
							},
							"CustomErrorResponses": {
								"shape": "S1d"
							},
							"Comment": {},
							"PriceClass": {},
							"Enabled": {
								"type": "boolean"
							},
							"ViewerCertificate": {
								"shape": "S1i"
							},
							"Restrictions": {
								"shape": "S1m"
							},
							"WebACLId": {},
							"HttpVersion": {},
							"IsIPV6Enabled": {
								"type": "boolean"
							}
						}
					}
				}
			}
		}
	}
};

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListCloudFrontOriginAccessIdentities": {
			"input_token": "Marker",
			"output_token": "CloudFrontOriginAccessIdentityList.NextMarker",
			"limit_key": "MaxItems",
			"more_results": "CloudFrontOriginAccessIdentityList.IsTruncated",
			"result_key": "CloudFrontOriginAccessIdentityList.Items"
		},
		"ListDistributions": {
			"input_token": "Marker",
			"output_token": "DistributionList.NextMarker",
			"limit_key": "MaxItems",
			"more_results": "DistributionList.IsTruncated",
			"result_key": "DistributionList.Items"
		},
		"ListInvalidations": {
			"input_token": "Marker",
			"output_token": "InvalidationList.NextMarker",
			"limit_key": "MaxItems",
			"more_results": "InvalidationList.IsTruncated",
			"result_key": "InvalidationList.Items"
		},
		"ListStreamingDistributions": {
			"input_token": "Marker",
			"output_token": "StreamingDistributionList.NextMarker",
			"limit_key": "MaxItems",
			"more_results": "StreamingDistributionList.IsTruncated",
			"result_key": "StreamingDistributionList.Items"
		}
	}
};

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"DistributionDeployed": {
			"delay": 60,
			"operation": "GetDistribution",
			"maxAttempts": 25,
			"description": "Wait until a distribution is deployed.",
			"acceptors": [
				{
					"expected": "Deployed",
					"matcher": "path",
					"state": "success",
					"argument": "Distribution.Status"
				}
			]
		},
		"InvalidationCompleted": {
			"delay": 20,
			"operation": "GetInvalidation",
			"maxAttempts": 30,
			"description": "Wait until an invalidation has completed.",
			"acceptors": [
				{
					"expected": "Completed",
					"matcher": "path",
					"state": "success",
					"argument": "Invalidation.Status"
				}
			]
		},
		"StreamingDistributionDeployed": {
			"delay": 60,
			"operation": "GetStreamingDistribution",
			"maxAttempts": 25,
			"description": "Wait until a streaming distribution is deployed.",
			"acceptors": [
				{
					"expected": "Deployed",
					"matcher": "path",
					"state": "success",
					"argument": "StreamingDistribution.Status"
				}
			]
		}
	}
};

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2017-03-25",
		"endpointPrefix": "cloudfront",
		"globalEndpoint": "cloudfront.amazonaws.com",
		"protocol": "rest-xml",
		"serviceAbbreviation": "CloudFront",
		"serviceFullName": "Amazon CloudFront",
		"signatureVersion": "v4",
		"uid": "cloudfront-2017-03-25"
	},
	"operations": {
		"CreateCloudFrontOriginAccessIdentity": {
			"http": {
				"requestUri": "/2017-03-25/origin-access-identity/cloudfront",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"CloudFrontOriginAccessIdentityConfig"
				],
				"members": {
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2",
						"locationName": "CloudFrontOriginAccessIdentityConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						}
					}
				},
				"payload": "CloudFrontOriginAccessIdentityConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontOriginAccessIdentity": {
						"shape": "S5"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "CloudFrontOriginAccessIdentity"
			}
		},
		"CreateDistribution": {
			"http": {
				"requestUri": "/2017-03-25/distribution",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionConfig"
				],
				"members": {
					"DistributionConfig": {
						"shape": "S7",
						"locationName": "DistributionConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						}
					}
				},
				"payload": "DistributionConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"Distribution": {
						"shape": "S1s"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "Distribution"
			}
		},
		"CreateDistributionWithTags": {
			"http": {
				"requestUri": "/2017-03-25/distribution?WithTags",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionConfigWithTags"
				],
				"members": {
					"DistributionConfigWithTags": {
						"locationName": "DistributionConfigWithTags",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						},
						"type": "structure",
						"required": [
							"DistributionConfig",
							"Tags"
						],
						"members": {
							"DistributionConfig": {
								"shape": "S7"
							},
							"Tags": {
								"shape": "S21"
							}
						}
					}
				},
				"payload": "DistributionConfigWithTags"
			},
			"output": {
				"type": "structure",
				"members": {
					"Distribution": {
						"shape": "S1s"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "Distribution"
			}
		},
		"CreateInvalidation": {
			"http": {
				"requestUri": "/2017-03-25/distribution/{DistributionId}/invalidation",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionId",
					"InvalidationBatch"
				],
				"members": {
					"DistributionId": {
						"location": "uri",
						"locationName": "DistributionId"
					},
					"InvalidationBatch": {
						"shape": "S28",
						"locationName": "InvalidationBatch",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						}
					}
				},
				"payload": "InvalidationBatch"
			},
			"output": {
				"type": "structure",
				"members": {
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"Invalidation": {
						"shape": "S2c"
					}
				},
				"payload": "Invalidation"
			}
		},
		"CreateStreamingDistribution": {
			"http": {
				"requestUri": "/2017-03-25/streaming-distribution",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"StreamingDistributionConfig"
				],
				"members": {
					"StreamingDistributionConfig": {
						"shape": "S2e",
						"locationName": "StreamingDistributionConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						}
					}
				},
				"payload": "StreamingDistributionConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistribution": {
						"shape": "S2i"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "StreamingDistribution"
			}
		},
		"CreateStreamingDistributionWithTags": {
			"http": {
				"requestUri": "/2017-03-25/streaming-distribution?WithTags",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"StreamingDistributionConfigWithTags"
				],
				"members": {
					"StreamingDistributionConfigWithTags": {
						"locationName": "StreamingDistributionConfigWithTags",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						},
						"type": "structure",
						"required": [
							"StreamingDistributionConfig",
							"Tags"
						],
						"members": {
							"StreamingDistributionConfig": {
								"shape": "S2e"
							},
							"Tags": {
								"shape": "S21"
							}
						}
					}
				},
				"payload": "StreamingDistributionConfigWithTags"
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistribution": {
						"shape": "S2i"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "StreamingDistribution"
			}
		},
		"DeleteCloudFrontOriginAccessIdentity": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				}
			}
		},
		"DeleteDistribution": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2017-03-25/distribution/{Id}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				}
			}
		},
		"DeleteStreamingDistribution": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2017-03-25/streaming-distribution/{Id}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				}
			}
		},
		"GetCloudFrontOriginAccessIdentity": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontOriginAccessIdentity": {
						"shape": "S5"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "CloudFrontOriginAccessIdentity"
			}
		},
		"GetCloudFrontOriginAccessIdentityConfig": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "CloudFrontOriginAccessIdentityConfig"
			}
		},
		"GetDistribution": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/distribution/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Distribution": {
						"shape": "S1s"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "Distribution"
			}
		},
		"GetDistributionConfig": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/distribution/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DistributionConfig": {
						"shape": "S7"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "DistributionConfig"
			}
		},
		"GetInvalidation": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/distribution/{DistributionId}/invalidation/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionId",
					"Id"
				],
				"members": {
					"DistributionId": {
						"location": "uri",
						"locationName": "DistributionId"
					},
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Invalidation": {
						"shape": "S2c"
					}
				},
				"payload": "Invalidation"
			}
		},
		"GetStreamingDistribution": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/streaming-distribution/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistribution": {
						"shape": "S2i"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "StreamingDistribution"
			}
		},
		"GetStreamingDistributionConfig": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/streaming-distribution/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistributionConfig": {
						"shape": "S2e"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "StreamingDistributionConfig"
			}
		},
		"ListCloudFrontOriginAccessIdentities": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/origin-access-identity/cloudfront"
			},
			"input": {
				"type": "structure",
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontOriginAccessIdentityList": {
						"type": "structure",
						"required": [
							"Marker",
							"MaxItems",
							"IsTruncated",
							"Quantity"
						],
						"members": {
							"Marker": {},
							"NextMarker": {},
							"MaxItems": {
								"type": "integer"
							},
							"IsTruncated": {
								"type": "boolean"
							},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "CloudFrontOriginAccessIdentitySummary",
									"type": "structure",
									"required": [
										"Id",
										"S3CanonicalUserId",
										"Comment"
									],
									"members": {
										"Id": {},
										"S3CanonicalUserId": {},
										"Comment": {}
									}
								}
							}
						}
					}
				},
				"payload": "CloudFrontOriginAccessIdentityList"
			}
		},
		"ListDistributions": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/distribution"
			},
			"input": {
				"type": "structure",
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DistributionList": {
						"shape": "S3a"
					}
				},
				"payload": "DistributionList"
			}
		},
		"ListDistributionsByWebACLId": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/distributionsByWebACLId/{WebACLId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"WebACLId"
				],
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems"
					},
					"WebACLId": {
						"location": "uri",
						"locationName": "WebACLId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DistributionList": {
						"shape": "S3a"
					}
				},
				"payload": "DistributionList"
			}
		},
		"ListInvalidations": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/distribution/{DistributionId}/invalidation"
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionId"
				],
				"members": {
					"DistributionId": {
						"location": "uri",
						"locationName": "DistributionId"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InvalidationList": {
						"type": "structure",
						"required": [
							"Marker",
							"MaxItems",
							"IsTruncated",
							"Quantity"
						],
						"members": {
							"Marker": {},
							"NextMarker": {},
							"MaxItems": {
								"type": "integer"
							},
							"IsTruncated": {
								"type": "boolean"
							},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "InvalidationSummary",
									"type": "structure",
									"required": [
										"Id",
										"CreateTime",
										"Status"
									],
									"members": {
										"Id": {},
										"CreateTime": {
											"type": "timestamp"
										},
										"Status": {}
									}
								}
							}
						}
					}
				},
				"payload": "InvalidationList"
			}
		},
		"ListStreamingDistributions": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/streaming-distribution"
			},
			"input": {
				"type": "structure",
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistributionList": {
						"type": "structure",
						"required": [
							"Marker",
							"MaxItems",
							"IsTruncated",
							"Quantity"
						],
						"members": {
							"Marker": {},
							"NextMarker": {},
							"MaxItems": {
								"type": "integer"
							},
							"IsTruncated": {
								"type": "boolean"
							},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "StreamingDistributionSummary",
									"type": "structure",
									"required": [
										"Id",
										"ARN",
										"Status",
										"LastModifiedTime",
										"DomainName",
										"S3Origin",
										"Aliases",
										"TrustedSigners",
										"Comment",
										"PriceClass",
										"Enabled"
									],
									"members": {
										"Id": {},
										"ARN": {},
										"Status": {},
										"LastModifiedTime": {
											"type": "timestamp"
										},
										"DomainName": {},
										"S3Origin": {
											"shape": "S2f"
										},
										"Aliases": {
											"shape": "S8"
										},
										"TrustedSigners": {
											"shape": "Sy"
										},
										"Comment": {},
										"PriceClass": {},
										"Enabled": {
											"type": "boolean"
										}
									}
								}
							}
						}
					}
				},
				"payload": "StreamingDistributionList"
			}
		},
		"ListTagsForResource": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-25/tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Resource"
				],
				"members": {
					"Resource": {
						"location": "querystring",
						"locationName": "Resource"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Tags"
				],
				"members": {
					"Tags": {
						"shape": "S21"
					}
				},
				"payload": "Tags"
			}
		},
		"TagResource": {
			"http": {
				"requestUri": "/2017-03-25/tagging?Operation=Tag",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Resource",
					"Tags"
				],
				"members": {
					"Resource": {
						"location": "querystring",
						"locationName": "Resource"
					},
					"Tags": {
						"shape": "S21",
						"locationName": "Tags",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						}
					}
				},
				"payload": "Tags"
			}
		},
		"UntagResource": {
			"http": {
				"requestUri": "/2017-03-25/tagging?Operation=Untag",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Resource",
					"TagKeys"
				],
				"members": {
					"Resource": {
						"location": "querystring",
						"locationName": "Resource"
					},
					"TagKeys": {
						"locationName": "TagKeys",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						},
						"type": "structure",
						"members": {
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Key"
								}
							}
						}
					}
				},
				"payload": "TagKeys"
			}
		},
		"UpdateCloudFrontOriginAccessIdentity": {
			"http": {
				"method": "PUT",
				"requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"CloudFrontOriginAccessIdentityConfig",
					"Id"
				],
				"members": {
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2",
						"locationName": "CloudFrontOriginAccessIdentityConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						}
					},
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				},
				"payload": "CloudFrontOriginAccessIdentityConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontOriginAccessIdentity": {
						"shape": "S5"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "CloudFrontOriginAccessIdentity"
			}
		},
		"UpdateDistribution": {
			"http": {
				"method": "PUT",
				"requestUri": "/2017-03-25/distribution/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"DistributionConfig",
					"Id"
				],
				"members": {
					"DistributionConfig": {
						"shape": "S7",
						"locationName": "DistributionConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						}
					},
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				},
				"payload": "DistributionConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"Distribution": {
						"shape": "S1s"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "Distribution"
			}
		},
		"UpdateStreamingDistribution": {
			"http": {
				"method": "PUT",
				"requestUri": "/2017-03-25/streaming-distribution/{Id}/config"
			},
			"input": {
				"type": "structure",
				"required": [
					"StreamingDistributionConfig",
					"Id"
				],
				"members": {
					"StreamingDistributionConfig": {
						"shape": "S2e",
						"locationName": "StreamingDistributionConfig",
						"xmlNamespace": {
							"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
						}
					},
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					}
				},
				"payload": "StreamingDistributionConfig"
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamingDistribution": {
						"shape": "S2i"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					}
				},
				"payload": "StreamingDistribution"
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "structure",
			"required": [
				"CallerReference",
				"Comment"
			],
			"members": {
				"CallerReference": {},
				"Comment": {}
			}
		},
		"S5": {
			"type": "structure",
			"required": [
				"Id",
				"S3CanonicalUserId"
			],
			"members": {
				"Id": {},
				"S3CanonicalUserId": {},
				"CloudFrontOriginAccessIdentityConfig": {
					"shape": "S2"
				}
			}
		},
		"S7": {
			"type": "structure",
			"required": [
				"CallerReference",
				"Origins",
				"DefaultCacheBehavior",
				"Comment",
				"Enabled"
			],
			"members": {
				"CallerReference": {},
				"Aliases": {
					"shape": "S8"
				},
				"DefaultRootObject": {},
				"Origins": {
					"shape": "Sb"
				},
				"DefaultCacheBehavior": {
					"shape": "Sn"
				},
				"CacheBehaviors": {
					"shape": "S1a"
				},
				"CustomErrorResponses": {
					"shape": "S1d"
				},
				"Comment": {},
				"Logging": {
					"type": "structure",
					"required": [
						"Enabled",
						"IncludeCookies",
						"Bucket",
						"Prefix"
					],
					"members": {
						"Enabled": {
							"type": "boolean"
						},
						"IncludeCookies": {
							"type": "boolean"
						},
						"Bucket": {},
						"Prefix": {}
					}
				},
				"PriceClass": {},
				"Enabled": {
					"type": "boolean"
				},
				"ViewerCertificate": {
					"shape": "S1i"
				},
				"Restrictions": {
					"shape": "S1m"
				},
				"WebACLId": {},
				"HttpVersion": {},
				"IsIPV6Enabled": {
					"type": "boolean"
				}
			}
		},
		"S8": {
			"type": "structure",
			"required": [
				"Quantity"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "CNAME"
					}
				}
			}
		},
		"Sb": {
			"type": "structure",
			"required": [
				"Quantity"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "Origin",
						"type": "structure",
						"required": [
							"Id",
							"DomainName"
						],
						"members": {
							"Id": {},
							"DomainName": {},
							"OriginPath": {},
							"CustomHeaders": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "OriginCustomHeader",
											"type": "structure",
											"required": [
												"HeaderName",
												"HeaderValue"
											],
											"members": {
												"HeaderName": {},
												"HeaderValue": {}
											}
										}
									}
								}
							},
							"S3OriginConfig": {
								"type": "structure",
								"required": [
									"OriginAccessIdentity"
								],
								"members": {
									"OriginAccessIdentity": {}
								}
							},
							"CustomOriginConfig": {
								"type": "structure",
								"required": [
									"HTTPPort",
									"HTTPSPort",
									"OriginProtocolPolicy"
								],
								"members": {
									"HTTPPort": {
										"type": "integer"
									},
									"HTTPSPort": {
										"type": "integer"
									},
									"OriginProtocolPolicy": {},
									"OriginSslProtocols": {
										"type": "structure",
										"required": [
											"Quantity",
											"Items"
										],
										"members": {
											"Quantity": {
												"type": "integer"
											},
											"Items": {
												"type": "list",
												"member": {
													"locationName": "SslProtocol"
												}
											}
										}
									},
									"OriginReadTimeout": {
										"type": "integer"
									},
									"OriginKeepaliveTimeout": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			}
		},
		"Sn": {
			"type": "structure",
			"required": [
				"TargetOriginId",
				"ForwardedValues",
				"TrustedSigners",
				"ViewerProtocolPolicy",
				"MinTTL"
			],
			"members": {
				"TargetOriginId": {},
				"ForwardedValues": {
					"shape": "So"
				},
				"TrustedSigners": {
					"shape": "Sy"
				},
				"ViewerProtocolPolicy": {},
				"MinTTL": {
					"type": "long"
				},
				"AllowedMethods": {
					"shape": "S12"
				},
				"SmoothStreaming": {
					"type": "boolean"
				},
				"DefaultTTL": {
					"type": "long"
				},
				"MaxTTL": {
					"type": "long"
				},
				"Compress": {
					"type": "boolean"
				},
				"LambdaFunctionAssociations": {
					"shape": "S16"
				}
			}
		},
		"So": {
			"type": "structure",
			"required": [
				"QueryString",
				"Cookies"
			],
			"members": {
				"QueryString": {
					"type": "boolean"
				},
				"Cookies": {
					"type": "structure",
					"required": [
						"Forward"
					],
					"members": {
						"Forward": {},
						"WhitelistedNames": {
							"type": "structure",
							"required": [
								"Quantity"
							],
							"members": {
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "Name"
									}
								}
							}
						}
					}
				},
				"Headers": {
					"type": "structure",
					"required": [
						"Quantity"
					],
					"members": {
						"Quantity": {
							"type": "integer"
						},
						"Items": {
							"type": "list",
							"member": {
								"locationName": "Name"
							}
						}
					}
				},
				"QueryStringCacheKeys": {
					"type": "structure",
					"required": [
						"Quantity"
					],
					"members": {
						"Quantity": {
							"type": "integer"
						},
						"Items": {
							"type": "list",
							"member": {
								"locationName": "Name"
							}
						}
					}
				}
			}
		},
		"Sy": {
			"type": "structure",
			"required": [
				"Enabled",
				"Quantity"
			],
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "AwsAccountNumber"
					}
				}
			}
		},
		"S12": {
			"type": "structure",
			"required": [
				"Quantity",
				"Items"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"shape": "S13"
				},
				"CachedMethods": {
					"type": "structure",
					"required": [
						"Quantity",
						"Items"
					],
					"members": {
						"Quantity": {
							"type": "integer"
						},
						"Items": {
							"shape": "S13"
						}
					}
				}
			}
		},
		"S13": {
			"type": "list",
			"member": {
				"locationName": "Method"
			}
		},
		"S16": {
			"type": "structure",
			"required": [
				"Quantity"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "LambdaFunctionAssociation",
						"type": "structure",
						"members": {
							"LambdaFunctionARN": {},
							"EventType": {}
						}
					}
				}
			}
		},
		"S1a": {
			"type": "structure",
			"required": [
				"Quantity"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "CacheBehavior",
						"type": "structure",
						"required": [
							"PathPattern",
							"TargetOriginId",
							"ForwardedValues",
							"TrustedSigners",
							"ViewerProtocolPolicy",
							"MinTTL"
						],
						"members": {
							"PathPattern": {},
							"TargetOriginId": {},
							"ForwardedValues": {
								"shape": "So"
							},
							"TrustedSigners": {
								"shape": "Sy"
							},
							"ViewerProtocolPolicy": {},
							"MinTTL": {
								"type": "long"
							},
							"AllowedMethods": {
								"shape": "S12"
							},
							"SmoothStreaming": {
								"type": "boolean"
							},
							"DefaultTTL": {
								"type": "long"
							},
							"MaxTTL": {
								"type": "long"
							},
							"Compress": {
								"type": "boolean"
							},
							"LambdaFunctionAssociations": {
								"shape": "S16"
							}
						}
					}
				}
			}
		},
		"S1d": {
			"type": "structure",
			"required": [
				"Quantity"
			],
			"members": {
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "CustomErrorResponse",
						"type": "structure",
						"required": [
							"ErrorCode"
						],
						"members": {
							"ErrorCode": {
								"type": "integer"
							},
							"ResponsePagePath": {},
							"ResponseCode": {},
							"ErrorCachingMinTTL": {
								"type": "long"
							}
						}
					}
				}
			}
		},
		"S1i": {
			"type": "structure",
			"members": {
				"CloudFrontDefaultCertificate": {
					"type": "boolean"
				},
				"IAMCertificateId": {},
				"ACMCertificateArn": {},
				"SSLSupportMethod": {},
				"MinimumProtocolVersion": {},
				"Certificate": {
					"deprecated": true
				},
				"CertificateSource": {
					"deprecated": true
				}
			}
		},
		"S1m": {
			"type": "structure",
			"required": [
				"GeoRestriction"
			],
			"members": {
				"GeoRestriction": {
					"type": "structure",
					"required": [
						"RestrictionType",
						"Quantity"
					],
					"members": {
						"RestrictionType": {},
						"Quantity": {
							"type": "integer"
						},
						"Items": {
							"type": "list",
							"member": {
								"locationName": "Location"
							}
						}
					}
				}
			}
		},
		"S1s": {
			"type": "structure",
			"required": [
				"Id",
				"ARN",
				"Status",
				"LastModifiedTime",
				"InProgressInvalidationBatches",
				"DomainName",
				"ActiveTrustedSigners",
				"DistributionConfig"
			],
			"members": {
				"Id": {},
				"ARN": {},
				"Status": {},
				"LastModifiedTime": {
					"type": "timestamp"
				},
				"InProgressInvalidationBatches": {
					"type": "integer"
				},
				"DomainName": {},
				"ActiveTrustedSigners": {
					"shape": "S1u"
				},
				"DistributionConfig": {
					"shape": "S7"
				}
			}
		},
		"S1u": {
			"type": "structure",
			"required": [
				"Enabled",
				"Quantity"
			],
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "Signer",
						"type": "structure",
						"members": {
							"AwsAccountNumber": {},
							"KeyPairIds": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "KeyPairId"
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"S21": {
			"type": "structure",
			"members": {
				"Items": {
					"type": "list",
					"member": {
						"locationName": "Tag",
						"type": "structure",
						"required": [
							"Key"
						],
						"members": {
							"Key": {},
							"Value": {}
						}
					}
				}
			}
		},
		"S28": {
			"type": "structure",
			"required": [
				"Paths",
				"CallerReference"
			],
			"members": {
				"Paths": {
					"type": "structure",
					"required": [
						"Quantity"
					],
					"members": {
						"Quantity": {
							"type": "integer"
						},
						"Items": {
							"type": "list",
							"member": {
								"locationName": "Path"
							}
						}
					}
				},
				"CallerReference": {}
			}
		},
		"S2c": {
			"type": "structure",
			"required": [
				"Id",
				"Status",
				"CreateTime",
				"InvalidationBatch"
			],
			"members": {
				"Id": {},
				"Status": {},
				"CreateTime": {
					"type": "timestamp"
				},
				"InvalidationBatch": {
					"shape": "S28"
				}
			}
		},
		"S2e": {
			"type": "structure",
			"required": [
				"CallerReference",
				"S3Origin",
				"Comment",
				"TrustedSigners",
				"Enabled"
			],
			"members": {
				"CallerReference": {},
				"S3Origin": {
					"shape": "S2f"
				},
				"Aliases": {
					"shape": "S8"
				},
				"Comment": {},
				"Logging": {
					"type": "structure",
					"required": [
						"Enabled",
						"Bucket",
						"Prefix"
					],
					"members": {
						"Enabled": {
							"type": "boolean"
						},
						"Bucket": {},
						"Prefix": {}
					}
				},
				"TrustedSigners": {
					"shape": "Sy"
				},
				"PriceClass": {},
				"Enabled": {
					"type": "boolean"
				}
			}
		},
		"S2f": {
			"type": "structure",
			"required": [
				"DomainName",
				"OriginAccessIdentity"
			],
			"members": {
				"DomainName": {},
				"OriginAccessIdentity": {}
			}
		},
		"S2i": {
			"type": "structure",
			"required": [
				"Id",
				"ARN",
				"Status",
				"DomainName",
				"ActiveTrustedSigners",
				"StreamingDistributionConfig"
			],
			"members": {
				"Id": {},
				"ARN": {},
				"Status": {},
				"LastModifiedTime": {
					"type": "timestamp"
				},
				"DomainName": {},
				"ActiveTrustedSigners": {
					"shape": "S1u"
				},
				"StreamingDistributionConfig": {
					"shape": "S2e"
				}
			}
		},
		"S3a": {
			"type": "structure",
			"required": [
				"Marker",
				"MaxItems",
				"IsTruncated",
				"Quantity"
			],
			"members": {
				"Marker": {},
				"NextMarker": {},
				"MaxItems": {
					"type": "integer"
				},
				"IsTruncated": {
					"type": "boolean"
				},
				"Quantity": {
					"type": "integer"
				},
				"Items": {
					"type": "list",
					"member": {
						"locationName": "DistributionSummary",
						"type": "structure",
						"required": [
							"Id",
							"ARN",
							"Status",
							"LastModifiedTime",
							"DomainName",
							"Aliases",
							"Origins",
							"DefaultCacheBehavior",
							"CacheBehaviors",
							"CustomErrorResponses",
							"Comment",
							"PriceClass",
							"Enabled",
							"ViewerCertificate",
							"Restrictions",
							"WebACLId",
							"HttpVersion",
							"IsIPV6Enabled"
						],
						"members": {
							"Id": {},
							"ARN": {},
							"Status": {},
							"LastModifiedTime": {
								"type": "timestamp"
							},
							"DomainName": {},
							"Aliases": {
								"shape": "S8"
							},
							"Origins": {
								"shape": "Sb"
							},
							"DefaultCacheBehavior": {
								"shape": "Sn"
							},
							"CacheBehaviors": {
								"shape": "S1a"
							},
							"CustomErrorResponses": {
								"shape": "S1d"
							},
							"Comment": {},
							"PriceClass": {},
							"Enabled": {
								"type": "boolean"
							},
							"ViewerCertificate": {
								"shape": "S1i"
							},
							"Restrictions": {
								"shape": "S1m"
							},
							"WebACLId": {},
							"HttpVersion": {},
							"IsIPV6Enabled": {
								"type": "boolean"
							}
						}
					}
				}
			}
		}
	}
};

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListCloudFrontOriginAccessIdentities": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"more_results": "CloudFrontOriginAccessIdentityList.IsTruncated",
			"output_token": "CloudFrontOriginAccessIdentityList.NextMarker",
			"result_key": "CloudFrontOriginAccessIdentityList.Items"
		},
		"ListDistributions": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"more_results": "DistributionList.IsTruncated",
			"output_token": "DistributionList.NextMarker",
			"result_key": "DistributionList.Items"
		},
		"ListInvalidations": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"more_results": "InvalidationList.IsTruncated",
			"output_token": "InvalidationList.NextMarker",
			"result_key": "InvalidationList.Items"
		},
		"ListStreamingDistributions": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"more_results": "StreamingDistributionList.IsTruncated",
			"output_token": "StreamingDistributionList.NextMarker",
			"result_key": "StreamingDistributionList.Items"
		}
	}
};

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"DistributionDeployed": {
			"delay": 60,
			"operation": "GetDistribution",
			"maxAttempts": 25,
			"description": "Wait until a distribution is deployed.",
			"acceptors": [
				{
					"expected": "Deployed",
					"matcher": "path",
					"state": "success",
					"argument": "Distribution.Status"
				}
			]
		},
		"InvalidationCompleted": {
			"delay": 20,
			"operation": "GetInvalidation",
			"maxAttempts": 30,
			"description": "Wait until an invalidation has completed.",
			"acceptors": [
				{
					"expected": "Completed",
					"matcher": "path",
					"state": "success",
					"argument": "Invalidation.Status"
				}
			]
		},
		"StreamingDistributionDeployed": {
			"delay": 60,
			"operation": "GetStreamingDistribution",
			"maxAttempts": 25,
			"description": "Wait until a streaming distribution is deployed.",
			"acceptors": [
				{
					"expected": "Deployed",
					"matcher": "path",
					"state": "success",
					"argument": "StreamingDistribution.Status"
				}
			]
		}
	}
};

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudhsm'] = {};
AWS.CloudHSM = Service.defineService('cloudhsm', ['2014-05-30']);
Object.defineProperty(apiLoader.services['cloudhsm'], '2014-05-30', {
  get: function get() {
    var model = __webpack_require__(1531);
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudHSM;


/***/ }),
/* 1531 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-05-30",
		"endpointPrefix": "cloudhsm",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "CloudHSM",
		"serviceFullName": "Amazon CloudHSM",
		"signatureVersion": "v4",
		"targetPrefix": "CloudHsmFrontendService",
		"uid": "cloudhsm-2014-05-30"
	},
	"operations": {
		"AddTagsToResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn",
					"TagList"
				],
				"members": {
					"ResourceArn": {},
					"TagList": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Status"
				],
				"members": {
					"Status": {}
				}
			}
		},
		"CreateHapg": {
			"input": {
				"type": "structure",
				"required": [
					"Label"
				],
				"members": {
					"Label": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HapgArn": {}
				}
			}
		},
		"CreateHsm": {
			"input": {
				"type": "structure",
				"required": [
					"SubnetId",
					"SshKey",
					"IamRoleArn",
					"SubscriptionType"
				],
				"members": {
					"SubnetId": {
						"locationName": "SubnetId"
					},
					"SshKey": {
						"locationName": "SshKey"
					},
					"EniIp": {
						"locationName": "EniIp"
					},
					"IamRoleArn": {
						"locationName": "IamRoleArn"
					},
					"ExternalId": {
						"locationName": "ExternalId"
					},
					"SubscriptionType": {
						"locationName": "SubscriptionType"
					},
					"ClientToken": {
						"locationName": "ClientToken"
					},
					"SyslogIp": {
						"locationName": "SyslogIp"
					}
				},
				"locationName": "CreateHsmRequest"
			},
			"output": {
				"type": "structure",
				"members": {
					"HsmArn": {}
				}
			}
		},
		"CreateLunaClient": {
			"input": {
				"type": "structure",
				"required": [
					"Certificate"
				],
				"members": {
					"Label": {},
					"Certificate": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientArn": {}
				}
			}
		},
		"DeleteHapg": {
			"input": {
				"type": "structure",
				"required": [
					"HapgArn"
				],
				"members": {
					"HapgArn": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Status"
				],
				"members": {
					"Status": {}
				}
			}
		},
		"DeleteHsm": {
			"input": {
				"type": "structure",
				"required": [
					"HsmArn"
				],
				"members": {
					"HsmArn": {
						"locationName": "HsmArn"
					}
				},
				"locationName": "DeleteHsmRequest"
			},
			"output": {
				"type": "structure",
				"required": [
					"Status"
				],
				"members": {
					"Status": {}
				}
			}
		},
		"DeleteLunaClient": {
			"input": {
				"type": "structure",
				"required": [
					"ClientArn"
				],
				"members": {
					"ClientArn": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Status"
				],
				"members": {
					"Status": {}
				}
			}
		},
		"DescribeHapg": {
			"input": {
				"type": "structure",
				"required": [
					"HapgArn"
				],
				"members": {
					"HapgArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HapgArn": {},
					"HapgSerial": {},
					"HsmsLastActionFailed": {
						"shape": "Sz"
					},
					"HsmsPendingDeletion": {
						"shape": "Sz"
					},
					"HsmsPendingRegistration": {
						"shape": "Sz"
					},
					"Label": {},
					"LastModifiedTimestamp": {},
					"PartitionSerialList": {
						"shape": "S11"
					},
					"State": {}
				}
			}
		},
		"DescribeHsm": {
			"input": {
				"type": "structure",
				"members": {
					"HsmArn": {},
					"HsmSerialNumber": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HsmArn": {},
					"Status": {},
					"StatusDetails": {},
					"AvailabilityZone": {},
					"EniId": {},
					"EniIp": {},
					"SubscriptionType": {},
					"SubscriptionStartDate": {},
					"SubscriptionEndDate": {},
					"VpcId": {},
					"SubnetId": {},
					"IamRoleArn": {},
					"SerialNumber": {},
					"VendorName": {},
					"HsmType": {},
					"SoftwareVersion": {},
					"SshPublicKey": {},
					"SshKeyLastUpdated": {},
					"ServerCertUri": {},
					"ServerCertLastUpdated": {},
					"Partitions": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"DescribeLunaClient": {
			"input": {
				"type": "structure",
				"members": {
					"ClientArn": {},
					"CertificateFingerprint": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientArn": {},
					"Certificate": {},
					"CertificateFingerprint": {},
					"LastModifiedTimestamp": {},
					"Label": {}
				}
			}
		},
		"GetConfig": {
			"input": {
				"type": "structure",
				"required": [
					"ClientArn",
					"ClientVersion",
					"HapgList"
				],
				"members": {
					"ClientArn": {},
					"ClientVersion": {},
					"HapgList": {
						"shape": "S1i"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConfigType": {},
					"ConfigFile": {},
					"ConfigCred": {}
				}
			}
		},
		"ListAvailableZones": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"AZList": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"ListHapgs": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HapgList"
				],
				"members": {
					"HapgList": {
						"shape": "S1i"
					},
					"NextToken": {}
				}
			}
		},
		"ListHsms": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HsmList": {
						"shape": "Sz"
					},
					"NextToken": {}
				}
			}
		},
		"ListLunaClients": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ClientList"
				],
				"members": {
					"ClientList": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			}
		},
		"ListTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn"
				],
				"members": {
					"ResourceArn": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TagList"
				],
				"members": {
					"TagList": {
						"shape": "S3"
					}
				}
			}
		},
		"ModifyHapg": {
			"input": {
				"type": "structure",
				"required": [
					"HapgArn"
				],
				"members": {
					"HapgArn": {},
					"Label": {},
					"PartitionSerialList": {
						"shape": "S11"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HapgArn": {}
				}
			}
		},
		"ModifyHsm": {
			"input": {
				"type": "structure",
				"required": [
					"HsmArn"
				],
				"members": {
					"HsmArn": {
						"locationName": "HsmArn"
					},
					"SubnetId": {
						"locationName": "SubnetId"
					},
					"EniIp": {
						"locationName": "EniIp"
					},
					"IamRoleArn": {
						"locationName": "IamRoleArn"
					},
					"ExternalId": {
						"locationName": "ExternalId"
					},
					"SyslogIp": {
						"locationName": "SyslogIp"
					}
				},
				"locationName": "ModifyHsmRequest"
			},
			"output": {
				"type": "structure",
				"members": {
					"HsmArn": {}
				}
			}
		},
		"ModifyLunaClient": {
			"input": {
				"type": "structure",
				"required": [
					"ClientArn",
					"Certificate"
				],
				"members": {
					"ClientArn": {},
					"Certificate": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientArn": {}
				}
			}
		},
		"RemoveTagsFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn",
					"TagKeyList"
				],
				"members": {
					"ResourceArn": {},
					"TagKeyList": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Status"
				],
				"members": {
					"Status": {}
				}
			}
		}
	},
	"shapes": {
		"S3": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Sz": {
			"type": "list",
			"member": {}
		},
		"S11": {
			"type": "list",
			"member": {}
		},
		"S1i": {
			"type": "list",
			"member": {}
		}
	}
};

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudtrail'] = {};
AWS.CloudTrail = Service.defineService('cloudtrail', ['2013-11-01']);
Object.defineProperty(apiLoader.services['cloudtrail'], '2013-11-01', {
  get: function get() {
    var model = __webpack_require__(1533);
    model.paginators = __webpack_require__(1534).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudTrail;


/***/ }),
/* 1533 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2013-11-01",
		"endpointPrefix": "cloudtrail",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "CloudTrail",
		"serviceFullName": "AWS CloudTrail",
		"signatureVersion": "v4",
		"targetPrefix": "com.amazonaws.cloudtrail.v20131101.CloudTrail_20131101",
		"uid": "cloudtrail-2013-11-01"
	},
	"operations": {
		"AddTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"ResourceId": {},
					"TagsList": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"CreateTrail": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"S3BucketName"
				],
				"members": {
					"Name": {},
					"S3BucketName": {},
					"S3KeyPrefix": {},
					"SnsTopicName": {},
					"IncludeGlobalServiceEvents": {
						"type": "boolean"
					},
					"IsMultiRegionTrail": {
						"type": "boolean"
					},
					"EnableLogFileValidation": {
						"type": "boolean"
					},
					"CloudWatchLogsLogGroupArn": {},
					"CloudWatchLogsRoleArn": {},
					"KmsKeyId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Name": {},
					"S3BucketName": {},
					"S3KeyPrefix": {},
					"SnsTopicName": {
						"deprecated": true
					},
					"SnsTopicARN": {},
					"IncludeGlobalServiceEvents": {
						"type": "boolean"
					},
					"IsMultiRegionTrail": {
						"type": "boolean"
					},
					"TrailARN": {},
					"LogFileValidationEnabled": {
						"type": "boolean"
					},
					"CloudWatchLogsLogGroupArn": {},
					"CloudWatchLogsRoleArn": {},
					"KmsKeyId": {}
				}
			},
			"idempotent": true
		},
		"DeleteTrail": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"DescribeTrails": {
			"input": {
				"type": "structure",
				"members": {
					"trailNameList": {
						"type": "list",
						"member": {}
					},
					"includeShadowTrails": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"trailList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"S3BucketName": {},
								"S3KeyPrefix": {},
								"SnsTopicName": {
									"deprecated": true
								},
								"SnsTopicARN": {},
								"IncludeGlobalServiceEvents": {
									"type": "boolean"
								},
								"IsMultiRegionTrail": {
									"type": "boolean"
								},
								"HomeRegion": {},
								"TrailARN": {},
								"LogFileValidationEnabled": {
									"type": "boolean"
								},
								"CloudWatchLogsLogGroupArn": {},
								"CloudWatchLogsRoleArn": {},
								"KmsKeyId": {},
								"HasCustomEventSelectors": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"idempotent": true
		},
		"GetEventSelectors": {
			"input": {
				"type": "structure",
				"required": [
					"TrailName"
				],
				"members": {
					"TrailName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TrailARN": {},
					"EventSelectors": {
						"shape": "Si"
					}
				}
			},
			"idempotent": true
		},
		"GetTrailStatus": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsLogging": {
						"type": "boolean"
					},
					"LatestDeliveryError": {},
					"LatestNotificationError": {},
					"LatestDeliveryTime": {
						"type": "timestamp"
					},
					"LatestNotificationTime": {
						"type": "timestamp"
					},
					"StartLoggingTime": {
						"type": "timestamp"
					},
					"StopLoggingTime": {
						"type": "timestamp"
					},
					"LatestCloudWatchLogsDeliveryError": {},
					"LatestCloudWatchLogsDeliveryTime": {
						"type": "timestamp"
					},
					"LatestDigestDeliveryTime": {
						"type": "timestamp"
					},
					"LatestDigestDeliveryError": {},
					"LatestDeliveryAttemptTime": {},
					"LatestNotificationAttemptTime": {},
					"LatestNotificationAttemptSucceeded": {},
					"LatestDeliveryAttemptSucceeded": {},
					"TimeLoggingStarted": {},
					"TimeLoggingStopped": {}
				}
			},
			"idempotent": true
		},
		"ListPublicKeys": {
			"input": {
				"type": "structure",
				"members": {
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PublicKeyList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Value": {
									"type": "blob"
								},
								"ValidityStartTime": {
									"type": "timestamp"
								},
								"ValidityEndTime": {
									"type": "timestamp"
								},
								"Fingerprint": {}
							}
						}
					},
					"NextToken": {}
				}
			},
			"idempotent": true
		},
		"ListTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceIdList"
				],
				"members": {
					"ResourceIdList": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceTagList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ResourceId": {},
								"TagsList": {
									"shape": "S3"
								}
							}
						}
					},
					"NextToken": {}
				}
			},
			"idempotent": true
		},
		"LookupEvents": {
			"input": {
				"type": "structure",
				"members": {
					"LookupAttributes": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"AttributeKey",
								"AttributeValue"
							],
							"members": {
								"AttributeKey": {},
								"AttributeValue": {}
							}
						}
					},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Events": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EventId": {},
								"EventName": {},
								"EventTime": {
									"type": "timestamp"
								},
								"EventSource": {},
								"Username": {},
								"Resources": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ResourceType": {},
											"ResourceName": {}
										}
									}
								},
								"CloudTrailEvent": {}
							}
						}
					},
					"NextToken": {}
				}
			},
			"idempotent": true
		},
		"PutEventSelectors": {
			"input": {
				"type": "structure",
				"required": [
					"TrailName",
					"EventSelectors"
				],
				"members": {
					"TrailName": {},
					"EventSelectors": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TrailARN": {},
					"EventSelectors": {
						"shape": "Si"
					}
				}
			},
			"idempotent": true
		},
		"RemoveTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"ResourceId": {},
					"TagsList": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"StartLogging": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"StopLogging": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"UpdateTrail": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"S3BucketName": {},
					"S3KeyPrefix": {},
					"SnsTopicName": {},
					"IncludeGlobalServiceEvents": {
						"type": "boolean"
					},
					"IsMultiRegionTrail": {
						"type": "boolean"
					},
					"EnableLogFileValidation": {
						"type": "boolean"
					},
					"CloudWatchLogsLogGroupArn": {},
					"CloudWatchLogsRoleArn": {},
					"KmsKeyId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Name": {},
					"S3BucketName": {},
					"S3KeyPrefix": {},
					"SnsTopicName": {
						"deprecated": true
					},
					"SnsTopicARN": {},
					"IncludeGlobalServiceEvents": {
						"type": "boolean"
					},
					"IsMultiRegionTrail": {
						"type": "boolean"
					},
					"TrailARN": {},
					"LogFileValidationEnabled": {
						"type": "boolean"
					},
					"CloudWatchLogsLogGroupArn": {},
					"CloudWatchLogsRoleArn": {},
					"KmsKeyId": {}
				}
			},
			"idempotent": true
		}
	},
	"shapes": {
		"S3": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Si": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ReadWriteType": {},
					"IncludeManagementEvents": {
						"type": "boolean"
					},
					"DataResources": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Type": {},
								"Values": {
									"type": "list",
									"member": {}
								}
							}
						}
					}
				}
			}
		}
	}
};

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeTrails": {
			"result_key": "trailList"
		},
		"LookupEvents": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Events"
		}
	}
};

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudwatch'] = {};
AWS.CloudWatch = Service.defineService('cloudwatch', ['2010-08-01']);
Object.defineProperty(apiLoader.services['cloudwatch'], '2010-08-01', {
  get: function get() {
    var model = __webpack_require__(1536);
    model.paginators = __webpack_require__(1537).pagination;
    model.waiters = __webpack_require__(1538).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudWatch;


/***/ }),
/* 1536 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2010-08-01",
		"endpointPrefix": "monitoring",
		"protocol": "query",
		"serviceAbbreviation": "CloudWatch",
		"serviceFullName": "Amazon CloudWatch",
		"signatureVersion": "v4",
		"uid": "monitoring-2010-08-01",
		"xmlNamespace": "http://monitoring.amazonaws.com/doc/2010-08-01/"
	},
	"operations": {
		"DeleteAlarms": {
			"input": {
				"type": "structure",
				"required": [
					"AlarmNames"
				],
				"members": {
					"AlarmNames": {
						"shape": "S2"
					}
				}
			}
		},
		"DeleteDashboards": {
			"input": {
				"type": "structure",
				"members": {
					"DashboardNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "DeleteDashboardsResult",
				"type": "structure",
				"members": {}
			}
		},
		"DescribeAlarmHistory": {
			"input": {
				"type": "structure",
				"members": {
					"AlarmName": {},
					"HistoryItemType": {},
					"StartDate": {
						"type": "timestamp"
					},
					"EndDate": {
						"type": "timestamp"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeAlarmHistoryResult",
				"type": "structure",
				"members": {
					"AlarmHistoryItems": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AlarmName": {},
								"Timestamp": {
									"type": "timestamp"
								},
								"HistoryItemType": {},
								"HistorySummary": {},
								"HistoryData": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeAlarms": {
			"input": {
				"type": "structure",
				"members": {
					"AlarmNames": {
						"shape": "S2"
					},
					"AlarmNamePrefix": {},
					"StateValue": {},
					"ActionPrefix": {},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeAlarmsResult",
				"type": "structure",
				"members": {
					"MetricAlarms": {
						"shape": "Sn"
					},
					"NextToken": {}
				}
			}
		},
		"DescribeAlarmsForMetric": {
			"input": {
				"type": "structure",
				"required": [
					"MetricName",
					"Namespace"
				],
				"members": {
					"MetricName": {},
					"Namespace": {},
					"Statistic": {},
					"ExtendedStatistic": {},
					"Dimensions": {
						"shape": "S10"
					},
					"Period": {
						"type": "integer"
					},
					"Unit": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeAlarmsForMetricResult",
				"type": "structure",
				"members": {
					"MetricAlarms": {
						"shape": "Sn"
					}
				}
			}
		},
		"DisableAlarmActions": {
			"input": {
				"type": "structure",
				"required": [
					"AlarmNames"
				],
				"members": {
					"AlarmNames": {
						"shape": "S2"
					}
				}
			}
		},
		"EnableAlarmActions": {
			"input": {
				"type": "structure",
				"required": [
					"AlarmNames"
				],
				"members": {
					"AlarmNames": {
						"shape": "S2"
					}
				}
			}
		},
		"GetDashboard": {
			"input": {
				"type": "structure",
				"members": {
					"DashboardName": {}
				}
			},
			"output": {
				"resultWrapper": "GetDashboardResult",
				"type": "structure",
				"members": {
					"DashboardArn": {},
					"DashboardBody": {},
					"DashboardName": {}
				}
			}
		},
		"GetMetricStatistics": {
			"input": {
				"type": "structure",
				"required": [
					"Namespace",
					"MetricName",
					"StartTime",
					"EndTime",
					"Period"
				],
				"members": {
					"Namespace": {},
					"MetricName": {},
					"Dimensions": {
						"shape": "S10"
					},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Period": {
						"type": "integer"
					},
					"Statistics": {
						"type": "list",
						"member": {}
					},
					"ExtendedStatistics": {
						"type": "list",
						"member": {}
					},
					"Unit": {}
				}
			},
			"output": {
				"resultWrapper": "GetMetricStatisticsResult",
				"type": "structure",
				"members": {
					"Label": {},
					"Datapoints": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Timestamp": {
									"type": "timestamp"
								},
								"SampleCount": {
									"type": "double"
								},
								"Average": {
									"type": "double"
								},
								"Sum": {
									"type": "double"
								},
								"Minimum": {
									"type": "double"
								},
								"Maximum": {
									"type": "double"
								},
								"Unit": {},
								"ExtendedStatistics": {
									"type": "map",
									"key": {},
									"value": {
										"type": "double"
									}
								}
							},
							"xmlOrder": [
								"Timestamp",
								"SampleCount",
								"Average",
								"Sum",
								"Minimum",
								"Maximum",
								"Unit",
								"ExtendedStatistics"
							]
						}
					}
				}
			}
		},
		"ListDashboards": {
			"input": {
				"type": "structure",
				"members": {
					"DashboardNamePrefix": {},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListDashboardsResult",
				"type": "structure",
				"members": {
					"DashboardEntries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"DashboardName": {},
								"DashboardArn": {},
								"LastModified": {
									"type": "timestamp"
								},
								"Size": {
									"type": "long"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListMetrics": {
			"input": {
				"type": "structure",
				"members": {
					"Namespace": {},
					"MetricName": {},
					"Dimensions": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Name"
							],
							"members": {
								"Name": {},
								"Value": {}
							}
						}
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListMetricsResult",
				"type": "structure",
				"members": {
					"Metrics": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Namespace": {},
								"MetricName": {},
								"Dimensions": {
									"shape": "S10"
								}
							},
							"xmlOrder": [
								"Namespace",
								"MetricName",
								"Dimensions"
							]
						}
					},
					"NextToken": {}
				},
				"xmlOrder": [
					"Metrics",
					"NextToken"
				]
			}
		},
		"PutDashboard": {
			"input": {
				"type": "structure",
				"members": {
					"DashboardName": {},
					"DashboardBody": {}
				}
			},
			"output": {
				"resultWrapper": "PutDashboardResult",
				"type": "structure",
				"members": {
					"DashboardValidationMessages": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"DataPath": {},
								"Message": {}
							}
						}
					}
				}
			}
		},
		"PutMetricAlarm": {
			"input": {
				"type": "structure",
				"required": [
					"AlarmName",
					"MetricName",
					"Namespace",
					"Period",
					"EvaluationPeriods",
					"Threshold",
					"ComparisonOperator"
				],
				"members": {
					"AlarmName": {},
					"AlarmDescription": {},
					"ActionsEnabled": {
						"type": "boolean"
					},
					"OKActions": {
						"shape": "Ss"
					},
					"AlarmActions": {
						"shape": "Ss"
					},
					"InsufficientDataActions": {
						"shape": "Ss"
					},
					"MetricName": {},
					"Namespace": {},
					"Statistic": {},
					"ExtendedStatistic": {},
					"Dimensions": {
						"shape": "S10"
					},
					"Period": {
						"type": "integer"
					},
					"Unit": {},
					"EvaluationPeriods": {
						"type": "integer"
					},
					"Threshold": {
						"type": "double"
					},
					"ComparisonOperator": {},
					"TreatMissingData": {},
					"EvaluateLowSampleCountPercentile": {}
				}
			}
		},
		"PutMetricData": {
			"input": {
				"type": "structure",
				"required": [
					"Namespace",
					"MetricData"
				],
				"members": {
					"Namespace": {},
					"MetricData": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"MetricName"
							],
							"members": {
								"MetricName": {},
								"Dimensions": {
									"shape": "S10"
								},
								"Timestamp": {
									"type": "timestamp"
								},
								"Value": {
									"type": "double"
								},
								"StatisticValues": {
									"type": "structure",
									"required": [
										"SampleCount",
										"Sum",
										"Minimum",
										"Maximum"
									],
									"members": {
										"SampleCount": {
											"type": "double"
										},
										"Sum": {
											"type": "double"
										},
										"Minimum": {
											"type": "double"
										},
										"Maximum": {
											"type": "double"
										}
									}
								},
								"Unit": {},
								"StorageResolution": {
									"type": "integer"
								}
							}
						}
					}
				}
			}
		},
		"SetAlarmState": {
			"input": {
				"type": "structure",
				"required": [
					"AlarmName",
					"StateValue",
					"StateReason"
				],
				"members": {
					"AlarmName": {},
					"StateValue": {},
					"StateReason": {},
					"StateReasonData": {}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "list",
			"member": {}
		},
		"Sn": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"AlarmName": {},
					"AlarmArn": {},
					"AlarmDescription": {},
					"AlarmConfigurationUpdatedTimestamp": {
						"type": "timestamp"
					},
					"ActionsEnabled": {
						"type": "boolean"
					},
					"OKActions": {
						"shape": "Ss"
					},
					"AlarmActions": {
						"shape": "Ss"
					},
					"InsufficientDataActions": {
						"shape": "Ss"
					},
					"StateValue": {},
					"StateReason": {},
					"StateReasonData": {},
					"StateUpdatedTimestamp": {
						"type": "timestamp"
					},
					"MetricName": {},
					"Namespace": {},
					"Statistic": {},
					"ExtendedStatistic": {},
					"Dimensions": {
						"shape": "S10"
					},
					"Period": {
						"type": "integer"
					},
					"Unit": {},
					"EvaluationPeriods": {
						"type": "integer"
					},
					"Threshold": {
						"type": "double"
					},
					"ComparisonOperator": {},
					"TreatMissingData": {},
					"EvaluateLowSampleCountPercentile": {}
				},
				"xmlOrder": [
					"AlarmName",
					"AlarmArn",
					"AlarmDescription",
					"AlarmConfigurationUpdatedTimestamp",
					"ActionsEnabled",
					"OKActions",
					"AlarmActions",
					"InsufficientDataActions",
					"StateValue",
					"StateReason",
					"StateReasonData",
					"StateUpdatedTimestamp",
					"MetricName",
					"Namespace",
					"Statistic",
					"Dimensions",
					"Period",
					"Unit",
					"EvaluationPeriods",
					"Threshold",
					"ComparisonOperator",
					"ExtendedStatistic",
					"TreatMissingData",
					"EvaluateLowSampleCountPercentile"
				]
			}
		},
		"Ss": {
			"type": "list",
			"member": {}
		},
		"S10": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Name",
					"Value"
				],
				"members": {
					"Name": {},
					"Value": {}
				},
				"xmlOrder": [
					"Name",
					"Value"
				]
			}
		}
	}
};

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeAlarmHistory": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "AlarmHistoryItems"
		},
		"DescribeAlarms": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "MetricAlarms"
		},
		"DescribeAlarmsForMetric": {
			"result_key": "MetricAlarms"
		},
		"ListMetrics": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "Metrics"
		}
	}
};

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"AlarmExists": {
			"delay": 5,
			"maxAttempts": 40,
			"operation": "DescribeAlarms",
			"acceptors": [
				{
					"matcher": "path",
					"expected": true,
					"argument": "length(MetricAlarms[]) > `0`",
					"state": "success"
				}
			]
		}
	}
};

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudwatchevents'] = {};
AWS.CloudWatchEvents = Service.defineService('cloudwatchevents', ['2014-02-03*', '2015-10-07']);
Object.defineProperty(apiLoader.services['cloudwatchevents'], '2015-10-07', {
  get: function get() {
    var model = __webpack_require__(1540);
    model.paginators = __webpack_require__(1541).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudWatchEvents;


/***/ }),
/* 1540 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-10-07",
		"endpointPrefix": "events",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon CloudWatch Events",
		"signatureVersion": "v4",
		"targetPrefix": "AWSEvents",
		"uid": "events-2015-10-07"
	},
	"operations": {
		"DeleteRule": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			}
		},
		"DescribeEventBus": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"Name": {},
					"Arn": {},
					"Policy": {}
				}
			}
		},
		"DescribeRule": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Name": {},
					"Arn": {},
					"EventPattern": {},
					"ScheduleExpression": {},
					"State": {},
					"Description": {},
					"RoleArn": {}
				}
			}
		},
		"DisableRule": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			}
		},
		"EnableRule": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			}
		},
		"ListRuleNamesByTarget": {
			"input": {
				"type": "structure",
				"required": [
					"TargetArn"
				],
				"members": {
					"TargetArn": {},
					"NextToken": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RuleNames": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			}
		},
		"ListRules": {
			"input": {
				"type": "structure",
				"members": {
					"NamePrefix": {},
					"NextToken": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Rules": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Arn": {},
								"EventPattern": {},
								"State": {},
								"Description": {},
								"ScheduleExpression": {},
								"RoleArn": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListTargetsByRule": {
			"input": {
				"type": "structure",
				"required": [
					"Rule"
				],
				"members": {
					"Rule": {},
					"NextToken": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Targets": {
						"shape": "Ss"
					},
					"NextToken": {}
				}
			}
		},
		"PutEvents": {
			"input": {
				"type": "structure",
				"required": [
					"Entries"
				],
				"members": {
					"Entries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Time": {
									"type": "timestamp"
								},
								"Source": {},
								"Resources": {
									"type": "list",
									"member": {}
								},
								"DetailType": {},
								"Detail": {}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FailedEntryCount": {
						"type": "integer"
					},
					"Entries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EventId": {},
								"ErrorCode": {},
								"ErrorMessage": {}
							}
						}
					}
				}
			}
		},
		"PutPermission": {
			"input": {
				"type": "structure",
				"required": [
					"Action",
					"Principal",
					"StatementId"
				],
				"members": {
					"Action": {},
					"Principal": {},
					"StatementId": {}
				}
			}
		},
		"PutRule": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"ScheduleExpression": {},
					"EventPattern": {},
					"State": {},
					"Description": {},
					"RoleArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RuleArn": {}
				}
			}
		},
		"PutTargets": {
			"input": {
				"type": "structure",
				"required": [
					"Rule",
					"Targets"
				],
				"members": {
					"Rule": {},
					"Targets": {
						"shape": "Ss"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FailedEntryCount": {
						"type": "integer"
					},
					"FailedEntries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"TargetId": {},
								"ErrorCode": {},
								"ErrorMessage": {}
							}
						}
					}
				}
			}
		},
		"RemovePermission": {
			"input": {
				"type": "structure",
				"required": [
					"StatementId"
				],
				"members": {
					"StatementId": {}
				}
			}
		},
		"RemoveTargets": {
			"input": {
				"type": "structure",
				"required": [
					"Rule",
					"Ids"
				],
				"members": {
					"Rule": {},
					"Ids": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FailedEntryCount": {
						"type": "integer"
					},
					"FailedEntries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"TargetId": {},
								"ErrorCode": {},
								"ErrorMessage": {}
							}
						}
					}
				}
			}
		},
		"TestEventPattern": {
			"input": {
				"type": "structure",
				"required": [
					"EventPattern",
					"Event"
				],
				"members": {
					"EventPattern": {},
					"Event": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Result": {
						"type": "boolean"
					}
				}
			}
		}
	},
	"shapes": {
		"Ss": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Id",
					"Arn"
				],
				"members": {
					"Id": {},
					"Arn": {},
					"RoleArn": {},
					"Input": {},
					"InputPath": {},
					"InputTransformer": {
						"type": "structure",
						"required": [
							"InputTemplate"
						],
						"members": {
							"InputPathsMap": {
								"type": "map",
								"key": {},
								"value": {}
							},
							"InputTemplate": {}
						}
					},
					"KinesisParameters": {
						"type": "structure",
						"required": [
							"PartitionKeyPath"
						],
						"members": {
							"PartitionKeyPath": {}
						}
					},
					"RunCommandParameters": {
						"type": "structure",
						"required": [
							"RunCommandTargets"
						],
						"members": {
							"RunCommandTargets": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"Key",
										"Values"
									],
									"members": {
										"Key": {},
										"Values": {
											"type": "list",
											"member": {}
										}
									}
								}
							}
						}
					},
					"EcsParameters": {
						"type": "structure",
						"required": [
							"TaskDefinitionArn"
						],
						"members": {
							"TaskDefinitionArn": {},
							"TaskCount": {
								"type": "integer"
							}
						}
					}
				}
			}
		}
	}
};

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cloudwatchlogs'] = {};
AWS.CloudWatchLogs = Service.defineService('cloudwatchlogs', ['2014-03-28']);
Object.defineProperty(apiLoader.services['cloudwatchlogs'], '2014-03-28', {
  get: function get() {
    var model = __webpack_require__(1543);
    model.paginators = __webpack_require__(1544).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CloudWatchLogs;


/***/ }),
/* 1543 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-03-28",
		"endpointPrefix": "logs",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon CloudWatch Logs",
		"signatureVersion": "v4",
		"targetPrefix": "Logs_20140328",
		"uid": "logs-2014-03-28"
	},
	"operations": {
		"CancelExportTask": {
			"input": {
				"type": "structure",
				"required": [
					"taskId"
				],
				"members": {
					"taskId": {}
				}
			}
		},
		"CreateExportTask": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"from",
					"to",
					"destination"
				],
				"members": {
					"taskName": {},
					"logGroupName": {},
					"logStreamNamePrefix": {},
					"from": {
						"type": "long"
					},
					"to": {
						"type": "long"
					},
					"destination": {},
					"destinationPrefix": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskId": {}
				}
			}
		},
		"CreateLogGroup": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName"
				],
				"members": {
					"logGroupName": {},
					"tags": {
						"shape": "Sc"
					}
				}
			}
		},
		"CreateLogStream": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"logStreamName"
				],
				"members": {
					"logGroupName": {},
					"logStreamName": {}
				}
			}
		},
		"DeleteDestination": {
			"input": {
				"type": "structure",
				"required": [
					"destinationName"
				],
				"members": {
					"destinationName": {}
				}
			}
		},
		"DeleteLogGroup": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName"
				],
				"members": {
					"logGroupName": {}
				}
			}
		},
		"DeleteLogStream": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"logStreamName"
				],
				"members": {
					"logGroupName": {},
					"logStreamName": {}
				}
			}
		},
		"DeleteMetricFilter": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"filterName"
				],
				"members": {
					"logGroupName": {},
					"filterName": {}
				}
			}
		},
		"DeleteRetentionPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName"
				],
				"members": {
					"logGroupName": {}
				}
			}
		},
		"DeleteSubscriptionFilter": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"filterName"
				],
				"members": {
					"logGroupName": {},
					"filterName": {}
				}
			}
		},
		"DescribeDestinations": {
			"input": {
				"type": "structure",
				"members": {
					"DestinationNamePrefix": {},
					"nextToken": {},
					"limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"destinations": {
						"type": "list",
						"member": {
							"shape": "St"
						}
					},
					"nextToken": {}
				}
			}
		},
		"DescribeExportTasks": {
			"input": {
				"type": "structure",
				"members": {
					"taskId": {},
					"statusCode": {},
					"nextToken": {},
					"limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"exportTasks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"taskId": {},
								"taskName": {},
								"logGroupName": {},
								"from": {
									"type": "long"
								},
								"to": {
									"type": "long"
								},
								"destination": {},
								"destinationPrefix": {},
								"status": {
									"type": "structure",
									"members": {
										"code": {},
										"message": {}
									}
								},
								"executionInfo": {
									"type": "structure",
									"members": {
										"creationTime": {
											"type": "long"
										},
										"completionTime": {
											"type": "long"
										}
									}
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"DescribeLogGroups": {
			"input": {
				"type": "structure",
				"members": {
					"logGroupNamePrefix": {},
					"nextToken": {},
					"limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"logGroups": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"logGroupName": {},
								"creationTime": {
									"type": "long"
								},
								"retentionInDays": {
									"type": "integer"
								},
								"metricFilterCount": {
									"type": "integer"
								},
								"arn": {},
								"storedBytes": {
									"type": "long"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"DescribeLogStreams": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName"
				],
				"members": {
					"logGroupName": {},
					"logStreamNamePrefix": {},
					"orderBy": {},
					"descending": {
						"type": "boolean"
					},
					"nextToken": {},
					"limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"logStreams": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"logStreamName": {},
								"creationTime": {
									"type": "long"
								},
								"firstEventTimestamp": {
									"type": "long"
								},
								"lastEventTimestamp": {
									"type": "long"
								},
								"lastIngestionTime": {
									"type": "long"
								},
								"uploadSequenceToken": {},
								"arn": {},
								"storedBytes": {
									"type": "long"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"DescribeMetricFilters": {
			"input": {
				"type": "structure",
				"members": {
					"logGroupName": {},
					"filterNamePrefix": {},
					"nextToken": {},
					"limit": {
						"type": "integer"
					},
					"metricName": {},
					"metricNamespace": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"metricFilters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"filterName": {},
								"filterPattern": {},
								"metricTransformations": {
									"shape": "S1r"
								},
								"creationTime": {
									"type": "long"
								},
								"logGroupName": {}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"DescribeSubscriptionFilters": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName"
				],
				"members": {
					"logGroupName": {},
					"filterNamePrefix": {},
					"nextToken": {},
					"limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"subscriptionFilters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"filterName": {},
								"logGroupName": {},
								"filterPattern": {},
								"destinationArn": {},
								"roleArn": {},
								"distribution": {},
								"creationTime": {
									"type": "long"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"FilterLogEvents": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName"
				],
				"members": {
					"logGroupName": {},
					"logStreamNames": {
						"type": "list",
						"member": {}
					},
					"startTime": {
						"type": "long"
					},
					"endTime": {
						"type": "long"
					},
					"filterPattern": {},
					"nextToken": {},
					"limit": {
						"type": "integer"
					},
					"interleaved": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"events": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"logStreamName": {},
								"timestamp": {
									"type": "long"
								},
								"message": {},
								"ingestionTime": {
									"type": "long"
								},
								"eventId": {}
							}
						}
					},
					"searchedLogStreams": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"logStreamName": {},
								"searchedCompletely": {
									"type": "boolean"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"GetLogEvents": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"logStreamName"
				],
				"members": {
					"logGroupName": {},
					"logStreamName": {},
					"startTime": {
						"type": "long"
					},
					"endTime": {
						"type": "long"
					},
					"nextToken": {},
					"limit": {
						"type": "integer"
					},
					"startFromHead": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"events": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"timestamp": {
									"type": "long"
								},
								"message": {},
								"ingestionTime": {
									"type": "long"
								}
							}
						}
					},
					"nextForwardToken": {},
					"nextBackwardToken": {}
				}
			}
		},
		"ListTagsLogGroup": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName"
				],
				"members": {
					"logGroupName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tags": {
						"shape": "Sc"
					}
				}
			}
		},
		"PutDestination": {
			"input": {
				"type": "structure",
				"required": [
					"destinationName",
					"targetArn",
					"roleArn"
				],
				"members": {
					"destinationName": {},
					"targetArn": {},
					"roleArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"destination": {
						"shape": "St"
					}
				}
			}
		},
		"PutDestinationPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"destinationName",
					"accessPolicy"
				],
				"members": {
					"destinationName": {},
					"accessPolicy": {}
				}
			}
		},
		"PutLogEvents": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"logStreamName",
					"logEvents"
				],
				"members": {
					"logGroupName": {},
					"logStreamName": {},
					"logEvents": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"timestamp",
								"message"
							],
							"members": {
								"timestamp": {
									"type": "long"
								},
								"message": {}
							}
						}
					},
					"sequenceToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"nextSequenceToken": {},
					"rejectedLogEventsInfo": {
						"type": "structure",
						"members": {
							"tooNewLogEventStartIndex": {
								"type": "integer"
							},
							"tooOldLogEventEndIndex": {
								"type": "integer"
							},
							"expiredLogEventEndIndex": {
								"type": "integer"
							}
						}
					}
				}
			}
		},
		"PutMetricFilter": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"filterName",
					"filterPattern",
					"metricTransformations"
				],
				"members": {
					"logGroupName": {},
					"filterName": {},
					"filterPattern": {},
					"metricTransformations": {
						"shape": "S1r"
					}
				}
			}
		},
		"PutRetentionPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"retentionInDays"
				],
				"members": {
					"logGroupName": {},
					"retentionInDays": {
						"type": "integer"
					}
				}
			}
		},
		"PutSubscriptionFilter": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"filterName",
					"filterPattern",
					"destinationArn"
				],
				"members": {
					"logGroupName": {},
					"filterName": {},
					"filterPattern": {},
					"destinationArn": {},
					"roleArn": {},
					"distribution": {}
				}
			}
		},
		"TagLogGroup": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"tags"
				],
				"members": {
					"logGroupName": {},
					"tags": {
						"shape": "Sc"
					}
				}
			}
		},
		"TestMetricFilter": {
			"input": {
				"type": "structure",
				"required": [
					"filterPattern",
					"logEventMessages"
				],
				"members": {
					"filterPattern": {},
					"logEventMessages": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"matches": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"eventNumber": {
									"type": "long"
								},
								"eventMessage": {},
								"extractedValues": {
									"type": "map",
									"key": {},
									"value": {}
								}
							}
						}
					}
				}
			}
		},
		"UntagLogGroup": {
			"input": {
				"type": "structure",
				"required": [
					"logGroupName",
					"tags"
				],
				"members": {
					"logGroupName": {},
					"tags": {
						"type": "list",
						"member": {}
					}
				}
			}
		}
	},
	"shapes": {
		"Sc": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"St": {
			"type": "structure",
			"members": {
				"destinationName": {},
				"targetArn": {},
				"roleArn": {},
				"accessPolicy": {},
				"arn": {},
				"creationTime": {
					"type": "long"
				}
			}
		},
		"S1r": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"metricName",
					"metricNamespace",
					"metricValue"
				],
				"members": {
					"metricName": {},
					"metricNamespace": {},
					"metricValue": {},
					"defaultValue": {
						"type": "double"
					}
				}
			}
		}
	}
};

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeDestinations": {
			"input_token": "nextToken",
			"limit_key": "limit",
			"output_token": "nextToken",
			"result_key": "destinations"
		},
		"DescribeLogGroups": {
			"input_token": "nextToken",
			"limit_key": "limit",
			"output_token": "nextToken",
			"result_key": "logGroups"
		},
		"DescribeLogStreams": {
			"input_token": "nextToken",
			"limit_key": "limit",
			"output_token": "nextToken",
			"result_key": "logStreams"
		},
		"DescribeMetricFilters": {
			"input_token": "nextToken",
			"limit_key": "limit",
			"output_token": "nextToken",
			"result_key": "metricFilters"
		},
		"DescribeSubscriptionFilters": {
			"input_token": "nextToken",
			"limit_key": "limit",
			"output_token": "nextToken",
			"result_key": "subscriptionFilters"
		},
		"FilterLogEvents": {
			"input_token": "nextToken",
			"limit_key": "limit",
			"output_token": "nextToken",
			"result_key": [
				"events",
				"searchedLogStreams"
			]
		},
		"GetLogEvents": {
			"input_token": "nextToken",
			"limit_key": "limit",
			"output_token": "nextForwardToken",
			"result_key": "events"
		}
	}
};

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['codecommit'] = {};
AWS.CodeCommit = Service.defineService('codecommit', ['2015-04-13']);
Object.defineProperty(apiLoader.services['codecommit'], '2015-04-13', {
  get: function get() {
    var model = __webpack_require__(1546);
    model.paginators = __webpack_require__(1547).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CodeCommit;


/***/ }),
/* 1546 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-04-13",
		"endpointPrefix": "codecommit",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "CodeCommit",
		"serviceFullName": "AWS CodeCommit",
		"signatureVersion": "v4",
		"targetPrefix": "CodeCommit_20150413",
		"uid": "codecommit-2015-04-13"
	},
	"operations": {
		"BatchGetRepositories": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryNames"
				],
				"members": {
					"repositoryNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"repositories": {
						"type": "list",
						"member": {
							"shape": "S6"
						}
					},
					"repositoriesNotFound": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"CreateBranch": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"branchName",
					"commitId"
				],
				"members": {
					"repositoryName": {},
					"branchName": {},
					"commitId": {}
				}
			}
		},
		"CreateRepository": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"repositoryName": {},
					"repositoryDescription": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"repositoryMetadata": {
						"shape": "S6"
					}
				}
			}
		},
		"DeleteRepository": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"repositoryName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"repositoryId": {}
				}
			}
		},
		"GetBlob": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"blobId"
				],
				"members": {
					"repositoryName": {},
					"blobId": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"content"
				],
				"members": {
					"content": {
						"type": "blob"
					}
				}
			}
		},
		"GetBranch": {
			"input": {
				"type": "structure",
				"members": {
					"repositoryName": {},
					"branchName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"branch": {
						"type": "structure",
						"members": {
							"branchName": {},
							"commitId": {}
						}
					}
				}
			}
		},
		"GetCommit": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"commitId"
				],
				"members": {
					"repositoryName": {},
					"commitId": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"commit"
				],
				"members": {
					"commit": {
						"type": "structure",
						"members": {
							"treeId": {},
							"parents": {
								"type": "list",
								"member": {}
							},
							"message": {},
							"author": {
								"shape": "Sz"
							},
							"committer": {
								"shape": "Sz"
							},
							"additionalData": {}
						}
					}
				}
			}
		},
		"GetDifferences": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"afterCommitSpecifier"
				],
				"members": {
					"repositoryName": {},
					"beforeCommitSpecifier": {},
					"afterCommitSpecifier": {},
					"beforePath": {},
					"afterPath": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"differences": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"beforeBlob": {
									"shape": "S1c"
								},
								"afterBlob": {
									"shape": "S1c"
								},
								"changeType": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"GetRepository": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"repositoryName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"repositoryMetadata": {
						"shape": "S6"
					}
				}
			}
		},
		"GetRepositoryTriggers": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"repositoryName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"configurationId": {},
					"triggers": {
						"shape": "S1k"
					}
				}
			}
		},
		"ListBranches": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"repositoryName": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"branches": {
						"shape": "S1o"
					},
					"nextToken": {}
				}
			}
		},
		"ListRepositories": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {},
					"sortBy": {},
					"order": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"repositories": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"repositoryName": {},
								"repositoryId": {}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"PutRepositoryTriggers": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"triggers"
				],
				"members": {
					"repositoryName": {},
					"triggers": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"configurationId": {}
				}
			}
		},
		"TestRepositoryTriggers": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"triggers"
				],
				"members": {
					"repositoryName": {},
					"triggers": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"successfulExecutions": {
						"type": "list",
						"member": {}
					},
					"failedExecutions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"trigger": {},
								"failureMessage": {}
							}
						}
					}
				}
			}
		},
		"UpdateDefaultBranch": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"defaultBranchName"
				],
				"members": {
					"repositoryName": {},
					"defaultBranchName": {}
				}
			}
		},
		"UpdateRepositoryDescription": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"repositoryName": {},
					"repositoryDescription": {}
				}
			}
		},
		"UpdateRepositoryName": {
			"input": {
				"type": "structure",
				"required": [
					"oldName",
					"newName"
				],
				"members": {
					"oldName": {},
					"newName": {}
				}
			}
		}
	},
	"shapes": {
		"S6": {
			"type": "structure",
			"members": {
				"accountId": {},
				"repositoryId": {},
				"repositoryName": {},
				"repositoryDescription": {},
				"defaultBranch": {},
				"lastModifiedDate": {
					"type": "timestamp"
				},
				"creationDate": {
					"type": "timestamp"
				},
				"cloneUrlHttp": {},
				"cloneUrlSsh": {},
				"Arn": {}
			}
		},
		"Sz": {
			"type": "structure",
			"members": {
				"name": {},
				"email": {},
				"date": {}
			}
		},
		"S1c": {
			"type": "structure",
			"members": {
				"blobId": {},
				"path": {},
				"mode": {}
			}
		},
		"S1k": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"name",
					"destinationArn",
					"events"
				],
				"members": {
					"name": {},
					"destinationArn": {},
					"customData": {},
					"branches": {
						"shape": "S1o"
					},
					"events": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"S1o": {
			"type": "list",
			"member": {}
		}
	}
};

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"GetDifferences": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken"
		},
		"ListBranches": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "branches"
		},
		"ListRepositories": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "repositories"
		}
	}
};

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['codedeploy'] = {};
AWS.CodeDeploy = Service.defineService('codedeploy', ['2014-10-06']);
Object.defineProperty(apiLoader.services['codedeploy'], '2014-10-06', {
  get: function get() {
    var model = __webpack_require__(1549);
    model.paginators = __webpack_require__(1550).pagination;
    model.waiters = __webpack_require__(1551).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CodeDeploy;


/***/ }),
/* 1549 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-10-06",
		"endpointPrefix": "codedeploy",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "CodeDeploy",
		"serviceFullName": "AWS CodeDeploy",
		"signatureVersion": "v4",
		"targetPrefix": "CodeDeploy_20141006",
		"timestampFormat": "unixTimestamp",
		"uid": "codedeploy-2014-10-06"
	},
	"operations": {
		"AddTagsToOnPremisesInstances": {
			"input": {
				"type": "structure",
				"required": [
					"tags",
					"instanceNames"
				],
				"members": {
					"tags": {
						"shape": "S2"
					},
					"instanceNames": {
						"shape": "S6"
					}
				}
			}
		},
		"BatchGetApplicationRevisions": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"revisions"
				],
				"members": {
					"applicationName": {},
					"revisions": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"errorMessage": {},
					"revisions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"revisionLocation": {
									"shape": "Sb"
								},
								"genericRevisionInfo": {
									"shape": "Sq"
								}
							}
						}
					}
				}
			}
		},
		"BatchGetApplications": {
			"input": {
				"type": "structure",
				"members": {
					"applicationNames": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applicationsInfo": {
						"type": "list",
						"member": {
							"shape": "Sz"
						}
					}
				}
			}
		},
		"BatchGetDeploymentGroups": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"deploymentGroupNames"
				],
				"members": {
					"applicationName": {},
					"deploymentGroupNames": {
						"shape": "Ss"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentGroupsInfo": {
						"type": "list",
						"member": {
							"shape": "S16"
						}
					},
					"errorMessage": {}
				}
			}
		},
		"BatchGetDeploymentInstances": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentId",
					"instanceIds"
				],
				"members": {
					"deploymentId": {},
					"instanceIds": {
						"shape": "S2n"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instancesSummary": {
						"type": "list",
						"member": {
							"shape": "S2r"
						}
					},
					"errorMessage": {}
				}
			}
		},
		"BatchGetDeployments": {
			"input": {
				"type": "structure",
				"members": {
					"deploymentIds": {
						"shape": "S34"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentsInfo": {
						"type": "list",
						"member": {
							"shape": "S37"
						}
					}
				}
			}
		},
		"BatchGetOnPremisesInstances": {
			"input": {
				"type": "structure",
				"members": {
					"instanceNames": {
						"shape": "S6"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instanceInfos": {
						"type": "list",
						"member": {
							"shape": "S3l"
						}
					}
				}
			}
		},
		"ContinueDeployment": {
			"input": {
				"type": "structure",
				"members": {
					"deploymentId": {}
				}
			}
		},
		"CreateApplication": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applicationId": {}
				}
			}
		},
		"CreateDeployment": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {},
					"deploymentGroupName": {},
					"revision": {
						"shape": "Sb"
					},
					"deploymentConfigName": {},
					"description": {},
					"ignoreApplicationStopFailures": {
						"type": "boolean"
					},
					"targetInstances": {
						"shape": "S3e"
					},
					"autoRollbackConfiguration": {
						"shape": "S1u"
					},
					"updateOutdatedInstancesOnly": {
						"type": "boolean"
					},
					"fileExistsBehavior": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentId": {}
				}
			}
		},
		"CreateDeploymentConfig": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentConfigName",
					"minimumHealthyHosts"
				],
				"members": {
					"deploymentConfigName": {},
					"minimumHealthyHosts": {
						"shape": "S3v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentConfigId": {}
				}
			}
		},
		"CreateDeploymentGroup": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"deploymentGroupName",
					"serviceRoleArn"
				],
				"members": {
					"applicationName": {},
					"deploymentGroupName": {},
					"deploymentConfigName": {},
					"ec2TagFilters": {
						"shape": "S19"
					},
					"onPremisesInstanceTagFilters": {
						"shape": "S1c"
					},
					"autoScalingGroups": {
						"shape": "S3f"
					},
					"serviceRoleArn": {},
					"triggerConfigurations": {
						"shape": "S1k"
					},
					"alarmConfiguration": {
						"shape": "S1q"
					},
					"autoRollbackConfiguration": {
						"shape": "S1u"
					},
					"deploymentStyle": {
						"shape": "S1x"
					},
					"blueGreenDeploymentConfiguration": {
						"shape": "S20"
					},
					"loadBalancerInfo": {
						"shape": "S28"
					},
					"ec2TagSet": {
						"shape": "S2i"
					},
					"onPremisesTagSet": {
						"shape": "S2k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentGroupId": {}
				}
			}
		},
		"DeleteApplication": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {}
				}
			}
		},
		"DeleteDeploymentConfig": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentConfigName"
				],
				"members": {
					"deploymentConfigName": {}
				}
			}
		},
		"DeleteDeploymentGroup": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"deploymentGroupName"
				],
				"members": {
					"applicationName": {},
					"deploymentGroupName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"hooksNotCleanedUp": {
						"shape": "S1f"
					}
				}
			}
		},
		"DeregisterOnPremisesInstance": {
			"input": {
				"type": "structure",
				"required": [
					"instanceName"
				],
				"members": {
					"instanceName": {}
				}
			}
		},
		"GetApplication": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"application": {
						"shape": "Sz"
					}
				}
			}
		},
		"GetApplicationRevision": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"revision"
				],
				"members": {
					"applicationName": {},
					"revision": {
						"shape": "Sb"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"revision": {
						"shape": "Sb"
					},
					"revisionInfo": {
						"shape": "Sq"
					}
				}
			}
		},
		"GetDeployment": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentId"
				],
				"members": {
					"deploymentId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentInfo": {
						"shape": "S37"
					}
				}
			}
		},
		"GetDeploymentConfig": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentConfigName"
				],
				"members": {
					"deploymentConfigName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentConfigInfo": {
						"type": "structure",
						"members": {
							"deploymentConfigId": {},
							"deploymentConfigName": {},
							"minimumHealthyHosts": {
								"shape": "S3v"
							},
							"createTime": {
								"type": "timestamp"
							}
						}
					}
				}
			}
		},
		"GetDeploymentGroup": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"deploymentGroupName"
				],
				"members": {
					"applicationName": {},
					"deploymentGroupName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentGroupInfo": {
						"shape": "S16"
					}
				}
			}
		},
		"GetDeploymentInstance": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentId",
					"instanceId"
				],
				"members": {
					"deploymentId": {},
					"instanceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instanceSummary": {
						"shape": "S2r"
					}
				}
			}
		},
		"GetOnPremisesInstance": {
			"input": {
				"type": "structure",
				"required": [
					"instanceName"
				],
				"members": {
					"instanceName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instanceInfo": {
						"shape": "S3l"
					}
				}
			}
		},
		"ListApplicationRevisions": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {},
					"sortBy": {},
					"sortOrder": {},
					"s3Bucket": {},
					"s3KeyPrefix": {},
					"deployed": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"revisions": {
						"shape": "Sa"
					},
					"nextToken": {}
				}
			}
		},
		"ListApplications": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applications": {
						"shape": "Sw"
					},
					"nextToken": {}
				}
			}
		},
		"ListDeploymentConfigs": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deploymentConfigsList": {
						"type": "list",
						"member": {}
					},
					"nextToken": {}
				}
			}
		},
		"ListDeploymentGroups": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName"
				],
				"members": {
					"applicationName": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"deploymentGroups": {
						"shape": "Ss"
					},
					"nextToken": {}
				}
			}
		},
		"ListDeploymentInstances": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentId"
				],
				"members": {
					"deploymentId": {},
					"nextToken": {},
					"instanceStatusFilter": {
						"type": "list",
						"member": {}
					},
					"instanceTypeFilter": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instancesList": {
						"shape": "S2n"
					},
					"nextToken": {}
				}
			}
		},
		"ListDeployments": {
			"input": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"deploymentGroupName": {},
					"includeOnlyStatuses": {
						"type": "list",
						"member": {}
					},
					"createTimeRange": {
						"type": "structure",
						"members": {
							"start": {
								"type": "timestamp"
							},
							"end": {
								"type": "timestamp"
							}
						}
					},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"deployments": {
						"shape": "S34"
					},
					"nextToken": {}
				}
			}
		},
		"ListGitHubAccountTokenNames": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tokenNameList": {
						"type": "list",
						"member": {}
					},
					"nextToken": {}
				}
			}
		},
		"ListOnPremisesInstances": {
			"input": {
				"type": "structure",
				"members": {
					"registrationStatus": {},
					"tagFilters": {
						"shape": "S1c"
					},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"instanceNames": {
						"shape": "S6"
					},
					"nextToken": {}
				}
			}
		},
		"RegisterApplicationRevision": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"revision"
				],
				"members": {
					"applicationName": {},
					"description": {},
					"revision": {
						"shape": "Sb"
					}
				}
			}
		},
		"RegisterOnPremisesInstance": {
			"input": {
				"type": "structure",
				"required": [
					"instanceName"
				],
				"members": {
					"instanceName": {},
					"iamSessionArn": {},
					"iamUserArn": {}
				}
			}
		},
		"RemoveTagsFromOnPremisesInstances": {
			"input": {
				"type": "structure",
				"required": [
					"tags",
					"instanceNames"
				],
				"members": {
					"tags": {
						"shape": "S2"
					},
					"instanceNames": {
						"shape": "S6"
					}
				}
			}
		},
		"SkipWaitTimeForInstanceTermination": {
			"input": {
				"type": "structure",
				"members": {
					"deploymentId": {}
				}
			}
		},
		"StopDeployment": {
			"input": {
				"type": "structure",
				"required": [
					"deploymentId"
				],
				"members": {
					"deploymentId": {},
					"autoRollbackEnabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"status": {},
					"statusMessage": {}
				}
			}
		},
		"UpdateApplication": {
			"input": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"newApplicationName": {}
				}
			}
		},
		"UpdateDeploymentGroup": {
			"input": {
				"type": "structure",
				"required": [
					"applicationName",
					"currentDeploymentGroupName"
				],
				"members": {
					"applicationName": {},
					"currentDeploymentGroupName": {},
					"newDeploymentGroupName": {},
					"deploymentConfigName": {},
					"ec2TagFilters": {
						"shape": "S19"
					},
					"onPremisesInstanceTagFilters": {
						"shape": "S1c"
					},
					"autoScalingGroups": {
						"shape": "S3f"
					},
					"serviceRoleArn": {},
					"triggerConfigurations": {
						"shape": "S1k"
					},
					"alarmConfiguration": {
						"shape": "S1q"
					},
					"autoRollbackConfiguration": {
						"shape": "S1u"
					},
					"deploymentStyle": {
						"shape": "S1x"
					},
					"blueGreenDeploymentConfiguration": {
						"shape": "S20"
					},
					"loadBalancerInfo": {
						"shape": "S28"
					},
					"ec2TagSet": {
						"shape": "S2i"
					},
					"onPremisesTagSet": {
						"shape": "S2k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"hooksNotCleanedUp": {
						"shape": "S1f"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S6": {
			"type": "list",
			"member": {}
		},
		"Sa": {
			"type": "list",
			"member": {
				"shape": "Sb"
			}
		},
		"Sb": {
			"type": "structure",
			"members": {
				"revisionType": {},
				"s3Location": {
					"type": "structure",
					"members": {
						"bucket": {},
						"key": {},
						"bundleType": {},
						"version": {},
						"eTag": {}
					}
				},
				"gitHubLocation": {
					"type": "structure",
					"members": {
						"repository": {},
						"commitId": {}
					}
				}
			}
		},
		"Sq": {
			"type": "structure",
			"members": {
				"description": {},
				"deploymentGroups": {
					"shape": "Ss"
				},
				"firstUsedTime": {
					"type": "timestamp"
				},
				"lastUsedTime": {
					"type": "timestamp"
				},
				"registerTime": {
					"type": "timestamp"
				}
			}
		},
		"Ss": {
			"type": "list",
			"member": {}
		},
		"Sw": {
			"type": "list",
			"member": {}
		},
		"Sz": {
			"type": "structure",
			"members": {
				"applicationId": {},
				"applicationName": {},
				"createTime": {
					"type": "timestamp"
				},
				"linkedToGitHub": {
					"type": "boolean"
				},
				"gitHubAccountName": {}
			}
		},
		"S16": {
			"type": "structure",
			"members": {
				"applicationName": {},
				"deploymentGroupId": {},
				"deploymentGroupName": {},
				"deploymentConfigName": {},
				"ec2TagFilters": {
					"shape": "S19"
				},
				"onPremisesInstanceTagFilters": {
					"shape": "S1c"
				},
				"autoScalingGroups": {
					"shape": "S1f"
				},
				"serviceRoleArn": {},
				"targetRevision": {
					"shape": "Sb"
				},
				"triggerConfigurations": {
					"shape": "S1k"
				},
				"alarmConfiguration": {
					"shape": "S1q"
				},
				"autoRollbackConfiguration": {
					"shape": "S1u"
				},
				"deploymentStyle": {
					"shape": "S1x"
				},
				"blueGreenDeploymentConfiguration": {
					"shape": "S20"
				},
				"loadBalancerInfo": {
					"shape": "S28"
				},
				"lastSuccessfulDeployment": {
					"shape": "S2f"
				},
				"lastAttemptedDeployment": {
					"shape": "S2f"
				},
				"ec2TagSet": {
					"shape": "S2i"
				},
				"onPremisesTagSet": {
					"shape": "S2k"
				}
			}
		},
		"S19": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {},
					"Type": {}
				}
			}
		},
		"S1c": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {},
					"Type": {}
				}
			}
		},
		"S1f": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"hook": {}
				}
			}
		},
		"S1k": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"triggerName": {},
					"triggerTargetArn": {},
					"triggerEvents": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"S1q": {
			"type": "structure",
			"members": {
				"enabled": {
					"type": "boolean"
				},
				"ignorePollAlarmFailure": {
					"type": "boolean"
				},
				"alarms": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"name": {}
						}
					}
				}
			}
		},
		"S1u": {
			"type": "structure",
			"members": {
				"enabled": {
					"type": "boolean"
				},
				"events": {
					"type": "list",
					"member": {}
				}
			}
		},
		"S1x": {
			"type": "structure",
			"members": {
				"deploymentType": {},
				"deploymentOption": {}
			}
		},
		"S20": {
			"type": "structure",
			"members": {
				"terminateBlueInstancesOnDeploymentSuccess": {
					"type": "structure",
					"members": {
						"action": {},
						"terminationWaitTimeInMinutes": {
							"type": "integer"
						}
					}
				},
				"deploymentReadyOption": {
					"type": "structure",
					"members": {
						"actionOnTimeout": {},
						"waitTimeInMinutes": {
							"type": "integer"
						}
					}
				},
				"greenFleetProvisioningOption": {
					"type": "structure",
					"members": {
						"action": {}
					}
				}
			}
		},
		"S28": {
			"type": "structure",
			"members": {
				"elbInfoList": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"name": {}
						}
					}
				},
				"targetGroupInfoList": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"name": {}
						}
					}
				}
			}
		},
		"S2f": {
			"type": "structure",
			"members": {
				"deploymentId": {},
				"status": {},
				"endTime": {
					"type": "timestamp"
				},
				"createTime": {
					"type": "timestamp"
				}
			}
		},
		"S2i": {
			"type": "structure",
			"members": {
				"ec2TagSetList": {
					"type": "list",
					"member": {
						"shape": "S19"
					}
				}
			}
		},
		"S2k": {
			"type": "structure",
			"members": {
				"onPremisesTagSetList": {
					"type": "list",
					"member": {
						"shape": "S1c"
					}
				}
			}
		},
		"S2n": {
			"type": "list",
			"member": {}
		},
		"S2r": {
			"type": "structure",
			"members": {
				"deploymentId": {},
				"instanceId": {},
				"status": {},
				"lastUpdatedAt": {
					"type": "timestamp"
				},
				"lifecycleEvents": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"lifecycleEventName": {},
							"diagnostics": {
								"type": "structure",
								"members": {
									"errorCode": {},
									"scriptName": {},
									"message": {},
									"logTail": {}
								}
							},
							"startTime": {
								"type": "timestamp"
							},
							"endTime": {
								"type": "timestamp"
							},
							"status": {}
						}
					}
				},
				"instanceType": {}
			}
		},
		"S34": {
			"type": "list",
			"member": {}
		},
		"S37": {
			"type": "structure",
			"members": {
				"applicationName": {},
				"deploymentGroupName": {},
				"deploymentConfigName": {},
				"deploymentId": {},
				"previousRevision": {
					"shape": "Sb"
				},
				"revision": {
					"shape": "Sb"
				},
				"status": {},
				"errorInformation": {
					"type": "structure",
					"members": {
						"code": {},
						"message": {}
					}
				},
				"createTime": {
					"type": "timestamp"
				},
				"startTime": {
					"type": "timestamp"
				},
				"completeTime": {
					"type": "timestamp"
				},
				"deploymentOverview": {
					"type": "structure",
					"members": {
						"Pending": {
							"type": "long"
						},
						"InProgress": {
							"type": "long"
						},
						"Succeeded": {
							"type": "long"
						},
						"Failed": {
							"type": "long"
						},
						"Skipped": {
							"type": "long"
						},
						"Ready": {
							"type": "long"
						}
					}
				},
				"description": {},
				"creator": {},
				"ignoreApplicationStopFailures": {
					"type": "boolean"
				},
				"autoRollbackConfiguration": {
					"shape": "S1u"
				},
				"updateOutdatedInstancesOnly": {
					"type": "boolean"
				},
				"rollbackInfo": {
					"type": "structure",
					"members": {
						"rollbackDeploymentId": {},
						"rollbackTriggeringDeploymentId": {},
						"rollbackMessage": {}
					}
				},
				"deploymentStyle": {
					"shape": "S1x"
				},
				"targetInstances": {
					"shape": "S3e"
				},
				"instanceTerminationWaitTimeStarted": {
					"type": "boolean"
				},
				"blueGreenDeploymentConfiguration": {
					"shape": "S20"
				},
				"loadBalancerInfo": {
					"shape": "S28"
				},
				"additionalDeploymentStatusInfo": {},
				"fileExistsBehavior": {}
			}
		},
		"S3e": {
			"type": "structure",
			"members": {
				"tagFilters": {
					"shape": "S19"
				},
				"autoScalingGroups": {
					"shape": "S3f"
				},
				"ec2TagSet": {
					"shape": "S2i"
				}
			}
		},
		"S3f": {
			"type": "list",
			"member": {}
		},
		"S3l": {
			"type": "structure",
			"members": {
				"instanceName": {},
				"iamSessionArn": {},
				"iamUserArn": {},
				"instanceArn": {},
				"registerTime": {
					"type": "timestamp"
				},
				"deregisterTime": {
					"type": "timestamp"
				},
				"tags": {
					"shape": "S2"
				}
			}
		},
		"S3v": {
			"type": "structure",
			"members": {
				"value": {
					"type": "integer"
				},
				"type": {}
			}
		}
	}
};

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListApplicationRevisions": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "revisions"
		},
		"ListApplications": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "applications"
		},
		"ListDeploymentConfigs": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "deploymentConfigsList"
		},
		"ListDeploymentGroups": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "deploymentGroups"
		},
		"ListDeploymentInstances": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "instancesList"
		},
		"ListDeployments": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "deployments"
		}
	}
};

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"DeploymentSuccessful": {
			"delay": 15,
			"operation": "GetDeployment",
			"maxAttempts": 120,
			"acceptors": [
				{
					"expected": "Succeeded",
					"matcher": "path",
					"state": "success",
					"argument": "deploymentInfo.status"
				},
				{
					"expected": "Failed",
					"matcher": "path",
					"state": "failure",
					"argument": "deploymentInfo.status"
				},
				{
					"expected": "Stopped",
					"matcher": "path",
					"state": "failure",
					"argument": "deploymentInfo.status"
				}
			]
		}
	}
};

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['codepipeline'] = {};
AWS.CodePipeline = Service.defineService('codepipeline', ['2015-07-09']);
Object.defineProperty(apiLoader.services['codepipeline'], '2015-07-09', {
  get: function get() {
    var model = __webpack_require__(1553);
    model.paginators = __webpack_require__(1554).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CodePipeline;


/***/ }),
/* 1553 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-07-09",
		"endpointPrefix": "codepipeline",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "CodePipeline",
		"serviceFullName": "AWS CodePipeline",
		"signatureVersion": "v4",
		"targetPrefix": "CodePipeline_20150709",
		"uid": "codepipeline-2015-07-09"
	},
	"operations": {
		"AcknowledgeJob": {
			"input": {
				"type": "structure",
				"required": [
					"jobId",
					"nonce"
				],
				"members": {
					"jobId": {},
					"nonce": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"status": {}
				}
			}
		},
		"AcknowledgeThirdPartyJob": {
			"input": {
				"type": "structure",
				"required": [
					"jobId",
					"nonce",
					"clientToken"
				],
				"members": {
					"jobId": {},
					"nonce": {},
					"clientToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"status": {}
				}
			}
		},
		"CreateCustomActionType": {
			"input": {
				"type": "structure",
				"required": [
					"category",
					"provider",
					"version",
					"inputArtifactDetails",
					"outputArtifactDetails"
				],
				"members": {
					"category": {},
					"provider": {},
					"version": {},
					"settings": {
						"shape": "Se"
					},
					"configurationProperties": {
						"shape": "Sh"
					},
					"inputArtifactDetails": {
						"shape": "Sn"
					},
					"outputArtifactDetails": {
						"shape": "Sn"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"actionType"
				],
				"members": {
					"actionType": {
						"shape": "Sr"
					}
				}
			}
		},
		"CreatePipeline": {
			"input": {
				"type": "structure",
				"required": [
					"pipeline"
				],
				"members": {
					"pipeline": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"pipeline": {
						"shape": "Sv"
					}
				}
			}
		},
		"DeleteCustomActionType": {
			"input": {
				"type": "structure",
				"required": [
					"category",
					"provider",
					"version"
				],
				"members": {
					"category": {},
					"provider": {},
					"version": {}
				}
			}
		},
		"DeletePipeline": {
			"input": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {}
				}
			}
		},
		"DisableStageTransition": {
			"input": {
				"type": "structure",
				"required": [
					"pipelineName",
					"stageName",
					"transitionType",
					"reason"
				],
				"members": {
					"pipelineName": {},
					"stageName": {},
					"transitionType": {},
					"reason": {}
				}
			}
		},
		"EnableStageTransition": {
			"input": {
				"type": "structure",
				"required": [
					"pipelineName",
					"stageName",
					"transitionType"
				],
				"members": {
					"pipelineName": {},
					"stageName": {},
					"transitionType": {}
				}
			}
		},
		"GetJobDetails": {
			"input": {
				"type": "structure",
				"required": [
					"jobId"
				],
				"members": {
					"jobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"jobDetails": {
						"type": "structure",
						"members": {
							"id": {},
							"data": {
								"shape": "S1x"
							},
							"accountId": {}
						}
					}
				}
			}
		},
		"GetPipeline": {
			"input": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {},
					"version": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"pipeline": {
						"shape": "Sv"
					}
				}
			}
		},
		"GetPipelineExecution": {
			"input": {
				"type": "structure",
				"required": [
					"pipelineName",
					"pipelineExecutionId"
				],
				"members": {
					"pipelineName": {},
					"pipelineExecutionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"pipelineExecution": {
						"type": "structure",
						"members": {
							"pipelineName": {},
							"pipelineVersion": {
								"type": "integer"
							},
							"pipelineExecutionId": {},
							"status": {},
							"artifactRevisions": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"name": {},
										"revisionId": {},
										"revisionChangeIdentifier": {},
										"revisionSummary": {},
										"created": {
											"type": "timestamp"
										},
										"revisionUrl": {}
									}
								}
							}
						}
					}
				}
			}
		},
		"GetPipelineState": {
			"input": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"pipelineName": {},
					"pipelineVersion": {
						"type": "integer"
					},
					"stageStates": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"stageName": {},
								"inboundTransitionState": {
									"type": "structure",
									"members": {
										"enabled": {
											"type": "boolean"
										},
										"lastChangedBy": {},
										"lastChangedAt": {
											"type": "timestamp"
										},
										"disabledReason": {}
									}
								},
								"actionStates": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"actionName": {},
											"currentRevision": {
												"shape": "S32"
											},
											"latestExecution": {
												"type": "structure",
												"members": {
													"status": {},
													"summary": {},
													"lastStatusChange": {
														"type": "timestamp"
													},
													"token": {},
													"lastUpdatedBy": {},
													"externalExecutionId": {},
													"externalExecutionUrl": {},
													"percentComplete": {
														"type": "integer"
													},
													"errorDetails": {
														"type": "structure",
														"members": {
															"code": {},
															"message": {}
														}
													}
												}
											},
											"entityUrl": {},
											"revisionUrl": {}
										}
									}
								},
								"latestExecution": {
									"type": "structure",
									"required": [
										"pipelineExecutionId",
										"status"
									],
									"members": {
										"pipelineExecutionId": {},
										"status": {}
									}
								}
							}
						}
					},
					"created": {
						"type": "timestamp"
					},
					"updated": {
						"type": "timestamp"
					}
				}
			}
		},
		"GetThirdPartyJobDetails": {
			"input": {
				"type": "structure",
				"required": [
					"jobId",
					"clientToken"
				],
				"members": {
					"jobId": {},
					"clientToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"jobDetails": {
						"type": "structure",
						"members": {
							"id": {},
							"data": {
								"type": "structure",
								"members": {
									"actionTypeId": {
										"shape": "Ss"
									},
									"actionConfiguration": {
										"shape": "S1y"
									},
									"pipelineContext": {
										"shape": "S1z"
									},
									"inputArtifacts": {
										"shape": "S22"
									},
									"outputArtifacts": {
										"shape": "S22"
									},
									"artifactCredentials": {
										"shape": "S2a"
									},
									"continuationToken": {},
									"encryptionKey": {
										"shape": "S11"
									}
								}
							},
							"nonce": {}
						}
					}
				}
			}
		},
		"ListActionTypes": {
			"input": {
				"type": "structure",
				"members": {
					"actionOwnerFilter": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"actionTypes"
				],
				"members": {
					"actionTypes": {
						"type": "list",
						"member": {
							"shape": "Sr"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListPipelineExecutions": {
			"input": {
				"type": "structure",
				"required": [
					"pipelineName"
				],
				"members": {
					"pipelineName": {},
					"maxResults": {
						"type": "integer"
					},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"pipelineExecutionSummaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"pipelineExecutionId": {},
								"status": {},
								"startTime": {
									"type": "timestamp"
								},
								"lastUpdateTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListPipelines": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"pipelines": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {},
								"version": {
									"type": "integer"
								},
								"created": {
									"type": "timestamp"
								},
								"updated": {
									"type": "timestamp"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"PollForJobs": {
			"input": {
				"type": "structure",
				"required": [
					"actionTypeId"
				],
				"members": {
					"actionTypeId": {
						"shape": "Ss"
					},
					"maxBatchSize": {
						"type": "integer"
					},
					"queryParam": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"jobs": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"id": {},
								"data": {
									"shape": "S1x"
								},
								"nonce": {},
								"accountId": {}
							}
						}
					}
				}
			}
		},
		"PollForThirdPartyJobs": {
			"input": {
				"type": "structure",
				"required": [
					"actionTypeId"
				],
				"members": {
					"actionTypeId": {
						"shape": "Ss"
					},
					"maxBatchSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"jobs": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"clientId": {},
								"jobId": {}
							}
						}
					}
				}
			}
		},
		"PutActionRevision": {
			"input": {
				"type": "structure",
				"required": [
					"pipelineName",
					"stageName",
					"actionName",
					"actionRevision"
				],
				"members": {
					"pipelineName": {},
					"stageName": {},
					"actionName": {},
					"actionRevision": {
						"shape": "S32"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"newRevision": {
						"type": "boolean"
					},
					"pipelineExecutionId": {}
				}
			}
		},
		"PutApprovalResult": {
			"input": {
				"type": "structure",
				"required": [
					"pipelineName",
					"stageName",
					"actionName",
					"result",
					"token"
				],
				"members": {
					"pipelineName": {},
					"stageName": {},
					"actionName": {},
					"result": {
						"type": "structure",
						"required": [
							"summary",
							"status"
						],
						"members": {
							"summary": {},
							"status": {}
						}
					},
					"token": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"approvedAt": {
						"type": "timestamp"
					}
				}
			}
		},
		"PutJobFailureResult": {
			"input": {
				"type": "structure",
				"required": [
					"jobId",
					"failureDetails"
				],
				"members": {
					"jobId": {},
					"failureDetails": {
						"shape": "S4h"
					}
				}
			}
		},
		"PutJobSuccessResult": {
			"input": {
				"type": "structure",
				"required": [
					"jobId"
				],
				"members": {
					"jobId": {},
					"currentRevision": {
						"shape": "S4k"
					},
					"continuationToken": {},
					"executionDetails": {
						"shape": "S4m"
					}
				}
			}
		},
		"PutThirdPartyJobFailureResult": {
			"input": {
				"type": "structure",
				"required": [
					"jobId",
					"clientToken",
					"failureDetails"
				],
				"members": {
					"jobId": {},
					"clientToken": {},
					"failureDetails": {
						"shape": "S4h"
					}
				}
			}
		},
		"PutThirdPartyJobSuccessResult": {
			"input": {
				"type": "structure",
				"required": [
					"jobId",
					"clientToken"
				],
				"members": {
					"jobId": {},
					"clientToken": {},
					"currentRevision": {
						"shape": "S4k"
					},
					"continuationToken": {},
					"executionDetails": {
						"shape": "S4m"
					}
				}
			}
		},
		"RetryStageExecution": {
			"input": {
				"type": "structure",
				"required": [
					"pipelineName",
					"stageName",
					"pipelineExecutionId",
					"retryMode"
				],
				"members": {
					"pipelineName": {},
					"stageName": {},
					"pipelineExecutionId": {},
					"retryMode": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"pipelineExecutionId": {}
				}
			}
		},
		"StartPipelineExecution": {
			"input": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"pipelineExecutionId": {}
				}
			}
		},
		"UpdatePipeline": {
			"input": {
				"type": "structure",
				"required": [
					"pipeline"
				],
				"members": {
					"pipeline": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"pipeline": {
						"shape": "Sv"
					}
				}
			}
		}
	},
	"shapes": {
		"Se": {
			"type": "structure",
			"members": {
				"thirdPartyConfigurationUrl": {},
				"entityUrlTemplate": {},
				"executionUrlTemplate": {},
				"revisionUrlTemplate": {}
			}
		},
		"Sh": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"name",
					"required",
					"key",
					"secret"
				],
				"members": {
					"name": {},
					"required": {
						"type": "boolean"
					},
					"key": {
						"type": "boolean"
					},
					"secret": {
						"type": "boolean"
					},
					"queryable": {
						"type": "boolean"
					},
					"description": {},
					"type": {}
				}
			}
		},
		"Sn": {
			"type": "structure",
			"required": [
				"minimumCount",
				"maximumCount"
			],
			"members": {
				"minimumCount": {
					"type": "integer"
				},
				"maximumCount": {
					"type": "integer"
				}
			}
		},
		"Sr": {
			"type": "structure",
			"required": [
				"id",
				"inputArtifactDetails",
				"outputArtifactDetails"
			],
			"members": {
				"id": {
					"shape": "Ss"
				},
				"settings": {
					"shape": "Se"
				},
				"actionConfigurationProperties": {
					"shape": "Sh"
				},
				"inputArtifactDetails": {
					"shape": "Sn"
				},
				"outputArtifactDetails": {
					"shape": "Sn"
				}
			}
		},
		"Ss": {
			"type": "structure",
			"required": [
				"category",
				"owner",
				"provider",
				"version"
			],
			"members": {
				"category": {},
				"owner": {},
				"provider": {},
				"version": {}
			}
		},
		"Sv": {
			"type": "structure",
			"required": [
				"name",
				"roleArn",
				"artifactStore",
				"stages"
			],
			"members": {
				"name": {},
				"roleArn": {},
				"artifactStore": {
					"type": "structure",
					"required": [
						"type",
						"location"
					],
					"members": {
						"type": {},
						"location": {},
						"encryptionKey": {
							"shape": "S11"
						}
					}
				},
				"stages": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"name",
							"actions"
						],
						"members": {
							"name": {},
							"blockers": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"name",
										"type"
									],
									"members": {
										"name": {},
										"type": {}
									}
								}
							},
							"actions": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"name",
										"actionTypeId"
									],
									"members": {
										"name": {},
										"actionTypeId": {
											"shape": "Ss"
										},
										"runOrder": {
											"type": "integer"
										},
										"configuration": {
											"shape": "S1f"
										},
										"outputArtifacts": {
											"type": "list",
											"member": {
												"type": "structure",
												"required": [
													"name"
												],
												"members": {
													"name": {}
												}
											}
										},
										"inputArtifacts": {
											"type": "list",
											"member": {
												"type": "structure",
												"required": [
													"name"
												],
												"members": {
													"name": {}
												}
											}
										},
										"roleArn": {}
									}
								}
							}
						}
					}
				},
				"version": {
					"type": "integer"
				}
			}
		},
		"S11": {
			"type": "structure",
			"required": [
				"id",
				"type"
			],
			"members": {
				"id": {},
				"type": {}
			}
		},
		"S1f": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1x": {
			"type": "structure",
			"members": {
				"actionTypeId": {
					"shape": "Ss"
				},
				"actionConfiguration": {
					"shape": "S1y"
				},
				"pipelineContext": {
					"shape": "S1z"
				},
				"inputArtifacts": {
					"shape": "S22"
				},
				"outputArtifacts": {
					"shape": "S22"
				},
				"artifactCredentials": {
					"shape": "S2a"
				},
				"continuationToken": {},
				"encryptionKey": {
					"shape": "S11"
				}
			}
		},
		"S1y": {
			"type": "structure",
			"members": {
				"configuration": {
					"shape": "S1f"
				}
			}
		},
		"S1z": {
			"type": "structure",
			"members": {
				"pipelineName": {},
				"stage": {
					"type": "structure",
					"members": {
						"name": {}
					}
				},
				"action": {
					"type": "structure",
					"members": {
						"name": {}
					}
				}
			}
		},
		"S22": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"revision": {},
					"location": {
						"type": "structure",
						"members": {
							"type": {},
							"s3Location": {
								"type": "structure",
								"required": [
									"bucketName",
									"objectKey"
								],
								"members": {
									"bucketName": {},
									"objectKey": {}
								}
							}
						}
					}
				}
			}
		},
		"S2a": {
			"type": "structure",
			"required": [
				"accessKeyId",
				"secretAccessKey",
				"sessionToken"
			],
			"members": {
				"accessKeyId": {},
				"secretAccessKey": {},
				"sessionToken": {}
			},
			"sensitive": true
		},
		"S32": {
			"type": "structure",
			"required": [
				"revisionId",
				"revisionChangeId",
				"created"
			],
			"members": {
				"revisionId": {},
				"revisionChangeId": {},
				"created": {
					"type": "timestamp"
				}
			}
		},
		"S4h": {
			"type": "structure",
			"required": [
				"type",
				"message"
			],
			"members": {
				"type": {},
				"message": {},
				"externalExecutionId": {}
			}
		},
		"S4k": {
			"type": "structure",
			"required": [
				"revision",
				"changeIdentifier"
			],
			"members": {
				"revision": {},
				"changeIdentifier": {},
				"created": {
					"type": "timestamp"
				},
				"revisionSummary": {}
			}
		},
		"S4m": {
			"type": "structure",
			"members": {
				"summary": {},
				"externalExecutionId": {},
				"percentComplete": {
					"type": "integer"
				}
			}
		}
	}
};

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitoidentityserviceprovider'] = {};
AWS.CognitoIdentityServiceProvider = Service.defineService('cognitoidentityserviceprovider', ['2016-04-18']);
Object.defineProperty(apiLoader.services['cognitoidentityserviceprovider'], '2016-04-18', {
  get: function get() {
    var model = __webpack_require__(1556);
    model.paginators = __webpack_require__(1557).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoIdentityServiceProvider;


/***/ }),
/* 1556 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-04-18",
		"endpointPrefix": "cognito-idp",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Cognito Identity Provider",
		"signatureVersion": "v4",
		"targetPrefix": "AWSCognitoIdentityProviderService",
		"uid": "cognito-idp-2016-04-18"
	},
	"operations": {
		"AddCustomAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"CustomAttributes"
				],
				"members": {
					"UserPoolId": {},
					"CustomAttributes": {
						"type": "list",
						"member": {
							"shape": "S4"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminAddUserToGroup": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"GroupName"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"GroupName": {}
				}
			}
		},
		"AdminConfirmSignUp": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminCreateUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"ValidationData": {
						"shape": "Si"
					},
					"TemporaryPassword": {
						"shape": "Sm"
					},
					"ForceAliasCreation": {
						"type": "boolean"
					},
					"MessageAction": {},
					"DesiredDeliveryMediums": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "Ss"
					}
				}
			}
		},
		"AdminDeleteUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			}
		},
		"AdminDeleteUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"UserAttributeNames"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributeNames": {
						"shape": "Sz"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminDisableProviderForUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"User"
				],
				"members": {
					"UserPoolId": {},
					"User": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminDisableUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminEnableUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminForgetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"DeviceKey"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"DeviceKey": {}
				}
			}
		},
		"AdminGetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey",
					"UserPoolId",
					"Username"
				],
				"members": {
					"DeviceKey": {},
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Device"
				],
				"members": {
					"Device": {
						"shape": "S1d"
					}
				}
			}
		},
		"AdminGetUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Username"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"UserCreateDate": {
						"type": "timestamp"
					},
					"UserLastModifiedDate": {
						"type": "timestamp"
					},
					"Enabled": {
						"type": "boolean"
					},
					"UserStatus": {},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			}
		},
		"AdminInitiateAuth": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId",
					"AuthFlow"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					},
					"AuthFlow": {},
					"AuthParameters": {
						"shape": "S1j"
					},
					"ClientMetadata": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1o"
					},
					"AuthenticationResult": {
						"shape": "S1p"
					}
				}
			}
		},
		"AdminLinkProviderForUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"DestinationUser",
					"SourceUser"
				],
				"members": {
					"UserPoolId": {},
					"DestinationUser": {
						"shape": "S12"
					},
					"SourceUser": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminListDevices": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Devices": {
						"shape": "S1z"
					},
					"PaginationToken": {}
				}
			}
		},
		"AdminListGroupsForUser": {
			"input": {
				"type": "structure",
				"required": [
					"Username",
					"UserPoolId"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserPoolId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Groups": {
						"shape": "S23"
					},
					"NextToken": {}
				}
			}
		},
		"AdminRemoveUserFromGroup": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"GroupName"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"GroupName": {}
				}
			}
		},
		"AdminResetUserPassword": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminRespondToAuthChallenge": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId",
					"ChallengeName"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					},
					"ChallengeName": {},
					"ChallengeResponses": {
						"shape": "S2c"
					},
					"Session": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1o"
					},
					"AuthenticationResult": {
						"shape": "S1p"
					}
				}
			}
		},
		"AdminSetUserSettings": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"MFAOptions"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUpdateDeviceStatus": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"DeviceKey"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"DeviceKey": {},
					"DeviceRememberedStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUpdateUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"UserAttributes"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUserGlobalSignOut": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ChangePassword": {
			"input": {
				"type": "structure",
				"required": [
					"PreviousPassword",
					"ProposedPassword",
					"AccessToken"
				],
				"members": {
					"PreviousPassword": {
						"shape": "Sm"
					},
					"ProposedPassword": {
						"shape": "Sm"
					},
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"ConfirmDevice": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"DeviceKey": {},
					"DeviceSecretVerifierConfig": {
						"type": "structure",
						"members": {
							"PasswordVerifier": {},
							"Salt": {}
						}
					},
					"DeviceName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserConfirmationNecessary": {
						"type": "boolean"
					}
				}
			}
		},
		"ConfirmForgotPassword": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"ConfirmationCode",
					"Password"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"SecretHash": {
						"shape": "S2u"
					},
					"Username": {
						"shape": "Sd"
					},
					"ConfirmationCode": {},
					"Password": {
						"shape": "Sm"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"ConfirmSignUp": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"ConfirmationCode"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"SecretHash": {
						"shape": "S2u"
					},
					"Username": {
						"shape": "Sd"
					},
					"ConfirmationCode": {},
					"ForceAliasCreation": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"CreateGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {},
					"Description": {},
					"RoleArn": {},
					"Precedence": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Group": {
						"shape": "S24"
					}
				}
			}
		},
		"CreateIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName",
					"ProviderType",
					"ProviderDetails"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {},
					"ProviderType": {},
					"ProviderDetails": {
						"shape": "S34"
					},
					"AttributeMapping": {
						"shape": "S35"
					},
					"IdpIdentifiers": {
						"shape": "S37"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S3a"
					}
				}
			}
		},
		"CreateResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier",
					"Name"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {},
					"Name": {},
					"Scopes": {
						"shape": "S3e"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServer"
				],
				"members": {
					"ResourceServer": {
						"shape": "S3j"
					}
				}
			}
		},
		"CreateUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"JobName",
					"UserPoolId",
					"CloudWatchLogsRoleArn"
				],
				"members": {
					"JobName": {},
					"UserPoolId": {},
					"CloudWatchLogsRoleArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S3n"
					}
				}
			}
		},
		"CreateUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"PoolName"
				],
				"members": {
					"PoolName": {},
					"Policies": {
						"shape": "S3v"
					},
					"LambdaConfig": {
						"shape": "S3y"
					},
					"AutoVerifiedAttributes": {
						"shape": "S3z"
					},
					"AliasAttributes": {
						"shape": "S41"
					},
					"UsernameAttributes": {
						"shape": "S43"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"VerificationMessageTemplate": {
						"shape": "S48"
					},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S4d"
					},
					"EmailConfiguration": {
						"shape": "S4e"
					},
					"SmsConfiguration": {
						"shape": "S4g"
					},
					"UserPoolTags": {
						"shape": "S4h"
					},
					"AdminCreateUserConfig": {
						"shape": "S4i"
					},
					"Schema": {
						"shape": "S4l"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPool": {
						"shape": "S4n"
					}
				}
			}
		},
		"CreateUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientName"
				],
				"members": {
					"UserPoolId": {},
					"ClientName": {},
					"GenerateSecret": {
						"type": "boolean"
					},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S4t"
					},
					"WriteAttributes": {
						"shape": "S4t"
					},
					"ExplicitAuthFlows": {
						"shape": "S4v"
					},
					"SupportedIdentityProviders": {
						"shape": "S4x"
					},
					"CallbackURLs": {
						"shape": "S4y"
					},
					"LogoutURLs": {
						"shape": "S50"
					},
					"DefaultRedirectURI": {},
					"AllowedOAuthFlows": {
						"shape": "S51"
					},
					"AllowedOAuthScopes": {
						"shape": "S53"
					},
					"AllowedOAuthFlowsUserPoolClient": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S56"
					}
				}
			}
		},
		"CreateUserPoolDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Domain",
					"UserPoolId"
				],
				"members": {
					"Domain": {},
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {}
				}
			}
		},
		"DeleteIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {}
				}
			}
		},
		"DeleteResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {}
				}
			}
		},
		"DeleteUser": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"authtype": "none"
		},
		"DeleteUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserAttributeNames",
					"AccessToken"
				],
				"members": {
					"UserAttributeNames": {
						"shape": "Sz"
					},
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"DeleteUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			}
		},
		"DeleteUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					}
				}
			}
		},
		"DeleteUserPoolDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Domain",
					"UserPoolId"
				],
				"members": {
					"Domain": {},
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S3a"
					}
				}
			}
		},
		"DescribeResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServer"
				],
				"members": {
					"ResourceServer": {
						"shape": "S3j"
					}
				}
			}
		},
		"DescribeUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S3n"
					}
				}
			}
		},
		"DescribeUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPool": {
						"shape": "S4n"
					}
				}
			}
		},
		"DescribeUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S56"
					}
				}
			}
		},
		"DescribeUserPoolDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Domain"
				],
				"members": {
					"Domain": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DomainDescription": {
						"type": "structure",
						"members": {
							"UserPoolId": {},
							"AWSAccountId": {},
							"Domain": {},
							"S3Bucket": {},
							"CloudFrontDistribution": {},
							"Version": {},
							"Status": {}
						}
					}
				}
			}
		},
		"ForgetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"DeviceKey": {}
				}
			}
		},
		"ForgotPassword": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"SecretHash": {
						"shape": "S2u"
					},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S65"
					}
				}
			},
			"authtype": "none"
		},
		"GetCSVHeader": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"CSVHeader": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"GetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey"
				],
				"members": {
					"DeviceKey": {},
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Device"
				],
				"members": {
					"Device": {
						"shape": "S1d"
					}
				}
			}
		},
		"GetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Group": {
						"shape": "S24"
					}
				}
			}
		},
		"GetIdentityProviderByIdentifier": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"IdpIdentifier"
				],
				"members": {
					"UserPoolId": {},
					"IdpIdentifier": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S3a"
					}
				}
			}
		},
		"GetUICustomization": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"UICustomization"
				],
				"members": {
					"UICustomization": {
						"shape": "S6h"
					}
				}
			}
		},
		"GetUser": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Username",
					"UserAttributes"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"authtype": "none"
		},
		"GetUserAttributeVerificationCode": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"AttributeName"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"AttributeName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S65"
					}
				}
			},
			"authtype": "none"
		},
		"GlobalSignOut": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"InitiateAuth": {
			"input": {
				"type": "structure",
				"required": [
					"AuthFlow",
					"ClientId"
				],
				"members": {
					"AuthFlow": {},
					"AuthParameters": {
						"shape": "S1j"
					},
					"ClientMetadata": {
						"shape": "S1k"
					},
					"ClientId": {
						"shape": "S1h"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1o"
					},
					"AuthenticationResult": {
						"shape": "S1p"
					}
				}
			}
		},
		"ListDevices": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Devices": {
						"shape": "S1z"
					},
					"PaginationToken": {}
				}
			}
		},
		"ListGroups": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Groups": {
						"shape": "S23"
					},
					"NextToken": {}
				}
			}
		},
		"ListIdentityProviders": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Providers"
				],
				"members": {
					"Providers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ProviderName": {},
								"ProviderType": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"CreationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListResourceServers": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServers"
				],
				"members": {
					"ResourceServers": {
						"type": "list",
						"member": {
							"shape": "S3j"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUserImportJobs": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"MaxResults"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJobs": {
						"type": "list",
						"member": {
							"shape": "S3n"
						}
					},
					"PaginationToken": {}
				}
			}
		},
		"ListUserPoolClients": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClients": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ClientId": {
									"shape": "S1h"
								},
								"UserPoolId": {},
								"ClientName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUserPools": {
			"input": {
				"type": "structure",
				"required": [
					"MaxResults"
				],
				"members": {
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPools": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"LambdaConfig": {
									"shape": "S3y"
								},
								"Status": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"CreationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUsers": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"AttributesToGet": {
						"type": "list",
						"member": {}
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {},
					"Filter": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Users": {
						"shape": "S7o"
					},
					"PaginationToken": {}
				}
			}
		},
		"ListUsersInGroup": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"GroupName"
				],
				"members": {
					"UserPoolId": {},
					"GroupName": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Users": {
						"shape": "S7o"
					},
					"NextToken": {}
				}
			}
		},
		"ResendConfirmationCode": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"SecretHash": {
						"shape": "S2u"
					},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S65"
					}
				}
			},
			"authtype": "none"
		},
		"RespondToAuthChallenge": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"ChallengeName"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"ChallengeName": {},
					"Session": {},
					"ChallengeResponses": {
						"shape": "S2c"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1o"
					},
					"AuthenticationResult": {
						"shape": "S1p"
					}
				}
			}
		},
		"SetUICustomization": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					},
					"CSS": {},
					"ImageFile": {
						"type": "blob"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"UICustomization"
				],
				"members": {
					"UICustomization": {
						"shape": "S6h"
					}
				}
			}
		},
		"SetUserSettings": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"MFAOptions"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"SignUp": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"Password"
				],
				"members": {
					"ClientId": {
						"shape": "S1h"
					},
					"SecretHash": {
						"shape": "S2u"
					},
					"Username": {
						"shape": "Sd"
					},
					"Password": {
						"shape": "Sm"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"ValidationData": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"UserConfirmed",
					"UserSub"
				],
				"members": {
					"UserConfirmed": {
						"type": "boolean"
					},
					"CodeDeliveryDetails": {
						"shape": "S65"
					},
					"UserSub": {}
				}
			},
			"authtype": "none"
		},
		"StartUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S3n"
					}
				}
			}
		},
		"StopUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S3n"
					}
				}
			}
		},
		"UpdateDeviceStatus": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"DeviceKey": {},
					"DeviceRememberedStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {},
					"Description": {},
					"RoleArn": {},
					"Precedence": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Group": {
						"shape": "S24"
					}
				}
			}
		},
		"UpdateIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {},
					"ProviderDetails": {
						"shape": "S34"
					},
					"AttributeMapping": {
						"shape": "S35"
					},
					"IdpIdentifiers": {
						"shape": "S37"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S3a"
					}
				}
			}
		},
		"UpdateResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier",
					"Name"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {},
					"Name": {},
					"Scopes": {
						"shape": "S3e"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServer"
				],
				"members": {
					"ResourceServer": {
						"shape": "S3j"
					}
				}
			}
		},
		"UpdateUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserAttributes",
					"AccessToken"
				],
				"members": {
					"UserAttributes": {
						"shape": "Si"
					},
					"AccessToken": {
						"shape": "S1q"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetailsList": {
						"type": "list",
						"member": {
							"shape": "S65"
						}
					}
				}
			},
			"authtype": "none"
		},
		"UpdateUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"Policies": {
						"shape": "S3v"
					},
					"LambdaConfig": {
						"shape": "S3y"
					},
					"AutoVerifiedAttributes": {
						"shape": "S3z"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"VerificationMessageTemplate": {
						"shape": "S48"
					},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S4d"
					},
					"EmailConfiguration": {
						"shape": "S4e"
					},
					"SmsConfiguration": {
						"shape": "S4g"
					},
					"UserPoolTags": {
						"shape": "S4h"
					},
					"AdminCreateUserConfig": {
						"shape": "S4i"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1h"
					},
					"ClientName": {},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S4t"
					},
					"WriteAttributes": {
						"shape": "S4t"
					},
					"ExplicitAuthFlows": {
						"shape": "S4v"
					},
					"SupportedIdentityProviders": {
						"shape": "S4x"
					},
					"CallbackURLs": {
						"shape": "S4y"
					},
					"LogoutURLs": {
						"shape": "S50"
					},
					"DefaultRedirectURI": {},
					"AllowedOAuthFlows": {
						"shape": "S51"
					},
					"AllowedOAuthScopes": {
						"shape": "S53"
					},
					"AllowedOAuthFlowsUserPoolClient": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S56"
					}
				}
			}
		},
		"VerifyUserAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"AttributeName",
					"Code"
				],
				"members": {
					"AccessToken": {
						"shape": "S1q"
					},
					"AttributeName": {},
					"Code": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"Name": {},
				"AttributeDataType": {},
				"DeveloperOnlyAttribute": {
					"type": "boolean"
				},
				"Mutable": {
					"type": "boolean"
				},
				"Required": {
					"type": "boolean"
				},
				"NumberAttributeConstraints": {
					"type": "structure",
					"members": {
						"MinValue": {},
						"MaxValue": {}
					}
				},
				"StringAttributeConstraints": {
					"type": "structure",
					"members": {
						"MinLength": {},
						"MaxLength": {}
					}
				}
			}
		},
		"Sd": {
			"type": "string",
			"sensitive": true
		},
		"Si": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Value": {
						"type": "string",
						"sensitive": true
					}
				}
			}
		},
		"Sm": {
			"type": "string",
			"sensitive": true
		},
		"Ss": {
			"type": "structure",
			"members": {
				"Username": {
					"shape": "Sd"
				},
				"Attributes": {
					"shape": "Si"
				},
				"UserCreateDate": {
					"type": "timestamp"
				},
				"UserLastModifiedDate": {
					"type": "timestamp"
				},
				"Enabled": {
					"type": "boolean"
				},
				"UserStatus": {},
				"MFAOptions": {
					"shape": "Sv"
				}
			}
		},
		"Sv": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"DeliveryMedium": {},
					"AttributeName": {}
				}
			}
		},
		"Sz": {
			"type": "list",
			"member": {}
		},
		"S12": {
			"type": "structure",
			"members": {
				"ProviderName": {},
				"ProviderAttributeName": {},
				"ProviderAttributeValue": {}
			}
		},
		"S1d": {
			"type": "structure",
			"members": {
				"DeviceKey": {},
				"DeviceAttributes": {
					"shape": "Si"
				},
				"DeviceCreateDate": {
					"type": "timestamp"
				},
				"DeviceLastModifiedDate": {
					"type": "timestamp"
				},
				"DeviceLastAuthenticatedDate": {
					"type": "timestamp"
				}
			}
		},
		"S1h": {
			"type": "string",
			"sensitive": true
		},
		"S1j": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1k": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1o": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1p": {
			"type": "structure",
			"members": {
				"AccessToken": {
					"shape": "S1q"
				},
				"ExpiresIn": {
					"type": "integer"
				},
				"TokenType": {},
				"RefreshToken": {
					"shape": "S1q"
				},
				"IdToken": {
					"shape": "S1q"
				},
				"NewDeviceMetadata": {
					"type": "structure",
					"members": {
						"DeviceKey": {},
						"DeviceGroupKey": {}
					}
				}
			}
		},
		"S1q": {
			"type": "string",
			"sensitive": true
		},
		"S1z": {
			"type": "list",
			"member": {
				"shape": "S1d"
			}
		},
		"S23": {
			"type": "list",
			"member": {
				"shape": "S24"
			}
		},
		"S24": {
			"type": "structure",
			"members": {
				"GroupName": {},
				"UserPoolId": {},
				"Description": {},
				"RoleArn": {},
				"Precedence": {
					"type": "integer"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				}
			}
		},
		"S2c": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S2u": {
			"type": "string",
			"sensitive": true
		},
		"S34": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S35": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S37": {
			"type": "list",
			"member": {}
		},
		"S3a": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ProviderName": {},
				"ProviderType": {},
				"ProviderDetails": {
					"shape": "S34"
				},
				"AttributeMapping": {
					"shape": "S35"
				},
				"IdpIdentifiers": {
					"shape": "S37"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				}
			}
		},
		"S3e": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"ScopeName",
					"ScopeDescription"
				],
				"members": {
					"ScopeName": {},
					"ScopeDescription": {}
				}
			}
		},
		"S3j": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"Identifier": {},
				"Name": {},
				"Scopes": {
					"shape": "S3e"
				}
			}
		},
		"S3n": {
			"type": "structure",
			"members": {
				"JobName": {},
				"JobId": {},
				"UserPoolId": {},
				"PreSignedUrl": {},
				"CreationDate": {
					"type": "timestamp"
				},
				"StartDate": {
					"type": "timestamp"
				},
				"CompletionDate": {
					"type": "timestamp"
				},
				"Status": {},
				"CloudWatchLogsRoleArn": {},
				"ImportedUsers": {
					"type": "long"
				},
				"SkippedUsers": {
					"type": "long"
				},
				"FailedUsers": {
					"type": "long"
				},
				"CompletionMessage": {}
			}
		},
		"S3v": {
			"type": "structure",
			"members": {
				"PasswordPolicy": {
					"type": "structure",
					"members": {
						"MinimumLength": {
							"type": "integer"
						},
						"RequireUppercase": {
							"type": "boolean"
						},
						"RequireLowercase": {
							"type": "boolean"
						},
						"RequireNumbers": {
							"type": "boolean"
						},
						"RequireSymbols": {
							"type": "boolean"
						}
					}
				}
			}
		},
		"S3y": {
			"type": "structure",
			"members": {
				"PreSignUp": {},
				"CustomMessage": {},
				"PostConfirmation": {},
				"PreAuthentication": {},
				"PostAuthentication": {},
				"DefineAuthChallenge": {},
				"CreateAuthChallenge": {},
				"VerifyAuthChallengeResponse": {}
			}
		},
		"S3z": {
			"type": "list",
			"member": {}
		},
		"S41": {
			"type": "list",
			"member": {}
		},
		"S43": {
			"type": "list",
			"member": {}
		},
		"S48": {
			"type": "structure",
			"members": {
				"SmsMessage": {},
				"EmailMessage": {},
				"EmailSubject": {},
				"EmailMessageByLink": {},
				"EmailSubjectByLink": {},
				"DefaultEmailOption": {}
			}
		},
		"S4d": {
			"type": "structure",
			"members": {
				"ChallengeRequiredOnNewDevice": {
					"type": "boolean"
				},
				"DeviceOnlyRememberedOnUserPrompt": {
					"type": "boolean"
				}
			}
		},
		"S4e": {
			"type": "structure",
			"members": {
				"SourceArn": {},
				"ReplyToEmailAddress": {}
			}
		},
		"S4g": {
			"type": "structure",
			"required": [
				"SnsCallerArn"
			],
			"members": {
				"SnsCallerArn": {},
				"ExternalId": {}
			}
		},
		"S4h": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S4i": {
			"type": "structure",
			"members": {
				"AllowAdminCreateUserOnly": {
					"type": "boolean"
				},
				"UnusedAccountValidityDays": {
					"type": "integer"
				},
				"InviteMessageTemplate": {
					"type": "structure",
					"members": {
						"SMSMessage": {},
						"EmailMessage": {},
						"EmailSubject": {}
					}
				}
			}
		},
		"S4l": {
			"type": "list",
			"member": {
				"shape": "S4"
			}
		},
		"S4n": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"Policies": {
					"shape": "S3v"
				},
				"LambdaConfig": {
					"shape": "S3y"
				},
				"Status": {},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"SchemaAttributes": {
					"shape": "S4l"
				},
				"AutoVerifiedAttributes": {
					"shape": "S3z"
				},
				"AliasAttributes": {
					"shape": "S41"
				},
				"UsernameAttributes": {
					"shape": "S43"
				},
				"SmsVerificationMessage": {},
				"EmailVerificationMessage": {},
				"EmailVerificationSubject": {},
				"VerificationMessageTemplate": {
					"shape": "S48"
				},
				"SmsAuthenticationMessage": {},
				"MfaConfiguration": {},
				"DeviceConfiguration": {
					"shape": "S4d"
				},
				"EstimatedNumberOfUsers": {
					"type": "integer"
				},
				"EmailConfiguration": {
					"shape": "S4e"
				},
				"SmsConfiguration": {
					"shape": "S4g"
				},
				"UserPoolTags": {
					"shape": "S4h"
				},
				"SmsConfigurationFailure": {},
				"EmailConfigurationFailure": {},
				"AdminCreateUserConfig": {
					"shape": "S4i"
				}
			}
		},
		"S4t": {
			"type": "list",
			"member": {}
		},
		"S4v": {
			"type": "list",
			"member": {}
		},
		"S4x": {
			"type": "list",
			"member": {}
		},
		"S4y": {
			"type": "list",
			"member": {}
		},
		"S50": {
			"type": "list",
			"member": {}
		},
		"S51": {
			"type": "list",
			"member": {}
		},
		"S53": {
			"type": "list",
			"member": {}
		},
		"S56": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ClientName": {},
				"ClientId": {
					"shape": "S1h"
				},
				"ClientSecret": {
					"type": "string",
					"sensitive": true
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"RefreshTokenValidity": {
					"type": "integer"
				},
				"ReadAttributes": {
					"shape": "S4t"
				},
				"WriteAttributes": {
					"shape": "S4t"
				},
				"ExplicitAuthFlows": {
					"shape": "S4v"
				},
				"SupportedIdentityProviders": {
					"shape": "S4x"
				},
				"CallbackURLs": {
					"shape": "S4y"
				},
				"LogoutURLs": {
					"shape": "S50"
				},
				"DefaultRedirectURI": {},
				"AllowedOAuthFlows": {
					"shape": "S51"
				},
				"AllowedOAuthScopes": {
					"shape": "S53"
				},
				"AllowedOAuthFlowsUserPoolClient": {
					"type": "boolean"
				}
			}
		},
		"S65": {
			"type": "structure",
			"members": {
				"Destination": {},
				"DeliveryMedium": {},
				"AttributeName": {}
			}
		},
		"S6h": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ClientId": {
					"shape": "S1h"
				},
				"ImageUrl": {},
				"CSS": {},
				"CSSVersion": {},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				}
			}
		},
		"S7o": {
			"type": "list",
			"member": {
				"shape": "Ss"
			}
		}
	}
};

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cognitosync'] = {};
AWS.CognitoSync = Service.defineService('cognitosync', ['2014-06-30']);
Object.defineProperty(apiLoader.services['cognitosync'], '2014-06-30', {
  get: function get() {
    var model = __webpack_require__(1559);
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CognitoSync;


/***/ }),
/* 1559 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-06-30",
		"endpointPrefix": "cognito-sync",
		"jsonVersion": "1.1",
		"serviceFullName": "Amazon Cognito Sync",
		"signatureVersion": "v4",
		"protocol": "rest-json",
		"uid": "cognito-sync-2014-06-30"
	},
	"operations": {
		"BulkPublish": {
			"http": {
				"requestUri": "/identitypools/{IdentityPoolId}/bulkpublish",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {}
				}
			}
		},
		"DeleteDataset": {
			"http": {
				"method": "DELETE",
				"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityId",
					"DatasetName"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"IdentityId": {
						"location": "uri",
						"locationName": "IdentityId"
					},
					"DatasetName": {
						"location": "uri",
						"locationName": "DatasetName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Dataset": {
						"shape": "S8"
					}
				}
			}
		},
		"DescribeDataset": {
			"http": {
				"method": "GET",
				"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityId",
					"DatasetName"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"IdentityId": {
						"location": "uri",
						"locationName": "IdentityId"
					},
					"DatasetName": {
						"location": "uri",
						"locationName": "DatasetName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Dataset": {
						"shape": "S8"
					}
				}
			}
		},
		"DescribeIdentityPoolUsage": {
			"http": {
				"method": "GET",
				"requestUri": "/identitypools/{IdentityPoolId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolUsage": {
						"shape": "Sg"
					}
				}
			}
		},
		"DescribeIdentityUsage": {
			"http": {
				"method": "GET",
				"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityId"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"IdentityId": {
						"location": "uri",
						"locationName": "IdentityId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityUsage": {
						"type": "structure",
						"members": {
							"IdentityId": {},
							"IdentityPoolId": {},
							"LastModifiedDate": {
								"type": "timestamp"
							},
							"DatasetCount": {
								"type": "integer"
							},
							"DataStorage": {
								"type": "long"
							}
						}
					}
				}
			}
		},
		"GetBulkPublishDetails": {
			"http": {
				"requestUri": "/identitypools/{IdentityPoolId}/getBulkPublishDetails",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"BulkPublishStartTime": {
						"type": "timestamp"
					},
					"BulkPublishCompleteTime": {
						"type": "timestamp"
					},
					"BulkPublishStatus": {},
					"FailureMessage": {}
				}
			}
		},
		"GetCognitoEvents": {
			"http": {
				"method": "GET",
				"requestUri": "/identitypools/{IdentityPoolId}/events",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Events": {
						"shape": "Sq"
					}
				}
			}
		},
		"GetIdentityPoolConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/identitypools/{IdentityPoolId}/configuration",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"PushSync": {
						"shape": "Sv"
					},
					"CognitoStreams": {
						"shape": "Sz"
					}
				}
			}
		},
		"ListDatasets": {
			"http": {
				"method": "GET",
				"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityId",
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"IdentityId": {
						"location": "uri",
						"locationName": "IdentityId"
					},
					"NextToken": {
						"location": "querystring",
						"locationName": "nextToken"
					},
					"MaxResults": {
						"location": "querystring",
						"locationName": "maxResults",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Datasets": {
						"type": "list",
						"member": {
							"shape": "S8"
						}
					},
					"Count": {
						"type": "integer"
					},
					"NextToken": {}
				}
			}
		},
		"ListIdentityPoolUsage": {
			"http": {
				"method": "GET",
				"requestUri": "/identitypools",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {
						"location": "querystring",
						"locationName": "nextToken"
					},
					"MaxResults": {
						"location": "querystring",
						"locationName": "maxResults",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolUsages": {
						"type": "list",
						"member": {
							"shape": "Sg"
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"Count": {
						"type": "integer"
					},
					"NextToken": {}
				}
			}
		},
		"ListRecords": {
			"http": {
				"method": "GET",
				"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/records",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityId",
					"DatasetName"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"IdentityId": {
						"location": "uri",
						"locationName": "IdentityId"
					},
					"DatasetName": {
						"location": "uri",
						"locationName": "DatasetName"
					},
					"LastSyncCount": {
						"location": "querystring",
						"locationName": "lastSyncCount",
						"type": "long"
					},
					"NextToken": {
						"location": "querystring",
						"locationName": "nextToken"
					},
					"MaxResults": {
						"location": "querystring",
						"locationName": "maxResults",
						"type": "integer"
					},
					"SyncSessionToken": {
						"location": "querystring",
						"locationName": "syncSessionToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Records": {
						"shape": "S1c"
					},
					"NextToken": {},
					"Count": {
						"type": "integer"
					},
					"DatasetSyncCount": {
						"type": "long"
					},
					"LastModifiedBy": {},
					"MergedDatasetNames": {
						"type": "list",
						"member": {}
					},
					"DatasetExists": {
						"type": "boolean"
					},
					"DatasetDeletedAfterRequestedSyncCount": {
						"type": "boolean"
					},
					"SyncSessionToken": {}
				}
			}
		},
		"RegisterDevice": {
			"http": {
				"requestUri": "/identitypools/{IdentityPoolId}/identity/{IdentityId}/device",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityId",
					"Platform",
					"Token"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"IdentityId": {
						"location": "uri",
						"locationName": "IdentityId"
					},
					"Platform": {},
					"Token": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeviceId": {}
				}
			}
		},
		"SetCognitoEvents": {
			"http": {
				"requestUri": "/identitypools/{IdentityPoolId}/events",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"Events"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"Events": {
						"shape": "Sq"
					}
				}
			}
		},
		"SetIdentityPoolConfiguration": {
			"http": {
				"requestUri": "/identitypools/{IdentityPoolId}/configuration",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"PushSync": {
						"shape": "Sv"
					},
					"CognitoStreams": {
						"shape": "Sz"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"PushSync": {
						"shape": "Sv"
					},
					"CognitoStreams": {
						"shape": "Sz"
					}
				}
			}
		},
		"SubscribeToDataset": {
			"http": {
				"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityId",
					"DatasetName",
					"DeviceId"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"IdentityId": {
						"location": "uri",
						"locationName": "IdentityId"
					},
					"DatasetName": {
						"location": "uri",
						"locationName": "DatasetName"
					},
					"DeviceId": {
						"location": "uri",
						"locationName": "DeviceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UnsubscribeFromDataset": {
			"http": {
				"method": "DELETE",
				"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityId",
					"DatasetName",
					"DeviceId"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"IdentityId": {
						"location": "uri",
						"locationName": "IdentityId"
					},
					"DatasetName": {
						"location": "uri",
						"locationName": "DatasetName"
					},
					"DeviceId": {
						"location": "uri",
						"locationName": "DeviceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateRecords": {
			"http": {
				"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityId",
					"DatasetName",
					"SyncSessionToken"
				],
				"members": {
					"IdentityPoolId": {
						"location": "uri",
						"locationName": "IdentityPoolId"
					},
					"IdentityId": {
						"location": "uri",
						"locationName": "IdentityId"
					},
					"DatasetName": {
						"location": "uri",
						"locationName": "DatasetName"
					},
					"DeviceId": {},
					"RecordPatches": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Op",
								"Key",
								"SyncCount"
							],
							"members": {
								"Op": {},
								"Key": {},
								"Value": {},
								"SyncCount": {
									"type": "long"
								},
								"DeviceLastModifiedDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"SyncSessionToken": {},
					"ClientContext": {
						"location": "header",
						"locationName": "x-amz-Client-Context"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Records": {
						"shape": "S1c"
					}
				}
			}
		}
	},
	"shapes": {
		"S8": {
			"type": "structure",
			"members": {
				"IdentityId": {},
				"DatasetName": {},
				"CreationDate": {
					"type": "timestamp"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"LastModifiedBy": {},
				"DataStorage": {
					"type": "long"
				},
				"NumRecords": {
					"type": "long"
				}
			}
		},
		"Sg": {
			"type": "structure",
			"members": {
				"IdentityPoolId": {},
				"SyncSessionsCount": {
					"type": "long"
				},
				"DataStorage": {
					"type": "long"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				}
			}
		},
		"Sq": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"Sv": {
			"type": "structure",
			"members": {
				"ApplicationArns": {
					"type": "list",
					"member": {}
				},
				"RoleArn": {}
			}
		},
		"Sz": {
			"type": "structure",
			"members": {
				"StreamName": {},
				"RoleArn": {},
				"StreamingStatus": {}
			}
		},
		"S1c": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {},
					"SyncCount": {
						"type": "long"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"LastModifiedBy": {},
					"DeviceLastModifiedDate": {
						"type": "timestamp"
					}
				}
			}
		}
	},
	"examples": {}
};

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['configservice'] = {};
AWS.ConfigService = Service.defineService('configservice', ['2014-11-12']);
Object.defineProperty(apiLoader.services['configservice'], '2014-11-12', {
  get: function get() {
    var model = __webpack_require__(1561);
    model.paginators = __webpack_require__(1562).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ConfigService;


/***/ }),
/* 1561 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-11-12",
		"endpointPrefix": "config",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Config Service",
		"serviceFullName": "AWS Config",
		"signatureVersion": "v4",
		"targetPrefix": "StarlingDoveService",
		"uid": "config-2014-11-12"
	},
	"operations": {
		"DeleteConfigRule": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigRuleName"
				],
				"members": {
					"ConfigRuleName": {}
				}
			}
		},
		"DeleteConfigurationRecorder": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationRecorderName"
				],
				"members": {
					"ConfigurationRecorderName": {}
				}
			}
		},
		"DeleteDeliveryChannel": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryChannelName"
				],
				"members": {
					"DeliveryChannelName": {}
				}
			}
		},
		"DeleteEvaluationResults": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigRuleName"
				],
				"members": {
					"ConfigRuleName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeliverConfigSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"deliveryChannelName"
				],
				"members": {
					"deliveryChannelName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"configSnapshotId": {}
				}
			}
		},
		"DescribeComplianceByConfigRule": {
			"input": {
				"type": "structure",
				"members": {
					"ConfigRuleNames": {
						"shape": "Sd"
					},
					"ComplianceTypes": {
						"shape": "Se"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ComplianceByConfigRules": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ConfigRuleName": {},
								"Compliance": {
									"shape": "Sj"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeComplianceByResource": {
			"input": {
				"type": "structure",
				"members": {
					"ResourceType": {},
					"ResourceId": {},
					"ComplianceTypes": {
						"shape": "Se"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ComplianceByResources": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ResourceType": {},
								"ResourceId": {},
								"Compliance": {
									"shape": "Sj"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeConfigRuleEvaluationStatus": {
			"input": {
				"type": "structure",
				"members": {
					"ConfigRuleNames": {
						"shape": "Sd"
					},
					"NextToken": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConfigRulesEvaluationStatus": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ConfigRuleName": {},
								"ConfigRuleArn": {},
								"ConfigRuleId": {},
								"LastSuccessfulInvocationTime": {
									"type": "timestamp"
								},
								"LastFailedInvocationTime": {
									"type": "timestamp"
								},
								"LastSuccessfulEvaluationTime": {
									"type": "timestamp"
								},
								"LastFailedEvaluationTime": {
									"type": "timestamp"
								},
								"FirstActivatedTime": {
									"type": "timestamp"
								},
								"LastErrorCode": {},
								"LastErrorMessage": {},
								"FirstEvaluationStarted": {
									"type": "boolean"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeConfigRules": {
			"input": {
				"type": "structure",
				"members": {
					"ConfigRuleNames": {
						"shape": "Sd"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConfigRules": {
						"type": "list",
						"member": {
							"shape": "S13"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeConfigurationRecorderStatus": {
			"input": {
				"type": "structure",
				"members": {
					"ConfigurationRecorderNames": {
						"shape": "S1i"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConfigurationRecordersStatus": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {},
								"lastStartTime": {
									"type": "timestamp"
								},
								"lastStopTime": {
									"type": "timestamp"
								},
								"recording": {
									"type": "boolean"
								},
								"lastStatus": {},
								"lastErrorCode": {},
								"lastErrorMessage": {},
								"lastStatusChangeTime": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeConfigurationRecorders": {
			"input": {
				"type": "structure",
				"members": {
					"ConfigurationRecorderNames": {
						"shape": "S1i"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConfigurationRecorders": {
						"type": "list",
						"member": {
							"shape": "S1q"
						}
					}
				}
			}
		},
		"DescribeDeliveryChannelStatus": {
			"input": {
				"type": "structure",
				"members": {
					"DeliveryChannelNames": {
						"shape": "S1x"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeliveryChannelsStatus": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {},
								"configSnapshotDeliveryInfo": {
									"shape": "S21"
								},
								"configHistoryDeliveryInfo": {
									"shape": "S21"
								},
								"configStreamDeliveryInfo": {
									"type": "structure",
									"members": {
										"lastStatus": {},
										"lastErrorCode": {},
										"lastErrorMessage": {},
										"lastStatusChangeTime": {
											"type": "timestamp"
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeDeliveryChannels": {
			"input": {
				"type": "structure",
				"members": {
					"DeliveryChannelNames": {
						"shape": "S1x"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeliveryChannels": {
						"type": "list",
						"member": {
							"shape": "S27"
						}
					}
				}
			}
		},
		"GetComplianceDetailsByConfigRule": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigRuleName"
				],
				"members": {
					"ConfigRuleName": {},
					"ComplianceTypes": {
						"shape": "Se"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EvaluationResults": {
						"shape": "S2b"
					},
					"NextToken": {}
				}
			}
		},
		"GetComplianceDetailsByResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceType",
					"ResourceId"
				],
				"members": {
					"ResourceType": {},
					"ResourceId": {},
					"ComplianceTypes": {
						"shape": "Se"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EvaluationResults": {
						"shape": "S2b"
					},
					"NextToken": {}
				}
			}
		},
		"GetComplianceSummaryByConfigRule": {
			"output": {
				"type": "structure",
				"members": {
					"ComplianceSummary": {
						"shape": "S2i"
					}
				}
			}
		},
		"GetComplianceSummaryByResourceType": {
			"input": {
				"type": "structure",
				"members": {
					"ResourceTypes": {
						"shape": "S2k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ComplianceSummariesByResourceType": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ResourceType": {},
								"ComplianceSummary": {
									"shape": "S2i"
								}
							}
						}
					}
				}
			}
		},
		"GetDiscoveredResourceCounts": {
			"input": {
				"type": "structure",
				"members": {
					"resourceTypes": {
						"shape": "S2k"
					},
					"limit": {
						"type": "integer"
					},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"totalDiscoveredResources": {
						"type": "long"
					},
					"resourceCounts": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"resourceType": {},
								"count": {
									"type": "long"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"GetResourceConfigHistory": {
			"input": {
				"type": "structure",
				"required": [
					"resourceType",
					"resourceId"
				],
				"members": {
					"resourceType": {},
					"resourceId": {},
					"laterTime": {
						"type": "timestamp"
					},
					"earlierTime": {
						"type": "timestamp"
					},
					"chronologicalOrder": {},
					"limit": {
						"type": "integer"
					},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"configurationItems": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"version": {},
								"accountId": {},
								"configurationItemCaptureTime": {
									"type": "timestamp"
								},
								"configurationItemStatus": {},
								"configurationStateId": {},
								"configurationItemMD5Hash": {},
								"arn": {},
								"resourceType": {},
								"resourceId": {},
								"resourceName": {},
								"awsRegion": {},
								"availabilityZone": {},
								"resourceCreationTime": {
									"type": "timestamp"
								},
								"tags": {
									"type": "map",
									"key": {},
									"value": {}
								},
								"relatedEvents": {
									"type": "list",
									"member": {}
								},
								"relationships": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"resourceType": {},
											"resourceId": {},
											"resourceName": {},
											"relationshipName": {}
										}
									}
								},
								"configuration": {},
								"supplementaryConfiguration": {
									"type": "map",
									"key": {},
									"value": {}
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListDiscoveredResources": {
			"input": {
				"type": "structure",
				"required": [
					"resourceType"
				],
				"members": {
					"resourceType": {},
					"resourceIds": {
						"type": "list",
						"member": {}
					},
					"resourceName": {},
					"limit": {
						"type": "integer"
					},
					"includeDeletedResources": {
						"type": "boolean"
					},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"resourceIdentifiers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"resourceType": {},
								"resourceId": {},
								"resourceName": {},
								"resourceDeletionTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"PutConfigRule": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigRule"
				],
				"members": {
					"ConfigRule": {
						"shape": "S13"
					}
				}
			}
		},
		"PutConfigurationRecorder": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationRecorder"
				],
				"members": {
					"ConfigurationRecorder": {
						"shape": "S1q"
					}
				}
			}
		},
		"PutDeliveryChannel": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryChannel"
				],
				"members": {
					"DeliveryChannel": {
						"shape": "S27"
					}
				}
			}
		},
		"PutEvaluations": {
			"input": {
				"type": "structure",
				"required": [
					"ResultToken"
				],
				"members": {
					"Evaluations": {
						"shape": "S3y"
					},
					"ResultToken": {},
					"TestMode": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FailedEvaluations": {
						"shape": "S3y"
					}
				}
			}
		},
		"StartConfigRulesEvaluation": {
			"input": {
				"type": "structure",
				"members": {
					"ConfigRuleNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"StartConfigurationRecorder": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationRecorderName"
				],
				"members": {
					"ConfigurationRecorderName": {}
				}
			}
		},
		"StopConfigurationRecorder": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationRecorderName"
				],
				"members": {
					"ConfigurationRecorderName": {}
				}
			}
		}
	},
	"shapes": {
		"Sd": {
			"type": "list",
			"member": {}
		},
		"Se": {
			"type": "list",
			"member": {}
		},
		"Sj": {
			"type": "structure",
			"members": {
				"ComplianceType": {},
				"ComplianceContributorCount": {
					"shape": "Sk"
				}
			}
		},
		"Sk": {
			"type": "structure",
			"members": {
				"CappedCount": {
					"type": "integer"
				},
				"CapExceeded": {
					"type": "boolean"
				}
			}
		},
		"S13": {
			"type": "structure",
			"required": [
				"Source"
			],
			"members": {
				"ConfigRuleName": {},
				"ConfigRuleArn": {},
				"ConfigRuleId": {},
				"Description": {},
				"Scope": {
					"type": "structure",
					"members": {
						"ComplianceResourceTypes": {
							"type": "list",
							"member": {}
						},
						"TagKey": {},
						"TagValue": {},
						"ComplianceResourceId": {}
					}
				},
				"Source": {
					"type": "structure",
					"required": [
						"Owner",
						"SourceIdentifier"
					],
					"members": {
						"Owner": {},
						"SourceIdentifier": {},
						"SourceDetails": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventSource": {},
									"MessageType": {},
									"MaximumExecutionFrequency": {}
								}
							}
						}
					}
				},
				"InputParameters": {},
				"MaximumExecutionFrequency": {},
				"ConfigRuleState": {}
			}
		},
		"S1i": {
			"type": "list",
			"member": {}
		},
		"S1q": {
			"type": "structure",
			"members": {
				"name": {},
				"roleARN": {},
				"recordingGroup": {
					"type": "structure",
					"members": {
						"allSupported": {
							"type": "boolean"
						},
						"includeGlobalResourceTypes": {
							"type": "boolean"
						},
						"resourceTypes": {
							"type": "list",
							"member": {}
						}
					}
				}
			}
		},
		"S1x": {
			"type": "list",
			"member": {}
		},
		"S21": {
			"type": "structure",
			"members": {
				"lastStatus": {},
				"lastErrorCode": {},
				"lastErrorMessage": {},
				"lastAttemptTime": {
					"type": "timestamp"
				},
				"lastSuccessfulTime": {
					"type": "timestamp"
				},
				"nextDeliveryTime": {
					"type": "timestamp"
				}
			}
		},
		"S27": {
			"type": "structure",
			"members": {
				"name": {},
				"s3BucketName": {},
				"s3KeyPrefix": {},
				"snsTopicARN": {},
				"configSnapshotDeliveryProperties": {
					"type": "structure",
					"members": {
						"deliveryFrequency": {}
					}
				}
			}
		},
		"S2b": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"EvaluationResultIdentifier": {
						"type": "structure",
						"members": {
							"EvaluationResultQualifier": {
								"type": "structure",
								"members": {
									"ConfigRuleName": {},
									"ResourceType": {},
									"ResourceId": {}
								}
							},
							"OrderingTimestamp": {
								"type": "timestamp"
							}
						}
					},
					"ComplianceType": {},
					"ResultRecordedTime": {
						"type": "timestamp"
					},
					"ConfigRuleInvokedTime": {
						"type": "timestamp"
					},
					"Annotation": {},
					"ResultToken": {}
				}
			}
		},
		"S2i": {
			"type": "structure",
			"members": {
				"CompliantResourceCount": {
					"shape": "Sk"
				},
				"NonCompliantResourceCount": {
					"shape": "Sk"
				},
				"ComplianceSummaryTimestamp": {
					"type": "timestamp"
				}
			}
		},
		"S2k": {
			"type": "list",
			"member": {}
		},
		"S3y": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"ComplianceResourceType",
					"ComplianceResourceId",
					"ComplianceType",
					"OrderingTimestamp"
				],
				"members": {
					"ComplianceResourceType": {},
					"ComplianceResourceId": {},
					"ComplianceType": {},
					"Annotation": {},
					"OrderingTimestamp": {
						"type": "timestamp"
					}
				}
			}
		}
	}
};

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"GetResourceConfigHistory": {
			"input_token": "nextToken",
			"limit_key": "limit",
			"output_token": "nextToken",
			"result_key": "configurationItems"
		}
	}
};

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['cur'] = {};
AWS.CUR = Service.defineService('cur', ['2017-01-06']);
Object.defineProperty(apiLoader.services['cur'], '2017-01-06', {
  get: function get() {
    var model = __webpack_require__(1564);
    model.paginators = __webpack_require__(1565).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.CUR;


/***/ }),
/* 1564 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2017-01-06",
		"endpointPrefix": "cur",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Cost and Usage Report Service",
		"signatureVersion": "v4",
		"signingName": "cur",
		"targetPrefix": "AWSOrigamiServiceGatewayService",
		"uid": "cur-2017-01-06"
	},
	"operations": {
		"DeleteReportDefinition": {
			"input": {
				"type": "structure",
				"members": {
					"ReportName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResponseMessage": {}
				}
			}
		},
		"DescribeReportDefinitions": {
			"input": {
				"type": "structure",
				"members": {
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReportDefinitions": {
						"type": "list",
						"member": {
							"shape": "Sa"
						}
					},
					"NextToken": {}
				}
			}
		},
		"PutReportDefinition": {
			"input": {
				"type": "structure",
				"required": [
					"ReportDefinition"
				],
				"members": {
					"ReportDefinition": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		}
	},
	"shapes": {
		"Sa": {
			"type": "structure",
			"required": [
				"ReportName",
				"TimeUnit",
				"Format",
				"Compression",
				"AdditionalSchemaElements",
				"S3Bucket",
				"S3Prefix",
				"S3Region"
			],
			"members": {
				"ReportName": {},
				"TimeUnit": {},
				"Format": {},
				"Compression": {},
				"AdditionalSchemaElements": {
					"type": "list",
					"member": {}
				},
				"S3Bucket": {},
				"S3Prefix": {},
				"S3Region": {},
				"AdditionalArtifacts": {
					"type": "list",
					"member": {}
				}
			}
		}
	}
};

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeReportDefinitions": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		}
	}
};

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['devicefarm'] = {};
AWS.DeviceFarm = Service.defineService('devicefarm', ['2015-06-23']);
Object.defineProperty(apiLoader.services['devicefarm'], '2015-06-23', {
  get: function get() {
    var model = __webpack_require__(1567);
    model.paginators = __webpack_require__(1568).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DeviceFarm;


/***/ }),
/* 1567 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-06-23",
		"endpointPrefix": "devicefarm",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Device Farm",
		"signatureVersion": "v4",
		"targetPrefix": "DeviceFarm_20150623",
		"uid": "devicefarm-2015-06-23"
	},
	"operations": {
		"CreateDevicePool": {
			"input": {
				"type": "structure",
				"required": [
					"projectArn",
					"name",
					"rules"
				],
				"members": {
					"projectArn": {},
					"name": {},
					"description": {},
					"rules": {
						"shape": "S5"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"devicePool": {
						"shape": "Sb"
					}
				}
			}
		},
		"CreateNetworkProfile": {
			"input": {
				"type": "structure",
				"required": [
					"projectArn",
					"name"
				],
				"members": {
					"projectArn": {},
					"name": {},
					"description": {},
					"type": {},
					"uplinkBandwidthBits": {
						"type": "long"
					},
					"downlinkBandwidthBits": {
						"type": "long"
					},
					"uplinkDelayMs": {
						"type": "long"
					},
					"downlinkDelayMs": {
						"type": "long"
					},
					"uplinkJitterMs": {
						"type": "long"
					},
					"downlinkJitterMs": {
						"type": "long"
					},
					"uplinkLossPercent": {
						"type": "integer"
					},
					"downlinkLossPercent": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"networkProfile": {
						"shape": "Si"
					}
				}
			}
		},
		"CreateProject": {
			"input": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {},
					"defaultJobTimeoutMinutes": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"project": {
						"shape": "Sm"
					}
				}
			}
		},
		"CreateRemoteAccessSession": {
			"input": {
				"type": "structure",
				"required": [
					"projectArn",
					"deviceArn"
				],
				"members": {
					"projectArn": {},
					"deviceArn": {},
					"name": {},
					"configuration": {
						"type": "structure",
						"members": {
							"billingMethod": {}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"remoteAccessSession": {
						"shape": "Ss"
					}
				}
			}
		},
		"CreateUpload": {
			"input": {
				"type": "structure",
				"required": [
					"projectArn",
					"name",
					"type"
				],
				"members": {
					"projectArn": {},
					"name": {},
					"type": {},
					"contentType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"upload": {
						"shape": "S18"
					}
				}
			}
		},
		"DeleteDevicePool": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteNetworkProfile": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteProject": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteRemoteAccessSession": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteRun": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteUpload": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"GetAccountSettings": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"accountSettings": {
						"type": "structure",
						"members": {
							"awsAccountNumber": {},
							"unmeteredDevices": {
								"shape": "S1s"
							},
							"unmeteredRemoteAccessDevices": {
								"shape": "S1s"
							},
							"maxJobTimeoutMinutes": {
								"type": "integer"
							},
							"trialMinutes": {
								"type": "structure",
								"members": {
									"total": {
										"type": "double"
									},
									"remaining": {
										"type": "double"
									}
								}
							},
							"maxSlots": {
								"type": "map",
								"key": {},
								"value": {
									"type": "integer"
								}
							},
							"defaultJobTimeoutMinutes": {
								"type": "integer"
							}
						}
					}
				}
			}
		},
		"GetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"device": {
						"shape": "Sv"
					}
				}
			}
		},
		"GetDevicePool": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"devicePool": {
						"shape": "Sb"
					}
				}
			}
		},
		"GetDevicePoolCompatibility": {
			"input": {
				"type": "structure",
				"required": [
					"devicePoolArn"
				],
				"members": {
					"devicePoolArn": {},
					"appArn": {},
					"testType": {},
					"test": {
						"shape": "S21"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"compatibleDevices": {
						"shape": "S25"
					},
					"incompatibleDevices": {
						"shape": "S25"
					}
				}
			}
		},
		"GetJob": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"job": {
						"shape": "S2b"
					}
				}
			}
		},
		"GetNetworkProfile": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"networkProfile": {
						"shape": "Si"
					}
				}
			}
		},
		"GetOfferingStatus": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"current": {
						"shape": "S2i"
					},
					"nextPeriod": {
						"shape": "S2i"
					},
					"nextToken": {}
				}
			}
		},
		"GetProject": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"project": {
						"shape": "Sm"
					}
				}
			}
		},
		"GetRemoteAccessSession": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"remoteAccessSession": {
						"shape": "Ss"
					}
				}
			}
		},
		"GetRun": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"run": {
						"shape": "S2z"
					}
				}
			}
		},
		"GetSuite": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"suite": {
						"shape": "S32"
					}
				}
			}
		},
		"GetTest": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"test": {
						"shape": "S35"
					}
				}
			}
		},
		"GetUpload": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"upload": {
						"shape": "S18"
					}
				}
			}
		},
		"InstallToRemoteAccessSession": {
			"input": {
				"type": "structure",
				"required": [
					"remoteAccessSessionArn",
					"appArn"
				],
				"members": {
					"remoteAccessSessionArn": {},
					"appArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"appUpload": {
						"shape": "S18"
					}
				}
			}
		},
		"ListArtifacts": {
			"input": {
				"type": "structure",
				"required": [
					"arn",
					"type"
				],
				"members": {
					"arn": {},
					"type": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"artifacts": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"arn": {},
								"name": {},
								"type": {},
								"extension": {},
								"url": {}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListDevicePools": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"type": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"devicePools": {
						"type": "list",
						"member": {
							"shape": "Sb"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListDevices": {
			"input": {
				"type": "structure",
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"devices": {
						"type": "list",
						"member": {
							"shape": "Sv"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListJobs": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"jobs": {
						"type": "list",
						"member": {
							"shape": "S2b"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListNetworkProfiles": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"type": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"networkProfiles": {
						"type": "list",
						"member": {
							"shape": "Si"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListOfferingPromotions": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"offeringPromotions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"id": {},
								"description": {}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListOfferingTransactions": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"offeringTransactions": {
						"type": "list",
						"member": {
							"shape": "S40"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"offerings": {
						"type": "list",
						"member": {
							"shape": "S2m"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListProjects": {
			"input": {
				"type": "structure",
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"projects": {
						"type": "list",
						"member": {
							"shape": "Sm"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListRemoteAccessSessions": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"remoteAccessSessions": {
						"type": "list",
						"member": {
							"shape": "Ss"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListRuns": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"runs": {
						"type": "list",
						"member": {
							"shape": "S2z"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListSamples": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"samples": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"arn": {},
								"type": {},
								"url": {}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListSuites": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"suites": {
						"type": "list",
						"member": {
							"shape": "S32"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListTests": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tests": {
						"type": "list",
						"member": {
							"shape": "S35"
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListUniqueProblems": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"uniqueProblems": {
						"type": "map",
						"key": {},
						"value": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"message": {},
									"problems": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"run": {
													"shape": "S4w"
												},
												"job": {
													"shape": "S4w"
												},
												"suite": {
													"shape": "S4w"
												},
												"test": {
													"shape": "S4w"
												},
												"device": {
													"shape": "Sv"
												},
												"result": {},
												"message": {}
											}
										}
									}
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListUploads": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"nextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"uploads": {
						"type": "list",
						"member": {
							"shape": "S18"
						}
					},
					"nextToken": {}
				}
			}
		},
		"PurchaseOffering": {
			"input": {
				"type": "structure",
				"members": {
					"offeringId": {},
					"quantity": {
						"type": "integer"
					},
					"offeringPromotionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"offeringTransaction": {
						"shape": "S40"
					}
				}
			}
		},
		"RenewOffering": {
			"input": {
				"type": "structure",
				"members": {
					"offeringId": {},
					"quantity": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"offeringTransaction": {
						"shape": "S40"
					}
				}
			}
		},
		"ScheduleRun": {
			"input": {
				"type": "structure",
				"required": [
					"projectArn",
					"devicePoolArn",
					"test"
				],
				"members": {
					"projectArn": {},
					"appArn": {},
					"devicePoolArn": {},
					"name": {},
					"test": {
						"shape": "S21"
					},
					"configuration": {
						"type": "structure",
						"members": {
							"extraDataPackageArn": {},
							"networkProfileArn": {},
							"locale": {},
							"location": {
								"type": "structure",
								"required": [
									"latitude",
									"longitude"
								],
								"members": {
									"latitude": {
										"type": "double"
									},
									"longitude": {
										"type": "double"
									}
								}
							},
							"radios": {
								"type": "structure",
								"members": {
									"wifi": {
										"type": "boolean"
									},
									"bluetooth": {
										"type": "boolean"
									},
									"nfc": {
										"type": "boolean"
									},
									"gps": {
										"type": "boolean"
									}
								}
							},
							"auxiliaryApps": {
								"type": "list",
								"member": {}
							},
							"billingMethod": {}
						}
					},
					"executionConfiguration": {
						"type": "structure",
						"members": {
							"jobTimeoutMinutes": {
								"type": "integer"
							},
							"accountsCleanup": {
								"type": "boolean"
							},
							"appPackagesCleanup": {
								"type": "boolean"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"run": {
						"shape": "S2z"
					}
				}
			}
		},
		"StopRemoteAccessSession": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"remoteAccessSession": {
						"shape": "Ss"
					}
				}
			}
		},
		"StopRun": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"run": {
						"shape": "S2z"
					}
				}
			}
		},
		"UpdateDevicePool": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"name": {},
					"description": {},
					"rules": {
						"shape": "S5"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"devicePool": {
						"shape": "Sb"
					}
				}
			}
		},
		"UpdateNetworkProfile": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"name": {},
					"description": {},
					"type": {},
					"uplinkBandwidthBits": {
						"type": "long"
					},
					"downlinkBandwidthBits": {
						"type": "long"
					},
					"uplinkDelayMs": {
						"type": "long"
					},
					"downlinkDelayMs": {
						"type": "long"
					},
					"uplinkJitterMs": {
						"type": "long"
					},
					"downlinkJitterMs": {
						"type": "long"
					},
					"uplinkLossPercent": {
						"type": "integer"
					},
					"downlinkLossPercent": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"networkProfile": {
						"shape": "Si"
					}
				}
			}
		},
		"UpdateProject": {
			"input": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {},
					"name": {},
					"defaultJobTimeoutMinutes": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"project": {
						"shape": "Sm"
					}
				}
			}
		}
	},
	"shapes": {
		"S5": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"attribute": {},
					"operator": {},
					"value": {}
				}
			}
		},
		"Sb": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"description": {},
				"type": {},
				"rules": {
					"shape": "S5"
				}
			}
		},
		"Si": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"description": {},
				"type": {},
				"uplinkBandwidthBits": {
					"type": "long"
				},
				"downlinkBandwidthBits": {
					"type": "long"
				},
				"uplinkDelayMs": {
					"type": "long"
				},
				"downlinkDelayMs": {
					"type": "long"
				},
				"uplinkJitterMs": {
					"type": "long"
				},
				"downlinkJitterMs": {
					"type": "long"
				},
				"uplinkLossPercent": {
					"type": "integer"
				},
				"downlinkLossPercent": {
					"type": "integer"
				}
			}
		},
		"Sm": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"defaultJobTimeoutMinutes": {
					"type": "integer"
				},
				"created": {
					"type": "timestamp"
				}
			}
		},
		"Ss": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"created": {
					"type": "timestamp"
				},
				"status": {},
				"result": {},
				"message": {},
				"started": {
					"type": "timestamp"
				},
				"stopped": {
					"type": "timestamp"
				},
				"device": {
					"shape": "Sv"
				},
				"billingMethod": {},
				"deviceMinutes": {
					"shape": "S13"
				},
				"endpoint": {}
			}
		},
		"Sv": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"manufacturer": {},
				"model": {},
				"formFactor": {},
				"platform": {},
				"os": {},
				"cpu": {
					"type": "structure",
					"members": {
						"frequency": {},
						"architecture": {},
						"clock": {
							"type": "double"
						}
					}
				},
				"resolution": {
					"type": "structure",
					"members": {
						"width": {
							"type": "integer"
						},
						"height": {
							"type": "integer"
						}
					}
				},
				"heapSize": {
					"type": "long"
				},
				"memory": {
					"type": "long"
				},
				"image": {},
				"carrier": {},
				"radio": {},
				"remoteAccessEnabled": {
					"type": "boolean"
				},
				"fleetType": {},
				"fleetName": {}
			}
		},
		"S13": {
			"type": "structure",
			"members": {
				"total": {
					"type": "double"
				},
				"metered": {
					"type": "double"
				},
				"unmetered": {
					"type": "double"
				}
			}
		},
		"S18": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"created": {
					"type": "timestamp"
				},
				"type": {},
				"status": {},
				"url": {},
				"metadata": {},
				"contentType": {},
				"message": {}
			}
		},
		"S1s": {
			"type": "map",
			"key": {},
			"value": {
				"type": "integer"
			}
		},
		"S21": {
			"type": "structure",
			"required": [
				"type"
			],
			"members": {
				"type": {},
				"testPackageArn": {},
				"filter": {},
				"parameters": {
					"type": "map",
					"key": {},
					"value": {}
				}
			}
		},
		"S25": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"device": {
						"shape": "Sv"
					},
					"compatible": {
						"type": "boolean"
					},
					"incompatibilityMessages": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"message": {},
								"type": {}
							}
						}
					}
				}
			}
		},
		"S2b": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"type": {},
				"created": {
					"type": "timestamp"
				},
				"status": {},
				"result": {},
				"started": {
					"type": "timestamp"
				},
				"stopped": {
					"type": "timestamp"
				},
				"counters": {
					"shape": "S2c"
				},
				"message": {},
				"device": {
					"shape": "Sv"
				},
				"deviceMinutes": {
					"shape": "S13"
				}
			}
		},
		"S2c": {
			"type": "structure",
			"members": {
				"total": {
					"type": "integer"
				},
				"passed": {
					"type": "integer"
				},
				"failed": {
					"type": "integer"
				},
				"warned": {
					"type": "integer"
				},
				"errored": {
					"type": "integer"
				},
				"stopped": {
					"type": "integer"
				},
				"skipped": {
					"type": "integer"
				}
			}
		},
		"S2i": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S2k"
			}
		},
		"S2k": {
			"type": "structure",
			"members": {
				"type": {},
				"offering": {
					"shape": "S2m"
				},
				"quantity": {
					"type": "integer"
				},
				"effectiveOn": {
					"type": "timestamp"
				}
			}
		},
		"S2m": {
			"type": "structure",
			"members": {
				"id": {},
				"description": {},
				"type": {},
				"platform": {},
				"recurringCharges": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"cost": {
								"shape": "S2q"
							},
							"frequency": {}
						}
					}
				}
			}
		},
		"S2q": {
			"type": "structure",
			"members": {
				"amount": {
					"type": "double"
				},
				"currencyCode": {}
			}
		},
		"S2z": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"type": {},
				"platform": {},
				"created": {
					"type": "timestamp"
				},
				"status": {},
				"result": {},
				"started": {
					"type": "timestamp"
				},
				"stopped": {
					"type": "timestamp"
				},
				"counters": {
					"shape": "S2c"
				},
				"message": {},
				"totalJobs": {
					"type": "integer"
				},
				"completedJobs": {
					"type": "integer"
				},
				"billingMethod": {},
				"deviceMinutes": {
					"shape": "S13"
				},
				"networkProfile": {
					"shape": "Si"
				}
			}
		},
		"S32": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"type": {},
				"created": {
					"type": "timestamp"
				},
				"status": {},
				"result": {},
				"started": {
					"type": "timestamp"
				},
				"stopped": {
					"type": "timestamp"
				},
				"counters": {
					"shape": "S2c"
				},
				"message": {},
				"deviceMinutes": {
					"shape": "S13"
				}
			}
		},
		"S35": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {},
				"type": {},
				"created": {
					"type": "timestamp"
				},
				"status": {},
				"result": {},
				"started": {
					"type": "timestamp"
				},
				"stopped": {
					"type": "timestamp"
				},
				"counters": {
					"shape": "S2c"
				},
				"message": {},
				"deviceMinutes": {
					"shape": "S13"
				}
			}
		},
		"S40": {
			"type": "structure",
			"members": {
				"offeringStatus": {
					"shape": "S2k"
				},
				"transactionId": {},
				"offeringPromotionId": {},
				"createdOn": {
					"type": "timestamp"
				},
				"cost": {
					"shape": "S2q"
				}
			}
		},
		"S4w": {
			"type": "structure",
			"members": {
				"arn": {},
				"name": {}
			}
		}
	}
};

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"GetOfferingStatus": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": [
				"current",
				"nextPeriod"
			]
		},
		"ListArtifacts": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "artifacts"
		},
		"ListDevicePools": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "devicePools"
		},
		"ListDevices": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "devices"
		},
		"ListJobs": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "jobs"
		},
		"ListOfferingTransactions": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "offeringTransactions"
		},
		"ListOfferings": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "offerings"
		},
		"ListProjects": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "projects"
		},
		"ListRuns": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "runs"
		},
		"ListSamples": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "samples"
		},
		"ListSuites": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "suites"
		},
		"ListTests": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "tests"
		},
		"ListUniqueProblems": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "uniqueProblems"
		},
		"ListUploads": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "uploads"
		}
	}
};

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['directconnect'] = {};
AWS.DirectConnect = Service.defineService('directconnect', ['2012-10-25']);
Object.defineProperty(apiLoader.services['directconnect'], '2012-10-25', {
  get: function get() {
    var model = __webpack_require__(1570);
    model.paginators = __webpack_require__(1571).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DirectConnect;


/***/ }),
/* 1570 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2012-10-25",
		"endpointPrefix": "directconnect",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Direct Connect",
		"signatureVersion": "v4",
		"targetPrefix": "OvertureService",
		"uid": "directconnect-2012-10-25"
	},
	"operations": {
		"AllocateConnectionOnInterconnect": {
			"input": {
				"type": "structure",
				"required": [
					"bandwidth",
					"connectionName",
					"ownerAccount",
					"interconnectId",
					"vlan"
				],
				"members": {
					"bandwidth": {},
					"connectionName": {},
					"ownerAccount": {},
					"interconnectId": {},
					"vlan": {
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "S7"
			},
			"deprecated": true
		},
		"AllocateHostedConnection": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"ownerAccount",
					"bandwidth",
					"connectionName",
					"vlan"
				],
				"members": {
					"connectionId": {},
					"ownerAccount": {},
					"bandwidth": {},
					"connectionName": {},
					"vlan": {
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"AllocatePrivateVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"ownerAccount",
					"newPrivateVirtualInterfaceAllocation"
				],
				"members": {
					"connectionId": {},
					"ownerAccount": {},
					"newPrivateVirtualInterfaceAllocation": {
						"type": "structure",
						"required": [
							"virtualInterfaceName",
							"vlan",
							"asn"
						],
						"members": {
							"virtualInterfaceName": {},
							"vlan": {
								"type": "integer"
							},
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"amazonAddress": {},
							"addressFamily": {},
							"customerAddress": {}
						}
					}
				}
			},
			"output": {
				"shape": "Sp"
			}
		},
		"AllocatePublicVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"ownerAccount",
					"newPublicVirtualInterfaceAllocation"
				],
				"members": {
					"connectionId": {},
					"ownerAccount": {},
					"newPublicVirtualInterfaceAllocation": {
						"type": "structure",
						"required": [
							"virtualInterfaceName",
							"vlan",
							"asn"
						],
						"members": {
							"virtualInterfaceName": {},
							"vlan": {
								"type": "integer"
							},
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"amazonAddress": {},
							"customerAddress": {},
							"addressFamily": {},
							"routeFilterPrefixes": {
								"shape": "Sv"
							}
						}
					}
				}
			},
			"output": {
				"shape": "Sp"
			}
		},
		"AssociateConnectionWithLag": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"lagId"
				],
				"members": {
					"connectionId": {},
					"lagId": {}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"AssociateHostedConnection": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"parentConnectionId"
				],
				"members": {
					"connectionId": {},
					"parentConnectionId": {}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"AssociateVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"virtualInterfaceId",
					"connectionId"
				],
				"members": {
					"virtualInterfaceId": {},
					"connectionId": {}
				}
			},
			"output": {
				"shape": "Sp"
			}
		},
		"ConfirmConnection": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId"
				],
				"members": {
					"connectionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"connectionState": {}
				}
			}
		},
		"ConfirmPrivateVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"virtualInterfaceId",
					"virtualGatewayId"
				],
				"members": {
					"virtualInterfaceId": {},
					"virtualGatewayId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterfaceState": {}
				}
			}
		},
		"ConfirmPublicVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"virtualInterfaceId"
				],
				"members": {
					"virtualInterfaceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterfaceState": {}
				}
			}
		},
		"CreateBGPPeer": {
			"input": {
				"type": "structure",
				"members": {
					"virtualInterfaceId": {},
					"newBGPPeer": {
						"type": "structure",
						"members": {
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"addressFamily": {},
							"amazonAddress": {},
							"customerAddress": {}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterface": {
						"shape": "Sp"
					}
				}
			}
		},
		"CreateConnection": {
			"input": {
				"type": "structure",
				"required": [
					"location",
					"bandwidth",
					"connectionName"
				],
				"members": {
					"location": {},
					"bandwidth": {},
					"connectionName": {},
					"lagId": {}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"CreateInterconnect": {
			"input": {
				"type": "structure",
				"required": [
					"interconnectName",
					"bandwidth",
					"location"
				],
				"members": {
					"interconnectName": {},
					"bandwidth": {},
					"location": {},
					"lagId": {}
				}
			},
			"output": {
				"shape": "S1j"
			}
		},
		"CreateLag": {
			"input": {
				"type": "structure",
				"required": [
					"numberOfConnections",
					"location",
					"connectionsBandwidth",
					"lagName"
				],
				"members": {
					"numberOfConnections": {
						"type": "integer"
					},
					"location": {},
					"connectionsBandwidth": {},
					"lagName": {},
					"connectionId": {}
				}
			},
			"output": {
				"shape": "S1o"
			}
		},
		"CreatePrivateVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"newPrivateVirtualInterface"
				],
				"members": {
					"connectionId": {},
					"newPrivateVirtualInterface": {
						"type": "structure",
						"required": [
							"virtualInterfaceName",
							"vlan",
							"asn",
							"virtualGatewayId"
						],
						"members": {
							"virtualInterfaceName": {},
							"vlan": {
								"type": "integer"
							},
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"amazonAddress": {},
							"customerAddress": {},
							"addressFamily": {},
							"virtualGatewayId": {}
						}
					}
				}
			},
			"output": {
				"shape": "Sp"
			}
		},
		"CreatePublicVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"newPublicVirtualInterface"
				],
				"members": {
					"connectionId": {},
					"newPublicVirtualInterface": {
						"type": "structure",
						"required": [
							"virtualInterfaceName",
							"vlan",
							"asn"
						],
						"members": {
							"virtualInterfaceName": {},
							"vlan": {
								"type": "integer"
							},
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"amazonAddress": {},
							"customerAddress": {},
							"addressFamily": {},
							"routeFilterPrefixes": {
								"shape": "Sv"
							}
						}
					}
				}
			},
			"output": {
				"shape": "Sp"
			}
		},
		"DeleteBGPPeer": {
			"input": {
				"type": "structure",
				"members": {
					"virtualInterfaceId": {},
					"asn": {
						"type": "integer"
					},
					"customerAddress": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterface": {
						"shape": "Sp"
					}
				}
			}
		},
		"DeleteConnection": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId"
				],
				"members": {
					"connectionId": {}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"DeleteInterconnect": {
			"input": {
				"type": "structure",
				"required": [
					"interconnectId"
				],
				"members": {
					"interconnectId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"interconnectState": {}
				}
			}
		},
		"DeleteLag": {
			"input": {
				"type": "structure",
				"required": [
					"lagId"
				],
				"members": {
					"lagId": {}
				}
			},
			"output": {
				"shape": "S1o"
			}
		},
		"DeleteVirtualInterface": {
			"input": {
				"type": "structure",
				"required": [
					"virtualInterfaceId"
				],
				"members": {
					"virtualInterfaceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterfaceState": {}
				}
			}
		},
		"DescribeConnectionLoa": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId"
				],
				"members": {
					"connectionId": {},
					"providerName": {},
					"loaContentType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"loa": {
						"shape": "S28"
					}
				}
			},
			"deprecated": true
		},
		"DescribeConnections": {
			"input": {
				"type": "structure",
				"members": {
					"connectionId": {}
				}
			},
			"output": {
				"shape": "S2b"
			}
		},
		"DescribeConnectionsOnInterconnect": {
			"input": {
				"type": "structure",
				"required": [
					"interconnectId"
				],
				"members": {
					"interconnectId": {}
				}
			},
			"output": {
				"shape": "S2b"
			},
			"deprecated": true
		},
		"DescribeHostedConnections": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId"
				],
				"members": {
					"connectionId": {}
				}
			},
			"output": {
				"shape": "S2b"
			}
		},
		"DescribeInterconnectLoa": {
			"input": {
				"type": "structure",
				"required": [
					"interconnectId"
				],
				"members": {
					"interconnectId": {},
					"providerName": {},
					"loaContentType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"loa": {
						"shape": "S28"
					}
				}
			},
			"deprecated": true
		},
		"DescribeInterconnects": {
			"input": {
				"type": "structure",
				"members": {
					"interconnectId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"interconnects": {
						"type": "list",
						"member": {
							"shape": "S1j"
						}
					}
				}
			}
		},
		"DescribeLags": {
			"input": {
				"type": "structure",
				"members": {
					"lagId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"lags": {
						"type": "list",
						"member": {
							"shape": "S1o"
						}
					}
				}
			}
		},
		"DescribeLoa": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId"
				],
				"members": {
					"connectionId": {},
					"providerName": {},
					"loaContentType": {}
				}
			},
			"output": {
				"shape": "S28"
			}
		},
		"DescribeLocations": {
			"output": {
				"type": "structure",
				"members": {
					"locations": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"locationCode": {},
								"locationName": {}
							}
						}
					}
				}
			}
		},
		"DescribeTags": {
			"input": {
				"type": "structure",
				"required": [
					"resourceArns"
				],
				"members": {
					"resourceArns": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"resourceTags": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"resourceArn": {},
								"tags": {
									"shape": "S2x"
								}
							}
						}
					}
				}
			}
		},
		"DescribeVirtualGateways": {
			"output": {
				"type": "structure",
				"members": {
					"virtualGateways": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"virtualGatewayId": {},
								"virtualGatewayState": {}
							}
						}
					}
				}
			}
		},
		"DescribeVirtualInterfaces": {
			"input": {
				"type": "structure",
				"members": {
					"connectionId": {},
					"virtualInterfaceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"virtualInterfaces": {
						"type": "list",
						"member": {
							"shape": "Sp"
						}
					}
				}
			}
		},
		"DisassociateConnectionFromLag": {
			"input": {
				"type": "structure",
				"required": [
					"connectionId",
					"lagId"
				],
				"members": {
					"connectionId": {},
					"lagId": {}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"TagResource": {
			"input": {
				"type": "structure",
				"required": [
					"resourceArn",
					"tags"
				],
				"members": {
					"resourceArn": {},
					"tags": {
						"shape": "S2x"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UntagResource": {
			"input": {
				"type": "structure",
				"required": [
					"resourceArn",
					"tagKeys"
				],
				"members": {
					"resourceArn": {},
					"tagKeys": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateLag": {
			"input": {
				"type": "structure",
				"required": [
					"lagId"
				],
				"members": {
					"lagId": {},
					"lagName": {},
					"minimumLinks": {
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "S1o"
			}
		}
	},
	"shapes": {
		"S7": {
			"type": "structure",
			"members": {
				"ownerAccount": {},
				"connectionId": {},
				"connectionName": {},
				"connectionState": {},
				"region": {},
				"location": {},
				"bandwidth": {},
				"vlan": {
					"type": "integer"
				},
				"partnerName": {},
				"loaIssueTime": {
					"type": "timestamp"
				},
				"lagId": {},
				"awsDevice": {}
			}
		},
		"Sp": {
			"type": "structure",
			"members": {
				"ownerAccount": {},
				"virtualInterfaceId": {},
				"location": {},
				"connectionId": {},
				"virtualInterfaceType": {},
				"virtualInterfaceName": {},
				"vlan": {
					"type": "integer"
				},
				"asn": {
					"type": "integer"
				},
				"authKey": {},
				"amazonAddress": {},
				"customerAddress": {},
				"addressFamily": {},
				"virtualInterfaceState": {},
				"customerRouterConfig": {},
				"virtualGatewayId": {},
				"routeFilterPrefixes": {
					"shape": "Sv"
				},
				"bgpPeers": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"asn": {
								"type": "integer"
							},
							"authKey": {},
							"addressFamily": {},
							"amazonAddress": {},
							"customerAddress": {},
							"bgpPeerState": {},
							"bgpStatus": {}
						}
					}
				}
			}
		},
		"Sv": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"cidr": {}
				}
			}
		},
		"S1j": {
			"type": "structure",
			"members": {
				"interconnectId": {},
				"interconnectName": {},
				"interconnectState": {},
				"region": {},
				"location": {},
				"bandwidth": {},
				"loaIssueTime": {
					"type": "timestamp"
				},
				"lagId": {},
				"awsDevice": {}
			}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"connectionsBandwidth": {},
				"numberOfConnections": {
					"type": "integer"
				},
				"lagId": {},
				"ownerAccount": {},
				"lagName": {},
				"lagState": {},
				"location": {},
				"region": {},
				"minimumLinks": {
					"type": "integer"
				},
				"awsDevice": {},
				"connections": {
					"shape": "S1q"
				},
				"allowsHostedConnections": {
					"type": "boolean"
				}
			}
		},
		"S1q": {
			"type": "list",
			"member": {
				"shape": "S7"
			}
		},
		"S28": {
			"type": "structure",
			"members": {
				"loaContent": {
					"type": "blob"
				},
				"loaContentType": {}
			}
		},
		"S2b": {
			"type": "structure",
			"members": {
				"connections": {
					"shape": "S1q"
				}
			}
		},
		"S2x": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"key"
				],
				"members": {
					"key": {},
					"value": {}
				}
			}
		}
	}
};

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeConnections": {
			"result_key": "connections"
		},
		"DescribeConnectionsOnInterconnect": {
			"result_key": "connections"
		},
		"DescribeInterconnects": {
			"result_key": "interconnects"
		},
		"DescribeLocations": {
			"result_key": "locations"
		},
		"DescribeVirtualGateways": {
			"result_key": "virtualGateways"
		},
		"DescribeVirtualInterfaces": {
			"result_key": "virtualInterfaces"
		}
	}
};

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['dynamodb'] = {};
AWS.DynamoDB = Service.defineService('dynamodb', ['2011-12-05', '2012-08-10']);
__webpack_require__(1573);
Object.defineProperty(apiLoader.services['dynamodb'], '2011-12-05', {
  get: function get() {
    var model = __webpack_require__(1578);
    model.paginators = __webpack_require__(1579).pagination;
    model.waiters = __webpack_require__(1580).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['dynamodb'], '2012-08-10', {
  get: function get() {
    var model = __webpack_require__(1581);
    model.paginators = __webpack_require__(1582).pagination;
    model.waiters = __webpack_require__(1583).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DynamoDB;


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
__webpack_require__(1574);

AWS.util.update(AWS.DynamoDB.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    if (request.service.config.dynamoDbCrc32) {
      request.removeListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
      request.addListener('extractData', this.checkCrc32);
      request.addListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
    }
  },

  /**
   * @api private
   */
  checkCrc32: function checkCrc32(resp) {
    if (!resp.httpResponse.streaming && !resp.request.service.crc32IsValid(resp)) {
      resp.data = null;
      resp.error = AWS.util.error(new Error(), {
        code: 'CRC32CheckFailed',
        message: 'CRC32 integrity check failed',
        retryable: true
      });
      resp.request.haltHandlersOnError();
      throw (resp.error);
    }
  },

  /**
   * @api private
   */
  crc32IsValid: function crc32IsValid(resp) {
    var crc = resp.httpResponse.headers['x-amz-crc32'];
    if (!crc) return true; // no (valid) CRC32 header
    return parseInt(crc, 10) === AWS.util.crypto.crc32(resp.httpResponse.body);
  },

  /**
   * @api private
   */
  defaultRetryCount: 10,

  /**
   * @api private
   */
  retryDelays: function retryDelays(retryCount) {
    var retryDelayOptions = AWS.util.copy(this.config.retryDelayOptions);

    if (typeof retryDelayOptions.base !== 'number') {
        retryDelayOptions.base = 50; // default for dynamodb
    }
    var delay = AWS.util.calculateRetryDelay(retryCount, retryDelayOptions);
    return delay;
  }
});


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var Translator = __webpack_require__(1575);
var DynamoDBSet = __webpack_require__(815);

/**
 * The document client simplifies working with items in Amazon DynamoDB
 * by abstracting away the notion of attribute values. This abstraction
 * annotates native JavaScript types supplied as input parameters, as well
 * as converts annotated response data to native JavaScript types.
 *
 * ## Marshalling Input and Unmarshalling Response Data
 *
 * The document client affords developers the use of native JavaScript types
 * instead of `AttributeValue`s to simplify the JavaScript development
 * experience with Amazon DynamoDB. JavaScript objects passed in as parameters
 * are marshalled into `AttributeValue` shapes required by Amazon DynamoDB.
 * Responses from DynamoDB are unmarshalled into plain JavaScript objects
 * by the `DocumentClient`. The `DocumentClient`, does not accept
 * `AttributeValue`s in favor of native JavaScript types.
 *
 * |                             JavaScript Type                            | DynamoDB AttributeValue |
 * |:----------------------------------------------------------------------:|-------------------------|
 * | String                                                                 | S                       |
 * | Number                                                                 | N                       |
 * | Boolean                                                                | BOOL                    |
 * | null                                                                   | NULL                    |
 * | Array                                                                  | L                       |
 * | Object                                                                 | M                       |
 * | Buffer, File, Blob, ArrayBuffer, DataView, and JavaScript typed arrays | B                       |
 *
 * ## Support for Sets
 *
 * The `DocumentClient` offers a convenient way to create sets from
 * JavaScript Arrays. The type of set is inferred from the first element
 * in the array. DynamoDB supports string, number, and binary sets. To
 * learn more about supported types see the
 * [Amazon DynamoDB Data Model Documentation](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html)
 * For more information see {AWS.DynamoDB.DocumentClient.createSet}
 *
 */
AWS.DynamoDB.DocumentClient = AWS.util.inherit({

  /**
   * @api private
   */
  operations: {
    batchGetItem: 'batchGet',
    batchWriteItem: 'batchWrite',
    putItem: 'put',
    getItem: 'get',
    deleteItem: 'delete',
    updateItem: 'update',
    scan: 'scan',
    query: 'query'
  },

  /**
   * Creates a DynamoDB document client with a set of configuration options.
   *
   * @option options params [map] An optional map of parameters to bind to every
   *   request sent by this service object.
   * @option options service [AWS.DynamoDB] An optional pre-configured instance
   *  of the AWS.DynamoDB service object to use for requests. The object may
   *  bound parameters used by the document client.
   * @option options convertEmptyValues [Boolean] set to true if you would like
   *  the document client to convert empty values (0-length strings, binary
   *  buffers, and sets) to be converted to NULL types when persisting to
   *  DynamoDB.
   * @see AWS.DynamoDB.constructor
   *
   */
  constructor: function DocumentClient(options) {
    var self = this;
    self.options = options || {};
    self.configure(self.options);
  },

  /**
   * @api private
   */
  configure: function configure(options) {
    var self = this;
    self.service = options.service;
    self.bindServiceObject(options);
    self.attrValue = options.attrValue =
      self.service.api.operations.putItem.input.members.Item.value.shape;
  },

  /**
   * @api private
   */
  bindServiceObject: function bindServiceObject(options) {
    var self = this;
    options = options || {};

    if (!self.service) {
      self.service = new AWS.DynamoDB(options);
    } else {
      var config = AWS.util.copy(self.service.config);
      self.service = new self.service.constructor.__super__(config);
      self.service.config.params =
        AWS.util.merge(self.service.config.params || {}, options.params);
    }
  },

  /**
   * Returns the attributes of one or more items from one or more tables
   * by delegating to `AWS.DynamoDB.batchGetItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.batchGetItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.batchGetItem
   * @example Get items from multiple tables
   *  var params = {
   *    RequestItems: {
   *      'Table-1': {
   *        Keys: [
   *          {
   *             HashKey: 'haskey',
   *             NumberRangeKey: 1
   *          }
   *        ]
   *      },
   *      'Table-2': {
   *        Keys: [
   *          { foo: 'bar' },
   *        ]
   *      }
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.batchGet(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  batchGet: function(params, callback) {
    var self = this;
    var request = self.service.batchGetItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Puts or deletes multiple items in one or more tables by delegating
   * to `AWS.DynamoDB.batchWriteItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.batchWriteItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.batchWriteItem
   * @example Write to and delete from a table
   *  var params = {
   *    RequestItems: {
   *      'Table-1': [
   *        {
   *          DeleteRequest: {
   *            Key: { HashKey: 'someKey' }
   *          }
   *        },
   *        {
   *          PutRequest: {
   *            Item: {
   *              HashKey: 'anotherKey',
   *              NumAttribute: 1,
   *              BoolAttribute: true,
   *              ListAttribute: [1, 'two', false],
   *              MapAttribute: { foo: 'bar' }
   *            }
   *          }
   *        }
   *      ]
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.batchWrite(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  batchWrite: function(params, callback) {
    var self = this;
    var request = self.service.batchWriteItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Deletes a single item in a table by primary key by delegating to
   * `AWS.DynamoDB.deleteItem()`
   *
   * Supply the same parameters as {AWS.DynamoDB.deleteItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.deleteItem
   * @example Delete an item from a table
   *  var params = {
   *    TableName : 'Table',
   *    Key: {
   *      HashKey: 'hashkey',
   *      NumberRangeKey: 1
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.delete(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  delete: function(params, callback) {
    var self = this;
    var request = self.service.deleteItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Returns a set of attributes for the item with the given primary key
   * by delegating to `AWS.DynamoDB.getItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.getItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.getItem
   * @example Get an item from a table
   *  var params = {
   *    TableName : 'Table',
   *    Key: {
   *      HashKey: 'hashkey'
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.get(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  get: function(params, callback) {
    var self = this;
    var request = self.service.getItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Creates a new item, or replaces an old item with a new item by
   * delegating to `AWS.DynamoDB.putItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.putItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.putItem
   * @example Create a new item in a table
   *  var params = {
   *    TableName : 'Table',
   *    Item: {
   *       HashKey: 'haskey',
   *       NumAttribute: 1,
   *       BoolAttribute: true,
   *       ListAttribute: [1, 'two', false],
   *       MapAttribute: { foo: 'bar'},
   *       NullAttribute: null
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.put(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  put: function put(params, callback) {
    var self = this;
    var request = self.service.putItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Edits an existing item's attributes, or adds a new item to the table if
   * it does not already exist by delegating to `AWS.DynamoDB.updateItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.updateItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.updateItem
   * @example Update an item with expressions
   *  var params = {
   *    TableName: 'Table',
   *    Key: { HashKey : 'hashkey' },
   *    UpdateExpression: 'set #a = :x + :y',
   *    ConditionExpression: '#a < :MAX',
   *    ExpressionAttributeNames: {'#a' : 'Sum'},
   *    ExpressionAttributeValues: {
   *      ':x' : 20,
   *      ':y' : 45,
   *      ':MAX' : 100,
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.update(params, function(err, data) {
   *     if (err) console.log(err);
   *     else console.log(data);
   *  });
   *
   */
  update: function(params, callback) {
    var self = this;
    var request = self.service.updateItem(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Returns one or more items and item attributes by accessing every item
   * in a table or a secondary index.
   *
   * Supply the same parameters as {AWS.DynamoDB.scan} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.scan
   * @example Scan the table with a filter expression
   *  var params = {
   *    TableName : 'Table',
   *    FilterExpression : 'Year = :this_year',
   *    ExpressionAttributeValues : {':this_year' : 2015}
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.scan(params, function(err, data) {
   *     if (err) console.log(err);
   *     else console.log(data);
   *  });
   *
   */
  scan: function(params, callback) {
    var self = this;
    var request = self.service.scan(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

   /**
    * Directly access items from a table by primary key or a secondary index.
    *
    * Supply the same parameters as {AWS.DynamoDB.query} with
    * `AttributeValue`s substituted by native JavaScript types.
    *
    * @see AWS.DynamoDB.query
    * @example Query an index
    *  var params = {
    *    TableName: 'Table',
    *    IndexName: 'Index',
    *    KeyConditionExpression: 'HashKey = :hkey and RangeKey > :rkey',
    *    ExpressionAttributeValues: {
    *      ':hkey': 'key',
    *      ':rkey': 2015
    *    }
    *  };
    *
    *  var documentClient = new AWS.DynamoDB.DocumentClient();
    *
    *  documentClient.query(params, function(err, data) {
    *     if (err) console.log(err);
    *     else console.log(data);
    *  });
    *
    */
  query: function(params, callback) {
    var self = this;
    var request = self.service.query(params);
    self.setupRequest(request);
    self.setupResponse(request);
    if (typeof callback === 'function') {
      request.send(callback);
    }
    return request;
  },

  /**
   * Creates a set of elements inferring the type of set from
   * the type of the first element. Amazon DynamoDB currently supports
   * the number sets, string sets, and binary sets. For more information
   * about DynamoDB data types see the documentation on the
   * [Amazon DynamoDB Data Model](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html#DataModel.DataTypes).
   *
   * @param list [Array] Collection to represent your DynamoDB Set
   * @param options [map]
   *  * **validate** [Boolean] set to true if you want to validate the type
   *    of each element in the set. Defaults to `false`.
   * @example Creating a number set
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  var params = {
   *    Item: {
   *      hashkey: 'hashkey'
   *      numbers: documentClient.createSet([1, 2, 3]);
   *    }
   *  };
   *
   *  documentClient.put(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */
  createSet: function(list, options) {
    options = options || {};
    return new DynamoDBSet(list, options);
  },

  /**
   * @api private
   */
  getTranslator: function() {
    return new Translator(this.options);
  },

  /**
   * @api private
   */
  setupRequest: function setupRequest(request) {
    var self = this;
    var translator = self.getTranslator();
    var operation = request.operation;
    var inputShape = request.service.api.operations[operation].input;
    request._events.validate.unshift(function(req) {
      req.rawParams = AWS.util.copy(req.params);
      req.params = translator.translateInput(req.rawParams, inputShape);
    });
  },

  /**
   * @api private
   */
  setupResponse: function setupResponse(request) {
    var self = this;
    var translator = self.getTranslator();
    var outputShape = self.service.api.operations[request.operation].output;
    request.on('extractData', function(response) {
      response.data = translator.translateOutput(response.data, outputShape);
    });

    var response = request.response;
    response.nextPage = function(cb) {
      var resp = this;
      var req = resp.request;
      var config;
      var service = req.service;
      var operation = req.operation;
      try {
        config = service.paginationConfig(operation, true);
      } catch (e) { resp.error = e; }

      if (!resp.hasNextPage()) {
        if (cb) cb(resp.error, null);
        else if (resp.error) throw resp.error;
        return null;
      }

      var params = AWS.util.copy(req.rawParams);
      if (!resp.nextPageTokens) {
        return cb ? cb(null, null) : null;
      } else {
        var inputTokens = config.inputToken;
        if (typeof inputTokens === 'string') inputTokens = [inputTokens];
        for (var i = 0; i < inputTokens.length; i++) {
          params[inputTokens[i]] = resp.nextPageTokens[i];
        }
        return self[operation](params, cb);
      }
    };
  }

});

module.exports = AWS.DynamoDB.DocumentClient;


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(7).util;
var convert = __webpack_require__(1576);

var Translator = function(options) {
  options = options || {};
  this.attrValue = options.attrValue;
  this.convertEmptyValues = Boolean(options.convertEmptyValues);
  this.wrapNumbers = Boolean(options.wrapNumbers);
};

Translator.prototype.translateInput = function(value, shape) {
  this.mode = 'input';
  return this.translate(value, shape);
};

Translator.prototype.translateOutput = function(value, shape) {
  this.mode = 'output';
  return this.translate(value, shape);
};

Translator.prototype.translate = function(value, shape) {
  var self = this;
  if (!shape || value === undefined) return undefined;

  if (shape.shape === self.attrValue) {
    return convert[self.mode](value, {
      convertEmptyValues: self.convertEmptyValues,
      wrapNumbers: self.wrapNumbers,
    });
  }
  switch (shape.type) {
    case 'structure': return self.translateStructure(value, shape);
    case 'map': return self.translateMap(value, shape);
    case 'list': return self.translateList(value, shape);
    default: return self.translateScalar(value, shape);
  }
};

Translator.prototype.translateStructure = function(structure, shape) {
  var self = this;
  if (structure == null) return undefined;

  var struct = {};
  util.each(structure, function(name, value) {
    var memberShape = shape.members[name];
    if (memberShape) {
      var result = self.translate(value, memberShape);
      if (result !== undefined) struct[name] = result;
    }
  });
  return struct;
};

Translator.prototype.translateList = function(list, shape) {
  var self = this;
  if (list == null) return undefined;

  var out = [];
  util.arrayEach(list, function(value) {
    var result = self.translate(value, shape.member);
    if (result === undefined) out.push(null);
    else out.push(result);
  });
  return out;
};

Translator.prototype.translateMap = function(map, shape) {
  var self = this;
  if (map == null) return undefined;

  var out = {};
  util.each(map, function(key, value) {
    var result = self.translate(value, shape.value);
    if (result === undefined) out[key] = null;
    else out[key] = result;
  });
  return out;
};

Translator.prototype.translateScalar = function(value, shape) {
  return shape.toType(value);
};

module.exports = Translator;


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var util = AWS.util;
var typeOf = __webpack_require__(814).typeOf;
var DynamoDBSet = __webpack_require__(815);
var NumberValue = __webpack_require__(1577);

AWS.DynamoDB.Converter = {
  /**
   * Convert a JavaScript value to its equivalent DynamoDB AttributeValue type
   *
   * @param data [any] The data to convert to a DynamoDB AttributeValue
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   * @return [map] An object in the Amazon DynamoDB AttributeValue format
   *
   * @see AWS.DynamoDB.Converter.marshall AWS.DynamoDB.Converter.marshall to
   *    convert entire records (rather than individual attributes)
   */
  input: function convertInput(data, options) {
    options = options || {};
    var type = typeOf(data);
    if (type === 'Object') {
      return formatMap(data, options);
    } else if (type === 'Array') {
      return formatList(data, options);
    } else if (type === 'Set') {
      return formatSet(data, options);
    } else if (type === 'String') {
      if (data.length === 0 && options.convertEmptyValues) {
        return convertInput(null);
      }
      return { S: data };
    } else if (type === 'Number' || type === 'NumberValue') {
      return { N: data.toString() };
    } else if (type === 'Binary') {
      if (data.length === 0 && options.convertEmptyValues) {
        return convertInput(null);
      }
      return { B: data };
    } else if (type === 'Boolean') {
      return { BOOL: data };
    } else if (type === 'null') {
      return { NULL: true };
    } else if (type !== 'undefined' && type !== 'Function') {
      // this value has a custom constructor
      return formatMap(data, options);
    }
  },

  /**
   * Convert a JavaScript object into a DynamoDB record.
   *
   * @param data [any] The data to convert to a DynamoDB record
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [map] An object in the DynamoDB record format.
   *
   * @example Convert a JavaScript object into a DynamoDB record
   *  var marshalled = AWS.DynamoDB.Converter.marshall({
   *    string: 'foo',
   *    list: ['fizz', 'buzz', 'pop'],
   *    map: {
   *      nestedMap: {
   *        key: 'value',
   *      }
   *    },
   *    number: 123,
   *    nullValue: null,
   *    boolValue: true,
   *    stringSet: new DynamoDBSet(['foo', 'bar', 'baz'])
   *  });
   */
  marshall: function marshallItem(data, options) {
    return AWS.DynamoDB.Converter.input(data, options).M;
  },

  /**
   * Convert a DynamoDB AttributeValue object to its equivalent JavaScript type.
   *
   * @param data [map] An object in the Amazon DynamoDB AttributeValue format
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [Object|Array|String|Number|Boolean|null]
   *
   * @see AWS.DynamoDB.Converter.unmarshall AWS.DynamoDB.Converter.unmarshall to
   *    convert entire records (rather than individual attributes)
   */
  output: function convertOutput(data, options) {
    options = options || {};
    var list, map, i;
    for (var type in data) {
      var values = data[type];
      if (type === 'M') {
        map = {};
        for (var key in values) {
          map[key] = convertOutput(values[key], options);
        }
        return map;
      } else if (type === 'L') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(convertOutput(values[i], options));
        }
        return list;
      } else if (type === 'SS') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(values[i] + '');
        }
        return new DynamoDBSet(list);
      } else if (type === 'NS') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(convertNumber(values[i], options.wrapNumbers));
        }
        return new DynamoDBSet(list);
      } else if (type === 'BS') {
        list = [];
        for (i = 0; i < values.length; i++) {
          list.push(new util.Buffer(values[i]));
        }
        return new DynamoDBSet(list);
      } else if (type === 'S') {
        return values + '';
      } else if (type === 'N') {
        return convertNumber(values, options.wrapNumbers);
      } else if (type === 'B') {
        return new util.Buffer(values);
      } else if (type === 'BOOL') {
        return (values === 'true' || values === 'TRUE' || values === true);
      } else if (type === 'NULL') {
        return null;
      }
    }
  },

  /**
   * Convert a DynamoDB record into a JavaScript object.
   *
   * @param data [any] The DynamoDB record
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [map] An object whose properties have been converted from
   *    DynamoDB's AttributeValue format into their corresponding native
   *    JavaScript types.
   *
   * @example Convert a record received from a DynamoDB stream
   *  var unmarshalled = AWS.DynamoDB.Converter.unmarshall({
   *    string: {S: 'foo'},
   *    list: {L: [{S: 'fizz'}, {S: 'buzz'}, {S: 'pop'}]},
   *    map: {
   *      M: {
   *        nestedMap: {
   *          M: {
   *            key: {S: 'value'}
   *          }
   *        }
   *      }
   *    },
   *    number: {N: '123'},
   *    nullValue: {NULL: true},
   *    boolValue: {BOOL: true}
   *  });
   */
  unmarshall: function unmarshall(data, options) {
    return AWS.DynamoDB.Converter.output({M: data}, options);
  }
};

/**
 * @api private
 * @param data [Array]
 * @param options [map]
 */
function formatList(data, options) {
  var list = {L: []};
  for (var i = 0; i < data.length; i++) {
    list['L'].push(AWS.DynamoDB.Converter.input(data[i], options));
  }
  return list;
}

/**
 * @api private
 * @param value [String]
 * @param wrapNumbers [Boolean]
 */
function convertNumber(value, wrapNumbers) {
  return wrapNumbers ? new NumberValue(value) : Number(value);
}

/**
 * @api private
 * @param data [map]
 * @param options [map]
 */
function formatMap(data, options) {
  var map = {M: {}};
  for (var key in data) {
    var formatted = AWS.DynamoDB.Converter.input(data[key], options);
    if (formatted !== void 0) {
      map['M'][key] = formatted;
    }
  }
  return map;
}

/**
 * @api private
 */
function formatSet(data, options) {
  options = options || {};
  var values = data.values;
  if (options.convertEmptyValues) {
    values = filterEmptySetValues(data);
    if (values.length === 0) {
      return AWS.DynamoDB.Converter.input(null);
    }
  }

  var map = {};
  switch (data.type) {
    case 'String': map['SS'] = values; break;
    case 'Binary': map['BS'] = values; break;
    case 'Number': map['NS'] = values.map(function (value) {
      return value.toString();
    });
  }
  return map;
}

/**
 * @api private
 */
function filterEmptySetValues(set) {
    var nonEmptyValues = [];
    var potentiallyEmptyTypes = {
        String: true,
        Binary: true,
        Number: false
    };
    if (potentiallyEmptyTypes[set.type]) {
        for (var i = 0; i < set.values.length; i++) {
            if (set.values[i].length === 0) {
                continue;
            }
            nonEmptyValues.push(set.values[i]);
        }

        return nonEmptyValues;
    }

    return set.values;
}

module.exports = AWS.DynamoDB.Converter;


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(7).util;

/**
 * An object recognizable as a numeric value that stores the underlying number
 * as a string.
 *
 * Intended to be a deserialization target for the DynamoDB Document Client when
 * the `wrapNumbers` flag is set. This allows for numeric values that lose
 * precision when converted to JavaScript's `number` type.
 */
var DynamoDBNumberValue = util.inherit({
  constructor: function NumberValue(value) {
    this.value = value.toString();
  },

  /**
   * Render the underlying value as a number when converting to JSON.
   */
  toJSON: function () {
    return this.toNumber();
  },

  /**
   * Convert the underlying value to a JavaScript number.
   */
  toNumber: function () {
    return Number(this.value);
  },

  /**
   * Return a string representing the unaltered value provided to the
   * constructor.
   */
  toString: function () {
    return this.value;
  }
});

module.exports = DynamoDBNumberValue;

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2011-12-05",
		"endpointPrefix": "dynamodb",
		"jsonVersion": "1.0",
		"protocol": "json",
		"serviceAbbreviation": "DynamoDB",
		"serviceFullName": "Amazon DynamoDB",
		"signatureVersion": "v4",
		"targetPrefix": "DynamoDB_20111205",
		"uid": "dynamodb-2011-12-05"
	},
	"operations": {
		"BatchGetItem": {
			"input": {
				"type": "structure",
				"required": [
					"RequestItems"
				],
				"members": {
					"RequestItems": {
						"shape": "S2"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Responses": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"Items": {
									"shape": "Sk"
								},
								"ConsumedCapacityUnits": {
									"type": "double"
								}
							}
						}
					},
					"UnprocessedKeys": {
						"shape": "S2"
					}
				}
			}
		},
		"BatchWriteItem": {
			"input": {
				"type": "structure",
				"required": [
					"RequestItems"
				],
				"members": {
					"RequestItems": {
						"shape": "So"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Responses": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"ConsumedCapacityUnits": {
									"type": "double"
								}
							}
						}
					},
					"UnprocessedItems": {
						"shape": "So"
					}
				}
			}
		},
		"CreateTable": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"KeySchema",
					"ProvisionedThroughput"
				],
				"members": {
					"TableName": {},
					"KeySchema": {
						"shape": "Sy"
					},
					"ProvisionedThroughput": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableDescription": {
						"shape": "S15"
					}
				}
			}
		},
		"DeleteItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Key"
				],
				"members": {
					"TableName": {},
					"Key": {
						"shape": "S6"
					},
					"Expected": {
						"shape": "S1b"
					},
					"ReturnValues": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Sl"
					},
					"ConsumedCapacityUnits": {
						"type": "double"
					}
				}
			}
		},
		"DeleteTable": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableDescription": {
						"shape": "S15"
					}
				}
			}
		},
		"DescribeTable": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Table": {
						"shape": "S15"
					}
				}
			}
		},
		"GetItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Key"
				],
				"members": {
					"TableName": {},
					"Key": {
						"shape": "S6"
					},
					"AttributesToGet": {
						"shape": "Se"
					},
					"ConsistentRead": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Item": {
						"shape": "Sl"
					},
					"ConsumedCapacityUnits": {
						"type": "double"
					}
				}
			}
		},
		"ListTables": {
			"input": {
				"type": "structure",
				"members": {
					"ExclusiveStartTableName": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableNames": {
						"type": "list",
						"member": {}
					},
					"LastEvaluatedTableName": {}
				}
			}
		},
		"PutItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Item"
				],
				"members": {
					"TableName": {},
					"Item": {
						"shape": "Ss"
					},
					"Expected": {
						"shape": "S1b"
					},
					"ReturnValues": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Sl"
					},
					"ConsumedCapacityUnits": {
						"type": "double"
					}
				}
			}
		},
		"Query": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"HashKeyValue"
				],
				"members": {
					"TableName": {},
					"AttributesToGet": {
						"shape": "Se"
					},
					"Limit": {
						"type": "integer"
					},
					"ConsistentRead": {
						"type": "boolean"
					},
					"Count": {
						"type": "boolean"
					},
					"HashKeyValue": {
						"shape": "S7"
					},
					"RangeKeyCondition": {
						"shape": "S1u"
					},
					"ScanIndexForward": {
						"type": "boolean"
					},
					"ExclusiveStartKey": {
						"shape": "S6"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Items": {
						"shape": "Sk"
					},
					"Count": {
						"type": "integer"
					},
					"LastEvaluatedKey": {
						"shape": "S6"
					},
					"ConsumedCapacityUnits": {
						"type": "double"
					}
				}
			}
		},
		"Scan": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {},
					"AttributesToGet": {
						"shape": "Se"
					},
					"Limit": {
						"type": "integer"
					},
					"Count": {
						"type": "boolean"
					},
					"ScanFilter": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S1u"
						}
					},
					"ExclusiveStartKey": {
						"shape": "S6"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Items": {
						"shape": "Sk"
					},
					"Count": {
						"type": "integer"
					},
					"ScannedCount": {
						"type": "integer"
					},
					"LastEvaluatedKey": {
						"shape": "S6"
					},
					"ConsumedCapacityUnits": {
						"type": "double"
					}
				}
			}
		},
		"UpdateItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Key",
					"AttributeUpdates"
				],
				"members": {
					"TableName": {},
					"Key": {
						"shape": "S6"
					},
					"AttributeUpdates": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"Value": {
									"shape": "S7"
								},
								"Action": {}
							}
						}
					},
					"Expected": {
						"shape": "S1b"
					},
					"ReturnValues": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Sl"
					},
					"ConsumedCapacityUnits": {
						"type": "double"
					}
				}
			}
		},
		"UpdateTable": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"ProvisionedThroughput"
				],
				"members": {
					"TableName": {},
					"ProvisionedThroughput": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableDescription": {
						"shape": "S15"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"required": [
					"Keys"
				],
				"members": {
					"Keys": {
						"type": "list",
						"member": {
							"shape": "S6"
						}
					},
					"AttributesToGet": {
						"shape": "Se"
					},
					"ConsistentRead": {
						"type": "boolean"
					}
				}
			}
		},
		"S6": {
			"type": "structure",
			"required": [
				"HashKeyElement"
			],
			"members": {
				"HashKeyElement": {
					"shape": "S7"
				},
				"RangeKeyElement": {
					"shape": "S7"
				}
			}
		},
		"S7": {
			"type": "structure",
			"members": {
				"S": {},
				"N": {},
				"B": {
					"type": "blob"
				},
				"SS": {
					"type": "list",
					"member": {}
				},
				"NS": {
					"type": "list",
					"member": {}
				},
				"BS": {
					"type": "list",
					"member": {
						"type": "blob"
					}
				}
			}
		},
		"Se": {
			"type": "list",
			"member": {}
		},
		"Sk": {
			"type": "list",
			"member": {
				"shape": "Sl"
			}
		},
		"Sl": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S7"
			}
		},
		"So": {
			"type": "map",
			"key": {},
			"value": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"PutRequest": {
							"type": "structure",
							"required": [
								"Item"
							],
							"members": {
								"Item": {
									"shape": "Ss"
								}
							}
						},
						"DeleteRequest": {
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {
									"shape": "S6"
								}
							}
						}
					}
				}
			}
		},
		"Ss": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S7"
			}
		},
		"Sy": {
			"type": "structure",
			"required": [
				"HashKeyElement"
			],
			"members": {
				"HashKeyElement": {
					"shape": "Sz"
				},
				"RangeKeyElement": {
					"shape": "Sz"
				}
			}
		},
		"Sz": {
			"type": "structure",
			"required": [
				"AttributeName",
				"AttributeType"
			],
			"members": {
				"AttributeName": {},
				"AttributeType": {}
			}
		},
		"S12": {
			"type": "structure",
			"required": [
				"ReadCapacityUnits",
				"WriteCapacityUnits"
			],
			"members": {
				"ReadCapacityUnits": {
					"type": "long"
				},
				"WriteCapacityUnits": {
					"type": "long"
				}
			}
		},
		"S15": {
			"type": "structure",
			"members": {
				"TableName": {},
				"KeySchema": {
					"shape": "Sy"
				},
				"TableStatus": {},
				"CreationDateTime": {
					"type": "timestamp"
				},
				"ProvisionedThroughput": {
					"type": "structure",
					"members": {
						"LastIncreaseDateTime": {
							"type": "timestamp"
						},
						"LastDecreaseDateTime": {
							"type": "timestamp"
						},
						"NumberOfDecreasesToday": {
							"type": "long"
						},
						"ReadCapacityUnits": {
							"type": "long"
						},
						"WriteCapacityUnits": {
							"type": "long"
						}
					}
				},
				"TableSizeBytes": {
					"type": "long"
				},
				"ItemCount": {
					"type": "long"
				}
			}
		},
		"S1b": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"members": {
					"Value": {
						"shape": "S7"
					},
					"Exists": {
						"type": "boolean"
					}
				}
			}
		},
		"S1u": {
			"type": "structure",
			"required": [
				"ComparisonOperator"
			],
			"members": {
				"AttributeValueList": {
					"type": "list",
					"member": {
						"shape": "S7"
					}
				},
				"ComparisonOperator": {}
			}
		}
	}
};

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"BatchGetItem": {
			"input_token": "RequestItems",
			"output_token": "UnprocessedKeys"
		},
		"ListTables": {
			"input_token": "ExclusiveStartTableName",
			"limit_key": "Limit",
			"output_token": "LastEvaluatedTableName",
			"result_key": "TableNames"
		},
		"Query": {
			"input_token": "ExclusiveStartKey",
			"limit_key": "Limit",
			"output_token": "LastEvaluatedKey",
			"result_key": "Items"
		},
		"Scan": {
			"input_token": "ExclusiveStartKey",
			"limit_key": "Limit",
			"output_token": "LastEvaluatedKey",
			"result_key": "Items"
		}
	}
};

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"TableExists": {
			"delay": 20,
			"operation": "DescribeTable",
			"maxAttempts": 25,
			"acceptors": [
				{
					"expected": "ACTIVE",
					"matcher": "path",
					"state": "success",
					"argument": "Table.TableStatus"
				},
				{
					"expected": "ResourceNotFoundException",
					"matcher": "error",
					"state": "retry"
				}
			]
		},
		"TableNotExists": {
			"delay": 20,
			"operation": "DescribeTable",
			"maxAttempts": 25,
			"acceptors": [
				{
					"expected": "ResourceNotFoundException",
					"matcher": "error",
					"state": "success"
				}
			]
		}
	}
};

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2012-08-10",
		"endpointPrefix": "dynamodb",
		"jsonVersion": "1.0",
		"protocol": "json",
		"serviceAbbreviation": "DynamoDB",
		"serviceFullName": "Amazon DynamoDB",
		"signatureVersion": "v4",
		"targetPrefix": "DynamoDB_20120810",
		"uid": "dynamodb-2012-08-10"
	},
	"operations": {
		"BatchGetItem": {
			"input": {
				"type": "structure",
				"required": [
					"RequestItems"
				],
				"members": {
					"RequestItems": {
						"shape": "S2"
					},
					"ReturnConsumedCapacity": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Responses": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "Sr"
						}
					},
					"UnprocessedKeys": {
						"shape": "S2"
					},
					"ConsumedCapacity": {
						"shape": "St"
					}
				}
			}
		},
		"BatchWriteItem": {
			"input": {
				"type": "structure",
				"required": [
					"RequestItems"
				],
				"members": {
					"RequestItems": {
						"shape": "S10"
					},
					"ReturnConsumedCapacity": {},
					"ReturnItemCollectionMetrics": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UnprocessedItems": {
						"shape": "S10"
					},
					"ItemCollectionMetrics": {
						"type": "map",
						"key": {},
						"value": {
							"type": "list",
							"member": {
								"shape": "S1a"
							}
						}
					},
					"ConsumedCapacity": {
						"shape": "St"
					}
				}
			}
		},
		"CreateTable": {
			"input": {
				"type": "structure",
				"required": [
					"AttributeDefinitions",
					"TableName",
					"KeySchema",
					"ProvisionedThroughput"
				],
				"members": {
					"AttributeDefinitions": {
						"shape": "S1f"
					},
					"TableName": {},
					"KeySchema": {
						"shape": "S1j"
					},
					"LocalSecondaryIndexes": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"IndexName",
								"KeySchema",
								"Projection"
							],
							"members": {
								"IndexName": {},
								"KeySchema": {
									"shape": "S1j"
								},
								"Projection": {
									"shape": "S1o"
								}
							}
						}
					},
					"GlobalSecondaryIndexes": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"IndexName",
								"KeySchema",
								"Projection",
								"ProvisionedThroughput"
							],
							"members": {
								"IndexName": {},
								"KeySchema": {
									"shape": "S1j"
								},
								"Projection": {
									"shape": "S1o"
								},
								"ProvisionedThroughput": {
									"shape": "S1u"
								}
							}
						}
					},
					"ProvisionedThroughput": {
						"shape": "S1u"
					},
					"StreamSpecification": {
						"shape": "S1w"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableDescription": {
						"shape": "S20"
					}
				}
			}
		},
		"DeleteItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Key"
				],
				"members": {
					"TableName": {},
					"Key": {
						"shape": "S6"
					},
					"Expected": {
						"shape": "S2e"
					},
					"ConditionalOperator": {},
					"ReturnValues": {},
					"ReturnConsumedCapacity": {},
					"ReturnItemCollectionMetrics": {},
					"ConditionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					},
					"ExpressionAttributeValues": {
						"shape": "S2m"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Ss"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					},
					"ItemCollectionMetrics": {
						"shape": "S1a"
					}
				}
			}
		},
		"DeleteTable": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableDescription": {
						"shape": "S20"
					}
				}
			}
		},
		"DescribeLimits": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"AccountMaxReadCapacityUnits": {
						"type": "long"
					},
					"AccountMaxWriteCapacityUnits": {
						"type": "long"
					},
					"TableMaxReadCapacityUnits": {
						"type": "long"
					},
					"TableMaxWriteCapacityUnits": {
						"type": "long"
					}
				}
			}
		},
		"DescribeTable": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Table": {
						"shape": "S20"
					}
				}
			}
		},
		"DescribeTimeToLive": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TimeToLiveDescription": {
						"type": "structure",
						"members": {
							"TimeToLiveStatus": {},
							"AttributeName": {}
						}
					}
				}
			}
		},
		"GetItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Key"
				],
				"members": {
					"TableName": {},
					"Key": {
						"shape": "S6"
					},
					"AttributesToGet": {
						"shape": "Sj"
					},
					"ConsistentRead": {
						"type": "boolean"
					},
					"ReturnConsumedCapacity": {},
					"ProjectionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Item": {
						"shape": "Ss"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					}
				}
			}
		},
		"ListTables": {
			"input": {
				"type": "structure",
				"members": {
					"ExclusiveStartTableName": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableNames": {
						"type": "list",
						"member": {}
					},
					"LastEvaluatedTableName": {}
				}
			}
		},
		"ListTagsOfResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn"
				],
				"members": {
					"ResourceArn": {},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Tags": {
						"shape": "S3a"
					},
					"NextToken": {}
				}
			}
		},
		"PutItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Item"
				],
				"members": {
					"TableName": {},
					"Item": {
						"shape": "S14"
					},
					"Expected": {
						"shape": "S2e"
					},
					"ReturnValues": {},
					"ReturnConsumedCapacity": {},
					"ReturnItemCollectionMetrics": {},
					"ConditionalOperator": {},
					"ConditionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					},
					"ExpressionAttributeValues": {
						"shape": "S2m"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Ss"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					},
					"ItemCollectionMetrics": {
						"shape": "S1a"
					}
				}
			}
		},
		"Query": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {},
					"IndexName": {},
					"Select": {},
					"AttributesToGet": {
						"shape": "Sj"
					},
					"Limit": {
						"type": "integer"
					},
					"ConsistentRead": {
						"type": "boolean"
					},
					"KeyConditions": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S3k"
						}
					},
					"QueryFilter": {
						"shape": "S3l"
					},
					"ConditionalOperator": {},
					"ScanIndexForward": {
						"type": "boolean"
					},
					"ExclusiveStartKey": {
						"shape": "S6"
					},
					"ReturnConsumedCapacity": {},
					"ProjectionExpression": {},
					"FilterExpression": {},
					"KeyConditionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					},
					"ExpressionAttributeValues": {
						"shape": "S2m"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Items": {
						"shape": "Sr"
					},
					"Count": {
						"type": "integer"
					},
					"ScannedCount": {
						"type": "integer"
					},
					"LastEvaluatedKey": {
						"shape": "S6"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					}
				}
			}
		},
		"Scan": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"TableName": {},
					"IndexName": {},
					"AttributesToGet": {
						"shape": "Sj"
					},
					"Limit": {
						"type": "integer"
					},
					"Select": {},
					"ScanFilter": {
						"shape": "S3l"
					},
					"ConditionalOperator": {},
					"ExclusiveStartKey": {
						"shape": "S6"
					},
					"ReturnConsumedCapacity": {},
					"TotalSegments": {
						"type": "integer"
					},
					"Segment": {
						"type": "integer"
					},
					"ProjectionExpression": {},
					"FilterExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					},
					"ExpressionAttributeValues": {
						"shape": "S2m"
					},
					"ConsistentRead": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Items": {
						"shape": "Sr"
					},
					"Count": {
						"type": "integer"
					},
					"ScannedCount": {
						"type": "integer"
					},
					"LastEvaluatedKey": {
						"shape": "S6"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					}
				}
			}
		},
		"TagResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn",
					"Tags"
				],
				"members": {
					"ResourceArn": {},
					"Tags": {
						"shape": "S3a"
					}
				}
			}
		},
		"UntagResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn",
					"TagKeys"
				],
				"members": {
					"ResourceArn": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"UpdateItem": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"Key"
				],
				"members": {
					"TableName": {},
					"Key": {
						"shape": "S6"
					},
					"AttributeUpdates": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"Value": {
									"shape": "S8"
								},
								"Action": {}
							}
						}
					},
					"Expected": {
						"shape": "S2e"
					},
					"ConditionalOperator": {},
					"ReturnValues": {},
					"ReturnConsumedCapacity": {},
					"ReturnItemCollectionMetrics": {},
					"UpdateExpression": {},
					"ConditionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					},
					"ExpressionAttributeValues": {
						"shape": "S2m"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Ss"
					},
					"ConsumedCapacity": {
						"shape": "Su"
					},
					"ItemCollectionMetrics": {
						"shape": "S1a"
					}
				}
			}
		},
		"UpdateTable": {
			"input": {
				"type": "structure",
				"required": [
					"TableName"
				],
				"members": {
					"AttributeDefinitions": {
						"shape": "S1f"
					},
					"TableName": {},
					"ProvisionedThroughput": {
						"shape": "S1u"
					},
					"GlobalSecondaryIndexUpdates": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Update": {
									"type": "structure",
									"required": [
										"IndexName",
										"ProvisionedThroughput"
									],
									"members": {
										"IndexName": {},
										"ProvisionedThroughput": {
											"shape": "S1u"
										}
									}
								},
								"Create": {
									"type": "structure",
									"required": [
										"IndexName",
										"KeySchema",
										"Projection",
										"ProvisionedThroughput"
									],
									"members": {
										"IndexName": {},
										"KeySchema": {
											"shape": "S1j"
										},
										"Projection": {
											"shape": "S1o"
										},
										"ProvisionedThroughput": {
											"shape": "S1u"
										}
									}
								},
								"Delete": {
									"type": "structure",
									"required": [
										"IndexName"
									],
									"members": {
										"IndexName": {}
									}
								}
							}
						}
					},
					"StreamSpecification": {
						"shape": "S1w"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TableDescription": {
						"shape": "S20"
					}
				}
			}
		},
		"UpdateTimeToLive": {
			"input": {
				"type": "structure",
				"required": [
					"TableName",
					"TimeToLiveSpecification"
				],
				"members": {
					"TableName": {},
					"TimeToLiveSpecification": {
						"shape": "S4a"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TimeToLiveSpecification": {
						"shape": "S4a"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"required": [
					"Keys"
				],
				"members": {
					"Keys": {
						"type": "list",
						"member": {
							"shape": "S6"
						}
					},
					"AttributesToGet": {
						"shape": "Sj"
					},
					"ConsistentRead": {
						"type": "boolean"
					},
					"ProjectionExpression": {},
					"ExpressionAttributeNames": {
						"shape": "Sm"
					}
				}
			}
		},
		"S6": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S8"
			}
		},
		"S8": {
			"type": "structure",
			"members": {
				"S": {},
				"N": {},
				"B": {
					"type": "blob"
				},
				"SS": {
					"type": "list",
					"member": {}
				},
				"NS": {
					"type": "list",
					"member": {}
				},
				"BS": {
					"type": "list",
					"member": {
						"type": "blob"
					}
				},
				"M": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S8"
					}
				},
				"L": {
					"type": "list",
					"member": {
						"shape": "S8"
					}
				},
				"NULL": {
					"type": "boolean"
				},
				"BOOL": {
					"type": "boolean"
				}
			}
		},
		"Sj": {
			"type": "list",
			"member": {}
		},
		"Sm": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"Sr": {
			"type": "list",
			"member": {
				"shape": "Ss"
			}
		},
		"Ss": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S8"
			}
		},
		"St": {
			"type": "list",
			"member": {
				"shape": "Su"
			}
		},
		"Su": {
			"type": "structure",
			"members": {
				"TableName": {},
				"CapacityUnits": {
					"type": "double"
				},
				"Table": {
					"shape": "Sw"
				},
				"LocalSecondaryIndexes": {
					"shape": "Sx"
				},
				"GlobalSecondaryIndexes": {
					"shape": "Sx"
				}
			}
		},
		"Sw": {
			"type": "structure",
			"members": {
				"CapacityUnits": {
					"type": "double"
				}
			}
		},
		"Sx": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "Sw"
			}
		},
		"S10": {
			"type": "map",
			"key": {},
			"value": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"PutRequest": {
							"type": "structure",
							"required": [
								"Item"
							],
							"members": {
								"Item": {
									"shape": "S14"
								}
							}
						},
						"DeleteRequest": {
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {
									"shape": "S6"
								}
							}
						}
					}
				}
			}
		},
		"S14": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S8"
			}
		},
		"S1a": {
			"type": "structure",
			"members": {
				"ItemCollectionKey": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S8"
					}
				},
				"SizeEstimateRangeGB": {
					"type": "list",
					"member": {
						"type": "double"
					}
				}
			}
		},
		"S1f": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"AttributeName",
					"AttributeType"
				],
				"members": {
					"AttributeName": {},
					"AttributeType": {}
				}
			}
		},
		"S1j": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"AttributeName",
					"KeyType"
				],
				"members": {
					"AttributeName": {},
					"KeyType": {}
				}
			}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"ProjectionType": {},
				"NonKeyAttributes": {
					"type": "list",
					"member": {}
				}
			}
		},
		"S1u": {
			"type": "structure",
			"required": [
				"ReadCapacityUnits",
				"WriteCapacityUnits"
			],
			"members": {
				"ReadCapacityUnits": {
					"type": "long"
				},
				"WriteCapacityUnits": {
					"type": "long"
				}
			}
		},
		"S1w": {
			"type": "structure",
			"members": {
				"StreamEnabled": {
					"type": "boolean"
				},
				"StreamViewType": {}
			}
		},
		"S20": {
			"type": "structure",
			"members": {
				"AttributeDefinitions": {
					"shape": "S1f"
				},
				"TableName": {},
				"KeySchema": {
					"shape": "S1j"
				},
				"TableStatus": {},
				"CreationDateTime": {
					"type": "timestamp"
				},
				"ProvisionedThroughput": {
					"shape": "S23"
				},
				"TableSizeBytes": {
					"type": "long"
				},
				"ItemCount": {
					"type": "long"
				},
				"TableArn": {},
				"LocalSecondaryIndexes": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"IndexName": {},
							"KeySchema": {
								"shape": "S1j"
							},
							"Projection": {
								"shape": "S1o"
							},
							"IndexSizeBytes": {
								"type": "long"
							},
							"ItemCount": {
								"type": "long"
							},
							"IndexArn": {}
						}
					}
				},
				"GlobalSecondaryIndexes": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"IndexName": {},
							"KeySchema": {
								"shape": "S1j"
							},
							"Projection": {
								"shape": "S1o"
							},
							"IndexStatus": {},
							"Backfilling": {
								"type": "boolean"
							},
							"ProvisionedThroughput": {
								"shape": "S23"
							},
							"IndexSizeBytes": {
								"type": "long"
							},
							"ItemCount": {
								"type": "long"
							},
							"IndexArn": {}
						}
					}
				},
				"StreamSpecification": {
					"shape": "S1w"
				},
				"LatestStreamLabel": {},
				"LatestStreamArn": {}
			}
		},
		"S23": {
			"type": "structure",
			"members": {
				"LastIncreaseDateTime": {
					"type": "timestamp"
				},
				"LastDecreaseDateTime": {
					"type": "timestamp"
				},
				"NumberOfDecreasesToday": {
					"type": "long"
				},
				"ReadCapacityUnits": {
					"type": "long"
				},
				"WriteCapacityUnits": {
					"type": "long"
				}
			}
		},
		"S2e": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"members": {
					"Value": {
						"shape": "S8"
					},
					"Exists": {
						"type": "boolean"
					},
					"ComparisonOperator": {},
					"AttributeValueList": {
						"shape": "S2i"
					}
				}
			}
		},
		"S2i": {
			"type": "list",
			"member": {
				"shape": "S8"
			}
		},
		"S2m": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S8"
			}
		},
		"S3a": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S3k": {
			"type": "structure",
			"required": [
				"ComparisonOperator"
			],
			"members": {
				"AttributeValueList": {
					"shape": "S2i"
				},
				"ComparisonOperator": {}
			}
		},
		"S3l": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "S3k"
			}
		},
		"S4a": {
			"type": "structure",
			"required": [
				"Enabled",
				"AttributeName"
			],
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"AttributeName": {}
			}
		}
	}
};

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"BatchGetItem": {
			"input_token": "RequestItems",
			"output_token": "UnprocessedKeys"
		},
		"ListTables": {
			"input_token": "ExclusiveStartTableName",
			"limit_key": "Limit",
			"output_token": "LastEvaluatedTableName",
			"result_key": "TableNames"
		},
		"Query": {
			"input_token": "ExclusiveStartKey",
			"limit_key": "Limit",
			"output_token": "LastEvaluatedKey",
			"result_key": "Items"
		},
		"Scan": {
			"input_token": "ExclusiveStartKey",
			"limit_key": "Limit",
			"output_token": "LastEvaluatedKey",
			"result_key": "Items"
		}
	}
};

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"TableExists": {
			"delay": 20,
			"operation": "DescribeTable",
			"maxAttempts": 25,
			"acceptors": [
				{
					"expected": "ACTIVE",
					"matcher": "path",
					"state": "success",
					"argument": "Table.TableStatus"
				},
				{
					"expected": "ResourceNotFoundException",
					"matcher": "error",
					"state": "retry"
				}
			]
		},
		"TableNotExists": {
			"delay": 20,
			"operation": "DescribeTable",
			"maxAttempts": 25,
			"acceptors": [
				{
					"expected": "ResourceNotFoundException",
					"matcher": "error",
					"state": "success"
				}
			]
		}
	}
};

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['dynamodbstreams'] = {};
AWS.DynamoDBStreams = Service.defineService('dynamodbstreams', ['2012-08-10']);
Object.defineProperty(apiLoader.services['dynamodbstreams'], '2012-08-10', {
  get: function get() {
    var model = __webpack_require__(1585);
    model.paginators = __webpack_require__(1586).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.DynamoDBStreams;


/***/ }),
/* 1585 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2012-08-10",
		"endpointPrefix": "streams.dynamodb",
		"jsonVersion": "1.0",
		"protocol": "json",
		"serviceFullName": "Amazon DynamoDB Streams",
		"signatureVersion": "v4",
		"signingName": "dynamodb",
		"targetPrefix": "DynamoDBStreams_20120810",
		"uid": "streams-dynamodb-2012-08-10"
	},
	"operations": {
		"DescribeStream": {
			"input": {
				"type": "structure",
				"required": [
					"StreamArn"
				],
				"members": {
					"StreamArn": {},
					"Limit": {
						"type": "integer"
					},
					"ExclusiveStartShardId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamDescription": {
						"type": "structure",
						"members": {
							"StreamArn": {},
							"StreamLabel": {},
							"StreamStatus": {},
							"StreamViewType": {},
							"CreationRequestDateTime": {
								"type": "timestamp"
							},
							"TableName": {},
							"KeySchema": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"AttributeName",
										"KeyType"
									],
									"members": {
										"AttributeName": {},
										"KeyType": {}
									}
								}
							},
							"Shards": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"ShardId": {},
										"SequenceNumberRange": {
											"type": "structure",
											"members": {
												"StartingSequenceNumber": {},
												"EndingSequenceNumber": {}
											}
										},
										"ParentShardId": {}
									}
								}
							},
							"LastEvaluatedShardId": {}
						}
					}
				}
			}
		},
		"GetRecords": {
			"input": {
				"type": "structure",
				"required": [
					"ShardIterator"
				],
				"members": {
					"ShardIterator": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Records": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"eventID": {},
								"eventName": {},
								"eventVersion": {},
								"eventSource": {},
								"awsRegion": {},
								"dynamodb": {
									"type": "structure",
									"members": {
										"ApproximateCreationDateTime": {
											"type": "timestamp"
										},
										"Keys": {
											"shape": "Sr"
										},
										"NewImage": {
											"shape": "Sr"
										},
										"OldImage": {
											"shape": "Sr"
										},
										"SequenceNumber": {},
										"SizeBytes": {
											"type": "long"
										},
										"StreamViewType": {}
									}
								},
								"userIdentity": {
									"type": "structure",
									"members": {
										"PrincipalId": {},
										"Type": {}
									}
								}
							}
						}
					},
					"NextShardIterator": {}
				}
			}
		},
		"GetShardIterator": {
			"input": {
				"type": "structure",
				"required": [
					"StreamArn",
					"ShardId",
					"ShardIteratorType"
				],
				"members": {
					"StreamArn": {},
					"ShardId": {},
					"ShardIteratorType": {},
					"SequenceNumber": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ShardIterator": {}
				}
			}
		},
		"ListStreams": {
			"input": {
				"type": "structure",
				"members": {
					"TableName": {},
					"Limit": {
						"type": "integer"
					},
					"ExclusiveStartStreamArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Streams": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"StreamArn": {},
								"TableName": {},
								"StreamLabel": {}
							}
						}
					},
					"LastEvaluatedStreamArn": {}
				}
			}
		}
	},
	"shapes": {
		"Sr": {
			"type": "map",
			"key": {},
			"value": {
				"shape": "St"
			}
		},
		"St": {
			"type": "structure",
			"members": {
				"S": {},
				"N": {},
				"B": {
					"type": "blob"
				},
				"SS": {
					"type": "list",
					"member": {}
				},
				"NS": {
					"type": "list",
					"member": {}
				},
				"BS": {
					"type": "list",
					"member": {
						"type": "blob"
					}
				},
				"M": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "St"
					}
				},
				"L": {
					"type": "list",
					"member": {
						"shape": "St"
					}
				},
				"NULL": {
					"type": "boolean"
				},
				"BOOL": {
					"type": "boolean"
				}
			}
		}
	}
};

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ec2'] = {};
AWS.EC2 = Service.defineService('ec2', ['2013-06-15*', '2013-10-15*', '2014-02-01*', '2014-05-01*', '2014-06-15*', '2014-09-01*', '2014-10-01*', '2015-03-01*', '2015-04-15*', '2015-10-01*', '2016-04-01*', '2016-09-15*', '2016-11-15']);
__webpack_require__(1588);
Object.defineProperty(apiLoader.services['ec2'], '2016-11-15', {
  get: function get() {
    var model = __webpack_require__(1589);
    model.paginators = __webpack_require__(1590).pagination;
    model.waiters = __webpack_require__(1591).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.EC2;


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

AWS.util.update(AWS.EC2.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.removeListener('extractError', AWS.EventListeners.Query.EXTRACT_ERROR);
    request.addListener('extractError', this.extractError);

    if (request.operation === 'copySnapshot') {
      request.onAsync('validate', this.buildCopySnapshotPresignedUrl);
    }
  },

  /**
   * @api private
   */
  buildCopySnapshotPresignedUrl: function buildCopySnapshotPresignedUrl(req, done) {
    if (req.params.PresignedUrl || req._subRequest) {
      return done();
    }

    req.params = AWS.util.copy(req.params);
    req.params.DestinationRegion = req.service.config.region;

    var config = AWS.util.copy(req.service.config);
    delete config.endpoint;
    config.region = req.params.SourceRegion;
    var svc = new req.service.constructor(config);
    var newReq = svc[req.operation](req.params);
    newReq._subRequest = true;
    newReq.presign(function(err, url) {
      if (err) done(err);
      else {
        req.params.PresignedUrl = url;
        done();
      }
    });
  },

  /**
   * @api private
   */
  extractError: function extractError(resp) {
    // EC2 nests the error code and message deeper than other AWS Query services.
    var httpResponse = resp.httpResponse;
    var data = new AWS.XML.Parser().parse(httpResponse.body.toString() || '');
    if (data.Errors) {
      resp.error = AWS.util.error(new Error(), {
        code: data.Errors.Error.Code,
        message: data.Errors.Error.Message
      });
    } else {
      resp.error = AWS.util.error(new Error(), {
        code: httpResponse.statusCode,
        message: null
      });
    }
    resp.error.requestId = data.RequestID || null;
  }
});


/***/ }),
/* 1589 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-11-15",
		"endpointPrefix": "ec2",
		"protocol": "ec2",
		"serviceAbbreviation": "Amazon EC2",
		"serviceFullName": "Amazon Elastic Compute Cloud",
		"signatureVersion": "v4",
		"uid": "ec2-2016-11-15",
		"xmlNamespace": "http://ec2.amazonaws.com/doc/2016-11-15"
	},
	"operations": {
		"AcceptReservedInstancesExchangeQuote": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedInstanceIds"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"ReservedInstanceIds": {
						"shape": "S3",
						"locationName": "ReservedInstanceId"
					},
					"TargetConfigurations": {
						"shape": "S5",
						"locationName": "TargetConfiguration"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ExchangeId": {
						"locationName": "exchangeId"
					}
				}
			}
		},
		"AcceptVpcPeeringConnection": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpcPeeringConnection": {
						"shape": "Sb",
						"locationName": "vpcPeeringConnection"
					}
				}
			}
		},
		"AllocateAddress": {
			"input": {
				"type": "structure",
				"members": {
					"Domain": {},
					"Address": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PublicIp": {
						"locationName": "publicIp"
					},
					"AllocationId": {
						"locationName": "allocationId"
					},
					"Domain": {
						"locationName": "domain"
					}
				}
			}
		},
		"AllocateHosts": {
			"input": {
				"type": "structure",
				"required": [
					"AvailabilityZone",
					"InstanceType",
					"Quantity"
				],
				"members": {
					"AutoPlacement": {
						"locationName": "autoPlacement"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"ClientToken": {
						"locationName": "clientToken"
					},
					"InstanceType": {
						"locationName": "instanceType"
					},
					"Quantity": {
						"locationName": "quantity",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HostIds": {
						"shape": "Sr",
						"locationName": "hostIdSet"
					}
				}
			}
		},
		"AssignIpv6Addresses": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"Ipv6AddressCount": {
						"locationName": "ipv6AddressCount",
						"type": "integer"
					},
					"Ipv6Addresses": {
						"shape": "St",
						"locationName": "ipv6Addresses"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AssignedIpv6Addresses": {
						"shape": "St",
						"locationName": "assignedIpv6Addresses"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			}
		},
		"AssignPrivateIpAddresses": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"AllowReassignment": {
						"locationName": "allowReassignment",
						"type": "boolean"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"PrivateIpAddresses": {
						"shape": "Sw",
						"locationName": "privateIpAddress"
					},
					"SecondaryPrivateIpAddressCount": {
						"locationName": "secondaryPrivateIpAddressCount",
						"type": "integer"
					}
				}
			}
		},
		"AssociateAddress": {
			"input": {
				"type": "structure",
				"members": {
					"AllocationId": {},
					"InstanceId": {},
					"PublicIp": {},
					"AllowReassociation": {
						"locationName": "allowReassociation",
						"type": "boolean"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			}
		},
		"AssociateDhcpOptions": {
			"input": {
				"type": "structure",
				"required": [
					"DhcpOptionsId",
					"VpcId"
				],
				"members": {
					"DhcpOptionsId": {},
					"VpcId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"AssociateIamInstanceProfile": {
			"input": {
				"type": "structure",
				"required": [
					"IamInstanceProfile",
					"InstanceId"
				],
				"members": {
					"IamInstanceProfile": {
						"shape": "S11"
					},
					"InstanceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IamInstanceProfileAssociation": {
						"shape": "S13",
						"locationName": "iamInstanceProfileAssociation"
					}
				}
			}
		},
		"AssociateRouteTable": {
			"input": {
				"type": "structure",
				"required": [
					"RouteTableId",
					"SubnetId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			}
		},
		"AssociateSubnetCidrBlock": {
			"input": {
				"type": "structure",
				"required": [
					"Ipv6CidrBlock",
					"SubnetId"
				],
				"members": {
					"Ipv6CidrBlock": {
						"locationName": "ipv6CidrBlock"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Ipv6CidrBlockAssociation": {
						"shape": "S1a",
						"locationName": "ipv6CidrBlockAssociation"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			}
		},
		"AssociateVpcCidrBlock": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"AmazonProvidedIpv6CidrBlock": {
						"locationName": "amazonProvidedIpv6CidrBlock",
						"type": "boolean"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Ipv6CidrBlockAssociation": {
						"shape": "S1f",
						"locationName": "ipv6CidrBlockAssociation"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"AttachClassicLinkVpc": {
			"input": {
				"type": "structure",
				"required": [
					"Groups",
					"InstanceId",
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Groups": {
						"shape": "S1j",
						"locationName": "SecurityGroupId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"AttachInternetGateway": {
			"input": {
				"type": "structure",
				"required": [
					"InternetGatewayId",
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InternetGatewayId": {
						"locationName": "internetGatewayId"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"AttachNetworkInterface": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceIndex",
					"InstanceId",
					"NetworkInterfaceId"
				],
				"members": {
					"DeviceIndex": {
						"locationName": "deviceIndex",
						"type": "integer"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AttachmentId": {
						"locationName": "attachmentId"
					}
				}
			}
		},
		"AttachVolume": {
			"input": {
				"type": "structure",
				"required": [
					"Device",
					"InstanceId",
					"VolumeId"
				],
				"members": {
					"Device": {},
					"InstanceId": {},
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S1p"
			}
		},
		"AttachVpnGateway": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId",
					"VpnGatewayId"
				],
				"members": {
					"VpcId": {},
					"VpnGatewayId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpcAttachment": {
						"shape": "S1t",
						"locationName": "attachment"
					}
				}
			}
		},
		"AuthorizeSecurityGroupEgress": {
			"input": {
				"type": "structure",
				"required": [
					"GroupId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"GroupId": {
						"locationName": "groupId"
					},
					"IpPermissions": {
						"shape": "S1w",
						"locationName": "ipPermissions"
					},
					"CidrIp": {
						"locationName": "cidrIp"
					},
					"FromPort": {
						"locationName": "fromPort",
						"type": "integer"
					},
					"IpProtocol": {
						"locationName": "ipProtocol"
					},
					"ToPort": {
						"locationName": "toPort",
						"type": "integer"
					},
					"SourceSecurityGroupName": {
						"locationName": "sourceSecurityGroupName"
					},
					"SourceSecurityGroupOwnerId": {
						"locationName": "sourceSecurityGroupOwnerId"
					}
				}
			}
		},
		"AuthorizeSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"members": {
					"CidrIp": {},
					"FromPort": {
						"type": "integer"
					},
					"GroupId": {},
					"GroupName": {},
					"IpPermissions": {
						"shape": "S1w"
					},
					"IpProtocol": {},
					"SourceSecurityGroupName": {},
					"SourceSecurityGroupOwnerId": {},
					"ToPort": {
						"type": "integer"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"BundleInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"Storage"
				],
				"members": {
					"InstanceId": {},
					"Storage": {
						"shape": "S28"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BundleTask": {
						"shape": "S2c",
						"locationName": "bundleInstanceTask"
					}
				}
			}
		},
		"CancelBundleTask": {
			"input": {
				"type": "structure",
				"required": [
					"BundleId"
				],
				"members": {
					"BundleId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BundleTask": {
						"shape": "S2c",
						"locationName": "bundleInstanceTask"
					}
				}
			}
		},
		"CancelConversionTask": {
			"input": {
				"type": "structure",
				"required": [
					"ConversionTaskId"
				],
				"members": {
					"ConversionTaskId": {
						"locationName": "conversionTaskId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"ReasonMessage": {
						"locationName": "reasonMessage"
					}
				}
			}
		},
		"CancelExportTask": {
			"input": {
				"type": "structure",
				"required": [
					"ExportTaskId"
				],
				"members": {
					"ExportTaskId": {
						"locationName": "exportTaskId"
					}
				}
			}
		},
		"CancelImportTask": {
			"input": {
				"type": "structure",
				"members": {
					"CancelReason": {},
					"DryRun": {
						"type": "boolean"
					},
					"ImportTaskId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImportTaskId": {
						"locationName": "importTaskId"
					},
					"PreviousState": {
						"locationName": "previousState"
					},
					"State": {
						"locationName": "state"
					}
				}
			}
		},
		"CancelReservedInstancesListing": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedInstancesListingId"
				],
				"members": {
					"ReservedInstancesListingId": {
						"locationName": "reservedInstancesListingId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesListings": {
						"shape": "S2n",
						"locationName": "reservedInstancesListingsSet"
					}
				}
			}
		},
		"CancelSpotFleetRequests": {
			"input": {
				"type": "structure",
				"required": [
					"SpotFleetRequestIds",
					"TerminateInstances"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"SpotFleetRequestIds": {
						"shape": "S2z",
						"locationName": "spotFleetRequestId"
					},
					"TerminateInstances": {
						"locationName": "terminateInstances",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SuccessfulFleetRequests": {
						"locationName": "successfulFleetRequestSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"CurrentSpotFleetRequestState",
								"PreviousSpotFleetRequestState",
								"SpotFleetRequestId"
							],
							"members": {
								"CurrentSpotFleetRequestState": {
									"locationName": "currentSpotFleetRequestState"
								},
								"PreviousSpotFleetRequestState": {
									"locationName": "previousSpotFleetRequestState"
								},
								"SpotFleetRequestId": {
									"locationName": "spotFleetRequestId"
								}
							}
						}
					},
					"UnsuccessfulFleetRequests": {
						"locationName": "unsuccessfulFleetRequestSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"Error",
								"SpotFleetRequestId"
							],
							"members": {
								"Error": {
									"locationName": "error",
									"type": "structure",
									"required": [
										"Code",
										"Message"
									],
									"members": {
										"Code": {
											"locationName": "code"
										},
										"Message": {
											"locationName": "message"
										}
									}
								},
								"SpotFleetRequestId": {
									"locationName": "spotFleetRequestId"
								}
							}
						}
					}
				}
			}
		},
		"CancelSpotInstanceRequests": {
			"input": {
				"type": "structure",
				"required": [
					"SpotInstanceRequestIds"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"SpotInstanceRequestIds": {
						"shape": "S39",
						"locationName": "SpotInstanceRequestId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CancelledSpotInstanceRequests": {
						"locationName": "spotInstanceRequestSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"SpotInstanceRequestId": {
									"locationName": "spotInstanceRequestId"
								},
								"State": {
									"locationName": "state"
								}
							}
						}
					}
				}
			}
		},
		"ConfirmProductInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"ProductCode"
				],
				"members": {
					"InstanceId": {},
					"ProductCode": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"OwnerId": {
						"locationName": "ownerId"
					},
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"CopyImage": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"SourceImageId",
					"SourceRegion"
				],
				"members": {
					"ClientToken": {},
					"Description": {},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"KmsKeyId": {
						"locationName": "kmsKeyId"
					},
					"Name": {},
					"SourceImageId": {},
					"SourceRegion": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImageId": {
						"locationName": "imageId"
					}
				}
			}
		},
		"CopySnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SourceRegion",
					"SourceSnapshotId"
				],
				"members": {
					"Description": {},
					"DestinationRegion": {
						"locationName": "destinationRegion"
					},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"KmsKeyId": {
						"locationName": "kmsKeyId"
					},
					"PresignedUrl": {
						"locationName": "presignedUrl"
					},
					"SourceRegion": {},
					"SourceSnapshotId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SnapshotId": {
						"locationName": "snapshotId"
					}
				}
			}
		},
		"CreateCustomerGateway": {
			"input": {
				"type": "structure",
				"required": [
					"BgpAsn",
					"PublicIp",
					"Type"
				],
				"members": {
					"BgpAsn": {
						"type": "integer"
					},
					"PublicIp": {
						"locationName": "IpAddress"
					},
					"Type": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CustomerGateway": {
						"shape": "S3n",
						"locationName": "customerGateway"
					}
				}
			}
		},
		"CreateDefaultVpc": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Vpc": {
						"shape": "S3q",
						"locationName": "vpc"
					}
				}
			}
		},
		"CreateDhcpOptions": {
			"input": {
				"type": "structure",
				"required": [
					"DhcpConfigurations"
				],
				"members": {
					"DhcpConfigurations": {
						"locationName": "dhcpConfiguration",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Key": {
									"locationName": "key"
								},
								"Values": {
									"shape": "S2z",
									"locationName": "Value"
								}
							}
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DhcpOptions": {
						"shape": "S3y",
						"locationName": "dhcpOptions"
					}
				}
			}
		},
		"CreateEgressOnlyInternetGateway": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"ClientToken": {},
					"DryRun": {
						"type": "boolean"
					},
					"VpcId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"EgressOnlyInternetGateway": {
						"shape": "S45",
						"locationName": "egressOnlyInternetGateway"
					}
				}
			}
		},
		"CreateFlowLogs": {
			"input": {
				"type": "structure",
				"required": [
					"DeliverLogsPermissionArn",
					"LogGroupName",
					"ResourceIds",
					"ResourceType",
					"TrafficType"
				],
				"members": {
					"ClientToken": {},
					"DeliverLogsPermissionArn": {},
					"LogGroupName": {},
					"ResourceIds": {
						"shape": "S2z",
						"locationName": "ResourceId"
					},
					"ResourceType": {},
					"TrafficType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"FlowLogIds": {
						"shape": "S2z",
						"locationName": "flowLogIdSet"
					},
					"Unsuccessful": {
						"shape": "S4d",
						"locationName": "unsuccessful"
					}
				}
			}
		},
		"CreateFpgaImage": {
			"input": {
				"type": "structure",
				"required": [
					"InputStorageLocation"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"InputStorageLocation": {
						"shape": "S4h"
					},
					"LogsStorageLocation": {
						"shape": "S4h"
					},
					"Description": {},
					"Name": {},
					"ClientToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FpgaImageId": {
						"locationName": "fpgaImageId"
					},
					"FpgaImageGlobalId": {
						"locationName": "fpgaImageGlobalId"
					}
				}
			}
		},
		"CreateImage": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"Name"
				],
				"members": {
					"BlockDeviceMappings": {
						"shape": "S4k",
						"locationName": "blockDeviceMapping"
					},
					"Description": {
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"Name": {
						"locationName": "name"
					},
					"NoReboot": {
						"locationName": "noReboot",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImageId": {
						"locationName": "imageId"
					}
				}
			}
		},
		"CreateInstanceExportTask": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"Description": {
						"locationName": "description"
					},
					"ExportToS3Task": {
						"locationName": "exportToS3",
						"type": "structure",
						"members": {
							"ContainerFormat": {
								"locationName": "containerFormat"
							},
							"DiskImageFormat": {
								"locationName": "diskImageFormat"
							},
							"S3Bucket": {
								"locationName": "s3Bucket"
							},
							"S3Prefix": {
								"locationName": "s3Prefix"
							}
						}
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"TargetEnvironment": {
						"locationName": "targetEnvironment"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ExportTask": {
						"shape": "S4v",
						"locationName": "exportTask"
					}
				}
			}
		},
		"CreateInternetGateway": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InternetGateway": {
						"shape": "S51",
						"locationName": "internetGateway"
					}
				}
			}
		},
		"CreateKeyPair": {
			"input": {
				"type": "structure",
				"required": [
					"KeyName"
				],
				"members": {
					"KeyName": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyFingerprint": {
						"locationName": "keyFingerprint"
					},
					"KeyMaterial": {
						"locationName": "keyMaterial"
					},
					"KeyName": {
						"locationName": "keyName"
					}
				}
			}
		},
		"CreateNatGateway": {
			"input": {
				"type": "structure",
				"required": [
					"AllocationId",
					"SubnetId"
				],
				"members": {
					"AllocationId": {},
					"ClientToken": {},
					"SubnetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"NatGateway": {
						"shape": "S56",
						"locationName": "natGateway"
					}
				}
			}
		},
		"CreateNetworkAcl": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkAcl": {
						"shape": "S5d",
						"locationName": "networkAcl"
					}
				}
			}
		},
		"CreateNetworkAclEntry": {
			"input": {
				"type": "structure",
				"required": [
					"Egress",
					"NetworkAclId",
					"Protocol",
					"RuleAction",
					"RuleNumber"
				],
				"members": {
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Egress": {
						"locationName": "egress",
						"type": "boolean"
					},
					"IcmpTypeCode": {
						"shape": "S5i",
						"locationName": "Icmp"
					},
					"Ipv6CidrBlock": {
						"locationName": "ipv6CidrBlock"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					},
					"PortRange": {
						"shape": "S5j",
						"locationName": "portRange"
					},
					"Protocol": {
						"locationName": "protocol"
					},
					"RuleAction": {
						"locationName": "ruleAction"
					},
					"RuleNumber": {
						"locationName": "ruleNumber",
						"type": "integer"
					}
				}
			}
		},
		"CreateNetworkInterface": {
			"input": {
				"type": "structure",
				"required": [
					"SubnetId"
				],
				"members": {
					"Description": {
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Groups": {
						"shape": "S5n",
						"locationName": "SecurityGroupId"
					},
					"Ipv6AddressCount": {
						"locationName": "ipv6AddressCount",
						"type": "integer"
					},
					"Ipv6Addresses": {
						"shape": "S5o",
						"locationName": "ipv6Addresses"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					},
					"PrivateIpAddresses": {
						"shape": "S5q",
						"locationName": "privateIpAddresses"
					},
					"SecondaryPrivateIpAddressCount": {
						"locationName": "secondaryPrivateIpAddressCount",
						"type": "integer"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkInterface": {
						"shape": "S5t",
						"locationName": "networkInterface"
					}
				}
			}
		},
		"CreateNetworkInterfacePermission": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId",
					"Permission"
				],
				"members": {
					"NetworkInterfaceId": {},
					"AwsAccountId": {},
					"AwsService": {},
					"Permission": {},
					"DryRun": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InterfacePermission": {
						"shape": "S67",
						"locationName": "interfacePermission"
					}
				}
			}
		},
		"CreatePlacementGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"Strategy"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"GroupName": {
						"locationName": "groupName"
					},
					"Strategy": {
						"locationName": "strategy"
					}
				}
			}
		},
		"CreateReservedInstancesListing": {
			"input": {
				"type": "structure",
				"required": [
					"ClientToken",
					"InstanceCount",
					"PriceSchedules",
					"ReservedInstancesId"
				],
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"InstanceCount": {
						"locationName": "instanceCount",
						"type": "integer"
					},
					"PriceSchedules": {
						"locationName": "priceSchedules",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"Price": {
									"locationName": "price",
									"type": "double"
								},
								"Term": {
									"locationName": "term",
									"type": "long"
								}
							}
						}
					},
					"ReservedInstancesId": {
						"locationName": "reservedInstancesId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesListings": {
						"shape": "S2n",
						"locationName": "reservedInstancesListingsSet"
					}
				}
			}
		},
		"CreateRoute": {
			"input": {
				"type": "structure",
				"required": [
					"RouteTableId"
				],
				"members": {
					"DestinationCidrBlock": {
						"locationName": "destinationCidrBlock"
					},
					"DestinationIpv6CidrBlock": {
						"locationName": "destinationIpv6CidrBlock"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EgressOnlyInternetGatewayId": {
						"locationName": "egressOnlyInternetGatewayId"
					},
					"GatewayId": {
						"locationName": "gatewayId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"NatGatewayId": {
						"locationName": "natGatewayId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"CreateRouteTable": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RouteTable": {
						"shape": "S6k",
						"locationName": "routeTable"
					}
				}
			}
		},
		"CreateSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"Description",
					"GroupName"
				],
				"members": {
					"Description": {
						"locationName": "GroupDescription"
					},
					"GroupName": {},
					"VpcId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GroupId": {
						"locationName": "groupId"
					}
				}
			}
		},
		"CreateSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"Description": {},
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S6w"
			}
		},
		"CreateSpotDatafeedSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"locationName": "bucket"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Prefix": {
						"locationName": "prefix"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SpotDatafeedSubscription": {
						"shape": "S70",
						"locationName": "spotDatafeedSubscription"
					}
				}
			}
		},
		"CreateSubnet": {
			"input": {
				"type": "structure",
				"required": [
					"CidrBlock",
					"VpcId"
				],
				"members": {
					"AvailabilityZone": {},
					"CidrBlock": {},
					"Ipv6CidrBlock": {},
					"VpcId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Subnet": {
						"shape": "S75",
						"locationName": "subnet"
					}
				}
			}
		},
		"CreateTags": {
			"input": {
				"type": "structure",
				"required": [
					"Resources",
					"Tags"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Resources": {
						"shape": "S79",
						"locationName": "ResourceId"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "Tag"
					}
				}
			}
		},
		"CreateVolume": {
			"input": {
				"type": "structure",
				"required": [
					"AvailabilityZone"
				],
				"members": {
					"AvailabilityZone": {},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"KmsKeyId": {},
					"Size": {
						"type": "integer"
					},
					"SnapshotId": {},
					"VolumeType": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"TagSpecifications": {
						"shape": "S7b",
						"locationName": "TagSpecification"
					}
				}
			},
			"output": {
				"shape": "S7e"
			}
		},
		"CreateVpc": {
			"input": {
				"type": "structure",
				"required": [
					"CidrBlock"
				],
				"members": {
					"CidrBlock": {},
					"AmazonProvidedIpv6CidrBlock": {
						"locationName": "amazonProvidedIpv6CidrBlock",
						"type": "boolean"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceTenancy": {
						"locationName": "instanceTenancy"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Vpc": {
						"shape": "S3q",
						"locationName": "vpc"
					}
				}
			}
		},
		"CreateVpcEndpoint": {
			"input": {
				"type": "structure",
				"required": [
					"ServiceName",
					"VpcId"
				],
				"members": {
					"ClientToken": {},
					"DryRun": {
						"type": "boolean"
					},
					"PolicyDocument": {},
					"RouteTableIds": {
						"shape": "S2z",
						"locationName": "RouteTableId"
					},
					"ServiceName": {},
					"VpcId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"VpcEndpoint": {
						"shape": "S7l",
						"locationName": "vpcEndpoint"
					}
				}
			}
		},
		"CreateVpcPeeringConnection": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"PeerOwnerId": {
						"locationName": "peerOwnerId"
					},
					"PeerVpcId": {
						"locationName": "peerVpcId"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpcPeeringConnection": {
						"shape": "Sb",
						"locationName": "vpcPeeringConnection"
					}
				}
			}
		},
		"CreateVpnConnection": {
			"input": {
				"type": "structure",
				"required": [
					"CustomerGatewayId",
					"Type",
					"VpnGatewayId"
				],
				"members": {
					"CustomerGatewayId": {},
					"Type": {},
					"VpnGatewayId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Options": {
						"locationName": "options",
						"type": "structure",
						"members": {
							"StaticRoutesOnly": {
								"locationName": "staticRoutesOnly",
								"type": "boolean"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpnConnection": {
						"shape": "S7s",
						"locationName": "vpnConnection"
					}
				}
			}
		},
		"CreateVpnConnectionRoute": {
			"input": {
				"type": "structure",
				"required": [
					"DestinationCidrBlock",
					"VpnConnectionId"
				],
				"members": {
					"DestinationCidrBlock": {},
					"VpnConnectionId": {}
				}
			}
		},
		"CreateVpnGateway": {
			"input": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"AvailabilityZone": {},
					"Type": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpnGateway": {
						"shape": "S84",
						"locationName": "vpnGateway"
					}
				}
			}
		},
		"DeleteCustomerGateway": {
			"input": {
				"type": "structure",
				"required": [
					"CustomerGatewayId"
				],
				"members": {
					"CustomerGatewayId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteDhcpOptions": {
			"input": {
				"type": "structure",
				"required": [
					"DhcpOptionsId"
				],
				"members": {
					"DhcpOptionsId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteEgressOnlyInternetGateway": {
			"input": {
				"type": "structure",
				"required": [
					"EgressOnlyInternetGatewayId"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"EgressOnlyInternetGatewayId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReturnCode": {
						"locationName": "returnCode",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteFlowLogs": {
			"input": {
				"type": "structure",
				"required": [
					"FlowLogIds"
				],
				"members": {
					"FlowLogIds": {
						"shape": "S2z",
						"locationName": "FlowLogId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Unsuccessful": {
						"shape": "S4d",
						"locationName": "unsuccessful"
					}
				}
			}
		},
		"DeleteInternetGateway": {
			"input": {
				"type": "structure",
				"required": [
					"InternetGatewayId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InternetGatewayId": {
						"locationName": "internetGatewayId"
					}
				}
			}
		},
		"DeleteKeyPair": {
			"input": {
				"type": "structure",
				"required": [
					"KeyName"
				],
				"members": {
					"KeyName": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteNatGateway": {
			"input": {
				"type": "structure",
				"required": [
					"NatGatewayId"
				],
				"members": {
					"NatGatewayId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NatGatewayId": {
						"locationName": "natGatewayId"
					}
				}
			}
		},
		"DeleteNetworkAcl": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkAclId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					}
				}
			}
		},
		"DeleteNetworkAclEntry": {
			"input": {
				"type": "structure",
				"required": [
					"Egress",
					"NetworkAclId",
					"RuleNumber"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Egress": {
						"locationName": "egress",
						"type": "boolean"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					},
					"RuleNumber": {
						"locationName": "ruleNumber",
						"type": "integer"
					}
				}
			}
		},
		"DeleteNetworkInterface": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			}
		},
		"DeleteNetworkInterfacePermission": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfacePermissionId"
				],
				"members": {
					"NetworkInterfacePermissionId": {},
					"Force": {
						"type": "boolean"
					},
					"DryRun": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"DeletePlacementGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"GroupName": {
						"locationName": "groupName"
					}
				}
			}
		},
		"DeleteRoute": {
			"input": {
				"type": "structure",
				"required": [
					"RouteTableId"
				],
				"members": {
					"DestinationCidrBlock": {
						"locationName": "destinationCidrBlock"
					},
					"DestinationIpv6CidrBlock": {
						"locationName": "destinationIpv6CidrBlock"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					}
				}
			}
		},
		"DeleteRouteTable": {
			"input": {
				"type": "structure",
				"required": [
					"RouteTableId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					}
				}
			}
		},
		"DeleteSecurityGroup": {
			"input": {
				"type": "structure",
				"members": {
					"GroupId": {},
					"GroupName": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotId"
				],
				"members": {
					"SnapshotId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteSpotDatafeedSubscription": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteSubnet": {
			"input": {
				"type": "structure",
				"required": [
					"SubnetId"
				],
				"members": {
					"SubnetId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteTags": {
			"input": {
				"type": "structure",
				"required": [
					"Resources"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Resources": {
						"shape": "S79",
						"locationName": "resourceId"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tag"
					}
				}
			}
		},
		"DeleteVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteVpc": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"VpcId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteVpcEndpoints": {
			"input": {
				"type": "structure",
				"required": [
					"VpcEndpointIds"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"VpcEndpointIds": {
						"shape": "S2z",
						"locationName": "VpcEndpointId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Unsuccessful": {
						"shape": "S4d",
						"locationName": "unsuccessful"
					}
				}
			}
		},
		"DeleteVpcPeeringConnection": {
			"input": {
				"type": "structure",
				"required": [
					"VpcPeeringConnectionId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteVpnConnection": {
			"input": {
				"type": "structure",
				"required": [
					"VpnConnectionId"
				],
				"members": {
					"VpnConnectionId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeleteVpnConnectionRoute": {
			"input": {
				"type": "structure",
				"required": [
					"DestinationCidrBlock",
					"VpnConnectionId"
				],
				"members": {
					"DestinationCidrBlock": {},
					"VpnConnectionId": {}
				}
			}
		},
		"DeleteVpnGateway": {
			"input": {
				"type": "structure",
				"required": [
					"VpnGatewayId"
				],
				"members": {
					"VpnGatewayId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DeregisterImage": {
			"input": {
				"type": "structure",
				"required": [
					"ImageId"
				],
				"members": {
					"ImageId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DescribeAccountAttributes": {
			"input": {
				"type": "structure",
				"members": {
					"AttributeNames": {
						"locationName": "attributeName",
						"type": "list",
						"member": {
							"locationName": "attributeName"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AccountAttributes": {
						"locationName": "accountAttributeSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AttributeName": {
									"locationName": "attributeName"
								},
								"AttributeValues": {
									"locationName": "attributeValueSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"AttributeValue": {
												"locationName": "attributeValue"
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeAddresses": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"PublicIps": {
						"locationName": "PublicIp",
						"type": "list",
						"member": {
							"locationName": "PublicIp"
						}
					},
					"AllocationIds": {
						"locationName": "AllocationId",
						"type": "list",
						"member": {
							"locationName": "AllocationId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Addresses": {
						"locationName": "addressesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"InstanceId": {
									"locationName": "instanceId"
								},
								"PublicIp": {
									"locationName": "publicIp"
								},
								"AllocationId": {
									"locationName": "allocationId"
								},
								"AssociationId": {
									"locationName": "associationId"
								},
								"Domain": {
									"locationName": "domain"
								},
								"NetworkInterfaceId": {
									"locationName": "networkInterfaceId"
								},
								"NetworkInterfaceOwnerId": {
									"locationName": "networkInterfaceOwnerId"
								},
								"PrivateIpAddress": {
									"locationName": "privateIpAddress"
								}
							}
						}
					}
				}
			}
		},
		"DescribeAvailabilityZones": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"ZoneNames": {
						"locationName": "ZoneName",
						"type": "list",
						"member": {
							"locationName": "ZoneName"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AvailabilityZones": {
						"locationName": "availabilityZoneInfo",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"State": {
									"locationName": "zoneState"
								},
								"Messages": {
									"locationName": "messageSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Message": {
												"locationName": "message"
											}
										}
									}
								},
								"RegionName": {
									"locationName": "regionName"
								},
								"ZoneName": {
									"locationName": "zoneName"
								}
							}
						}
					}
				}
			}
		},
		"DescribeBundleTasks": {
			"input": {
				"type": "structure",
				"members": {
					"BundleIds": {
						"locationName": "BundleId",
						"type": "list",
						"member": {
							"locationName": "BundleId"
						}
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BundleTasks": {
						"locationName": "bundleInstanceTasksSet",
						"type": "list",
						"member": {
							"shape": "S2c",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeClassicLinkInstances": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceIds": {
						"shape": "S9w",
						"locationName": "InstanceId"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Instances": {
						"locationName": "instancesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Groups": {
									"shape": "S5w",
									"locationName": "groupSet"
								},
								"InstanceId": {
									"locationName": "instanceId"
								},
								"Tags": {
									"shape": "Sj",
									"locationName": "tagSet"
								},
								"VpcId": {
									"locationName": "vpcId"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeConversionTasks": {
			"input": {
				"type": "structure",
				"members": {
					"ConversionTaskIds": {
						"locationName": "conversionTaskId",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConversionTasks": {
						"locationName": "conversionTasks",
						"type": "list",
						"member": {
							"shape": "Sa4",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeCustomerGateways": {
			"input": {
				"type": "structure",
				"members": {
					"CustomerGatewayIds": {
						"locationName": "CustomerGatewayId",
						"type": "list",
						"member": {
							"locationName": "CustomerGatewayId"
						}
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CustomerGateways": {
						"locationName": "customerGatewaySet",
						"type": "list",
						"member": {
							"shape": "S3n",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeDhcpOptions": {
			"input": {
				"type": "structure",
				"members": {
					"DhcpOptionsIds": {
						"locationName": "DhcpOptionsId",
						"type": "list",
						"member": {
							"locationName": "DhcpOptionsId"
						}
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DhcpOptions": {
						"locationName": "dhcpOptionsSet",
						"type": "list",
						"member": {
							"shape": "S3y",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeEgressOnlyInternetGateways": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"EgressOnlyInternetGatewayIds": {
						"locationName": "EgressOnlyInternetGatewayId",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EgressOnlyInternetGateways": {
						"locationName": "egressOnlyInternetGatewaySet",
						"type": "list",
						"member": {
							"shape": "S45",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeElasticGpus": {
			"input": {
				"type": "structure",
				"members": {
					"ElasticGpuIds": {
						"locationName": "ElasticGpuId",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ElasticGpuSet": {
						"locationName": "elasticGpuSet",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ElasticGpuId": {
									"locationName": "elasticGpuId"
								},
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"ElasticGpuType": {
									"locationName": "elasticGpuType"
								},
								"ElasticGpuHealth": {
									"locationName": "elasticGpuHealth",
									"type": "structure",
									"members": {
										"Status": {
											"locationName": "status"
										}
									}
								},
								"ElasticGpuState": {
									"locationName": "elasticGpuState"
								},
								"InstanceId": {
									"locationName": "instanceId"
								}
							}
						}
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeExportTasks": {
			"input": {
				"type": "structure",
				"members": {
					"ExportTaskIds": {
						"locationName": "exportTaskId",
						"type": "list",
						"member": {
							"locationName": "ExportTaskId"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ExportTasks": {
						"locationName": "exportTaskSet",
						"type": "list",
						"member": {
							"shape": "S4v",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeFlowLogs": {
			"input": {
				"type": "structure",
				"members": {
					"Filter": {
						"shape": "S9c"
					},
					"FlowLogIds": {
						"shape": "S2z",
						"locationName": "FlowLogId"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FlowLogs": {
						"locationName": "flowLogSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"CreationTime": {
									"locationName": "creationTime",
									"type": "timestamp"
								},
								"DeliverLogsErrorMessage": {
									"locationName": "deliverLogsErrorMessage"
								},
								"DeliverLogsPermissionArn": {
									"locationName": "deliverLogsPermissionArn"
								},
								"DeliverLogsStatus": {
									"locationName": "deliverLogsStatus"
								},
								"FlowLogId": {
									"locationName": "flowLogId"
								},
								"FlowLogStatus": {
									"locationName": "flowLogStatus"
								},
								"LogGroupName": {
									"locationName": "logGroupName"
								},
								"ResourceId": {
									"locationName": "resourceId"
								},
								"TrafficType": {
									"locationName": "trafficType"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeFpgaImages": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"FpgaImageIds": {
						"locationName": "FpgaImageId",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"Owners": {
						"shape": "Sb7",
						"locationName": "Owner"
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FpgaImages": {
						"locationName": "fpgaImageSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"FpgaImageId": {
									"locationName": "fpgaImageId"
								},
								"FpgaImageGlobalId": {
									"locationName": "fpgaImageGlobalId"
								},
								"Name": {
									"locationName": "name"
								},
								"Description": {
									"locationName": "description"
								},
								"ShellVersion": {
									"locationName": "shellVersion"
								},
								"PciId": {
									"locationName": "pciId",
									"type": "structure",
									"members": {
										"DeviceId": {},
										"VendorId": {},
										"SubsystemId": {},
										"SubsystemVendorId": {}
									}
								},
								"State": {
									"locationName": "state",
									"type": "structure",
									"members": {
										"Code": {
											"locationName": "code"
										},
										"Message": {
											"locationName": "message"
										}
									}
								},
								"CreateTime": {
									"locationName": "createTime",
									"type": "timestamp"
								},
								"UpdateTime": {
									"locationName": "updateTime",
									"type": "timestamp"
								},
								"OwnerId": {
									"locationName": "ownerId"
								},
								"OwnerAlias": {
									"locationName": "ownerAlias"
								},
								"ProductCodes": {
									"shape": "Sbg",
									"locationName": "productCodes"
								},
								"Tags": {
									"shape": "Sj",
									"locationName": "tags"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeHostReservationOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"Filter": {
						"shape": "S9c"
					},
					"MaxDuration": {
						"type": "integer"
					},
					"MaxResults": {
						"type": "integer"
					},
					"MinDuration": {
						"type": "integer"
					},
					"NextToken": {},
					"OfferingId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"OfferingSet": {
						"locationName": "offeringSet",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"Duration": {
									"locationName": "duration",
									"type": "integer"
								},
								"HourlyPrice": {
									"locationName": "hourlyPrice"
								},
								"InstanceFamily": {
									"locationName": "instanceFamily"
								},
								"OfferingId": {
									"locationName": "offeringId"
								},
								"PaymentOption": {
									"locationName": "paymentOption"
								},
								"UpfrontPrice": {
									"locationName": "upfrontPrice"
								}
							}
						}
					}
				}
			}
		},
		"DescribeHostReservations": {
			"input": {
				"type": "structure",
				"members": {
					"Filter": {
						"shape": "S9c"
					},
					"HostReservationIdSet": {
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HostReservationSet": {
						"locationName": "hostReservationSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Count": {
									"locationName": "count",
									"type": "integer"
								},
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"Duration": {
									"locationName": "duration",
									"type": "integer"
								},
								"End": {
									"locationName": "end",
									"type": "timestamp"
								},
								"HostIdSet": {
									"shape": "Sbt",
									"locationName": "hostIdSet"
								},
								"HostReservationId": {
									"locationName": "hostReservationId"
								},
								"HourlyPrice": {
									"locationName": "hourlyPrice"
								},
								"InstanceFamily": {
									"locationName": "instanceFamily"
								},
								"OfferingId": {
									"locationName": "offeringId"
								},
								"PaymentOption": {
									"locationName": "paymentOption"
								},
								"Start": {
									"locationName": "start",
									"type": "timestamp"
								},
								"State": {
									"locationName": "state"
								},
								"UpfrontPrice": {
									"locationName": "upfrontPrice"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeHosts": {
			"input": {
				"type": "structure",
				"members": {
					"Filter": {
						"shape": "S9c",
						"locationName": "filter"
					},
					"HostIds": {
						"shape": "Sbw",
						"locationName": "hostId"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Hosts": {
						"locationName": "hostSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AutoPlacement": {
									"locationName": "autoPlacement"
								},
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"AvailableCapacity": {
									"locationName": "availableCapacity",
									"type": "structure",
									"members": {
										"AvailableInstanceCapacity": {
											"locationName": "availableInstanceCapacity",
											"type": "list",
											"member": {
												"locationName": "item",
												"type": "structure",
												"members": {
													"AvailableCapacity": {
														"locationName": "availableCapacity",
														"type": "integer"
													},
													"InstanceType": {
														"locationName": "instanceType"
													},
													"TotalCapacity": {
														"locationName": "totalCapacity",
														"type": "integer"
													}
												}
											}
										},
										"AvailableVCpus": {
											"locationName": "availableVCpus",
											"type": "integer"
										}
									}
								},
								"ClientToken": {
									"locationName": "clientToken"
								},
								"HostId": {
									"locationName": "hostId"
								},
								"HostProperties": {
									"locationName": "hostProperties",
									"type": "structure",
									"members": {
										"Cores": {
											"locationName": "cores",
											"type": "integer"
										},
										"InstanceType": {
											"locationName": "instanceType"
										},
										"Sockets": {
											"locationName": "sockets",
											"type": "integer"
										},
										"TotalVCpus": {
											"locationName": "totalVCpus",
											"type": "integer"
										}
									}
								},
								"HostReservationId": {
									"locationName": "hostReservationId"
								},
								"Instances": {
									"locationName": "instances",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"InstanceId": {
												"locationName": "instanceId"
											},
											"InstanceType": {
												"locationName": "instanceType"
											}
										}
									}
								},
								"State": {
									"locationName": "state"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeIamInstanceProfileAssociations": {
			"input": {
				"type": "structure",
				"members": {
					"AssociationIds": {
						"locationName": "AssociationId",
						"type": "list",
						"member": {
							"locationName": "AssociationId"
						}
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IamInstanceProfileAssociations": {
						"locationName": "iamInstanceProfileAssociationSet",
						"type": "list",
						"member": {
							"shape": "S13",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeIdFormat": {
			"input": {
				"type": "structure",
				"members": {
					"Resource": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Statuses": {
						"shape": "Scd",
						"locationName": "statusSet"
					}
				}
			}
		},
		"DescribeIdentityIdFormat": {
			"input": {
				"type": "structure",
				"required": [
					"PrincipalArn"
				],
				"members": {
					"PrincipalArn": {
						"locationName": "principalArn"
					},
					"Resource": {
						"locationName": "resource"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Statuses": {
						"shape": "Scd",
						"locationName": "statusSet"
					}
				}
			}
		},
		"DescribeImageAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"ImageId"
				],
				"members": {
					"Attribute": {},
					"ImageId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BlockDeviceMappings": {
						"shape": "Sck",
						"locationName": "blockDeviceMapping"
					},
					"ImageId": {
						"locationName": "imageId"
					},
					"LaunchPermissions": {
						"shape": "Scl",
						"locationName": "launchPermission"
					},
					"ProductCodes": {
						"shape": "Sbg",
						"locationName": "productCodes"
					},
					"Description": {
						"shape": "S42",
						"locationName": "description"
					},
					"KernelId": {
						"shape": "S42",
						"locationName": "kernel"
					},
					"RamdiskId": {
						"shape": "S42",
						"locationName": "ramdisk"
					},
					"SriovNetSupport": {
						"shape": "S42",
						"locationName": "sriovNetSupport"
					}
				}
			}
		},
		"DescribeImages": {
			"input": {
				"type": "structure",
				"members": {
					"ExecutableUsers": {
						"locationName": "ExecutableBy",
						"type": "list",
						"member": {
							"locationName": "ExecutableBy"
						}
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"ImageIds": {
						"locationName": "ImageId",
						"type": "list",
						"member": {
							"locationName": "ImageId"
						}
					},
					"Owners": {
						"shape": "Sb7",
						"locationName": "Owner"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Images": {
						"locationName": "imagesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Architecture": {
									"locationName": "architecture"
								},
								"CreationDate": {
									"locationName": "creationDate"
								},
								"ImageId": {
									"locationName": "imageId"
								},
								"ImageLocation": {
									"locationName": "imageLocation"
								},
								"ImageType": {
									"locationName": "imageType"
								},
								"Public": {
									"locationName": "isPublic",
									"type": "boolean"
								},
								"KernelId": {
									"locationName": "kernelId"
								},
								"OwnerId": {
									"locationName": "imageOwnerId"
								},
								"Platform": {
									"locationName": "platform"
								},
								"ProductCodes": {
									"shape": "Sbg",
									"locationName": "productCodes"
								},
								"RamdiskId": {
									"locationName": "ramdiskId"
								},
								"State": {
									"locationName": "imageState"
								},
								"BlockDeviceMappings": {
									"shape": "Sck",
									"locationName": "blockDeviceMapping"
								},
								"Description": {
									"locationName": "description"
								},
								"EnaSupport": {
									"locationName": "enaSupport",
									"type": "boolean"
								},
								"Hypervisor": {
									"locationName": "hypervisor"
								},
								"ImageOwnerAlias": {
									"locationName": "imageOwnerAlias"
								},
								"Name": {
									"locationName": "name"
								},
								"RootDeviceName": {
									"locationName": "rootDeviceName"
								},
								"RootDeviceType": {
									"locationName": "rootDeviceType"
								},
								"SriovNetSupport": {
									"locationName": "sriovNetSupport"
								},
								"StateReason": {
									"shape": "Scz",
									"locationName": "stateReason"
								},
								"Tags": {
									"shape": "Sj",
									"locationName": "tagSet"
								},
								"VirtualizationType": {
									"locationName": "virtualizationType"
								}
							}
						}
					}
				}
			}
		},
		"DescribeImportImageTasks": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9c"
					},
					"ImportTaskIds": {
						"shape": "Sd2",
						"locationName": "ImportTaskId"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImportImageTasks": {
						"locationName": "importImageTaskSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Architecture": {
									"locationName": "architecture"
								},
								"Description": {
									"locationName": "description"
								},
								"Hypervisor": {
									"locationName": "hypervisor"
								},
								"ImageId": {
									"locationName": "imageId"
								},
								"ImportTaskId": {
									"locationName": "importTaskId"
								},
								"LicenseType": {
									"locationName": "licenseType"
								},
								"Platform": {
									"locationName": "platform"
								},
								"Progress": {
									"locationName": "progress"
								},
								"SnapshotDetails": {
									"shape": "Sd6",
									"locationName": "snapshotDetailSet"
								},
								"Status": {
									"locationName": "status"
								},
								"StatusMessage": {
									"locationName": "statusMessage"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeImportSnapshotTasks": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9c"
					},
					"ImportTaskIds": {
						"shape": "Sd2",
						"locationName": "ImportTaskId"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImportSnapshotTasks": {
						"locationName": "importSnapshotTaskSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Description": {
									"locationName": "description"
								},
								"ImportTaskId": {
									"locationName": "importTaskId"
								},
								"SnapshotTaskDetail": {
									"shape": "Sdd",
									"locationName": "snapshotTaskDetail"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeInstanceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"InstanceId"
				],
				"members": {
					"Attribute": {
						"locationName": "attribute"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceId": {
						"locationName": "instanceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Groups": {
						"shape": "S5w",
						"locationName": "groupSet"
					},
					"BlockDeviceMappings": {
						"shape": "Sdh",
						"locationName": "blockDeviceMapping"
					},
					"DisableApiTermination": {
						"shape": "Sdk",
						"locationName": "disableApiTermination"
					},
					"EnaSupport": {
						"shape": "Sdk",
						"locationName": "enaSupport"
					},
					"EbsOptimized": {
						"shape": "Sdk",
						"locationName": "ebsOptimized"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"InstanceInitiatedShutdownBehavior": {
						"shape": "S42",
						"locationName": "instanceInitiatedShutdownBehavior"
					},
					"InstanceType": {
						"shape": "S42",
						"locationName": "instanceType"
					},
					"KernelId": {
						"shape": "S42",
						"locationName": "kernel"
					},
					"ProductCodes": {
						"shape": "Sbg",
						"locationName": "productCodes"
					},
					"RamdiskId": {
						"shape": "S42",
						"locationName": "ramdisk"
					},
					"RootDeviceName": {
						"shape": "S42",
						"locationName": "rootDeviceName"
					},
					"SourceDestCheck": {
						"shape": "Sdk",
						"locationName": "sourceDestCheck"
					},
					"SriovNetSupport": {
						"shape": "S42",
						"locationName": "sriovNetSupport"
					},
					"UserData": {
						"shape": "S42",
						"locationName": "userData"
					}
				}
			}
		},
		"DescribeInstanceStatus": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"InstanceIds": {
						"shape": "S9w",
						"locationName": "InstanceId"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"IncludeAllInstances": {
						"locationName": "includeAllInstances",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceStatuses": {
						"locationName": "instanceStatusSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"Events": {
									"locationName": "eventsSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Code": {
												"locationName": "code"
											},
											"Description": {
												"locationName": "description"
											},
											"NotAfter": {
												"locationName": "notAfter",
												"type": "timestamp"
											},
											"NotBefore": {
												"locationName": "notBefore",
												"type": "timestamp"
											}
										}
									}
								},
								"InstanceId": {
									"locationName": "instanceId"
								},
								"InstanceState": {
									"shape": "Sds",
									"locationName": "instanceState"
								},
								"InstanceStatus": {
									"shape": "Sdu",
									"locationName": "instanceStatus"
								},
								"SystemStatus": {
									"shape": "Sdu",
									"locationName": "systemStatus"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeInstances": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"InstanceIds": {
						"shape": "S9w",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Reservations": {
						"locationName": "reservationSet",
						"type": "list",
						"member": {
							"shape": "Se3",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeInternetGateways": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InternetGatewayIds": {
						"shape": "S2z",
						"locationName": "internetGatewayId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InternetGateways": {
						"locationName": "internetGatewaySet",
						"type": "list",
						"member": {
							"shape": "S51",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeKeyPairs": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"KeyNames": {
						"locationName": "KeyName",
						"type": "list",
						"member": {
							"locationName": "KeyName"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyPairs": {
						"locationName": "keySet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"KeyFingerprint": {
									"locationName": "keyFingerprint"
								},
								"KeyName": {
									"locationName": "keyName"
								}
							}
						}
					}
				}
			}
		},
		"DescribeMovingAddresses": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"PublicIps": {
						"shape": "S2z",
						"locationName": "publicIp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MovingAddressStatuses": {
						"locationName": "movingAddressStatusSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"MoveStatus": {
									"locationName": "moveStatus"
								},
								"PublicIp": {
									"locationName": "publicIp"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeNatGateways": {
			"input": {
				"type": "structure",
				"members": {
					"Filter": {
						"shape": "S9c"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NatGatewayIds": {
						"shape": "S2z",
						"locationName": "NatGatewayId"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NatGateways": {
						"locationName": "natGatewaySet",
						"type": "list",
						"member": {
							"shape": "S56",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeNetworkAcls": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkAclIds": {
						"shape": "S2z",
						"locationName": "NetworkAclId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkAcls": {
						"locationName": "networkAclSet",
						"type": "list",
						"member": {
							"shape": "S5d",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeNetworkInterfaceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"Attribute": {
						"locationName": "attribute"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Attachment": {
						"shape": "S5v",
						"locationName": "attachment"
					},
					"Description": {
						"shape": "S42",
						"locationName": "description"
					},
					"Groups": {
						"shape": "S5w",
						"locationName": "groupSet"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"SourceDestCheck": {
						"shape": "Sdk",
						"locationName": "sourceDestCheck"
					}
				}
			}
		},
		"DescribeNetworkInterfacePermissions": {
			"input": {
				"type": "structure",
				"members": {
					"NetworkInterfacePermissionIds": {
						"locationName": "NetworkInterfacePermissionId",
						"type": "list",
						"member": {}
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkInterfacePermissions": {
						"locationName": "networkInterfacePermissions",
						"type": "list",
						"member": {
							"shape": "S67",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeNetworkInterfaces": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkInterfaceIds": {
						"locationName": "NetworkInterfaceId",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkInterfaces": {
						"locationName": "networkInterfaceSet",
						"type": "list",
						"member": {
							"shape": "S5t",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribePlacementGroups": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"GroupNames": {
						"locationName": "groupName",
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlacementGroups": {
						"locationName": "placementGroupSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"GroupName": {
									"locationName": "groupName"
								},
								"State": {
									"locationName": "state"
								},
								"Strategy": {
									"locationName": "strategy"
								}
							}
						}
					}
				}
			}
		},
		"DescribePrefixLists": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"PrefixListIds": {
						"shape": "S2z",
						"locationName": "PrefixListId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"PrefixLists": {
						"locationName": "prefixListSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Cidrs": {
									"shape": "S2z",
									"locationName": "cidrSet"
								},
								"PrefixListId": {
									"locationName": "prefixListId"
								},
								"PrefixListName": {
									"locationName": "prefixListName"
								}
							}
						}
					}
				}
			}
		},
		"DescribeRegions": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"RegionNames": {
						"locationName": "RegionName",
						"type": "list",
						"member": {
							"locationName": "RegionName"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Regions": {
						"locationName": "regionInfo",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Endpoint": {
									"locationName": "regionEndpoint"
								},
								"RegionName": {
									"locationName": "regionName"
								}
							}
						}
					}
				}
			}
		},
		"DescribeReservedInstances": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"OfferingClass": {},
					"ReservedInstancesIds": {
						"shape": "Sfu",
						"locationName": "ReservedInstancesId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"OfferingType": {
						"locationName": "offeringType"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstances": {
						"locationName": "reservedInstancesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"Duration": {
									"locationName": "duration",
									"type": "long"
								},
								"End": {
									"locationName": "end",
									"type": "timestamp"
								},
								"FixedPrice": {
									"locationName": "fixedPrice",
									"type": "float"
								},
								"InstanceCount": {
									"locationName": "instanceCount",
									"type": "integer"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"ProductDescription": {
									"locationName": "productDescription"
								},
								"ReservedInstancesId": {
									"locationName": "reservedInstancesId"
								},
								"Start": {
									"locationName": "start",
									"type": "timestamp"
								},
								"State": {
									"locationName": "state"
								},
								"UsagePrice": {
									"locationName": "usagePrice",
									"type": "float"
								},
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"InstanceTenancy": {
									"locationName": "instanceTenancy"
								},
								"OfferingClass": {
									"locationName": "offeringClass"
								},
								"OfferingType": {
									"locationName": "offeringType"
								},
								"RecurringCharges": {
									"shape": "Sg2",
									"locationName": "recurringCharges"
								},
								"Scope": {
									"locationName": "scope"
								},
								"Tags": {
									"shape": "Sj",
									"locationName": "tagSet"
								}
							}
						}
					}
				}
			}
		},
		"DescribeReservedInstancesListings": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"ReservedInstancesId": {
						"locationName": "reservedInstancesId"
					},
					"ReservedInstancesListingId": {
						"locationName": "reservedInstancesListingId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesListings": {
						"shape": "S2n",
						"locationName": "reservedInstancesListingsSet"
					}
				}
			}
		},
		"DescribeReservedInstancesModifications": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"ReservedInstancesModificationIds": {
						"locationName": "ReservedInstancesModificationId",
						"type": "list",
						"member": {
							"locationName": "ReservedInstancesModificationId"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"ReservedInstancesModifications": {
						"locationName": "reservedInstancesModificationsSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ClientToken": {
									"locationName": "clientToken"
								},
								"CreateDate": {
									"locationName": "createDate",
									"type": "timestamp"
								},
								"EffectiveDate": {
									"locationName": "effectiveDate",
									"type": "timestamp"
								},
								"ModificationResults": {
									"locationName": "modificationResultSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"ReservedInstancesId": {
												"locationName": "reservedInstancesId"
											},
											"TargetConfiguration": {
												"shape": "Sgf",
												"locationName": "targetConfiguration"
											}
										}
									}
								},
								"ReservedInstancesIds": {
									"locationName": "reservedInstancesSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"ReservedInstancesId": {
												"locationName": "reservedInstancesId"
											}
										}
									}
								},
								"ReservedInstancesModificationId": {
									"locationName": "reservedInstancesModificationId"
								},
								"Status": {
									"locationName": "status"
								},
								"StatusMessage": {
									"locationName": "statusMessage"
								},
								"UpdateDate": {
									"locationName": "updateDate",
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeReservedInstancesOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"IncludeMarketplace": {
						"type": "boolean"
					},
					"InstanceType": {},
					"MaxDuration": {
						"type": "long"
					},
					"MaxInstanceCount": {
						"type": "integer"
					},
					"MinDuration": {
						"type": "long"
					},
					"OfferingClass": {},
					"ProductDescription": {},
					"ReservedInstancesOfferingIds": {
						"locationName": "ReservedInstancesOfferingId",
						"type": "list",
						"member": {}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceTenancy": {
						"locationName": "instanceTenancy"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"OfferingType": {
						"locationName": "offeringType"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesOfferings": {
						"locationName": "reservedInstancesOfferingsSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"Duration": {
									"locationName": "duration",
									"type": "long"
								},
								"FixedPrice": {
									"locationName": "fixedPrice",
									"type": "float"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"ProductDescription": {
									"locationName": "productDescription"
								},
								"ReservedInstancesOfferingId": {
									"locationName": "reservedInstancesOfferingId"
								},
								"UsagePrice": {
									"locationName": "usagePrice",
									"type": "float"
								},
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"InstanceTenancy": {
									"locationName": "instanceTenancy"
								},
								"Marketplace": {
									"locationName": "marketplace",
									"type": "boolean"
								},
								"OfferingClass": {
									"locationName": "offeringClass"
								},
								"OfferingType": {
									"locationName": "offeringType"
								},
								"PricingDetails": {
									"locationName": "pricingDetailsSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Count": {
												"locationName": "count",
												"type": "integer"
											},
											"Price": {
												"locationName": "price",
												"type": "double"
											}
										}
									}
								},
								"RecurringCharges": {
									"shape": "Sg2",
									"locationName": "recurringCharges"
								},
								"Scope": {
									"locationName": "scope"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeRouteTables": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"RouteTableIds": {
						"shape": "S2z",
						"locationName": "RouteTableId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RouteTables": {
						"locationName": "routeTableSet",
						"type": "list",
						"member": {
							"shape": "S6k",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeScheduledInstanceAvailability": {
			"input": {
				"type": "structure",
				"required": [
					"FirstSlotStartTimeRange",
					"Recurrence"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"FirstSlotStartTimeRange": {
						"type": "structure",
						"required": [
							"EarliestTime",
							"LatestTime"
						],
						"members": {
							"EarliestTime": {
								"type": "timestamp"
							},
							"LatestTime": {
								"type": "timestamp"
							}
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"MaxSlotDurationInHours": {
						"type": "integer"
					},
					"MinSlotDurationInHours": {
						"type": "integer"
					},
					"NextToken": {},
					"Recurrence": {
						"type": "structure",
						"members": {
							"Frequency": {},
							"Interval": {
								"type": "integer"
							},
							"OccurrenceDays": {
								"locationName": "OccurrenceDay",
								"type": "list",
								"member": {
									"locationName": "OccurenceDay",
									"type": "integer"
								}
							},
							"OccurrenceRelativeToEnd": {
								"type": "boolean"
							},
							"OccurrenceUnit": {}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"ScheduledInstanceAvailabilitySet": {
						"locationName": "scheduledInstanceAvailabilitySet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"AvailableInstanceCount": {
									"locationName": "availableInstanceCount",
									"type": "integer"
								},
								"FirstSlotStartTime": {
									"locationName": "firstSlotStartTime",
									"type": "timestamp"
								},
								"HourlyPrice": {
									"locationName": "hourlyPrice"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"MaxTermDurationInDays": {
									"locationName": "maxTermDurationInDays",
									"type": "integer"
								},
								"MinTermDurationInDays": {
									"locationName": "minTermDurationInDays",
									"type": "integer"
								},
								"NetworkPlatform": {
									"locationName": "networkPlatform"
								},
								"Platform": {
									"locationName": "platform"
								},
								"PurchaseToken": {
									"locationName": "purchaseToken"
								},
								"Recurrence": {
									"shape": "Sgz",
									"locationName": "recurrence"
								},
								"SlotDurationInHours": {
									"locationName": "slotDurationInHours",
									"type": "integer"
								},
								"TotalScheduledInstanceHours": {
									"locationName": "totalScheduledInstanceHours",
									"type": "integer"
								}
							}
						}
					}
				}
			}
		},
		"DescribeScheduledInstances": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"ScheduledInstanceIds": {
						"locationName": "ScheduledInstanceId",
						"type": "list",
						"member": {
							"locationName": "ScheduledInstanceId"
						}
					},
					"SlotStartTimeRange": {
						"type": "structure",
						"members": {
							"EarliestTime": {
								"type": "timestamp"
							},
							"LatestTime": {
								"type": "timestamp"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"ScheduledInstanceSet": {
						"locationName": "scheduledInstanceSet",
						"type": "list",
						"member": {
							"shape": "Sh6",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeSecurityGroupReferences": {
			"input": {
				"type": "structure",
				"required": [
					"GroupId"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"GroupId": {
						"type": "list",
						"member": {
							"locationName": "item"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SecurityGroupReferenceSet": {
						"locationName": "securityGroupReferenceSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"GroupId",
								"ReferencingVpcId"
							],
							"members": {
								"GroupId": {
									"locationName": "groupId"
								},
								"ReferencingVpcId": {
									"locationName": "referencingVpcId"
								},
								"VpcPeeringConnectionId": {
									"locationName": "vpcPeeringConnectionId"
								}
							}
						}
					}
				}
			}
		},
		"DescribeSecurityGroups": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"GroupIds": {
						"shape": "S1j",
						"locationName": "GroupId"
					},
					"GroupNames": {
						"shape": "Shd",
						"locationName": "GroupName"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SecurityGroups": {
						"locationName": "securityGroupInfo",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Description": {
									"locationName": "groupDescription"
								},
								"GroupName": {
									"locationName": "groupName"
								},
								"IpPermissions": {
									"shape": "S1w",
									"locationName": "ipPermissions"
								},
								"OwnerId": {
									"locationName": "ownerId"
								},
								"GroupId": {
									"locationName": "groupId"
								},
								"IpPermissionsEgress": {
									"shape": "S1w",
									"locationName": "ipPermissionsEgress"
								},
								"Tags": {
									"shape": "Sj",
									"locationName": "tagSet"
								},
								"VpcId": {
									"locationName": "vpcId"
								}
							}
						}
					}
				}
			}
		},
		"DescribeSnapshotAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"SnapshotId"
				],
				"members": {
					"Attribute": {},
					"SnapshotId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CreateVolumePermissions": {
						"shape": "Shk",
						"locationName": "createVolumePermission"
					},
					"ProductCodes": {
						"shape": "Sbg",
						"locationName": "productCodes"
					},
					"SnapshotId": {
						"locationName": "snapshotId"
					}
				}
			}
		},
		"DescribeSnapshots": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"OwnerIds": {
						"shape": "Sb7",
						"locationName": "Owner"
					},
					"RestorableByUserIds": {
						"locationName": "RestorableBy",
						"type": "list",
						"member": {}
					},
					"SnapshotIds": {
						"locationName": "SnapshotId",
						"type": "list",
						"member": {
							"locationName": "SnapshotId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Snapshots": {
						"locationName": "snapshotSet",
						"type": "list",
						"member": {
							"shape": "S6w",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeSpotDatafeedSubscription": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SpotDatafeedSubscription": {
						"shape": "S70",
						"locationName": "spotDatafeedSubscription"
					}
				}
			}
		},
		"DescribeSpotFleetInstances": {
			"input": {
				"type": "structure",
				"required": [
					"SpotFleetRequestId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ActiveInstances",
					"SpotFleetRequestId"
				],
				"members": {
					"ActiveInstances": {
						"locationName": "activeInstanceSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"InstanceId": {
									"locationName": "instanceId"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"SpotInstanceRequestId": {
									"locationName": "spotInstanceRequestId"
								},
								"InstanceHealth": {
									"locationName": "instanceHealth"
								}
							}
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					}
				}
			}
		},
		"DescribeSpotFleetRequestHistory": {
			"input": {
				"type": "structure",
				"required": [
					"SpotFleetRequestId",
					"StartTime"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EventType": {
						"locationName": "eventType"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HistoryRecords",
					"LastEvaluatedTime",
					"SpotFleetRequestId",
					"StartTime"
				],
				"members": {
					"HistoryRecords": {
						"locationName": "historyRecordSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"EventInformation",
								"EventType",
								"Timestamp"
							],
							"members": {
								"EventInformation": {
									"locationName": "eventInformation",
									"type": "structure",
									"members": {
										"EventDescription": {
											"locationName": "eventDescription"
										},
										"EventSubType": {
											"locationName": "eventSubType"
										},
										"InstanceId": {
											"locationName": "instanceId"
										}
									}
								},
								"EventType": {
									"locationName": "eventType"
								},
								"Timestamp": {
									"locationName": "timestamp",
									"type": "timestamp"
								}
							}
						}
					},
					"LastEvaluatedTime": {
						"locationName": "lastEvaluatedTime",
						"type": "timestamp"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					}
				}
			}
		},
		"DescribeSpotFleetRequests": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestIds": {
						"shape": "S2z",
						"locationName": "spotFleetRequestId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"SpotFleetRequestConfigs"
				],
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotFleetRequestConfigs": {
						"locationName": "spotFleetRequestConfigSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"CreateTime",
								"SpotFleetRequestConfig",
								"SpotFleetRequestId",
								"SpotFleetRequestState"
							],
							"members": {
								"ActivityStatus": {
									"locationName": "activityStatus"
								},
								"CreateTime": {
									"locationName": "createTime",
									"type": "timestamp"
								},
								"SpotFleetRequestConfig": {
									"shape": "Si9",
									"locationName": "spotFleetRequestConfig"
								},
								"SpotFleetRequestId": {
									"locationName": "spotFleetRequestId"
								},
								"SpotFleetRequestState": {
									"locationName": "spotFleetRequestState"
								}
							}
						}
					}
				}
			}
		},
		"DescribeSpotInstanceRequests": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"SpotInstanceRequestIds": {
						"shape": "S39",
						"locationName": "SpotInstanceRequestId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SpotInstanceRequests": {
						"shape": "Sin",
						"locationName": "spotInstanceRequestSet"
					}
				}
			}
		},
		"DescribeSpotPriceHistory": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EndTime": {
						"locationName": "endTime",
						"type": "timestamp"
					},
					"InstanceTypes": {
						"locationName": "InstanceType",
						"type": "list",
						"member": {}
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"ProductDescriptions": {
						"locationName": "ProductDescription",
						"type": "list",
						"member": {}
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"SpotPriceHistory": {
						"locationName": "spotPriceHistorySet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"ProductDescription": {
									"locationName": "productDescription"
								},
								"SpotPrice": {
									"locationName": "spotPrice"
								},
								"Timestamp": {
									"locationName": "timestamp",
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeStaleSecurityGroups": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"VpcId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"StaleSecurityGroupSet": {
						"locationName": "staleSecurityGroupSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"GroupId"
							],
							"members": {
								"Description": {
									"locationName": "description"
								},
								"GroupId": {
									"locationName": "groupId"
								},
								"GroupName": {
									"locationName": "groupName"
								},
								"StaleIpPermissions": {
									"shape": "Sj4",
									"locationName": "staleIpPermissions"
								},
								"StaleIpPermissionsEgress": {
									"shape": "Sj4",
									"locationName": "staleIpPermissionsEgress"
								},
								"VpcId": {
									"locationName": "vpcId"
								}
							}
						}
					}
				}
			}
		},
		"DescribeSubnets": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"SubnetIds": {
						"locationName": "SubnetId",
						"type": "list",
						"member": {
							"locationName": "SubnetId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Subnets": {
						"locationName": "subnetSet",
						"type": "list",
						"member": {
							"shape": "S75",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeTags": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"Tags": {
						"locationName": "tagSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Key": {
									"locationName": "key"
								},
								"ResourceId": {
									"locationName": "resourceId"
								},
								"ResourceType": {
									"locationName": "resourceType"
								},
								"Value": {
									"locationName": "value"
								}
							}
						}
					}
				}
			}
		},
		"DescribeVolumeAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"Attribute": {},
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AutoEnableIO": {
						"shape": "Sdk",
						"locationName": "autoEnableIO"
					},
					"ProductCodes": {
						"shape": "Sbg",
						"locationName": "productCodes"
					},
					"VolumeId": {
						"locationName": "volumeId"
					}
				}
			}
		},
		"DescribeVolumeStatus": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"VolumeIds": {
						"shape": "Sjl",
						"locationName": "VolumeId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"VolumeStatuses": {
						"locationName": "volumeStatusSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Actions": {
									"locationName": "actionsSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Code": {
												"locationName": "code"
											},
											"Description": {
												"locationName": "description"
											},
											"EventId": {
												"locationName": "eventId"
											},
											"EventType": {
												"locationName": "eventType"
											}
										}
									}
								},
								"AvailabilityZone": {
									"locationName": "availabilityZone"
								},
								"Events": {
									"locationName": "eventsSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Description": {
												"locationName": "description"
											},
											"EventId": {
												"locationName": "eventId"
											},
											"EventType": {
												"locationName": "eventType"
											},
											"NotAfter": {
												"locationName": "notAfter",
												"type": "timestamp"
											},
											"NotBefore": {
												"locationName": "notBefore",
												"type": "timestamp"
											}
										}
									}
								},
								"VolumeId": {
									"locationName": "volumeId"
								},
								"VolumeStatus": {
									"locationName": "volumeStatus",
									"type": "structure",
									"members": {
										"Details": {
											"locationName": "details",
											"type": "list",
											"member": {
												"locationName": "item",
												"type": "structure",
												"members": {
													"Name": {
														"locationName": "name"
													},
													"Status": {
														"locationName": "status"
													}
												}
											}
										},
										"Status": {
											"locationName": "status"
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeVolumes": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"VolumeIds": {
						"shape": "Sjl",
						"locationName": "VolumeId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Volumes": {
						"locationName": "volumeSet",
						"type": "list",
						"member": {
							"shape": "S7e",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeVolumesModifications": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"VolumeIds": {
						"shape": "Sjl",
						"locationName": "VolumeId"
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumesModifications": {
						"locationName": "volumeModificationSet",
						"type": "list",
						"member": {
							"shape": "Sk4",
							"locationName": "item"
						}
					},
					"NextToken": {
						"locationName": "nextToken"
					}
				}
			}
		},
		"DescribeVpcAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"VpcId"
				],
				"members": {
					"Attribute": {},
					"VpcId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpcId": {
						"locationName": "vpcId"
					},
					"EnableDnsHostnames": {
						"shape": "Sdk",
						"locationName": "enableDnsHostnames"
					},
					"EnableDnsSupport": {
						"shape": "Sdk",
						"locationName": "enableDnsSupport"
					}
				}
			}
		},
		"DescribeVpcClassicLink": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcIds": {
						"shape": "Ska",
						"locationName": "VpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Vpcs": {
						"locationName": "vpcSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ClassicLinkEnabled": {
									"locationName": "classicLinkEnabled",
									"type": "boolean"
								},
								"Tags": {
									"shape": "Sj",
									"locationName": "tagSet"
								},
								"VpcId": {
									"locationName": "vpcId"
								}
							}
						}
					}
				}
			}
		},
		"DescribeVpcClassicLinkDnsSupport": {
			"input": {
				"type": "structure",
				"members": {
					"MaxResults": {
						"locationName": "maxResults",
						"type": "integer"
					},
					"NextToken": {
						"locationName": "nextToken"
					},
					"VpcIds": {
						"shape": "Ska"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"Vpcs": {
						"locationName": "vpcs",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ClassicLinkDnsSupported": {
									"locationName": "classicLinkDnsSupported",
									"type": "boolean"
								},
								"VpcId": {
									"locationName": "vpcId"
								}
							}
						}
					}
				}
			}
		},
		"DescribeVpcEndpointServices": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"ServiceNames": {
						"shape": "S2z",
						"locationName": "serviceNameSet"
					}
				}
			}
		},
		"DescribeVpcEndpoints": {
			"input": {
				"type": "structure",
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"VpcEndpointIds": {
						"shape": "S2z",
						"locationName": "VpcEndpointId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {
						"locationName": "nextToken"
					},
					"VpcEndpoints": {
						"locationName": "vpcEndpointSet",
						"type": "list",
						"member": {
							"shape": "S7l",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeVpcPeeringConnections": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcPeeringConnectionIds": {
						"shape": "S2z",
						"locationName": "VpcPeeringConnectionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpcPeeringConnections": {
						"locationName": "vpcPeeringConnectionSet",
						"type": "list",
						"member": {
							"shape": "Sb",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeVpcs": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"VpcIds": {
						"locationName": "VpcId",
						"type": "list",
						"member": {
							"locationName": "VpcId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Vpcs": {
						"locationName": "vpcSet",
						"type": "list",
						"member": {
							"shape": "S3q",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeVpnConnections": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"VpnConnectionIds": {
						"locationName": "VpnConnectionId",
						"type": "list",
						"member": {
							"locationName": "VpnConnectionId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpnConnections": {
						"locationName": "vpnConnectionSet",
						"type": "list",
						"member": {
							"shape": "S7s",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DescribeVpnGateways": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S9c",
						"locationName": "Filter"
					},
					"VpnGatewayIds": {
						"locationName": "VpnGatewayId",
						"type": "list",
						"member": {
							"locationName": "VpnGatewayId"
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VpnGateways": {
						"locationName": "vpnGatewaySet",
						"type": "list",
						"member": {
							"shape": "S84",
							"locationName": "item"
						}
					}
				}
			}
		},
		"DetachClassicLinkVpc": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"DetachInternetGateway": {
			"input": {
				"type": "structure",
				"required": [
					"InternetGatewayId",
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InternetGatewayId": {
						"locationName": "internetGatewayId"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"DetachNetworkInterface": {
			"input": {
				"type": "structure",
				"required": [
					"AttachmentId"
				],
				"members": {
					"AttachmentId": {
						"locationName": "attachmentId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Force": {
						"locationName": "force",
						"type": "boolean"
					}
				}
			}
		},
		"DetachVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"Device": {},
					"Force": {
						"type": "boolean"
					},
					"InstanceId": {},
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S1p"
			}
		},
		"DetachVpnGateway": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId",
					"VpnGatewayId"
				],
				"members": {
					"VpcId": {},
					"VpnGatewayId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DisableVgwRoutePropagation": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayId",
					"RouteTableId"
				],
				"members": {
					"GatewayId": {},
					"RouteTableId": {}
				}
			}
		},
		"DisableVpcClassicLink": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"DisableVpcClassicLinkDnsSupport": {
			"input": {
				"type": "structure",
				"members": {
					"VpcId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"DisassociateAddress": {
			"input": {
				"type": "structure",
				"members": {
					"AssociationId": {},
					"PublicIp": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DisassociateIamInstanceProfile": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId"
				],
				"members": {
					"AssociationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IamInstanceProfileAssociation": {
						"shape": "S13",
						"locationName": "iamInstanceProfileAssociation"
					}
				}
			}
		},
		"DisassociateRouteTable": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId"
				],
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"DisassociateSubnetCidrBlock": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId"
				],
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Ipv6CidrBlockAssociation": {
						"shape": "S1a",
						"locationName": "ipv6CidrBlockAssociation"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			}
		},
		"DisassociateVpcCidrBlock": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId"
				],
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Ipv6CidrBlockAssociation": {
						"shape": "S1f",
						"locationName": "ipv6CidrBlockAssociation"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"EnableVgwRoutePropagation": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayId",
					"RouteTableId"
				],
				"members": {
					"GatewayId": {},
					"RouteTableId": {}
				}
			}
		},
		"EnableVolumeIO": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VolumeId": {
						"locationName": "volumeId"
					}
				}
			}
		},
		"EnableVpcClassicLink": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"EnableVpcClassicLinkDnsSupport": {
			"input": {
				"type": "structure",
				"members": {
					"VpcId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"GetConsoleOutput": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceId": {
						"locationName": "instanceId"
					},
					"Output": {
						"locationName": "output"
					},
					"Timestamp": {
						"locationName": "timestamp",
						"type": "timestamp"
					}
				}
			}
		},
		"GetConsoleScreenshot": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"InstanceId": {},
					"WakeUp": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImageData": {
						"locationName": "imageData"
					},
					"InstanceId": {
						"locationName": "instanceId"
					}
				}
			}
		},
		"GetHostReservationPurchasePreview": {
			"input": {
				"type": "structure",
				"required": [
					"HostIdSet",
					"OfferingId"
				],
				"members": {
					"HostIdSet": {
						"shape": "Slw"
					},
					"OfferingId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CurrencyCode": {
						"locationName": "currencyCode"
					},
					"Purchase": {
						"shape": "Sly",
						"locationName": "purchase"
					},
					"TotalHourlyPrice": {
						"locationName": "totalHourlyPrice"
					},
					"TotalUpfrontPrice": {
						"locationName": "totalUpfrontPrice"
					}
				}
			}
		},
		"GetPasswordData": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceId": {
						"locationName": "instanceId"
					},
					"PasswordData": {
						"locationName": "passwordData"
					},
					"Timestamp": {
						"locationName": "timestamp",
						"type": "timestamp"
					}
				}
			}
		},
		"GetReservedInstancesExchangeQuote": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedInstanceIds"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"ReservedInstanceIds": {
						"shape": "S3",
						"locationName": "ReservedInstanceId"
					},
					"TargetConfigurations": {
						"shape": "S5",
						"locationName": "TargetConfiguration"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CurrencyCode": {
						"locationName": "currencyCode"
					},
					"IsValidExchange": {
						"locationName": "isValidExchange",
						"type": "boolean"
					},
					"OutputReservedInstancesWillExpireAt": {
						"locationName": "outputReservedInstancesWillExpireAt",
						"type": "timestamp"
					},
					"PaymentDue": {
						"locationName": "paymentDue"
					},
					"ReservedInstanceValueRollup": {
						"shape": "Sm4",
						"locationName": "reservedInstanceValueRollup"
					},
					"ReservedInstanceValueSet": {
						"locationName": "reservedInstanceValueSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ReservationValue": {
									"shape": "Sm4",
									"locationName": "reservationValue"
								},
								"ReservedInstanceId": {
									"locationName": "reservedInstanceId"
								}
							}
						}
					},
					"TargetConfigurationValueRollup": {
						"shape": "Sm4",
						"locationName": "targetConfigurationValueRollup"
					},
					"TargetConfigurationValueSet": {
						"locationName": "targetConfigurationValueSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ReservationValue": {
									"shape": "Sm4",
									"locationName": "reservationValue"
								},
								"TargetConfiguration": {
									"locationName": "targetConfiguration",
									"type": "structure",
									"members": {
										"InstanceCount": {
											"locationName": "instanceCount",
											"type": "integer"
										},
										"OfferingId": {
											"locationName": "offeringId"
										}
									}
								}
							}
						}
					},
					"ValidationFailureReason": {
						"locationName": "validationFailureReason"
					}
				}
			}
		},
		"ImportImage": {
			"input": {
				"type": "structure",
				"members": {
					"Architecture": {},
					"ClientData": {
						"shape": "Smb"
					},
					"ClientToken": {},
					"Description": {},
					"DiskContainers": {
						"locationName": "DiskContainer",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Description": {},
								"DeviceName": {},
								"Format": {},
								"SnapshotId": {},
								"Url": {},
								"UserBucket": {
									"shape": "Sme"
								}
							}
						}
					},
					"DryRun": {
						"type": "boolean"
					},
					"Hypervisor": {},
					"LicenseType": {},
					"Platform": {},
					"RoleName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Architecture": {
						"locationName": "architecture"
					},
					"Description": {
						"locationName": "description"
					},
					"Hypervisor": {
						"locationName": "hypervisor"
					},
					"ImageId": {
						"locationName": "imageId"
					},
					"ImportTaskId": {
						"locationName": "importTaskId"
					},
					"LicenseType": {
						"locationName": "licenseType"
					},
					"Platform": {
						"locationName": "platform"
					},
					"Progress": {
						"locationName": "progress"
					},
					"SnapshotDetails": {
						"shape": "Sd6",
						"locationName": "snapshotDetailSet"
					},
					"Status": {
						"locationName": "status"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					}
				}
			}
		},
		"ImportInstance": {
			"input": {
				"type": "structure",
				"required": [
					"Platform"
				],
				"members": {
					"Description": {
						"locationName": "description"
					},
					"DiskImages": {
						"locationName": "diskImage",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Description": {},
								"Image": {
									"shape": "Smj"
								},
								"Volume": {
									"shape": "Smk"
								}
							}
						}
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"LaunchSpecification": {
						"locationName": "launchSpecification",
						"type": "structure",
						"members": {
							"AdditionalInfo": {
								"locationName": "additionalInfo"
							},
							"Architecture": {
								"locationName": "architecture"
							},
							"GroupIds": {
								"shape": "S5n",
								"locationName": "GroupId"
							},
							"GroupNames": {
								"shape": "Smm",
								"locationName": "GroupName"
							},
							"InstanceInitiatedShutdownBehavior": {
								"locationName": "instanceInitiatedShutdownBehavior"
							},
							"InstanceType": {
								"locationName": "instanceType"
							},
							"Monitoring": {
								"locationName": "monitoring",
								"type": "boolean"
							},
							"Placement": {
								"shape": "Se9",
								"locationName": "placement"
							},
							"PrivateIpAddress": {
								"locationName": "privateIpAddress"
							},
							"SubnetId": {
								"locationName": "subnetId"
							},
							"UserData": {
								"locationName": "userData",
								"type": "structure",
								"members": {
									"Data": {
										"locationName": "data"
									}
								}
							}
						}
					},
					"Platform": {
						"locationName": "platform"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConversionTask": {
						"shape": "Sa4",
						"locationName": "conversionTask"
					}
				}
			}
		},
		"ImportKeyPair": {
			"input": {
				"type": "structure",
				"required": [
					"KeyName",
					"PublicKeyMaterial"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"KeyName": {
						"locationName": "keyName"
					},
					"PublicKeyMaterial": {
						"locationName": "publicKeyMaterial",
						"type": "blob"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyFingerprint": {
						"locationName": "keyFingerprint"
					},
					"KeyName": {
						"locationName": "keyName"
					}
				}
			}
		},
		"ImportSnapshot": {
			"input": {
				"type": "structure",
				"members": {
					"ClientData": {
						"shape": "Smb"
					},
					"ClientToken": {},
					"Description": {},
					"DiskContainer": {
						"type": "structure",
						"members": {
							"Description": {},
							"Format": {},
							"Url": {},
							"UserBucket": {
								"shape": "Sme"
							}
						}
					},
					"DryRun": {
						"type": "boolean"
					},
					"RoleName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Description": {
						"locationName": "description"
					},
					"ImportTaskId": {
						"locationName": "importTaskId"
					},
					"SnapshotTaskDetail": {
						"shape": "Sdd",
						"locationName": "snapshotTaskDetail"
					}
				}
			}
		},
		"ImportVolume": {
			"input": {
				"type": "structure",
				"required": [
					"AvailabilityZone",
					"Image",
					"Volume"
				],
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"Description": {
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Image": {
						"shape": "Smj",
						"locationName": "image"
					},
					"Volume": {
						"shape": "Smk",
						"locationName": "volume"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConversionTask": {
						"shape": "Sa4",
						"locationName": "conversionTask"
					}
				}
			}
		},
		"ModifyHosts": {
			"input": {
				"type": "structure",
				"required": [
					"AutoPlacement",
					"HostIds"
				],
				"members": {
					"AutoPlacement": {
						"locationName": "autoPlacement"
					},
					"HostIds": {
						"shape": "Sbw",
						"locationName": "hostId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Successful": {
						"shape": "Sr",
						"locationName": "successful"
					},
					"Unsuccessful": {
						"shape": "Smz",
						"locationName": "unsuccessful"
					}
				}
			}
		},
		"ModifyIdFormat": {
			"input": {
				"type": "structure",
				"required": [
					"Resource",
					"UseLongIds"
				],
				"members": {
					"Resource": {},
					"UseLongIds": {
						"type": "boolean"
					}
				}
			}
		},
		"ModifyIdentityIdFormat": {
			"input": {
				"type": "structure",
				"required": [
					"PrincipalArn",
					"Resource",
					"UseLongIds"
				],
				"members": {
					"PrincipalArn": {
						"locationName": "principalArn"
					},
					"Resource": {
						"locationName": "resource"
					},
					"UseLongIds": {
						"locationName": "useLongIds",
						"type": "boolean"
					}
				}
			}
		},
		"ModifyImageAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"ImageId"
				],
				"members": {
					"Attribute": {},
					"Description": {
						"shape": "S42"
					},
					"ImageId": {},
					"LaunchPermission": {
						"type": "structure",
						"members": {
							"Add": {
								"shape": "Scl"
							},
							"Remove": {
								"shape": "Scl"
							}
						}
					},
					"OperationType": {},
					"ProductCodes": {
						"locationName": "ProductCode",
						"type": "list",
						"member": {
							"locationName": "ProductCode"
						}
					},
					"UserGroups": {
						"locationName": "UserGroup",
						"type": "list",
						"member": {
							"locationName": "UserGroup"
						}
					},
					"UserIds": {
						"shape": "Sn7",
						"locationName": "UserId"
					},
					"Value": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"ModifyInstanceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"SourceDestCheck": {
						"shape": "Sdk"
					},
					"Attribute": {
						"locationName": "attribute"
					},
					"BlockDeviceMappings": {
						"locationName": "blockDeviceMapping",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"DeviceName": {
									"locationName": "deviceName"
								},
								"Ebs": {
									"locationName": "ebs",
									"type": "structure",
									"members": {
										"DeleteOnTermination": {
											"locationName": "deleteOnTermination",
											"type": "boolean"
										},
										"VolumeId": {
											"locationName": "volumeId"
										}
									}
								},
								"NoDevice": {
									"locationName": "noDevice"
								},
								"VirtualName": {
									"locationName": "virtualName"
								}
							}
						}
					},
					"DisableApiTermination": {
						"shape": "Sdk",
						"locationName": "disableApiTermination"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EbsOptimized": {
						"shape": "Sdk",
						"locationName": "ebsOptimized"
					},
					"EnaSupport": {
						"shape": "Sdk",
						"locationName": "enaSupport"
					},
					"Groups": {
						"shape": "S1j",
						"locationName": "GroupId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"InstanceInitiatedShutdownBehavior": {
						"shape": "S42",
						"locationName": "instanceInitiatedShutdownBehavior"
					},
					"InstanceType": {
						"shape": "S42",
						"locationName": "instanceType"
					},
					"Kernel": {
						"shape": "S42",
						"locationName": "kernel"
					},
					"Ramdisk": {
						"shape": "S42",
						"locationName": "ramdisk"
					},
					"SriovNetSupport": {
						"shape": "S42",
						"locationName": "sriovNetSupport"
					},
					"UserData": {
						"locationName": "userData",
						"type": "structure",
						"members": {
							"Value": {
								"locationName": "value",
								"type": "blob"
							}
						}
					},
					"Value": {
						"locationName": "value"
					}
				}
			}
		},
		"ModifyInstancePlacement": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"Affinity": {
						"locationName": "affinity"
					},
					"HostId": {
						"locationName": "hostId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"Tenancy": {
						"locationName": "tenancy"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"ModifyNetworkInterfaceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"Attachment": {
						"locationName": "attachment",
						"type": "structure",
						"members": {
							"AttachmentId": {
								"locationName": "attachmentId"
							},
							"DeleteOnTermination": {
								"locationName": "deleteOnTermination",
								"type": "boolean"
							}
						}
					},
					"Description": {
						"shape": "S42",
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Groups": {
						"shape": "S5n",
						"locationName": "SecurityGroupId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"SourceDestCheck": {
						"shape": "Sdk",
						"locationName": "sourceDestCheck"
					}
				}
			}
		},
		"ModifyReservedInstances": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedInstancesIds",
					"TargetConfigurations"
				],
				"members": {
					"ReservedInstancesIds": {
						"shape": "Sfu",
						"locationName": "ReservedInstancesId"
					},
					"ClientToken": {
						"locationName": "clientToken"
					},
					"TargetConfigurations": {
						"locationName": "ReservedInstancesConfigurationSetItemType",
						"type": "list",
						"member": {
							"shape": "Sgf",
							"locationName": "item"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesModificationId": {
						"locationName": "reservedInstancesModificationId"
					}
				}
			}
		},
		"ModifySnapshotAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotId"
				],
				"members": {
					"Attribute": {},
					"CreateVolumePermission": {
						"type": "structure",
						"members": {
							"Add": {
								"shape": "Shk"
							},
							"Remove": {
								"shape": "Shk"
							}
						}
					},
					"GroupNames": {
						"shape": "Shd",
						"locationName": "UserGroup"
					},
					"OperationType": {},
					"SnapshotId": {},
					"UserIds": {
						"shape": "Sn7",
						"locationName": "UserId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"ModifySpotFleetRequest": {
			"input": {
				"type": "structure",
				"required": [
					"SpotFleetRequestId"
				],
				"members": {
					"ExcessCapacityTerminationPolicy": {
						"locationName": "excessCapacityTerminationPolicy"
					},
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					},
					"TargetCapacity": {
						"locationName": "targetCapacity",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"ModifySubnetAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"SubnetId"
				],
				"members": {
					"AssignIpv6AddressOnCreation": {
						"shape": "Sdk"
					},
					"MapPublicIpOnLaunch": {
						"shape": "Sdk"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			}
		},
		"ModifyVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"DryRun": {
						"type": "boolean"
					},
					"VolumeId": {},
					"Size": {
						"type": "integer"
					},
					"VolumeType": {},
					"Iops": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumeModification": {
						"shape": "Sk4",
						"locationName": "volumeModification"
					}
				}
			}
		},
		"ModifyVolumeAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"AutoEnableIO": {
						"shape": "Sdk"
					},
					"VolumeId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"ModifyVpcAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"VpcId"
				],
				"members": {
					"EnableDnsHostnames": {
						"shape": "Sdk"
					},
					"EnableDnsSupport": {
						"shape": "Sdk"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"ModifyVpcEndpoint": {
			"input": {
				"type": "structure",
				"required": [
					"VpcEndpointId"
				],
				"members": {
					"AddRouteTableIds": {
						"shape": "S2z",
						"locationName": "AddRouteTableId"
					},
					"DryRun": {
						"type": "boolean"
					},
					"PolicyDocument": {},
					"RemoveRouteTableIds": {
						"shape": "S2z",
						"locationName": "RemoveRouteTableId"
					},
					"ResetPolicy": {
						"type": "boolean"
					},
					"VpcEndpointId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"ModifyVpcPeeringConnectionOptions": {
			"input": {
				"type": "structure",
				"required": [
					"VpcPeeringConnectionId"
				],
				"members": {
					"AccepterPeeringConnectionOptions": {
						"shape": "Sny"
					},
					"DryRun": {
						"type": "boolean"
					},
					"RequesterPeeringConnectionOptions": {
						"shape": "Sny"
					},
					"VpcPeeringConnectionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AccepterPeeringConnectionOptions": {
						"shape": "So0",
						"locationName": "accepterPeeringConnectionOptions"
					},
					"RequesterPeeringConnectionOptions": {
						"shape": "So0",
						"locationName": "requesterPeeringConnectionOptions"
					}
				}
			}
		},
		"MonitorInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "S9w",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceMonitorings": {
						"shape": "So3",
						"locationName": "instancesSet"
					}
				}
			}
		},
		"MoveAddressToVpc": {
			"input": {
				"type": "structure",
				"required": [
					"PublicIp"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"PublicIp": {
						"locationName": "publicIp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AllocationId": {
						"locationName": "allocationId"
					},
					"Status": {
						"locationName": "status"
					}
				}
			}
		},
		"PurchaseHostReservation": {
			"input": {
				"type": "structure",
				"required": [
					"HostIdSet",
					"OfferingId"
				],
				"members": {
					"ClientToken": {},
					"CurrencyCode": {},
					"HostIdSet": {
						"shape": "Slw"
					},
					"LimitPrice": {},
					"OfferingId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"CurrencyCode": {
						"locationName": "currencyCode"
					},
					"Purchase": {
						"shape": "Sly",
						"locationName": "purchase"
					},
					"TotalHourlyPrice": {
						"locationName": "totalHourlyPrice"
					},
					"TotalUpfrontPrice": {
						"locationName": "totalUpfrontPrice"
					}
				}
			}
		},
		"PurchaseReservedInstancesOffering": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceCount",
					"ReservedInstancesOfferingId"
				],
				"members": {
					"InstanceCount": {
						"type": "integer"
					},
					"ReservedInstancesOfferingId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"LimitPrice": {
						"locationName": "limitPrice",
						"type": "structure",
						"members": {
							"Amount": {
								"locationName": "amount",
								"type": "double"
							},
							"CurrencyCode": {
								"locationName": "currencyCode"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReservedInstancesId": {
						"locationName": "reservedInstancesId"
					}
				}
			}
		},
		"PurchaseScheduledInstances": {
			"input": {
				"type": "structure",
				"required": [
					"PurchaseRequests"
				],
				"members": {
					"ClientToken": {
						"idempotencyToken": true
					},
					"DryRun": {
						"type": "boolean"
					},
					"PurchaseRequests": {
						"locationName": "PurchaseRequest",
						"type": "list",
						"member": {
							"locationName": "PurchaseRequest",
							"type": "structure",
							"required": [
								"InstanceCount",
								"PurchaseToken"
							],
							"members": {
								"InstanceCount": {
									"type": "integer"
								},
								"PurchaseToken": {}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ScheduledInstanceSet": {
						"locationName": "scheduledInstanceSet",
						"type": "list",
						"member": {
							"shape": "Sh6",
							"locationName": "item"
						}
					}
				}
			}
		},
		"RebootInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "S9w",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"RegisterImage": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"ImageLocation": {},
					"Architecture": {
						"locationName": "architecture"
					},
					"BlockDeviceMappings": {
						"shape": "S4k",
						"locationName": "BlockDeviceMapping"
					},
					"Description": {
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EnaSupport": {
						"locationName": "enaSupport",
						"type": "boolean"
					},
					"KernelId": {
						"locationName": "kernelId"
					},
					"Name": {
						"locationName": "name"
					},
					"BillingProducts": {
						"locationName": "BillingProduct",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"RamdiskId": {
						"locationName": "ramdiskId"
					},
					"RootDeviceName": {
						"locationName": "rootDeviceName"
					},
					"SriovNetSupport": {
						"locationName": "sriovNetSupport"
					},
					"VirtualizationType": {
						"locationName": "virtualizationType"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ImageId": {
						"locationName": "imageId"
					}
				}
			}
		},
		"RejectVpcPeeringConnection": {
			"input": {
				"type": "structure",
				"required": [
					"VpcPeeringConnectionId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Return": {
						"locationName": "return",
						"type": "boolean"
					}
				}
			}
		},
		"ReleaseAddress": {
			"input": {
				"type": "structure",
				"members": {
					"AllocationId": {},
					"PublicIp": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"ReleaseHosts": {
			"input": {
				"type": "structure",
				"required": [
					"HostIds"
				],
				"members": {
					"HostIds": {
						"shape": "Sbw",
						"locationName": "hostId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Successful": {
						"shape": "Sr",
						"locationName": "successful"
					},
					"Unsuccessful": {
						"shape": "Smz",
						"locationName": "unsuccessful"
					}
				}
			}
		},
		"ReplaceIamInstanceProfileAssociation": {
			"input": {
				"type": "structure",
				"required": [
					"IamInstanceProfile",
					"AssociationId"
				],
				"members": {
					"IamInstanceProfile": {
						"shape": "S11"
					},
					"AssociationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IamInstanceProfileAssociation": {
						"shape": "S13",
						"locationName": "iamInstanceProfileAssociation"
					}
				}
			}
		},
		"ReplaceNetworkAclAssociation": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId",
					"NetworkAclId"
				],
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NewAssociationId": {
						"locationName": "newAssociationId"
					}
				}
			}
		},
		"ReplaceNetworkAclEntry": {
			"input": {
				"type": "structure",
				"required": [
					"Egress",
					"NetworkAclId",
					"Protocol",
					"RuleAction",
					"RuleNumber"
				],
				"members": {
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Egress": {
						"locationName": "egress",
						"type": "boolean"
					},
					"IcmpTypeCode": {
						"shape": "S5i",
						"locationName": "Icmp"
					},
					"Ipv6CidrBlock": {
						"locationName": "ipv6CidrBlock"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					},
					"PortRange": {
						"shape": "S5j",
						"locationName": "portRange"
					},
					"Protocol": {
						"locationName": "protocol"
					},
					"RuleAction": {
						"locationName": "ruleAction"
					},
					"RuleNumber": {
						"locationName": "ruleNumber",
						"type": "integer"
					}
				}
			}
		},
		"ReplaceRoute": {
			"input": {
				"type": "structure",
				"required": [
					"RouteTableId"
				],
				"members": {
					"DestinationCidrBlock": {
						"locationName": "destinationCidrBlock"
					},
					"DestinationIpv6CidrBlock": {
						"locationName": "destinationIpv6CidrBlock"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EgressOnlyInternetGatewayId": {
						"locationName": "egressOnlyInternetGatewayId"
					},
					"GatewayId": {
						"locationName": "gatewayId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"NatGatewayId": {
						"locationName": "natGatewayId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			}
		},
		"ReplaceRouteTableAssociation": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId",
					"RouteTableId"
				],
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NewAssociationId": {
						"locationName": "newAssociationId"
					}
				}
			}
		},
		"ReportInstanceStatus": {
			"input": {
				"type": "structure",
				"required": [
					"Instances",
					"ReasonCodes",
					"Status"
				],
				"members": {
					"Description": {
						"locationName": "description"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EndTime": {
						"locationName": "endTime",
						"type": "timestamp"
					},
					"Instances": {
						"shape": "S9w",
						"locationName": "instanceId"
					},
					"ReasonCodes": {
						"locationName": "reasonCode",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					},
					"Status": {
						"locationName": "status"
					}
				}
			}
		},
		"RequestSpotFleet": {
			"input": {
				"type": "structure",
				"required": [
					"SpotFleetRequestConfig"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"SpotFleetRequestConfig": {
						"shape": "Si9",
						"locationName": "spotFleetRequestConfig"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"SpotFleetRequestId"
				],
				"members": {
					"SpotFleetRequestId": {
						"locationName": "spotFleetRequestId"
					}
				}
			}
		},
		"RequestSpotInstances": {
			"input": {
				"type": "structure",
				"required": [
					"SpotPrice"
				],
				"members": {
					"AvailabilityZoneGroup": {
						"locationName": "availabilityZoneGroup"
					},
					"BlockDurationMinutes": {
						"locationName": "blockDurationMinutes",
						"type": "integer"
					},
					"ClientToken": {
						"locationName": "clientToken"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceCount": {
						"locationName": "instanceCount",
						"type": "integer"
					},
					"LaunchGroup": {
						"locationName": "launchGroup"
					},
					"LaunchSpecification": {
						"type": "structure",
						"members": {
							"SecurityGroupIds": {
								"shape": "S2z",
								"locationName": "SecurityGroupId"
							},
							"SecurityGroups": {
								"shape": "S2z",
								"locationName": "SecurityGroup"
							},
							"AddressingType": {
								"locationName": "addressingType"
							},
							"BlockDeviceMappings": {
								"shape": "Sck",
								"locationName": "blockDeviceMapping"
							},
							"EbsOptimized": {
								"locationName": "ebsOptimized",
								"type": "boolean"
							},
							"IamInstanceProfile": {
								"shape": "S11",
								"locationName": "iamInstanceProfile"
							},
							"ImageId": {
								"locationName": "imageId"
							},
							"InstanceType": {
								"locationName": "instanceType"
							},
							"KernelId": {
								"locationName": "kernelId"
							},
							"KeyName": {
								"locationName": "keyName"
							},
							"Monitoring": {
								"shape": "Siq",
								"locationName": "monitoring"
							},
							"NetworkInterfaces": {
								"shape": "Sif",
								"locationName": "NetworkInterface"
							},
							"Placement": {
								"shape": "Sih",
								"locationName": "placement"
							},
							"RamdiskId": {
								"locationName": "ramdiskId"
							},
							"SubnetId": {
								"locationName": "subnetId"
							},
							"UserData": {
								"locationName": "userData"
							}
						}
					},
					"SpotPrice": {
						"locationName": "spotPrice"
					},
					"Type": {
						"locationName": "type"
					},
					"ValidFrom": {
						"locationName": "validFrom",
						"type": "timestamp"
					},
					"ValidUntil": {
						"locationName": "validUntil",
						"type": "timestamp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SpotInstanceRequests": {
						"shape": "Sin",
						"locationName": "spotInstanceRequestSet"
					}
				}
			}
		},
		"ResetImageAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"ImageId"
				],
				"members": {
					"Attribute": {},
					"ImageId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"ResetInstanceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"InstanceId"
				],
				"members": {
					"Attribute": {
						"locationName": "attribute"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"InstanceId": {
						"locationName": "instanceId"
					}
				}
			}
		},
		"ResetNetworkInterfaceAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"SourceDestCheck": {
						"locationName": "sourceDestCheck"
					}
				}
			}
		},
		"ResetSnapshotAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"Attribute",
					"SnapshotId"
				],
				"members": {
					"Attribute": {},
					"SnapshotId": {},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"RestoreAddressToClassic": {
			"input": {
				"type": "structure",
				"required": [
					"PublicIp"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"PublicIp": {
						"locationName": "publicIp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PublicIp": {
						"locationName": "publicIp"
					},
					"Status": {
						"locationName": "status"
					}
				}
			}
		},
		"RevokeSecurityGroupEgress": {
			"input": {
				"type": "structure",
				"required": [
					"GroupId"
				],
				"members": {
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"GroupId": {
						"locationName": "groupId"
					},
					"IpPermissions": {
						"shape": "S1w",
						"locationName": "ipPermissions"
					},
					"CidrIp": {
						"locationName": "cidrIp"
					},
					"FromPort": {
						"locationName": "fromPort",
						"type": "integer"
					},
					"IpProtocol": {
						"locationName": "ipProtocol"
					},
					"ToPort": {
						"locationName": "toPort",
						"type": "integer"
					},
					"SourceSecurityGroupName": {
						"locationName": "sourceSecurityGroupName"
					},
					"SourceSecurityGroupOwnerId": {
						"locationName": "sourceSecurityGroupOwnerId"
					}
				}
			}
		},
		"RevokeSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"members": {
					"CidrIp": {},
					"FromPort": {
						"type": "integer"
					},
					"GroupId": {},
					"GroupName": {},
					"IpPermissions": {
						"shape": "S1w"
					},
					"IpProtocol": {},
					"SourceSecurityGroupName": {},
					"SourceSecurityGroupOwnerId": {},
					"ToPort": {
						"type": "integer"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			}
		},
		"RunInstances": {
			"input": {
				"type": "structure",
				"required": [
					"ImageId",
					"MaxCount",
					"MinCount"
				],
				"members": {
					"BlockDeviceMappings": {
						"shape": "S4k",
						"locationName": "BlockDeviceMapping"
					},
					"ImageId": {},
					"InstanceType": {},
					"Ipv6AddressCount": {
						"type": "integer"
					},
					"Ipv6Addresses": {
						"shape": "S5o",
						"locationName": "Ipv6Address"
					},
					"KernelId": {},
					"KeyName": {},
					"MaxCount": {
						"type": "integer"
					},
					"MinCount": {
						"type": "integer"
					},
					"Monitoring": {
						"shape": "Siq"
					},
					"Placement": {
						"shape": "Se9"
					},
					"RamdiskId": {},
					"SecurityGroupIds": {
						"shape": "S5n",
						"locationName": "SecurityGroupId"
					},
					"SecurityGroups": {
						"shape": "Smm",
						"locationName": "SecurityGroup"
					},
					"SubnetId": {},
					"UserData": {},
					"AdditionalInfo": {
						"locationName": "additionalInfo"
					},
					"ClientToken": {
						"locationName": "clientToken"
					},
					"DisableApiTermination": {
						"locationName": "disableApiTermination",
						"type": "boolean"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"EbsOptimized": {
						"locationName": "ebsOptimized",
						"type": "boolean"
					},
					"IamInstanceProfile": {
						"shape": "S11",
						"locationName": "iamInstanceProfile"
					},
					"InstanceInitiatedShutdownBehavior": {
						"locationName": "instanceInitiatedShutdownBehavior"
					},
					"NetworkInterfaces": {
						"shape": "Sif",
						"locationName": "networkInterface"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					},
					"ElasticGpuSpecification": {
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"Type"
							],
							"members": {
								"Type": {}
							}
						}
					},
					"TagSpecifications": {
						"shape": "S7b",
						"locationName": "TagSpecification"
					}
				}
			},
			"output": {
				"shape": "Se3"
			}
		},
		"RunScheduledInstances": {
			"input": {
				"type": "structure",
				"required": [
					"LaunchSpecification",
					"ScheduledInstanceId"
				],
				"members": {
					"ClientToken": {
						"idempotencyToken": true
					},
					"DryRun": {
						"type": "boolean"
					},
					"InstanceCount": {
						"type": "integer"
					},
					"LaunchSpecification": {
						"type": "structure",
						"required": [
							"ImageId"
						],
						"members": {
							"BlockDeviceMappings": {
								"locationName": "BlockDeviceMapping",
								"type": "list",
								"member": {
									"locationName": "BlockDeviceMapping",
									"type": "structure",
									"members": {
										"DeviceName": {},
										"Ebs": {
											"type": "structure",
											"members": {
												"DeleteOnTermination": {
													"type": "boolean"
												},
												"Encrypted": {
													"type": "boolean"
												},
												"Iops": {
													"type": "integer"
												},
												"SnapshotId": {},
												"VolumeSize": {
													"type": "integer"
												},
												"VolumeType": {}
											}
										},
										"NoDevice": {},
										"VirtualName": {}
									}
								}
							},
							"EbsOptimized": {
								"type": "boolean"
							},
							"IamInstanceProfile": {
								"type": "structure",
								"members": {
									"Arn": {},
									"Name": {}
								}
							},
							"ImageId": {},
							"InstanceType": {},
							"KernelId": {},
							"KeyName": {},
							"Monitoring": {
								"type": "structure",
								"members": {
									"Enabled": {
										"type": "boolean"
									}
								}
							},
							"NetworkInterfaces": {
								"locationName": "NetworkInterface",
								"type": "list",
								"member": {
									"locationName": "NetworkInterface",
									"type": "structure",
									"members": {
										"AssociatePublicIpAddress": {
											"type": "boolean"
										},
										"DeleteOnTermination": {
											"type": "boolean"
										},
										"Description": {},
										"DeviceIndex": {
											"type": "integer"
										},
										"Groups": {
											"shape": "Spt",
											"locationName": "Group"
										},
										"Ipv6AddressCount": {
											"type": "integer"
										},
										"Ipv6Addresses": {
											"locationName": "Ipv6Address",
											"type": "list",
											"member": {
												"locationName": "Ipv6Address",
												"type": "structure",
												"members": {
													"Ipv6Address": {}
												}
											}
										},
										"NetworkInterfaceId": {},
										"PrivateIpAddress": {},
										"PrivateIpAddressConfigs": {
											"locationName": "PrivateIpAddressConfig",
											"type": "list",
											"member": {
												"locationName": "PrivateIpAddressConfigSet",
												"type": "structure",
												"members": {
													"Primary": {
														"type": "boolean"
													},
													"PrivateIpAddress": {}
												}
											}
										},
										"SecondaryPrivateIpAddressCount": {
											"type": "integer"
										},
										"SubnetId": {}
									}
								}
							},
							"Placement": {
								"type": "structure",
								"members": {
									"AvailabilityZone": {},
									"GroupName": {}
								}
							},
							"RamdiskId": {},
							"SecurityGroupIds": {
								"shape": "Spt",
								"locationName": "SecurityGroupId"
							},
							"SubnetId": {},
							"UserData": {}
						}
					},
					"ScheduledInstanceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceIdSet": {
						"locationName": "instanceIdSet",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					}
				}
			}
		},
		"StartInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "S9w",
						"locationName": "InstanceId"
					},
					"AdditionalInfo": {
						"locationName": "additionalInfo"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StartingInstances": {
						"shape": "Sq4",
						"locationName": "instancesSet"
					}
				}
			}
		},
		"StopInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "S9w",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					},
					"Force": {
						"locationName": "force",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StoppingInstances": {
						"shape": "Sq4",
						"locationName": "instancesSet"
					}
				}
			}
		},
		"TerminateInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "S9w",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TerminatingInstances": {
						"shape": "Sq4",
						"locationName": "instancesSet"
					}
				}
			}
		},
		"UnassignIpv6Addresses": {
			"input": {
				"type": "structure",
				"required": [
					"Ipv6Addresses",
					"NetworkInterfaceId"
				],
				"members": {
					"Ipv6Addresses": {
						"shape": "St",
						"locationName": "ipv6Addresses"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"UnassignedIpv6Addresses": {
						"shape": "St",
						"locationName": "unassignedIpv6Addresses"
					}
				}
			}
		},
		"UnassignPrivateIpAddresses": {
			"input": {
				"type": "structure",
				"required": [
					"NetworkInterfaceId",
					"PrivateIpAddresses"
				],
				"members": {
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"PrivateIpAddresses": {
						"shape": "Sw",
						"locationName": "privateIpAddress"
					}
				}
			}
		},
		"UnmonitorInstances": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "S9w",
						"locationName": "InstanceId"
					},
					"DryRun": {
						"locationName": "dryRun",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceMonitorings": {
						"shape": "So3",
						"locationName": "instancesSet"
					}
				}
			}
		}
	},
	"shapes": {
		"S3": {
			"type": "list",
			"member": {
				"locationName": "ReservedInstanceId"
			}
		},
		"S5": {
			"type": "list",
			"member": {
				"locationName": "TargetConfigurationRequest",
				"type": "structure",
				"required": [
					"OfferingId"
				],
				"members": {
					"InstanceCount": {
						"type": "integer"
					},
					"OfferingId": {}
				}
			}
		},
		"Sb": {
			"type": "structure",
			"members": {
				"AccepterVpcInfo": {
					"shape": "Sc",
					"locationName": "accepterVpcInfo"
				},
				"ExpirationTime": {
					"locationName": "expirationTime",
					"type": "timestamp"
				},
				"RequesterVpcInfo": {
					"shape": "Sc",
					"locationName": "requesterVpcInfo"
				},
				"Status": {
					"locationName": "status",
					"type": "structure",
					"members": {
						"Code": {
							"locationName": "code"
						},
						"Message": {
							"locationName": "message"
						}
					}
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				},
				"VpcPeeringConnectionId": {
					"locationName": "vpcPeeringConnectionId"
				}
			}
		},
		"Sc": {
			"type": "structure",
			"members": {
				"CidrBlock": {
					"locationName": "cidrBlock"
				},
				"Ipv6CidrBlockSet": {
					"locationName": "ipv6CidrBlockSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"Ipv6CidrBlock": {
								"locationName": "ipv6CidrBlock"
							}
						}
					}
				},
				"OwnerId": {
					"locationName": "ownerId"
				},
				"PeeringOptions": {
					"locationName": "peeringOptions",
					"type": "structure",
					"members": {
						"AllowDnsResolutionFromRemoteVpc": {
							"locationName": "allowDnsResolutionFromRemoteVpc",
							"type": "boolean"
						},
						"AllowEgressFromLocalClassicLinkToRemoteVpc": {
							"locationName": "allowEgressFromLocalClassicLinkToRemoteVpc",
							"type": "boolean"
						},
						"AllowEgressFromLocalVpcToRemoteClassicLink": {
							"locationName": "allowEgressFromLocalVpcToRemoteClassicLink",
							"type": "boolean"
						}
					}
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"Sj": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Key": {
						"locationName": "key"
					},
					"Value": {
						"locationName": "value"
					}
				}
			}
		},
		"Sr": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"St": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"Sw": {
			"type": "list",
			"member": {
				"locationName": "PrivateIpAddress"
			}
		},
		"S11": {
			"type": "structure",
			"members": {
				"Arn": {
					"locationName": "arn"
				},
				"Name": {
					"locationName": "name"
				}
			}
		},
		"S13": {
			"type": "structure",
			"members": {
				"AssociationId": {
					"locationName": "associationId"
				},
				"InstanceId": {
					"locationName": "instanceId"
				},
				"IamInstanceProfile": {
					"shape": "S14",
					"locationName": "iamInstanceProfile"
				},
				"State": {
					"locationName": "state"
				},
				"Timestamp": {
					"locationName": "timestamp",
					"type": "timestamp"
				}
			}
		},
		"S14": {
			"type": "structure",
			"members": {
				"Arn": {
					"locationName": "arn"
				},
				"Id": {
					"locationName": "id"
				}
			}
		},
		"S1a": {
			"type": "structure",
			"members": {
				"AssociationId": {
					"locationName": "associationId"
				},
				"Ipv6CidrBlock": {
					"locationName": "ipv6CidrBlock"
				},
				"Ipv6CidrBlockState": {
					"locationName": "ipv6CidrBlockState",
					"type": "structure",
					"members": {
						"State": {
							"locationName": "state"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						}
					}
				}
			}
		},
		"S1f": {
			"type": "structure",
			"members": {
				"AssociationId": {
					"locationName": "associationId"
				},
				"Ipv6CidrBlock": {
					"locationName": "ipv6CidrBlock"
				},
				"Ipv6CidrBlockState": {
					"locationName": "ipv6CidrBlockState",
					"type": "structure",
					"members": {
						"State": {
							"locationName": "state"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						}
					}
				}
			}
		},
		"S1j": {
			"type": "list",
			"member": {
				"locationName": "groupId"
			}
		},
		"S1p": {
			"type": "structure",
			"members": {
				"AttachTime": {
					"locationName": "attachTime",
					"type": "timestamp"
				},
				"Device": {
					"locationName": "device"
				},
				"InstanceId": {
					"locationName": "instanceId"
				},
				"State": {
					"locationName": "status"
				},
				"VolumeId": {
					"locationName": "volumeId"
				},
				"DeleteOnTermination": {
					"locationName": "deleteOnTermination",
					"type": "boolean"
				}
			}
		},
		"S1t": {
			"type": "structure",
			"members": {
				"State": {
					"locationName": "state"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S1w": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"FromPort": {
						"locationName": "fromPort",
						"type": "integer"
					},
					"IpProtocol": {
						"locationName": "ipProtocol"
					},
					"IpRanges": {
						"locationName": "ipRanges",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"CidrIp": {
									"locationName": "cidrIp"
								}
							}
						}
					},
					"Ipv6Ranges": {
						"locationName": "ipv6Ranges",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"CidrIpv6": {
									"locationName": "cidrIpv6"
								}
							}
						}
					},
					"PrefixListIds": {
						"locationName": "prefixListIds",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"PrefixListId": {
									"locationName": "prefixListId"
								}
							}
						}
					},
					"ToPort": {
						"locationName": "toPort",
						"type": "integer"
					},
					"UserIdGroupPairs": {
						"locationName": "groups",
						"type": "list",
						"member": {
							"shape": "S25",
							"locationName": "item"
						}
					}
				}
			}
		},
		"S25": {
			"type": "structure",
			"members": {
				"GroupId": {
					"locationName": "groupId"
				},
				"GroupName": {
					"locationName": "groupName"
				},
				"PeeringStatus": {
					"locationName": "peeringStatus"
				},
				"UserId": {
					"locationName": "userId"
				},
				"VpcId": {
					"locationName": "vpcId"
				},
				"VpcPeeringConnectionId": {
					"locationName": "vpcPeeringConnectionId"
				}
			}
		},
		"S28": {
			"type": "structure",
			"members": {
				"S3": {
					"type": "structure",
					"members": {
						"AWSAccessKeyId": {},
						"Bucket": {
							"locationName": "bucket"
						},
						"Prefix": {
							"locationName": "prefix"
						},
						"UploadPolicy": {
							"locationName": "uploadPolicy",
							"type": "blob"
						},
						"UploadPolicySignature": {
							"locationName": "uploadPolicySignature"
						}
					}
				}
			}
		},
		"S2c": {
			"type": "structure",
			"members": {
				"BundleId": {
					"locationName": "bundleId"
				},
				"BundleTaskError": {
					"locationName": "error",
					"type": "structure",
					"members": {
						"Code": {
							"locationName": "code"
						},
						"Message": {
							"locationName": "message"
						}
					}
				},
				"InstanceId": {
					"locationName": "instanceId"
				},
				"Progress": {
					"locationName": "progress"
				},
				"StartTime": {
					"locationName": "startTime",
					"type": "timestamp"
				},
				"State": {
					"locationName": "state"
				},
				"Storage": {
					"shape": "S28",
					"locationName": "storage"
				},
				"UpdateTime": {
					"locationName": "updateTime",
					"type": "timestamp"
				}
			}
		},
		"S2n": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"CreateDate": {
						"locationName": "createDate",
						"type": "timestamp"
					},
					"InstanceCounts": {
						"locationName": "instanceCounts",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"InstanceCount": {
									"locationName": "instanceCount",
									"type": "integer"
								},
								"State": {
									"locationName": "state"
								}
							}
						}
					},
					"PriceSchedules": {
						"locationName": "priceSchedules",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Active": {
									"locationName": "active",
									"type": "boolean"
								},
								"CurrencyCode": {
									"locationName": "currencyCode"
								},
								"Price": {
									"locationName": "price",
									"type": "double"
								},
								"Term": {
									"locationName": "term",
									"type": "long"
								}
							}
						}
					},
					"ReservedInstancesId": {
						"locationName": "reservedInstancesId"
					},
					"ReservedInstancesListingId": {
						"locationName": "reservedInstancesListingId"
					},
					"Status": {
						"locationName": "status"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					},
					"UpdateDate": {
						"locationName": "updateDate",
						"type": "timestamp"
					}
				}
			}
		},
		"S2z": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"S39": {
			"type": "list",
			"member": {
				"locationName": "SpotInstanceRequestId"
			}
		},
		"S3n": {
			"type": "structure",
			"members": {
				"BgpAsn": {
					"locationName": "bgpAsn"
				},
				"CustomerGatewayId": {
					"locationName": "customerGatewayId"
				},
				"IpAddress": {
					"locationName": "ipAddress"
				},
				"State": {
					"locationName": "state"
				},
				"Type": {
					"locationName": "type"
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				}
			}
		},
		"S3q": {
			"type": "structure",
			"members": {
				"CidrBlock": {
					"locationName": "cidrBlock"
				},
				"DhcpOptionsId": {
					"locationName": "dhcpOptionsId"
				},
				"State": {
					"locationName": "state"
				},
				"VpcId": {
					"locationName": "vpcId"
				},
				"InstanceTenancy": {
					"locationName": "instanceTenancy"
				},
				"Ipv6CidrBlockAssociationSet": {
					"locationName": "ipv6CidrBlockAssociationSet",
					"type": "list",
					"member": {
						"shape": "S1f",
						"locationName": "item"
					}
				},
				"IsDefault": {
					"locationName": "isDefault",
					"type": "boolean"
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				}
			}
		},
		"S3y": {
			"type": "structure",
			"members": {
				"DhcpConfigurations": {
					"locationName": "dhcpConfigurationSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"Key": {
								"locationName": "key"
							},
							"Values": {
								"locationName": "valueSet",
								"type": "list",
								"member": {
									"shape": "S42",
									"locationName": "item"
								}
							}
						}
					}
				},
				"DhcpOptionsId": {
					"locationName": "dhcpOptionsId"
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				}
			}
		},
		"S42": {
			"type": "structure",
			"members": {
				"Value": {
					"locationName": "value"
				}
			}
		},
		"S45": {
			"type": "structure",
			"members": {
				"Attachments": {
					"shape": "S46",
					"locationName": "attachmentSet"
				},
				"EgressOnlyInternetGatewayId": {
					"locationName": "egressOnlyInternetGatewayId"
				}
			}
		},
		"S46": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"State": {
						"locationName": "state"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			}
		},
		"S4d": {
			"type": "list",
			"member": {
				"shape": "S4e",
				"locationName": "item"
			}
		},
		"S4e": {
			"type": "structure",
			"required": [
				"Error"
			],
			"members": {
				"Error": {
					"locationName": "error",
					"type": "structure",
					"required": [
						"Code",
						"Message"
					],
					"members": {
						"Code": {
							"locationName": "code"
						},
						"Message": {
							"locationName": "message"
						}
					}
				},
				"ResourceId": {
					"locationName": "resourceId"
				}
			}
		},
		"S4h": {
			"type": "structure",
			"members": {
				"Bucket": {},
				"Key": {}
			}
		},
		"S4k": {
			"type": "list",
			"member": {
				"shape": "S4l",
				"locationName": "BlockDeviceMapping"
			}
		},
		"S4l": {
			"type": "structure",
			"members": {
				"DeviceName": {
					"locationName": "deviceName"
				},
				"VirtualName": {
					"locationName": "virtualName"
				},
				"Ebs": {
					"locationName": "ebs",
					"type": "structure",
					"members": {
						"Encrypted": {
							"locationName": "encrypted",
							"type": "boolean"
						},
						"DeleteOnTermination": {
							"locationName": "deleteOnTermination",
							"type": "boolean"
						},
						"Iops": {
							"locationName": "iops",
							"type": "integer"
						},
						"SnapshotId": {
							"locationName": "snapshotId"
						},
						"VolumeSize": {
							"locationName": "volumeSize",
							"type": "integer"
						},
						"VolumeType": {
							"locationName": "volumeType"
						}
					}
				},
				"NoDevice": {
					"locationName": "noDevice"
				}
			}
		},
		"S4v": {
			"type": "structure",
			"members": {
				"Description": {
					"locationName": "description"
				},
				"ExportTaskId": {
					"locationName": "exportTaskId"
				},
				"ExportToS3Task": {
					"locationName": "exportToS3",
					"type": "structure",
					"members": {
						"ContainerFormat": {
							"locationName": "containerFormat"
						},
						"DiskImageFormat": {
							"locationName": "diskImageFormat"
						},
						"S3Bucket": {
							"locationName": "s3Bucket"
						},
						"S3Key": {
							"locationName": "s3Key"
						}
					}
				},
				"InstanceExportDetails": {
					"locationName": "instanceExport",
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"TargetEnvironment": {
							"locationName": "targetEnvironment"
						}
					}
				},
				"State": {
					"locationName": "state"
				},
				"StatusMessage": {
					"locationName": "statusMessage"
				}
			}
		},
		"S51": {
			"type": "structure",
			"members": {
				"Attachments": {
					"shape": "S46",
					"locationName": "attachmentSet"
				},
				"InternetGatewayId": {
					"locationName": "internetGatewayId"
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				}
			}
		},
		"S56": {
			"type": "structure",
			"members": {
				"CreateTime": {
					"locationName": "createTime",
					"type": "timestamp"
				},
				"DeleteTime": {
					"locationName": "deleteTime",
					"type": "timestamp"
				},
				"FailureCode": {
					"locationName": "failureCode"
				},
				"FailureMessage": {
					"locationName": "failureMessage"
				},
				"NatGatewayAddresses": {
					"locationName": "natGatewayAddressSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"AllocationId": {
								"locationName": "allocationId"
							},
							"NetworkInterfaceId": {
								"locationName": "networkInterfaceId"
							},
							"PrivateIp": {
								"locationName": "privateIp"
							},
							"PublicIp": {
								"locationName": "publicIp"
							}
						}
					}
				},
				"NatGatewayId": {
					"locationName": "natGatewayId"
				},
				"ProvisionedBandwidth": {
					"locationName": "provisionedBandwidth",
					"type": "structure",
					"members": {
						"ProvisionTime": {
							"locationName": "provisionTime",
							"type": "timestamp"
						},
						"Provisioned": {
							"locationName": "provisioned"
						},
						"RequestTime": {
							"locationName": "requestTime",
							"type": "timestamp"
						},
						"Requested": {
							"locationName": "requested"
						},
						"Status": {
							"locationName": "status"
						}
					}
				},
				"State": {
					"locationName": "state"
				},
				"SubnetId": {
					"locationName": "subnetId"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S5d": {
			"type": "structure",
			"members": {
				"Associations": {
					"locationName": "associationSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"NetworkAclAssociationId": {
								"locationName": "networkAclAssociationId"
							},
							"NetworkAclId": {
								"locationName": "networkAclId"
							},
							"SubnetId": {
								"locationName": "subnetId"
							}
						}
					}
				},
				"Entries": {
					"locationName": "entrySet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"CidrBlock": {
								"locationName": "cidrBlock"
							},
							"Egress": {
								"locationName": "egress",
								"type": "boolean"
							},
							"IcmpTypeCode": {
								"shape": "S5i",
								"locationName": "icmpTypeCode"
							},
							"Ipv6CidrBlock": {
								"locationName": "ipv6CidrBlock"
							},
							"PortRange": {
								"shape": "S5j",
								"locationName": "portRange"
							},
							"Protocol": {
								"locationName": "protocol"
							},
							"RuleAction": {
								"locationName": "ruleAction"
							},
							"RuleNumber": {
								"locationName": "ruleNumber",
								"type": "integer"
							}
						}
					}
				},
				"IsDefault": {
					"locationName": "default",
					"type": "boolean"
				},
				"NetworkAclId": {
					"locationName": "networkAclId"
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S5i": {
			"type": "structure",
			"members": {
				"Code": {
					"locationName": "code",
					"type": "integer"
				},
				"Type": {
					"locationName": "type",
					"type": "integer"
				}
			}
		},
		"S5j": {
			"type": "structure",
			"members": {
				"From": {
					"locationName": "from",
					"type": "integer"
				},
				"To": {
					"locationName": "to",
					"type": "integer"
				}
			}
		},
		"S5n": {
			"type": "list",
			"member": {
				"locationName": "SecurityGroupId"
			}
		},
		"S5o": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Ipv6Address": {
						"locationName": "ipv6Address"
					}
				}
			}
		},
		"S5q": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"required": [
					"PrivateIpAddress"
				],
				"members": {
					"Primary": {
						"locationName": "primary",
						"type": "boolean"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					}
				}
			}
		},
		"S5t": {
			"type": "structure",
			"members": {
				"Association": {
					"shape": "S5u",
					"locationName": "association"
				},
				"Attachment": {
					"shape": "S5v",
					"locationName": "attachment"
				},
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"Description": {
					"locationName": "description"
				},
				"Groups": {
					"shape": "S5w",
					"locationName": "groupSet"
				},
				"InterfaceType": {
					"locationName": "interfaceType"
				},
				"Ipv6Addresses": {
					"locationName": "ipv6AddressesSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"Ipv6Address": {
								"locationName": "ipv6Address"
							}
						}
					}
				},
				"MacAddress": {
					"locationName": "macAddress"
				},
				"NetworkInterfaceId": {
					"locationName": "networkInterfaceId"
				},
				"OwnerId": {
					"locationName": "ownerId"
				},
				"PrivateDnsName": {
					"locationName": "privateDnsName"
				},
				"PrivateIpAddress": {
					"locationName": "privateIpAddress"
				},
				"PrivateIpAddresses": {
					"locationName": "privateIpAddressesSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"Association": {
								"shape": "S5u",
								"locationName": "association"
							},
							"Primary": {
								"locationName": "primary",
								"type": "boolean"
							},
							"PrivateDnsName": {
								"locationName": "privateDnsName"
							},
							"PrivateIpAddress": {
								"locationName": "privateIpAddress"
							}
						}
					}
				},
				"RequesterId": {
					"locationName": "requesterId"
				},
				"RequesterManaged": {
					"locationName": "requesterManaged",
					"type": "boolean"
				},
				"SourceDestCheck": {
					"locationName": "sourceDestCheck",
					"type": "boolean"
				},
				"Status": {
					"locationName": "status"
				},
				"SubnetId": {
					"locationName": "subnetId"
				},
				"TagSet": {
					"shape": "Sj",
					"locationName": "tagSet"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S5u": {
			"type": "structure",
			"members": {
				"AllocationId": {
					"locationName": "allocationId"
				},
				"AssociationId": {
					"locationName": "associationId"
				},
				"IpOwnerId": {
					"locationName": "ipOwnerId"
				},
				"PublicDnsName": {
					"locationName": "publicDnsName"
				},
				"PublicIp": {
					"locationName": "publicIp"
				}
			}
		},
		"S5v": {
			"type": "structure",
			"members": {
				"AttachTime": {
					"locationName": "attachTime",
					"type": "timestamp"
				},
				"AttachmentId": {
					"locationName": "attachmentId"
				},
				"DeleteOnTermination": {
					"locationName": "deleteOnTermination",
					"type": "boolean"
				},
				"DeviceIndex": {
					"locationName": "deviceIndex",
					"type": "integer"
				},
				"InstanceId": {
					"locationName": "instanceId"
				},
				"InstanceOwnerId": {
					"locationName": "instanceOwnerId"
				},
				"Status": {
					"locationName": "status"
				}
			}
		},
		"S5w": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"GroupName": {
						"locationName": "groupName"
					},
					"GroupId": {
						"locationName": "groupId"
					}
				}
			}
		},
		"S67": {
			"type": "structure",
			"members": {
				"NetworkInterfacePermissionId": {
					"locationName": "networkInterfacePermissionId"
				},
				"NetworkInterfaceId": {
					"locationName": "networkInterfaceId"
				},
				"AwsAccountId": {
					"locationName": "awsAccountId"
				},
				"AwsService": {
					"locationName": "awsService"
				},
				"Permission": {
					"locationName": "permission"
				},
				"PermissionState": {
					"locationName": "permissionState",
					"type": "structure",
					"members": {
						"State": {
							"locationName": "state"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						}
					}
				}
			}
		},
		"S6k": {
			"type": "structure",
			"members": {
				"Associations": {
					"locationName": "associationSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"Main": {
								"locationName": "main",
								"type": "boolean"
							},
							"RouteTableAssociationId": {
								"locationName": "routeTableAssociationId"
							},
							"RouteTableId": {
								"locationName": "routeTableId"
							},
							"SubnetId": {
								"locationName": "subnetId"
							}
						}
					}
				},
				"PropagatingVgws": {
					"locationName": "propagatingVgwSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"GatewayId": {
								"locationName": "gatewayId"
							}
						}
					}
				},
				"RouteTableId": {
					"locationName": "routeTableId"
				},
				"Routes": {
					"locationName": "routeSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"DestinationCidrBlock": {
								"locationName": "destinationCidrBlock"
							},
							"DestinationIpv6CidrBlock": {
								"locationName": "destinationIpv6CidrBlock"
							},
							"DestinationPrefixListId": {
								"locationName": "destinationPrefixListId"
							},
							"EgressOnlyInternetGatewayId": {
								"locationName": "egressOnlyInternetGatewayId"
							},
							"GatewayId": {
								"locationName": "gatewayId"
							},
							"InstanceId": {
								"locationName": "instanceId"
							},
							"InstanceOwnerId": {
								"locationName": "instanceOwnerId"
							},
							"NatGatewayId": {
								"locationName": "natGatewayId"
							},
							"NetworkInterfaceId": {
								"locationName": "networkInterfaceId"
							},
							"Origin": {
								"locationName": "origin"
							},
							"State": {
								"locationName": "state"
							},
							"VpcPeeringConnectionId": {
								"locationName": "vpcPeeringConnectionId"
							}
						}
					}
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S6w": {
			"type": "structure",
			"members": {
				"DataEncryptionKeyId": {
					"locationName": "dataEncryptionKeyId"
				},
				"Description": {
					"locationName": "description"
				},
				"Encrypted": {
					"locationName": "encrypted",
					"type": "boolean"
				},
				"KmsKeyId": {
					"locationName": "kmsKeyId"
				},
				"OwnerId": {
					"locationName": "ownerId"
				},
				"Progress": {
					"locationName": "progress"
				},
				"SnapshotId": {
					"locationName": "snapshotId"
				},
				"StartTime": {
					"locationName": "startTime",
					"type": "timestamp"
				},
				"State": {
					"locationName": "status"
				},
				"StateMessage": {
					"locationName": "statusMessage"
				},
				"VolumeId": {
					"locationName": "volumeId"
				},
				"VolumeSize": {
					"locationName": "volumeSize",
					"type": "integer"
				},
				"OwnerAlias": {
					"locationName": "ownerAlias"
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				}
			}
		},
		"S70": {
			"type": "structure",
			"members": {
				"Bucket": {
					"locationName": "bucket"
				},
				"Fault": {
					"shape": "S71",
					"locationName": "fault"
				},
				"OwnerId": {
					"locationName": "ownerId"
				},
				"Prefix": {
					"locationName": "prefix"
				},
				"State": {
					"locationName": "state"
				}
			}
		},
		"S71": {
			"type": "structure",
			"members": {
				"Code": {
					"locationName": "code"
				},
				"Message": {
					"locationName": "message"
				}
			}
		},
		"S75": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"AvailableIpAddressCount": {
					"locationName": "availableIpAddressCount",
					"type": "integer"
				},
				"CidrBlock": {
					"locationName": "cidrBlock"
				},
				"DefaultForAz": {
					"locationName": "defaultForAz",
					"type": "boolean"
				},
				"MapPublicIpOnLaunch": {
					"locationName": "mapPublicIpOnLaunch",
					"type": "boolean"
				},
				"State": {
					"locationName": "state"
				},
				"SubnetId": {
					"locationName": "subnetId"
				},
				"VpcId": {
					"locationName": "vpcId"
				},
				"AssignIpv6AddressOnCreation": {
					"locationName": "assignIpv6AddressOnCreation",
					"type": "boolean"
				},
				"Ipv6CidrBlockAssociationSet": {
					"locationName": "ipv6CidrBlockAssociationSet",
					"type": "list",
					"member": {
						"shape": "S1a",
						"locationName": "item"
					}
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				}
			}
		},
		"S79": {
			"type": "list",
			"member": {}
		},
		"S7b": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"ResourceType": {
						"locationName": "resourceType"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "Tag"
					}
				}
			}
		},
		"S7e": {
			"type": "structure",
			"members": {
				"Attachments": {
					"locationName": "attachmentSet",
					"type": "list",
					"member": {
						"shape": "S1p",
						"locationName": "item"
					}
				},
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"CreateTime": {
					"locationName": "createTime",
					"type": "timestamp"
				},
				"Encrypted": {
					"locationName": "encrypted",
					"type": "boolean"
				},
				"KmsKeyId": {
					"locationName": "kmsKeyId"
				},
				"Size": {
					"locationName": "size",
					"type": "integer"
				},
				"SnapshotId": {
					"locationName": "snapshotId"
				},
				"State": {
					"locationName": "status"
				},
				"VolumeId": {
					"locationName": "volumeId"
				},
				"Iops": {
					"locationName": "iops",
					"type": "integer"
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				},
				"VolumeType": {
					"locationName": "volumeType"
				}
			}
		},
		"S7l": {
			"type": "structure",
			"members": {
				"CreationTimestamp": {
					"locationName": "creationTimestamp",
					"type": "timestamp"
				},
				"PolicyDocument": {
					"locationName": "policyDocument"
				},
				"RouteTableIds": {
					"shape": "S2z",
					"locationName": "routeTableIdSet"
				},
				"ServiceName": {
					"locationName": "serviceName"
				},
				"State": {
					"locationName": "state"
				},
				"VpcEndpointId": {
					"locationName": "vpcEndpointId"
				},
				"VpcId": {
					"locationName": "vpcId"
				}
			}
		},
		"S7s": {
			"type": "structure",
			"members": {
				"CustomerGatewayConfiguration": {
					"locationName": "customerGatewayConfiguration"
				},
				"CustomerGatewayId": {
					"locationName": "customerGatewayId"
				},
				"State": {
					"locationName": "state"
				},
				"Type": {
					"locationName": "type"
				},
				"VpnConnectionId": {
					"locationName": "vpnConnectionId"
				},
				"VpnGatewayId": {
					"locationName": "vpnGatewayId"
				},
				"Options": {
					"locationName": "options",
					"type": "structure",
					"members": {
						"StaticRoutesOnly": {
							"locationName": "staticRoutesOnly",
							"type": "boolean"
						}
					}
				},
				"Routes": {
					"locationName": "routes",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"DestinationCidrBlock": {
								"locationName": "destinationCidrBlock"
							},
							"Source": {
								"locationName": "source"
							},
							"State": {
								"locationName": "state"
							}
						}
					}
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				},
				"VgwTelemetry": {
					"locationName": "vgwTelemetry",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"AcceptedRouteCount": {
								"locationName": "acceptedRouteCount",
								"type": "integer"
							},
							"LastStatusChange": {
								"locationName": "lastStatusChange",
								"type": "timestamp"
							},
							"OutsideIpAddress": {
								"locationName": "outsideIpAddress"
							},
							"Status": {
								"locationName": "status"
							},
							"StatusMessage": {
								"locationName": "statusMessage"
							}
						}
					}
				}
			}
		},
		"S84": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"State": {
					"locationName": "state"
				},
				"Type": {
					"locationName": "type"
				},
				"VpcAttachments": {
					"locationName": "attachments",
					"type": "list",
					"member": {
						"shape": "S1t",
						"locationName": "item"
					}
				},
				"VpnGatewayId": {
					"locationName": "vpnGatewayId"
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				}
			}
		},
		"S9c": {
			"type": "list",
			"member": {
				"locationName": "Filter",
				"type": "structure",
				"members": {
					"Name": {},
					"Values": {
						"shape": "S2z",
						"locationName": "Value"
					}
				}
			}
		},
		"S9w": {
			"type": "list",
			"member": {
				"locationName": "InstanceId"
			}
		},
		"Sa4": {
			"type": "structure",
			"required": [
				"ConversionTaskId",
				"State"
			],
			"members": {
				"ConversionTaskId": {
					"locationName": "conversionTaskId"
				},
				"ExpirationTime": {
					"locationName": "expirationTime"
				},
				"ImportInstance": {
					"locationName": "importInstance",
					"type": "structure",
					"required": [
						"Volumes"
					],
					"members": {
						"Description": {
							"locationName": "description"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Platform": {
							"locationName": "platform"
						},
						"Volumes": {
							"locationName": "volumes",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"required": [
									"AvailabilityZone",
									"BytesConverted",
									"Image",
									"Status",
									"Volume"
								],
								"members": {
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"BytesConverted": {
										"locationName": "bytesConverted",
										"type": "long"
									},
									"Description": {
										"locationName": "description"
									},
									"Image": {
										"shape": "Sa9",
										"locationName": "image"
									},
									"Status": {
										"locationName": "status"
									},
									"StatusMessage": {
										"locationName": "statusMessage"
									},
									"Volume": {
										"shape": "Saa",
										"locationName": "volume"
									}
								}
							}
						}
					}
				},
				"ImportVolume": {
					"locationName": "importVolume",
					"type": "structure",
					"required": [
						"AvailabilityZone",
						"BytesConverted",
						"Image",
						"Volume"
					],
					"members": {
						"AvailabilityZone": {
							"locationName": "availabilityZone"
						},
						"BytesConverted": {
							"locationName": "bytesConverted",
							"type": "long"
						},
						"Description": {
							"locationName": "description"
						},
						"Image": {
							"shape": "Sa9",
							"locationName": "image"
						},
						"Volume": {
							"shape": "Saa",
							"locationName": "volume"
						}
					}
				},
				"State": {
					"locationName": "state"
				},
				"StatusMessage": {
					"locationName": "statusMessage"
				},
				"Tags": {
					"shape": "Sj",
					"locationName": "tagSet"
				}
			}
		},
		"Sa9": {
			"type": "structure",
			"required": [
				"Format",
				"ImportManifestUrl",
				"Size"
			],
			"members": {
				"Checksum": {
					"locationName": "checksum"
				},
				"Format": {
					"locationName": "format"
				},
				"ImportManifestUrl": {
					"locationName": "importManifestUrl"
				},
				"Size": {
					"locationName": "size",
					"type": "long"
				}
			}
		},
		"Saa": {
			"type": "structure",
			"required": [
				"Id"
			],
			"members": {
				"Id": {
					"locationName": "id"
				},
				"Size": {
					"locationName": "size",
					"type": "long"
				}
			}
		},
		"Sb7": {
			"type": "list",
			"member": {
				"locationName": "Owner"
			}
		},
		"Sbg": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"ProductCodeId": {
						"locationName": "productCode"
					},
					"ProductCodeType": {
						"locationName": "type"
					}
				}
			}
		},
		"Sbt": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"Sbw": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"Scd": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Deadline": {
						"locationName": "deadline",
						"type": "timestamp"
					},
					"Resource": {
						"locationName": "resource"
					},
					"UseLongIds": {
						"locationName": "useLongIds",
						"type": "boolean"
					}
				}
			}
		},
		"Sck": {
			"type": "list",
			"member": {
				"shape": "S4l",
				"locationName": "item"
			}
		},
		"Scl": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Group": {
						"locationName": "group"
					},
					"UserId": {
						"locationName": "userId"
					}
				}
			}
		},
		"Scz": {
			"type": "structure",
			"members": {
				"Code": {
					"locationName": "code"
				},
				"Message": {
					"locationName": "message"
				}
			}
		},
		"Sd2": {
			"type": "list",
			"member": {
				"locationName": "ImportTaskId"
			}
		},
		"Sd6": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Description": {
						"locationName": "description"
					},
					"DeviceName": {
						"locationName": "deviceName"
					},
					"DiskImageSize": {
						"locationName": "diskImageSize",
						"type": "double"
					},
					"Format": {
						"locationName": "format"
					},
					"Progress": {
						"locationName": "progress"
					},
					"SnapshotId": {
						"locationName": "snapshotId"
					},
					"Status": {
						"locationName": "status"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"Url": {
						"locationName": "url"
					},
					"UserBucket": {
						"shape": "Sd8",
						"locationName": "userBucket"
					}
				}
			}
		},
		"Sd8": {
			"type": "structure",
			"members": {
				"S3Bucket": {
					"locationName": "s3Bucket"
				},
				"S3Key": {
					"locationName": "s3Key"
				}
			}
		},
		"Sdd": {
			"type": "structure",
			"members": {
				"Description": {
					"locationName": "description"
				},
				"DiskImageSize": {
					"locationName": "diskImageSize",
					"type": "double"
				},
				"Format": {
					"locationName": "format"
				},
				"Progress": {
					"locationName": "progress"
				},
				"SnapshotId": {
					"locationName": "snapshotId"
				},
				"Status": {
					"locationName": "status"
				},
				"StatusMessage": {
					"locationName": "statusMessage"
				},
				"Url": {
					"locationName": "url"
				},
				"UserBucket": {
					"shape": "Sd8",
					"locationName": "userBucket"
				}
			}
		},
		"Sdh": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"DeviceName": {
						"locationName": "deviceName"
					},
					"Ebs": {
						"locationName": "ebs",
						"type": "structure",
						"members": {
							"AttachTime": {
								"locationName": "attachTime",
								"type": "timestamp"
							},
							"DeleteOnTermination": {
								"locationName": "deleteOnTermination",
								"type": "boolean"
							},
							"Status": {
								"locationName": "status"
							},
							"VolumeId": {
								"locationName": "volumeId"
							}
						}
					}
				}
			}
		},
		"Sdk": {
			"type": "structure",
			"members": {
				"Value": {
					"locationName": "value",
					"type": "boolean"
				}
			}
		},
		"Sds": {
			"type": "structure",
			"members": {
				"Code": {
					"locationName": "code",
					"type": "integer"
				},
				"Name": {
					"locationName": "name"
				}
			}
		},
		"Sdu": {
			"type": "structure",
			"members": {
				"Details": {
					"locationName": "details",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"ImpairedSince": {
								"locationName": "impairedSince",
								"type": "timestamp"
							},
							"Name": {
								"locationName": "name"
							},
							"Status": {
								"locationName": "status"
							}
						}
					}
				},
				"Status": {
					"locationName": "status"
				}
			}
		},
		"Se3": {
			"type": "structure",
			"members": {
				"Groups": {
					"shape": "S5w",
					"locationName": "groupSet"
				},
				"Instances": {
					"locationName": "instancesSet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"AmiLaunchIndex": {
								"locationName": "amiLaunchIndex",
								"type": "integer"
							},
							"ImageId": {
								"locationName": "imageId"
							},
							"InstanceId": {
								"locationName": "instanceId"
							},
							"InstanceType": {
								"locationName": "instanceType"
							},
							"KernelId": {
								"locationName": "kernelId"
							},
							"KeyName": {
								"locationName": "keyName"
							},
							"LaunchTime": {
								"locationName": "launchTime",
								"type": "timestamp"
							},
							"Monitoring": {
								"shape": "Se7",
								"locationName": "monitoring"
							},
							"Placement": {
								"shape": "Se9",
								"locationName": "placement"
							},
							"Platform": {
								"locationName": "platform"
							},
							"PrivateDnsName": {
								"locationName": "privateDnsName"
							},
							"PrivateIpAddress": {
								"locationName": "privateIpAddress"
							},
							"ProductCodes": {
								"shape": "Sbg",
								"locationName": "productCodes"
							},
							"PublicDnsName": {
								"locationName": "dnsName"
							},
							"PublicIpAddress": {
								"locationName": "ipAddress"
							},
							"RamdiskId": {
								"locationName": "ramdiskId"
							},
							"State": {
								"shape": "Sds",
								"locationName": "instanceState"
							},
							"StateTransitionReason": {
								"locationName": "reason"
							},
							"SubnetId": {
								"locationName": "subnetId"
							},
							"VpcId": {
								"locationName": "vpcId"
							},
							"Architecture": {
								"locationName": "architecture"
							},
							"BlockDeviceMappings": {
								"shape": "Sdh",
								"locationName": "blockDeviceMapping"
							},
							"ClientToken": {
								"locationName": "clientToken"
							},
							"EbsOptimized": {
								"locationName": "ebsOptimized",
								"type": "boolean"
							},
							"EnaSupport": {
								"locationName": "enaSupport",
								"type": "boolean"
							},
							"Hypervisor": {
								"locationName": "hypervisor"
							},
							"IamInstanceProfile": {
								"shape": "S14",
								"locationName": "iamInstanceProfile"
							},
							"InstanceLifecycle": {
								"locationName": "instanceLifecycle"
							},
							"ElasticGpuAssociations": {
								"locationName": "elasticGpuAssociationSet",
								"type": "list",
								"member": {
									"locationName": "item",
									"type": "structure",
									"members": {
										"ElasticGpuId": {
											"locationName": "elasticGpuId"
										},
										"ElasticGpuAssociationId": {
											"locationName": "elasticGpuAssociationId"
										},
										"ElasticGpuAssociationState": {
											"locationName": "elasticGpuAssociationState"
										},
										"ElasticGpuAssociationTime": {
											"locationName": "elasticGpuAssociationTime"
										}
									}
								}
							},
							"NetworkInterfaces": {
								"locationName": "networkInterfaceSet",
								"type": "list",
								"member": {
									"locationName": "item",
									"type": "structure",
									"members": {
										"Association": {
											"shape": "Sef",
											"locationName": "association"
										},
										"Attachment": {
											"locationName": "attachment",
											"type": "structure",
											"members": {
												"AttachTime": {
													"locationName": "attachTime",
													"type": "timestamp"
												},
												"AttachmentId": {
													"locationName": "attachmentId"
												},
												"DeleteOnTermination": {
													"locationName": "deleteOnTermination",
													"type": "boolean"
												},
												"DeviceIndex": {
													"locationName": "deviceIndex",
													"type": "integer"
												},
												"Status": {
													"locationName": "status"
												}
											}
										},
										"Description": {
											"locationName": "description"
										},
										"Groups": {
											"shape": "S5w",
											"locationName": "groupSet"
										},
										"Ipv6Addresses": {
											"shape": "S5o",
											"locationName": "ipv6AddressesSet"
										},
										"MacAddress": {
											"locationName": "macAddress"
										},
										"NetworkInterfaceId": {
											"locationName": "networkInterfaceId"
										},
										"OwnerId": {
											"locationName": "ownerId"
										},
										"PrivateDnsName": {
											"locationName": "privateDnsName"
										},
										"PrivateIpAddress": {
											"locationName": "privateIpAddress"
										},
										"PrivateIpAddresses": {
											"locationName": "privateIpAddressesSet",
											"type": "list",
											"member": {
												"locationName": "item",
												"type": "structure",
												"members": {
													"Association": {
														"shape": "Sef",
														"locationName": "association"
													},
													"Primary": {
														"locationName": "primary",
														"type": "boolean"
													},
													"PrivateDnsName": {
														"locationName": "privateDnsName"
													},
													"PrivateIpAddress": {
														"locationName": "privateIpAddress"
													}
												}
											}
										},
										"SourceDestCheck": {
											"locationName": "sourceDestCheck",
											"type": "boolean"
										},
										"Status": {
											"locationName": "status"
										},
										"SubnetId": {
											"locationName": "subnetId"
										},
										"VpcId": {
											"locationName": "vpcId"
										}
									}
								}
							},
							"RootDeviceName": {
								"locationName": "rootDeviceName"
							},
							"RootDeviceType": {
								"locationName": "rootDeviceType"
							},
							"SecurityGroups": {
								"shape": "S5w",
								"locationName": "groupSet"
							},
							"SourceDestCheck": {
								"locationName": "sourceDestCheck",
								"type": "boolean"
							},
							"SpotInstanceRequestId": {
								"locationName": "spotInstanceRequestId"
							},
							"SriovNetSupport": {
								"locationName": "sriovNetSupport"
							},
							"StateReason": {
								"shape": "Scz",
								"locationName": "stateReason"
							},
							"Tags": {
								"shape": "Sj",
								"locationName": "tagSet"
							},
							"VirtualizationType": {
								"locationName": "virtualizationType"
							}
						}
					}
				},
				"OwnerId": {
					"locationName": "ownerId"
				},
				"RequesterId": {
					"locationName": "requesterId"
				},
				"ReservationId": {
					"locationName": "reservationId"
				}
			}
		},
		"Se7": {
			"type": "structure",
			"members": {
				"State": {
					"locationName": "state"
				}
			}
		},
		"Se9": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"Affinity": {
					"locationName": "affinity"
				},
				"GroupName": {
					"locationName": "groupName"
				},
				"HostId": {
					"locationName": "hostId"
				},
				"Tenancy": {
					"locationName": "tenancy"
				},
				"SpreadDomain": {
					"locationName": "spreadDomain"
				}
			}
		},
		"Sef": {
			"type": "structure",
			"members": {
				"IpOwnerId": {
					"locationName": "ipOwnerId"
				},
				"PublicDnsName": {
					"locationName": "publicDnsName"
				},
				"PublicIp": {
					"locationName": "publicIp"
				}
			}
		},
		"Sfu": {
			"type": "list",
			"member": {
				"locationName": "ReservedInstancesId"
			}
		},
		"Sg2": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Amount": {
						"locationName": "amount",
						"type": "double"
					},
					"Frequency": {
						"locationName": "frequency"
					}
				}
			}
		},
		"Sgf": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"InstanceCount": {
					"locationName": "instanceCount",
					"type": "integer"
				},
				"InstanceType": {
					"locationName": "instanceType"
				},
				"Platform": {
					"locationName": "platform"
				},
				"Scope": {
					"locationName": "scope"
				}
			}
		},
		"Sgz": {
			"type": "structure",
			"members": {
				"Frequency": {
					"locationName": "frequency"
				},
				"Interval": {
					"locationName": "interval",
					"type": "integer"
				},
				"OccurrenceDaySet": {
					"locationName": "occurrenceDaySet",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "integer"
					}
				},
				"OccurrenceRelativeToEnd": {
					"locationName": "occurrenceRelativeToEnd",
					"type": "boolean"
				},
				"OccurrenceUnit": {
					"locationName": "occurrenceUnit"
				}
			}
		},
		"Sh6": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"CreateDate": {
					"locationName": "createDate",
					"type": "timestamp"
				},
				"HourlyPrice": {
					"locationName": "hourlyPrice"
				},
				"InstanceCount": {
					"locationName": "instanceCount",
					"type": "integer"
				},
				"InstanceType": {
					"locationName": "instanceType"
				},
				"NetworkPlatform": {
					"locationName": "networkPlatform"
				},
				"NextSlotStartTime": {
					"locationName": "nextSlotStartTime",
					"type": "timestamp"
				},
				"Platform": {
					"locationName": "platform"
				},
				"PreviousSlotEndTime": {
					"locationName": "previousSlotEndTime",
					"type": "timestamp"
				},
				"Recurrence": {
					"shape": "Sgz",
					"locationName": "recurrence"
				},
				"ScheduledInstanceId": {
					"locationName": "scheduledInstanceId"
				},
				"SlotDurationInHours": {
					"locationName": "slotDurationInHours",
					"type": "integer"
				},
				"TermEndDate": {
					"locationName": "termEndDate",
					"type": "timestamp"
				},
				"TermStartDate": {
					"locationName": "termStartDate",
					"type": "timestamp"
				},
				"TotalScheduledInstanceHours": {
					"locationName": "totalScheduledInstanceHours",
					"type": "integer"
				}
			}
		},
		"Shd": {
			"type": "list",
			"member": {
				"locationName": "GroupName"
			}
		},
		"Shk": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"Group": {
						"locationName": "group"
					},
					"UserId": {
						"locationName": "userId"
					}
				}
			}
		},
		"Si9": {
			"type": "structure",
			"required": [
				"IamFleetRole",
				"LaunchSpecifications",
				"SpotPrice",
				"TargetCapacity"
			],
			"members": {
				"AllocationStrategy": {
					"locationName": "allocationStrategy"
				},
				"ClientToken": {
					"locationName": "clientToken"
				},
				"ExcessCapacityTerminationPolicy": {
					"locationName": "excessCapacityTerminationPolicy"
				},
				"FulfilledCapacity": {
					"locationName": "fulfilledCapacity",
					"type": "double"
				},
				"IamFleetRole": {
					"locationName": "iamFleetRole"
				},
				"LaunchSpecifications": {
					"locationName": "launchSpecifications",
					"type": "list",
					"member": {
						"locationName": "item",
						"type": "structure",
						"members": {
							"SecurityGroups": {
								"shape": "S5w",
								"locationName": "groupSet"
							},
							"AddressingType": {
								"locationName": "addressingType"
							},
							"BlockDeviceMappings": {
								"shape": "Sck",
								"locationName": "blockDeviceMapping"
							},
							"EbsOptimized": {
								"locationName": "ebsOptimized",
								"type": "boolean"
							},
							"IamInstanceProfile": {
								"shape": "S11",
								"locationName": "iamInstanceProfile"
							},
							"ImageId": {
								"locationName": "imageId"
							},
							"InstanceType": {
								"locationName": "instanceType"
							},
							"KernelId": {
								"locationName": "kernelId"
							},
							"KeyName": {
								"locationName": "keyName"
							},
							"Monitoring": {
								"locationName": "monitoring",
								"type": "structure",
								"members": {
									"Enabled": {
										"locationName": "enabled",
										"type": "boolean"
									}
								}
							},
							"NetworkInterfaces": {
								"shape": "Sif",
								"locationName": "networkInterfaceSet"
							},
							"Placement": {
								"shape": "Sih",
								"locationName": "placement"
							},
							"RamdiskId": {
								"locationName": "ramdiskId"
							},
							"SpotPrice": {
								"locationName": "spotPrice"
							},
							"SubnetId": {
								"locationName": "subnetId"
							},
							"UserData": {
								"locationName": "userData"
							},
							"WeightedCapacity": {
								"locationName": "weightedCapacity",
								"type": "double"
							},
							"TagSpecifications": {
								"locationName": "tagSpecificationSet",
								"type": "list",
								"member": {
									"locationName": "item",
									"type": "structure",
									"members": {
										"ResourceType": {
											"locationName": "resourceType"
										},
										"Tags": {
											"shape": "Sj",
											"locationName": "tag"
										}
									}
								}
							}
						}
					}
				},
				"SpotPrice": {
					"locationName": "spotPrice"
				},
				"TargetCapacity": {
					"locationName": "targetCapacity",
					"type": "integer"
				},
				"TerminateInstancesWithExpiration": {
					"locationName": "terminateInstancesWithExpiration",
					"type": "boolean"
				},
				"Type": {
					"locationName": "type"
				},
				"ValidFrom": {
					"locationName": "validFrom",
					"type": "timestamp"
				},
				"ValidUntil": {
					"locationName": "validUntil",
					"type": "timestamp"
				},
				"ReplaceUnhealthyInstances": {
					"locationName": "replaceUnhealthyInstances",
					"type": "boolean"
				}
			}
		},
		"Sif": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"AssociatePublicIpAddress": {
						"locationName": "associatePublicIpAddress",
						"type": "boolean"
					},
					"DeleteOnTermination": {
						"locationName": "deleteOnTermination",
						"type": "boolean"
					},
					"Description": {
						"locationName": "description"
					},
					"DeviceIndex": {
						"locationName": "deviceIndex",
						"type": "integer"
					},
					"Groups": {
						"shape": "S5n",
						"locationName": "SecurityGroupId"
					},
					"Ipv6AddressCount": {
						"locationName": "ipv6AddressCount",
						"type": "integer"
					},
					"Ipv6Addresses": {
						"shape": "S5o",
						"locationName": "ipv6AddressesSet",
						"queryName": "Ipv6Addresses"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					},
					"PrivateIpAddresses": {
						"shape": "S5q",
						"locationName": "privateIpAddressesSet",
						"queryName": "PrivateIpAddresses"
					},
					"SecondaryPrivateIpAddressCount": {
						"locationName": "secondaryPrivateIpAddressCount",
						"type": "integer"
					},
					"SubnetId": {
						"locationName": "subnetId"
					}
				}
			}
		},
		"Sih": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {
					"locationName": "availabilityZone"
				},
				"GroupName": {
					"locationName": "groupName"
				},
				"Tenancy": {
					"locationName": "tenancy"
				}
			}
		},
		"Sin": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"ActualBlockHourlyPrice": {
						"locationName": "actualBlockHourlyPrice"
					},
					"AvailabilityZoneGroup": {
						"locationName": "availabilityZoneGroup"
					},
					"BlockDurationMinutes": {
						"locationName": "blockDurationMinutes",
						"type": "integer"
					},
					"CreateTime": {
						"locationName": "createTime",
						"type": "timestamp"
					},
					"Fault": {
						"shape": "S71",
						"locationName": "fault"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"LaunchGroup": {
						"locationName": "launchGroup"
					},
					"LaunchSpecification": {
						"locationName": "launchSpecification",
						"type": "structure",
						"members": {
							"UserData": {
								"locationName": "userData"
							},
							"SecurityGroups": {
								"shape": "S5w",
								"locationName": "groupSet"
							},
							"AddressingType": {
								"locationName": "addressingType"
							},
							"BlockDeviceMappings": {
								"shape": "Sck",
								"locationName": "blockDeviceMapping"
							},
							"EbsOptimized": {
								"locationName": "ebsOptimized",
								"type": "boolean"
							},
							"IamInstanceProfile": {
								"shape": "S11",
								"locationName": "iamInstanceProfile"
							},
							"ImageId": {
								"locationName": "imageId"
							},
							"InstanceType": {
								"locationName": "instanceType"
							},
							"KernelId": {
								"locationName": "kernelId"
							},
							"KeyName": {
								"locationName": "keyName"
							},
							"NetworkInterfaces": {
								"shape": "Sif",
								"locationName": "networkInterfaceSet"
							},
							"Placement": {
								"shape": "Sih",
								"locationName": "placement"
							},
							"RamdiskId": {
								"locationName": "ramdiskId"
							},
							"SubnetId": {
								"locationName": "subnetId"
							},
							"Monitoring": {
								"shape": "Siq",
								"locationName": "monitoring"
							}
						}
					},
					"LaunchedAvailabilityZone": {
						"locationName": "launchedAvailabilityZone"
					},
					"ProductDescription": {
						"locationName": "productDescription"
					},
					"SpotInstanceRequestId": {
						"locationName": "spotInstanceRequestId"
					},
					"SpotPrice": {
						"locationName": "spotPrice"
					},
					"State": {
						"locationName": "state"
					},
					"Status": {
						"locationName": "status",
						"type": "structure",
						"members": {
							"Code": {
								"locationName": "code"
							},
							"Message": {
								"locationName": "message"
							},
							"UpdateTime": {
								"locationName": "updateTime",
								"type": "timestamp"
							}
						}
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					},
					"Type": {
						"locationName": "type"
					},
					"ValidFrom": {
						"locationName": "validFrom",
						"type": "timestamp"
					},
					"ValidUntil": {
						"locationName": "validUntil",
						"type": "timestamp"
					}
				}
			}
		},
		"Siq": {
			"type": "structure",
			"required": [
				"Enabled"
			],
			"members": {
				"Enabled": {
					"locationName": "enabled",
					"type": "boolean"
				}
			}
		},
		"Sj4": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"FromPort": {
						"locationName": "fromPort",
						"type": "integer"
					},
					"IpProtocol": {
						"locationName": "ipProtocol"
					},
					"IpRanges": {
						"locationName": "ipRanges",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"PrefixListIds": {
						"locationName": "prefixListIds",
						"type": "list",
						"member": {
							"locationName": "item"
						}
					},
					"ToPort": {
						"locationName": "toPort",
						"type": "integer"
					},
					"UserIdGroupPairs": {
						"locationName": "groups",
						"type": "list",
						"member": {
							"shape": "S25",
							"locationName": "item"
						}
					}
				}
			}
		},
		"Sjl": {
			"type": "list",
			"member": {
				"locationName": "VolumeId"
			}
		},
		"Sk4": {
			"type": "structure",
			"members": {
				"VolumeId": {
					"locationName": "volumeId"
				},
				"ModificationState": {
					"locationName": "modificationState"
				},
				"StatusMessage": {
					"locationName": "statusMessage"
				},
				"TargetSize": {
					"locationName": "targetSize",
					"type": "integer"
				},
				"TargetIops": {
					"locationName": "targetIops",
					"type": "integer"
				},
				"TargetVolumeType": {
					"locationName": "targetVolumeType"
				},
				"OriginalSize": {
					"locationName": "originalSize",
					"type": "integer"
				},
				"OriginalIops": {
					"locationName": "originalIops",
					"type": "integer"
				},
				"OriginalVolumeType": {
					"locationName": "originalVolumeType"
				},
				"Progress": {
					"locationName": "progress",
					"type": "long"
				},
				"StartTime": {
					"locationName": "startTime",
					"type": "timestamp"
				},
				"EndTime": {
					"locationName": "endTime",
					"type": "timestamp"
				}
			}
		},
		"Ska": {
			"type": "list",
			"member": {
				"locationName": "VpcId"
			}
		},
		"Slw": {
			"type": "list",
			"member": {
				"locationName": "item"
			}
		},
		"Sly": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"CurrencyCode": {
						"locationName": "currencyCode"
					},
					"Duration": {
						"locationName": "duration",
						"type": "integer"
					},
					"HostIdSet": {
						"shape": "Sbt",
						"locationName": "hostIdSet"
					},
					"HostReservationId": {
						"locationName": "hostReservationId"
					},
					"HourlyPrice": {
						"locationName": "hourlyPrice"
					},
					"InstanceFamily": {
						"locationName": "instanceFamily"
					},
					"PaymentOption": {
						"locationName": "paymentOption"
					},
					"UpfrontPrice": {
						"locationName": "upfrontPrice"
					}
				}
			}
		},
		"Sm4": {
			"type": "structure",
			"members": {
				"HourlyPrice": {
					"locationName": "hourlyPrice"
				},
				"RemainingTotalValue": {
					"locationName": "remainingTotalValue"
				},
				"RemainingUpfrontValue": {
					"locationName": "remainingUpfrontValue"
				}
			}
		},
		"Smb": {
			"type": "structure",
			"members": {
				"Comment": {},
				"UploadEnd": {
					"type": "timestamp"
				},
				"UploadSize": {
					"type": "double"
				},
				"UploadStart": {
					"type": "timestamp"
				}
			}
		},
		"Sme": {
			"type": "structure",
			"members": {
				"S3Bucket": {},
				"S3Key": {}
			}
		},
		"Smj": {
			"type": "structure",
			"required": [
				"Bytes",
				"Format",
				"ImportManifestUrl"
			],
			"members": {
				"Bytes": {
					"locationName": "bytes",
					"type": "long"
				},
				"Format": {
					"locationName": "format"
				},
				"ImportManifestUrl": {
					"locationName": "importManifestUrl"
				}
			}
		},
		"Smk": {
			"type": "structure",
			"required": [
				"Size"
			],
			"members": {
				"Size": {
					"locationName": "size",
					"type": "long"
				}
			}
		},
		"Smm": {
			"type": "list",
			"member": {
				"locationName": "SecurityGroup"
			}
		},
		"Smz": {
			"type": "list",
			"member": {
				"shape": "S4e",
				"locationName": "item"
			}
		},
		"Sn7": {
			"type": "list",
			"member": {
				"locationName": "UserId"
			}
		},
		"Sny": {
			"type": "structure",
			"members": {
				"AllowDnsResolutionFromRemoteVpc": {
					"type": "boolean"
				},
				"AllowEgressFromLocalClassicLinkToRemoteVpc": {
					"type": "boolean"
				},
				"AllowEgressFromLocalVpcToRemoteClassicLink": {
					"type": "boolean"
				}
			}
		},
		"So0": {
			"type": "structure",
			"members": {
				"AllowDnsResolutionFromRemoteVpc": {
					"locationName": "allowDnsResolutionFromRemoteVpc",
					"type": "boolean"
				},
				"AllowEgressFromLocalClassicLinkToRemoteVpc": {
					"locationName": "allowEgressFromLocalClassicLinkToRemoteVpc",
					"type": "boolean"
				},
				"AllowEgressFromLocalVpcToRemoteClassicLink": {
					"locationName": "allowEgressFromLocalVpcToRemoteClassicLink",
					"type": "boolean"
				}
			}
		},
		"So3": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"InstanceId": {
						"locationName": "instanceId"
					},
					"Monitoring": {
						"shape": "Se7",
						"locationName": "monitoring"
					}
				}
			}
		},
		"Spt": {
			"type": "list",
			"member": {
				"locationName": "SecurityGroupId"
			}
		},
		"Sq4": {
			"type": "list",
			"member": {
				"locationName": "item",
				"type": "structure",
				"members": {
					"CurrentState": {
						"shape": "Sds",
						"locationName": "currentState"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"PreviousState": {
						"shape": "Sds",
						"locationName": "previousState"
					}
				}
			}
		}
	}
};

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeAccountAttributes": {
			"result_key": "AccountAttributes"
		},
		"DescribeAddresses": {
			"result_key": "Addresses"
		},
		"DescribeAvailabilityZones": {
			"result_key": "AvailabilityZones"
		},
		"DescribeBundleTasks": {
			"result_key": "BundleTasks"
		},
		"DescribeConversionTasks": {
			"result_key": "ConversionTasks"
		},
		"DescribeCustomerGateways": {
			"result_key": "CustomerGateways"
		},
		"DescribeDhcpOptions": {
			"result_key": "DhcpOptions"
		},
		"DescribeExportTasks": {
			"result_key": "ExportTasks"
		},
		"DescribeImages": {
			"result_key": "Images"
		},
		"DescribeInstanceStatus": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "InstanceStatuses"
		},
		"DescribeInstances": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Reservations"
		},
		"DescribeInternetGateways": {
			"result_key": "InternetGateways"
		},
		"DescribeKeyPairs": {
			"result_key": "KeyPairs"
		},
		"DescribeNatGateways": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "NatGateways"
		},
		"DescribeNetworkAcls": {
			"result_key": "NetworkAcls"
		},
		"DescribeNetworkInterfaces": {
			"result_key": "NetworkInterfaces"
		},
		"DescribePlacementGroups": {
			"result_key": "PlacementGroups"
		},
		"DescribeRegions": {
			"result_key": "Regions"
		},
		"DescribeReservedInstances": {
			"result_key": "ReservedInstances"
		},
		"DescribeReservedInstancesListings": {
			"result_key": "ReservedInstancesListings"
		},
		"DescribeReservedInstancesModifications": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "ReservedInstancesModifications"
		},
		"DescribeReservedInstancesOfferings": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ReservedInstancesOfferings"
		},
		"DescribeRouteTables": {
			"result_key": "RouteTables"
		},
		"DescribeSecurityGroups": {
			"result_key": "SecurityGroups"
		},
		"DescribeSnapshots": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Snapshots"
		},
		"DescribeSpotFleetRequests": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "SpotFleetRequestConfigs"
		},
		"DescribeSpotInstanceRequests": {
			"result_key": "SpotInstanceRequests"
		},
		"DescribeSpotPriceHistory": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "SpotPriceHistory"
		},
		"DescribeSubnets": {
			"result_key": "Subnets"
		},
		"DescribeTags": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Tags"
		},
		"DescribeVolumeStatus": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "VolumeStatuses"
		},
		"DescribeVolumes": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Volumes"
		},
		"DescribeVpcPeeringConnections": {
			"result_key": "VpcPeeringConnections"
		},
		"DescribeVpcs": {
			"result_key": "Vpcs"
		},
		"DescribeVpnConnections": {
			"result_key": "VpnConnections"
		},
		"DescribeVpnGateways": {
			"result_key": "VpnGateways"
		}
	}
};

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"InstanceExists": {
			"delay": 5,
			"maxAttempts": 40,
			"operation": "DescribeInstances",
			"acceptors": [
				{
					"matcher": "path",
					"expected": true,
					"argument": "length(Reservations[]) > `0`",
					"state": "success"
				},
				{
					"matcher": "error",
					"expected": "InvalidInstanceID.NotFound",
					"state": "retry"
				}
			]
		},
		"BundleTaskComplete": {
			"delay": 15,
			"operation": "DescribeBundleTasks",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "complete",
					"matcher": "pathAll",
					"state": "success",
					"argument": "BundleTasks[].State"
				},
				{
					"expected": "failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "BundleTasks[].State"
				}
			]
		},
		"ConversionTaskCancelled": {
			"delay": 15,
			"operation": "DescribeConversionTasks",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "cancelled",
					"matcher": "pathAll",
					"state": "success",
					"argument": "ConversionTasks[].State"
				}
			]
		},
		"ConversionTaskCompleted": {
			"delay": 15,
			"operation": "DescribeConversionTasks",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "completed",
					"matcher": "pathAll",
					"state": "success",
					"argument": "ConversionTasks[].State"
				},
				{
					"expected": "cancelled",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "ConversionTasks[].State"
				},
				{
					"expected": "cancelling",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "ConversionTasks[].State"
				}
			]
		},
		"ConversionTaskDeleted": {
			"delay": 15,
			"operation": "DescribeConversionTasks",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "deleted",
					"matcher": "pathAll",
					"state": "success",
					"argument": "ConversionTasks[].State"
				}
			]
		},
		"CustomerGatewayAvailable": {
			"delay": 15,
			"operation": "DescribeCustomerGateways",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "available",
					"matcher": "pathAll",
					"state": "success",
					"argument": "CustomerGateways[].State"
				},
				{
					"expected": "deleted",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "CustomerGateways[].State"
				},
				{
					"expected": "deleting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "CustomerGateways[].State"
				}
			]
		},
		"ExportTaskCancelled": {
			"delay": 15,
			"operation": "DescribeExportTasks",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "cancelled",
					"matcher": "pathAll",
					"state": "success",
					"argument": "ExportTasks[].State"
				}
			]
		},
		"ExportTaskCompleted": {
			"delay": 15,
			"operation": "DescribeExportTasks",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "completed",
					"matcher": "pathAll",
					"state": "success",
					"argument": "ExportTasks[].State"
				}
			]
		},
		"ImageExists": {
			"operation": "DescribeImages",
			"maxAttempts": 40,
			"delay": 15,
			"acceptors": [
				{
					"matcher": "path",
					"expected": true,
					"argument": "length(Images[]) > `0`",
					"state": "success"
				},
				{
					"matcher": "error",
					"expected": "InvalidAMIID.NotFound",
					"state": "retry"
				}
			]
		},
		"ImageAvailable": {
			"operation": "DescribeImages",
			"maxAttempts": 40,
			"delay": 15,
			"acceptors": [
				{
					"state": "success",
					"matcher": "pathAll",
					"argument": "Images[].State",
					"expected": "available"
				},
				{
					"state": "failure",
					"matcher": "pathAny",
					"argument": "Images[].State",
					"expected": "failed"
				}
			]
		},
		"InstanceRunning": {
			"delay": 15,
			"operation": "DescribeInstances",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "running",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Reservations[].Instances[].State.Name"
				},
				{
					"expected": "shutting-down",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Reservations[].Instances[].State.Name"
				},
				{
					"expected": "terminated",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Reservations[].Instances[].State.Name"
				},
				{
					"expected": "stopping",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Reservations[].Instances[].State.Name"
				},
				{
					"matcher": "error",
					"expected": "InvalidInstanceID.NotFound",
					"state": "retry"
				}
			]
		},
		"InstanceStatusOk": {
			"operation": "DescribeInstanceStatus",
			"maxAttempts": 40,
			"delay": 15,
			"acceptors": [
				{
					"state": "success",
					"matcher": "pathAll",
					"argument": "InstanceStatuses[].InstanceStatus.Status",
					"expected": "ok"
				},
				{
					"matcher": "error",
					"expected": "InvalidInstanceID.NotFound",
					"state": "retry"
				}
			]
		},
		"InstanceStopped": {
			"delay": 15,
			"operation": "DescribeInstances",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "stopped",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Reservations[].Instances[].State.Name"
				},
				{
					"expected": "pending",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Reservations[].Instances[].State.Name"
				},
				{
					"expected": "terminated",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Reservations[].Instances[].State.Name"
				}
			]
		},
		"InstanceTerminated": {
			"delay": 15,
			"operation": "DescribeInstances",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "terminated",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Reservations[].Instances[].State.Name"
				},
				{
					"expected": "pending",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Reservations[].Instances[].State.Name"
				},
				{
					"expected": "stopping",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Reservations[].Instances[].State.Name"
				}
			]
		},
		"KeyPairExists": {
			"operation": "DescribeKeyPairs",
			"delay": 5,
			"maxAttempts": 6,
			"acceptors": [
				{
					"expected": true,
					"matcher": "path",
					"state": "success",
					"argument": "length(KeyPairs[].KeyName) > `0`"
				},
				{
					"expected": "InvalidKeyPair.NotFound",
					"matcher": "error",
					"state": "retry"
				}
			]
		},
		"NatGatewayAvailable": {
			"operation": "DescribeNatGateways",
			"delay": 15,
			"maxAttempts": 40,
			"acceptors": [
				{
					"state": "success",
					"matcher": "pathAll",
					"argument": "NatGateways[].State",
					"expected": "available"
				},
				{
					"state": "failure",
					"matcher": "pathAny",
					"argument": "NatGateways[].State",
					"expected": "failed"
				},
				{
					"state": "failure",
					"matcher": "pathAny",
					"argument": "NatGateways[].State",
					"expected": "deleting"
				},
				{
					"state": "failure",
					"matcher": "pathAny",
					"argument": "NatGateways[].State",
					"expected": "deleted"
				},
				{
					"state": "retry",
					"matcher": "error",
					"expected": "NatGatewayNotFound"
				}
			]
		},
		"NetworkInterfaceAvailable": {
			"operation": "DescribeNetworkInterfaces",
			"delay": 20,
			"maxAttempts": 10,
			"acceptors": [
				{
					"expected": "available",
					"matcher": "pathAll",
					"state": "success",
					"argument": "NetworkInterfaces[].Status"
				},
				{
					"expected": "InvalidNetworkInterfaceID.NotFound",
					"matcher": "error",
					"state": "failure"
				}
			]
		},
		"PasswordDataAvailable": {
			"operation": "GetPasswordData",
			"maxAttempts": 40,
			"delay": 15,
			"acceptors": [
				{
					"state": "success",
					"matcher": "path",
					"argument": "length(PasswordData) > `0`",
					"expected": true
				}
			]
		},
		"SnapshotCompleted": {
			"delay": 15,
			"operation": "DescribeSnapshots",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "completed",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Snapshots[].State"
				}
			]
		},
		"SpotInstanceRequestFulfilled": {
			"operation": "DescribeSpotInstanceRequests",
			"maxAttempts": 40,
			"delay": 15,
			"acceptors": [
				{
					"state": "success",
					"matcher": "pathAll",
					"argument": "SpotInstanceRequests[].Status.Code",
					"expected": "fulfilled"
				},
				{
					"state": "failure",
					"matcher": "pathAny",
					"argument": "SpotInstanceRequests[].Status.Code",
					"expected": "schedule-expired"
				},
				{
					"state": "failure",
					"matcher": "pathAny",
					"argument": "SpotInstanceRequests[].Status.Code",
					"expected": "canceled-before-fulfillment"
				},
				{
					"state": "failure",
					"matcher": "pathAny",
					"argument": "SpotInstanceRequests[].Status.Code",
					"expected": "bad-parameters"
				},
				{
					"state": "failure",
					"matcher": "pathAny",
					"argument": "SpotInstanceRequests[].Status.Code",
					"expected": "system-error"
				},
				{
					"state": "retry",
					"matcher": "error",
					"expected": "InvalidSpotInstanceRequestID.NotFound"
				}
			]
		},
		"SubnetAvailable": {
			"delay": 15,
			"operation": "DescribeSubnets",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "available",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Subnets[].State"
				}
			]
		},
		"SystemStatusOk": {
			"operation": "DescribeInstanceStatus",
			"maxAttempts": 40,
			"delay": 15,
			"acceptors": [
				{
					"state": "success",
					"matcher": "pathAll",
					"argument": "InstanceStatuses[].SystemStatus.Status",
					"expected": "ok"
				}
			]
		},
		"VolumeAvailable": {
			"delay": 15,
			"operation": "DescribeVolumes",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "available",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Volumes[].State"
				},
				{
					"expected": "deleted",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Volumes[].State"
				}
			]
		},
		"VolumeDeleted": {
			"delay": 15,
			"operation": "DescribeVolumes",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "deleted",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Volumes[].State"
				},
				{
					"matcher": "error",
					"expected": "InvalidVolume.NotFound",
					"state": "success"
				}
			]
		},
		"VolumeInUse": {
			"delay": 15,
			"operation": "DescribeVolumes",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "in-use",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Volumes[].State"
				},
				{
					"expected": "deleted",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Volumes[].State"
				}
			]
		},
		"VpcAvailable": {
			"delay": 15,
			"operation": "DescribeVpcs",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "available",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Vpcs[].State"
				}
			]
		},
		"VpcExists": {
			"operation": "DescribeVpcs",
			"delay": 1,
			"maxAttempts": 5,
			"acceptors": [
				{
					"matcher": "status",
					"expected": 200,
					"state": "success"
				},
				{
					"matcher": "error",
					"expected": "InvalidVpcID.NotFound",
					"state": "retry"
				}
			]
		},
		"VpnConnectionAvailable": {
			"delay": 15,
			"operation": "DescribeVpnConnections",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "available",
					"matcher": "pathAll",
					"state": "success",
					"argument": "VpnConnections[].State"
				},
				{
					"expected": "deleting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "VpnConnections[].State"
				},
				{
					"expected": "deleted",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "VpnConnections[].State"
				}
			]
		},
		"VpnConnectionDeleted": {
			"delay": 15,
			"operation": "DescribeVpnConnections",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "deleted",
					"matcher": "pathAll",
					"state": "success",
					"argument": "VpnConnections[].State"
				},
				{
					"expected": "pending",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "VpnConnections[].State"
				}
			]
		},
		"VpcPeeringConnectionExists": {
			"delay": 15,
			"operation": "DescribeVpcPeeringConnections",
			"maxAttempts": 40,
			"acceptors": [
				{
					"matcher": "status",
					"expected": 200,
					"state": "success"
				},
				{
					"matcher": "error",
					"expected": "InvalidVpcPeeringConnectionID.NotFound",
					"state": "retry"
				}
			]
		},
		"VpcPeeringConnectionDeleted": {
			"delay": 15,
			"operation": "DescribeVpcPeeringConnections",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "deleted",
					"matcher": "pathAll",
					"state": "success",
					"argument": "VpcPeeringConnections[].Status.Code"
				},
				{
					"matcher": "error",
					"expected": "InvalidVpcPeeringConnectionID.NotFound",
					"state": "success"
				}
			]
		}
	}
};

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ecr'] = {};
AWS.ECR = Service.defineService('ecr', ['2015-09-21']);
Object.defineProperty(apiLoader.services['ecr'], '2015-09-21', {
  get: function get() {
    var model = __webpack_require__(1593);
    model.paginators = __webpack_require__(1594).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ECR;


/***/ }),
/* 1593 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"uid": "ecr-2015-09-21",
		"apiVersion": "2015-09-21",
		"endpointPrefix": "ecr",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Amazon ECR",
		"serviceFullName": "Amazon EC2 Container Registry",
		"signatureVersion": "v4",
		"targetPrefix": "AmazonEC2ContainerRegistry_V20150921"
	},
	"operations": {
		"BatchCheckLayerAvailability": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"layerDigests"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"layerDigests": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"layers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"layerDigest": {},
								"layerAvailability": {},
								"layerSize": {
									"type": "long"
								},
								"mediaType": {}
							}
						}
					},
					"failures": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"layerDigest": {},
								"failureCode": {},
								"failureReason": {}
							}
						}
					}
				}
			}
		},
		"BatchDeleteImage": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"imageIds"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"imageIds": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"imageIds": {
						"shape": "Si"
					},
					"failures": {
						"shape": "Sn"
					}
				}
			}
		},
		"BatchGetImage": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"imageIds"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"imageIds": {
						"shape": "Si"
					},
					"acceptedMediaTypes": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"images": {
						"type": "list",
						"member": {
							"shape": "Sv"
						}
					},
					"failures": {
						"shape": "Sn"
					}
				}
			}
		},
		"CompleteLayerUpload": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"uploadId",
					"layerDigests"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"uploadId": {},
					"layerDigests": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"registryId": {},
					"repositoryName": {},
					"uploadId": {},
					"layerDigest": {}
				}
			}
		},
		"CreateRepository": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"repositoryName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"repository": {
						"shape": "S13"
					}
				}
			}
		},
		"DeleteRepository": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"force": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"repository": {
						"shape": "S13"
					}
				}
			}
		},
		"DeleteRepositoryPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"registryId": {},
					"repositoryName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"registryId": {},
					"repositoryName": {},
					"policyText": {}
				}
			}
		},
		"DescribeImages": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"imageIds": {
						"shape": "Si"
					},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					},
					"filter": {
						"type": "structure",
						"members": {
							"tagStatus": {}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"imageDetails": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"registryId": {},
								"repositoryName": {},
								"imageDigest": {},
								"imageTags": {
									"type": "list",
									"member": {}
								},
								"imageSizeInBytes": {
									"type": "long"
								},
								"imagePushedAt": {
									"type": "timestamp"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"DescribeRepositories": {
			"input": {
				"type": "structure",
				"members": {
					"registryId": {},
					"repositoryNames": {
						"type": "list",
						"member": {}
					},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"repositories": {
						"type": "list",
						"member": {
							"shape": "S13"
						}
					},
					"nextToken": {}
				}
			}
		},
		"GetAuthorizationToken": {
			"input": {
				"type": "structure",
				"members": {
					"registryIds": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"authorizationData": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"authorizationToken": {},
								"expiresAt": {
									"type": "timestamp"
								},
								"proxyEndpoint": {}
							}
						}
					}
				}
			}
		},
		"GetDownloadUrlForLayer": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"layerDigest"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"layerDigest": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"downloadUrl": {},
					"layerDigest": {}
				}
			}
		},
		"GetRepositoryPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"registryId": {},
					"repositoryName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"registryId": {},
					"repositoryName": {},
					"policyText": {}
				}
			}
		},
		"InitiateLayerUpload": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"registryId": {},
					"repositoryName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"uploadId": {},
					"partSize": {
						"type": "long"
					}
				}
			}
		},
		"ListImages": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					},
					"filter": {
						"type": "structure",
						"members": {
							"tagStatus": {}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"imageIds": {
						"shape": "Si"
					},
					"nextToken": {}
				}
			}
		},
		"PutImage": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"imageManifest"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"imageManifest": {},
					"imageTag": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"image": {
						"shape": "Sv"
					}
				}
			}
		},
		"SetRepositoryPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"policyText"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"policyText": {},
					"force": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"registryId": {},
					"repositoryName": {},
					"policyText": {}
				}
			}
		},
		"UploadLayerPart": {
			"input": {
				"type": "structure",
				"required": [
					"repositoryName",
					"uploadId",
					"partFirstByte",
					"partLastByte",
					"layerPartBlob"
				],
				"members": {
					"registryId": {},
					"repositoryName": {},
					"uploadId": {},
					"partFirstByte": {
						"type": "long"
					},
					"partLastByte": {
						"type": "long"
					},
					"layerPartBlob": {
						"type": "blob"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"registryId": {},
					"repositoryName": {},
					"uploadId": {},
					"lastByteReceived": {
						"type": "long"
					}
				}
			}
		}
	},
	"shapes": {
		"Si": {
			"type": "list",
			"member": {
				"shape": "Sj"
			}
		},
		"Sj": {
			"type": "structure",
			"members": {
				"imageDigest": {},
				"imageTag": {}
			}
		},
		"Sn": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"imageId": {
						"shape": "Sj"
					},
					"failureCode": {},
					"failureReason": {}
				}
			}
		},
		"Sv": {
			"type": "structure",
			"members": {
				"registryId": {},
				"repositoryName": {},
				"imageId": {
					"shape": "Sj"
				},
				"imageManifest": {}
			}
		},
		"S13": {
			"type": "structure",
			"members": {
				"repositoryArn": {},
				"registryId": {},
				"repositoryName": {},
				"repositoryUri": {},
				"createdAt": {
					"type": "timestamp"
				}
			}
		}
	}
};

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListImages": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults",
			"result_key": "imageIds"
		},
		"DescribeImages": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults",
			"result_key": "imageDetails"
		},
		"DescribeRepositories": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults",
			"result_key": "repositories"
		}
	}
};

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ecs'] = {};
AWS.ECS = Service.defineService('ecs', ['2014-11-13']);
Object.defineProperty(apiLoader.services['ecs'], '2014-11-13', {
  get: function get() {
    var model = __webpack_require__(1596);
    model.paginators = __webpack_require__(1597).pagination;
    model.waiters = __webpack_require__(1598).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ECS;


/***/ }),
/* 1596 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-11-13",
		"endpointPrefix": "ecs",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Amazon ECS",
		"serviceFullName": "Amazon EC2 Container Service",
		"signatureVersion": "v4",
		"targetPrefix": "AmazonEC2ContainerServiceV20141113",
		"uid": "ecs-2014-11-13"
	},
	"operations": {
		"CreateCluster": {
			"input": {
				"type": "structure",
				"members": {
					"clusterName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"cluster": {
						"shape": "S4"
					}
				}
			}
		},
		"CreateService": {
			"input": {
				"type": "structure",
				"required": [
					"serviceName",
					"taskDefinition",
					"desiredCount"
				],
				"members": {
					"cluster": {},
					"serviceName": {},
					"taskDefinition": {},
					"loadBalancers": {
						"shape": "S7"
					},
					"desiredCount": {
						"type": "integer"
					},
					"clientToken": {},
					"role": {},
					"deploymentConfiguration": {
						"shape": "Sa"
					},
					"placementConstraints": {
						"shape": "Sb"
					},
					"placementStrategy": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"service": {
						"shape": "Si"
					}
				}
			}
		},
		"DeleteAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"attributes"
				],
				"members": {
					"cluster": {},
					"attributes": {
						"shape": "Sp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"attributes": {
						"shape": "Sp"
					}
				}
			}
		},
		"DeleteCluster": {
			"input": {
				"type": "structure",
				"required": [
					"cluster"
				],
				"members": {
					"cluster": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"cluster": {
						"shape": "S4"
					}
				}
			}
		},
		"DeleteService": {
			"input": {
				"type": "structure",
				"required": [
					"service"
				],
				"members": {
					"cluster": {},
					"service": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"service": {
						"shape": "Si"
					}
				}
			}
		},
		"DeregisterContainerInstance": {
			"input": {
				"type": "structure",
				"required": [
					"containerInstance"
				],
				"members": {
					"cluster": {},
					"containerInstance": {},
					"force": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstance": {
						"shape": "S10"
					}
				}
			}
		},
		"DeregisterTaskDefinition": {
			"input": {
				"type": "structure",
				"required": [
					"taskDefinition"
				],
				"members": {
					"taskDefinition": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskDefinition": {
						"shape": "S1b"
					}
				}
			}
		},
		"DescribeClusters": {
			"input": {
				"type": "structure",
				"members": {
					"clusters": {
						"shape": "S16"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"clusters": {
						"type": "list",
						"member": {
							"shape": "S4"
						}
					},
					"failures": {
						"shape": "S28"
					}
				}
			}
		},
		"DescribeContainerInstances": {
			"input": {
				"type": "structure",
				"required": [
					"containerInstances"
				],
				"members": {
					"cluster": {},
					"containerInstances": {
						"shape": "S16"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstances": {
						"shape": "S2c"
					},
					"failures": {
						"shape": "S28"
					}
				}
			}
		},
		"DescribeServices": {
			"input": {
				"type": "structure",
				"required": [
					"services"
				],
				"members": {
					"cluster": {},
					"services": {
						"shape": "S16"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"services": {
						"type": "list",
						"member": {
							"shape": "Si"
						}
					},
					"failures": {
						"shape": "S28"
					}
				}
			}
		},
		"DescribeTaskDefinition": {
			"input": {
				"type": "structure",
				"required": [
					"taskDefinition"
				],
				"members": {
					"taskDefinition": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskDefinition": {
						"shape": "S1b"
					}
				}
			}
		},
		"DescribeTasks": {
			"input": {
				"type": "structure",
				"required": [
					"tasks"
				],
				"members": {
					"cluster": {},
					"tasks": {
						"shape": "S16"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tasks": {
						"shape": "S2k"
					},
					"failures": {
						"shape": "S28"
					}
				}
			}
		},
		"DiscoverPollEndpoint": {
			"input": {
				"type": "structure",
				"members": {
					"containerInstance": {},
					"cluster": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"endpoint": {},
					"telemetryEndpoint": {}
				}
			}
		},
		"ListAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"targetType"
				],
				"members": {
					"cluster": {},
					"targetType": {},
					"attributeName": {},
					"attributeValue": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"attributes": {
						"shape": "Sp"
					},
					"nextToken": {}
				}
			}
		},
		"ListClusters": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"clusterArns": {
						"shape": "S16"
					},
					"nextToken": {}
				}
			}
		},
		"ListContainerInstances": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"filter": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					},
					"status": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstanceArns": {
						"shape": "S16"
					},
					"nextToken": {}
				}
			}
		},
		"ListServices": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"serviceArns": {
						"shape": "S16"
					},
					"nextToken": {}
				}
			}
		},
		"ListTaskDefinitionFamilies": {
			"input": {
				"type": "structure",
				"members": {
					"familyPrefix": {},
					"status": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"families": {
						"shape": "S16"
					},
					"nextToken": {}
				}
			}
		},
		"ListTaskDefinitions": {
			"input": {
				"type": "structure",
				"members": {
					"familyPrefix": {},
					"status": {},
					"sort": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskDefinitionArns": {
						"shape": "S16"
					},
					"nextToken": {}
				}
			}
		},
		"ListTasks": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"containerInstance": {},
					"family": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					},
					"startedBy": {},
					"serviceName": {},
					"desiredStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskArns": {
						"shape": "S16"
					},
					"nextToken": {}
				}
			}
		},
		"PutAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"attributes"
				],
				"members": {
					"cluster": {},
					"attributes": {
						"shape": "Sp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"attributes": {
						"shape": "Sp"
					}
				}
			}
		},
		"RegisterContainerInstance": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"instanceIdentityDocument": {},
					"instanceIdentityDocumentSignature": {},
					"totalResources": {
						"shape": "S13"
					},
					"versionInfo": {
						"shape": "S12"
					},
					"containerInstanceArn": {},
					"attributes": {
						"shape": "Sp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstance": {
						"shape": "S10"
					}
				}
			}
		},
		"RegisterTaskDefinition": {
			"input": {
				"type": "structure",
				"required": [
					"family",
					"containerDefinitions"
				],
				"members": {
					"family": {},
					"taskRoleArn": {},
					"networkMode": {},
					"containerDefinitions": {
						"shape": "S1c"
					},
					"volumes": {
						"shape": "S1x"
					},
					"placementConstraints": {
						"shape": "S22"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"taskDefinition": {
						"shape": "S1b"
					}
				}
			}
		},
		"RunTask": {
			"input": {
				"type": "structure",
				"required": [
					"taskDefinition"
				],
				"members": {
					"cluster": {},
					"taskDefinition": {},
					"overrides": {
						"shape": "S2m"
					},
					"count": {
						"type": "integer"
					},
					"startedBy": {},
					"group": {},
					"placementConstraints": {
						"shape": "Sb"
					},
					"placementStrategy": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tasks": {
						"shape": "S2k"
					},
					"failures": {
						"shape": "S28"
					}
				}
			}
		},
		"StartTask": {
			"input": {
				"type": "structure",
				"required": [
					"taskDefinition",
					"containerInstances"
				],
				"members": {
					"cluster": {},
					"taskDefinition": {},
					"overrides": {
						"shape": "S2m"
					},
					"containerInstances": {
						"shape": "S16"
					},
					"startedBy": {},
					"group": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"tasks": {
						"shape": "S2k"
					},
					"failures": {
						"shape": "S28"
					}
				}
			}
		},
		"StopTask": {
			"input": {
				"type": "structure",
				"required": [
					"task"
				],
				"members": {
					"cluster": {},
					"task": {},
					"reason": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"task": {
						"shape": "S2l"
					}
				}
			}
		},
		"SubmitContainerStateChange": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"task": {},
					"containerName": {},
					"status": {},
					"exitCode": {
						"type": "integer"
					},
					"reason": {},
					"networkBindings": {
						"shape": "S2r"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"acknowledgment": {}
				}
			}
		},
		"SubmitTaskStateChange": {
			"input": {
				"type": "structure",
				"members": {
					"cluster": {},
					"task": {},
					"status": {},
					"reason": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"acknowledgment": {}
				}
			}
		},
		"UpdateContainerAgent": {
			"input": {
				"type": "structure",
				"required": [
					"containerInstance"
				],
				"members": {
					"cluster": {},
					"containerInstance": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstance": {
						"shape": "S10"
					}
				}
			}
		},
		"UpdateContainerInstancesState": {
			"input": {
				"type": "structure",
				"required": [
					"containerInstances",
					"status"
				],
				"members": {
					"cluster": {},
					"containerInstances": {
						"shape": "S16"
					},
					"status": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"containerInstances": {
						"shape": "S2c"
					},
					"failures": {
						"shape": "S28"
					}
				}
			}
		},
		"UpdateService": {
			"input": {
				"type": "structure",
				"required": [
					"service"
				],
				"members": {
					"cluster": {},
					"service": {},
					"desiredCount": {
						"type": "integer"
					},
					"taskDefinition": {},
					"deploymentConfiguration": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"service": {
						"shape": "Si"
					}
				}
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"clusterArn": {},
				"clusterName": {},
				"status": {},
				"registeredContainerInstancesCount": {
					"type": "integer"
				},
				"runningTasksCount": {
					"type": "integer"
				},
				"pendingTasksCount": {
					"type": "integer"
				},
				"activeServicesCount": {
					"type": "integer"
				}
			}
		},
		"S7": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"targetGroupArn": {},
					"loadBalancerName": {},
					"containerName": {},
					"containerPort": {
						"type": "integer"
					}
				}
			}
		},
		"Sa": {
			"type": "structure",
			"members": {
				"maximumPercent": {
					"type": "integer"
				},
				"minimumHealthyPercent": {
					"type": "integer"
				}
			}
		},
		"Sb": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"type": {},
					"expression": {}
				}
			}
		},
		"Se": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"type": {},
					"field": {}
				}
			}
		},
		"Si": {
			"type": "structure",
			"members": {
				"serviceArn": {},
				"serviceName": {},
				"clusterArn": {},
				"loadBalancers": {
					"shape": "S7"
				},
				"status": {},
				"desiredCount": {
					"type": "integer"
				},
				"runningCount": {
					"type": "integer"
				},
				"pendingCount": {
					"type": "integer"
				},
				"taskDefinition": {},
				"deploymentConfiguration": {
					"shape": "Sa"
				},
				"deployments": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"id": {},
							"status": {},
							"taskDefinition": {},
							"desiredCount": {
								"type": "integer"
							},
							"pendingCount": {
								"type": "integer"
							},
							"runningCount": {
								"type": "integer"
							},
							"createdAt": {
								"type": "timestamp"
							},
							"updatedAt": {
								"type": "timestamp"
							}
						}
					}
				},
				"roleArn": {},
				"events": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"id": {},
							"createdAt": {
								"type": "timestamp"
							},
							"message": {}
						}
					}
				},
				"createdAt": {
					"type": "timestamp"
				},
				"placementConstraints": {
					"shape": "Sb"
				},
				"placementStrategy": {
					"shape": "Se"
				}
			}
		},
		"Sp": {
			"type": "list",
			"member": {
				"shape": "Sq"
			}
		},
		"Sq": {
			"type": "structure",
			"required": [
				"name"
			],
			"members": {
				"name": {},
				"value": {},
				"targetType": {},
				"targetId": {}
			}
		},
		"S10": {
			"type": "structure",
			"members": {
				"containerInstanceArn": {},
				"ec2InstanceId": {},
				"version": {
					"type": "long"
				},
				"versionInfo": {
					"shape": "S12"
				},
				"remainingResources": {
					"shape": "S13"
				},
				"registeredResources": {
					"shape": "S13"
				},
				"status": {},
				"agentConnected": {
					"type": "boolean"
				},
				"runningTasksCount": {
					"type": "integer"
				},
				"pendingTasksCount": {
					"type": "integer"
				},
				"agentUpdateStatus": {},
				"attributes": {
					"shape": "Sp"
				},
				"registeredAt": {
					"type": "timestamp"
				}
			}
		},
		"S12": {
			"type": "structure",
			"members": {
				"agentVersion": {},
				"agentHash": {},
				"dockerVersion": {}
			}
		},
		"S13": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"type": {},
					"doubleValue": {
						"type": "double"
					},
					"longValue": {
						"type": "long"
					},
					"integerValue": {
						"type": "integer"
					},
					"stringSetValue": {
						"shape": "S16"
					}
				}
			}
		},
		"S16": {
			"type": "list",
			"member": {}
		},
		"S1b": {
			"type": "structure",
			"members": {
				"taskDefinitionArn": {},
				"containerDefinitions": {
					"shape": "S1c"
				},
				"family": {},
				"taskRoleArn": {},
				"networkMode": {},
				"revision": {
					"type": "integer"
				},
				"volumes": {
					"shape": "S1x"
				},
				"status": {},
				"requiresAttributes": {
					"type": "list",
					"member": {
						"shape": "Sq"
					}
				},
				"placementConstraints": {
					"shape": "S22"
				}
			}
		},
		"S1c": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"image": {},
					"cpu": {
						"type": "integer"
					},
					"memory": {
						"type": "integer"
					},
					"memoryReservation": {
						"type": "integer"
					},
					"links": {
						"shape": "S16"
					},
					"portMappings": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"containerPort": {
									"type": "integer"
								},
								"hostPort": {
									"type": "integer"
								},
								"protocol": {}
							}
						}
					},
					"essential": {
						"type": "boolean"
					},
					"entryPoint": {
						"shape": "S16"
					},
					"command": {
						"shape": "S16"
					},
					"environment": {
						"shape": "S1h"
					},
					"mountPoints": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"sourceVolume": {},
								"containerPath": {},
								"readOnly": {
									"type": "boolean"
								}
							}
						}
					},
					"volumesFrom": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"sourceContainer": {},
								"readOnly": {
									"type": "boolean"
								}
							}
						}
					},
					"hostname": {},
					"user": {},
					"workingDirectory": {},
					"disableNetworking": {
						"type": "boolean"
					},
					"privileged": {
						"type": "boolean"
					},
					"readonlyRootFilesystem": {
						"type": "boolean"
					},
					"dnsServers": {
						"shape": "S16"
					},
					"dnsSearchDomains": {
						"shape": "S16"
					},
					"extraHosts": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"hostname",
								"ipAddress"
							],
							"members": {
								"hostname": {},
								"ipAddress": {}
							}
						}
					},
					"dockerSecurityOptions": {
						"shape": "S16"
					},
					"dockerLabels": {
						"type": "map",
						"key": {},
						"value": {}
					},
					"ulimits": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"name",
								"softLimit",
								"hardLimit"
							],
							"members": {
								"name": {},
								"softLimit": {
									"type": "integer"
								},
								"hardLimit": {
									"type": "integer"
								}
							}
						}
					},
					"logConfiguration": {
						"type": "structure",
						"required": [
							"logDriver"
						],
						"members": {
							"logDriver": {},
							"options": {
								"type": "map",
								"key": {},
								"value": {}
							}
						}
					}
				}
			}
		},
		"S1h": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"value": {}
				}
			}
		},
		"S1x": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"name": {},
					"host": {
						"type": "structure",
						"members": {
							"sourcePath": {}
						}
					}
				}
			}
		},
		"S22": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"type": {},
					"expression": {}
				}
			}
		},
		"S28": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"arn": {},
					"reason": {}
				}
			}
		},
		"S2c": {
			"type": "list",
			"member": {
				"shape": "S10"
			}
		},
		"S2k": {
			"type": "list",
			"member": {
				"shape": "S2l"
			}
		},
		"S2l": {
			"type": "structure",
			"members": {
				"taskArn": {},
				"clusterArn": {},
				"taskDefinitionArn": {},
				"containerInstanceArn": {},
				"overrides": {
					"shape": "S2m"
				},
				"lastStatus": {},
				"desiredStatus": {},
				"containers": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"containerArn": {},
							"taskArn": {},
							"name": {},
							"lastStatus": {},
							"exitCode": {
								"type": "integer"
							},
							"reason": {},
							"networkBindings": {
								"shape": "S2r"
							}
						}
					}
				},
				"startedBy": {},
				"version": {
					"type": "long"
				},
				"stoppedReason": {},
				"createdAt": {
					"type": "timestamp"
				},
				"startedAt": {
					"type": "timestamp"
				},
				"stoppedAt": {
					"type": "timestamp"
				},
				"group": {}
			}
		},
		"S2m": {
			"type": "structure",
			"members": {
				"containerOverrides": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"name": {},
							"command": {
								"shape": "S16"
							},
							"environment": {
								"shape": "S1h"
							},
							"cpu": {
								"type": "integer"
							},
							"memory": {
								"type": "integer"
							},
							"memoryReservation": {
								"type": "integer"
							}
						}
					}
				},
				"taskRoleArn": {}
			}
		},
		"S2r": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"bindIP": {},
					"containerPort": {
						"type": "integer"
					},
					"hostPort": {
						"type": "integer"
					},
					"protocol": {}
				}
			}
		}
	}
};

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListClusters": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "clusterArns"
		},
		"ListContainerInstances": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "containerInstanceArns"
		},
		"ListServices": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "serviceArns"
		},
		"ListTaskDefinitionFamilies": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "families"
		},
		"ListTaskDefinitions": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "taskDefinitionArns"
		},
		"ListTasks": {
			"input_token": "nextToken",
			"limit_key": "maxResults",
			"output_token": "nextToken",
			"result_key": "taskArns"
		}
	}
};

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"TasksRunning": {
			"delay": 6,
			"operation": "DescribeTasks",
			"maxAttempts": 100,
			"acceptors": [
				{
					"expected": "STOPPED",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "tasks[].lastStatus"
				},
				{
					"expected": "MISSING",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "failures[].reason"
				},
				{
					"expected": "RUNNING",
					"matcher": "pathAll",
					"state": "success",
					"argument": "tasks[].lastStatus"
				}
			]
		},
		"TasksStopped": {
			"delay": 6,
			"operation": "DescribeTasks",
			"maxAttempts": 100,
			"acceptors": [
				{
					"expected": "STOPPED",
					"matcher": "pathAll",
					"state": "success",
					"argument": "tasks[].lastStatus"
				}
			]
		},
		"ServicesStable": {
			"delay": 15,
			"operation": "DescribeServices",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "MISSING",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "failures[].reason"
				},
				{
					"expected": "DRAINING",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "services[].status"
				},
				{
					"expected": "INACTIVE",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "services[].status"
				},
				{
					"expected": true,
					"matcher": "path",
					"state": "success",
					"argument": "length(services[?!(length(deployments) == `1` && runningCount == desiredCount)]) == `0`"
				}
			]
		},
		"ServicesInactive": {
			"delay": 15,
			"operation": "DescribeServices",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "MISSING",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "failures[].reason"
				},
				{
					"expected": "INACTIVE",
					"matcher": "pathAny",
					"state": "success",
					"argument": "services[].status"
				}
			]
		}
	}
};

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['efs'] = {};
AWS.EFS = Service.defineService('efs', ['2015-02-01']);
Object.defineProperty(apiLoader.services['efs'], '2015-02-01', {
  get: function get() {
    var model = __webpack_require__(1600);
    model.paginators = __webpack_require__(1601).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.EFS;


/***/ }),
/* 1600 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-02-01",
		"endpointPrefix": "elasticfilesystem",
		"protocol": "rest-json",
		"serviceAbbreviation": "EFS",
		"serviceFullName": "Amazon Elastic File System",
		"signatureVersion": "v4",
		"uid": "elasticfilesystem-2015-02-01"
	},
	"operations": {
		"CreateFileSystem": {
			"http": {
				"requestUri": "/2015-02-01/file-systems",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"CreationToken"
				],
				"members": {
					"CreationToken": {},
					"PerformanceMode": {},
					"Encrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {}
				}
			},
			"output": {
				"shape": "S6"
			}
		},
		"CreateMountTarget": {
			"http": {
				"requestUri": "/2015-02-01/mount-targets",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId",
					"SubnetId"
				],
				"members": {
					"FileSystemId": {},
					"SubnetId": {},
					"IpAddress": {},
					"SecurityGroups": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"shape": "Sk"
			}
		},
		"CreateTags": {
			"http": {
				"requestUri": "/2015-02-01/create-tags/{FileSystemId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId",
					"Tags"
				],
				"members": {
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					},
					"Tags": {
						"shape": "So"
					}
				}
			}
		},
		"DeleteFileSystem": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2015-02-01/file-systems/{FileSystemId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId"
				],
				"members": {
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					}
				}
			}
		},
		"DeleteMountTarget": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2015-02-01/mount-targets/{MountTargetId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"MountTargetId"
				],
				"members": {
					"MountTargetId": {
						"location": "uri",
						"locationName": "MountTargetId"
					}
				}
			}
		},
		"DeleteTags": {
			"http": {
				"requestUri": "/2015-02-01/delete-tags/{FileSystemId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId",
					"TagKeys"
				],
				"members": {
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"DescribeFileSystems": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/file-systems",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"CreationToken": {
						"location": "querystring",
						"locationName": "CreationToken"
					},
					"FileSystemId": {
						"location": "querystring",
						"locationName": "FileSystemId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Marker": {},
					"FileSystems": {
						"type": "list",
						"member": {
							"shape": "S6"
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeMountTargetSecurityGroups": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/mount-targets/{MountTargetId}/security-groups",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"MountTargetId"
				],
				"members": {
					"MountTargetId": {
						"location": "uri",
						"locationName": "MountTargetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"SecurityGroups"
				],
				"members": {
					"SecurityGroups": {
						"shape": "Si"
					}
				}
			}
		},
		"DescribeMountTargets": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/mount-targets",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"FileSystemId": {
						"location": "querystring",
						"locationName": "FileSystemId"
					},
					"MountTargetId": {
						"location": "querystring",
						"locationName": "MountTargetId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Marker": {},
					"MountTargets": {
						"type": "list",
						"member": {
							"shape": "Sk"
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeTags": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-02-01/tags/{FileSystemId}/",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FileSystemId"
				],
				"members": {
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"FileSystemId": {
						"location": "uri",
						"locationName": "FileSystemId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Tags"
				],
				"members": {
					"Marker": {},
					"Tags": {
						"shape": "So"
					},
					"NextMarker": {}
				}
			}
		},
		"ModifyMountTargetSecurityGroups": {
			"http": {
				"method": "PUT",
				"requestUri": "/2015-02-01/mount-targets/{MountTargetId}/security-groups",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"MountTargetId"
				],
				"members": {
					"MountTargetId": {
						"location": "uri",
						"locationName": "MountTargetId"
					},
					"SecurityGroups": {
						"shape": "Si"
					}
				}
			}
		}
	},
	"shapes": {
		"S6": {
			"type": "structure",
			"required": [
				"OwnerId",
				"CreationToken",
				"FileSystemId",
				"CreationTime",
				"LifeCycleState",
				"NumberOfMountTargets",
				"SizeInBytes",
				"PerformanceMode"
			],
			"members": {
				"OwnerId": {},
				"CreationToken": {},
				"FileSystemId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"LifeCycleState": {},
				"Name": {},
				"NumberOfMountTargets": {
					"type": "integer"
				},
				"SizeInBytes": {
					"type": "structure",
					"required": [
						"Value"
					],
					"members": {
						"Value": {
							"type": "long"
						},
						"Timestamp": {
							"type": "timestamp"
						}
					}
				},
				"PerformanceMode": {},
				"Encrypted": {
					"type": "boolean"
				},
				"KmsKeyId": {}
			}
		},
		"Si": {
			"type": "list",
			"member": {}
		},
		"Sk": {
			"type": "structure",
			"required": [
				"MountTargetId",
				"FileSystemId",
				"SubnetId",
				"LifeCycleState"
			],
			"members": {
				"OwnerId": {},
				"MountTargetId": {},
				"FileSystemId": {},
				"SubnetId": {},
				"LifeCycleState": {},
				"IpAddress": {},
				"NetworkInterfaceId": {}
			}
		},
		"So": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		}
	}
};

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elasticache'] = {};
AWS.ElastiCache = Service.defineService('elasticache', ['2012-11-15*', '2014-03-24*', '2014-07-15*', '2014-09-30*', '2015-02-02']);
Object.defineProperty(apiLoader.services['elasticache'], '2015-02-02', {
  get: function get() {
    var model = __webpack_require__(1603);
    model.paginators = __webpack_require__(1604).pagination;
    model.waiters = __webpack_require__(1605).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ElastiCache;


/***/ }),
/* 1603 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-02-02",
		"endpointPrefix": "elasticache",
		"protocol": "query",
		"serviceFullName": "Amazon ElastiCache",
		"signatureVersion": "v4",
		"uid": "elasticache-2015-02-02",
		"xmlNamespace": "http://elasticache.amazonaws.com/doc/2015-02-02/"
	},
	"operations": {
		"AddTagsToResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"Tags"
				],
				"members": {
					"ResourceName": {},
					"Tags": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"shape": "S5",
				"resultWrapper": "AddTagsToResourceResult"
			}
		},
		"AuthorizeCacheSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"CacheSecurityGroupName",
					"EC2SecurityGroupName",
					"EC2SecurityGroupOwnerId"
				],
				"members": {
					"CacheSecurityGroupName": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "AuthorizeCacheSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"CacheSecurityGroup": {
						"shape": "S8"
					}
				}
			}
		},
		"CopySnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SourceSnapshotName",
					"TargetSnapshotName"
				],
				"members": {
					"SourceSnapshotName": {},
					"TargetSnapshotName": {},
					"TargetBucket": {}
				}
			},
			"output": {
				"resultWrapper": "CopySnapshotResult",
				"type": "structure",
				"members": {
					"Snapshot": {
						"shape": "Sd"
					}
				}
			}
		},
		"CreateCacheCluster": {
			"input": {
				"type": "structure",
				"required": [
					"CacheClusterId"
				],
				"members": {
					"CacheClusterId": {},
					"ReplicationGroupId": {},
					"AZMode": {},
					"PreferredAvailabilityZone": {},
					"PreferredAvailabilityZones": {
						"shape": "So"
					},
					"NumCacheNodes": {
						"type": "integer"
					},
					"CacheNodeType": {},
					"Engine": {},
					"EngineVersion": {},
					"CacheParameterGroupName": {},
					"CacheSubnetGroupName": {},
					"CacheSecurityGroupNames": {
						"shape": "Sp"
					},
					"SecurityGroupIds": {
						"shape": "Sq"
					},
					"Tags": {
						"shape": "S3"
					},
					"SnapshotArns": {
						"shape": "Sr"
					},
					"SnapshotName": {},
					"PreferredMaintenanceWindow": {},
					"Port": {
						"type": "integer"
					},
					"NotificationTopicArn": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"SnapshotRetentionLimit": {
						"type": "integer"
					},
					"SnapshotWindow": {},
					"AuthToken": {}
				}
			},
			"output": {
				"resultWrapper": "CreateCacheClusterResult",
				"type": "structure",
				"members": {
					"CacheCluster": {
						"shape": "Su"
					}
				}
			}
		},
		"CreateCacheParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"CacheParameterGroupName",
					"CacheParameterGroupFamily",
					"Description"
				],
				"members": {
					"CacheParameterGroupName": {},
					"CacheParameterGroupFamily": {},
					"Description": {}
				}
			},
			"output": {
				"resultWrapper": "CreateCacheParameterGroupResult",
				"type": "structure",
				"members": {
					"CacheParameterGroup": {
						"shape": "S19"
					}
				}
			}
		},
		"CreateCacheSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"CacheSecurityGroupName",
					"Description"
				],
				"members": {
					"CacheSecurityGroupName": {},
					"Description": {}
				}
			},
			"output": {
				"resultWrapper": "CreateCacheSecurityGroupResult",
				"type": "structure",
				"members": {
					"CacheSecurityGroup": {
						"shape": "S8"
					}
				}
			}
		},
		"CreateCacheSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"CacheSubnetGroupName",
					"CacheSubnetGroupDescription",
					"SubnetIds"
				],
				"members": {
					"CacheSubnetGroupName": {},
					"CacheSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S1d"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateCacheSubnetGroupResult",
				"type": "structure",
				"members": {
					"CacheSubnetGroup": {
						"shape": "S1f"
					}
				}
			}
		},
		"CreateReplicationGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ReplicationGroupId",
					"ReplicationGroupDescription"
				],
				"members": {
					"ReplicationGroupId": {},
					"ReplicationGroupDescription": {},
					"PrimaryClusterId": {},
					"AutomaticFailoverEnabled": {
						"type": "boolean"
					},
					"NumCacheClusters": {
						"type": "integer"
					},
					"PreferredCacheClusterAZs": {
						"shape": "Sl"
					},
					"NumNodeGroups": {
						"type": "integer"
					},
					"ReplicasPerNodeGroup": {
						"type": "integer"
					},
					"NodeGroupConfiguration": {
						"type": "list",
						"member": {
							"shape": "Sk",
							"locationName": "NodeGroupConfiguration"
						}
					},
					"CacheNodeType": {},
					"Engine": {},
					"EngineVersion": {},
					"CacheParameterGroupName": {},
					"CacheSubnetGroupName": {},
					"CacheSecurityGroupNames": {
						"shape": "Sp"
					},
					"SecurityGroupIds": {
						"shape": "Sq"
					},
					"Tags": {
						"shape": "S3"
					},
					"SnapshotArns": {
						"shape": "Sr"
					},
					"SnapshotName": {},
					"PreferredMaintenanceWindow": {},
					"Port": {
						"type": "integer"
					},
					"NotificationTopicArn": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"SnapshotRetentionLimit": {
						"type": "integer"
					},
					"SnapshotWindow": {},
					"AuthToken": {}
				}
			},
			"output": {
				"resultWrapper": "CreateReplicationGroupResult",
				"type": "structure",
				"members": {
					"ReplicationGroup": {
						"shape": "S1m"
					}
				}
			}
		},
		"CreateSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotName"
				],
				"members": {
					"ReplicationGroupId": {},
					"CacheClusterId": {},
					"SnapshotName": {}
				}
			},
			"output": {
				"resultWrapper": "CreateSnapshotResult",
				"type": "structure",
				"members": {
					"Snapshot": {
						"shape": "Sd"
					}
				}
			}
		},
		"DeleteCacheCluster": {
			"input": {
				"type": "structure",
				"required": [
					"CacheClusterId"
				],
				"members": {
					"CacheClusterId": {},
					"FinalSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteCacheClusterResult",
				"type": "structure",
				"members": {
					"CacheCluster": {
						"shape": "Su"
					}
				}
			}
		},
		"DeleteCacheParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"CacheParameterGroupName"
				],
				"members": {
					"CacheParameterGroupName": {}
				}
			}
		},
		"DeleteCacheSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"CacheSecurityGroupName"
				],
				"members": {
					"CacheSecurityGroupName": {}
				}
			}
		},
		"DeleteCacheSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"CacheSubnetGroupName"
				],
				"members": {
					"CacheSubnetGroupName": {}
				}
			}
		},
		"DeleteReplicationGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ReplicationGroupId"
				],
				"members": {
					"ReplicationGroupId": {},
					"RetainPrimaryCluster": {
						"type": "boolean"
					},
					"FinalSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteReplicationGroupResult",
				"type": "structure",
				"members": {
					"ReplicationGroup": {
						"shape": "S1m"
					}
				}
			}
		},
		"DeleteSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotName"
				],
				"members": {
					"SnapshotName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteSnapshotResult",
				"type": "structure",
				"members": {
					"Snapshot": {
						"shape": "Sd"
					}
				}
			}
		},
		"DescribeCacheClusters": {
			"input": {
				"type": "structure",
				"members": {
					"CacheClusterId": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"ShowCacheNodeInfo": {
						"type": "boolean"
					},
					"ShowCacheClustersNotInReplicationGroups": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeCacheClustersResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"CacheClusters": {
						"type": "list",
						"member": {
							"shape": "Su",
							"locationName": "CacheCluster"
						}
					}
				}
			}
		},
		"DescribeCacheEngineVersions": {
			"input": {
				"type": "structure",
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"CacheParameterGroupFamily": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"DefaultOnly": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeCacheEngineVersionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"CacheEngineVersions": {
						"type": "list",
						"member": {
							"locationName": "CacheEngineVersion",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"CacheParameterGroupFamily": {},
								"CacheEngineDescription": {},
								"CacheEngineVersionDescription": {}
							}
						}
					}
				}
			}
		},
		"DescribeCacheParameterGroups": {
			"input": {
				"type": "structure",
				"members": {
					"CacheParameterGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeCacheParameterGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"CacheParameterGroups": {
						"type": "list",
						"member": {
							"shape": "S19",
							"locationName": "CacheParameterGroup"
						}
					}
				}
			}
		},
		"DescribeCacheParameters": {
			"input": {
				"type": "structure",
				"required": [
					"CacheParameterGroupName"
				],
				"members": {
					"CacheParameterGroupName": {},
					"Source": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeCacheParametersResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Parameters": {
						"shape": "S2h"
					},
					"CacheNodeTypeSpecificParameters": {
						"shape": "S2k"
					}
				}
			}
		},
		"DescribeCacheSecurityGroups": {
			"input": {
				"type": "structure",
				"members": {
					"CacheSecurityGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeCacheSecurityGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"CacheSecurityGroups": {
						"type": "list",
						"member": {
							"shape": "S8",
							"locationName": "CacheSecurityGroup"
						}
					}
				}
			}
		},
		"DescribeCacheSubnetGroups": {
			"input": {
				"type": "structure",
				"members": {
					"CacheSubnetGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeCacheSubnetGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"CacheSubnetGroups": {
						"type": "list",
						"member": {
							"shape": "S1f",
							"locationName": "CacheSubnetGroup"
						}
					}
				}
			}
		},
		"DescribeEngineDefaultParameters": {
			"input": {
				"type": "structure",
				"required": [
					"CacheParameterGroupFamily"
				],
				"members": {
					"CacheParameterGroupFamily": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEngineDefaultParametersResult",
				"type": "structure",
				"members": {
					"EngineDefaults": {
						"type": "structure",
						"members": {
							"CacheParameterGroupFamily": {},
							"Marker": {},
							"Parameters": {
								"shape": "S2h"
							},
							"CacheNodeTypeSpecificParameters": {
								"shape": "S2k"
							}
						},
						"wrapper": true
					}
				}
			}
		},
		"DescribeEvents": {
			"input": {
				"type": "structure",
				"members": {
					"SourceIdentifier": {},
					"SourceType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Events": {
						"type": "list",
						"member": {
							"locationName": "Event",
							"type": "structure",
							"members": {
								"SourceIdentifier": {},
								"SourceType": {},
								"Message": {},
								"Date": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeReplicationGroups": {
			"input": {
				"type": "structure",
				"members": {
					"ReplicationGroupId": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReplicationGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReplicationGroups": {
						"type": "list",
						"member": {
							"shape": "S1m",
							"locationName": "ReplicationGroup"
						}
					}
				}
			}
		},
		"DescribeReservedCacheNodes": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedCacheNodeId": {},
					"ReservedCacheNodesOfferingId": {},
					"CacheNodeType": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedCacheNodesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedCacheNodes": {
						"type": "list",
						"member": {
							"shape": "S38",
							"locationName": "ReservedCacheNode"
						}
					}
				}
			}
		},
		"DescribeReservedCacheNodesOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedCacheNodesOfferingId": {},
					"CacheNodeType": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedCacheNodesOfferingsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedCacheNodesOfferings": {
						"type": "list",
						"member": {
							"locationName": "ReservedCacheNodesOffering",
							"type": "structure",
							"members": {
								"ReservedCacheNodesOfferingId": {},
								"CacheNodeType": {},
								"Duration": {
									"type": "integer"
								},
								"FixedPrice": {
									"type": "double"
								},
								"UsagePrice": {
									"type": "double"
								},
								"ProductDescription": {},
								"OfferingType": {},
								"RecurringCharges": {
									"shape": "S3a"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DescribeSnapshots": {
			"input": {
				"type": "structure",
				"members": {
					"ReplicationGroupId": {},
					"CacheClusterId": {},
					"SnapshotName": {},
					"SnapshotSource": {},
					"Marker": {},
					"MaxRecords": {
						"type": "integer"
					},
					"ShowNodeGroupConfig": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeSnapshotsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Snapshots": {
						"type": "list",
						"member": {
							"shape": "Sd",
							"locationName": "Snapshot"
						}
					}
				}
			}
		},
		"ListAllowedNodeTypeModifications": {
			"input": {
				"type": "structure",
				"members": {
					"CacheClusterId": {},
					"ReplicationGroupId": {}
				}
			},
			"output": {
				"resultWrapper": "ListAllowedNodeTypeModificationsResult",
				"type": "structure",
				"members": {
					"ScaleUpModifications": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"ListTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName"
				],
				"members": {
					"ResourceName": {}
				}
			},
			"output": {
				"shape": "S5",
				"resultWrapper": "ListTagsForResourceResult"
			}
		},
		"ModifyCacheCluster": {
			"input": {
				"type": "structure",
				"required": [
					"CacheClusterId"
				],
				"members": {
					"CacheClusterId": {},
					"NumCacheNodes": {
						"type": "integer"
					},
					"CacheNodeIdsToRemove": {
						"shape": "Sy"
					},
					"AZMode": {},
					"NewAvailabilityZones": {
						"shape": "So"
					},
					"CacheSecurityGroupNames": {
						"shape": "Sp"
					},
					"SecurityGroupIds": {
						"shape": "Sq"
					},
					"PreferredMaintenanceWindow": {},
					"NotificationTopicArn": {},
					"CacheParameterGroupName": {},
					"NotificationTopicStatus": {},
					"ApplyImmediately": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"SnapshotRetentionLimit": {
						"type": "integer"
					},
					"SnapshotWindow": {},
					"CacheNodeType": {}
				}
			},
			"output": {
				"resultWrapper": "ModifyCacheClusterResult",
				"type": "structure",
				"members": {
					"CacheCluster": {
						"shape": "Su"
					}
				}
			}
		},
		"ModifyCacheParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"CacheParameterGroupName",
					"ParameterNameValues"
				],
				"members": {
					"CacheParameterGroupName": {},
					"ParameterNameValues": {
						"shape": "S3q"
					}
				}
			},
			"output": {
				"shape": "S3s",
				"resultWrapper": "ModifyCacheParameterGroupResult"
			}
		},
		"ModifyCacheSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"CacheSubnetGroupName"
				],
				"members": {
					"CacheSubnetGroupName": {},
					"CacheSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S1d"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyCacheSubnetGroupResult",
				"type": "structure",
				"members": {
					"CacheSubnetGroup": {
						"shape": "S1f"
					}
				}
			}
		},
		"ModifyReplicationGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ReplicationGroupId"
				],
				"members": {
					"ReplicationGroupId": {},
					"ReplicationGroupDescription": {},
					"PrimaryClusterId": {},
					"SnapshottingClusterId": {},
					"AutomaticFailoverEnabled": {
						"type": "boolean"
					},
					"CacheSecurityGroupNames": {
						"shape": "Sp"
					},
					"SecurityGroupIds": {
						"shape": "Sq"
					},
					"PreferredMaintenanceWindow": {},
					"NotificationTopicArn": {},
					"CacheParameterGroupName": {},
					"NotificationTopicStatus": {},
					"ApplyImmediately": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"SnapshotRetentionLimit": {
						"type": "integer"
					},
					"SnapshotWindow": {},
					"CacheNodeType": {},
					"NodeGroupId": {}
				}
			},
			"output": {
				"resultWrapper": "ModifyReplicationGroupResult",
				"type": "structure",
				"members": {
					"ReplicationGroup": {
						"shape": "S1m"
					}
				}
			}
		},
		"PurchaseReservedCacheNodesOffering": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedCacheNodesOfferingId"
				],
				"members": {
					"ReservedCacheNodesOfferingId": {},
					"ReservedCacheNodeId": {},
					"CacheNodeCount": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "PurchaseReservedCacheNodesOfferingResult",
				"type": "structure",
				"members": {
					"ReservedCacheNode": {
						"shape": "S38"
					}
				}
			}
		},
		"RebootCacheCluster": {
			"input": {
				"type": "structure",
				"required": [
					"CacheClusterId",
					"CacheNodeIdsToReboot"
				],
				"members": {
					"CacheClusterId": {},
					"CacheNodeIdsToReboot": {
						"shape": "Sy"
					}
				}
			},
			"output": {
				"resultWrapper": "RebootCacheClusterResult",
				"type": "structure",
				"members": {
					"CacheCluster": {
						"shape": "Su"
					}
				}
			}
		},
		"RemoveTagsFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"TagKeys"
				],
				"members": {
					"ResourceName": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"shape": "S5",
				"resultWrapper": "RemoveTagsFromResourceResult"
			}
		},
		"ResetCacheParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"CacheParameterGroupName"
				],
				"members": {
					"CacheParameterGroupName": {},
					"ResetAllParameters": {
						"type": "boolean"
					},
					"ParameterNameValues": {
						"shape": "S3q"
					}
				}
			},
			"output": {
				"shape": "S3s",
				"resultWrapper": "ResetCacheParameterGroupResult"
			}
		},
		"RevokeCacheSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"CacheSecurityGroupName",
					"EC2SecurityGroupName",
					"EC2SecurityGroupOwnerId"
				],
				"members": {
					"CacheSecurityGroupName": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "RevokeCacheSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"CacheSecurityGroup": {
						"shape": "S8"
					}
				}
			}
		},
		"TestFailover": {
			"input": {
				"type": "structure",
				"required": [
					"ReplicationGroupId",
					"NodeGroupId"
				],
				"members": {
					"ReplicationGroupId": {},
					"NodeGroupId": {}
				}
			},
			"output": {
				"resultWrapper": "TestFailoverResult",
				"type": "structure",
				"members": {
					"ReplicationGroup": {
						"shape": "S1m"
					}
				}
			}
		}
	},
	"shapes": {
		"S3": {
			"type": "list",
			"member": {
				"locationName": "Tag",
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S5": {
			"type": "structure",
			"members": {
				"TagList": {
					"shape": "S3"
				}
			}
		},
		"S8": {
			"type": "structure",
			"members": {
				"OwnerId": {},
				"CacheSecurityGroupName": {},
				"Description": {},
				"EC2SecurityGroups": {
					"type": "list",
					"member": {
						"locationName": "EC2SecurityGroup",
						"type": "structure",
						"members": {
							"Status": {},
							"EC2SecurityGroupName": {},
							"EC2SecurityGroupOwnerId": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"Sd": {
			"type": "structure",
			"members": {
				"SnapshotName": {},
				"ReplicationGroupId": {},
				"ReplicationGroupDescription": {},
				"CacheClusterId": {},
				"SnapshotStatus": {},
				"SnapshotSource": {},
				"CacheNodeType": {},
				"Engine": {},
				"EngineVersion": {},
				"NumCacheNodes": {
					"type": "integer"
				},
				"PreferredAvailabilityZone": {},
				"CacheClusterCreateTime": {
					"type": "timestamp"
				},
				"PreferredMaintenanceWindow": {},
				"TopicArn": {},
				"Port": {
					"type": "integer"
				},
				"CacheParameterGroupName": {},
				"CacheSubnetGroupName": {},
				"VpcId": {},
				"AutoMinorVersionUpgrade": {
					"type": "boolean"
				},
				"SnapshotRetentionLimit": {
					"type": "integer"
				},
				"SnapshotWindow": {},
				"NumNodeGroups": {
					"type": "integer"
				},
				"AutomaticFailover": {},
				"NodeSnapshots": {
					"type": "list",
					"member": {
						"locationName": "NodeSnapshot",
						"type": "structure",
						"members": {
							"CacheClusterId": {},
							"NodeGroupId": {},
							"CacheNodeId": {},
							"NodeGroupConfiguration": {
								"shape": "Sk"
							},
							"CacheSize": {},
							"CacheNodeCreateTime": {
								"type": "timestamp"
							},
							"SnapshotCreateTime": {
								"type": "timestamp"
							}
						},
						"wrapper": true
					}
				}
			},
			"wrapper": true
		},
		"Sk": {
			"type": "structure",
			"members": {
				"Slots": {},
				"ReplicaCount": {
					"type": "integer"
				},
				"PrimaryAvailabilityZone": {},
				"ReplicaAvailabilityZones": {
					"shape": "Sl"
				}
			}
		},
		"Sl": {
			"type": "list",
			"member": {
				"locationName": "AvailabilityZone"
			}
		},
		"So": {
			"type": "list",
			"member": {
				"locationName": "PreferredAvailabilityZone"
			}
		},
		"Sp": {
			"type": "list",
			"member": {
				"locationName": "CacheSecurityGroupName"
			}
		},
		"Sq": {
			"type": "list",
			"member": {
				"locationName": "SecurityGroupId"
			}
		},
		"Sr": {
			"type": "list",
			"member": {
				"locationName": "SnapshotArn"
			}
		},
		"Su": {
			"type": "structure",
			"members": {
				"CacheClusterId": {},
				"ConfigurationEndpoint": {
					"shape": "Sv"
				},
				"ClientDownloadLandingPage": {},
				"CacheNodeType": {},
				"Engine": {},
				"EngineVersion": {},
				"CacheClusterStatus": {},
				"NumCacheNodes": {
					"type": "integer"
				},
				"PreferredAvailabilityZone": {},
				"CacheClusterCreateTime": {
					"type": "timestamp"
				},
				"PreferredMaintenanceWindow": {},
				"PendingModifiedValues": {
					"type": "structure",
					"members": {
						"NumCacheNodes": {
							"type": "integer"
						},
						"CacheNodeIdsToRemove": {
							"shape": "Sy"
						},
						"EngineVersion": {},
						"CacheNodeType": {}
					}
				},
				"NotificationConfiguration": {
					"type": "structure",
					"members": {
						"TopicArn": {},
						"TopicStatus": {}
					}
				},
				"CacheSecurityGroups": {
					"type": "list",
					"member": {
						"locationName": "CacheSecurityGroup",
						"type": "structure",
						"members": {
							"CacheSecurityGroupName": {},
							"Status": {}
						}
					}
				},
				"CacheParameterGroup": {
					"type": "structure",
					"members": {
						"CacheParameterGroupName": {},
						"ParameterApplyStatus": {},
						"CacheNodeIdsToReboot": {
							"shape": "Sy"
						}
					}
				},
				"CacheSubnetGroupName": {},
				"CacheNodes": {
					"type": "list",
					"member": {
						"locationName": "CacheNode",
						"type": "structure",
						"members": {
							"CacheNodeId": {},
							"CacheNodeStatus": {},
							"CacheNodeCreateTime": {
								"type": "timestamp"
							},
							"Endpoint": {
								"shape": "Sv"
							},
							"ParameterGroupStatus": {},
							"SourceCacheNodeId": {},
							"CustomerAvailabilityZone": {}
						}
					}
				},
				"AutoMinorVersionUpgrade": {
					"type": "boolean"
				},
				"SecurityGroups": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"SecurityGroupId": {},
							"Status": {}
						}
					}
				},
				"ReplicationGroupId": {},
				"SnapshotRetentionLimit": {
					"type": "integer"
				},
				"SnapshotWindow": {}
			},
			"wrapper": true
		},
		"Sv": {
			"type": "structure",
			"members": {
				"Address": {},
				"Port": {
					"type": "integer"
				}
			}
		},
		"Sy": {
			"type": "list",
			"member": {
				"locationName": "CacheNodeId"
			}
		},
		"S19": {
			"type": "structure",
			"members": {
				"CacheParameterGroupName": {},
				"CacheParameterGroupFamily": {},
				"Description": {}
			},
			"wrapper": true
		},
		"S1d": {
			"type": "list",
			"member": {
				"locationName": "SubnetIdentifier"
			}
		},
		"S1f": {
			"type": "structure",
			"members": {
				"CacheSubnetGroupName": {},
				"CacheSubnetGroupDescription": {},
				"VpcId": {},
				"Subnets": {
					"type": "list",
					"member": {
						"locationName": "Subnet",
						"type": "structure",
						"members": {
							"SubnetIdentifier": {},
							"SubnetAvailabilityZone": {
								"type": "structure",
								"members": {
									"Name": {}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"wrapper": true
		},
		"S1m": {
			"type": "structure",
			"members": {
				"ReplicationGroupId": {},
				"Description": {},
				"Status": {},
				"PendingModifiedValues": {
					"type": "structure",
					"members": {
						"PrimaryClusterId": {},
						"AutomaticFailoverStatus": {}
					}
				},
				"MemberClusters": {
					"type": "list",
					"member": {
						"locationName": "ClusterId"
					}
				},
				"NodeGroups": {
					"type": "list",
					"member": {
						"locationName": "NodeGroup",
						"type": "structure",
						"members": {
							"NodeGroupId": {},
							"Status": {},
							"PrimaryEndpoint": {
								"shape": "Sv"
							},
							"Slots": {},
							"NodeGroupMembers": {
								"type": "list",
								"member": {
									"locationName": "NodeGroupMember",
									"type": "structure",
									"members": {
										"CacheClusterId": {},
										"CacheNodeId": {},
										"ReadEndpoint": {
											"shape": "Sv"
										},
										"PreferredAvailabilityZone": {},
										"CurrentRole": {}
									}
								}
							}
						}
					}
				},
				"SnapshottingClusterId": {},
				"AutomaticFailover": {},
				"ConfigurationEndpoint": {
					"shape": "Sv"
				},
				"SnapshotRetentionLimit": {
					"type": "integer"
				},
				"SnapshotWindow": {},
				"ClusterEnabled": {
					"type": "boolean"
				},
				"CacheNodeType": {}
			},
			"wrapper": true
		},
		"S2h": {
			"type": "list",
			"member": {
				"locationName": "Parameter",
				"type": "structure",
				"members": {
					"ParameterName": {},
					"ParameterValue": {},
					"Description": {},
					"Source": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"MinimumEngineVersion": {},
					"ChangeType": {}
				}
			}
		},
		"S2k": {
			"type": "list",
			"member": {
				"locationName": "CacheNodeTypeSpecificParameter",
				"type": "structure",
				"members": {
					"ParameterName": {},
					"Description": {},
					"Source": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"MinimumEngineVersion": {},
					"CacheNodeTypeSpecificValues": {
						"type": "list",
						"member": {
							"locationName": "CacheNodeTypeSpecificValue",
							"type": "structure",
							"members": {
								"CacheNodeType": {},
								"Value": {}
							}
						}
					},
					"ChangeType": {}
				}
			}
		},
		"S38": {
			"type": "structure",
			"members": {
				"ReservedCacheNodeId": {},
				"ReservedCacheNodesOfferingId": {},
				"CacheNodeType": {},
				"StartTime": {
					"type": "timestamp"
				},
				"Duration": {
					"type": "integer"
				},
				"FixedPrice": {
					"type": "double"
				},
				"UsagePrice": {
					"type": "double"
				},
				"CacheNodeCount": {
					"type": "integer"
				},
				"ProductDescription": {},
				"OfferingType": {},
				"State": {},
				"RecurringCharges": {
					"shape": "S3a"
				}
			},
			"wrapper": true
		},
		"S3a": {
			"type": "list",
			"member": {
				"locationName": "RecurringCharge",
				"type": "structure",
				"members": {
					"RecurringChargeAmount": {
						"type": "double"
					},
					"RecurringChargeFrequency": {}
				},
				"wrapper": true
			}
		},
		"S3q": {
			"type": "list",
			"member": {
				"locationName": "ParameterNameValue",
				"type": "structure",
				"members": {
					"ParameterName": {},
					"ParameterValue": {}
				}
			}
		},
		"S3s": {
			"type": "structure",
			"members": {
				"CacheParameterGroupName": {}
			}
		}
	}
};

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeCacheClusters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "CacheClusters"
		},
		"DescribeCacheEngineVersions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "CacheEngineVersions"
		},
		"DescribeCacheParameterGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "CacheParameterGroups"
		},
		"DescribeCacheParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Parameters"
		},
		"DescribeCacheSecurityGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "CacheSecurityGroups"
		},
		"DescribeCacheSubnetGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "CacheSubnetGroups"
		},
		"DescribeEngineDefaultParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "EngineDefaults.Marker",
			"result_key": "EngineDefaults.Parameters"
		},
		"DescribeEvents": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Events"
		},
		"DescribeReplicationGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReplicationGroups"
		},
		"DescribeReservedCacheNodes": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedCacheNodes"
		},
		"DescribeReservedCacheNodesOfferings": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedCacheNodesOfferings"
		},
		"DescribeSnapshots": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Snapshots"
		}
	}
};

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"CacheClusterAvailable": {
			"acceptors": [
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "available",
					"matcher": "pathAll",
					"state": "success"
				},
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "deleted",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "deleting",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "incompatible-network",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "restore-failed",
					"matcher": "pathAny",
					"state": "failure"
				}
			],
			"delay": 15,
			"description": "Wait until ElastiCache cluster is available.",
			"maxAttempts": 40,
			"operation": "DescribeCacheClusters"
		},
		"CacheClusterDeleted": {
			"acceptors": [
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "deleted",
					"matcher": "pathAll",
					"state": "success"
				},
				{
					"expected": "CacheClusterNotFound",
					"matcher": "error",
					"state": "success"
				},
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "available",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "creating",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "incompatible-network",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "modifying",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "restore-failed",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"argument": "CacheClusters[].CacheClusterStatus",
					"expected": "snapshotting",
					"matcher": "pathAny",
					"state": "failure"
				}
			],
			"delay": 15,
			"description": "Wait until ElastiCache cluster is deleted.",
			"maxAttempts": 40,
			"operation": "DescribeCacheClusters"
		},
		"ReplicationGroupAvailable": {
			"acceptors": [
				{
					"argument": "ReplicationGroups[].Status",
					"expected": "available",
					"matcher": "pathAll",
					"state": "success"
				},
				{
					"argument": "ReplicationGroups[].Status",
					"expected": "deleted",
					"matcher": "pathAny",
					"state": "failure"
				}
			],
			"delay": 15,
			"description": "Wait until ElastiCache replication group is available.",
			"maxAttempts": 40,
			"operation": "DescribeReplicationGroups"
		},
		"ReplicationGroupDeleted": {
			"acceptors": [
				{
					"argument": "ReplicationGroups[].Status",
					"expected": "deleted",
					"matcher": "pathAll",
					"state": "success"
				},
				{
					"argument": "ReplicationGroups[].Status",
					"expected": "available",
					"matcher": "pathAny",
					"state": "failure"
				},
				{
					"expected": "ReplicationGroupNotFoundFault",
					"matcher": "error",
					"state": "success"
				}
			],
			"delay": 15,
			"description": "Wait until ElastiCache replication group is deleted.",
			"maxAttempts": 40,
			"operation": "DescribeReplicationGroups"
		}
	}
};

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elasticbeanstalk'] = {};
AWS.ElasticBeanstalk = Service.defineService('elasticbeanstalk', ['2010-12-01']);
Object.defineProperty(apiLoader.services['elasticbeanstalk'], '2010-12-01', {
  get: function get() {
    var model = __webpack_require__(1607);
    model.paginators = __webpack_require__(1608).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ElasticBeanstalk;


/***/ }),
/* 1607 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2010-12-01",
		"endpointPrefix": "elasticbeanstalk",
		"protocol": "query",
		"serviceAbbreviation": "Elastic Beanstalk",
		"serviceFullName": "AWS Elastic Beanstalk",
		"signatureVersion": "v4",
		"uid": "elasticbeanstalk-2010-12-01",
		"xmlNamespace": "http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"
	},
	"operations": {
		"AbortEnvironmentUpdate": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {}
				}
			}
		},
		"ApplyEnvironmentManagedAction": {
			"input": {
				"type": "structure",
				"required": [
					"ActionId"
				],
				"members": {
					"EnvironmentName": {},
					"EnvironmentId": {},
					"ActionId": {}
				}
			},
			"output": {
				"resultWrapper": "ApplyEnvironmentManagedActionResult",
				"type": "structure",
				"members": {
					"ActionId": {},
					"ActionDescription": {},
					"ActionType": {},
					"Status": {}
				}
			}
		},
		"CheckDNSAvailability": {
			"input": {
				"type": "structure",
				"required": [
					"CNAMEPrefix"
				],
				"members": {
					"CNAMEPrefix": {}
				}
			},
			"output": {
				"resultWrapper": "CheckDNSAvailabilityResult",
				"type": "structure",
				"members": {
					"Available": {
						"type": "boolean"
					},
					"FullyQualifiedCNAME": {}
				}
			}
		},
		"ComposeEnvironments": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"GroupName": {},
					"VersionLabels": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"shape": "Si",
				"resultWrapper": "ComposeEnvironmentsResult"
			}
		},
		"CreateApplication": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName"
				],
				"members": {
					"ApplicationName": {},
					"Description": {},
					"ResourceLifecycleConfig": {
						"shape": "S17"
					}
				}
			},
			"output": {
				"shape": "S1d",
				"resultWrapper": "CreateApplicationResult"
			}
		},
		"CreateApplicationVersion": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"VersionLabel"
				],
				"members": {
					"ApplicationName": {},
					"VersionLabel": {},
					"Description": {},
					"SourceBuildInformation": {
						"shape": "S1i"
					},
					"SourceBundle": {
						"shape": "S1m"
					},
					"BuildConfiguration": {
						"type": "structure",
						"required": [
							"CodeBuildServiceRole",
							"Image"
						],
						"members": {
							"ArtifactName": {},
							"CodeBuildServiceRole": {},
							"ComputeType": {},
							"Image": {},
							"TimeoutInMinutes": {
								"type": "integer"
							}
						}
					},
					"AutoCreateApplication": {
						"type": "boolean"
					},
					"Process": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S1u",
				"resultWrapper": "CreateApplicationVersionResult"
			}
		},
		"CreateConfigurationTemplate": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"TemplateName"
				],
				"members": {
					"ApplicationName": {},
					"TemplateName": {},
					"SolutionStackName": {},
					"PlatformArn": {},
					"SourceConfiguration": {
						"type": "structure",
						"members": {
							"ApplicationName": {},
							"TemplateName": {}
						}
					},
					"EnvironmentId": {},
					"Description": {},
					"OptionSettings": {
						"shape": "S1z"
					}
				}
			},
			"output": {
				"shape": "S25",
				"resultWrapper": "CreateConfigurationTemplateResult"
			}
		},
		"CreateEnvironment": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName"
				],
				"members": {
					"ApplicationName": {},
					"EnvironmentName": {},
					"GroupName": {},
					"Description": {},
					"CNAMEPrefix": {},
					"Tier": {
						"shape": "S11"
					},
					"Tags": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					},
					"VersionLabel": {},
					"TemplateName": {},
					"SolutionStackName": {},
					"PlatformArn": {},
					"OptionSettings": {
						"shape": "S1z"
					},
					"OptionsToRemove": {
						"shape": "S2c"
					}
				}
			},
			"output": {
				"shape": "Sk",
				"resultWrapper": "CreateEnvironmentResult"
			}
		},
		"CreatePlatformVersion": {
			"input": {
				"type": "structure",
				"required": [
					"PlatformName",
					"PlatformVersion",
					"PlatformDefinitionBundle"
				],
				"members": {
					"PlatformName": {},
					"PlatformVersion": {},
					"PlatformDefinitionBundle": {
						"shape": "S1m"
					},
					"EnvironmentName": {},
					"OptionSettings": {
						"shape": "S1z"
					}
				}
			},
			"output": {
				"resultWrapper": "CreatePlatformVersionResult",
				"type": "structure",
				"members": {
					"PlatformSummary": {
						"shape": "S2i"
					},
					"Builder": {
						"type": "structure",
						"members": {
							"ARN": {}
						}
					}
				}
			}
		},
		"CreateStorageLocation": {
			"output": {
				"resultWrapper": "CreateStorageLocationResult",
				"type": "structure",
				"members": {
					"S3Bucket": {}
				}
			}
		},
		"DeleteApplication": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName"
				],
				"members": {
					"ApplicationName": {},
					"TerminateEnvByForce": {
						"type": "boolean"
					}
				}
			}
		},
		"DeleteApplicationVersion": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"VersionLabel"
				],
				"members": {
					"ApplicationName": {},
					"VersionLabel": {},
					"DeleteSourceBundle": {
						"type": "boolean"
					}
				}
			}
		},
		"DeleteConfigurationTemplate": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"TemplateName"
				],
				"members": {
					"ApplicationName": {},
					"TemplateName": {}
				}
			}
		},
		"DeleteEnvironmentConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"EnvironmentName"
				],
				"members": {
					"ApplicationName": {},
					"EnvironmentName": {}
				}
			}
		},
		"DeletePlatformVersion": {
			"input": {
				"type": "structure",
				"members": {
					"PlatformArn": {}
				}
			},
			"output": {
				"resultWrapper": "DeletePlatformVersionResult",
				"type": "structure",
				"members": {
					"PlatformSummary": {
						"shape": "S2i"
					}
				}
			}
		},
		"DescribeApplicationVersions": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"VersionLabels": {
						"shape": "S1f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeApplicationVersionsResult",
				"type": "structure",
				"members": {
					"ApplicationVersions": {
						"type": "list",
						"member": {
							"shape": "S1v"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeApplications": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeApplicationsResult",
				"type": "structure",
				"members": {
					"Applications": {
						"type": "list",
						"member": {
							"shape": "S1e"
						}
					}
				}
			}
		},
		"DescribeConfigurationOptions": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"TemplateName": {},
					"EnvironmentName": {},
					"SolutionStackName": {},
					"PlatformArn": {},
					"Options": {
						"shape": "S2c"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeConfigurationOptionsResult",
				"type": "structure",
				"members": {
					"SolutionStackName": {},
					"PlatformArn": {},
					"Options": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Namespace": {},
								"Name": {},
								"DefaultValue": {},
								"ChangeSeverity": {},
								"UserDefined": {
									"type": "boolean"
								},
								"ValueType": {},
								"ValueOptions": {
									"type": "list",
									"member": {}
								},
								"MinValue": {
									"type": "integer"
								},
								"MaxValue": {
									"type": "integer"
								},
								"MaxLength": {
									"type": "integer"
								},
								"Regex": {
									"type": "structure",
									"members": {
										"Pattern": {},
										"Label": {}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeConfigurationSettings": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName"
				],
				"members": {
					"ApplicationName": {},
					"TemplateName": {},
					"EnvironmentName": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeConfigurationSettingsResult",
				"type": "structure",
				"members": {
					"ConfigurationSettings": {
						"type": "list",
						"member": {
							"shape": "S25"
						}
					}
				}
			}
		},
		"DescribeEnvironmentHealth": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentName": {},
					"EnvironmentId": {},
					"AttributeNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeEnvironmentHealthResult",
				"type": "structure",
				"members": {
					"EnvironmentName": {},
					"HealthStatus": {},
					"Status": {},
					"Color": {},
					"Causes": {
						"shape": "S3y"
					},
					"ApplicationMetrics": {
						"shape": "S40"
					},
					"InstancesHealth": {
						"type": "structure",
						"members": {
							"NoData": {
								"type": "integer"
							},
							"Unknown": {
								"type": "integer"
							},
							"Pending": {
								"type": "integer"
							},
							"Ok": {
								"type": "integer"
							},
							"Info": {
								"type": "integer"
							},
							"Warning": {
								"type": "integer"
							},
							"Degraded": {
								"type": "integer"
							},
							"Severe": {
								"type": "integer"
							}
						}
					},
					"RefreshedAt": {
						"type": "timestamp"
					}
				}
			}
		},
		"DescribeEnvironmentManagedActionHistory": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {},
					"NextToken": {},
					"MaxItems": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeEnvironmentManagedActionHistoryResult",
				"type": "structure",
				"members": {
					"ManagedActionHistoryItems": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ActionId": {},
								"ActionType": {},
								"ActionDescription": {},
								"FailureType": {},
								"Status": {},
								"FailureDescription": {},
								"ExecutedTime": {
									"type": "timestamp"
								},
								"FinishedTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeEnvironmentManagedActions": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentName": {},
					"EnvironmentId": {},
					"Status": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEnvironmentManagedActionsResult",
				"type": "structure",
				"members": {
					"ManagedActions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ActionId": {},
								"ActionDescription": {},
								"ActionType": {},
								"Status": {},
								"WindowStartTime": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeEnvironmentResources": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEnvironmentResourcesResult",
				"type": "structure",
				"members": {
					"EnvironmentResources": {
						"type": "structure",
						"members": {
							"EnvironmentName": {},
							"AutoScalingGroups": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {}
									}
								}
							},
							"Instances": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Id": {}
									}
								}
							},
							"LaunchConfigurations": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {}
									}
								}
							},
							"LoadBalancers": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {}
									}
								}
							},
							"Triggers": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {}
									}
								}
							},
							"Queues": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {},
										"URL": {}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeEnvironments": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"VersionLabel": {},
					"EnvironmentIds": {
						"type": "list",
						"member": {}
					},
					"EnvironmentNames": {
						"type": "list",
						"member": {}
					},
					"IncludeDeleted": {
						"type": "boolean"
					},
					"IncludedDeletedBackTo": {
						"type": "timestamp"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"shape": "Si",
				"resultWrapper": "DescribeEnvironmentsResult"
			}
		},
		"DescribeEvents": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"VersionLabel": {},
					"TemplateName": {},
					"EnvironmentId": {},
					"EnvironmentName": {},
					"PlatformArn": {},
					"RequestId": {},
					"Severity": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventsResult",
				"type": "structure",
				"members": {
					"Events": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EventDate": {
									"type": "timestamp"
								},
								"Message": {},
								"ApplicationName": {},
								"VersionLabel": {},
								"TemplateName": {},
								"EnvironmentName": {},
								"PlatformArn": {},
								"RequestId": {},
								"Severity": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeInstancesHealth": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentName": {},
					"EnvironmentId": {},
					"AttributeNames": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeInstancesHealthResult",
				"type": "structure",
				"members": {
					"InstanceHealthList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"InstanceId": {},
								"HealthStatus": {},
								"Color": {},
								"Causes": {
									"shape": "S3y"
								},
								"LaunchedAt": {
									"type": "timestamp"
								},
								"ApplicationMetrics": {
									"shape": "S40"
								},
								"System": {
									"type": "structure",
									"members": {
										"CPUUtilization": {
											"type": "structure",
											"members": {
												"User": {
													"type": "double"
												},
												"Nice": {
													"type": "double"
												},
												"System": {
													"type": "double"
												},
												"Idle": {
													"type": "double"
												},
												"IOWait": {
													"type": "double"
												},
												"IRQ": {
													"type": "double"
												},
												"SoftIRQ": {
													"type": "double"
												}
											}
										},
										"LoadAverage": {
											"type": "list",
											"member": {
												"type": "double"
											}
										}
									}
								},
								"Deployment": {
									"type": "structure",
									"members": {
										"VersionLabel": {},
										"DeploymentId": {
											"type": "long"
										},
										"Status": {},
										"DeploymentTime": {
											"type": "timestamp"
										}
									}
								},
								"AvailabilityZone": {},
								"InstanceType": {}
							}
						}
					},
					"RefreshedAt": {
						"type": "timestamp"
					},
					"NextToken": {}
				}
			}
		},
		"DescribePlatformVersion": {
			"input": {
				"type": "structure",
				"members": {
					"PlatformArn": {}
				}
			},
			"output": {
				"resultWrapper": "DescribePlatformVersionResult",
				"type": "structure",
				"members": {
					"PlatformDescription": {
						"type": "structure",
						"members": {
							"PlatformArn": {},
							"PlatformOwner": {},
							"PlatformName": {},
							"PlatformVersion": {},
							"SolutionStackName": {},
							"PlatformStatus": {},
							"DateCreated": {
								"type": "timestamp"
							},
							"DateUpdated": {
								"type": "timestamp"
							},
							"PlatformCategory": {},
							"Description": {},
							"Maintainer": {},
							"OperatingSystemName": {},
							"OperatingSystemVersion": {},
							"ProgrammingLanguages": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {},
										"Version": {}
									}
								}
							},
							"Frameworks": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {},
										"Version": {}
									}
								}
							},
							"CustomAmiList": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"VirtualizationType": {},
										"ImageId": {}
									}
								}
							},
							"SupportedTierList": {
								"shape": "S2o"
							},
							"SupportedAddonList": {
								"shape": "S2q"
							}
						}
					}
				}
			}
		},
		"ListAvailableSolutionStacks": {
			"output": {
				"resultWrapper": "ListAvailableSolutionStacksResult",
				"type": "structure",
				"members": {
					"SolutionStacks": {
						"type": "list",
						"member": {}
					},
					"SolutionStackDetails": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"SolutionStackName": {},
								"PermittedFileTypes": {
									"type": "list",
									"member": {}
								}
							}
						}
					}
				}
			}
		},
		"ListPlatformVersions": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Type": {},
								"Operator": {},
								"Values": {
									"type": "list",
									"member": {}
								}
							}
						}
					},
					"MaxRecords": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListPlatformVersionsResult",
				"type": "structure",
				"members": {
					"PlatformSummaryList": {
						"type": "list",
						"member": {
							"shape": "S2i"
						}
					},
					"NextToken": {}
				}
			}
		},
		"RebuildEnvironment": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {}
				}
			}
		},
		"RequestEnvironmentInfo": {
			"input": {
				"type": "structure",
				"required": [
					"InfoType"
				],
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {},
					"InfoType": {}
				}
			}
		},
		"RestartAppServer": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {}
				}
			}
		},
		"RetrieveEnvironmentInfo": {
			"input": {
				"type": "structure",
				"required": [
					"InfoType"
				],
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {},
					"InfoType": {}
				}
			},
			"output": {
				"resultWrapper": "RetrieveEnvironmentInfoResult",
				"type": "structure",
				"members": {
					"EnvironmentInfo": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"InfoType": {},
								"Ec2InstanceId": {},
								"SampleTimestamp": {
									"type": "timestamp"
								},
								"Message": {}
							}
						}
					}
				}
			}
		},
		"SwapEnvironmentCNAMEs": {
			"input": {
				"type": "structure",
				"members": {
					"SourceEnvironmentId": {},
					"SourceEnvironmentName": {},
					"DestinationEnvironmentId": {},
					"DestinationEnvironmentName": {}
				}
			}
		},
		"TerminateEnvironment": {
			"input": {
				"type": "structure",
				"members": {
					"EnvironmentId": {},
					"EnvironmentName": {},
					"TerminateResources": {
						"type": "boolean"
					},
					"ForceTerminate": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "Sk",
				"resultWrapper": "TerminateEnvironmentResult"
			}
		},
		"UpdateApplication": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName"
				],
				"members": {
					"ApplicationName": {},
					"Description": {}
				}
			},
			"output": {
				"shape": "S1d",
				"resultWrapper": "UpdateApplicationResult"
			}
		},
		"UpdateApplicationResourceLifecycle": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"ResourceLifecycleConfig"
				],
				"members": {
					"ApplicationName": {},
					"ResourceLifecycleConfig": {
						"shape": "S17"
					}
				}
			},
			"output": {
				"resultWrapper": "UpdateApplicationResourceLifecycleResult",
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"ResourceLifecycleConfig": {
						"shape": "S17"
					}
				}
			}
		},
		"UpdateApplicationVersion": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"VersionLabel"
				],
				"members": {
					"ApplicationName": {},
					"VersionLabel": {},
					"Description": {}
				}
			},
			"output": {
				"shape": "S1u",
				"resultWrapper": "UpdateApplicationVersionResult"
			}
		},
		"UpdateConfigurationTemplate": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"TemplateName"
				],
				"members": {
					"ApplicationName": {},
					"TemplateName": {},
					"Description": {},
					"OptionSettings": {
						"shape": "S1z"
					},
					"OptionsToRemove": {
						"shape": "S2c"
					}
				}
			},
			"output": {
				"shape": "S25",
				"resultWrapper": "UpdateConfigurationTemplateResult"
			}
		},
		"UpdateEnvironment": {
			"input": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"EnvironmentId": {},
					"EnvironmentName": {},
					"GroupName": {},
					"Description": {},
					"Tier": {
						"shape": "S11"
					},
					"VersionLabel": {},
					"TemplateName": {},
					"SolutionStackName": {},
					"PlatformArn": {},
					"OptionSettings": {
						"shape": "S1z"
					},
					"OptionsToRemove": {
						"shape": "S2c"
					}
				}
			},
			"output": {
				"shape": "Sk",
				"resultWrapper": "UpdateEnvironmentResult"
			}
		},
		"ValidateConfigurationSettings": {
			"input": {
				"type": "structure",
				"required": [
					"ApplicationName",
					"OptionSettings"
				],
				"members": {
					"ApplicationName": {},
					"TemplateName": {},
					"EnvironmentName": {},
					"OptionSettings": {
						"shape": "S1z"
					}
				}
			},
			"output": {
				"resultWrapper": "ValidateConfigurationSettingsResult",
				"type": "structure",
				"members": {
					"Messages": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Message": {},
								"Severity": {},
								"Namespace": {},
								"OptionName": {}
							}
						}
					}
				}
			}
		}
	},
	"shapes": {
		"Si": {
			"type": "structure",
			"members": {
				"Environments": {
					"type": "list",
					"member": {
						"shape": "Sk"
					}
				},
				"NextToken": {}
			}
		},
		"Sk": {
			"type": "structure",
			"members": {
				"EnvironmentName": {},
				"EnvironmentId": {},
				"ApplicationName": {},
				"VersionLabel": {},
				"SolutionStackName": {},
				"PlatformArn": {},
				"TemplateName": {},
				"Description": {},
				"EndpointURL": {},
				"CNAME": {},
				"DateCreated": {
					"type": "timestamp"
				},
				"DateUpdated": {
					"type": "timestamp"
				},
				"Status": {},
				"AbortableOperationInProgress": {
					"type": "boolean"
				},
				"Health": {},
				"HealthStatus": {},
				"Resources": {
					"type": "structure",
					"members": {
						"LoadBalancer": {
							"type": "structure",
							"members": {
								"LoadBalancerName": {},
								"Domain": {},
								"Listeners": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Protocol": {},
											"Port": {
												"type": "integer"
											}
										}
									}
								}
							}
						}
					}
				},
				"Tier": {
					"shape": "S11"
				},
				"EnvironmentLinks": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"LinkName": {},
							"EnvironmentName": {}
						}
					}
				},
				"EnvironmentArn": {}
			}
		},
		"S11": {
			"type": "structure",
			"members": {
				"Name": {},
				"Type": {},
				"Version": {}
			}
		},
		"S17": {
			"type": "structure",
			"members": {
				"ServiceRole": {},
				"VersionLifecycleConfig": {
					"type": "structure",
					"members": {
						"MaxCountRule": {
							"type": "structure",
							"required": [
								"Enabled"
							],
							"members": {
								"Enabled": {
									"type": "boolean"
								},
								"MaxCount": {
									"type": "integer"
								},
								"DeleteSourceFromS3": {
									"type": "boolean"
								}
							}
						},
						"MaxAgeRule": {
							"type": "structure",
							"required": [
								"Enabled"
							],
							"members": {
								"Enabled": {
									"type": "boolean"
								},
								"MaxAgeInDays": {
									"type": "integer"
								},
								"DeleteSourceFromS3": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		},
		"S1d": {
			"type": "structure",
			"members": {
				"Application": {
					"shape": "S1e"
				}
			}
		},
		"S1e": {
			"type": "structure",
			"members": {
				"ApplicationName": {},
				"Description": {},
				"DateCreated": {
					"type": "timestamp"
				},
				"DateUpdated": {
					"type": "timestamp"
				},
				"Versions": {
					"shape": "S1f"
				},
				"ConfigurationTemplates": {
					"type": "list",
					"member": {}
				},
				"ResourceLifecycleConfig": {
					"shape": "S17"
				}
			}
		},
		"S1f": {
			"type": "list",
			"member": {}
		},
		"S1i": {
			"type": "structure",
			"required": [
				"SourceType",
				"SourceRepository",
				"SourceLocation"
			],
			"members": {
				"SourceType": {},
				"SourceRepository": {},
				"SourceLocation": {}
			}
		},
		"S1m": {
			"type": "structure",
			"members": {
				"S3Bucket": {},
				"S3Key": {}
			}
		},
		"S1u": {
			"type": "structure",
			"members": {
				"ApplicationVersion": {
					"shape": "S1v"
				}
			}
		},
		"S1v": {
			"type": "structure",
			"members": {
				"ApplicationName": {},
				"Description": {},
				"VersionLabel": {},
				"SourceBuildInformation": {
					"shape": "S1i"
				},
				"BuildArn": {},
				"SourceBundle": {
					"shape": "S1m"
				},
				"DateCreated": {
					"type": "timestamp"
				},
				"DateUpdated": {
					"type": "timestamp"
				},
				"Status": {}
			}
		},
		"S1z": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ResourceName": {},
					"Namespace": {},
					"OptionName": {},
					"Value": {}
				}
			}
		},
		"S25": {
			"type": "structure",
			"members": {
				"SolutionStackName": {},
				"PlatformArn": {},
				"ApplicationName": {},
				"TemplateName": {},
				"Description": {},
				"EnvironmentName": {},
				"DeploymentStatus": {},
				"DateCreated": {
					"type": "timestamp"
				},
				"DateUpdated": {
					"type": "timestamp"
				},
				"OptionSettings": {
					"shape": "S1z"
				}
			}
		},
		"S2c": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ResourceName": {},
					"Namespace": {},
					"OptionName": {}
				}
			}
		},
		"S2i": {
			"type": "structure",
			"members": {
				"PlatformArn": {},
				"PlatformOwner": {},
				"PlatformStatus": {},
				"PlatformCategory": {},
				"OperatingSystemName": {},
				"OperatingSystemVersion": {},
				"SupportedTierList": {
					"shape": "S2o"
				},
				"SupportedAddonList": {
					"shape": "S2q"
				}
			}
		},
		"S2o": {
			"type": "list",
			"member": {}
		},
		"S2q": {
			"type": "list",
			"member": {}
		},
		"S3y": {
			"type": "list",
			"member": {}
		},
		"S40": {
			"type": "structure",
			"members": {
				"Duration": {
					"type": "integer"
				},
				"RequestCount": {
					"type": "integer"
				},
				"StatusCodes": {
					"type": "structure",
					"members": {
						"Status2xx": {
							"type": "integer"
						},
						"Status3xx": {
							"type": "integer"
						},
						"Status4xx": {
							"type": "integer"
						},
						"Status5xx": {
							"type": "integer"
						}
					}
				},
				"Latency": {
					"type": "structure",
					"members": {
						"P999": {
							"type": "double"
						},
						"P99": {
							"type": "double"
						},
						"P95": {
							"type": "double"
						},
						"P90": {
							"type": "double"
						},
						"P85": {
							"type": "double"
						},
						"P75": {
							"type": "double"
						},
						"P50": {
							"type": "double"
						},
						"P10": {
							"type": "double"
						}
					}
				}
			}
		}
	}
};

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeApplicationVersions": {
			"result_key": "ApplicationVersions"
		},
		"DescribeApplications": {
			"result_key": "Applications"
		},
		"DescribeConfigurationOptions": {
			"result_key": "Options"
		},
		"DescribeEnvironments": {
			"result_key": "Environments"
		},
		"DescribeEvents": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "Events"
		},
		"ListAvailableSolutionStacks": {
			"result_key": "SolutionStacks"
		}
	}
};

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elb'] = {};
AWS.ELB = Service.defineService('elb', ['2012-06-01']);
Object.defineProperty(apiLoader.services['elb'], '2012-06-01', {
  get: function get() {
    var model = __webpack_require__(1610);
    model.paginators = __webpack_require__(1611).pagination;
    model.waiters = __webpack_require__(1612).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ELB;


/***/ }),
/* 1610 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2012-06-01",
		"endpointPrefix": "elasticloadbalancing",
		"protocol": "query",
		"serviceFullName": "Elastic Load Balancing",
		"signatureVersion": "v4",
		"uid": "elasticloadbalancing-2012-06-01",
		"xmlNamespace": "http://elasticloadbalancing.amazonaws.com/doc/2012-06-01/"
	},
	"operations": {
		"AddTags": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerNames",
					"Tags"
				],
				"members": {
					"LoadBalancerNames": {
						"shape": "S2"
					},
					"Tags": {
						"shape": "S4"
					}
				}
			},
			"output": {
				"resultWrapper": "AddTagsResult",
				"type": "structure",
				"members": {}
			}
		},
		"ApplySecurityGroupsToLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"SecurityGroups"
				],
				"members": {
					"LoadBalancerName": {},
					"SecurityGroups": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "ApplySecurityGroupsToLoadBalancerResult",
				"type": "structure",
				"members": {
					"SecurityGroups": {
						"shape": "Sa"
					}
				}
			}
		},
		"AttachLoadBalancerToSubnets": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"Subnets"
				],
				"members": {
					"LoadBalancerName": {},
					"Subnets": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"resultWrapper": "AttachLoadBalancerToSubnetsResult",
				"type": "structure",
				"members": {
					"Subnets": {
						"shape": "Se"
					}
				}
			}
		},
		"ConfigureHealthCheck": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"HealthCheck"
				],
				"members": {
					"LoadBalancerName": {},
					"HealthCheck": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"resultWrapper": "ConfigureHealthCheckResult",
				"type": "structure",
				"members": {
					"HealthCheck": {
						"shape": "Si"
					}
				}
			}
		},
		"CreateAppCookieStickinessPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"PolicyName",
					"CookieName"
				],
				"members": {
					"LoadBalancerName": {},
					"PolicyName": {},
					"CookieName": {}
				}
			},
			"output": {
				"resultWrapper": "CreateAppCookieStickinessPolicyResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateLBCookieStickinessPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"PolicyName"
				],
				"members": {
					"LoadBalancerName": {},
					"PolicyName": {},
					"CookieExpirationPeriod": {
						"type": "long"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateLBCookieStickinessPolicyResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"Listeners"
				],
				"members": {
					"LoadBalancerName": {},
					"Listeners": {
						"shape": "Sx"
					},
					"AvailabilityZones": {
						"shape": "S13"
					},
					"Subnets": {
						"shape": "Se"
					},
					"SecurityGroups": {
						"shape": "Sa"
					},
					"Scheme": {},
					"Tags": {
						"shape": "S4"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateLoadBalancerResult",
				"type": "structure",
				"members": {
					"DNSName": {}
				}
			}
		},
		"CreateLoadBalancerListeners": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"Listeners"
				],
				"members": {
					"LoadBalancerName": {},
					"Listeners": {
						"shape": "Sx"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateLoadBalancerListenersResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateLoadBalancerPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"PolicyName",
					"PolicyTypeName"
				],
				"members": {
					"LoadBalancerName": {},
					"PolicyName": {},
					"PolicyTypeName": {},
					"PolicyAttributes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AttributeName": {},
								"AttributeValue": {}
							}
						}
					}
				}
			},
			"output": {
				"resultWrapper": "CreateLoadBalancerPolicyResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName"
				],
				"members": {
					"LoadBalancerName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteLoadBalancerResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteLoadBalancerListeners": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"LoadBalancerPorts"
				],
				"members": {
					"LoadBalancerName": {},
					"LoadBalancerPorts": {
						"type": "list",
						"member": {
							"type": "integer"
						}
					}
				}
			},
			"output": {
				"resultWrapper": "DeleteLoadBalancerListenersResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteLoadBalancerPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"PolicyName"
				],
				"members": {
					"LoadBalancerName": {},
					"PolicyName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteLoadBalancerPolicyResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeregisterInstancesFromLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"Instances"
				],
				"members": {
					"LoadBalancerName": {},
					"Instances": {
						"shape": "S1p"
					}
				}
			},
			"output": {
				"resultWrapper": "DeregisterInstancesFromLoadBalancerResult",
				"type": "structure",
				"members": {
					"Instances": {
						"shape": "S1p"
					}
				}
			}
		},
		"DescribeAccountLimits": {
			"input": {
				"type": "structure",
				"members": {
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeAccountLimitsResult",
				"type": "structure",
				"members": {
					"Limits": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Max": {}
							}
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeInstanceHealth": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName"
				],
				"members": {
					"LoadBalancerName": {},
					"Instances": {
						"shape": "S1p"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeInstanceHealthResult",
				"type": "structure",
				"members": {
					"InstanceStates": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"InstanceId": {},
								"State": {},
								"ReasonCode": {},
								"Description": {}
							}
						}
					}
				}
			}
		},
		"DescribeLoadBalancerAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName"
				],
				"members": {
					"LoadBalancerName": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeLoadBalancerAttributesResult",
				"type": "structure",
				"members": {
					"LoadBalancerAttributes": {
						"shape": "S2a"
					}
				}
			}
		},
		"DescribeLoadBalancerPolicies": {
			"input": {
				"type": "structure",
				"members": {
					"LoadBalancerName": {},
					"PolicyNames": {
						"shape": "S2s"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeLoadBalancerPoliciesResult",
				"type": "structure",
				"members": {
					"PolicyDescriptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PolicyName": {},
								"PolicyTypeName": {},
								"PolicyAttributeDescriptions": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"AttributeName": {},
											"AttributeValue": {}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeLoadBalancerPolicyTypes": {
			"input": {
				"type": "structure",
				"members": {
					"PolicyTypeNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeLoadBalancerPolicyTypesResult",
				"type": "structure",
				"members": {
					"PolicyTypeDescriptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PolicyTypeName": {},
								"Description": {},
								"PolicyAttributeTypeDescriptions": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"AttributeName": {},
											"AttributeType": {},
											"Description": {},
											"DefaultValue": {},
											"Cardinality": {}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeLoadBalancers": {
			"input": {
				"type": "structure",
				"members": {
					"LoadBalancerNames": {
						"shape": "S2"
					},
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeLoadBalancersResult",
				"type": "structure",
				"members": {
					"LoadBalancerDescriptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"LoadBalancerName": {},
								"DNSName": {},
								"CanonicalHostedZoneName": {},
								"CanonicalHostedZoneNameID": {},
								"ListenerDescriptions": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Listener": {
												"shape": "Sy"
											},
											"PolicyNames": {
												"shape": "S2s"
											}
										}
									}
								},
								"Policies": {
									"type": "structure",
									"members": {
										"AppCookieStickinessPolicies": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"PolicyName": {},
													"CookieName": {}
												}
											}
										},
										"LBCookieStickinessPolicies": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"PolicyName": {},
													"CookieExpirationPeriod": {
														"type": "long"
													}
												}
											}
										},
										"OtherPolicies": {
											"shape": "S2s"
										}
									}
								},
								"BackendServerDescriptions": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"InstancePort": {
												"type": "integer"
											},
											"PolicyNames": {
												"shape": "S2s"
											}
										}
									}
								},
								"AvailabilityZones": {
									"shape": "S13"
								},
								"Subnets": {
									"shape": "Se"
								},
								"VPCId": {},
								"Instances": {
									"shape": "S1p"
								},
								"HealthCheck": {
									"shape": "Si"
								},
								"SourceSecurityGroup": {
									"type": "structure",
									"members": {
										"OwnerAlias": {},
										"GroupName": {}
									}
								},
								"SecurityGroups": {
									"shape": "Sa"
								},
								"CreatedTime": {
									"type": "timestamp"
								},
								"Scheme": {}
							}
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeTags": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerNames"
				],
				"members": {
					"LoadBalancerNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeTagsResult",
				"type": "structure",
				"members": {
					"TagDescriptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"LoadBalancerName": {},
								"Tags": {
									"shape": "S4"
								}
							}
						}
					}
				}
			}
		},
		"DetachLoadBalancerFromSubnets": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"Subnets"
				],
				"members": {
					"LoadBalancerName": {},
					"Subnets": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"resultWrapper": "DetachLoadBalancerFromSubnetsResult",
				"type": "structure",
				"members": {
					"Subnets": {
						"shape": "Se"
					}
				}
			}
		},
		"DisableAvailabilityZonesForLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"AvailabilityZones"
				],
				"members": {
					"LoadBalancerName": {},
					"AvailabilityZones": {
						"shape": "S13"
					}
				}
			},
			"output": {
				"resultWrapper": "DisableAvailabilityZonesForLoadBalancerResult",
				"type": "structure",
				"members": {
					"AvailabilityZones": {
						"shape": "S13"
					}
				}
			}
		},
		"EnableAvailabilityZonesForLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"AvailabilityZones"
				],
				"members": {
					"LoadBalancerName": {},
					"AvailabilityZones": {
						"shape": "S13"
					}
				}
			},
			"output": {
				"resultWrapper": "EnableAvailabilityZonesForLoadBalancerResult",
				"type": "structure",
				"members": {
					"AvailabilityZones": {
						"shape": "S13"
					}
				}
			}
		},
		"ModifyLoadBalancerAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"LoadBalancerAttributes"
				],
				"members": {
					"LoadBalancerName": {},
					"LoadBalancerAttributes": {
						"shape": "S2a"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyLoadBalancerAttributesResult",
				"type": "structure",
				"members": {
					"LoadBalancerName": {},
					"LoadBalancerAttributes": {
						"shape": "S2a"
					}
				}
			}
		},
		"RegisterInstancesWithLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"Instances"
				],
				"members": {
					"LoadBalancerName": {},
					"Instances": {
						"shape": "S1p"
					}
				}
			},
			"output": {
				"resultWrapper": "RegisterInstancesWithLoadBalancerResult",
				"type": "structure",
				"members": {
					"Instances": {
						"shape": "S1p"
					}
				}
			}
		},
		"RemoveTags": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerNames",
					"Tags"
				],
				"members": {
					"LoadBalancerNames": {
						"shape": "S2"
					},
					"Tags": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {}
							}
						}
					}
				}
			},
			"output": {
				"resultWrapper": "RemoveTagsResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetLoadBalancerListenerSSLCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"LoadBalancerPort",
					"SSLCertificateId"
				],
				"members": {
					"LoadBalancerName": {},
					"LoadBalancerPort": {
						"type": "integer"
					},
					"SSLCertificateId": {}
				}
			},
			"output": {
				"resultWrapper": "SetLoadBalancerListenerSSLCertificateResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetLoadBalancerPoliciesForBackendServer": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"InstancePort",
					"PolicyNames"
				],
				"members": {
					"LoadBalancerName": {},
					"InstancePort": {
						"type": "integer"
					},
					"PolicyNames": {
						"shape": "S2s"
					}
				}
			},
			"output": {
				"resultWrapper": "SetLoadBalancerPoliciesForBackendServerResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetLoadBalancerPoliciesOfListener": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerName",
					"LoadBalancerPort",
					"PolicyNames"
				],
				"members": {
					"LoadBalancerName": {},
					"LoadBalancerPort": {
						"type": "integer"
					},
					"PolicyNames": {
						"shape": "S2s"
					}
				}
			},
			"output": {
				"resultWrapper": "SetLoadBalancerPoliciesOfListenerResult",
				"type": "structure",
				"members": {}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "list",
			"member": {}
		},
		"S4": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Sa": {
			"type": "list",
			"member": {}
		},
		"Se": {
			"type": "list",
			"member": {}
		},
		"Si": {
			"type": "structure",
			"required": [
				"Target",
				"Interval",
				"Timeout",
				"UnhealthyThreshold",
				"HealthyThreshold"
			],
			"members": {
				"Target": {},
				"Interval": {
					"type": "integer"
				},
				"Timeout": {
					"type": "integer"
				},
				"UnhealthyThreshold": {
					"type": "integer"
				},
				"HealthyThreshold": {
					"type": "integer"
				}
			}
		},
		"Sx": {
			"type": "list",
			"member": {
				"shape": "Sy"
			}
		},
		"Sy": {
			"type": "structure",
			"required": [
				"Protocol",
				"LoadBalancerPort",
				"InstancePort"
			],
			"members": {
				"Protocol": {},
				"LoadBalancerPort": {
					"type": "integer"
				},
				"InstanceProtocol": {},
				"InstancePort": {
					"type": "integer"
				},
				"SSLCertificateId": {}
			}
		},
		"S13": {
			"type": "list",
			"member": {}
		},
		"S1p": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"InstanceId": {}
				}
			}
		},
		"S2a": {
			"type": "structure",
			"members": {
				"CrossZoneLoadBalancing": {
					"type": "structure",
					"required": [
						"Enabled"
					],
					"members": {
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"AccessLog": {
					"type": "structure",
					"required": [
						"Enabled"
					],
					"members": {
						"Enabled": {
							"type": "boolean"
						},
						"S3BucketName": {},
						"EmitInterval": {
							"type": "integer"
						},
						"S3BucketPrefix": {}
					}
				},
				"ConnectionDraining": {
					"type": "structure",
					"required": [
						"Enabled"
					],
					"members": {
						"Enabled": {
							"type": "boolean"
						},
						"Timeout": {
							"type": "integer"
						}
					}
				},
				"ConnectionSettings": {
					"type": "structure",
					"required": [
						"IdleTimeout"
					],
					"members": {
						"IdleTimeout": {
							"type": "integer"
						}
					}
				},
				"AdditionalAttributes": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Key": {},
							"Value": {}
						}
					}
				}
			}
		},
		"S2s": {
			"type": "list",
			"member": {}
		}
	}
};

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeInstanceHealth": {
			"result_key": "InstanceStates"
		},
		"DescribeLoadBalancerPolicies": {
			"result_key": "PolicyDescriptions"
		},
		"DescribeLoadBalancerPolicyTypes": {
			"result_key": "PolicyTypeDescriptions"
		},
		"DescribeLoadBalancers": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"result_key": "LoadBalancerDescriptions"
		}
	}
};

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"InstanceDeregistered": {
			"delay": 15,
			"operation": "DescribeInstanceHealth",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": "OutOfService",
					"matcher": "pathAll",
					"state": "success",
					"argument": "InstanceStates[].State"
				},
				{
					"matcher": "error",
					"expected": "InvalidInstance",
					"state": "success"
				}
			]
		},
		"AnyInstanceInService": {
			"acceptors": [
				{
					"argument": "InstanceStates[].State",
					"expected": "InService",
					"matcher": "pathAny",
					"state": "success"
				}
			],
			"delay": 15,
			"maxAttempts": 40,
			"operation": "DescribeInstanceHealth"
		},
		"InstanceInService": {
			"acceptors": [
				{
					"argument": "InstanceStates[].State",
					"expected": "InService",
					"matcher": "pathAll",
					"state": "success"
				},
				{
					"matcher": "error",
					"expected": "InvalidInstance",
					"state": "retry"
				}
			],
			"delay": 15,
			"maxAttempts": 40,
			"operation": "DescribeInstanceHealth"
		}
	}
};

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elbv2'] = {};
AWS.ELBv2 = Service.defineService('elbv2', ['2015-12-01']);
Object.defineProperty(apiLoader.services['elbv2'], '2015-12-01', {
  get: function get() {
    var model = __webpack_require__(1614);
    model.paginators = __webpack_require__(1615).pagination;
    model.waiters = __webpack_require__(1616).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ELBv2;


/***/ }),
/* 1614 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-12-01",
		"endpointPrefix": "elasticloadbalancing",
		"protocol": "query",
		"serviceAbbreviation": "Elastic Load Balancing v2",
		"serviceFullName": "Elastic Load Balancing",
		"signatureVersion": "v4",
		"uid": "elasticloadbalancingv2-2015-12-01",
		"xmlNamespace": "http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"
	},
	"operations": {
		"AddTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArns",
					"Tags"
				],
				"members": {
					"ResourceArns": {
						"shape": "S2"
					},
					"Tags": {
						"shape": "S4"
					}
				}
			},
			"output": {
				"resultWrapper": "AddTagsResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateListener": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn",
					"Protocol",
					"Port",
					"DefaultActions"
				],
				"members": {
					"LoadBalancerArn": {},
					"Protocol": {},
					"Port": {
						"type": "integer"
					},
					"SslPolicy": {},
					"Certificates": {
						"shape": "Se"
					},
					"DefaultActions": {
						"shape": "Sh"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateListenerResult",
				"type": "structure",
				"members": {
					"Listeners": {
						"shape": "Sm"
					}
				}
			}
		},
		"CreateLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Subnets"
				],
				"members": {
					"Name": {},
					"Subnets": {
						"shape": "Sr"
					},
					"SecurityGroups": {
						"shape": "St"
					},
					"Scheme": {},
					"Tags": {
						"shape": "S4"
					},
					"IpAddressType": {}
				}
			},
			"output": {
				"resultWrapper": "CreateLoadBalancerResult",
				"type": "structure",
				"members": {
					"LoadBalancers": {
						"shape": "Sy"
					}
				}
			}
		},
		"CreateRule": {
			"input": {
				"type": "structure",
				"required": [
					"ListenerArn",
					"Conditions",
					"Priority",
					"Actions"
				],
				"members": {
					"ListenerArn": {},
					"Conditions": {
						"shape": "S1c"
					},
					"Priority": {
						"type": "integer"
					},
					"Actions": {
						"shape": "Sh"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateRuleResult",
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S1j"
					}
				}
			}
		},
		"CreateTargetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Protocol",
					"Port",
					"VpcId"
				],
				"members": {
					"Name": {},
					"Protocol": {},
					"Port": {
						"type": "integer"
					},
					"VpcId": {},
					"HealthCheckProtocol": {},
					"HealthCheckPort": {},
					"HealthCheckPath": {},
					"HealthCheckIntervalSeconds": {
						"type": "integer"
					},
					"HealthCheckTimeoutSeconds": {
						"type": "integer"
					},
					"HealthyThresholdCount": {
						"type": "integer"
					},
					"UnhealthyThresholdCount": {
						"type": "integer"
					},
					"Matcher": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateTargetGroupResult",
				"type": "structure",
				"members": {
					"TargetGroups": {
						"shape": "S1y"
					}
				}
			}
		},
		"DeleteListener": {
			"input": {
				"type": "structure",
				"required": [
					"ListenerArn"
				],
				"members": {
					"ListenerArn": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteListenerResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn"
				],
				"members": {
					"LoadBalancerArn": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteLoadBalancerResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleArn"
				],
				"members": {
					"RuleArn": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteRuleResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteTargetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn"
				],
				"members": {
					"TargetGroupArn": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteTargetGroupResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeregisterTargets": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn",
					"Targets"
				],
				"members": {
					"TargetGroupArn": {},
					"Targets": {
						"shape": "S2a"
					}
				}
			},
			"output": {
				"resultWrapper": "DeregisterTargetsResult",
				"type": "structure",
				"members": {}
			}
		},
		"DescribeAccountLimits": {
			"input": {
				"type": "structure",
				"members": {
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeAccountLimitsResult",
				"type": "structure",
				"members": {
					"Limits": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Max": {}
							}
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeListeners": {
			"input": {
				"type": "structure",
				"members": {
					"LoadBalancerArn": {},
					"ListenerArns": {
						"type": "list",
						"member": {}
					},
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeListenersResult",
				"type": "structure",
				"members": {
					"Listeners": {
						"shape": "Sm"
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeLoadBalancerAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn"
				],
				"members": {
					"LoadBalancerArn": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeLoadBalancerAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "S2r"
					}
				}
			}
		},
		"DescribeLoadBalancers": {
			"input": {
				"type": "structure",
				"members": {
					"LoadBalancerArns": {
						"shape": "S20"
					},
					"Names": {
						"type": "list",
						"member": {}
					},
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeLoadBalancersResult",
				"type": "structure",
				"members": {
					"LoadBalancers": {
						"shape": "Sy"
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeRules": {
			"input": {
				"type": "structure",
				"members": {
					"ListenerArn": {},
					"RuleArns": {
						"type": "list",
						"member": {}
					},
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeRulesResult",
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S1j"
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeSSLPolicies": {
			"input": {
				"type": "structure",
				"members": {
					"Names": {
						"type": "list",
						"member": {}
					},
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeSSLPoliciesResult",
				"type": "structure",
				"members": {
					"SslPolicies": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"SslProtocols": {
									"type": "list",
									"member": {}
								},
								"Ciphers": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {},
											"Priority": {
												"type": "integer"
											}
										}
									}
								},
								"Name": {}
							}
						}
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArns"
				],
				"members": {
					"ResourceArns": {
						"shape": "S2"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeTagsResult",
				"type": "structure",
				"members": {
					"TagDescriptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ResourceArn": {},
								"Tags": {
									"shape": "S4"
								}
							}
						}
					}
				}
			}
		},
		"DescribeTargetGroupAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn"
				],
				"members": {
					"TargetGroupArn": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeTargetGroupAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "S3i"
					}
				}
			}
		},
		"DescribeTargetGroups": {
			"input": {
				"type": "structure",
				"members": {
					"LoadBalancerArn": {},
					"TargetGroupArns": {
						"type": "list",
						"member": {}
					},
					"Names": {
						"type": "list",
						"member": {}
					},
					"Marker": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeTargetGroupsResult",
				"type": "structure",
				"members": {
					"TargetGroups": {
						"shape": "S1y"
					},
					"NextMarker": {}
				}
			}
		},
		"DescribeTargetHealth": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn"
				],
				"members": {
					"TargetGroupArn": {},
					"Targets": {
						"shape": "S2a"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeTargetHealthResult",
				"type": "structure",
				"members": {
					"TargetHealthDescriptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Target": {
									"shape": "S2b"
								},
								"HealthCheckPort": {},
								"TargetHealth": {
									"type": "structure",
									"members": {
										"State": {},
										"Reason": {},
										"Description": {}
									}
								}
							}
						}
					}
				}
			}
		},
		"ModifyListener": {
			"input": {
				"type": "structure",
				"required": [
					"ListenerArn"
				],
				"members": {
					"ListenerArn": {},
					"Port": {
						"type": "integer"
					},
					"Protocol": {},
					"SslPolicy": {},
					"Certificates": {
						"shape": "Se"
					},
					"DefaultActions": {
						"shape": "Sh"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyListenerResult",
				"type": "structure",
				"members": {
					"Listeners": {
						"shape": "Sm"
					}
				}
			}
		},
		"ModifyLoadBalancerAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn",
					"Attributes"
				],
				"members": {
					"LoadBalancerArn": {},
					"Attributes": {
						"shape": "S2r"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyLoadBalancerAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "S2r"
					}
				}
			}
		},
		"ModifyRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleArn"
				],
				"members": {
					"RuleArn": {},
					"Conditions": {
						"shape": "S1c"
					},
					"Actions": {
						"shape": "Sh"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyRuleResult",
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S1j"
					}
				}
			}
		},
		"ModifyTargetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn"
				],
				"members": {
					"TargetGroupArn": {},
					"HealthCheckProtocol": {},
					"HealthCheckPort": {},
					"HealthCheckPath": {},
					"HealthCheckIntervalSeconds": {
						"type": "integer"
					},
					"HealthCheckTimeoutSeconds": {
						"type": "integer"
					},
					"HealthyThresholdCount": {
						"type": "integer"
					},
					"UnhealthyThresholdCount": {
						"type": "integer"
					},
					"Matcher": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyTargetGroupResult",
				"type": "structure",
				"members": {
					"TargetGroups": {
						"shape": "S1y"
					}
				}
			}
		},
		"ModifyTargetGroupAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn",
					"Attributes"
				],
				"members": {
					"TargetGroupArn": {},
					"Attributes": {
						"shape": "S3i"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyTargetGroupAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "S3i"
					}
				}
			}
		},
		"RegisterTargets": {
			"input": {
				"type": "structure",
				"required": [
					"TargetGroupArn",
					"Targets"
				],
				"members": {
					"TargetGroupArn": {},
					"Targets": {
						"shape": "S2a"
					}
				}
			},
			"output": {
				"resultWrapper": "RegisterTargetsResult",
				"type": "structure",
				"members": {}
			}
		},
		"RemoveTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArns",
					"TagKeys"
				],
				"members": {
					"ResourceArns": {
						"shape": "S2"
					},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "RemoveTagsResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetIpAddressType": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn",
					"IpAddressType"
				],
				"members": {
					"LoadBalancerArn": {},
					"IpAddressType": {}
				}
			},
			"output": {
				"resultWrapper": "SetIpAddressTypeResult",
				"type": "structure",
				"members": {
					"IpAddressType": {}
				}
			}
		},
		"SetRulePriorities": {
			"input": {
				"type": "structure",
				"required": [
					"RulePriorities"
				],
				"members": {
					"RulePriorities": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"RuleArn": {},
								"Priority": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"output": {
				"resultWrapper": "SetRulePrioritiesResult",
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S1j"
					}
				}
			}
		},
		"SetSecurityGroups": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn",
					"SecurityGroups"
				],
				"members": {
					"LoadBalancerArn": {},
					"SecurityGroups": {
						"shape": "St"
					}
				}
			},
			"output": {
				"resultWrapper": "SetSecurityGroupsResult",
				"type": "structure",
				"members": {
					"SecurityGroupIds": {
						"shape": "St"
					}
				}
			}
		},
		"SetSubnets": {
			"input": {
				"type": "structure",
				"required": [
					"LoadBalancerArn",
					"Subnets"
				],
				"members": {
					"LoadBalancerArn": {},
					"Subnets": {
						"shape": "Sr"
					}
				}
			},
			"output": {
				"resultWrapper": "SetSubnetsResult",
				"type": "structure",
				"members": {
					"AvailabilityZones": {
						"shape": "S18"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "list",
			"member": {}
		},
		"S4": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Se": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"CertificateArn": {}
				}
			}
		},
		"Sh": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Type",
					"TargetGroupArn"
				],
				"members": {
					"Type": {},
					"TargetGroupArn": {}
				}
			}
		},
		"Sm": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ListenerArn": {},
					"LoadBalancerArn": {},
					"Port": {
						"type": "integer"
					},
					"Protocol": {},
					"Certificates": {
						"shape": "Se"
					},
					"SslPolicy": {},
					"DefaultActions": {
						"shape": "Sh"
					}
				}
			}
		},
		"Sr": {
			"type": "list",
			"member": {}
		},
		"St": {
			"type": "list",
			"member": {}
		},
		"Sy": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"LoadBalancerArn": {},
					"DNSName": {},
					"CanonicalHostedZoneId": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"LoadBalancerName": {},
					"Scheme": {},
					"VpcId": {},
					"State": {
						"type": "structure",
						"members": {
							"Code": {},
							"Reason": {}
						}
					},
					"Type": {},
					"AvailabilityZones": {
						"shape": "S18"
					},
					"SecurityGroups": {
						"shape": "St"
					},
					"IpAddressType": {}
				}
			}
		},
		"S18": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"ZoneName": {},
					"SubnetId": {}
				}
			}
		},
		"S1c": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Field": {},
					"Values": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"S1j": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"RuleArn": {},
					"Priority": {},
					"Conditions": {
						"shape": "S1c"
					},
					"Actions": {
						"shape": "Sh"
					},
					"IsDefault": {
						"type": "boolean"
					}
				}
			}
		},
		"S1v": {
			"type": "structure",
			"required": [
				"HttpCode"
			],
			"members": {
				"HttpCode": {}
			}
		},
		"S1y": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"TargetGroupArn": {},
					"TargetGroupName": {},
					"Protocol": {},
					"Port": {
						"type": "integer"
					},
					"VpcId": {},
					"HealthCheckProtocol": {},
					"HealthCheckPort": {},
					"HealthCheckIntervalSeconds": {
						"type": "integer"
					},
					"HealthCheckTimeoutSeconds": {
						"type": "integer"
					},
					"HealthyThresholdCount": {
						"type": "integer"
					},
					"UnhealthyThresholdCount": {
						"type": "integer"
					},
					"HealthCheckPath": {},
					"Matcher": {
						"shape": "S1v"
					},
					"LoadBalancerArns": {
						"shape": "S20"
					}
				}
			}
		},
		"S20": {
			"type": "list",
			"member": {}
		},
		"S2a": {
			"type": "list",
			"member": {
				"shape": "S2b"
			}
		},
		"S2b": {
			"type": "structure",
			"required": [
				"Id"
			],
			"members": {
				"Id": {},
				"Port": {
					"type": "integer"
				}
			}
		},
		"S2r": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S3i": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		}
	}
};

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeListeners": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"result_key": "Listeners"
		},
		"DescribeLoadBalancers": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"result_key": "LoadBalancers"
		},
		"DescribeTargetGroups": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"result_key": "TargetGroups"
		}
	}
};

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"LoadBalancerExists": {
			"delay": 15,
			"operation": "DescribeLoadBalancers",
			"maxAttempts": 40,
			"acceptors": [
				{
					"matcher": "status",
					"expected": 200,
					"state": "success"
				},
				{
					"matcher": "error",
					"expected": "LoadBalancerNotFound",
					"state": "retry"
				}
			]
		},
		"LoadBalancerAvailable": {
			"delay": 15,
			"operation": "DescribeLoadBalancers",
			"maxAttempts": 40,
			"acceptors": [
				{
					"state": "success",
					"matcher": "pathAll",
					"argument": "LoadBalancers[].State.Code",
					"expected": "active"
				},
				{
					"state": "retry",
					"matcher": "pathAny",
					"argument": "LoadBalancers[].State.Code",
					"expected": "provisioning"
				},
				{
					"state": "retry",
					"matcher": "error",
					"expected": "LoadBalancerNotFound"
				}
			]
		},
		"LoadBalancersDeleted": {
			"delay": 15,
			"operation": "DescribeLoadBalancers",
			"maxAttempts": 40,
			"acceptors": [
				{
					"state": "retry",
					"matcher": "pathAll",
					"argument": "LoadBalancers[].State.Code",
					"expected": "active"
				},
				{
					"matcher": "error",
					"expected": "LoadBalancerNotFound",
					"state": "success"
				}
			]
		},
		"TargetInService": {
			"delay": 15,
			"maxAttempts": 40,
			"operation": "DescribeTargetHealth",
			"acceptors": [
				{
					"argument": "TargetHealthDescriptions[].TargetHealth.State",
					"expected": "healthy",
					"matcher": "pathAll",
					"state": "success"
				},
				{
					"matcher": "error",
					"expected": "InvalidInstance",
					"state": "retry"
				}
			]
		},
		"TargetDeregistered": {
			"delay": 15,
			"maxAttempts": 40,
			"operation": "DescribeTargetHealth",
			"acceptors": [
				{
					"matcher": "error",
					"expected": "InvalidTarget",
					"state": "success"
				},
				{
					"argument": "TargetHealthDescriptions[].TargetHealth.State",
					"expected": "unused",
					"matcher": "pathAll",
					"state": "success"
				}
			]
		}
	}
};

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['emr'] = {};
AWS.EMR = Service.defineService('emr', ['2009-03-31']);
Object.defineProperty(apiLoader.services['emr'], '2009-03-31', {
  get: function get() {
    var model = __webpack_require__(1618);
    model.paginators = __webpack_require__(1619).pagination;
    model.waiters = __webpack_require__(1620).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.EMR;


/***/ }),
/* 1618 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2009-03-31",
		"endpointPrefix": "elasticmapreduce",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Amazon EMR",
		"serviceFullName": "Amazon Elastic MapReduce",
		"signatureVersion": "v4",
		"targetPrefix": "ElasticMapReduce",
		"timestampFormat": "unixTimestamp",
		"uid": "elasticmapreduce-2009-03-31"
	},
	"operations": {
		"AddInstanceFleet": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId",
					"InstanceFleet"
				],
				"members": {
					"ClusterId": {},
					"InstanceFleet": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClusterId": {},
					"InstanceFleetId": {}
				}
			}
		},
		"AddInstanceGroups": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceGroups",
					"JobFlowId"
				],
				"members": {
					"InstanceGroups": {
						"shape": "Sq"
					},
					"JobFlowId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"JobFlowId": {},
					"InstanceGroupIds": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"AddJobFlowSteps": {
			"input": {
				"type": "structure",
				"required": [
					"JobFlowId",
					"Steps"
				],
				"members": {
					"JobFlowId": {},
					"Steps": {
						"shape": "S1b"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StepIds": {
						"shape": "S1k"
					}
				}
			}
		},
		"AddTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"Tags"
				],
				"members": {
					"ResourceId": {},
					"Tags": {
						"shape": "S1n"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CancelSteps": {
			"input": {
				"type": "structure",
				"members": {
					"ClusterId": {},
					"StepIds": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CancelStepsInfoList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"StepId": {},
								"Status": {},
								"Reason": {}
							}
						}
					}
				}
			}
		},
		"CreateSecurityConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"SecurityConfiguration"
				],
				"members": {
					"Name": {},
					"SecurityConfiguration": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Name",
					"CreationDateTime"
				],
				"members": {
					"Name": {},
					"CreationDateTime": {
						"type": "timestamp"
					}
				}
			}
		},
		"DeleteSecurityConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeCluster": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId"
				],
				"members": {
					"ClusterId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Cluster": {
						"type": "structure",
						"members": {
							"Id": {},
							"Name": {},
							"Status": {
								"shape": "S25"
							},
							"Ec2InstanceAttributes": {
								"type": "structure",
								"members": {
									"Ec2KeyName": {},
									"Ec2SubnetId": {},
									"RequestedEc2SubnetIds": {
										"shape": "S2b"
									},
									"Ec2AvailabilityZone": {},
									"RequestedEc2AvailabilityZones": {
										"shape": "S2b"
									},
									"IamInstanceProfile": {},
									"EmrManagedMasterSecurityGroup": {},
									"EmrManagedSlaveSecurityGroup": {},
									"ServiceAccessSecurityGroup": {},
									"AdditionalMasterSecurityGroups": {
										"shape": "S2c"
									},
									"AdditionalSlaveSecurityGroups": {
										"shape": "S2c"
									}
								}
							},
							"InstanceCollectionType": {},
							"LogUri": {},
							"RequestedAmiVersion": {},
							"RunningAmiVersion": {},
							"ReleaseLabel": {},
							"AutoTerminate": {
								"type": "boolean"
							},
							"TerminationProtected": {
								"type": "boolean"
							},
							"VisibleToAllUsers": {
								"type": "boolean"
							},
							"Applications": {
								"shape": "S2f"
							},
							"Tags": {
								"shape": "S1n"
							},
							"ServiceRole": {},
							"NormalizedInstanceHours": {
								"type": "integer"
							},
							"MasterPublicDnsName": {},
							"Configurations": {
								"shape": "Sh"
							},
							"SecurityConfiguration": {},
							"AutoScalingRole": {},
							"ScaleDownBehavior": {},
							"CustomAmiId": {},
							"EbsRootVolumeSize": {
								"type": "integer"
							},
							"RepoUpgradeOnBoot": {}
						}
					}
				}
			}
		},
		"DescribeJobFlows": {
			"input": {
				"type": "structure",
				"members": {
					"CreatedAfter": {
						"type": "timestamp"
					},
					"CreatedBefore": {
						"type": "timestamp"
					},
					"JobFlowIds": {
						"shape": "S1i"
					},
					"JobFlowStates": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"JobFlows": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"JobFlowId",
								"Name",
								"ExecutionStatusDetail",
								"Instances"
							],
							"members": {
								"JobFlowId": {},
								"Name": {},
								"LogUri": {},
								"AmiVersion": {},
								"ExecutionStatusDetail": {
									"type": "structure",
									"required": [
										"State",
										"CreationDateTime"
									],
									"members": {
										"State": {},
										"CreationDateTime": {
											"type": "timestamp"
										},
										"StartDateTime": {
											"type": "timestamp"
										},
										"ReadyDateTime": {
											"type": "timestamp"
										},
										"EndDateTime": {
											"type": "timestamp"
										},
										"LastStateChangeReason": {}
									}
								},
								"Instances": {
									"type": "structure",
									"required": [
										"MasterInstanceType",
										"SlaveInstanceType",
										"InstanceCount"
									],
									"members": {
										"MasterInstanceType": {},
										"MasterPublicDnsName": {},
										"MasterInstanceId": {},
										"SlaveInstanceType": {},
										"InstanceCount": {
											"type": "integer"
										},
										"InstanceGroups": {
											"type": "list",
											"member": {
												"type": "structure",
												"required": [
													"Market",
													"InstanceRole",
													"InstanceType",
													"InstanceRequestCount",
													"InstanceRunningCount",
													"State",
													"CreationDateTime"
												],
												"members": {
													"InstanceGroupId": {},
													"Name": {},
													"Market": {},
													"InstanceRole": {},
													"BidPrice": {},
													"InstanceType": {},
													"InstanceRequestCount": {
														"type": "integer"
													},
													"InstanceRunningCount": {
														"type": "integer"
													},
													"State": {},
													"LastStateChangeReason": {},
													"CreationDateTime": {
														"type": "timestamp"
													},
													"StartDateTime": {
														"type": "timestamp"
													},
													"ReadyDateTime": {
														"type": "timestamp"
													},
													"EndDateTime": {
														"type": "timestamp"
													}
												}
											}
										},
										"NormalizedInstanceHours": {
											"type": "integer"
										},
										"Ec2KeyName": {},
										"Ec2SubnetId": {},
										"Placement": {
											"shape": "S2u"
										},
										"KeepJobFlowAliveWhenNoSteps": {
											"type": "boolean"
										},
										"TerminationProtected": {
											"type": "boolean"
										},
										"HadoopVersion": {}
									}
								},
								"Steps": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"StepConfig",
											"ExecutionStatusDetail"
										],
										"members": {
											"StepConfig": {
												"shape": "S1c"
											},
											"ExecutionStatusDetail": {
												"type": "structure",
												"required": [
													"State",
													"CreationDateTime"
												],
												"members": {
													"State": {},
													"CreationDateTime": {
														"type": "timestamp"
													},
													"StartDateTime": {
														"type": "timestamp"
													},
													"EndDateTime": {
														"type": "timestamp"
													},
													"LastStateChangeReason": {}
												}
											}
										}
									}
								},
								"BootstrapActions": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"BootstrapActionConfig": {
												"shape": "S31"
											}
										}
									}
								},
								"SupportedProducts": {
									"shape": "S33"
								},
								"VisibleToAllUsers": {
									"type": "boolean"
								},
								"JobFlowRole": {},
								"ServiceRole": {},
								"AutoScalingRole": {},
								"ScaleDownBehavior": {}
							}
						}
					}
				}
			},
			"deprecated": true
		},
		"DescribeSecurityConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Name": {},
					"SecurityConfiguration": {},
					"CreationDateTime": {
						"type": "timestamp"
					}
				}
			}
		},
		"DescribeStep": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId",
					"StepId"
				],
				"members": {
					"ClusterId": {},
					"StepId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Step": {
						"type": "structure",
						"members": {
							"Id": {},
							"Name": {},
							"Config": {
								"shape": "S39"
							},
							"ActionOnFailure": {},
							"Status": {
								"shape": "S3a"
							}
						}
					}
				}
			}
		},
		"ListBootstrapActions": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId"
				],
				"members": {
					"ClusterId": {},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BootstrapActions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"ScriptPath": {},
								"Args": {
									"shape": "S2c"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"ListClusters": {
			"input": {
				"type": "structure",
				"members": {
					"CreatedAfter": {
						"type": "timestamp"
					},
					"CreatedBefore": {
						"type": "timestamp"
					},
					"ClusterStates": {
						"type": "list",
						"member": {}
					},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Clusters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"Status": {
									"shape": "S25"
								},
								"NormalizedInstanceHours": {
									"type": "integer"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"ListInstanceFleets": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId"
				],
				"members": {
					"ClusterId": {},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceFleets": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"Status": {
									"type": "structure",
									"members": {
										"State": {},
										"StateChangeReason": {
											"type": "structure",
											"members": {
												"Code": {},
												"Message": {}
											}
										},
										"Timeline": {
											"type": "structure",
											"members": {
												"CreationDateTime": {
													"type": "timestamp"
												},
												"ReadyDateTime": {
													"type": "timestamp"
												},
												"EndDateTime": {
													"type": "timestamp"
												}
											}
										}
									}
								},
								"InstanceFleetType": {},
								"TargetOnDemandCapacity": {
									"type": "integer"
								},
								"TargetSpotCapacity": {
									"type": "integer"
								},
								"ProvisionedOnDemandCapacity": {
									"type": "integer"
								},
								"ProvisionedSpotCapacity": {
									"type": "integer"
								},
								"InstanceTypeSpecifications": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"InstanceType": {},
											"WeightedCapacity": {
												"type": "integer"
											},
											"BidPrice": {},
											"BidPriceAsPercentageOfOnDemandPrice": {
												"type": "double"
											},
											"Configurations": {
												"shape": "Sh"
											},
											"EbsBlockDevices": {
												"shape": "S41"
											},
											"EbsOptimized": {
												"type": "boolean"
											}
										}
									}
								},
								"LaunchSpecifications": {
									"shape": "Sk"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"ListInstanceGroups": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId"
				],
				"members": {
					"ClusterId": {},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceGroups": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"Market": {},
								"InstanceGroupType": {},
								"BidPrice": {},
								"InstanceType": {},
								"RequestedInstanceCount": {
									"type": "integer"
								},
								"RunningInstanceCount": {
									"type": "integer"
								},
								"Status": {
									"type": "structure",
									"members": {
										"State": {},
										"StateChangeReason": {
											"type": "structure",
											"members": {
												"Code": {},
												"Message": {}
											}
										},
										"Timeline": {
											"type": "structure",
											"members": {
												"CreationDateTime": {
													"type": "timestamp"
												},
												"ReadyDateTime": {
													"type": "timestamp"
												},
												"EndDateTime": {
													"type": "timestamp"
												}
											}
										}
									}
								},
								"Configurations": {
									"shape": "Sh"
								},
								"EbsBlockDevices": {
									"shape": "S41"
								},
								"EbsOptimized": {
									"type": "boolean"
								},
								"ShrinkPolicy": {
									"shape": "S4d"
								},
								"AutoScalingPolicy": {
									"shape": "S4h"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"ListInstances": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId"
				],
				"members": {
					"ClusterId": {},
					"InstanceGroupId": {},
					"InstanceGroupTypes": {
						"type": "list",
						"member": {}
					},
					"InstanceFleetId": {},
					"InstanceFleetType": {},
					"InstanceStates": {
						"type": "list",
						"member": {}
					},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Instances": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Ec2InstanceId": {},
								"PublicDnsName": {},
								"PublicIpAddress": {},
								"PrivateDnsName": {},
								"PrivateIpAddress": {},
								"Status": {
									"type": "structure",
									"members": {
										"State": {},
										"StateChangeReason": {
											"type": "structure",
											"members": {
												"Code": {},
												"Message": {}
											}
										},
										"Timeline": {
											"type": "structure",
											"members": {
												"CreationDateTime": {
													"type": "timestamp"
												},
												"ReadyDateTime": {
													"type": "timestamp"
												},
												"EndDateTime": {
													"type": "timestamp"
												}
											}
										}
									}
								},
								"InstanceGroupId": {},
								"InstanceFleetId": {},
								"Market": {},
								"InstanceType": {},
								"EbsVolumes": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Device": {},
											"VolumeId": {}
										}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"ListSecurityConfigurations": {
			"input": {
				"type": "structure",
				"members": {
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SecurityConfigurations": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"CreationDateTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"ListSteps": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId"
				],
				"members": {
					"ClusterId": {},
					"StepStates": {
						"type": "list",
						"member": {}
					},
					"StepIds": {
						"shape": "S1i"
					},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Steps": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"Config": {
									"shape": "S39"
								},
								"ActionOnFailure": {},
								"Status": {
									"shape": "S3a"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"ModifyInstanceFleet": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId",
					"InstanceFleet"
				],
				"members": {
					"ClusterId": {},
					"InstanceFleet": {
						"type": "structure",
						"required": [
							"InstanceFleetId"
						],
						"members": {
							"InstanceFleetId": {},
							"TargetOnDemandCapacity": {
								"type": "integer"
							},
							"TargetSpotCapacity": {
								"type": "integer"
							}
						}
					}
				}
			}
		},
		"ModifyInstanceGroups": {
			"input": {
				"type": "structure",
				"members": {
					"ClusterId": {},
					"InstanceGroups": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"InstanceGroupId"
							],
							"members": {
								"InstanceGroupId": {},
								"InstanceCount": {
									"type": "integer"
								},
								"EC2InstanceIdsToTerminate": {
									"type": "list",
									"member": {}
								},
								"ShrinkPolicy": {
									"shape": "S4d"
								}
							}
						}
					}
				}
			}
		},
		"PutAutoScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId",
					"InstanceGroupId",
					"AutoScalingPolicy"
				],
				"members": {
					"ClusterId": {},
					"InstanceGroupId": {},
					"AutoScalingPolicy": {
						"shape": "Su"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ClusterId": {},
					"InstanceGroupId": {},
					"AutoScalingPolicy": {
						"shape": "S4h"
					}
				}
			}
		},
		"RemoveAutoScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterId",
					"InstanceGroupId"
				],
				"members": {
					"ClusterId": {},
					"InstanceGroupId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"RemoveTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"TagKeys"
				],
				"members": {
					"ResourceId": {},
					"TagKeys": {
						"shape": "S2c"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"RunJobFlow": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Instances"
				],
				"members": {
					"Name": {},
					"LogUri": {},
					"AdditionalInfo": {},
					"AmiVersion": {},
					"ReleaseLabel": {},
					"Instances": {
						"type": "structure",
						"members": {
							"MasterInstanceType": {},
							"SlaveInstanceType": {},
							"InstanceCount": {
								"type": "integer"
							},
							"InstanceGroups": {
								"shape": "Sq"
							},
							"InstanceFleets": {
								"type": "list",
								"member": {
									"shape": "S3"
								}
							},
							"Ec2KeyName": {},
							"Placement": {
								"shape": "S2u"
							},
							"KeepJobFlowAliveWhenNoSteps": {
								"type": "boolean"
							},
							"TerminationProtected": {
								"type": "boolean"
							},
							"HadoopVersion": {},
							"Ec2SubnetId": {},
							"Ec2SubnetIds": {
								"shape": "S2b"
							},
							"EmrManagedMasterSecurityGroup": {},
							"EmrManagedSlaveSecurityGroup": {},
							"ServiceAccessSecurityGroup": {},
							"AdditionalMasterSecurityGroups": {
								"shape": "S5n"
							},
							"AdditionalSlaveSecurityGroups": {
								"shape": "S5n"
							}
						}
					},
					"Steps": {
						"shape": "S1b"
					},
					"BootstrapActions": {
						"type": "list",
						"member": {
							"shape": "S31"
						}
					},
					"SupportedProducts": {
						"shape": "S33"
					},
					"NewSupportedProducts": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Args": {
									"shape": "S1i"
								}
							}
						}
					},
					"Applications": {
						"shape": "S2f"
					},
					"Configurations": {
						"shape": "Sh"
					},
					"VisibleToAllUsers": {
						"type": "boolean"
					},
					"JobFlowRole": {},
					"ServiceRole": {},
					"Tags": {
						"shape": "S1n"
					},
					"SecurityConfiguration": {},
					"AutoScalingRole": {},
					"ScaleDownBehavior": {},
					"CustomAmiId": {},
					"EbsRootVolumeSize": {
						"type": "integer"
					},
					"RepoUpgradeOnBoot": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"JobFlowId": {}
				}
			}
		},
		"SetTerminationProtection": {
			"input": {
				"type": "structure",
				"required": [
					"JobFlowIds",
					"TerminationProtected"
				],
				"members": {
					"JobFlowIds": {
						"shape": "S1i"
					},
					"TerminationProtected": {
						"type": "boolean"
					}
				}
			}
		},
		"SetVisibleToAllUsers": {
			"input": {
				"type": "structure",
				"required": [
					"JobFlowIds",
					"VisibleToAllUsers"
				],
				"members": {
					"JobFlowIds": {
						"shape": "S1i"
					},
					"VisibleToAllUsers": {
						"type": "boolean"
					}
				}
			}
		},
		"TerminateJobFlows": {
			"input": {
				"type": "structure",
				"required": [
					"JobFlowIds"
				],
				"members": {
					"JobFlowIds": {
						"shape": "S1i"
					}
				}
			}
		}
	},
	"shapes": {
		"S3": {
			"type": "structure",
			"required": [
				"InstanceFleetType"
			],
			"members": {
				"Name": {},
				"InstanceFleetType": {},
				"TargetOnDemandCapacity": {
					"type": "integer"
				},
				"TargetSpotCapacity": {
					"type": "integer"
				},
				"InstanceTypeConfigs": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"InstanceType"
						],
						"members": {
							"InstanceType": {},
							"WeightedCapacity": {
								"type": "integer"
							},
							"BidPrice": {},
							"BidPriceAsPercentageOfOnDemandPrice": {
								"type": "double"
							},
							"EbsConfiguration": {
								"shape": "Sa"
							},
							"Configurations": {
								"shape": "Sh"
							}
						}
					}
				},
				"LaunchSpecifications": {
					"shape": "Sk"
				}
			}
		},
		"Sa": {
			"type": "structure",
			"members": {
				"EbsBlockDeviceConfigs": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"VolumeSpecification"
						],
						"members": {
							"VolumeSpecification": {
								"shape": "Sd"
							},
							"VolumesPerInstance": {
								"type": "integer"
							}
						}
					}
				},
				"EbsOptimized": {
					"type": "boolean"
				}
			}
		},
		"Sd": {
			"type": "structure",
			"required": [
				"VolumeType",
				"SizeInGB"
			],
			"members": {
				"VolumeType": {},
				"Iops": {
					"type": "integer"
				},
				"SizeInGB": {
					"type": "integer"
				}
			}
		},
		"Sh": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Classification": {},
					"Configurations": {
						"shape": "Sh"
					},
					"Properties": {
						"shape": "Sj"
					}
				}
			}
		},
		"Sj": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"Sk": {
			"type": "structure",
			"required": [
				"SpotSpecification"
			],
			"members": {
				"SpotSpecification": {
					"type": "structure",
					"required": [
						"TimeoutDurationMinutes",
						"TimeoutAction"
					],
					"members": {
						"TimeoutDurationMinutes": {
							"type": "integer"
						},
						"TimeoutAction": {},
						"BlockDurationMinutes": {
							"type": "integer"
						}
					}
				}
			}
		},
		"Sq": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"InstanceRole",
					"InstanceType",
					"InstanceCount"
				],
				"members": {
					"Name": {},
					"Market": {},
					"InstanceRole": {},
					"BidPrice": {},
					"InstanceType": {},
					"InstanceCount": {
						"type": "integer"
					},
					"Configurations": {
						"shape": "Sh"
					},
					"EbsConfiguration": {
						"shape": "Sa"
					},
					"AutoScalingPolicy": {
						"shape": "Su"
					}
				}
			}
		},
		"Su": {
			"type": "structure",
			"required": [
				"Constraints",
				"Rules"
			],
			"members": {
				"Constraints": {
					"shape": "Sv"
				},
				"Rules": {
					"shape": "Sw"
				}
			}
		},
		"Sv": {
			"type": "structure",
			"required": [
				"MinCapacity",
				"MaxCapacity"
			],
			"members": {
				"MinCapacity": {
					"type": "integer"
				},
				"MaxCapacity": {
					"type": "integer"
				}
			}
		},
		"Sw": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Name",
					"Action",
					"Trigger"
				],
				"members": {
					"Name": {},
					"Description": {},
					"Action": {
						"type": "structure",
						"required": [
							"SimpleScalingPolicyConfiguration"
						],
						"members": {
							"Market": {},
							"SimpleScalingPolicyConfiguration": {
								"type": "structure",
								"required": [
									"ScalingAdjustment"
								],
								"members": {
									"AdjustmentType": {},
									"ScalingAdjustment": {
										"type": "integer"
									},
									"CoolDown": {
										"type": "integer"
									}
								}
							}
						}
					},
					"Trigger": {
						"type": "structure",
						"required": [
							"CloudWatchAlarmDefinition"
						],
						"members": {
							"CloudWatchAlarmDefinition": {
								"type": "structure",
								"required": [
									"ComparisonOperator",
									"MetricName",
									"Period",
									"Threshold"
								],
								"members": {
									"ComparisonOperator": {},
									"EvaluationPeriods": {
										"type": "integer"
									},
									"MetricName": {},
									"Namespace": {},
									"Period": {
										"type": "integer"
									},
									"Statistic": {},
									"Threshold": {
										"type": "double"
									},
									"Unit": {},
									"Dimensions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Key": {},
												"Value": {}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"S1b": {
			"type": "list",
			"member": {
				"shape": "S1c"
			}
		},
		"S1c": {
			"type": "structure",
			"required": [
				"Name",
				"HadoopJarStep"
			],
			"members": {
				"Name": {},
				"ActionOnFailure": {},
				"HadoopJarStep": {
					"type": "structure",
					"required": [
						"Jar"
					],
					"members": {
						"Properties": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"Value": {}
								}
							}
						},
						"Jar": {},
						"MainClass": {},
						"Args": {
							"shape": "S1i"
						}
					}
				}
			}
		},
		"S1i": {
			"type": "list",
			"member": {}
		},
		"S1k": {
			"type": "list",
			"member": {}
		},
		"S1n": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S25": {
			"type": "structure",
			"members": {
				"State": {},
				"StateChangeReason": {
					"type": "structure",
					"members": {
						"Code": {},
						"Message": {}
					}
				},
				"Timeline": {
					"type": "structure",
					"members": {
						"CreationDateTime": {
							"type": "timestamp"
						},
						"ReadyDateTime": {
							"type": "timestamp"
						},
						"EndDateTime": {
							"type": "timestamp"
						}
					}
				}
			}
		},
		"S2b": {
			"type": "list",
			"member": {}
		},
		"S2c": {
			"type": "list",
			"member": {}
		},
		"S2f": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Name": {},
					"Version": {},
					"Args": {
						"shape": "S2c"
					},
					"AdditionalInfo": {
						"shape": "Sj"
					}
				}
			}
		},
		"S2u": {
			"type": "structure",
			"members": {
				"AvailabilityZone": {},
				"AvailabilityZones": {
					"shape": "S2b"
				}
			}
		},
		"S31": {
			"type": "structure",
			"required": [
				"Name",
				"ScriptBootstrapAction"
			],
			"members": {
				"Name": {},
				"ScriptBootstrapAction": {
					"type": "structure",
					"required": [
						"Path"
					],
					"members": {
						"Path": {},
						"Args": {
							"shape": "S1i"
						}
					}
				}
			}
		},
		"S33": {
			"type": "list",
			"member": {}
		},
		"S39": {
			"type": "structure",
			"members": {
				"Jar": {},
				"Properties": {
					"shape": "Sj"
				},
				"MainClass": {},
				"Args": {
					"shape": "S2c"
				}
			}
		},
		"S3a": {
			"type": "structure",
			"members": {
				"State": {},
				"StateChangeReason": {
					"type": "structure",
					"members": {
						"Code": {},
						"Message": {}
					}
				},
				"FailureDetails": {
					"type": "structure",
					"members": {
						"Reason": {},
						"Message": {},
						"LogFile": {}
					}
				},
				"Timeline": {
					"type": "structure",
					"members": {
						"CreationDateTime": {
							"type": "timestamp"
						},
						"StartDateTime": {
							"type": "timestamp"
						},
						"EndDateTime": {
							"type": "timestamp"
						}
					}
				}
			}
		},
		"S41": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"VolumeSpecification": {
						"shape": "Sd"
					},
					"Device": {}
				}
			}
		},
		"S4d": {
			"type": "structure",
			"members": {
				"DecommissionTimeout": {
					"type": "integer"
				},
				"InstanceResizePolicy": {
					"type": "structure",
					"members": {
						"InstancesToTerminate": {
							"shape": "S4f"
						},
						"InstancesToProtect": {
							"shape": "S4f"
						},
						"InstanceTerminationTimeout": {
							"type": "integer"
						}
					}
				}
			}
		},
		"S4f": {
			"type": "list",
			"member": {}
		},
		"S4h": {
			"type": "structure",
			"members": {
				"Status": {
					"type": "structure",
					"members": {
						"State": {},
						"StateChangeReason": {
							"type": "structure",
							"members": {
								"Code": {},
								"Message": {}
							}
						}
					}
				},
				"Constraints": {
					"shape": "Sv"
				},
				"Rules": {
					"shape": "Sw"
				}
			}
		},
		"S5n": {
			"type": "list",
			"member": {}
		}
	}
};

/***/ }),
/* 1619 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeJobFlows": {
			"result_key": "JobFlows"
		},
		"ListBootstrapActions": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "BootstrapActions"
		},
		"ListClusters": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "Clusters"
		},
		"ListInstanceFleets": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "InstanceFleets"
		},
		"ListInstanceGroups": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "InstanceGroups"
		},
		"ListInstances": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "Instances"
		},
		"ListSteps": {
			"input_token": "Marker",
			"output_token": "Marker",
			"result_key": "Steps"
		}
	}
};

/***/ }),
/* 1620 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"ClusterRunning": {
			"delay": 30,
			"operation": "DescribeCluster",
			"maxAttempts": 60,
			"acceptors": [
				{
					"state": "success",
					"matcher": "path",
					"argument": "Cluster.Status.State",
					"expected": "RUNNING"
				},
				{
					"state": "success",
					"matcher": "path",
					"argument": "Cluster.Status.State",
					"expected": "WAITING"
				},
				{
					"state": "failure",
					"matcher": "path",
					"argument": "Cluster.Status.State",
					"expected": "TERMINATING"
				},
				{
					"state": "failure",
					"matcher": "path",
					"argument": "Cluster.Status.State",
					"expected": "TERMINATED"
				},
				{
					"state": "failure",
					"matcher": "path",
					"argument": "Cluster.Status.State",
					"expected": "TERMINATED_WITH_ERRORS"
				}
			]
		},
		"StepComplete": {
			"delay": 30,
			"operation": "DescribeStep",
			"maxAttempts": 60,
			"acceptors": [
				{
					"state": "success",
					"matcher": "path",
					"argument": "Step.Status.State",
					"expected": "COMPLETED"
				},
				{
					"state": "failure",
					"matcher": "path",
					"argument": "Step.Status.State",
					"expected": "FAILED"
				},
				{
					"state": "failure",
					"matcher": "path",
					"argument": "Step.Status.State",
					"expected": "CANCELLED"
				}
			]
		},
		"ClusterTerminated": {
			"delay": 30,
			"operation": "DescribeCluster",
			"maxAttempts": 60,
			"acceptors": [
				{
					"state": "success",
					"matcher": "path",
					"argument": "Cluster.Status.State",
					"expected": "TERMINATED"
				},
				{
					"state": "failure",
					"matcher": "path",
					"argument": "Cluster.Status.State",
					"expected": "TERMINATED_WITH_ERRORS"
				}
			]
		}
	}
};

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['elastictranscoder'] = {};
AWS.ElasticTranscoder = Service.defineService('elastictranscoder', ['2012-09-25']);
Object.defineProperty(apiLoader.services['elastictranscoder'], '2012-09-25', {
  get: function get() {
    var model = __webpack_require__(1622);
    model.paginators = __webpack_require__(1623).pagination;
    model.waiters = __webpack_require__(1624).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ElasticTranscoder;


/***/ }),
/* 1622 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"uid": "elastictranscoder-2012-09-25",
		"apiVersion": "2012-09-25",
		"endpointPrefix": "elastictranscoder",
		"protocol": "rest-json",
		"serviceFullName": "Amazon Elastic Transcoder",
		"signatureVersion": "v4"
	},
	"operations": {
		"CancelJob": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2012-09-25/jobs/{Id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateJob": {
			"http": {
				"requestUri": "/2012-09-25/jobs",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"PipelineId"
				],
				"members": {
					"PipelineId": {},
					"Input": {
						"shape": "S5"
					},
					"Inputs": {
						"shape": "St"
					},
					"Output": {
						"shape": "Su"
					},
					"Outputs": {
						"type": "list",
						"member": {
							"shape": "Su"
						}
					},
					"OutputKeyPrefix": {},
					"Playlists": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Format": {},
								"OutputKeys": {
									"shape": "S1l"
								},
								"HlsContentProtection": {
									"shape": "S1m"
								},
								"PlayReadyDrm": {
									"shape": "S1q"
								}
							}
						}
					},
					"UserMetadata": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Job": {
						"shape": "S1y"
					}
				}
			}
		},
		"CreatePipeline": {
			"http": {
				"requestUri": "/2012-09-25/pipelines",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"InputBucket",
					"Role"
				],
				"members": {
					"Name": {},
					"InputBucket": {},
					"OutputBucket": {},
					"Role": {},
					"AwsKmsKeyArn": {},
					"Notifications": {
						"shape": "S2a"
					},
					"ContentConfig": {
						"shape": "S2c"
					},
					"ThumbnailConfig": {
						"shape": "S2c"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Pipeline": {
						"shape": "S2l"
					},
					"Warnings": {
						"shape": "S2n"
					}
				}
			}
		},
		"CreatePreset": {
			"http": {
				"requestUri": "/2012-09-25/presets",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Container"
				],
				"members": {
					"Name": {},
					"Description": {},
					"Container": {},
					"Video": {
						"shape": "S2r"
					},
					"Audio": {
						"shape": "S37"
					},
					"Thumbnails": {
						"shape": "S3i"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Preset": {
						"shape": "S3m"
					},
					"Warning": {}
				}
			}
		},
		"DeletePipeline": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2012-09-25/pipelines/{Id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeletePreset": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2012-09-25/presets/{Id}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ListJobsByPipeline": {
			"http": {
				"method": "GET",
				"requestUri": "/2012-09-25/jobsByPipeline/{PipelineId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"PipelineId"
				],
				"members": {
					"PipelineId": {
						"location": "uri",
						"locationName": "PipelineId"
					},
					"Ascending": {
						"location": "querystring",
						"locationName": "Ascending"
					},
					"PageToken": {
						"location": "querystring",
						"locationName": "PageToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Jobs": {
						"shape": "S3v"
					},
					"NextPageToken": {}
				}
			}
		},
		"ListJobsByStatus": {
			"http": {
				"method": "GET",
				"requestUri": "/2012-09-25/jobsByStatus/{Status}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Status"
				],
				"members": {
					"Status": {
						"location": "uri",
						"locationName": "Status"
					},
					"Ascending": {
						"location": "querystring",
						"locationName": "Ascending"
					},
					"PageToken": {
						"location": "querystring",
						"locationName": "PageToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Jobs": {
						"shape": "S3v"
					},
					"NextPageToken": {}
				}
			}
		},
		"ListPipelines": {
			"http": {
				"method": "GET",
				"requestUri": "/2012-09-25/pipelines"
			},
			"input": {
				"type": "structure",
				"members": {
					"Ascending": {
						"location": "querystring",
						"locationName": "Ascending"
					},
					"PageToken": {
						"location": "querystring",
						"locationName": "PageToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Pipelines": {
						"type": "list",
						"member": {
							"shape": "S2l"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListPresets": {
			"http": {
				"method": "GET",
				"requestUri": "/2012-09-25/presets"
			},
			"input": {
				"type": "structure",
				"members": {
					"Ascending": {
						"location": "querystring",
						"locationName": "Ascending"
					},
					"PageToken": {
						"location": "querystring",
						"locationName": "PageToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Presets": {
						"type": "list",
						"member": {
							"shape": "S3m"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ReadJob": {
			"http": {
				"method": "GET",
				"requestUri": "/2012-09-25/jobs/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Job": {
						"shape": "S1y"
					}
				}
			}
		},
		"ReadPipeline": {
			"http": {
				"method": "GET",
				"requestUri": "/2012-09-25/pipelines/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Pipeline": {
						"shape": "S2l"
					},
					"Warnings": {
						"shape": "S2n"
					}
				}
			}
		},
		"ReadPreset": {
			"http": {
				"method": "GET",
				"requestUri": "/2012-09-25/presets/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Preset": {
						"shape": "S3m"
					}
				}
			}
		},
		"TestRole": {
			"http": {
				"requestUri": "/2012-09-25/roleTests",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"Role",
					"InputBucket",
					"OutputBucket",
					"Topics"
				],
				"members": {
					"Role": {},
					"InputBucket": {},
					"OutputBucket": {},
					"Topics": {
						"type": "list",
						"member": {}
					}
				},
				"deprecated": true
			},
			"output": {
				"type": "structure",
				"members": {
					"Success": {},
					"Messages": {
						"type": "list",
						"member": {}
					}
				},
				"deprecated": true
			},
			"deprecated": true
		},
		"UpdatePipeline": {
			"http": {
				"method": "PUT",
				"requestUri": "/2012-09-25/pipelines/{Id}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"Name": {},
					"InputBucket": {},
					"Role": {},
					"AwsKmsKeyArn": {},
					"Notifications": {
						"shape": "S2a"
					},
					"ContentConfig": {
						"shape": "S2c"
					},
					"ThumbnailConfig": {
						"shape": "S2c"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Pipeline": {
						"shape": "S2l"
					},
					"Warnings": {
						"shape": "S2n"
					}
				}
			}
		},
		"UpdatePipelineNotifications": {
			"http": {
				"requestUri": "/2012-09-25/pipelines/{Id}/notifications"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id",
					"Notifications"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"Notifications": {
						"shape": "S2a"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Pipeline": {
						"shape": "S2l"
					}
				}
			}
		},
		"UpdatePipelineStatus": {
			"http": {
				"requestUri": "/2012-09-25/pipelines/{Id}/status"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id",
					"Status"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"Status": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Pipeline": {
						"shape": "S2l"
					}
				}
			}
		}
	},
	"shapes": {
		"S5": {
			"type": "structure",
			"members": {
				"Key": {},
				"FrameRate": {},
				"Resolution": {},
				"AspectRatio": {},
				"Interlaced": {},
				"Container": {},
				"Encryption": {
					"shape": "Sc"
				},
				"TimeSpan": {
					"shape": "Sg"
				},
				"InputCaptions": {
					"type": "structure",
					"members": {
						"MergePolicy": {},
						"CaptionSources": {
							"shape": "Sk"
						}
					}
				},
				"DetectedProperties": {
					"type": "structure",
					"members": {
						"Width": {
							"type": "integer"
						},
						"Height": {
							"type": "integer"
						},
						"FrameRate": {},
						"FileSize": {
							"type": "long"
						},
						"DurationMillis": {
							"type": "long"
						}
					}
				}
			}
		},
		"Sc": {
			"type": "structure",
			"members": {
				"Mode": {},
				"Key": {},
				"KeyMd5": {},
				"InitializationVector": {}
			}
		},
		"Sg": {
			"type": "structure",
			"members": {
				"StartTime": {},
				"Duration": {}
			}
		},
		"Sk": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Language": {},
					"TimeOffset": {},
					"Label": {},
					"Encryption": {
						"shape": "Sc"
					}
				}
			}
		},
		"St": {
			"type": "list",
			"member": {
				"shape": "S5"
			}
		},
		"Su": {
			"type": "structure",
			"members": {
				"Key": {},
				"ThumbnailPattern": {},
				"ThumbnailEncryption": {
					"shape": "Sc"
				},
				"Rotate": {},
				"PresetId": {},
				"SegmentDuration": {},
				"Watermarks": {
					"shape": "Sx"
				},
				"AlbumArt": {
					"shape": "S11"
				},
				"Composition": {
					"shape": "S19",
					"deprecated": true
				},
				"Captions": {
					"shape": "S1b"
				},
				"Encryption": {
					"shape": "Sc"
				}
			}
		},
		"Sx": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"PresetWatermarkId": {},
					"InputKey": {},
					"Encryption": {
						"shape": "Sc"
					}
				}
			}
		},
		"S11": {
			"type": "structure",
			"members": {
				"MergePolicy": {},
				"Artwork": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"InputKey": {},
							"MaxWidth": {},
							"MaxHeight": {},
							"SizingPolicy": {},
							"PaddingPolicy": {},
							"AlbumArtFormat": {},
							"Encryption": {
								"shape": "Sc"
							}
						}
					}
				}
			}
		},
		"S19": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"TimeSpan": {
						"shape": "Sg"
					}
				},
				"deprecated": true
			},
			"deprecated": true
		},
		"S1b": {
			"type": "structure",
			"members": {
				"MergePolicy": {
					"deprecated": true
				},
				"CaptionSources": {
					"shape": "Sk",
					"deprecated": true
				},
				"CaptionFormats": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Format": {},
							"Pattern": {},
							"Encryption": {
								"shape": "Sc"
							}
						}
					}
				}
			}
		},
		"S1l": {
			"type": "list",
			"member": {}
		},
		"S1m": {
			"type": "structure",
			"members": {
				"Method": {},
				"Key": {},
				"KeyMd5": {},
				"InitializationVector": {},
				"LicenseAcquisitionUrl": {},
				"KeyStoragePolicy": {}
			}
		},
		"S1q": {
			"type": "structure",
			"members": {
				"Format": {},
				"Key": {},
				"KeyMd5": {},
				"KeyId": {},
				"InitializationVector": {},
				"LicenseAcquisitionUrl": {}
			}
		},
		"S1v": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1y": {
			"type": "structure",
			"members": {
				"Id": {},
				"Arn": {},
				"PipelineId": {},
				"Input": {
					"shape": "S5"
				},
				"Inputs": {
					"shape": "St"
				},
				"Output": {
					"shape": "S1z"
				},
				"Outputs": {
					"type": "list",
					"member": {
						"shape": "S1z"
					}
				},
				"OutputKeyPrefix": {},
				"Playlists": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Name": {},
							"Format": {},
							"OutputKeys": {
								"shape": "S1l"
							},
							"HlsContentProtection": {
								"shape": "S1m"
							},
							"PlayReadyDrm": {
								"shape": "S1q"
							},
							"Status": {},
							"StatusDetail": {}
						}
					}
				},
				"Status": {},
				"UserMetadata": {
					"shape": "S1v"
				},
				"Timing": {
					"type": "structure",
					"members": {
						"SubmitTimeMillis": {
							"type": "long"
						},
						"StartTimeMillis": {
							"type": "long"
						},
						"FinishTimeMillis": {
							"type": "long"
						}
					}
				}
			}
		},
		"S1z": {
			"type": "structure",
			"members": {
				"Id": {},
				"Key": {},
				"ThumbnailPattern": {},
				"ThumbnailEncryption": {
					"shape": "Sc"
				},
				"Rotate": {},
				"PresetId": {},
				"SegmentDuration": {},
				"Status": {},
				"StatusDetail": {},
				"Duration": {
					"type": "long"
				},
				"Width": {
					"type": "integer"
				},
				"Height": {
					"type": "integer"
				},
				"FrameRate": {},
				"FileSize": {
					"type": "long"
				},
				"DurationMillis": {
					"type": "long"
				},
				"Watermarks": {
					"shape": "Sx"
				},
				"AlbumArt": {
					"shape": "S11"
				},
				"Composition": {
					"shape": "S19",
					"deprecated": true
				},
				"Captions": {
					"shape": "S1b"
				},
				"Encryption": {
					"shape": "Sc"
				},
				"AppliedColorSpaceConversion": {}
			}
		},
		"S2a": {
			"type": "structure",
			"members": {
				"Progressing": {},
				"Completed": {},
				"Warning": {},
				"Error": {}
			}
		},
		"S2c": {
			"type": "structure",
			"members": {
				"Bucket": {},
				"StorageClass": {},
				"Permissions": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"GranteeType": {},
							"Grantee": {},
							"Access": {
								"type": "list",
								"member": {}
							}
						}
					}
				}
			}
		},
		"S2l": {
			"type": "structure",
			"members": {
				"Id": {},
				"Arn": {},
				"Name": {},
				"Status": {},
				"InputBucket": {},
				"OutputBucket": {},
				"Role": {},
				"AwsKmsKeyArn": {},
				"Notifications": {
					"shape": "S2a"
				},
				"ContentConfig": {
					"shape": "S2c"
				},
				"ThumbnailConfig": {
					"shape": "S2c"
				}
			}
		},
		"S2n": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Code": {},
					"Message": {}
				}
			}
		},
		"S2r": {
			"type": "structure",
			"members": {
				"Codec": {},
				"CodecOptions": {
					"type": "map",
					"key": {},
					"value": {}
				},
				"KeyframesMaxDist": {},
				"FixedGOP": {},
				"BitRate": {},
				"FrameRate": {},
				"MaxFrameRate": {},
				"Resolution": {},
				"AspectRatio": {},
				"MaxWidth": {},
				"MaxHeight": {},
				"DisplayAspectRatio": {},
				"SizingPolicy": {},
				"PaddingPolicy": {},
				"Watermarks": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Id": {},
							"MaxWidth": {},
							"MaxHeight": {},
							"SizingPolicy": {},
							"HorizontalAlign": {},
							"HorizontalOffset": {},
							"VerticalAlign": {},
							"VerticalOffset": {},
							"Opacity": {},
							"Target": {}
						}
					}
				}
			}
		},
		"S37": {
			"type": "structure",
			"members": {
				"Codec": {},
				"SampleRate": {},
				"BitRate": {},
				"Channels": {},
				"AudioPackingMode": {},
				"CodecOptions": {
					"type": "structure",
					"members": {
						"Profile": {},
						"BitDepth": {},
						"BitOrder": {},
						"Signed": {}
					}
				}
			}
		},
		"S3i": {
			"type": "structure",
			"members": {
				"Format": {},
				"Interval": {},
				"Resolution": {},
				"AspectRatio": {},
				"MaxWidth": {},
				"MaxHeight": {},
				"SizingPolicy": {},
				"PaddingPolicy": {}
			}
		},
		"S3m": {
			"type": "structure",
			"members": {
				"Id": {},
				"Arn": {},
				"Name": {},
				"Description": {},
				"Container": {},
				"Audio": {
					"shape": "S37"
				},
				"Video": {
					"shape": "S2r"
				},
				"Thumbnails": {
					"shape": "S3i"
				},
				"Type": {}
			}
		},
		"S3v": {
			"type": "list",
			"member": {
				"shape": "S1y"
			}
		}
	}
};

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListJobsByPipeline": {
			"input_token": "PageToken",
			"output_token": "NextPageToken",
			"result_key": "Jobs"
		},
		"ListJobsByStatus": {
			"input_token": "PageToken",
			"output_token": "NextPageToken",
			"result_key": "Jobs"
		},
		"ListPipelines": {
			"input_token": "PageToken",
			"output_token": "NextPageToken",
			"result_key": "Pipelines"
		},
		"ListPresets": {
			"input_token": "PageToken",
			"output_token": "NextPageToken",
			"result_key": "Presets"
		}
	}
};

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"JobComplete": {
			"delay": 30,
			"operation": "ReadJob",
			"maxAttempts": 120,
			"acceptors": [
				{
					"expected": "Complete",
					"matcher": "path",
					"state": "success",
					"argument": "Job.Status"
				},
				{
					"expected": "Canceled",
					"matcher": "path",
					"state": "failure",
					"argument": "Job.Status"
				},
				{
					"expected": "Error",
					"matcher": "path",
					"state": "failure",
					"argument": "Job.Status"
				}
			]
		}
	}
};

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['firehose'] = {};
AWS.Firehose = Service.defineService('firehose', ['2015-08-04']);
Object.defineProperty(apiLoader.services['firehose'], '2015-08-04', {
  get: function get() {
    var model = __webpack_require__(1626);
    model.paginators = __webpack_require__(1627).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Firehose;


/***/ }),
/* 1626 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-08-04",
		"endpointPrefix": "firehose",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Firehose",
		"serviceFullName": "Amazon Kinesis Firehose",
		"signatureVersion": "v4",
		"targetPrefix": "Firehose_20150804",
		"uid": "firehose-2015-08-04"
	},
	"operations": {
		"CreateDeliveryStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName"
				],
				"members": {
					"DeliveryStreamName": {},
					"DeliveryStreamType": {},
					"KinesisStreamSourceConfiguration": {
						"type": "structure",
						"required": [
							"KinesisStreamARN",
							"RoleARN"
						],
						"members": {
							"KinesisStreamARN": {},
							"RoleARN": {}
						}
					},
					"S3DestinationConfiguration": {
						"shape": "S7",
						"deprecated": true
					},
					"ExtendedS3DestinationConfiguration": {
						"type": "structure",
						"required": [
							"RoleARN",
							"BucketARN"
						],
						"members": {
							"RoleARN": {},
							"BucketARN": {},
							"Prefix": {},
							"BufferingHints": {
								"shape": "Sa"
							},
							"CompressionFormat": {},
							"EncryptionConfiguration": {
								"shape": "Se"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"S3BackupMode": {},
							"S3BackupConfiguration": {
								"shape": "S7"
							}
						}
					},
					"RedshiftDestinationConfiguration": {
						"type": "structure",
						"required": [
							"RoleARN",
							"ClusterJDBCURL",
							"CopyCommand",
							"Username",
							"Password",
							"S3Configuration"
						],
						"members": {
							"RoleARN": {},
							"ClusterJDBCURL": {},
							"CopyCommand": {
								"shape": "Sy"
							},
							"Username": {
								"shape": "S12"
							},
							"Password": {
								"shape": "S13"
							},
							"RetryOptions": {
								"shape": "S14"
							},
							"S3Configuration": {
								"shape": "S7"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"S3BackupMode": {},
							"S3BackupConfiguration": {
								"shape": "S7"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							}
						}
					},
					"ElasticsearchDestinationConfiguration": {
						"type": "structure",
						"required": [
							"RoleARN",
							"DomainARN",
							"IndexName",
							"TypeName",
							"S3Configuration"
						],
						"members": {
							"RoleARN": {},
							"DomainARN": {},
							"IndexName": {},
							"TypeName": {},
							"IndexRotationPeriod": {},
							"BufferingHints": {
								"shape": "S1c"
							},
							"RetryOptions": {
								"shape": "S1f"
							},
							"S3BackupMode": {},
							"S3Configuration": {
								"shape": "S7"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeliveryStreamARN": {}
				}
			}
		},
		"DeleteDeliveryStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName"
				],
				"members": {
					"DeliveryStreamName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeDeliveryStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName"
				],
				"members": {
					"DeliveryStreamName": {},
					"Limit": {
						"type": "integer"
					},
					"ExclusiveStartDestinationId": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"DeliveryStreamDescription"
				],
				"members": {
					"DeliveryStreamDescription": {
						"type": "structure",
						"required": [
							"DeliveryStreamName",
							"DeliveryStreamARN",
							"DeliveryStreamStatus",
							"DeliveryStreamType",
							"VersionId",
							"Destinations",
							"HasMoreDestinations"
						],
						"members": {
							"DeliveryStreamName": {},
							"DeliveryStreamARN": {},
							"DeliveryStreamStatus": {},
							"DeliveryStreamType": {},
							"VersionId": {},
							"CreateTimestamp": {
								"type": "timestamp"
							},
							"LastUpdateTimestamp": {
								"type": "timestamp"
							},
							"Source": {
								"type": "structure",
								"members": {
									"KinesisStreamSourceDescription": {
										"type": "structure",
										"members": {
											"KinesisStreamARN": {},
											"RoleARN": {},
											"DeliveryStartTimestamp": {
												"type": "timestamp"
											}
										}
									}
								}
							},
							"Destinations": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"DestinationId"
									],
									"members": {
										"DestinationId": {},
										"S3DestinationDescription": {
											"shape": "S1z"
										},
										"ExtendedS3DestinationDescription": {
											"type": "structure",
											"required": [
												"RoleARN",
												"BucketARN",
												"BufferingHints",
												"CompressionFormat",
												"EncryptionConfiguration"
											],
											"members": {
												"RoleARN": {},
												"BucketARN": {},
												"Prefix": {},
												"BufferingHints": {
													"shape": "Sa"
												},
												"CompressionFormat": {},
												"EncryptionConfiguration": {
													"shape": "Se"
												},
												"CloudWatchLoggingOptions": {
													"shape": "Si"
												},
												"ProcessingConfiguration": {
													"shape": "Sn"
												},
												"S3BackupMode": {},
												"S3BackupDescription": {
													"shape": "S1z"
												}
											}
										},
										"RedshiftDestinationDescription": {
											"type": "structure",
											"required": [
												"RoleARN",
												"ClusterJDBCURL",
												"CopyCommand",
												"Username",
												"S3DestinationDescription"
											],
											"members": {
												"RoleARN": {},
												"ClusterJDBCURL": {},
												"CopyCommand": {
													"shape": "Sy"
												},
												"Username": {
													"shape": "S12"
												},
												"RetryOptions": {
													"shape": "S14"
												},
												"S3DestinationDescription": {
													"shape": "S1z"
												},
												"ProcessingConfiguration": {
													"shape": "Sn"
												},
												"S3BackupMode": {},
												"S3BackupDescription": {
													"shape": "S1z"
												},
												"CloudWatchLoggingOptions": {
													"shape": "Si"
												}
											}
										},
										"ElasticsearchDestinationDescription": {
											"type": "structure",
											"members": {
												"RoleARN": {},
												"DomainARN": {},
												"IndexName": {},
												"TypeName": {},
												"IndexRotationPeriod": {},
												"BufferingHints": {
													"shape": "S1c"
												},
												"RetryOptions": {
													"shape": "S1f"
												},
												"S3BackupMode": {},
												"S3DestinationDescription": {
													"shape": "S1z"
												},
												"ProcessingConfiguration": {
													"shape": "Sn"
												},
												"CloudWatchLoggingOptions": {
													"shape": "Si"
												}
											}
										}
									}
								}
							},
							"HasMoreDestinations": {
								"type": "boolean"
							}
						}
					}
				}
			}
		},
		"GetKinesisStream": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamARN"
				],
				"members": {
					"DeliveryStreamARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KinesisStreamARN": {},
					"CredentialsForReadingKinesisStream": {
						"type": "structure",
						"required": [
							"AccessKeyId",
							"SecretAccessKey",
							"SessionToken",
							"Expiration"
						],
						"members": {
							"AccessKeyId": {},
							"SecretAccessKey": {},
							"SessionToken": {},
							"Expiration": {
								"type": "timestamp"
							}
						}
					}
				}
			},
			"internalonly": true
		},
		"ListDeliveryStreams": {
			"input": {
				"type": "structure",
				"members": {
					"Limit": {
						"type": "integer"
					},
					"DeliveryStreamType": {},
					"ExclusiveStartDeliveryStreamName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"DeliveryStreamNames",
					"HasMoreDeliveryStreams"
				],
				"members": {
					"DeliveryStreamNames": {
						"type": "list",
						"member": {}
					},
					"HasMoreDeliveryStreams": {
						"type": "boolean"
					}
				}
			}
		},
		"PutRecord": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName",
					"Record"
				],
				"members": {
					"DeliveryStreamName": {},
					"Record": {
						"shape": "S2e"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"RecordId"
				],
				"members": {
					"RecordId": {}
				}
			}
		},
		"PutRecordBatch": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName",
					"Records"
				],
				"members": {
					"DeliveryStreamName": {},
					"Records": {
						"type": "list",
						"member": {
							"shape": "S2e"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"FailedPutCount",
					"RequestResponses"
				],
				"members": {
					"FailedPutCount": {
						"type": "integer"
					},
					"RequestResponses": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"RecordId": {},
								"ErrorCode": {},
								"ErrorMessage": {}
							}
						}
					}
				}
			}
		},
		"UpdateDestination": {
			"input": {
				"type": "structure",
				"required": [
					"DeliveryStreamName",
					"CurrentDeliveryStreamVersionId",
					"DestinationId"
				],
				"members": {
					"DeliveryStreamName": {},
					"CurrentDeliveryStreamVersionId": {},
					"DestinationId": {},
					"S3DestinationUpdate": {
						"shape": "S2r",
						"deprecated": true
					},
					"ExtendedS3DestinationUpdate": {
						"type": "structure",
						"members": {
							"RoleARN": {},
							"BucketARN": {},
							"Prefix": {},
							"BufferingHints": {
								"shape": "Sa"
							},
							"CompressionFormat": {},
							"EncryptionConfiguration": {
								"shape": "Se"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"S3BackupMode": {},
							"S3BackupUpdate": {
								"shape": "S2r"
							}
						}
					},
					"RedshiftDestinationUpdate": {
						"type": "structure",
						"members": {
							"RoleARN": {},
							"ClusterJDBCURL": {},
							"CopyCommand": {
								"shape": "Sy"
							},
							"Username": {
								"shape": "S12"
							},
							"Password": {
								"shape": "S13"
							},
							"RetryOptions": {
								"shape": "S14"
							},
							"S3Update": {
								"shape": "S2r"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"S3BackupMode": {},
							"S3BackupUpdate": {
								"shape": "S2r"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							}
						}
					},
					"ElasticsearchDestinationUpdate": {
						"type": "structure",
						"members": {
							"RoleARN": {},
							"DomainARN": {},
							"IndexName": {},
							"TypeName": {},
							"IndexRotationPeriod": {},
							"BufferingHints": {
								"shape": "S1c"
							},
							"RetryOptions": {
								"shape": "S1f"
							},
							"S3Update": {
								"shape": "S2r"
							},
							"ProcessingConfiguration": {
								"shape": "Sn"
							},
							"CloudWatchLoggingOptions": {
								"shape": "Si"
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		}
	},
	"shapes": {
		"S7": {
			"type": "structure",
			"required": [
				"RoleARN",
				"BucketARN"
			],
			"members": {
				"RoleARN": {},
				"BucketARN": {},
				"Prefix": {},
				"BufferingHints": {
					"shape": "Sa"
				},
				"CompressionFormat": {},
				"EncryptionConfiguration": {
					"shape": "Se"
				},
				"CloudWatchLoggingOptions": {
					"shape": "Si"
				}
			}
		},
		"Sa": {
			"type": "structure",
			"members": {
				"SizeInMBs": {
					"type": "integer"
				},
				"IntervalInSeconds": {
					"type": "integer"
				}
			}
		},
		"Se": {
			"type": "structure",
			"members": {
				"NoEncryptionConfig": {},
				"KMSEncryptionConfig": {
					"type": "structure",
					"required": [
						"AWSKMSKeyARN"
					],
					"members": {
						"AWSKMSKeyARN": {}
					}
				}
			}
		},
		"Si": {
			"type": "structure",
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"LogGroupName": {},
				"LogStreamName": {}
			}
		},
		"Sn": {
			"type": "structure",
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"Processors": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"Type"
						],
						"members": {
							"Type": {},
							"Parameters": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"ParameterName",
										"ParameterValue"
									],
									"members": {
										"ParameterName": {},
										"ParameterValue": {}
									}
								}
							}
						}
					}
				}
			}
		},
		"Sy": {
			"type": "structure",
			"required": [
				"DataTableName"
			],
			"members": {
				"DataTableName": {},
				"DataTableColumns": {},
				"CopyOptions": {}
			}
		},
		"S12": {
			"type": "string",
			"sensitive": true
		},
		"S13": {
			"type": "string",
			"sensitive": true
		},
		"S14": {
			"type": "structure",
			"members": {
				"DurationInSeconds": {
					"type": "integer"
				}
			}
		},
		"S1c": {
			"type": "structure",
			"members": {
				"IntervalInSeconds": {
					"type": "integer"
				},
				"SizeInMBs": {
					"type": "integer"
				}
			}
		},
		"S1f": {
			"type": "structure",
			"members": {
				"DurationInSeconds": {
					"type": "integer"
				}
			}
		},
		"S1z": {
			"type": "structure",
			"required": [
				"RoleARN",
				"BucketARN",
				"BufferingHints",
				"CompressionFormat",
				"EncryptionConfiguration"
			],
			"members": {
				"RoleARN": {},
				"BucketARN": {},
				"Prefix": {},
				"BufferingHints": {
					"shape": "Sa"
				},
				"CompressionFormat": {},
				"EncryptionConfiguration": {
					"shape": "Se"
				},
				"CloudWatchLoggingOptions": {
					"shape": "Si"
				}
			}
		},
		"S2e": {
			"type": "structure",
			"required": [
				"Data"
			],
			"members": {
				"Data": {
					"type": "blob"
				}
			}
		},
		"S2r": {
			"type": "structure",
			"members": {
				"RoleARN": {},
				"BucketARN": {},
				"Prefix": {},
				"BufferingHints": {
					"shape": "Sa"
				},
				"CompressionFormat": {},
				"EncryptionConfiguration": {
					"shape": "Se"
				},
				"CloudWatchLoggingOptions": {
					"shape": "Si"
				}
			}
		}
	}
};

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['gamelift'] = {};
AWS.GameLift = Service.defineService('gamelift', ['2015-10-01']);
Object.defineProperty(apiLoader.services['gamelift'], '2015-10-01', {
  get: function get() {
    var model = __webpack_require__(1629);
    model.paginators = __webpack_require__(1630).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.GameLift;


/***/ }),
/* 1629 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-10-01",
		"endpointPrefix": "gamelift",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon GameLift",
		"signatureVersion": "v4",
		"targetPrefix": "GameLift",
		"uid": "gamelift-2015-10-01"
	},
	"operations": {
		"AcceptMatch": {
			"input": {
				"type": "structure",
				"required": [
					"TicketId",
					"PlayerIds",
					"AcceptanceType"
				],
				"members": {
					"TicketId": {},
					"PlayerIds": {
						"type": "list",
						"member": {}
					},
					"AcceptanceType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateAlias": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"RoutingStrategy"
				],
				"members": {
					"Name": {},
					"Description": {},
					"RoutingStrategy": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Alias": {
						"shape": "Sf"
					}
				}
			}
		},
		"CreateBuild": {
			"input": {
				"type": "structure",
				"members": {
					"Name": {},
					"Version": {},
					"StorageLocation": {
						"shape": "Sk"
					},
					"OperatingSystem": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Build": {
						"shape": "So"
					},
					"UploadCredentials": {
						"shape": "Ss"
					},
					"StorageLocation": {
						"shape": "Sk"
					}
				}
			}
		},
		"CreateFleet": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"BuildId",
					"EC2InstanceType"
				],
				"members": {
					"Name": {},
					"Description": {},
					"BuildId": {},
					"ServerLaunchPath": {},
					"ServerLaunchParameters": {},
					"LogPaths": {
						"shape": "Su"
					},
					"EC2InstanceType": {},
					"EC2InboundPermissions": {
						"shape": "Sw"
					},
					"NewGameSessionProtectionPolicy": {},
					"RuntimeConfiguration": {
						"shape": "S12"
					},
					"ResourceCreationLimitPolicy": {
						"shape": "S18"
					},
					"MetricGroups": {
						"shape": "S1a"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetAttributes": {
						"shape": "S1d"
					}
				}
			}
		},
		"CreateGameSession": {
			"input": {
				"type": "structure",
				"required": [
					"MaximumPlayerSessionCount"
				],
				"members": {
					"FleetId": {},
					"AliasId": {},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"Name": {},
					"GameProperties": {
						"shape": "S1g"
					},
					"CreatorId": {},
					"GameSessionId": {},
					"IdempotencyToken": {},
					"GameSessionData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSession": {
						"shape": "S1n"
					}
				}
			}
		},
		"CreateGameSessionQueue": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"TimeoutInSeconds": {
						"type": "integer"
					},
					"PlayerLatencyPolicies": {
						"shape": "S1t"
					},
					"Destinations": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionQueue": {
						"shape": "S1y"
					}
				}
			}
		},
		"CreateMatchmakingConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"GameSessionQueueArns",
					"RequestTimeoutSeconds",
					"AcceptanceRequired",
					"RuleSetName"
				],
				"members": {
					"Name": {},
					"Description": {},
					"GameSessionQueueArns": {
						"shape": "S20"
					},
					"RequestTimeoutSeconds": {
						"type": "integer"
					},
					"AcceptanceTimeoutSeconds": {
						"type": "integer"
					},
					"AcceptanceRequired": {
						"type": "boolean"
					},
					"RuleSetName": {},
					"NotificationTarget": {},
					"AdditionalPlayerCount": {
						"type": "integer"
					},
					"CustomEventData": {},
					"GameProperties": {
						"shape": "S1g"
					},
					"GameSessionData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Configuration": {
						"shape": "S27"
					}
				}
			}
		},
		"CreateMatchmakingRuleSet": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"RuleSetBody"
				],
				"members": {
					"Name": {},
					"RuleSetBody": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"RuleSet"
				],
				"members": {
					"RuleSet": {
						"shape": "S2b"
					}
				}
			}
		},
		"CreatePlayerSession": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId",
					"PlayerId"
				],
				"members": {
					"GameSessionId": {},
					"PlayerId": {},
					"PlayerData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlayerSession": {
						"shape": "S2f"
					}
				}
			}
		},
		"CreatePlayerSessions": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId",
					"PlayerIds"
				],
				"members": {
					"GameSessionId": {},
					"PlayerIds": {
						"type": "list",
						"member": {}
					},
					"PlayerDataMap": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlayerSessions": {
						"shape": "S2m"
					}
				}
			}
		},
		"DeleteAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {}
				}
			}
		},
		"DeleteBuild": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {}
				}
			}
		},
		"DeleteFleet": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {}
				}
			}
		},
		"DeleteGameSessionQueue": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteMatchmakingConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"FleetId"
				],
				"members": {
					"Name": {},
					"FleetId": {}
				}
			}
		},
		"DescribeAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Alias": {
						"shape": "Sf"
					}
				}
			}
		},
		"DescribeBuild": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Build": {
						"shape": "So"
					}
				}
			}
		},
		"DescribeEC2InstanceLimits": {
			"input": {
				"type": "structure",
				"members": {
					"EC2InstanceType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EC2InstanceLimits": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EC2InstanceType": {},
								"CurrentInstances": {
									"type": "integer"
								},
								"InstanceLimit": {
									"type": "integer"
								}
							}
						}
					}
				}
			}
		},
		"DescribeFleetAttributes": {
			"input": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S34"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetAttributes": {
						"type": "list",
						"member": {
							"shape": "S1d"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeFleetCapacity": {
			"input": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S34"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetCapacity": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"InstanceType": {},
								"InstanceCounts": {
									"type": "structure",
									"members": {
										"DESIRED": {
											"type": "integer"
										},
										"MINIMUM": {
											"type": "integer"
										},
										"MAXIMUM": {
											"type": "integer"
										},
										"PENDING": {
											"type": "integer"
										},
										"ACTIVE": {
											"type": "integer"
										},
										"IDLE": {
											"type": "integer"
										},
										"TERMINATING": {
											"type": "integer"
										}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeFleetEvents": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Events": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EventId": {},
								"ResourceId": {},
								"EventCode": {},
								"Message": {},
								"EventTime": {
									"type": "timestamp"
								},
								"PreSignedLogUrl": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeFleetPortSettings": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InboundPermissions": {
						"shape": "Sw"
					}
				}
			}
		},
		"DescribeFleetUtilization": {
			"input": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S34"
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetUtilization": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"ActiveServerProcessCount": {
									"type": "integer"
								},
								"ActiveGameSessionCount": {
									"type": "integer"
								},
								"CurrentPlayerSessionCount": {
									"type": "integer"
								},
								"MaximumPlayerSessionCount": {
									"type": "integer"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeGameSessionDetails": {
			"input": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"GameSessionId": {},
					"AliasId": {},
					"StatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionDetails": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"GameSession": {
									"shape": "S1n"
								},
								"ProtectionPolicy": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeGameSessionPlacement": {
			"input": {
				"type": "structure",
				"required": [
					"PlacementId"
				],
				"members": {
					"PlacementId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionPlacement": {
						"shape": "S3t"
					}
				}
			}
		},
		"DescribeGameSessionQueues": {
			"input": {
				"type": "structure",
				"members": {
					"Names": {
						"type": "list",
						"member": {}
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionQueues": {
						"type": "list",
						"member": {
							"shape": "S1y"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeGameSessions": {
			"input": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"GameSessionId": {},
					"AliasId": {},
					"StatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessions": {
						"shape": "S46"
					},
					"NextToken": {}
				}
			}
		},
		"DescribeInstances": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"InstanceId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Instances": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"InstanceId": {},
								"IpAddress": {},
								"OperatingSystem": {},
								"Type": {},
								"Status": {},
								"CreationTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMatchmaking": {
			"input": {
				"type": "structure",
				"required": [
					"TicketIds"
				],
				"members": {
					"TicketIds": {
						"shape": "S4e"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TicketList": {
						"type": "list",
						"member": {
							"shape": "S4h"
						}
					}
				}
			}
		},
		"DescribeMatchmakingConfigurations": {
			"input": {
				"type": "structure",
				"members": {
					"Names": {
						"shape": "S4e"
					},
					"RuleSetName": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Configurations": {
						"type": "list",
						"member": {
							"shape": "S27"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMatchmakingRuleSets": {
			"input": {
				"type": "structure",
				"members": {
					"Names": {
						"type": "list",
						"member": {}
					},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"RuleSets"
				],
				"members": {
					"RuleSets": {
						"type": "list",
						"member": {
							"shape": "S2b"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribePlayerSessions": {
			"input": {
				"type": "structure",
				"members": {
					"GameSessionId": {},
					"PlayerId": {},
					"PlayerSessionId": {},
					"PlayerSessionStatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PlayerSessions": {
						"shape": "S2m"
					},
					"NextToken": {}
				}
			}
		},
		"DescribeRuntimeConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RuntimeConfiguration": {
						"shape": "S12"
					}
				}
			}
		},
		"DescribeScalingPolicies": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"StatusFilter": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ScalingPolicies": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"Name": {},
								"Status": {},
								"ScalingAdjustment": {
									"type": "integer"
								},
								"ScalingAdjustmentType": {},
								"ComparisonOperator": {},
								"Threshold": {
									"type": "double"
								},
								"EvaluationPeriods": {
									"type": "integer"
								},
								"MetricName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"GetGameSessionLogUrl": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId"
				],
				"members": {
					"GameSessionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PreSignedUrl": {}
				}
			}
		},
		"GetInstanceAccess": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId",
					"InstanceId"
				],
				"members": {
					"FleetId": {},
					"InstanceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceAccess": {
						"type": "structure",
						"members": {
							"FleetId": {},
							"InstanceId": {},
							"IpAddress": {},
							"OperatingSystem": {},
							"Credentials": {
								"type": "structure",
								"members": {
									"UserName": {},
									"Secret": {}
								},
								"sensitive": true
							}
						}
					}
				}
			}
		},
		"ListAliases": {
			"input": {
				"type": "structure",
				"members": {
					"RoutingStrategyType": {},
					"Name": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Aliases": {
						"type": "list",
						"member": {
							"shape": "Sf"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListBuilds": {
			"input": {
				"type": "structure",
				"members": {
					"Status": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Builds": {
						"type": "list",
						"member": {
							"shape": "So"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListFleets": {
			"input": {
				"type": "structure",
				"members": {
					"BuildId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetIds": {
						"shape": "S34"
					},
					"NextToken": {}
				}
			}
		},
		"PutScalingPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"FleetId",
					"ScalingAdjustment",
					"ScalingAdjustmentType",
					"Threshold",
					"ComparisonOperator",
					"EvaluationPeriods",
					"MetricName"
				],
				"members": {
					"Name": {},
					"FleetId": {},
					"ScalingAdjustment": {
						"type": "integer"
					},
					"ScalingAdjustmentType": {},
					"Threshold": {
						"type": "double"
					},
					"ComparisonOperator": {},
					"EvaluationPeriods": {
						"type": "integer"
					},
					"MetricName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Name": {}
				}
			}
		},
		"RequestUploadCredentials": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UploadCredentials": {
						"shape": "Ss"
					},
					"StorageLocation": {
						"shape": "Sk"
					}
				}
			}
		},
		"ResolveAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"SearchGameSessions": {
			"input": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"AliasId": {},
					"FilterExpression": {},
					"SortExpression": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessions": {
						"shape": "S46"
					},
					"NextToken": {}
				}
			}
		},
		"StartGameSessionPlacement": {
			"input": {
				"type": "structure",
				"required": [
					"PlacementId",
					"GameSessionQueueName",
					"MaximumPlayerSessionCount"
				],
				"members": {
					"PlacementId": {},
					"GameSessionQueueName": {},
					"GameProperties": {
						"shape": "S1g"
					},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"GameSessionName": {},
					"PlayerLatencies": {
						"shape": "S3v"
					},
					"DesiredPlayerSessions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PlayerId": {},
								"PlayerData": {}
							}
						}
					},
					"GameSessionData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionPlacement": {
						"shape": "S3t"
					}
				}
			}
		},
		"StartMatchmaking": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationName",
					"Players"
				],
				"members": {
					"TicketId": {},
					"ConfigurationName": {},
					"Players": {
						"shape": "S4k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MatchmakingTicket": {
						"shape": "S4h"
					}
				}
			}
		},
		"StopGameSessionPlacement": {
			"input": {
				"type": "structure",
				"required": [
					"PlacementId"
				],
				"members": {
					"PlacementId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionPlacement": {
						"shape": "S3t"
					}
				}
			}
		},
		"StopMatchmaking": {
			"input": {
				"type": "structure",
				"required": [
					"TicketId"
				],
				"members": {
					"TicketId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasId"
				],
				"members": {
					"AliasId": {},
					"Name": {},
					"Description": {},
					"RoutingStrategy": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Alias": {
						"shape": "Sf"
					}
				}
			}
		},
		"UpdateBuild": {
			"input": {
				"type": "structure",
				"required": [
					"BuildId"
				],
				"members": {
					"BuildId": {},
					"Name": {},
					"Version": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Build": {
						"shape": "So"
					}
				}
			}
		},
		"UpdateFleetAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"Name": {},
					"Description": {},
					"NewGameSessionProtectionPolicy": {},
					"ResourceCreationLimitPolicy": {
						"shape": "S18"
					},
					"MetricGroups": {
						"shape": "S1a"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"UpdateFleetCapacity": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"DesiredInstances": {
						"type": "integer"
					},
					"MinSize": {
						"type": "integer"
					},
					"MaxSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"UpdateFleetPortSettings": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId"
				],
				"members": {
					"FleetId": {},
					"InboundPermissionAuthorizations": {
						"shape": "Sw"
					},
					"InboundPermissionRevocations": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FleetId": {}
				}
			}
		},
		"UpdateGameSession": {
			"input": {
				"type": "structure",
				"required": [
					"GameSessionId"
				],
				"members": {
					"GameSessionId": {},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"Name": {},
					"PlayerSessionCreationPolicy": {},
					"ProtectionPolicy": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSession": {
						"shape": "S1n"
					}
				}
			}
		},
		"UpdateGameSessionQueue": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"TimeoutInSeconds": {
						"type": "integer"
					},
					"PlayerLatencyPolicies": {
						"shape": "S1t"
					},
					"Destinations": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GameSessionQueue": {
						"shape": "S1y"
					}
				}
			}
		},
		"UpdateMatchmakingConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Description": {},
					"GameSessionQueueArns": {
						"shape": "S20"
					},
					"RequestTimeoutSeconds": {
						"type": "integer"
					},
					"AcceptanceTimeoutSeconds": {
						"type": "integer"
					},
					"AcceptanceRequired": {
						"type": "boolean"
					},
					"RuleSetName": {},
					"NotificationTarget": {},
					"AdditionalPlayerCount": {
						"type": "integer"
					},
					"CustomEventData": {},
					"GameProperties": {
						"shape": "S1g"
					},
					"GameSessionData": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Configuration": {
						"shape": "S27"
					}
				}
			}
		},
		"UpdateRuntimeConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"FleetId",
					"RuntimeConfiguration"
				],
				"members": {
					"FleetId": {},
					"RuntimeConfiguration": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RuntimeConfiguration": {
						"shape": "S12"
					}
				}
			}
		},
		"ValidateMatchmakingRuleSet": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetBody"
				],
				"members": {
					"RuleSetBody": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Valid": {
						"type": "boolean"
					}
				}
			}
		}
	},
	"shapes": {
		"Sa": {
			"type": "structure",
			"members": {
				"Type": {},
				"FleetId": {},
				"Message": {}
			}
		},
		"Sf": {
			"type": "structure",
			"members": {
				"AliasId": {},
				"Name": {},
				"AliasArn": {},
				"Description": {},
				"RoutingStrategy": {
					"shape": "Sa"
				},
				"CreationTime": {
					"type": "timestamp"
				},
				"LastUpdatedTime": {
					"type": "timestamp"
				}
			}
		},
		"Sk": {
			"type": "structure",
			"members": {
				"Bucket": {},
				"Key": {},
				"RoleArn": {}
			}
		},
		"So": {
			"type": "structure",
			"members": {
				"BuildId": {},
				"Name": {},
				"Version": {},
				"Status": {},
				"SizeOnDisk": {
					"type": "long"
				},
				"OperatingSystem": {},
				"CreationTime": {
					"type": "timestamp"
				}
			}
		},
		"Ss": {
			"type": "structure",
			"members": {
				"AccessKeyId": {},
				"SecretAccessKey": {},
				"SessionToken": {}
			},
			"sensitive": true
		},
		"Su": {
			"type": "list",
			"member": {}
		},
		"Sw": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"FromPort",
					"ToPort",
					"IpRange",
					"Protocol"
				],
				"members": {
					"FromPort": {
						"type": "integer"
					},
					"ToPort": {
						"type": "integer"
					},
					"IpRange": {},
					"Protocol": {}
				}
			}
		},
		"S12": {
			"type": "structure",
			"members": {
				"ServerProcesses": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"LaunchPath",
							"ConcurrentExecutions"
						],
						"members": {
							"LaunchPath": {},
							"Parameters": {},
							"ConcurrentExecutions": {
								"type": "integer"
							}
						}
					}
				},
				"MaxConcurrentGameSessionActivations": {
					"type": "integer"
				},
				"GameSessionActivationTimeoutSeconds": {
					"type": "integer"
				}
			}
		},
		"S18": {
			"type": "structure",
			"members": {
				"NewGameSessionsPerCreator": {
					"type": "integer"
				},
				"PolicyPeriodInMinutes": {
					"type": "integer"
				}
			}
		},
		"S1a": {
			"type": "list",
			"member": {}
		},
		"S1d": {
			"type": "structure",
			"members": {
				"FleetId": {},
				"FleetArn": {},
				"Description": {},
				"Name": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"TerminationTime": {
					"type": "timestamp"
				},
				"Status": {},
				"BuildId": {},
				"ServerLaunchPath": {},
				"ServerLaunchParameters": {},
				"LogPaths": {
					"shape": "Su"
				},
				"NewGameSessionProtectionPolicy": {},
				"OperatingSystem": {},
				"ResourceCreationLimitPolicy": {
					"shape": "S18"
				},
				"MetricGroups": {
					"shape": "S1a"
				}
			}
		},
		"S1g": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S1n": {
			"type": "structure",
			"members": {
				"GameSessionId": {},
				"Name": {},
				"FleetId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"TerminationTime": {
					"type": "timestamp"
				},
				"CurrentPlayerSessionCount": {
					"type": "integer"
				},
				"MaximumPlayerSessionCount": {
					"type": "integer"
				},
				"Status": {},
				"GameProperties": {
					"shape": "S1g"
				},
				"IpAddress": {},
				"Port": {
					"type": "integer"
				},
				"PlayerSessionCreationPolicy": {},
				"CreatorId": {},
				"GameSessionData": {}
			}
		},
		"S1t": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"MaximumIndividualPlayerLatencyMilliseconds": {
						"type": "integer"
					},
					"PolicyDurationSeconds": {
						"type": "integer"
					}
				}
			}
		},
		"S1v": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"DestinationArn": {}
				}
			}
		},
		"S1y": {
			"type": "structure",
			"members": {
				"Name": {},
				"GameSessionQueueArn": {},
				"TimeoutInSeconds": {
					"type": "integer"
				},
				"PlayerLatencyPolicies": {
					"shape": "S1t"
				},
				"Destinations": {
					"shape": "S1v"
				}
			}
		},
		"S20": {
			"type": "list",
			"member": {}
		},
		"S27": {
			"type": "structure",
			"members": {
				"Name": {},
				"Description": {},
				"GameSessionQueueArns": {
					"shape": "S20"
				},
				"RequestTimeoutSeconds": {
					"type": "integer"
				},
				"AcceptanceTimeoutSeconds": {
					"type": "integer"
				},
				"AcceptanceRequired": {
					"type": "boolean"
				},
				"RuleSetName": {},
				"NotificationTarget": {},
				"AdditionalPlayerCount": {
					"type": "integer"
				},
				"CustomEventData": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"GameProperties": {
					"shape": "S1g"
				},
				"GameSessionData": {}
			}
		},
		"S2b": {
			"type": "structure",
			"required": [
				"RuleSetBody"
			],
			"members": {
				"RuleSetName": {},
				"RuleSetBody": {},
				"CreationTime": {
					"type": "timestamp"
				}
			}
		},
		"S2f": {
			"type": "structure",
			"members": {
				"PlayerSessionId": {},
				"PlayerId": {},
				"GameSessionId": {},
				"FleetId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"TerminationTime": {
					"type": "timestamp"
				},
				"Status": {},
				"IpAddress": {},
				"Port": {
					"type": "integer"
				},
				"PlayerData": {}
			}
		},
		"S2m": {
			"type": "list",
			"member": {
				"shape": "S2f"
			}
		},
		"S34": {
			"type": "list",
			"member": {}
		},
		"S3t": {
			"type": "structure",
			"members": {
				"PlacementId": {},
				"GameSessionQueueName": {},
				"Status": {},
				"GameProperties": {
					"shape": "S1g"
				},
				"MaximumPlayerSessionCount": {
					"type": "integer"
				},
				"GameSessionName": {},
				"GameSessionId": {},
				"GameSessionArn": {},
				"GameSessionRegion": {},
				"PlayerLatencies": {
					"shape": "S3v"
				},
				"StartTime": {
					"type": "timestamp"
				},
				"EndTime": {
					"type": "timestamp"
				},
				"IpAddress": {},
				"Port": {
					"type": "integer"
				},
				"PlacedPlayerSessions": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"PlayerId": {},
							"PlayerSessionId": {}
						}
					}
				},
				"GameSessionData": {}
			}
		},
		"S3v": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"PlayerId": {},
					"RegionIdentifier": {},
					"LatencyInMilliseconds": {
						"type": "float"
					}
				}
			}
		},
		"S46": {
			"type": "list",
			"member": {
				"shape": "S1n"
			}
		},
		"S4e": {
			"type": "list",
			"member": {}
		},
		"S4h": {
			"type": "structure",
			"members": {
				"TicketId": {},
				"ConfigurationName": {},
				"Status": {},
				"StatusReason": {},
				"StatusMessage": {},
				"StartTime": {
					"type": "timestamp"
				},
				"Players": {
					"shape": "S4k"
				},
				"GameSessionConnectionInfo": {
					"type": "structure",
					"members": {
						"GameSessionArn": {},
						"IpAddress": {},
						"Port": {
							"type": "integer"
						},
						"MatchedPlayerSessions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PlayerId": {},
									"PlayerSessionId": {}
								}
							}
						}
					}
				}
			}
		},
		"S4k": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"PlayerId": {},
					"PlayerAttributes": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"S": {},
								"N": {
									"type": "double"
								},
								"SL": {
									"shape": "Su"
								},
								"SDM": {
									"type": "map",
									"key": {},
									"value": {
										"type": "double"
									}
								}
							}
						}
					},
					"Team": {},
					"LatencyInMs": {
						"type": "map",
						"key": {},
						"value": {
							"type": "integer"
						}
					}
				}
			}
		}
	}
};

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['inspector'] = {};
AWS.Inspector = Service.defineService('inspector', ['2015-08-18*', '2016-02-16']);
Object.defineProperty(apiLoader.services['inspector'], '2016-02-16', {
  get: function get() {
    var model = __webpack_require__(1632);
    model.paginators = __webpack_require__(1633).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Inspector;


/***/ }),
/* 1632 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-02-16",
		"endpointPrefix": "inspector",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Inspector",
		"signatureVersion": "v4",
		"targetPrefix": "InspectorService",
		"uid": "inspector-2016-02-16"
	},
	"operations": {
		"AddAttributesToFindings": {
			"input": {
				"type": "structure",
				"required": [
					"findingArns",
					"attributes"
				],
				"members": {
					"findingArns": {
						"shape": "S2"
					},
					"attributes": {
						"shape": "S4"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"failedItems"
				],
				"members": {
					"failedItems": {
						"shape": "S9"
					}
				}
			}
		},
		"CreateAssessmentTarget": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentTargetName",
					"resourceGroupArn"
				],
				"members": {
					"assessmentTargetName": {},
					"resourceGroupArn": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"assessmentTargetArn"
				],
				"members": {
					"assessmentTargetArn": {}
				}
			}
		},
		"CreateAssessmentTemplate": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentTargetArn",
					"assessmentTemplateName",
					"durationInSeconds",
					"rulesPackageArns"
				],
				"members": {
					"assessmentTargetArn": {},
					"assessmentTemplateName": {},
					"durationInSeconds": {
						"type": "integer"
					},
					"rulesPackageArns": {
						"shape": "Sj"
					},
					"userAttributesForFindings": {
						"shape": "S4"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"assessmentTemplateArn"
				],
				"members": {
					"assessmentTemplateArn": {}
				}
			}
		},
		"CreateResourceGroup": {
			"input": {
				"type": "structure",
				"required": [
					"resourceGroupTags"
				],
				"members": {
					"resourceGroupTags": {
						"shape": "Sm"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"resourceGroupArn"
				],
				"members": {
					"resourceGroupArn": {}
				}
			}
		},
		"DeleteAssessmentRun": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentRunArn"
				],
				"members": {
					"assessmentRunArn": {}
				}
			}
		},
		"DeleteAssessmentTarget": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentTargetArn"
				],
				"members": {
					"assessmentTargetArn": {}
				}
			}
		},
		"DeleteAssessmentTemplate": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentTemplateArn"
				],
				"members": {
					"assessmentTemplateArn": {}
				}
			}
		},
		"DescribeAssessmentRuns": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentRunArns"
				],
				"members": {
					"assessmentRunArns": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"assessmentRuns",
					"failedItems"
				],
				"members": {
					"assessmentRuns": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"arn",
								"name",
								"assessmentTemplateArn",
								"state",
								"durationInSeconds",
								"rulesPackageArns",
								"userAttributesForFindings",
								"createdAt",
								"stateChangedAt",
								"dataCollected",
								"stateChanges",
								"notifications",
								"findingCounts"
							],
							"members": {
								"arn": {},
								"name": {},
								"assessmentTemplateArn": {},
								"state": {},
								"durationInSeconds": {
									"type": "integer"
								},
								"rulesPackageArns": {
									"type": "list",
									"member": {}
								},
								"userAttributesForFindings": {
									"shape": "S4"
								},
								"createdAt": {
									"type": "timestamp"
								},
								"startedAt": {
									"type": "timestamp"
								},
								"completedAt": {
									"type": "timestamp"
								},
								"stateChangedAt": {
									"type": "timestamp"
								},
								"dataCollected": {
									"type": "boolean"
								},
								"stateChanges": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"stateChangedAt",
											"state"
										],
										"members": {
											"stateChangedAt": {
												"type": "timestamp"
											},
											"state": {}
										}
									}
								},
								"notifications": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"date",
											"event",
											"error"
										],
										"members": {
											"date": {
												"type": "timestamp"
											},
											"event": {},
											"message": {},
											"error": {
												"type": "boolean"
											},
											"snsTopicArn": {},
											"snsPublishStatusCode": {}
										}
									}
								},
								"findingCounts": {
									"type": "map",
									"key": {},
									"value": {
										"type": "integer"
									}
								}
							}
						}
					},
					"failedItems": {
						"shape": "S9"
					}
				}
			}
		},
		"DescribeAssessmentTargets": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentTargetArns"
				],
				"members": {
					"assessmentTargetArns": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"assessmentTargets",
					"failedItems"
				],
				"members": {
					"assessmentTargets": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"arn",
								"name",
								"resourceGroupArn",
								"createdAt",
								"updatedAt"
							],
							"members": {
								"arn": {},
								"name": {},
								"resourceGroupArn": {},
								"createdAt": {
									"type": "timestamp"
								},
								"updatedAt": {
									"type": "timestamp"
								}
							}
						}
					},
					"failedItems": {
						"shape": "S9"
					}
				}
			}
		},
		"DescribeAssessmentTemplates": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentTemplateArns"
				],
				"members": {
					"assessmentTemplateArns": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"assessmentTemplates",
					"failedItems"
				],
				"members": {
					"assessmentTemplates": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"arn",
								"name",
								"assessmentTargetArn",
								"durationInSeconds",
								"rulesPackageArns",
								"userAttributesForFindings",
								"createdAt"
							],
							"members": {
								"arn": {},
								"name": {},
								"assessmentTargetArn": {},
								"durationInSeconds": {
									"type": "integer"
								},
								"rulesPackageArns": {
									"shape": "Sj"
								},
								"userAttributesForFindings": {
									"shape": "S4"
								},
								"createdAt": {
									"type": "timestamp"
								}
							}
						}
					},
					"failedItems": {
						"shape": "S9"
					}
				}
			}
		},
		"DescribeCrossAccountAccessRole": {
			"output": {
				"type": "structure",
				"required": [
					"roleArn",
					"valid",
					"registeredAt"
				],
				"members": {
					"roleArn": {},
					"valid": {
						"type": "boolean"
					},
					"registeredAt": {
						"type": "timestamp"
					}
				}
			}
		},
		"DescribeFindings": {
			"input": {
				"type": "structure",
				"required": [
					"findingArns"
				],
				"members": {
					"findingArns": {
						"shape": "Sv"
					},
					"locale": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"findings",
					"failedItems"
				],
				"members": {
					"findings": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"arn",
								"attributes",
								"userAttributes",
								"createdAt",
								"updatedAt"
							],
							"members": {
								"arn": {},
								"schemaVersion": {
									"type": "integer"
								},
								"service": {},
								"serviceAttributes": {
									"type": "structure",
									"required": [
										"schemaVersion"
									],
									"members": {
										"schemaVersion": {
											"type": "integer"
										},
										"assessmentRunArn": {},
										"rulesPackageArn": {}
									}
								},
								"assetType": {},
								"assetAttributes": {
									"type": "structure",
									"required": [
										"schemaVersion"
									],
									"members": {
										"schemaVersion": {
											"type": "integer"
										},
										"agentId": {},
										"autoScalingGroup": {},
										"amiId": {},
										"hostname": {},
										"ipv4Addresses": {
											"type": "list",
											"member": {}
										}
									}
								},
								"id": {},
								"title": {},
								"description": {},
								"recommendation": {},
								"severity": {},
								"numericSeverity": {
									"type": "double"
								},
								"confidence": {
									"type": "integer"
								},
								"indicatorOfCompromise": {
									"type": "boolean"
								},
								"attributes": {
									"shape": "S26"
								},
								"userAttributes": {
									"shape": "S4"
								},
								"createdAt": {
									"type": "timestamp"
								},
								"updatedAt": {
									"type": "timestamp"
								}
							}
						}
					},
					"failedItems": {
						"shape": "S9"
					}
				}
			}
		},
		"DescribeResourceGroups": {
			"input": {
				"type": "structure",
				"required": [
					"resourceGroupArns"
				],
				"members": {
					"resourceGroupArns": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"resourceGroups",
					"failedItems"
				],
				"members": {
					"resourceGroups": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"arn",
								"tags",
								"createdAt"
							],
							"members": {
								"arn": {},
								"tags": {
									"shape": "Sm"
								},
								"createdAt": {
									"type": "timestamp"
								}
							}
						}
					},
					"failedItems": {
						"shape": "S9"
					}
				}
			}
		},
		"DescribeRulesPackages": {
			"input": {
				"type": "structure",
				"required": [
					"rulesPackageArns"
				],
				"members": {
					"rulesPackageArns": {
						"shape": "Sv"
					},
					"locale": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"rulesPackages",
					"failedItems"
				],
				"members": {
					"rulesPackages": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"arn",
								"name",
								"version",
								"provider"
							],
							"members": {
								"arn": {},
								"name": {},
								"version": {},
								"provider": {},
								"description": {}
							}
						}
					},
					"failedItems": {
						"shape": "S9"
					}
				}
			}
		},
		"GetAssessmentReport": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentRunArn",
					"reportFileFormat",
					"reportType"
				],
				"members": {
					"assessmentRunArn": {},
					"reportFileFormat": {},
					"reportType": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"status"
				],
				"members": {
					"status": {},
					"url": {}
				}
			}
		},
		"GetTelemetryMetadata": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentRunArn"
				],
				"members": {
					"assessmentRunArn": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"telemetryMetadata"
				],
				"members": {
					"telemetryMetadata": {
						"shape": "S2q"
					}
				}
			}
		},
		"ListAssessmentRunAgents": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentRunArn"
				],
				"members": {
					"assessmentRunArn": {},
					"filter": {
						"type": "structure",
						"required": [
							"agentHealths",
							"agentHealthCodes"
						],
						"members": {
							"agentHealths": {
								"type": "list",
								"member": {}
							},
							"agentHealthCodes": {
								"type": "list",
								"member": {}
							}
						}
					},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"assessmentRunAgents"
				],
				"members": {
					"assessmentRunAgents": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"agentId",
								"assessmentRunArn",
								"agentHealth",
								"agentHealthCode",
								"telemetryMetadata"
							],
							"members": {
								"agentId": {},
								"assessmentRunArn": {},
								"agentHealth": {},
								"agentHealthCode": {},
								"agentHealthDetails": {},
								"autoScalingGroup": {},
								"telemetryMetadata": {
									"shape": "S2q"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListAssessmentRuns": {
			"input": {
				"type": "structure",
				"members": {
					"assessmentTemplateArns": {
						"shape": "S36"
					},
					"filter": {
						"type": "structure",
						"members": {
							"namePattern": {},
							"states": {
								"type": "list",
								"member": {}
							},
							"durationRange": {
								"shape": "S3a"
							},
							"rulesPackageArns": {
								"shape": "S3b"
							},
							"startTimeRange": {
								"shape": "S3c"
							},
							"completionTimeRange": {
								"shape": "S3c"
							},
							"stateChangeTimeRange": {
								"shape": "S3c"
							}
						}
					},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"assessmentRunArns"
				],
				"members": {
					"assessmentRunArns": {
						"shape": "S3e"
					},
					"nextToken": {}
				}
			}
		},
		"ListAssessmentTargets": {
			"input": {
				"type": "structure",
				"members": {
					"filter": {
						"type": "structure",
						"members": {
							"assessmentTargetNamePattern": {}
						}
					},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"assessmentTargetArns"
				],
				"members": {
					"assessmentTargetArns": {
						"shape": "S3e"
					},
					"nextToken": {}
				}
			}
		},
		"ListAssessmentTemplates": {
			"input": {
				"type": "structure",
				"members": {
					"assessmentTargetArns": {
						"shape": "S36"
					},
					"filter": {
						"type": "structure",
						"members": {
							"namePattern": {},
							"durationRange": {
								"shape": "S3a"
							},
							"rulesPackageArns": {
								"shape": "S3b"
							}
						}
					},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"assessmentTemplateArns"
				],
				"members": {
					"assessmentTemplateArns": {
						"shape": "S3e"
					},
					"nextToken": {}
				}
			}
		},
		"ListEventSubscriptions": {
			"input": {
				"type": "structure",
				"members": {
					"resourceArn": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"subscriptions"
				],
				"members": {
					"subscriptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"resourceArn",
								"topicArn",
								"eventSubscriptions"
							],
							"members": {
								"resourceArn": {},
								"topicArn": {},
								"eventSubscriptions": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"event",
											"subscribedAt"
										],
										"members": {
											"event": {},
											"subscribedAt": {
												"type": "timestamp"
											}
										}
									}
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListFindings": {
			"input": {
				"type": "structure",
				"members": {
					"assessmentRunArns": {
						"shape": "S36"
					},
					"filter": {
						"type": "structure",
						"members": {
							"agentIds": {
								"type": "list",
								"member": {}
							},
							"autoScalingGroups": {
								"type": "list",
								"member": {}
							},
							"ruleNames": {
								"type": "list",
								"member": {}
							},
							"severities": {
								"type": "list",
								"member": {}
							},
							"rulesPackageArns": {
								"shape": "S3b"
							},
							"attributes": {
								"shape": "S26"
							},
							"userAttributes": {
								"shape": "S26"
							},
							"creationTimeRange": {
								"shape": "S3c"
							}
						}
					},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"findingArns"
				],
				"members": {
					"findingArns": {
						"shape": "S3e"
					},
					"nextToken": {}
				}
			}
		},
		"ListRulesPackages": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"rulesPackageArns"
				],
				"members": {
					"rulesPackageArns": {
						"shape": "S3e"
					},
					"nextToken": {}
				}
			}
		},
		"ListTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"resourceArn"
				],
				"members": {
					"resourceArn": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"tags"
				],
				"members": {
					"tags": {
						"shape": "S44"
					}
				}
			}
		},
		"PreviewAgents": {
			"input": {
				"type": "structure",
				"required": [
					"previewAgentsArn"
				],
				"members": {
					"previewAgentsArn": {},
					"nextToken": {},
					"maxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"agentPreviews"
				],
				"members": {
					"agentPreviews": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"agentId"
							],
							"members": {
								"agentId": {},
								"autoScalingGroup": {}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"RegisterCrossAccountAccessRole": {
			"input": {
				"type": "structure",
				"required": [
					"roleArn"
				],
				"members": {
					"roleArn": {}
				}
			}
		},
		"RemoveAttributesFromFindings": {
			"input": {
				"type": "structure",
				"required": [
					"findingArns",
					"attributeKeys"
				],
				"members": {
					"findingArns": {
						"shape": "S2"
					},
					"attributeKeys": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"failedItems"
				],
				"members": {
					"failedItems": {
						"shape": "S9"
					}
				}
			}
		},
		"SetTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"resourceArn"
				],
				"members": {
					"resourceArn": {},
					"tags": {
						"shape": "S44"
					}
				}
			}
		},
		"StartAssessmentRun": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentTemplateArn"
				],
				"members": {
					"assessmentTemplateArn": {},
					"assessmentRunName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"assessmentRunArn"
				],
				"members": {
					"assessmentRunArn": {}
				}
			}
		},
		"StopAssessmentRun": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentRunArn"
				],
				"members": {
					"assessmentRunArn": {},
					"stopAction": {}
				}
			}
		},
		"SubscribeToEvent": {
			"input": {
				"type": "structure",
				"required": [
					"resourceArn",
					"event",
					"topicArn"
				],
				"members": {
					"resourceArn": {},
					"event": {},
					"topicArn": {}
				}
			}
		},
		"UnsubscribeFromEvent": {
			"input": {
				"type": "structure",
				"required": [
					"resourceArn",
					"event",
					"topicArn"
				],
				"members": {
					"resourceArn": {},
					"event": {},
					"topicArn": {}
				}
			}
		},
		"UpdateAssessmentTarget": {
			"input": {
				"type": "structure",
				"required": [
					"assessmentTargetArn",
					"assessmentTargetName",
					"resourceGroupArn"
				],
				"members": {
					"assessmentTargetArn": {},
					"assessmentTargetName": {},
					"resourceGroupArn": {}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "list",
			"member": {}
		},
		"S4": {
			"type": "list",
			"member": {
				"shape": "S5"
			}
		},
		"S5": {
			"type": "structure",
			"required": [
				"key"
			],
			"members": {
				"key": {},
				"value": {}
			}
		},
		"S9": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"required": [
					"failureCode",
					"retryable"
				],
				"members": {
					"failureCode": {},
					"retryable": {
						"type": "boolean"
					}
				}
			}
		},
		"Sj": {
			"type": "list",
			"member": {}
		},
		"Sm": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"key"
				],
				"members": {
					"key": {},
					"value": {}
				}
			}
		},
		"Sv": {
			"type": "list",
			"member": {}
		},
		"S26": {
			"type": "list",
			"member": {
				"shape": "S5"
			}
		},
		"S2q": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"messageType",
					"count"
				],
				"members": {
					"messageType": {},
					"count": {
						"type": "long"
					},
					"dataSize": {
						"type": "long"
					}
				}
			}
		},
		"S36": {
			"type": "list",
			"member": {}
		},
		"S3a": {
			"type": "structure",
			"members": {
				"minSeconds": {
					"type": "integer"
				},
				"maxSeconds": {
					"type": "integer"
				}
			}
		},
		"S3b": {
			"type": "list",
			"member": {}
		},
		"S3c": {
			"type": "structure",
			"members": {
				"beginDate": {
					"type": "timestamp"
				},
				"endDate": {
					"type": "timestamp"
				}
			}
		},
		"S3e": {
			"type": "list",
			"member": {}
		},
		"S44": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"key"
				],
				"members": {
					"key": {},
					"value": {}
				}
			}
		}
	}
};

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListAssessmentRunAgents": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListAssessmentRuns": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListAssessmentTargets": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListAssessmentTemplates": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListEventSubscriptions": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListFindings": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"ListRulesPackages": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		},
		"PreviewAgents": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"limit_key": "maxResults"
		}
	}
};

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['iot'] = {};
AWS.Iot = Service.defineService('iot', ['2015-05-28']);
Object.defineProperty(apiLoader.services['iot'], '2015-05-28', {
  get: function get() {
    var model = __webpack_require__(1635);
    model.paginators = __webpack_require__(1636).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Iot;


/***/ }),
/* 1635 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-05-28",
		"endpointPrefix": "iot",
		"protocol": "rest-json",
		"serviceFullName": "AWS IoT",
		"signatureVersion": "v4",
		"signingName": "execute-api",
		"uid": "iot-2015-05-28"
	},
	"operations": {
		"AcceptCertificateTransfer": {
			"http": {
				"method": "PATCH",
				"requestUri": "/accept-certificate-transfer/{certificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateId"
				],
				"members": {
					"certificateId": {
						"location": "uri",
						"locationName": "certificateId"
					},
					"setAsActive": {
						"location": "querystring",
						"locationName": "setAsActive",
						"type": "boolean"
					}
				}
			}
		},
		"AttachPrincipalPolicy": {
			"http": {
				"method": "PUT",
				"requestUri": "/principal-policies/{policyName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName",
					"principal"
				],
				"members": {
					"policyName": {
						"location": "uri",
						"locationName": "policyName"
					},
					"principal": {
						"location": "header",
						"locationName": "x-amzn-iot-principal"
					}
				}
			}
		},
		"AttachThingPrincipal": {
			"http": {
				"method": "PUT",
				"requestUri": "/things/{thingName}/principals"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName",
					"principal"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					},
					"principal": {
						"location": "header",
						"locationName": "x-amzn-principal"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CancelCertificateTransfer": {
			"http": {
				"method": "PATCH",
				"requestUri": "/cancel-certificate-transfer/{certificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateId"
				],
				"members": {
					"certificateId": {
						"location": "uri",
						"locationName": "certificateId"
					}
				}
			}
		},
		"CreateCertificateFromCsr": {
			"http": {
				"requestUri": "/certificates"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateSigningRequest"
				],
				"members": {
					"certificateSigningRequest": {},
					"setAsActive": {
						"location": "querystring",
						"locationName": "setAsActive",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"certificateArn": {},
					"certificateId": {},
					"certificatePem": {}
				}
			}
		},
		"CreateKeysAndCertificate": {
			"http": {
				"requestUri": "/keys-and-certificate"
			},
			"input": {
				"type": "structure",
				"members": {
					"setAsActive": {
						"location": "querystring",
						"locationName": "setAsActive",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"certificateArn": {},
					"certificateId": {},
					"certificatePem": {},
					"keyPair": {
						"type": "structure",
						"members": {
							"PublicKey": {},
							"PrivateKey": {
								"type": "string",
								"sensitive": true
							}
						}
					}
				}
			}
		},
		"CreatePolicy": {
			"http": {
				"requestUri": "/policies/{policyName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName",
					"policyDocument"
				],
				"members": {
					"policyName": {
						"location": "uri",
						"locationName": "policyName"
					},
					"policyDocument": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"policyName": {},
					"policyArn": {},
					"policyDocument": {},
					"policyVersionId": {}
				}
			}
		},
		"CreatePolicyVersion": {
			"http": {
				"requestUri": "/policies/{policyName}/version"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName",
					"policyDocument"
				],
				"members": {
					"policyName": {
						"location": "uri",
						"locationName": "policyName"
					},
					"policyDocument": {},
					"setAsDefault": {
						"location": "querystring",
						"locationName": "setAsDefault",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"policyArn": {},
					"policyDocument": {},
					"policyVersionId": {},
					"isDefaultVersion": {
						"type": "boolean"
					}
				}
			}
		},
		"CreateThing": {
			"http": {
				"requestUri": "/things/{thingName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					},
					"thingTypeName": {},
					"attributePayload": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"thingName": {},
					"thingArn": {}
				}
			}
		},
		"CreateThingType": {
			"http": {
				"requestUri": "/thing-types/{thingTypeName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingTypeName"
				],
				"members": {
					"thingTypeName": {
						"location": "uri",
						"locationName": "thingTypeName"
					},
					"thingTypeProperties": {
						"shape": "S14"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"thingTypeName": {},
					"thingTypeArn": {}
				}
			}
		},
		"CreateTopicRule": {
			"http": {
				"requestUri": "/rules/{ruleName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"ruleName",
					"topicRulePayload"
				],
				"members": {
					"ruleName": {
						"location": "uri",
						"locationName": "ruleName"
					},
					"topicRulePayload": {
						"shape": "S1b"
					}
				},
				"payload": "topicRulePayload"
			}
		},
		"DeleteCACertificate": {
			"http": {
				"method": "DELETE",
				"requestUri": "/cacertificate/{caCertificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateId"
				],
				"members": {
					"certificateId": {
						"location": "uri",
						"locationName": "caCertificateId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteCertificate": {
			"http": {
				"method": "DELETE",
				"requestUri": "/certificates/{certificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateId"
				],
				"members": {
					"certificateId": {
						"location": "uri",
						"locationName": "certificateId"
					}
				}
			}
		},
		"DeletePolicy": {
			"http": {
				"method": "DELETE",
				"requestUri": "/policies/{policyName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName"
				],
				"members": {
					"policyName": {
						"location": "uri",
						"locationName": "policyName"
					}
				}
			}
		},
		"DeletePolicyVersion": {
			"http": {
				"method": "DELETE",
				"requestUri": "/policies/{policyName}/version/{policyVersionId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName",
					"policyVersionId"
				],
				"members": {
					"policyName": {
						"location": "uri",
						"locationName": "policyName"
					},
					"policyVersionId": {
						"location": "uri",
						"locationName": "policyVersionId"
					}
				}
			}
		},
		"DeleteRegistrationCode": {
			"http": {
				"method": "DELETE",
				"requestUri": "/registrationcode"
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteThing": {
			"http": {
				"method": "DELETE",
				"requestUri": "/things/{thingName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					},
					"expectedVersion": {
						"location": "querystring",
						"locationName": "expectedVersion",
						"type": "long"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteThingType": {
			"http": {
				"method": "DELETE",
				"requestUri": "/thing-types/{thingTypeName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingTypeName"
				],
				"members": {
					"thingTypeName": {
						"location": "uri",
						"locationName": "thingTypeName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteTopicRule": {
			"http": {
				"method": "DELETE",
				"requestUri": "/rules/{ruleName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"ruleName"
				],
				"members": {
					"ruleName": {
						"location": "uri",
						"locationName": "ruleName"
					}
				}
			}
		},
		"DeprecateThingType": {
			"http": {
				"requestUri": "/thing-types/{thingTypeName}/deprecate"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingTypeName"
				],
				"members": {
					"thingTypeName": {
						"location": "uri",
						"locationName": "thingTypeName"
					},
					"undoDeprecate": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeCACertificate": {
			"http": {
				"method": "GET",
				"requestUri": "/cacertificate/{caCertificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateId"
				],
				"members": {
					"certificateId": {
						"location": "uri",
						"locationName": "caCertificateId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"certificateDescription": {
						"type": "structure",
						"members": {
							"certificateArn": {},
							"certificateId": {},
							"status": {},
							"certificatePem": {},
							"ownedBy": {},
							"creationDate": {
								"type": "timestamp"
							},
							"autoRegistrationStatus": {}
						}
					}
				}
			}
		},
		"DescribeCertificate": {
			"http": {
				"method": "GET",
				"requestUri": "/certificates/{certificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateId"
				],
				"members": {
					"certificateId": {
						"location": "uri",
						"locationName": "certificateId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"certificateDescription": {
						"type": "structure",
						"members": {
							"certificateArn": {},
							"certificateId": {},
							"caCertificateId": {},
							"status": {},
							"certificatePem": {},
							"ownedBy": {},
							"previousOwnedBy": {},
							"creationDate": {
								"type": "timestamp"
							},
							"lastModifiedDate": {
								"type": "timestamp"
							},
							"transferData": {
								"type": "structure",
								"members": {
									"transferMessage": {},
									"rejectReason": {},
									"transferDate": {
										"type": "timestamp"
									},
									"acceptDate": {
										"type": "timestamp"
									},
									"rejectDate": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeEndpoint": {
			"http": {
				"method": "GET",
				"requestUri": "/endpoint"
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"endpointAddress": {}
				}
			}
		},
		"DescribeThing": {
			"http": {
				"method": "GET",
				"requestUri": "/things/{thingName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"defaultClientId": {},
					"thingName": {},
					"thingTypeName": {},
					"attributes": {
						"shape": "Sx"
					},
					"version": {
						"type": "long"
					}
				}
			}
		},
		"DescribeThingType": {
			"http": {
				"method": "GET",
				"requestUri": "/thing-types/{thingTypeName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingTypeName"
				],
				"members": {
					"thingTypeName": {
						"location": "uri",
						"locationName": "thingTypeName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"thingTypeName": {},
					"thingTypeProperties": {
						"shape": "S14"
					},
					"thingTypeMetadata": {
						"shape": "S3x"
					}
				}
			}
		},
		"DetachPrincipalPolicy": {
			"http": {
				"method": "DELETE",
				"requestUri": "/principal-policies/{policyName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName",
					"principal"
				],
				"members": {
					"policyName": {
						"location": "uri",
						"locationName": "policyName"
					},
					"principal": {
						"location": "header",
						"locationName": "x-amzn-iot-principal"
					}
				}
			}
		},
		"DetachThingPrincipal": {
			"http": {
				"method": "DELETE",
				"requestUri": "/things/{thingName}/principals"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName",
					"principal"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					},
					"principal": {
						"location": "header",
						"locationName": "x-amzn-principal"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DisableTopicRule": {
			"http": {
				"requestUri": "/rules/{ruleName}/disable"
			},
			"input": {
				"type": "structure",
				"required": [
					"ruleName"
				],
				"members": {
					"ruleName": {
						"location": "uri",
						"locationName": "ruleName"
					}
				}
			}
		},
		"EnableTopicRule": {
			"http": {
				"requestUri": "/rules/{ruleName}/enable"
			},
			"input": {
				"type": "structure",
				"required": [
					"ruleName"
				],
				"members": {
					"ruleName": {
						"location": "uri",
						"locationName": "ruleName"
					}
				}
			}
		},
		"GetLoggingOptions": {
			"http": {
				"method": "GET",
				"requestUri": "/loggingOptions"
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"roleArn": {},
					"logLevel": {}
				}
			}
		},
		"GetPolicy": {
			"http": {
				"method": "GET",
				"requestUri": "/policies/{policyName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName"
				],
				"members": {
					"policyName": {
						"location": "uri",
						"locationName": "policyName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"policyName": {},
					"policyArn": {},
					"policyDocument": {},
					"defaultVersionId": {}
				}
			}
		},
		"GetPolicyVersion": {
			"http": {
				"method": "GET",
				"requestUri": "/policies/{policyName}/version/{policyVersionId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName",
					"policyVersionId"
				],
				"members": {
					"policyName": {
						"location": "uri",
						"locationName": "policyName"
					},
					"policyVersionId": {
						"location": "uri",
						"locationName": "policyVersionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"policyArn": {},
					"policyName": {},
					"policyDocument": {},
					"policyVersionId": {},
					"isDefaultVersion": {
						"type": "boolean"
					}
				}
			}
		},
		"GetRegistrationCode": {
			"http": {
				"method": "GET",
				"requestUri": "/registrationcode"
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"registrationCode": {}
				}
			}
		},
		"GetTopicRule": {
			"http": {
				"method": "GET",
				"requestUri": "/rules/{ruleName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"ruleName"
				],
				"members": {
					"ruleName": {
						"location": "uri",
						"locationName": "ruleName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ruleArn": {},
					"rule": {
						"type": "structure",
						"members": {
							"ruleName": {},
							"sql": {},
							"description": {},
							"createdAt": {
								"type": "timestamp"
							},
							"actions": {
								"shape": "S1e"
							},
							"ruleDisabled": {
								"type": "boolean"
							},
							"awsIotSqlVersion": {}
						}
					}
				}
			}
		},
		"ListCACertificates": {
			"http": {
				"method": "GET",
				"requestUri": "/cacertificates"
			},
			"input": {
				"type": "structure",
				"members": {
					"pageSize": {
						"location": "querystring",
						"locationName": "pageSize",
						"type": "integer"
					},
					"marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"ascendingOrder": {
						"location": "querystring",
						"locationName": "isAscendingOrder",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"certificates": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"certificateArn": {},
								"certificateId": {},
								"status": {},
								"creationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"nextMarker": {}
				}
			}
		},
		"ListCertificates": {
			"http": {
				"method": "GET",
				"requestUri": "/certificates"
			},
			"input": {
				"type": "structure",
				"members": {
					"pageSize": {
						"location": "querystring",
						"locationName": "pageSize",
						"type": "integer"
					},
					"marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"ascendingOrder": {
						"location": "querystring",
						"locationName": "isAscendingOrder",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"certificates": {
						"shape": "S4u"
					},
					"nextMarker": {}
				}
			}
		},
		"ListCertificatesByCA": {
			"http": {
				"method": "GET",
				"requestUri": "/certificates-by-ca/{caCertificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"caCertificateId"
				],
				"members": {
					"caCertificateId": {
						"location": "uri",
						"locationName": "caCertificateId"
					},
					"pageSize": {
						"location": "querystring",
						"locationName": "pageSize",
						"type": "integer"
					},
					"marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"ascendingOrder": {
						"location": "querystring",
						"locationName": "isAscendingOrder",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"certificates": {
						"shape": "S4u"
					},
					"nextMarker": {}
				}
			}
		},
		"ListOutgoingCertificates": {
			"http": {
				"method": "GET",
				"requestUri": "/certificates-out-going"
			},
			"input": {
				"type": "structure",
				"members": {
					"pageSize": {
						"location": "querystring",
						"locationName": "pageSize",
						"type": "integer"
					},
					"marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"ascendingOrder": {
						"location": "querystring",
						"locationName": "isAscendingOrder",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"outgoingCertificates": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"certificateArn": {},
								"certificateId": {},
								"transferredTo": {},
								"transferDate": {
									"type": "timestamp"
								},
								"transferMessage": {},
								"creationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"nextMarker": {}
				}
			}
		},
		"ListPolicies": {
			"http": {
				"method": "GET",
				"requestUri": "/policies"
			},
			"input": {
				"type": "structure",
				"members": {
					"marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"pageSize": {
						"location": "querystring",
						"locationName": "pageSize",
						"type": "integer"
					},
					"ascendingOrder": {
						"location": "querystring",
						"locationName": "isAscendingOrder",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"policies": {
						"shape": "S54"
					},
					"nextMarker": {}
				}
			}
		},
		"ListPolicyPrincipals": {
			"http": {
				"method": "GET",
				"requestUri": "/policy-principals"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName"
				],
				"members": {
					"policyName": {
						"location": "header",
						"locationName": "x-amzn-iot-policy"
					},
					"marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"pageSize": {
						"location": "querystring",
						"locationName": "pageSize",
						"type": "integer"
					},
					"ascendingOrder": {
						"location": "querystring",
						"locationName": "isAscendingOrder",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"principals": {
						"shape": "S58"
					},
					"nextMarker": {}
				}
			}
		},
		"ListPolicyVersions": {
			"http": {
				"method": "GET",
				"requestUri": "/policies/{policyName}/version"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName"
				],
				"members": {
					"policyName": {
						"location": "uri",
						"locationName": "policyName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"policyVersions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"versionId": {},
								"isDefaultVersion": {
									"type": "boolean"
								},
								"createDate": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"ListPrincipalPolicies": {
			"http": {
				"method": "GET",
				"requestUri": "/principal-policies"
			},
			"input": {
				"type": "structure",
				"required": [
					"principal"
				],
				"members": {
					"principal": {
						"location": "header",
						"locationName": "x-amzn-iot-principal"
					},
					"marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"pageSize": {
						"location": "querystring",
						"locationName": "pageSize",
						"type": "integer"
					},
					"ascendingOrder": {
						"location": "querystring",
						"locationName": "isAscendingOrder",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"policies": {
						"shape": "S54"
					},
					"nextMarker": {}
				}
			}
		},
		"ListPrincipalThings": {
			"http": {
				"method": "GET",
				"requestUri": "/principals/things"
			},
			"input": {
				"type": "structure",
				"required": [
					"principal"
				],
				"members": {
					"nextToken": {
						"location": "querystring",
						"locationName": "nextToken"
					},
					"maxResults": {
						"location": "querystring",
						"locationName": "maxResults",
						"type": "integer"
					},
					"principal": {
						"location": "header",
						"locationName": "x-amzn-principal"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"things": {
						"type": "list",
						"member": {}
					},
					"nextToken": {}
				}
			}
		},
		"ListThingPrincipals": {
			"http": {
				"method": "GET",
				"requestUri": "/things/{thingName}/principals"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"principals": {
						"shape": "S58"
					}
				}
			}
		},
		"ListThingTypes": {
			"http": {
				"method": "GET",
				"requestUri": "/thing-types"
			},
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {
						"location": "querystring",
						"locationName": "nextToken"
					},
					"maxResults": {
						"location": "querystring",
						"locationName": "maxResults",
						"type": "integer"
					},
					"thingTypeName": {
						"location": "querystring",
						"locationName": "thingTypeName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"thingTypes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"thingTypeName": {},
								"thingTypeProperties": {
									"shape": "S14"
								},
								"thingTypeMetadata": {
									"shape": "S3x"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListThings": {
			"http": {
				"method": "GET",
				"requestUri": "/things"
			},
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {
						"location": "querystring",
						"locationName": "nextToken"
					},
					"maxResults": {
						"location": "querystring",
						"locationName": "maxResults",
						"type": "integer"
					},
					"attributeName": {
						"location": "querystring",
						"locationName": "attributeName"
					},
					"attributeValue": {
						"location": "querystring",
						"locationName": "attributeValue"
					},
					"thingTypeName": {
						"location": "querystring",
						"locationName": "thingTypeName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"things": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"thingName": {},
								"thingTypeName": {},
								"attributes": {
									"shape": "Sx"
								},
								"version": {
									"type": "long"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"ListTopicRules": {
			"http": {
				"method": "GET",
				"requestUri": "/rules"
			},
			"input": {
				"type": "structure",
				"members": {
					"topic": {
						"location": "querystring",
						"locationName": "topic"
					},
					"maxResults": {
						"location": "querystring",
						"locationName": "maxResults",
						"type": "integer"
					},
					"nextToken": {
						"location": "querystring",
						"locationName": "nextToken"
					},
					"ruleDisabled": {
						"location": "querystring",
						"locationName": "ruleDisabled",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"rules": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ruleArn": {},
								"ruleName": {},
								"topicPattern": {},
								"createdAt": {
									"type": "timestamp"
								},
								"ruleDisabled": {
									"type": "boolean"
								}
							}
						}
					},
					"nextToken": {}
				}
			}
		},
		"RegisterCACertificate": {
			"http": {
				"requestUri": "/cacertificate"
			},
			"input": {
				"type": "structure",
				"required": [
					"caCertificate",
					"verificationCertificate"
				],
				"members": {
					"caCertificate": {},
					"verificationCertificate": {},
					"setAsActive": {
						"location": "querystring",
						"locationName": "setAsActive",
						"type": "boolean"
					},
					"allowAutoRegistration": {
						"location": "querystring",
						"locationName": "allowAutoRegistration",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"certificateArn": {},
					"certificateId": {}
				}
			}
		},
		"RegisterCertificate": {
			"http": {
				"requestUri": "/certificate/register"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificatePem"
				],
				"members": {
					"certificatePem": {},
					"caCertificatePem": {},
					"setAsActive": {
						"deprecated": true,
						"location": "querystring",
						"locationName": "setAsActive",
						"type": "boolean"
					},
					"status": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"certificateArn": {},
					"certificateId": {}
				}
			}
		},
		"RejectCertificateTransfer": {
			"http": {
				"method": "PATCH",
				"requestUri": "/reject-certificate-transfer/{certificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateId"
				],
				"members": {
					"certificateId": {
						"location": "uri",
						"locationName": "certificateId"
					},
					"rejectReason": {}
				}
			}
		},
		"ReplaceTopicRule": {
			"http": {
				"method": "PATCH",
				"requestUri": "/rules/{ruleName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"ruleName",
					"topicRulePayload"
				],
				"members": {
					"ruleName": {
						"location": "uri",
						"locationName": "ruleName"
					},
					"topicRulePayload": {
						"shape": "S1b"
					}
				},
				"payload": "topicRulePayload"
			}
		},
		"SetDefaultPolicyVersion": {
			"http": {
				"method": "PATCH",
				"requestUri": "/policies/{policyName}/version/{policyVersionId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"policyName",
					"policyVersionId"
				],
				"members": {
					"policyName": {
						"location": "uri",
						"locationName": "policyName"
					},
					"policyVersionId": {
						"location": "uri",
						"locationName": "policyVersionId"
					}
				}
			}
		},
		"SetLoggingOptions": {
			"http": {
				"requestUri": "/loggingOptions"
			},
			"input": {
				"type": "structure",
				"required": [
					"loggingOptionsPayload"
				],
				"members": {
					"loggingOptionsPayload": {
						"type": "structure",
						"required": [
							"roleArn"
						],
						"members": {
							"roleArn": {},
							"logLevel": {}
						}
					}
				},
				"payload": "loggingOptionsPayload"
			}
		},
		"TransferCertificate": {
			"http": {
				"method": "PATCH",
				"requestUri": "/transfer-certificate/{certificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateId",
					"targetAwsAccount"
				],
				"members": {
					"certificateId": {
						"location": "uri",
						"locationName": "certificateId"
					},
					"targetAwsAccount": {
						"location": "querystring",
						"locationName": "targetAwsAccount"
					},
					"transferMessage": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"transferredCertificateArn": {}
				}
			}
		},
		"UpdateCACertificate": {
			"http": {
				"method": "PUT",
				"requestUri": "/cacertificate/{caCertificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateId"
				],
				"members": {
					"certificateId": {
						"location": "uri",
						"locationName": "caCertificateId"
					},
					"newStatus": {
						"location": "querystring",
						"locationName": "newStatus"
					},
					"newAutoRegistrationStatus": {
						"location": "querystring",
						"locationName": "newAutoRegistrationStatus"
					}
				}
			}
		},
		"UpdateCertificate": {
			"http": {
				"method": "PUT",
				"requestUri": "/certificates/{certificateId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"certificateId",
					"newStatus"
				],
				"members": {
					"certificateId": {
						"location": "uri",
						"locationName": "certificateId"
					},
					"newStatus": {
						"location": "querystring",
						"locationName": "newStatus"
					}
				}
			}
		},
		"UpdateThing": {
			"http": {
				"method": "PATCH",
				"requestUri": "/things/{thingName}"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					},
					"thingTypeName": {},
					"attributePayload": {
						"shape": "Sw"
					},
					"expectedVersion": {
						"type": "long"
					},
					"removeThingType": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		}
	},
	"shapes": {
		"Sw": {
			"type": "structure",
			"members": {
				"attributes": {
					"shape": "Sx"
				},
				"merge": {
					"type": "boolean"
				}
			}
		},
		"Sx": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S14": {
			"type": "structure",
			"members": {
				"thingTypeDescription": {},
				"searchableAttributes": {
					"type": "list",
					"member": {}
				}
			}
		},
		"S1b": {
			"type": "structure",
			"required": [
				"sql",
				"actions"
			],
			"members": {
				"sql": {},
				"description": {},
				"actions": {
					"shape": "S1e"
				},
				"ruleDisabled": {
					"type": "boolean"
				},
				"awsIotSqlVersion": {}
			}
		},
		"S1e": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"dynamoDB": {
						"type": "structure",
						"required": [
							"tableName",
							"roleArn",
							"hashKeyField",
							"hashKeyValue"
						],
						"members": {
							"tableName": {},
							"roleArn": {},
							"operation": {},
							"hashKeyField": {},
							"hashKeyValue": {},
							"hashKeyType": {},
							"rangeKeyField": {},
							"rangeKeyValue": {},
							"rangeKeyType": {},
							"payloadField": {}
						}
					},
					"dynamoDBv2": {
						"type": "structure",
						"members": {
							"roleArn": {},
							"putItem": {
								"type": "structure",
								"required": [
									"tableName"
								],
								"members": {
									"tableName": {}
								}
							}
						}
					},
					"lambda": {
						"type": "structure",
						"required": [
							"functionArn"
						],
						"members": {
							"functionArn": {}
						}
					},
					"sns": {
						"type": "structure",
						"required": [
							"targetArn",
							"roleArn"
						],
						"members": {
							"targetArn": {},
							"roleArn": {},
							"messageFormat": {}
						}
					},
					"sqs": {
						"type": "structure",
						"required": [
							"roleArn",
							"queueUrl"
						],
						"members": {
							"roleArn": {},
							"queueUrl": {},
							"useBase64": {
								"type": "boolean"
							}
						}
					},
					"kinesis": {
						"type": "structure",
						"required": [
							"roleArn",
							"streamName"
						],
						"members": {
							"roleArn": {},
							"streamName": {},
							"partitionKey": {}
						}
					},
					"republish": {
						"type": "structure",
						"required": [
							"roleArn",
							"topic"
						],
						"members": {
							"roleArn": {},
							"topic": {}
						}
					},
					"s3": {
						"type": "structure",
						"required": [
							"roleArn",
							"bucketName",
							"key"
						],
						"members": {
							"roleArn": {},
							"bucketName": {},
							"key": {},
							"cannedAcl": {}
						}
					},
					"firehose": {
						"type": "structure",
						"required": [
							"roleArn",
							"deliveryStreamName"
						],
						"members": {
							"roleArn": {},
							"deliveryStreamName": {},
							"separator": {}
						}
					},
					"cloudwatchMetric": {
						"type": "structure",
						"required": [
							"roleArn",
							"metricNamespace",
							"metricName",
							"metricValue",
							"metricUnit"
						],
						"members": {
							"roleArn": {},
							"metricNamespace": {},
							"metricName": {},
							"metricValue": {},
							"metricUnit": {},
							"metricTimestamp": {}
						}
					},
					"cloudwatchAlarm": {
						"type": "structure",
						"required": [
							"roleArn",
							"alarmName",
							"stateReason",
							"stateValue"
						],
						"members": {
							"roleArn": {},
							"alarmName": {},
							"stateReason": {},
							"stateValue": {}
						}
					},
					"elasticsearch": {
						"type": "structure",
						"required": [
							"roleArn",
							"endpoint",
							"index",
							"type",
							"id"
						],
						"members": {
							"roleArn": {},
							"endpoint": {},
							"index": {},
							"type": {},
							"id": {}
						}
					},
					"salesforce": {
						"type": "structure",
						"required": [
							"token",
							"url"
						],
						"members": {
							"token": {},
							"url": {}
						}
					}
				}
			}
		},
		"S3x": {
			"type": "structure",
			"members": {
				"deprecated": {
					"type": "boolean"
				},
				"deprecationDate": {
					"type": "timestamp"
				},
				"creationDate": {
					"type": "timestamp"
				}
			}
		},
		"S4u": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"certificateArn": {},
					"certificateId": {},
					"status": {},
					"creationDate": {
						"type": "timestamp"
					}
				}
			}
		},
		"S54": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"policyName": {},
					"policyArn": {}
				}
			}
		},
		"S58": {
			"type": "list",
			"member": {}
		}
	}
};

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['iotdata'] = {};
AWS.IotData = Service.defineService('iotdata', ['2015-05-28']);
__webpack_require__(1638);
Object.defineProperty(apiLoader.services['iotdata'], '2015-05-28', {
  get: function get() {
    var model = __webpack_require__(1639);
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.IotData;


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

/**
 * @api private
 */
var blobPayloadOutputOps = [
  'deleteThingShadow',
  'getThingShadow',
  'updateThingShadow'
];

/**
 * Constructs a service interface object. Each API operation is exposed as a
 * function on service.
 *
 * ### Sending a Request Using IotData
 *
 * ```javascript
 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 * iotdata.getThingShadow(params, function (err, data) {
 *   if (err) console.log(err, err.stack); // an error occurred
 *   else     console.log(data);           // successful response
 * });
 * ```
 *
 * ### Locking the API Version
 *
 * In order to ensure that the IotData object uses this specific API,
 * you can construct the object by passing the `apiVersion` option to the
 * constructor:
 *
 * ```javascript
 * var iotdata = new AWS.IotData({
 *   endpoint: 'my.host.tld',
 *   apiVersion: '2015-05-28'
 * });
 * ```
 *
 * You can also set the API version globally in `AWS.config.apiVersions` using
 * the **iotdata** service identifier:
 *
 * ```javascript
 * AWS.config.apiVersions = {
 *   iotdata: '2015-05-28',
 *   // other service API versions
 * };
 *
 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 * ```
 *
 * @note You *must* provide an `endpoint` configuration parameter when
 *   constructing this service. See {constructor} for more information.
 *
 * @!method constructor(options = {})
 *   Constructs a service object. This object has one method for each
 *   API operation.
 *
 *   @example Constructing a IotData object
 *     var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 *   @note You *must* provide an `endpoint` when constructing this service.
 *   @option (see AWS.Config.constructor)
 *
 * @service iotdata
 * @version 2015-05-28
 */
AWS.util.update(AWS.IotData.prototype, {
    /**
     * @api private
     */
    validateService: function validateService() {
        if (!this.config.endpoint || this.config.endpoint.indexOf('{') >= 0) {
            var msg = 'AWS.IotData requires an explicit ' +
                '`endpoint\' configuration option.';
            throw AWS.util.error(new Error(),
                {name: 'InvalidEndpoint', message: msg});
        }
    },

    /**
     * @api private
     */
    setupRequestListeners: function setupRequestListeners(request) {
        request.addListener('validateResponse', this.validateResponseBody);
        if (blobPayloadOutputOps.indexOf(request.operation) > -1) {
            request.addListener('extractData', AWS.util.convertPayloadToString);
        }
    },

    /**
     * @api private
     */
    validateResponseBody: function validateResponseBody(resp) {
        var body = resp.httpResponse.body.toString() || '{}';
        var bodyCheck = body.trim();
        if (!bodyCheck || bodyCheck.charAt(0) !== '{') {
            resp.httpResponse.body = '';
        }
    }

});


/***/ }),
/* 1639 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"uid": "iot-data-2015-05-28",
		"apiVersion": "2015-05-28",
		"endpointPrefix": "data.iot",
		"protocol": "rest-json",
		"serviceFullName": "AWS IoT Data Plane",
		"signatureVersion": "v4",
		"signingName": "iotdata"
	},
	"operations": {
		"DeleteThingShadow": {
			"http": {
				"method": "DELETE",
				"requestUri": "/things/{thingName}/shadow"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"payload"
				],
				"members": {
					"payload": {
						"type": "blob"
					}
				},
				"payload": "payload"
			}
		},
		"GetThingShadow": {
			"http": {
				"method": "GET",
				"requestUri": "/things/{thingName}/shadow"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"payload": {
						"type": "blob"
					}
				},
				"payload": "payload"
			}
		},
		"Publish": {
			"http": {
				"requestUri": "/topics/{topic}"
			},
			"input": {
				"type": "structure",
				"required": [
					"topic"
				],
				"members": {
					"topic": {
						"location": "uri",
						"locationName": "topic"
					},
					"qos": {
						"location": "querystring",
						"locationName": "qos",
						"type": "integer"
					},
					"payload": {
						"type": "blob"
					}
				},
				"payload": "payload"
			}
		},
		"UpdateThingShadow": {
			"http": {
				"requestUri": "/things/{thingName}/shadow"
			},
			"input": {
				"type": "structure",
				"required": [
					"thingName",
					"payload"
				],
				"members": {
					"thingName": {
						"location": "uri",
						"locationName": "thingName"
					},
					"payload": {
						"type": "blob"
					}
				},
				"payload": "payload"
			},
			"output": {
				"type": "structure",
				"members": {
					"payload": {
						"type": "blob"
					}
				},
				"payload": "payload"
			}
		}
	},
	"shapes": {}
};

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['kinesis'] = {};
AWS.Kinesis = Service.defineService('kinesis', ['2013-12-02']);
Object.defineProperty(apiLoader.services['kinesis'], '2013-12-02', {
  get: function get() {
    var model = __webpack_require__(1641);
    model.paginators = __webpack_require__(1642).pagination;
    model.waiters = __webpack_require__(1643).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Kinesis;


/***/ }),
/* 1641 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2013-12-02",
		"endpointPrefix": "kinesis",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Kinesis",
		"serviceFullName": "Amazon Kinesis",
		"signatureVersion": "v4",
		"targetPrefix": "Kinesis_20131202",
		"uid": "kinesis-2013-12-02"
	},
	"operations": {
		"AddTagsToStream": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"Tags"
				],
				"members": {
					"StreamName": {},
					"Tags": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			}
		},
		"CreateStream": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"ShardCount"
				],
				"members": {
					"StreamName": {},
					"ShardCount": {
						"type": "integer"
					}
				}
			}
		},
		"DecreaseStreamRetentionPeriod": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"RetentionPeriodHours"
				],
				"members": {
					"StreamName": {},
					"RetentionPeriodHours": {
						"type": "integer"
					}
				}
			}
		},
		"DeleteStream": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName"
				],
				"members": {
					"StreamName": {}
				}
			}
		},
		"DescribeLimits": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"required": [
					"ShardLimit",
					"OpenShardCount"
				],
				"members": {
					"ShardLimit": {
						"type": "integer"
					},
					"OpenShardCount": {
						"type": "integer"
					}
				}
			}
		},
		"DescribeStream": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName"
				],
				"members": {
					"StreamName": {},
					"Limit": {
						"type": "integer"
					},
					"ExclusiveStartShardId": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"StreamDescription"
				],
				"members": {
					"StreamDescription": {
						"type": "structure",
						"required": [
							"StreamName",
							"StreamARN",
							"StreamStatus",
							"Shards",
							"HasMoreShards",
							"RetentionPeriodHours",
							"StreamCreationTimestamp",
							"EnhancedMonitoring"
						],
						"members": {
							"StreamName": {},
							"StreamARN": {},
							"StreamStatus": {},
							"Shards": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"ShardId",
										"HashKeyRange",
										"SequenceNumberRange"
									],
									"members": {
										"ShardId": {},
										"ParentShardId": {},
										"AdjacentParentShardId": {},
										"HashKeyRange": {
											"type": "structure",
											"required": [
												"StartingHashKey",
												"EndingHashKey"
											],
											"members": {
												"StartingHashKey": {},
												"EndingHashKey": {}
											}
										},
										"SequenceNumberRange": {
											"type": "structure",
											"required": [
												"StartingSequenceNumber"
											],
											"members": {
												"StartingSequenceNumber": {},
												"EndingSequenceNumber": {}
											}
										}
									}
								}
							},
							"HasMoreShards": {
								"type": "boolean"
							},
							"RetentionPeriodHours": {
								"type": "integer"
							},
							"StreamCreationTimestamp": {
								"type": "timestamp"
							},
							"EnhancedMonitoring": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"ShardLevelMetrics": {
											"shape": "Su"
										}
									}
								}
							},
							"EncryptionType": {},
							"KeyId": {}
						}
					}
				}
			}
		},
		"DisableEnhancedMonitoring": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"ShardLevelMetrics"
				],
				"members": {
					"StreamName": {},
					"ShardLevelMetrics": {
						"shape": "Su"
					}
				}
			},
			"output": {
				"shape": "Sz"
			}
		},
		"EnableEnhancedMonitoring": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"ShardLevelMetrics"
				],
				"members": {
					"StreamName": {},
					"ShardLevelMetrics": {
						"shape": "Su"
					}
				}
			},
			"output": {
				"shape": "Sz"
			}
		},
		"GetRecords": {
			"input": {
				"type": "structure",
				"required": [
					"ShardIterator"
				],
				"members": {
					"ShardIterator": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Records"
				],
				"members": {
					"Records": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"SequenceNumber",
								"Data",
								"PartitionKey"
							],
							"members": {
								"SequenceNumber": {},
								"ApproximateArrivalTimestamp": {
									"type": "timestamp"
								},
								"Data": {
									"type": "blob"
								},
								"PartitionKey": {},
								"EncryptionType": {}
							}
						}
					},
					"NextShardIterator": {},
					"MillisBehindLatest": {
						"type": "long"
					}
				}
			}
		},
		"GetShardIterator": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"ShardId",
					"ShardIteratorType"
				],
				"members": {
					"StreamName": {},
					"ShardId": {},
					"ShardIteratorType": {},
					"StartingSequenceNumber": {},
					"Timestamp": {
						"type": "timestamp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ShardIterator": {}
				}
			}
		},
		"IncreaseStreamRetentionPeriod": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"RetentionPeriodHours"
				],
				"members": {
					"StreamName": {},
					"RetentionPeriodHours": {
						"type": "integer"
					}
				}
			}
		},
		"ListStreams": {
			"input": {
				"type": "structure",
				"members": {
					"Limit": {
						"type": "integer"
					},
					"ExclusiveStartStreamName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"StreamNames",
					"HasMoreStreams"
				],
				"members": {
					"StreamNames": {
						"type": "list",
						"member": {}
					},
					"HasMoreStreams": {
						"type": "boolean"
					}
				}
			}
		},
		"ListTagsForStream": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName"
				],
				"members": {
					"StreamName": {},
					"ExclusiveStartTagKey": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Tags",
					"HasMoreTags"
				],
				"members": {
					"Tags": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					},
					"HasMoreTags": {
						"type": "boolean"
					}
				}
			}
		},
		"MergeShards": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"ShardToMerge",
					"AdjacentShardToMerge"
				],
				"members": {
					"StreamName": {},
					"ShardToMerge": {},
					"AdjacentShardToMerge": {}
				}
			}
		},
		"PutRecord": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"Data",
					"PartitionKey"
				],
				"members": {
					"StreamName": {},
					"Data": {
						"type": "blob"
					},
					"PartitionKey": {},
					"ExplicitHashKey": {},
					"SequenceNumberForOrdering": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ShardId",
					"SequenceNumber"
				],
				"members": {
					"ShardId": {},
					"SequenceNumber": {},
					"EncryptionType": {}
				}
			}
		},
		"PutRecords": {
			"input": {
				"type": "structure",
				"required": [
					"Records",
					"StreamName"
				],
				"members": {
					"Records": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Data",
								"PartitionKey"
							],
							"members": {
								"Data": {
									"type": "blob"
								},
								"ExplicitHashKey": {},
								"PartitionKey": {}
							}
						}
					},
					"StreamName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Records"
				],
				"members": {
					"FailedRecordCount": {
						"type": "integer"
					},
					"Records": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"SequenceNumber": {},
								"ShardId": {},
								"ErrorCode": {},
								"ErrorMessage": {}
							}
						}
					},
					"EncryptionType": {}
				}
			}
		},
		"RemoveTagsFromStream": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"TagKeys"
				],
				"members": {
					"StreamName": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"SplitShard": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"ShardToSplit",
					"NewStartingHashKey"
				],
				"members": {
					"StreamName": {},
					"ShardToSplit": {},
					"NewStartingHashKey": {}
				}
			}
		},
		"StartStreamEncryption": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"EncryptionType",
					"KeyId"
				],
				"members": {
					"StreamName": {},
					"EncryptionType": {},
					"KeyId": {}
				}
			}
		},
		"StopStreamEncryption": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"EncryptionType",
					"KeyId"
				],
				"members": {
					"StreamName": {},
					"EncryptionType": {},
					"KeyId": {}
				}
			}
		},
		"UpdateShardCount": {
			"input": {
				"type": "structure",
				"required": [
					"StreamName",
					"TargetShardCount",
					"ScalingType"
				],
				"members": {
					"StreamName": {},
					"TargetShardCount": {
						"type": "integer"
					},
					"ScalingType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StreamName": {},
					"CurrentShardCount": {
						"type": "integer"
					},
					"TargetShardCount": {
						"type": "integer"
					}
				}
			}
		}
	},
	"shapes": {
		"Su": {
			"type": "list",
			"member": {}
		},
		"Sz": {
			"type": "structure",
			"members": {
				"StreamName": {},
				"CurrentShardLevelMetrics": {
					"shape": "Su"
				},
				"DesiredShardLevelMetrics": {
					"shape": "Su"
				}
			}
		}
	}
};

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeStream": {
			"input_token": "ExclusiveStartShardId",
			"limit_key": "Limit",
			"more_results": "StreamDescription.HasMoreShards",
			"output_token": "StreamDescription.Shards[-1].ShardId",
			"result_key": "StreamDescription.Shards"
		},
		"ListStreams": {
			"input_token": "ExclusiveStartStreamName",
			"limit_key": "Limit",
			"more_results": "HasMoreStreams",
			"output_token": "StreamNames[-1]",
			"result_key": "StreamNames"
		}
	}
};

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"StreamExists": {
			"delay": 10,
			"operation": "DescribeStream",
			"maxAttempts": 18,
			"acceptors": [
				{
					"expected": "ACTIVE",
					"matcher": "path",
					"state": "success",
					"argument": "StreamDescription.StreamStatus"
				}
			]
		},
		"StreamNotExists": {
			"delay": 10,
			"operation": "DescribeStream",
			"maxAttempts": 18,
			"acceptors": [
				{
					"expected": "ResourceNotFoundException",
					"matcher": "error",
					"state": "success"
				}
			]
		}
	}
};

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['kms'] = {};
AWS.KMS = Service.defineService('kms', ['2014-11-01']);
Object.defineProperty(apiLoader.services['kms'], '2014-11-01', {
  get: function get() {
    var model = __webpack_require__(1645);
    model.paginators = __webpack_require__(1646).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.KMS;


/***/ }),
/* 1645 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-11-01",
		"endpointPrefix": "kms",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "KMS",
		"serviceFullName": "AWS Key Management Service",
		"signatureVersion": "v4",
		"targetPrefix": "TrentService",
		"uid": "kms-2014-11-01"
	},
	"operations": {
		"CancelKeyDeletion": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyId": {}
				}
			}
		},
		"CreateAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasName",
					"TargetKeyId"
				],
				"members": {
					"AliasName": {},
					"TargetKeyId": {}
				}
			}
		},
		"CreateGrant": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId",
					"GranteePrincipal"
				],
				"members": {
					"KeyId": {},
					"GranteePrincipal": {},
					"RetiringPrincipal": {},
					"Operations": {
						"shape": "S8"
					},
					"Constraints": {
						"shape": "Sa"
					},
					"GrantTokens": {
						"shape": "Se"
					},
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GrantToken": {},
					"GrantId": {}
				}
			}
		},
		"CreateKey": {
			"input": {
				"type": "structure",
				"members": {
					"Policy": {},
					"Description": {},
					"KeyUsage": {},
					"Origin": {},
					"BypassPolicyLockoutSafetyCheck": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "Sp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyMetadata": {
						"shape": "Su"
					}
				}
			}
		},
		"Decrypt": {
			"input": {
				"type": "structure",
				"required": [
					"CiphertextBlob"
				],
				"members": {
					"CiphertextBlob": {
						"type": "blob"
					},
					"EncryptionContext": {
						"shape": "Sb"
					},
					"GrantTokens": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyId": {},
					"Plaintext": {
						"shape": "S14"
					}
				}
			}
		},
		"DeleteAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasName"
				],
				"members": {
					"AliasName": {}
				}
			}
		},
		"DeleteImportedKeyMaterial": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {}
				}
			}
		},
		"DescribeKey": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {},
					"GrantTokens": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyMetadata": {
						"shape": "Su"
					}
				}
			}
		},
		"DisableKey": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {}
				}
			}
		},
		"DisableKeyRotation": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {}
				}
			}
		},
		"EnableKey": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {}
				}
			}
		},
		"EnableKeyRotation": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {}
				}
			}
		},
		"Encrypt": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId",
					"Plaintext"
				],
				"members": {
					"KeyId": {},
					"Plaintext": {
						"shape": "S14"
					},
					"EncryptionContext": {
						"shape": "Sb"
					},
					"GrantTokens": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CiphertextBlob": {
						"type": "blob"
					},
					"KeyId": {}
				}
			}
		},
		"GenerateDataKey": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {},
					"EncryptionContext": {
						"shape": "Sb"
					},
					"NumberOfBytes": {
						"type": "integer"
					},
					"KeySpec": {},
					"GrantTokens": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CiphertextBlob": {
						"type": "blob"
					},
					"Plaintext": {
						"shape": "S14"
					},
					"KeyId": {}
				}
			}
		},
		"GenerateDataKeyWithoutPlaintext": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {},
					"EncryptionContext": {
						"shape": "Sb"
					},
					"KeySpec": {},
					"NumberOfBytes": {
						"type": "integer"
					},
					"GrantTokens": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CiphertextBlob": {
						"type": "blob"
					},
					"KeyId": {}
				}
			}
		},
		"GenerateRandom": {
			"input": {
				"type": "structure",
				"members": {
					"NumberOfBytes": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Plaintext": {
						"shape": "S14"
					}
				}
			}
		},
		"GetKeyPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId",
					"PolicyName"
				],
				"members": {
					"KeyId": {},
					"PolicyName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Policy": {}
				}
			}
		},
		"GetKeyRotationStatus": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyRotationEnabled": {
						"type": "boolean"
					}
				}
			}
		},
		"GetParametersForImport": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId",
					"WrappingAlgorithm",
					"WrappingKeySpec"
				],
				"members": {
					"KeyId": {},
					"WrappingAlgorithm": {},
					"WrappingKeySpec": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyId": {},
					"ImportToken": {
						"type": "blob"
					},
					"PublicKey": {
						"shape": "S14"
					},
					"ParametersValidTo": {
						"type": "timestamp"
					}
				}
			}
		},
		"ImportKeyMaterial": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId",
					"ImportToken",
					"EncryptedKeyMaterial"
				],
				"members": {
					"KeyId": {},
					"ImportToken": {
						"type": "blob"
					},
					"EncryptedKeyMaterial": {
						"type": "blob"
					},
					"ValidTo": {
						"type": "timestamp"
					},
					"ExpirationModel": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ListAliases": {
			"input": {
				"type": "structure",
				"members": {
					"Limit": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Aliases": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AliasName": {},
								"AliasArn": {},
								"TargetKeyId": {}
							}
						}
					},
					"NextMarker": {},
					"Truncated": {
						"type": "boolean"
					}
				}
			}
		},
		"ListGrants": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"Limit": {
						"type": "integer"
					},
					"Marker": {},
					"KeyId": {}
				}
			},
			"output": {
				"shape": "S25"
			}
		},
		"ListKeyPolicies": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {},
					"Limit": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PolicyNames": {
						"type": "list",
						"member": {}
					},
					"NextMarker": {},
					"Truncated": {
						"type": "boolean"
					}
				}
			}
		},
		"ListKeys": {
			"input": {
				"type": "structure",
				"members": {
					"Limit": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Keys": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"KeyId": {},
								"KeyArn": {}
							}
						}
					},
					"NextMarker": {},
					"Truncated": {
						"type": "boolean"
					}
				}
			}
		},
		"ListResourceTags": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {},
					"Limit": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Tags": {
						"shape": "Sp"
					},
					"NextMarker": {},
					"Truncated": {
						"type": "boolean"
					}
				}
			}
		},
		"ListRetirableGrants": {
			"input": {
				"type": "structure",
				"required": [
					"RetiringPrincipal"
				],
				"members": {
					"Limit": {
						"type": "integer"
					},
					"Marker": {},
					"RetiringPrincipal": {}
				}
			},
			"output": {
				"shape": "S25"
			}
		},
		"PutKeyPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId",
					"PolicyName",
					"Policy"
				],
				"members": {
					"KeyId": {},
					"PolicyName": {},
					"Policy": {},
					"BypassPolicyLockoutSafetyCheck": {
						"type": "boolean"
					}
				}
			}
		},
		"ReEncrypt": {
			"input": {
				"type": "structure",
				"required": [
					"CiphertextBlob",
					"DestinationKeyId"
				],
				"members": {
					"CiphertextBlob": {
						"type": "blob"
					},
					"SourceEncryptionContext": {
						"shape": "Sb"
					},
					"DestinationKeyId": {},
					"DestinationEncryptionContext": {
						"shape": "Sb"
					},
					"GrantTokens": {
						"shape": "Se"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CiphertextBlob": {
						"type": "blob"
					},
					"SourceKeyId": {},
					"KeyId": {}
				}
			}
		},
		"RetireGrant": {
			"input": {
				"type": "structure",
				"members": {
					"GrantToken": {},
					"KeyId": {},
					"GrantId": {}
				}
			}
		},
		"RevokeGrant": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId",
					"GrantId"
				],
				"members": {
					"KeyId": {},
					"GrantId": {}
				}
			}
		},
		"ScheduleKeyDeletion": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"KeyId": {},
					"PendingWindowInDays": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"KeyId": {},
					"DeletionDate": {
						"type": "timestamp"
					}
				}
			}
		},
		"TagResource": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId",
					"Tags"
				],
				"members": {
					"KeyId": {},
					"Tags": {
						"shape": "Sp"
					}
				}
			}
		},
		"UntagResource": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId",
					"TagKeys"
				],
				"members": {
					"KeyId": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"UpdateAlias": {
			"input": {
				"type": "structure",
				"required": [
					"AliasName",
					"TargetKeyId"
				],
				"members": {
					"AliasName": {},
					"TargetKeyId": {}
				}
			}
		},
		"UpdateKeyDescription": {
			"input": {
				"type": "structure",
				"required": [
					"KeyId",
					"Description"
				],
				"members": {
					"KeyId": {},
					"Description": {}
				}
			}
		}
	},
	"shapes": {
		"S8": {
			"type": "list",
			"member": {}
		},
		"Sa": {
			"type": "structure",
			"members": {
				"EncryptionContextSubset": {
					"shape": "Sb"
				},
				"EncryptionContextEquals": {
					"shape": "Sb"
				}
			}
		},
		"Sb": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"Se": {
			"type": "list",
			"member": {}
		},
		"Sp": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"TagKey",
					"TagValue"
				],
				"members": {
					"TagKey": {},
					"TagValue": {}
				}
			}
		},
		"Su": {
			"type": "structure",
			"required": [
				"KeyId"
			],
			"members": {
				"AWSAccountId": {},
				"KeyId": {},
				"Arn": {},
				"CreationDate": {
					"type": "timestamp"
				},
				"Enabled": {
					"type": "boolean"
				},
				"Description": {},
				"KeyUsage": {},
				"KeyState": {},
				"DeletionDate": {
					"type": "timestamp"
				},
				"ValidTo": {
					"type": "timestamp"
				},
				"Origin": {},
				"ExpirationModel": {},
				"KeyManager": {}
			}
		},
		"S14": {
			"type": "blob",
			"sensitive": true
		},
		"S25": {
			"type": "structure",
			"members": {
				"Grants": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"KeyId": {},
							"GrantId": {},
							"Name": {},
							"CreationDate": {
								"type": "timestamp"
							},
							"GranteePrincipal": {},
							"RetiringPrincipal": {},
							"IssuingAccount": {},
							"Operations": {
								"shape": "S8"
							},
							"Constraints": {
								"shape": "Sa"
							}
						}
					}
				},
				"NextMarker": {},
				"Truncated": {
					"type": "boolean"
				}
			}
		}
	}
};

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListAliases": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"more_results": "Truncated",
			"output_token": "NextMarker",
			"result_key": "Aliases"
		},
		"ListGrants": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"more_results": "Truncated",
			"output_token": "NextMarker",
			"result_key": "Grants"
		},
		"ListKeyPolicies": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"more_results": "Truncated",
			"output_token": "NextMarker",
			"result_key": "PolicyNames"
		},
		"ListKeys": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"more_results": "Truncated",
			"output_token": "NextMarker",
			"result_key": "Keys"
		}
	}
};

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['lambda'] = {};
AWS.Lambda = Service.defineService('lambda', ['2014-11-11', '2015-03-31']);
__webpack_require__(1648);
Object.defineProperty(apiLoader.services['lambda'], '2014-11-11', {
  get: function get() {
    var model = __webpack_require__(1649);
    model.paginators = __webpack_require__(1650).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['lambda'], '2015-03-31', {
  get: function get() {
    var model = __webpack_require__(1651);
    model.paginators = __webpack_require__(1652).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Lambda;


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

AWS.util.update(AWS.Lambda.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    if (request.operation === 'invoke') {
      request.addListener('extractData', AWS.util.convertPayloadToString);
    }
  }
});



/***/ }),
/* 1649 */
/***/ (function(module, exports) {

module.exports = {
	"metadata": {
		"apiVersion": "2014-11-11",
		"endpointPrefix": "lambda",
		"serviceFullName": "AWS Lambda",
		"signatureVersion": "v4",
		"protocol": "rest-json"
	},
	"operations": {
		"AddEventSource": {
			"http": {
				"requestUri": "/2014-11-13/event-source-mappings/"
			},
			"input": {
				"type": "structure",
				"required": [
					"EventSource",
					"FunctionName",
					"Role"
				],
				"members": {
					"EventSource": {},
					"FunctionName": {},
					"Role": {},
					"BatchSize": {
						"type": "integer"
					},
					"Parameters": {
						"shape": "S6"
					}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"DeleteFunction": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2014-11-13/functions/{FunctionName}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					}
				}
			}
		},
		"GetEventSource": {
			"http": {
				"method": "GET",
				"requestUri": "/2014-11-13/event-source-mappings/{UUID}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"UUID"
				],
				"members": {
					"UUID": {
						"location": "uri",
						"locationName": "UUID"
					}
				}
			},
			"output": {
				"shape": "S7"
			}
		},
		"GetFunction": {
			"http": {
				"method": "GET",
				"requestUri": "/2014-11-13/functions/{FunctionName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Configuration": {
						"shape": "Se"
					},
					"Code": {
						"type": "structure",
						"members": {
							"RepositoryType": {},
							"Location": {}
						}
					}
				}
			}
		},
		"GetFunctionConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/2014-11-13/functions/{FunctionName}/configuration",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					}
				}
			},
			"output": {
				"shape": "Se"
			}
		},
		"InvokeAsync": {
			"http": {
				"requestUri": "/2014-11-13/functions/{FunctionName}/invoke-async/",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName",
					"InvokeArgs"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"InvokeArgs": {
						"shape": "Sq"
					}
				},
				"payload": "InvokeArgs"
			},
			"output": {
				"type": "structure",
				"members": {
					"Status": {
						"location": "statusCode",
						"type": "integer"
					}
				}
			}
		},
		"ListEventSources": {
			"http": {
				"method": "GET",
				"requestUri": "/2014-11-13/event-source-mappings/",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"EventSourceArn": {
						"location": "querystring",
						"locationName": "EventSource"
					},
					"FunctionName": {
						"location": "querystring",
						"locationName": "FunctionName"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"EventSources": {
						"type": "list",
						"member": {
							"shape": "S7"
						}
					}
				}
			}
		},
		"ListFunctions": {
			"http": {
				"method": "GET",
				"requestUri": "/2014-11-13/functions/",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Functions": {
						"type": "list",
						"member": {
							"shape": "Se"
						}
					}
				}
			}
		},
		"RemoveEventSource": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2014-11-13/event-source-mappings/{UUID}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"UUID"
				],
				"members": {
					"UUID": {
						"location": "uri",
						"locationName": "UUID"
					}
				}
			}
		},
		"UpdateFunctionConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/2014-11-13/functions/{FunctionName}/configuration",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Role": {
						"location": "querystring",
						"locationName": "Role"
					},
					"Handler": {
						"location": "querystring",
						"locationName": "Handler"
					},
					"Description": {
						"location": "querystring",
						"locationName": "Description"
					},
					"Timeout": {
						"location": "querystring",
						"locationName": "Timeout",
						"type": "integer"
					},
					"MemorySize": {
						"location": "querystring",
						"locationName": "MemorySize",
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "Se"
			}
		},
		"UploadFunction": {
			"http": {
				"method": "PUT",
				"requestUri": "/2014-11-13/functions/{FunctionName}",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName",
					"FunctionZip",
					"Runtime",
					"Role",
					"Handler",
					"Mode"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"FunctionZip": {
						"shape": "Sq"
					},
					"Runtime": {
						"location": "querystring",
						"locationName": "Runtime"
					},
					"Role": {
						"location": "querystring",
						"locationName": "Role"
					},
					"Handler": {
						"location": "querystring",
						"locationName": "Handler"
					},
					"Mode": {
						"location": "querystring",
						"locationName": "Mode"
					},
					"Description": {
						"location": "querystring",
						"locationName": "Description"
					},
					"Timeout": {
						"location": "querystring",
						"locationName": "Timeout",
						"type": "integer"
					},
					"MemorySize": {
						"location": "querystring",
						"locationName": "MemorySize",
						"type": "integer"
					}
				},
				"payload": "FunctionZip"
			},
			"output": {
				"shape": "Se"
			}
		}
	},
	"shapes": {
		"S6": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S7": {
			"type": "structure",
			"members": {
				"UUID": {},
				"BatchSize": {
					"type": "integer"
				},
				"EventSource": {},
				"FunctionName": {},
				"Parameters": {
					"shape": "S6"
				},
				"Role": {},
				"LastModified": {
					"type": "timestamp"
				},
				"IsActive": {
					"type": "boolean"
				},
				"Status": {}
			}
		},
		"Se": {
			"type": "structure",
			"members": {
				"FunctionName": {},
				"FunctionARN": {},
				"ConfigurationId": {},
				"Runtime": {},
				"Role": {},
				"Handler": {},
				"Mode": {},
				"CodeSize": {
					"type": "long"
				},
				"Description": {},
				"Timeout": {
					"type": "integer"
				},
				"MemorySize": {
					"type": "integer"
				},
				"LastModified": {
					"type": "timestamp"
				}
			}
		},
		"Sq": {
			"type": "blob",
			"streaming": true
		}
	}
};

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListEventSources": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"limit_key": "MaxItems",
			"result_key": "EventSources"
		},
		"ListFunctions": {
			"input_token": "Marker",
			"output_token": "NextMarker",
			"limit_key": "MaxItems",
			"result_key": "Functions"
		}
	}
};

/***/ }),
/* 1651 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-03-31",
		"endpointPrefix": "lambda",
		"protocol": "rest-json",
		"serviceFullName": "AWS Lambda",
		"signatureVersion": "v4",
		"uid": "lambda-2015-03-31"
	},
	"operations": {
		"AddPermission": {
			"http": {
				"requestUri": "/2015-03-31/functions/{FunctionName}/policy",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName",
					"StatementId",
					"Action",
					"Principal"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"StatementId": {},
					"Action": {},
					"Principal": {},
					"SourceArn": {},
					"SourceAccount": {},
					"EventSourceToken": {},
					"Qualifier": {
						"location": "querystring",
						"locationName": "Qualifier"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Statement": {}
				}
			}
		},
		"CreateAlias": {
			"http": {
				"requestUri": "/2015-03-31/functions/{FunctionName}/aliases",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName",
					"Name",
					"FunctionVersion"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Name": {},
					"FunctionVersion": {},
					"Description": {}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"CreateEventSourceMapping": {
			"http": {
				"requestUri": "/2015-03-31/event-source-mappings/",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"EventSourceArn",
					"FunctionName",
					"StartingPosition"
				],
				"members": {
					"EventSourceArn": {},
					"FunctionName": {},
					"Enabled": {
						"type": "boolean"
					},
					"BatchSize": {
						"type": "integer"
					},
					"StartingPosition": {},
					"StartingPositionTimestamp": {
						"type": "timestamp"
					}
				}
			},
			"output": {
				"shape": "Sn"
			}
		},
		"CreateFunction": {
			"http": {
				"requestUri": "/2015-03-31/functions",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName",
					"Runtime",
					"Role",
					"Handler",
					"Code"
				],
				"members": {
					"FunctionName": {},
					"Runtime": {},
					"Role": {},
					"Handler": {},
					"Code": {
						"type": "structure",
						"members": {
							"ZipFile": {
								"shape": "St"
							},
							"S3Bucket": {},
							"S3Key": {},
							"S3ObjectVersion": {}
						}
					},
					"Description": {},
					"Timeout": {
						"type": "integer"
					},
					"MemorySize": {
						"type": "integer"
					},
					"Publish": {
						"type": "boolean"
					},
					"VpcConfig": {
						"shape": "S10"
					},
					"DeadLetterConfig": {
						"shape": "S15"
					},
					"Environment": {
						"shape": "S17"
					},
					"KMSKeyArn": {},
					"TracingConfig": {
						"shape": "S1c"
					},
					"Tags": {
						"shape": "S1e"
					}
				}
			},
			"output": {
				"shape": "S1h"
			}
		},
		"DeleteAlias": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName",
					"Name"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Name": {
						"location": "uri",
						"locationName": "Name"
					}
				}
			}
		},
		"DeleteEventSourceMapping": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2015-03-31/event-source-mappings/{UUID}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"UUID"
				],
				"members": {
					"UUID": {
						"location": "uri",
						"locationName": "UUID"
					}
				}
			},
			"output": {
				"shape": "Sn"
			}
		},
		"DeleteFunction": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2015-03-31/functions/{FunctionName}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Qualifier": {
						"location": "querystring",
						"locationName": "Qualifier"
					}
				}
			}
		},
		"GetAccountSettings": {
			"http": {
				"method": "GET",
				"requestUri": "/2016-08-19/account-settings/",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"AccountLimit": {
						"type": "structure",
						"members": {
							"TotalCodeSize": {
								"type": "long"
							},
							"CodeSizeUnzipped": {
								"type": "long"
							},
							"CodeSizeZipped": {
								"type": "long"
							},
							"ConcurrentExecutions": {
								"type": "integer"
							}
						}
					},
					"AccountUsage": {
						"type": "structure",
						"members": {
							"TotalCodeSize": {
								"type": "long"
							},
							"FunctionCount": {
								"type": "long"
							}
						}
					}
				}
			}
		},
		"GetAlias": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName",
					"Name"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Name": {
						"location": "uri",
						"locationName": "Name"
					}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"GetEventSourceMapping": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-03-31/event-source-mappings/{UUID}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"UUID"
				],
				"members": {
					"UUID": {
						"location": "uri",
						"locationName": "UUID"
					}
				}
			},
			"output": {
				"shape": "Sn"
			}
		},
		"GetFunction": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-03-31/functions/{FunctionName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Qualifier": {
						"location": "querystring",
						"locationName": "Qualifier"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Configuration": {
						"shape": "S1h"
					},
					"Code": {
						"type": "structure",
						"members": {
							"RepositoryType": {},
							"Location": {}
						}
					},
					"Tags": {
						"shape": "S1e"
					}
				}
			}
		},
		"GetFunctionConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-03-31/functions/{FunctionName}/configuration",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Qualifier": {
						"location": "querystring",
						"locationName": "Qualifier"
					}
				}
			},
			"output": {
				"shape": "S1h"
			}
		},
		"GetPolicy": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-03-31/functions/{FunctionName}/policy",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Qualifier": {
						"location": "querystring",
						"locationName": "Qualifier"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Policy": {}
				}
			}
		},
		"Invoke": {
			"http": {
				"requestUri": "/2015-03-31/functions/{FunctionName}/invocations"
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"InvocationType": {
						"location": "header",
						"locationName": "X-Amz-Invocation-Type"
					},
					"LogType": {
						"location": "header",
						"locationName": "X-Amz-Log-Type"
					},
					"ClientContext": {
						"location": "header",
						"locationName": "X-Amz-Client-Context"
					},
					"Payload": {
						"shape": "St"
					},
					"Qualifier": {
						"location": "querystring",
						"locationName": "Qualifier"
					}
				},
				"payload": "Payload"
			},
			"output": {
				"type": "structure",
				"members": {
					"StatusCode": {
						"location": "statusCode",
						"type": "integer"
					},
					"FunctionError": {
						"location": "header",
						"locationName": "X-Amz-Function-Error"
					},
					"LogResult": {
						"location": "header",
						"locationName": "X-Amz-Log-Result"
					},
					"Payload": {
						"shape": "St"
					}
				},
				"payload": "Payload"
			}
		},
		"InvokeAsync": {
			"http": {
				"requestUri": "/2014-11-13/functions/{FunctionName}/invoke-async/",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName",
					"InvokeArgs"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"InvokeArgs": {
						"type": "blob",
						"streaming": true
					}
				},
				"deprecated": true,
				"payload": "InvokeArgs"
			},
			"output": {
				"type": "structure",
				"members": {
					"Status": {
						"location": "statusCode",
						"type": "integer"
					}
				},
				"deprecated": true
			},
			"deprecated": true
		},
		"ListAliases": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-03-31/functions/{FunctionName}/aliases",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"FunctionVersion": {
						"location": "querystring",
						"locationName": "FunctionVersion"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Aliases": {
						"type": "list",
						"member": {
							"shape": "Sg"
						}
					}
				}
			}
		},
		"ListEventSourceMappings": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-03-31/event-source-mappings/",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"EventSourceArn": {
						"location": "querystring",
						"locationName": "EventSourceArn"
					},
					"FunctionName": {
						"location": "querystring",
						"locationName": "FunctionName"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"EventSourceMappings": {
						"type": "list",
						"member": {
							"shape": "Sn"
						}
					}
				}
			}
		},
		"ListFunctions": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-03-31/functions/",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"MasterRegion": {
						"location": "querystring",
						"locationName": "MasterRegion"
					},
					"FunctionVersion": {
						"location": "querystring",
						"locationName": "FunctionVersion"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Functions": {
						"shape": "S2r"
					}
				}
			}
		},
		"ListTags": {
			"http": {
				"method": "GET",
				"requestUri": "/2017-03-31/tags/{ARN}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Resource"
				],
				"members": {
					"Resource": {
						"location": "uri",
						"locationName": "ARN"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Tags": {
						"shape": "S1e"
					}
				}
			}
		},
		"ListVersionsByFunction": {
			"http": {
				"method": "GET",
				"requestUri": "/2015-03-31/functions/{FunctionName}/versions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "Marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "MaxItems",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Versions": {
						"shape": "S2r"
					}
				}
			}
		},
		"PublishVersion": {
			"http": {
				"requestUri": "/2015-03-31/functions/{FunctionName}/versions",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"CodeSha256": {},
					"Description": {}
				}
			},
			"output": {
				"shape": "S1h"
			}
		},
		"RemovePermission": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2015-03-31/functions/{FunctionName}/policy/{StatementId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName",
					"StatementId"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"StatementId": {
						"location": "uri",
						"locationName": "StatementId"
					},
					"Qualifier": {
						"location": "querystring",
						"locationName": "Qualifier"
					}
				}
			}
		},
		"TagResource": {
			"http": {
				"requestUri": "/2017-03-31/tags/{ARN}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Resource",
					"Tags"
				],
				"members": {
					"Resource": {
						"location": "uri",
						"locationName": "ARN"
					},
					"Tags": {
						"shape": "S1e"
					}
				}
			}
		},
		"UntagResource": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2017-03-31/tags/{ARN}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"Resource",
					"TagKeys"
				],
				"members": {
					"Resource": {
						"location": "uri",
						"locationName": "ARN"
					},
					"TagKeys": {
						"location": "querystring",
						"locationName": "tagKeys",
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"UpdateAlias": {
			"http": {
				"method": "PUT",
				"requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName",
					"Name"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Name": {
						"location": "uri",
						"locationName": "Name"
					},
					"FunctionVersion": {},
					"Description": {}
				}
			},
			"output": {
				"shape": "Sg"
			}
		},
		"UpdateEventSourceMapping": {
			"http": {
				"method": "PUT",
				"requestUri": "/2015-03-31/event-source-mappings/{UUID}",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"UUID"
				],
				"members": {
					"UUID": {
						"location": "uri",
						"locationName": "UUID"
					},
					"FunctionName": {},
					"Enabled": {
						"type": "boolean"
					},
					"BatchSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"shape": "Sn"
			}
		},
		"UpdateFunctionCode": {
			"http": {
				"method": "PUT",
				"requestUri": "/2015-03-31/functions/{FunctionName}/code",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"ZipFile": {
						"shape": "St"
					},
					"S3Bucket": {},
					"S3Key": {},
					"S3ObjectVersion": {},
					"Publish": {
						"type": "boolean"
					},
					"DryRun": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"shape": "S1h"
			}
		},
		"UpdateFunctionConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/2015-03-31/functions/{FunctionName}/configuration",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FunctionName"
				],
				"members": {
					"FunctionName": {
						"location": "uri",
						"locationName": "FunctionName"
					},
					"Role": {},
					"Handler": {},
					"Description": {},
					"Timeout": {
						"type": "integer"
					},
					"MemorySize": {
						"type": "integer"
					},
					"VpcConfig": {
						"shape": "S10"
					},
					"Environment": {
						"shape": "S17"
					},
					"Runtime": {},
					"DeadLetterConfig": {
						"shape": "S15"
					},
					"KMSKeyArn": {},
					"TracingConfig": {
						"shape": "S1c"
					}
				}
			},
			"output": {
				"shape": "S1h"
			}
		}
	},
	"shapes": {
		"Sg": {
			"type": "structure",
			"members": {
				"AliasArn": {},
				"Name": {},
				"FunctionVersion": {},
				"Description": {}
			}
		},
		"Sn": {
			"type": "structure",
			"members": {
				"UUID": {},
				"BatchSize": {
					"type": "integer"
				},
				"EventSourceArn": {},
				"FunctionArn": {},
				"LastModified": {
					"type": "timestamp"
				},
				"LastProcessingResult": {},
				"State": {},
				"StateTransitionReason": {}
			}
		},
		"St": {
			"type": "blob",
			"sensitive": true
		},
		"S10": {
			"type": "structure",
			"members": {
				"SubnetIds": {
					"shape": "S11"
				},
				"SecurityGroupIds": {
					"shape": "S13"
				}
			}
		},
		"S11": {
			"type": "list",
			"member": {}
		},
		"S13": {
			"type": "list",
			"member": {}
		},
		"S15": {
			"type": "structure",
			"members": {
				"TargetArn": {}
			}
		},
		"S17": {
			"type": "structure",
			"members": {
				"Variables": {
					"shape": "S18"
				}
			}
		},
		"S18": {
			"type": "map",
			"key": {
				"type": "string",
				"sensitive": true
			},
			"value": {
				"type": "string",
				"sensitive": true
			},
			"sensitive": true
		},
		"S1c": {
			"type": "structure",
			"members": {
				"Mode": {}
			}
		},
		"S1e": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1h": {
			"type": "structure",
			"members": {
				"FunctionName": {},
				"FunctionArn": {},
				"Runtime": {},
				"Role": {},
				"Handler": {},
				"CodeSize": {
					"type": "long"
				},
				"Description": {},
				"Timeout": {
					"type": "integer"
				},
				"MemorySize": {
					"type": "integer"
				},
				"LastModified": {},
				"CodeSha256": {},
				"Version": {},
				"VpcConfig": {
					"type": "structure",
					"members": {
						"SubnetIds": {
							"shape": "S11"
						},
						"SecurityGroupIds": {
							"shape": "S13"
						},
						"VpcId": {}
					}
				},
				"DeadLetterConfig": {
					"shape": "S15"
				},
				"Environment": {
					"type": "structure",
					"members": {
						"Variables": {
							"shape": "S18"
						},
						"Error": {
							"type": "structure",
							"members": {
								"ErrorCode": {},
								"Message": {
									"type": "string",
									"sensitive": true
								}
							}
						}
					}
				},
				"KMSKeyArn": {},
				"TracingConfig": {
					"type": "structure",
					"members": {
						"Mode": {}
					}
				},
				"MasterArn": {}
			}
		},
		"S2r": {
			"type": "list",
			"member": {
				"shape": "S1h"
			}
		}
	}
};

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListEventSourceMappings": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"output_token": "NextMarker",
			"result_key": "EventSourceMappings"
		},
		"ListFunctions": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"output_token": "NextMarker",
			"result_key": "Functions"
		}
	}
};

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['lexruntime'] = {};
AWS.LexRuntime = Service.defineService('lexruntime', ['2016-11-28']);
Object.defineProperty(apiLoader.services['lexruntime'], '2016-11-28', {
  get: function get() {
    var model = __webpack_require__(1654);
    model.paginators = __webpack_require__(1655).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.LexRuntime;


/***/ }),
/* 1654 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-11-28",
		"endpointPrefix": "runtime.lex",
		"jsonVersion": "1.1",
		"protocol": "rest-json",
		"serviceFullName": "Amazon Lex Runtime Service",
		"signatureVersion": "v4",
		"signingName": "lex",
		"uid": "runtime.lex-2016-11-28"
	},
	"operations": {
		"PostContent": {
			"http": {
				"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/content"
			},
			"input": {
				"type": "structure",
				"required": [
					"botName",
					"botAlias",
					"userId",
					"contentType",
					"inputStream"
				],
				"members": {
					"botName": {
						"location": "uri",
						"locationName": "botName"
					},
					"botAlias": {
						"location": "uri",
						"locationName": "botAlias"
					},
					"userId": {
						"location": "uri",
						"locationName": "userId"
					},
					"sessionAttributes": {
						"jsonvalue": true,
						"location": "header",
						"locationName": "x-amz-lex-session-attributes"
					},
					"contentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"accept": {
						"location": "header",
						"locationName": "Accept"
					},
					"inputStream": {
						"shape": "S8"
					}
				},
				"payload": "inputStream"
			},
			"output": {
				"type": "structure",
				"members": {
					"contentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"intentName": {
						"location": "header",
						"locationName": "x-amz-lex-intent-name"
					},
					"slots": {
						"jsonvalue": true,
						"location": "header",
						"locationName": "x-amz-lex-slots"
					},
					"sessionAttributes": {
						"jsonvalue": true,
						"location": "header",
						"locationName": "x-amz-lex-session-attributes"
					},
					"message": {
						"location": "header",
						"locationName": "x-amz-lex-message"
					},
					"dialogState": {
						"location": "header",
						"locationName": "x-amz-lex-dialog-state"
					},
					"slotToElicit": {
						"location": "header",
						"locationName": "x-amz-lex-slot-to-elicit"
					},
					"inputTranscript": {
						"location": "header",
						"locationName": "x-amz-lex-input-transcript"
					},
					"audioStream": {
						"shape": "S8"
					}
				},
				"payload": "audioStream"
			},
			"authtype": "v4-unsigned-body"
		},
		"PostText": {
			"http": {
				"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/text"
			},
			"input": {
				"type": "structure",
				"required": [
					"botName",
					"botAlias",
					"userId",
					"inputText"
				],
				"members": {
					"botName": {
						"location": "uri",
						"locationName": "botName"
					},
					"botAlias": {
						"location": "uri",
						"locationName": "botAlias"
					},
					"userId": {
						"location": "uri",
						"locationName": "userId"
					},
					"sessionAttributes": {
						"shape": "Se"
					},
					"inputText": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"intentName": {},
					"slots": {
						"shape": "Se"
					},
					"sessionAttributes": {
						"shape": "Se"
					},
					"message": {},
					"dialogState": {},
					"slotToElicit": {},
					"responseCard": {
						"type": "structure",
						"members": {
							"version": {},
							"contentType": {},
							"genericAttachments": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"title": {},
										"subTitle": {},
										"attachmentLinkUrl": {},
										"imageUrl": {},
										"buttons": {
											"type": "list",
											"member": {
												"type": "structure",
												"required": [
													"text",
													"value"
												],
												"members": {
													"text": {},
													"value": {}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	},
	"shapes": {
		"S8": {
			"type": "blob",
			"streaming": true
		},
		"Se": {
			"type": "map",
			"key": {},
			"value": {}
		}
	}
};

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['machinelearning'] = {};
AWS.MachineLearning = Service.defineService('machinelearning', ['2014-12-12']);
__webpack_require__(1657);
Object.defineProperty(apiLoader.services['machinelearning'], '2014-12-12', {
  get: function get() {
    var model = __webpack_require__(1658);
    model.paginators = __webpack_require__(1659).pagination;
    model.waiters = __webpack_require__(1660).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MachineLearning;


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

AWS.util.update(AWS.MachineLearning.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    if (request.operation === 'predict') {
      request.addListener('build', this.buildEndpoint);
    }
  },

  /**
   * Updates request endpoint from PredictEndpoint
   * @api private
   */
  buildEndpoint: function buildEndpoint(request) {
    var url = request.params.PredictEndpoint;
    if (url) {
      request.httpRequest.endpoint = new AWS.Endpoint(url);
    }
  }

});


/***/ }),
/* 1658 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"uid": "machinelearning-2014-12-12",
		"apiVersion": "2014-12-12",
		"endpointPrefix": "machinelearning",
		"jsonVersion": "1.1",
		"serviceFullName": "Amazon Machine Learning",
		"signatureVersion": "v4",
		"targetPrefix": "AmazonML_20141212",
		"protocol": "json"
	},
	"operations": {
		"AddTags": {
			"input": {
				"type": "structure",
				"required": [
					"Tags",
					"ResourceId",
					"ResourceType"
				],
				"members": {
					"Tags": {
						"shape": "S2"
					},
					"ResourceId": {},
					"ResourceType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceId": {},
					"ResourceType": {}
				}
			}
		},
		"CreateBatchPrediction": {
			"input": {
				"type": "structure",
				"required": [
					"BatchPredictionId",
					"MLModelId",
					"BatchPredictionDataSourceId",
					"OutputUri"
				],
				"members": {
					"BatchPredictionId": {},
					"BatchPredictionName": {},
					"MLModelId": {},
					"BatchPredictionDataSourceId": {},
					"OutputUri": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BatchPredictionId": {}
				}
			}
		},
		"CreateDataSourceFromRDS": {
			"input": {
				"type": "structure",
				"required": [
					"DataSourceId",
					"RDSData",
					"RoleARN"
				],
				"members": {
					"DataSourceId": {},
					"DataSourceName": {},
					"RDSData": {
						"type": "structure",
						"required": [
							"DatabaseInformation",
							"SelectSqlQuery",
							"DatabaseCredentials",
							"S3StagingLocation",
							"ResourceRole",
							"ServiceRole",
							"SubnetId",
							"SecurityGroupIds"
						],
						"members": {
							"DatabaseInformation": {
								"shape": "Sf"
							},
							"SelectSqlQuery": {},
							"DatabaseCredentials": {
								"type": "structure",
								"required": [
									"Username",
									"Password"
								],
								"members": {
									"Username": {},
									"Password": {}
								}
							},
							"S3StagingLocation": {},
							"DataRearrangement": {},
							"DataSchema": {},
							"DataSchemaUri": {},
							"ResourceRole": {},
							"ServiceRole": {},
							"SubnetId": {},
							"SecurityGroupIds": {
								"type": "list",
								"member": {}
							}
						}
					},
					"RoleARN": {},
					"ComputeStatistics": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DataSourceId": {}
				}
			}
		},
		"CreateDataSourceFromRedshift": {
			"input": {
				"type": "structure",
				"required": [
					"DataSourceId",
					"DataSpec",
					"RoleARN"
				],
				"members": {
					"DataSourceId": {},
					"DataSourceName": {},
					"DataSpec": {
						"type": "structure",
						"required": [
							"DatabaseInformation",
							"SelectSqlQuery",
							"DatabaseCredentials",
							"S3StagingLocation"
						],
						"members": {
							"DatabaseInformation": {
								"shape": "Sy"
							},
							"SelectSqlQuery": {},
							"DatabaseCredentials": {
								"type": "structure",
								"required": [
									"Username",
									"Password"
								],
								"members": {
									"Username": {},
									"Password": {}
								}
							},
							"S3StagingLocation": {},
							"DataRearrangement": {},
							"DataSchema": {},
							"DataSchemaUri": {}
						}
					},
					"RoleARN": {},
					"ComputeStatistics": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DataSourceId": {}
				}
			}
		},
		"CreateDataSourceFromS3": {
			"input": {
				"type": "structure",
				"required": [
					"DataSourceId",
					"DataSpec"
				],
				"members": {
					"DataSourceId": {},
					"DataSourceName": {},
					"DataSpec": {
						"type": "structure",
						"required": [
							"DataLocationS3"
						],
						"members": {
							"DataLocationS3": {},
							"DataRearrangement": {},
							"DataSchema": {},
							"DataSchemaLocationS3": {}
						}
					},
					"ComputeStatistics": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DataSourceId": {}
				}
			}
		},
		"CreateEvaluation": {
			"input": {
				"type": "structure",
				"required": [
					"EvaluationId",
					"MLModelId",
					"EvaluationDataSourceId"
				],
				"members": {
					"EvaluationId": {},
					"EvaluationName": {},
					"MLModelId": {},
					"EvaluationDataSourceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EvaluationId": {}
				}
			}
		},
		"CreateMLModel": {
			"input": {
				"type": "structure",
				"required": [
					"MLModelId",
					"MLModelType",
					"TrainingDataSourceId"
				],
				"members": {
					"MLModelId": {},
					"MLModelName": {},
					"MLModelType": {},
					"Parameters": {
						"shape": "S1d"
					},
					"TrainingDataSourceId": {},
					"Recipe": {},
					"RecipeUri": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MLModelId": {}
				}
			}
		},
		"CreateRealtimeEndpoint": {
			"input": {
				"type": "structure",
				"required": [
					"MLModelId"
				],
				"members": {
					"MLModelId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MLModelId": {},
					"RealtimeEndpointInfo": {
						"shape": "S1j"
					}
				}
			}
		},
		"DeleteBatchPrediction": {
			"input": {
				"type": "structure",
				"required": [
					"BatchPredictionId"
				],
				"members": {
					"BatchPredictionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BatchPredictionId": {}
				}
			}
		},
		"DeleteDataSource": {
			"input": {
				"type": "structure",
				"required": [
					"DataSourceId"
				],
				"members": {
					"DataSourceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DataSourceId": {}
				}
			}
		},
		"DeleteEvaluation": {
			"input": {
				"type": "structure",
				"required": [
					"EvaluationId"
				],
				"members": {
					"EvaluationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EvaluationId": {}
				}
			}
		},
		"DeleteMLModel": {
			"input": {
				"type": "structure",
				"required": [
					"MLModelId"
				],
				"members": {
					"MLModelId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MLModelId": {}
				}
			}
		},
		"DeleteRealtimeEndpoint": {
			"input": {
				"type": "structure",
				"required": [
					"MLModelId"
				],
				"members": {
					"MLModelId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MLModelId": {},
					"RealtimeEndpointInfo": {
						"shape": "S1j"
					}
				}
			}
		},
		"DeleteTags": {
			"input": {
				"type": "structure",
				"required": [
					"TagKeys",
					"ResourceId",
					"ResourceType"
				],
				"members": {
					"TagKeys": {
						"type": "list",
						"member": {}
					},
					"ResourceId": {},
					"ResourceType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceId": {},
					"ResourceType": {}
				}
			}
		},
		"DescribeBatchPredictions": {
			"input": {
				"type": "structure",
				"members": {
					"FilterVariable": {},
					"EQ": {},
					"GT": {},
					"LT": {},
					"GE": {},
					"LE": {},
					"NE": {},
					"Prefix": {},
					"SortOrder": {},
					"NextToken": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Results": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"BatchPredictionId": {},
								"MLModelId": {},
								"BatchPredictionDataSourceId": {},
								"InputDataLocationS3": {},
								"CreatedByIamUser": {},
								"CreatedAt": {
									"type": "timestamp"
								},
								"LastUpdatedAt": {
									"type": "timestamp"
								},
								"Name": {},
								"Status": {},
								"OutputUri": {},
								"Message": {},
								"ComputeTime": {
									"type": "long"
								},
								"FinishedAt": {
									"type": "timestamp"
								},
								"StartedAt": {
									"type": "timestamp"
								},
								"TotalRecordCount": {
									"type": "long"
								},
								"InvalidRecordCount": {
									"type": "long"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeDataSources": {
			"input": {
				"type": "structure",
				"members": {
					"FilterVariable": {},
					"EQ": {},
					"GT": {},
					"LT": {},
					"GE": {},
					"LE": {},
					"NE": {},
					"Prefix": {},
					"SortOrder": {},
					"NextToken": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Results": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"DataSourceId": {},
								"DataLocationS3": {},
								"DataRearrangement": {},
								"CreatedByIamUser": {},
								"CreatedAt": {
									"type": "timestamp"
								},
								"LastUpdatedAt": {
									"type": "timestamp"
								},
								"DataSizeInBytes": {
									"type": "long"
								},
								"NumberOfFiles": {
									"type": "long"
								},
								"Name": {},
								"Status": {},
								"Message": {},
								"RedshiftMetadata": {
									"shape": "S2i"
								},
								"RDSMetadata": {
									"shape": "S2j"
								},
								"RoleARN": {},
								"ComputeStatistics": {
									"type": "boolean"
								},
								"ComputeTime": {
									"type": "long"
								},
								"FinishedAt": {
									"type": "timestamp"
								},
								"StartedAt": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeEvaluations": {
			"input": {
				"type": "structure",
				"members": {
					"FilterVariable": {},
					"EQ": {},
					"GT": {},
					"LT": {},
					"GE": {},
					"LE": {},
					"NE": {},
					"Prefix": {},
					"SortOrder": {},
					"NextToken": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Results": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EvaluationId": {},
								"MLModelId": {},
								"EvaluationDataSourceId": {},
								"InputDataLocationS3": {},
								"CreatedByIamUser": {},
								"CreatedAt": {
									"type": "timestamp"
								},
								"LastUpdatedAt": {
									"type": "timestamp"
								},
								"Name": {},
								"Status": {},
								"PerformanceMetrics": {
									"shape": "S2q"
								},
								"Message": {},
								"ComputeTime": {
									"type": "long"
								},
								"FinishedAt": {
									"type": "timestamp"
								},
								"StartedAt": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMLModels": {
			"input": {
				"type": "structure",
				"members": {
					"FilterVariable": {},
					"EQ": {},
					"GT": {},
					"LT": {},
					"GE": {},
					"LE": {},
					"NE": {},
					"Prefix": {},
					"SortOrder": {},
					"NextToken": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Results": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"MLModelId": {},
								"TrainingDataSourceId": {},
								"CreatedByIamUser": {},
								"CreatedAt": {
									"type": "timestamp"
								},
								"LastUpdatedAt": {
									"type": "timestamp"
								},
								"Name": {},
								"Status": {},
								"SizeInBytes": {
									"type": "long"
								},
								"EndpointInfo": {
									"shape": "S1j"
								},
								"TrainingParameters": {
									"shape": "S1d"
								},
								"InputDataLocationS3": {},
								"Algorithm": {},
								"MLModelType": {},
								"ScoreThreshold": {
									"type": "float"
								},
								"ScoreThresholdLastUpdatedAt": {
									"type": "timestamp"
								},
								"Message": {},
								"ComputeTime": {
									"type": "long"
								},
								"FinishedAt": {
									"type": "timestamp"
								},
								"StartedAt": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"ResourceType"
				],
				"members": {
					"ResourceId": {},
					"ResourceType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceId": {},
					"ResourceType": {},
					"Tags": {
						"shape": "S2"
					}
				}
			}
		},
		"GetBatchPrediction": {
			"input": {
				"type": "structure",
				"required": [
					"BatchPredictionId"
				],
				"members": {
					"BatchPredictionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BatchPredictionId": {},
					"MLModelId": {},
					"BatchPredictionDataSourceId": {},
					"InputDataLocationS3": {},
					"CreatedByIamUser": {},
					"CreatedAt": {
						"type": "timestamp"
					},
					"LastUpdatedAt": {
						"type": "timestamp"
					},
					"Name": {},
					"Status": {},
					"OutputUri": {},
					"LogUri": {},
					"Message": {},
					"ComputeTime": {
						"type": "long"
					},
					"FinishedAt": {
						"type": "timestamp"
					},
					"StartedAt": {
						"type": "timestamp"
					},
					"TotalRecordCount": {
						"type": "long"
					},
					"InvalidRecordCount": {
						"type": "long"
					}
				}
			}
		},
		"GetDataSource": {
			"input": {
				"type": "structure",
				"required": [
					"DataSourceId"
				],
				"members": {
					"DataSourceId": {},
					"Verbose": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DataSourceId": {},
					"DataLocationS3": {},
					"DataRearrangement": {},
					"CreatedByIamUser": {},
					"CreatedAt": {
						"type": "timestamp"
					},
					"LastUpdatedAt": {
						"type": "timestamp"
					},
					"DataSizeInBytes": {
						"type": "long"
					},
					"NumberOfFiles": {
						"type": "long"
					},
					"Name": {},
					"Status": {},
					"LogUri": {},
					"Message": {},
					"RedshiftMetadata": {
						"shape": "S2i"
					},
					"RDSMetadata": {
						"shape": "S2j"
					},
					"RoleARN": {},
					"ComputeStatistics": {
						"type": "boolean"
					},
					"ComputeTime": {
						"type": "long"
					},
					"FinishedAt": {
						"type": "timestamp"
					},
					"StartedAt": {
						"type": "timestamp"
					},
					"DataSourceSchema": {}
				}
			}
		},
		"GetEvaluation": {
			"input": {
				"type": "structure",
				"required": [
					"EvaluationId"
				],
				"members": {
					"EvaluationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EvaluationId": {},
					"MLModelId": {},
					"EvaluationDataSourceId": {},
					"InputDataLocationS3": {},
					"CreatedByIamUser": {},
					"CreatedAt": {
						"type": "timestamp"
					},
					"LastUpdatedAt": {
						"type": "timestamp"
					},
					"Name": {},
					"Status": {},
					"PerformanceMetrics": {
						"shape": "S2q"
					},
					"LogUri": {},
					"Message": {},
					"ComputeTime": {
						"type": "long"
					},
					"FinishedAt": {
						"type": "timestamp"
					},
					"StartedAt": {
						"type": "timestamp"
					}
				}
			}
		},
		"GetMLModel": {
			"input": {
				"type": "structure",
				"required": [
					"MLModelId"
				],
				"members": {
					"MLModelId": {},
					"Verbose": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MLModelId": {},
					"TrainingDataSourceId": {},
					"CreatedByIamUser": {},
					"CreatedAt": {
						"type": "timestamp"
					},
					"LastUpdatedAt": {
						"type": "timestamp"
					},
					"Name": {},
					"Status": {},
					"SizeInBytes": {
						"type": "long"
					},
					"EndpointInfo": {
						"shape": "S1j"
					},
					"TrainingParameters": {
						"shape": "S1d"
					},
					"InputDataLocationS3": {},
					"MLModelType": {},
					"ScoreThreshold": {
						"type": "float"
					},
					"ScoreThresholdLastUpdatedAt": {
						"type": "timestamp"
					},
					"LogUri": {},
					"Message": {},
					"ComputeTime": {
						"type": "long"
					},
					"FinishedAt": {
						"type": "timestamp"
					},
					"StartedAt": {
						"type": "timestamp"
					},
					"Recipe": {},
					"Schema": {}
				}
			}
		},
		"Predict": {
			"input": {
				"type": "structure",
				"required": [
					"MLModelId",
					"Record",
					"PredictEndpoint"
				],
				"members": {
					"MLModelId": {},
					"Record": {
						"type": "map",
						"key": {},
						"value": {}
					},
					"PredictEndpoint": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Prediction": {
						"type": "structure",
						"members": {
							"predictedLabel": {},
							"predictedValue": {
								"type": "float"
							},
							"predictedScores": {
								"type": "map",
								"key": {},
								"value": {
									"type": "float"
								}
							},
							"details": {
								"type": "map",
								"key": {},
								"value": {}
							}
						}
					}
				}
			}
		},
		"UpdateBatchPrediction": {
			"input": {
				"type": "structure",
				"required": [
					"BatchPredictionId",
					"BatchPredictionName"
				],
				"members": {
					"BatchPredictionId": {},
					"BatchPredictionName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BatchPredictionId": {}
				}
			}
		},
		"UpdateDataSource": {
			"input": {
				"type": "structure",
				"required": [
					"DataSourceId",
					"DataSourceName"
				],
				"members": {
					"DataSourceId": {},
					"DataSourceName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DataSourceId": {}
				}
			}
		},
		"UpdateEvaluation": {
			"input": {
				"type": "structure",
				"required": [
					"EvaluationId",
					"EvaluationName"
				],
				"members": {
					"EvaluationId": {},
					"EvaluationName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EvaluationId": {}
				}
			}
		},
		"UpdateMLModel": {
			"input": {
				"type": "structure",
				"required": [
					"MLModelId"
				],
				"members": {
					"MLModelId": {},
					"MLModelName": {},
					"ScoreThreshold": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MLModelId": {}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Sf": {
			"type": "structure",
			"required": [
				"InstanceIdentifier",
				"DatabaseName"
			],
			"members": {
				"InstanceIdentifier": {},
				"DatabaseName": {}
			}
		},
		"Sy": {
			"type": "structure",
			"required": [
				"DatabaseName",
				"ClusterIdentifier"
			],
			"members": {
				"DatabaseName": {},
				"ClusterIdentifier": {}
			}
		},
		"S1d": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1j": {
			"type": "structure",
			"members": {
				"PeakRequestsPerSecond": {
					"type": "integer"
				},
				"CreatedAt": {
					"type": "timestamp"
				},
				"EndpointUrl": {},
				"EndpointStatus": {}
			}
		},
		"S2i": {
			"type": "structure",
			"members": {
				"RedshiftDatabase": {
					"shape": "Sy"
				},
				"DatabaseUserName": {},
				"SelectSqlQuery": {}
			}
		},
		"S2j": {
			"type": "structure",
			"members": {
				"Database": {
					"shape": "Sf"
				},
				"DatabaseUserName": {},
				"SelectSqlQuery": {},
				"ResourceRole": {},
				"ServiceRole": {},
				"DataPipelineId": {}
			}
		},
		"S2q": {
			"type": "structure",
			"members": {
				"Properties": {
					"type": "map",
					"key": {},
					"value": {}
				}
			}
		}
	},
	"examples": {}
};

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeBatchPredictions": {
			"limit_key": "Limit",
			"output_token": "NextToken",
			"input_token": "NextToken",
			"result_key": "Results"
		},
		"DescribeDataSources": {
			"limit_key": "Limit",
			"output_token": "NextToken",
			"input_token": "NextToken",
			"result_key": "Results"
		},
		"DescribeEvaluations": {
			"limit_key": "Limit",
			"output_token": "NextToken",
			"input_token": "NextToken",
			"result_key": "Results"
		},
		"DescribeMLModels": {
			"limit_key": "Limit",
			"output_token": "NextToken",
			"input_token": "NextToken",
			"result_key": "Results"
		}
	}
};

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"DataSourceAvailable": {
			"delay": 30,
			"operation": "DescribeDataSources",
			"maxAttempts": 60,
			"acceptors": [
				{
					"expected": "COMPLETED",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Results[].Status"
				},
				{
					"expected": "FAILED",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Results[].Status"
				}
			]
		},
		"MLModelAvailable": {
			"delay": 30,
			"operation": "DescribeMLModels",
			"maxAttempts": 60,
			"acceptors": [
				{
					"expected": "COMPLETED",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Results[].Status"
				},
				{
					"expected": "FAILED",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Results[].Status"
				}
			]
		},
		"EvaluationAvailable": {
			"delay": 30,
			"operation": "DescribeEvaluations",
			"maxAttempts": 60,
			"acceptors": [
				{
					"expected": "COMPLETED",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Results[].Status"
				},
				{
					"expected": "FAILED",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Results[].Status"
				}
			]
		},
		"BatchPredictionAvailable": {
			"delay": 30,
			"operation": "DescribeBatchPredictions",
			"maxAttempts": 60,
			"acceptors": [
				{
					"expected": "COMPLETED",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Results[].Status"
				},
				{
					"expected": "FAILED",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Results[].Status"
				}
			]
		}
	}
};

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['marketplacecommerceanalytics'] = {};
AWS.MarketplaceCommerceAnalytics = Service.defineService('marketplacecommerceanalytics', ['2015-07-01']);
Object.defineProperty(apiLoader.services['marketplacecommerceanalytics'], '2015-07-01', {
  get: function get() {
    var model = __webpack_require__(1662);
    model.paginators = __webpack_require__(1663).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MarketplaceCommerceAnalytics;


/***/ }),
/* 1662 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-07-01",
		"endpointPrefix": "marketplacecommerceanalytics",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Marketplace Commerce Analytics",
		"signatureVersion": "v4",
		"signingName": "marketplacecommerceanalytics",
		"targetPrefix": "MarketplaceCommerceAnalytics20150701",
		"uid": "marketplacecommerceanalytics-2015-07-01"
	},
	"operations": {
		"GenerateDataSet": {
			"input": {
				"type": "structure",
				"required": [
					"dataSetType",
					"dataSetPublicationDate",
					"roleNameArn",
					"destinationS3BucketName",
					"snsTopicArn"
				],
				"members": {
					"dataSetType": {},
					"dataSetPublicationDate": {
						"type": "timestamp"
					},
					"roleNameArn": {},
					"destinationS3BucketName": {},
					"destinationS3Prefix": {},
					"snsTopicArn": {},
					"customerDefinedValues": {
						"shape": "S8"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"dataSetRequestId": {}
				}
			}
		},
		"StartSupportDataExport": {
			"input": {
				"type": "structure",
				"required": [
					"dataSetType",
					"fromDate",
					"roleNameArn",
					"destinationS3BucketName",
					"snsTopicArn"
				],
				"members": {
					"dataSetType": {},
					"fromDate": {
						"type": "timestamp"
					},
					"roleNameArn": {},
					"destinationS3BucketName": {},
					"destinationS3Prefix": {},
					"snsTopicArn": {},
					"customerDefinedValues": {
						"shape": "S8"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"dataSetRequestId": {}
				}
			}
		}
	},
	"shapes": {
		"S8": {
			"type": "map",
			"key": {},
			"value": {}
		}
	}
};

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['mturk'] = {};
AWS.MTurk = Service.defineService('mturk', ['2017-01-17']);
Object.defineProperty(apiLoader.services['mturk'], '2017-01-17', {
  get: function get() {
    var model = __webpack_require__(1665);
    model.paginators = __webpack_require__(1666).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MTurk;


/***/ }),
/* 1665 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2017-01-17",
		"endpointPrefix": "mturk-requester",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Amazon MTurk",
		"serviceFullName": "Amazon Mechanical Turk",
		"signatureVersion": "v4",
		"targetPrefix": "MTurkRequesterServiceV20170117",
		"uid": "mturk-requester-2017-01-17"
	},
	"operations": {
		"AcceptQualificationRequest": {
			"input": {
				"type": "structure",
				"required": [
					"QualificationRequestId"
				],
				"members": {
					"QualificationRequestId": {},
					"IntegerValue": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ApproveAssignment": {
			"input": {
				"type": "structure",
				"required": [
					"AssignmentId"
				],
				"members": {
					"AssignmentId": {},
					"RequesterFeedback": {},
					"OverrideRejection": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"AssociateQualificationWithWorker": {
			"input": {
				"type": "structure",
				"required": [
					"QualificationTypeId",
					"WorkerId"
				],
				"members": {
					"QualificationTypeId": {},
					"WorkerId": {},
					"IntegerValue": {
						"type": "integer"
					},
					"SendNotification": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateAdditionalAssignmentsForHIT": {
			"input": {
				"type": "structure",
				"required": [
					"HITId"
				],
				"members": {
					"HITId": {},
					"NumberOfAdditionalAssignments": {
						"type": "integer"
					},
					"UniqueRequestToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateHIT": {
			"input": {
				"type": "structure",
				"required": [
					"LifetimeInSeconds",
					"AssignmentDurationInSeconds",
					"Reward",
					"Title",
					"Description"
				],
				"members": {
					"MaxAssignments": {
						"type": "integer"
					},
					"AutoApprovalDelayInSeconds": {
						"type": "long"
					},
					"LifetimeInSeconds": {
						"type": "long"
					},
					"AssignmentDurationInSeconds": {
						"type": "long"
					},
					"Reward": {},
					"Title": {},
					"Keywords": {},
					"Description": {},
					"Question": {},
					"RequesterAnnotation": {},
					"QualificationRequirements": {
						"shape": "Si"
					},
					"UniqueRequestToken": {},
					"AssignmentReviewPolicy": {
						"shape": "Sp"
					},
					"HITReviewPolicy": {
						"shape": "Sp"
					},
					"HITLayoutId": {},
					"HITLayoutParameters": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HIT": {
						"shape": "Sy"
					}
				}
			}
		},
		"CreateHITType": {
			"input": {
				"type": "structure",
				"required": [
					"AssignmentDurationInSeconds",
					"Reward",
					"Title",
					"Description"
				],
				"members": {
					"AutoApprovalDelayInSeconds": {
						"type": "long"
					},
					"AssignmentDurationInSeconds": {
						"type": "long"
					},
					"Reward": {},
					"Title": {},
					"Keywords": {},
					"Description": {},
					"QualificationRequirements": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HITTypeId": {}
				}
			},
			"idempotent": true
		},
		"CreateHITWithHITType": {
			"input": {
				"type": "structure",
				"required": [
					"HITTypeId",
					"LifetimeInSeconds"
				],
				"members": {
					"HITTypeId": {},
					"MaxAssignments": {
						"type": "integer"
					},
					"LifetimeInSeconds": {
						"type": "long"
					},
					"Question": {},
					"RequesterAnnotation": {},
					"UniqueRequestToken": {},
					"AssignmentReviewPolicy": {
						"shape": "Sp"
					},
					"HITReviewPolicy": {
						"shape": "Sp"
					},
					"HITLayoutId": {},
					"HITLayoutParameters": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HIT": {
						"shape": "Sy"
					}
				}
			}
		},
		"CreateQualificationType": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Description",
					"QualificationTypeStatus"
				],
				"members": {
					"Name": {},
					"Keywords": {},
					"Description": {},
					"QualificationTypeStatus": {},
					"RetryDelayInSeconds": {
						"type": "long"
					},
					"Test": {},
					"AnswerKey": {},
					"TestDurationInSeconds": {
						"type": "long"
					},
					"AutoGranted": {
						"type": "boolean"
					},
					"AutoGrantedValue": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"QualificationType": {
						"shape": "S19"
					}
				}
			}
		},
		"CreateWorkerBlock": {
			"input": {
				"type": "structure",
				"required": [
					"WorkerId",
					"Reason"
				],
				"members": {
					"WorkerId": {},
					"Reason": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteHIT": {
			"input": {
				"type": "structure",
				"required": [
					"HITId"
				],
				"members": {
					"HITId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"DeleteQualificationType": {
			"input": {
				"type": "structure",
				"required": [
					"QualificationTypeId"
				],
				"members": {
					"QualificationTypeId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"DeleteWorkerBlock": {
			"input": {
				"type": "structure",
				"required": [
					"WorkerId"
				],
				"members": {
					"WorkerId": {},
					"Reason": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"DisassociateQualificationFromWorker": {
			"input": {
				"type": "structure",
				"required": [
					"WorkerId",
					"QualificationTypeId"
				],
				"members": {
					"WorkerId": {},
					"QualificationTypeId": {},
					"Reason": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"GetAccountBalance": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"AvailableBalance": {},
					"OnHoldBalance": {}
				}
			},
			"idempotent": true
		},
		"GetAssignment": {
			"input": {
				"type": "structure",
				"required": [
					"AssignmentId"
				],
				"members": {
					"AssignmentId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Assignment": {
						"shape": "S1o"
					},
					"HIT": {
						"shape": "Sy"
					}
				}
			},
			"idempotent": true
		},
		"GetFileUploadURL": {
			"input": {
				"type": "structure",
				"required": [
					"AssignmentId",
					"QuestionIdentifier"
				],
				"members": {
					"AssignmentId": {},
					"QuestionIdentifier": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FileUploadURL": {}
				}
			},
			"idempotent": true
		},
		"GetHIT": {
			"input": {
				"type": "structure",
				"required": [
					"HITId"
				],
				"members": {
					"HITId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HIT": {
						"shape": "Sy"
					}
				}
			},
			"idempotent": true
		},
		"GetQualificationScore": {
			"input": {
				"type": "structure",
				"required": [
					"QualificationTypeId",
					"WorkerId"
				],
				"members": {
					"QualificationTypeId": {},
					"WorkerId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Qualification": {
						"shape": "S1w"
					}
				}
			},
			"idempotent": true
		},
		"GetQualificationType": {
			"input": {
				"type": "structure",
				"required": [
					"QualificationTypeId"
				],
				"members": {
					"QualificationTypeId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"QualificationType": {
						"shape": "S19"
					}
				}
			},
			"idempotent": true
		},
		"ListAssignmentsForHIT": {
			"input": {
				"type": "structure",
				"required": [
					"HITId"
				],
				"members": {
					"HITId": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					},
					"AssignmentStatuses": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"NumResults": {
						"type": "integer"
					},
					"Assignments": {
						"type": "list",
						"member": {
							"shape": "S1o"
						}
					}
				}
			},
			"idempotent": true
		},
		"ListBonusPayments": {
			"input": {
				"type": "structure",
				"members": {
					"HITId": {},
					"AssignmentId": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NumResults": {
						"type": "integer"
					},
					"NextToken": {},
					"BonusPayments": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"WorkerId": {},
								"BonusAmount": {},
								"AssignmentId": {},
								"Reason": {},
								"GrantTime": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"idempotent": true
		},
		"ListHITs": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"NumResults": {
						"type": "integer"
					},
					"HITs": {
						"shape": "S2c"
					}
				}
			},
			"idempotent": true
		},
		"ListHITsForQualificationType": {
			"input": {
				"type": "structure",
				"required": [
					"QualificationTypeId"
				],
				"members": {
					"QualificationTypeId": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"NumResults": {
						"type": "integer"
					},
					"HITs": {
						"shape": "S2c"
					}
				}
			},
			"idempotent": true
		},
		"ListQualificationRequests": {
			"input": {
				"type": "structure",
				"members": {
					"QualificationTypeId": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NumResults": {
						"type": "integer"
					},
					"NextToken": {},
					"QualificationRequests": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"QualificationRequestId": {},
								"QualificationTypeId": {},
								"WorkerId": {},
								"Test": {},
								"Answer": {},
								"SubmitTime": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"idempotent": true
		},
		"ListQualificationTypes": {
			"input": {
				"type": "structure",
				"required": [
					"MustBeRequestable"
				],
				"members": {
					"Query": {},
					"MustBeRequestable": {
						"type": "boolean"
					},
					"MustBeOwnedByCaller": {
						"type": "boolean"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NumResults": {
						"type": "integer"
					},
					"NextToken": {},
					"QualificationTypes": {
						"type": "list",
						"member": {
							"shape": "S19"
						}
					}
				}
			},
			"idempotent": true
		},
		"ListReviewPolicyResultsForHIT": {
			"input": {
				"type": "structure",
				"required": [
					"HITId"
				],
				"members": {
					"HITId": {},
					"PolicyLevels": {
						"type": "list",
						"member": {}
					},
					"RetrieveActions": {
						"type": "boolean"
					},
					"RetrieveResults": {
						"type": "boolean"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"HITId": {},
					"AssignmentReviewPolicy": {
						"shape": "Sp"
					},
					"HITReviewPolicy": {
						"shape": "Sp"
					},
					"AssignmentReviewReport": {
						"shape": "S2q"
					},
					"HITReviewReport": {
						"shape": "S2q"
					},
					"NextToken": {}
				}
			},
			"idempotent": true
		},
		"ListReviewableHITs": {
			"input": {
				"type": "structure",
				"members": {
					"HITTypeId": {},
					"Status": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"NumResults": {
						"type": "integer"
					},
					"HITs": {
						"shape": "S2c"
					}
				}
			},
			"idempotent": true
		},
		"ListWorkerBlocks": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"NumResults": {
						"type": "integer"
					},
					"WorkerBlocks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"WorkerId": {},
								"Reason": {}
							}
						}
					}
				}
			},
			"idempotent": true
		},
		"ListWorkersWithQualificationType": {
			"input": {
				"type": "structure",
				"required": [
					"QualificationTypeId"
				],
				"members": {
					"QualificationTypeId": {},
					"Status": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"NumResults": {
						"type": "integer"
					},
					"Qualifications": {
						"type": "list",
						"member": {
							"shape": "S1w"
						}
					}
				}
			},
			"idempotent": true
		},
		"NotifyWorkers": {
			"input": {
				"type": "structure",
				"required": [
					"Subject",
					"MessageText",
					"WorkerIds"
				],
				"members": {
					"Subject": {},
					"MessageText": {},
					"WorkerIds": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NotifyWorkersFailureStatuses": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"NotifyWorkersFailureCode": {},
								"NotifyWorkersFailureMessage": {},
								"WorkerId": {}
							}
						}
					}
				}
			}
		},
		"RejectAssignment": {
			"input": {
				"type": "structure",
				"required": [
					"AssignmentId"
				],
				"members": {
					"AssignmentId": {},
					"RequesterFeedback": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"RejectQualificationRequest": {
			"input": {
				"type": "structure",
				"required": [
					"QualificationRequestId"
				],
				"members": {
					"QualificationRequestId": {},
					"Reason": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"SendBonus": {
			"input": {
				"type": "structure",
				"required": [
					"WorkerId",
					"BonusAmount",
					"AssignmentId"
				],
				"members": {
					"WorkerId": {},
					"BonusAmount": {},
					"AssignmentId": {},
					"Reason": {},
					"UniqueRequestToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"SendTestEventNotification": {
			"input": {
				"type": "structure",
				"required": [
					"Notification",
					"TestEventType"
				],
				"members": {
					"Notification": {
						"shape": "S3j"
					},
					"TestEventType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateExpirationForHIT": {
			"input": {
				"type": "structure",
				"required": [
					"HITId"
				],
				"members": {
					"HITId": {},
					"ExpireAt": {
						"type": "timestamp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"UpdateHITReviewStatus": {
			"input": {
				"type": "structure",
				"required": [
					"HITId"
				],
				"members": {
					"HITId": {},
					"Revert": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"UpdateHITTypeOfHIT": {
			"input": {
				"type": "structure",
				"required": [
					"HITId",
					"HITTypeId"
				],
				"members": {
					"HITId": {},
					"HITTypeId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"UpdateNotificationSettings": {
			"input": {
				"type": "structure",
				"required": [
					"HITTypeId"
				],
				"members": {
					"HITTypeId": {},
					"Notification": {
						"shape": "S3j"
					},
					"Active": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"idempotent": true
		},
		"UpdateQualificationType": {
			"input": {
				"type": "structure",
				"required": [
					"QualificationTypeId"
				],
				"members": {
					"QualificationTypeId": {},
					"Description": {},
					"QualificationTypeStatus": {},
					"Test": {},
					"AnswerKey": {},
					"TestDurationInSeconds": {
						"type": "long"
					},
					"RetryDelayInSeconds": {
						"type": "long"
					},
					"AutoGranted": {
						"type": "boolean"
					},
					"AutoGrantedValue": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"QualificationType": {
						"shape": "S19"
					}
				}
			}
		}
	},
	"shapes": {
		"Si": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"QualificationTypeId",
					"Comparator"
				],
				"members": {
					"QualificationTypeId": {},
					"Comparator": {},
					"IntegerValues": {
						"type": "list",
						"member": {
							"type": "integer"
						}
					},
					"LocaleValues": {
						"type": "list",
						"member": {
							"shape": "Sn"
						}
					},
					"RequiredToPreview": {
						"type": "boolean"
					}
				}
			}
		},
		"Sn": {
			"type": "structure",
			"required": [
				"Country"
			],
			"members": {
				"Country": {},
				"Subdivision": {}
			}
		},
		"Sp": {
			"type": "structure",
			"members": {
				"PolicyName": {},
				"Parameters": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Key": {},
							"Values": {
								"shape": "Ss"
							},
							"MapEntries": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Key": {},
										"Values": {
											"shape": "Ss"
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"Ss": {
			"type": "list",
			"member": {}
		},
		"Sv": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Name": {},
					"Value": {}
				}
			}
		},
		"Sy": {
			"type": "structure",
			"members": {
				"HITId": {},
				"HITTypeId": {},
				"HITGroupId": {},
				"HITLayoutId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"Title": {},
				"Description": {},
				"Question": {},
				"Keywords": {},
				"HITStatus": {},
				"MaxAssignments": {
					"type": "integer"
				},
				"Reward": {},
				"AutoApprovalDelayInSeconds": {
					"type": "long"
				},
				"Expiration": {
					"type": "timestamp"
				},
				"AssignmentDurationInSeconds": {
					"type": "long"
				},
				"RequesterAnnotation": {},
				"QualificationRequirements": {
					"shape": "Si"
				},
				"HITReviewStatus": {},
				"NumberOfAssignmentsPending": {
					"type": "integer"
				},
				"NumberOfAssignmentsAvailable": {
					"type": "integer"
				},
				"NumberOfAssignmentsCompleted": {
					"type": "integer"
				}
			}
		},
		"S19": {
			"type": "structure",
			"members": {
				"QualificationTypeId": {},
				"CreationTime": {
					"type": "timestamp"
				},
				"Name": {},
				"Description": {},
				"Keywords": {},
				"QualificationTypeStatus": {},
				"Test": {},
				"TestDurationInSeconds": {
					"type": "long"
				},
				"AnswerKey": {},
				"RetryDelayInSeconds": {
					"type": "long"
				},
				"IsRequestable": {
					"type": "boolean"
				},
				"AutoGranted": {
					"type": "boolean"
				},
				"AutoGrantedValue": {
					"type": "integer"
				}
			}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"AssignmentId": {},
				"WorkerId": {},
				"HITId": {},
				"AssignmentStatus": {},
				"AutoApprovalTime": {
					"type": "timestamp"
				},
				"AcceptTime": {
					"type": "timestamp"
				},
				"SubmitTime": {
					"type": "timestamp"
				},
				"ApprovalTime": {
					"type": "timestamp"
				},
				"RejectionTime": {
					"type": "timestamp"
				},
				"Deadline": {
					"type": "timestamp"
				},
				"Answer": {},
				"RequesterFeedback": {}
			}
		},
		"S1w": {
			"type": "structure",
			"members": {
				"QualificationTypeId": {},
				"WorkerId": {},
				"GrantTime": {
					"type": "timestamp"
				},
				"IntegerValue": {
					"type": "integer"
				},
				"LocaleValue": {
					"shape": "Sn"
				},
				"Status": {}
			}
		},
		"S2c": {
			"type": "list",
			"member": {
				"shape": "Sy"
			}
		},
		"S2q": {
			"type": "structure",
			"members": {
				"ReviewResults": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"ActionId": {},
							"SubjectId": {},
							"SubjectType": {},
							"QuestionId": {},
							"Key": {},
							"Value": {}
						}
					}
				},
				"ReviewActions": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"ActionId": {},
							"ActionName": {},
							"TargetId": {},
							"TargetType": {},
							"Status": {},
							"CompleteTime": {
								"type": "timestamp"
							},
							"Result": {},
							"ErrorCode": {}
						}
					}
				}
			}
		},
		"S3j": {
			"type": "structure",
			"required": [
				"Destination",
				"Transport"
			],
			"members": {
				"Destination": {},
				"Transport": {},
				"Version": {},
				"EventTypes": {
					"type": "list",
					"member": {}
				}
			}
		}
	}
};

/***/ }),
/* 1666 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListAssignmentsForHIT": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		},
		"ListBonusPayments": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		},
		"ListHITs": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		},
		"ListHITsForQualificationType": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		},
		"ListQualificationRequests": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		},
		"ListQualificationTypes": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		},
		"ListReviewPolicyResultsForHIT": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		},
		"ListReviewableHITs": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		},
		"ListWorkerBlocks": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		},
		"ListWorkersWithQualificationType": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"limit_key": "MaxResults"
		}
	}
};

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['mobileanalytics'] = {};
AWS.MobileAnalytics = Service.defineService('mobileanalytics', ['2014-06-05']);
Object.defineProperty(apiLoader.services['mobileanalytics'], '2014-06-05', {
  get: function get() {
    var model = __webpack_require__(1668);
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.MobileAnalytics;


/***/ }),
/* 1668 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-06-05",
		"endpointPrefix": "mobileanalytics",
		"serviceFullName": "Amazon Mobile Analytics",
		"signatureVersion": "v4",
		"protocol": "rest-json"
	},
	"operations": {
		"PutEvents": {
			"http": {
				"requestUri": "/2014-06-05/events",
				"responseCode": 202
			},
			"input": {
				"type": "structure",
				"required": [
					"events",
					"clientContext"
				],
				"members": {
					"events": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"eventType",
								"timestamp"
							],
							"members": {
								"eventType": {},
								"timestamp": {},
								"session": {
									"type": "structure",
									"members": {
										"id": {},
										"duration": {
											"type": "long"
										},
										"startTimestamp": {},
										"stopTimestamp": {}
									}
								},
								"version": {},
								"attributes": {
									"type": "map",
									"key": {},
									"value": {}
								},
								"metrics": {
									"type": "map",
									"key": {},
									"value": {
										"type": "double"
									}
								}
							}
						}
					},
					"clientContext": {
						"location": "header",
						"locationName": "x-amz-Client-Context"
					},
					"clientContextEncoding": {
						"location": "header",
						"locationName": "x-amz-Client-Context-Encoding"
					}
				}
			}
		}
	},
	"shapes": {}
};

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['opsworks'] = {};
AWS.OpsWorks = Service.defineService('opsworks', ['2013-02-18']);
Object.defineProperty(apiLoader.services['opsworks'], '2013-02-18', {
  get: function get() {
    var model = __webpack_require__(1670);
    model.paginators = __webpack_require__(1671).pagination;
    model.waiters = __webpack_require__(1672).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.OpsWorks;


/***/ }),
/* 1670 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2013-02-18",
		"endpointPrefix": "opsworks",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS OpsWorks",
		"signatureVersion": "v4",
		"targetPrefix": "OpsWorks_20130218",
		"uid": "opsworks-2013-02-18"
	},
	"operations": {
		"AssignInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"LayerIds"
				],
				"members": {
					"InstanceId": {},
					"LayerIds": {
						"shape": "S3"
					}
				}
			}
		},
		"AssignVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"VolumeId": {},
					"InstanceId": {}
				}
			}
		},
		"AssociateElasticIp": {
			"input": {
				"type": "structure",
				"required": [
					"ElasticIp"
				],
				"members": {
					"ElasticIp": {},
					"InstanceId": {}
				}
			}
		},
		"AttachElasticLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"ElasticLoadBalancerName",
					"LayerId"
				],
				"members": {
					"ElasticLoadBalancerName": {},
					"LayerId": {}
				}
			}
		},
		"CloneStack": {
			"input": {
				"type": "structure",
				"required": [
					"SourceStackId",
					"ServiceRoleArn"
				],
				"members": {
					"SourceStackId": {},
					"Name": {},
					"Region": {},
					"VpcId": {},
					"Attributes": {
						"shape": "S8"
					},
					"ServiceRoleArn": {},
					"DefaultInstanceProfileArn": {},
					"DefaultOs": {},
					"HostnameTheme": {},
					"DefaultAvailabilityZone": {},
					"DefaultSubnetId": {},
					"CustomJson": {},
					"ConfigurationManager": {
						"shape": "Sa"
					},
					"ChefConfiguration": {
						"shape": "Sb"
					},
					"UseCustomCookbooks": {
						"type": "boolean"
					},
					"UseOpsworksSecurityGroups": {
						"type": "boolean"
					},
					"CustomCookbooksSource": {
						"shape": "Sd"
					},
					"DefaultSshKeyName": {},
					"ClonePermissions": {
						"type": "boolean"
					},
					"CloneAppIds": {
						"shape": "S3"
					},
					"DefaultRootDeviceType": {},
					"AgentVersion": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StackId": {}
				}
			}
		},
		"CreateApp": {
			"input": {
				"type": "structure",
				"required": [
					"StackId",
					"Name",
					"Type"
				],
				"members": {
					"StackId": {},
					"Shortname": {},
					"Name": {},
					"Description": {},
					"DataSources": {
						"shape": "Si"
					},
					"Type": {},
					"AppSource": {
						"shape": "Sd"
					},
					"Domains": {
						"shape": "S3"
					},
					"EnableSsl": {
						"type": "boolean"
					},
					"SslConfiguration": {
						"shape": "Sl"
					},
					"Attributes": {
						"shape": "Sm"
					},
					"Environment": {
						"shape": "So"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AppId": {}
				}
			}
		},
		"CreateDeployment": {
			"input": {
				"type": "structure",
				"required": [
					"StackId",
					"Command"
				],
				"members": {
					"StackId": {},
					"AppId": {},
					"InstanceIds": {
						"shape": "S3"
					},
					"LayerIds": {
						"shape": "S3"
					},
					"Command": {
						"shape": "Ss"
					},
					"Comment": {},
					"CustomJson": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeploymentId": {}
				}
			}
		},
		"CreateInstance": {
			"input": {
				"type": "structure",
				"required": [
					"StackId",
					"LayerIds",
					"InstanceType"
				],
				"members": {
					"StackId": {},
					"LayerIds": {
						"shape": "S3"
					},
					"InstanceType": {},
					"AutoScalingType": {},
					"Hostname": {},
					"Os": {},
					"AmiId": {},
					"SshKeyName": {},
					"AvailabilityZone": {},
					"VirtualizationType": {},
					"SubnetId": {},
					"Architecture": {},
					"RootDeviceType": {},
					"BlockDeviceMappings": {
						"shape": "Sz"
					},
					"InstallUpdatesOnBoot": {
						"type": "boolean"
					},
					"EbsOptimized": {
						"type": "boolean"
					},
					"AgentVersion": {},
					"Tenancy": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceId": {}
				}
			}
		},
		"CreateLayer": {
			"input": {
				"type": "structure",
				"required": [
					"StackId",
					"Type",
					"Name",
					"Shortname"
				],
				"members": {
					"StackId": {},
					"Type": {},
					"Name": {},
					"Shortname": {},
					"Attributes": {
						"shape": "S17"
					},
					"CloudWatchLogsConfiguration": {
						"shape": "S19"
					},
					"CustomInstanceProfileArn": {},
					"CustomJson": {},
					"CustomSecurityGroupIds": {
						"shape": "S3"
					},
					"Packages": {
						"shape": "S3"
					},
					"VolumeConfigurations": {
						"shape": "S1f"
					},
					"EnableAutoHealing": {
						"type": "boolean"
					},
					"AutoAssignElasticIps": {
						"type": "boolean"
					},
					"AutoAssignPublicIps": {
						"type": "boolean"
					},
					"CustomRecipes": {
						"shape": "S1h"
					},
					"InstallUpdatesOnBoot": {
						"type": "boolean"
					},
					"UseEbsOptimizedInstances": {
						"type": "boolean"
					},
					"LifecycleEventConfiguration": {
						"shape": "S1i"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"LayerId": {}
				}
			}
		},
		"CreateStack": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Region",
					"ServiceRoleArn",
					"DefaultInstanceProfileArn"
				],
				"members": {
					"Name": {},
					"Region": {},
					"VpcId": {},
					"Attributes": {
						"shape": "S8"
					},
					"ServiceRoleArn": {},
					"DefaultInstanceProfileArn": {},
					"DefaultOs": {},
					"HostnameTheme": {},
					"DefaultAvailabilityZone": {},
					"DefaultSubnetId": {},
					"CustomJson": {},
					"ConfigurationManager": {
						"shape": "Sa"
					},
					"ChefConfiguration": {
						"shape": "Sb"
					},
					"UseCustomCookbooks": {
						"type": "boolean"
					},
					"UseOpsworksSecurityGroups": {
						"type": "boolean"
					},
					"CustomCookbooksSource": {
						"shape": "Sd"
					},
					"DefaultSshKeyName": {},
					"DefaultRootDeviceType": {},
					"AgentVersion": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StackId": {}
				}
			}
		},
		"CreateUserProfile": {
			"input": {
				"type": "structure",
				"required": [
					"IamUserArn"
				],
				"members": {
					"IamUserArn": {},
					"SshUsername": {},
					"SshPublicKey": {},
					"AllowSelfManagement": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IamUserArn": {}
				}
			}
		},
		"DeleteApp": {
			"input": {
				"type": "structure",
				"required": [
					"AppId"
				],
				"members": {
					"AppId": {}
				}
			}
		},
		"DeleteInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"DeleteElasticIp": {
						"type": "boolean"
					},
					"DeleteVolumes": {
						"type": "boolean"
					}
				}
			}
		},
		"DeleteLayer": {
			"input": {
				"type": "structure",
				"required": [
					"LayerId"
				],
				"members": {
					"LayerId": {}
				}
			}
		},
		"DeleteStack": {
			"input": {
				"type": "structure",
				"required": [
					"StackId"
				],
				"members": {
					"StackId": {}
				}
			}
		},
		"DeleteUserProfile": {
			"input": {
				"type": "structure",
				"required": [
					"IamUserArn"
				],
				"members": {
					"IamUserArn": {}
				}
			}
		},
		"DeregisterEcsCluster": {
			"input": {
				"type": "structure",
				"required": [
					"EcsClusterArn"
				],
				"members": {
					"EcsClusterArn": {}
				}
			}
		},
		"DeregisterElasticIp": {
			"input": {
				"type": "structure",
				"required": [
					"ElasticIp"
				],
				"members": {
					"ElasticIp": {}
				}
			}
		},
		"DeregisterInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {}
				}
			}
		},
		"DeregisterRdsDbInstance": {
			"input": {
				"type": "structure",
				"required": [
					"RdsDbInstanceArn"
				],
				"members": {
					"RdsDbInstanceArn": {}
				}
			}
		},
		"DeregisterVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"VolumeId": {}
				}
			}
		},
		"DescribeAgentVersions": {
			"input": {
				"type": "structure",
				"members": {
					"StackId": {},
					"ConfigurationManager": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AgentVersions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Version": {},
								"ConfigurationManager": {
									"shape": "Sa"
								}
							}
						}
					}
				}
			}
		},
		"DescribeApps": {
			"input": {
				"type": "structure",
				"members": {
					"StackId": {},
					"AppIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Apps": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AppId": {},
								"StackId": {},
								"Shortname": {},
								"Name": {},
								"Description": {},
								"DataSources": {
									"shape": "Si"
								},
								"Type": {},
								"AppSource": {
									"shape": "Sd"
								},
								"Domains": {
									"shape": "S3"
								},
								"EnableSsl": {
									"type": "boolean"
								},
								"SslConfiguration": {
									"shape": "Sl"
								},
								"Attributes": {
									"shape": "Sm"
								},
								"CreatedAt": {},
								"Environment": {
									"shape": "So"
								}
							}
						}
					}
				}
			}
		},
		"DescribeCommands": {
			"input": {
				"type": "structure",
				"members": {
					"DeploymentId": {},
					"InstanceId": {},
					"CommandIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Commands": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"CommandId": {},
								"InstanceId": {},
								"DeploymentId": {},
								"CreatedAt": {},
								"AcknowledgedAt": {},
								"CompletedAt": {},
								"Status": {},
								"ExitCode": {
									"type": "integer"
								},
								"LogUrl": {},
								"Type": {}
							}
						}
					}
				}
			}
		},
		"DescribeDeployments": {
			"input": {
				"type": "structure",
				"members": {
					"StackId": {},
					"AppId": {},
					"DeploymentIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Deployments": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"DeploymentId": {},
								"StackId": {},
								"AppId": {},
								"CreatedAt": {},
								"CompletedAt": {},
								"Duration": {
									"type": "integer"
								},
								"IamUserArn": {},
								"Comment": {},
								"Command": {
									"shape": "Ss"
								},
								"Status": {},
								"CustomJson": {},
								"InstanceIds": {
									"shape": "S3"
								}
							}
						}
					}
				}
			}
		},
		"DescribeEcsClusters": {
			"input": {
				"type": "structure",
				"members": {
					"EcsClusterArns": {
						"shape": "S3"
					},
					"StackId": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EcsClusters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EcsClusterArn": {},
								"EcsClusterName": {},
								"StackId": {},
								"RegisteredAt": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeElasticIps": {
			"input": {
				"type": "structure",
				"members": {
					"InstanceId": {},
					"StackId": {},
					"Ips": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ElasticIps": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Ip": {},
								"Name": {},
								"Domain": {},
								"Region": {},
								"InstanceId": {}
							}
						}
					}
				}
			}
		},
		"DescribeElasticLoadBalancers": {
			"input": {
				"type": "structure",
				"members": {
					"StackId": {},
					"LayerIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ElasticLoadBalancers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ElasticLoadBalancerName": {},
								"Region": {},
								"DnsName": {},
								"StackId": {},
								"LayerId": {},
								"VpcId": {},
								"AvailabilityZones": {
									"shape": "S3"
								},
								"SubnetIds": {
									"shape": "S3"
								},
								"Ec2InstanceIds": {
									"shape": "S3"
								}
							}
						}
					}
				}
			}
		},
		"DescribeInstances": {
			"input": {
				"type": "structure",
				"members": {
					"StackId": {},
					"LayerId": {},
					"InstanceIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Instances": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AgentVersion": {},
								"AmiId": {},
								"Architecture": {},
								"Arn": {},
								"AutoScalingType": {},
								"AvailabilityZone": {},
								"BlockDeviceMappings": {
									"shape": "Sz"
								},
								"CreatedAt": {},
								"EbsOptimized": {
									"type": "boolean"
								},
								"Ec2InstanceId": {},
								"EcsClusterArn": {},
								"EcsContainerInstanceArn": {},
								"ElasticIp": {},
								"Hostname": {},
								"InfrastructureClass": {},
								"InstallUpdatesOnBoot": {
									"type": "boolean"
								},
								"InstanceId": {},
								"InstanceProfileArn": {},
								"InstanceType": {},
								"LastServiceErrorId": {},
								"LayerIds": {
									"shape": "S3"
								},
								"Os": {},
								"Platform": {},
								"PrivateDns": {},
								"PrivateIp": {},
								"PublicDns": {},
								"PublicIp": {},
								"RegisteredBy": {},
								"ReportedAgentVersion": {},
								"ReportedOs": {
									"type": "structure",
									"members": {
										"Family": {},
										"Name": {},
										"Version": {}
									}
								},
								"RootDeviceType": {},
								"RootDeviceVolumeId": {},
								"SecurityGroupIds": {
									"shape": "S3"
								},
								"SshHostDsaKeyFingerprint": {},
								"SshHostRsaKeyFingerprint": {},
								"SshKeyName": {},
								"StackId": {},
								"Status": {},
								"SubnetId": {},
								"Tenancy": {},
								"VirtualizationType": {}
							}
						}
					}
				}
			}
		},
		"DescribeLayers": {
			"input": {
				"type": "structure",
				"members": {
					"StackId": {},
					"LayerIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Layers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Arn": {},
								"StackId": {},
								"LayerId": {},
								"Type": {},
								"Name": {},
								"Shortname": {},
								"Attributes": {
									"shape": "S17"
								},
								"CloudWatchLogsConfiguration": {
									"shape": "S19"
								},
								"CustomInstanceProfileArn": {},
								"CustomJson": {},
								"CustomSecurityGroupIds": {
									"shape": "S3"
								},
								"DefaultSecurityGroupNames": {
									"shape": "S3"
								},
								"Packages": {
									"shape": "S3"
								},
								"VolumeConfigurations": {
									"shape": "S1f"
								},
								"EnableAutoHealing": {
									"type": "boolean"
								},
								"AutoAssignElasticIps": {
									"type": "boolean"
								},
								"AutoAssignPublicIps": {
									"type": "boolean"
								},
								"DefaultRecipes": {
									"shape": "S1h"
								},
								"CustomRecipes": {
									"shape": "S1h"
								},
								"CreatedAt": {},
								"InstallUpdatesOnBoot": {
									"type": "boolean"
								},
								"UseEbsOptimizedInstances": {
									"type": "boolean"
								},
								"LifecycleEventConfiguration": {
									"shape": "S1i"
								}
							}
						}
					}
				}
			}
		},
		"DescribeLoadBasedAutoScaling": {
			"input": {
				"type": "structure",
				"required": [
					"LayerIds"
				],
				"members": {
					"LayerIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"LoadBasedAutoScalingConfigurations": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"LayerId": {},
								"Enable": {
									"type": "boolean"
								},
								"UpScaling": {
									"shape": "S36"
								},
								"DownScaling": {
									"shape": "S36"
								}
							}
						}
					}
				}
			}
		},
		"DescribeMyUserProfile": {
			"output": {
				"type": "structure",
				"members": {
					"UserProfile": {
						"type": "structure",
						"members": {
							"IamUserArn": {},
							"Name": {},
							"SshUsername": {},
							"SshPublicKey": {}
						}
					}
				}
			}
		},
		"DescribePermissions": {
			"input": {
				"type": "structure",
				"members": {
					"IamUserArn": {},
					"StackId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Permissions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"StackId": {},
								"IamUserArn": {},
								"AllowSsh": {
									"type": "boolean"
								},
								"AllowSudo": {
									"type": "boolean"
								},
								"Level": {}
							}
						}
					}
				}
			}
		},
		"DescribeRaidArrays": {
			"input": {
				"type": "structure",
				"members": {
					"InstanceId": {},
					"StackId": {},
					"RaidArrayIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RaidArrays": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"RaidArrayId": {},
								"InstanceId": {},
								"Name": {},
								"RaidLevel": {
									"type": "integer"
								},
								"NumberOfDisks": {
									"type": "integer"
								},
								"Size": {
									"type": "integer"
								},
								"Device": {},
								"MountPoint": {},
								"AvailabilityZone": {},
								"CreatedAt": {},
								"StackId": {},
								"VolumeType": {},
								"Iops": {
									"type": "integer"
								}
							}
						}
					}
				}
			}
		},
		"DescribeRdsDbInstances": {
			"input": {
				"type": "structure",
				"required": [
					"StackId"
				],
				"members": {
					"StackId": {},
					"RdsDbInstanceArns": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RdsDbInstances": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"RdsDbInstanceArn": {},
								"DbInstanceIdentifier": {},
								"DbUser": {},
								"DbPassword": {},
								"Region": {},
								"Address": {},
								"Engine": {},
								"StackId": {},
								"MissingOnRds": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		},
		"DescribeServiceErrors": {
			"input": {
				"type": "structure",
				"members": {
					"StackId": {},
					"InstanceId": {},
					"ServiceErrorIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ServiceErrors": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ServiceErrorId": {},
								"StackId": {},
								"InstanceId": {},
								"Type": {},
								"Message": {},
								"CreatedAt": {}
							}
						}
					}
				}
			}
		},
		"DescribeStackProvisioningParameters": {
			"input": {
				"type": "structure",
				"required": [
					"StackId"
				],
				"members": {
					"StackId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AgentInstallerUrl": {},
					"Parameters": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			}
		},
		"DescribeStackSummary": {
			"input": {
				"type": "structure",
				"required": [
					"StackId"
				],
				"members": {
					"StackId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StackSummary": {
						"type": "structure",
						"members": {
							"StackId": {},
							"Name": {},
							"Arn": {},
							"LayersCount": {
								"type": "integer"
							},
							"AppsCount": {
								"type": "integer"
							},
							"InstancesCount": {
								"type": "structure",
								"members": {
									"Assigning": {
										"type": "integer"
									},
									"Booting": {
										"type": "integer"
									},
									"ConnectionLost": {
										"type": "integer"
									},
									"Deregistering": {
										"type": "integer"
									},
									"Online": {
										"type": "integer"
									},
									"Pending": {
										"type": "integer"
									},
									"Rebooting": {
										"type": "integer"
									},
									"Registered": {
										"type": "integer"
									},
									"Registering": {
										"type": "integer"
									},
									"Requested": {
										"type": "integer"
									},
									"RunningSetup": {
										"type": "integer"
									},
									"SetupFailed": {
										"type": "integer"
									},
									"ShuttingDown": {
										"type": "integer"
									},
									"StartFailed": {
										"type": "integer"
									},
									"Stopped": {
										"type": "integer"
									},
									"Stopping": {
										"type": "integer"
									},
									"Terminated": {
										"type": "integer"
									},
									"Terminating": {
										"type": "integer"
									},
									"Unassigning": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeStacks": {
			"input": {
				"type": "structure",
				"members": {
					"StackIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Stacks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"StackId": {},
								"Name": {},
								"Arn": {},
								"Region": {},
								"VpcId": {},
								"Attributes": {
									"shape": "S8"
								},
								"ServiceRoleArn": {},
								"DefaultInstanceProfileArn": {},
								"DefaultOs": {},
								"HostnameTheme": {},
								"DefaultAvailabilityZone": {},
								"DefaultSubnetId": {},
								"CustomJson": {},
								"ConfigurationManager": {
									"shape": "Sa"
								},
								"ChefConfiguration": {
									"shape": "Sb"
								},
								"UseCustomCookbooks": {
									"type": "boolean"
								},
								"UseOpsworksSecurityGroups": {
									"type": "boolean"
								},
								"CustomCookbooksSource": {
									"shape": "Sd"
								},
								"DefaultSshKeyName": {},
								"CreatedAt": {},
								"DefaultRootDeviceType": {},
								"AgentVersion": {}
							}
						}
					}
				}
			}
		},
		"DescribeTimeBasedAutoScaling": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TimeBasedAutoScalingConfigurations": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"InstanceId": {},
								"AutoScalingSchedule": {
									"shape": "S46"
								}
							}
						}
					}
				}
			}
		},
		"DescribeUserProfiles": {
			"input": {
				"type": "structure",
				"members": {
					"IamUserArns": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserProfiles": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IamUserArn": {},
								"Name": {},
								"SshUsername": {},
								"SshPublicKey": {},
								"AllowSelfManagement": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		},
		"DescribeVolumes": {
			"input": {
				"type": "structure",
				"members": {
					"InstanceId": {},
					"StackId": {},
					"RaidArrayId": {},
					"VolumeIds": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Volumes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"VolumeId": {},
								"Ec2VolumeId": {},
								"Name": {},
								"RaidArrayId": {},
								"InstanceId": {},
								"Status": {},
								"Size": {
									"type": "integer"
								},
								"Device": {},
								"MountPoint": {},
								"Region": {},
								"AvailabilityZone": {},
								"VolumeType": {},
								"Iops": {
									"type": "integer"
								}
							}
						}
					}
				}
			}
		},
		"DetachElasticLoadBalancer": {
			"input": {
				"type": "structure",
				"required": [
					"ElasticLoadBalancerName",
					"LayerId"
				],
				"members": {
					"ElasticLoadBalancerName": {},
					"LayerId": {}
				}
			}
		},
		"DisassociateElasticIp": {
			"input": {
				"type": "structure",
				"required": [
					"ElasticIp"
				],
				"members": {
					"ElasticIp": {}
				}
			}
		},
		"GetHostnameSuggestion": {
			"input": {
				"type": "structure",
				"required": [
					"LayerId"
				],
				"members": {
					"LayerId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"LayerId": {},
					"Hostname": {}
				}
			}
		},
		"GrantAccess": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"ValidForInMinutes": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TemporaryCredential": {
						"type": "structure",
						"members": {
							"Username": {},
							"Password": {},
							"ValidForInMinutes": {
								"type": "integer"
							},
							"InstanceId": {}
						}
					}
				}
			}
		},
		"ListTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn"
				],
				"members": {
					"ResourceArn": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Tags": {
						"shape": "S4v"
					},
					"NextToken": {}
				}
			}
		},
		"RebootInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {}
				}
			}
		},
		"RegisterEcsCluster": {
			"input": {
				"type": "structure",
				"required": [
					"EcsClusterArn",
					"StackId"
				],
				"members": {
					"EcsClusterArn": {},
					"StackId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EcsClusterArn": {}
				}
			}
		},
		"RegisterElasticIp": {
			"input": {
				"type": "structure",
				"required": [
					"ElasticIp",
					"StackId"
				],
				"members": {
					"ElasticIp": {},
					"StackId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ElasticIp": {}
				}
			}
		},
		"RegisterInstance": {
			"input": {
				"type": "structure",
				"required": [
					"StackId"
				],
				"members": {
					"StackId": {},
					"Hostname": {},
					"PublicIp": {},
					"PrivateIp": {},
					"RsaPublicKey": {},
					"RsaPublicKeyFingerprint": {},
					"InstanceIdentity": {
						"type": "structure",
						"members": {
							"Document": {},
							"Signature": {}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceId": {}
				}
			}
		},
		"RegisterRdsDbInstance": {
			"input": {
				"type": "structure",
				"required": [
					"StackId",
					"RdsDbInstanceArn",
					"DbUser",
					"DbPassword"
				],
				"members": {
					"StackId": {},
					"RdsDbInstanceArn": {},
					"DbUser": {},
					"DbPassword": {}
				}
			}
		},
		"RegisterVolume": {
			"input": {
				"type": "structure",
				"required": [
					"StackId"
				],
				"members": {
					"Ec2VolumeId": {},
					"StackId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumeId": {}
				}
			}
		},
		"SetLoadBasedAutoScaling": {
			"input": {
				"type": "structure",
				"required": [
					"LayerId"
				],
				"members": {
					"LayerId": {},
					"Enable": {
						"type": "boolean"
					},
					"UpScaling": {
						"shape": "S36"
					},
					"DownScaling": {
						"shape": "S36"
					}
				}
			}
		},
		"SetPermission": {
			"input": {
				"type": "structure",
				"required": [
					"StackId",
					"IamUserArn"
				],
				"members": {
					"StackId": {},
					"IamUserArn": {},
					"AllowSsh": {
						"type": "boolean"
					},
					"AllowSudo": {
						"type": "boolean"
					},
					"Level": {}
				}
			}
		},
		"SetTimeBasedAutoScaling": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"AutoScalingSchedule": {
						"shape": "S46"
					}
				}
			}
		},
		"StartInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {}
				}
			}
		},
		"StartStack": {
			"input": {
				"type": "structure",
				"required": [
					"StackId"
				],
				"members": {
					"StackId": {}
				}
			}
		},
		"StopInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {}
				}
			}
		},
		"StopStack": {
			"input": {
				"type": "structure",
				"required": [
					"StackId"
				],
				"members": {
					"StackId": {}
				}
			}
		},
		"TagResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn",
					"Tags"
				],
				"members": {
					"ResourceArn": {},
					"Tags": {
						"shape": "S4v"
					}
				}
			}
		},
		"UnassignInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {}
				}
			}
		},
		"UnassignVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"VolumeId": {}
				}
			}
		},
		"UntagResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceArn",
					"TagKeys"
				],
				"members": {
					"ResourceArn": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"UpdateApp": {
			"input": {
				"type": "structure",
				"required": [
					"AppId"
				],
				"members": {
					"AppId": {},
					"Name": {},
					"Description": {},
					"DataSources": {
						"shape": "Si"
					},
					"Type": {},
					"AppSource": {
						"shape": "Sd"
					},
					"Domains": {
						"shape": "S3"
					},
					"EnableSsl": {
						"type": "boolean"
					},
					"SslConfiguration": {
						"shape": "Sl"
					},
					"Attributes": {
						"shape": "Sm"
					},
					"Environment": {
						"shape": "So"
					}
				}
			}
		},
		"UpdateElasticIp": {
			"input": {
				"type": "structure",
				"required": [
					"ElasticIp"
				],
				"members": {
					"ElasticIp": {},
					"Name": {}
				}
			}
		},
		"UpdateInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"LayerIds": {
						"shape": "S3"
					},
					"InstanceType": {},
					"AutoScalingType": {},
					"Hostname": {},
					"Os": {},
					"AmiId": {},
					"SshKeyName": {},
					"Architecture": {},
					"InstallUpdatesOnBoot": {
						"type": "boolean"
					},
					"EbsOptimized": {
						"type": "boolean"
					},
					"AgentVersion": {}
				}
			}
		},
		"UpdateLayer": {
			"input": {
				"type": "structure",
				"required": [
					"LayerId"
				],
				"members": {
					"LayerId": {},
					"Name": {},
					"Shortname": {},
					"Attributes": {
						"shape": "S17"
					},
					"CloudWatchLogsConfiguration": {
						"shape": "S19"
					},
					"CustomInstanceProfileArn": {},
					"CustomJson": {},
					"CustomSecurityGroupIds": {
						"shape": "S3"
					},
					"Packages": {
						"shape": "S3"
					},
					"VolumeConfigurations": {
						"shape": "S1f"
					},
					"EnableAutoHealing": {
						"type": "boolean"
					},
					"AutoAssignElasticIps": {
						"type": "boolean"
					},
					"AutoAssignPublicIps": {
						"type": "boolean"
					},
					"CustomRecipes": {
						"shape": "S1h"
					},
					"InstallUpdatesOnBoot": {
						"type": "boolean"
					},
					"UseEbsOptimizedInstances": {
						"type": "boolean"
					},
					"LifecycleEventConfiguration": {
						"shape": "S1i"
					}
				}
			}
		},
		"UpdateMyUserProfile": {
			"input": {
				"type": "structure",
				"members": {
					"SshPublicKey": {}
				}
			}
		},
		"UpdateRdsDbInstance": {
			"input": {
				"type": "structure",
				"required": [
					"RdsDbInstanceArn"
				],
				"members": {
					"RdsDbInstanceArn": {},
					"DbUser": {},
					"DbPassword": {}
				}
			}
		},
		"UpdateStack": {
			"input": {
				"type": "structure",
				"required": [
					"StackId"
				],
				"members": {
					"StackId": {},
					"Name": {},
					"Attributes": {
						"shape": "S8"
					},
					"ServiceRoleArn": {},
					"DefaultInstanceProfileArn": {},
					"DefaultOs": {},
					"HostnameTheme": {},
					"DefaultAvailabilityZone": {},
					"DefaultSubnetId": {},
					"CustomJson": {},
					"ConfigurationManager": {
						"shape": "Sa"
					},
					"ChefConfiguration": {
						"shape": "Sb"
					},
					"UseCustomCookbooks": {
						"type": "boolean"
					},
					"CustomCookbooksSource": {
						"shape": "Sd"
					},
					"DefaultSshKeyName": {},
					"DefaultRootDeviceType": {},
					"UseOpsworksSecurityGroups": {
						"type": "boolean"
					},
					"AgentVersion": {}
				}
			}
		},
		"UpdateUserProfile": {
			"input": {
				"type": "structure",
				"required": [
					"IamUserArn"
				],
				"members": {
					"IamUserArn": {},
					"SshUsername": {},
					"SshPublicKey": {},
					"AllowSelfManagement": {
						"type": "boolean"
					}
				}
			}
		},
		"UpdateVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeId"
				],
				"members": {
					"VolumeId": {},
					"Name": {},
					"MountPoint": {}
				}
			}
		}
	},
	"shapes": {
		"S3": {
			"type": "list",
			"member": {}
		},
		"S8": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"Sa": {
			"type": "structure",
			"members": {
				"Name": {},
				"Version": {}
			}
		},
		"Sb": {
			"type": "structure",
			"members": {
				"ManageBerkshelf": {
					"type": "boolean"
				},
				"BerkshelfVersion": {}
			}
		},
		"Sd": {
			"type": "structure",
			"members": {
				"Type": {},
				"Url": {},
				"Username": {},
				"Password": {},
				"SshKey": {},
				"Revision": {}
			}
		},
		"Si": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Type": {},
					"Arn": {},
					"DatabaseName": {}
				}
			}
		},
		"Sl": {
			"type": "structure",
			"required": [
				"Certificate",
				"PrivateKey"
			],
			"members": {
				"Certificate": {},
				"PrivateKey": {},
				"Chain": {}
			}
		},
		"Sm": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"So": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {},
					"Secure": {
						"type": "boolean"
					}
				}
			}
		},
		"Ss": {
			"type": "structure",
			"required": [
				"Name"
			],
			"members": {
				"Name": {},
				"Args": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S3"
					}
				}
			}
		},
		"Sz": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"DeviceName": {},
					"NoDevice": {},
					"VirtualName": {},
					"Ebs": {
						"type": "structure",
						"members": {
							"SnapshotId": {},
							"Iops": {
								"type": "integer"
							},
							"VolumeSize": {
								"type": "integer"
							},
							"VolumeType": {},
							"DeleteOnTermination": {
								"type": "boolean"
							}
						}
					}
				}
			}
		},
		"S17": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S19": {
			"type": "structure",
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"LogStreams": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"LogGroupName": {},
							"DatetimeFormat": {},
							"TimeZone": {},
							"File": {},
							"FileFingerprintLines": {},
							"MultiLineStartPattern": {},
							"InitialPosition": {},
							"Encoding": {},
							"BufferDuration": {
								"type": "integer"
							},
							"BatchCount": {
								"type": "integer"
							},
							"BatchSize": {
								"type": "integer"
							}
						}
					}
				}
			}
		},
		"S1f": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"MountPoint",
					"NumberOfDisks",
					"Size"
				],
				"members": {
					"MountPoint": {},
					"RaidLevel": {
						"type": "integer"
					},
					"NumberOfDisks": {
						"type": "integer"
					},
					"Size": {
						"type": "integer"
					},
					"VolumeType": {},
					"Iops": {
						"type": "integer"
					}
				}
			}
		},
		"S1h": {
			"type": "structure",
			"members": {
				"Setup": {
					"shape": "S3"
				},
				"Configure": {
					"shape": "S3"
				},
				"Deploy": {
					"shape": "S3"
				},
				"Undeploy": {
					"shape": "S3"
				},
				"Shutdown": {
					"shape": "S3"
				}
			}
		},
		"S1i": {
			"type": "structure",
			"members": {
				"Shutdown": {
					"type": "structure",
					"members": {
						"ExecutionTimeout": {
							"type": "integer"
						},
						"DelayUntilElbConnectionsDrained": {
							"type": "boolean"
						}
					}
				}
			}
		},
		"S36": {
			"type": "structure",
			"members": {
				"InstanceCount": {
					"type": "integer"
				},
				"ThresholdsWaitTime": {
					"type": "integer"
				},
				"IgnoreMetricsTime": {
					"type": "integer"
				},
				"CpuThreshold": {
					"type": "double"
				},
				"MemoryThreshold": {
					"type": "double"
				},
				"LoadThreshold": {
					"type": "double"
				},
				"Alarms": {
					"shape": "S3"
				}
			}
		},
		"S46": {
			"type": "structure",
			"members": {
				"Monday": {
					"shape": "S47"
				},
				"Tuesday": {
					"shape": "S47"
				},
				"Wednesday": {
					"shape": "S47"
				},
				"Thursday": {
					"shape": "S47"
				},
				"Friday": {
					"shape": "S47"
				},
				"Saturday": {
					"shape": "S47"
				},
				"Sunday": {
					"shape": "S47"
				}
			}
		},
		"S47": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S4v": {
			"type": "map",
			"key": {},
			"value": {}
		}
	}
};

/***/ }),
/* 1671 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeApps": {
			"result_key": "Apps"
		},
		"DescribeCommands": {
			"result_key": "Commands"
		},
		"DescribeDeployments": {
			"result_key": "Deployments"
		},
		"DescribeEcsClusters": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "EcsClusters"
		},
		"DescribeElasticIps": {
			"result_key": "ElasticIps"
		},
		"DescribeElasticLoadBalancers": {
			"result_key": "ElasticLoadBalancers"
		},
		"DescribeInstances": {
			"result_key": "Instances"
		},
		"DescribeLayers": {
			"result_key": "Layers"
		},
		"DescribeLoadBasedAutoScaling": {
			"result_key": "LoadBasedAutoScalingConfigurations"
		},
		"DescribePermissions": {
			"result_key": "Permissions"
		},
		"DescribeRaidArrays": {
			"result_key": "RaidArrays"
		},
		"DescribeServiceErrors": {
			"result_key": "ServiceErrors"
		},
		"DescribeStacks": {
			"result_key": "Stacks"
		},
		"DescribeTimeBasedAutoScaling": {
			"result_key": "TimeBasedAutoScalingConfigurations"
		},
		"DescribeUserProfiles": {
			"result_key": "UserProfiles"
		},
		"DescribeVolumes": {
			"result_key": "Volumes"
		}
	}
};

/***/ }),
/* 1672 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"AppExists": {
			"delay": 1,
			"operation": "DescribeApps",
			"maxAttempts": 40,
			"acceptors": [
				{
					"expected": 200,
					"matcher": "status",
					"state": "success"
				},
				{
					"matcher": "status",
					"expected": 400,
					"state": "failure"
				}
			]
		},
		"DeploymentSuccessful": {
			"delay": 15,
			"operation": "DescribeDeployments",
			"maxAttempts": 40,
			"description": "Wait until a deployment has completed successfully",
			"acceptors": [
				{
					"expected": "successful",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Deployments[].Status"
				},
				{
					"expected": "failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Deployments[].Status"
				}
			]
		},
		"InstanceOnline": {
			"delay": 15,
			"operation": "DescribeInstances",
			"maxAttempts": 40,
			"description": "Wait until OpsWorks instance is online.",
			"acceptors": [
				{
					"expected": "online",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Instances[].Status"
				},
				{
					"expected": "setup_failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "shutting_down",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "start_failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "stopped",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "stopping",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "terminating",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "terminated",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "stop_failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				}
			]
		},
		"InstanceRegistered": {
			"delay": 15,
			"operation": "DescribeInstances",
			"maxAttempts": 40,
			"description": "Wait until OpsWorks instance is registered.",
			"acceptors": [
				{
					"expected": "registered",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Instances[].Status"
				},
				{
					"expected": "setup_failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "shutting_down",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "stopped",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "stopping",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "terminating",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "terminated",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "stop_failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				}
			]
		},
		"InstanceStopped": {
			"delay": 15,
			"operation": "DescribeInstances",
			"maxAttempts": 40,
			"description": "Wait until OpsWorks instance is stopped.",
			"acceptors": [
				{
					"expected": "stopped",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Instances[].Status"
				},
				{
					"expected": "booting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "online",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "pending",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "rebooting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "requested",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "running_setup",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "setup_failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "start_failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "stop_failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				}
			]
		},
		"InstanceTerminated": {
			"delay": 15,
			"operation": "DescribeInstances",
			"maxAttempts": 40,
			"description": "Wait until OpsWorks instance is terminated.",
			"acceptors": [
				{
					"expected": "terminated",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Instances[].Status"
				},
				{
					"expected": "ResourceNotFoundException",
					"matcher": "error",
					"state": "success"
				},
				{
					"expected": "booting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "online",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "pending",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "rebooting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "requested",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "running_setup",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "setup_failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				},
				{
					"expected": "start_failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Instances[].Status"
				}
			]
		}
	}
};

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['polly'] = {};
AWS.Polly = Service.defineService('polly', ['2016-06-10']);
__webpack_require__(1674);
Object.defineProperty(apiLoader.services['polly'], '2016-06-10', {
  get: function get() {
    var model = __webpack_require__(1676);
    model.paginators = __webpack_require__(1677).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Polly;


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1675);

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var rest = AWS.Protocol.Rest;

/**
 * A presigner object can be used to generate presigned urls for the Polly service.
 */
AWS.Polly.Presigner = AWS.util.inherit({
    /**
     * Creates a presigner object with a set of configuration options.
     *
     * @option options params [map] An optional map of parameters to bind to every
     *   request sent by this service object.
     * @option options service [AWS.Polly] An optional pre-configured instance
     *  of the AWS.Polly service object to use for requests. The object may
     *  bound parameters used by the presigner.
     * @see AWS.Polly.constructor
     */
    constructor: function Signer(options) {
        options = options || {};
        this.options = options;
        this.service = options.service;
        this.bindServiceObject(options);
        this._operations = {};
    },

    /**
     * @api private
     */
    bindServiceObject: function bindServiceObject(options) {
        options = options || {};
        if (!this.service) {
            this.service = new AWS.Polly(options);
        } else {
            var config = AWS.util.copy(this.service.config);
            this.service = new this.service.constructor.__super__(config);
            this.service.config.params = AWS.util.merge(this.service.config.params || {}, options.params);
        }
    },

    /**
     * @api private
     */
    modifyInputMembers: function modifyInputMembers(input) {
        // make copies of the input so we don't overwrite the api
        // need to be careful to copy anything we access/modify
        var modifiedInput = AWS.util.copy(input);
        modifiedInput.members = AWS.util.copy(input.members);
        AWS.util.each(input.members, function(name, member) {
            modifiedInput.members[name] = AWS.util.copy(member);
            // update location and locationName
            if (!member.location || member.location === 'body') {
                modifiedInput.members[name].location = 'querystring';
                modifiedInput.members[name].locationName = name;
            }
        });
        return modifiedInput;
    },

    /**
     * @api private
     */
    convertPostToGet: function convertPostToGet(req) {
        // convert method
        req.httpRequest.method = 'GET';

        var operation = req.service.api.operations[req.operation];
        // get cached operation input first
        var input = this._operations[req.operation];
        if (!input) {
            // modify the original input
            this._operations[req.operation] = input = this.modifyInputMembers(operation.input);
        }

        var uri = rest.generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);

        req.httpRequest.path = uri;
        req.httpRequest.body = '';

        // don't need these headers on a GET request
        delete req.httpRequest.headers['Content-Length'];
        delete req.httpRequest.headers['Content-Type'];
    },

    /**
     * @overload getSynthesizeSpeechUrl(params = {}, [expires = 3600], [callback])
     *   Generate a presigned url for {AWS.Polly.synthesizeSpeech}.
     *   @note You must ensure that you have static or previously resolved
     *     credentials if you call this method synchronously (with no callback),
     *     otherwise it may not properly sign the request. If you cannot guarantee
     *     this (you are using an asynchronous credential provider, i.e., EC2
     *     IAM roles), you should always call this method with an asynchronous
     *     callback.
     *   @param params [map] parameters to pass to the operation. See the {AWS.Polly.synthesizeSpeech}
     *     operation for the expected operation parameters.
     *   @param expires [Integer] (3600) the number of seconds to expire the pre-signed URL operation in.
     *     Defaults to 1 hour.
     *   @return [string] if called synchronously (with no callback), returns the signed URL.
     *   @return [null] nothing is returned if a callback is provided.
     *   @callback callback function (err, url)
     *     If a callback is supplied, it is called when a signed URL has been generated.
     *     @param err [Error] the error object returned from the presigner.
     *     @param url [String] the signed URL.
     *   @see AWS.Polly.synthesizeSpeech
     */
    getSynthesizeSpeechUrl: function getSynthesizeSpeechUrl(params, expires, callback) {
        var self = this;
        var request = this.service.makeRequest('synthesizeSpeech', params);
        // remove existing build listeners
        request.removeAllListeners('build');
        request.on('build', function(req) {
            self.convertPostToGet(req);
        });
        return request.presign(expires, callback);
    }
});


/***/ }),
/* 1676 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-06-10",
		"endpointPrefix": "polly",
		"protocol": "rest-json",
		"serviceFullName": "Amazon Polly",
		"signatureVersion": "v4",
		"uid": "polly-2016-06-10"
	},
	"operations": {
		"DeleteLexicon": {
			"http": {
				"method": "DELETE",
				"requestUri": "/v1/lexicons/{LexiconName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {
						"shape": "S2",
						"location": "uri",
						"locationName": "LexiconName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeVoices": {
			"http": {
				"method": "GET",
				"requestUri": "/v1/voices",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"LanguageCode": {
						"location": "querystring",
						"locationName": "LanguageCode"
					},
					"NextToken": {
						"location": "querystring",
						"locationName": "NextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Voices": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Gender": {},
								"Id": {},
								"LanguageCode": {},
								"LanguageName": {},
								"Name": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"GetLexicon": {
			"http": {
				"method": "GET",
				"requestUri": "/v1/lexicons/{LexiconName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {
						"shape": "S2",
						"location": "uri",
						"locationName": "LexiconName"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Lexicon": {
						"type": "structure",
						"members": {
							"Content": {},
							"Name": {
								"shape": "S2"
							}
						}
					},
					"LexiconAttributes": {
						"shape": "Si"
					}
				}
			}
		},
		"ListLexicons": {
			"http": {
				"method": "GET",
				"requestUri": "/v1/lexicons",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {
						"location": "querystring",
						"locationName": "NextToken"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Lexicons": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {
									"shape": "S2"
								},
								"Attributes": {
									"shape": "Si"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"PutLexicon": {
			"http": {
				"method": "PUT",
				"requestUri": "/v1/lexicons/{LexiconName}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Content"
				],
				"members": {
					"Name": {
						"shape": "S2",
						"location": "uri",
						"locationName": "LexiconName"
					},
					"Content": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"SynthesizeSpeech": {
			"http": {
				"requestUri": "/v1/speech",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"OutputFormat",
					"Text",
					"VoiceId"
				],
				"members": {
					"LexiconNames": {
						"type": "list",
						"member": {
							"shape": "S2"
						}
					},
					"OutputFormat": {},
					"SampleRate": {},
					"SpeechMarkTypes": {
						"type": "list",
						"member": {}
					},
					"Text": {},
					"TextType": {},
					"VoiceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AudioStream": {
						"type": "blob",
						"streaming": true
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"RequestCharacters": {
						"location": "header",
						"locationName": "x-amzn-RequestCharacters",
						"type": "integer"
					}
				},
				"payload": "AudioStream"
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "string",
			"sensitive": true
		},
		"Si": {
			"type": "structure",
			"members": {
				"Alphabet": {},
				"LanguageCode": {},
				"LastModified": {
					"type": "timestamp"
				},
				"LexiconArn": {},
				"LexemesCount": {
					"type": "integer"
				},
				"Size": {
					"type": "integer"
				}
			}
		}
	}
};

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['rds'] = {};
AWS.RDS = Service.defineService('rds', ['2013-01-10', '2013-02-12', '2013-09-09', '2014-09-01', '2014-09-01*', '2014-10-31']);
__webpack_require__(1679);
Object.defineProperty(apiLoader.services['rds'], '2013-01-10', {
  get: function get() {
    var model = __webpack_require__(1681);
    model.paginators = __webpack_require__(1682).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2013-02-12', {
  get: function get() {
    var model = __webpack_require__(1683);
    model.paginators = __webpack_require__(1684).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2013-09-09', {
  get: function get() {
    var model = __webpack_require__(1685);
    model.paginators = __webpack_require__(1686).pagination;
    model.waiters = __webpack_require__(1687).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2014-09-01', {
  get: function get() {
    var model = __webpack_require__(1688);
    model.paginators = __webpack_require__(1689).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(apiLoader.services['rds'], '2014-10-31', {
  get: function get() {
    var model = __webpack_require__(1690);
    model.paginators = __webpack_require__(1691).pagination;
    model.waiters = __webpack_require__(1692).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.RDS;


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
__webpack_require__(1680);
 /**
  * @api private
  */
 var crossRegionOperations = ['copyDBSnapshot', 'createDBInstanceReadReplica', 'createDBCluster', 'copyDBClusterSnapshot'];

 AWS.util.update(AWS.RDS.prototype, {
   /**
    * @api private
    */
   setupRequestListeners: function setupRequestListeners(request) {
     if (crossRegionOperations.indexOf(request.operation) !== -1 &&
         request.params.SourceRegion) {
       request.params = AWS.util.copy(request.params);
       if (request.params.PreSignedUrl ||
           request.params.SourceRegion === this.config.region) {
         delete request.params.SourceRegion;
       } else {
         var doesParamValidation = !!this.config.paramValidation;
         // remove the validate parameters listener so we can re-add it after we build the URL
         if (doesParamValidation) {
           request.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
         }
         request.onAsync('validate', this.buildCrossRegionPresignedUrl);
         if (doesParamValidation) {
           request.addListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
         }
       }
     }
   },

   /**
    * @api private
    */
   buildCrossRegionPresignedUrl: function buildCrossRegionPresignedUrl(req, done) {
     var config = AWS.util.copy(req.service.config);
     config.region = req.params.SourceRegion;
     delete req.params.SourceRegion;
     delete config.endpoint;
     // relevant params for the operation will already be in req.params
     delete config.params;
     config.signatureVersion = 'v4';
     var destinationRegion = req.service.config.region;

     var svc = new req.service.constructor(config);
     var newReq = svc[req.operation](AWS.util.copy(req.params));
     newReq.on('build', function addDestinationRegionParam(request) {
       var httpRequest = request.httpRequest;
       httpRequest.params.DestinationRegion = destinationRegion;
       httpRequest.body = AWS.util.queryParamsToString(httpRequest.params);
     });
     newReq.presign(function(err, url) {
       if (err) done(err);
       else {
         req.params.PreSignedUrl = url;
         done();
       }
     });
   }
 });

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

/**
 * @api private
 */
var service = null;

/**
 * @api private
 */
var api = {
    signatureVersion: 'v4',
    signingName: 'rds-db'
};

/**
 * @api private
 */
var requiredAuthTokenOptions = {
    region: 'string',
    hostname: 'string',
    port: 'number',
    username: 'string'
};

/**
 * A signer object can be used to generate an auth token to a database.
 */
AWS.RDS.Signer = AWS.util.inherit({
    /**
     * Creates a signer object can be used to generate an auth token.
     *
     * @option options credentials [AWS.Credentials] the AWS credentials
     *   to sign requests with. Uses the default credential provider chain
     *   if not specified.
     * @option options hostname [String] the hostname of the database to connect to.
     * @option options port [Number] the port number the database is listening on.
     * @option options region [String] the region the database is located in.
     * @option options username [String] the username to login as.
     * @example Passing in options to constructor
     *   var signer = new AWS.RDS.Signer({
     *     credentials: new AWS.SharedIniFileCredentials({profile: 'default'}),
     *     region: 'us-east-1',
     *     hostname: 'db.us-east-1.rds.amazonaws.com',
     *     port: 8000,
     *     username: 'name'
     *   });
     */
    constructor: function Signer(options) {
        this.options = options || {};
    },

    /**
     * @api private
     * Strips the protocol from a url.
     */
    convertUrlToAuthToken: function convertUrlToAuthToken(url) {
        // we are always using https as the protocol
        var protocol = 'https://';
        if (url.indexOf(protocol) === 0) {
            return url.substring(protocol.length);
        }
    },

    /**
     * @overload getAuthToken(options = {}, [callback])
     *   Generate an auth token to a database.
     *   @note You must ensure that you have static or previously resolved
     *     credentials if you call this method synchronously (with no callback),
     *     otherwise it may not properly sign the request. If you cannot guarantee
     *     this (you are using an asynchronous credential provider, i.e., EC2
     *     IAM roles), you should always call this method with an asynchronous
     *     callback.
     *
     *   @param options [map] The fields to use when generating an auth token.
     *     Any options specified here will be merged on top of any options passed
     *     to AWS.RDS.Signer:
     *
     *     * **credentials** (AWS.Credentials) &mdash; the AWS credentials
     *         to sign requests with. Uses the default credential provider chain
     *         if not specified.
     *     * **hostname** (String) &mdash; the hostname of the database to connect to.
     *     * **port** (Number) &mdash; the port number the database is listening on.
     *     * **region** (String) &mdash; the region the database is located in.
     *     * **username** (String) &mdash; the username to login as.
     *   @return [String] if called synchronously (with no callback), returns the
     *     auth token.
     *   @return [null] nothing is returned if a callback is provided.
     *   @callback callback function (err, token)
     *     If a callback is supplied, it is called when an auth token has been generated.
     *     @param err [Error] the error object returned from the signer.
     *     @param token [String] the auth token.
     *
     *   @example Generating an auth token synchronously
     *     var signer = new AWS.RDS.Signer({
     *       // configure options
     *       region: 'us-east-1',
     *       username: 'default',
     *       hostname: 'db.us-east-1.amazonaws.com',
     *       port: 8000
     *     });
     *     var token = signer.getAuthToken({
     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
     *       username: 'test' // overriding username
     *     });
     *   @example Generating an auth token asynchronously
     *     var signer = new AWS.RDS.Signer({
     *       // configure options
     *       region: 'us-east-1',
     *       username: 'default',
     *       hostname: 'db.us-east-1.amazonaws.com',
     *       port: 8000
     *     });
     *     signer.getAuthToken({
     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
     *       username: 'test' // overriding username
     *     }, function(err, token) {
     *       if (err) {
     *         // handle error
     *       } else {
     *         // use token
     *       }
     *     });
     *
     */
    getAuthToken: function getAuthToken(options, callback) {
        if (typeof options === 'function' && callback === undefined) {
            callback = options;
            options = {};
        }
        var self = this;
        var hasCallback = typeof callback === 'function';
        // merge options with existing options
        options = AWS.util.merge(this.options, options);
        // validate options
        var optionsValidation = this.validateAuthTokenOptions(options);
        if (optionsValidation !== true) {
            if (hasCallback) {
                return callback(optionsValidation, null);
            }
            throw optionsValidation;
        }

        // 15 minutes
        var expires = 900;
        // create service to generate a request from
        var serviceOptions = {
            region: options.region,
            endpoint: new AWS.Endpoint(options.hostname + ':' + options.port),
            paramValidation: false,
            signatureVersion: 'v4'
        };
        if (options.credentials) {
            serviceOptions.credentials = options.credentials;
        }
        service = new AWS.Service(serviceOptions);
        // ensure the SDK is using sigv4 signing (config is not enough)
        service.api = api;

        var request = service.makeRequest();
        // add listeners to request to properly build auth token
        this.modifyRequestForAuthToken(request, options);

        if (hasCallback) {
            request.presign(expires, function(err, url) {
                if (url) {
                    url = self.convertUrlToAuthToken(url);
                }
                callback(err, url);
            });
        } else {
            var url = request.presign(expires);
            return this.convertUrlToAuthToken(url);
        }
    },

    /**
     * @api private
     * Modifies a request to allow the presigner to generate an auth token.
     */
    modifyRequestForAuthToken: function modifyRequestForAuthToken(request, options) {
        request.on('build', request.buildAsGet);
        var httpRequest = request.httpRequest;
        httpRequest.body = AWS.util.queryParamsToString({
            Action: 'connect',
            DBUser: options.username
        });
    },

    /**
     * @api private
     * Validates that the options passed in contain all the keys with values of the correct type that
     *   are needed to generate an auth token.
     */
    validateAuthTokenOptions: function validateAuthTokenOptions(options) {
        // iterate over all keys in options
        var message = '';
        options = options || {};
        for (var key in requiredAuthTokenOptions) {
            if (!Object.prototype.hasOwnProperty.call(requiredAuthTokenOptions, key)) {
                continue;
            }
            if (typeof options[key] !== requiredAuthTokenOptions[key]) {
                message += 'option \'' + key + '\' should have been type \'' + requiredAuthTokenOptions[key] + '\', was \'' + typeof options[key] + '\'.\n';
            }
        }
        if (message.length) {
            return AWS.util.error(new Error(), {
                code: 'InvalidParameter',
                message: message
            });
        }
        return true;
    }
});

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2013-01-10",
		"endpointPrefix": "rds",
		"protocol": "query",
		"serviceAbbreviation": "Amazon RDS",
		"serviceFullName": "Amazon Relational Database Service",
		"signatureVersion": "v4",
		"uid": "rds-2013-01-10",
		"xmlNamespace": "http://rds.amazonaws.com/doc/2013-01-10/"
	},
	"operations": {
		"AddSourceIdentifierToSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SourceIdentifier"
				],
				"members": {
					"SubscriptionName": {},
					"SourceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"AddTagsToResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"Tags"
				],
				"members": {
					"ResourceName": {},
					"Tags": {
						"shape": "S9"
					}
				}
			}
		},
		"AuthorizeDBSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupId": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		},
		"CopyDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBSnapshotIdentifier",
					"TargetDBSnapshotIdentifier"
				],
				"members": {
					"SourceDBSnapshotIdentifier": {},
					"TargetDBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "CopyDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sk"
					}
				}
			}
		},
		"CreateDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"AllocatedStorage",
					"DBInstanceClass",
					"Engine",
					"MasterUsername",
					"MasterUserPassword"
				],
				"members": {
					"DBName": {},
					"DBInstanceIdentifier": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"DBInstanceClass": {},
					"Engine": {},
					"MasterUsername": {},
					"MasterUserPassword": {},
					"DBSecurityGroups": {
						"shape": "Sp"
					},
					"VpcSecurityGroupIds": {
						"shape": "Sq"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"PreferredMaintenanceWindow": {},
					"DBParameterGroupName": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {},
					"Port": {
						"type": "integer"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"CharacterSetName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"CreateDBInstanceReadReplica": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"SourceDBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"SourceDBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"AvailabilityZone": {},
					"Port": {
						"type": "integer"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBInstanceReadReplicaResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"CreateDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName",
					"DBParameterGroupFamily",
					"Description"
				],
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBParameterGroupResult",
				"type": "structure",
				"members": {
					"DBParameterGroup": {
						"shape": "S1c"
					}
				}
			}
		},
		"CreateDBSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName",
					"DBSecurityGroupDescription"
				],
				"members": {
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSecurityGroupResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		},
		"CreateDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier",
					"DBInstanceIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sk"
					}
				}
			}
		},
		"CreateDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName",
					"DBSubnetGroupDescription",
					"SubnetIds"
				],
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S1i"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSubnetGroupResult",
				"type": "structure",
				"members": {
					"DBSubnetGroup": {
						"shape": "S11"
					}
				}
			}
		},
		"CreateEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SnsTopicArn"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"EventCategories": {
						"shape": "S6"
					},
					"SourceIds": {
						"shape": "S5"
					},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"CreateOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName",
					"EngineName",
					"MajorEngineVersion",
					"OptionGroupDescription"
				],
				"members": {
					"OptionGroupName": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"OptionGroupDescription": {}
				}
			},
			"output": {
				"resultWrapper": "CreateOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "S1o"
					}
				}
			}
		},
		"DeleteDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"SkipFinalSnapshot": {
						"type": "boolean"
					},
					"FinalDBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"DeleteDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {}
				}
			}
		},
		"DeleteDBSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {}
				}
			}
		},
		"DeleteDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sk"
					}
				}
			}
		},
		"DeleteDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName"
				],
				"members": {
					"DBSubnetGroupName": {}
				}
			}
		},
		"DeleteEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"DeleteOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName"
				],
				"members": {
					"OptionGroupName": {}
				}
			}
		},
		"DescribeDBEngineVersions": {
			"input": {
				"type": "structure",
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"DBParameterGroupFamily": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"DefaultOnly": {
						"type": "boolean"
					},
					"ListSupportedCharacterSets": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBEngineVersionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBEngineVersions": {
						"type": "list",
						"member": {
							"locationName": "DBEngineVersion",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"DBParameterGroupFamily": {},
								"DBEngineDescription": {},
								"DBEngineVersionDescription": {},
								"DefaultCharacterSet": {
									"shape": "S25"
								},
								"SupportedCharacterSets": {
									"type": "list",
									"member": {
										"shape": "S25",
										"locationName": "CharacterSet"
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeDBInstances": {
			"input": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBInstancesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBInstances": {
						"type": "list",
						"member": {
							"shape": "St",
							"locationName": "DBInstance"
						}
					}
				}
			}
		},
		"DescribeDBParameterGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBParameterGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"shape": "S1c",
							"locationName": "DBParameterGroup"
						}
					}
				}
			}
		},
		"DescribeDBParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {},
					"Source": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBParametersResult",
				"type": "structure",
				"members": {
					"Parameters": {
						"shape": "S2f"
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBSecurityGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBSecurityGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSecurityGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSecurityGroups": {
						"type": "list",
						"member": {
							"shape": "Sd",
							"locationName": "DBSecurityGroup"
						}
					}
				}
			}
		},
		"DescribeDBSnapshots": {
			"input": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {},
					"SnapshotType": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSnapshotsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSnapshots": {
						"type": "list",
						"member": {
							"shape": "Sk",
							"locationName": "DBSnapshot"
						}
					}
				}
			}
		},
		"DescribeDBSubnetGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSubnetGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSubnetGroups": {
						"type": "list",
						"member": {
							"shape": "S11",
							"locationName": "DBSubnetGroup"
						}
					}
				}
			}
		},
		"DescribeEngineDefaultParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupFamily"
				],
				"members": {
					"DBParameterGroupFamily": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEngineDefaultParametersResult",
				"type": "structure",
				"members": {
					"EngineDefaults": {
						"type": "structure",
						"members": {
							"DBParameterGroupFamily": {},
							"Marker": {},
							"Parameters": {
								"shape": "S2f"
							}
						},
						"wrapper": true
					}
				}
			}
		},
		"DescribeEventCategories": {
			"input": {
				"type": "structure",
				"members": {
					"SourceType": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventCategoriesResult",
				"type": "structure",
				"members": {
					"EventCategoriesMapList": {
						"type": "list",
						"member": {
							"locationName": "EventCategoriesMap",
							"type": "structure",
							"members": {
								"SourceType": {},
								"EventCategories": {
									"shape": "S6"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DescribeEventSubscriptions": {
			"input": {
				"type": "structure",
				"members": {
					"SubscriptionName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventSubscriptionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"EventSubscriptionsList": {
						"type": "list",
						"member": {
							"shape": "S4",
							"locationName": "EventSubscription"
						}
					}
				}
			}
		},
		"DescribeEvents": {
			"input": {
				"type": "structure",
				"members": {
					"SourceIdentifier": {},
					"SourceType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"EventCategories": {
						"shape": "S6"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Events": {
						"type": "list",
						"member": {
							"locationName": "Event",
							"type": "structure",
							"members": {
								"SourceIdentifier": {},
								"SourceType": {},
								"Message": {},
								"EventCategories": {
									"shape": "S6"
								},
								"Date": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeOptionGroupOptions": {
			"input": {
				"type": "structure",
				"required": [
					"EngineName"
				],
				"members": {
					"EngineName": {},
					"MajorEngineVersion": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOptionGroupOptionsResult",
				"type": "structure",
				"members": {
					"OptionGroupOptions": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupOption",
							"type": "structure",
							"members": {
								"Name": {},
								"Description": {},
								"EngineName": {},
								"MajorEngineVersion": {},
								"MinimumRequiredMinorEngineVersion": {},
								"PortRequired": {
									"type": "boolean"
								},
								"DefaultPort": {
									"type": "integer"
								},
								"OptionsDependedOn": {
									"type": "list",
									"member": {
										"locationName": "OptionName"
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeOptionGroups": {
			"input": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"Marker": {},
					"MaxRecords": {
						"type": "integer"
					},
					"EngineName": {},
					"MajorEngineVersion": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOptionGroupsResult",
				"type": "structure",
				"members": {
					"OptionGroupsList": {
						"type": "list",
						"member": {
							"shape": "S1o",
							"locationName": "OptionGroup"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeOrderableDBInstanceOptions": {
			"input": {
				"type": "structure",
				"required": [
					"Engine"
				],
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"DBInstanceClass": {},
					"LicenseModel": {},
					"Vpc": {
						"type": "boolean"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
				"type": "structure",
				"members": {
					"OrderableDBInstanceOptions": {
						"type": "list",
						"member": {
							"locationName": "OrderableDBInstanceOption",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"DBInstanceClass": {},
								"LicenseModel": {},
								"AvailabilityZones": {
									"type": "list",
									"member": {
										"shape": "S14",
										"locationName": "AvailabilityZone"
									}
								},
								"MultiAZCapable": {
									"type": "boolean"
								},
								"ReadReplicaCapable": {
									"type": "boolean"
								},
								"Vpc": {
									"type": "boolean"
								}
							},
							"wrapper": true
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeReservedDBInstances": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedDBInstancesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedDBInstances": {
						"type": "list",
						"member": {
							"shape": "S3m",
							"locationName": "ReservedDBInstance"
						}
					}
				}
			}
		},
		"DescribeReservedDBInstancesOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedDBInstancesOfferings": {
						"type": "list",
						"member": {
							"locationName": "ReservedDBInstancesOffering",
							"type": "structure",
							"members": {
								"ReservedDBInstancesOfferingId": {},
								"DBInstanceClass": {},
								"Duration": {
									"type": "integer"
								},
								"FixedPrice": {
									"type": "double"
								},
								"UsagePrice": {
									"type": "double"
								},
								"CurrencyCode": {},
								"ProductDescription": {},
								"OfferingType": {},
								"MultiAZ": {
									"type": "boolean"
								},
								"RecurringCharges": {
									"shape": "S3o"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"ListTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName"
				],
				"members": {
					"ResourceName": {}
				}
			},
			"output": {
				"resultWrapper": "ListTagsForResourceResult",
				"type": "structure",
				"members": {
					"TagList": {
						"shape": "S9"
					}
				}
			}
		},
		"ModifyDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"DBInstanceClass": {},
					"DBSecurityGroups": {
						"shape": "Sp"
					},
					"VpcSecurityGroupIds": {
						"shape": "Sq"
					},
					"ApplyImmediately": {
						"type": "boolean"
					},
					"MasterUserPassword": {},
					"DBParameterGroupName": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {},
					"PreferredMaintenanceWindow": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AllowMajorVersionUpgrade": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"NewDBInstanceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"ModifyDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName",
					"Parameters"
				],
				"members": {
					"DBParameterGroupName": {},
					"Parameters": {
						"shape": "S2f"
					}
				}
			},
			"output": {
				"shape": "S3z",
				"resultWrapper": "ModifyDBParameterGroupResult"
			}
		},
		"ModifyDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName",
					"SubnetIds"
				],
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S1i"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBSubnetGroupResult",
				"type": "structure",
				"members": {
					"DBSubnetGroup": {
						"shape": "S11"
					}
				}
			}
		},
		"ModifyEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"EventCategories": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"ModifyOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName"
				],
				"members": {
					"OptionGroupName": {},
					"OptionsToInclude": {
						"type": "list",
						"member": {
							"locationName": "OptionConfiguration",
							"type": "structure",
							"required": [
								"OptionName"
							],
							"members": {
								"OptionName": {},
								"Port": {
									"type": "integer"
								},
								"DBSecurityGroupMemberships": {
									"shape": "Sp"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "Sq"
								}
							}
						}
					},
					"OptionsToRemove": {
						"type": "list",
						"member": {}
					},
					"ApplyImmediately": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "S1o"
					}
				}
			}
		},
		"PromoteReadReplica": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {}
				}
			},
			"output": {
				"resultWrapper": "PromoteReadReplicaResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"PurchaseReservedDBInstancesOffering": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedDBInstancesOfferingId"
				],
				"members": {
					"ReservedDBInstancesOfferingId": {},
					"ReservedDBInstanceId": {},
					"DBInstanceCount": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
				"type": "structure",
				"members": {
					"ReservedDBInstance": {
						"shape": "S3m"
					}
				}
			}
		},
		"RebootDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"ForceFailover": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "RebootDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"RemoveSourceIdentifierFromSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SourceIdentifier"
				],
				"members": {
					"SubscriptionName": {},
					"SourceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"RemoveTagsFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"TagKeys"
				],
				"members": {
					"ResourceName": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"ResetDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {},
					"ResetAllParameters": {
						"type": "boolean"
					},
					"Parameters": {
						"shape": "S2f"
					}
				}
			},
			"output": {
				"shape": "S3z",
				"resultWrapper": "ResetDBParameterGroupResult"
			}
		},
		"RestoreDBInstanceFromDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {},
					"DBInstanceClass": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"DBName": {},
					"Engine": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"RestoreDBInstanceToPointInTime": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBInstanceIdentifier",
					"TargetDBInstanceIdentifier"
				],
				"members": {
					"SourceDBInstanceIdentifier": {},
					"TargetDBInstanceIdentifier": {},
					"RestoreTime": {
						"type": "timestamp"
					},
					"UseLatestRestorableTime": {
						"type": "boolean"
					},
					"DBInstanceClass": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"DBName": {},
					"Engine": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"RevokeDBSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupId": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "RevokeDBSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"Id": {},
				"CustomerAwsId": {},
				"CustSubscriptionId": {},
				"SnsTopicArn": {},
				"Status": {},
				"SubscriptionCreationTime": {},
				"SourceType": {},
				"SourceIdsList": {
					"shape": "S5"
				},
				"EventCategoriesList": {
					"shape": "S6"
				},
				"Enabled": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"S5": {
			"type": "list",
			"member": {
				"locationName": "SourceId"
			}
		},
		"S6": {
			"type": "list",
			"member": {
				"locationName": "EventCategory"
			}
		},
		"S9": {
			"type": "list",
			"member": {
				"locationName": "Tag",
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Sd": {
			"type": "structure",
			"members": {
				"OwnerId": {},
				"DBSecurityGroupName": {},
				"DBSecurityGroupDescription": {},
				"VpcId": {},
				"EC2SecurityGroups": {
					"type": "list",
					"member": {
						"locationName": "EC2SecurityGroup",
						"type": "structure",
						"members": {
							"Status": {},
							"EC2SecurityGroupName": {},
							"EC2SecurityGroupId": {},
							"EC2SecurityGroupOwnerId": {}
						}
					}
				},
				"IPRanges": {
					"type": "list",
					"member": {
						"locationName": "IPRange",
						"type": "structure",
						"members": {
							"Status": {},
							"CIDRIP": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"Sk": {
			"type": "structure",
			"members": {
				"DBSnapshotIdentifier": {},
				"DBInstanceIdentifier": {},
				"SnapshotCreateTime": {
					"type": "timestamp"
				},
				"Engine": {},
				"AllocatedStorage": {
					"type": "integer"
				},
				"Status": {},
				"Port": {
					"type": "integer"
				},
				"AvailabilityZone": {},
				"VpcId": {},
				"InstanceCreateTime": {
					"type": "timestamp"
				},
				"MasterUsername": {},
				"EngineVersion": {},
				"LicenseModel": {},
				"SnapshotType": {},
				"Iops": {
					"type": "integer"
				}
			},
			"wrapper": true
		},
		"Sp": {
			"type": "list",
			"member": {
				"locationName": "DBSecurityGroupName"
			}
		},
		"Sq": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupId"
			}
		},
		"St": {
			"type": "structure",
			"members": {
				"DBInstanceIdentifier": {},
				"DBInstanceClass": {},
				"Engine": {},
				"DBInstanceStatus": {},
				"MasterUsername": {},
				"DBName": {},
				"Endpoint": {
					"type": "structure",
					"members": {
						"Address": {},
						"Port": {
							"type": "integer"
						}
					}
				},
				"AllocatedStorage": {
					"type": "integer"
				},
				"InstanceCreateTime": {
					"type": "timestamp"
				},
				"PreferredBackupWindow": {},
				"BackupRetentionPeriod": {
					"type": "integer"
				},
				"DBSecurityGroups": {
					"shape": "Sv"
				},
				"VpcSecurityGroups": {
					"shape": "Sx"
				},
				"DBParameterGroups": {
					"type": "list",
					"member": {
						"locationName": "DBParameterGroup",
						"type": "structure",
						"members": {
							"DBParameterGroupName": {},
							"ParameterApplyStatus": {}
						}
					}
				},
				"AvailabilityZone": {},
				"DBSubnetGroup": {
					"shape": "S11"
				},
				"PreferredMaintenanceWindow": {},
				"PendingModifiedValues": {
					"type": "structure",
					"members": {
						"DBInstanceClass": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"MasterUserPassword": {},
						"Port": {
							"type": "integer"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"Iops": {
							"type": "integer"
						},
						"DBInstanceIdentifier": {}
					}
				},
				"LatestRestorableTime": {
					"type": "timestamp"
				},
				"MultiAZ": {
					"type": "boolean"
				},
				"EngineVersion": {},
				"AutoMinorVersionUpgrade": {
					"type": "boolean"
				},
				"ReadReplicaSourceDBInstanceIdentifier": {},
				"ReadReplicaDBInstanceIdentifiers": {
					"type": "list",
					"member": {
						"locationName": "ReadReplicaDBInstanceIdentifier"
					}
				},
				"LicenseModel": {},
				"Iops": {
					"type": "integer"
				},
				"OptionGroupMembership": {
					"type": "structure",
					"members": {
						"OptionGroupName": {},
						"Status": {}
					}
				},
				"CharacterSetName": {},
				"SecondaryAvailabilityZone": {},
				"PubliclyAccessible": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"Sv": {
			"type": "list",
			"member": {
				"locationName": "DBSecurityGroup",
				"type": "structure",
				"members": {
					"DBSecurityGroupName": {},
					"Status": {}
				}
			}
		},
		"Sx": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupMembership",
				"type": "structure",
				"members": {
					"VpcSecurityGroupId": {},
					"Status": {}
				}
			}
		},
		"S11": {
			"type": "structure",
			"members": {
				"DBSubnetGroupName": {},
				"DBSubnetGroupDescription": {},
				"VpcId": {},
				"SubnetGroupStatus": {},
				"Subnets": {
					"type": "list",
					"member": {
						"locationName": "Subnet",
						"type": "structure",
						"members": {
							"SubnetIdentifier": {},
							"SubnetAvailabilityZone": {
								"shape": "S14"
							},
							"SubnetStatus": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"S14": {
			"type": "structure",
			"members": {
				"Name": {},
				"ProvisionedIopsCapable": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"S1c": {
			"type": "structure",
			"members": {
				"DBParameterGroupName": {},
				"DBParameterGroupFamily": {},
				"Description": {}
			},
			"wrapper": true
		},
		"S1i": {
			"type": "list",
			"member": {
				"locationName": "SubnetIdentifier"
			}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"OptionGroupName": {},
				"OptionGroupDescription": {},
				"EngineName": {},
				"MajorEngineVersion": {},
				"Options": {
					"type": "list",
					"member": {
						"locationName": "Option",
						"type": "structure",
						"members": {
							"OptionName": {},
							"OptionDescription": {},
							"Port": {
								"type": "integer"
							},
							"DBSecurityGroupMemberships": {
								"shape": "Sv"
							},
							"VpcSecurityGroupMemberships": {
								"shape": "Sx"
							}
						}
					}
				},
				"AllowsVpcAndNonVpcInstanceMemberships": {
					"type": "boolean"
				},
				"VpcId": {}
			},
			"wrapper": true
		},
		"S25": {
			"type": "structure",
			"members": {
				"CharacterSetName": {},
				"CharacterSetDescription": {}
			}
		},
		"S2f": {
			"type": "list",
			"member": {
				"locationName": "Parameter",
				"type": "structure",
				"members": {
					"ParameterName": {},
					"ParameterValue": {},
					"Description": {},
					"Source": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"MinimumEngineVersion": {},
					"ApplyMethod": {}
				}
			}
		},
		"S3m": {
			"type": "structure",
			"members": {
				"ReservedDBInstanceId": {},
				"ReservedDBInstancesOfferingId": {},
				"DBInstanceClass": {},
				"StartTime": {
					"type": "timestamp"
				},
				"Duration": {
					"type": "integer"
				},
				"FixedPrice": {
					"type": "double"
				},
				"UsagePrice": {
					"type": "double"
				},
				"CurrencyCode": {},
				"DBInstanceCount": {
					"type": "integer"
				},
				"ProductDescription": {},
				"OfferingType": {},
				"MultiAZ": {
					"type": "boolean"
				},
				"State": {},
				"RecurringCharges": {
					"shape": "S3o"
				}
			},
			"wrapper": true
		},
		"S3o": {
			"type": "list",
			"member": {
				"locationName": "RecurringCharge",
				"type": "structure",
				"members": {
					"RecurringChargeAmount": {
						"type": "double"
					},
					"RecurringChargeFrequency": {}
				},
				"wrapper": true
			}
		},
		"S3z": {
			"type": "structure",
			"members": {
				"DBParameterGroupName": {}
			}
		}
	}
};

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeDBEngineVersions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBEngineVersions"
		},
		"DescribeDBInstances": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBInstances"
		},
		"DescribeDBParameterGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBParameterGroups"
		},
		"DescribeDBParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Parameters"
		},
		"DescribeDBSecurityGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSecurityGroups"
		},
		"DescribeDBSnapshots": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSnapshots"
		},
		"DescribeDBSubnetGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSubnetGroups"
		},
		"DescribeEngineDefaultParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "EngineDefaults.Marker",
			"result_key": "EngineDefaults.Parameters"
		},
		"DescribeEventSubscriptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "EventSubscriptionsList"
		},
		"DescribeEvents": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Events"
		},
		"DescribeOptionGroupOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OptionGroupOptions"
		},
		"DescribeOptionGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OptionGroupsList"
		},
		"DescribeOrderableDBInstanceOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OrderableDBInstanceOptions"
		},
		"DescribeReservedDBInstances": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedDBInstances"
		},
		"DescribeReservedDBInstancesOfferings": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedDBInstancesOfferings"
		},
		"ListTagsForResource": {
			"result_key": "TagList"
		}
	}
};

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2013-02-12",
		"endpointPrefix": "rds",
		"protocol": "query",
		"serviceAbbreviation": "Amazon RDS",
		"serviceFullName": "Amazon Relational Database Service",
		"signatureVersion": "v4",
		"uid": "rds-2013-02-12",
		"xmlNamespace": "http://rds.amazonaws.com/doc/2013-02-12/"
	},
	"operations": {
		"AddSourceIdentifierToSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SourceIdentifier"
				],
				"members": {
					"SubscriptionName": {},
					"SourceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"AddTagsToResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"Tags"
				],
				"members": {
					"ResourceName": {},
					"Tags": {
						"shape": "S9"
					}
				}
			}
		},
		"AuthorizeDBSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupId": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		},
		"CopyDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBSnapshotIdentifier",
					"TargetDBSnapshotIdentifier"
				],
				"members": {
					"SourceDBSnapshotIdentifier": {},
					"TargetDBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "CopyDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sk"
					}
				}
			}
		},
		"CreateDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"AllocatedStorage",
					"DBInstanceClass",
					"Engine",
					"MasterUsername",
					"MasterUserPassword"
				],
				"members": {
					"DBName": {},
					"DBInstanceIdentifier": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"DBInstanceClass": {},
					"Engine": {},
					"MasterUsername": {},
					"MasterUserPassword": {},
					"DBSecurityGroups": {
						"shape": "Sp"
					},
					"VpcSecurityGroupIds": {
						"shape": "Sq"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"PreferredMaintenanceWindow": {},
					"DBParameterGroupName": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {},
					"Port": {
						"type": "integer"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"CharacterSetName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"CreateDBInstanceReadReplica": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"SourceDBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"SourceDBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"AvailabilityZone": {},
					"Port": {
						"type": "integer"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBInstanceReadReplicaResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"CreateDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName",
					"DBParameterGroupFamily",
					"Description"
				],
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBParameterGroupResult",
				"type": "structure",
				"members": {
					"DBParameterGroup": {
						"shape": "S1d"
					}
				}
			}
		},
		"CreateDBSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName",
					"DBSecurityGroupDescription"
				],
				"members": {
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSecurityGroupResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		},
		"CreateDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier",
					"DBInstanceIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sk"
					}
				}
			}
		},
		"CreateDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName",
					"DBSubnetGroupDescription",
					"SubnetIds"
				],
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S1j"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSubnetGroupResult",
				"type": "structure",
				"members": {
					"DBSubnetGroup": {
						"shape": "S11"
					}
				}
			}
		},
		"CreateEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SnsTopicArn"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"EventCategories": {
						"shape": "S6"
					},
					"SourceIds": {
						"shape": "S5"
					},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"CreateOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName",
					"EngineName",
					"MajorEngineVersion",
					"OptionGroupDescription"
				],
				"members": {
					"OptionGroupName": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"OptionGroupDescription": {}
				}
			},
			"output": {
				"resultWrapper": "CreateOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "S1p"
					}
				}
			}
		},
		"DeleteDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"SkipFinalSnapshot": {
						"type": "boolean"
					},
					"FinalDBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"DeleteDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {}
				}
			}
		},
		"DeleteDBSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {}
				}
			}
		},
		"DeleteDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sk"
					}
				}
			}
		},
		"DeleteDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName"
				],
				"members": {
					"DBSubnetGroupName": {}
				}
			}
		},
		"DeleteEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"DeleteOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName"
				],
				"members": {
					"OptionGroupName": {}
				}
			}
		},
		"DescribeDBEngineVersions": {
			"input": {
				"type": "structure",
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"DBParameterGroupFamily": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"DefaultOnly": {
						"type": "boolean"
					},
					"ListSupportedCharacterSets": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBEngineVersionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBEngineVersions": {
						"type": "list",
						"member": {
							"locationName": "DBEngineVersion",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"DBParameterGroupFamily": {},
								"DBEngineDescription": {},
								"DBEngineVersionDescription": {},
								"DefaultCharacterSet": {
									"shape": "S28"
								},
								"SupportedCharacterSets": {
									"type": "list",
									"member": {
										"shape": "S28",
										"locationName": "CharacterSet"
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeDBInstances": {
			"input": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBInstancesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBInstances": {
						"type": "list",
						"member": {
							"shape": "St",
							"locationName": "DBInstance"
						}
					}
				}
			}
		},
		"DescribeDBLogFiles": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"FilenameContains": {},
					"FileLastWritten": {
						"type": "long"
					},
					"FileSize": {
						"type": "long"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBLogFilesResult",
				"type": "structure",
				"members": {
					"DescribeDBLogFiles": {
						"type": "list",
						"member": {
							"locationName": "DescribeDBLogFilesDetails",
							"type": "structure",
							"members": {
								"LogFileName": {},
								"LastWritten": {
									"type": "long"
								},
								"Size": {
									"type": "long"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBParameterGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBParameterGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"shape": "S1d",
							"locationName": "DBParameterGroup"
						}
					}
				}
			}
		},
		"DescribeDBParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {},
					"Source": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBParametersResult",
				"type": "structure",
				"members": {
					"Parameters": {
						"shape": "S2n"
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBSecurityGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBSecurityGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSecurityGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSecurityGroups": {
						"type": "list",
						"member": {
							"shape": "Sd",
							"locationName": "DBSecurityGroup"
						}
					}
				}
			}
		},
		"DescribeDBSnapshots": {
			"input": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {},
					"SnapshotType": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSnapshotsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSnapshots": {
						"type": "list",
						"member": {
							"shape": "Sk",
							"locationName": "DBSnapshot"
						}
					}
				}
			}
		},
		"DescribeDBSubnetGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSubnetGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSubnetGroups": {
						"type": "list",
						"member": {
							"shape": "S11",
							"locationName": "DBSubnetGroup"
						}
					}
				}
			}
		},
		"DescribeEngineDefaultParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupFamily"
				],
				"members": {
					"DBParameterGroupFamily": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEngineDefaultParametersResult",
				"type": "structure",
				"members": {
					"EngineDefaults": {
						"type": "structure",
						"members": {
							"DBParameterGroupFamily": {},
							"Marker": {},
							"Parameters": {
								"shape": "S2n"
							}
						},
						"wrapper": true
					}
				}
			}
		},
		"DescribeEventCategories": {
			"input": {
				"type": "structure",
				"members": {
					"SourceType": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventCategoriesResult",
				"type": "structure",
				"members": {
					"EventCategoriesMapList": {
						"type": "list",
						"member": {
							"locationName": "EventCategoriesMap",
							"type": "structure",
							"members": {
								"SourceType": {},
								"EventCategories": {
									"shape": "S6"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DescribeEventSubscriptions": {
			"input": {
				"type": "structure",
				"members": {
					"SubscriptionName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventSubscriptionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"EventSubscriptionsList": {
						"type": "list",
						"member": {
							"shape": "S4",
							"locationName": "EventSubscription"
						}
					}
				}
			}
		},
		"DescribeEvents": {
			"input": {
				"type": "structure",
				"members": {
					"SourceIdentifier": {},
					"SourceType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"EventCategories": {
						"shape": "S6"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Events": {
						"type": "list",
						"member": {
							"locationName": "Event",
							"type": "structure",
							"members": {
								"SourceIdentifier": {},
								"SourceType": {},
								"Message": {},
								"EventCategories": {
									"shape": "S6"
								},
								"Date": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeOptionGroupOptions": {
			"input": {
				"type": "structure",
				"required": [
					"EngineName"
				],
				"members": {
					"EngineName": {},
					"MajorEngineVersion": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOptionGroupOptionsResult",
				"type": "structure",
				"members": {
					"OptionGroupOptions": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupOption",
							"type": "structure",
							"members": {
								"Name": {},
								"Description": {},
								"EngineName": {},
								"MajorEngineVersion": {},
								"MinimumRequiredMinorEngineVersion": {},
								"PortRequired": {
									"type": "boolean"
								},
								"DefaultPort": {
									"type": "integer"
								},
								"OptionsDependedOn": {
									"type": "list",
									"member": {
										"locationName": "OptionName"
									}
								},
								"Persistent": {
									"type": "boolean"
								},
								"OptionGroupOptionSettings": {
									"type": "list",
									"member": {
										"locationName": "OptionGroupOptionSetting",
										"type": "structure",
										"members": {
											"SettingName": {},
											"SettingDescription": {},
											"DefaultValue": {},
											"ApplyType": {},
											"AllowedValues": {},
											"IsModifiable": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeOptionGroups": {
			"input": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"Marker": {},
					"MaxRecords": {
						"type": "integer"
					},
					"EngineName": {},
					"MajorEngineVersion": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOptionGroupsResult",
				"type": "structure",
				"members": {
					"OptionGroupsList": {
						"type": "list",
						"member": {
							"shape": "S1p",
							"locationName": "OptionGroup"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeOrderableDBInstanceOptions": {
			"input": {
				"type": "structure",
				"required": [
					"Engine"
				],
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"DBInstanceClass": {},
					"LicenseModel": {},
					"Vpc": {
						"type": "boolean"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
				"type": "structure",
				"members": {
					"OrderableDBInstanceOptions": {
						"type": "list",
						"member": {
							"locationName": "OrderableDBInstanceOption",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"DBInstanceClass": {},
								"LicenseModel": {},
								"AvailabilityZones": {
									"type": "list",
									"member": {
										"shape": "S14",
										"locationName": "AvailabilityZone"
									}
								},
								"MultiAZCapable": {
									"type": "boolean"
								},
								"ReadReplicaCapable": {
									"type": "boolean"
								},
								"Vpc": {
									"type": "boolean"
								}
							},
							"wrapper": true
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeReservedDBInstances": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedDBInstancesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedDBInstances": {
						"type": "list",
						"member": {
							"shape": "S3w",
							"locationName": "ReservedDBInstance"
						}
					}
				}
			}
		},
		"DescribeReservedDBInstancesOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedDBInstancesOfferings": {
						"type": "list",
						"member": {
							"locationName": "ReservedDBInstancesOffering",
							"type": "structure",
							"members": {
								"ReservedDBInstancesOfferingId": {},
								"DBInstanceClass": {},
								"Duration": {
									"type": "integer"
								},
								"FixedPrice": {
									"type": "double"
								},
								"UsagePrice": {
									"type": "double"
								},
								"CurrencyCode": {},
								"ProductDescription": {},
								"OfferingType": {},
								"MultiAZ": {
									"type": "boolean"
								},
								"RecurringCharges": {
									"shape": "S3y"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DownloadDBLogFilePortion": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"LogFileName"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"LogFileName": {},
					"Marker": {},
					"NumberOfLines": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DownloadDBLogFilePortionResult",
				"type": "structure",
				"members": {
					"LogFileData": {},
					"Marker": {},
					"AdditionalDataPending": {
						"type": "boolean"
					}
				}
			}
		},
		"ListTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName"
				],
				"members": {
					"ResourceName": {}
				}
			},
			"output": {
				"resultWrapper": "ListTagsForResourceResult",
				"type": "structure",
				"members": {
					"TagList": {
						"shape": "S9"
					}
				}
			}
		},
		"ModifyDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"DBInstanceClass": {},
					"DBSecurityGroups": {
						"shape": "Sp"
					},
					"VpcSecurityGroupIds": {
						"shape": "Sq"
					},
					"ApplyImmediately": {
						"type": "boolean"
					},
					"MasterUserPassword": {},
					"DBParameterGroupName": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {},
					"PreferredMaintenanceWindow": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AllowMajorVersionUpgrade": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"NewDBInstanceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"ModifyDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName",
					"Parameters"
				],
				"members": {
					"DBParameterGroupName": {},
					"Parameters": {
						"shape": "S2n"
					}
				}
			},
			"output": {
				"shape": "S4b",
				"resultWrapper": "ModifyDBParameterGroupResult"
			}
		},
		"ModifyDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName",
					"SubnetIds"
				],
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S1j"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBSubnetGroupResult",
				"type": "structure",
				"members": {
					"DBSubnetGroup": {
						"shape": "S11"
					}
				}
			}
		},
		"ModifyEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"EventCategories": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"ModifyOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName"
				],
				"members": {
					"OptionGroupName": {},
					"OptionsToInclude": {
						"type": "list",
						"member": {
							"locationName": "OptionConfiguration",
							"type": "structure",
							"required": [
								"OptionName"
							],
							"members": {
								"OptionName": {},
								"Port": {
									"type": "integer"
								},
								"DBSecurityGroupMemberships": {
									"shape": "Sp"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "Sq"
								},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "S1t",
										"locationName": "OptionSetting"
									}
								}
							}
						}
					},
					"OptionsToRemove": {
						"type": "list",
						"member": {}
					},
					"ApplyImmediately": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "S1p"
					}
				}
			}
		},
		"PromoteReadReplica": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {}
				}
			},
			"output": {
				"resultWrapper": "PromoteReadReplicaResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"PurchaseReservedDBInstancesOffering": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedDBInstancesOfferingId"
				],
				"members": {
					"ReservedDBInstancesOfferingId": {},
					"ReservedDBInstanceId": {},
					"DBInstanceCount": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
				"type": "structure",
				"members": {
					"ReservedDBInstance": {
						"shape": "S3w"
					}
				}
			}
		},
		"RebootDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"ForceFailover": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "RebootDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"RemoveSourceIdentifierFromSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SourceIdentifier"
				],
				"members": {
					"SubscriptionName": {},
					"SourceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"RemoveTagsFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"TagKeys"
				],
				"members": {
					"ResourceName": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"ResetDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {},
					"ResetAllParameters": {
						"type": "boolean"
					},
					"Parameters": {
						"shape": "S2n"
					}
				}
			},
			"output": {
				"shape": "S4b",
				"resultWrapper": "ResetDBParameterGroupResult"
			}
		},
		"RestoreDBInstanceFromDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {},
					"DBInstanceClass": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"DBName": {},
					"Engine": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"RestoreDBInstanceToPointInTime": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBInstanceIdentifier",
					"TargetDBInstanceIdentifier"
				],
				"members": {
					"SourceDBInstanceIdentifier": {},
					"TargetDBInstanceIdentifier": {},
					"RestoreTime": {
						"type": "timestamp"
					},
					"UseLatestRestorableTime": {
						"type": "boolean"
					},
					"DBInstanceClass": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"DBName": {},
					"Engine": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"RevokeDBSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupId": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "RevokeDBSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"CustomerAwsId": {},
				"CustSubscriptionId": {},
				"SnsTopicArn": {},
				"Status": {},
				"SubscriptionCreationTime": {},
				"SourceType": {},
				"SourceIdsList": {
					"shape": "S5"
				},
				"EventCategoriesList": {
					"shape": "S6"
				},
				"Enabled": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"S5": {
			"type": "list",
			"member": {
				"locationName": "SourceId"
			}
		},
		"S6": {
			"type": "list",
			"member": {
				"locationName": "EventCategory"
			}
		},
		"S9": {
			"type": "list",
			"member": {
				"locationName": "Tag",
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Sd": {
			"type": "structure",
			"members": {
				"OwnerId": {},
				"DBSecurityGroupName": {},
				"DBSecurityGroupDescription": {},
				"VpcId": {},
				"EC2SecurityGroups": {
					"type": "list",
					"member": {
						"locationName": "EC2SecurityGroup",
						"type": "structure",
						"members": {
							"Status": {},
							"EC2SecurityGroupName": {},
							"EC2SecurityGroupId": {},
							"EC2SecurityGroupOwnerId": {}
						}
					}
				},
				"IPRanges": {
					"type": "list",
					"member": {
						"locationName": "IPRange",
						"type": "structure",
						"members": {
							"Status": {},
							"CIDRIP": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"Sk": {
			"type": "structure",
			"members": {
				"DBSnapshotIdentifier": {},
				"DBInstanceIdentifier": {},
				"SnapshotCreateTime": {
					"type": "timestamp"
				},
				"Engine": {},
				"AllocatedStorage": {
					"type": "integer"
				},
				"Status": {},
				"Port": {
					"type": "integer"
				},
				"AvailabilityZone": {},
				"VpcId": {},
				"InstanceCreateTime": {
					"type": "timestamp"
				},
				"MasterUsername": {},
				"EngineVersion": {},
				"LicenseModel": {},
				"SnapshotType": {},
				"Iops": {
					"type": "integer"
				},
				"OptionGroupName": {}
			},
			"wrapper": true
		},
		"Sp": {
			"type": "list",
			"member": {
				"locationName": "DBSecurityGroupName"
			}
		},
		"Sq": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupId"
			}
		},
		"St": {
			"type": "structure",
			"members": {
				"DBInstanceIdentifier": {},
				"DBInstanceClass": {},
				"Engine": {},
				"DBInstanceStatus": {},
				"MasterUsername": {},
				"DBName": {},
				"Endpoint": {
					"type": "structure",
					"members": {
						"Address": {},
						"Port": {
							"type": "integer"
						}
					}
				},
				"AllocatedStorage": {
					"type": "integer"
				},
				"InstanceCreateTime": {
					"type": "timestamp"
				},
				"PreferredBackupWindow": {},
				"BackupRetentionPeriod": {
					"type": "integer"
				},
				"DBSecurityGroups": {
					"shape": "Sv"
				},
				"VpcSecurityGroups": {
					"shape": "Sx"
				},
				"DBParameterGroups": {
					"type": "list",
					"member": {
						"locationName": "DBParameterGroup",
						"type": "structure",
						"members": {
							"DBParameterGroupName": {},
							"ParameterApplyStatus": {}
						}
					}
				},
				"AvailabilityZone": {},
				"DBSubnetGroup": {
					"shape": "S11"
				},
				"PreferredMaintenanceWindow": {},
				"PendingModifiedValues": {
					"type": "structure",
					"members": {
						"DBInstanceClass": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"MasterUserPassword": {},
						"Port": {
							"type": "integer"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"Iops": {
							"type": "integer"
						},
						"DBInstanceIdentifier": {}
					}
				},
				"LatestRestorableTime": {
					"type": "timestamp"
				},
				"MultiAZ": {
					"type": "boolean"
				},
				"EngineVersion": {},
				"AutoMinorVersionUpgrade": {
					"type": "boolean"
				},
				"ReadReplicaSourceDBInstanceIdentifier": {},
				"ReadReplicaDBInstanceIdentifiers": {
					"type": "list",
					"member": {
						"locationName": "ReadReplicaDBInstanceIdentifier"
					}
				},
				"LicenseModel": {},
				"Iops": {
					"type": "integer"
				},
				"OptionGroupMemberships": {
					"type": "list",
					"member": {
						"locationName": "OptionGroupMembership",
						"type": "structure",
						"members": {
							"OptionGroupName": {},
							"Status": {}
						}
					}
				},
				"CharacterSetName": {},
				"SecondaryAvailabilityZone": {},
				"PubliclyAccessible": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"Sv": {
			"type": "list",
			"member": {
				"locationName": "DBSecurityGroup",
				"type": "structure",
				"members": {
					"DBSecurityGroupName": {},
					"Status": {}
				}
			}
		},
		"Sx": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupMembership",
				"type": "structure",
				"members": {
					"VpcSecurityGroupId": {},
					"Status": {}
				}
			}
		},
		"S11": {
			"type": "structure",
			"members": {
				"DBSubnetGroupName": {},
				"DBSubnetGroupDescription": {},
				"VpcId": {},
				"SubnetGroupStatus": {},
				"Subnets": {
					"type": "list",
					"member": {
						"locationName": "Subnet",
						"type": "structure",
						"members": {
							"SubnetIdentifier": {},
							"SubnetAvailabilityZone": {
								"shape": "S14"
							},
							"SubnetStatus": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"S14": {
			"type": "structure",
			"members": {
				"Name": {},
				"ProvisionedIopsCapable": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"S1d": {
			"type": "structure",
			"members": {
				"DBParameterGroupName": {},
				"DBParameterGroupFamily": {},
				"Description": {}
			},
			"wrapper": true
		},
		"S1j": {
			"type": "list",
			"member": {
				"locationName": "SubnetIdentifier"
			}
		},
		"S1p": {
			"type": "structure",
			"members": {
				"OptionGroupName": {},
				"OptionGroupDescription": {},
				"EngineName": {},
				"MajorEngineVersion": {},
				"Options": {
					"type": "list",
					"member": {
						"locationName": "Option",
						"type": "structure",
						"members": {
							"OptionName": {},
							"OptionDescription": {},
							"Persistent": {
								"type": "boolean"
							},
							"Port": {
								"type": "integer"
							},
							"OptionSettings": {
								"type": "list",
								"member": {
									"shape": "S1t",
									"locationName": "OptionSetting"
								}
							},
							"DBSecurityGroupMemberships": {
								"shape": "Sv"
							},
							"VpcSecurityGroupMemberships": {
								"shape": "Sx"
							}
						}
					}
				},
				"AllowsVpcAndNonVpcInstanceMemberships": {
					"type": "boolean"
				},
				"VpcId": {}
			},
			"wrapper": true
		},
		"S1t": {
			"type": "structure",
			"members": {
				"Name": {},
				"Value": {},
				"DefaultValue": {},
				"Description": {},
				"ApplyType": {},
				"DataType": {},
				"AllowedValues": {},
				"IsModifiable": {
					"type": "boolean"
				},
				"IsCollection": {
					"type": "boolean"
				}
			}
		},
		"S28": {
			"type": "structure",
			"members": {
				"CharacterSetName": {},
				"CharacterSetDescription": {}
			}
		},
		"S2n": {
			"type": "list",
			"member": {
				"locationName": "Parameter",
				"type": "structure",
				"members": {
					"ParameterName": {},
					"ParameterValue": {},
					"Description": {},
					"Source": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"MinimumEngineVersion": {},
					"ApplyMethod": {}
				}
			}
		},
		"S3w": {
			"type": "structure",
			"members": {
				"ReservedDBInstanceId": {},
				"ReservedDBInstancesOfferingId": {},
				"DBInstanceClass": {},
				"StartTime": {
					"type": "timestamp"
				},
				"Duration": {
					"type": "integer"
				},
				"FixedPrice": {
					"type": "double"
				},
				"UsagePrice": {
					"type": "double"
				},
				"CurrencyCode": {},
				"DBInstanceCount": {
					"type": "integer"
				},
				"ProductDescription": {},
				"OfferingType": {},
				"MultiAZ": {
					"type": "boolean"
				},
				"State": {},
				"RecurringCharges": {
					"shape": "S3y"
				}
			},
			"wrapper": true
		},
		"S3y": {
			"type": "list",
			"member": {
				"locationName": "RecurringCharge",
				"type": "structure",
				"members": {
					"RecurringChargeAmount": {
						"type": "double"
					},
					"RecurringChargeFrequency": {}
				},
				"wrapper": true
			}
		},
		"S4b": {
			"type": "structure",
			"members": {
				"DBParameterGroupName": {}
			}
		}
	}
};

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeDBEngineVersions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBEngineVersions"
		},
		"DescribeDBInstances": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBInstances"
		},
		"DescribeDBLogFiles": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DescribeDBLogFiles"
		},
		"DescribeDBParameterGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBParameterGroups"
		},
		"DescribeDBParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Parameters"
		},
		"DescribeDBSecurityGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSecurityGroups"
		},
		"DescribeDBSnapshots": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSnapshots"
		},
		"DescribeDBSubnetGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSubnetGroups"
		},
		"DescribeEngineDefaultParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "EngineDefaults.Marker",
			"result_key": "EngineDefaults.Parameters"
		},
		"DescribeEventSubscriptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "EventSubscriptionsList"
		},
		"DescribeEvents": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Events"
		},
		"DescribeOptionGroupOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OptionGroupOptions"
		},
		"DescribeOptionGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OptionGroupsList"
		},
		"DescribeOrderableDBInstanceOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OrderableDBInstanceOptions"
		},
		"DescribeReservedDBInstances": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedDBInstances"
		},
		"DescribeReservedDBInstancesOfferings": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedDBInstancesOfferings"
		},
		"DownloadDBLogFilePortion": {
			"input_token": "Marker",
			"limit_key": "NumberOfLines",
			"more_results": "AdditionalDataPending",
			"output_token": "Marker",
			"result_key": "LogFileData"
		},
		"ListTagsForResource": {
			"result_key": "TagList"
		}
	}
};

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2013-09-09",
		"endpointPrefix": "rds",
		"protocol": "query",
		"serviceAbbreviation": "Amazon RDS",
		"serviceFullName": "Amazon Relational Database Service",
		"signatureVersion": "v4",
		"uid": "rds-2013-09-09",
		"xmlNamespace": "http://rds.amazonaws.com/doc/2013-09-09/"
	},
	"operations": {
		"AddSourceIdentifierToSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SourceIdentifier"
				],
				"members": {
					"SubscriptionName": {},
					"SourceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"AddTagsToResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"Tags"
				],
				"members": {
					"ResourceName": {},
					"Tags": {
						"shape": "S9"
					}
				}
			}
		},
		"AuthorizeDBSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupId": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		},
		"CopyDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBSnapshotIdentifier",
					"TargetDBSnapshotIdentifier"
				],
				"members": {
					"SourceDBSnapshotIdentifier": {},
					"TargetDBSnapshotIdentifier": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CopyDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sk"
					}
				}
			}
		},
		"CreateDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"AllocatedStorage",
					"DBInstanceClass",
					"Engine",
					"MasterUsername",
					"MasterUserPassword"
				],
				"members": {
					"DBName": {},
					"DBInstanceIdentifier": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"DBInstanceClass": {},
					"Engine": {},
					"MasterUsername": {},
					"MasterUserPassword": {},
					"DBSecurityGroups": {
						"shape": "Sp"
					},
					"VpcSecurityGroupIds": {
						"shape": "Sq"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"PreferredMaintenanceWindow": {},
					"DBParameterGroupName": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {},
					"Port": {
						"type": "integer"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"CharacterSetName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"CreateDBInstanceReadReplica": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"SourceDBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"SourceDBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"AvailabilityZone": {},
					"Port": {
						"type": "integer"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "S9"
					},
					"DBSubnetGroupName": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBInstanceReadReplicaResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"CreateDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName",
					"DBParameterGroupFamily",
					"Description"
				],
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBParameterGroupResult",
				"type": "structure",
				"members": {
					"DBParameterGroup": {
						"shape": "S1f"
					}
				}
			}
		},
		"CreateDBSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName",
					"DBSecurityGroupDescription"
				],
				"members": {
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSecurityGroupResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		},
		"CreateDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier",
					"DBInstanceIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sk"
					}
				}
			}
		},
		"CreateDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName",
					"DBSubnetGroupDescription",
					"SubnetIds"
				],
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S1l"
					},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSubnetGroupResult",
				"type": "structure",
				"members": {
					"DBSubnetGroup": {
						"shape": "S11"
					}
				}
			}
		},
		"CreateEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SnsTopicArn"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"EventCategories": {
						"shape": "S6"
					},
					"SourceIds": {
						"shape": "S5"
					},
					"Enabled": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"CreateOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName",
					"EngineName",
					"MajorEngineVersion",
					"OptionGroupDescription"
				],
				"members": {
					"OptionGroupName": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"OptionGroupDescription": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "S1r"
					}
				}
			}
		},
		"DeleteDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"SkipFinalSnapshot": {
						"type": "boolean"
					},
					"FinalDBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"DeleteDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {}
				}
			}
		},
		"DeleteDBSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {}
				}
			}
		},
		"DeleteDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sk"
					}
				}
			}
		},
		"DeleteDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName"
				],
				"members": {
					"DBSubnetGroupName": {}
				}
			}
		},
		"DeleteEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"DeleteOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName"
				],
				"members": {
					"OptionGroupName": {}
				}
			}
		},
		"DescribeDBEngineVersions": {
			"input": {
				"type": "structure",
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"DBParameterGroupFamily": {},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"DefaultOnly": {
						"type": "boolean"
					},
					"ListSupportedCharacterSets": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBEngineVersionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBEngineVersions": {
						"type": "list",
						"member": {
							"locationName": "DBEngineVersion",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"DBParameterGroupFamily": {},
								"DBEngineDescription": {},
								"DBEngineVersionDescription": {},
								"DefaultCharacterSet": {
									"shape": "S2d"
								},
								"SupportedCharacterSets": {
									"type": "list",
									"member": {
										"shape": "S2d",
										"locationName": "CharacterSet"
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeDBInstances": {
			"input": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBInstancesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBInstances": {
						"type": "list",
						"member": {
							"shape": "St",
							"locationName": "DBInstance"
						}
					}
				}
			}
		},
		"DescribeDBLogFiles": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"FilenameContains": {},
					"FileLastWritten": {
						"type": "long"
					},
					"FileSize": {
						"type": "long"
					},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBLogFilesResult",
				"type": "structure",
				"members": {
					"DescribeDBLogFiles": {
						"type": "list",
						"member": {
							"locationName": "DescribeDBLogFilesDetails",
							"type": "structure",
							"members": {
								"LogFileName": {},
								"LastWritten": {
									"type": "long"
								},
								"Size": {
									"type": "long"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBParameterGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBParameterGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"shape": "S1f",
							"locationName": "DBParameterGroup"
						}
					}
				}
			}
		},
		"DescribeDBParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {},
					"Source": {},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBParametersResult",
				"type": "structure",
				"members": {
					"Parameters": {
						"shape": "S2s"
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBSecurityGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBSecurityGroupName": {},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSecurityGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSecurityGroups": {
						"type": "list",
						"member": {
							"shape": "Sd",
							"locationName": "DBSecurityGroup"
						}
					}
				}
			}
		},
		"DescribeDBSnapshots": {
			"input": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {},
					"SnapshotType": {},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSnapshotsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSnapshots": {
						"type": "list",
						"member": {
							"shape": "Sk",
							"locationName": "DBSnapshot"
						}
					}
				}
			}
		},
		"DescribeDBSubnetGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSubnetGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSubnetGroups": {
						"type": "list",
						"member": {
							"shape": "S11",
							"locationName": "DBSubnetGroup"
						}
					}
				}
			}
		},
		"DescribeEngineDefaultParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupFamily"
				],
				"members": {
					"DBParameterGroupFamily": {},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEngineDefaultParametersResult",
				"type": "structure",
				"members": {
					"EngineDefaults": {
						"type": "structure",
						"members": {
							"DBParameterGroupFamily": {},
							"Marker": {},
							"Parameters": {
								"shape": "S2s"
							}
						},
						"wrapper": true
					}
				}
			}
		},
		"DescribeEventCategories": {
			"input": {
				"type": "structure",
				"members": {
					"SourceType": {},
					"Filters": {
						"shape": "S27"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventCategoriesResult",
				"type": "structure",
				"members": {
					"EventCategoriesMapList": {
						"type": "list",
						"member": {
							"locationName": "EventCategoriesMap",
							"type": "structure",
							"members": {
								"SourceType": {},
								"EventCategories": {
									"shape": "S6"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DescribeEventSubscriptions": {
			"input": {
				"type": "structure",
				"members": {
					"SubscriptionName": {},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventSubscriptionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"EventSubscriptionsList": {
						"type": "list",
						"member": {
							"shape": "S4",
							"locationName": "EventSubscription"
						}
					}
				}
			}
		},
		"DescribeEvents": {
			"input": {
				"type": "structure",
				"members": {
					"SourceIdentifier": {},
					"SourceType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"EventCategories": {
						"shape": "S6"
					},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Events": {
						"type": "list",
						"member": {
							"locationName": "Event",
							"type": "structure",
							"members": {
								"SourceIdentifier": {},
								"SourceType": {},
								"Message": {},
								"EventCategories": {
									"shape": "S6"
								},
								"Date": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeOptionGroupOptions": {
			"input": {
				"type": "structure",
				"required": [
					"EngineName"
				],
				"members": {
					"EngineName": {},
					"MajorEngineVersion": {},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOptionGroupOptionsResult",
				"type": "structure",
				"members": {
					"OptionGroupOptions": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupOption",
							"type": "structure",
							"members": {
								"Name": {},
								"Description": {},
								"EngineName": {},
								"MajorEngineVersion": {},
								"MinimumRequiredMinorEngineVersion": {},
								"PortRequired": {
									"type": "boolean"
								},
								"DefaultPort": {
									"type": "integer"
								},
								"OptionsDependedOn": {
									"type": "list",
									"member": {
										"locationName": "OptionName"
									}
								},
								"Persistent": {
									"type": "boolean"
								},
								"Permanent": {
									"type": "boolean"
								},
								"OptionGroupOptionSettings": {
									"type": "list",
									"member": {
										"locationName": "OptionGroupOptionSetting",
										"type": "structure",
										"members": {
											"SettingName": {},
											"SettingDescription": {},
											"DefaultValue": {},
											"ApplyType": {},
											"AllowedValues": {},
											"IsModifiable": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeOptionGroups": {
			"input": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"Filters": {
						"shape": "S27"
					},
					"Marker": {},
					"MaxRecords": {
						"type": "integer"
					},
					"EngineName": {},
					"MajorEngineVersion": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOptionGroupsResult",
				"type": "structure",
				"members": {
					"OptionGroupsList": {
						"type": "list",
						"member": {
							"shape": "S1r",
							"locationName": "OptionGroup"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeOrderableDBInstanceOptions": {
			"input": {
				"type": "structure",
				"required": [
					"Engine"
				],
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"DBInstanceClass": {},
					"LicenseModel": {},
					"Vpc": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
				"type": "structure",
				"members": {
					"OrderableDBInstanceOptions": {
						"type": "list",
						"member": {
							"locationName": "OrderableDBInstanceOption",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"DBInstanceClass": {},
								"LicenseModel": {},
								"AvailabilityZones": {
									"type": "list",
									"member": {
										"shape": "S14",
										"locationName": "AvailabilityZone"
									}
								},
								"MultiAZCapable": {
									"type": "boolean"
								},
								"ReadReplicaCapable": {
									"type": "boolean"
								},
								"Vpc": {
									"type": "boolean"
								}
							},
							"wrapper": true
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeReservedDBInstances": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedDBInstancesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedDBInstances": {
						"type": "list",
						"member": {
							"shape": "S41",
							"locationName": "ReservedDBInstance"
						}
					}
				}
			}
		},
		"DescribeReservedDBInstancesOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S27"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedDBInstancesOfferings": {
						"type": "list",
						"member": {
							"locationName": "ReservedDBInstancesOffering",
							"type": "structure",
							"members": {
								"ReservedDBInstancesOfferingId": {},
								"DBInstanceClass": {},
								"Duration": {
									"type": "integer"
								},
								"FixedPrice": {
									"type": "double"
								},
								"UsagePrice": {
									"type": "double"
								},
								"CurrencyCode": {},
								"ProductDescription": {},
								"OfferingType": {},
								"MultiAZ": {
									"type": "boolean"
								},
								"RecurringCharges": {
									"shape": "S43"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DownloadDBLogFilePortion": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"LogFileName"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"LogFileName": {},
					"Marker": {},
					"NumberOfLines": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DownloadDBLogFilePortionResult",
				"type": "structure",
				"members": {
					"LogFileData": {},
					"Marker": {},
					"AdditionalDataPending": {
						"type": "boolean"
					}
				}
			}
		},
		"ListTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName"
				],
				"members": {
					"ResourceName": {},
					"Filters": {
						"shape": "S27"
					}
				}
			},
			"output": {
				"resultWrapper": "ListTagsForResourceResult",
				"type": "structure",
				"members": {
					"TagList": {
						"shape": "S9"
					}
				}
			}
		},
		"ModifyDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"DBInstanceClass": {},
					"DBSecurityGroups": {
						"shape": "Sp"
					},
					"VpcSecurityGroupIds": {
						"shape": "Sq"
					},
					"ApplyImmediately": {
						"type": "boolean"
					},
					"MasterUserPassword": {},
					"DBParameterGroupName": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {},
					"PreferredMaintenanceWindow": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AllowMajorVersionUpgrade": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"NewDBInstanceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"ModifyDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName",
					"Parameters"
				],
				"members": {
					"DBParameterGroupName": {},
					"Parameters": {
						"shape": "S2s"
					}
				}
			},
			"output": {
				"shape": "S4g",
				"resultWrapper": "ModifyDBParameterGroupResult"
			}
		},
		"ModifyDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName",
					"SubnetIds"
				],
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S1l"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBSubnetGroupResult",
				"type": "structure",
				"members": {
					"DBSubnetGroup": {
						"shape": "S11"
					}
				}
			}
		},
		"ModifyEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"EventCategories": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"ModifyOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName"
				],
				"members": {
					"OptionGroupName": {},
					"OptionsToInclude": {
						"type": "list",
						"member": {
							"locationName": "OptionConfiguration",
							"type": "structure",
							"required": [
								"OptionName"
							],
							"members": {
								"OptionName": {},
								"Port": {
									"type": "integer"
								},
								"DBSecurityGroupMemberships": {
									"shape": "Sp"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "Sq"
								},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "S1v",
										"locationName": "OptionSetting"
									}
								}
							}
						}
					},
					"OptionsToRemove": {
						"type": "list",
						"member": {}
					},
					"ApplyImmediately": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "S1r"
					}
				}
			}
		},
		"PromoteReadReplica": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {}
				}
			},
			"output": {
				"resultWrapper": "PromoteReadReplicaResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"PurchaseReservedDBInstancesOffering": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedDBInstancesOfferingId"
				],
				"members": {
					"ReservedDBInstancesOfferingId": {},
					"ReservedDBInstanceId": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
				"type": "structure",
				"members": {
					"ReservedDBInstance": {
						"shape": "S41"
					}
				}
			}
		},
		"RebootDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"ForceFailover": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "RebootDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"RemoveSourceIdentifierFromSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SourceIdentifier"
				],
				"members": {
					"SubscriptionName": {},
					"SourceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"RemoveTagsFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"TagKeys"
				],
				"members": {
					"ResourceName": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"ResetDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {},
					"ResetAllParameters": {
						"type": "boolean"
					},
					"Parameters": {
						"shape": "S2s"
					}
				}
			},
			"output": {
				"shape": "S4g",
				"resultWrapper": "ResetDBParameterGroupResult"
			}
		},
		"RestoreDBInstanceFromDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {},
					"DBInstanceClass": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"DBName": {},
					"Engine": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"RestoreDBInstanceToPointInTime": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBInstanceIdentifier",
					"TargetDBInstanceIdentifier"
				],
				"members": {
					"SourceDBInstanceIdentifier": {},
					"TargetDBInstanceIdentifier": {},
					"RestoreTime": {
						"type": "timestamp"
					},
					"UseLatestRestorableTime": {
						"type": "boolean"
					},
					"DBInstanceClass": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"DBName": {},
					"Engine": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "St"
					}
				}
			}
		},
		"RevokeDBSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupId": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "RevokeDBSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"CustomerAwsId": {},
				"CustSubscriptionId": {},
				"SnsTopicArn": {},
				"Status": {},
				"SubscriptionCreationTime": {},
				"SourceType": {},
				"SourceIdsList": {
					"shape": "S5"
				},
				"EventCategoriesList": {
					"shape": "S6"
				},
				"Enabled": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"S5": {
			"type": "list",
			"member": {
				"locationName": "SourceId"
			}
		},
		"S6": {
			"type": "list",
			"member": {
				"locationName": "EventCategory"
			}
		},
		"S9": {
			"type": "list",
			"member": {
				"locationName": "Tag",
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Sd": {
			"type": "structure",
			"members": {
				"OwnerId": {},
				"DBSecurityGroupName": {},
				"DBSecurityGroupDescription": {},
				"VpcId": {},
				"EC2SecurityGroups": {
					"type": "list",
					"member": {
						"locationName": "EC2SecurityGroup",
						"type": "structure",
						"members": {
							"Status": {},
							"EC2SecurityGroupName": {},
							"EC2SecurityGroupId": {},
							"EC2SecurityGroupOwnerId": {}
						}
					}
				},
				"IPRanges": {
					"type": "list",
					"member": {
						"locationName": "IPRange",
						"type": "structure",
						"members": {
							"Status": {},
							"CIDRIP": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"Sk": {
			"type": "structure",
			"members": {
				"DBSnapshotIdentifier": {},
				"DBInstanceIdentifier": {},
				"SnapshotCreateTime": {
					"type": "timestamp"
				},
				"Engine": {},
				"AllocatedStorage": {
					"type": "integer"
				},
				"Status": {},
				"Port": {
					"type": "integer"
				},
				"AvailabilityZone": {},
				"VpcId": {},
				"InstanceCreateTime": {
					"type": "timestamp"
				},
				"MasterUsername": {},
				"EngineVersion": {},
				"LicenseModel": {},
				"SnapshotType": {},
				"Iops": {
					"type": "integer"
				},
				"OptionGroupName": {},
				"PercentProgress": {
					"type": "integer"
				},
				"SourceRegion": {}
			},
			"wrapper": true
		},
		"Sp": {
			"type": "list",
			"member": {
				"locationName": "DBSecurityGroupName"
			}
		},
		"Sq": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupId"
			}
		},
		"St": {
			"type": "structure",
			"members": {
				"DBInstanceIdentifier": {},
				"DBInstanceClass": {},
				"Engine": {},
				"DBInstanceStatus": {},
				"MasterUsername": {},
				"DBName": {},
				"Endpoint": {
					"type": "structure",
					"members": {
						"Address": {},
						"Port": {
							"type": "integer"
						}
					}
				},
				"AllocatedStorage": {
					"type": "integer"
				},
				"InstanceCreateTime": {
					"type": "timestamp"
				},
				"PreferredBackupWindow": {},
				"BackupRetentionPeriod": {
					"type": "integer"
				},
				"DBSecurityGroups": {
					"shape": "Sv"
				},
				"VpcSecurityGroups": {
					"shape": "Sx"
				},
				"DBParameterGroups": {
					"type": "list",
					"member": {
						"locationName": "DBParameterGroup",
						"type": "structure",
						"members": {
							"DBParameterGroupName": {},
							"ParameterApplyStatus": {}
						}
					}
				},
				"AvailabilityZone": {},
				"DBSubnetGroup": {
					"shape": "S11"
				},
				"PreferredMaintenanceWindow": {},
				"PendingModifiedValues": {
					"type": "structure",
					"members": {
						"DBInstanceClass": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"MasterUserPassword": {},
						"Port": {
							"type": "integer"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"Iops": {
							"type": "integer"
						},
						"DBInstanceIdentifier": {}
					}
				},
				"LatestRestorableTime": {
					"type": "timestamp"
				},
				"MultiAZ": {
					"type": "boolean"
				},
				"EngineVersion": {},
				"AutoMinorVersionUpgrade": {
					"type": "boolean"
				},
				"ReadReplicaSourceDBInstanceIdentifier": {},
				"ReadReplicaDBInstanceIdentifiers": {
					"type": "list",
					"member": {
						"locationName": "ReadReplicaDBInstanceIdentifier"
					}
				},
				"LicenseModel": {},
				"Iops": {
					"type": "integer"
				},
				"OptionGroupMemberships": {
					"type": "list",
					"member": {
						"locationName": "OptionGroupMembership",
						"type": "structure",
						"members": {
							"OptionGroupName": {},
							"Status": {}
						}
					}
				},
				"CharacterSetName": {},
				"SecondaryAvailabilityZone": {},
				"PubliclyAccessible": {
					"type": "boolean"
				},
				"StatusInfos": {
					"type": "list",
					"member": {
						"locationName": "DBInstanceStatusInfo",
						"type": "structure",
						"members": {
							"StatusType": {},
							"Normal": {
								"type": "boolean"
							},
							"Status": {},
							"Message": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"Sv": {
			"type": "list",
			"member": {
				"locationName": "DBSecurityGroup",
				"type": "structure",
				"members": {
					"DBSecurityGroupName": {},
					"Status": {}
				}
			}
		},
		"Sx": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupMembership",
				"type": "structure",
				"members": {
					"VpcSecurityGroupId": {},
					"Status": {}
				}
			}
		},
		"S11": {
			"type": "structure",
			"members": {
				"DBSubnetGroupName": {},
				"DBSubnetGroupDescription": {},
				"VpcId": {},
				"SubnetGroupStatus": {},
				"Subnets": {
					"type": "list",
					"member": {
						"locationName": "Subnet",
						"type": "structure",
						"members": {
							"SubnetIdentifier": {},
							"SubnetAvailabilityZone": {
								"shape": "S14"
							},
							"SubnetStatus": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"S14": {
			"type": "structure",
			"members": {
				"Name": {},
				"ProvisionedIopsCapable": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"S1f": {
			"type": "structure",
			"members": {
				"DBParameterGroupName": {},
				"DBParameterGroupFamily": {},
				"Description": {}
			},
			"wrapper": true
		},
		"S1l": {
			"type": "list",
			"member": {
				"locationName": "SubnetIdentifier"
			}
		},
		"S1r": {
			"type": "structure",
			"members": {
				"OptionGroupName": {},
				"OptionGroupDescription": {},
				"EngineName": {},
				"MajorEngineVersion": {},
				"Options": {
					"type": "list",
					"member": {
						"locationName": "Option",
						"type": "structure",
						"members": {
							"OptionName": {},
							"OptionDescription": {},
							"Persistent": {
								"type": "boolean"
							},
							"Permanent": {
								"type": "boolean"
							},
							"Port": {
								"type": "integer"
							},
							"OptionSettings": {
								"type": "list",
								"member": {
									"shape": "S1v",
									"locationName": "OptionSetting"
								}
							},
							"DBSecurityGroupMemberships": {
								"shape": "Sv"
							},
							"VpcSecurityGroupMemberships": {
								"shape": "Sx"
							}
						}
					}
				},
				"AllowsVpcAndNonVpcInstanceMemberships": {
					"type": "boolean"
				},
				"VpcId": {}
			},
			"wrapper": true
		},
		"S1v": {
			"type": "structure",
			"members": {
				"Name": {},
				"Value": {},
				"DefaultValue": {},
				"Description": {},
				"ApplyType": {},
				"DataType": {},
				"AllowedValues": {},
				"IsModifiable": {
					"type": "boolean"
				},
				"IsCollection": {
					"type": "boolean"
				}
			}
		},
		"S27": {
			"type": "list",
			"member": {
				"locationName": "Filter",
				"type": "structure",
				"required": [
					"Name",
					"Values"
				],
				"members": {
					"Name": {},
					"Values": {
						"type": "list",
						"member": {
							"locationName": "Value"
						}
					}
				}
			}
		},
		"S2d": {
			"type": "structure",
			"members": {
				"CharacterSetName": {},
				"CharacterSetDescription": {}
			}
		},
		"S2s": {
			"type": "list",
			"member": {
				"locationName": "Parameter",
				"type": "structure",
				"members": {
					"ParameterName": {},
					"ParameterValue": {},
					"Description": {},
					"Source": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"MinimumEngineVersion": {},
					"ApplyMethod": {}
				}
			}
		},
		"S41": {
			"type": "structure",
			"members": {
				"ReservedDBInstanceId": {},
				"ReservedDBInstancesOfferingId": {},
				"DBInstanceClass": {},
				"StartTime": {
					"type": "timestamp"
				},
				"Duration": {
					"type": "integer"
				},
				"FixedPrice": {
					"type": "double"
				},
				"UsagePrice": {
					"type": "double"
				},
				"CurrencyCode": {},
				"DBInstanceCount": {
					"type": "integer"
				},
				"ProductDescription": {},
				"OfferingType": {},
				"MultiAZ": {
					"type": "boolean"
				},
				"State": {},
				"RecurringCharges": {
					"shape": "S43"
				}
			},
			"wrapper": true
		},
		"S43": {
			"type": "list",
			"member": {
				"locationName": "RecurringCharge",
				"type": "structure",
				"members": {
					"RecurringChargeAmount": {
						"type": "double"
					},
					"RecurringChargeFrequency": {}
				},
				"wrapper": true
			}
		},
		"S4g": {
			"type": "structure",
			"members": {
				"DBParameterGroupName": {}
			}
		}
	}
};

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeDBEngineVersions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBEngineVersions"
		},
		"DescribeDBInstances": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBInstances"
		},
		"DescribeDBLogFiles": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DescribeDBLogFiles"
		},
		"DescribeDBParameterGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBParameterGroups"
		},
		"DescribeDBParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Parameters"
		},
		"DescribeDBSecurityGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSecurityGroups"
		},
		"DescribeDBSnapshots": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSnapshots"
		},
		"DescribeDBSubnetGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSubnetGroups"
		},
		"DescribeEngineDefaultParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "EngineDefaults.Marker",
			"result_key": "EngineDefaults.Parameters"
		},
		"DescribeEventSubscriptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "EventSubscriptionsList"
		},
		"DescribeEvents": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Events"
		},
		"DescribeOptionGroupOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OptionGroupOptions"
		},
		"DescribeOptionGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OptionGroupsList"
		},
		"DescribeOrderableDBInstanceOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OrderableDBInstanceOptions"
		},
		"DescribeReservedDBInstances": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedDBInstances"
		},
		"DescribeReservedDBInstancesOfferings": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedDBInstancesOfferings"
		},
		"DownloadDBLogFilePortion": {
			"input_token": "Marker",
			"limit_key": "NumberOfLines",
			"more_results": "AdditionalDataPending",
			"output_token": "Marker",
			"result_key": "LogFileData"
		},
		"ListTagsForResource": {
			"result_key": "TagList"
		}
	}
};

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"DBInstanceAvailable": {
			"delay": 30,
			"operation": "DescribeDBInstances",
			"maxAttempts": 60,
			"acceptors": [
				{
					"expected": "available",
					"matcher": "pathAll",
					"state": "success",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "deleted",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "deleting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "incompatible-restore",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "incompatible-parameters",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "incompatible-parameters",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "incompatible-restore",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				}
			]
		},
		"DBInstanceDeleted": {
			"delay": 30,
			"operation": "DescribeDBInstances",
			"maxAttempts": 60,
			"acceptors": [
				{
					"expected": "deleted",
					"matcher": "pathAll",
					"state": "success",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "creating",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "modifying",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "rebooting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "resetting-master-credentials",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				}
			]
		}
	}
};

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-09-01",
		"endpointPrefix": "rds",
		"protocol": "query",
		"serviceAbbreviation": "Amazon RDS",
		"serviceFullName": "Amazon Relational Database Service",
		"signatureVersion": "v4",
		"uid": "rds-2014-09-01",
		"xmlNamespace": "http://rds.amazonaws.com/doc/2014-09-01/"
	},
	"operations": {
		"AddSourceIdentifierToSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SourceIdentifier"
				],
				"members": {
					"SubscriptionName": {},
					"SourceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"AddTagsToResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"Tags"
				],
				"members": {
					"ResourceName": {},
					"Tags": {
						"shape": "S9"
					}
				}
			}
		},
		"AuthorizeDBSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupId": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		},
		"CopyDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBParameterGroupIdentifier",
					"TargetDBParameterGroupIdentifier",
					"TargetDBParameterGroupDescription"
				],
				"members": {
					"SourceDBParameterGroupIdentifier": {},
					"TargetDBParameterGroupIdentifier": {},
					"TargetDBParameterGroupDescription": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CopyDBParameterGroupResult",
				"type": "structure",
				"members": {
					"DBParameterGroup": {
						"shape": "Sk"
					}
				}
			}
		},
		"CopyDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBSnapshotIdentifier",
					"TargetDBSnapshotIdentifier"
				],
				"members": {
					"SourceDBSnapshotIdentifier": {},
					"TargetDBSnapshotIdentifier": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CopyDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sn"
					}
				}
			}
		},
		"CopyOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"SourceOptionGroupIdentifier",
					"TargetOptionGroupIdentifier",
					"TargetOptionGroupDescription"
				],
				"members": {
					"SourceOptionGroupIdentifier": {},
					"TargetOptionGroupIdentifier": {},
					"TargetOptionGroupDescription": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CopyOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "St"
					}
				}
			}
		},
		"CreateDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"AllocatedStorage",
					"DBInstanceClass",
					"Engine",
					"MasterUsername",
					"MasterUserPassword"
				],
				"members": {
					"DBName": {},
					"DBInstanceIdentifier": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"DBInstanceClass": {},
					"Engine": {},
					"MasterUsername": {},
					"MasterUserPassword": {},
					"DBSecurityGroups": {
						"shape": "S13"
					},
					"VpcSecurityGroupIds": {
						"shape": "S14"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"PreferredMaintenanceWindow": {},
					"DBParameterGroupName": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {},
					"Port": {
						"type": "integer"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"CharacterSetName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "S9"
					},
					"StorageType": {},
					"TdeCredentialArn": {},
					"TdeCredentialPassword": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S17"
					}
				}
			}
		},
		"CreateDBInstanceReadReplica": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"SourceDBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"SourceDBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"AvailabilityZone": {},
					"Port": {
						"type": "integer"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "S9"
					},
					"DBSubnetGroupName": {},
					"StorageType": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBInstanceReadReplicaResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S17"
					}
				}
			}
		},
		"CreateDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName",
					"DBParameterGroupFamily",
					"Description"
				],
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBParameterGroupResult",
				"type": "structure",
				"members": {
					"DBParameterGroup": {
						"shape": "Sk"
					}
				}
			}
		},
		"CreateDBSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName",
					"DBSecurityGroupDescription"
				],
				"members": {
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSecurityGroupResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		},
		"CreateDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier",
					"DBInstanceIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sn"
					}
				}
			}
		},
		"CreateDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName",
					"DBSubnetGroupDescription",
					"SubnetIds"
				],
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S1u"
					},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSubnetGroupResult",
				"type": "structure",
				"members": {
					"DBSubnetGroup": {
						"shape": "S1b"
					}
				}
			}
		},
		"CreateEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SnsTopicArn"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"EventCategories": {
						"shape": "S6"
					},
					"SourceIds": {
						"shape": "S5"
					},
					"Enabled": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"CreateOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName",
					"EngineName",
					"MajorEngineVersion",
					"OptionGroupDescription"
				],
				"members": {
					"OptionGroupName": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"OptionGroupDescription": {},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "St"
					}
				}
			}
		},
		"DeleteDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"SkipFinalSnapshot": {
						"type": "boolean"
					},
					"FinalDBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S17"
					}
				}
			}
		},
		"DeleteDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {}
				}
			}
		},
		"DeleteDBSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {}
				}
			}
		},
		"DeleteDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "Sn"
					}
				}
			}
		},
		"DeleteDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName"
				],
				"members": {
					"DBSubnetGroupName": {}
				}
			}
		},
		"DeleteEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"DeleteOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName"
				],
				"members": {
					"OptionGroupName": {}
				}
			}
		},
		"DescribeDBEngineVersions": {
			"input": {
				"type": "structure",
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"DBParameterGroupFamily": {},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"DefaultOnly": {
						"type": "boolean"
					},
					"ListSupportedCharacterSets": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBEngineVersionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBEngineVersions": {
						"type": "list",
						"member": {
							"locationName": "DBEngineVersion",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"DBParameterGroupFamily": {},
								"DBEngineDescription": {},
								"DBEngineVersionDescription": {},
								"DefaultCharacterSet": {
									"shape": "S2h"
								},
								"SupportedCharacterSets": {
									"type": "list",
									"member": {
										"shape": "S2h",
										"locationName": "CharacterSet"
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeDBInstances": {
			"input": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBInstancesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBInstances": {
						"type": "list",
						"member": {
							"shape": "S17",
							"locationName": "DBInstance"
						}
					}
				}
			}
		},
		"DescribeDBLogFiles": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"FilenameContains": {},
					"FileLastWritten": {
						"type": "long"
					},
					"FileSize": {
						"type": "long"
					},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBLogFilesResult",
				"type": "structure",
				"members": {
					"DescribeDBLogFiles": {
						"type": "list",
						"member": {
							"locationName": "DescribeDBLogFilesDetails",
							"type": "structure",
							"members": {
								"LogFileName": {},
								"LastWritten": {
									"type": "long"
								},
								"Size": {
									"type": "long"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBParameterGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBParameterGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"shape": "Sk",
							"locationName": "DBParameterGroup"
						}
					}
				}
			}
		},
		"DescribeDBParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {},
					"Source": {},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBParametersResult",
				"type": "structure",
				"members": {
					"Parameters": {
						"shape": "S2w"
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBSecurityGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBSecurityGroupName": {},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSecurityGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSecurityGroups": {
						"type": "list",
						"member": {
							"shape": "Sd",
							"locationName": "DBSecurityGroup"
						}
					}
				}
			}
		},
		"DescribeDBSnapshots": {
			"input": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {},
					"SnapshotType": {},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSnapshotsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSnapshots": {
						"type": "list",
						"member": {
							"shape": "Sn",
							"locationName": "DBSnapshot"
						}
					}
				}
			}
		},
		"DescribeDBSubnetGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSubnetGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSubnetGroups": {
						"type": "list",
						"member": {
							"shape": "S1b",
							"locationName": "DBSubnetGroup"
						}
					}
				}
			}
		},
		"DescribeEngineDefaultParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupFamily"
				],
				"members": {
					"DBParameterGroupFamily": {},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEngineDefaultParametersResult",
				"type": "structure",
				"members": {
					"EngineDefaults": {
						"type": "structure",
						"members": {
							"DBParameterGroupFamily": {},
							"Marker": {},
							"Parameters": {
								"shape": "S2w"
							}
						},
						"wrapper": true
					}
				}
			}
		},
		"DescribeEventCategories": {
			"input": {
				"type": "structure",
				"members": {
					"SourceType": {},
					"Filters": {
						"shape": "S2b"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventCategoriesResult",
				"type": "structure",
				"members": {
					"EventCategoriesMapList": {
						"type": "list",
						"member": {
							"locationName": "EventCategoriesMap",
							"type": "structure",
							"members": {
								"SourceType": {},
								"EventCategories": {
									"shape": "S6"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DescribeEventSubscriptions": {
			"input": {
				"type": "structure",
				"members": {
					"SubscriptionName": {},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventSubscriptionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"EventSubscriptionsList": {
						"type": "list",
						"member": {
							"shape": "S4",
							"locationName": "EventSubscription"
						}
					}
				}
			}
		},
		"DescribeEvents": {
			"input": {
				"type": "structure",
				"members": {
					"SourceIdentifier": {},
					"SourceType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"EventCategories": {
						"shape": "S6"
					},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Events": {
						"type": "list",
						"member": {
							"locationName": "Event",
							"type": "structure",
							"members": {
								"SourceIdentifier": {},
								"SourceType": {},
								"Message": {},
								"EventCategories": {
									"shape": "S6"
								},
								"Date": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeOptionGroupOptions": {
			"input": {
				"type": "structure",
				"required": [
					"EngineName"
				],
				"members": {
					"EngineName": {},
					"MajorEngineVersion": {},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOptionGroupOptionsResult",
				"type": "structure",
				"members": {
					"OptionGroupOptions": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupOption",
							"type": "structure",
							"members": {
								"Name": {},
								"Description": {},
								"EngineName": {},
								"MajorEngineVersion": {},
								"MinimumRequiredMinorEngineVersion": {},
								"PortRequired": {
									"type": "boolean"
								},
								"DefaultPort": {
									"type": "integer"
								},
								"OptionsDependedOn": {
									"type": "list",
									"member": {
										"locationName": "OptionName"
									}
								},
								"Persistent": {
									"type": "boolean"
								},
								"Permanent": {
									"type": "boolean"
								},
								"OptionGroupOptionSettings": {
									"type": "list",
									"member": {
										"locationName": "OptionGroupOptionSetting",
										"type": "structure",
										"members": {
											"SettingName": {},
											"SettingDescription": {},
											"DefaultValue": {},
											"ApplyType": {},
											"AllowedValues": {},
											"IsModifiable": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeOptionGroups": {
			"input": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"Filters": {
						"shape": "S2b"
					},
					"Marker": {},
					"MaxRecords": {
						"type": "integer"
					},
					"EngineName": {},
					"MajorEngineVersion": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOptionGroupsResult",
				"type": "structure",
				"members": {
					"OptionGroupsList": {
						"type": "list",
						"member": {
							"shape": "St",
							"locationName": "OptionGroup"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeOrderableDBInstanceOptions": {
			"input": {
				"type": "structure",
				"required": [
					"Engine"
				],
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"DBInstanceClass": {},
					"LicenseModel": {},
					"Vpc": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
				"type": "structure",
				"members": {
					"OrderableDBInstanceOptions": {
						"type": "list",
						"member": {
							"locationName": "OrderableDBInstanceOption",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"DBInstanceClass": {},
								"LicenseModel": {},
								"AvailabilityZones": {
									"type": "list",
									"member": {
										"shape": "S1e",
										"locationName": "AvailabilityZone"
									}
								},
								"MultiAZCapable": {
									"type": "boolean"
								},
								"ReadReplicaCapable": {
									"type": "boolean"
								},
								"Vpc": {
									"type": "boolean"
								},
								"StorageType": {},
								"SupportsIops": {
									"type": "boolean"
								}
							},
							"wrapper": true
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeReservedDBInstances": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedDBInstancesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedDBInstances": {
						"type": "list",
						"member": {
							"shape": "S45",
							"locationName": "ReservedDBInstance"
						}
					}
				}
			}
		},
		"DescribeReservedDBInstancesOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S2b"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedDBInstancesOfferings": {
						"type": "list",
						"member": {
							"locationName": "ReservedDBInstancesOffering",
							"type": "structure",
							"members": {
								"ReservedDBInstancesOfferingId": {},
								"DBInstanceClass": {},
								"Duration": {
									"type": "integer"
								},
								"FixedPrice": {
									"type": "double"
								},
								"UsagePrice": {
									"type": "double"
								},
								"CurrencyCode": {},
								"ProductDescription": {},
								"OfferingType": {},
								"MultiAZ": {
									"type": "boolean"
								},
								"RecurringCharges": {
									"shape": "S47"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DownloadDBLogFilePortion": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"LogFileName"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"LogFileName": {},
					"Marker": {},
					"NumberOfLines": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DownloadDBLogFilePortionResult",
				"type": "structure",
				"members": {
					"LogFileData": {},
					"Marker": {},
					"AdditionalDataPending": {
						"type": "boolean"
					}
				}
			}
		},
		"ListTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName"
				],
				"members": {
					"ResourceName": {},
					"Filters": {
						"shape": "S2b"
					}
				}
			},
			"output": {
				"resultWrapper": "ListTagsForResourceResult",
				"type": "structure",
				"members": {
					"TagList": {
						"shape": "S9"
					}
				}
			}
		},
		"ModifyDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"DBInstanceClass": {},
					"DBSecurityGroups": {
						"shape": "S13"
					},
					"VpcSecurityGroupIds": {
						"shape": "S14"
					},
					"ApplyImmediately": {
						"type": "boolean"
					},
					"MasterUserPassword": {},
					"DBParameterGroupName": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {},
					"PreferredMaintenanceWindow": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AllowMajorVersionUpgrade": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"NewDBInstanceIdentifier": {},
					"StorageType": {},
					"TdeCredentialArn": {},
					"TdeCredentialPassword": {}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S17"
					}
				}
			}
		},
		"ModifyDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName",
					"Parameters"
				],
				"members": {
					"DBParameterGroupName": {},
					"Parameters": {
						"shape": "S2w"
					}
				}
			},
			"output": {
				"shape": "S4k",
				"resultWrapper": "ModifyDBParameterGroupResult"
			}
		},
		"ModifyDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName",
					"SubnetIds"
				],
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S1u"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBSubnetGroupResult",
				"type": "structure",
				"members": {
					"DBSubnetGroup": {
						"shape": "S1b"
					}
				}
			}
		},
		"ModifyEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"EventCategories": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"ModifyOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName"
				],
				"members": {
					"OptionGroupName": {},
					"OptionsToInclude": {
						"type": "list",
						"member": {
							"locationName": "OptionConfiguration",
							"type": "structure",
							"required": [
								"OptionName"
							],
							"members": {
								"OptionName": {},
								"Port": {
									"type": "integer"
								},
								"DBSecurityGroupMemberships": {
									"shape": "S13"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "S14"
								},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "Sx",
										"locationName": "OptionSetting"
									}
								}
							}
						}
					},
					"OptionsToRemove": {
						"type": "list",
						"member": {}
					},
					"ApplyImmediately": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "St"
					}
				}
			}
		},
		"PromoteReadReplica": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {}
				}
			},
			"output": {
				"resultWrapper": "PromoteReadReplicaResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S17"
					}
				}
			}
		},
		"PurchaseReservedDBInstancesOffering": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedDBInstancesOfferingId"
				],
				"members": {
					"ReservedDBInstancesOfferingId": {},
					"ReservedDBInstanceId": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"Tags": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
				"type": "structure",
				"members": {
					"ReservedDBInstance": {
						"shape": "S45"
					}
				}
			}
		},
		"RebootDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"ForceFailover": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "RebootDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S17"
					}
				}
			}
		},
		"RemoveSourceIdentifierFromSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SourceIdentifier"
				],
				"members": {
					"SubscriptionName": {},
					"SourceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S4"
					}
				}
			}
		},
		"RemoveTagsFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"TagKeys"
				],
				"members": {
					"ResourceName": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"ResetDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {},
					"ResetAllParameters": {
						"type": "boolean"
					},
					"Parameters": {
						"shape": "S2w"
					}
				}
			},
			"output": {
				"shape": "S4k",
				"resultWrapper": "ResetDBParameterGroupResult"
			}
		},
		"RestoreDBInstanceFromDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {},
					"DBInstanceClass": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"DBName": {},
					"Engine": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"Tags": {
						"shape": "S9"
					},
					"StorageType": {},
					"TdeCredentialArn": {},
					"TdeCredentialPassword": {}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S17"
					}
				}
			}
		},
		"RestoreDBInstanceToPointInTime": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBInstanceIdentifier",
					"TargetDBInstanceIdentifier"
				],
				"members": {
					"SourceDBInstanceIdentifier": {},
					"TargetDBInstanceIdentifier": {},
					"RestoreTime": {
						"type": "timestamp"
					},
					"UseLatestRestorableTime": {
						"type": "boolean"
					},
					"DBInstanceClass": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"DBName": {},
					"Engine": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"Tags": {
						"shape": "S9"
					},
					"StorageType": {},
					"TdeCredentialArn": {},
					"TdeCredentialPassword": {}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S17"
					}
				}
			}
		},
		"RevokeDBSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupId": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "RevokeDBSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sd"
					}
				}
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"CustomerAwsId": {},
				"CustSubscriptionId": {},
				"SnsTopicArn": {},
				"Status": {},
				"SubscriptionCreationTime": {},
				"SourceType": {},
				"SourceIdsList": {
					"shape": "S5"
				},
				"EventCategoriesList": {
					"shape": "S6"
				},
				"Enabled": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"S5": {
			"type": "list",
			"member": {
				"locationName": "SourceId"
			}
		},
		"S6": {
			"type": "list",
			"member": {
				"locationName": "EventCategory"
			}
		},
		"S9": {
			"type": "list",
			"member": {
				"locationName": "Tag",
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Sd": {
			"type": "structure",
			"members": {
				"OwnerId": {},
				"DBSecurityGroupName": {},
				"DBSecurityGroupDescription": {},
				"VpcId": {},
				"EC2SecurityGroups": {
					"type": "list",
					"member": {
						"locationName": "EC2SecurityGroup",
						"type": "structure",
						"members": {
							"Status": {},
							"EC2SecurityGroupName": {},
							"EC2SecurityGroupId": {},
							"EC2SecurityGroupOwnerId": {}
						}
					}
				},
				"IPRanges": {
					"type": "list",
					"member": {
						"locationName": "IPRange",
						"type": "structure",
						"members": {
							"Status": {},
							"CIDRIP": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"Sk": {
			"type": "structure",
			"members": {
				"DBParameterGroupName": {},
				"DBParameterGroupFamily": {},
				"Description": {}
			},
			"wrapper": true
		},
		"Sn": {
			"type": "structure",
			"members": {
				"DBSnapshotIdentifier": {},
				"DBInstanceIdentifier": {},
				"SnapshotCreateTime": {
					"type": "timestamp"
				},
				"Engine": {},
				"AllocatedStorage": {
					"type": "integer"
				},
				"Status": {},
				"Port": {
					"type": "integer"
				},
				"AvailabilityZone": {},
				"VpcId": {},
				"InstanceCreateTime": {
					"type": "timestamp"
				},
				"MasterUsername": {},
				"EngineVersion": {},
				"LicenseModel": {},
				"SnapshotType": {},
				"Iops": {
					"type": "integer"
				},
				"OptionGroupName": {},
				"PercentProgress": {
					"type": "integer"
				},
				"SourceRegion": {},
				"StorageType": {},
				"TdeCredentialArn": {}
			},
			"wrapper": true
		},
		"St": {
			"type": "structure",
			"members": {
				"OptionGroupName": {},
				"OptionGroupDescription": {},
				"EngineName": {},
				"MajorEngineVersion": {},
				"Options": {
					"type": "list",
					"member": {
						"locationName": "Option",
						"type": "structure",
						"members": {
							"OptionName": {},
							"OptionDescription": {},
							"Persistent": {
								"type": "boolean"
							},
							"Permanent": {
								"type": "boolean"
							},
							"Port": {
								"type": "integer"
							},
							"OptionSettings": {
								"type": "list",
								"member": {
									"shape": "Sx",
									"locationName": "OptionSetting"
								}
							},
							"DBSecurityGroupMemberships": {
								"shape": "Sy"
							},
							"VpcSecurityGroupMemberships": {
								"shape": "S10"
							}
						}
					}
				},
				"AllowsVpcAndNonVpcInstanceMemberships": {
					"type": "boolean"
				},
				"VpcId": {}
			},
			"wrapper": true
		},
		"Sx": {
			"type": "structure",
			"members": {
				"Name": {},
				"Value": {},
				"DefaultValue": {},
				"Description": {},
				"ApplyType": {},
				"DataType": {},
				"AllowedValues": {},
				"IsModifiable": {
					"type": "boolean"
				},
				"IsCollection": {
					"type": "boolean"
				}
			}
		},
		"Sy": {
			"type": "list",
			"member": {
				"locationName": "DBSecurityGroup",
				"type": "structure",
				"members": {
					"DBSecurityGroupName": {},
					"Status": {}
				}
			}
		},
		"S10": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupMembership",
				"type": "structure",
				"members": {
					"VpcSecurityGroupId": {},
					"Status": {}
				}
			}
		},
		"S13": {
			"type": "list",
			"member": {
				"locationName": "DBSecurityGroupName"
			}
		},
		"S14": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupId"
			}
		},
		"S17": {
			"type": "structure",
			"members": {
				"DBInstanceIdentifier": {},
				"DBInstanceClass": {},
				"Engine": {},
				"DBInstanceStatus": {},
				"MasterUsername": {},
				"DBName": {},
				"Endpoint": {
					"type": "structure",
					"members": {
						"Address": {},
						"Port": {
							"type": "integer"
						}
					}
				},
				"AllocatedStorage": {
					"type": "integer"
				},
				"InstanceCreateTime": {
					"type": "timestamp"
				},
				"PreferredBackupWindow": {},
				"BackupRetentionPeriod": {
					"type": "integer"
				},
				"DBSecurityGroups": {
					"shape": "Sy"
				},
				"VpcSecurityGroups": {
					"shape": "S10"
				},
				"DBParameterGroups": {
					"type": "list",
					"member": {
						"locationName": "DBParameterGroup",
						"type": "structure",
						"members": {
							"DBParameterGroupName": {},
							"ParameterApplyStatus": {}
						}
					}
				},
				"AvailabilityZone": {},
				"DBSubnetGroup": {
					"shape": "S1b"
				},
				"PreferredMaintenanceWindow": {},
				"PendingModifiedValues": {
					"type": "structure",
					"members": {
						"DBInstanceClass": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"MasterUserPassword": {},
						"Port": {
							"type": "integer"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"Iops": {
							"type": "integer"
						},
						"DBInstanceIdentifier": {},
						"StorageType": {}
					}
				},
				"LatestRestorableTime": {
					"type": "timestamp"
				},
				"MultiAZ": {
					"type": "boolean"
				},
				"EngineVersion": {},
				"AutoMinorVersionUpgrade": {
					"type": "boolean"
				},
				"ReadReplicaSourceDBInstanceIdentifier": {},
				"ReadReplicaDBInstanceIdentifiers": {
					"type": "list",
					"member": {
						"locationName": "ReadReplicaDBInstanceIdentifier"
					}
				},
				"LicenseModel": {},
				"Iops": {
					"type": "integer"
				},
				"OptionGroupMemberships": {
					"type": "list",
					"member": {
						"locationName": "OptionGroupMembership",
						"type": "structure",
						"members": {
							"OptionGroupName": {},
							"Status": {}
						}
					}
				},
				"CharacterSetName": {},
				"SecondaryAvailabilityZone": {},
				"PubliclyAccessible": {
					"type": "boolean"
				},
				"StatusInfos": {
					"type": "list",
					"member": {
						"locationName": "DBInstanceStatusInfo",
						"type": "structure",
						"members": {
							"StatusType": {},
							"Normal": {
								"type": "boolean"
							},
							"Status": {},
							"Message": {}
						}
					}
				},
				"StorageType": {},
				"TdeCredentialArn": {}
			},
			"wrapper": true
		},
		"S1b": {
			"type": "structure",
			"members": {
				"DBSubnetGroupName": {},
				"DBSubnetGroupDescription": {},
				"VpcId": {},
				"SubnetGroupStatus": {},
				"Subnets": {
					"type": "list",
					"member": {
						"locationName": "Subnet",
						"type": "structure",
						"members": {
							"SubnetIdentifier": {},
							"SubnetAvailabilityZone": {
								"shape": "S1e"
							},
							"SubnetStatus": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"S1e": {
			"type": "structure",
			"members": {
				"Name": {}
			},
			"wrapper": true
		},
		"S1u": {
			"type": "list",
			"member": {
				"locationName": "SubnetIdentifier"
			}
		},
		"S2b": {
			"type": "list",
			"member": {
				"locationName": "Filter",
				"type": "structure",
				"required": [
					"Name",
					"Values"
				],
				"members": {
					"Name": {},
					"Values": {
						"type": "list",
						"member": {
							"locationName": "Value"
						}
					}
				}
			}
		},
		"S2h": {
			"type": "structure",
			"members": {
				"CharacterSetName": {},
				"CharacterSetDescription": {}
			}
		},
		"S2w": {
			"type": "list",
			"member": {
				"locationName": "Parameter",
				"type": "structure",
				"members": {
					"ParameterName": {},
					"ParameterValue": {},
					"Description": {},
					"Source": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"MinimumEngineVersion": {},
					"ApplyMethod": {}
				}
			}
		},
		"S45": {
			"type": "structure",
			"members": {
				"ReservedDBInstanceId": {},
				"ReservedDBInstancesOfferingId": {},
				"DBInstanceClass": {},
				"StartTime": {
					"type": "timestamp"
				},
				"Duration": {
					"type": "integer"
				},
				"FixedPrice": {
					"type": "double"
				},
				"UsagePrice": {
					"type": "double"
				},
				"CurrencyCode": {},
				"DBInstanceCount": {
					"type": "integer"
				},
				"ProductDescription": {},
				"OfferingType": {},
				"MultiAZ": {
					"type": "boolean"
				},
				"State": {},
				"RecurringCharges": {
					"shape": "S47"
				}
			},
			"wrapper": true
		},
		"S47": {
			"type": "list",
			"member": {
				"locationName": "RecurringCharge",
				"type": "structure",
				"members": {
					"RecurringChargeAmount": {
						"type": "double"
					},
					"RecurringChargeFrequency": {}
				},
				"wrapper": true
			}
		},
		"S4k": {
			"type": "structure",
			"members": {
				"DBParameterGroupName": {}
			}
		}
	}
};

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-10-31",
		"endpointPrefix": "rds",
		"protocol": "query",
		"serviceAbbreviation": "Amazon RDS",
		"serviceFullName": "Amazon Relational Database Service",
		"signatureVersion": "v4",
		"uid": "rds-2014-10-31",
		"xmlNamespace": "http://rds.amazonaws.com/doc/2014-10-31/"
	},
	"operations": {
		"AddRoleToDBCluster": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterIdentifier",
					"RoleArn"
				],
				"members": {
					"DBClusterIdentifier": {},
					"RoleArn": {}
				}
			}
		},
		"AddSourceIdentifierToSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SourceIdentifier"
				],
				"members": {
					"SubscriptionName": {},
					"SourceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S5"
					}
				}
			}
		},
		"AddTagsToResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"Tags"
				],
				"members": {
					"ResourceName": {},
					"Tags": {
						"shape": "Sa"
					}
				}
			}
		},
		"ApplyPendingMaintenanceAction": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceIdentifier",
					"ApplyAction",
					"OptInType"
				],
				"members": {
					"ResourceIdentifier": {},
					"ApplyAction": {},
					"OptInType": {}
				}
			},
			"output": {
				"resultWrapper": "ApplyPendingMaintenanceActionResult",
				"type": "structure",
				"members": {
					"ResourcePendingMaintenanceActions": {
						"shape": "Se"
					}
				}
			}
		},
		"AuthorizeDBSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupId": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sk"
					}
				}
			}
		},
		"CopyDBClusterParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBClusterParameterGroupIdentifier",
					"TargetDBClusterParameterGroupIdentifier",
					"TargetDBClusterParameterGroupDescription"
				],
				"members": {
					"SourceDBClusterParameterGroupIdentifier": {},
					"TargetDBClusterParameterGroupIdentifier": {},
					"TargetDBClusterParameterGroupDescription": {},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CopyDBClusterParameterGroupResult",
				"type": "structure",
				"members": {
					"DBClusterParameterGroup": {
						"shape": "Sr"
					}
				}
			}
		},
		"CopyDBClusterSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBClusterSnapshotIdentifier",
					"TargetDBClusterSnapshotIdentifier"
				],
				"members": {
					"SourceDBClusterSnapshotIdentifier": {},
					"TargetDBClusterSnapshotIdentifier": {},
					"KmsKeyId": {},
					"PreSignedUrl": {},
					"CopyTags": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "Sa"
					},
					"SourceRegion": {}
				}
			},
			"output": {
				"resultWrapper": "CopyDBClusterSnapshotResult",
				"type": "structure",
				"members": {
					"DBClusterSnapshot": {
						"shape": "Sv"
					}
				}
			}
		},
		"CopyDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBParameterGroupIdentifier",
					"TargetDBParameterGroupIdentifier",
					"TargetDBParameterGroupDescription"
				],
				"members": {
					"SourceDBParameterGroupIdentifier": {},
					"TargetDBParameterGroupIdentifier": {},
					"TargetDBParameterGroupDescription": {},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CopyDBParameterGroupResult",
				"type": "structure",
				"members": {
					"DBParameterGroup": {
						"shape": "S10"
					}
				}
			}
		},
		"CopyDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBSnapshotIdentifier",
					"TargetDBSnapshotIdentifier"
				],
				"members": {
					"SourceDBSnapshotIdentifier": {},
					"TargetDBSnapshotIdentifier": {},
					"KmsKeyId": {},
					"Tags": {
						"shape": "Sa"
					},
					"CopyTags": {
						"type": "boolean"
					},
					"PreSignedUrl": {},
					"OptionGroupName": {},
					"SourceRegion": {}
				}
			},
			"output": {
				"resultWrapper": "CopyDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "S13"
					}
				}
			}
		},
		"CopyOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"SourceOptionGroupIdentifier",
					"TargetOptionGroupIdentifier",
					"TargetOptionGroupDescription"
				],
				"members": {
					"SourceOptionGroupIdentifier": {},
					"TargetOptionGroupIdentifier": {},
					"TargetOptionGroupDescription": {},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CopyOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "S17"
					}
				}
			}
		},
		"CreateDBCluster": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterIdentifier",
					"Engine"
				],
				"members": {
					"AvailabilityZones": {
						"shape": "Sw"
					},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"CharacterSetName": {},
					"DatabaseName": {},
					"DBClusterIdentifier": {},
					"DBClusterParameterGroupName": {},
					"VpcSecurityGroupIds": {
						"shape": "S1h"
					},
					"DBSubnetGroupName": {},
					"Engine": {},
					"EngineVersion": {},
					"Port": {
						"type": "integer"
					},
					"MasterUsername": {},
					"MasterUserPassword": {},
					"OptionGroupName": {},
					"PreferredBackupWindow": {},
					"PreferredMaintenanceWindow": {},
					"ReplicationSourceIdentifier": {},
					"Tags": {
						"shape": "Sa"
					},
					"StorageEncrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"PreSignedUrl": {},
					"EnableIAMDatabaseAuthentication": {
						"type": "boolean"
					},
					"SourceRegion": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBClusterResult",
				"type": "structure",
				"members": {
					"DBCluster": {
						"shape": "S1j"
					}
				}
			}
		},
		"CreateDBClusterParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterParameterGroupName",
					"DBParameterGroupFamily",
					"Description"
				],
				"members": {
					"DBClusterParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBClusterParameterGroupResult",
				"type": "structure",
				"members": {
					"DBClusterParameterGroup": {
						"shape": "Sr"
					}
				}
			}
		},
		"CreateDBClusterSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterSnapshotIdentifier",
					"DBClusterIdentifier"
				],
				"members": {
					"DBClusterSnapshotIdentifier": {},
					"DBClusterIdentifier": {},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBClusterSnapshotResult",
				"type": "structure",
				"members": {
					"DBClusterSnapshot": {
						"shape": "Sv"
					}
				}
			}
		},
		"CreateDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"DBInstanceClass",
					"Engine"
				],
				"members": {
					"DBName": {},
					"DBInstanceIdentifier": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"DBInstanceClass": {},
					"Engine": {},
					"MasterUsername": {},
					"MasterUserPassword": {},
					"DBSecurityGroups": {
						"shape": "S1w"
					},
					"VpcSecurityGroupIds": {
						"shape": "S1h"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"PreferredMaintenanceWindow": {},
					"DBParameterGroupName": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {},
					"Port": {
						"type": "integer"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"CharacterSetName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "Sa"
					},
					"DBClusterIdentifier": {},
					"StorageType": {},
					"TdeCredentialArn": {},
					"TdeCredentialPassword": {},
					"StorageEncrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"Domain": {},
					"CopyTagsToSnapshot": {
						"type": "boolean"
					},
					"MonitoringInterval": {
						"type": "integer"
					},
					"MonitoringRoleArn": {},
					"DomainIAMRoleName": {},
					"PromotionTier": {
						"type": "integer"
					},
					"Timezone": {},
					"EnableIAMDatabaseAuthentication": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S1y"
					}
				}
			}
		},
		"CreateDBInstanceReadReplica": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"SourceDBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"SourceDBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"AvailabilityZone": {},
					"Port": {
						"type": "integer"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "Sa"
					},
					"DBSubnetGroupName": {},
					"StorageType": {},
					"CopyTagsToSnapshot": {
						"type": "boolean"
					},
					"MonitoringInterval": {
						"type": "integer"
					},
					"MonitoringRoleArn": {},
					"KmsKeyId": {},
					"PreSignedUrl": {},
					"EnableIAMDatabaseAuthentication": {
						"type": "boolean"
					},
					"SourceRegion": {}
				}
			},
			"output": {
				"resultWrapper": "CreateDBInstanceReadReplicaResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S1y"
					}
				}
			}
		},
		"CreateDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName",
					"DBParameterGroupFamily",
					"Description"
				],
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBParameterGroupResult",
				"type": "structure",
				"members": {
					"DBParameterGroup": {
						"shape": "S10"
					}
				}
			}
		},
		"CreateDBSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName",
					"DBSecurityGroupDescription"
				],
				"members": {
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSecurityGroupResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sk"
					}
				}
			}
		},
		"CreateDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier",
					"DBInstanceIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "S13"
					}
				}
			}
		},
		"CreateDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName",
					"DBSubnetGroupDescription",
					"SubnetIds"
				],
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S2o"
					},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateDBSubnetGroupResult",
				"type": "structure",
				"members": {
					"DBSubnetGroup": {
						"shape": "S22"
					}
				}
			}
		},
		"CreateEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SnsTopicArn"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"EventCategories": {
						"shape": "S7"
					},
					"SourceIds": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S5"
					}
				}
			}
		},
		"CreateOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName",
					"EngineName",
					"MajorEngineVersion",
					"OptionGroupDescription"
				],
				"members": {
					"OptionGroupName": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"OptionGroupDescription": {},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "S17"
					}
				}
			}
		},
		"DeleteDBCluster": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterIdentifier"
				],
				"members": {
					"DBClusterIdentifier": {},
					"SkipFinalSnapshot": {
						"type": "boolean"
					},
					"FinalDBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBClusterResult",
				"type": "structure",
				"members": {
					"DBCluster": {
						"shape": "S1j"
					}
				}
			}
		},
		"DeleteDBClusterParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterParameterGroupName"
				],
				"members": {
					"DBClusterParameterGroupName": {}
				}
			}
		},
		"DeleteDBClusterSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterSnapshotIdentifier"
				],
				"members": {
					"DBClusterSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBClusterSnapshotResult",
				"type": "structure",
				"members": {
					"DBClusterSnapshot": {
						"shape": "Sv"
					}
				}
			}
		},
		"DeleteDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"SkipFinalSnapshot": {
						"type": "boolean"
					},
					"FinalDBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S1y"
					}
				}
			}
		},
		"DeleteDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {}
				}
			}
		},
		"DeleteDBSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {}
				}
			}
		},
		"DeleteDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "S13"
					}
				}
			}
		},
		"DeleteDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName"
				],
				"members": {
					"DBSubnetGroupName": {}
				}
			}
		},
		"DeleteEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S5"
					}
				}
			}
		},
		"DeleteOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName"
				],
				"members": {
					"OptionGroupName": {}
				}
			}
		},
		"DescribeAccountAttributes": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"resultWrapper": "DescribeAccountAttributesResult",
				"type": "structure",
				"members": {
					"AccountQuotas": {
						"type": "list",
						"member": {
							"locationName": "AccountQuota",
							"type": "structure",
							"members": {
								"AccountQuotaName": {},
								"Used": {
									"type": "long"
								},
								"Max": {
									"type": "long"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DescribeCertificates": {
			"input": {
				"type": "structure",
				"members": {
					"CertificateIdentifier": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeCertificatesResult",
				"type": "structure",
				"members": {
					"Certificates": {
						"type": "list",
						"member": {
							"locationName": "Certificate",
							"type": "structure",
							"members": {
								"CertificateIdentifier": {},
								"CertificateType": {},
								"Thumbprint": {},
								"ValidFrom": {
									"type": "timestamp"
								},
								"ValidTill": {
									"type": "timestamp"
								},
								"CertificateArn": {}
							},
							"wrapper": true
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBClusterParameterGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBClusterParameterGroupName": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBClusterParameterGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBClusterParameterGroups": {
						"type": "list",
						"member": {
							"shape": "Sr",
							"locationName": "DBClusterParameterGroup"
						}
					}
				}
			}
		},
		"DescribeDBClusterParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterParameterGroupName"
				],
				"members": {
					"DBClusterParameterGroupName": {},
					"Source": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBClusterParametersResult",
				"type": "structure",
				"members": {
					"Parameters": {
						"shape": "S3q"
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBClusterSnapshotAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterSnapshotIdentifier"
				],
				"members": {
					"DBClusterSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBClusterSnapshotAttributesResult",
				"type": "structure",
				"members": {
					"DBClusterSnapshotAttributesResult": {
						"shape": "S3v"
					}
				}
			}
		},
		"DescribeDBClusterSnapshots": {
			"input": {
				"type": "structure",
				"members": {
					"DBClusterIdentifier": {},
					"DBClusterSnapshotIdentifier": {},
					"SnapshotType": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"IncludeShared": {
						"type": "boolean"
					},
					"IncludePublic": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBClusterSnapshotsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBClusterSnapshots": {
						"type": "list",
						"member": {
							"shape": "Sv",
							"locationName": "DBClusterSnapshot"
						}
					}
				}
			}
		},
		"DescribeDBClusters": {
			"input": {
				"type": "structure",
				"members": {
					"DBClusterIdentifier": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBClustersResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBClusters": {
						"type": "list",
						"member": {
							"shape": "S1j",
							"locationName": "DBCluster"
						}
					}
				}
			}
		},
		"DescribeDBEngineVersions": {
			"input": {
				"type": "structure",
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"DBParameterGroupFamily": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"DefaultOnly": {
						"type": "boolean"
					},
					"ListSupportedCharacterSets": {
						"type": "boolean"
					},
					"ListSupportedTimezones": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBEngineVersionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBEngineVersions": {
						"type": "list",
						"member": {
							"locationName": "DBEngineVersion",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"DBParameterGroupFamily": {},
								"DBEngineDescription": {},
								"DBEngineVersionDescription": {},
								"DefaultCharacterSet": {
									"shape": "S49"
								},
								"SupportedCharacterSets": {
									"type": "list",
									"member": {
										"shape": "S49",
										"locationName": "CharacterSet"
									}
								},
								"ValidUpgradeTarget": {
									"type": "list",
									"member": {
										"locationName": "UpgradeTarget",
										"type": "structure",
										"members": {
											"Engine": {},
											"EngineVersion": {},
											"Description": {},
											"AutoUpgrade": {
												"type": "boolean"
											},
											"IsMajorVersionUpgrade": {
												"type": "boolean"
											}
										}
									}
								},
								"SupportedTimezones": {
									"type": "list",
									"member": {
										"locationName": "Timezone",
										"type": "structure",
										"members": {
											"TimezoneName": {}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"DescribeDBInstances": {
			"input": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBInstancesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBInstances": {
						"type": "list",
						"member": {
							"shape": "S1y",
							"locationName": "DBInstance"
						}
					}
				}
			}
		},
		"DescribeDBLogFiles": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"FilenameContains": {},
					"FileLastWritten": {
						"type": "long"
					},
					"FileSize": {
						"type": "long"
					},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBLogFilesResult",
				"type": "structure",
				"members": {
					"DescribeDBLogFiles": {
						"type": "list",
						"member": {
							"locationName": "DescribeDBLogFilesDetails",
							"type": "structure",
							"members": {
								"LogFileName": {},
								"LastWritten": {
									"type": "long"
								},
								"Size": {
									"type": "long"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBParameterGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBParameterGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"shape": "S10",
							"locationName": "DBParameterGroup"
						}
					}
				}
			}
		},
		"DescribeDBParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {},
					"Source": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBParametersResult",
				"type": "structure",
				"members": {
					"Parameters": {
						"shape": "S3q"
					},
					"Marker": {}
				}
			}
		},
		"DescribeDBSecurityGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBSecurityGroupName": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSecurityGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSecurityGroups": {
						"type": "list",
						"member": {
							"shape": "Sk",
							"locationName": "DBSecurityGroup"
						}
					}
				}
			}
		},
		"DescribeDBSnapshotAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSnapshotAttributesResult",
				"type": "structure",
				"members": {
					"DBSnapshotAttributesResult": {
						"shape": "S4w"
					}
				}
			}
		},
		"DescribeDBSnapshots": {
			"input": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {},
					"SnapshotType": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"IncludeShared": {
						"type": "boolean"
					},
					"IncludePublic": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSnapshotsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSnapshots": {
						"type": "list",
						"member": {
							"shape": "S13",
							"locationName": "DBSnapshot"
						}
					}
				}
			}
		},
		"DescribeDBSubnetGroups": {
			"input": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDBSubnetGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"DBSubnetGroups": {
						"type": "list",
						"member": {
							"shape": "S22",
							"locationName": "DBSubnetGroup"
						}
					}
				}
			}
		},
		"DescribeEngineDefaultClusterParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupFamily"
				],
				"members": {
					"DBParameterGroupFamily": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEngineDefaultClusterParametersResult",
				"type": "structure",
				"members": {
					"EngineDefaults": {
						"shape": "S57"
					}
				}
			}
		},
		"DescribeEngineDefaultParameters": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupFamily"
				],
				"members": {
					"DBParameterGroupFamily": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEngineDefaultParametersResult",
				"type": "structure",
				"members": {
					"EngineDefaults": {
						"shape": "S57"
					}
				}
			}
		},
		"DescribeEventCategories": {
			"input": {
				"type": "structure",
				"members": {
					"SourceType": {},
					"Filters": {
						"shape": "S3f"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventCategoriesResult",
				"type": "structure",
				"members": {
					"EventCategoriesMapList": {
						"type": "list",
						"member": {
							"locationName": "EventCategoriesMap",
							"type": "structure",
							"members": {
								"SourceType": {},
								"EventCategories": {
									"shape": "S7"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DescribeEventSubscriptions": {
			"input": {
				"type": "structure",
				"members": {
					"SubscriptionName": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventSubscriptionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"EventSubscriptionsList": {
						"type": "list",
						"member": {
							"shape": "S5",
							"locationName": "EventSubscription"
						}
					}
				}
			}
		},
		"DescribeEvents": {
			"input": {
				"type": "structure",
				"members": {
					"SourceIdentifier": {},
					"SourceType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"EventCategories": {
						"shape": "S7"
					},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Events": {
						"type": "list",
						"member": {
							"locationName": "Event",
							"type": "structure",
							"members": {
								"SourceIdentifier": {},
								"SourceType": {},
								"Message": {},
								"EventCategories": {
									"shape": "S7"
								},
								"Date": {
									"type": "timestamp"
								},
								"SourceArn": {}
							}
						}
					}
				}
			}
		},
		"DescribeOptionGroupOptions": {
			"input": {
				"type": "structure",
				"required": [
					"EngineName"
				],
				"members": {
					"EngineName": {},
					"MajorEngineVersion": {},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOptionGroupOptionsResult",
				"type": "structure",
				"members": {
					"OptionGroupOptions": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupOption",
							"type": "structure",
							"members": {
								"Name": {},
								"Description": {},
								"EngineName": {},
								"MajorEngineVersion": {},
								"MinimumRequiredMinorEngineVersion": {},
								"PortRequired": {
									"type": "boolean"
								},
								"DefaultPort": {
									"type": "integer"
								},
								"OptionsDependedOn": {
									"type": "list",
									"member": {
										"locationName": "OptionName"
									}
								},
								"OptionsConflictsWith": {
									"type": "list",
									"member": {
										"locationName": "OptionConflictName"
									}
								},
								"Persistent": {
									"type": "boolean"
								},
								"Permanent": {
									"type": "boolean"
								},
								"OptionGroupOptionSettings": {
									"type": "list",
									"member": {
										"locationName": "OptionGroupOptionSetting",
										"type": "structure",
										"members": {
											"SettingName": {},
											"SettingDescription": {},
											"DefaultValue": {},
											"ApplyType": {},
											"AllowedValues": {},
											"IsModifiable": {
												"type": "boolean"
											}
										}
									}
								},
								"OptionGroupOptionVersions": {
									"type": "list",
									"member": {
										"locationName": "OptionVersion",
										"type": "structure",
										"members": {
											"Version": {},
											"IsDefault": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeOptionGroups": {
			"input": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"Filters": {
						"shape": "S3f"
					},
					"Marker": {},
					"MaxRecords": {
						"type": "integer"
					},
					"EngineName": {},
					"MajorEngineVersion": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOptionGroupsResult",
				"type": "structure",
				"members": {
					"OptionGroupsList": {
						"type": "list",
						"member": {
							"shape": "S17",
							"locationName": "OptionGroup"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeOrderableDBInstanceOptions": {
			"input": {
				"type": "structure",
				"required": [
					"Engine"
				],
				"members": {
					"Engine": {},
					"EngineVersion": {},
					"DBInstanceClass": {},
					"LicenseModel": {},
					"Vpc": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
				"type": "structure",
				"members": {
					"OrderableDBInstanceOptions": {
						"type": "list",
						"member": {
							"locationName": "OrderableDBInstanceOption",
							"type": "structure",
							"members": {
								"Engine": {},
								"EngineVersion": {},
								"DBInstanceClass": {},
								"LicenseModel": {},
								"AvailabilityZones": {
									"type": "list",
									"member": {
										"shape": "S25",
										"locationName": "AvailabilityZone"
									}
								},
								"MultiAZCapable": {
									"type": "boolean"
								},
								"ReadReplicaCapable": {
									"type": "boolean"
								},
								"Vpc": {
									"type": "boolean"
								},
								"SupportsStorageEncryption": {
									"type": "boolean"
								},
								"StorageType": {},
								"SupportsIops": {
									"type": "boolean"
								},
								"SupportsEnhancedMonitoring": {
									"type": "boolean"
								},
								"SupportsIAMDatabaseAuthentication": {
									"type": "boolean"
								}
							},
							"wrapper": true
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribePendingMaintenanceActions": {
			"input": {
				"type": "structure",
				"members": {
					"ResourceIdentifier": {},
					"Filters": {
						"shape": "S3f"
					},
					"Marker": {},
					"MaxRecords": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribePendingMaintenanceActionsResult",
				"type": "structure",
				"members": {
					"PendingMaintenanceActions": {
						"type": "list",
						"member": {
							"shape": "Se",
							"locationName": "ResourcePendingMaintenanceActions"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeReservedDBInstances": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedDBInstancesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedDBInstances": {
						"type": "list",
						"member": {
							"shape": "S6a",
							"locationName": "ReservedDBInstance"
						}
					}
				}
			}
		},
		"DescribeReservedDBInstancesOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"Duration": {},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"Filters": {
						"shape": "S3f"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedDBInstancesOfferings": {
						"type": "list",
						"member": {
							"locationName": "ReservedDBInstancesOffering",
							"type": "structure",
							"members": {
								"ReservedDBInstancesOfferingId": {},
								"DBInstanceClass": {},
								"Duration": {
									"type": "integer"
								},
								"FixedPrice": {
									"type": "double"
								},
								"UsagePrice": {
									"type": "double"
								},
								"CurrencyCode": {},
								"ProductDescription": {},
								"OfferingType": {},
								"MultiAZ": {
									"type": "boolean"
								},
								"RecurringCharges": {
									"shape": "S6c"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DescribeSourceRegions": {
			"input": {
				"type": "structure",
				"members": {
					"RegionName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"Filters": {
						"shape": "S3f"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeSourceRegionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"SourceRegions": {
						"type": "list",
						"member": {
							"locationName": "SourceRegion",
							"type": "structure",
							"members": {
								"RegionName": {},
								"Endpoint": {},
								"Status": {}
							}
						}
					}
				}
			}
		},
		"DownloadDBLogFilePortion": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"LogFileName"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"LogFileName": {},
					"Marker": {},
					"NumberOfLines": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "DownloadDBLogFilePortionResult",
				"type": "structure",
				"members": {
					"LogFileData": {},
					"Marker": {},
					"AdditionalDataPending": {
						"type": "boolean"
					}
				}
			}
		},
		"FailoverDBCluster": {
			"input": {
				"type": "structure",
				"members": {
					"DBClusterIdentifier": {},
					"TargetDBInstanceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "FailoverDBClusterResult",
				"type": "structure",
				"members": {
					"DBCluster": {
						"shape": "S1j"
					}
				}
			}
		},
		"ListTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName"
				],
				"members": {
					"ResourceName": {},
					"Filters": {
						"shape": "S3f"
					}
				}
			},
			"output": {
				"resultWrapper": "ListTagsForResourceResult",
				"type": "structure",
				"members": {
					"TagList": {
						"shape": "Sa"
					}
				}
			}
		},
		"ModifyDBCluster": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterIdentifier"
				],
				"members": {
					"DBClusterIdentifier": {},
					"NewDBClusterIdentifier": {},
					"ApplyImmediately": {
						"type": "boolean"
					},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"DBClusterParameterGroupName": {},
					"VpcSecurityGroupIds": {
						"shape": "S1h"
					},
					"Port": {
						"type": "integer"
					},
					"MasterUserPassword": {},
					"OptionGroupName": {},
					"PreferredBackupWindow": {},
					"PreferredMaintenanceWindow": {},
					"EnableIAMDatabaseAuthentication": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBClusterResult",
				"type": "structure",
				"members": {
					"DBCluster": {
						"shape": "S1j"
					}
				}
			}
		},
		"ModifyDBClusterParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterParameterGroupName",
					"Parameters"
				],
				"members": {
					"DBClusterParameterGroupName": {},
					"Parameters": {
						"shape": "S3q"
					}
				}
			},
			"output": {
				"shape": "S6v",
				"resultWrapper": "ModifyDBClusterParameterGroupResult"
			}
		},
		"ModifyDBClusterSnapshotAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterSnapshotIdentifier",
					"AttributeName"
				],
				"members": {
					"DBClusterSnapshotIdentifier": {},
					"AttributeName": {},
					"ValuesToAdd": {
						"shape": "S3y"
					},
					"ValuesToRemove": {
						"shape": "S3y"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBClusterSnapshotAttributeResult",
				"type": "structure",
				"members": {
					"DBClusterSnapshotAttributesResult": {
						"shape": "S3v"
					}
				}
			}
		},
		"ModifyDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"DBInstanceClass": {},
					"DBSubnetGroupName": {},
					"DBSecurityGroups": {
						"shape": "S1w"
					},
					"VpcSecurityGroupIds": {
						"shape": "S1h"
					},
					"ApplyImmediately": {
						"type": "boolean"
					},
					"MasterUserPassword": {},
					"DBParameterGroupName": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {},
					"PreferredMaintenanceWindow": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AllowMajorVersionUpgrade": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"NewDBInstanceIdentifier": {},
					"StorageType": {},
					"TdeCredentialArn": {},
					"TdeCredentialPassword": {},
					"CACertificateIdentifier": {},
					"Domain": {},
					"CopyTagsToSnapshot": {
						"type": "boolean"
					},
					"MonitoringInterval": {
						"type": "integer"
					},
					"DBPortNumber": {
						"type": "integer"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"MonitoringRoleArn": {},
					"DomainIAMRoleName": {},
					"PromotionTier": {
						"type": "integer"
					},
					"EnableIAMDatabaseAuthentication": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S1y"
					}
				}
			}
		},
		"ModifyDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName",
					"Parameters"
				],
				"members": {
					"DBParameterGroupName": {},
					"Parameters": {
						"shape": "S3q"
					}
				}
			},
			"output": {
				"shape": "S71",
				"resultWrapper": "ModifyDBParameterGroupResult"
			}
		},
		"ModifyDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBSnapshotIdentifier": {},
					"EngineVersion": {}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBSnapshot": {
						"shape": "S13"
					}
				}
			}
		},
		"ModifyDBSnapshotAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"DBSnapshotIdentifier",
					"AttributeName"
				],
				"members": {
					"DBSnapshotIdentifier": {},
					"AttributeName": {},
					"ValuesToAdd": {
						"shape": "S3y"
					},
					"ValuesToRemove": {
						"shape": "S3y"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBSnapshotAttributeResult",
				"type": "structure",
				"members": {
					"DBSnapshotAttributesResult": {
						"shape": "S4w"
					}
				}
			}
		},
		"ModifyDBSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBSubnetGroupName",
					"SubnetIds"
				],
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"SubnetIds": {
						"shape": "S2o"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyDBSubnetGroupResult",
				"type": "structure",
				"members": {
					"DBSubnetGroup": {
						"shape": "S22"
					}
				}
			}
		},
		"ModifyEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"EventCategories": {
						"shape": "S7"
					},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S5"
					}
				}
			}
		},
		"ModifyOptionGroup": {
			"input": {
				"type": "structure",
				"required": [
					"OptionGroupName"
				],
				"members": {
					"OptionGroupName": {},
					"OptionsToInclude": {
						"type": "list",
						"member": {
							"locationName": "OptionConfiguration",
							"type": "structure",
							"required": [
								"OptionName"
							],
							"members": {
								"OptionName": {},
								"Port": {
									"type": "integer"
								},
								"OptionVersion": {},
								"DBSecurityGroupMemberships": {
									"shape": "S1w"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "S1h"
								},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "S1b",
										"locationName": "OptionSetting"
									}
								}
							}
						}
					},
					"OptionsToRemove": {
						"type": "list",
						"member": {}
					},
					"ApplyImmediately": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyOptionGroupResult",
				"type": "structure",
				"members": {
					"OptionGroup": {
						"shape": "S17"
					}
				}
			}
		},
		"PromoteReadReplica": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"PreferredBackupWindow": {}
				}
			},
			"output": {
				"resultWrapper": "PromoteReadReplicaResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S1y"
					}
				}
			}
		},
		"PromoteReadReplicaDBCluster": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterIdentifier"
				],
				"members": {
					"DBClusterIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "PromoteReadReplicaDBClusterResult",
				"type": "structure",
				"members": {
					"DBCluster": {
						"shape": "S1j"
					}
				}
			}
		},
		"PurchaseReservedDBInstancesOffering": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedDBInstancesOfferingId"
				],
				"members": {
					"ReservedDBInstancesOfferingId": {},
					"ReservedDBInstanceId": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"Tags": {
						"shape": "Sa"
					}
				}
			},
			"output": {
				"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
				"type": "structure",
				"members": {
					"ReservedDBInstance": {
						"shape": "S6a"
					}
				}
			}
		},
		"RebootDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"ForceFailover": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "RebootDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S1y"
					}
				}
			}
		},
		"RemoveRoleFromDBCluster": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterIdentifier",
					"RoleArn"
				],
				"members": {
					"DBClusterIdentifier": {},
					"RoleArn": {}
				}
			}
		},
		"RemoveSourceIdentifierFromSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SourceIdentifier"
				],
				"members": {
					"SubscriptionName": {},
					"SourceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S5"
					}
				}
			}
		},
		"RemoveTagsFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"TagKeys"
				],
				"members": {
					"ResourceName": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"ResetDBClusterParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterParameterGroupName"
				],
				"members": {
					"DBClusterParameterGroupName": {},
					"ResetAllParameters": {
						"type": "boolean"
					},
					"Parameters": {
						"shape": "S3q"
					}
				}
			},
			"output": {
				"shape": "S6v",
				"resultWrapper": "ResetDBClusterParameterGroupResult"
			}
		},
		"ResetDBParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"DBParameterGroupName"
				],
				"members": {
					"DBParameterGroupName": {},
					"ResetAllParameters": {
						"type": "boolean"
					},
					"Parameters": {
						"shape": "S3q"
					}
				}
			},
			"output": {
				"shape": "S71",
				"resultWrapper": "ResetDBParameterGroupResult"
			}
		},
		"RestoreDBClusterFromS3": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterIdentifier",
					"Engine",
					"MasterUsername",
					"MasterUserPassword",
					"SourceEngine",
					"SourceEngineVersion",
					"S3BucketName",
					"S3IngestionRoleArn"
				],
				"members": {
					"AvailabilityZones": {
						"shape": "Sw"
					},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"CharacterSetName": {},
					"DatabaseName": {},
					"DBClusterIdentifier": {},
					"DBClusterParameterGroupName": {},
					"VpcSecurityGroupIds": {
						"shape": "S1h"
					},
					"DBSubnetGroupName": {},
					"Engine": {},
					"EngineVersion": {},
					"Port": {
						"type": "integer"
					},
					"MasterUsername": {},
					"MasterUserPassword": {},
					"OptionGroupName": {},
					"PreferredBackupWindow": {},
					"PreferredMaintenanceWindow": {},
					"Tags": {
						"shape": "Sa"
					},
					"StorageEncrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"EnableIAMDatabaseAuthentication": {
						"type": "boolean"
					},
					"SourceEngine": {},
					"SourceEngineVersion": {},
					"S3BucketName": {},
					"S3Prefix": {},
					"S3IngestionRoleArn": {}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBClusterFromS3Result",
				"type": "structure",
				"members": {
					"DBCluster": {
						"shape": "S1j"
					}
				}
			}
		},
		"RestoreDBClusterFromSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterIdentifier",
					"SnapshotIdentifier",
					"Engine"
				],
				"members": {
					"AvailabilityZones": {
						"shape": "Sw"
					},
					"DBClusterIdentifier": {},
					"SnapshotIdentifier": {},
					"Engine": {},
					"EngineVersion": {},
					"Port": {
						"type": "integer"
					},
					"DBSubnetGroupName": {},
					"DatabaseName": {},
					"OptionGroupName": {},
					"VpcSecurityGroupIds": {
						"shape": "S1h"
					},
					"Tags": {
						"shape": "Sa"
					},
					"KmsKeyId": {},
					"EnableIAMDatabaseAuthentication": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBClusterFromSnapshotResult",
				"type": "structure",
				"members": {
					"DBCluster": {
						"shape": "S1j"
					}
				}
			}
		},
		"RestoreDBClusterToPointInTime": {
			"input": {
				"type": "structure",
				"required": [
					"DBClusterIdentifier",
					"SourceDBClusterIdentifier"
				],
				"members": {
					"DBClusterIdentifier": {},
					"RestoreType": {},
					"SourceDBClusterIdentifier": {},
					"RestoreToTime": {
						"type": "timestamp"
					},
					"UseLatestRestorableTime": {
						"type": "boolean"
					},
					"Port": {
						"type": "integer"
					},
					"DBSubnetGroupName": {},
					"OptionGroupName": {},
					"VpcSecurityGroupIds": {
						"shape": "S1h"
					},
					"Tags": {
						"shape": "Sa"
					},
					"KmsKeyId": {},
					"EnableIAMDatabaseAuthentication": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBClusterToPointInTimeResult",
				"type": "structure",
				"members": {
					"DBCluster": {
						"shape": "S1j"
					}
				}
			}
		},
		"RestoreDBInstanceFromDBSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier",
					"DBSnapshotIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {},
					"DBInstanceClass": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"DBName": {},
					"Engine": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"Tags": {
						"shape": "Sa"
					},
					"StorageType": {},
					"TdeCredentialArn": {},
					"TdeCredentialPassword": {},
					"Domain": {},
					"CopyTagsToSnapshot": {
						"type": "boolean"
					},
					"DomainIAMRoleName": {},
					"EnableIAMDatabaseAuthentication": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S1y"
					}
				}
			}
		},
		"RestoreDBInstanceToPointInTime": {
			"input": {
				"type": "structure",
				"required": [
					"SourceDBInstanceIdentifier",
					"TargetDBInstanceIdentifier"
				],
				"members": {
					"SourceDBInstanceIdentifier": {},
					"TargetDBInstanceIdentifier": {},
					"RestoreTime": {
						"type": "timestamp"
					},
					"UseLatestRestorableTime": {
						"type": "boolean"
					},
					"DBInstanceClass": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"DBSubnetGroupName": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"LicenseModel": {},
					"DBName": {},
					"Engine": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"CopyTagsToSnapshot": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "Sa"
					},
					"StorageType": {},
					"TdeCredentialArn": {},
					"TdeCredentialPassword": {},
					"Domain": {},
					"DomainIAMRoleName": {},
					"EnableIAMDatabaseAuthentication": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S1y"
					}
				}
			}
		},
		"RevokeDBSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"DBSecurityGroupName"
				],
				"members": {
					"DBSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupId": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "RevokeDBSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"DBSecurityGroup": {
						"shape": "Sk"
					}
				}
			}
		},
		"StartDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "StartDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S1y"
					}
				}
			}
		},
		"StopDBInstance": {
			"input": {
				"type": "structure",
				"required": [
					"DBInstanceIdentifier"
				],
				"members": {
					"DBInstanceIdentifier": {},
					"DBSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "StopDBInstanceResult",
				"type": "structure",
				"members": {
					"DBInstance": {
						"shape": "S1y"
					}
				}
			}
		}
	},
	"shapes": {
		"S5": {
			"type": "structure",
			"members": {
				"CustomerAwsId": {},
				"CustSubscriptionId": {},
				"SnsTopicArn": {},
				"Status": {},
				"SubscriptionCreationTime": {},
				"SourceType": {},
				"SourceIdsList": {
					"shape": "S6"
				},
				"EventCategoriesList": {
					"shape": "S7"
				},
				"Enabled": {
					"type": "boolean"
				},
				"EventSubscriptionArn": {}
			},
			"wrapper": true
		},
		"S6": {
			"type": "list",
			"member": {
				"locationName": "SourceId"
			}
		},
		"S7": {
			"type": "list",
			"member": {
				"locationName": "EventCategory"
			}
		},
		"Sa": {
			"type": "list",
			"member": {
				"locationName": "Tag",
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Se": {
			"type": "structure",
			"members": {
				"ResourceIdentifier": {},
				"PendingMaintenanceActionDetails": {
					"type": "list",
					"member": {
						"locationName": "PendingMaintenanceAction",
						"type": "structure",
						"members": {
							"Action": {},
							"AutoAppliedAfterDate": {
								"type": "timestamp"
							},
							"ForcedApplyDate": {
								"type": "timestamp"
							},
							"OptInStatus": {},
							"CurrentApplyDate": {
								"type": "timestamp"
							},
							"Description": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"Sk": {
			"type": "structure",
			"members": {
				"OwnerId": {},
				"DBSecurityGroupName": {},
				"DBSecurityGroupDescription": {},
				"VpcId": {},
				"EC2SecurityGroups": {
					"type": "list",
					"member": {
						"locationName": "EC2SecurityGroup",
						"type": "structure",
						"members": {
							"Status": {},
							"EC2SecurityGroupName": {},
							"EC2SecurityGroupId": {},
							"EC2SecurityGroupOwnerId": {}
						}
					}
				},
				"IPRanges": {
					"type": "list",
					"member": {
						"locationName": "IPRange",
						"type": "structure",
						"members": {
							"Status": {},
							"CIDRIP": {}
						}
					}
				},
				"DBSecurityGroupArn": {}
			},
			"wrapper": true
		},
		"Sr": {
			"type": "structure",
			"members": {
				"DBClusterParameterGroupName": {},
				"DBParameterGroupFamily": {},
				"Description": {},
				"DBClusterParameterGroupArn": {}
			},
			"wrapper": true
		},
		"Sv": {
			"type": "structure",
			"members": {
				"AvailabilityZones": {
					"shape": "Sw"
				},
				"DBClusterSnapshotIdentifier": {},
				"DBClusterIdentifier": {},
				"SnapshotCreateTime": {
					"type": "timestamp"
				},
				"Engine": {},
				"AllocatedStorage": {
					"type": "integer"
				},
				"Status": {},
				"Port": {
					"type": "integer"
				},
				"VpcId": {},
				"ClusterCreateTime": {
					"type": "timestamp"
				},
				"MasterUsername": {},
				"EngineVersion": {},
				"LicenseModel": {},
				"SnapshotType": {},
				"PercentProgress": {
					"type": "integer"
				},
				"StorageEncrypted": {
					"type": "boolean"
				},
				"KmsKeyId": {},
				"DBClusterSnapshotArn": {},
				"SourceDBClusterSnapshotArn": {},
				"IAMDatabaseAuthenticationEnabled": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"Sw": {
			"type": "list",
			"member": {
				"locationName": "AvailabilityZone"
			}
		},
		"S10": {
			"type": "structure",
			"members": {
				"DBParameterGroupName": {},
				"DBParameterGroupFamily": {},
				"Description": {},
				"DBParameterGroupArn": {}
			},
			"wrapper": true
		},
		"S13": {
			"type": "structure",
			"members": {
				"DBSnapshotIdentifier": {},
				"DBInstanceIdentifier": {},
				"SnapshotCreateTime": {
					"type": "timestamp"
				},
				"Engine": {},
				"AllocatedStorage": {
					"type": "integer"
				},
				"Status": {},
				"Port": {
					"type": "integer"
				},
				"AvailabilityZone": {},
				"VpcId": {},
				"InstanceCreateTime": {
					"type": "timestamp"
				},
				"MasterUsername": {},
				"EngineVersion": {},
				"LicenseModel": {},
				"SnapshotType": {},
				"Iops": {
					"type": "integer"
				},
				"OptionGroupName": {},
				"PercentProgress": {
					"type": "integer"
				},
				"SourceRegion": {},
				"SourceDBSnapshotIdentifier": {},
				"StorageType": {},
				"TdeCredentialArn": {},
				"Encrypted": {
					"type": "boolean"
				},
				"KmsKeyId": {},
				"DBSnapshotArn": {},
				"Timezone": {},
				"IAMDatabaseAuthenticationEnabled": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"S17": {
			"type": "structure",
			"members": {
				"OptionGroupName": {},
				"OptionGroupDescription": {},
				"EngineName": {},
				"MajorEngineVersion": {},
				"Options": {
					"type": "list",
					"member": {
						"locationName": "Option",
						"type": "structure",
						"members": {
							"OptionName": {},
							"OptionDescription": {},
							"Persistent": {
								"type": "boolean"
							},
							"Permanent": {
								"type": "boolean"
							},
							"Port": {
								"type": "integer"
							},
							"OptionVersion": {},
							"OptionSettings": {
								"type": "list",
								"member": {
									"shape": "S1b",
									"locationName": "OptionSetting"
								}
							},
							"DBSecurityGroupMemberships": {
								"shape": "S1c"
							},
							"VpcSecurityGroupMemberships": {
								"shape": "S1e"
							}
						}
					}
				},
				"AllowsVpcAndNonVpcInstanceMemberships": {
					"type": "boolean"
				},
				"VpcId": {},
				"OptionGroupArn": {}
			},
			"wrapper": true
		},
		"S1b": {
			"type": "structure",
			"members": {
				"Name": {},
				"Value": {},
				"DefaultValue": {},
				"Description": {},
				"ApplyType": {},
				"DataType": {},
				"AllowedValues": {},
				"IsModifiable": {
					"type": "boolean"
				},
				"IsCollection": {
					"type": "boolean"
				}
			}
		},
		"S1c": {
			"type": "list",
			"member": {
				"locationName": "DBSecurityGroup",
				"type": "structure",
				"members": {
					"DBSecurityGroupName": {},
					"Status": {}
				}
			}
		},
		"S1e": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupMembership",
				"type": "structure",
				"members": {
					"VpcSecurityGroupId": {},
					"Status": {}
				}
			}
		},
		"S1h": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupId"
			}
		},
		"S1j": {
			"type": "structure",
			"members": {
				"AllocatedStorage": {
					"type": "integer"
				},
				"AvailabilityZones": {
					"shape": "Sw"
				},
				"BackupRetentionPeriod": {
					"type": "integer"
				},
				"CharacterSetName": {},
				"DatabaseName": {},
				"DBClusterIdentifier": {},
				"DBClusterParameterGroup": {},
				"DBSubnetGroup": {},
				"Status": {},
				"PercentProgress": {},
				"EarliestRestorableTime": {
					"type": "timestamp"
				},
				"Endpoint": {},
				"ReaderEndpoint": {},
				"MultiAZ": {
					"type": "boolean"
				},
				"Engine": {},
				"EngineVersion": {},
				"LatestRestorableTime": {
					"type": "timestamp"
				},
				"Port": {
					"type": "integer"
				},
				"MasterUsername": {},
				"DBClusterOptionGroupMemberships": {
					"type": "list",
					"member": {
						"locationName": "DBClusterOptionGroup",
						"type": "structure",
						"members": {
							"DBClusterOptionGroupName": {},
							"Status": {}
						}
					}
				},
				"PreferredBackupWindow": {},
				"PreferredMaintenanceWindow": {},
				"ReplicationSourceIdentifier": {},
				"ReadReplicaIdentifiers": {
					"type": "list",
					"member": {
						"locationName": "ReadReplicaIdentifier"
					}
				},
				"DBClusterMembers": {
					"type": "list",
					"member": {
						"locationName": "DBClusterMember",
						"type": "structure",
						"members": {
							"DBInstanceIdentifier": {},
							"IsClusterWriter": {
								"type": "boolean"
							},
							"DBClusterParameterGroupStatus": {},
							"PromotionTier": {
								"type": "integer"
							}
						},
						"wrapper": true
					}
				},
				"VpcSecurityGroups": {
					"shape": "S1e"
				},
				"HostedZoneId": {},
				"StorageEncrypted": {
					"type": "boolean"
				},
				"KmsKeyId": {},
				"DbClusterResourceId": {},
				"DBClusterArn": {},
				"AssociatedRoles": {
					"type": "list",
					"member": {
						"locationName": "DBClusterRole",
						"type": "structure",
						"members": {
							"RoleArn": {},
							"Status": {}
						}
					}
				},
				"IAMDatabaseAuthenticationEnabled": {
					"type": "boolean"
				},
				"CloneGroupId": {},
				"ClusterCreateTime": {
					"type": "timestamp"
				}
			},
			"wrapper": true
		},
		"S1w": {
			"type": "list",
			"member": {
				"locationName": "DBSecurityGroupName"
			}
		},
		"S1y": {
			"type": "structure",
			"members": {
				"DBInstanceIdentifier": {},
				"DBInstanceClass": {},
				"Engine": {},
				"DBInstanceStatus": {},
				"MasterUsername": {},
				"DBName": {},
				"Endpoint": {
					"type": "structure",
					"members": {
						"Address": {},
						"Port": {
							"type": "integer"
						},
						"HostedZoneId": {}
					}
				},
				"AllocatedStorage": {
					"type": "integer"
				},
				"InstanceCreateTime": {
					"type": "timestamp"
				},
				"PreferredBackupWindow": {},
				"BackupRetentionPeriod": {
					"type": "integer"
				},
				"DBSecurityGroups": {
					"shape": "S1c"
				},
				"VpcSecurityGroups": {
					"shape": "S1e"
				},
				"DBParameterGroups": {
					"type": "list",
					"member": {
						"locationName": "DBParameterGroup",
						"type": "structure",
						"members": {
							"DBParameterGroupName": {},
							"ParameterApplyStatus": {}
						}
					}
				},
				"AvailabilityZone": {},
				"DBSubnetGroup": {
					"shape": "S22"
				},
				"PreferredMaintenanceWindow": {},
				"PendingModifiedValues": {
					"type": "structure",
					"members": {
						"DBInstanceClass": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"MasterUserPassword": {},
						"Port": {
							"type": "integer"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"DBInstanceIdentifier": {},
						"StorageType": {},
						"CACertificateIdentifier": {},
						"DBSubnetGroupName": {}
					}
				},
				"LatestRestorableTime": {
					"type": "timestamp"
				},
				"MultiAZ": {
					"type": "boolean"
				},
				"EngineVersion": {},
				"AutoMinorVersionUpgrade": {
					"type": "boolean"
				},
				"ReadReplicaSourceDBInstanceIdentifier": {},
				"ReadReplicaDBInstanceIdentifiers": {
					"type": "list",
					"member": {
						"locationName": "ReadReplicaDBInstanceIdentifier"
					}
				},
				"ReadReplicaDBClusterIdentifiers": {
					"type": "list",
					"member": {
						"locationName": "ReadReplicaDBClusterIdentifier"
					}
				},
				"LicenseModel": {},
				"Iops": {
					"type": "integer"
				},
				"OptionGroupMemberships": {
					"type": "list",
					"member": {
						"locationName": "OptionGroupMembership",
						"type": "structure",
						"members": {
							"OptionGroupName": {},
							"Status": {}
						}
					}
				},
				"CharacterSetName": {},
				"SecondaryAvailabilityZone": {},
				"PubliclyAccessible": {
					"type": "boolean"
				},
				"StatusInfos": {
					"type": "list",
					"member": {
						"locationName": "DBInstanceStatusInfo",
						"type": "structure",
						"members": {
							"StatusType": {},
							"Normal": {
								"type": "boolean"
							},
							"Status": {},
							"Message": {}
						}
					}
				},
				"StorageType": {},
				"TdeCredentialArn": {},
				"DbInstancePort": {
					"type": "integer"
				},
				"DBClusterIdentifier": {},
				"StorageEncrypted": {
					"type": "boolean"
				},
				"KmsKeyId": {},
				"DbiResourceId": {},
				"CACertificateIdentifier": {},
				"DomainMemberships": {
					"type": "list",
					"member": {
						"locationName": "DomainMembership",
						"type": "structure",
						"members": {
							"Domain": {},
							"Status": {},
							"FQDN": {},
							"IAMRoleName": {}
						}
					}
				},
				"CopyTagsToSnapshot": {
					"type": "boolean"
				},
				"MonitoringInterval": {
					"type": "integer"
				},
				"EnhancedMonitoringResourceArn": {},
				"MonitoringRoleArn": {},
				"PromotionTier": {
					"type": "integer"
				},
				"DBInstanceArn": {},
				"Timezone": {},
				"IAMDatabaseAuthenticationEnabled": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"S22": {
			"type": "structure",
			"members": {
				"DBSubnetGroupName": {},
				"DBSubnetGroupDescription": {},
				"VpcId": {},
				"SubnetGroupStatus": {},
				"Subnets": {
					"type": "list",
					"member": {
						"locationName": "Subnet",
						"type": "structure",
						"members": {
							"SubnetIdentifier": {},
							"SubnetAvailabilityZone": {
								"shape": "S25"
							},
							"SubnetStatus": {}
						}
					}
				},
				"DBSubnetGroupArn": {}
			},
			"wrapper": true
		},
		"S25": {
			"type": "structure",
			"members": {
				"Name": {}
			},
			"wrapper": true
		},
		"S2o": {
			"type": "list",
			"member": {
				"locationName": "SubnetIdentifier"
			}
		},
		"S3f": {
			"type": "list",
			"member": {
				"locationName": "Filter",
				"type": "structure",
				"required": [
					"Name",
					"Values"
				],
				"members": {
					"Name": {},
					"Values": {
						"type": "list",
						"member": {
							"locationName": "Value"
						}
					}
				}
			}
		},
		"S3q": {
			"type": "list",
			"member": {
				"locationName": "Parameter",
				"type": "structure",
				"members": {
					"ParameterName": {},
					"ParameterValue": {},
					"Description": {},
					"Source": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"MinimumEngineVersion": {},
					"ApplyMethod": {}
				}
			}
		},
		"S3v": {
			"type": "structure",
			"members": {
				"DBClusterSnapshotIdentifier": {},
				"DBClusterSnapshotAttributes": {
					"type": "list",
					"member": {
						"locationName": "DBClusterSnapshotAttribute",
						"type": "structure",
						"members": {
							"AttributeName": {},
							"AttributeValues": {
								"shape": "S3y"
							}
						}
					}
				}
			},
			"wrapper": true
		},
		"S3y": {
			"type": "list",
			"member": {
				"locationName": "AttributeValue"
			}
		},
		"S49": {
			"type": "structure",
			"members": {
				"CharacterSetName": {},
				"CharacterSetDescription": {}
			}
		},
		"S4w": {
			"type": "structure",
			"members": {
				"DBSnapshotIdentifier": {},
				"DBSnapshotAttributes": {
					"type": "list",
					"member": {
						"locationName": "DBSnapshotAttribute",
						"type": "structure",
						"members": {
							"AttributeName": {},
							"AttributeValues": {
								"shape": "S3y"
							}
						},
						"wrapper": true
					}
				}
			},
			"wrapper": true
		},
		"S57": {
			"type": "structure",
			"members": {
				"DBParameterGroupFamily": {},
				"Marker": {},
				"Parameters": {
					"shape": "S3q"
				}
			},
			"wrapper": true
		},
		"S6a": {
			"type": "structure",
			"members": {
				"ReservedDBInstanceId": {},
				"ReservedDBInstancesOfferingId": {},
				"DBInstanceClass": {},
				"StartTime": {
					"type": "timestamp"
				},
				"Duration": {
					"type": "integer"
				},
				"FixedPrice": {
					"type": "double"
				},
				"UsagePrice": {
					"type": "double"
				},
				"CurrencyCode": {},
				"DBInstanceCount": {
					"type": "integer"
				},
				"ProductDescription": {},
				"OfferingType": {},
				"MultiAZ": {
					"type": "boolean"
				},
				"State": {},
				"RecurringCharges": {
					"shape": "S6c"
				},
				"ReservedDBInstanceArn": {}
			},
			"wrapper": true
		},
		"S6c": {
			"type": "list",
			"member": {
				"locationName": "RecurringCharge",
				"type": "structure",
				"members": {
					"RecurringChargeAmount": {
						"type": "double"
					},
					"RecurringChargeFrequency": {}
				},
				"wrapper": true
			}
		},
		"S6v": {
			"type": "structure",
			"members": {
				"DBClusterParameterGroupName": {}
			}
		},
		"S71": {
			"type": "structure",
			"members": {
				"DBParameterGroupName": {}
			}
		}
	}
};

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeDBEngineVersions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBEngineVersions"
		},
		"DescribeDBInstances": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBInstances"
		},
		"DescribeDBLogFiles": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DescribeDBLogFiles"
		},
		"DescribeDBParameterGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBParameterGroups"
		},
		"DescribeDBParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Parameters"
		},
		"DescribeDBSecurityGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSecurityGroups"
		},
		"DescribeDBSnapshots": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSnapshots"
		},
		"DescribeDBSubnetGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "DBSubnetGroups"
		},
		"DescribeEngineDefaultParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "EngineDefaults.Marker",
			"result_key": "EngineDefaults.Parameters"
		},
		"DescribeEventSubscriptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "EventSubscriptionsList"
		},
		"DescribeEvents": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Events"
		},
		"DescribeOptionGroupOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OptionGroupOptions"
		},
		"DescribeOptionGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OptionGroupsList"
		},
		"DescribeOrderableDBInstanceOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OrderableDBInstanceOptions"
		},
		"DescribeReservedDBInstances": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedDBInstances"
		},
		"DescribeReservedDBInstancesOfferings": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedDBInstancesOfferings"
		},
		"DownloadDBLogFilePortion": {
			"input_token": "Marker",
			"limit_key": "NumberOfLines",
			"more_results": "AdditionalDataPending",
			"output_token": "Marker",
			"result_key": "LogFileData"
		},
		"ListTagsForResource": {
			"result_key": "TagList"
		}
	}
};

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"DBInstanceAvailable": {
			"delay": 30,
			"operation": "DescribeDBInstances",
			"maxAttempts": 60,
			"acceptors": [
				{
					"expected": "available",
					"matcher": "pathAll",
					"state": "success",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "deleted",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "deleting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "incompatible-restore",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "incompatible-parameters",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				}
			]
		},
		"DBInstanceDeleted": {
			"delay": 30,
			"operation": "DescribeDBInstances",
			"maxAttempts": 60,
			"acceptors": [
				{
					"expected": "deleted",
					"matcher": "pathAll",
					"state": "success",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "DBInstanceNotFound",
					"matcher": "error",
					"state": "success"
				},
				{
					"expected": "creating",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "modifying",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "rebooting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				},
				{
					"expected": "resetting-master-credentials",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "DBInstances[].DBInstanceStatus"
				}
			]
		}
	}
};

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['redshift'] = {};
AWS.Redshift = Service.defineService('redshift', ['2012-12-01']);
Object.defineProperty(apiLoader.services['redshift'], '2012-12-01', {
  get: function get() {
    var model = __webpack_require__(1694);
    model.paginators = __webpack_require__(1695).pagination;
    model.waiters = __webpack_require__(1696).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Redshift;


/***/ }),
/* 1694 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2012-12-01",
		"endpointPrefix": "redshift",
		"protocol": "query",
		"serviceFullName": "Amazon Redshift",
		"signatureVersion": "v4",
		"uid": "redshift-2012-12-01",
		"xmlNamespace": "http://redshift.amazonaws.com/doc/2012-12-01/"
	},
	"operations": {
		"AuthorizeClusterSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterSecurityGroupName"
				],
				"members": {
					"ClusterSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "AuthorizeClusterSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"ClusterSecurityGroup": {
						"shape": "S4"
					}
				}
			}
		},
		"AuthorizeSnapshotAccess": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotIdentifier",
					"AccountWithRestoreAccess"
				],
				"members": {
					"SnapshotIdentifier": {},
					"SnapshotClusterIdentifier": {},
					"AccountWithRestoreAccess": {}
				}
			},
			"output": {
				"resultWrapper": "AuthorizeSnapshotAccessResult",
				"type": "structure",
				"members": {
					"Snapshot": {
						"shape": "Sd"
					}
				}
			}
		},
		"CopyClusterSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SourceSnapshotIdentifier",
					"TargetSnapshotIdentifier"
				],
				"members": {
					"SourceSnapshotIdentifier": {},
					"SourceSnapshotClusterIdentifier": {},
					"TargetSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "CopyClusterSnapshotResult",
				"type": "structure",
				"members": {
					"Snapshot": {
						"shape": "Sd"
					}
				}
			}
		},
		"CreateCluster": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier",
					"NodeType",
					"MasterUsername",
					"MasterUserPassword"
				],
				"members": {
					"DBName": {},
					"ClusterIdentifier": {},
					"ClusterType": {},
					"NodeType": {},
					"MasterUsername": {},
					"MasterUserPassword": {},
					"ClusterSecurityGroups": {
						"shape": "Sp"
					},
					"VpcSecurityGroupIds": {
						"shape": "Sq"
					},
					"ClusterSubnetGroupName": {},
					"AvailabilityZone": {},
					"PreferredMaintenanceWindow": {},
					"ClusterParameterGroupName": {},
					"AutomatedSnapshotRetentionPeriod": {
						"type": "integer"
					},
					"Port": {
						"type": "integer"
					},
					"ClusterVersion": {},
					"AllowVersionUpgrade": {
						"type": "boolean"
					},
					"NumberOfNodes": {
						"type": "integer"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"Encrypted": {
						"type": "boolean"
					},
					"HsmClientCertificateIdentifier": {},
					"HsmConfigurationIdentifier": {},
					"ElasticIp": {},
					"Tags": {
						"shape": "S7"
					},
					"KmsKeyId": {},
					"EnhancedVpcRouting": {
						"type": "boolean"
					},
					"AdditionalInfo": {},
					"IamRoles": {
						"shape": "St"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateClusterResult",
				"type": "structure",
				"members": {
					"Cluster": {
						"shape": "Sv"
					}
				}
			}
		},
		"CreateClusterParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ParameterGroupName",
					"ParameterGroupFamily",
					"Description"
				],
				"members": {
					"ParameterGroupName": {},
					"ParameterGroupFamily": {},
					"Description": {},
					"Tags": {
						"shape": "S7"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateClusterParameterGroupResult",
				"type": "structure",
				"members": {
					"ClusterParameterGroup": {
						"shape": "S1g"
					}
				}
			}
		},
		"CreateClusterSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterSecurityGroupName",
					"Description"
				],
				"members": {
					"ClusterSecurityGroupName": {},
					"Description": {},
					"Tags": {
						"shape": "S7"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateClusterSecurityGroupResult",
				"type": "structure",
				"members": {
					"ClusterSecurityGroup": {
						"shape": "S4"
					}
				}
			}
		},
		"CreateClusterSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotIdentifier",
					"ClusterIdentifier"
				],
				"members": {
					"SnapshotIdentifier": {},
					"ClusterIdentifier": {},
					"Tags": {
						"shape": "S7"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateClusterSnapshotResult",
				"type": "structure",
				"members": {
					"Snapshot": {
						"shape": "Sd"
					}
				}
			}
		},
		"CreateClusterSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterSubnetGroupName",
					"Description",
					"SubnetIds"
				],
				"members": {
					"ClusterSubnetGroupName": {},
					"Description": {},
					"SubnetIds": {
						"shape": "S1m"
					},
					"Tags": {
						"shape": "S7"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateClusterSubnetGroupResult",
				"type": "structure",
				"members": {
					"ClusterSubnetGroup": {
						"shape": "S1o"
					}
				}
			}
		},
		"CreateEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName",
					"SnsTopicArn"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"SourceIds": {
						"shape": "S1t"
					},
					"EventCategories": {
						"shape": "S1u"
					},
					"Severity": {},
					"Enabled": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "S7"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S1w"
					}
				}
			}
		},
		"CreateHsmClientCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"HsmClientCertificateIdentifier"
				],
				"members": {
					"HsmClientCertificateIdentifier": {},
					"Tags": {
						"shape": "S7"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateHsmClientCertificateResult",
				"type": "structure",
				"members": {
					"HsmClientCertificate": {
						"shape": "S1z"
					}
				}
			}
		},
		"CreateHsmConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"HsmConfigurationIdentifier",
					"Description",
					"HsmIpAddress",
					"HsmPartitionName",
					"HsmPartitionPassword",
					"HsmServerPublicCertificate"
				],
				"members": {
					"HsmConfigurationIdentifier": {},
					"Description": {},
					"HsmIpAddress": {},
					"HsmPartitionName": {},
					"HsmPartitionPassword": {},
					"HsmServerPublicCertificate": {},
					"Tags": {
						"shape": "S7"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateHsmConfigurationResult",
				"type": "structure",
				"members": {
					"HsmConfiguration": {
						"shape": "S22"
					}
				}
			}
		},
		"CreateSnapshotCopyGrant": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotCopyGrantName"
				],
				"members": {
					"SnapshotCopyGrantName": {},
					"KmsKeyId": {},
					"Tags": {
						"shape": "S7"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateSnapshotCopyGrantResult",
				"type": "structure",
				"members": {
					"SnapshotCopyGrant": {
						"shape": "S25"
					}
				}
			}
		},
		"CreateTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"Tags"
				],
				"members": {
					"ResourceName": {},
					"Tags": {
						"shape": "S7"
					}
				}
			}
		},
		"DeleteCluster": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier"
				],
				"members": {
					"ClusterIdentifier": {},
					"SkipFinalClusterSnapshot": {
						"type": "boolean"
					},
					"FinalClusterSnapshotIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteClusterResult",
				"type": "structure",
				"members": {
					"Cluster": {
						"shape": "Sv"
					}
				}
			}
		},
		"DeleteClusterParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ParameterGroupName"
				],
				"members": {
					"ParameterGroupName": {}
				}
			}
		},
		"DeleteClusterSecurityGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterSecurityGroupName"
				],
				"members": {
					"ClusterSecurityGroupName": {}
				}
			}
		},
		"DeleteClusterSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotIdentifier"
				],
				"members": {
					"SnapshotIdentifier": {},
					"SnapshotClusterIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteClusterSnapshotResult",
				"type": "structure",
				"members": {
					"Snapshot": {
						"shape": "Sd"
					}
				}
			}
		},
		"DeleteClusterSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterSubnetGroupName"
				],
				"members": {
					"ClusterSubnetGroupName": {}
				}
			}
		},
		"DeleteEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {}
				}
			}
		},
		"DeleteHsmClientCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"HsmClientCertificateIdentifier"
				],
				"members": {
					"HsmClientCertificateIdentifier": {}
				}
			}
		},
		"DeleteHsmConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"HsmConfigurationIdentifier"
				],
				"members": {
					"HsmConfigurationIdentifier": {}
				}
			}
		},
		"DeleteSnapshotCopyGrant": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotCopyGrantName"
				],
				"members": {
					"SnapshotCopyGrantName": {}
				}
			}
		},
		"DeleteTags": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceName",
					"TagKeys"
				],
				"members": {
					"ResourceName": {},
					"TagKeys": {
						"shape": "S2j"
					}
				}
			}
		},
		"DescribeClusterParameterGroups": {
			"input": {
				"type": "structure",
				"members": {
					"ParameterGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"TagKeys": {
						"shape": "S2j"
					},
					"TagValues": {
						"shape": "S2l"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeClusterParameterGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ParameterGroups": {
						"type": "list",
						"member": {
							"shape": "S1g",
							"locationName": "ClusterParameterGroup"
						}
					}
				}
			}
		},
		"DescribeClusterParameters": {
			"input": {
				"type": "structure",
				"required": [
					"ParameterGroupName"
				],
				"members": {
					"ParameterGroupName": {},
					"Source": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeClusterParametersResult",
				"type": "structure",
				"members": {
					"Parameters": {
						"shape": "S2q"
					},
					"Marker": {}
				}
			}
		},
		"DescribeClusterSecurityGroups": {
			"input": {
				"type": "structure",
				"members": {
					"ClusterSecurityGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"TagKeys": {
						"shape": "S2j"
					},
					"TagValues": {
						"shape": "S2l"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeClusterSecurityGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ClusterSecurityGroups": {
						"type": "list",
						"member": {
							"shape": "S4",
							"locationName": "ClusterSecurityGroup"
						}
					}
				}
			}
		},
		"DescribeClusterSnapshots": {
			"input": {
				"type": "structure",
				"members": {
					"ClusterIdentifier": {},
					"SnapshotIdentifier": {},
					"SnapshotType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"OwnerAccount": {},
					"TagKeys": {
						"shape": "S2j"
					},
					"TagValues": {
						"shape": "S2l"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeClusterSnapshotsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Snapshots": {
						"type": "list",
						"member": {
							"shape": "Sd",
							"locationName": "Snapshot"
						}
					}
				}
			}
		},
		"DescribeClusterSubnetGroups": {
			"input": {
				"type": "structure",
				"members": {
					"ClusterSubnetGroupName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"TagKeys": {
						"shape": "S2j"
					},
					"TagValues": {
						"shape": "S2l"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeClusterSubnetGroupsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ClusterSubnetGroups": {
						"type": "list",
						"member": {
							"shape": "S1o",
							"locationName": "ClusterSubnetGroup"
						}
					}
				}
			}
		},
		"DescribeClusterVersions": {
			"input": {
				"type": "structure",
				"members": {
					"ClusterVersion": {},
					"ClusterParameterGroupFamily": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeClusterVersionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ClusterVersions": {
						"type": "list",
						"member": {
							"locationName": "ClusterVersion",
							"type": "structure",
							"members": {
								"ClusterVersion": {},
								"ClusterParameterGroupFamily": {},
								"Description": {}
							}
						}
					}
				}
			}
		},
		"DescribeClusters": {
			"input": {
				"type": "structure",
				"members": {
					"ClusterIdentifier": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"TagKeys": {
						"shape": "S2j"
					},
					"TagValues": {
						"shape": "S2l"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeClustersResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Clusters": {
						"type": "list",
						"member": {
							"shape": "Sv",
							"locationName": "Cluster"
						}
					}
				}
			}
		},
		"DescribeDefaultClusterParameters": {
			"input": {
				"type": "structure",
				"required": [
					"ParameterGroupFamily"
				],
				"members": {
					"ParameterGroupFamily": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeDefaultClusterParametersResult",
				"type": "structure",
				"members": {
					"DefaultClusterParameters": {
						"type": "structure",
						"members": {
							"ParameterGroupFamily": {},
							"Marker": {},
							"Parameters": {
								"shape": "S2q"
							}
						},
						"wrapper": true
					}
				}
			}
		},
		"DescribeEventCategories": {
			"input": {
				"type": "structure",
				"members": {
					"SourceType": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventCategoriesResult",
				"type": "structure",
				"members": {
					"EventCategoriesMapList": {
						"type": "list",
						"member": {
							"locationName": "EventCategoriesMap",
							"type": "structure",
							"members": {
								"SourceType": {},
								"Events": {
									"type": "list",
									"member": {
										"locationName": "EventInfoMap",
										"type": "structure",
										"members": {
											"EventId": {},
											"EventCategories": {
												"shape": "S1u"
											},
											"EventDescription": {},
											"Severity": {}
										},
										"wrapper": true
									}
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DescribeEventSubscriptions": {
			"input": {
				"type": "structure",
				"members": {
					"SubscriptionName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventSubscriptionsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"EventSubscriptionsList": {
						"type": "list",
						"member": {
							"shape": "S1w",
							"locationName": "EventSubscription"
						}
					}
				}
			}
		},
		"DescribeEvents": {
			"input": {
				"type": "structure",
				"members": {
					"SourceIdentifier": {},
					"SourceType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeEventsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"Events": {
						"type": "list",
						"member": {
							"locationName": "Event",
							"type": "structure",
							"members": {
								"SourceIdentifier": {},
								"SourceType": {},
								"Message": {},
								"EventCategories": {
									"shape": "S1u"
								},
								"Severity": {},
								"Date": {
									"type": "timestamp"
								},
								"EventId": {}
							}
						}
					}
				}
			}
		},
		"DescribeHsmClientCertificates": {
			"input": {
				"type": "structure",
				"members": {
					"HsmClientCertificateIdentifier": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"TagKeys": {
						"shape": "S2j"
					},
					"TagValues": {
						"shape": "S2l"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeHsmClientCertificatesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"HsmClientCertificates": {
						"type": "list",
						"member": {
							"shape": "S1z",
							"locationName": "HsmClientCertificate"
						}
					}
				}
			}
		},
		"DescribeHsmConfigurations": {
			"input": {
				"type": "structure",
				"members": {
					"HsmConfigurationIdentifier": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"TagKeys": {
						"shape": "S2j"
					},
					"TagValues": {
						"shape": "S2l"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeHsmConfigurationsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"HsmConfigurations": {
						"type": "list",
						"member": {
							"shape": "S22",
							"locationName": "HsmConfiguration"
						}
					}
				}
			}
		},
		"DescribeLoggingStatus": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier"
				],
				"members": {
					"ClusterIdentifier": {}
				}
			},
			"output": {
				"shape": "S3x",
				"resultWrapper": "DescribeLoggingStatusResult"
			}
		},
		"DescribeOrderableClusterOptions": {
			"input": {
				"type": "structure",
				"members": {
					"ClusterVersion": {},
					"NodeType": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeOrderableClusterOptionsResult",
				"type": "structure",
				"members": {
					"OrderableClusterOptions": {
						"type": "list",
						"member": {
							"locationName": "OrderableClusterOption",
							"type": "structure",
							"members": {
								"ClusterVersion": {},
								"ClusterType": {},
								"NodeType": {},
								"AvailabilityZones": {
									"type": "list",
									"member": {
										"shape": "S1r",
										"locationName": "AvailabilityZone"
									}
								}
							},
							"wrapper": true
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeReservedNodeOfferings": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedNodeOfferingId": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedNodeOfferingsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedNodeOfferings": {
						"type": "list",
						"member": {
							"locationName": "ReservedNodeOffering",
							"type": "structure",
							"members": {
								"ReservedNodeOfferingId": {},
								"NodeType": {},
								"Duration": {
									"type": "integer"
								},
								"FixedPrice": {
									"type": "double"
								},
								"UsagePrice": {
									"type": "double"
								},
								"CurrencyCode": {},
								"OfferingType": {},
								"RecurringCharges": {
									"shape": "S47"
								}
							},
							"wrapper": true
						}
					}
				}
			}
		},
		"DescribeReservedNodes": {
			"input": {
				"type": "structure",
				"members": {
					"ReservedNodeId": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReservedNodesResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"ReservedNodes": {
						"type": "list",
						"member": {
							"shape": "S4c",
							"locationName": "ReservedNode"
						}
					}
				}
			}
		},
		"DescribeResize": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier"
				],
				"members": {
					"ClusterIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeResizeResult",
				"type": "structure",
				"members": {
					"TargetNodeType": {},
					"TargetNumberOfNodes": {
						"type": "integer"
					},
					"TargetClusterType": {},
					"Status": {},
					"ImportTablesCompleted": {
						"type": "list",
						"member": {}
					},
					"ImportTablesInProgress": {
						"type": "list",
						"member": {}
					},
					"ImportTablesNotStarted": {
						"type": "list",
						"member": {}
					},
					"AvgResizeRateInMegaBytesPerSecond": {
						"type": "double"
					},
					"TotalResizeDataInMegaBytes": {
						"type": "long"
					},
					"ProgressInMegaBytes": {
						"type": "long"
					},
					"ElapsedTimeInSeconds": {
						"type": "long"
					},
					"EstimatedTimeToCompletionInSeconds": {
						"type": "long"
					}
				}
			}
		},
		"DescribeSnapshotCopyGrants": {
			"input": {
				"type": "structure",
				"members": {
					"SnapshotCopyGrantName": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"TagKeys": {
						"shape": "S2j"
					},
					"TagValues": {
						"shape": "S2l"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeSnapshotCopyGrantsResult",
				"type": "structure",
				"members": {
					"Marker": {},
					"SnapshotCopyGrants": {
						"type": "list",
						"member": {
							"shape": "S25",
							"locationName": "SnapshotCopyGrant"
						}
					}
				}
			}
		},
		"DescribeTableRestoreStatus": {
			"input": {
				"type": "structure",
				"members": {
					"ClusterIdentifier": {},
					"TableRestoreRequestId": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeTableRestoreStatusResult",
				"type": "structure",
				"members": {
					"TableRestoreStatusDetails": {
						"type": "list",
						"member": {
							"shape": "S4q",
							"locationName": "TableRestoreStatus"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeTags": {
			"input": {
				"type": "structure",
				"members": {
					"ResourceName": {},
					"ResourceType": {},
					"MaxRecords": {
						"type": "integer"
					},
					"Marker": {},
					"TagKeys": {
						"shape": "S2j"
					},
					"TagValues": {
						"shape": "S2l"
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeTagsResult",
				"type": "structure",
				"members": {
					"TaggedResources": {
						"type": "list",
						"member": {
							"locationName": "TaggedResource",
							"type": "structure",
							"members": {
								"Tag": {
									"shape": "S8"
								},
								"ResourceName": {},
								"ResourceType": {}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DisableLogging": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier"
				],
				"members": {
					"ClusterIdentifier": {}
				}
			},
			"output": {
				"shape": "S3x",
				"resultWrapper": "DisableLoggingResult"
			}
		},
		"DisableSnapshotCopy": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier"
				],
				"members": {
					"ClusterIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "DisableSnapshotCopyResult",
				"type": "structure",
				"members": {
					"Cluster": {
						"shape": "Sv"
					}
				}
			}
		},
		"EnableLogging": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier",
					"BucketName"
				],
				"members": {
					"ClusterIdentifier": {},
					"BucketName": {},
					"S3KeyPrefix": {}
				}
			},
			"output": {
				"shape": "S3x",
				"resultWrapper": "EnableLoggingResult"
			}
		},
		"EnableSnapshotCopy": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier",
					"DestinationRegion"
				],
				"members": {
					"ClusterIdentifier": {},
					"DestinationRegion": {},
					"RetentionPeriod": {
						"type": "integer"
					},
					"SnapshotCopyGrantName": {}
				}
			},
			"output": {
				"resultWrapper": "EnableSnapshotCopyResult",
				"type": "structure",
				"members": {
					"Cluster": {
						"shape": "Sv"
					}
				}
			}
		},
		"GetClusterCredentials": {
			"input": {
				"type": "structure",
				"required": [
					"DbUser",
					"ClusterIdentifier"
				],
				"members": {
					"DbUser": {},
					"DbName": {},
					"ClusterIdentifier": {},
					"DurationSeconds": {
						"type": "integer"
					},
					"AutoCreate": {
						"type": "boolean"
					},
					"DbGroups": {
						"type": "list",
						"member": {
							"locationName": "DbGroup"
						}
					}
				}
			},
			"output": {
				"resultWrapper": "GetClusterCredentialsResult",
				"type": "structure",
				"members": {
					"DbUser": {},
					"DbPassword": {
						"type": "string",
						"sensitive": true
					},
					"Expiration": {
						"type": "timestamp"
					}
				}
			}
		},
		"ModifyCluster": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier"
				],
				"members": {
					"ClusterIdentifier": {},
					"ClusterType": {},
					"NodeType": {},
					"NumberOfNodes": {
						"type": "integer"
					},
					"ClusterSecurityGroups": {
						"shape": "Sp"
					},
					"VpcSecurityGroupIds": {
						"shape": "Sq"
					},
					"MasterUserPassword": {},
					"ClusterParameterGroupName": {},
					"AutomatedSnapshotRetentionPeriod": {
						"type": "integer"
					},
					"PreferredMaintenanceWindow": {},
					"ClusterVersion": {},
					"AllowVersionUpgrade": {
						"type": "boolean"
					},
					"HsmClientCertificateIdentifier": {},
					"HsmConfigurationIdentifier": {},
					"NewClusterIdentifier": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"ElasticIp": {},
					"EnhancedVpcRouting": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyClusterResult",
				"type": "structure",
				"members": {
					"Cluster": {
						"shape": "Sv"
					}
				}
			}
		},
		"ModifyClusterIamRoles": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier"
				],
				"members": {
					"ClusterIdentifier": {},
					"AddIamRoles": {
						"shape": "St"
					},
					"RemoveIamRoles": {
						"shape": "St"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyClusterIamRolesResult",
				"type": "structure",
				"members": {
					"Cluster": {
						"shape": "Sv"
					}
				}
			}
		},
		"ModifyClusterParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ParameterGroupName",
					"Parameters"
				],
				"members": {
					"ParameterGroupName": {},
					"Parameters": {
						"shape": "S2q"
					}
				}
			},
			"output": {
				"shape": "S5b",
				"resultWrapper": "ModifyClusterParameterGroupResult"
			}
		},
		"ModifyClusterSubnetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterSubnetGroupName",
					"SubnetIds"
				],
				"members": {
					"ClusterSubnetGroupName": {},
					"Description": {},
					"SubnetIds": {
						"shape": "S1m"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyClusterSubnetGroupResult",
				"type": "structure",
				"members": {
					"ClusterSubnetGroup": {
						"shape": "S1o"
					}
				}
			}
		},
		"ModifyEventSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionName"
				],
				"members": {
					"SubscriptionName": {},
					"SnsTopicArn": {},
					"SourceType": {},
					"SourceIds": {
						"shape": "S1t"
					},
					"EventCategories": {
						"shape": "S1u"
					},
					"Severity": {},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifyEventSubscriptionResult",
				"type": "structure",
				"members": {
					"EventSubscription": {
						"shape": "S1w"
					}
				}
			}
		},
		"ModifySnapshotCopyRetentionPeriod": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier",
					"RetentionPeriod"
				],
				"members": {
					"ClusterIdentifier": {},
					"RetentionPeriod": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "ModifySnapshotCopyRetentionPeriodResult",
				"type": "structure",
				"members": {
					"Cluster": {
						"shape": "Sv"
					}
				}
			}
		},
		"PurchaseReservedNodeOffering": {
			"input": {
				"type": "structure",
				"required": [
					"ReservedNodeOfferingId"
				],
				"members": {
					"ReservedNodeOfferingId": {},
					"NodeCount": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "PurchaseReservedNodeOfferingResult",
				"type": "structure",
				"members": {
					"ReservedNode": {
						"shape": "S4c"
					}
				}
			}
		},
		"RebootCluster": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier"
				],
				"members": {
					"ClusterIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "RebootClusterResult",
				"type": "structure",
				"members": {
					"Cluster": {
						"shape": "Sv"
					}
				}
			}
		},
		"ResetClusterParameterGroup": {
			"input": {
				"type": "structure",
				"required": [
					"ParameterGroupName"
				],
				"members": {
					"ParameterGroupName": {},
					"ResetAllParameters": {
						"type": "boolean"
					},
					"Parameters": {
						"shape": "S2q"
					}
				}
			},
			"output": {
				"shape": "S5b",
				"resultWrapper": "ResetClusterParameterGroupResult"
			}
		},
		"RestoreFromClusterSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier",
					"SnapshotIdentifier"
				],
				"members": {
					"ClusterIdentifier": {},
					"SnapshotIdentifier": {},
					"SnapshotClusterIdentifier": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"AllowVersionUpgrade": {
						"type": "boolean"
					},
					"ClusterSubnetGroupName": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"OwnerAccount": {},
					"HsmClientCertificateIdentifier": {},
					"HsmConfigurationIdentifier": {},
					"ElasticIp": {},
					"ClusterParameterGroupName": {},
					"ClusterSecurityGroups": {
						"shape": "Sp"
					},
					"VpcSecurityGroupIds": {
						"shape": "Sq"
					},
					"PreferredMaintenanceWindow": {},
					"AutomatedSnapshotRetentionPeriod": {
						"type": "integer"
					},
					"KmsKeyId": {},
					"NodeType": {},
					"EnhancedVpcRouting": {
						"type": "boolean"
					},
					"AdditionalInfo": {},
					"IamRoles": {
						"shape": "St"
					}
				}
			},
			"output": {
				"resultWrapper": "RestoreFromClusterSnapshotResult",
				"type": "structure",
				"members": {
					"Cluster": {
						"shape": "Sv"
					}
				}
			}
		},
		"RestoreTableFromClusterSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier",
					"SnapshotIdentifier",
					"SourceDatabaseName",
					"SourceTableName",
					"NewTableName"
				],
				"members": {
					"ClusterIdentifier": {},
					"SnapshotIdentifier": {},
					"SourceDatabaseName": {},
					"SourceSchemaName": {},
					"SourceTableName": {},
					"TargetDatabaseName": {},
					"TargetSchemaName": {},
					"NewTableName": {}
				}
			},
			"output": {
				"resultWrapper": "RestoreTableFromClusterSnapshotResult",
				"type": "structure",
				"members": {
					"TableRestoreStatus": {
						"shape": "S4q"
					}
				}
			}
		},
		"RevokeClusterSecurityGroupIngress": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterSecurityGroupName"
				],
				"members": {
					"ClusterSecurityGroupName": {},
					"CIDRIP": {},
					"EC2SecurityGroupName": {},
					"EC2SecurityGroupOwnerId": {}
				}
			},
			"output": {
				"resultWrapper": "RevokeClusterSecurityGroupIngressResult",
				"type": "structure",
				"members": {
					"ClusterSecurityGroup": {
						"shape": "S4"
					}
				}
			}
		},
		"RevokeSnapshotAccess": {
			"input": {
				"type": "structure",
				"required": [
					"SnapshotIdentifier",
					"AccountWithRestoreAccess"
				],
				"members": {
					"SnapshotIdentifier": {},
					"SnapshotClusterIdentifier": {},
					"AccountWithRestoreAccess": {}
				}
			},
			"output": {
				"resultWrapper": "RevokeSnapshotAccessResult",
				"type": "structure",
				"members": {
					"Snapshot": {
						"shape": "Sd"
					}
				}
			}
		},
		"RotateEncryptionKey": {
			"input": {
				"type": "structure",
				"required": [
					"ClusterIdentifier"
				],
				"members": {
					"ClusterIdentifier": {}
				}
			},
			"output": {
				"resultWrapper": "RotateEncryptionKeyResult",
				"type": "structure",
				"members": {
					"Cluster": {
						"shape": "Sv"
					}
				}
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"ClusterSecurityGroupName": {},
				"Description": {},
				"EC2SecurityGroups": {
					"type": "list",
					"member": {
						"locationName": "EC2SecurityGroup",
						"type": "structure",
						"members": {
							"Status": {},
							"EC2SecurityGroupName": {},
							"EC2SecurityGroupOwnerId": {},
							"Tags": {
								"shape": "S7"
							}
						}
					}
				},
				"IPRanges": {
					"type": "list",
					"member": {
						"locationName": "IPRange",
						"type": "structure",
						"members": {
							"Status": {},
							"CIDRIP": {},
							"Tags": {
								"shape": "S7"
							}
						}
					}
				},
				"Tags": {
					"shape": "S7"
				}
			},
			"wrapper": true
		},
		"S7": {
			"type": "list",
			"member": {
				"shape": "S8",
				"locationName": "Tag"
			}
		},
		"S8": {
			"type": "structure",
			"members": {
				"Key": {},
				"Value": {}
			}
		},
		"Sd": {
			"type": "structure",
			"members": {
				"SnapshotIdentifier": {},
				"ClusterIdentifier": {},
				"SnapshotCreateTime": {
					"type": "timestamp"
				},
				"Status": {},
				"Port": {
					"type": "integer"
				},
				"AvailabilityZone": {},
				"ClusterCreateTime": {
					"type": "timestamp"
				},
				"MasterUsername": {},
				"ClusterVersion": {},
				"SnapshotType": {},
				"NodeType": {},
				"NumberOfNodes": {
					"type": "integer"
				},
				"DBName": {},
				"VpcId": {},
				"Encrypted": {
					"type": "boolean"
				},
				"KmsKeyId": {},
				"EncryptedWithHSM": {
					"type": "boolean"
				},
				"AccountsWithRestoreAccess": {
					"type": "list",
					"member": {
						"locationName": "AccountWithRestoreAccess",
						"type": "structure",
						"members": {
							"AccountId": {},
							"AccountAlias": {}
						}
					}
				},
				"OwnerAccount": {},
				"TotalBackupSizeInMegaBytes": {
					"type": "double"
				},
				"ActualIncrementalBackupSizeInMegaBytes": {
					"type": "double"
				},
				"BackupProgressInMegaBytes": {
					"type": "double"
				},
				"CurrentBackupRateInMegaBytesPerSecond": {
					"type": "double"
				},
				"EstimatedSecondsToCompletion": {
					"type": "long"
				},
				"ElapsedTimeInSeconds": {
					"type": "long"
				},
				"SourceRegion": {},
				"Tags": {
					"shape": "S7"
				},
				"RestorableNodeTypes": {
					"type": "list",
					"member": {
						"locationName": "NodeType"
					}
				},
				"EnhancedVpcRouting": {
					"type": "boolean"
				}
			},
			"wrapper": true
		},
		"Sp": {
			"type": "list",
			"member": {
				"locationName": "ClusterSecurityGroupName"
			}
		},
		"Sq": {
			"type": "list",
			"member": {
				"locationName": "VpcSecurityGroupId"
			}
		},
		"St": {
			"type": "list",
			"member": {
				"locationName": "IamRoleArn"
			}
		},
		"Sv": {
			"type": "structure",
			"members": {
				"ClusterIdentifier": {},
				"NodeType": {},
				"ClusterStatus": {},
				"ModifyStatus": {},
				"MasterUsername": {},
				"DBName": {},
				"Endpoint": {
					"type": "structure",
					"members": {
						"Address": {},
						"Port": {
							"type": "integer"
						}
					}
				},
				"ClusterCreateTime": {
					"type": "timestamp"
				},
				"AutomatedSnapshotRetentionPeriod": {
					"type": "integer"
				},
				"ClusterSecurityGroups": {
					"type": "list",
					"member": {
						"locationName": "ClusterSecurityGroup",
						"type": "structure",
						"members": {
							"ClusterSecurityGroupName": {},
							"Status": {}
						}
					}
				},
				"VpcSecurityGroups": {
					"type": "list",
					"member": {
						"locationName": "VpcSecurityGroup",
						"type": "structure",
						"members": {
							"VpcSecurityGroupId": {},
							"Status": {}
						}
					}
				},
				"ClusterParameterGroups": {
					"type": "list",
					"member": {
						"locationName": "ClusterParameterGroup",
						"type": "structure",
						"members": {
							"ParameterGroupName": {},
							"ParameterApplyStatus": {},
							"ClusterParameterStatusList": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"ParameterName": {},
										"ParameterApplyStatus": {},
										"ParameterApplyErrorDescription": {}
									}
								}
							}
						}
					}
				},
				"ClusterSubnetGroupName": {},
				"VpcId": {},
				"AvailabilityZone": {},
				"PreferredMaintenanceWindow": {},
				"PendingModifiedValues": {
					"type": "structure",
					"members": {
						"MasterUserPassword": {},
						"NodeType": {},
						"NumberOfNodes": {
							"type": "integer"
						},
						"ClusterType": {},
						"ClusterVersion": {},
						"AutomatedSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"ClusterIdentifier": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"EnhancedVpcRouting": {
							"type": "boolean"
						}
					}
				},
				"ClusterVersion": {},
				"AllowVersionUpgrade": {
					"type": "boolean"
				},
				"NumberOfNodes": {
					"type": "integer"
				},
				"PubliclyAccessible": {
					"type": "boolean"
				},
				"Encrypted": {
					"type": "boolean"
				},
				"RestoreStatus": {
					"type": "structure",
					"members": {
						"Status": {},
						"CurrentRestoreRateInMegaBytesPerSecond": {
							"type": "double"
						},
						"SnapshotSizeInMegaBytes": {
							"type": "long"
						},
						"ProgressInMegaBytes": {
							"type": "long"
						},
						"ElapsedTimeInSeconds": {
							"type": "long"
						},
						"EstimatedTimeToCompletionInSeconds": {
							"type": "long"
						}
					}
				},
				"HsmStatus": {
					"type": "structure",
					"members": {
						"HsmClientCertificateIdentifier": {},
						"HsmConfigurationIdentifier": {},
						"Status": {}
					}
				},
				"ClusterSnapshotCopyStatus": {
					"type": "structure",
					"members": {
						"DestinationRegion": {},
						"RetentionPeriod": {
							"type": "long"
						},
						"SnapshotCopyGrantName": {}
					}
				},
				"ClusterPublicKey": {},
				"ClusterNodes": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"NodeRole": {},
							"PrivateIPAddress": {},
							"PublicIPAddress": {}
						}
					}
				},
				"ElasticIpStatus": {
					"type": "structure",
					"members": {
						"ElasticIp": {},
						"Status": {}
					}
				},
				"ClusterRevisionNumber": {},
				"Tags": {
					"shape": "S7"
				},
				"KmsKeyId": {},
				"EnhancedVpcRouting": {
					"type": "boolean"
				},
				"IamRoles": {
					"type": "list",
					"member": {
						"locationName": "ClusterIamRole",
						"type": "structure",
						"members": {
							"IamRoleArn": {},
							"ApplyStatus": {}
						}
					}
				}
			},
			"wrapper": true
		},
		"S1g": {
			"type": "structure",
			"members": {
				"ParameterGroupName": {},
				"ParameterGroupFamily": {},
				"Description": {},
				"Tags": {
					"shape": "S7"
				}
			},
			"wrapper": true
		},
		"S1m": {
			"type": "list",
			"member": {
				"locationName": "SubnetIdentifier"
			}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"ClusterSubnetGroupName": {},
				"Description": {},
				"VpcId": {},
				"SubnetGroupStatus": {},
				"Subnets": {
					"type": "list",
					"member": {
						"locationName": "Subnet",
						"type": "structure",
						"members": {
							"SubnetIdentifier": {},
							"SubnetAvailabilityZone": {
								"shape": "S1r"
							},
							"SubnetStatus": {}
						}
					}
				},
				"Tags": {
					"shape": "S7"
				}
			},
			"wrapper": true
		},
		"S1r": {
			"type": "structure",
			"members": {
				"Name": {}
			},
			"wrapper": true
		},
		"S1t": {
			"type": "list",
			"member": {
				"locationName": "SourceId"
			}
		},
		"S1u": {
			"type": "list",
			"member": {
				"locationName": "EventCategory"
			}
		},
		"S1w": {
			"type": "structure",
			"members": {
				"CustomerAwsId": {},
				"CustSubscriptionId": {},
				"SnsTopicArn": {},
				"Status": {},
				"SubscriptionCreationTime": {
					"type": "timestamp"
				},
				"SourceType": {},
				"SourceIdsList": {
					"shape": "S1t"
				},
				"EventCategoriesList": {
					"shape": "S1u"
				},
				"Severity": {},
				"Enabled": {
					"type": "boolean"
				},
				"Tags": {
					"shape": "S7"
				}
			},
			"wrapper": true
		},
		"S1z": {
			"type": "structure",
			"members": {
				"HsmClientCertificateIdentifier": {},
				"HsmClientCertificatePublicKey": {},
				"Tags": {
					"shape": "S7"
				}
			},
			"wrapper": true
		},
		"S22": {
			"type": "structure",
			"members": {
				"HsmConfigurationIdentifier": {},
				"Description": {},
				"HsmIpAddress": {},
				"HsmPartitionName": {},
				"Tags": {
					"shape": "S7"
				}
			},
			"wrapper": true
		},
		"S25": {
			"type": "structure",
			"members": {
				"SnapshotCopyGrantName": {},
				"KmsKeyId": {},
				"Tags": {
					"shape": "S7"
				}
			},
			"wrapper": true
		},
		"S2j": {
			"type": "list",
			"member": {
				"locationName": "TagKey"
			}
		},
		"S2l": {
			"type": "list",
			"member": {
				"locationName": "TagValue"
			}
		},
		"S2q": {
			"type": "list",
			"member": {
				"locationName": "Parameter",
				"type": "structure",
				"members": {
					"ParameterName": {},
					"ParameterValue": {},
					"Description": {},
					"Source": {},
					"DataType": {},
					"AllowedValues": {},
					"ApplyType": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"MinimumEngineVersion": {}
				}
			}
		},
		"S3x": {
			"type": "structure",
			"members": {
				"LoggingEnabled": {
					"type": "boolean"
				},
				"BucketName": {},
				"S3KeyPrefix": {},
				"LastSuccessfulDeliveryTime": {
					"type": "timestamp"
				},
				"LastFailureTime": {
					"type": "timestamp"
				},
				"LastFailureMessage": {}
			}
		},
		"S47": {
			"type": "list",
			"member": {
				"locationName": "RecurringCharge",
				"type": "structure",
				"members": {
					"RecurringChargeAmount": {
						"type": "double"
					},
					"RecurringChargeFrequency": {}
				},
				"wrapper": true
			}
		},
		"S4c": {
			"type": "structure",
			"members": {
				"ReservedNodeId": {},
				"ReservedNodeOfferingId": {},
				"NodeType": {},
				"StartTime": {
					"type": "timestamp"
				},
				"Duration": {
					"type": "integer"
				},
				"FixedPrice": {
					"type": "double"
				},
				"UsagePrice": {
					"type": "double"
				},
				"CurrencyCode": {},
				"NodeCount": {
					"type": "integer"
				},
				"State": {},
				"OfferingType": {},
				"RecurringCharges": {
					"shape": "S47"
				}
			},
			"wrapper": true
		},
		"S4q": {
			"type": "structure",
			"members": {
				"TableRestoreRequestId": {},
				"Status": {},
				"Message": {},
				"RequestTime": {
					"type": "timestamp"
				},
				"ProgressInMegaBytes": {
					"type": "long"
				},
				"TotalDataInMegaBytes": {
					"type": "long"
				},
				"ClusterIdentifier": {},
				"SnapshotIdentifier": {},
				"SourceDatabaseName": {},
				"SourceSchemaName": {},
				"SourceTableName": {},
				"TargetDatabaseName": {},
				"TargetSchemaName": {},
				"NewTableName": {}
			},
			"wrapper": true
		},
		"S5b": {
			"type": "structure",
			"members": {
				"ParameterGroupName": {},
				"ParameterGroupStatus": {}
			}
		}
	}
};

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeClusterParameterGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ParameterGroups"
		},
		"DescribeClusterParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Parameters"
		},
		"DescribeClusterSecurityGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ClusterSecurityGroups"
		},
		"DescribeClusterSnapshots": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Snapshots"
		},
		"DescribeClusterSubnetGroups": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ClusterSubnetGroups"
		},
		"DescribeClusterVersions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ClusterVersions"
		},
		"DescribeClusters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Clusters"
		},
		"DescribeDefaultClusterParameters": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "DefaultClusterParameters.Marker",
			"result_key": "DefaultClusterParameters.Parameters"
		},
		"DescribeEventSubscriptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "EventSubscriptionsList"
		},
		"DescribeEvents": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "Events"
		},
		"DescribeHsmClientCertificates": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "HsmClientCertificates"
		},
		"DescribeHsmConfigurations": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "HsmConfigurations"
		},
		"DescribeOrderableClusterOptions": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "OrderableClusterOptions"
		},
		"DescribeReservedNodeOfferings": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedNodeOfferings"
		},
		"DescribeReservedNodes": {
			"input_token": "Marker",
			"limit_key": "MaxRecords",
			"output_token": "Marker",
			"result_key": "ReservedNodes"
		}
	}
};

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"ClusterAvailable": {
			"delay": 60,
			"operation": "DescribeClusters",
			"maxAttempts": 30,
			"acceptors": [
				{
					"expected": "available",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Clusters[].ClusterStatus"
				},
				{
					"expected": "deleting",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Clusters[].ClusterStatus"
				},
				{
					"expected": "ClusterNotFound",
					"matcher": "error",
					"state": "retry"
				}
			]
		},
		"ClusterDeleted": {
			"delay": 60,
			"operation": "DescribeClusters",
			"maxAttempts": 30,
			"acceptors": [
				{
					"expected": "ClusterNotFound",
					"matcher": "error",
					"state": "success"
				},
				{
					"expected": "creating",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Clusters[].ClusterStatus"
				},
				{
					"expected": "modifying",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Clusters[].ClusterStatus"
				}
			]
		},
		"ClusterRestored": {
			"operation": "DescribeClusters",
			"maxAttempts": 30,
			"delay": 60,
			"acceptors": [
				{
					"state": "success",
					"matcher": "pathAll",
					"argument": "Clusters[].RestoreStatus.Status",
					"expected": "completed"
				},
				{
					"state": "failure",
					"matcher": "pathAny",
					"argument": "Clusters[].ClusterStatus",
					"expected": "deleting"
				}
			]
		},
		"SnapshotAvailable": {
			"delay": 15,
			"operation": "DescribeClusterSnapshots",
			"maxAttempts": 20,
			"acceptors": [
				{
					"expected": "available",
					"matcher": "pathAll",
					"state": "success",
					"argument": "Snapshots[].Status"
				},
				{
					"expected": "failed",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Snapshots[].Status"
				},
				{
					"expected": "deleted",
					"matcher": "pathAny",
					"state": "failure",
					"argument": "Snapshots[].Status"
				}
			]
		}
	}
};

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['rekognition'] = {};
AWS.Rekognition = Service.defineService('rekognition', ['2016-06-27']);
Object.defineProperty(apiLoader.services['rekognition'], '2016-06-27', {
  get: function get() {
    var model = __webpack_require__(1698);
    model.paginators = __webpack_require__(1699).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Rekognition;


/***/ }),
/* 1698 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-06-27",
		"endpointPrefix": "rekognition",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Rekognition",
		"signatureVersion": "v4",
		"targetPrefix": "RekognitionService",
		"uid": "rekognition-2016-06-27"
	},
	"operations": {
		"CompareFaces": {
			"input": {
				"type": "structure",
				"required": [
					"SourceImage",
					"TargetImage"
				],
				"members": {
					"SourceImage": {
						"shape": "S2"
					},
					"TargetImage": {
						"shape": "S2"
					},
					"SimilarityThreshold": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SourceImageFace": {
						"type": "structure",
						"members": {
							"BoundingBox": {
								"shape": "Sb"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"FaceMatches": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Similarity": {
									"type": "float"
								},
								"Face": {
									"shape": "Sf"
								}
							}
						}
					},
					"UnmatchedFaces": {
						"type": "list",
						"member": {
							"shape": "Sf"
						}
					},
					"SourceImageOrientationCorrection": {},
					"TargetImageOrientationCorrection": {}
				}
			}
		},
		"CreateCollection": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId"
				],
				"members": {
					"CollectionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StatusCode": {
						"type": "integer"
					},
					"CollectionArn": {}
				}
			}
		},
		"DeleteCollection": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId"
				],
				"members": {
					"CollectionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StatusCode": {
						"type": "integer"
					}
				}
			}
		},
		"DeleteFaces": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId",
					"FaceIds"
				],
				"members": {
					"CollectionId": {},
					"FaceIds": {
						"shape": "Sw"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeletedFaces": {
						"shape": "Sw"
					}
				}
			}
		},
		"DetectFaces": {
			"input": {
				"type": "structure",
				"required": [
					"Image"
				],
				"members": {
					"Image": {
						"shape": "S2"
					},
					"Attributes": {
						"shape": "S10"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FaceDetails": {
						"type": "list",
						"member": {
							"shape": "S14"
						}
					},
					"OrientationCorrection": {}
				}
			}
		},
		"DetectLabels": {
			"input": {
				"type": "structure",
				"required": [
					"Image"
				],
				"members": {
					"Image": {
						"shape": "S2"
					},
					"MaxLabels": {
						"type": "integer"
					},
					"MinConfidence": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Labels": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Confidence": {
									"type": "float"
								}
							}
						}
					},
					"OrientationCorrection": {}
				}
			}
		},
		"DetectModerationLabels": {
			"input": {
				"type": "structure",
				"required": [
					"Image"
				],
				"members": {
					"Image": {
						"shape": "S2"
					},
					"MinConfidence": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ModerationLabels": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Confidence": {
									"type": "float"
								},
								"Name": {},
								"ParentName": {}
							}
						}
					}
				}
			}
		},
		"GetCelebrityInfo": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Urls": {
						"shape": "S1u"
					},
					"Name": {}
				}
			}
		},
		"IndexFaces": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId",
					"Image"
				],
				"members": {
					"CollectionId": {},
					"Image": {
						"shape": "S2"
					},
					"ExternalImageId": {},
					"DetectionAttributes": {
						"shape": "S10"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FaceRecords": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Face": {
									"shape": "S21"
								},
								"FaceDetail": {
									"shape": "S14"
								}
							}
						}
					},
					"OrientationCorrection": {}
				}
			}
		},
		"ListCollections": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CollectionIds": {
						"type": "list",
						"member": {}
					},
					"NextToken": {}
				}
			}
		},
		"ListFaces": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId"
				],
				"members": {
					"CollectionId": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Faces": {
						"type": "list",
						"member": {
							"shape": "S21"
						}
					},
					"NextToken": {}
				}
			}
		},
		"RecognizeCelebrities": {
			"input": {
				"type": "structure",
				"required": [
					"Image"
				],
				"members": {
					"Image": {
						"shape": "S2"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CelebrityFaces": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Urls": {
									"shape": "S1u"
								},
								"Name": {},
								"Id": {},
								"Face": {
									"shape": "Sf"
								},
								"MatchConfidence": {
									"type": "float"
								}
							}
						}
					},
					"UnrecognizedFaces": {
						"type": "list",
						"member": {
							"shape": "Sf"
						}
					},
					"OrientationCorrection": {}
				}
			}
		},
		"SearchFaces": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId",
					"FaceId"
				],
				"members": {
					"CollectionId": {},
					"FaceId": {},
					"MaxFaces": {
						"type": "integer"
					},
					"FaceMatchThreshold": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SearchedFaceId": {},
					"FaceMatches": {
						"shape": "S2j"
					}
				}
			}
		},
		"SearchFacesByImage": {
			"input": {
				"type": "structure",
				"required": [
					"CollectionId",
					"Image"
				],
				"members": {
					"CollectionId": {},
					"Image": {
						"shape": "S2"
					},
					"MaxFaces": {
						"type": "integer"
					},
					"FaceMatchThreshold": {
						"type": "float"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SearchedFaceBoundingBox": {
						"shape": "Sb"
					},
					"SearchedFaceConfidence": {
						"type": "float"
					},
					"FaceMatches": {
						"shape": "S2j"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "structure",
			"members": {
				"Bytes": {
					"type": "blob"
				},
				"S3Object": {
					"type": "structure",
					"members": {
						"Bucket": {},
						"Name": {},
						"Version": {}
					}
				}
			}
		},
		"Sb": {
			"type": "structure",
			"members": {
				"Width": {
					"type": "float"
				},
				"Height": {
					"type": "float"
				},
				"Left": {
					"type": "float"
				},
				"Top": {
					"type": "float"
				}
			}
		},
		"Sf": {
			"type": "structure",
			"members": {
				"BoundingBox": {
					"shape": "Sb"
				},
				"Confidence": {
					"type": "float"
				},
				"Landmarks": {
					"shape": "Sg"
				},
				"Pose": {
					"shape": "Sj"
				},
				"Quality": {
					"shape": "Sl"
				}
			}
		},
		"Sg": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Type": {},
					"X": {
						"type": "float"
					},
					"Y": {
						"type": "float"
					}
				}
			}
		},
		"Sj": {
			"type": "structure",
			"members": {
				"Roll": {
					"type": "float"
				},
				"Yaw": {
					"type": "float"
				},
				"Pitch": {
					"type": "float"
				}
			}
		},
		"Sl": {
			"type": "structure",
			"members": {
				"Brightness": {
					"type": "float"
				},
				"Sharpness": {
					"type": "float"
				}
			}
		},
		"Sw": {
			"type": "list",
			"member": {}
		},
		"S10": {
			"type": "list",
			"member": {}
		},
		"S14": {
			"type": "structure",
			"members": {
				"BoundingBox": {
					"shape": "Sb"
				},
				"AgeRange": {
					"type": "structure",
					"members": {
						"Low": {
							"type": "integer"
						},
						"High": {
							"type": "integer"
						}
					}
				},
				"Smile": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Eyeglasses": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Sunglasses": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Gender": {
					"type": "structure",
					"members": {
						"Value": {},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Beard": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Mustache": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"EyesOpen": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"MouthOpen": {
					"type": "structure",
					"members": {
						"Value": {
							"type": "boolean"
						},
						"Confidence": {
							"type": "float"
						}
					}
				},
				"Emotions": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Type": {},
							"Confidence": {
								"type": "float"
							}
						}
					}
				},
				"Landmarks": {
					"shape": "Sg"
				},
				"Pose": {
					"shape": "Sj"
				},
				"Quality": {
					"shape": "Sl"
				},
				"Confidence": {
					"type": "float"
				}
			}
		},
		"S1u": {
			"type": "list",
			"member": {}
		},
		"S21": {
			"type": "structure",
			"members": {
				"FaceId": {},
				"BoundingBox": {
					"shape": "Sb"
				},
				"ImageId": {},
				"ExternalImageId": {},
				"Confidence": {
					"type": "float"
				}
			}
		},
		"S2j": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Similarity": {
						"type": "float"
					},
					"Face": {
						"shape": "S21"
					}
				}
			}
		}
	}
};

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListCollections": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "CollectionIds"
		},
		"ListFaces": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Faces"
		}
	}
};

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['route53'] = {};
AWS.Route53 = Service.defineService('route53', ['2013-04-01']);
__webpack_require__(1701);
Object.defineProperty(apiLoader.services['route53'], '2013-04-01', {
  get: function get() {
    var model = __webpack_require__(1702);
    model.paginators = __webpack_require__(1703).pagination;
    model.waiters = __webpack_require__(1704).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Route53;


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

AWS.util.update(AWS.Route53.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.on('build', this.sanitizeUrl);
  },

  /**
   * @api private
   */
  sanitizeUrl: function sanitizeUrl(request) {
    var path = request.httpRequest.path;
    request.httpRequest.path = path.replace(/\/%2F\w+%2F/, '/');
  },

  /**
   * @return [Boolean] whether the error can be retried
   * @api private
   */
  retryableError: function retryableError(error) {
    if (error.code === 'PriorRequestNotComplete' &&
        error.statusCode === 400) {
      return true;
    } else {
      var _super = AWS.Service.prototype.retryableError;
      return _super.call(this, error);
    }
  }
});


/***/ }),
/* 1702 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2013-04-01",
		"endpointPrefix": "route53",
		"globalEndpoint": "route53.amazonaws.com",
		"protocol": "rest-xml",
		"serviceAbbreviation": "Route 53",
		"serviceFullName": "Amazon Route 53",
		"signatureVersion": "v4",
		"uid": "route53-2013-04-01"
	},
	"operations": {
		"AssociateVPCWithHostedZone": {
			"http": {
				"requestUri": "/2013-04-01/hostedzone/{Id}/associatevpc"
			},
			"input": {
				"locationName": "AssociateVPCWithHostedZoneRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"HostedZoneId",
					"VPC"
				],
				"members": {
					"HostedZoneId": {
						"location": "uri",
						"locationName": "Id"
					},
					"VPC": {
						"shape": "S3"
					},
					"Comment": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ChangeInfo"
				],
				"members": {
					"ChangeInfo": {
						"shape": "S8"
					}
				}
			}
		},
		"ChangeResourceRecordSets": {
			"http": {
				"requestUri": "/2013-04-01/hostedzone/{Id}/rrset/"
			},
			"input": {
				"locationName": "ChangeResourceRecordSetsRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"HostedZoneId",
					"ChangeBatch"
				],
				"members": {
					"HostedZoneId": {
						"location": "uri",
						"locationName": "Id"
					},
					"ChangeBatch": {
						"type": "structure",
						"required": [
							"Changes"
						],
						"members": {
							"Comment": {},
							"Changes": {
								"type": "list",
								"member": {
									"locationName": "Change",
									"type": "structure",
									"required": [
										"Action",
										"ResourceRecordSet"
									],
									"members": {
										"Action": {},
										"ResourceRecordSet": {
											"shape": "Sh"
										}
									}
								}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ChangeInfo"
				],
				"members": {
					"ChangeInfo": {
						"shape": "S8"
					}
				}
			}
		},
		"ChangeTagsForResource": {
			"http": {
				"requestUri": "/2013-04-01/tags/{ResourceType}/{ResourceId}"
			},
			"input": {
				"locationName": "ChangeTagsForResourceRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"ResourceType",
					"ResourceId"
				],
				"members": {
					"ResourceType": {
						"location": "uri",
						"locationName": "ResourceType"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"AddTags": {
						"shape": "S15"
					},
					"RemoveTagKeys": {
						"type": "list",
						"member": {
							"locationName": "Key"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateHealthCheck": {
			"http": {
				"requestUri": "/2013-04-01/healthcheck",
				"responseCode": 201
			},
			"input": {
				"locationName": "CreateHealthCheckRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"CallerReference",
					"HealthCheckConfig"
				],
				"members": {
					"CallerReference": {},
					"HealthCheckConfig": {
						"shape": "S1d"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HealthCheck",
					"Location"
				],
				"members": {
					"HealthCheck": {
						"shape": "S1y"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					}
				}
			}
		},
		"CreateHostedZone": {
			"http": {
				"requestUri": "/2013-04-01/hostedzone",
				"responseCode": 201
			},
			"input": {
				"locationName": "CreateHostedZoneRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"Name",
					"CallerReference"
				],
				"members": {
					"Name": {},
					"VPC": {
						"shape": "S3"
					},
					"CallerReference": {},
					"HostedZoneConfig": {
						"shape": "S2e"
					},
					"DelegationSetId": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HostedZone",
					"ChangeInfo",
					"DelegationSet",
					"Location"
				],
				"members": {
					"HostedZone": {
						"shape": "S2h"
					},
					"ChangeInfo": {
						"shape": "S8"
					},
					"DelegationSet": {
						"shape": "S2j"
					},
					"VPC": {
						"shape": "S3"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					}
				}
			}
		},
		"CreateReusableDelegationSet": {
			"http": {
				"requestUri": "/2013-04-01/delegationset",
				"responseCode": 201
			},
			"input": {
				"locationName": "CreateReusableDelegationSetRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"CallerReference"
				],
				"members": {
					"CallerReference": {},
					"HostedZoneId": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"DelegationSet",
					"Location"
				],
				"members": {
					"DelegationSet": {
						"shape": "S2j"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					}
				}
			}
		},
		"CreateTrafficPolicy": {
			"http": {
				"requestUri": "/2013-04-01/trafficpolicy",
				"responseCode": 201
			},
			"input": {
				"locationName": "CreateTrafficPolicyRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"Name",
					"Document"
				],
				"members": {
					"Name": {},
					"Document": {},
					"Comment": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicy",
					"Location"
				],
				"members": {
					"TrafficPolicy": {
						"shape": "S2s"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					}
				}
			}
		},
		"CreateTrafficPolicyInstance": {
			"http": {
				"requestUri": "/2013-04-01/trafficpolicyinstance",
				"responseCode": 201
			},
			"input": {
				"locationName": "CreateTrafficPolicyInstanceRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"HostedZoneId",
					"Name",
					"TTL",
					"TrafficPolicyId",
					"TrafficPolicyVersion"
				],
				"members": {
					"HostedZoneId": {},
					"Name": {},
					"TTL": {
						"type": "long"
					},
					"TrafficPolicyId": {},
					"TrafficPolicyVersion": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicyInstance",
					"Location"
				],
				"members": {
					"TrafficPolicyInstance": {
						"shape": "S2x"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					}
				}
			}
		},
		"CreateTrafficPolicyVersion": {
			"http": {
				"requestUri": "/2013-04-01/trafficpolicy/{Id}",
				"responseCode": 201
			},
			"input": {
				"locationName": "CreateTrafficPolicyVersionRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"Id",
					"Document"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"Document": {},
					"Comment": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicy",
					"Location"
				],
				"members": {
					"TrafficPolicy": {
						"shape": "S2s"
					},
					"Location": {
						"location": "header",
						"locationName": "Location"
					}
				}
			}
		},
		"CreateVPCAssociationAuthorization": {
			"http": {
				"requestUri": "/2013-04-01/hostedzone/{Id}/authorizevpcassociation"
			},
			"input": {
				"locationName": "CreateVPCAssociationAuthorizationRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"HostedZoneId",
					"VPC"
				],
				"members": {
					"HostedZoneId": {
						"location": "uri",
						"locationName": "Id"
					},
					"VPC": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HostedZoneId",
					"VPC"
				],
				"members": {
					"HostedZoneId": {},
					"VPC": {
						"shape": "S3"
					}
				}
			}
		},
		"DeleteHealthCheck": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"HealthCheckId"
				],
				"members": {
					"HealthCheckId": {
						"location": "uri",
						"locationName": "HealthCheckId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteHostedZone": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2013-04-01/hostedzone/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ChangeInfo"
				],
				"members": {
					"ChangeInfo": {
						"shape": "S8"
					}
				}
			}
		},
		"DeleteReusableDelegationSet": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2013-04-01/delegationset/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteTrafficPolicy": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id",
					"Version"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"Version": {
						"location": "uri",
						"locationName": "Version",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteTrafficPolicyInstance": {
			"http": {
				"method": "DELETE",
				"requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteVPCAssociationAuthorization": {
			"http": {
				"requestUri": "/2013-04-01/hostedzone/{Id}/deauthorizevpcassociation"
			},
			"input": {
				"locationName": "DeleteVPCAssociationAuthorizationRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"HostedZoneId",
					"VPC"
				],
				"members": {
					"HostedZoneId": {
						"location": "uri",
						"locationName": "Id"
					},
					"VPC": {
						"shape": "S3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DisassociateVPCFromHostedZone": {
			"http": {
				"requestUri": "/2013-04-01/hostedzone/{Id}/disassociatevpc"
			},
			"input": {
				"locationName": "DisassociateVPCFromHostedZoneRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"HostedZoneId",
					"VPC"
				],
				"members": {
					"HostedZoneId": {
						"location": "uri",
						"locationName": "Id"
					},
					"VPC": {
						"shape": "S3"
					},
					"Comment": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ChangeInfo"
				],
				"members": {
					"ChangeInfo": {
						"shape": "S8"
					}
				}
			}
		},
		"GetChange": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/change/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ChangeInfo"
				],
				"members": {
					"ChangeInfo": {
						"shape": "S8"
					}
				}
			}
		},
		"GetCheckerIpRanges": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/checkeripranges"
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"required": [
					"CheckerIpRanges"
				],
				"members": {
					"CheckerIpRanges": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"GetGeoLocation": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/geolocation"
			},
			"input": {
				"type": "structure",
				"members": {
					"ContinentCode": {
						"location": "querystring",
						"locationName": "continentcode"
					},
					"CountryCode": {
						"location": "querystring",
						"locationName": "countrycode"
					},
					"SubdivisionCode": {
						"location": "querystring",
						"locationName": "subdivisioncode"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"GeoLocationDetails"
				],
				"members": {
					"GeoLocationDetails": {
						"shape": "S3r"
					}
				}
			}
		},
		"GetHealthCheck": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"HealthCheckId"
				],
				"members": {
					"HealthCheckId": {
						"location": "uri",
						"locationName": "HealthCheckId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HealthCheck"
				],
				"members": {
					"HealthCheck": {
						"shape": "S1y"
					}
				}
			}
		},
		"GetHealthCheckCount": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/healthcheckcount"
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"required": [
					"HealthCheckCount"
				],
				"members": {
					"HealthCheckCount": {
						"type": "long"
					}
				}
			}
		},
		"GetHealthCheckLastFailureReason": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}/lastfailurereason"
			},
			"input": {
				"type": "structure",
				"required": [
					"HealthCheckId"
				],
				"members": {
					"HealthCheckId": {
						"location": "uri",
						"locationName": "HealthCheckId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HealthCheckObservations"
				],
				"members": {
					"HealthCheckObservations": {
						"shape": "S42"
					}
				}
			}
		},
		"GetHealthCheckStatus": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}/status"
			},
			"input": {
				"type": "structure",
				"required": [
					"HealthCheckId"
				],
				"members": {
					"HealthCheckId": {
						"location": "uri",
						"locationName": "HealthCheckId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HealthCheckObservations"
				],
				"members": {
					"HealthCheckObservations": {
						"shape": "S42"
					}
				}
			}
		},
		"GetHostedZone": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/hostedzone/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HostedZone"
				],
				"members": {
					"HostedZone": {
						"shape": "S2h"
					},
					"DelegationSet": {
						"shape": "S2j"
					},
					"VPCs": {
						"shape": "S4a"
					}
				}
			}
		},
		"GetHostedZoneCount": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/hostedzonecount"
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"required": [
					"HostedZoneCount"
				],
				"members": {
					"HostedZoneCount": {
						"type": "long"
					}
				}
			}
		},
		"GetReusableDelegationSet": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/delegationset/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"DelegationSet"
				],
				"members": {
					"DelegationSet": {
						"shape": "S2j"
					}
				}
			}
		},
		"GetTrafficPolicy": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id",
					"Version"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"Version": {
						"location": "uri",
						"locationName": "Version",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicy"
				],
				"members": {
					"TrafficPolicy": {
						"shape": "S2s"
					}
				}
			}
		},
		"GetTrafficPolicyInstance": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicyInstance"
				],
				"members": {
					"TrafficPolicyInstance": {
						"shape": "S2x"
					}
				}
			}
		},
		"GetTrafficPolicyInstanceCount": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/trafficpolicyinstancecount"
			},
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicyInstanceCount"
				],
				"members": {
					"TrafficPolicyInstanceCount": {
						"type": "integer"
					}
				}
			}
		},
		"ListGeoLocations": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/geolocations"
			},
			"input": {
				"type": "structure",
				"members": {
					"StartContinentCode": {
						"location": "querystring",
						"locationName": "startcontinentcode"
					},
					"StartCountryCode": {
						"location": "querystring",
						"locationName": "startcountrycode"
					},
					"StartSubdivisionCode": {
						"location": "querystring",
						"locationName": "startsubdivisioncode"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"GeoLocationDetailsList",
					"IsTruncated",
					"MaxItems"
				],
				"members": {
					"GeoLocationDetailsList": {
						"type": "list",
						"member": {
							"shape": "S3r",
							"locationName": "GeoLocationDetails"
						}
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"NextContinentCode": {},
					"NextCountryCode": {},
					"NextSubdivisionCode": {},
					"MaxItems": {}
				}
			}
		},
		"ListHealthChecks": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/healthcheck"
			},
			"input": {
				"type": "structure",
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HealthChecks",
					"Marker",
					"IsTruncated",
					"MaxItems"
				],
				"members": {
					"HealthChecks": {
						"type": "list",
						"member": {
							"shape": "S1y",
							"locationName": "HealthCheck"
						}
					},
					"Marker": {},
					"IsTruncated": {
						"type": "boolean"
					},
					"NextMarker": {},
					"MaxItems": {}
				}
			}
		},
		"ListHostedZones": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/hostedzone"
			},
			"input": {
				"type": "structure",
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					},
					"DelegationSetId": {
						"location": "querystring",
						"locationName": "delegationsetid"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HostedZones",
					"Marker",
					"IsTruncated",
					"MaxItems"
				],
				"members": {
					"HostedZones": {
						"shape": "S4y"
					},
					"Marker": {},
					"IsTruncated": {
						"type": "boolean"
					},
					"NextMarker": {},
					"MaxItems": {}
				}
			}
		},
		"ListHostedZonesByName": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/hostedzonesbyname"
			},
			"input": {
				"type": "structure",
				"members": {
					"DNSName": {
						"location": "querystring",
						"locationName": "dnsname"
					},
					"HostedZoneId": {
						"location": "querystring",
						"locationName": "hostedzoneid"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HostedZones",
					"IsTruncated",
					"MaxItems"
				],
				"members": {
					"HostedZones": {
						"shape": "S4y"
					},
					"DNSName": {},
					"HostedZoneId": {},
					"IsTruncated": {
						"type": "boolean"
					},
					"NextDNSName": {},
					"NextHostedZoneId": {},
					"MaxItems": {}
				}
			}
		},
		"ListResourceRecordSets": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/hostedzone/{Id}/rrset"
			},
			"input": {
				"type": "structure",
				"required": [
					"HostedZoneId"
				],
				"members": {
					"HostedZoneId": {
						"location": "uri",
						"locationName": "Id"
					},
					"StartRecordName": {
						"location": "querystring",
						"locationName": "name"
					},
					"StartRecordType": {
						"location": "querystring",
						"locationName": "type"
					},
					"StartRecordIdentifier": {
						"location": "querystring",
						"locationName": "identifier"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceRecordSets",
					"IsTruncated",
					"MaxItems"
				],
				"members": {
					"ResourceRecordSets": {
						"type": "list",
						"member": {
							"shape": "Sh",
							"locationName": "ResourceRecordSet"
						}
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"NextRecordName": {},
					"NextRecordType": {},
					"NextRecordIdentifier": {},
					"MaxItems": {}
				}
			}
		},
		"ListReusableDelegationSets": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/delegationset"
			},
			"input": {
				"type": "structure",
				"members": {
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"DelegationSets",
					"Marker",
					"IsTruncated",
					"MaxItems"
				],
				"members": {
					"DelegationSets": {
						"type": "list",
						"member": {
							"shape": "S2j",
							"locationName": "DelegationSet"
						}
					},
					"Marker": {},
					"IsTruncated": {
						"type": "boolean"
					},
					"NextMarker": {},
					"MaxItems": {}
				}
			}
		},
		"ListTagsForResource": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/tags/{ResourceType}/{ResourceId}"
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceType",
					"ResourceId"
				],
				"members": {
					"ResourceType": {
						"location": "uri",
						"locationName": "ResourceType"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceTagSet"
				],
				"members": {
					"ResourceTagSet": {
						"shape": "S59"
					}
				}
			}
		},
		"ListTagsForResources": {
			"http": {
				"requestUri": "/2013-04-01/tags/{ResourceType}"
			},
			"input": {
				"locationName": "ListTagsForResourcesRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"ResourceType",
					"ResourceIds"
				],
				"members": {
					"ResourceType": {
						"location": "uri",
						"locationName": "ResourceType"
					},
					"ResourceIds": {
						"type": "list",
						"member": {
							"locationName": "ResourceId"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceTagSets"
				],
				"members": {
					"ResourceTagSets": {
						"type": "list",
						"member": {
							"shape": "S59",
							"locationName": "ResourceTagSet"
						}
					}
				}
			}
		},
		"ListTrafficPolicies": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/trafficpolicies"
			},
			"input": {
				"type": "structure",
				"members": {
					"TrafficPolicyIdMarker": {
						"location": "querystring",
						"locationName": "trafficpolicyid"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicySummaries",
					"IsTruncated",
					"TrafficPolicyIdMarker",
					"MaxItems"
				],
				"members": {
					"TrafficPolicySummaries": {
						"type": "list",
						"member": {
							"locationName": "TrafficPolicySummary",
							"type": "structure",
							"required": [
								"Id",
								"Name",
								"Type",
								"LatestVersion",
								"TrafficPolicyCount"
							],
							"members": {
								"Id": {},
								"Name": {},
								"Type": {},
								"LatestVersion": {
									"type": "integer"
								},
								"TrafficPolicyCount": {
									"type": "integer"
								}
							}
						}
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"TrafficPolicyIdMarker": {},
					"MaxItems": {}
				}
			}
		},
		"ListTrafficPolicyInstances": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/trafficpolicyinstances"
			},
			"input": {
				"type": "structure",
				"members": {
					"HostedZoneIdMarker": {
						"location": "querystring",
						"locationName": "hostedzoneid"
					},
					"TrafficPolicyInstanceNameMarker": {
						"location": "querystring",
						"locationName": "trafficpolicyinstancename"
					},
					"TrafficPolicyInstanceTypeMarker": {
						"location": "querystring",
						"locationName": "trafficpolicyinstancetype"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicyInstances",
					"IsTruncated",
					"MaxItems"
				],
				"members": {
					"TrafficPolicyInstances": {
						"shape": "S5k"
					},
					"HostedZoneIdMarker": {},
					"TrafficPolicyInstanceNameMarker": {},
					"TrafficPolicyInstanceTypeMarker": {},
					"IsTruncated": {
						"type": "boolean"
					},
					"MaxItems": {}
				}
			}
		},
		"ListTrafficPolicyInstancesByHostedZone": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/trafficpolicyinstances/hostedzone"
			},
			"input": {
				"type": "structure",
				"required": [
					"HostedZoneId"
				],
				"members": {
					"HostedZoneId": {
						"location": "querystring",
						"locationName": "id"
					},
					"TrafficPolicyInstanceNameMarker": {
						"location": "querystring",
						"locationName": "trafficpolicyinstancename"
					},
					"TrafficPolicyInstanceTypeMarker": {
						"location": "querystring",
						"locationName": "trafficpolicyinstancetype"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicyInstances",
					"IsTruncated",
					"MaxItems"
				],
				"members": {
					"TrafficPolicyInstances": {
						"shape": "S5k"
					},
					"TrafficPolicyInstanceNameMarker": {},
					"TrafficPolicyInstanceTypeMarker": {},
					"IsTruncated": {
						"type": "boolean"
					},
					"MaxItems": {}
				}
			}
		},
		"ListTrafficPolicyInstancesByPolicy": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/trafficpolicyinstances/trafficpolicy"
			},
			"input": {
				"type": "structure",
				"required": [
					"TrafficPolicyId",
					"TrafficPolicyVersion"
				],
				"members": {
					"TrafficPolicyId": {
						"location": "querystring",
						"locationName": "id"
					},
					"TrafficPolicyVersion": {
						"location": "querystring",
						"locationName": "version",
						"type": "integer"
					},
					"HostedZoneIdMarker": {
						"location": "querystring",
						"locationName": "hostedzoneid"
					},
					"TrafficPolicyInstanceNameMarker": {
						"location": "querystring",
						"locationName": "trafficpolicyinstancename"
					},
					"TrafficPolicyInstanceTypeMarker": {
						"location": "querystring",
						"locationName": "trafficpolicyinstancetype"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicyInstances",
					"IsTruncated",
					"MaxItems"
				],
				"members": {
					"TrafficPolicyInstances": {
						"shape": "S5k"
					},
					"HostedZoneIdMarker": {},
					"TrafficPolicyInstanceNameMarker": {},
					"TrafficPolicyInstanceTypeMarker": {},
					"IsTruncated": {
						"type": "boolean"
					},
					"MaxItems": {}
				}
			}
		},
		"ListTrafficPolicyVersions": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/trafficpolicies/{Id}/versions"
			},
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"TrafficPolicyVersionMarker": {
						"location": "querystring",
						"locationName": "trafficpolicyversion"
					},
					"MaxItems": {
						"location": "querystring",
						"locationName": "maxitems"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicies",
					"IsTruncated",
					"TrafficPolicyVersionMarker",
					"MaxItems"
				],
				"members": {
					"TrafficPolicies": {
						"type": "list",
						"member": {
							"shape": "S2s",
							"locationName": "TrafficPolicy"
						}
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"TrafficPolicyVersionMarker": {},
					"MaxItems": {}
				}
			}
		},
		"ListVPCAssociationAuthorizations": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/hostedzone/{Id}/authorizevpcassociation"
			},
			"input": {
				"type": "structure",
				"required": [
					"HostedZoneId"
				],
				"members": {
					"HostedZoneId": {
						"location": "uri",
						"locationName": "Id"
					},
					"NextToken": {
						"location": "querystring",
						"locationName": "nexttoken"
					},
					"MaxResults": {
						"location": "querystring",
						"locationName": "maxresults"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HostedZoneId",
					"VPCs"
				],
				"members": {
					"HostedZoneId": {},
					"NextToken": {},
					"VPCs": {
						"shape": "S4a"
					}
				}
			}
		},
		"TestDNSAnswer": {
			"http": {
				"method": "GET",
				"requestUri": "/2013-04-01/testdnsanswer"
			},
			"input": {
				"type": "structure",
				"required": [
					"HostedZoneId",
					"RecordName",
					"RecordType"
				],
				"members": {
					"HostedZoneId": {
						"location": "querystring",
						"locationName": "hostedzoneid"
					},
					"RecordName": {
						"location": "querystring",
						"locationName": "recordname"
					},
					"RecordType": {
						"location": "querystring",
						"locationName": "recordtype"
					},
					"ResolverIP": {
						"location": "querystring",
						"locationName": "resolverip"
					},
					"EDNS0ClientSubnetIP": {
						"location": "querystring",
						"locationName": "edns0clientsubnetip"
					},
					"EDNS0ClientSubnetMask": {
						"location": "querystring",
						"locationName": "edns0clientsubnetmask"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Nameserver",
					"RecordName",
					"RecordType",
					"RecordData",
					"ResponseCode",
					"Protocol"
				],
				"members": {
					"Nameserver": {},
					"RecordName": {},
					"RecordType": {},
					"RecordData": {
						"type": "list",
						"member": {
							"locationName": "RecordDataEntry"
						}
					},
					"ResponseCode": {},
					"Protocol": {}
				}
			}
		},
		"UpdateHealthCheck": {
			"http": {
				"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
			},
			"input": {
				"locationName": "UpdateHealthCheckRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"HealthCheckId"
				],
				"members": {
					"HealthCheckId": {
						"location": "uri",
						"locationName": "HealthCheckId"
					},
					"HealthCheckVersion": {
						"type": "long"
					},
					"IPAddress": {},
					"Port": {
						"type": "integer"
					},
					"ResourcePath": {},
					"FullyQualifiedDomainName": {},
					"SearchString": {},
					"FailureThreshold": {
						"type": "integer"
					},
					"Inverted": {
						"type": "boolean"
					},
					"HealthThreshold": {
						"type": "integer"
					},
					"ChildHealthChecks": {
						"shape": "S1p"
					},
					"EnableSNI": {
						"type": "boolean"
					},
					"Regions": {
						"shape": "S1r"
					},
					"AlarmIdentifier": {
						"shape": "S1t"
					},
					"InsufficientDataHealthStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HealthCheck"
				],
				"members": {
					"HealthCheck": {
						"shape": "S1y"
					}
				}
			}
		},
		"UpdateHostedZoneComment": {
			"http": {
				"requestUri": "/2013-04-01/hostedzone/{Id}"
			},
			"input": {
				"locationName": "UpdateHostedZoneCommentRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"Comment": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"HostedZone"
				],
				"members": {
					"HostedZone": {
						"shape": "S2h"
					}
				}
			}
		},
		"UpdateTrafficPolicyComment": {
			"http": {
				"requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
			},
			"input": {
				"locationName": "UpdateTrafficPolicyCommentRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"Id",
					"Version",
					"Comment"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"Version": {
						"location": "uri",
						"locationName": "Version",
						"type": "integer"
					},
					"Comment": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicy"
				],
				"members": {
					"TrafficPolicy": {
						"shape": "S2s"
					}
				}
			}
		},
		"UpdateTrafficPolicyInstance": {
			"http": {
				"requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
			},
			"input": {
				"locationName": "UpdateTrafficPolicyInstanceRequest",
				"xmlNamespace": {
					"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
				},
				"type": "structure",
				"required": [
					"Id",
					"TTL",
					"TrafficPolicyId",
					"TrafficPolicyVersion"
				],
				"members": {
					"Id": {
						"location": "uri",
						"locationName": "Id"
					},
					"TTL": {
						"type": "long"
					},
					"TrafficPolicyId": {},
					"TrafficPolicyVersion": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TrafficPolicyInstance"
				],
				"members": {
					"TrafficPolicyInstance": {
						"shape": "S2x"
					}
				}
			}
		}
	},
	"shapes": {
		"S3": {
			"type": "structure",
			"members": {
				"VPCRegion": {},
				"VPCId": {}
			}
		},
		"S8": {
			"type": "structure",
			"required": [
				"Id",
				"Status",
				"SubmittedAt"
			],
			"members": {
				"Id": {},
				"Status": {},
				"SubmittedAt": {
					"type": "timestamp"
				},
				"Comment": {}
			}
		},
		"Sh": {
			"type": "structure",
			"required": [
				"Name",
				"Type"
			],
			"members": {
				"Name": {},
				"Type": {},
				"SetIdentifier": {},
				"Weight": {
					"type": "long"
				},
				"Region": {},
				"GeoLocation": {
					"type": "structure",
					"members": {
						"ContinentCode": {},
						"CountryCode": {},
						"SubdivisionCode": {}
					}
				},
				"Failover": {},
				"MultiValueAnswer": {
					"type": "boolean"
				},
				"TTL": {
					"type": "long"
				},
				"ResourceRecords": {
					"type": "list",
					"member": {
						"locationName": "ResourceRecord",
						"type": "structure",
						"required": [
							"Value"
						],
						"members": {
							"Value": {}
						}
					}
				},
				"AliasTarget": {
					"type": "structure",
					"required": [
						"HostedZoneId",
						"DNSName",
						"EvaluateTargetHealth"
					],
					"members": {
						"HostedZoneId": {},
						"DNSName": {},
						"EvaluateTargetHealth": {
							"type": "boolean"
						}
					}
				},
				"HealthCheckId": {},
				"TrafficPolicyInstanceId": {}
			}
		},
		"S15": {
			"type": "list",
			"member": {
				"locationName": "Tag",
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S1d": {
			"type": "structure",
			"required": [
				"Type"
			],
			"members": {
				"IPAddress": {},
				"Port": {
					"type": "integer"
				},
				"Type": {},
				"ResourcePath": {},
				"FullyQualifiedDomainName": {},
				"SearchString": {},
				"RequestInterval": {
					"type": "integer"
				},
				"FailureThreshold": {
					"type": "integer"
				},
				"MeasureLatency": {
					"type": "boolean"
				},
				"Inverted": {
					"type": "boolean"
				},
				"HealthThreshold": {
					"type": "integer"
				},
				"ChildHealthChecks": {
					"shape": "S1p"
				},
				"EnableSNI": {
					"type": "boolean"
				},
				"Regions": {
					"shape": "S1r"
				},
				"AlarmIdentifier": {
					"shape": "S1t"
				},
				"InsufficientDataHealthStatus": {}
			}
		},
		"S1p": {
			"type": "list",
			"member": {
				"locationName": "ChildHealthCheck"
			}
		},
		"S1r": {
			"type": "list",
			"member": {
				"locationName": "Region"
			}
		},
		"S1t": {
			"type": "structure",
			"required": [
				"Region",
				"Name"
			],
			"members": {
				"Region": {},
				"Name": {}
			}
		},
		"S1y": {
			"type": "structure",
			"required": [
				"Id",
				"CallerReference",
				"HealthCheckConfig",
				"HealthCheckVersion"
			],
			"members": {
				"Id": {},
				"CallerReference": {},
				"HealthCheckConfig": {
					"shape": "S1d"
				},
				"HealthCheckVersion": {
					"type": "long"
				},
				"CloudWatchAlarmConfiguration": {
					"type": "structure",
					"required": [
						"EvaluationPeriods",
						"Threshold",
						"ComparisonOperator",
						"Period",
						"MetricName",
						"Namespace",
						"Statistic"
					],
					"members": {
						"EvaluationPeriods": {
							"type": "integer"
						},
						"Threshold": {
							"type": "double"
						},
						"ComparisonOperator": {},
						"Period": {
							"type": "integer"
						},
						"MetricName": {},
						"Namespace": {},
						"Statistic": {},
						"Dimensions": {
							"type": "list",
							"member": {
								"locationName": "Dimension",
								"type": "structure",
								"required": [
									"Name",
									"Value"
								],
								"members": {
									"Name": {},
									"Value": {}
								}
							}
						}
					}
				}
			}
		},
		"S2e": {
			"type": "structure",
			"members": {
				"Comment": {},
				"PrivateZone": {
					"type": "boolean"
				}
			}
		},
		"S2h": {
			"type": "structure",
			"required": [
				"Id",
				"Name",
				"CallerReference"
			],
			"members": {
				"Id": {},
				"Name": {},
				"CallerReference": {},
				"Config": {
					"shape": "S2e"
				},
				"ResourceRecordSetCount": {
					"type": "long"
				}
			}
		},
		"S2j": {
			"type": "structure",
			"required": [
				"NameServers"
			],
			"members": {
				"Id": {},
				"CallerReference": {},
				"NameServers": {
					"type": "list",
					"member": {
						"locationName": "NameServer"
					}
				}
			}
		},
		"S2s": {
			"type": "structure",
			"required": [
				"Id",
				"Version",
				"Name",
				"Type",
				"Document"
			],
			"members": {
				"Id": {},
				"Version": {
					"type": "integer"
				},
				"Name": {},
				"Type": {},
				"Document": {},
				"Comment": {}
			}
		},
		"S2x": {
			"type": "structure",
			"required": [
				"Id",
				"HostedZoneId",
				"Name",
				"TTL",
				"State",
				"Message",
				"TrafficPolicyId",
				"TrafficPolicyVersion",
				"TrafficPolicyType"
			],
			"members": {
				"Id": {},
				"HostedZoneId": {},
				"Name": {},
				"TTL": {
					"type": "long"
				},
				"State": {},
				"Message": {},
				"TrafficPolicyId": {},
				"TrafficPolicyVersion": {
					"type": "integer"
				},
				"TrafficPolicyType": {}
			}
		},
		"S3r": {
			"type": "structure",
			"members": {
				"ContinentCode": {},
				"ContinentName": {},
				"CountryCode": {},
				"CountryName": {},
				"SubdivisionCode": {},
				"SubdivisionName": {}
			}
		},
		"S42": {
			"type": "list",
			"member": {
				"locationName": "HealthCheckObservation",
				"type": "structure",
				"members": {
					"Region": {},
					"IPAddress": {},
					"StatusReport": {
						"type": "structure",
						"members": {
							"Status": {},
							"CheckedTime": {
								"type": "timestamp"
							}
						}
					}
				}
			}
		},
		"S4a": {
			"type": "list",
			"member": {
				"shape": "S3",
				"locationName": "VPC"
			}
		},
		"S4y": {
			"type": "list",
			"member": {
				"shape": "S2h",
				"locationName": "HostedZone"
			}
		},
		"S59": {
			"type": "structure",
			"members": {
				"ResourceType": {},
				"ResourceId": {},
				"Tags": {
					"shape": "S15"
				}
			}
		},
		"S5k": {
			"type": "list",
			"member": {
				"shape": "S2x",
				"locationName": "TrafficPolicyInstance"
			}
		}
	}
};

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListHealthChecks": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"more_results": "IsTruncated",
			"output_token": "NextMarker",
			"result_key": "HealthChecks"
		},
		"ListHostedZones": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"more_results": "IsTruncated",
			"output_token": "NextMarker",
			"result_key": "HostedZones"
		},
		"ListResourceRecordSets": {
			"input_token": [
				"StartRecordName",
				"StartRecordType",
				"StartRecordIdentifier"
			],
			"limit_key": "MaxItems",
			"more_results": "IsTruncated",
			"output_token": [
				"NextRecordName",
				"NextRecordType",
				"NextRecordIdentifier"
			],
			"result_key": "ResourceRecordSets"
		}
	}
};

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"ResourceRecordSetsChanged": {
			"delay": 30,
			"maxAttempts": 60,
			"operation": "GetChange",
			"acceptors": [
				{
					"matcher": "path",
					"expected": "INSYNC",
					"argument": "ChangeInfo.Status",
					"state": "success"
				}
			]
		}
	}
};

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['route53domains'] = {};
AWS.Route53Domains = Service.defineService('route53domains', ['2014-05-15']);
Object.defineProperty(apiLoader.services['route53domains'], '2014-05-15', {
  get: function get() {
    var model = __webpack_require__(1706);
    model.paginators = __webpack_require__(1707).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.Route53Domains;


/***/ }),
/* 1706 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-05-15",
		"endpointPrefix": "route53domains",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Route 53 Domains",
		"signatureVersion": "v4",
		"targetPrefix": "Route53Domains_v20140515",
		"uid": "route53domains-2014-05-15"
	},
	"operations": {
		"CheckDomainAvailability": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {},
					"IdnLangCode": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Availability"
				],
				"members": {
					"Availability": {}
				}
			}
		},
		"DeleteTagsForDomain": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName",
					"TagsToDelete"
				],
				"members": {
					"DomainName": {},
					"TagsToDelete": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DisableDomainAutoRenew": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DisableDomainTransferLock": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"OperationId"
				],
				"members": {
					"OperationId": {}
				}
			}
		},
		"EnableDomainAutoRenew": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"EnableDomainTransferLock": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"OperationId"
				],
				"members": {
					"OperationId": {}
				}
			}
		},
		"GetContactReachabilityStatus": {
			"input": {
				"type": "structure",
				"members": {
					"domainName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"domainName": {},
					"status": {}
				}
			}
		},
		"GetDomainDetail": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"DomainName",
					"Nameservers",
					"AdminContact",
					"RegistrantContact",
					"TechContact"
				],
				"members": {
					"DomainName": {},
					"Nameservers": {
						"shape": "So"
					},
					"AutoRenew": {
						"type": "boolean"
					},
					"AdminContact": {
						"shape": "Su"
					},
					"RegistrantContact": {
						"shape": "Su"
					},
					"TechContact": {
						"shape": "Su"
					},
					"AdminPrivacy": {
						"type": "boolean"
					},
					"RegistrantPrivacy": {
						"type": "boolean"
					},
					"TechPrivacy": {
						"type": "boolean"
					},
					"RegistrarName": {},
					"WhoIsServer": {},
					"RegistrarUrl": {},
					"AbuseContactEmail": {},
					"AbuseContactPhone": {},
					"RegistryDomainId": {},
					"CreationDate": {
						"type": "timestamp"
					},
					"UpdatedDate": {
						"type": "timestamp"
					},
					"ExpirationDate": {
						"type": "timestamp"
					},
					"Reseller": {},
					"DnsSec": {},
					"StatusList": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"GetDomainSuggestions": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName",
					"SuggestionCount",
					"OnlyAvailable"
				],
				"members": {
					"DomainName": {},
					"SuggestionCount": {
						"type": "integer"
					},
					"OnlyAvailable": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SuggestionsList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"DomainName": {},
								"Availability": {}
							}
						}
					}
				}
			}
		},
		"GetOperationDetail": {
			"input": {
				"type": "structure",
				"required": [
					"OperationId"
				],
				"members": {
					"OperationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"OperationId": {},
					"Status": {},
					"Message": {},
					"DomainName": {},
					"Type": {},
					"SubmittedDate": {
						"type": "timestamp"
					}
				}
			}
		},
		"ListDomains": {
			"input": {
				"type": "structure",
				"members": {
					"Marker": {},
					"MaxItems": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Domains"
				],
				"members": {
					"Domains": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"DomainName"
							],
							"members": {
								"DomainName": {},
								"AutoRenew": {
									"type": "boolean"
								},
								"TransferLock": {
									"type": "boolean"
								},
								"Expiry": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextPageMarker": {}
				}
			}
		},
		"ListOperations": {
			"input": {
				"type": "structure",
				"members": {
					"Marker": {},
					"MaxItems": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Operations"
				],
				"members": {
					"Operations": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"OperationId",
								"Status",
								"Type",
								"SubmittedDate"
							],
							"members": {
								"OperationId": {},
								"Status": {},
								"Type": {},
								"SubmittedDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextPageMarker": {}
				}
			}
		},
		"ListTagsForDomain": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TagList"
				],
				"members": {
					"TagList": {
						"shape": "S24"
					}
				}
			}
		},
		"RegisterDomain": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName",
					"DurationInYears",
					"AdminContact",
					"RegistrantContact",
					"TechContact"
				],
				"members": {
					"DomainName": {},
					"IdnLangCode": {},
					"DurationInYears": {
						"type": "integer"
					},
					"AutoRenew": {
						"type": "boolean"
					},
					"AdminContact": {
						"shape": "Su"
					},
					"RegistrantContact": {
						"shape": "Su"
					},
					"TechContact": {
						"shape": "Su"
					},
					"PrivacyProtectAdminContact": {
						"type": "boolean"
					},
					"PrivacyProtectRegistrantContact": {
						"type": "boolean"
					},
					"PrivacyProtectTechContact": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"OperationId"
				],
				"members": {
					"OperationId": {}
				}
			}
		},
		"RenewDomain": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName",
					"CurrentExpiryYear"
				],
				"members": {
					"DomainName": {},
					"DurationInYears": {
						"type": "integer"
					},
					"CurrentExpiryYear": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"OperationId"
				],
				"members": {
					"OperationId": {}
				}
			}
		},
		"ResendContactReachabilityEmail": {
			"input": {
				"type": "structure",
				"members": {
					"domainName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"domainName": {},
					"emailAddress": {},
					"isAlreadyVerified": {
						"type": "boolean"
					}
				}
			}
		},
		"RetrieveDomainAuthCode": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"AuthCode"
				],
				"members": {
					"AuthCode": {
						"shape": "S2h"
					}
				}
			}
		},
		"TransferDomain": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName",
					"DurationInYears",
					"AdminContact",
					"RegistrantContact",
					"TechContact"
				],
				"members": {
					"DomainName": {},
					"IdnLangCode": {},
					"DurationInYears": {
						"type": "integer"
					},
					"Nameservers": {
						"shape": "So"
					},
					"AuthCode": {
						"shape": "S2h"
					},
					"AutoRenew": {
						"type": "boolean"
					},
					"AdminContact": {
						"shape": "Su"
					},
					"RegistrantContact": {
						"shape": "Su"
					},
					"TechContact": {
						"shape": "Su"
					},
					"PrivacyProtectAdminContact": {
						"type": "boolean"
					},
					"PrivacyProtectRegistrantContact": {
						"type": "boolean"
					},
					"PrivacyProtectTechContact": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"OperationId"
				],
				"members": {
					"OperationId": {}
				}
			}
		},
		"UpdateDomainContact": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {},
					"AdminContact": {
						"shape": "Su"
					},
					"RegistrantContact": {
						"shape": "Su"
					},
					"TechContact": {
						"shape": "Su"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"OperationId"
				],
				"members": {
					"OperationId": {}
				}
			}
		},
		"UpdateDomainContactPrivacy": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {},
					"AdminPrivacy": {
						"type": "boolean"
					},
					"RegistrantPrivacy": {
						"type": "boolean"
					},
					"TechPrivacy": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"OperationId"
				],
				"members": {
					"OperationId": {}
				}
			}
		},
		"UpdateDomainNameservers": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName",
					"Nameservers"
				],
				"members": {
					"DomainName": {},
					"FIAuthKey": {},
					"Nameservers": {
						"shape": "So"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"OperationId"
				],
				"members": {
					"OperationId": {}
				}
			}
		},
		"UpdateTagsForDomain": {
			"input": {
				"type": "structure",
				"required": [
					"DomainName"
				],
				"members": {
					"DomainName": {},
					"TagsToUpdate": {
						"shape": "S24"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ViewBilling": {
			"input": {
				"type": "structure",
				"members": {
					"Start": {
						"type": "timestamp"
					},
					"End": {
						"type": "timestamp"
					},
					"Marker": {},
					"MaxItems": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextPageMarker": {},
					"BillingRecords": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"DomainName": {},
								"Operation": {},
								"InvoiceId": {},
								"BillDate": {
									"type": "timestamp"
								},
								"Price": {
									"type": "double"
								}
							}
						}
					}
				}
			}
		}
	},
	"shapes": {
		"So": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"GlueIps": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"Su": {
			"type": "structure",
			"members": {
				"FirstName": {},
				"LastName": {},
				"ContactType": {},
				"OrganizationName": {},
				"AddressLine1": {},
				"AddressLine2": {},
				"City": {},
				"State": {},
				"CountryCode": {},
				"ZipCode": {},
				"PhoneNumber": {},
				"Email": {},
				"Fax": {},
				"ExtraParams": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"Name",
							"Value"
						],
						"members": {
							"Name": {},
							"Value": {}
						}
					}
				}
			},
			"sensitive": true
		},
		"S24": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S2h": {
			"type": "string",
			"sensitive": true
		}
	}
};

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListDomains": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"output_token": "NextPageMarker",
			"result_key": "Domains"
		},
		"ListOperations": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"output_token": "NextPageMarker",
			"result_key": "Operations"
		}
	}
};

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['s3'] = {};
AWS.S3 = Service.defineService('s3', ['2006-03-01']);
__webpack_require__(1709);
Object.defineProperty(apiLoader.services['s3'], '2006-03-01', {
  get: function get() {
    var model = __webpack_require__(1711);
    model.paginators = __webpack_require__(1712).pagination;
    model.waiters = __webpack_require__(1713).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.S3;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var v4Credentials = __webpack_require__(810);

// Pull in managed upload extension
__webpack_require__(1710);

/**
 * @api private
 */
var operationsWith200StatusCodeError = {
  'completeMultipartUpload': true,
  'copyObject': true,
  'uploadPartCopy': true
};

/**
 * @api private
 */
 var regionRedirectErrorCodes = [
  'AuthorizationHeaderMalformed', // non-head operations on virtual-hosted global bucket endpoints
  'BadRequest', // head operations on virtual-hosted global bucket endpoints
  'PermanentRedirect', // non-head operations on path-style or regional endpoints
  301 // head operations on path-style or regional endpoints
 ];

AWS.util.update(AWS.S3.prototype, {
  /**
   * @api private
   */
  getSignatureVersion: function getSignatureVersion(request) {
    var defaultApiVersion = this.api.signatureVersion;
    var userDefinedVersion = this._originalConfig ? this._originalConfig.signatureVersion : null;
    var regionDefinedVersion = this.config.signatureVersion;
    var isPresigned = request ? request.isPresigned() : false;
    /*
      1) User defined version specified:
        a) always return user defined version
      2) No user defined version specified:
        a) default to lowest version the region supports
        b) If using presigned urls, default to lowest version the region supports
    */
    if (userDefinedVersion) {
      userDefinedVersion = userDefinedVersion === 'v2' ? 's3' : userDefinedVersion;
      return userDefinedVersion;
    }
    if (isPresigned !== true) {
      defaultApiVersion = 'v4';
    } else if (regionDefinedVersion) {
      defaultApiVersion = regionDefinedVersion;
    }
    return defaultApiVersion;
  },

  /**
   * @api private
   */
  getSignerClass: function getSignerClass(request) {
    var signatureVersion = this.getSignatureVersion(request);
    return AWS.Signers.RequestSigner.getVersion(signatureVersion);
  },

  /**
   * @api private
   */
  validateService: function validateService() {
    var msg;
    var messages = [];

    // default to us-east-1 when no region is provided
    if (!this.config.region) this.config.region = 'us-east-1';

    if (!this.config.endpoint && this.config.s3BucketEndpoint) {
      messages.push('An endpoint must be provided when configuring ' +
                    '`s3BucketEndpoint` to true.');
    }
    if (messages.length === 1) {
      msg = messages[0];
    } else if (messages.length > 1) {
      msg = 'Multiple configuration errors:\n' + messages.join('\n');
    }
    if (msg) {
      throw AWS.util.error(new Error(),
        {name: 'InvalidEndpoint', message: msg});
    }
  },

  /**
   * @api private
   */
  shouldDisableBodySigning: function shouldDisableBodySigning(request) {
    var signerClass = this.getSignerClass();
    if (this.config.s3DisableBodySigning === true && signerClass === AWS.Signers.V4
        && request.httpRequest.endpoint.protocol === 'https:') {
      return true;
    }
    return false;
  },

  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('validate', this.validateScheme);
    request.addListener('validate', this.validateBucketEndpoint);
    request.addListener('validate', this.correctBucketRegionFromCache);
    request.addListener('validate', this.validateBucketName);
    request.addListener('build', this.addContentType);
    request.addListener('build', this.populateURI);
    request.addListener('build', this.computeContentMd5);
    request.addListener('build', this.computeSseCustomerKeyMd5);
    request.addListener('afterBuild', this.addExpect100Continue);
    request.removeListener('validate',
      AWS.EventListeners.Core.VALIDATE_REGION);
    request.addListener('extractError', this.extractError);
    request.onAsync('extractError', this.requestBucketRegion);
    request.addListener('extractData', this.extractData);
    request.addListener('extractData', AWS.util.hoistPayloadMember);
    request.addListener('beforePresign', this.prepareSignedUrl);
    if (AWS.util.isBrowser()) {
      request.onAsync('retry', this.reqRegionForNetworkingError);
    }
    if (this.shouldDisableBodySigning(request))  {
      request.removeListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
      request.addListener('afterBuild', this.disableBodySigning);
    }
  },

  /**
   * @api private
   */
  validateScheme: function(req) {
    var params = req.params,
        scheme = req.httpRequest.endpoint.protocol,
        sensitive = params.SSECustomerKey || params.CopySourceSSECustomerKey;
    if (sensitive && scheme !== 'https:') {
      var msg = 'Cannot send SSE keys over HTTP. Set \'sslEnabled\'' +
        'to \'true\' in your configuration';
      throw AWS.util.error(new Error(),
        { code: 'ConfigError', message: msg });
    }
  },

  /**
   * @api private
   */
  validateBucketEndpoint: function(req) {
    if (!req.params.Bucket && req.service.config.s3BucketEndpoint) {
      var msg = 'Cannot send requests to root API with `s3BucketEndpoint` set.';
      throw AWS.util.error(new Error(),
        { code: 'ConfigError', message: msg });
    }
  },

  /**
   * @api private
   */
  validateBucketName: function validateBucketName(req) {
    var service = req.service;
    var signatureVersion = service.getSignatureVersion(req);
    // Only validate buckets when using sigv4
    if (signatureVersion !== 'v4') {
      return;
    }
    var bucket = req.params && req.params.Bucket;
    var key = req.params && req.params.Key;
    var slashIndex = bucket && bucket.indexOf('/');
    if (bucket && slashIndex >= 0) {
      if (typeof key === 'string') {
        req.params = AWS.util.copy(req.params);
        // Need to include trailing slash to match sigv2 behavior
        var prefix = bucket.substr(slashIndex + 1) || '';
        req.params.Key = prefix + '/' + key;
        req.params.Bucket = bucket.substr(0, slashIndex);
      } else {
        var msg = 'Bucket names cannot contain forward slashes. Bucket: ' + bucket;
        throw AWS.util.error(new Error(),
          { code: 'InvalidBucket', message: msg });
      }
    }
  },

  /**
   * @api private
   */
  isValidAccelerateOperation: function isValidAccelerateOperation(operation) {
    var invalidOperations = [
      'createBucket',
      'deleteBucket',
      'listBuckets'
    ];
    return invalidOperations.indexOf(operation) === -1;
  },


  /**
   * S3 prefers dns-compatible bucket names to be moved from the uri path
   * to the hostname as a sub-domain.  This is not possible, even for dns-compat
   * buckets when using SSL and the bucket name contains a dot ('.').  The
   * ssl wildcard certificate is only 1-level deep.
   *
   * @api private
   */
  populateURI: function populateURI(req) {
    var httpRequest = req.httpRequest;
    var b = req.params.Bucket;
    var service = req.service;
    var endpoint = httpRequest.endpoint;
    if (b) {
      if (!service.pathStyleBucketName(b)) {
        if (service.config.useAccelerateEndpoint && service.isValidAccelerateOperation(req.operation)) {
          if (service.config.useDualstack) {
            endpoint.hostname = b + '.s3-accelerate.dualstack.amazonaws.com';
          } else {
            endpoint.hostname = b + '.s3-accelerate.amazonaws.com';
          }
        } else if (!service.config.s3BucketEndpoint) {
          endpoint.hostname =
            b + '.' + endpoint.hostname;
        }

        var port = endpoint.port;
        if (port !== 80 && port !== 443) {
          endpoint.host = endpoint.hostname + ':' +
            endpoint.port;
        } else {
          endpoint.host = endpoint.hostname;
        }

        httpRequest.virtualHostedBucket = b; // needed for signing the request
        service.removeVirtualHostedBucketFromPath(req);
      }
    }
  },

  /**
   * Takes the bucket name out of the path if bucket is virtual-hosted
   *
   * @api private
   */
  removeVirtualHostedBucketFromPath: function removeVirtualHostedBucketFromPath(req) {
    var httpRequest = req.httpRequest;
    var bucket = httpRequest.virtualHostedBucket;
    if (bucket && httpRequest.path) {
      httpRequest.path = httpRequest.path.replace(new RegExp('/' + bucket), '');
      if (httpRequest.path[0] !== '/') {
        httpRequest.path = '/' + httpRequest.path;
      }
    }
  },

  /**
   * Adds Expect: 100-continue header if payload is greater-or-equal 1MB
   * @api private
   */
  addExpect100Continue: function addExpect100Continue(req) {
    var len = req.httpRequest.headers['Content-Length'];
    if (AWS.util.isNode() && len >= 1024 * 1024) {
      req.httpRequest.headers['Expect'] = '100-continue';
    }
  },

  /**
   * Adds a default content type if none is supplied.
   *
   * @api private
   */
  addContentType: function addContentType(req) {
    var httpRequest = req.httpRequest;
    if (httpRequest.method === 'GET' || httpRequest.method === 'HEAD') {
      // Content-Type is not set in GET/HEAD requests
      delete httpRequest.headers['Content-Type'];
      return;
    }

    if (!httpRequest.headers['Content-Type']) { // always have a Content-Type
      httpRequest.headers['Content-Type'] = 'application/octet-stream';
    }

    var contentType = httpRequest.headers['Content-Type'];
    if (AWS.util.isBrowser()) {
      if (typeof httpRequest.body === 'string' && !contentType.match(/;\s*charset=/)) {
        var charset = '; charset=UTF-8';
        httpRequest.headers['Content-Type'] += charset;
      } else {
        var replaceFn = function(_, prefix, charsetName) {
          return prefix + charsetName.toUpperCase();
        };

        httpRequest.headers['Content-Type'] =
          contentType.replace(/(;\s*charset=)(.+)$/, replaceFn);
      }
    }
  },

  /**
   * @api private
   */
  computableChecksumOperations: {
    putBucketCors: true,
    putBucketLifecycle: true,
    putBucketLifecycleConfiguration: true,
    putBucketTagging: true,
    deleteObjects: true,
    putBucketReplication: true
  },

  /**
   * Checks whether checksums should be computed for the request.
   * If the request requires checksums to be computed, this will always
   * return true, otherwise it depends on whether {AWS.Config.computeChecksums}
   * is set.
   *
   * @param req [AWS.Request] the request to check against
   * @return [Boolean] whether to compute checksums for a request.
   * @api private
   */
  willComputeChecksums: function willComputeChecksums(req) {
    if (this.computableChecksumOperations[req.operation]) return true;
    if (!this.config.computeChecksums) return false;

    // TODO: compute checksums for Stream objects
    if (!AWS.util.Buffer.isBuffer(req.httpRequest.body) &&
        typeof req.httpRequest.body !== 'string') {
      return false;
    }

    var rules = req.service.api.operations[req.operation].input.members;

    // Sha256 signing disabled, and not a presigned url
    if (req.service.shouldDisableBodySigning(req) && !Object.prototype.hasOwnProperty.call(req.httpRequest.headers, 'presigned-expires')) {
      if (rules.ContentMD5 && !req.params.ContentMD5) {
        return true;
      }
    }

    // V4 signer uses SHA256 signatures so only compute MD5 if it is required
    if (req.service.getSignerClass(req) === AWS.Signers.V4) {
      if (rules.ContentMD5 && !rules.ContentMD5.required) return false;
    }

    if (rules.ContentMD5 && !req.params.ContentMD5) return true;
  },

  /**
   * A listener that computes the Content-MD5 and sets it in the header.
   * @see AWS.S3.willComputeChecksums
   * @api private
   */
  computeContentMd5: function computeContentMd5(req) {
    if (req.service.willComputeChecksums(req)) {
      var md5 = AWS.util.crypto.md5(req.httpRequest.body, 'base64');
      req.httpRequest.headers['Content-MD5'] = md5;
    }
  },

  /**
   * @api private
   */
  computeSseCustomerKeyMd5: function computeSseCustomerKeyMd5(req) {
    var keys = {
      SSECustomerKey: 'x-amz-server-side-encryption-customer-key-MD5',
      CopySourceSSECustomerKey: 'x-amz-copy-source-server-side-encryption-customer-key-MD5'
    };
    AWS.util.each(keys, function(key, header) {
      if (req.params[key]) {
        var value = AWS.util.crypto.md5(req.params[key], 'base64');
        req.httpRequest.headers[header] = value;
      }
    });
  },

  /**
   * Returns true if the bucket name should be left in the URI path for
   * a request to S3.  This function takes into account the current
   * endpoint protocol (e.g. http or https).
   *
   * @api private
   */
  pathStyleBucketName: function pathStyleBucketName(bucketName) {
    // user can force path style requests via the configuration
    if (this.config.s3ForcePathStyle) return true;
    if (this.config.s3BucketEndpoint) return false;

    if (this.dnsCompatibleBucketName(bucketName)) {
      return (this.config.sslEnabled && bucketName.match(/\./)) ? true : false;
    } else {
      return true; // not dns compatible names must always use path style
    }
  },

  /**
   * Returns true if the bucket name is DNS compatible.  Buckets created
   * outside of the classic region MUST be DNS compatible.
   *
   * @api private
   */
  dnsCompatibleBucketName: function dnsCompatibleBucketName(bucketName) {
    var b = bucketName;
    var domain = new RegExp(/^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/);
    var ipAddress = new RegExp(/(\d+\.){3}\d+/);
    var dots = new RegExp(/\.\./);
    return (b.match(domain) && !b.match(ipAddress) && !b.match(dots)) ? true : false;
  },

  /**
   * @return [Boolean] whether response contains an error
   * @api private
   */
  successfulResponse: function successfulResponse(resp) {
    var req = resp.request;
    var httpResponse = resp.httpResponse;
    if (operationsWith200StatusCodeError[req.operation] &&
        httpResponse.body.toString().match('<Error>')) {
      return false;
    } else {
      return httpResponse.statusCode < 300;
    }
  },

  /**
   * @return [Boolean] whether the error can be retried
   * @api private
   */
  retryableError: function retryableError(error, request) {
    if (operationsWith200StatusCodeError[request.operation] &&
        error.statusCode === 200) {
      return true;
    } else if (request._requestRegionForBucket &&
        request.service.bucketRegionCache[request._requestRegionForBucket]) {
      return false;
    } else if (error && error.code === 'RequestTimeout') {
      return true;
    } else if (error &&
        regionRedirectErrorCodes.indexOf(error.code) != -1 &&
        error.region && error.region != request.httpRequest.region) {
      request.httpRequest.region = error.region;
      if (error.statusCode === 301) {
        request.service.updateReqBucketRegion(request);
      }
      return true;
    } else {
      var _super = AWS.Service.prototype.retryableError;
      return _super.call(this, error, request);
    }
  },

  /**
   * Updates httpRequest with region. If region is not provided, then
   * the httpRequest will be updated based on httpRequest.region
   *
   * @api private
   */
  updateReqBucketRegion: function updateReqBucketRegion(request, region) {
    var httpRequest = request.httpRequest;
    if (typeof region === 'string' && region.length) {
      httpRequest.region = region;
    }
    if (!httpRequest.endpoint.host.match(/s3(?!-accelerate).*\.amazonaws\.com$/)) {
      return;
    }
    var service = request.service;
    var s3Config = service.config;
    var s3BucketEndpoint = s3Config.s3BucketEndpoint;
    if (s3BucketEndpoint) {
      delete s3Config.s3BucketEndpoint;
    }
    var newConfig = AWS.util.copy(s3Config);
    delete newConfig.endpoint;
    newConfig.region = httpRequest.region;

    httpRequest.endpoint = (new AWS.S3(newConfig)).endpoint;
    service.populateURI(request);
    s3Config.s3BucketEndpoint = s3BucketEndpoint;
    httpRequest.headers.Host = httpRequest.endpoint.host;

    if (request._asm.currentState === 'validate') {
      request.removeListener('build', service.populateURI);
      request.addListener('build', service.removeVirtualHostedBucketFromPath);
    }
  },

  /**
   * Provides a specialized parser for getBucketLocation -- all other
   * operations are parsed by the super class.
   *
   * @api private
   */
  extractData: function extractData(resp) {
    var req = resp.request;
    if (req.operation === 'getBucketLocation') {
      var match = resp.httpResponse.body.toString().match(/>(.+)<\/Location/);
      delete resp.data['_'];
      if (match) {
        resp.data.LocationConstraint = match[1];
      } else {
        resp.data.LocationConstraint = '';
      }
    }
    var bucket = req.params.Bucket || null;
    if (req.operation === 'deleteBucket' && typeof bucket === 'string' && !resp.error) {
      req.service.clearBucketRegionCache(bucket);
    } else {
      var headers = resp.httpResponse.headers || {};
      var region = headers['x-amz-bucket-region'] || null;
      if (!region && req.operation === 'createBucket' && !resp.error) {
        var createBucketConfiguration = req.params.CreateBucketConfiguration;
        if (!createBucketConfiguration) {
          region = 'us-east-1';
        } else if (createBucketConfiguration.LocationConstraint === 'EU') {
          region = 'eu-west-1';
        } else {
          region = createBucketConfiguration.LocationConstraint;
        }
      }
      if (region) {
          if (bucket && region !== req.service.bucketRegionCache[bucket]) {
            req.service.bucketRegionCache[bucket] = region;
          }
      }
    }
    req.service.extractRequestIds(resp);
  },

  /**
   * Extracts an error object from the http response.
   *
   * @api private
   */
  extractError: function extractError(resp) {
    var codes = {
      304: 'NotModified',
      403: 'Forbidden',
      400: 'BadRequest',
      404: 'NotFound'
    };

    var req = resp.request;
    var code = resp.httpResponse.statusCode;
    var body = resp.httpResponse.body || '';

    var headers = resp.httpResponse.headers || {};
    var region = headers['x-amz-bucket-region'] || null;
    var bucket = req.params.Bucket || null;
    var bucketRegionCache = req.service.bucketRegionCache;
    if (region && bucket && region !== bucketRegionCache[bucket]) {
      bucketRegionCache[bucket] = region;
    }

    var cachedRegion;
    if (codes[code] && body.length === 0) {
      if (bucket && !region) {
        cachedRegion = bucketRegionCache[bucket] || null;
        if (cachedRegion !== req.httpRequest.region) {
          region = cachedRegion;
        }
      }
      resp.error = AWS.util.error(new Error(), {
        code: codes[code],
        message: null,
        region: region
      });
    } else {
      var data = new AWS.XML.Parser().parse(body.toString());

      if (data.Region && !region) {
        region = data.Region;
        if (bucket && region !== bucketRegionCache[bucket]) {
          bucketRegionCache[bucket] = region;
        }
      } else if (bucket && !region && !data.Region) {
        cachedRegion = bucketRegionCache[bucket] || null;
        if (cachedRegion !== req.httpRequest.region) {
          region = cachedRegion;
        }
      }

      resp.error = AWS.util.error(new Error(), {
        code: data.Code || code,
        message: data.Message || null,
        region: region
      });
    }
    req.service.extractRequestIds(resp);
  },

  /**
   * If region was not obtained synchronously, then send async request
   * to get bucket region for errors resulting from wrong region.
   *
   * @api private
   */
  requestBucketRegion: function requestBucketRegion(resp, done) {
    var error = resp.error;
    var req = resp.request;
    var bucket = req.params.Bucket || null;

    if (!error || !bucket || error.region || req.operation === 'listObjects' ||
        (AWS.util.isNode() && req.operation === 'headBucket') ||
        (error.statusCode === 400 && req.operation !== 'headObject') ||
        regionRedirectErrorCodes.indexOf(error.code) === -1) {
      return done();
    }
    var reqOperation = AWS.util.isNode() ? 'headBucket' : 'listObjects';
    var reqParams = {Bucket: bucket};
    if (reqOperation === 'listObjects') reqParams.MaxKeys = 0;
    var regionReq = req.service[reqOperation](reqParams);
    regionReq._requestRegionForBucket = bucket;
    regionReq.send(function() {
      var region = req.service.bucketRegionCache[bucket] || null;
      error.region = region;
      done();
    });
  },

   /**
   * For browser only. If NetworkingError received, will attempt to obtain
   * the bucket region.
   *
   * @api private
   */
   reqRegionForNetworkingError: function reqRegionForNetworkingError(resp, done) {
    if (!AWS.util.isBrowser()) {
      return done();
    }
    var error = resp.error;
    var request = resp.request;
    var bucket = request.params.Bucket;
    if (!error || error.code !== 'NetworkingError' || !bucket ||
        request.httpRequest.region === 'us-east-1') {
      return done();
    }
    var service = request.service;
    var bucketRegionCache = service.bucketRegionCache;
    var cachedRegion = bucketRegionCache[bucket] || null;

    if (cachedRegion && cachedRegion !== request.httpRequest.region) {
      service.updateReqBucketRegion(request, cachedRegion);
      done();
    } else if (!service.dnsCompatibleBucketName(bucket)) {
      service.updateReqBucketRegion(request, 'us-east-1');
      if (bucketRegionCache[bucket] !== 'us-east-1') {
        bucketRegionCache[bucket] = 'us-east-1';
      }
      done();
    } else if (request.httpRequest.virtualHostedBucket) {
      var getRegionReq = service.listObjects({Bucket: bucket, MaxKeys: 0});
      service.updateReqBucketRegion(getRegionReq, 'us-east-1');
      getRegionReq._requestRegionForBucket = bucket;

      getRegionReq.send(function() {
        var region = service.bucketRegionCache[bucket] || null;
        if (region && region !== request.httpRequest.region) {
          service.updateReqBucketRegion(request, region);
        }
        done();
      });
    } else {
      // DNS-compatible path-style
      // (s3ForcePathStyle or bucket name with dot over https)
      // Cannot obtain region information for this case
      done();
    }
   },

  /**
   * Cache for bucket region.
   *
   * @api private
   */
   bucketRegionCache: {},

  /**
   * Clears bucket region cache.
   *
   * @api private
   */
   clearBucketRegionCache: function(buckets) {
    var bucketRegionCache = this.bucketRegionCache;
    if (!buckets) {
      buckets = Object.keys(bucketRegionCache);
    } else if (typeof buckets === 'string') {
      buckets = [buckets];
    }
    for (var i = 0; i < buckets.length; i++) {
      delete bucketRegionCache[buckets[i]];
    }
    return bucketRegionCache;
   },

   /**
    * Corrects request region if bucket's cached region is different
    *
    * @api private
    */
  correctBucketRegionFromCache: function correctBucketRegionFromCache(req) {
    var bucket = req.params.Bucket || null;
    if (bucket) {
      var service = req.service;
      var requestRegion = req.httpRequest.region;
      var cachedRegion = service.bucketRegionCache[bucket];
      if (cachedRegion && cachedRegion !== requestRegion) {
        service.updateReqBucketRegion(req, cachedRegion);
      }
    }
  },

  /**
   * Extracts S3 specific request ids from the http response.
   *
   * @api private
   */
  extractRequestIds: function extractRequestIds(resp) {
    var extendedRequestId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-id-2'] : null;
    var cfId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-cf-id'] : null;
    resp.extendedRequestId = extendedRequestId;
    resp.cfId = cfId;

    if (resp.error) {
      resp.error.requestId = resp.requestId || null;
      resp.error.extendedRequestId = extendedRequestId;
      resp.error.cfId = cfId;
    }
  },

  /**
   * Get a pre-signed URL for a given operation name.
   *
   * @note You must ensure that you have static or previously resolved
   *   credentials if you call this method synchronously (with no callback),
   *   otherwise it may not properly sign the request. If you cannot guarantee
   *   this (you are using an asynchronous credential provider, i.e., EC2
   *   IAM roles), you should always call this method with an asynchronous
   *   callback.
   * @note Not all operation parameters are supported when using pre-signed
   *   URLs. Certain parameters, such as `SSECustomerKey`, `ACL`, `Expires`,
   *   `ContentLength`, or `Tagging` must be provided as headers when sending a
   *   request. If you are using pre-signed URLs to upload from a browser and
   *   need to use these fields, see {createPresignedPost}.
   * @param operation [String] the name of the operation to call
   * @param params [map] parameters to pass to the operation. See the given
   *   operation for the expected operation parameters. In addition, you can
   *   also pass the "Expires" parameter to inform S3 how long the URL should
   *   work for.
   * @option params Expires [Integer] (900) the number of seconds to expire
   *   the pre-signed URL operation in. Defaults to 15 minutes.
   * @param callback [Function] if a callback is provided, this function will
   *   pass the URL as the second parameter (after the error parameter) to
   *   the callback function.
   * @return [String] if called synchronously (with no callback), returns the
   *   signed URL.
   * @return [null] nothing is returned if a callback is provided.
   * @example Pre-signing a getObject operation (synchronously)
   *   var params = {Bucket: 'bucket', Key: 'key'};
   *   var url = s3.getSignedUrl('getObject', params);
   *   console.log('The URL is', url);
   * @example Pre-signing a putObject (asynchronously)
   *   var params = {Bucket: 'bucket', Key: 'key'};
   *   s3.getSignedUrl('putObject', params, function (err, url) {
   *     console.log('The URL is', url);
   *   });
   * @example Pre-signing a putObject operation with a specific payload
   *   var params = {Bucket: 'bucket', Key: 'key', Body: 'body'};
   *   var url = s3.getSignedUrl('putObject', params);
   *   console.log('The URL is', url);
   * @example Passing in a 1-minute expiry time for a pre-signed URL
   *   var params = {Bucket: 'bucket', Key: 'key', Expires: 60};
   *   var url = s3.getSignedUrl('getObject', params);
   *   console.log('The URL is', url); // expires in 60 seconds
   */
  getSignedUrl: function getSignedUrl(operation, params, callback) {
    params = AWS.util.copy(params || {});
    var expires = params.Expires || 900;
    delete params.Expires; // we can't validate this
    var request = this.makeRequest(operation, params);

    if (callback) {
      AWS.util.defer(function() {
        request.presign(expires, callback);
      });
    } else {
      return request.presign(expires, callback);
    }
  },


  /**
   * Get a pre-signed POST policy to support uploading to S3 directly from an
   * HTML form.
   *
   * @param params [map]
   * @option params Bucket [String]     The bucket to which the post should be
   *                                    uploaded
   * @option params Expires [Integer]   (3600) The number of seconds for which
   *                                    the presigned policy should be valid.
   * @option params Conditions [Array]  An array of conditions that must be met
   *                                    for the presigned policy to allow the
   *                                    upload. This can include required tags,
   *                                    the accepted range for content lengths,
   *                                    etc.
   * @see http://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
   * @option params Fields [map]        Fields to include in the form. All
   *                                    values passed in as fields will be
   *                                    signed as exact match conditions.
   * @param callback [Function]
   *
   * @note All fields passed in when creating presigned post data will be signed
   *   as exact match conditions. Any fields that will be interpolated by S3
   *   must be added to the fields hash after signing, and an appropriate
   *   condition for such fields must be explicitly added to the Conditions
   *   array passed to this function before signing.
   *
   * @example Presiging post data with a known key
   *   var params = {
   *     Bucket: 'bucket',
   *     Fields: {
   *       key: 'key'
   *     }
   *   };
   *   s3.createPresignedPost(params, function(err, data) {
   *     if (err) {
   *       console.error('Presigning post data encountered an error', err);
   *     } else {
   *       console.log('The post data is', data);
   *     }
   *   });
   *
   * @example Presigning post data with an interpolated key
   *   var params = {
   *     Bucket: 'bucket',
   *     Conditions: [
   *       ['starts-with', '$key', 'path/to/uploads/']
   *     ]
   *   };
   *   s3.createPresignedPost(params, function(err, data) {
   *     if (err) {
   *       console.error('Presigning post data encountered an error', err);
   *     } else {
   *       data.Fields.key = 'path/to/uploads/${filename}';
   *       console.log('The post data is', data);
   *     }
   *   });
   *
   * @note You must ensure that you have static or previously resolved
   *   credentials if you call this method synchronously (with no callback),
   *   otherwise it may not properly sign the request. If you cannot guarantee
   *   this (you are using an asynchronous credential provider, i.e., EC2
   *   IAM roles), you should always call this method with an asynchronous
   *   callback.
   *
   * @return [map]  If called synchronously (with no callback), returns a hash
   *                with the url to set as the form action and a hash of fields
   *                to include in the form.
   * @return [null] Nothing is returned if a callback is provided.
   *
   * @callback callback function (err, data)
   *  @param err [Error] the error object returned from the policy signer
   *  @param data [map] The data necessary to construct an HTML form
   *  @param data.url [String] The URL to use as the action of the form
   *  @param data.fields [map] A hash of fields that must be included in the
   *                           form for the upload to succeed. This hash will
   *                           include the signed POST policy, your access key
   *                           ID and security token (if present), etc. These
   *                           may be safely included as input elements of type
   *                           'hidden.'
   */
  createPresignedPost: function createPresignedPost(params, callback) {
    if (typeof params === 'function' && callback === undefined) {
      callback = params;
      params = null;
    }

    params = AWS.util.copy(params || {});
    var boundParams = this.config.params || {};
    var bucket = params.Bucket || boundParams.Bucket,
      self = this,
      config = this.config,
      endpoint = AWS.util.copy(this.endpoint);
    if (!config.s3BucketEndpoint) {
      endpoint.pathname = '/' + bucket;
    }

    function finalizePost() {
      return {
        url: AWS.util.urlFormat(endpoint),
        fields: self.preparePostFields(
          config.credentials,
          config.region,
          bucket,
          params.Fields,
          params.Conditions,
          params.Expires
        )
      };
    }

    if (callback) {
      config.getCredentials(function (err) {
        if (err) {
          callback(err);
        }

        callback(null, finalizePost());
      });
    } else {
      return finalizePost();
    }
  },

  /**
   * @api private
   */
  preparePostFields: function preparePostFields(
    credentials,
    region,
    bucket,
    fields,
    conditions,
    expiresInSeconds
  ) {
    var now = AWS.util.date.getDate();
    if (!credentials || !region || !bucket) {
      throw new Error('Unable to create a POST object policy without a bucket,'
        + ' region, and credentials');
    }
    fields = AWS.util.copy(fields || {});
    conditions = (conditions || []).slice(0);
    expiresInSeconds = expiresInSeconds || 3600;

    var signingDate = AWS.util.date.iso8601(now).replace(/[:\-]|\.\d{3}/g, '');
    var shortDate = signingDate.substr(0, 8);
    var scope = v4Credentials.createScope(shortDate, region, 's3');
    var credential = credentials.accessKeyId + '/' + scope;

    fields['bucket'] = bucket;
    fields['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256';
    fields['X-Amz-Credential'] = credential;
    fields['X-Amz-Date'] = signingDate;
    if (credentials.sessionToken) {
      fields['X-Amz-Security-Token'] = credentials.sessionToken;
    }
    for (var field in fields) {
      if (fields.hasOwnProperty(field)) {
        var condition = {};
        condition[field] = fields[field];
        conditions.push(condition);
      }
    }

    fields.Policy = this.preparePostPolicy(
      new Date(now.valueOf() + expiresInSeconds * 1000),
      conditions
    );
    fields['X-Amz-Signature'] = AWS.util.crypto.hmac(
      v4Credentials.getSigningKey(credentials, shortDate, region, 's3', true),
      fields.Policy,
      'hex'
    );

    return fields;
  },

  /**
   * @api private
   */
  preparePostPolicy: function preparePostPolicy(expiration, conditions) {
    return AWS.util.base64.encode(JSON.stringify({
      expiration: AWS.util.date.iso8601(expiration),
      conditions: conditions
    }));
  },

  /**
   * @api private
   */
  prepareSignedUrl: function prepareSignedUrl(request) {
    request.addListener('validate', request.service.noPresignedContentLength);
    request.removeListener('build', request.service.addContentType);
    if (!request.params.Body) {
      // no Content-MD5/SHA-256 if body is not provided
      request.removeListener('build', request.service.computeContentMd5);
    } else {
      request.addListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
    }
  },

  /**
   * @api private
   * @param request
   */
  disableBodySigning: function disableBodySigning(request) {
    var headers = request.httpRequest.headers;
    // Add the header to anything that isn't a presigned url, unless that presigned url had a body defined
    if (!Object.prototype.hasOwnProperty.call(headers, 'presigned-expires')) {
      headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
    }
  },

  /**
   * @api private
   */
  noPresignedContentLength: function noPresignedContentLength(request) {
    if (request.params.ContentLength !== undefined) {
      throw AWS.util.error(new Error(), {code: 'UnexpectedParameter',
        message: 'ContentLength is not supported in pre-signed URLs.'});
    }
  },

  createBucket: function createBucket(params, callback) {
    // When creating a bucket *outside* the classic region, the location
    // constraint must be set for the bucket and it must match the endpoint.
    // This chunk of code will set the location constraint param based
    // on the region (when possible), but it will not override a passed-in
    // location constraint.
    if (typeof params === 'function' || !params) {
      callback = callback || params;
      params = {};
    }
    var hostname = this.endpoint.hostname;
    if (hostname !== this.api.globalEndpoint && !params.CreateBucketConfiguration) {
      params.CreateBucketConfiguration = { LocationConstraint: this.config.region };
    }
    return this.makeRequest('createBucket', params, callback);
  },

  /**
   * @see AWS.S3.ManagedUpload
   * @overload upload(params = {}, [options], [callback])
   *   Uploads an arbitrarily sized buffer, blob, or stream, using intelligent
   *   concurrent handling of parts if the payload is large enough. You can
   *   configure the concurrent queue size by setting `options`. Note that this
   *   is the only operation for which the SDK can retry requests with stream
   *   bodies.
   *
   *   @param (see AWS.S3.putObject)
   *   @option (see AWS.S3.ManagedUpload.constructor)
   *   @return [AWS.S3.ManagedUpload] the managed upload object that can call
   *     `send()` or track progress.
   *   @example Uploading a stream object
   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *     s3.upload(params, function(err, data) {
   *       console.log(err, data);
   *     });
   *   @example Uploading a stream with concurrency of 1 and partSize of 10mb
   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *     var options = {partSize: 10 * 1024 * 1024, queueSize: 1};
   *     s3.upload(params, options, function(err, data) {
   *       console.log(err, data);
   *     });
   * @callback callback function(err, data)
   *   @param err [Error] an error or null if no error occurred.
   *   @param data [map] The response data from the successful upload:
   *   @param data.Location [String] the URL of the uploaded object
   *   @param data.ETag [String] the ETag of the uploaded object
   *   @param data.Bucket [String]  the bucket to which the object was uploaded
   *   @param data.Key [String] the key to which the object was uploaded
   */
  upload: function upload(params, options, callback) {
    if (typeof options === 'function' && callback === undefined) {
      callback = options;
      options = null;
    }

    options = options || {};
    options = AWS.util.merge(options || {}, {service: this, params: params});

    var uploader = new AWS.S3.ManagedUpload(options);
    if (typeof callback === 'function') uploader.send(callback);
    return uploader;
  }
});


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);
var byteLength = AWS.util.string.byteLength;
var Buffer = AWS.util.Buffer;

/**
 * The managed uploader allows for easy and efficient uploading of buffers,
 * blobs, or streams, using a configurable amount of concurrency to perform
 * multipart uploads where possible. This abstraction also enables uploading
 * streams of unknown size due to the use of multipart uploads.
 *
 * To construct a managed upload object, see the {constructor} function.
 *
 * ## Tracking upload progress
 *
 * The managed upload object can also track progress by attaching an
 * 'httpUploadProgress' listener to the upload manager. This event is similar
 * to {AWS.Request~httpUploadProgress} but groups all concurrent upload progress
 * into a single event. See {AWS.S3.ManagedUpload~httpUploadProgress} for more
 * information.
 *
 * ## Handling Multipart Cleanup
 *
 * By default, this class will automatically clean up any multipart uploads
 * when an individual part upload fails. This behavior can be disabled in order
 * to manually handle failures by setting the `leavePartsOnError` configuration
 * option to `true` when initializing the upload object.
 *
 * @!event httpUploadProgress(progress)
 *   Triggered when the uploader has uploaded more data.
 *   @note The `total` property may not be set if the stream being uploaded has
 *     not yet finished chunking. In this case the `total` will be undefined
 *     until the total stream size is known.
 *   @note This event will not be emitted in Node.js 0.8.x.
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request and the `key` of the S3 object. Note that `total` may be undefined until the payload
 *     size is known.
 *   @context (see AWS.Request~send)
 */
AWS.S3.ManagedUpload = AWS.util.inherit({
  /**
   * Creates a managed upload object with a set of configuration options.
   *
   * @note A "Body" parameter is required to be set prior to calling {send}.
   * @option options params [map] a map of parameters to pass to the upload
   *   requests. The "Body" parameter is required to be specified either on
   *   the service or in the params option.
   * @note ContentMD5 should not be provided when using the managed upload object.
   *   Instead, setting "computeChecksums" to true will enable automatic ContentMD5 generation
   *   by the managed upload object.
   * @option options queueSize [Number] (4) the size of the concurrent queue
   *   manager to upload parts in parallel. Set to 1 for synchronous uploading
   *   of parts. Note that the uploader will buffer at most queueSize * partSize
   *   bytes into memory at any given time.
   * @option options partSize [Number] (5mb) the size in bytes for each
   *   individual part to be uploaded. Adjust the part size to ensure the number
   *   of parts does not exceed {maxTotalParts}. See {minPartSize} for the
   *   minimum allowed part size.
   * @option options leavePartsOnError [Boolean] (false) whether to abort the
   *   multipart upload if an error occurs. Set to true if you want to handle
   *   failures manually.
   * @option options service [AWS.S3] an optional S3 service object to use for
   *   requests. This object might have bound parameters used by the uploader.
   * @option options tags [Array<map>] The tags to apply to the uploaded object.
   *   Each tag should have a `Key` and `Value` keys.
   * @example Creating a default uploader for a stream object
   *   var upload = new AWS.S3.ManagedUpload({
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
   *   });
   * @example Creating an uploader with concurrency of 1 and partSize of 10mb
   *   var upload = new AWS.S3.ManagedUpload({
   *     partSize: 10 * 1024 * 1024, queueSize: 1,
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
   *   });
   * @example Creating an uploader with tags
   *   var upload = new AWS.S3.ManagedUpload({
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream},
   *     tags: [{Key: 'tag1', Value: 'value1'}, {Key: 'tag2', Value: 'value2'}]
   *   });
   * @see send
   */
  constructor: function ManagedUpload(options) {
    var self = this;
    AWS.SequentialExecutor.call(self);
    self.body = null;
    self.sliceFn = null;
    self.callback = null;
    self.parts = {};
    self.completeInfo = [];
    self.fillQueue = function() {
      self.callback(new Error('Unsupported body payload ' + typeof self.body));
    };

    self.configure(options);
  },

  /**
   * @api private
   */
  configure: function configure(options) {
    options = options || {};
    this.partSize = this.minPartSize;

    if (options.queueSize) this.queueSize = options.queueSize;
    if (options.partSize) this.partSize = options.partSize;
    if (options.leavePartsOnError) this.leavePartsOnError = true;
    if (options.tags) {
      if (!Array.isArray(options.tags)) {
        throw new Error('Tags must be specified as an array; ' +
          typeof options.tags + ' provided.');
      }
      this.tags = options.tags;
    }

    if (this.partSize < this.minPartSize) {
      throw new Error('partSize must be greater than ' +
                      this.minPartSize);
    }

    this.service = options.service;
    this.bindServiceObject(options.params);
    this.validateBody();
    this.adjustTotalBytes();
  },

  /**
   * @api private
   */
  leavePartsOnError: false,

  /**
   * @api private
   */
  queueSize: 4,

  /**
   * @api private
   */
  partSize: null,

  /**
   * @readonly
   * @return [Number] the minimum number of bytes for an individual part
   *   upload.
   */
  minPartSize: 1024 * 1024 * 5,

  /**
   * @readonly
   * @return [Number] the maximum allowed number of parts in a multipart upload.
   */
  maxTotalParts: 10000,

  /**
   * Initiates the managed upload for the payload.
   *
   * @callback callback function(err, data)
   *   @param err [Error] an error or null if no error occurred.
   *   @param data [map] The response data from the successful upload:
   *     * `Location` (String) the URL of the uploaded object
   *     * `ETag` (String) the ETag of the uploaded object
   *     * `Bucket` (String) the bucket to which the object was uploaded
   *     * `Key` (String) the key to which the object was uploaded
   * @example Sending a managed upload object
   *   var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *   var upload = new AWS.S3.ManagedUpload({params: params});
   *   upload.send(function(err, data) {
   *     console.log(err, data);
   *   });
   */
  send: function(callback) {
    var self = this;
    self.failed = false;
    self.callback = callback || function(err) { if (err) throw err; };

    var runFill = true;
    if (self.sliceFn) {
      self.fillQueue = self.fillBuffer;
    } else if (AWS.util.isNode()) {
      var Stream = AWS.util.stream.Stream;
      if (self.body instanceof Stream) {
        runFill = false;
        self.fillQueue = self.fillStream;
        self.partBuffers = [];
        self.body.
          on('error', function(err) { self.cleanup(err); }).
          on('readable', function() { self.fillQueue(); }).
          on('end', function() {
            self.isDoneChunking = true;
            self.numParts = self.totalPartNumbers;
            self.fillQueue.call(self);

            if (self.isDoneChunking && self.totalPartNumbers >= 1 && self.doneParts === self.numParts) {
              self.finishMultiPart();
            }
          });
      }
    }

    if (runFill) self.fillQueue.call(self);
  },

  /**
   * @!method  promise()
   *   Returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [map] The response data from the successful upload:
   *       `Location` (String) the URL of the uploaded object
   *       `ETag` (String) the ETag of the uploaded object
   *       `Bucket` (String) the bucket to which the object was uploaded
   *       `Key` (String) the key to which the object was uploaded
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] an error or null if no error occurred.
   *   @return [Promise] A promise that represents the state of the upload request.
   *   @example Sending an upload request using promises.
   *     var upload = s3.upload({Bucket: 'bucket', Key: 'key', Body: stream});
   *     var promise = upload.promise();
   *     promise.then(function(data) { ... }, function(err) { ... });
   */

  /**
   * Aborts a managed upload, including all concurrent upload requests.
   * @note By default, calling this function will cleanup a multipart upload
   *   if one was created. To leave the multipart upload around after aborting
   *   a request, configure `leavePartsOnError` to `true` in the {constructor}.
   * @note Calling {abort} in the browser environment will not abort any requests
   *   that are already in flight. If a multipart upload was created, any parts
   *   not yet uploaded will not be sent, and the multipart upload will be cleaned up.
   * @example Aborting an upload
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: new Buffer(1024 * 1024 * 25) // 25MB payload
   *   };
   *   var upload = s3.upload(params);
   *   upload.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(upload.abort.bind(upload), 1000);
   */
  abort: function() {
    this.cleanup(AWS.util.error(new Error('Request aborted by user'), {
      code: 'RequestAbortedError', retryable: false
    }));
  },

  /**
   * @api private
   */
  validateBody: function validateBody() {
    var self = this;
    self.body = self.service.config.params.Body;
    if (typeof self.body === 'string') {
      self.body = new AWS.util.Buffer(self.body);
    } else if (!self.body) {
      throw new Error('params.Body is required');
    }
    self.sliceFn = AWS.util.arraySliceFn(self.body);
  },

  /**
   * @api private
   */
  bindServiceObject: function bindServiceObject(params) {
    params = params || {};
    var self = this;
    // bind parameters to new service object
    if (!self.service) {
      self.service = new AWS.S3({params: params});
    } else {
      var service = self.service;
      var config = AWS.util.copy(service.config);
      config.signatureVersion = service.getSignatureVersion();
      self.service = new service.constructor.__super__(config);
      self.service.config.params =
        AWS.util.merge(self.service.config.params || {}, params);
    }
  },

  /**
   * @api private
   */
  adjustTotalBytes: function adjustTotalBytes() {
    var self = this;
    try { // try to get totalBytes
      self.totalBytes = byteLength(self.body);
    } catch (e) { }

    // try to adjust partSize if we know payload length
    if (self.totalBytes) {
      var newPartSize = Math.ceil(self.totalBytes / self.maxTotalParts);
      if (newPartSize > self.partSize) self.partSize = newPartSize;
    } else {
      self.totalBytes = undefined;
    }
  },

  /**
   * @api private
   */
  isDoneChunking: false,

  /**
   * @api private
   */
  partPos: 0,

  /**
   * @api private
   */
  totalChunkedBytes: 0,

  /**
   * @api private
   */
  totalUploadedBytes: 0,

  /**
   * @api private
   */
  totalBytes: undefined,

  /**
   * @api private
   */
  numParts: 0,

  /**
   * @api private
   */
  totalPartNumbers: 0,

  /**
   * @api private
   */
  activeParts: 0,

  /**
   * @api private
   */
  doneParts: 0,

  /**
   * @api private
   */
  parts: null,

  /**
   * @api private
   */
  completeInfo: null,

  /**
   * @api private
   */
  failed: false,

  /**
   * @api private
   */
  multipartReq: null,

  /**
   * @api private
   */
  partBuffers: null,

  /**
   * @api private
   */
  partBufferLength: 0,

  /**
   * @api private
   */
  fillBuffer: function fillBuffer() {
    var self = this;
    var bodyLen = byteLength(self.body);

    if (bodyLen === 0) {
      self.isDoneChunking = true;
      self.numParts = 1;
      self.nextChunk(self.body);
      return;
    }

    while (self.activeParts < self.queueSize && self.partPos < bodyLen) {
      var endPos = Math.min(self.partPos + self.partSize, bodyLen);
      var buf = self.sliceFn.call(self.body, self.partPos, endPos);
      self.partPos += self.partSize;

      if (byteLength(buf) < self.partSize || self.partPos === bodyLen) {
        self.isDoneChunking = true;
        self.numParts = self.totalPartNumbers + 1;
      }
      self.nextChunk(buf);
    }
  },

  /**
   * @api private
   */
  fillStream: function fillStream() {
    var self = this;
    if (self.activeParts >= self.queueSize) return;

    var buf = self.body.read(self.partSize - self.partBufferLength) ||
              self.body.read();
    if (buf) {
      self.partBuffers.push(buf);
      self.partBufferLength += buf.length;
      self.totalChunkedBytes += buf.length;
    }

    if (self.partBufferLength >= self.partSize) {
      // if we have single buffer we avoid copyfull concat
      var pbuf = self.partBuffers.length === 1 ?
        self.partBuffers[0] : Buffer.concat(self.partBuffers);
      self.partBuffers = [];
      self.partBufferLength = 0;

      // if we have more than partSize, push the rest back on the queue
      if (pbuf.length > self.partSize) {
        var rest = pbuf.slice(self.partSize);
        self.partBuffers.push(rest);
        self.partBufferLength += rest.length;
        pbuf = pbuf.slice(0, self.partSize);
      }

      self.nextChunk(pbuf);
    }

    if (self.isDoneChunking && !self.isDoneSending) {
      // if we have single buffer we avoid copyfull concat
      pbuf = self.partBuffers.length === 1 ?
          self.partBuffers[0] : Buffer.concat(self.partBuffers);
      self.partBuffers = [];
      self.partBufferLength = 0;
      self.totalBytes = self.totalChunkedBytes;
      self.isDoneSending = true;

      if (self.numParts === 0 || pbuf.length > 0) {
        self.numParts++;
        self.nextChunk(pbuf);
      }
    }

    self.body.read(0);
  },

  /**
   * @api private
   */
  nextChunk: function nextChunk(chunk) {
    var self = this;
    if (self.failed) return null;

    var partNumber = ++self.totalPartNumbers;
    if (self.isDoneChunking && partNumber === 1) {
      var params = {Body: chunk};
      if (this.tags) {
        params.Tagging = this.getTaggingHeader();
      }
      var req = self.service.putObject(params);
      req._managedUpload = self;
      req.on('httpUploadProgress', self.progress).send(self.finishSinglePart);
      return null;
    } else if (self.service.config.params.ContentMD5) {
      var err = AWS.util.error(new Error('The Content-MD5 you specified is invalid for multi-part uploads.'), {
        code: 'InvalidDigest', retryable: false
      });

      self.cleanup(err);
      return null;
    }

    if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) {
      return null; // Already uploaded this part.
    }

    self.activeParts++;
    if (!self.service.config.params.UploadId) {

      if (!self.multipartReq) { // create multipart
        self.multipartReq = self.service.createMultipartUpload();
        self.multipartReq.on('success', function(resp) {
          self.service.config.params.UploadId = resp.data.UploadId;
          self.multipartReq = null;
        });
        self.queueChunks(chunk, partNumber);
        self.multipartReq.on('error', function(err) {
          self.cleanup(err);
        });
        self.multipartReq.send();
      } else {
        self.queueChunks(chunk, partNumber);
      }
    } else { // multipart is created, just send
      self.uploadPart(chunk, partNumber);
    }
  },

  /**
   * @api private
   */
  getTaggingHeader: function getTaggingHeader() {
    var kvPairStrings = [];
    for (var i = 0; i < this.tags.length; i++) {
      kvPairStrings.push(AWS.util.uriEscape(this.tags[i].Key) + '=' +
        AWS.util.uriEscape(this.tags[i].Value));
    }

    return kvPairStrings.join('&');
  },

  /**
   * @api private
   */
  uploadPart: function uploadPart(chunk, partNumber) {
    var self = this;

    var partParams = {
      Body: chunk,
      ContentLength: AWS.util.string.byteLength(chunk),
      PartNumber: partNumber
    };

    var partInfo = {ETag: null, PartNumber: partNumber};
    self.completeInfo[partNumber] = partInfo;

    var req = self.service.uploadPart(partParams);
    self.parts[partNumber] = req;
    req._lastUploadedBytes = 0;
    req._managedUpload = self;
    req.on('httpUploadProgress', self.progress);
    req.send(function(err, data) {
      delete self.parts[partParams.PartNumber];
      self.activeParts--;

      if (!err && (!data || !data.ETag)) {
        var message = 'No access to ETag property on response.';
        if (AWS.util.isBrowser()) {
          message += ' Check CORS configuration to expose ETag header.';
        }

        err = AWS.util.error(new Error(message), {
          code: 'ETagMissing', retryable: false
        });
      }
      if (err) return self.cleanup(err);

      partInfo.ETag = data.ETag;
      self.doneParts++;
      if (self.isDoneChunking && self.doneParts === self.numParts) {
        self.finishMultiPart();
      } else {
        self.fillQueue.call(self);
      }
    });
  },

  /**
   * @api private
   */
  queueChunks: function queueChunks(chunk, partNumber) {
    var self = this;
    self.multipartReq.on('success', function() {
      self.uploadPart(chunk, partNumber);
    });
  },

  /**
   * @api private
   */
  cleanup: function cleanup(err) {
    var self = this;
    if (self.failed) return;

    // clean up stream
    if (typeof self.body.removeAllListeners === 'function' &&
        typeof self.body.resume === 'function') {
      self.body.removeAllListeners('readable');
      self.body.removeAllListeners('end');
      self.body.resume();
    }

    // cleanup multipartReq listeners
    if (self.multipartReq) {
      self.multipartReq.removeAllListeners('success');
      self.multipartReq.removeAllListeners('error');
      self.multipartReq.removeAllListeners('complete');
      delete self.multipartReq;
    }

    if (self.service.config.params.UploadId && !self.leavePartsOnError) {
      self.service.abortMultipartUpload().send();
    } else if (self.leavePartsOnError) {
      self.isDoneChunking = false;
    }

    AWS.util.each(self.parts, function(partNumber, part) {
      part.removeAllListeners('complete');
      part.abort();
    });

    self.activeParts = 0;
    self.partPos = 0;
    self.numParts = 0;
    self.totalPartNumbers = 0;
    self.parts = {};
    self.failed = true;
    self.callback(err);
  },

  /**
   * @api private
   */
  finishMultiPart: function finishMultiPart() {
    var self = this;
    var completeParams = { MultipartUpload: { Parts: self.completeInfo.slice(1) } };
    self.service.completeMultipartUpload(completeParams, function(err, data) {
      if (err) {
        return self.cleanup(err);
      }

      if (data && typeof data.Location === 'string') {
        data.Location = data.Location.replace(/%2F/g, '/');
      }

      if (Array.isArray(self.tags)) {
        self.service.putObjectTagging(
          {Tagging: {TagSet: self.tags}},
          function(e, d) {
            if (e) {
              self.callback(e);
            } else {
              self.callback(e, data);
            }
          }
        );
      } else {
        self.callback(err, data);
      }
    });
  },

  /**
   * @api private
   */
  finishSinglePart: function finishSinglePart(err, data) {
    var upload = this.request._managedUpload;
    var httpReq = this.request.httpRequest;
    var endpoint = httpReq.endpoint;
    if (err) return upload.callback(err);
    data.Location =
      [endpoint.protocol, '//', endpoint.host, httpReq.path].join('');
    data.key = this.request.params.Key; // will stay undocumented
    data.Key = this.request.params.Key;
    data.Bucket = this.request.params.Bucket;
    upload.callback(err, data);
  },

  /**
   * @api private
   */
  progress: function progress(info) {
    var upload = this._managedUpload;
    if (this.operation === 'putObject') {
      info.part = 1;
      info.key = this.params.Key;
    } else {
      upload.totalUploadedBytes += info.loaded - this._lastUploadedBytes;
      this._lastUploadedBytes = info.loaded;
      info = {
        loaded: upload.totalUploadedBytes,
        total: upload.totalBytes,
        part: this.params.PartNumber,
        key: this.params.Key
      };
    }
    upload.emit('httpUploadProgress', [info]);
  }
});

AWS.util.mixin(AWS.S3.ManagedUpload, AWS.SequentialExecutor);

/**
 * @api private
 */
AWS.S3.ManagedUpload.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
  this.prototype.promise = AWS.util.promisifyMethod('send', PromiseDependency);
};

/**
 * @api private
 */
AWS.S3.ManagedUpload.deletePromisesFromClass = function deletePromisesFromClass() {
  delete this.prototype.promise;
};

AWS.util.addPromises(AWS.S3.ManagedUpload);

module.exports = AWS.S3.ManagedUpload;


/***/ }),
/* 1711 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2006-03-01",
		"checksumFormat": "md5",
		"endpointPrefix": "s3",
		"globalEndpoint": "s3.amazonaws.com",
		"protocol": "rest-xml",
		"serviceAbbreviation": "Amazon S3",
		"serviceFullName": "Amazon Simple Storage Service",
		"signatureVersion": "s3",
		"timestampFormat": "rfc822",
		"uid": "s3-2006-03-01"
	},
	"operations": {
		"AbortMultipartUpload": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"UploadId"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"UploadId": {
						"location": "querystring",
						"locationName": "uploadId"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"CompleteMultipartUpload": {
			"http": {
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"UploadId"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"MultipartUpload": {
						"locationName": "CompleteMultipartUpload",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"Parts": {
								"locationName": "Part",
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"ETag": {},
										"PartNumber": {
											"type": "integer"
										}
									}
								},
								"flattened": true
							}
						}
					},
					"UploadId": {
						"location": "querystring",
						"locationName": "uploadId"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				},
				"payload": "MultipartUpload"
			},
			"output": {
				"type": "structure",
				"members": {
					"Location": {},
					"Bucket": {},
					"Key": {},
					"Expiration": {
						"location": "header",
						"locationName": "x-amz-expiration"
					},
					"ETag": {},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"CopyObject": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"CopySource",
					"Key"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CacheControl": {
						"location": "header",
						"locationName": "Cache-Control"
					},
					"ContentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"ContentEncoding": {
						"location": "header",
						"locationName": "Content-Encoding"
					},
					"ContentLanguage": {
						"location": "header",
						"locationName": "Content-Language"
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"CopySource": {
						"location": "header",
						"locationName": "x-amz-copy-source"
					},
					"CopySourceIfMatch": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-match"
					},
					"CopySourceIfModifiedSince": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-modified-since",
						"type": "timestamp"
					},
					"CopySourceIfNoneMatch": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-none-match"
					},
					"CopySourceIfUnmodifiedSince": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-unmodified-since",
						"type": "timestamp"
					},
					"Expires": {
						"location": "header",
						"locationName": "Expires",
						"type": "timestamp"
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"Metadata": {
						"shape": "S11",
						"location": "headers",
						"locationName": "x-amz-meta-"
					},
					"MetadataDirective": {
						"location": "header",
						"locationName": "x-amz-metadata-directive"
					},
					"TaggingDirective": {
						"location": "header",
						"locationName": "x-amz-tagging-directive"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"StorageClass": {
						"location": "header",
						"locationName": "x-amz-storage-class"
					},
					"WebsiteRedirectLocation": {
						"location": "header",
						"locationName": "x-amz-website-redirect-location"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"CopySourceSSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
					},
					"CopySourceSSECustomerKey": {
						"shape": "S1c",
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-key"
					},
					"CopySourceSSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"Tagging": {
						"location": "header",
						"locationName": "x-amz-tagging"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CopyObjectResult": {
						"type": "structure",
						"members": {
							"ETag": {},
							"LastModified": {
								"type": "timestamp"
							}
						}
					},
					"Expiration": {
						"location": "header",
						"locationName": "x-amz-expiration"
					},
					"CopySourceVersionId": {
						"location": "header",
						"locationName": "x-amz-copy-source-version-id"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				},
				"payload": "CopyObjectResult"
			},
			"alias": "PutObjectCopy"
		},
		"CreateBucket": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CreateBucketConfiguration": {
						"locationName": "CreateBucketConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"LocationConstraint": {}
						}
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWrite": {
						"location": "header",
						"locationName": "x-amz-grant-write"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					}
				},
				"payload": "CreateBucketConfiguration"
			},
			"output": {
				"type": "structure",
				"members": {
					"Location": {
						"location": "header",
						"locationName": "Location"
					}
				}
			},
			"alias": "PutBucket"
		},
		"CreateMultipartUpload": {
			"http": {
				"requestUri": "/{Bucket}/{Key+}?uploads"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CacheControl": {
						"location": "header",
						"locationName": "Cache-Control"
					},
					"ContentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"ContentEncoding": {
						"location": "header",
						"locationName": "Content-Encoding"
					},
					"ContentLanguage": {
						"location": "header",
						"locationName": "Content-Language"
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"Expires": {
						"location": "header",
						"locationName": "Expires",
						"type": "timestamp"
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"Metadata": {
						"shape": "S11",
						"location": "headers",
						"locationName": "x-amz-meta-"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"StorageClass": {
						"location": "header",
						"locationName": "x-amz-storage-class"
					},
					"WebsiteRedirectLocation": {
						"location": "header",
						"locationName": "x-amz-website-redirect-location"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"Tagging": {
						"location": "header",
						"locationName": "x-amz-tagging"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AbortDate": {
						"location": "header",
						"locationName": "x-amz-abort-date",
						"type": "timestamp"
					},
					"AbortRuleId": {
						"location": "header",
						"locationName": "x-amz-abort-rule-id"
					},
					"Bucket": {
						"locationName": "Bucket"
					},
					"Key": {},
					"UploadId": {},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			},
			"alias": "InitiateMultipartUpload"
		},
		"DeleteBucket": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketAnalyticsConfiguration": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?analytics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			}
		},
		"DeleteBucketCors": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?cors"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketInventoryConfiguration": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?inventory"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			}
		},
		"DeleteBucketLifecycle": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?lifecycle"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketMetricsConfiguration": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?metrics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			}
		},
		"DeleteBucketPolicy": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?policy"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketReplication": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?replication"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketTagging": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteBucketWebsite": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}?website"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"DeleteObject": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"MFA": {
						"location": "header",
						"locationName": "x-amz-mfa"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeleteMarker": {
						"location": "header",
						"locationName": "x-amz-delete-marker",
						"type": "boolean"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"DeleteObjectTagging": {
			"http": {
				"method": "DELETE",
				"requestUri": "/{Bucket}/{Key+}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					}
				}
			}
		},
		"DeleteObjects": {
			"http": {
				"requestUri": "/{Bucket}?delete"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Delete"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Delete": {
						"locationName": "Delete",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"Objects"
						],
						"members": {
							"Objects": {
								"locationName": "Object",
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"Key"
									],
									"members": {
										"Key": {},
										"VersionId": {}
									}
								},
								"flattened": true
							},
							"Quiet": {
								"type": "boolean"
							}
						}
					},
					"MFA": {
						"location": "header",
						"locationName": "x-amz-mfa"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				},
				"payload": "Delete"
			},
			"output": {
				"type": "structure",
				"members": {
					"Deleted": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"VersionId": {},
								"DeleteMarker": {
									"type": "boolean"
								},
								"DeleteMarkerVersionId": {}
							}
						},
						"flattened": true
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					},
					"Errors": {
						"locationName": "Error",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"VersionId": {},
								"Code": {},
								"Message": {}
							}
						},
						"flattened": true
					}
				}
			},
			"alias": "DeleteMultipleObjects"
		},
		"GetBucketAccelerateConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?accelerate"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Status": {}
				}
			}
		},
		"GetBucketAcl": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?acl"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Owner": {
						"shape": "S2u"
					},
					"Grants": {
						"shape": "S2x",
						"locationName": "AccessControlList"
					}
				}
			}
		},
		"GetBucketAnalyticsConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?analytics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AnalyticsConfiguration": {
						"shape": "S36"
					}
				},
				"payload": "AnalyticsConfiguration"
			}
		},
		"GetBucketCors": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?cors"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CORSRules": {
						"shape": "S3m",
						"locationName": "CORSRule"
					}
				}
			}
		},
		"GetBucketInventoryConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?inventory"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InventoryConfiguration": {
						"shape": "S3z"
					}
				},
				"payload": "InventoryConfiguration"
			}
		},
		"GetBucketLifecycle": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?lifecycle"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S4c",
						"locationName": "Rule"
					}
				}
			},
			"deprecated": true
		},
		"GetBucketLifecycleConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?lifecycle"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Rules": {
						"shape": "S4r",
						"locationName": "Rule"
					}
				}
			}
		},
		"GetBucketLocation": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?location"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"LocationConstraint": {}
				}
			}
		},
		"GetBucketLogging": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?logging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"LoggingEnabled": {
						"shape": "S51"
					}
				}
			}
		},
		"GetBucketMetricsConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?metrics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"MetricsConfiguration": {
						"shape": "S59"
					}
				},
				"payload": "MetricsConfiguration"
			}
		},
		"GetBucketNotification": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?notification"
			},
			"input": {
				"shape": "S5c"
			},
			"output": {
				"shape": "S5d"
			},
			"deprecated": true
		},
		"GetBucketNotificationConfiguration": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?notification"
			},
			"input": {
				"shape": "S5c"
			},
			"output": {
				"shape": "S5o"
			}
		},
		"GetBucketPolicy": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?policy"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Policy": {}
				},
				"payload": "Policy"
			}
		},
		"GetBucketReplication": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?replication"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ReplicationConfiguration": {
						"shape": "S67"
					}
				},
				"payload": "ReplicationConfiguration"
			}
		},
		"GetBucketRequestPayment": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?requestPayment"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Payer": {}
				}
			}
		},
		"GetBucketTagging": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TagSet"
				],
				"members": {
					"TagSet": {
						"shape": "S3c"
					}
				}
			}
		},
		"GetBucketVersioning": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?versioning"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Status": {},
					"MFADelete": {
						"locationName": "MfaDelete"
					}
				}
			}
		},
		"GetBucketWebsite": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?website"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RedirectAllRequestsTo": {
						"shape": "S6o"
					},
					"IndexDocument": {
						"shape": "S6r"
					},
					"ErrorDocument": {
						"shape": "S6t"
					},
					"RoutingRules": {
						"shape": "S6u"
					}
				}
			}
		},
		"GetObject": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					},
					"IfModifiedSince": {
						"location": "header",
						"locationName": "If-Modified-Since",
						"type": "timestamp"
					},
					"IfNoneMatch": {
						"location": "header",
						"locationName": "If-None-Match"
					},
					"IfUnmodifiedSince": {
						"location": "header",
						"locationName": "If-Unmodified-Since",
						"type": "timestamp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"Range": {
						"location": "header",
						"locationName": "Range"
					},
					"ResponseCacheControl": {
						"location": "querystring",
						"locationName": "response-cache-control"
					},
					"ResponseContentDisposition": {
						"location": "querystring",
						"locationName": "response-content-disposition"
					},
					"ResponseContentEncoding": {
						"location": "querystring",
						"locationName": "response-content-encoding"
					},
					"ResponseContentLanguage": {
						"location": "querystring",
						"locationName": "response-content-language"
					},
					"ResponseContentType": {
						"location": "querystring",
						"locationName": "response-content-type"
					},
					"ResponseExpires": {
						"location": "querystring",
						"locationName": "response-expires",
						"type": "timestamp"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"PartNumber": {
						"location": "querystring",
						"locationName": "partNumber",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Body": {
						"streaming": true,
						"type": "blob"
					},
					"DeleteMarker": {
						"location": "header",
						"locationName": "x-amz-delete-marker",
						"type": "boolean"
					},
					"AcceptRanges": {
						"location": "header",
						"locationName": "accept-ranges"
					},
					"Expiration": {
						"location": "header",
						"locationName": "x-amz-expiration"
					},
					"Restore": {
						"location": "header",
						"locationName": "x-amz-restore"
					},
					"LastModified": {
						"location": "header",
						"locationName": "Last-Modified",
						"type": "timestamp"
					},
					"ContentLength": {
						"location": "header",
						"locationName": "Content-Length",
						"type": "long"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					},
					"MissingMeta": {
						"location": "header",
						"locationName": "x-amz-missing-meta",
						"type": "integer"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"CacheControl": {
						"location": "header",
						"locationName": "Cache-Control"
					},
					"ContentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"ContentEncoding": {
						"location": "header",
						"locationName": "Content-Encoding"
					},
					"ContentLanguage": {
						"location": "header",
						"locationName": "Content-Language"
					},
					"ContentRange": {
						"location": "header",
						"locationName": "Content-Range"
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"Expires": {
						"location": "header",
						"locationName": "Expires",
						"type": "timestamp"
					},
					"WebsiteRedirectLocation": {
						"location": "header",
						"locationName": "x-amz-website-redirect-location"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"Metadata": {
						"shape": "S11",
						"location": "headers",
						"locationName": "x-amz-meta-"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"StorageClass": {
						"location": "header",
						"locationName": "x-amz-storage-class"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					},
					"ReplicationStatus": {
						"location": "header",
						"locationName": "x-amz-replication-status"
					},
					"PartsCount": {
						"location": "header",
						"locationName": "x-amz-mp-parts-count",
						"type": "integer"
					},
					"TagCount": {
						"location": "header",
						"locationName": "x-amz-tagging-count",
						"type": "integer"
					}
				},
				"payload": "Body"
			}
		},
		"GetObjectAcl": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}/{Key+}?acl"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Owner": {
						"shape": "S2u"
					},
					"Grants": {
						"shape": "S2x",
						"locationName": "AccessControlList"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"GetObjectTagging": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}/{Key+}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"TagSet"
				],
				"members": {
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"TagSet": {
						"shape": "S3c"
					}
				}
			}
		},
		"GetObjectTorrent": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}/{Key+}?torrent"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Body": {
						"streaming": true,
						"type": "blob"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				},
				"payload": "Body"
			}
		},
		"HeadBucket": {
			"http": {
				"method": "HEAD",
				"requestUri": "/{Bucket}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			}
		},
		"HeadObject": {
			"http": {
				"method": "HEAD",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"IfMatch": {
						"location": "header",
						"locationName": "If-Match"
					},
					"IfModifiedSince": {
						"location": "header",
						"locationName": "If-Modified-Since",
						"type": "timestamp"
					},
					"IfNoneMatch": {
						"location": "header",
						"locationName": "If-None-Match"
					},
					"IfUnmodifiedSince": {
						"location": "header",
						"locationName": "If-Unmodified-Since",
						"type": "timestamp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"Range": {
						"location": "header",
						"locationName": "Range"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"PartNumber": {
						"location": "querystring",
						"locationName": "partNumber",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeleteMarker": {
						"location": "header",
						"locationName": "x-amz-delete-marker",
						"type": "boolean"
					},
					"AcceptRanges": {
						"location": "header",
						"locationName": "accept-ranges"
					},
					"Expiration": {
						"location": "header",
						"locationName": "x-amz-expiration"
					},
					"Restore": {
						"location": "header",
						"locationName": "x-amz-restore"
					},
					"LastModified": {
						"location": "header",
						"locationName": "Last-Modified",
						"type": "timestamp"
					},
					"ContentLength": {
						"location": "header",
						"locationName": "Content-Length",
						"type": "long"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					},
					"MissingMeta": {
						"location": "header",
						"locationName": "x-amz-missing-meta",
						"type": "integer"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"CacheControl": {
						"location": "header",
						"locationName": "Cache-Control"
					},
					"ContentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"ContentEncoding": {
						"location": "header",
						"locationName": "Content-Encoding"
					},
					"ContentLanguage": {
						"location": "header",
						"locationName": "Content-Language"
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"Expires": {
						"location": "header",
						"locationName": "Expires",
						"type": "timestamp"
					},
					"WebsiteRedirectLocation": {
						"location": "header",
						"locationName": "x-amz-website-redirect-location"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"Metadata": {
						"shape": "S11",
						"location": "headers",
						"locationName": "x-amz-meta-"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"StorageClass": {
						"location": "header",
						"locationName": "x-amz-storage-class"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					},
					"ReplicationStatus": {
						"location": "header",
						"locationName": "x-amz-replication-status"
					},
					"PartsCount": {
						"location": "header",
						"locationName": "x-amz-mp-parts-count",
						"type": "integer"
					}
				}
			}
		},
		"ListBucketAnalyticsConfigurations": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?analytics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContinuationToken": {
						"location": "querystring",
						"locationName": "continuation-token"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsTruncated": {
						"type": "boolean"
					},
					"ContinuationToken": {},
					"NextContinuationToken": {},
					"AnalyticsConfigurationList": {
						"locationName": "AnalyticsConfiguration",
						"type": "list",
						"member": {
							"shape": "S36"
						},
						"flattened": true
					}
				}
			}
		},
		"ListBucketInventoryConfigurations": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?inventory"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContinuationToken": {
						"location": "querystring",
						"locationName": "continuation-token"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ContinuationToken": {},
					"InventoryConfigurationList": {
						"locationName": "InventoryConfiguration",
						"type": "list",
						"member": {
							"shape": "S3z"
						},
						"flattened": true
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"NextContinuationToken": {}
				}
			}
		},
		"ListBucketMetricsConfigurations": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?metrics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContinuationToken": {
						"location": "querystring",
						"locationName": "continuation-token"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsTruncated": {
						"type": "boolean"
					},
					"ContinuationToken": {},
					"NextContinuationToken": {},
					"MetricsConfigurationList": {
						"locationName": "MetricsConfiguration",
						"type": "list",
						"member": {
							"shape": "S59"
						},
						"flattened": true
					}
				}
			}
		},
		"ListBuckets": {
			"http": {
				"method": "GET"
			},
			"output": {
				"type": "structure",
				"members": {
					"Buckets": {
						"type": "list",
						"member": {
							"locationName": "Bucket",
							"type": "structure",
							"members": {
								"Name": {},
								"CreationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"Owner": {
						"shape": "S2u"
					}
				}
			},
			"alias": "GetService"
		},
		"ListMultipartUploads": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?uploads"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Delimiter": {
						"location": "querystring",
						"locationName": "delimiter"
					},
					"EncodingType": {
						"location": "querystring",
						"locationName": "encoding-type"
					},
					"KeyMarker": {
						"location": "querystring",
						"locationName": "key-marker"
					},
					"MaxUploads": {
						"location": "querystring",
						"locationName": "max-uploads",
						"type": "integer"
					},
					"Prefix": {
						"location": "querystring",
						"locationName": "prefix"
					},
					"UploadIdMarker": {
						"location": "querystring",
						"locationName": "upload-id-marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Bucket": {},
					"KeyMarker": {},
					"UploadIdMarker": {},
					"NextKeyMarker": {},
					"Prefix": {},
					"Delimiter": {},
					"NextUploadIdMarker": {},
					"MaxUploads": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Uploads": {
						"locationName": "Upload",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"UploadId": {},
								"Key": {},
								"Initiated": {
									"type": "timestamp"
								},
								"StorageClass": {},
								"Owner": {
									"shape": "S2u"
								},
								"Initiator": {
									"shape": "S8q"
								}
							}
						},
						"flattened": true
					},
					"CommonPrefixes": {
						"shape": "S8r"
					},
					"EncodingType": {}
				}
			}
		},
		"ListObjectVersions": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?versions"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Delimiter": {
						"location": "querystring",
						"locationName": "delimiter"
					},
					"EncodingType": {
						"location": "querystring",
						"locationName": "encoding-type"
					},
					"KeyMarker": {
						"location": "querystring",
						"locationName": "key-marker"
					},
					"MaxKeys": {
						"location": "querystring",
						"locationName": "max-keys",
						"type": "integer"
					},
					"Prefix": {
						"location": "querystring",
						"locationName": "prefix"
					},
					"VersionIdMarker": {
						"location": "querystring",
						"locationName": "version-id-marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsTruncated": {
						"type": "boolean"
					},
					"KeyMarker": {},
					"VersionIdMarker": {},
					"NextKeyMarker": {},
					"NextVersionIdMarker": {},
					"Versions": {
						"locationName": "Version",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ETag": {},
								"Size": {
									"type": "integer"
								},
								"StorageClass": {},
								"Key": {},
								"VersionId": {},
								"IsLatest": {
									"type": "boolean"
								},
								"LastModified": {
									"type": "timestamp"
								},
								"Owner": {
									"shape": "S2u"
								}
							}
						},
						"flattened": true
					},
					"DeleteMarkers": {
						"locationName": "DeleteMarker",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Owner": {
									"shape": "S2u"
								},
								"Key": {},
								"VersionId": {},
								"IsLatest": {
									"type": "boolean"
								},
								"LastModified": {
									"type": "timestamp"
								}
							}
						},
						"flattened": true
					},
					"Name": {},
					"Prefix": {},
					"Delimiter": {},
					"MaxKeys": {
						"type": "integer"
					},
					"CommonPrefixes": {
						"shape": "S8r"
					},
					"EncodingType": {}
				}
			},
			"alias": "GetBucketObjectVersions"
		},
		"ListObjects": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Delimiter": {
						"location": "querystring",
						"locationName": "delimiter"
					},
					"EncodingType": {
						"location": "querystring",
						"locationName": "encoding-type"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"MaxKeys": {
						"location": "querystring",
						"locationName": "max-keys",
						"type": "integer"
					},
					"Prefix": {
						"location": "querystring",
						"locationName": "prefix"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsTruncated": {
						"type": "boolean"
					},
					"Marker": {},
					"NextMarker": {},
					"Contents": {
						"shape": "S99"
					},
					"Name": {},
					"Prefix": {},
					"Delimiter": {},
					"MaxKeys": {
						"type": "integer"
					},
					"CommonPrefixes": {
						"shape": "S8r"
					},
					"EncodingType": {}
				}
			},
			"alias": "GetBucket"
		},
		"ListObjectsV2": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}?list-type=2"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Delimiter": {
						"location": "querystring",
						"locationName": "delimiter"
					},
					"EncodingType": {
						"location": "querystring",
						"locationName": "encoding-type"
					},
					"MaxKeys": {
						"location": "querystring",
						"locationName": "max-keys",
						"type": "integer"
					},
					"Prefix": {
						"location": "querystring",
						"locationName": "prefix"
					},
					"ContinuationToken": {
						"location": "querystring",
						"locationName": "continuation-token"
					},
					"FetchOwner": {
						"location": "querystring",
						"locationName": "fetch-owner",
						"type": "boolean"
					},
					"StartAfter": {
						"location": "querystring",
						"locationName": "start-after"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IsTruncated": {
						"type": "boolean"
					},
					"Contents": {
						"shape": "S99"
					},
					"Name": {},
					"Prefix": {},
					"Delimiter": {},
					"MaxKeys": {
						"type": "integer"
					},
					"CommonPrefixes": {
						"shape": "S8r"
					},
					"EncodingType": {},
					"KeyCount": {
						"type": "integer"
					},
					"ContinuationToken": {},
					"NextContinuationToken": {},
					"StartAfter": {}
				}
			}
		},
		"ListParts": {
			"http": {
				"method": "GET",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"UploadId"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"MaxParts": {
						"location": "querystring",
						"locationName": "max-parts",
						"type": "integer"
					},
					"PartNumberMarker": {
						"location": "querystring",
						"locationName": "part-number-marker",
						"type": "integer"
					},
					"UploadId": {
						"location": "querystring",
						"locationName": "uploadId"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AbortDate": {
						"location": "header",
						"locationName": "x-amz-abort-date",
						"type": "timestamp"
					},
					"AbortRuleId": {
						"location": "header",
						"locationName": "x-amz-abort-rule-id"
					},
					"Bucket": {},
					"Key": {},
					"UploadId": {},
					"PartNumberMarker": {
						"type": "integer"
					},
					"NextPartNumberMarker": {
						"type": "integer"
					},
					"MaxParts": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Parts": {
						"locationName": "Part",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PartNumber": {
									"type": "integer"
								},
								"LastModified": {
									"type": "timestamp"
								},
								"ETag": {},
								"Size": {
									"type": "integer"
								}
							}
						},
						"flattened": true
					},
					"Initiator": {
						"shape": "S8q"
					},
					"Owner": {
						"shape": "S2u"
					},
					"StorageClass": {},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"PutBucketAccelerateConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?accelerate"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"AccelerateConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"AccelerateConfiguration": {
						"locationName": "AccelerateConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"Status": {}
						}
					}
				},
				"payload": "AccelerateConfiguration"
			}
		},
		"PutBucketAcl": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?acl"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"AccessControlPolicy": {
						"shape": "S9r",
						"locationName": "AccessControlPolicy",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWrite": {
						"location": "header",
						"locationName": "x-amz-grant-write"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					}
				},
				"payload": "AccessControlPolicy"
			}
		},
		"PutBucketAnalyticsConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?analytics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id",
					"AnalyticsConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					},
					"AnalyticsConfiguration": {
						"shape": "S36",
						"locationName": "AnalyticsConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "AnalyticsConfiguration"
			}
		},
		"PutBucketCors": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?cors"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"CORSConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CORSConfiguration": {
						"locationName": "CORSConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"CORSRules"
						],
						"members": {
							"CORSRules": {
								"shape": "S3m",
								"locationName": "CORSRule"
							}
						}
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					}
				},
				"payload": "CORSConfiguration"
			}
		},
		"PutBucketInventoryConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?inventory"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id",
					"InventoryConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					},
					"InventoryConfiguration": {
						"shape": "S3z",
						"locationName": "InventoryConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "InventoryConfiguration"
			}
		},
		"PutBucketLifecycle": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?lifecycle"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"LifecycleConfiguration": {
						"locationName": "LifecycleConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"Rules"
						],
						"members": {
							"Rules": {
								"shape": "S4c",
								"locationName": "Rule"
							}
						}
					}
				},
				"payload": "LifecycleConfiguration"
			},
			"deprecated": true
		},
		"PutBucketLifecycleConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?lifecycle"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"LifecycleConfiguration": {
						"locationName": "LifecycleConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"Rules"
						],
						"members": {
							"Rules": {
								"shape": "S4r",
								"locationName": "Rule"
							}
						}
					}
				},
				"payload": "LifecycleConfiguration"
			}
		},
		"PutBucketLogging": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?logging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"BucketLoggingStatus"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"BucketLoggingStatus": {
						"locationName": "BucketLoggingStatus",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"LoggingEnabled": {
								"shape": "S51"
							}
						}
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					}
				},
				"payload": "BucketLoggingStatus"
			}
		},
		"PutBucketMetricsConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?metrics"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Id",
					"MetricsConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Id": {
						"location": "querystring",
						"locationName": "id"
					},
					"MetricsConfiguration": {
						"shape": "S59",
						"locationName": "MetricsConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "MetricsConfiguration"
			}
		},
		"PutBucketNotification": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?notification"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"NotificationConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"NotificationConfiguration": {
						"shape": "S5d",
						"locationName": "NotificationConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "NotificationConfiguration"
			},
			"deprecated": true
		},
		"PutBucketNotificationConfiguration": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?notification"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"NotificationConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"NotificationConfiguration": {
						"shape": "S5o",
						"locationName": "NotificationConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "NotificationConfiguration"
			}
		},
		"PutBucketPolicy": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?policy"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Policy"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"Policy": {}
				},
				"payload": "Policy"
			}
		},
		"PutBucketReplication": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?replication"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"ReplicationConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"ReplicationConfiguration": {
						"shape": "S67",
						"locationName": "ReplicationConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "ReplicationConfiguration"
			}
		},
		"PutBucketRequestPayment": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?requestPayment"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"RequestPaymentConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"RequestPaymentConfiguration": {
						"locationName": "RequestPaymentConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"Payer"
						],
						"members": {
							"Payer": {}
						}
					}
				},
				"payload": "RequestPaymentConfiguration"
			}
		},
		"PutBucketTagging": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Tagging"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"Tagging": {
						"shape": "Sab",
						"locationName": "Tagging",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "Tagging"
			}
		},
		"PutBucketVersioning": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?versioning"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"VersioningConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"MFA": {
						"location": "header",
						"locationName": "x-amz-mfa"
					},
					"VersioningConfiguration": {
						"locationName": "VersioningConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"MFADelete": {
								"locationName": "MfaDelete"
							},
							"Status": {}
						}
					}
				},
				"payload": "VersioningConfiguration"
			}
		},
		"PutBucketWebsite": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}?website"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"WebsiteConfiguration"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"WebsiteConfiguration": {
						"locationName": "WebsiteConfiguration",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"members": {
							"ErrorDocument": {
								"shape": "S6t"
							},
							"IndexDocument": {
								"shape": "S6r"
							},
							"RedirectAllRequestsTo": {
								"shape": "S6o"
							},
							"RoutingRules": {
								"shape": "S6u"
							}
						}
					}
				},
				"payload": "WebsiteConfiguration"
			}
		},
		"PutObject": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"Body": {
						"streaming": true,
						"type": "blob"
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CacheControl": {
						"location": "header",
						"locationName": "Cache-Control"
					},
					"ContentDisposition": {
						"location": "header",
						"locationName": "Content-Disposition"
					},
					"ContentEncoding": {
						"location": "header",
						"locationName": "Content-Encoding"
					},
					"ContentLanguage": {
						"location": "header",
						"locationName": "Content-Language"
					},
					"ContentLength": {
						"location": "header",
						"locationName": "Content-Length",
						"type": "long"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"ContentType": {
						"location": "header",
						"locationName": "Content-Type"
					},
					"Expires": {
						"location": "header",
						"locationName": "Expires",
						"type": "timestamp"
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"Metadata": {
						"shape": "S11",
						"location": "headers",
						"locationName": "x-amz-meta-"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"StorageClass": {
						"location": "header",
						"locationName": "x-amz-storage-class"
					},
					"WebsiteRedirectLocation": {
						"location": "header",
						"locationName": "x-amz-website-redirect-location"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"Tagging": {
						"location": "header",
						"locationName": "x-amz-tagging"
					}
				},
				"payload": "Body"
			},
			"output": {
				"type": "structure",
				"members": {
					"Expiration": {
						"location": "header",
						"locationName": "x-amz-expiration"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"PutObjectAcl": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}?acl"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"ACL": {
						"location": "header",
						"locationName": "x-amz-acl"
					},
					"AccessControlPolicy": {
						"shape": "S9r",
						"locationName": "AccessControlPolicy",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"GrantFullControl": {
						"location": "header",
						"locationName": "x-amz-grant-full-control"
					},
					"GrantRead": {
						"location": "header",
						"locationName": "x-amz-grant-read"
					},
					"GrantReadACP": {
						"location": "header",
						"locationName": "x-amz-grant-read-acp"
					},
					"GrantWrite": {
						"location": "header",
						"locationName": "x-amz-grant-write"
					},
					"GrantWriteACP": {
						"location": "header",
						"locationName": "x-amz-grant-write-acp"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					}
				},
				"payload": "AccessControlPolicy"
			},
			"output": {
				"type": "structure",
				"members": {
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"PutObjectTagging": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}?tagging"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"Tagging"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"Tagging": {
						"shape": "Sab",
						"locationName": "Tagging",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						}
					}
				},
				"payload": "Tagging"
			},
			"output": {
				"type": "structure",
				"members": {
					"VersionId": {
						"location": "header",
						"locationName": "x-amz-version-id"
					}
				}
			}
		},
		"RestoreObject": {
			"http": {
				"requestUri": "/{Bucket}/{Key+}?restore"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"RestoreRequest": {
						"locationName": "RestoreRequest",
						"xmlNamespace": {
							"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
						},
						"type": "structure",
						"required": [
							"Days"
						],
						"members": {
							"Days": {
								"type": "integer"
							},
							"GlacierJobParameters": {
								"type": "structure",
								"required": [
									"Tier"
								],
								"members": {
									"Tier": {}
								}
							}
						}
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				},
				"payload": "RestoreRequest"
			},
			"output": {
				"type": "structure",
				"members": {
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			},
			"alias": "PostObjectRestore"
		},
		"UploadPart": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"Key",
					"PartNumber",
					"UploadId"
				],
				"members": {
					"Body": {
						"streaming": true,
						"type": "blob"
					},
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"ContentLength": {
						"location": "header",
						"locationName": "Content-Length",
						"type": "long"
					},
					"ContentMD5": {
						"location": "header",
						"locationName": "Content-MD5"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"PartNumber": {
						"location": "querystring",
						"locationName": "partNumber",
						"type": "integer"
					},
					"UploadId": {
						"location": "querystring",
						"locationName": "uploadId"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				},
				"payload": "Body"
			},
			"output": {
				"type": "structure",
				"members": {
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"ETag": {
						"location": "header",
						"locationName": "ETag"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				}
			}
		},
		"UploadPartCopy": {
			"http": {
				"method": "PUT",
				"requestUri": "/{Bucket}/{Key+}"
			},
			"input": {
				"type": "structure",
				"required": [
					"Bucket",
					"CopySource",
					"Key",
					"PartNumber",
					"UploadId"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					},
					"CopySource": {
						"location": "header",
						"locationName": "x-amz-copy-source"
					},
					"CopySourceIfMatch": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-match"
					},
					"CopySourceIfModifiedSince": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-modified-since",
						"type": "timestamp"
					},
					"CopySourceIfNoneMatch": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-none-match"
					},
					"CopySourceIfUnmodifiedSince": {
						"location": "header",
						"locationName": "x-amz-copy-source-if-unmodified-since",
						"type": "timestamp"
					},
					"CopySourceRange": {
						"location": "header",
						"locationName": "x-amz-copy-source-range"
					},
					"Key": {
						"location": "uri",
						"locationName": "Key"
					},
					"PartNumber": {
						"location": "querystring",
						"locationName": "partNumber",
						"type": "integer"
					},
					"UploadId": {
						"location": "querystring",
						"locationName": "uploadId"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKey": {
						"shape": "S19",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"CopySourceSSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
					},
					"CopySourceSSECustomerKey": {
						"shape": "S1c",
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-key"
					},
					"CopySourceSSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
					},
					"RequestPayer": {
						"location": "header",
						"locationName": "x-amz-request-payer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CopySourceVersionId": {
						"location": "header",
						"locationName": "x-amz-copy-source-version-id"
					},
					"CopyPartResult": {
						"type": "structure",
						"members": {
							"ETag": {},
							"LastModified": {
								"type": "timestamp"
							}
						}
					},
					"ServerSideEncryption": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption"
					},
					"SSECustomerAlgorithm": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-algorithm"
					},
					"SSECustomerKeyMD5": {
						"location": "header",
						"locationName": "x-amz-server-side-encryption-customer-key-MD5"
					},
					"SSEKMSKeyId": {
						"shape": "Sj",
						"location": "header",
						"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
					},
					"RequestCharged": {
						"location": "header",
						"locationName": "x-amz-request-charged"
					}
				},
				"payload": "CopyPartResult"
			}
		}
	},
	"shapes": {
		"Sj": {
			"type": "string",
			"sensitive": true
		},
		"S11": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S19": {
			"type": "blob",
			"sensitive": true
		},
		"S1c": {
			"type": "blob",
			"sensitive": true
		},
		"S2u": {
			"type": "structure",
			"members": {
				"DisplayName": {},
				"ID": {}
			}
		},
		"S2x": {
			"type": "list",
			"member": {
				"locationName": "Grant",
				"type": "structure",
				"members": {
					"Grantee": {
						"shape": "S2z"
					},
					"Permission": {}
				}
			}
		},
		"S2z": {
			"type": "structure",
			"required": [
				"Type"
			],
			"members": {
				"DisplayName": {},
				"EmailAddress": {},
				"ID": {},
				"Type": {
					"locationName": "xsi:type",
					"xmlAttribute": true
				},
				"URI": {}
			},
			"xmlNamespace": {
				"prefix": "xsi",
				"uri": "http://www.w3.org/2001/XMLSchema-instance"
			}
		},
		"S36": {
			"type": "structure",
			"required": [
				"Id",
				"StorageClassAnalysis"
			],
			"members": {
				"Id": {},
				"Filter": {
					"type": "structure",
					"members": {
						"Prefix": {},
						"Tag": {
							"shape": "S39"
						},
						"And": {
							"type": "structure",
							"members": {
								"Prefix": {},
								"Tags": {
									"shape": "S3c",
									"flattened": true,
									"locationName": "Tag"
								}
							}
						}
					}
				},
				"StorageClassAnalysis": {
					"type": "structure",
					"members": {
						"DataExport": {
							"type": "structure",
							"required": [
								"OutputSchemaVersion",
								"Destination"
							],
							"members": {
								"OutputSchemaVersion": {},
								"Destination": {
									"type": "structure",
									"required": [
										"S3BucketDestination"
									],
									"members": {
										"S3BucketDestination": {
											"type": "structure",
											"required": [
												"Format",
												"Bucket"
											],
											"members": {
												"Format": {},
												"BucketAccountId": {},
												"Bucket": {},
												"Prefix": {}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"S39": {
			"type": "structure",
			"required": [
				"Key",
				"Value"
			],
			"members": {
				"Key": {},
				"Value": {}
			}
		},
		"S3c": {
			"type": "list",
			"member": {
				"shape": "S39",
				"locationName": "Tag"
			}
		},
		"S3m": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"AllowedMethods",
					"AllowedOrigins"
				],
				"members": {
					"AllowedHeaders": {
						"locationName": "AllowedHeader",
						"type": "list",
						"member": {},
						"flattened": true
					},
					"AllowedMethods": {
						"locationName": "AllowedMethod",
						"type": "list",
						"member": {},
						"flattened": true
					},
					"AllowedOrigins": {
						"locationName": "AllowedOrigin",
						"type": "list",
						"member": {},
						"flattened": true
					},
					"ExposeHeaders": {
						"locationName": "ExposeHeader",
						"type": "list",
						"member": {},
						"flattened": true
					},
					"MaxAgeSeconds": {
						"type": "integer"
					}
				}
			},
			"flattened": true
		},
		"S3z": {
			"type": "structure",
			"required": [
				"Destination",
				"IsEnabled",
				"Id",
				"IncludedObjectVersions",
				"Schedule"
			],
			"members": {
				"Destination": {
					"type": "structure",
					"required": [
						"S3BucketDestination"
					],
					"members": {
						"S3BucketDestination": {
							"type": "structure",
							"required": [
								"Bucket",
								"Format"
							],
							"members": {
								"AccountId": {},
								"Bucket": {},
								"Format": {},
								"Prefix": {}
							}
						}
					}
				},
				"IsEnabled": {
					"type": "boolean"
				},
				"Filter": {
					"type": "structure",
					"required": [
						"Prefix"
					],
					"members": {
						"Prefix": {}
					}
				},
				"Id": {},
				"IncludedObjectVersions": {},
				"OptionalFields": {
					"type": "list",
					"member": {
						"locationName": "Field"
					}
				},
				"Schedule": {
					"type": "structure",
					"required": [
						"Frequency"
					],
					"members": {
						"Frequency": {}
					}
				}
			}
		},
		"S4c": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Prefix",
					"Status"
				],
				"members": {
					"Expiration": {
						"shape": "S4e"
					},
					"ID": {},
					"Prefix": {},
					"Status": {},
					"Transition": {
						"shape": "S4j"
					},
					"NoncurrentVersionTransition": {
						"shape": "S4l"
					},
					"NoncurrentVersionExpiration": {
						"shape": "S4m"
					},
					"AbortIncompleteMultipartUpload": {
						"shape": "S4n"
					}
				}
			},
			"flattened": true
		},
		"S4e": {
			"type": "structure",
			"members": {
				"Date": {
					"shape": "S4f"
				},
				"Days": {
					"type": "integer"
				},
				"ExpiredObjectDeleteMarker": {
					"type": "boolean"
				}
			}
		},
		"S4f": {
			"type": "timestamp",
			"timestampFormat": "iso8601"
		},
		"S4j": {
			"type": "structure",
			"members": {
				"Date": {
					"shape": "S4f"
				},
				"Days": {
					"type": "integer"
				},
				"StorageClass": {}
			}
		},
		"S4l": {
			"type": "structure",
			"members": {
				"NoncurrentDays": {
					"type": "integer"
				},
				"StorageClass": {}
			}
		},
		"S4m": {
			"type": "structure",
			"members": {
				"NoncurrentDays": {
					"type": "integer"
				}
			}
		},
		"S4n": {
			"type": "structure",
			"members": {
				"DaysAfterInitiation": {
					"type": "integer"
				}
			}
		},
		"S4r": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Status"
				],
				"members": {
					"Expiration": {
						"shape": "S4e"
					},
					"ID": {},
					"Prefix": {
						"deprecated": true
					},
					"Filter": {
						"type": "structure",
						"members": {
							"Prefix": {},
							"Tag": {
								"shape": "S39"
							},
							"And": {
								"type": "structure",
								"members": {
									"Prefix": {},
									"Tags": {
										"shape": "S3c",
										"flattened": true,
										"locationName": "Tag"
									}
								}
							}
						}
					},
					"Status": {},
					"Transitions": {
						"locationName": "Transition",
						"type": "list",
						"member": {
							"shape": "S4j"
						},
						"flattened": true
					},
					"NoncurrentVersionTransitions": {
						"locationName": "NoncurrentVersionTransition",
						"type": "list",
						"member": {
							"shape": "S4l"
						},
						"flattened": true
					},
					"NoncurrentVersionExpiration": {
						"shape": "S4m"
					},
					"AbortIncompleteMultipartUpload": {
						"shape": "S4n"
					}
				}
			},
			"flattened": true
		},
		"S51": {
			"type": "structure",
			"members": {
				"TargetBucket": {},
				"TargetGrants": {
					"type": "list",
					"member": {
						"locationName": "Grant",
						"type": "structure",
						"members": {
							"Grantee": {
								"shape": "S2z"
							},
							"Permission": {}
						}
					}
				},
				"TargetPrefix": {}
			}
		},
		"S59": {
			"type": "structure",
			"required": [
				"Id"
			],
			"members": {
				"Id": {},
				"Filter": {
					"type": "structure",
					"members": {
						"Prefix": {},
						"Tag": {
							"shape": "S39"
						},
						"And": {
							"type": "structure",
							"members": {
								"Prefix": {},
								"Tags": {
									"shape": "S3c",
									"flattened": true,
									"locationName": "Tag"
								}
							}
						}
					}
				}
			}
		},
		"S5c": {
			"type": "structure",
			"required": [
				"Bucket"
			],
			"members": {
				"Bucket": {
					"location": "uri",
					"locationName": "Bucket"
				}
			}
		},
		"S5d": {
			"type": "structure",
			"members": {
				"TopicConfiguration": {
					"type": "structure",
					"members": {
						"Id": {},
						"Events": {
							"shape": "S5g",
							"locationName": "Event"
						},
						"Event": {
							"deprecated": true
						},
						"Topic": {}
					}
				},
				"QueueConfiguration": {
					"type": "structure",
					"members": {
						"Id": {},
						"Event": {
							"deprecated": true
						},
						"Events": {
							"shape": "S5g",
							"locationName": "Event"
						},
						"Queue": {}
					}
				},
				"CloudFunctionConfiguration": {
					"type": "structure",
					"members": {
						"Id": {},
						"Event": {
							"deprecated": true
						},
						"Events": {
							"shape": "S5g",
							"locationName": "Event"
						},
						"CloudFunction": {},
						"InvocationRole": {}
					}
				}
			}
		},
		"S5g": {
			"type": "list",
			"member": {},
			"flattened": true
		},
		"S5o": {
			"type": "structure",
			"members": {
				"TopicConfigurations": {
					"locationName": "TopicConfiguration",
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"TopicArn",
							"Events"
						],
						"members": {
							"Id": {},
							"TopicArn": {
								"locationName": "Topic"
							},
							"Events": {
								"shape": "S5g",
								"locationName": "Event"
							},
							"Filter": {
								"shape": "S5r"
							}
						}
					},
					"flattened": true
				},
				"QueueConfigurations": {
					"locationName": "QueueConfiguration",
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"QueueArn",
							"Events"
						],
						"members": {
							"Id": {},
							"QueueArn": {
								"locationName": "Queue"
							},
							"Events": {
								"shape": "S5g",
								"locationName": "Event"
							},
							"Filter": {
								"shape": "S5r"
							}
						}
					},
					"flattened": true
				},
				"LambdaFunctionConfigurations": {
					"locationName": "CloudFunctionConfiguration",
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"LambdaFunctionArn",
							"Events"
						],
						"members": {
							"Id": {},
							"LambdaFunctionArn": {
								"locationName": "CloudFunction"
							},
							"Events": {
								"shape": "S5g",
								"locationName": "Event"
							},
							"Filter": {
								"shape": "S5r"
							}
						}
					},
					"flattened": true
				}
			}
		},
		"S5r": {
			"type": "structure",
			"members": {
				"Key": {
					"locationName": "S3Key",
					"type": "structure",
					"members": {
						"FilterRules": {
							"locationName": "FilterRule",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Value": {}
								}
							},
							"flattened": true
						}
					}
				}
			}
		},
		"S67": {
			"type": "structure",
			"required": [
				"Role",
				"Rules"
			],
			"members": {
				"Role": {},
				"Rules": {
					"locationName": "Rule",
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"Prefix",
							"Status",
							"Destination"
						],
						"members": {
							"ID": {},
							"Prefix": {},
							"Status": {},
							"Destination": {
								"type": "structure",
								"required": [
									"Bucket"
								],
								"members": {
									"Bucket": {},
									"StorageClass": {}
								}
							}
						}
					},
					"flattened": true
				}
			}
		},
		"S6o": {
			"type": "structure",
			"required": [
				"HostName"
			],
			"members": {
				"HostName": {},
				"Protocol": {}
			}
		},
		"S6r": {
			"type": "structure",
			"required": [
				"Suffix"
			],
			"members": {
				"Suffix": {}
			}
		},
		"S6t": {
			"type": "structure",
			"required": [
				"Key"
			],
			"members": {
				"Key": {}
			}
		},
		"S6u": {
			"type": "list",
			"member": {
				"locationName": "RoutingRule",
				"type": "structure",
				"required": [
					"Redirect"
				],
				"members": {
					"Condition": {
						"type": "structure",
						"members": {
							"HttpErrorCodeReturnedEquals": {},
							"KeyPrefixEquals": {}
						}
					},
					"Redirect": {
						"type": "structure",
						"members": {
							"HostName": {},
							"HttpRedirectCode": {},
							"Protocol": {},
							"ReplaceKeyPrefixWith": {},
							"ReplaceKeyWith": {}
						}
					}
				}
			}
		},
		"S8q": {
			"type": "structure",
			"members": {
				"ID": {},
				"DisplayName": {}
			}
		},
		"S8r": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Prefix": {}
				}
			},
			"flattened": true
		},
		"S99": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"LastModified": {
						"type": "timestamp"
					},
					"ETag": {},
					"Size": {
						"type": "integer"
					},
					"StorageClass": {},
					"Owner": {
						"shape": "S2u"
					}
				}
			},
			"flattened": true
		},
		"S9r": {
			"type": "structure",
			"members": {
				"Grants": {
					"shape": "S2x",
					"locationName": "AccessControlList"
				},
				"Owner": {
					"shape": "S2u"
				}
			}
		},
		"Sab": {
			"type": "structure",
			"required": [
				"TagSet"
			],
			"members": {
				"TagSet": {
					"shape": "S3c"
				}
			}
		}
	}
};

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListBuckets": {
			"result_key": "Buckets"
		},
		"ListMultipartUploads": {
			"input_token": [
				"KeyMarker",
				"UploadIdMarker"
			],
			"limit_key": "MaxUploads",
			"more_results": "IsTruncated",
			"output_token": [
				"NextKeyMarker",
				"NextUploadIdMarker"
			],
			"result_key": [
				"Uploads",
				"CommonPrefixes"
			]
		},
		"ListObjectVersions": {
			"input_token": [
				"KeyMarker",
				"VersionIdMarker"
			],
			"limit_key": "MaxKeys",
			"more_results": "IsTruncated",
			"output_token": [
				"NextKeyMarker",
				"NextVersionIdMarker"
			],
			"result_key": [
				"Versions",
				"DeleteMarkers",
				"CommonPrefixes"
			]
		},
		"ListObjects": {
			"input_token": "Marker",
			"limit_key": "MaxKeys",
			"more_results": "IsTruncated",
			"output_token": "NextMarker || Contents[-1].Key",
			"result_key": [
				"Contents",
				"CommonPrefixes"
			]
		},
		"ListObjectsV2": {
			"input_token": "ContinuationToken",
			"limit_key": "MaxKeys",
			"output_token": "NextContinuationToken",
			"result_key": [
				"Contents",
				"CommonPrefixes"
			]
		},
		"ListParts": {
			"input_token": "PartNumberMarker",
			"limit_key": "MaxParts",
			"more_results": "IsTruncated",
			"output_token": "NextPartNumberMarker",
			"result_key": "Parts"
		}
	}
};

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"BucketExists": {
			"delay": 5,
			"operation": "HeadBucket",
			"maxAttempts": 20,
			"acceptors": [
				{
					"expected": 200,
					"matcher": "status",
					"state": "success"
				},
				{
					"expected": 301,
					"matcher": "status",
					"state": "success"
				},
				{
					"expected": 403,
					"matcher": "status",
					"state": "success"
				},
				{
					"expected": 404,
					"matcher": "status",
					"state": "retry"
				}
			]
		},
		"BucketNotExists": {
			"delay": 5,
			"operation": "HeadBucket",
			"maxAttempts": 20,
			"acceptors": [
				{
					"expected": 404,
					"matcher": "status",
					"state": "success"
				}
			]
		},
		"ObjectExists": {
			"delay": 5,
			"operation": "HeadObject",
			"maxAttempts": 20,
			"acceptors": [
				{
					"expected": 200,
					"matcher": "status",
					"state": "success"
				},
				{
					"expected": 404,
					"matcher": "status",
					"state": "retry"
				}
			]
		},
		"ObjectNotExists": {
			"delay": 5,
			"operation": "HeadObject",
			"maxAttempts": 20,
			"acceptors": [
				{
					"expected": 404,
					"matcher": "status",
					"state": "success"
				}
			]
		}
	}
};

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['servicecatalog'] = {};
AWS.ServiceCatalog = Service.defineService('servicecatalog', ['2015-12-10']);
Object.defineProperty(apiLoader.services['servicecatalog'], '2015-12-10', {
  get: function get() {
    var model = __webpack_require__(1715);
    model.paginators = __webpack_require__(1716).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.ServiceCatalog;


/***/ }),
/* 1715 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-12-10",
		"endpointPrefix": "servicecatalog",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Service Catalog",
		"signatureVersion": "v4",
		"targetPrefix": "AWS242ServiceCatalogService",
		"uid": "servicecatalog-2015-12-10"
	},
	"operations": {
		"AcceptPortfolioShare": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AssociatePrincipalWithPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId",
					"PrincipalARN",
					"PrincipalType"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"PrincipalARN": {},
					"PrincipalType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AssociateProductWithPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"PortfolioId": {},
					"SourcePortfolioId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AssociateTagOptionWithResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"TagOptionId"
				],
				"members": {
					"ResourceId": {},
					"TagOptionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateConstraint": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId",
					"ProductId",
					"Parameters",
					"Type",
					"IdempotencyToken"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"ProductId": {},
					"Parameters": {},
					"Type": {},
					"Description": {},
					"IdempotencyToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConstraintDetail": {
						"shape": "Sl"
					},
					"ConstraintParameters": {},
					"Status": {}
				}
			}
		},
		"CreatePortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"DisplayName",
					"ProviderName",
					"IdempotencyToken"
				],
				"members": {
					"AcceptLanguage": {},
					"DisplayName": {},
					"Description": {},
					"ProviderName": {},
					"Tags": {
						"shape": "Ss"
					},
					"IdempotencyToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetail": {
						"shape": "Sx"
					},
					"Tags": {
						"shape": "S10"
					}
				}
			}
		},
		"CreatePortfolioShare": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId",
					"AccountId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"AccountId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateProduct": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Owner",
					"ProductType",
					"ProvisioningArtifactParameters",
					"IdempotencyToken"
				],
				"members": {
					"AcceptLanguage": {},
					"Name": {},
					"Owner": {},
					"Description": {},
					"Distributor": {},
					"SupportDescription": {},
					"SupportEmail": {},
					"SupportUrl": {},
					"ProductType": {},
					"Tags": {
						"shape": "Ss"
					},
					"ProvisioningArtifactParameters": {
						"shape": "S1b"
					},
					"IdempotencyToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewDetail": {
						"shape": "S1j"
					},
					"ProvisioningArtifactDetail": {
						"shape": "S1o"
					},
					"Tags": {
						"shape": "S10"
					}
				}
			}
		},
		"CreateProvisioningArtifact": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"Parameters",
					"IdempotencyToken"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"Parameters": {
						"shape": "S1b"
					},
					"IdempotencyToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisioningArtifactDetail": {
						"shape": "S1o"
					},
					"Info": {
						"shape": "S1e"
					},
					"Status": {}
				}
			}
		},
		"CreateTagOption": {
			"input": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TagOptionDetail": {
						"shape": "S1v"
					}
				}
			}
		},
		"DeleteConstraint": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeletePortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeletePortfolioShare": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId",
					"AccountId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"AccountId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteProduct": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteProvisioningArtifact": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"ProvisioningArtifactId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"ProvisioningArtifactId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeConstraint": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConstraintDetail": {
						"shape": "Sl"
					},
					"ConstraintParameters": {},
					"Status": {}
				}
			}
		},
		"DescribePortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetail": {
						"shape": "Sx"
					},
					"Tags": {
						"shape": "S10"
					},
					"TagOptions": {
						"shape": "S2b"
					}
				}
			}
		},
		"DescribeProduct": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewSummary": {
						"shape": "S1k"
					},
					"ProvisioningArtifacts": {
						"shape": "S2e"
					}
				}
			}
		},
		"DescribeProductAsAdmin": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewDetail": {
						"shape": "S1j"
					},
					"ProvisioningArtifactSummaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"Description": {},
								"CreatedTime": {
									"type": "timestamp"
								},
								"ProvisioningArtifactMetadata": {
									"shape": "S1e"
								}
							}
						}
					},
					"Tags": {
						"shape": "S10"
					},
					"TagOptions": {
						"shape": "S2b"
					}
				}
			}
		},
		"DescribeProductView": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewSummary": {
						"shape": "S1k"
					},
					"ProvisioningArtifacts": {
						"shape": "S2e"
					}
				}
			}
		},
		"DescribeProvisionedProduct": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisionedProductDetail": {
						"shape": "S2p"
					}
				}
			}
		},
		"DescribeProvisioningArtifact": {
			"input": {
				"type": "structure",
				"required": [
					"ProvisioningArtifactId",
					"ProductId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProvisioningArtifactId": {},
					"ProductId": {},
					"Verbose": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisioningArtifactDetail": {
						"shape": "S1o"
					},
					"Info": {
						"shape": "S1e"
					},
					"Status": {}
				}
			}
		},
		"DescribeProvisioningParameters": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"ProvisioningArtifactId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"ProvisioningArtifactId": {},
					"PathId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisioningArtifactParameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ParameterKey": {},
								"DefaultValue": {},
								"ParameterType": {},
								"IsNoEcho": {
									"type": "boolean"
								},
								"Description": {},
								"ParameterConstraints": {
									"type": "structure",
									"members": {
										"AllowedValues": {
											"type": "list",
											"member": {}
										}
									}
								}
							}
						}
					},
					"ConstraintSummaries": {
						"shape": "S3b"
					},
					"UsageInstructions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Type": {},
								"Value": {}
							}
						}
					},
					"TagOptions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Values": {
									"type": "list",
									"member": {}
								}
							}
						}
					}
				}
			}
		},
		"DescribeRecord": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {},
					"PageToken": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RecordDetail": {
						"shape": "S3o"
					},
					"RecordOutputs": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"OutputKey": {},
								"OutputValue": {},
								"Description": {}
							}
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"DescribeTagOption": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TagOptionDetail": {
						"shape": "S1v"
					}
				}
			}
		},
		"DisassociatePrincipalFromPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId",
					"PrincipalARN"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"PrincipalARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DisassociateProductFromPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"PortfolioId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DisassociateTagOptionFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"TagOptionId"
				],
				"members": {
					"ResourceId": {},
					"TagOptionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ListAcceptedPortfolioShares": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"PageToken": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetails": {
						"shape": "S4f"
					},
					"NextPageToken": {}
				}
			}
		},
		"ListConstraintsForPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"ProductId": {},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConstraintDetails": {
						"type": "list",
						"member": {
							"shape": "Sl"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListLaunchPaths": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"LaunchPathSummaries": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"ConstraintSummaries": {
									"shape": "S3b"
								},
								"Tags": {
									"shape": "S10"
								},
								"Name": {}
							}
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListPortfolioAccess": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AccountIds": {
						"type": "list",
						"member": {}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListPortfolios": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"PageToken": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetails": {
						"shape": "S4f"
					},
					"NextPageToken": {}
				}
			}
		},
		"ListPortfoliosForProduct": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"PageToken": {},
					"PageSize": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetails": {
						"shape": "S4f"
					},
					"NextPageToken": {}
				}
			}
		},
		"ListPrincipalsForPortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Principals": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PrincipalARN": {},
								"PrincipalType": {}
							}
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListProvisioningArtifacts": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisioningArtifactDetails": {
						"type": "list",
						"member": {
							"shape": "S1o"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListRecordHistory": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"AccessLevelFilter": {
						"shape": "S53"
					},
					"SearchFilter": {
						"type": "structure",
						"members": {
							"Key": {},
							"Value": {}
						}
					},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RecordDetails": {
						"type": "list",
						"member": {
							"shape": "S3o"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"ListResourcesForTagOption": {
			"input": {
				"type": "structure",
				"required": [
					"TagOptionId"
				],
				"members": {
					"TagOptionId": {},
					"ResourceType": {},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceDetails": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"ARN": {},
								"Name": {},
								"Description": {},
								"CreatedTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"PageToken": {}
				}
			}
		},
		"ListTagOptions": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"type": "structure",
						"members": {
							"Key": {},
							"Value": {},
							"Active": {
								"type": "boolean"
							}
						}
					},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TagOptionDetails": {
						"shape": "S2b"
					},
					"PageToken": {}
				}
			}
		},
		"ProvisionProduct": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"ProvisioningArtifactId",
					"ProvisionedProductName",
					"ProvisionToken"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"ProvisioningArtifactId": {},
					"PathId": {},
					"ProvisionedProductName": {},
					"ProvisioningParameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					},
					"Tags": {
						"shape": "S10"
					},
					"NotificationArns": {
						"type": "list",
						"member": {}
					},
					"ProvisionToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RecordDetail": {
						"shape": "S3o"
					}
				}
			}
		},
		"RejectPortfolioShare": {
			"input": {
				"type": "structure",
				"required": [
					"PortfolioId"
				],
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ScanProvisionedProducts": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"AccessLevelFilter": {
						"shape": "S53"
					},
					"PageSize": {
						"type": "integer"
					},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisionedProducts": {
						"type": "list",
						"member": {
							"shape": "S2p"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"SearchProducts": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"Filters": {
						"shape": "S61"
					},
					"PageSize": {
						"type": "integer"
					},
					"SortBy": {},
					"SortOrder": {},
					"PageToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewSummaries": {
						"type": "list",
						"member": {
							"shape": "S1k"
						}
					},
					"ProductViewAggregations": {
						"type": "map",
						"key": {},
						"value": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Value": {},
									"ApproximateCount": {
										"type": "integer"
									}
								}
							}
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"SearchProductsAsAdmin": {
			"input": {
				"type": "structure",
				"members": {
					"AcceptLanguage": {},
					"PortfolioId": {},
					"Filters": {
						"shape": "S61"
					},
					"SortBy": {},
					"SortOrder": {},
					"PageToken": {},
					"PageSize": {
						"type": "integer"
					},
					"ProductSource": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewDetails": {
						"type": "list",
						"member": {
							"shape": "S1j"
						}
					},
					"NextPageToken": {}
				}
			}
		},
		"TerminateProvisionedProduct": {
			"input": {
				"type": "structure",
				"required": [
					"TerminateToken"
				],
				"members": {
					"ProvisionedProductName": {},
					"ProvisionedProductId": {},
					"TerminateToken": {
						"idempotencyToken": true
					},
					"IgnoreErrors": {
						"type": "boolean"
					},
					"AcceptLanguage": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RecordDetail": {
						"shape": "S3o"
					}
				}
			}
		},
		"UpdateConstraint": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {},
					"Description": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ConstraintDetail": {
						"shape": "Sl"
					},
					"ConstraintParameters": {},
					"Status": {}
				}
			}
		},
		"UpdatePortfolio": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {},
					"DisplayName": {},
					"Description": {},
					"ProviderName": {},
					"AddTags": {
						"shape": "Ss"
					},
					"RemoveTags": {
						"shape": "S6p"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"PortfolioDetail": {
						"shape": "Sx"
					},
					"Tags": {
						"shape": "S10"
					}
				}
			}
		},
		"UpdateProduct": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"AcceptLanguage": {},
					"Id": {},
					"Name": {},
					"Owner": {},
					"Description": {},
					"Distributor": {},
					"SupportDescription": {},
					"SupportEmail": {},
					"SupportUrl": {},
					"AddTags": {
						"shape": "Ss"
					},
					"RemoveTags": {
						"shape": "S6p"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProductViewDetail": {
						"shape": "S1j"
					},
					"Tags": {
						"shape": "S10"
					}
				}
			}
		},
		"UpdateProvisionedProduct": {
			"input": {
				"type": "structure",
				"required": [
					"UpdateToken"
				],
				"members": {
					"AcceptLanguage": {},
					"ProvisionedProductName": {},
					"ProvisionedProductId": {},
					"ProductId": {},
					"ProvisioningArtifactId": {},
					"PathId": {},
					"ProvisioningParameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {},
								"UsePreviousValue": {
									"type": "boolean"
								}
							}
						}
					},
					"UpdateToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"RecordDetail": {
						"shape": "S3o"
					}
				}
			}
		},
		"UpdateProvisioningArtifact": {
			"input": {
				"type": "structure",
				"required": [
					"ProductId",
					"ProvisioningArtifactId"
				],
				"members": {
					"AcceptLanguage": {},
					"ProductId": {},
					"ProvisioningArtifactId": {},
					"Name": {},
					"Description": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ProvisioningArtifactDetail": {
						"shape": "S1o"
					},
					"Info": {
						"shape": "S1e"
					},
					"Status": {}
				}
			}
		},
		"UpdateTagOption": {
			"input": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {},
					"Value": {},
					"Active": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TagOptionDetail": {
						"shape": "S1v"
					}
				}
			}
		}
	},
	"shapes": {
		"Sl": {
			"type": "structure",
			"members": {
				"ConstraintId": {},
				"Type": {},
				"Description": {},
				"Owner": {}
			}
		},
		"Ss": {
			"type": "list",
			"member": {
				"shape": "St"
			}
		},
		"St": {
			"type": "structure",
			"required": [
				"Key",
				"Value"
			],
			"members": {
				"Key": {},
				"Value": {}
			}
		},
		"Sx": {
			"type": "structure",
			"members": {
				"Id": {},
				"ARN": {},
				"DisplayName": {},
				"Description": {},
				"CreatedTime": {
					"type": "timestamp"
				},
				"ProviderName": {}
			}
		},
		"S10": {
			"type": "list",
			"member": {
				"shape": "St"
			}
		},
		"S1b": {
			"type": "structure",
			"required": [
				"Info"
			],
			"members": {
				"Name": {},
				"Description": {},
				"Info": {
					"shape": "S1e"
				},
				"Type": {}
			}
		},
		"S1e": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1j": {
			"type": "structure",
			"members": {
				"ProductViewSummary": {
					"shape": "S1k"
				},
				"Status": {},
				"ProductARN": {},
				"CreatedTime": {
					"type": "timestamp"
				}
			}
		},
		"S1k": {
			"type": "structure",
			"members": {
				"Id": {},
				"ProductId": {},
				"Name": {},
				"Owner": {},
				"ShortDescription": {},
				"Type": {},
				"Distributor": {},
				"HasDefaultPath": {
					"type": "boolean"
				},
				"SupportEmail": {},
				"SupportDescription": {},
				"SupportUrl": {}
			}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"Description": {},
				"Type": {},
				"CreatedTime": {
					"type": "timestamp"
				}
			}
		},
		"S1v": {
			"type": "structure",
			"members": {
				"Key": {},
				"Value": {},
				"Active": {
					"type": "boolean"
				},
				"Id": {}
			}
		},
		"S2b": {
			"type": "list",
			"member": {
				"shape": "S1v"
			}
		},
		"S2e": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"Description": {},
					"CreatedTime": {
						"type": "timestamp"
					}
				}
			}
		},
		"S2p": {
			"type": "structure",
			"members": {
				"Name": {},
				"Arn": {},
				"Type": {},
				"Id": {},
				"Status": {},
				"StatusMessage": {},
				"CreatedTime": {
					"type": "timestamp"
				},
				"IdempotencyToken": {},
				"LastRecordId": {}
			}
		},
		"S3b": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Type": {},
					"Description": {}
				}
			}
		},
		"S3o": {
			"type": "structure",
			"members": {
				"RecordId": {},
				"ProvisionedProductName": {},
				"Status": {},
				"CreatedTime": {
					"type": "timestamp"
				},
				"UpdatedTime": {
					"type": "timestamp"
				},
				"ProvisionedProductType": {},
				"RecordType": {},
				"ProvisionedProductId": {},
				"ProductId": {},
				"ProvisioningArtifactId": {},
				"PathId": {},
				"RecordErrors": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Code": {},
							"Description": {}
						}
					}
				},
				"RecordTags": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Key": {},
							"Value": {}
						}
					}
				}
			}
		},
		"S4f": {
			"type": "list",
			"member": {
				"shape": "Sx"
			}
		},
		"S53": {
			"type": "structure",
			"members": {
				"Key": {},
				"Value": {}
			}
		},
		"S61": {
			"type": "map",
			"key": {},
			"value": {
				"type": "list",
				"member": {}
			}
		},
		"S6p": {
			"type": "list",
			"member": {}
		}
	}
};

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListResourcesForTagOption": {
			"input_token": "PageToken",
			"output_token": "PageToken",
			"limit_key": "PageSize"
		},
		"ListTagOptions": {
			"input_token": "PageToken",
			"output_token": "PageToken",
			"limit_key": "PageSize"
		}
	}
};

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ses'] = {};
AWS.SES = Service.defineService('ses', ['2010-12-01']);
Object.defineProperty(apiLoader.services['ses'], '2010-12-01', {
  get: function get() {
    var model = __webpack_require__(1718);
    model.paginators = __webpack_require__(1719).pagination;
    model.waiters = __webpack_require__(1720).waiters;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SES;


/***/ }),
/* 1718 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2010-12-01",
		"endpointPrefix": "email",
		"protocol": "query",
		"serviceAbbreviation": "Amazon SES",
		"serviceFullName": "Amazon Simple Email Service",
		"signatureVersion": "v4",
		"signingName": "ses",
		"uid": "email-2010-12-01",
		"xmlNamespace": "http://ses.amazonaws.com/doc/2010-12-01/"
	},
	"operations": {
		"CloneReceiptRuleSet": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetName",
					"OriginalRuleSetName"
				],
				"members": {
					"RuleSetName": {},
					"OriginalRuleSetName": {}
				}
			},
			"output": {
				"resultWrapper": "CloneReceiptRuleSetResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateConfigurationSet": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationSet"
				],
				"members": {
					"ConfigurationSet": {
						"shape": "S5"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateConfigurationSetResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateConfigurationSetEventDestination": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationSetName",
					"EventDestination"
				],
				"members": {
					"ConfigurationSetName": {},
					"EventDestination": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateConfigurationSetEventDestinationResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateReceiptFilter": {
			"input": {
				"type": "structure",
				"required": [
					"Filter"
				],
				"members": {
					"Filter": {
						"shape": "Sp"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateReceiptFilterResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateReceiptRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetName",
					"Rule"
				],
				"members": {
					"RuleSetName": {},
					"After": {},
					"Rule": {
						"shape": "Sx"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateReceiptRuleResult",
				"type": "structure",
				"members": {}
			}
		},
		"CreateReceiptRuleSet": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetName"
				],
				"members": {
					"RuleSetName": {}
				}
			},
			"output": {
				"resultWrapper": "CreateReceiptRuleSetResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteConfigurationSet": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationSetName"
				],
				"members": {
					"ConfigurationSetName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteConfigurationSetResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteConfigurationSetEventDestination": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationSetName",
					"EventDestinationName"
				],
				"members": {
					"ConfigurationSetName": {},
					"EventDestinationName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteConfigurationSetEventDestinationResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"Identity"
				],
				"members": {
					"Identity": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteIdentityResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteIdentityPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"Identity",
					"PolicyName"
				],
				"members": {
					"Identity": {},
					"PolicyName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteIdentityPolicyResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteReceiptFilter": {
			"input": {
				"type": "structure",
				"required": [
					"FilterName"
				],
				"members": {
					"FilterName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteReceiptFilterResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteReceiptRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetName",
					"RuleName"
				],
				"members": {
					"RuleSetName": {},
					"RuleName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteReceiptRuleResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteReceiptRuleSet": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetName"
				],
				"members": {
					"RuleSetName": {}
				}
			},
			"output": {
				"resultWrapper": "DeleteReceiptRuleSetResult",
				"type": "structure",
				"members": {}
			}
		},
		"DeleteVerifiedEmailAddress": {
			"input": {
				"type": "structure",
				"required": [
					"EmailAddress"
				],
				"members": {
					"EmailAddress": {}
				}
			}
		},
		"DescribeActiveReceiptRuleSet": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"resultWrapper": "DescribeActiveReceiptRuleSetResult",
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S27"
					},
					"Rules": {
						"shape": "S29"
					}
				}
			}
		},
		"DescribeConfigurationSet": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationSetName"
				],
				"members": {
					"ConfigurationSetName": {},
					"ConfigurationSetAttributeNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "DescribeConfigurationSetResult",
				"type": "structure",
				"members": {
					"ConfigurationSet": {
						"shape": "S5"
					},
					"EventDestinations": {
						"type": "list",
						"member": {
							"shape": "S9"
						}
					}
				}
			}
		},
		"DescribeReceiptRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetName",
					"RuleName"
				],
				"members": {
					"RuleSetName": {},
					"RuleName": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReceiptRuleResult",
				"type": "structure",
				"members": {
					"Rule": {
						"shape": "Sx"
					}
				}
			}
		},
		"DescribeReceiptRuleSet": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetName"
				],
				"members": {
					"RuleSetName": {}
				}
			},
			"output": {
				"resultWrapper": "DescribeReceiptRuleSetResult",
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S27"
					},
					"Rules": {
						"shape": "S29"
					}
				}
			}
		},
		"GetIdentityDkimAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"Identities"
				],
				"members": {
					"Identities": {
						"shape": "S2k"
					}
				}
			},
			"output": {
				"resultWrapper": "GetIdentityDkimAttributesResult",
				"type": "structure",
				"required": [
					"DkimAttributes"
				],
				"members": {
					"DkimAttributes": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"required": [
								"DkimEnabled",
								"DkimVerificationStatus"
							],
							"members": {
								"DkimEnabled": {
									"type": "boolean"
								},
								"DkimVerificationStatus": {},
								"DkimTokens": {
									"shape": "S2p"
								}
							}
						}
					}
				}
			}
		},
		"GetIdentityMailFromDomainAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"Identities"
				],
				"members": {
					"Identities": {
						"shape": "S2k"
					}
				}
			},
			"output": {
				"resultWrapper": "GetIdentityMailFromDomainAttributesResult",
				"type": "structure",
				"required": [
					"MailFromDomainAttributes"
				],
				"members": {
					"MailFromDomainAttributes": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"required": [
								"MailFromDomain",
								"MailFromDomainStatus",
								"BehaviorOnMXFailure"
							],
							"members": {
								"MailFromDomain": {},
								"MailFromDomainStatus": {},
								"BehaviorOnMXFailure": {}
							}
						}
					}
				}
			}
		},
		"GetIdentityNotificationAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"Identities"
				],
				"members": {
					"Identities": {
						"shape": "S2k"
					}
				}
			},
			"output": {
				"resultWrapper": "GetIdentityNotificationAttributesResult",
				"type": "structure",
				"required": [
					"NotificationAttributes"
				],
				"members": {
					"NotificationAttributes": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"required": [
								"BounceTopic",
								"ComplaintTopic",
								"DeliveryTopic",
								"ForwardingEnabled"
							],
							"members": {
								"BounceTopic": {},
								"ComplaintTopic": {},
								"DeliveryTopic": {},
								"ForwardingEnabled": {
									"type": "boolean"
								},
								"HeadersInBounceNotificationsEnabled": {
									"type": "boolean"
								},
								"HeadersInComplaintNotificationsEnabled": {
									"type": "boolean"
								},
								"HeadersInDeliveryNotificationsEnabled": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		},
		"GetIdentityPolicies": {
			"input": {
				"type": "structure",
				"required": [
					"Identity",
					"PolicyNames"
				],
				"members": {
					"Identity": {},
					"PolicyNames": {
						"shape": "S34"
					}
				}
			},
			"output": {
				"resultWrapper": "GetIdentityPoliciesResult",
				"type": "structure",
				"required": [
					"Policies"
				],
				"members": {
					"Policies": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			}
		},
		"GetIdentityVerificationAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"Identities"
				],
				"members": {
					"Identities": {
						"shape": "S2k"
					}
				}
			},
			"output": {
				"resultWrapper": "GetIdentityVerificationAttributesResult",
				"type": "structure",
				"required": [
					"VerificationAttributes"
				],
				"members": {
					"VerificationAttributes": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"required": [
								"VerificationStatus"
							],
							"members": {
								"VerificationStatus": {},
								"VerificationToken": {}
							}
						}
					}
				}
			}
		},
		"GetSendQuota": {
			"output": {
				"resultWrapper": "GetSendQuotaResult",
				"type": "structure",
				"members": {
					"Max24HourSend": {
						"type": "double"
					},
					"MaxSendRate": {
						"type": "double"
					},
					"SentLast24Hours": {
						"type": "double"
					}
				}
			}
		},
		"GetSendStatistics": {
			"output": {
				"resultWrapper": "GetSendStatisticsResult",
				"type": "structure",
				"members": {
					"SendDataPoints": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Timestamp": {
									"type": "timestamp"
								},
								"DeliveryAttempts": {
									"type": "long"
								},
								"Bounces": {
									"type": "long"
								},
								"Complaints": {
									"type": "long"
								},
								"Rejects": {
									"type": "long"
								}
							}
						}
					}
				}
			}
		},
		"ListConfigurationSets": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"MaxItems": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "ListConfigurationSetsResult",
				"type": "structure",
				"members": {
					"ConfigurationSets": {
						"type": "list",
						"member": {
							"shape": "S5"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListIdentities": {
			"input": {
				"type": "structure",
				"members": {
					"IdentityType": {},
					"NextToken": {},
					"MaxItems": {
						"type": "integer"
					}
				}
			},
			"output": {
				"resultWrapper": "ListIdentitiesResult",
				"type": "structure",
				"required": [
					"Identities"
				],
				"members": {
					"Identities": {
						"shape": "S2k"
					},
					"NextToken": {}
				}
			}
		},
		"ListIdentityPolicies": {
			"input": {
				"type": "structure",
				"required": [
					"Identity"
				],
				"members": {
					"Identity": {}
				}
			},
			"output": {
				"resultWrapper": "ListIdentityPoliciesResult",
				"type": "structure",
				"required": [
					"PolicyNames"
				],
				"members": {
					"PolicyNames": {
						"shape": "S34"
					}
				}
			}
		},
		"ListReceiptFilters": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"resultWrapper": "ListReceiptFiltersResult",
				"type": "structure",
				"members": {
					"Filters": {
						"type": "list",
						"member": {
							"shape": "Sp"
						}
					}
				}
			}
		},
		"ListReceiptRuleSets": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListReceiptRuleSetsResult",
				"type": "structure",
				"members": {
					"RuleSets": {
						"type": "list",
						"member": {
							"shape": "S27"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListVerifiedEmailAddresses": {
			"output": {
				"resultWrapper": "ListVerifiedEmailAddressesResult",
				"type": "structure",
				"members": {
					"VerifiedEmailAddresses": {
						"shape": "S41"
					}
				}
			}
		},
		"PutIdentityPolicy": {
			"input": {
				"type": "structure",
				"required": [
					"Identity",
					"PolicyName",
					"Policy"
				],
				"members": {
					"Identity": {},
					"PolicyName": {},
					"Policy": {}
				}
			},
			"output": {
				"resultWrapper": "PutIdentityPolicyResult",
				"type": "structure",
				"members": {}
			}
		},
		"ReorderReceiptRuleSet": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetName",
					"RuleNames"
				],
				"members": {
					"RuleSetName": {},
					"RuleNames": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "ReorderReceiptRuleSetResult",
				"type": "structure",
				"members": {}
			}
		},
		"SendBounce": {
			"input": {
				"type": "structure",
				"required": [
					"OriginalMessageId",
					"BounceSender",
					"BouncedRecipientInfoList"
				],
				"members": {
					"OriginalMessageId": {},
					"BounceSender": {},
					"Explanation": {},
					"MessageDsn": {
						"type": "structure",
						"required": [
							"ReportingMta"
						],
						"members": {
							"ReportingMta": {},
							"ArrivalDate": {
								"type": "timestamp"
							},
							"ExtensionFields": {
								"shape": "S4d"
							}
						}
					},
					"BouncedRecipientInfoList": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Recipient"
							],
							"members": {
								"Recipient": {},
								"RecipientArn": {},
								"BounceType": {},
								"RecipientDsnFields": {
									"type": "structure",
									"required": [
										"Action",
										"Status"
									],
									"members": {
										"FinalRecipient": {},
										"Action": {},
										"RemoteMta": {},
										"Status": {},
										"DiagnosticCode": {},
										"LastAttemptDate": {
											"type": "timestamp"
										},
										"ExtensionFields": {
											"shape": "S4d"
										}
									}
								}
							}
						}
					},
					"BounceSenderArn": {}
				}
			},
			"output": {
				"resultWrapper": "SendBounceResult",
				"type": "structure",
				"members": {
					"MessageId": {}
				}
			}
		},
		"SendEmail": {
			"input": {
				"type": "structure",
				"required": [
					"Source",
					"Destination",
					"Message"
				],
				"members": {
					"Source": {},
					"Destination": {
						"type": "structure",
						"members": {
							"ToAddresses": {
								"shape": "S41"
							},
							"CcAddresses": {
								"shape": "S41"
							},
							"BccAddresses": {
								"shape": "S41"
							}
						}
					},
					"Message": {
						"type": "structure",
						"required": [
							"Subject",
							"Body"
						],
						"members": {
							"Subject": {
								"shape": "S4u"
							},
							"Body": {
								"type": "structure",
								"members": {
									"Text": {
										"shape": "S4u"
									},
									"Html": {
										"shape": "S4u"
									}
								}
							}
						}
					},
					"ReplyToAddresses": {
						"shape": "S41"
					},
					"ReturnPath": {},
					"SourceArn": {},
					"ReturnPathArn": {},
					"Tags": {
						"shape": "S4y"
					},
					"ConfigurationSetName": {}
				}
			},
			"output": {
				"resultWrapper": "SendEmailResult",
				"type": "structure",
				"required": [
					"MessageId"
				],
				"members": {
					"MessageId": {}
				}
			}
		},
		"SendRawEmail": {
			"input": {
				"type": "structure",
				"required": [
					"RawMessage"
				],
				"members": {
					"Source": {},
					"Destinations": {
						"shape": "S41"
					},
					"RawMessage": {
						"type": "structure",
						"required": [
							"Data"
						],
						"members": {
							"Data": {
								"type": "blob"
							}
						}
					},
					"FromArn": {},
					"SourceArn": {},
					"ReturnPathArn": {},
					"Tags": {
						"shape": "S4y"
					},
					"ConfigurationSetName": {}
				}
			},
			"output": {
				"resultWrapper": "SendRawEmailResult",
				"type": "structure",
				"required": [
					"MessageId"
				],
				"members": {
					"MessageId": {}
				}
			}
		},
		"SetActiveReceiptRuleSet": {
			"input": {
				"type": "structure",
				"members": {
					"RuleSetName": {}
				}
			},
			"output": {
				"resultWrapper": "SetActiveReceiptRuleSetResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetIdentityDkimEnabled": {
			"input": {
				"type": "structure",
				"required": [
					"Identity",
					"DkimEnabled"
				],
				"members": {
					"Identity": {},
					"DkimEnabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "SetIdentityDkimEnabledResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetIdentityFeedbackForwardingEnabled": {
			"input": {
				"type": "structure",
				"required": [
					"Identity",
					"ForwardingEnabled"
				],
				"members": {
					"Identity": {},
					"ForwardingEnabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "SetIdentityFeedbackForwardingEnabledResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetIdentityHeadersInNotificationsEnabled": {
			"input": {
				"type": "structure",
				"required": [
					"Identity",
					"NotificationType",
					"Enabled"
				],
				"members": {
					"Identity": {},
					"NotificationType": {},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"resultWrapper": "SetIdentityHeadersInNotificationsEnabledResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetIdentityMailFromDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Identity"
				],
				"members": {
					"Identity": {},
					"MailFromDomain": {},
					"BehaviorOnMXFailure": {}
				}
			},
			"output": {
				"resultWrapper": "SetIdentityMailFromDomainResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetIdentityNotificationTopic": {
			"input": {
				"type": "structure",
				"required": [
					"Identity",
					"NotificationType"
				],
				"members": {
					"Identity": {},
					"NotificationType": {},
					"SnsTopic": {}
				}
			},
			"output": {
				"resultWrapper": "SetIdentityNotificationTopicResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetReceiptRulePosition": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetName",
					"RuleName"
				],
				"members": {
					"RuleSetName": {},
					"RuleName": {},
					"After": {}
				}
			},
			"output": {
				"resultWrapper": "SetReceiptRulePositionResult",
				"type": "structure",
				"members": {}
			}
		},
		"UpdateConfigurationSetEventDestination": {
			"input": {
				"type": "structure",
				"required": [
					"ConfigurationSetName",
					"EventDestination"
				],
				"members": {
					"ConfigurationSetName": {},
					"EventDestination": {
						"shape": "S9"
					}
				}
			},
			"output": {
				"resultWrapper": "UpdateConfigurationSetEventDestinationResult",
				"type": "structure",
				"members": {}
			}
		},
		"UpdateReceiptRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleSetName",
					"Rule"
				],
				"members": {
					"RuleSetName": {},
					"Rule": {
						"shape": "Sx"
					}
				}
			},
			"output": {
				"resultWrapper": "UpdateReceiptRuleResult",
				"type": "structure",
				"members": {}
			}
		},
		"VerifyDomainDkim": {
			"input": {
				"type": "structure",
				"required": [
					"Domain"
				],
				"members": {
					"Domain": {}
				}
			},
			"output": {
				"resultWrapper": "VerifyDomainDkimResult",
				"type": "structure",
				"required": [
					"DkimTokens"
				],
				"members": {
					"DkimTokens": {
						"shape": "S2p"
					}
				}
			}
		},
		"VerifyDomainIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"Domain"
				],
				"members": {
					"Domain": {}
				}
			},
			"output": {
				"resultWrapper": "VerifyDomainIdentityResult",
				"type": "structure",
				"required": [
					"VerificationToken"
				],
				"members": {
					"VerificationToken": {}
				}
			}
		},
		"VerifyEmailAddress": {
			"input": {
				"type": "structure",
				"required": [
					"EmailAddress"
				],
				"members": {
					"EmailAddress": {}
				}
			}
		},
		"VerifyEmailIdentity": {
			"input": {
				"type": "structure",
				"required": [
					"EmailAddress"
				],
				"members": {
					"EmailAddress": {}
				}
			},
			"output": {
				"resultWrapper": "VerifyEmailIdentityResult",
				"type": "structure",
				"members": {}
			}
		}
	},
	"shapes": {
		"S5": {
			"type": "structure",
			"required": [
				"Name"
			],
			"members": {
				"Name": {}
			}
		},
		"S9": {
			"type": "structure",
			"required": [
				"Name",
				"MatchingEventTypes"
			],
			"members": {
				"Name": {},
				"Enabled": {
					"type": "boolean"
				},
				"MatchingEventTypes": {
					"type": "list",
					"member": {}
				},
				"KinesisFirehoseDestination": {
					"type": "structure",
					"required": [
						"IAMRoleARN",
						"DeliveryStreamARN"
					],
					"members": {
						"IAMRoleARN": {},
						"DeliveryStreamARN": {}
					}
				},
				"CloudWatchDestination": {
					"type": "structure",
					"required": [
						"DimensionConfigurations"
					],
					"members": {
						"DimensionConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"DimensionName",
									"DimensionValueSource",
									"DefaultDimensionValue"
								],
								"members": {
									"DimensionName": {},
									"DimensionValueSource": {},
									"DefaultDimensionValue": {}
								}
							}
						}
					}
				},
				"SNSDestination": {
					"type": "structure",
					"required": [
						"TopicARN"
					],
					"members": {
						"TopicARN": {}
					}
				}
			}
		},
		"Sp": {
			"type": "structure",
			"required": [
				"Name",
				"IpFilter"
			],
			"members": {
				"Name": {},
				"IpFilter": {
					"type": "structure",
					"required": [
						"Policy",
						"Cidr"
					],
					"members": {
						"Policy": {},
						"Cidr": {}
					}
				}
			}
		},
		"Sx": {
			"type": "structure",
			"required": [
				"Name"
			],
			"members": {
				"Name": {},
				"Enabled": {
					"type": "boolean"
				},
				"TlsPolicy": {},
				"Recipients": {
					"type": "list",
					"member": {}
				},
				"Actions": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"S3Action": {
								"type": "structure",
								"required": [
									"BucketName"
								],
								"members": {
									"TopicArn": {},
									"BucketName": {},
									"ObjectKeyPrefix": {},
									"KmsKeyArn": {}
								}
							},
							"BounceAction": {
								"type": "structure",
								"required": [
									"SmtpReplyCode",
									"Message",
									"Sender"
								],
								"members": {
									"TopicArn": {},
									"SmtpReplyCode": {},
									"StatusCode": {},
									"Message": {},
									"Sender": {}
								}
							},
							"WorkmailAction": {
								"type": "structure",
								"required": [
									"OrganizationArn"
								],
								"members": {
									"TopicArn": {},
									"OrganizationArn": {}
								}
							},
							"LambdaAction": {
								"type": "structure",
								"required": [
									"FunctionArn"
								],
								"members": {
									"TopicArn": {},
									"FunctionArn": {},
									"InvocationType": {}
								}
							},
							"StopAction": {
								"type": "structure",
								"required": [
									"Scope"
								],
								"members": {
									"Scope": {},
									"TopicArn": {}
								}
							},
							"AddHeaderAction": {
								"type": "structure",
								"required": [
									"HeaderName",
									"HeaderValue"
								],
								"members": {
									"HeaderName": {},
									"HeaderValue": {}
								}
							},
							"SNSAction": {
								"type": "structure",
								"required": [
									"TopicArn"
								],
								"members": {
									"TopicArn": {},
									"Encoding": {}
								}
							}
						}
					}
				},
				"ScanEnabled": {
					"type": "boolean"
				}
			}
		},
		"S27": {
			"type": "structure",
			"members": {
				"Name": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				}
			}
		},
		"S29": {
			"type": "list",
			"member": {
				"shape": "Sx"
			}
		},
		"S2k": {
			"type": "list",
			"member": {}
		},
		"S2p": {
			"type": "list",
			"member": {}
		},
		"S34": {
			"type": "list",
			"member": {}
		},
		"S41": {
			"type": "list",
			"member": {}
		},
		"S4d": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Name",
					"Value"
				],
				"members": {
					"Name": {},
					"Value": {}
				}
			}
		},
		"S4u": {
			"type": "structure",
			"required": [
				"Data"
			],
			"members": {
				"Data": {},
				"Charset": {}
			}
		},
		"S4y": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Name",
					"Value"
				],
				"members": {
					"Name": {},
					"Value": {}
				}
			}
		}
	}
};

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListIdentities": {
			"input_token": "NextToken",
			"limit_key": "MaxItems",
			"output_token": "NextToken",
			"result_key": "Identities"
		},
		"ListVerifiedEmailAddresses": {
			"result_key": "VerifiedEmailAddresses"
		}
	}
};

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

module.exports = {
	"version": 2,
	"waiters": {
		"IdentityExists": {
			"delay": 3,
			"operation": "GetIdentityVerificationAttributes",
			"maxAttempts": 20,
			"acceptors": [
				{
					"expected": "Success",
					"matcher": "pathAll",
					"state": "success",
					"argument": "VerificationAttributes.*.VerificationStatus"
				}
			]
		}
	}
};

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sns'] = {};
AWS.SNS = Service.defineService('sns', ['2010-03-31']);
Object.defineProperty(apiLoader.services['sns'], '2010-03-31', {
  get: function get() {
    var model = __webpack_require__(1722);
    model.paginators = __webpack_require__(1723).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SNS;


/***/ }),
/* 1722 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"uid": "sns-2010-03-31",
		"apiVersion": "2010-03-31",
		"endpointPrefix": "sns",
		"protocol": "query",
		"serviceAbbreviation": "Amazon SNS",
		"serviceFullName": "Amazon Simple Notification Service",
		"signatureVersion": "v4",
		"xmlNamespace": "http://sns.amazonaws.com/doc/2010-03-31/"
	},
	"operations": {
		"AddPermission": {
			"input": {
				"type": "structure",
				"required": [
					"TopicArn",
					"Label",
					"AWSAccountId",
					"ActionName"
				],
				"members": {
					"TopicArn": {},
					"Label": {},
					"AWSAccountId": {
						"type": "list",
						"member": {}
					},
					"ActionName": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"CheckIfPhoneNumberIsOptedOut": {
			"input": {
				"type": "structure",
				"required": [
					"phoneNumber"
				],
				"members": {
					"phoneNumber": {}
				}
			},
			"output": {
				"resultWrapper": "CheckIfPhoneNumberIsOptedOutResult",
				"type": "structure",
				"members": {
					"isOptedOut": {
						"type": "boolean"
					}
				}
			}
		},
		"ConfirmSubscription": {
			"input": {
				"type": "structure",
				"required": [
					"TopicArn",
					"Token"
				],
				"members": {
					"TopicArn": {},
					"Token": {},
					"AuthenticateOnUnsubscribe": {}
				}
			},
			"output": {
				"resultWrapper": "ConfirmSubscriptionResult",
				"type": "structure",
				"members": {
					"SubscriptionArn": {}
				}
			}
		},
		"CreatePlatformApplication": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Platform",
					"Attributes"
				],
				"members": {
					"Name": {},
					"Platform": {},
					"Attributes": {
						"shape": "Sj"
					}
				}
			},
			"output": {
				"resultWrapper": "CreatePlatformApplicationResult",
				"type": "structure",
				"members": {
					"PlatformApplicationArn": {}
				}
			}
		},
		"CreatePlatformEndpoint": {
			"input": {
				"type": "structure",
				"required": [
					"PlatformApplicationArn",
					"Token"
				],
				"members": {
					"PlatformApplicationArn": {},
					"Token": {},
					"CustomUserData": {},
					"Attributes": {
						"shape": "Sj"
					}
				}
			},
			"output": {
				"resultWrapper": "CreatePlatformEndpointResult",
				"type": "structure",
				"members": {
					"EndpointArn": {}
				}
			}
		},
		"CreateTopic": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"resultWrapper": "CreateTopicResult",
				"type": "structure",
				"members": {
					"TopicArn": {}
				}
			}
		},
		"DeleteEndpoint": {
			"input": {
				"type": "structure",
				"required": [
					"EndpointArn"
				],
				"members": {
					"EndpointArn": {}
				}
			}
		},
		"DeletePlatformApplication": {
			"input": {
				"type": "structure",
				"required": [
					"PlatformApplicationArn"
				],
				"members": {
					"PlatformApplicationArn": {}
				}
			}
		},
		"DeleteTopic": {
			"input": {
				"type": "structure",
				"required": [
					"TopicArn"
				],
				"members": {
					"TopicArn": {}
				}
			}
		},
		"GetEndpointAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"EndpointArn"
				],
				"members": {
					"EndpointArn": {}
				}
			},
			"output": {
				"resultWrapper": "GetEndpointAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Sj"
					}
				}
			}
		},
		"GetPlatformApplicationAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"PlatformApplicationArn"
				],
				"members": {
					"PlatformApplicationArn": {}
				}
			},
			"output": {
				"resultWrapper": "GetPlatformApplicationAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Sj"
					}
				}
			}
		},
		"GetSMSAttributes": {
			"input": {
				"type": "structure",
				"members": {
					"attributes": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"resultWrapper": "GetSMSAttributesResult",
				"type": "structure",
				"members": {
					"attributes": {
						"shape": "Sj"
					}
				}
			}
		},
		"GetSubscriptionAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionArn"
				],
				"members": {
					"SubscriptionArn": {}
				}
			},
			"output": {
				"resultWrapper": "GetSubscriptionAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			}
		},
		"GetTopicAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"TopicArn"
				],
				"members": {
					"TopicArn": {}
				}
			},
			"output": {
				"resultWrapper": "GetTopicAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			}
		},
		"ListEndpointsByPlatformApplication": {
			"input": {
				"type": "structure",
				"required": [
					"PlatformApplicationArn"
				],
				"members": {
					"PlatformApplicationArn": {},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListEndpointsByPlatformApplicationResult",
				"type": "structure",
				"members": {
					"Endpoints": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EndpointArn": {},
								"Attributes": {
									"shape": "Sj"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListPhoneNumbersOptedOut": {
			"input": {
				"type": "structure",
				"members": {
					"nextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListPhoneNumbersOptedOutResult",
				"type": "structure",
				"members": {
					"phoneNumbers": {
						"type": "list",
						"member": {}
					},
					"nextToken": {}
				}
			}
		},
		"ListPlatformApplications": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListPlatformApplicationsResult",
				"type": "structure",
				"members": {
					"PlatformApplications": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PlatformApplicationArn": {},
								"Attributes": {
									"shape": "Sj"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListSubscriptions": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListSubscriptionsResult",
				"type": "structure",
				"members": {
					"Subscriptions": {
						"shape": "S1n"
					},
					"NextToken": {}
				}
			}
		},
		"ListSubscriptionsByTopic": {
			"input": {
				"type": "structure",
				"required": [
					"TopicArn"
				],
				"members": {
					"TopicArn": {},
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListSubscriptionsByTopicResult",
				"type": "structure",
				"members": {
					"Subscriptions": {
						"shape": "S1n"
					},
					"NextToken": {}
				}
			}
		},
		"ListTopics": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {}
				}
			},
			"output": {
				"resultWrapper": "ListTopicsResult",
				"type": "structure",
				"members": {
					"Topics": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"TopicArn": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"OptInPhoneNumber": {
			"input": {
				"type": "structure",
				"required": [
					"phoneNumber"
				],
				"members": {
					"phoneNumber": {}
				}
			},
			"output": {
				"resultWrapper": "OptInPhoneNumberResult",
				"type": "structure",
				"members": {}
			}
		},
		"Publish": {
			"input": {
				"type": "structure",
				"required": [
					"Message"
				],
				"members": {
					"TopicArn": {},
					"TargetArn": {},
					"PhoneNumber": {},
					"Message": {},
					"Subject": {},
					"MessageStructure": {},
					"MessageAttributes": {
						"type": "map",
						"key": {
							"locationName": "Name"
						},
						"value": {
							"locationName": "Value",
							"type": "structure",
							"required": [
								"DataType"
							],
							"members": {
								"DataType": {},
								"StringValue": {},
								"BinaryValue": {
									"type": "blob"
								}
							}
						}
					}
				}
			},
			"output": {
				"resultWrapper": "PublishResult",
				"type": "structure",
				"members": {
					"MessageId": {}
				}
			}
		},
		"RemovePermission": {
			"input": {
				"type": "structure",
				"required": [
					"TopicArn",
					"Label"
				],
				"members": {
					"TopicArn": {},
					"Label": {}
				}
			}
		},
		"SetEndpointAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"EndpointArn",
					"Attributes"
				],
				"members": {
					"EndpointArn": {},
					"Attributes": {
						"shape": "Sj"
					}
				}
			}
		},
		"SetPlatformApplicationAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"PlatformApplicationArn",
					"Attributes"
				],
				"members": {
					"PlatformApplicationArn": {},
					"Attributes": {
						"shape": "Sj"
					}
				}
			}
		},
		"SetSMSAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"attributes"
				],
				"members": {
					"attributes": {
						"shape": "Sj"
					}
				}
			},
			"output": {
				"resultWrapper": "SetSMSAttributesResult",
				"type": "structure",
				"members": {}
			}
		},
		"SetSubscriptionAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionArn",
					"AttributeName"
				],
				"members": {
					"SubscriptionArn": {},
					"AttributeName": {},
					"AttributeValue": {}
				}
			}
		},
		"SetTopicAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"TopicArn",
					"AttributeName"
				],
				"members": {
					"TopicArn": {},
					"AttributeName": {},
					"AttributeValue": {}
				}
			}
		},
		"Subscribe": {
			"input": {
				"type": "structure",
				"required": [
					"TopicArn",
					"Protocol"
				],
				"members": {
					"TopicArn": {},
					"Protocol": {},
					"Endpoint": {}
				}
			},
			"output": {
				"resultWrapper": "SubscribeResult",
				"type": "structure",
				"members": {
					"SubscriptionArn": {}
				}
			}
		},
		"Unsubscribe": {
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionArn"
				],
				"members": {
					"SubscriptionArn": {}
				}
			}
		}
	},
	"shapes": {
		"Sj": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1n": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"SubscriptionArn": {},
					"Owner": {},
					"Protocol": {},
					"Endpoint": {},
					"TopicArn": {}
				}
			}
		}
	}
};

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListEndpointsByPlatformApplication": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "Endpoints"
		},
		"ListPlatformApplications": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "PlatformApplications"
		},
		"ListSubscriptions": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "Subscriptions"
		},
		"ListSubscriptionsByTopic": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "Subscriptions"
		},
		"ListTopics": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "Topics"
		}
	}
};

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['sqs'] = {};
AWS.SQS = Service.defineService('sqs', ['2012-11-05']);
__webpack_require__(1725);
Object.defineProperty(apiLoader.services['sqs'], '2012-11-05', {
  get: function get() {
    var model = __webpack_require__(1726);
    model.paginators = __webpack_require__(1727).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SQS;


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

var AWS = __webpack_require__(7);

AWS.util.update(AWS.SQS.prototype, {
  /**
   * @api private
   */
  setupRequestListeners: function setupRequestListeners(request) {
    request.addListener('build', this.buildEndpoint);

    if (request.service.config.computeChecksums) {
      if (request.operation === 'sendMessage') {
        request.addListener('extractData', this.verifySendMessageChecksum);
      } else if (request.operation === 'sendMessageBatch') {
        request.addListener('extractData', this.verifySendMessageBatchChecksum);
      } else if (request.operation === 'receiveMessage') {
        request.addListener('extractData', this.verifyReceiveMessageChecksum);
      }
    }
  },

  /**
   * @api private
   */
  verifySendMessageChecksum: function verifySendMessageChecksum(response) {
    if (!response.data) return;

    var md5 = response.data.MD5OfMessageBody;
    var body = this.params.MessageBody;
    var calculatedMd5 = this.service.calculateChecksum(body);
    if (calculatedMd5 !== md5) {
      var msg = 'Got "' + response.data.MD5OfMessageBody +
        '", expecting "' + calculatedMd5 + '".';
      this.service.throwInvalidChecksumError(response,
        [response.data.MessageId], msg);
    }
  },

  /**
   * @api private
   */
  verifySendMessageBatchChecksum: function verifySendMessageBatchChecksum(response) {
    if (!response.data) return;

    var service = this.service;
    var entries = {};
    var errors = [];
    var messageIds = [];
    AWS.util.arrayEach(response.data.Successful, function (entry) {
      entries[entry.Id] = entry;
    });
    AWS.util.arrayEach(this.params.Entries, function (entry) {
      if (entries[entry.Id]) {
        var md5 = entries[entry.Id].MD5OfMessageBody;
        var body = entry.MessageBody;
        if (!service.isChecksumValid(md5, body)) {
          errors.push(entry.Id);
          messageIds.push(entries[entry.Id].MessageId);
        }
      }
    });

    if (errors.length > 0) {
      service.throwInvalidChecksumError(response, messageIds,
        'Invalid messages: ' + errors.join(', '));
    }
  },

  /**
   * @api private
   */
  verifyReceiveMessageChecksum: function verifyReceiveMessageChecksum(response) {
    if (!response.data) return;

    var service = this.service;
    var messageIds = [];
    AWS.util.arrayEach(response.data.Messages, function(message) {
      var md5 = message.MD5OfBody;
      var body = message.Body;
      if (!service.isChecksumValid(md5, body)) {
        messageIds.push(message.MessageId);
      }
    });

    if (messageIds.length > 0) {
      service.throwInvalidChecksumError(response, messageIds,
        'Invalid messages: ' + messageIds.join(', '));
    }
  },

  /**
   * @api private
   */
  throwInvalidChecksumError: function throwInvalidChecksumError(response, ids, message) {
    response.error = AWS.util.error(new Error(), {
      retryable: true,
      code: 'InvalidChecksum',
      messageIds: ids,
      message: response.request.operation +
               ' returned an invalid MD5 response. ' + message
    });
  },

  /**
   * @api private
   */
  isChecksumValid: function isChecksumValid(checksum, data) {
    return this.calculateChecksum(data) === checksum;
  },

  /**
   * @api private
   */
  calculateChecksum: function calculateChecksum(data) {
    return AWS.util.crypto.md5(data, 'hex');
  },

  /**
   * @api private
   */
  buildEndpoint: function buildEndpoint(request) {
    var url = request.httpRequest.params.QueueUrl;
    if (url) {
      request.httpRequest.endpoint = new AWS.Endpoint(url);

      // signature version 4 requires the region name to be set,
      // sqs queue urls contain the region name
      var matches = request.httpRequest.endpoint.host.match(/^sqs\.(.+?)\./);
      if (matches) request.httpRequest.region = matches[1];
    }
  }
});


/***/ }),
/* 1726 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2012-11-05",
		"endpointPrefix": "sqs",
		"protocol": "query",
		"serviceAbbreviation": "Amazon SQS",
		"serviceFullName": "Amazon Simple Queue Service",
		"signatureVersion": "v4",
		"uid": "sqs-2012-11-05",
		"xmlNamespace": "http://queue.amazonaws.com/doc/2012-11-05/"
	},
	"operations": {
		"AddPermission": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl",
					"Label",
					"AWSAccountIds",
					"Actions"
				],
				"members": {
					"QueueUrl": {},
					"Label": {},
					"AWSAccountIds": {
						"type": "list",
						"member": {
							"locationName": "AWSAccountId"
						},
						"flattened": true
					},
					"Actions": {
						"type": "list",
						"member": {
							"locationName": "ActionName"
						},
						"flattened": true
					}
				}
			}
		},
		"ChangeMessageVisibility": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl",
					"ReceiptHandle",
					"VisibilityTimeout"
				],
				"members": {
					"QueueUrl": {},
					"ReceiptHandle": {},
					"VisibilityTimeout": {
						"type": "integer"
					}
				}
			}
		},
		"ChangeMessageVisibilityBatch": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl",
					"Entries"
				],
				"members": {
					"QueueUrl": {},
					"Entries": {
						"type": "list",
						"member": {
							"locationName": "ChangeMessageVisibilityBatchRequestEntry",
							"type": "structure",
							"required": [
								"Id",
								"ReceiptHandle"
							],
							"members": {
								"Id": {},
								"ReceiptHandle": {},
								"VisibilityTimeout": {
									"type": "integer"
								}
							}
						},
						"flattened": true
					}
				}
			},
			"output": {
				"resultWrapper": "ChangeMessageVisibilityBatchResult",
				"type": "structure",
				"required": [
					"Successful",
					"Failed"
				],
				"members": {
					"Successful": {
						"type": "list",
						"member": {
							"locationName": "ChangeMessageVisibilityBatchResultEntry",
							"type": "structure",
							"required": [
								"Id"
							],
							"members": {
								"Id": {}
							}
						},
						"flattened": true
					},
					"Failed": {
						"shape": "Sd"
					}
				}
			}
		},
		"CreateQueue": {
			"input": {
				"type": "structure",
				"required": [
					"QueueName"
				],
				"members": {
					"QueueName": {},
					"Attributes": {
						"shape": "Sh",
						"locationName": "Attribute"
					}
				}
			},
			"output": {
				"resultWrapper": "CreateQueueResult",
				"type": "structure",
				"members": {
					"QueueUrl": {}
				}
			}
		},
		"DeleteMessage": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl",
					"ReceiptHandle"
				],
				"members": {
					"QueueUrl": {},
					"ReceiptHandle": {}
				}
			}
		},
		"DeleteMessageBatch": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl",
					"Entries"
				],
				"members": {
					"QueueUrl": {},
					"Entries": {
						"type": "list",
						"member": {
							"locationName": "DeleteMessageBatchRequestEntry",
							"type": "structure",
							"required": [
								"Id",
								"ReceiptHandle"
							],
							"members": {
								"Id": {},
								"ReceiptHandle": {}
							}
						},
						"flattened": true
					}
				}
			},
			"output": {
				"resultWrapper": "DeleteMessageBatchResult",
				"type": "structure",
				"required": [
					"Successful",
					"Failed"
				],
				"members": {
					"Successful": {
						"type": "list",
						"member": {
							"locationName": "DeleteMessageBatchResultEntry",
							"type": "structure",
							"required": [
								"Id"
							],
							"members": {
								"Id": {}
							}
						},
						"flattened": true
					},
					"Failed": {
						"shape": "Sd"
					}
				}
			}
		},
		"DeleteQueue": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl"
				],
				"members": {
					"QueueUrl": {}
				}
			}
		},
		"GetQueueAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl"
				],
				"members": {
					"QueueUrl": {},
					"AttributeNames": {
						"shape": "St"
					}
				}
			},
			"output": {
				"resultWrapper": "GetQueueAttributesResult",
				"type": "structure",
				"members": {
					"Attributes": {
						"shape": "Sh",
						"locationName": "Attribute"
					}
				}
			}
		},
		"GetQueueUrl": {
			"input": {
				"type": "structure",
				"required": [
					"QueueName"
				],
				"members": {
					"QueueName": {},
					"QueueOwnerAWSAccountId": {}
				}
			},
			"output": {
				"resultWrapper": "GetQueueUrlResult",
				"type": "structure",
				"members": {
					"QueueUrl": {}
				}
			}
		},
		"ListDeadLetterSourceQueues": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl"
				],
				"members": {
					"QueueUrl": {}
				}
			},
			"output": {
				"resultWrapper": "ListDeadLetterSourceQueuesResult",
				"type": "structure",
				"required": [
					"queueUrls"
				],
				"members": {
					"queueUrls": {
						"shape": "Sz"
					}
				}
			}
		},
		"ListQueues": {
			"input": {
				"type": "structure",
				"members": {
					"QueueNamePrefix": {}
				}
			},
			"output": {
				"resultWrapper": "ListQueuesResult",
				"type": "structure",
				"members": {
					"QueueUrls": {
						"shape": "Sz"
					}
				}
			}
		},
		"PurgeQueue": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl"
				],
				"members": {
					"QueueUrl": {}
				}
			}
		},
		"ReceiveMessage": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl"
				],
				"members": {
					"QueueUrl": {},
					"AttributeNames": {
						"shape": "St"
					},
					"MessageAttributeNames": {
						"type": "list",
						"member": {
							"locationName": "MessageAttributeName"
						},
						"flattened": true
					},
					"MaxNumberOfMessages": {
						"type": "integer"
					},
					"VisibilityTimeout": {
						"type": "integer"
					},
					"WaitTimeSeconds": {
						"type": "integer"
					},
					"ReceiveRequestAttemptId": {}
				}
			},
			"output": {
				"resultWrapper": "ReceiveMessageResult",
				"type": "structure",
				"members": {
					"Messages": {
						"type": "list",
						"member": {
							"locationName": "Message",
							"type": "structure",
							"members": {
								"MessageId": {},
								"ReceiptHandle": {},
								"MD5OfBody": {},
								"Body": {},
								"Attributes": {
									"locationName": "Attribute",
									"type": "map",
									"key": {
										"locationName": "Name"
									},
									"value": {
										"locationName": "Value"
									},
									"flattened": true
								},
								"MD5OfMessageAttributes": {},
								"MessageAttributes": {
									"shape": "S1b",
									"locationName": "MessageAttribute"
								}
							}
						},
						"flattened": true
					}
				}
			}
		},
		"RemovePermission": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl",
					"Label"
				],
				"members": {
					"QueueUrl": {},
					"Label": {}
				}
			}
		},
		"SendMessage": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl",
					"MessageBody"
				],
				"members": {
					"QueueUrl": {},
					"MessageBody": {},
					"DelaySeconds": {
						"type": "integer"
					},
					"MessageAttributes": {
						"shape": "S1b",
						"locationName": "MessageAttribute"
					},
					"MessageDeduplicationId": {},
					"MessageGroupId": {}
				}
			},
			"output": {
				"resultWrapper": "SendMessageResult",
				"type": "structure",
				"members": {
					"MD5OfMessageBody": {},
					"MD5OfMessageAttributes": {},
					"MessageId": {},
					"SequenceNumber": {}
				}
			}
		},
		"SendMessageBatch": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl",
					"Entries"
				],
				"members": {
					"QueueUrl": {},
					"Entries": {
						"type": "list",
						"member": {
							"locationName": "SendMessageBatchRequestEntry",
							"type": "structure",
							"required": [
								"Id",
								"MessageBody"
							],
							"members": {
								"Id": {},
								"MessageBody": {},
								"DelaySeconds": {
									"type": "integer"
								},
								"MessageAttributes": {
									"shape": "S1b",
									"locationName": "MessageAttribute"
								},
								"MessageDeduplicationId": {},
								"MessageGroupId": {}
							}
						},
						"flattened": true
					}
				}
			},
			"output": {
				"resultWrapper": "SendMessageBatchResult",
				"type": "structure",
				"required": [
					"Successful",
					"Failed"
				],
				"members": {
					"Successful": {
						"type": "list",
						"member": {
							"locationName": "SendMessageBatchResultEntry",
							"type": "structure",
							"required": [
								"Id",
								"MessageId",
								"MD5OfMessageBody"
							],
							"members": {
								"Id": {},
								"MessageId": {},
								"MD5OfMessageBody": {},
								"MD5OfMessageAttributes": {},
								"SequenceNumber": {}
							}
						},
						"flattened": true
					},
					"Failed": {
						"shape": "Sd"
					}
				}
			}
		},
		"SetQueueAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"QueueUrl",
					"Attributes"
				],
				"members": {
					"QueueUrl": {},
					"Attributes": {
						"shape": "Sh",
						"locationName": "Attribute"
					}
				}
			}
		}
	},
	"shapes": {
		"Sd": {
			"type": "list",
			"member": {
				"locationName": "BatchResultErrorEntry",
				"type": "structure",
				"required": [
					"Id",
					"SenderFault",
					"Code"
				],
				"members": {
					"Id": {},
					"SenderFault": {
						"type": "boolean"
					},
					"Code": {},
					"Message": {}
				}
			},
			"flattened": true
		},
		"Sh": {
			"type": "map",
			"key": {
				"locationName": "Name"
			},
			"value": {
				"locationName": "Value"
			},
			"flattened": true,
			"locationName": "Attribute"
		},
		"St": {
			"type": "list",
			"member": {
				"locationName": "AttributeName"
			},
			"flattened": true
		},
		"Sz": {
			"type": "list",
			"member": {
				"locationName": "QueueUrl"
			},
			"flattened": true
		},
		"S1b": {
			"type": "map",
			"key": {
				"locationName": "Name"
			},
			"value": {
				"locationName": "Value",
				"type": "structure",
				"required": [
					"DataType"
				],
				"members": {
					"StringValue": {},
					"BinaryValue": {
						"type": "blob"
					},
					"StringListValues": {
						"flattened": true,
						"locationName": "StringListValue",
						"type": "list",
						"member": {
							"locationName": "StringListValue"
						}
					},
					"BinaryListValues": {
						"flattened": true,
						"locationName": "BinaryListValue",
						"type": "list",
						"member": {
							"locationName": "BinaryListValue",
							"type": "blob"
						}
					},
					"DataType": {}
				}
			},
			"flattened": true
		}
	}
};

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"ListQueues": {
			"result_key": "QueueUrls"
		}
	}
};

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['ssm'] = {};
AWS.SSM = Service.defineService('ssm', ['2014-11-06']);
Object.defineProperty(apiLoader.services['ssm'], '2014-11-06', {
  get: function get() {
    var model = __webpack_require__(1729);
    model.paginators = __webpack_require__(1730).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.SSM;


/***/ }),
/* 1729 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2014-11-06",
		"endpointPrefix": "ssm",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "Amazon SSM",
		"serviceFullName": "Amazon Simple Systems Manager (SSM)",
		"signatureVersion": "v4",
		"targetPrefix": "AmazonSSM",
		"uid": "ssm-2014-11-06"
	},
	"operations": {
		"AddTagsToResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceType",
					"ResourceId",
					"Tags"
				],
				"members": {
					"ResourceType": {},
					"ResourceId": {},
					"Tags": {
						"shape": "S4"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CancelCommand": {
			"input": {
				"type": "structure",
				"required": [
					"CommandId"
				],
				"members": {
					"CommandId": {},
					"InstanceIds": {
						"shape": "Sb"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateActivation": {
			"input": {
				"type": "structure",
				"required": [
					"IamRole"
				],
				"members": {
					"Description": {},
					"DefaultInstanceName": {},
					"IamRole": {},
					"RegistrationLimit": {
						"type": "integer"
					},
					"ExpirationDate": {
						"type": "timestamp"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ActivationId": {},
					"ActivationCode": {}
				}
			}
		},
		"CreateAssociation": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"DocumentVersion": {},
					"InstanceId": {},
					"Parameters": {
						"shape": "Sq"
					},
					"Targets": {
						"shape": "Su"
					},
					"ScheduleExpression": {},
					"OutputLocation": {
						"shape": "S10"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AssociationDescription": {
						"shape": "S16"
					}
				}
			}
		},
		"CreateAssociationBatch": {
			"input": {
				"type": "structure",
				"required": [
					"Entries"
				],
				"members": {
					"Entries": {
						"type": "list",
						"member": {
							"shape": "S1j",
							"locationName": "entries"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Successful": {
						"type": "list",
						"member": {
							"shape": "S16",
							"locationName": "AssociationDescription"
						}
					},
					"Failed": {
						"type": "list",
						"member": {
							"locationName": "FailedCreateAssociationEntry",
							"type": "structure",
							"members": {
								"Entry": {
									"shape": "S1j"
								},
								"Message": {},
								"Fault": {}
							}
						}
					}
				}
			}
		},
		"CreateDocument": {
			"input": {
				"type": "structure",
				"required": [
					"Content",
					"Name"
				],
				"members": {
					"Content": {},
					"Name": {},
					"DocumentType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DocumentDescription": {
						"shape": "S1u"
					}
				}
			}
		},
		"CreateMaintenanceWindow": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Schedule",
					"Duration",
					"Cutoff",
					"AllowUnassociatedTargets"
				],
				"members": {
					"Name": {},
					"Description": {
						"shape": "S2d"
					},
					"Schedule": {},
					"Duration": {
						"type": "integer"
					},
					"Cutoff": {
						"type": "integer"
					},
					"AllowUnassociatedTargets": {
						"type": "boolean"
					},
					"ClientToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowId": {}
				}
			}
		},
		"CreatePatchBaseline": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"OperatingSystem": {},
					"Name": {},
					"GlobalFilters": {
						"shape": "S2o"
					},
					"ApprovalRules": {
						"shape": "S2u"
					},
					"ApprovedPatches": {
						"shape": "S2z"
					},
					"ApprovedPatchesComplianceLevel": {},
					"RejectedPatches": {
						"shape": "S2z"
					},
					"Description": {},
					"ClientToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BaselineId": {}
				}
			}
		},
		"CreateResourceDataSync": {
			"input": {
				"type": "structure",
				"required": [
					"SyncName",
					"S3Destination"
				],
				"members": {
					"SyncName": {},
					"S3Destination": {
						"shape": "S36"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteActivation": {
			"input": {
				"type": "structure",
				"required": [
					"ActivationId"
				],
				"members": {
					"ActivationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteAssociation": {
			"input": {
				"type": "structure",
				"members": {
					"Name": {},
					"InstanceId": {},
					"AssociationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteDocument": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteMaintenanceWindow": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId"
				],
				"members": {
					"WindowId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowId": {}
				}
			}
		},
		"DeleteParameter": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteParameters": {
			"input": {
				"type": "structure",
				"required": [
					"Names"
				],
				"members": {
					"Names": {
						"shape": "S3o"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DeletedParameters": {
						"shape": "S3o"
					},
					"InvalidParameters": {
						"shape": "S3o"
					}
				}
			}
		},
		"DeletePatchBaseline": {
			"input": {
				"type": "structure",
				"required": [
					"BaselineId"
				],
				"members": {
					"BaselineId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BaselineId": {}
				}
			}
		},
		"DeleteResourceDataSync": {
			"input": {
				"type": "structure",
				"required": [
					"SyncName"
				],
				"members": {
					"SyncName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeregisterManagedInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeregisterPatchBaselineForPatchGroup": {
			"input": {
				"type": "structure",
				"required": [
					"BaselineId",
					"PatchGroup"
				],
				"members": {
					"BaselineId": {},
					"PatchGroup": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BaselineId": {},
					"PatchGroup": {}
				}
			}
		},
		"DeregisterTargetFromMaintenanceWindow": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId",
					"WindowTargetId"
				],
				"members": {
					"WindowId": {},
					"WindowTargetId": {},
					"Safe": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowId": {},
					"WindowTargetId": {}
				}
			}
		},
		"DeregisterTaskFromMaintenanceWindow": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId",
					"WindowTaskId"
				],
				"members": {
					"WindowId": {},
					"WindowTaskId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowId": {},
					"WindowTaskId": {}
				}
			}
		},
		"DescribeActivations": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FilterKey": {},
								"FilterValues": {
									"type": "list",
									"member": {}
								}
							}
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ActivationList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ActivationId": {},
								"Description": {},
								"DefaultInstanceName": {},
								"IamRole": {},
								"RegistrationLimit": {
									"type": "integer"
								},
								"RegistrationsCount": {
									"type": "integer"
								},
								"ExpirationDate": {
									"type": "timestamp"
								},
								"Expired": {
									"type": "boolean"
								},
								"CreatedDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeAssociation": {
			"input": {
				"type": "structure",
				"members": {
					"Name": {},
					"InstanceId": {},
					"AssociationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AssociationDescription": {
						"shape": "S16"
					}
				}
			}
		},
		"DescribeAutomationExecutions": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Key",
								"Values"
							],
							"members": {
								"Key": {},
								"Values": {
									"type": "list",
									"member": {}
								}
							}
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AutomationExecutionMetadataList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AutomationExecutionId": {},
								"DocumentName": {},
								"DocumentVersion": {},
								"AutomationExecutionStatus": {},
								"ExecutionStartTime": {
									"type": "timestamp"
								},
								"ExecutionEndTime": {
									"type": "timestamp"
								},
								"ExecutedBy": {},
								"LogFile": {},
								"Outputs": {
									"shape": "S4x"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeAvailablePatches": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S52"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Patches": {
						"type": "list",
						"member": {
							"shape": "S5a"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeDocument": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"DocumentVersion": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Document": {
						"shape": "S1u"
					}
				}
			}
		},
		"DescribeDocumentPermission": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"PermissionType"
				],
				"members": {
					"Name": {},
					"PermissionType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AccountIds": {
						"shape": "S5r"
					}
				}
			}
		},
		"DescribeEffectiveInstanceAssociations": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Associations": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AssociationId": {},
								"InstanceId": {},
								"Content": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeEffectivePatchesForPatchBaseline": {
			"input": {
				"type": "structure",
				"required": [
					"BaselineId"
				],
				"members": {
					"BaselineId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"EffectivePatches": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Patch": {
									"shape": "S5a"
								},
								"PatchStatus": {
									"type": "structure",
									"members": {
										"DeploymentStatus": {},
										"ComplianceLevel": {},
										"ApprovalDate": {
											"type": "timestamp"
										}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeInstanceAssociationsStatus": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceAssociationStatusInfos": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"AssociationId": {},
								"Name": {},
								"DocumentVersion": {},
								"InstanceId": {},
								"ExecutionDate": {
									"type": "timestamp"
								},
								"Status": {},
								"DetailedStatus": {},
								"ExecutionSummary": {},
								"ErrorCode": {},
								"OutputUrl": {
									"type": "structure",
									"members": {
										"S3OutputUrl": {
											"type": "structure",
											"members": {
												"OutputUrl": {}
											}
										}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeInstanceInformation": {
			"input": {
				"type": "structure",
				"members": {
					"InstanceInformationFilterList": {
						"type": "list",
						"member": {
							"locationName": "InstanceInformationFilter",
							"type": "structure",
							"required": [
								"key",
								"valueSet"
							],
							"members": {
								"key": {},
								"valueSet": {
									"shape": "S6h"
								}
							}
						}
					},
					"Filters": {
						"type": "list",
						"member": {
							"locationName": "InstanceInformationStringFilter",
							"type": "structure",
							"required": [
								"Key",
								"Values"
							],
							"members": {
								"Key": {},
								"Values": {
									"shape": "S6h"
								}
							}
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceInformationList": {
						"type": "list",
						"member": {
							"locationName": "InstanceInformation",
							"type": "structure",
							"members": {
								"InstanceId": {},
								"PingStatus": {},
								"LastPingDateTime": {
									"type": "timestamp"
								},
								"AgentVersion": {},
								"IsLatestVersion": {
									"type": "boolean"
								},
								"PlatformType": {},
								"PlatformName": {},
								"PlatformVersion": {},
								"ActivationId": {},
								"IamRole": {},
								"RegistrationDate": {
									"type": "timestamp"
								},
								"ResourceType": {},
								"Name": {},
								"IPAddress": {},
								"ComputerName": {},
								"AssociationStatus": {},
								"LastAssociationExecutionDate": {
									"type": "timestamp"
								},
								"LastSuccessfulAssociationExecutionDate": {
									"type": "timestamp"
								},
								"AssociationOverview": {
									"type": "structure",
									"members": {
										"DetailedStatus": {},
										"InstanceAssociationStatusAggregatedCount": {
											"type": "map",
											"key": {},
											"value": {
												"type": "integer"
											}
										}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeInstancePatchStates": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceIds"
				],
				"members": {
					"InstanceIds": {
						"shape": "Sb"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstancePatchStates": {
						"type": "list",
						"member": {
							"shape": "S71"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeInstancePatchStatesForPatchGroup": {
			"input": {
				"type": "structure",
				"required": [
					"PatchGroup"
				],
				"members": {
					"PatchGroup": {},
					"Filters": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Key",
								"Values",
								"Type"
							],
							"members": {
								"Key": {},
								"Values": {
									"type": "list",
									"member": {}
								},
								"Type": {}
							}
						}
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstancePatchStates": {
						"type": "list",
						"member": {
							"shape": "S71"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeInstancePatches": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId"
				],
				"members": {
					"InstanceId": {},
					"Filters": {
						"shape": "S52"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Patches": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Title",
								"KBId",
								"Classification",
								"Severity",
								"State",
								"InstalledTime"
							],
							"members": {
								"Title": {},
								"KBId": {},
								"Classification": {},
								"Severity": {},
								"State": {},
								"InstalledTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMaintenanceWindowExecutionTaskInvocations": {
			"input": {
				"type": "structure",
				"required": [
					"WindowExecutionId",
					"TaskId"
				],
				"members": {
					"WindowExecutionId": {},
					"TaskId": {},
					"Filters": {
						"shape": "S7s"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowExecutionTaskInvocationIdentities": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"WindowExecutionId": {},
								"TaskExecutionId": {},
								"InvocationId": {},
								"ExecutionId": {},
								"TaskType": {},
								"Parameters": {
									"shape": "S84"
								},
								"Status": {},
								"StatusDetails": {},
								"StartTime": {
									"type": "timestamp"
								},
								"EndTime": {
									"type": "timestamp"
								},
								"OwnerInformation": {
									"shape": "S73"
								},
								"WindowTargetId": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMaintenanceWindowExecutionTasks": {
			"input": {
				"type": "structure",
				"required": [
					"WindowExecutionId"
				],
				"members": {
					"WindowExecutionId": {},
					"Filters": {
						"shape": "S7s"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowExecutionTaskIdentities": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"WindowExecutionId": {},
								"TaskExecutionId": {},
								"Status": {},
								"StatusDetails": {},
								"StartTime": {
									"type": "timestamp"
								},
								"EndTime": {
									"type": "timestamp"
								},
								"TaskArn": {},
								"TaskType": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMaintenanceWindowExecutions": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId"
				],
				"members": {
					"WindowId": {},
					"Filters": {
						"shape": "S7s"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowExecutions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"WindowId": {},
								"WindowExecutionId": {},
								"Status": {},
								"StatusDetails": {},
								"StartTime": {
									"type": "timestamp"
								},
								"EndTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMaintenanceWindowTargets": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId"
				],
				"members": {
					"WindowId": {},
					"Filters": {
						"shape": "S7s"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Targets": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"WindowId": {},
								"WindowTargetId": {},
								"ResourceType": {},
								"Targets": {
									"shape": "Su"
								},
								"OwnerInformation": {
									"shape": "S73"
								},
								"Name": {},
								"Description": {
									"shape": "S2d"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMaintenanceWindowTasks": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId"
				],
				"members": {
					"WindowId": {},
					"Filters": {
						"shape": "S7s"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Tasks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"WindowId": {},
								"WindowTaskId": {},
								"TaskArn": {},
								"Type": {},
								"Targets": {
									"shape": "Su"
								},
								"TaskParameters": {
									"shape": "S8q"
								},
								"Priority": {
									"type": "integer"
								},
								"LoggingInfo": {
									"shape": "S8w"
								},
								"ServiceRoleArn": {},
								"MaxConcurrency": {},
								"MaxErrors": {},
								"Name": {},
								"Description": {
									"shape": "S2d"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeMaintenanceWindows": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S7s"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowIdentities": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"WindowId": {},
								"Name": {},
								"Description": {
									"shape": "S2d"
								},
								"Enabled": {
									"type": "boolean"
								},
								"Duration": {
									"type": "integer"
								},
								"Cutoff": {
									"type": "integer"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribeParameters": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Key",
								"Values"
							],
							"members": {
								"Key": {},
								"Values": {
									"type": "list",
									"member": {}
								}
							}
						}
					},
					"ParameterFilters": {
						"shape": "S9b"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Parameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Type": {},
								"KeyId": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"LastModifiedUser": {},
								"Description": {},
								"AllowedPattern": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribePatchBaselines": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "S52"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BaselineIdentities": {
						"type": "list",
						"member": {
							"shape": "S9r"
						}
					},
					"NextToken": {}
				}
			}
		},
		"DescribePatchGroupState": {
			"input": {
				"type": "structure",
				"required": [
					"PatchGroup"
				],
				"members": {
					"PatchGroup": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Instances": {
						"type": "integer"
					},
					"InstancesWithInstalledPatches": {
						"type": "integer"
					},
					"InstancesWithInstalledOtherPatches": {
						"type": "integer"
					},
					"InstancesWithMissingPatches": {
						"type": "integer"
					},
					"InstancesWithFailedPatches": {
						"type": "integer"
					},
					"InstancesWithNotApplicablePatches": {
						"type": "integer"
					}
				}
			}
		},
		"DescribePatchGroups": {
			"input": {
				"type": "structure",
				"members": {
					"MaxResults": {
						"type": "integer"
					},
					"Filters": {
						"shape": "S52"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Mappings": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PatchGroup": {},
								"BaselineIdentity": {
									"shape": "S9r"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"GetAutomationExecution": {
			"input": {
				"type": "structure",
				"required": [
					"AutomationExecutionId"
				],
				"members": {
					"AutomationExecutionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AutomationExecution": {
						"type": "structure",
						"members": {
							"AutomationExecutionId": {},
							"DocumentName": {},
							"DocumentVersion": {},
							"ExecutionStartTime": {
								"type": "timestamp"
							},
							"ExecutionEndTime": {
								"type": "timestamp"
							},
							"AutomationExecutionStatus": {},
							"StepExecutions": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"StepName": {},
										"Action": {},
										"ExecutionStartTime": {
											"type": "timestamp"
										},
										"ExecutionEndTime": {
											"type": "timestamp"
										},
										"StepStatus": {},
										"ResponseCode": {},
										"Inputs": {
											"type": "map",
											"key": {},
											"value": {}
										},
										"Outputs": {
											"shape": "S4x"
										},
										"Response": {},
										"FailureMessage": {},
										"FailureDetails": {
											"type": "structure",
											"members": {
												"FailureStage": {},
												"FailureType": {},
												"Details": {
													"shape": "S4x"
												}
											}
										}
									}
								}
							},
							"Parameters": {
								"shape": "S4x"
							},
							"Outputs": {
								"shape": "S4x"
							},
							"FailureMessage": {}
						}
					}
				}
			}
		},
		"GetCommandInvocation": {
			"input": {
				"type": "structure",
				"required": [
					"CommandId",
					"InstanceId"
				],
				"members": {
					"CommandId": {},
					"InstanceId": {},
					"PluginName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CommandId": {},
					"InstanceId": {},
					"Comment": {},
					"DocumentName": {},
					"PluginName": {},
					"ResponseCode": {
						"type": "integer"
					},
					"ExecutionStartDateTime": {},
					"ExecutionElapsedTime": {},
					"ExecutionEndDateTime": {},
					"Status": {},
					"StatusDetails": {},
					"StandardOutputContent": {},
					"StandardOutputUrl": {},
					"StandardErrorContent": {},
					"StandardErrorUrl": {}
				}
			}
		},
		"GetDefaultPatchBaseline": {
			"input": {
				"type": "structure",
				"members": {
					"OperatingSystem": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BaselineId": {},
					"OperatingSystem": {}
				}
			}
		},
		"GetDeployablePatchSnapshotForInstance": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"SnapshotId"
				],
				"members": {
					"InstanceId": {},
					"SnapshotId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"InstanceId": {},
					"SnapshotId": {},
					"SnapshotDownloadUrl": {},
					"Product": {}
				}
			}
		},
		"GetDocument": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"DocumentVersion": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Name": {},
					"DocumentVersion": {},
					"Content": {},
					"DocumentType": {}
				}
			}
		},
		"GetInventory": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "Sar"
					},
					"ResultAttributes": {
						"type": "list",
						"member": {
							"locationName": "ResultAttribute",
							"type": "structure",
							"required": [
								"TypeName"
							],
							"members": {
								"TypeName": {}
							}
						}
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Entities": {
						"type": "list",
						"member": {
							"locationName": "Entity",
							"type": "structure",
							"members": {
								"Id": {},
								"Data": {
									"type": "map",
									"key": {},
									"value": {
										"type": "structure",
										"required": [
											"TypeName",
											"SchemaVersion",
											"Content"
										],
										"members": {
											"TypeName": {},
											"SchemaVersion": {},
											"CaptureTime": {},
											"ContentHash": {},
											"Content": {
												"shape": "Sba"
											}
										}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"GetInventorySchema": {
			"input": {
				"type": "structure",
				"members": {
					"TypeName": {},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					},
					"SubType": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Schemas": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"TypeName",
								"Attributes"
							],
							"members": {
								"TypeName": {},
								"Version": {},
								"Attributes": {
									"type": "list",
									"member": {
										"locationName": "Attribute",
										"type": "structure",
										"required": [
											"Name",
											"DataType"
										],
										"members": {
											"Name": {},
											"DataType": {}
										}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"GetMaintenanceWindow": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId"
				],
				"members": {
					"WindowId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowId": {},
					"Name": {},
					"Description": {
						"shape": "S2d"
					},
					"Schedule": {},
					"Duration": {
						"type": "integer"
					},
					"Cutoff": {
						"type": "integer"
					},
					"AllowUnassociatedTargets": {
						"type": "boolean"
					},
					"Enabled": {
						"type": "boolean"
					},
					"CreatedDate": {
						"type": "timestamp"
					},
					"ModifiedDate": {
						"type": "timestamp"
					}
				}
			}
		},
		"GetMaintenanceWindowExecution": {
			"input": {
				"type": "structure",
				"required": [
					"WindowExecutionId"
				],
				"members": {
					"WindowExecutionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowExecutionId": {},
					"TaskIds": {
						"type": "list",
						"member": {}
					},
					"Status": {},
					"StatusDetails": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					}
				}
			}
		},
		"GetMaintenanceWindowExecutionTask": {
			"input": {
				"type": "structure",
				"required": [
					"WindowExecutionId",
					"TaskId"
				],
				"members": {
					"WindowExecutionId": {},
					"TaskId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowExecutionId": {},
					"TaskExecutionId": {},
					"TaskArn": {},
					"ServiceRole": {},
					"Type": {},
					"TaskParameters": {
						"type": "list",
						"member": {
							"shape": "S8q"
						},
						"sensitive": true
					},
					"Priority": {
						"type": "integer"
					},
					"MaxConcurrency": {},
					"MaxErrors": {},
					"Status": {},
					"StatusDetails": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					}
				}
			}
		},
		"GetMaintenanceWindowExecutionTaskInvocation": {
			"input": {
				"type": "structure",
				"required": [
					"WindowExecutionId",
					"TaskId",
					"InvocationId"
				],
				"members": {
					"WindowExecutionId": {},
					"TaskId": {},
					"InvocationId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowExecutionId": {},
					"TaskExecutionId": {},
					"InvocationId": {},
					"ExecutionId": {},
					"TaskType": {},
					"Parameters": {
						"shape": "S84"
					},
					"Status": {},
					"StatusDetails": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"OwnerInformation": {
						"shape": "S73"
					},
					"WindowTargetId": {}
				}
			}
		},
		"GetMaintenanceWindowTask": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId",
					"WindowTaskId"
				],
				"members": {
					"WindowId": {},
					"WindowTaskId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowId": {},
					"WindowTaskId": {},
					"Targets": {
						"shape": "Su"
					},
					"TaskArn": {},
					"ServiceRoleArn": {},
					"TaskType": {},
					"TaskParameters": {
						"shape": "S8q"
					},
					"TaskInvocationParameters": {
						"shape": "Sc1"
					},
					"Priority": {
						"type": "integer"
					},
					"MaxConcurrency": {},
					"MaxErrors": {},
					"LoggingInfo": {
						"shape": "S8w"
					},
					"Name": {},
					"Description": {
						"shape": "S2d"
					}
				}
			}
		},
		"GetParameter": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"WithDecryption": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Parameter": {
						"shape": "Scj"
					}
				}
			}
		},
		"GetParameterHistory": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"WithDecryption": {
						"type": "boolean"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Parameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Type": {},
								"KeyId": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"LastModifiedUser": {},
								"Description": {},
								"Value": {},
								"AllowedPattern": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"GetParameters": {
			"input": {
				"type": "structure",
				"required": [
					"Names"
				],
				"members": {
					"Names": {
						"shape": "S3o"
					},
					"WithDecryption": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Parameters": {
						"shape": "Scr"
					},
					"InvalidParameters": {
						"shape": "S3o"
					}
				}
			}
		},
		"GetParametersByPath": {
			"input": {
				"type": "structure",
				"required": [
					"Path"
				],
				"members": {
					"Path": {},
					"Recursive": {
						"type": "boolean"
					},
					"ParameterFilters": {
						"shape": "S9b"
					},
					"WithDecryption": {
						"type": "boolean"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Parameters": {
						"shape": "Scr"
					},
					"NextToken": {}
				}
			}
		},
		"GetPatchBaseline": {
			"input": {
				"type": "structure",
				"required": [
					"BaselineId"
				],
				"members": {
					"BaselineId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BaselineId": {},
					"Name": {},
					"OperatingSystem": {},
					"GlobalFilters": {
						"shape": "S2o"
					},
					"ApprovalRules": {
						"shape": "S2u"
					},
					"ApprovedPatches": {
						"shape": "S2z"
					},
					"ApprovedPatchesComplianceLevel": {},
					"RejectedPatches": {
						"shape": "S2z"
					},
					"PatchGroups": {
						"type": "list",
						"member": {}
					},
					"CreatedDate": {
						"type": "timestamp"
					},
					"ModifiedDate": {
						"type": "timestamp"
					},
					"Description": {}
				}
			}
		},
		"GetPatchBaselineForPatchGroup": {
			"input": {
				"type": "structure",
				"required": [
					"PatchGroup"
				],
				"members": {
					"PatchGroup": {},
					"OperatingSystem": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BaselineId": {},
					"PatchGroup": {},
					"OperatingSystem": {}
				}
			}
		},
		"ListAssociations": {
			"input": {
				"type": "structure",
				"members": {
					"AssociationFilterList": {
						"type": "list",
						"member": {
							"locationName": "AssociationFilter",
							"type": "structure",
							"required": [
								"key",
								"value"
							],
							"members": {
								"key": {},
								"value": {}
							}
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Associations": {
						"type": "list",
						"member": {
							"locationName": "Association",
							"type": "structure",
							"members": {
								"Name": {},
								"InstanceId": {},
								"AssociationId": {},
								"DocumentVersion": {},
								"Targets": {
									"shape": "Su"
								},
								"LastExecutionDate": {
									"type": "timestamp"
								},
								"Overview": {
									"shape": "S1c"
								},
								"ScheduleExpression": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListCommandInvocations": {
			"input": {
				"type": "structure",
				"members": {
					"CommandId": {},
					"InstanceId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"Filters": {
						"shape": "Sda"
					},
					"Details": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CommandInvocations": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"CommandId": {},
								"InstanceId": {},
								"InstanceName": {},
								"Comment": {},
								"DocumentName": {},
								"RequestedDateTime": {
									"type": "timestamp"
								},
								"Status": {},
								"StatusDetails": {},
								"TraceOutput": {},
								"StandardOutputUrl": {},
								"StandardErrorUrl": {},
								"CommandPlugins": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {},
											"Status": {},
											"StatusDetails": {},
											"ResponseCode": {
												"type": "integer"
											},
											"ResponseStartDateTime": {
												"type": "timestamp"
											},
											"ResponseFinishDateTime": {
												"type": "timestamp"
											},
											"Output": {},
											"StandardOutputUrl": {},
											"StandardErrorUrl": {},
											"OutputS3Region": {},
											"OutputS3BucketName": {},
											"OutputS3KeyPrefix": {}
										}
									}
								},
								"ServiceRole": {},
								"NotificationConfig": {
									"shape": "Sc3"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListCommands": {
			"input": {
				"type": "structure",
				"members": {
					"CommandId": {},
					"InstanceId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {},
					"Filters": {
						"shape": "Sda"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Commands": {
						"type": "list",
						"member": {
							"shape": "Sdq"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListComplianceItems": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "Sdw"
					},
					"ResourceIds": {
						"type": "list",
						"member": {}
					},
					"ResourceTypes": {
						"type": "list",
						"member": {}
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ComplianceItems": {
						"type": "list",
						"member": {
							"locationName": "Item",
							"type": "structure",
							"members": {
								"ComplianceType": {},
								"ResourceType": {},
								"ResourceId": {},
								"Id": {},
								"Title": {},
								"Status": {},
								"Severity": {},
								"ExecutionSummary": {
									"shape": "See"
								},
								"Details": {
									"shape": "Seh"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListComplianceSummaries": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "Sdw"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ComplianceSummaryItems": {
						"type": "list",
						"member": {
							"locationName": "Item",
							"type": "structure",
							"members": {
								"ComplianceType": {},
								"CompliantSummary": {
									"shape": "Sem"
								},
								"NonCompliantSummary": {
									"shape": "Sep"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListDocumentVersions": {
			"input": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DocumentVersions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"DocumentVersion": {},
								"CreatedDate": {
									"type": "timestamp"
								},
								"IsDefaultVersion": {
									"type": "boolean"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListDocuments": {
			"input": {
				"type": "structure",
				"members": {
					"DocumentFilterList": {
						"type": "list",
						"member": {
							"locationName": "DocumentFilter",
							"type": "structure",
							"required": [
								"key",
								"value"
							],
							"members": {
								"key": {},
								"value": {}
							}
						}
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DocumentIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "DocumentIdentifier",
							"type": "structure",
							"members": {
								"Name": {},
								"Owner": {},
								"PlatformTypes": {
									"shape": "S28"
								},
								"DocumentVersion": {},
								"DocumentType": {},
								"SchemaVersion": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListInventoryEntries": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"TypeName"
				],
				"members": {
					"InstanceId": {},
					"TypeName": {},
					"Filters": {
						"shape": "Sar"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TypeName": {},
					"InstanceId": {},
					"SchemaVersion": {},
					"CaptureTime": {},
					"Entries": {
						"shape": "Sba"
					},
					"NextToken": {}
				}
			}
		},
		"ListResourceComplianceSummaries": {
			"input": {
				"type": "structure",
				"members": {
					"Filters": {
						"shape": "Sdw"
					},
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceComplianceSummaryItems": {
						"type": "list",
						"member": {
							"locationName": "Item",
							"type": "structure",
							"members": {
								"ComplianceType": {},
								"ResourceType": {},
								"ResourceId": {},
								"Status": {},
								"OverallSeverity": {},
								"ExecutionSummary": {
									"shape": "See"
								},
								"CompliantSummary": {
									"shape": "Sem"
								},
								"NonCompliantSummary": {
									"shape": "Sep"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListResourceDataSync": {
			"input": {
				"type": "structure",
				"members": {
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceDataSyncItems": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"SyncName": {},
								"S3Destination": {
									"shape": "S36"
								},
								"LastSyncTime": {
									"type": "timestamp"
								},
								"LastSuccessfulSyncTime": {
									"type": "timestamp"
								},
								"LastStatus": {},
								"SyncCreatedTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceType",
					"ResourceId"
				],
				"members": {
					"ResourceType": {},
					"ResourceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TagList": {
						"shape": "S4"
					}
				}
			}
		},
		"ModifyDocumentPermission": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"PermissionType"
				],
				"members": {
					"Name": {},
					"PermissionType": {},
					"AccountIdsToAdd": {
						"shape": "S5r"
					},
					"AccountIdsToRemove": {
						"shape": "S5r"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"PutComplianceItems": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"ResourceType",
					"ComplianceType",
					"ExecutionSummary",
					"Items"
				],
				"members": {
					"ResourceId": {},
					"ResourceType": {},
					"ComplianceType": {},
					"ExecutionSummary": {
						"shape": "See"
					},
					"Items": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Severity",
								"Status"
							],
							"members": {
								"Id": {},
								"Title": {},
								"Severity": {},
								"Status": {},
								"Details": {
									"shape": "Seh"
								}
							}
						}
					},
					"ItemContentHash": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"PutInventory": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"Items"
				],
				"members": {
					"InstanceId": {},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Item",
							"type": "structure",
							"required": [
								"TypeName",
								"SchemaVersion",
								"CaptureTime"
							],
							"members": {
								"TypeName": {},
								"SchemaVersion": {},
								"CaptureTime": {},
								"ContentHash": {},
								"Content": {
									"shape": "Sba"
								},
								"Context": {
									"type": "map",
									"key": {},
									"value": {}
								}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"PutParameter": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"Value",
					"Type"
				],
				"members": {
					"Name": {},
					"Description": {},
					"Value": {},
					"Type": {},
					"KeyId": {},
					"Overwrite": {
						"type": "boolean"
					},
					"AllowedPattern": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"RegisterDefaultPatchBaseline": {
			"input": {
				"type": "structure",
				"required": [
					"BaselineId"
				],
				"members": {
					"BaselineId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BaselineId": {}
				}
			}
		},
		"RegisterPatchBaselineForPatchGroup": {
			"input": {
				"type": "structure",
				"required": [
					"BaselineId",
					"PatchGroup"
				],
				"members": {
					"BaselineId": {},
					"PatchGroup": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BaselineId": {},
					"PatchGroup": {}
				}
			}
		},
		"RegisterTargetWithMaintenanceWindow": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId",
					"ResourceType",
					"Targets"
				],
				"members": {
					"WindowId": {},
					"ResourceType": {},
					"Targets": {
						"shape": "Su"
					},
					"OwnerInformation": {
						"shape": "S73"
					},
					"Name": {},
					"Description": {
						"shape": "S2d"
					},
					"ClientToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowTargetId": {}
				}
			}
		},
		"RegisterTaskWithMaintenanceWindow": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId",
					"Targets",
					"TaskArn",
					"ServiceRoleArn",
					"TaskType",
					"MaxConcurrency",
					"MaxErrors"
				],
				"members": {
					"WindowId": {},
					"Targets": {
						"shape": "Su"
					},
					"TaskArn": {},
					"ServiceRoleArn": {},
					"TaskType": {},
					"TaskParameters": {
						"shape": "S8q"
					},
					"TaskInvocationParameters": {
						"shape": "Sc1"
					},
					"Priority": {
						"type": "integer"
					},
					"MaxConcurrency": {},
					"MaxErrors": {},
					"LoggingInfo": {
						"shape": "S8w"
					},
					"Name": {},
					"Description": {
						"shape": "S2d"
					},
					"ClientToken": {
						"idempotencyToken": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowTaskId": {}
				}
			}
		},
		"RemoveTagsFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceType",
					"ResourceId",
					"TagKeys"
				],
				"members": {
					"ResourceType": {},
					"ResourceId": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"SendAutomationSignal": {
			"input": {
				"type": "structure",
				"required": [
					"AutomationExecutionId",
					"SignalType"
				],
				"members": {
					"AutomationExecutionId": {},
					"SignalType": {},
					"Payload": {
						"shape": "S4x"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"SendCommand": {
			"input": {
				"type": "structure",
				"required": [
					"DocumentName"
				],
				"members": {
					"InstanceIds": {
						"shape": "Sb"
					},
					"Targets": {
						"shape": "Su"
					},
					"DocumentName": {},
					"DocumentHash": {},
					"DocumentHashType": {},
					"TimeoutSeconds": {
						"type": "integer"
					},
					"Comment": {},
					"Parameters": {
						"shape": "Sq"
					},
					"OutputS3Region": {},
					"OutputS3BucketName": {},
					"OutputS3KeyPrefix": {},
					"MaxConcurrency": {},
					"MaxErrors": {},
					"ServiceRoleArn": {},
					"NotificationConfig": {
						"shape": "Sc3"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Command": {
						"shape": "Sdq"
					}
				}
			}
		},
		"StartAutomationExecution": {
			"input": {
				"type": "structure",
				"required": [
					"DocumentName"
				],
				"members": {
					"DocumentName": {},
					"DocumentVersion": {},
					"Parameters": {
						"shape": "S4x"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AutomationExecutionId": {}
				}
			}
		},
		"StopAutomationExecution": {
			"input": {
				"type": "structure",
				"required": [
					"AutomationExecutionId"
				],
				"members": {
					"AutomationExecutionId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateAssociation": {
			"input": {
				"type": "structure",
				"required": [
					"AssociationId"
				],
				"members": {
					"AssociationId": {},
					"Parameters": {
						"shape": "Sq"
					},
					"DocumentVersion": {},
					"ScheduleExpression": {},
					"OutputLocation": {
						"shape": "S10"
					},
					"Name": {},
					"Targets": {
						"shape": "Su"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AssociationDescription": {
						"shape": "S16"
					}
				}
			}
		},
		"UpdateAssociationStatus": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"InstanceId",
					"AssociationStatus"
				],
				"members": {
					"Name": {},
					"InstanceId": {},
					"AssociationStatus": {
						"shape": "S18"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AssociationDescription": {
						"shape": "S16"
					}
				}
			}
		},
		"UpdateDocument": {
			"input": {
				"type": "structure",
				"required": [
					"Content",
					"Name"
				],
				"members": {
					"Content": {},
					"Name": {},
					"DocumentVersion": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DocumentDescription": {
						"shape": "S1u"
					}
				}
			}
		},
		"UpdateDocumentDefaultVersion": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"DocumentVersion"
				],
				"members": {
					"Name": {},
					"DocumentVersion": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Description": {
						"type": "structure",
						"members": {
							"Name": {},
							"DefaultVersion": {}
						}
					}
				}
			}
		},
		"UpdateMaintenanceWindow": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId"
				],
				"members": {
					"WindowId": {},
					"Name": {},
					"Description": {
						"shape": "S2d"
					},
					"Schedule": {},
					"Duration": {
						"type": "integer"
					},
					"Cutoff": {
						"type": "integer"
					},
					"AllowUnassociatedTargets": {
						"type": "boolean"
					},
					"Enabled": {
						"type": "boolean"
					},
					"Replace": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowId": {},
					"Name": {},
					"Description": {
						"shape": "S2d"
					},
					"Schedule": {},
					"Duration": {
						"type": "integer"
					},
					"Cutoff": {
						"type": "integer"
					},
					"AllowUnassociatedTargets": {
						"type": "boolean"
					},
					"Enabled": {
						"type": "boolean"
					}
				}
			}
		},
		"UpdateMaintenanceWindowTarget": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId",
					"WindowTargetId"
				],
				"members": {
					"WindowId": {},
					"WindowTargetId": {},
					"Targets": {
						"shape": "Su"
					},
					"OwnerInformation": {
						"shape": "S73"
					},
					"Name": {},
					"Description": {
						"shape": "S2d"
					},
					"Replace": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowId": {},
					"WindowTargetId": {},
					"Targets": {
						"shape": "Su"
					},
					"OwnerInformation": {
						"shape": "S73"
					},
					"Name": {},
					"Description": {
						"shape": "S2d"
					}
				}
			}
		},
		"UpdateMaintenanceWindowTask": {
			"input": {
				"type": "structure",
				"required": [
					"WindowId",
					"WindowTaskId"
				],
				"members": {
					"WindowId": {},
					"WindowTaskId": {},
					"Targets": {
						"shape": "Su"
					},
					"TaskArn": {},
					"ServiceRoleArn": {},
					"TaskParameters": {
						"shape": "S8q"
					},
					"TaskInvocationParameters": {
						"shape": "Sc1"
					},
					"Priority": {
						"type": "integer"
					},
					"MaxConcurrency": {},
					"MaxErrors": {},
					"LoggingInfo": {
						"shape": "S8w"
					},
					"Name": {},
					"Description": {
						"shape": "S2d"
					},
					"Replace": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WindowId": {},
					"WindowTaskId": {},
					"Targets": {
						"shape": "Su"
					},
					"TaskArn": {},
					"ServiceRoleArn": {},
					"TaskParameters": {
						"shape": "S8q"
					},
					"TaskInvocationParameters": {
						"shape": "Sc1"
					},
					"Priority": {
						"type": "integer"
					},
					"MaxConcurrency": {},
					"MaxErrors": {},
					"LoggingInfo": {
						"shape": "S8w"
					},
					"Name": {},
					"Description": {
						"shape": "S2d"
					}
				}
			}
		},
		"UpdateManagedInstanceRole": {
			"input": {
				"type": "structure",
				"required": [
					"InstanceId",
					"IamRole"
				],
				"members": {
					"InstanceId": {},
					"IamRole": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdatePatchBaseline": {
			"input": {
				"type": "structure",
				"required": [
					"BaselineId"
				],
				"members": {
					"BaselineId": {},
					"Name": {},
					"GlobalFilters": {
						"shape": "S2o"
					},
					"ApprovalRules": {
						"shape": "S2u"
					},
					"ApprovedPatches": {
						"shape": "S2z"
					},
					"ApprovedPatchesComplianceLevel": {},
					"RejectedPatches": {
						"shape": "S2z"
					},
					"Description": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"BaselineId": {},
					"Name": {},
					"OperatingSystem": {},
					"GlobalFilters": {
						"shape": "S2o"
					},
					"ApprovalRules": {
						"shape": "S2u"
					},
					"ApprovedPatches": {
						"shape": "S2z"
					},
					"ApprovedPatchesComplianceLevel": {},
					"RejectedPatches": {
						"shape": "S2z"
					},
					"CreatedDate": {
						"type": "timestamp"
					},
					"ModifiedDate": {
						"type": "timestamp"
					},
					"Description": {}
				}
			}
		}
	},
	"shapes": {
		"S4": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"Sb": {
			"type": "list",
			"member": {}
		},
		"Sq": {
			"type": "map",
			"key": {},
			"value": {
				"type": "list",
				"member": {}
			}
		},
		"Su": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Values": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"S10": {
			"type": "structure",
			"members": {
				"S3Location": {
					"type": "structure",
					"members": {
						"OutputS3Region": {},
						"OutputS3BucketName": {},
						"OutputS3KeyPrefix": {}
					}
				}
			}
		},
		"S16": {
			"type": "structure",
			"members": {
				"Name": {},
				"InstanceId": {},
				"Date": {
					"type": "timestamp"
				},
				"LastUpdateAssociationDate": {
					"type": "timestamp"
				},
				"Status": {
					"shape": "S18"
				},
				"Overview": {
					"shape": "S1c"
				},
				"DocumentVersion": {},
				"Parameters": {
					"shape": "Sq"
				},
				"AssociationId": {},
				"Targets": {
					"shape": "Su"
				},
				"ScheduleExpression": {},
				"OutputLocation": {
					"shape": "S10"
				},
				"LastExecutionDate": {
					"type": "timestamp"
				},
				"LastSuccessfulExecutionDate": {
					"type": "timestamp"
				}
			}
		},
		"S18": {
			"type": "structure",
			"required": [
				"Date",
				"Name",
				"Message"
			],
			"members": {
				"Date": {
					"type": "timestamp"
				},
				"Name": {},
				"Message": {},
				"AdditionalInfo": {}
			}
		},
		"S1c": {
			"type": "structure",
			"members": {
				"Status": {},
				"DetailedStatus": {},
				"AssociationStatusAggregatedCount": {
					"type": "map",
					"key": {},
					"value": {
						"type": "integer"
					}
				}
			}
		},
		"S1j": {
			"type": "structure",
			"required": [
				"Name"
			],
			"members": {
				"Name": {},
				"InstanceId": {},
				"Parameters": {
					"shape": "Sq"
				},
				"DocumentVersion": {},
				"Targets": {
					"shape": "Su"
				},
				"ScheduleExpression": {},
				"OutputLocation": {
					"shape": "S10"
				}
			}
		},
		"S1u": {
			"type": "structure",
			"members": {
				"Sha1": {},
				"Hash": {},
				"HashType": {},
				"Name": {},
				"Owner": {},
				"CreatedDate": {
					"type": "timestamp"
				},
				"Status": {},
				"DocumentVersion": {},
				"Description": {},
				"Parameters": {
					"type": "list",
					"member": {
						"locationName": "DocumentParameter",
						"type": "structure",
						"members": {
							"Name": {},
							"Type": {},
							"Description": {},
							"DefaultValue": {}
						}
					}
				},
				"PlatformTypes": {
					"shape": "S28"
				},
				"DocumentType": {},
				"SchemaVersion": {},
				"LatestVersion": {},
				"DefaultVersion": {}
			}
		},
		"S28": {
			"type": "list",
			"member": {
				"locationName": "PlatformType"
			}
		},
		"S2d": {
			"type": "string",
			"sensitive": true
		},
		"S2o": {
			"type": "structure",
			"required": [
				"PatchFilters"
			],
			"members": {
				"PatchFilters": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"Key",
							"Values"
						],
						"members": {
							"Key": {},
							"Values": {
								"type": "list",
								"member": {}
							}
						}
					}
				}
			}
		},
		"S2u": {
			"type": "structure",
			"required": [
				"PatchRules"
			],
			"members": {
				"PatchRules": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"PatchFilterGroup",
							"ApproveAfterDays"
						],
						"members": {
							"PatchFilterGroup": {
								"shape": "S2o"
							},
							"ComplianceLevel": {},
							"ApproveAfterDays": {
								"type": "integer"
							}
						}
					}
				}
			}
		},
		"S2z": {
			"type": "list",
			"member": {}
		},
		"S36": {
			"type": "structure",
			"required": [
				"BucketName",
				"SyncFormat",
				"Region"
			],
			"members": {
				"BucketName": {},
				"Prefix": {},
				"SyncFormat": {},
				"Region": {}
			}
		},
		"S3o": {
			"type": "list",
			"member": {}
		},
		"S4x": {
			"type": "map",
			"key": {},
			"value": {
				"type": "list",
				"member": {}
			}
		},
		"S52": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Values": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"S5a": {
			"type": "structure",
			"members": {
				"Id": {},
				"ReleaseDate": {
					"type": "timestamp"
				},
				"Title": {},
				"Description": {},
				"ContentUrl": {},
				"Vendor": {},
				"ProductFamily": {},
				"Product": {},
				"Classification": {},
				"MsrcSeverity": {},
				"KbNumber": {},
				"MsrcNumber": {},
				"Language": {}
			}
		},
		"S5r": {
			"type": "list",
			"member": {
				"locationName": "AccountId"
			}
		},
		"S6h": {
			"type": "list",
			"member": {
				"locationName": "InstanceInformationFilterValue"
			}
		},
		"S71": {
			"type": "structure",
			"required": [
				"InstanceId",
				"PatchGroup",
				"BaselineId",
				"OperationStartTime",
				"OperationEndTime",
				"Operation"
			],
			"members": {
				"InstanceId": {},
				"PatchGroup": {},
				"BaselineId": {},
				"SnapshotId": {},
				"OwnerInformation": {
					"shape": "S73"
				},
				"InstalledCount": {
					"type": "integer"
				},
				"InstalledOtherCount": {
					"type": "integer"
				},
				"MissingCount": {
					"type": "integer"
				},
				"FailedCount": {
					"type": "integer"
				},
				"NotApplicableCount": {
					"type": "integer"
				},
				"OperationStartTime": {
					"type": "timestamp"
				},
				"OperationEndTime": {
					"type": "timestamp"
				},
				"Operation": {}
			}
		},
		"S73": {
			"type": "string",
			"sensitive": true
		},
		"S7s": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"Key": {},
					"Values": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"S84": {
			"type": "string",
			"sensitive": true
		},
		"S8q": {
			"type": "map",
			"key": {},
			"value": {
				"type": "structure",
				"members": {
					"Values": {
						"type": "list",
						"member": {
							"type": "string",
							"sensitive": true
						},
						"sensitive": true
					}
				},
				"sensitive": true
			},
			"sensitive": true
		},
		"S8w": {
			"type": "structure",
			"required": [
				"S3BucketName",
				"S3Region"
			],
			"members": {
				"S3BucketName": {},
				"S3KeyPrefix": {},
				"S3Region": {}
			}
		},
		"S9b": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {},
					"Option": {},
					"Values": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"S9r": {
			"type": "structure",
			"members": {
				"BaselineId": {},
				"BaselineName": {},
				"OperatingSystem": {},
				"BaselineDescription": {},
				"DefaultBaseline": {
					"type": "boolean"
				}
			}
		},
		"Sar": {
			"type": "list",
			"member": {
				"locationName": "InventoryFilter",
				"type": "structure",
				"required": [
					"Key",
					"Values"
				],
				"members": {
					"Key": {},
					"Values": {
						"type": "list",
						"member": {
							"locationName": "FilterValue"
						}
					},
					"Type": {}
				}
			}
		},
		"Sba": {
			"type": "list",
			"member": {
				"type": "map",
				"key": {},
				"value": {}
			}
		},
		"Sc1": {
			"type": "structure",
			"members": {
				"RunCommand": {
					"type": "structure",
					"members": {
						"Comment": {},
						"DocumentHash": {},
						"DocumentHashType": {},
						"NotificationConfig": {
							"shape": "Sc3"
						},
						"OutputS3BucketName": {},
						"OutputS3KeyPrefix": {},
						"Parameters": {
							"shape": "Sq"
						},
						"ServiceRoleArn": {},
						"TimeoutSeconds": {
							"type": "integer"
						}
					}
				},
				"Automation": {
					"type": "structure",
					"members": {
						"DocumentVersion": {},
						"Parameters": {
							"shape": "S4x"
						}
					}
				},
				"StepFunctions": {
					"type": "structure",
					"members": {
						"Input": {
							"type": "string",
							"sensitive": true
						},
						"Name": {}
					}
				},
				"Lambda": {
					"type": "structure",
					"members": {
						"ClientContext": {},
						"Qualifier": {},
						"Payload": {
							"type": "blob",
							"sensitive": true
						}
					}
				}
			}
		},
		"Sc3": {
			"type": "structure",
			"members": {
				"NotificationArn": {},
				"NotificationEvents": {
					"type": "list",
					"member": {}
				},
				"NotificationType": {}
			}
		},
		"Scj": {
			"type": "structure",
			"members": {
				"Name": {},
				"Type": {},
				"Value": {}
			}
		},
		"Scr": {
			"type": "list",
			"member": {
				"shape": "Scj"
			}
		},
		"Sda": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"key",
					"value"
				],
				"members": {
					"key": {},
					"value": {}
				}
			}
		},
		"Sdq": {
			"type": "structure",
			"members": {
				"CommandId": {},
				"DocumentName": {},
				"Comment": {},
				"ExpiresAfter": {
					"type": "timestamp"
				},
				"Parameters": {
					"shape": "Sq"
				},
				"InstanceIds": {
					"shape": "Sb"
				},
				"Targets": {
					"shape": "Su"
				},
				"RequestedDateTime": {
					"type": "timestamp"
				},
				"Status": {},
				"StatusDetails": {},
				"OutputS3Region": {},
				"OutputS3BucketName": {},
				"OutputS3KeyPrefix": {},
				"MaxConcurrency": {},
				"MaxErrors": {},
				"TargetCount": {
					"type": "integer"
				},
				"CompletedCount": {
					"type": "integer"
				},
				"ErrorCount": {
					"type": "integer"
				},
				"ServiceRole": {},
				"NotificationConfig": {
					"shape": "Sc3"
				}
			}
		},
		"Sdw": {
			"type": "list",
			"member": {
				"locationName": "ComplianceFilter",
				"type": "structure",
				"members": {
					"Key": {},
					"Values": {
						"type": "list",
						"member": {
							"locationName": "FilterValue"
						}
					},
					"Type": {}
				}
			}
		},
		"See": {
			"type": "structure",
			"required": [
				"ExecutionTime"
			],
			"members": {
				"ExecutionTime": {
					"type": "timestamp"
				},
				"ExecutionId": {},
				"ExecutionType": {}
			}
		},
		"Seh": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"Sem": {
			"type": "structure",
			"members": {
				"CompliantCount": {
					"type": "integer"
				},
				"SeveritySummary": {
					"shape": "Seo"
				}
			}
		},
		"Seo": {
			"type": "structure",
			"members": {
				"CriticalCount": {
					"type": "integer"
				},
				"HighCount": {
					"type": "integer"
				},
				"MediumCount": {
					"type": "integer"
				},
				"LowCount": {
					"type": "integer"
				},
				"InformationalCount": {
					"type": "integer"
				},
				"UnspecifiedCount": {
					"type": "integer"
				}
			}
		},
		"Sep": {
			"type": "structure",
			"members": {
				"NonCompliantCount": {
					"type": "integer"
				},
				"SeveritySummary": {
					"shape": "Seo"
				}
			}
		}
	}
};

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeActivations": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ActivationList"
		},
		"DescribeInstanceInformation": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "InstanceInformationList"
		},
		"DescribeParameters": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken"
		},
		"GetParameterHistory": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken"
		},
		"GetParametersByPath": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken"
		},
		"ListAssociations": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Associations"
		},
		"ListCommandInvocations": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "CommandInvocations"
		},
		"ListCommands": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "Commands"
		},
		"ListDocuments": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "DocumentIdentifiers"
		}
	}
};

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['storagegateway'] = {};
AWS.StorageGateway = Service.defineService('storagegateway', ['2013-06-30']);
Object.defineProperty(apiLoader.services['storagegateway'], '2013-06-30', {
  get: function get() {
    var model = __webpack_require__(1732);
    model.paginators = __webpack_require__(1733).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.StorageGateway;


/***/ }),
/* 1732 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2013-06-30",
		"endpointPrefix": "storagegateway",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "AWS Storage Gateway",
		"signatureVersion": "v4",
		"targetPrefix": "StorageGateway_20130630",
		"uid": "storagegateway-2013-06-30"
	},
	"operations": {
		"ActivateGateway": {
			"input": {
				"type": "structure",
				"required": [
					"ActivationKey",
					"GatewayName",
					"GatewayTimezone",
					"GatewayRegion"
				],
				"members": {
					"ActivationKey": {},
					"GatewayName": {},
					"GatewayTimezone": {},
					"GatewayRegion": {},
					"GatewayType": {},
					"TapeDriveType": {},
					"MediumChangerType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"AddCache": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"DiskIds"
				],
				"members": {
					"GatewayARN": {},
					"DiskIds": {
						"shape": "Sc"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"AddTagsToResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceARN",
					"Tags"
				],
				"members": {
					"ResourceARN": {},
					"Tags": {
						"shape": "Sh"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceARN": {}
				}
			}
		},
		"AddUploadBuffer": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"DiskIds"
				],
				"members": {
					"GatewayARN": {},
					"DiskIds": {
						"shape": "Sc"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"AddWorkingStorage": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"DiskIds"
				],
				"members": {
					"GatewayARN": {},
					"DiskIds": {
						"shape": "Sc"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"CancelArchival": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"TapeARN"
				],
				"members": {
					"GatewayARN": {},
					"TapeARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TapeARN": {}
				}
			}
		},
		"CancelRetrieval": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"TapeARN"
				],
				"members": {
					"GatewayARN": {},
					"TapeARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TapeARN": {}
				}
			}
		},
		"CreateCachediSCSIVolume": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"VolumeSizeInBytes",
					"TargetName",
					"NetworkInterfaceId",
					"ClientToken"
				],
				"members": {
					"GatewayARN": {},
					"VolumeSizeInBytes": {
						"type": "long"
					},
					"SnapshotId": {},
					"TargetName": {},
					"SourceVolumeARN": {},
					"NetworkInterfaceId": {},
					"ClientToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumeARN": {},
					"TargetARN": {}
				}
			}
		},
		"CreateNFSFileShare": {
			"input": {
				"type": "structure",
				"required": [
					"ClientToken",
					"GatewayARN",
					"Role",
					"LocationARN"
				],
				"members": {
					"ClientToken": {},
					"NFSFileShareDefaults": {
						"shape": "S15"
					},
					"GatewayARN": {},
					"KMSEncrypted": {
						"type": "boolean"
					},
					"KMSKey": {},
					"Role": {},
					"LocationARN": {},
					"DefaultStorageClass": {},
					"ClientList": {
						"shape": "S1d"
					},
					"Squash": {},
					"ReadOnly": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FileShareARN": {}
				}
			}
		},
		"CreateSnapshot": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeARN",
					"SnapshotDescription"
				],
				"members": {
					"VolumeARN": {},
					"SnapshotDescription": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumeARN": {},
					"SnapshotId": {}
				}
			}
		},
		"CreateSnapshotFromVolumeRecoveryPoint": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeARN",
					"SnapshotDescription"
				],
				"members": {
					"VolumeARN": {},
					"SnapshotDescription": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SnapshotId": {},
					"VolumeARN": {},
					"VolumeRecoveryPointTime": {}
				}
			}
		},
		"CreateStorediSCSIVolume": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"DiskId",
					"PreserveExistingData",
					"TargetName",
					"NetworkInterfaceId"
				],
				"members": {
					"GatewayARN": {},
					"DiskId": {},
					"SnapshotId": {},
					"PreserveExistingData": {
						"type": "boolean"
					},
					"TargetName": {},
					"NetworkInterfaceId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumeARN": {},
					"VolumeSizeInBytes": {
						"type": "long"
					},
					"TargetARN": {}
				}
			}
		},
		"CreateTapeWithBarcode": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"TapeSizeInBytes",
					"TapeBarcode"
				],
				"members": {
					"GatewayARN": {},
					"TapeSizeInBytes": {
						"type": "long"
					},
					"TapeBarcode": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TapeARN": {}
				}
			}
		},
		"CreateTapes": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"TapeSizeInBytes",
					"ClientToken",
					"NumTapesToCreate",
					"TapeBarcodePrefix"
				],
				"members": {
					"GatewayARN": {},
					"TapeSizeInBytes": {
						"type": "long"
					},
					"ClientToken": {},
					"NumTapesToCreate": {
						"type": "integer"
					},
					"TapeBarcodePrefix": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TapeARNs": {
						"shape": "S1z"
					}
				}
			}
		},
		"DeleteBandwidthRateLimit": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"BandwidthType"
				],
				"members": {
					"GatewayARN": {},
					"BandwidthType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"DeleteChapCredentials": {
			"input": {
				"type": "structure",
				"required": [
					"TargetARN",
					"InitiatorName"
				],
				"members": {
					"TargetARN": {},
					"InitiatorName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TargetARN": {},
					"InitiatorName": {}
				}
			}
		},
		"DeleteFileShare": {
			"input": {
				"type": "structure",
				"required": [
					"FileShareARN"
				],
				"members": {
					"FileShareARN": {},
					"ForceDelete": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FileShareARN": {}
				}
			}
		},
		"DeleteGateway": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"DeleteSnapshotSchedule": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeARN"
				],
				"members": {
					"VolumeARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumeARN": {}
				}
			}
		},
		"DeleteTape": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"TapeARN"
				],
				"members": {
					"GatewayARN": {},
					"TapeARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TapeARN": {}
				}
			}
		},
		"DeleteTapeArchive": {
			"input": {
				"type": "structure",
				"required": [
					"TapeARN"
				],
				"members": {
					"TapeARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TapeARN": {}
				}
			}
		},
		"DeleteVolume": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeARN"
				],
				"members": {
					"VolumeARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumeARN": {}
				}
			}
		},
		"DescribeBandwidthRateLimit": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"AverageUploadRateLimitInBitsPerSec": {
						"type": "long"
					},
					"AverageDownloadRateLimitInBitsPerSec": {
						"type": "long"
					}
				}
			}
		},
		"DescribeCache": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"DiskIds": {
						"shape": "Sc"
					},
					"CacheAllocatedInBytes": {
						"type": "long"
					},
					"CacheUsedPercentage": {
						"type": "double"
					},
					"CacheDirtyPercentage": {
						"type": "double"
					},
					"CacheHitPercentage": {
						"type": "double"
					},
					"CacheMissPercentage": {
						"type": "double"
					}
				}
			}
		},
		"DescribeCachediSCSIVolumes": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeARNs"
				],
				"members": {
					"VolumeARNs": {
						"shape": "S2q"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CachediSCSIVolumes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"VolumeARN": {},
								"VolumeId": {},
								"VolumeType": {},
								"VolumeStatus": {},
								"VolumeSizeInBytes": {
									"type": "long"
								},
								"VolumeProgress": {
									"type": "double"
								},
								"SourceSnapshotId": {},
								"VolumeiSCSIAttributes": {
									"shape": "S2y"
								},
								"CreatedDate": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeChapCredentials": {
			"input": {
				"type": "structure",
				"required": [
					"TargetARN"
				],
				"members": {
					"TargetARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChapCredentials": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"TargetARN": {},
								"SecretToAuthenticateInitiator": {},
								"InitiatorName": {},
								"SecretToAuthenticateTarget": {}
							}
						}
					}
				}
			}
		},
		"DescribeGatewayInformation": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"GatewayId": {},
					"GatewayName": {},
					"GatewayTimezone": {},
					"GatewayState": {},
					"GatewayNetworkInterfaces": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Ipv4Address": {},
								"MacAddress": {},
								"Ipv6Address": {}
							}
						}
					},
					"GatewayType": {},
					"NextUpdateAvailabilityDate": {},
					"LastSoftwareUpdate": {}
				}
			}
		},
		"DescribeMaintenanceStartTime": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"HourOfDay": {
						"type": "integer"
					},
					"MinuteOfHour": {
						"type": "integer"
					},
					"DayOfWeek": {
						"type": "integer"
					},
					"Timezone": {}
				}
			}
		},
		"DescribeNFSFileShares": {
			"input": {
				"type": "structure",
				"required": [
					"FileShareARNList"
				],
				"members": {
					"FileShareARNList": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NFSFileShareInfoList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"NFSFileShareDefaults": {
									"shape": "S15"
								},
								"FileShareARN": {},
								"FileShareId": {},
								"FileShareStatus": {},
								"GatewayARN": {},
								"KMSEncrypted": {
									"type": "boolean"
								},
								"KMSKey": {},
								"Path": {},
								"Role": {},
								"LocationARN": {},
								"DefaultStorageClass": {},
								"ClientList": {
									"shape": "S1d"
								},
								"Squash": {},
								"ReadOnly": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		},
		"DescribeSnapshotSchedule": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeARN"
				],
				"members": {
					"VolumeARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumeARN": {},
					"StartAt": {
						"type": "integer"
					},
					"RecurrenceInHours": {
						"type": "integer"
					},
					"Description": {},
					"Timezone": {}
				}
			}
		},
		"DescribeStorediSCSIVolumes": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeARNs"
				],
				"members": {
					"VolumeARNs": {
						"shape": "S2q"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"StorediSCSIVolumes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"VolumeARN": {},
								"VolumeId": {},
								"VolumeType": {},
								"VolumeStatus": {},
								"VolumeSizeInBytes": {
									"type": "long"
								},
								"VolumeProgress": {
									"type": "double"
								},
								"VolumeDiskId": {},
								"SourceSnapshotId": {},
								"PreservedExistingData": {
									"type": "boolean"
								},
								"VolumeiSCSIAttributes": {
									"shape": "S2y"
								},
								"CreatedDate": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			}
		},
		"DescribeTapeArchives": {
			"input": {
				"type": "structure",
				"members": {
					"TapeARNs": {
						"shape": "S1z"
					},
					"Marker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TapeArchives": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"TapeARN": {},
								"TapeBarcode": {},
								"TapeCreatedDate": {
									"type": "timestamp"
								},
								"TapeSizeInBytes": {
									"type": "long"
								},
								"CompletionTime": {
									"type": "timestamp"
								},
								"RetrievedTo": {},
								"TapeStatus": {},
								"TapeUsedInBytes": {
									"type": "long"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeTapeRecoveryPoints": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {},
					"Marker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"TapeRecoveryPointInfos": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"TapeARN": {},
								"TapeRecoveryPointTime": {
									"type": "timestamp"
								},
								"TapeSizeInBytes": {
									"type": "long"
								},
								"TapeStatus": {}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeTapes": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {},
					"TapeARNs": {
						"shape": "S1z"
					},
					"Marker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Tapes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"TapeARN": {},
								"TapeBarcode": {},
								"TapeCreatedDate": {
									"type": "timestamp"
								},
								"TapeSizeInBytes": {
									"type": "long"
								},
								"TapeStatus": {},
								"VTLDevice": {},
								"Progress": {
									"type": "double"
								},
								"TapeUsedInBytes": {
									"type": "long"
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeUploadBuffer": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"DiskIds": {
						"shape": "Sc"
					},
					"UploadBufferUsedInBytes": {
						"type": "long"
					},
					"UploadBufferAllocatedInBytes": {
						"type": "long"
					}
				}
			}
		},
		"DescribeVTLDevices": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {},
					"VTLDeviceARNs": {
						"type": "list",
						"member": {}
					},
					"Marker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"VTLDevices": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"VTLDeviceARN": {},
								"VTLDeviceType": {},
								"VTLDeviceVendor": {},
								"VTLDeviceProductIdentifier": {},
								"DeviceiSCSIAttributes": {
									"type": "structure",
									"members": {
										"TargetARN": {},
										"NetworkInterfaceId": {},
										"NetworkInterfacePort": {
											"type": "integer"
										},
										"ChapEnabled": {
											"type": "boolean"
										}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeWorkingStorage": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"DiskIds": {
						"shape": "Sc"
					},
					"WorkingStorageUsedInBytes": {
						"type": "long"
					},
					"WorkingStorageAllocatedInBytes": {
						"type": "long"
					}
				}
			}
		},
		"DisableGateway": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"ListFileShares": {
			"input": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"Limit": {
						"type": "integer"
					},
					"Marker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Marker": {},
					"NextMarker": {},
					"FileShareInfoList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"FileShareARN": {},
								"FileShareId": {},
								"FileShareStatus": {},
								"GatewayARN": {}
							}
						}
					}
				}
			}
		},
		"ListGateways": {
			"input": {
				"type": "structure",
				"members": {
					"Marker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Gateways": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"GatewayId": {},
								"GatewayARN": {},
								"GatewayType": {},
								"GatewayOperationalState": {},
								"GatewayName": {}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"ListLocalDisks": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"Disks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"DiskId": {},
								"DiskPath": {},
								"DiskNode": {},
								"DiskStatus": {},
								"DiskSizeInBytes": {
									"type": "long"
								},
								"DiskAllocationType": {},
								"DiskAllocationResource": {}
							}
						}
					}
				}
			}
		},
		"ListTagsForResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceARN"
				],
				"members": {
					"ResourceARN": {},
					"Marker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceARN": {},
					"Marker": {},
					"Tags": {
						"shape": "Sh"
					}
				}
			}
		},
		"ListTapes": {
			"input": {
				"type": "structure",
				"members": {
					"TapeARNs": {
						"shape": "S1z"
					},
					"Marker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TapeInfos": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"TapeARN": {},
								"TapeBarcode": {},
								"TapeSizeInBytes": {
									"type": "long"
								},
								"TapeStatus": {},
								"GatewayARN": {}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"ListVolumeInitiators": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeARN"
				],
				"members": {
					"VolumeARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Initiators": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"ListVolumeRecoveryPoints": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"VolumeRecoveryPointInfos": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"VolumeARN": {},
								"VolumeSizeInBytes": {
									"type": "long"
								},
								"VolumeUsageInBytes": {
									"type": "long"
								},
								"VolumeRecoveryPointTime": {}
							}
						}
					}
				}
			}
		},
		"ListVolumes": {
			"input": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"Marker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"Marker": {},
					"VolumeInfos": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"VolumeARN": {},
								"VolumeId": {},
								"GatewayARN": {},
								"GatewayId": {},
								"VolumeType": {},
								"VolumeSizeInBytes": {
									"type": "long"
								}
							}
						}
					}
				}
			}
		},
		"RefreshCache": {
			"input": {
				"type": "structure",
				"required": [
					"FileShareARN"
				],
				"members": {
					"FileShareARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FileShareARN": {}
				}
			}
		},
		"RemoveTagsFromResource": {
			"input": {
				"type": "structure",
				"required": [
					"ResourceARN",
					"TagKeys"
				],
				"members": {
					"ResourceARN": {},
					"TagKeys": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ResourceARN": {}
				}
			}
		},
		"ResetCache": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"RetrieveTapeArchive": {
			"input": {
				"type": "structure",
				"required": [
					"TapeARN",
					"GatewayARN"
				],
				"members": {
					"TapeARN": {},
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TapeARN": {}
				}
			}
		},
		"RetrieveTapeRecoveryPoint": {
			"input": {
				"type": "structure",
				"required": [
					"TapeARN",
					"GatewayARN"
				],
				"members": {
					"TapeARN": {},
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TapeARN": {}
				}
			}
		},
		"SetLocalConsolePassword": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"LocalConsolePassword"
				],
				"members": {
					"GatewayARN": {},
					"LocalConsolePassword": {
						"type": "string",
						"sensitive": true
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"ShutdownGateway": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"StartGateway": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"UpdateBandwidthRateLimit": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {},
					"AverageUploadRateLimitInBitsPerSec": {
						"type": "long"
					},
					"AverageDownloadRateLimitInBitsPerSec": {
						"type": "long"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"UpdateChapCredentials": {
			"input": {
				"type": "structure",
				"required": [
					"TargetARN",
					"SecretToAuthenticateInitiator",
					"InitiatorName"
				],
				"members": {
					"TargetARN": {},
					"SecretToAuthenticateInitiator": {},
					"InitiatorName": {},
					"SecretToAuthenticateTarget": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"TargetARN": {},
					"InitiatorName": {}
				}
			}
		},
		"UpdateGatewayInformation": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {},
					"GatewayName": {},
					"GatewayTimezone": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {},
					"GatewayName": {}
				}
			}
		},
		"UpdateGatewaySoftwareNow": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN"
				],
				"members": {
					"GatewayARN": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"UpdateMaintenanceStartTime": {
			"input": {
				"type": "structure",
				"required": [
					"GatewayARN",
					"HourOfDay",
					"MinuteOfHour",
					"DayOfWeek"
				],
				"members": {
					"GatewayARN": {},
					"HourOfDay": {
						"type": "integer"
					},
					"MinuteOfHour": {
						"type": "integer"
					},
					"DayOfWeek": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"GatewayARN": {}
				}
			}
		},
		"UpdateNFSFileShare": {
			"input": {
				"type": "structure",
				"required": [
					"FileShareARN"
				],
				"members": {
					"FileShareARN": {},
					"KMSEncrypted": {
						"type": "boolean"
					},
					"KMSKey": {},
					"NFSFileShareDefaults": {
						"shape": "S15"
					},
					"DefaultStorageClass": {},
					"ClientList": {
						"shape": "S1d"
					},
					"Squash": {},
					"ReadOnly": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"FileShareARN": {}
				}
			}
		},
		"UpdateSnapshotSchedule": {
			"input": {
				"type": "structure",
				"required": [
					"VolumeARN",
					"StartAt",
					"RecurrenceInHours"
				],
				"members": {
					"VolumeARN": {},
					"StartAt": {
						"type": "integer"
					},
					"RecurrenceInHours": {
						"type": "integer"
					},
					"Description": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VolumeARN": {}
				}
			}
		},
		"UpdateVTLDeviceType": {
			"input": {
				"type": "structure",
				"required": [
					"VTLDeviceARN",
					"DeviceType"
				],
				"members": {
					"VTLDeviceARN": {},
					"DeviceType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"VTLDeviceARN": {}
				}
			}
		}
	},
	"shapes": {
		"Sc": {
			"type": "list",
			"member": {}
		},
		"Sh": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			}
		},
		"S15": {
			"type": "structure",
			"members": {
				"FileMode": {},
				"DirectoryMode": {},
				"GroupId": {
					"type": "long"
				},
				"OwnerId": {
					"type": "long"
				}
			}
		},
		"S1d": {
			"type": "list",
			"member": {}
		},
		"S1z": {
			"type": "list",
			"member": {}
		},
		"S2q": {
			"type": "list",
			"member": {}
		},
		"S2y": {
			"type": "structure",
			"members": {
				"TargetARN": {},
				"NetworkInterfaceId": {},
				"NetworkInterfacePort": {
					"type": "integer"
				},
				"LunNumber": {
					"type": "integer"
				},
				"ChapEnabled": {
					"type": "boolean"
				}
			}
		}
	}
};

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeCachediSCSIVolumes": {
			"result_key": "CachediSCSIVolumes"
		},
		"DescribeStorediSCSIVolumes": {
			"result_key": "StorediSCSIVolumes"
		},
		"DescribeTapeArchives": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "TapeArchives"
		},
		"DescribeTapeRecoveryPoints": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "TapeRecoveryPointInfos"
		},
		"DescribeTapes": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "Tapes"
		},
		"DescribeVTLDevices": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "VTLDevices"
		},
		"ListGateways": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "Gateways"
		},
		"ListLocalDisks": {
			"result_key": "Disks"
		},
		"ListVolumeRecoveryPoints": {
			"result_key": "VolumeRecoveryPointInfos"
		},
		"ListVolumes": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "VolumeInfos"
		}
	}
};

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['waf'] = {};
AWS.WAF = Service.defineService('waf', ['2015-08-24']);
Object.defineProperty(apiLoader.services['waf'], '2015-08-24', {
  get: function get() {
    var model = __webpack_require__(1735);
    model.paginators = __webpack_require__(1736).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.WAF;


/***/ }),
/* 1735 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2015-08-24",
		"endpointPrefix": "waf",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceAbbreviation": "WAF",
		"serviceFullName": "AWS WAF",
		"signatureVersion": "v4",
		"targetPrefix": "AWSWAF_20150824",
		"uid": "waf-2015-08-24"
	},
	"operations": {
		"CreateByteMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"ChangeToken"
				],
				"members": {
					"Name": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ByteMatchSet": {
						"shape": "S5"
					},
					"ChangeToken": {}
				}
			}
		},
		"CreateIPSet": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"ChangeToken"
				],
				"members": {
					"Name": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IPSet": {
						"shape": "Sh"
					},
					"ChangeToken": {}
				}
			}
		},
		"CreateRateBasedRule": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"MetricName",
					"RateKey",
					"RateLimit",
					"ChangeToken"
				],
				"members": {
					"Name": {},
					"MetricName": {},
					"RateKey": {},
					"RateLimit": {
						"type": "long"
					},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Rule": {
						"shape": "Sr"
					},
					"ChangeToken": {}
				}
			}
		},
		"CreateRule": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"MetricName",
					"ChangeToken"
				],
				"members": {
					"Name": {},
					"MetricName": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Rule": {
						"shape": "Sy"
					},
					"ChangeToken": {}
				}
			}
		},
		"CreateSizeConstraintSet": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"ChangeToken"
				],
				"members": {
					"Name": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SizeConstraintSet": {
						"shape": "S11"
					},
					"ChangeToken": {}
				}
			}
		},
		"CreateSqlInjectionMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"ChangeToken"
				],
				"members": {
					"Name": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SqlInjectionMatchSet": {
						"shape": "S18"
					},
					"ChangeToken": {}
				}
			}
		},
		"CreateWebACL": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"MetricName",
					"DefaultAction",
					"ChangeToken"
				],
				"members": {
					"Name": {},
					"MetricName": {},
					"DefaultAction": {
						"shape": "S1c"
					},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WebACL": {
						"shape": "S1f"
					},
					"ChangeToken": {}
				}
			}
		},
		"CreateXssMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"Name",
					"ChangeToken"
				],
				"members": {
					"Name": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"XssMatchSet": {
						"shape": "S1m"
					},
					"ChangeToken": {}
				}
			}
		},
		"DeleteByteMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"ByteMatchSetId",
					"ChangeToken"
				],
				"members": {
					"ByteMatchSetId": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"DeleteIPSet": {
			"input": {
				"type": "structure",
				"required": [
					"IPSetId",
					"ChangeToken"
				],
				"members": {
					"IPSetId": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"DeleteRateBasedRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleId",
					"ChangeToken"
				],
				"members": {
					"RuleId": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"DeleteRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleId",
					"ChangeToken"
				],
				"members": {
					"RuleId": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"DeleteSizeConstraintSet": {
			"input": {
				"type": "structure",
				"required": [
					"SizeConstraintSetId",
					"ChangeToken"
				],
				"members": {
					"SizeConstraintSetId": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"DeleteSqlInjectionMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"SqlInjectionMatchSetId",
					"ChangeToken"
				],
				"members": {
					"SqlInjectionMatchSetId": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"DeleteWebACL": {
			"input": {
				"type": "structure",
				"required": [
					"WebACLId",
					"ChangeToken"
				],
				"members": {
					"WebACLId": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"DeleteXssMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"XssMatchSetId",
					"ChangeToken"
				],
				"members": {
					"XssMatchSetId": {},
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"GetByteMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"ByteMatchSetId"
				],
				"members": {
					"ByteMatchSetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ByteMatchSet": {
						"shape": "S5"
					}
				}
			}
		},
		"GetChangeToken": {
			"input": {
				"type": "structure",
				"members": {}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"GetChangeTokenStatus": {
			"input": {
				"type": "structure",
				"required": [
					"ChangeToken"
				],
				"members": {
					"ChangeToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeTokenStatus": {}
				}
			}
		},
		"GetIPSet": {
			"input": {
				"type": "structure",
				"required": [
					"IPSetId"
				],
				"members": {
					"IPSetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"IPSet": {
						"shape": "Sh"
					}
				}
			}
		},
		"GetRateBasedRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleId"
				],
				"members": {
					"RuleId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Rule": {
						"shape": "Sr"
					}
				}
			}
		},
		"GetRateBasedRuleManagedKeys": {
			"input": {
				"type": "structure",
				"required": [
					"RuleId"
				],
				"members": {
					"RuleId": {},
					"NextMarker": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ManagedKeys": {
						"type": "list",
						"member": {}
					},
					"NextMarker": {}
				}
			}
		},
		"GetRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleId"
				],
				"members": {
					"RuleId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Rule": {
						"shape": "Sy"
					}
				}
			}
		},
		"GetSampledRequests": {
			"input": {
				"type": "structure",
				"required": [
					"WebAclId",
					"RuleId",
					"TimeWindow",
					"MaxItems"
				],
				"members": {
					"WebAclId": {},
					"RuleId": {},
					"TimeWindow": {
						"shape": "S2o"
					},
					"MaxItems": {
						"type": "long"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SampledRequests": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Request",
								"Weight"
							],
							"members": {
								"Request": {
									"type": "structure",
									"members": {
										"ClientIP": {},
										"Country": {},
										"URI": {},
										"Method": {},
										"HTTPVersion": {},
										"Headers": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"Name": {},
													"Value": {}
												}
											}
										}
									}
								},
								"Weight": {
									"type": "long"
								},
								"Timestamp": {
									"type": "timestamp"
								},
								"Action": {}
							}
						}
					},
					"PopulationSize": {
						"type": "long"
					},
					"TimeWindow": {
						"shape": "S2o"
					}
				}
			}
		},
		"GetSizeConstraintSet": {
			"input": {
				"type": "structure",
				"required": [
					"SizeConstraintSetId"
				],
				"members": {
					"SizeConstraintSetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SizeConstraintSet": {
						"shape": "S11"
					}
				}
			}
		},
		"GetSqlInjectionMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"SqlInjectionMatchSetId"
				],
				"members": {
					"SqlInjectionMatchSetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SqlInjectionMatchSet": {
						"shape": "S18"
					}
				}
			}
		},
		"GetWebACL": {
			"input": {
				"type": "structure",
				"required": [
					"WebACLId"
				],
				"members": {
					"WebACLId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"WebACL": {
						"shape": "S1f"
					}
				}
			}
		},
		"GetXssMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"XssMatchSetId"
				],
				"members": {
					"XssMatchSetId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"XssMatchSet": {
						"shape": "S1m"
					}
				}
			}
		},
		"ListByteMatchSets": {
			"input": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"ByteMatchSets": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"ByteMatchSetId",
								"Name"
							],
							"members": {
								"ByteMatchSetId": {},
								"Name": {}
							}
						}
					}
				}
			}
		},
		"ListIPSets": {
			"input": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"IPSets": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"IPSetId",
								"Name"
							],
							"members": {
								"IPSetId": {},
								"Name": {}
							}
						}
					}
				}
			}
		},
		"ListRateBasedRules": {
			"input": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Rules": {
						"shape": "S3q"
					}
				}
			}
		},
		"ListRules": {
			"input": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Rules": {
						"shape": "S3q"
					}
				}
			}
		},
		"ListSizeConstraintSets": {
			"input": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"SizeConstraintSets": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"SizeConstraintSetId",
								"Name"
							],
							"members": {
								"SizeConstraintSetId": {},
								"Name": {}
							}
						}
					}
				}
			}
		},
		"ListSqlInjectionMatchSets": {
			"input": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"SqlInjectionMatchSets": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"SqlInjectionMatchSetId",
								"Name"
							],
							"members": {
								"SqlInjectionMatchSetId": {},
								"Name": {}
							}
						}
					}
				}
			}
		},
		"ListWebACLs": {
			"input": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"WebACLs": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"WebACLId",
								"Name"
							],
							"members": {
								"WebACLId": {},
								"Name": {}
							}
						}
					}
				}
			}
		},
		"ListXssMatchSets": {
			"input": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"Limit": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"NextMarker": {},
					"XssMatchSets": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"XssMatchSetId",
								"Name"
							],
							"members": {
								"XssMatchSetId": {},
								"Name": {}
							}
						}
					}
				}
			}
		},
		"UpdateByteMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"ByteMatchSetId",
					"ChangeToken",
					"Updates"
				],
				"members": {
					"ByteMatchSetId": {},
					"ChangeToken": {},
					"Updates": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Action",
								"ByteMatchTuple"
							],
							"members": {
								"Action": {},
								"ByteMatchTuple": {
									"shape": "S8"
								}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"UpdateIPSet": {
			"input": {
				"type": "structure",
				"required": [
					"IPSetId",
					"ChangeToken",
					"Updates"
				],
				"members": {
					"IPSetId": {},
					"ChangeToken": {},
					"Updates": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Action",
								"IPSetDescriptor"
							],
							"members": {
								"Action": {},
								"IPSetDescriptor": {
									"shape": "Sj"
								}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"UpdateRateBasedRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleId",
					"ChangeToken",
					"Updates",
					"RateLimit"
				],
				"members": {
					"RuleId": {},
					"ChangeToken": {},
					"Updates": {
						"shape": "S4k"
					},
					"RateLimit": {
						"type": "long"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"UpdateRule": {
			"input": {
				"type": "structure",
				"required": [
					"RuleId",
					"ChangeToken",
					"Updates"
				],
				"members": {
					"RuleId": {},
					"ChangeToken": {},
					"Updates": {
						"shape": "S4k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"UpdateSizeConstraintSet": {
			"input": {
				"type": "structure",
				"required": [
					"SizeConstraintSetId",
					"ChangeToken",
					"Updates"
				],
				"members": {
					"SizeConstraintSetId": {},
					"ChangeToken": {},
					"Updates": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Action",
								"SizeConstraint"
							],
							"members": {
								"Action": {},
								"SizeConstraint": {
									"shape": "S13"
								}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"UpdateSqlInjectionMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"SqlInjectionMatchSetId",
					"ChangeToken",
					"Updates"
				],
				"members": {
					"SqlInjectionMatchSetId": {},
					"ChangeToken": {},
					"Updates": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Action",
								"SqlInjectionMatchTuple"
							],
							"members": {
								"Action": {},
								"SqlInjectionMatchTuple": {
									"shape": "S1a"
								}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"UpdateWebACL": {
			"input": {
				"type": "structure",
				"required": [
					"WebACLId",
					"ChangeToken"
				],
				"members": {
					"WebACLId": {},
					"ChangeToken": {},
					"Updates": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Action",
								"ActivatedRule"
							],
							"members": {
								"Action": {},
								"ActivatedRule": {
									"shape": "S1h"
								}
							}
						}
					},
					"DefaultAction": {
						"shape": "S1c"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		},
		"UpdateXssMatchSet": {
			"input": {
				"type": "structure",
				"required": [
					"XssMatchSetId",
					"ChangeToken",
					"Updates"
				],
				"members": {
					"XssMatchSetId": {},
					"ChangeToken": {},
					"Updates": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Action",
								"XssMatchTuple"
							],
							"members": {
								"Action": {},
								"XssMatchTuple": {
									"shape": "S1o"
								}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChangeToken": {}
				}
			}
		}
	},
	"shapes": {
		"S5": {
			"type": "structure",
			"required": [
				"ByteMatchSetId",
				"ByteMatchTuples"
			],
			"members": {
				"ByteMatchSetId": {},
				"Name": {},
				"ByteMatchTuples": {
					"type": "list",
					"member": {
						"shape": "S8"
					}
				}
			}
		},
		"S8": {
			"type": "structure",
			"required": [
				"FieldToMatch",
				"TargetString",
				"TextTransformation",
				"PositionalConstraint"
			],
			"members": {
				"FieldToMatch": {
					"shape": "S9"
				},
				"TargetString": {
					"type": "blob"
				},
				"TextTransformation": {},
				"PositionalConstraint": {}
			}
		},
		"S9": {
			"type": "structure",
			"required": [
				"Type"
			],
			"members": {
				"Type": {},
				"Data": {}
			}
		},
		"Sh": {
			"type": "structure",
			"required": [
				"IPSetId",
				"IPSetDescriptors"
			],
			"members": {
				"IPSetId": {},
				"Name": {},
				"IPSetDescriptors": {
					"type": "list",
					"member": {
						"shape": "Sj"
					}
				}
			}
		},
		"Sj": {
			"type": "structure",
			"required": [
				"Type",
				"Value"
			],
			"members": {
				"Type": {},
				"Value": {}
			}
		},
		"Sr": {
			"type": "structure",
			"required": [
				"RuleId",
				"MatchPredicates",
				"RateKey",
				"RateLimit"
			],
			"members": {
				"RuleId": {},
				"Name": {},
				"MetricName": {},
				"MatchPredicates": {
					"shape": "Ss"
				},
				"RateKey": {},
				"RateLimit": {
					"type": "long"
				}
			}
		},
		"Ss": {
			"type": "list",
			"member": {
				"shape": "St"
			}
		},
		"St": {
			"type": "structure",
			"required": [
				"Negated",
				"Type",
				"DataId"
			],
			"members": {
				"Negated": {
					"type": "boolean"
				},
				"Type": {},
				"DataId": {}
			}
		},
		"Sy": {
			"type": "structure",
			"required": [
				"RuleId",
				"Predicates"
			],
			"members": {
				"RuleId": {},
				"Name": {},
				"MetricName": {},
				"Predicates": {
					"shape": "Ss"
				}
			}
		},
		"S11": {
			"type": "structure",
			"required": [
				"SizeConstraintSetId",
				"SizeConstraints"
			],
			"members": {
				"SizeConstraintSetId": {},
				"Name": {},
				"SizeConstraints": {
					"type": "list",
					"member": {
						"shape": "S13"
					}
				}
			}
		},
		"S13": {
			"type": "structure",
			"required": [
				"FieldToMatch",
				"TextTransformation",
				"ComparisonOperator",
				"Size"
			],
			"members": {
				"FieldToMatch": {
					"shape": "S9"
				},
				"TextTransformation": {},
				"ComparisonOperator": {},
				"Size": {
					"type": "long"
				}
			}
		},
		"S18": {
			"type": "structure",
			"required": [
				"SqlInjectionMatchSetId",
				"SqlInjectionMatchTuples"
			],
			"members": {
				"SqlInjectionMatchSetId": {},
				"Name": {},
				"SqlInjectionMatchTuples": {
					"type": "list",
					"member": {
						"shape": "S1a"
					}
				}
			}
		},
		"S1a": {
			"type": "structure",
			"required": [
				"FieldToMatch",
				"TextTransformation"
			],
			"members": {
				"FieldToMatch": {
					"shape": "S9"
				},
				"TextTransformation": {}
			}
		},
		"S1c": {
			"type": "structure",
			"required": [
				"Type"
			],
			"members": {
				"Type": {}
			}
		},
		"S1f": {
			"type": "structure",
			"required": [
				"WebACLId",
				"DefaultAction",
				"Rules"
			],
			"members": {
				"WebACLId": {},
				"Name": {},
				"MetricName": {},
				"DefaultAction": {
					"shape": "S1c"
				},
				"Rules": {
					"type": "list",
					"member": {
						"shape": "S1h"
					}
				}
			}
		},
		"S1h": {
			"type": "structure",
			"required": [
				"Priority",
				"RuleId",
				"Action"
			],
			"members": {
				"Priority": {
					"type": "integer"
				},
				"RuleId": {},
				"Action": {
					"shape": "S1c"
				},
				"Type": {}
			}
		},
		"S1m": {
			"type": "structure",
			"required": [
				"XssMatchSetId",
				"XssMatchTuples"
			],
			"members": {
				"XssMatchSetId": {},
				"Name": {},
				"XssMatchTuples": {
					"type": "list",
					"member": {
						"shape": "S1o"
					}
				}
			}
		},
		"S1o": {
			"type": "structure",
			"required": [
				"FieldToMatch",
				"TextTransformation"
			],
			"members": {
				"FieldToMatch": {
					"shape": "S9"
				},
				"TextTransformation": {}
			}
		},
		"S2o": {
			"type": "structure",
			"required": [
				"StartTime",
				"EndTime"
			],
			"members": {
				"StartTime": {
					"type": "timestamp"
				},
				"EndTime": {
					"type": "timestamp"
				}
			}
		},
		"S3q": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"RuleId",
					"Name"
				],
				"members": {
					"RuleId": {},
					"Name": {}
				}
			}
		},
		"S4k": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Action",
					"Predicate"
				],
				"members": {
					"Action": {},
					"Predicate": {
						"shape": "St"
					}
				}
			}
		}
	}
};

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {}
};

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(19);
var AWS = __webpack_require__(7);
var Service = AWS.Service;
var apiLoader = AWS.apiLoader;

apiLoader.services['workdocs'] = {};
AWS.WorkDocs = Service.defineService('workdocs', ['2016-05-01']);
Object.defineProperty(apiLoader.services['workdocs'], '2016-05-01', {
  get: function get() {
    var model = __webpack_require__(1738);
    model.paginators = __webpack_require__(1739).pagination;
    return model;
  },
  enumerable: true,
  configurable: true
});

module.exports = AWS.WorkDocs;


/***/ }),
/* 1738 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-05-01",
		"endpointPrefix": "workdocs",
		"jsonVersion": "1.1",
		"protocol": "rest-json",
		"serviceFullName": "Amazon WorkDocs",
		"signatureVersion": "v4",
		"uid": "workdocs-2016-05-01"
	},
	"operations": {
		"AbortDocumentVersionUpload": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					}
				}
			}
		},
		"ActivateUser": {
			"http": {
				"requestUri": "/api/v1/users/{UserId}/activation",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					},
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S8"
					}
				}
			}
		},
		"AddResourcePermissions": {
			"http": {
				"requestUri": "/api/v1/resources/{ResourceId}/permissions",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"Principals"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"Principals": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Id",
								"Type",
								"Role"
							],
							"members": {
								"Id": {},
								"Type": {},
								"Role": {}
							}
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ShareResults": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PrincipalId": {},
								"Role": {},
								"Status": {},
								"ShareId": {},
								"StatusMessage": {
									"type": "string",
									"sensitive": true
								}
							}
						}
					}
				}
			}
		},
		"CreateComment": {
			"http": {
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comment",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId",
					"Text"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"ParentId": {},
					"ThreadId": {},
					"Text": {
						"shape": "Sy"
					},
					"Visibility": {},
					"NotifyCollaborators": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Comment": {
						"shape": "S12"
					}
				}
			}
		},
		"CreateCustomMetadata": {
			"http": {
				"method": "PUT",
				"requestUri": "/api/v1/resources/{ResourceId}/customMetadata",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"CustomMetadata"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionid"
					},
					"CustomMetadata": {
						"shape": "S15"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateFolder": {
			"http": {
				"requestUri": "/api/v1/folders",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"ParentFolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"Name": {},
					"ParentFolderId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S1c"
					}
				}
			}
		},
		"CreateLabels": {
			"http": {
				"method": "PUT",
				"requestUri": "/api/v1/resources/{ResourceId}/labels",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"Labels"
				],
				"members": {
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"Labels": {
						"shape": "S1f"
					},
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"CreateNotificationSubscription": {
			"http": {
				"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"OrganizationId",
					"Endpoint",
					"Protocol",
					"SubscriptionType"
				],
				"members": {
					"OrganizationId": {
						"location": "uri",
						"locationName": "OrganizationId"
					},
					"Endpoint": {},
					"Protocol": {},
					"SubscriptionType": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Subscription": {
						"shape": "S1o"
					}
				}
			}
		},
		"CreateUser": {
			"http": {
				"requestUri": "/api/v1/users",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"Username",
					"GivenName",
					"Surname",
					"Password"
				],
				"members": {
					"OrganizationId": {},
					"Username": {},
					"EmailAddress": {},
					"GivenName": {},
					"Surname": {},
					"Password": {
						"type": "string",
						"sensitive": true
					},
					"TimeZoneId": {},
					"StorageRule": {
						"shape": "Sj"
					},
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S8"
					}
				}
			}
		},
		"DeactivateUser": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/users/{UserId}/activation",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					},
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					}
				}
			}
		},
		"DeleteComment": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comment/{CommentId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId",
					"CommentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"CommentId": {
						"location": "uri",
						"locationName": "CommentId"
					}
				}
			}
		},
		"DeleteCustomMetadata": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/resources/{ResourceId}/customMetadata",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"VersionId": {
						"location": "querystring",
						"locationName": "versionId"
					},
					"Keys": {
						"location": "querystring",
						"locationName": "keys",
						"type": "list",
						"member": {}
					},
					"DeleteAll": {
						"location": "querystring",
						"locationName": "deleteAll",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteDocument": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/documents/{DocumentId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					}
				}
			}
		},
		"DeleteFolder": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/folders/{FolderId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					}
				}
			}
		},
		"DeleteFolderContents": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/folders/{FolderId}/contents",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					}
				}
			}
		},
		"DeleteLabels": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/resources/{ResourceId}/labels",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"Labels": {
						"shape": "S1f",
						"location": "querystring",
						"locationName": "labels"
					},
					"DeleteAll": {
						"location": "querystring",
						"locationName": "deleteAll",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DeleteNotificationSubscription": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"SubscriptionId",
					"OrganizationId"
				],
				"members": {
					"SubscriptionId": {
						"location": "uri",
						"locationName": "SubscriptionId"
					},
					"OrganizationId": {
						"location": "uri",
						"locationName": "OrganizationId"
					}
				}
			}
		},
		"DeleteUser": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/users/{UserId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					}
				}
			}
		},
		"DescribeActivities": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/activities",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"StartTime": {
						"location": "querystring",
						"locationName": "startTime",
						"type": "timestamp"
					},
					"EndTime": {
						"location": "querystring",
						"locationName": "endTime",
						"type": "timestamp"
					},
					"OrganizationId": {
						"location": "querystring",
						"locationName": "organizationId"
					},
					"UserId": {
						"location": "querystring",
						"locationName": "userId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserActivities": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Type": {},
								"TimeStamp": {
									"type": "timestamp"
								},
								"OrganizationId": {},
								"Initiator": {
									"shape": "S2b"
								},
								"Participants": {
									"type": "structure",
									"members": {
										"Users": {
											"type": "list",
											"member": {
												"shape": "S2b"
											}
										},
										"Groups": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"Id": {},
													"Name": {}
												}
											}
										}
									}
								},
								"ResourceMetadata": {
									"shape": "S2h"
								},
								"OriginalParent": {
									"shape": "S2h"
								},
								"CommentMetadata": {
									"type": "structure",
									"members": {
										"CommentId": {},
										"Contributor": {
											"shape": "S8"
										},
										"CreatedTimestamp": {
											"type": "timestamp"
										},
										"CommentStatus": {},
										"RecipientId": {}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeComments": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comments",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Comments": {
						"type": "list",
						"member": {
							"shape": "S12"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeDocumentVersions": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/versions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Include": {
						"location": "querystring",
						"locationName": "include"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DocumentVersions": {
						"type": "list",
						"member": {
							"shape": "S2s"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeFolderContents": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/folders/{FolderId}/contents",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"Sort": {
						"location": "querystring",
						"locationName": "sort"
					},
					"Order": {
						"location": "querystring",
						"locationName": "order"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Type": {
						"location": "querystring",
						"locationName": "type"
					},
					"Include": {
						"location": "querystring",
						"locationName": "include"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Folders": {
						"shape": "S35"
					},
					"Documents": {
						"type": "list",
						"member": {
							"shape": "S37"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeNotificationSubscriptions": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"OrganizationId"
				],
				"members": {
					"OrganizationId": {
						"location": "uri",
						"locationName": "OrganizationId"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Subscriptions": {
						"type": "list",
						"member": {
							"shape": "S1o"
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeResourcePermissions": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/resources/{ResourceId}/permissions",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Principals": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Type": {},
								"Roles": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Role": {},
											"Type": {}
										}
									}
								}
							}
						}
					},
					"Marker": {}
				}
			}
		},
		"DescribeRootFolders": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/me/root",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"AuthenticationToken"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Folders": {
						"shape": "S35"
					},
					"Marker": {}
				}
			}
		},
		"DescribeUsers": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/users",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"OrganizationId": {
						"location": "querystring",
						"locationName": "organizationId"
					},
					"UserIds": {
						"location": "querystring",
						"locationName": "userIds"
					},
					"Query": {
						"location": "querystring",
						"locationName": "query",
						"type": "string",
						"sensitive": true
					},
					"Include": {
						"location": "querystring",
						"locationName": "include"
					},
					"Order": {
						"location": "querystring",
						"locationName": "order"
					},
					"Sort": {
						"location": "querystring",
						"locationName": "sort"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Users": {
						"type": "list",
						"member": {
							"shape": "S8"
						}
					},
					"TotalNumberOfUsers": {
						"type": "long"
					},
					"Marker": {}
				}
			}
		},
		"GetCurrentUser": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/me",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"AuthenticationToken"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S8"
					}
				}
			}
		},
		"GetDocument": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"IncludeCustomMetadata": {
						"location": "querystring",
						"locationName": "includeCustomMetadata",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S37"
					},
					"CustomMetadata": {
						"shape": "S15"
					}
				}
			}
		},
		"GetDocumentPath": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/path",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Path": {
						"shape": "S3x"
					}
				}
			}
		},
		"GetDocumentVersion": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					},
					"IncludeCustomMetadata": {
						"location": "querystring",
						"locationName": "includeCustomMetadata",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S2s"
					},
					"CustomMetadata": {
						"shape": "S15"
					}
				}
			}
		},
		"GetFolder": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/folders/{FolderId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"IncludeCustomMetadata": {
						"location": "querystring",
						"locationName": "includeCustomMetadata",
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S1c"
					},
					"CustomMetadata": {
						"shape": "S15"
					}
				}
			}
		},
		"GetFolderPath": {
			"http": {
				"method": "GET",
				"requestUri": "/api/v1/folders/{FolderId}/path",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"Limit": {
						"location": "querystring",
						"locationName": "limit",
						"type": "integer"
					},
					"Fields": {
						"location": "querystring",
						"locationName": "fields"
					},
					"Marker": {
						"location": "querystring",
						"locationName": "marker"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Path": {
						"shape": "S3x"
					}
				}
			}
		},
		"InitiateDocumentVersionUpload": {
			"http": {
				"requestUri": "/api/v1/documents",
				"responseCode": 201
			},
			"input": {
				"type": "structure",
				"required": [
					"ParentFolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"Id": {},
					"Name": {},
					"ContentCreatedTimestamp": {
						"type": "timestamp"
					},
					"ContentModifiedTimestamp": {
						"type": "timestamp"
					},
					"ContentType": {},
					"DocumentSizeInBytes": {
						"type": "long"
					},
					"ParentFolderId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Metadata": {
						"shape": "S37"
					},
					"UploadMetadata": {
						"type": "structure",
						"members": {
							"UploadUrl": {
								"shape": "S2x"
							},
							"SignedHeaders": {
								"type": "map",
								"key": {},
								"value": {}
							}
						}
					}
				}
			}
		},
		"RemoveAllResourcePermissions": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/resources/{ResourceId}/permissions",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					}
				}
			}
		},
		"RemoveResourcePermission": {
			"http": {
				"method": "DELETE",
				"requestUri": "/api/v1/resources/{ResourceId}/permissions/{PrincipalId}",
				"responseCode": 204
			},
			"input": {
				"type": "structure",
				"required": [
					"ResourceId",
					"PrincipalId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"ResourceId": {
						"location": "uri",
						"locationName": "ResourceId"
					},
					"PrincipalId": {
						"location": "uri",
						"locationName": "PrincipalId"
					},
					"PrincipalType": {
						"location": "querystring",
						"locationName": "type"
					}
				}
			}
		},
		"UpdateDocument": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/documents/{DocumentId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"Name": {},
					"ParentFolderId": {},
					"ResourceState": {}
				}
			}
		},
		"UpdateDocumentVersion": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"DocumentId",
					"VersionId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"DocumentId": {
						"location": "uri",
						"locationName": "DocumentId"
					},
					"VersionId": {
						"location": "uri",
						"locationName": "VersionId"
					},
					"VersionStatus": {}
				}
			}
		},
		"UpdateFolder": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/folders/{FolderId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"FolderId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"FolderId": {
						"location": "uri",
						"locationName": "FolderId"
					},
					"Name": {},
					"ParentFolderId": {},
					"ResourceState": {}
				}
			}
		},
		"UpdateUser": {
			"http": {
				"method": "PATCH",
				"requestUri": "/api/v1/users/{UserId}",
				"responseCode": 200
			},
			"input": {
				"type": "structure",
				"required": [
					"UserId"
				],
				"members": {
					"AuthenticationToken": {
						"shape": "S2",
						"location": "header",
						"locationName": "Authentication"
					},
					"UserId": {
						"location": "uri",
						"locationName": "UserId"
					},
					"GivenName": {},
					"Surname": {},
					"Type": {},
					"StorageRule": {
						"shape": "Sj"
					},
					"TimeZoneId": {},
					"Locale": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "S8"
					}
				}
			}
		}
	},
	"shapes": {
		"S2": {
			"type": "string",
			"sensitive": true
		},
		"S8": {
			"type": "structure",
			"members": {
				"Id": {},
				"Username": {},
				"EmailAddress": {},
				"GivenName": {},
				"Surname": {},
				"OrganizationId": {},
				"RootFolderId": {},
				"RecycleBinFolderId": {},
				"Status": {},
				"Type": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"TimeZoneId": {},
				"Locale": {},
				"Storage": {
					"type": "structure",
					"members": {
						"StorageUtilizedInBytes": {
							"type": "long"
						},
						"StorageRule": {
							"shape": "Sj"
						}
					}
				}
			}
		},
		"Sj": {
			"type": "structure",
			"members": {
				"StorageAllocatedInBytes": {
					"type": "long"
				},
				"StorageType": {}
			}
		},
		"Sy": {
			"type": "string",
			"sensitive": true
		},
		"S12": {
			"type": "structure",
			"required": [
				"CommentId"
			],
			"members": {
				"CommentId": {},
				"ParentId": {},
				"ThreadId": {},
				"Text": {
					"shape": "Sy"
				},
				"Contributor": {
					"shape": "S8"
				},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"Status": {},
				"Visibility": {},
				"RecipientId": {}
			}
		},
		"S15": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1c": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"CreatorId": {},
				"ParentFolderId": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"ResourceState": {},
				"Signature": {},
				"Labels": {
					"shape": "S1f"
				},
				"Size": {
					"type": "long"
				},
				"LatestVersionSize": {
					"type": "long"
				}
			}
		},
		"S1f": {
			"type": "list",
			"member": {}
		},
		"S1o": {
			"type": "structure",
			"members": {
				"SubscriptionId": {},
				"EndPoint": {},
				"Protocol": {}
			}
		},
		"S2b": {
			"type": "structure",
			"members": {
				"Id": {},
				"Username": {},
				"GivenName": {},
				"Surname": {},
				"EmailAddress": {}
			}
		},
		"S2h": {
			"type": "structure",
			"members": {
				"Type": {},
				"Name": {},
				"OriginalName": {},
				"Id": {},
				"VersionId": {},
				"Owner": {
					"shape": "S2b"
				},
				"ParentId": {}
			}
		},
		"S2s": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"ContentType": {},
				"Size": {
					"type": "long"
				},
				"Signature": {},
				"Status": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"ContentCreatedTimestamp": {
					"type": "timestamp"
				},
				"ContentModifiedTimestamp": {
					"type": "timestamp"
				},
				"CreatorId": {},
				"Thumbnail": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S2x"
					}
				},
				"Source": {
					"type": "map",
					"key": {},
					"value": {
						"shape": "S2x"
					}
				}
			}
		},
		"S2x": {
			"type": "string",
			"sensitive": true
		},
		"S35": {
			"type": "list",
			"member": {
				"shape": "S1c"
			}
		},
		"S37": {
			"type": "structure",
			"members": {
				"Id": {},
				"CreatorId": {},
				"ParentFolderId": {},
				"CreatedTimestamp": {
					"type": "timestamp"
				},
				"ModifiedTimestamp": {
					"type": "timestamp"
				},
				"LatestVersionMetadata": {
					"shape": "S2s"
				},
				"ResourceState": {},
				"Labels": {
					"shape": "S1f"
				}
			}
		},
		"S3x": {
			"type": "structure",
			"members": {
				"Components": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"Id": {},
							"Name": {}
						}
					}
				}
			}
		}
	}
};

/***/ }),
/* 1739 */
/***/ (function(module, exports) {

module.exports = {
	"pagination": {
		"DescribeDocumentVersions": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "DocumentVersions"
		},
		"DescribeFolderContents": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": [
				"Folders",
				"Documents"
			]
		},
		"DescribeUsers": {
			"input_token": "Marker",
			"limit_key": "Limit",
			"output_token": "Marker",
			"result_key": "Users"
		}
	}
};

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(816),
    baseEach = __webpack_require__(252),
    castFunction = __webpack_require__(817),
    isArray = __webpack_require__(62);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(252);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _outlookAccessToken = __webpack_require__(332);

var _outlookAccessToken2 = _interopRequireDefault(_outlookAccessToken);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _querystring = __webpack_require__(320);

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _fetch(method, path, query, file, onprogress) {
  var url = _config2.default.graph.graphMeEndpoint + path;
  var body = null;
  if (query) {
    switch (method) {
      case 'GET':
        if (query) url = url + '?' + _querystring2.default.stringify(query);
        break;
    }
  }
  return new Promise(function (resolve, reject) {
    _outlookAccessToken2.default.get(function (microsoftAccess) {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url);

      // xhr.withCredentials = true
      xhr.setRequestHeader('Accept', 'application/json');
      // !file && xhr.setRequestHeader('Content-Type', 'application/json')
      if (microsoftAccess && microsoftAccess.accessToken) {
        xhr.setRequestHeader('Authorization', microsoftAccess.accessToken);
        xhr.setRequestHeader('Prefer', 'outlook.timezone="Asia/Tokyo"');
      }
      xhr.onload = function () {
        try {
          var json = JSON.parse(xhr.responseText);
          if (xhr.status == 200) resolve(json.value);else {
            reject({ error: json.error, status: xhr.status });
          }
        } catch (e) {
          reject({ error: xhr.status == 503 && "error:unavailable" || "error:fetch_error", status: xhr.status });
        }
      };

      xhr.onabort = xhr.ontimeout = xhr.onerror = function () {
        reject({ error: xhr.status == 503 && "error:unavailable" || "error:fetch_error", status: xhr.status });
      };

      if (onprogress) xhr.onprogress = onprogress;

      xhr.send(body);
    });
  });
}
// src/actions/outlook-api.js

exports.default = {
  get: function get(path) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _fetch('GET', path, query);
  }
};

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeDeviceOrientation = changeDeviceOrientation;

// src/actions/device-orientation.js

var CHANGE_DEVICE_ORIENTATION = exports.CHANGE_DEVICE_ORIENTATION = "CHANGE_DEVICE_ORIENTATION";

function changeDeviceOrientation() {
  return {
    type: CHANGE_DEVICE_ORIENTATION
  };
}

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(855);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(252);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(139),
    isArrayLike = __webpack_require__(159),
    keys = __webpack_require__(138);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._fetch = _fetch;

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _core = __webpack_require__(7);

var _core2 = _interopRequireDefault(_core);

var _awsSdk = __webpack_require__(774);

var _awsSdk2 = _interopRequireDefault(_awsSdk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _fetch(method, path, query, file, onprogress) {
  _awsSdk2.default.config.update({
    accessKeyId: _config2.default.aws.accessKeyId,
    secretAccessKey: _config2.default.aws.secretAccessKey,
    region: _config2.default.aws.region
  });

  var body = '';
  if (query) {
    switch (method) {
      case 'POST':
        if (query) {
          body = query.replace(/<a href=".*?".*?>.*?<\/a>/g, '').replace(/<[^>]*?>/g, '').replace(/ ?:emoji-([-0-9a-f]+): ?/ig, '').replace(/(https?:\/\/[^\s]+)/g, '').replace(/\s/g, '');
        }
    }
  }
  var data = JSON.stringify({
    user_message: body
  });
  var httpRequest = new _awsSdk2.default.HttpRequest('' + _config2.default.aws.lambdaEndpoint + path, _awsSdk2.default.config.region);
  httpRequest.method = method;
  httpRequest.headers['host'] = 'tisfiy6gkzs4oobyfaqnkw7t740isdfk.lambda-url.ap-northeast-1.on.aws';
  httpRequest.headers['content-type'] = 'application/json';
  httpRequest.headers['accept'] = 'text/event-stream';
  httpRequest.headers['Lambda-Runtime-Function-Response-Mode'] = 'streaming';
  httpRequest.body = data;
  return fetch(httpRequest.endpoint.href, {
    method: httpRequest.method,
    headers: httpRequest.headers,
    body: httpRequest.body
  });
}

exports.default = {
  get: function get(path) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _fetch('GET', path, query, null);
  },

  post: function post(path) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _fetch('POST', path, query, null);
  },

  put: function put(path) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _fetch('PUT', path, query, null);
  },

  delete: function _delete(path) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return _fetch('DELETE', path, query, null);
  }
};

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduceRight = __webpack_require__(1749),
    baseEachRight = __webpack_require__(1750),
    baseIteratee = __webpack_require__(139),
    baseReduce = __webpack_require__(772),
    isArray = __webpack_require__(62);

/**
 * This method is like `_.reduce` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduce
 * @example
 *
 * var array = [[0, 1], [2, 3], [4, 5]];
 *
 * _.reduceRight(array, function(flattened, other) {
 *   return flattened.concat(other);
 * }, []);
 * // => [4, 5, 2, 3, 0, 1]
 */
function reduceRight(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduceRight : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
}

module.exports = reduceRight;


/***/ }),
/* 1749 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduceRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the last element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduceRight(array, iteratee, accumulator, initAccum) {
  var length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[--length];
  }
  while (length--) {
    accumulator = iteratee(accumulator, array[length], length, array);
  }
  return accumulator;
}

module.exports = arrayReduceRight;


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwnRight = __webpack_require__(1751),
    createBaseEach = __webpack_require__(758);

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach(baseForOwnRight, true);

module.exports = baseEachRight;


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

var baseForRight = __webpack_require__(1752),
    keys = __webpack_require__(138);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

module.exports = baseForOwnRight;


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(757);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

module.exports = baseForRight;


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// src/helpers/run-after-interactions.js

function runAfterInteractions(func) {
  return func();
}

exports.default = runAfterInteractions;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransitionGroup = __webpack_require__(469);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = __webpack_require__(862);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var ReactPropTypesSecret = __webpack_require__(1756);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1757 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(1760);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1762);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1763);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(1764);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(333);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _PropTypes = __webpack_require__(864);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(1761);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(863);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(863);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _class, _temp;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _themrShape = __webpack_require__(1766);

var _themrShape2 = _interopRequireDefault(_themrShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThemeProvider = (_temp = _class = function (_Component) {
  _inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    _classCallCheck(this, ThemeProvider);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    return {
      themr: {
        theme: this.props.theme
      }
    };
  };

  ThemeProvider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return ThemeProvider;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.element.isRequired,
  theme: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  theme: {}
}, _class.childContextTypes = {
  themr: _themrShape2.default.isRequired
}, _temp);
exports.default = ThemeProvider;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.shape({
  theme: _propTypes2.default.object.isRequired
});

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.themeable = themeable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(303);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(77);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @typedef {Object.<string, TReactCSSThemrTheme>} TReactCSSThemrTheme
 */

/**
 * @typedef {{}} TReactCSSThemrOptions
 * @property {String|Boolean} [composeTheme=COMPOSE_DEEPLY]
 */

var COMPOSE_DEEPLY = 'deeply';
var COMPOSE_SOFTLY = 'softly';
var DONT_COMPOSE = false;

var DEFAULT_OPTIONS = {
  composeTheme: COMPOSE_DEEPLY,
  mapThemrProps: defaultMapThemrProps
};

var THEMR_CONFIG = typeof Symbol !== 'undefined' ? Symbol('THEMR_CONFIG') : '__REACT_CSS_THEMR_CONFIG__';

/**
 * Themr decorator
 * @param {String|Number|Symbol} componentName - Component name
 * @param {TReactCSSThemrTheme} [localTheme] - Base theme
 * @param {{}} [options] - Themr options
 * @returns {function(ThemedComponent:Function):Function} - ThemedComponent
 */

exports.default = function (componentName, localTheme) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (ThemedComponent) {
    var _class, _temp;

    var _DEFAULT_OPTIONS$opti = _extends({}, DEFAULT_OPTIONS, options),
        optionComposeTheme = _DEFAULT_OPTIONS$opti.composeTheme,
        optionMapThemrProps = _DEFAULT_OPTIONS$opti.mapThemrProps;

    validateComposeOption(optionComposeTheme);

    var config = ThemedComponent[THEMR_CONFIG];
    if (config && config.componentName === componentName) {
      config.localTheme = themeable(config.localTheme, localTheme);
      return ThemedComponent;
    }

    config = {
      componentName: componentName,
      localTheme: localTheme
    };

    /**
     * @property {{wrappedInstance: *}} refs
     */
    var Themed = (_temp = _class = function (_Component) {
      _inherits(Themed, _Component);

      function Themed() {
        _classCallCheck(this, Themed);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)));

        _this.theme_ = _this.calcTheme(_this.props);
        return _this;
      }

      Themed.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2.default)(true, 'DEPRECATED: To access the wrapped instance, you have to pass ' + '{ innerRef: fn } and retrieve with a callback ref style.');

        return this.refs.wrappedInstance;
      };

      Themed.prototype.getNamespacedTheme = function getNamespacedTheme(props) {
        var themeNamespace = props.themeNamespace,
            theme = props.theme;

        if (!themeNamespace) return theme;
        if (themeNamespace && !theme) throw new Error('Invalid themeNamespace use in react-css-themr. ' + 'themeNamespace prop should be used only with theme prop.');

        return Object.keys(theme).filter(function (key) {
          return key.startsWith(themeNamespace);
        }).reduce(function (result, key) {
          var _extends2;

          return _extends({}, result, (_extends2 = {}, _extends2[removeNamespace(key, themeNamespace)] = theme[key], _extends2));
        }, {});
      };

      Themed.prototype.getThemeNotComposed = function getThemeNotComposed(props) {
        if (props.theme) return this.getNamespacedTheme(props);
        if (config.localTheme) return config.localTheme;
        return this.getContextTheme();
      };

      Themed.prototype.getContextTheme = function getContextTheme() {
        return this.context.themr ? this.context.themr.theme[config.componentName] : {};
      };

      Themed.prototype.getTheme = function getTheme(props) {
        return props.composeTheme === COMPOSE_SOFTLY ? _extends({}, this.getContextTheme(), config.localTheme, this.getNamespacedTheme(props)) : themeable(themeable(this.getContextTheme(), config.localTheme), this.getNamespacedTheme(props));
      };

      Themed.prototype.calcTheme = function calcTheme(props) {
        var composeTheme = props.composeTheme;

        return composeTheme ? this.getTheme(props) : this.getThemeNotComposed(props);
      };

      Themed.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.composeTheme !== this.props.composeTheme || nextProps.theme !== this.props.theme || nextProps.themeNamespace !== this.props.themeNamespace) {
          this.theme_ = this.calcTheme(nextProps);
        }
      };

      Themed.prototype.render = function render() {
        return _react2.default.createElement(ThemedComponent, this.props.mapThemrProps(this.props, this.theme_));
      };

      return Themed;
    }(_react.Component), _class.displayName = 'Themed' + ThemedComponent.name, _class.contextTypes = {
      themr: _propTypes2.default.object
    }, _class.propTypes = _extends({}, ThemedComponent.propTypes, {
      composeTheme: _propTypes2.default.oneOf([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE]),
      innerRef: _propTypes2.default.func,
      theme: _propTypes2.default.object,
      themeNamespace: _propTypes2.default.string,
      mapThemrProps: _propTypes2.default.func
    }), _class.defaultProps = _extends({}, ThemedComponent.defaultProps, {
      composeTheme: optionComposeTheme,
      mapThemrProps: optionMapThemrProps
    }), _temp);


    Themed[THEMR_CONFIG] = config;

    return (0, _hoistNonReactStatics2.default)(Themed, ThemedComponent);
  };
};

/**
 * Merges passed themes by concatenating string keys and processing nested themes
 *
 * @param {...TReactCSSThemrTheme} themes - Themes
 * @returns {TReactCSSThemrTheme} - Resulting theme
 */


function themeable() {
  for (var _len2 = arguments.length, themes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    themes[_key2] = arguments[_key2];
  }

  return themes.reduce(function (acc, theme) {
    return merge(acc, theme);
  }, {});
}

/**
 * @param {TReactCSSThemrTheme} [original] - Original theme
 * @param {TReactCSSThemrTheme} [mixin] - Mixin theme
 * @returns {TReactCSSThemrTheme} - resulting theme
 */
function merge() {
  var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mixin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  //make a copy to avoid mutations of nested objects
  //also strip all functions injected by isomorphic-style-loader
  var result = Object.keys(original).reduce(function (acc, key) {
    var value = original[key];
    if (typeof value !== 'function') {
      acc[key] = value;
    }
    return acc;
  }, {});

  //traverse mixin keys and merge them to resulting theme
  Object.keys(mixin).forEach(function (key) {
    //there's no need to set any defaults here
    var originalValue = result[key];
    var mixinValue = mixin[key];

    switch (typeof mixinValue === 'undefined' ? 'undefined' : _typeof(mixinValue)) {
      case 'object':
        {
          //possibly nested theme object
          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof(originalValue)) {
            case 'object':
              {
                //exactly nested theme object - go recursive
                result[key] = merge(originalValue, mixinValue);
                break;
              }

            case 'undefined':
              {
                //original does not contain this nested key - just take it as is
                result[key] = mixinValue;
                break;
              }

            default:
              {
                //can't merge an object with a non-object
                throw new Error('You are merging object ' + key + ' with a non-object ' + originalValue);
              }
          }
          break;
        }

      case 'undefined': //fallthrough - handles accidentally unset values which may come from props
      case 'function':
        {
          //this handles issue when isomorphic-style-loader addes helper functions to css-module
          break; //just skip
        }

      default:
        {
          //plain values
          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof(originalValue)) {
            case 'object':
              {
                //can't merge a non-object with an object
                throw new Error('You are merging non-object ' + mixinValue + ' with an object ' + key);
              }

            case 'undefined':
              {
                //mixin key is new to original theme - take it as is
                result[key] = mixinValue;
                break;
              }
            case 'function':
              {
                //this handles issue when isomorphic-style-loader addes helper functions to css-module
                break; //just skip
              }

            default:
              {
                //finally we can merge
                result[key] = originalValue.split(' ').concat(mixinValue.split(' ')).filter(function (item, pos, self) {
                  return self.indexOf(item) === pos && item !== '';
                }).join(' ');
                break;
              }
          }
          break;
        }
    }
  });

  return result;
}

/**
 * Validates compose option
 *
 * @param {String|Boolean} composeTheme - Compose them option
 * @throws
 * @returns {undefined}
 */
function validateComposeOption(composeTheme) {
  if ([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE].indexOf(composeTheme) === -1) {
    throw new Error('Invalid composeTheme option for react-css-themr. Valid composition options are ' + COMPOSE_DEEPLY + ', ' + COMPOSE_SOFTLY + ' and ' + DONT_COMPOSE + '. The given option was ' + composeTheme);
  }
}

/**
 * Removes namespace from key
 *
 * @param {String} key - Key
 * @param {String} themeNamespace - Theme namespace
 * @returns {String} - Key
 */
function removeNamespace(key, themeNamespace) {
  var capitalized = key.substr(themeNamespace.length);
  return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
}

/**
 * Maps props and theme to an object that will be used to pass down props to the
 * decorated component.
 *
 * @param {Object} ownProps - All props given to the decorated component
 * @param {Object} theme - Calculated then that should be passed down
 * @returns {Object} - Props that will be passed down to the decorated component
 */
function defaultMapThemrProps(ownProps, theme) {
  var composeTheme = ownProps.composeTheme,
      innerRef = ownProps.innerRef,
      themeNamespace = ownProps.themeNamespace,
      mapThemrProps = ownProps.mapThemrProps,
      rest = _objectWithoutProperties(ownProps, ['composeTheme', 'innerRef', 'themeNamespace', 'mapThemrProps']);

  return _extends({}, rest, {
    ref: innerRef,
    theme: theme
  });
}

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snackbar = exports.snackbarFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _ActivableRenderer = __webpack_require__(470);

var _ActivableRenderer2 = _interopRequireDefault(_ActivableRenderer);

var _Button = __webpack_require__(334);

var _Button2 = _interopRequireDefault(_Button);

var _Portal = __webpack_require__(337);

var _Portal2 = _interopRequireDefault(_Portal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(Button) {
  var Snackbar = function (_Component) {
    _inherits(Snackbar, _Component);

    function Snackbar() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Snackbar);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.scheduleTimeout = function (props) {
        var onTimeout = props.onTimeout,
            timeout = props.timeout;

        if (_this.curTimeout) clearTimeout(_this.curTimeout);
        _this.curTimeout = setTimeout(function () {
          if (onTimeout) onTimeout();
          _this.curTimeout = null;
        }, timeout);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Snackbar, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.active && this.props.timeout) {
          this.scheduleTimeout(this.props);
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.active && nextProps.timeout) {
          this.scheduleTimeout(nextProps);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        clearTimeout(this.curTimeout);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            action = _props.action,
            active = _props.active,
            children = _props.children,
            label = _props.label,
            onClick = _props.onClick,
            theme = _props.theme,
            type = _props.type;

        var className = (0, _classnames3.default)([theme.snackbar, theme[type]], _defineProperty({}, theme.active, active), this.props.className);

        return _react2.default.createElement(
          _Portal2.default,
          { className: theme.portal },
          _react2.default.createElement(
            'div',
            { 'data-react-toolbox': 'snackbar', className: className },
            _react2.default.createElement(
              'span',
              { className: theme.label },
              label,
              children
            ),
            action ? _react2.default.createElement(Button, {
              className: theme.button,
              label: action,
              onClick: onClick
            }) : null
          )
        );
      }
    }]);

    return Snackbar;
  }(_react.Component);

  Snackbar.propTypes = {
    action: _propTypes2.default.string,
    active: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    onClick: _propTypes2.default.func,
    onTimeout: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      accept: _propTypes2.default.string,
      active: _propTypes2.default.string,
      button: _propTypes2.default.string,
      cancel: _propTypes2.default.string,
      label: _propTypes2.default.string,
      snackbar: _propTypes2.default.string,
      warning: _propTypes2.default.string
    }),
    timeout: _propTypes2.default.number,
    type: _propTypes2.default.oneOf(['accept', 'cancel', 'warning'])
  };


  return (0, _ActivableRenderer2.default)()(Snackbar);
};

var Snackbar = factory(_Button2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.SNACKBAR)(Snackbar);
exports.snackbarFactory = factory;
exports.Snackbar = Snackbar;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(335);


/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */
module.exports = _curry2(function dissoc(prop, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  delete result[prop];
  return result;
});


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

var _has = __webpack_require__(867);


module.exports = (function() {
  var toString = Object.prototype.toString;
  return toString.call(arguments) === '[object Arguments]' ?
    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
    function _isArguments(x) { return _has('callee', x); };
}());


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowseButton = exports.browseButtonFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _FontIcon = __webpack_require__(81);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Ripple = __webpack_require__(121);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(ripple, FontIcon) {
  var SimpleBrowseButton = function (_Component) {
    _inherits(SimpleBrowseButton, _Component);

    function SimpleBrowseButton() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, SimpleBrowseButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimpleBrowseButton.__proto__ || Object.getPrototypeOf(SimpleBrowseButton)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
        if (_this.props.primary) return 'primary';
        if (_this.props.accent) return 'accent';
        return 'neutral';
      }, _this.getShape = function () {
        if (_this.props.raised) return 'raised';
        if (_this.props.floating) return 'floating';
        return 'flat';
      }, _this.handleMouseUp = function (event) {
        _this.labelNode.blur();
        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
      }, _this.handleMouseLeave = function (event) {
        _this.labelNode.blur();
        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
      }, _this.handleFileChange = function (event) {
        if (_this.props.onChange) _this.props.onChange(event);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SimpleBrowseButton, [{
      key: 'render',
      value: function render() {
        var _classnames,
            _this2 = this;

        var _props = this.props,
            accent = _props.accent,
            children = _props.children,
            className = _props.className,
            flat = _props.flat,
            floating = _props.floating,
            icon = _props.icon,
            inverse = _props.inverse,
            label = _props.label,
            mini = _props.mini,
            neutral = _props.neutral,
            primary = _props.primary,
            raised = _props.raised,
            theme = _props.theme,
            others = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'flat', 'floating', 'icon', 'inverse', 'label', 'mini', 'neutral', 'primary', 'raised', 'theme']);

        var element = 'label';
        var level = this.getLevel();
        var shape = this.getShape();

        var classes = (0, _classnames3.default)(theme.button, [theme[shape]], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.mini, mini), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);

        var props = _extends({}, others, {
          ref: function ref(node) {
            _this2.labelNode = node;
          },
          className: classes,
          disabled: this.props.disabled,
          onMouseUp: this.handleMouseUp,
          onMouseLeave: this.handleMouseLeave,
          'data-react-toolbox': 'label'
        });

        return _react2.default.createElement(element, props, icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null, _react2.default.createElement(
          'span',
          null,
          label
        ), _react2.default.createElement('input', {
          className: classes,
          type: 'file',
          onChange: this.handleFileChange
        }), children);
      }
    }]);

    return SimpleBrowseButton;
  }(_react.Component);

  SimpleBrowseButton.propTypes = {
    accent: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    flat: _propTypes2.default.bool,
    floating: _propTypes2.default.bool,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    inverse: _propTypes2.default.bool,
    label: _propTypes2.default.string,
    mini: _propTypes2.default.bool,
    neutral: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    onMouseLeave: _propTypes2.default.func,
    onMouseUp: _propTypes2.default.func,
    primary: _propTypes2.default.bool,
    raised: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      accent: _propTypes2.default.string,
      button: _propTypes2.default.string,
      flat: _propTypes2.default.string,
      floating: _propTypes2.default.string,
      icon: _propTypes2.default.string,
      inverse: _propTypes2.default.string,
      mini: _propTypes2.default.string,
      neutral: _propTypes2.default.string,
      primary: _propTypes2.default.string,
      raised: _propTypes2.default.string,
      rippleWrapper: _propTypes2.default.string,
      toggle: _propTypes2.default.string
    }),
    type: _propTypes2.default.string
  };
  SimpleBrowseButton.defaultProps = {
    accent: false,
    className: '',
    flat: false,
    floating: false,
    mini: false,
    neutral: true,
    primary: false,
    raised: false
  };


  return ripple(SimpleBrowseButton);
};

var BrowseButton = factory((0, _Ripple2.default)({ centered: false }), _FontIcon2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(BrowseButton);
exports.browseButtonFactory = factory;
exports.BrowseButton = BrowseButton;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1773);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--rippleWrapper--1rgCVa6u {\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n.theme--ripple--2h1V1x-d {\n  background-color: currentColor;\n  border-radius: 50%;\n  left: 50%;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n  transition-duration: 800ms;\n  z-index: 100\n}\n.theme--ripple--2h1V1x-d.theme--rippleRestarting--3kDLjpnX {\n  opacity: 0.3;\n  transition-property: none;\n}\n.theme--ripple--2h1V1x-d.theme--rippleActive--3F10kJ1V {\n  opacity: 0.3;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n}\n.theme--ripple--2h1V1x-d:not(.theme--rippleActive--3F10kJ1V):not(.theme--rippleRestarting--3kDLjpnX) {\n  opacity: 0;\n  transition-property: opacity, -webkit-transform;\n  transition-property: opacity, transform;\n  transition-property: opacity, transform, -webkit-transform;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/ripple/theme.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,WAAW;CACZ;AACD;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,kCAAkC;UAC1B,0BAA0B;EAClC,2BAA2B;EAC3B,YAAY;CACb;AACD;EACE,aAAa;EACb,0BAA0B;CAC3B;AACD;EACE,aAAa;EACb,uCAAuC;EACvC,+BAA+B;EAC/B,kDAAkD;CACnD;AACD;EACE,WAAW;EACX,gDAAgD;EAChD,wCAAwC;EACxC,2DAA2D;CAC5D","file":"theme.css","sourcesContent":[".rippleWrapper {\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n.ripple {\n  background-color: currentColor;\n  border-radius: 50%;\n  left: 50%;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  -webkit-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n  transition-duration: 800ms;\n  z-index: 100\n}\n.ripple.rippleRestarting {\n  opacity: 0.3;\n  transition-property: none;\n}\n.ripple.rippleActive {\n  opacity: 0.3;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n}\n.ripple:not(.rippleActive):not(.rippleRestarting) {\n  opacity: 0;\n  transition-property: opacity, -webkit-transform;\n  transition-property: opacity, transform;\n  transition-property: opacity, transform, -webkit-transform;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"rippleWrapper": "theme--rippleWrapper--1rgCVa6u",
	"ripple": "theme--ripple--2h1V1x-d",
	"rippleRestarting": "theme--rippleRestarting--3kDLjpnX",
	"rippleActive": "theme--rippleActive--3F10kJ1V"
};

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--button--3Z03UYbr {\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 0;\n  cursor: pointer;\n  display: inline-block;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  font-size: 14px;\n  font-weight: 500;\n  height: 36px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  letter-spacing: 0;\n  line-height: 36px;\n  outline: none;\n  padding: 0;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition:\n    box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1),\n    background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n    color 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--button--3Z03UYbr *,\n    .theme--button--3Z03UYbr *::after,\n    .theme--button--3Z03UYbr *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--button--3Z03UYbr > input {\n  height: 0.1px;\n  margin: 0;\n  opacity: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 0.1px;\n  z-index: 0;\n}\n.theme--button--3Z03UYbr::-moz-focus-inner {\n  border: 0;\n}\n.theme--button--3Z03UYbr > span:not([data-react-toolbox='tooltip']) {\n  display: inline-block;\n  line-height: 36px;\n  vertical-align: middle;\n}\n.theme--button--3Z03UYbr > svg {\n  display: inline-block;\n  fill: currentColor;\n  font-size: 120%;\n  height: 36px;\n  vertical-align: top;\n  width: 1em;\n}\n.theme--button--3Z03UYbr > * {\n  pointer-events: none;\n}\n.theme--button--3Z03UYbr > .theme--rippleWrapper--3K-f63vq {\n  overflow: hidden;\n}\n.theme--button--3Z03UYbr[disabled] {\n  color: rgba(0, 0, 0, 0.26);\n  cursor: auto;\n  pointer-events: none;\n}\n.theme--squared--2EsEFlUi {\n  border-radius: 2px;\n  min-width: 90px;\n  padding: 0 12px\n}\n.theme--squared--2EsEFlUi .theme--icon--3fETU78M {\n  font-size: 120%;\n  margin-right: 6px;\n  vertical-align: middle;\n}\n.theme--squared--2EsEFlUi > svg {\n  margin-right: 5px;\n}\n.theme--solid--3xS832Qq[disabled] {\n  background-color: rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n.theme--solid--3xS832Qq:active {\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n.theme--solid--3xS832Qq:focus:not(:active) {\n  box-shadow:\n      0 0 8px rgba(0, 0, 0, .18),\n      0 8px 16px rgba(0, 0, 0, .36);\n}\n.theme--raised--mn5IWeN_ {\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n.theme--flat--3La9jgHl {\n  background: transparent;\n}\n.theme--floating--2efCJ7Xa {\n  border-radius: 50%;\n  box-shadow:\n    0 1px 1.5px 0 rgba(0, 0, 0, .12),\n    0 1px 1px 0 rgba(0, 0, 0, .24);\n  font-size: 24px;\n  height: 56px;\n  width: 56px\n}\n.theme--floating--2efCJ7Xa .theme--icon--3fETU78M:not([data-react-toolbox='tooltip']) {\n  line-height: 56px;\n}\n.theme--floating--2efCJ7Xa > .theme--rippleWrapper--3K-f63vq {\n  border-radius: 50%;\n}\n.theme--floating--2efCJ7Xa.theme--mini--28aWRK9a {\n  font-size: 17.77778px;\n  height: 40px;\n  width: 40px;\n}\n.theme--floating--2efCJ7Xa.theme--mini--28aWRK9a .theme--icon--3fETU78M {\n  font-size: 17.77778px;\n  line-height: 40px;\n}\n.theme--toggle--3EXj2f1i {\n  background: transparent;\n  border-radius: 50%;\n  vertical-align: middle;\n  width: 36px\n}\n.theme--toggle--3EXj2f1i > .theme--icon--3fETU78M,\n  .theme--toggle--3EXj2f1i svg {\n  font-size: 20px;\n  line-height: 36px;\n  vertical-align: top;\n}\n.theme--toggle--3EXj2f1i > .theme--rippleWrapper--3K-f63vq {\n  border-radius: 50%;\n}\n.theme--primary--1nN7hCEm:not([disabled]).theme--raised--mn5IWeN_,\n  .theme--primary--1nN7hCEm:not([disabled]).theme--floating--2efCJ7Xa {\n  background: rgb(63, 81, 181);\n  color: rgb(255, 255, 255);\n}\n.theme--primary--1nN7hCEm:not([disabled]).theme--flat--3La9jgHl,\n  .theme--primary--1nN7hCEm:not([disabled]).theme--toggle--3EXj2f1i {\n  color: rgb(63, 81, 181);\n}\n.theme--primary--1nN7hCEm:not([disabled]).theme--flat--3La9jgHl:focus:not(:active), .theme--primary--1nN7hCEm:not([disabled]).theme--toggle--3EXj2f1i:focus:not(:active) {\n  background: rgba(63, 81, 181, 0.2);\n}\n.theme--primary--1nN7hCEm:not([disabled]).theme--flat--3La9jgHl:hover {\n  background: rgba(63, 81, 181, 0.2);\n}\n.theme--accent--2u8DdsvP:not([disabled]).theme--raised--mn5IWeN_,\n  .theme--accent--2u8DdsvP:not([disabled]).theme--floating--2efCJ7Xa {\n  background: rgb(255, 64, 129);\n  color: rgb(255, 255, 255);\n}\n.theme--accent--2u8DdsvP:not([disabled]).theme--flat--3La9jgHl,\n  .theme--accent--2u8DdsvP:not([disabled]).theme--toggle--3EXj2f1i {\n  color: rgb(255, 64, 129);\n}\n.theme--accent--2u8DdsvP:not([disabled]).theme--flat--3La9jgHl:focus:not(:active), .theme--accent--2u8DdsvP:not([disabled]).theme--toggle--3EXj2f1i:focus:not(:active) {\n  background: rgba(255, 64, 129, 0.2);\n}\n.theme--accent--2u8DdsvP:not([disabled]).theme--flat--3La9jgHl:hover {\n  background: rgba(255, 64, 129, 0.2);\n}\n.theme--neutral--1GNPg3Jn:not([disabled]).theme--raised--mn5IWeN_,\n  .theme--neutral--1GNPg3Jn:not([disabled]).theme--floating--2efCJ7Xa {\n  background-color: rgb(255, 255, 255);\n  color: rgb(33, 33, 33);\n}\n.theme--neutral--1GNPg3Jn:not([disabled]).theme--flat--3La9jgHl,\n  .theme--neutral--1GNPg3Jn:not([disabled]).theme--toggle--3EXj2f1i {\n  color: rgb(33, 33, 33);\n}\n.theme--neutral--1GNPg3Jn:not([disabled]).theme--flat--3La9jgHl:focus:not(:active), .theme--neutral--1GNPg3Jn:not([disabled]).theme--toggle--3EXj2f1i:focus:not(:active) {\n  background: rgba(33, 33, 33, 0.2);\n}\n.theme--neutral--1GNPg3Jn:not([disabled]).theme--flat--3La9jgHl:hover {\n  background: rgba(33, 33, 33, 0.2);\n}\n.theme--neutral--1GNPg3Jn:not([disabled]).theme--inverse--35dMQbyk.theme--raised--mn5IWeN_,\n    .theme--neutral--1GNPg3Jn:not([disabled]).theme--inverse--35dMQbyk.theme--floating--2efCJ7Xa {\n  background-color: rgb(33, 33, 33);\n  color: rgb(255, 255, 255);\n}\n.theme--neutral--1GNPg3Jn:not([disabled]).theme--inverse--35dMQbyk.theme--flat--3La9jgHl,\n    .theme--neutral--1GNPg3Jn:not([disabled]).theme--inverse--35dMQbyk.theme--toggle--3EXj2f1i {\n  color: rgb(255, 255, 255);\n}\n.theme--neutral--1GNPg3Jn:not([disabled]).theme--inverse--35dMQbyk.theme--flat--3La9jgHl:focus:not(:active), .theme--neutral--1GNPg3Jn:not([disabled]).theme--inverse--35dMQbyk.theme--toggle--3EXj2f1i:focus:not(:active) {\n  background: rgba(33, 33, 33, 0.2);\n}\n.theme--neutral--1GNPg3Jn:not([disabled]).theme--inverse--35dMQbyk.theme--flat--3La9jgHl:hover {\n  background: rgba(33, 33, 33, 0.2);\n}\n.theme--neutral--1GNPg3Jn.theme--inverse--35dMQbyk[disabled] {\n  background-color: rgba(0, 0, 0, 0.08);\n  color: rgba(0, 0, 0, 0.54);\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/button/theme.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;MACvB,sBAAsB;EAC1B,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B;;;4CAG0C;EAC1C,oBAAoB;EACpB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,WAAW;CACZ;AACD;EACE,UAAU;CACX;AACD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;CACxB;AACD;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,WAAW;CACZ;AACD;EACE,qBAAqB;CACtB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,2BAA2B;EAC3B,aAAa;EACb,qBAAqB;CACtB;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;CAChB;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;CACxB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,sCAAsC;EACtC;;mCAEiC;CAClC;AACD;EACE;;mCAEiC;CAClC;AACD;EACE;;oCAEkC;CACnC;AACD;EACE;;mCAEiC;CAIlC;AACD;EACE,wBAAwB;CAGzB;AACD;EACE,mBAAmB;EACnB;;mCAEiC;EAGjC,gBAAgB;EAChB,aAAa;EACb,WAAW;CACZ;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;CACb;AACD;EACE,sBAAsB;EACtB,kBAAkB;CACnB;AACD;EACE,wBAAwB;EACxB,mBAAmB;EAEnB,uBAAuB;EACvB,WAAW;CACZ;AACD;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;;EAEE,6BAA6B;EAC7B,0BAA0B;CAC3B;AACD;;EAEE,wBAAwB;CACzB;AACD;EACE,mCAAmC;CACpC;AACD;EACE,mCAAmC;CACpC;AACD;;EAEE,8BAA8B;EAC9B,0BAA0B;CAC3B;AACD;;EAEE,yBAAyB;CAC1B;AACD;EACE,oCAAoC;CACrC;AACD;EACE,oCAAoC;CACrC;AACD;;EAEE,qCAAqC;EACrC,uBAAuB;CACxB;AACD;;EAEE,uBAAuB;CACxB;AACD;EACE,kCAAkC;CACnC;AACD;EACE,kCAAkC;CACnC;AACD;;EAEE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;;EAEE,0BAA0B;CAC3B;AACD;EACE,kCAAkC;CACnC;AACD;EACE,kCAAkC;CACnC;AACD;EACE,sCAAsC;EACtC,2BAA2B;CAC5B","file":"theme.css","sourcesContent":[".button {\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 0;\n  cursor: pointer;\n  display: inline-block;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  font-size: 14px;\n  font-weight: 500;\n  height: 36px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  letter-spacing: 0;\n  line-height: 36px;\n  outline: none;\n  padding: 0;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition:\n    box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1),\n    background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n    color 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.button *,\n    .button *::after,\n    .button *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.button > input {\n  height: 0.1px;\n  margin: 0;\n  opacity: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 0.1px;\n  z-index: 0;\n}\n.button::-moz-focus-inner {\n  border: 0;\n}\n.button > span:not([data-react-toolbox='tooltip']) {\n  display: inline-block;\n  line-height: 36px;\n  vertical-align: middle;\n}\n.button > svg {\n  display: inline-block;\n  fill: currentColor;\n  font-size: 120%;\n  height: 36px;\n  vertical-align: top;\n  width: 1em;\n}\n.button > * {\n  pointer-events: none;\n}\n.button > .rippleWrapper {\n  overflow: hidden;\n}\n.button[disabled] {\n  color: rgba(0, 0, 0, 0.26);\n  cursor: auto;\n  pointer-events: none;\n}\n.squared {\n  border-radius: 2px;\n  min-width: 90px;\n  padding: 0 12px\n}\n.squared .icon {\n  font-size: 120%;\n  margin-right: 6px;\n  vertical-align: middle;\n}\n.squared > svg {\n  margin-right: 5px;\n}\n.solid[disabled] {\n  background-color: rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n.solid:active {\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n.solid:focus:not(:active) {\n  box-shadow:\n      0 0 8px rgba(0, 0, 0, .18),\n      0 8px 16px rgba(0, 0, 0, .36);\n}\n.raised {\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n  composes: button;\n  composes: squared;\n  composes: solid;\n}\n.flat {\n  background: transparent;\n  composes: button;\n  composes: squared;\n}\n.floating {\n  border-radius: 50%;\n  box-shadow:\n    0 1px 1.5px 0 rgba(0, 0, 0, .12),\n    0 1px 1px 0 rgba(0, 0, 0, .24);\n  composes: button;\n  composes: solid;\n  font-size: 24px;\n  height: 56px;\n  width: 56px\n}\n.floating .icon:not([data-react-toolbox='tooltip']) {\n  line-height: 56px;\n}\n.floating > .rippleWrapper {\n  border-radius: 50%;\n}\n.floating.mini {\n  font-size: 17.77778px;\n  height: 40px;\n  width: 40px;\n}\n.floating.mini .icon {\n  font-size: 17.77778px;\n  line-height: 40px;\n}\n.toggle {\n  background: transparent;\n  border-radius: 50%;\n  composes: button;\n  vertical-align: middle;\n  width: 36px\n}\n.toggle > .icon,\n  .toggle svg {\n  font-size: 20px;\n  line-height: 36px;\n  vertical-align: top;\n}\n.toggle > .rippleWrapper {\n  border-radius: 50%;\n}\n.primary:not([disabled]).raised,\n  .primary:not([disabled]).floating {\n  background: rgb(63, 81, 181);\n  color: rgb(255, 255, 255);\n}\n.primary:not([disabled]).flat,\n  .primary:not([disabled]).toggle {\n  color: rgb(63, 81, 181);\n}\n.primary:not([disabled]).flat:focus:not(:active), .primary:not([disabled]).toggle:focus:not(:active) {\n  background: rgba(63, 81, 181, 0.2);\n}\n.primary:not([disabled]).flat:hover {\n  background: rgba(63, 81, 181, 0.2);\n}\n.accent:not([disabled]).raised,\n  .accent:not([disabled]).floating {\n  background: rgb(255, 64, 129);\n  color: rgb(255, 255, 255);\n}\n.accent:not([disabled]).flat,\n  .accent:not([disabled]).toggle {\n  color: rgb(255, 64, 129);\n}\n.accent:not([disabled]).flat:focus:not(:active), .accent:not([disabled]).toggle:focus:not(:active) {\n  background: rgba(255, 64, 129, 0.2);\n}\n.accent:not([disabled]).flat:hover {\n  background: rgba(255, 64, 129, 0.2);\n}\n.neutral:not([disabled]).raised,\n  .neutral:not([disabled]).floating {\n  background-color: rgb(255, 255, 255);\n  color: rgb(33, 33, 33);\n}\n.neutral:not([disabled]).flat,\n  .neutral:not([disabled]).toggle {\n  color: rgb(33, 33, 33);\n}\n.neutral:not([disabled]).flat:focus:not(:active), .neutral:not([disabled]).toggle:focus:not(:active) {\n  background: rgba(33, 33, 33, 0.2);\n}\n.neutral:not([disabled]).flat:hover {\n  background: rgba(33, 33, 33, 0.2);\n}\n.neutral:not([disabled]).inverse.raised,\n    .neutral:not([disabled]).inverse.floating {\n  background-color: rgb(33, 33, 33);\n  color: rgb(255, 255, 255);\n}\n.neutral:not([disabled]).inverse.flat,\n    .neutral:not([disabled]).inverse.toggle {\n  color: rgb(255, 255, 255);\n}\n.neutral:not([disabled]).inverse.flat:focus:not(:active), .neutral:not([disabled]).inverse.toggle:focus:not(:active) {\n  background: rgba(33, 33, 33, 0.2);\n}\n.neutral:not([disabled]).inverse.flat:hover {\n  background: rgba(33, 33, 33, 0.2);\n}\n.neutral.inverse[disabled] {\n  background-color: rgba(0, 0, 0, 0.08);\n  color: rgba(0, 0, 0, 0.54);\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"button": "theme--button--3Z03UYbr",
	"rippleWrapper": "theme--rippleWrapper--3K-f63vq",
	"squared": "theme--squared--2EsEFlUi",
	"icon": "theme--icon--3fETU78M",
	"solid": "theme--solid--3xS832Qq",
	"raised": "theme--raised--mn5IWeN_ theme--button--3Z03UYbr theme--squared--2EsEFlUi theme--solid--3xS832Qq",
	"flat": "theme--flat--3La9jgHl theme--button--3Z03UYbr theme--squared--2EsEFlUi",
	"floating": "theme--floating--2efCJ7Xa theme--button--3Z03UYbr theme--solid--3xS832Qq",
	"mini": "theme--mini--28aWRK9a",
	"toggle": "theme--toggle--3EXj2f1i theme--button--3Z03UYbr",
	"primary": "theme--primary--1nN7hCEm",
	"accent": "theme--accent--2u8DdsvP",
	"neutral": "theme--neutral--1GNPg3Jn",
	"inverse": "theme--inverse--35dMQbyk"
};

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1776);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--snackbar--2gm4F3sV {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: rgb(33, 33, 33);\n  border-radius: 2px;\n  bottom: 0;\n  color: rgb(255, 255, 255);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  left: 24px;\n  margin: 14px auto 0;\n  padding: 14px 24px;\n  position: fixed;\n  right: 24px;\n  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1) 0.35s;\n  z-index: 200;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--snackbar--2gm4F3sV *,\n    .theme--snackbar--2gm4F3sV *::after,\n    .theme--snackbar--2gm4F3sV *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--snackbar--2gm4F3sV.theme--accept--3YVJuj4_ .theme--button--3V_K9k6L {\n  color: rgb(76, 175, 80);\n}\n.theme--snackbar--2gm4F3sV.theme--warning--2ZxfE_GJ .theme--button--3V_K9k6L {\n  color: rgb(238, 255, 65);\n}\n.theme--snackbar--2gm4F3sV.theme--cancel--2XLtYEaf .theme--button--3V_K9k6L {\n  color: rgb(244, 67, 54);\n}\n.theme--snackbar--2gm4F3sV:not(.theme--active--17WGOlU6) {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}\n.theme--snackbar--2gm4F3sV.theme--active--17WGOlU6 {\n  -webkit-transform: translateY(0%);\n          transform: translateY(0%);\n}\n.theme--label--3-NAhvOu {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  font-size: 14px;\n}\n.theme--button--3V_K9k6L {\n  margin:\n    -7px     -12px     -7px     48px;\n  min-width: inherit;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/snackbar/theme.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,kCAAkC;EAClC,mBAAmB;EACnB,UAAU;EACV,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yDAAyD;EACzD,aAAa;EACb,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,wBAAwB;CACzB;AACD;EACE,yBAAyB;CAC1B;AACD;EACE,wBAAwB;CACzB;AACD;EACE,oCAAoC;UAC5B,4BAA4B;CACrC;AACD;EACE,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;EACrB,gBAAgB;CACjB;AACD;EACE;qCACmC;EACnC,mBAAmB;CACpB","file":"theme.css","sourcesContent":[".snackbar {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: rgb(33, 33, 33);\n  border-radius: 2px;\n  bottom: 0;\n  color: rgb(255, 255, 255);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  left: 24px;\n  margin: 14px auto 0;\n  padding: 14px 24px;\n  position: fixed;\n  right: 24px;\n  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1) 0.35s;\n  z-index: 200;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.snackbar *,\n    .snackbar *::after,\n    .snackbar *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.snackbar.accept .button {\n  color: rgb(76, 175, 80);\n}\n.snackbar.warning .button {\n  color: rgb(238, 255, 65);\n}\n.snackbar.cancel .button {\n  color: rgb(244, 67, 54);\n}\n.snackbar:not(.active) {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}\n.snackbar.active {\n  -webkit-transform: translateY(0%);\n          transform: translateY(0%);\n}\n.label {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  font-size: 14px;\n}\n.button {\n  margin:\n    -7px     -12px     -7px     48px;\n  min-width: inherit;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"snackbar": "theme--snackbar--2gm4F3sV",
	"accept": "theme--accept--3YVJuj4_",
	"button": "theme--button--3V_K9k6L",
	"warning": "theme--warning--2ZxfE_GJ",
	"cancel": "theme--cancel--2XLtYEaf",
	"active": "theme--active--17WGOlU6",
	"label": "theme--label--3-NAhvOu"
};

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1778);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./snackbar.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./snackbar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/* トースト表示ポジションが右上の場合  */\n.snackbar--snackbar--30rJigZI.snackbar--active--CfL3m7Oj {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: snackbar--fadeup--11HH9maL 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: snackbar--fadeup--11HH9maL 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n/* トースト表示ポジションが左上の場合  */\n/* .snackbar.active {\n  top: 20px;\n  bottom: unset;\n  width: 35%;\n  right: auto;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n} */\n/* トースト表示ポジションが右下の場合  */\n/* .snackbar.active {\n  top: unset;\n  bottom: 20px;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n} */\n/* トースト表示ポジションが左下の場合  */\n/* .snackbar.active {\n  top: unset;\n  bottom: 20px;\n  width: 35%;\n  right: auto;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n} */\n/*トーストメッセージが右側の場合　上と下のポジションを変更する時はtopとbottomの値を入れ替える*/\n.snackbar--snackbar--30rJigZI:not(.snackbar--active--CfL3m7Oj) {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: snackbar--fadeout--1W5r5NER 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: snackbar--fadeout--1W5r5NER 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n/*トーストメッセージが左側の場合　right: autoを設定した後、上と下のポジションを変更する時はtopとbottomの値を入れ替える*/\n/* .snackbar:not(.active) {\n  top: 20px;\n  bottom: unset;\n  width: 35%;\n  right: auto;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  animation: fadeout 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n} */\n.snackbar--snackbar--30rJigZI[class~=successToastify].snackbar--active--CfL3m7Oj {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: snackbar--fadeup--11HH9maL 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: snackbar--fadeup--11HH9maL 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n.snackbar--snackbar--30rJigZI[class~=successToastify]:not(.snackbar--active--CfL3m7Oj) {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: snackbar--fadeout--1W5r5NER 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: snackbar--fadeout--1W5r5NER 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n.snackbar--snackbar--30rJigZI[class~=errorToastify].snackbar--active--CfL3m7Oj {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #FE6301;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: snackbar--fadeup--11HH9maL 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: snackbar--fadeup--11HH9maL 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n.snackbar--snackbar--30rJigZI[class~=errorToastify]:not(.snackbar--active--CfL3m7Oj) {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #FE6301;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: snackbar--fadeout--1W5r5NER 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: snackbar--fadeout--1W5r5NER 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n[class~=successToastify] > .snackbar--button--5xju2U6x {\n  margin: -7px -12px -7px 10px;\n}\n[class~=errorToastify] > .snackbar--button--5xju2U6x {\n  margin: -7px -12px -7px 10px;\n}\n[class~=toast_Content]{\n  color: black;\n  font-weight:  bold;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 16px;\n}\n[class~=check_circle]{\n  color: black;\n  font-weight:  bold;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n[class~=check_circle] > [data-react-toolbox='font-icon'] {\n  vertical-align: bottom;\n  margin-right: 10px;\n  color: rgb(91, 184, 92);\n}\n[class~=error_info] {\n  color: black;\n  font-weight:  bold;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n[class~=error_info] > [data-react-toolbox='font-icon'] {\n  vertical-align: bottom;\n  margin-right: 10px;\n  color: #e74c3c;\n}\n[class~=toastImg]{\n  width: 45px; \n  height: 45px; \n  vertical-align: bottom;\n  margin-right: 20px;\n}\n[class~=closeIcon] > [data-react-toolbox='font-icon']{\n  margin-top: 5px;\n  color: #212121;\n}\n@-webkit-keyframes snackbar--fadeup--11HH9maL {\n  0% {\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n    opacity: 0;\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n@keyframes snackbar--fadeup--11HH9maL {\n  0% {\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n    opacity: 0;\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n@-webkit-keyframes snackbar--fadeout--1W5r5NER {\n  0% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n    opacity: 1;\n  }\n  80% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n  }\n}\n@keyframes snackbar--fadeout--1W5r5NER {\n  0% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n    opacity: 1;\n  }\n  80% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n  }\n}\n/* スマートフォン用スタイル */\n@media screen and (max-width: 768px) {\n  .snackbar--snackbar--30rJigZI.snackbar--active--CfL3m7Oj,\n  .snackbar--snackbar--30rJigZI[class~=successToastify].snackbar--active--CfL3m7Oj,\n  .snackbar--snackbar--30rJigZI[class~=errorToastify].snackbar--active--CfL3m7Oj {\n    width: 90%;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n\n  [class~=toast_Content] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    min-height: 45px;\n    font-size: 14px;\n    line-height: 1.4;\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n  }\n\n  [class~=toastImg] {\n    width: 35px;\n    height: 35px;\n    min-width: 35px;\n    margin-right: 10px;\n  }\n\n  [class~=closeIcon] {\n    padding: 8px;\n    margin-left: 8px;\n  }\n}\n@keyframes snackbar--fadeup--11HH9maL {\n  0% {\n    -webkit-transform: translateY(20px);\n            transform: translateY(20px);\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n  }\n}\n@keyframes snackbar--fadeout--1W5r5NER {\n  0% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(20px);\n            transform: translateY(20px);\n  }\n}\n/* この記述はトーストの位置が左側で表示する時に使用 */\n/* @keyframes fadeup {\n  0% {\n    transform: translateX(-200px);\n    opacity: 0;\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeout {\n  0% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n  80% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-200px);\n  }\n\n} */", "", {"version":3,"sources":["/./src/web/components/themes/snackbar.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,2CAA2C;EAC3C,0FAAsE;UAC9D,kFAA8D;CACvE;AACD,wBAAwB;AACxB;;;;;;;;;;;;;IAaI;AACJ,wBAAwB;AACxB;;;;;;;;;;;;IAYI;AACJ,wBAAwB;AACxB;;;;;;;;;;;;;IAaI;AACJ,sDAAsD;AACtD;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,2CAA2C;EAC3C,2FAAuE;UAC/D,mFAA+D;CACxE;AACD,wEAAwE;AACxE;;;;;;;;;;;;;IAaI;AACJ;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,2CAA2C;EAC3C,0FAAsE;UAC9D,kFAA8D;CACvE;AACD;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,2CAA2C;EAC3C,2FAAuE;UAC/D,mFAA+D;CACxE;AACD;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,2CAA2C;EAC3C,0FAAsE;UAC9D,kFAA8D;CACvE;AACD;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,2CAA2C;EAC3C,2FAAuE;UAC/D,mFAA+D;CACxE;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,gBAAgB;CACjB;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;CACzB;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;AACD;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;CAChB;AACD;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,eAAe;CAChB;AACD;EACE;IACE,qCAAqC;YAC7B,6BAA6B;IACrC,WAAW;GACZ;EACD;IACE,WAAW;GACZ;EACD;IACE,WAAW;IACX,iCAAiC;YACzB,yBAAyB;GAClC;CACF;AACD;EACE;IACE,qCAAqC;YAC7B,6BAA6B;IACrC,WAAW;GACZ;EACD;IACE,WAAW;GACZ;EACD;IACE,WAAW;IACX,iCAAiC;YACzB,yBAAyB;GAClC;CACF;AACD;EACE;IACE,iCAAiC;YACzB,yBAAyB;IACjC,WAAW;GACZ;EACD;IACE,WAAW;GACZ;EACD;IACE,WAAW;IACX,qCAAqC;YAC7B,6BAA6B;GACtC;CACF;AACD;EACE;IACE,iCAAiC;YACzB,yBAAyB;IACjC,WAAW;GACZ;EACD;IACE,WAAW;GACZ;EACD;IACE,WAAW;IACX,qCAAqC;YAC7B,6BAA6B;GACtC;CACF;AACD,kBAAkB;AAClB;EACE;;;IAGE,WAAW;IACX,iBAAiB;IACjB,eAAe;GAChB;;EAED;IACE,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,0BAA0B;QACtB,uBAAuB;YACnB,oBAAoB;IAC5B,sBAAsB;QAClB,kBAAkB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;QAChB,YAAY;YACR,QAAQ;GACjB;;EAED;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;GACpB;;EAED;IACE,aAAa;IACb,iBAAiB;GAClB;CACF;AACD;EACE;IACE,oCAAoC;YAC5B,4BAA4B;IACpC,WAAW;GACZ;EACD;IACE,WAAW;IACX,iCAAiC;YACzB,yBAAyB;GAClC;CACF;AACD;EACE;IACE,iCAAiC;YACzB,yBAAyB;IACjC,WAAW;GACZ;EACD;IACE,WAAW;IACX,oCAAoC;YAC5B,4BAA4B;GACrC;CACF;AACD,8BAA8B;AAC9B;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2BI","file":"snackbar.css","sourcesContent":["/* トースト表示ポジションが右上の場合  */\n.snackbar.active {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n/* トースト表示ポジションが左上の場合  */\n/* .snackbar.active {\n  top: 20px;\n  bottom: unset;\n  width: 35%;\n  right: auto;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n} */\n/* トースト表示ポジションが右下の場合  */\n/* .snackbar.active {\n  top: unset;\n  bottom: 20px;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n} */\n/* トースト表示ポジションが左下の場合  */\n/* .snackbar.active {\n  top: unset;\n  bottom: 20px;\n  width: 35%;\n  right: auto;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n} */\n/*トーストメッセージが右側の場合　上と下のポジションを変更する時はtopとbottomの値を入れ替える*/\n.snackbar:not(.active) {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: fadeout 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: fadeout 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n/*トーストメッセージが左側の場合　right: autoを設定した後、上と下のポジションを変更する時はtopとbottomの値を入れ替える*/\n/* .snackbar:not(.active) {\n  top: 20px;\n  bottom: unset;\n  width: 35%;\n  right: auto;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  animation: fadeout 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n} */\n.snackbar[class~=successToastify].active {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n.snackbar[class~=successToastify]:not(.active) {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #69C779;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: fadeout 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: fadeout 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n.snackbar[class~=errorToastify].active {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #FE6301;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: fadeup 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n.snackbar[class~=errorToastify]:not(.active) {\n  top: 35px;\n  bottom: unset;\n  width: 35%;\n  border: solid;\n  border-left-width: 10px;\n  border-left-color: #FE6301;\n  border-radius: 10px;\n  margin-right: inherit;\n  background-color: #ffffff;\n  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .5);\n  -webkit-animation: fadeout 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: fadeout 1s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n[class~=successToastify] > .button {\n  margin: -7px -12px -7px 10px;\n}\n[class~=errorToastify] > .button {\n  margin: -7px -12px -7px 10px;\n}\n[class~=toast_Content]{\n  color: black;\n  font-weight:  bold;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 16px;\n}\n[class~=check_circle]{\n  color: black;\n  font-weight:  bold;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n[class~=check_circle] > [data-react-toolbox='font-icon'] {\n  vertical-align: bottom;\n  margin-right: 10px;\n  color: rgb(91, 184, 92);\n}\n[class~=error_info] {\n  color: black;\n  font-weight:  bold;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n[class~=error_info] > [data-react-toolbox='font-icon'] {\n  vertical-align: bottom;\n  margin-right: 10px;\n  color: #e74c3c;\n}\n[class~=toastImg]{\n  width: 45px; \n  height: 45px; \n  vertical-align: bottom;\n  margin-right: 20px;\n}\n[class~=closeIcon] > [data-react-toolbox='font-icon']{\n  margin-top: 5px;\n  color: #212121;\n}\n@-webkit-keyframes fadeup {\n  0% {\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n    opacity: 0;\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n@keyframes fadeup {\n  0% {\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n    opacity: 0;\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n@-webkit-keyframes fadeout {\n  0% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n    opacity: 1;\n  }\n  80% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n  }\n}\n@keyframes fadeout {\n  0% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n    opacity: 1;\n  }\n  80% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n  }\n}\n/* スマートフォン用スタイル */\n@media screen and (max-width: 768px) {\n  .snackbar.active,\n  .snackbar[class~=successToastify].active,\n  .snackbar[class~=errorToastify].active {\n    width: 90%;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n\n  [class~=toast_Content] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    min-height: 45px;\n    font-size: 14px;\n    line-height: 1.4;\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n  }\n\n  [class~=toastImg] {\n    width: 35px;\n    height: 35px;\n    min-width: 35px;\n    margin-right: 10px;\n  }\n\n  [class~=closeIcon] {\n    padding: 8px;\n    margin-left: 8px;\n  }\n}\n@keyframes fadeup {\n  0% {\n    -webkit-transform: translateY(20px);\n            transform: translateY(20px);\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n  }\n}\n@keyframes fadeout {\n  0% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(20px);\n            transform: translateY(20px);\n  }\n}\n/* この記述はトーストの位置が左側で表示する時に使用 */\n/* @keyframes fadeup {\n  0% {\n    transform: translateX(-200px);\n    opacity: 0;\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeout {\n  0% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n  80% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-200px);\n  }\n\n} */"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"snackbar": "snackbar--snackbar--30rJigZI",
	"active": "snackbar--active--CfL3m7Oj",
	"fadeup": "snackbar--fadeup--11HH9maL",
	"fadeout": "snackbar--fadeout--1W5r5NER",
	"button": "snackbar--button--5xju2U6x"
};

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/app.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    routes: state.routes,
    isChecking: state.sessions.isChecking
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNativeLayout: function onNativeLayout() {
      return dispatch(_actions2.default.changeDeviceOrientation());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = exports.layoutFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _utils = __webpack_require__(106);

var _filterReactChildren = __webpack_require__(874);

var _filterReactChildren2 = _interopRequireDefault(_filterReactChildren);

var _isComponentOfType = __webpack_require__(265);

var _isComponentOfType2 = _interopRequireDefault(_isComponentOfType);

var _AppBar = __webpack_require__(875);

var _AppBar2 = _interopRequireDefault(_AppBar);

var _NavDrawer = __webpack_require__(876);

var _NavDrawer2 = _interopRequireDefault(_NavDrawer);

var _Sidebar = __webpack_require__(877);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _isBrowser = __webpack_require__(1793);

var _isBrowser2 = _interopRequireDefault(_isBrowser);

var _breakpoints = __webpack_require__(1794);

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(AppBar, NavDrawer, Sidebar) {
  var isNavDrawer = function isNavDrawer(child) {
    return (0, _isComponentOfType2.default)(NavDrawer, child);
  };
  var isSidebar = function isSidebar(child) {
    return (0, _isComponentOfType2.default)(Sidebar, child);
  };
  var isAppBar = function isAppBar(child) {
    return (0, _isComponentOfType2.default)(AppBar, child);
  };
  var isUnknown = function isUnknown(child) {
    return !isNavDrawer(child) && !isSidebar(child) && !isAppBar(child);
  };

  var Layout = function (_Component) {
    _inherits(Layout, _Component);

    function Layout() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Layout);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Layout.__proto__ || Object.getPrototypeOf(Layout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        width: (0, _isBrowser2.default)() && (0, _utils.getViewport)().width
      }, _this.handleResize = function () {
        _this.setState({ width: (0, _utils.getViewport)().width });
      }, _this.isPinned = function (sideNav) {
        if (sideNav) {
          var _sideNav$props = sideNav.props,
              permanentAt = _sideNav$props.permanentAt,
              pinned = _sideNav$props.pinned;
          var width = _this.state.width;

          return width > _breakpoints2.default[permanentAt] || pinned;
        }
        return undefined;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Layout, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!this.state.width) this.handleResize();
        window.addEventListener('resize', this.handleResize);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
      }
    }, {
      key: 'render',
      value: function render() {
        var _classnames;

        var _props = this.props,
            children = _props.children,
            className = _props.className,
            theme = _props.theme,
            rest = _objectWithoutProperties(_props, ['children', 'className', 'theme']);

        var appBar = (0, _filterReactChildren2.default)(children, isAppBar)[0];
        var navDrawer = (0, _filterReactChildren2.default)(children, isNavDrawer)[0];
        var sidebar = (0, _filterReactChildren2.default)(children, isSidebar)[0];
        var unknown = (0, _filterReactChildren2.default)(children, isUnknown);
        var appBarFixed = appBar && appBar.props.fixed;
        var navDrawerPinned = this.isPinned(navDrawer);
        var navDrawerClipped = navDrawer && navDrawer.props.clipped;
        var sidebarWidth = sidebar && sidebar.props.width;
        var sidebarPinned = this.isPinned(sidebar);
        var sidebarClipped = sidebar && sidebar.props.clipped;

        var clonedAppBar = appBar && (0, _react.cloneElement)(appBar, {
          theme: theme,
          themeNamespace: 'appbar'
        });

        var clonedLeftSideNav = navDrawer && (0, _react.cloneElement)(navDrawer, {
          clipped: navDrawerClipped,
          pinned: navDrawerPinned
        });

        var clonedRightSideNav = sidebar && (0, _react.cloneElement)(sidebar, {
          clipped: sidebarClipped,
          pinned: sidebarPinned
        });

        var _className = (0, _classnames3.default)(theme.layout, theme['sidebarWidth' + sidebarWidth], (_classnames = {}, _defineProperty(_classnames, theme.navDrawerPinned, navDrawerPinned), _defineProperty(_classnames, theme.navDrawerClipped, navDrawerClipped), _defineProperty(_classnames, theme.sidebarPinned, sidebarPinned), _defineProperty(_classnames, theme.sidebarClipped, sidebarClipped), _defineProperty(_classnames, theme.appbarFixed, appBarFixed), _classnames), className);

        return _react2.default.createElement(
          'div',
          _extends({}, rest, { className: _className }),
          clonedLeftSideNav,
          clonedAppBar,
          unknown,
          clonedRightSideNav
        );
      }
    }]);

    return Layout;
  }(_react.Component);

  Layout.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
      appbarFixed: _propTypes2.default.string,
      layout: _propTypes2.default.string,
      navDrawerClipped: _propTypes2.default.string,
      navDrawerPinned: _propTypes2.default.string,
      sidebarClipped: _propTypes2.default.string,
      sidebarPinned: _propTypes2.default.string
    })
  };
  Layout.defaultProps = {
    className: ''
  };


  return Layout;
};

var Layout = factory(_AppBar2.default, _NavDrawer2.default, _Sidebar2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.LAYOUT)(Layout);
exports.layoutFactory = factory;
exports.Layout = Layout;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(473);


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */
module.exports = _curry3(function assoc(prop, val, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  result[prop] = val;
  return result;
});


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

var pipe = __webpack_require__(1783);
var reverse = __webpack_require__(1791);


/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */
module.exports = function compose() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }
  return pipe.apply(this, reverse(arguments));
};


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(869);
var _pipe = __webpack_require__(1784);
var reduce = __webpack_require__(870);
var tail = __webpack_require__(1789);


/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      var f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */
module.exports = function pipe() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }
  return _arity(arguments[0].length,
                reduce(_pipe, arguments[0], tail(arguments)));
};


/***/ }),
/* 1784 */
/***/ (function(module, exports) {

module.exports = function _pipe(f, g) {
  return function() {
    return g.call(this, f.apply(this, arguments));
  };
};


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

var _xwrap = __webpack_require__(1786);
var bind = __webpack_require__(1787);
var isArrayLike = __webpack_require__(1788);


module.exports = (function() {
  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      idx += 1;
    }
    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      step = iter.next();
    }
    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj) {
    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
  return function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }
    if (isArrayLike(list)) {
      return _arrayReduce(fn, acc, list);
    }
    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list);
    }
    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }
    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }
    throw new TypeError('reduce: list must be array or iterable');
  };
}());


/***/ }),
/* 1786 */
/***/ (function(module, exports) {

module.exports = (function() {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function() {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
  XWrap.prototype['@@transducer/step'] = function(acc, x) {
    return this.f(acc, x);
  };

  return function _xwrap(fn) { return new XWrap(fn); };
}());


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(869);
var _curry2 = __webpack_require__(335);


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */
module.exports = _curry2(function bind(fn, thisObj) {
  return _arity(fn.length, function() {
    return fn.apply(thisObj, arguments);
  });
});


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(222);
var _isArray = __webpack_require__(871);
var _isString = __webpack_require__(872);


/**
 * Tests whether or not an object is similar to an array.
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @deprecated since v0.23.0
 * @example
 *
 *      R.isArrayLike([]); //=> true
 *      R.isArrayLike(true); //=> false
 *      R.isArrayLike({}); //=> false
 *      R.isArrayLike({length: 10}); //=> false
 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */
module.exports = _curry1(function isArrayLike(x) {
  if (_isArray(x)) { return true; }
  if (!x) { return false; }
  if (typeof x !== 'object') { return false; }
  if (_isString(x)) { return false; }
  if (x.nodeType === 1) { return !!x.length; }
  if (x.length === 0) { return true; }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(873);
var _curry1 = __webpack_require__(222);
var slice = __webpack_require__(1790);


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */
module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(873);
var _curry3 = __webpack_require__(473);


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */
module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(222);
var _isString = __webpack_require__(872);


/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */
module.exports = _curry1(function reverse(list) {
  return _isString(list) ? list.split('').reverse().join('') :
                           Array.prototype.slice.call(list, 0).reverse();
});


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(335);


/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */
module.exports = _curry2(function pickBy(test, obj) {
  var result = {};
  for (var prop in obj) {
    if (test(obj[prop], prop, obj)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBrowser;
function isBrowser() {
  return typeof window !== 'undefined' && window.document;
}

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  xxs: 480,
  xs: 600,
  smTablet: 720,
  sm: 840,
  md: 960,
  lgTablet: 1024,
  lg: 1280,
  xl: 1440,
  xxl: 1600,
  xxxl: 1920
};

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Panel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Panel = function Panel(_ref) {
  var bodyScroll = _ref.bodyScroll,
      children = _ref.children,
      className = _ref.className,
      theme = _ref.theme,
      other = _objectWithoutProperties(_ref, ['bodyScroll', 'children', 'className', 'theme']);

  var _className = (0, _classnames2.default)(theme.panel, _defineProperty({}, theme.bodyScroll, bodyScroll), className);
  return _react2.default.createElement(
    'div',
    _extends({}, other, { 'data-react-toolbox': 'panel', className: _className }),
    children
  );
};

Panel.propTypes = {
  bodyScroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.shape({
    panel: _propTypes2.default.string
  })
};

Panel.defaultProps = {
  bodyScroll: true,
  className: ''
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.LAYOUT)(Panel);
exports.Panel = Panel;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/* Orientation */\n/* Devices (defined by max width) */\n/* Devices (defined by min-width) */\n.theme--appBar--30Pm7vnH {\n  background: rgb(48, 63, 159);\n  color: rgb(255, 255, 255);\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  height: 64px;\n  padding: 0 24px;\n  transition-duration: 0.5s;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--appBar--30Pm7vnH *,\n    .theme--appBar--30Pm7vnH *::after,\n    .theme--appBar--30Pm7vnH *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--appBar--30Pm7vnH.theme--scrollHide--3Z2Khlh_ {\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n.theme--appBar--30Pm7vnH:not(.theme--flat--2zoEnJPf) {\n  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14),\n    0 1px 10px 0 rgba(0, 0, 0, .12),\n    0 2px 4px -1px rgba(0, 0, 0, .2);\n}\n.theme--appBar--30Pm7vnH.theme--fixed--2D3filTC {\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 300;\n}\n.theme--appBar--30Pm7vnH .theme--inner--2hLa08-l {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n.theme--appBar--30Pm7vnH a {\n  color: rgb(255, 255, 255);\n}\n@media screen and (max-width: 480px) and (orientation: portrait) {\n  .theme--appBar--30Pm7vnH {\n    height: 56px;\n  }\n}\n@media screen and (max-width: 600px) and (orientation: landscape) {\n  .theme--appBar--30Pm7vnH {\n    height: 48px;\n  }\n}\n.theme--title--2g4PfRHL {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  font-size: 18px;\n  font-weight: bold;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n.theme--title--2g4PfRHL > small {\n  font-size: 18px;\n  font-weight: normal;\n}\n.theme--leftIcon--3wDDkUBb {\n  margin-left: -12px;\n}\n.theme--rightIcon--KBf-kIvh {\n  margin-left: auto;\n  margin-right: -12px;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/app_bar/theme.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB,oCAAoC;AACpC,oCAAoC;AACpC;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,wDAAwD;EACxD,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,kDAAkD;EAClD,gEAAgE;EAChE,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;EACE;;qCAEmC;CACpC;AACD;EACE,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,aAAa;CACd;AACD;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,0BAA0B;CAC3B;AACD;EACE;IACE,aAAa;GACd;CACF;AACD;EACE;IACE,aAAa;GACd;CACF;AACD;EACE,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;EAClB,oBAAoB;CACrB","file":"theme.css","sourcesContent":["/* Orientation */\n/* Devices (defined by max width) */\n/* Devices (defined by min-width) */\n.appBar {\n  background: rgb(48, 63, 159);\n  color: rgb(255, 255, 255);\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  height: 64px;\n  padding: 0 24px;\n  transition-duration: 0.5s;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.appBar *,\n    .appBar *::after,\n    .appBar *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.appBar.scrollHide {\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n.appBar:not(.flat) {\n  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14),\n    0 1px 10px 0 rgba(0, 0, 0, .12),\n    0 2px 4px -1px rgba(0, 0, 0, .2);\n}\n.appBar.fixed {\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 300;\n}\n.appBar .inner {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n.appBar a {\n  color: rgb(255, 255, 255);\n}\n@media screen and (max-width: 480px) and (orientation: portrait) {\n  .appBar {\n    height: 56px;\n  }\n}\n@media screen and (max-width: 600px) and (orientation: landscape) {\n  .appBar {\n    height: 48px;\n  }\n}\n.title {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  font-size: 18px;\n  font-weight: bold;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n.title > small {\n  font-size: 18px;\n  font-weight: normal;\n}\n.leftIcon {\n  margin-left: -12px;\n}\n.rightIcon {\n  margin-left: auto;\n  margin-right: -12px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"appBar": "theme--appBar--30Pm7vnH",
	"scrollHide": "theme--scrollHide--3Z2Khlh_",
	"flat": "theme--flat--2zoEnJPf",
	"fixed": "theme--fixed--2D3filTC",
	"inner": "theme--inner--2hLa08-l",
	"title": "theme--title--2g4PfRHL",
	"leftIcon": "theme--leftIcon--3wDDkUBb",
	"rightIcon": "theme--rightIcon--KBf-kIvh"
};

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1798);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--overlay--2vmqiHlJ {\n  background-color: rgb(0, 0, 0);\n  bottom: 0;\n  height: 100vh;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 100vw\n}\n.theme--overlay--2vmqiHlJ.theme--active--3KLhwRUz {\n  opacity: 0.6;\n  pointer-events: all;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/overlay/theme.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,UAAU;EACV,cAAc;EACd,QAAQ;EACR,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,OAAO;EACP,uDAAuD;EACvD,YAAY;CACb;AACD;EACE,aAAa;EACb,oBAAoB;CACrB","file":"theme.css","sourcesContent":[".overlay {\n  background-color: rgb(0, 0, 0);\n  bottom: 0;\n  height: 100vh;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 100vw\n}\n.overlay.active {\n  opacity: 0.6;\n  pointer-events: all;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"overlay": "theme--overlay--2vmqiHlJ",
	"active": "theme--active--3KLhwRUz"
};

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1800);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/* Orientation */\n/* Devices (defined by max width) */\n/* Devices (defined by min-width) */\n.theme--wrapper--1maWY2KD {\n  position: relative;\n  z-index: 200;\n}\n.theme--drawer--2hsrrkea {\n  background-color: rgb(250, 250, 250);\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n  color: rgb(66, 66, 66);\n  display: block;\n  height: 100vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  -webkit-transform-style: preserve-3d;\n          transform-style: preserve-3d;\n  transition: -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition-delay: 0s;\n  width: 280px;\n  will-change: transform;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--drawer--2hsrrkea *,\n    .theme--drawer--2hsrrkea *::after,\n    .theme--drawer--2hsrrkea *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--drawer--2hsrrkea.theme--active--Z0sxy_WI {\n  pointer-events: all;\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n  transition-delay: 0.07s;\n}\n.theme--drawer--2hsrrkea.theme--right--1X9H3tsb {\n  border-left: 1px solid rgb(224, 224, 224);\n  right: 0;\n}\n.theme--drawer--2hsrrkea.theme--right--1X9H3tsb:not(.theme--active--Z0sxy_WI) {\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n}\n.theme--drawer--2hsrrkea.theme--left--2_qXBH_h {\n  border-right: 1px solid rgb(224, 224, 224);\n  left: 0;\n}\n.theme--drawer--2hsrrkea.theme--left--2_qXBH_h:not(.theme--active--Z0sxy_WI) {\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n@media screen and (min-width: 600px) {\n  .theme--drawer--2hsrrkea {\n    width: 256px;\n  }\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/drawer/theme.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB,oCAAoC;AACpC,oCAAoC;AACpC;EACE,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,qCAAqC;EACrC;;mCAEiC;EACjC,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,OAAO;EACP,qCAAqC;UAC7B,6BAA6B;EACrC,iEAAiE;EACjE,yDAAyD;EACzD,+GAA+G;EAC/G,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,oBAAoB;EACpB,iCAAiC;UACzB,yBAAyB;EACjC,wBAAwB;CACzB;AACD;EACE,0CAA0C;EAC1C,SAAS;CACV;AACD;EACE,oCAAoC;UAC5B,4BAA4B;CACrC;AACD;EACE,2CAA2C;EAC3C,QAAQ;CACT;AACD;EACE,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;EACE;IACE,aAAa;GACd;CACF","file":"theme.css","sourcesContent":["/* Orientation */\n/* Devices (defined by max width) */\n/* Devices (defined by min-width) */\n.wrapper {\n  position: relative;\n  z-index: 200;\n}\n.drawer {\n  background-color: rgb(250, 250, 250);\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n  color: rgb(66, 66, 66);\n  display: block;\n  height: 100vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  -webkit-transform-style: preserve-3d;\n          transform-style: preserve-3d;\n  transition: -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition-delay: 0s;\n  width: 280px;\n  will-change: transform;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.drawer *,\n    .drawer *::after,\n    .drawer *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.drawer.active {\n  pointer-events: all;\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n  transition-delay: 0.07s;\n}\n.drawer.right {\n  border-left: 1px solid rgb(224, 224, 224);\n  right: 0;\n}\n.drawer.right:not(.active) {\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n}\n.drawer.left {\n  border-right: 1px solid rgb(224, 224, 224);\n  left: 0;\n}\n.drawer.left:not(.active) {\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n@media screen and (min-width: 600px) {\n  .drawer {\n    width: 256px;\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"wrapper": "theme--wrapper--1maWY2KD",
	"drawer": "theme--drawer--2hsrrkea",
	"active": "theme--active--Z0sxy_WI",
	"right": "theme--right--1X9H3tsb",
	"left": "theme--left--2_qXBH_h"
};

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1802);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/* Orientation */\n/* Devices (defined by max width) */\n/* Devices (defined by min-width) */\n.theme--layout--rumm3SDi {\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  min-height: 100vh;\n  min-width: 100%;\n  position: relative;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.theme--layout--rumm3SDi *,\n    .theme--layout--rumm3SDi *::after,\n    .theme--layout--rumm3SDi *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--panel--2tKiriHT {\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0\n}\n.theme--panel--2tKiriHT:not(.theme--bodyScroll--1-JakArC) {\n  height: 100vh;\n  max-height: 100vh;\n  overflow-y: scroll;\n}\n.theme--sidebarDrawer--2CI34OR_,\n.theme--navDrawerDrawer--32OlLFqO {\n  z-index: 100\n}\n.theme--sidebarDrawer--2CI34OR_.theme--pinned--1uhbihgs, .theme--navDrawerDrawer--32OlLFqO.theme--pinned--1uhbihgs {\n  box-shadow: none;\n}\n.theme--sidebarDrawer--2CI34OR_.theme--clipped--1fu9EmcV, .theme--navDrawerDrawer--32OlLFqO.theme--clipped--1fu9EmcV {\n  height: calc(100vh - 64px);\n  padding-top: 5px;\n  top: 64px;\n}\n@media screen and (max-width: 480px) and (orientation: portrait) {\n  .theme--sidebarDrawer--2CI34OR_.theme--clipped--1fu9EmcV, .theme--navDrawerDrawer--32OlLFqO.theme--clipped--1fu9EmcV {\n    height: calc(100vh - 56px);\n    top: 56px;\n  }\n}\n@media screen and (max-width: 600px) and (orientation: landscape) {\n  .theme--sidebarDrawer--2CI34OR_.theme--clipped--1fu9EmcV, .theme--navDrawerDrawer--32OlLFqO.theme--clipped--1fu9EmcV {\n    height: calc(100vh - 48px);\n    top: 48px;\n  }\n}\n.theme--appbarInner--2c02_JWo,\n.theme--panel--2tKiriHT {\n  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.theme--appbarFixed--3eFSx03J.theme--appbarAppBar--3vOCSxHS {\n  z-index: 100;\n}\n.theme--appbarFixed--3eFSx03J .theme--panel--2tKiriHT {\n  top: 64px;\n}\n.theme--appbarFixed--3eFSx03J .theme--panel--2tKiriHT:not(.theme--bodyScroll--1-JakArC) {\n  height: calc(100vh - 64px);\n  max-height: calc(100vh - 64px);\n  overflow-y: scroll;\n}\n@media screen and (max-width: 480px) and (orientation: portrait) {\n  .theme--appbarFixed--3eFSx03J .theme--panel--2tKiriHT {\n    top: 56px;\n  }\n}\n@media screen and (max-width: 600px) and (orientation: landscape) {\n  .theme--appbarFixed--3eFSx03J .theme--panel--2tKiriHT {\n    top: 48px;\n  }\n}\n.theme--navDrawerPinned--2W7Wu93L .theme--appbarLeftIcon--2kB39wQv {\n  display: none;\n}\n.theme--navDrawerPinned--2W7Wu93L .theme--panel--2tKiriHT {\n  left: 280px;\n}\n.theme--navDrawerPinned--2W7Wu93L:not(.theme--navDrawerClipped--3B95n0s7) .theme--appbarAppBar--3vOCSxHS {\n  padding-left: 304px;\n}\n@media screen and (min-width: 600px) {\n  .theme--navDrawerPinned--2W7Wu93L .theme--panel--2tKiriHT {\n    left: 256px;\n  }\n  .theme--navDrawerPinned--2W7Wu93L:not(.theme--navDrawerClipped--3B95n0s7) .theme--appbarAppBar--3vOCSxHS {\n    padding-left: 280px;\n  }\n}\n.theme--navDrawerClipped--3B95n0s7 .theme--navDrawerWrapper--2CO1O7fo {\n  position: relative;\n  z-index: 1;\n}\n.theme--sidebarPinned--2lM_ZsAk .theme--appbarLeftIcon--2kB39wQv {\n  display: none;\n}\n.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n  right: 280px;\n}\n.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n  padding-right: 304px;\n}\n@media screen and (min-width: 600px) {\n  .theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 256px;\n  }\n  .theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 280px;\n  }\n}\n.theme--sidebarClipped--3YrfJ-7G .theme--sidebarWrapper--1Jr6plax {\n  position: relative;\n  z-index: 1;\n}\n.theme--sidebarWidth1--1J_y3jDO .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth1--1J_y3jDO .theme--sidebarDrawer--2CI34OR_ {\n    width: 64px;\n  }\n  .theme--sidebarWidth1--1J_y3jDO.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 64px;\n  }\n  .theme--sidebarWidth1--1J_y3jDO.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 88px;\n  }\n}\n.theme--sidebarWidth2--Z3_CyU3i .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth2--Z3_CyU3i .theme--sidebarDrawer--2CI34OR_ {\n    width: 128px;\n  }\n  .theme--sidebarWidth2--Z3_CyU3i.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 128px;\n  }\n  .theme--sidebarWidth2--Z3_CyU3i.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 152px;\n  }\n}\n.theme--sidebarWidth3--1GnpmQgp .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth3--1GnpmQgp .theme--sidebarDrawer--2CI34OR_ {\n    width: 192px;\n  }\n  .theme--sidebarWidth3--1GnpmQgp.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 192px;\n  }\n  .theme--sidebarWidth3--1GnpmQgp.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 216px;\n  }\n}\n.theme--sidebarWidth4--2b2Qv473 .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth4--2b2Qv473 .theme--sidebarDrawer--2CI34OR_ {\n    width: 256px;\n  }\n  .theme--sidebarWidth4--2b2Qv473.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 256px;\n  }\n  .theme--sidebarWidth4--2b2Qv473.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 280px;\n  }\n}\n.theme--sidebarWidth5--2D3Lwr7X .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth5--2D3Lwr7X .theme--sidebarDrawer--2CI34OR_ {\n    width: 320px;\n  }\n  .theme--sidebarWidth5--2D3Lwr7X.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 320px;\n  }\n  .theme--sidebarWidth5--2D3Lwr7X.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 344px;\n  }\n}\n.theme--sidebarWidth6--3Hg1RS7O .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth6--3Hg1RS7O .theme--sidebarDrawer--2CI34OR_ {\n    width: 384px;\n  }\n  .theme--sidebarWidth6--3Hg1RS7O.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 384px;\n  }\n  .theme--sidebarWidth6--3Hg1RS7O.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 408px;\n  }\n}\n.theme--sidebarWidth7--3jcfBQwi .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth7--3jcfBQwi .theme--sidebarDrawer--2CI34OR_ {\n    width: 448px;\n  }\n  .theme--sidebarWidth7--3jcfBQwi.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 448px;\n  }\n  .theme--sidebarWidth7--3jcfBQwi.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 472px;\n  }\n}\n.theme--sidebarWidth8--1sMyc6aK .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth8--1sMyc6aK .theme--sidebarDrawer--2CI34OR_ {\n    width: 512px;\n  }\n  .theme--sidebarWidth8--1sMyc6aK.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 512px;\n  }\n  .theme--sidebarWidth8--1sMyc6aK.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 536px;\n  }\n}\n.theme--sidebarWidth9--3qZyZfyh .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth9--3qZyZfyh .theme--sidebarDrawer--2CI34OR_ {\n    width: 576px;\n  }\n  .theme--sidebarWidth9--3qZyZfyh.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 576px;\n  }\n  .theme--sidebarWidth9--3qZyZfyh.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 600px;\n  }\n}\n.theme--sidebarWidth10--3sMSLhXc .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth10--3sMSLhXc .theme--sidebarDrawer--2CI34OR_ {\n    width: 640px;\n  }\n  .theme--sidebarWidth10--3sMSLhXc.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 640px;\n  }\n  .theme--sidebarWidth10--3sMSLhXc.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 664px;\n  }\n}\n.theme--sidebarWidth11--2BMVApY3 .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth11--2BMVApY3 .theme--sidebarDrawer--2CI34OR_ {\n    width: 704px;\n  }\n  .theme--sidebarWidth11--2BMVApY3.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 704px;\n  }\n  .theme--sidebarWidth11--2BMVApY3.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 728px;\n  }\n}\n.theme--sidebarWidth12--22TuYbVW .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .theme--sidebarWidth12--22TuYbVW .theme--sidebarDrawer--2CI34OR_ {\n    width: 768px;\n  }\n  .theme--sidebarWidth12--22TuYbVW.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 768px;\n  }\n  .theme--sidebarWidth12--22TuYbVW.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 792px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .theme--sidebarWidth1--1J_y3jDO .theme--sidebarDrawer--2CI34OR_ {\n    width: 56px;\n  }\n  .theme--sidebarWidth1--1J_y3jDO.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 56px;\n  }\n  .theme--sidebarWidth1--1J_y3jDO.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 80px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .theme--sidebarWidth1--1J_y3jDO .theme--sidebarDrawer--2CI34OR_ {\n    width: 64px;\n  }\n  .theme--sidebarWidth1--1J_y3jDO.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 64px;\n  }\n  .theme--sidebarWidth1--1J_y3jDO.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 88px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .theme--sidebarWidth2--Z3_CyU3i .theme--sidebarDrawer--2CI34OR_ {\n    width: 112px;\n  }\n  .theme--sidebarWidth2--Z3_CyU3i.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 112px;\n  }\n  .theme--sidebarWidth2--Z3_CyU3i.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 136px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .theme--sidebarWidth2--Z3_CyU3i .theme--sidebarDrawer--2CI34OR_ {\n    width: 128px;\n  }\n  .theme--sidebarWidth2--Z3_CyU3i.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 128px;\n  }\n  .theme--sidebarWidth2--Z3_CyU3i.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 152px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .theme--sidebarWidth3--1GnpmQgp .theme--sidebarDrawer--2CI34OR_ {\n    width: 168px;\n  }\n  .theme--sidebarWidth3--1GnpmQgp.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 168px;\n  }\n  .theme--sidebarWidth3--1GnpmQgp.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 192px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .theme--sidebarWidth3--1GnpmQgp .theme--sidebarDrawer--2CI34OR_ {\n    width: 192px;\n  }\n  .theme--sidebarWidth3--1GnpmQgp.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 192px;\n  }\n  .theme--sidebarWidth3--1GnpmQgp.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 216px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .theme--sidebarWidth4--2b2Qv473 .theme--sidebarDrawer--2CI34OR_ {\n    width: 224px;\n  }\n  .theme--sidebarWidth4--2b2Qv473.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 224px;\n  }\n  .theme--sidebarWidth4--2b2Qv473.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 248px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .theme--sidebarWidth4--2b2Qv473 .theme--sidebarDrawer--2CI34OR_ {\n    width: 256px;\n  }\n  .theme--sidebarWidth4--2b2Qv473.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 256px;\n  }\n  .theme--sidebarWidth4--2b2Qv473.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 280px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .theme--sidebarWidth5--2D3Lwr7X .theme--sidebarDrawer--2CI34OR_ {\n    width: 280px;\n  }\n  .theme--sidebarWidth5--2D3Lwr7X.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 280px;\n  }\n  .theme--sidebarWidth5--2D3Lwr7X.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 304px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .theme--sidebarWidth5--2D3Lwr7X .theme--sidebarDrawer--2CI34OR_ {\n    width: 320px;\n  }\n  .theme--sidebarWidth5--2D3Lwr7X.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 320px;\n  }\n  .theme--sidebarWidth5--2D3Lwr7X.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 344px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .theme--sidebarWidth6--3Hg1RS7O .theme--sidebarDrawer--2CI34OR_ {\n    width: 336px;\n  }\n  .theme--sidebarWidth6--3Hg1RS7O.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 336px;\n  }\n  .theme--sidebarWidth6--3Hg1RS7O.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 360px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .theme--sidebarWidth6--3Hg1RS7O .theme--sidebarDrawer--2CI34OR_ {\n    width: 384px;\n  }\n  .theme--sidebarWidth6--3Hg1RS7O.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 384px;\n  }\n  .theme--sidebarWidth6--3Hg1RS7O.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 408px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .theme--sidebarWidth7--3jcfBQwi .theme--sidebarDrawer--2CI34OR_ {\n    width: 392px;\n  }\n  .theme--sidebarWidth7--3jcfBQwi.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 392px;\n  }\n  .theme--sidebarWidth7--3jcfBQwi.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 416px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .theme--sidebarWidth7--3jcfBQwi .theme--sidebarDrawer--2CI34OR_ {\n    width: 448px;\n  }\n  .theme--sidebarWidth7--3jcfBQwi.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 448px;\n  }\n  .theme--sidebarWidth7--3jcfBQwi.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 472px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .theme--sidebarWidth8--1sMyc6aK .theme--sidebarDrawer--2CI34OR_ {\n    width: 448px;\n  }\n  .theme--sidebarWidth8--1sMyc6aK.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 448px;\n  }\n  .theme--sidebarWidth8--1sMyc6aK.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 472px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .theme--sidebarWidth8--1sMyc6aK .theme--sidebarDrawer--2CI34OR_ {\n    width: 512px;\n  }\n  .theme--sidebarWidth8--1sMyc6aK.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 512px;\n  }\n  .theme--sidebarWidth8--1sMyc6aK.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 536px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .theme--sidebarWidth9--3qZyZfyh .theme--sidebarDrawer--2CI34OR_ {\n    width: 504px;\n  }\n  .theme--sidebarWidth9--3qZyZfyh.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 504px;\n  }\n  .theme--sidebarWidth9--3qZyZfyh.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 528px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .theme--sidebarWidth9--3qZyZfyh .theme--sidebarDrawer--2CI34OR_ {\n    width: 576px;\n  }\n  .theme--sidebarWidth9--3qZyZfyh.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 576px;\n  }\n  .theme--sidebarWidth9--3qZyZfyh.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 600px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .theme--sidebarWidth1--1J_y3jDO .theme--sidebarDrawer--2CI34OR_ {\n    width: 64px;\n  }\n  .theme--sidebarWidth1--1J_y3jDO.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 64px;\n  }\n  .theme--sidebarWidth1--1J_y3jDO.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 88px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .theme--sidebarWidth2--Z3_CyU3i .theme--sidebarDrawer--2CI34OR_ {\n    width: 128px;\n  }\n  .theme--sidebarWidth2--Z3_CyU3i.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 128px;\n  }\n  .theme--sidebarWidth2--Z3_CyU3i.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 152px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .theme--sidebarWidth3--1GnpmQgp .theme--sidebarDrawer--2CI34OR_ {\n    width: 192px;\n  }\n  .theme--sidebarWidth3--1GnpmQgp.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 192px;\n  }\n  .theme--sidebarWidth3--1GnpmQgp.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 216px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .theme--sidebarWidth4--2b2Qv473 .theme--sidebarDrawer--2CI34OR_ {\n    width: 256px;\n  }\n  .theme--sidebarWidth4--2b2Qv473.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 256px;\n  }\n  .theme--sidebarWidth4--2b2Qv473.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 280px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .theme--sidebarWidth5--2D3Lwr7X .theme--sidebarDrawer--2CI34OR_ {\n    width: 320px;\n  }\n  .theme--sidebarWidth5--2D3Lwr7X.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 320px;\n  }\n  .theme--sidebarWidth5--2D3Lwr7X.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 344px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .theme--sidebarWidth6--3Hg1RS7O .theme--sidebarDrawer--2CI34OR_ {\n    width: 384px;\n  }\n  .theme--sidebarWidth6--3Hg1RS7O.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 384px;\n  }\n  .theme--sidebarWidth6--3Hg1RS7O.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 408px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .theme--sidebarWidth7--3jcfBQwi .theme--sidebarDrawer--2CI34OR_ {\n    width: 448px;\n  }\n  .theme--sidebarWidth7--3jcfBQwi.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 448px;\n  }\n  .theme--sidebarWidth7--3jcfBQwi.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 472px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .theme--sidebarWidth8--1sMyc6aK .theme--sidebarDrawer--2CI34OR_ {\n    width: 512px;\n  }\n  .theme--sidebarWidth8--1sMyc6aK.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 512px;\n  }\n  .theme--sidebarWidth8--1sMyc6aK.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 536px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .theme--sidebarWidth9--3qZyZfyh .theme--sidebarDrawer--2CI34OR_ {\n    width: 576px;\n  }\n  .theme--sidebarWidth9--3qZyZfyh.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 576px;\n  }\n  .theme--sidebarWidth9--3qZyZfyh.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 600px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .theme--sidebarWidth10--3sMSLhXc .theme--sidebarDrawer--2CI34OR_ {\n    width: 640px;\n  }\n  .theme--sidebarWidth10--3sMSLhXc.theme--sidebarPinned--2lM_ZsAk .theme--panel--2tKiriHT {\n    right: 640px;\n  }\n  .theme--sidebarWidth10--3sMSLhXc.theme--sidebarPinned--2lM_ZsAk:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: 664px;\n  }\n}\n.theme--sidebarWidth25--2ff3MeMg .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n.theme--sidebarWidth33--1CGPE9iQ .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n.theme--sidebarWidth50--3gxaRB1n .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n.theme--sidebarWidth66--2UwEiydP .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n.theme--sidebarWidth75--1qO0w6o8 .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n.theme--sidebarWidth100--M1UR8il0 .theme--sidebarDrawer--2CI34OR_ {\n  width: 100%;\n}\n@media screen and (min-width: 720px) {\n    .theme--sidebarWidth25--2ff3MeMg .theme--panel--2tKiriHT {\n    right: 25%;\n  }\n    .theme--sidebarWidth25--2ff3MeMg .theme--sidebarDrawer--2CI34OR_ {\n    width: 25%;\n  }\n    .theme--sidebarWidth25--2ff3MeMg:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: calc(25% + 24px);\n  }\n    .theme--sidebarWidth33--1CGPE9iQ .theme--panel--2tKiriHT {\n    right: 33%;\n  }\n    .theme--sidebarWidth33--1CGPE9iQ .theme--sidebarDrawer--2CI34OR_ {\n    width: 33%;\n  }\n    .theme--sidebarWidth33--1CGPE9iQ:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: calc(33% + 24px);\n  }\n    .theme--sidebarWidth50--3gxaRB1n .theme--panel--2tKiriHT {\n    right: 50%;\n  }\n    .theme--sidebarWidth50--3gxaRB1n .theme--sidebarDrawer--2CI34OR_ {\n    width: 50%;\n  }\n    .theme--sidebarWidth50--3gxaRB1n:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: calc(50% + 24px);\n  }\n    .theme--sidebarWidth66--2UwEiydP .theme--panel--2tKiriHT {\n    right: 66%;\n  }\n    .theme--sidebarWidth66--2UwEiydP .theme--sidebarDrawer--2CI34OR_ {\n    width: 66%;\n  }\n    .theme--sidebarWidth66--2UwEiydP:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: calc(66% + 24px);\n  }\n    .theme--sidebarWidth75--1qO0w6o8 .theme--panel--2tKiriHT {\n    right: 75%;\n  }\n    .theme--sidebarWidth75--1qO0w6o8 .theme--sidebarDrawer--2CI34OR_ {\n    width: 75%;\n  }\n    .theme--sidebarWidth75--1qO0w6o8:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: calc(75% + 24px);\n  }\n    .theme--sidebarWidth100--M1UR8il0 .theme--panel--2tKiriHT {\n    right: 100%;\n  }\n    .theme--sidebarWidth100--M1UR8il0 .theme--sidebarDrawer--2CI34OR_ {\n    width: 100%;\n  }\n    .theme--sidebarWidth100--M1UR8il0:not(.theme--sidebarClipped--3YrfJ-7G) .theme--appbarAppBar--3vOCSxHS {\n    padding-right: calc(100% + 24px);\n  }\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/layout/theme.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB,oCAAoC;AACpC,oCAAoC;AACpC;EACE,2BAA2B;MACvB,wBAAwB;UACpB,qBAAqB;EAC7B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;MAChB,YAAY;UACR,QAAQ;EAChB,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;CAChC;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,QAAQ;EACR,mBAAmB;EACnB,SAAS;EACT,MAAM;CACP;AACD;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;CACpB;AACD;;EAEE,YAAY;CACb;AACD;EACE,iBAAiB;CAClB;AACD;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,UAAU;CACX;AACD;EACE;IACE,2BAA2B;IAC3B,UAAU;GACX;CACF;AACD;EACE;IACE,2BAA2B;IAC3B,UAAU;GACX;CACF;AACD;;EAEE,mDAAmD;CACpD;AACD;EACE,aAAa;CACd;AACD;EACE,UAAU;CACX;AACD;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,mBAAmB;CACpB;AACD;EACE;IACE,UAAU;GACX;CACF;AACD;EACE;IACE,UAAU;GACX;CACF;AACD;EACE,cAAc;CACf;AACD;EACE,YAAY;CACb;AACD;EACE,oBAAoB;CACrB;AACD;EACE;IACE,YAAY;GACb;EACD;IACE,oBAAoB;GACrB;CACF;AACD;EACE,mBAAmB;EACnB,WAAW;CACZ;AACD;EACE,cAAc;CACf;AACD;EACE,aAAa;CACd;AACD;EACE,qBAAqB;CACtB;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,mBAAmB;EACnB,WAAW;CACZ;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,YAAY;GACb;EACD;IACE,YAAY;GACb;EACD;IACE,oBAAoB;GACrB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,YAAY;GACb;EACD;IACE,YAAY;GACb;EACD;IACE,oBAAoB;GACrB;CACF;AACD;EACE;IACE,YAAY;GACb;EACD;IACE,YAAY;GACb;EACD;IACE,oBAAoB;GACrB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,YAAY;GACb;EACD;IACE,YAAY;GACb;EACD;IACE,oBAAoB;GACrB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE;IACE,aAAa;GACd;EACD;IACE,aAAa;GACd;EACD;IACE,qBAAqB;GACtB;CACF;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;IACI;IACA,WAAW;GACZ;IACC;IACA,WAAW;GACZ;IACC;IACA,gCAAgC;GACjC;IACC;IACA,WAAW;GACZ;IACC;IACA,WAAW;GACZ;IACC;IACA,gCAAgC;GACjC;IACC;IACA,WAAW;GACZ;IACC;IACA,WAAW;GACZ;IACC;IACA,gCAAgC;GACjC;IACC;IACA,WAAW;GACZ;IACC;IACA,WAAW;GACZ;IACC;IACA,gCAAgC;GACjC;IACC;IACA,WAAW;GACZ;IACC;IACA,WAAW;GACZ;IACC;IACA,gCAAgC;GACjC;IACC;IACA,YAAY;GACb;IACC;IACA,YAAY;GACb;IACC;IACA,iCAAiC;GAClC;CACF","file":"theme.css","sourcesContent":["/* Orientation */\n/* Devices (defined by max width) */\n/* Devices (defined by min-width) */\n.layout {\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  min-height: 100vh;\n  min-width: 100%;\n  position: relative;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.layout *,\n    .layout *::after,\n    .layout *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.panel {\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0\n}\n.panel:not(.bodyScroll) {\n  height: 100vh;\n  max-height: 100vh;\n  overflow-y: scroll;\n}\n.sidebarDrawer,\n.navDrawerDrawer {\n  z-index: 100\n}\n.sidebarDrawer.pinned, .navDrawerDrawer.pinned {\n  box-shadow: none;\n}\n.sidebarDrawer.clipped, .navDrawerDrawer.clipped {\n  height: calc(100vh - 64px);\n  padding-top: 5px;\n  top: 64px;\n}\n@media screen and (max-width: 480px) and (orientation: portrait) {\n  .sidebarDrawer.clipped, .navDrawerDrawer.clipped {\n    height: calc(100vh - 56px);\n    top: 56px;\n  }\n}\n@media screen and (max-width: 600px) and (orientation: landscape) {\n  .sidebarDrawer.clipped, .navDrawerDrawer.clipped {\n    height: calc(100vh - 48px);\n    top: 48px;\n  }\n}\n.appbarInner,\n.panel {\n  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.appbarFixed.appbarAppBar {\n  z-index: 100;\n}\n.appbarFixed .panel {\n  top: 64px;\n}\n.appbarFixed .panel:not(.bodyScroll) {\n  height: calc(100vh - 64px);\n  max-height: calc(100vh - 64px);\n  overflow-y: scroll;\n}\n@media screen and (max-width: 480px) and (orientation: portrait) {\n  .appbarFixed .panel {\n    top: 56px;\n  }\n}\n@media screen and (max-width: 600px) and (orientation: landscape) {\n  .appbarFixed .panel {\n    top: 48px;\n  }\n}\n.navDrawerPinned .appbarLeftIcon {\n  display: none;\n}\n.navDrawerPinned .panel {\n  left: 280px;\n}\n.navDrawerPinned:not(.navDrawerClipped) .appbarAppBar {\n  padding-left: 304px;\n}\n@media screen and (min-width: 600px) {\n  .navDrawerPinned .panel {\n    left: 256px;\n  }\n  .navDrawerPinned:not(.navDrawerClipped) .appbarAppBar {\n    padding-left: 280px;\n  }\n}\n.navDrawerClipped .navDrawerWrapper {\n  position: relative;\n  z-index: 1;\n}\n.sidebarPinned .appbarLeftIcon {\n  display: none;\n}\n.sidebarPinned .panel {\n  right: 280px;\n}\n.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n  padding-right: 304px;\n}\n@media screen and (min-width: 600px) {\n  .sidebarPinned .panel {\n    right: 256px;\n  }\n  .sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 280px;\n  }\n}\n.sidebarClipped .sidebarWrapper {\n  position: relative;\n  z-index: 1;\n}\n.sidebarWidth1 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth1 .sidebarDrawer {\n    width: 64px;\n  }\n  .sidebarWidth1.sidebarPinned .panel {\n    right: 64px;\n  }\n  .sidebarWidth1.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 88px;\n  }\n}\n.sidebarWidth2 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth2 .sidebarDrawer {\n    width: 128px;\n  }\n  .sidebarWidth2.sidebarPinned .panel {\n    right: 128px;\n  }\n  .sidebarWidth2.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 152px;\n  }\n}\n.sidebarWidth3 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth3 .sidebarDrawer {\n    width: 192px;\n  }\n  .sidebarWidth3.sidebarPinned .panel {\n    right: 192px;\n  }\n  .sidebarWidth3.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 216px;\n  }\n}\n.sidebarWidth4 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth4 .sidebarDrawer {\n    width: 256px;\n  }\n  .sidebarWidth4.sidebarPinned .panel {\n    right: 256px;\n  }\n  .sidebarWidth4.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 280px;\n  }\n}\n.sidebarWidth5 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth5 .sidebarDrawer {\n    width: 320px;\n  }\n  .sidebarWidth5.sidebarPinned .panel {\n    right: 320px;\n  }\n  .sidebarWidth5.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 344px;\n  }\n}\n.sidebarWidth6 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth6 .sidebarDrawer {\n    width: 384px;\n  }\n  .sidebarWidth6.sidebarPinned .panel {\n    right: 384px;\n  }\n  .sidebarWidth6.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 408px;\n  }\n}\n.sidebarWidth7 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth7 .sidebarDrawer {\n    width: 448px;\n  }\n  .sidebarWidth7.sidebarPinned .panel {\n    right: 448px;\n  }\n  .sidebarWidth7.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 472px;\n  }\n}\n.sidebarWidth8 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth8 .sidebarDrawer {\n    width: 512px;\n  }\n  .sidebarWidth8.sidebarPinned .panel {\n    right: 512px;\n  }\n  .sidebarWidth8.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 536px;\n  }\n}\n.sidebarWidth9 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth9 .sidebarDrawer {\n    width: 576px;\n  }\n  .sidebarWidth9.sidebarPinned .panel {\n    right: 576px;\n  }\n  .sidebarWidth9.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 600px;\n  }\n}\n.sidebarWidth10 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth10 .sidebarDrawer {\n    width: 640px;\n  }\n  .sidebarWidth10.sidebarPinned .panel {\n    right: 640px;\n  }\n  .sidebarWidth10.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 664px;\n  }\n}\n.sidebarWidth11 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth11 .sidebarDrawer {\n    width: 704px;\n  }\n  .sidebarWidth11.sidebarPinned .panel {\n    right: 704px;\n  }\n  .sidebarWidth11.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 728px;\n  }\n}\n.sidebarWidth12 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 840px) {\n  .sidebarWidth12 .sidebarDrawer {\n    width: 768px;\n  }\n  .sidebarWidth12.sidebarPinned .panel {\n    right: 768px;\n  }\n  .sidebarWidth12.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 792px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .sidebarWidth1 .sidebarDrawer {\n    width: 56px;\n  }\n  .sidebarWidth1.sidebarPinned .panel {\n    right: 56px;\n  }\n  .sidebarWidth1.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 80px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .sidebarWidth1 .sidebarDrawer {\n    width: 64px;\n  }\n  .sidebarWidth1.sidebarPinned .panel {\n    right: 64px;\n  }\n  .sidebarWidth1.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 88px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .sidebarWidth2 .sidebarDrawer {\n    width: 112px;\n  }\n  .sidebarWidth2.sidebarPinned .panel {\n    right: 112px;\n  }\n  .sidebarWidth2.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 136px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .sidebarWidth2 .sidebarDrawer {\n    width: 128px;\n  }\n  .sidebarWidth2.sidebarPinned .panel {\n    right: 128px;\n  }\n  .sidebarWidth2.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 152px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .sidebarWidth3 .sidebarDrawer {\n    width: 168px;\n  }\n  .sidebarWidth3.sidebarPinned .panel {\n    right: 168px;\n  }\n  .sidebarWidth3.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 192px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .sidebarWidth3 .sidebarDrawer {\n    width: 192px;\n  }\n  .sidebarWidth3.sidebarPinned .panel {\n    right: 192px;\n  }\n  .sidebarWidth3.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 216px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .sidebarWidth4 .sidebarDrawer {\n    width: 224px;\n  }\n  .sidebarWidth4.sidebarPinned .panel {\n    right: 224px;\n  }\n  .sidebarWidth4.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 248px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .sidebarWidth4 .sidebarDrawer {\n    width: 256px;\n  }\n  .sidebarWidth4.sidebarPinned .panel {\n    right: 256px;\n  }\n  .sidebarWidth4.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 280px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .sidebarWidth5 .sidebarDrawer {\n    width: 280px;\n  }\n  .sidebarWidth5.sidebarPinned .panel {\n    right: 280px;\n  }\n  .sidebarWidth5.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 304px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .sidebarWidth5 .sidebarDrawer {\n    width: 320px;\n  }\n  .sidebarWidth5.sidebarPinned .panel {\n    right: 320px;\n  }\n  .sidebarWidth5.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 344px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .sidebarWidth6 .sidebarDrawer {\n    width: 336px;\n  }\n  .sidebarWidth6.sidebarPinned .panel {\n    right: 336px;\n  }\n  .sidebarWidth6.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 360px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .sidebarWidth6 .sidebarDrawer {\n    width: 384px;\n  }\n  .sidebarWidth6.sidebarPinned .panel {\n    right: 384px;\n  }\n  .sidebarWidth6.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 408px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .sidebarWidth7 .sidebarDrawer {\n    width: 392px;\n  }\n  .sidebarWidth7.sidebarPinned .panel {\n    right: 392px;\n  }\n  .sidebarWidth7.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 416px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .sidebarWidth7 .sidebarDrawer {\n    width: 448px;\n  }\n  .sidebarWidth7.sidebarPinned .panel {\n    right: 448px;\n  }\n  .sidebarWidth7.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 472px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .sidebarWidth8 .sidebarDrawer {\n    width: 448px;\n  }\n  .sidebarWidth8.sidebarPinned .panel {\n    right: 448px;\n  }\n  .sidebarWidth8.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 472px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .sidebarWidth8 .sidebarDrawer {\n    width: 512px;\n  }\n  .sidebarWidth8.sidebarPinned .panel {\n    right: 512px;\n  }\n  .sidebarWidth8.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 536px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: landscape) {\n  .sidebarWidth9 .sidebarDrawer {\n    width: 504px;\n  }\n  .sidebarWidth9.sidebarPinned .panel {\n    right: 504px;\n  }\n  .sidebarWidth9.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 528px;\n  }\n}\n@media screen and (min-width: 600px) and (orientation: portrait) {\n  .sidebarWidth9 .sidebarDrawer {\n    width: 576px;\n  }\n  .sidebarWidth9.sidebarPinned .panel {\n    right: 576px;\n  }\n  .sidebarWidth9.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 600px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .sidebarWidth1 .sidebarDrawer {\n    width: 64px;\n  }\n  .sidebarWidth1.sidebarPinned .panel {\n    right: 64px;\n  }\n  .sidebarWidth1.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 88px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .sidebarWidth2 .sidebarDrawer {\n    width: 128px;\n  }\n  .sidebarWidth2.sidebarPinned .panel {\n    right: 128px;\n  }\n  .sidebarWidth2.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 152px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .sidebarWidth3 .sidebarDrawer {\n    width: 192px;\n  }\n  .sidebarWidth3.sidebarPinned .panel {\n    right: 192px;\n  }\n  .sidebarWidth3.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 216px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .sidebarWidth4 .sidebarDrawer {\n    width: 256px;\n  }\n  .sidebarWidth4.sidebarPinned .panel {\n    right: 256px;\n  }\n  .sidebarWidth4.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 280px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .sidebarWidth5 .sidebarDrawer {\n    width: 320px;\n  }\n  .sidebarWidth5.sidebarPinned .panel {\n    right: 320px;\n  }\n  .sidebarWidth5.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 344px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .sidebarWidth6 .sidebarDrawer {\n    width: 384px;\n  }\n  .sidebarWidth6.sidebarPinned .panel {\n    right: 384px;\n  }\n  .sidebarWidth6.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 408px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .sidebarWidth7 .sidebarDrawer {\n    width: 448px;\n  }\n  .sidebarWidth7.sidebarPinned .panel {\n    right: 448px;\n  }\n  .sidebarWidth7.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 472px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .sidebarWidth8 .sidebarDrawer {\n    width: 512px;\n  }\n  .sidebarWidth8.sidebarPinned .panel {\n    right: 512px;\n  }\n  .sidebarWidth8.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 536px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .sidebarWidth9 .sidebarDrawer {\n    width: 576px;\n  }\n  .sidebarWidth9.sidebarPinned .panel {\n    right: 576px;\n  }\n  .sidebarWidth9.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 600px;\n  }\n}\n@media screen and (min-width: 720px) {\n  .sidebarWidth10 .sidebarDrawer {\n    width: 640px;\n  }\n  .sidebarWidth10.sidebarPinned .panel {\n    right: 640px;\n  }\n  .sidebarWidth10.sidebarPinned:not(.sidebarClipped) .appbarAppBar {\n    padding-right: 664px;\n  }\n}\n.sidebarWidth25 .sidebarDrawer {\n  width: 100%;\n}\n.sidebarWidth33 .sidebarDrawer {\n  width: 100%;\n}\n.sidebarWidth50 .sidebarDrawer {\n  width: 100%;\n}\n.sidebarWidth66 .sidebarDrawer {\n  width: 100%;\n}\n.sidebarWidth75 .sidebarDrawer {\n  width: 100%;\n}\n.sidebarWidth100 .sidebarDrawer {\n  width: 100%;\n}\n@media screen and (min-width: 720px) {\n    .sidebarWidth25 .panel {\n    right: 25%;\n  }\n    .sidebarWidth25 .sidebarDrawer {\n    width: 25%;\n  }\n    .sidebarWidth25:not(.sidebarClipped) .appbarAppBar {\n    padding-right: calc(25% + 24px);\n  }\n    .sidebarWidth33 .panel {\n    right: 33%;\n  }\n    .sidebarWidth33 .sidebarDrawer {\n    width: 33%;\n  }\n    .sidebarWidth33:not(.sidebarClipped) .appbarAppBar {\n    padding-right: calc(33% + 24px);\n  }\n    .sidebarWidth50 .panel {\n    right: 50%;\n  }\n    .sidebarWidth50 .sidebarDrawer {\n    width: 50%;\n  }\n    .sidebarWidth50:not(.sidebarClipped) .appbarAppBar {\n    padding-right: calc(50% + 24px);\n  }\n    .sidebarWidth66 .panel {\n    right: 66%;\n  }\n    .sidebarWidth66 .sidebarDrawer {\n    width: 66%;\n  }\n    .sidebarWidth66:not(.sidebarClipped) .appbarAppBar {\n    padding-right: calc(66% + 24px);\n  }\n    .sidebarWidth75 .panel {\n    right: 75%;\n  }\n    .sidebarWidth75 .sidebarDrawer {\n    width: 75%;\n  }\n    .sidebarWidth75:not(.sidebarClipped) .appbarAppBar {\n    padding-right: calc(75% + 24px);\n  }\n    .sidebarWidth100 .panel {\n    right: 100%;\n  }\n    .sidebarWidth100 .sidebarDrawer {\n    width: 100%;\n  }\n    .sidebarWidth100:not(.sidebarClipped) .appbarAppBar {\n    padding-right: calc(100% + 24px);\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"layout": "theme--layout--rumm3SDi",
	"panel": "theme--panel--2tKiriHT",
	"bodyScroll": "theme--bodyScroll--1-JakArC",
	"sidebarDrawer": "theme--sidebarDrawer--2CI34OR_",
	"navDrawerDrawer": "theme--navDrawerDrawer--32OlLFqO",
	"pinned": "theme--pinned--1uhbihgs",
	"clipped": "theme--clipped--1fu9EmcV",
	"appbarInner": "theme--appbarInner--2c02_JWo",
	"appbarFixed": "theme--appbarFixed--3eFSx03J",
	"appbarAppBar": "theme--appbarAppBar--3vOCSxHS",
	"navDrawerPinned": "theme--navDrawerPinned--2W7Wu93L",
	"appbarLeftIcon": "theme--appbarLeftIcon--2kB39wQv",
	"navDrawerClipped": "theme--navDrawerClipped--3B95n0s7",
	"navDrawerWrapper": "theme--navDrawerWrapper--2CO1O7fo",
	"sidebarPinned": "theme--sidebarPinned--2lM_ZsAk",
	"sidebarClipped": "theme--sidebarClipped--3YrfJ-7G",
	"sidebarWrapper": "theme--sidebarWrapper--1Jr6plax",
	"sidebarWidth1": "theme--sidebarWidth1--1J_y3jDO",
	"sidebarWidth2": "theme--sidebarWidth2--Z3_CyU3i",
	"sidebarWidth3": "theme--sidebarWidth3--1GnpmQgp",
	"sidebarWidth4": "theme--sidebarWidth4--2b2Qv473",
	"sidebarWidth5": "theme--sidebarWidth5--2D3Lwr7X",
	"sidebarWidth6": "theme--sidebarWidth6--3Hg1RS7O",
	"sidebarWidth7": "theme--sidebarWidth7--3jcfBQwi",
	"sidebarWidth8": "theme--sidebarWidth8--1sMyc6aK",
	"sidebarWidth9": "theme--sidebarWidth9--3qZyZfyh",
	"sidebarWidth10": "theme--sidebarWidth10--3sMSLhXc",
	"sidebarWidth11": "theme--sidebarWidth11--2BMVApY3",
	"sidebarWidth12": "theme--sidebarWidth12--22TuYbVW",
	"sidebarWidth25": "theme--sidebarWidth25--2ff3MeMg",
	"sidebarWidth33": "theme--sidebarWidth33--1CGPE9iQ",
	"sidebarWidth50": "theme--sidebarWidth50--3gxaRB1n",
	"sidebarWidth66": "theme--sidebarWidth66--2UwEiydP",
	"sidebarWidth75": "theme--sidebarWidth75--1qO0w6o8",
	"sidebarWidth100": "theme--sidebarWidth100--M1UR8il0"
};

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1804);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/* Orientation */\n/* Devices (defined by max width) */\n/* Devices (defined by min-width) */\n.theme--wrapper--2b3tN19t {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100vh;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 200;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.theme--wrapper--2b3tN19t *,\n    .theme--wrapper--2b3tN19t *::after,\n    .theme--wrapper--2b3tN19t *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--dialog--rMK_ktAb {\n  background-color: rgb(255, 255, 255);\n  border-radius: 2px;\n  box-shadow: 0 19px 60px rgba(0, 0, 0, .3), 0 15px 20px rgba(0, 0, 0, .22);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  max-height: 96vh;\n  max-width: 96vw;\n  opacity: 0;\n  overflow: hidden;\n  -webkit-transform: translateY(-40px);\n          transform: translateY(-40px);\n  transition:\n    opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n    -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition:\n    opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n    transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition:\n    opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n    transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n    -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition-delay: 0.07s\n}\n.theme--dialog--rMK_ktAb.theme--active--3h1dIap1 {\n  opacity: 1;\n  -webkit-transform: translateY(0%);\n          transform: translateY(0%);\n}\n.theme--small--1JpL9MHb {\n  width: 30vw;\n}\n@media screen and (max-width: 720px) {\n  .theme--small--1JpL9MHb {\n    width: 50vw;\n  }\n}\n@media screen and (max-width: 600px) {\n  .theme--small--1JpL9MHb {\n    width: 75vw;\n  }\n}\n.theme--normal--1X1EcorX {\n  width: 50vw;\n}\n@media screen and (max-width: 600px) {\n  .theme--normal--1X1EcorX {\n    width: 96vw;\n  }\n}\n.theme--large--LLFVtLMJ {\n  width: 96vw;\n}\n.theme--fullscreen--2knRsunm {\n  width: 96vw;\n}\n@media screen and (max-width: 600px) {\n  .theme--fullscreen--2knRsunm {\n    border-radius: 0;\n    max-height: 100vh;\n    max-width: 100vw;\n    min-height: 100vh;\n    width: 100vw;\n  }\n}\n.theme--title--15Pbz4W0 {\n  color: rgb(0, 0, 0);\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  line-height: 1;\n  margin: 0 0 16px;\n}\n.theme--body--2gv1o00s {\n  color: rgb(117, 117, 117);\n  -webkit-box-flex: 2;\n      -ms-flex-positive: 2;\n          flex-grow: 2;\n  padding: 24px\n}\n.theme--body--2gv1o00s p {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 24px;\n  margin: 0;\n}\n.theme--navigation--1agKAgKw {\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0;\n  padding: 8px;\n  text-align: right;\n}\n.theme--button--x5dNHbmZ {\n  margin-left: 8px;\n  min-width: 0;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/dialog/theme.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB,oCAAoC;AACpC,oCAAoC;AACpC;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;CAChC;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,qCAAqC;EACrC,mBAAmB;EACnB,0EAA0E;EAC1E,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,qCAAqC;UAC7B,6BAA6B;EACrC;;yDAEuD;EACvD;;iDAE+C;EAC/C;;;yDAGuD;EACvD,uBAAuB;CACxB;AACD;EACE,WAAW;EACX,kCAAkC;UAC1B,0BAA0B;CACnC;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,YAAY;GACb;CACF;AACD;EACE;IACE,YAAY;GACb;CACF;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,YAAY;GACb;CACF;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;CACb;AACD;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;GACd;CACF;AACD;EACE,oBAAoB;EACpB,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;CAClB;AACD;EACE,0BAA0B;EAC1B,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;EACrB,aAAa;CACd;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;CACX;AACD;EACE,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;EACrB,aAAa;EACb,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;CACpB","file":"theme.css","sourcesContent":["/* Orientation */\n/* Devices (defined by max width) */\n/* Devices (defined by min-width) */\n.wrapper {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100vh;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 200;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.wrapper *,\n    .wrapper *::after,\n    .wrapper *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.dialog {\n  background-color: rgb(255, 255, 255);\n  border-radius: 2px;\n  box-shadow: 0 19px 60px rgba(0, 0, 0, .3), 0 15px 20px rgba(0, 0, 0, .22);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  max-height: 96vh;\n  max-width: 96vw;\n  opacity: 0;\n  overflow: hidden;\n  -webkit-transform: translateY(-40px);\n          transform: translateY(-40px);\n  transition:\n    opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n    -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition:\n    opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n    transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition:\n    opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n    transform 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n    -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition-delay: 0.07s\n}\n.dialog.active {\n  opacity: 1;\n  -webkit-transform: translateY(0%);\n          transform: translateY(0%);\n}\n.small {\n  width: 30vw;\n}\n@media screen and (max-width: 720px) {\n  .small {\n    width: 50vw;\n  }\n}\n@media screen and (max-width: 600px) {\n  .small {\n    width: 75vw;\n  }\n}\n.normal {\n  width: 50vw;\n}\n@media screen and (max-width: 600px) {\n  .normal {\n    width: 96vw;\n  }\n}\n.large {\n  width: 96vw;\n}\n.fullscreen {\n  width: 96vw;\n}\n@media screen and (max-width: 600px) {\n  .fullscreen {\n    border-radius: 0;\n    max-height: 100vh;\n    max-width: 100vw;\n    min-height: 100vh;\n    width: 100vw;\n  }\n}\n.title {\n  color: rgb(0, 0, 0);\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  line-height: 1;\n  margin: 0 0 16px;\n}\n.body {\n  color: rgb(117, 117, 117);\n  -webkit-box-flex: 2;\n      -ms-flex-positive: 2;\n          flex-grow: 2;\n  padding: 24px\n}\n.body p {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 24px;\n  margin: 0;\n}\n.navigation {\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0;\n  padding: 8px;\n  text-align: right;\n}\n.button {\n  margin-left: 8px;\n  min-width: 0;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"wrapper": "theme--wrapper--2b3tN19t",
	"dialog": "theme--dialog--rMK_ktAb",
	"active": "theme--active--3h1dIap1",
	"small": "theme--small--1JpL9MHb",
	"normal": "theme--normal--1X1EcorX",
	"large": "theme--large--LLFVtLMJ",
	"fullscreen": "theme--fullscreen--2knRsunm",
	"title": "theme--title--15Pbz4W0",
	"body": "theme--body--2gv1o00s",
	"navigation": "theme--navigation--1agKAgKw",
	"button": "theme--button--x5dNHbmZ"
};

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

// GENERATED DO NOT EDIT
module.exports = [
  "alignContent",
  "MozAlignContent",
  "WebkitAlignContent",
  "MSAlignContent",
  "OAlignContent",
  "alignItems",
  "MozAlignItems",
  "WebkitAlignItems",
  "MSAlignItems",
  "OAlignItems",
  "alignSelf",
  "MozAlignSelf",
  "WebkitAlignSelf",
  "MSAlignSelf",
  "OAlignSelf",
  "all",
  "MozAll",
  "WebkitAll",
  "MSAll",
  "OAll",
  "animation",
  "MozAnimation",
  "WebkitAnimation",
  "MSAnimation",
  "OAnimation",
  "animationDelay",
  "MozAnimationDelay",
  "WebkitAnimationDelay",
  "MSAnimationDelay",
  "OAnimationDelay",
  "animationDirection",
  "MozAnimationDirection",
  "WebkitAnimationDirection",
  "MSAnimationDirection",
  "OAnimationDirection",
  "animationDuration",
  "MozAnimationDuration",
  "WebkitAnimationDuration",
  "MSAnimationDuration",
  "OAnimationDuration",
  "animationFillMode",
  "MozAnimationFillMode",
  "WebkitAnimationFillMode",
  "MSAnimationFillMode",
  "OAnimationFillMode",
  "animationIterationCount",
  "MozAnimationIterationCount",
  "WebkitAnimationIterationCount",
  "MSAnimationIterationCount",
  "OAnimationIterationCount",
  "animationName",
  "MozAnimationName",
  "WebkitAnimationName",
  "MSAnimationName",
  "OAnimationName",
  "animationPlayState",
  "MozAnimationPlayState",
  "WebkitAnimationPlayState",
  "MSAnimationPlayState",
  "OAnimationPlayState",
  "animationTimingFunction",
  "MozAnimationTimingFunction",
  "WebkitAnimationTimingFunction",
  "MSAnimationTimingFunction",
  "OAnimationTimingFunction",
  "backfaceVisibility",
  "MozBackfaceVisibility",
  "WebkitBackfaceVisibility",
  "MSBackfaceVisibility",
  "OBackfaceVisibility",
  "background",
  "MozBackground",
  "WebkitBackground",
  "MSBackground",
  "OBackground",
  "backgroundAttachment",
  "MozBackgroundAttachment",
  "WebkitBackgroundAttachment",
  "MSBackgroundAttachment",
  "OBackgroundAttachment",
  "backgroundBlendMode",
  "MozBackgroundBlendMode",
  "WebkitBackgroundBlendMode",
  "MSBackgroundBlendMode",
  "OBackgroundBlendMode",
  "backgroundClip",
  "MozBackgroundClip",
  "WebkitBackgroundClip",
  "MSBackgroundClip",
  "OBackgroundClip",
  "backgroundColor",
  "MozBackgroundColor",
  "WebkitBackgroundColor",
  "MSBackgroundColor",
  "OBackgroundColor",
  "backgroundImage",
  "MozBackgroundImage",
  "WebkitBackgroundImage",
  "MSBackgroundImage",
  "OBackgroundImage",
  "backgroundOrigin",
  "MozBackgroundOrigin",
  "WebkitBackgroundOrigin",
  "MSBackgroundOrigin",
  "OBackgroundOrigin",
  "backgroundPosition",
  "MozBackgroundPosition",
  "WebkitBackgroundPosition",
  "MSBackgroundPosition",
  "OBackgroundPosition",
  "backgroundRepeat",
  "MozBackgroundRepeat",
  "WebkitBackgroundRepeat",
  "MSBackgroundRepeat",
  "OBackgroundRepeat",
  "backgroundSize",
  "MozBackgroundSize",
  "WebkitBackgroundSize",
  "MSBackgroundSize",
  "OBackgroundSize",
  "blockSize",
  "MozBlockSize",
  "WebkitBlockSize",
  "MSBlockSize",
  "OBlockSize",
  "border",
  "MozBorder",
  "WebkitBorder",
  "MSBorder",
  "OBorder",
  "borderBlockEnd",
  "MozBorderBlockEnd",
  "WebkitBorderBlockEnd",
  "MSBorderBlockEnd",
  "OBorderBlockEnd",
  "borderBlockEndColor",
  "MozBorderBlockEndColor",
  "WebkitBorderBlockEndColor",
  "MSBorderBlockEndColor",
  "OBorderBlockEndColor",
  "borderBlockEndStyle",
  "MozBorderBlockEndStyle",
  "WebkitBorderBlockEndStyle",
  "MSBorderBlockEndStyle",
  "OBorderBlockEndStyle",
  "borderBlockEndWidth",
  "MozBorderBlockEndWidth",
  "WebkitBorderBlockEndWidth",
  "MSBorderBlockEndWidth",
  "OBorderBlockEndWidth",
  "borderBlockStart",
  "MozBorderBlockStart",
  "WebkitBorderBlockStart",
  "MSBorderBlockStart",
  "OBorderBlockStart",
  "borderBlockStartColor",
  "MozBorderBlockStartColor",
  "WebkitBorderBlockStartColor",
  "MSBorderBlockStartColor",
  "OBorderBlockStartColor",
  "borderBlockStartStyle",
  "MozBorderBlockStartStyle",
  "WebkitBorderBlockStartStyle",
  "MSBorderBlockStartStyle",
  "OBorderBlockStartStyle",
  "borderBlockStartWidth",
  "MozBorderBlockStartWidth",
  "WebkitBorderBlockStartWidth",
  "MSBorderBlockStartWidth",
  "OBorderBlockStartWidth",
  "borderBottom",
  "MozBorderBottom",
  "WebkitBorderBottom",
  "MSBorderBottom",
  "OBorderBottom",
  "borderBottomColor",
  "MozBorderBottomColor",
  "WebkitBorderBottomColor",
  "MSBorderBottomColor",
  "OBorderBottomColor",
  "borderBottomLeftRadius",
  "MozBorderBottomLeftRadius",
  "WebkitBorderBottomLeftRadius",
  "MSBorderBottomLeftRadius",
  "OBorderBottomLeftRadius",
  "borderBottomRightRadius",
  "MozBorderBottomRightRadius",
  "WebkitBorderBottomRightRadius",
  "MSBorderBottomRightRadius",
  "OBorderBottomRightRadius",
  "borderBottomStyle",
  "MozBorderBottomStyle",
  "WebkitBorderBottomStyle",
  "MSBorderBottomStyle",
  "OBorderBottomStyle",
  "borderBottomWidth",
  "MozBorderBottomWidth",
  "WebkitBorderBottomWidth",
  "MSBorderBottomWidth",
  "OBorderBottomWidth",
  "borderCollapse",
  "MozBorderCollapse",
  "WebkitBorderCollapse",
  "MSBorderCollapse",
  "OBorderCollapse",
  "borderColor",
  "MozBorderColor",
  "WebkitBorderColor",
  "MSBorderColor",
  "OBorderColor",
  "borderImage",
  "MozBorderImage",
  "WebkitBorderImage",
  "MSBorderImage",
  "OBorderImage",
  "borderImageOutset",
  "MozBorderImageOutset",
  "WebkitBorderImageOutset",
  "MSBorderImageOutset",
  "OBorderImageOutset",
  "borderImageRepeat",
  "MozBorderImageRepeat",
  "WebkitBorderImageRepeat",
  "MSBorderImageRepeat",
  "OBorderImageRepeat",
  "borderImageSlice",
  "MozBorderImageSlice",
  "WebkitBorderImageSlice",
  "MSBorderImageSlice",
  "OBorderImageSlice",
  "borderImageSource",
  "MozBorderImageSource",
  "WebkitBorderImageSource",
  "MSBorderImageSource",
  "OBorderImageSource",
  "borderImageWidth",
  "MozBorderImageWidth",
  "WebkitBorderImageWidth",
  "MSBorderImageWidth",
  "OBorderImageWidth",
  "borderInlineEnd",
  "MozBorderInlineEnd",
  "WebkitBorderInlineEnd",
  "MSBorderInlineEnd",
  "OBorderInlineEnd",
  "borderInlineEndColor",
  "MozBorderInlineEndColor",
  "WebkitBorderInlineEndColor",
  "MSBorderInlineEndColor",
  "OBorderInlineEndColor",
  "borderInlineEndStyle",
  "MozBorderInlineEndStyle",
  "WebkitBorderInlineEndStyle",
  "MSBorderInlineEndStyle",
  "OBorderInlineEndStyle",
  "borderInlineEndWidth",
  "MozBorderInlineEndWidth",
  "WebkitBorderInlineEndWidth",
  "MSBorderInlineEndWidth",
  "OBorderInlineEndWidth",
  "borderInlineStart",
  "MozBorderInlineStart",
  "WebkitBorderInlineStart",
  "MSBorderInlineStart",
  "OBorderInlineStart",
  "borderInlineStartColor",
  "MozBorderInlineStartColor",
  "WebkitBorderInlineStartColor",
  "MSBorderInlineStartColor",
  "OBorderInlineStartColor",
  "borderInlineStartStyle",
  "MozBorderInlineStartStyle",
  "WebkitBorderInlineStartStyle",
  "MSBorderInlineStartStyle",
  "OBorderInlineStartStyle",
  "borderInlineStartWidth",
  "MozBorderInlineStartWidth",
  "WebkitBorderInlineStartWidth",
  "MSBorderInlineStartWidth",
  "OBorderInlineStartWidth",
  "borderLeft",
  "MozBorderLeft",
  "WebkitBorderLeft",
  "MSBorderLeft",
  "OBorderLeft",
  "borderLeftColor",
  "MozBorderLeftColor",
  "WebkitBorderLeftColor",
  "MSBorderLeftColor",
  "OBorderLeftColor",
  "borderLeftStyle",
  "MozBorderLeftStyle",
  "WebkitBorderLeftStyle",
  "MSBorderLeftStyle",
  "OBorderLeftStyle",
  "borderLeftWidth",
  "MozBorderLeftWidth",
  "WebkitBorderLeftWidth",
  "MSBorderLeftWidth",
  "OBorderLeftWidth",
  "borderRadius",
  "MozBorderRadius",
  "WebkitBorderRadius",
  "MSBorderRadius",
  "OBorderRadius",
  "borderRight",
  "MozBorderRight",
  "WebkitBorderRight",
  "MSBorderRight",
  "OBorderRight",
  "borderRightColor",
  "MozBorderRightColor",
  "WebkitBorderRightColor",
  "MSBorderRightColor",
  "OBorderRightColor",
  "borderRightStyle",
  "MozBorderRightStyle",
  "WebkitBorderRightStyle",
  "MSBorderRightStyle",
  "OBorderRightStyle",
  "borderRightWidth",
  "MozBorderRightWidth",
  "WebkitBorderRightWidth",
  "MSBorderRightWidth",
  "OBorderRightWidth",
  "borderSpacing",
  "MozBorderSpacing",
  "WebkitBorderSpacing",
  "MSBorderSpacing",
  "OBorderSpacing",
  "borderStyle",
  "MozBorderStyle",
  "WebkitBorderStyle",
  "MSBorderStyle",
  "OBorderStyle",
  "borderTop",
  "MozBorderTop",
  "WebkitBorderTop",
  "MSBorderTop",
  "OBorderTop",
  "borderTopColor",
  "MozBorderTopColor",
  "WebkitBorderTopColor",
  "MSBorderTopColor",
  "OBorderTopColor",
  "borderTopLeftRadius",
  "MozBorderTopLeftRadius",
  "WebkitBorderTopLeftRadius",
  "MSBorderTopLeftRadius",
  "OBorderTopLeftRadius",
  "borderTopRightRadius",
  "MozBorderTopRightRadius",
  "WebkitBorderTopRightRadius",
  "MSBorderTopRightRadius",
  "OBorderTopRightRadius",
  "borderTopStyle",
  "MozBorderTopStyle",
  "WebkitBorderTopStyle",
  "MSBorderTopStyle",
  "OBorderTopStyle",
  "borderTopWidth",
  "MozBorderTopWidth",
  "WebkitBorderTopWidth",
  "MSBorderTopWidth",
  "OBorderTopWidth",
  "borderWidth",
  "MozBorderWidth",
  "WebkitBorderWidth",
  "MSBorderWidth",
  "OBorderWidth",
  "bottom",
  "MozBottom",
  "WebkitBottom",
  "MSBottom",
  "OBottom",
  "boxDecorationBreak",
  "MozBoxDecorationBreak",
  "WebkitBoxDecorationBreak",
  "MSBoxDecorationBreak",
  "OBoxDecorationBreak",
  "boxShadow",
  "MozBoxShadow",
  "WebkitBoxShadow",
  "MSBoxShadow",
  "OBoxShadow",
  "boxSizing",
  "MozBoxSizing",
  "WebkitBoxSizing",
  "MSBoxSizing",
  "OBoxSizing",
  "breakAfter",
  "MozBreakAfter",
  "WebkitBreakAfter",
  "MSBreakAfter",
  "OBreakAfter",
  "breakBefore",
  "MozBreakBefore",
  "WebkitBreakBefore",
  "MSBreakBefore",
  "OBreakBefore",
  "breakInside",
  "MozBreakInside",
  "WebkitBreakInside",
  "MSBreakInside",
  "OBreakInside",
  "captionSide",
  "MozCaptionSide",
  "WebkitCaptionSide",
  "MSCaptionSide",
  "OCaptionSide",
  "caretColor",
  "MozCaretColor",
  "WebkitCaretColor",
  "MSCaretColor",
  "OCaretColor",
  "ch",
  "MozCh",
  "WebkitCh",
  "MSCh",
  "OCh",
  "clear",
  "MozClear",
  "WebkitClear",
  "MSClear",
  "OClear",
  "clip",
  "MozClip",
  "WebkitClip",
  "MSClip",
  "OClip",
  "clipPath",
  "MozClipPath",
  "WebkitClipPath",
  "MSClipPath",
  "OClipPath",
  "cm",
  "MozCm",
  "WebkitCm",
  "MSCm",
  "OCm",
  "color",
  "MozColor",
  "WebkitColor",
  "MSColor",
  "OColor",
  "columnCount",
  "MozColumnCount",
  "WebkitColumnCount",
  "MSColumnCount",
  "OColumnCount",
  "columnFill",
  "MozColumnFill",
  "WebkitColumnFill",
  "MSColumnFill",
  "OColumnFill",
  "columnGap",
  "MozColumnGap",
  "WebkitColumnGap",
  "MSColumnGap",
  "OColumnGap",
  "columnRule",
  "MozColumnRule",
  "WebkitColumnRule",
  "MSColumnRule",
  "OColumnRule",
  "columnRuleColor",
  "MozColumnRuleColor",
  "WebkitColumnRuleColor",
  "MSColumnRuleColor",
  "OColumnRuleColor",
  "columnRuleStyle",
  "MozColumnRuleStyle",
  "WebkitColumnRuleStyle",
  "MSColumnRuleStyle",
  "OColumnRuleStyle",
  "columnRuleWidth",
  "MozColumnRuleWidth",
  "WebkitColumnRuleWidth",
  "MSColumnRuleWidth",
  "OColumnRuleWidth",
  "columnSpan",
  "MozColumnSpan",
  "WebkitColumnSpan",
  "MSColumnSpan",
  "OColumnSpan",
  "columnWidth",
  "MozColumnWidth",
  "WebkitColumnWidth",
  "MSColumnWidth",
  "OColumnWidth",
  "columns",
  "MozColumns",
  "WebkitColumns",
  "MSColumns",
  "OColumns",
  "content",
  "MozContent",
  "WebkitContent",
  "MSContent",
  "OContent",
  "counterIncrement",
  "MozCounterIncrement",
  "WebkitCounterIncrement",
  "MSCounterIncrement",
  "OCounterIncrement",
  "counterReset",
  "MozCounterReset",
  "WebkitCounterReset",
  "MSCounterReset",
  "OCounterReset",
  "cursor",
  "MozCursor",
  "WebkitCursor",
  "MSCursor",
  "OCursor",
  "deg",
  "MozDeg",
  "WebkitDeg",
  "MSDeg",
  "ODeg",
  "direction",
  "MozDirection",
  "WebkitDirection",
  "MSDirection",
  "ODirection",
  "display",
  "MozDisplay",
  "WebkitDisplay",
  "MSDisplay",
  "ODisplay",
  "dpcm",
  "MozDpcm",
  "WebkitDpcm",
  "MSDpcm",
  "ODpcm",
  "dpi",
  "MozDpi",
  "WebkitDpi",
  "MSDpi",
  "ODpi",
  "dppx",
  "MozDppx",
  "WebkitDppx",
  "MSDppx",
  "ODppx",
  "em",
  "MozEm",
  "WebkitEm",
  "MSEm",
  "OEm",
  "emptyCells",
  "MozEmptyCells",
  "WebkitEmptyCells",
  "MSEmptyCells",
  "OEmptyCells",
  "ex",
  "MozEx",
  "WebkitEx",
  "MSEx",
  "OEx",
  "filter",
  "MozFilter",
  "WebkitFilter",
  "MSFilter",
  "OFilter",
  "flexBasis",
  "MozFlexBasis",
  "WebkitFlexBasis",
  "MSFlexBasis",
  "OFlexBasis",
  "flexDirection",
  "MozFlexDirection",
  "WebkitFlexDirection",
  "MSFlexDirection",
  "OFlexDirection",
  "flexFlow",
  "MozFlexFlow",
  "WebkitFlexFlow",
  "MSFlexFlow",
  "OFlexFlow",
  "flexGrow",
  "MozFlexGrow",
  "WebkitFlexGrow",
  "MSFlexGrow",
  "OFlexGrow",
  "flexShrink",
  "MozFlexShrink",
  "WebkitFlexShrink",
  "MSFlexShrink",
  "OFlexShrink",
  "flexWrap",
  "MozFlexWrap",
  "WebkitFlexWrap",
  "MSFlexWrap",
  "OFlexWrap",
  "float",
  "MozFloat",
  "WebkitFloat",
  "MSFloat",
  "OFloat",
  "font",
  "MozFont",
  "WebkitFont",
  "MSFont",
  "OFont",
  "fontFamily",
  "MozFontFamily",
  "WebkitFontFamily",
  "MSFontFamily",
  "OFontFamily",
  "fontFeatureSettings",
  "MozFontFeatureSettings",
  "WebkitFontFeatureSettings",
  "MSFontFeatureSettings",
  "OFontFeatureSettings",
  "fontKerning",
  "MozFontKerning",
  "WebkitFontKerning",
  "MSFontKerning",
  "OFontKerning",
  "fontLanguageOverride",
  "MozFontLanguageOverride",
  "WebkitFontLanguageOverride",
  "MSFontLanguageOverride",
  "OFontLanguageOverride",
  "fontSize",
  "MozFontSize",
  "WebkitFontSize",
  "MSFontSize",
  "OFontSize",
  "fontSizeAdjust",
  "MozFontSizeAdjust",
  "WebkitFontSizeAdjust",
  "MSFontSizeAdjust",
  "OFontSizeAdjust",
  "fontStretch",
  "MozFontStretch",
  "WebkitFontStretch",
  "MSFontStretch",
  "OFontStretch",
  "fontStyle",
  "MozFontStyle",
  "WebkitFontStyle",
  "MSFontStyle",
  "OFontStyle",
  "fontSynthesis",
  "MozFontSynthesis",
  "WebkitFontSynthesis",
  "MSFontSynthesis",
  "OFontSynthesis",
  "fontVariant",
  "MozFontVariant",
  "WebkitFontVariant",
  "MSFontVariant",
  "OFontVariant",
  "fontVariantAlternates",
  "MozFontVariantAlternates",
  "WebkitFontVariantAlternates",
  "MSFontVariantAlternates",
  "OFontVariantAlternates",
  "fontVariantCaps",
  "MozFontVariantCaps",
  "WebkitFontVariantCaps",
  "MSFontVariantCaps",
  "OFontVariantCaps",
  "fontVariantEastAsian",
  "MozFontVariantEastAsian",
  "WebkitFontVariantEastAsian",
  "MSFontVariantEastAsian",
  "OFontVariantEastAsian",
  "fontVariantLigatures",
  "MozFontVariantLigatures",
  "WebkitFontVariantLigatures",
  "MSFontVariantLigatures",
  "OFontVariantLigatures",
  "fontVariantNumeric",
  "MozFontVariantNumeric",
  "WebkitFontVariantNumeric",
  "MSFontVariantNumeric",
  "OFontVariantNumeric",
  "fontVariantPosition",
  "MozFontVariantPosition",
  "WebkitFontVariantPosition",
  "MSFontVariantPosition",
  "OFontVariantPosition",
  "fontWeight",
  "MozFontWeight",
  "WebkitFontWeight",
  "MSFontWeight",
  "OFontWeight",
  "fr",
  "MozFr",
  "WebkitFr",
  "MSFr",
  "OFr",
  "grad",
  "MozGrad",
  "WebkitGrad",
  "MSGrad",
  "OGrad",
  "grid",
  "MozGrid",
  "WebkitGrid",
  "MSGrid",
  "OGrid",
  "gridArea",
  "MozGridArea",
  "WebkitGridArea",
  "MSGridArea",
  "OGridArea",
  "gridAutoColumns",
  "MozGridAutoColumns",
  "WebkitGridAutoColumns",
  "MSGridAutoColumns",
  "OGridAutoColumns",
  "gridAutoFlow",
  "MozGridAutoFlow",
  "WebkitGridAutoFlow",
  "MSGridAutoFlow",
  "OGridAutoFlow",
  "gridAutoRows",
  "MozGridAutoRows",
  "WebkitGridAutoRows",
  "MSGridAutoRows",
  "OGridAutoRows",
  "gridColumn",
  "MozGridColumn",
  "WebkitGridColumn",
  "MSGridColumn",
  "OGridColumn",
  "gridColumnEnd",
  "MozGridColumnEnd",
  "WebkitGridColumnEnd",
  "MSGridColumnEnd",
  "OGridColumnEnd",
  "gridColumnGap",
  "MozGridColumnGap",
  "WebkitGridColumnGap",
  "MSGridColumnGap",
  "OGridColumnGap",
  "gridColumnStart",
  "MozGridColumnStart",
  "WebkitGridColumnStart",
  "MSGridColumnStart",
  "OGridColumnStart",
  "gridGap",
  "MozGridGap",
  "WebkitGridGap",
  "MSGridGap",
  "OGridGap",
  "gridRow",
  "MozGridRow",
  "WebkitGridRow",
  "MSGridRow",
  "OGridRow",
  "gridRowEnd",
  "MozGridRowEnd",
  "WebkitGridRowEnd",
  "MSGridRowEnd",
  "OGridRowEnd",
  "gridRowGap",
  "MozGridRowGap",
  "WebkitGridRowGap",
  "MSGridRowGap",
  "OGridRowGap",
  "gridRowStart",
  "MozGridRowStart",
  "WebkitGridRowStart",
  "MSGridRowStart",
  "OGridRowStart",
  "gridTemplate",
  "MozGridTemplate",
  "WebkitGridTemplate",
  "MSGridTemplate",
  "OGridTemplate",
  "gridTemplateAreas",
  "MozGridTemplateAreas",
  "WebkitGridTemplateAreas",
  "MSGridTemplateAreas",
  "OGridTemplateAreas",
  "gridTemplateColumns",
  "MozGridTemplateColumns",
  "WebkitGridTemplateColumns",
  "MSGridTemplateColumns",
  "OGridTemplateColumns",
  "gridTemplateRows",
  "MozGridTemplateRows",
  "WebkitGridTemplateRows",
  "MSGridTemplateRows",
  "OGridTemplateRows",
  "height",
  "MozHeight",
  "WebkitHeight",
  "MSHeight",
  "OHeight",
  "hyphens",
  "MozHyphens",
  "WebkitHyphens",
  "MSHyphens",
  "OHyphens",
  "hz",
  "MozHz",
  "WebkitHz",
  "MSHz",
  "OHz",
  "imageOrientation",
  "MozImageOrientation",
  "WebkitImageOrientation",
  "MSImageOrientation",
  "OImageOrientation",
  "imageRendering",
  "MozImageRendering",
  "WebkitImageRendering",
  "MSImageRendering",
  "OImageRendering",
  "imageResolution",
  "MozImageResolution",
  "WebkitImageResolution",
  "MSImageResolution",
  "OImageResolution",
  "imeMode",
  "MozImeMode",
  "WebkitImeMode",
  "MSImeMode",
  "OImeMode",
  "in",
  "MozIn",
  "WebkitIn",
  "MSIn",
  "OIn",
  "inherit",
  "MozInherit",
  "WebkitInherit",
  "MSInherit",
  "OInherit",
  "initial",
  "MozInitial",
  "WebkitInitial",
  "MSInitial",
  "OInitial",
  "inlineSize",
  "MozInlineSize",
  "WebkitInlineSize",
  "MSInlineSize",
  "OInlineSize",
  "isolation",
  "MozIsolation",
  "WebkitIsolation",
  "MSIsolation",
  "OIsolation",
  "justifyContent",
  "MozJustifyContent",
  "WebkitJustifyContent",
  "MSJustifyContent",
  "OJustifyContent",
  "khz",
  "MozKhz",
  "WebkitKhz",
  "MSKhz",
  "OKhz",
  "left",
  "MozLeft",
  "WebkitLeft",
  "MSLeft",
  "OLeft",
  "letterSpacing",
  "MozLetterSpacing",
  "WebkitLetterSpacing",
  "MSLetterSpacing",
  "OLetterSpacing",
  "lineBreak",
  "MozLineBreak",
  "WebkitLineBreak",
  "MSLineBreak",
  "OLineBreak",
  "lineHeight",
  "MozLineHeight",
  "WebkitLineHeight",
  "MSLineHeight",
  "OLineHeight",
  "listStyle",
  "MozListStyle",
  "WebkitListStyle",
  "MSListStyle",
  "OListStyle",
  "listStyleImage",
  "MozListStyleImage",
  "WebkitListStyleImage",
  "MSListStyleImage",
  "OListStyleImage",
  "listStylePosition",
  "MozListStylePosition",
  "WebkitListStylePosition",
  "MSListStylePosition",
  "OListStylePosition",
  "listStyleType",
  "MozListStyleType",
  "WebkitListStyleType",
  "MSListStyleType",
  "OListStyleType",
  "margin",
  "MozMargin",
  "WebkitMargin",
  "MSMargin",
  "OMargin",
  "marginBlockEnd",
  "MozMarginBlockEnd",
  "WebkitMarginBlockEnd",
  "MSMarginBlockEnd",
  "OMarginBlockEnd",
  "marginBlockStart",
  "MozMarginBlockStart",
  "WebkitMarginBlockStart",
  "MSMarginBlockStart",
  "OMarginBlockStart",
  "marginBottom",
  "MozMarginBottom",
  "WebkitMarginBottom",
  "MSMarginBottom",
  "OMarginBottom",
  "marginInlineEnd",
  "MozMarginInlineEnd",
  "WebkitMarginInlineEnd",
  "MSMarginInlineEnd",
  "OMarginInlineEnd",
  "marginInlineStart",
  "MozMarginInlineStart",
  "WebkitMarginInlineStart",
  "MSMarginInlineStart",
  "OMarginInlineStart",
  "marginLeft",
  "MozMarginLeft",
  "WebkitMarginLeft",
  "MSMarginLeft",
  "OMarginLeft",
  "marginRight",
  "MozMarginRight",
  "WebkitMarginRight",
  "MSMarginRight",
  "OMarginRight",
  "marginTop",
  "MozMarginTop",
  "WebkitMarginTop",
  "MSMarginTop",
  "OMarginTop",
  "mask",
  "MozMask",
  "WebkitMask",
  "MSMask",
  "OMask",
  "maskClip",
  "MozMaskClip",
  "WebkitMaskClip",
  "MSMaskClip",
  "OMaskClip",
  "maskComposite",
  "MozMaskComposite",
  "WebkitMaskComposite",
  "MSMaskComposite",
  "OMaskComposite",
  "maskImage",
  "MozMaskImage",
  "WebkitMaskImage",
  "MSMaskImage",
  "OMaskImage",
  "maskMode",
  "MozMaskMode",
  "WebkitMaskMode",
  "MSMaskMode",
  "OMaskMode",
  "maskOrigin",
  "MozMaskOrigin",
  "WebkitMaskOrigin",
  "MSMaskOrigin",
  "OMaskOrigin",
  "maskPosition",
  "MozMaskPosition",
  "WebkitMaskPosition",
  "MSMaskPosition",
  "OMaskPosition",
  "maskRepeat",
  "MozMaskRepeat",
  "WebkitMaskRepeat",
  "MSMaskRepeat",
  "OMaskRepeat",
  "maskSize",
  "MozMaskSize",
  "WebkitMaskSize",
  "MSMaskSize",
  "OMaskSize",
  "maskType",
  "MozMaskType",
  "WebkitMaskType",
  "MSMaskType",
  "OMaskType",
  "maxHeight",
  "MozMaxHeight",
  "WebkitMaxHeight",
  "MSMaxHeight",
  "OMaxHeight",
  "maxWidth",
  "MozMaxWidth",
  "WebkitMaxWidth",
  "MSMaxWidth",
  "OMaxWidth",
  "minBlockSize",
  "MozMinBlockSize",
  "WebkitMinBlockSize",
  "MSMinBlockSize",
  "OMinBlockSize",
  "minHeight",
  "MozMinHeight",
  "WebkitMinHeight",
  "MSMinHeight",
  "OMinHeight",
  "minInlineSize",
  "MozMinInlineSize",
  "WebkitMinInlineSize",
  "MSMinInlineSize",
  "OMinInlineSize",
  "minWidth",
  "MozMinWidth",
  "WebkitMinWidth",
  "MSMinWidth",
  "OMinWidth",
  "mixBlendMode",
  "MozMixBlendMode",
  "WebkitMixBlendMode",
  "MSMixBlendMode",
  "OMixBlendMode",
  "mm",
  "MozMm",
  "WebkitMm",
  "MSMm",
  "OMm",
  "ms",
  "MozMs",
  "WebkitMs",
  "MSMs",
  "OMs",
  "objectFit",
  "MozObjectFit",
  "WebkitObjectFit",
  "MSObjectFit",
  "OObjectFit",
  "objectPosition",
  "MozObjectPosition",
  "WebkitObjectPosition",
  "MSObjectPosition",
  "OObjectPosition",
  "offsetBlockEnd",
  "MozOffsetBlockEnd",
  "WebkitOffsetBlockEnd",
  "MSOffsetBlockEnd",
  "OOffsetBlockEnd",
  "offsetBlockStart",
  "MozOffsetBlockStart",
  "WebkitOffsetBlockStart",
  "MSOffsetBlockStart",
  "OOffsetBlockStart",
  "offsetInlineEnd",
  "MozOffsetInlineEnd",
  "WebkitOffsetInlineEnd",
  "MSOffsetInlineEnd",
  "OOffsetInlineEnd",
  "offsetInlineStart",
  "MozOffsetInlineStart",
  "WebkitOffsetInlineStart",
  "MSOffsetInlineStart",
  "OOffsetInlineStart",
  "opacity",
  "MozOpacity",
  "WebkitOpacity",
  "MSOpacity",
  "OOpacity",
  "order",
  "MozOrder",
  "WebkitOrder",
  "MSOrder",
  "OOrder",
  "orphans",
  "MozOrphans",
  "WebkitOrphans",
  "MSOrphans",
  "OOrphans",
  "outline",
  "MozOutline",
  "WebkitOutline",
  "MSOutline",
  "OOutline",
  "outlineColor",
  "MozOutlineColor",
  "WebkitOutlineColor",
  "MSOutlineColor",
  "OOutlineColor",
  "outlineOffset",
  "MozOutlineOffset",
  "WebkitOutlineOffset",
  "MSOutlineOffset",
  "OOutlineOffset",
  "outlineStyle",
  "MozOutlineStyle",
  "WebkitOutlineStyle",
  "MSOutlineStyle",
  "OOutlineStyle",
  "outlineWidth",
  "MozOutlineWidth",
  "WebkitOutlineWidth",
  "MSOutlineWidth",
  "OOutlineWidth",
  "overflow",
  "MozOverflow",
  "WebkitOverflow",
  "MSOverflow",
  "OOverflow",
  "overflowWrap",
  "MozOverflowWrap",
  "WebkitOverflowWrap",
  "MSOverflowWrap",
  "OOverflowWrap",
  "overflowX",
  "MozOverflowX",
  "WebkitOverflowX",
  "MSOverflowX",
  "OOverflowX",
  "overflowY",
  "MozOverflowY",
  "WebkitOverflowY",
  "MSOverflowY",
  "OOverflowY",
  "padding",
  "MozPadding",
  "WebkitPadding",
  "MSPadding",
  "OPadding",
  "paddingBlockEnd",
  "MozPaddingBlockEnd",
  "WebkitPaddingBlockEnd",
  "MSPaddingBlockEnd",
  "OPaddingBlockEnd",
  "paddingBlockStart",
  "MozPaddingBlockStart",
  "WebkitPaddingBlockStart",
  "MSPaddingBlockStart",
  "OPaddingBlockStart",
  "paddingBottom",
  "MozPaddingBottom",
  "WebkitPaddingBottom",
  "MSPaddingBottom",
  "OPaddingBottom",
  "paddingInlineEnd",
  "MozPaddingInlineEnd",
  "WebkitPaddingInlineEnd",
  "MSPaddingInlineEnd",
  "OPaddingInlineEnd",
  "paddingInlineStart",
  "MozPaddingInlineStart",
  "WebkitPaddingInlineStart",
  "MSPaddingInlineStart",
  "OPaddingInlineStart",
  "paddingLeft",
  "MozPaddingLeft",
  "WebkitPaddingLeft",
  "MSPaddingLeft",
  "OPaddingLeft",
  "paddingRight",
  "MozPaddingRight",
  "WebkitPaddingRight",
  "MSPaddingRight",
  "OPaddingRight",
  "paddingTop",
  "MozPaddingTop",
  "WebkitPaddingTop",
  "MSPaddingTop",
  "OPaddingTop",
  "pageBreakAfter",
  "MozPageBreakAfter",
  "WebkitPageBreakAfter",
  "MSPageBreakAfter",
  "OPageBreakAfter",
  "pageBreakBefore",
  "MozPageBreakBefore",
  "WebkitPageBreakBefore",
  "MSPageBreakBefore",
  "OPageBreakBefore",
  "pageBreakInside",
  "MozPageBreakInside",
  "WebkitPageBreakInside",
  "MSPageBreakInside",
  "OPageBreakInside",
  "pc",
  "MozPc",
  "WebkitPc",
  "MSPc",
  "OPc",
  "perspective",
  "MozPerspective",
  "WebkitPerspective",
  "MSPerspective",
  "OPerspective",
  "perspectiveOrigin",
  "MozPerspectiveOrigin",
  "WebkitPerspectiveOrigin",
  "MSPerspectiveOrigin",
  "OPerspectiveOrigin",
  "pointerEvents",
  "MozPointerEvents",
  "WebkitPointerEvents",
  "MSPointerEvents",
  "OPointerEvents",
  "position",
  "MozPosition",
  "WebkitPosition",
  "MSPosition",
  "OPosition",
  "pt",
  "MozPt",
  "WebkitPt",
  "MSPt",
  "OPt",
  "px",
  "MozPx",
  "WebkitPx",
  "MSPx",
  "OPx",
  "q",
  "MozQ",
  "WebkitQ",
  "MSQ",
  "OQ",
  "quotes",
  "MozQuotes",
  "WebkitQuotes",
  "MSQuotes",
  "OQuotes",
  "rad",
  "MozRad",
  "WebkitRad",
  "MSRad",
  "ORad",
  "rem",
  "MozRem",
  "WebkitRem",
  "MSRem",
  "ORem",
  "resize",
  "MozResize",
  "WebkitResize",
  "MSResize",
  "OResize",
  "revert",
  "MozRevert",
  "WebkitRevert",
  "MSRevert",
  "ORevert",
  "right",
  "MozRight",
  "WebkitRight",
  "MSRight",
  "ORight",
  "rubyAlign",
  "MozRubyAlign",
  "WebkitRubyAlign",
  "MSRubyAlign",
  "ORubyAlign",
  "rubyMerge",
  "MozRubyMerge",
  "WebkitRubyMerge",
  "MSRubyMerge",
  "ORubyMerge",
  "rubyPosition",
  "MozRubyPosition",
  "WebkitRubyPosition",
  "MSRubyPosition",
  "ORubyPosition",
  "s",
  "MozS",
  "WebkitS",
  "MSS",
  "OS",
  "scrollBehavior",
  "MozScrollBehavior",
  "WebkitScrollBehavior",
  "MSScrollBehavior",
  "OScrollBehavior",
  "scrollSnapCoordinate",
  "MozScrollSnapCoordinate",
  "WebkitScrollSnapCoordinate",
  "MSScrollSnapCoordinate",
  "OScrollSnapCoordinate",
  "scrollSnapDestination",
  "MozScrollSnapDestination",
  "WebkitScrollSnapDestination",
  "MSScrollSnapDestination",
  "OScrollSnapDestination",
  "scrollSnapType",
  "MozScrollSnapType",
  "WebkitScrollSnapType",
  "MSScrollSnapType",
  "OScrollSnapType",
  "shapeImageThreshold",
  "MozShapeImageThreshold",
  "WebkitShapeImageThreshold",
  "MSShapeImageThreshold",
  "OShapeImageThreshold",
  "shapeMargin",
  "MozShapeMargin",
  "WebkitShapeMargin",
  "MSShapeMargin",
  "OShapeMargin",
  "shapeOutside",
  "MozShapeOutside",
  "WebkitShapeOutside",
  "MSShapeOutside",
  "OShapeOutside",
  "tabSize",
  "MozTabSize",
  "WebkitTabSize",
  "MSTabSize",
  "OTabSize",
  "tableLayout",
  "MozTableLayout",
  "WebkitTableLayout",
  "MSTableLayout",
  "OTableLayout",
  "textAlign",
  "MozTextAlign",
  "WebkitTextAlign",
  "MSTextAlign",
  "OTextAlign",
  "textAlignLast",
  "MozTextAlignLast",
  "WebkitTextAlignLast",
  "MSTextAlignLast",
  "OTextAlignLast",
  "textCombineUpright",
  "MozTextCombineUpright",
  "WebkitTextCombineUpright",
  "MSTextCombineUpright",
  "OTextCombineUpright",
  "textDecoration",
  "MozTextDecoration",
  "WebkitTextDecoration",
  "MSTextDecoration",
  "OTextDecoration",
  "textDecorationColor",
  "MozTextDecorationColor",
  "WebkitTextDecorationColor",
  "MSTextDecorationColor",
  "OTextDecorationColor",
  "textDecorationLine",
  "MozTextDecorationLine",
  "WebkitTextDecorationLine",
  "MSTextDecorationLine",
  "OTextDecorationLine",
  "textDecorationStyle",
  "MozTextDecorationStyle",
  "WebkitTextDecorationStyle",
  "MSTextDecorationStyle",
  "OTextDecorationStyle",
  "textEmphasis",
  "MozTextEmphasis",
  "WebkitTextEmphasis",
  "MSTextEmphasis",
  "OTextEmphasis",
  "textEmphasisColor",
  "MozTextEmphasisColor",
  "WebkitTextEmphasisColor",
  "MSTextEmphasisColor",
  "OTextEmphasisColor",
  "textEmphasisPosition",
  "MozTextEmphasisPosition",
  "WebkitTextEmphasisPosition",
  "MSTextEmphasisPosition",
  "OTextEmphasisPosition",
  "textEmphasisStyle",
  "MozTextEmphasisStyle",
  "WebkitTextEmphasisStyle",
  "MSTextEmphasisStyle",
  "OTextEmphasisStyle",
  "textIndent",
  "MozTextIndent",
  "WebkitTextIndent",
  "MSTextIndent",
  "OTextIndent",
  "textOrientation",
  "MozTextOrientation",
  "WebkitTextOrientation",
  "MSTextOrientation",
  "OTextOrientation",
  "textOverflow",
  "MozTextOverflow",
  "WebkitTextOverflow",
  "MSTextOverflow",
  "OTextOverflow",
  "textRendering",
  "MozTextRendering",
  "WebkitTextRendering",
  "MSTextRendering",
  "OTextRendering",
  "textShadow",
  "MozTextShadow",
  "WebkitTextShadow",
  "MSTextShadow",
  "OTextShadow",
  "textTransform",
  "MozTextTransform",
  "WebkitTextTransform",
  "MSTextTransform",
  "OTextTransform",
  "textUnderlinePosition",
  "MozTextUnderlinePosition",
  "WebkitTextUnderlinePosition",
  "MSTextUnderlinePosition",
  "OTextUnderlinePosition",
  "top",
  "MozTop",
  "WebkitTop",
  "MSTop",
  "OTop",
  "touchAction",
  "MozTouchAction",
  "WebkitTouchAction",
  "MSTouchAction",
  "OTouchAction",
  "transform",
  "MozTransform",
  "WebkitTransform",
  "msTransform",
  "OTransform",
  "transformBox",
  "MozTransformBox",
  "WebkitTransformBox",
  "MSTransformBox",
  "OTransformBox",
  "transformOrigin",
  "MozTransformOrigin",
  "WebkitTransformOrigin",
  "MSTransformOrigin",
  "OTransformOrigin",
  "transformStyle",
  "MozTransformStyle",
  "WebkitTransformStyle",
  "MSTransformStyle",
  "OTransformStyle",
  "transition",
  "MozTransition",
  "WebkitTransition",
  "MSTransition",
  "OTransition",
  "transitionDelay",
  "MozTransitionDelay",
  "WebkitTransitionDelay",
  "MSTransitionDelay",
  "OTransitionDelay",
  "transitionDuration",
  "MozTransitionDuration",
  "WebkitTransitionDuration",
  "MSTransitionDuration",
  "OTransitionDuration",
  "transitionProperty",
  "MozTransitionProperty",
  "WebkitTransitionProperty",
  "MSTransitionProperty",
  "OTransitionProperty",
  "transitionTimingFunction",
  "MozTransitionTimingFunction",
  "WebkitTransitionTimingFunction",
  "MSTransitionTimingFunction",
  "OTransitionTimingFunction",
  "turn",
  "MozTurn",
  "WebkitTurn",
  "MSTurn",
  "OTurn",
  "unicodeBidi",
  "MozUnicodeBidi",
  "WebkitUnicodeBidi",
  "MSUnicodeBidi",
  "OUnicodeBidi",
  "unset",
  "MozUnset",
  "WebkitUnset",
  "MSUnset",
  "OUnset",
  "verticalAlign",
  "MozVerticalAlign",
  "WebkitVerticalAlign",
  "MSVerticalAlign",
  "OVerticalAlign",
  "vh",
  "MozVh",
  "WebkitVh",
  "MSVh",
  "OVh",
  "visibility",
  "MozVisibility",
  "WebkitVisibility",
  "MSVisibility",
  "OVisibility",
  "vmax",
  "MozVmax",
  "WebkitVmax",
  "MSVmax",
  "OVmax",
  "vmin",
  "MozVmin",
  "WebkitVmin",
  "MSVmin",
  "OVmin",
  "vw",
  "MozVw",
  "WebkitVw",
  "MSVw",
  "OVw",
  "whiteSpace",
  "MozWhiteSpace",
  "WebkitWhiteSpace",
  "MSWhiteSpace",
  "OWhiteSpace",
  "widows",
  "MozWidows",
  "WebkitWidows",
  "MSWidows",
  "OWidows",
  "width",
  "MozWidth",
  "WebkitWidth",
  "MSWidth",
  "OWidth",
  "willChange",
  "MozWillChange",
  "WebkitWillChange",
  "MSWillChange",
  "OWillChange",
  "wordBreak",
  "MozWordBreak",
  "WebkitWordBreak",
  "MSWordBreak",
  "OWordBreak",
  "wordSpacing",
  "MozWordSpacing",
  "WebkitWordSpacing",
  "MSWordSpacing",
  "OWordSpacing",
  "wordWrap",
  "MozWordWrap",
  "WebkitWordWrap",
  "MSWordWrap",
  "OWordWrap",
  "writingMode",
  "MozWritingMode",
  "WebkitWritingMode",
  "MSWritingMode",
  "OWritingMode",
  "zIndex",
  "MozZIndex",
  "WebkitZIndex",
  "MSZIndex",
  "OZIndex",
  "fontSize",
  "MozFontSize",
  "WebkitFontSize",
  "MSFontSize",
  "OFontSize",
  "flex",
  "MozFlex",
  "WebkitFlex",
  "MSFlex",
  "OFlex",
  "fr",
  "MozFr",
  "WebkitFr",
  "MSFr",
  "OFr",
  "overflowScrolling",
  "MozOverflowScrolling",
  "WebkitOverflowScrolling",
  "MSOverflowScrolling",
  "OOverflowScrolling"
]


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1807)();
}


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var ReactPropTypesSecret = __webpack_require__(1808);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1810);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--field--3bR0o0EJ {\n  display: block;\n  height: 18px;\n  margin-bottom: 15px;\n  position: relative;\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--field--3bR0o0EJ *,\n    .theme--field--3bR0o0EJ *::after,\n    .theme--field--3bR0o0EJ *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--field--3bR0o0EJ .theme--ripple--1wnPqS50 {\n  background-color: rgb(63, 81, 181);\n  opacity: 0.3;\n  transition-duration: 650ms;\n}\n.theme--text--3TK5aIJw {\n  color: rgb(0, 0, 0);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 18px;\n  padding-left: 10px;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.theme--input--3-_ku8Km {\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  width: 0\n}\n.theme--input--3-_ku8Km:focus ~ .theme--check--H6yLc5ML::before {\n  background-color: rgba(0, 0, 0, 0.01);\n  border-radius: 50%;\n  content: '';\n  height: 41.4px;\n  left: 50%;\n  margin-left: -20.7px;\n  margin-top: -20.7px;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  width: 41.4px;\n}\n.theme--input--3-_ku8Km:focus ~ .theme--check--H6yLc5ML.theme--checked--JzkJiriO::before {\n  background-color: rgba(63, 81, 181, 0.26);\n}\n.theme--check--H6yLc5ML {\n  border-color: rgb(0, 0, 0);\n  border-radius: 2px;\n  border-style: solid;\n  border-width: 2px;\n  cursor: pointer;\n  display: inline-block;\n  height: 18px;\n  position: relative;\n  transition-duration: 0.2s;\n  transition-property: background-color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  vertical-align: top;\n  width: 18px;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--check--H6yLc5ML *,\n    .theme--check--H6yLc5ML *::after,\n    .theme--check--H6yLc5ML *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--check--H6yLc5ML.theme--checked--JzkJiriO {\n  background-color: rgb(63, 81, 181);\n  border-color: rgb(63, 81, 181);\n}\n.theme--check--H6yLc5ML.theme--checked--JzkJiriO::after {\n  -webkit-animation: theme--checkmark-expand--3mZZw-KE 140ms ease-out forwards;\n          animation: theme--checkmark-expand--3mZZw-KE 140ms ease-out forwards;\n  border-bottom-width: 2px;\n  border-color: rgb(255, 255, 255);\n  border-left: 0;\n  border-right-width: 2px;\n  border-style: solid;\n  border-top: 0;\n  content: '';\n  height: 12px;\n  left: 4px;\n  position: absolute;\n  top: -1px;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  width: 7px;\n}\n.theme--disabled--23f2a7mn > .theme--text--3TK5aIJw {\n  color: rgba(0, 0, 0, 0.26);\n}\n.theme--disabled--23f2a7mn > .theme--check--H6yLc5ML {\n  border-color: rgba(0, 0, 0, 0.26);\n  cursor: auto;\n}\n.theme--disabled--23f2a7mn > .theme--check--H6yLc5ML.theme--checked--JzkJiriO {\n  background-color: rgba(0, 0, 0, 0.26);\n  border-color: transparent;\n  cursor: auto;\n}\n@-webkit-keyframes theme--checkmark-expand--3mZZw-KE {\n  0% {\n    height: 0;\n    left: 6px;\n    top: 9px;\n    width: 0;\n  }\n\n  100% {\n    height: 12px;\n    left: 4px;\n    top: -1px;\n    width: 7px;\n  }\n}\n@keyframes theme--checkmark-expand--3mZZw-KE {\n  0% {\n    height: 0;\n    left: 6px;\n    top: 9px;\n    width: 0;\n  }\n\n  100% {\n    height: 12px;\n    left: 4px;\n    top: -1px;\n    width: 7px;\n  }\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/checkbox/theme.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,mCAAmC;EACnC,aAAa;EACb,2BAA2B;CAC5B;AACD;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;CACrB;AACD;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;CACT;AACD;EACE,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,cAAc;CACf;AACD;EACE,0CAA0C;CAC3C;AACD;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,sCAAsC;EACtC,yDAAyD;EACzD,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,mCAAmC;EACnC,+BAA+B;CAChC;AACD;EACE,6EAA4D;UACpD,qEAAoD;EAC5D,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,iCAAiC;UACzB,yBAAyB;EACjC,WAAW;CACZ;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,kCAAkC;EAClC,aAAa;CACd;AACD;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,aAAa;CACd;AACD;EACE;IACE,UAAU;IACV,UAAU;IACV,SAAS;IACT,SAAS;GACV;;EAED;IACE,aAAa;IACb,UAAU;IACV,UAAU;IACV,WAAW;GACZ;CACF;AACD;EACE;IACE,UAAU;IACV,UAAU;IACV,SAAS;IACT,SAAS;GACV;;EAED;IACE,aAAa;IACb,UAAU;IACV,UAAU;IACV,WAAW;GACZ;CACF","file":"theme.css","sourcesContent":[".field {\n  display: block;\n  height: 18px;\n  margin-bottom: 15px;\n  position: relative;\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.field *,\n    .field *::after,\n    .field *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.field .ripple {\n  background-color: rgb(63, 81, 181);\n  opacity: 0.3;\n  transition-duration: 650ms;\n}\n.text {\n  color: rgb(0, 0, 0);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 18px;\n  padding-left: 10px;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.input {\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  width: 0\n}\n.input:focus ~ .check::before {\n  background-color: rgba(0, 0, 0, 0.01);\n  border-radius: 50%;\n  content: '';\n  height: 41.4px;\n  left: 50%;\n  margin-left: -20.7px;\n  margin-top: -20.7px;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  width: 41.4px;\n}\n.input:focus ~ .check.checked::before {\n  background-color: rgba(63, 81, 181, 0.26);\n}\n.check {\n  border-color: rgb(0, 0, 0);\n  border-radius: 2px;\n  border-style: solid;\n  border-width: 2px;\n  cursor: pointer;\n  display: inline-block;\n  height: 18px;\n  position: relative;\n  transition-duration: 0.2s;\n  transition-property: background-color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  vertical-align: top;\n  width: 18px;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.check *,\n    .check *::after,\n    .check *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.check.checked {\n  background-color: rgb(63, 81, 181);\n  border-color: rgb(63, 81, 181);\n}\n.check.checked::after {\n  -webkit-animation: checkmark-expand 140ms ease-out forwards;\n          animation: checkmark-expand 140ms ease-out forwards;\n  border-bottom-width: 2px;\n  border-color: rgb(255, 255, 255);\n  border-left: 0;\n  border-right-width: 2px;\n  border-style: solid;\n  border-top: 0;\n  content: '';\n  height: 12px;\n  left: 4px;\n  position: absolute;\n  top: -1px;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  width: 7px;\n}\n.disabled > .text {\n  color: rgba(0, 0, 0, 0.26);\n}\n.disabled > .check {\n  border-color: rgba(0, 0, 0, 0.26);\n  cursor: auto;\n}\n.disabled > .check.checked {\n  background-color: rgba(0, 0, 0, 0.26);\n  border-color: transparent;\n  cursor: auto;\n}\n@-webkit-keyframes checkmark-expand {\n  0% {\n    height: 0;\n    left: 6px;\n    top: 9px;\n    width: 0;\n  }\n\n  100% {\n    height: 12px;\n    left: 4px;\n    top: -1px;\n    width: 7px;\n  }\n}\n@keyframes checkmark-expand {\n  0% {\n    height: 0;\n    left: 6px;\n    top: 9px;\n    width: 0;\n  }\n\n  100% {\n    height: 12px;\n    left: 4px;\n    top: -1px;\n    width: 7px;\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"field": "theme--field--3bR0o0EJ",
	"ripple": "theme--ripple--1wnPqS50",
	"text": "theme--text--3TK5aIJw",
	"input": "theme--input--3-_ku8Km",
	"check": "theme--check--H6yLc5ML",
	"checked": "theme--checked--JzkJiriO",
	"checkmark-expand": "theme--checkmark-expand--3mZZw-KE",
	"disabled": "theme--disabled--23f2a7mn"
};

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.app-button--itunes--1ymErf99:after {\n  display: inline-block;\n  width: 178px;\n  height: 58px;\n  vertical-align: middle;\n  -webkit-transform: scale(0.5, 0.5) translate(-87px, -30px);\n          transform: scale(0.5, 0.5) translate(-87px, -30px);\n  content: url('data:image/png;base64,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');\n}\n\n.app-button--android--DANaCzzX:after {\n  display: inline-block;\n  width: 178px;\n  height: 58px;\n  -webkit-transform: scale(0.5, 0.5) translate(-87px, -30px);\n          transform: scale(0.5, 0.5) translate(-87px, -30px);\n  vertical-align: middle;\n  content: url('data:image/png;base64,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');\n}", "", {"version":3,"sources":["/./src/web/components/themes/app-button.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,2DAA2D;UACnD,mDAAmD;EAC3D,+jLAA+jL;CAChkL;;AAED;EACE,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,2DAA2D;UACnD,mDAAmD;EAC3D,uBAAuB;EACvB,+nkDAA+nkD;CAChokD","file":"app-button.css","sourcesContent":["\n.itunes:after {\n  display: inline-block;\n  width: 178px;\n  height: 58px;\n  vertical-align: middle;\n  -webkit-transform: scale(0.5, 0.5) translate(-87px, -30px);\n          transform: scale(0.5, 0.5) translate(-87px, -30px);\n  content: url('data:image/png;base64,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');\n}\n\n.android:after {\n  display: inline-block;\n  width: 178px;\n  height: 58px;\n  -webkit-transform: scale(0.5, 0.5) translate(-87px, -30px);\n          transform: scale(0.5, 0.5) translate(-87px, -30px);\n  vertical-align: middle;\n  content: url('data:image/png;base64,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');\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"itunes": "app-button--itunes--1ymErf99",
	"android": "app-button--android--DANaCzzX"
};

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawLoginPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _loginPage = __webpack_require__(1813);

var _loginPage2 = _interopRequireDefault(_loginPage);

var _formValidator = __webpack_require__(41);

var _button = __webpack_require__(8);

var _list = __webpack_require__(25);

var _card = __webpack_require__(28);

var _input = __webpack_require__(59);

var _dialog = __webpack_require__(47);

var _actionDialog = __webpack_require__(224);

var _actionDialog2 = _interopRequireDefault(_actionDialog);

var _fluidInput = __webpack_require__(1842);

var _fluidInput2 = _interopRequireDefault(_fluidInput);

var _scrollableDialogPanel = __webpack_require__(163);

var _scrollableDialogPanel2 = _interopRequireDefault(_scrollableDialogPanel);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _appButton = __webpack_require__(881);

var _appButton2 = _interopRequireDefault(_appButton);

var _loginPage3 = __webpack_require__(1844);

var _loginPage4 = _interopRequireDefault(_loginPage3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/login-page.jsx

var LoginPage = function (_React$Component) {
  _inherits(LoginPage, _React$Component);

  function LoginPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LoginPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginPage.__proto__ || Object.getPrototypeOf(LoginPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.toggleLoginHistoryDialog = function () {
      return _this.setState({ loginHistoryDialog: !_this.state.loginHistoryDialog });
    }, _this.validateAndSubmit = function (e) {
      return _this.props.validateAndSubmit(_this.props, e);
    }, _this.clearLoginStatus = function () {
      return _this.props.clearLoginStatus(_this.props);
    }, _this.onChangeEmail = (0, _formValidator.linkUI)(_this, 'email'), _this.onChangePassword = (0, _formValidator.linkUI)(_this, 'password'), _this.onChangePasscode = (0, _formValidator.linkUI)(_this, 'passcode'), _this.onChangeNewPassword = (0, _formValidator.linkUI)(_this, 'newPassword'), _this.onChangeNewPasswordConfirm = (0, _formValidator.linkUI)(_this, 'newPasswordConfirm'), _this.setDocumentTitle = function () {
      return document.title = _this.props.t('label:ログイン') + ' - gamba!';
    }, _this.openSSOLogin = function () {
      return window.open(_this.props.sso_url, "gamba!", 'width=500,height=700,menubar=no,toolbar=no,location=no');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LoginPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.onSSOSuccess = function (access_token) {
        return _this2.props.loadAccessToken(access_token);
      };
      this.setDocumentTitle();
      zE(function () {
        zE.show();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.onSSOSuccess = undefined;
      zE(function () {
        zE.hide();
      });
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!this.props.sso_required && nextProps.sso_required && nextProps.sso_url) window.open(nextProps.sso_url, "gamba!", 'width=500,height=700,menubar=no,toolbar=no,location=no');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          validateAndSubmit = _props.validateAndSubmit,
          trial_expired = _props.trial_expired,
          re_trial = _props.re_trial,
          clearAlertMessage = _props.clearAlertMessage,
          isFailed = _props.isFailed,
          password_change_required = _props.password_change_required,
          passcode_required = _props.passcode_required,
          password_required = _props.password_required,
          sso_required = _props.sso_required,
          sso_url = _props.sso_url,
          alertMessage = _props.alertMessage;


      return _react2.default.createElement(
        _card.Card,
        { raised: true, theme: _loginPage4.default, className: 'login' },
        _react2.default.createElement(
          'div',
          { className: _loginPage4.default.gamba },
          _react2.default.createElement(
            'h1',
            null,
            'gamba!'
          )
        ),
        _react2.default.createElement(
          'form',
          { onSubmit: this.validateAndSubmit },
          _react2.default.createElement(_card.CardTitle, { title: t('message:ようこそ'), subtitle: t('message:ログインしてください') }),
          !password_change_required && !passcode_required && !password_required && !sso_required && _react2.default.createElement(
            _card.Card,
            { theme: _loginPage4.default },
            _react2.default.createElement(
              'div',
              { className: _loginPage4.default.email },
              _react2.default.createElement(_input.Input, { name: 'email', required: true,
                theme: _fluidInput2.default,
                autoFocus: true,
                label: t('label:メールアドレス'),
                value: ui.email,
                icon: 'email',
                error: ui.emailError && t('error:メールアドレスを入力してください') || alertMessage,
                onChange: this.onChangeEmail }),
              ui.history && ui.history.length > 0 && _react2.default.createElement(_button.IconButton, { onClick: this.toggleLoginHistoryDialog, icon: 'arrow_drop_down' })
            ),
            _react2.default.createElement('div', { style: { height: '75px' } }),
            _react2.default.createElement(
              _card.CardActions,
              { theme: _loginPage4.default },
              _react2.default.createElement(_button.Button, { raised: true, type: 'reset', label: t('label:取り消し'), onClick: this.clearLoginStatus }),
              _react2.default.createElement(_button.Button, { raised: true, primary: true, type: 'submit', icon: 'arrow_forward', label: t('label:次へ') })
            )
          ),
          sso_required && _react2.default.createElement(
            _card.Card,
            { theme: _loginPage4.default },
            _react2.default.createElement(_input.Input, { name: 'email', disabled: true,
              label: t('label:メールアドレス'),
              value: ui.email,
              icon: 'email' }),
            _react2.default.createElement(
              _card.CardText,
              null,
              t('label:シングルサインオン認証を行ってください')
            ),
            _react2.default.createElement(
              _card.CardActions,
              { theme: _loginPage4.default },
              _react2.default.createElement(_button.Button, { raised: true, type: 'reset', label: t('label:取り消し'), onClick: this.clearLoginStatus }),
              _react2.default.createElement(_button.Button, { raised: true, primary: true, icon: 'arrow_forward', label: t('label:ログイン'), onClick: this.openSSOLogin })
            )
          ),
          password_required && _react2.default.createElement(
            _card.Card,
            { theme: _loginPage4.default },
            _react2.default.createElement(_input.Input, { name: 'email', disabled: true,
              label: t('label:メールアドレス'),
              value: ui.email,
              icon: 'email' }),
            _react2.default.createElement(_input.Input, { name: 'password', required: true,
              autoFocus: true,
              type: 'password',
              label: t('label:パスワード'),
              icon: 'lock_open',
              value: ui.password,
              error: ui.passwordError && t('error:パスワードを入力してください') || alertMessage,
              onChange: this.onChangePassword }),
            _react2.default.createElement(
              _card.CardActions,
              { theme: _loginPage4.default },
              _react2.default.createElement(_button.Button, { raised: true, type: 'reset', label: t('label:取り消し'), onClick: this.clearLoginStatus }),
              _react2.default.createElement(_button.Button, { raised: true, primary: true, type: 'submit', icon: 'done', label: t('label:ログイン') })
            )
          ),
          passcode_required && _react2.default.createElement(
            _card.Card,
            { theme: _loginPage4.default },
            _react2.default.createElement(_input.Input, { name: 'email', disabled: true,
              label: t('label:メールアドレス'),
              value: ui.email,
              icon: 'email' }),
            _react2.default.createElement(
              _card.CardText,
              null,
              t('label:確認コードについて')
            ),
            _react2.default.createElement(_input.Input, { name: 'passcode', required: true,
              autoFocus: true,
              label: t('label:確認コード'),
              icon: 'phonelink_lock',
              value: ui.passcode,
              error: ui.passcodeError && t('error:確認コードを入力してください'),
              onChange: this.onChangePasscode }),
            _react2.default.createElement(_input.Input, { name: 'password', required: true,
              type: 'password',
              label: t('label:パスワード'),
              icon: 'lock_open',
              value: ui.password,
              error: ui.passwordError && t('error:パスワードを入力してください') || alertMessage,
              onChange: this.onChangePassword }),
            _react2.default.createElement(
              _card.CardActions,
              { theme: _loginPage4.default },
              _react2.default.createElement(_button.Button, { raised: true, type: 'reset', label: t('label:取り消し'), onClick: this.clearLoginStatus }),
              _react2.default.createElement(_button.Button, { raised: true, primary: true, type: 'submit', icon: 'done', label: t('label:ログイン') })
            )
          ),
          password_change_required && _react2.default.createElement(
            _card.Card,
            { theme: _loginPage4.default },
            _react2.default.createElement(_input.Input, { name: 'email', disabled: true,
              label: t('label:メールアドレス'),
              value: ui.email,
              icon: 'email' }),
            _react2.default.createElement(
              _card.CardText,
              null,
              t('label:パスワードの変更が必要です')
            ),
            _react2.default.createElement(_input.Input, { name: 'oldPassword',
              type: 'password',
              autoFocus: true,
              label: t('label:現在のパスワード'),
              value: ui.password,
              icon: 'lock_open',
              error: ui.passwordError && t('error:パスワードを入力してください'),
              onChange: this.onChangePassword }),
            _react2.default.createElement(_input.Input, { name: 'password',
              type: 'password',
              label: t('label:新しいパスワード'),
              value: ui.newPassword,
              icon: 'lock_open',
              error: ui.newPasswordError && t('error:パスワードを入力してください'),
              onChange: this.onChangeNewPassword }),
            _react2.default.createElement(_input.Input, { name: 'passwordConfirm',
              type: 'password',
              label: t('label:新しいパスワード(再入力)'),
              value: ui.newPasswordConfirm,
              icon: 'lock_open',
              error: ui.newPasswordConfirmError && t('error:パスワードを入力してください') || alertMessage,
              onChange: this.onChangeNewPasswordConfirm }),
            _react2.default.createElement(
              _card.CardActions,
              { theme: _loginPage4.default },
              _react2.default.createElement(_button.Button, { raised: true, type: 'reset', label: t('label:取り消し'), onClick: this.clearLoginStatus }),
              _react2.default.createElement(_button.Button, { raised: true, primary: true, type: 'submit', icon: 'done', label: t('label:パスワードを変更してログイン') })
            )
          ),
          _react2.default.createElement(
            _card.CardText,
            { style: { alignItems: 'center', display: 'flex', flexDirection: 'column' } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: _config2.default.baseUrl + "v3/registration/password_reset", target: '_blank', rel: 'noopener noreferrer' },
                t('label:パスワード再発行')
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: t('url:無料体験リンク'), target: '_blank', rel: 'noopener noreferrer' },
                t('label:無料体験に登録')
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: t('url:gambaにログインできない'), target: '_blank', rel: 'noopener noreferrer' },
                t('label:うまくログインできない時')
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: 'https://www.getgamba.com/', target: '_blank', rel: 'noopener noreferrer' },
                t('label:gambaについて')
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { margin: '0 40px' } },
            t('label:アプリもあります')
          ),
          _react2.default.createElement(
            'div',
            { style: { margin: '20px 10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-around' } },
            _react2.default.createElement(
              'a',
              { href: 'https://itunes.apple.com/jp/app/gamba-ri-bao-gong-younotameno/id1032574463?mt=8', target: '_blank', rel: 'noopener noreferrer' },
              _react2.default.createElement('span', { className: _appButton2.default.itunes })
            ),
            _react2.default.createElement(
              'a',
              { href: 'https://play.google.com/store/apps/details?id=com.rikkeisoft.gamba', target: '_blank', rel: 'noopener noreferrer' },
              _react2.default.createElement('span', { className: _appButton2.default.android })
            )
          )
        ),
        _react2.default.createElement(_confirmDialog2.default, { open: trial_expired, centeredTitle: true,
          title: t('label:トライアル期間が終了しました'),
          description: t('label:引き続き利用するには契約が必要です'),
          yesLabel: t('label:契約する'),
          noLabel: t('label:閉じる'),
          yesHref: _config2.default.baseUrl + 'v3/contract',
          onNo: clearAlertMessage }),
        _react2.default.createElement(_confirmDialog2.default, { open: re_trial, reTrialMessage: true, centeredTitle: true,
          configBaseUrl: _config2.default.baseUrl,
          title: t('label:お客様のトライアル期間は終了しました'),
          description: t('label:再度利用するにはもう一度トライアルをしてください'),
          yesLabel: t('label:無料トライアルを始める'),
          noLabel: t('label:閉じる'),
          yesHref: _config2.default.baseUrl + 'v3/registration/new_refresh?email=' + encodeURIComponent(ui.email),
          onNo: clearAlertMessage }),
        ui.history && ui.history.length > 0 && _react2.default.createElement(
          _dialog.Dialog,
          { active: !!this.state.loginHistoryDialog, theme: _actionDialog2.default,
            title: t('label:メールアドレスを選択'),
            actions: [{ raised: true, label: t('label:取り消し'), onClick: this.toggleLoginHistoryDialog }],
            onOverlayClick: this.toggleLoginHistoryDialog,
            onEscKeyDown: this.toggleLoginHistoryDialog },
          _react2.default.createElement(
            _scrollableDialogPanel2.default,
            null,
            _react2.default.createElement(
              _list.List,
              null,
              ui.history && _.map(ui.history, function (item, i) {
                return _react2.default.createElement(_list.ListItem, { caption: item.email, selectable: true, key: i,
                  onClick: function onClick() {
                    _this3.toggleLoginHistoryDialog();_this3.onChangeEmail(item.email);
                  } });
              })
            )
          )
        )
      );
    }
  }]);

  return LoginPage;
}(_react2.default.Component);

var RawLoginPage = exports.RawLoginPage = LoginPage;
exports.default = (0, _loginPage2.default)(LoginPage);

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _route = __webpack_require__(67);

var _formValidator = __webpack_require__(41);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

var _loginHistory = __webpack_require__(882);

var _loginHistory2 = _interopRequireDefault(_loginHistory);

var _accessToken = __webpack_require__(220);

var _accessToken2 = _interopRequireDefault(_accessToken);

var _groupIdStore = __webpack_require__(341);

var _groupIdStore2 = _interopRequireDefault(_groupIdStore);

var _mentionsStore = __webpack_require__(883);

var _mentionsStore2 = _interopRequireDefault(_mentionsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/login-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    email: ownProps.location && ownProps.location.query && ownProps.location.query.email || null,
    login: state.sessions.login,
    isFailed: state.sessions.isFailed,
    password_change_required: state.sessions.password_change_required,
    passcode_required: state.sessions.passcode_required,
    password_required: state.sessions.password_required,
    sso_required: state.sessions.sso_required,
    sso_url: state.sessions.sso_url,
    trial_expired: state.alertMessage.trial_expired,
    re_trial: state.alertMessage.re_trial,
    alertMessage: state.alertMessage.message
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    validateAndSubmit: function validateAndSubmit(props) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (event && event.preventDefault) event.preventDefault();
      var rules = {
        email: { rule: 'isEmail' }
      };
      var opts = {};
      if (props.password_required) {
        rules.password = { rule: 'isRequired' };
        opts.password = props.ui.password;
      } else if (props.password_change_required) {
        rules.password = { rule: 'isRequired' };
        rules.newPassword = { rule: 'isRequired' };
        rules.newPasswordConfirm = { rule: 'isSame', name: 'newPassword' };
        opts.password = props.ui.password;
        opts.new_password = props.ui.newPassword;
      } else if (props.passcode_required) {
        rules.password = { rule: 'isRequired' };
        rules.passcode = { rule: 'isNumber' };
        opts.password = props.ui.password;
        opts.passcode = props.ui.passcode;
      }
      (0, _formValidator.validate)(props.ui, rules, function (errors, nextUI) {
        dispatch((0, _alertMessage.clearAlertMessage)());
        props.updateUI(nextUI);
        if (!errors) {
          dispatch(_actions2.default.login(props.ui.email, opts));
        }
      });
      return false;
    },

    willMount: function willMount(props) {
      _accessToken2.default.clear();
      _groupIdStore2.default.clear();
      _mentionsStore2.default.clear();
      dispatch(_actions2.default.logoutCompleted());
      dispatch(_actions2.default.closeRightSidePage());
      _loginHistory2.default.get(function (history) {
        return props.updateUI({ history: history });
      });
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (!props.login && nextProps.login) {
        dispatch(_actions2.default.clearLoginStatus());
        (0, _route.replaceRoute)('main', nextProps.location && nextProps.location.query);
      }
    },

    clearLoginStatus: function clearLoginStatus(props) {
      props.updateUI({
        email: '',
        password: '',
        passcode: '',
        newPassword: '',
        newPasswordConfirm: ''
      });
      dispatch(_actions2.default.clearLoginStatus());
    },

    loadAccessToken: function loadAccessToken(access_token) {
      _accessToken2.default.set(access_token, function () {
        return dispatch(_actions2.default.loginCompleted({ access_token: access_token }));
      });
    },
    clearAlertMessage: function clearAlertMessage() {
      return dispatch(_actions2.default.clearAlertMessage());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    history: undefined,
    email: function email(props) {
      return props.email || '';
    },
    password: '',
    passcode: '',
    newPassword: '',
    newPasswordConfirm: '',
    emailError: undefined,
    passwordError: undefined,
    passcodeError: undefined,
    newPasswordError: undefined,
    newPasswordConfirmError: undefined
  }
}), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('login'), (0, _analytics.trackHandlers)('validateAndSubmit', 'login_submit'));

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

var baseAt = __webpack_require__(1815),
    flatRest = __webpack_require__(1816);

/**
 * Creates an array of values corresponding to `paths` of `object`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Array} Returns the picked values.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _.at(object, ['a[0].b.c', 'a[1]']);
 * // => [3, 4]
 */
var at = flatRest(baseAt);

module.exports = at;


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

var get = __webpack_require__(769);

/**
 * The base implementation of `_.at` without support for individual paths.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {string[]} paths The property paths to pick.
 * @returns {Array} Returns the picked elements.
 */
function baseAt(object, paths) {
  var index = -1,
      length = paths.length,
      result = Array(length),
      skip = object == null;

  while (++index < length) {
    result[index] = skip ? undefined : get(object, paths[index]);
  }
  return result;
}

module.exports = baseAt;


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(479),
    overRest = __webpack_require__(752),
    setToString = __webpack_require__(753);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(217),
    isArguments = __webpack_require__(309),
    isArray = __webpack_require__(62);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixpanelBrowser = __webpack_require__(1819);

var _mixpanelBrowser2 = _interopRequireDefault(_mixpanelBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _mixpanelBrowser2.default;
// src/helpers/mixpanel.js

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Config = {
    DEBUG: false,
    LIB_VERSION: '2.18.0'
};

// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var win;
if (typeof(window) === 'undefined') {
    win = {
        navigator: { userAgent: '' },
        document: { location: {} }
    };
} else {
    win = window;
}



/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */

var ArrayProto = Array.prototype;
var FuncProto = Function.prototype;
var ObjProto = Object.prototype;
var slice = ArrayProto.slice;
var toString = ObjProto.toString;
var hasOwnProperty = ObjProto.hasOwnProperty;
var windowConsole = win.console;
var navigator$1 = win.navigator;
var document$1 = win.document;
var userAgent = navigator$1.userAgent;
var nativeBind = FuncProto.bind;
var nativeForEach = ArrayProto.forEach;
var nativeIndexOf = ArrayProto.indexOf;
var nativeIsArray = Array.isArray;
var breaker = {};
var _ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};

// Console override
var console$1 = {
    /** @type {function(...[*])} */
    log: function() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            try {
                windowConsole.log.apply(windowConsole, arguments);
            } catch (err) {
                _.each(arguments, function(arg) {
                    windowConsole.log(arg);
                });
            }
        }
    },
    /** @type {function(...[*])} */
    error: function() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...[*])} */
    critical: function() {
        if (!_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.error(arg);
                });
            }
        }
    }
};


// UNDERSCORE
// Embed part of the Underscore Library
_.bind = function(func, context) {
    var args, bound;
    if (nativeBind && func.bind === nativeBind) {
        return nativeBind.apply(func, slice.call(arguments, 1));
    }
    if (!_.isFunction(func)) {
        throw new TypeError();
    }
    args = slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) {
            return func.apply(context, args.concat(slice.call(arguments)));
        }
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat(slice.call(arguments)));
        if (Object(result) === result) {
            return result;
        }
        return self;
    };
    return bound;
};

_.bind_instance_methods = function(obj) {
    for (var func in obj) {
        if (typeof(obj[func]) === 'function') {
            obj[func] = _.bind(obj[func], obj);
        }
    }
};

/**
 * @param {*=} obj
 * @param {function(...[*])=} iterator
 * @param {Object=} context
 */
_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) {
        return;
    }
    if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
    } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
            if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) {
                return;
            }
        }
    } else {
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                if (iterator.call(context, obj[key], key, obj) === breaker) {
                    return;
                }
            }
        }
    }
};

_.escapeHTML = function(s) {
    var escaped = s;
    if (escaped && _.isString(escaped)) {
        escaped = escaped
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }
    return escaped;
};

_.extend = function(obj) {
    _.each(slice.call(arguments, 1), function(source) {
        for (var prop in source) {
            if (source[prop] !== void 0) {
                obj[prop] = source[prop];
            }
        }
    });
    return obj;
};

_.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
};

// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};

_.isArguments = function(obj) {
    return !!(obj && hasOwnProperty.call(obj, 'callee'));
};

_.toArray = function(iterable) {
    if (!iterable) {
        return [];
    }
    if (iterable.toArray) {
        return iterable.toArray();
    }
    if (_.isArray(iterable)) {
        return slice.call(iterable);
    }
    if (_.isArguments(iterable)) {
        return slice.call(iterable);
    }
    return _.values(iterable);
};

_.keys = function(obj) {
    var results = [];
    if (obj === null) {
        return results;
    }
    _.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};

_.values = function(obj) {
    var results = [];
    if (obj === null) {
        return results;
    }
    _.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};

_.identity = function(value) {
    return value;
};

_.include = function(obj, target) {
    var found = false;
    if (obj === null) {
        return found;
    }
    if (nativeIndexOf && obj.indexOf === nativeIndexOf) {
        return obj.indexOf(target) != -1;
    }
    _.each(obj, function(value) {
        if (found || (found = (value === target))) {
            return breaker;
        }
    });
    return found;
};

_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};

// Underscore Addons
_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};

_.isObject = function(obj) {
    return (obj === Object(obj) && !_.isArray(obj));
};

_.isEmptyObject = function(obj) {
    if (_.isObject(obj)) {
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
};

_.isUndefined = function(obj) {
    return obj === void 0;
};

_.isString = function(obj) {
    return toString.call(obj) == '[object String]';
};

_.isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
};

_.isNumber = function(obj) {
    return toString.call(obj) == '[object Number]';
};

_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};

_.encodeDates = function(obj) {
    _.each(obj, function(v, k) {
        if (_.isDate(v)) {
            obj[k] = _.formatDate(v);
        } else if (_.isObject(v)) {
            obj[k] = _.encodeDates(v); // recurse
        }
    });
    return obj;
};

_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};

_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' +
        pad(d.getUTCMonth() + 1) + '-' +
        pad(d.getUTCDate()) + 'T' +
        pad(d.getUTCHours()) + ':' +
        pad(d.getUTCMinutes()) + ':' +
        pad(d.getUTCSeconds());
};

_.safewrap = function(f) {
    return function() {
        try {
            return f.apply(this, arguments);
        } catch (e) {
            console$1.critical('Implementation error. Please turn on debug and contact support@mixpanel.com.');
            if (Config.DEBUG){
                console$1.critical(e);
            }
        }
    };
};

_.safewrap_class = function(klass, functions) {
    for (var i = 0; i < functions.length; i++) {
        klass.prototype[functions[i]] = _.safewrap(klass.prototype[functions[i]]);
    }
};

_.safewrap_instance_methods = function(obj) {
    for (var func in obj) {
        if (typeof(obj[func]) === 'function') {
            obj[func] = _.safewrap(obj[func]);
        }
    }
};

_.strip_empty_properties = function(p) {
    var ret = {};
    _.each(p, function(v, k) {
        if (_.isString(v) && v.length > 0) {
            ret[k] = v;
        }
    });
    return ret;
};

/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */
_.truncate = function(obj, length) {
    var ret;

    if (typeof(obj) === 'string') {
        ret = obj.slice(0, length);
    } else if (_.isArray(obj)) {
        ret = [];
        _.each(obj, function(val) {
            ret.push(_.truncate(val, length));
        });
    } else if (_.isObject(obj)) {
        ret = {};
        _.each(obj, function(val, key) {
            ret[key] = _.truncate(val, length);
        });
    } else {
        ret = obj;
    }

    return ret;
};

_.JSONEncode = (function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = { // table of character substitutions
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };

            escapable.lastIndex = 0;
            return escapable.test(string) ?
                '"' + string.replace(escapable, function(a) {
                    var c = meta[a];
                    return typeof c === 'string' ? c :
                        '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                }) + '"' :
                '"' + string + '"';
        };

        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];

            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' &&
                typeof value.toJSON === 'function') {
                value = value.toJSON(key);
            }

            // What happens next depends on the value's type.
            switch (typeof value) {
                case 'string':
                    return quote(value);

                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';

                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.

                    return String(value);

                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) {
                        return 'null';
                    }

                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];

                    // Is the value an array?
                    if (toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.

                        length = value.length;
                        for (i = 0; i < length; i += 1) {
                            partial[i] = str(i, value) || 'null';
                        }

                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' :
                            gap ? '[\n' + gap +
                            partial.join(',\n' + gap) + '\n' +
                            mind + ']' :
                            '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }

                    // Iterate through all of the keys in the object.
                    for (k in value) {
                        if (hasOwnProperty.call(value, k)) {
                            v = str(k, value);
                            if (v) {
                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
                            }
                        }
                    }

                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' :
                        gap ? '{' + partial.join(',') + '' +
                        mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };

        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
})();

_.JSONDecode = (function() { // https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
    var at, // The index of the current character
        ch, // The current character
        escapee = {
            '"': '"',
            '\\': '\\',
            '/': '/',
            'b': '\b',
            'f': '\f',
            'n': '\n',
            'r': '\r',
            't': '\t'
        },
        text,
        error = function(m) {
            throw {
                name: 'SyntaxError',
                message: m,
                at: at,
                text: text
            };
        },
        next = function(c) {
            // If a c parameter is provided, verify that it matches the current character.
            if (c && c !== ch) {
                error('Expected \'' + c + '\' instead of \'' + ch + '\'');
            }
            // Get the next character. When there are no more characters,
            // return the empty string.
            ch = text.charAt(at);
            at += 1;
            return ch;
        },
        number = function() {
            // Parse a number value.
            var number,
                string = '';

            if (ch === '-') {
                string = '-';
                next('-');
            }
            while (ch >= '0' && ch <= '9') {
                string += ch;
                next();
            }
            if (ch === '.') {
                string += '.';
                while (next() && ch >= '0' && ch <= '9') {
                    string += ch;
                }
            }
            if (ch === 'e' || ch === 'E') {
                string += ch;
                next();
                if (ch === '-' || ch === '+') {
                    string += ch;
                    next();
                }
                while (ch >= '0' && ch <= '9') {
                    string += ch;
                    next();
                }
            }
            number = +string;
            if (!isFinite(number)) {
                error('Bad number');
            } else {
                return number;
            }
        },

        string = function() {
            // Parse a string value.
            var hex,
                i,
                string = '',
                uffff;
            // When parsing for string values, we must look for " and \ characters.
            if (ch === '"') {
                while (next()) {
                    if (ch === '"') {
                        next();
                        return string;
                    }
                    if (ch === '\\') {
                        next();
                        if (ch === 'u') {
                            uffff = 0;
                            for (i = 0; i < 4; i += 1) {
                                hex = parseInt(next(), 16);
                                if (!isFinite(hex)) {
                                    break;
                                }
                                uffff = uffff * 16 + hex;
                            }
                            string += String.fromCharCode(uffff);
                        } else if (typeof escapee[ch] === 'string') {
                            string += escapee[ch];
                        } else {
                            break;
                        }
                    } else {
                        string += ch;
                    }
                }
            }
            error('Bad string');
        },
        white = function() {
            // Skip whitespace.
            while (ch && ch <= ' ') {
                next();
            }
        },
        word = function() {
            // true, false, or null.
            switch (ch) {
                case 't':
                    next('t');
                    next('r');
                    next('u');
                    next('e');
                    return true;
                case 'f':
                    next('f');
                    next('a');
                    next('l');
                    next('s');
                    next('e');
                    return false;
                case 'n':
                    next('n');
                    next('u');
                    next('l');
                    next('l');
                    return null;
            }
            error('Unexpected "' + ch + '"');
        },
        value, // Placeholder for the value function.
        array = function() {
            // Parse an array value.
            var array = [];

            if (ch === '[') {
                next('[');
                white();
                if (ch === ']') {
                    next(']');
                    return array; // empty array
                }
                while (ch) {
                    array.push(value());
                    white();
                    if (ch === ']') {
                        next(']');
                        return array;
                    }
                    next(',');
                    white();
                }
            }
            error('Bad array');
        },
        object = function() {
            // Parse an object value.
            var key,
                object = {};

            if (ch === '{') {
                next('{');
                white();
                if (ch === '}') {
                    next('}');
                    return object; // empty object
                }
                while (ch) {
                    key = string();
                    white();
                    next(':');
                    if (Object.hasOwnProperty.call(object, key)) {
                        error('Duplicate key "' + key + '"');
                    }
                    object[key] = value();
                    white();
                    if (ch === '}') {
                        next('}');
                        return object;
                    }
                    next(',');
                    white();
                }
            }
            error('Bad object');
        };

    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch (ch) {
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };

    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;

        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) {
            error('Syntax error');
        }

        return result;
    };
})();

_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
        ac = 0,
        enc = '',
        tmp_arr = [];

    if (!data) {
        return data;
    }

    data = _.utf8Encode(data);

    do { // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);

        bits = o1 << 16 | o2 << 8 | o3;

        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;

        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);

    enc = tmp_arr.join('');

    switch (data.length % 3) {
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }

    return enc;
};

_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    var utftext = '',
        start,
        end;
    var stringl = 0,
        n;

    start = end = 0;
    stringl = string.length;

    for (n = 0; n < stringl; n++) {
        var c1 = string.charCodeAt(n);
        var enc = null;

        if (c1 < 128) {
            end++;
        } else if ((c1 > 127) && (c1 < 2048)) {
            enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
        } else {
            enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
        }
        if (enc !== null) {
            if (end > start) {
                utftext += string.substring(start, end);
            }
            utftext += enc;
            start = end = n + 1;
        }
    }

    if (end > start) {
        utftext += string.substring(start, string.length);
    }

    return utftext;
};

_.UUID = (function() {

    // Time/ticks information
    // 1*new Date() is a cross browser version of Date.now()
    var T = function() {
        var d = 1 * new Date(),
            i = 0;

        // this while loop figures how many browser ticks go by
        // before 1*new Date() returns a new number, ie the amount
        // of ticks that go by per millisecond
        while (d == 1 * new Date()) {
            i++;
        }

        return d.toString(16) + i.toString(16);
    };

    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace('.', '');
    };

    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = userAgent,
            i, ch, buffer = [],
            ret = 0;

        function xor(result, byte_array) {
            var j, tmp = 0;
            for (j = 0; j < byte_array.length; j++) {
                tmp |= (buffer[j] << j * 8);
            }
            return result ^ tmp;
        }

        for (i = 0; i < ua.length; i++) {
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }

        if (buffer.length > 0) {
            ret = xor(ret, buffer);
        }

        return ret.toString(16);
    };

    return function() {
        var se = (screen.height * screen.width).toString(16);
        return (T() + '-' + R() + '-' + UA() + '-' + se + '-' + T());
    };
})();

// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
_.isBlockedUA = function(ua) {
    if (/(google web preview|baiduspider|yandexbot|bingbot|googlebot|yahoo! slurp)/i.test(ua)) {
        return true;
    }
    return false;
};

/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */
_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];

    if (_.isUndefined(arg_separator)) {
        arg_separator = '&';
    }

    _.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });

    return tmp_arr.join(arg_separator);
};

_.getQueryParam = function(url, param) {
    // Expects a raw URL

    param = param.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)',
        regex = new RegExp(regexS),
        results = regex.exec(url);
    if (results === null || (results && typeof(results[1]) !== 'string' && results[1].length)) {
        return '';
    } else {
        return decodeURIComponent(results[1]).replace(/\+/g, ' ');
    }
};

_.getHashParam = function(hash, param) {
    var matches = hash.match(new RegExp(param + '=([^&]*)'));
    return matches ? matches[1] : null;
};

// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = document$1.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    },

    parse: function(name) {
        var cookie;
        try {
            cookie = _.JSONDecode(_.cookie.get(name)) || {};
        } catch (err) {
            // noop
        }
        return cookie;
    },

    set_seconds: function(name, value, seconds, cross_subdomain, is_secure) {
        var cdomain = '',
            expires = '',
            secure = '';

        if (cross_subdomain) {
            var matches = document$1.location.hostname.match(/[a-z0-9][a-z0-9\-]+\.[a-z\.]{2,6}$/i),
                domain = matches ? matches[0] : '';

            cdomain = ((domain) ? '; domain=.' + domain : '');
        }

        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + (seconds * 1000));
            expires = '; expires=' + date.toGMTString();
        }

        if (is_secure) {
            secure = '; secure';
        }

        document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },

    set: function(name, value, days, cross_subdomain, is_secure) {
        var cdomain = '', expires = '', secure = '';

        if (cross_subdomain) {
            var matches = document$1.location.hostname.match(/[a-z0-9][a-z0-9\-]+\.[a-z\.]{2,6}$/i),
                domain = matches ? matches[0] : '';

            cdomain   = ((domain) ? '; domain=.' + domain : '');
        }

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toGMTString();
        }

        if (is_secure) {
            secure = '; secure';
        }

        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },

    remove: function(name, cross_subdomain) {
        _.cookie.set(name, '', -1, cross_subdomain);
    }
};

// _.localStorage
_.localStorage = {
    error: function(msg) {
        console$1.error('localStorage error: ' + msg);
    },

    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            _.localStorage.error(err);
        }
        return null;
    },

    parse: function(name) {
        try {
            return _.JSONDecode(_.localStorage.get(name)) || {};
        } catch (err) {
            // noop
        }
        return null;
    },

    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            _.localStorage.error(err);
        }
    },

    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            _.localStorage.error(err);
        }
    }
};

_.register_event = (function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440

    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...[*])} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */
    var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            console$1.error('No valid element provided to register_event');
            return;
        }

        if (element.addEventListener && !oldSchool) {
            element.addEventListener(type, handler, !!useCapture);
        } else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };

    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);

            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) {
                return undefined;
            }

            var ret = true;
            var old_result, new_result;

            if (_.isFunction(old_handlers)) {
                old_result = old_handlers(event);
            }
            new_result = new_handler.call(element, event);

            if ((false === old_result) || (false === new_result)) {
                ret = false;
            }

            return ret;
        };

        return handler;
    }

    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };

    return register_event;
})();

_.dom_query = (function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */

    function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }

    var bad_whitespace = /[\t\r\n]/g;

    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return ((' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0);
    }

    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!document$1.getElementsByTagName) {
            return [];
        }
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [document$1];
        for (i = 0; i < tokens.length; i++) {
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = document$1.getElementById(id);
                if (!element || (tagName && element.nodeName.toLowerCase() != tagName)) {
                    // element not found or tag with that ID not found, return false
                    return [];
                }
                // Set currentContext to contain just this element
                currentContext = [element];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) {
                    tagName = '*';
                }
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for (j = 0; j < currentContext.length; j++) {
                    if (tagName == '*') {
                        elements = getAllChildren(currentContext[j]);
                    } else {
                        elements = currentContext[j].getElementsByTagName(tagName);
                    }
                    for (k = 0; k < elements.length; k++) {
                        found[foundCount++] = elements[k];
                    }
                }
                currentContext = [];
                currentContextIndex = 0;
                for (j = 0; j < found.length; j++) {
                    if (found[j].className &&
                        _.isString(found[j].className) && // some SVG elements have classNames which are not strings
                        hasClass(found[j], className)
                    ) {
                        currentContext[currentContextIndex++] = found[j];
                    }
                }
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match(/^(\w*)\[(\w+)([=~\|\^\$\*]?)=?"?([^\]"]*)"?\]$/);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) {
                    tagName = '*';
                }
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for (j = 0; j < currentContext.length; j++) {
                    if (tagName == '*') {
                        elements = getAllChildren(currentContext[j]);
                    } else {
                        elements = currentContext[j].getElementsByTagName(tagName);
                    }
                    for (k = 0; k < elements.length; k++) {
                        found[foundCount++] = elements[k];
                    }
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch (attrOperator) {
                    case '=': // Equality
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName) == attrValue);
                        };
                        break;
                    case '~': // Match one of space seperated words
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b')));
                        };
                        break;
                    case '|': // Match start with value followed by optional hyphen
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?')));
                        };
                        break;
                    case '^': // Match starts with value
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).indexOf(attrValue) === 0);
                        };
                        break;
                    case '$': // Match ends with value - fails with "Warning" in Opera 7
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length);
                        };
                        break;
                    case '*': // Match ends with value
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).indexOf(attrValue) > -1);
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for (j = 0; j < found.length; j++) {
                    if (checkFunction(found[j])) {
                        currentContext[currentContextIndex++] = found[j];
                    }
                }
                // alert('Attribute Selector: '+tagName+' '+attrName+' '+attrOperator+' '+attrValue);
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for (j = 0; j < currentContext.length; j++) {
                elements = currentContext[j].getElementsByTagName(tagName);
                for (k = 0; k < elements.length; k++) {
                    found[foundCount++] = elements[k];
                }
            }
            currentContext = found;
        }
        return currentContext;
    }

    return function(query) {
        if (_.isElement(query)) {
            return [query];
        } else if (_.isObject(query) && !_.isUndefined(query.length)) {
            return query;
        } else {
            return getElementsBySelector.call(this, query);
        }
    };
})();

_.info = {
    campaignParams: function() {
        var campaign_keywords = 'utm_source utm_medium utm_campaign utm_content utm_term'.split(' '),
            kw = '',
            params = {};
        _.each(campaign_keywords, function(kwkey) {
            kw = _.getQueryParam(document$1.URL, kwkey);
            if (kw.length) {
                params[kwkey] = kw;
            }
        });

        return params;
    },

    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
            return 'google';
        } else if (referrer.search('https?://(.*)bing.com') === 0) {
            return 'bing';
        } else if (referrer.search('https?://(.*)yahoo.com') === 0) {
            return 'yahoo';
        } else if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
            return 'duckduckgo';
        } else {
            return null;
        }
    },

    searchInfo: function(referrer) {
        var search = _.info.searchEngine(referrer),
            param = (search != 'yahoo') ? 'q' : 'p',
            ret = {};

        if (search !== null) {
            ret['$search_engine'] = search;

            var keyword = _.getQueryParam(referrer, param);
            if (keyword.length) {
                ret['mp_keyword'] = keyword;
            }
        }

        return ret;
    },

    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */
    browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || _.includes(user_agent, ' OPR/')) {
            if (_.includes(user_agent, 'Mini')) {
                return 'Opera Mini';
            }
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
            return 'BlackBerry';
        } else if (_.includes(user_agent, 'IEMobile') || _.includes(user_agent, 'WPDesktop')) {
            return 'Internet Explorer Mobile';
        } else if (_.includes(user_agent, 'Edge')) {
            return 'Microsoft Edge';
        } else if (_.includes(user_agent, 'FBIOS')) {
            return 'Facebook Mobile';
        } else if (_.includes(user_agent, 'Chrome')) {
            return 'Chrome';
        } else if (_.includes(user_agent, 'CriOS')) {
            return 'Chrome iOS';
        } else if (_.includes(user_agent, 'UCWEB') || _.includes(user_agent, 'UCBrowser')) {
            return 'UC Browser';
        } else if (_.includes(user_agent, 'FxiOS')) {
            return 'Firefox iOS';
        } else if (_.includes(vendor, 'Apple')) {
            if (_.includes(user_agent, 'Mobile')) {
                return 'Mobile Safari';
            }
            return 'Safari';
        } else if (_.includes(user_agent, 'Android')) {
            return 'Android Mobile';
        } else if (_.includes(user_agent, 'Konqueror')) {
            return 'Konqueror';
        } else if (_.includes(user_agent, 'Firefox')) {
            return 'Firefox';
        } else if (_.includes(user_agent, 'MSIE') || _.includes(user_agent, 'Trident/')) {
            return 'Internet Explorer';
        } else if (_.includes(user_agent, 'Gecko')) {
            return 'Mozilla';
        } else {
            return '';
        }
    },

    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */
    browserVersion: function(userAgent, vendor, opera) {
        var browser = _.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser' : /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) {
            return null;
        }
        var matches = userAgent.match(regex);
        if (!matches) {
            return null;
        }
        return parseFloat(matches[matches.length - 2]);
    },

    os: function() {
        var a = userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) {
                return 'Windows Phone';
            }
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) {
            return 'iOS';
        } else if (/Android/.test(a)) {
            return 'Android';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
            return 'BlackBerry';
        } else if (/Mac/i.test(a)) {
            return 'Mac OS X';
        } else if (/Linux/.test(a)) {
            return 'Linux';
        } else if (/CrOS/.test(a)) {
            return 'Chrome OS';
        } else {
            return '';
        }
    },

    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) {
            return 'Windows Phone';
        } else if (/iPad/.test(user_agent)) {
            return 'iPad';
        } else if (/iPod/.test(user_agent)) {
            return 'iPod Touch';
        } else if (/iPhone/.test(user_agent)) {
            return 'iPhone';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
            return 'BlackBerry';
        } else if (/Android/.test(user_agent)) {
            return 'Android';
        } else {
            return '';
        }
    },

    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) {
            return split[2];
        }
        return '';
    },

    properties: function() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator$1.vendor, window.opera),
            '$referrer': document$1.referrer,
            '$referring_domain': _.info.referringDomain(document$1.referrer),
            '$device': _.info.device(userAgent)
        }), {
            '$current_url': window.location.href,
            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, window.opera),
            '$screen_height': screen.height,
            '$screen_width': screen.width,
            'mp_lib': 'web',
            '$lib_version': Config.LIB_VERSION
        });
    },

    people_properties: function() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator$1.vendor, window.opera)
        }), {
            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, window.opera)
        });
    },

    pageviewInfo: function(page) {
        return _.strip_empty_properties({
            'mp_page': page,
            'mp_referrer': document$1.referrer,
            'mp_browser': _.info.browser(userAgent, navigator$1.vendor, window.opera),
            'mp_platform': _.info.os()
        });
    }
};

// EXPORTS (for closure compiler)
_['toArray']            = _.toArray;
_['isObject']           = _.isObject;
_['JSONEncode']         = _.JSONEncode;
_['JSONDecode']         = _.JSONDecode;
_['isBlockedUA']        = _.isBlockedUA;
_['isEmptyObject']      = _.isEmptyObject;
_['info']               = _.info;
_['info']['device']     = _.info.device;
_['info']['browser']    = _.info.browser;
_['info']['properties'] = _.info.properties;

/*
 * Get the className of an element, accounting for edge cases where element.className is an object
 * @param {Element} el - element to get the className of
 * @returns {string} the element's class
 */
function getClassName(el) {
    switch(typeof el.className) {
        case 'string':
            return el.className;
        case 'object': // handle cases where className might be SVGAnimatedString or some other type
            return el.className.baseVal || el.getAttribute('class') || '';
        default: // future proof
            return '';
    }
}

/*
 * Get the direct text content of an element, protecting against sensitive data collection.
 * Concats textContent of each of the element's text node children; this avoids potential
 * collection of sensitive data that could happen if we used element.textContent and the
 * element had sensitive child elements, since element.textContent includes child content.
 * Scrubs values that look like they could be sensitive (i.e. cc or ssn number).
 * @param {Element} el - element to get the text of
 * @returns {string} the element's direct text content
 */
function getSafeText(el) {
    var elText = '';

    if (shouldTrackElement(el) && el.childNodes && el.childNodes.length) {
        _.each(el.childNodes, function(child) {
            if (isTextNode(child) && child.textContent) {
                elText += _.trim(child.textContent)
                    // scrub potentially sensitive values
                    .split(/(\s+)/).filter(shouldTrackValue).join('')
                    // normalize whitespace
                    .replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ')
                    // truncate
                    .substring(0, 255);
            }
        });
    }

    return _.trim(elText);
}

/*
 * Check whether an element has nodeType Node.ELEMENT_NODE
 * @param {Element} el - element to check
 * @returns {boolean} whether el is of the correct nodeType
 */
function isElementNode(el) {
    return el && el.nodeType === 1; // Node.ELEMENT_NODE - use integer constant for browser portability
}

/*
 * Check whether an element is of a given tag type.
 * Due to potential reference discrepancies (such as the webcomponents.js polyfill),
 * we want to match tagNames instead of specific references because something like
 * element === document.body won't always work because element might not be a native
 * element.
 * @param {Element} el - element to check
 * @param {string} tag - tag name (e.g., "div")
 * @returns {boolean} whether el is of the given tag type
 */
function isTag(el, tag) {
    return el && el.tagName && el.tagName.toLowerCase() === tag.toLowerCase();
}

/*
 * Check whether an element has nodeType Node.TEXT_NODE
 * @param {Element} el - element to check
 * @returns {boolean} whether el is of the correct nodeType
 */
function isTextNode(el) {
    return el && el.nodeType === 3; // Node.TEXT_NODE - use integer constant for browser portability
}

/*
 * Check whether a DOM event should be "tracked" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @param {Event} event - event to check
 * @returns {boolean} whether the event should be tracked
 */
function shouldTrackDomEvent(el, event) {
    if (!el || isTag(el, 'html') || !isElementNode(el)) {
        return false;
    }
    var tag = el.tagName.toLowerCase();
    switch (tag) {
        case 'html':
            return false;
        case 'form':
            return event.type === 'submit';
        case 'input':
            if (['button', 'submit'].indexOf(el.getAttribute('type')) === -1) {
                return event.type === 'change';
            } else {
                return event.type === 'click';
            }
        case 'select':
        case 'textarea':
            return event.type === 'change';
        default:
            return event.type === 'click';
    }
}

/*
 * Check whether a DOM element should be "tracked" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {Element} el - element to check
 * @returns {boolean} whether the element should be tracked
 */
function shouldTrackElement(el) {
    for (var curEl = el; curEl.parentNode && !isTag(curEl, 'body'); curEl = curEl.parentNode) {
        var classes = getClassName(curEl).split(' ');
        if (_.includes(classes, 'mp-sensitive') || _.includes(classes, 'mp-no-track')) {
            return false;
        }
    }

    if (_.includes(getClassName(el).split(' '), 'mp-include')) {
        return true;
    }

    // don't send data from inputs or similar elements since there will always be
    // a risk of clientside javascript placing sensitive data in attributes
    if (
        isTag(el, 'input') ||
        isTag(el, 'select') ||
        isTag(el, 'textarea') ||
        el.getAttribute('contenteditable') === 'true'
    ) {
        return false;
    }

    // don't include hidden or password fields
    var type = el.type || '';
    if (typeof type === 'string') { // it's possible for el.type to be a DOM element if el is a form with a child input[name="type"]
        switch(type.toLowerCase()) {
            case 'hidden':
                return false;
            case 'password':
                return false;
        }
    }

    // filter out data from fields that look like sensitive fields
    var name = el.name || el.id || '';
    if (typeof name === 'string') { // it's possible for el.name or el.id to be a DOM element if el is a form with a child input[name="name"]
        var sensitiveNameRegex = /^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i;
        if (sensitiveNameRegex.test(name.replace(/[^a-zA-Z0-9]/g, ''))) {
            return false;
        }
    }

    return true;
}

/*
 * Check whether a string value should be "tracked" or if it may contain sentitive data
 * using a variety of heuristics.
 * @param {string} value - string value to check
 * @returns {boolean} whether the element should be tracked
 */
function shouldTrackValue(value) {
    if (value === null || _.isUndefined(value)) {
        return false;
    }

    if (typeof value === 'string') {
        value = _.trim(value);

        // check to see if input value looks like a credit card number
        // see: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s20.html
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((value || '').replace(/[\- ]/g, ''))) {
            return false;
        }

        // check to see if input value looks like a social security number
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(value)) {
            return false;
        }
    }

    return true;
}

var autotrack = {
    _initializedTokens: [],

    _previousElementSibling: function(el) {
        if (el.previousElementSibling) {
            return el.previousElementSibling;
        } else {
            do {
                el = el.previousSibling;
            } while (el && !isElementNode(el));
            return el;
        }
    },

    _loadScript: function(scriptUrlToLoad, callback) {
        var scriptTag = document.createElement('script');
        scriptTag.type = 'text/javascript';
        scriptTag.src = scriptUrlToLoad;
        scriptTag.onload = callback;

        var scripts = document.getElementsByTagName('script');
        if (scripts.length > 0) {
            scripts[0].parentNode.insertBefore(scriptTag, scripts[0]);
        } else {
            document.body.appendChild(scriptTag);
        }
    },

    _getPropertiesFromElement: function(elem) {
        var props = {
            'classes': getClassName(elem).split(' '),
            'tag_name': elem.tagName.toLowerCase()
        };

        if (shouldTrackElement(elem)) {
            _.each(elem.attributes, function(attr) {
                if (shouldTrackValue(attr.value)) {
                    props['attr__' + attr.name] = attr.value;
                }
            });
        }

        var nthChild = 1;
        var nthOfType = 1;
        var currentElem = elem;
        while (currentElem = this._previousElementSibling(currentElem)) { // eslint-disable-line no-cond-assign
            nthChild++;
            if (currentElem.tagName === elem.tagName) {
                nthOfType++;
            }
        }
        props['nth_child'] = nthChild;
        props['nth_of_type'] = nthOfType;

        return props;
    },

    _getDefaultProperties: function(eventType) {
        return {
            '$event_type': eventType,
            '$ce_version': 1,
            '$host': window.location.host,
            '$pathname': window.location.pathname
        };
    },

    _extractCustomPropertyValue: function(customProperty) {
        var propValues = [];
        _.each(document.querySelectorAll(customProperty['css_selector']), function(matchedElem) {
            var value;

            if (['input', 'select'].indexOf(matchedElem.tagName.toLowerCase()) > -1) {
                value = matchedElem['value'];
            } else if (matchedElem['textContent']) {
                value = matchedElem['textContent'];
            }

            if (shouldTrackValue(value)) {
                propValues.push(value);
            }
        });
        return propValues.join(', ');
    },

    _getCustomProperties: function(targetElementList) {
        var props = {};
        _.each(this._customProperties, function(customProperty) {
            _.each(customProperty['event_selectors'], function(eventSelector) {
                var eventElements = document.querySelectorAll(eventSelector);
                _.each(eventElements, function(eventElement) {
                    if (_.includes(targetElementList, eventElement) && shouldTrackElement(eventElement)) {
                        props[customProperty['name']] = this._extractCustomPropertyValue(customProperty);
                    }
                }, this);
            }, this);
        }, this);
        return props;
    },

    _getEventTarget: function(e) {
        // https://developer.mozilla.org/en-US/docs/Web/API/Event/target#Compatibility_notes
        if (typeof e.target === 'undefined') {
            return e.srcElement;
        } else {
            return e.target;
        }
    },

    _trackEvent: function(e, instance) {
        /*** Don't mess with this code without running IE8 tests on it ***/
        var target = this._getEventTarget(e);
        if (isTextNode(target)) { // defeat Safari bug (see: http://www.quirksmode.org/js/events_properties.html)
            target = target.parentNode;
        }

        if (shouldTrackDomEvent(target, e)) {
            var targetElementList = [target];
            var curEl = target;
            while (curEl.parentNode && !isTag(curEl, 'body')) {
                targetElementList.push(curEl.parentNode);
                curEl = curEl.parentNode;
            }

            var elementsJson = [];
            var href, explicitNoTrack = false;
            _.each(targetElementList, function(el) {
                var shouldTrackEl = shouldTrackElement(el);

                // if the element or a parent element is an anchor tag
                // include the href as a property
                if (el.tagName.toLowerCase() === 'a') {
                    href = el.getAttribute('href');
                    href = shouldTrackEl && shouldTrackValue(href) && href;
                }

                // allow users to programatically prevent tracking of elements by adding class 'mp-no-track'
                var classes = getClassName(el).split(' ');
                if (_.includes(classes, 'mp-no-track')) {
                    explicitNoTrack = true;
                }

                elementsJson.push(this._getPropertiesFromElement(el));
            }, this);

            if (explicitNoTrack) {
                return false;
            }

            // only populate text content from target element (not parents)
            // to prevent text within a sensitive element from being collected
            // as part of a parent's el.textContent
            var elementText;
            var safeElementText = getSafeText(target);
            if (safeElementText && safeElementText.length) {
                elementText = safeElementText;
            }

            var props = _.extend(
                this._getDefaultProperties(e.type),
                {
                    '$elements':  elementsJson,
                    '$el_attr__href': href,
                    '$el_text': elementText
                },
                this._getCustomProperties(targetElementList)
            );

            instance.track('$web_event', props);
            return true;
        }
    },

    // only reason is to stub for unit tests
    // since you can't override window.location props
    _navigate: function(href) {
        window.location.href = href;
    },

    _addDomEventHandlers: function(instance) {
        var handler = _.bind(function(e) {
            e = e || window.event;
            this._trackEvent(e, instance);
        }, this);
        _.register_event(document, 'submit', handler, false, true);
        _.register_event(document, 'change', handler, false, true);
        _.register_event(document, 'click', handler, false, true);
    },

    _customProperties: {},
    init: function(instance) {
        if (!(document && document.body)) {
            console.log('document not ready yet, trying again in 500 milliseconds...');
            var that = this;
            setTimeout(function() { that.init(instance); }, 500);
            return;
        }

        var token = instance.get_config('token');
        if (this._initializedTokens.indexOf(token) > -1) {
            console.log('autotrack already initialized for token "' + token + '"');
            return;
        }
        this._initializedTokens.push(token);

        if (!this._maybeLoadEditor(instance)) { // don't autotrack actions when the editor is enabled
            var parseDecideResponse = _.bind(function(response) {
                if (response && response['config'] && response['config']['enable_collect_everything'] === true) {

                    if (response['custom_properties']) {
                        this._customProperties = response['custom_properties'];
                    }

                    instance.track('$web_event', _.extend({
                        '$title': document.title
                    }, this._getDefaultProperties('pageview')));

                    this._addDomEventHandlers(instance);

                } else {
                    instance['__autotrack_enabled'] = false;
                }
            }, this);

            instance._send_request(
                instance.get_config('api_host') + '/decide/', {
                    'verbose': true,
                    'version': '1',
                    'lib': 'web',
                    'token': token
                },
                instance._prepare_callback(parseDecideResponse)
            );
        }
    },

    _editorParamsFromHash: function(instance, hash) {
        var editorParams;
        try {
            var state = _.getHashParam(hash, 'state');
            state = JSON.parse(decodeURIComponent(state));
            var expiresInSeconds = _.getHashParam(hash, 'expires_in');
            editorParams = {
                'accessToken': _.getHashParam(hash, 'access_token'),
                'accessTokenExpiresAt': (new Date()).getTime() + (Number(expiresInSeconds) * 1000),
                'bookmarkletMode': !!state['bookmarkletMode'],
                'projectId': state['projectId'],
                'projectOwnerId': state['projectOwnerId'],
                'projectToken': state['token'],
                'readOnly': state['readOnly'],
                'userFlags': state['userFlags'],
                'userId': state['userId']
            };
            window.sessionStorage.setItem('editorParams', JSON.stringify(editorParams));

            if (state['desiredHash']) {
                window.location.hash = state['desiredHash'];
            } else if (window.history) {
                history.replaceState('', document.title, window.location.pathname + window.location.search); // completely remove hash
            } else {
                window.location.hash = ''; // clear hash (but leaves # unfortunately)
            }
        } catch (e) {
            console.error('Unable to parse data from hash', e);
        }
        return editorParams;
    },

    /**
     * To load the visual editor, we need an access token and other state. That state comes from one of three places:
     * 1. In the URL hash params if the customer is using an old snippet
     * 2. From session storage under the key `_mpcehash` if the snippet already parsed the hash
     * 3. From session storage under the key `editorParams` if the editor was initialized on a previous page
     */
    _maybeLoadEditor: function(instance) {
        try {
            var parseFromUrl = false;
            if (_.getHashParam(window.location.hash, 'state')) {
                var state = _.getHashParam(window.location.hash, 'state');
                state = JSON.parse(decodeURIComponent(state));
                parseFromUrl = state['action'] === 'mpeditor';
            }
            var parseFromStorage = !!window.sessionStorage.getItem('_mpcehash');
            var editorParams;

            if (parseFromUrl) { // happens if they are initializing the editor using an old snippet
                editorParams = this._editorParamsFromHash(instance, window.location.hash);
            } else if (parseFromStorage) { // happens if they are initialized the editor and using the new snippet
                editorParams = this._editorParamsFromHash(instance, window.sessionStorage.getItem('_mpcehash'));
                window.sessionStorage.removeItem('_mpcehash');
            } else { // get credentials from sessionStorage from a previous initialzation
                editorParams = JSON.parse(window.sessionStorage.getItem('editorParams') || '{}');
            }

            if (editorParams['projectToken'] && instance.get_config('token') === editorParams['projectToken']) {
                this._loadEditor(instance, editorParams);
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    },

    _loadEditor: function(instance, editorParams) {
        if (!window['_mpEditorLoaded']) { // only load the codeless event editor once, even if there are multiple instances of MixpanelLib
            window['_mpEditorLoaded'] = true;
            var editorUrl = instance.get_config('app_host')
              + '/js-bundle/reports/collect-everything/editor.js?_ts='
              + (new Date()).getTime();
            this._loadScript(editorUrl, function() {
                window['mp_load_editor'](editorParams);
            });
            return true;
        }
        return false;
    },

    // this is a mechanism to ramp up CE with no server-side interaction.
    // when CE is active, every page load results in a decide request. we
    // need to gently ramp this up so we don't overload decide. this decides
    // deterministically if CE is enabled for this project by modding the char
    // value of the project token.
    enabledForProject: function(token, numBuckets, numEnabledBuckets) {
        numBuckets = !_.isUndefined(numBuckets) ? numBuckets : 10;
        numEnabledBuckets = !_.isUndefined(numEnabledBuckets) ? numEnabledBuckets : 10;
        var charCodeSum = 0;
        for (var i = 0; i < token.length; i++) {
            charCodeSum += token.charCodeAt(i);
        }
        return (charCodeSum % numBuckets) < numEnabledBuckets;
    },

    isBrowserSupported: function() {
        return _.isFunction(document.querySelectorAll);
    }
};

_.bind_instance_methods(autotrack);
_.safewrap_instance_methods(autotrack);

/*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */

// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==

/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/

var init_type;       // MODULE or SNIPPET loader
var mixpanel_master; // main mixpanel instance / object
var INIT_MODULE  = 0;
var INIT_SNIPPET = 1;

/*
 * Constants
 */
/** @const */   var PRIMARY_INSTANCE_NAME     = 'mixpanel';
/** @const */   var SET_QUEUE_KEY             = '__mps';
/** @const */   var SET_ONCE_QUEUE_KEY        = '__mpso';
/** @const */   var UNSET_QUEUE_KEY           = '__mpus';
/** @const */   var ADD_QUEUE_KEY             = '__mpa';
/** @const */   var APPEND_QUEUE_KEY          = '__mpap';
/** @const */   var UNION_QUEUE_KEY           = '__mpu';
/** @const */   var SET_ACTION                = '$set';
/** @const */   var SET_ONCE_ACTION           = '$set_once';
/** @const */   var UNSET_ACTION              = '$unset';
/** @const */   var ADD_ACTION                = '$add';
/** @const */   var APPEND_ACTION             = '$append';
/** @const */   var UNION_ACTION              = '$union';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */   var PEOPLE_DISTINCT_ID_KEY    = '$people_distinct_id';
/** @const */   var ALIAS_ID_KEY              = '__alias';
/** @const */   var CAMPAIGN_IDS_KEY          = '__cmpns';
/** @const */   var EVENT_TIMERS_KEY          = '__timers';
/** @const */   var RESERVED_PROPERTIES       = [
    SET_QUEUE_KEY,
    SET_ONCE_QUEUE_KEY,
    UNSET_QUEUE_KEY,
    ADD_QUEUE_KEY,
    APPEND_QUEUE_KEY,
    UNION_QUEUE_KEY,
    PEOPLE_DISTINCT_ID_KEY,
    ALIAS_ID_KEY,
    CAMPAIGN_IDS_KEY,
    EVENT_TIMERS_KEY
];

/*
 * Dynamic... constants? Is that an oxymoron?
 */
    // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
    // https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var USE_XHR = (win.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest());

    // IE<10 does not support cross-origin XHR's but script tags
    // with defer won't block window.onload; ENQUEUE_REQUESTS
    // should only be true for Opera<12
var ENQUEUE_REQUESTS = !USE_XHR && (userAgent.indexOf('MSIE') === -1) && (userAgent.indexOf('Mozilla') === -1);

/*
 * Module-level globals
 */
var DEFAULT_CONFIG = {
    'api_host':               'https://api.mixpanel.com',
    'app_host':               'https://mixpanel.com',
    'autotrack':              true,
    'cdn':                    'https://cdn.mxpnl.com',
    'cross_subdomain_cookie': true,
    'persistence':            'cookie',
    'persistence_name':       '',
    'cookie_name':            '',
    'loaded':                 function() {},
    'store_google':           true,
    'save_referrer':          true,
    'test':                   false,
    'verbose':                false,
    'img':                    false,
    'track_pageview':         true,
    'debug':                  false,
    'track_links_timeout':    300,
    'cookie_expiration':      365,
    'upgrade':                false,
    'disable_persistence':    false,
    'disable_cookie':         false,
    'secure_cookie':          false,
    'ip':                     true,
    'property_blacklist':     []
};

var DOM_LOADED = false;

/**
 * DomTracker Object
 * @constructor
 */
var DomTracker = function() {};

// interface
DomTracker.prototype.create_properties = function() {};
DomTracker.prototype.event_handler = function() {};
DomTracker.prototype.after_track_handler = function() {};

DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};

/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function(...[*])=} user_callback
 */
DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = _.dom_query(query);

    if (elements.length === 0) {
        console$1.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }

    _.each(elements, function(element) {
        _.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');

            that.event_handler(e, this, options);

            // in case the mixpanel servers don't get back to us in time
            win.setTimeout(that.track_callback(user_callback, props, options, true), timeout);

            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);

    return true;
};

/**
 * @param {function(...[*])} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */
DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;

    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) { return; }
        options.callback_fired = true;

        if (user_callback && user_callback(timeout_occured, props) === false) {
            // user can prevent the default functionality by
            // returning false from their callback
            return;
        }

        that.after_track_handler(props, options, timeout_occured);
    };
};

DomTracker.prototype.create_properties = function(properties, element) {
    var props;

    if (typeof(properties) === 'function') {
        props = properties(element);
    } else {
        props = _.extend({}, properties);
    }

    return props;
};

/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */
var LinkTracker = function() {
    this.override_event = 'click';
};
_.inherit(LinkTracker, DomTracker);

LinkTracker.prototype.create_properties = function(properties, element) {
    var props = LinkTracker.superclass.create_properties.apply(this, arguments);

    if (element.href) { props['url'] = element.href; }

    return props;
};

LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = (
        evt.which === 2 ||
        evt.metaKey ||
        evt.ctrlKey ||
        element.target === '_blank'
    );
    options.href = element.href;

    if (!options.new_tab) {
        evt.preventDefault();
    }
};

LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) { return; }

    setTimeout(function() {
        win.location = options.href;
    }, 0);
};

/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */
var FormTracker = function() {
    this.override_event = 'submit';
};
_.inherit(FormTracker, DomTracker);

FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};

FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};

/**
 * Mixpanel Persistence Object
 * @constructor
 */
var MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;

    if (config['persistence_name']) {
        this.name = 'mp_' + config['persistence_name'];
    } else {
        this.name = 'mp_' + config['token'] + '_mixpanel';
    }

    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }

    var localStorage_supported = function() {
        var supported = true;
        try {
            var key = '__mplssupport__',
                val = 'xyz';
            _.localStorage.set(key, val);
            if (_.localStorage.get(key) !== val) {
                supported = false;
            }
            _.localStorage.remove(key);
        } catch (err) {
            supported = false;
        }
        if (!supported) {
            console$1.error('localStorage unsupported; falling back to cookie store');
        }
        return supported;
    };
    if (storage_type === 'localStorage' && localStorage_supported()) {
        this.storage = _.localStorage;
    } else {
        this.storage = _.cookie;
    }

    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
};

MixpanelPersistence.prototype.properties = function() {
    var p = {};
    // Filter out reserved properties
    _.each(this['props'], function(v, k) {
        if (!_.include(RESERVED_PROPERTIES, k)) {
            p[k] = v;
        }
    });
    return p;
};

MixpanelPersistence.prototype.load = function() {
    if (this.disabled) { return; }

    var entry = this.storage.parse(this.name);

    if (entry) {
        this['props'] = _.extend({}, entry);
    }
};

MixpanelPersistence.prototype.upgrade = function(config) {
    var upgrade_from_old_lib = config['upgrade'],
        old_cookie_name,
        old_cookie;

    if (upgrade_from_old_lib) {
        old_cookie_name = 'mp_super_properties';
        // Case where they had a custom cookie name before.
        if (typeof(upgrade_from_old_lib) === 'string') {
            old_cookie_name = upgrade_from_old_lib;
        }

        old_cookie = this.storage.parse(old_cookie_name);

        // remove the cookie
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);

        if (old_cookie) {
            this['props'] = _.extend(
                this['props'],
                old_cookie['all'],
                old_cookie['events']
            );
        }
    }

    if (!config['cookie_name'] && config['name'] !== 'mixpanel') {
        // special case to handle people with cookies of the form
        // mp_TOKEN_INSTANCENAME from the first release of this library
        old_cookie_name = 'mp_' + config['token'] + '_' + config['name'];
        old_cookie = this.storage.parse(old_cookie_name);

        if (old_cookie) {
            this.storage.remove(old_cookie_name);
            this.storage.remove(old_cookie_name, true);

            // Save the prop values that were in the cookie from before -
            // this should only happen once as we delete the old one.
            this.register_once(old_cookie);
        }
    }

    if (this.storage === _.localStorage) {
        old_cookie = _.cookie.parse(this.name);

        _.cookie.remove(this.name);
        _.cookie.remove(this.name, true);

        if (old_cookie) {
            this.register_once(old_cookie);
        }
    }
};

MixpanelPersistence.prototype.save = function() {
    if (this.disabled) { return; }
    this._expire_notification_campaigns();
    this.storage.set(
        this.name,
        _.JSONEncode(this['props']),
        this.expire_days,
        this.cross_subdomain,
        this.secure
    );
};

MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false);
    this.storage.remove(this.name, true);
};

// removes the storage entry and deletes all loaded data
// forced name for tests
MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};

/**
 * @param {Object} props
 * @param {*=} default_value
 * @param {number=} days
 */
MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if (_.isObject(props)) {
        if (typeof(default_value) === 'undefined') { default_value = 'None'; }
        this.expire_days = (typeof(days) === 'undefined') ? this.default_expiry : days;

        _.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) {
                this['props'][prop] = val;
            }
        }, this);

        this.save();

        return true;
    }
    return false;
};

/**
 * @param {Object} props
 * @param {number=} days
 */
MixpanelPersistence.prototype.register = function(props, days) {
    if (_.isObject(props)) {
        this.expire_days = (typeof(days) === 'undefined') ? this.default_expiry : days;

        _.extend(this['props'], props);

        this.save();

        return true;
    }
    return false;
};

MixpanelPersistence.prototype.unregister = function(prop) {
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};

MixpanelPersistence.prototype._expire_notification_campaigns = _.safewrap(function() {
    var campaigns_shown = this['props'][CAMPAIGN_IDS_KEY],
        EXPIRY_TIME = Config.DEBUG ? 60 * 1000 : 60 * 60 * 1000; // 1 minute (Config.DEBUG) / 1 hour (PDXN)
    if (!campaigns_shown) {
        return;
    }
    for (var campaign_id in campaigns_shown) {
        if (1 * new Date() - campaigns_shown[campaign_id] > EXPIRY_TIME) {
            delete campaigns_shown[campaign_id];
        }
    }
    if (_.isEmptyObject(campaigns_shown)) {
        delete this['props'][CAMPAIGN_IDS_KEY];
    }
});

MixpanelPersistence.prototype.update_campaign_params = function() {
    if (!this.campaign_params_saved) {
        this.register_once(_.info.campaignParams());
        this.campaign_params_saved = true;
    }
};

MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register(_.info.searchInfo(referrer));
};

// EXPORTED METHOD, we test this directly.
MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': _.info.referringDomain(referrer) || '$direct'
    }, '');
};

MixpanelPersistence.prototype.get_referrer_info = function() {
    return _.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};

// safely fills the passed in object with stored properties,
// does not override any properties defined in both
// returns the passed in object
MixpanelPersistence.prototype.safe_merge = function(props) {
    _.each(this['props'], function(val, prop) {
        if (!(prop in props)) {
            props[prop] = val;
        }
    });

    return props;
};

MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};

MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) {
        this.remove();
    }
};

MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};

MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue),
        q_data = data[queue],
        set_q = this._get_or_create_queue(SET_ACTION),
        set_once_q = this._get_or_create_queue(SET_ONCE_ACTION),
        unset_q = this._get_or_create_queue(UNSET_ACTION),
        add_q = this._get_or_create_queue(ADD_ACTION),
        union_q = this._get_or_create_queue(UNION_ACTION),
        append_q = this._get_or_create_queue(APPEND_ACTION, []);

    if (q_key === SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        _.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue(ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue(UNION_ACTION, q_data);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        _.each(q_data, function(v, k) {
            if (!(k in set_once_q)) {
                set_once_q[k] = v;
            }
        });
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === UNSET_QUEUE_KEY) {
        _.each(q_data, function(prop) {

            // undo previously-queued actions on this key
            _.each([set_q, set_once_q, add_q, union_q], function(enqueued_obj) {
                if (prop in enqueued_obj) {
                    delete enqueued_obj[prop];
                }
            });
            _.each(append_q, function(append_obj) {
                if (prop in append_obj) {
                    delete append_obj[prop];
                }
            });

            unset_q[prop] = true;

        });
    } else if (q_key === ADD_QUEUE_KEY) {
        _.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) {
                set_q[k] += v;
            } else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) {
                    add_q[k] = 0;
                }
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === UNION_QUEUE_KEY) {
        _.each(q_data, function(v, k) {
            if (_.isArray(v)) {
                if (!(k in union_q)) {
                    union_q[k] = [];
                }
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    }

    console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    console$1.log(data);

    this.save();
};

MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this._get_queue(queue);
    if (!_.isUndefined(q)) {
        _.each(data, function(v, k) {
            delete q[k];
        }, this);

        this.save();
    }
};

MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === SET_ACTION) {
        return SET_QUEUE_KEY;
    } else if (queue === SET_ONCE_ACTION) {
        return SET_ONCE_QUEUE_KEY;
    } else if (queue === UNSET_ACTION) {
        return UNSET_QUEUE_KEY;
    } else if (queue === ADD_ACTION) {
        return ADD_QUEUE_KEY;
    } else if (queue === APPEND_ACTION) {
        return APPEND_QUEUE_KEY;
    } else if (queue === UNION_ACTION) {
        return UNION_QUEUE_KEY;
    } else {
        console$1.error('Invalid queue:', queue);
    }
};

MixpanelPersistence.prototype._get_queue = function(queue) {
    return this['props'][this._get_queue_key(queue)];
};
MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = _.isUndefined(default_val) ? {} : default_val;

    return this['props'][key] || (this['props'][key] = default_val);
};

MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this['props'][EVENT_TIMERS_KEY] || {};
    timers[event_name] = timestamp;
    this['props'][EVENT_TIMERS_KEY] = timers;
    this.save();
};

MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this['props'][EVENT_TIMERS_KEY] || {};
    var timestamp = timers[event_name];
    if (!_.isUndefined(timestamp)) {
        delete this['props'][EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};

/**
 * Mixpanel Library Object
 * @constructor
 */
var MixpanelLib = function() {};

/**
 * Mixpanel People Object
 * @constructor
 */
var MixpanelPeople = function() {};

var MPNotif;

/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */
var create_mplib = function(token, config, name) {
    var instance,
        target = (name === PRIMARY_INSTANCE_NAME) ? mixpanel_master : mixpanel_master[name];

    if (target && init_type === INIT_MODULE) {
        instance = target;
    } else {
        if (target && !_.isArray(target)) {
            console$1.error('You have already initialized ' + name);
            return;
        }
        instance = new MixpanelLib();
    }

    instance._init(token, config, name);

    instance['people'] = new MixpanelPeople();
    instance['people']._init(instance);

    // if any instance on the page has debug = true, we set the
    // global debug to be true
    Config.DEBUG = Config.DEBUG || instance.get_config('debug');

    instance['__autotrack_enabled'] = instance.get_config('autotrack');
    if (instance.get_config('autotrack')) {
        var num_buckets = 100;
        var num_enabled_buckets = 100;
        if (!autotrack.enabledForProject(instance.get_config('token'), num_buckets, num_enabled_buckets)) {
            instance['__autotrack_enabled'] = false;
            console$1.log('Not in active bucket: disabling Automatic Event Collection.');
        } else if (!autotrack.isBrowserSupported()) {
            instance['__autotrack_enabled'] = false;
            console$1.log('Disabling Automatic Event Collection because this browser is not supported');
        } else {
            autotrack.init(instance);
        }

        try {
            add_dom_event_counting_handlers(instance);
        } catch (e) {
            console$1.error(e);
        }
    }

    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!_.isUndefined(target) && _.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }

    return instance;
};

// Initialization methods

/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/8b2e1f7b/src/mixpanel-core.js#L87-L110">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */
MixpanelLib.prototype.init = function (token, config, name) {
    if (_.isUndefined(name)) {
        console$1.error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === PRIMARY_INSTANCE_NAME) {
        console$1.error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }

    var instance = create_mplib(token, config, name);
    mixpanel_master[name] = instance;
    instance._loaded();

    return instance;
};

// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
MixpanelLib.prototype._init = function(token, config, name) {
    this['__loaded'] = true;
    this['config'] = {};

    this.set_config(_.extend({}, DEFAULT_CONFIG, config, {
        'name': name,
        'token': token,
        'callback_fn': ((name === PRIMARY_INSTANCE_NAME) ? name : PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));

    this['_jsc'] = function() {};

    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };

    this['persistence'] = this['cookie'] = new MixpanelPersistence(this['config']);
    this.register_once({'distinct_id': _.UUID()}, '');
};

// Private methods

MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);

    // this happens after so a user can call identify/name_tag in
    // the loaded callback
    if (this.get_config('track_pageview')) {
        this.track_pageview();
    }
};

MixpanelLib.prototype._dom_loaded = function() {
    _.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    _.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};

MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        console$1.error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }

    if (!DOM_LOADED) {
        this.__dom_loaded_queue.push([DomClass, args]);
        return false;
    }

    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};

/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */
MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if (_.isUndefined(callback)) {
        return null;
    }

    if (USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};

MixpanelLib.prototype._send_request = function(url, data, callback) {
    if (ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return;
    }

    // needed to correctly format responses
    var verbose_mode = this.get_config('verbose');
    if (data['verbose']) { verbose_mode = true; }

    if (this.get_config('test')) { data['test'] = 1; }
    if (verbose_mode) { data['verbose'] = 1; }
    if (this.get_config('img')) { data['img'] = 1; }
    if (!USE_XHR) {
        if (callback) {
            data['callback'] = callback;
        } else if (verbose_mode || this.get_config('test')) {
            // Verbose output (from verbose mode, or an error in test mode) is a json blob,
            // which by itself is not valid javascript. Without a callback, this verbose output will
            // cause an error when returned via jsonp, so we force a no-op callback param.
            // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
            data['callback'] = '(function(){})';
        }
    }

    data['ip'] = this.get_config('ip')?1:0;
    data['_'] = new Date().getTime().toString();
    url += '?' + _.HTTPBuildQuery(data);

    if ('img' in data) {
        var img = document$1.createElement('img');
        img.src = url;
        document$1.body.appendChild(img);
    } else if (USE_XHR) {
        try {
            var req = new XMLHttpRequest();
            req.open('GET', url, true);
            // send the mp_optout cookie
            // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
            req.withCredentials = true;
            req.onreadystatechange = function () {
                if (req.readyState === 4) { // XMLHttpRequest.DONE == 4, except in safari 4
                    if (req.status === 200) {
                        if (callback) {
                            if (verbose_mode) {
                                callback(_.JSONDecode(req.responseText));
                            } else {
                                callback(Number(req.responseText));
                            }
                        }
                    } else {
                        var error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                        console$1.error(error);
                        if (callback) {
                            if (verbose_mode) {
                                callback({status: 0, error: error});
                            } else {
                                callback(0);
                            }
                        }
                    }
                }
            };
            req.send(null);
        } catch (e) {
            console$1.error(e);
        }
    } else {
        var script = document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }
};

/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */
MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    _.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if (typeof(item) === 'function') {
                item.call(this);
            } else if (_.isArray(item) && fn_name === 'alias') {
                alias_calls.push(item);
            } else if (_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof(this[fn_name]) === 'function') {
                tracking_calls.push(item);
            } else {
                other_calls.push(item);
            }
        }
    }, this);

    var execute = function(calls, context) {
        _.each(calls, function(item) {
            this[item[0]].apply(this, item.slice(1));
        }, context);
    };

    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};

/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */
MixpanelLib.prototype.push = function(item) {
    this._execute_array([item]);
};

/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */
MixpanelLib.prototype.disable = function(events) {
    if (typeof(events) === 'undefined') {
        this._flags.disable_all_events = true;
    } else {
        this.__disabled_events = this.__disabled_events.concat(events);
    }
};

/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */
MixpanelLib.prototype.track = function(event_name, properties, callback) {
    if (typeof(callback) !== 'function') {
        callback = function() {};
    }

    if (_.isUndefined(event_name)) {
        console$1.error('No event name provided to mixpanel.track');
        return;
    }

    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }

    // set defaults
    properties = properties || {};
    properties['token'] = this.get_config('token');

    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }

    // update persistence
    this['persistence'].update_search_keyword(document$1.referrer);

    if (this.get_config('store_google')) { this['persistence'].update_campaign_params(); }
    if (this.get_config('save_referrer')) { this['persistence'].update_referrer_info(document$1.referrer); }

    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object

    // update properties with pageview info and super-properties
    properties = _.extend(
        {},
        _.info.properties(),
        this['persistence'].properties(),
        properties
    );

    try {
        if (this.get_config('autotrack') && event_name !== 'mp_page_view' && event_name !== '$create_alias') {
            // The point of $__c is to count how many clicks occur per tracked event. Since we're
            // tracking an event in this function, we need to reset the $__c value.
            properties = _.extend({}, properties, this.mp_counts);
            this.mp_counts = {'$__c': 0};
            _.cookie.set('mp_' + this.get_config('name') + '__c', 0, 1, true);
        }
    } catch (e) {
        console$1.error(e);
    }

    var property_blacklist = this.get_config('property_blacklist');
    if (_.isArray(property_blacklist)) {
        _.each(property_blacklist, function(blacklisted_prop) {
            delete properties[blacklisted_prop];
        });
    } else {
        console$1.error('Invalid value for property_blacklist config: ' + property_blacklist);
    }

    var data = {
        'event': event_name,
        'properties': properties
    };

    var truncated_data = _.truncate(data, 255);
    var json_data      = _.JSONEncode(truncated_data);
    var encoded_data   = _.base64Encode(json_data);

    console$1.log('MIXPANEL REQUEST:');
    console$1.log(truncated_data);

    this._send_request(
        this.get_config('api_host') + '/track/',
        { 'data': encoded_data },
        this._prepare_callback(callback, truncated_data)
    );

    return truncated_data;
};

/**
 * Track a page view event, which is currently ignored by the server.
 * This function is called by default on page load unless the
 * track_pageview configuration variable is false.
 *
 * @param {String} [page] The url of the page to record. If you don't include this, it defaults to the current url.
 * @api private
 */
MixpanelLib.prototype.track_pageview = function(page) {
    if (_.isUndefined(page)) {
        page = document$1.location.href;
    }
    this.track('mp_page_view', _.info.pageviewInfo(page));
};

/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */
MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, LinkTracker, arguments);
};

/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */
MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, FormTracker, arguments);
};

/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */
MixpanelLib.prototype.time_event = function(event_name) {
    if (_.isUndefined(event_name)) {
        console$1.error('No event name provided to mixpanel.time_event');
        return;
    }

    if (this._event_is_disabled(event_name)) {
        return;
    }

    this['persistence'].set_event_timer(event_name,  new Date().getTime());
};

/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number} [days] How many days since the user's last visit to store the super properties
 */
MixpanelLib.prototype.register = function(props, days) {
    this['persistence'].register(props, days);
};

/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number} [days] How many days since the users last visit to store the super properties
 */
MixpanelLib.prototype.register_once = function(props, default_value, days) {
    this['persistence'].register_once(props, default_value, days);
};

/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 */
MixpanelLib.prototype.unregister = function(property) {
    this['persistence'].unregister(property);
};

MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};

/**
 * Identify a user with a unique ID instead of a Mixpanel
 * randomly generated distinct_id. If the method is never called,
 * then unique visitors will be identified by a UUID generated
 * the first time they visit the site.
 *
 * ### Notes:
 *
 * You can call this function to overwrite a previously set
 * unique ID for the current user. Mixpanel cannot translate
 * between IDs at this time, so when you change a user's ID
 * they will appear to be a new user.
 *
 * When used alone, mixpanel.identify will change the user's
 * distinct_id to the unique ID provided. When used in tandem
 * with mixpanel.alias, it will allow you to identify based on
 * unique ID and map that back to the original, anonymous
 * distinct_id given to the user upon her first arrival to your
 * site (thus connecting anonymous pre-signup activity to
 * post-signup activity). Though the two work together, do not
 * call identify() at the same time as alias(). Calling the two
 * at the same time can cause a race condition, so it is best
 * practice to call identify on the original, anonymous ID
 * right after you've aliased it.
 * <a href="https://mixpanel.com/help/questions/articles/how-should-i-handle-my-user-identity-with-the-mixpanel-javascript-library">Learn more about how mixpanel.identify and mixpanel.alias can be used</a>.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */
MixpanelLib.prototype.identify = function(
    unique_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback
) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed

    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (unique_id !== this.get_distinct_id() && unique_id !== this.get_property(ALIAS_ID_KEY)) {
        this.unregister(ALIAS_ID_KEY);
        this._register_single('distinct_id', unique_id);
    }
    this._check_and_handle_notifications(this.get_distinct_id());
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback);
};

/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */
MixpanelLib.prototype.reset = function() {
    this['persistence'].clear();
    this._flags.identify_called = false;
    this.register_once({'distinct_id': _.UUID()}, '');
};

/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */
MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};

/**
 * Create an alias, which Mixpanel will use to link two distinct_ids going forward (not retroactively).
 * Multiple aliases can map to the same original ID, but not vice-versa. Aliases can also be chained - the
 * following is a valid scenario:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     ...
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * If the original ID is not passed in, we will use the current distinct_id - probably the auto-generated GUID.
 *
 * ### Notes:
 *
 * The best practice is to call alias() when a unique ID is first created for a user
 * (e.g., when a user first registers for an account and provides an email address).
 * alias() should never be called more than once for a given user, except to
 * chain a newer ID to a previously new ID, as described above.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */
MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property(PEOPLE_DISTINCT_ID_KEY)) {
        console$1.critical('Attempting to create alias for existing People user - aborting.');
        return -2;
    }

    var _this = this;
    if (_.isUndefined(original)) {
        original = this.get_distinct_id();
    }
    if (alias !== original) {
        this._register_single(ALIAS_ID_KEY, alias);
        return this.track('$create_alias', { 'alias': alias, 'distinct_id': original }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        console$1.error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};

/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @api private
 */
MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};

/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // super properties cookie expiration (in days)
 *       cookie_expiration:          365
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie:     true
 *
 *       // debug mode
 *       debug:                      false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence:        false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip:                         true
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence:                'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name:           ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist:         []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie:              false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout:        300
 *
 *       // should we track a page view on page load
 *       track_pageview:             true
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade:                    false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */
MixpanelLib.prototype.set_config = function(config) {
    if (_.isObject(config)) {
        _.extend(this['config'], config);

        if (!this.get_config('persistence_name')) {
            this['config']['persistence_name'] = this['config']['cookie_name'];
        }
        if (!this.get_config('disable_persistence')) {
            this['config']['disable_persistence'] = this['config']['disable_cookie'];
        }

        if (this['persistence']) {
            this['persistence'].update_config(this['config']);
        }
        Config.DEBUG = Config.DEBUG || this.get_config('debug');
    }
};

/**
 * returns the current config object for the library.
 */
MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};

/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */
MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence']['props'][property_name];
};

MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== PRIMARY_INSTANCE_NAME) {
        name = PRIMARY_INSTANCE_NAME + '.' + name;
    }
    return name;
};

MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return _.isBlockedUA(userAgent) ||
        this._flags.disable_all_events ||
        _.include(this.__disabled_events, event_name);
};

MixpanelLib.prototype._check_and_handle_notifications = function(distinct_id) {
    if (!distinct_id || this._flags.identify_called || this.get_config('disable_notifications')) {
        return;
    }

    console$1.log('MIXPANEL NOTIFICATION CHECK');

    var data = {
        'verbose':     true,
        'version':     '2',
        'lib':         'web',
        'token':       this.get_config('token'),
        'distinct_id': distinct_id
    };
    var self = this;
    this._send_request(
        this.get_config('api_host') + '/decide/',
        data,
        this._prepare_callback(function(r) {
            if (r['notifications'] && r['notifications'].length > 0) {
                self._show_notification.call(self, r['notifications'][0]);
            }
        })
    );
};

MixpanelLib.prototype._show_notification = function(notification_data) {
    var notification = new MPNotif(notification_data, this);
    notification.show();
};

MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};

/*
 * Set properties on a user record.
 *
 * ### Usage:
 *
 *     mixpanel.people.set('gender', 'm');
 *
 *     // or set multiple properties at once
 *     mixpanel.people.set({
 *         'Company': 'Acme',
 *         'Plan': 'Premium',
 *         'Upgrade date': new Date()
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.set = function(prop, to, callback) {
    var data = {};
    var $set = {};
    if (_.isObject(prop)) {
        _.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                $set[k] = v;
            }
        }, this);
        callback = to;
    } else {
        $set[prop] = to;
    }

    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) {
        this._mixpanel['persistence'].update_referrer_info(document$1.referrer);
    }

    // update $set object with default people properties
    $set = _.extend(
        {},
        _.info.people_properties(),
        this._mixpanel['persistence'].get_referrer_info(),
        $set
    );

    data[SET_ACTION] = $set;

    return this._send_request(data, callback);
};

/*
 * Set properties on a user record, only if they do not yet exist.
 * This will not overwrite previous people property values, unlike
 * people.set().
 *
 * ### Usage:
 *
 *     mixpanel.people.set_once('First Login Date', new Date());
 *
 *     // or set multiple properties at once
 *     mixpanel.people.set_once({
 *         'First Login Date': new Date(),
 *         'Starting Plan': 'Premium'
 *     });
 *
 *     // properties can be strings, integers or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.set_once = function(prop, to, callback) {
    var data = {};
    var $set_once = {};
    if (_.isObject(prop)) {
        _.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                $set_once[k] = v;
            }
        }, this);
        callback = to;
    } else {
        $set_once[prop] = to;
    }
    data[SET_ONCE_ACTION] = $set_once;
    return this._send_request(data, callback);
};

/*
 * Unset properties on a user record (permanently removes the properties and their values from a profile).
 *
 * ### Usage:
 *
 *     mixpanel.people.unset('gender');
 *
 *     // or unset multiple properties at once
 *     mixpanel.people.unset(['gender', 'Company']);
 *
 * @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.unset = function(prop, callback) {
    var data = {};
    var $unset = [];
    if (!_.isArray(prop)) {
        prop = [prop];
    }

    _.each(prop, function(k) {
        if (!this._is_reserved_property(k)) {
            $unset.push(k);
        }
    }, this);

    data[UNSET_ACTION] = $unset;

    return this._send_request(data, callback);
};

/*
 * Increment/decrement numeric people analytics properties.
 *
 * ### Usage:
 *
 *     mixpanel.people.increment('page_views', 1);
 *
 *     // or, for convenience, if you're just incrementing a counter by
 *     // 1, you can simply do
 *     mixpanel.people.increment('page_views');
 *
 *     // to decrement a counter, pass a negative number
 *     mixpanel.people.increment('credits_left', -1);
 *
 *     // like mixpanel.people.set(), you can increment multiple
 *     // properties at once:
 *     mixpanel.people.increment({
 *         counter1: 1,
 *         counter2: 6
 *     });
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
 * @param {Number} [by] An amount to increment the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.increment = function(prop, by, callback) {
    var data = {};
    var $add = {};
    if (_.isObject(prop)) {
        _.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else {
                    $add[k] = v;
                }
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if (_.isUndefined(by)) {
            by = 1;
        }
        $add[prop] = by;
    }
    data[ADD_ACTION] = $add;

    return this._send_request(data, callback);
};

/*
 * Append a value to a list-valued people analytics property.
 *
 * ### Usage:
 *
 *     // append a value to a list, creating it if needed
 *     mixpanel.people.append('pages_visited', 'homepage');
 *
 *     // like mixpanel.people.set(), you can append multiple
 *     // properties at once:
 *     mixpanel.people.append({
 *         list1: 'bob',
 *         list2: 123
 *     });
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [value] An item to append to the list
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.append = function(list_name, value, callback) {
    var data = {};
    var $append = {};
    if (_.isObject(list_name)) {
        _.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) {
                $append[k] = v;
            }
        }, this);
        callback = value;
    } else {
        $append[list_name] = value;
    }
    data[APPEND_ACTION] = $append;

    return this._send_request(data, callback);
};

/*
 * Merge a given list with a list-valued people analytics property,
 * excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.people.union('pages_visited', 'homepage');
 *
 *     // like mixpanel.people.set(), you can append multiple
 *     // properties at once:
 *     mixpanel.people.union({
 *         list1: 'bob',
 *         list2: 123
 *     });
 *
 *     // like mixpanel.people.append(), you can append multiple
 *     // values to the same list:
 *     mixpanel.people.union({
 *         list1: ['bob', 'billy']
 *     });
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [value] Value / values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.union = function(list_name, values, callback) {
    var data = {};
    var $union = {};
    if (_.isObject(list_name)) {
        _.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) {
                $union[k] = _.isArray(v) ? v : [v];
            }
        }, this);
        callback = values;
    } else {
        $union[list_name] = _.isArray(values) ? values : [values];
    }
    data[UNION_ACTION] = $union;

    return this._send_request(data, callback);
};

/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 */
MixpanelPeople.prototype.track_charge = function(amount, properties, callback) {
    if (!_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            console$1.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
            return;
        }
    }

    return this.append('$transactions', _.extend({
        '$amount': amount
    }, properties), callback);
};

/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};

/*
 * Permanently deletes the current people analytics profile from
 * Mixpanel (using the current distinct_id).
 *
 * ### Usage:
 *
 *     // remove the all data you have stored about the current user
 *     mixpanel.people.delete_user();
 *
 */
MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {'$delete': this._mixpanel.get_distinct_id()};
    return this._send_request(data);
};

MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};

MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();

    var date_encoded_data = _.encodeDates(data);
    var truncated_data    = _.truncate(date_encoded_data, 255);
    var json_data         = _.JSONEncode(date_encoded_data);
    var encoded_data      = _.base64Encode(json_data);

    if (!this._identify_called()) {
        this._enqueue(data);
        if (!_.isUndefined(callback)) {
            if (this._get_config('verbose')) {
                callback({status: -1, error: null});
            } else {
                callback(-1);
            }
        }
        return truncated_data;
    }

    console$1.log('MIXPANEL PEOPLE REQUEST:');
    console$1.log(truncated_data);

    this._mixpanel._send_request(
        this._get_config('api_host') + '/engage/',
        {'data': encoded_data},
        this._mixpanel._prepare_callback(callback, truncated_data)
    );

    return truncated_data;
};

MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};

MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};

// Queue up engage operations if identify hasn't been called yet.
MixpanelPeople.prototype._enqueue = function(data) {
    if (SET_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(SET_ACTION, data);
    } else if (SET_ONCE_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(SET_ONCE_ACTION, data);
    } else if (UNSET_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(UNSET_ACTION, data);
    } else if (ADD_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(ADD_ACTION, data);
    } else if (APPEND_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, data);
    } else if (UNION_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(UNION_ACTION, data);
    } else {
        console$1.error('Invalid call to _enqueue():', data);
    }
};

MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = _.extend({}, this._mixpanel['persistence']._get_queue(action));
    var action_params = queued_data;

    if (!_.isUndefined(queued_data) && _.isObject(queued_data) && !_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        if (queue_to_params_fn) {
            action_params = queue_to_params_fn(queued_data);
        }
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            }
            if (!_.isUndefined(callback)) {
                callback(response, data);
            }
        });
    }
};

// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
MixpanelPeople.prototype._flush = function(
    _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback
) {
    var _this = this;
    var $append_queue = this._mixpanel['persistence']._get_queue(APPEND_ACTION);

    this._flush_one_queue(SET_ACTION, this.set, _set_callback);
    this._flush_one_queue(SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue(UNSET_ACTION, this.unset, _unset_callback, function(queue) { return _.keys(queue); });
    this._flush_one_queue(ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue(UNION_ACTION, this.union, _union_callback);

    // we have to fire off each $append individually since there is
    // no concat method server side
    if (!_.isUndefined($append_queue) && _.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var callback = function(response, data) {
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, $append_item);
            }
            if (!_.isUndefined(_append_callback)) {
                _append_callback(response, data);
            }
        };
        for (var i = $append_queue.length - 1; i >= 0; i--) {
            $append_item = $append_queue.pop();
            _this.append($append_item, callback);
        }
        // Save the shortened append queue
        _this._mixpanel['persistence'].save();
    }
};

MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token';
};


// Internal class for notification display
MixpanelLib._Notification = function(notif_data, mixpanel_instance) {
    _.bind_instance_methods(this);

    this.mixpanel    = mixpanel_instance;
    this.persistence = this.mixpanel['persistence'];

    this.campaign_id = _.escapeHTML(notif_data['id']);
    this.message_id  = _.escapeHTML(notif_data['message_id']);

    this.body            = (_.escapeHTML(notif_data['body']) || '').replace(/\n/g, '<br/>');
    this.cta             = _.escapeHTML(notif_data['cta']) || 'Close';
    this.notif_type      = _.escapeHTML(notif_data['type']) || 'takeover';
    this.style           = _.escapeHTML(notif_data['style']) || 'light';
    this.title           = _.escapeHTML(notif_data['title']) || '';
    this.video_width     = MPNotif.VIDEO_WIDTH;
    this.video_height    = MPNotif.VIDEO_HEIGHT;

    // These fields are url-sanitized in the backend already.
    this.dest_url        = notif_data['cta_url'] || null;
    this.image_url       = notif_data['image_url'] || null;
    this.thumb_image_url = notif_data['thumb_image_url'] || null;
    this.video_url       = notif_data['video_url'] || null;

    this.clickthrough = true;
    if (!this.dest_url) {
        this.dest_url = '#dismiss';
        this.clickthrough = false;
    }

    this.mini = this.notif_type === 'mini';
    if (!this.mini) {
        this.notif_type = 'takeover';
    }
    this.notif_width = !this.mini ? MPNotif.NOTIF_WIDTH : MPNotif.NOTIF_WIDTH_MINI;

    this._set_client_config();
    this.imgs_to_preload = this._init_image_html();
    this._init_video();
};

MPNotif = MixpanelLib._Notification;

MPNotif.ANIM_TIME         = 200;
MPNotif.MARKUP_PREFIX     = 'mixpanel-notification';
MPNotif.BG_OPACITY        = 0.6;
MPNotif.NOTIF_TOP         = 25;
MPNotif.NOTIF_START_TOP   = 200;
MPNotif.NOTIF_WIDTH       = 388;
MPNotif.NOTIF_WIDTH_MINI  = 420;
MPNotif.NOTIF_HEIGHT_MINI = 85;
MPNotif.THUMB_BORDER_SIZE = 5;
MPNotif.THUMB_IMG_SIZE    = 60;
MPNotif.THUMB_OFFSET      = Math.round(MPNotif.THUMB_IMG_SIZE / 2);
MPNotif.VIDEO_WIDTH       = 595;
MPNotif.VIDEO_HEIGHT      = 334;

MPNotif.prototype.show = function() {
    var self = this;
    this._set_client_config();

    // don't display until HTML body exists
    if (!this.body_el) {
        setTimeout(function() { self.show(); }, 300);
        return;
    }

    this._init_styles();
    this._init_notification_el();

    // wait for any images to load before showing notification
    this._preload_images(this._attach_and_animate);
};

MPNotif.prototype.dismiss = _.safewrap(function() {
    if (!this.marked_as_shown) {
        // unexpected condition: user interacted with notif even though we didn't consider it
        // visible (see _mark_as_shown()); send tracking signals to mark delivery
        this._mark_delivery({'invisible': true});
    }

    var exiting_el = this.showing_video ? this._get_el('video') : this._get_notification_display_el();
    if (this.use_transitions) {
        this._remove_class('bg', 'visible');
        this._add_class(exiting_el, 'exiting');
        setTimeout(this._remove_notification_el, MPNotif.ANIM_TIME);
    } else {
        var notif_attr, notif_start, notif_goal;
        if (this.mini) {
            notif_attr  = 'right';
            notif_start = 20;
            notif_goal  = -100;
        } else {
            notif_attr  = 'top';
            notif_start = MPNotif.NOTIF_TOP;
            notif_goal  = MPNotif.NOTIF_START_TOP + MPNotif.NOTIF_TOP;
        }
        this._animate_els([
            {
                el:    this._get_el('bg'),
                attr:  'opacity',
                start: MPNotif.BG_OPACITY,
                goal:  0.0
            },
            {
                el:    exiting_el,
                attr:  'opacity',
                start: 1.0,
                goal:  0.0
            },
            {
                el:    exiting_el,
                attr:  notif_attr,
                start: notif_start,
                goal:  notif_goal
            }
        ], MPNotif.ANIM_TIME, this._remove_notification_el);
    }
});

MPNotif.prototype._add_class = _.safewrap(function(el, class_name) {
    class_name = MPNotif.MARKUP_PREFIX + '-' + class_name;
    if (typeof el === 'string') {
        el = this._get_el(el);
    }
    if (!el.className) {
        el.className = class_name;
    } else if (!~(' ' + el.className + ' ').indexOf(' ' + class_name + ' ')) {
        el.className += ' ' + class_name;
    }
});
MPNotif.prototype._remove_class = _.safewrap(function(el, class_name) {
    class_name = MPNotif.MARKUP_PREFIX + '-' + class_name;
    if (typeof el === 'string') {
        el = this._get_el(el);
    }
    if (el.className) {
        el.className = (' ' + el.className + ' ')
                .replace(' ' + class_name + ' ', '')
                .replace(/^[\s\xA0]+/, '')
                .replace(/[\s\xA0]+$/, '');
    }
});

MPNotif.prototype._animate_els = _.safewrap(function(anims, mss, done_cb, start_time) {
    var self = this,
        in_progress = false,
        ai, anim,
        cur_time = 1 * new Date(), time_diff;

    start_time = start_time || cur_time;
    time_diff = cur_time - start_time;

    for (ai = 0; ai < anims.length; ai++) {
        anim = anims[ai];
        if (typeof anim.val === 'undefined') {
            anim.val = anim.start;
        }
        if (anim.val !== anim.goal) {
            in_progress = true;
            var anim_diff = anim.goal - anim.start,
                anim_dir = anim.goal >= anim.start ? 1 : -1;
            anim.val = anim.start + anim_diff * time_diff / mss;
            if (anim.attr !== 'opacity') {
                anim.val = Math.round(anim.val);
            }
            if ((anim_dir > 0 && anim.val >= anim.goal) || (anim_dir < 0 && anim.val <= anim.goal)) {
                anim.val = anim.goal;
            }
        }
    }
    if (!in_progress) {
        if (done_cb) {
            done_cb();
        }
        return;
    }

    for (ai = 0; ai < anims.length; ai++) {
        anim = anims[ai];
        if (anim.el) {
            var suffix = anim.attr === 'opacity' ? '' : 'px';
            anim.el.style[anim.attr] = String(anim.val) + suffix;
        }
    }
    setTimeout(function() { self._animate_els(anims, mss, done_cb, start_time); }, 10);
});

MPNotif.prototype._attach_and_animate = _.safewrap(function() {
    var self = this;

    // no possibility to double-display
    if (this.shown || this._get_shown_campaigns()[this.campaign_id]) {
        return;
    }
    this.shown = true;

    this.body_el.appendChild(this.notification_el);
    setTimeout(function() {
        var notif_el = self._get_notification_display_el();
        if (self.use_transitions) {
            if (!self.mini) {
                self._add_class('bg', 'visible');
            }
            self._add_class(notif_el, 'visible');
            self._mark_as_shown();
        } else {
            var notif_attr, notif_start, notif_goal;
            if (self.mini) {
                notif_attr  = 'right';
                notif_start = -100;
                notif_goal  = 20;
            } else {
                notif_attr  = 'top';
                notif_start = MPNotif.NOTIF_START_TOP + MPNotif.NOTIF_TOP;
                notif_goal  = MPNotif.NOTIF_TOP;
            }
            self._animate_els([
                {
                    el:    self._get_el('bg'),
                    attr:  'opacity',
                    start: 0.0,
                    goal:  MPNotif.BG_OPACITY
                },
                {
                    el:    notif_el,
                    attr:  'opacity',
                    start: 0.0,
                    goal:  1.0
                },
                {
                    el:    notif_el,
                    attr:  notif_attr,
                    start: notif_start,
                    goal:  notif_goal
                }
            ], MPNotif.ANIM_TIME, self._mark_as_shown);
        }
    }, 100);
    _.register_event(self._get_el('cancel'), 'click', function(e) {
        e.preventDefault();
        self.dismiss();
    });
    var click_el = self._get_el('button') ||
                       self._get_el('mini-content');
    _.register_event(click_el, 'click', function(e) {
        e.preventDefault();
        if (self.show_video) {
            self._track_event('$campaign_open', {'$resource_type': 'video'});
            self._switch_to_video();
        } else {
            self.dismiss();
            if (self.clickthrough) {
                self._track_event('$campaign_open', {'$resource_type': 'link'}, function() {
                    win.location.href = self.dest_url;
                });
            }
        }
    });
});

MPNotif.prototype._get_el = function(id) {
    return document$1.getElementById(MPNotif.MARKUP_PREFIX + '-' + id);
};

MPNotif.prototype._get_notification_display_el = function() {
    return this._get_el(this.notif_type);
};

MPNotif.prototype._get_shown_campaigns = function() {
    return this.persistence['props'][CAMPAIGN_IDS_KEY] || (this.persistence['props'][CAMPAIGN_IDS_KEY] = {});
};

MPNotif.prototype._browser_lte = function(browser, version) {
    return this.browser_versions[browser] && this.browser_versions[browser] <= version;
};

MPNotif.prototype._init_image_html = function() {
    var imgs_to_preload = [];

    if (!this.mini) {
        if (this.image_url) {
            imgs_to_preload.push(this.image_url);
            this.img_html = '<img id="img" src="' + this.image_url + '"/>';
        } else {
            this.img_html = '';
        }
        if (this.thumb_image_url) {
            imgs_to_preload.push(this.thumb_image_url);
            this.thumb_img_html =
                    '<div id="thumbborder-wrapper"><div id="thumbborder"></div></div>' +
                    '<img id="thumbnail"' +
                        ' src="' + this.thumb_image_url + '"' +
                        ' width="' + MPNotif.THUMB_IMG_SIZE + '"' +
                        ' height="' + MPNotif.THUMB_IMG_SIZE + '"' +
                    '/>' +
                    '<div id="thumbspacer"></div>';
        } else {
            this.thumb_img_html = '';
        }
    } else {
        this.thumb_image_url = this.thumb_image_url || '//cdn.mxpnl.com/site_media/images/icons/notifications/mini-news-dark.png';
        imgs_to_preload.push(this.thumb_image_url);
    }

    return imgs_to_preload;
};

MPNotif.prototype._init_notification_el = function() {
    var notification_html = '';
    var video_src         = '';
    var video_html        = '';
    var cancel_html       = '<div id="cancel">' +
                                    '<div id="cancel-icon"></div>' +
                                '</div>';

    this.notification_el = document$1.createElement('div');
    this.notification_el.id = MPNotif.MARKUP_PREFIX + '-wrapper';
    if (!this.mini) {
        // TAKEOVER notification
        var close_html  = (this.clickthrough || this.show_video) ? '' : '<div id="button-close"></div>',
            play_html   = this.show_video ? '<div id="button-play"></div>' : '';
        if (this._browser_lte('ie', 7)) {
            close_html = '';
            play_html = '';
        }
        notification_html =
                '<div id="takeover">' +
                    this.thumb_img_html +
                    '<div id="mainbox">' +
                        cancel_html +
                        '<div id="content">' +
                            this.img_html +
                            '<div id="title">' + this.title + '</div>' +
                            '<div id="body">' + this.body + '</div>' +
                            '<div id="tagline">' +
                                '<a href="http://mixpanel.com?from=inapp" target="_blank">POWERED BY MIXPANEL</a>' +
                            '</div>' +
                        '</div>' +
                        '<div id="button">' +
                            close_html +
                            '<a id="button-link" href="' + this.dest_url + '">' + this.cta + '</a>' +
                            play_html +
                        '</div>' +
                    '</div>' +
                '</div>';
    } else {
        // MINI notification
        notification_html =
                '<div id="mini">' +
                    '<div id="mainbox">' +
                        cancel_html +
                        '<div id="mini-content">' +
                            '<div id="mini-icon">' +
                                '<div id="mini-icon-img"></div>' +
                            '</div>' +
                            '<div id="body">' +
                                '<div id="body-text"><div>' + this.body + '</div></div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div id="mini-border"></div>' +
                '</div>';
    }
    if (this.youtube_video) {
        video_src = '//www.youtube.com/embed/' + this.youtube_video +
                '?wmode=transparent&showinfo=0&modestbranding=0&rel=0&autoplay=1&loop=0&vq=hd1080';
        if (this.yt_custom) {
            video_src += '&enablejsapi=1&html5=1&controls=0';
            video_html =
                    '<div id="video-controls">' +
                        '<div id="video-progress" class="video-progress-el">' +
                            '<div id="video-progress-total" class="video-progress-el"></div>' +
                            '<div id="video-elapsed" class="video-progress-el"></div>' +
                        '</div>' +
                        '<div id="video-time" class="video-progress-el"></div>' +
                    '</div>';
        }
    } else if (this.vimeo_video) {
        video_src = '//player.vimeo.com/video/' + this.vimeo_video + '?autoplay=1&title=0&byline=0&portrait=0';
    }
    if (this.show_video) {
        this.video_iframe =
                '<iframe id="' + MPNotif.MARKUP_PREFIX + '-video-frame" ' +
                    'width="' + this.video_width + '" height="' + this.video_height + '" ' +
                    ' src="' + video_src + '"' +
                    ' frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen="1" scrolling="no"' +
                '></iframe>';
        video_html =
                '<div id="video-' + (this.flip_animate ? '' : 'no') + 'flip">' +
                    '<div id="video">' +
                        '<div id="video-holder"></div>' +
                        video_html +
                    '</div>' +
                '</div>';
    }
    var main_html = video_html + notification_html;
    if (this.flip_animate) {
        main_html =
                (this.mini ? notification_html : '') +
                '<div id="flipcontainer"><div id="flipper">' +
                    (this.mini ? video_html : main_html) +
                '</div></div>';
    }

    this.notification_el.innerHTML =
            ('<div id="overlay" class="' + this.notif_type + '">' +
                '<div id="campaignid-' + this.campaign_id + '">' +
                    '<div id="bgwrapper">' +
                        '<div id="bg"></div>' +
                        main_html +
                    '</div>' +
                '</div>' +
            '</div>')
            .replace(/class=\"/g, 'class="' + MPNotif.MARKUP_PREFIX + '-')
            .replace(/id=\"/g, 'id="' + MPNotif.MARKUP_PREFIX + '-');
};

MPNotif.prototype._init_styles = function() {
    if (this.style === 'dark') {
        this.style_vals = {
            bg:             '#1d1f25',
            bg_actions:     '#282b32',
            bg_hover:       '#3a4147',
            bg_light:       '#4a5157',
            border_gray:    '#32353c',
            cancel_opacity: '0.4',
            mini_hover:     '#2a3137',
            text_title:     '#fff',
            text_main:      '#9498a3',
            text_tagline:   '#464851',
            text_hover:     '#ddd'
        };
    } else {
        this.style_vals = {
            bg:             '#fff',
            bg_actions:     '#e7eaee',
            bg_hover:       '#eceff3',
            bg_light:       '#f5f5f5',
            border_gray:    '#e4ecf2',
            cancel_opacity: '1.0',
            mini_hover:     '#fafafa',
            text_title:     '#5c6578',
            text_main:      '#8b949b',
            text_tagline:   '#ced9e6',
            text_hover:     '#7c8598'
        };
    }
    var shadow = '0px 0px 35px 0px rgba(45, 49, 56, 0.7)',
        video_shadow = shadow,
        mini_shadow = shadow,
        thumb_total_size = MPNotif.THUMB_IMG_SIZE + MPNotif.THUMB_BORDER_SIZE * 2,
        anim_seconds = (MPNotif.ANIM_TIME / 1000) + 's';
    if (this.mini) {
        shadow = 'none';
    }

    // don't display on small viewports
    var notif_media_queries = {},
        min_width = MPNotif.NOTIF_WIDTH_MINI + 20;
    notif_media_queries['@media only screen and (max-width: ' + (min_width - 1) + 'px)'] = {
        '#overlay': {
            'display': 'none'
        }
    };
    var notif_styles = {
        '.flipped': {
            'transform': 'rotateY(180deg)'
        },
        '#overlay': {
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'width': '100%',
            'height': '100%',
            'overflow': 'auto',
            'text-align': 'center',
            'z-index': '10000',
            'font-family': '"Helvetica", "Arial", sans-serif',
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale'
        },
        '#overlay.mini': {
            'height': '0',
            'overflow': 'visible'
        },
        '#overlay a': {
            'width': 'initial',
            'padding': '0',
            'text-decoration': 'none',
            'text-transform': 'none',
            'color': 'inherit'
        },
        '#bgwrapper': {
            'position': 'relative',
            'width': '100%',
            'height': '100%'
        },
        '#bg': {
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'width': '100%',
            'height': '100%',
            'min-width': this.doc_width * 4 + 'px',
            'min-height': this.doc_height * 4 + 'px',
            'background-color': 'black',
            'opacity': '0.0',
            '-ms-filter': 'progid:DXImageTransform.Microsoft.Alpha(Opacity=60)', // IE8
            'filter': 'alpha(opacity=60)', // IE5-7
            'transition': 'opacity ' + anim_seconds
        },
        '#bg.visible': {
            'opacity': MPNotif.BG_OPACITY
        },
        '.mini #bg': {
            'width': '0',
            'height': '0',
            'min-width': '0'
        },
        '#flipcontainer': {
            'perspective': '1000px',
            'position': 'absolute',
            'width': '100%'
        },
        '#flipper': {
            'position': 'relative',
            'transform-style': 'preserve-3d',
            'transition': '0.3s'
        },
        '#takeover': {
            'position': 'absolute',
            'left': '50%',
            'width': MPNotif.NOTIF_WIDTH + 'px',
            'margin-left': Math.round(-MPNotif.NOTIF_WIDTH / 2) + 'px',
            'backface-visibility': 'hidden',
            'transform': 'rotateY(0deg)',
            'opacity': '0.0',
            'top': MPNotif.NOTIF_START_TOP + 'px',
            'transition': 'opacity ' + anim_seconds + ', top ' + anim_seconds
        },
        '#takeover.visible': {
            'opacity': '1.0',
            'top': MPNotif.NOTIF_TOP + 'px'
        },
        '#takeover.exiting': {
            'opacity': '0.0',
            'top': MPNotif.NOTIF_START_TOP + 'px'
        },
        '#thumbspacer': {
            'height': MPNotif.THUMB_OFFSET + 'px'
        },
        '#thumbborder-wrapper': {
            'position': 'absolute',
            'top': (-MPNotif.THUMB_BORDER_SIZE) + 'px',
            'left': (MPNotif.NOTIF_WIDTH / 2 - MPNotif.THUMB_OFFSET - MPNotif.THUMB_BORDER_SIZE) + 'px',
            'width': thumb_total_size + 'px',
            'height': (thumb_total_size / 2) + 'px',
            'overflow': 'hidden'
        },
        '#thumbborder': {
            'position': 'absolute',
            'width': thumb_total_size + 'px',
            'height': thumb_total_size + 'px',
            'border-radius': thumb_total_size + 'px',
            'background-color': this.style_vals.bg_actions,
            'opacity': '0.5'
        },
        '#thumbnail': {
            'position': 'absolute',
            'top': '0px',
            'left': (MPNotif.NOTIF_WIDTH / 2 - MPNotif.THUMB_OFFSET) + 'px',
            'width': MPNotif.THUMB_IMG_SIZE + 'px',
            'height': MPNotif.THUMB_IMG_SIZE + 'px',
            'overflow': 'hidden',
            'z-index': '100',
            'border-radius': MPNotif.THUMB_IMG_SIZE + 'px'
        },
        '#mini': {
            'position': 'absolute',
            'right': '20px',
            'top': MPNotif.NOTIF_TOP + 'px',
            'width': this.notif_width + 'px',
            'height': MPNotif.NOTIF_HEIGHT_MINI * 2 + 'px',
            'margin-top': 20 - MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'backface-visibility': 'hidden',
            'opacity': '0.0',
            'transform': 'rotateX(90deg)',
            'transition': 'opacity 0.3s, transform 0.3s, right 0.3s'
        },
        '#mini.visible': {
            'opacity': '1.0',
            'transform': 'rotateX(0deg)'
        },
        '#mini.exiting': {
            'opacity': '0.0',
            'right': '-150px'
        },
        '#mainbox': {
            'border-radius': '4px',
            'box-shadow': shadow,
            'text-align': 'center',
            'background-color': this.style_vals.bg,
            'font-size': '14px',
            'color': this.style_vals.text_main
        },
        '#mini #mainbox': {
            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'margin-top': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'border-radius': '3px',
            'transition': 'background-color ' + anim_seconds
        },
        '#mini-border': {
            'height': (MPNotif.NOTIF_HEIGHT_MINI + 6) + 'px',
            'width': (MPNotif.NOTIF_WIDTH_MINI + 6) + 'px',
            'position': 'absolute',
            'top': '-3px',
            'left': '-3px',
            'margin-top': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'border-radius': '6px',
            'opacity': '0.25',
            'background-color': '#fff',
            'z-index': '-1',
            'box-shadow': mini_shadow
        },
        '#mini-icon': {
            'position': 'relative',
            'display': 'inline-block',
            'width': '75px',
            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'border-radius': '3px 0 0 3px',
            'background-color': this.style_vals.bg_actions,
            'background': 'linear-gradient(135deg, ' + this.style_vals.bg_light + ' 0%, ' + this.style_vals.bg_actions + ' 100%)',
            'transition': 'background-color ' + anim_seconds
        },
        '#mini:hover #mini-icon': {
            'background-color': this.style_vals.mini_hover
        },
        '#mini:hover #mainbox': {
            'background-color': this.style_vals.mini_hover
        },
        '#mini-icon-img': {
            'position': 'absolute',
            'background-image': 'url(' + this.thumb_image_url + ')',
            'width': '48px',
            'height': '48px',
            'top': '20px',
            'left': '12px'
        },
        '#content': {
            'padding': '30px 20px 0px 20px'
        },
        '#mini-content': {
            'text-align': 'left',
            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'cursor': 'pointer'
        },
        '#img': {
            'width': '328px',
            'margin-top': '30px',
            'border-radius': '5px'
        },
        '#title': {
            'max-height': '600px',
            'overflow': 'hidden',
            'word-wrap': 'break-word',
            'padding': '25px 0px 20px 0px',
            'font-size': '19px',
            'font-weight': 'bold',
            'color': this.style_vals.text_title
        },
        '#body': {
            'max-height': '600px',
            'margin-bottom': '25px',
            'overflow': 'hidden',
            'word-wrap': 'break-word',
            'line-height': '21px',
            'font-size': '15px',
            'font-weight': 'normal',
            'text-align': 'left'
        },
        '#mini #body': {
            'display': 'inline-block',
            'max-width': '250px',
            'margin': '0 0 0 30px',
            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px',
            'font-size': '16px',
            'letter-spacing': '0.8px',
            'color': this.style_vals.text_title
        },
        '#mini #body-text': {
            'display': 'table',
            'height': MPNotif.NOTIF_HEIGHT_MINI + 'px'
        },
        '#mini #body-text div': {
            'display': 'table-cell',
            'vertical-align': 'middle'
        },
        '#tagline': {
            'margin-bottom': '15px',
            'font-size': '10px',
            'font-weight': '600',
            'letter-spacing': '0.8px',
            'color': '#ccd7e0',
            'text-align': 'left'
        },
        '#tagline a': {
            'color': this.style_vals.text_tagline,
            'transition': 'color ' + anim_seconds
        },
        '#tagline a:hover': {
            'color': this.style_vals.text_hover
        },
        '#cancel': {
            'position': 'absolute',
            'right': '0',
            'width': '8px',
            'height': '8px',
            'padding': '10px',
            'border-radius': '20px',
            'margin': '12px 12px 0 0',
            'box-sizing': 'content-box',
            'cursor': 'pointer',
            'transition': 'background-color ' + anim_seconds
        },
        '#mini #cancel': {
            'margin': '7px 7px 0 0'
        },
        '#cancel-icon': {
            'width': '8px',
            'height': '8px',
            'overflow': 'hidden',
            'background-image': 'url(//cdn.mxpnl.com/site_media/images/icons/notifications/cancel-x.png)',
            'opacity': this.style_vals.cancel_opacity
        },
        '#cancel:hover': {
            'background-color': this.style_vals.bg_hover
        },
        '#button': {
            'display': 'block',
            'height': '60px',
            'line-height': '60px',
            'text-align': 'center',
            'background-color': this.style_vals.bg_actions,
            'border-radius': '0 0 4px 4px',
            'overflow': 'hidden',
            'cursor': 'pointer',
            'transition': 'background-color ' + anim_seconds
        },
        '#button-close': {
            'display': 'inline-block',
            'width': '9px',
            'height': '60px',
            'margin-right': '8px',
            'vertical-align': 'top',
            'background-image': 'url(//cdn.mxpnl.com/site_media/images/icons/notifications/close-x-' + this.style + '.png)',
            'background-repeat': 'no-repeat',
            'background-position': '0px 25px'
        },
        '#button-play': {
            'display': 'inline-block',
            'width': '30px',
            'height': '60px',
            'margin-left': '15px',
            'background-image': 'url(//cdn.mxpnl.com/site_media/images/icons/notifications/play-' + this.style + '-small.png)',
            'background-repeat': 'no-repeat',
            'background-position': '0px 15px'
        },
        'a#button-link': {
            'display': 'inline-block',
            'vertical-align': 'top',
            'text-align': 'center',
            'font-size': '17px',
            'font-weight': 'bold',
            'overflow': 'hidden',
            'word-wrap': 'break-word',
            'color': this.style_vals.text_title,
            'transition': 'color ' + anim_seconds
        },
        '#button:hover': {
            'background-color': this.style_vals.bg_hover,
            'color': this.style_vals.text_hover
        },
        '#button:hover a': {
            'color': this.style_vals.text_hover
        },

        '#video-noflip': {
            'position': 'relative',
            'top': (-this.video_height * 2) + 'px'
        },
        '#video-flip': {
            'backface-visibility': 'hidden',
            'transform': 'rotateY(180deg)'
        },
        '#video': {
            'position': 'absolute',
            'width': (this.video_width - 1) + 'px',
            'height': this.video_height + 'px',
            'top': MPNotif.NOTIF_TOP + 'px',
            'margin-top': '100px',
            'left': '50%',
            'margin-left': Math.round(-this.video_width / 2) + 'px',
            'overflow': 'hidden',
            'border-radius': '5px',
            'box-shadow': video_shadow,
            'transform': 'translateZ(1px)', // webkit rendering bug http://stackoverflow.com/questions/18167981/clickable-link-area-unexpectedly-smaller-after-css-transform
            'transition': 'opacity ' + anim_seconds + ', top ' + anim_seconds
        },
        '#video.exiting': {
            'opacity': '0.0',
            'top': this.video_height + 'px'
        },
        '#video-holder': {
            'position': 'absolute',
            'width': (this.video_width - 1) + 'px',
            'height': this.video_height + 'px',
            'overflow': 'hidden',
            'border-radius': '5px'
        },
        '#video-frame': {
            'margin-left': '-1px',
            'width': this.video_width + 'px'
        },
        '#video-controls': {
            'opacity': '0',
            'transition': 'opacity 0.5s'
        },
        '#video:hover #video-controls': {
            'opacity': '1.0'
        },
        '#video .video-progress-el': {
            'position': 'absolute',
            'bottom': '0',
            'height': '25px',
            'border-radius': '0 0 0 5px'
        },
        '#video-progress': {
            'width': '90%'
        },
        '#video-progress-total': {
            'width': '100%',
            'background-color': this.style_vals.bg,
            'opacity': '0.7'
        },
        '#video-elapsed': {
            'width': '0',
            'background-color': '#6cb6f5',
            'opacity': '0.9'
        },
        '#video #video-time': {
            'width': '10%',
            'right': '0',
            'font-size': '11px',
            'line-height': '25px',
            'color': this.style_vals.text_main,
            'background-color': '#666',
            'border-radius': '0 0 5px 0'
        }
    };

    // IE hacks
    if (this._browser_lte('ie', 8)) {
        _.extend(notif_styles, {
            '* html #overlay': {
                'position': 'absolute'
            },
            '* html #bg': {
                'position': 'absolute'
            },
            'html, body': {
                'height': '100%'
            }
        });
    }
    if (this._browser_lte('ie', 7)) {
        _.extend(notif_styles, {
            '#mini #body': {
                'display': 'inline',
                'zoom': '1',
                'border': '1px solid ' + this.style_vals.bg_hover
            },
            '#mini #body-text': {
                'padding': '20px'
            },
            '#mini #mini-icon': {
                'display': 'none'
            }
        });
    }

    // add vendor-prefixed style rules
    var VENDOR_STYLES   = ['backface-visibility', 'border-radius', 'box-shadow', 'opacity',
                               'perspective', 'transform', 'transform-style', 'transition'],
        VENDOR_PREFIXES = ['khtml', 'moz', 'ms', 'o', 'webkit'];
    for (var selector in notif_styles) {
        for (var si = 0; si < VENDOR_STYLES.length; si++) {
            var prop = VENDOR_STYLES[si];
            if (prop in notif_styles[selector]) {
                var val = notif_styles[selector][prop];
                for (var pi = 0; pi < VENDOR_PREFIXES.length; pi++) {
                    notif_styles[selector]['-' + VENDOR_PREFIXES[pi] + '-' + prop] = val;
                }
            }
        }
    }

    var inject_styles = function(styles, media_queries) {
        var create_style_text = function(style_defs) {
            var st = '';
            for (var selector in style_defs) {
                var mp_selector = selector
                        .replace(/#/g, '#' + MPNotif.MARKUP_PREFIX + '-')
                        .replace(/\./g, '.' + MPNotif.MARKUP_PREFIX + '-');
                st += '\n' + mp_selector + ' {';
                var props = style_defs[selector];
                for (var k in props) {
                    st += k + ':' + props[k] + ';';
                }
                st += '}';
            }
            return st;
        };
        var create_media_query_text = function(mq_defs) {
            var mqt = '';
            for (var mq in mq_defs) {
                mqt += '\n' + mq + ' {' + create_style_text(mq_defs[mq]) + '\n}';
            }
            return mqt;
        };

        var style_text = create_style_text(styles) + create_media_query_text(media_queries),
            head_el = document$1.head || document$1.getElementsByTagName('head')[0] || document$1.documentElement,
            style_el = document$1.createElement('style');
        head_el.appendChild(style_el);
        style_el.setAttribute('type', 'text/css');
        if (style_el.styleSheet) { // IE
            style_el.styleSheet.cssText = style_text;
        } else {
            style_el.textContent = style_text;
        }
    };
    inject_styles(notif_styles, notif_media_queries);
};

MPNotif.prototype._init_video = _.safewrap(function() {
    if (!this.video_url) {
        return;
    }
    var self = this;

    // Youtube iframe API compatibility
    self.yt_custom = 'postMessage' in win;

    self.dest_url = self.video_url;
    var youtube_match = self.video_url.match(
                // http://stackoverflow.com/questions/2936467/parse-youtube-video-id-using-preg-match
                /(?:youtube(?:-nocookie)?\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i
            ),
        vimeo_match = self.video_url.match(
                /vimeo\.com\/.*?(\d+)/i
            );
    if (youtube_match) {
        self.show_video = true;
        self.youtube_video = youtube_match[1];

        if (self.yt_custom) {
            win['onYouTubeIframeAPIReady'] = function() {
                if (self._get_el('video-frame')) {
                    self._yt_video_ready();
                }
            };

            // load Youtube iframe API; see https://developers.google.com/youtube/iframe_api_reference
            var tag = document$1.createElement('script');
            tag.src = '//www.youtube.com/iframe_api';
            var firstScriptTag = document$1.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    } else if (vimeo_match) {
        self.show_video = true;
        self.vimeo_video = vimeo_match[1];
    }

    // IE <= 7, FF <= 3: fall through to video link rather than embedded player
    if (self._browser_lte('ie', 7) || self._browser_lte('firefox', 3)) {
        self.show_video = false;
        self.clickthrough = true;
    }
});

MPNotif.prototype._mark_as_shown = _.safewrap(function() {
    // click on background to dismiss
    var self = this;
    _.register_event(self._get_el('bg'), 'click', function() {
        self.dismiss();
    });

    var get_style = function(el, style_name) {
        var styles = {};
        if (document$1.defaultView && document$1.defaultView.getComputedStyle) {
            styles = document$1.defaultView.getComputedStyle(el, null); // FF3 requires both args
        } else if (el.currentStyle) { // IE
            styles = el.currentStyle;
        }
        return styles[style_name];
    };

    if (this.campaign_id) {
        var notif_el = this._get_el('overlay');
        if (notif_el && get_style(notif_el, 'visibility') !== 'hidden' && get_style(notif_el, 'display') !== 'none') {
            this._mark_delivery();
        }
    }
});

MPNotif.prototype._mark_delivery = _.safewrap(function(extra_props) {
    if (!this.marked_as_shown) {
        this.marked_as_shown = true;

        if (this.campaign_id) {
            // mark notification shown (local cache)
            this._get_shown_campaigns()[this.campaign_id] = 1 * new Date();
            this.persistence.save();
        }

        // track delivery
        this._track_event('$campaign_delivery', extra_props);

        // mark notification shown (mixpanel property)
        this.mixpanel['people']['append']({
            '$campaigns': this.campaign_id,
            '$notifications': {
                'campaign_id': this.campaign_id,
                'message_id':  this.message_id,
                'type':        'web',
                'time':        new Date()
            }
        });
    }
});

MPNotif.prototype._preload_images = function(all_loaded_cb) {
    var self = this;
    if (this.imgs_to_preload.length === 0) {
        all_loaded_cb();
        return;
    }

    var preloaded_imgs = 0;
    var img_objs = [];
    var onload = function() {
        preloaded_imgs++;
        if (preloaded_imgs === self.imgs_to_preload.length && all_loaded_cb) {
            all_loaded_cb();
            all_loaded_cb = null;
        }
    };
    for (var i = 0; i < this.imgs_to_preload.length; i++) {
        var img = new Image();
        img.onload = onload;
        img.src = this.imgs_to_preload[i];
        if (img.complete) {
            onload();
        }
        img_objs.push(img);
    }

    // IE6/7 doesn't fire onload reliably
    if (this._browser_lte('ie', 7)) {
        setTimeout(function() {
            var imgs_loaded = true;
            for (i = 0; i < img_objs.length; i++) {
                if (!img_objs[i].complete) {
                    imgs_loaded = false;
                }
            }
            if (imgs_loaded && all_loaded_cb) {
                all_loaded_cb();
                all_loaded_cb = null;
            }
        }, 500);
    }
};

MPNotif.prototype._remove_notification_el = _.safewrap(function() {
    win.clearInterval(this._video_progress_checker);
    this.notification_el.style.visibility = 'hidden';
    this.body_el.removeChild(this.notification_el);
});

MPNotif.prototype._set_client_config = function() {
    var get_browser_version = function(browser_ex) {
        var match = navigator.userAgent.match(browser_ex);
        return match && match[1];
    };
    this.browser_versions = {};
    this.browser_versions['chrome']  = get_browser_version(/Chrome\/(\d+)/);
    this.browser_versions['firefox'] = get_browser_version(/Firefox\/(\d+)/);
    this.browser_versions['ie']      = get_browser_version(/MSIE (\d+).+/);
    if (!this.browser_versions['ie'] && !(win.ActiveXObject) && 'ActiveXObject' in win) {
        this.browser_versions['ie'] = 11;
    }

    this.body_el = document$1.body || document$1.getElementsByTagName('body')[0];
    if (this.body_el) {
        this.doc_width = Math.max(
                this.body_el.scrollWidth, document$1.documentElement.scrollWidth,
                this.body_el.offsetWidth, document$1.documentElement.offsetWidth,
                this.body_el.clientWidth, document$1.documentElement.clientWidth
            );
        this.doc_height = Math.max(
                this.body_el.scrollHeight, document$1.documentElement.scrollHeight,
                this.body_el.offsetHeight, document$1.documentElement.offsetHeight,
                this.body_el.clientHeight, document$1.documentElement.clientHeight
            );
    }

    // detect CSS compatibility
    var ie_ver = this.browser_versions['ie'];
    var sample_styles = document$1.createElement('div').style,
        is_css_compatible = function(rule) {
            if (rule in sample_styles) {
                return true;
            }
            if (!ie_ver) {
                rule = rule[0].toUpperCase() + rule.slice(1);
                var props = ['O' + rule, 'Webkit' + rule, 'Moz' + rule];
                for (var i = 0; i < props.length; i++) {
                    if (props[i] in sample_styles) {
                        return true;
                    }
                }
            }
            return false;
        };
    this.use_transitions = this.body_el &&
        is_css_compatible('transition') &&
        is_css_compatible('transform');
    this.flip_animate = (this.browser_versions['chrome'] >= 33 || this.browser_versions['firefox'] >= 15) &&
        this.body_el &&
        is_css_compatible('backfaceVisibility') &&
        is_css_compatible('perspective') &&
        is_css_compatible('transform');
};

MPNotif.prototype._switch_to_video = _.safewrap(function() {
    var self = this,
        anims = [
            {
                el:    self._get_notification_display_el(),
                attr:  'opacity',
                start: 1.0,
                goal:  0.0
            },
            {
                el:    self._get_notification_display_el(),
                attr:  'top',
                start: MPNotif.NOTIF_TOP,
                goal:  -500
            },
            {
                el:    self._get_el('video-noflip'),
                attr:  'opacity',
                start: 0.0,
                goal:  1.0
            },
            {
                el:    self._get_el('video-noflip'),
                attr:  'top',
                start: -self.video_height * 2,
                goal:  0
            }
        ];

    if (self.mini) {
        var bg = self._get_el('bg'),
            overlay = self._get_el('overlay');
        bg.style.width = '100%';
        bg.style.height = '100%';
        overlay.style.width = '100%';

        self._add_class(self._get_notification_display_el(), 'exiting');
        self._add_class(bg, 'visible');

        anims.push({
            el:    self._get_el('bg'),
            attr:  'opacity',
            start: 0.0,
            goal:  MPNotif.BG_OPACITY
        });
    }

    var video_el = self._get_el('video-holder');
    video_el.innerHTML = self.video_iframe;

    var video_ready = function() {
        if (win['YT'] && win['YT']['loaded']) {
            self._yt_video_ready();
        }
        self.showing_video = true;
        self._get_notification_display_el().style.visibility = 'hidden';
    };
    if (self.flip_animate) {
        self._add_class('flipper', 'flipped');
        setTimeout(video_ready, MPNotif.ANIM_TIME);
    } else {
        self._animate_els(anims, MPNotif.ANIM_TIME, video_ready);
    }
});

MPNotif.prototype._track_event = function(event_name, properties, cb) {
    if (this.campaign_id) {
        properties = properties || {};
        properties = _.extend(properties, {
            'campaign_id':     this.campaign_id,
            'message_id':      this.message_id,
            'message_type':    'web_inapp',
            'message_subtype': this.notif_type
        });
        this.mixpanel['track'](event_name, properties, cb);
    } else if (cb) {
        cb.call();
    }
};

MPNotif.prototype._yt_video_ready = _.safewrap(function() {
    var self = this;
    if (self.video_inited) {
        return;
    }
    self.video_inited = true;

    var progress_bar  = self._get_el('video-elapsed'),
        progress_time = self._get_el('video-time'),
        progress_el   = self._get_el('video-progress');

    new win['YT']['Player'](MPNotif.MARKUP_PREFIX + '-video-frame', {
        'events': {
            'onReady': function(event) {
                var ytplayer = event['target'],
                    video_duration = ytplayer['getDuration'](),
                    pad = function(i) {
                        return ('00' + i).slice(-2);
                    },
                    update_video_time = function(current_time) {
                        var secs = Math.round(video_duration - current_time),
                            mins = Math.floor(secs / 60),
                            hours = Math.floor(mins / 60);
                        secs -= mins * 60;
                        mins -= hours * 60;
                        progress_time.innerHTML = '-' + (hours ? hours + ':' : '') + pad(mins) + ':' + pad(secs);
                    };
                update_video_time(0);
                self._video_progress_checker = win.setInterval(function() {
                    var current_time = ytplayer['getCurrentTime']();
                    progress_bar.style.width = (current_time / video_duration * 100) + '%';
                    update_video_time(current_time);
                }, 250);
                _.register_event(progress_el, 'click', function(e) {
                    var clickx = Math.max(0, e.pageX - progress_el.getBoundingClientRect().left);
                    ytplayer['seekTo'](video_duration * clickx / progress_el.clientWidth, true);
                });
            }
        }
    });
});

// EXPORTS (for closure compiler)

// MixpanelLib Exports
MixpanelLib.prototype['init']                            = MixpanelLib.prototype.init;
MixpanelLib.prototype['reset']                           = MixpanelLib.prototype.reset;
MixpanelLib.prototype['disable']                         = MixpanelLib.prototype.disable;
MixpanelLib.prototype['time_event']                      = MixpanelLib.prototype.time_event;
MixpanelLib.prototype['track']                           = MixpanelLib.prototype.track;
MixpanelLib.prototype['track_links']                     = MixpanelLib.prototype.track_links;
MixpanelLib.prototype['track_forms']                     = MixpanelLib.prototype.track_forms;
MixpanelLib.prototype['track_pageview']                  = MixpanelLib.prototype.track_pageview;
MixpanelLib.prototype['register']                        = MixpanelLib.prototype.register;
MixpanelLib.prototype['register_once']                   = MixpanelLib.prototype.register_once;
MixpanelLib.prototype['unregister']                      = MixpanelLib.prototype.unregister;
MixpanelLib.prototype['identify']                        = MixpanelLib.prototype.identify;
MixpanelLib.prototype['alias']                           = MixpanelLib.prototype.alias;
MixpanelLib.prototype['name_tag']                        = MixpanelLib.prototype.name_tag;
MixpanelLib.prototype['set_config']                      = MixpanelLib.prototype.set_config;
MixpanelLib.prototype['get_config']                      = MixpanelLib.prototype.get_config;
MixpanelLib.prototype['get_property']                    = MixpanelLib.prototype.get_property;
MixpanelLib.prototype['get_distinct_id']                 = MixpanelLib.prototype.get_distinct_id;
MixpanelLib.prototype['toString']                        = MixpanelLib.prototype.toString;
MixpanelLib.prototype['_check_and_handle_notifications'] = MixpanelLib.prototype._check_and_handle_notifications;
MixpanelLib.prototype['_show_notification']              = MixpanelLib.prototype._show_notification;

// MixpanelPersistence Exports
MixpanelPersistence.prototype['properties']            = MixpanelPersistence.prototype.properties;
MixpanelPersistence.prototype['update_search_keyword'] = MixpanelPersistence.prototype.update_search_keyword;
MixpanelPersistence.prototype['update_referrer_info']  = MixpanelPersistence.prototype.update_referrer_info;
MixpanelPersistence.prototype['get_cross_subdomain']   = MixpanelPersistence.prototype.get_cross_subdomain;
MixpanelPersistence.prototype['clear']                 = MixpanelPersistence.prototype.clear;

// MixpanelPeople Exports
MixpanelPeople.prototype['set']           = MixpanelPeople.prototype.set;
MixpanelPeople.prototype['set_once']      = MixpanelPeople.prototype.set_once;
MixpanelPeople.prototype['unset']         = MixpanelPeople.prototype.unset;
MixpanelPeople.prototype['increment']     = MixpanelPeople.prototype.increment;
MixpanelPeople.prototype['append']        = MixpanelPeople.prototype.append;
MixpanelPeople.prototype['union']         = MixpanelPeople.prototype.union;
MixpanelPeople.prototype['track_charge']  = MixpanelPeople.prototype.track_charge;
MixpanelPeople.prototype['clear_charges'] = MixpanelPeople.prototype.clear_charges;
MixpanelPeople.prototype['delete_user']   = MixpanelPeople.prototype.delete_user;
MixpanelPeople.prototype['toString']      = MixpanelPeople.prototype.toString;

_.safewrap_class(MixpanelLib, ['identify', '_check_and_handle_notifications', '_show_notification']);

var instances = {};
var extend_mp = function() {
    // add all the sub mixpanel instances
    _.each(instances, function(instance, name) {
        if (name !== PRIMARY_INSTANCE_NAME) { mixpanel_master[name] = instance; }
    });

    // add private functions as _
    mixpanel_master['_'] = _;
};

var override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!mixpanel_master[name]) {
                mixpanel_master[name] = instances[name] = create_mplib(token, config, name);
                mixpanel_master[name]._loaded();
            }
            return mixpanel_master[name];
        } else {
            var instance = mixpanel_master;

            if (instances[PRIMARY_INSTANCE_NAME]) {
                // main mixpanel lib already initialized
                instance = instances[PRIMARY_INSTANCE_NAME];
            } else if (token) {
                // intialize the main mixpanel lib
                instance = create_mplib(token, config, PRIMARY_INSTANCE_NAME);
                instance._loaded();
                instances[PRIMARY_INSTANCE_NAME] = instance;
            }

            mixpanel_master = instance;
            if (init_type === INIT_SNIPPET) {
                win[PRIMARY_INSTANCE_NAME] = mixpanel_master;
            }
            extend_mp();
        }
    };
};

var add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) { return; }
        dom_loaded_handler.done = true;

        DOM_LOADED = true;
        ENQUEUE_REQUESTS = false;

        _.each(instances, function(inst) {
            inst._dom_loaded();
        });
    }

    function do_scroll_check() {
        try {
            document$1.documentElement.doScroll('left');
        } catch(e) {
            setTimeout(do_scroll_check, 1);
            return;
        }

        dom_loaded_handler();
    }

    if (document$1.addEventListener) {
        if (document$1.readyState === 'complete') {
            // safari 4 can fire the DOMContentLoaded event before loading all
            // external JS (including this file). you will see some copypasta
            // on the internet that checks for 'complete' and 'loaded', but
            // 'loaded' is an IE thing
            dom_loaded_handler();
        } else {
            document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
        }
    } else if (document$1.attachEvent) {
        // IE
        document$1.attachEvent('onreadystatechange', dom_loaded_handler);

        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = win.frameElement === null;
        } catch(e) {
            // noop
        }

        if (document$1.documentElement.doScroll && toplevel) {
            do_scroll_check();
        }
    }

    // fallback handler, always will work
    _.register_event(win, 'load', dom_loaded_handler, true);
};

var add_dom_event_counting_handlers = function(instance) {
    var name = instance.get_config('name');

    instance.mp_counts = instance.mp_counts || {};
    instance.mp_counts['$__c'] = parseInt(_.cookie.get('mp_' + name + '__c')) || 0;

    var increment_count = function() {
        instance.mp_counts['$__c'] = (instance.mp_counts['$__c'] || 0) + 1;
        _.cookie.set('mp_' + name + '__c', instance.mp_counts['$__c'], 1, true);
    };

    var evtCallback = function() {
        try {
            instance.mp_counts = instance.mp_counts || {};
            increment_count();
        } catch (e) {
            console$1.error(e);
        }
    };
    _.register_event(document$1, 'submit', evtCallback);
    _.register_event(document$1, 'change', evtCallback);
    var mousedownTarget = null;
    _.register_event(document$1, 'mousedown', function(e) {
        mousedownTarget = e.target;
    });
    _.register_event(document$1, 'mouseup', function(e) {
        if (e.target === mousedownTarget) {
            evtCallback(e);
        }
    });
};

function init_as_module() {
    init_type = INIT_MODULE;
    mixpanel_master = new MixpanelLib();

    override_mp_init_func();
    mixpanel_master['init']();
    add_dom_loaded_handler();

    return mixpanel_master;
}

var mixpanel = init_as_module();

module.exports = mixpanel;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1821),
    baseFlatten = __webpack_require__(340),
    baseRest = __webpack_require__(425),
    isArrayLikeObject = __webpack_require__(886);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(434),
    arrayIncludes = __webpack_require__(884),
    arrayIncludesWith = __webpack_require__(885),
    arrayMap = __webpack_require__(318),
    baseUnary = __webpack_require__(251),
    cacheHas = __webpack_require__(435);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(853),
    baseIsNaN = __webpack_require__(1823),
    strictIndexOf = __webpack_require__(1824);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1823 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1824 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1826);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--avatar--GpVoeLYj {\n  background-color: rgb(158, 158, 158);\n  border-radius: 50%;\n  color: rgb(255, 255, 255);\n  display: inline-block;\n  font-size: 24px;\n  height: 40px;\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 40px;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--avatar--GpVoeLYj *,\n    .theme--avatar--GpVoeLYj *::after,\n    .theme--avatar--GpVoeLYj *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--avatar--GpVoeLYj > svg {\n  fill: currentColor;\n  height: 40px;\n  width: 1em;\n}\n.theme--avatar--GpVoeLYj > img {\n  height: auto;\n  max-width: 100%;\n}\n.theme--image--1xRhkwZ3 {\n  background-color: transparent;\n  background-position: center;\n  background-size: cover;\n  border-radius: 50%;\n  display: block;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n.theme--letter--2Ks9GkZI {\n  display: block;\n  line-height: 40px;\n  width: 100%;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/avatar/theme.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;CACZ;AACD;EACE,aAAa;EACb,gBAAgB;CACjB;AACD;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;CACb","file":"theme.css","sourcesContent":[".avatar {\n  background-color: rgb(158, 158, 158);\n  border-radius: 50%;\n  color: rgb(255, 255, 255);\n  display: inline-block;\n  font-size: 24px;\n  height: 40px;\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 40px;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.avatar *,\n    .avatar *::after,\n    .avatar *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.avatar > svg {\n  fill: currentColor;\n  height: 40px;\n  width: 1em;\n}\n.avatar > img {\n  height: auto;\n  max-width: 100%;\n}\n.image {\n  background-color: transparent;\n  background-position: center;\n  background-size: cover;\n  border-radius: 50%;\n  display: block;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n.letter {\n  display: block;\n  line-height: 40px;\n  width: 100%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"avatar": "theme--avatar--GpVoeLYj",
	"image": "theme--image--1xRhkwZ3",
	"letter": "theme--letter--2Ks9GkZI"
};

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListSubHeader = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListSubHeader = function ListSubHeader(_ref) {
  var caption = _ref.caption,
      className = _ref.className,
      theme = _ref.theme;
  return _react2.default.createElement(
    'h5',
    { className: (0, _classnames2.default)(theme.subheader, className) },
    caption
  );
};

ListSubHeader.propTypes = {
  caption: _propTypes2.default.string,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.object };

ListSubHeader.defaultProps = {
  className: ''
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListSubHeader);
exports.ListSubHeader = ListSubHeader;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListDivider = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListDivider = function ListDivider(_ref) {
  var inset = _ref.inset,
      theme = _ref.theme;
  return _react2.default.createElement('hr', { className: inset ? theme.divider + ' ' + theme.inset : theme.divider });
};

ListDivider.propTypes = {
  inset: _propTypes2.default.bool,
  theme: _propTypes2.default.shape({
    divider: _propTypes2.default.string,
    inset: _propTypes2.default.string
  })
};

ListDivider.defaultProps = {
  inset: false
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListDivider);
exports.ListDivider = ListDivider;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = exports.listFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _ListItem = __webpack_require__(889);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mergeProp = function mergeProp(propName, child, parent) {
  return child[propName] !== undefined ? child[propName] : parent[propName];
};

var factory = function factory(ListItem) {
  var List = function (_Component) {
    _inherits(List, _Component);

    function List() {
      _classCallCheck(this, List);

      return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
    }

    _createClass(List, [{
      key: 'renderItems',
      value: function renderItems() {
        var _this2 = this;

        return _react2.default.Children.map(this.props.children, function (item) {
          if (item === null || item === undefined) {
            return item;
          } else if (item.type === ListItem) {
            var selectable = mergeProp('selectable', item.props, _this2.props);
            var ripple = mergeProp('ripple', item.props, _this2.props);
            return _react2.default.cloneElement(item, { selectable: selectable, ripple: ripple });
          }
          return _react2.default.cloneElement(item);
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'ul',
          {
            'data-react-toolbox': 'list',
            className: (0, _classnames2.default)(this.props.theme.list, this.props.className)
          },
          this.renderItems()
        );
      }
    }]);

    return List;
  }(_react.Component);

  List.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
      list: _propTypes2.default.string
    })
  };
  List.defaultProps = {
    className: '',
    ripple: false,
    selectable: false
  };


  return List;
};

var List = factory(_ListItem2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(List);
exports.listFactory = factory;
exports.List = List;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListCheckbox = exports.listCheckboxFactory = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Checkbox = __webpack_require__(339);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _ListItemContent = __webpack_require__(343);

var _ListItemContent2 = _interopRequireDefault(_ListItemContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var factory = function factory(Checkbox, ListItemContent) {
  var ListCheckbox = function ListCheckbox(_ref) {
    var caption = _ref.caption,
        checked = _ref.checked,
        className = _ref.className,
        disabled = _ref.disabled,
        legend = _ref.legend,
        name = _ref.name,
        onBlur = _ref.onBlur,
        onChange = _ref.onChange,
        onFocus = _ref.onFocus,
        theme = _ref.theme;

    var _className = (0, _classnames3.default)(theme.item, theme.checkboxItem, _defineProperty({}, theme.disabled, disabled), className);

    return _react2.default.createElement(
      'li',
      { className: _className },
      _react2.default.createElement(Checkbox, {
        checked: checked,
        className: theme.checkbox,
        disabled: disabled,
        label: _react2.default.createElement(ListItemContent, { caption: caption, legend: legend }),
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus
      })
    );
  };

  ListCheckbox.propTypes = {
    caption: _propTypes2.default.string,
    checked: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    legend: _propTypes2.default.string,
    name: _propTypes2.default.string,
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      checkbox: _propTypes2.default.string,
      checkboxItem: _propTypes2.default.string,
      disabled: _propTypes2.default.string,
      item: _propTypes2.default.string
    })
  };

  ListCheckbox.defaultProps = {
    checked: false,
    disabled: false
  };

  return ListCheckbox;
};

var ListCheckbox = factory(_Checkbox2.default, _ListItemContent2.default);

exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListCheckbox);
exports.listCheckboxFactory = factory;
exports.ListCheckbox = ListCheckbox;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--list--3teJ8F4p {\n  display: inline-block;\n  list-style: none;\n  margin: 0;\n  padding: 8px 0;\n  position: relative;\n  text-align: left;\n  white-space: nowrap;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--list--3teJ8F4p *,\n    .theme--list--3teJ8F4p *::after,\n    .theme--list--3teJ8F4p *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--list--3teJ8F4p + .theme--divider--3e50_q6z {\n  margin-top: -8px;\n}\n.theme--subheader--1s1ZAIxY {\n  color: rgb(117, 117, 117);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 48px;\n  margin: -8px 0 0;\n  padding-left: 16px;\n}\n.theme--divider--3e50_q6z {\n  background-color: rgb(238, 238, 238);\n  border: 0;\n  height: 1px;\n  margin: -1px 0 0\n}\n.theme--divider--3e50_q6z.theme--inset--1cTceL6v {\n  margin-left: 72px;\n  margin-right: 16px;\n}\n.theme--listItem--1qmzE3YK {\n  position: relative\n}\n.theme--listItem--1qmzE3YK > [data-react-toolbox='ripple'] {\n  overflow: hidden;\n}\n.theme--listItem--1qmzE3YK .theme--ripple--1-X1WSB1 {\n  color: rgb(117, 117, 117);\n}\n.theme--listItem--1qmzE3YK ~ .theme--divider--3e50_q6z {\n  margin-bottom: 8px;\n  margin-top: 8px;\n}\n.theme--item--3xeGUGDI {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: rgb(33, 33, 33);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 48px;\n  padding: 0 16px;\n  position: relative\n}\n.theme--item--3xeGUGDI.theme--selectable--3ZvdyZhf:not(.theme--disabled--1HXmPjq8):hover {\n  background-color: rgb(238, 238, 238);\n  cursor: pointer;\n}\n.theme--item--3xeGUGDI.theme--disabled--1HXmPjq8 {\n  pointer-events: none;\n}\n.theme--item--3xeGUGDI.theme--disabled--1HXmPjq8:not(.theme--checkboxItem--2ToK4gSk) {\n  opacity: 0.5;\n}\n.theme--item--3xeGUGDI.theme--disabled--1HXmPjq8 > .theme--checkbox--hj7lUMJz > [data-react-toolbox='label'] {\n  opacity: 0.5;\n}\n.theme--left--2aHInA3v [data-react-toolbox='font-icon'] {\n  width: 18px;\n}\n.theme--left--2aHInA3v :last-child > [data-react-toolbox='font-icon'] {\n  margin-right: 22px;\n}\n.theme--right--2TgmXcHD > :last-child {\n  margin-right: 0;\n}\n.theme--right--2TgmXcHD > :first-child {\n  margin-left: 16px;\n}\n.theme--left--2aHInA3v,\n.theme--right--2TgmXcHD {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n.theme--itemAction--1Wpktme5 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 8px 16px 8px 0\n}\n.theme--itemAction--1Wpktme5 > * {\n  padding: 0;\n}\n.theme--itemAction--1Wpktme5 > [data-react-toolbox='font-icon'] {\n  color: rgb(117, 117, 117);\n  font-size: 24px;\n}\n.theme--itemContentRoot--2E9EPt9q {\n  display: block;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1\n}\n.theme--itemContentRoot--2E9EPt9q.theme--large--UrmWGZg2 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  height: 72px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.theme--checkbox--hj7lUMJz {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  margin: 0;\n  min-height: 48px;\n  width: 100%\n}\n.theme--checkbox--hj7lUMJz > [data-react-toolbox='check'] {\n  margin-right: 38px;\n}\n.theme--checkbox--hj7lUMJz > [data-react-toolbox='label'] {\n  padding-left: 0;\n}\n.theme--itemText--SRdeL95T {\n  display: block\n}\n.theme--itemText--SRdeL95T:not(.theme--primary--21dym1qT) {\n  color: rgb(117, 117, 117);\n  font-size: 14px;\n  padding-top: 3px;\n  white-space: normal;\n}\n.theme--itemText--SRdeL95T.theme--primary--21dym1qT {\n  color: rgb(33, 33, 33);\n  font-size: 16px;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/list/theme.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,iBAAiB;CAClB;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;EACE,qCAAqC;EACrC,UAAU;EACV,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,mBAAmB;EACnB,gBAAgB;CACjB;AACD;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,gBAAgB;CACjB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,aAAa;CACd;AACD;EACE,aAAa;CACd;AACD;EACE,YAAY;CACb;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;;EAEE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;MAChB,mBAAmB;UACf,eAAe;CACxB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;CACvB;AACD;EACE,WAAW;CACZ;AACD;EACE,0BAA0B;EAC1B,gBAAgB;CACjB;AACD;EACE,eAAe;EACf,oBAAoB;MAChB,qBAAqB;UACjB,YAAY;CACrB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,aAAa;EACb,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;CACjC;AACD;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,WAAW;CACZ;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,uBAAuB;EACvB,gBAAgB;CACjB","file":"theme.css","sourcesContent":[".list {\n  display: inline-block;\n  list-style: none;\n  margin: 0;\n  padding: 8px 0;\n  position: relative;\n  text-align: left;\n  white-space: nowrap;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.list *,\n    .list *::after,\n    .list *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.list + .divider {\n  margin-top: -8px;\n}\n.subheader {\n  color: rgb(117, 117, 117);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 48px;\n  margin: -8px 0 0;\n  padding-left: 16px;\n}\n.divider {\n  background-color: rgb(238, 238, 238);\n  border: 0;\n  height: 1px;\n  margin: -1px 0 0\n}\n.divider.inset {\n  margin-left: 72px;\n  margin-right: 16px;\n}\n.listItem {\n  position: relative\n}\n.listItem > [data-react-toolbox='ripple'] {\n  overflow: hidden;\n}\n.listItem .ripple {\n  color: rgb(117, 117, 117);\n}\n.listItem ~ .divider {\n  margin-bottom: 8px;\n  margin-top: 8px;\n}\n.item {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: rgb(33, 33, 33);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 48px;\n  padding: 0 16px;\n  position: relative\n}\n.item.selectable:not(.disabled):hover {\n  background-color: rgb(238, 238, 238);\n  cursor: pointer;\n}\n.item.disabled {\n  pointer-events: none;\n}\n.item.disabled:not(.checkboxItem) {\n  opacity: 0.5;\n}\n.item.disabled > .checkbox > [data-react-toolbox='label'] {\n  opacity: 0.5;\n}\n.left [data-react-toolbox='font-icon'] {\n  width: 18px;\n}\n.left :last-child > [data-react-toolbox='font-icon'] {\n  margin-right: 22px;\n}\n.right > :last-child {\n  margin-right: 0;\n}\n.right > :first-child {\n  margin-left: 16px;\n}\n.left,\n.right {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n}\n.itemAction {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 8px 16px 8px 0\n}\n.itemAction > * {\n  padding: 0;\n}\n.itemAction > [data-react-toolbox='font-icon'] {\n  color: rgb(117, 117, 117);\n  font-size: 24px;\n}\n.itemContentRoot {\n  display: block;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1\n}\n.itemContentRoot.large {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  height: 72px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.checkbox {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  margin: 0;\n  min-height: 48px;\n  width: 100%\n}\n.checkbox > [data-react-toolbox='check'] {\n  margin-right: 38px;\n}\n.checkbox > [data-react-toolbox='label'] {\n  padding-left: 0;\n}\n.itemText {\n  display: block\n}\n.itemText:not(.primary) {\n  color: rgb(117, 117, 117);\n  font-size: 14px;\n  padding-top: 3px;\n  white-space: normal;\n}\n.itemText.primary {\n  color: rgb(33, 33, 33);\n  font-size: 16px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"list": "theme--list--3teJ8F4p",
	"divider": "theme--divider--3e50_q6z",
	"subheader": "theme--subheader--1s1ZAIxY",
	"inset": "theme--inset--1cTceL6v",
	"listItem": "theme--listItem--1qmzE3YK",
	"ripple": "theme--ripple--1-X1WSB1",
	"item": "theme--item--3xeGUGDI",
	"selectable": "theme--selectable--3ZvdyZhf",
	"disabled": "theme--disabled--1HXmPjq8",
	"checkboxItem": "theme--checkboxItem--2ToK4gSk",
	"checkbox": "theme--checkbox--hj7lUMJz",
	"left": "theme--left--2aHInA3v",
	"right": "theme--right--2TgmXcHD",
	"itemAction": "theme--itemAction--1Wpktme5",
	"itemContentRoot": "theme--itemContentRoot--2E9EPt9q",
	"large": "theme--large--UrmWGZg2",
	"itemText": "theme--itemText--SRdeL95T",
	"primary": "theme--primary--21dym1qT"
};

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Card = function Card(_ref) {
  var children = _ref.children,
      className = _ref.className,
      raised = _ref.raised,
      theme = _ref.theme,
      other = _objectWithoutProperties(_ref, ['children', 'className', 'raised', 'theme']);

  var classes = (0, _classnames3.default)(theme.card, _defineProperty({}, theme.raised, raised), className);

  return _react2.default.createElement(
    'div',
    _extends({ 'data-react-toolbox': 'card', className: classes }, other),
    children
  );
};

Card.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  raised: _propTypes2.default.bool,
  theme: _propTypes2.default.shape({
    card: _propTypes2.default.string,
    raised: _propTypes2.default.string
  })
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.CARD)(Card);
exports.Card = Card;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CardActions = function CardActions(_ref) {
  var children = _ref.children,
      className = _ref.className,
      theme = _ref.theme,
      other = _objectWithoutProperties(_ref, ['children', 'className', 'theme']);

  return _react2.default.createElement(
    'div',
    _extends({ className: (0, _classnames2.default)(theme.cardActions, className) }, other),
    children
  );
};

CardActions.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.shape({
    cardActions: _propTypes2.default.string
  })
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.CARD)(CardActions);
exports.CardActions = CardActions;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardMedia = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _classnames3 = __webpack_require__(14);

var _classnames4 = _interopRequireDefault(_classnames3);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CardMedia = function CardMedia(_ref) {
  var aspectRatio = _ref.aspectRatio,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      contentOverlay = _ref.contentOverlay,
      image = _ref.image,
      theme = _ref.theme,
      other = _objectWithoutProperties(_ref, ['aspectRatio', 'children', 'className', 'color', 'contentOverlay', 'image', 'theme']);

  var classes = (0, _classnames4.default)(theme.cardMedia, _defineProperty({}, theme[aspectRatio], aspectRatio), className);

  var innerClasses = (0, _classnames4.default)(theme.content, _defineProperty({}, theme.contentOverlay, contentOverlay));

  var bgStyle = {
    backgroundColor: color || undefined,
    backgroundImage: typeof image === 'string' ? 'url(\'' + image + '\')' : undefined
  };

  return _react2.default.createElement(
    'div',
    _extends({ style: bgStyle, className: classes }, other),
    _react2.default.createElement(
      'div',
      { className: innerClasses },
      children
    )
  );
};

CardMedia.propTypes = {
  aspectRatio: _propTypes2.default.oneOf(['wide', 'square']),
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  color: _propTypes2.default.string,
  contentOverlay: _propTypes2.default.bool,
  image: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  theme: _propTypes2.default.shape({
    cardMedia: _propTypes2.default.string,
    content: _propTypes2.default.string,
    contentOverlay: _propTypes2.default.string,
    square: _propTypes2.default.string,
    wide: _propTypes2.default.string
  })
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.CARD)(CardMedia);
exports.CardMedia = CardMedia;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardText = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CardText = function CardText(_ref) {
  var children = _ref.children,
      className = _ref.className,
      theme = _ref.theme,
      other = _objectWithoutProperties(_ref, ['children', 'className', 'theme']);

  return _react2.default.createElement(
    'div',
    _extends({ className: (0, _classnames2.default)(theme.cardText, className) }, other),
    typeof children === 'string' ? _react2.default.createElement(
      'p',
      null,
      children
    ) : children
  );
};

CardText.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.shape({
    cardText: _propTypes2.default.string
  })
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.CARD)(CardText);
exports.CardText = CardText;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardTitleFactory = exports.CardTitle = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Avatar = __webpack_require__(342);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var factory = function factory(Avatar) {
  var CardTitle = function CardTitle(_ref) {
    var _classnames;

    var avatar = _ref.avatar,
        children = _ref.children,
        className = _ref.className,
        subtitle = _ref.subtitle,
        theme = _ref.theme,
        title = _ref.title,
        other = _objectWithoutProperties(_ref, ['avatar', 'children', 'className', 'subtitle', 'theme', 'title']);

    var classes = (0, _classnames3.default)(theme.cardTitle, (_classnames = {}, _defineProperty(_classnames, theme.small, avatar), _defineProperty(_classnames, theme.large, !avatar), _classnames), className);

    return _react2.default.createElement(
      'div',
      _extends({ className: classes }, other),
      typeof avatar === 'string' ? _react2.default.createElement(Avatar, { image: avatar, theme: theme }) : avatar,
      _react2.default.createElement(
        'div',
        null,
        title && _react2.default.createElement(
          'h5',
          { className: theme.title },
          title
        ),
        children && typeof children === 'string' && _react2.default.createElement(
          'h5',
          { className: theme.title },
          children
        ),
        subtitle && _react2.default.createElement(
          'p',
          { className: theme.subtitle },
          subtitle
        ),
        children && typeof children !== 'string' && children
      )
    );
  };

  CardTitle.propTypes = {
    avatar: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.array]),
    className: _propTypes2.default.string,
    subtitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    theme: _propTypes2.default.shape({
      large: _propTypes2.default.string,
      title: _propTypes2.default.string,
      small: _propTypes2.default.string,
      subtitle: _propTypes2.default.string
    }),
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
  };

  return CardTitle;
};

var CardTitle = factory(_Avatar2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.CARD)(CardTitle);
exports.CardTitle = CardTitle;
exports.cardTitleFactory = factory;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1838);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--card--1V4Xvs_T {\n  background: rgb(255, 255, 255);\n  border-radius: 2px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  font-size: 14px;\n  overflow: hidden;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--card--1V4Xvs_T *,\n    .theme--card--1V4Xvs_T *::after,\n    .theme--card--1V4Xvs_T *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--card--1V4Xvs_T.theme--raised--1Zehkq2I {\n  box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14),\n    0 3px 14px 2px rgba(0, 0, 0, .12),\n    0 5px 5px -3px rgba(0, 0, 0, .2);\n}\n.theme--cardMedia--20fBMo0n {\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative\n}\n.theme--cardMedia--20fBMo0n.theme--wide--3mHFViHL,\n  .theme--cardMedia--20fBMo0n.theme--square--1D2gx3CG {\n  width: 100%;\n}\n.theme--cardMedia--20fBMo0n.theme--wide--3mHFViHL .theme--content--DupHXUXR, .theme--cardMedia--20fBMo0n.theme--square--1D2gx3CG .theme--content--DupHXUXR {\n  height: 100%;\n  position: absolute;\n}\n.theme--cardMedia--20fBMo0n.theme--wide--3mHFViHL .theme--content--DupHXUXR > iframe,\n    .theme--cardMedia--20fBMo0n.theme--wide--3mHFViHL .theme--content--DupHXUXR > video,\n    .theme--cardMedia--20fBMo0n.theme--wide--3mHFViHL .theme--content--DupHXUXR > img,\n    .theme--cardMedia--20fBMo0n.theme--square--1D2gx3CG .theme--content--DupHXUXR > iframe,\n    .theme--cardMedia--20fBMo0n.theme--square--1D2gx3CG .theme--content--DupHXUXR > video,\n    .theme--cardMedia--20fBMo0n.theme--square--1D2gx3CG .theme--content--DupHXUXR > img {\n  max-width: 100%;\n}\n.theme--cardMedia--20fBMo0n::after {\n  content: '';\n  display: block;\n  height: 0;\n}\n.theme--cardMedia--20fBMo0n.theme--wide--3mHFViHL::after {\n  padding-top: 56.25%;\n}\n.theme--cardMedia--20fBMo0n.theme--square--1D2gx3CG::after {\n  padding-top: 100%;\n}\n.theme--cardMedia--20fBMo0n .theme--content--DupHXUXR {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  left: 0;\n  overflow: hidden;\n  position: relative;\n  top: 0;\n  width: 100%;\n}\n.theme--cardMedia--20fBMo0n .theme--contentOverlay--2lGl6svG .theme--cardTitle--3xJmCzox,\n    .theme--cardMedia--20fBMo0n .theme--contentOverlay--2lGl6svG .theme--cardActions--3IWw9pPG,\n    .theme--cardMedia--20fBMo0n .theme--contentOverlay--2lGl6svG .theme--cardText--1NEQwxVv {\n  background-color: rgba(0, 0, 0, 0.35);\n}\n.theme--cardMedia--20fBMo0n .theme--cardTitle--3xJmCzox .theme--title--1a6DOyt_,\n    .theme--cardMedia--20fBMo0n .theme--cardTitle--3xJmCzox .theme--subtitle--3p4-wYKn {\n  color: rgb(255, 255, 255);\n}\n.theme--cardTitle--3xJmCzox {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex\n}\n.theme--cardTitle--3xJmCzox [data-react-toolbox='avatar'] {\n  margin-right: 13px;\n}\n.theme--cardTitle--3xJmCzox .theme--title--1a6DOyt_ {\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  line-height: 1;\n  margin: 0;\n  padding: 0;\n}\n.theme--cardTitle--3xJmCzox .theme--subtitle--3p4-wYKn {\n  color: rgb(117, 117, 117);\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 24px;\n  margin: 0;\n  padding: 0;\n}\n.theme--cardTitle--3xJmCzox.theme--large--TPO87gZE {\n  padding: 20px 16px 14px;\n}\n.theme--cardTitle--3xJmCzox.theme--large--TPO87gZE .theme--title--1a6DOyt_ {\n  font-size: 24px;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 400;\n  line-height: 1.25;\n}\n.theme--cardTitle--3xJmCzox.theme--small--AqQtsGt2 {\n  padding: 16px;\n}\n.theme--cardTitle--3xJmCzox.theme--small--AqQtsGt2 .theme--title--1a6DOyt_ {\n  font-size: 22.4px;\n  font-size: 1.4rem;\n  letter-spacing: 0;\n  line-height: 1.4;\n}\n.theme--cardTitle--3xJmCzox.theme--small--AqQtsGt2 .theme--subtitle--3p4-wYKn {\n  font-weight: 500;\n  line-height: 1.4;\n}\n.theme--cardTitle--3xJmCzox,\n.theme--cardText--1NEQwxVv {\n  padding: 14px 16px\n}\n.theme--cardTitle--3xJmCzox p, .theme--cardText--1NEQwxVv p {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 24px;\n  margin: 0;\n}\n.theme--cardTitle--3xJmCzox:last-child, .theme--cardText--1NEQwxVv:last-child {\n  padding-bottom: 20px;\n}\n.theme--cardTitle--3xJmCzox + .theme--cardText--1NEQwxVv, .theme--cardText--1NEQwxVv + .theme--cardText--1NEQwxVv {\n  padding-top: 0;\n}\n.theme--cardActions--3IWw9pPG {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  padding: 8px\n}\n.theme--cardActions--3IWw9pPG [data-react-toolbox='button'] {\n  margin: 0 4px;\n  min-width: 0;\n  padding: 0 8px;\n}\n.theme--cardActions--3IWw9pPG [data-react-toolbox='button']:first-child {\n  margin-left: 0;\n}\n.theme--cardActions--3IWw9pPG [data-react-toolbox='button']:last-child {\n  margin-right: 0;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/card/theme.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB;;mCAEiC;EACjC,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE;;qCAEmC;CACpC;AACD;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;CACnB;AACD;;EAEE,YAAY;CACb;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;;;;;;EAME,gBAAgB;CACjB;AACD;EACE,YAAY;EACZ,eAAe;EACf,UAAU;CACX;AACD;EACE,oBAAoB;CACrB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,sBAAsB;MAClB,mBAAmB;UACf,0BAA0B;EAClC,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,OAAO;EACP,YAAY;CACb;AACD;;;EAGE,sCAAsC;CACvC;AACD;;EAEE,0BAA0B;CAC3B;AACD;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;CACd;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,WAAW;CACZ;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;CACZ;AACD;EACE,wBAAwB;CACzB;AACD;EACE,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;CACnB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,iBAAiB;CAClB;AACD;;EAEE,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;CACX;AACD;EACE,qBAAqB;CACtB;AACD;EACE,eAAe;CAChB;AACD;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,wBAAwB;MACpB,qBAAqB;UACjB,4BAA4B;EACpC,YAAY;CACb;AACD;EACE,cAAc;EACd,aAAa;EACb,eAAe;CAChB;AACD;EACE,eAAe;CAChB;AACD;EACE,gBAAgB;CACjB","file":"theme.css","sourcesContent":[".card {\n  background: rgb(255, 255, 255);\n  border-radius: 2px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  font-size: 14px;\n  overflow: hidden;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.card *,\n    .card *::after,\n    .card *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.card.raised {\n  box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14),\n    0 3px 14px 2px rgba(0, 0, 0, .12),\n    0 5px 5px -3px rgba(0, 0, 0, .2);\n}\n.cardMedia {\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative\n}\n.cardMedia.wide,\n  .cardMedia.square {\n  width: 100%;\n}\n.cardMedia.wide .content, .cardMedia.square .content {\n  height: 100%;\n  position: absolute;\n}\n.cardMedia.wide .content > iframe,\n    .cardMedia.wide .content > video,\n    .cardMedia.wide .content > img,\n    .cardMedia.square .content > iframe,\n    .cardMedia.square .content > video,\n    .cardMedia.square .content > img {\n  max-width: 100%;\n}\n.cardMedia::after {\n  content: '';\n  display: block;\n  height: 0;\n}\n.cardMedia.wide::after {\n  padding-top: 56.25%;\n}\n.cardMedia.square::after {\n  padding-top: 100%;\n}\n.cardMedia .content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  left: 0;\n  overflow: hidden;\n  position: relative;\n  top: 0;\n  width: 100%;\n}\n.cardMedia .contentOverlay .cardTitle,\n    .cardMedia .contentOverlay .cardActions,\n    .cardMedia .contentOverlay .cardText {\n  background-color: rgba(0, 0, 0, 0.35);\n}\n.cardMedia .cardTitle .title,\n    .cardMedia .cardTitle .subtitle {\n  color: rgb(255, 255, 255);\n}\n.cardTitle {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex\n}\n.cardTitle [data-react-toolbox='avatar'] {\n  margin-right: 13px;\n}\n.cardTitle .title {\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  line-height: 1;\n  margin: 0;\n  padding: 0;\n}\n.cardTitle .subtitle {\n  color: rgb(117, 117, 117);\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 24px;\n  margin: 0;\n  padding: 0;\n}\n.cardTitle.large {\n  padding: 20px 16px 14px;\n}\n.cardTitle.large .title {\n  font-size: 24px;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 400;\n  line-height: 1.25;\n}\n.cardTitle.small {\n  padding: 16px;\n}\n.cardTitle.small .title {\n  font-size: 22.4px;\n  font-size: 1.4rem;\n  letter-spacing: 0;\n  line-height: 1.4;\n}\n.cardTitle.small .subtitle {\n  font-weight: 500;\n  line-height: 1.4;\n}\n.cardTitle,\n.cardText {\n  padding: 14px 16px\n}\n.cardTitle p, .cardText p {\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 24px;\n  margin: 0;\n}\n.cardTitle:last-child, .cardText:last-child {\n  padding-bottom: 20px;\n}\n.cardTitle + .cardText, .cardText + .cardText {\n  padding-top: 0;\n}\n.cardActions {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  padding: 8px\n}\n.cardActions [data-react-toolbox='button'] {\n  margin: 0 4px;\n  min-width: 0;\n  padding: 0 8px;\n}\n.cardActions [data-react-toolbox='button']:first-child {\n  margin-left: 0;\n}\n.cardActions [data-react-toolbox='button']:last-child {\n  margin-right: 0;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"card": "theme--card--1V4Xvs_T",
	"raised": "theme--raised--1Zehkq2I",
	"cardMedia": "theme--cardMedia--20fBMo0n",
	"wide": "theme--wide--3mHFViHL",
	"square": "theme--square--1D2gx3CG",
	"content": "theme--content--DupHXUXR",
	"contentOverlay": "theme--contentOverlay--2lGl6svG",
	"cardTitle": "theme--cardTitle--3xJmCzox",
	"cardActions": "theme--cardActions--3IWw9pPG",
	"cardText": "theme--cardText--1NEQwxVv",
	"title": "theme--title--1a6DOyt_",
	"subtitle": "theme--subtitle--3p4-wYKn",
	"large": "theme--large--TPO87gZE",
	"small": "theme--small--AqQtsGt2"
};

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1840);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--input--1rMafvds {\n  padding: 20px 0;\n  position: relative;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--input--1rMafvds *,\n    .theme--input--1rMafvds *::after,\n    .theme--input--1rMafvds *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--input--1rMafvds.theme--withIcon--qJ0JHkvT {\n  margin-left: 68px;\n}\n.theme--icon--3-liGPQn {\n  color: rgba(0, 0, 0, 0.26);\n  display: block;\n  font-size: 24px !important;\n  height: 48px;\n  left: -68px;\n  line-height: 48px !important;\n  position: absolute;\n  text-align: center;\n  top: 16px;\n  transition: color 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 48px;\n}\n.theme--inputElement--2lFEhyIO {\n  background-color: transparent;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  border-left: 0;\n  border-right: 0;\n  border-top: 0;\n  color: rgb(33, 33, 33);\n  display: block;\n  font-size: 16px;\n  outline: none;\n  padding: 8px 0;\n  width: 100%\n}\n.theme--inputElement--2lFEhyIO:focus:not([disabled]):not([readonly]) ~ .theme--bar--3FW5maR-::before,\n    .theme--inputElement--2lFEhyIO:focus:not([disabled]):not([readonly]) ~ .theme--bar--3FW5maR-::after {\n  width: 50%;\n}\n.theme--inputElement--2lFEhyIO:focus:not([disabled]):not([readonly]) ~ .theme--label--155-bh6y:not(.theme--fixed--3s19ksk3) {\n  color: rgb(63, 81, 181);\n}\n.theme--inputElement--2lFEhyIO:focus:not([disabled]):not([readonly]) ~ .theme--label--155-bh6y > .theme--required--2qVITGno {\n  color: rgb(222, 50, 38);\n}\n.theme--inputElement--2lFEhyIO:focus:not([disabled]):not([readonly]) ~ .theme--hint--WRioQWEc {\n  display: block;\n  opacity: 1;\n}\n.theme--inputElement--2lFEhyIO:focus:not([disabled]):not([readonly]) ~ .theme--icon--3-liGPQn {\n  color: rgb(63, 81, 181);\n}\n.theme--inputElement--2lFEhyIO:focus:not([disabled]):not([readonly]).theme--filled--2-QbL1UE ~ .theme--hint--WRioQWEc {\n  opacity: 0;\n}\n.theme--inputElement--2lFEhyIO:focus:not([disabled]):not([readonly]) ~ .theme--label--155-bh6y:not(.theme--fixed--3s19ksk3), .theme--inputElement--2lFEhyIO.theme--filled--2-QbL1UE ~ .theme--label--155-bh6y:not(.theme--fixed--3s19ksk3), .theme--inputElement--2lFEhyIO[type='date'] ~ .theme--label--155-bh6y:not(.theme--fixed--3s19ksk3), .theme--inputElement--2lFEhyIO[type='time'] ~ .theme--label--155-bh6y:not(.theme--fixed--3s19ksk3) {\n  font-size: 12px;\n  top: 6px;\n}\n.theme--inputElement--2lFEhyIO.theme--filled--2-QbL1UE ~ .theme--label--155-bh6y.theme--fixed--3s19ksk3,\n  .theme--inputElement--2lFEhyIO.theme--filled--2-QbL1UE ~ .theme--hint--WRioQWEc {\n  display: none;\n}\n.theme--label--155-bh6y {\n  color: rgba(0, 0, 0, 0.26);\n  font-size: 16px;\n  left: 0;\n  line-height: 16px;\n  pointer-events: none;\n  position: absolute;\n  top: 32px;\n  transition-duration: 0.35s;\n  transition-property: top, font-size, color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)\n}\n.theme--label--155-bh6y.theme--fixed--3s19ksk3 ~ .theme--hint--WRioQWEc {\n  display: none;\n}\n.theme--hint--WRioQWEc {\n  color: rgba(0, 0, 0, 0.26);\n  font-size: 16px;\n  left: 0;\n  line-height: 16px;\n  opacity: 1;\n  pointer-events: none;\n  position: absolute;\n  top: 32px;\n  transition-duration: 0.35s;\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.theme--bar--3FW5maR- {\n  display: block;\n  position: relative;\n  width: 100%\n}\n.theme--bar--3FW5maR-::before,\n  .theme--bar--3FW5maR-::after {\n  background-color: rgb(63, 81, 181);\n  bottom: 0;\n  content: '';\n  height: 2px;\n  position: absolute;\n  transition-duration: 0.2s;\n  transition-property: width, background-color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: 0;\n}\n.theme--bar--3FW5maR-::before {\n  left: 50%;\n}\n.theme--bar--3FW5maR-::after {\n  right: 50%;\n}\n.theme--error--3Md23YAQ,\n.theme--counter--KQAKpz-E {\n  color: rgb(222, 50, 38);\n  font-size: 12px;\n  line-height: 20px;\n  margin-bottom: -20px;\n}\n.theme--counter--KQAKpz-E {\n  color: rgba(0, 0, 0, 0.26);\n  position: absolute;\n  right: 0;\n}\n.theme--disabled--3HvJKQ_z > .theme--inputElement--2lFEhyIO {\n  border-bottom-style: dotted;\n  color: rgba(0, 0, 0, 0.26);\n}\n.theme--errored--au7blPGA {\n  padding-bottom: 0\n}\n.theme--errored--au7blPGA > .theme--inputElement--2lFEhyIO {\n  border-bottom-color: rgb(222, 50, 38);\n  margin-top: 1px;\n}\n.theme--errored--au7blPGA > .theme--counter--KQAKpz-E,\n  .theme--errored--au7blPGA > .theme--label--155-bh6y {\n  color: rgb(222, 50, 38);\n}\n.theme--errored--au7blPGA > .theme--label--155-bh6y > .theme--required--2qVITGno {\n  color: rgb(222, 50, 38);\n}\n.theme--hidden--20Ykjwub {\n  display: none;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/input/theme.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,kBAAkB;CACnB;AACD;EACE,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,qDAAqD;EACrD,YAAY;CACb;AACD;EACE,8BAA8B;EAC9B,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,WAAW;CACZ;AACD;;EAEE,WAAW;CACZ;AACD;EACE,wBAAwB;CACzB;AACD;EACE,wBAAwB;CACzB;AACD;EACE,eAAe;EACf,WAAW;CACZ;AACD;EACE,wBAAwB;CACzB;AACD;EACE,WAAW;CACZ;AACD;EACE,gBAAgB;EAChB,SAAS;CACV;AACD;;EAEE,cAAc;CACf;AACD;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,2CAA2C;EAC3C,wDAAwD;CACzD;AACD;EACE,cAAc;CACf;AACD;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,6BAA6B;EAC7B,yDAAyD;CAC1D;AACD;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;CACZ;AACD;;EAEE,mCAAmC;EACnC,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,6CAA6C;EAC7C,yDAAyD;EACzD,SAAS;CACV;AACD;EACE,UAAU;CACX;AACD;EACE,WAAW;CACZ;AACD;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;CACtB;AACD;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;CACV;AACD;EACE,4BAA4B;EAC5B,2BAA2B;CAC5B;AACD;EACE,iBAAiB;CAClB;AACD;EACE,sCAAsC;EACtC,gBAAgB;CACjB;AACD;;EAEE,wBAAwB;CACzB;AACD;EACE,wBAAwB;CACzB;AACD;EACE,cAAc;CACf","file":"theme.css","sourcesContent":[".input {\n  padding: 20px 0;\n  position: relative;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.input *,\n    .input *::after,\n    .input *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.input.withIcon {\n  margin-left: 68px;\n}\n.icon {\n  color: rgba(0, 0, 0, 0.26);\n  display: block;\n  font-size: 24px !important;\n  height: 48px;\n  left: -68px;\n  line-height: 48px !important;\n  position: absolute;\n  text-align: center;\n  top: 16px;\n  transition: color 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 48px;\n}\n.inputElement {\n  background-color: transparent;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  border-left: 0;\n  border-right: 0;\n  border-top: 0;\n  color: rgb(33, 33, 33);\n  display: block;\n  font-size: 16px;\n  outline: none;\n  padding: 8px 0;\n  width: 100%\n}\n.inputElement:focus:not([disabled]):not([readonly]) ~ .bar::before,\n    .inputElement:focus:not([disabled]):not([readonly]) ~ .bar::after {\n  width: 50%;\n}\n.inputElement:focus:not([disabled]):not([readonly]) ~ .label:not(.fixed) {\n  color: rgb(63, 81, 181);\n}\n.inputElement:focus:not([disabled]):not([readonly]) ~ .label > .required {\n  color: rgb(222, 50, 38);\n}\n.inputElement:focus:not([disabled]):not([readonly]) ~ .hint {\n  display: block;\n  opacity: 1;\n}\n.inputElement:focus:not([disabled]):not([readonly]) ~ .icon {\n  color: rgb(63, 81, 181);\n}\n.inputElement:focus:not([disabled]):not([readonly]).filled ~ .hint {\n  opacity: 0;\n}\n.inputElement:focus:not([disabled]):not([readonly]) ~ .label:not(.fixed), .inputElement.filled ~ .label:not(.fixed), .inputElement[type='date'] ~ .label:not(.fixed), .inputElement[type='time'] ~ .label:not(.fixed) {\n  font-size: 12px;\n  top: 6px;\n}\n.inputElement.filled ~ .label.fixed,\n  .inputElement.filled ~ .hint {\n  display: none;\n}\n.label {\n  color: rgba(0, 0, 0, 0.26);\n  font-size: 16px;\n  left: 0;\n  line-height: 16px;\n  pointer-events: none;\n  position: absolute;\n  top: 32px;\n  transition-duration: 0.35s;\n  transition-property: top, font-size, color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)\n}\n.label.fixed ~ .hint {\n  display: none;\n}\n.hint {\n  color: rgba(0, 0, 0, 0.26);\n  font-size: 16px;\n  left: 0;\n  line-height: 16px;\n  opacity: 1;\n  pointer-events: none;\n  position: absolute;\n  top: 32px;\n  transition-duration: 0.35s;\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.bar {\n  display: block;\n  position: relative;\n  width: 100%\n}\n.bar::before,\n  .bar::after {\n  background-color: rgb(63, 81, 181);\n  bottom: 0;\n  content: '';\n  height: 2px;\n  position: absolute;\n  transition-duration: 0.2s;\n  transition-property: width, background-color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: 0;\n}\n.bar::before {\n  left: 50%;\n}\n.bar::after {\n  right: 50%;\n}\n.error,\n.counter {\n  color: rgb(222, 50, 38);\n  font-size: 12px;\n  line-height: 20px;\n  margin-bottom: -20px;\n}\n.counter {\n  color: rgba(0, 0, 0, 0.26);\n  position: absolute;\n  right: 0;\n}\n.disabled > .inputElement {\n  border-bottom-style: dotted;\n  color: rgba(0, 0, 0, 0.26);\n}\n.errored {\n  padding-bottom: 0\n}\n.errored > .inputElement {\n  border-bottom-color: rgb(222, 50, 38);\n  margin-top: 1px;\n}\n.errored > .counter,\n  .errored > .label {\n  color: rgb(222, 50, 38);\n}\n.errored > .label > .required {\n  color: rgb(222, 50, 38);\n}\n.hidden {\n  display: none;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"input": "theme--input--1rMafvds",
	"withIcon": "theme--withIcon--qJ0JHkvT",
	"icon": "theme--icon--3-liGPQn",
	"inputElement": "theme--inputElement--2lFEhyIO",
	"bar": "theme--bar--3FW5maR-",
	"label": "theme--label--155-bh6y",
	"fixed": "theme--fixed--3s19ksk3",
	"required": "theme--required--2qVITGno",
	"hint": "theme--hint--WRioQWEc",
	"filled": "theme--filled--2-QbL1UE",
	"error": "theme--error--3Md23YAQ",
	"counter": "theme--counter--KQAKpz-E",
	"disabled": "theme--disabled--3HvJKQ_z",
	"errored": "theme--errored--au7blPGA",
	"hidden": "theme--hidden--20Ykjwub"
};

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.action-dialog--body--3egZqzny {\n  padding-bottom: 0;\n}\n\n.action-dialog--listItem--2YLNDHEV[class~=text_hidden] .action-dialog--itemContentRoot--36yCpfh9{\n  overflow: hidden;\n}\n\n.action-dialog--listItem--2YLNDHEV[class~=text_hidden] .action-dialog--itemText--1kuDLXeg{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* モバイル向けスタイル */\n\n@media screen and (max-width: 600px) {\n  [data-react-toolbox=\"dialog\"] > section {\n    max-height: 80vh !important;\n    overflow-y: auto !important;\n  }\n}", "", {"version":3,"sources":["/./src/web/components/themes/action-dialog.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;CACzB;;AAED,gBAAgB;;AAEhB;EACE;IACE,4BAA4B;IAC5B,4BAA4B;GAC7B;CACF","file":"action-dialog.css","sourcesContent":["\n.body {\n  padding-bottom: 0;\n}\n\n.listItem[class~=text_hidden] .itemContentRoot{\n  overflow: hidden;\n}\n\n.listItem[class~=text_hidden] .itemText{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* モバイル向けスタイル */\n\n@media screen and (max-width: 600px) {\n  [data-react-toolbox=\"dialog\"] > section {\n    max-height: 80vh !important;\n    overflow-y: auto !important;\n  }\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"body": "action-dialog--body--3egZqzny",
	"listItem": "action-dialog--listItem--2YLNDHEV",
	"itemContentRoot": "action-dialog--itemContentRoot--36yCpfh9",
	"itemText": "action-dialog--itemText--1kuDLXeg"
};

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1843);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./fluid-input.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./fluid-input.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.fluid-input--input--2HS7HYqi {\n  width: 100%;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/fluid-input.css"],"names":[],"mappings":";AACA;EACE,YAAY;CACb","file":"fluid-input.css","sourcesContent":["\n.input {\n  width: 100%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"input": "fluid-input--input--2HS7HYqi"
};

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1845);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./login-page.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./login-page.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.login-page--gamba--GCnzIQu_ {\n  background-color: red;\n}\n\n.login-page--gamba--GCnzIQu_ h1 {\n  font-family: \"Century Gothic\", \"Questrial\", sans-serif;\n  font-weight: bold;\n  color: white;\n  text-align: center;\n  font-size: 42px;\n  margin: 15px;\n}\n\n.login-page--card--cz9ukldG[class~=login] {\n  margin: 50px auto;\n  max-width: 500px;\n}\n\n.login-page--card--cz9ukldG {\n  margin: 0 10px;\n  width: calc(100% - 20px);\n}\n\n.login-page--cardActions--2pE8eRIV button:last-child{\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n.login-page--email--12ygrGqh {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}", "", {"version":3,"sources":["/./src/web/components/themes/login-page.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;CACvB;;AAED;EACE,uDAAuD;EACvD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;CACd;;AAED;EACE,kBAAkB;EAClB,iBAAiB;CAClB;;AAED;EACE,eAAe;EACf,yBAAyB;CAC1B;;AAED;EACE,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;CACtB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B","file":"login-page.css","sourcesContent":["\n.gamba {\n  background-color: red;\n}\n\n.gamba h1 {\n  font-family: \"Century Gothic\", \"Questrial\", sans-serif;\n  font-weight: bold;\n  color: white;\n  text-align: center;\n  font-size: 42px;\n  margin: 15px;\n}\n\n.card[class~=login] {\n  margin: 50px auto;\n  max-width: 500px;\n}\n\n.card {\n  margin: 0 10px;\n  width: calc(100% - 20px);\n}\n\n.cardActions button:last-child{\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n.email {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"gamba": "login-page--gamba--GCnzIQu_",
	"card": "login-page--card--cz9ukldG",
	"cardActions": "login-page--cardActions--2pE8eRIV",
	"email": "login-page--email--12ygrGqh"
};

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawMainPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mainPage = __webpack_require__(1847);

var _mainPage2 = _interopRequireDefault(_mainPage);

var _layout = __webpack_require__(85);

var _list = __webpack_require__(25);

var _leftSidebarUser = __webpack_require__(1879);

var _leftSidebarUser2 = _interopRequireDefault(_leftSidebarUser);

var _menu = __webpack_require__(63);

var _leftSidebar = __webpack_require__(1888);

var _leftSidebar2 = _interopRequireDefault(_leftSidebar);

var _userSelectionDialog = __webpack_require__(2000);

var _userSelectionDialog2 = _interopRequireDefault(_userSelectionDialog);

var _groupSelectionDialog = __webpack_require__(2009);

var _groupSelectionDialog2 = _interopRequireDefault(_groupSelectionDialog);

var _emojiPalette = __webpack_require__(2011);

var _emojiPalette2 = _interopRequireDefault(_emojiPalette);

var _stampPalette = __webpack_require__(2013);

var _stampPalette2 = _interopRequireDefault(_stampPalette);

var _imagesView = __webpack_require__(2165);

var _imagesView2 = _interopRequireDefault(_imagesView);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _helpButton = __webpack_require__(2171);

var _helpButton2 = _interopRequireDefault(_helpButton);

var _drawer = __webpack_require__(2173);

var _drawer2 = _interopRequireDefault(_drawer);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _userSettingsPage = __webpack_require__(2175);

var _userSettingsPage2 = _interopRequireDefault(_userSettingsPage);

var _reactWebNotification = __webpack_require__(2274);

var _reactWebNotification2 = _interopRequireDefault(_reactWebNotification);

var _googleSigninProvider = __webpack_require__(200);

var _googleSigninProvider2 = _interopRequireDefault(_googleSigninProvider);

var _leftSidebarGroupListItem = __webpack_require__(347);

var _leftSidebarGroupListItem2 = _interopRequireDefault(_leftSidebarGroupListItem);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _analytics = __webpack_require__(27);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _button = __webpack_require__(8);

var _react3 = __webpack_require__(981);

var Sentry = _interopRequireWildcard(_react3);

var _liveChat = __webpack_require__(2336);

var _liveChat2 = _interopRequireDefault(_liveChat);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/main-page.jsx

var MainPage = function (_React$Component) {
  _inherits(MainPage, _React$Component);

  function MainPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MainPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MainPage.__proto__ || Object.getPrototypeOf(MainPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { showTrialAlert: true }, _this.configureSentry = function (user) {
      Sentry.setUser({ id: user.user_id, username: 'COMP-' + user.account.account_id + '-USER-' + user.user_id });
    }, _this.configureZendesk = function (user) {
      // Zendesk APIの初期化が間に合っていない場合、zE.identifyがundefinedのままになっていることがありうる
      setTimeout(function () {
        return zE && typeof zE.identify == 'function' && zE.identify({ name: user.name, email: user.email });
      }, 60000);
    }, _this.openHelpPage = function () {
      window.open('https://support.getgamba.com/hc/ja');
      (0, _analytics.track)('open_help');
    }, _this.activateZendesk = function () {
      // Check if the zE object and the activate method exist before calling it
      if (typeof zE === 'function' && typeof zE.activate === 'function') {
        zE.activate({ hideOnClose: true });
        (0, _analytics.track)('open_inquiry');
      }
    }, _this.onClose = function () {
      return _this.setState({
        title: undefined,
        body: undefined,
        tag: undefined,
        icon: undefined,
        onClick: undefined
      });
    }, _this.closeAlertMessage = function () {
      return _this.setState({ showTrialAlert: false });
    }, _this.changePlan = function () {
      window.open(_config2.default.baseUrl + 'v3/contract');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MainPage, [{
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps) {
      if (nextProps.socketNotification && !_lodash2.default.isEqual(this.props.socketNotification, nextProps.socketNotification) && nextProps.socketNotification[0]) {
        var notification = _lodash2.default.find(nextProps.socketNotification, function (socketNotification) {
          return !socketNotification.notification.delivered_at;
        });
        notification = notification && notification.notification || undefined;
        if (notification) this.setState({
          title: nextProps.t('label:新着のお知らせ'),
          body: notification.description,
          tag: 'notification-' + notification.notification_id,
          icon: notification.icon_image.thumb_url,
          onClick: function onClick() {
            return nextProps.onWebNotification('notification', notification);
          }
        });
      }

      if (nextProps.socketChat && !_lodash2.default.isEqual(this.props.socketChat, nextProps.socketChat) && nextProps.socketChat[0]) {
        var message = _lodash2.default.find(nextProps.socketChat, function (socketChat) {
          return socketChat.appending && socketChat.chat.user.user_id != nextProps.user.user_id;
        });
        message = message && message.chat || undefined;
        if (message) this.setState({
          title: nextProps.t('label:新着のメッセージ', { name: message.user.name }),
          body: message.files.length > 0 && nextProps.t('label:添付ファイルが届いています') || message.message_text,
          tag: 'chat-' + message.message_id,
          icon: message.user.icon_image.thumb_url,
          onClick: function onClick() {
            return nextProps.onWebNotification('chat', message);
          }
        });
      }

      if (!this.props.user && nextProps.user) {
        if (nextProps.user.trial && nextProps.user.left_days < 0) {
          nextProps.logout();
        }

        this.configureSentry(nextProps.user);
        this.configureZendesk(nextProps.user);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          user = _props.user,
          children = _props.children,
          groups = _props.groups,
          params = _props.params,
          location = _props.location,
          active = _props.active,
          pinned = _props.pinned,
          isFetching = _props.isFetching,
          onOverlayClick = _props.onOverlayClick;


      if (!user) return _react2.default.createElement('div', { className: 'initial-loading' });

      var group_id = location.pathname == "/groups/home" ? 'home' : params.group_id;

      return _react2.default.createElement(
        _userSelectionDialog2.default,
        null,
        _react2.default.createElement(
          _groupSelectionDialog2.default,
          null,
          _react2.default.createElement(
            _stampPalette2.default,
            null,
            _react2.default.createElement(
              _emojiPalette2.default,
              null,
              _react2.default.createElement(
                _googleSigninProvider2.default,
                null,
                _react2.default.createElement(
                  _imagesView2.default,
                  null,
                  _react2.default.createElement(
                    _layout.Layout,
                    { ref: function ref(c) {
                        return _this2.drawer = c;
                      } },
                    _react2.default.createElement(
                      _layout.NavDrawer,
                      { active: active, theme: _drawer2.default,
                        pinned: pinned,
                        onOverlayClick: onOverlayClick },
                      _react2.default.createElement(_leftSidebarUser2.default, { user: user, openUserSettingsPage: this.props.openUserSettingsPage }),
                      _react2.default.createElement(_leftSidebar2.default, { ref: function ref(c) {
                          return _this2.sidebar = c;
                        }, group_id: group_id }),
                      _react2.default.createElement(
                        _list.List,
                        { selectable: true, theme: _leftSidebarGroupListItem2.default },
                        _react2.default.createElement(_list.ListSubHeader, {
                          caption: t('label:その他') }),
                        _react2.default.createElement(_list.ListItem, {
                          leftIcon: 'settings',
                          theme: _leftSidebarGroupListItem2.default,
                          caption: t('label:個人設定'),
                          onClick: this.props.openUserSettingsPage }),
                        _react2.default.createElement(_list.ListItem, {
                          leftIcon: 'open_in_new',
                          theme: _leftSidebarGroupListItem2.default,
                          caption: t('label:ヘルプページを開く'),
                          onClick: this.openHelpPage }),
                        _react2.default.createElement(_list.ListItem, {
                          leftIcon: 'help_outline',
                          theme: _leftSidebarGroupListItem2.default,
                          caption: t('label:問い合わせる'),
                          onClick: this.activateZendesk })
                      ),
                      user && user.trial && _react2.default.createElement(
                        'div',
                        { className: _leftSidebarGroupListItem2.default.trialWrap },
                        _react2.default.createElement(
                          'p',
                          { style: { marginTop: 10, marginBottom: 5 } },
                          t('label:トライアルの有効期限'),
                          ' :'
                        ),
                        _react2.default.createElement(
                          'p',
                          { style: { marginBottom: 10 } },
                          t('label:残りX日', { dates: user.left_days })
                        ),
                        user.account_admin && _react2.default.createElement(_button.Button, { primary: true, onClick: this.changePlan, label: t('label:プラン変更') })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: _helpButton2.default.helpButtonArea },
                        _react2.default.createElement('div', { className: _helpButton2.default.helpButtonGambaKun }),
                        _react2.default.createElement(
                          'div',
                          { className: _helpButton2.default.helpText },
                          t('label:アプリ名')
                        )
                      )
                    ),
                    _react2.default.createElement(_userSettingsPage2.default, null),
                    (groups || !isFetching) && children,
                    _react2.default.createElement(_liveChat2.default, null)
                  )
                )
              )
            )
          ),
          user && user.account_admin && user.trial && user.left_days == 0 && _react2.default.createElement(_confirmDialog2.default, { open: this.state.showTrialAlert, trialDatesMessage: true, centeredTitle: true,
            configBaseUrl: _config2.default.baseUrl,
            title: t('label:トライアル最終日です'),
            yesLabel: t('label:契約する'),
            noLabel: t('label:閉じる'),
            yesHref: _config2.default.baseUrl + 'v3/contract',
            onNo: this.closeAlertMessage }),
          _react2.default.createElement(_reactWebNotification2.default, {
            ignore: !this.state.title,
            title: this.state.title || '',
            timeout: 10000,
            onClick: this.state.onClick,
            onClose: this.onClose,
            options: {
              body: this.state.body,
              icon: this.state.icon,
              tag: this.state.tag
            } })
        )
      );
    }
  }]);

  return MainPage;
}(_react2.default.Component);

var RawMainPage = exports.RawMainPage = MainPage;
exports.default = (0, _mainPage2.default)(MainPage);

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/main-page.js

var _route = __webpack_require__(67);

var _reactRedux = __webpack_require__(11);

var _store = __webpack_require__(18);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _socketRsync = __webpack_require__(144);

var _socketRsync2 = _interopRequireDefault(_socketRsync);

var _reactI18next = __webpack_require__(2);

var _analytics = __webpack_require__(27);

var _loginHistory = __webpack_require__(882);

var _loginHistory2 = _interopRequireDefault(_loginHistory);

var _groupIdStore = __webpack_require__(341);

var _groupIdStore2 = _interopRequireDefault(_groupIdStore);

var _announceUnreadFlag = __webpack_require__(485);

var _announceUnreadFlag2 = _interopRequireDefault(_announceUnreadFlag);

var _windowFocus = __webpack_require__(904);

var _windowFocus2 = _interopRequireDefault(_windowFocus);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    organizations: (0, _store.stripArray)(state.organizations.items),
    groups: (0, _store.stripArray)(state.groups.items),
    isFetchingGroup: state.groups.isFetchingGroup,
    user: state.user.current,
    login: state.sessions.login,
    isFetching: state.organizations.isFetching || state.groups.isFetching || state.user.isFetching,
    isFetchFailed: state.organizations.isFetchFailed || state.groups.isFetchFailed || state.user.isFetchFailed,
    isPhone: state.media.isPhone,
    active: state.sidebar.open,
    pinned: state.media.isPhone ? false : state.sidebar.docked,
    routes: state.routes,
    access_token: state.sessions.access_token,
    announceDate: state.announce.latest,
    socketNotification: state.socket.items['notification'],
    socketChat: state.socket.items['chat'],
    userSettings: state.userSettings,
    rightSidePage: state.rightSidePage,
    likeConfig: state.likes.likeConfig,
    notificationSettings: state.user.notificationSettings,
    unreadChatCount: state.chatRooms.unreadCount
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, stateProps, dispatchProps, ownProps, {
    usersAdminUrl: _config2.default.baseUrl + 'v3/session/redirect?login=true&redirect_to=/v3/users&access_token=' + stateProps.access_token
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount(props) {
      dispatch(_actions2.default.closeAnnounce());
      if (!props.login) {
        var params = props.location && props.location.query || {};
        if (props.location && props.location.pathname != '/' && props.location.pathname != '/login') params.redirect = props.location.pathname;
        (0, _route.replaceRoute)('login', params);
      } else {
        dispatch(_actions2.default.fetchCurrentUser());
        dispatch(_actions2.default.fetchDivisions());
        dispatch(_actions2.default.fetchGroups());
        dispatch(_actions2.default.fetchOrganizations());
        dispatch(_actions2.default.fetchBuildNo());
        dispatch(_actions2.default.fetchLikeConfig());
        dispatch(_actions2.default.fetchBlockDiaries());
        dispatch(_actions2.default.fetchBlockUsers());
        dispatch(_actions2.default.fetchReviewSetting());
        dispatch(_actions2.default.fetchShowTimestampSetting());
        dispatch(_actions2.default.fetchNotificationSettings());
        dispatch(_actions2.default.fetchChatRoomUnreadCount('main-page'));
      }
      dispatch(_actions2.default.fetchProductTourState());
      if (props.params && props.params.division_id) dispatch(_actions2.default.setCurrentDivisionId(props.params.division_id));else if (props.params) dispatch(_actions2.default.setCurrentDivisionId(null));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (nextProps.user && nextProps.groups && (nextProps.location && nextProps.location.pathname == '/' || !(nextProps.routes instanceof Array) && nextProps.routes && (!nextProps.routes.name || nextProps.routes.name == 'main') || // スマホアプリの場合でかつ起動直後にのみ発火
      nextProps.params && nextProps.params.group_id && !(0, _store.getArray)('group_id', nextProps.groups, nextProps.params.group_id))) {
        dispatch(_actions2.default.closeSidebar());
        if (_route.directRoute && nextProps.location && nextProps.location.query && nextProps.location.query.redirect) {
          (0, _route.directRoute)(nextProps.location.query.redirect + '?' + (0, _map2.default)(nextProps.location.query, function (value, key) {
            return key != 'redirect' ? key + '=' + encodeURIComponent(value) : '';
          }).join('&'));
        } else if (nextProps.groups.length == 1) {
          (0, _route.replaceRoute)('group_timeline', { group_id: nextProps.groups[0].group_id });
        } else {
          _groupIdStore2.default.get(function (group_id) {
            if (group_id && (0, _store.getArray)('group_id', nextProps.groups, group_id)) {
              (0, _route.replaceRoute)('group_timeline', { group_id: group_id });
            } else {
              (0, _route.replaceRoute)('home_group');
            }
          });
        }
      }

      if (props.groups && nextProps.groups && nextProps.groups.length > props.groups.length && nextProps.active) {
        // this.props.groups よりも nextProps.groups の方が要素が増えている = 新規作成されたグループ
        // groupsの差分を計算し、新規作成したグループに遷移させる
        var thisIds = props.groups.map(function (group) {
          return group.group_id;
        });
        var nextIds = nextProps.groups.map(function (group) {
          return group.group_id;
        });
        var group_id = nextIds.filter(function (id) {
          return thisIds.indexOf(id) == -1;
        })[0];
        (0, _route.pushRoute)('group_timeline', { group_id: group_id });
      }

      // グループが削除されて0個になった場合、Web版の画面をHomeに切り替える
      if (nextProps.location && nextProps.location.pathname == '/' && !nextProps.isFetching && !nextProps.groups) {
        (0, _route.replaceRoute)('home_group');
        dispatch(_actions2.default.openSidebar());
      }

      /* gambaからのお知らせを最後にみた時刻(announce_last_seen_at)がnullか最新のお知らせ時刻(announceDate)よりも小さい場合はdispatch(actions.openAnnounce())が発火する*/
      if (!props.announceDate && nextProps.announceDate && nextProps.user && (!nextProps.user.announce_last_seen_at || nextProps.user.announce_last_seen_at < nextProps.announceDate)) {
        dispatch(_actions2.default.openAnnounce());
      }

      if (props.login && !nextProps.login) {
        (0, _route.pushRoute)('login');
      }

      if (!props.user && nextProps.user) {
        _loginHistory2.default.set(nextProps.user);
        (0, _analytics.setId)(nextProps.user.user_id, nextProps.user.account && nextProps.user.account.account_id);
        props.initializeSocket(nextProps.user);
      }
      if (props.params && props.params.division_id) dispatch(_actions2.default.setCurrentDivisionId(props.params.division_id));else if (props.params) dispatch(_actions2.default.setCurrentDivisionId(null));
    },

    willUnmount: function willUnmount(props) {
      (0, _analytics.setId)(undefined, undefined);
      dispatch(_actions2.default.clearDiaries());
      dispatch(_actions2.default.clearNotifications());
      dispatch(_actions2.default.clearAnnounce());
      dispatch(_actions2.default.clearChatRooms());
      dispatch(_actions2.default.clearChatMessages());
      dispatch(_actions2.default.clearChatRoomUnreadCount());
      dispatch(_actions2.default.openSidebar());
      props.destroySocket();
    },

    onOverlayClick: function onOverlayClick() {
      dispatch(_actions2.default.closeSidebar());
    },

    onOpen: function onOpen() {
      dispatch(_actions2.default.openSidebar());
    },

    closeRightSidePage: function closeRightSidePage() {
      return dispatch(_actions2.default.closeRightSidePage());
    },
    closeSidebar: function closeSidebar() {
      return dispatch(_actions2.default.closeSidebar());
    },

    requestSync: function requestSync(props) {
      dispatch(_actions2.default.fetchCurrentUser());
      dispatch(_actions2.default.fetchAnnounce());
      dispatch(_actions2.default.fetchBuildNo());
      dispatch(_actions2.default.fetchDivisions());
      dispatch(_actions2.default.fetchGroups());

      if (props.params && props.params.group_id) {
        dispatch(_actions2.default.fetchNotificationsUnreadCount(props.params.group_id));
        dispatch(_actions2.default.fetchGroupUnreadCount(props.params.group_id));
      }

      if (props.params && props.params.division_id) {
        dispatch(_actions2.default.fetchHomeNotificationsUnreadCount(props.params.division_id));
      } else {
        dispatch(_actions2.default.fetchHomeNotificationsUnreadCount());
      }
    },

    receiveSocket: function receiveSocket(message, message_type, props) {
      switch (message_type) {
        case 'diary':
        case 'diary_delete':
          dispatch(_actions2.default.loadGroupUnreadCount(message.group_id, message.unreads));
          break;
        case 'chat':
          if (message.chat && message.chat.user && message.chat.user.user_id && props.user && props.user.user_id && props.user.user_id != message.chat.user.user_id && props.rightSidePage && props.rightSidePage.name != "chat_messages") {
            if (props.notificationSettings && props.notificationSettings.others && (props.notificationSettings.others.notify_on_alert_display_to_chat == 'all' || props.notificationSettings.others.notify_on_alert_display_to_chat == 'mail')) {
              // show toast for new message
              if (props.notificationSettings.others.notify_on_alert_display_to_chat == 'all' || props.notificationSettings.others.notify_on_alert_display_to_chat == 'push')
                // it means to show the content of the message
                dispatch((0, _alertMessage.emitAlertMessage)((message.chat.user.name ? message.chat.user.name : '不明なユーザー') + ' : ' + (message.chat.message_text ? message.chat.message_text : ''), 'messageAlert'));else {
                // it means none or mail(view message only)
                dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:新着メッセージがあります', name: message.chat.user.name ? message.chat.user.name : '不明なユーザー' }, 'messageAlert'));
              }
            }
          }

          dispatch(_actions2.default.loadChatRoomUnreadCount(message.unread_count));
          break;
        case 'group':
          dispatch(_actions2.default.loadGroup(message.group));
          break;
        case 'group_delete':
          dispatch(_actions2.default.loadGroup(message.group, { deleted: true }));
          break;
        case 'division':
          dispatch(_actions2.default.reloadDivision(message.division));
          break;
        case 'division_delete':
          dispatch(_actions2.default.deleteDivisionCompleted(message));
          break;
      }
    },

    onRegister: function onRegister(token, type) {
      dispatch(_actions2.default.subscribeDeviceToken(token, type));
    },

    onNotification: function onNotification(notification) {
      /*
      notification = {
        foreground: false, // BOOLEAN: If the notification was received in foreground or not
        userInteraction: false, // BOOLEAN: If the notification was opened by the user from the notification area or not
        message: 'My Notification Message', // STRING: The notification message
        data: {}, // OBJECT: The push data
      } */

      var url = notification.url || notification.data && notification.data.body && notification.data.body.url;
      if (notification.foreground || !url) return;

      var paths = url.replace(/^.+groups\//, '').split('/');
      var kpi_id, diary_id, chat_room_id, match;
      var group_id = parseInt(paths[0]);
      if (paths.length == 2 && paths[1] == 'timeline') {
        (0, _route.pushRoute)('group_timeline', { group_id: group_id });
      } else if (paths.length == 4 && paths[2] == 'kpi_chart') {
        kpi_id = parseInt(paths[3]);
        dispatch(_actions2.default.openRightSidePage('kpi_chart', { group_id: group_id, kpi_id: kpi_id }));
      } else if (paths.length == 3 && (match = paths[2].match(/^pickup\?diary_ids=([0-9]+)$/))) {
        diary_id = parseInt(match[1]);
        dispatch(_actions2.default.openRightSidePage('pickup_diaries', { diary_ids: [diary_id] }));
      } else if (paths.length == 3 && paths[1] == 'messages') {
        chat_room_id = parseInt(paths[2]);
        dispatch(_actions2.default.openRightSidePage('chat_messages', { chat_room_id: chat_room_id, from: 'notification' }));
      } else if (paths.length == 2 && paths[1] == 'announces') {
        dispatch(_actions2.default.openRightSidePage('notifications', { group_id: 'home', tabIndex: 1 }));
      }
    },

    onWebNotification: function onWebNotification(type, notification) {
      if (type == 'notification') {
        switch (notification.category) {
          case 'group_profile_updated':
          case 'user_profile_updated':
            return dispatch(_actions2.default.openRightSidePage('group_members', { group_id: notification.group_id }));
          case 'kpi_updated':
            return dispatch(_actions2.default.openRightSidePage('kpi_chart', { kpi_id: notification.kpi_id, group_id: notification.group_id }));
          case 'diary_reported':
          case 'kpi_reported':
          case 'memo_reported':
          case 'diary_replied':
          default:
            if (notification.diary_id) dispatch(_actions2.default.openRightSidePage('pickup_diaries', { diary_ids: [notification.diary_id] }));
            return;
        }
      }
      if (type == 'chat') return dispatch(_actions2.default.openRightSidePage('chat_messages', { chat_room_id: notification.chat_room_id }));
    },

    onWindowFocus: function onWindowFocus(props) {
      return props.refreshSocket();
    },
    openUserSettingsPage: function openUserSettingsPage() {
      dispatch(_actions2.default.closeSidebar());
      dispatch(_actions2.default.openUserSettingsPage());
    },

    logout: function logout() {
      return dispatch(_actions2.default.logout(false));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), _socketRsync.provideRsync, (0, _socketRsync2.default)('diary', 'diary_delete', 'chat', 'group', 'group_delete', 'division', 'division_delete'), (0, _reactI18next.translate)(), _lifecycle2.default, _windowFocus2.default);

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var url = __webpack_require__(1849);
var parser = __webpack_require__(480);
var Manager = __webpack_require__(895);
var debug = __webpack_require__(344)('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  } else if (opts && 'object' === typeof opts.query) {
    opts.query = encodeQueryString(opts.query);
  }
  return io.socket(parsed.path, opts);
}
/**
 *  Helper method to parse query objects to string.
 * @param {object} query
 * @returns {string}
 */
function encodeQueryString (obj) {
  var str = [];
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }
  return str.join('&');
}
/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = __webpack_require__(895);
exports.Socket = __webpack_require__(484);


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module dependencies.
 */

var parseuri = __webpack_require__(892);
var debug = __webpack_require__(344)('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || global.location;
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug.debug = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1851);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting
    args = exports.formatArgs.apply(self, args);

    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 1851 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1853);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  return ('WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  return JSON.stringify(v);
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}
  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1854);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = Array.prototype.slice.call(arguments);

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    if ('function' === typeof exports.formatArgs) {
      args = exports.formatArgs.apply(self, args);
    }
    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 1854 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options){
  options = options || {};
  if ('string' == typeof val) return parse(val);
  return options.long
    ? long(val)
    : short(val);
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = '' + str;
  if (str.length > 10000) return;
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) return;
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function short(ms) {
  if (ms >= d) return Math.round(ms / d) + 'd';
  if (ms >= h) return Math.round(ms / h) + 'h';
  if (ms >= m) return Math.round(ms / m) + 'm';
  if (ms >= s) return Math.round(ms / s) + 's';
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function long(ms) {
  return plural(ms, d, 'day')
    || plural(ms, h, 'hour')
    || plural(ms, m, 'minute')
    || plural(ms, s, 'second')
    || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) return;
  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
;(function () {
  // Detect the `define` function exposed by asynchronous module loaders. The
  // strict `define` check is necessary for compatibility with `r.js`.
  var isLoader = "function" === "function" && __webpack_require__(893);

  // A set of types used to distinguish objects from primitives.
  var objectTypes = {
    "function": true,
    "object": true
  };

  // Detect the `exports` object exposed by CommonJS implementations.
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  // Use the `global` object exposed by Node (including Browserify via
  // `insert-module-globals`), Narwhal, and Ringo as the default context,
  // and the `window` object in browsers. Rhino exports a `global` function
  // instead.
  var root = objectTypes[typeof window] && window || this,
      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;

  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
    root = freeGlobal;
  }

  // Public: Initializes JSON 3 using the given `context` object, attaching the
  // `stringify` and `parse` functions to the specified `exports` object.
  function runInContext(context, exports) {
    context || (context = root["Object"]());
    exports || (exports = root["Object"]());

    // Native constructor aliases.
    var Number = context["Number"] || root["Number"],
        String = context["String"] || root["String"],
        Object = context["Object"] || root["Object"],
        Date = context["Date"] || root["Date"],
        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
        TypeError = context["TypeError"] || root["TypeError"],
        Math = context["Math"] || root["Math"],
        nativeJSON = context["JSON"] || root["JSON"];

    // Delegate to the native `stringify` and `parse` implementations.
    if (typeof nativeJSON == "object" && nativeJSON) {
      exports.stringify = nativeJSON.stringify;
      exports.parse = nativeJSON.parse;
    }

    // Convenience aliases.
    var objectProto = Object.prototype,
        getClass = objectProto.toString,
        isProperty, forEach, undef;

    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
    var isExtended = new Date(-3509827334573292);
    try {
      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
      // results for certain dates in Opera >= 10.53.
      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
        // Safari < 2.0.2 stores the internal millisecond time value correctly,
        // but clips the values returned by the date methods to the range of
        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
    } catch (exception) {}

    // Internal: Determines whether the native `JSON.stringify` and `parse`
    // implementations are spec-compliant. Based on work by Ken Snyder.
    function has(name) {
      if (has[name] !== undef) {
        // Return cached feature test result.
        return has[name];
      }
      var isSupported;
      if (name == "bug-string-char-index") {
        // IE <= 7 doesn't support accessing string characters using square
        // bracket notation. IE 8 only supports this for primitives.
        isSupported = "a"[0] != "a";
      } else if (name == "json") {
        // Indicates whether both `JSON.stringify` and `JSON.parse` are
        // supported.
        isSupported = has("json-stringify") && has("json-parse");
      } else {
        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
        // Test `JSON.stringify`.
        if (name == "json-stringify") {
          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
          if (stringifySupported) {
            // A test function object with a custom `toJSON` method.
            (value = function () {
              return 1;
            }).toJSON = value;
            try {
              stringifySupported =
                // Firefox 3.1b1 and b2 serialize string, number, and boolean
                // primitives as object literals.
                stringify(0) === "0" &&
                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
                // literals.
                stringify(new Number()) === "0" &&
                stringify(new String()) == '""' &&
                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
                // does not define a canonical JSON representation (this applies to
                // objects with `toJSON` properties as well, *unless* they are nested
                // within an object or array).
                stringify(getClass) === undef &&
                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
                // FF 3.1b3 pass this test.
                stringify(undef) === undef &&
                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
                // respectively, if the value is omitted entirely.
                stringify() === undef &&
                // FF 3.1b1, 2 throw an error if the given value is not a number,
                // string, array, object, Boolean, or `null` literal. This applies to
                // objects with custom `toJSON` methods as well, unless they are nested
                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
                // methods entirely.
                stringify(value) === "1" &&
                stringify([value]) == "[1]" &&
                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
                // `"[null]"`.
                stringify([undef]) == "[null]" &&
                // YUI 3.0.0b1 fails to serialize `null` literals.
                stringify(null) == "null" &&
                // FF 3.1b1, 2 halts serialization if an array contains a function:
                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
                // elides non-JSON values from objects and arrays, unless they
                // define custom `toJSON` methods.
                stringify([undef, getClass, null]) == "[null,null,null]" &&
                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
                // where character escape codes are expected (e.g., `\b` => `\u0008`).
                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
                stringify(null, value) === "1" &&
                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
                // serialize extended years.
                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
                // The milliseconds are optional in ES 5, but required in 5.1.
                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
                // four-digit years instead of six-digit years. Credits: @Yaffle.
                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
                // values less than 1000. Credits: @Yaffle.
                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
            } catch (exception) {
              stringifySupported = false;
            }
          }
          isSupported = stringifySupported;
        }
        // Test `JSON.parse`.
        if (name == "json-parse") {
          var parse = exports.parse;
          if (typeof parse == "function") {
            try {
              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
              // Conforming implementations should also coerce the initial argument to
              // a string prior to parsing.
              if (parse("0") === 0 && !parse(false)) {
                // Simple parsing test.
                value = parse(serialized);
                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
                if (parseSupported) {
                  try {
                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
                    parseSupported = !parse('"\t"');
                  } catch (exception) {}
                  if (parseSupported) {
                    try {
                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
                      // certain octal literals.
                      parseSupported = parse("01") !== 1;
                    } catch (exception) {}
                  }
                  if (parseSupported) {
                    try {
                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
                      // points. These environments, along with FF 3.1b1 and 2,
                      // also allow trailing commas in JSON objects and arrays.
                      parseSupported = parse("1.") !== 1;
                    } catch (exception) {}
                  }
                }
              }
            } catch (exception) {
              parseSupported = false;
            }
          }
          isSupported = parseSupported;
        }
      }
      return has[name] = !!isSupported;
    }

    if (!has("json")) {
      // Common `[[Class]]` name aliases.
      var functionClass = "[object Function]",
          dateClass = "[object Date]",
          numberClass = "[object Number]",
          stringClass = "[object String]",
          arrayClass = "[object Array]",
          booleanClass = "[object Boolean]";

      // Detect incomplete support for accessing string characters by index.
      var charIndexBuggy = has("bug-string-char-index");

      // Define additional utility methods if the `Date` methods are buggy.
      if (!isExtended) {
        var floor = Math.floor;
        // A mapping between the months of the year and the number of days between
        // January 1st and the first of the respective month.
        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        // Internal: Calculates the number of days between the Unix epoch and the
        // first day of the given month.
        var getDay = function (year, month) {
          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
        };
      }

      // Internal: Determines if a property is a direct property of the given
      // object. Delegates to the native `Object#hasOwnProperty` method.
      if (!(isProperty = objectProto.hasOwnProperty)) {
        isProperty = function (property) {
          var members = {}, constructor;
          if ((members.__proto__ = null, members.__proto__ = {
            // The *proto* property cannot be set multiple times in recent
            // versions of Firefox and SeaMonkey.
            "toString": 1
          }, members).toString != getClass) {
            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
            // supports the mutable *proto* property.
            isProperty = function (property) {
              // Capture and break the object's prototype chain (see section 8.6.2
              // of the ES 5.1 spec). The parenthesized expression prevents an
              // unsafe transformation by the Closure Compiler.
              var original = this.__proto__, result = property in (this.__proto__ = null, this);
              // Restore the original prototype chain.
              this.__proto__ = original;
              return result;
            };
          } else {
            // Capture a reference to the top-level `Object` constructor.
            constructor = members.constructor;
            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
            // other environments.
            isProperty = function (property) {
              var parent = (this.constructor || constructor).prototype;
              return property in this && !(property in parent && this[property] === parent[property]);
            };
          }
          members = null;
          return isProperty.call(this, property);
        };
      }

      // Internal: Normalizes the `for...in` iteration algorithm across
      // environments. Each enumerated key is yielded to a `callback` function.
      forEach = function (object, callback) {
        var size = 0, Properties, members, property;

        // Tests for bugs in the current environment's `for...in` algorithm. The
        // `valueOf` property inherits the non-enumerable flag from
        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
        (Properties = function () {
          this.valueOf = 0;
        }).prototype.valueOf = 0;

        // Iterate over a new instance of the `Properties` class.
        members = new Properties();
        for (property in members) {
          // Ignore all properties inherited from `Object.prototype`.
          if (isProperty.call(members, property)) {
            size++;
          }
        }
        Properties = members = null;

        // Normalize the iteration algorithm.
        if (!size) {
          // A list of non-enumerable properties inherited from `Object.prototype`.
          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
          // properties.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, length;
            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
            for (property in object) {
              // Gecko <= 1.0 enumerates the `prototype` property of functions under
              // certain conditions; IE does not.
              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
                callback(property);
              }
            }
            // Manually invoke the callback for each non-enumerable property.
            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
          };
        } else if (size == 2) {
          // Safari <= 2.0.4 enumerates shadowed properties twice.
          forEach = function (object, callback) {
            // Create a set of iterated properties.
            var members = {}, isFunction = getClass.call(object) == functionClass, property;
            for (property in object) {
              // Store each property name to prevent double enumeration. The
              // `prototype` property of functions is not enumerated due to cross-
              // environment inconsistencies.
              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
                callback(property);
              }
            }
          };
        } else {
          // No bugs detected; use the standard `for...in` algorithm.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
            for (property in object) {
              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
                callback(property);
              }
            }
            // Manually invoke the callback for the `constructor` property due to
            // cross-environment inconsistencies.
            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
              callback(property);
            }
          };
        }
        return forEach(object, callback);
      };

      // Public: Serializes a JavaScript `value` as a JSON string. The optional
      // `filter` argument may specify either a function that alters how object and
      // array members are serialized, or an array of strings and numbers that
      // indicates which properties should be serialized. The optional `width`
      // argument may be either a string or number that specifies the indentation
      // level of the output.
      if (!has("json-stringify")) {
        // Internal: A map of control characters and their escaped equivalents.
        var Escapes = {
          92: "\\\\",
          34: '\\"',
          8: "\\b",
          12: "\\f",
          10: "\\n",
          13: "\\r",
          9: "\\t"
        };

        // Internal: Converts `value` into a zero-padded string such that its
        // length is at least equal to `width`. The `width` must be <= 6.
        var leadingZeroes = "000000";
        var toPaddedString = function (width, value) {
          // The `|| 0` expression is necessary to work around a bug in
          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
          return (leadingZeroes + (value || 0)).slice(-width);
        };

        // Internal: Double-quotes a string `value`, replacing all ASCII control
        // characters (characters with code unit values between 0 and 31) with
        // their escaped equivalents. This is an implementation of the
        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
        var unicodePrefix = "\\u00";
        var quote = function (value) {
          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
          for (; index < length; index++) {
            var charCode = value.charCodeAt(index);
            // If the character is a control character, append its Unicode or
            // shorthand escape sequence; otherwise, append the character as-is.
            switch (charCode) {
              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
                result += Escapes[charCode];
                break;
              default:
                if (charCode < 32) {
                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
                  break;
                }
                result += useCharIndex ? symbols[index] : value.charAt(index);
            }
          }
          return result + '"';
        };

        // Internal: Recursively serializes an object. Implements the
        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
          try {
            // Necessary for host object support.
            value = object[property];
          } catch (exception) {}
          if (typeof value == "object" && value) {
            className = getClass.call(value);
            if (className == dateClass && !isProperty.call(value, "toJSON")) {
              if (value > -1 / 0 && value < 1 / 0) {
                // Dates are serialized according to the `Date#toJSON` method
                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
                // for the ISO 8601 date time string format.
                if (getDay) {
                  // Manually compute the year, month, date, hours, minutes,
                  // seconds, and milliseconds if the `getUTC*` methods are
                  // buggy. Adapted from @Yaffle's `date-shim` project.
                  date = floor(value / 864e5);
                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
                  date = 1 + date - getDay(year, month);
                  // The `time` value specifies the time within the day (see ES
                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
                  // to compute `A modulo B`, as the `%` operator does not
                  // correspond to the `modulo` operation for negative numbers.
                  time = (value % 864e5 + 864e5) % 864e5;
                  // The hours, minutes, seconds, and milliseconds are obtained by
                  // decomposing the time within the day. See section 15.9.1.10.
                  hours = floor(time / 36e5) % 24;
                  minutes = floor(time / 6e4) % 60;
                  seconds = floor(time / 1e3) % 60;
                  milliseconds = time % 1e3;
                } else {
                  year = value.getUTCFullYear();
                  month = value.getUTCMonth();
                  date = value.getUTCDate();
                  hours = value.getUTCHours();
                  minutes = value.getUTCMinutes();
                  seconds = value.getUTCSeconds();
                  milliseconds = value.getUTCMilliseconds();
                }
                // Serialize extended years correctly.
                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
                  // Months, dates, hours, minutes, and seconds should have two
                  // digits; milliseconds should have three.
                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
                  // Milliseconds are optional in ES 5.0, but required in 5.1.
                  "." + toPaddedString(3, milliseconds) + "Z";
              } else {
                value = null;
              }
            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
              // ignores all `toJSON` methods on these objects unless they are
              // defined directly on an instance.
              value = value.toJSON(property);
            }
          }
          if (callback) {
            // If a replacement function was provided, call it to obtain the value
            // for serialization.
            value = callback.call(object, property, value);
          }
          if (value === null) {
            return "null";
          }
          className = getClass.call(value);
          if (className == booleanClass) {
            // Booleans are represented literally.
            return "" + value;
          } else if (className == numberClass) {
            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
            // `"null"`.
            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
          } else if (className == stringClass) {
            // Strings are double-quoted and escaped.
            return quote("" + value);
          }
          // Recursively serialize objects and arrays.
          if (typeof value == "object") {
            // Check for cyclic structures. This is a linear search; performance
            // is inversely proportional to the number of unique nested objects.
            for (length = stack.length; length--;) {
              if (stack[length] === value) {
                // Cyclic structures cannot be serialized by `JSON.stringify`.
                throw TypeError();
              }
            }
            // Add the object to the stack of traversed objects.
            stack.push(value);
            results = [];
            // Save the current indentation level and indent one additional level.
            prefix = indentation;
            indentation += whitespace;
            if (className == arrayClass) {
              // Recursively serialize array elements.
              for (index = 0, length = value.length; index < length; index++) {
                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
                results.push(element === undef ? "null" : element);
              }
              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
            } else {
              // Recursively serialize object members. Members are selected from
              // either a user-specified list of property names, or the object
              // itself.
              forEach(properties || value, function (property) {
                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
                if (element !== undef) {
                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
                  // is not the empty string, let `member` {quote(property) + ":"}
                  // be the concatenation of `member` and the `space` character."
                  // The "`space` character" refers to the literal space
                  // character, not the `space` {width} argument provided to
                  // `JSON.stringify`.
                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
                }
              });
              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
            }
            // Remove the object from the traversed object stack.
            stack.pop();
            return result;
          }
        };

        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
        exports.stringify = function (source, filter, width) {
          var whitespace, callback, properties, className;
          if (objectTypes[typeof filter] && filter) {
            if ((className = getClass.call(filter)) == functionClass) {
              callback = filter;
            } else if (className == arrayClass) {
              // Convert the property names array into a makeshift set.
              properties = {};
              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
            }
          }
          if (width) {
            if ((className = getClass.call(width)) == numberClass) {
              // Convert the `width` to an integer and create a string containing
              // `width` number of space characters.
              if ((width -= width % 1) > 0) {
                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
              }
            } else if (className == stringClass) {
              whitespace = width.length <= 10 ? width : width.slice(0, 10);
            }
          }
          // Opera <= 7.54u2 discards the values associated with empty string keys
          // (`""`) only if they are used directly within an object member list
          // (e.g., `!("" in { "": 1})`).
          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
        };
      }

      // Public: Parses a JSON source string.
      if (!has("json-parse")) {
        var fromCharCode = String.fromCharCode;

        // Internal: A map of escaped control characters and their unescaped
        // equivalents.
        var Unescapes = {
          92: "\\",
          34: '"',
          47: "/",
          98: "\b",
          116: "\t",
          110: "\n",
          102: "\f",
          114: "\r"
        };

        // Internal: Stores the parser state.
        var Index, Source;

        // Internal: Resets the parser state and throws a `SyntaxError`.
        var abort = function () {
          Index = Source = null;
          throw SyntaxError();
        };

        // Internal: Returns the next token, or `"$"` if the parser has reached
        // the end of the source string. A token may be a string, number, `null`
        // literal, or Boolean literal.
        var lex = function () {
          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
          while (Index < length) {
            charCode = source.charCodeAt(Index);
            switch (charCode) {
              case 9: case 10: case 13: case 32:
                // Skip whitespace tokens, including tabs, carriage returns, line
                // feeds, and space characters.
                Index++;
                break;
              case 123: case 125: case 91: case 93: case 58: case 44:
                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
                // the current position.
                value = charIndexBuggy ? source.charAt(Index) : source[Index];
                Index++;
                return value;
              case 34:
                // `"` delimits a JSON string; advance to the next character and
                // begin parsing the string. String tokens are prefixed with the
                // sentinel `@` character to distinguish them from punctuators and
                // end-of-string tokens.
                for (value = "@", Index++; Index < length;) {
                  charCode = source.charCodeAt(Index);
                  if (charCode < 32) {
                    // Unescaped ASCII control characters (those with a code unit
                    // less than the space character) are not permitted.
                    abort();
                  } else if (charCode == 92) {
                    // A reverse solidus (`\`) marks the beginning of an escaped
                    // control character (including `"`, `\`, and `/`) or Unicode
                    // escape sequence.
                    charCode = source.charCodeAt(++Index);
                    switch (charCode) {
                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
                        // Revive escaped control characters.
                        value += Unescapes[charCode];
                        Index++;
                        break;
                      case 117:
                        // `\u` marks the beginning of a Unicode escape sequence.
                        // Advance to the first character and validate the
                        // four-digit code point.
                        begin = ++Index;
                        for (position = Index + 4; Index < position; Index++) {
                          charCode = source.charCodeAt(Index);
                          // A valid sequence comprises four hexdigits (case-
                          // insensitive) that form a single hexadecimal value.
                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
                            // Invalid Unicode escape sequence.
                            abort();
                          }
                        }
                        // Revive the escaped character.
                        value += fromCharCode("0x" + source.slice(begin, Index));
                        break;
                      default:
                        // Invalid escape sequence.
                        abort();
                    }
                  } else {
                    if (charCode == 34) {
                      // An unescaped double-quote character marks the end of the
                      // string.
                      break;
                    }
                    charCode = source.charCodeAt(Index);
                    begin = Index;
                    // Optimize for the common case where a string is valid.
                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
                      charCode = source.charCodeAt(++Index);
                    }
                    // Append the string as-is.
                    value += source.slice(begin, Index);
                  }
                }
                if (source.charCodeAt(Index) == 34) {
                  // Advance to the next character and return the revived string.
                  Index++;
                  return value;
                }
                // Unterminated string.
                abort();
              default:
                // Parse numbers and literals.
                begin = Index;
                // Advance past the negative sign, if one is specified.
                if (charCode == 45) {
                  isSigned = true;
                  charCode = source.charCodeAt(++Index);
                }
                // Parse an integer or floating-point value.
                if (charCode >= 48 && charCode <= 57) {
                  // Leading zeroes are interpreted as octal literals.
                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
                    // Illegal octal literal.
                    abort();
                  }
                  isSigned = false;
                  // Parse the integer component.
                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
                  // Floats cannot contain a leading decimal point; however, this
                  // case is already accounted for by the parser.
                  if (source.charCodeAt(Index) == 46) {
                    position = ++Index;
                    // Parse the decimal component.
                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal trailing decimal.
                      abort();
                    }
                    Index = position;
                  }
                  // Parse exponents. The `e` denoting the exponent is
                  // case-insensitive.
                  charCode = source.charCodeAt(Index);
                  if (charCode == 101 || charCode == 69) {
                    charCode = source.charCodeAt(++Index);
                    // Skip past the sign following the exponent, if one is
                    // specified.
                    if (charCode == 43 || charCode == 45) {
                      Index++;
                    }
                    // Parse the exponential component.
                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal empty exponent.
                      abort();
                    }
                    Index = position;
                  }
                  // Coerce the parsed value to a JavaScript number.
                  return +source.slice(begin, Index);
                }
                // A negative sign may only precede numbers.
                if (isSigned) {
                  abort();
                }
                // `true`, `false`, and `null` literals.
                if (source.slice(Index, Index + 4) == "true") {
                  Index += 4;
                  return true;
                } else if (source.slice(Index, Index + 5) == "false") {
                  Index += 5;
                  return false;
                } else if (source.slice(Index, Index + 4) == "null") {
                  Index += 4;
                  return null;
                }
                // Unrecognized token.
                abort();
            }
          }
          // Return the sentinel `$` character if the parser has reached the end
          // of the source string.
          return "$";
        };

        // Internal: Parses a JSON `value` token.
        var get = function (value) {
          var results, hasMembers;
          if (value == "$") {
            // Unexpected end of input.
            abort();
          }
          if (typeof value == "string") {
            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
              // Remove the sentinel `@` character.
              return value.slice(1);
            }
            // Parse object and array literals.
            if (value == "[") {
              // Parses a JSON array, returning a new JavaScript array.
              results = [];
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing square bracket marks the end of the array literal.
                if (value == "]") {
                  break;
                }
                // If the array literal contains elements, the current token
                // should be a comma separating the previous element from the
                // next.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "]") {
                      // Unexpected trailing `,` in array literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each array element.
                    abort();
                  }
                }
                // Elisions and leading commas are not permitted.
                if (value == ",") {
                  abort();
                }
                results.push(get(value));
              }
              return results;
            } else if (value == "{") {
              // Parses a JSON object, returning a new JavaScript object.
              results = {};
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing curly brace marks the end of the object literal.
                if (value == "}") {
                  break;
                }
                // If the object literal contains members, the current token
                // should be a comma separator.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "}") {
                      // Unexpected trailing `,` in object literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each object member.
                    abort();
                  }
                }
                // Leading commas are not permitted, object property names must be
                // double-quoted strings, and a `:` must separate each property
                // name and value.
                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
                  abort();
                }
                results[value.slice(1)] = get(lex());
              }
              return results;
            }
            // Unexpected token encountered.
            abort();
          }
          return value;
        };

        // Internal: Updates a traversed object member.
        var update = function (source, property, callback) {
          var element = walk(source, property, callback);
          if (element === undef) {
            delete source[property];
          } else {
            source[property] = element;
          }
        };

        // Internal: Recursively traverses a parsed JSON object, invoking the
        // `callback` function for each value. This is an implementation of the
        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
        var walk = function (source, property, callback) {
          var value = source[property], length;
          if (typeof value == "object" && value) {
            // `forEach` can't be used to traverse an array in Opera <= 8.54
            // because its `Object#hasOwnProperty` implementation returns `false`
            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
            if (getClass.call(value) == arrayClass) {
              for (length = value.length; length--;) {
                update(value, length, callback);
              }
            } else {
              forEach(value, function (property) {
                update(value, property, callback);
              });
            }
          }
          return callback.call(source, property, value);
        };

        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
        exports.parse = function (source, callback) {
          var result, value;
          Index = 0;
          Source = "" + source;
          result = get(lex());
          // If a JSON string contains multiple tokens, it is invalid.
          if (lex() != "$") {
            abort();
          }
          // Reset the parser state.
          Index = Source = null;
          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
        };
      }
    }

    exports["runInContext"] = runInContext;
    return exports;
  }

  if (freeExports && !isLoader) {
    // Export for CommonJS environments.
    runInContext(root, freeExports);
  } else {
    // Export for web browsers and JavaScript engines.
    var nativeJSON = root.JSON,
        previousJSON = root["JSON3"],
        isRestored = false;

    var JSON3 = runInContext(root, (root["JSON3"] = {
      // Public: Restores the original value of the global `JSON` object and
      // returns a reference to the `JSON3` object.
      "noConflict": function () {
        if (!isRestored) {
          isRestored = true;
          root.JSON = nativeJSON;
          root["JSON3"] = previousJSON;
          nativeJSON = previousJSON = null;
        }
        return JSON3;
      }
    }));

    root.JSON = {
      "parse": JSON3.parse,
      "stringify": JSON3.stringify
    };
  }

  // Export for asynchronous module loaders.
  if (isLoader) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return JSON3;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module), __webpack_require__(24)))

/***/ }),
/* 1856 */
/***/ (function(module, exports) {


/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks[event] = this._callbacks[event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  var self = this;
  this._callbacks = this._callbacks || {};

  function on() {
    self.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks[event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks[event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks[event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks[event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = __webpack_require__(1858);
var isBuf = __webpack_require__(894);

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet){
  var buffers = [];
  var packetData = packet.data;

  function _deconstructPacket(data) {
    if (!data) return data;

    if (isBuf(data)) {
      var placeholder = { _placeholder: true, num: buffers.length };
      buffers.push(data);
      return placeholder;
    } else if (isArray(data)) {
      var newData = new Array(data.length);
      for (var i = 0; i < data.length; i++) {
        newData[i] = _deconstructPacket(data[i]);
      }
      return newData;
    } else if ('object' == typeof data && !(data instanceof Date)) {
      var newData = {};
      for (var key in data) {
        newData[key] = _deconstructPacket(data[key]);
      }
      return newData;
    }
    return data;
  }

  var pack = packet;
  pack.data = _deconstructPacket(packetData);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  var curPlaceHolder = 0;

  function _reconstructPacket(data) {
    if (data && data._placeholder) {
      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
      return buf;
    } else if (isArray(data)) {
      for (var i = 0; i < data.length; i++) {
        data[i] = _reconstructPacket(data[i]);
      }
      return data;
    } else if (data && 'object' == typeof data) {
      for (var key in data) {
        data[key] = _reconstructPacket(data[key]);
      }
      return data;
    }
    return data;
  }

  packet.data = _reconstructPacket(packet.data);
  packet.attachments = undefined; // no longer useful
  return packet;
};

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((global.Blob && obj instanceof Blob) ||
        (global.File && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1858 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(1860);


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(1861);

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = __webpack_require__(225);


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var transports = __webpack_require__(896);
var Emitter = __webpack_require__(267);
var debug = __webpack_require__(346)('engine.io-client:socket');
var index = __webpack_require__(900);
var parser = __webpack_require__(225);
var parseuri = __webpack_require__(892);
var parsejson = __webpack_require__(1876);
var parseqs = __webpack_require__(483);

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (global.location && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (global.location ? location.hostname : 'localhost');
  this.port = opts.port || (global.location && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // other options for Node.js client
  var freeGlobal = typeof global === 'object' && global;
  if (freeGlobal.global === freeGlobal) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = __webpack_require__(482);
Socket.transports = __webpack_require__(896);
Socket.parser = __webpack_require__(225);

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    agent: this.agent,
    hostname: this.hostname,
    port: this.port,
    secure: this.secure,
    path: this.path,
    query: query,
    forceJSONP: this.forceJSONP,
    jsonp: this.jsonp,
    forceBase64: this.forceBase64,
    enablesXDR: this.enablesXDR,
    timestampRequests: this.timestampRequests,
    timestampParam: this.timestampParam,
    policyPort: this.policyPort,
    socket: this,
    pfx: this.pfx,
    key: this.key,
    passphrase: this.passphrase,
    cert: this.cert,
    ca: this.ca,
    ciphers: this.ciphers,
    rejectUnauthorized: this.rejectUnauthorized,
    perMessageDeflate: this.perMessageDeflate,
    extraHeaders: this.extraHeaders,
    forceNode: this.forceNode,
    localAddress: this.localAddress
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(parsejson(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1862 */
/***/ (function(module, exports) {


/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module requirements.
 */

var XMLHttpRequest = __webpack_require__(481);
var Polling = __webpack_require__(897);
var Emitter = __webpack_require__(267);
var inherit = __webpack_require__(345);
var debug = __webpack_require__(346)('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;

  if (global.location) {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = opts.hostname !== global.location.hostname ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  } else {
    this.extraHeaders = opts.extraHeaders;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}
    if (this.supportsBinary) {
      // This has to be done after open because Firefox is stupid
      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
      xhr.responseType = 'arraybuffer';
    }

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (global.document) {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (global.document) {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      if (!this.supportsBinary) {
        data = this.xhr.responseText;
      } else {
        try {
          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
        } catch (e) {
          var ui8Arr = new Uint8Array(this.xhr.response);
          var dataArray = [];
          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
            dataArray.push(ui8Arr[idx]);
          }

          data = String.fromCharCode.apply(null, dataArray);
        }
      }
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (global.document) {
  if (global.attachEvent) {
    global.attachEvent('onunload', unloadHandler);
  } else if (global.addEventListener) {
    global.addEventListener('beforeunload', unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1864 */
/***/ (function(module, exports) {


/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};


/***/ }),
/* 1865 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1866 */
/***/ (function(module, exports) {

/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};


/***/ }),
/* 1867 */
/***/ (function(module, exports) {

module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/wtf8 v1.0.0 by @mathias */
;(function(root) {

	// Detect free variables `exports`
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function wtf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte.
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read the first byte.
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			var byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid WTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function wtf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	var wtf8 = {
		'version': '1.0.0',
		'encode': wtf8encode,
		'decode': wtf8decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return wtf8;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = wtf8;
		} else { // in Narwhal or RingoJS v0.7.0-
			var object = {};
			var hasOwnProperty = object.hasOwnProperty;
			for (var key in wtf8) {
				hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.wtf8 = wtf8;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module), __webpack_require__(24)))

/***/ }),
/* 1869 */
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = global.BlobBuilder
  || global.WebKitBlobBuilder
  || global.MSBlobBuilder
  || global.MozBlobBuilder;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  for (var i = 0; i < ary.length; i++) {
    var chunk = ary[i];
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      ary[i] = buf;
    }
  }
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary);

  for (var i = 0; i < ary.length; i++) {
    bb.append(ary[i]);
  }

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  mapArrayBufferViews(ary);
  return new Blob(ary, options || {});
};

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug.debug = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1872);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting
    args = exports.formatArgs.apply(self, args);

    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 1872 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module requirements.
 */

var Polling = __webpack_require__(897);
var inherit = __webpack_require__(345);

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    if (!global.___eio) global.___eio = [];
    callbacks = global.___eio;
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (global.document && global.addEventListener) {
    global.addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var Transport = __webpack_require__(482);
var parser = __webpack_require__(225);
var parseqs = __webpack_require__(483);
var inherit = __webpack_require__(345);
var yeast = __webpack_require__(899);
var debug = __webpack_require__(346)('engine.io-client:websocket');
var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
var NodeWebSocket;
if (typeof window === 'undefined') {
  try {
    NodeWebSocket = __webpack_require__(1875);
  } catch (e) { }
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocket = BrowserWebSocket;
if (!WebSocket && typeof window === 'undefined') {
  WebSocket = NodeWebSocket;
}

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  if (!this.usingBrowserWebSocket) {
    WebSocket = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = void (0);
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1875 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * JSON parse.
 *
 * @see Based on jQuery#parseJSON (MIT) and JSON2
 * @api private
 */

var rvalidchars = /^[\],:{}\s]*$/;
var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
var rtrimLeft = /^\s+/;
var rtrimRight = /\s+$/;

module.exports = function parsejson(data) {
  if ('string' != typeof data || !data) {
    return null;
  }

  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');

  // Attempt to parse using the native JSON parser first
  if (global.JSON && JSON.parse) {
    return JSON.parse(data);
  }

  if (rvalidchars.test(data.replace(rvalidescape, '@')
      .replace(rvalidtokens, ']')
      .replace(rvalidbraces, ''))) {
    return (new Function('return ' + data))();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 1877 */
/***/ (function(module, exports) {

module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}


/***/ }),
/* 1878 */
/***/ (function(module, exports) {


/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};



/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _list = __webpack_require__(25);

var _leftSidebarUser = __webpack_require__(1880);

var _leftSidebarUser2 = _interopRequireDefault(_leftSidebarUser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeftSideBarUser(props) {
  var t = props.t,
      user = props.user,
      openUserSettingsPage = props.openUserSettingsPage;


  return _react2.default.createElement(
    _list.List,
    { theme: _leftSidebarUser2.default },
    _react2.default.createElement(_list.ListItem, { selectable: true,
      theme: _leftSidebarUser2.default,
      avatar: user && user.icon_image.thumb_url,
      caption: user && user.name || '',
      leftIcon: !user && "account_circle" || '',
      onClick: openUserSettingsPage })
  );
}
// src/web/components/left-sidebar-user.jsx

exports.default = (0, _reactI18next.translate)()(LeftSideBarUser);

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1881);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./left-sidebar-user.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./left-sidebar-user.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.left-sidebar-user--list--MeiE0mLB {\n  padding-top: 0;\n  padding-bottom: 0;\n  background: rgba(191, 0, 0, .85);\n}\n\n.left-sidebar-user--item--2mlg24wz {\n  color: #FFF;\n  min-height: 46px;\n}\n\n.left-sidebar-user--itemAction--1duZ9ESd {\n  margin: 0 4px 0 0;\n}\n\n.left-sidebar-user--itemContentRoot--12Y5u-Kh {\n  min-width: 140px;\n}\n\n.left-sidebar-user--item--2mlg24wz.left-sidebar-user--selectable--1p6_SISp:hover {\n  background-color: rgba(255, 255, 255, .3)!important;\n}\n\n.left-sidebar-user--itemText--1WOcmkCv {\n  color: #FFF!important;\n  font-weight: bold;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-left: 12px;\n}\n\n/* スマホ表示用のスタイル追加 */\n\n@media screen and (max-width: 768px) {\n  .left-sidebar-user--list--MeiE0mLB {\n    background: #ffffff;\n  }\n\n  .left-sidebar-user--item--2mlg24wz {\n    color: #555555;\n  }\n\n  .left-sidebar-user--item--2mlg24wz.left-sidebar-user--selectable--1p6_SISp:hover {\n    background-color: rgba(0, 0, 0, .05)!important;\n  }\n\n  .left-sidebar-user--itemText--1WOcmkCv {\n    color: #555555!important;\n  }\n}", "", {"version":3,"sources":["/./src/web/components/themes/left-sidebar-user.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iCAAiC;CAClC;;AAED;EACE,YAAY;EACZ,iBAAiB;CAClB;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,oDAAoD;CACrD;;AAED;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;CACnB;;AAED,mBAAmB;;AAEnB;EACE;IACE,oBAAoB;GACrB;;EAED;IACE,eAAe;GAChB;;EAED;IACE,+CAA+C;GAChD;;EAED;IACE,yBAAyB;GAC1B;CACF","file":"left-sidebar-user.css","sourcesContent":["\n.list {\n  padding-top: 0;\n  padding-bottom: 0;\n  background: rgba(191, 0, 0, .85);\n}\n\n.item {\n  color: #FFF;\n  min-height: 46px;\n}\n\n.itemAction {\n  margin: 0 4px 0 0;\n}\n\n.itemContentRoot {\n  min-width: 140px;\n}\n\n.item.selectable:hover {\n  background-color: rgba(255, 255, 255, .3)!important;\n}\n\n.itemText {\n  color: #FFF!important;\n  font-weight: bold;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-left: 12px;\n}\n\n/* スマホ表示用のスタイル追加 */\n\n@media screen and (max-width: 768px) {\n  .list {\n    background: #ffffff;\n  }\n\n  .item {\n    color: #555555;\n  }\n\n  .item.selectable:hover {\n    background-color: rgba(0, 0, 0, .05)!important;\n  }\n\n  .itemText {\n    color: #555555!important;\n  }\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"list": "left-sidebar-user--list--MeiE0mLB",
	"item": "left-sidebar-user--item--2mlg24wz",
	"itemAction": "left-sidebar-user--itemAction--1duZ9ESd",
	"itemContentRoot": "left-sidebar-user--itemContentRoot--12Y5u-Kh",
	"selectable": "left-sidebar-user--selectable--1p6_SISp",
	"itemText": "left-sidebar-user--itemText--1WOcmkCv"
};

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuDivider = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuDivider = function MenuDivider(_ref) {
  var theme = _ref.theme;
  return _react2.default.createElement('hr', { 'data-react-toolbox': 'menu-divider', className: theme.menuDivider });
};

MenuDivider.propTypes = {
  theme: _propTypes2.default.shape({
    menuDivider: _propTypes2.default.string
  })
};

exports.default = (0, _reactCssThemr.themr)(_identifiers.MENU)(MenuDivider);
exports.MenuDivider = MenuDivider;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.time = exports.prefixer = exports.events = undefined;

var _utils = __webpack_require__(106);

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

var _events = __webpack_require__(143);

var _events2 = _interopRequireDefault(_events);

var _prefixer = __webpack_require__(336);

var _prefixer2 = _interopRequireDefault(_prefixer);

var _time = __webpack_require__(145);

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { events: _events2.default, prefixer: _prefixer2.default, time: _time2.default };
exports.events = _events2.default;
exports.prefixer = _prefixer2.default;
exports.time = _time2.default;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasOwnProperty;
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconMenu = exports.iconMenuFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _IconButton = __webpack_require__(338);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Menu = __webpack_require__(906);

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(IconButton, Menu) {
  var IconMenu = function (_Component) {
    _inherits(IconMenu, _Component);

    function IconMenu() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, IconMenu);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconMenu.__proto__ || Object.getPrototypeOf(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: false
      }, _this.handleButtonClick = function (event) {
        _this.setState({ active: !_this.state.active });
        if (_this.props.onClick) _this.props.onClick(event);
      }, _this.handleMenuHide = function () {
        _this.setState({ active: false });
        if (_this.props.onHide) _this.props.onHide();
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(IconMenu, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            className = _props.className,
            icon = _props.icon,
            iconRipple = _props.iconRipple,
            inverse = _props.inverse,
            menuRipple = _props.menuRipple,
            onHide = _props.onHide,
            onSelect = _props.onSelect,
            onShow = _props.onShow,
            position = _props.position,
            selectable = _props.selectable,
            selected = _props.selected,
            theme = _props.theme,
            other = _objectWithoutProperties(_props, ['children', 'className', 'icon', 'iconRipple', 'inverse', 'menuRipple', 'onHide', 'onSelect', 'onShow', 'position', 'selectable', 'selected', 'theme']);

        return _react2.default.createElement(
          'div',
          _extends({}, other, { className: (0, _classnames2.default)(theme.iconMenu, className) }),
          _react2.default.createElement(IconButton, {
            className: theme.icon,
            icon: icon,
            inverse: inverse,
            onClick: this.handleButtonClick,
            ripple: iconRipple
          }),
          _react2.default.createElement(
            Menu,
            {
              active: this.state.active,
              onHide: this.handleMenuHide,
              onSelect: onSelect,
              onShow: onShow,
              position: position,
              ripple: menuRipple,
              selectable: selectable,
              selected: selected,
              theme: theme
            },
            children
          )
        );
      }
    }]);

    return IconMenu;
  }(_react.Component);

  IconMenu.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    iconRipple: _propTypes2.default.bool,
    menuRipple: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    onHide: _propTypes2.default.func,
    onSelect: _propTypes2.default.func,
    onShow: _propTypes2.default.func,
    position: _propTypes2.default.string,
    selectable: _propTypes2.default.bool,
    selected: _propTypes2.default.node,
    theme: _propTypes2.default.shape({
      icon: _propTypes2.default.string,
      iconMenu: _propTypes2.default.string
    })
  };
  IconMenu.defaultProps = {
    className: '',
    icon: 'more_vert',
    iconRipple: true,
    menuRipple: true,
    position: 'auto',
    selectable: false
  };


  return IconMenu;
};

var IconMenu = factory(_IconButton2.default, _Menu2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.MENU)(IconMenu);
exports.iconMenuFactory = factory;
exports.IconMenu = IconMenu;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1887);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--iconMenu--17vYVaXn {\n  display: inline-block;\n  position: relative;\n  text-align: center;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--iconMenu--17vYVaXn *,\n    .theme--iconMenu--17vYVaXn *::after,\n    .theme--iconMenu--17vYVaXn *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--iconMenu--17vYVaXn .theme--icon--1w7r1T2s {\n  cursor: pointer;\n}\n.theme--menu--3hyPJBlU {\n  display: inline-block;\n  position: relative\n}\n.theme--menu--3hyPJBlU.theme--topLeft--1epwpkmT {\n  left: 0;\n  position: absolute;\n  top: 0;\n}\n.theme--menu--3hyPJBlU.theme--topLeft--1epwpkmT > .theme--outline--LKDMtdOY {\n  -webkit-transform-origin: 0 0;\n          transform-origin: 0 0;\n}\n.theme--menu--3hyPJBlU.theme--topRight--3M_ZcN5W {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.theme--menu--3hyPJBlU.theme--topRight--3M_ZcN5W > .theme--outline--LKDMtdOY {\n  -webkit-transform-origin: 100% 0;\n          transform-origin: 100% 0;\n}\n.theme--menu--3hyPJBlU.theme--bottomLeft--1twSKsX7 {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n}\n.theme--menu--3hyPJBlU.theme--bottomLeft--1twSKsX7 > .theme--outline--LKDMtdOY {\n  -webkit-transform-origin: 0 100%;\n          transform-origin: 0 100%;\n}\n.theme--menu--3hyPJBlU.theme--bottomRight--1y-5zIli {\n  bottom: 0;\n  position: absolute;\n  right: 0;\n}\n.theme--menu--3hyPJBlU.theme--bottomRight--1y-5zIli > .theme--outline--LKDMtdOY {\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n.theme--menu--3hyPJBlU:not(.theme--static--1Z2ShK0W) {\n  pointer-events: none;\n  z-index: 200;\n}\n.theme--menu--3hyPJBlU:not(.theme--static--1Z2ShK0W) > .theme--outline--LKDMtdOY {\n  opacity: 0;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  transition:\n        opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n        -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  transition:\n        transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n        opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition:\n        transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n        opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n        -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: transform;\n}\n.theme--menu--3hyPJBlU:not(.theme--static--1Z2ShK0W) > .theme--menuInner--ODk2trJl {\n  left: 0;\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n}\n.theme--menu--3hyPJBlU:not(.theme--static--1Z2ShK0W).theme--rippled--Op3PYVe7:not(.theme--active--2pxLPeEE) > .theme--outline--LKDMtdOY {\n  transition-delay: 0.3s;\n}\n.theme--menu--3hyPJBlU:not(.theme--static--1Z2ShK0W).theme--rippled--Op3PYVe7:not(.theme--active--2pxLPeEE) > .theme--menuInner--ODk2trJl {\n  transition-delay: 0.3s;\n}\n.theme--menu--3hyPJBlU:not(.theme--static--1Z2ShK0W).theme--active--2pxLPeEE {\n  pointer-events: all;\n}\n.theme--menu--3hyPJBlU:not(.theme--static--1Z2ShK0W).theme--active--2pxLPeEE > .theme--outline--LKDMtdOY {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.theme--menu--3hyPJBlU:not(.theme--static--1Z2ShK0W).theme--active--2pxLPeEE > .theme--menuInner--ODk2trJl {\n  opacity: 1;\n  transition:\n          opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n          clip 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.theme--outline--LKDMtdOY {\n  background-color: rgb(255, 255, 255);\n  border-radius: 2px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n  display: block;\n  left: 0;\n  position: absolute;\n  top: 0;\n}\n.theme--menuInner--ODk2trJl {\n  display: block;\n  list-style: none;\n  padding: 8px 0;\n  position: relative;\n  text-align: left;\n  white-space: nowrap;\n}\n.theme--menuItem--2Nt8Pel8 {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: rgb(33, 33, 33);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 16px;\n  height: 48px;\n  overflow: hidden;\n  padding: 0 16px;\n  position: relative\n}\n.theme--menuItem--2Nt8Pel8:not(.theme--disabled--3XzLwv-o):hover {\n  background-color: rgb(238, 238, 238);\n  cursor: pointer;\n}\n.theme--menuItem--2Nt8Pel8.theme--disabled--3XzLwv-o {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.theme--menuItem--2Nt8Pel8.theme--selected--3bW0yRji {\n  background-color: transparent;\n  font-weight: 500;\n}\n.theme--menuItem--2Nt8Pel8 .theme--ripple--7B-cHeKo {\n  color: rgb(117, 117, 117);\n}\n.theme--menuItem--2Nt8Pel8 .theme--icon--1w7r1T2s {\n  font-size: 24px;\n  width: 38.4px;\n}\n.theme--caption--1y1NdStt {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  font-size: 16px;\n}\n.theme--shortcut--1dTRdqLv {\n  margin-left: 16px;\n}\n.theme--menuDivider--RWcVZPDe {\n  background-color: rgb(238, 238, 238);\n  border: 0;\n  display: block;\n  height: 1px;\n  margin: 12px 0;\n  outline: 0;\n  padding: 0;\n  width: 100%;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/menu/theme.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,gBAAgB;CACjB;AACD;EACE,sBAAsB;EACtB,kBAAkB;CACnB;AACD;EACE,QAAQ;EACR,mBAAmB;EACnB,OAAO;CACR;AACD;EACE,8BAA8B;UACtB,sBAAsB;CAC/B;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,OAAO;CACR;AACD;EACE,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,UAAU;EACV,QAAQ;EACR,mBAAmB;CACpB;AACD;EACE,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,UAAU;EACV,mBAAmB;EACnB,SAAS;CACV;AACD;EACE,oCAAoC;UAC5B,4BAA4B;CACrC;AACD;EACE,qBAAqB;EACrB,aAAa;CACd;AACD;EACE,WAAW;EACX,4BAA4B;UACpB,oBAAoB;EAC5B;;4DAE0D;EAC1D;;kDAEgD;EAChD;;;4DAG0D;EAC1D,uBAAuB;CACxB;AACD;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,OAAO;CACR;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;EACX,4BAA4B;UACpB,oBAAoB;CAC7B;AACD;EACE,WAAW;EACX;;iDAE+C;CAChD;AACD;EACE,qCAAqC;EACrC,mBAAmB;EACnB;;mCAEiC;EACjC,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,OAAO;CACR;AACD;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,gBAAgB;CACjB;AACD;EACE,aAAa;EACb,qBAAqB;CACtB;AACD;EACE,8BAA8B;EAC9B,iBAAiB;CAClB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,gBAAgB;EAChB,cAAc;CACf;AACD;EACE,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;EACrB,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,UAAU;EACV,eAAe;EACf,YAAY;EACZ,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;CACb","file":"theme.css","sourcesContent":[".iconMenu {\n  display: inline-block;\n  position: relative;\n  text-align: center;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.iconMenu *,\n    .iconMenu *::after,\n    .iconMenu *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.iconMenu .icon {\n  cursor: pointer;\n}\n.menu {\n  display: inline-block;\n  position: relative\n}\n.menu.topLeft {\n  left: 0;\n  position: absolute;\n  top: 0;\n}\n.menu.topLeft > .outline {\n  -webkit-transform-origin: 0 0;\n          transform-origin: 0 0;\n}\n.menu.topRight {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.menu.topRight > .outline {\n  -webkit-transform-origin: 100% 0;\n          transform-origin: 100% 0;\n}\n.menu.bottomLeft {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n}\n.menu.bottomLeft > .outline {\n  -webkit-transform-origin: 0 100%;\n          transform-origin: 0 100%;\n}\n.menu.bottomRight {\n  bottom: 0;\n  position: absolute;\n  right: 0;\n}\n.menu.bottomRight > .outline {\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n.menu:not(.static) {\n  pointer-events: none;\n  z-index: 200;\n}\n.menu:not(.static) > .outline {\n  opacity: 0;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  transition:\n        opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n        -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  transition:\n        transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n        opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition:\n        transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n        opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n        -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: transform;\n}\n.menu:not(.static) > .menuInner {\n  left: 0;\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n}\n.menu:not(.static).rippled:not(.active) > .outline {\n  transition-delay: 0.3s;\n}\n.menu:not(.static).rippled:not(.active) > .menuInner {\n  transition-delay: 0.3s;\n}\n.menu:not(.static).active {\n  pointer-events: all;\n}\n.menu:not(.static).active > .outline {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.menu:not(.static).active > .menuInner {\n  opacity: 1;\n  transition:\n          opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n          clip 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.outline {\n  background-color: rgb(255, 255, 255);\n  border-radius: 2px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n  display: block;\n  left: 0;\n  position: absolute;\n  top: 0;\n}\n.menuInner {\n  display: block;\n  list-style: none;\n  padding: 8px 0;\n  position: relative;\n  text-align: left;\n  white-space: nowrap;\n}\n.menuItem {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: rgb(33, 33, 33);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 16px;\n  height: 48px;\n  overflow: hidden;\n  padding: 0 16px;\n  position: relative\n}\n.menuItem:not(.disabled):hover {\n  background-color: rgb(238, 238, 238);\n  cursor: pointer;\n}\n.menuItem.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.menuItem.selected {\n  background-color: transparent;\n  font-weight: 500;\n}\n.menuItem .ripple {\n  color: rgb(117, 117, 117);\n}\n.menuItem .icon {\n  font-size: 24px;\n  width: 38.4px;\n}\n.caption {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  font-size: 16px;\n}\n.shortcut {\n  margin-left: 16px;\n}\n.menuDivider {\n  background-color: rgb(238, 238, 238);\n  border: 0;\n  display: block;\n  height: 1px;\n  margin: 12px 0;\n  outline: 0;\n  padding: 0;\n  width: 100%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"iconMenu": "theme--iconMenu--17vYVaXn",
	"icon": "theme--icon--1w7r1T2s",
	"menu": "theme--menu--3hyPJBlU",
	"topLeft": "theme--topLeft--1epwpkmT",
	"outline": "theme--outline--LKDMtdOY",
	"topRight": "theme--topRight--3M_ZcN5W",
	"bottomLeft": "theme--bottomLeft--1twSKsX7",
	"bottomRight": "theme--bottomRight--1y-5zIli",
	"static": "theme--static--1Z2ShK0W",
	"menuInner": "theme--menuInner--ODk2trJl",
	"rippled": "theme--rippled--Op3PYVe7",
	"active": "theme--active--2pxLPeEE",
	"menuItem": "theme--menuItem--2Nt8Pel8",
	"disabled": "theme--disabled--3XzLwv-o",
	"selected": "theme--selected--3bW0yRji",
	"ripple": "theme--ripple--7B-cHeKo",
	"caption": "theme--caption--1y1NdStt",
	"shortcut": "theme--shortcut--1dTRdqLv",
	"menuDivider": "theme--menuDivider--RWcVZPDe"
};

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawLeftSidebar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _leftSidebar = __webpack_require__(1891);

var _leftSidebar2 = _interopRequireDefault(_leftSidebar);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _list = __webpack_require__(25);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _leftSidebarGroupList = __webpack_require__(1892);

var _leftSidebarGroupList2 = _interopRequireDefault(_leftSidebarGroupList);

var _groupCreatePage = __webpack_require__(1900);

var _groupCreatePage2 = _interopRequireDefault(_groupCreatePage);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _leftSidebarGroupListItem = __webpack_require__(347);

var _leftSidebarGroupListItem2 = _interopRequireDefault(_leftSidebarGroupListItem);

var _warningIcon = __webpack_require__(1997);

var _warningIcon2 = _interopRequireDefault(_warningIcon);

var _noScrollbar = __webpack_require__(498);

var _noScrollbar2 = _interopRequireDefault(_noScrollbar);

var _analytics = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/left-sidebar.jsx

var LeftSidebar = function (_PureComponent) {
  _inherits(LeftSidebar, _PureComponent);

  function LeftSidebar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LeftSidebar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeftSidebar.__proto__ || Object.getPrototypeOf(LeftSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onCreateGroup = function () {
      if (_this.props.user && _this.props.user.group_creatable) {
        _this.props.updateUI({ active: true });
      }
    }, _this.onClose = function () {
      return _this.props.updateUI({ active: false });
    }, _this.selectHome = function () {
      return _this.props.selectGroup('home', _this.props);
    }, _this.onAnnounceClick = function () {
      return _this.props.openAnnouncePage();
    }, _this.onEmailConfirmClick = function () {
      return _this.setState({ emailConfirm: !_this.state.emailConfirm });
    }, _this.requestConfirmationMail = function () {
      _this.setState({ emailConfirm: false });
      _this.props.requestConfirmationMail();
    }, _this.onReloadClick = function () {
      return _this.setState({ reloadNeeded: !_this.state.reloadNeeded });
    }, _this.onReload = function () {
      location.reload(true);
    }, _this.activateZendesk = function () {
      return zE.activate({ hideOnClose: true });
    }, _this.openHelpPage = function () {
      window.open('https://support.getgamba.com/hc/ja');
      (0, _analytics.track)('open_help');
    }, _this.onSortGroup = function () {
      return _this.props.updateUI({ sortActive: true });
    }, _this.onSortGroupClose = function () {
      return _this.props.updateUI({ sortActive: false });
    }, _this.onFilter = function () {
      return _this.props.updateUI({ isFilter: !_this.props.ui.isFilter });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LeftSidebar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          organizations = _props.organizations,
          MemberGroups = _props.MemberGroups,
          publicOtherGroups = _props.publicOtherGroups,
          groups = _props.groups,
          divisions = _props.divisions,
          user = _props.user,
          group_id = _props.group_id,
          currentDivisionId = _props.currentDivisionId,
          selectGroup = _props.selectGroup,
          selectDivision = _props.selectDivision,
          selectOrganization = _props.selectOrganization,
          openUserSettingsPage = _props.openUserSettingsPage,
          openSortGroup = _props.openSortGroup,
          onSearchChange = _props.onSearchChange,
          updateUI = _props.updateUI,
          reloadNeeded = _props.reloadNeeded,
          routes = _props.routes,
          latest = _props.latest,
          close = _props.close,
          unreadGroupsCount = _props.unreadGroupsCount,
          unreadGroups = _props.unreadGroups,
          menuItems = _props.menuItems,
          expandDivision = _props.expandDivision,
          collapseDivision = _props.collapseDivision,
          expandedDivisions = _props.expandedDivisions,
          expandDivisionNotSetGroup = _props.expandDivisionNotSetGroup,
          canExpandDivNotSetGroup = _props.canExpandDivNotSetGroup,
          selectDivisionNotSetGroup = _props.selectDivisionNotSetGroup;


      return _react2.default.createElement(
        'div',
        { className: _noScrollbar2.default.noScrollBar },
        (!close || user && user.unconfirmed || groups && groups.length > 1 || reloadNeeded) && _react2.default.createElement(
          _list.List,
          { selectable: true, theme: _leftSidebarGroupListItem2.default },
          reloadNeeded && _react2.default.createElement(_list.ListItem, { leftIcon: _react2.default.createElement(_font_icon2.default, { value: 'warning', className: _warningIcon2.default.warning }),
            theme: _leftSidebarGroupListItem2.default,
            caption: t('label:更新が必要です'),
            onClick: this.onReloadClick }),
          !close && _react2.default.createElement(_list.ListItem, { leftIcon: _react2.default.createElement(_font_icon2.default, { value: 'error', className: _warningIcon2.default.warning }),
            theme: _leftSidebarGroupListItem2.default,
            caption: t('label:お知らせがあります'),
            onClick: this.onAnnounceClick }),
          user && user.unconfirmed && _react2.default.createElement(_list.ListItem, { leftIcon: _react2.default.createElement(_font_icon2.default, { value: 'warning', style: { color: '#FFCC00' } }),
            theme: _leftSidebarGroupListItem2.default,
            caption: t('label:メールアドレスを確認してください'),
            onClick: this.onEmailConfirmClick }),
          groups && groups.length > 1 && _react2.default.createElement(_list.ListItem, { leftIcon: 'home',
            className: group_id == 'home' && 'active' || '',
            theme: _leftSidebarGroupListItem2.default,
            caption: t('label:すべてのグループ'),
            onClick: this.selectHome,
            rightActions: unreadGroupsCount && [_react2.default.createElement(
              'span',
              { key: 'count', className: _leftSidebarGroupListItem2.default.unreadCount },
              unreadGroupsCount < 10 ? unreadGroupsCount : '10+'
            )] || [] })
        ),
        _react2.default.createElement(_leftSidebarGroupList2.default, { t: t, labelText: ui.isFilter ? t('label:Section(unread)') : t('label:Section'),
          isFilter: ui.isFilter,
          onFilter: this.onFilter,
          currentGroupId: group_id,
          currentDivisionId: currentDivisionId,
          groups: MemberGroups,
          divisions: divisions,
          unreadGroups: unreadGroups,
          menuItems: menuItems,
          otherGroups: publicOtherGroups,
          selectGroup: selectGroup,
          selectDivision: selectDivision,
          onCreateGroup: this.props.user && this.props.user.group_creatable && this.onCreateGroup,
          onSearchChange: onSearchChange,
          openSortGroup: openSortGroup,
          expandDivision: expandDivision,
          collapseDivision: collapseDivision,
          expandedDivisions: expandedDivisions,
          expandDivisionNotSetGroup: expandDivisionNotSetGroup,
          canExpandDivNotSetGroup: canExpandDivNotSetGroup,
          selectDivisionNotSetGroup: selectDivisionNotSetGroup
        }),
        _react2.default.createElement(_groupCreatePage2.default, { active: ui.active, onClose: this.onClose }),
        _react2.default.createElement(_confirmDialog2.default, { open: this.state.reloadNeeded,
          title: t('label:更新が必要です'),
          description: t('label:サービスが更新されています'),
          yesLabel: t('label:更新する'),
          noLabel: t('label:閉じる'),
          onYes: this.onReload,
          onNo: this.onReloadClick }),
        _react2.default.createElement(_confirmDialog2.default, { open: this.state.emailConfirm,
          title: t('label:メールアドレスの確認が完了していません'),
          description: t('label:メールアドレスの確認を行ってください'),
          yesLabel: t('label:確認メール再送'),
          noLabel: t('label:閉じる'),
          onYes: this.requestConfirmationMail,
          onNo: this.onEmailConfirmClick })
      );
    }
  }]);

  return LeftSidebar;
}(_pureComponent2.default);

var RawLeftSidebar = exports.RawLeftSidebar = LeftSidebar;
exports.default = (0, _leftSidebar2.default)(LeftSidebar);

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(766),
    noop = __webpack_require__(1890),
    setToArray = __webpack_require__(436);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1890 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/left-sidebar.js

var _reactRedux = __webpack_require__(11);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _route = __webpack_require__(67);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _reduce = __webpack_require__(160);

var _reduce2 = _interopRequireDefault(_reduce);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactI18next = __webpack_require__(2);

var _store = __webpack_require__(18);

var _groupIdStore = __webpack_require__(341);

var _groupIdStore2 = _interopRequireDefault(_groupIdStore);

var _saveSearchQueryTemp = __webpack_require__(488);

var _saveSearchQueryTemp2 = _interopRequireDefault(_saveSearchQueryTemp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    search: state.groups.search,
    organizations: state.organizations.items,
    groups: state.groups.items,
    divisions: state.divisions.items,
    user: state.user.current,
    active: state.sidebar.open,
    reloadNeeded: state.buildNo.reloadNeeded,
    routes: state.routes,
    isSaving: state.savedDiaries.isPosting,
    chatUnreadCount: state.chatRooms.unreadCount,
    latest: state.announce.latest,
    close: state.announce.close,
    currentDivisionId: state.divisions.currentId,
    menuItems: state.menus.items,
    userMenuItems: state.user && state.user.current ? state.user.current.menu_items : null,
    expandedDivisions: state.menus.expandedDivisions,
    canExpandDivNotSetGroup: state.menus.canExpandDivNotSetGroup
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var groups = stateProps.groups;
  var divisions = stateProps.divisions;

  if (stateProps.search) groups = (0, _filter2.default)(groups, function (group) {
    return !group.is_free_group || group.name.indexOf(stateProps.search) > -1;
  });
  divisions = (0, _filter2.default)(divisions, function (division) {
    if (division.name.indexOf(stateProps.search || '') > -1) {
      return division;
    }
    var divisionGroups = division.groups.filter(function (group) {
      return group.name.indexOf(stateProps.search || '') <= -1;
    });
    groups = groups.filter(function (group) {
      return divisionGroups.filter(function (g) {
        return g.name == group.name;
      }).length === 0;
    });
    return division;
  });

  var memberGroups = (0, _filter2.default)(groups, function (group) {
    return group.is_member || group.favorite;
  });

  var unreadGroupsCount = (0, _reduce2.default)(memberGroups, function (sum, group) {
    if (group.unreadCount > 0) {
      sum += group.unreadCount;
    }
    return sum;
  }, 0);

  var unreadGroups = (0, _filter2.default)(memberGroups, function (group) {
    return group.unreadCount > 0 && group;
  });

  var otherGroups = (0, _filter2.default)(groups, function (group) {
    return group.can_read && !group.is_member && !group.favorite;
  });

  return _extends({}, stateProps, dispatchProps, ownProps, {
    MemberGroups: (0, _store.stripArray)(memberGroups),
    publicOtherGroups: (0, _store.stripArray)(otherGroups),
    unreadGroupsCount: unreadGroupsCount,
    unreadGroups: unreadGroups,
    divisions: divisions
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    selectGroup: function selectGroup(group_id, props) {
      if (props && props.isSaving) return; // 一時保存中はグループ切り替えを禁止
      dispatch(_actions2.default.closeSidebar());
      if (group_id == 'home') {
        _groupIdStore2.default.clear();
        (0, _route.pushRoute)('home_group');
      } else {
        _groupIdStore2.default.set(group_id);
        (0, _route.pushRoute)('group_timeline', { group_id: group_id });
      }
    },
    selectDivision: function selectDivision(division_id, props) {
      if (props && props.isSaving) return; // 一時保存中はグループ切り替えを禁止
      dispatch(_actions2.default.closeSidebar());
      _groupIdStore2.default.clear();
      (0, _route.pushRoute)('division_group', { division_id: division_id });
    },
    selectDivisionNotSetGroup: function selectDivisionNotSetGroup(division_id, props) {
      if (props && props.isSaving) return; // 一時保存中はグループ切り替えを禁止
      dispatch(_actions2.default.closeSidebar());
      _groupIdStore2.default.clear();
      if (division_id === 'new') {
        (0, _route.pushRoute)('division_not_set_group', { division_id: division_id });
      }
    },

    selectOrganization: function selectOrganization(organization_id) {
      dispatch(_actions2.default.closeSidebar());
      dispatch(_actions2.default.closeRightSidePage());
      dispatch(_actions2.default.clearDiaries());
      (0, _route.pushRoute)('organization', { organization_id: organization_id });
    },

    onSearchChange: function onSearchChange(query) {
      dispatch(_actions2.default.searchGroups(query));
    },

    openUserSettingsPage: function openUserSettingsPage() {
      dispatch(_actions2.default.closeSidebar());
      dispatch(_actions2.default.openUserSettingsPage());
    },
    openSortGroup: function openSortGroup() {
      return dispatch(_actions2.default.openUserSettingsPage('groupSorting'));
    },

    openSidebar: function openSidebar() {
      return dispatch(_actions2.default.openSidebar());
    },

    openAnnouncePage: function openAnnouncePage() {
      return dispatch(_actions2.default.openRightSidePage('notifications', { group_id: 'home', tabIndex: 1, from: 'announceButton' }));
    },

    closeSidebar: function closeSidebar() {
      return dispatch(_actions2.default.closeSidebar());
    },

    closeAnnounce: function closeAnnounce() {
      return dispatch(_actions2.default.closeAnnounce());
    },

    openAnnounce: function openAnnounce() {
      return dispatch(_actions2.default.openAnnounce());
    },

    requestConfirmationMail: function requestConfirmationMail() {
      return dispatch(_actions2.default.requestConfirmationMail());
    },

    openChatRooms: function openChatRooms() {
      return dispatch(_actions2.default.openRightSidePage('chat_rooms', { from: 'chatButton' }));
    },

    didMount: function didMount(props) {
      dispatch(_actions2.default.initMenus(props.userMenuItems, props.divisions, props.groups));
    },

    willMount: function willMount(props) {
      dispatch(_actions2.default.initMenus(props.userMenuItems, props.divisions, props.groups));
    },

    willUpdate: function willUpdate(props, nextProps) {
      // Filter the userMenuItems array with type "group" to get user's groups
      var user_groups = (nextProps.userMenuItems || []).filter(function (item) {
        return item.type == 'group';
      });
      if (user_groups.length > 0 && nextProps.menuItems.length == 0 || !_lodash2.default.isEqual(props.divisions, nextProps.divisions) || !_lodash2.default.isEqual(props.groups, nextProps.groups)) dispatch(_actions2.default.initMenus(nextProps.userMenuItems, nextProps.divisions, nextProps.groups));
      if (!_lodash2.default.isEqual(props.menuItems, nextProps.menuItems)) dispatch(_actions2.default.updateUserMenuItems(nextProps.menuItems));
    },

    expandDivision: function expandDivision(division_id) {
      dispatch(_actions2.default.expandDivision(division_id));
    },
    collapseDivision: function collapseDivision(division_id) {
      dispatch(_actions2.default.collapseDivision(division_id));
    },
    expandDivisionNotSetGroup: function expandDivisionNotSetGroup() {
      dispatch(_actions2.default.expandDivisionNotSetGroup());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: {
    active: false,
    isFilter: false
  } }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _list = __webpack_require__(25);

var _button = __webpack_require__(8);

var _compactInput = __webpack_require__(178);

var _compactInput2 = _interopRequireDefault(_compactInput);

var _compactList = __webpack_require__(489);

var _compactList2 = _interopRequireDefault(_compactList);

var _leftSidebarGroupListItem = __webpack_require__(347);

var _leftSidebarGroupListItem2 = _interopRequireDefault(_leftSidebarGroupListItem);

var _cardTitleRightActions = __webpack_require__(910);

var _cardTitleRightActions2 = _interopRequireDefault(_cardTitleRightActions);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _logo = __webpack_require__(490);

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton); // src/web/components/left-sidebar-group-list.jsx

function LeftSidebarGroupList(props) {
  var onSelectGroup = function onSelectGroup(group_id) {
    props.ui.searchInput && props.updateUI({ searchInput: false }), props.onSearchChange('');
    props.selectGroup && props.selectGroup(group_id);
  };
  var onSelectDivision = function onSelectDivision(division_id) {
    props.ui.searchInput && props.updateUI({ searchInput: false }), props.onSearchChange('');
    props.selectDivision && props.selectDivision(division_id), props.expandDivision(division_id);
  };
  var onSelectDivisionNotSetGroup = function onSelectDivisionNotSetGroup(division_id) {
    props.ui.searchInput && props.updateUI({ searchInput: false }), props.onSearchChange('');
    props.selectDivisionNotSetGroup && props.selectDivisionNotSetGroup(division_id);
    props.expandDivisionNotSetGroup && !props.canExpandDivNotSetGroup && props.expandDivisionNotSetGroup();
  };
  var t = props.t,
      ui = props.ui,
      currentGroupId = props.currentGroupId,
      currentDivisionId = props.currentDivisionId,
      groups = props.groups,
      divisions = props.divisions,
      otherGroups = props.otherGroups,
      labelText = props.labelText,
      selectGroup = props.selectGroup,
      selectDivision = props.selectDivision,
      onSearchChange = props.onSearchChange,
      onCreateGroup = props.onCreateGroup,
      onSortGroup = props.onSortGroup,
      openSortGroup = props.openSortGroup,
      updateUI = props.updateUI,
      isFilter = props.isFilter,
      onFilter = props.onFilter,
      unreadGroups = props.unreadGroups,
      menuItems = props.menuItems,
      expandDivision = props.expandDivision,
      collapseDivision = props.collapseDivision,
      expandedDivisions = props.expandedDivisions,
      expandDivisionNotSetGroup = props.expandDivisionNotSetGroup,
      canExpandDivNotSetGroup = props.canExpandDivNotSetGroup,
      selectDivisionNotSetGroup = props.selectDivisionNotSetGroup;


  var visibleGroups = isFilter ? unreadGroups || [] : groups || [];
  var groupsOnSet = visibleGroups.filter(function (item) {
    return !item.is_free_group;
  });
  var groupsNotSet = visibleGroups.filter(function (item) {
    return item.is_free_group && (item.is_member || item.favorite);
  });
  var totalDivision = menuItems.filter(function (menuItem) {
    var subGroupsId = menuItems.filter(function (menu) {
      return menu.type == 'group' && menu.parent_id == menuItem.item_id;
    }).map(function (menu) {
      return menu.item_id;
    });
    var hasSubMenu = groupsOnSet.find(function (group) {
      return subGroupsId.includes(group.group_id);
    });
    return menuItem.type == 'division' && hasSubMenu;
  }).length;

  return _react2.default.createElement(
    _list.List,
    { selectable: true, theme: _compactList2.default },
    _react2.default.createElement(_list.ListSubHeader, { caption: !ui.searchInput && _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
          'div',
          null,
          labelText
        ),
        (onSearchChange || onCreateGroup) && _react2.default.createElement(
          'div',
          { style: { marginLeft: 'auto' } },
          _react2.default.createElement(TooltipIconButton, { tooltip: t("label:未読のみ表示"), icon: isFilter ? "filter_alt" : "filter_alt_off", onClick: onFilter, style: { background: isFilter && "rgb(170, 170, 170, 0.5)" } }),
          _react2.default.createElement(TooltipIconButton, { tooltip: t('label:並べ替え'), icon: 'swap_vert', onClick: openSortGroup }),
          onCreateGroup && _react2.default.createElement(TooltipIconButton, { tooltip: t('label:グループ新規作成'), icon: 'add_circle_outline', onClick: onCreateGroup }),
          _react2.default.createElement(TooltipIconButton, { tooltip: t('label:セクション/グループ名を検索'), icon: 'search', onClick: function onClick() {
              return updateUI({ searchInput: true });
            } })
        )
      ) || _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(_compactInput2.default, { type: 'text', className: 'fluid',
          hasFocus: true,
          onChange: onSearchChange }),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: 'auto' } },
          _react2.default.createElement(_button.IconButton, { icon: 'close', onClick: function onClick() {
              updateUI({ searchInput: false });onSearchChange('');
            } })
        )
      ) }),
    groupsOnSet && _lodash2.default.map(menuItems, function (menuItem, i) {
      var menuExtra = menuItem.type == 'division' ? divisions.find(function (d) {
        return d.division_id == menuItem.item_id;
      }) : groupsOnSet.find(function (g) {
        return g.group_id == menuItem.item_id;
      });
      var subGroupsId = menuItems.filter(function (menu) {
        return menu.type == 'group' && menu.parent_id == menuItem.item_id;
      }).map(function (menu) {
        return menu.item_id;
      });
      var hasSubMenu = groupsOnSet.find(function (group) {
        return subGroupsId.includes(group.group_id);
      });
      var rightAction = void 0;
      if (menuItem.type == 'division' && !expandedDivisions.includes(menuItem.item_id)) rightAction = [_react2.default.createElement(_button.IconButton, { key: 'expand_sub_groups', icon: 'expand_more', onClick: function onClick() {
          return expandDivision(menuItem.item_id);
        } })];
      if (menuItem.type == 'division' && expandedDivisions.includes(menuItem.item_id)) rightAction = [_react2.default.createElement(_button.IconButton, { key: 'collapse_sub_groups', icon: 'expand_less', onClick: function onClick() {
          return collapseDivision(menuItem.item_id);
        } })];
      if (menuItem.type == 'division' && !hasSubMenu) return null;
      if (menuItem.type == 'division') return menuExtra && _react2.default.createElement(_list.ListItem, { theme: _leftSidebarGroupListItem2.default,
        className: menuExtra.division_id == currentDivisionId && 'active' || '',
        caption: menuExtra.name, key: menuExtra.division_id,
        avatar: menuExtra.icon_image.thumb_url,
        style: { height: 5, width: 5, backgroundColor: '#000', borderRadius: 20 },
        onClick: function onClick() {
          return onSelectDivision(menuExtra.division_id, props);
        },
        rightActions: rightAction || [] });
      return menuExtra && expandedDivisions.includes(menuItem.parent_id) && _react2.default.createElement(_list.ListItem, { theme: _leftSidebarGroupListItem2.default,
        className: (menuExtra.group_id == currentGroupId && 'active' || '') + ' indent ' + menuExtra.access_type,
        caption: menuExtra.name, key: menuItem.parent_id + '.' + menuExtra.group_id,
        avatar: menuExtra.icon_image.thumb_url,
        rightActions: menuExtra.unreadCount && [_react2.default.createElement(
          'span',
          { key: 'count', className: _leftSidebarGroupListItem2.default.unreadCount },
          menuExtra.unreadCount < 10 ? menuExtra.unreadCount : '10+'
        )] || [],
        onClick: function onClick() {
          return onSelectGroup(menuExtra.group_id, props);
        } });
    }),
    totalDivision > 0 && groupsNotSet.length > 0 && _react2.default.createElement(_list.ListItem, {
      key: 'division_group_not_set',
      theme: _leftSidebarGroupListItem2.default,
      className: currentDivisionId == 0 ? 'active' : '',
      caption: t('label:セクションなし'),
      avatar: _logo2.default,
      style: { height: 5, width: 5, backgroundColor: '#000', borderRadius: 20 },
      onClick: function onClick() {
        return onSelectDivisionNotSetGroup('new', props);
      },
      rightActions: [_react2.default.createElement(_button.IconButton, {
        key: !canExpandDivNotSetGroup ? "expand_sub_groups" : "collapse_sub_groups",
        icon: !canExpandDivNotSetGroup ? "expand_more" : "expand_less",
        onClick: expandDivisionNotSetGroup
      })]
    }),
    (canExpandDivNotSetGroup || totalDivision === 0) && groupsNotSet && _lodash2.default.map(menuItems, function (menuItem, i) {
      var menuExtra = groupsNotSet.find(function (g) {
        return g.group_id == menuItem.item_id && menuItem.is_free_group;
      });
      return menuExtra && _react2.default.createElement(_list.ListItem, { theme: _leftSidebarGroupListItem2.default,
        className: (menuExtra.group_id == currentGroupId && 'active' || '') + (totalDivision > 0 ? ' indent ' : '') + menuExtra.access_type,
        caption: menuExtra.name, key: (totalDivision > 0 ? menuItem.parent_id + '.' : '') + menuExtra.group_id,
        avatar: menuExtra.icon_image.thumb_url,
        rightActions: menuExtra.unreadCount && [_react2.default.createElement(
          'span',
          { key: 'count', className: _leftSidebarGroupListItem2.default.unreadCount },
          menuExtra.unreadCount < 10 ? menuExtra.unreadCount : '10+'
        )] || [],
        onClick: function onClick() {
          return onSelectGroup(menuExtra.group_id, props);
        } });
    }),
    isFilter && unreadGroups.length == 0 && _react2.default.createElement(_list.ListItem, { theme: _leftSidebarGroupListItem2.default,
      ripple: false,
      caption: t('label:未読グループがありません') }),
    !totalDivision && (!groups || groups.length === 0) || totalDivision > 0 && groupsOnSet.length === 0 && _react2.default.createElement(_list.ListItem, { theme: _leftSidebarGroupListItem2.default,
      ripple: false,
      caption: t('label:セクション/グループはありません') }),
    ui.show && otherGroups && _react2.default.createElement(_list.ListDivider, { theme: _leftSidebarGroupListItem2.default }),
    ui.show && otherGroups && _lodash2.default.map(menuItems, function (menuItem, i) {
      var menuExtra = menuItem.type == 'division' ? divisions.find(function (d) {
        return d.division_id == menuItem.item_id;
      }) : otherGroups.find(function (g) {
        return g.group_id == menuItem.item_id;
      });
      var subGroupsId = menuItems.filter(function (menu) {
        return menu.type == 'group' && menu.parent_id == menuItem.item_id;
      }).map(function (menu) {
        return menu.item_id;
      });
      var hasSubMenu = otherGroups.find(function (group) {
        return subGroupsId.includes(group.group_id);
      });
      var rightAction = void 0;
      if (menuItem.type == 'division' && !expandedDivisions.includes(menuItem.item_id)) rightAction = [_react2.default.createElement(_button.IconButton, { key: 'expand_sub_groups', icon: 'expand_more', onClick: function onClick() {
          return expandDivision(menuItem.item_id);
        } })];
      if (menuItem.type == 'division' && expandedDivisions.includes(menuItem.item_id)) rightAction = [_react2.default.createElement(_button.IconButton, { key: 'collapse_sub_groups', icon: 'expand_less', onClick: function onClick() {
          return collapseDivision(menuItem.item_id);
        } })];
      if (menuItem.type == 'division' && !hasSubMenu) return null;
      if (menuItem.type == 'division') return menuExtra && _react2.default.createElement(_list.ListItem, { theme: _leftSidebarGroupListItem2.default,
        className: menuExtra.division_id == currentDivisionId && 'active' || '',
        caption: menuExtra.name, key: menuExtra.division_id,
        avatar: menuExtra.icon_image.thumb_url,
        style: { height: 5, width: 5, backgroundColor: '#000', borderRadius: 20 },
        onClick: function onClick() {
          return onSelectDivision(menuExtra.division_id, props);
        },
        rightActions: rightAction || [] });
      return menuExtra && expandedDivisions.includes(menuItem.parent_id) && _react2.default.createElement(_list.ListItem, { theme: _leftSidebarGroupListItem2.default,
        className: (menuExtra.group_id == currentGroupId && 'active' || '') + ' indent ',
        caption: menuExtra.name, key: menuItem.parent_id + '.' + menuExtra.group_id,
        avatar: menuExtra.icon_image.thumb_url,
        rightActions: menuExtra.unreadCount && [_react2.default.createElement(
          'span',
          { key: 'count', className: _leftSidebarGroupListItem2.default.unreadCount },
          menuExtra.unreadCount < 10 ? menuExtra.unreadCount : '10+'
        )] || [],
        onClick: function onClick() {
          return onSelectGroup(menuExtra.group_id, props);
        } });
    }),
    ui.show && otherGroups && _lodash2.default.map(menuItems, function (menuItem, i) {
      var menuExtra = otherGroups.find(function (g) {
        return g.group_id == menuItem.item_id && menuItem.is_free_group;
      });
      return menuExtra && _react2.default.createElement(_list.ListItem, { theme: _leftSidebarGroupListItem2.default,
        className: menuExtra.group_id == currentGroupId && 'active' || '',
        caption: menuExtra.name, key: menuExtra.group_id,
        avatar: menuExtra.icon_image.thumb_url,
        rightActions: menuExtra.unreadCount && [_react2.default.createElement(
          'span',
          { key: 'count', className: _leftSidebarGroupListItem2.default.unreadCount },
          menuExtra.unreadCount < 10 ? menuExtra.unreadCount : '10+'
        )] || [],
        onClick: function onClick() {
          return onSelectGroup(menuExtra.group_id, props);
        } });
    }),
    !isFilter && otherGroups && _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false,
      rightActions: [_react2.default.createElement(_button.Button, { flat: true, key: 'more',
        icon: ui.show && 'arrow_drop_up' || 'arrow_drop_down',
        label: ui.show && t('label:隠す') || t('label:すべて表示'),
        onClick: function onClick() {
          return updateUI({ show: !ui.show });
        } })] })
  );
}

exports.default = (0, _uiState2.default)({ state: { show: false, searchInput: false } })(LeftSidebarGroupList);

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.compact-input--input--3ze1FZ-U {\n  padding: 0;\n}\n\n.compact-input--input--3ze1FZ-U[class~=fluid] {\n  width: 100%;\n}\n\n.compact-input--hint--Y5VKR3nj {\n  top: 12px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/compact-input.css"],"names":[],"mappings":";AACA;EACE,WAAW;CACZ;;AAED;EACE,YAAY;CACb;;AAED;EACE,UAAU;CACX","file":"compact-input.css","sourcesContent":["\n.input {\n  padding: 0;\n}\n\n.input[class~=fluid] {\n  width: 100%;\n}\n\n.hint {\n  top: 12px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"input": "compact-input--input--3ze1FZ-U",
	"hint": "compact-input--hint--Y5VKR3nj"
};

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.compact-list--list--2cp-Bu5Z {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.compact-list--itemContentRoot--37jH5_E- {\n  height: auto!important;\n  min-width: 183px;\n}\n\n.compact-list--subheader--28RiVokl {\n  line-height: 30px;\n  margin: 0;\n}\n\n.compact-list--itemText--drJwDh5f {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/compact-list.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,kBAAkB;CACnB;;AAED;EACE,uBAAuB;EACvB,iBAAiB;CAClB;;AAED;EACE,kBAAkB;EAClB,UAAU;CACX;;AAED;EACE,wBAAwB;EACxB,iBAAiB;CAClB","file":"compact-list.css","sourcesContent":["\n.list {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.itemContentRoot {\n  height: auto!important;\n  min-width: 183px;\n}\n\n.subheader {\n  line-height: 30px;\n  margin: 0;\n}\n\n.itemText {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"list": "compact-list--list--2cp-Bu5Z",
	"itemContentRoot": "compact-list--itemContentRoot--37jH5_E-",
	"subheader": "compact-list--subheader--28RiVokl",
	"itemText": "compact-list--itemText--drJwDh5f"
};

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".left-sidebar-group-list-item--itemContentRoot--2QcItw4V {\n  min-width: 123px;\n}\n\n.left-sidebar-group-list-item--unreadCount--2NEpVUob {\n  border-radius: 50%;\n  background-color: #AAA;\n  color: #FFF;\n  width: 22px;\n  height: 22px;\n  text-align: center;\n  position: relative;\n  left: -50px;\n  font-size: 80%;\n  line-height: 20px;\n  padding-top: 2px;\n}\n\n.left-sidebar-group-list-item--itemText--197z0-4a {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: 15px!important;\n}\n\n.left-sidebar-group-list-item--itemAction--295celvE {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.left-sidebar-group-list-item--selectable--3iIgy_t0:hover, .left-sidebar-group-list-item--listItem--eUkaftxl[class~=active] {\n  background-color: #FFF!important;\n}\n\n.left-sidebar-group-list-item--selectable--3iIgy_t0:hover .left-sidebar-group-list-item--itemAction--295celvE::after{\n  background-color:   #f3f0f0;\n}\n\n.left-sidebar-group-list-item--listItem--eUkaftxl[class~=active] .left-sidebar-group-list-item--itemAction--295celvE::after {\n  background-color: #f3f0f0;\n}\n\n.left-sidebar-group-list-item--divider--3E96esVu {\n  background-color: #CCC;\n  margin-left: 30px;\n  margin-right: 10px;\n  margin-bottom: 0px;\n}\n\n[class~=private_access] .left-sidebar-group-list-item--itemAction--295celvE::after {\n  position: absolute;\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  content: 'vpn_key';\n  color: #757575;\n  background-color: #FFF;\n  border-radius: 80%;\n  text-shadow: 5px 5px 10px #FFF;\n  top: 25px;\n  left: 46px;\n  padding: 3px;\n}\n\n[class~=following_group] .left-sidebar-group-list-item--itemAction--295celvE::after {\n  position: absolute;\n  font-family: 'Material Icons';\n  content: 'flag';\n  color: #ffcc00;\n  background-color: #FFF;\n  border-radius: 80%;\n  top: 25px;\n  left: 46px;\n  padding: 3px;\n}\n\n.left-sidebar-group-list-item--trialWrap--1VoOhSv8 {\n  border: 2px solid red;\n  border-radius: 10px;\n  margin: 10px;\n  text-align: center;\n}\n\n.left-sidebar-group-list-item--trialWrap--1VoOhSv8 p {\n  margin: 0px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.left-sidebar-group-list-item--trialWrap--1VoOhSv8 button {\n  background: #303fa8;\n  color: #fff!important;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.left-sidebar-group-list-item--trialWrap--1VoOhSv8 button:hover {\n  background: rgba(63, 81, 181, 0.85098)!important;  \n}\n\n.left-sidebar-group-list-item--listItem--eUkaftxl[class~=indent] .left-sidebar-group-list-item--itemAction--295celvE {\n  padding-left: 20px;\n}\n\n.left-sidebar-group-list-item--listItem--eUkaftxl[class~=indent][class~=private_access] .left-sidebar-group-list-item--itemAction--295celvE::after {\n  left: 66px;\n}\n\n.left-sidebar-group-list-item--listItem--eUkaftxl[class~=disabled]{\n    background-color:  \t#3b3b3b!important;\n}\n\n@media screen and (max-width: 768px) {\n  /* リストアイテムの背景色 */\n  .left-sidebar-group-list-item--itemContentRoot--2QcItw4V {\n    background-color: #ffffff;\n  }\n\n  /* アクティブ時とホバー時の背景 */\n  .left-sidebar-group-list-item--selectable--3iIgy_t0:hover, .left-sidebar-group-list-item--listItem--eUkaftxl[class~=active] {\n    background-color: #FFF!important;\n  }\n\n  /* カスタムアイコン（vpn_keyなど）の背景 */\n  [class~=private_access] .left-sidebar-group-list-item--itemAction--295celvE::after,\n  [class~=following_group] .left-sidebar-group-list-item--itemAction--295celvE::after {\n    background-color: #f3f0f0;\n  }\n\n  /* テキストの色 */\n  .left-sidebar-group-list-item--itemText--197z0-4a {\n    color: #555555;\n  }\n\n  /* disabled状態の背景色も調整 */\n  .left-sidebar-group-list-item--listItem--eUkaftxl[class~=disabled] {\n    background-color: #3b3b3b!important;\n  }\n\n  /* ホバー時のアクション背景 */\n  .left-sidebar-group-list-item--selectable--3iIgy_t0:hover .left-sidebar-group-list-item--itemAction--295celvE::after,\n  .left-sidebar-group-list-item--listItem--eUkaftxl[class~=active] .left-sidebar-group-list-item--itemAction--295celvE::after {\n    background-color: #FFF;\n  }\n\n  .left-sidebar-group-list-item--list--17znwhWR {\n    border-bottom: 1px solid rgba(0, 0, 0, .1);\n    border-top: 1px solid rgba(0, 0, 0, .1);\n    margin-top: 8px;\n    padding-top: 8px;\n  }\n }", "", {"version":3,"sources":["/./src/web/components/themes/left-sidebar-group-list-item.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;CAClB;;AAED;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;CAClB;;AAED;EACE,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;CAC3B;;AAED;EACE,gBAAgB;EAChB,mBAAmB;CACpB;;AAED;EACE,iCAAiC;CAClC;;AAED;EACE,4BAA4B;CAC7B;;AAED;EACE,0BAA0B;CAC3B;;AAED;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;;AAED;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,UAAU;EACV,WAAW;EACX,aAAa;CACd;;AAED;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,aAAa;CACd;;AAED;EACE,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;CACpB;;AAED;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;CACnB;;AAED;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;CACrB;;AAED;EACE,iDAAiD;CAClD;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,WAAW;CACZ;;AAED;IACI,sCAAsC;CACzC;;AAED;EACE,iBAAiB;EACjB;IACE,0BAA0B;GAC3B;;EAED,oBAAoB;EACpB;IACE,iCAAiC;GAClC;;EAED,4BAA4B;EAC5B;;IAEE,0BAA0B;GAC3B;;EAED,YAAY;EACZ;IACE,eAAe;GAChB;;EAED,uBAAuB;EACvB;IACE,oCAAoC;GACrC;;EAED,kBAAkB;EAClB;;IAEE,uBAAuB;GACxB;;EAED;IACE,2CAA2C;IAC3C,wCAAwC;IACxC,gBAAgB;IAChB,iBAAiB;GAClB;EACD","file":"left-sidebar-group-list-item.css","sourcesContent":[".itemContentRoot {\n  min-width: 123px;\n}\n\n.unreadCount {\n  border-radius: 50%;\n  background-color: #AAA;\n  color: #FFF;\n  width: 22px;\n  height: 22px;\n  text-align: center;\n  position: relative;\n  left: -50px;\n  font-size: 80%;\n  line-height: 20px;\n  padding-top: 2px;\n}\n\n.itemText {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: 15px!important;\n}\n\n.itemAction {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.selectable:hover, .listItem[class~=active] {\n  background-color: #FFF!important;\n}\n\n.selectable:hover .itemAction::after{\n  background-color:   #f3f0f0;\n}\n\n.listItem[class~=active] .itemAction::after {\n  background-color: #f3f0f0;\n}\n\n.divider {\n  background-color: #CCC;\n  margin-left: 30px;\n  margin-right: 10px;\n  margin-bottom: 0px;\n}\n\n[class~=private_access] .itemAction::after {\n  position: absolute;\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  content: 'vpn_key';\n  color: #757575;\n  background-color: #FFF;\n  border-radius: 80%;\n  text-shadow: 5px 5px 10px #FFF;\n  top: 25px;\n  left: 46px;\n  padding: 3px;\n}\n\n[class~=following_group] .itemAction::after {\n  position: absolute;\n  font-family: 'Material Icons';\n  content: 'flag';\n  color: #ffcc00;\n  background-color: #FFF;\n  border-radius: 80%;\n  top: 25px;\n  left: 46px;\n  padding: 3px;\n}\n\n.trialWrap {\n  border: 2px solid red;\n  border-radius: 10px;\n  margin: 10px;\n  text-align: center;\n}\n\n.trialWrap p {\n  margin: 0px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.trialWrap button {\n  background: #303fa8;\n  color: #fff!important;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.trialWrap button:hover {\n  background: rgba(63, 81, 181, 0.85098)!important;  \n}\n\n.listItem[class~=indent] .itemAction {\n  padding-left: 20px;\n}\n\n.listItem[class~=indent][class~=private_access] .itemAction::after {\n  left: 66px;\n}\n\n.listItem[class~=disabled]{\n    background-color:  \t#3b3b3b!important;\n}\n\n@media screen and (max-width: 768px) {\n  /* リストアイテムの背景色 */\n  .itemContentRoot {\n    background-color: #ffffff;\n  }\n\n  /* アクティブ時とホバー時の背景 */\n  .selectable:hover, .listItem[class~=active] {\n    background-color: #FFF!important;\n  }\n\n  /* カスタムアイコン（vpn_keyなど）の背景 */\n  [class~=private_access] .itemAction::after,\n  [class~=following_group] .itemAction::after {\n    background-color: #f3f0f0;\n  }\n\n  /* テキストの色 */\n  .itemText {\n    color: #555555;\n  }\n\n  /* disabled状態の背景色も調整 */\n  .listItem[class~=disabled] {\n    background-color: #3b3b3b!important;\n  }\n\n  /* ホバー時のアクション背景 */\n  .selectable:hover .itemAction::after,\n  .listItem[class~=active] .itemAction::after {\n    background-color: #FFF;\n  }\n\n  .list {\n    border-bottom: 1px solid rgba(0, 0, 0, .1);\n    border-top: 1px solid rgba(0, 0, 0, .1);\n    margin-top: 8px;\n    padding-top: 8px;\n  }\n }"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"itemContentRoot": "left-sidebar-group-list-item--itemContentRoot--2QcItw4V",
	"unreadCount": "left-sidebar-group-list-item--unreadCount--2NEpVUob",
	"itemText": "left-sidebar-group-list-item--itemText--197z0-4a",
	"itemAction": "left-sidebar-group-list-item--itemAction--295celvE",
	"selectable": "left-sidebar-group-list-item--selectable--3iIgy_t0",
	"listItem": "left-sidebar-group-list-item--listItem--eUkaftxl",
	"divider": "left-sidebar-group-list-item--divider--3E96esVu",
	"trialWrap": "left-sidebar-group-list-item--trialWrap--1VoOhSv8",
	"list": "left-sidebar-group-list-item--list--17znwhWR"
};

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.card-title-right-actions--cardTitle--1TcKx5X5 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-width: 100%;\n  padding-top: 16px;\n  padding-left: 16px;\n  padding-right: 16px\n}\n\n.card-title-right-actions--avatar--2PSlS_MR {\n  height: 40px;\n  width: 40px;\n  min-width: 40px;\n  margin-right: 16px;\n  cursor: pointer;\n}\n\n.card-title-right-actions--content--2bpcQfaI {\n  width: calc(100% - 128px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.card-title-right-actions--title--Sp4DPedE {\n  font-size: 16.5px;\n  font-weight: bold;\n  line-height: 18px;\n  margin: 0;\n  padding: 0;\n}\n\n.card-title-right-actions--subtitle--2WKeFMsL {\n  color: #757575;\n  margin-left: -3px;\n  padding: 0;\n}\n\n.card-title-right-actions--rightIcons--zUWxR19o {\n  margin-left: auto;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/card-title-right-actions.css"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;;AAED;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;CACjB;;AAED;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,wBAAwB;CACzB;;AAED;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;CACZ;;AAED;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;CACZ;;AAED;EACE,kBAAkB;CACnB","file":"card-title-right-actions.css","sourcesContent":["\n.cardTitle {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-width: 100%;\n  padding-top: 16px;\n  padding-left: 16px;\n  padding-right: 16px\n}\n\n.avatar {\n  height: 40px;\n  width: 40px;\n  min-width: 40px;\n  margin-right: 16px;\n  cursor: pointer;\n}\n\n.content {\n  width: calc(100% - 128px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.title {\n  font-size: 16.5px;\n  font-weight: bold;\n  line-height: 18px;\n  margin: 0;\n  padding: 0;\n}\n\n.subtitle {\n  color: #757575;\n  margin-left: -3px;\n  padding: 0;\n}\n\n.rightIcons {\n  margin-left: auto;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"cardTitle": "card-title-right-actions--cardTitle--1TcKx5X5",
	"avatar": "card-title-right-actions--avatar--2PSlS_MR",
	"content": "card-title-right-actions--content--2bpcQfaI",
	"title": "card-title-right-actions--title--Sp4DPedE",
	"subtitle": "card-title-right-actions--subtitle--2WKeFMsL",
	"rightIcons": "card-title-right-actions--rightIcons--zUWxR19o"
};

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _Portal = __webpack_require__(337);

var _Portal2 = _interopRequireDefault(_Portal);

var _utils = __webpack_require__(106);

var _identifiers = __webpack_require__(16);

var _events = __webpack_require__(143);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POSITION = {
  BOTTOM: 'bottom',
  HORIZONTAL: 'horizontal',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  VERTICAL: 'vertical'
};

var defaults = {
  className: '',
  delay: 0,
  hideOnClick: true,
  passthrough: true,
  showOnClick: false,
  position: POSITION.VERTICAL,
  theme: {}
};

var tooltipFactory = function tooltipFactory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaults$options = _extends({}, defaults, options),
      defaultClassName = _defaults$options.className,
      defaultDelay = _defaults$options.delay,
      defaultHideOnClick = _defaults$options.hideOnClick,
      defaultShowOnClick = _defaults$options.showOnClick,
      defaultPassthrough = _defaults$options.passthrough,
      defaultPosition = _defaults$options.position,
      defaultTheme = _defaults$options.theme;

  return function (ComposedComponent) {
    var TooltippedComponent = function (_Component) {
      _inherits(TooltippedComponent, _Component);

      function TooltippedComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TooltippedComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltippedComponent.__proto__ || Object.getPrototypeOf(TooltippedComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          active: false,
          position: _this.props.tooltipPosition,
          visible: false
        }, _this.onTransformEnd = function (e) {
          if (e.propertyName === 'transform') {
            _events2.default.removeEventListenerOnTransitionEnded(_this.tooltipNode, _this.onTransformEnd);
            _this.setState({ visible: false });
          }
        }, _this.handleMouseEnter = function (event) {
          _this.activate(_this.calculatePosition(event.currentTarget));
          if (_this.props.onMouseEnter) _this.props.onMouseEnter(event);
        }, _this.handleMouseLeave = function (event) {
          _this.deactivate();
          if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
        }, _this.handleClick = function (event) {
          if (_this.props.tooltipHideOnClick && _this.state.active) {
            _this.deactivate();
          }

          if (_this.props.tooltipShowOnClick && !_this.state.active) {
            _this.activate(_this.calculatePosition(event.currentTarget));
          }

          if (_this.props.onClick) _this.props.onClick(event);
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(TooltippedComponent, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.tooltipNode) {
            _events2.default.removeEventListenerOnTransitionEnded(this.tooltipNode, this.onTransformEnd);
          }
          if (this.timeout) clearTimeout(this.timeout);
        }
      }, {
        key: 'getPosition',
        value: function getPosition(element) {
          var tooltipPosition = this.props.tooltipPosition;

          if (tooltipPosition === POSITION.HORIZONTAL) {
            var origin = element.getBoundingClientRect();

            var _getViewport = (0, _utils.getViewport)(),
                ww = _getViewport.width;

            var toRight = origin.left < ww / 2 - origin.width / 2;
            return toRight ? POSITION.RIGHT : POSITION.LEFT;
          } else if (tooltipPosition === POSITION.VERTICAL) {
            var _origin = element.getBoundingClientRect();

            var _getViewport2 = (0, _utils.getViewport)(),
                wh = _getViewport2.height;

            var toBottom = _origin.top < wh / 2 - _origin.height / 2;
            return toBottom ? POSITION.BOTTOM : POSITION.TOP;
          }
          return tooltipPosition;
        }
      }, {
        key: 'activate',
        value: function activate(_ref2) {
          var _this2 = this;

          var top = _ref2.top,
              left = _ref2.left,
              position = _ref2.position;

          if (this.timeout) clearTimeout(this.timeout);
          this.setState({ visible: true, position: position });
          this.timeout = setTimeout(function () {
            _this2.setState({ active: true, top: top, left: left });
          }, this.props.tooltipDelay);
        }
      }, {
        key: 'deactivate',
        value: function deactivate() {
          if (this.timeout) clearTimeout(this.timeout);
          if (this.state.active) {
            _events2.default.addEventListenerOnTransitionEnded(this.tooltipNode, this.onTransformEnd);
            this.setState({ active: false });
          } else if (this.state.visible) {
            this.setState({ visible: false });
          }
        }
      }, {
        key: 'calculatePosition',
        value: function calculatePosition(element) {
          var position = this.getPosition(element);

          var _element$getBoundingC = element.getBoundingClientRect(),
              top = _element$getBoundingC.top,
              left = _element$getBoundingC.left,
              height = _element$getBoundingC.height,
              width = _element$getBoundingC.width;

          var xOffset = window.scrollX || window.pageXOffset;
          var yOffset = window.scrollY || window.pageYOffset;
          if (position === POSITION.BOTTOM) {
            return {
              top: top + height + yOffset,
              left: left + width / 2 + xOffset,
              position: position
            };
          } else if (position === POSITION.TOP) {
            return {
              top: top + yOffset,
              left: left + width / 2 + xOffset,
              position: position
            };
          } else if (position === POSITION.LEFT) {
            return {
              top: top + height / 2 + yOffset,
              left: left + xOffset,
              position: position
            };
          } else if (position === POSITION.RIGHT) {
            return {
              top: top + height / 2 + yOffset,
              left: left + width + xOffset,
              position: position
            };
          }
          return undefined;
        }
      }, {
        key: 'render',
        value: function render() {
          var _classnames,
              _this3 = this;

          var _state = this.state,
              active = _state.active,
              left = _state.left,
              top = _state.top,
              position = _state.position,
              visible = _state.visible;

          var positionClass = 'tooltip' + (position.charAt(0).toUpperCase() + position.slice(1));

          var _props = this.props,
              children = _props.children,
              className = _props.className,
              theme = _props.theme,
              onClick = _props.onClick,
              onMouseEnter = _props.onMouseEnter,
              onMouseLeave = _props.onMouseLeave,
              tooltip = _props.tooltip,
              tooltipDelay = _props.tooltipDelay,
              tooltipHideOnClick = _props.tooltipHideOnClick,
              tooltipPosition = _props.tooltipPosition,
              tooltipShowOnClick = _props.tooltipShowOnClick,
              other = _objectWithoutProperties(_props, ['children', 'className', 'theme', 'onClick', 'onMouseEnter', 'onMouseLeave', 'tooltip', 'tooltipDelay', 'tooltipHideOnClick', 'tooltipPosition', 'tooltipShowOnClick']);

          var _className = (0, _classnames3.default)(theme.tooltip, (_classnames = {}, _defineProperty(_classnames, theme.tooltipActive, active), _defineProperty(_classnames, theme[positionClass], theme[positionClass]), _classnames));

          var childProps = _extends({}, other, {
            className: className,
            onClick: this.handleClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
          });

          var shouldPass = typeof ComposedComponent !== 'string' && defaultPassthrough;
          var finalProps = shouldPass ? _extends({}, childProps, { theme: theme }) : childProps;

          return _react2.default.createElement(ComposedComponent, finalProps, children, visible && _react2.default.createElement(
            _Portal2.default,
            null,
            _react2.default.createElement(
              'span',
              {
                ref: function ref(node) {
                  _this3.tooltipNode = node;
                },
                className: _className,
                'data-react-toolbox': 'tooltip',
                style: { top: top, left: left }
              },
              _react2.default.createElement(
                'span',
                { className: theme.tooltipInner },
                tooltip
              )
            )
          ));
        }
      }]);

      return TooltippedComponent;
    }(_react.Component);

    TooltippedComponent.propTypes = {
      children: _propTypes2.default.node,
      className: _propTypes2.default.string,
      onClick: _propTypes2.default.func,
      onMouseEnter: _propTypes2.default.func,
      onMouseLeave: _propTypes2.default.func,
      theme: _propTypes2.default.shape({
        tooltip: _propTypes2.default.string,
        tooltipActive: _propTypes2.default.string,
        tooltipWrapper: _propTypes2.default.string
      }),
      tooltip: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
      tooltipDelay: _propTypes2.default.number,
      tooltipHideOnClick: _propTypes2.default.bool,
      tooltipPosition: _propTypes2.default.oneOf(Object.keys(POSITION).map(function (key) {
        return POSITION[key];
      })),
      tooltipShowOnClick: _propTypes2.default.bool
    };
    TooltippedComponent.defaultProps = {
      className: defaultClassName,
      tooltipDelay: defaultDelay,
      tooltipHideOnClick: defaultHideOnClick,
      tooltipPosition: defaultPosition,
      tooltipShowOnClick: defaultShowOnClick
    };


    return (0, _reactCssThemr.themr)(_identifiers.TOOLTIP, defaultTheme)(TooltippedComponent);
  };
};

exports.default = tooltipFactory;

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1899);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--tooltip--3ihYkrZe {\n  display: block;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 14px;\n  max-width: 170px;\n  padding: 5px;\n  pointer-events: none;\n  position: absolute;\n  text-align: center;\n  text-transform: none;\n  -webkit-transform: scale(0) translateX(-50%);\n          transform: scale(0) translateX(-50%);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n  transition: cubic-bezier(0.4, 0, 0.2, 1) 200ms transform;\n  z-index: 200;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--tooltip--3ihYkrZe *,\n    .theme--tooltip--3ihYkrZe *::after,\n    .theme--tooltip--3ihYkrZe *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--tooltip--3ihYkrZe.theme--tooltipActive--1bmEtrMR {\n  -webkit-transform: scale(1) translateX(-50%);\n          transform: scale(1) translateX(-50%);\n}\n.theme--tooltip--3ihYkrZe.theme--tooltipTop--jN452dvt {\n  -webkit-transform: scale(0) translateX(-50%) translateY(-100%);\n          transform: scale(0) translateX(-50%) translateY(-100%);\n}\n.theme--tooltip--3ihYkrZe.theme--tooltipTop--jN452dvt.theme--tooltipActive--1bmEtrMR {\n  -webkit-transform: scale(1) translateX(-50%) translateY(-100%);\n          transform: scale(1) translateX(-50%) translateY(-100%);\n}\n.theme--tooltip--3ihYkrZe.theme--tooltipLeft--On476v9e {\n  -webkit-transform: scale(0) translateX(-100%) translateY(-50%);\n          transform: scale(0) translateX(-100%) translateY(-50%);\n}\n.theme--tooltip--3ihYkrZe.theme--tooltipLeft--On476v9e.theme--tooltipActive--1bmEtrMR {\n  -webkit-transform: scale(1) translateX(-100%) translateY(-50%);\n          transform: scale(1) translateX(-100%) translateY(-50%);\n}\n.theme--tooltip--3ihYkrZe.theme--tooltipRight--33MGEZiM {\n  -webkit-transform: scale(0) translateX(0) translateY(-50%);\n          transform: scale(0) translateX(0) translateY(-50%);\n}\n.theme--tooltip--3ihYkrZe.theme--tooltipRight--33MGEZiM.theme--tooltipActive--1bmEtrMR {\n  -webkit-transform: scale(1) translateX(0) translateY(-50%);\n          transform: scale(1) translateX(0) translateY(-50%);\n}\n.theme--tooltipInner--1KIL32V6 {\n  background: rgba(97, 97, 97, 0.9);\n  border-radius: 2px;\n  color: rgb(255, 255, 255);\n  display: block;\n  padding: 8px;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/tooltip/theme.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,wDAAwD;EACxD,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;UACrC,qCAAqC;EAC7C,mCAAmC;UAC3B,2BAA2B;EACnC,yDAAyD;EACzD,aAAa;EACb,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,6CAA6C;UACrC,qCAAqC;CAC9C;AACD;EACE,+DAA+D;UACvD,uDAAuD;CAChE;AACD;EACE,+DAA+D;UACvD,uDAAuD;CAChE;AACD;EACE,+DAA+D;UACvD,uDAAuD;CAChE;AACD;EACE,+DAA+D;UACvD,uDAAuD;CAChE;AACD;EACE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,2DAA2D;UACnD,mDAAmD;CAC5D;AACD;EACE,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,aAAa;CACd","file":"theme.css","sourcesContent":[".tooltip {\n  display: block;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 14px;\n  max-width: 170px;\n  padding: 5px;\n  pointer-events: none;\n  position: absolute;\n  text-align: center;\n  text-transform: none;\n  -webkit-transform: scale(0) translateX(-50%);\n          transform: scale(0) translateX(-50%);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n  transition: cubic-bezier(0.4, 0, 0.2, 1) 200ms transform;\n  z-index: 200;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.tooltip *,\n    .tooltip *::after,\n    .tooltip *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.tooltip.tooltipActive {\n  -webkit-transform: scale(1) translateX(-50%);\n          transform: scale(1) translateX(-50%);\n}\n.tooltip.tooltipTop {\n  -webkit-transform: scale(0) translateX(-50%) translateY(-100%);\n          transform: scale(0) translateX(-50%) translateY(-100%);\n}\n.tooltip.tooltipTop.tooltipActive {\n  -webkit-transform: scale(1) translateX(-50%) translateY(-100%);\n          transform: scale(1) translateX(-50%) translateY(-100%);\n}\n.tooltip.tooltipLeft {\n  -webkit-transform: scale(0) translateX(-100%) translateY(-50%);\n          transform: scale(0) translateX(-100%) translateY(-50%);\n}\n.tooltip.tooltipLeft.tooltipActive {\n  -webkit-transform: scale(1) translateX(-100%) translateY(-50%);\n          transform: scale(1) translateX(-100%) translateY(-50%);\n}\n.tooltip.tooltipRight {\n  -webkit-transform: scale(0) translateX(0) translateY(-50%);\n          transform: scale(0) translateX(0) translateY(-50%);\n}\n.tooltip.tooltipRight.tooltipActive {\n  -webkit-transform: scale(1) translateX(0) translateY(-50%);\n          transform: scale(1) translateX(0) translateY(-50%);\n}\n.tooltipInner {\n  background: rgba(97, 97, 97, 0.9);\n  border-radius: 2px;\n  color: rgb(255, 255, 255);\n  display: block;\n  padding: 8px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"tooltip": "theme--tooltip--3ihYkrZe",
	"tooltipActive": "theme--tooltipActive--1bmEtrMR",
	"tooltipTop": "theme--tooltipTop--jN452dvt",
	"tooltipLeft": "theme--tooltipLeft--On476v9e",
	"tooltipRight": "theme--tooltipRight--33MGEZiM",
	"tooltipInner": "theme--tooltipInner--1KIL32V6"
};

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupCreatePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupCreatePage = __webpack_require__(1901);

var _groupCreatePage2 = _interopRequireDefault(_groupCreatePage);

var _settingsPage = __webpack_require__(268);

var _groupFormPanel = __webpack_require__(912);

var _groupFormPanel2 = _interopRequireDefault(_groupFormPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-create-page.jsx

var GroupCreatePage = function (_React$Component) {
  _inherits(GroupCreatePage, _React$Component);

  function GroupCreatePage() {
    _classCallCheck(this, GroupCreatePage);

    return _possibleConstructorReturn(this, (GroupCreatePage.__proto__ || Object.getPrototypeOf(GroupCreatePage)).apply(this, arguments));
  }

  _createClass(GroupCreatePage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          active = _props.active,
          onClose = _props.onClose;


      return _react2.default.createElement(
        _settingsPage.SettingsPage,
        { title: t('label:グループ新規作成'),
          active: active,
          onCloseDialog: onClose,
          initialName: 'profile' },
        _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'profile',
          label: t('label:新規作成'),
          icon: 'add_circle',
          params: { onClose: onClose },
          component: _groupFormPanel2.default })
      );
    }
  }]);

  return GroupCreatePage;
}(_react2.default.Component);

var RawGroupCreatePage = exports.RawGroupCreatePage = GroupCreatePage;
exports.default = (0, _groupCreatePage2.default)(GroupCreatePage);

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {};
};
// src/connects/group-create-page.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/settings-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isPhone: state.media.isPhone,
    message: state.alertMessage.message,
    category: state.alertMessage.category
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onCloseDrawer: function onCloseDrawer() {
      return ownProps.updateUI({ active: false });
    },
    onOpenDrawer: function onOpenDrawer() {
      return ownProps.updateUI({ active: true });
    },
    clearAlertMessage: function clearAlertMessage() {
      return dispatch(_actions2.default.clearAlertMessage());
    },
    selectPanel: function selectPanel(name, subName, params) {
      return ownProps.updateUI({ name: name, subName: subName, params: params });
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (nextProps.name && props.name != nextProps.name) {
        ownProps.updateUI({ name: nextProps.name });
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _uiState2.default)({
  state: {
    active: false,
    name: function name(props) {
      return props.initialName;
    },
    subName: undefined,
    params: undefined
  },
  exports: true
}), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1904);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./settings-dialog.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./settings-dialog.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.settings-dialog--body--29tovis7 {\n  padding: 0\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/settings-dialog.css"],"names":[],"mappings":";AACA;EACE,UAAU;CACX","file":"settings-dialog.css","sourcesContent":["\n.body {\n  padding: 0\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"body": "settings-dialog--body--29tovis7"
};

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1906);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./inactive-list-item.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./inactive-list-item.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.inactive-list-item--listItem--2UI7OWlO {\n  margin-left: 5px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/inactive-list-item.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB","file":"inactive-list-item.css","sourcesContent":["\n.listItem {\n  margin-left: 5px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listItem": "inactive-list-item--listItem--2UI7OWlO"
};

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1908);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./active-list-item.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./active-list-item.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.active-list-item--listItem--3RbTLkbu {\n  border-left: solid red 5px;\n  background-color: #EEE;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/active-list-item.css"],"names":[],"mappings":";AACA;EACE,2BAA2B;EAC3B,uBAAuB;CACxB","file":"active-list-item.css","sourcesContent":["\n.listItem {\n  border-left: solid red 5px;\n  background-color: #EEE;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listItem": "active-list-item--listItem--3RbTLkbu"
};

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/group-form-panel.js

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _fileUpload = __webpack_require__(179);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _componentId = __webpack_require__(164);

var _componentId2 = _interopRequireDefault(_componentId);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _formValidator = __webpack_require__(41);

var _alertMessage = __webpack_require__(13);

var _route = __webpack_require__(67);

var _store = __webpack_require__(18);

var _i18n = __webpack_require__(173);

var _i18n2 = _interopRequireDefault(_i18n);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    group: ownProps.group ? (0, _store.getArray)('group_id', state.groups.items, ownProps.group.group_id) : undefined,
    isUpdating: state.groups.isUpdating,
    isUpdateFailed: state.groups.isUpdateFailed,
    _uploadFile: state.uploadFile[ownProps.componentId],
    created: state.groups.created,
    remindSchedule: state.groups.remindSchedule
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var uploadFile;
  if (stateProps._uploadFile) {
    uploadFile = (0, _find2.default)(stateProps._uploadFile, function (value, key) {
      return value;
    });
  }

  return _extends({
    isUploading: uploadFile && uploadFile.isUploading,
    uploadedFile: uploadFile && uploadFile.item
  }, ownProps, stateProps, dispatchProps);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    validateAndSubmit: function validateAndSubmit(props, crop) {
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      if (event && event.preventDefault) event.preventDefault();

      (0, _formValidator.validate)(props.ui, {
        name: { rule: 'isRequired' }
      }, function (errors, nextUI) {
        props.updateUI(nextUI);
        if (!errors) {
          props.ui.handlers && props.ui.handlers.getValue(function (desc) {
            if (props.group) dispatch(_actions2.default.updateGroup(props.group.group_id, props.ui.name, props.ui.access_type, props.uploadedFile && props.uploadedFile.file_id, crop, desc, props.ui.locale));else dispatch(_actions2.default.createGroup(props.ui.name, props.ui.access_type, props.uploadedFile && props.uploadedFile.file_id, crop, desc, props.organization && props.organization.organization_id, props.ui.cancelRemindMail, props.ui.locale));
          });
        }
      });
      return false;
    },

    uploadFile: function uploadFile(props, file) {
      return !props.isUploading && (0, _fileUpload2.default)(file, dispatch, props.group.group_id, 'group', ownProps.componentId, true);
    },

    willUnmount: function willUnmount(props) {
      dispatch(_actions2.default.clearUploadFilesAndVideos(props.componentId));
    },

    willUpdate: function willUpdate(props, nextProps) {
      // changing isFetching true => false
      if (props.isUpdating && !nextProps.isUpdating) {
        if (!nextProps.isUpdateFailed) {
          // successfully updated
          dispatch(_actions2.default.clearUploadFilesAndVideos(nextProps.componentId));
          if (nextProps.group) {
            nextProps.updateUI({
              name: nextProps.group.name,
              nameError: undefined
            });
            dispatch((0, _alertMessage.emitAlertMessage)("label:グループの基本設定を更新しました", "success"));
          } else {
            dispatch(_actions2.default.fetchGroups());
            dispatch((0, _alertMessage.emitAlertMessage)("label:グループを作成しました", "success"));
            (0, _route.pushRoute)('group_timeline', { group_id: nextProps.created.group_id });
            nextProps.onClose();
          }
        }
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)(_componentId2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: {
    access_type: function access_type(props) {
      return props.group && props.group.access_type || 'public_access';
    },
    name: function name(props) {
      return props.group && props.group.name || '';
    },
    nameError: undefined,
    handlers: undefined,
    cancelRemindMail: false,
    locale: function locale(props) {
      return props.group && props.group.locale || _i18n2.default.language;
    }
  } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('group_profile'), (0, _analytics.trackHandlers)('validateAndSubmit', 'group_form_submit'));

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = exports.dropdownFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames4 = __webpack_require__(14);

var _classnames5 = _interopRequireDefault(_classnames4);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Input = __webpack_require__(223);

var _Input2 = _interopRequireDefault(_Input);

var _events = __webpack_require__(143);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


var factory = function factory(Input) {
  var Dropdown = function (_Component) {
    _inherits(Dropdown, _Component);

    function Dropdown() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Dropdown);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: false,
        up: false
      }, _this.getDocumentEvents = function () {
        return {
          click: _this.handleDocumentClick,
          touchend: _this.handleDocumentClick
        };
      }, _this.getSelectedItem = function () {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _this.props.source[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item[_this.props.valueKey] === _this.props.value) return item;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return !_this.props.allowBlank ? _this.props.source[0] : undefined;
      }, _this.handleSelect = function (item, event) {
        if (_this.props.onBlur) _this.props.onBlur(event);
        if (!_this.props.disabled && _this.props.onChange) {
          if (_this.props.name) event.target.name = _this.props.name;
          _this.props.onChange(item, event);
          _this.close();
        }
      }, _this.handleClick = function (event) {
        _this.open(event);
        _events2.default.pauseEvent(event);
        if (_this.props.onClick) _this.props.onClick(event);
      }, _this.handleDocumentClick = function (event) {
        if (_this.state.active && !_events2.default.targetIsDescendant(event, _reactDom2.default.findDOMNode(_this))) {
          _this.setState({ active: false });
        }
      }, _this.close = function () {
        if (_this.state.active) {
          _this.setState({ active: false });
        }
      }, _this.open = function (event) {
        if (_this.state.active) return;
        var client = event.target.getBoundingClientRect();
        var screenHeight = window.innerHeight || document.documentElement.offsetHeight;
        var up = _this.props.auto ? client.top > screenHeight / 2 + client.height : false;
        if (_this.inputNode) _this.inputNode.blur();
        _this.setState({ active: true, up: up });
      }, _this.handleFocus = function (event) {
        event.stopPropagation();
        if (!_this.props.disabled) _this.open(event);
        if (_this.props.onFocus) _this.props.onFocus(event);
      }, _this.handleBlur = function (event) {
        event.stopPropagation();
        if (_this.state.active) _this.close();
        if (_this.props.onBlur) _this.props.onBlur(event);
      }, _this.renderValue = function (item, idx) {
        var _classnames;

        var _this$props = _this.props,
            labelKey = _this$props.labelKey,
            theme = _this$props.theme,
            valueKey = _this$props.valueKey;

        var className = (0, _classnames5.default)((_classnames = {}, _defineProperty(_classnames, theme.selected, item[valueKey] === _this.props.value), _defineProperty(_classnames, theme.disabled, item.disabled), _classnames));
        return _react2.default.createElement(
          'li',
          {
            key: idx,
            className: className,
            onClick: !item.disabled && _this.handleSelect.bind(_this, item[valueKey])
          },
          _this.props.template ? _this.props.template(item) : item[labelKey]
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Dropdown, [{
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        if (!this.state.active && nextState.active) {
          _events2.default.addEventsToDocument(this.getDocumentEvents());
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (prevState.active && !this.state.active) {
          _events2.default.removeEventsFromDocument(this.getDocumentEvents());
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.state.active) {
          _events2.default.removeEventsFromDocument(this.getDocumentEvents());
        }
      }
    }, {
      key: 'renderTemplateValue',
      value: function renderTemplateValue(selected) {
        var _classnames2;

        var theme = this.props.theme;

        var className = (0, _classnames5.default)(theme.field, (_classnames2 = {}, _defineProperty(_classnames2, theme.errored, this.props.error), _defineProperty(_classnames2, theme.disabled, this.props.disabled), _defineProperty(_classnames2, theme.required, this.props.required), _classnames2));

        return _react2.default.createElement(
          'div',
          { className: className, onClick: this.handleClick },
          _react2.default.createElement(
            'div',
            { className: theme.templateValue + ' ' + theme.value },
            this.props.template(selected)
          ),
          this.props.label ? _react2.default.createElement(
            'label',
            { className: theme.label },
            this.props.label,
            this.props.required ? _react2.default.createElement(
              'span',
              { className: theme.required },
              ' * '
            ) : null
          ) : null,
          this.props.error ? _react2.default.createElement(
            'span',
            { className: theme.error },
            this.props.error
          ) : null
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var _classnames3,
            _this2 = this;

        var _props = this.props,
            allowBlank = _props.allowBlank,
            auto = _props.auto,
            labelKey = _props.labelKey,
            required = _props.required,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onBlur = _props.onBlur,
            source = _props.source,
            template = _props.template,
            theme = _props.theme,
            valueKey = _props.valueKey,
            others = _objectWithoutProperties(_props, ['allowBlank', 'auto', 'labelKey', 'required', 'onChange', 'onFocus', 'onBlur', 'source', 'template', 'theme', 'valueKey']);

        var selected = this.getSelectedItem();
        var className = (0, _classnames5.default)(theme.dropdown, (_classnames3 = {}, _defineProperty(_classnames3, theme.up, this.state.up), _defineProperty(_classnames3, theme.active, this.state.active), _defineProperty(_classnames3, theme.disabled, this.props.disabled), _defineProperty(_classnames3, theme.required, this.props.required), _classnames3), this.props.className);

        return _react2.default.createElement(
          'div',
          {
            className: className,
            'data-react-toolbox': 'dropdown',
            onBlur: this.handleBlur,
            onFocus: this.handleFocus
          },
          _react2.default.createElement(Input, _extends({}, others, {
            tabIndex: '0',
            className: theme.value,
            onClick: this.handleClick,
            required: this.props.required,
            readOnly: true,
            innerRef: function innerRef(node) {
              _this2.inputNode = node;
            },
            type: template && selected ? 'hidden' : null,
            theme: theme,
            themeNamespace: 'input',
            value: selected && selected[labelKey] ? selected[labelKey] : ''
          })),
          template && selected ? this.renderTemplateValue(selected) : null,
          _react2.default.createElement(
            'ul',
            { className: theme.values },
            source.map(this.renderValue)
          )
        );
      }
    }]);

    return Dropdown;
  }(_react.Component);

  Dropdown.propTypes = {
    allowBlank: _propTypes2.default.bool,
    auto: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    error: _propTypes2.default.string,
    label: _propTypes2.default.string,
    labelKey: _propTypes2.default.string,
    name: _propTypes2.default.string,
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    required: _propTypes2.default.bool,
    source: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])).isRequired,
    template: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      active: _propTypes2.default.string,
      disabled: _propTypes2.default.string,
      dropdown: _propTypes2.default.string,
      error: _propTypes2.default.string,
      errored: _propTypes2.default.string,
      field: _propTypes2.default.string,
      label: _propTypes2.default.string,
      required: _propTypes2.default.string,
      selected: _propTypes2.default.string,
      templateValue: _propTypes2.default.string,
      up: _propTypes2.default.string,
      value: _propTypes2.default.string,
      values: _propTypes2.default.string
    }),
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    valueKey: _propTypes2.default.string
  };
  Dropdown.defaultProps = {
    auto: true,
    className: '',
    allowBlank: true,
    disabled: false,
    labelKey: 'label',
    required: false,
    valueKey: 'value'
  };


  return Dropdown;
};

var Dropdown = factory(_Input2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.DROPDOWN)(Dropdown);
exports.dropdownFactory = factory;
exports.Dropdown = Dropdown;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1912);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--dropdown--2swCWb0u {\n  position: relative;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--dropdown--2swCWb0u *,\n    .theme--dropdown--2swCWb0u *::after,\n    .theme--dropdown--2swCWb0u *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--dropdown--2swCWb0u:not(.theme--active--2DhLhq-v) > .theme--values--zzbgVjjn {\n  max-height: 0;\n  visibility: hidden;\n}\n.theme--dropdown--2swCWb0u.theme--active--2DhLhq-v > .theme--label--gDvvVpfZ,\n    .theme--dropdown--2swCWb0u.theme--active--2DhLhq-v > .theme--value--ZKriOxdC {\n  opacity: 0.5;\n}\n.theme--dropdown--2swCWb0u.theme--active--2DhLhq-v > .theme--values--zzbgVjjn {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, .12), 0 1px 4px rgba(0, 0, 0, .24);\n  max-height: 45vh;\n  visibility: visible;\n}\n.theme--dropdown--2swCWb0u:not(.theme--up--2K-HD1iZ) > .theme--values--zzbgVjjn {\n  bottom: auto;\n  top: 0;\n}\n.theme--dropdown--2swCWb0u.theme--up--2K-HD1iZ > .theme--values--zzbgVjjn {\n  bottom: 0;\n  top: auto;\n}\n.theme--dropdown--2swCWb0u.theme--disabled--17Y0f7Ov {\n  cursor: normal;\n  pointer-events: none;\n}\n.theme--value--ZKriOxdC > input {\n  cursor: pointer;\n}\n.theme--value--ZKriOxdC::after {\n  border-left: 5.48571px solid transparent;\n  border-right: 5.48571px solid transparent;\n  border-top: 5.48571px solid rgba(0, 0, 0, 0.12);\n  content: '';\n  height: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transition: -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 0;\n}\n.theme--field--1g21bwuz {\n  cursor: pointer;\n  padding: 20px 0;\n  position: relative\n}\n.theme--field--1g21bwuz.theme--errored--2bMvs3HK {\n  padding-bottom: 0;\n}\n.theme--field--1g21bwuz.theme--errored--2bMvs3HK > .theme--label--gDvvVpfZ {\n  color: rgb(222, 50, 38);\n}\n.theme--field--1g21bwuz.theme--errored--2bMvs3HK > .theme--templateValue--HhBpqKrV {\n  border-bottom: 1px solid rgb(222, 50, 38);\n}\n.theme--field--1g21bwuz.theme--errored--2bMvs3HK > .theme--label--gDvvVpfZ > .theme--required--3jLvXKNn {\n  color: rgb(222, 50, 38);\n}\n.theme--field--1g21bwuz.theme--disabled--17Y0f7Ov {\n  cursor: normal;\n  pointer-events: none;\n}\n.theme--field--1g21bwuz.theme--disabled--17Y0f7Ov > .theme--templateValue--HhBpqKrV {\n  border-bottom-style: dotted;\n  opacity: 0.7;\n}\n.theme--templateValue--HhBpqKrV {\n  background-color: transparent;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  color: rgb(33, 33, 33);\n  min-height: 38.4px;\n  padding: 8px 0;\n  position: relative;\n}\n.theme--label--gDvvVpfZ {\n  color: rgba(0, 0, 0, 0.26);\n  font-size: 12px;\n  left: 0;\n  line-height: 16px;\n  position: absolute;\n  top: 6px\n}\n.theme--label--gDvvVpfZ .theme--required--3jLvXKNn {\n  color: rgb(222, 50, 38);\n}\n.theme--error--3EAXrhv5 {\n  color: rgb(222, 50, 38);\n  font-size: 12px;\n  line-height: 20px;\n  margin-bottom: -20px;\n}\n.theme--values--zzbgVjjn {\n  background-color: rgb(255, 255, 255);\n  border-radius: 2px;\n  list-style: none;\n  margin: 0;\n  overflow-y: auto;\n  padding: 0;\n  position: absolute;\n  transition-duration: 0.35s;\n  transition-property: max-height, box-shadow;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: 100%;\n  z-index: 100\n}\n.theme--values--zzbgVjjn > * {\n  cursor: pointer;\n  overflow: hidden;\n  padding: 10px;\n  position: relative;\n}\n.theme--values--zzbgVjjn > *:hover:not(.theme--disabled--17Y0f7Ov) {\n  background-color: rgb(238, 238, 238);\n}\n.theme--values--zzbgVjjn > *.theme--selected--34e_cKYu {\n  color: rgb(63, 81, 181);\n}\n.theme--values--zzbgVjjn > *.theme--disabled--17Y0f7Ov {\n  color: rgba(0, 0, 0, 0.26);\n  cursor: not-allowed;\n}\n.theme--values--zzbgVjjn::-webkit-scrollbar {\n  height: 0;\n  width: 0;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/dropdown/theme.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,cAAc;EACd,mBAAmB;CACpB;AACD;;EAEE,aAAa;CACd;AACD;EACE,uEAAuE;EACvE,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,aAAa;EACb,OAAO;CACR;AACD;EACE,UAAU;EACV,UAAU;CACX;AACD;EACE,eAAe;EACf,qBAAqB;CACtB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,gDAAgD;EAChD,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,iEAAiE;EACjE,yDAAyD;EACzD,+GAA+G;EAC/G,SAAS;CACV;AACD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,wBAAwB;CACzB;AACD;EACE,0CAA0C;CAC3C;AACD;EACE,wBAAwB;CACzB;AACD;EACE,eAAe;EACf,qBAAqB;CACtB;AACD;EACE,4BAA4B;EAC5B,aAAa;CACd;AACD;EACE,8BAA8B;EAC9B,6CAA6C;EAC7C,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;CACpB;AACD;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;CACT;AACD;EACE,wBAAwB;CACzB;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;CACtB;AACD;EACE,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;EAC5C,yDAAyD;EACzD,YAAY;EACZ,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;CACpB;AACD;EACE,qCAAqC;CACtC;AACD;EACE,wBAAwB;CACzB;AACD;EACE,2BAA2B;EAC3B,oBAAoB;CACrB;AACD;EACE,UAAU;EACV,SAAS;CACV","file":"theme.css","sourcesContent":[".dropdown {\n  position: relative;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.dropdown *,\n    .dropdown *::after,\n    .dropdown *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.dropdown:not(.active) > .values {\n  max-height: 0;\n  visibility: hidden;\n}\n.dropdown.active > .label,\n    .dropdown.active > .value {\n  opacity: 0.5;\n}\n.dropdown.active > .values {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, .12), 0 1px 4px rgba(0, 0, 0, .24);\n  max-height: 45vh;\n  visibility: visible;\n}\n.dropdown:not(.up) > .values {\n  bottom: auto;\n  top: 0;\n}\n.dropdown.up > .values {\n  bottom: 0;\n  top: auto;\n}\n.dropdown.disabled {\n  cursor: normal;\n  pointer-events: none;\n}\n.value > input {\n  cursor: pointer;\n}\n.value::after {\n  border-left: 5.48571px solid transparent;\n  border-right: 5.48571px solid transparent;\n  border-top: 5.48571px solid rgba(0, 0, 0, 0.12);\n  content: '';\n  height: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transition: -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 0;\n}\n.field {\n  cursor: pointer;\n  padding: 20px 0;\n  position: relative\n}\n.field.errored {\n  padding-bottom: 0;\n}\n.field.errored > .label {\n  color: rgb(222, 50, 38);\n}\n.field.errored > .templateValue {\n  border-bottom: 1px solid rgb(222, 50, 38);\n}\n.field.errored > .label > .required {\n  color: rgb(222, 50, 38);\n}\n.field.disabled {\n  cursor: normal;\n  pointer-events: none;\n}\n.field.disabled > .templateValue {\n  border-bottom-style: dotted;\n  opacity: 0.7;\n}\n.templateValue {\n  background-color: transparent;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  color: rgb(33, 33, 33);\n  min-height: 38.4px;\n  padding: 8px 0;\n  position: relative;\n}\n.label {\n  color: rgba(0, 0, 0, 0.26);\n  font-size: 12px;\n  left: 0;\n  line-height: 16px;\n  position: absolute;\n  top: 6px\n}\n.label .required {\n  color: rgb(222, 50, 38);\n}\n.error {\n  color: rgb(222, 50, 38);\n  font-size: 12px;\n  line-height: 20px;\n  margin-bottom: -20px;\n}\n.values {\n  background-color: rgb(255, 255, 255);\n  border-radius: 2px;\n  list-style: none;\n  margin: 0;\n  overflow-y: auto;\n  padding: 0;\n  position: absolute;\n  transition-duration: 0.35s;\n  transition-property: max-height, box-shadow;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: 100%;\n  z-index: 100\n}\n.values > * {\n  cursor: pointer;\n  overflow: hidden;\n  padding: 10px;\n  position: relative;\n}\n.values > *:hover:not(.disabled) {\n  background-color: rgb(238, 238, 238);\n}\n.values > *.selected {\n  color: rgb(63, 81, 181);\n}\n.values > *.disabled {\n  color: rgba(0, 0, 0, 0.26);\n  cursor: not-allowed;\n}\n.values::-webkit-scrollbar {\n  height: 0;\n  width: 0;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"dropdown": "theme--dropdown--2swCWb0u",
	"active": "theme--active--2DhLhq-v",
	"values": "theme--values--zzbgVjjn",
	"label": "theme--label--gDvvVpfZ",
	"value": "theme--value--ZKriOxdC",
	"up": "theme--up--2K-HD1iZ",
	"disabled": "theme--disabled--17Y0f7Ov",
	"field": "theme--field--1g21bwuz",
	"errored": "theme--errored--2bMvs3HK",
	"templateValue": "theme--templateValue--HhBpqKrV",
	"required": "theme--required--3jLvXKNn",
	"error": "theme--error--3EAXrhv5",
	"selected": "theme--selected--34e_cKYu"
};

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.flat-card--card--21V4h5lI {\n  border-radius: 0;\n  border-radius: initial;\n  box-shadow: none;\n  box-shadow: initial;\n  overflow: visible;\n  overflow: initial;\n}\n\n.flat-card--checkbox--2HeG3EeB {\n  margin-left: 5px;\n}\n\n.flat-card--field--3bt40gAc[class~=deleteCheck]{\n  padding-top: 10px;\n}\n\n.flat-card--field--3bt40gAc[class~=deleteCheck] .flat-card--text--f5JiLjpJ{\n  color: #757575;\n}\n\n.flat-card--field--3bt40gAc[class~=logoutCheck]{\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin: auto;\n  width: 80%;\n}\n\n.flat-card--field--3bt40gAc[class~=logoutCheck] .flat-card--text--f5JiLjpJ{\n  color: #757575;\n  font-size: 14px;\n}\n\n.flat-card--dropdown--3IXJ5m8A:not(.flat-card--up--2rWUPVBg)[class~=notification] > .flat-card--values--2jIznYbq {\n  bottom: auto;\n  top: 40px;\n}\n\n.flat-card--dropdown--3IXJ5m8A[class~=notification] .flat-card--field--3bt40gAc {\n  padding: 0px 0;\n}\n\n.flat-card--rightButton--1n1tA7Ln {\n  width: 250px;\n  right: 0;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-orient: horizontal !important;\n  -webkit-box-direction: normal !important;\n      -ms-flex-direction: row !important;\n          flex-direction: row !important;\n}\n\n.flat-card--notificationContainer--ePVeyyyI {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  text-align: right;\n  margin: 12px auto;\n}\n\n.flat-card--leftLabel--BvV-eIdm {\n  margin: 0 0 0 auto;\n}\n\n.flat-card--rightLabel--2yDVQPFg {\n  margin: 0 64px 0 72px;\n}\n\n.flat-card--labelContainer--1mw57PTd {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: end;\n}\n\n.flat-card--adminLabel--6MVrnvOK {\n  margin: 0 190px 0 0;\n}\n\n.flat-card--remindLabel--212H_nWG {\n  margin: 0 90px 0 0;\n}\n\n.flat-card--switch--3qZlo0hF {\n  margin-right: 100px;\n}\n\n.flat-card--singleSwitch--nN1PyI3_ {\n  margin-right: 200px;\n}\n\n.flat-card--singleSwitch--nN1PyI3_>input {\n  display: none;\n}\n\n.flat-card--switch--3qZlo0hF>input[type=\"checkbox\"][checked] {\n  height: 0;\n}\n\n.flat-card--datePickerContainer--1BQA8VqQ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 20px;\n}\n\n.flat-card--datePickerContainer--1BQA8VqQ div {\n  width: 100%;\n}\n\n.flat-card--datePickerContainer--1BQA8VqQ div div input:focus-within {\n  border-bottom: 2px solid rgb(63, 81, 181);\n}\n\n.flat-card--fontIcon--1EJZRBhA {\n  vertical-align: middle;\n  margin-left: 14px;\n  margin-right: 30px;\n  color: #bfbfbf;\n}\n\n.flat-card--departmentContainer--1FE3juNH {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.flat-card--departmentContainer--1FE3juNH div {\n  width: 100%;\n}\n\n.flat-card--departmentContainer--1FE3juNH div input:active {\n  border-bottom: 2px solid rgb(63, 81, 181);\n}\n\n.flat-card--cancelBirthdayBtn--1Gq9NPSK {\n  margin-left: 10px;\n}\n\n@media (max-width: 768px) {\n  .flat-card--rightLabel--2yDVQPFg {\n    margin: 0 0 0 10px; \n  }\n  .flat-card--rightButton--1n1tA7Ln {\n    width: 60px;\n    right: 0;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n            flex-direction: row !important;\n  }\n  .flat-card--switch--3qZlo0hF {\n    margin-right: 10px;\n  }\n\n  .flat-card--itemContentRoot--3JfDNVNb {\n    width: 100px;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    white-space: normal;\n    word-break: break-word;\n  }\n}", "", {"version":3,"sources":["/./src/web/components/themes/flat-card.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,eAAe;CAChB;;AAED;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,WAAW;CACZ;;AAED;EACE,eAAe;EACf,gBAAgB;CACjB;;AAED;EACE,aAAa;EACb,UAAU;CACX;;AAED;EACE,eAAe;CAChB;;AAED;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,gCAAgC;EAChC,yBAAyB;EACzB,0CAA0C;EAC1C,yCAAyC;MACrC,mCAAmC;UAC/B,+BAA+B;CACxC;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,uBAAuB;MACnB,oBAAoB;UAChB,sBAAsB;EAC9B,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,sBAAsB;CACvB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;MAClB,mBAAmB;UACf,qBAAqB;CAC9B;;AAED;EACE,oBAAoB;CACrB;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,oBAAoB;CACrB;;AAED;EACE,oBAAoB;CACrB;;AAED;EACE,cAAc;CACf;;AAED;EACE,UAAU;CACX;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,iBAAiB;CAClB;;AAED;EACE,YAAY;CACb;;AAED;EACE,0CAA0C;CAC3C;;AAED;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;CAChB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;;AAED;EACE,YAAY;CACb;;AAED;EACE,0CAA0C;CAC3C;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE;IACE,mBAAmB;GACpB;EACD;IACE,YAAY;IACZ,SAAS;IACT,gCAAgC;IAChC,gCAAgC;IAChC,yBAAyB;IACzB,0CAA0C;IAC1C,yCAAyC;QACrC,mCAAmC;YAC/B,+BAA+B;GACxC;EACD;IACE,mBAAmB;GACpB;;EAED;IACE,aAAa;IACb,qBAAqB;QACjB,eAAe;IACnB,oBAAoB;IACpB,uBAAuB;GACxB;CACF","file":"flat-card.css","sourcesContent":["\n.card {\n  border-radius: 0;\n  border-radius: initial;\n  box-shadow: none;\n  box-shadow: initial;\n  overflow: visible;\n  overflow: initial;\n}\n\n.checkbox {\n  margin-left: 5px;\n}\n\n.field[class~=deleteCheck]{\n  padding-top: 10px;\n}\n\n.field[class~=deleteCheck] .text{\n  color: #757575;\n}\n\n.field[class~=logoutCheck]{\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin: auto;\n  width: 80%;\n}\n\n.field[class~=logoutCheck] .text{\n  color: #757575;\n  font-size: 14px;\n}\n\n.dropdown:not(.up)[class~=notification] > .values {\n  bottom: auto;\n  top: 40px;\n}\n\n.dropdown[class~=notification] .field {\n  padding: 0px 0;\n}\n\n.rightButton {\n  width: 250px;\n  right: 0;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-orient: horizontal !important;\n  -webkit-box-direction: normal !important;\n      -ms-flex-direction: row !important;\n          flex-direction: row !important;\n}\n\n.notificationContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  text-align: right;\n  margin: 12px auto;\n}\n\n.leftLabel {\n  margin: 0 0 0 auto;\n}\n\n.rightLabel {\n  margin: 0 64px 0 72px;\n}\n\n.labelContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: end;\n}\n\n.adminLabel {\n  margin: 0 190px 0 0;\n}\n\n.remindLabel {\n  margin: 0 90px 0 0;\n}\n\n.switch {\n  margin-right: 100px;\n}\n\n.singleSwitch {\n  margin-right: 200px;\n}\n\n.singleSwitch>input {\n  display: none;\n}\n\n.switch>input[type=\"checkbox\"][checked] {\n  height: 0;\n}\n\n.datePickerContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 20px;\n}\n\n.datePickerContainer div {\n  width: 100%;\n}\n\n.datePickerContainer div div input:focus-within {\n  border-bottom: 2px solid rgb(63, 81, 181);\n}\n\n.fontIcon {\n  vertical-align: middle;\n  margin-left: 14px;\n  margin-right: 30px;\n  color: #bfbfbf;\n}\n\n.departmentContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.departmentContainer div {\n  width: 100%;\n}\n\n.departmentContainer div input:active {\n  border-bottom: 2px solid rgb(63, 81, 181);\n}\n\n.cancelBirthdayBtn {\n  margin-left: 10px;\n}\n\n@media (max-width: 768px) {\n  .rightLabel {\n    margin: 0 0 0 10px; \n  }\n  .rightButton {\n    width: 60px;\n    right: 0;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n            flex-direction: row !important;\n  }\n  .switch {\n    margin-right: 10px;\n  }\n\n  .itemContentRoot {\n    width: 100px;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    white-space: normal;\n    word-break: break-word;\n  }\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"card": "flat-card--card--21V4h5lI",
	"checkbox": "flat-card--checkbox--2HeG3EeB",
	"field": "flat-card--field--3bt40gAc",
	"text": "flat-card--text--f5JiLjpJ",
	"dropdown": "flat-card--dropdown--3IXJ5m8A",
	"up": "flat-card--up--2rWUPVBg",
	"values": "flat-card--values--2jIznYbq",
	"rightButton": "flat-card--rightButton--1n1tA7Ln",
	"notificationContainer": "flat-card--notificationContainer--ePVeyyyI",
	"leftLabel": "flat-card--leftLabel--BvV-eIdm",
	"rightLabel": "flat-card--rightLabel--2yDVQPFg",
	"labelContainer": "flat-card--labelContainer--1mw57PTd",
	"adminLabel": "flat-card--adminLabel--6MVrnvOK",
	"remindLabel": "flat-card--remindLabel--212H_nWG",
	"switch": "flat-card--switch--3qZlo0hF",
	"singleSwitch": "flat-card--singleSwitch--nN1PyI3_",
	"datePickerContainer": "flat-card--datePickerContainer--1BQA8VqQ",
	"fontIcon": "flat-card--fontIcon--1EJZRBhA",
	"departmentContainer": "flat-card--departmentContainer--1FE3juNH",
	"cancelBirthdayBtn": "flat-card--cancelBirthdayBtn--1Gq9NPSK",
	"itemContentRoot": "flat-card--itemContentRoot--3JfDNVNb"
};

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__(1915);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _utils = __webpack_require__(1916);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-debugger: "warn" */


/**
 * Predefined constants
 * @type {Object}
 */
var constants = {
  orientation: {
    horizontal: {
      dimension: 'width',
      direction: 'left',
      reverseDirection: 'right',
      coordinate: 'x'
    },
    vertical: {
      dimension: 'height',
      direction: 'top',
      reverseDirection: 'bottom',
      coordinate: 'y'
    }
  }
};

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider(props, context) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props, context));

    _this.handleNoop = function (e) {
      e.stopPropagation();
      e.preventDefault();
    };

    _this.handleFormat = function (value) {
      var format = _this.props.format;

      return format ? format(value) : value;
    };

    _this.handleUpdate = function () {
      if (!_this.slider) {
        // for shallow rendering
        return;
      }
      var orientation = _this.props.orientation;

      var dimension = (0, _utils.capitalize)(constants.orientation[orientation].dimension);
      var sliderPos = _this.slider['offset' + dimension];
      var handlePos = _this.handle['offset' + dimension];

      _this.setState({
        limit: sliderPos - handlePos,
        grab: handlePos / 2
      });
    };

    _this.handleStart = function (e) {
      var onChangeStart = _this.props.onChangeStart;

      document.addEventListener('mousemove', _this.handleDrag);
      document.addEventListener('mouseup', _this.handleEnd);
      onChangeStart && onChangeStart(e);
    };

    _this.handleDrag = function (e) {
      _this.handleNoop(e);
      var onChange = _this.props.onChange;
      var target = e.target;

      if (!onChange) return;

      var value = _this.position(e);
      if (target.classList.contains('rangeslider__label') && target.dataset.value) {
        value = parseFloat(target.dataset.value);
      }

      onChange && onChange(value, e);
    };

    _this.handleEnd = function (e) {
      var onChangeComplete = _this.props.onChangeComplete;

      onChangeComplete && onChangeComplete(e);
      document.removeEventListener('mousemove', _this.handleDrag);
      document.removeEventListener('mouseup', _this.handleEnd);
    };

    _this.getPositionFromValue = function (value) {
      var limit = _this.state.limit;
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;

      var diffMaxMin = max - min;
      var diffValMin = value - min;
      var percentage = diffValMin / diffMaxMin;
      var pos = Math.round(percentage * limit);

      return pos;
    };

    _this.getValueFromPosition = function (pos) {
      var limit = _this.state.limit;
      var _this$props2 = _this.props,
          orientation = _this$props2.orientation,
          min = _this$props2.min,
          max = _this$props2.max,
          step = _this$props2.step;

      var percentage = (0, _utils.clamp)(pos, 0, limit) / (limit || 1);
      var baseVal = step * Math.round(percentage * (max - min) / step);
      var value = orientation === 'horizontal' ? baseVal + min : max - baseVal;

      return (0, _utils.clamp)(value, min, max);
    };

    _this.position = function (e) {
      var grab = _this.state.grab;
      var _this$props3 = _this.props,
          orientation = _this$props3.orientation,
          reverse = _this$props3.reverse;


      var node = _this.slider;
      var coordinateStyle = constants.orientation[orientation].coordinate;
      var directionStyle = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
      var clientCoordinateStyle = 'client' + (0, _utils.capitalize)(coordinateStyle);
      var coordinate = !e.touches ? e[clientCoordinateStyle] : e.touches[0][clientCoordinateStyle];
      var direction = node.getBoundingClientRect()[directionStyle];
      var pos = reverse ? direction - coordinate - grab : coordinate - direction - grab;
      var value = _this.getValueFromPosition(pos);

      return value;
    };

    _this.coordinates = function (pos) {
      var _this$state = _this.state,
          limit = _this$state.limit,
          grab = _this$state.grab;
      var orientation = _this.props.orientation;

      var value = _this.getValueFromPosition(pos);
      var handlePos = _this.getPositionFromValue(value);
      var sumHandleposGrab = orientation === 'horizontal' ? handlePos + grab : handlePos;
      var fillPos = orientation === 'horizontal' ? sumHandleposGrab : limit - sumHandleposGrab;

      return {
        fill: fillPos,
        handle: handlePos,
        label: handlePos
      };
    };

    _this.state = {
      limit: 0,
      grab: 0
    };
    return _this;
  }

  _createClass(Slider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleUpdate();
      var resizeObserver = new _resizeObserverPolyfill2.default(this.handleUpdate);
      resizeObserver.observe(this.slider);
    }

    /**
     * Prevent default event and bubbling
     * @param  {Object} e - Event object
     * @return {void}
     */


    /**
     * Format label/tooltip value
     * @param  {Number} - value
     * @return {Formatted Number}
     */


    /**
     * Update slider state on change
     * @return {void}
     */


    /**
     * Attach event listeners to mousemove/mouseup events
     * @return {void}
     */


    /**
     * Handle drag/mousemove event
     * @param  {Object} e - Event object
     * @return {void}
     */


    /**
     * Detach event listeners to mousemove/mouseup events
     * @return {void}
     */


    /**
     * Calculate position of slider based on its value
     * @param  {number} value - Current value of slider
     * @return {position} pos - Calculated position of slider based on value
     */


    /**
     * Translate position of slider to slider value
     * @param  {number} pos - Current position/coordinates of slider
     * @return {number} value - Slider value
     */


    /**
     * Calculate position of slider based on value
     * @param  {Object} e - Event object
     * @return {number} value - Slider value
     */


    /**
     * Grab coordinates of slider
     * @param  {Object} pos - Position object
     * @return {Object} - Slider fill/handle coordinates
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          orientation = _props.orientation,
          className = _props.className,
          tooltip = _props.tooltip,
          reverse = _props.reverse;

      var dimension = constants.orientation[orientation].dimension;
      var direction = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
      var position = this.getPositionFromValue(value);
      var coords = this.coordinates(position);
      var fillStyle = _defineProperty({}, dimension, coords.fill + 'px');
      var handleStyle = _defineProperty({}, direction, coords.handle + 'px');
      var labels = null;
      var labelKeys = Object.keys(this.props.labels);

      if (labelKeys.length > 0) {
        var items = [];

        labelKeys = labelKeys.sort(function (a, b) {
          return reverse ? a - b : b - a;
        });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = labelKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var labelPosition = this.getPositionFromValue(key);
            var labelCoords = this.coordinates(labelPosition);
            var labelStyle = _defineProperty({}, direction, labelCoords.label + 'px');
            items.push(_react2.default.createElement(
              'li',
              {
                key: key,
                className: (0, _classnames2.default)('rangeslider__label'),
                'data-value': key,
                onMouseDown: this.handleDrag,
                onTouchStart: this.handleDrag,
                onTouchEnd: this.handleEnd,
                style: labelStyle
              },
              this.props.labels[key]
            ));
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        labels = _react2.default.createElement(
          'ul',
          {
            ref: function ref(sl) {
              _this2.labels = sl;
            },
            className: (0, _classnames2.default)('rangeslider__label-list')
          },
          items
        );
      }

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(s) {
            _this2.slider = s;
          },
          className: (0, _classnames2.default)('rangeslider', 'rangeslider-' + orientation, { 'rangeslider-reverse': reverse }, className),
          onMouseDown: this.handleDrag,
          onMouseUp: this.handleEnd,
          onTouchStart: this.handleDrag,
          onTouchEnd: this.handleEnd
        },
        _react2.default.createElement('div', { className: 'rangeslider__fill', style: fillStyle }),
        _react2.default.createElement(
          'div',
          {
            ref: function ref(sh) {
              _this2.handle = sh;
            },
            className: 'rangeslider__handle',
            onMouseDown: this.handleStart,
            onTouchMove: this.handleDrag,
            onTouchEnd: this.handleEnd,
            style: handleStyle
          },
          tooltip && _react2.default.createElement(
            'div',
            {
              ref: function ref(st) {
                _this2.tooltip = st;
              },
              className: 'rangeslider__tooltip'
            },
            _react2.default.createElement(
              'span',
              null,
              this.handleFormat(value)
            )
          )
        ),
        labels
      );
    }
  }]);

  return Slider;
}(_react.Component);

Slider.propTypes = {
  min: _propTypes2.default.number,
  max: _propTypes2.default.number,
  step: _propTypes2.default.number,
  value: _propTypes2.default.number,
  orientation: _propTypes2.default.string,
  tooltip: _propTypes2.default.bool,
  reverse: _propTypes2.default.bool,
  labels: _propTypes2.default.object,
  format: _propTypes2.default.func,
  onChangeStart: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onChangeComplete: _propTypes2.default.func
};
Slider.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  value: 0,
  orientation: 'horizontal',
  tooltip: true,
  reverse: false,
  labels: {}
};
exports.default = Slider;

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map != 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: {} };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window != 'undefined' && typeof document != 'undefined' && window.document === document;

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        return requestAnimationFrame;
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Detect whether running in IE 11 (facepalm).
var isIE11 = typeof navigator != 'undefined' && /Trident\/.*rv:11/.test(navigator.userAgent);

// MutationObserver should not be used if running in Internet Explorer 11 as it's
// implementation is unreliable. Example: https://jsfiddle.net/x2r3jpuz/2/
//
// It's a real bummer that there is no other way to check for this issue but to
// use the UA information.
var mutationObserverSupported = typeof MutationObserver != 'undefined' && !isIE11;

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;

    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */
    this.mutationEventsAdded_ = false;

    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */
    this.mutationsObserver_ = null;

    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName;

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */
ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = Array.prototype.slice.call(arguments, 1);

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement != 'undefined') {
        return function (target) { return target instanceof SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly != 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;

    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */
    this.broadcastHeight = 0;

    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    /**
     * Reference to the observed element.
     *
     * @type {Element}
     */
    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];

    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */
    this.observations_ = new MapShim();

    /**
     * Reference to the callback function.
     *
     * @private {ResizeObserverCallback}
     */
    this.callback_ = callback;

    /**
     * Reference to the associated ResizeObserverController.
     *
     * @private {ResizeObserverController}
     */
    this.controller_ = controller;

    /**
     * Public ResizeObserver instance which will be passed to the callback
     * function and used as a value of it's "this" binding.
     *
     * @private {ResizeObserver}
     */
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap != 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = function(callback) {
    if (!(this instanceof ResizeObserver$1)) {
        throw new TypeError('Cannot call a class as a function');
    }

    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof ResizeObserver != 'undefined') {
        // eslint-disable-next-line no-undef
        return ResizeObserver;
    }

    return ResizeObserver$1;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.clamp = clamp;
/**
 * Capitalize first letter of string
 * @private
 * @param  {string} - String
 * @return {string} - String with first letter capitalized
 */
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
}

/**
 * Clamp position between a range
 * @param  {number} - Value to be clamped
 * @param  {number} - Minimum value in range
 * @param  {number} - Maximum value in range
 * @return {number} - Clamped value
 */
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/**\n* Rangeslider\n*/\n.rangeslider {\n  margin: 20px 0;\n  position: relative;\n  background: #e6e6e6;\n  -ms-touch-action: none;\n  touch-action: none;\n}\n.rangeslider,\n.rangeslider .rangeslider__fill {\n  display: block;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, .4);\n}\n.rangeslider .rangeslider__handle {\n  background: #fff;\n  border: 1px solid #ccc;\n  cursor: pointer;\n  display: inline-block;\n  position: absolute;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, .4), 0 -1px 3px rgba(0, 0, 0, .4);\n}\n.rangeslider .rangeslider__handle:hover .rangeslider__tooltip {\n  opacity: 1;\n}\n.rangeslider .rangeslider__tooltip {\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  position: absolute;\n  background-color: rgba(0, 0, 0, .8);\n  font-weight: normal;\n  font-size: 14px;\n  transition: all 100ms ease-in;\n  border-radius: 4px;\n  display: inline-block;\n  color: white;\n  opacity: 0;\n}\n.rangeslider .rangeslider__tooltip span {\n  margin-top: 12px;\n  display: inline-block;\n  line-height: 100%;\n}\n.rangeslider .rangeslider__tooltip:after {\n  content: ' ';\n  position: absolute;\n  width: 0;\n  height: 0;\n}\n/**\n* Rangeslider - Horizontal slider\n*/\n.rangeslider-horizontal {\n  height: 12px;\n  border-radius: 10px;\n}\n.rangeslider-horizontal .rangeslider__fill {\n  height: 100%;\n  background-color: #7CB342;\n  border-radius: 10px;\n  top: 0;\n}\n.rangeslider-horizontal .rangeslider__handle {\n  width: 30px;\n  height: 30px;\n  border-radius: 30px;\n  top: -10px;\n}\n.rangeslider-horizontal .rangeslider__handle:after {\n  content: ' ';\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  top: 6px;\n  left: 6px;\n  border-radius: 50%;\n  background-color: #dadada;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, .4) inset, 0 -1px 3px rgba(0, 0, 0, .4) inset;\n}\n.rangeslider-horizontal .rangeslider__tooltip {\n  top: -55px;\n}\n.rangeslider-horizontal .rangeslider__tooltip:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid rgba(0, 0, 0, .8);\n  left: 12px;\n  bottom: -8px;\n}\n/**\n* Rangeslider - Vertical slider\n*/\n.rangeslider-vertical {\n  margin: 20px auto;\n  height: 150px;\n  max-width: 10px;\n  background-color: transparent;\n}\n.rangeslider-vertical .rangeslider__fill,\n.rangeslider-vertical .rangeslider__handle {\n  position: absolute;\n}\n.rangeslider-vertical .rangeslider__fill {\n  width: 100%;\n  background-color: #7CB342;\n  box-shadow: none;\n  bottom: 0;\n}\n.rangeslider-vertical .rangeslider__handle {\n  width: 30px;\n  height: 10px;\n  left: -10px;\n  box-shadow: none;\n}\n.rangeslider-vertical .rangeslider__tooltip {\n  left: -55px;\n  top: -15px;\n}\n.rangeslider-vertical .rangeslider__tooltip:after {\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-left: 8px solid rgba(0, 0, 0, .8);\n  left: 100%;\n  top: 12px;\n}\n/**\n* Rangeslider - Reverse\n*/\n.rangeslider-reverse.rangeslider-horizontal .rangeslider__fill {\n  right: 0;\n}\n.rangeslider-reverse.rangeslider-vertical .rangeslider__fill {\n  top: 0;\n  bottom: inherit;\n}\n/**\n* Rangeslider - Labels\n*/\n.rangeslider-vertical .rangeslider__label-list {\n  position: relative;\n  list-style-type: none;\n  margin: 0 0 0 24px;\n  padding: 0;\n  text-align: left;\n  width: 250px;\n}\n.rangeslider-vertical .rangeslider__label-list .rangeslider__label {\n  position: absolute;\n}\n.rangeslider-vertical .rangeslider__label-list .rangeslider__label::before {\n  content: '';\n  width: 10px;\n  height: 2px;\n  background: black;\n  position: absolute;\n  left: -14px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  z-index: -1;\n}\n.rangeslider__label-list .rangeslider__label {\n  position: absolute;\n  font-size: 14px;\n  cursor: pointer;\n  display: inline-block;\n  top: 10px;\n}\n", ""]);

// exports


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1919);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--linear--JEuO8g-f {\n  background: rgb(238, 238, 238);\n  display: inline-block;\n  height: 4px;\n  overflow: hidden;\n  position: relative;\n  width: 100%\n}\n.theme--linear--JEuO8g-f.theme--indeterminate--4Xd0Y-CL .theme--value--1sYsmnME {\n  -webkit-animation: theme--linear-indeterminate-bar--1nG1yWmE 1s linear infinite;\n          animation: theme--linear-indeterminate-bar--1nG1yWmE 1s linear infinite;\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n.theme--value--1sYsmnME,\n.theme--buffer--1ea7-zJr {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  -webkit-transform: scaleX(0);\n          transform: scaleX(0);\n  -webkit-transform-origin: left center;\n          transform-origin: left center;\n  transition-duration: 0.35s;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.theme--value--1sYsmnME {\n  background-color: rgb(63, 81, 181);\n}\n.theme--buffer--1ea7-zJr {\n  background-image:\n    linear-gradient(to right, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)),\n    linear-gradient(to right, rgb(63, 81, 181), rgb(63, 81, 181));\n}\n.theme--circular--2fReLSLF {\n  display: inline-block;\n  height: 60px;\n  position: relative;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n  width: 60px\n}\n.theme--circular--2fReLSLF.theme--indeterminate--4Xd0Y-CL .theme--circle--2UI1LHDa {\n  -webkit-animation: theme--circular-indeterminate-bar-rotate--2aoK7qNK 2s linear infinite;\n          animation: theme--circular-indeterminate-bar-rotate--2aoK7qNK 2s linear infinite;\n}\n.theme--circular--2fReLSLF.theme--indeterminate--4Xd0Y-CL .theme--path--zFYb5BfM {\n  -webkit-animation: theme--circular-indeterminate-bar-dash--272Bqk2S 1.5s ease-in-out infinite;\n          animation: theme--circular-indeterminate-bar-dash--272Bqk2S 1.5s ease-in-out infinite;\n  stroke-dasharray: 1.25, 250;\n  stroke-dashoffset: 0;\n}\n.theme--circular--2fReLSLF.theme--indeterminate--4Xd0Y-CL.theme--multicolor--36xdGzyb .theme--path--zFYb5BfM {\n  -webkit-animation:\n        theme--circular-indeterminate-bar-dash--272Bqk2S 1.5s ease-in-out infinite,         theme--colors--24yUKjiR 6s ease-in-out infinite;\n          animation:\n        theme--circular-indeterminate-bar-dash--272Bqk2S 1.5s ease-in-out infinite,         theme--colors--24yUKjiR 6s ease-in-out infinite;\n}\n.theme--circular--2fReLSLF[disabled] .theme--value--1sYsmnME, .theme--linear--JEuO8g-f[disabled] .theme--value--1sYsmnME {\n  background-color: rgba(0, 0, 0, 0.26);\n}\n.theme--circular--2fReLSLF[disabled] .theme--buffer--1ea7-zJr, .theme--linear--JEuO8g-f[disabled] .theme--buffer--1ea7-zJr {\n  background-image:\n      linear-gradient(to right, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)),\n      linear-gradient(to right, rgba(0, 0, 0, 0.26), rgba(0, 0, 0, 0.26));\n}\n.theme--circle--2UI1LHDa {\n  height: 100%;\n  width: 100%;\n}\n.theme--path--zFYb5BfM {\n  fill: none;\n  stroke: rgb(63, 81, 181);\n  stroke-dasharray: 0, 250;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  stroke-miterlimit: 20;\n  stroke-width: 4;\n  transition: stroke-dasharray 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n@-webkit-keyframes theme--linear-indeterminate-bar--1nG1yWmE {\n  0% {\n    -webkit-transform: translate(-50%) scaleX(0);\n            transform: translate(-50%) scaleX(0);\n  }\n\n  50% {\n    -webkit-transform: translate(-0%) scaleX(0.3);\n            transform: translate(-0%) scaleX(0.3);\n  }\n\n  100% {\n    -webkit-transform: translate(50%) scaleX(0);\n            transform: translate(50%) scaleX(0);\n  }\n}\n@keyframes theme--linear-indeterminate-bar--1nG1yWmE {\n  0% {\n    -webkit-transform: translate(-50%) scaleX(0);\n            transform: translate(-50%) scaleX(0);\n  }\n\n  50% {\n    -webkit-transform: translate(-0%) scaleX(0.3);\n            transform: translate(-0%) scaleX(0.3);\n  }\n\n  100% {\n    -webkit-transform: translate(50%) scaleX(0);\n            transform: translate(50%) scaleX(0);\n  }\n}\n@-webkit-keyframes theme--circular-indeterminate-bar-rotate--2aoK7qNK {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes theme--circular-indeterminate-bar-rotate--2aoK7qNK {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes theme--circular-indeterminate-bar-dash--272Bqk2S {\n  0% {\n    stroke-dasharray: 1.25, 250;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 111.25, 250;\n    stroke-dashoffset: -43.75;\n  }\n\n  100% {\n    stroke-dasharray: 111.25, 250;\n    stroke-dashoffset: -155;\n  }\n}\n@keyframes theme--circular-indeterminate-bar-dash--272Bqk2S {\n  0% {\n    stroke-dasharray: 1.25, 250;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 111.25, 250;\n    stroke-dashoffset: -43.75;\n  }\n\n  100% {\n    stroke-dasharray: 111.25, 250;\n    stroke-dashoffset: -155;\n  }\n}\n@-webkit-keyframes theme--colors--24yUKjiR {\n  0% {\n    stroke: #4285f4;\n  }\n\n  25% {\n    stroke: #de3e35;\n  }\n\n  50% {\n    stroke: #f7c223;\n  }\n\n  75% {\n    stroke: #1b9a59;\n  }\n\n  100% {\n    stroke: #4285f4;\n  }\n}\n@keyframes theme--colors--24yUKjiR {\n  0% {\n    stroke: #4285f4;\n  }\n\n  25% {\n    stroke: #de3e35;\n  }\n\n  50% {\n    stroke: #f7c223;\n  }\n\n  75% {\n    stroke: #1b9a59;\n  }\n\n  100% {\n    stroke: #4285f4;\n  }\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/progress_bar/theme.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;CACZ;AACD;EACE,gFAA+D;UACvD,wEAAuD;EAC/D,wCAAwC;UAChC,gCAAgC;CACzC;AACD;;EAEE,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,6BAA6B;UACrB,qBAAqB;EAC7B,sCAAsC;UAC9B,8BAA8B;EACtC,2BAA2B;EAC3B,yDAAyD;CAC1D;AACD;EACE,mCAAmC;CACpC;AACD;EACE;;kEAEgE;CACjE;AACD;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;UAC1B,0BAA0B;EAClC,WAAW;CACZ;AACD;EACE,yFAAwE;UAChE,iFAAgE;CACzE;AACD;EACE,8FAA6E;UACrE,sFAAqE;EAC7E,4BAA4B;EAC5B,qBAAqB;CACtB;AACD;EACE;4IACwG;UAChG;4IACgG;CACzG;AACD;EACE,sCAAsC;CACvC;AACD;EACE;;0EAEwE;CACzE;AACD;EACE,aAAa;EACb,YAAY;CACb;AACD;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,gEAAgE;CACjE;AACD;EACE;IACE,6CAA6C;YACrC,qCAAqC;GAC9C;;EAED;IACE,8CAA8C;YACtC,sCAAsC;GAC/C;;EAED;IACE,4CAA4C;YACpC,oCAAoC;GAC7C;CACF;AACD;EACE;IACE,6CAA6C;YACrC,qCAAqC;GAC9C;;EAED;IACE,8CAA8C;YACtC,sCAAsC;GAC/C;;EAED;IACE,4CAA4C;YACpC,oCAAoC;GAC7C;CACF;AACD;EACE;IACE,kCAAkC;YAC1B,0BAA0B;GACnC;CACF;AACD;EACE;IACE,kCAAkC;YAC1B,0BAA0B;GACnC;CACF;AACD;EACE;IACE,4BAA4B;IAC5B,qBAAqB;GACtB;;EAED;IACE,8BAA8B;IAC9B,0BAA0B;GAC3B;;EAED;IACE,8BAA8B;IAC9B,wBAAwB;GACzB;CACF;AACD;EACE;IACE,4BAA4B;IAC5B,qBAAqB;GACtB;;EAED;IACE,8BAA8B;IAC9B,0BAA0B;GAC3B;;EAED;IACE,8BAA8B;IAC9B,wBAAwB;GACzB;CACF;AACD;EACE;IACE,gBAAgB;GACjB;;EAED;IACE,gBAAgB;GACjB;;EAED;IACE,gBAAgB;GACjB;;EAED;IACE,gBAAgB;GACjB;;EAED;IACE,gBAAgB;GACjB;CACF;AACD;EACE;IACE,gBAAgB;GACjB;;EAED;IACE,gBAAgB;GACjB;;EAED;IACE,gBAAgB;GACjB;;EAED;IACE,gBAAgB;GACjB;;EAED;IACE,gBAAgB;GACjB;CACF","file":"theme.css","sourcesContent":[".linear {\n  background: rgb(238, 238, 238);\n  display: inline-block;\n  height: 4px;\n  overflow: hidden;\n  position: relative;\n  width: 100%\n}\n.linear.indeterminate .value {\n  -webkit-animation: linear-indeterminate-bar 1s linear infinite;\n          animation: linear-indeterminate-bar 1s linear infinite;\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n.value,\n.buffer {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  -webkit-transform: scaleX(0);\n          transform: scaleX(0);\n  -webkit-transform-origin: left center;\n          transform-origin: left center;\n  transition-duration: 0.35s;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.value {\n  background-color: rgb(63, 81, 181);\n}\n.buffer {\n  background-image:\n    linear-gradient(to right, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)),\n    linear-gradient(to right, rgb(63, 81, 181), rgb(63, 81, 181));\n}\n.circular {\n  display: inline-block;\n  height: 60px;\n  position: relative;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n  width: 60px\n}\n.circular.indeterminate .circle {\n  -webkit-animation: circular-indeterminate-bar-rotate 2s linear infinite;\n          animation: circular-indeterminate-bar-rotate 2s linear infinite;\n}\n.circular.indeterminate .path {\n  -webkit-animation: circular-indeterminate-bar-dash 1.5s ease-in-out infinite;\n          animation: circular-indeterminate-bar-dash 1.5s ease-in-out infinite;\n  stroke-dasharray: 1.25, 250;\n  stroke-dashoffset: 0;\n}\n.circular.indeterminate.multicolor .path {\n  -webkit-animation:\n        circular-indeterminate-bar-dash 1.5s ease-in-out infinite,         colors 6s ease-in-out infinite;\n          animation:\n        circular-indeterminate-bar-dash 1.5s ease-in-out infinite,         colors 6s ease-in-out infinite;\n}\n.circular[disabled] .value, .linear[disabled] .value {\n  background-color: rgba(0, 0, 0, 0.26);\n}\n.circular[disabled] .buffer, .linear[disabled] .buffer {\n  background-image:\n      linear-gradient(to right, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)),\n      linear-gradient(to right, rgba(0, 0, 0, 0.26), rgba(0, 0, 0, 0.26));\n}\n.circle {\n  height: 100%;\n  width: 100%;\n}\n.path {\n  fill: none;\n  stroke: rgb(63, 81, 181);\n  stroke-dasharray: 0, 250;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  stroke-miterlimit: 20;\n  stroke-width: 4;\n  transition: stroke-dasharray 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n@-webkit-keyframes linear-indeterminate-bar {\n  0% {\n    -webkit-transform: translate(-50%) scaleX(0);\n            transform: translate(-50%) scaleX(0);\n  }\n\n  50% {\n    -webkit-transform: translate(-0%) scaleX(0.3);\n            transform: translate(-0%) scaleX(0.3);\n  }\n\n  100% {\n    -webkit-transform: translate(50%) scaleX(0);\n            transform: translate(50%) scaleX(0);\n  }\n}\n@keyframes linear-indeterminate-bar {\n  0% {\n    -webkit-transform: translate(-50%) scaleX(0);\n            transform: translate(-50%) scaleX(0);\n  }\n\n  50% {\n    -webkit-transform: translate(-0%) scaleX(0.3);\n            transform: translate(-0%) scaleX(0.3);\n  }\n\n  100% {\n    -webkit-transform: translate(50%) scaleX(0);\n            transform: translate(50%) scaleX(0);\n  }\n}\n@-webkit-keyframes circular-indeterminate-bar-rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes circular-indeterminate-bar-rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes circular-indeterminate-bar-dash {\n  0% {\n    stroke-dasharray: 1.25, 250;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 111.25, 250;\n    stroke-dashoffset: -43.75;\n  }\n\n  100% {\n    stroke-dasharray: 111.25, 250;\n    stroke-dashoffset: -155;\n  }\n}\n@keyframes circular-indeterminate-bar-dash {\n  0% {\n    stroke-dasharray: 1.25, 250;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 111.25, 250;\n    stroke-dashoffset: -43.75;\n  }\n\n  100% {\n    stroke-dasharray: 111.25, 250;\n    stroke-dashoffset: -155;\n  }\n}\n@-webkit-keyframes colors {\n  0% {\n    stroke: #4285f4;\n  }\n\n  25% {\n    stroke: #de3e35;\n  }\n\n  50% {\n    stroke: #f7c223;\n  }\n\n  75% {\n    stroke: #1b9a59;\n  }\n\n  100% {\n    stroke: #4285f4;\n  }\n}\n@keyframes colors {\n  0% {\n    stroke: #4285f4;\n  }\n\n  25% {\n    stroke: #de3e35;\n  }\n\n  50% {\n    stroke: #f7c223;\n  }\n\n  75% {\n    stroke: #1b9a59;\n  }\n\n  100% {\n    stroke: #4285f4;\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"linear": "theme--linear--JEuO8g-f",
	"indeterminate": "theme--indeterminate--4Xd0Y-CL",
	"value": "theme--value--1sYsmnME",
	"linear-indeterminate-bar": "theme--linear-indeterminate-bar--1nG1yWmE",
	"buffer": "theme--buffer--1ea7-zJr",
	"circular": "theme--circular--2fReLSLF",
	"circle": "theme--circle--2UI1LHDa",
	"circular-indeterminate-bar-rotate": "theme--circular-indeterminate-bar-rotate--2aoK7qNK",
	"path": "theme--path--zFYb5BfM",
	"circular-indeterminate-bar-dash": "theme--circular-indeterminate-bar-dash--272Bqk2S",
	"multicolor": "theme--multicolor--36xdGzyb",
	"colors": "theme--colors--24yUKjiR"
};

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){"use strict";function n(e,t,n){this.root=this.currentNode=e,this.nodeType=t,this.filter=n||ht}function i(e,t){for(var n=e.length;n--;)if(!t(e[n]))return!1;return!0}function o(e){return e.nodeType===F&&!!ut[e.nodeName]}function r(e){switch(e.nodeType){case M:return gt;case F:case W:if(st&&Ct.has(e))return Ct.get(e);break;default:return pt}var t;return t=i(e.childNodes,a)?ft.test(e.nodeName)?gt:mt:vt,st&&Ct.set(e,t),t}function a(e){return r(e)===gt}function s(e){return r(e)===mt}function d(e){return r(e)===vt}function l(e,t){var i=new n(t,z,s);return i.currentNode=e,i}function c(e,t){return e=l(e,t).previousNode(),e!==t?e:null}function h(e,t){return e=l(e,t).nextNode(),e!==t?e:null}function f(e){return!e.textContent&&!e.querySelector("IMG")}function u(e,t){return!o(e)&&e.nodeType===t.nodeType&&e.nodeName===t.nodeName&&"A"!==e.nodeName&&e.className===t.className&&(!e.style&&!t.style||e.style.cssText===t.style.cssText)}function p(e,t,n){if(e.nodeName!==t)return!1;for(var i in n)if(e.getAttribute(i)!==n[i])return!1;return!0}function g(e,t,n,i){for(;e&&e!==t;){if(p(e,n,i))return e;e=e.parentNode}return null}function m(e,t){for(;t;){if(t===e)return!0;t=t.parentNode}return!1}function v(e,t,n){var i,o,r,a,s,d="";return e&&e!==t&&(d=v(e.parentNode,t,n),e.nodeType===F&&(d+=(d?">":"")+e.nodeName,(i=e.id)&&(d+="#"+i),(o=e.className.trim())&&(r=o.split(/\s\s*/),r.sort(),d+=".",d+=r.join(".")),(a=e.dir)&&(d+="[dir="+a+"]"),r&&(s=n.classNames,lt.call(r,s.highlight)>-1&&(d+="[backgroundColor="+e.style.backgroundColor.replace(/ /g,"")+"]"),lt.call(r,s.colour)>-1&&(d+="[color="+e.style.color.replace(/ /g,"")+"]"),lt.call(r,s.fontFamily)>-1&&(d+="[fontFamily="+e.style.fontFamily.replace(/ /g,"")+"]"),lt.call(r,s.fontSize)>-1&&(d+="[fontSize="+e.style.fontSize+"]")))),d}function C(e){var t=e.nodeType;return t===F||t===W?e.childNodes.length:e.length||0}function _(e){var t=e.parentNode;return t&&t.removeChild(e),e}function N(e,t){var n=e.parentNode;n&&n.replaceChild(t,e)}function S(e){for(var t=e.ownerDocument.createDocumentFragment(),n=e.childNodes,i=n?n.length:0;i--;)t.appendChild(e.firstChild);return t}function y(e,n,i,o){var r,a,s,d,l=e.createElement(n);if(i instanceof Array&&(o=i,i=null),i)for(r in i)a=i[r],a!==t&&l.setAttribute(r,a);if(o)for(s=0,d=o.length;d>s;s+=1)l.appendChild(o[s]);return l}function T(e,t){var n,i,o=t.__squire__,r=e.ownerDocument,s=e;if(e===t&&((i=e.firstChild)&&"BR"!==i.nodeName||(n=o.createDefaultBlock(),i?e.replaceChild(n,i):e.appendChild(n),e=n,n=null)),e.nodeType===M)return s;if(a(e)){for(i=e.firstChild;rt&&i&&i.nodeType===M&&!i.data;)e.removeChild(i),i=e.firstChild;i||(rt?(n=r.createTextNode($),o._didAddZWS()):n=r.createTextNode(""))}else if(!e.querySelector("BR"))for(n=y(r,"BR");(i=e.lastElementChild)&&!a(i);)e=i;if(n)try{e.appendChild(n)}catch(d){o.didError({name:"Squire: fixCursor – "+d,message:"Parent: "+e.nodeName+"/"+e.innerHTML+" appendChild: "+n.nodeName})}return s}function E(e,t){var n,i,o,r,s=e.childNodes,l=e.ownerDocument,c=null;for(n=0,i=s.length;i>n;n+=1)o=s[n],r="BR"===o.nodeName,!r&&a(o)?(c||(c=y(l,"div")),c.appendChild(o),n-=1,i-=1):(r||c)&&(c||(c=y(l,"div")),T(c,t),r?e.replaceChild(c,o):(e.insertBefore(c,o),n+=1,i+=1),c=null),d(o)&&E(o,t);return c&&e.appendChild(T(c,t)),e}function b(e,t,n,i){var o,r,a,s=e.nodeType;if(s===M&&e!==n)return b(e.parentNode,e.splitText(t),n,i);if(s===F){if("number"==typeof t&&(t=t<e.childNodes.length?e.childNodes[t]:null),e===n)return t;for(o=e.parentNode,r=e.cloneNode(!1);t;)a=t.nextSibling,r.appendChild(t),t=a;return"OL"===e.nodeName&&g(e,i,"BLOCKQUOTE")&&(r.start=(+e.start||1)+e.childNodes.length-1),T(e,i),T(r,i),(a=e.nextSibling)?o.insertBefore(r,a):o.appendChild(r),b(o,r,n,i)}return t}function k(e,t){for(var n,i,o,r=e.childNodes,s=r.length,d=[];s--;)if(n=r[s],i=s&&r[s-1],s&&a(n)&&u(n,i)&&!ut[n.nodeName])t.startContainer===n&&(t.startContainer=i,t.startOffset+=C(i)),t.endContainer===n&&(t.endContainer=i,t.endOffset+=C(i)),t.startContainer===e&&(t.startOffset>s?t.startOffset-=1:t.startOffset===s&&(t.startContainer=i,t.startOffset=C(i))),t.endContainer===e&&(t.endOffset>s?t.endOffset-=1:t.endOffset===s&&(t.endContainer=i,t.endOffset=C(i))),_(n),n.nodeType===M?i.appendData(n.data):d.push(S(n));else if(n.nodeType===F){for(o=d.length;o--;)n.appendChild(d.pop());k(n,t)}}function L(e,t){if(e.nodeType===M&&(e=e.parentNode),e.nodeType===F){var n={startContainer:t.startContainer,startOffset:t.startOffset,endContainer:t.endContainer,endOffset:t.endOffset};k(e,n),t.setStart(n.startContainer,n.startOffset),t.setEnd(n.endContainer,n.endOffset)}}function A(e,t,n,i){for(var o,r,a,s=t;(o=s.parentNode)&&o!==i&&o.nodeType===F&&1===o.childNodes.length;)s=o;_(s),a=e.childNodes.length,r=e.lastChild,r&&"BR"===r.nodeName&&(e.removeChild(r),a-=1),e.appendChild(S(t)),n.setStart(e,a),n.collapse(!0),L(e,n)}function x(e,t){var n,i,o=e.previousSibling,r=e.firstChild,a=e.ownerDocument,s="LI"===e.nodeName;if(!s||r&&/^[OU]L$/.test(r.nodeName))if(o&&u(o,e)){if(!d(o)){if(!s)return;i=y(a,"DIV"),i.appendChild(S(o)),o.appendChild(i)}_(e),n=!d(e),o.appendChild(S(e)),n&&E(o,t),r&&x(r,t)}else s&&(o=y(a,"DIV"),e.insertBefore(o,r),T(o,t))}function O(e){this.isShiftDown=e.shiftKey}function B(e,t,n){var i,o;if(e||(e={}),t)for(i in t)!n&&i in e||(o=t[i],e[i]=o&&o.constructor===Object?B(e[i],o,n):o);return e}function R(e,t){e.nodeType===H&&(e=e.body);var n,i=e.ownerDocument,o=i.defaultView;this._win=o,this._doc=i,this._root=e,this._events={},this._isFocused=!1,this._lastSelection=null,this._hasZWS=!1,this._lastAnchorNode=null,this._lastFocusNode=null,this._path="",this._willUpdatePath=!1,"onselectionchange"in i?this.addEventListener("selectionchange",this._updatePathOnEvent):(this.addEventListener("keyup",this._updatePathOnEvent),this.addEventListener("mouseup",this._updatePathOnEvent)),this._undoIndex=-1,this._undoStack=[],this._undoStackLength=0,this._isInUndoState=!1,this._ignoreChange=!1,this._ignoreAllChanges=!1,at?(n=new MutationObserver(this._docWasChanged.bind(this)),n.observe(e,{childList:!0,attributes:!0,characterData:!0,subtree:!0}),this._mutation=n):this.addEventListener("keyup",this._keyUpDetectChange),this._restoreSelection=!1,this.addEventListener("blur",D),this.addEventListener("mousedown",P),this.addEventListener("touchstart",P),this.addEventListener("focus",U),this._awaitingPaste=!1,this.addEventListener("cut",an),this.addEventListener("copy",dn),this.addEventListener("keydown",O),this.addEventListener("keyup",O),this.addEventListener("paste",ln),this.addEventListener("drop",cn),this.addEventListener("keydown",It),this._keyHandlers=Object.create(zt),this.setConfig(t),e.setAttribute("contenteditable","true"),e.setAttribute("data-gramm","false");try{i.execCommand("enableObjectResizing",!1,"false"),i.execCommand("enableInlineTableEditing",!1,"false")}catch(r){}e.__squire__=this,this.setHTML("")}function D(){this._restoreSelection=!0}function P(){this._restoreSelection=!1}function U(){this._restoreSelection&&this.setSelection(this._lastSelection)}function I(e,t,n){var i,o;for(i=t.firstChild;i;i=o){if(o=i.nextSibling,a(i)){if(i.nodeType===M||"BR"===i.nodeName||"IMG"===i.nodeName){n.appendChild(i);continue}}else if(s(i)){n.appendChild(e.createDefaultBlock([I(e,i,e._doc.createDocumentFragment())]));continue}I(e,i,n)}return n}var w=2,F=1,M=3,H=9,W=11,z=1,K=4,q=0,G=1,Z=2,Q=3,$="​",j=e.defaultView,V=navigator.userAgent,Y=(/Android/.test(V),/Mac OS X/.test(V)),X=/Windows NT/.test(V),J=/iP(?:ad|hone|od)/.test(V)||Y&&!!navigator.maxTouchPoints,et=/Gecko\//.test(V),tt=/Edge\//.test(V),nt=!tt&&/WebKit\//.test(V),it=/Trident\/[4567]\./.test(V),ot=Y?"meta-":"ctrl-",rt=nt,at="undefined"!=typeof MutationObserver,st="undefined"!=typeof WeakMap,dt=/[^ \t\r\n]/,lt=Array.prototype.indexOf,ct={1:1,2:2,3:4,8:128,9:256,11:1024},ht=function(){return!0};n.prototype.nextNode=function(){for(var e,t=this.currentNode,n=this.root,i=this.nodeType,o=this.filter;;){for(e=t.firstChild;!e&&t&&t!==n;)e=t.nextSibling,e||(t=t.parentNode);if(!e)return null;if(ct[e.nodeType]&i&&o(e))return this.currentNode=e,e;t=e}},n.prototype.previousNode=function(){for(var e,t=this.currentNode,n=this.root,i=this.nodeType,o=this.filter;;){if(t===n)return null;if(e=t.previousSibling)for(;t=e.lastChild;)e=t;else e=t.parentNode;if(!e)return null;if(ct[e.nodeType]&i&&o(e))return this.currentNode=e,e;t=e}},n.prototype.previousPONode=function(){for(var e,t=this.currentNode,n=this.root,i=this.nodeType,o=this.filter;;){for(e=t.lastChild;!e&&t&&t!==n;)e=t.previousSibling,e||(t=t.parentNode);if(!e)return null;if(ct[e.nodeType]&i&&o(e))return this.currentNode=e,e;t=e}};var ft=/^(?:#text|A(?:BBR|CRONYM)?|B(?:R|D[IO])?|C(?:ITE|ODE)|D(?:ATA|EL|FN)|EM|FONT|HR|I(?:FRAME|MG|NPUT|NS)?|KBD|Q|R(?:P|T|UBY)|S(?:AMP|MALL|PAN|TR(?:IKE|ONG)|U[BP])?|TIME|U|VAR|WBR)$/,ut={BR:1,HR:1,IFRAME:1,IMG:1,INPUT:1},pt=0,gt=1,mt=2,vt=3,Ct=st?new WeakMap:null,_t=function(e,t){for(var n=e.childNodes;t&&e.nodeType===F;)e=n[t-1],n=e.childNodes,t=n.length;return e},Nt=function(e,t){if(e.nodeType===F){var n=e.childNodes;if(t<n.length)e=n[t];else{for(;e&&!e.nextSibling;)e=e.parentNode;e&&(e=e.nextSibling)}}return e},St=function(e,t){var n,i,o,r,a=e.startContainer,s=e.startOffset,d=e.endContainer,l=e.endOffset;a.nodeType===M?(n=a.parentNode,i=n.childNodes,s===a.length?(s=lt.call(i,a)+1,e.collapsed&&(d=n,l=s)):(s&&(r=a.splitText(s),d===a?(l-=s,d=r):d===n&&(l+=1),a=r),s=lt.call(i,a)),a=n):i=a.childNodes,o=i.length,s===o?a.appendChild(t):a.insertBefore(t,i[s]),a===d&&(l+=i.length-o),e.setStart(a,s),e.setEnd(d,l)},yt=function(e,t,n){var i=e.startContainer,o=e.startOffset,r=e.endContainer,a=e.endOffset;t||(t=e.commonAncestorContainer),t.nodeType===M&&(t=t.parentNode);for(var s,d,l,c,h,f=b(r,a,t,n),u=b(i,o,t,n),p=t.ownerDocument.createDocumentFragment();u!==f;)s=u.nextSibling,p.appendChild(u),u=s;return i=t,o=f?lt.call(t.childNodes,f):t.childNodes.length,l=t.childNodes[o],d=l&&l.previousSibling,d&&d.nodeType===M&&l.nodeType===M&&(i=d,o=d.length,c=d.data,h=l.data," "===c.charAt(c.length-1)&&" "===h.charAt(0)&&(h=" "+h.slice(1)),d.appendData(h),_(l)),e.setStart(i,o),e.collapse(!0),T(t,n),p},Tt=function(e,t){var n,i,o=xt(e,t),r=Ot(e,t),a=o!==r;return kt(e),Lt(e,o,r,t),n=yt(e,null,t),kt(e),a&&(r=Ot(e,t),o&&r&&o!==r&&A(o,r,e,t)),o&&T(o,t),i=t.firstChild,i&&"BR"!==i.nodeName?e.collapse(!0):(T(t,t),e.selectNodeContents(t.firstChild)),n},Et=function(e,t,n){var i,o,r,s,l,u,p,m,v,N,S,y=t.firstChild&&a(t.firstChild);for(E(t,n),i=t;i=h(i,n);)T(i,n);if(e.collapsed||Tt(e,n),kt(e),e.collapse(!1),s=g(e.endContainer,n,"BLOCKQUOTE")||n,o=xt(e,n),m=h(t,t),p=!y&&!!o&&f(o),o&&m&&!p&&!g(m,t,"PRE")&&!g(m,t,"TABLE")){if(Lt(e,o,o,n),e.collapse(!0),l=e.endContainer,u=e.endOffset,on(o,n,!1),a(l)&&(v=b(l,u,c(l,n),n),l=v.parentNode,u=lt.call(l.childNodes,v)),u!==C(l))for(r=n.ownerDocument.createDocumentFragment();i=l.childNodes[u];)r.appendChild(i);A(l,m,e,n),u=lt.call(l.parentNode.childNodes,l)+1,l=l.parentNode,e.setEnd(l,u)}C(t)&&(p&&(e.setEndBefore(o),e.collapse(!1),_(o)),Lt(e,s,s,n),v=b(e.endContainer,e.endOffset,s,n),N=v?v.previousSibling:s.lastChild,s.insertBefore(t,v),v?e.setEndBefore(v):e.setEnd(s,C(s)),o=Ot(e,n),kt(e),l=e.endContainer,u=e.endOffset,v&&d(v)&&x(v,n),v=N&&N.nextSibling,v&&d(v)&&x(v,n),e.setEnd(l,u)),r&&(S=e.cloneRange(),A(o,r,S,n),e.setEnd(S.endContainer,S.endOffset)),kt(e)},bt=function(e,t,n){var i=t.ownerDocument.createRange();if(i.selectNode(t),n){var o=e.compareBoundaryPoints(Q,i)>-1,r=e.compareBoundaryPoints(G,i)<1;return!o&&!r}var a=e.compareBoundaryPoints(q,i)<1,s=e.compareBoundaryPoints(Z,i)>-1;return a&&s},kt=function(e){for(var t,n=e.startContainer,i=e.startOffset,r=e.endContainer,a=e.endOffset,s=!0;n.nodeType!==M&&(t=n.childNodes[i],t&&!o(t));)n=t,i=0;if(a)for(;r.nodeType!==M;){if(t=r.childNodes[a-1],!t||o(t)){if(s&&t&&"BR"===t.nodeName){a-=1,s=!1;continue}break}r=t,a=C(r)}else for(;r.nodeType!==M&&(t=r.firstChild,t&&!o(t));)r=t;e.collapsed?(e.setStart(r,a),e.setEnd(n,i)):(e.setStart(n,i),e.setEnd(r,a))},Lt=function(e,t,n,i){var o,r=e.startContainer,a=e.startOffset,s=e.endContainer,d=e.endOffset,l=!0;for(t||(t=e.commonAncestorContainer),n||(n=t);!a&&r!==t&&r!==i;)o=r.parentNode,a=lt.call(o.childNodes,r),r=o;for(;;){if(s===n||s===i)break;if(l&&s.nodeType!==M&&s.childNodes[d]&&"BR"===s.childNodes[d].nodeName&&(d+=1,l=!1),d!==C(s))break;o=s.parentNode,d=lt.call(o.childNodes,s)+1,s=o}e.setStart(r,a),e.setEnd(s,d)},At=function(e,t,n){var i=g(e.endContainer,n,"A");if(i){var o=e.cloneRange();i=i.parentNode,Lt(o,i,i,n),o.endContainer===i&&(e.setStart(o.endContainer,o.endOffset),e.setEnd(o.endContainer,o.endOffset))}return e},xt=function(e,t){var n,i=e.startContainer;return a(i)?n=c(i,t):i!==t&&s(i)?n=i:(n=_t(i,e.startOffset),n=h(n,t)),n&&bt(e,n,!0)?n:null},Ot=function(e,t){var n,i,o=e.endContainer;if(a(o))n=c(o,t);else if(o!==t&&s(o))n=o;else{if(n=Nt(o,e.endOffset),!n||!m(t,n))for(n=t;i=n.lastChild;)n=i;n=c(n,t)}return n&&bt(e,n,!0)?n:null},Bt=new n(null,K|z,function(e){return e.nodeType===M?dt.test(e.data):"INPUT"===e.nodeName||"IMG"===e.nodeName||!e.isContentEditable}),Rt=function(e,t){var n,i=e.startContainer,o=e.startOffset;if(Bt.root=null,i.nodeType===M){if(o)return!1;n=i}else if(n=Nt(i,o),n&&!m(t,n)&&(n=null),!n&&(n=_t(i,o),n.nodeType===M&&n.length))return!1;return Bt.currentNode=n,Bt.root=xt(e,t),!Bt.previousNode()},Dt=function(e,t){var n,i=e.endContainer,o=e.endOffset;if(Bt.root=null,i.nodeType===M){if(n=i.data.length,n&&n>o)return!1;Bt.currentNode=i}else Bt.currentNode=_t(i,o);return Bt.root=Ot(e,t),!Bt.nextNode()},Pt=function(e,t){var n,i=xt(e,t),o=Ot(e,t);i&&o&&(n=i.parentNode,e.setStart(n,lt.call(n.childNodes,i)),n=o.parentNode,e.setEnd(n,lt.call(n.childNodes,o)+1))},Ut={8:"backspace",9:"tab",13:"enter",32:"space",33:"pageup",34:"pagedown",37:"left",39:"right",46:"delete",219:"[",221:"]"},It=function(e){var t=e.keyCode,n=Ut[t],i="",o=this.getSelection();e.defaultPrevented||(n||(n=String.fromCharCode(t).toLowerCase(),/^[A-Za-z0-9]$/.test(n)||(n="")),t>111&&124>t&&(n="f"+(t-111)),"backspace"!==n&&"delete"!==n&&(e.altKey&&(i+="alt-"),e.ctrlKey&&(i+="ctrl-"),e.metaKey&&(i+="meta-"),e.shiftKey&&(i+="shift-")),X&&e.shiftKey&&"delete"===n&&(i+="shift-"),n=i+n,this._keyHandlers[n]?this._keyHandlers[n](this,e,o):o.collapsed||e.isComposing||e.ctrlKey||e.metaKey||1!==(e.key||n).length||(this.saveUndoState(o),Tt(o,this._root),this._ensureBottomLine(),this.setSelection(o),this._updatePath(o,!0)))},wt=function(e){return function(t,n){n.preventDefault(),t[e]()}},Ft=function(e,t){return t=t||null,function(n,i){i.preventDefault();var o=n.getSelection();n.hasFormat(e,null,o)?n.changeFormat(null,{tag:e},o):n.changeFormat({tag:e},t,o)}},Mt=function(e,t){try{t||(t=e.getSelection());var n,i=t.startContainer;for(i.nodeType===M&&(i=i.parentNode),n=i;a(n)&&(!n.textContent||n.textContent===$);)i=n,n=i.parentNode;i!==n&&(t.setStart(n,lt.call(n.childNodes,i)),t.collapse(!0),n.removeChild(i),s(n)||(n=c(n,e._root)),T(n,e._root),kt(t)),i===e._root&&(i=i.firstChild)&&"BR"===i.nodeName&&_(i),e._ensureBottomLine(),e.setSelection(t),e._updatePath(t,!0)}catch(o){e.didError(o)}},Ht=function(e,t){for(var n;(n=e.parentNode)&&n!==t&&!n.isContentEditable;)e=n;_(e)},Wt=function(e,t,n){var i,o,r,a,s,d=e._root;if(e._recordUndoState(n),e._config.addLinks&&An(n.startContainer,d,e),e._removeZWS(),e._getRangeAndRemoveBookmark(n),n.collapsed||Tt(n,d),i=xt(n,d),i&&(o=g(i,d,"PRE")))return kt(n),r=n.startContainer,a=n.startOffset,r.nodeType!==M&&(r=e._doc.createTextNode(""),o.insertBefore(r,o.firstChild)),t||"\n"!==r.data.charAt(a-1)&&!Rt(n,d)||"\n"!==r.data.charAt(a)&&!Dt(n,d)?(r.insertData(a,"\n"),T(o,d),r.length===a+1?n.setStartAfter(r):n.setStart(r,a+1)):(r.deleteData(a&&a-1,a?2:1),s=b(r,a&&a-1,d,d),r=s.previousSibling,r.textContent||_(r),r=e.createDefaultBlock(),s.parentNode.insertBefore(r,s),s.textContent||_(s),n.setStart(r,0)),n.collapse(!0),e.setSelection(n),e._updatePath(n,!0),void e._docWasChanged();if(!i||t||/^T[HD]$/.test(i.nodeName))return At(n,"A",d),St(n,e.createElement("BR")),n.collapse(!1),e.setSelection(n),void e._updatePath(n,!0);if((o=g(i,d,"LI"))&&(i=o),f(i)){if(g(i,d,"UL")||g(i,d,"OL"))return e.decreaseListLevel(n);if(g(i,d,"BLOCKQUOTE"))return e.modifyBlocks(yn,n)}for(s=_n(e,i,n.startContainer,n.startOffset),gn(i),en(i),T(i,d);s.nodeType===F;){var l,c=s.firstChild;if("A"===s.nodeName&&(!s.textContent||s.textContent===$)){c=e._doc.createTextNode(""),N(s,c),s=c;break}for(;c&&c.nodeType===M&&!c.data&&(l=c.nextSibling,l&&"BR"!==l.nodeName);)_(c),c=l;if(!c||"BR"===c.nodeName||c.nodeType===M)break;s=c}n=e.createRange(s,0),e.setSelection(n),e._updatePath(n,!0)},zt={enter:J?function(e,t,n){e._saveRangeToBookmark(n);for(var i=e._root.getElementsByTagName("INPUT"),o=0;o<i.length;o++)"checkbox"==i[o].type&&(i[o].checked?i[o].setAttribute("checked",!0):i[o].removeAttribute("checked"));var r=e._getHTML(),a=function(){e.removeEventListener("keyup",a),e._setHTML(r),n=e._getRangeAndRemoveBookmark(),Wt(e,!1,n)};e.addEventListener("keyup",a)}:function(e,t,n){t.preventDefault(),Wt(e,t.shiftKey,n)},"shift-enter":function(e,t,n){return e._keyHandlers.enter(e,t,n)},backspace:function(e,t,n){var i=e._root;if(e._removeZWS(),e.saveUndoState(n),n.collapsed)if(Rt(n,i)){t.preventDefault();var o,r=xt(n,i);if(!r)return;if(E(r.parentNode,i),o=c(r,i)){if(!o.isContentEditable||"INPUT"==o.nodeName)return void Ht(o,i);for(A(o,r,n,i),r=o.parentNode;r!==i&&!r.nextSibling;)r=r.parentNode;r!==i&&(r=r.nextSibling)&&x(r,i),e.setSelection(n)}else if(r){if(g(r,i,"UL")||g(r,i,"OL"))return e.decreaseListLevel(n);if(g(r,i,"BLOCKQUOTE"))return e.modifyBlocks(Sn,n);e.setSelection(n),e._updatePath(n,!0)}}else{if(navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)){var a=n.cloneRange();a.setStart(a.startContainer,a.startOffset-1);var s=a.cloneContents(),d=s.lastChild;if(d.nodeType===F&&("INPUT"==d.nodeName||!d.isContentEditable))return t.preventDefault(),n.setStart(n.startContainer,n.startOffset-1),Tt(n,i),void Mt(e,n)}e.setSelection(n),setTimeout(function(){Mt(e)},0)}else t.preventDefault(),Tt(n,i),Mt(e,n)},"delete":function(e,t,n){var i,o,r,a,s,d,l=e._root;if(e._removeZWS(),e.saveUndoState(n),n.collapsed)if(Dt(n,l)){if(t.preventDefault(),i=xt(n,l),!i)return;if(E(i.parentNode,l),o=h(i,l)){if(!o.isContentEditable)return void Ht(o,l);for(A(i,o,n,l),o=i.parentNode;o!==l&&!o.nextSibling;)o=o.parentNode;o!==l&&(o=o.nextSibling)&&x(o,l),e.setSelection(n),e._updatePath(n,!0)}}else{if(r=n.cloneRange(),Lt(n,l,l,l),a=n.endContainer,s=n.endOffset,a.nodeType===F&&(d=a.childNodes[s],d&&"IMG"===d.nodeName))return t.preventDefault(),_(d),kt(n),void Mt(e,n);e.setSelection(r),setTimeout(function(){Mt(e)},0)}else t.preventDefault(),Tt(n,l),Mt(e,n)},tab:function(e,t,n){e._root;e._removeZWS()},"shift-tab":function(e,t,n){var i,o=e._root;e._removeZWS(),n.collapsed&&Rt(n,o)&&(i=n.startContainer,(g(i,o,"UL")||g(i,o,"OL"))&&(t.preventDefault(),e.decreaseListLevel(n)))},space:function(e,t,n){var i,o=e._root;if(e._recordUndoState(n),e._config.addLinks&&An(n.startContainer,o,e),e._getRangeAndRemoveBookmark(n),i=n.endContainer,n.collapsed&&n.endOffset===C(i))do if("A"===i.nodeName){n.setStartAfter(i);break}while(!i.nextSibling&&(i=i.parentNode)&&i!==o);n.collapsed||(Tt(n,o),e._ensureBottomLine(),e.setSelection(n),e._updatePath(n,!0)),e.setSelection(n)},left:function(e){e._removeZWS()},right:function(e){e._removeZWS()}};Y&&et&&(zt["meta-left"]=function(e,t){t.preventDefault();var n=pn(e);n&&n.modify&&n.modify("move","backward","lineboundary")},zt["meta-right"]=function(e,t){t.preventDefault();var n=pn(e);n&&n.modify&&n.modify("move","forward","lineboundary")}),Y||(zt.pageup=function(e){e.moveCursorToStart()},zt.pagedown=function(e){e.moveCursorToEnd()});const Kt=function(e,t){return function(n,i){i.preventDefault();var o=n.getPath();/(?:^|>)BLOCKQUOTE/.test(o)||!/(?:^|>)[OU]L/.test(o)?n[e]():n[t]()}},qt=function(e,t){return function(n,i){i.preventDefault();var o=n.getPath();e.test(o)?n.removeList():n[t]()}};zt[ot+"b"]=Ft("B"),zt[ot+"i"]=Ft("I"),zt[ot+"u"]=Ft("U"),zt[ot+"shift-7"]=Ft("S"),zt[ot+"shift-5"]=Ft("SUB",{tag:"SUP"}),zt[ot+"shift-6"]=Ft("SUP",{tag:"SUB"}),zt[ot+"shift-8"]=qt(/(?:^|>)UL/,"makeUnorderedList"),zt[ot+"shift-9"]=qt(/(?:^|>)OL/,"makeOrderedList"),zt[ot+"["]=Kt("decreaseQuoteLevel","decreaseListLevel"),zt[ot+"]"]=Kt("increaseQuoteLevel","increaseListLevel"),zt[ot+"d"]=wt("toggleCode"),zt[ot+"y"]=wt("redo"),zt[ot+"z"]=wt("undo"),zt[ot+"shift-z"]=wt("redo");var Gt={1:10,2:13,3:16,4:18,5:24,6:32,7:48},Zt={fontWeight:{regexp:/^bold|^700/i,replace:function(e){return y(e,"B")}},fontStyle:{regexp:/^italic/i,replace:function(e){return y(e,"I")}},fontFamily:{regexp:dt,replace:function(e,t,n){return y(e,"SPAN",{"class":t.fontFamily,style:"font-family:"+n})}},fontSize:{regexp:dt,replace:function(e,t,n){return y(e,"SPAN",{"class":t.fontSize,style:"font-size:"+n})}},textDecoration:{regexp:/^underline/i,replace:function(e){return y(e,"U")}}},Qt=function(e){return function(t,n){var i,o,r,a=y(t.ownerDocument,e),s=t.attributes;for(i=0,o=s.length;o>i;i+=1)r=s[i],a.setAttribute(r.name,r.value);return n.replaceChild(a,t),a.appendChild(S(t)),a}},$t=function(e,t,n){var i,o,r,a,s,d,l=e.style,c=e.ownerDocument;for(i in Zt)if(o=Zt[i],r=l[i],r&&o.regexp.test(r)){if(d=o.replace(c,n.classNames,r),d.nodeName===e.nodeName&&d.className===e.className)continue;s||(s=d),a&&a.appendChild(d),a=d,e.style[i]=""}return s&&(a.appendChild(S(e)),e.appendChild(s)),a||e},jt={SPAN:$t,STRONG:Qt("B"),EM:Qt("I"),INS:Qt("U"),STRIKE:Qt("S"),FONT:function(e,t,n){var i,o,r,a,s,d=e.face,l=e.size,c=e.color,h=e.ownerDocument,f=n.classNames;return d&&(i=y(h,"SPAN",{"class":f.fontFamily,style:"font-family:"+d}),s=i,a=i),l&&(o=y(h,"SPAN",{"class":f.fontSize,style:"font-size:"+Gt[l]+"px"}),s||(s=o),a&&a.appendChild(o),a=o),c&&/^#?([\dA-F]{3}){1,2}$/i.test(c)&&("#"!==c.charAt(0)&&(c="#"+c),r=y(h,"SPAN",{"class":f.colour,style:"color:"+c}),s||(s=r),a&&a.appendChild(r),a=r),s||(s=a=y(h,"SPAN")),t.replaceChild(s,e),a.appendChild(S(e)),a},TT:function(e,t,n){var i=y(e.ownerDocument,"SPAN",{"class":n.classNames.fontFamily,style:'font-family:menlo,consolas,"courier new",monospace'});return t.replaceChild(i,e),i.appendChild(S(e)),i}},Vt=/^(?:A(?:DDRESS|RTICLE|SIDE|UDIO)|BLOCKQUOTE|CAPTION|D(?:[DLT]|IV)|F(?:IGURE|IGCAPTION|OOTER)|H[1-6]|HEADER|L(?:ABEL|EGEND|I)|O(?:L|UTPUT)|P(?:RE)?|SECTION|T(?:ABLE|BODY|D|FOOT|H|HEAD|R)|COL(?:GROUP)?|UL)$/,Yt=/^(?:HEAD|META|STYLE)/,Xt=new n(null,K|z),Jt=function Dn(e,t,n){var i,o,r,s,d,l,c,h,f,u,p,g,m=e.childNodes;for(i=e;a(i);)i=i.parentNode;for(Xt.root=i,o=0,r=m.length;r>o;o+=1)if(s=m[o],d=s.nodeName,l=s.nodeType,c=jt[d],l===F){if(h=s.childNodes.length,c)s=c(s,e,t);else{if(Yt.test(d)){e.removeChild(s),o-=1,r-=1;continue}if(!Vt.test(d)&&!a(s)){o-=1,r+=h-1,e.replaceChild(S(s),s);continue}}h&&Dn(s,t,n||"PRE"===d)}else{if(l===M){if(p=s.data,f=!dt.test(p.charAt(0)),u=!dt.test(p.charAt(p.length-1)),n||!f&&!u)continue;if(f){for(Xt.currentNode=s;(g=Xt.previousPONode())&&(d=g.nodeName,!("IMG"===d||"#text"===d&&dt.test(g.data)));)if(!a(g)){g=null;break}p=p.replace(/^[ \t\r\n]+/g,g?" ":"")}if(u){for(Xt.currentNode=s;(g=Xt.nextNode())&&!("IMG"===d||"#text"===d&&dt.test(g.data));)if(!a(g)){g=null;break}p=p.replace(/[ \t\r\n]+$/g,g?" ":"")}if(p){s.data=p;continue}}e.removeChild(s),o-=1,r-=1}return e},en=function Pn(e){for(var t,n=e.childNodes,i=n.length;i--;)t=n[i],t.nodeType!==F||o(t)?t.nodeType!==M||t.data||e.removeChild(t):(Pn(t),a(t)&&!t.firstChild&&e.removeChild(t))},tn=function(e){return e.nodeType===F?"BR"===e.nodeName:dt.test(e.data)},nn=function(e,t){for(var i,o=e.parentNode;a(o);)o=o.parentNode;return i=new n(o,z|K,tn),i.currentNode=e,!!i.nextNode()||t&&!i.previousNode()},on=function(e,t,n){var i,o,r,s=e.querySelectorAll("BR"),d=[],l=s.length;for(i=0;l>i;i+=1)d[i]=nn(s[i],n);for(;l--;)o=s[l],r=o.parentNode,r&&(d[l]?a(r)||E(r,t):_(o))},rn=function(e,t,n,i,o,r){var a,s,d=e.clipboardData,l=e.target.ownerDocument,c=l.body,h=y(l,"div");h.appendChild(t),a=h.innerHTML,i&&(a=i(a)),o?s=o(a):(on(h,n,!0),h.setAttribute("style","position:fixed;overflow:hidden;bottom:100%;right:100%;"),c.appendChild(h),s=h.innerText||h.textContent,s=s.replace(/ /g," "),c.removeChild(h)),X&&(s=s.replace(/\r?\n/g,"\r\n")),r||s===a||d.setData("text/html",a),d.setData("text/plain",s),e.preventDefault()},an=function(e){var t,n,i,o,r,a,s=this.getSelection(),d=this._root,l=this;if(s.collapsed)return void e.preventDefault();if(this.saveUndoState(s),!tt&&e.clipboardData){for(t=xt(s,d),n=Ot(s,d),i=t===n&&t||d,o=Tt(s,d),r=s.commonAncestorContainer,r.nodeType===M&&(r=r.parentNode);r&&r!==i;)a=r.cloneNode(!1),a.appendChild(o),o=a,r=r.parentNode;rn(e,o,d,this._config.willCutCopy,null,!1)}else setTimeout(function(){try{l._ensureBottomLine()}catch(e){l.didError(e)}},0);this.setSelection(s)},sn=function(e,t,n,i,o,r){var a,s,d,l,c,h;if(!tt&&e.clipboardData){for(a=xt(t,n),s=Ot(t,n),d=a===s&&a||n,t=t.cloneRange(),kt(t),Lt(t,d,d,n),l=t.cloneContents(),c=t.commonAncestorContainer,c.nodeType===M&&(c=c.parentNode);c&&c!==d;)h=c.cloneNode(!1),h.appendChild(l),l=h,c=c.parentNode;rn(e,l,n,i,o,r)}},dn=function(e){sn(e,this.getSelection(),this._root,this._config.willCutCopy,null,!1)},ln=function(e){var t,n,i,o,r,a=e.clipboardData,s=a&&a.items,d=this.isShiftDown,l=!1,c=!1,h=!1,f=null,u=null,p=this;if(s){for(t=s.length;t--;)n=s[t],i=n.type,"text/html"===i?u=n:"text/plain"===i||"text/uri-list"===i?f=n:"text/rtf"===i?c=!0:/^image\/.*/.test(i)&&(h=!0);if(h&&(!c||!u))return e.preventDefault(),this.fireEvent("dragover",{dataTransfer:a,preventDefault:function(){l=!0}}),void(l&&this.fireEvent("drop",{dataTransfer:a}));if(!tt)return e.preventDefault(),void(!u||d&&f?f&&f.getAsString(function(e){p.insertPlainText(e,!0)}):u.getAsString(function(e){p.insertHTML(e,!0)}))}if(o=a&&a.types,!tt&&o&&(lt.call(o,"text/html")>-1||!et&&lt.call(o,"text/plain")>-1&&lt.call(o,"text/rtf")<0))return e.preventDefault(),void(!d&&(r=a.getData("text/html"))?this.insertHTML(r,!0):((r=a.getData("text/plain"))||(r=a.getData("text/uri-list")))&&this.insertPlainText(r,!0));this._awaitingPaste=!0;var g=this._doc.body,m=this.getSelection(),v=m.startContainer,C=m.startOffset,N=m.endContainer,S=m.endOffset,y=this.createElement("DIV",{contenteditable:"true",style:"position:fixed; overflow:hidden; top:0; right:100%; width:1px; height:1px;"});g.appendChild(y),m.selectNodeContents(y),this.setSelection(m),setTimeout(function(){try{p._awaitingPaste=!1;for(var e,t,n="",i=y;y=i;)i=y.nextSibling,_(y),e=y.firstChild,e&&e===y.lastChild&&"DIV"===e.nodeName&&(y=e),n+=y.innerHTML;t=p.createRange(v,C,N,S),p.setSelection(t),n&&p.insertHTML(n,!0)}catch(o){p.didError(o)}},0)},cn=function(e){for(var t=e.dataTransfer.types,n=t.length,i=!1,o=!1;n--;)switch(t[n]){case"text/plain":i=!0;break;case"text/html":o=!0;break;default:return}(o||i)&&this.saveUndoState()},hn=R.prototype,fn=function(e,t,n){var i=n._doc,o=e?DOMPurify.sanitize(e,{ALLOW_UNKNOWN_PROTOCOLS:!0,WHOLE_DOCUMENT:!1,RETURN_DOM:!0,RETURN_DOM_FRAGMENT:!0}):null;return o?i.importNode(o,!0):i.createDocumentFragment()};hn.setConfig=function(e){return e=B({blockTag:"DIV",blockAttributes:null,tagAttributes:{blockquote:null,ul:null,ol:null,li:null,a:null},classNames:{colour:"colour",fontFamily:"font",fontSize:"size",highlight:"highlight"},leafNodeNames:ut,undo:{documentSizeThreshold:-1,undoLimit:-1},isInsertedHTMLSanitized:!0,isSetHTMLSanitized:!0,sanitizeToDOMFragment:"undefined"!=typeof DOMPurify&&DOMPurify.isSupported?fn:null,willCutCopy:null,addLinks:!0},e,!0),e.blockTag=e.blockTag.toUpperCase(),this._config=e,this},hn.createElement=function(e,t,n){return y(this._doc,e,t,n)},hn.createDefaultBlock=function(e){var t=this._config;return T(this.createElement(t.blockTag,t.blockAttributes,e),this._root)},hn.didError=function(e){console.log(e)},hn.getDocument=function(){return this._doc},hn.getRoot=function(){return this._root},hn.modifyDocument=function(e){var t=this._mutation;t&&(t.takeRecords().length&&this._docWasChanged(),t.disconnect()),this._ignoreAllChanges=!0,e(),this._ignoreAllChanges=!1,t&&(t.observe(this._root,{childList:!0,attributes:!0,characterData:!0,subtree:!0}),this._ignoreChange=!1)};var un={pathChange:1,select:1,input:1,undoStateChange:1};hn.fireEvent=function(e,t){var n,i,o,r=this._events[e];if(/^(?:focus|blur)/.test(e))if(n=this._root===this._doc.activeElement,"focus"===e){if(!n||this._isFocused)return this;this._isFocused=!0}else{if(n||!this._isFocused)return this;this._isFocused=!1}if(r)for(t||(t={}),t.type!==e&&(t.type=e),r=r.slice(),i=r.length;i--;){o=r[i];try{o.handleEvent?o.handleEvent(t):o.call(this,t)}catch(a){a.details="Squire: fireEvent error. Event type: "+e,this.didError(a)}}return this},hn.destroy=function(){var e,t=this._events;for(e in t)this.removeEventListener(e);this._mutation&&this._mutation.disconnect(),delete this._root.__squire__,this._undoIndex=-1,this._undoStack=[],this._undoStackLength=0},hn.handleEvent=function(e){this.fireEvent(e.type,e)},hn.addEventListener=function(e,t){var n=this._events[e],i=this._root;return t?(n||(n=this._events[e]=[],un[e]||("selectionchange"===e&&(i=this._doc),i.addEventListener(e,this,!0))),n.push(t),this):(this.didError({name:"Squire: addEventListener with null or undefined fn",message:"Event type: "+e}),this)},hn.removeEventListener=function(e,t){var n,i=this._events[e],o=this._root;if(i){if(t)for(n=i.length;n--;)i[n]===t&&i.splice(n,1);else i.length=0;i.length||(delete this._events[e],un[e]||("selectionchange"===e&&(o=this._doc),o.removeEventListener(e,this,!0)))}return this},hn.createRange=function(e,t,n,i){if(e instanceof this._win.Range)return e.cloneRange();var o=this._doc.createRange();return o.setStart(e,t),n?o.setEnd(n,i):o.setEnd(e,t),o},hn.getCursorPosition=function(e){if(!e&&!(e=this.getSelection())||!e.getBoundingClientRect)return null;var t,n,i=e.getBoundingClientRect();return i&&!i.top&&(this._ignoreChange=!0,t=this._doc.createElement("SPAN"),t.textContent=$,St(e,t),i=t.getBoundingClientRect(),n=t.parentNode,n.removeChild(t),L(n,e)),i},hn._moveCursorTo=function(e){var t=this._root,n=this.createRange(t,e?0:t.childNodes.length);return kt(n),this.setSelection(n),this},hn.moveCursorToStart=function(){return this._moveCursorTo(!0)},hn.moveCursorToEnd=function(){return this._moveCursorTo(!1)};var pn=function(e){return e._win.getSelection()||null};hn.setSelection=function(e){if(e)if(this._lastSelection=e,this._isFocused){J&&this._win.focus();var t=pn(this);t&&t.setBaseAndExtent?t.setBaseAndExtent(e.startContainer,e.startOffset,e.endContainer,e.endOffset):t&&(t.removeAllRanges(),t.addRange(e))}else D.call(this);return this},hn.getSelection=function(){var e,t,n,i,r=pn(this),a=this._root;return this._isFocused&&r&&r.rangeCount&&(e=r.getRangeAt(0).cloneRange(),t=e.startContainer,n=e.endContainer,t&&o(t)&&e.setStartBefore(t),n&&o(n)&&e.setEndBefore(n)),e&&m(a,e.commonAncestorContainer)?this._lastSelection=e:(e=this._lastSelection,i=e.commonAncestorContainer,m(i.ownerDocument,i)||(e=null)),e||(e=this.createRange(a.firstChild,0)),e},hn.getSelectedText=function(){var e=this.getSelection();if(!e||e.collapsed)return"";var t,i=new n(e.commonAncestorContainer,K|z,function(t){return bt(e,t,!0)}),o=e.startContainer,r=e.endContainer,s=i.currentNode=o,d="",l=!1;for(i.filter(s)||(s=i.nextNode());s;)s.nodeType===M?(t=s.data,t&&/\S/.test(t)&&(s===r&&(t=t.slice(0,e.endOffset)),s===o&&(t=t.slice(e.startOffset)),d+=t,l=!0)):("BR"===s.nodeName||l&&!a(s))&&(d+="\n",l=!1),s=i.nextNode();return d},hn.getPath=function(){return this._path};var gn=function(e,t){for(var i,o,r,s=new n(e,K);o=s.nextNode();)for(;(r=o.data.indexOf($))>-1&&(!t||o.parentNode!==t);){if(1===o.length){do i=o.parentNode,i.removeChild(o),o=i,s.currentNode=i;while(a(o)&&!C(o));break}o.deleteData(r,1)}};hn._didAddZWS=function(){this._hasZWS=!0},hn._removeZWS=function(){this._hasZWS&&(gn(this._root),this._hasZWS=!1)},hn._updatePath=function(e,t){if(e){var n,i=e.startContainer,o=e.endContainer;(t||i!==this._lastAnchorNode||o!==this._lastFocusNode)&&(this._lastAnchorNode=i,this._lastFocusNode=o,n=i&&o?i===o?v(o,this._root,this._config):"(selection)":"",this._path!==n&&(this._path=n,this.fireEvent("pathChange",{path:n}))),this.fireEvent(e.collapsed?"cursor":"select",{range:e})
}},hn._updatePathOnEvent=function(){var e=this;e._isFocused&&!e._willUpdatePath&&(e._willUpdatePath=!0,setTimeout(function(){e._willUpdatePath=!1,e._updatePath(e.getSelection())},0))},hn.focus=function(){return this._root.focus({preventScroll:!0}),it&&this.fireEvent("focus"),this},hn.blur=function(){return this._root.blur(),it&&this.fireEvent("blur"),this};var mn="squire-selection-start",vn="squire-selection-end";hn._saveRangeToBookmark=function(e){var t,n=this.createElement("INPUT",{id:mn,type:"hidden"}),i=this.createElement("INPUT",{id:vn,type:"hidden"});St(e,n),e.collapse(!1),St(e,i),n.compareDocumentPosition(i)&w&&(n.id=vn,i.id=mn,t=n,n=i,i=t),e.setStartAfter(n),e.setEndBefore(i)},hn._getRangeAndRemoveBookmark=function(e){var t=this._root,n=t.querySelector("#"+mn),i=t.querySelector("#"+vn);if(n&&i){var o=n.parentNode,r=i.parentNode,a=lt.call(o.childNodes,n),s=lt.call(r.childNodes,i);o===r&&(s-=1),_(n),_(i),e||(e=this._doc.createRange()),e.setStart(o,a),e.setEnd(r,s),L(o,e),o!==r&&L(r,e),e.collapsed&&(o=e.startContainer,o.nodeType===M&&(r=o.childNodes[e.startOffset],r&&r.nodeType===M||(r=o.childNodes[e.startOffset-1]),r&&r.nodeType===M&&(e.setStart(r,0),e.collapse(!0))))}return e||null},hn._keyUpDetectChange=function(e){var t=e.keyCode;e.ctrlKey||e.metaKey||e.altKey||!(16>t||t>20)||!(33>t||t>45)||this._docWasChanged()},hn._docWasChanged=function(){if(st&&(Ct=new WeakMap),!this._ignoreAllChanges){if(at&&this._ignoreChange)return void(this._ignoreChange=!1);this._isInUndoState&&(this._isInUndoState=!1,this.fireEvent("undoStateChange",{canUndo:!0,canRedo:!1})),this.fireEvent("input")}},hn._recordUndoState=function(e,t){if(!this._isInUndoState||t){var n,i=this._undoIndex,o=this._undoStack,r=this._config.undo,a=r.documentSizeThreshold,s=r.undoLimit;t||(i+=1),i<this._undoStackLength&&(o.length=this._undoStackLength=i),e&&this._saveRangeToBookmark(e),n=this._getHTML(),a>-1&&2*n.length>a&&s>-1&&i>s&&(o.splice(0,i-s),i=s,this._undoStackLength=s),o[i]=n,this._undoIndex=i,this._undoStackLength+=1,this._isInUndoState=!0}},hn.saveUndoState=function(e){return e===t&&(e=this.getSelection()),this._recordUndoState(e,this._isInUndoState),this._getRangeAndRemoveBookmark(e),this},hn.undo=function(){if(0!==this._undoIndex||!this._isInUndoState){this._recordUndoState(this.getSelection(),!1),this._undoIndex-=1,this._setHTML(this._undoStack[this._undoIndex]);var e=this._getRangeAndRemoveBookmark();e&&this.setSelection(e),this._isInUndoState=!0,this.fireEvent("undoStateChange",{canUndo:0!==this._undoIndex,canRedo:!0}),this.fireEvent("input")}return this},hn.redo=function(){var e=this._undoIndex,t=this._undoStackLength;if(t>e+1&&this._isInUndoState){this._undoIndex+=1,this._setHTML(this._undoStack[this._undoIndex]);var n=this._getRangeAndRemoveBookmark();n&&this.setSelection(n),this.fireEvent("undoStateChange",{canUndo:!0,canRedo:t>e+2}),this.fireEvent("input")}return this},hn.hasFormat=function(e,t,i){if(e=e.toUpperCase(),t||(t={}),!i&&!(i=this.getSelection()))return!1;!i.collapsed&&i.startContainer.nodeType===M&&i.startOffset===i.startContainer.length&&i.startContainer.nextSibling&&i.setStartBefore(i.startContainer.nextSibling),!i.collapsed&&i.endContainer.nodeType===M&&0===i.endOffset&&i.endContainer.previousSibling&&i.setEndAfter(i.endContainer.previousSibling);var o,r,a=this._root,s=i.commonAncestorContainer;if(g(s,a,e,t))return!0;if(s.nodeType===M)return!1;o=new n(s,K,function(e){return bt(i,e,!0)});for(var d=!1;r=o.nextNode();){if(!g(r,a,e,t))return!1;d=!0}return d},hn.getFontInfo=function(e){var n,i,o,r={color:t,backgroundColor:t,family:t,size:t},a=0;if(!e&&!(e=this.getSelection()))return r;if(n=e.commonAncestorContainer,e.collapsed||n.nodeType===M)for(n.nodeType===M&&(n=n.parentNode);4>a&&n;)(i=n.style)&&(!r.color&&(o=i.color)&&(r.color=o,a+=1),!r.backgroundColor&&(o=i.backgroundColor)&&(r.backgroundColor=o,a+=1),!r.family&&(o=i.fontFamily)&&(r.family=o,a+=1),!r.size&&(o=i.fontSize)&&(r.size=o,a+=1)),n=n.parentNode;return r},hn._addFormat=function(e,t,i){var o,r,s,d,l,c,h,f,u,p=this._root;if(i.collapsed){for(o=T(this.createElement(e,t),p),St(i,o),i.setStart(o.firstChild,o.firstChild.length),i.collapse(!0),u=o;a(u);)u=u.parentNode;gn(u,o)}else{if(r=new n(i.commonAncestorContainer,K|z,function(e){return(e.nodeType===M||"BR"===e.nodeName||"IMG"===e.nodeName)&&bt(i,e,!0)}),s=i.startContainer,l=i.startOffset,d=i.endContainer,c=i.endOffset,r.currentNode=s,r.filter(s)||(s=r.nextNode(),l=0),!s)return i;do h=r.currentNode,f=!g(h,p,e,t),f&&(h===d&&h.length>c&&h.splitText(c),h===s&&l&&(h=h.splitText(l),d===s&&(d=h,c-=l),s=h,l=0),o=this.createElement(e,t),N(h,o),o.appendChild(h));while(r.nextNode());d.nodeType!==M&&(h.nodeType===M?(d=h,c=h.length):(d=h.parentNode,c=1)),i=this.createRange(s,l,d,c)}return i},hn._removeFormat=function(e,t,n,i){this._saveRangeToBookmark(n);var o,r=this._doc;n.collapsed&&(rt?(o=r.createTextNode($),this._didAddZWS()):o=r.createTextNode(""),St(n,o));for(var s=n.commonAncestorContainer;a(s);)s=s.parentNode;var d=n.startContainer,l=n.startOffset,c=n.endContainer,h=n.endOffset,f=[],u=function(e,t){if(!bt(n,e,!1)){var i,o,r=e.nodeType===M;if(!bt(n,e,!0))return void("INPUT"===e.nodeName||r&&!e.data||f.push([t,e]));if(r)e===c&&h!==e.length&&f.push([t,e.splitText(h)]),e===d&&l&&(e.splitText(l),f.push([t,e]));else for(i=e.firstChild;i;i=o)o=i.nextSibling,u(i,t)}},g=Array.prototype.filter.call(s.getElementsByTagName(e),function(i){return bt(n,i,!0)&&p(i,e,t)});return i||g.forEach(function(e){u(e,e)}),f.forEach(function(e){var t=e[0].cloneNode(!1),n=e[1];N(n,t),t.appendChild(n)}),g.forEach(function(e){N(e,S(e))}),this._getRangeAndRemoveBookmark(n),o&&n.collapse(!1),L(s,n),n},hn.changeFormat=function(e,t,n,i){return n||(n=this.getSelection())?(this.saveUndoState(n),t&&(n=this._removeFormat(t.tag.toUpperCase(),t.attributes||{},n,i)),e&&(n=this._addFormat(e.tag.toUpperCase(),e.attributes||{},n)),this.setSelection(n),this._updatePath(n,!0),at||this._docWasChanged(),this):this};var Cn={DT:"DD",DD:"DT",LI:"LI",PRE:"PRE"},_n=function(e,t,n,i){var o=Cn[t.nodeName],r=null,a=b(n,i,t.parentNode,e._root),s=e._config;return o||(o=s.blockTag,r=s.blockAttributes),p(a,o,r)||(t=y(a.ownerDocument,o,r),a.dir&&(t.dir=a.dir),N(a,t),t.appendChild(S(a)),a=t),a};hn.forEachBlock=function(e,t,n){if(!n&&!(n=this.getSelection()))return this;t&&this.saveUndoState(n);var i=this._root,o=xt(n,i),r=Ot(n,i);if(o&&r)do if(e(o)||o===r)break;while(o=h(o,i));return t&&(this.setSelection(n),this._updatePath(n,!0),at||this._docWasChanged()),this},hn.modifyBlocks=function(e,t){if(!t&&!(t=this.getSelection()))return this;this._recordUndoState(t,this._isInUndoState);var n,i=this._root;return Pt(t,i),Lt(t,i,i,i),n=yt(t,i,i),St(t,e.call(this,n)),t.endOffset<t.endContainer.childNodes.length&&x(t.endContainer.childNodes[t.endOffset],i),x(t.startContainer.childNodes[t.startOffset],i),this._getRangeAndRemoveBookmark(t),this.setSelection(t),this._updatePath(t,!0),at||this._docWasChanged(),this};var Nn=function(e){return this.createElement("BLOCKQUOTE",this._config.tagAttributes.blockquote,[e])},Sn=function(e){var t=this._root,n=e.querySelectorAll("blockquote");return Array.prototype.filter.call(n,function(e){return!g(e.parentNode,t,"BLOCKQUOTE")}).forEach(function(e){N(e,S(e))}),e},yn=function(){return this.createDefaultBlock([this.createElement("INPUT",{id:mn,type:"hidden"}),this.createElement("INPUT",{id:vn,type:"hidden"})])},Tn=function(e,t,n){for(var i,o,r,a,s=l(t,e._root),d=e._config.tagAttributes,c=d[n.toLowerCase()],h=d.li;i=s.nextNode();)"LI"===i.parentNode.nodeName&&(i=i.parentNode,s.currentNode=i.lastChild),"LI"!==i.nodeName?(a=e.createElement("LI",h),i.dir&&(a.dir=i.dir),(r=i.previousSibling)&&r.nodeName===n?(r.appendChild(a),_(i)):N(i,e.createElement(n,c,[a])),a.appendChild(S(i)),s.currentNode=a):(i=i.parentNode,o=i.nodeName,o!==n&&/^[OU]L$/.test(o)&&N(i,e.createElement(n,c,[S(i)])))},En=function(e){return Tn(this,e,"UL"),e},bn=function(e){return Tn(this,e,"OL"),e},kn=function(e){var t,n,i,o,r,a=e.querySelectorAll("UL, OL"),d=e.querySelectorAll("LI"),l=this._root;for(t=0,n=a.length;n>t;t+=1)i=a[t],o=S(i),E(o,l),N(i,o);for(t=0,n=d.length;n>t;t+=1)r=d[t],s(r)?N(r,this.createDefaultBlock([S(r)])):(E(r,l),N(r,S(r)));return e},Ln=function(e,t){for(var n=e.commonAncestorContainer,i=e.startContainer,o=e.endContainer;n&&n!==t&&!/^[OU]L$/.test(n.nodeName);)n=n.parentNode;if(!n||n===t)return null;for(i===n&&(i=i.childNodes[e.startOffset]),o===n&&(o=o.childNodes[e.endOffset]);i&&i.parentNode!==n;)i=i.parentNode;for(;o&&o.parentNode!==n;)o=o.parentNode;return[n,i,o]};hn.increaseListLevel=function(e){if(!e&&!(e=this.getSelection()))return this.focus();var t=this._root,n=Ln(e,t);if(!n)return this.focus();var i=n[0],o=n[1],r=n[2];if(!o||o===i.firstChild)return this.focus();this._recordUndoState(e,this._isInUndoState);var a,s,d=i.nodeName,l=o.previousSibling;l.nodeName!==d&&(a=this._config.tagAttributes[d.toLowerCase()],l=this.createElement(d,a),i.insertBefore(l,o));do s=o===r?null:o.nextSibling,l.appendChild(o);while(o=s);return s=l.nextSibling,s&&x(s,t),this._getRangeAndRemoveBookmark(e),this.setSelection(e),this._updatePath(e,!0),at||this._docWasChanged(),this.focus()},hn.decreaseListLevel=function(e){if(!e&&!(e=this.getSelection()))return this.focus();var t=this._root,n=Ln(e,t);if(!n)return this.focus();var i,o,r,a,s=n[0],d=n[1],l=n[2];if(d||(d=s.firstChild),l||(l=s.lastChild),this._recordUndoState(e,this._isInUndoState),d){if(i=s.parentNode,r=l.nextSibling?b(s,l.nextSibling,i,t):s.nextSibling,i!==t&&"LI"===i.nodeName){for(i=i.parentNode;r;)o=r.nextSibling,l.appendChild(r),r=o;r=s.parentNode.nextSibling}a=!/^[OU]L$/.test(i.nodeName);do o=d===l?null:d.nextSibling,s.removeChild(d),a&&"LI"===d.nodeName&&(d=this.createDefaultBlock([S(d)])),i.insertBefore(d,r);while(d=o)}return s.firstChild||_(s),r&&x(r,t),this._getRangeAndRemoveBookmark(e),this.setSelection(e),this._updatePath(e,!0),at||this._docWasChanged(),this.focus()},hn._ensureBottomLine=function(){var e=this._root,t=e.lastElementChild;t&&t.nodeName===this._config.blockTag&&s(t)||e.appendChild(this.createDefaultBlock())},hn.setKeyHandler=function(e,t){return this._keyHandlers[e]=t,this},hn._getHTML=function(){return this._root.innerHTML},hn._setHTML=function(e){var t=this._root,n=t;n.innerHTML=e;do T(n,t);while(n=h(n,t));this._ignoreChange=!0},hn.getHTML=function(e){var t,n;return e&&(n=this.getSelection())&&this._saveRangeToBookmark(n),t=this._getHTML().replace(/\u200B/g,""),n&&this._getRangeAndRemoveBookmark(n),t},hn.setHTML=function(e){var t,n,i,o=this._config,r=o.isSetHTMLSanitized?o.sanitizeToDOMFragment:null,a=this._root;"function"==typeof r?n=r(e,!1,this):(t=this.createElement("DIV"),t.innerHTML=e,n=this._doc.createDocumentFragment(),n.appendChild(S(t))),Jt(n,o),on(n,a,!1),E(n,a);for(var s=n;s=h(s,a);)T(s,a);for(this._ignoreChange=!0;i=a.lastChild;)a.removeChild(i);a.appendChild(n),T(a,a),this._undoIndex=-1,this._undoStack.length=0,this._undoStackLength=0,this._isInUndoState=!1;var d=this._getRangeAndRemoveBookmark()||this.createRange(a.firstChild,0);return this.saveUndoState(d),this._lastSelection=d,D.call(this),this._updatePath(d,!0),this},hn.insertElement=function(e,t){if(t||(t=this.getSelection()),t.collapse(!0),a(e))St(t,e),t.setStartAfter(e);else{for(var n,i,o=this._root,r=xt(t,o)||o;r!==o&&!r.nextSibling;)r=r.parentNode;r!==o&&(n=r.parentNode,i=b(n,r.nextSibling,o,o)),i?o.insertBefore(e,i):(o.appendChild(e),i=this.createDefaultBlock(),o.appendChild(i)),t.setStart(i,0),t.setEnd(i,0),kt(t)}return this.focus(),this.setSelection(t),this._updatePath(t),at||this._docWasChanged(),this},hn.insertImage=function(e,t){var n=this.createElement("IMG",B({src:e},t,!0));return this.insertElement(n),n},hn.linkRegExp=/\b(?:((?:(?:ht|f)tps?:\/\/|www\d{0,3}[.]|[a-z0-9][a-z0-9.\-]*[.][a-z]{2,}\/)(?:[^\s()<>]+|\([^\s()<>]+\))+(?:[^\s?&`!()\[\]{};:'".,<>«»“”‘’]|\([^\s()<>]+\)))|([\w\-.%+]+@(?:[\w\-]+\.)+[a-z]{2,}\b(?:[?][^&?\s]+=[^\s?&`!()\[\]{};:'".,<>«»“”‘’]+(?:&[^&?\s]+=[^\s?&`!()\[\]{};:'".,<>«»“”‘’]+)*)?))/i;var An=function(e,t,i){var o,r,a,s,d,l,c,h,f=e.ownerDocument,u=new n(e,K,function(e){return!g(e,t,"A")}),p=i.linkRegExp,m=i._config.tagAttributes.a;if(p)for(;o=u.nextNode();)for(r=o.data,a=o.parentNode;s=p.exec(r);)d=s.index,l=d+s[0].length,d&&(c=f.createTextNode(r.slice(0,d)),a.insertBefore(c,o)),h=s[1]?/^(?:ht|f)tps?:/i.test(s[1])?s[1]:"http://"+s[1]:"mailto:"+s[0],c=i.createElement("A",B({href:h},m,!1)),c.textContent=r.slice(d,l),a.insertBefore(c,o),o.data=r=r.slice(l),i.fireEvent("addLink",{link:h})};hn.insertHTML=function(e,t){var n,i,o,r,a,s,d,l=this._config,c=l.isInsertedHTMLSanitized?l.sanitizeToDOMFragment:null,f=this.getSelection(),u=this._doc;"function"==typeof c?r=c(e,t,this):(t&&(n=e.indexOf("<!--StartFragment-->"),i=e.lastIndexOf("<!--EndFragment-->"),n>-1&&i>-1&&(e=e.slice(n+20,i))),/<\/td>((?!<\/tr>)[\s\S])*$/i.test(e)&&(e="<TR>"+e+"</TR>"),/<\/tr>((?!<\/table>)[\s\S])*$/i.test(e)&&(e="<TABLE>"+e+"</TABLE>"),o=this.createElement("DIV"),o.innerHTML=e,r=u.createDocumentFragment(),r.appendChild(S(o))),this.saveUndoState(f);try{for(a=this._root,s=r,d={fragment:r,preventDefault:function(){this.defaultPrevented=!0},defaultPrevented:!1},An(r,r,this),Jt(r,l),on(r,a,!1),en(r),r.normalize();s=h(s,r);)T(s,a);t&&this.fireEvent("willPaste",d),d.defaultPrevented||(Et(f,d.fragment,a),at||this._docWasChanged(),f.collapse(!1),At(f,"A",a),this._ensureBottomLine()),this.setSelection(f),this._updatePath(f,!0),t&&this.focus()}catch(p){this.didError(p)}return this};var xn=function(e){return e.split("&").join("&amp;").split("<").join("&lt;").split(">").join("&gt;").split('"').join("&quot;")};hn.insertPlainText=function(e,t){var n=this.getSelection();if(n.collapsed&&g(n.startContainer,this._root,"PRE")){var i,o,r=n.startContainer,a=n.startOffset;return r&&r.nodeType===M||(i=this._doc.createTextNode(""),r.insertBefore(i,r.childNodes[a]),r=i,a=0),o={text:e,preventDefault:function(){this.defaultPrevented=!0},defaultPrevented:!1},t&&this.fireEvent("willPaste",o),o.defaultPrevented||(e=o.text,r.insertData(a,e),n.setStart(r,a+e.length),n.collapse(!0)),this.setSelection(n),this}var s,d,l,c,h=e.split("\n"),f=this._config,u=f.blockTag,p=f.blockAttributes,m="</"+u+">",v="<"+u;for(s in p)v+=" "+s+'="'+xn(p[s])+'"';for(v+=">",d=0,l=h.length;l>d;d+=1)c=h[d],c=xn(c).replace(/ (?= )/g,"&nbsp;"),d&&(c=v+(c||"<BR>")+m),h[d]=c;return this.insertHTML(h.join(""),t)};var On=function(e,t,n){return function(){return this[e](t,n),this.focus()}};hn.addStyles=function(e){if(e){var t=this._doc.documentElement.firstChild,n=this.createElement("STYLE",{type:"text/css"});n.appendChild(this._doc.createTextNode(e)),t.appendChild(n)}return this},hn.bold=On("changeFormat",{tag:"B"}),hn.italic=On("changeFormat",{tag:"I"}),hn.underline=On("changeFormat",{tag:"U"}),hn.strikethrough=On("changeFormat",{tag:"S"}),hn.subscript=On("changeFormat",{tag:"SUB"},{tag:"SUP"}),hn.superscript=On("changeFormat",{tag:"SUP"},{tag:"SUB"}),hn.removeBold=On("changeFormat",null,{tag:"B"}),hn.removeItalic=On("changeFormat",null,{tag:"I"}),hn.removeUnderline=On("changeFormat",null,{tag:"U"}),hn.removeStrikethrough=On("changeFormat",null,{tag:"S"}),hn.removeSubscript=On("changeFormat",null,{tag:"SUB"}),hn.removeSuperscript=On("changeFormat",null,{tag:"SUP"}),hn.makeLink=function(e,t){var n=this.getSelection();if(n.collapsed){var i=e.indexOf(":")+1;if(i)for(;"/"===e[i];)i+=1;St(n,this._doc.createTextNode(e.slice(i)))}return t=B(B({href:e},t,!0),this._config.tagAttributes.a,!1),this.changeFormat({tag:"A",attributes:t},{tag:"A"},n),this.focus()},hn.removeLink=function(){return this.changeFormat(null,{tag:"A"},this.getSelection(),!0),this.focus()},hn.setFontFace=function(e){var t=this._config.classNames.fontFamily;return this.changeFormat(e?{tag:"SPAN",attributes:{"class":t,style:"font-family: "+e+", sans-serif;"}}:null,{tag:"SPAN",attributes:{"class":t}}),this.focus()},hn.setFontSize=function(e){var t=this._config.classNames.fontSize;return this.changeFormat(e?{tag:"SPAN",attributes:{"class":t,style:"font-size: "+("number"==typeof e?e+"px":e)}}:null,{tag:"SPAN",attributes:{"class":t}}),this.focus()},hn.setTextColour=function(e){var t=this._config.classNames.colour;return this.changeFormat(e?{tag:"SPAN",attributes:{"class":t,style:"color:"+e}}:null,{tag:"SPAN",attributes:{"class":t}}),this.focus()},hn.setHighlightColour=function(e){var t=this._config.classNames.highlight;return this.changeFormat(e?{tag:"SPAN",attributes:{"class":t,style:"background-color:"+e}}:e,{tag:"SPAN",attributes:{"class":t}}),this.focus()},hn.setTextAlignment=function(e){return this.forEachBlock(function(t){var n=t.className.split(/\s+/).filter(function(e){return!!e&&!/^align/.test(e)}).join(" ");e?(t.className=n+" align-"+e,t.style.textAlign=e):(t.className=n,t.style.textAlign="")},!0),this.focus()},hn.setTextDirection=function(e){return this.forEachBlock(function(t){e?t.dir=e:t.removeAttribute("dir")},!0),this.focus()};var Bn=function(e){for(var t,i=this._root,o=this._doc,r=o.createDocumentFragment(),a=l(e,i);t=a.nextNode();){var s,d,c=t.querySelectorAll("BR"),h=[],f=c.length;for(s=0;f>s;s+=1)h[s]=nn(c[s],!1);for(;f--;)d=c[f],h[f]?N(d,o.createTextNode("\n")):_(d);for(c=t.querySelectorAll("CODE"),f=c.length;f--;)_(c[f]);r.childNodes.length&&r.appendChild(o.createTextNode("\n")),r.appendChild(S(t))}for(a=new n(r,K);t=a.nextNode();)t.data=t.data.replace(/ /g," ");return r.normalize(),T(this.createElement("PRE",this._config.tagAttributes.pre,[r]),i)},Rn=function(e){for(var t,i,o,r,a,s,d=this._doc,l=this._root,c=e.querySelectorAll("PRE"),h=c.length;h--;){for(t=c[h],i=new n(t,K);o=i.nextNode();){for(r=o.data,r=r.replace(/ (?= )/g," "),a=d.createDocumentFragment();(s=r.indexOf("\n"))>-1;)a.appendChild(d.createTextNode(r.slice(0,s))),a.appendChild(d.createElement("BR")),r=r.slice(s+1);o.parentNode.insertBefore(a,o),o.data=r}E(t,l),N(t,S(t))}return e};hn.code=function(){var e=this.getSelection();return e.collapsed||d(e.commonAncestorContainer)?this.modifyBlocks(Bn,e):this.changeFormat({tag:"CODE",attributes:this._config.tagAttributes.code},null,e),this.focus()},hn.removeCode=function(){var e=this.getSelection(),t=e.commonAncestorContainer,n=g(t,this._root,"PRE");return n?this.modifyBlocks(Rn,e):this.changeFormat(null,{tag:"CODE"},e),this.focus()},hn.toggleCode=function(){return this.hasFormat("PRE")||this.hasFormat("CODE")?this.removeCode():this.code(),this},hn.removeAllFormatting=function(e){if(!e&&!(e=this.getSelection())||e.collapsed)return this;for(var t=this._root,n=e.commonAncestorContainer;n&&!s(n);)n=n.parentNode;if(n||(Pt(e,t),n=t),n.nodeType===M)return this;this.saveUndoState(e),Lt(e,n,n,t);for(var i,o,r=n.ownerDocument,a=e.startContainer,d=e.startOffset,l=e.endContainer,c=e.endOffset,h=r.createDocumentFragment(),f=r.createDocumentFragment(),u=b(l,c,n,t),p=b(a,d,n,t);p!==u;)i=p.nextSibling,h.appendChild(p),p=i;return I(this,h,f),f.normalize(),p=f.firstChild,i=f.lastChild,o=n.childNodes,p?(n.insertBefore(f,u),d=lt.call(o,p),c=lt.call(o,i)+1):(d=lt.call(o,u),c=d),e.setStart(n,d),e.setEnd(n,c),L(n,e),kt(e),this.setSelection(e),this._updatePath(e,!0),this.focus()},hn.increaseQuoteLevel=On("modifyBlocks",Nn),hn.decreaseQuoteLevel=On("modifyBlocks",Sn),hn.makeUnorderedList=On("modifyBlocks",En),hn.makeOrderedList=On("modifyBlocks",bn),hn.removeList=On("modifyBlocks",kn),R.isInline=a,R.isBlock=s,R.isContainer=d,R.getBlockWalker=l,R.getPreviousBlock=c,R.getNextBlock=h,R.areAlike=u,R.hasTagAttributes=p,R.getNearest=g,R.isOrContains=m,R.detach=_,R.replaceWith=N,R.empty=S,R.getNodeBefore=_t,R.getNodeAfter=Nt,R.insertNodeInRange=St,R.extractContentsOfRange=yt,R.deleteContentsOfRange=Tt,R.insertTreeFragmentIntoRange=Et,R.isNodeContainedInRange=bt,R.moveRangeBoundariesDownTree=kt,R.moveRangeBoundariesUpTree=Lt,R.getStartBlockOfRange=xt,R.getEndBlockOfRange=Ot,R.contentWalker=Bt,R.rangeDoesStartAtBlockBoundary=Rt,R.rangeDoesEndAtBlockBoundary=Dt,R.expandRangeToBlockBoundaries=Pt,R.onCopy=sn,R.onPaste=ln,R.addLinks=An,R.splitBlock=_n,R.startSelectionId=mn,R.endSelectionId=vn, true?module.exports=R:"function"==typeof define&&define.amd?define(function(){return R}):(j.Squire=R,top!==j&&"true"===e.documentElement.getAttribute("data-squireinit")&&(j.editor=new R(e),j.onEditorLoad&&(j.onEditorLoad(j.editor),j.onEditorLoad=null)))}(document);

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

/* jshint maxerr: 10000 */
/* jslint unused: true */
/* jshint shadow: true */
/* jshint -W075 */
(function(ns){
    // this list must be ordered from largest length of the value array, index 0, to the shortest
    ns.emojioneList = {":kiss_mm:":{"uc_base":"1f468-2764-1f48b-1f468","uc_output":"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","uc_match":"1f468-2764-fe0f-1f48b-1f468","uc_greedy":"1f468-2764-1f48b-1f468","shortnames":[":couplekiss_mm:"],"category":"people"},":kiss_woman_man:":{"uc_base":"1f469-2764-1f48b-1f468","uc_output":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f468","uc_match":"1f469-2764-fe0f-1f48b-1f468","uc_greedy":"1f469-2764-1f48b-1f468","shortnames":[],"category":"people"},":kiss_ww:":{"uc_base":"1f469-2764-1f48b-1f469","uc_output":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","uc_match":"1f469-2764-fe0f-1f48b-1f469","uc_greedy":"1f469-2764-1f48b-1f469","shortnames":[":couplekiss_ww:"],"category":"people"},":england:":{"uc_base":"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f","uc_output":"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f","uc_match":"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f","uc_greedy":"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f","shortnames":[],"category":"flags"},":scotland:":{"uc_base":"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f","uc_output":"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f","uc_match":"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f","uc_greedy":"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f","shortnames":[],"category":"flags"},":wales:":{"uc_base":"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f","uc_output":"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f","uc_match":"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f","uc_greedy":"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f","shortnames":[],"category":"flags"},":family_mmbb:":{"uc_base":"1f468-1f468-1f466-1f466","uc_output":"1f468-200d-1f468-200d-1f466-200d-1f466","uc_match":"1f468-1f468-1f466-1f466","uc_greedy":"1f468-1f468-1f466-1f466","shortnames":[],"category":"people"},":family_mmgb:":{"uc_base":"1f468-1f468-1f467-1f466","uc_output":"1f468-200d-1f468-200d-1f467-200d-1f466","uc_match":"1f468-1f468-1f467-1f466","uc_greedy":"1f468-1f468-1f467-1f466","shortnames":[],"category":"people"},":family_mmgg:":{"uc_base":"1f468-1f468-1f467-1f467","uc_output":"1f468-200d-1f468-200d-1f467-200d-1f467","uc_match":"1f468-1f468-1f467-1f467","uc_greedy":"1f468-1f468-1f467-1f467","shortnames":[],"category":"people"},":family_mwbb:":{"uc_base":"1f468-1f469-1f466-1f466","uc_output":"1f468-200d-1f469-200d-1f466-200d-1f466","uc_match":"1f468-1f469-1f466-1f466","uc_greedy":"1f468-1f469-1f466-1f466","shortnames":[],"category":"people"},":family_mwgb:":{"uc_base":"1f468-1f469-1f467-1f466","uc_output":"1f468-200d-1f469-200d-1f467-200d-1f466","uc_match":"1f468-1f469-1f467-1f466","uc_greedy":"1f468-1f469-1f467-1f466","shortnames":[],"category":"people"},":family_mwgg:":{"uc_base":"1f468-1f469-1f467-1f467","uc_output":"1f468-200d-1f469-200d-1f467-200d-1f467","uc_match":"1f468-1f469-1f467-1f467","uc_greedy":"1f468-1f469-1f467-1f467","shortnames":[],"category":"people"},":family_wwbb:":{"uc_base":"1f469-1f469-1f466-1f466","uc_output":"1f469-200d-1f469-200d-1f466-200d-1f466","uc_match":"1f469-1f469-1f466-1f466","uc_greedy":"1f469-1f469-1f466-1f466","shortnames":[],"category":"people"},":family_wwgb:":{"uc_base":"1f469-1f469-1f467-1f466","uc_output":"1f469-200d-1f469-200d-1f467-200d-1f466","uc_match":"1f469-1f469-1f467-1f466","uc_greedy":"1f469-1f469-1f467-1f466","shortnames":[],"category":"people"},":family_wwgg:":{"uc_base":"1f469-1f469-1f467-1f467","uc_output":"1f469-200d-1f469-200d-1f467-200d-1f467","uc_match":"1f469-1f469-1f467-1f467","uc_greedy":"1f469-1f469-1f467-1f467","shortnames":[],"category":"people"},":couple_mm:":{"uc_base":"1f468-2764-1f468","uc_output":"1f468-200d-2764-fe0f-200d-1f468","uc_match":"1f468-2764-fe0f-1f468","uc_greedy":"1f468-2764-1f468","shortnames":[":couple_with_heart_mm:"],"category":"people"},":couple_with_heart_woman_man:":{"uc_base":"1f469-2764-1f468","uc_output":"1f469-200d-2764-fe0f-200d-1f468","uc_match":"1f469-2764-fe0f-1f468","uc_greedy":"1f469-2764-1f468","shortnames":[],"category":"people"},":couple_ww:":{"uc_base":"1f469-2764-1f469","uc_output":"1f469-200d-2764-fe0f-200d-1f469","uc_match":"1f469-2764-fe0f-1f469","uc_greedy":"1f469-2764-1f469","shortnames":[":couple_with_heart_ww:"],"category":"people"},":family_man_boy_boy:":{"uc_base":"1f468-1f466-1f466","uc_output":"1f468-200d-1f466-200d-1f466","uc_match":"1f468-1f466-1f466","uc_greedy":"1f468-1f466-1f466","shortnames":[],"category":"people"},":family_man_girl_boy:":{"uc_base":"1f468-1f467-1f466","uc_output":"1f468-200d-1f467-200d-1f466","uc_match":"1f468-1f467-1f466","uc_greedy":"1f468-1f467-1f466","shortnames":[],"category":"people"},":family_man_girl_girl:":{"uc_base":"1f468-1f467-1f467","uc_output":"1f468-200d-1f467-200d-1f467","uc_match":"1f468-1f467-1f467","uc_greedy":"1f468-1f467-1f467","shortnames":[],"category":"people"},":family_man_woman_boy:":{"uc_base":"1f468-1f469-1f466","uc_output":"1f468-200d-1f469-200d-1f466","uc_match":"1f468-1f469-1f466","uc_greedy":"1f468-1f469-1f466","shortnames":[],"category":"people"},":family_mmb:":{"uc_base":"1f468-1f468-1f466","uc_output":"1f468-200d-1f468-200d-1f466","uc_match":"1f468-1f468-1f466","uc_greedy":"1f468-1f468-1f466","shortnames":[],"category":"people"},":family_mmg:":{"uc_base":"1f468-1f468-1f467","uc_output":"1f468-200d-1f468-200d-1f467","uc_match":"1f468-1f468-1f467","uc_greedy":"1f468-1f468-1f467","shortnames":[],"category":"people"},":family_mwg:":{"uc_base":"1f468-1f469-1f467","uc_output":"1f468-200d-1f469-200d-1f467","uc_match":"1f468-1f469-1f467","uc_greedy":"1f468-1f469-1f467","shortnames":[],"category":"people"},":family_woman_boy_boy:":{"uc_base":"1f469-1f466-1f466","uc_output":"1f469-200d-1f466-200d-1f466","uc_match":"1f469-1f466-1f466","uc_greedy":"1f469-1f466-1f466","shortnames":[],"category":"people"},":family_woman_girl_boy:":{"uc_base":"1f469-1f467-1f466","uc_output":"1f469-200d-1f467-200d-1f466","uc_match":"1f469-1f467-1f466","uc_greedy":"1f469-1f467-1f466","shortnames":[],"category":"people"},":family_woman_girl_girl:":{"uc_base":"1f469-1f467-1f467","uc_output":"1f469-200d-1f467-200d-1f467","uc_match":"1f469-1f467-1f467","uc_greedy":"1f469-1f467-1f467","shortnames":[],"category":"people"},":family_wwb:":{"uc_base":"1f469-1f469-1f466","uc_output":"1f469-200d-1f469-200d-1f466","uc_match":"1f469-1f469-1f466","uc_greedy":"1f469-1f469-1f466","shortnames":[],"category":"people"},":family_wwg:":{"uc_base":"1f469-1f469-1f467","uc_output":"1f469-200d-1f469-200d-1f467","uc_match":"1f469-1f469-1f467","uc_greedy":"1f469-1f469-1f467","shortnames":[],"category":"people"},":blond-haired_man_tone1:":{"uc_base":"1f471-1f3fb-2642","uc_output":"1f471-1f3fb-200d-2642-fe0f","uc_match":"1f471-1f3fb-2642-fe0f","uc_greedy":"1f471-1f3fb-2642","shortnames":[":blond-haired_man_light_skin_tone:"],"category":"people"},":blond-haired_man_tone2:":{"uc_base":"1f471-1f3fc-2642","uc_output":"1f471-1f3fc-200d-2642-fe0f","uc_match":"1f471-1f3fc-2642-fe0f","uc_greedy":"1f471-1f3fc-2642","shortnames":[":blond-haired_man_medium_light_skin_tone:"],"category":"people"},":blond-haired_man_tone3:":{"uc_base":"1f471-1f3fd-2642","uc_output":"1f471-1f3fd-200d-2642-fe0f","uc_match":"1f471-1f3fd-2642-fe0f","uc_greedy":"1f471-1f3fd-2642","shortnames":[":blond-haired_man_medium_skin_tone:"],"category":"people"},":blond-haired_man_tone4:":{"uc_base":"1f471-1f3fe-2642","uc_output":"1f471-1f3fe-200d-2642-fe0f","uc_match":"1f471-1f3fe-2642-fe0f","uc_greedy":"1f471-1f3fe-2642","shortnames":[":blond-haired_man_medium_dark_skin_tone:"],"category":"people"},":blond-haired_man_tone5:":{"uc_base":"1f471-1f3ff-2642","uc_output":"1f471-1f3ff-200d-2642-fe0f","uc_match":"1f471-1f3ff-2642-fe0f","uc_greedy":"1f471-1f3ff-2642","shortnames":[":blond-haired_man_dark_skin_tone:"],"category":"people"},":blond-haired_woman_tone1:":{"uc_base":"1f471-1f3fb-2640","uc_output":"1f471-1f3fb-200d-2640-fe0f","uc_match":"1f471-1f3fb-2640-fe0f","uc_greedy":"1f471-1f3fb-2640","shortnames":[":blond-haired_woman_light_skin_tone:"],"category":"people"},":blond-haired_woman_tone2:":{"uc_base":"1f471-1f3fc-2640","uc_output":"1f471-1f3fc-200d-2640-fe0f","uc_match":"1f471-1f3fc-2640-fe0f","uc_greedy":"1f471-1f3fc-2640","shortnames":[":blond-haired_woman_medium_light_skin_tone:"],"category":"people"},":blond-haired_woman_tone3:":{"uc_base":"1f471-1f3fd-2640","uc_output":"1f471-1f3fd-200d-2640-fe0f","uc_match":"1f471-1f3fd-2640-fe0f","uc_greedy":"1f471-1f3fd-2640","shortnames":[":blond-haired_woman_medium_skin_tone:"],"category":"people"},":blond-haired_woman_tone4:":{"uc_base":"1f471-1f3fe-2640","uc_output":"1f471-1f3fe-200d-2640-fe0f","uc_match":"1f471-1f3fe-2640-fe0f","uc_greedy":"1f471-1f3fe-2640","shortnames":[":blond-haired_woman_medium_dark_skin_tone:"],"category":"people"},":blond-haired_woman_tone5:":{"uc_base":"1f471-1f3ff-2640","uc_output":"1f471-1f3ff-200d-2640-fe0f","uc_match":"1f471-1f3ff-2640-fe0f","uc_greedy":"1f471-1f3ff-2640","shortnames":[":blond-haired_woman_dark_skin_tone:"],"category":"people"},":eye_in_speech_bubble:":{"uc_base":"1f441-1f5e8","uc_output":"1f441-fe0f-200d-1f5e8-fe0f","uc_match":"1f441-fe0f-200d-1f5e8","uc_greedy":"1f441-1f5e8","shortnames":[],"category":"symbols"},":man_biking_tone1:":{"uc_base":"1f6b4-1f3fb-2642","uc_output":"1f6b4-1f3fb-200d-2642-fe0f","uc_match":"1f6b4-1f3fb-2642-fe0f","uc_greedy":"1f6b4-1f3fb-2642","shortnames":[":man_biking_light_skin_tone:"],"category":"activity"},":man_biking_tone2:":{"uc_base":"1f6b4-1f3fc-2642","uc_output":"1f6b4-1f3fc-200d-2642-fe0f","uc_match":"1f6b4-1f3fc-2642-fe0f","uc_greedy":"1f6b4-1f3fc-2642","shortnames":[":man_biking_medium_light_skin_tone:"],"category":"activity"},":man_biking_tone3:":{"uc_base":"1f6b4-1f3fd-2642","uc_output":"1f6b4-1f3fd-200d-2642-fe0f","uc_match":"1f6b4-1f3fd-2642-fe0f","uc_greedy":"1f6b4-1f3fd-2642","shortnames":[":man_biking_medium_skin_tone:"],"category":"activity"},":man_biking_tone4:":{"uc_base":"1f6b4-1f3fe-2642","uc_output":"1f6b4-1f3fe-200d-2642-fe0f","uc_match":"1f6b4-1f3fe-2642-fe0f","uc_greedy":"1f6b4-1f3fe-2642","shortnames":[":man_biking_medium_dark_skin_tone:"],"category":"activity"},":man_biking_tone5:":{"uc_base":"1f6b4-1f3ff-2642","uc_output":"1f6b4-1f3ff-200d-2642-fe0f","uc_match":"1f6b4-1f3ff-2642-fe0f","uc_greedy":"1f6b4-1f3ff-2642","shortnames":[":man_biking_dark_skin_tone:"],"category":"activity"},":man_bowing_tone1:":{"uc_base":"1f647-1f3fb-2642","uc_output":"1f647-1f3fb-200d-2642-fe0f","uc_match":"1f647-1f3fb-2642-fe0f","uc_greedy":"1f647-1f3fb-2642","shortnames":[":man_bowing_light_skin_tone:"],"category":"people"},":man_bowing_tone2:":{"uc_base":"1f647-1f3fc-2642","uc_output":"1f647-1f3fc-200d-2642-fe0f","uc_match":"1f647-1f3fc-2642-fe0f","uc_greedy":"1f647-1f3fc-2642","shortnames":[":man_bowing_medium_light_skin_tone:"],"category":"people"},":man_bowing_tone3:":{"uc_base":"1f647-1f3fd-2642","uc_output":"1f647-1f3fd-200d-2642-fe0f","uc_match":"1f647-1f3fd-2642-fe0f","uc_greedy":"1f647-1f3fd-2642","shortnames":[":man_bowing_medium_skin_tone:"],"category":"people"},":man_bowing_tone4:":{"uc_base":"1f647-1f3fe-2642","uc_output":"1f647-1f3fe-200d-2642-fe0f","uc_match":"1f647-1f3fe-2642-fe0f","uc_greedy":"1f647-1f3fe-2642","shortnames":[":man_bowing_medium_dark_skin_tone:"],"category":"people"},":man_bowing_tone5:":{"uc_base":"1f647-1f3ff-2642","uc_output":"1f647-1f3ff-200d-2642-fe0f","uc_match":"1f647-1f3ff-2642-fe0f","uc_greedy":"1f647-1f3ff-2642","shortnames":[":man_bowing_dark_skin_tone:"],"category":"people"},":man_cartwheeling_tone1:":{"uc_base":"1f938-1f3fb-2642","uc_output":"1f938-1f3fb-200d-2642-fe0f","uc_match":"1f938-1f3fb-2642-fe0f","uc_greedy":"1f938-1f3fb-2642","shortnames":[":man_cartwheeling_light_skin_tone:"],"category":"activity"},":man_cartwheeling_tone2:":{"uc_base":"1f938-1f3fc-2642","uc_output":"1f938-1f3fc-200d-2642-fe0f","uc_match":"1f938-1f3fc-2642-fe0f","uc_greedy":"1f938-1f3fc-2642","shortnames":[":man_cartwheeling_medium_light_skin_tone:"],"category":"activity"},":man_cartwheeling_tone3:":{"uc_base":"1f938-1f3fd-2642","uc_output":"1f938-1f3fd-200d-2642-fe0f","uc_match":"1f938-1f3fd-2642-fe0f","uc_greedy":"1f938-1f3fd-2642","shortnames":[":man_cartwheeling_medium_skin_tone:"],"category":"activity"},":man_cartwheeling_tone4:":{"uc_base":"1f938-1f3fe-2642","uc_output":"1f938-1f3fe-200d-2642-fe0f","uc_match":"1f938-1f3fe-2642-fe0f","uc_greedy":"1f938-1f3fe-2642","shortnames":[":man_cartwheeling_medium_dark_skin_tone:"],"category":"activity"},":man_cartwheeling_tone5:":{"uc_base":"1f938-1f3ff-2642","uc_output":"1f938-1f3ff-200d-2642-fe0f","uc_match":"1f938-1f3ff-2642-fe0f","uc_greedy":"1f938-1f3ff-2642","shortnames":[":man_cartwheeling_dark_skin_tone:"],"category":"activity"},":man_climbing_tone1:":{"uc_base":"1f9d7-1f3fb-2642","uc_output":"1f9d7-1f3fb-200d-2642-fe0f","uc_match":"1f9d7-1f3fb-2642-fe0f","uc_greedy":"1f9d7-1f3fb-2642","shortnames":[":man_climbing_light_skin_tone:"],"category":"activity"},":man_climbing_tone2:":{"uc_base":"1f9d7-1f3fc-2642","uc_output":"1f9d7-1f3fc-200d-2642-fe0f","uc_match":"1f9d7-1f3fc-2642-fe0f","uc_greedy":"1f9d7-1f3fc-2642","shortnames":[":man_climbing_medium_light_skin_tone:"],"category":"activity"},":man_climbing_tone3:":{"uc_base":"1f9d7-1f3fd-2642","uc_output":"1f9d7-1f3fd-200d-2642-fe0f","uc_match":"1f9d7-1f3fd-2642-fe0f","uc_greedy":"1f9d7-1f3fd-2642","shortnames":[":man_climbing_medium_skin_tone:"],"category":"activity"},":man_climbing_tone4:":{"uc_base":"1f9d7-1f3fe-2642","uc_output":"1f9d7-1f3fe-200d-2642-fe0f","uc_match":"1f9d7-1f3fe-2642-fe0f","uc_greedy":"1f9d7-1f3fe-2642","shortnames":[":man_climbing_medium_dark_skin_tone:"],"category":"activity"},":man_climbing_tone5:":{"uc_base":"1f9d7-1f3ff-2642","uc_output":"1f9d7-1f3ff-200d-2642-fe0f","uc_match":"1f9d7-1f3ff-2642-fe0f","uc_greedy":"1f9d7-1f3ff-2642","shortnames":[":man_climbing_dark_skin_tone:"],"category":"activity"},":man_construction_worker_tone1:":{"uc_base":"1f477-1f3fb-2642","uc_output":"1f477-1f3fb-200d-2642-fe0f","uc_match":"1f477-1f3fb-2642-fe0f","uc_greedy":"1f477-1f3fb-2642","shortnames":[":man_construction_worker_light_skin_tone:"],"category":"people"},":man_construction_worker_tone2:":{"uc_base":"1f477-1f3fc-2642","uc_output":"1f477-1f3fc-200d-2642-fe0f","uc_match":"1f477-1f3fc-2642-fe0f","uc_greedy":"1f477-1f3fc-2642","shortnames":[":man_construction_worker_medium_light_skin_tone:"],"category":"people"},":man_construction_worker_tone3:":{"uc_base":"1f477-1f3fd-2642","uc_output":"1f477-1f3fd-200d-2642-fe0f","uc_match":"1f477-1f3fd-2642-fe0f","uc_greedy":"1f477-1f3fd-2642","shortnames":[":man_construction_worker_medium_skin_tone:"],"category":"people"},":man_construction_worker_tone4:":{"uc_base":"1f477-1f3fe-2642","uc_output":"1f477-1f3fe-200d-2642-fe0f","uc_match":"1f477-1f3fe-2642-fe0f","uc_greedy":"1f477-1f3fe-2642","shortnames":[":man_construction_worker_medium_dark_skin_tone:"],"category":"people"},":man_construction_worker_tone5:":{"uc_base":"1f477-1f3ff-2642","uc_output":"1f477-1f3ff-200d-2642-fe0f","uc_match":"1f477-1f3ff-2642-fe0f","uc_greedy":"1f477-1f3ff-2642","shortnames":[":man_construction_worker_dark_skin_tone:"],"category":"people"},":man_detective_tone1:":{"uc_base":"1f575-1f3fb-2642","uc_output":"1f575-1f3fb-200d-2642-fe0f","uc_match":"1f575-fe0f-1f3fb-2642-fe0f","uc_greedy":"1f575-1f3fb-2642","shortnames":[":man_detective_light_skin_tone:"],"category":"people"},":man_detective_tone2:":{"uc_base":"1f575-1f3fc-2642","uc_output":"1f575-1f3fc-200d-2642-fe0f","uc_match":"1f575-fe0f-1f3fc-2642-fe0f","uc_greedy":"1f575-1f3fc-2642","shortnames":[":man_detective_medium_light_skin_tone:"],"category":"people"},":man_detective_tone3:":{"uc_base":"1f575-1f3fd-2642","uc_output":"1f575-1f3fd-200d-2642-fe0f","uc_match":"1f575-fe0f-1f3fd-2642-fe0f","uc_greedy":"1f575-1f3fd-2642","shortnames":[":man_detective_medium_skin_tone:"],"category":"people"},":man_detective_tone4:":{"uc_base":"1f575-1f3fe-2642","uc_output":"1f575-1f3fe-200d-2642-fe0f","uc_match":"1f575-fe0f-1f3fe-2642-fe0f","uc_greedy":"1f575-1f3fe-2642","shortnames":[":man_detective_medium_dark_skin_tone:"],"category":"people"},":man_detective_tone5:":{"uc_base":"1f575-1f3ff-2642","uc_output":"1f575-1f3ff-200d-2642-fe0f","uc_match":"1f575-fe0f-1f3ff-2642-fe0f","uc_greedy":"1f575-1f3ff-2642","shortnames":[":man_detective_dark_skin_tone:"],"category":"people"},":man_elf_tone1:":{"uc_base":"1f9dd-1f3fb-2642","uc_output":"1f9dd-1f3fb-200d-2642-fe0f","uc_match":"1f9dd-1f3fb-2642-fe0f","uc_greedy":"1f9dd-1f3fb-2642","shortnames":[":man_elf_light_skin_tone:"],"category":"people"},":man_elf_tone2:":{"uc_base":"1f9dd-1f3fc-2642","uc_output":"1f9dd-1f3fc-200d-2642-fe0f","uc_match":"1f9dd-1f3fc-2642-fe0f","uc_greedy":"1f9dd-1f3fc-2642","shortnames":[":man_elf_medium_light_skin_tone:"],"category":"people"},":man_elf_tone3:":{"uc_base":"1f9dd-1f3fd-2642","uc_output":"1f9dd-1f3fd-200d-2642-fe0f","uc_match":"1f9dd-1f3fd-2642-fe0f","uc_greedy":"1f9dd-1f3fd-2642","shortnames":[":man_elf_medium_skin_tone:"],"category":"people"},":man_elf_tone4:":{"uc_base":"1f9dd-1f3fe-2642","uc_output":"1f9dd-1f3fe-200d-2642-fe0f","uc_match":"1f9dd-1f3fe-2642-fe0f","uc_greedy":"1f9dd-1f3fe-2642","shortnames":[":man_elf_medium_dark_skin_tone:"],"category":"people"},":man_elf_tone5:":{"uc_base":"1f9dd-1f3ff-2642","uc_output":"1f9dd-1f3ff-200d-2642-fe0f","uc_match":"1f9dd-1f3ff-2642-fe0f","uc_greedy":"1f9dd-1f3ff-2642","shortnames":[":man_elf_dark_skin_tone:"],"category":"people"},":man_facepalming_tone1:":{"uc_base":"1f926-1f3fb-2642","uc_output":"1f926-1f3fb-200d-2642-fe0f","uc_match":"1f926-1f3fb-2642-fe0f","uc_greedy":"1f926-1f3fb-2642","shortnames":[":man_facepalming_light_skin_tone:"],"category":"people"},":man_facepalming_tone2:":{"uc_base":"1f926-1f3fc-2642","uc_output":"1f926-1f3fc-200d-2642-fe0f","uc_match":"1f926-1f3fc-2642-fe0f","uc_greedy":"1f926-1f3fc-2642","shortnames":[":man_facepalming_medium_light_skin_tone:"],"category":"people"},":man_facepalming_tone3:":{"uc_base":"1f926-1f3fd-2642","uc_output":"1f926-1f3fd-200d-2642-fe0f","uc_match":"1f926-1f3fd-2642-fe0f","uc_greedy":"1f926-1f3fd-2642","shortnames":[":man_facepalming_medium_skin_tone:"],"category":"people"},":man_facepalming_tone4:":{"uc_base":"1f926-1f3fe-2642","uc_output":"1f926-1f3fe-200d-2642-fe0f","uc_match":"1f926-1f3fe-2642-fe0f","uc_greedy":"1f926-1f3fe-2642","shortnames":[":man_facepalming_medium_dark_skin_tone:"],"category":"people"},":man_facepalming_tone5:":{"uc_base":"1f926-1f3ff-2642","uc_output":"1f926-1f3ff-200d-2642-fe0f","uc_match":"1f926-1f3ff-2642-fe0f","uc_greedy":"1f926-1f3ff-2642","shortnames":[":man_facepalming_dark_skin_tone:"],"category":"people"},":man_fairy_tone1:":{"uc_base":"1f9da-1f3fb-2642","uc_output":"1f9da-1f3fb-200d-2642-fe0f","uc_match":"1f9da-1f3fb-2642-fe0f","uc_greedy":"1f9da-1f3fb-2642","shortnames":[":man_fairy_light_skin_tone:"],"category":"people"},":man_fairy_tone2:":{"uc_base":"1f9da-1f3fc-2642","uc_output":"1f9da-1f3fc-200d-2642-fe0f","uc_match":"1f9da-1f3fc-2642-fe0f","uc_greedy":"1f9da-1f3fc-2642","shortnames":[":man_fairy_medium_light_skin_tone:"],"category":"people"},":man_fairy_tone3:":{"uc_base":"1f9da-1f3fd-2642","uc_output":"1f9da-1f3fd-200d-2642-fe0f","uc_match":"1f9da-1f3fd-2642-fe0f","uc_greedy":"1f9da-1f3fd-2642","shortnames":[":man_fairy_medium_skin_tone:"],"category":"people"},":man_fairy_tone4:":{"uc_base":"1f9da-1f3fe-2642","uc_output":"1f9da-1f3fe-200d-2642-fe0f","uc_match":"1f9da-1f3fe-2642-fe0f","uc_greedy":"1f9da-1f3fe-2642","shortnames":[":man_fairy_medium_dark_skin_tone:"],"category":"people"},":man_fairy_tone5:":{"uc_base":"1f9da-1f3ff-2642","uc_output":"1f9da-1f3ff-200d-2642-fe0f","uc_match":"1f9da-1f3ff-2642-fe0f","uc_greedy":"1f9da-1f3ff-2642","shortnames":[":man_fairy_dark_skin_tone:"],"category":"people"},":man_frowning_tone1:":{"uc_base":"1f64d-1f3fb-2642","uc_output":"1f64d-1f3fb-200d-2642-fe0f","uc_match":"1f64d-1f3fb-2642-fe0f","uc_greedy":"1f64d-1f3fb-2642","shortnames":[":man_frowning_light_skin_tone:"],"category":"people"},":man_frowning_tone2:":{"uc_base":"1f64d-1f3fc-2642","uc_output":"1f64d-1f3fc-200d-2642-fe0f","uc_match":"1f64d-1f3fc-2642-fe0f","uc_greedy":"1f64d-1f3fc-2642","shortnames":[":man_frowning_medium_light_skin_tone:"],"category":"people"},":man_frowning_tone3:":{"uc_base":"1f64d-1f3fd-2642","uc_output":"1f64d-1f3fd-200d-2642-fe0f","uc_match":"1f64d-1f3fd-2642-fe0f","uc_greedy":"1f64d-1f3fd-2642","shortnames":[":man_frowning_medium_skin_tone:"],"category":"people"},":man_frowning_tone4:":{"uc_base":"1f64d-1f3fe-2642","uc_output":"1f64d-1f3fe-200d-2642-fe0f","uc_match":"1f64d-1f3fe-2642-fe0f","uc_greedy":"1f64d-1f3fe-2642","shortnames":[":man_frowning_medium_dark_skin_tone:"],"category":"people"},":man_frowning_tone5:":{"uc_base":"1f64d-1f3ff-2642","uc_output":"1f64d-1f3ff-200d-2642-fe0f","uc_match":"1f64d-1f3ff-2642-fe0f","uc_greedy":"1f64d-1f3ff-2642","shortnames":[":man_frowning_dark_skin_tone:"],"category":"people"},":man_gesturing_no_tone1:":{"uc_base":"1f645-1f3fb-2642","uc_output":"1f645-1f3fb-200d-2642-fe0f","uc_match":"1f645-1f3fb-2642-fe0f","uc_greedy":"1f645-1f3fb-2642","shortnames":[":man_gesturing_no_light_skin_tone:"],"category":"people"},":man_gesturing_no_tone2:":{"uc_base":"1f645-1f3fc-2642","uc_output":"1f645-1f3fc-200d-2642-fe0f","uc_match":"1f645-1f3fc-2642-fe0f","uc_greedy":"1f645-1f3fc-2642","shortnames":[":man_gesturing_no_medium_light_skin_tone:"],"category":"people"},":man_gesturing_no_tone3:":{"uc_base":"1f645-1f3fd-2642","uc_output":"1f645-1f3fd-200d-2642-fe0f","uc_match":"1f645-1f3fd-2642-fe0f","uc_greedy":"1f645-1f3fd-2642","shortnames":[":man_gesturing_no_medium_skin_tone:"],"category":"people"},":man_gesturing_no_tone4:":{"uc_base":"1f645-1f3fe-2642","uc_output":"1f645-1f3fe-200d-2642-fe0f","uc_match":"1f645-1f3fe-2642-fe0f","uc_greedy":"1f645-1f3fe-2642","shortnames":[":man_gesturing_no_medium_dark_skin_tone:"],"category":"people"},":man_gesturing_no_tone5:":{"uc_base":"1f645-1f3ff-2642","uc_output":"1f645-1f3ff-200d-2642-fe0f","uc_match":"1f645-1f3ff-2642-fe0f","uc_greedy":"1f645-1f3ff-2642","shortnames":[":man_gesturing_no_dark_skin_tone:"],"category":"people"},":man_gesturing_ok_tone1:":{"uc_base":"1f646-1f3fb-2642","uc_output":"1f646-1f3fb-200d-2642-fe0f","uc_match":"1f646-1f3fb-2642-fe0f","uc_greedy":"1f646-1f3fb-2642","shortnames":[":man_gesturing_ok_light_skin_tone:"],"category":"people"},":man_gesturing_ok_tone2:":{"uc_base":"1f646-1f3fc-2642","uc_output":"1f646-1f3fc-200d-2642-fe0f","uc_match":"1f646-1f3fc-2642-fe0f","uc_greedy":"1f646-1f3fc-2642","shortnames":[":man_gesturing_ok_medium_light_skin_tone:"],"category":"people"},":man_gesturing_ok_tone3:":{"uc_base":"1f646-1f3fd-2642","uc_output":"1f646-1f3fd-200d-2642-fe0f","uc_match":"1f646-1f3fd-2642-fe0f","uc_greedy":"1f646-1f3fd-2642","shortnames":[":man_gesturing_ok_medium_skin_tone:"],"category":"people"},":man_gesturing_ok_tone4:":{"uc_base":"1f646-1f3fe-2642","uc_output":"1f646-1f3fe-200d-2642-fe0f","uc_match":"1f646-1f3fe-2642-fe0f","uc_greedy":"1f646-1f3fe-2642","shortnames":[":man_gesturing_ok_medium_dark_skin_tone:"],"category":"people"},":man_gesturing_ok_tone5:":{"uc_base":"1f646-1f3ff-2642","uc_output":"1f646-1f3ff-200d-2642-fe0f","uc_match":"1f646-1f3ff-2642-fe0f","uc_greedy":"1f646-1f3ff-2642","shortnames":[":man_gesturing_ok_dark_skin_tone:"],"category":"people"},":man_getting_face_massage_tone1:":{"uc_base":"1f486-1f3fb-2642","uc_output":"1f486-1f3fb-200d-2642-fe0f","uc_match":"1f486-1f3fb-2642-fe0f","uc_greedy":"1f486-1f3fb-2642","shortnames":[":man_getting_face_massage_light_skin_tone:"],"category":"people"},":man_getting_face_massage_tone2:":{"uc_base":"1f486-1f3fc-2642","uc_output":"1f486-1f3fc-200d-2642-fe0f","uc_match":"1f486-1f3fc-2642-fe0f","uc_greedy":"1f486-1f3fc-2642","shortnames":[":man_getting_face_massage_medium_light_skin_tone:"],"category":"people"},":man_getting_face_massage_tone3:":{"uc_base":"1f486-1f3fd-2642","uc_output":"1f486-1f3fd-200d-2642-fe0f","uc_match":"1f486-1f3fd-2642-fe0f","uc_greedy":"1f486-1f3fd-2642","shortnames":[":man_getting_face_massage_medium_skin_tone:"],"category":"people"},":man_getting_face_massage_tone4:":{"uc_base":"1f486-1f3fe-2642","uc_output":"1f486-1f3fe-200d-2642-fe0f","uc_match":"1f486-1f3fe-2642-fe0f","uc_greedy":"1f486-1f3fe-2642","shortnames":[":man_getting_face_massage_medium_dark_skin_tone:"],"category":"people"},":man_getting_face_massage_tone5:":{"uc_base":"1f486-1f3ff-2642","uc_output":"1f486-1f3ff-200d-2642-fe0f","uc_match":"1f486-1f3ff-2642-fe0f","uc_greedy":"1f486-1f3ff-2642","shortnames":[":man_getting_face_massage_dark_skin_tone:"],"category":"people"},":man_getting_haircut_tone1:":{"uc_base":"1f487-1f3fb-2642","uc_output":"1f487-1f3fb-200d-2642-fe0f","uc_match":"1f487-1f3fb-2642-fe0f","uc_greedy":"1f487-1f3fb-2642","shortnames":[":man_getting_haircut_light_skin_tone:"],"category":"people"},":man_getting_haircut_tone2:":{"uc_base":"1f487-1f3fc-2642","uc_output":"1f487-1f3fc-200d-2642-fe0f","uc_match":"1f487-1f3fc-2642-fe0f","uc_greedy":"1f487-1f3fc-2642","shortnames":[":man_getting_haircut_medium_light_skin_tone:"],"category":"people"},":man_getting_haircut_tone3:":{"uc_base":"1f487-1f3fd-2642","uc_output":"1f487-1f3fd-200d-2642-fe0f","uc_match":"1f487-1f3fd-2642-fe0f","uc_greedy":"1f487-1f3fd-2642","shortnames":[":man_getting_haircut_medium_skin_tone:"],"category":"people"},":man_getting_haircut_tone4:":{"uc_base":"1f487-1f3fe-2642","uc_output":"1f487-1f3fe-200d-2642-fe0f","uc_match":"1f487-1f3fe-2642-fe0f","uc_greedy":"1f487-1f3fe-2642","shortnames":[":man_getting_haircut_medium_dark_skin_tone:"],"category":"people"},":man_getting_haircut_tone5:":{"uc_base":"1f487-1f3ff-2642","uc_output":"1f487-1f3ff-200d-2642-fe0f","uc_match":"1f487-1f3ff-2642-fe0f","uc_greedy":"1f487-1f3ff-2642","shortnames":[":man_getting_haircut_dark_skin_tone:"],"category":"people"},":man_golfing_tone1:":{"uc_base":"1f3cc-1f3fb-2642","uc_output":"1f3cc-1f3fb-200d-2642-fe0f","uc_match":"1f3cc-fe0f-1f3fb-2642-fe0f","uc_greedy":"1f3cc-1f3fb-2642","shortnames":[":man_golfing_light_skin_tone:"],"category":"activity"},":man_golfing_tone2:":{"uc_base":"1f3cc-1f3fc-2642","uc_output":"1f3cc-1f3fc-200d-2642-fe0f","uc_match":"1f3cc-fe0f-1f3fc-2642-fe0f","uc_greedy":"1f3cc-1f3fc-2642","shortnames":[":man_golfing_medium_light_skin_tone:"],"category":"activity"},":man_golfing_tone3:":{"uc_base":"1f3cc-1f3fd-2642","uc_output":"1f3cc-1f3fd-200d-2642-fe0f","uc_match":"1f3cc-fe0f-1f3fd-2642-fe0f","uc_greedy":"1f3cc-1f3fd-2642","shortnames":[":man_golfing_medium_skin_tone:"],"category":"activity"},":man_golfing_tone4:":{"uc_base":"1f3cc-1f3fe-2642","uc_output":"1f3cc-1f3fe-200d-2642-fe0f","uc_match":"1f3cc-fe0f-1f3fe-2642-fe0f","uc_greedy":"1f3cc-1f3fe-2642","shortnames":[":man_golfing_medium_dark_skin_tone:"],"category":"activity"},":man_golfing_tone5:":{"uc_base":"1f3cc-1f3ff-2642","uc_output":"1f3cc-1f3ff-200d-2642-fe0f","uc_match":"1f3cc-fe0f-1f3ff-2642-fe0f","uc_greedy":"1f3cc-1f3ff-2642","shortnames":[":man_golfing_dark_skin_tone:"],"category":"activity"},":man_guard_tone1:":{"uc_base":"1f482-1f3fb-2642","uc_output":"1f482-1f3fb-200d-2642-fe0f","uc_match":"1f482-1f3fb-2642-fe0f","uc_greedy":"1f482-1f3fb-2642","shortnames":[":man_guard_light_skin_tone:"],"category":"people"},":man_guard_tone2:":{"uc_base":"1f482-1f3fc-2642","uc_output":"1f482-1f3fc-200d-2642-fe0f","uc_match":"1f482-1f3fc-2642-fe0f","uc_greedy":"1f482-1f3fc-2642","shortnames":[":man_guard_medium_light_skin_tone:"],"category":"people"},":man_guard_tone3:":{"uc_base":"1f482-1f3fd-2642","uc_output":"1f482-1f3fd-200d-2642-fe0f","uc_match":"1f482-1f3fd-2642-fe0f","uc_greedy":"1f482-1f3fd-2642","shortnames":[":man_guard_medium_skin_tone:"],"category":"people"},":man_guard_tone4:":{"uc_base":"1f482-1f3fe-2642","uc_output":"1f482-1f3fe-200d-2642-fe0f","uc_match":"1f482-1f3fe-2642-fe0f","uc_greedy":"1f482-1f3fe-2642","shortnames":[":man_guard_medium_dark_skin_tone:"],"category":"people"},":man_guard_tone5:":{"uc_base":"1f482-1f3ff-2642","uc_output":"1f482-1f3ff-200d-2642-fe0f","uc_match":"1f482-1f3ff-2642-fe0f","uc_greedy":"1f482-1f3ff-2642","shortnames":[":man_guard_dark_skin_tone:"],"category":"people"},":man_health_worker_tone1:":{"uc_base":"1f468-1f3fb-2695","uc_output":"1f468-1f3fb-200d-2695-fe0f","uc_match":"1f468-1f3fb-2695-fe0f","uc_greedy":"1f468-1f3fb-2695","shortnames":[":man_health_worker_light_skin_tone:"],"category":"people"},":man_health_worker_tone2:":{"uc_base":"1f468-1f3fc-2695","uc_output":"1f468-1f3fc-200d-2695-fe0f","uc_match":"1f468-1f3fc-2695-fe0f","uc_greedy":"1f468-1f3fc-2695","shortnames":[":man_health_worker_medium_light_skin_tone:"],"category":"people"},":man_health_worker_tone3:":{"uc_base":"1f468-1f3fd-2695","uc_output":"1f468-1f3fd-200d-2695-fe0f","uc_match":"1f468-1f3fd-2695-fe0f","uc_greedy":"1f468-1f3fd-2695","shortnames":[":man_health_worker_medium_skin_tone:"],"category":"people"},":man_health_worker_tone4:":{"uc_base":"1f468-1f3fe-2695","uc_output":"1f468-1f3fe-200d-2695-fe0f","uc_match":"1f468-1f3fe-2695-fe0f","uc_greedy":"1f468-1f3fe-2695","shortnames":[":man_health_worker_medium_dark_skin_tone:"],"category":"people"},":man_health_worker_tone5:":{"uc_base":"1f468-1f3ff-2695","uc_output":"1f468-1f3ff-200d-2695-fe0f","uc_match":"1f468-1f3ff-2695-fe0f","uc_greedy":"1f468-1f3ff-2695","shortnames":[":man_health_worker_dark_skin_tone:"],"category":"people"},":man_in_lotus_position_tone1:":{"uc_base":"1f9d8-1f3fb-2642","uc_output":"1f9d8-1f3fb-200d-2642-fe0f","uc_match":"1f9d8-1f3fb-2642-fe0f","uc_greedy":"1f9d8-1f3fb-2642","shortnames":[":man_in_lotus_position_light_skin_tone:"],"category":"activity"},":man_in_lotus_position_tone2:":{"uc_base":"1f9d8-1f3fc-2642","uc_output":"1f9d8-1f3fc-200d-2642-fe0f","uc_match":"1f9d8-1f3fc-2642-fe0f","uc_greedy":"1f9d8-1f3fc-2642","shortnames":[":man_in_lotus_position_medium_light_skin_tone:"],"category":"activity"},":man_in_lotus_position_tone3:":{"uc_base":"1f9d8-1f3fd-2642","uc_output":"1f9d8-1f3fd-200d-2642-fe0f","uc_match":"1f9d8-1f3fd-2642-fe0f","uc_greedy":"1f9d8-1f3fd-2642","shortnames":[":man_in_lotus_position_medium_skin_tone:"],"category":"activity"},":man_in_lotus_position_tone4:":{"uc_base":"1f9d8-1f3fe-2642","uc_output":"1f9d8-1f3fe-200d-2642-fe0f","uc_match":"1f9d8-1f3fe-2642-fe0f","uc_greedy":"1f9d8-1f3fe-2642","shortnames":[":man_in_lotus_position_medium_dark_skin_tone:"],"category":"activity"},":man_in_lotus_position_tone5:":{"uc_base":"1f9d8-1f3ff-2642","uc_output":"1f9d8-1f3ff-200d-2642-fe0f","uc_match":"1f9d8-1f3ff-2642-fe0f","uc_greedy":"1f9d8-1f3ff-2642","shortnames":[":man_in_lotus_position_dark_skin_tone:"],"category":"activity"},":man_in_steamy_room_tone1:":{"uc_base":"1f9d6-1f3fb-2642","uc_output":"1f9d6-1f3fb-200d-2642-fe0f","uc_match":"1f9d6-1f3fb-2642-fe0f","uc_greedy":"1f9d6-1f3fb-2642","shortnames":[":man_in_steamy_room_light_skin_tone:"],"category":"people"},":man_in_steamy_room_tone2:":{"uc_base":"1f9d6-1f3fc-2642","uc_output":"1f9d6-1f3fc-200d-2642-fe0f","uc_match":"1f9d6-1f3fc-2642-fe0f","uc_greedy":"1f9d6-1f3fc-2642","shortnames":[":man_in_steamy_room_medium_light_skin_tone:"],"category":"people"},":man_in_steamy_room_tone3:":{"uc_base":"1f9d6-1f3fd-2642","uc_output":"1f9d6-1f3fd-200d-2642-fe0f","uc_match":"1f9d6-1f3fd-2642-fe0f","uc_greedy":"1f9d6-1f3fd-2642","shortnames":[":man_in_steamy_room_medium_skin_tone:"],"category":"people"},":man_in_steamy_room_tone4:":{"uc_base":"1f9d6-1f3fe-2642","uc_output":"1f9d6-1f3fe-200d-2642-fe0f","uc_match":"1f9d6-1f3fe-2642-fe0f","uc_greedy":"1f9d6-1f3fe-2642","shortnames":[":man_in_steamy_room_medium_dark_skin_tone:"],"category":"people"},":man_in_steamy_room_tone5:":{"uc_base":"1f9d6-1f3ff-2642","uc_output":"1f9d6-1f3ff-200d-2642-fe0f","uc_match":"1f9d6-1f3ff-2642-fe0f","uc_greedy":"1f9d6-1f3ff-2642","shortnames":[":man_in_steamy_room_dark_skin_tone:"],"category":"people"},":man_judge_tone1:":{"uc_base":"1f468-1f3fb-2696","uc_output":"1f468-1f3fb-200d-2696-fe0f","uc_match":"1f468-1f3fb-2696-fe0f","uc_greedy":"1f468-1f3fb-2696","shortnames":[":man_judge_light_skin_tone:"],"category":"people"},":man_judge_tone2:":{"uc_base":"1f468-1f3fc-2696","uc_output":"1f468-1f3fc-200d-2696-fe0f","uc_match":"1f468-1f3fc-2696-fe0f","uc_greedy":"1f468-1f3fc-2696","shortnames":[":man_judge_medium_light_skin_tone:"],"category":"people"},":man_judge_tone3:":{"uc_base":"1f468-1f3fd-2696","uc_output":"1f468-1f3fd-200d-2696-fe0f","uc_match":"1f468-1f3fd-2696-fe0f","uc_greedy":"1f468-1f3fd-2696","shortnames":[":man_judge_medium_skin_tone:"],"category":"people"},":man_judge_tone4:":{"uc_base":"1f468-1f3fe-2696","uc_output":"1f468-1f3fe-200d-2696-fe0f","uc_match":"1f468-1f3fe-2696-fe0f","uc_greedy":"1f468-1f3fe-2696","shortnames":[":man_judge_medium_dark_skin_tone:"],"category":"people"},":man_judge_tone5:":{"uc_base":"1f468-1f3ff-2696","uc_output":"1f468-1f3ff-200d-2696-fe0f","uc_match":"1f468-1f3ff-2696-fe0f","uc_greedy":"1f468-1f3ff-2696","shortnames":[":man_judge_dark_skin_tone:"],"category":"people"},":man_juggling_tone1:":{"uc_base":"1f939-1f3fb-2642","uc_output":"1f939-1f3fb-200d-2642-fe0f","uc_match":"1f939-1f3fb-2642-fe0f","uc_greedy":"1f939-1f3fb-2642","shortnames":[":man_juggling_light_skin_tone:"],"category":"activity"},":man_juggling_tone2:":{"uc_base":"1f939-1f3fc-2642","uc_output":"1f939-1f3fc-200d-2642-fe0f","uc_match":"1f939-1f3fc-2642-fe0f","uc_greedy":"1f939-1f3fc-2642","shortnames":[":man_juggling_medium_light_skin_tone:"],"category":"activity"},":man_juggling_tone3:":{"uc_base":"1f939-1f3fd-2642","uc_output":"1f939-1f3fd-200d-2642-fe0f","uc_match":"1f939-1f3fd-2642-fe0f","uc_greedy":"1f939-1f3fd-2642","shortnames":[":man_juggling_medium_skin_tone:"],"category":"activity"},":man_juggling_tone4:":{"uc_base":"1f939-1f3fe-2642","uc_output":"1f939-1f3fe-200d-2642-fe0f","uc_match":"1f939-1f3fe-2642-fe0f","uc_greedy":"1f939-1f3fe-2642","shortnames":[":man_juggling_medium_dark_skin_tone:"],"category":"activity"},":man_juggling_tone5:":{"uc_base":"1f939-1f3ff-2642","uc_output":"1f939-1f3ff-200d-2642-fe0f","uc_match":"1f939-1f3ff-2642-fe0f","uc_greedy":"1f939-1f3ff-2642","shortnames":[":man_juggling_dark_skin_tone:"],"category":"activity"},":man_lifting_weights_tone1:":{"uc_base":"1f3cb-1f3fb-2642","uc_output":"1f3cb-1f3fb-200d-2642-fe0f","uc_match":"1f3cb-fe0f-1f3fb-2642-fe0f","uc_greedy":"1f3cb-1f3fb-2642","shortnames":[":man_lifting_weights_light_skin_tone:"],"category":"activity"},":man_lifting_weights_tone2:":{"uc_base":"1f3cb-1f3fc-2642","uc_output":"1f3cb-1f3fc-200d-2642-fe0f","uc_match":"1f3cb-fe0f-1f3fc-2642-fe0f","uc_greedy":"1f3cb-1f3fc-2642","shortnames":[":man_lifting_weights_medium_light_skin_tone:"],"category":"activity"},":man_lifting_weights_tone3:":{"uc_base":"1f3cb-1f3fd-2642","uc_output":"1f3cb-1f3fd-200d-2642-fe0f","uc_match":"1f3cb-fe0f-1f3fd-2642-fe0f","uc_greedy":"1f3cb-1f3fd-2642","shortnames":[":man_lifting_weights_medium_skin_tone:"],"category":"activity"},":man_lifting_weights_tone4:":{"uc_base":"1f3cb-1f3fe-2642","uc_output":"1f3cb-1f3fe-200d-2642-fe0f","uc_match":"1f3cb-fe0f-1f3fe-2642-fe0f","uc_greedy":"1f3cb-1f3fe-2642","shortnames":[":man_lifting_weights_medium_dark_skin_tone:"],"category":"activity"},":man_lifting_weights_tone5:":{"uc_base":"1f3cb-1f3ff-2642","uc_output":"1f3cb-1f3ff-200d-2642-fe0f","uc_match":"1f3cb-fe0f-1f3ff-2642-fe0f","uc_greedy":"1f3cb-1f3ff-2642","shortnames":[":man_lifting_weights_dark_skin_tone:"],"category":"activity"},":man_mage_tone1:":{"uc_base":"1f9d9-1f3fb-2642","uc_output":"1f9d9-1f3fb-200d-2642-fe0f","uc_match":"1f9d9-1f3fb-2642-fe0f","uc_greedy":"1f9d9-1f3fb-2642","shortnames":[":man_mage_light_skin_tone:"],"category":"people"},":man_mage_tone2:":{"uc_base":"1f9d9-1f3fc-2642","uc_output":"1f9d9-1f3fc-200d-2642-fe0f","uc_match":"1f9d9-1f3fc-2642-fe0f","uc_greedy":"1f9d9-1f3fc-2642","shortnames":[":man_mage_medium_light_skin_tone:"],"category":"people"},":man_mage_tone3:":{"uc_base":"1f9d9-1f3fd-2642","uc_output":"1f9d9-1f3fd-200d-2642-fe0f","uc_match":"1f9d9-1f3fd-2642-fe0f","uc_greedy":"1f9d9-1f3fd-2642","shortnames":[":man_mage_medium_skin_tone:"],"category":"people"},":man_mage_tone4:":{"uc_base":"1f9d9-1f3fe-2642","uc_output":"1f9d9-1f3fe-200d-2642-fe0f","uc_match":"1f9d9-1f3fe-2642-fe0f","uc_greedy":"1f9d9-1f3fe-2642","shortnames":[":man_mage_medium_dark_skin_tone:"],"category":"people"},":man_mage_tone5:":{"uc_base":"1f9d9-1f3ff-2642","uc_output":"1f9d9-1f3ff-200d-2642-fe0f","uc_match":"1f9d9-1f3ff-2642-fe0f","uc_greedy":"1f9d9-1f3ff-2642","shortnames":[":man_mage_dark_skin_tone:"],"category":"people"},":man_mountain_biking_tone1:":{"uc_base":"1f6b5-1f3fb-2642","uc_output":"1f6b5-1f3fb-200d-2642-fe0f","uc_match":"1f6b5-1f3fb-2642-fe0f","uc_greedy":"1f6b5-1f3fb-2642","shortnames":[":man_mountain_biking_light_skin_tone:"],"category":"activity"},":man_mountain_biking_tone2:":{"uc_base":"1f6b5-1f3fc-2642","uc_output":"1f6b5-1f3fc-200d-2642-fe0f","uc_match":"1f6b5-1f3fc-2642-fe0f","uc_greedy":"1f6b5-1f3fc-2642","shortnames":[":man_mountain_biking_medium_light_skin_tone:"],"category":"activity"},":man_mountain_biking_tone3:":{"uc_base":"1f6b5-1f3fd-2642","uc_output":"1f6b5-1f3fd-200d-2642-fe0f","uc_match":"1f6b5-1f3fd-2642-fe0f","uc_greedy":"1f6b5-1f3fd-2642","shortnames":[":man_mountain_biking_medium_skin_tone:"],"category":"activity"},":man_mountain_biking_tone4:":{"uc_base":"1f6b5-1f3fe-2642","uc_output":"1f6b5-1f3fe-200d-2642-fe0f","uc_match":"1f6b5-1f3fe-2642-fe0f","uc_greedy":"1f6b5-1f3fe-2642","shortnames":[":man_mountain_biking_medium_dark_skin_tone:"],"category":"activity"},":man_mountain_biking_tone5:":{"uc_base":"1f6b5-1f3ff-2642","uc_output":"1f6b5-1f3ff-200d-2642-fe0f","uc_match":"1f6b5-1f3ff-2642-fe0f","uc_greedy":"1f6b5-1f3ff-2642","shortnames":[":man_mountain_biking_dark_skin_tone:"],"category":"activity"},":man_pilot_tone1:":{"uc_base":"1f468-1f3fb-2708","uc_output":"1f468-1f3fb-200d-2708-fe0f","uc_match":"1f468-1f3fb-2708-fe0f","uc_greedy":"1f468-1f3fb-2708","shortnames":[":man_pilot_light_skin_tone:"],"category":"people"},":man_pilot_tone2:":{"uc_base":"1f468-1f3fc-2708","uc_output":"1f468-1f3fc-200d-2708-fe0f","uc_match":"1f468-1f3fc-2708-fe0f","uc_greedy":"1f468-1f3fc-2708","shortnames":[":man_pilot_medium_light_skin_tone:"],"category":"people"},":man_pilot_tone3:":{"uc_base":"1f468-1f3fd-2708","uc_output":"1f468-1f3fd-200d-2708-fe0f","uc_match":"1f468-1f3fd-2708-fe0f","uc_greedy":"1f468-1f3fd-2708","shortnames":[":man_pilot_medium_skin_tone:"],"category":"people"},":man_pilot_tone4:":{"uc_base":"1f468-1f3fe-2708","uc_output":"1f468-1f3fe-200d-2708-fe0f","uc_match":"1f468-1f3fe-2708-fe0f","uc_greedy":"1f468-1f3fe-2708","shortnames":[":man_pilot_medium_dark_skin_tone:"],"category":"people"},":man_pilot_tone5:":{"uc_base":"1f468-1f3ff-2708","uc_output":"1f468-1f3ff-200d-2708-fe0f","uc_match":"1f468-1f3ff-2708-fe0f","uc_greedy":"1f468-1f3ff-2708","shortnames":[":man_pilot_dark_skin_tone:"],"category":"people"},":man_playing_handball_tone1:":{"uc_base":"1f93e-1f3fb-2642","uc_output":"1f93e-1f3fb-200d-2642-fe0f","uc_match":"1f93e-1f3fb-2642-fe0f","uc_greedy":"1f93e-1f3fb-2642","shortnames":[":man_playing_handball_light_skin_tone:"],"category":"activity"},":man_playing_handball_tone2:":{"uc_base":"1f93e-1f3fc-2642","uc_output":"1f93e-1f3fc-200d-2642-fe0f","uc_match":"1f93e-1f3fc-2642-fe0f","uc_greedy":"1f93e-1f3fc-2642","shortnames":[":man_playing_handball_medium_light_skin_tone:"],"category":"activity"},":man_playing_handball_tone3:":{"uc_base":"1f93e-1f3fd-2642","uc_output":"1f93e-1f3fd-200d-2642-fe0f","uc_match":"1f93e-1f3fd-2642-fe0f","uc_greedy":"1f93e-1f3fd-2642","shortnames":[":man_playing_handball_medium_skin_tone:"],"category":"activity"},":man_playing_handball_tone4:":{"uc_base":"1f93e-1f3fe-2642","uc_output":"1f93e-1f3fe-200d-2642-fe0f","uc_match":"1f93e-1f3fe-2642-fe0f","uc_greedy":"1f93e-1f3fe-2642","shortnames":[":man_playing_handball_medium_dark_skin_tone:"],"category":"activity"},":man_playing_handball_tone5:":{"uc_base":"1f93e-1f3ff-2642","uc_output":"1f93e-1f3ff-200d-2642-fe0f","uc_match":"1f93e-1f3ff-2642-fe0f","uc_greedy":"1f93e-1f3ff-2642","shortnames":[":man_playing_handball_dark_skin_tone:"],"category":"activity"},":man_playing_water_polo_tone1:":{"uc_base":"1f93d-1f3fb-2642","uc_output":"1f93d-1f3fb-200d-2642-fe0f","uc_match":"1f93d-1f3fb-2642-fe0f","uc_greedy":"1f93d-1f3fb-2642","shortnames":[":man_playing_water_polo_light_skin_tone:"],"category":"activity"},":man_playing_water_polo_tone2:":{"uc_base":"1f93d-1f3fc-2642","uc_output":"1f93d-1f3fc-200d-2642-fe0f","uc_match":"1f93d-1f3fc-2642-fe0f","uc_greedy":"1f93d-1f3fc-2642","shortnames":[":man_playing_water_polo_medium_light_skin_tone:"],"category":"activity"},":man_playing_water_polo_tone3:":{"uc_base":"1f93d-1f3fd-2642","uc_output":"1f93d-1f3fd-200d-2642-fe0f","uc_match":"1f93d-1f3fd-2642-fe0f","uc_greedy":"1f93d-1f3fd-2642","shortnames":[":man_playing_water_polo_medium_skin_tone:"],"category":"activity"},":man_playing_water_polo_tone4:":{"uc_base":"1f93d-1f3fe-2642","uc_output":"1f93d-1f3fe-200d-2642-fe0f","uc_match":"1f93d-1f3fe-2642-fe0f","uc_greedy":"1f93d-1f3fe-2642","shortnames":[":man_playing_water_polo_medium_dark_skin_tone:"],"category":"activity"},":man_playing_water_polo_tone5:":{"uc_base":"1f93d-1f3ff-2642","uc_output":"1f93d-1f3ff-200d-2642-fe0f","uc_match":"1f93d-1f3ff-2642-fe0f","uc_greedy":"1f93d-1f3ff-2642","shortnames":[":man_playing_water_polo_dark_skin_tone:"],"category":"activity"},":man_police_officer_tone1:":{"uc_base":"1f46e-1f3fb-2642","uc_output":"1f46e-1f3fb-200d-2642-fe0f","uc_match":"1f46e-1f3fb-2642-fe0f","uc_greedy":"1f46e-1f3fb-2642","shortnames":[":man_police_officer_light_skin_tone:"],"category":"people"},":man_police_officer_tone2:":{"uc_base":"1f46e-1f3fc-2642","uc_output":"1f46e-1f3fc-200d-2642-fe0f","uc_match":"1f46e-1f3fc-2642-fe0f","uc_greedy":"1f46e-1f3fc-2642","shortnames":[":man_police_officer_medium_light_skin_tone:"],"category":"people"},":man_police_officer_tone3:":{"uc_base":"1f46e-1f3fd-2642","uc_output":"1f46e-1f3fd-200d-2642-fe0f","uc_match":"1f46e-1f3fd-2642-fe0f","uc_greedy":"1f46e-1f3fd-2642","shortnames":[":man_police_officer_medium_skin_tone:"],"category":"people"},":man_police_officer_tone4:":{"uc_base":"1f46e-1f3fe-2642","uc_output":"1f46e-1f3fe-200d-2642-fe0f","uc_match":"1f46e-1f3fe-2642-fe0f","uc_greedy":"1f46e-1f3fe-2642","shortnames":[":man_police_officer_medium_dark_skin_tone:"],"category":"people"},":man_police_officer_tone5:":{"uc_base":"1f46e-1f3ff-2642","uc_output":"1f46e-1f3ff-200d-2642-fe0f","uc_match":"1f46e-1f3ff-2642-fe0f","uc_greedy":"1f46e-1f3ff-2642","shortnames":[":man_police_officer_dark_skin_tone:"],"category":"people"},":man_pouting_tone1:":{"uc_base":"1f64e-1f3fb-2642","uc_output":"1f64e-1f3fb-200d-2642-fe0f","uc_match":"1f64e-1f3fb-2642-fe0f","uc_greedy":"1f64e-1f3fb-2642","shortnames":[":man_pouting_light_skin_tone:"],"category":"people"},":man_pouting_tone2:":{"uc_base":"1f64e-1f3fc-2642","uc_output":"1f64e-1f3fc-200d-2642-fe0f","uc_match":"1f64e-1f3fc-2642-fe0f","uc_greedy":"1f64e-1f3fc-2642","shortnames":[":man_pouting_medium_light_skin_tone:"],"category":"people"},":man_pouting_tone3:":{"uc_base":"1f64e-1f3fd-2642","uc_output":"1f64e-1f3fd-200d-2642-fe0f","uc_match":"1f64e-1f3fd-2642-fe0f","uc_greedy":"1f64e-1f3fd-2642","shortnames":[":man_pouting_medium_skin_tone:"],"category":"people"},":man_pouting_tone4:":{"uc_base":"1f64e-1f3fe-2642","uc_output":"1f64e-1f3fe-200d-2642-fe0f","uc_match":"1f64e-1f3fe-2642-fe0f","uc_greedy":"1f64e-1f3fe-2642","shortnames":[":man_pouting_medium_dark_skin_tone:"],"category":"people"},":man_pouting_tone5:":{"uc_base":"1f64e-1f3ff-2642","uc_output":"1f64e-1f3ff-200d-2642-fe0f","uc_match":"1f64e-1f3ff-2642-fe0f","uc_greedy":"1f64e-1f3ff-2642","shortnames":[":man_pouting_dark_skin_tone:"],"category":"people"},":man_raising_hand_tone1:":{"uc_base":"1f64b-1f3fb-2642","uc_output":"1f64b-1f3fb-200d-2642-fe0f","uc_match":"1f64b-1f3fb-2642-fe0f","uc_greedy":"1f64b-1f3fb-2642","shortnames":[":man_raising_hand_light_skin_tone:"],"category":"people"},":man_raising_hand_tone2:":{"uc_base":"1f64b-1f3fc-2642","uc_output":"1f64b-1f3fc-200d-2642-fe0f","uc_match":"1f64b-1f3fc-2642-fe0f","uc_greedy":"1f64b-1f3fc-2642","shortnames":[":man_raising_hand_medium_light_skin_tone:"],"category":"people"},":man_raising_hand_tone3:":{"uc_base":"1f64b-1f3fd-2642","uc_output":"1f64b-1f3fd-200d-2642-fe0f","uc_match":"1f64b-1f3fd-2642-fe0f","uc_greedy":"1f64b-1f3fd-2642","shortnames":[":man_raising_hand_medium_skin_tone:"],"category":"people"},":man_raising_hand_tone4:":{"uc_base":"1f64b-1f3fe-2642","uc_output":"1f64b-1f3fe-200d-2642-fe0f","uc_match":"1f64b-1f3fe-2642-fe0f","uc_greedy":"1f64b-1f3fe-2642","shortnames":[":man_raising_hand_medium_dark_skin_tone:"],"category":"people"},":man_raising_hand_tone5:":{"uc_base":"1f64b-1f3ff-2642","uc_output":"1f64b-1f3ff-200d-2642-fe0f","uc_match":"1f64b-1f3ff-2642-fe0f","uc_greedy":"1f64b-1f3ff-2642","shortnames":[":man_raising_hand_dark_skin_tone:"],"category":"people"},":man_rowing_boat_tone1:":{"uc_base":"1f6a3-1f3fb-2642","uc_output":"1f6a3-1f3fb-200d-2642-fe0f","uc_match":"1f6a3-1f3fb-2642-fe0f","uc_greedy":"1f6a3-1f3fb-2642","shortnames":[":man_rowing_boat_light_skin_tone:"],"category":"activity"},":man_rowing_boat_tone2:":{"uc_base":"1f6a3-1f3fc-2642","uc_output":"1f6a3-1f3fc-200d-2642-fe0f","uc_match":"1f6a3-1f3fc-2642-fe0f","uc_greedy":"1f6a3-1f3fc-2642","shortnames":[":man_rowing_boat_medium_light_skin_tone:"],"category":"activity"},":man_rowing_boat_tone3:":{"uc_base":"1f6a3-1f3fd-2642","uc_output":"1f6a3-1f3fd-200d-2642-fe0f","uc_match":"1f6a3-1f3fd-2642-fe0f","uc_greedy":"1f6a3-1f3fd-2642","shortnames":[":man_rowing_boat_medium_skin_tone:"],"category":"activity"},":man_rowing_boat_tone4:":{"uc_base":"1f6a3-1f3fe-2642","uc_output":"1f6a3-1f3fe-200d-2642-fe0f","uc_match":"1f6a3-1f3fe-2642-fe0f","uc_greedy":"1f6a3-1f3fe-2642","shortnames":[":man_rowing_boat_medium_dark_skin_tone:"],"category":"activity"},":man_rowing_boat_tone5:":{"uc_base":"1f6a3-1f3ff-2642","uc_output":"1f6a3-1f3ff-200d-2642-fe0f","uc_match":"1f6a3-1f3ff-2642-fe0f","uc_greedy":"1f6a3-1f3ff-2642","shortnames":[":man_rowing_boat_dark_skin_tone:"],"category":"activity"},":man_running_tone1:":{"uc_base":"1f3c3-1f3fb-2642","uc_output":"1f3c3-1f3fb-200d-2642-fe0f","uc_match":"1f3c3-1f3fb-2642-fe0f","uc_greedy":"1f3c3-1f3fb-2642","shortnames":[":man_running_light_skin_tone:"],"category":"people"},":man_running_tone2:":{"uc_base":"1f3c3-1f3fc-2642","uc_output":"1f3c3-1f3fc-200d-2642-fe0f","uc_match":"1f3c3-1f3fc-2642-fe0f","uc_greedy":"1f3c3-1f3fc-2642","shortnames":[":man_running_medium_light_skin_tone:"],"category":"people"},":man_running_tone3:":{"uc_base":"1f3c3-1f3fd-2642","uc_output":"1f3c3-1f3fd-200d-2642-fe0f","uc_match":"1f3c3-1f3fd-2642-fe0f","uc_greedy":"1f3c3-1f3fd-2642","shortnames":[":man_running_medium_skin_tone:"],"category":"people"},":man_running_tone4:":{"uc_base":"1f3c3-1f3fe-2642","uc_output":"1f3c3-1f3fe-200d-2642-fe0f","uc_match":"1f3c3-1f3fe-2642-fe0f","uc_greedy":"1f3c3-1f3fe-2642","shortnames":[":man_running_medium_dark_skin_tone:"],"category":"people"},":man_running_tone5:":{"uc_base":"1f3c3-1f3ff-2642","uc_output":"1f3c3-1f3ff-200d-2642-fe0f","uc_match":"1f3c3-1f3ff-2642-fe0f","uc_greedy":"1f3c3-1f3ff-2642","shortnames":[":man_running_dark_skin_tone:"],"category":"people"},":man_shrugging_tone1:":{"uc_base":"1f937-1f3fb-2642","uc_output":"1f937-1f3fb-200d-2642-fe0f","uc_match":"1f937-1f3fb-2642-fe0f","uc_greedy":"1f937-1f3fb-2642","shortnames":[":man_shrugging_light_skin_tone:"],"category":"people"},":man_shrugging_tone2:":{"uc_base":"1f937-1f3fc-2642","uc_output":"1f937-1f3fc-200d-2642-fe0f","uc_match":"1f937-1f3fc-2642-fe0f","uc_greedy":"1f937-1f3fc-2642","shortnames":[":man_shrugging_medium_light_skin_tone:"],"category":"people"},":man_shrugging_tone3:":{"uc_base":"1f937-1f3fd-2642","uc_output":"1f937-1f3fd-200d-2642-fe0f","uc_match":"1f937-1f3fd-2642-fe0f","uc_greedy":"1f937-1f3fd-2642","shortnames":[":man_shrugging_medium_skin_tone:"],"category":"people"},":man_shrugging_tone4:":{"uc_base":"1f937-1f3fe-2642","uc_output":"1f937-1f3fe-200d-2642-fe0f","uc_match":"1f937-1f3fe-2642-fe0f","uc_greedy":"1f937-1f3fe-2642","shortnames":[":man_shrugging_medium_dark_skin_tone:"],"category":"people"},":man_shrugging_tone5:":{"uc_base":"1f937-1f3ff-2642","uc_output":"1f937-1f3ff-200d-2642-fe0f","uc_match":"1f937-1f3ff-2642-fe0f","uc_greedy":"1f937-1f3ff-2642","shortnames":[":man_shrugging_dark_skin_tone:"],"category":"people"},":man_superhero_tone1:":{"uc_base":"1f9b8-1f3fb-2642","uc_output":"1f9b8-1f3fb-200d-2642-fe0f","uc_match":"1f9b8-1f3fb-2642-fe0f","uc_greedy":"1f9b8-1f3fb-2642","shortnames":[":man_superhero_light_skin_tone:"],"category":"people"},":man_superhero_tone2:":{"uc_base":"1f9b8-1f3fc-2642","uc_output":"1f9b8-1f3fc-200d-2642-fe0f","uc_match":"1f9b8-1f3fc-2642-fe0f","uc_greedy":"1f9b8-1f3fc-2642","shortnames":[":man_superhero_medium_light_skin_tone:"],"category":"people"},":man_superhero_tone3:":{"uc_base":"1f9b8-1f3fd-2642","uc_output":"1f9b8-1f3fd-200d-2642-fe0f","uc_match":"1f9b8-1f3fd-2642-fe0f","uc_greedy":"1f9b8-1f3fd-2642","shortnames":[":man_superhero_medium_skin_tone:"],"category":"people"},":man_superhero_tone4:":{"uc_base":"1f9b8-1f3fe-2642","uc_output":"1f9b8-1f3fe-200d-2642-fe0f","uc_match":"1f9b8-1f3fe-2642-fe0f","uc_greedy":"1f9b8-1f3fe-2642","shortnames":[":man_superhero_medium_dark_skin_tone:"],"category":"people"},":man_superhero_tone5:":{"uc_base":"1f9b8-1f3ff-2642","uc_output":"1f9b8-1f3ff-200d-2642-fe0f","uc_match":"1f9b8-1f3ff-2642-fe0f","uc_greedy":"1f9b8-1f3ff-2642","shortnames":[":man_superhero_dark_skin_tone:"],"category":"people"},":man_supervillain_tone1:":{"uc_base":"1f9b9-1f3fb-2642","uc_output":"1f9b9-1f3fb-200d-2642-fe0f","uc_match":"1f9b9-1f3fb-2642-fe0f","uc_greedy":"1f9b9-1f3fb-2642","shortnames":[":man_supervillain_light_skin_tone:"],"category":"people"},":man_supervillain_tone2:":{"uc_base":"1f9b9-1f3fc-2642","uc_output":"1f9b9-1f3fc-200d-2642-fe0f","uc_match":"1f9b9-1f3fc-2642-fe0f","uc_greedy":"1f9b9-1f3fc-2642","shortnames":[":man_supervillain_medium_light_skin_tone:"],"category":"people"},":man_supervillain_tone3:":{"uc_base":"1f9b9-1f3fd-2642","uc_output":"1f9b9-1f3fd-200d-2642-fe0f","uc_match":"1f9b9-1f3fd-2642-fe0f","uc_greedy":"1f9b9-1f3fd-2642","shortnames":[":man_supervillain_medium_skin_tone:"],"category":"people"},":man_supervillain_tone4:":{"uc_base":"1f9b9-1f3fe-2642","uc_output":"1f9b9-1f3fe-200d-2642-fe0f","uc_match":"1f9b9-1f3fe-2642-fe0f","uc_greedy":"1f9b9-1f3fe-2642","shortnames":[":man_supervillain_medium_dark_skin_tone:"],"category":"people"},":man_supervillain_tone5:":{"uc_base":"1f9b9-1f3ff-2642","uc_output":"1f9b9-1f3ff-200d-2642-fe0f","uc_match":"1f9b9-1f3ff-2642-fe0f","uc_greedy":"1f9b9-1f3ff-2642","shortnames":[":man_supervillain_dark_skin_tone:"],"category":"people"},":man_surfing_tone1:":{"uc_base":"1f3c4-1f3fb-2642","uc_output":"1f3c4-1f3fb-200d-2642-fe0f","uc_match":"1f3c4-1f3fb-2642-fe0f","uc_greedy":"1f3c4-1f3fb-2642","shortnames":[":man_surfing_light_skin_tone:"],"category":"activity"},":man_surfing_tone2:":{"uc_base":"1f3c4-1f3fc-2642","uc_output":"1f3c4-1f3fc-200d-2642-fe0f","uc_match":"1f3c4-1f3fc-2642-fe0f","uc_greedy":"1f3c4-1f3fc-2642","shortnames":[":man_surfing_medium_light_skin_tone:"],"category":"activity"},":man_surfing_tone3:":{"uc_base":"1f3c4-1f3fd-2642","uc_output":"1f3c4-1f3fd-200d-2642-fe0f","uc_match":"1f3c4-1f3fd-2642-fe0f","uc_greedy":"1f3c4-1f3fd-2642","shortnames":[":man_surfing_medium_skin_tone:"],"category":"activity"},":man_surfing_tone4:":{"uc_base":"1f3c4-1f3fe-2642","uc_output":"1f3c4-1f3fe-200d-2642-fe0f","uc_match":"1f3c4-1f3fe-2642-fe0f","uc_greedy":"1f3c4-1f3fe-2642","shortnames":[":man_surfing_medium_dark_skin_tone:"],"category":"activity"},":man_surfing_tone5:":{"uc_base":"1f3c4-1f3ff-2642","uc_output":"1f3c4-1f3ff-200d-2642-fe0f","uc_match":"1f3c4-1f3ff-2642-fe0f","uc_greedy":"1f3c4-1f3ff-2642","shortnames":[":man_surfing_dark_skin_tone:"],"category":"activity"},":man_swimming_tone1:":{"uc_base":"1f3ca-1f3fb-2642","uc_output":"1f3ca-1f3fb-200d-2642-fe0f","uc_match":"1f3ca-1f3fb-2642-fe0f","uc_greedy":"1f3ca-1f3fb-2642","shortnames":[":man_swimming_light_skin_tone:"],"category":"activity"},":man_swimming_tone2:":{"uc_base":"1f3ca-1f3fc-2642","uc_output":"1f3ca-1f3fc-200d-2642-fe0f","uc_match":"1f3ca-1f3fc-2642-fe0f","uc_greedy":"1f3ca-1f3fc-2642","shortnames":[":man_swimming_medium_light_skin_tone:"],"category":"activity"},":man_swimming_tone3:":{"uc_base":"1f3ca-1f3fd-2642","uc_output":"1f3ca-1f3fd-200d-2642-fe0f","uc_match":"1f3ca-1f3fd-2642-fe0f","uc_greedy":"1f3ca-1f3fd-2642","shortnames":[":man_swimming_medium_skin_tone:"],"category":"activity"},":man_swimming_tone4:":{"uc_base":"1f3ca-1f3fe-2642","uc_output":"1f3ca-1f3fe-200d-2642-fe0f","uc_match":"1f3ca-1f3fe-2642-fe0f","uc_greedy":"1f3ca-1f3fe-2642","shortnames":[":man_swimming_medium_dark_skin_tone:"],"category":"activity"},":man_swimming_tone5:":{"uc_base":"1f3ca-1f3ff-2642","uc_output":"1f3ca-1f3ff-200d-2642-fe0f","uc_match":"1f3ca-1f3ff-2642-fe0f","uc_greedy":"1f3ca-1f3ff-2642","shortnames":[":man_swimming_dark_skin_tone:"],"category":"activity"},":man_tipping_hand_tone1:":{"uc_base":"1f481-1f3fb-2642","uc_output":"1f481-1f3fb-200d-2642-fe0f","uc_match":"1f481-1f3fb-2642-fe0f","uc_greedy":"1f481-1f3fb-2642","shortnames":[":man_tipping_hand_light_skin_tone:"],"category":"people"},":man_tipping_hand_tone2:":{"uc_base":"1f481-1f3fc-2642","uc_output":"1f481-1f3fc-200d-2642-fe0f","uc_match":"1f481-1f3fc-2642-fe0f","uc_greedy":"1f481-1f3fc-2642","shortnames":[":man_tipping_hand_medium_light_skin_tone:"],"category":"people"},":man_tipping_hand_tone3:":{"uc_base":"1f481-1f3fd-2642","uc_output":"1f481-1f3fd-200d-2642-fe0f","uc_match":"1f481-1f3fd-2642-fe0f","uc_greedy":"1f481-1f3fd-2642","shortnames":[":man_tipping_hand_medium_skin_tone:"],"category":"people"},":man_tipping_hand_tone4:":{"uc_base":"1f481-1f3fe-2642","uc_output":"1f481-1f3fe-200d-2642-fe0f","uc_match":"1f481-1f3fe-2642-fe0f","uc_greedy":"1f481-1f3fe-2642","shortnames":[":man_tipping_hand_medium_dark_skin_tone:"],"category":"people"},":man_tipping_hand_tone5:":{"uc_base":"1f481-1f3ff-2642","uc_output":"1f481-1f3ff-200d-2642-fe0f","uc_match":"1f481-1f3ff-2642-fe0f","uc_greedy":"1f481-1f3ff-2642","shortnames":[":man_tipping_hand_dark_skin_tone:"],"category":"people"},":man_vampire_tone1:":{"uc_base":"1f9db-1f3fb-2642","uc_output":"1f9db-1f3fb-200d-2642-fe0f","uc_match":"1f9db-1f3fb-2642-fe0f","uc_greedy":"1f9db-1f3fb-2642","shortnames":[":man_vampire_light_skin_tone:"],"category":"people"},":man_vampire_tone2:":{"uc_base":"1f9db-1f3fc-2642","uc_output":"1f9db-1f3fc-200d-2642-fe0f","uc_match":"1f9db-1f3fc-2642-fe0f","uc_greedy":"1f9db-1f3fc-2642","shortnames":[":man_vampire_medium_light_skin_tone:"],"category":"people"},":man_vampire_tone3:":{"uc_base":"1f9db-1f3fd-2642","uc_output":"1f9db-1f3fd-200d-2642-fe0f","uc_match":"1f9db-1f3fd-2642-fe0f","uc_greedy":"1f9db-1f3fd-2642","shortnames":[":man_vampire_medium_skin_tone:"],"category":"people"},":man_vampire_tone4:":{"uc_base":"1f9db-1f3fe-2642","uc_output":"1f9db-1f3fe-200d-2642-fe0f","uc_match":"1f9db-1f3fe-2642-fe0f","uc_greedy":"1f9db-1f3fe-2642","shortnames":[":man_vampire_medium_dark_skin_tone:"],"category":"people"},":man_vampire_tone5:":{"uc_base":"1f9db-1f3ff-2642","uc_output":"1f9db-1f3ff-200d-2642-fe0f","uc_match":"1f9db-1f3ff-2642-fe0f","uc_greedy":"1f9db-1f3ff-2642","shortnames":[":man_vampire_dark_skin_tone:"],"category":"people"},":man_walking_tone1:":{"uc_base":"1f6b6-1f3fb-2642","uc_output":"1f6b6-1f3fb-200d-2642-fe0f","uc_match":"1f6b6-1f3fb-2642-fe0f","uc_greedy":"1f6b6-1f3fb-2642","shortnames":[":man_walking_light_skin_tone:"],"category":"people"},":man_walking_tone2:":{"uc_base":"1f6b6-1f3fc-2642","uc_output":"1f6b6-1f3fc-200d-2642-fe0f","uc_match":"1f6b6-1f3fc-2642-fe0f","uc_greedy":"1f6b6-1f3fc-2642","shortnames":[":man_walking_medium_light_skin_tone:"],"category":"people"},":man_walking_tone3:":{"uc_base":"1f6b6-1f3fd-2642","uc_output":"1f6b6-1f3fd-200d-2642-fe0f","uc_match":"1f6b6-1f3fd-2642-fe0f","uc_greedy":"1f6b6-1f3fd-2642","shortnames":[":man_walking_medium_skin_tone:"],"category":"people"},":man_walking_tone4:":{"uc_base":"1f6b6-1f3fe-2642","uc_output":"1f6b6-1f3fe-200d-2642-fe0f","uc_match":"1f6b6-1f3fe-2642-fe0f","uc_greedy":"1f6b6-1f3fe-2642","shortnames":[":man_walking_medium_dark_skin_tone:"],"category":"people"},":man_walking_tone5:":{"uc_base":"1f6b6-1f3ff-2642","uc_output":"1f6b6-1f3ff-200d-2642-fe0f","uc_match":"1f6b6-1f3ff-2642-fe0f","uc_greedy":"1f6b6-1f3ff-2642","shortnames":[":man_walking_dark_skin_tone:"],"category":"people"},":man_wearing_turban_tone1:":{"uc_base":"1f473-1f3fb-2642","uc_output":"1f473-1f3fb-200d-2642-fe0f","uc_match":"1f473-1f3fb-2642-fe0f","uc_greedy":"1f473-1f3fb-2642","shortnames":[":man_wearing_turban_light_skin_tone:"],"category":"people"},":man_wearing_turban_tone2:":{"uc_base":"1f473-1f3fc-2642","uc_output":"1f473-1f3fc-200d-2642-fe0f","uc_match":"1f473-1f3fc-2642-fe0f","uc_greedy":"1f473-1f3fc-2642","shortnames":[":man_wearing_turban_medium_light_skin_tone:"],"category":"people"},":man_wearing_turban_tone3:":{"uc_base":"1f473-1f3fd-2642","uc_output":"1f473-1f3fd-200d-2642-fe0f","uc_match":"1f473-1f3fd-2642-fe0f","uc_greedy":"1f473-1f3fd-2642","shortnames":[":man_wearing_turban_medium_skin_tone:"],"category":"people"},":man_wearing_turban_tone4:":{"uc_base":"1f473-1f3fe-2642","uc_output":"1f473-1f3fe-200d-2642-fe0f","uc_match":"1f473-1f3fe-2642-fe0f","uc_greedy":"1f473-1f3fe-2642","shortnames":[":man_wearing_turban_medium_dark_skin_tone:"],"category":"people"},":man_wearing_turban_tone5:":{"uc_base":"1f473-1f3ff-2642","uc_output":"1f473-1f3ff-200d-2642-fe0f","uc_match":"1f473-1f3ff-2642-fe0f","uc_greedy":"1f473-1f3ff-2642","shortnames":[":man_wearing_turban_dark_skin_tone:"],"category":"people"},":mermaid_tone1:":{"uc_base":"1f9dc-1f3fb-2640","uc_output":"1f9dc-1f3fb-200d-2640-fe0f","uc_match":"1f9dc-1f3fb-2640-fe0f","uc_greedy":"1f9dc-1f3fb-2640","shortnames":[":mermaid_light_skin_tone:"],"category":"people"},":mermaid_tone2:":{"uc_base":"1f9dc-1f3fc-2640","uc_output":"1f9dc-1f3fc-200d-2640-fe0f","uc_match":"1f9dc-1f3fc-2640-fe0f","uc_greedy":"1f9dc-1f3fc-2640","shortnames":[":mermaid_medium_light_skin_tone:"],"category":"people"},":mermaid_tone3:":{"uc_base":"1f9dc-1f3fd-2640","uc_output":"1f9dc-1f3fd-200d-2640-fe0f","uc_match":"1f9dc-1f3fd-2640-fe0f","uc_greedy":"1f9dc-1f3fd-2640","shortnames":[":mermaid_medium_skin_tone:"],"category":"people"},":mermaid_tone4:":{"uc_base":"1f9dc-1f3fe-2640","uc_output":"1f9dc-1f3fe-200d-2640-fe0f","uc_match":"1f9dc-1f3fe-2640-fe0f","uc_greedy":"1f9dc-1f3fe-2640","shortnames":[":mermaid_medium_dark_skin_tone:"],"category":"people"},":mermaid_tone5:":{"uc_base":"1f9dc-1f3ff-2640","uc_output":"1f9dc-1f3ff-200d-2640-fe0f","uc_match":"1f9dc-1f3ff-2640-fe0f","uc_greedy":"1f9dc-1f3ff-2640","shortnames":[":mermaid_dark_skin_tone:"],"category":"people"},":merman_tone1:":{"uc_base":"1f9dc-1f3fb-2642","uc_output":"1f9dc-1f3fb-200d-2642-fe0f","uc_match":"1f9dc-1f3fb-2642-fe0f","uc_greedy":"1f9dc-1f3fb-2642","shortnames":[":merman_light_skin_tone:"],"category":"people"},":merman_tone2:":{"uc_base":"1f9dc-1f3fc-2642","uc_output":"1f9dc-1f3fc-200d-2642-fe0f","uc_match":"1f9dc-1f3fc-2642-fe0f","uc_greedy":"1f9dc-1f3fc-2642","shortnames":[":merman_medium_light_skin_tone:"],"category":"people"},":merman_tone3:":{"uc_base":"1f9dc-1f3fd-2642","uc_output":"1f9dc-1f3fd-200d-2642-fe0f","uc_match":"1f9dc-1f3fd-2642-fe0f","uc_greedy":"1f9dc-1f3fd-2642","shortnames":[":merman_medium_skin_tone:"],"category":"people"},":merman_tone4:":{"uc_base":"1f9dc-1f3fe-2642","uc_output":"1f9dc-1f3fe-200d-2642-fe0f","uc_match":"1f9dc-1f3fe-2642-fe0f","uc_greedy":"1f9dc-1f3fe-2642","shortnames":[":merman_medium_dark_skin_tone:"],"category":"people"},":merman_tone5:":{"uc_base":"1f9dc-1f3ff-2642","uc_output":"1f9dc-1f3ff-200d-2642-fe0f","uc_match":"1f9dc-1f3ff-2642-fe0f","uc_greedy":"1f9dc-1f3ff-2642","shortnames":[":merman_dark_skin_tone:"],"category":"people"},":woman_biking_tone1:":{"uc_base":"1f6b4-1f3fb-2640","uc_output":"1f6b4-1f3fb-200d-2640-fe0f","uc_match":"1f6b4-1f3fb-2640-fe0f","uc_greedy":"1f6b4-1f3fb-2640","shortnames":[":woman_biking_light_skin_tone:"],"category":"activity"},":woman_biking_tone2:":{"uc_base":"1f6b4-1f3fc-2640","uc_output":"1f6b4-1f3fc-200d-2640-fe0f","uc_match":"1f6b4-1f3fc-2640-fe0f","uc_greedy":"1f6b4-1f3fc-2640","shortnames":[":woman_biking_medium_light_skin_tone:"],"category":"activity"},":woman_biking_tone3:":{"uc_base":"1f6b4-1f3fd-2640","uc_output":"1f6b4-1f3fd-200d-2640-fe0f","uc_match":"1f6b4-1f3fd-2640-fe0f","uc_greedy":"1f6b4-1f3fd-2640","shortnames":[":woman_biking_medium_skin_tone:"],"category":"activity"},":woman_biking_tone4:":{"uc_base":"1f6b4-1f3fe-2640","uc_output":"1f6b4-1f3fe-200d-2640-fe0f","uc_match":"1f6b4-1f3fe-2640-fe0f","uc_greedy":"1f6b4-1f3fe-2640","shortnames":[":woman_biking_medium_dark_skin_tone:"],"category":"activity"},":woman_biking_tone5:":{"uc_base":"1f6b4-1f3ff-2640","uc_output":"1f6b4-1f3ff-200d-2640-fe0f","uc_match":"1f6b4-1f3ff-2640-fe0f","uc_greedy":"1f6b4-1f3ff-2640","shortnames":[":woman_biking_dark_skin_tone:"],"category":"activity"},":woman_bowing_tone1:":{"uc_base":"1f647-1f3fb-2640","uc_output":"1f647-1f3fb-200d-2640-fe0f","uc_match":"1f647-1f3fb-2640-fe0f","uc_greedy":"1f647-1f3fb-2640","shortnames":[":woman_bowing_light_skin_tone:"],"category":"people"},":woman_bowing_tone2:":{"uc_base":"1f647-1f3fc-2640","uc_output":"1f647-1f3fc-200d-2640-fe0f","uc_match":"1f647-1f3fc-2640-fe0f","uc_greedy":"1f647-1f3fc-2640","shortnames":[":woman_bowing_medium_light_skin_tone:"],"category":"people"},":woman_bowing_tone3:":{"uc_base":"1f647-1f3fd-2640","uc_output":"1f647-1f3fd-200d-2640-fe0f","uc_match":"1f647-1f3fd-2640-fe0f","uc_greedy":"1f647-1f3fd-2640","shortnames":[":woman_bowing_medium_skin_tone:"],"category":"people"},":woman_bowing_tone4:":{"uc_base":"1f647-1f3fe-2640","uc_output":"1f647-1f3fe-200d-2640-fe0f","uc_match":"1f647-1f3fe-2640-fe0f","uc_greedy":"1f647-1f3fe-2640","shortnames":[":woman_bowing_medium_dark_skin_tone:"],"category":"people"},":woman_bowing_tone5:":{"uc_base":"1f647-1f3ff-2640","uc_output":"1f647-1f3ff-200d-2640-fe0f","uc_match":"1f647-1f3ff-2640-fe0f","uc_greedy":"1f647-1f3ff-2640","shortnames":[":woman_bowing_dark_skin_tone:"],"category":"people"},":woman_cartwheeling_tone1:":{"uc_base":"1f938-1f3fb-2640","uc_output":"1f938-1f3fb-200d-2640-fe0f","uc_match":"1f938-1f3fb-2640-fe0f","uc_greedy":"1f938-1f3fb-2640","shortnames":[":woman_cartwheeling_light_skin_tone:"],"category":"activity"},":woman_cartwheeling_tone2:":{"uc_base":"1f938-1f3fc-2640","uc_output":"1f938-1f3fc-200d-2640-fe0f","uc_match":"1f938-1f3fc-2640-fe0f","uc_greedy":"1f938-1f3fc-2640","shortnames":[":woman_cartwheeling_medium_light_skin_tone:"],"category":"activity"},":woman_cartwheeling_tone3:":{"uc_base":"1f938-1f3fd-2640","uc_output":"1f938-1f3fd-200d-2640-fe0f","uc_match":"1f938-1f3fd-2640-fe0f","uc_greedy":"1f938-1f3fd-2640","shortnames":[":woman_cartwheeling_medium_skin_tone:"],"category":"activity"},":woman_cartwheeling_tone4:":{"uc_base":"1f938-1f3fe-2640","uc_output":"1f938-1f3fe-200d-2640-fe0f","uc_match":"1f938-1f3fe-2640-fe0f","uc_greedy":"1f938-1f3fe-2640","shortnames":[":woman_cartwheeling_medium_dark_skin_tone:"],"category":"activity"},":woman_cartwheeling_tone5:":{"uc_base":"1f938-1f3ff-2640","uc_output":"1f938-1f3ff-200d-2640-fe0f","uc_match":"1f938-1f3ff-2640-fe0f","uc_greedy":"1f938-1f3ff-2640","shortnames":[":woman_cartwheeling_dark_skin_tone:"],"category":"activity"},":woman_climbing_tone1:":{"uc_base":"1f9d7-1f3fb-2640","uc_output":"1f9d7-1f3fb-200d-2640-fe0f","uc_match":"1f9d7-1f3fb-2640-fe0f","uc_greedy":"1f9d7-1f3fb-2640","shortnames":[":woman_climbing_light_skin_tone:"],"category":"activity"},":woman_climbing_tone2:":{"uc_base":"1f9d7-1f3fc-2640","uc_output":"1f9d7-1f3fc-200d-2640-fe0f","uc_match":"1f9d7-1f3fc-2640-fe0f","uc_greedy":"1f9d7-1f3fc-2640","shortnames":[":woman_climbing_medium_light_skin_tone:"],"category":"activity"},":woman_climbing_tone3:":{"uc_base":"1f9d7-1f3fd-2640","uc_output":"1f9d7-1f3fd-200d-2640-fe0f","uc_match":"1f9d7-1f3fd-2640-fe0f","uc_greedy":"1f9d7-1f3fd-2640","shortnames":[":woman_climbing_medium_skin_tone:"],"category":"activity"},":woman_climbing_tone4:":{"uc_base":"1f9d7-1f3fe-2640","uc_output":"1f9d7-1f3fe-200d-2640-fe0f","uc_match":"1f9d7-1f3fe-2640-fe0f","uc_greedy":"1f9d7-1f3fe-2640","shortnames":[":woman_climbing_medium_dark_skin_tone:"],"category":"activity"},":woman_climbing_tone5:":{"uc_base":"1f9d7-1f3ff-2640","uc_output":"1f9d7-1f3ff-200d-2640-fe0f","uc_match":"1f9d7-1f3ff-2640-fe0f","uc_greedy":"1f9d7-1f3ff-2640","shortnames":[":woman_climbing_dark_skin_tone:"],"category":"activity"},":woman_construction_worker_tone1:":{"uc_base":"1f477-1f3fb-2640","uc_output":"1f477-1f3fb-200d-2640-fe0f","uc_match":"1f477-1f3fb-2640-fe0f","uc_greedy":"1f477-1f3fb-2640","shortnames":[":woman_construction_worker_light_skin_tone:"],"category":"people"},":woman_construction_worker_tone2:":{"uc_base":"1f477-1f3fc-2640","uc_output":"1f477-1f3fc-200d-2640-fe0f","uc_match":"1f477-1f3fc-2640-fe0f","uc_greedy":"1f477-1f3fc-2640","shortnames":[":woman_construction_worker_medium_light_skin_tone:"],"category":"people"},":woman_construction_worker_tone3:":{"uc_base":"1f477-1f3fd-2640","uc_output":"1f477-1f3fd-200d-2640-fe0f","uc_match":"1f477-1f3fd-2640-fe0f","uc_greedy":"1f477-1f3fd-2640","shortnames":[":woman_construction_worker_medium_skin_tone:"],"category":"people"},":woman_construction_worker_tone4:":{"uc_base":"1f477-1f3fe-2640","uc_output":"1f477-1f3fe-200d-2640-fe0f","uc_match":"1f477-1f3fe-2640-fe0f","uc_greedy":"1f477-1f3fe-2640","shortnames":[":woman_construction_worker_medium_dark_skin_tone:"],"category":"people"},":woman_construction_worker_tone5:":{"uc_base":"1f477-1f3ff-2640","uc_output":"1f477-1f3ff-200d-2640-fe0f","uc_match":"1f477-1f3ff-2640-fe0f","uc_greedy":"1f477-1f3ff-2640","shortnames":[":woman_construction_worker_dark_skin_tone:"],"category":"people"},":woman_detective_tone1:":{"uc_base":"1f575-1f3fb-2640","uc_output":"1f575-1f3fb-200d-2640-fe0f","uc_match":"1f575-fe0f-1f3fb-2640-fe0f","uc_greedy":"1f575-1f3fb-2640","shortnames":[":woman_detective_light_skin_tone:"],"category":"people"},":woman_detective_tone2:":{"uc_base":"1f575-1f3fc-2640","uc_output":"1f575-1f3fc-200d-2640-fe0f","uc_match":"1f575-fe0f-1f3fc-2640-fe0f","uc_greedy":"1f575-1f3fc-2640","shortnames":[":woman_detective_medium_light_skin_tone:"],"category":"people"},":woman_detective_tone3:":{"uc_base":"1f575-1f3fd-2640","uc_output":"1f575-1f3fd-200d-2640-fe0f","uc_match":"1f575-fe0f-1f3fd-2640-fe0f","uc_greedy":"1f575-1f3fd-2640","shortnames":[":woman_detective_medium_skin_tone:"],"category":"people"},":woman_detective_tone4:":{"uc_base":"1f575-1f3fe-2640","uc_output":"1f575-1f3fe-200d-2640-fe0f","uc_match":"1f575-fe0f-1f3fe-2640-fe0f","uc_greedy":"1f575-1f3fe-2640","shortnames":[":woman_detective_medium_dark_skin_tone:"],"category":"people"},":woman_detective_tone5:":{"uc_base":"1f575-1f3ff-2640","uc_output":"1f575-1f3ff-200d-2640-fe0f","uc_match":"1f575-fe0f-1f3ff-2640-fe0f","uc_greedy":"1f575-1f3ff-2640","shortnames":[":woman_detective_dark_skin_tone:"],"category":"people"},":woman_elf_tone1:":{"uc_base":"1f9dd-1f3fb-2640","uc_output":"1f9dd-1f3fb-200d-2640-fe0f","uc_match":"1f9dd-1f3fb-2640-fe0f","uc_greedy":"1f9dd-1f3fb-2640","shortnames":[":woman_elf_light_skin_tone:"],"category":"people"},":woman_elf_tone2:":{"uc_base":"1f9dd-1f3fc-2640","uc_output":"1f9dd-1f3fc-200d-2640-fe0f","uc_match":"1f9dd-1f3fc-2640-fe0f","uc_greedy":"1f9dd-1f3fc-2640","shortnames":[":woman_elf_medium_light_skin_tone:"],"category":"people"},":woman_elf_tone3:":{"uc_base":"1f9dd-1f3fd-2640","uc_output":"1f9dd-1f3fd-200d-2640-fe0f","uc_match":"1f9dd-1f3fd-2640-fe0f","uc_greedy":"1f9dd-1f3fd-2640","shortnames":[":woman_elf_medium_skin_tone:"],"category":"people"},":woman_elf_tone4:":{"uc_base":"1f9dd-1f3fe-2640","uc_output":"1f9dd-1f3fe-200d-2640-fe0f","uc_match":"1f9dd-1f3fe-2640-fe0f","uc_greedy":"1f9dd-1f3fe-2640","shortnames":[":woman_elf_medium_dark_skin_tone:"],"category":"people"},":woman_elf_tone5:":{"uc_base":"1f9dd-1f3ff-2640","uc_output":"1f9dd-1f3ff-200d-2640-fe0f","uc_match":"1f9dd-1f3ff-2640-fe0f","uc_greedy":"1f9dd-1f3ff-2640","shortnames":[":woman_elf_dark_skin_tone:"],"category":"people"},":woman_facepalming_tone1:":{"uc_base":"1f926-1f3fb-2640","uc_output":"1f926-1f3fb-200d-2640-fe0f","uc_match":"1f926-1f3fb-2640-fe0f","uc_greedy":"1f926-1f3fb-2640","shortnames":[":woman_facepalming_light_skin_tone:"],"category":"people"},":woman_facepalming_tone2:":{"uc_base":"1f926-1f3fc-2640","uc_output":"1f926-1f3fc-200d-2640-fe0f","uc_match":"1f926-1f3fc-2640-fe0f","uc_greedy":"1f926-1f3fc-2640","shortnames":[":woman_facepalming_medium_light_skin_tone:"],"category":"people"},":woman_facepalming_tone3:":{"uc_base":"1f926-1f3fd-2640","uc_output":"1f926-1f3fd-200d-2640-fe0f","uc_match":"1f926-1f3fd-2640-fe0f","uc_greedy":"1f926-1f3fd-2640","shortnames":[":woman_facepalming_medium_skin_tone:"],"category":"people"},":woman_facepalming_tone4:":{"uc_base":"1f926-1f3fe-2640","uc_output":"1f926-1f3fe-200d-2640-fe0f","uc_match":"1f926-1f3fe-2640-fe0f","uc_greedy":"1f926-1f3fe-2640","shortnames":[":woman_facepalming_medium_dark_skin_tone:"],"category":"people"},":woman_facepalming_tone5:":{"uc_base":"1f926-1f3ff-2640","uc_output":"1f926-1f3ff-200d-2640-fe0f","uc_match":"1f926-1f3ff-2640-fe0f","uc_greedy":"1f926-1f3ff-2640","shortnames":[":woman_facepalming_dark_skin_tone:"],"category":"people"},":woman_fairy_tone1:":{"uc_base":"1f9da-1f3fb-2640","uc_output":"1f9da-1f3fb-200d-2640-fe0f","uc_match":"1f9da-1f3fb-2640-fe0f","uc_greedy":"1f9da-1f3fb-2640","shortnames":[":woman_fairy_light_skin_tone:"],"category":"people"},":woman_fairy_tone2:":{"uc_base":"1f9da-1f3fc-2640","uc_output":"1f9da-1f3fc-200d-2640-fe0f","uc_match":"1f9da-1f3fc-2640-fe0f","uc_greedy":"1f9da-1f3fc-2640","shortnames":[":woman_fairy_medium_light_skin_tone:"],"category":"people"},":woman_fairy_tone3:":{"uc_base":"1f9da-1f3fd-2640","uc_output":"1f9da-1f3fd-200d-2640-fe0f","uc_match":"1f9da-1f3fd-2640-fe0f","uc_greedy":"1f9da-1f3fd-2640","shortnames":[":woman_fairy_medium_skin_tone:"],"category":"people"},":woman_fairy_tone4:":{"uc_base":"1f9da-1f3fe-2640","uc_output":"1f9da-1f3fe-200d-2640-fe0f","uc_match":"1f9da-1f3fe-2640-fe0f","uc_greedy":"1f9da-1f3fe-2640","shortnames":[":woman_fairy_medium_dark_skin_tone:"],"category":"people"},":woman_fairy_tone5:":{"uc_base":"1f9da-1f3ff-2640","uc_output":"1f9da-1f3ff-200d-2640-fe0f","uc_match":"1f9da-1f3ff-2640-fe0f","uc_greedy":"1f9da-1f3ff-2640","shortnames":[":woman_fairy_dark_skin_tone:"],"category":"people"},":woman_frowning_tone1:":{"uc_base":"1f64d-1f3fb-2640","uc_output":"1f64d-1f3fb-200d-2640-fe0f","uc_match":"1f64d-1f3fb-2640-fe0f","uc_greedy":"1f64d-1f3fb-2640","shortnames":[":woman_frowning_light_skin_tone:"],"category":"people"},":woman_frowning_tone2:":{"uc_base":"1f64d-1f3fc-2640","uc_output":"1f64d-1f3fc-200d-2640-fe0f","uc_match":"1f64d-1f3fc-2640-fe0f","uc_greedy":"1f64d-1f3fc-2640","shortnames":[":woman_frowning_medium_light_skin_tone:"],"category":"people"},":woman_frowning_tone3:":{"uc_base":"1f64d-1f3fd-2640","uc_output":"1f64d-1f3fd-200d-2640-fe0f","uc_match":"1f64d-1f3fd-2640-fe0f","uc_greedy":"1f64d-1f3fd-2640","shortnames":[":woman_frowning_medium_skin_tone:"],"category":"people"},":woman_frowning_tone4:":{"uc_base":"1f64d-1f3fe-2640","uc_output":"1f64d-1f3fe-200d-2640-fe0f","uc_match":"1f64d-1f3fe-2640-fe0f","uc_greedy":"1f64d-1f3fe-2640","shortnames":[":woman_frowning_medium_dark_skin_tone:"],"category":"people"},":woman_frowning_tone5:":{"uc_base":"1f64d-1f3ff-2640","uc_output":"1f64d-1f3ff-200d-2640-fe0f","uc_match":"1f64d-1f3ff-2640-fe0f","uc_greedy":"1f64d-1f3ff-2640","shortnames":[":woman_frowning_dark_skin_tone:"],"category":"people"},":woman_gesturing_no_tone1:":{"uc_base":"1f645-1f3fb-2640","uc_output":"1f645-1f3fb-200d-2640-fe0f","uc_match":"1f645-1f3fb-2640-fe0f","uc_greedy":"1f645-1f3fb-2640","shortnames":[":woman_gesturing_no_light_skin_tone:"],"category":"people"},":woman_gesturing_no_tone2:":{"uc_base":"1f645-1f3fc-2640","uc_output":"1f645-1f3fc-200d-2640-fe0f","uc_match":"1f645-1f3fc-2640-fe0f","uc_greedy":"1f645-1f3fc-2640","shortnames":[":woman_gesturing_no_medium_light_skin_tone:"],"category":"people"},":woman_gesturing_no_tone3:":{"uc_base":"1f645-1f3fd-2640","uc_output":"1f645-1f3fd-200d-2640-fe0f","uc_match":"1f645-1f3fd-2640-fe0f","uc_greedy":"1f645-1f3fd-2640","shortnames":[":woman_gesturing_no_medium_skin_tone:"],"category":"people"},":woman_gesturing_no_tone4:":{"uc_base":"1f645-1f3fe-2640","uc_output":"1f645-1f3fe-200d-2640-fe0f","uc_match":"1f645-1f3fe-2640-fe0f","uc_greedy":"1f645-1f3fe-2640","shortnames":[":woman_gesturing_no_medium_dark_skin_tone:"],"category":"people"},":woman_gesturing_no_tone5:":{"uc_base":"1f645-1f3ff-2640","uc_output":"1f645-1f3ff-200d-2640-fe0f","uc_match":"1f645-1f3ff-2640-fe0f","uc_greedy":"1f645-1f3ff-2640","shortnames":[":woman_gesturing_no_dark_skin_tone:"],"category":"people"},":woman_gesturing_ok_tone1:":{"uc_base":"1f646-1f3fb-2640","uc_output":"1f646-1f3fb-200d-2640-fe0f","uc_match":"1f646-1f3fb-2640-fe0f","uc_greedy":"1f646-1f3fb-2640","shortnames":[":woman_gesturing_ok_light_skin_tone:"],"category":"people"},":woman_gesturing_ok_tone2:":{"uc_base":"1f646-1f3fc-2640","uc_output":"1f646-1f3fc-200d-2640-fe0f","uc_match":"1f646-1f3fc-2640-fe0f","uc_greedy":"1f646-1f3fc-2640","shortnames":[":woman_gesturing_ok_medium_light_skin_tone:"],"category":"people"},":woman_gesturing_ok_tone3:":{"uc_base":"1f646-1f3fd-2640","uc_output":"1f646-1f3fd-200d-2640-fe0f","uc_match":"1f646-1f3fd-2640-fe0f","uc_greedy":"1f646-1f3fd-2640","shortnames":[":woman_gesturing_ok_medium_skin_tone:"],"category":"people"},":woman_gesturing_ok_tone4:":{"uc_base":"1f646-1f3fe-2640","uc_output":"1f646-1f3fe-200d-2640-fe0f","uc_match":"1f646-1f3fe-2640-fe0f","uc_greedy":"1f646-1f3fe-2640","shortnames":[":woman_gesturing_ok_medium_dark_skin_tone:"],"category":"people"},":woman_gesturing_ok_tone5:":{"uc_base":"1f646-1f3ff-2640","uc_output":"1f646-1f3ff-200d-2640-fe0f","uc_match":"1f646-1f3ff-2640-fe0f","uc_greedy":"1f646-1f3ff-2640","shortnames":[":woman_gesturing_ok_dark_skin_tone:"],"category":"people"},":woman_getting_face_massage_tone1:":{"uc_base":"1f486-1f3fb-2640","uc_output":"1f486-1f3fb-200d-2640-fe0f","uc_match":"1f486-1f3fb-2640-fe0f","uc_greedy":"1f486-1f3fb-2640","shortnames":[":woman_getting_face_massage_light_skin_tone:"],"category":"people"},":woman_getting_face_massage_tone2:":{"uc_base":"1f486-1f3fc-2640","uc_output":"1f486-1f3fc-200d-2640-fe0f","uc_match":"1f486-1f3fc-2640-fe0f","uc_greedy":"1f486-1f3fc-2640","shortnames":[":woman_getting_face_massage_medium_light_skin_tone:"],"category":"people"},":woman_getting_face_massage_tone3:":{"uc_base":"1f486-1f3fd-2640","uc_output":"1f486-1f3fd-200d-2640-fe0f","uc_match":"1f486-1f3fd-2640-fe0f","uc_greedy":"1f486-1f3fd-2640","shortnames":[":woman_getting_face_massage_medium_skin_tone:"],"category":"people"},":woman_getting_face_massage_tone4:":{"uc_base":"1f486-1f3fe-2640","uc_output":"1f486-1f3fe-200d-2640-fe0f","uc_match":"1f486-1f3fe-2640-fe0f","uc_greedy":"1f486-1f3fe-2640","shortnames":[":woman_getting_face_massage_medium_dark_skin_tone:"],"category":"people"},":woman_getting_face_massage_tone5:":{"uc_base":"1f486-1f3ff-2640","uc_output":"1f486-1f3ff-200d-2640-fe0f","uc_match":"1f486-1f3ff-2640-fe0f","uc_greedy":"1f486-1f3ff-2640","shortnames":[":woman_getting_face_massage_dark_skin_tone:"],"category":"people"},":woman_getting_haircut_tone1:":{"uc_base":"1f487-1f3fb-2640","uc_output":"1f487-1f3fb-200d-2640-fe0f","uc_match":"1f487-1f3fb-2640-fe0f","uc_greedy":"1f487-1f3fb-2640","shortnames":[":woman_getting_haircut_light_skin_tone:"],"category":"people"},":woman_getting_haircut_tone2:":{"uc_base":"1f487-1f3fc-2640","uc_output":"1f487-1f3fc-200d-2640-fe0f","uc_match":"1f487-1f3fc-2640-fe0f","uc_greedy":"1f487-1f3fc-2640","shortnames":[":woman_getting_haircut_medium_light_skin_tone:"],"category":"people"},":woman_getting_haircut_tone3:":{"uc_base":"1f487-1f3fd-2640","uc_output":"1f487-1f3fd-200d-2640-fe0f","uc_match":"1f487-1f3fd-2640-fe0f","uc_greedy":"1f487-1f3fd-2640","shortnames":[":woman_getting_haircut_medium_skin_tone:"],"category":"people"},":woman_getting_haircut_tone4:":{"uc_base":"1f487-1f3fe-2640","uc_output":"1f487-1f3fe-200d-2640-fe0f","uc_match":"1f487-1f3fe-2640-fe0f","uc_greedy":"1f487-1f3fe-2640","shortnames":[":woman_getting_haircut_medium_dark_skin_tone:"],"category":"people"},":woman_getting_haircut_tone5:":{"uc_base":"1f487-1f3ff-2640","uc_output":"1f487-1f3ff-200d-2640-fe0f","uc_match":"1f487-1f3ff-2640-fe0f","uc_greedy":"1f487-1f3ff-2640","shortnames":[":woman_getting_haircut_dark_skin_tone:"],"category":"people"},":woman_golfing_tone1:":{"uc_base":"1f3cc-1f3fb-2640","uc_output":"1f3cc-1f3fb-200d-2640-fe0f","uc_match":"1f3cc-fe0f-1f3fb-2640-fe0f","uc_greedy":"1f3cc-1f3fb-2640","shortnames":[":woman_golfing_light_skin_tone:"],"category":"activity"},":woman_golfing_tone2:":{"uc_base":"1f3cc-1f3fc-2640","uc_output":"1f3cc-1f3fc-200d-2640-fe0f","uc_match":"1f3cc-fe0f-1f3fc-2640-fe0f","uc_greedy":"1f3cc-1f3fc-2640","shortnames":[":woman_golfing_medium_light_skin_tone:"],"category":"activity"},":woman_golfing_tone3:":{"uc_base":"1f3cc-1f3fd-2640","uc_output":"1f3cc-1f3fd-200d-2640-fe0f","uc_match":"1f3cc-fe0f-1f3fd-2640-fe0f","uc_greedy":"1f3cc-1f3fd-2640","shortnames":[":woman_golfing_medium_skin_tone:"],"category":"activity"},":woman_golfing_tone4:":{"uc_base":"1f3cc-1f3fe-2640","uc_output":"1f3cc-1f3fe-200d-2640-fe0f","uc_match":"1f3cc-fe0f-1f3fe-2640-fe0f","uc_greedy":"1f3cc-1f3fe-2640","shortnames":[":woman_golfing_medium_dark_skin_tone:"],"category":"activity"},":woman_golfing_tone5:":{"uc_base":"1f3cc-1f3ff-2640","uc_output":"1f3cc-1f3ff-200d-2640-fe0f","uc_match":"1f3cc-fe0f-1f3ff-2640-fe0f","uc_greedy":"1f3cc-1f3ff-2640","shortnames":[":woman_golfing_dark_skin_tone:"],"category":"activity"},":woman_guard_tone1:":{"uc_base":"1f482-1f3fb-2640","uc_output":"1f482-1f3fb-200d-2640-fe0f","uc_match":"1f482-1f3fb-2640-fe0f","uc_greedy":"1f482-1f3fb-2640","shortnames":[":woman_guard_light_skin_tone:"],"category":"people"},":woman_guard_tone2:":{"uc_base":"1f482-1f3fc-2640","uc_output":"1f482-1f3fc-200d-2640-fe0f","uc_match":"1f482-1f3fc-2640-fe0f","uc_greedy":"1f482-1f3fc-2640","shortnames":[":woman_guard_medium_light_skin_tone:"],"category":"people"},":woman_guard_tone3:":{"uc_base":"1f482-1f3fd-2640","uc_output":"1f482-1f3fd-200d-2640-fe0f","uc_match":"1f482-1f3fd-2640-fe0f","uc_greedy":"1f482-1f3fd-2640","shortnames":[":woman_guard_medium_skin_tone:"],"category":"people"},":woman_guard_tone4:":{"uc_base":"1f482-1f3fe-2640","uc_output":"1f482-1f3fe-200d-2640-fe0f","uc_match":"1f482-1f3fe-2640-fe0f","uc_greedy":"1f482-1f3fe-2640","shortnames":[":woman_guard_medium_dark_skin_tone:"],"category":"people"},":woman_guard_tone5:":{"uc_base":"1f482-1f3ff-2640","uc_output":"1f482-1f3ff-200d-2640-fe0f","uc_match":"1f482-1f3ff-2640-fe0f","uc_greedy":"1f482-1f3ff-2640","shortnames":[":woman_guard_dark_skin_tone:"],"category":"people"},":woman_health_worker_tone1:":{"uc_base":"1f469-1f3fb-2695","uc_output":"1f469-1f3fb-200d-2695-fe0f","uc_match":"1f469-1f3fb-2695-fe0f","uc_greedy":"1f469-1f3fb-2695","shortnames":[":woman_health_worker_light_skin_tone:"],"category":"people"},":woman_health_worker_tone2:":{"uc_base":"1f469-1f3fc-2695","uc_output":"1f469-1f3fc-200d-2695-fe0f","uc_match":"1f469-1f3fc-2695-fe0f","uc_greedy":"1f469-1f3fc-2695","shortnames":[":woman_health_worker_medium_light_skin_tone:"],"category":"people"},":woman_health_worker_tone3:":{"uc_base":"1f469-1f3fd-2695","uc_output":"1f469-1f3fd-200d-2695-fe0f","uc_match":"1f469-1f3fd-2695-fe0f","uc_greedy":"1f469-1f3fd-2695","shortnames":[":woman_health_worker_medium_skin_tone:"],"category":"people"},":woman_health_worker_tone4:":{"uc_base":"1f469-1f3fe-2695","uc_output":"1f469-1f3fe-200d-2695-fe0f","uc_match":"1f469-1f3fe-2695-fe0f","uc_greedy":"1f469-1f3fe-2695","shortnames":[":woman_health_worker_medium_dark_skin_tone:"],"category":"people"},":woman_health_worker_tone5:":{"uc_base":"1f469-1f3ff-2695","uc_output":"1f469-1f3ff-200d-2695-fe0f","uc_match":"1f469-1f3ff-2695-fe0f","uc_greedy":"1f469-1f3ff-2695","shortnames":[":woman_health_worker_dark_skin_tone:"],"category":"people"},":woman_in_lotus_position_tone1:":{"uc_base":"1f9d8-1f3fb-2640","uc_output":"1f9d8-1f3fb-200d-2640-fe0f","uc_match":"1f9d8-1f3fb-2640-fe0f","uc_greedy":"1f9d8-1f3fb-2640","shortnames":[":woman_in_lotus_position_light_skin_tone:"],"category":"activity"},":woman_in_lotus_position_tone2:":{"uc_base":"1f9d8-1f3fc-2640","uc_output":"1f9d8-1f3fc-200d-2640-fe0f","uc_match":"1f9d8-1f3fc-2640-fe0f","uc_greedy":"1f9d8-1f3fc-2640","shortnames":[":woman_in_lotus_position_medium_light_skin_tone:"],"category":"activity"},":woman_in_lotus_position_tone3:":{"uc_base":"1f9d8-1f3fd-2640","uc_output":"1f9d8-1f3fd-200d-2640-fe0f","uc_match":"1f9d8-1f3fd-2640-fe0f","uc_greedy":"1f9d8-1f3fd-2640","shortnames":[":woman_in_lotus_position_medium_skin_tone:"],"category":"activity"},":woman_in_lotus_position_tone4:":{"uc_base":"1f9d8-1f3fe-2640","uc_output":"1f9d8-1f3fe-200d-2640-fe0f","uc_match":"1f9d8-1f3fe-2640-fe0f","uc_greedy":"1f9d8-1f3fe-2640","shortnames":[":woman_in_lotus_position_medium_dark_skin_tone:"],"category":"activity"},":woman_in_lotus_position_tone5:":{"uc_base":"1f9d8-1f3ff-2640","uc_output":"1f9d8-1f3ff-200d-2640-fe0f","uc_match":"1f9d8-1f3ff-2640-fe0f","uc_greedy":"1f9d8-1f3ff-2640","shortnames":[":woman_in_lotus_position_dark_skin_tone:"],"category":"activity"},":woman_in_steamy_room_tone1:":{"uc_base":"1f9d6-1f3fb-2640","uc_output":"1f9d6-1f3fb-200d-2640-fe0f","uc_match":"1f9d6-1f3fb-2640-fe0f","uc_greedy":"1f9d6-1f3fb-2640","shortnames":[":woman_in_steamy_room_light_skin_tone:"],"category":"people"},":woman_in_steamy_room_tone2:":{"uc_base":"1f9d6-1f3fc-2640","uc_output":"1f9d6-1f3fc-200d-2640-fe0f","uc_match":"1f9d6-1f3fc-2640-fe0f","uc_greedy":"1f9d6-1f3fc-2640","shortnames":[":woman_in_steamy_room_medium_light_skin_tone:"],"category":"people"},":woman_in_steamy_room_tone3:":{"uc_base":"1f9d6-1f3fd-2640","uc_output":"1f9d6-1f3fd-200d-2640-fe0f","uc_match":"1f9d6-1f3fd-2640-fe0f","uc_greedy":"1f9d6-1f3fd-2640","shortnames":[":woman_in_steamy_room_medium_skin_tone:"],"category":"people"},":woman_in_steamy_room_tone4:":{"uc_base":"1f9d6-1f3fe-2640","uc_output":"1f9d6-1f3fe-200d-2640-fe0f","uc_match":"1f9d6-1f3fe-2640-fe0f","uc_greedy":"1f9d6-1f3fe-2640","shortnames":[":woman_in_steamy_room_medium_dark_skin_tone:"],"category":"people"},":woman_in_steamy_room_tone5:":{"uc_base":"1f9d6-1f3ff-2640","uc_output":"1f9d6-1f3ff-200d-2640-fe0f","uc_match":"1f9d6-1f3ff-2640-fe0f","uc_greedy":"1f9d6-1f3ff-2640","shortnames":[":woman_in_steamy_room_dark_skin_tone:"],"category":"people"},":woman_judge_tone1:":{"uc_base":"1f469-1f3fb-2696","uc_output":"1f469-1f3fb-200d-2696-fe0f","uc_match":"1f469-1f3fb-2696-fe0f","uc_greedy":"1f469-1f3fb-2696","shortnames":[":woman_judge_light_skin_tone:"],"category":"people"},":woman_judge_tone2:":{"uc_base":"1f469-1f3fc-2696","uc_output":"1f469-1f3fc-200d-2696-fe0f","uc_match":"1f469-1f3fc-2696-fe0f","uc_greedy":"1f469-1f3fc-2696","shortnames":[":woman_judge_medium_light_skin_tone:"],"category":"people"},":woman_judge_tone3:":{"uc_base":"1f469-1f3fd-2696","uc_output":"1f469-1f3fd-200d-2696-fe0f","uc_match":"1f469-1f3fd-2696-fe0f","uc_greedy":"1f469-1f3fd-2696","shortnames":[":woman_judge_medium_skin_tone:"],"category":"people"},":woman_judge_tone4:":{"uc_base":"1f469-1f3fe-2696","uc_output":"1f469-1f3fe-200d-2696-fe0f","uc_match":"1f469-1f3fe-2696-fe0f","uc_greedy":"1f469-1f3fe-2696","shortnames":[":woman_judge_medium_dark_skin_tone:"],"category":"people"},":woman_judge_tone5:":{"uc_base":"1f469-1f3ff-2696","uc_output":"1f469-1f3ff-200d-2696-fe0f","uc_match":"1f469-1f3ff-2696-fe0f","uc_greedy":"1f469-1f3ff-2696","shortnames":[":woman_judge_dark_skin_tone:"],"category":"people"},":woman_juggling_tone1:":{"uc_base":"1f939-1f3fb-2640","uc_output":"1f939-1f3fb-200d-2640-fe0f","uc_match":"1f939-1f3fb-2640-fe0f","uc_greedy":"1f939-1f3fb-2640","shortnames":[":woman_juggling_light_skin_tone:"],"category":"activity"},":woman_juggling_tone2:":{"uc_base":"1f939-1f3fc-2640","uc_output":"1f939-1f3fc-200d-2640-fe0f","uc_match":"1f939-1f3fc-2640-fe0f","uc_greedy":"1f939-1f3fc-2640","shortnames":[":woman_juggling_medium_light_skin_tone:"],"category":"activity"},":woman_juggling_tone3:":{"uc_base":"1f939-1f3fd-2640","uc_output":"1f939-1f3fd-200d-2640-fe0f","uc_match":"1f939-1f3fd-2640-fe0f","uc_greedy":"1f939-1f3fd-2640","shortnames":[":woman_juggling_medium_skin_tone:"],"category":"activity"},":woman_juggling_tone4:":{"uc_base":"1f939-1f3fe-2640","uc_output":"1f939-1f3fe-200d-2640-fe0f","uc_match":"1f939-1f3fe-2640-fe0f","uc_greedy":"1f939-1f3fe-2640","shortnames":[":woman_juggling_medium_dark_skin_tone:"],"category":"activity"},":woman_juggling_tone5:":{"uc_base":"1f939-1f3ff-2640","uc_output":"1f939-1f3ff-200d-2640-fe0f","uc_match":"1f939-1f3ff-2640-fe0f","uc_greedy":"1f939-1f3ff-2640","shortnames":[":woman_juggling_dark_skin_tone:"],"category":"activity"},":woman_lifting_weights_tone1:":{"uc_base":"1f3cb-1f3fb-2640","uc_output":"1f3cb-1f3fb-200d-2640-fe0f","uc_match":"1f3cb-fe0f-1f3fb-2640-fe0f","uc_greedy":"1f3cb-1f3fb-2640","shortnames":[":woman_lifting_weights_light_skin_tone:"],"category":"activity"},":woman_lifting_weights_tone2:":{"uc_base":"1f3cb-1f3fc-2640","uc_output":"1f3cb-1f3fc-200d-2640-fe0f","uc_match":"1f3cb-fe0f-1f3fc-2640-fe0f","uc_greedy":"1f3cb-1f3fc-2640","shortnames":[":woman_lifting_weights_medium_light_skin_tone:"],"category":"activity"},":woman_lifting_weights_tone3:":{"uc_base":"1f3cb-1f3fd-2640","uc_output":"1f3cb-1f3fd-200d-2640-fe0f","uc_match":"1f3cb-fe0f-1f3fd-2640-fe0f","uc_greedy":"1f3cb-1f3fd-2640","shortnames":[":woman_lifting_weights_medium_skin_tone:"],"category":"activity"},":woman_lifting_weights_tone4:":{"uc_base":"1f3cb-1f3fe-2640","uc_output":"1f3cb-1f3fe-200d-2640-fe0f","uc_match":"1f3cb-fe0f-1f3fe-2640-fe0f","uc_greedy":"1f3cb-1f3fe-2640","shortnames":[":woman_lifting_weights_medium_dark_skin_tone:"],"category":"activity"},":woman_lifting_weights_tone5:":{"uc_base":"1f3cb-1f3ff-2640","uc_output":"1f3cb-1f3ff-200d-2640-fe0f","uc_match":"1f3cb-fe0f-1f3ff-2640-fe0f","uc_greedy":"1f3cb-1f3ff-2640","shortnames":[":woman_lifting_weights_dark_skin_tone:"],"category":"activity"},":woman_mage_tone1:":{"uc_base":"1f9d9-1f3fb-2640","uc_output":"1f9d9-1f3fb-200d-2640-fe0f","uc_match":"1f9d9-1f3fb-2640-fe0f","uc_greedy":"1f9d9-1f3fb-2640","shortnames":[":woman_mage_light_skin_tone:"],"category":"people"},":woman_mage_tone2:":{"uc_base":"1f9d9-1f3fc-2640","uc_output":"1f9d9-1f3fc-200d-2640-fe0f","uc_match":"1f9d9-1f3fc-2640-fe0f","uc_greedy":"1f9d9-1f3fc-2640","shortnames":[":woman_mage_medium_light_skin_tone:"],"category":"people"},":woman_mage_tone3:":{"uc_base":"1f9d9-1f3fd-2640","uc_output":"1f9d9-1f3fd-200d-2640-fe0f","uc_match":"1f9d9-1f3fd-2640-fe0f","uc_greedy":"1f9d9-1f3fd-2640","shortnames":[":woman_mage_medium_skin_tone:"],"category":"people"},":woman_mage_tone4:":{"uc_base":"1f9d9-1f3fe-2640","uc_output":"1f9d9-1f3fe-200d-2640-fe0f","uc_match":"1f9d9-1f3fe-2640-fe0f","uc_greedy":"1f9d9-1f3fe-2640","shortnames":[":woman_mage_medium_dark_skin_tone:"],"category":"people"},":woman_mage_tone5:":{"uc_base":"1f9d9-1f3ff-2640","uc_output":"1f9d9-1f3ff-200d-2640-fe0f","uc_match":"1f9d9-1f3ff-2640-fe0f","uc_greedy":"1f9d9-1f3ff-2640","shortnames":[":woman_mage_dark_skin_tone:"],"category":"people"},":woman_mountain_biking_tone1:":{"uc_base":"1f6b5-1f3fb-2640","uc_output":"1f6b5-1f3fb-200d-2640-fe0f","uc_match":"1f6b5-1f3fb-2640-fe0f","uc_greedy":"1f6b5-1f3fb-2640","shortnames":[":woman_mountain_biking_light_skin_tone:"],"category":"activity"},":woman_mountain_biking_tone2:":{"uc_base":"1f6b5-1f3fc-2640","uc_output":"1f6b5-1f3fc-200d-2640-fe0f","uc_match":"1f6b5-1f3fc-2640-fe0f","uc_greedy":"1f6b5-1f3fc-2640","shortnames":[":woman_mountain_biking_medium_light_skin_tone:"],"category":"activity"},":woman_mountain_biking_tone3:":{"uc_base":"1f6b5-1f3fd-2640","uc_output":"1f6b5-1f3fd-200d-2640-fe0f","uc_match":"1f6b5-1f3fd-2640-fe0f","uc_greedy":"1f6b5-1f3fd-2640","shortnames":[":woman_mountain_biking_medium_skin_tone:"],"category":"activity"},":woman_mountain_biking_tone4:":{"uc_base":"1f6b5-1f3fe-2640","uc_output":"1f6b5-1f3fe-200d-2640-fe0f","uc_match":"1f6b5-1f3fe-2640-fe0f","uc_greedy":"1f6b5-1f3fe-2640","shortnames":[":woman_mountain_biking_medium_dark_skin_tone:"],"category":"activity"},":woman_mountain_biking_tone5:":{"uc_base":"1f6b5-1f3ff-2640","uc_output":"1f6b5-1f3ff-200d-2640-fe0f","uc_match":"1f6b5-1f3ff-2640-fe0f","uc_greedy":"1f6b5-1f3ff-2640","shortnames":[":woman_mountain_biking_dark_skin_tone:"],"category":"activity"},":woman_pilot_tone1:":{"uc_base":"1f469-1f3fb-2708","uc_output":"1f469-1f3fb-200d-2708-fe0f","uc_match":"1f469-1f3fb-2708-fe0f","uc_greedy":"1f469-1f3fb-2708","shortnames":[":woman_pilot_light_skin_tone:"],"category":"people"},":woman_pilot_tone2:":{"uc_base":"1f469-1f3fc-2708","uc_output":"1f469-1f3fc-200d-2708-fe0f","uc_match":"1f469-1f3fc-2708-fe0f","uc_greedy":"1f469-1f3fc-2708","shortnames":[":woman_pilot_medium_light_skin_tone:"],"category":"people"},":woman_pilot_tone3:":{"uc_base":"1f469-1f3fd-2708","uc_output":"1f469-1f3fd-200d-2708-fe0f","uc_match":"1f469-1f3fd-2708-fe0f","uc_greedy":"1f469-1f3fd-2708","shortnames":[":woman_pilot_medium_skin_tone:"],"category":"people"},":woman_pilot_tone4:":{"uc_base":"1f469-1f3fe-2708","uc_output":"1f469-1f3fe-200d-2708-fe0f","uc_match":"1f469-1f3fe-2708-fe0f","uc_greedy":"1f469-1f3fe-2708","shortnames":[":woman_pilot_medium_dark_skin_tone:"],"category":"people"},":woman_pilot_tone5:":{"uc_base":"1f469-1f3ff-2708","uc_output":"1f469-1f3ff-200d-2708-fe0f","uc_match":"1f469-1f3ff-2708-fe0f","uc_greedy":"1f469-1f3ff-2708","shortnames":[":woman_pilot_dark_skin_tone:"],"category":"people"},":woman_playing_handball_tone1:":{"uc_base":"1f93e-1f3fb-2640","uc_output":"1f93e-1f3fb-200d-2640-fe0f","uc_match":"1f93e-1f3fb-2640-fe0f","uc_greedy":"1f93e-1f3fb-2640","shortnames":[":woman_playing_handball_light_skin_tone:"],"category":"activity"},":woman_playing_handball_tone2:":{"uc_base":"1f93e-1f3fc-2640","uc_output":"1f93e-1f3fc-200d-2640-fe0f","uc_match":"1f93e-1f3fc-2640-fe0f","uc_greedy":"1f93e-1f3fc-2640","shortnames":[":woman_playing_handball_medium_light_skin_tone:"],"category":"activity"},":woman_playing_handball_tone3:":{"uc_base":"1f93e-1f3fd-2640","uc_output":"1f93e-1f3fd-200d-2640-fe0f","uc_match":"1f93e-1f3fd-2640-fe0f","uc_greedy":"1f93e-1f3fd-2640","shortnames":[":woman_playing_handball_medium_skin_tone:"],"category":"activity"},":woman_playing_handball_tone4:":{"uc_base":"1f93e-1f3fe-2640","uc_output":"1f93e-1f3fe-200d-2640-fe0f","uc_match":"1f93e-1f3fe-2640-fe0f","uc_greedy":"1f93e-1f3fe-2640","shortnames":[":woman_playing_handball_medium_dark_skin_tone:"],"category":"activity"},":woman_playing_handball_tone5:":{"uc_base":"1f93e-1f3ff-2640","uc_output":"1f93e-1f3ff-200d-2640-fe0f","uc_match":"1f93e-1f3ff-2640-fe0f","uc_greedy":"1f93e-1f3ff-2640","shortnames":[":woman_playing_handball_dark_skin_tone:"],"category":"activity"},":woman_playing_water_polo_tone1:":{"uc_base":"1f93d-1f3fb-2640","uc_output":"1f93d-1f3fb-200d-2640-fe0f","uc_match":"1f93d-1f3fb-2640-fe0f","uc_greedy":"1f93d-1f3fb-2640","shortnames":[":woman_playing_water_polo_light_skin_tone:"],"category":"activity"},":woman_playing_water_polo_tone2:":{"uc_base":"1f93d-1f3fc-2640","uc_output":"1f93d-1f3fc-200d-2640-fe0f","uc_match":"1f93d-1f3fc-2640-fe0f","uc_greedy":"1f93d-1f3fc-2640","shortnames":[":woman_playing_water_polo_medium_light_skin_tone:"],"category":"activity"},":woman_playing_water_polo_tone3:":{"uc_base":"1f93d-1f3fd-2640","uc_output":"1f93d-1f3fd-200d-2640-fe0f","uc_match":"1f93d-1f3fd-2640-fe0f","uc_greedy":"1f93d-1f3fd-2640","shortnames":[":woman_playing_water_polo_medium_skin_tone:"],"category":"activity"},":woman_playing_water_polo_tone4:":{"uc_base":"1f93d-1f3fe-2640","uc_output":"1f93d-1f3fe-200d-2640-fe0f","uc_match":"1f93d-1f3fe-2640-fe0f","uc_greedy":"1f93d-1f3fe-2640","shortnames":[":woman_playing_water_polo_medium_dark_skin_tone:"],"category":"activity"},":woman_playing_water_polo_tone5:":{"uc_base":"1f93d-1f3ff-2640","uc_output":"1f93d-1f3ff-200d-2640-fe0f","uc_match":"1f93d-1f3ff-2640-fe0f","uc_greedy":"1f93d-1f3ff-2640","shortnames":[":woman_playing_water_polo_dark_skin_tone:"],"category":"activity"},":woman_police_officer_tone1:":{"uc_base":"1f46e-1f3fb-2640","uc_output":"1f46e-1f3fb-200d-2640-fe0f","uc_match":"1f46e-1f3fb-2640-fe0f","uc_greedy":"1f46e-1f3fb-2640","shortnames":[":woman_police_officer_light_skin_tone:"],"category":"people"},":woman_police_officer_tone2:":{"uc_base":"1f46e-1f3fc-2640","uc_output":"1f46e-1f3fc-200d-2640-fe0f","uc_match":"1f46e-1f3fc-2640-fe0f","uc_greedy":"1f46e-1f3fc-2640","shortnames":[":woman_police_officer_medium_light_skin_tone:"],"category":"people"},":woman_police_officer_tone3:":{"uc_base":"1f46e-1f3fd-2640","uc_output":"1f46e-1f3fd-200d-2640-fe0f","uc_match":"1f46e-1f3fd-2640-fe0f","uc_greedy":"1f46e-1f3fd-2640","shortnames":[":woman_police_officer_medium_skin_tone:"],"category":"people"},":woman_police_officer_tone4:":{"uc_base":"1f46e-1f3fe-2640","uc_output":"1f46e-1f3fe-200d-2640-fe0f","uc_match":"1f46e-1f3fe-2640-fe0f","uc_greedy":"1f46e-1f3fe-2640","shortnames":[":woman_police_officer_medium_dark_skin_tone:"],"category":"people"},":woman_police_officer_tone5:":{"uc_base":"1f46e-1f3ff-2640","uc_output":"1f46e-1f3ff-200d-2640-fe0f","uc_match":"1f46e-1f3ff-2640-fe0f","uc_greedy":"1f46e-1f3ff-2640","shortnames":[":woman_police_officer_dark_skin_tone:"],"category":"people"},":woman_pouting_tone1:":{"uc_base":"1f64e-1f3fb-2640","uc_output":"1f64e-1f3fb-200d-2640-fe0f","uc_match":"1f64e-1f3fb-2640-fe0f","uc_greedy":"1f64e-1f3fb-2640","shortnames":[":woman_pouting_light_skin_tone:"],"category":"people"},":woman_pouting_tone2:":{"uc_base":"1f64e-1f3fc-2640","uc_output":"1f64e-1f3fc-200d-2640-fe0f","uc_match":"1f64e-1f3fc-2640-fe0f","uc_greedy":"1f64e-1f3fc-2640","shortnames":[":woman_pouting_medium_light_skin_tone:"],"category":"people"},":woman_pouting_tone3:":{"uc_base":"1f64e-1f3fd-2640","uc_output":"1f64e-1f3fd-200d-2640-fe0f","uc_match":"1f64e-1f3fd-2640-fe0f","uc_greedy":"1f64e-1f3fd-2640","shortnames":[":woman_pouting_medium_skin_tone:"],"category":"people"},":woman_pouting_tone4:":{"uc_base":"1f64e-1f3fe-2640","uc_output":"1f64e-1f3fe-200d-2640-fe0f","uc_match":"1f64e-1f3fe-2640-fe0f","uc_greedy":"1f64e-1f3fe-2640","shortnames":[":woman_pouting_medium_dark_skin_tone:"],"category":"people"},":woman_pouting_tone5:":{"uc_base":"1f64e-1f3ff-2640","uc_output":"1f64e-1f3ff-200d-2640-fe0f","uc_match":"1f64e-1f3ff-2640-fe0f","uc_greedy":"1f64e-1f3ff-2640","shortnames":[":woman_pouting_dark_skin_tone:"],"category":"people"},":woman_raising_hand_tone1:":{"uc_base":"1f64b-1f3fb-2640","uc_output":"1f64b-1f3fb-200d-2640-fe0f","uc_match":"1f64b-1f3fb-2640-fe0f","uc_greedy":"1f64b-1f3fb-2640","shortnames":[":woman_raising_hand_light_skin_tone:"],"category":"people"},":woman_raising_hand_tone2:":{"uc_base":"1f64b-1f3fc-2640","uc_output":"1f64b-1f3fc-200d-2640-fe0f","uc_match":"1f64b-1f3fc-2640-fe0f","uc_greedy":"1f64b-1f3fc-2640","shortnames":[":woman_raising_hand_medium_light_skin_tone:"],"category":"people"},":woman_raising_hand_tone3:":{"uc_base":"1f64b-1f3fd-2640","uc_output":"1f64b-1f3fd-200d-2640-fe0f","uc_match":"1f64b-1f3fd-2640-fe0f","uc_greedy":"1f64b-1f3fd-2640","shortnames":[":woman_raising_hand_medium_skin_tone:"],"category":"people"},":woman_raising_hand_tone4:":{"uc_base":"1f64b-1f3fe-2640","uc_output":"1f64b-1f3fe-200d-2640-fe0f","uc_match":"1f64b-1f3fe-2640-fe0f","uc_greedy":"1f64b-1f3fe-2640","shortnames":[":woman_raising_hand_medium_dark_skin_tone:"],"category":"people"},":woman_raising_hand_tone5:":{"uc_base":"1f64b-1f3ff-2640","uc_output":"1f64b-1f3ff-200d-2640-fe0f","uc_match":"1f64b-1f3ff-2640-fe0f","uc_greedy":"1f64b-1f3ff-2640","shortnames":[":woman_raising_hand_dark_skin_tone:"],"category":"people"},":woman_rowing_boat_tone1:":{"uc_base":"1f6a3-1f3fb-2640","uc_output":"1f6a3-1f3fb-200d-2640-fe0f","uc_match":"1f6a3-1f3fb-2640-fe0f","uc_greedy":"1f6a3-1f3fb-2640","shortnames":[":woman_rowing_boat_light_skin_tone:"],"category":"activity"},":woman_rowing_boat_tone2:":{"uc_base":"1f6a3-1f3fc-2640","uc_output":"1f6a3-1f3fc-200d-2640-fe0f","uc_match":"1f6a3-1f3fc-2640-fe0f","uc_greedy":"1f6a3-1f3fc-2640","shortnames":[":woman_rowing_boat_medium_light_skin_tone:"],"category":"activity"},":woman_rowing_boat_tone3:":{"uc_base":"1f6a3-1f3fd-2640","uc_output":"1f6a3-1f3fd-200d-2640-fe0f","uc_match":"1f6a3-1f3fd-2640-fe0f","uc_greedy":"1f6a3-1f3fd-2640","shortnames":[":woman_rowing_boat_medium_skin_tone:"],"category":"activity"},":woman_rowing_boat_tone4:":{"uc_base":"1f6a3-1f3fe-2640","uc_output":"1f6a3-1f3fe-200d-2640-fe0f","uc_match":"1f6a3-1f3fe-2640-fe0f","uc_greedy":"1f6a3-1f3fe-2640","shortnames":[":woman_rowing_boat_medium_dark_skin_tone:"],"category":"activity"},":woman_rowing_boat_tone5:":{"uc_base":"1f6a3-1f3ff-2640","uc_output":"1f6a3-1f3ff-200d-2640-fe0f","uc_match":"1f6a3-1f3ff-2640-fe0f","uc_greedy":"1f6a3-1f3ff-2640","shortnames":[":woman_rowing_boat_dark_skin_tone:"],"category":"activity"},":woman_running_tone1:":{"uc_base":"1f3c3-1f3fb-2640","uc_output":"1f3c3-1f3fb-200d-2640-fe0f","uc_match":"1f3c3-1f3fb-2640-fe0f","uc_greedy":"1f3c3-1f3fb-2640","shortnames":[":woman_running_light_skin_tone:"],"category":"people"},":woman_running_tone2:":{"uc_base":"1f3c3-1f3fc-2640","uc_output":"1f3c3-1f3fc-200d-2640-fe0f","uc_match":"1f3c3-1f3fc-2640-fe0f","uc_greedy":"1f3c3-1f3fc-2640","shortnames":[":woman_running_medium_light_skin_tone:"],"category":"people"},":woman_running_tone3:":{"uc_base":"1f3c3-1f3fd-2640","uc_output":"1f3c3-1f3fd-200d-2640-fe0f","uc_match":"1f3c3-1f3fd-2640-fe0f","uc_greedy":"1f3c3-1f3fd-2640","shortnames":[":woman_running_medium_skin_tone:"],"category":"people"},":woman_running_tone4:":{"uc_base":"1f3c3-1f3fe-2640","uc_output":"1f3c3-1f3fe-200d-2640-fe0f","uc_match":"1f3c3-1f3fe-2640-fe0f","uc_greedy":"1f3c3-1f3fe-2640","shortnames":[":woman_running_medium_dark_skin_tone:"],"category":"people"},":woman_running_tone5:":{"uc_base":"1f3c3-1f3ff-2640","uc_output":"1f3c3-1f3ff-200d-2640-fe0f","uc_match":"1f3c3-1f3ff-2640-fe0f","uc_greedy":"1f3c3-1f3ff-2640","shortnames":[":woman_running_dark_skin_tone:"],"category":"people"},":woman_shrugging_tone1:":{"uc_base":"1f937-1f3fb-2640","uc_output":"1f937-1f3fb-200d-2640-fe0f","uc_match":"1f937-1f3fb-2640-fe0f","uc_greedy":"1f937-1f3fb-2640","shortnames":[":woman_shrugging_light_skin_tone:"],"category":"people"},":woman_shrugging_tone2:":{"uc_base":"1f937-1f3fc-2640","uc_output":"1f937-1f3fc-200d-2640-fe0f","uc_match":"1f937-1f3fc-2640-fe0f","uc_greedy":"1f937-1f3fc-2640","shortnames":[":woman_shrugging_medium_light_skin_tone:"],"category":"people"},":woman_shrugging_tone3:":{"uc_base":"1f937-1f3fd-2640","uc_output":"1f937-1f3fd-200d-2640-fe0f","uc_match":"1f937-1f3fd-2640-fe0f","uc_greedy":"1f937-1f3fd-2640","shortnames":[":woman_shrugging_medium_skin_tone:"],"category":"people"},":woman_shrugging_tone4:":{"uc_base":"1f937-1f3fe-2640","uc_output":"1f937-1f3fe-200d-2640-fe0f","uc_match":"1f937-1f3fe-2640-fe0f","uc_greedy":"1f937-1f3fe-2640","shortnames":[":woman_shrugging_medium_dark_skin_tone:"],"category":"people"},":woman_shrugging_tone5:":{"uc_base":"1f937-1f3ff-2640","uc_output":"1f937-1f3ff-200d-2640-fe0f","uc_match":"1f937-1f3ff-2640-fe0f","uc_greedy":"1f937-1f3ff-2640","shortnames":[":woman_shrugging_dark_skin_tone:"],"category":"people"},":woman_superhero_tone1:":{"uc_base":"1f9b8-1f3fb-2640","uc_output":"1f9b8-1f3fb-200d-2640-fe0f","uc_match":"1f9b8-1f3fb-2640-fe0f","uc_greedy":"1f9b8-1f3fb-2640","shortnames":[":woman_superhero_light_skin_tone:"],"category":"people"},":woman_superhero_tone2:":{"uc_base":"1f9b8-1f3fc-2640","uc_output":"1f9b8-1f3fc-200d-2640-fe0f","uc_match":"1f9b8-1f3fc-2640-fe0f","uc_greedy":"1f9b8-1f3fc-2640","shortnames":[":woman_superhero_medium_light_skin_tone:"],"category":"people"},":woman_superhero_tone3:":{"uc_base":"1f9b8-1f3fd-2640","uc_output":"1f9b8-1f3fd-200d-2640-fe0f","uc_match":"1f9b8-1f3fd-2640-fe0f","uc_greedy":"1f9b8-1f3fd-2640","shortnames":[":woman_superhero_medium_skin_tone:"],"category":"people"},":woman_superhero_tone4:":{"uc_base":"1f9b8-1f3fe-2640","uc_output":"1f9b8-1f3fe-200d-2640-fe0f","uc_match":"1f9b8-1f3fe-2640-fe0f","uc_greedy":"1f9b8-1f3fe-2640","shortnames":[":woman_superhero_medium_dark_skin_tone:"],"category":"people"},":woman_superhero_tone5:":{"uc_base":"1f9b8-1f3ff-2640","uc_output":"1f9b8-1f3ff-200d-2640-fe0f","uc_match":"1f9b8-1f3ff-2640-fe0f","uc_greedy":"1f9b8-1f3ff-2640","shortnames":[":woman_superhero_dark_skin_tone:"],"category":"people"},":woman_supervillain_tone1:":{"uc_base":"1f9b9-1f3fb-2640","uc_output":"1f9b9-1f3fb-200d-2640-fe0f","uc_match":"1f9b9-1f3fb-2640-fe0f","uc_greedy":"1f9b9-1f3fb-2640","shortnames":[":woman_supervillain_light_skin_tone:"],"category":"people"},":woman_supervillain_tone2:":{"uc_base":"1f9b9-1f3fc-2640","uc_output":"1f9b9-1f3fc-200d-2640-fe0f","uc_match":"1f9b9-1f3fc-2640-fe0f","uc_greedy":"1f9b9-1f3fc-2640","shortnames":[":woman_supervillain_medium_light_skin_tone:"],"category":"people"},":woman_supervillain_tone3:":{"uc_base":"1f9b9-1f3fd-2640","uc_output":"1f9b9-1f3fd-200d-2640-fe0f","uc_match":"1f9b9-1f3fd-2640-fe0f","uc_greedy":"1f9b9-1f3fd-2640","shortnames":[":woman_supervillain_medium_skin_tone:"],"category":"people"},":woman_supervillain_tone4:":{"uc_base":"1f9b9-1f3fe-2640","uc_output":"1f9b9-1f3fe-200d-2640-fe0f","uc_match":"1f9b9-1f3fe-2640-fe0f","uc_greedy":"1f9b9-1f3fe-2640","shortnames":[":woman_supervillain_medium_dark_skin_tone:"],"category":"people"},":woman_supervillain_tone5:":{"uc_base":"1f9b9-1f3ff-2640","uc_output":"1f9b9-1f3ff-200d-2640-fe0f","uc_match":"1f9b9-1f3ff-2640-fe0f","uc_greedy":"1f9b9-1f3ff-2640","shortnames":[":woman_supervillain_dark_skin_tone:"],"category":"people"},":woman_surfing_tone1:":{"uc_base":"1f3c4-1f3fb-2640","uc_output":"1f3c4-1f3fb-200d-2640-fe0f","uc_match":"1f3c4-1f3fb-2640-fe0f","uc_greedy":"1f3c4-1f3fb-2640","shortnames":[":woman_surfing_light_skin_tone:"],"category":"activity"},":woman_surfing_tone2:":{"uc_base":"1f3c4-1f3fc-2640","uc_output":"1f3c4-1f3fc-200d-2640-fe0f","uc_match":"1f3c4-1f3fc-2640-fe0f","uc_greedy":"1f3c4-1f3fc-2640","shortnames":[":woman_surfing_medium_light_skin_tone:"],"category":"activity"},":woman_surfing_tone3:":{"uc_base":"1f3c4-1f3fd-2640","uc_output":"1f3c4-1f3fd-200d-2640-fe0f","uc_match":"1f3c4-1f3fd-2640-fe0f","uc_greedy":"1f3c4-1f3fd-2640","shortnames":[":woman_surfing_medium_skin_tone:"],"category":"activity"},":woman_surfing_tone4:":{"uc_base":"1f3c4-1f3fe-2640","uc_output":"1f3c4-1f3fe-200d-2640-fe0f","uc_match":"1f3c4-1f3fe-2640-fe0f","uc_greedy":"1f3c4-1f3fe-2640","shortnames":[":woman_surfing_medium_dark_skin_tone:"],"category":"activity"},":woman_surfing_tone5:":{"uc_base":"1f3c4-1f3ff-2640","uc_output":"1f3c4-1f3ff-200d-2640-fe0f","uc_match":"1f3c4-1f3ff-2640-fe0f","uc_greedy":"1f3c4-1f3ff-2640","shortnames":[":woman_surfing_dark_skin_tone:"],"category":"activity"},":woman_swimming_tone1:":{"uc_base":"1f3ca-1f3fb-2640","uc_output":"1f3ca-1f3fb-200d-2640-fe0f","uc_match":"1f3ca-1f3fb-2640-fe0f","uc_greedy":"1f3ca-1f3fb-2640","shortnames":[":woman_swimming_light_skin_tone:"],"category":"activity"},":woman_swimming_tone2:":{"uc_base":"1f3ca-1f3fc-2640","uc_output":"1f3ca-1f3fc-200d-2640-fe0f","uc_match":"1f3ca-1f3fc-2640-fe0f","uc_greedy":"1f3ca-1f3fc-2640","shortnames":[":woman_swimming_medium_light_skin_tone:"],"category":"activity"},":woman_swimming_tone3:":{"uc_base":"1f3ca-1f3fd-2640","uc_output":"1f3ca-1f3fd-200d-2640-fe0f","uc_match":"1f3ca-1f3fd-2640-fe0f","uc_greedy":"1f3ca-1f3fd-2640","shortnames":[":woman_swimming_medium_skin_tone:"],"category":"activity"},":woman_swimming_tone4:":{"uc_base":"1f3ca-1f3fe-2640","uc_output":"1f3ca-1f3fe-200d-2640-fe0f","uc_match":"1f3ca-1f3fe-2640-fe0f","uc_greedy":"1f3ca-1f3fe-2640","shortnames":[":woman_swimming_medium_dark_skin_tone:"],"category":"activity"},":woman_swimming_tone5:":{"uc_base":"1f3ca-1f3ff-2640","uc_output":"1f3ca-1f3ff-200d-2640-fe0f","uc_match":"1f3ca-1f3ff-2640-fe0f","uc_greedy":"1f3ca-1f3ff-2640","shortnames":[":woman_swimming_dark_skin_tone:"],"category":"activity"},":woman_tipping_hand_tone1:":{"uc_base":"1f481-1f3fb-2640","uc_output":"1f481-1f3fb-200d-2640-fe0f","uc_match":"1f481-1f3fb-2640-fe0f","uc_greedy":"1f481-1f3fb-2640","shortnames":[":woman_tipping_hand_light_skin_tone:"],"category":"people"},":woman_tipping_hand_tone2:":{"uc_base":"1f481-1f3fc-2640","uc_output":"1f481-1f3fc-200d-2640-fe0f","uc_match":"1f481-1f3fc-2640-fe0f","uc_greedy":"1f481-1f3fc-2640","shortnames":[":woman_tipping_hand_medium_light_skin_tone:"],"category":"people"},":woman_tipping_hand_tone3:":{"uc_base":"1f481-1f3fd-2640","uc_output":"1f481-1f3fd-200d-2640-fe0f","uc_match":"1f481-1f3fd-2640-fe0f","uc_greedy":"1f481-1f3fd-2640","shortnames":[":woman_tipping_hand_medium_skin_tone:"],"category":"people"},":woman_tipping_hand_tone4:":{"uc_base":"1f481-1f3fe-2640","uc_output":"1f481-1f3fe-200d-2640-fe0f","uc_match":"1f481-1f3fe-2640-fe0f","uc_greedy":"1f481-1f3fe-2640","shortnames":[":woman_tipping_hand_medium_dark_skin_tone:"],"category":"people"},":woman_tipping_hand_tone5:":{"uc_base":"1f481-1f3ff-2640","uc_output":"1f481-1f3ff-200d-2640-fe0f","uc_match":"1f481-1f3ff-2640-fe0f","uc_greedy":"1f481-1f3ff-2640","shortnames":[":woman_tipping_hand_dark_skin_tone:"],"category":"people"},":woman_vampire_tone1:":{"uc_base":"1f9db-1f3fb-2640","uc_output":"1f9db-1f3fb-200d-2640-fe0f","uc_match":"1f9db-1f3fb-2640-fe0f","uc_greedy":"1f9db-1f3fb-2640","shortnames":[":woman_vampire_light_skin_tone:"],"category":"people"},":woman_vampire_tone2:":{"uc_base":"1f9db-1f3fc-2640","uc_output":"1f9db-1f3fc-200d-2640-fe0f","uc_match":"1f9db-1f3fc-2640-fe0f","uc_greedy":"1f9db-1f3fc-2640","shortnames":[":woman_vampire_medium_light_skin_tone:"],"category":"people"},":woman_vampire_tone3:":{"uc_base":"1f9db-1f3fd-2640","uc_output":"1f9db-1f3fd-200d-2640-fe0f","uc_match":"1f9db-1f3fd-2640-fe0f","uc_greedy":"1f9db-1f3fd-2640","shortnames":[":woman_vampire_medium_skin_tone:"],"category":"people"},":woman_vampire_tone4:":{"uc_base":"1f9db-1f3fe-2640","uc_output":"1f9db-1f3fe-200d-2640-fe0f","uc_match":"1f9db-1f3fe-2640-fe0f","uc_greedy":"1f9db-1f3fe-2640","shortnames":[":woman_vampire_medium_dark_skin_tone:"],"category":"people"},":woman_vampire_tone5:":{"uc_base":"1f9db-1f3ff-2640","uc_output":"1f9db-1f3ff-200d-2640-fe0f","uc_match":"1f9db-1f3ff-2640-fe0f","uc_greedy":"1f9db-1f3ff-2640","shortnames":[":woman_vampire_dark_skin_tone:"],"category":"people"},":woman_walking_tone1:":{"uc_base":"1f6b6-1f3fb-2640","uc_output":"1f6b6-1f3fb-200d-2640-fe0f","uc_match":"1f6b6-1f3fb-2640-fe0f","uc_greedy":"1f6b6-1f3fb-2640","shortnames":[":woman_walking_light_skin_tone:"],"category":"people"},":woman_walking_tone2:":{"uc_base":"1f6b6-1f3fc-2640","uc_output":"1f6b6-1f3fc-200d-2640-fe0f","uc_match":"1f6b6-1f3fc-2640-fe0f","uc_greedy":"1f6b6-1f3fc-2640","shortnames":[":woman_walking_medium_light_skin_tone:"],"category":"people"},":woman_walking_tone3:":{"uc_base":"1f6b6-1f3fd-2640","uc_output":"1f6b6-1f3fd-200d-2640-fe0f","uc_match":"1f6b6-1f3fd-2640-fe0f","uc_greedy":"1f6b6-1f3fd-2640","shortnames":[":woman_walking_medium_skin_tone:"],"category":"people"},":woman_walking_tone4:":{"uc_base":"1f6b6-1f3fe-2640","uc_output":"1f6b6-1f3fe-200d-2640-fe0f","uc_match":"1f6b6-1f3fe-2640-fe0f","uc_greedy":"1f6b6-1f3fe-2640","shortnames":[":woman_walking_medium_dark_skin_tone:"],"category":"people"},":woman_walking_tone5:":{"uc_base":"1f6b6-1f3ff-2640","uc_output":"1f6b6-1f3ff-200d-2640-fe0f","uc_match":"1f6b6-1f3ff-2640-fe0f","uc_greedy":"1f6b6-1f3ff-2640","shortnames":[":woman_walking_dark_skin_tone:"],"category":"people"},":woman_wearing_turban_tone1:":{"uc_base":"1f473-1f3fb-2640","uc_output":"1f473-1f3fb-200d-2640-fe0f","uc_match":"1f473-1f3fb-2640-fe0f","uc_greedy":"1f473-1f3fb-2640","shortnames":[":woman_wearing_turban_light_skin_tone:"],"category":"people"},":woman_wearing_turban_tone2:":{"uc_base":"1f473-1f3fc-2640","uc_output":"1f473-1f3fc-200d-2640-fe0f","uc_match":"1f473-1f3fc-2640-fe0f","uc_greedy":"1f473-1f3fc-2640","shortnames":[":woman_wearing_turban_medium_light_skin_tone:"],"category":"people"},":woman_wearing_turban_tone3:":{"uc_base":"1f473-1f3fd-2640","uc_output":"1f473-1f3fd-200d-2640-fe0f","uc_match":"1f473-1f3fd-2640-fe0f","uc_greedy":"1f473-1f3fd-2640","shortnames":[":woman_wearing_turban_medium_skin_tone:"],"category":"people"},":woman_wearing_turban_tone4:":{"uc_base":"1f473-1f3fe-2640","uc_output":"1f473-1f3fe-200d-2640-fe0f","uc_match":"1f473-1f3fe-2640-fe0f","uc_greedy":"1f473-1f3fe-2640","shortnames":[":woman_wearing_turban_medium_dark_skin_tone:"],"category":"people"},":woman_wearing_turban_tone5:":{"uc_base":"1f473-1f3ff-2640","uc_output":"1f473-1f3ff-200d-2640-fe0f","uc_match":"1f473-1f3ff-2640-fe0f","uc_greedy":"1f473-1f3ff-2640","shortnames":[":woman_wearing_turban_dark_skin_tone:"],"category":"people"},":man_bouncing_ball_tone1:":{"uc_base":"26f9-1f3fb-2642","uc_output":"26f9-1f3fb-200d-2642-fe0f","uc_match":"26f9-fe0f-1f3fb-2642-fe0f","uc_greedy":"26f9-1f3fb-2642","shortnames":[":man_bouncing_ball_light_skin_tone:"],"category":"activity"},":man_bouncing_ball_tone2:":{"uc_base":"26f9-1f3fc-2642","uc_output":"26f9-1f3fc-200d-2642-fe0f","uc_match":"26f9-fe0f-1f3fc-2642-fe0f","uc_greedy":"26f9-1f3fc-2642","shortnames":[":man_bouncing_ball_medium_light_skin_tone:"],"category":"activity"},":man_bouncing_ball_tone3:":{"uc_base":"26f9-1f3fd-2642","uc_output":"26f9-1f3fd-200d-2642-fe0f","uc_match":"26f9-fe0f-1f3fd-2642-fe0f","uc_greedy":"26f9-1f3fd-2642","shortnames":[":man_bouncing_ball_medium_skin_tone:"],"category":"activity"},":man_bouncing_ball_tone4:":{"uc_base":"26f9-1f3fe-2642","uc_output":"26f9-1f3fe-200d-2642-fe0f","uc_match":"26f9-fe0f-1f3fe-2642-fe0f","uc_greedy":"26f9-1f3fe-2642","shortnames":[":man_bouncing_ball_medium_dark_skin_tone:"],"category":"activity"},":man_bouncing_ball_tone5:":{"uc_base":"26f9-1f3ff-2642","uc_output":"26f9-1f3ff-200d-2642-fe0f","uc_match":"26f9-fe0f-1f3ff-2642-fe0f","uc_greedy":"26f9-1f3ff-2642","shortnames":[":man_bouncing_ball_dark_skin_tone:"],"category":"activity"},":man_detective:":{"uc_base":"1f575-2642","uc_output":"1f575-fe0f-200d-2642-fe0f","uc_match":"1f575-fe0f-200d-2642","uc_greedy":"1f575-2642","shortnames":[],"category":"people"},":man_golfing:":{"uc_base":"1f3cc-2642","uc_output":"1f3cc-fe0f-200d-2642-fe0f","uc_match":"1f3cc-fe0f-200d-2642","uc_greedy":"1f3cc-2642","shortnames":[],"category":"activity"},":man_lifting_weights:":{"uc_base":"1f3cb-2642","uc_output":"1f3cb-fe0f-200d-2642-fe0f","uc_match":"1f3cb-fe0f-200d-2642","uc_greedy":"1f3cb-2642","shortnames":[],"category":"activity"},":woman_bouncing_ball_tone1:":{"uc_base":"26f9-1f3fb-2640","uc_output":"26f9-1f3fb-200d-2640-fe0f","uc_match":"26f9-fe0f-1f3fb-2640-fe0f","uc_greedy":"26f9-1f3fb-2640","shortnames":[":woman_bouncing_ball_light_skin_tone:"],"category":"activity"},":woman_bouncing_ball_tone2:":{"uc_base":"26f9-1f3fc-2640","uc_output":"26f9-1f3fc-200d-2640-fe0f","uc_match":"26f9-fe0f-1f3fc-2640-fe0f","uc_greedy":"26f9-1f3fc-2640","shortnames":[":woman_bouncing_ball_medium_light_skin_tone:"],"category":"activity"},":woman_bouncing_ball_tone3:":{"uc_base":"26f9-1f3fd-2640","uc_output":"26f9-1f3fd-200d-2640-fe0f","uc_match":"26f9-fe0f-1f3fd-2640-fe0f","uc_greedy":"26f9-1f3fd-2640","shortnames":[":woman_bouncing_ball_medium_skin_tone:"],"category":"activity"},":woman_bouncing_ball_tone4:":{"uc_base":"26f9-1f3fe-2640","uc_output":"26f9-1f3fe-200d-2640-fe0f","uc_match":"26f9-fe0f-1f3fe-2640-fe0f","uc_greedy":"26f9-1f3fe-2640","shortnames":[":woman_bouncing_ball_medium_dark_skin_tone:"],"category":"activity"},":woman_bouncing_ball_tone5:":{"uc_base":"26f9-1f3ff-2640","uc_output":"26f9-1f3ff-200d-2640-fe0f","uc_match":"26f9-fe0f-1f3ff-2640-fe0f","uc_greedy":"26f9-1f3ff-2640","shortnames":[":woman_bouncing_ball_dark_skin_tone:"],"category":"activity"},":woman_detective:":{"uc_base":"1f575-2640","uc_output":"1f575-fe0f-200d-2640-fe0f","uc_match":"1f575-fe0f-200d-2640","uc_greedy":"1f575-2640","shortnames":[],"category":"people"},":woman_golfing:":{"uc_base":"1f3cc-2640","uc_output":"1f3cc-fe0f-200d-2640-fe0f","uc_match":"1f3cc-fe0f-200d-2640","uc_greedy":"1f3cc-2640","shortnames":[],"category":"activity"},":woman_lifting_weights:":{"uc_base":"1f3cb-2640","uc_output":"1f3cb-fe0f-200d-2640-fe0f","uc_match":"1f3cb-fe0f-200d-2640","uc_greedy":"1f3cb-2640","shortnames":[],"category":"activity"},":man_bouncing_ball:":{"uc_base":"26f9-2642","uc_output":"26f9-fe0f-200d-2642-fe0f","uc_match":"26f9-fe0f-200d-2642","uc_greedy":"26f9-2642","shortnames":[],"category":"activity"},":woman_bouncing_ball:":{"uc_base":"26f9-2640","uc_output":"26f9-fe0f-200d-2640-fe0f","uc_match":"26f9-fe0f-200d-2640","uc_greedy":"26f9-2640","shortnames":[],"category":"activity"},":man_artist_tone1:":{"uc_base":"1f468-1f3fb-1f3a8","uc_output":"1f468-1f3fb-200d-1f3a8","uc_match":"1f468-1f3fb-1f3a8","uc_greedy":"1f468-1f3fb-1f3a8","shortnames":[":man_artist_light_skin_tone:"],"category":"people"},":man_artist_tone2:":{"uc_base":"1f468-1f3fc-1f3a8","uc_output":"1f468-1f3fc-200d-1f3a8","uc_match":"1f468-1f3fc-1f3a8","uc_greedy":"1f468-1f3fc-1f3a8","shortnames":[":man_artist_medium_light_skin_tone:"],"category":"people"},":man_artist_tone3:":{"uc_base":"1f468-1f3fd-1f3a8","uc_output":"1f468-1f3fd-200d-1f3a8","uc_match":"1f468-1f3fd-1f3a8","uc_greedy":"1f468-1f3fd-1f3a8","shortnames":[":man_artist_medium_skin_tone:"],"category":"people"},":man_artist_tone4:":{"uc_base":"1f468-1f3fe-1f3a8","uc_output":"1f468-1f3fe-200d-1f3a8","uc_match":"1f468-1f3fe-1f3a8","uc_greedy":"1f468-1f3fe-1f3a8","shortnames":[":man_artist_medium_dark_skin_tone:"],"category":"people"},":man_artist_tone5:":{"uc_base":"1f468-1f3ff-1f3a8","uc_output":"1f468-1f3ff-200d-1f3a8","uc_match":"1f468-1f3ff-1f3a8","uc_greedy":"1f468-1f3ff-1f3a8","shortnames":[":man_artist_dark_skin_tone:"],"category":"people"},":man_astronaut_tone1:":{"uc_base":"1f468-1f3fb-1f680","uc_output":"1f468-1f3fb-200d-1f680","uc_match":"1f468-1f3fb-1f680","uc_greedy":"1f468-1f3fb-1f680","shortnames":[":man_astronaut_light_skin_tone:"],"category":"people"},":man_astronaut_tone2:":{"uc_base":"1f468-1f3fc-1f680","uc_output":"1f468-1f3fc-200d-1f680","uc_match":"1f468-1f3fc-1f680","uc_greedy":"1f468-1f3fc-1f680","shortnames":[":man_astronaut_medium_light_skin_tone:"],"category":"people"},":man_astronaut_tone3:":{"uc_base":"1f468-1f3fd-1f680","uc_output":"1f468-1f3fd-200d-1f680","uc_match":"1f468-1f3fd-1f680","uc_greedy":"1f468-1f3fd-1f680","shortnames":[":man_astronaut_medium_skin_tone:"],"category":"people"},":man_astronaut_tone4:":{"uc_base":"1f468-1f3fe-1f680","uc_output":"1f468-1f3fe-200d-1f680","uc_match":"1f468-1f3fe-1f680","uc_greedy":"1f468-1f3fe-1f680","shortnames":[":man_astronaut_medium_dark_skin_tone:"],"category":"people"},":man_astronaut_tone5:":{"uc_base":"1f468-1f3ff-1f680","uc_output":"1f468-1f3ff-200d-1f680","uc_match":"1f468-1f3ff-1f680","uc_greedy":"1f468-1f3ff-1f680","shortnames":[":man_astronaut_dark_skin_tone:"],"category":"people"},":man_bald_tone1:":{"uc_base":"1f468-1f3fb-1f9b2","uc_output":"1f468-1f3fb-200d-1f9b2","uc_match":"1f468-1f3fb-1f9b2","uc_greedy":"1f468-1f3fb-1f9b2","shortnames":[":man_bald_light_skin_tone:"],"category":"people"},":man_bald_tone2:":{"uc_base":"1f468-1f3fc-1f9b2","uc_output":"1f468-1f3fc-200d-1f9b2","uc_match":"1f468-1f3fc-1f9b2","uc_greedy":"1f468-1f3fc-1f9b2","shortnames":[":man_bald_medium_light_skin_tone:"],"category":"people"},":man_bald_tone3:":{"uc_base":"1f468-1f3fd-1f9b2","uc_output":"1f468-1f3fd-200d-1f9b2","uc_match":"1f468-1f3fd-1f9b2","uc_greedy":"1f468-1f3fd-1f9b2","shortnames":[":man_bald_medium_skin_tone:"],"category":"people"},":man_bald_tone4:":{"uc_base":"1f468-1f3fe-1f9b2","uc_output":"1f468-1f3fe-200d-1f9b2","uc_match":"1f468-1f3fe-1f9b2","uc_greedy":"1f468-1f3fe-1f9b2","shortnames":[":man_bald_medium_dark_skin_tone:"],"category":"people"},":man_bald_tone5:":{"uc_base":"1f468-1f3ff-1f9b2","uc_output":"1f468-1f3ff-200d-1f9b2","uc_match":"1f468-1f3ff-1f9b2","uc_greedy":"1f468-1f3ff-1f9b2","shortnames":[":man_bald_dark_skin_tone:"],"category":"people"},":man_cook_tone1:":{"uc_base":"1f468-1f3fb-1f373","uc_output":"1f468-1f3fb-200d-1f373","uc_match":"1f468-1f3fb-1f373","uc_greedy":"1f468-1f3fb-1f373","shortnames":[":man_cook_light_skin_tone:"],"category":"people"},":man_cook_tone2:":{"uc_base":"1f468-1f3fc-1f373","uc_output":"1f468-1f3fc-200d-1f373","uc_match":"1f468-1f3fc-1f373","uc_greedy":"1f468-1f3fc-1f373","shortnames":[":man_cook_medium_light_skin_tone:"],"category":"people"},":man_cook_tone3:":{"uc_base":"1f468-1f3fd-1f373","uc_output":"1f468-1f3fd-200d-1f373","uc_match":"1f468-1f3fd-1f373","uc_greedy":"1f468-1f3fd-1f373","shortnames":[":man_cook_medium_skin_tone:"],"category":"people"},":man_cook_tone4:":{"uc_base":"1f468-1f3fe-1f373","uc_output":"1f468-1f3fe-200d-1f373","uc_match":"1f468-1f3fe-1f373","uc_greedy":"1f468-1f3fe-1f373","shortnames":[":man_cook_medium_dark_skin_tone:"],"category":"people"},":man_cook_tone5:":{"uc_base":"1f468-1f3ff-1f373","uc_output":"1f468-1f3ff-200d-1f373","uc_match":"1f468-1f3ff-1f373","uc_greedy":"1f468-1f3ff-1f373","shortnames":[":man_cook_dark_skin_tone:"],"category":"people"},":man_curly_haired_tone1:":{"uc_base":"1f468-1f3fb-1f9b1","uc_output":"1f468-1f3fb-200d-1f9b1","uc_match":"1f468-1f3fb-1f9b1","uc_greedy":"1f468-1f3fb-1f9b1","shortnames":[":man_curly_haired_light_skin_tone:"],"category":"people"},":man_curly_haired_tone2:":{"uc_base":"1f468-1f3fc-1f9b1","uc_output":"1f468-1f3fc-200d-1f9b1","uc_match":"1f468-1f3fc-1f9b1","uc_greedy":"1f468-1f3fc-1f9b1","shortnames":[":man_curly_haired_medium_light_skin_tone:"],"category":"people"},":man_curly_haired_tone3:":{"uc_base":"1f468-1f3fd-1f9b1","uc_output":"1f468-1f3fd-200d-1f9b1","uc_match":"1f468-1f3fd-1f9b1","uc_greedy":"1f468-1f3fd-1f9b1","shortnames":[":man_curly_haired_medium_skin_tone:"],"category":"people"},":man_curly_haired_tone4:":{"uc_base":"1f468-1f3fe-1f9b1","uc_output":"1f468-1f3fe-200d-1f9b1","uc_match":"1f468-1f3fe-1f9b1","uc_greedy":"1f468-1f3fe-1f9b1","shortnames":[":man_curly_haired_medium_dark_skin_tone:"],"category":"people"},":man_curly_haired_tone5:":{"uc_base":"1f468-1f3ff-1f9b1","uc_output":"1f468-1f3ff-200d-1f9b1","uc_match":"1f468-1f3ff-1f9b1","uc_greedy":"1f468-1f3ff-1f9b1","shortnames":[":man_curly_haired_dark_skin_tone:"],"category":"people"},":man_factory_worker_tone1:":{"uc_base":"1f468-1f3fb-1f3ed","uc_output":"1f468-1f3fb-200d-1f3ed","uc_match":"1f468-1f3fb-1f3ed","uc_greedy":"1f468-1f3fb-1f3ed","shortnames":[":man_factory_worker_light_skin_tone:"],"category":"people"},":man_factory_worker_tone2:":{"uc_base":"1f468-1f3fc-1f3ed","uc_output":"1f468-1f3fc-200d-1f3ed","uc_match":"1f468-1f3fc-1f3ed","uc_greedy":"1f468-1f3fc-1f3ed","shortnames":[":man_factory_worker_medium_light_skin_tone:"],"category":"people"},":man_factory_worker_tone3:":{"uc_base":"1f468-1f3fd-1f3ed","uc_output":"1f468-1f3fd-200d-1f3ed","uc_match":"1f468-1f3fd-1f3ed","uc_greedy":"1f468-1f3fd-1f3ed","shortnames":[":man_factory_worker_medium_skin_tone:"],"category":"people"},":man_factory_worker_tone4:":{"uc_base":"1f468-1f3fe-1f3ed","uc_output":"1f468-1f3fe-200d-1f3ed","uc_match":"1f468-1f3fe-1f3ed","uc_greedy":"1f468-1f3fe-1f3ed","shortnames":[":man_factory_worker_medium_dark_skin_tone:"],"category":"people"},":man_factory_worker_tone5:":{"uc_base":"1f468-1f3ff-1f3ed","uc_output":"1f468-1f3ff-200d-1f3ed","uc_match":"1f468-1f3ff-1f3ed","uc_greedy":"1f468-1f3ff-1f3ed","shortnames":[":man_factory_worker_dark_skin_tone:"],"category":"people"},":man_farmer_tone1:":{"uc_base":"1f468-1f3fb-1f33e","uc_output":"1f468-1f3fb-200d-1f33e","uc_match":"1f468-1f3fb-1f33e","uc_greedy":"1f468-1f3fb-1f33e","shortnames":[":man_farmer_light_skin_tone:"],"category":"people"},":man_farmer_tone2:":{"uc_base":"1f468-1f3fc-1f33e","uc_output":"1f468-1f3fc-200d-1f33e","uc_match":"1f468-1f3fc-1f33e","uc_greedy":"1f468-1f3fc-1f33e","shortnames":[":man_farmer_medium_light_skin_tone:"],"category":"people"},":man_farmer_tone3:":{"uc_base":"1f468-1f3fd-1f33e","uc_output":"1f468-1f3fd-200d-1f33e","uc_match":"1f468-1f3fd-1f33e","uc_greedy":"1f468-1f3fd-1f33e","shortnames":[":man_farmer_medium_skin_tone:"],"category":"people"},":man_farmer_tone4:":{"uc_base":"1f468-1f3fe-1f33e","uc_output":"1f468-1f3fe-200d-1f33e","uc_match":"1f468-1f3fe-1f33e","uc_greedy":"1f468-1f3fe-1f33e","shortnames":[":man_farmer_medium_dark_skin_tone:"],"category":"people"},":man_farmer_tone5:":{"uc_base":"1f468-1f3ff-1f33e","uc_output":"1f468-1f3ff-200d-1f33e","uc_match":"1f468-1f3ff-1f33e","uc_greedy":"1f468-1f3ff-1f33e","shortnames":[":man_farmer_dark_skin_tone:"],"category":"people"},":man_firefighter_tone1:":{"uc_base":"1f468-1f3fb-1f692","uc_output":"1f468-1f3fb-200d-1f692","uc_match":"1f468-1f3fb-1f692","uc_greedy":"1f468-1f3fb-1f692","shortnames":[":man_firefighter_light_skin_tone:"],"category":"people"},":man_firefighter_tone2:":{"uc_base":"1f468-1f3fc-1f692","uc_output":"1f468-1f3fc-200d-1f692","uc_match":"1f468-1f3fc-1f692","uc_greedy":"1f468-1f3fc-1f692","shortnames":[":man_firefighter_medium_light_skin_tone:"],"category":"people"},":man_firefighter_tone3:":{"uc_base":"1f468-1f3fd-1f692","uc_output":"1f468-1f3fd-200d-1f692","uc_match":"1f468-1f3fd-1f692","uc_greedy":"1f468-1f3fd-1f692","shortnames":[":man_firefighter_medium_skin_tone:"],"category":"people"},":man_firefighter_tone4:":{"uc_base":"1f468-1f3fe-1f692","uc_output":"1f468-1f3fe-200d-1f692","uc_match":"1f468-1f3fe-1f692","uc_greedy":"1f468-1f3fe-1f692","shortnames":[":man_firefighter_medium_dark_skin_tone:"],"category":"people"},":man_firefighter_tone5:":{"uc_base":"1f468-1f3ff-1f692","uc_output":"1f468-1f3ff-200d-1f692","uc_match":"1f468-1f3ff-1f692","uc_greedy":"1f468-1f3ff-1f692","shortnames":[":man_firefighter_dark_skin_tone:"],"category":"people"},":man_mechanic_tone1:":{"uc_base":"1f468-1f3fb-1f527","uc_output":"1f468-1f3fb-200d-1f527","uc_match":"1f468-1f3fb-1f527","uc_greedy":"1f468-1f3fb-1f527","shortnames":[":man_mechanic_light_skin_tone:"],"category":"people"},":man_mechanic_tone2:":{"uc_base":"1f468-1f3fc-1f527","uc_output":"1f468-1f3fc-200d-1f527","uc_match":"1f468-1f3fc-1f527","uc_greedy":"1f468-1f3fc-1f527","shortnames":[":man_mechanic_medium_light_skin_tone:"],"category":"people"},":man_mechanic_tone3:":{"uc_base":"1f468-1f3fd-1f527","uc_output":"1f468-1f3fd-200d-1f527","uc_match":"1f468-1f3fd-1f527","uc_greedy":"1f468-1f3fd-1f527","shortnames":[":man_mechanic_medium_skin_tone:"],"category":"people"},":man_mechanic_tone4:":{"uc_base":"1f468-1f3fe-1f527","uc_output":"1f468-1f3fe-200d-1f527","uc_match":"1f468-1f3fe-1f527","uc_greedy":"1f468-1f3fe-1f527","shortnames":[":man_mechanic_medium_dark_skin_tone:"],"category":"people"},":man_mechanic_tone5:":{"uc_base":"1f468-1f3ff-1f527","uc_output":"1f468-1f3ff-200d-1f527","uc_match":"1f468-1f3ff-1f527","uc_greedy":"1f468-1f3ff-1f527","shortnames":[":man_mechanic_dark_skin_tone:"],"category":"people"},":man_office_worker_tone1:":{"uc_base":"1f468-1f3fb-1f4bc","uc_output":"1f468-1f3fb-200d-1f4bc","uc_match":"1f468-1f3fb-1f4bc","uc_greedy":"1f468-1f3fb-1f4bc","shortnames":[":man_office_worker_light_skin_tone:"],"category":"people"},":man_office_worker_tone2:":{"uc_base":"1f468-1f3fc-1f4bc","uc_output":"1f468-1f3fc-200d-1f4bc","uc_match":"1f468-1f3fc-1f4bc","uc_greedy":"1f468-1f3fc-1f4bc","shortnames":[":man_office_worker_medium_light_skin_tone:"],"category":"people"},":man_office_worker_tone3:":{"uc_base":"1f468-1f3fd-1f4bc","uc_output":"1f468-1f3fd-200d-1f4bc","uc_match":"1f468-1f3fd-1f4bc","uc_greedy":"1f468-1f3fd-1f4bc","shortnames":[":man_office_worker_medium_skin_tone:"],"category":"people"},":man_office_worker_tone4:":{"uc_base":"1f468-1f3fe-1f4bc","uc_output":"1f468-1f3fe-200d-1f4bc","uc_match":"1f468-1f3fe-1f4bc","uc_greedy":"1f468-1f3fe-1f4bc","shortnames":[":man_office_worker_medium_dark_skin_tone:"],"category":"people"},":man_office_worker_tone5:":{"uc_base":"1f468-1f3ff-1f4bc","uc_output":"1f468-1f3ff-200d-1f4bc","uc_match":"1f468-1f3ff-1f4bc","uc_greedy":"1f468-1f3ff-1f4bc","shortnames":[":man_office_worker_dark_skin_tone:"],"category":"people"},":man_red_haired_tone1:":{"uc_base":"1f468-1f3fb-1f9b0","uc_output":"1f468-1f3fb-200d-1f9b0","uc_match":"1f468-1f3fb-1f9b0","uc_greedy":"1f468-1f3fb-1f9b0","shortnames":[":man_red_haired_light_skin_tone:"],"category":"people"},":man_red_haired_tone2:":{"uc_base":"1f468-1f3fc-1f9b0","uc_output":"1f468-1f3fc-200d-1f9b0","uc_match":"1f468-1f3fc-1f9b0","uc_greedy":"1f468-1f3fc-1f9b0","shortnames":[":man_red_haired_medium_light_skin_tone:"],"category":"people"},":man_red_haired_tone3:":{"uc_base":"1f468-1f3fd-1f9b0","uc_output":"1f468-1f3fd-200d-1f9b0","uc_match":"1f468-1f3fd-1f9b0","uc_greedy":"1f468-1f3fd-1f9b0","shortnames":[":man_red_haired_medium_skin_tone:"],"category":"people"},":man_red_haired_tone4:":{"uc_base":"1f468-1f3fe-1f9b0","uc_output":"1f468-1f3fe-200d-1f9b0","uc_match":"1f468-1f3fe-1f9b0","uc_greedy":"1f468-1f3fe-1f9b0","shortnames":[":man_red_haired_medium_dark_skin_tone:"],"category":"people"},":man_red_haired_tone5:":{"uc_base":"1f468-1f3ff-1f9b0","uc_output":"1f468-1f3ff-200d-1f9b0","uc_match":"1f468-1f3ff-1f9b0","uc_greedy":"1f468-1f3ff-1f9b0","shortnames":[":man_red_haired_dark_skin_tone:"],"category":"people"},":man_scientist_tone1:":{"uc_base":"1f468-1f3fb-1f52c","uc_output":"1f468-1f3fb-200d-1f52c","uc_match":"1f468-1f3fb-1f52c","uc_greedy":"1f468-1f3fb-1f52c","shortnames":[":man_scientist_light_skin_tone:"],"category":"people"},":man_scientist_tone2:":{"uc_base":"1f468-1f3fc-1f52c","uc_output":"1f468-1f3fc-200d-1f52c","uc_match":"1f468-1f3fc-1f52c","uc_greedy":"1f468-1f3fc-1f52c","shortnames":[":man_scientist_medium_light_skin_tone:"],"category":"people"},":man_scientist_tone3:":{"uc_base":"1f468-1f3fd-1f52c","uc_output":"1f468-1f3fd-200d-1f52c","uc_match":"1f468-1f3fd-1f52c","uc_greedy":"1f468-1f3fd-1f52c","shortnames":[":man_scientist_medium_skin_tone:"],"category":"people"},":man_scientist_tone4:":{"uc_base":"1f468-1f3fe-1f52c","uc_output":"1f468-1f3fe-200d-1f52c","uc_match":"1f468-1f3fe-1f52c","uc_greedy":"1f468-1f3fe-1f52c","shortnames":[":man_scientist_medium_dark_skin_tone:"],"category":"people"},":man_scientist_tone5:":{"uc_base":"1f468-1f3ff-1f52c","uc_output":"1f468-1f3ff-200d-1f52c","uc_match":"1f468-1f3ff-1f52c","uc_greedy":"1f468-1f3ff-1f52c","shortnames":[":man_scientist_dark_skin_tone:"],"category":"people"},":man_singer_tone1:":{"uc_base":"1f468-1f3fb-1f3a4","uc_output":"1f468-1f3fb-200d-1f3a4","uc_match":"1f468-1f3fb-1f3a4","uc_greedy":"1f468-1f3fb-1f3a4","shortnames":[":man_singer_light_skin_tone:"],"category":"people"},":man_singer_tone2:":{"uc_base":"1f468-1f3fc-1f3a4","uc_output":"1f468-1f3fc-200d-1f3a4","uc_match":"1f468-1f3fc-1f3a4","uc_greedy":"1f468-1f3fc-1f3a4","shortnames":[":man_singer_medium_light_skin_tone:"],"category":"people"},":man_singer_tone3:":{"uc_base":"1f468-1f3fd-1f3a4","uc_output":"1f468-1f3fd-200d-1f3a4","uc_match":"1f468-1f3fd-1f3a4","uc_greedy":"1f468-1f3fd-1f3a4","shortnames":[":man_singer_medium_skin_tone:"],"category":"people"},":man_singer_tone4:":{"uc_base":"1f468-1f3fe-1f3a4","uc_output":"1f468-1f3fe-200d-1f3a4","uc_match":"1f468-1f3fe-1f3a4","uc_greedy":"1f468-1f3fe-1f3a4","shortnames":[":man_singer_medium_dark_skin_tone:"],"category":"people"},":man_singer_tone5:":{"uc_base":"1f468-1f3ff-1f3a4","uc_output":"1f468-1f3ff-200d-1f3a4","uc_match":"1f468-1f3ff-1f3a4","uc_greedy":"1f468-1f3ff-1f3a4","shortnames":[":man_singer_dark_skin_tone:"],"category":"people"},":man_student_tone1:":{"uc_base":"1f468-1f3fb-1f393","uc_output":"1f468-1f3fb-200d-1f393","uc_match":"1f468-1f3fb-1f393","uc_greedy":"1f468-1f3fb-1f393","shortnames":[":man_student_light_skin_tone:"],"category":"people"},":man_student_tone2:":{"uc_base":"1f468-1f3fc-1f393","uc_output":"1f468-1f3fc-200d-1f393","uc_match":"1f468-1f3fc-1f393","uc_greedy":"1f468-1f3fc-1f393","shortnames":[":man_student_medium_light_skin_tone:"],"category":"people"},":man_student_tone3:":{"uc_base":"1f468-1f3fd-1f393","uc_output":"1f468-1f3fd-200d-1f393","uc_match":"1f468-1f3fd-1f393","uc_greedy":"1f468-1f3fd-1f393","shortnames":[":man_student_medium_skin_tone:"],"category":"people"},":man_student_tone4:":{"uc_base":"1f468-1f3fe-1f393","uc_output":"1f468-1f3fe-200d-1f393","uc_match":"1f468-1f3fe-1f393","uc_greedy":"1f468-1f3fe-1f393","shortnames":[":man_student_medium_dark_skin_tone:"],"category":"people"},":man_student_tone5:":{"uc_base":"1f468-1f3ff-1f393","uc_output":"1f468-1f3ff-200d-1f393","uc_match":"1f468-1f3ff-1f393","uc_greedy":"1f468-1f3ff-1f393","shortnames":[":man_student_dark_skin_tone:"],"category":"people"},":man_teacher_tone1:":{"uc_base":"1f468-1f3fb-1f3eb","uc_output":"1f468-1f3fb-200d-1f3eb","uc_match":"1f468-1f3fb-1f3eb","uc_greedy":"1f468-1f3fb-1f3eb","shortnames":[":man_teacher_light_skin_tone:"],"category":"people"},":man_teacher_tone2:":{"uc_base":"1f468-1f3fc-1f3eb","uc_output":"1f468-1f3fc-200d-1f3eb","uc_match":"1f468-1f3fc-1f3eb","uc_greedy":"1f468-1f3fc-1f3eb","shortnames":[":man_teacher_medium_light_skin_tone:"],"category":"people"},":man_teacher_tone3:":{"uc_base":"1f468-1f3fd-1f3eb","uc_output":"1f468-1f3fd-200d-1f3eb","uc_match":"1f468-1f3fd-1f3eb","uc_greedy":"1f468-1f3fd-1f3eb","shortnames":[":man_teacher_medium_skin_tone:"],"category":"people"},":man_teacher_tone4:":{"uc_base":"1f468-1f3fe-1f3eb","uc_output":"1f468-1f3fe-200d-1f3eb","uc_match":"1f468-1f3fe-1f3eb","uc_greedy":"1f468-1f3fe-1f3eb","shortnames":[":man_teacher_medium_dark_skin_tone:"],"category":"people"},":man_teacher_tone5:":{"uc_base":"1f468-1f3ff-1f3eb","uc_output":"1f468-1f3ff-200d-1f3eb","uc_match":"1f468-1f3ff-1f3eb","uc_greedy":"1f468-1f3ff-1f3eb","shortnames":[":man_teacher_dark_skin_tone:"],"category":"people"},":man_technologist_tone1:":{"uc_base":"1f468-1f3fb-1f4bb","uc_output":"1f468-1f3fb-200d-1f4bb","uc_match":"1f468-1f3fb-1f4bb","uc_greedy":"1f468-1f3fb-1f4bb","shortnames":[":man_technologist_light_skin_tone:"],"category":"people"},":man_technologist_tone2:":{"uc_base":"1f468-1f3fc-1f4bb","uc_output":"1f468-1f3fc-200d-1f4bb","uc_match":"1f468-1f3fc-1f4bb","uc_greedy":"1f468-1f3fc-1f4bb","shortnames":[":man_technologist_medium_light_skin_tone:"],"category":"people"},":man_technologist_tone3:":{"uc_base":"1f468-1f3fd-1f4bb","uc_output":"1f468-1f3fd-200d-1f4bb","uc_match":"1f468-1f3fd-1f4bb","uc_greedy":"1f468-1f3fd-1f4bb","shortnames":[":man_technologist_medium_skin_tone:"],"category":"people"},":man_technologist_tone4:":{"uc_base":"1f468-1f3fe-1f4bb","uc_output":"1f468-1f3fe-200d-1f4bb","uc_match":"1f468-1f3fe-1f4bb","uc_greedy":"1f468-1f3fe-1f4bb","shortnames":[":man_technologist_medium_dark_skin_tone:"],"category":"people"},":man_technologist_tone5:":{"uc_base":"1f468-1f3ff-1f4bb","uc_output":"1f468-1f3ff-200d-1f4bb","uc_match":"1f468-1f3ff-1f4bb","uc_greedy":"1f468-1f3ff-1f4bb","shortnames":[":man_technologist_dark_skin_tone:"],"category":"people"},":man_white_haired_tone1:":{"uc_base":"1f468-1f3fb-1f9b3","uc_output":"1f468-1f3fb-200d-1f9b3","uc_match":"1f468-1f3fb-1f9b3","uc_greedy":"1f468-1f3fb-1f9b3","shortnames":[":man_white_haired_light_skin_tone:"],"category":"people"},":man_white_haired_tone2:":{"uc_base":"1f468-1f3fc-1f9b3","uc_output":"1f468-1f3fc-200d-1f9b3","uc_match":"1f468-1f3fc-1f9b3","uc_greedy":"1f468-1f3fc-1f9b3","shortnames":[":man_white_haired_medium_light_skin_tone:"],"category":"people"},":man_white_haired_tone3:":{"uc_base":"1f468-1f3fd-1f9b3","uc_output":"1f468-1f3fd-200d-1f9b3","uc_match":"1f468-1f3fd-1f9b3","uc_greedy":"1f468-1f3fd-1f9b3","shortnames":[":man_white_haired_medium_skin_tone:"],"category":"people"},":man_white_haired_tone4:":{"uc_base":"1f468-1f3fe-1f9b3","uc_output":"1f468-1f3fe-200d-1f9b3","uc_match":"1f468-1f3fe-1f9b3","uc_greedy":"1f468-1f3fe-1f9b3","shortnames":[":man_white_haired_medium_dark_skin_tone:"],"category":"people"},":man_white_haired_tone5:":{"uc_base":"1f468-1f3ff-1f9b3","uc_output":"1f468-1f3ff-200d-1f9b3","uc_match":"1f468-1f3ff-1f9b3","uc_greedy":"1f468-1f3ff-1f9b3","shortnames":[":man_white_haired_dark_skin_tone:"],"category":"people"},":woman_artist_tone1:":{"uc_base":"1f469-1f3fb-1f3a8","uc_output":"1f469-1f3fb-200d-1f3a8","uc_match":"1f469-1f3fb-1f3a8","uc_greedy":"1f469-1f3fb-1f3a8","shortnames":[":woman_artist_light_skin_tone:"],"category":"people"},":woman_artist_tone2:":{"uc_base":"1f469-1f3fc-1f3a8","uc_output":"1f469-1f3fc-200d-1f3a8","uc_match":"1f469-1f3fc-1f3a8","uc_greedy":"1f469-1f3fc-1f3a8","shortnames":[":woman_artist_medium_light_skin_tone:"],"category":"people"},":woman_artist_tone3:":{"uc_base":"1f469-1f3fd-1f3a8","uc_output":"1f469-1f3fd-200d-1f3a8","uc_match":"1f469-1f3fd-1f3a8","uc_greedy":"1f469-1f3fd-1f3a8","shortnames":[":woman_artist_medium_skin_tone:"],"category":"people"},":woman_artist_tone4:":{"uc_base":"1f469-1f3fe-1f3a8","uc_output":"1f469-1f3fe-200d-1f3a8","uc_match":"1f469-1f3fe-1f3a8","uc_greedy":"1f469-1f3fe-1f3a8","shortnames":[":woman_artist_medium_dark_skin_tone:"],"category":"people"},":woman_artist_tone5:":{"uc_base":"1f469-1f3ff-1f3a8","uc_output":"1f469-1f3ff-200d-1f3a8","uc_match":"1f469-1f3ff-1f3a8","uc_greedy":"1f469-1f3ff-1f3a8","shortnames":[":woman_artist_dark_skin_tone:"],"category":"people"},":woman_astronaut_tone1:":{"uc_base":"1f469-1f3fb-1f680","uc_output":"1f469-1f3fb-200d-1f680","uc_match":"1f469-1f3fb-1f680","uc_greedy":"1f469-1f3fb-1f680","shortnames":[":woman_astronaut_light_skin_tone:"],"category":"people"},":woman_astronaut_tone2:":{"uc_base":"1f469-1f3fc-1f680","uc_output":"1f469-1f3fc-200d-1f680","uc_match":"1f469-1f3fc-1f680","uc_greedy":"1f469-1f3fc-1f680","shortnames":[":woman_astronaut_medium_light_skin_tone:"],"category":"people"},":woman_astronaut_tone3:":{"uc_base":"1f469-1f3fd-1f680","uc_output":"1f469-1f3fd-200d-1f680","uc_match":"1f469-1f3fd-1f680","uc_greedy":"1f469-1f3fd-1f680","shortnames":[":woman_astronaut_medium_skin_tone:"],"category":"people"},":woman_astronaut_tone4:":{"uc_base":"1f469-1f3fe-1f680","uc_output":"1f469-1f3fe-200d-1f680","uc_match":"1f469-1f3fe-1f680","uc_greedy":"1f469-1f3fe-1f680","shortnames":[":woman_astronaut_medium_dark_skin_tone:"],"category":"people"},":woman_astronaut_tone5:":{"uc_base":"1f469-1f3ff-1f680","uc_output":"1f469-1f3ff-200d-1f680","uc_match":"1f469-1f3ff-1f680","uc_greedy":"1f469-1f3ff-1f680","shortnames":[":woman_astronaut_dark_skin_tone:"],"category":"people"},":woman_bald_tone1:":{"uc_base":"1f469-1f3fb-1f9b2","uc_output":"1f469-1f3fb-200d-1f9b2","uc_match":"1f469-1f3fb-1f9b2","uc_greedy":"1f469-1f3fb-1f9b2","shortnames":[":woman_bald_light_skin_tone:"],"category":"people"},":woman_bald_tone2:":{"uc_base":"1f469-1f3fc-1f9b2","uc_output":"1f469-1f3fc-200d-1f9b2","uc_match":"1f469-1f3fc-1f9b2","uc_greedy":"1f469-1f3fc-1f9b2","shortnames":[":woman_bald_medium_light_skin_tone:"],"category":"people"},":woman_bald_tone3:":{"uc_base":"1f469-1f3fd-1f9b2","uc_output":"1f469-1f3fd-200d-1f9b2","uc_match":"1f469-1f3fd-1f9b2","uc_greedy":"1f469-1f3fd-1f9b2","shortnames":[":woman_bald_medium_skin_tone:"],"category":"people"},":woman_bald_tone4:":{"uc_base":"1f469-1f3fe-1f9b2","uc_output":"1f469-1f3fe-200d-1f9b2","uc_match":"1f469-1f3fe-1f9b2","uc_greedy":"1f469-1f3fe-1f9b2","shortnames":[":woman_bald_medium_dark_skin_tone:"],"category":"people"},":woman_bald_tone5:":{"uc_base":"1f469-1f3ff-1f9b2","uc_output":"1f469-1f3ff-200d-1f9b2","uc_match":"1f469-1f3ff-1f9b2","uc_greedy":"1f469-1f3ff-1f9b2","shortnames":[":woman_bald_dark_skin_tone:"],"category":"people"},":woman_cook_tone1:":{"uc_base":"1f469-1f3fb-1f373","uc_output":"1f469-1f3fb-200d-1f373","uc_match":"1f469-1f3fb-1f373","uc_greedy":"1f469-1f3fb-1f373","shortnames":[":woman_cook_light_skin_tone:"],"category":"people"},":woman_cook_tone2:":{"uc_base":"1f469-1f3fc-1f373","uc_output":"1f469-1f3fc-200d-1f373","uc_match":"1f469-1f3fc-1f373","uc_greedy":"1f469-1f3fc-1f373","shortnames":[":woman_cook_medium_light_skin_tone:"],"category":"people"},":woman_cook_tone3:":{"uc_base":"1f469-1f3fd-1f373","uc_output":"1f469-1f3fd-200d-1f373","uc_match":"1f469-1f3fd-1f373","uc_greedy":"1f469-1f3fd-1f373","shortnames":[":woman_cook_medium_skin_tone:"],"category":"people"},":woman_cook_tone4:":{"uc_base":"1f469-1f3fe-1f373","uc_output":"1f469-1f3fe-200d-1f373","uc_match":"1f469-1f3fe-1f373","uc_greedy":"1f469-1f3fe-1f373","shortnames":[":woman_cook_medium_dark_skin_tone:"],"category":"people"},":woman_cook_tone5:":{"uc_base":"1f469-1f3ff-1f373","uc_output":"1f469-1f3ff-200d-1f373","uc_match":"1f469-1f3ff-1f373","uc_greedy":"1f469-1f3ff-1f373","shortnames":[":woman_cook_dark_skin_tone:"],"category":"people"},":woman_curly_haired_tone1:":{"uc_base":"1f469-1f3fb-1f9b1","uc_output":"1f469-1f3fb-200d-1f9b1","uc_match":"1f469-1f3fb-1f9b1","uc_greedy":"1f469-1f3fb-1f9b1","shortnames":[":woman_curly_haired_light_skin_tone:"],"category":"people"},":woman_curly_haired_tone2:":{"uc_base":"1f469-1f3fc-1f9b1","uc_output":"1f469-1f3fc-200d-1f9b1","uc_match":"1f469-1f3fc-1f9b1","uc_greedy":"1f469-1f3fc-1f9b1","shortnames":[":woman_curly_haired_medium_light_skin_tone:"],"category":"people"},":woman_curly_haired_tone3:":{"uc_base":"1f469-1f3fd-1f9b1","uc_output":"1f469-1f3fd-200d-1f9b1","uc_match":"1f469-1f3fd-1f9b1","uc_greedy":"1f469-1f3fd-1f9b1","shortnames":[":woman_curly_haired_medium_skin_tone:"],"category":"people"},":woman_curly_haired_tone4:":{"uc_base":"1f469-1f3fe-1f9b1","uc_output":"1f469-1f3fe-200d-1f9b1","uc_match":"1f469-1f3fe-1f9b1","uc_greedy":"1f469-1f3fe-1f9b1","shortnames":[":woman_curly_haired_medium_dark_skin_tone:"],"category":"people"},":woman_curly_haired_tone5:":{"uc_base":"1f469-1f3ff-1f9b1","uc_output":"1f469-1f3ff-200d-1f9b1","uc_match":"1f469-1f3ff-1f9b1","uc_greedy":"1f469-1f3ff-1f9b1","shortnames":[":woman_curly_haired_dark_skin_tone:"],"category":"people"},":woman_factory_worker_tone1:":{"uc_base":"1f469-1f3fb-1f3ed","uc_output":"1f469-1f3fb-200d-1f3ed","uc_match":"1f469-1f3fb-1f3ed","uc_greedy":"1f469-1f3fb-1f3ed","shortnames":[":woman_factory_worker_light_skin_tone:"],"category":"people"},":woman_factory_worker_tone2:":{"uc_base":"1f469-1f3fc-1f3ed","uc_output":"1f469-1f3fc-200d-1f3ed","uc_match":"1f469-1f3fc-1f3ed","uc_greedy":"1f469-1f3fc-1f3ed","shortnames":[":woman_factory_worker_medium_light_skin_tone:"],"category":"people"},":woman_factory_worker_tone3:":{"uc_base":"1f469-1f3fd-1f3ed","uc_output":"1f469-1f3fd-200d-1f3ed","uc_match":"1f469-1f3fd-1f3ed","uc_greedy":"1f469-1f3fd-1f3ed","shortnames":[":woman_factory_worker_medium_skin_tone:"],"category":"people"},":woman_factory_worker_tone4:":{"uc_base":"1f469-1f3fe-1f3ed","uc_output":"1f469-1f3fe-200d-1f3ed","uc_match":"1f469-1f3fe-1f3ed","uc_greedy":"1f469-1f3fe-1f3ed","shortnames":[":woman_factory_worker_medium_dark_skin_tone:"],"category":"people"},":woman_factory_worker_tone5:":{"uc_base":"1f469-1f3ff-1f3ed","uc_output":"1f469-1f3ff-200d-1f3ed","uc_match":"1f469-1f3ff-1f3ed","uc_greedy":"1f469-1f3ff-1f3ed","shortnames":[":woman_factory_worker_dark_skin_tone:"],"category":"people"},":woman_farmer_tone1:":{"uc_base":"1f469-1f3fb-1f33e","uc_output":"1f469-1f3fb-200d-1f33e","uc_match":"1f469-1f3fb-1f33e","uc_greedy":"1f469-1f3fb-1f33e","shortnames":[":woman_farmer_light_skin_tone:"],"category":"people"},":woman_farmer_tone2:":{"uc_base":"1f469-1f3fc-1f33e","uc_output":"1f469-1f3fc-200d-1f33e","uc_match":"1f469-1f3fc-1f33e","uc_greedy":"1f469-1f3fc-1f33e","shortnames":[":woman_farmer_medium_light_skin_tone:"],"category":"people"},":woman_farmer_tone3:":{"uc_base":"1f469-1f3fd-1f33e","uc_output":"1f469-1f3fd-200d-1f33e","uc_match":"1f469-1f3fd-1f33e","uc_greedy":"1f469-1f3fd-1f33e","shortnames":[":woman_farmer_medium_skin_tone:"],"category":"people"},":woman_farmer_tone4:":{"uc_base":"1f469-1f3fe-1f33e","uc_output":"1f469-1f3fe-200d-1f33e","uc_match":"1f469-1f3fe-1f33e","uc_greedy":"1f469-1f3fe-1f33e","shortnames":[":woman_farmer_medium_dark_skin_tone:"],"category":"people"},":woman_farmer_tone5:":{"uc_base":"1f469-1f3ff-1f33e","uc_output":"1f469-1f3ff-200d-1f33e","uc_match":"1f469-1f3ff-1f33e","uc_greedy":"1f469-1f3ff-1f33e","shortnames":[":woman_farmer_dark_skin_tone:"],"category":"people"},":woman_firefighter_tone1:":{"uc_base":"1f469-1f3fb-1f692","uc_output":"1f469-1f3fb-200d-1f692","uc_match":"1f469-1f3fb-1f692","uc_greedy":"1f469-1f3fb-1f692","shortnames":[":woman_firefighter_light_skin_tone:"],"category":"people"},":woman_firefighter_tone2:":{"uc_base":"1f469-1f3fc-1f692","uc_output":"1f469-1f3fc-200d-1f692","uc_match":"1f469-1f3fc-1f692","uc_greedy":"1f469-1f3fc-1f692","shortnames":[":woman_firefighter_medium_light_skin_tone:"],"category":"people"},":woman_firefighter_tone3:":{"uc_base":"1f469-1f3fd-1f692","uc_output":"1f469-1f3fd-200d-1f692","uc_match":"1f469-1f3fd-1f692","uc_greedy":"1f469-1f3fd-1f692","shortnames":[":woman_firefighter_medium_skin_tone:"],"category":"people"},":woman_firefighter_tone4:":{"uc_base":"1f469-1f3fe-1f692","uc_output":"1f469-1f3fe-200d-1f692","uc_match":"1f469-1f3fe-1f692","uc_greedy":"1f469-1f3fe-1f692","shortnames":[":woman_firefighter_medium_dark_skin_tone:"],"category":"people"},":woman_firefighter_tone5:":{"uc_base":"1f469-1f3ff-1f692","uc_output":"1f469-1f3ff-200d-1f692","uc_match":"1f469-1f3ff-1f692","uc_greedy":"1f469-1f3ff-1f692","shortnames":[":woman_firefighter_dark_skin_tone:"],"category":"people"},":woman_mechanic_tone1:":{"uc_base":"1f469-1f3fb-1f527","uc_output":"1f469-1f3fb-200d-1f527","uc_match":"1f469-1f3fb-1f527","uc_greedy":"1f469-1f3fb-1f527","shortnames":[":woman_mechanic_light_skin_tone:"],"category":"people"},":woman_mechanic_tone2:":{"uc_base":"1f469-1f3fc-1f527","uc_output":"1f469-1f3fc-200d-1f527","uc_match":"1f469-1f3fc-1f527","uc_greedy":"1f469-1f3fc-1f527","shortnames":[":woman_mechanic_medium_light_skin_tone:"],"category":"people"},":woman_mechanic_tone3:":{"uc_base":"1f469-1f3fd-1f527","uc_output":"1f469-1f3fd-200d-1f527","uc_match":"1f469-1f3fd-1f527","uc_greedy":"1f469-1f3fd-1f527","shortnames":[":woman_mechanic_medium_skin_tone:"],"category":"people"},":woman_mechanic_tone4:":{"uc_base":"1f469-1f3fe-1f527","uc_output":"1f469-1f3fe-200d-1f527","uc_match":"1f469-1f3fe-1f527","uc_greedy":"1f469-1f3fe-1f527","shortnames":[":woman_mechanic_medium_dark_skin_tone:"],"category":"people"},":woman_mechanic_tone5:":{"uc_base":"1f469-1f3ff-1f527","uc_output":"1f469-1f3ff-200d-1f527","uc_match":"1f469-1f3ff-1f527","uc_greedy":"1f469-1f3ff-1f527","shortnames":[":woman_mechanic_dark_skin_tone:"],"category":"people"},":woman_office_worker_tone1:":{"uc_base":"1f469-1f3fb-1f4bc","uc_output":"1f469-1f3fb-200d-1f4bc","uc_match":"1f469-1f3fb-1f4bc","uc_greedy":"1f469-1f3fb-1f4bc","shortnames":[":woman_office_worker_light_skin_tone:"],"category":"people"},":woman_office_worker_tone2:":{"uc_base":"1f469-1f3fc-1f4bc","uc_output":"1f469-1f3fc-200d-1f4bc","uc_match":"1f469-1f3fc-1f4bc","uc_greedy":"1f469-1f3fc-1f4bc","shortnames":[":woman_office_worker_medium_light_skin_tone:"],"category":"people"},":woman_office_worker_tone3:":{"uc_base":"1f469-1f3fd-1f4bc","uc_output":"1f469-1f3fd-200d-1f4bc","uc_match":"1f469-1f3fd-1f4bc","uc_greedy":"1f469-1f3fd-1f4bc","shortnames":[":woman_office_worker_medium_skin_tone:"],"category":"people"},":woman_office_worker_tone4:":{"uc_base":"1f469-1f3fe-1f4bc","uc_output":"1f469-1f3fe-200d-1f4bc","uc_match":"1f469-1f3fe-1f4bc","uc_greedy":"1f469-1f3fe-1f4bc","shortnames":[":woman_office_worker_medium_dark_skin_tone:"],"category":"people"},":woman_office_worker_tone5:":{"uc_base":"1f469-1f3ff-1f4bc","uc_output":"1f469-1f3ff-200d-1f4bc","uc_match":"1f469-1f3ff-1f4bc","uc_greedy":"1f469-1f3ff-1f4bc","shortnames":[":woman_office_worker_dark_skin_tone:"],"category":"people"},":woman_red_haired_tone1:":{"uc_base":"1f469-1f3fb-1f9b0","uc_output":"1f469-1f3fb-200d-1f9b0","uc_match":"1f469-1f3fb-1f9b0","uc_greedy":"1f469-1f3fb-1f9b0","shortnames":[":woman_red_haired_light_skin_tone:"],"category":"people"},":woman_red_haired_tone2:":{"uc_base":"1f469-1f3fc-1f9b0","uc_output":"1f469-1f3fc-200d-1f9b0","uc_match":"1f469-1f3fc-1f9b0","uc_greedy":"1f469-1f3fc-1f9b0","shortnames":[":woman_red_haired_medium_light_skin_tone:"],"category":"people"},":woman_red_haired_tone3:":{"uc_base":"1f469-1f3fd-1f9b0","uc_output":"1f469-1f3fd-200d-1f9b0","uc_match":"1f469-1f3fd-1f9b0","uc_greedy":"1f469-1f3fd-1f9b0","shortnames":[":woman_red_haired_medium_skin_tone:"],"category":"people"},":woman_red_haired_tone4:":{"uc_base":"1f469-1f3fe-1f9b0","uc_output":"1f469-1f3fe-200d-1f9b0","uc_match":"1f469-1f3fe-1f9b0","uc_greedy":"1f469-1f3fe-1f9b0","shortnames":[":woman_red_haired_medium_dark_skin_tone:"],"category":"people"},":woman_red_haired_tone5:":{"uc_base":"1f469-1f3ff-1f9b0","uc_output":"1f469-1f3ff-200d-1f9b0","uc_match":"1f469-1f3ff-1f9b0","uc_greedy":"1f469-1f3ff-1f9b0","shortnames":[":woman_red_haired_dark_skin_tone:"],"category":"people"},":woman_scientist_tone1:":{"uc_base":"1f469-1f3fb-1f52c","uc_output":"1f469-1f3fb-200d-1f52c","uc_match":"1f469-1f3fb-1f52c","uc_greedy":"1f469-1f3fb-1f52c","shortnames":[":woman_scientist_light_skin_tone:"],"category":"people"},":woman_scientist_tone2:":{"uc_base":"1f469-1f3fc-1f52c","uc_output":"1f469-1f3fc-200d-1f52c","uc_match":"1f469-1f3fc-1f52c","uc_greedy":"1f469-1f3fc-1f52c","shortnames":[":woman_scientist_medium_light_skin_tone:"],"category":"people"},":woman_scientist_tone3:":{"uc_base":"1f469-1f3fd-1f52c","uc_output":"1f469-1f3fd-200d-1f52c","uc_match":"1f469-1f3fd-1f52c","uc_greedy":"1f469-1f3fd-1f52c","shortnames":[":woman_scientist_medium_skin_tone:"],"category":"people"},":woman_scientist_tone4:":{"uc_base":"1f469-1f3fe-1f52c","uc_output":"1f469-1f3fe-200d-1f52c","uc_match":"1f469-1f3fe-1f52c","uc_greedy":"1f469-1f3fe-1f52c","shortnames":[":woman_scientist_medium_dark_skin_tone:"],"category":"people"},":woman_scientist_tone5:":{"uc_base":"1f469-1f3ff-1f52c","uc_output":"1f469-1f3ff-200d-1f52c","uc_match":"1f469-1f3ff-1f52c","uc_greedy":"1f469-1f3ff-1f52c","shortnames":[":woman_scientist_dark_skin_tone:"],"category":"people"},":woman_singer_tone1:":{"uc_base":"1f469-1f3fb-1f3a4","uc_output":"1f469-1f3fb-200d-1f3a4","uc_match":"1f469-1f3fb-1f3a4","uc_greedy":"1f469-1f3fb-1f3a4","shortnames":[":woman_singer_light_skin_tone:"],"category":"people"},":woman_singer_tone2:":{"uc_base":"1f469-1f3fc-1f3a4","uc_output":"1f469-1f3fc-200d-1f3a4","uc_match":"1f469-1f3fc-1f3a4","uc_greedy":"1f469-1f3fc-1f3a4","shortnames":[":woman_singer_medium_light_skin_tone:"],"category":"people"},":woman_singer_tone3:":{"uc_base":"1f469-1f3fd-1f3a4","uc_output":"1f469-1f3fd-200d-1f3a4","uc_match":"1f469-1f3fd-1f3a4","uc_greedy":"1f469-1f3fd-1f3a4","shortnames":[":woman_singer_medium_skin_tone:"],"category":"people"},":woman_singer_tone4:":{"uc_base":"1f469-1f3fe-1f3a4","uc_output":"1f469-1f3fe-200d-1f3a4","uc_match":"1f469-1f3fe-1f3a4","uc_greedy":"1f469-1f3fe-1f3a4","shortnames":[":woman_singer_medium_dark_skin_tone:"],"category":"people"},":woman_singer_tone5:":{"uc_base":"1f469-1f3ff-1f3a4","uc_output":"1f469-1f3ff-200d-1f3a4","uc_match":"1f469-1f3ff-1f3a4","uc_greedy":"1f469-1f3ff-1f3a4","shortnames":[":woman_singer_dark_skin_tone:"],"category":"people"},":woman_student_tone1:":{"uc_base":"1f469-1f3fb-1f393","uc_output":"1f469-1f3fb-200d-1f393","uc_match":"1f469-1f3fb-1f393","uc_greedy":"1f469-1f3fb-1f393","shortnames":[":woman_student_light_skin_tone:"],"category":"people"},":woman_student_tone2:":{"uc_base":"1f469-1f3fc-1f393","uc_output":"1f469-1f3fc-200d-1f393","uc_match":"1f469-1f3fc-1f393","uc_greedy":"1f469-1f3fc-1f393","shortnames":[":woman_student_medium_light_skin_tone:"],"category":"people"},":woman_student_tone3:":{"uc_base":"1f469-1f3fd-1f393","uc_output":"1f469-1f3fd-200d-1f393","uc_match":"1f469-1f3fd-1f393","uc_greedy":"1f469-1f3fd-1f393","shortnames":[":woman_student_medium_skin_tone:"],"category":"people"},":woman_student_tone4:":{"uc_base":"1f469-1f3fe-1f393","uc_output":"1f469-1f3fe-200d-1f393","uc_match":"1f469-1f3fe-1f393","uc_greedy":"1f469-1f3fe-1f393","shortnames":[":woman_student_medium_dark_skin_tone:"],"category":"people"},":woman_student_tone5:":{"uc_base":"1f469-1f3ff-1f393","uc_output":"1f469-1f3ff-200d-1f393","uc_match":"1f469-1f3ff-1f393","uc_greedy":"1f469-1f3ff-1f393","shortnames":[":woman_student_dark_skin_tone:"],"category":"people"},":woman_teacher_tone1:":{"uc_base":"1f469-1f3fb-1f3eb","uc_output":"1f469-1f3fb-200d-1f3eb","uc_match":"1f469-1f3fb-1f3eb","uc_greedy":"1f469-1f3fb-1f3eb","shortnames":[":woman_teacher_light_skin_tone:"],"category":"people"},":woman_teacher_tone2:":{"uc_base":"1f469-1f3fc-1f3eb","uc_output":"1f469-1f3fc-200d-1f3eb","uc_match":"1f469-1f3fc-1f3eb","uc_greedy":"1f469-1f3fc-1f3eb","shortnames":[":woman_teacher_medium_light_skin_tone:"],"category":"people"},":woman_teacher_tone3:":{"uc_base":"1f469-1f3fd-1f3eb","uc_output":"1f469-1f3fd-200d-1f3eb","uc_match":"1f469-1f3fd-1f3eb","uc_greedy":"1f469-1f3fd-1f3eb","shortnames":[":woman_teacher_medium_skin_tone:"],"category":"people"},":woman_teacher_tone4:":{"uc_base":"1f469-1f3fe-1f3eb","uc_output":"1f469-1f3fe-200d-1f3eb","uc_match":"1f469-1f3fe-1f3eb","uc_greedy":"1f469-1f3fe-1f3eb","shortnames":[":woman_teacher_medium_dark_skin_tone:"],"category":"people"},":woman_teacher_tone5:":{"uc_base":"1f469-1f3ff-1f3eb","uc_output":"1f469-1f3ff-200d-1f3eb","uc_match":"1f469-1f3ff-1f3eb","uc_greedy":"1f469-1f3ff-1f3eb","shortnames":[":woman_teacher_dark_skin_tone:"],"category":"people"},":woman_technologist_tone1:":{"uc_base":"1f469-1f3fb-1f4bb","uc_output":"1f469-1f3fb-200d-1f4bb","uc_match":"1f469-1f3fb-1f4bb","uc_greedy":"1f469-1f3fb-1f4bb","shortnames":[":woman_technologist_light_skin_tone:"],"category":"people"},":woman_technologist_tone2:":{"uc_base":"1f469-1f3fc-1f4bb","uc_output":"1f469-1f3fc-200d-1f4bb","uc_match":"1f469-1f3fc-1f4bb","uc_greedy":"1f469-1f3fc-1f4bb","shortnames":[":woman_technologist_medium_light_skin_tone:"],"category":"people"},":woman_technologist_tone3:":{"uc_base":"1f469-1f3fd-1f4bb","uc_output":"1f469-1f3fd-200d-1f4bb","uc_match":"1f469-1f3fd-1f4bb","uc_greedy":"1f469-1f3fd-1f4bb","shortnames":[":woman_technologist_medium_skin_tone:"],"category":"people"},":woman_technologist_tone4:":{"uc_base":"1f469-1f3fe-1f4bb","uc_output":"1f469-1f3fe-200d-1f4bb","uc_match":"1f469-1f3fe-1f4bb","uc_greedy":"1f469-1f3fe-1f4bb","shortnames":[":woman_technologist_medium_dark_skin_tone:"],"category":"people"},":woman_technologist_tone5:":{"uc_base":"1f469-1f3ff-1f4bb","uc_output":"1f469-1f3ff-200d-1f4bb","uc_match":"1f469-1f3ff-1f4bb","uc_greedy":"1f469-1f3ff-1f4bb","shortnames":[":woman_technologist_dark_skin_tone:"],"category":"people"},":woman_white_haired_tone1:":{"uc_base":"1f469-1f3fb-1f9b3","uc_output":"1f469-1f3fb-200d-1f9b3","uc_match":"1f469-1f3fb-1f9b3","uc_greedy":"1f469-1f3fb-1f9b3","shortnames":[":woman_white_haired_light_skin_tone:"],"category":"people"},":woman_white_haired_tone2:":{"uc_base":"1f469-1f3fc-1f9b3","uc_output":"1f469-1f3fc-200d-1f9b3","uc_match":"1f469-1f3fc-1f9b3","uc_greedy":"1f469-1f3fc-1f9b3","shortnames":[":woman_white_haired_medium_light_skin_tone:"],"category":"people"},":woman_white_haired_tone3:":{"uc_base":"1f469-1f3fd-1f9b3","uc_output":"1f469-1f3fd-200d-1f9b3","uc_match":"1f469-1f3fd-1f9b3","uc_greedy":"1f469-1f3fd-1f9b3","shortnames":[":woman_white_haired_medium_skin_tone:"],"category":"people"},":woman_white_haired_tone4:":{"uc_base":"1f469-1f3fe-1f9b3","uc_output":"1f469-1f3fe-200d-1f9b3","uc_match":"1f469-1f3fe-1f9b3","uc_greedy":"1f469-1f3fe-1f9b3","shortnames":[":woman_white_haired_medium_dark_skin_tone:"],"category":"people"},":woman_white_haired_tone5:":{"uc_base":"1f469-1f3ff-1f9b3","uc_output":"1f469-1f3ff-200d-1f9b3","uc_match":"1f469-1f3ff-1f9b3","uc_greedy":"1f469-1f3ff-1f9b3","shortnames":[":woman_white_haired_dark_skin_tone:"],"category":"people"},":rainbow_flag:":{"uc_base":"1f3f3-1f308","uc_output":"1f3f3-fe0f-200d-1f308","uc_match":"1f3f3-fe0f-1f308","uc_greedy":"1f3f3-1f308","shortnames":[":gay_pride_flag:"],"category":"flags"},":blond-haired_man:":{"uc_base":"1f471-2642","uc_output":"1f471-200d-2642-fe0f","uc_match":"1f471-2642-fe0f","uc_greedy":"1f471-2642","shortnames":[],"category":"people"},":blond-haired_woman:":{"uc_base":"1f471-2640","uc_output":"1f471-200d-2640-fe0f","uc_match":"1f471-2640-fe0f","uc_greedy":"1f471-2640","shortnames":[],"category":"people"},":man_biking:":{"uc_base":"1f6b4-2642","uc_output":"1f6b4-200d-2642-fe0f","uc_match":"1f6b4-2642-fe0f","uc_greedy":"1f6b4-2642","shortnames":[],"category":"activity"},":man_bowing:":{"uc_base":"1f647-2642","uc_output":"1f647-200d-2642-fe0f","uc_match":"1f647-2642-fe0f","uc_greedy":"1f647-2642","shortnames":[],"category":"people"},":man_cartwheeling:":{"uc_base":"1f938-2642","uc_output":"1f938-200d-2642-fe0f","uc_match":"1f938-2642-fe0f","uc_greedy":"1f938-2642","shortnames":[],"category":"activity"},":man_climbing:":{"uc_base":"1f9d7-2642","uc_output":"1f9d7-200d-2642-fe0f","uc_match":"1f9d7-2642-fe0f","uc_greedy":"1f9d7-2642","shortnames":[],"category":"activity"},":man_construction_worker:":{"uc_base":"1f477-2642","uc_output":"1f477-200d-2642-fe0f","uc_match":"1f477-2642-fe0f","uc_greedy":"1f477-2642","shortnames":[],"category":"people"},":man_elf:":{"uc_base":"1f9dd-2642","uc_output":"1f9dd-200d-2642-fe0f","uc_match":"1f9dd-2642-fe0f","uc_greedy":"1f9dd-2642","shortnames":[],"category":"people"},":man_facepalming:":{"uc_base":"1f926-2642","uc_output":"1f926-200d-2642-fe0f","uc_match":"1f926-2642-fe0f","uc_greedy":"1f926-2642","shortnames":[],"category":"people"},":man_fairy:":{"uc_base":"1f9da-2642","uc_output":"1f9da-200d-2642-fe0f","uc_match":"1f9da-2642-fe0f","uc_greedy":"1f9da-2642","shortnames":[],"category":"people"},":man_frowning:":{"uc_base":"1f64d-2642","uc_output":"1f64d-200d-2642-fe0f","uc_match":"1f64d-2642-fe0f","uc_greedy":"1f64d-2642","shortnames":[],"category":"people"},":man_genie:":{"uc_base":"1f9de-2642","uc_output":"1f9de-200d-2642-fe0f","uc_match":"1f9de-2642-fe0f","uc_greedy":"1f9de-2642","shortnames":[],"category":"people"},":man_gesturing_no:":{"uc_base":"1f645-2642","uc_output":"1f645-200d-2642-fe0f","uc_match":"1f645-2642-fe0f","uc_greedy":"1f645-2642","shortnames":[],"category":"people"},":man_gesturing_ok:":{"uc_base":"1f646-2642","uc_output":"1f646-200d-2642-fe0f","uc_match":"1f646-2642-fe0f","uc_greedy":"1f646-2642","shortnames":[],"category":"people"},":man_getting_face_massage:":{"uc_base":"1f486-2642","uc_output":"1f486-200d-2642-fe0f","uc_match":"1f486-2642-fe0f","uc_greedy":"1f486-2642","shortnames":[],"category":"people"},":man_getting_haircut:":{"uc_base":"1f487-2642","uc_output":"1f487-200d-2642-fe0f","uc_match":"1f487-2642-fe0f","uc_greedy":"1f487-2642","shortnames":[],"category":"people"},":man_guard:":{"uc_base":"1f482-2642","uc_output":"1f482-200d-2642-fe0f","uc_match":"1f482-2642-fe0f","uc_greedy":"1f482-2642","shortnames":[],"category":"people"},":man_health_worker:":{"uc_base":"1f468-2695","uc_output":"1f468-200d-2695-fe0f","uc_match":"1f468-2695-fe0f","uc_greedy":"1f468-2695","shortnames":[],"category":"people"},":man_in_lotus_position:":{"uc_base":"1f9d8-2642","uc_output":"1f9d8-200d-2642-fe0f","uc_match":"1f9d8-2642-fe0f","uc_greedy":"1f9d8-2642","shortnames":[],"category":"activity"},":man_in_steamy_room:":{"uc_base":"1f9d6-2642","uc_output":"1f9d6-200d-2642-fe0f","uc_match":"1f9d6-2642-fe0f","uc_greedy":"1f9d6-2642","shortnames":[],"category":"people"},":man_judge:":{"uc_base":"1f468-2696","uc_output":"1f468-200d-2696-fe0f","uc_match":"1f468-2696-fe0f","uc_greedy":"1f468-2696","shortnames":[],"category":"people"},":man_juggling:":{"uc_base":"1f939-2642","uc_output":"1f939-200d-2642-fe0f","uc_match":"1f939-2642-fe0f","uc_greedy":"1f939-2642","shortnames":[],"category":"activity"},":man_mage:":{"uc_base":"1f9d9-2642","uc_output":"1f9d9-200d-2642-fe0f","uc_match":"1f9d9-2642-fe0f","uc_greedy":"1f9d9-2642","shortnames":[],"category":"people"},":man_mountain_biking:":{"uc_base":"1f6b5-2642","uc_output":"1f6b5-200d-2642-fe0f","uc_match":"1f6b5-2642-fe0f","uc_greedy":"1f6b5-2642","shortnames":[],"category":"activity"},":man_pilot:":{"uc_base":"1f468-2708","uc_output":"1f468-200d-2708-fe0f","uc_match":"1f468-2708-fe0f","uc_greedy":"1f468-2708","shortnames":[],"category":"people"},":man_playing_handball:":{"uc_base":"1f93e-2642","uc_output":"1f93e-200d-2642-fe0f","uc_match":"1f93e-2642-fe0f","uc_greedy":"1f93e-2642","shortnames":[],"category":"activity"},":man_playing_water_polo:":{"uc_base":"1f93d-2642","uc_output":"1f93d-200d-2642-fe0f","uc_match":"1f93d-2642-fe0f","uc_greedy":"1f93d-2642","shortnames":[],"category":"activity"},":man_police_officer:":{"uc_base":"1f46e-2642","uc_output":"1f46e-200d-2642-fe0f","uc_match":"1f46e-2642-fe0f","uc_greedy":"1f46e-2642","shortnames":[],"category":"people"},":man_pouting:":{"uc_base":"1f64e-2642","uc_output":"1f64e-200d-2642-fe0f","uc_match":"1f64e-2642-fe0f","uc_greedy":"1f64e-2642","shortnames":[],"category":"people"},":man_raising_hand:":{"uc_base":"1f64b-2642","uc_output":"1f64b-200d-2642-fe0f","uc_match":"1f64b-2642-fe0f","uc_greedy":"1f64b-2642","shortnames":[],"category":"people"},":man_rowing_boat:":{"uc_base":"1f6a3-2642","uc_output":"1f6a3-200d-2642-fe0f","uc_match":"1f6a3-2642-fe0f","uc_greedy":"1f6a3-2642","shortnames":[],"category":"activity"},":man_running:":{"uc_base":"1f3c3-2642","uc_output":"1f3c3-200d-2642-fe0f","uc_match":"1f3c3-2642-fe0f","uc_greedy":"1f3c3-2642","shortnames":[],"category":"people"},":man_shrugging:":{"uc_base":"1f937-2642","uc_output":"1f937-200d-2642-fe0f","uc_match":"1f937-2642-fe0f","uc_greedy":"1f937-2642","shortnames":[],"category":"people"},":man_superhero:":{"uc_base":"1f9b8-2642","uc_output":"1f9b8-200d-2642-fe0f","uc_match":"1f9b8-2642-fe0f","uc_greedy":"1f9b8-2642","shortnames":[],"category":"people"},":man_supervillain:":{"uc_base":"1f9b9-2642","uc_output":"1f9b9-200d-2642-fe0f","uc_match":"1f9b9-2642-fe0f","uc_greedy":"1f9b9-2642","shortnames":[],"category":"people"},":man_surfing:":{"uc_base":"1f3c4-2642","uc_output":"1f3c4-200d-2642-fe0f","uc_match":"1f3c4-2642-fe0f","uc_greedy":"1f3c4-2642","shortnames":[],"category":"activity"},":man_swimming:":{"uc_base":"1f3ca-2642","uc_output":"1f3ca-200d-2642-fe0f","uc_match":"1f3ca-2642-fe0f","uc_greedy":"1f3ca-2642","shortnames":[],"category":"activity"},":man_tipping_hand:":{"uc_base":"1f481-2642","uc_output":"1f481-200d-2642-fe0f","uc_match":"1f481-2642-fe0f","uc_greedy":"1f481-2642","shortnames":[],"category":"people"},":man_vampire:":{"uc_base":"1f9db-2642","uc_output":"1f9db-200d-2642-fe0f","uc_match":"1f9db-2642-fe0f","uc_greedy":"1f9db-2642","shortnames":[],"category":"people"},":man_walking:":{"uc_base":"1f6b6-2642","uc_output":"1f6b6-200d-2642-fe0f","uc_match":"1f6b6-2642-fe0f","uc_greedy":"1f6b6-2642","shortnames":[],"category":"people"},":man_wearing_turban:":{"uc_base":"1f473-2642","uc_output":"1f473-200d-2642-fe0f","uc_match":"1f473-2642-fe0f","uc_greedy":"1f473-2642","shortnames":[],"category":"people"},":man_zombie:":{"uc_base":"1f9df-2642","uc_output":"1f9df-200d-2642-fe0f","uc_match":"1f9df-2642-fe0f","uc_greedy":"1f9df-2642","shortnames":[],"category":"people"},":men_with_bunny_ears_partying:":{"uc_base":"1f46f-2642","uc_output":"1f46f-200d-2642-fe0f","uc_match":"1f46f-2642-fe0f","uc_greedy":"1f46f-2642","shortnames":[],"category":"people"},":men_wrestling:":{"uc_base":"1f93c-2642","uc_output":"1f93c-200d-2642-fe0f","uc_match":"1f93c-2642-fe0f","uc_greedy":"1f93c-2642","shortnames":[],"category":"activity"},":mermaid:":{"uc_base":"1f9dc-2640","uc_output":"1f9dc-200d-2640-fe0f","uc_match":"1f9dc-2640-fe0f","uc_greedy":"1f9dc-2640","shortnames":[],"category":"people"},":merman:":{"uc_base":"1f9dc-2642","uc_output":"1f9dc-200d-2642-fe0f","uc_match":"1f9dc-2642-fe0f","uc_greedy":"1f9dc-2642","shortnames":[],"category":"people"},":pirate_flag:":{"uc_base":"1f3f4-2620","uc_output":"1f3f4-200d-2620-fe0f","uc_match":"1f3f4-2620-fe0f","uc_greedy":"1f3f4-2620","shortnames":[],"category":"flags"},":woman_biking:":{"uc_base":"1f6b4-2640","uc_output":"1f6b4-200d-2640-fe0f","uc_match":"1f6b4-2640-fe0f","uc_greedy":"1f6b4-2640","shortnames":[],"category":"activity"},":woman_bowing:":{"uc_base":"1f647-2640","uc_output":"1f647-200d-2640-fe0f","uc_match":"1f647-2640-fe0f","uc_greedy":"1f647-2640","shortnames":[],"category":"people"},":woman_cartwheeling:":{"uc_base":"1f938-2640","uc_output":"1f938-200d-2640-fe0f","uc_match":"1f938-2640-fe0f","uc_greedy":"1f938-2640","shortnames":[],"category":"activity"},":woman_climbing:":{"uc_base":"1f9d7-2640","uc_output":"1f9d7-200d-2640-fe0f","uc_match":"1f9d7-2640-fe0f","uc_greedy":"1f9d7-2640","shortnames":[],"category":"activity"},":woman_construction_worker:":{"uc_base":"1f477-2640","uc_output":"1f477-200d-2640-fe0f","uc_match":"1f477-2640-fe0f","uc_greedy":"1f477-2640","shortnames":[],"category":"people"},":woman_elf:":{"uc_base":"1f9dd-2640","uc_output":"1f9dd-200d-2640-fe0f","uc_match":"1f9dd-2640-fe0f","uc_greedy":"1f9dd-2640","shortnames":[],"category":"people"},":woman_facepalming:":{"uc_base":"1f926-2640","uc_output":"1f926-200d-2640-fe0f","uc_match":"1f926-2640-fe0f","uc_greedy":"1f926-2640","shortnames":[],"category":"people"},":woman_fairy:":{"uc_base":"1f9da-2640","uc_output":"1f9da-200d-2640-fe0f","uc_match":"1f9da-2640-fe0f","uc_greedy":"1f9da-2640","shortnames":[],"category":"people"},":woman_frowning:":{"uc_base":"1f64d-2640","uc_output":"1f64d-200d-2640-fe0f","uc_match":"1f64d-2640-fe0f","uc_greedy":"1f64d-2640","shortnames":[],"category":"people"},":woman_genie:":{"uc_base":"1f9de-2640","uc_output":"1f9de-200d-2640-fe0f","uc_match":"1f9de-2640-fe0f","uc_greedy":"1f9de-2640","shortnames":[],"category":"people"},":woman_gesturing_no:":{"uc_base":"1f645-2640","uc_output":"1f645-200d-2640-fe0f","uc_match":"1f645-2640-fe0f","uc_greedy":"1f645-2640","shortnames":[],"category":"people"},":woman_gesturing_ok:":{"uc_base":"1f646-2640","uc_output":"1f646-200d-2640-fe0f","uc_match":"1f646-2640-fe0f","uc_greedy":"1f646-2640","shortnames":[],"category":"people"},":woman_getting_face_massage:":{"uc_base":"1f486-2640","uc_output":"1f486-200d-2640-fe0f","uc_match":"1f486-2640-fe0f","uc_greedy":"1f486-2640","shortnames":[],"category":"people"},":woman_getting_haircut:":{"uc_base":"1f487-2640","uc_output":"1f487-200d-2640-fe0f","uc_match":"1f487-2640-fe0f","uc_greedy":"1f487-2640","shortnames":[],"category":"people"},":woman_guard:":{"uc_base":"1f482-2640","uc_output":"1f482-200d-2640-fe0f","uc_match":"1f482-2640-fe0f","uc_greedy":"1f482-2640","shortnames":[],"category":"people"},":woman_health_worker:":{"uc_base":"1f469-2695","uc_output":"1f469-200d-2695-fe0f","uc_match":"1f469-2695-fe0f","uc_greedy":"1f469-2695","shortnames":[],"category":"people"},":woman_in_lotus_position:":{"uc_base":"1f9d8-2640","uc_output":"1f9d8-200d-2640-fe0f","uc_match":"1f9d8-2640-fe0f","uc_greedy":"1f9d8-2640","shortnames":[],"category":"activity"},":woman_in_steamy_room:":{"uc_base":"1f9d6-2640","uc_output":"1f9d6-200d-2640-fe0f","uc_match":"1f9d6-2640-fe0f","uc_greedy":"1f9d6-2640","shortnames":[],"category":"people"},":woman_judge:":{"uc_base":"1f469-2696","uc_output":"1f469-200d-2696-fe0f","uc_match":"1f469-2696-fe0f","uc_greedy":"1f469-2696","shortnames":[],"category":"people"},":woman_juggling:":{"uc_base":"1f939-2640","uc_output":"1f939-200d-2640-fe0f","uc_match":"1f939-2640-fe0f","uc_greedy":"1f939-2640","shortnames":[],"category":"activity"},":woman_mage:":{"uc_base":"1f9d9-2640","uc_output":"1f9d9-200d-2640-fe0f","uc_match":"1f9d9-2640-fe0f","uc_greedy":"1f9d9-2640","shortnames":[],"category":"people"},":woman_mountain_biking:":{"uc_base":"1f6b5-2640","uc_output":"1f6b5-200d-2640-fe0f","uc_match":"1f6b5-2640-fe0f","uc_greedy":"1f6b5-2640","shortnames":[],"category":"activity"},":woman_pilot:":{"uc_base":"1f469-2708","uc_output":"1f469-200d-2708-fe0f","uc_match":"1f469-2708-fe0f","uc_greedy":"1f469-2708","shortnames":[],"category":"people"},":woman_playing_handball:":{"uc_base":"1f93e-2640","uc_output":"1f93e-200d-2640-fe0f","uc_match":"1f93e-2640-fe0f","uc_greedy":"1f93e-2640","shortnames":[],"category":"activity"},":woman_playing_water_polo:":{"uc_base":"1f93d-2640","uc_output":"1f93d-200d-2640-fe0f","uc_match":"1f93d-2640-fe0f","uc_greedy":"1f93d-2640","shortnames":[],"category":"activity"},":woman_police_officer:":{"uc_base":"1f46e-2640","uc_output":"1f46e-200d-2640-fe0f","uc_match":"1f46e-2640-fe0f","uc_greedy":"1f46e-2640","shortnames":[],"category":"people"},":woman_pouting:":{"uc_base":"1f64e-2640","uc_output":"1f64e-200d-2640-fe0f","uc_match":"1f64e-2640-fe0f","uc_greedy":"1f64e-2640","shortnames":[],"category":"people"},":woman_raising_hand:":{"uc_base":"1f64b-2640","uc_output":"1f64b-200d-2640-fe0f","uc_match":"1f64b-2640-fe0f","uc_greedy":"1f64b-2640","shortnames":[],"category":"people"},":woman_rowing_boat:":{"uc_base":"1f6a3-2640","uc_output":"1f6a3-200d-2640-fe0f","uc_match":"1f6a3-2640-fe0f","uc_greedy":"1f6a3-2640","shortnames":[],"category":"activity"},":woman_running:":{"uc_base":"1f3c3-2640","uc_output":"1f3c3-200d-2640-fe0f","uc_match":"1f3c3-2640-fe0f","uc_greedy":"1f3c3-2640","shortnames":[],"category":"people"},":woman_shrugging:":{"uc_base":"1f937-2640","uc_output":"1f937-200d-2640-fe0f","uc_match":"1f937-2640-fe0f","uc_greedy":"1f937-2640","shortnames":[],"category":"people"},":woman_superhero:":{"uc_base":"1f9b8-2640","uc_output":"1f9b8-200d-2640-fe0f","uc_match":"1f9b8-2640-fe0f","uc_greedy":"1f9b8-2640","shortnames":[],"category":"people"},":woman_supervillain:":{"uc_base":"1f9b9-2640","uc_output":"1f9b9-200d-2640-fe0f","uc_match":"1f9b9-2640-fe0f","uc_greedy":"1f9b9-2640","shortnames":[],"category":"people"},":woman_surfing:":{"uc_base":"1f3c4-2640","uc_output":"1f3c4-200d-2640-fe0f","uc_match":"1f3c4-2640-fe0f","uc_greedy":"1f3c4-2640","shortnames":[],"category":"activity"},":woman_swimming:":{"uc_base":"1f3ca-2640","uc_output":"1f3ca-200d-2640-fe0f","uc_match":"1f3ca-2640-fe0f","uc_greedy":"1f3ca-2640","shortnames":[],"category":"activity"},":woman_tipping_hand:":{"uc_base":"1f481-2640","uc_output":"1f481-200d-2640-fe0f","uc_match":"1f481-2640-fe0f","uc_greedy":"1f481-2640","shortnames":[],"category":"people"},":woman_vampire:":{"uc_base":"1f9db-2640","uc_output":"1f9db-200d-2640-fe0f","uc_match":"1f9db-2640-fe0f","uc_greedy":"1f9db-2640","shortnames":[],"category":"people"},":woman_walking:":{"uc_base":"1f6b6-2640","uc_output":"1f6b6-200d-2640-fe0f","uc_match":"1f6b6-2640-fe0f","uc_greedy":"1f6b6-2640","shortnames":[],"category":"people"},":woman_wearing_turban:":{"uc_base":"1f473-2640","uc_output":"1f473-200d-2640-fe0f","uc_match":"1f473-2640-fe0f","uc_greedy":"1f473-2640","shortnames":[],"category":"people"},":woman_zombie:":{"uc_base":"1f9df-2640","uc_output":"1f9df-200d-2640-fe0f","uc_match":"1f9df-2640-fe0f","uc_greedy":"1f9df-2640","shortnames":[],"category":"people"},":women_with_bunny_ears_partying:":{"uc_base":"1f46f-2640","uc_output":"1f46f-200d-2640-fe0f","uc_match":"1f46f-2640-fe0f","uc_greedy":"1f46f-2640","shortnames":[],"category":"people"},":women_wrestling:":{"uc_base":"1f93c-2640","uc_output":"1f93c-200d-2640-fe0f","uc_match":"1f93c-2640-fe0f","uc_greedy":"1f93c-2640","shortnames":[],"category":"activity"},":family_man_boy:":{"uc_base":"1f468-1f466","uc_output":"1f468-200d-1f466","uc_match":"1f468-1f466","uc_greedy":"1f468-1f466","shortnames":[],"category":"people"},":family_man_girl:":{"uc_base":"1f468-1f467","uc_output":"1f468-200d-1f467","uc_match":"1f468-1f467","uc_greedy":"1f468-1f467","shortnames":[],"category":"people"},":family_woman_boy:":{"uc_base":"1f469-1f466","uc_output":"1f469-200d-1f466","uc_match":"1f469-1f466","uc_greedy":"1f469-1f466","shortnames":[],"category":"people"},":family_woman_girl:":{"uc_base":"1f469-1f467","uc_output":"1f469-200d-1f467","uc_match":"1f469-1f467","uc_greedy":"1f469-1f467","shortnames":[],"category":"people"},":man_artist:":{"uc_base":"1f468-1f3a8","uc_output":"1f468-200d-1f3a8","uc_match":"1f468-1f3a8","uc_greedy":"1f468-1f3a8","shortnames":[],"category":"people"},":man_astronaut:":{"uc_base":"1f468-1f680","uc_output":"1f468-200d-1f680","uc_match":"1f468-1f680","uc_greedy":"1f468-1f680","shortnames":[],"category":"people"},":man_bald:":{"uc_base":"1f468-1f9b2","uc_output":"1f468-200d-1f9b2","uc_match":"1f468-1f9b2","uc_greedy":"1f468-1f9b2","shortnames":[],"category":"people"},":man_cook:":{"uc_base":"1f468-1f373","uc_output":"1f468-200d-1f373","uc_match":"1f468-1f373","uc_greedy":"1f468-1f373","shortnames":[],"category":"people"},":man_curly_haired:":{"uc_base":"1f468-1f9b1","uc_output":"1f468-200d-1f9b1","uc_match":"1f468-1f9b1","uc_greedy":"1f468-1f9b1","shortnames":[],"category":"people"},":man_factory_worker:":{"uc_base":"1f468-1f3ed","uc_output":"1f468-200d-1f3ed","uc_match":"1f468-1f3ed","uc_greedy":"1f468-1f3ed","shortnames":[],"category":"people"},":man_farmer:":{"uc_base":"1f468-1f33e","uc_output":"1f468-200d-1f33e","uc_match":"1f468-1f33e","uc_greedy":"1f468-1f33e","shortnames":[],"category":"people"},":man_firefighter:":{"uc_base":"1f468-1f692","uc_output":"1f468-200d-1f692","uc_match":"1f468-1f692","uc_greedy":"1f468-1f692","shortnames":[],"category":"people"},":man_mechanic:":{"uc_base":"1f468-1f527","uc_output":"1f468-200d-1f527","uc_match":"1f468-1f527","uc_greedy":"1f468-1f527","shortnames":[],"category":"people"},":man_office_worker:":{"uc_base":"1f468-1f4bc","uc_output":"1f468-200d-1f4bc","uc_match":"1f468-1f4bc","uc_greedy":"1f468-1f4bc","shortnames":[],"category":"people"},":man_red_haired:":{"uc_base":"1f468-1f9b0","uc_output":"1f468-200d-1f9b0","uc_match":"1f468-1f9b0","uc_greedy":"1f468-1f9b0","shortnames":[],"category":"people"},":man_scientist:":{"uc_base":"1f468-1f52c","uc_output":"1f468-200d-1f52c","uc_match":"1f468-1f52c","uc_greedy":"1f468-1f52c","shortnames":[],"category":"people"},":man_singer:":{"uc_base":"1f468-1f3a4","uc_output":"1f468-200d-1f3a4","uc_match":"1f468-1f3a4","uc_greedy":"1f468-1f3a4","shortnames":[],"category":"people"},":man_student:":{"uc_base":"1f468-1f393","uc_output":"1f468-200d-1f393","uc_match":"1f468-1f393","uc_greedy":"1f468-1f393","shortnames":[],"category":"people"},":man_teacher:":{"uc_base":"1f468-1f3eb","uc_output":"1f468-200d-1f3eb","uc_match":"1f468-1f3eb","uc_greedy":"1f468-1f3eb","shortnames":[],"category":"people"},":man_technologist:":{"uc_base":"1f468-1f4bb","uc_output":"1f468-200d-1f4bb","uc_match":"1f468-1f4bb","uc_greedy":"1f468-1f4bb","shortnames":[],"category":"people"},":man_white_haired:":{"uc_base":"1f468-1f9b3","uc_output":"1f468-200d-1f9b3","uc_match":"1f468-1f9b3","uc_greedy":"1f468-1f9b3","shortnames":[],"category":"people"},":woman_artist:":{"uc_base":"1f469-1f3a8","uc_output":"1f469-200d-1f3a8","uc_match":"1f469-1f3a8","uc_greedy":"1f469-1f3a8","shortnames":[],"category":"people"},":woman_astronaut:":{"uc_base":"1f469-1f680","uc_output":"1f469-200d-1f680","uc_match":"1f469-1f680","uc_greedy":"1f469-1f680","shortnames":[],"category":"people"},":woman_bald:":{"uc_base":"1f469-1f9b2","uc_output":"1f469-200d-1f9b2","uc_match":"1f469-1f9b2","uc_greedy":"1f469-1f9b2","shortnames":[],"category":"people"},":woman_cook:":{"uc_base":"1f469-1f373","uc_output":"1f469-200d-1f373","uc_match":"1f469-1f373","uc_greedy":"1f469-1f373","shortnames":[],"category":"people"},":woman_curly_haired:":{"uc_base":"1f469-1f9b1","uc_output":"1f469-200d-1f9b1","uc_match":"1f469-1f9b1","uc_greedy":"1f469-1f9b1","shortnames":[],"category":"people"},":woman_factory_worker:":{"uc_base":"1f469-1f3ed","uc_output":"1f469-200d-1f3ed","uc_match":"1f469-1f3ed","uc_greedy":"1f469-1f3ed","shortnames":[],"category":"people"},":woman_farmer:":{"uc_base":"1f469-1f33e","uc_output":"1f469-200d-1f33e","uc_match":"1f469-1f33e","uc_greedy":"1f469-1f33e","shortnames":[],"category":"people"},":woman_firefighter:":{"uc_base":"1f469-1f692","uc_output":"1f469-200d-1f692","uc_match":"1f469-1f692","uc_greedy":"1f469-1f692","shortnames":[],"category":"people"},":woman_mechanic:":{"uc_base":"1f469-1f527","uc_output":"1f469-200d-1f527","uc_match":"1f469-1f527","uc_greedy":"1f469-1f527","shortnames":[],"category":"people"},":woman_office_worker:":{"uc_base":"1f469-1f4bc","uc_output":"1f469-200d-1f4bc","uc_match":"1f469-1f4bc","uc_greedy":"1f469-1f4bc","shortnames":[],"category":"people"},":woman_red_haired:":{"uc_base":"1f469-1f9b0","uc_output":"1f469-200d-1f9b0","uc_match":"1f469-1f9b0","uc_greedy":"1f469-1f9b0","shortnames":[],"category":"people"},":woman_scientist:":{"uc_base":"1f469-1f52c","uc_output":"1f469-200d-1f52c","uc_match":"1f469-1f52c","uc_greedy":"1f469-1f52c","shortnames":[],"category":"people"},":woman_singer:":{"uc_base":"1f469-1f3a4","uc_output":"1f469-200d-1f3a4","uc_match":"1f469-1f3a4","uc_greedy":"1f469-1f3a4","shortnames":[],"category":"people"},":woman_student:":{"uc_base":"1f469-1f393","uc_output":"1f469-200d-1f393","uc_match":"1f469-1f393","uc_greedy":"1f469-1f393","shortnames":[],"category":"people"},":woman_teacher:":{"uc_base":"1f469-1f3eb","uc_output":"1f469-200d-1f3eb","uc_match":"1f469-1f3eb","uc_greedy":"1f469-1f3eb","shortnames":[],"category":"people"},":woman_technologist:":{"uc_base":"1f469-1f4bb","uc_output":"1f469-200d-1f4bb","uc_match":"1f469-1f4bb","uc_greedy":"1f469-1f4bb","shortnames":[],"category":"people"},":woman_white_haired:":{"uc_base":"1f469-1f9b3","uc_output":"1f469-200d-1f9b3","uc_match":"1f469-1f9b3","uc_greedy":"1f469-1f9b3","shortnames":[],"category":"people"},":asterisk:":{"uc_base":"002a-20e3","uc_output":"002a-fe0f-20e3","uc_match":"002a-20e3","uc_greedy":"002a-20e3","shortnames":[":keycap_asterisk:"],"category":"symbols"},":eight:":{"uc_base":"0038-20e3","uc_output":"0038-fe0f-20e3","uc_match":"0038-20e3","uc_greedy":"0038-20e3","shortnames":[],"category":"symbols"},":five:":{"uc_base":"0035-20e3","uc_output":"0035-fe0f-20e3","uc_match":"0035-20e3","uc_greedy":"0035-20e3","shortnames":[],"category":"symbols"},":four:":{"uc_base":"0034-20e3","uc_output":"0034-fe0f-20e3","uc_match":"0034-20e3","uc_greedy":"0034-20e3","shortnames":[],"category":"symbols"},":hash:":{"uc_base":"0023-20e3","uc_output":"0023-fe0f-20e3","uc_match":"0023-20e3","uc_greedy":"0023-20e3","shortnames":[],"category":"symbols"},":nine:":{"uc_base":"0039-20e3","uc_output":"0039-fe0f-20e3","uc_match":"0039-20e3","uc_greedy":"0039-20e3","shortnames":[],"category":"symbols"},":one:":{"uc_base":"0031-20e3","uc_output":"0031-fe0f-20e3","uc_match":"0031-20e3","uc_greedy":"0031-20e3","shortnames":[],"category":"symbols"},":seven:":{"uc_base":"0037-20e3","uc_output":"0037-fe0f-20e3","uc_match":"0037-20e3","uc_greedy":"0037-20e3","shortnames":[],"category":"symbols"},":six:":{"uc_base":"0036-20e3","uc_output":"0036-fe0f-20e3","uc_match":"0036-20e3","uc_greedy":"0036-20e3","shortnames":[],"category":"symbols"},":three:":{"uc_base":"0033-20e3","uc_output":"0033-fe0f-20e3","uc_match":"0033-20e3","uc_greedy":"0033-20e3","shortnames":[],"category":"symbols"},":two:":{"uc_base":"0032-20e3","uc_output":"0032-fe0f-20e3","uc_match":"0032-20e3","uc_greedy":"0032-20e3","shortnames":[],"category":"symbols"},":zero:":{"uc_base":"0030-20e3","uc_output":"0030-fe0f-20e3","uc_match":"0030-20e3","uc_greedy":"0030-20e3","shortnames":[],"category":"symbols"},":adult_tone1:":{"uc_base":"1f9d1-1f3fb","uc_output":"1f9d1-1f3fb","uc_match":"1f9d1-1f3fb","uc_greedy":"1f9d1-1f3fb","shortnames":[":adult_light_skin_tone:"],"category":"people"},":adult_tone2:":{"uc_base":"1f9d1-1f3fc","uc_output":"1f9d1-1f3fc","uc_match":"1f9d1-1f3fc","uc_greedy":"1f9d1-1f3fc","shortnames":[":adult_medium_light_skin_tone:"],"category":"people"},":adult_tone3:":{"uc_base":"1f9d1-1f3fd","uc_output":"1f9d1-1f3fd","uc_match":"1f9d1-1f3fd","uc_greedy":"1f9d1-1f3fd","shortnames":[":adult_medium_skin_tone:"],"category":"people"},":adult_tone4:":{"uc_base":"1f9d1-1f3fe","uc_output":"1f9d1-1f3fe","uc_match":"1f9d1-1f3fe","uc_greedy":"1f9d1-1f3fe","shortnames":[":adult_medium_dark_skin_tone:"],"category":"people"},":adult_tone5:":{"uc_base":"1f9d1-1f3ff","uc_output":"1f9d1-1f3ff","uc_match":"1f9d1-1f3ff","uc_greedy":"1f9d1-1f3ff","shortnames":[":adult_dark_skin_tone:"],"category":"people"},":angel_tone1:":{"uc_base":"1f47c-1f3fb","uc_output":"1f47c-1f3fb","uc_match":"1f47c-1f3fb","uc_greedy":"1f47c-1f3fb","shortnames":[],"category":"people"},":angel_tone2:":{"uc_base":"1f47c-1f3fc","uc_output":"1f47c-1f3fc","uc_match":"1f47c-1f3fc","uc_greedy":"1f47c-1f3fc","shortnames":[],"category":"people"},":angel_tone3:":{"uc_base":"1f47c-1f3fd","uc_output":"1f47c-1f3fd","uc_match":"1f47c-1f3fd","uc_greedy":"1f47c-1f3fd","shortnames":[],"category":"people"},":angel_tone4:":{"uc_base":"1f47c-1f3fe","uc_output":"1f47c-1f3fe","uc_match":"1f47c-1f3fe","uc_greedy":"1f47c-1f3fe","shortnames":[],"category":"people"},":angel_tone5:":{"uc_base":"1f47c-1f3ff","uc_output":"1f47c-1f3ff","uc_match":"1f47c-1f3ff","uc_greedy":"1f47c-1f3ff","shortnames":[],"category":"people"},":baby_tone1:":{"uc_base":"1f476-1f3fb","uc_output":"1f476-1f3fb","uc_match":"1f476-1f3fb","uc_greedy":"1f476-1f3fb","shortnames":[],"category":"people"},":baby_tone2:":{"uc_base":"1f476-1f3fc","uc_output":"1f476-1f3fc","uc_match":"1f476-1f3fc","uc_greedy":"1f476-1f3fc","shortnames":[],"category":"people"},":baby_tone3:":{"uc_base":"1f476-1f3fd","uc_output":"1f476-1f3fd","uc_match":"1f476-1f3fd","uc_greedy":"1f476-1f3fd","shortnames":[],"category":"people"},":baby_tone4:":{"uc_base":"1f476-1f3fe","uc_output":"1f476-1f3fe","uc_match":"1f476-1f3fe","uc_greedy":"1f476-1f3fe","shortnames":[],"category":"people"},":baby_tone5:":{"uc_base":"1f476-1f3ff","uc_output":"1f476-1f3ff","uc_match":"1f476-1f3ff","uc_greedy":"1f476-1f3ff","shortnames":[],"category":"people"},":bath_tone1:":{"uc_base":"1f6c0-1f3fb","uc_output":"1f6c0-1f3fb","uc_match":"1f6c0-1f3fb","uc_greedy":"1f6c0-1f3fb","shortnames":[],"category":"objects"},":bath_tone2:":{"uc_base":"1f6c0-1f3fc","uc_output":"1f6c0-1f3fc","uc_match":"1f6c0-1f3fc","uc_greedy":"1f6c0-1f3fc","shortnames":[],"category":"objects"},":bath_tone3:":{"uc_base":"1f6c0-1f3fd","uc_output":"1f6c0-1f3fd","uc_match":"1f6c0-1f3fd","uc_greedy":"1f6c0-1f3fd","shortnames":[],"category":"objects"},":bath_tone4:":{"uc_base":"1f6c0-1f3fe","uc_output":"1f6c0-1f3fe","uc_match":"1f6c0-1f3fe","uc_greedy":"1f6c0-1f3fe","shortnames":[],"category":"objects"},":bath_tone5:":{"uc_base":"1f6c0-1f3ff","uc_output":"1f6c0-1f3ff","uc_match":"1f6c0-1f3ff","uc_greedy":"1f6c0-1f3ff","shortnames":[],"category":"objects"},":bearded_person_tone1:":{"uc_base":"1f9d4-1f3fb","uc_output":"1f9d4-1f3fb","uc_match":"1f9d4-1f3fb","uc_greedy":"1f9d4-1f3fb","shortnames":[":bearded_person_light_skin_tone:"],"category":"people"},":bearded_person_tone2:":{"uc_base":"1f9d4-1f3fc","uc_output":"1f9d4-1f3fc","uc_match":"1f9d4-1f3fc","uc_greedy":"1f9d4-1f3fc","shortnames":[":bearded_person_medium_light_skin_tone:"],"category":"people"},":bearded_person_tone3:":{"uc_base":"1f9d4-1f3fd","uc_output":"1f9d4-1f3fd","uc_match":"1f9d4-1f3fd","uc_greedy":"1f9d4-1f3fd","shortnames":[":bearded_person_medium_skin_tone:"],"category":"people"},":bearded_person_tone4:":{"uc_base":"1f9d4-1f3fe","uc_output":"1f9d4-1f3fe","uc_match":"1f9d4-1f3fe","uc_greedy":"1f9d4-1f3fe","shortnames":[":bearded_person_medium_dark_skin_tone:"],"category":"people"},":bearded_person_tone5:":{"uc_base":"1f9d4-1f3ff","uc_output":"1f9d4-1f3ff","uc_match":"1f9d4-1f3ff","uc_greedy":"1f9d4-1f3ff","shortnames":[":bearded_person_dark_skin_tone:"],"category":"people"},":blond_haired_person_tone1:":{"uc_base":"1f471-1f3fb","uc_output":"1f471-1f3fb","uc_match":"1f471-1f3fb","uc_greedy":"1f471-1f3fb","shortnames":[":person_with_blond_hair_tone1:"],"category":"people"},":blond_haired_person_tone2:":{"uc_base":"1f471-1f3fc","uc_output":"1f471-1f3fc","uc_match":"1f471-1f3fc","uc_greedy":"1f471-1f3fc","shortnames":[":person_with_blond_hair_tone2:"],"category":"people"},":blond_haired_person_tone3:":{"uc_base":"1f471-1f3fd","uc_output":"1f471-1f3fd","uc_match":"1f471-1f3fd","uc_greedy":"1f471-1f3fd","shortnames":[":person_with_blond_hair_tone3:"],"category":"people"},":blond_haired_person_tone4:":{"uc_base":"1f471-1f3fe","uc_output":"1f471-1f3fe","uc_match":"1f471-1f3fe","uc_greedy":"1f471-1f3fe","shortnames":[":person_with_blond_hair_tone4:"],"category":"people"},":blond_haired_person_tone5:":{"uc_base":"1f471-1f3ff","uc_output":"1f471-1f3ff","uc_match":"1f471-1f3ff","uc_greedy":"1f471-1f3ff","shortnames":[":person_with_blond_hair_tone5:"],"category":"people"},":boy_tone1:":{"uc_base":"1f466-1f3fb","uc_output":"1f466-1f3fb","uc_match":"1f466-1f3fb","uc_greedy":"1f466-1f3fb","shortnames":[],"category":"people"},":boy_tone2:":{"uc_base":"1f466-1f3fc","uc_output":"1f466-1f3fc","uc_match":"1f466-1f3fc","uc_greedy":"1f466-1f3fc","shortnames":[],"category":"people"},":boy_tone3:":{"uc_base":"1f466-1f3fd","uc_output":"1f466-1f3fd","uc_match":"1f466-1f3fd","uc_greedy":"1f466-1f3fd","shortnames":[],"category":"people"},":boy_tone4:":{"uc_base":"1f466-1f3fe","uc_output":"1f466-1f3fe","uc_match":"1f466-1f3fe","uc_greedy":"1f466-1f3fe","shortnames":[],"category":"people"},":boy_tone5:":{"uc_base":"1f466-1f3ff","uc_output":"1f466-1f3ff","uc_match":"1f466-1f3ff","uc_greedy":"1f466-1f3ff","shortnames":[],"category":"people"},":breast_feeding_tone1:":{"uc_base":"1f931-1f3fb","uc_output":"1f931-1f3fb","uc_match":"1f931-1f3fb","uc_greedy":"1f931-1f3fb","shortnames":[":breast_feeding_light_skin_tone:"],"category":"people"},":breast_feeding_tone2:":{"uc_base":"1f931-1f3fc","uc_output":"1f931-1f3fc","uc_match":"1f931-1f3fc","uc_greedy":"1f931-1f3fc","shortnames":[":breast_feeding_medium_light_skin_tone:"],"category":"people"},":breast_feeding_tone3:":{"uc_base":"1f931-1f3fd","uc_output":"1f931-1f3fd","uc_match":"1f931-1f3fd","uc_greedy":"1f931-1f3fd","shortnames":[":breast_feeding_medium_skin_tone:"],"category":"people"},":breast_feeding_tone4:":{"uc_base":"1f931-1f3fe","uc_output":"1f931-1f3fe","uc_match":"1f931-1f3fe","uc_greedy":"1f931-1f3fe","shortnames":[":breast_feeding_medium_dark_skin_tone:"],"category":"people"},":breast_feeding_tone5:":{"uc_base":"1f931-1f3ff","uc_output":"1f931-1f3ff","uc_match":"1f931-1f3ff","uc_greedy":"1f931-1f3ff","shortnames":[":breast_feeding_dark_skin_tone:"],"category":"people"},":bride_with_veil_tone1:":{"uc_base":"1f470-1f3fb","uc_output":"1f470-1f3fb","uc_match":"1f470-1f3fb","uc_greedy":"1f470-1f3fb","shortnames":[],"category":"people"},":bride_with_veil_tone2:":{"uc_base":"1f470-1f3fc","uc_output":"1f470-1f3fc","uc_match":"1f470-1f3fc","uc_greedy":"1f470-1f3fc","shortnames":[],"category":"people"},":bride_with_veil_tone3:":{"uc_base":"1f470-1f3fd","uc_output":"1f470-1f3fd","uc_match":"1f470-1f3fd","uc_greedy":"1f470-1f3fd","shortnames":[],"category":"people"},":bride_with_veil_tone4:":{"uc_base":"1f470-1f3fe","uc_output":"1f470-1f3fe","uc_match":"1f470-1f3fe","uc_greedy":"1f470-1f3fe","shortnames":[],"category":"people"},":bride_with_veil_tone5:":{"uc_base":"1f470-1f3ff","uc_output":"1f470-1f3ff","uc_match":"1f470-1f3ff","uc_greedy":"1f470-1f3ff","shortnames":[],"category":"people"},":call_me_tone1:":{"uc_base":"1f919-1f3fb","uc_output":"1f919-1f3fb","uc_match":"1f919-1f3fb","uc_greedy":"1f919-1f3fb","shortnames":[":call_me_hand_tone1:"],"category":"people"},":call_me_tone2:":{"uc_base":"1f919-1f3fc","uc_output":"1f919-1f3fc","uc_match":"1f919-1f3fc","uc_greedy":"1f919-1f3fc","shortnames":[":call_me_hand_tone2:"],"category":"people"},":call_me_tone3:":{"uc_base":"1f919-1f3fd","uc_output":"1f919-1f3fd","uc_match":"1f919-1f3fd","uc_greedy":"1f919-1f3fd","shortnames":[":call_me_hand_tone3:"],"category":"people"},":call_me_tone4:":{"uc_base":"1f919-1f3fe","uc_output":"1f919-1f3fe","uc_match":"1f919-1f3fe","uc_greedy":"1f919-1f3fe","shortnames":[":call_me_hand_tone4:"],"category":"people"},":call_me_tone5:":{"uc_base":"1f919-1f3ff","uc_output":"1f919-1f3ff","uc_match":"1f919-1f3ff","uc_greedy":"1f919-1f3ff","shortnames":[":call_me_hand_tone5:"],"category":"people"},":child_tone1:":{"uc_base":"1f9d2-1f3fb","uc_output":"1f9d2-1f3fb","uc_match":"1f9d2-1f3fb","uc_greedy":"1f9d2-1f3fb","shortnames":[":child_light_skin_tone:"],"category":"people"},":child_tone2:":{"uc_base":"1f9d2-1f3fc","uc_output":"1f9d2-1f3fc","uc_match":"1f9d2-1f3fc","uc_greedy":"1f9d2-1f3fc","shortnames":[":child_medium_light_skin_tone:"],"category":"people"},":child_tone3:":{"uc_base":"1f9d2-1f3fd","uc_output":"1f9d2-1f3fd","uc_match":"1f9d2-1f3fd","uc_greedy":"1f9d2-1f3fd","shortnames":[":child_medium_skin_tone:"],"category":"people"},":child_tone4:":{"uc_base":"1f9d2-1f3fe","uc_output":"1f9d2-1f3fe","uc_match":"1f9d2-1f3fe","uc_greedy":"1f9d2-1f3fe","shortnames":[":child_medium_dark_skin_tone:"],"category":"people"},":child_tone5:":{"uc_base":"1f9d2-1f3ff","uc_output":"1f9d2-1f3ff","uc_match":"1f9d2-1f3ff","uc_greedy":"1f9d2-1f3ff","shortnames":[":child_dark_skin_tone:"],"category":"people"},":clap_tone1:":{"uc_base":"1f44f-1f3fb","uc_output":"1f44f-1f3fb","uc_match":"1f44f-1f3fb","uc_greedy":"1f44f-1f3fb","shortnames":[],"category":"people"},":clap_tone2:":{"uc_base":"1f44f-1f3fc","uc_output":"1f44f-1f3fc","uc_match":"1f44f-1f3fc","uc_greedy":"1f44f-1f3fc","shortnames":[],"category":"people"},":clap_tone3:":{"uc_base":"1f44f-1f3fd","uc_output":"1f44f-1f3fd","uc_match":"1f44f-1f3fd","uc_greedy":"1f44f-1f3fd","shortnames":[],"category":"people"},":clap_tone4:":{"uc_base":"1f44f-1f3fe","uc_output":"1f44f-1f3fe","uc_match":"1f44f-1f3fe","uc_greedy":"1f44f-1f3fe","shortnames":[],"category":"people"},":clap_tone5:":{"uc_base":"1f44f-1f3ff","uc_output":"1f44f-1f3ff","uc_match":"1f44f-1f3ff","uc_greedy":"1f44f-1f3ff","shortnames":[],"category":"people"},":construction_worker_tone1:":{"uc_base":"1f477-1f3fb","uc_output":"1f477-1f3fb","uc_match":"1f477-1f3fb","uc_greedy":"1f477-1f3fb","shortnames":[],"category":"people"},":construction_worker_tone2:":{"uc_base":"1f477-1f3fc","uc_output":"1f477-1f3fc","uc_match":"1f477-1f3fc","uc_greedy":"1f477-1f3fc","shortnames":[],"category":"people"},":construction_worker_tone3:":{"uc_base":"1f477-1f3fd","uc_output":"1f477-1f3fd","uc_match":"1f477-1f3fd","uc_greedy":"1f477-1f3fd","shortnames":[],"category":"people"},":construction_worker_tone4:":{"uc_base":"1f477-1f3fe","uc_output":"1f477-1f3fe","uc_match":"1f477-1f3fe","uc_greedy":"1f477-1f3fe","shortnames":[],"category":"people"},":construction_worker_tone5:":{"uc_base":"1f477-1f3ff","uc_output":"1f477-1f3ff","uc_match":"1f477-1f3ff","uc_greedy":"1f477-1f3ff","shortnames":[],"category":"people"},":dancer_tone1:":{"uc_base":"1f483-1f3fb","uc_output":"1f483-1f3fb","uc_match":"1f483-1f3fb","uc_greedy":"1f483-1f3fb","shortnames":[],"category":"people"},":dancer_tone2:":{"uc_base":"1f483-1f3fc","uc_output":"1f483-1f3fc","uc_match":"1f483-1f3fc","uc_greedy":"1f483-1f3fc","shortnames":[],"category":"people"},":dancer_tone3:":{"uc_base":"1f483-1f3fd","uc_output":"1f483-1f3fd","uc_match":"1f483-1f3fd","uc_greedy":"1f483-1f3fd","shortnames":[],"category":"people"},":dancer_tone4:":{"uc_base":"1f483-1f3fe","uc_output":"1f483-1f3fe","uc_match":"1f483-1f3fe","uc_greedy":"1f483-1f3fe","shortnames":[],"category":"people"},":dancer_tone5:":{"uc_base":"1f483-1f3ff","uc_output":"1f483-1f3ff","uc_match":"1f483-1f3ff","uc_greedy":"1f483-1f3ff","shortnames":[],"category":"people"},":detective_tone1:":{"uc_base":"1f575-1f3fb","uc_output":"1f575-1f3fb","uc_match":"1f575-fe0f-1f3fb","uc_greedy":"1f575-fe0f-1f3fb","shortnames":[":spy_tone1:",":sleuth_or_spy_tone1:"],"category":"people"},":detective_tone2:":{"uc_base":"1f575-1f3fc","uc_output":"1f575-1f3fc","uc_match":"1f575-fe0f-1f3fc","uc_greedy":"1f575-fe0f-1f3fc","shortnames":[":spy_tone2:",":sleuth_or_spy_tone2:"],"category":"people"},":detective_tone3:":{"uc_base":"1f575-1f3fd","uc_output":"1f575-1f3fd","uc_match":"1f575-fe0f-1f3fd","uc_greedy":"1f575-fe0f-1f3fd","shortnames":[":spy_tone3:",":sleuth_or_spy_tone3:"],"category":"people"},":detective_tone4:":{"uc_base":"1f575-1f3fe","uc_output":"1f575-1f3fe","uc_match":"1f575-fe0f-1f3fe","uc_greedy":"1f575-fe0f-1f3fe","shortnames":[":spy_tone4:",":sleuth_or_spy_tone4:"],"category":"people"},":detective_tone5:":{"uc_base":"1f575-1f3ff","uc_output":"1f575-1f3ff","uc_match":"1f575-fe0f-1f3ff","uc_greedy":"1f575-fe0f-1f3ff","shortnames":[":spy_tone5:",":sleuth_or_spy_tone5:"],"category":"people"},":ear_tone1:":{"uc_base":"1f442-1f3fb","uc_output":"1f442-1f3fb","uc_match":"1f442-1f3fb","uc_greedy":"1f442-1f3fb","shortnames":[],"category":"people"},":ear_tone2:":{"uc_base":"1f442-1f3fc","uc_output":"1f442-1f3fc","uc_match":"1f442-1f3fc","uc_greedy":"1f442-1f3fc","shortnames":[],"category":"people"},":ear_tone3:":{"uc_base":"1f442-1f3fd","uc_output":"1f442-1f3fd","uc_match":"1f442-1f3fd","uc_greedy":"1f442-1f3fd","shortnames":[],"category":"people"},":ear_tone4:":{"uc_base":"1f442-1f3fe","uc_output":"1f442-1f3fe","uc_match":"1f442-1f3fe","uc_greedy":"1f442-1f3fe","shortnames":[],"category":"people"},":ear_tone5:":{"uc_base":"1f442-1f3ff","uc_output":"1f442-1f3ff","uc_match":"1f442-1f3ff","uc_greedy":"1f442-1f3ff","shortnames":[],"category":"people"},":elf_tone1:":{"uc_base":"1f9dd-1f3fb","uc_output":"1f9dd-1f3fb","uc_match":"1f9dd-1f3fb","uc_greedy":"1f9dd-1f3fb","shortnames":[":elf_light_skin_tone:"],"category":"people"},":elf_tone2:":{"uc_base":"1f9dd-1f3fc","uc_output":"1f9dd-1f3fc","uc_match":"1f9dd-1f3fc","uc_greedy":"1f9dd-1f3fc","shortnames":[":elf_medium_light_skin_tone:"],"category":"people"},":elf_tone3:":{"uc_base":"1f9dd-1f3fd","uc_output":"1f9dd-1f3fd","uc_match":"1f9dd-1f3fd","uc_greedy":"1f9dd-1f3fd","shortnames":[":elf_medium_skin_tone:"],"category":"people"},":elf_tone4:":{"uc_base":"1f9dd-1f3fe","uc_output":"1f9dd-1f3fe","uc_match":"1f9dd-1f3fe","uc_greedy":"1f9dd-1f3fe","shortnames":[":elf_medium_dark_skin_tone:"],"category":"people"},":elf_tone5:":{"uc_base":"1f9dd-1f3ff","uc_output":"1f9dd-1f3ff","uc_match":"1f9dd-1f3ff","uc_greedy":"1f9dd-1f3ff","shortnames":[":elf_dark_skin_tone:"],"category":"people"},":fairy_tone1:":{"uc_base":"1f9da-1f3fb","uc_output":"1f9da-1f3fb","uc_match":"1f9da-1f3fb","uc_greedy":"1f9da-1f3fb","shortnames":[":fairy_light_skin_tone:"],"category":"people"},":fairy_tone2:":{"uc_base":"1f9da-1f3fc","uc_output":"1f9da-1f3fc","uc_match":"1f9da-1f3fc","uc_greedy":"1f9da-1f3fc","shortnames":[":fairy_medium_light_skin_tone:"],"category":"people"},":fairy_tone3:":{"uc_base":"1f9da-1f3fd","uc_output":"1f9da-1f3fd","uc_match":"1f9da-1f3fd","uc_greedy":"1f9da-1f3fd","shortnames":[":fairy_medium_skin_tone:"],"category":"people"},":fairy_tone4:":{"uc_base":"1f9da-1f3fe","uc_output":"1f9da-1f3fe","uc_match":"1f9da-1f3fe","uc_greedy":"1f9da-1f3fe","shortnames":[":fairy_medium_dark_skin_tone:"],"category":"people"},":fairy_tone5:":{"uc_base":"1f9da-1f3ff","uc_output":"1f9da-1f3ff","uc_match":"1f9da-1f3ff","uc_greedy":"1f9da-1f3ff","shortnames":[":fairy_dark_skin_tone:"],"category":"people"},":fingers_crossed_tone1:":{"uc_base":"1f91e-1f3fb","uc_output":"1f91e-1f3fb","uc_match":"1f91e-1f3fb","uc_greedy":"1f91e-1f3fb","shortnames":[":hand_with_index_and_middle_fingers_crossed_tone1:"],"category":"people"},":fingers_crossed_tone2:":{"uc_base":"1f91e-1f3fc","uc_output":"1f91e-1f3fc","uc_match":"1f91e-1f3fc","uc_greedy":"1f91e-1f3fc","shortnames":[":hand_with_index_and_middle_fingers_crossed_tone2:"],"category":"people"},":fingers_crossed_tone3:":{"uc_base":"1f91e-1f3fd","uc_output":"1f91e-1f3fd","uc_match":"1f91e-1f3fd","uc_greedy":"1f91e-1f3fd","shortnames":[":hand_with_index_and_middle_fingers_crossed_tone3:"],"category":"people"},":fingers_crossed_tone4:":{"uc_base":"1f91e-1f3fe","uc_output":"1f91e-1f3fe","uc_match":"1f91e-1f3fe","uc_greedy":"1f91e-1f3fe","shortnames":[":hand_with_index_and_middle_fingers_crossed_tone4:"],"category":"people"},":fingers_crossed_tone5:":{"uc_base":"1f91e-1f3ff","uc_output":"1f91e-1f3ff","uc_match":"1f91e-1f3ff","uc_greedy":"1f91e-1f3ff","shortnames":[":hand_with_index_and_middle_fingers_crossed_tone5:"],"category":"people"},":flag_ac:":{"uc_base":"1f1e6-1f1e8","uc_output":"1f1e6-1f1e8","uc_match":"1f1e6-1f1e8","uc_greedy":"1f1e6-1f1e8","shortnames":[":ac:"],"category":"flags"},":flag_ad:":{"uc_base":"1f1e6-1f1e9","uc_output":"1f1e6-1f1e9","uc_match":"1f1e6-1f1e9","uc_greedy":"1f1e6-1f1e9","shortnames":[":ad:"],"category":"flags"},":flag_ae:":{"uc_base":"1f1e6-1f1ea","uc_output":"1f1e6-1f1ea","uc_match":"1f1e6-1f1ea","uc_greedy":"1f1e6-1f1ea","shortnames":[":ae:"],"category":"flags"},":flag_af:":{"uc_base":"1f1e6-1f1eb","uc_output":"1f1e6-1f1eb","uc_match":"1f1e6-1f1eb","uc_greedy":"1f1e6-1f1eb","shortnames":[":af:"],"category":"flags"},":flag_ag:":{"uc_base":"1f1e6-1f1ec","uc_output":"1f1e6-1f1ec","uc_match":"1f1e6-1f1ec","uc_greedy":"1f1e6-1f1ec","shortnames":[":ag:"],"category":"flags"},":flag_ai:":{"uc_base":"1f1e6-1f1ee","uc_output":"1f1e6-1f1ee","uc_match":"1f1e6-1f1ee","uc_greedy":"1f1e6-1f1ee","shortnames":[":ai:"],"category":"flags"},":flag_al:":{"uc_base":"1f1e6-1f1f1","uc_output":"1f1e6-1f1f1","uc_match":"1f1e6-1f1f1","uc_greedy":"1f1e6-1f1f1","shortnames":[":al:"],"category":"flags"},":flag_am:":{"uc_base":"1f1e6-1f1f2","uc_output":"1f1e6-1f1f2","uc_match":"1f1e6-1f1f2","uc_greedy":"1f1e6-1f1f2","shortnames":[":am:"],"category":"flags"},":flag_ao:":{"uc_base":"1f1e6-1f1f4","uc_output":"1f1e6-1f1f4","uc_match":"1f1e6-1f1f4","uc_greedy":"1f1e6-1f1f4","shortnames":[":ao:"],"category":"flags"},":flag_aq:":{"uc_base":"1f1e6-1f1f6","uc_output":"1f1e6-1f1f6","uc_match":"1f1e6-1f1f6","uc_greedy":"1f1e6-1f1f6","shortnames":[":aq:"],"category":"flags"},":flag_ar:":{"uc_base":"1f1e6-1f1f7","uc_output":"1f1e6-1f1f7","uc_match":"1f1e6-1f1f7","uc_greedy":"1f1e6-1f1f7","shortnames":[":ar:"],"category":"flags"},":flag_as:":{"uc_base":"1f1e6-1f1f8","uc_output":"1f1e6-1f1f8","uc_match":"1f1e6-1f1f8","uc_greedy":"1f1e6-1f1f8","shortnames":[":as:"],"category":"flags"},":flag_at:":{"uc_base":"1f1e6-1f1f9","uc_output":"1f1e6-1f1f9","uc_match":"1f1e6-1f1f9","uc_greedy":"1f1e6-1f1f9","shortnames":[":at:"],"category":"flags"},":flag_au:":{"uc_base":"1f1e6-1f1fa","uc_output":"1f1e6-1f1fa","uc_match":"1f1e6-1f1fa","uc_greedy":"1f1e6-1f1fa","shortnames":[":au:"],"category":"flags"},":flag_aw:":{"uc_base":"1f1e6-1f1fc","uc_output":"1f1e6-1f1fc","uc_match":"1f1e6-1f1fc","uc_greedy":"1f1e6-1f1fc","shortnames":[":aw:"],"category":"flags"},":flag_ax:":{"uc_base":"1f1e6-1f1fd","uc_output":"1f1e6-1f1fd","uc_match":"1f1e6-1f1fd","uc_greedy":"1f1e6-1f1fd","shortnames":[":ax:"],"category":"flags"},":flag_az:":{"uc_base":"1f1e6-1f1ff","uc_output":"1f1e6-1f1ff","uc_match":"1f1e6-1f1ff","uc_greedy":"1f1e6-1f1ff","shortnames":[":az:"],"category":"flags"},":flag_ba:":{"uc_base":"1f1e7-1f1e6","uc_output":"1f1e7-1f1e6","uc_match":"1f1e7-1f1e6","uc_greedy":"1f1e7-1f1e6","shortnames":[":ba:"],"category":"flags"},":flag_bb:":{"uc_base":"1f1e7-1f1e7","uc_output":"1f1e7-1f1e7","uc_match":"1f1e7-1f1e7","uc_greedy":"1f1e7-1f1e7","shortnames":[":bb:"],"category":"flags"},":flag_bd:":{"uc_base":"1f1e7-1f1e9","uc_output":"1f1e7-1f1e9","uc_match":"1f1e7-1f1e9","uc_greedy":"1f1e7-1f1e9","shortnames":[":bd:"],"category":"flags"},":flag_be:":{"uc_base":"1f1e7-1f1ea","uc_output":"1f1e7-1f1ea","uc_match":"1f1e7-1f1ea","uc_greedy":"1f1e7-1f1ea","shortnames":[":be:"],"category":"flags"},":flag_bf:":{"uc_base":"1f1e7-1f1eb","uc_output":"1f1e7-1f1eb","uc_match":"1f1e7-1f1eb","uc_greedy":"1f1e7-1f1eb","shortnames":[":bf:"],"category":"flags"},":flag_bg:":{"uc_base":"1f1e7-1f1ec","uc_output":"1f1e7-1f1ec","uc_match":"1f1e7-1f1ec","uc_greedy":"1f1e7-1f1ec","shortnames":[":bg:"],"category":"flags"},":flag_bh:":{"uc_base":"1f1e7-1f1ed","uc_output":"1f1e7-1f1ed","uc_match":"1f1e7-1f1ed","uc_greedy":"1f1e7-1f1ed","shortnames":[":bh:"],"category":"flags"},":flag_bi:":{"uc_base":"1f1e7-1f1ee","uc_output":"1f1e7-1f1ee","uc_match":"1f1e7-1f1ee","uc_greedy":"1f1e7-1f1ee","shortnames":[":bi:"],"category":"flags"},":flag_bj:":{"uc_base":"1f1e7-1f1ef","uc_output":"1f1e7-1f1ef","uc_match":"1f1e7-1f1ef","uc_greedy":"1f1e7-1f1ef","shortnames":[":bj:"],"category":"flags"},":flag_bl:":{"uc_base":"1f1e7-1f1f1","uc_output":"1f1e7-1f1f1","uc_match":"1f1e7-1f1f1","uc_greedy":"1f1e7-1f1f1","shortnames":[":bl:"],"category":"flags"},":flag_bm:":{"uc_base":"1f1e7-1f1f2","uc_output":"1f1e7-1f1f2","uc_match":"1f1e7-1f1f2","uc_greedy":"1f1e7-1f1f2","shortnames":[":bm:"],"category":"flags"},":flag_bn:":{"uc_base":"1f1e7-1f1f3","uc_output":"1f1e7-1f1f3","uc_match":"1f1e7-1f1f3","uc_greedy":"1f1e7-1f1f3","shortnames":[":bn:"],"category":"flags"},":flag_bo:":{"uc_base":"1f1e7-1f1f4","uc_output":"1f1e7-1f1f4","uc_match":"1f1e7-1f1f4","uc_greedy":"1f1e7-1f1f4","shortnames":[":bo:"],"category":"flags"},":flag_bq:":{"uc_base":"1f1e7-1f1f6","uc_output":"1f1e7-1f1f6","uc_match":"1f1e7-1f1f6","uc_greedy":"1f1e7-1f1f6","shortnames":[":bq:"],"category":"flags"},":flag_br:":{"uc_base":"1f1e7-1f1f7","uc_output":"1f1e7-1f1f7","uc_match":"1f1e7-1f1f7","uc_greedy":"1f1e7-1f1f7","shortnames":[":br:"],"category":"flags"},":flag_bs:":{"uc_base":"1f1e7-1f1f8","uc_output":"1f1e7-1f1f8","uc_match":"1f1e7-1f1f8","uc_greedy":"1f1e7-1f1f8","shortnames":[":bs:"],"category":"flags"},":flag_bt:":{"uc_base":"1f1e7-1f1f9","uc_output":"1f1e7-1f1f9","uc_match":"1f1e7-1f1f9","uc_greedy":"1f1e7-1f1f9","shortnames":[":bt:"],"category":"flags"},":flag_bv:":{"uc_base":"1f1e7-1f1fb","uc_output":"1f1e7-1f1fb","uc_match":"1f1e7-1f1fb","uc_greedy":"1f1e7-1f1fb","shortnames":[":bv:"],"category":"flags"},":flag_bw:":{"uc_base":"1f1e7-1f1fc","uc_output":"1f1e7-1f1fc","uc_match":"1f1e7-1f1fc","uc_greedy":"1f1e7-1f1fc","shortnames":[":bw:"],"category":"flags"},":flag_by:":{"uc_base":"1f1e7-1f1fe","uc_output":"1f1e7-1f1fe","uc_match":"1f1e7-1f1fe","uc_greedy":"1f1e7-1f1fe","shortnames":[":by:"],"category":"flags"},":flag_bz:":{"uc_base":"1f1e7-1f1ff","uc_output":"1f1e7-1f1ff","uc_match":"1f1e7-1f1ff","uc_greedy":"1f1e7-1f1ff","shortnames":[":bz:"],"category":"flags"},":flag_ca:":{"uc_base":"1f1e8-1f1e6","uc_output":"1f1e8-1f1e6","uc_match":"1f1e8-1f1e6","uc_greedy":"1f1e8-1f1e6","shortnames":[":ca:"],"category":"flags"},":flag_cc:":{"uc_base":"1f1e8-1f1e8","uc_output":"1f1e8-1f1e8","uc_match":"1f1e8-1f1e8","uc_greedy":"1f1e8-1f1e8","shortnames":[":cc:"],"category":"flags"},":flag_cd:":{"uc_base":"1f1e8-1f1e9","uc_output":"1f1e8-1f1e9","uc_match":"1f1e8-1f1e9","uc_greedy":"1f1e8-1f1e9","shortnames":[":congo:"],"category":"flags"},":flag_cf:":{"uc_base":"1f1e8-1f1eb","uc_output":"1f1e8-1f1eb","uc_match":"1f1e8-1f1eb","uc_greedy":"1f1e8-1f1eb","shortnames":[":cf:"],"category":"flags"},":flag_cg:":{"uc_base":"1f1e8-1f1ec","uc_output":"1f1e8-1f1ec","uc_match":"1f1e8-1f1ec","uc_greedy":"1f1e8-1f1ec","shortnames":[":cg:"],"category":"flags"},":flag_ch:":{"uc_base":"1f1e8-1f1ed","uc_output":"1f1e8-1f1ed","uc_match":"1f1e8-1f1ed","uc_greedy":"1f1e8-1f1ed","shortnames":[":ch:"],"category":"flags"},":flag_ci:":{"uc_base":"1f1e8-1f1ee","uc_output":"1f1e8-1f1ee","uc_match":"1f1e8-1f1ee","uc_greedy":"1f1e8-1f1ee","shortnames":[":ci:"],"category":"flags"},":flag_ck:":{"uc_base":"1f1e8-1f1f0","uc_output":"1f1e8-1f1f0","uc_match":"1f1e8-1f1f0","uc_greedy":"1f1e8-1f1f0","shortnames":[":ck:"],"category":"flags"},":flag_cl:":{"uc_base":"1f1e8-1f1f1","uc_output":"1f1e8-1f1f1","uc_match":"1f1e8-1f1f1","uc_greedy":"1f1e8-1f1f1","shortnames":[":chile:"],"category":"flags"},":flag_cm:":{"uc_base":"1f1e8-1f1f2","uc_output":"1f1e8-1f1f2","uc_match":"1f1e8-1f1f2","uc_greedy":"1f1e8-1f1f2","shortnames":[":cm:"],"category":"flags"},":flag_cn:":{"uc_base":"1f1e8-1f1f3","uc_output":"1f1e8-1f1f3","uc_match":"1f1e8-1f1f3","uc_greedy":"1f1e8-1f1f3","shortnames":[":cn:"],"category":"flags"},":flag_co:":{"uc_base":"1f1e8-1f1f4","uc_output":"1f1e8-1f1f4","uc_match":"1f1e8-1f1f4","uc_greedy":"1f1e8-1f1f4","shortnames":[":co:"],"category":"flags"},":flag_cp:":{"uc_base":"1f1e8-1f1f5","uc_output":"1f1e8-1f1f5","uc_match":"1f1e8-1f1f5","uc_greedy":"1f1e8-1f1f5","shortnames":[":cp:"],"category":"flags"},":flag_cr:":{"uc_base":"1f1e8-1f1f7","uc_output":"1f1e8-1f1f7","uc_match":"1f1e8-1f1f7","uc_greedy":"1f1e8-1f1f7","shortnames":[":cr:"],"category":"flags"},":flag_cu:":{"uc_base":"1f1e8-1f1fa","uc_output":"1f1e8-1f1fa","uc_match":"1f1e8-1f1fa","uc_greedy":"1f1e8-1f1fa","shortnames":[":cu:"],"category":"flags"},":flag_cv:":{"uc_base":"1f1e8-1f1fb","uc_output":"1f1e8-1f1fb","uc_match":"1f1e8-1f1fb","uc_greedy":"1f1e8-1f1fb","shortnames":[":cv:"],"category":"flags"},":flag_cw:":{"uc_base":"1f1e8-1f1fc","uc_output":"1f1e8-1f1fc","uc_match":"1f1e8-1f1fc","uc_greedy":"1f1e8-1f1fc","shortnames":[":cw:"],"category":"flags"},":flag_cx:":{"uc_base":"1f1e8-1f1fd","uc_output":"1f1e8-1f1fd","uc_match":"1f1e8-1f1fd","uc_greedy":"1f1e8-1f1fd","shortnames":[":cx:"],"category":"flags"},":flag_cy:":{"uc_base":"1f1e8-1f1fe","uc_output":"1f1e8-1f1fe","uc_match":"1f1e8-1f1fe","uc_greedy":"1f1e8-1f1fe","shortnames":[":cy:"],"category":"flags"},":flag_cz:":{"uc_base":"1f1e8-1f1ff","uc_output":"1f1e8-1f1ff","uc_match":"1f1e8-1f1ff","uc_greedy":"1f1e8-1f1ff","shortnames":[":cz:"],"category":"flags"},":flag_de:":{"uc_base":"1f1e9-1f1ea","uc_output":"1f1e9-1f1ea","uc_match":"1f1e9-1f1ea","uc_greedy":"1f1e9-1f1ea","shortnames":[":de:"],"category":"flags"},":flag_dg:":{"uc_base":"1f1e9-1f1ec","uc_output":"1f1e9-1f1ec","uc_match":"1f1e9-1f1ec","uc_greedy":"1f1e9-1f1ec","shortnames":[":dg:"],"category":"flags"},":flag_dj:":{"uc_base":"1f1e9-1f1ef","uc_output":"1f1e9-1f1ef","uc_match":"1f1e9-1f1ef","uc_greedy":"1f1e9-1f1ef","shortnames":[":dj:"],"category":"flags"},":flag_dk:":{"uc_base":"1f1e9-1f1f0","uc_output":"1f1e9-1f1f0","uc_match":"1f1e9-1f1f0","uc_greedy":"1f1e9-1f1f0","shortnames":[":dk:"],"category":"flags"},":flag_dm:":{"uc_base":"1f1e9-1f1f2","uc_output":"1f1e9-1f1f2","uc_match":"1f1e9-1f1f2","uc_greedy":"1f1e9-1f1f2","shortnames":[":dm:"],"category":"flags"},":flag_do:":{"uc_base":"1f1e9-1f1f4","uc_output":"1f1e9-1f1f4","uc_match":"1f1e9-1f1f4","uc_greedy":"1f1e9-1f1f4","shortnames":[":do:"],"category":"flags"},":flag_dz:":{"uc_base":"1f1e9-1f1ff","uc_output":"1f1e9-1f1ff","uc_match":"1f1e9-1f1ff","uc_greedy":"1f1e9-1f1ff","shortnames":[":dz:"],"category":"flags"},":flag_ea:":{"uc_base":"1f1ea-1f1e6","uc_output":"1f1ea-1f1e6","uc_match":"1f1ea-1f1e6","uc_greedy":"1f1ea-1f1e6","shortnames":[":ea:"],"category":"flags"},":flag_ec:":{"uc_base":"1f1ea-1f1e8","uc_output":"1f1ea-1f1e8","uc_match":"1f1ea-1f1e8","uc_greedy":"1f1ea-1f1e8","shortnames":[":ec:"],"category":"flags"},":flag_ee:":{"uc_base":"1f1ea-1f1ea","uc_output":"1f1ea-1f1ea","uc_match":"1f1ea-1f1ea","uc_greedy":"1f1ea-1f1ea","shortnames":[":ee:"],"category":"flags"},":flag_eg:":{"uc_base":"1f1ea-1f1ec","uc_output":"1f1ea-1f1ec","uc_match":"1f1ea-1f1ec","uc_greedy":"1f1ea-1f1ec","shortnames":[":eg:"],"category":"flags"},":flag_eh:":{"uc_base":"1f1ea-1f1ed","uc_output":"1f1ea-1f1ed","uc_match":"1f1ea-1f1ed","uc_greedy":"1f1ea-1f1ed","shortnames":[":eh:"],"category":"flags"},":flag_er:":{"uc_base":"1f1ea-1f1f7","uc_output":"1f1ea-1f1f7","uc_match":"1f1ea-1f1f7","uc_greedy":"1f1ea-1f1f7","shortnames":[":er:"],"category":"flags"},":flag_es:":{"uc_base":"1f1ea-1f1f8","uc_output":"1f1ea-1f1f8","uc_match":"1f1ea-1f1f8","uc_greedy":"1f1ea-1f1f8","shortnames":[":es:"],"category":"flags"},":flag_et:":{"uc_base":"1f1ea-1f1f9","uc_output":"1f1ea-1f1f9","uc_match":"1f1ea-1f1f9","uc_greedy":"1f1ea-1f1f9","shortnames":[":et:"],"category":"flags"},":flag_eu:":{"uc_base":"1f1ea-1f1fa","uc_output":"1f1ea-1f1fa","uc_match":"1f1ea-1f1fa","uc_greedy":"1f1ea-1f1fa","shortnames":[":eu:"],"category":"flags"},":flag_fi:":{"uc_base":"1f1eb-1f1ee","uc_output":"1f1eb-1f1ee","uc_match":"1f1eb-1f1ee","uc_greedy":"1f1eb-1f1ee","shortnames":[":fi:"],"category":"flags"},":flag_fj:":{"uc_base":"1f1eb-1f1ef","uc_output":"1f1eb-1f1ef","uc_match":"1f1eb-1f1ef","uc_greedy":"1f1eb-1f1ef","shortnames":[":fj:"],"category":"flags"},":flag_fk:":{"uc_base":"1f1eb-1f1f0","uc_output":"1f1eb-1f1f0","uc_match":"1f1eb-1f1f0","uc_greedy":"1f1eb-1f1f0","shortnames":[":fk:"],"category":"flags"},":flag_fm:":{"uc_base":"1f1eb-1f1f2","uc_output":"1f1eb-1f1f2","uc_match":"1f1eb-1f1f2","uc_greedy":"1f1eb-1f1f2","shortnames":[":fm:"],"category":"flags"},":flag_fo:":{"uc_base":"1f1eb-1f1f4","uc_output":"1f1eb-1f1f4","uc_match":"1f1eb-1f1f4","uc_greedy":"1f1eb-1f1f4","shortnames":[":fo:"],"category":"flags"},":flag_fr:":{"uc_base":"1f1eb-1f1f7","uc_output":"1f1eb-1f1f7","uc_match":"1f1eb-1f1f7","uc_greedy":"1f1eb-1f1f7","shortnames":[":fr:"],"category":"flags"},":flag_ga:":{"uc_base":"1f1ec-1f1e6","uc_output":"1f1ec-1f1e6","uc_match":"1f1ec-1f1e6","uc_greedy":"1f1ec-1f1e6","shortnames":[":ga:"],"category":"flags"},":flag_gb:":{"uc_base":"1f1ec-1f1e7","uc_output":"1f1ec-1f1e7","uc_match":"1f1ec-1f1e7","uc_greedy":"1f1ec-1f1e7","shortnames":[":gb:"],"category":"flags"},":flag_gd:":{"uc_base":"1f1ec-1f1e9","uc_output":"1f1ec-1f1e9","uc_match":"1f1ec-1f1e9","uc_greedy":"1f1ec-1f1e9","shortnames":[":gd:"],"category":"flags"},":flag_ge:":{"uc_base":"1f1ec-1f1ea","uc_output":"1f1ec-1f1ea","uc_match":"1f1ec-1f1ea","uc_greedy":"1f1ec-1f1ea","shortnames":[":ge:"],"category":"flags"},":flag_gf:":{"uc_base":"1f1ec-1f1eb","uc_output":"1f1ec-1f1eb","uc_match":"1f1ec-1f1eb","uc_greedy":"1f1ec-1f1eb","shortnames":[":gf:"],"category":"flags"},":flag_gg:":{"uc_base":"1f1ec-1f1ec","uc_output":"1f1ec-1f1ec","uc_match":"1f1ec-1f1ec","uc_greedy":"1f1ec-1f1ec","shortnames":[":gg:"],"category":"flags"},":flag_gh:":{"uc_base":"1f1ec-1f1ed","uc_output":"1f1ec-1f1ed","uc_match":"1f1ec-1f1ed","uc_greedy":"1f1ec-1f1ed","shortnames":[":gh:"],"category":"flags"},":flag_gi:":{"uc_base":"1f1ec-1f1ee","uc_output":"1f1ec-1f1ee","uc_match":"1f1ec-1f1ee","uc_greedy":"1f1ec-1f1ee","shortnames":[":gi:"],"category":"flags"},":flag_gl:":{"uc_base":"1f1ec-1f1f1","uc_output":"1f1ec-1f1f1","uc_match":"1f1ec-1f1f1","uc_greedy":"1f1ec-1f1f1","shortnames":[":gl:"],"category":"flags"},":flag_gm:":{"uc_base":"1f1ec-1f1f2","uc_output":"1f1ec-1f1f2","uc_match":"1f1ec-1f1f2","uc_greedy":"1f1ec-1f1f2","shortnames":[":gm:"],"category":"flags"},":flag_gn:":{"uc_base":"1f1ec-1f1f3","uc_output":"1f1ec-1f1f3","uc_match":"1f1ec-1f1f3","uc_greedy":"1f1ec-1f1f3","shortnames":[":gn:"],"category":"flags"},":flag_gp:":{"uc_base":"1f1ec-1f1f5","uc_output":"1f1ec-1f1f5","uc_match":"1f1ec-1f1f5","uc_greedy":"1f1ec-1f1f5","shortnames":[":gp:"],"category":"flags"},":flag_gq:":{"uc_base":"1f1ec-1f1f6","uc_output":"1f1ec-1f1f6","uc_match":"1f1ec-1f1f6","uc_greedy":"1f1ec-1f1f6","shortnames":[":gq:"],"category":"flags"},":flag_gr:":{"uc_base":"1f1ec-1f1f7","uc_output":"1f1ec-1f1f7","uc_match":"1f1ec-1f1f7","uc_greedy":"1f1ec-1f1f7","shortnames":[":gr:"],"category":"flags"},":flag_gs:":{"uc_base":"1f1ec-1f1f8","uc_output":"1f1ec-1f1f8","uc_match":"1f1ec-1f1f8","uc_greedy":"1f1ec-1f1f8","shortnames":[":gs:"],"category":"flags"},":flag_gt:":{"uc_base":"1f1ec-1f1f9","uc_output":"1f1ec-1f1f9","uc_match":"1f1ec-1f1f9","uc_greedy":"1f1ec-1f1f9","shortnames":[":gt:"],"category":"flags"},":flag_gu:":{"uc_base":"1f1ec-1f1fa","uc_output":"1f1ec-1f1fa","uc_match":"1f1ec-1f1fa","uc_greedy":"1f1ec-1f1fa","shortnames":[":gu:"],"category":"flags"},":flag_gw:":{"uc_base":"1f1ec-1f1fc","uc_output":"1f1ec-1f1fc","uc_match":"1f1ec-1f1fc","uc_greedy":"1f1ec-1f1fc","shortnames":[":gw:"],"category":"flags"},":flag_gy:":{"uc_base":"1f1ec-1f1fe","uc_output":"1f1ec-1f1fe","uc_match":"1f1ec-1f1fe","uc_greedy":"1f1ec-1f1fe","shortnames":[":gy:"],"category":"flags"},":flag_hk:":{"uc_base":"1f1ed-1f1f0","uc_output":"1f1ed-1f1f0","uc_match":"1f1ed-1f1f0","uc_greedy":"1f1ed-1f1f0","shortnames":[":hk:"],"category":"flags"},":flag_hm:":{"uc_base":"1f1ed-1f1f2","uc_output":"1f1ed-1f1f2","uc_match":"1f1ed-1f1f2","uc_greedy":"1f1ed-1f1f2","shortnames":[":hm:"],"category":"flags"},":flag_hn:":{"uc_base":"1f1ed-1f1f3","uc_output":"1f1ed-1f1f3","uc_match":"1f1ed-1f1f3","uc_greedy":"1f1ed-1f1f3","shortnames":[":hn:"],"category":"flags"},":flag_hr:":{"uc_base":"1f1ed-1f1f7","uc_output":"1f1ed-1f1f7","uc_match":"1f1ed-1f1f7","uc_greedy":"1f1ed-1f1f7","shortnames":[":hr:"],"category":"flags"},":flag_ht:":{"uc_base":"1f1ed-1f1f9","uc_output":"1f1ed-1f1f9","uc_match":"1f1ed-1f1f9","uc_greedy":"1f1ed-1f1f9","shortnames":[":ht:"],"category":"flags"},":flag_hu:":{"uc_base":"1f1ed-1f1fa","uc_output":"1f1ed-1f1fa","uc_match":"1f1ed-1f1fa","uc_greedy":"1f1ed-1f1fa","shortnames":[":hu:"],"category":"flags"},":flag_ic:":{"uc_base":"1f1ee-1f1e8","uc_output":"1f1ee-1f1e8","uc_match":"1f1ee-1f1e8","uc_greedy":"1f1ee-1f1e8","shortnames":[":ic:"],"category":"flags"},":flag_id:":{"uc_base":"1f1ee-1f1e9","uc_output":"1f1ee-1f1e9","uc_match":"1f1ee-1f1e9","uc_greedy":"1f1ee-1f1e9","shortnames":[":indonesia:"],"category":"flags"},":flag_ie:":{"uc_base":"1f1ee-1f1ea","uc_output":"1f1ee-1f1ea","uc_match":"1f1ee-1f1ea","uc_greedy":"1f1ee-1f1ea","shortnames":[":ie:"],"category":"flags"},":flag_il:":{"uc_base":"1f1ee-1f1f1","uc_output":"1f1ee-1f1f1","uc_match":"1f1ee-1f1f1","uc_greedy":"1f1ee-1f1f1","shortnames":[":il:"],"category":"flags"},":flag_im:":{"uc_base":"1f1ee-1f1f2","uc_output":"1f1ee-1f1f2","uc_match":"1f1ee-1f1f2","uc_greedy":"1f1ee-1f1f2","shortnames":[":im:"],"category":"flags"},":flag_in:":{"uc_base":"1f1ee-1f1f3","uc_output":"1f1ee-1f1f3","uc_match":"1f1ee-1f1f3","uc_greedy":"1f1ee-1f1f3","shortnames":[":in:"],"category":"flags"},":flag_io:":{"uc_base":"1f1ee-1f1f4","uc_output":"1f1ee-1f1f4","uc_match":"1f1ee-1f1f4","uc_greedy":"1f1ee-1f1f4","shortnames":[":io:"],"category":"flags"},":flag_iq:":{"uc_base":"1f1ee-1f1f6","uc_output":"1f1ee-1f1f6","uc_match":"1f1ee-1f1f6","uc_greedy":"1f1ee-1f1f6","shortnames":[":iq:"],"category":"flags"},":flag_ir:":{"uc_base":"1f1ee-1f1f7","uc_output":"1f1ee-1f1f7","uc_match":"1f1ee-1f1f7","uc_greedy":"1f1ee-1f1f7","shortnames":[":ir:"],"category":"flags"},":flag_is:":{"uc_base":"1f1ee-1f1f8","uc_output":"1f1ee-1f1f8","uc_match":"1f1ee-1f1f8","uc_greedy":"1f1ee-1f1f8","shortnames":[":is:"],"category":"flags"},":flag_it:":{"uc_base":"1f1ee-1f1f9","uc_output":"1f1ee-1f1f9","uc_match":"1f1ee-1f1f9","uc_greedy":"1f1ee-1f1f9","shortnames":[":it:"],"category":"flags"},":flag_je:":{"uc_base":"1f1ef-1f1ea","uc_output":"1f1ef-1f1ea","uc_match":"1f1ef-1f1ea","uc_greedy":"1f1ef-1f1ea","shortnames":[":je:"],"category":"flags"},":flag_jm:":{"uc_base":"1f1ef-1f1f2","uc_output":"1f1ef-1f1f2","uc_match":"1f1ef-1f1f2","uc_greedy":"1f1ef-1f1f2","shortnames":[":jm:"],"category":"flags"},":flag_jo:":{"uc_base":"1f1ef-1f1f4","uc_output":"1f1ef-1f1f4","uc_match":"1f1ef-1f1f4","uc_greedy":"1f1ef-1f1f4","shortnames":[":jo:"],"category":"flags"},":flag_jp:":{"uc_base":"1f1ef-1f1f5","uc_output":"1f1ef-1f1f5","uc_match":"1f1ef-1f1f5","uc_greedy":"1f1ef-1f1f5","shortnames":[":jp:"],"category":"flags"},":flag_ke:":{"uc_base":"1f1f0-1f1ea","uc_output":"1f1f0-1f1ea","uc_match":"1f1f0-1f1ea","uc_greedy":"1f1f0-1f1ea","shortnames":[":ke:"],"category":"flags"},":flag_kg:":{"uc_base":"1f1f0-1f1ec","uc_output":"1f1f0-1f1ec","uc_match":"1f1f0-1f1ec","uc_greedy":"1f1f0-1f1ec","shortnames":[":kg:"],"category":"flags"},":flag_kh:":{"uc_base":"1f1f0-1f1ed","uc_output":"1f1f0-1f1ed","uc_match":"1f1f0-1f1ed","uc_greedy":"1f1f0-1f1ed","shortnames":[":kh:"],"category":"flags"},":flag_ki:":{"uc_base":"1f1f0-1f1ee","uc_output":"1f1f0-1f1ee","uc_match":"1f1f0-1f1ee","uc_greedy":"1f1f0-1f1ee","shortnames":[":ki:"],"category":"flags"},":flag_km:":{"uc_base":"1f1f0-1f1f2","uc_output":"1f1f0-1f1f2","uc_match":"1f1f0-1f1f2","uc_greedy":"1f1f0-1f1f2","shortnames":[":km:"],"category":"flags"},":flag_kn:":{"uc_base":"1f1f0-1f1f3","uc_output":"1f1f0-1f1f3","uc_match":"1f1f0-1f1f3","uc_greedy":"1f1f0-1f1f3","shortnames":[":kn:"],"category":"flags"},":flag_kp:":{"uc_base":"1f1f0-1f1f5","uc_output":"1f1f0-1f1f5","uc_match":"1f1f0-1f1f5","uc_greedy":"1f1f0-1f1f5","shortnames":[":kp:"],"category":"flags"},":flag_kr:":{"uc_base":"1f1f0-1f1f7","uc_output":"1f1f0-1f1f7","uc_match":"1f1f0-1f1f7","uc_greedy":"1f1f0-1f1f7","shortnames":[":kr:"],"category":"flags"},":flag_kw:":{"uc_base":"1f1f0-1f1fc","uc_output":"1f1f0-1f1fc","uc_match":"1f1f0-1f1fc","uc_greedy":"1f1f0-1f1fc","shortnames":[":kw:"],"category":"flags"},":flag_ky:":{"uc_base":"1f1f0-1f1fe","uc_output":"1f1f0-1f1fe","uc_match":"1f1f0-1f1fe","uc_greedy":"1f1f0-1f1fe","shortnames":[":ky:"],"category":"flags"},":flag_kz:":{"uc_base":"1f1f0-1f1ff","uc_output":"1f1f0-1f1ff","uc_match":"1f1f0-1f1ff","uc_greedy":"1f1f0-1f1ff","shortnames":[":kz:"],"category":"flags"},":flag_la:":{"uc_base":"1f1f1-1f1e6","uc_output":"1f1f1-1f1e6","uc_match":"1f1f1-1f1e6","uc_greedy":"1f1f1-1f1e6","shortnames":[":la:"],"category":"flags"},":flag_lb:":{"uc_base":"1f1f1-1f1e7","uc_output":"1f1f1-1f1e7","uc_match":"1f1f1-1f1e7","uc_greedy":"1f1f1-1f1e7","shortnames":[":lb:"],"category":"flags"},":flag_lc:":{"uc_base":"1f1f1-1f1e8","uc_output":"1f1f1-1f1e8","uc_match":"1f1f1-1f1e8","uc_greedy":"1f1f1-1f1e8","shortnames":[":lc:"],"category":"flags"},":flag_li:":{"uc_base":"1f1f1-1f1ee","uc_output":"1f1f1-1f1ee","uc_match":"1f1f1-1f1ee","uc_greedy":"1f1f1-1f1ee","shortnames":[":li:"],"category":"flags"},":flag_lk:":{"uc_base":"1f1f1-1f1f0","uc_output":"1f1f1-1f1f0","uc_match":"1f1f1-1f1f0","uc_greedy":"1f1f1-1f1f0","shortnames":[":lk:"],"category":"flags"},":flag_lr:":{"uc_base":"1f1f1-1f1f7","uc_output":"1f1f1-1f1f7","uc_match":"1f1f1-1f1f7","uc_greedy":"1f1f1-1f1f7","shortnames":[":lr:"],"category":"flags"},":flag_ls:":{"uc_base":"1f1f1-1f1f8","uc_output":"1f1f1-1f1f8","uc_match":"1f1f1-1f1f8","uc_greedy":"1f1f1-1f1f8","shortnames":[":ls:"],"category":"flags"},":flag_lt:":{"uc_base":"1f1f1-1f1f9","uc_output":"1f1f1-1f1f9","uc_match":"1f1f1-1f1f9","uc_greedy":"1f1f1-1f1f9","shortnames":[":lt:"],"category":"flags"},":flag_lu:":{"uc_base":"1f1f1-1f1fa","uc_output":"1f1f1-1f1fa","uc_match":"1f1f1-1f1fa","uc_greedy":"1f1f1-1f1fa","shortnames":[":lu:"],"category":"flags"},":flag_lv:":{"uc_base":"1f1f1-1f1fb","uc_output":"1f1f1-1f1fb","uc_match":"1f1f1-1f1fb","uc_greedy":"1f1f1-1f1fb","shortnames":[":lv:"],"category":"flags"},":flag_ly:":{"uc_base":"1f1f1-1f1fe","uc_output":"1f1f1-1f1fe","uc_match":"1f1f1-1f1fe","uc_greedy":"1f1f1-1f1fe","shortnames":[":ly:"],"category":"flags"},":flag_ma:":{"uc_base":"1f1f2-1f1e6","uc_output":"1f1f2-1f1e6","uc_match":"1f1f2-1f1e6","uc_greedy":"1f1f2-1f1e6","shortnames":[":ma:"],"category":"flags"},":flag_mc:":{"uc_base":"1f1f2-1f1e8","uc_output":"1f1f2-1f1e8","uc_match":"1f1f2-1f1e8","uc_greedy":"1f1f2-1f1e8","shortnames":[":mc:"],"category":"flags"},":flag_md:":{"uc_base":"1f1f2-1f1e9","uc_output":"1f1f2-1f1e9","uc_match":"1f1f2-1f1e9","uc_greedy":"1f1f2-1f1e9","shortnames":[":md:"],"category":"flags"},":flag_me:":{"uc_base":"1f1f2-1f1ea","uc_output":"1f1f2-1f1ea","uc_match":"1f1f2-1f1ea","uc_greedy":"1f1f2-1f1ea","shortnames":[":me:"],"category":"flags"},":flag_mf:":{"uc_base":"1f1f2-1f1eb","uc_output":"1f1f2-1f1eb","uc_match":"1f1f2-1f1eb","uc_greedy":"1f1f2-1f1eb","shortnames":[":mf:"],"category":"flags"},":flag_mg:":{"uc_base":"1f1f2-1f1ec","uc_output":"1f1f2-1f1ec","uc_match":"1f1f2-1f1ec","uc_greedy":"1f1f2-1f1ec","shortnames":[":mg:"],"category":"flags"},":flag_mh:":{"uc_base":"1f1f2-1f1ed","uc_output":"1f1f2-1f1ed","uc_match":"1f1f2-1f1ed","uc_greedy":"1f1f2-1f1ed","shortnames":[":mh:"],"category":"flags"},":flag_mk:":{"uc_base":"1f1f2-1f1f0","uc_output":"1f1f2-1f1f0","uc_match":"1f1f2-1f1f0","uc_greedy":"1f1f2-1f1f0","shortnames":[":mk:"],"category":"flags"},":flag_ml:":{"uc_base":"1f1f2-1f1f1","uc_output":"1f1f2-1f1f1","uc_match":"1f1f2-1f1f1","uc_greedy":"1f1f2-1f1f1","shortnames":[":ml:"],"category":"flags"},":flag_mm:":{"uc_base":"1f1f2-1f1f2","uc_output":"1f1f2-1f1f2","uc_match":"1f1f2-1f1f2","uc_greedy":"1f1f2-1f1f2","shortnames":[":mm:"],"category":"flags"},":flag_mn:":{"uc_base":"1f1f2-1f1f3","uc_output":"1f1f2-1f1f3","uc_match":"1f1f2-1f1f3","uc_greedy":"1f1f2-1f1f3","shortnames":[":mn:"],"category":"flags"},":flag_mo:":{"uc_base":"1f1f2-1f1f4","uc_output":"1f1f2-1f1f4","uc_match":"1f1f2-1f1f4","uc_greedy":"1f1f2-1f1f4","shortnames":[":mo:"],"category":"flags"},":flag_mp:":{"uc_base":"1f1f2-1f1f5","uc_output":"1f1f2-1f1f5","uc_match":"1f1f2-1f1f5","uc_greedy":"1f1f2-1f1f5","shortnames":[":mp:"],"category":"flags"},":flag_mq:":{"uc_base":"1f1f2-1f1f6","uc_output":"1f1f2-1f1f6","uc_match":"1f1f2-1f1f6","uc_greedy":"1f1f2-1f1f6","shortnames":[":mq:"],"category":"flags"},":flag_mr:":{"uc_base":"1f1f2-1f1f7","uc_output":"1f1f2-1f1f7","uc_match":"1f1f2-1f1f7","uc_greedy":"1f1f2-1f1f7","shortnames":[":mr:"],"category":"flags"},":flag_ms:":{"uc_base":"1f1f2-1f1f8","uc_output":"1f1f2-1f1f8","uc_match":"1f1f2-1f1f8","uc_greedy":"1f1f2-1f1f8","shortnames":[":ms:"],"category":"flags"},":flag_mt:":{"uc_base":"1f1f2-1f1f9","uc_output":"1f1f2-1f1f9","uc_match":"1f1f2-1f1f9","uc_greedy":"1f1f2-1f1f9","shortnames":[":mt:"],"category":"flags"},":flag_mu:":{"uc_base":"1f1f2-1f1fa","uc_output":"1f1f2-1f1fa","uc_match":"1f1f2-1f1fa","uc_greedy":"1f1f2-1f1fa","shortnames":[":mu:"],"category":"flags"},":flag_mv:":{"uc_base":"1f1f2-1f1fb","uc_output":"1f1f2-1f1fb","uc_match":"1f1f2-1f1fb","uc_greedy":"1f1f2-1f1fb","shortnames":[":mv:"],"category":"flags"},":flag_mw:":{"uc_base":"1f1f2-1f1fc","uc_output":"1f1f2-1f1fc","uc_match":"1f1f2-1f1fc","uc_greedy":"1f1f2-1f1fc","shortnames":[":mw:"],"category":"flags"},":flag_mx:":{"uc_base":"1f1f2-1f1fd","uc_output":"1f1f2-1f1fd","uc_match":"1f1f2-1f1fd","uc_greedy":"1f1f2-1f1fd","shortnames":[":mx:"],"category":"flags"},":flag_my:":{"uc_base":"1f1f2-1f1fe","uc_output":"1f1f2-1f1fe","uc_match":"1f1f2-1f1fe","uc_greedy":"1f1f2-1f1fe","shortnames":[":my:"],"category":"flags"},":flag_mz:":{"uc_base":"1f1f2-1f1ff","uc_output":"1f1f2-1f1ff","uc_match":"1f1f2-1f1ff","uc_greedy":"1f1f2-1f1ff","shortnames":[":mz:"],"category":"flags"},":flag_na:":{"uc_base":"1f1f3-1f1e6","uc_output":"1f1f3-1f1e6","uc_match":"1f1f3-1f1e6","uc_greedy":"1f1f3-1f1e6","shortnames":[":na:"],"category":"flags"},":flag_nc:":{"uc_base":"1f1f3-1f1e8","uc_output":"1f1f3-1f1e8","uc_match":"1f1f3-1f1e8","uc_greedy":"1f1f3-1f1e8","shortnames":[":nc:"],"category":"flags"},":flag_ne:":{"uc_base":"1f1f3-1f1ea","uc_output":"1f1f3-1f1ea","uc_match":"1f1f3-1f1ea","uc_greedy":"1f1f3-1f1ea","shortnames":[":ne:"],"category":"flags"},":flag_nf:":{"uc_base":"1f1f3-1f1eb","uc_output":"1f1f3-1f1eb","uc_match":"1f1f3-1f1eb","uc_greedy":"1f1f3-1f1eb","shortnames":[":nf:"],"category":"flags"},":flag_ng:":{"uc_base":"1f1f3-1f1ec","uc_output":"1f1f3-1f1ec","uc_match":"1f1f3-1f1ec","uc_greedy":"1f1f3-1f1ec","shortnames":[":nigeria:"],"category":"flags"},":flag_ni:":{"uc_base":"1f1f3-1f1ee","uc_output":"1f1f3-1f1ee","uc_match":"1f1f3-1f1ee","uc_greedy":"1f1f3-1f1ee","shortnames":[":ni:"],"category":"flags"},":flag_nl:":{"uc_base":"1f1f3-1f1f1","uc_output":"1f1f3-1f1f1","uc_match":"1f1f3-1f1f1","uc_greedy":"1f1f3-1f1f1","shortnames":[":nl:"],"category":"flags"},":flag_no:":{"uc_base":"1f1f3-1f1f4","uc_output":"1f1f3-1f1f4","uc_match":"1f1f3-1f1f4","uc_greedy":"1f1f3-1f1f4","shortnames":[":no:"],"category":"flags"},":flag_np:":{"uc_base":"1f1f3-1f1f5","uc_output":"1f1f3-1f1f5","uc_match":"1f1f3-1f1f5","uc_greedy":"1f1f3-1f1f5","shortnames":[":np:"],"category":"flags"},":flag_nr:":{"uc_base":"1f1f3-1f1f7","uc_output":"1f1f3-1f1f7","uc_match":"1f1f3-1f1f7","uc_greedy":"1f1f3-1f1f7","shortnames":[":nr:"],"category":"flags"},":flag_nu:":{"uc_base":"1f1f3-1f1fa","uc_output":"1f1f3-1f1fa","uc_match":"1f1f3-1f1fa","uc_greedy":"1f1f3-1f1fa","shortnames":[":nu:"],"category":"flags"},":flag_nz:":{"uc_base":"1f1f3-1f1ff","uc_output":"1f1f3-1f1ff","uc_match":"1f1f3-1f1ff","uc_greedy":"1f1f3-1f1ff","shortnames":[":nz:"],"category":"flags"},":flag_om:":{"uc_base":"1f1f4-1f1f2","uc_output":"1f1f4-1f1f2","uc_match":"1f1f4-1f1f2","uc_greedy":"1f1f4-1f1f2","shortnames":[":om:"],"category":"flags"},":flag_pa:":{"uc_base":"1f1f5-1f1e6","uc_output":"1f1f5-1f1e6","uc_match":"1f1f5-1f1e6","uc_greedy":"1f1f5-1f1e6","shortnames":[":pa:"],"category":"flags"},":flag_pe:":{"uc_base":"1f1f5-1f1ea","uc_output":"1f1f5-1f1ea","uc_match":"1f1f5-1f1ea","uc_greedy":"1f1f5-1f1ea","shortnames":[":pe:"],"category":"flags"},":flag_pf:":{"uc_base":"1f1f5-1f1eb","uc_output":"1f1f5-1f1eb","uc_match":"1f1f5-1f1eb","uc_greedy":"1f1f5-1f1eb","shortnames":[":pf:"],"category":"flags"},":flag_pg:":{"uc_base":"1f1f5-1f1ec","uc_output":"1f1f5-1f1ec","uc_match":"1f1f5-1f1ec","uc_greedy":"1f1f5-1f1ec","shortnames":[":pg:"],"category":"flags"},":flag_ph:":{"uc_base":"1f1f5-1f1ed","uc_output":"1f1f5-1f1ed","uc_match":"1f1f5-1f1ed","uc_greedy":"1f1f5-1f1ed","shortnames":[":ph:"],"category":"flags"},":flag_pk:":{"uc_base":"1f1f5-1f1f0","uc_output":"1f1f5-1f1f0","uc_match":"1f1f5-1f1f0","uc_greedy":"1f1f5-1f1f0","shortnames":[":pk:"],"category":"flags"},":flag_pl:":{"uc_base":"1f1f5-1f1f1","uc_output":"1f1f5-1f1f1","uc_match":"1f1f5-1f1f1","uc_greedy":"1f1f5-1f1f1","shortnames":[":pl:"],"category":"flags"},":flag_pm:":{"uc_base":"1f1f5-1f1f2","uc_output":"1f1f5-1f1f2","uc_match":"1f1f5-1f1f2","uc_greedy":"1f1f5-1f1f2","shortnames":[":pm:"],"category":"flags"},":flag_pn:":{"uc_base":"1f1f5-1f1f3","uc_output":"1f1f5-1f1f3","uc_match":"1f1f5-1f1f3","uc_greedy":"1f1f5-1f1f3","shortnames":[":pn:"],"category":"flags"},":flag_pr:":{"uc_base":"1f1f5-1f1f7","uc_output":"1f1f5-1f1f7","uc_match":"1f1f5-1f1f7","uc_greedy":"1f1f5-1f1f7","shortnames":[":pr:"],"category":"flags"},":flag_ps:":{"uc_base":"1f1f5-1f1f8","uc_output":"1f1f5-1f1f8","uc_match":"1f1f5-1f1f8","uc_greedy":"1f1f5-1f1f8","shortnames":[":ps:"],"category":"flags"},":flag_pt:":{"uc_base":"1f1f5-1f1f9","uc_output":"1f1f5-1f1f9","uc_match":"1f1f5-1f1f9","uc_greedy":"1f1f5-1f1f9","shortnames":[":pt:"],"category":"flags"},":flag_pw:":{"uc_base":"1f1f5-1f1fc","uc_output":"1f1f5-1f1fc","uc_match":"1f1f5-1f1fc","uc_greedy":"1f1f5-1f1fc","shortnames":[":pw:"],"category":"flags"},":flag_py:":{"uc_base":"1f1f5-1f1fe","uc_output":"1f1f5-1f1fe","uc_match":"1f1f5-1f1fe","uc_greedy":"1f1f5-1f1fe","shortnames":[":py:"],"category":"flags"},":flag_qa:":{"uc_base":"1f1f6-1f1e6","uc_output":"1f1f6-1f1e6","uc_match":"1f1f6-1f1e6","uc_greedy":"1f1f6-1f1e6","shortnames":[":qa:"],"category":"flags"},":flag_re:":{"uc_base":"1f1f7-1f1ea","uc_output":"1f1f7-1f1ea","uc_match":"1f1f7-1f1ea","uc_greedy":"1f1f7-1f1ea","shortnames":[":re:"],"category":"flags"},":flag_ro:":{"uc_base":"1f1f7-1f1f4","uc_output":"1f1f7-1f1f4","uc_match":"1f1f7-1f1f4","uc_greedy":"1f1f7-1f1f4","shortnames":[":ro:"],"category":"flags"},":flag_rs:":{"uc_base":"1f1f7-1f1f8","uc_output":"1f1f7-1f1f8","uc_match":"1f1f7-1f1f8","uc_greedy":"1f1f7-1f1f8","shortnames":[":rs:"],"category":"flags"},":flag_ru:":{"uc_base":"1f1f7-1f1fa","uc_output":"1f1f7-1f1fa","uc_match":"1f1f7-1f1fa","uc_greedy":"1f1f7-1f1fa","shortnames":[":ru:"],"category":"flags"},":flag_rw:":{"uc_base":"1f1f7-1f1fc","uc_output":"1f1f7-1f1fc","uc_match":"1f1f7-1f1fc","uc_greedy":"1f1f7-1f1fc","shortnames":[":rw:"],"category":"flags"},":flag_sa:":{"uc_base":"1f1f8-1f1e6","uc_output":"1f1f8-1f1e6","uc_match":"1f1f8-1f1e6","uc_greedy":"1f1f8-1f1e6","shortnames":[":saudiarabia:",":saudi:"],"category":"flags"},":flag_sb:":{"uc_base":"1f1f8-1f1e7","uc_output":"1f1f8-1f1e7","uc_match":"1f1f8-1f1e7","uc_greedy":"1f1f8-1f1e7","shortnames":[":sb:"],"category":"flags"},":flag_sc:":{"uc_base":"1f1f8-1f1e8","uc_output":"1f1f8-1f1e8","uc_match":"1f1f8-1f1e8","uc_greedy":"1f1f8-1f1e8","shortnames":[":sc:"],"category":"flags"},":flag_sd:":{"uc_base":"1f1f8-1f1e9","uc_output":"1f1f8-1f1e9","uc_match":"1f1f8-1f1e9","uc_greedy":"1f1f8-1f1e9","shortnames":[":sd:"],"category":"flags"},":flag_se:":{"uc_base":"1f1f8-1f1ea","uc_output":"1f1f8-1f1ea","uc_match":"1f1f8-1f1ea","uc_greedy":"1f1f8-1f1ea","shortnames":[":se:"],"category":"flags"},":flag_sg:":{"uc_base":"1f1f8-1f1ec","uc_output":"1f1f8-1f1ec","uc_match":"1f1f8-1f1ec","uc_greedy":"1f1f8-1f1ec","shortnames":[":sg:"],"category":"flags"},":flag_sh:":{"uc_base":"1f1f8-1f1ed","uc_output":"1f1f8-1f1ed","uc_match":"1f1f8-1f1ed","uc_greedy":"1f1f8-1f1ed","shortnames":[":sh:"],"category":"flags"},":flag_si:":{"uc_base":"1f1f8-1f1ee","uc_output":"1f1f8-1f1ee","uc_match":"1f1f8-1f1ee","uc_greedy":"1f1f8-1f1ee","shortnames":[":si:"],"category":"flags"},":flag_sj:":{"uc_base":"1f1f8-1f1ef","uc_output":"1f1f8-1f1ef","uc_match":"1f1f8-1f1ef","uc_greedy":"1f1f8-1f1ef","shortnames":[":sj:"],"category":"flags"},":flag_sk:":{"uc_base":"1f1f8-1f1f0","uc_output":"1f1f8-1f1f0","uc_match":"1f1f8-1f1f0","uc_greedy":"1f1f8-1f1f0","shortnames":[":sk:"],"category":"flags"},":flag_sl:":{"uc_base":"1f1f8-1f1f1","uc_output":"1f1f8-1f1f1","uc_match":"1f1f8-1f1f1","uc_greedy":"1f1f8-1f1f1","shortnames":[":sl:"],"category":"flags"},":flag_sm:":{"uc_base":"1f1f8-1f1f2","uc_output":"1f1f8-1f1f2","uc_match":"1f1f8-1f1f2","uc_greedy":"1f1f8-1f1f2","shortnames":[":sm:"],"category":"flags"},":flag_sn:":{"uc_base":"1f1f8-1f1f3","uc_output":"1f1f8-1f1f3","uc_match":"1f1f8-1f1f3","uc_greedy":"1f1f8-1f1f3","shortnames":[":sn:"],"category":"flags"},":flag_so:":{"uc_base":"1f1f8-1f1f4","uc_output":"1f1f8-1f1f4","uc_match":"1f1f8-1f1f4","uc_greedy":"1f1f8-1f1f4","shortnames":[":so:"],"category":"flags"},":flag_sr:":{"uc_base":"1f1f8-1f1f7","uc_output":"1f1f8-1f1f7","uc_match":"1f1f8-1f1f7","uc_greedy":"1f1f8-1f1f7","shortnames":[":sr:"],"category":"flags"},":flag_ss:":{"uc_base":"1f1f8-1f1f8","uc_output":"1f1f8-1f1f8","uc_match":"1f1f8-1f1f8","uc_greedy":"1f1f8-1f1f8","shortnames":[":ss:"],"category":"flags"},":flag_st:":{"uc_base":"1f1f8-1f1f9","uc_output":"1f1f8-1f1f9","uc_match":"1f1f8-1f1f9","uc_greedy":"1f1f8-1f1f9","shortnames":[":st:"],"category":"flags"},":flag_sv:":{"uc_base":"1f1f8-1f1fb","uc_output":"1f1f8-1f1fb","uc_match":"1f1f8-1f1fb","uc_greedy":"1f1f8-1f1fb","shortnames":[":sv:"],"category":"flags"},":flag_sx:":{"uc_base":"1f1f8-1f1fd","uc_output":"1f1f8-1f1fd","uc_match":"1f1f8-1f1fd","uc_greedy":"1f1f8-1f1fd","shortnames":[":sx:"],"category":"flags"},":flag_sy:":{"uc_base":"1f1f8-1f1fe","uc_output":"1f1f8-1f1fe","uc_match":"1f1f8-1f1fe","uc_greedy":"1f1f8-1f1fe","shortnames":[":sy:"],"category":"flags"},":flag_sz:":{"uc_base":"1f1f8-1f1ff","uc_output":"1f1f8-1f1ff","uc_match":"1f1f8-1f1ff","uc_greedy":"1f1f8-1f1ff","shortnames":[":sz:"],"category":"flags"},":flag_ta:":{"uc_base":"1f1f9-1f1e6","uc_output":"1f1f9-1f1e6","uc_match":"1f1f9-1f1e6","uc_greedy":"1f1f9-1f1e6","shortnames":[":ta:"],"category":"flags"},":flag_tc:":{"uc_base":"1f1f9-1f1e8","uc_output":"1f1f9-1f1e8","uc_match":"1f1f9-1f1e8","uc_greedy":"1f1f9-1f1e8","shortnames":[":tc:"],"category":"flags"},":flag_td:":{"uc_base":"1f1f9-1f1e9","uc_output":"1f1f9-1f1e9","uc_match":"1f1f9-1f1e9","uc_greedy":"1f1f9-1f1e9","shortnames":[":td:"],"category":"flags"},":flag_tf:":{"uc_base":"1f1f9-1f1eb","uc_output":"1f1f9-1f1eb","uc_match":"1f1f9-1f1eb","uc_greedy":"1f1f9-1f1eb","shortnames":[":tf:"],"category":"flags"},":flag_tg:":{"uc_base":"1f1f9-1f1ec","uc_output":"1f1f9-1f1ec","uc_match":"1f1f9-1f1ec","uc_greedy":"1f1f9-1f1ec","shortnames":[":tg:"],"category":"flags"},":flag_th:":{"uc_base":"1f1f9-1f1ed","uc_output":"1f1f9-1f1ed","uc_match":"1f1f9-1f1ed","uc_greedy":"1f1f9-1f1ed","shortnames":[":th:"],"category":"flags"},":flag_tj:":{"uc_base":"1f1f9-1f1ef","uc_output":"1f1f9-1f1ef","uc_match":"1f1f9-1f1ef","uc_greedy":"1f1f9-1f1ef","shortnames":[":tj:"],"category":"flags"},":flag_tk:":{"uc_base":"1f1f9-1f1f0","uc_output":"1f1f9-1f1f0","uc_match":"1f1f9-1f1f0","uc_greedy":"1f1f9-1f1f0","shortnames":[":tk:"],"category":"flags"},":flag_tl:":{"uc_base":"1f1f9-1f1f1","uc_output":"1f1f9-1f1f1","uc_match":"1f1f9-1f1f1","uc_greedy":"1f1f9-1f1f1","shortnames":[":tl:"],"category":"flags"},":flag_tm:":{"uc_base":"1f1f9-1f1f2","uc_output":"1f1f9-1f1f2","uc_match":"1f1f9-1f1f2","uc_greedy":"1f1f9-1f1f2","shortnames":[":turkmenistan:"],"category":"flags"},":flag_tn:":{"uc_base":"1f1f9-1f1f3","uc_output":"1f1f9-1f1f3","uc_match":"1f1f9-1f1f3","uc_greedy":"1f1f9-1f1f3","shortnames":[":tn:"],"category":"flags"},":flag_to:":{"uc_base":"1f1f9-1f1f4","uc_output":"1f1f9-1f1f4","uc_match":"1f1f9-1f1f4","uc_greedy":"1f1f9-1f1f4","shortnames":[":to:"],"category":"flags"},":flag_tr:":{"uc_base":"1f1f9-1f1f7","uc_output":"1f1f9-1f1f7","uc_match":"1f1f9-1f1f7","uc_greedy":"1f1f9-1f1f7","shortnames":[":tr:"],"category":"flags"},":flag_tt:":{"uc_base":"1f1f9-1f1f9","uc_output":"1f1f9-1f1f9","uc_match":"1f1f9-1f1f9","uc_greedy":"1f1f9-1f1f9","shortnames":[":tt:"],"category":"flags"},":flag_tv:":{"uc_base":"1f1f9-1f1fb","uc_output":"1f1f9-1f1fb","uc_match":"1f1f9-1f1fb","uc_greedy":"1f1f9-1f1fb","shortnames":[":tuvalu:"],"category":"flags"},":flag_tw:":{"uc_base":"1f1f9-1f1fc","uc_output":"1f1f9-1f1fc","uc_match":"1f1f9-1f1fc","uc_greedy":"1f1f9-1f1fc","shortnames":[":tw:"],"category":"flags"},":flag_tz:":{"uc_base":"1f1f9-1f1ff","uc_output":"1f1f9-1f1ff","uc_match":"1f1f9-1f1ff","uc_greedy":"1f1f9-1f1ff","shortnames":[":tz:"],"category":"flags"},":flag_ua:":{"uc_base":"1f1fa-1f1e6","uc_output":"1f1fa-1f1e6","uc_match":"1f1fa-1f1e6","uc_greedy":"1f1fa-1f1e6","shortnames":[":ua:"],"category":"flags"},":flag_ug:":{"uc_base":"1f1fa-1f1ec","uc_output":"1f1fa-1f1ec","uc_match":"1f1fa-1f1ec","uc_greedy":"1f1fa-1f1ec","shortnames":[":ug:"],"category":"flags"},":flag_um:":{"uc_base":"1f1fa-1f1f2","uc_output":"1f1fa-1f1f2","uc_match":"1f1fa-1f1f2","uc_greedy":"1f1fa-1f1f2","shortnames":[":um:"],"category":"flags"},":flag_us:":{"uc_base":"1f1fa-1f1f8","uc_output":"1f1fa-1f1f8","uc_match":"1f1fa-1f1f8","uc_greedy":"1f1fa-1f1f8","shortnames":[":us:"],"category":"flags"},":flag_uy:":{"uc_base":"1f1fa-1f1fe","uc_output":"1f1fa-1f1fe","uc_match":"1f1fa-1f1fe","uc_greedy":"1f1fa-1f1fe","shortnames":[":uy:"],"category":"flags"},":flag_uz:":{"uc_base":"1f1fa-1f1ff","uc_output":"1f1fa-1f1ff","uc_match":"1f1fa-1f1ff","uc_greedy":"1f1fa-1f1ff","shortnames":[":uz:"],"category":"flags"},":flag_va:":{"uc_base":"1f1fb-1f1e6","uc_output":"1f1fb-1f1e6","uc_match":"1f1fb-1f1e6","uc_greedy":"1f1fb-1f1e6","shortnames":[":va:"],"category":"flags"},":flag_vc:":{"uc_base":"1f1fb-1f1e8","uc_output":"1f1fb-1f1e8","uc_match":"1f1fb-1f1e8","uc_greedy":"1f1fb-1f1e8","shortnames":[":vc:"],"category":"flags"},":flag_ve:":{"uc_base":"1f1fb-1f1ea","uc_output":"1f1fb-1f1ea","uc_match":"1f1fb-1f1ea","uc_greedy":"1f1fb-1f1ea","shortnames":[":ve:"],"category":"flags"},":flag_vg:":{"uc_base":"1f1fb-1f1ec","uc_output":"1f1fb-1f1ec","uc_match":"1f1fb-1f1ec","uc_greedy":"1f1fb-1f1ec","shortnames":[":vg:"],"category":"flags"},":flag_vi:":{"uc_base":"1f1fb-1f1ee","uc_output":"1f1fb-1f1ee","uc_match":"1f1fb-1f1ee","uc_greedy":"1f1fb-1f1ee","shortnames":[":vi:"],"category":"flags"},":flag_vn:":{"uc_base":"1f1fb-1f1f3","uc_output":"1f1fb-1f1f3","uc_match":"1f1fb-1f1f3","uc_greedy":"1f1fb-1f1f3","shortnames":[":vn:"],"category":"flags"},":flag_vu:":{"uc_base":"1f1fb-1f1fa","uc_output":"1f1fb-1f1fa","uc_match":"1f1fb-1f1fa","uc_greedy":"1f1fb-1f1fa","shortnames":[":vu:"],"category":"flags"},":flag_wf:":{"uc_base":"1f1fc-1f1eb","uc_output":"1f1fc-1f1eb","uc_match":"1f1fc-1f1eb","uc_greedy":"1f1fc-1f1eb","shortnames":[":wf:"],"category":"flags"},":flag_ws:":{"uc_base":"1f1fc-1f1f8","uc_output":"1f1fc-1f1f8","uc_match":"1f1fc-1f1f8","uc_greedy":"1f1fc-1f1f8","shortnames":[":ws:"],"category":"flags"},":flag_xk:":{"uc_base":"1f1fd-1f1f0","uc_output":"1f1fd-1f1f0","uc_match":"1f1fd-1f1f0","uc_greedy":"1f1fd-1f1f0","shortnames":[":xk:"],"category":"flags"},":flag_ye:":{"uc_base":"1f1fe-1f1ea","uc_output":"1f1fe-1f1ea","uc_match":"1f1fe-1f1ea","uc_greedy":"1f1fe-1f1ea","shortnames":[":ye:"],"category":"flags"},":flag_yt:":{"uc_base":"1f1fe-1f1f9","uc_output":"1f1fe-1f1f9","uc_match":"1f1fe-1f1f9","uc_greedy":"1f1fe-1f1f9","shortnames":[":yt:"],"category":"flags"},":flag_za:":{"uc_base":"1f1ff-1f1e6","uc_output":"1f1ff-1f1e6","uc_match":"1f1ff-1f1e6","uc_greedy":"1f1ff-1f1e6","shortnames":[":za:"],"category":"flags"},":flag_zm:":{"uc_base":"1f1ff-1f1f2","uc_output":"1f1ff-1f1f2","uc_match":"1f1ff-1f1f2","uc_greedy":"1f1ff-1f1f2","shortnames":[":zm:"],"category":"flags"},":flag_zw:":{"uc_base":"1f1ff-1f1fc","uc_output":"1f1ff-1f1fc","uc_match":"1f1ff-1f1fc","uc_greedy":"1f1ff-1f1fc","shortnames":[":zw:"],"category":"flags"},":foot_tone1:":{"uc_base":"1f9b6-1f3fb","uc_output":"1f9b6-1f3fb","uc_match":"1f9b6-1f3fb","uc_greedy":"1f9b6-1f3fb","shortnames":[":foot_light_skin_tone:"],"category":"people"},":foot_tone2:":{"uc_base":"1f9b6-1f3fc","uc_output":"1f9b6-1f3fc","uc_match":"1f9b6-1f3fc","uc_greedy":"1f9b6-1f3fc","shortnames":[":foot_medium_light_skin_tone:"],"category":"people"},":foot_tone3:":{"uc_base":"1f9b6-1f3fd","uc_output":"1f9b6-1f3fd","uc_match":"1f9b6-1f3fd","uc_greedy":"1f9b6-1f3fd","shortnames":[":foot_medium_skin_tone:"],"category":"people"},":foot_tone4:":{"uc_base":"1f9b6-1f3fe","uc_output":"1f9b6-1f3fe","uc_match":"1f9b6-1f3fe","uc_greedy":"1f9b6-1f3fe","shortnames":[":foot_medium_dark_skin_tone:"],"category":"people"},":foot_tone5:":{"uc_base":"1f9b6-1f3ff","uc_output":"1f9b6-1f3ff","uc_match":"1f9b6-1f3ff","uc_greedy":"1f9b6-1f3ff","shortnames":[":foot_dark_skin_tone:"],"category":"people"},":girl_tone1:":{"uc_base":"1f467-1f3fb","uc_output":"1f467-1f3fb","uc_match":"1f467-1f3fb","uc_greedy":"1f467-1f3fb","shortnames":[],"category":"people"},":girl_tone2:":{"uc_base":"1f467-1f3fc","uc_output":"1f467-1f3fc","uc_match":"1f467-1f3fc","uc_greedy":"1f467-1f3fc","shortnames":[],"category":"people"},":girl_tone3:":{"uc_base":"1f467-1f3fd","uc_output":"1f467-1f3fd","uc_match":"1f467-1f3fd","uc_greedy":"1f467-1f3fd","shortnames":[],"category":"people"},":girl_tone4:":{"uc_base":"1f467-1f3fe","uc_output":"1f467-1f3fe","uc_match":"1f467-1f3fe","uc_greedy":"1f467-1f3fe","shortnames":[],"category":"people"},":girl_tone5:":{"uc_base":"1f467-1f3ff","uc_output":"1f467-1f3ff","uc_match":"1f467-1f3ff","uc_greedy":"1f467-1f3ff","shortnames":[],"category":"people"},":guard_tone1:":{"uc_base":"1f482-1f3fb","uc_output":"1f482-1f3fb","uc_match":"1f482-1f3fb","uc_greedy":"1f482-1f3fb","shortnames":[":guardsman_tone1:"],"category":"people"},":guard_tone2:":{"uc_base":"1f482-1f3fc","uc_output":"1f482-1f3fc","uc_match":"1f482-1f3fc","uc_greedy":"1f482-1f3fc","shortnames":[":guardsman_tone2:"],"category":"people"},":guard_tone3:":{"uc_base":"1f482-1f3fd","uc_output":"1f482-1f3fd","uc_match":"1f482-1f3fd","uc_greedy":"1f482-1f3fd","shortnames":[":guardsman_tone3:"],"category":"people"},":guard_tone4:":{"uc_base":"1f482-1f3fe","uc_output":"1f482-1f3fe","uc_match":"1f482-1f3fe","uc_greedy":"1f482-1f3fe","shortnames":[":guardsman_tone4:"],"category":"people"},":guard_tone5:":{"uc_base":"1f482-1f3ff","uc_output":"1f482-1f3ff","uc_match":"1f482-1f3ff","uc_greedy":"1f482-1f3ff","shortnames":[":guardsman_tone5:"],"category":"people"},":hand_splayed_tone1:":{"uc_base":"1f590-1f3fb","uc_output":"1f590-1f3fb","uc_match":"1f590-fe0f-1f3fb","uc_greedy":"1f590-fe0f-1f3fb","shortnames":[":raised_hand_with_fingers_splayed_tone1:"],"category":"people"},":hand_splayed_tone2:":{"uc_base":"1f590-1f3fc","uc_output":"1f590-1f3fc","uc_match":"1f590-fe0f-1f3fc","uc_greedy":"1f590-fe0f-1f3fc","shortnames":[":raised_hand_with_fingers_splayed_tone2:"],"category":"people"},":hand_splayed_tone3:":{"uc_base":"1f590-1f3fd","uc_output":"1f590-1f3fd","uc_match":"1f590-fe0f-1f3fd","uc_greedy":"1f590-fe0f-1f3fd","shortnames":[":raised_hand_with_fingers_splayed_tone3:"],"category":"people"},":hand_splayed_tone4:":{"uc_base":"1f590-1f3fe","uc_output":"1f590-1f3fe","uc_match":"1f590-fe0f-1f3fe","uc_greedy":"1f590-fe0f-1f3fe","shortnames":[":raised_hand_with_fingers_splayed_tone4:"],"category":"people"},":hand_splayed_tone5:":{"uc_base":"1f590-1f3ff","uc_output":"1f590-1f3ff","uc_match":"1f590-fe0f-1f3ff","uc_greedy":"1f590-fe0f-1f3ff","shortnames":[":raised_hand_with_fingers_splayed_tone5:"],"category":"people"},":horse_racing_tone1:":{"uc_base":"1f3c7-1f3fb","uc_output":"1f3c7-1f3fb","uc_match":"1f3c7-1f3fb","uc_greedy":"1f3c7-1f3fb","shortnames":[],"category":"activity"},":horse_racing_tone2:":{"uc_base":"1f3c7-1f3fc","uc_output":"1f3c7-1f3fc","uc_match":"1f3c7-1f3fc","uc_greedy":"1f3c7-1f3fc","shortnames":[],"category":"activity"},":horse_racing_tone3:":{"uc_base":"1f3c7-1f3fd","uc_output":"1f3c7-1f3fd","uc_match":"1f3c7-1f3fd","uc_greedy":"1f3c7-1f3fd","shortnames":[],"category":"activity"},":horse_racing_tone4:":{"uc_base":"1f3c7-1f3fe","uc_output":"1f3c7-1f3fe","uc_match":"1f3c7-1f3fe","uc_greedy":"1f3c7-1f3fe","shortnames":[],"category":"activity"},":horse_racing_tone5:":{"uc_base":"1f3c7-1f3ff","uc_output":"1f3c7-1f3ff","uc_match":"1f3c7-1f3ff","uc_greedy":"1f3c7-1f3ff","shortnames":[],"category":"activity"},":left_facing_fist_tone1:":{"uc_base":"1f91b-1f3fb","uc_output":"1f91b-1f3fb","uc_match":"1f91b-1f3fb","uc_greedy":"1f91b-1f3fb","shortnames":[":left_fist_tone1:"],"category":"people"},":left_facing_fist_tone2:":{"uc_base":"1f91b-1f3fc","uc_output":"1f91b-1f3fc","uc_match":"1f91b-1f3fc","uc_greedy":"1f91b-1f3fc","shortnames":[":left_fist_tone2:"],"category":"people"},":left_facing_fist_tone3:":{"uc_base":"1f91b-1f3fd","uc_output":"1f91b-1f3fd","uc_match":"1f91b-1f3fd","uc_greedy":"1f91b-1f3fd","shortnames":[":left_fist_tone3:"],"category":"people"},":left_facing_fist_tone4:":{"uc_base":"1f91b-1f3fe","uc_output":"1f91b-1f3fe","uc_match":"1f91b-1f3fe","uc_greedy":"1f91b-1f3fe","shortnames":[":left_fist_tone4:"],"category":"people"},":left_facing_fist_tone5:":{"uc_base":"1f91b-1f3ff","uc_output":"1f91b-1f3ff","uc_match":"1f91b-1f3ff","uc_greedy":"1f91b-1f3ff","shortnames":[":left_fist_tone5:"],"category":"people"},":leg_tone1:":{"uc_base":"1f9b5-1f3fb","uc_output":"1f9b5-1f3fb","uc_match":"1f9b5-1f3fb","uc_greedy":"1f9b5-1f3fb","shortnames":[":leg_light_skin_tone:"],"category":"people"},":leg_tone2:":{"uc_base":"1f9b5-1f3fc","uc_output":"1f9b5-1f3fc","uc_match":"1f9b5-1f3fc","uc_greedy":"1f9b5-1f3fc","shortnames":[":leg_medium_light_skin_tone:"],"category":"people"},":leg_tone3:":{"uc_base":"1f9b5-1f3fd","uc_output":"1f9b5-1f3fd","uc_match":"1f9b5-1f3fd","uc_greedy":"1f9b5-1f3fd","shortnames":[":leg_medium_skin_tone:"],"category":"people"},":leg_tone4:":{"uc_base":"1f9b5-1f3fe","uc_output":"1f9b5-1f3fe","uc_match":"1f9b5-1f3fe","uc_greedy":"1f9b5-1f3fe","shortnames":[":leg_medium_dark_skin_tone:"],"category":"people"},":leg_tone5:":{"uc_base":"1f9b5-1f3ff","uc_output":"1f9b5-1f3ff","uc_match":"1f9b5-1f3ff","uc_greedy":"1f9b5-1f3ff","shortnames":[":leg_dark_skin_tone:"],"category":"people"},":levitate_tone1:":{"uc_base":"1f574-1f3fb","uc_output":"1f574-1f3fb","uc_match":"1f574-fe0f-1f3fb","uc_greedy":"1f574-fe0f-1f3fb","shortnames":[":man_in_business_suit_levitating_tone1:",":man_in_business_suit_levitating_light_skin_tone:"],"category":"people"},":levitate_tone2:":{"uc_base":"1f574-1f3fc","uc_output":"1f574-1f3fc","uc_match":"1f574-fe0f-1f3fc","uc_greedy":"1f574-fe0f-1f3fc","shortnames":[":man_in_business_suit_levitating_tone2:",":man_in_business_suit_levitating_medium_light_skin_tone:"],"category":"people"},":levitate_tone3:":{"uc_base":"1f574-1f3fd","uc_output":"1f574-1f3fd","uc_match":"1f574-fe0f-1f3fd","uc_greedy":"1f574-fe0f-1f3fd","shortnames":[":man_in_business_suit_levitating_tone3:",":man_in_business_suit_levitating_medium_skin_tone:"],"category":"people"},":levitate_tone4:":{"uc_base":"1f574-1f3fe","uc_output":"1f574-1f3fe","uc_match":"1f574-fe0f-1f3fe","uc_greedy":"1f574-fe0f-1f3fe","shortnames":[":man_in_business_suit_levitating_tone4:",":man_in_business_suit_levitating_medium_dark_skin_tone:"],"category":"people"},":levitate_tone5:":{"uc_base":"1f574-1f3ff","uc_output":"1f574-1f3ff","uc_match":"1f574-fe0f-1f3ff","uc_greedy":"1f574-fe0f-1f3ff","shortnames":[":man_in_business_suit_levitating_tone5:",":man_in_business_suit_levitating_dark_skin_tone:"],"category":"people"},":love_you_gesture_tone1:":{"uc_base":"1f91f-1f3fb","uc_output":"1f91f-1f3fb","uc_match":"1f91f-1f3fb","uc_greedy":"1f91f-1f3fb","shortnames":[":love_you_gesture_light_skin_tone:"],"category":"people"},":love_you_gesture_tone2:":{"uc_base":"1f91f-1f3fc","uc_output":"1f91f-1f3fc","uc_match":"1f91f-1f3fc","uc_greedy":"1f91f-1f3fc","shortnames":[":love_you_gesture_medium_light_skin_tone:"],"category":"people"},":love_you_gesture_tone3:":{"uc_base":"1f91f-1f3fd","uc_output":"1f91f-1f3fd","uc_match":"1f91f-1f3fd","uc_greedy":"1f91f-1f3fd","shortnames":[":love_you_gesture_medium_skin_tone:"],"category":"people"},":love_you_gesture_tone4:":{"uc_base":"1f91f-1f3fe","uc_output":"1f91f-1f3fe","uc_match":"1f91f-1f3fe","uc_greedy":"1f91f-1f3fe","shortnames":[":love_you_gesture_medium_dark_skin_tone:"],"category":"people"},":love_you_gesture_tone5:":{"uc_base":"1f91f-1f3ff","uc_output":"1f91f-1f3ff","uc_match":"1f91f-1f3ff","uc_greedy":"1f91f-1f3ff","shortnames":[":love_you_gesture_dark_skin_tone:"],"category":"people"},":mage_tone1:":{"uc_base":"1f9d9-1f3fb","uc_output":"1f9d9-1f3fb","uc_match":"1f9d9-1f3fb","uc_greedy":"1f9d9-1f3fb","shortnames":[":mage_light_skin_tone:"],"category":"people"},":mage_tone2:":{"uc_base":"1f9d9-1f3fc","uc_output":"1f9d9-1f3fc","uc_match":"1f9d9-1f3fc","uc_greedy":"1f9d9-1f3fc","shortnames":[":mage_medium_light_skin_tone:"],"category":"people"},":mage_tone3:":{"uc_base":"1f9d9-1f3fd","uc_output":"1f9d9-1f3fd","uc_match":"1f9d9-1f3fd","uc_greedy":"1f9d9-1f3fd","shortnames":[":mage_medium_skin_tone:"],"category":"people"},":mage_tone4:":{"uc_base":"1f9d9-1f3fe","uc_output":"1f9d9-1f3fe","uc_match":"1f9d9-1f3fe","uc_greedy":"1f9d9-1f3fe","shortnames":[":mage_medium_dark_skin_tone:"],"category":"people"},":mage_tone5:":{"uc_base":"1f9d9-1f3ff","uc_output":"1f9d9-1f3ff","uc_match":"1f9d9-1f3ff","uc_greedy":"1f9d9-1f3ff","shortnames":[":mage_dark_skin_tone:"],"category":"people"},":man_dancing_tone1:":{"uc_base":"1f57a-1f3fb","uc_output":"1f57a-1f3fb","uc_match":"1f57a-1f3fb","uc_greedy":"1f57a-1f3fb","shortnames":[":male_dancer_tone1:"],"category":"people"},":man_dancing_tone2:":{"uc_base":"1f57a-1f3fc","uc_output":"1f57a-1f3fc","uc_match":"1f57a-1f3fc","uc_greedy":"1f57a-1f3fc","shortnames":[":male_dancer_tone2:"],"category":"people"},":man_dancing_tone3:":{"uc_base":"1f57a-1f3fd","uc_output":"1f57a-1f3fd","uc_match":"1f57a-1f3fd","uc_greedy":"1f57a-1f3fd","shortnames":[":male_dancer_tone3:"],"category":"people"},":man_dancing_tone4:":{"uc_base":"1f57a-1f3fe","uc_output":"1f57a-1f3fe","uc_match":"1f57a-1f3fe","uc_greedy":"1f57a-1f3fe","shortnames":[":male_dancer_tone4:"],"category":"people"},":man_dancing_tone5:":{"uc_base":"1f57a-1f3ff","uc_output":"1f57a-1f3ff","uc_match":"1f57a-1f3ff","uc_greedy":"1f57a-1f3ff","shortnames":[":male_dancer_tone5:"],"category":"people"},":man_in_tuxedo_tone1:":{"uc_base":"1f935-1f3fb","uc_output":"1f935-1f3fb","uc_match":"1f935-1f3fb","uc_greedy":"1f935-1f3fb","shortnames":[":tuxedo_tone1:"],"category":"people"},":man_in_tuxedo_tone2:":{"uc_base":"1f935-1f3fc","uc_output":"1f935-1f3fc","uc_match":"1f935-1f3fc","uc_greedy":"1f935-1f3fc","shortnames":[":tuxedo_tone2:"],"category":"people"},":man_in_tuxedo_tone3:":{"uc_base":"1f935-1f3fd","uc_output":"1f935-1f3fd","uc_match":"1f935-1f3fd","uc_greedy":"1f935-1f3fd","shortnames":[":tuxedo_tone3:"],"category":"people"},":man_in_tuxedo_tone4:":{"uc_base":"1f935-1f3fe","uc_output":"1f935-1f3fe","uc_match":"1f935-1f3fe","uc_greedy":"1f935-1f3fe","shortnames":[":tuxedo_tone4:"],"category":"people"},":man_in_tuxedo_tone5:":{"uc_base":"1f935-1f3ff","uc_output":"1f935-1f3ff","uc_match":"1f935-1f3ff","uc_greedy":"1f935-1f3ff","shortnames":[":tuxedo_tone5:"],"category":"people"},":man_tone1:":{"uc_base":"1f468-1f3fb","uc_output":"1f468-1f3fb","uc_match":"1f468-1f3fb","uc_greedy":"1f468-1f3fb","shortnames":[],"category":"people"},":man_tone2:":{"uc_base":"1f468-1f3fc","uc_output":"1f468-1f3fc","uc_match":"1f468-1f3fc","uc_greedy":"1f468-1f3fc","shortnames":[],"category":"people"},":man_tone3:":{"uc_base":"1f468-1f3fd","uc_output":"1f468-1f3fd","uc_match":"1f468-1f3fd","uc_greedy":"1f468-1f3fd","shortnames":[],"category":"people"},":man_tone4:":{"uc_base":"1f468-1f3fe","uc_output":"1f468-1f3fe","uc_match":"1f468-1f3fe","uc_greedy":"1f468-1f3fe","shortnames":[],"category":"people"},":man_tone5:":{"uc_base":"1f468-1f3ff","uc_output":"1f468-1f3ff","uc_match":"1f468-1f3ff","uc_greedy":"1f468-1f3ff","shortnames":[],"category":"people"},":man_with_chinese_cap_tone1:":{"uc_base":"1f472-1f3fb","uc_output":"1f472-1f3fb","uc_match":"1f472-1f3fb","uc_greedy":"1f472-1f3fb","shortnames":[":man_with_gua_pi_mao_tone1:"],"category":"people"},":man_with_chinese_cap_tone2:":{"uc_base":"1f472-1f3fc","uc_output":"1f472-1f3fc","uc_match":"1f472-1f3fc","uc_greedy":"1f472-1f3fc","shortnames":[":man_with_gua_pi_mao_tone2:"],"category":"people"},":man_with_chinese_cap_tone3:":{"uc_base":"1f472-1f3fd","uc_output":"1f472-1f3fd","uc_match":"1f472-1f3fd","uc_greedy":"1f472-1f3fd","shortnames":[":man_with_gua_pi_mao_tone3:"],"category":"people"},":man_with_chinese_cap_tone4:":{"uc_base":"1f472-1f3fe","uc_output":"1f472-1f3fe","uc_match":"1f472-1f3fe","uc_greedy":"1f472-1f3fe","shortnames":[":man_with_gua_pi_mao_tone4:"],"category":"people"},":man_with_chinese_cap_tone5:":{"uc_base":"1f472-1f3ff","uc_output":"1f472-1f3ff","uc_match":"1f472-1f3ff","uc_greedy":"1f472-1f3ff","shortnames":[":man_with_gua_pi_mao_tone5:"],"category":"people"},":merperson_tone1:":{"uc_base":"1f9dc-1f3fb","uc_output":"1f9dc-1f3fb","uc_match":"1f9dc-1f3fb","uc_greedy":"1f9dc-1f3fb","shortnames":[":merperson_light_skin_tone:"],"category":"people"},":merperson_tone2:":{"uc_base":"1f9dc-1f3fc","uc_output":"1f9dc-1f3fc","uc_match":"1f9dc-1f3fc","uc_greedy":"1f9dc-1f3fc","shortnames":[":merperson_medium_light_skin_tone:"],"category":"people"},":merperson_tone3:":{"uc_base":"1f9dc-1f3fd","uc_output":"1f9dc-1f3fd","uc_match":"1f9dc-1f3fd","uc_greedy":"1f9dc-1f3fd","shortnames":[":merperson_medium_skin_tone:"],"category":"people"},":merperson_tone4:":{"uc_base":"1f9dc-1f3fe","uc_output":"1f9dc-1f3fe","uc_match":"1f9dc-1f3fe","uc_greedy":"1f9dc-1f3fe","shortnames":[":merperson_medium_dark_skin_tone:"],"category":"people"},":merperson_tone5:":{"uc_base":"1f9dc-1f3ff","uc_output":"1f9dc-1f3ff","uc_match":"1f9dc-1f3ff","uc_greedy":"1f9dc-1f3ff","shortnames":[":merperson_dark_skin_tone:"],"category":"people"},":metal_tone1:":{"uc_base":"1f918-1f3fb","uc_output":"1f918-1f3fb","uc_match":"1f918-1f3fb","uc_greedy":"1f918-1f3fb","shortnames":[":sign_of_the_horns_tone1:"],"category":"people"},":metal_tone2:":{"uc_base":"1f918-1f3fc","uc_output":"1f918-1f3fc","uc_match":"1f918-1f3fc","uc_greedy":"1f918-1f3fc","shortnames":[":sign_of_the_horns_tone2:"],"category":"people"},":metal_tone3:":{"uc_base":"1f918-1f3fd","uc_output":"1f918-1f3fd","uc_match":"1f918-1f3fd","uc_greedy":"1f918-1f3fd","shortnames":[":sign_of_the_horns_tone3:"],"category":"people"},":metal_tone4:":{"uc_base":"1f918-1f3fe","uc_output":"1f918-1f3fe","uc_match":"1f918-1f3fe","uc_greedy":"1f918-1f3fe","shortnames":[":sign_of_the_horns_tone4:"],"category":"people"},":metal_tone5:":{"uc_base":"1f918-1f3ff","uc_output":"1f918-1f3ff","uc_match":"1f918-1f3ff","uc_greedy":"1f918-1f3ff","shortnames":[":sign_of_the_horns_tone5:"],"category":"people"},":middle_finger_tone1:":{"uc_base":"1f595-1f3fb","uc_output":"1f595-1f3fb","uc_match":"1f595-1f3fb","uc_greedy":"1f595-1f3fb","shortnames":[":reversed_hand_with_middle_finger_extended_tone1:"],"category":"people"},":middle_finger_tone2:":{"uc_base":"1f595-1f3fc","uc_output":"1f595-1f3fc","uc_match":"1f595-1f3fc","uc_greedy":"1f595-1f3fc","shortnames":[":reversed_hand_with_middle_finger_extended_tone2:"],"category":"people"},":middle_finger_tone3:":{"uc_base":"1f595-1f3fd","uc_output":"1f595-1f3fd","uc_match":"1f595-1f3fd","uc_greedy":"1f595-1f3fd","shortnames":[":reversed_hand_with_middle_finger_extended_tone3:"],"category":"people"},":middle_finger_tone4:":{"uc_base":"1f595-1f3fe","uc_output":"1f595-1f3fe","uc_match":"1f595-1f3fe","uc_greedy":"1f595-1f3fe","shortnames":[":reversed_hand_with_middle_finger_extended_tone4:"],"category":"people"},":middle_finger_tone5:":{"uc_base":"1f595-1f3ff","uc_output":"1f595-1f3ff","uc_match":"1f595-1f3ff","uc_greedy":"1f595-1f3ff","shortnames":[":reversed_hand_with_middle_finger_extended_tone5:"],"category":"people"},":mrs_claus_tone1:":{"uc_base":"1f936-1f3fb","uc_output":"1f936-1f3fb","uc_match":"1f936-1f3fb","uc_greedy":"1f936-1f3fb","shortnames":[":mother_christmas_tone1:"],"category":"people"},":mrs_claus_tone2:":{"uc_base":"1f936-1f3fc","uc_output":"1f936-1f3fc","uc_match":"1f936-1f3fc","uc_greedy":"1f936-1f3fc","shortnames":[":mother_christmas_tone2:"],"category":"people"},":mrs_claus_tone3:":{"uc_base":"1f936-1f3fd","uc_output":"1f936-1f3fd","uc_match":"1f936-1f3fd","uc_greedy":"1f936-1f3fd","shortnames":[":mother_christmas_tone3:"],"category":"people"},":mrs_claus_tone4:":{"uc_base":"1f936-1f3fe","uc_output":"1f936-1f3fe","uc_match":"1f936-1f3fe","uc_greedy":"1f936-1f3fe","shortnames":[":mother_christmas_tone4:"],"category":"people"},":mrs_claus_tone5:":{"uc_base":"1f936-1f3ff","uc_output":"1f936-1f3ff","uc_match":"1f936-1f3ff","uc_greedy":"1f936-1f3ff","shortnames":[":mother_christmas_tone5:"],"category":"people"},":muscle_tone1:":{"uc_base":"1f4aa-1f3fb","uc_output":"1f4aa-1f3fb","uc_match":"1f4aa-1f3fb","uc_greedy":"1f4aa-1f3fb","shortnames":[],"category":"people"},":muscle_tone2:":{"uc_base":"1f4aa-1f3fc","uc_output":"1f4aa-1f3fc","uc_match":"1f4aa-1f3fc","uc_greedy":"1f4aa-1f3fc","shortnames":[],"category":"people"},":muscle_tone3:":{"uc_base":"1f4aa-1f3fd","uc_output":"1f4aa-1f3fd","uc_match":"1f4aa-1f3fd","uc_greedy":"1f4aa-1f3fd","shortnames":[],"category":"people"},":muscle_tone4:":{"uc_base":"1f4aa-1f3fe","uc_output":"1f4aa-1f3fe","uc_match":"1f4aa-1f3fe","uc_greedy":"1f4aa-1f3fe","shortnames":[],"category":"people"},":muscle_tone5:":{"uc_base":"1f4aa-1f3ff","uc_output":"1f4aa-1f3ff","uc_match":"1f4aa-1f3ff","uc_greedy":"1f4aa-1f3ff","shortnames":[],"category":"people"},":nail_care_tone1:":{"uc_base":"1f485-1f3fb","uc_output":"1f485-1f3fb","uc_match":"1f485-1f3fb","uc_greedy":"1f485-1f3fb","shortnames":[],"category":"people"},":nail_care_tone2:":{"uc_base":"1f485-1f3fc","uc_output":"1f485-1f3fc","uc_match":"1f485-1f3fc","uc_greedy":"1f485-1f3fc","shortnames":[],"category":"people"},":nail_care_tone3:":{"uc_base":"1f485-1f3fd","uc_output":"1f485-1f3fd","uc_match":"1f485-1f3fd","uc_greedy":"1f485-1f3fd","shortnames":[],"category":"people"},":nail_care_tone4:":{"uc_base":"1f485-1f3fe","uc_output":"1f485-1f3fe","uc_match":"1f485-1f3fe","uc_greedy":"1f485-1f3fe","shortnames":[],"category":"people"},":nail_care_tone5:":{"uc_base":"1f485-1f3ff","uc_output":"1f485-1f3ff","uc_match":"1f485-1f3ff","uc_greedy":"1f485-1f3ff","shortnames":[],"category":"people"},":nose_tone1:":{"uc_base":"1f443-1f3fb","uc_output":"1f443-1f3fb","uc_match":"1f443-1f3fb","uc_greedy":"1f443-1f3fb","shortnames":[],"category":"people"},":nose_tone2:":{"uc_base":"1f443-1f3fc","uc_output":"1f443-1f3fc","uc_match":"1f443-1f3fc","uc_greedy":"1f443-1f3fc","shortnames":[],"category":"people"},":nose_tone3:":{"uc_base":"1f443-1f3fd","uc_output":"1f443-1f3fd","uc_match":"1f443-1f3fd","uc_greedy":"1f443-1f3fd","shortnames":[],"category":"people"},":nose_tone4:":{"uc_base":"1f443-1f3fe","uc_output":"1f443-1f3fe","uc_match":"1f443-1f3fe","uc_greedy":"1f443-1f3fe","shortnames":[],"category":"people"},":nose_tone5:":{"uc_base":"1f443-1f3ff","uc_output":"1f443-1f3ff","uc_match":"1f443-1f3ff","uc_greedy":"1f443-1f3ff","shortnames":[],"category":"people"},":ok_hand_tone1:":{"uc_base":"1f44c-1f3fb","uc_output":"1f44c-1f3fb","uc_match":"1f44c-1f3fb","uc_greedy":"1f44c-1f3fb","shortnames":[],"category":"people"},":ok_hand_tone2:":{"uc_base":"1f44c-1f3fc","uc_output":"1f44c-1f3fc","uc_match":"1f44c-1f3fc","uc_greedy":"1f44c-1f3fc","shortnames":[],"category":"people"},":ok_hand_tone3:":{"uc_base":"1f44c-1f3fd","uc_output":"1f44c-1f3fd","uc_match":"1f44c-1f3fd","uc_greedy":"1f44c-1f3fd","shortnames":[],"category":"people"},":ok_hand_tone4:":{"uc_base":"1f44c-1f3fe","uc_output":"1f44c-1f3fe","uc_match":"1f44c-1f3fe","uc_greedy":"1f44c-1f3fe","shortnames":[],"category":"people"},":ok_hand_tone5:":{"uc_base":"1f44c-1f3ff","uc_output":"1f44c-1f3ff","uc_match":"1f44c-1f3ff","uc_greedy":"1f44c-1f3ff","shortnames":[],"category":"people"},":older_adult_tone1:":{"uc_base":"1f9d3-1f3fb","uc_output":"1f9d3-1f3fb","uc_match":"1f9d3-1f3fb","uc_greedy":"1f9d3-1f3fb","shortnames":[":older_adult_light_skin_tone:"],"category":"people"},":older_adult_tone2:":{"uc_base":"1f9d3-1f3fc","uc_output":"1f9d3-1f3fc","uc_match":"1f9d3-1f3fc","uc_greedy":"1f9d3-1f3fc","shortnames":[":older_adult_medium_light_skin_tone:"],"category":"people"},":older_adult_tone3:":{"uc_base":"1f9d3-1f3fd","uc_output":"1f9d3-1f3fd","uc_match":"1f9d3-1f3fd","uc_greedy":"1f9d3-1f3fd","shortnames":[":older_adult_medium_skin_tone:"],"category":"people"},":older_adult_tone4:":{"uc_base":"1f9d3-1f3fe","uc_output":"1f9d3-1f3fe","uc_match":"1f9d3-1f3fe","uc_greedy":"1f9d3-1f3fe","shortnames":[":older_adult_medium_dark_skin_tone:"],"category":"people"},":older_adult_tone5:":{"uc_base":"1f9d3-1f3ff","uc_output":"1f9d3-1f3ff","uc_match":"1f9d3-1f3ff","uc_greedy":"1f9d3-1f3ff","shortnames":[":older_adult_dark_skin_tone:"],"category":"people"},":older_man_tone1:":{"uc_base":"1f474-1f3fb","uc_output":"1f474-1f3fb","uc_match":"1f474-1f3fb","uc_greedy":"1f474-1f3fb","shortnames":[],"category":"people"},":older_man_tone2:":{"uc_base":"1f474-1f3fc","uc_output":"1f474-1f3fc","uc_match":"1f474-1f3fc","uc_greedy":"1f474-1f3fc","shortnames":[],"category":"people"},":older_man_tone3:":{"uc_base":"1f474-1f3fd","uc_output":"1f474-1f3fd","uc_match":"1f474-1f3fd","uc_greedy":"1f474-1f3fd","shortnames":[],"category":"people"},":older_man_tone4:":{"uc_base":"1f474-1f3fe","uc_output":"1f474-1f3fe","uc_match":"1f474-1f3fe","uc_greedy":"1f474-1f3fe","shortnames":[],"category":"people"},":older_man_tone5:":{"uc_base":"1f474-1f3ff","uc_output":"1f474-1f3ff","uc_match":"1f474-1f3ff","uc_greedy":"1f474-1f3ff","shortnames":[],"category":"people"},":older_woman_tone1:":{"uc_base":"1f475-1f3fb","uc_output":"1f475-1f3fb","uc_match":"1f475-1f3fb","uc_greedy":"1f475-1f3fb","shortnames":[":grandma_tone1:"],"category":"people"},":older_woman_tone2:":{"uc_base":"1f475-1f3fc","uc_output":"1f475-1f3fc","uc_match":"1f475-1f3fc","uc_greedy":"1f475-1f3fc","shortnames":[":grandma_tone2:"],"category":"people"},":older_woman_tone3:":{"uc_base":"1f475-1f3fd","uc_output":"1f475-1f3fd","uc_match":"1f475-1f3fd","uc_greedy":"1f475-1f3fd","shortnames":[":grandma_tone3:"],"category":"people"},":older_woman_tone4:":{"uc_base":"1f475-1f3fe","uc_output":"1f475-1f3fe","uc_match":"1f475-1f3fe","uc_greedy":"1f475-1f3fe","shortnames":[":grandma_tone4:"],"category":"people"},":older_woman_tone5:":{"uc_base":"1f475-1f3ff","uc_output":"1f475-1f3ff","uc_match":"1f475-1f3ff","uc_greedy":"1f475-1f3ff","shortnames":[":grandma_tone5:"],"category":"people"},":open_hands_tone1:":{"uc_base":"1f450-1f3fb","uc_output":"1f450-1f3fb","uc_match":"1f450-1f3fb","uc_greedy":"1f450-1f3fb","shortnames":[],"category":"people"},":open_hands_tone2:":{"uc_base":"1f450-1f3fc","uc_output":"1f450-1f3fc","uc_match":"1f450-1f3fc","uc_greedy":"1f450-1f3fc","shortnames":[],"category":"people"},":open_hands_tone3:":{"uc_base":"1f450-1f3fd","uc_output":"1f450-1f3fd","uc_match":"1f450-1f3fd","uc_greedy":"1f450-1f3fd","shortnames":[],"category":"people"},":open_hands_tone4:":{"uc_base":"1f450-1f3fe","uc_output":"1f450-1f3fe","uc_match":"1f450-1f3fe","uc_greedy":"1f450-1f3fe","shortnames":[],"category":"people"},":open_hands_tone5:":{"uc_base":"1f450-1f3ff","uc_output":"1f450-1f3ff","uc_match":"1f450-1f3ff","uc_greedy":"1f450-1f3ff","shortnames":[],"category":"people"},":palms_up_together_tone1:":{"uc_base":"1f932-1f3fb","uc_output":"1f932-1f3fb","uc_match":"1f932-1f3fb","uc_greedy":"1f932-1f3fb","shortnames":[":palms_up_together_light_skin_tone:"],"category":"people"},":palms_up_together_tone2:":{"uc_base":"1f932-1f3fc","uc_output":"1f932-1f3fc","uc_match":"1f932-1f3fc","uc_greedy":"1f932-1f3fc","shortnames":[":palms_up_together_medium_light_skin_tone:"],"category":"people"},":palms_up_together_tone3:":{"uc_base":"1f932-1f3fd","uc_output":"1f932-1f3fd","uc_match":"1f932-1f3fd","uc_greedy":"1f932-1f3fd","shortnames":[":palms_up_together_medium_skin_tone:"],"category":"people"},":palms_up_together_tone4:":{"uc_base":"1f932-1f3fe","uc_output":"1f932-1f3fe","uc_match":"1f932-1f3fe","uc_greedy":"1f932-1f3fe","shortnames":[":palms_up_together_medium_dark_skin_tone:"],"category":"people"},":palms_up_together_tone5:":{"uc_base":"1f932-1f3ff","uc_output":"1f932-1f3ff","uc_match":"1f932-1f3ff","uc_greedy":"1f932-1f3ff","shortnames":[":palms_up_together_dark_skin_tone:"],"category":"people"},":person_biking_tone1:":{"uc_base":"1f6b4-1f3fb","uc_output":"1f6b4-1f3fb","uc_match":"1f6b4-1f3fb","uc_greedy":"1f6b4-1f3fb","shortnames":[":bicyclist_tone1:"],"category":"activity"},":person_biking_tone2:":{"uc_base":"1f6b4-1f3fc","uc_output":"1f6b4-1f3fc","uc_match":"1f6b4-1f3fc","uc_greedy":"1f6b4-1f3fc","shortnames":[":bicyclist_tone2:"],"category":"activity"},":person_biking_tone3:":{"uc_base":"1f6b4-1f3fd","uc_output":"1f6b4-1f3fd","uc_match":"1f6b4-1f3fd","uc_greedy":"1f6b4-1f3fd","shortnames":[":bicyclist_tone3:"],"category":"activity"},":person_biking_tone4:":{"uc_base":"1f6b4-1f3fe","uc_output":"1f6b4-1f3fe","uc_match":"1f6b4-1f3fe","uc_greedy":"1f6b4-1f3fe","shortnames":[":bicyclist_tone4:"],"category":"activity"},":person_biking_tone5:":{"uc_base":"1f6b4-1f3ff","uc_output":"1f6b4-1f3ff","uc_match":"1f6b4-1f3ff","uc_greedy":"1f6b4-1f3ff","shortnames":[":bicyclist_tone5:"],"category":"activity"},":person_bowing_tone1:":{"uc_base":"1f647-1f3fb","uc_output":"1f647-1f3fb","uc_match":"1f647-1f3fb","uc_greedy":"1f647-1f3fb","shortnames":[":bow_tone1:"],"category":"people"},":person_bowing_tone2:":{"uc_base":"1f647-1f3fc","uc_output":"1f647-1f3fc","uc_match":"1f647-1f3fc","uc_greedy":"1f647-1f3fc","shortnames":[":bow_tone2:"],"category":"people"},":person_bowing_tone3:":{"uc_base":"1f647-1f3fd","uc_output":"1f647-1f3fd","uc_match":"1f647-1f3fd","uc_greedy":"1f647-1f3fd","shortnames":[":bow_tone3:"],"category":"people"},":person_bowing_tone4:":{"uc_base":"1f647-1f3fe","uc_output":"1f647-1f3fe","uc_match":"1f647-1f3fe","uc_greedy":"1f647-1f3fe","shortnames":[":bow_tone4:"],"category":"people"},":person_bowing_tone5:":{"uc_base":"1f647-1f3ff","uc_output":"1f647-1f3ff","uc_match":"1f647-1f3ff","uc_greedy":"1f647-1f3ff","shortnames":[":bow_tone5:"],"category":"people"},":person_climbing_tone1:":{"uc_base":"1f9d7-1f3fb","uc_output":"1f9d7-1f3fb","uc_match":"1f9d7-1f3fb","uc_greedy":"1f9d7-1f3fb","shortnames":[":person_climbing_light_skin_tone:"],"category":"activity"},":person_climbing_tone2:":{"uc_base":"1f9d7-1f3fc","uc_output":"1f9d7-1f3fc","uc_match":"1f9d7-1f3fc","uc_greedy":"1f9d7-1f3fc","shortnames":[":person_climbing_medium_light_skin_tone:"],"category":"activity"},":person_climbing_tone3:":{"uc_base":"1f9d7-1f3fd","uc_output":"1f9d7-1f3fd","uc_match":"1f9d7-1f3fd","uc_greedy":"1f9d7-1f3fd","shortnames":[":person_climbing_medium_skin_tone:"],"category":"activity"},":person_climbing_tone4:":{"uc_base":"1f9d7-1f3fe","uc_output":"1f9d7-1f3fe","uc_match":"1f9d7-1f3fe","uc_greedy":"1f9d7-1f3fe","shortnames":[":person_climbing_medium_dark_skin_tone:"],"category":"activity"},":person_climbing_tone5:":{"uc_base":"1f9d7-1f3ff","uc_output":"1f9d7-1f3ff","uc_match":"1f9d7-1f3ff","uc_greedy":"1f9d7-1f3ff","shortnames":[":person_climbing_dark_skin_tone:"],"category":"activity"},":person_doing_cartwheel_tone1:":{"uc_base":"1f938-1f3fb","uc_output":"1f938-1f3fb","uc_match":"1f938-1f3fb","uc_greedy":"1f938-1f3fb","shortnames":[":cartwheel_tone1:"],"category":"activity"},":person_doing_cartwheel_tone2:":{"uc_base":"1f938-1f3fc","uc_output":"1f938-1f3fc","uc_match":"1f938-1f3fc","uc_greedy":"1f938-1f3fc","shortnames":[":cartwheel_tone2:"],"category":"activity"},":person_doing_cartwheel_tone3:":{"uc_base":"1f938-1f3fd","uc_output":"1f938-1f3fd","uc_match":"1f938-1f3fd","uc_greedy":"1f938-1f3fd","shortnames":[":cartwheel_tone3:"],"category":"activity"},":person_doing_cartwheel_tone4:":{"uc_base":"1f938-1f3fe","uc_output":"1f938-1f3fe","uc_match":"1f938-1f3fe","uc_greedy":"1f938-1f3fe","shortnames":[":cartwheel_tone4:"],"category":"activity"},":person_doing_cartwheel_tone5:":{"uc_base":"1f938-1f3ff","uc_output":"1f938-1f3ff","uc_match":"1f938-1f3ff","uc_greedy":"1f938-1f3ff","shortnames":[":cartwheel_tone5:"],"category":"activity"},":person_facepalming_tone1:":{"uc_base":"1f926-1f3fb","uc_output":"1f926-1f3fb","uc_match":"1f926-1f3fb","uc_greedy":"1f926-1f3fb","shortnames":[":face_palm_tone1:",":facepalm_tone1:"],"category":"people"},":person_facepalming_tone2:":{"uc_base":"1f926-1f3fc","uc_output":"1f926-1f3fc","uc_match":"1f926-1f3fc","uc_greedy":"1f926-1f3fc","shortnames":[":face_palm_tone2:",":facepalm_tone2:"],"category":"people"},":person_facepalming_tone3:":{"uc_base":"1f926-1f3fd","uc_output":"1f926-1f3fd","uc_match":"1f926-1f3fd","uc_greedy":"1f926-1f3fd","shortnames":[":face_palm_tone3:",":facepalm_tone3:"],"category":"people"},":person_facepalming_tone4:":{"uc_base":"1f926-1f3fe","uc_output":"1f926-1f3fe","uc_match":"1f926-1f3fe","uc_greedy":"1f926-1f3fe","shortnames":[":face_palm_tone4:",":facepalm_tone4:"],"category":"people"},":person_facepalming_tone5:":{"uc_base":"1f926-1f3ff","uc_output":"1f926-1f3ff","uc_match":"1f926-1f3ff","uc_greedy":"1f926-1f3ff","shortnames":[":face_palm_tone5:",":facepalm_tone5:"],"category":"people"},":person_frowning_tone1:":{"uc_base":"1f64d-1f3fb","uc_output":"1f64d-1f3fb","uc_match":"1f64d-1f3fb","uc_greedy":"1f64d-1f3fb","shortnames":[],"category":"people"},":person_frowning_tone2:":{"uc_base":"1f64d-1f3fc","uc_output":"1f64d-1f3fc","uc_match":"1f64d-1f3fc","uc_greedy":"1f64d-1f3fc","shortnames":[],"category":"people"},":person_frowning_tone3:":{"uc_base":"1f64d-1f3fd","uc_output":"1f64d-1f3fd","uc_match":"1f64d-1f3fd","uc_greedy":"1f64d-1f3fd","shortnames":[],"category":"people"},":person_frowning_tone4:":{"uc_base":"1f64d-1f3fe","uc_output":"1f64d-1f3fe","uc_match":"1f64d-1f3fe","uc_greedy":"1f64d-1f3fe","shortnames":[],"category":"people"},":person_frowning_tone5:":{"uc_base":"1f64d-1f3ff","uc_output":"1f64d-1f3ff","uc_match":"1f64d-1f3ff","uc_greedy":"1f64d-1f3ff","shortnames":[],"category":"people"},":person_gesturing_no_tone1:":{"uc_base":"1f645-1f3fb","uc_output":"1f645-1f3fb","uc_match":"1f645-1f3fb","uc_greedy":"1f645-1f3fb","shortnames":[":no_good_tone1:"],"category":"people"},":person_gesturing_no_tone2:":{"uc_base":"1f645-1f3fc","uc_output":"1f645-1f3fc","uc_match":"1f645-1f3fc","uc_greedy":"1f645-1f3fc","shortnames":[":no_good_tone2:"],"category":"people"},":person_gesturing_no_tone3:":{"uc_base":"1f645-1f3fd","uc_output":"1f645-1f3fd","uc_match":"1f645-1f3fd","uc_greedy":"1f645-1f3fd","shortnames":[":no_good_tone3:"],"category":"people"},":person_gesturing_no_tone4:":{"uc_base":"1f645-1f3fe","uc_output":"1f645-1f3fe","uc_match":"1f645-1f3fe","uc_greedy":"1f645-1f3fe","shortnames":[":no_good_tone4:"],"category":"people"},":person_gesturing_no_tone5:":{"uc_base":"1f645-1f3ff","uc_output":"1f645-1f3ff","uc_match":"1f645-1f3ff","uc_greedy":"1f645-1f3ff","shortnames":[":no_good_tone5:"],"category":"people"},":person_gesturing_ok_tone1:":{"uc_base":"1f646-1f3fb","uc_output":"1f646-1f3fb","uc_match":"1f646-1f3fb","uc_greedy":"1f646-1f3fb","shortnames":[":ok_woman_tone1:"],"category":"people"},":person_gesturing_ok_tone2:":{"uc_base":"1f646-1f3fc","uc_output":"1f646-1f3fc","uc_match":"1f646-1f3fc","uc_greedy":"1f646-1f3fc","shortnames":[":ok_woman_tone2:"],"category":"people"},":person_gesturing_ok_tone3:":{"uc_base":"1f646-1f3fd","uc_output":"1f646-1f3fd","uc_match":"1f646-1f3fd","uc_greedy":"1f646-1f3fd","shortnames":[":ok_woman_tone3:"],"category":"people"},":person_gesturing_ok_tone4:":{"uc_base":"1f646-1f3fe","uc_output":"1f646-1f3fe","uc_match":"1f646-1f3fe","uc_greedy":"1f646-1f3fe","shortnames":[":ok_woman_tone4:"],"category":"people"},":person_gesturing_ok_tone5:":{"uc_base":"1f646-1f3ff","uc_output":"1f646-1f3ff","uc_match":"1f646-1f3ff","uc_greedy":"1f646-1f3ff","shortnames":[":ok_woman_tone5:"],"category":"people"},":person_getting_haircut_tone1:":{"uc_base":"1f487-1f3fb","uc_output":"1f487-1f3fb","uc_match":"1f487-1f3fb","uc_greedy":"1f487-1f3fb","shortnames":[":haircut_tone1:"],"category":"people"},":person_getting_haircut_tone2:":{"uc_base":"1f487-1f3fc","uc_output":"1f487-1f3fc","uc_match":"1f487-1f3fc","uc_greedy":"1f487-1f3fc","shortnames":[":haircut_tone2:"],"category":"people"},":person_getting_haircut_tone3:":{"uc_base":"1f487-1f3fd","uc_output":"1f487-1f3fd","uc_match":"1f487-1f3fd","uc_greedy":"1f487-1f3fd","shortnames":[":haircut_tone3:"],"category":"people"},":person_getting_haircut_tone4:":{"uc_base":"1f487-1f3fe","uc_output":"1f487-1f3fe","uc_match":"1f487-1f3fe","uc_greedy":"1f487-1f3fe","shortnames":[":haircut_tone4:"],"category":"people"},":person_getting_haircut_tone5:":{"uc_base":"1f487-1f3ff","uc_output":"1f487-1f3ff","uc_match":"1f487-1f3ff","uc_greedy":"1f487-1f3ff","shortnames":[":haircut_tone5:"],"category":"people"},":person_getting_massage_tone1:":{"uc_base":"1f486-1f3fb","uc_output":"1f486-1f3fb","uc_match":"1f486-1f3fb","uc_greedy":"1f486-1f3fb","shortnames":[":massage_tone1:"],"category":"people"},":person_getting_massage_tone2:":{"uc_base":"1f486-1f3fc","uc_output":"1f486-1f3fc","uc_match":"1f486-1f3fc","uc_greedy":"1f486-1f3fc","shortnames":[":massage_tone2:"],"category":"people"},":person_getting_massage_tone3:":{"uc_base":"1f486-1f3fd","uc_output":"1f486-1f3fd","uc_match":"1f486-1f3fd","uc_greedy":"1f486-1f3fd","shortnames":[":massage_tone3:"],"category":"people"},":person_getting_massage_tone4:":{"uc_base":"1f486-1f3fe","uc_output":"1f486-1f3fe","uc_match":"1f486-1f3fe","uc_greedy":"1f486-1f3fe","shortnames":[":massage_tone4:"],"category":"people"},":person_getting_massage_tone5:":{"uc_base":"1f486-1f3ff","uc_output":"1f486-1f3ff","uc_match":"1f486-1f3ff","uc_greedy":"1f486-1f3ff","shortnames":[":massage_tone5:"],"category":"people"},":person_golfing_tone1:":{"uc_base":"1f3cc-1f3fb","uc_output":"1f3cc-1f3fb","uc_match":"1f3cc-fe0f-1f3fb","uc_greedy":"1f3cc-fe0f-1f3fb","shortnames":[":person_golfing_light_skin_tone:"],"category":"activity"},":person_golfing_tone2:":{"uc_base":"1f3cc-1f3fc","uc_output":"1f3cc-1f3fc","uc_match":"1f3cc-fe0f-1f3fc","uc_greedy":"1f3cc-fe0f-1f3fc","shortnames":[":person_golfing_medium_light_skin_tone:"],"category":"activity"},":person_golfing_tone3:":{"uc_base":"1f3cc-1f3fd","uc_output":"1f3cc-1f3fd","uc_match":"1f3cc-fe0f-1f3fd","uc_greedy":"1f3cc-fe0f-1f3fd","shortnames":[":person_golfing_medium_skin_tone:"],"category":"activity"},":person_golfing_tone4:":{"uc_base":"1f3cc-1f3fe","uc_output":"1f3cc-1f3fe","uc_match":"1f3cc-fe0f-1f3fe","uc_greedy":"1f3cc-fe0f-1f3fe","shortnames":[":person_golfing_medium_dark_skin_tone:"],"category":"activity"},":person_golfing_tone5:":{"uc_base":"1f3cc-1f3ff","uc_output":"1f3cc-1f3ff","uc_match":"1f3cc-fe0f-1f3ff","uc_greedy":"1f3cc-fe0f-1f3ff","shortnames":[":person_golfing_dark_skin_tone:"],"category":"activity"},":person_in_bed_tone1:":{"uc_base":"1f6cc-1f3fb","uc_output":"1f6cc-1f3fb","uc_match":"1f6cc-1f3fb","uc_greedy":"1f6cc-1f3fb","shortnames":[":person_in_bed_light_skin_tone:"],"category":"objects"},":person_in_bed_tone2:":{"uc_base":"1f6cc-1f3fc","uc_output":"1f6cc-1f3fc","uc_match":"1f6cc-1f3fc","uc_greedy":"1f6cc-1f3fc","shortnames":[":person_in_bed_medium_light_skin_tone:"],"category":"objects"},":person_in_bed_tone3:":{"uc_base":"1f6cc-1f3fd","uc_output":"1f6cc-1f3fd","uc_match":"1f6cc-1f3fd","uc_greedy":"1f6cc-1f3fd","shortnames":[":person_in_bed_medium_skin_tone:"],"category":"objects"},":person_in_bed_tone4:":{"uc_base":"1f6cc-1f3fe","uc_output":"1f6cc-1f3fe","uc_match":"1f6cc-1f3fe","uc_greedy":"1f6cc-1f3fe","shortnames":[":person_in_bed_medium_dark_skin_tone:"],"category":"objects"},":person_in_bed_tone5:":{"uc_base":"1f6cc-1f3ff","uc_output":"1f6cc-1f3ff","uc_match":"1f6cc-1f3ff","uc_greedy":"1f6cc-1f3ff","shortnames":[":person_in_bed_dark_skin_tone:"],"category":"objects"},":person_in_lotus_position_tone1:":{"uc_base":"1f9d8-1f3fb","uc_output":"1f9d8-1f3fb","uc_match":"1f9d8-1f3fb","uc_greedy":"1f9d8-1f3fb","shortnames":[":person_in_lotus_position_light_skin_tone:"],"category":"activity"},":person_in_lotus_position_tone2:":{"uc_base":"1f9d8-1f3fc","uc_output":"1f9d8-1f3fc","uc_match":"1f9d8-1f3fc","uc_greedy":"1f9d8-1f3fc","shortnames":[":person_in_lotus_position_medium_light_skin_tone:"],"category":"activity"},":person_in_lotus_position_tone3:":{"uc_base":"1f9d8-1f3fd","uc_output":"1f9d8-1f3fd","uc_match":"1f9d8-1f3fd","uc_greedy":"1f9d8-1f3fd","shortnames":[":person_in_lotus_position_medium_skin_tone:"],"category":"activity"},":person_in_lotus_position_tone4:":{"uc_base":"1f9d8-1f3fe","uc_output":"1f9d8-1f3fe","uc_match":"1f9d8-1f3fe","uc_greedy":"1f9d8-1f3fe","shortnames":[":person_in_lotus_position_medium_dark_skin_tone:"],"category":"activity"},":person_in_lotus_position_tone5:":{"uc_base":"1f9d8-1f3ff","uc_output":"1f9d8-1f3ff","uc_match":"1f9d8-1f3ff","uc_greedy":"1f9d8-1f3ff","shortnames":[":person_in_lotus_position_dark_skin_tone:"],"category":"activity"},":person_in_steamy_room_tone1:":{"uc_base":"1f9d6-1f3fb","uc_output":"1f9d6-1f3fb","uc_match":"1f9d6-1f3fb","uc_greedy":"1f9d6-1f3fb","shortnames":[":person_in_steamy_room_light_skin_tone:"],"category":"people"},":person_in_steamy_room_tone2:":{"uc_base":"1f9d6-1f3fc","uc_output":"1f9d6-1f3fc","uc_match":"1f9d6-1f3fc","uc_greedy":"1f9d6-1f3fc","shortnames":[":person_in_steamy_room_medium_light_skin_tone:"],"category":"people"},":person_in_steamy_room_tone3:":{"uc_base":"1f9d6-1f3fd","uc_output":"1f9d6-1f3fd","uc_match":"1f9d6-1f3fd","uc_greedy":"1f9d6-1f3fd","shortnames":[":person_in_steamy_room_medium_skin_tone:"],"category":"people"},":person_in_steamy_room_tone4:":{"uc_base":"1f9d6-1f3fe","uc_output":"1f9d6-1f3fe","uc_match":"1f9d6-1f3fe","uc_greedy":"1f9d6-1f3fe","shortnames":[":person_in_steamy_room_medium_dark_skin_tone:"],"category":"people"},":person_in_steamy_room_tone5:":{"uc_base":"1f9d6-1f3ff","uc_output":"1f9d6-1f3ff","uc_match":"1f9d6-1f3ff","uc_greedy":"1f9d6-1f3ff","shortnames":[":person_in_steamy_room_dark_skin_tone:"],"category":"people"},":person_juggling_tone1:":{"uc_base":"1f939-1f3fb","uc_output":"1f939-1f3fb","uc_match":"1f939-1f3fb","uc_greedy":"1f939-1f3fb","shortnames":[":juggling_tone1:",":juggler_tone1:"],"category":"activity"},":person_juggling_tone2:":{"uc_base":"1f939-1f3fc","uc_output":"1f939-1f3fc","uc_match":"1f939-1f3fc","uc_greedy":"1f939-1f3fc","shortnames":[":juggling_tone2:",":juggler_tone2:"],"category":"activity"},":person_juggling_tone3:":{"uc_base":"1f939-1f3fd","uc_output":"1f939-1f3fd","uc_match":"1f939-1f3fd","uc_greedy":"1f939-1f3fd","shortnames":[":juggling_tone3:",":juggler_tone3:"],"category":"activity"},":person_juggling_tone4:":{"uc_base":"1f939-1f3fe","uc_output":"1f939-1f3fe","uc_match":"1f939-1f3fe","uc_greedy":"1f939-1f3fe","shortnames":[":juggling_tone4:",":juggler_tone4:"],"category":"activity"},":person_juggling_tone5:":{"uc_base":"1f939-1f3ff","uc_output":"1f939-1f3ff","uc_match":"1f939-1f3ff","uc_greedy":"1f939-1f3ff","shortnames":[":juggling_tone5:",":juggler_tone5:"],"category":"activity"},":person_lifting_weights_tone1:":{"uc_base":"1f3cb-1f3fb","uc_output":"1f3cb-1f3fb","uc_match":"1f3cb-fe0f-1f3fb","uc_greedy":"1f3cb-fe0f-1f3fb","shortnames":[":lifter_tone1:",":weight_lifter_tone1:"],"category":"activity"},":person_lifting_weights_tone2:":{"uc_base":"1f3cb-1f3fc","uc_output":"1f3cb-1f3fc","uc_match":"1f3cb-fe0f-1f3fc","uc_greedy":"1f3cb-fe0f-1f3fc","shortnames":[":lifter_tone2:",":weight_lifter_tone2:"],"category":"activity"},":person_lifting_weights_tone3:":{"uc_base":"1f3cb-1f3fd","uc_output":"1f3cb-1f3fd","uc_match":"1f3cb-fe0f-1f3fd","uc_greedy":"1f3cb-fe0f-1f3fd","shortnames":[":lifter_tone3:",":weight_lifter_tone3:"],"category":"activity"},":person_lifting_weights_tone4:":{"uc_base":"1f3cb-1f3fe","uc_output":"1f3cb-1f3fe","uc_match":"1f3cb-fe0f-1f3fe","uc_greedy":"1f3cb-fe0f-1f3fe","shortnames":[":lifter_tone4:",":weight_lifter_tone4:"],"category":"activity"},":person_lifting_weights_tone5:":{"uc_base":"1f3cb-1f3ff","uc_output":"1f3cb-1f3ff","uc_match":"1f3cb-fe0f-1f3ff","uc_greedy":"1f3cb-fe0f-1f3ff","shortnames":[":lifter_tone5:",":weight_lifter_tone5:"],"category":"activity"},":person_mountain_biking_tone1:":{"uc_base":"1f6b5-1f3fb","uc_output":"1f6b5-1f3fb","uc_match":"1f6b5-1f3fb","uc_greedy":"1f6b5-1f3fb","shortnames":[":mountain_bicyclist_tone1:"],"category":"activity"},":person_mountain_biking_tone2:":{"uc_base":"1f6b5-1f3fc","uc_output":"1f6b5-1f3fc","uc_match":"1f6b5-1f3fc","uc_greedy":"1f6b5-1f3fc","shortnames":[":mountain_bicyclist_tone2:"],"category":"activity"},":person_mountain_biking_tone3:":{"uc_base":"1f6b5-1f3fd","uc_output":"1f6b5-1f3fd","uc_match":"1f6b5-1f3fd","uc_greedy":"1f6b5-1f3fd","shortnames":[":mountain_bicyclist_tone3:"],"category":"activity"},":person_mountain_biking_tone4:":{"uc_base":"1f6b5-1f3fe","uc_output":"1f6b5-1f3fe","uc_match":"1f6b5-1f3fe","uc_greedy":"1f6b5-1f3fe","shortnames":[":mountain_bicyclist_tone4:"],"category":"activity"},":person_mountain_biking_tone5:":{"uc_base":"1f6b5-1f3ff","uc_output":"1f6b5-1f3ff","uc_match":"1f6b5-1f3ff","uc_greedy":"1f6b5-1f3ff","shortnames":[":mountain_bicyclist_tone5:"],"category":"activity"},":person_playing_handball_tone1:":{"uc_base":"1f93e-1f3fb","uc_output":"1f93e-1f3fb","uc_match":"1f93e-1f3fb","uc_greedy":"1f93e-1f3fb","shortnames":[":handball_tone1:"],"category":"activity"},":person_playing_handball_tone2:":{"uc_base":"1f93e-1f3fc","uc_output":"1f93e-1f3fc","uc_match":"1f93e-1f3fc","uc_greedy":"1f93e-1f3fc","shortnames":[":handball_tone2:"],"category":"activity"},":person_playing_handball_tone3:":{"uc_base":"1f93e-1f3fd","uc_output":"1f93e-1f3fd","uc_match":"1f93e-1f3fd","uc_greedy":"1f93e-1f3fd","shortnames":[":handball_tone3:"],"category":"activity"},":person_playing_handball_tone4:":{"uc_base":"1f93e-1f3fe","uc_output":"1f93e-1f3fe","uc_match":"1f93e-1f3fe","uc_greedy":"1f93e-1f3fe","shortnames":[":handball_tone4:"],"category":"activity"},":person_playing_handball_tone5:":{"uc_base":"1f93e-1f3ff","uc_output":"1f93e-1f3ff","uc_match":"1f93e-1f3ff","uc_greedy":"1f93e-1f3ff","shortnames":[":handball_tone5:"],"category":"activity"},":person_playing_water_polo_tone1:":{"uc_base":"1f93d-1f3fb","uc_output":"1f93d-1f3fb","uc_match":"1f93d-1f3fb","uc_greedy":"1f93d-1f3fb","shortnames":[":water_polo_tone1:"],"category":"activity"},":person_playing_water_polo_tone2:":{"uc_base":"1f93d-1f3fc","uc_output":"1f93d-1f3fc","uc_match":"1f93d-1f3fc","uc_greedy":"1f93d-1f3fc","shortnames":[":water_polo_tone2:"],"category":"activity"},":person_playing_water_polo_tone3:":{"uc_base":"1f93d-1f3fd","uc_output":"1f93d-1f3fd","uc_match":"1f93d-1f3fd","uc_greedy":"1f93d-1f3fd","shortnames":[":water_polo_tone3:"],"category":"activity"},":person_playing_water_polo_tone4:":{"uc_base":"1f93d-1f3fe","uc_output":"1f93d-1f3fe","uc_match":"1f93d-1f3fe","uc_greedy":"1f93d-1f3fe","shortnames":[":water_polo_tone4:"],"category":"activity"},":person_playing_water_polo_tone5:":{"uc_base":"1f93d-1f3ff","uc_output":"1f93d-1f3ff","uc_match":"1f93d-1f3ff","uc_greedy":"1f93d-1f3ff","shortnames":[":water_polo_tone5:"],"category":"activity"},":person_pouting_tone1:":{"uc_base":"1f64e-1f3fb","uc_output":"1f64e-1f3fb","uc_match":"1f64e-1f3fb","uc_greedy":"1f64e-1f3fb","shortnames":[":person_with_pouting_face_tone1:"],"category":"people"},":person_pouting_tone2:":{"uc_base":"1f64e-1f3fc","uc_output":"1f64e-1f3fc","uc_match":"1f64e-1f3fc","uc_greedy":"1f64e-1f3fc","shortnames":[":person_with_pouting_face_tone2:"],"category":"people"},":person_pouting_tone3:":{"uc_base":"1f64e-1f3fd","uc_output":"1f64e-1f3fd","uc_match":"1f64e-1f3fd","uc_greedy":"1f64e-1f3fd","shortnames":[":person_with_pouting_face_tone3:"],"category":"people"},":person_pouting_tone4:":{"uc_base":"1f64e-1f3fe","uc_output":"1f64e-1f3fe","uc_match":"1f64e-1f3fe","uc_greedy":"1f64e-1f3fe","shortnames":[":person_with_pouting_face_tone4:"],"category":"people"},":person_pouting_tone5:":{"uc_base":"1f64e-1f3ff","uc_output":"1f64e-1f3ff","uc_match":"1f64e-1f3ff","uc_greedy":"1f64e-1f3ff","shortnames":[":person_with_pouting_face_tone5:"],"category":"people"},":person_raising_hand_tone1:":{"uc_base":"1f64b-1f3fb","uc_output":"1f64b-1f3fb","uc_match":"1f64b-1f3fb","uc_greedy":"1f64b-1f3fb","shortnames":[":raising_hand_tone1:"],"category":"people"},":person_raising_hand_tone2:":{"uc_base":"1f64b-1f3fc","uc_output":"1f64b-1f3fc","uc_match":"1f64b-1f3fc","uc_greedy":"1f64b-1f3fc","shortnames":[":raising_hand_tone2:"],"category":"people"},":person_raising_hand_tone3:":{"uc_base":"1f64b-1f3fd","uc_output":"1f64b-1f3fd","uc_match":"1f64b-1f3fd","uc_greedy":"1f64b-1f3fd","shortnames":[":raising_hand_tone3:"],"category":"people"},":person_raising_hand_tone4:":{"uc_base":"1f64b-1f3fe","uc_output":"1f64b-1f3fe","uc_match":"1f64b-1f3fe","uc_greedy":"1f64b-1f3fe","shortnames":[":raising_hand_tone4:"],"category":"people"},":person_raising_hand_tone5:":{"uc_base":"1f64b-1f3ff","uc_output":"1f64b-1f3ff","uc_match":"1f64b-1f3ff","uc_greedy":"1f64b-1f3ff","shortnames":[":raising_hand_tone5:"],"category":"people"},":person_rowing_boat_tone1:":{"uc_base":"1f6a3-1f3fb","uc_output":"1f6a3-1f3fb","uc_match":"1f6a3-1f3fb","uc_greedy":"1f6a3-1f3fb","shortnames":[":rowboat_tone1:"],"category":"activity"},":person_rowing_boat_tone2:":{"uc_base":"1f6a3-1f3fc","uc_output":"1f6a3-1f3fc","uc_match":"1f6a3-1f3fc","uc_greedy":"1f6a3-1f3fc","shortnames":[":rowboat_tone2:"],"category":"activity"},":person_rowing_boat_tone3:":{"uc_base":"1f6a3-1f3fd","uc_output":"1f6a3-1f3fd","uc_match":"1f6a3-1f3fd","uc_greedy":"1f6a3-1f3fd","shortnames":[":rowboat_tone3:"],"category":"activity"},":person_rowing_boat_tone4:":{"uc_base":"1f6a3-1f3fe","uc_output":"1f6a3-1f3fe","uc_match":"1f6a3-1f3fe","uc_greedy":"1f6a3-1f3fe","shortnames":[":rowboat_tone4:"],"category":"activity"},":person_rowing_boat_tone5:":{"uc_base":"1f6a3-1f3ff","uc_output":"1f6a3-1f3ff","uc_match":"1f6a3-1f3ff","uc_greedy":"1f6a3-1f3ff","shortnames":[":rowboat_tone5:"],"category":"activity"},":person_running_tone1:":{"uc_base":"1f3c3-1f3fb","uc_output":"1f3c3-1f3fb","uc_match":"1f3c3-1f3fb","uc_greedy":"1f3c3-1f3fb","shortnames":[":runner_tone1:"],"category":"people"},":person_running_tone2:":{"uc_base":"1f3c3-1f3fc","uc_output":"1f3c3-1f3fc","uc_match":"1f3c3-1f3fc","uc_greedy":"1f3c3-1f3fc","shortnames":[":runner_tone2:"],"category":"people"},":person_running_tone3:":{"uc_base":"1f3c3-1f3fd","uc_output":"1f3c3-1f3fd","uc_match":"1f3c3-1f3fd","uc_greedy":"1f3c3-1f3fd","shortnames":[":runner_tone3:"],"category":"people"},":person_running_tone4:":{"uc_base":"1f3c3-1f3fe","uc_output":"1f3c3-1f3fe","uc_match":"1f3c3-1f3fe","uc_greedy":"1f3c3-1f3fe","shortnames":[":runner_tone4:"],"category":"people"},":person_running_tone5:":{"uc_base":"1f3c3-1f3ff","uc_output":"1f3c3-1f3ff","uc_match":"1f3c3-1f3ff","uc_greedy":"1f3c3-1f3ff","shortnames":[":runner_tone5:"],"category":"people"},":person_shrugging_tone1:":{"uc_base":"1f937-1f3fb","uc_output":"1f937-1f3fb","uc_match":"1f937-1f3fb","uc_greedy":"1f937-1f3fb","shortnames":[":shrug_tone1:"],"category":"people"},":person_shrugging_tone2:":{"uc_base":"1f937-1f3fc","uc_output":"1f937-1f3fc","uc_match":"1f937-1f3fc","uc_greedy":"1f937-1f3fc","shortnames":[":shrug_tone2:"],"category":"people"},":person_shrugging_tone3:":{"uc_base":"1f937-1f3fd","uc_output":"1f937-1f3fd","uc_match":"1f937-1f3fd","uc_greedy":"1f937-1f3fd","shortnames":[":shrug_tone3:"],"category":"people"},":person_shrugging_tone4:":{"uc_base":"1f937-1f3fe","uc_output":"1f937-1f3fe","uc_match":"1f937-1f3fe","uc_greedy":"1f937-1f3fe","shortnames":[":shrug_tone4:"],"category":"people"},":person_shrugging_tone5:":{"uc_base":"1f937-1f3ff","uc_output":"1f937-1f3ff","uc_match":"1f937-1f3ff","uc_greedy":"1f937-1f3ff","shortnames":[":shrug_tone5:"],"category":"people"},":person_surfing_tone1:":{"uc_base":"1f3c4-1f3fb","uc_output":"1f3c4-1f3fb","uc_match":"1f3c4-1f3fb","uc_greedy":"1f3c4-1f3fb","shortnames":[":surfer_tone1:"],"category":"activity"},":person_surfing_tone2:":{"uc_base":"1f3c4-1f3fc","uc_output":"1f3c4-1f3fc","uc_match":"1f3c4-1f3fc","uc_greedy":"1f3c4-1f3fc","shortnames":[":surfer_tone2:"],"category":"activity"},":person_surfing_tone3:":{"uc_base":"1f3c4-1f3fd","uc_output":"1f3c4-1f3fd","uc_match":"1f3c4-1f3fd","uc_greedy":"1f3c4-1f3fd","shortnames":[":surfer_tone3:"],"category":"activity"},":person_surfing_tone4:":{"uc_base":"1f3c4-1f3fe","uc_output":"1f3c4-1f3fe","uc_match":"1f3c4-1f3fe","uc_greedy":"1f3c4-1f3fe","shortnames":[":surfer_tone4:"],"category":"activity"},":person_surfing_tone5:":{"uc_base":"1f3c4-1f3ff","uc_output":"1f3c4-1f3ff","uc_match":"1f3c4-1f3ff","uc_greedy":"1f3c4-1f3ff","shortnames":[":surfer_tone5:"],"category":"activity"},":person_swimming_tone1:":{"uc_base":"1f3ca-1f3fb","uc_output":"1f3ca-1f3fb","uc_match":"1f3ca-1f3fb","uc_greedy":"1f3ca-1f3fb","shortnames":[":swimmer_tone1:"],"category":"activity"},":person_swimming_tone2:":{"uc_base":"1f3ca-1f3fc","uc_output":"1f3ca-1f3fc","uc_match":"1f3ca-1f3fc","uc_greedy":"1f3ca-1f3fc","shortnames":[":swimmer_tone2:"],"category":"activity"},":person_swimming_tone3:":{"uc_base":"1f3ca-1f3fd","uc_output":"1f3ca-1f3fd","uc_match":"1f3ca-1f3fd","uc_greedy":"1f3ca-1f3fd","shortnames":[":swimmer_tone3:"],"category":"activity"},":person_swimming_tone4:":{"uc_base":"1f3ca-1f3fe","uc_output":"1f3ca-1f3fe","uc_match":"1f3ca-1f3fe","uc_greedy":"1f3ca-1f3fe","shortnames":[":swimmer_tone4:"],"category":"activity"},":person_swimming_tone5:":{"uc_base":"1f3ca-1f3ff","uc_output":"1f3ca-1f3ff","uc_match":"1f3ca-1f3ff","uc_greedy":"1f3ca-1f3ff","shortnames":[":swimmer_tone5:"],"category":"activity"},":person_tipping_hand_tone1:":{"uc_base":"1f481-1f3fb","uc_output":"1f481-1f3fb","uc_match":"1f481-1f3fb","uc_greedy":"1f481-1f3fb","shortnames":[":information_desk_person_tone1:"],"category":"people"},":person_tipping_hand_tone2:":{"uc_base":"1f481-1f3fc","uc_output":"1f481-1f3fc","uc_match":"1f481-1f3fc","uc_greedy":"1f481-1f3fc","shortnames":[":information_desk_person_tone2:"],"category":"people"},":person_tipping_hand_tone3:":{"uc_base":"1f481-1f3fd","uc_output":"1f481-1f3fd","uc_match":"1f481-1f3fd","uc_greedy":"1f481-1f3fd","shortnames":[":information_desk_person_tone3:"],"category":"people"},":person_tipping_hand_tone4:":{"uc_base":"1f481-1f3fe","uc_output":"1f481-1f3fe","uc_match":"1f481-1f3fe","uc_greedy":"1f481-1f3fe","shortnames":[":information_desk_person_tone4:"],"category":"people"},":person_tipping_hand_tone5:":{"uc_base":"1f481-1f3ff","uc_output":"1f481-1f3ff","uc_match":"1f481-1f3ff","uc_greedy":"1f481-1f3ff","shortnames":[":information_desk_person_tone5:"],"category":"people"},":person_walking_tone1:":{"uc_base":"1f6b6-1f3fb","uc_output":"1f6b6-1f3fb","uc_match":"1f6b6-1f3fb","uc_greedy":"1f6b6-1f3fb","shortnames":[":walking_tone1:"],"category":"people"},":person_walking_tone2:":{"uc_base":"1f6b6-1f3fc","uc_output":"1f6b6-1f3fc","uc_match":"1f6b6-1f3fc","uc_greedy":"1f6b6-1f3fc","shortnames":[":walking_tone2:"],"category":"people"},":person_walking_tone3:":{"uc_base":"1f6b6-1f3fd","uc_output":"1f6b6-1f3fd","uc_match":"1f6b6-1f3fd","uc_greedy":"1f6b6-1f3fd","shortnames":[":walking_tone3:"],"category":"people"},":person_walking_tone4:":{"uc_base":"1f6b6-1f3fe","uc_output":"1f6b6-1f3fe","uc_match":"1f6b6-1f3fe","uc_greedy":"1f6b6-1f3fe","shortnames":[":walking_tone4:"],"category":"people"},":person_walking_tone5:":{"uc_base":"1f6b6-1f3ff","uc_output":"1f6b6-1f3ff","uc_match":"1f6b6-1f3ff","uc_greedy":"1f6b6-1f3ff","shortnames":[":walking_tone5:"],"category":"people"},":person_wearing_turban_tone1:":{"uc_base":"1f473-1f3fb","uc_output":"1f473-1f3fb","uc_match":"1f473-1f3fb","uc_greedy":"1f473-1f3fb","shortnames":[":man_with_turban_tone1:"],"category":"people"},":person_wearing_turban_tone2:":{"uc_base":"1f473-1f3fc","uc_output":"1f473-1f3fc","uc_match":"1f473-1f3fc","uc_greedy":"1f473-1f3fc","shortnames":[":man_with_turban_tone2:"],"category":"people"},":person_wearing_turban_tone3:":{"uc_base":"1f473-1f3fd","uc_output":"1f473-1f3fd","uc_match":"1f473-1f3fd","uc_greedy":"1f473-1f3fd","shortnames":[":man_with_turban_tone3:"],"category":"people"},":person_wearing_turban_tone4:":{"uc_base":"1f473-1f3fe","uc_output":"1f473-1f3fe","uc_match":"1f473-1f3fe","uc_greedy":"1f473-1f3fe","shortnames":[":man_with_turban_tone4:"],"category":"people"},":person_wearing_turban_tone5:":{"uc_base":"1f473-1f3ff","uc_output":"1f473-1f3ff","uc_match":"1f473-1f3ff","uc_greedy":"1f473-1f3ff","shortnames":[":man_with_turban_tone5:"],"category":"people"},":point_down_tone1:":{"uc_base":"1f447-1f3fb","uc_output":"1f447-1f3fb","uc_match":"1f447-1f3fb","uc_greedy":"1f447-1f3fb","shortnames":[],"category":"people"},":point_down_tone2:":{"uc_base":"1f447-1f3fc","uc_output":"1f447-1f3fc","uc_match":"1f447-1f3fc","uc_greedy":"1f447-1f3fc","shortnames":[],"category":"people"},":point_down_tone3:":{"uc_base":"1f447-1f3fd","uc_output":"1f447-1f3fd","uc_match":"1f447-1f3fd","uc_greedy":"1f447-1f3fd","shortnames":[],"category":"people"},":point_down_tone4:":{"uc_base":"1f447-1f3fe","uc_output":"1f447-1f3fe","uc_match":"1f447-1f3fe","uc_greedy":"1f447-1f3fe","shortnames":[],"category":"people"},":point_down_tone5:":{"uc_base":"1f447-1f3ff","uc_output":"1f447-1f3ff","uc_match":"1f447-1f3ff","uc_greedy":"1f447-1f3ff","shortnames":[],"category":"people"},":point_left_tone1:":{"uc_base":"1f448-1f3fb","uc_output":"1f448-1f3fb","uc_match":"1f448-1f3fb","uc_greedy":"1f448-1f3fb","shortnames":[],"category":"people"},":point_left_tone2:":{"uc_base":"1f448-1f3fc","uc_output":"1f448-1f3fc","uc_match":"1f448-1f3fc","uc_greedy":"1f448-1f3fc","shortnames":[],"category":"people"},":point_left_tone3:":{"uc_base":"1f448-1f3fd","uc_output":"1f448-1f3fd","uc_match":"1f448-1f3fd","uc_greedy":"1f448-1f3fd","shortnames":[],"category":"people"},":point_left_tone4:":{"uc_base":"1f448-1f3fe","uc_output":"1f448-1f3fe","uc_match":"1f448-1f3fe","uc_greedy":"1f448-1f3fe","shortnames":[],"category":"people"},":point_left_tone5:":{"uc_base":"1f448-1f3ff","uc_output":"1f448-1f3ff","uc_match":"1f448-1f3ff","uc_greedy":"1f448-1f3ff","shortnames":[],"category":"people"},":point_right_tone1:":{"uc_base":"1f449-1f3fb","uc_output":"1f449-1f3fb","uc_match":"1f449-1f3fb","uc_greedy":"1f449-1f3fb","shortnames":[],"category":"people"},":point_right_tone2:":{"uc_base":"1f449-1f3fc","uc_output":"1f449-1f3fc","uc_match":"1f449-1f3fc","uc_greedy":"1f449-1f3fc","shortnames":[],"category":"people"},":point_right_tone3:":{"uc_base":"1f449-1f3fd","uc_output":"1f449-1f3fd","uc_match":"1f449-1f3fd","uc_greedy":"1f449-1f3fd","shortnames":[],"category":"people"},":point_right_tone4:":{"uc_base":"1f449-1f3fe","uc_output":"1f449-1f3fe","uc_match":"1f449-1f3fe","uc_greedy":"1f449-1f3fe","shortnames":[],"category":"people"},":point_right_tone5:":{"uc_base":"1f449-1f3ff","uc_output":"1f449-1f3ff","uc_match":"1f449-1f3ff","uc_greedy":"1f449-1f3ff","shortnames":[],"category":"people"},":point_up_2_tone1:":{"uc_base":"1f446-1f3fb","uc_output":"1f446-1f3fb","uc_match":"1f446-1f3fb","uc_greedy":"1f446-1f3fb","shortnames":[],"category":"people"},":point_up_2_tone2:":{"uc_base":"1f446-1f3fc","uc_output":"1f446-1f3fc","uc_match":"1f446-1f3fc","uc_greedy":"1f446-1f3fc","shortnames":[],"category":"people"},":point_up_2_tone3:":{"uc_base":"1f446-1f3fd","uc_output":"1f446-1f3fd","uc_match":"1f446-1f3fd","uc_greedy":"1f446-1f3fd","shortnames":[],"category":"people"},":point_up_2_tone4:":{"uc_base":"1f446-1f3fe","uc_output":"1f446-1f3fe","uc_match":"1f446-1f3fe","uc_greedy":"1f446-1f3fe","shortnames":[],"category":"people"},":point_up_2_tone5:":{"uc_base":"1f446-1f3ff","uc_output":"1f446-1f3ff","uc_match":"1f446-1f3ff","uc_greedy":"1f446-1f3ff","shortnames":[],"category":"people"},":police_officer_tone1:":{"uc_base":"1f46e-1f3fb","uc_output":"1f46e-1f3fb","uc_match":"1f46e-1f3fb","uc_greedy":"1f46e-1f3fb","shortnames":[":cop_tone1:"],"category":"people"},":police_officer_tone2:":{"uc_base":"1f46e-1f3fc","uc_output":"1f46e-1f3fc","uc_match":"1f46e-1f3fc","uc_greedy":"1f46e-1f3fc","shortnames":[":cop_tone2:"],"category":"people"},":police_officer_tone3:":{"uc_base":"1f46e-1f3fd","uc_output":"1f46e-1f3fd","uc_match":"1f46e-1f3fd","uc_greedy":"1f46e-1f3fd","shortnames":[":cop_tone3:"],"category":"people"},":police_officer_tone4:":{"uc_base":"1f46e-1f3fe","uc_output":"1f46e-1f3fe","uc_match":"1f46e-1f3fe","uc_greedy":"1f46e-1f3fe","shortnames":[":cop_tone4:"],"category":"people"},":police_officer_tone5:":{"uc_base":"1f46e-1f3ff","uc_output":"1f46e-1f3ff","uc_match":"1f46e-1f3ff","uc_greedy":"1f46e-1f3ff","shortnames":[":cop_tone5:"],"category":"people"},":pray_tone1:":{"uc_base":"1f64f-1f3fb","uc_output":"1f64f-1f3fb","uc_match":"1f64f-1f3fb","uc_greedy":"1f64f-1f3fb","shortnames":[],"category":"people"},":pray_tone2:":{"uc_base":"1f64f-1f3fc","uc_output":"1f64f-1f3fc","uc_match":"1f64f-1f3fc","uc_greedy":"1f64f-1f3fc","shortnames":[],"category":"people"},":pray_tone3:":{"uc_base":"1f64f-1f3fd","uc_output":"1f64f-1f3fd","uc_match":"1f64f-1f3fd","uc_greedy":"1f64f-1f3fd","shortnames":[],"category":"people"},":pray_tone4:":{"uc_base":"1f64f-1f3fe","uc_output":"1f64f-1f3fe","uc_match":"1f64f-1f3fe","uc_greedy":"1f64f-1f3fe","shortnames":[],"category":"people"},":pray_tone5:":{"uc_base":"1f64f-1f3ff","uc_output":"1f64f-1f3ff","uc_match":"1f64f-1f3ff","uc_greedy":"1f64f-1f3ff","shortnames":[],"category":"people"},":pregnant_woman_tone1:":{"uc_base":"1f930-1f3fb","uc_output":"1f930-1f3fb","uc_match":"1f930-1f3fb","uc_greedy":"1f930-1f3fb","shortnames":[":expecting_woman_tone1:"],"category":"people"},":pregnant_woman_tone2:":{"uc_base":"1f930-1f3fc","uc_output":"1f930-1f3fc","uc_match":"1f930-1f3fc","uc_greedy":"1f930-1f3fc","shortnames":[":expecting_woman_tone2:"],"category":"people"},":pregnant_woman_tone3:":{"uc_base":"1f930-1f3fd","uc_output":"1f930-1f3fd","uc_match":"1f930-1f3fd","uc_greedy":"1f930-1f3fd","shortnames":[":expecting_woman_tone3:"],"category":"people"},":pregnant_woman_tone4:":{"uc_base":"1f930-1f3fe","uc_output":"1f930-1f3fe","uc_match":"1f930-1f3fe","uc_greedy":"1f930-1f3fe","shortnames":[":expecting_woman_tone4:"],"category":"people"},":pregnant_woman_tone5:":{"uc_base":"1f930-1f3ff","uc_output":"1f930-1f3ff","uc_match":"1f930-1f3ff","uc_greedy":"1f930-1f3ff","shortnames":[":expecting_woman_tone5:"],"category":"people"},":prince_tone1:":{"uc_base":"1f934-1f3fb","uc_output":"1f934-1f3fb","uc_match":"1f934-1f3fb","uc_greedy":"1f934-1f3fb","shortnames":[],"category":"people"},":prince_tone2:":{"uc_base":"1f934-1f3fc","uc_output":"1f934-1f3fc","uc_match":"1f934-1f3fc","uc_greedy":"1f934-1f3fc","shortnames":[],"category":"people"},":prince_tone3:":{"uc_base":"1f934-1f3fd","uc_output":"1f934-1f3fd","uc_match":"1f934-1f3fd","uc_greedy":"1f934-1f3fd","shortnames":[],"category":"people"},":prince_tone4:":{"uc_base":"1f934-1f3fe","uc_output":"1f934-1f3fe","uc_match":"1f934-1f3fe","uc_greedy":"1f934-1f3fe","shortnames":[],"category":"people"},":prince_tone5:":{"uc_base":"1f934-1f3ff","uc_output":"1f934-1f3ff","uc_match":"1f934-1f3ff","uc_greedy":"1f934-1f3ff","shortnames":[],"category":"people"},":princess_tone1:":{"uc_base":"1f478-1f3fb","uc_output":"1f478-1f3fb","uc_match":"1f478-1f3fb","uc_greedy":"1f478-1f3fb","shortnames":[],"category":"people"},":princess_tone2:":{"uc_base":"1f478-1f3fc","uc_output":"1f478-1f3fc","uc_match":"1f478-1f3fc","uc_greedy":"1f478-1f3fc","shortnames":[],"category":"people"},":princess_tone3:":{"uc_base":"1f478-1f3fd","uc_output":"1f478-1f3fd","uc_match":"1f478-1f3fd","uc_greedy":"1f478-1f3fd","shortnames":[],"category":"people"},":princess_tone4:":{"uc_base":"1f478-1f3fe","uc_output":"1f478-1f3fe","uc_match":"1f478-1f3fe","uc_greedy":"1f478-1f3fe","shortnames":[],"category":"people"},":princess_tone5:":{"uc_base":"1f478-1f3ff","uc_output":"1f478-1f3ff","uc_match":"1f478-1f3ff","uc_greedy":"1f478-1f3ff","shortnames":[],"category":"people"},":punch_tone1:":{"uc_base":"1f44a-1f3fb","uc_output":"1f44a-1f3fb","uc_match":"1f44a-1f3fb","uc_greedy":"1f44a-1f3fb","shortnames":[],"category":"people"},":punch_tone2:":{"uc_base":"1f44a-1f3fc","uc_output":"1f44a-1f3fc","uc_match":"1f44a-1f3fc","uc_greedy":"1f44a-1f3fc","shortnames":[],"category":"people"},":punch_tone3:":{"uc_base":"1f44a-1f3fd","uc_output":"1f44a-1f3fd","uc_match":"1f44a-1f3fd","uc_greedy":"1f44a-1f3fd","shortnames":[],"category":"people"},":punch_tone4:":{"uc_base":"1f44a-1f3fe","uc_output":"1f44a-1f3fe","uc_match":"1f44a-1f3fe","uc_greedy":"1f44a-1f3fe","shortnames":[],"category":"people"},":punch_tone5:":{"uc_base":"1f44a-1f3ff","uc_output":"1f44a-1f3ff","uc_match":"1f44a-1f3ff","uc_greedy":"1f44a-1f3ff","shortnames":[],"category":"people"},":raised_back_of_hand_tone1:":{"uc_base":"1f91a-1f3fb","uc_output":"1f91a-1f3fb","uc_match":"1f91a-1f3fb","uc_greedy":"1f91a-1f3fb","shortnames":[":back_of_hand_tone1:"],"category":"people"},":raised_back_of_hand_tone2:":{"uc_base":"1f91a-1f3fc","uc_output":"1f91a-1f3fc","uc_match":"1f91a-1f3fc","uc_greedy":"1f91a-1f3fc","shortnames":[":back_of_hand_tone2:"],"category":"people"},":raised_back_of_hand_tone3:":{"uc_base":"1f91a-1f3fd","uc_output":"1f91a-1f3fd","uc_match":"1f91a-1f3fd","uc_greedy":"1f91a-1f3fd","shortnames":[":back_of_hand_tone3:"],"category":"people"},":raised_back_of_hand_tone4:":{"uc_base":"1f91a-1f3fe","uc_output":"1f91a-1f3fe","uc_match":"1f91a-1f3fe","uc_greedy":"1f91a-1f3fe","shortnames":[":back_of_hand_tone4:"],"category":"people"},":raised_back_of_hand_tone5:":{"uc_base":"1f91a-1f3ff","uc_output":"1f91a-1f3ff","uc_match":"1f91a-1f3ff","uc_greedy":"1f91a-1f3ff","shortnames":[":back_of_hand_tone5:"],"category":"people"},":raised_hands_tone1:":{"uc_base":"1f64c-1f3fb","uc_output":"1f64c-1f3fb","uc_match":"1f64c-1f3fb","uc_greedy":"1f64c-1f3fb","shortnames":[],"category":"people"},":raised_hands_tone2:":{"uc_base":"1f64c-1f3fc","uc_output":"1f64c-1f3fc","uc_match":"1f64c-1f3fc","uc_greedy":"1f64c-1f3fc","shortnames":[],"category":"people"},":raised_hands_tone3:":{"uc_base":"1f64c-1f3fd","uc_output":"1f64c-1f3fd","uc_match":"1f64c-1f3fd","uc_greedy":"1f64c-1f3fd","shortnames":[],"category":"people"},":raised_hands_tone4:":{"uc_base":"1f64c-1f3fe","uc_output":"1f64c-1f3fe","uc_match":"1f64c-1f3fe","uc_greedy":"1f64c-1f3fe","shortnames":[],"category":"people"},":raised_hands_tone5:":{"uc_base":"1f64c-1f3ff","uc_output":"1f64c-1f3ff","uc_match":"1f64c-1f3ff","uc_greedy":"1f64c-1f3ff","shortnames":[],"category":"people"},":right_facing_fist_tone1:":{"uc_base":"1f91c-1f3fb","uc_output":"1f91c-1f3fb","uc_match":"1f91c-1f3fb","uc_greedy":"1f91c-1f3fb","shortnames":[":right_fist_tone1:"],"category":"people"},":right_facing_fist_tone2:":{"uc_base":"1f91c-1f3fc","uc_output":"1f91c-1f3fc","uc_match":"1f91c-1f3fc","uc_greedy":"1f91c-1f3fc","shortnames":[":right_fist_tone2:"],"category":"people"},":right_facing_fist_tone3:":{"uc_base":"1f91c-1f3fd","uc_output":"1f91c-1f3fd","uc_match":"1f91c-1f3fd","uc_greedy":"1f91c-1f3fd","shortnames":[":right_fist_tone3:"],"category":"people"},":right_facing_fist_tone4:":{"uc_base":"1f91c-1f3fe","uc_output":"1f91c-1f3fe","uc_match":"1f91c-1f3fe","uc_greedy":"1f91c-1f3fe","shortnames":[":right_fist_tone4:"],"category":"people"},":right_facing_fist_tone5:":{"uc_base":"1f91c-1f3ff","uc_output":"1f91c-1f3ff","uc_match":"1f91c-1f3ff","uc_greedy":"1f91c-1f3ff","shortnames":[":right_fist_tone5:"],"category":"people"},":santa_tone1:":{"uc_base":"1f385-1f3fb","uc_output":"1f385-1f3fb","uc_match":"1f385-1f3fb","uc_greedy":"1f385-1f3fb","shortnames":[],"category":"people"},":santa_tone2:":{"uc_base":"1f385-1f3fc","uc_output":"1f385-1f3fc","uc_match":"1f385-1f3fc","uc_greedy":"1f385-1f3fc","shortnames":[],"category":"people"},":santa_tone3:":{"uc_base":"1f385-1f3fd","uc_output":"1f385-1f3fd","uc_match":"1f385-1f3fd","uc_greedy":"1f385-1f3fd","shortnames":[],"category":"people"},":santa_tone4:":{"uc_base":"1f385-1f3fe","uc_output":"1f385-1f3fe","uc_match":"1f385-1f3fe","uc_greedy":"1f385-1f3fe","shortnames":[],"category":"people"},":santa_tone5:":{"uc_base":"1f385-1f3ff","uc_output":"1f385-1f3ff","uc_match":"1f385-1f3ff","uc_greedy":"1f385-1f3ff","shortnames":[],"category":"people"},":selfie_tone1:":{"uc_base":"1f933-1f3fb","uc_output":"1f933-1f3fb","uc_match":"1f933-1f3fb","uc_greedy":"1f933-1f3fb","shortnames":[],"category":"people"},":selfie_tone2:":{"uc_base":"1f933-1f3fc","uc_output":"1f933-1f3fc","uc_match":"1f933-1f3fc","uc_greedy":"1f933-1f3fc","shortnames":[],"category":"people"},":selfie_tone3:":{"uc_base":"1f933-1f3fd","uc_output":"1f933-1f3fd","uc_match":"1f933-1f3fd","uc_greedy":"1f933-1f3fd","shortnames":[],"category":"people"},":selfie_tone4:":{"uc_base":"1f933-1f3fe","uc_output":"1f933-1f3fe","uc_match":"1f933-1f3fe","uc_greedy":"1f933-1f3fe","shortnames":[],"category":"people"},":selfie_tone5:":{"uc_base":"1f933-1f3ff","uc_output":"1f933-1f3ff","uc_match":"1f933-1f3ff","uc_greedy":"1f933-1f3ff","shortnames":[],"category":"people"},":snowboarder_tone1:":{"uc_base":"1f3c2-1f3fb","uc_output":"1f3c2-1f3fb","uc_match":"1f3c2-1f3fb","uc_greedy":"1f3c2-1f3fb","shortnames":[":snowboarder_light_skin_tone:"],"category":"activity"},":snowboarder_tone2:":{"uc_base":"1f3c2-1f3fc","uc_output":"1f3c2-1f3fc","uc_match":"1f3c2-1f3fc","uc_greedy":"1f3c2-1f3fc","shortnames":[":snowboarder_medium_light_skin_tone:"],"category":"activity"},":snowboarder_tone3:":{"uc_base":"1f3c2-1f3fd","uc_output":"1f3c2-1f3fd","uc_match":"1f3c2-1f3fd","uc_greedy":"1f3c2-1f3fd","shortnames":[":snowboarder_medium_skin_tone:"],"category":"activity"},":snowboarder_tone4:":{"uc_base":"1f3c2-1f3fe","uc_output":"1f3c2-1f3fe","uc_match":"1f3c2-1f3fe","uc_greedy":"1f3c2-1f3fe","shortnames":[":snowboarder_medium_dark_skin_tone:"],"category":"activity"},":snowboarder_tone5:":{"uc_base":"1f3c2-1f3ff","uc_output":"1f3c2-1f3ff","uc_match":"1f3c2-1f3ff","uc_greedy":"1f3c2-1f3ff","shortnames":[":snowboarder_dark_skin_tone:"],"category":"activity"},":superhero_tone1:":{"uc_base":"1f9b8-1f3fb","uc_output":"1f9b8-1f3fb","uc_match":"1f9b8-1f3fb","uc_greedy":"1f9b8-1f3fb","shortnames":[":superhero_light_skin_tone:"],"category":"people"},":superhero_tone2:":{"uc_base":"1f9b8-1f3fc","uc_output":"1f9b8-1f3fc","uc_match":"1f9b8-1f3fc","uc_greedy":"1f9b8-1f3fc","shortnames":[":superhero_medium_light_skin_tone:"],"category":"people"},":superhero_tone3:":{"uc_base":"1f9b8-1f3fd","uc_output":"1f9b8-1f3fd","uc_match":"1f9b8-1f3fd","uc_greedy":"1f9b8-1f3fd","shortnames":[":superhero_medium_skin_tone:"],"category":"people"},":superhero_tone4:":{"uc_base":"1f9b8-1f3fe","uc_output":"1f9b8-1f3fe","uc_match":"1f9b8-1f3fe","uc_greedy":"1f9b8-1f3fe","shortnames":[":superhero_medium_dark_skin_tone:"],"category":"people"},":superhero_tone5:":{"uc_base":"1f9b8-1f3ff","uc_output":"1f9b8-1f3ff","uc_match":"1f9b8-1f3ff","uc_greedy":"1f9b8-1f3ff","shortnames":[":superhero_dark_skin_tone:"],"category":"people"},":supervillain_tone1:":{"uc_base":"1f9b9-1f3fb","uc_output":"1f9b9-1f3fb","uc_match":"1f9b9-1f3fb","uc_greedy":"1f9b9-1f3fb","shortnames":[":supervillain_light_skin_tone:"],"category":"people"},":supervillain_tone2:":{"uc_base":"1f9b9-1f3fc","uc_output":"1f9b9-1f3fc","uc_match":"1f9b9-1f3fc","uc_greedy":"1f9b9-1f3fc","shortnames":[":supervillain_medium_light_skin_tone:"],"category":"people"},":supervillain_tone3:":{"uc_base":"1f9b9-1f3fd","uc_output":"1f9b9-1f3fd","uc_match":"1f9b9-1f3fd","uc_greedy":"1f9b9-1f3fd","shortnames":[":supervillain_medium_skin_tone:"],"category":"people"},":supervillain_tone4:":{"uc_base":"1f9b9-1f3fe","uc_output":"1f9b9-1f3fe","uc_match":"1f9b9-1f3fe","uc_greedy":"1f9b9-1f3fe","shortnames":[":supervillain_medium_dark_skin_tone:"],"category":"people"},":supervillain_tone5:":{"uc_base":"1f9b9-1f3ff","uc_output":"1f9b9-1f3ff","uc_match":"1f9b9-1f3ff","uc_greedy":"1f9b9-1f3ff","shortnames":[":supervillain_dark_skin_tone:"],"category":"people"},":thumbsdown_tone1:":{"uc_base":"1f44e-1f3fb","uc_output":"1f44e-1f3fb","uc_match":"1f44e-1f3fb","uc_greedy":"1f44e-1f3fb","shortnames":[":-1_tone1:",":thumbdown_tone1:"],"category":"people"},":thumbsdown_tone2:":{"uc_base":"1f44e-1f3fc","uc_output":"1f44e-1f3fc","uc_match":"1f44e-1f3fc","uc_greedy":"1f44e-1f3fc","shortnames":[":-1_tone2:",":thumbdown_tone2:"],"category":"people"},":thumbsdown_tone3:":{"uc_base":"1f44e-1f3fd","uc_output":"1f44e-1f3fd","uc_match":"1f44e-1f3fd","uc_greedy":"1f44e-1f3fd","shortnames":[":-1_tone3:",":thumbdown_tone3:"],"category":"people"},":thumbsdown_tone4:":{"uc_base":"1f44e-1f3fe","uc_output":"1f44e-1f3fe","uc_match":"1f44e-1f3fe","uc_greedy":"1f44e-1f3fe","shortnames":[":-1_tone4:",":thumbdown_tone4:"],"category":"people"},":thumbsdown_tone5:":{"uc_base":"1f44e-1f3ff","uc_output":"1f44e-1f3ff","uc_match":"1f44e-1f3ff","uc_greedy":"1f44e-1f3ff","shortnames":[":-1_tone5:",":thumbdown_tone5:"],"category":"people"},":thumbsup_tone1:":{"uc_base":"1f44d-1f3fb","uc_output":"1f44d-1f3fb","uc_match":"1f44d-1f3fb","uc_greedy":"1f44d-1f3fb","shortnames":[":+1_tone1:",":thumbup_tone1:"],"category":"people"},":thumbsup_tone2:":{"uc_base":"1f44d-1f3fc","uc_output":"1f44d-1f3fc","uc_match":"1f44d-1f3fc","uc_greedy":"1f44d-1f3fc","shortnames":[":+1_tone2:",":thumbup_tone2:"],"category":"people"},":thumbsup_tone3:":{"uc_base":"1f44d-1f3fd","uc_output":"1f44d-1f3fd","uc_match":"1f44d-1f3fd","uc_greedy":"1f44d-1f3fd","shortnames":[":+1_tone3:",":thumbup_tone3:"],"category":"people"},":thumbsup_tone4:":{"uc_base":"1f44d-1f3fe","uc_output":"1f44d-1f3fe","uc_match":"1f44d-1f3fe","uc_greedy":"1f44d-1f3fe","shortnames":[":+1_tone4:",":thumbup_tone4:"],"category":"people"},":thumbsup_tone5:":{"uc_base":"1f44d-1f3ff","uc_output":"1f44d-1f3ff","uc_match":"1f44d-1f3ff","uc_greedy":"1f44d-1f3ff","shortnames":[":+1_tone5:",":thumbup_tone5:"],"category":"people"},":united_nations:":{"uc_base":"1f1fa-1f1f3","uc_output":"1f1fa-1f1f3","uc_match":"1f1fa-1f1f3","uc_greedy":"1f1fa-1f1f3","shortnames":[],"category":"flags"},":vampire_tone1:":{"uc_base":"1f9db-1f3fb","uc_output":"1f9db-1f3fb","uc_match":"1f9db-1f3fb","uc_greedy":"1f9db-1f3fb","shortnames":[":vampire_light_skin_tone:"],"category":"people"},":vampire_tone2:":{"uc_base":"1f9db-1f3fc","uc_output":"1f9db-1f3fc","uc_match":"1f9db-1f3fc","uc_greedy":"1f9db-1f3fc","shortnames":[":vampire_medium_light_skin_tone:"],"category":"people"},":vampire_tone3:":{"uc_base":"1f9db-1f3fd","uc_output":"1f9db-1f3fd","uc_match":"1f9db-1f3fd","uc_greedy":"1f9db-1f3fd","shortnames":[":vampire_medium_skin_tone:"],"category":"people"},":vampire_tone4:":{"uc_base":"1f9db-1f3fe","uc_output":"1f9db-1f3fe","uc_match":"1f9db-1f3fe","uc_greedy":"1f9db-1f3fe","shortnames":[":vampire_medium_dark_skin_tone:"],"category":"people"},":vampire_tone5:":{"uc_base":"1f9db-1f3ff","uc_output":"1f9db-1f3ff","uc_match":"1f9db-1f3ff","uc_greedy":"1f9db-1f3ff","shortnames":[":vampire_dark_skin_tone:"],"category":"people"},":vulcan_tone1:":{"uc_base":"1f596-1f3fb","uc_output":"1f596-1f3fb","uc_match":"1f596-1f3fb","uc_greedy":"1f596-1f3fb","shortnames":[":raised_hand_with_part_between_middle_and_ring_fingers_tone1:"],"category":"people"},":vulcan_tone2:":{"uc_base":"1f596-1f3fc","uc_output":"1f596-1f3fc","uc_match":"1f596-1f3fc","uc_greedy":"1f596-1f3fc","shortnames":[":raised_hand_with_part_between_middle_and_ring_fingers_tone2:"],"category":"people"},":vulcan_tone3:":{"uc_base":"1f596-1f3fd","uc_output":"1f596-1f3fd","uc_match":"1f596-1f3fd","uc_greedy":"1f596-1f3fd","shortnames":[":raised_hand_with_part_between_middle_and_ring_fingers_tone3:"],"category":"people"},":vulcan_tone4:":{"uc_base":"1f596-1f3fe","uc_output":"1f596-1f3fe","uc_match":"1f596-1f3fe","uc_greedy":"1f596-1f3fe","shortnames":[":raised_hand_with_part_between_middle_and_ring_fingers_tone4:"],"category":"people"},":vulcan_tone5:":{"uc_base":"1f596-1f3ff","uc_output":"1f596-1f3ff","uc_match":"1f596-1f3ff","uc_greedy":"1f596-1f3ff","shortnames":[":raised_hand_with_part_between_middle_and_ring_fingers_tone5:"],"category":"people"},":wave_tone1:":{"uc_base":"1f44b-1f3fb","uc_output":"1f44b-1f3fb","uc_match":"1f44b-1f3fb","uc_greedy":"1f44b-1f3fb","shortnames":[],"category":"people"},":wave_tone2:":{"uc_base":"1f44b-1f3fc","uc_output":"1f44b-1f3fc","uc_match":"1f44b-1f3fc","uc_greedy":"1f44b-1f3fc","shortnames":[],"category":"people"},":wave_tone3:":{"uc_base":"1f44b-1f3fd","uc_output":"1f44b-1f3fd","uc_match":"1f44b-1f3fd","uc_greedy":"1f44b-1f3fd","shortnames":[],"category":"people"},":wave_tone4:":{"uc_base":"1f44b-1f3fe","uc_output":"1f44b-1f3fe","uc_match":"1f44b-1f3fe","uc_greedy":"1f44b-1f3fe","shortnames":[],"category":"people"},":wave_tone5:":{"uc_base":"1f44b-1f3ff","uc_output":"1f44b-1f3ff","uc_match":"1f44b-1f3ff","uc_greedy":"1f44b-1f3ff","shortnames":[],"category":"people"},":woman_tone1:":{"uc_base":"1f469-1f3fb","uc_output":"1f469-1f3fb","uc_match":"1f469-1f3fb","uc_greedy":"1f469-1f3fb","shortnames":[],"category":"people"},":woman_tone2:":{"uc_base":"1f469-1f3fc","uc_output":"1f469-1f3fc","uc_match":"1f469-1f3fc","uc_greedy":"1f469-1f3fc","shortnames":[],"category":"people"},":woman_tone3:":{"uc_base":"1f469-1f3fd","uc_output":"1f469-1f3fd","uc_match":"1f469-1f3fd","uc_greedy":"1f469-1f3fd","shortnames":[],"category":"people"},":woman_tone4:":{"uc_base":"1f469-1f3fe","uc_output":"1f469-1f3fe","uc_match":"1f469-1f3fe","uc_greedy":"1f469-1f3fe","shortnames":[],"category":"people"},":woman_tone5:":{"uc_base":"1f469-1f3ff","uc_output":"1f469-1f3ff","uc_match":"1f469-1f3ff","uc_greedy":"1f469-1f3ff","shortnames":[],"category":"people"},":woman_with_headscarf_tone1:":{"uc_base":"1f9d5-1f3fb","uc_output":"1f9d5-1f3fb","uc_match":"1f9d5-1f3fb","uc_greedy":"1f9d5-1f3fb","shortnames":[":woman_with_headscarf_light_skin_tone:"],"category":"people"},":woman_with_headscarf_tone2:":{"uc_base":"1f9d5-1f3fc","uc_output":"1f9d5-1f3fc","uc_match":"1f9d5-1f3fc","uc_greedy":"1f9d5-1f3fc","shortnames":[":woman_with_headscarf_medium_light_skin_tone:"],"category":"people"},":woman_with_headscarf_tone3:":{"uc_base":"1f9d5-1f3fd","uc_output":"1f9d5-1f3fd","uc_match":"1f9d5-1f3fd","uc_greedy":"1f9d5-1f3fd","shortnames":[":woman_with_headscarf_medium_skin_tone:"],"category":"people"},":woman_with_headscarf_tone4:":{"uc_base":"1f9d5-1f3fe","uc_output":"1f9d5-1f3fe","uc_match":"1f9d5-1f3fe","uc_greedy":"1f9d5-1f3fe","shortnames":[":woman_with_headscarf_medium_dark_skin_tone:"],"category":"people"},":woman_with_headscarf_tone5:":{"uc_base":"1f9d5-1f3ff","uc_output":"1f9d5-1f3ff","uc_match":"1f9d5-1f3ff","uc_greedy":"1f9d5-1f3ff","shortnames":[":woman_with_headscarf_dark_skin_tone:"],"category":"people"},":fist_tone1:":{"uc_base":"270a-1f3fb","uc_output":"270a-1f3fb","uc_match":"270a-1f3fb","uc_greedy":"270a-1f3fb","shortnames":[],"category":"people"},":fist_tone2:":{"uc_base":"270a-1f3fc","uc_output":"270a-1f3fc","uc_match":"270a-1f3fc","uc_greedy":"270a-1f3fc","shortnames":[],"category":"people"},":fist_tone3:":{"uc_base":"270a-1f3fd","uc_output":"270a-1f3fd","uc_match":"270a-1f3fd","uc_greedy":"270a-1f3fd","shortnames":[],"category":"people"},":fist_tone4:":{"uc_base":"270a-1f3fe","uc_output":"270a-1f3fe","uc_match":"270a-1f3fe","uc_greedy":"270a-1f3fe","shortnames":[],"category":"people"},":fist_tone5:":{"uc_base":"270a-1f3ff","uc_output":"270a-1f3ff","uc_match":"270a-1f3ff","uc_greedy":"270a-1f3ff","shortnames":[],"category":"people"},":person_bouncing_ball_tone1:":{"uc_base":"26f9-1f3fb","uc_output":"26f9-1f3fb","uc_match":"26f9-fe0f-1f3fb","uc_greedy":"26f9-fe0f-1f3fb","shortnames":[":basketball_player_tone1:",":person_with_ball_tone1:"],"category":"activity"},":person_bouncing_ball_tone2:":{"uc_base":"26f9-1f3fc","uc_output":"26f9-1f3fc","uc_match":"26f9-fe0f-1f3fc","uc_greedy":"26f9-fe0f-1f3fc","shortnames":[":basketball_player_tone2:",":person_with_ball_tone2:"],"category":"activity"},":person_bouncing_ball_tone3:":{"uc_base":"26f9-1f3fd","uc_output":"26f9-1f3fd","uc_match":"26f9-fe0f-1f3fd","uc_greedy":"26f9-fe0f-1f3fd","shortnames":[":basketball_player_tone3:",":person_with_ball_tone3:"],"category":"activity"},":person_bouncing_ball_tone4:":{"uc_base":"26f9-1f3fe","uc_output":"26f9-1f3fe","uc_match":"26f9-fe0f-1f3fe","uc_greedy":"26f9-fe0f-1f3fe","shortnames":[":basketball_player_tone4:",":person_with_ball_tone4:"],"category":"activity"},":person_bouncing_ball_tone5:":{"uc_base":"26f9-1f3ff","uc_output":"26f9-1f3ff","uc_match":"26f9-fe0f-1f3ff","uc_greedy":"26f9-fe0f-1f3ff","shortnames":[":basketball_player_tone5:",":person_with_ball_tone5:"],"category":"activity"},":point_up_tone1:":{"uc_base":"261d-1f3fb","uc_output":"261d-1f3fb","uc_match":"261d-fe0f-1f3fb","uc_greedy":"261d-fe0f-1f3fb","shortnames":[],"category":"people"},":point_up_tone2:":{"uc_base":"261d-1f3fc","uc_output":"261d-1f3fc","uc_match":"261d-fe0f-1f3fc","uc_greedy":"261d-fe0f-1f3fc","shortnames":[],"category":"people"},":point_up_tone3:":{"uc_base":"261d-1f3fd","uc_output":"261d-1f3fd","uc_match":"261d-fe0f-1f3fd","uc_greedy":"261d-fe0f-1f3fd","shortnames":[],"category":"people"},":point_up_tone4:":{"uc_base":"261d-1f3fe","uc_output":"261d-1f3fe","uc_match":"261d-fe0f-1f3fe","uc_greedy":"261d-fe0f-1f3fe","shortnames":[],"category":"people"},":point_up_tone5:":{"uc_base":"261d-1f3ff","uc_output":"261d-1f3ff","uc_match":"261d-fe0f-1f3ff","uc_greedy":"261d-fe0f-1f3ff","shortnames":[],"category":"people"},":raised_hand_tone1:":{"uc_base":"270b-1f3fb","uc_output":"270b-1f3fb","uc_match":"270b-1f3fb","uc_greedy":"270b-1f3fb","shortnames":[],"category":"people"},":raised_hand_tone2:":{"uc_base":"270b-1f3fc","uc_output":"270b-1f3fc","uc_match":"270b-1f3fc","uc_greedy":"270b-1f3fc","shortnames":[],"category":"people"},":raised_hand_tone3:":{"uc_base":"270b-1f3fd","uc_output":"270b-1f3fd","uc_match":"270b-1f3fd","uc_greedy":"270b-1f3fd","shortnames":[],"category":"people"},":raised_hand_tone4:":{"uc_base":"270b-1f3fe","uc_output":"270b-1f3fe","uc_match":"270b-1f3fe","uc_greedy":"270b-1f3fe","shortnames":[],"category":"people"},":raised_hand_tone5:":{"uc_base":"270b-1f3ff","uc_output":"270b-1f3ff","uc_match":"270b-1f3ff","uc_greedy":"270b-1f3ff","shortnames":[],"category":"people"},":v_tone1:":{"uc_base":"270c-1f3fb","uc_output":"270c-1f3fb","uc_match":"270c-fe0f-1f3fb","uc_greedy":"270c-fe0f-1f3fb","shortnames":[],"category":"people"},":v_tone2:":{"uc_base":"270c-1f3fc","uc_output":"270c-1f3fc","uc_match":"270c-fe0f-1f3fc","uc_greedy":"270c-fe0f-1f3fc","shortnames":[],"category":"people"},":v_tone3:":{"uc_base":"270c-1f3fd","uc_output":"270c-1f3fd","uc_match":"270c-fe0f-1f3fd","uc_greedy":"270c-fe0f-1f3fd","shortnames":[],"category":"people"},":v_tone4:":{"uc_base":"270c-1f3fe","uc_output":"270c-1f3fe","uc_match":"270c-fe0f-1f3fe","uc_greedy":"270c-fe0f-1f3fe","shortnames":[],"category":"people"},":v_tone5:":{"uc_base":"270c-1f3ff","uc_output":"270c-1f3ff","uc_match":"270c-fe0f-1f3ff","uc_greedy":"270c-fe0f-1f3ff","shortnames":[],"category":"people"},":writing_hand_tone1:":{"uc_base":"270d-1f3fb","uc_output":"270d-1f3fb","uc_match":"270d-fe0f-1f3fb","uc_greedy":"270d-fe0f-1f3fb","shortnames":[],"category":"people"},":writing_hand_tone2:":{"uc_base":"270d-1f3fc","uc_output":"270d-1f3fc","uc_match":"270d-fe0f-1f3fc","uc_greedy":"270d-fe0f-1f3fc","shortnames":[],"category":"people"},":writing_hand_tone3:":{"uc_base":"270d-1f3fd","uc_output":"270d-1f3fd","uc_match":"270d-fe0f-1f3fd","uc_greedy":"270d-fe0f-1f3fd","shortnames":[],"category":"people"},":writing_hand_tone4:":{"uc_base":"270d-1f3fe","uc_output":"270d-1f3fe","uc_match":"270d-fe0f-1f3fe","uc_greedy":"270d-fe0f-1f3fe","shortnames":[],"category":"people"},":writing_hand_tone5:":{"uc_base":"270d-1f3ff","uc_output":"270d-1f3ff","uc_match":"270d-fe0f-1f3ff","uc_greedy":"270d-fe0f-1f3ff","shortnames":[],"category":"people"},":chess_pawn:":{"uc_base":"265f","uc_output":"265f-fe0f","uc_match":"265f","uc_greedy":"265f","shortnames":[],"category":"objects"},":infinity:":{"uc_base":"267e","uc_output":"267e-fe0f","uc_match":"267e","uc_greedy":"267e","shortnames":[],"category":"symbols"},":100:":{"uc_base":"1f4af","uc_output":"1f4af","uc_match":"1f4af","uc_greedy":"1f4af","shortnames":[],"category":"symbols"},":1234:":{"uc_base":"1f522","uc_output":"1f522","uc_match":"1f522","uc_greedy":"1f522","shortnames":[],"category":"symbols"},":8ball:":{"uc_base":"1f3b1","uc_output":"1f3b1","uc_match":"1f3b1","uc_greedy":"1f3b1","shortnames":[],"category":"activity"},":a:":{"uc_base":"1f170","uc_output":"1f170","uc_match":"1f170-fe0f","uc_greedy":"1f170-fe0f","shortnames":[],"category":"symbols"},":ab:":{"uc_base":"1f18e","uc_output":"1f18e","uc_match":"1f18e","uc_greedy":"1f18e","shortnames":[],"category":"symbols"},":abacus:":{"uc_base":"1f9ee","uc_output":"1f9ee","uc_match":"1f9ee","uc_greedy":"1f9ee","shortnames":[],"category":"objects"},":abc:":{"uc_base":"1f524","uc_output":"1f524","uc_match":"1f524","uc_greedy":"1f524","shortnames":[],"category":"symbols"},":abcd:":{"uc_base":"1f521","uc_output":"1f521","uc_match":"1f521","uc_greedy":"1f521","shortnames":[],"category":"symbols"},":accept:":{"uc_base":"1f251","uc_output":"1f251","uc_match":"1f251","uc_greedy":"1f251","shortnames":[],"category":"symbols"},":adult:":{"uc_base":"1f9d1","uc_output":"1f9d1","uc_match":"1f9d1","uc_greedy":"1f9d1","shortnames":[],"category":"people"},":aerial_tramway:":{"uc_base":"1f6a1","uc_output":"1f6a1","uc_match":"1f6a1","uc_greedy":"1f6a1","shortnames":[],"category":"travel"},":airplane_arriving:":{"uc_base":"1f6ec","uc_output":"1f6ec","uc_match":"1f6ec","uc_greedy":"1f6ec","shortnames":[],"category":"travel"},":airplane_departure:":{"uc_base":"1f6eb","uc_output":"1f6eb","uc_match":"1f6eb","uc_greedy":"1f6eb","shortnames":[],"category":"travel"},":airplane_small:":{"uc_base":"1f6e9","uc_output":"1f6e9","uc_match":"1f6e9-fe0f","uc_greedy":"1f6e9-fe0f","shortnames":[":small_airplane:"],"category":"travel"},":alien:":{"uc_base":"1f47d","uc_output":"1f47d","uc_match":"1f47d-fe0f","uc_greedy":"1f47d-fe0f","shortnames":[],"category":"people"},":ambulance:":{"uc_base":"1f691","uc_output":"1f691","uc_match":"1f691-fe0f","uc_greedy":"1f691-fe0f","shortnames":[],"category":"travel"},":amphora:":{"uc_base":"1f3fa","uc_output":"1f3fa","uc_match":"1f3fa","uc_greedy":"1f3fa","shortnames":[],"category":"objects"},":angel:":{"uc_base":"1f47c","uc_output":"1f47c","uc_match":"1f47c","uc_greedy":"1f47c","shortnames":[],"category":"people"},":anger:":{"uc_base":"1f4a2","uc_output":"1f4a2","uc_match":"1f4a2","uc_greedy":"1f4a2","shortnames":[],"category":"symbols"},":anger_right:":{"uc_base":"1f5ef","uc_output":"1f5ef","uc_match":"1f5ef-fe0f","uc_greedy":"1f5ef-fe0f","shortnames":[":right_anger_bubble:"],"category":"symbols"},":angry:":{"uc_base":"1f620","uc_output":"1f620","uc_match":"1f620","uc_greedy":"1f620","shortnames":[],"category":"people"},":anguished:":{"uc_base":"1f627","uc_output":"1f627","uc_match":"1f627","uc_greedy":"1f627","shortnames":[],"category":"people"},":ant:":{"uc_base":"1f41c","uc_output":"1f41c","uc_match":"1f41c","uc_greedy":"1f41c","shortnames":[],"category":"nature"},":apple:":{"uc_base":"1f34e","uc_output":"1f34e","uc_match":"1f34e","uc_greedy":"1f34e","shortnames":[],"category":"food"},":arrow_down_small:":{"uc_base":"1f53d","uc_output":"1f53d","uc_match":"1f53d","uc_greedy":"1f53d","shortnames":[],"category":"symbols"},":arrow_up_small:":{"uc_base":"1f53c","uc_output":"1f53c","uc_match":"1f53c","uc_greedy":"1f53c","shortnames":[],"category":"symbols"},":arrows_clockwise:":{"uc_base":"1f503","uc_output":"1f503","uc_match":"1f503","uc_greedy":"1f503","shortnames":[],"category":"symbols"},":arrows_counterclockwise:":{"uc_base":"1f504","uc_output":"1f504","uc_match":"1f504","uc_greedy":"1f504","shortnames":[],"category":"symbols"},":art:":{"uc_base":"1f3a8","uc_output":"1f3a8","uc_match":"1f3a8","uc_greedy":"1f3a8","shortnames":[],"category":"activity"},":articulated_lorry:":{"uc_base":"1f69b","uc_output":"1f69b","uc_match":"1f69b","uc_greedy":"1f69b","shortnames":[],"category":"travel"},":astonished:":{"uc_base":"1f632","uc_output":"1f632","uc_match":"1f632","uc_greedy":"1f632","shortnames":[],"category":"people"},":athletic_shoe:":{"uc_base":"1f45f","uc_output":"1f45f","uc_match":"1f45f","uc_greedy":"1f45f","shortnames":[],"category":"people"},":atm:":{"uc_base":"1f3e7","uc_output":"1f3e7","uc_match":"1f3e7","uc_greedy":"1f3e7","shortnames":[],"category":"symbols"},":avocado:":{"uc_base":"1f951","uc_output":"1f951","uc_match":"1f951","uc_greedy":"1f951","shortnames":[],"category":"food"},":b:":{"uc_base":"1f171","uc_output":"1f171","uc_match":"1f171-fe0f","uc_greedy":"1f171-fe0f","shortnames":[],"category":"symbols"},":baby:":{"uc_base":"1f476","uc_output":"1f476","uc_match":"1f476","uc_greedy":"1f476","shortnames":[],"category":"people"},":baby_bottle:":{"uc_base":"1f37c","uc_output":"1f37c","uc_match":"1f37c","uc_greedy":"1f37c","shortnames":[],"category":"food"},":baby_chick:":{"uc_base":"1f424","uc_output":"1f424","uc_match":"1f424","uc_greedy":"1f424","shortnames":[],"category":"nature"},":baby_symbol:":{"uc_base":"1f6bc","uc_output":"1f6bc","uc_match":"1f6bc-fe0f","uc_greedy":"1f6bc-fe0f","shortnames":[],"category":"symbols"},":back:":{"uc_base":"1f519","uc_output":"1f519","uc_match":"1f519","uc_greedy":"1f519","shortnames":[],"category":"symbols"},":bacon:":{"uc_base":"1f953","uc_output":"1f953","uc_match":"1f953","uc_greedy":"1f953","shortnames":[],"category":"food"},":badger:":{"uc_base":"1f9a1","uc_output":"1f9a1","uc_match":"1f9a1","uc_greedy":"1f9a1","shortnames":[],"category":"nature"},":badminton:":{"uc_base":"1f3f8","uc_output":"1f3f8","uc_match":"1f3f8","uc_greedy":"1f3f8","shortnames":[],"category":"activity"},":bagel:":{"uc_base":"1f96f","uc_output":"1f96f","uc_match":"1f96f","uc_greedy":"1f96f","shortnames":[],"category":"food"},":baggage_claim:":{"uc_base":"1f6c4","uc_output":"1f6c4","uc_match":"1f6c4","uc_greedy":"1f6c4","shortnames":[],"category":"symbols"},":bald:":{"uc_base":"1f9b2","uc_output":"1f9b2","uc_match":"1f9b2","uc_greedy":"1f9b2","shortnames":[],"category":"people"},":balloon:":{"uc_base":"1f388","uc_output":"1f388","uc_match":"1f388","uc_greedy":"1f388","shortnames":[],"category":"objects"},":ballot_box:":{"uc_base":"1f5f3","uc_output":"1f5f3","uc_match":"1f5f3-fe0f","uc_greedy":"1f5f3-fe0f","shortnames":[":ballot_box_with_ballot:"],"category":"objects"},":bamboo:":{"uc_base":"1f38d","uc_output":"1f38d","uc_match":"1f38d","uc_greedy":"1f38d","shortnames":[],"category":"nature"},":banana:":{"uc_base":"1f34c","uc_output":"1f34c","uc_match":"1f34c","uc_greedy":"1f34c","shortnames":[],"category":"food"},":bank:":{"uc_base":"1f3e6","uc_output":"1f3e6","uc_match":"1f3e6","uc_greedy":"1f3e6","shortnames":[],"category":"travel"},":bar_chart:":{"uc_base":"1f4ca","uc_output":"1f4ca","uc_match":"1f4ca","uc_greedy":"1f4ca","shortnames":[],"category":"objects"},":barber:":{"uc_base":"1f488","uc_output":"1f488","uc_match":"1f488","uc_greedy":"1f488","shortnames":[],"category":"objects"},":basket:":{"uc_base":"1f9fa","uc_output":"1f9fa","uc_match":"1f9fa","uc_greedy":"1f9fa","shortnames":[],"category":"objects"},":basketball:":{"uc_base":"1f3c0","uc_output":"1f3c0","uc_match":"1f3c0","uc_greedy":"1f3c0","shortnames":[],"category":"activity"},":bat:":{"uc_base":"1f987","uc_output":"1f987","uc_match":"1f987","uc_greedy":"1f987","shortnames":[],"category":"nature"},":bath:":{"uc_base":"1f6c0","uc_output":"1f6c0","uc_match":"1f6c0","uc_greedy":"1f6c0","shortnames":[],"category":"objects"},":bathtub:":{"uc_base":"1f6c1","uc_output":"1f6c1","uc_match":"1f6c1","uc_greedy":"1f6c1","shortnames":[],"category":"objects"},":battery:":{"uc_base":"1f50b","uc_output":"1f50b","uc_match":"1f50b","uc_greedy":"1f50b","shortnames":[],"category":"objects"},":beach:":{"uc_base":"1f3d6","uc_output":"1f3d6","uc_match":"1f3d6-fe0f","uc_greedy":"1f3d6-fe0f","shortnames":[":beach_with_umbrella:"],"category":"travel"},":bear:":{"uc_base":"1f43b","uc_output":"1f43b","uc_match":"1f43b","uc_greedy":"1f43b","shortnames":[],"category":"nature"},":bearded_person:":{"uc_base":"1f9d4","uc_output":"1f9d4","uc_match":"1f9d4","uc_greedy":"1f9d4","shortnames":[],"category":"people"},":bed:":{"uc_base":"1f6cf","uc_output":"1f6cf","uc_match":"1f6cf-fe0f","uc_greedy":"1f6cf-fe0f","shortnames":[],"category":"objects"},":bee:":{"uc_base":"1f41d","uc_output":"1f41d","uc_match":"1f41d","uc_greedy":"1f41d","shortnames":[],"category":"nature"},":beer:":{"uc_base":"1f37a","uc_output":"1f37a","uc_match":"1f37a","uc_greedy":"1f37a","shortnames":[],"category":"food"},":beers:":{"uc_base":"1f37b","uc_output":"1f37b","uc_match":"1f37b","uc_greedy":"1f37b","shortnames":[],"category":"food"},":beetle:":{"uc_base":"1f41e","uc_output":"1f41e","uc_match":"1f41e","uc_greedy":"1f41e","shortnames":[],"category":"nature"},":beginner:":{"uc_base":"1f530","uc_output":"1f530","uc_match":"1f530","uc_greedy":"1f530","shortnames":[],"category":"symbols"},":bell:":{"uc_base":"1f514","uc_output":"1f514","uc_match":"1f514","uc_greedy":"1f514","shortnames":[],"category":"symbols"},":bellhop:":{"uc_base":"1f6ce","uc_output":"1f6ce","uc_match":"1f6ce-fe0f","uc_greedy":"1f6ce-fe0f","shortnames":[":bellhop_bell:"],"category":"objects"},":bento:":{"uc_base":"1f371","uc_output":"1f371","uc_match":"1f371","uc_greedy":"1f371","shortnames":[],"category":"food"},":bike:":{"uc_base":"1f6b2","uc_output":"1f6b2","uc_match":"1f6b2-fe0f","uc_greedy":"1f6b2-fe0f","shortnames":[],"category":"travel"},":bikini:":{"uc_base":"1f459","uc_output":"1f459","uc_match":"1f459","uc_greedy":"1f459","shortnames":[],"category":"people"},":billed_cap:":{"uc_base":"1f9e2","uc_output":"1f9e2","uc_match":"1f9e2","uc_greedy":"1f9e2","shortnames":[],"category":"people"},":bird:":{"uc_base":"1f426","uc_output":"1f426","uc_match":"1f426-fe0f","uc_greedy":"1f426-fe0f","shortnames":[],"category":"nature"},":birthday:":{"uc_base":"1f382","uc_output":"1f382","uc_match":"1f382","uc_greedy":"1f382","shortnames":[],"category":"food"},":black_heart:":{"uc_base":"1f5a4","uc_output":"1f5a4","uc_match":"1f5a4","uc_greedy":"1f5a4","shortnames":[],"category":"symbols"},":black_joker:":{"uc_base":"1f0cf","uc_output":"1f0cf","uc_match":"1f0cf","uc_greedy":"1f0cf","shortnames":[],"category":"symbols"},":black_square_button:":{"uc_base":"1f532","uc_output":"1f532","uc_match":"1f532","uc_greedy":"1f532","shortnames":[],"category":"symbols"},":blond_haired_person:":{"uc_base":"1f471","uc_output":"1f471","uc_match":"1f471","uc_greedy":"1f471","shortnames":[":person_with_blond_hair:"],"category":"people"},":blossom:":{"uc_base":"1f33c","uc_output":"1f33c","uc_match":"1f33c","uc_greedy":"1f33c","shortnames":[],"category":"nature"},":blowfish:":{"uc_base":"1f421","uc_output":"1f421","uc_match":"1f421","uc_greedy":"1f421","shortnames":[],"category":"nature"},":blue_book:":{"uc_base":"1f4d8","uc_output":"1f4d8","uc_match":"1f4d8","uc_greedy":"1f4d8","shortnames":[],"category":"objects"},":blue_car:":{"uc_base":"1f699","uc_output":"1f699","uc_match":"1f699","uc_greedy":"1f699","shortnames":[],"category":"travel"},":blue_circle:":{"uc_base":"1f535","uc_output":"1f535","uc_match":"1f535","uc_greedy":"1f535","shortnames":[],"category":"symbols"},":blue_heart:":{"uc_base":"1f499","uc_output":"1f499","uc_match":"1f499","uc_greedy":"1f499","shortnames":[],"category":"symbols"},":blush:":{"uc_base":"1f60a","uc_output":"1f60a","uc_match":"1f60a","uc_greedy":"1f60a","shortnames":[],"category":"people"},":boar:":{"uc_base":"1f417","uc_output":"1f417","uc_match":"1f417","uc_greedy":"1f417","shortnames":[],"category":"nature"},":bomb:":{"uc_base":"1f4a3","uc_output":"1f4a3","uc_match":"1f4a3-fe0f","uc_greedy":"1f4a3-fe0f","shortnames":[],"category":"objects"},":bone:":{"uc_base":"1f9b4","uc_output":"1f9b4","uc_match":"1f9b4","uc_greedy":"1f9b4","shortnames":[],"category":"people"},":book:":{"uc_base":"1f4d6","uc_output":"1f4d6","uc_match":"1f4d6","uc_greedy":"1f4d6","shortnames":[],"category":"objects"},":bookmark:":{"uc_base":"1f516","uc_output":"1f516","uc_match":"1f516","uc_greedy":"1f516","shortnames":[],"category":"objects"},":bookmark_tabs:":{"uc_base":"1f4d1","uc_output":"1f4d1","uc_match":"1f4d1","uc_greedy":"1f4d1","shortnames":[],"category":"objects"},":books:":{"uc_base":"1f4da","uc_output":"1f4da","uc_match":"1f4da-fe0f","uc_greedy":"1f4da-fe0f","shortnames":[],"category":"objects"},":boom:":{"uc_base":"1f4a5","uc_output":"1f4a5","uc_match":"1f4a5","uc_greedy":"1f4a5","shortnames":[],"category":"nature"},":boot:":{"uc_base":"1f462","uc_output":"1f462","uc_match":"1f462","uc_greedy":"1f462","shortnames":[],"category":"people"},":bouquet:":{"uc_base":"1f490","uc_output":"1f490","uc_match":"1f490","uc_greedy":"1f490","shortnames":[],"category":"nature"},":bow_and_arrow:":{"uc_base":"1f3f9","uc_output":"1f3f9","uc_match":"1f3f9","uc_greedy":"1f3f9","shortnames":[":archery:"],"category":"activity"},":bowl_with_spoon:":{"uc_base":"1f963","uc_output":"1f963","uc_match":"1f963","uc_greedy":"1f963","shortnames":[],"category":"food"},":bowling:":{"uc_base":"1f3b3","uc_output":"1f3b3","uc_match":"1f3b3","uc_greedy":"1f3b3","shortnames":[],"category":"activity"},":boxing_glove:":{"uc_base":"1f94a","uc_output":"1f94a","uc_match":"1f94a","uc_greedy":"1f94a","shortnames":[":boxing_gloves:"],"category":"activity"},":boy:":{"uc_base":"1f466","uc_output":"1f466","uc_match":"1f466","uc_greedy":"1f466","shortnames":[],"category":"people"},":brain:":{"uc_base":"1f9e0","uc_output":"1f9e0","uc_match":"1f9e0","uc_greedy":"1f9e0","shortnames":[],"category":"people"},":bread:":{"uc_base":"1f35e","uc_output":"1f35e","uc_match":"1f35e","uc_greedy":"1f35e","shortnames":[],"category":"food"},":breast_feeding:":{"uc_base":"1f931","uc_output":"1f931","uc_match":"1f931","uc_greedy":"1f931","shortnames":[],"category":"people"},":bricks:":{"uc_base":"1f9f1","uc_output":"1f9f1","uc_match":"1f9f1","uc_greedy":"1f9f1","shortnames":[],"category":"objects"},":bride_with_veil:":{"uc_base":"1f470","uc_output":"1f470","uc_match":"1f470","uc_greedy":"1f470","shortnames":[],"category":"people"},":bridge_at_night:":{"uc_base":"1f309","uc_output":"1f309","uc_match":"1f309","uc_greedy":"1f309","shortnames":[],"category":"travel"},":briefcase:":{"uc_base":"1f4bc","uc_output":"1f4bc","uc_match":"1f4bc","uc_greedy":"1f4bc","shortnames":[],"category":"people"},":broccoli:":{"uc_base":"1f966","uc_output":"1f966","uc_match":"1f966","uc_greedy":"1f966","shortnames":[],"category":"food"},":broken_heart:":{"uc_base":"1f494","uc_output":"1f494","uc_match":"1f494","uc_greedy":"1f494","shortnames":[],"category":"symbols"},":broom:":{"uc_base":"1f9f9","uc_output":"1f9f9","uc_match":"1f9f9","uc_greedy":"1f9f9","shortnames":[],"category":"objects"},":bug:":{"uc_base":"1f41b","uc_output":"1f41b","uc_match":"1f41b","uc_greedy":"1f41b","shortnames":[],"category":"nature"},":bulb:":{"uc_base":"1f4a1","uc_output":"1f4a1","uc_match":"1f4a1","uc_greedy":"1f4a1","shortnames":[],"category":"objects"},":bullettrain_front:":{"uc_base":"1f685","uc_output":"1f685","uc_match":"1f685","uc_greedy":"1f685","shortnames":[],"category":"travel"},":bullettrain_side:":{"uc_base":"1f684","uc_output":"1f684","uc_match":"1f684","uc_greedy":"1f684","shortnames":[],"category":"travel"},":burrito:":{"uc_base":"1f32f","uc_output":"1f32f","uc_match":"1f32f","uc_greedy":"1f32f","shortnames":[],"category":"food"},":bus:":{"uc_base":"1f68c","uc_output":"1f68c","uc_match":"1f68c","uc_greedy":"1f68c","shortnames":[],"category":"travel"},":busstop:":{"uc_base":"1f68f","uc_output":"1f68f","uc_match":"1f68f","uc_greedy":"1f68f","shortnames":[],"category":"travel"},":bust_in_silhouette:":{"uc_base":"1f464","uc_output":"1f464","uc_match":"1f464","uc_greedy":"1f464","shortnames":[],"category":"people"},":busts_in_silhouette:":{"uc_base":"1f465","uc_output":"1f465","uc_match":"1f465","uc_greedy":"1f465","shortnames":[],"category":"people"},":butterfly:":{"uc_base":"1f98b","uc_output":"1f98b","uc_match":"1f98b","uc_greedy":"1f98b","shortnames":[],"category":"nature"},":cactus:":{"uc_base":"1f335","uc_output":"1f335","uc_match":"1f335","uc_greedy":"1f335","shortnames":[],"category":"nature"},":cake:":{"uc_base":"1f370","uc_output":"1f370","uc_match":"1f370","uc_greedy":"1f370","shortnames":[],"category":"food"},":calendar:":{"uc_base":"1f4c6","uc_output":"1f4c6","uc_match":"1f4c6","uc_greedy":"1f4c6","shortnames":[],"category":"objects"},":calendar_spiral:":{"uc_base":"1f5d3","uc_output":"1f5d3","uc_match":"1f5d3-fe0f","uc_greedy":"1f5d3-fe0f","shortnames":[":spiral_calendar_pad:"],"category":"objects"},":call_me:":{"uc_base":"1f919","uc_output":"1f919","uc_match":"1f919","uc_greedy":"1f919","shortnames":[":call_me_hand:"],"category":"people"},":calling:":{"uc_base":"1f4f2","uc_output":"1f4f2","uc_match":"1f4f2","uc_greedy":"1f4f2","shortnames":[],"category":"objects"},":camel:":{"uc_base":"1f42b","uc_output":"1f42b","uc_match":"1f42b","uc_greedy":"1f42b","shortnames":[],"category":"nature"},":camera:":{"uc_base":"1f4f7","uc_output":"1f4f7","uc_match":"1f4f7-fe0f","uc_greedy":"1f4f7-fe0f","shortnames":[],"category":"objects"},":camera_with_flash:":{"uc_base":"1f4f8","uc_output":"1f4f8","uc_match":"1f4f8","uc_greedy":"1f4f8","shortnames":[],"category":"objects"},":camping:":{"uc_base":"1f3d5","uc_output":"1f3d5","uc_match":"1f3d5-fe0f","uc_greedy":"1f3d5-fe0f","shortnames":[],"category":"travel"},":candle:":{"uc_base":"1f56f","uc_output":"1f56f","uc_match":"1f56f-fe0f","uc_greedy":"1f56f-fe0f","shortnames":[],"category":"objects"},":candy:":{"uc_base":"1f36c","uc_output":"1f36c","uc_match":"1f36c","uc_greedy":"1f36c","shortnames":[],"category":"food"},":canned_food:":{"uc_base":"1f96b","uc_output":"1f96b","uc_match":"1f96b","uc_greedy":"1f96b","shortnames":[],"category":"food"},":canoe:":{"uc_base":"1f6f6","uc_output":"1f6f6","uc_match":"1f6f6","uc_greedy":"1f6f6","shortnames":[":kayak:"],"category":"travel"},":capital_abcd:":{"uc_base":"1f520","uc_output":"1f520","uc_match":"1f520","uc_greedy":"1f520","shortnames":[],"category":"symbols"},":card_box:":{"uc_base":"1f5c3","uc_output":"1f5c3","uc_match":"1f5c3-fe0f","uc_greedy":"1f5c3-fe0f","shortnames":[":card_file_box:"],"category":"objects"},":card_index:":{"uc_base":"1f4c7","uc_output":"1f4c7","uc_match":"1f4c7","uc_greedy":"1f4c7","shortnames":[],"category":"objects"},":carousel_horse:":{"uc_base":"1f3a0","uc_output":"1f3a0","uc_match":"1f3a0","uc_greedy":"1f3a0","shortnames":[],"category":"travel"},":carrot:":{"uc_base":"1f955","uc_output":"1f955","uc_match":"1f955","uc_greedy":"1f955","shortnames":[],"category":"food"},":cat2:":{"uc_base":"1f408","uc_output":"1f408","uc_match":"1f408-fe0f","uc_greedy":"1f408-fe0f","shortnames":[],"category":"nature"},":cat:":{"uc_base":"1f431","uc_output":"1f431","uc_match":"1f431","uc_greedy":"1f431","shortnames":[],"category":"nature"},":cd:":{"uc_base":"1f4bf","uc_output":"1f4bf","uc_match":"1f4bf-fe0f","uc_greedy":"1f4bf-fe0f","shortnames":[],"category":"objects"},":champagne:":{"uc_base":"1f37e","uc_output":"1f37e","uc_match":"1f37e","uc_greedy":"1f37e","shortnames":[":bottle_with_popping_cork:"],"category":"food"},":champagne_glass:":{"uc_base":"1f942","uc_output":"1f942","uc_match":"1f942","uc_greedy":"1f942","shortnames":[":clinking_glass:"],"category":"food"},":chart:":{"uc_base":"1f4b9","uc_output":"1f4b9","uc_match":"1f4b9","uc_greedy":"1f4b9","shortnames":[],"category":"symbols"},":chart_with_downwards_trend:":{"uc_base":"1f4c9","uc_output":"1f4c9","uc_match":"1f4c9","uc_greedy":"1f4c9","shortnames":[],"category":"objects"},":chart_with_upwards_trend:":{"uc_base":"1f4c8","uc_output":"1f4c8","uc_match":"1f4c8","uc_greedy":"1f4c8","shortnames":[],"category":"objects"},":checkered_flag:":{"uc_base":"1f3c1","uc_output":"1f3c1","uc_match":"1f3c1","uc_greedy":"1f3c1","shortnames":[],"category":"flags"},":cheese:":{"uc_base":"1f9c0","uc_output":"1f9c0","uc_match":"1f9c0","uc_greedy":"1f9c0","shortnames":[":cheese_wedge:"],"category":"food"},":cherries:":{"uc_base":"1f352","uc_output":"1f352","uc_match":"1f352","uc_greedy":"1f352","shortnames":[],"category":"food"},":cherry_blossom:":{"uc_base":"1f338","uc_output":"1f338","uc_match":"1f338","uc_greedy":"1f338","shortnames":[],"category":"nature"},":chestnut:":{"uc_base":"1f330","uc_output":"1f330","uc_match":"1f330","uc_greedy":"1f330","shortnames":[],"category":"food"},":chicken:":{"uc_base":"1f414","uc_output":"1f414","uc_match":"1f414","uc_greedy":"1f414","shortnames":[],"category":"nature"},":child:":{"uc_base":"1f9d2","uc_output":"1f9d2","uc_match":"1f9d2","uc_greedy":"1f9d2","shortnames":[],"category":"people"},":children_crossing:":{"uc_base":"1f6b8","uc_output":"1f6b8","uc_match":"1f6b8","uc_greedy":"1f6b8","shortnames":[],"category":"symbols"},":chipmunk:":{"uc_base":"1f43f","uc_output":"1f43f","uc_match":"1f43f-fe0f","uc_greedy":"1f43f-fe0f","shortnames":[],"category":"nature"},":chocolate_bar:":{"uc_base":"1f36b","uc_output":"1f36b","uc_match":"1f36b","uc_greedy":"1f36b","shortnames":[],"category":"food"},":chopsticks:":{"uc_base":"1f962","uc_output":"1f962","uc_match":"1f962","uc_greedy":"1f962","shortnames":[],"category":"food"},":christmas_tree:":{"uc_base":"1f384","uc_output":"1f384","uc_match":"1f384","uc_greedy":"1f384","shortnames":[],"category":"nature"},":cinema:":{"uc_base":"1f3a6","uc_output":"1f3a6","uc_match":"1f3a6","uc_greedy":"1f3a6","shortnames":[],"category":"symbols"},":circus_tent:":{"uc_base":"1f3aa","uc_output":"1f3aa","uc_match":"1f3aa","uc_greedy":"1f3aa","shortnames":[],"category":"activity"},":city_dusk:":{"uc_base":"1f306","uc_output":"1f306","uc_match":"1f306","uc_greedy":"1f306","shortnames":[],"category":"travel"},":city_sunset:":{"uc_base":"1f307","uc_output":"1f307","uc_match":"1f307","uc_greedy":"1f307","shortnames":[":city_sunrise:"],"category":"travel"},":cityscape:":{"uc_base":"1f3d9","uc_output":"1f3d9","uc_match":"1f3d9-fe0f","uc_greedy":"1f3d9-fe0f","shortnames":[],"category":"travel"},":cl:":{"uc_base":"1f191","uc_output":"1f191","uc_match":"1f191","uc_greedy":"1f191","shortnames":[],"category":"symbols"},":clap:":{"uc_base":"1f44f","uc_output":"1f44f","uc_match":"1f44f","uc_greedy":"1f44f","shortnames":[],"category":"people"},":clapper:":{"uc_base":"1f3ac","uc_output":"1f3ac","uc_match":"1f3ac-fe0f","uc_greedy":"1f3ac-fe0f","shortnames":[],"category":"activity"},":classical_building:":{"uc_base":"1f3db","uc_output":"1f3db","uc_match":"1f3db-fe0f","uc_greedy":"1f3db-fe0f","shortnames":[],"category":"travel"},":clipboard:":{"uc_base":"1f4cb","uc_output":"1f4cb","uc_match":"1f4cb-fe0f","uc_greedy":"1f4cb-fe0f","shortnames":[],"category":"objects"},":clock1030:":{"uc_base":"1f565","uc_output":"1f565","uc_match":"1f565-fe0f","uc_greedy":"1f565-fe0f","shortnames":[],"category":"symbols"},":clock10:":{"uc_base":"1f559","uc_output":"1f559","uc_match":"1f559-fe0f","uc_greedy":"1f559-fe0f","shortnames":[],"category":"symbols"},":clock1130:":{"uc_base":"1f566","uc_output":"1f566","uc_match":"1f566-fe0f","uc_greedy":"1f566-fe0f","shortnames":[],"category":"symbols"},":clock11:":{"uc_base":"1f55a","uc_output":"1f55a","uc_match":"1f55a-fe0f","uc_greedy":"1f55a-fe0f","shortnames":[],"category":"symbols"},":clock1230:":{"uc_base":"1f567","uc_output":"1f567","uc_match":"1f567-fe0f","uc_greedy":"1f567-fe0f","shortnames":[],"category":"symbols"},":clock12:":{"uc_base":"1f55b","uc_output":"1f55b","uc_match":"1f55b-fe0f","uc_greedy":"1f55b-fe0f","shortnames":[],"category":"symbols"},":clock130:":{"uc_base":"1f55c","uc_output":"1f55c","uc_match":"1f55c-fe0f","uc_greedy":"1f55c-fe0f","shortnames":[],"category":"symbols"},":clock1:":{"uc_base":"1f550","uc_output":"1f550","uc_match":"1f550-fe0f","uc_greedy":"1f550-fe0f","shortnames":[],"category":"symbols"},":clock230:":{"uc_base":"1f55d","uc_output":"1f55d","uc_match":"1f55d-fe0f","uc_greedy":"1f55d-fe0f","shortnames":[],"category":"symbols"},":clock2:":{"uc_base":"1f551","uc_output":"1f551","uc_match":"1f551-fe0f","uc_greedy":"1f551-fe0f","shortnames":[],"category":"symbols"},":clock330:":{"uc_base":"1f55e","uc_output":"1f55e","uc_match":"1f55e-fe0f","uc_greedy":"1f55e-fe0f","shortnames":[],"category":"symbols"},":clock3:":{"uc_base":"1f552","uc_output":"1f552","uc_match":"1f552-fe0f","uc_greedy":"1f552-fe0f","shortnames":[],"category":"symbols"},":clock430:":{"uc_base":"1f55f","uc_output":"1f55f","uc_match":"1f55f-fe0f","uc_greedy":"1f55f-fe0f","shortnames":[],"category":"symbols"},":clock4:":{"uc_base":"1f553","uc_output":"1f553","uc_match":"1f553-fe0f","uc_greedy":"1f553-fe0f","shortnames":[],"category":"symbols"},":clock530:":{"uc_base":"1f560","uc_output":"1f560","uc_match":"1f560-fe0f","uc_greedy":"1f560-fe0f","shortnames":[],"category":"symbols"},":clock5:":{"uc_base":"1f554","uc_output":"1f554","uc_match":"1f554-fe0f","uc_greedy":"1f554-fe0f","shortnames":[],"category":"symbols"},":clock630:":{"uc_base":"1f561","uc_output":"1f561","uc_match":"1f561-fe0f","uc_greedy":"1f561-fe0f","shortnames":[],"category":"symbols"},":clock6:":{"uc_base":"1f555","uc_output":"1f555","uc_match":"1f555-fe0f","uc_greedy":"1f555-fe0f","shortnames":[],"category":"symbols"},":clock730:":{"uc_base":"1f562","uc_output":"1f562","uc_match":"1f562-fe0f","uc_greedy":"1f562-fe0f","shortnames":[],"category":"symbols"},":clock7:":{"uc_base":"1f556","uc_output":"1f556","uc_match":"1f556-fe0f","uc_greedy":"1f556-fe0f","shortnames":[],"category":"symbols"},":clock830:":{"uc_base":"1f563","uc_output":"1f563","uc_match":"1f563-fe0f","uc_greedy":"1f563-fe0f","shortnames":[],"category":"symbols"},":clock8:":{"uc_base":"1f557","uc_output":"1f557","uc_match":"1f557-fe0f","uc_greedy":"1f557-fe0f","shortnames":[],"category":"symbols"},":clock930:":{"uc_base":"1f564","uc_output":"1f564","uc_match":"1f564-fe0f","uc_greedy":"1f564-fe0f","shortnames":[],"category":"symbols"},":clock9:":{"uc_base":"1f558","uc_output":"1f558","uc_match":"1f558-fe0f","uc_greedy":"1f558-fe0f","shortnames":[],"category":"symbols"},":clock:":{"uc_base":"1f570","uc_output":"1f570","uc_match":"1f570-fe0f","uc_greedy":"1f570-fe0f","shortnames":[":mantlepiece_clock:"],"category":"objects"},":closed_book:":{"uc_base":"1f4d5","uc_output":"1f4d5","uc_match":"1f4d5","uc_greedy":"1f4d5","shortnames":[],"category":"objects"},":closed_lock_with_key:":{"uc_base":"1f510","uc_output":"1f510","uc_match":"1f510","uc_greedy":"1f510","shortnames":[],"category":"objects"},":closed_umbrella:":{"uc_base":"1f302","uc_output":"1f302","uc_match":"1f302","uc_greedy":"1f302","shortnames":[],"category":"people"},":cloud_lightning:":{"uc_base":"1f329","uc_output":"1f329","uc_match":"1f329-fe0f","uc_greedy":"1f329-fe0f","shortnames":[":cloud_with_lightning:"],"category":"nature"},":cloud_rain:":{"uc_base":"1f327","uc_output":"1f327","uc_match":"1f327-fe0f","uc_greedy":"1f327-fe0f","shortnames":[":cloud_with_rain:"],"category":"nature"},":cloud_snow:":{"uc_base":"1f328","uc_output":"1f328","uc_match":"1f328-fe0f","uc_greedy":"1f328-fe0f","shortnames":[":cloud_with_snow:"],"category":"nature"},":cloud_tornado:":{"uc_base":"1f32a","uc_output":"1f32a","uc_match":"1f32a-fe0f","uc_greedy":"1f32a-fe0f","shortnames":[":cloud_with_tornado:"],"category":"nature"},":clown:":{"uc_base":"1f921","uc_output":"1f921","uc_match":"1f921","uc_greedy":"1f921","shortnames":[":clown_face:"],"category":"people"},":coat:":{"uc_base":"1f9e5","uc_output":"1f9e5","uc_match":"1f9e5","uc_greedy":"1f9e5","shortnames":[],"category":"people"},":cocktail:":{"uc_base":"1f378","uc_output":"1f378","uc_match":"1f378-fe0f","uc_greedy":"1f378-fe0f","shortnames":[],"category":"food"},":coconut:":{"uc_base":"1f965","uc_output":"1f965","uc_match":"1f965","uc_greedy":"1f965","shortnames":[],"category":"food"},":cold_face:":{"uc_base":"1f976","uc_output":"1f976","uc_match":"1f976","uc_greedy":"1f976","shortnames":[],"category":"people"},":cold_sweat:":{"uc_base":"1f630","uc_output":"1f630","uc_match":"1f630","uc_greedy":"1f630","shortnames":[],"category":"people"},":compass:":{"uc_base":"1f9ed","uc_output":"1f9ed","uc_match":"1f9ed","uc_greedy":"1f9ed","shortnames":[],"category":"objects"},":compression:":{"uc_base":"1f5dc","uc_output":"1f5dc","uc_match":"1f5dc-fe0f","uc_greedy":"1f5dc-fe0f","shortnames":[],"category":"objects"},":computer:":{"uc_base":"1f4bb","uc_output":"1f4bb","uc_match":"1f4bb-fe0f","uc_greedy":"1f4bb-fe0f","shortnames":[],"category":"objects"},":confetti_ball:":{"uc_base":"1f38a","uc_output":"1f38a","uc_match":"1f38a","uc_greedy":"1f38a","shortnames":[],"category":"objects"},":confounded:":{"uc_base":"1f616","uc_output":"1f616","uc_match":"1f616","uc_greedy":"1f616","shortnames":[],"category":"people"},":confused:":{"uc_base":"1f615","uc_output":"1f615","uc_match":"1f615","uc_greedy":"1f615","shortnames":[],"category":"people"},":construction:":{"uc_base":"1f6a7","uc_output":"1f6a7","uc_match":"1f6a7","uc_greedy":"1f6a7","shortnames":[],"category":"travel"},":construction_site:":{"uc_base":"1f3d7","uc_output":"1f3d7","uc_match":"1f3d7-fe0f","uc_greedy":"1f3d7-fe0f","shortnames":[":building_construction:"],"category":"travel"},":construction_worker:":{"uc_base":"1f477","uc_output":"1f477","uc_match":"1f477","uc_greedy":"1f477","shortnames":[],"category":"people"},":control_knobs:":{"uc_base":"1f39b","uc_output":"1f39b","uc_match":"1f39b-fe0f","uc_greedy":"1f39b-fe0f","shortnames":[],"category":"objects"},":convenience_store:":{"uc_base":"1f3ea","uc_output":"1f3ea","uc_match":"1f3ea","uc_greedy":"1f3ea","shortnames":[],"category":"travel"},":cookie:":{"uc_base":"1f36a","uc_output":"1f36a","uc_match":"1f36a","uc_greedy":"1f36a","shortnames":[],"category":"food"},":cooking:":{"uc_base":"1f373","uc_output":"1f373","uc_match":"1f373","uc_greedy":"1f373","shortnames":[],"category":"food"},":cool:":{"uc_base":"1f192","uc_output":"1f192","uc_match":"1f192","uc_greedy":"1f192","shortnames":[],"category":"symbols"},":corn:":{"uc_base":"1f33d","uc_output":"1f33d","uc_match":"1f33d","uc_greedy":"1f33d","shortnames":[],"category":"food"},":couch:":{"uc_base":"1f6cb","uc_output":"1f6cb","uc_match":"1f6cb-fe0f","uc_greedy":"1f6cb-fe0f","shortnames":[":couch_and_lamp:"],"category":"objects"},":couple:":{"uc_base":"1f46b","uc_output":"1f46b","uc_match":"1f46b","uc_greedy":"1f46b","shortnames":[],"category":"people"},":couple_with_heart:":{"uc_base":"1f491","uc_output":"1f491","uc_match":"1f491","uc_greedy":"1f491","shortnames":[],"category":"people"},":couplekiss:":{"uc_base":"1f48f","uc_output":"1f48f","uc_match":"1f48f","uc_greedy":"1f48f","shortnames":[],"category":"people"},":cow2:":{"uc_base":"1f404","uc_output":"1f404","uc_match":"1f404","uc_greedy":"1f404","shortnames":[],"category":"nature"},":cow:":{"uc_base":"1f42e","uc_output":"1f42e","uc_match":"1f42e","uc_greedy":"1f42e","shortnames":[],"category":"nature"},":cowboy:":{"uc_base":"1f920","uc_output":"1f920","uc_match":"1f920","uc_greedy":"1f920","shortnames":[":face_with_cowboy_hat:"],"category":"people"},":crab:":{"uc_base":"1f980","uc_output":"1f980","uc_match":"1f980","uc_greedy":"1f980","shortnames":[],"category":"nature"},":crayon:":{"uc_base":"1f58d","uc_output":"1f58d","uc_match":"1f58d-fe0f","uc_greedy":"1f58d-fe0f","shortnames":[":lower_left_crayon:"],"category":"objects"},":credit_card:":{"uc_base":"1f4b3","uc_output":"1f4b3","uc_match":"1f4b3-fe0f","uc_greedy":"1f4b3-fe0f","shortnames":[],"category":"objects"},":crescent_moon:":{"uc_base":"1f319","uc_output":"1f319","uc_match":"1f319","uc_greedy":"1f319","shortnames":[],"category":"nature"},":cricket:":{"uc_base":"1f997","uc_output":"1f997","uc_match":"1f997","uc_greedy":"1f997","shortnames":[],"category":"nature"},":cricket_game:":{"uc_base":"1f3cf","uc_output":"1f3cf","uc_match":"1f3cf","uc_greedy":"1f3cf","shortnames":[":cricket_bat_ball:"],"category":"activity"},":crocodile:":{"uc_base":"1f40a","uc_output":"1f40a","uc_match":"1f40a","uc_greedy":"1f40a","shortnames":[],"category":"nature"},":croissant:":{"uc_base":"1f950","uc_output":"1f950","uc_match":"1f950","uc_greedy":"1f950","shortnames":[],"category":"food"},":crossed_flags:":{"uc_base":"1f38c","uc_output":"1f38c","uc_match":"1f38c","uc_greedy":"1f38c","shortnames":[],"category":"flags"},":crown:":{"uc_base":"1f451","uc_output":"1f451","uc_match":"1f451","uc_greedy":"1f451","shortnames":[],"category":"people"},":cruise_ship:":{"uc_base":"1f6f3","uc_output":"1f6f3","uc_match":"1f6f3-fe0f","uc_greedy":"1f6f3-fe0f","shortnames":[":passenger_ship:"],"category":"travel"},":cry:":{"uc_base":"1f622","uc_output":"1f622","uc_match":"1f622","uc_greedy":"1f622","shortnames":[],"category":"people"},":crying_cat_face:":{"uc_base":"1f63f","uc_output":"1f63f","uc_match":"1f63f","uc_greedy":"1f63f","shortnames":[],"category":"people"},":crystal_ball:":{"uc_base":"1f52e","uc_output":"1f52e","uc_match":"1f52e","uc_greedy":"1f52e","shortnames":[],"category":"objects"},":cucumber:":{"uc_base":"1f952","uc_output":"1f952","uc_match":"1f952","uc_greedy":"1f952","shortnames":[],"category":"food"},":cup_with_straw:":{"uc_base":"1f964","uc_output":"1f964","uc_match":"1f964","uc_greedy":"1f964","shortnames":[],"category":"food"},":cupcake:":{"uc_base":"1f9c1","uc_output":"1f9c1","uc_match":"1f9c1","uc_greedy":"1f9c1","shortnames":[],"category":"food"},":cupid:":{"uc_base":"1f498","uc_output":"1f498","uc_match":"1f498","uc_greedy":"1f498","shortnames":[],"category":"symbols"},":curling_stone:":{"uc_base":"1f94c","uc_output":"1f94c","uc_match":"1f94c","uc_greedy":"1f94c","shortnames":[],"category":"activity"},":curly_haired:":{"uc_base":"1f9b1","uc_output":"1f9b1","uc_match":"1f9b1","uc_greedy":"1f9b1","shortnames":[],"category":"people"},":currency_exchange:":{"uc_base":"1f4b1","uc_output":"1f4b1","uc_match":"1f4b1","uc_greedy":"1f4b1","shortnames":[],"category":"symbols"},":curry:":{"uc_base":"1f35b","uc_output":"1f35b","uc_match":"1f35b","uc_greedy":"1f35b","shortnames":[],"category":"food"},":custard:":{"uc_base":"1f36e","uc_output":"1f36e","uc_match":"1f36e","uc_greedy":"1f36e","shortnames":[":pudding:",":flan:"],"category":"food"},":customs:":{"uc_base":"1f6c3","uc_output":"1f6c3","uc_match":"1f6c3","uc_greedy":"1f6c3","shortnames":[],"category":"symbols"},":cut_of_meat:":{"uc_base":"1f969","uc_output":"1f969","uc_match":"1f969","uc_greedy":"1f969","shortnames":[],"category":"food"},":cyclone:":{"uc_base":"1f300","uc_output":"1f300","uc_match":"1f300","uc_greedy":"1f300","shortnames":[],"category":"symbols"},":dagger:":{"uc_base":"1f5e1","uc_output":"1f5e1","uc_match":"1f5e1-fe0f","uc_greedy":"1f5e1-fe0f","shortnames":[":dagger_knife:"],"category":"objects"},":dancer:":{"uc_base":"1f483","uc_output":"1f483","uc_match":"1f483","uc_greedy":"1f483","shortnames":[],"category":"people"},":dango:":{"uc_base":"1f361","uc_output":"1f361","uc_match":"1f361","uc_greedy":"1f361","shortnames":[],"category":"food"},":dark_sunglasses:":{"uc_base":"1f576","uc_output":"1f576","uc_match":"1f576-fe0f","uc_greedy":"1f576-fe0f","shortnames":[],"category":"people"},":dart:":{"uc_base":"1f3af","uc_output":"1f3af","uc_match":"1f3af","uc_greedy":"1f3af","shortnames":[],"category":"activity"},":dash:":{"uc_base":"1f4a8","uc_output":"1f4a8","uc_match":"1f4a8","uc_greedy":"1f4a8","shortnames":[],"category":"nature"},":date:":{"uc_base":"1f4c5","uc_output":"1f4c5","uc_match":"1f4c5","uc_greedy":"1f4c5","shortnames":[],"category":"objects"},":deciduous_tree:":{"uc_base":"1f333","uc_output":"1f333","uc_match":"1f333","uc_greedy":"1f333","shortnames":[],"category":"nature"},":deer:":{"uc_base":"1f98c","uc_output":"1f98c","uc_match":"1f98c","uc_greedy":"1f98c","shortnames":[],"category":"nature"},":department_store:":{"uc_base":"1f3ec","uc_output":"1f3ec","uc_match":"1f3ec","uc_greedy":"1f3ec","shortnames":[],"category":"travel"},":desert:":{"uc_base":"1f3dc","uc_output":"1f3dc","uc_match":"1f3dc-fe0f","uc_greedy":"1f3dc-fe0f","shortnames":[],"category":"travel"},":desktop:":{"uc_base":"1f5a5","uc_output":"1f5a5","uc_match":"1f5a5-fe0f","uc_greedy":"1f5a5-fe0f","shortnames":[":desktop_computer:"],"category":"objects"},":detective:":{"uc_base":"1f575","uc_output":"1f575","uc_match":"1f575-fe0f","uc_greedy":"1f575-fe0f","shortnames":[":spy:",":sleuth_or_spy:"],"category":"people"},":diamond_shape_with_a_dot_inside:":{"uc_base":"1f4a0","uc_output":"1f4a0","uc_match":"1f4a0","uc_greedy":"1f4a0","shortnames":[],"category":"symbols"},":disappointed:":{"uc_base":"1f61e","uc_output":"1f61e","uc_match":"1f61e","uc_greedy":"1f61e","shortnames":[],"category":"people"},":disappointed_relieved:":{"uc_base":"1f625","uc_output":"1f625","uc_match":"1f625","uc_greedy":"1f625","shortnames":[],"category":"people"},":dividers:":{"uc_base":"1f5c2","uc_output":"1f5c2","uc_match":"1f5c2-fe0f","uc_greedy":"1f5c2-fe0f","shortnames":[":card_index_dividers:"],"category":"objects"},":dizzy:":{"uc_base":"1f4ab","uc_output":"1f4ab","uc_match":"1f4ab","uc_greedy":"1f4ab","shortnames":[],"category":"nature"},":dizzy_face:":{"uc_base":"1f635","uc_output":"1f635","uc_match":"1f635","uc_greedy":"1f635","shortnames":[],"category":"people"},":dna:":{"uc_base":"1f9ec","uc_output":"1f9ec","uc_match":"1f9ec","uc_greedy":"1f9ec","shortnames":[],"category":"objects"},":do_not_litter:":{"uc_base":"1f6af","uc_output":"1f6af","uc_match":"1f6af","uc_greedy":"1f6af","shortnames":[],"category":"symbols"},":dog2:":{"uc_base":"1f415","uc_output":"1f415","uc_match":"1f415-fe0f","uc_greedy":"1f415-fe0f","shortnames":[],"category":"nature"},":dog:":{"uc_base":"1f436","uc_output":"1f436","uc_match":"1f436","uc_greedy":"1f436","shortnames":[],"category":"nature"},":dollar:":{"uc_base":"1f4b5","uc_output":"1f4b5","uc_match":"1f4b5","uc_greedy":"1f4b5","shortnames":[],"category":"objects"},":dolls:":{"uc_base":"1f38e","uc_output":"1f38e","uc_match":"1f38e","uc_greedy":"1f38e","shortnames":[],"category":"objects"},":dolphin:":{"uc_base":"1f42c","uc_output":"1f42c","uc_match":"1f42c","uc_greedy":"1f42c","shortnames":[],"category":"nature"},":door:":{"uc_base":"1f6aa","uc_output":"1f6aa","uc_match":"1f6aa","uc_greedy":"1f6aa","shortnames":[],"category":"objects"},":doughnut:":{"uc_base":"1f369","uc_output":"1f369","uc_match":"1f369","uc_greedy":"1f369","shortnames":[],"category":"food"},":dove:":{"uc_base":"1f54a","uc_output":"1f54a","uc_match":"1f54a-fe0f","uc_greedy":"1f54a-fe0f","shortnames":[":dove_of_peace:"],"category":"nature"},":dragon:":{"uc_base":"1f409","uc_output":"1f409","uc_match":"1f409","uc_greedy":"1f409","shortnames":[],"category":"nature"},":dragon_face:":{"uc_base":"1f432","uc_output":"1f432","uc_match":"1f432","uc_greedy":"1f432","shortnames":[],"category":"nature"},":dress:":{"uc_base":"1f457","uc_output":"1f457","uc_match":"1f457","uc_greedy":"1f457","shortnames":[],"category":"people"},":dromedary_camel:":{"uc_base":"1f42a","uc_output":"1f42a","uc_match":"1f42a","uc_greedy":"1f42a","shortnames":[],"category":"nature"},":drooling_face:":{"uc_base":"1f924","uc_output":"1f924","uc_match":"1f924","uc_greedy":"1f924","shortnames":[":drool:"],"category":"people"},":droplet:":{"uc_base":"1f4a7","uc_output":"1f4a7","uc_match":"1f4a7","uc_greedy":"1f4a7","shortnames":[],"category":"nature"},":drum:":{"uc_base":"1f941","uc_output":"1f941","uc_match":"1f941","uc_greedy":"1f941","shortnames":[":drum_with_drumsticks:"],"category":"activity"},":duck:":{"uc_base":"1f986","uc_output":"1f986","uc_match":"1f986","uc_greedy":"1f986","shortnames":[],"category":"nature"},":dumpling:":{"uc_base":"1f95f","uc_output":"1f95f","uc_match":"1f95f","uc_greedy":"1f95f","shortnames":[],"category":"food"},":dvd:":{"uc_base":"1f4c0","uc_output":"1f4c0","uc_match":"1f4c0","uc_greedy":"1f4c0","shortnames":[],"category":"objects"},":e-mail:":{"uc_base":"1f4e7","uc_output":"1f4e7","uc_match":"1f4e7","uc_greedy":"1f4e7","shortnames":[":email:"],"category":"objects"},":eagle:":{"uc_base":"1f985","uc_output":"1f985","uc_match":"1f985","uc_greedy":"1f985","shortnames":[],"category":"nature"},":ear:":{"uc_base":"1f442","uc_output":"1f442","uc_match":"1f442-fe0f","uc_greedy":"1f442-fe0f","shortnames":[],"category":"people"},":ear_of_rice:":{"uc_base":"1f33e","uc_output":"1f33e","uc_match":"1f33e","uc_greedy":"1f33e","shortnames":[],"category":"nature"},":earth_africa:":{"uc_base":"1f30d","uc_output":"1f30d","uc_match":"1f30d-fe0f","uc_greedy":"1f30d-fe0f","shortnames":[],"category":"nature"},":earth_americas:":{"uc_base":"1f30e","uc_output":"1f30e","uc_match":"1f30e-fe0f","uc_greedy":"1f30e-fe0f","shortnames":[],"category":"nature"},":earth_asia:":{"uc_base":"1f30f","uc_output":"1f30f","uc_match":"1f30f-fe0f","uc_greedy":"1f30f-fe0f","shortnames":[],"category":"nature"},":egg:":{"uc_base":"1f95a","uc_output":"1f95a","uc_match":"1f95a","uc_greedy":"1f95a","shortnames":[],"category":"food"},":eggplant:":{"uc_base":"1f346","uc_output":"1f346","uc_match":"1f346","uc_greedy":"1f346","shortnames":[],"category":"food"},":electric_plug:":{"uc_base":"1f50c","uc_output":"1f50c","uc_match":"1f50c","uc_greedy":"1f50c","shortnames":[],"category":"objects"},":elephant:":{"uc_base":"1f418","uc_output":"1f418","uc_match":"1f418","uc_greedy":"1f418","shortnames":[],"category":"nature"},":elf:":{"uc_base":"1f9dd","uc_output":"1f9dd","uc_match":"1f9dd","uc_greedy":"1f9dd","shortnames":[],"category":"people"},":end:":{"uc_base":"1f51a","uc_output":"1f51a","uc_match":"1f51a","uc_greedy":"1f51a","shortnames":[],"category":"symbols"},":envelope_with_arrow:":{"uc_base":"1f4e9","uc_output":"1f4e9","uc_match":"1f4e9","uc_greedy":"1f4e9","shortnames":[],"category":"objects"},":euro:":{"uc_base":"1f4b6","uc_output":"1f4b6","uc_match":"1f4b6","uc_greedy":"1f4b6","shortnames":[],"category":"objects"},":european_castle:":{"uc_base":"1f3f0","uc_output":"1f3f0","uc_match":"1f3f0","uc_greedy":"1f3f0","shortnames":[],"category":"travel"},":european_post_office:":{"uc_base":"1f3e4","uc_output":"1f3e4","uc_match":"1f3e4","uc_greedy":"1f3e4","shortnames":[],"category":"travel"},":evergreen_tree:":{"uc_base":"1f332","uc_output":"1f332","uc_match":"1f332","uc_greedy":"1f332","shortnames":[],"category":"nature"},":exploding_head:":{"uc_base":"1f92f","uc_output":"1f92f","uc_match":"1f92f","uc_greedy":"1f92f","shortnames":[],"category":"people"},":expressionless:":{"uc_base":"1f611","uc_output":"1f611","uc_match":"1f611","uc_greedy":"1f611","shortnames":[],"category":"people"},":eye:":{"uc_base":"1f441","uc_output":"1f441","uc_match":"1f441-fe0f","uc_greedy":"1f441-fe0f","shortnames":[],"category":"people"},":eyeglasses:":{"uc_base":"1f453","uc_output":"1f453","uc_match":"1f453-fe0f","uc_greedy":"1f453-fe0f","shortnames":[],"category":"people"},":eyes:":{"uc_base":"1f440","uc_output":"1f440","uc_match":"1f440","uc_greedy":"1f440","shortnames":[],"category":"people"},":face_vomiting:":{"uc_base":"1f92e","uc_output":"1f92e","uc_match":"1f92e","uc_greedy":"1f92e","shortnames":[],"category":"people"},":face_with_hand_over_mouth:":{"uc_base":"1f92d","uc_output":"1f92d","uc_match":"1f92d","uc_greedy":"1f92d","shortnames":[],"category":"people"},":face_with_monocle:":{"uc_base":"1f9d0","uc_output":"1f9d0","uc_match":"1f9d0","uc_greedy":"1f9d0","shortnames":[],"category":"people"},":face_with_raised_eyebrow:":{"uc_base":"1f928","uc_output":"1f928","uc_match":"1f928","uc_greedy":"1f928","shortnames":[],"category":"people"},":face_with_symbols_over_mouth:":{"uc_base":"1f92c","uc_output":"1f92c","uc_match":"1f92c","uc_greedy":"1f92c","shortnames":[],"category":"people"},":factory:":{"uc_base":"1f3ed","uc_output":"1f3ed","uc_match":"1f3ed-fe0f","uc_greedy":"1f3ed-fe0f","shortnames":[],"category":"travel"},":fairy:":{"uc_base":"1f9da","uc_output":"1f9da","uc_match":"1f9da","uc_greedy":"1f9da","shortnames":[],"category":"people"},":fallen_leaf:":{"uc_base":"1f342","uc_output":"1f342","uc_match":"1f342","uc_greedy":"1f342","shortnames":[],"category":"nature"},":family:":{"uc_base":"1f46a","uc_output":"1f46a","uc_match":"1f46a-fe0f","uc_greedy":"1f46a-fe0f","shortnames":[],"category":"people"},":fax:":{"uc_base":"1f4e0","uc_output":"1f4e0","uc_match":"1f4e0","uc_greedy":"1f4e0","shortnames":[],"category":"objects"},":fearful:":{"uc_base":"1f628","uc_output":"1f628","uc_match":"1f628","uc_greedy":"1f628","shortnames":[],"category":"people"},":feet:":{"uc_base":"1f43e","uc_output":"1f43e","uc_match":"1f43e","uc_greedy":"1f43e","shortnames":[":paw_prints:"],"category":"nature"},":ferris_wheel:":{"uc_base":"1f3a1","uc_output":"1f3a1","uc_match":"1f3a1","uc_greedy":"1f3a1","shortnames":[],"category":"travel"},":field_hockey:":{"uc_base":"1f3d1","uc_output":"1f3d1","uc_match":"1f3d1","uc_greedy":"1f3d1","shortnames":[],"category":"activity"},":file_cabinet:":{"uc_base":"1f5c4","uc_output":"1f5c4","uc_match":"1f5c4-fe0f","uc_greedy":"1f5c4-fe0f","shortnames":[],"category":"objects"},":file_folder:":{"uc_base":"1f4c1","uc_output":"1f4c1","uc_match":"1f4c1","uc_greedy":"1f4c1","shortnames":[],"category":"objects"},":film_frames:":{"uc_base":"1f39e","uc_output":"1f39e","uc_match":"1f39e-fe0f","uc_greedy":"1f39e-fe0f","shortnames":[],"category":"objects"},":fingers_crossed:":{"uc_base":"1f91e","uc_output":"1f91e","uc_match":"1f91e","uc_greedy":"1f91e","shortnames":[":hand_with_index_and_middle_finger_crossed:"],"category":"people"},":fire:":{"uc_base":"1f525","uc_output":"1f525","uc_match":"1f525","uc_greedy":"1f525","shortnames":[":flame:"],"category":"nature"},":fire_engine:":{"uc_base":"1f692","uc_output":"1f692","uc_match":"1f692","uc_greedy":"1f692","shortnames":[],"category":"travel"},":fire_extinguisher:":{"uc_base":"1f9ef","uc_output":"1f9ef","uc_match":"1f9ef","uc_greedy":"1f9ef","shortnames":[],"category":"objects"},":firecracker:":{"uc_base":"1f9e8","uc_output":"1f9e8","uc_match":"1f9e8","uc_greedy":"1f9e8","shortnames":[],"category":"travel"},":fireworks:":{"uc_base":"1f386","uc_output":"1f386","uc_match":"1f386","uc_greedy":"1f386","shortnames":[],"category":"travel"},":first_place:":{"uc_base":"1f947","uc_output":"1f947","uc_match":"1f947","uc_greedy":"1f947","shortnames":[":first_place_medal:"],"category":"activity"},":first_quarter_moon:":{"uc_base":"1f313","uc_output":"1f313","uc_match":"1f313","uc_greedy":"1f313","shortnames":[],"category":"nature"},":first_quarter_moon_with_face:":{"uc_base":"1f31b","uc_output":"1f31b","uc_match":"1f31b","uc_greedy":"1f31b","shortnames":[],"category":"nature"},":fish:":{"uc_base":"1f41f","uc_output":"1f41f","uc_match":"1f41f-fe0f","uc_greedy":"1f41f-fe0f","shortnames":[],"category":"nature"},":fish_cake:":{"uc_base":"1f365","uc_output":"1f365","uc_match":"1f365","uc_greedy":"1f365","shortnames":[],"category":"food"},":fishing_pole_and_fish:":{"uc_base":"1f3a3","uc_output":"1f3a3","uc_match":"1f3a3","uc_greedy":"1f3a3","shortnames":[],"category":"activity"},":flag_black:":{"uc_base":"1f3f4","uc_output":"1f3f4","uc_match":"1f3f4","uc_greedy":"1f3f4","shortnames":[":waving_black_flag:"],"category":"flags"},":flag_white:":{"uc_base":"1f3f3","uc_output":"1f3f3","uc_match":"1f3f3-fe0f","uc_greedy":"1f3f3-fe0f","shortnames":[":waving_white_flag:"],"category":"flags"},":flags:":{"uc_base":"1f38f","uc_output":"1f38f","uc_match":"1f38f","uc_greedy":"1f38f","shortnames":[],"category":"objects"},":flashlight:":{"uc_base":"1f526","uc_output":"1f526","uc_match":"1f526","uc_greedy":"1f526","shortnames":[],"category":"objects"},":floppy_disk:":{"uc_base":"1f4be","uc_output":"1f4be","uc_match":"1f4be","uc_greedy":"1f4be","shortnames":[],"category":"objects"},":flower_playing_cards:":{"uc_base":"1f3b4","uc_output":"1f3b4","uc_match":"1f3b4","uc_greedy":"1f3b4","shortnames":[],"category":"symbols"},":flushed:":{"uc_base":"1f633","uc_output":"1f633","uc_match":"1f633","uc_greedy":"1f633","shortnames":[],"category":"people"},":flying_disc:":{"uc_base":"1f94f","uc_output":"1f94f","uc_match":"1f94f","uc_greedy":"1f94f","shortnames":[],"category":"activity"},":flying_saucer:":{"uc_base":"1f6f8","uc_output":"1f6f8","uc_match":"1f6f8","uc_greedy":"1f6f8","shortnames":[],"category":"travel"},":fog:":{"uc_base":"1f32b","uc_output":"1f32b","uc_match":"1f32b-fe0f","uc_greedy":"1f32b-fe0f","shortnames":[],"category":"nature"},":foggy:":{"uc_base":"1f301","uc_output":"1f301","uc_match":"1f301","uc_greedy":"1f301","shortnames":[],"category":"travel"},":foot:":{"uc_base":"1f9b6","uc_output":"1f9b6","uc_match":"1f9b6","uc_greedy":"1f9b6","shortnames":[],"category":"people"},":football:":{"uc_base":"1f3c8","uc_output":"1f3c8","uc_match":"1f3c8","uc_greedy":"1f3c8","shortnames":[],"category":"activity"},":footprints:":{"uc_base":"1f463","uc_output":"1f463","uc_match":"1f463","uc_greedy":"1f463","shortnames":[],"category":"people"},":fork_and_knife:":{"uc_base":"1f374","uc_output":"1f374","uc_match":"1f374","uc_greedy":"1f374","shortnames":[],"category":"food"},":fork_knife_plate:":{"uc_base":"1f37d","uc_output":"1f37d","uc_match":"1f37d-fe0f","uc_greedy":"1f37d-fe0f","shortnames":[":fork_and_knife_with_plate:"],"category":"food"},":fortune_cookie:":{"uc_base":"1f960","uc_output":"1f960","uc_match":"1f960","uc_greedy":"1f960","shortnames":[],"category":"food"},":four_leaf_clover:":{"uc_base":"1f340","uc_output":"1f340","uc_match":"1f340","uc_greedy":"1f340","shortnames":[],"category":"nature"},":fox:":{"uc_base":"1f98a","uc_output":"1f98a","uc_match":"1f98a","uc_greedy":"1f98a","shortnames":[":fox_face:"],"category":"nature"},":frame_photo:":{"uc_base":"1f5bc","uc_output":"1f5bc","uc_match":"1f5bc-fe0f","uc_greedy":"1f5bc-fe0f","shortnames":[":frame_with_picture:"],"category":"objects"},":free:":{"uc_base":"1f193","uc_output":"1f193","uc_match":"1f193","uc_greedy":"1f193","shortnames":[],"category":"symbols"},":french_bread:":{"uc_base":"1f956","uc_output":"1f956","uc_match":"1f956","uc_greedy":"1f956","shortnames":[":baguette_bread:"],"category":"food"},":fried_shrimp:":{"uc_base":"1f364","uc_output":"1f364","uc_match":"1f364","uc_greedy":"1f364","shortnames":[],"category":"food"},":fries:":{"uc_base":"1f35f","uc_output":"1f35f","uc_match":"1f35f","uc_greedy":"1f35f","shortnames":[],"category":"food"},":frog:":{"uc_base":"1f438","uc_output":"1f438","uc_match":"1f438","uc_greedy":"1f438","shortnames":[],"category":"nature"},":frowning:":{"uc_base":"1f626","uc_output":"1f626","uc_match":"1f626","uc_greedy":"1f626","shortnames":[],"category":"people"},":full_moon:":{"uc_base":"1f315","uc_output":"1f315","uc_match":"1f315-fe0f","uc_greedy":"1f315-fe0f","shortnames":[],"category":"nature"},":full_moon_with_face:":{"uc_base":"1f31d","uc_output":"1f31d","uc_match":"1f31d","uc_greedy":"1f31d","shortnames":[],"category":"nature"},":game_die:":{"uc_base":"1f3b2","uc_output":"1f3b2","uc_match":"1f3b2","uc_greedy":"1f3b2","shortnames":[],"category":"activity"},":gem:":{"uc_base":"1f48e","uc_output":"1f48e","uc_match":"1f48e","uc_greedy":"1f48e","shortnames":[],"category":"objects"},":genie:":{"uc_base":"1f9de","uc_output":"1f9de","uc_match":"1f9de","uc_greedy":"1f9de","shortnames":[],"category":"people"},":ghost:":{"uc_base":"1f47b","uc_output":"1f47b","uc_match":"1f47b","uc_greedy":"1f47b","shortnames":[],"category":"people"},":gift:":{"uc_base":"1f381","uc_output":"1f381","uc_match":"1f381","uc_greedy":"1f381","shortnames":[],"category":"objects"},":gift_heart:":{"uc_base":"1f49d","uc_output":"1f49d","uc_match":"1f49d","uc_greedy":"1f49d","shortnames":[],"category":"symbols"},":giraffe:":{"uc_base":"1f992","uc_output":"1f992","uc_match":"1f992","uc_greedy":"1f992","shortnames":[],"category":"nature"},":girl:":{"uc_base":"1f467","uc_output":"1f467","uc_match":"1f467","uc_greedy":"1f467","shortnames":[],"category":"people"},":globe_with_meridians:":{"uc_base":"1f310","uc_output":"1f310","uc_match":"1f310","uc_greedy":"1f310","shortnames":[],"category":"symbols"},":gloves:":{"uc_base":"1f9e4","uc_output":"1f9e4","uc_match":"1f9e4","uc_greedy":"1f9e4","shortnames":[],"category":"people"},":goal:":{"uc_base":"1f945","uc_output":"1f945","uc_match":"1f945","uc_greedy":"1f945","shortnames":[":goal_net:"],"category":"activity"},":goat:":{"uc_base":"1f410","uc_output":"1f410","uc_match":"1f410","uc_greedy":"1f410","shortnames":[],"category":"nature"},":goggles:":{"uc_base":"1f97d","uc_output":"1f97d","uc_match":"1f97d","uc_greedy":"1f97d","shortnames":[],"category":"people"},":gorilla:":{"uc_base":"1f98d","uc_output":"1f98d","uc_match":"1f98d","uc_greedy":"1f98d","shortnames":[],"category":"nature"},":grapes:":{"uc_base":"1f347","uc_output":"1f347","uc_match":"1f347","uc_greedy":"1f347","shortnames":[],"category":"food"},":green_apple:":{"uc_base":"1f34f","uc_output":"1f34f","uc_match":"1f34f","uc_greedy":"1f34f","shortnames":[],"category":"food"},":green_book:":{"uc_base":"1f4d7","uc_output":"1f4d7","uc_match":"1f4d7","uc_greedy":"1f4d7","shortnames":[],"category":"objects"},":green_heart:":{"uc_base":"1f49a","uc_output":"1f49a","uc_match":"1f49a","uc_greedy":"1f49a","shortnames":[],"category":"symbols"},":grimacing:":{"uc_base":"1f62c","uc_output":"1f62c","uc_match":"1f62c","uc_greedy":"1f62c","shortnames":[],"category":"people"},":grin:":{"uc_base":"1f601","uc_output":"1f601","uc_match":"1f601","uc_greedy":"1f601","shortnames":[],"category":"people"},":grinning:":{"uc_base":"1f600","uc_output":"1f600","uc_match":"1f600","uc_greedy":"1f600","shortnames":[],"category":"people"},":guard:":{"uc_base":"1f482","uc_output":"1f482","uc_match":"1f482","uc_greedy":"1f482","shortnames":[":guardsman:"],"category":"people"},":guitar:":{"uc_base":"1f3b8","uc_output":"1f3b8","uc_match":"1f3b8","uc_greedy":"1f3b8","shortnames":[],"category":"activity"},":gun:":{"uc_base":"1f52b","uc_output":"1f52b","uc_match":"1f52b","uc_greedy":"1f52b","shortnames":[],"category":"objects"},":hamburger:":{"uc_base":"1f354","uc_output":"1f354","uc_match":"1f354","uc_greedy":"1f354","shortnames":[],"category":"food"},":hammer:":{"uc_base":"1f528","uc_output":"1f528","uc_match":"1f528","uc_greedy":"1f528","shortnames":[],"category":"objects"},":hamster:":{"uc_base":"1f439","uc_output":"1f439","uc_match":"1f439","uc_greedy":"1f439","shortnames":[],"category":"nature"},":hand_splayed:":{"uc_base":"1f590","uc_output":"1f590","uc_match":"1f590-fe0f","uc_greedy":"1f590-fe0f","shortnames":[":raised_hand_with_fingers_splayed:"],"category":"people"},":handbag:":{"uc_base":"1f45c","uc_output":"1f45c","uc_match":"1f45c","uc_greedy":"1f45c","shortnames":[],"category":"people"},":handshake:":{"uc_base":"1f91d","uc_output":"1f91d","uc_match":"1f91d","uc_greedy":"1f91d","shortnames":[":shaking_hands:"],"category":"people"},":hatched_chick:":{"uc_base":"1f425","uc_output":"1f425","uc_match":"1f425","uc_greedy":"1f425","shortnames":[],"category":"nature"},":hatching_chick:":{"uc_base":"1f423","uc_output":"1f423","uc_match":"1f423","uc_greedy":"1f423","shortnames":[],"category":"nature"},":head_bandage:":{"uc_base":"1f915","uc_output":"1f915","uc_match":"1f915","uc_greedy":"1f915","shortnames":[":face_with_head_bandage:"],"category":"people"},":headphones:":{"uc_base":"1f3a7","uc_output":"1f3a7","uc_match":"1f3a7-fe0f","uc_greedy":"1f3a7-fe0f","shortnames":[],"category":"activity"},":hear_no_evil:":{"uc_base":"1f649","uc_output":"1f649","uc_match":"1f649","uc_greedy":"1f649","shortnames":[],"category":"nature"},":heart_decoration:":{"uc_base":"1f49f","uc_output":"1f49f","uc_match":"1f49f","uc_greedy":"1f49f","shortnames":[],"category":"symbols"},":heart_eyes:":{"uc_base":"1f60d","uc_output":"1f60d","uc_match":"1f60d","uc_greedy":"1f60d","shortnames":[],"category":"people"},":heart_eyes_cat:":{"uc_base":"1f63b","uc_output":"1f63b","uc_match":"1f63b","uc_greedy":"1f63b","shortnames":[],"category":"people"},":heartbeat:":{"uc_base":"1f493","uc_output":"1f493","uc_match":"1f493","uc_greedy":"1f493","shortnames":[],"category":"symbols"},":heartpulse:":{"uc_base":"1f497","uc_output":"1f497","uc_match":"1f497","uc_greedy":"1f497","shortnames":[],"category":"symbols"},":heavy_dollar_sign:":{"uc_base":"1f4b2","uc_output":"1f4b2","uc_match":"1f4b2","uc_greedy":"1f4b2","shortnames":[],"category":"symbols"},":hedgehog:":{"uc_base":"1f994","uc_output":"1f994","uc_match":"1f994","uc_greedy":"1f994","shortnames":[],"category":"nature"},":helicopter:":{"uc_base":"1f681","uc_output":"1f681","uc_match":"1f681","uc_greedy":"1f681","shortnames":[],"category":"travel"},":herb:":{"uc_base":"1f33f","uc_output":"1f33f","uc_match":"1f33f","uc_greedy":"1f33f","shortnames":[],"category":"nature"},":hibiscus:":{"uc_base":"1f33a","uc_output":"1f33a","uc_match":"1f33a","uc_greedy":"1f33a","shortnames":[],"category":"nature"},":high_brightness:":{"uc_base":"1f506","uc_output":"1f506","uc_match":"1f506","uc_greedy":"1f506","shortnames":[],"category":"symbols"},":high_heel:":{"uc_base":"1f460","uc_output":"1f460","uc_match":"1f460","uc_greedy":"1f460","shortnames":[],"category":"people"},":hiking_boot:":{"uc_base":"1f97e","uc_output":"1f97e","uc_match":"1f97e","uc_greedy":"1f97e","shortnames":[],"category":"people"},":hippopotamus:":{"uc_base":"1f99b","uc_output":"1f99b","uc_match":"1f99b","uc_greedy":"1f99b","shortnames":[],"category":"nature"},":hockey:":{"uc_base":"1f3d2","uc_output":"1f3d2","uc_match":"1f3d2","uc_greedy":"1f3d2","shortnames":[],"category":"activity"},":hole:":{"uc_base":"1f573","uc_output":"1f573","uc_match":"1f573-fe0f","uc_greedy":"1f573-fe0f","shortnames":[],"category":"objects"},":homes:":{"uc_base":"1f3d8","uc_output":"1f3d8","uc_match":"1f3d8-fe0f","uc_greedy":"1f3d8-fe0f","shortnames":[":house_buildings:"],"category":"travel"},":honey_pot:":{"uc_base":"1f36f","uc_output":"1f36f","uc_match":"1f36f","uc_greedy":"1f36f","shortnames":[],"category":"food"},":horse:":{"uc_base":"1f434","uc_output":"1f434","uc_match":"1f434","uc_greedy":"1f434","shortnames":[],"category":"nature"},":horse_racing:":{"uc_base":"1f3c7","uc_output":"1f3c7","uc_match":"1f3c7","uc_greedy":"1f3c7","shortnames":[],"category":"activity"},":hospital:":{"uc_base":"1f3e5","uc_output":"1f3e5","uc_match":"1f3e5","uc_greedy":"1f3e5","shortnames":[],"category":"travel"},":hot_face:":{"uc_base":"1f975","uc_output":"1f975","uc_match":"1f975","uc_greedy":"1f975","shortnames":[],"category":"people"},":hot_pepper:":{"uc_base":"1f336","uc_output":"1f336","uc_match":"1f336-fe0f","uc_greedy":"1f336-fe0f","shortnames":[],"category":"food"},":hotdog:":{"uc_base":"1f32d","uc_output":"1f32d","uc_match":"1f32d","uc_greedy":"1f32d","shortnames":[":hot_dog:"],"category":"food"},":hotel:":{"uc_base":"1f3e8","uc_output":"1f3e8","uc_match":"1f3e8","uc_greedy":"1f3e8","shortnames":[],"category":"travel"},":house:":{"uc_base":"1f3e0","uc_output":"1f3e0","uc_match":"1f3e0-fe0f","uc_greedy":"1f3e0-fe0f","shortnames":[],"category":"travel"},":house_abandoned:":{"uc_base":"1f3da","uc_output":"1f3da","uc_match":"1f3da-fe0f","uc_greedy":"1f3da-fe0f","shortnames":[":derelict_house_building:"],"category":"travel"},":house_with_garden:":{"uc_base":"1f3e1","uc_output":"1f3e1","uc_match":"1f3e1","uc_greedy":"1f3e1","shortnames":[],"category":"travel"},":hugging:":{"uc_base":"1f917","uc_output":"1f917","uc_match":"1f917","uc_greedy":"1f917","shortnames":[":hugging_face:"],"category":"people"},":hushed:":{"uc_base":"1f62f","uc_output":"1f62f","uc_match":"1f62f","uc_greedy":"1f62f","shortnames":[],"category":"people"},":ice_cream:":{"uc_base":"1f368","uc_output":"1f368","uc_match":"1f368","uc_greedy":"1f368","shortnames":[],"category":"food"},":icecream:":{"uc_base":"1f366","uc_output":"1f366","uc_match":"1f366","uc_greedy":"1f366","shortnames":[],"category":"food"},":id:":{"uc_base":"1f194","uc_output":"1f194","uc_match":"1f194","uc_greedy":"1f194","shortnames":[],"category":"symbols"},":ideograph_advantage:":{"uc_base":"1f250","uc_output":"1f250","uc_match":"1f250","uc_greedy":"1f250","shortnames":[],"category":"symbols"},":imp:":{"uc_base":"1f47f","uc_output":"1f47f","uc_match":"1f47f","uc_greedy":"1f47f","shortnames":[],"category":"people"},":inbox_tray:":{"uc_base":"1f4e5","uc_output":"1f4e5","uc_match":"1f4e5-fe0f","uc_greedy":"1f4e5-fe0f","shortnames":[],"category":"objects"},":incoming_envelope:":{"uc_base":"1f4e8","uc_output":"1f4e8","uc_match":"1f4e8","uc_greedy":"1f4e8","shortnames":[],"category":"objects"},":innocent:":{"uc_base":"1f607","uc_output":"1f607","uc_match":"1f607","uc_greedy":"1f607","shortnames":[],"category":"people"},":iphone:":{"uc_base":"1f4f1","uc_output":"1f4f1","uc_match":"1f4f1","uc_greedy":"1f4f1","shortnames":[],"category":"objects"},":island:":{"uc_base":"1f3dd","uc_output":"1f3dd","uc_match":"1f3dd-fe0f","uc_greedy":"1f3dd-fe0f","shortnames":[":desert_island:"],"category":"travel"},":izakaya_lantern:":{"uc_base":"1f3ee","uc_output":"1f3ee","uc_match":"1f3ee","uc_greedy":"1f3ee","shortnames":[],"category":"objects"},":jack_o_lantern:":{"uc_base":"1f383","uc_output":"1f383","uc_match":"1f383","uc_greedy":"1f383","shortnames":[],"category":"people"},":japan:":{"uc_base":"1f5fe","uc_output":"1f5fe","uc_match":"1f5fe","uc_greedy":"1f5fe","shortnames":[],"category":"travel"},":japanese_castle:":{"uc_base":"1f3ef","uc_output":"1f3ef","uc_match":"1f3ef","uc_greedy":"1f3ef","shortnames":[],"category":"travel"},":japanese_goblin:":{"uc_base":"1f47a","uc_output":"1f47a","uc_match":"1f47a","uc_greedy":"1f47a","shortnames":[],"category":"people"},":japanese_ogre:":{"uc_base":"1f479","uc_output":"1f479","uc_match":"1f479","uc_greedy":"1f479","shortnames":[],"category":"people"},":jeans:":{"uc_base":"1f456","uc_output":"1f456","uc_match":"1f456","uc_greedy":"1f456","shortnames":[],"category":"people"},":jigsaw:":{"uc_base":"1f9e9","uc_output":"1f9e9","uc_match":"1f9e9","uc_greedy":"1f9e9","shortnames":[],"category":"objects"},":joy:":{"uc_base":"1f602","uc_output":"1f602","uc_match":"1f602","uc_greedy":"1f602","shortnames":[],"category":"people"},":joy_cat:":{"uc_base":"1f639","uc_output":"1f639","uc_match":"1f639","uc_greedy":"1f639","shortnames":[],"category":"people"},":joystick:":{"uc_base":"1f579","uc_output":"1f579","uc_match":"1f579-fe0f","uc_greedy":"1f579-fe0f","shortnames":[],"category":"objects"},":kaaba:":{"uc_base":"1f54b","uc_output":"1f54b","uc_match":"1f54b","uc_greedy":"1f54b","shortnames":[],"category":"travel"},":kangaroo:":{"uc_base":"1f998","uc_output":"1f998","uc_match":"1f998","uc_greedy":"1f998","shortnames":[],"category":"nature"},":key2:":{"uc_base":"1f5dd","uc_output":"1f5dd","uc_match":"1f5dd-fe0f","uc_greedy":"1f5dd","shortnames":[":old_key:"],"category":"objects"},":key:":{"uc_base":"1f511","uc_output":"1f511","uc_match":"1f511","uc_greedy":"1f511","shortnames":[],"category":"objects"},":keycap_ten:":{"uc_base":"1f51f","uc_output":"1f51f","uc_match":"1f51f","uc_greedy":"1f51f","shortnames":[],"category":"symbols"},":kimono:":{"uc_base":"1f458","uc_output":"1f458","uc_match":"1f458","uc_greedy":"1f458","shortnames":[],"category":"people"},":kiss:":{"uc_base":"1f48b","uc_output":"1f48b","uc_match":"1f48b","uc_greedy":"1f48b","shortnames":[],"category":"people"},":kissing:":{"uc_base":"1f617","uc_output":"1f617","uc_match":"1f617","uc_greedy":"1f617","shortnames":[],"category":"people"},":kissing_cat:":{"uc_base":"1f63d","uc_output":"1f63d","uc_match":"1f63d","uc_greedy":"1f63d","shortnames":[],"category":"people"},":kissing_closed_eyes:":{"uc_base":"1f61a","uc_output":"1f61a","uc_match":"1f61a","uc_greedy":"1f61a","shortnames":[],"category":"people"},":kissing_heart:":{"uc_base":"1f618","uc_output":"1f618","uc_match":"1f618","uc_greedy":"1f618","shortnames":[],"category":"people"},":kissing_smiling_eyes:":{"uc_base":"1f619","uc_output":"1f619","uc_match":"1f619","uc_greedy":"1f619","shortnames":[],"category":"people"},":kiwi:":{"uc_base":"1f95d","uc_output":"1f95d","uc_match":"1f95d","uc_greedy":"1f95d","shortnames":[":kiwifruit:"],"category":"food"},":knife:":{"uc_base":"1f52a","uc_output":"1f52a","uc_match":"1f52a","uc_greedy":"1f52a","shortnames":[],"category":"objects"},":koala:":{"uc_base":"1f428","uc_output":"1f428","uc_match":"1f428","uc_greedy":"1f428","shortnames":[],"category":"nature"},":koko:":{"uc_base":"1f201","uc_output":"1f201","uc_match":"1f201","uc_greedy":"1f201","shortnames":[],"category":"symbols"},":lab_coat:":{"uc_base":"1f97c","uc_output":"1f97c","uc_match":"1f97c","uc_greedy":"1f97c","shortnames":[],"category":"people"},":label:":{"uc_base":"1f3f7","uc_output":"1f3f7","uc_match":"1f3f7-fe0f","uc_greedy":"1f3f7-fe0f","shortnames":[],"category":"objects"},":lacrosse:":{"uc_base":"1f94d","uc_output":"1f94d","uc_match":"1f94d","uc_greedy":"1f94d","shortnames":[],"category":"activity"},":large_blue_diamond:":{"uc_base":"1f537","uc_output":"1f537","uc_match":"1f537","uc_greedy":"1f537","shortnames":[],"category":"symbols"},":large_orange_diamond:":{"uc_base":"1f536","uc_output":"1f536","uc_match":"1f536","uc_greedy":"1f536","shortnames":[],"category":"symbols"},":last_quarter_moon:":{"uc_base":"1f317","uc_output":"1f317","uc_match":"1f317","uc_greedy":"1f317","shortnames":[],"category":"nature"},":last_quarter_moon_with_face:":{"uc_base":"1f31c","uc_output":"1f31c","uc_match":"1f31c-fe0f","uc_greedy":"1f31c-fe0f","shortnames":[],"category":"nature"},":laughing:":{"uc_base":"1f606","uc_output":"1f606","uc_match":"1f606","uc_greedy":"1f606","shortnames":[":satisfied:"],"category":"people"},":leafy_green:":{"uc_base":"1f96c","uc_output":"1f96c","uc_match":"1f96c","uc_greedy":"1f96c","shortnames":[],"category":"food"},":leaves:":{"uc_base":"1f343","uc_output":"1f343","uc_match":"1f343","uc_greedy":"1f343","shortnames":[],"category":"nature"},":ledger:":{"uc_base":"1f4d2","uc_output":"1f4d2","uc_match":"1f4d2","uc_greedy":"1f4d2","shortnames":[],"category":"objects"},":left_facing_fist:":{"uc_base":"1f91b","uc_output":"1f91b","uc_match":"1f91b","uc_greedy":"1f91b","shortnames":[":left_fist:"],"category":"people"},":left_luggage:":{"uc_base":"1f6c5","uc_output":"1f6c5","uc_match":"1f6c5","uc_greedy":"1f6c5","shortnames":[],"category":"symbols"},":leg:":{"uc_base":"1f9b5","uc_output":"1f9b5","uc_match":"1f9b5","uc_greedy":"1f9b5","shortnames":[],"category":"people"},":lemon:":{"uc_base":"1f34b","uc_output":"1f34b","uc_match":"1f34b","uc_greedy":"1f34b","shortnames":[],"category":"food"},":leopard:":{"uc_base":"1f406","uc_output":"1f406","uc_match":"1f406","uc_greedy":"1f406","shortnames":[],"category":"nature"},":level_slider:":{"uc_base":"1f39a","uc_output":"1f39a","uc_match":"1f39a-fe0f","uc_greedy":"1f39a-fe0f","shortnames":[],"category":"objects"},":levitate:":{"uc_base":"1f574","uc_output":"1f574","uc_match":"1f574-fe0f","uc_greedy":"1f574-fe0f","shortnames":[":man_in_business_suit_levitating:"],"category":"people"},":light_rail:":{"uc_base":"1f688","uc_output":"1f688","uc_match":"1f688","uc_greedy":"1f688","shortnames":[],"category":"travel"},":link:":{"uc_base":"1f517","uc_output":"1f517","uc_match":"1f517","uc_greedy":"1f517","shortnames":[],"category":"objects"},":lion_face:":{"uc_base":"1f981","uc_output":"1f981","uc_match":"1f981","uc_greedy":"1f981","shortnames":[":lion:"],"category":"nature"},":lips:":{"uc_base":"1f444","uc_output":"1f444","uc_match":"1f444","uc_greedy":"1f444","shortnames":[],"category":"people"},":lipstick:":{"uc_base":"1f484","uc_output":"1f484","uc_match":"1f484","uc_greedy":"1f484","shortnames":[],"category":"people"},":lizard:":{"uc_base":"1f98e","uc_output":"1f98e","uc_match":"1f98e","uc_greedy":"1f98e","shortnames":[],"category":"nature"},":llama:":{"uc_base":"1f999","uc_output":"1f999","uc_match":"1f999","uc_greedy":"1f999","shortnames":[],"category":"nature"},":lobster:":{"uc_base":"1f99e","uc_output":"1f99e","uc_match":"1f99e","uc_greedy":"1f99e","shortnames":[],"category":"nature"},":lock:":{"uc_base":"1f512","uc_output":"1f512","uc_match":"1f512-fe0f","uc_greedy":"1f512-fe0f","shortnames":[],"category":"objects"},":lock_with_ink_pen:":{"uc_base":"1f50f","uc_output":"1f50f","uc_match":"1f50f","uc_greedy":"1f50f","shortnames":[],"category":"objects"},":lollipop:":{"uc_base":"1f36d","uc_output":"1f36d","uc_match":"1f36d","uc_greedy":"1f36d","shortnames":[],"category":"food"},":loud_sound:":{"uc_base":"1f50a","uc_output":"1f50a","uc_match":"1f50a","uc_greedy":"1f50a","shortnames":[],"category":"symbols"},":loudspeaker:":{"uc_base":"1f4e2","uc_output":"1f4e2","uc_match":"1f4e2","uc_greedy":"1f4e2","shortnames":[],"category":"symbols"},":love_hotel:":{"uc_base":"1f3e9","uc_output":"1f3e9","uc_match":"1f3e9","uc_greedy":"1f3e9","shortnames":[],"category":"travel"},":love_letter:":{"uc_base":"1f48c","uc_output":"1f48c","uc_match":"1f48c","uc_greedy":"1f48c","shortnames":[],"category":"objects"},":love_you_gesture:":{"uc_base":"1f91f","uc_output":"1f91f","uc_match":"1f91f","uc_greedy":"1f91f","shortnames":[],"category":"people"},":low_brightness:":{"uc_base":"1f505","uc_output":"1f505","uc_match":"1f505","uc_greedy":"1f505","shortnames":[],"category":"symbols"},":luggage:":{"uc_base":"1f9f3","uc_output":"1f9f3","uc_match":"1f9f3","uc_greedy":"1f9f3","shortnames":[],"category":"travel"},":lying_face:":{"uc_base":"1f925","uc_output":"1f925","uc_match":"1f925","uc_greedy":"1f925","shortnames":[":liar:"],"category":"people"},":mag:":{"uc_base":"1f50d","uc_output":"1f50d","uc_match":"1f50d-fe0f","uc_greedy":"1f50d-fe0f","shortnames":[],"category":"objects"},":mag_right:":{"uc_base":"1f50e","uc_output":"1f50e","uc_match":"1f50e","uc_greedy":"1f50e","shortnames":[],"category":"objects"},":mage:":{"uc_base":"1f9d9","uc_output":"1f9d9","uc_match":"1f9d9","uc_greedy":"1f9d9","shortnames":[],"category":"people"},":magnet:":{"uc_base":"1f9f2","uc_output":"1f9f2","uc_match":"1f9f2","uc_greedy":"1f9f2","shortnames":[],"category":"objects"},":mahjong:":{"uc_base":"1f004","uc_output":"1f004","uc_match":"1f004-fe0f","uc_greedy":"1f004-fe0f","shortnames":[],"category":"symbols"},":mailbox:":{"uc_base":"1f4eb","uc_output":"1f4eb","uc_match":"1f4eb-fe0f","uc_greedy":"1f4eb-fe0f","shortnames":[],"category":"objects"},":mailbox_closed:":{"uc_base":"1f4ea","uc_output":"1f4ea","uc_match":"1f4ea-fe0f","uc_greedy":"1f4ea-fe0f","shortnames":[],"category":"objects"},":mailbox_with_mail:":{"uc_base":"1f4ec","uc_output":"1f4ec","uc_match":"1f4ec-fe0f","uc_greedy":"1f4ec-fe0f","shortnames":[],"category":"objects"},":mailbox_with_no_mail:":{"uc_base":"1f4ed","uc_output":"1f4ed","uc_match":"1f4ed-fe0f","uc_greedy":"1f4ed-fe0f","shortnames":[],"category":"objects"},":man:":{"uc_base":"1f468","uc_output":"1f468","uc_match":"1f468","uc_greedy":"1f468","shortnames":[],"category":"people"},":man_dancing:":{"uc_base":"1f57a","uc_output":"1f57a","uc_match":"1f57a","uc_greedy":"1f57a","shortnames":[":male_dancer:"],"category":"people"},":man_in_tuxedo:":{"uc_base":"1f935","uc_output":"1f935","uc_match":"1f935","uc_greedy":"1f935","shortnames":[],"category":"people"},":man_with_chinese_cap:":{"uc_base":"1f472","uc_output":"1f472","uc_match":"1f472","uc_greedy":"1f472","shortnames":[":man_with_gua_pi_mao:"],"category":"people"},":mango:":{"uc_base":"1f96d","uc_output":"1f96d","uc_match":"1f96d","uc_greedy":"1f96d","shortnames":[],"category":"food"},":mans_shoe:":{"uc_base":"1f45e","uc_output":"1f45e","uc_match":"1f45e","uc_greedy":"1f45e","shortnames":[],"category":"people"},":map:":{"uc_base":"1f5fa","uc_output":"1f5fa","uc_match":"1f5fa-fe0f","uc_greedy":"1f5fa-fe0f","shortnames":[":world_map:"],"category":"travel"},":maple_leaf:":{"uc_base":"1f341","uc_output":"1f341","uc_match":"1f341","uc_greedy":"1f341","shortnames":[],"category":"nature"},":martial_arts_uniform:":{"uc_base":"1f94b","uc_output":"1f94b","uc_match":"1f94b","uc_greedy":"1f94b","shortnames":[":karate_uniform:"],"category":"activity"},":mask:":{"uc_base":"1f637","uc_output":"1f637","uc_match":"1f637","uc_greedy":"1f637","shortnames":[],"category":"people"},":meat_on_bone:":{"uc_base":"1f356","uc_output":"1f356","uc_match":"1f356","uc_greedy":"1f356","shortnames":[],"category":"food"},":medal:":{"uc_base":"1f3c5","uc_output":"1f3c5","uc_match":"1f3c5","uc_greedy":"1f3c5","shortnames":[":sports_medal:"],"category":"activity"},":mega:":{"uc_base":"1f4e3","uc_output":"1f4e3","uc_match":"1f4e3","uc_greedy":"1f4e3","shortnames":[],"category":"symbols"},":melon:":{"uc_base":"1f348","uc_output":"1f348","uc_match":"1f348","uc_greedy":"1f348","shortnames":[],"category":"food"},":menorah:":{"uc_base":"1f54e","uc_output":"1f54e","uc_match":"1f54e","uc_greedy":"1f54e","shortnames":[],"category":"symbols"},":mens:":{"uc_base":"1f6b9","uc_output":"1f6b9","uc_match":"1f6b9-fe0f","uc_greedy":"1f6b9-fe0f","shortnames":[],"category":"symbols"},":merperson:":{"uc_base":"1f9dc","uc_output":"1f9dc","uc_match":"1f9dc","uc_greedy":"1f9dc","shortnames":[],"category":"people"},":metal:":{"uc_base":"1f918","uc_output":"1f918","uc_match":"1f918","uc_greedy":"1f918","shortnames":[":sign_of_the_horns:"],"category":"people"},":metro:":{"uc_base":"1f687","uc_output":"1f687","uc_match":"1f687-fe0f","uc_greedy":"1f687-fe0f","shortnames":[],"category":"travel"},":microbe:":{"uc_base":"1f9a0","uc_output":"1f9a0","uc_match":"1f9a0","uc_greedy":"1f9a0","shortnames":[],"category":"nature"},":microphone2:":{"uc_base":"1f399","uc_output":"1f399","uc_match":"1f399-fe0f","uc_greedy":"1f399-fe0f","shortnames":[":studio_microphone:"],"category":"objects"},":microphone:":{"uc_base":"1f3a4","uc_output":"1f3a4","uc_match":"1f3a4","uc_greedy":"1f3a4","shortnames":[],"category":"activity"},":microscope:":{"uc_base":"1f52c","uc_output":"1f52c","uc_match":"1f52c","uc_greedy":"1f52c","shortnames":[],"category":"objects"},":middle_finger:":{"uc_base":"1f595","uc_output":"1f595","uc_match":"1f595","uc_greedy":"1f595","shortnames":[":reversed_hand_with_middle_finger_extended:"],"category":"people"},":military_medal:":{"uc_base":"1f396","uc_output":"1f396","uc_match":"1f396-fe0f","uc_greedy":"1f396-fe0f","shortnames":[],"category":"activity"},":milk:":{"uc_base":"1f95b","uc_output":"1f95b","uc_match":"1f95b","uc_greedy":"1f95b","shortnames":[":glass_of_milk:"],"category":"food"},":milky_way:":{"uc_base":"1f30c","uc_output":"1f30c","uc_match":"1f30c","uc_greedy":"1f30c","shortnames":[],"category":"travel"},":minibus:":{"uc_base":"1f690","uc_output":"1f690","uc_match":"1f690","uc_greedy":"1f690","shortnames":[],"category":"travel"},":minidisc:":{"uc_base":"1f4bd","uc_output":"1f4bd","uc_match":"1f4bd","uc_greedy":"1f4bd","shortnames":[],"category":"objects"},":mobile_phone_off:":{"uc_base":"1f4f4","uc_output":"1f4f4","uc_match":"1f4f4","uc_greedy":"1f4f4","shortnames":[],"category":"symbols"},":money_mouth:":{"uc_base":"1f911","uc_output":"1f911","uc_match":"1f911","uc_greedy":"1f911","shortnames":[":money_mouth_face:"],"category":"people"},":money_with_wings:":{"uc_base":"1f4b8","uc_output":"1f4b8","uc_match":"1f4b8","uc_greedy":"1f4b8","shortnames":[],"category":"objects"},":moneybag:":{"uc_base":"1f4b0","uc_output":"1f4b0","uc_match":"1f4b0-fe0f","uc_greedy":"1f4b0-fe0f","shortnames":[],"category":"objects"},":monkey:":{"uc_base":"1f412","uc_output":"1f412","uc_match":"1f412","uc_greedy":"1f412","shortnames":[],"category":"nature"},":monkey_face:":{"uc_base":"1f435","uc_output":"1f435","uc_match":"1f435","uc_greedy":"1f435","shortnames":[],"category":"nature"},":monorail:":{"uc_base":"1f69d","uc_output":"1f69d","uc_match":"1f69d","uc_greedy":"1f69d","shortnames":[],"category":"travel"},":moon_cake:":{"uc_base":"1f96e","uc_output":"1f96e","uc_match":"1f96e","uc_greedy":"1f96e","shortnames":[],"category":"food"},":mortar_board:":{"uc_base":"1f393","uc_output":"1f393","uc_match":"1f393-fe0f","uc_greedy":"1f393-fe0f","shortnames":[],"category":"people"},":mosque:":{"uc_base":"1f54c","uc_output":"1f54c","uc_match":"1f54c","uc_greedy":"1f54c","shortnames":[],"category":"travel"},":mosquito:":{"uc_base":"1f99f","uc_output":"1f99f","uc_match":"1f99f","uc_greedy":"1f99f","shortnames":[],"category":"nature"},":motor_scooter:":{"uc_base":"1f6f5","uc_output":"1f6f5","uc_match":"1f6f5","uc_greedy":"1f6f5","shortnames":[":motorbike:"],"category":"travel"},":motorboat:":{"uc_base":"1f6e5","uc_output":"1f6e5","uc_match":"1f6e5-fe0f","uc_greedy":"1f6e5-fe0f","shortnames":[],"category":"travel"},":motorcycle:":{"uc_base":"1f3cd","uc_output":"1f3cd","uc_match":"1f3cd-fe0f","uc_greedy":"1f3cd-fe0f","shortnames":[":racing_motorcycle:"],"category":"travel"},":motorway:":{"uc_base":"1f6e3","uc_output":"1f6e3","uc_match":"1f6e3-fe0f","uc_greedy":"1f6e3-fe0f","shortnames":[],"category":"travel"},":mount_fuji:":{"uc_base":"1f5fb","uc_output":"1f5fb","uc_match":"1f5fb","uc_greedy":"1f5fb","shortnames":[],"category":"travel"},":mountain_cableway:":{"uc_base":"1f6a0","uc_output":"1f6a0","uc_match":"1f6a0","uc_greedy":"1f6a0","shortnames":[],"category":"travel"},":mountain_railway:":{"uc_base":"1f69e","uc_output":"1f69e","uc_match":"1f69e","uc_greedy":"1f69e","shortnames":[],"category":"travel"},":mountain_snow:":{"uc_base":"1f3d4","uc_output":"1f3d4","uc_match":"1f3d4-fe0f","uc_greedy":"1f3d4-fe0f","shortnames":[":snow_capped_mountain:"],"category":"travel"},":mouse2:":{"uc_base":"1f401","uc_output":"1f401","uc_match":"1f401","uc_greedy":"1f401","shortnames":[],"category":"nature"},":mouse:":{"uc_base":"1f42d","uc_output":"1f42d","uc_match":"1f42d","uc_greedy":"1f42d","shortnames":[],"category":"nature"},":mouse_three_button:":{"uc_base":"1f5b1","uc_output":"1f5b1","uc_match":"1f5b1-fe0f","uc_greedy":"1f5b1-fe0f","shortnames":[":three_button_mouse:"],"category":"objects"},":movie_camera:":{"uc_base":"1f3a5","uc_output":"1f3a5","uc_match":"1f3a5","uc_greedy":"1f3a5","shortnames":[],"category":"objects"},":moyai:":{"uc_base":"1f5ff","uc_output":"1f5ff","uc_match":"1f5ff","uc_greedy":"1f5ff","shortnames":[],"category":"travel"},":mrs_claus:":{"uc_base":"1f936","uc_output":"1f936","uc_match":"1f936","uc_greedy":"1f936","shortnames":[":mother_christmas:"],"category":"people"},":muscle:":{"uc_base":"1f4aa","uc_output":"1f4aa","uc_match":"1f4aa","uc_greedy":"1f4aa","shortnames":[],"category":"people"},":mushroom:":{"uc_base":"1f344","uc_output":"1f344","uc_match":"1f344","uc_greedy":"1f344","shortnames":[],"category":"nature"},":musical_keyboard:":{"uc_base":"1f3b9","uc_output":"1f3b9","uc_match":"1f3b9","uc_greedy":"1f3b9","shortnames":[],"category":"activity"},":musical_note:":{"uc_base":"1f3b5","uc_output":"1f3b5","uc_match":"1f3b5","uc_greedy":"1f3b5","shortnames":[],"category":"symbols"},":musical_score:":{"uc_base":"1f3bc","uc_output":"1f3bc","uc_match":"1f3bc","uc_greedy":"1f3bc","shortnames":[],"category":"activity"},":mute:":{"uc_base":"1f507","uc_output":"1f507","uc_match":"1f507","uc_greedy":"1f507","shortnames":[],"category":"symbols"},":nail_care:":{"uc_base":"1f485","uc_output":"1f485","uc_match":"1f485","uc_greedy":"1f485","shortnames":[],"category":"people"},":name_badge:":{"uc_base":"1f4db","uc_output":"1f4db","uc_match":"1f4db","uc_greedy":"1f4db","shortnames":[],"category":"symbols"},":nauseated_face:":{"uc_base":"1f922","uc_output":"1f922","uc_match":"1f922","uc_greedy":"1f922","shortnames":[":sick:"],"category":"people"},":nazar_amulet:":{"uc_base":"1f9ff","uc_output":"1f9ff","uc_match":"1f9ff","uc_greedy":"1f9ff","shortnames":[],"category":"objects"},":necktie:":{"uc_base":"1f454","uc_output":"1f454","uc_match":"1f454","uc_greedy":"1f454","shortnames":[],"category":"people"},":nerd:":{"uc_base":"1f913","uc_output":"1f913","uc_match":"1f913","uc_greedy":"1f913","shortnames":[":nerd_face:"],"category":"people"},":neutral_face:":{"uc_base":"1f610","uc_output":"1f610","uc_match":"1f610-fe0f","uc_greedy":"1f610-fe0f","shortnames":[],"category":"people"},":new:":{"uc_base":"1f195","uc_output":"1f195","uc_match":"1f195","uc_greedy":"1f195","shortnames":[],"category":"symbols"},":new_moon:":{"uc_base":"1f311","uc_output":"1f311","uc_match":"1f311","uc_greedy":"1f311","shortnames":[],"category":"nature"},":new_moon_with_face:":{"uc_base":"1f31a","uc_output":"1f31a","uc_match":"1f31a","uc_greedy":"1f31a","shortnames":[],"category":"nature"},":newspaper2:":{"uc_base":"1f5de","uc_output":"1f5de","uc_match":"1f5de-fe0f","uc_greedy":"1f5de-fe0f","shortnames":[":rolled_up_newspaper:"],"category":"objects"},":newspaper:":{"uc_base":"1f4f0","uc_output":"1f4f0","uc_match":"1f4f0","uc_greedy":"1f4f0","shortnames":[],"category":"objects"},":ng:":{"uc_base":"1f196","uc_output":"1f196","uc_match":"1f196","uc_greedy":"1f196","shortnames":[],"category":"symbols"},":night_with_stars:":{"uc_base":"1f303","uc_output":"1f303","uc_match":"1f303","uc_greedy":"1f303","shortnames":[],"category":"travel"},":no_bell:":{"uc_base":"1f515","uc_output":"1f515","uc_match":"1f515","uc_greedy":"1f515","shortnames":[],"category":"symbols"},":no_bicycles:":{"uc_base":"1f6b3","uc_output":"1f6b3","uc_match":"1f6b3","uc_greedy":"1f6b3","shortnames":[],"category":"symbols"},":no_entry_sign:":{"uc_base":"1f6ab","uc_output":"1f6ab","uc_match":"1f6ab","uc_greedy":"1f6ab","shortnames":[],"category":"symbols"},":no_mobile_phones:":{"uc_base":"1f4f5","uc_output":"1f4f5","uc_match":"1f4f5","uc_greedy":"1f4f5","shortnames":[],"category":"symbols"},":no_mouth:":{"uc_base":"1f636","uc_output":"1f636","uc_match":"1f636","uc_greedy":"1f636","shortnames":[],"category":"people"},":no_pedestrians:":{"uc_base":"1f6b7","uc_output":"1f6b7","uc_match":"1f6b7","uc_greedy":"1f6b7","shortnames":[],"category":"symbols"},":no_smoking:":{"uc_base":"1f6ad","uc_output":"1f6ad","uc_match":"1f6ad-fe0f","uc_greedy":"1f6ad-fe0f","shortnames":[],"category":"symbols"},":non-potable_water:":{"uc_base":"1f6b1","uc_output":"1f6b1","uc_match":"1f6b1","uc_greedy":"1f6b1","shortnames":[],"category":"symbols"},":nose:":{"uc_base":"1f443","uc_output":"1f443","uc_match":"1f443","uc_greedy":"1f443","shortnames":[],"category":"people"},":notebook:":{"uc_base":"1f4d3","uc_output":"1f4d3","uc_match":"1f4d3","uc_greedy":"1f4d3","shortnames":[],"category":"objects"},":notebook_with_decorative_cover:":{"uc_base":"1f4d4","uc_output":"1f4d4","uc_match":"1f4d4","uc_greedy":"1f4d4","shortnames":[],"category":"objects"},":notepad_spiral:":{"uc_base":"1f5d2","uc_output":"1f5d2","uc_match":"1f5d2-fe0f","uc_greedy":"1f5d2-fe0f","shortnames":[":spiral_note_pad:"],"category":"objects"},":notes:":{"uc_base":"1f3b6","uc_output":"1f3b6","uc_match":"1f3b6","uc_greedy":"1f3b6","shortnames":[],"category":"symbols"},":nut_and_bolt:":{"uc_base":"1f529","uc_output":"1f529","uc_match":"1f529","uc_greedy":"1f529","shortnames":[],"category":"objects"},":o2:":{"uc_base":"1f17e","uc_output":"1f17e","uc_match":"1f17e-fe0f","uc_greedy":"1f17e-fe0f","shortnames":[],"category":"symbols"},":ocean:":{"uc_base":"1f30a","uc_output":"1f30a","uc_match":"1f30a","uc_greedy":"1f30a","shortnames":[],"category":"nature"},":octagonal_sign:":{"uc_base":"1f6d1","uc_output":"1f6d1","uc_match":"1f6d1","uc_greedy":"1f6d1","shortnames":[":stop_sign:"],"category":"symbols"},":octopus:":{"uc_base":"1f419","uc_output":"1f419","uc_match":"1f419","uc_greedy":"1f419","shortnames":[],"category":"nature"},":oden:":{"uc_base":"1f362","uc_output":"1f362","uc_match":"1f362","uc_greedy":"1f362","shortnames":[],"category":"food"},":office:":{"uc_base":"1f3e2","uc_output":"1f3e2","uc_match":"1f3e2","uc_greedy":"1f3e2","shortnames":[],"category":"travel"},":oil:":{"uc_base":"1f6e2","uc_output":"1f6e2","uc_match":"1f6e2-fe0f","uc_greedy":"1f6e2-fe0f","shortnames":[":oil_drum:"],"category":"objects"},":ok:":{"uc_base":"1f197","uc_output":"1f197","uc_match":"1f197","uc_greedy":"1f197","shortnames":[],"category":"symbols"},":ok_hand:":{"uc_base":"1f44c","uc_output":"1f44c","uc_match":"1f44c","uc_greedy":"1f44c","shortnames":[],"category":"people"},":older_adult:":{"uc_base":"1f9d3","uc_output":"1f9d3","uc_match":"1f9d3","uc_greedy":"1f9d3","shortnames":[],"category":"people"},":older_man:":{"uc_base":"1f474","uc_output":"1f474","uc_match":"1f474","uc_greedy":"1f474","shortnames":[],"category":"people"},":older_woman:":{"uc_base":"1f475","uc_output":"1f475","uc_match":"1f475","uc_greedy":"1f475","shortnames":[":grandma:"],"category":"people"},":om_symbol:":{"uc_base":"1f549","uc_output":"1f549","uc_match":"1f549-fe0f","uc_greedy":"1f549","shortnames":[],"category":"symbols"},":on:":{"uc_base":"1f51b","uc_output":"1f51b","uc_match":"1f51b","uc_greedy":"1f51b","shortnames":[],"category":"symbols"},":oncoming_automobile:":{"uc_base":"1f698","uc_output":"1f698","uc_match":"1f698-fe0f","uc_greedy":"1f698-fe0f","shortnames":[],"category":"travel"},":oncoming_bus:":{"uc_base":"1f68d","uc_output":"1f68d","uc_match":"1f68d-fe0f","uc_greedy":"1f68d-fe0f","shortnames":[],"category":"travel"},":oncoming_police_car:":{"uc_base":"1f694","uc_output":"1f694","uc_match":"1f694-fe0f","uc_greedy":"1f694-fe0f","shortnames":[],"category":"travel"},":oncoming_taxi:":{"uc_base":"1f696","uc_output":"1f696","uc_match":"1f696","uc_greedy":"1f696","shortnames":[],"category":"travel"},":open_file_folder:":{"uc_base":"1f4c2","uc_output":"1f4c2","uc_match":"1f4c2","uc_greedy":"1f4c2","shortnames":[],"category":"objects"},":open_hands:":{"uc_base":"1f450","uc_output":"1f450","uc_match":"1f450","uc_greedy":"1f450","shortnames":[],"category":"people"},":open_mouth:":{"uc_base":"1f62e","uc_output":"1f62e","uc_match":"1f62e","uc_greedy":"1f62e","shortnames":[],"category":"people"},":orange_book:":{"uc_base":"1f4d9","uc_output":"1f4d9","uc_match":"1f4d9","uc_greedy":"1f4d9","shortnames":[],"category":"objects"},":orange_heart:":{"uc_base":"1f9e1","uc_output":"1f9e1","uc_match":"1f9e1","uc_greedy":"1f9e1","shortnames":[],"category":"symbols"},":outbox_tray:":{"uc_base":"1f4e4","uc_output":"1f4e4","uc_match":"1f4e4-fe0f","uc_greedy":"1f4e4-fe0f","shortnames":[],"category":"objects"},":owl:":{"uc_base":"1f989","uc_output":"1f989","uc_match":"1f989","uc_greedy":"1f989","shortnames":[],"category":"nature"},":ox:":{"uc_base":"1f402","uc_output":"1f402","uc_match":"1f402","uc_greedy":"1f402","shortnames":[],"category":"nature"},":package:":{"uc_base":"1f4e6","uc_output":"1f4e6","uc_match":"1f4e6-fe0f","uc_greedy":"1f4e6-fe0f","shortnames":[],"category":"objects"},":page_facing_up:":{"uc_base":"1f4c4","uc_output":"1f4c4","uc_match":"1f4c4","uc_greedy":"1f4c4","shortnames":[],"category":"objects"},":page_with_curl:":{"uc_base":"1f4c3","uc_output":"1f4c3","uc_match":"1f4c3","uc_greedy":"1f4c3","shortnames":[],"category":"objects"},":pager:":{"uc_base":"1f4df","uc_output":"1f4df","uc_match":"1f4df-fe0f","uc_greedy":"1f4df-fe0f","shortnames":[],"category":"objects"},":paintbrush:":{"uc_base":"1f58c","uc_output":"1f58c","uc_match":"1f58c-fe0f","uc_greedy":"1f58c-fe0f","shortnames":[":lower_left_paintbrush:"],"category":"objects"},":palm_tree:":{"uc_base":"1f334","uc_output":"1f334","uc_match":"1f334","uc_greedy":"1f334","shortnames":[],"category":"nature"},":palms_up_together:":{"uc_base":"1f932","uc_output":"1f932","uc_match":"1f932","uc_greedy":"1f932","shortnames":[],"category":"people"},":pancakes:":{"uc_base":"1f95e","uc_output":"1f95e","uc_match":"1f95e","uc_greedy":"1f95e","shortnames":[],"category":"food"},":panda_face:":{"uc_base":"1f43c","uc_output":"1f43c","uc_match":"1f43c","uc_greedy":"1f43c","shortnames":[],"category":"nature"},":paperclip:":{"uc_base":"1f4ce","uc_output":"1f4ce","uc_match":"1f4ce","uc_greedy":"1f4ce","shortnames":[],"category":"objects"},":paperclips:":{"uc_base":"1f587","uc_output":"1f587","uc_match":"1f587-fe0f","uc_greedy":"1f587-fe0f","shortnames":[":linked_paperclips:"],"category":"objects"},":park:":{"uc_base":"1f3de","uc_output":"1f3de","uc_match":"1f3de-fe0f","uc_greedy":"1f3de-fe0f","shortnames":[":national_park:"],"category":"travel"},":parking:":{"uc_base":"1f17f","uc_output":"1f17f","uc_match":"1f17f-fe0f","uc_greedy":"1f17f-fe0f","shortnames":[],"category":"symbols"},":parrot:":{"uc_base":"1f99c","uc_output":"1f99c","uc_match":"1f99c","uc_greedy":"1f99c","shortnames":[],"category":"nature"},":partying_face:":{"uc_base":"1f973","uc_output":"1f973","uc_match":"1f973","uc_greedy":"1f973","shortnames":[],"category":"people"},":passport_control:":{"uc_base":"1f6c2","uc_output":"1f6c2","uc_match":"1f6c2","uc_greedy":"1f6c2","shortnames":[],"category":"symbols"},":peach:":{"uc_base":"1f351","uc_output":"1f351","uc_match":"1f351","uc_greedy":"1f351","shortnames":[],"category":"food"},":peacock:":{"uc_base":"1f99a","uc_output":"1f99a","uc_match":"1f99a","uc_greedy":"1f99a","shortnames":[],"category":"nature"},":peanuts:":{"uc_base":"1f95c","uc_output":"1f95c","uc_match":"1f95c","uc_greedy":"1f95c","shortnames":[":shelled_peanut:"],"category":"food"},":pear:":{"uc_base":"1f350","uc_output":"1f350","uc_match":"1f350","uc_greedy":"1f350","shortnames":[],"category":"food"},":pen_ballpoint:":{"uc_base":"1f58a","uc_output":"1f58a","uc_match":"1f58a-fe0f","uc_greedy":"1f58a-fe0f","shortnames":[":lower_left_ballpoint_pen:"],"category":"objects"},":pen_fountain:":{"uc_base":"1f58b","uc_output":"1f58b","uc_match":"1f58b-fe0f","uc_greedy":"1f58b-fe0f","shortnames":[":lower_left_fountain_pen:"],"category":"objects"},":pencil:":{"uc_base":"1f4dd","uc_output":"1f4dd","uc_match":"1f4dd","uc_greedy":"1f4dd","shortnames":[":memo:"],"category":"objects"},":penguin:":{"uc_base":"1f427","uc_output":"1f427","uc_match":"1f427","uc_greedy":"1f427","shortnames":[],"category":"nature"},":pensive:":{"uc_base":"1f614","uc_output":"1f614","uc_match":"1f614","uc_greedy":"1f614","shortnames":[],"category":"people"},":people_with_bunny_ears_partying:":{"uc_base":"1f46f","uc_output":"1f46f","uc_match":"1f46f","uc_greedy":"1f46f","shortnames":[":dancers:"],"category":"people"},":people_wrestling:":{"uc_base":"1f93c","uc_output":"1f93c","uc_match":"1f93c","uc_greedy":"1f93c","shortnames":[":wrestlers:",":wrestling:"],"category":"activity"},":performing_arts:":{"uc_base":"1f3ad","uc_output":"1f3ad","uc_match":"1f3ad-fe0f","uc_greedy":"1f3ad-fe0f","shortnames":[],"category":"activity"},":persevere:":{"uc_base":"1f623","uc_output":"1f623","uc_match":"1f623","uc_greedy":"1f623","shortnames":[],"category":"people"},":person_biking:":{"uc_base":"1f6b4","uc_output":"1f6b4","uc_match":"1f6b4","uc_greedy":"1f6b4","shortnames":[":bicyclist:"],"category":"activity"},":person_bowing:":{"uc_base":"1f647","uc_output":"1f647","uc_match":"1f647","uc_greedy":"1f647","shortnames":[":bow:"],"category":"people"},":person_climbing:":{"uc_base":"1f9d7","uc_output":"1f9d7","uc_match":"1f9d7","uc_greedy":"1f9d7","shortnames":[],"category":"activity"},":person_doing_cartwheel:":{"uc_base":"1f938","uc_output":"1f938","uc_match":"1f938","uc_greedy":"1f938","shortnames":[":cartwheel:"],"category":"activity"},":person_facepalming:":{"uc_base":"1f926","uc_output":"1f926","uc_match":"1f926","uc_greedy":"1f926","shortnames":[":face_palm:",":facepalm:"],"category":"people"},":person_fencing:":{"uc_base":"1f93a","uc_output":"1f93a","uc_match":"1f93a","uc_greedy":"1f93a","shortnames":[":fencer:",":fencing:"],"category":"activity"},":person_frowning:":{"uc_base":"1f64d","uc_output":"1f64d","uc_match":"1f64d","uc_greedy":"1f64d","shortnames":[],"category":"people"},":person_gesturing_no:":{"uc_base":"1f645","uc_output":"1f645","uc_match":"1f645","uc_greedy":"1f645","shortnames":[":no_good:"],"category":"people"},":person_gesturing_ok:":{"uc_base":"1f646","uc_output":"1f646","uc_match":"1f646","uc_greedy":"1f646","shortnames":[":ok_woman:"],"category":"people"},":person_getting_haircut:":{"uc_base":"1f487","uc_output":"1f487","uc_match":"1f487","uc_greedy":"1f487","shortnames":[":haircut:"],"category":"people"},":person_getting_massage:":{"uc_base":"1f486","uc_output":"1f486","uc_match":"1f486","uc_greedy":"1f486","shortnames":[":massage:"],"category":"people"},":person_golfing:":{"uc_base":"1f3cc","uc_output":"1f3cc","uc_match":"1f3cc-fe0f","uc_greedy":"1f3cc-fe0f","shortnames":[":golfer:"],"category":"activity"},":person_in_lotus_position:":{"uc_base":"1f9d8","uc_output":"1f9d8","uc_match":"1f9d8","uc_greedy":"1f9d8","shortnames":[],"category":"activity"},":person_in_steamy_room:":{"uc_base":"1f9d6","uc_output":"1f9d6","uc_match":"1f9d6","uc_greedy":"1f9d6","shortnames":[],"category":"people"},":person_juggling:":{"uc_base":"1f939","uc_output":"1f939","uc_match":"1f939","uc_greedy":"1f939","shortnames":[":juggling:",":juggler:"],"category":"activity"},":person_lifting_weights:":{"uc_base":"1f3cb","uc_output":"1f3cb","uc_match":"1f3cb-fe0f","uc_greedy":"1f3cb-fe0f","shortnames":[":lifter:",":weight_lifter:"],"category":"activity"},":person_mountain_biking:":{"uc_base":"1f6b5","uc_output":"1f6b5","uc_match":"1f6b5","uc_greedy":"1f6b5","shortnames":[":mountain_bicyclist:"],"category":"activity"},":person_playing_handball:":{"uc_base":"1f93e","uc_output":"1f93e","uc_match":"1f93e","uc_greedy":"1f93e","shortnames":[":handball:"],"category":"activity"},":person_playing_water_polo:":{"uc_base":"1f93d","uc_output":"1f93d","uc_match":"1f93d","uc_greedy":"1f93d","shortnames":[":water_polo:"],"category":"activity"},":person_pouting:":{"uc_base":"1f64e","uc_output":"1f64e","uc_match":"1f64e","uc_greedy":"1f64e","shortnames":[":person_with_pouting_face:"],"category":"people"},":person_raising_hand:":{"uc_base":"1f64b","uc_output":"1f64b","uc_match":"1f64b","uc_greedy":"1f64b","shortnames":[":raising_hand:"],"category":"people"},":person_rowing_boat:":{"uc_base":"1f6a3","uc_output":"1f6a3","uc_match":"1f6a3","uc_greedy":"1f6a3","shortnames":[":rowboat:"],"category":"activity"},":person_running:":{"uc_base":"1f3c3","uc_output":"1f3c3","uc_match":"1f3c3","uc_greedy":"1f3c3","shortnames":[":runner:"],"category":"people"},":person_shrugging:":{"uc_base":"1f937","uc_output":"1f937","uc_match":"1f937","uc_greedy":"1f937","shortnames":[":shrug:"],"category":"people"},":person_surfing:":{"uc_base":"1f3c4","uc_output":"1f3c4","uc_match":"1f3c4-fe0f","uc_greedy":"1f3c4-fe0f","shortnames":[":surfer:"],"category":"activity"},":person_swimming:":{"uc_base":"1f3ca","uc_output":"1f3ca","uc_match":"1f3ca-fe0f","uc_greedy":"1f3ca-fe0f","shortnames":[":swimmer:"],"category":"activity"},":person_tipping_hand:":{"uc_base":"1f481","uc_output":"1f481","uc_match":"1f481","uc_greedy":"1f481","shortnames":[":information_desk_person:"],"category":"people"},":person_walking:":{"uc_base":"1f6b6","uc_output":"1f6b6","uc_match":"1f6b6","uc_greedy":"1f6b6","shortnames":[":walking:"],"category":"people"},":person_wearing_turban:":{"uc_base":"1f473","uc_output":"1f473","uc_match":"1f473","uc_greedy":"1f473","shortnames":[":man_with_turban:"],"category":"people"},":petri_dish:":{"uc_base":"1f9eb","uc_output":"1f9eb","uc_match":"1f9eb","uc_greedy":"1f9eb","shortnames":[],"category":"objects"},":pie:":{"uc_base":"1f967","uc_output":"1f967","uc_match":"1f967","uc_greedy":"1f967","shortnames":[],"category":"food"},":pig2:":{"uc_base":"1f416","uc_output":"1f416","uc_match":"1f416","uc_greedy":"1f416","shortnames":[],"category":"nature"},":pig:":{"uc_base":"1f437","uc_output":"1f437","uc_match":"1f437","uc_greedy":"1f437","shortnames":[],"category":"nature"},":pig_nose:":{"uc_base":"1f43d","uc_output":"1f43d","uc_match":"1f43d","uc_greedy":"1f43d","shortnames":[],"category":"nature"},":pill:":{"uc_base":"1f48a","uc_output":"1f48a","uc_match":"1f48a","uc_greedy":"1f48a","shortnames":[],"category":"objects"},":pineapple:":{"uc_base":"1f34d","uc_output":"1f34d","uc_match":"1f34d","uc_greedy":"1f34d","shortnames":[],"category":"food"},":ping_pong:":{"uc_base":"1f3d3","uc_output":"1f3d3","uc_match":"1f3d3","uc_greedy":"1f3d3","shortnames":[":table_tennis:"],"category":"activity"},":pizza:":{"uc_base":"1f355","uc_output":"1f355","uc_match":"1f355","uc_greedy":"1f355","shortnames":[],"category":"food"},":place_of_worship:":{"uc_base":"1f6d0","uc_output":"1f6d0","uc_match":"1f6d0","uc_greedy":"1f6d0","shortnames":[":worship_symbol:"],"category":"symbols"},":pleading_face:":{"uc_base":"1f97a","uc_output":"1f97a","uc_match":"1f97a","uc_greedy":"1f97a","shortnames":[],"category":"people"},":point_down:":{"uc_base":"1f447","uc_output":"1f447","uc_match":"1f447-fe0f","uc_greedy":"1f447-fe0f","shortnames":[],"category":"people"},":point_left:":{"uc_base":"1f448","uc_output":"1f448","uc_match":"1f448-fe0f","uc_greedy":"1f448-fe0f","shortnames":[],"category":"people"},":point_right:":{"uc_base":"1f449","uc_output":"1f449","uc_match":"1f449-fe0f","uc_greedy":"1f449-fe0f","shortnames":[],"category":"people"},":point_up_2:":{"uc_base":"1f446","uc_output":"1f446","uc_match":"1f446-fe0f","uc_greedy":"1f446-fe0f","shortnames":[],"category":"people"},":police_car:":{"uc_base":"1f693","uc_output":"1f693","uc_match":"1f693","uc_greedy":"1f693","shortnames":[],"category":"travel"},":police_officer:":{"uc_base":"1f46e","uc_output":"1f46e","uc_match":"1f46e","uc_greedy":"1f46e","shortnames":[":cop:"],"category":"people"},":poodle:":{"uc_base":"1f429","uc_output":"1f429","uc_match":"1f429","uc_greedy":"1f429","shortnames":[],"category":"nature"},":poop:":{"uc_base":"1f4a9","uc_output":"1f4a9","uc_match":"1f4a9","uc_greedy":"1f4a9","shortnames":[":shit:",":hankey:",":poo:"],"category":"people"},":popcorn:":{"uc_base":"1f37f","uc_output":"1f37f","uc_match":"1f37f","uc_greedy":"1f37f","shortnames":[],"category":"food"},":post_office:":{"uc_base":"1f3e3","uc_output":"1f3e3","uc_match":"1f3e3","uc_greedy":"1f3e3","shortnames":[],"category":"travel"},":postal_horn:":{"uc_base":"1f4ef","uc_output":"1f4ef","uc_match":"1f4ef","uc_greedy":"1f4ef","shortnames":[],"category":"objects"},":postbox:":{"uc_base":"1f4ee","uc_output":"1f4ee","uc_match":"1f4ee","uc_greedy":"1f4ee","shortnames":[],"category":"objects"},":potable_water:":{"uc_base":"1f6b0","uc_output":"1f6b0","uc_match":"1f6b0","uc_greedy":"1f6b0","shortnames":[],"category":"objects"},":potato:":{"uc_base":"1f954","uc_output":"1f954","uc_match":"1f954","uc_greedy":"1f954","shortnames":[],"category":"food"},":pouch:":{"uc_base":"1f45d","uc_output":"1f45d","uc_match":"1f45d","uc_greedy":"1f45d","shortnames":[],"category":"people"},":poultry_leg:":{"uc_base":"1f357","uc_output":"1f357","uc_match":"1f357","uc_greedy":"1f357","shortnames":[],"category":"food"},":pound:":{"uc_base":"1f4b7","uc_output":"1f4b7","uc_match":"1f4b7","uc_greedy":"1f4b7","shortnames":[],"category":"objects"},":pouting_cat:":{"uc_base":"1f63e","uc_output":"1f63e","uc_match":"1f63e","uc_greedy":"1f63e","shortnames":[],"category":"people"},":pray:":{"uc_base":"1f64f","uc_output":"1f64f","uc_match":"1f64f","uc_greedy":"1f64f","shortnames":[],"category":"people"},":prayer_beads:":{"uc_base":"1f4ff","uc_output":"1f4ff","uc_match":"1f4ff","uc_greedy":"1f4ff","shortnames":[],"category":"objects"},":pregnant_woman:":{"uc_base":"1f930","uc_output":"1f930","uc_match":"1f930","uc_greedy":"1f930","shortnames":[":expecting_woman:"],"category":"people"},":pretzel:":{"uc_base":"1f968","uc_output":"1f968","uc_match":"1f968","uc_greedy":"1f968","shortnames":[],"category":"food"},":prince:":{"uc_base":"1f934","uc_output":"1f934","uc_match":"1f934","uc_greedy":"1f934","shortnames":[],"category":"people"},":princess:":{"uc_base":"1f478","uc_output":"1f478","uc_match":"1f478","uc_greedy":"1f478","shortnames":[],"category":"people"},":printer:":{"uc_base":"1f5a8","uc_output":"1f5a8","uc_match":"1f5a8-fe0f","uc_greedy":"1f5a8-fe0f","shortnames":[],"category":"objects"},":projector:":{"uc_base":"1f4fd","uc_output":"1f4fd","uc_match":"1f4fd-fe0f","uc_greedy":"1f4fd-fe0f","shortnames":[":film_projector:"],"category":"objects"},":punch:":{"uc_base":"1f44a","uc_output":"1f44a","uc_match":"1f44a","uc_greedy":"1f44a","shortnames":[],"category":"people"},":purple_heart:":{"uc_base":"1f49c","uc_output":"1f49c","uc_match":"1f49c","uc_greedy":"1f49c","shortnames":[],"category":"symbols"},":purse:":{"uc_base":"1f45b","uc_output":"1f45b","uc_match":"1f45b","uc_greedy":"1f45b","shortnames":[],"category":"people"},":pushpin:":{"uc_base":"1f4cc","uc_output":"1f4cc","uc_match":"1f4cc","uc_greedy":"1f4cc","shortnames":[],"category":"objects"},":put_litter_in_its_place:":{"uc_base":"1f6ae","uc_output":"1f6ae","uc_match":"1f6ae","uc_greedy":"1f6ae","shortnames":[],"category":"symbols"},":rabbit2:":{"uc_base":"1f407","uc_output":"1f407","uc_match":"1f407","uc_greedy":"1f407","shortnames":[],"category":"nature"},":rabbit:":{"uc_base":"1f430","uc_output":"1f430","uc_match":"1f430","uc_greedy":"1f430","shortnames":[],"category":"nature"},":raccoon:":{"uc_base":"1f99d","uc_output":"1f99d","uc_match":"1f99d","uc_greedy":"1f99d","shortnames":[],"category":"nature"},":race_car:":{"uc_base":"1f3ce","uc_output":"1f3ce","uc_match":"1f3ce-fe0f","uc_greedy":"1f3ce-fe0f","shortnames":[":racing_car:"],"category":"travel"},":racehorse:":{"uc_base":"1f40e","uc_output":"1f40e","uc_match":"1f40e","uc_greedy":"1f40e","shortnames":[],"category":"nature"},":radio:":{"uc_base":"1f4fb","uc_output":"1f4fb","uc_match":"1f4fb-fe0f","uc_greedy":"1f4fb-fe0f","shortnames":[],"category":"objects"},":radio_button:":{"uc_base":"1f518","uc_output":"1f518","uc_match":"1f518","uc_greedy":"1f518","shortnames":[],"category":"symbols"},":rage:":{"uc_base":"1f621","uc_output":"1f621","uc_match":"1f621","uc_greedy":"1f621","shortnames":[],"category":"people"},":railway_car:":{"uc_base":"1f683","uc_output":"1f683","uc_match":"1f683","uc_greedy":"1f683","shortnames":[],"category":"travel"},":railway_track:":{"uc_base":"1f6e4","uc_output":"1f6e4","uc_match":"1f6e4-fe0f","uc_greedy":"1f6e4-fe0f","shortnames":[":railroad_track:"],"category":"travel"},":rainbow:":{"uc_base":"1f308","uc_output":"1f308","uc_match":"1f308","uc_greedy":"1f308","shortnames":[],"category":"nature"},":raised_back_of_hand:":{"uc_base":"1f91a","uc_output":"1f91a","uc_match":"1f91a","uc_greedy":"1f91a","shortnames":[":back_of_hand:"],"category":"people"},":raised_hands:":{"uc_base":"1f64c","uc_output":"1f64c","uc_match":"1f64c","uc_greedy":"1f64c","shortnames":[],"category":"people"},":ram:":{"uc_base":"1f40f","uc_output":"1f40f","uc_match":"1f40f","uc_greedy":"1f40f","shortnames":[],"category":"nature"},":ramen:":{"uc_base":"1f35c","uc_output":"1f35c","uc_match":"1f35c","uc_greedy":"1f35c","shortnames":[],"category":"food"},":rat:":{"uc_base":"1f400","uc_output":"1f400","uc_match":"1f400","uc_greedy":"1f400","shortnames":[],"category":"nature"},":receipt:":{"uc_base":"1f9fe","uc_output":"1f9fe","uc_match":"1f9fe","uc_greedy":"1f9fe","shortnames":[],"category":"objects"},":red_car:":{"uc_base":"1f697","uc_output":"1f697","uc_match":"1f697","uc_greedy":"1f697","shortnames":[],"category":"travel"},":red_circle:":{"uc_base":"1f534","uc_output":"1f534","uc_match":"1f534","uc_greedy":"1f534","shortnames":[],"category":"symbols"},":red_envelope:":{"uc_base":"1f9e7","uc_output":"1f9e7","uc_match":"1f9e7","uc_greedy":"1f9e7","shortnames":[],"category":"objects"},":red_haired:":{"uc_base":"1f9b0","uc_output":"1f9b0","uc_match":"1f9b0","uc_greedy":"1f9b0","shortnames":[],"category":"people"},":regional_indicator_a:":{"uc_base":"1f1e6","uc_output":"1f1e6","uc_match":"1f1e6","uc_greedy":"1f1e6","shortnames":[],"category":"regional"},":regional_indicator_b:":{"uc_base":"1f1e7","uc_output":"1f1e7","uc_match":"1f1e7","uc_greedy":"1f1e7","shortnames":[],"category":"regional"},":regional_indicator_c:":{"uc_base":"1f1e8","uc_output":"1f1e8","uc_match":"1f1e8","uc_greedy":"1f1e8","shortnames":[],"category":"regional"},":regional_indicator_d:":{"uc_base":"1f1e9","uc_output":"1f1e9","uc_match":"1f1e9","uc_greedy":"1f1e9","shortnames":[],"category":"regional"},":regional_indicator_e:":{"uc_base":"1f1ea","uc_output":"1f1ea","uc_match":"1f1ea","uc_greedy":"1f1ea","shortnames":[],"category":"regional"},":regional_indicator_f:":{"uc_base":"1f1eb","uc_output":"1f1eb","uc_match":"1f1eb","uc_greedy":"1f1eb","shortnames":[],"category":"regional"},":regional_indicator_g:":{"uc_base":"1f1ec","uc_output":"1f1ec","uc_match":"1f1ec","uc_greedy":"1f1ec","shortnames":[],"category":"regional"},":regional_indicator_h:":{"uc_base":"1f1ed","uc_output":"1f1ed","uc_match":"1f1ed","uc_greedy":"1f1ed","shortnames":[],"category":"regional"},":regional_indicator_i:":{"uc_base":"1f1ee","uc_output":"1f1ee","uc_match":"1f1ee","uc_greedy":"1f1ee","shortnames":[],"category":"regional"},":regional_indicator_j:":{"uc_base":"1f1ef","uc_output":"1f1ef","uc_match":"1f1ef","uc_greedy":"1f1ef","shortnames":[],"category":"regional"},":regional_indicator_k:":{"uc_base":"1f1f0","uc_output":"1f1f0","uc_match":"1f1f0","uc_greedy":"1f1f0","shortnames":[],"category":"regional"},":regional_indicator_l:":{"uc_base":"1f1f1","uc_output":"1f1f1","uc_match":"1f1f1","uc_greedy":"1f1f1","shortnames":[],"category":"regional"},":regional_indicator_m:":{"uc_base":"1f1f2","uc_output":"1f1f2","uc_match":"1f1f2","uc_greedy":"1f1f2","shortnames":[],"category":"regional"},":regional_indicator_n:":{"uc_base":"1f1f3","uc_output":"1f1f3","uc_match":"1f1f3","uc_greedy":"1f1f3","shortnames":[],"category":"regional"},":regional_indicator_o:":{"uc_base":"1f1f4","uc_output":"1f1f4","uc_match":"1f1f4","uc_greedy":"1f1f4","shortnames":[],"category":"regional"},":regional_indicator_p:":{"uc_base":"1f1f5","uc_output":"1f1f5","uc_match":"1f1f5","uc_greedy":"1f1f5","shortnames":[],"category":"regional"},":regional_indicator_q:":{"uc_base":"1f1f6","uc_output":"1f1f6","uc_match":"1f1f6","uc_greedy":"1f1f6","shortnames":[],"category":"regional"},":regional_indicator_r:":{"uc_base":"1f1f7","uc_output":"1f1f7","uc_match":"1f1f7","uc_greedy":"1f1f7","shortnames":[],"category":"regional"},":regional_indicator_s:":{"uc_base":"1f1f8","uc_output":"1f1f8","uc_match":"1f1f8","uc_greedy":"1f1f8","shortnames":[],"category":"regional"},":regional_indicator_t:":{"uc_base":"1f1f9","uc_output":"1f1f9","uc_match":"1f1f9","uc_greedy":"1f1f9","shortnames":[],"category":"regional"},":regional_indicator_u:":{"uc_base":"1f1fa","uc_output":"1f1fa","uc_match":"1f1fa","uc_greedy":"1f1fa","shortnames":[],"category":"regional"},":regional_indicator_v:":{"uc_base":"1f1fb","uc_output":"1f1fb","uc_match":"1f1fb","uc_greedy":"1f1fb","shortnames":[],"category":"regional"},":regional_indicator_w:":{"uc_base":"1f1fc","uc_output":"1f1fc","uc_match":"1f1fc","uc_greedy":"1f1fc","shortnames":[],"category":"regional"},":regional_indicator_x:":{"uc_base":"1f1fd","uc_output":"1f1fd","uc_match":"1f1fd","uc_greedy":"1f1fd","shortnames":[],"category":"regional"},":regional_indicator_y:":{"uc_base":"1f1fe","uc_output":"1f1fe","uc_match":"1f1fe","uc_greedy":"1f1fe","shortnames":[],"category":"regional"},":regional_indicator_z:":{"uc_base":"1f1ff","uc_output":"1f1ff","uc_match":"1f1ff","uc_greedy":"1f1ff","shortnames":[],"category":"regional"},":relieved:":{"uc_base":"1f60c","uc_output":"1f60c","uc_match":"1f60c","uc_greedy":"1f60c","shortnames":[],"category":"people"},":reminder_ribbon:":{"uc_base":"1f397","uc_output":"1f397","uc_match":"1f397-fe0f","uc_greedy":"1f397-fe0f","shortnames":[],"category":"activity"},":repeat:":{"uc_base":"1f501","uc_output":"1f501","uc_match":"1f501","uc_greedy":"1f501","shortnames":[],"category":"symbols"},":repeat_one:":{"uc_base":"1f502","uc_output":"1f502","uc_match":"1f502","uc_greedy":"1f502","shortnames":[],"category":"symbols"},":restroom:":{"uc_base":"1f6bb","uc_output":"1f6bb","uc_match":"1f6bb","uc_greedy":"1f6bb","shortnames":[],"category":"symbols"},":revolving_hearts:":{"uc_base":"1f49e","uc_output":"1f49e","uc_match":"1f49e","uc_greedy":"1f49e","shortnames":[],"category":"symbols"},":rhino:":{"uc_base":"1f98f","uc_output":"1f98f","uc_match":"1f98f","uc_greedy":"1f98f","shortnames":[":rhinoceros:"],"category":"nature"},":ribbon:":{"uc_base":"1f380","uc_output":"1f380","uc_match":"1f380","uc_greedy":"1f380","shortnames":[],"category":"objects"},":rice:":{"uc_base":"1f35a","uc_output":"1f35a","uc_match":"1f35a","uc_greedy":"1f35a","shortnames":[],"category":"food"},":rice_ball:":{"uc_base":"1f359","uc_output":"1f359","uc_match":"1f359","uc_greedy":"1f359","shortnames":[],"category":"food"},":rice_cracker:":{"uc_base":"1f358","uc_output":"1f358","uc_match":"1f358","uc_greedy":"1f358","shortnames":[],"category":"food"},":rice_scene:":{"uc_base":"1f391","uc_output":"1f391","uc_match":"1f391","uc_greedy":"1f391","shortnames":[],"category":"travel"},":right_facing_fist:":{"uc_base":"1f91c","uc_output":"1f91c","uc_match":"1f91c","uc_greedy":"1f91c","shortnames":[":right_fist:"],"category":"people"},":ring:":{"uc_base":"1f48d","uc_output":"1f48d","uc_match":"1f48d","uc_greedy":"1f48d","shortnames":[],"category":"people"},":robot:":{"uc_base":"1f916","uc_output":"1f916","uc_match":"1f916","uc_greedy":"1f916","shortnames":[":robot_face:"],"category":"people"},":rocket:":{"uc_base":"1f680","uc_output":"1f680","uc_match":"1f680","uc_greedy":"1f680","shortnames":[],"category":"travel"},":rofl:":{"uc_base":"1f923","uc_output":"1f923","uc_match":"1f923","uc_greedy":"1f923","shortnames":[":rolling_on_the_floor_laughing:"],"category":"people"},":roll_of_paper:":{"uc_base":"1f9fb","uc_output":"1f9fb","uc_match":"1f9fb","uc_greedy":"1f9fb","shortnames":[],"category":"objects"},":roller_coaster:":{"uc_base":"1f3a2","uc_output":"1f3a2","uc_match":"1f3a2","uc_greedy":"1f3a2","shortnames":[],"category":"travel"},":rolling_eyes:":{"uc_base":"1f644","uc_output":"1f644","uc_match":"1f644","uc_greedy":"1f644","shortnames":[":face_with_rolling_eyes:"],"category":"people"},":rooster:":{"uc_base":"1f413","uc_output":"1f413","uc_match":"1f413","uc_greedy":"1f413","shortnames":[],"category":"nature"},":rose:":{"uc_base":"1f339","uc_output":"1f339","uc_match":"1f339","uc_greedy":"1f339","shortnames":[],"category":"nature"},":rosette:":{"uc_base":"1f3f5","uc_output":"1f3f5","uc_match":"1f3f5-fe0f","uc_greedy":"1f3f5-fe0f","shortnames":[],"category":"activity"},":rotating_light:":{"uc_base":"1f6a8","uc_output":"1f6a8","uc_match":"1f6a8","uc_greedy":"1f6a8","shortnames":[],"category":"travel"},":round_pushpin:":{"uc_base":"1f4cd","uc_output":"1f4cd","uc_match":"1f4cd","uc_greedy":"1f4cd","shortnames":[],"category":"objects"},":rugby_football:":{"uc_base":"1f3c9","uc_output":"1f3c9","uc_match":"1f3c9","uc_greedy":"1f3c9","shortnames":[],"category":"activity"},":running_shirt_with_sash:":{"uc_base":"1f3bd","uc_output":"1f3bd","uc_match":"1f3bd","uc_greedy":"1f3bd","shortnames":[],"category":"activity"},":sa:":{"uc_base":"1f202","uc_output":"1f202","uc_match":"1f202-fe0f","uc_greedy":"1f202-fe0f","shortnames":[],"category":"symbols"},":safety_pin:":{"uc_base":"1f9f7","uc_output":"1f9f7","uc_match":"1f9f7","uc_greedy":"1f9f7","shortnames":[],"category":"objects"},":sake:":{"uc_base":"1f376","uc_output":"1f376","uc_match":"1f376","uc_greedy":"1f376","shortnames":[],"category":"food"},":salad:":{"uc_base":"1f957","uc_output":"1f957","uc_match":"1f957","uc_greedy":"1f957","shortnames":[":green_salad:"],"category":"food"},":salt:":{"uc_base":"1f9c2","uc_output":"1f9c2","uc_match":"1f9c2","uc_greedy":"1f9c2","shortnames":[],"category":"food"},":sandal:":{"uc_base":"1f461","uc_output":"1f461","uc_match":"1f461","uc_greedy":"1f461","shortnames":[],"category":"people"},":sandwich:":{"uc_base":"1f96a","uc_output":"1f96a","uc_match":"1f96a","uc_greedy":"1f96a","shortnames":[],"category":"food"},":santa:":{"uc_base":"1f385","uc_output":"1f385","uc_match":"1f385","uc_greedy":"1f385","shortnames":[],"category":"people"},":satellite:":{"uc_base":"1f4e1","uc_output":"1f4e1","uc_match":"1f4e1","uc_greedy":"1f4e1","shortnames":[],"category":"objects"},":satellite_orbital:":{"uc_base":"1f6f0","uc_output":"1f6f0","uc_match":"1f6f0-fe0f","uc_greedy":"1f6f0-fe0f","shortnames":[],"category":"travel"},":sauropod:":{"uc_base":"1f995","uc_output":"1f995","uc_match":"1f995","uc_greedy":"1f995","shortnames":[],"category":"nature"},":saxophone:":{"uc_base":"1f3b7","uc_output":"1f3b7","uc_match":"1f3b7","uc_greedy":"1f3b7","shortnames":[],"category":"activity"},":scarf:":{"uc_base":"1f9e3","uc_output":"1f9e3","uc_match":"1f9e3","uc_greedy":"1f9e3","shortnames":[],"category":"people"},":school:":{"uc_base":"1f3eb","uc_output":"1f3eb","uc_match":"1f3eb","uc_greedy":"1f3eb","shortnames":[],"category":"travel"},":school_satchel:":{"uc_base":"1f392","uc_output":"1f392","uc_match":"1f392","uc_greedy":"1f392","shortnames":[],"category":"people"},":scooter:":{"uc_base":"1f6f4","uc_output":"1f6f4","uc_match":"1f6f4","uc_greedy":"1f6f4","shortnames":[],"category":"travel"},":scorpion:":{"uc_base":"1f982","uc_output":"1f982","uc_match":"1f982","uc_greedy":"1f982","shortnames":[],"category":"nature"},":scream:":{"uc_base":"1f631","uc_output":"1f631","uc_match":"1f631","uc_greedy":"1f631","shortnames":[],"category":"people"},":scream_cat:":{"uc_base":"1f640","uc_output":"1f640","uc_match":"1f640","uc_greedy":"1f640","shortnames":[],"category":"people"},":scroll:":{"uc_base":"1f4dc","uc_output":"1f4dc","uc_match":"1f4dc","uc_greedy":"1f4dc","shortnames":[],"category":"objects"},":seat:":{"uc_base":"1f4ba","uc_output":"1f4ba","uc_match":"1f4ba","uc_greedy":"1f4ba","shortnames":[],"category":"travel"},":second_place:":{"uc_base":"1f948","uc_output":"1f948","uc_match":"1f948","uc_greedy":"1f948","shortnames":[":second_place_medal:"],"category":"activity"},":see_no_evil:":{"uc_base":"1f648","uc_output":"1f648","uc_match":"1f648","uc_greedy":"1f648","shortnames":[],"category":"nature"},":seedling:":{"uc_base":"1f331","uc_output":"1f331","uc_match":"1f331","uc_greedy":"1f331","shortnames":[],"category":"nature"},":selfie:":{"uc_base":"1f933","uc_output":"1f933","uc_match":"1f933","uc_greedy":"1f933","shortnames":[],"category":"people"},":shallow_pan_of_food:":{"uc_base":"1f958","uc_output":"1f958","uc_match":"1f958","uc_greedy":"1f958","shortnames":[":paella:"],"category":"food"},":shark:":{"uc_base":"1f988","uc_output":"1f988","uc_match":"1f988","uc_greedy":"1f988","shortnames":[],"category":"nature"},":shaved_ice:":{"uc_base":"1f367","uc_output":"1f367","uc_match":"1f367","uc_greedy":"1f367","shortnames":[],"category":"food"},":sheep:":{"uc_base":"1f411","uc_output":"1f411","uc_match":"1f411","uc_greedy":"1f411","shortnames":[],"category":"nature"},":shell:":{"uc_base":"1f41a","uc_output":"1f41a","uc_match":"1f41a","uc_greedy":"1f41a","shortnames":[],"category":"nature"},":shield:":{"uc_base":"1f6e1","uc_output":"1f6e1","uc_match":"1f6e1-fe0f","uc_greedy":"1f6e1-fe0f","shortnames":[],"category":"objects"},":ship:":{"uc_base":"1f6a2","uc_output":"1f6a2","uc_match":"1f6a2","uc_greedy":"1f6a2","shortnames":[],"category":"travel"},":shirt:":{"uc_base":"1f455","uc_output":"1f455","uc_match":"1f455","uc_greedy":"1f455","shortnames":[],"category":"people"},":shopping_bags:":{"uc_base":"1f6cd","uc_output":"1f6cd","uc_match":"1f6cd-fe0f","uc_greedy":"1f6cd-fe0f","shortnames":[],"category":"objects"},":shopping_cart:":{"uc_base":"1f6d2","uc_output":"1f6d2","uc_match":"1f6d2","uc_greedy":"1f6d2","shortnames":[":shopping_trolley:"],"category":"objects"},":shower:":{"uc_base":"1f6bf","uc_output":"1f6bf","uc_match":"1f6bf","uc_greedy":"1f6bf","shortnames":[],"category":"objects"},":shrimp:":{"uc_base":"1f990","uc_output":"1f990","uc_match":"1f990","uc_greedy":"1f990","shortnames":[],"category":"nature"},":shushing_face:":{"uc_base":"1f92b","uc_output":"1f92b","uc_match":"1f92b","uc_greedy":"1f92b","shortnames":[],"category":"people"},":signal_strength:":{"uc_base":"1f4f6","uc_output":"1f4f6","uc_match":"1f4f6","uc_greedy":"1f4f6","shortnames":[],"category":"symbols"},":six_pointed_star:":{"uc_base":"1f52f","uc_output":"1f52f","uc_match":"1f52f","uc_greedy":"1f52f","shortnames":[],"category":"symbols"},":skateboard:":{"uc_base":"1f6f9","uc_output":"1f6f9","uc_match":"1f6f9","uc_greedy":"1f6f9","shortnames":[],"category":"activity"},":ski:":{"uc_base":"1f3bf","uc_output":"1f3bf","uc_match":"1f3bf","uc_greedy":"1f3bf","shortnames":[],"category":"activity"},":skull:":{"uc_base":"1f480","uc_output":"1f480","uc_match":"1f480","uc_greedy":"1f480","shortnames":[":skeleton:"],"category":"people"},":sled:":{"uc_base":"1f6f7","uc_output":"1f6f7","uc_match":"1f6f7","uc_greedy":"1f6f7","shortnames":[],"category":"activity"},":sleeping:":{"uc_base":"1f634","uc_output":"1f634","uc_match":"1f634","uc_greedy":"1f634","shortnames":[],"category":"people"},":sleeping_accommodation:":{"uc_base":"1f6cc","uc_output":"1f6cc","uc_match":"1f6cc","uc_greedy":"1f6cc","shortnames":[],"category":"objects"},":sleepy:":{"uc_base":"1f62a","uc_output":"1f62a","uc_match":"1f62a","uc_greedy":"1f62a","shortnames":[],"category":"people"},":slight_frown:":{"uc_base":"1f641","uc_output":"1f641","uc_match":"1f641","uc_greedy":"1f641","shortnames":[":slightly_frowning_face:"],"category":"people"},":slight_smile:":{"uc_base":"1f642","uc_output":"1f642","uc_match":"1f642","uc_greedy":"1f642","shortnames":[":slightly_smiling_face:"],"category":"people"},":slot_machine:":{"uc_base":"1f3b0","uc_output":"1f3b0","uc_match":"1f3b0","uc_greedy":"1f3b0","shortnames":[],"category":"activity"},":small_blue_diamond:":{"uc_base":"1f539","uc_output":"1f539","uc_match":"1f539","uc_greedy":"1f539","shortnames":[],"category":"symbols"},":small_orange_diamond:":{"uc_base":"1f538","uc_output":"1f538","uc_match":"1f538","uc_greedy":"1f538","shortnames":[],"category":"symbols"},":small_red_triangle:":{"uc_base":"1f53a","uc_output":"1f53a","uc_match":"1f53a","uc_greedy":"1f53a","shortnames":[],"category":"symbols"},":small_red_triangle_down:":{"uc_base":"1f53b","uc_output":"1f53b","uc_match":"1f53b","uc_greedy":"1f53b","shortnames":[],"category":"symbols"},":smile:":{"uc_base":"1f604","uc_output":"1f604","uc_match":"1f604","uc_greedy":"1f604","shortnames":[],"category":"people"},":smile_cat:":{"uc_base":"1f638","uc_output":"1f638","uc_match":"1f638","uc_greedy":"1f638","shortnames":[],"category":"people"},":smiley:":{"uc_base":"1f603","uc_output":"1f603","uc_match":"1f603","uc_greedy":"1f603","shortnames":[],"category":"people"},":smiley_cat:":{"uc_base":"1f63a","uc_output":"1f63a","uc_match":"1f63a","uc_greedy":"1f63a","shortnames":[],"category":"people"},":smiling_face_with_3_hearts:":{"uc_base":"1f970","uc_output":"1f970","uc_match":"1f970","uc_greedy":"1f970","shortnames":[],"category":"people"},":smiling_imp:":{"uc_base":"1f608","uc_output":"1f608","uc_match":"1f608","uc_greedy":"1f608","shortnames":[],"category":"people"},":smirk:":{"uc_base":"1f60f","uc_output":"1f60f","uc_match":"1f60f","uc_greedy":"1f60f","shortnames":[],"category":"people"},":smirk_cat:":{"uc_base":"1f63c","uc_output":"1f63c","uc_match":"1f63c","uc_greedy":"1f63c","shortnames":[],"category":"people"},":smoking:":{"uc_base":"1f6ac","uc_output":"1f6ac","uc_match":"1f6ac","uc_greedy":"1f6ac","shortnames":[],"category":"objects"},":snail:":{"uc_base":"1f40c","uc_output":"1f40c","uc_match":"1f40c","uc_greedy":"1f40c","shortnames":[],"category":"nature"},":snake:":{"uc_base":"1f40d","uc_output":"1f40d","uc_match":"1f40d","uc_greedy":"1f40d","shortnames":[],"category":"nature"},":sneezing_face:":{"uc_base":"1f927","uc_output":"1f927","uc_match":"1f927","uc_greedy":"1f927","shortnames":[":sneeze:"],"category":"people"},":snowboarder:":{"uc_base":"1f3c2","uc_output":"1f3c2","uc_match":"1f3c2-fe0f","uc_greedy":"1f3c2-fe0f","shortnames":[],"category":"activity"},":soap:":{"uc_base":"1f9fc","uc_output":"1f9fc","uc_match":"1f9fc","uc_greedy":"1f9fc","shortnames":[],"category":"objects"},":sob:":{"uc_base":"1f62d","uc_output":"1f62d","uc_match":"1f62d","uc_greedy":"1f62d","shortnames":[],"category":"people"},":socks:":{"uc_base":"1f9e6","uc_output":"1f9e6","uc_match":"1f9e6","uc_greedy":"1f9e6","shortnames":[],"category":"people"},":softball:":{"uc_base":"1f94e","uc_output":"1f94e","uc_match":"1f94e","uc_greedy":"1f94e","shortnames":[],"category":"activity"},":soon:":{"uc_base":"1f51c","uc_output":"1f51c","uc_match":"1f51c","uc_greedy":"1f51c","shortnames":[],"category":"symbols"},":sos:":{"uc_base":"1f198","uc_output":"1f198","uc_match":"1f198","uc_greedy":"1f198","shortnames":[],"category":"symbols"},":sound:":{"uc_base":"1f509","uc_output":"1f509","uc_match":"1f509","uc_greedy":"1f509","shortnames":[],"category":"symbols"},":space_invader:":{"uc_base":"1f47e","uc_output":"1f47e","uc_match":"1f47e","uc_greedy":"1f47e","shortnames":[],"category":"people"},":spaghetti:":{"uc_base":"1f35d","uc_output":"1f35d","uc_match":"1f35d","uc_greedy":"1f35d","shortnames":[],"category":"food"},":sparkler:":{"uc_base":"1f387","uc_output":"1f387","uc_match":"1f387","uc_greedy":"1f387","shortnames":[],"category":"travel"},":sparkling_heart:":{"uc_base":"1f496","uc_output":"1f496","uc_match":"1f496","uc_greedy":"1f496","shortnames":[],"category":"symbols"},":speak_no_evil:":{"uc_base":"1f64a","uc_output":"1f64a","uc_match":"1f64a","uc_greedy":"1f64a","shortnames":[],"category":"nature"},":speaker:":{"uc_base":"1f508","uc_output":"1f508","uc_match":"1f508-fe0f","uc_greedy":"1f508-fe0f","shortnames":[],"category":"symbols"},":speaking_head:":{"uc_base":"1f5e3","uc_output":"1f5e3","uc_match":"1f5e3-fe0f","uc_greedy":"1f5e3-fe0f","shortnames":[":speaking_head_in_silhouette:"],"category":"people"},":speech_balloon:":{"uc_base":"1f4ac","uc_output":"1f4ac","uc_match":"1f4ac","uc_greedy":"1f4ac","shortnames":[],"category":"symbols"},":speech_left:":{"uc_base":"1f5e8","uc_output":"1f5e8","uc_match":"1f5e8-fe0f","uc_greedy":"1f5e8-fe0f","shortnames":[":left_speech_bubble:"],"category":"symbols"},":speedboat:":{"uc_base":"1f6a4","uc_output":"1f6a4","uc_match":"1f6a4","uc_greedy":"1f6a4","shortnames":[],"category":"travel"},":spider:":{"uc_base":"1f577","uc_output":"1f577","uc_match":"1f577-fe0f","uc_greedy":"1f577-fe0f","shortnames":[],"category":"nature"},":spider_web:":{"uc_base":"1f578","uc_output":"1f578","uc_match":"1f578-fe0f","uc_greedy":"1f578-fe0f","shortnames":[],"category":"nature"},":sponge:":{"uc_base":"1f9fd","uc_output":"1f9fd","uc_match":"1f9fd","uc_greedy":"1f9fd","shortnames":[],"category":"objects"},":spoon:":{"uc_base":"1f944","uc_output":"1f944","uc_match":"1f944","uc_greedy":"1f944","shortnames":[],"category":"food"},":squeeze_bottle:":{"uc_base":"1f9f4","uc_output":"1f9f4","uc_match":"1f9f4","uc_greedy":"1f9f4","shortnames":[],"category":"objects"},":squid:":{"uc_base":"1f991","uc_output":"1f991","uc_match":"1f991","uc_greedy":"1f991","shortnames":[],"category":"nature"},":stadium:":{"uc_base":"1f3df","uc_output":"1f3df","uc_match":"1f3df-fe0f","uc_greedy":"1f3df-fe0f","shortnames":[],"category":"travel"},":star2:":{"uc_base":"1f31f","uc_output":"1f31f","uc_match":"1f31f","uc_greedy":"1f31f","shortnames":[],"category":"nature"},":star_struck:":{"uc_base":"1f929","uc_output":"1f929","uc_match":"1f929","uc_greedy":"1f929","shortnames":[],"category":"people"},":stars:":{"uc_base":"1f320","uc_output":"1f320","uc_match":"1f320","uc_greedy":"1f320","shortnames":[],"category":"travel"},":station:":{"uc_base":"1f689","uc_output":"1f689","uc_match":"1f689","uc_greedy":"1f689","shortnames":[],"category":"travel"},":statue_of_liberty:":{"uc_base":"1f5fd","uc_output":"1f5fd","uc_match":"1f5fd","uc_greedy":"1f5fd","shortnames":[],"category":"travel"},":steam_locomotive:":{"uc_base":"1f682","uc_output":"1f682","uc_match":"1f682","uc_greedy":"1f682","shortnames":[],"category":"travel"},":stew:":{"uc_base":"1f372","uc_output":"1f372","uc_match":"1f372","uc_greedy":"1f372","shortnames":[],"category":"food"},":straight_ruler:":{"uc_base":"1f4cf","uc_output":"1f4cf","uc_match":"1f4cf","uc_greedy":"1f4cf","shortnames":[],"category":"objects"},":strawberry:":{"uc_base":"1f353","uc_output":"1f353","uc_match":"1f353","uc_greedy":"1f353","shortnames":[],"category":"food"},":stuck_out_tongue:":{"uc_base":"1f61b","uc_output":"1f61b","uc_match":"1f61b","uc_greedy":"1f61b","shortnames":[],"category":"people"},":stuck_out_tongue_closed_eyes:":{"uc_base":"1f61d","uc_output":"1f61d","uc_match":"1f61d","uc_greedy":"1f61d","shortnames":[],"category":"people"},":stuck_out_tongue_winking_eye:":{"uc_base":"1f61c","uc_output":"1f61c","uc_match":"1f61c","uc_greedy":"1f61c","shortnames":[],"category":"people"},":stuffed_flatbread:":{"uc_base":"1f959","uc_output":"1f959","uc_match":"1f959","uc_greedy":"1f959","shortnames":[":stuffed_pita:"],"category":"food"},":sun_with_face:":{"uc_base":"1f31e","uc_output":"1f31e","uc_match":"1f31e","uc_greedy":"1f31e","shortnames":[],"category":"nature"},":sunflower:":{"uc_base":"1f33b","uc_output":"1f33b","uc_match":"1f33b","uc_greedy":"1f33b","shortnames":[],"category":"nature"},":sunglasses:":{"uc_base":"1f60e","uc_output":"1f60e","uc_match":"1f60e","uc_greedy":"1f60e","shortnames":[],"category":"people"},":sunrise:":{"uc_base":"1f305","uc_output":"1f305","uc_match":"1f305","uc_greedy":"1f305","shortnames":[],"category":"travel"},":sunrise_over_mountains:":{"uc_base":"1f304","uc_output":"1f304","uc_match":"1f304","uc_greedy":"1f304","shortnames":[],"category":"travel"},":superhero:":{"uc_base":"1f9b8","uc_output":"1f9b8","uc_match":"1f9b8","uc_greedy":"1f9b8","shortnames":[],"category":"people"},":supervillain:":{"uc_base":"1f9b9","uc_output":"1f9b9","uc_match":"1f9b9","uc_greedy":"1f9b9","shortnames":[],"category":"people"},":sushi:":{"uc_base":"1f363","uc_output":"1f363","uc_match":"1f363","uc_greedy":"1f363","shortnames":[],"category":"food"},":suspension_railway:":{"uc_base":"1f69f","uc_output":"1f69f","uc_match":"1f69f","uc_greedy":"1f69f","shortnames":[],"category":"travel"},":swan:":{"uc_base":"1f9a2","uc_output":"1f9a2","uc_match":"1f9a2","uc_greedy":"1f9a2","shortnames":[],"category":"nature"},":sweat:":{"uc_base":"1f613","uc_output":"1f613","uc_match":"1f613","uc_greedy":"1f613","shortnames":[],"category":"people"},":sweat_drops:":{"uc_base":"1f4a6","uc_output":"1f4a6","uc_match":"1f4a6","uc_greedy":"1f4a6","shortnames":[],"category":"nature"},":sweat_smile:":{"uc_base":"1f605","uc_output":"1f605","uc_match":"1f605","uc_greedy":"1f605","shortnames":[],"category":"people"},":sweet_potato:":{"uc_base":"1f360","uc_output":"1f360","uc_match":"1f360","uc_greedy":"1f360","shortnames":[],"category":"food"},":symbols:":{"uc_base":"1f523","uc_output":"1f523","uc_match":"1f523","uc_greedy":"1f523","shortnames":[],"category":"symbols"},":synagogue:":{"uc_base":"1f54d","uc_output":"1f54d","uc_match":"1f54d","uc_greedy":"1f54d","shortnames":[],"category":"travel"},":syringe:":{"uc_base":"1f489","uc_output":"1f489","uc_match":"1f489","uc_greedy":"1f489","shortnames":[],"category":"objects"},":t_rex:":{"uc_base":"1f996","uc_output":"1f996","uc_match":"1f996","uc_greedy":"1f996","shortnames":[],"category":"nature"},":taco:":{"uc_base":"1f32e","uc_output":"1f32e","uc_match":"1f32e","uc_greedy":"1f32e","shortnames":[],"category":"food"},":tada:":{"uc_base":"1f389","uc_output":"1f389","uc_match":"1f389","uc_greedy":"1f389","shortnames":[],"category":"objects"},":takeout_box:":{"uc_base":"1f961","uc_output":"1f961","uc_match":"1f961","uc_greedy":"1f961","shortnames":[],"category":"food"},":tanabata_tree:":{"uc_base":"1f38b","uc_output":"1f38b","uc_match":"1f38b","uc_greedy":"1f38b","shortnames":[],"category":"nature"},":tangerine:":{"uc_base":"1f34a","uc_output":"1f34a","uc_match":"1f34a","uc_greedy":"1f34a","shortnames":[],"category":"food"},":taxi:":{"uc_base":"1f695","uc_output":"1f695","uc_match":"1f695","uc_greedy":"1f695","shortnames":[],"category":"travel"},":tea:":{"uc_base":"1f375","uc_output":"1f375","uc_match":"1f375","uc_greedy":"1f375","shortnames":[],"category":"food"},":teddy_bear:":{"uc_base":"1f9f8","uc_output":"1f9f8","uc_match":"1f9f8","uc_greedy":"1f9f8","shortnames":[],"category":"objects"},":telephone_receiver:":{"uc_base":"1f4de","uc_output":"1f4de","uc_match":"1f4de","uc_greedy":"1f4de","shortnames":[],"category":"objects"},":telescope:":{"uc_base":"1f52d","uc_output":"1f52d","uc_match":"1f52d","uc_greedy":"1f52d","shortnames":[],"category":"objects"},":tennis:":{"uc_base":"1f3be","uc_output":"1f3be","uc_match":"1f3be","uc_greedy":"1f3be","shortnames":[],"category":"activity"},":test_tube:":{"uc_base":"1f9ea","uc_output":"1f9ea","uc_match":"1f9ea","uc_greedy":"1f9ea","shortnames":[],"category":"objects"},":thermometer:":{"uc_base":"1f321","uc_output":"1f321","uc_match":"1f321-fe0f","uc_greedy":"1f321-fe0f","shortnames":[],"category":"objects"},":thermometer_face:":{"uc_base":"1f912","uc_output":"1f912","uc_match":"1f912","uc_greedy":"1f912","shortnames":[":face_with_thermometer:"],"category":"people"},":thinking:":{"uc_base":"1f914","uc_output":"1f914","uc_match":"1f914","uc_greedy":"1f914","shortnames":[":thinking_face:"],"category":"people"},":third_place:":{"uc_base":"1f949","uc_output":"1f949","uc_match":"1f949","uc_greedy":"1f949","shortnames":[":third_place_medal:"],"category":"activity"},":thought_balloon:":{"uc_base":"1f4ad","uc_output":"1f4ad","uc_match":"1f4ad","uc_greedy":"1f4ad","shortnames":[],"category":"symbols"},":thread:":{"uc_base":"1f9f5","uc_output":"1f9f5","uc_match":"1f9f5","uc_greedy":"1f9f5","shortnames":[],"category":"objects"},":thumbsdown:":{"uc_base":"1f44e","uc_output":"1f44e","uc_match":"1f44e-fe0f","uc_greedy":"1f44e-fe0f","shortnames":[":-1:",":thumbdown:"],"category":"people"},":thumbsup:":{"uc_base":"1f44d","uc_output":"1f44d","uc_match":"1f44d-fe0f","uc_greedy":"1f44d-fe0f","shortnames":[":+1:",":thumbup:"],"category":"people"},":ticket:":{"uc_base":"1f3ab","uc_output":"1f3ab","uc_match":"1f3ab","uc_greedy":"1f3ab","shortnames":[],"category":"activity"},":tickets:":{"uc_base":"1f39f","uc_output":"1f39f","uc_match":"1f39f-fe0f","uc_greedy":"1f39f-fe0f","shortnames":[":admission_tickets:"],"category":"activity"},":tiger2:":{"uc_base":"1f405","uc_output":"1f405","uc_match":"1f405","uc_greedy":"1f405","shortnames":[],"category":"nature"},":tiger:":{"uc_base":"1f42f","uc_output":"1f42f","uc_match":"1f42f","uc_greedy":"1f42f","shortnames":[],"category":"nature"},":tired_face:":{"uc_base":"1f62b","uc_output":"1f62b","uc_match":"1f62b","uc_greedy":"1f62b","shortnames":[],"category":"people"},":toilet:":{"uc_base":"1f6bd","uc_output":"1f6bd","uc_match":"1f6bd","uc_greedy":"1f6bd","shortnames":[],"category":"objects"},":tokyo_tower:":{"uc_base":"1f5fc","uc_output":"1f5fc","uc_match":"1f5fc","uc_greedy":"1f5fc","shortnames":[],"category":"travel"},":tomato:":{"uc_base":"1f345","uc_output":"1f345","uc_match":"1f345","uc_greedy":"1f345","shortnames":[],"category":"food"},":tone1:":{"uc_base":"1f3fb","uc_output":"1f3fb","uc_match":"1f3fb","uc_greedy":"1f3fb","shortnames":[],"category":"modifier"},":tone2:":{"uc_base":"1f3fc","uc_output":"1f3fc","uc_match":"1f3fc","uc_greedy":"1f3fc","shortnames":[],"category":"modifier"},":tone3:":{"uc_base":"1f3fd","uc_output":"1f3fd","uc_match":"1f3fd","uc_greedy":"1f3fd","shortnames":[],"category":"modifier"},":tone4:":{"uc_base":"1f3fe","uc_output":"1f3fe","uc_match":"1f3fe","uc_greedy":"1f3fe","shortnames":[],"category":"modifier"},":tone5:":{"uc_base":"1f3ff","uc_output":"1f3ff","uc_match":"1f3ff","uc_greedy":"1f3ff","shortnames":[],"category":"modifier"},":tongue:":{"uc_base":"1f445","uc_output":"1f445","uc_match":"1f445","uc_greedy":"1f445","shortnames":[],"category":"people"},":toolbox:":{"uc_base":"1f9f0","uc_output":"1f9f0","uc_match":"1f9f0","uc_greedy":"1f9f0","shortnames":[],"category":"objects"},":tools:":{"uc_base":"1f6e0","uc_output":"1f6e0","uc_match":"1f6e0-fe0f","uc_greedy":"1f6e0-fe0f","shortnames":[":hammer_and_wrench:"],"category":"objects"},":tooth:":{"uc_base":"1f9b7","uc_output":"1f9b7","uc_match":"1f9b7","uc_greedy":"1f9b7","shortnames":[],"category":"people"},":top:":{"uc_base":"1f51d","uc_output":"1f51d","uc_match":"1f51d","uc_greedy":"1f51d","shortnames":[],"category":"symbols"},":tophat:":{"uc_base":"1f3a9","uc_output":"1f3a9","uc_match":"1f3a9","uc_greedy":"1f3a9","shortnames":[],"category":"people"},":trackball:":{"uc_base":"1f5b2","uc_output":"1f5b2","uc_match":"1f5b2-fe0f","uc_greedy":"1f5b2-fe0f","shortnames":[],"category":"objects"},":tractor:":{"uc_base":"1f69c","uc_output":"1f69c","uc_match":"1f69c","uc_greedy":"1f69c","shortnames":[],"category":"travel"},":traffic_light:":{"uc_base":"1f6a5","uc_output":"1f6a5","uc_match":"1f6a5","uc_greedy":"1f6a5","shortnames":[],"category":"travel"},":train2:":{"uc_base":"1f686","uc_output":"1f686","uc_match":"1f686","uc_greedy":"1f686","shortnames":[],"category":"travel"},":train:":{"uc_base":"1f68b","uc_output":"1f68b","uc_match":"1f68b","uc_greedy":"1f68b","shortnames":[],"category":"travel"},":tram:":{"uc_base":"1f68a","uc_output":"1f68a","uc_match":"1f68a","uc_greedy":"1f68a","shortnames":[],"category":"travel"},":triangular_flag_on_post:":{"uc_base":"1f6a9","uc_output":"1f6a9","uc_match":"1f6a9","uc_greedy":"1f6a9","shortnames":[],"category":"flags"},":triangular_ruler:":{"uc_base":"1f4d0","uc_output":"1f4d0","uc_match":"1f4d0","uc_greedy":"1f4d0","shortnames":[],"category":"objects"},":trident:":{"uc_base":"1f531","uc_output":"1f531","uc_match":"1f531","uc_greedy":"1f531","shortnames":[],"category":"symbols"},":triumph:":{"uc_base":"1f624","uc_output":"1f624","uc_match":"1f624","uc_greedy":"1f624","shortnames":[],"category":"people"},":trolleybus:":{"uc_base":"1f68e","uc_output":"1f68e","uc_match":"1f68e","uc_greedy":"1f68e","shortnames":[],"category":"travel"},":trophy:":{"uc_base":"1f3c6","uc_output":"1f3c6","uc_match":"1f3c6-fe0f","uc_greedy":"1f3c6-fe0f","shortnames":[],"category":"activity"},":tropical_drink:":{"uc_base":"1f379","uc_output":"1f379","uc_match":"1f379","uc_greedy":"1f379","shortnames":[],"category":"food"},":tropical_fish:":{"uc_base":"1f420","uc_output":"1f420","uc_match":"1f420","uc_greedy":"1f420","shortnames":[],"category":"nature"},":truck:":{"uc_base":"1f69a","uc_output":"1f69a","uc_match":"1f69a","uc_greedy":"1f69a","shortnames":[],"category":"travel"},":trumpet:":{"uc_base":"1f3ba","uc_output":"1f3ba","uc_match":"1f3ba","uc_greedy":"1f3ba","shortnames":[],"category":"activity"},":tulip:":{"uc_base":"1f337","uc_output":"1f337","uc_match":"1f337","uc_greedy":"1f337","shortnames":[],"category":"nature"},":tumbler_glass:":{"uc_base":"1f943","uc_output":"1f943","uc_match":"1f943","uc_greedy":"1f943","shortnames":[":whisky:"],"category":"food"},":turkey:":{"uc_base":"1f983","uc_output":"1f983","uc_match":"1f983","uc_greedy":"1f983","shortnames":[],"category":"nature"},":turtle:":{"uc_base":"1f422","uc_output":"1f422","uc_match":"1f422","uc_greedy":"1f422","shortnames":[],"category":"nature"},":tv:":{"uc_base":"1f4fa","uc_output":"1f4fa","uc_match":"1f4fa-fe0f","uc_greedy":"1f4fa-fe0f","shortnames":[],"category":"objects"},":twisted_rightwards_arrows:":{"uc_base":"1f500","uc_output":"1f500","uc_match":"1f500","uc_greedy":"1f500","shortnames":[],"category":"symbols"},":two_hearts:":{"uc_base":"1f495","uc_output":"1f495","uc_match":"1f495","uc_greedy":"1f495","shortnames":[],"category":"symbols"},":two_men_holding_hands:":{"uc_base":"1f46c","uc_output":"1f46c","uc_match":"1f46c","uc_greedy":"1f46c","shortnames":[],"category":"people"},":two_women_holding_hands:":{"uc_base":"1f46d","uc_output":"1f46d","uc_match":"1f46d","uc_greedy":"1f46d","shortnames":[],"category":"people"},":u5272:":{"uc_base":"1f239","uc_output":"1f239","uc_match":"1f239","uc_greedy":"1f239","shortnames":[],"category":"symbols"},":u5408:":{"uc_base":"1f234","uc_output":"1f234","uc_match":"1f234","uc_greedy":"1f234","shortnames":[],"category":"symbols"},":u55b6:":{"uc_base":"1f23a","uc_output":"1f23a","uc_match":"1f23a","uc_greedy":"1f23a","shortnames":[],"category":"symbols"},":u6307:":{"uc_base":"1f22f","uc_output":"1f22f","uc_match":"1f22f-fe0f","uc_greedy":"1f22f-fe0f","shortnames":[],"category":"symbols"},":u6708:":{"uc_base":"1f237","uc_output":"1f237","uc_match":"1f237-fe0f","uc_greedy":"1f237-fe0f","shortnames":[],"category":"symbols"},":u6709:":{"uc_base":"1f236","uc_output":"1f236","uc_match":"1f236","uc_greedy":"1f236","shortnames":[],"category":"symbols"},":u6e80:":{"uc_base":"1f235","uc_output":"1f235","uc_match":"1f235","uc_greedy":"1f235","shortnames":[],"category":"symbols"},":u7121:":{"uc_base":"1f21a","uc_output":"1f21a","uc_match":"1f21a-fe0f","uc_greedy":"1f21a-fe0f","shortnames":[],"category":"symbols"},":u7533:":{"uc_base":"1f238","uc_output":"1f238","uc_match":"1f238","uc_greedy":"1f238","shortnames":[],"category":"symbols"},":u7981:":{"uc_base":"1f232","uc_output":"1f232","uc_match":"1f232","uc_greedy":"1f232","shortnames":[],"category":"symbols"},":u7a7a:":{"uc_base":"1f233","uc_output":"1f233","uc_match":"1f233","uc_greedy":"1f233","shortnames":[],"category":"symbols"},":unamused:":{"uc_base":"1f612","uc_output":"1f612","uc_match":"1f612","uc_greedy":"1f612","shortnames":[],"category":"people"},":underage:":{"uc_base":"1f51e","uc_output":"1f51e","uc_match":"1f51e","uc_greedy":"1f51e","shortnames":[],"category":"symbols"},":unicorn:":{"uc_base":"1f984","uc_output":"1f984","uc_match":"1f984","uc_greedy":"1f984","shortnames":[":unicorn_face:"],"category":"nature"},":unlock:":{"uc_base":"1f513","uc_output":"1f513","uc_match":"1f513-fe0f","uc_greedy":"1f513-fe0f","shortnames":[],"category":"objects"},":up:":{"uc_base":"1f199","uc_output":"1f199","uc_match":"1f199","uc_greedy":"1f199","shortnames":[],"category":"symbols"},":upside_down:":{"uc_base":"1f643","uc_output":"1f643","uc_match":"1f643","uc_greedy":"1f643","shortnames":[":upside_down_face:"],"category":"people"},":vampire:":{"uc_base":"1f9db","uc_output":"1f9db","uc_match":"1f9db","uc_greedy":"1f9db","shortnames":[],"category":"people"},":vertical_traffic_light:":{"uc_base":"1f6a6","uc_output":"1f6a6","uc_match":"1f6a6","uc_greedy":"1f6a6","shortnames":[],"category":"travel"},":vhs:":{"uc_base":"1f4fc","uc_output":"1f4fc","uc_match":"1f4fc","uc_greedy":"1f4fc","shortnames":[],"category":"objects"},":vibration_mode:":{"uc_base":"1f4f3","uc_output":"1f4f3","uc_match":"1f4f3","uc_greedy":"1f4f3","shortnames":[],"category":"symbols"},":video_camera:":{"uc_base":"1f4f9","uc_output":"1f4f9","uc_match":"1f4f9-fe0f","uc_greedy":"1f4f9-fe0f","shortnames":[],"category":"objects"},":video_game:":{"uc_base":"1f3ae","uc_output":"1f3ae","uc_match":"1f3ae-fe0f","uc_greedy":"1f3ae-fe0f","shortnames":[],"category":"activity"},":violin:":{"uc_base":"1f3bb","uc_output":"1f3bb","uc_match":"1f3bb","uc_greedy":"1f3bb","shortnames":[],"category":"activity"},":volcano:":{"uc_base":"1f30b","uc_output":"1f30b","uc_match":"1f30b","uc_greedy":"1f30b","shortnames":[],"category":"travel"},":volleyball:":{"uc_base":"1f3d0","uc_output":"1f3d0","uc_match":"1f3d0","uc_greedy":"1f3d0","shortnames":[],"category":"activity"},":vs:":{"uc_base":"1f19a","uc_output":"1f19a","uc_match":"1f19a","uc_greedy":"1f19a","shortnames":[],"category":"symbols"},":vulcan:":{"uc_base":"1f596","uc_output":"1f596","uc_match":"1f596","uc_greedy":"1f596","shortnames":[":raised_hand_with_part_between_middle_and_ring_fingers:"],"category":"people"},":waning_crescent_moon:":{"uc_base":"1f318","uc_output":"1f318","uc_match":"1f318","uc_greedy":"1f318","shortnames":[],"category":"nature"},":waning_gibbous_moon:":{"uc_base":"1f316","uc_output":"1f316","uc_match":"1f316","uc_greedy":"1f316","shortnames":[],"category":"nature"},":wastebasket:":{"uc_base":"1f5d1","uc_output":"1f5d1","uc_match":"1f5d1-fe0f","uc_greedy":"1f5d1-fe0f","shortnames":[],"category":"objects"},":water_buffalo:":{"uc_base":"1f403","uc_output":"1f403","uc_match":"1f403","uc_greedy":"1f403","shortnames":[],"category":"nature"},":watermelon:":{"uc_base":"1f349","uc_output":"1f349","uc_match":"1f349","uc_greedy":"1f349","shortnames":[],"category":"food"},":wave:":{"uc_base":"1f44b","uc_output":"1f44b","uc_match":"1f44b","uc_greedy":"1f44b","shortnames":[],"category":"people"},":waxing_crescent_moon:":{"uc_base":"1f312","uc_output":"1f312","uc_match":"1f312","uc_greedy":"1f312","shortnames":[],"category":"nature"},":waxing_gibbous_moon:":{"uc_base":"1f314","uc_output":"1f314","uc_match":"1f314","uc_greedy":"1f314","shortnames":[],"category":"nature"},":wc:":{"uc_base":"1f6be","uc_output":"1f6be","uc_match":"1f6be","uc_greedy":"1f6be","shortnames":[],"category":"symbols"},":weary:":{"uc_base":"1f629","uc_output":"1f629","uc_match":"1f629","uc_greedy":"1f629","shortnames":[],"category":"people"},":wedding:":{"uc_base":"1f492","uc_output":"1f492","uc_match":"1f492","uc_greedy":"1f492","shortnames":[],"category":"travel"},":whale2:":{"uc_base":"1f40b","uc_output":"1f40b","uc_match":"1f40b","uc_greedy":"1f40b","shortnames":[],"category":"nature"},":whale:":{"uc_base":"1f433","uc_output":"1f433","uc_match":"1f433","uc_greedy":"1f433","shortnames":[],"category":"nature"},":white_flower:":{"uc_base":"1f4ae","uc_output":"1f4ae","uc_match":"1f4ae","uc_greedy":"1f4ae","shortnames":[],"category":"symbols"},":white_haired:":{"uc_base":"1f9b3","uc_output":"1f9b3","uc_match":"1f9b3","uc_greedy":"1f9b3","shortnames":[],"category":"people"},":white_square_button:":{"uc_base":"1f533","uc_output":"1f533","uc_match":"1f533","uc_greedy":"1f533","shortnames":[],"category":"symbols"},":white_sun_cloud:":{"uc_base":"1f325","uc_output":"1f325","uc_match":"1f325-fe0f","uc_greedy":"1f325-fe0f","shortnames":[":white_sun_behind_cloud:"],"category":"nature"},":white_sun_rain_cloud:":{"uc_base":"1f326","uc_output":"1f326","uc_match":"1f326-fe0f","uc_greedy":"1f326-fe0f","shortnames":[":white_sun_behind_cloud_with_rain:"],"category":"nature"},":white_sun_small_cloud:":{"uc_base":"1f324","uc_output":"1f324","uc_match":"1f324-fe0f","uc_greedy":"1f324-fe0f","shortnames":[":white_sun_with_small_cloud:"],"category":"nature"},":wilted_rose:":{"uc_base":"1f940","uc_output":"1f940","uc_match":"1f940","uc_greedy":"1f940","shortnames":[":wilted_flower:"],"category":"nature"},":wind_blowing_face:":{"uc_base":"1f32c","uc_output":"1f32c","uc_match":"1f32c-fe0f","uc_greedy":"1f32c-fe0f","shortnames":[],"category":"nature"},":wind_chime:":{"uc_base":"1f390","uc_output":"1f390","uc_match":"1f390","uc_greedy":"1f390","shortnames":[],"category":"objects"},":wine_glass:":{"uc_base":"1f377","uc_output":"1f377","uc_match":"1f377","uc_greedy":"1f377","shortnames":[],"category":"food"},":wink:":{"uc_base":"1f609","uc_output":"1f609","uc_match":"1f609","uc_greedy":"1f609","shortnames":[],"category":"people"},":wolf:":{"uc_base":"1f43a","uc_output":"1f43a","uc_match":"1f43a","uc_greedy":"1f43a","shortnames":[],"category":"nature"},":woman:":{"uc_base":"1f469","uc_output":"1f469","uc_match":"1f469","uc_greedy":"1f469","shortnames":[],"category":"people"},":woman_with_headscarf:":{"uc_base":"1f9d5","uc_output":"1f9d5","uc_match":"1f9d5","uc_greedy":"1f9d5","shortnames":[],"category":"people"},":womans_clothes:":{"uc_base":"1f45a","uc_output":"1f45a","uc_match":"1f45a","uc_greedy":"1f45a","shortnames":[],"category":"people"},":womans_flat_shoe:":{"uc_base":"1f97f","uc_output":"1f97f","uc_match":"1f97f","uc_greedy":"1f97f","shortnames":[],"category":"people"},":womans_hat:":{"uc_base":"1f452","uc_output":"1f452","uc_match":"1f452","uc_greedy":"1f452","shortnames":[],"category":"people"},":womens:":{"uc_base":"1f6ba","uc_output":"1f6ba","uc_match":"1f6ba-fe0f","uc_greedy":"1f6ba-fe0f","shortnames":[],"category":"symbols"},":woozy_face:":{"uc_base":"1f974","uc_output":"1f974","uc_match":"1f974","uc_greedy":"1f974","shortnames":[],"category":"people"},":worried:":{"uc_base":"1f61f","uc_output":"1f61f","uc_match":"1f61f","uc_greedy":"1f61f","shortnames":[],"category":"people"},":wrench:":{"uc_base":"1f527","uc_output":"1f527","uc_match":"1f527","uc_greedy":"1f527","shortnames":[],"category":"objects"},":yarn:":{"uc_base":"1f9f6","uc_output":"1f9f6","uc_match":"1f9f6","uc_greedy":"1f9f6","shortnames":[],"category":"objects"},":yellow_heart:":{"uc_base":"1f49b","uc_output":"1f49b","uc_match":"1f49b","uc_greedy":"1f49b","shortnames":[],"category":"symbols"},":yen:":{"uc_base":"1f4b4","uc_output":"1f4b4","uc_match":"1f4b4","uc_greedy":"1f4b4","shortnames":[],"category":"objects"},":yum:":{"uc_base":"1f60b","uc_output":"1f60b","uc_match":"1f60b","uc_greedy":"1f60b","shortnames":[],"category":"people"},":zany_face:":{"uc_base":"1f92a","uc_output":"1f92a","uc_match":"1f92a","uc_greedy":"1f92a","shortnames":[],"category":"people"},":zebra:":{"uc_base":"1f993","uc_output":"1f993","uc_match":"1f993","uc_greedy":"1f993","shortnames":[],"category":"nature"},":zipper_mouth:":{"uc_base":"1f910","uc_output":"1f910","uc_match":"1f910","uc_greedy":"1f910","shortnames":[":zipper_mouth_face:"],"category":"people"},":zombie:":{"uc_base":"1f9df","uc_output":"1f9df","uc_match":"1f9df","uc_greedy":"1f9df","shortnames":[],"category":"people"},":zzz:":{"uc_base":"1f4a4","uc_output":"1f4a4","uc_match":"1f4a4","uc_greedy":"1f4a4","shortnames":[],"category":"symbols"},":airplane:":{"uc_base":"2708","uc_output":"2708","uc_match":"2708-fe0f","uc_greedy":"2708-fe0f","shortnames":[],"category":"travel"},":alarm_clock:":{"uc_base":"23f0","uc_output":"23f0","uc_match":"23f0","uc_greedy":"23f0","shortnames":[],"category":"objects"},":alembic:":{"uc_base":"2697","uc_output":"2697","uc_match":"2697-fe0f","uc_greedy":"2697-fe0f","shortnames":[],"category":"objects"},":anchor:":{"uc_base":"2693","uc_output":"2693","uc_match":"2693-fe0f","uc_greedy":"2693-fe0f","shortnames":[],"category":"travel"},":aquarius:":{"uc_base":"2652","uc_output":"2652","uc_match":"2652-fe0f","uc_greedy":"2652-fe0f","shortnames":[],"category":"symbols"},":aries:":{"uc_base":"2648","uc_output":"2648","uc_match":"2648-fe0f","uc_greedy":"2648-fe0f","shortnames":[],"category":"symbols"},":arrow_backward:":{"uc_base":"25c0","uc_output":"25c0","uc_match":"25c0-fe0f","uc_greedy":"25c0","shortnames":[],"category":"symbols"},":arrow_double_down:":{"uc_base":"23ec","uc_output":"23ec","uc_match":"23ec","uc_greedy":"23ec","shortnames":[],"category":"symbols"},":arrow_double_up:":{"uc_base":"23eb","uc_output":"23eb","uc_match":"23eb","uc_greedy":"23eb","shortnames":[],"category":"symbols"},":arrow_down:":{"uc_base":"2b07","uc_output":"2b07","uc_match":"2b07-fe0f","uc_greedy":"2b07","shortnames":[],"category":"symbols"},":arrow_forward:":{"uc_base":"25b6","uc_output":"25b6","uc_match":"25b6-fe0f","uc_greedy":"25b6","shortnames":[],"category":"symbols"},":arrow_heading_down:":{"uc_base":"2935","uc_output":"2935","uc_match":"2935-fe0f","uc_greedy":"2935","shortnames":[],"category":"symbols"},":arrow_heading_up:":{"uc_base":"2934","uc_output":"2934","uc_match":"2934-fe0f","uc_greedy":"2934","shortnames":[],"category":"symbols"},":arrow_left:":{"uc_base":"2b05","uc_output":"2b05","uc_match":"2b05-fe0f","uc_greedy":"2b05","shortnames":[],"category":"symbols"},":arrow_lower_left:":{"uc_base":"2199","uc_output":"2199","uc_match":"2199-fe0f","uc_greedy":"2199","shortnames":[],"category":"symbols"},":arrow_lower_right:":{"uc_base":"2198","uc_output":"2198","uc_match":"2198-fe0f","uc_greedy":"2198","shortnames":[],"category":"symbols"},":arrow_right:":{"uc_base":"27a1","uc_output":"27a1","uc_match":"27a1-fe0f","uc_greedy":"27a1","shortnames":[],"category":"symbols"},":arrow_right_hook:":{"uc_base":"21aa","uc_output":"21aa","uc_match":"21aa-fe0f","uc_greedy":"21aa","shortnames":[],"category":"symbols"},":arrow_up:":{"uc_base":"2b06","uc_output":"2b06","uc_match":"2b06-fe0f","uc_greedy":"2b06","shortnames":[],"category":"symbols"},":arrow_up_down:":{"uc_base":"2195","uc_output":"2195","uc_match":"2195-fe0f","uc_greedy":"2195","shortnames":[],"category":"symbols"},":arrow_upper_left:":{"uc_base":"2196","uc_output":"2196","uc_match":"2196-fe0f","uc_greedy":"2196","shortnames":[],"category":"symbols"},":arrow_upper_right:":{"uc_base":"2197","uc_output":"2197","uc_match":"2197-fe0f","uc_greedy":"2197","shortnames":[],"category":"symbols"},":atom:":{"uc_base":"269b","uc_output":"269b","uc_match":"269b-fe0f","uc_greedy":"269b","shortnames":[":atom_symbol:"],"category":"symbols"},":ballot_box_with_check:":{"uc_base":"2611","uc_output":"2611","uc_match":"2611-fe0f","uc_greedy":"2611","shortnames":[],"category":"symbols"},":bangbang:":{"uc_base":"203c","uc_output":"203c","uc_match":"203c-fe0f","uc_greedy":"203c","shortnames":[],"category":"symbols"},":baseball:":{"uc_base":"26be","uc_output":"26be","uc_match":"26be-fe0f","uc_greedy":"26be-fe0f","shortnames":[],"category":"activity"},":beach_umbrella:":{"uc_base":"26f1","uc_output":"26f1","uc_match":"26f1-fe0f","uc_greedy":"26f1-fe0f","shortnames":[":umbrella_on_ground:"],"category":"travel"},":biohazard:":{"uc_base":"2623","uc_output":"2623","uc_match":"2623-fe0f","uc_greedy":"2623","shortnames":[":biohazard_sign:"],"category":"symbols"},":black_circle:":{"uc_base":"26ab","uc_output":"26ab","uc_match":"26ab-fe0f","uc_greedy":"26ab-fe0f","shortnames":[],"category":"symbols"},":black_large_square:":{"uc_base":"2b1b","uc_output":"2b1b","uc_match":"2b1b-fe0f","uc_greedy":"2b1b-fe0f","shortnames":[],"category":"symbols"},":black_medium_small_square:":{"uc_base":"25fe","uc_output":"25fe","uc_match":"25fe-fe0f","uc_greedy":"25fe-fe0f","shortnames":[],"category":"symbols"},":black_medium_square:":{"uc_base":"25fc","uc_output":"25fc","uc_match":"25fc-fe0f","uc_greedy":"25fc","shortnames":[],"category":"symbols"},":black_nib:":{"uc_base":"2712","uc_output":"2712","uc_match":"2712-fe0f","uc_greedy":"2712-fe0f","shortnames":[],"category":"objects"},":black_small_square:":{"uc_base":"25aa","uc_output":"25aa","uc_match":"25aa-fe0f","uc_greedy":"25aa","shortnames":[],"category":"symbols"},":cancer:":{"uc_base":"264b","uc_output":"264b","uc_match":"264b-fe0f","uc_greedy":"264b-fe0f","shortnames":[],"category":"symbols"},":capricorn:":{"uc_base":"2651","uc_output":"2651","uc_match":"2651-fe0f","uc_greedy":"2651-fe0f","shortnames":[],"category":"symbols"},":chains:":{"uc_base":"26d3","uc_output":"26d3","uc_match":"26d3-fe0f","uc_greedy":"26d3-fe0f","shortnames":[],"category":"objects"},":church:":{"uc_base":"26ea","uc_output":"26ea","uc_match":"26ea-fe0f","uc_greedy":"26ea-fe0f","shortnames":[],"category":"travel"},":cloud:":{"uc_base":"2601","uc_output":"2601","uc_match":"2601-fe0f","uc_greedy":"2601-fe0f","shortnames":[],"category":"nature"},":clubs:":{"uc_base":"2663","uc_output":"2663","uc_match":"2663-fe0f","uc_greedy":"2663-fe0f","shortnames":[],"category":"symbols"},":coffee:":{"uc_base":"2615","uc_output":"2615","uc_match":"2615-fe0f","uc_greedy":"2615-fe0f","shortnames":[],"category":"food"},":coffin:":{"uc_base":"26b0","uc_output":"26b0","uc_match":"26b0-fe0f","uc_greedy":"26b0-fe0f","shortnames":[],"category":"objects"},":comet:":{"uc_base":"2604","uc_output":"2604","uc_match":"2604-fe0f","uc_greedy":"2604-fe0f","shortnames":[],"category":"nature"},":congratulations:":{"uc_base":"3297","uc_output":"3297","uc_match":"3297-fe0f","uc_greedy":"3297-fe0f","shortnames":[],"category":"symbols"},":cross:":{"uc_base":"271d","uc_output":"271d","uc_match":"271d-fe0f","uc_greedy":"271d","shortnames":[":latin_cross:"],"category":"symbols"},":crossed_swords:":{"uc_base":"2694","uc_output":"2694","uc_match":"2694-fe0f","uc_greedy":"2694-fe0f","shortnames":[],"category":"objects"},":curly_loop:":{"uc_base":"27b0","uc_output":"27b0","uc_match":"27b0","uc_greedy":"27b0","shortnames":[],"category":"symbols"},":diamonds:":{"uc_base":"2666","uc_output":"2666","uc_match":"2666-fe0f","uc_greedy":"2666-fe0f","shortnames":[],"category":"symbols"},":eight_pointed_black_star:":{"uc_base":"2734","uc_output":"2734","uc_match":"2734-fe0f","uc_greedy":"2734-fe0f","shortnames":[],"category":"symbols"},":eight_spoked_asterisk:":{"uc_base":"2733","uc_output":"2733","uc_match":"2733-fe0f","uc_greedy":"2733-fe0f","shortnames":[],"category":"symbols"},":eject:":{"uc_base":"23cf","uc_output":"23cf","uc_match":"23cf-fe0f","uc_greedy":"23cf","shortnames":[":eject_symbol:"],"category":"symbols"},":envelope:":{"uc_base":"2709","uc_output":"2709","uc_match":"2709-fe0f","uc_greedy":"2709-fe0f","shortnames":[],"category":"objects"},":exclamation:":{"uc_base":"2757","uc_output":"2757","uc_match":"2757-fe0f","uc_greedy":"2757-fe0f","shortnames":[],"category":"symbols"},":fast_forward:":{"uc_base":"23e9","uc_output":"23e9","uc_match":"23e9-fe0f","uc_greedy":"23e9-fe0f","shortnames":[],"category":"symbols"},":female_sign:":{"uc_base":"2640","uc_output":"2640","uc_match":"2640-fe0f","uc_greedy":"2640","shortnames":[],"category":"symbols"},":ferry:":{"uc_base":"26f4","uc_output":"26f4","uc_match":"26f4-fe0f","uc_greedy":"26f4-fe0f","shortnames":[],"category":"travel"},":fist:":{"uc_base":"270a","uc_output":"270a","uc_match":"270a","uc_greedy":"270a","shortnames":[],"category":"people"},":fleur-de-lis:":{"uc_base":"269c","uc_output":"269c","uc_match":"269c-fe0f","uc_greedy":"269c-fe0f","shortnames":[],"category":"symbols"},":fountain:":{"uc_base":"26f2","uc_output":"26f2","uc_match":"26f2-fe0f","uc_greedy":"26f2-fe0f","shortnames":[],"category":"travel"},":frowning2:":{"uc_base":"2639","uc_output":"2639","uc_match":"2639-fe0f","uc_greedy":"2639-fe0f","shortnames":[":white_frowning_face:"],"category":"people"},":fuelpump:":{"uc_base":"26fd","uc_output":"26fd","uc_match":"26fd-fe0f","uc_greedy":"26fd-fe0f","shortnames":[],"category":"travel"},":gear:":{"uc_base":"2699","uc_output":"2699","uc_match":"2699-fe0f","uc_greedy":"2699-fe0f","shortnames":[],"category":"objects"},":gemini:":{"uc_base":"264a","uc_output":"264a","uc_match":"264a-fe0f","uc_greedy":"264a-fe0f","shortnames":[],"category":"symbols"},":golf:":{"uc_base":"26f3","uc_output":"26f3","uc_match":"26f3-fe0f","uc_greedy":"26f3-fe0f","shortnames":[],"category":"activity"},":grey_exclamation:":{"uc_base":"2755","uc_output":"2755","uc_match":"2755","uc_greedy":"2755","shortnames":[],"category":"symbols"},":grey_question:":{"uc_base":"2754","uc_output":"2754","uc_match":"2754","uc_greedy":"2754","shortnames":[],"category":"symbols"},":hammer_pick:":{"uc_base":"2692","uc_output":"2692","uc_match":"2692-fe0f","uc_greedy":"2692-fe0f","shortnames":[":hammer_and_pick:"],"category":"objects"},":heart:":{"uc_base":"2764","uc_output":"2764","uc_match":"2764-fe0f","uc_greedy":"2764-fe0f","shortnames":[],"category":"symbols"},":heart_exclamation:":{"uc_base":"2763","uc_output":"2763","uc_match":"2763-fe0f","uc_greedy":"2763-fe0f","shortnames":[":heavy_heart_exclamation_mark_ornament:"],"category":"symbols"},":hearts:":{"uc_base":"2665","uc_output":"2665","uc_match":"2665-fe0f","uc_greedy":"2665-fe0f","shortnames":[],"category":"symbols"},":heavy_check_mark:":{"uc_base":"2714","uc_output":"2714","uc_match":"2714-fe0f","uc_greedy":"2714","shortnames":[],"category":"symbols"},":heavy_division_sign:":{"uc_base":"2797","uc_output":"2797","uc_match":"2797","uc_greedy":"2797","shortnames":[],"category":"symbols"},":heavy_minus_sign:":{"uc_base":"2796","uc_output":"2796","uc_match":"2796","uc_greedy":"2796","shortnames":[],"category":"symbols"},":heavy_multiplication_x:":{"uc_base":"2716","uc_output":"2716","uc_match":"2716-fe0f","uc_greedy":"2716","shortnames":[],"category":"symbols"},":heavy_plus_sign:":{"uc_base":"2795","uc_output":"2795","uc_match":"2795","uc_greedy":"2795","shortnames":[],"category":"symbols"},":helmet_with_cross:":{"uc_base":"26d1","uc_output":"26d1","uc_match":"26d1-fe0f","uc_greedy":"26d1-fe0f","shortnames":[":helmet_with_white_cross:"],"category":"people"},":hotsprings:":{"uc_base":"2668","uc_output":"2668","uc_match":"2668-fe0f","uc_greedy":"2668-fe0f","shortnames":[],"category":"symbols"},":hourglass:":{"uc_base":"231b","uc_output":"231b","uc_match":"231b-fe0f","uc_greedy":"231b-fe0f","shortnames":[],"category":"objects"},":hourglass_flowing_sand:":{"uc_base":"23f3","uc_output":"23f3","uc_match":"23f3-fe0f","uc_greedy":"23f3-fe0f","shortnames":[],"category":"objects"},":ice_skate:":{"uc_base":"26f8","uc_output":"26f8","uc_match":"26f8-fe0f","uc_greedy":"26f8-fe0f","shortnames":[],"category":"activity"},":information_source:":{"uc_base":"2139","uc_output":"2139","uc_match":"2139-fe0f","uc_greedy":"2139","shortnames":[],"category":"symbols"},":interrobang:":{"uc_base":"2049","uc_output":"2049","uc_match":"2049-fe0f","uc_greedy":"2049","shortnames":[],"category":"symbols"},":keyboard:":{"uc_base":"2328","uc_output":"2328","uc_match":"2328-fe0f","uc_greedy":"2328-fe0f","shortnames":[],"category":"objects"},":left_right_arrow:":{"uc_base":"2194","uc_output":"2194","uc_match":"2194-fe0f","uc_greedy":"2194","shortnames":[],"category":"symbols"},":leftwards_arrow_with_hook:":{"uc_base":"21a9","uc_output":"21a9","uc_match":"21a9-fe0f","uc_greedy":"21a9","shortnames":[],"category":"symbols"},":leo:":{"uc_base":"264c","uc_output":"264c","uc_match":"264c-fe0f","uc_greedy":"264c-fe0f","shortnames":[],"category":"symbols"},":libra:":{"uc_base":"264e","uc_output":"264e","uc_match":"264e-fe0f","uc_greedy":"264e-fe0f","shortnames":[],"category":"symbols"},":loop:":{"uc_base":"27bf","uc_output":"27bf","uc_match":"27bf","uc_greedy":"27bf","shortnames":[],"category":"symbols"},":m:":{"uc_base":"24c2","uc_output":"24c2","uc_match":"24c2-fe0f","uc_greedy":"24c2-fe0f","shortnames":[],"category":"symbols"},":male_sign:":{"uc_base":"2642","uc_output":"2642","uc_match":"2642-fe0f","uc_greedy":"2642","shortnames":[],"category":"symbols"},":medical_symbol:":{"uc_base":"2695","uc_output":"2695","uc_match":"2695-fe0f","uc_greedy":"2695","shortnames":[],"category":"symbols"},":mountain:":{"uc_base":"26f0","uc_output":"26f0","uc_match":"26f0-fe0f","uc_greedy":"26f0-fe0f","shortnames":[],"category":"travel"},":negative_squared_cross_mark:":{"uc_base":"274e","uc_output":"274e","uc_match":"274e","uc_greedy":"274e","shortnames":[],"category":"symbols"},":no_entry:":{"uc_base":"26d4","uc_output":"26d4","uc_match":"26d4-fe0f","uc_greedy":"26d4-fe0f","shortnames":[],"category":"symbols"},":o:":{"uc_base":"2b55","uc_output":"2b55","uc_match":"2b55-fe0f","uc_greedy":"2b55-fe0f","shortnames":[],"category":"symbols"},":ophiuchus:":{"uc_base":"26ce","uc_output":"26ce","uc_match":"26ce","uc_greedy":"26ce","shortnames":[],"category":"symbols"},":orthodox_cross:":{"uc_base":"2626","uc_output":"2626","uc_match":"2626-fe0f","uc_greedy":"2626","shortnames":[],"category":"symbols"},":part_alternation_mark:":{"uc_base":"303d","uc_output":"303d","uc_match":"303d-fe0f","uc_greedy":"303d-fe0f","shortnames":[],"category":"symbols"},":partly_sunny:":{"uc_base":"26c5","uc_output":"26c5","uc_match":"26c5-fe0f","uc_greedy":"26c5-fe0f","shortnames":[],"category":"nature"},":pause_button:":{"uc_base":"23f8","uc_output":"23f8","uc_match":"23f8-fe0f","uc_greedy":"23f8","shortnames":[":double_vertical_bar:"],"category":"symbols"},":peace:":{"uc_base":"262e","uc_output":"262e","uc_match":"262e-fe0f","uc_greedy":"262e","shortnames":[":peace_symbol:"],"category":"symbols"},":pencil2:":{"uc_base":"270f","uc_output":"270f","uc_match":"270f-fe0f","uc_greedy":"270f-fe0f","shortnames":[],"category":"objects"},":person_bouncing_ball:":{"uc_base":"26f9","uc_output":"26f9","uc_match":"26f9-fe0f","uc_greedy":"26f9-fe0f","shortnames":[":basketball_player:",":person_with_ball:"],"category":"activity"},":pick:":{"uc_base":"26cf","uc_output":"26cf","uc_match":"26cf-fe0f","uc_greedy":"26cf-fe0f","shortnames":[],"category":"objects"},":pisces:":{"uc_base":"2653","uc_output":"2653","uc_match":"2653-fe0f","uc_greedy":"2653-fe0f","shortnames":[],"category":"symbols"},":play_pause:":{"uc_base":"23ef","uc_output":"23ef","uc_match":"23ef-fe0f","uc_greedy":"23ef","shortnames":[],"category":"symbols"},":point_up:":{"uc_base":"261d","uc_output":"261d","uc_match":"261d-fe0f","uc_greedy":"261d-fe0f","shortnames":[],"category":"people"},":question:":{"uc_base":"2753","uc_output":"2753","uc_match":"2753-fe0f","uc_greedy":"2753-fe0f","shortnames":[],"category":"symbols"},":radioactive:":{"uc_base":"2622","uc_output":"2622","uc_match":"2622-fe0f","uc_greedy":"2622","shortnames":[":radioactive_sign:"],"category":"symbols"},":raised_hand:":{"uc_base":"270b","uc_output":"270b","uc_match":"270b","uc_greedy":"270b","shortnames":[],"category":"people"},":record_button:":{"uc_base":"23fa","uc_output":"23fa","uc_match":"23fa-fe0f","uc_greedy":"23fa","shortnames":[],"category":"symbols"},":recycle:":{"uc_base":"267b","uc_output":"267b","uc_match":"267b-fe0f","uc_greedy":"267b-fe0f","shortnames":[],"category":"symbols"},":relaxed:":{"uc_base":"263a","uc_output":"263a","uc_match":"263a-fe0f","uc_greedy":"263a-fe0f","shortnames":[],"category":"people"},":rewind:":{"uc_base":"23ea","uc_output":"23ea","uc_match":"23ea-fe0f","uc_greedy":"23ea-fe0f","shortnames":[],"category":"symbols"},":sagittarius:":{"uc_base":"2650","uc_output":"2650","uc_match":"2650-fe0f","uc_greedy":"2650-fe0f","shortnames":[],"category":"symbols"},":sailboat:":{"uc_base":"26f5","uc_output":"26f5","uc_match":"26f5-fe0f","uc_greedy":"26f5-fe0f","shortnames":[],"category":"travel"},":scales:":{"uc_base":"2696","uc_output":"2696","uc_match":"2696-fe0f","uc_greedy":"2696-fe0f","shortnames":[],"category":"objects"},":scissors:":{"uc_base":"2702","uc_output":"2702","uc_match":"2702-fe0f","uc_greedy":"2702-fe0f","shortnames":[],"category":"objects"},":scorpius:":{"uc_base":"264f","uc_output":"264f","uc_match":"264f-fe0f","uc_greedy":"264f-fe0f","shortnames":[],"category":"symbols"},":secret:":{"uc_base":"3299","uc_output":"3299","uc_match":"3299-fe0f","uc_greedy":"3299-fe0f","shortnames":[],"category":"symbols"},":shamrock:":{"uc_base":"2618","uc_output":"2618","uc_match":"2618-fe0f","uc_greedy":"2618-fe0f","shortnames":[],"category":"nature"},":shinto_shrine:":{"uc_base":"26e9","uc_output":"26e9","uc_match":"26e9-fe0f","uc_greedy":"26e9-fe0f","shortnames":[],"category":"travel"},":skier:":{"uc_base":"26f7","uc_output":"26f7","uc_match":"26f7-fe0f","uc_greedy":"26f7-fe0f","shortnames":[],"category":"activity"},":skull_crossbones:":{"uc_base":"2620","uc_output":"2620","uc_match":"2620-fe0f","uc_greedy":"2620-fe0f","shortnames":[":skull_and_crossbones:"],"category":"people"},":snowflake:":{"uc_base":"2744","uc_output":"2744","uc_match":"2744-fe0f","uc_greedy":"2744-fe0f","shortnames":[],"category":"nature"},":snowman2:":{"uc_base":"2603","uc_output":"2603","uc_match":"2603-fe0f","uc_greedy":"2603-fe0f","shortnames":[],"category":"nature"},":snowman:":{"uc_base":"26c4","uc_output":"26c4","uc_match":"26c4-fe0f","uc_greedy":"26c4-fe0f","shortnames":[],"category":"nature"},":soccer:":{"uc_base":"26bd","uc_output":"26bd","uc_match":"26bd-fe0f","uc_greedy":"26bd-fe0f","shortnames":[],"category":"activity"},":spades:":{"uc_base":"2660","uc_output":"2660","uc_match":"2660-fe0f","uc_greedy":"2660-fe0f","shortnames":[],"category":"symbols"},":sparkle:":{"uc_base":"2747","uc_output":"2747","uc_match":"2747-fe0f","uc_greedy":"2747-fe0f","shortnames":[],"category":"symbols"},":sparkles:":{"uc_base":"2728","uc_output":"2728","uc_match":"2728","uc_greedy":"2728","shortnames":[],"category":"nature"},":star:":{"uc_base":"2b50","uc_output":"2b50","uc_match":"2b50-fe0f","uc_greedy":"2b50-fe0f","shortnames":[],"category":"nature"},":star_and_crescent:":{"uc_base":"262a","uc_output":"262a","uc_match":"262a-fe0f","uc_greedy":"262a","shortnames":[],"category":"symbols"},":star_of_david:":{"uc_base":"2721","uc_output":"2721","uc_match":"2721-fe0f","uc_greedy":"2721","shortnames":[],"category":"symbols"},":stop_button:":{"uc_base":"23f9","uc_output":"23f9","uc_match":"23f9-fe0f","uc_greedy":"23f9","shortnames":[],"category":"symbols"},":stopwatch:":{"uc_base":"23f1","uc_output":"23f1","uc_match":"23f1-fe0f","uc_greedy":"23f1-fe0f","shortnames":[],"category":"objects"},":sunny:":{"uc_base":"2600","uc_output":"2600","uc_match":"2600-fe0f","uc_greedy":"2600-fe0f","shortnames":[],"category":"nature"},":taurus:":{"uc_base":"2649","uc_output":"2649","uc_match":"2649-fe0f","uc_greedy":"2649-fe0f","shortnames":[],"category":"symbols"},":telephone:":{"uc_base":"260e","uc_output":"260e","uc_match":"260e-fe0f","uc_greedy":"260e-fe0f","shortnames":[],"category":"objects"},":tent:":{"uc_base":"26fa","uc_output":"26fa","uc_match":"26fa-fe0f","uc_greedy":"26fa-fe0f","shortnames":[],"category":"travel"},":thunder_cloud_rain:":{"uc_base":"26c8","uc_output":"26c8","uc_match":"26c8-fe0f","uc_greedy":"26c8-fe0f","shortnames":[":thunder_cloud_and_rain:"],"category":"nature"},":timer:":{"uc_base":"23f2","uc_output":"23f2","uc_match":"23f2-fe0f","uc_greedy":"23f2-fe0f","shortnames":[":timer_clock:"],"category":"objects"},":track_next:":{"uc_base":"23ed","uc_output":"23ed","uc_match":"23ed-fe0f","uc_greedy":"23ed","shortnames":[":next_track:"],"category":"symbols"},":track_previous:":{"uc_base":"23ee","uc_output":"23ee","uc_match":"23ee-fe0f","uc_greedy":"23ee","shortnames":[":previous_track:"],"category":"symbols"},":umbrella2:":{"uc_base":"2602","uc_output":"2602","uc_match":"2602-fe0f","uc_greedy":"2602-fe0f","shortnames":[],"category":"nature"},":umbrella:":{"uc_base":"2614","uc_output":"2614","uc_match":"2614-fe0f","uc_greedy":"2614-fe0f","shortnames":[],"category":"nature"},":urn:":{"uc_base":"26b1","uc_output":"26b1","uc_match":"26b1-fe0f","uc_greedy":"26b1-fe0f","shortnames":[":funeral_urn:"],"category":"objects"},":v:":{"uc_base":"270c","uc_output":"270c","uc_match":"270c-fe0f","uc_greedy":"270c-fe0f","shortnames":[],"category":"people"},":virgo:":{"uc_base":"264d","uc_output":"264d","uc_match":"264d-fe0f","uc_greedy":"264d-fe0f","shortnames":[],"category":"symbols"},":warning:":{"uc_base":"26a0","uc_output":"26a0","uc_match":"26a0-fe0f","uc_greedy":"26a0","shortnames":[],"category":"symbols"},":watch:":{"uc_base":"231a","uc_output":"231a","uc_match":"231a-fe0f","uc_greedy":"231a-fe0f","shortnames":[],"category":"objects"},":wavy_dash:":{"uc_base":"3030","uc_output":"3030","uc_match":"3030-fe0f","uc_greedy":"3030","shortnames":[],"category":"symbols"},":wheel_of_dharma:":{"uc_base":"2638","uc_output":"2638","uc_match":"2638-fe0f","uc_greedy":"2638","shortnames":[],"category":"symbols"},":wheelchair:":{"uc_base":"267f","uc_output":"267f","uc_match":"267f-fe0f","uc_greedy":"267f-fe0f","shortnames":[],"category":"symbols"},":white_check_mark:":{"uc_base":"2705","uc_output":"2705","uc_match":"2705","uc_greedy":"2705","shortnames":[],"category":"symbols"},":white_circle:":{"uc_base":"26aa","uc_output":"26aa","uc_match":"26aa-fe0f","uc_greedy":"26aa-fe0f","shortnames":[],"category":"symbols"},":white_large_square:":{"uc_base":"2b1c","uc_output":"2b1c","uc_match":"2b1c-fe0f","uc_greedy":"2b1c-fe0f","shortnames":[],"category":"symbols"},":white_medium_small_square:":{"uc_base":"25fd","uc_output":"25fd","uc_match":"25fd-fe0f","uc_greedy":"25fd-fe0f","shortnames":[],"category":"symbols"},":white_medium_square:":{"uc_base":"25fb","uc_output":"25fb","uc_match":"25fb-fe0f","uc_greedy":"25fb","shortnames":[],"category":"symbols"},":white_small_square:":{"uc_base":"25ab","uc_output":"25ab","uc_match":"25ab-fe0f","uc_greedy":"25ab","shortnames":[],"category":"symbols"},":writing_hand:":{"uc_base":"270d","uc_output":"270d","uc_match":"270d-fe0f","uc_greedy":"270d-fe0f","shortnames":[],"category":"people"},":x:":{"uc_base":"274c","uc_output":"274c","uc_match":"274c","uc_greedy":"274c","shortnames":[],"category":"symbols"},":yin_yang:":{"uc_base":"262f","uc_output":"262f","uc_match":"262f-fe0f","uc_greedy":"262f","shortnames":[],"category":"symbols"},":zap:":{"uc_base":"26a1","uc_output":"26a1","uc_match":"26a1-fe0f","uc_greedy":"26a1-fe0f","shortnames":[],"category":"nature"}};

    var tmpShortNames = [], emoji;
    for (emoji in ns.emojioneList) {
        if (!ns.emojioneList.hasOwnProperty(emoji) || (emoji === '')) continue;
        tmpShortNames.push(emoji.replace(/[+]/g, "\\$&"));
        for (var i = 0; i < ns.emojioneList[emoji].shortnames.length; i++) {
            tmpShortNames.push(ns.emojioneList[emoji].shortnames[i].replace(/[+]/g, "\\$&"));
        }
    }
    ns.shortnames = tmpShortNames.join('|');

    // javascript escapes here must be ordered from largest length to shortest
    ns.jsEscapeMap = {"\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69":"1f469-2764-1f48b-1f469","\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68":"1f468-2764-1f48b-1f468","\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68":"1f469-2764-1f48b-1f468","\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F":"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f","\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F":"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f","\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F":"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f468-1f468-1f466-1f466","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f468-1f468-1f467-1f466","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f468-1f468-1f467-1f467","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f468-1f469-1f466-1f466","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f468-1f469-1f467-1f466","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f468-1f469-1f467-1f467","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f469-1f469-1f466-1f466","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f469-1f469-1f467-1f466","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f469-1f469-1f467-1f467","\uD83D\uDC68\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68":"1f468-2764-1f48b-1f468","\uD83D\uDC69\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC68":"1f469-2764-1f48b-1f468","\uD83D\uDC69\u200D\u2764\u200D\uD83D\uDC8B\u200D\uD83D\uDC69":"1f469-2764-1f48b-1f469","\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69":"1f469-2764-1f469","\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68":"1f468-2764-1f468","\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68":"1f469-2764-1f468","\uD83D\uDD75\uFE0F\uD83C\uDFFB\u200D\u2640\uFE0F":"1f575-1f3fb-2640","\uD83D\uDD75\uFE0F\uD83C\uDFFB\u200D\u2642\uFE0F":"1f575-1f3fb-2642","\uD83D\uDD75\uFE0F\uD83C\uDFFC\u200D\u2640\uFE0F":"1f575-1f3fc-2640","\uD83D\uDD75\uFE0F\uD83C\uDFFC\u200D\u2642\uFE0F":"1f575-1f3fc-2642","\uD83D\uDD75\uFE0F\uD83C\uDFFD\u200D\u2640\uFE0F":"1f575-1f3fd-2640","\uD83D\uDD75\uFE0F\uD83C\uDFFD\u200D\u2642\uFE0F":"1f575-1f3fd-2642","\uD83D\uDD75\uFE0F\uD83C\uDFFE\u200D\u2640\uFE0F":"1f575-1f3fe-2640","\uD83D\uDD75\uFE0F\uD83C\uDFFE\u200D\u2642\uFE0F":"1f575-1f3fe-2642","\uD83D\uDD75\uFE0F\uD83C\uDFFF\u200D\u2640\uFE0F":"1f575-1f3ff-2640","\uD83D\uDD75\uFE0F\uD83C\uDFFF\u200D\u2642\uFE0F":"1f575-1f3ff-2642","\uD83C\uDFCB\uFE0F\uD83C\uDFFB\u200D\u2640\uFE0F":"1f3cb-1f3fb-2640","\uD83C\uDFCB\uFE0F\uD83C\uDFFB\u200D\u2642\uFE0F":"1f3cb-1f3fb-2642","\uD83C\uDFCB\uFE0F\uD83C\uDFFC\u200D\u2640\uFE0F":"1f3cb-1f3fc-2640","\uD83C\uDFCB\uFE0F\uD83C\uDFFC\u200D\u2642\uFE0F":"1f3cb-1f3fc-2642","\uD83C\uDFCB\uFE0F\uD83C\uDFFD\u200D\u2640\uFE0F":"1f3cb-1f3fd-2640","\uD83C\uDFCB\uFE0F\uD83C\uDFFD\u200D\u2642\uFE0F":"1f3cb-1f3fd-2642","\uD83C\uDFCB\uFE0F\uD83C\uDFFE\u200D\u2640\uFE0F":"1f3cb-1f3fe-2640","\uD83C\uDFCB\uFE0F\uD83C\uDFFE\u200D\u2642\uFE0F":"1f3cb-1f3fe-2642","\uD83C\uDFCB\uFE0F\uD83C\uDFFF\u200D\u2640\uFE0F":"1f3cb-1f3ff-2640","\uD83C\uDFCB\uFE0F\uD83C\uDFFF\u200D\u2642\uFE0F":"1f3cb-1f3ff-2642","\uD83C\uDFCC\uFE0F\uD83C\uDFFB\u200D\u2640\uFE0F":"1f3cc-1f3fb-2640","\uD83C\uDFCC\uFE0F\uD83C\uDFFB\u200D\u2642\uFE0F":"1f3cc-1f3fb-2642","\uD83C\uDFCC\uFE0F\uD83C\uDFFC\u200D\u2640\uFE0F":"1f3cc-1f3fc-2640","\uD83C\uDFCC\uFE0F\uD83C\uDFFC\u200D\u2642\uFE0F":"1f3cc-1f3fc-2642","\uD83C\uDFCC\uFE0F\uD83C\uDFFD\u200D\u2640\uFE0F":"1f3cc-1f3fd-2640","\uD83C\uDFCC\uFE0F\uD83C\uDFFD\u200D\u2642\uFE0F":"1f3cc-1f3fd-2642","\uD83C\uDFCC\uFE0F\uD83C\uDFFE\u200D\u2640\uFE0F":"1f3cc-1f3fe-2640","\uD83C\uDFCC\uFE0F\uD83C\uDFFE\u200D\u2642\uFE0F":"1f3cc-1f3fe-2642","\uD83C\uDFCC\uFE0F\uD83C\uDFFF\u200D\u2640\uFE0F":"1f3cc-1f3ff-2640","\uD83C\uDFCC\uFE0F\uD83C\uDFFF\u200D\u2642\uFE0F":"1f3cc-1f3ff-2642","\u26F9\uFE0F\uD83C\uDFFB\u200D\u2640\uFE0F":"26f9-1f3fb-2640","\u26F9\uFE0F\uD83C\uDFFB\u200D\u2642\uFE0F":"26f9-1f3fb-2642","\u26F9\uFE0F\uD83C\uDFFC\u200D\u2640\uFE0F":"26f9-1f3fc-2640","\u26F9\uFE0F\uD83C\uDFFC\u200D\u2642\uFE0F":"26f9-1f3fc-2642","\u26F9\uFE0F\uD83C\uDFFD\u200D\u2640\uFE0F":"26f9-1f3fd-2640","\u26F9\uFE0F\uD83C\uDFFD\u200D\u2642\uFE0F":"26f9-1f3fd-2642","\u26F9\uFE0F\uD83C\uDFFE\u200D\u2640\uFE0F":"26f9-1f3fe-2640","\u26F9\uFE0F\uD83C\uDFFE\u200D\u2642\uFE0F":"26f9-1f3fe-2642","\u26F9\uFE0F\uD83C\uDFFF\u200D\u2640\uFE0F":"26f9-1f3ff-2640","\u26F9\uFE0F\uD83C\uDFFF\u200D\u2642\uFE0F":"26f9-1f3ff-2642","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66":"1f468-1f468-1f466","\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67":"1f468-1f468-1f467","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67":"1f468-1f469-1f467","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66":"1f469-1f469-1f466","\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67":"1f469-1f469-1f467","\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f468-1f466-1f466","\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f468-1f467-1f466","\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66":"1f469-1f466-1f466","\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66":"1f469-1f467-1f466","\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f469-1f467-1f467","\uD83D\uDC68\u2764\uFE0F\uD83D\uDC8B\uD83D\uDC68":"1f468-2764-1f48b-1f468","\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67":"1f468-1f467-1f467","\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66":"1f468-1f469-1f466","\uD83D\uDC69\u2764\uFE0F\uD83D\uDC8B\uD83D\uDC68":"1f469-2764-1f48b-1f468","\uD83D\uDC69\u2764\uFE0F\uD83D\uDC8B\uD83D\uDC69":"1f469-2764-1f48b-1f469","\uD83D\uDC68\u200D\u2764\u200D\uD83D\uDC68":"1f468-2764-1f468","\uD83D\uDC69\u200D\u2764\u200D\uD83D\uDC68":"1f469-2764-1f468","\uD83D\uDC69\u200D\u2764\u200D\uD83D\uDC69":"1f469-2764-1f469","\uD83D\uDC68\uD83C\uDFFB\u200D\u2695\uFE0F":"1f468-1f3fb-2695","\uD83D\uDC68\uD83C\uDFFB\u200D\u2696\uFE0F":"1f468-1f3fb-2696","\uD83D\uDC68\uD83C\uDFFB\u200D\u2708\uFE0F":"1f468-1f3fb-2708","\uD83D\uDC68\uD83C\uDFFC\u200D\u2695\uFE0F":"1f468-1f3fc-2695","\uD83D\uDC68\uD83C\uDFFC\u200D\u2696\uFE0F":"1f468-1f3fc-2696","\uD83D\uDC68\uD83C\uDFFC\u200D\u2708\uFE0F":"1f468-1f3fc-2708","\uD83D\uDC68\uD83C\uDFFD\u200D\u2695\uFE0F":"1f468-1f3fd-2695","\uD83D\uDC68\uD83C\uDFFD\u200D\u2696\uFE0F":"1f468-1f3fd-2696","\uD83D\uDC68\uD83C\uDFFD\u200D\u2708\uFE0F":"1f468-1f3fd-2708","\uD83D\uDC68\uD83C\uDFFE\u200D\u2695\uFE0F":"1f468-1f3fe-2695","\uD83D\uDC68\uD83C\uDFFE\u200D\u2696\uFE0F":"1f468-1f3fe-2696","\uD83D\uDC68\uD83C\uDFFE\u200D\u2708\uFE0F":"1f468-1f3fe-2708","\uD83D\uDC68\uD83C\uDFFF\u200D\u2695\uFE0F":"1f468-1f3ff-2695","\uD83D\uDC68\uD83C\uDFFF\u200D\u2696\uFE0F":"1f468-1f3ff-2696","\uD83D\uDC68\uD83C\uDFFF\u200D\u2708\uFE0F":"1f468-1f3ff-2708","\uD83D\uDC69\uD83C\uDFFB\u200D\u2695\uFE0F":"1f469-1f3fb-2695","\uD83D\uDC69\uD83C\uDFFB\u200D\u2696\uFE0F":"1f469-1f3fb-2696","\uD83D\uDC69\uD83C\uDFFB\u200D\u2708\uFE0F":"1f469-1f3fb-2708","\uD83D\uDC69\uD83C\uDFFC\u200D\u2695\uFE0F":"1f469-1f3fc-2695","\uD83D\uDC69\uD83C\uDFFC\u200D\u2696\uFE0F":"1f469-1f3fc-2696","\uD83D\uDC69\uD83C\uDFFC\u200D\u2708\uFE0F":"1f469-1f3fc-2708","\uD83D\uDC69\uD83C\uDFFD\u200D\u2695\uFE0F":"1f469-1f3fd-2695","\uD83D\uDC69\uD83C\uDFFD\u200D\u2696\uFE0F":"1f469-1f3fd-2696","\uD83D\uDC69\uD83C\uDFFD\u200D\u2708\uFE0F":"1f469-1f3fd-2708","\uD83D\uDC69\uD83C\uDFFE\u200D\u2695\uFE0F":"1f469-1f3fe-2695","\uD83D\uDC69\uD83C\uDFFE\u200D\u2696\uFE0F":"1f469-1f3fe-2696","\uD83D\uDC69\uD83C\uDFFE\u200D\u2708\uFE0F":"1f469-1f3fe-2708","\uD83D\uDC69\uD83C\uDFFF\u200D\u2695\uFE0F":"1f469-1f3ff-2695","\uD83D\uDC69\uD83C\uDFFF\u200D\u2696\uFE0F":"1f469-1f3ff-2696","\uD83D\uDC69\uD83C\uDFFF\u200D\u2708\uFE0F":"1f469-1f3ff-2708","\uD83D\uDC6E\uD83C\uDFFB\u200D\u2640\uFE0F":"1f46e-1f3fb-2640","\uD83D\uDC6E\uD83C\uDFFB\u200D\u2642\uFE0F":"1f46e-1f3fb-2642","\uD83D\uDC6E\uD83C\uDFFC\u200D\u2640\uFE0F":"1f46e-1f3fc-2640","\uD83D\uDC6E\uD83C\uDFFC\u200D\u2642\uFE0F":"1f46e-1f3fc-2642","\uD83D\uDC6E\uD83C\uDFFD\u200D\u2640\uFE0F":"1f46e-1f3fd-2640","\uD83D\uDC6E\uD83C\uDFFD\u200D\u2642\uFE0F":"1f46e-1f3fd-2642","\uD83D\uDC6E\uD83C\uDFFE\u200D\u2640\uFE0F":"1f46e-1f3fe-2640","\uD83D\uDC6E\uD83C\uDFFE\u200D\u2642\uFE0F":"1f46e-1f3fe-2642","\uD83D\uDC6E\uD83C\uDFFF\u200D\u2640\uFE0F":"1f46e-1f3ff-2640","\uD83D\uDC6E\uD83C\uDFFF\u200D\u2642\uFE0F":"1f46e-1f3ff-2642","\uD83D\uDC71\uD83C\uDFFB\u200D\u2640\uFE0F":"1f471-1f3fb-2640","\uD83D\uDC71\uD83C\uDFFB\u200D\u2642\uFE0F":"1f471-1f3fb-2642","\uD83D\uDC71\uD83C\uDFFC\u200D\u2640\uFE0F":"1f471-1f3fc-2640","\uD83D\uDC71\uD83C\uDFFC\u200D\u2642\uFE0F":"1f471-1f3fc-2642","\uD83D\uDC71\uD83C\uDFFD\u200D\u2640\uFE0F":"1f471-1f3fd-2640","\uD83D\uDC71\uD83C\uDFFD\u200D\u2642\uFE0F":"1f471-1f3fd-2642","\uD83D\uDC71\uD83C\uDFFE\u200D\u2640\uFE0F":"1f471-1f3fe-2640","\uD83D\uDC71\uD83C\uDFFE\u200D\u2642\uFE0F":"1f471-1f3fe-2642","\uD83D\uDC71\uD83C\uDFFF\u200D\u2640\uFE0F":"1f471-1f3ff-2640","\uD83D\uDC71\uD83C\uDFFF\u200D\u2642\uFE0F":"1f471-1f3ff-2642","\uD83D\uDC73\uD83C\uDFFB\u200D\u2640\uFE0F":"1f473-1f3fb-2640","\uD83D\uDC73\uD83C\uDFFB\u200D\u2642\uFE0F":"1f473-1f3fb-2642","\uD83D\uDC73\uD83C\uDFFC\u200D\u2640\uFE0F":"1f473-1f3fc-2640","\uD83D\uDC73\uD83C\uDFFC\u200D\u2642\uFE0F":"1f473-1f3fc-2642","\uD83D\uDC73\uD83C\uDFFD\u200D\u2640\uFE0F":"1f473-1f3fd-2640","\uD83D\uDC73\uD83C\uDFFD\u200D\u2642\uFE0F":"1f473-1f3fd-2642","\uD83D\uDC73\uD83C\uDFFE\u200D\u2640\uFE0F":"1f473-1f3fe-2640","\uD83D\uDC73\uD83C\uDFFE\u200D\u2642\uFE0F":"1f473-1f3fe-2642","\uD83D\uDC73\uD83C\uDFFF\u200D\u2640\uFE0F":"1f473-1f3ff-2640","\uD83D\uDC73\uD83C\uDFFF\u200D\u2642\uFE0F":"1f473-1f3ff-2642","\uD83D\uDC77\uD83C\uDFFB\u200D\u2640\uFE0F":"1f477-1f3fb-2640","\uD83D\uDC77\uD83C\uDFFB\u200D\u2642\uFE0F":"1f477-1f3fb-2642","\uD83D\uDC77\uD83C\uDFFC\u200D\u2640\uFE0F":"1f477-1f3fc-2640","\uD83D\uDC77\uD83C\uDFFC\u200D\u2642\uFE0F":"1f477-1f3fc-2642","\uD83D\uDC77\uD83C\uDFFD\u200D\u2640\uFE0F":"1f477-1f3fd-2640","\uD83D\uDC77\uD83C\uDFFD\u200D\u2642\uFE0F":"1f477-1f3fd-2642","\uD83D\uDC77\uD83C\uDFFE\u200D\u2640\uFE0F":"1f477-1f3fe-2640","\uD83D\uDC77\uD83C\uDFFE\u200D\u2642\uFE0F":"1f477-1f3fe-2642","\uD83D\uDC77\uD83C\uDFFF\u200D\u2640\uFE0F":"1f477-1f3ff-2640","\uD83D\uDC77\uD83C\uDFFF\u200D\u2642\uFE0F":"1f477-1f3ff-2642","\uD83D\uDC82\uD83C\uDFFB\u200D\u2640\uFE0F":"1f482-1f3fb-2640","\uD83D\uDC82\uD83C\uDFFB\u200D\u2642\uFE0F":"1f482-1f3fb-2642","\uD83D\uDC82\uD83C\uDFFC\u200D\u2640\uFE0F":"1f482-1f3fc-2640","\uD83D\uDC82\uD83C\uDFFC\u200D\u2642\uFE0F":"1f482-1f3fc-2642","\uD83D\uDC82\uD83C\uDFFD\u200D\u2640\uFE0F":"1f482-1f3fd-2640","\uD83D\uDC82\uD83C\uDFFD\u200D\u2642\uFE0F":"1f482-1f3fd-2642","\uD83D\uDC82\uD83C\uDFFE\u200D\u2640\uFE0F":"1f482-1f3fe-2640","\uD83D\uDC82\uD83C\uDFFE\u200D\u2642\uFE0F":"1f482-1f3fe-2642","\uD83D\uDC82\uD83C\uDFFF\u200D\u2640\uFE0F":"1f482-1f3ff-2640","\uD83D\uDC82\uD83C\uDFFF\u200D\u2642\uFE0F":"1f482-1f3ff-2642","\uD83D\uDD75\uFE0F\uD83C\uDFFB\u2640\uFE0F":"1f575-1f3fb-2640","\uD83D\uDD75\uFE0F\uD83C\uDFFB\u2642\uFE0F":"1f575-1f3fb-2642","\uD83D\uDD75\uFE0F\uD83C\uDFFC\u2640\uFE0F":"1f575-1f3fc-2640","\uD83D\uDD75\uFE0F\uD83C\uDFFC\u2642\uFE0F":"1f575-1f3fc-2642","\uD83D\uDD75\uFE0F\uD83C\uDFFD\u2640\uFE0F":"1f575-1f3fd-2640","\uD83D\uDD75\uFE0F\uD83C\uDFFD\u2642\uFE0F":"1f575-1f3fd-2642","\uD83D\uDD75\uFE0F\uD83C\uDFFE\u2640\uFE0F":"1f575-1f3fe-2640","\uD83D\uDD75\uFE0F\uD83C\uDFFE\u2642\uFE0F":"1f575-1f3fe-2642","\uD83D\uDD75\uFE0F\uD83C\uDFFF\u2640\uFE0F":"1f575-1f3ff-2640","\uD83D\uDD75\uFE0F\uD83C\uDFFF\u2642\uFE0F":"1f575-1f3ff-2642","\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F":"1f3c3-1f3fb-2640","\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F":"1f3c3-1f3fb-2642","\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F":"1f3c3-1f3fc-2640","\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F":"1f3c3-1f3fc-2642","\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F":"1f3c3-1f3fd-2640","\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F":"1f3c3-1f3fd-2642","\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F":"1f3c3-1f3fe-2640","\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F":"1f3c3-1f3fe-2642","\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F":"1f3c3-1f3ff-2640","\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F":"1f3c3-1f3ff-2642","\uD83C\uDFC4\uD83C\uDFFB\u200D\u2640\uFE0F":"1f3c4-1f3fb-2640","\uD83C\uDFC4\uD83C\uDFFB\u200D\u2642\uFE0F":"1f3c4-1f3fb-2642","\uD83C\uDFC4\uD83C\uDFFC\u200D\u2640\uFE0F":"1f3c4-1f3fc-2640","\uD83C\uDFC4\uD83C\uDFFC\u200D\u2642\uFE0F":"1f3c4-1f3fc-2642","\uD83C\uDFC4\uD83C\uDFFD\u200D\u2640\uFE0F":"1f3c4-1f3fd-2640","\uD83C\uDFC4\uD83C\uDFFD\u200D\u2642\uFE0F":"1f3c4-1f3fd-2642","\uD83C\uDFC4\uD83C\uDFFE\u200D\u2640\uFE0F":"1f3c4-1f3fe-2640","\uD83C\uDFC4\uD83C\uDFFE\u200D\u2642\uFE0F":"1f3c4-1f3fe-2642","\uD83C\uDFC4\uD83C\uDFFF\u200D\u2640\uFE0F":"1f3c4-1f3ff-2640","\uD83C\uDFC4\uD83C\uDFFF\u200D\u2642\uFE0F":"1f3c4-1f3ff-2642","\uD83C\uDFCA\uD83C\uDFFB\u200D\u2640\uFE0F":"1f3ca-1f3fb-2640","\uD83C\uDFCA\uD83C\uDFFB\u200D\u2642\uFE0F":"1f3ca-1f3fb-2642","\uD83C\uDFCA\uD83C\uDFFC\u200D\u2640\uFE0F":"1f3ca-1f3fc-2640","\uD83C\uDFCA\uD83C\uDFFC\u200D\u2642\uFE0F":"1f3ca-1f3fc-2642","\uD83C\uDFCA\uD83C\uDFFD\u200D\u2640\uFE0F":"1f3ca-1f3fd-2640","\uD83C\uDFCA\uD83C\uDFFD\u200D\u2642\uFE0F":"1f3ca-1f3fd-2642","\uD83C\uDFCA\uD83C\uDFFE\u200D\u2640\uFE0F":"1f3ca-1f3fe-2640","\uD83C\uDFCA\uD83C\uDFFE\u200D\u2642\uFE0F":"1f3ca-1f3fe-2642","\uD83C\uDFCA\uD83C\uDFFF\u200D\u2640\uFE0F":"1f3ca-1f3ff-2640","\uD83C\uDFCA\uD83C\uDFFF\u200D\u2642\uFE0F":"1f3ca-1f3ff-2642","\uD83C\uDFCB\uFE0F\uD83C\uDFFB\u2640\uFE0F":"1f3cb-1f3fb-2640","\uD83C\uDFCB\uFE0F\uD83C\uDFFB\u2642\uFE0F":"1f3cb-1f3fb-2642","\uD83C\uDFCB\uFE0F\uD83C\uDFFC\u2640\uFE0F":"1f3cb-1f3fc-2640","\uD83C\uDFCB\uFE0F\uD83C\uDFFC\u2642\uFE0F":"1f3cb-1f3fc-2642","\uD83C\uDFCB\uFE0F\uD83C\uDFFD\u2640\uFE0F":"1f3cb-1f3fd-2640","\uD83C\uDFCB\uFE0F\uD83C\uDFFD\u2642\uFE0F":"1f3cb-1f3fd-2642","\uD83C\uDFCB\uFE0F\uD83C\uDFFE\u2640\uFE0F":"1f3cb-1f3fe-2640","\uD83C\uDFCB\uFE0F\uD83C\uDFFE\u2642\uFE0F":"1f3cb-1f3fe-2642","\uD83C\uDFCB\uFE0F\uD83C\uDFFF\u2640\uFE0F":"1f3cb-1f3ff-2640","\uD83C\uDFCB\uFE0F\uD83C\uDFFF\u2642\uFE0F":"1f3cb-1f3ff-2642","\uD83C\uDFCC\uFE0F\uD83C\uDFFB\u2640\uFE0F":"1f3cc-1f3fb-2640","\uD83C\uDFCC\uFE0F\uD83C\uDFFB\u2642\uFE0F":"1f3cc-1f3fb-2642","\uD83C\uDFCC\uFE0F\uD83C\uDFFC\u2640\uFE0F":"1f3cc-1f3fc-2640","\uD83C\uDFCC\uFE0F\uD83C\uDFFC\u2642\uFE0F":"1f3cc-1f3fc-2642","\uD83C\uDFCC\uFE0F\uD83C\uDFFD\u2640\uFE0F":"1f3cc-1f3fd-2640","\uD83C\uDFCC\uFE0F\uD83C\uDFFD\u2642\uFE0F":"1f3cc-1f3fd-2642","\uD83C\uDFCC\uFE0F\uD83C\uDFFE\u2640\uFE0F":"1f3cc-1f3fe-2640","\uD83C\uDFCC\uFE0F\uD83C\uDFFE\u2642\uFE0F":"1f3cc-1f3fe-2642","\uD83C\uDFCC\uFE0F\uD83C\uDFFF\u2640\uFE0F":"1f3cc-1f3ff-2640","\uD83C\uDFCC\uFE0F\uD83C\uDFFF\u2642\uFE0F":"1f3cc-1f3ff-2642","\uD83D\uDC86\uD83C\uDFFB\u200D\u2640\uFE0F":"1f486-1f3fb-2640","\uD83D\uDC86\uD83C\uDFFB\u200D\u2642\uFE0F":"1f486-1f3fb-2642","\uD83D\uDC86\uD83C\uDFFC\u200D\u2640\uFE0F":"1f486-1f3fc-2640","\uD83D\uDC86\uD83C\uDFFC\u200D\u2642\uFE0F":"1f486-1f3fc-2642","\uD83D\uDC86\uD83C\uDFFD\u200D\u2640\uFE0F":"1f486-1f3fd-2640","\uD83D\uDC86\uD83C\uDFFD\u200D\u2642\uFE0F":"1f486-1f3fd-2642","\uD83D\uDC86\uD83C\uDFFE\u200D\u2640\uFE0F":"1f486-1f3fe-2640","\uD83D\uDC86\uD83C\uDFFE\u200D\u2642\uFE0F":"1f486-1f3fe-2642","\uD83D\uDC86\uD83C\uDFFF\u200D\u2640\uFE0F":"1f486-1f3ff-2640","\uD83D\uDC86\uD83C\uDFFF\u200D\u2642\uFE0F":"1f486-1f3ff-2642","\uD83D\uDC87\uD83C\uDFFB\u200D\u2640\uFE0F":"1f487-1f3fb-2640","\uD83D\uDC87\uD83C\uDFFB\u200D\u2642\uFE0F":"1f487-1f3fb-2642","\uD83D\uDC87\uD83C\uDFFC\u200D\u2640\uFE0F":"1f487-1f3fc-2640","\uD83D\uDC87\uD83C\uDFFC\u200D\u2642\uFE0F":"1f487-1f3fc-2642","\uD83D\uDC87\uD83C\uDFFD\u200D\u2640\uFE0F":"1f487-1f3fd-2640","\uD83D\uDC87\uD83C\uDFFD\u200D\u2642\uFE0F":"1f487-1f3fd-2642","\uD83D\uDC87\uD83C\uDFFE\u200D\u2640\uFE0F":"1f487-1f3fe-2640","\uD83D\uDC87\uD83C\uDFFE\u200D\u2642\uFE0F":"1f487-1f3fe-2642","\uD83D\uDC87\uD83C\uDFFF\u200D\u2640\uFE0F":"1f487-1f3ff-2640","\uD83D\uDC87\uD83C\uDFFF\u200D\u2642\uFE0F":"1f487-1f3ff-2642","\uD83D\uDEA3\uD83C\uDFFB\u200D\u2640\uFE0F":"1f6a3-1f3fb-2640","\uD83D\uDEA3\uD83C\uDFFB\u200D\u2642\uFE0F":"1f6a3-1f3fb-2642","\uD83D\uDEA3\uD83C\uDFFC\u200D\u2640\uFE0F":"1f6a3-1f3fc-2640","\uD83D\uDEA3\uD83C\uDFFC\u200D\u2642\uFE0F":"1f6a3-1f3fc-2642","\uD83D\uDEA3\uD83C\uDFFD\u200D\u2640\uFE0F":"1f6a3-1f3fd-2640","\uD83D\uDEA3\uD83C\uDFFD\u200D\u2642\uFE0F":"1f6a3-1f3fd-2642","\uD83D\uDEA3\uD83C\uDFFE\u200D\u2640\uFE0F":"1f6a3-1f3fe-2640","\uD83D\uDEA3\uD83C\uDFFE\u200D\u2642\uFE0F":"1f6a3-1f3fe-2642","\uD83D\uDEA3\uD83C\uDFFF\u200D\u2640\uFE0F":"1f6a3-1f3ff-2640","\uD83D\uDEA3\uD83C\uDFFF\u200D\u2642\uFE0F":"1f6a3-1f3ff-2642","\uD83D\uDEB4\uD83C\uDFFB\u200D\u2640\uFE0F":"1f6b4-1f3fb-2640","\uD83D\uDEB4\uD83C\uDFFB\u200D\u2642\uFE0F":"1f6b4-1f3fb-2642","\uD83D\uDEB4\uD83C\uDFFC\u200D\u2640\uFE0F":"1f6b4-1f3fc-2640","\uD83D\uDEB4\uD83C\uDFFC\u200D\u2642\uFE0F":"1f6b4-1f3fc-2642","\uD83D\uDEB4\uD83C\uDFFD\u200D\u2640\uFE0F":"1f6b4-1f3fd-2640","\uD83D\uDEB4\uD83C\uDFFD\u200D\u2642\uFE0F":"1f6b4-1f3fd-2642","\uD83D\uDEB4\uD83C\uDFFE\u200D\u2640\uFE0F":"1f6b4-1f3fe-2640","\uD83D\uDEB4\uD83C\uDFFE\u200D\u2642\uFE0F":"1f6b4-1f3fe-2642","\uD83D\uDEB4\uD83C\uDFFF\u200D\u2640\uFE0F":"1f6b4-1f3ff-2640","\uD83D\uDEB4\uD83C\uDFFF\u200D\u2642\uFE0F":"1f6b4-1f3ff-2642","\uD83D\uDEB5\uD83C\uDFFB\u200D\u2640\uFE0F":"1f6b5-1f3fb-2640","\uD83D\uDEB5\uD83C\uDFFB\u200D\u2642\uFE0F":"1f6b5-1f3fb-2642","\uD83D\uDEB5\uD83C\uDFFC\u200D\u2640\uFE0F":"1f6b5-1f3fc-2640","\uD83D\uDEB5\uD83C\uDFFC\u200D\u2642\uFE0F":"1f6b5-1f3fc-2642","\uD83D\uDEB5\uD83C\uDFFD\u200D\u2640\uFE0F":"1f6b5-1f3fd-2640","\uD83D\uDEB5\uD83C\uDFFD\u200D\u2642\uFE0F":"1f6b5-1f3fd-2642","\uD83D\uDEB5\uD83C\uDFFE\u200D\u2640\uFE0F":"1f6b5-1f3fe-2640","\uD83D\uDEB5\uD83C\uDFFE\u200D\u2642\uFE0F":"1f6b5-1f3fe-2642","\uD83D\uDEB5\uD83C\uDFFF\u200D\u2640\uFE0F":"1f6b5-1f3ff-2640","\uD83D\uDEB5\uD83C\uDFFF\u200D\u2642\uFE0F":"1f6b5-1f3ff-2642","\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F":"1f6b6-1f3fb-2640","\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F":"1f6b6-1f3fb-2642","\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F":"1f6b6-1f3fc-2640","\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F":"1f6b6-1f3fc-2642","\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F":"1f6b6-1f3fd-2640","\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F":"1f6b6-1f3fd-2642","\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F":"1f6b6-1f3fe-2640","\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F":"1f6b6-1f3fe-2642","\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F":"1f6b6-1f3ff-2640","\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F":"1f6b6-1f3ff-2642","\uD83E\uDD38\uD83C\uDFFB\u200D\u2640\uFE0F":"1f938-1f3fb-2640","\uD83E\uDD38\uD83C\uDFFB\u200D\u2642\uFE0F":"1f938-1f3fb-2642","\uD83E\uDD38\uD83C\uDFFC\u200D\u2640\uFE0F":"1f938-1f3fc-2640","\uD83E\uDD38\uD83C\uDFFC\u200D\u2642\uFE0F":"1f938-1f3fc-2642","\uD83E\uDD38\uD83C\uDFFD\u200D\u2640\uFE0F":"1f938-1f3fd-2640","\uD83E\uDD38\uD83C\uDFFD\u200D\u2642\uFE0F":"1f938-1f3fd-2642","\uD83E\uDD38\uD83C\uDFFE\u200D\u2640\uFE0F":"1f938-1f3fe-2640","\uD83E\uDD38\uD83C\uDFFE\u200D\u2642\uFE0F":"1f938-1f3fe-2642","\uD83E\uDD38\uD83C\uDFFF\u200D\u2640\uFE0F":"1f938-1f3ff-2640","\uD83E\uDD38\uD83C\uDFFF\u200D\u2642\uFE0F":"1f938-1f3ff-2642","\uD83E\uDD39\uD83C\uDFFB\u200D\u2640\uFE0F":"1f939-1f3fb-2640","\uD83E\uDD39\uD83C\uDFFB\u200D\u2642\uFE0F":"1f939-1f3fb-2642","\uD83E\uDD39\uD83C\uDFFC\u200D\u2640\uFE0F":"1f939-1f3fc-2640","\uD83E\uDD39\uD83C\uDFFC\u200D\u2642\uFE0F":"1f939-1f3fc-2642","\uD83E\uDD39\uD83C\uDFFD\u200D\u2640\uFE0F":"1f939-1f3fd-2640","\uD83E\uDD39\uD83C\uDFFD\u200D\u2642\uFE0F":"1f939-1f3fd-2642","\uD83E\uDD39\uD83C\uDFFE\u200D\u2640\uFE0F":"1f939-1f3fe-2640","\uD83E\uDD39\uD83C\uDFFE\u200D\u2642\uFE0F":"1f939-1f3fe-2642","\uD83E\uDD39\uD83C\uDFFF\u200D\u2640\uFE0F":"1f939-1f3ff-2640","\uD83E\uDD39\uD83C\uDFFF\u200D\u2642\uFE0F":"1f939-1f3ff-2642","\uD83E\uDD3D\uD83C\uDFFB\u200D\u2640\uFE0F":"1f93d-1f3fb-2640","\uD83E\uDD3D\uD83C\uDFFB\u200D\u2642\uFE0F":"1f93d-1f3fb-2642","\uD83E\uDD3D\uD83C\uDFFC\u200D\u2640\uFE0F":"1f93d-1f3fc-2640","\uD83E\uDD3D\uD83C\uDFFC\u200D\u2642\uFE0F":"1f93d-1f3fc-2642","\uD83E\uDD3D\uD83C\uDFFD\u200D\u2640\uFE0F":"1f93d-1f3fd-2640","\uD83E\uDD3D\uD83C\uDFFD\u200D\u2642\uFE0F":"1f93d-1f3fd-2642","\uD83E\uDD3D\uD83C\uDFFE\u200D\u2640\uFE0F":"1f93d-1f3fe-2640","\uD83E\uDD3D\uD83C\uDFFE\u200D\u2642\uFE0F":"1f93d-1f3fe-2642","\uD83E\uDD3D\uD83C\uDFFF\u200D\u2640\uFE0F":"1f93d-1f3ff-2640","\uD83E\uDD3D\uD83C\uDFFF\u200D\u2642\uFE0F":"1f93d-1f3ff-2642","\uD83E\uDD3E\uD83C\uDFFB\u200D\u2640\uFE0F":"1f93e-1f3fb-2640","\uD83E\uDD3E\uD83C\uDFFB\u200D\u2642\uFE0F":"1f93e-1f3fb-2642","\uD83E\uDD3E\uD83C\uDFFC\u200D\u2640\uFE0F":"1f93e-1f3fc-2640","\uD83E\uDD3E\uD83C\uDFFC\u200D\u2642\uFE0F":"1f93e-1f3fc-2642","\uD83E\uDD3E\uD83C\uDFFD\u200D\u2640\uFE0F":"1f93e-1f3fd-2640","\uD83E\uDD3E\uD83C\uDFFD\u200D\u2642\uFE0F":"1f93e-1f3fd-2642","\uD83E\uDD3E\uD83C\uDFFE\u200D\u2640\uFE0F":"1f93e-1f3fe-2640","\uD83E\uDD3E\uD83C\uDFFE\u200D\u2642\uFE0F":"1f93e-1f3fe-2642","\uD83E\uDD3E\uD83C\uDFFF\u200D\u2640\uFE0F":"1f93e-1f3ff-2640","\uD83E\uDD3E\uD83C\uDFFF\u200D\u2642\uFE0F":"1f93e-1f3ff-2642","\uD83D\uDC81\uD83C\uDFFB\u200D\u2640\uFE0F":"1f481-1f3fb-2640","\uD83D\uDC81\uD83C\uDFFB\u200D\u2642\uFE0F":"1f481-1f3fb-2642","\uD83D\uDC81\uD83C\uDFFC\u200D\u2640\uFE0F":"1f481-1f3fc-2640","\uD83D\uDC81\uD83C\uDFFC\u200D\u2642\uFE0F":"1f481-1f3fc-2642","\uD83D\uDC81\uD83C\uDFFD\u200D\u2640\uFE0F":"1f481-1f3fd-2640","\uD83D\uDC81\uD83C\uDFFD\u200D\u2642\uFE0F":"1f481-1f3fd-2642","\uD83D\uDC81\uD83C\uDFFE\u200D\u2640\uFE0F":"1f481-1f3fe-2640","\uD83D\uDC81\uD83C\uDFFE\u200D\u2642\uFE0F":"1f481-1f3fe-2642","\uD83D\uDC81\uD83C\uDFFF\u200D\u2640\uFE0F":"1f481-1f3ff-2640","\uD83D\uDC81\uD83C\uDFFF\u200D\u2642\uFE0F":"1f481-1f3ff-2642","\uD83D\uDE45\uD83C\uDFFB\u200D\u2640\uFE0F":"1f645-1f3fb-2640","\uD83D\uDE45\uD83C\uDFFB\u200D\u2642\uFE0F":"1f645-1f3fb-2642","\uD83D\uDE45\uD83C\uDFFC\u200D\u2640\uFE0F":"1f645-1f3fc-2640","\uD83D\uDE45\uD83C\uDFFC\u200D\u2642\uFE0F":"1f645-1f3fc-2642","\uD83D\uDE45\uD83C\uDFFD\u200D\u2640\uFE0F":"1f645-1f3fd-2640","\uD83D\uDE45\uD83C\uDFFD\u200D\u2642\uFE0F":"1f645-1f3fd-2642","\uD83D\uDE45\uD83C\uDFFE\u200D\u2640\uFE0F":"1f645-1f3fe-2640","\uD83D\uDE45\uD83C\uDFFE\u200D\u2642\uFE0F":"1f645-1f3fe-2642","\uD83D\uDE45\uD83C\uDFFF\u200D\u2640\uFE0F":"1f645-1f3ff-2640","\uD83D\uDE45\uD83C\uDFFF\u200D\u2642\uFE0F":"1f645-1f3ff-2642","\uD83D\uDE46\uD83C\uDFFB\u200D\u2640\uFE0F":"1f646-1f3fb-2640","\uD83D\uDE46\uD83C\uDFFB\u200D\u2642\uFE0F":"1f646-1f3fb-2642","\uD83D\uDE46\uD83C\uDFFC\u200D\u2640\uFE0F":"1f646-1f3fc-2640","\uD83D\uDE46\uD83C\uDFFC\u200D\u2642\uFE0F":"1f646-1f3fc-2642","\uD83D\uDE46\uD83C\uDFFD\u200D\u2640\uFE0F":"1f646-1f3fd-2640","\uD83D\uDE46\uD83C\uDFFD\u200D\u2642\uFE0F":"1f646-1f3fd-2642","\uD83D\uDE46\uD83C\uDFFE\u200D\u2640\uFE0F":"1f646-1f3fe-2640","\uD83D\uDE46\uD83C\uDFFE\u200D\u2642\uFE0F":"1f646-1f3fe-2642","\uD83D\uDE46\uD83C\uDFFF\u200D\u2640\uFE0F":"1f646-1f3ff-2640","\uD83D\uDE46\uD83C\uDFFF\u200D\u2642\uFE0F":"1f646-1f3ff-2642","\uD83D\uDE47\uD83C\uDFFB\u200D\u2640\uFE0F":"1f647-1f3fb-2640","\uD83D\uDE47\uD83C\uDFFB\u200D\u2642\uFE0F":"1f647-1f3fb-2642","\uD83D\uDE47\uD83C\uDFFC\u200D\u2640\uFE0F":"1f647-1f3fc-2640","\uD83D\uDE47\uD83C\uDFFC\u200D\u2642\uFE0F":"1f647-1f3fc-2642","\uD83D\uDE47\uD83C\uDFFD\u200D\u2640\uFE0F":"1f647-1f3fd-2640","\uD83D\uDE47\uD83C\uDFFD\u200D\u2642\uFE0F":"1f647-1f3fd-2642","\uD83D\uDE47\uD83C\uDFFE\u200D\u2640\uFE0F":"1f647-1f3fe-2640","\uD83D\uDE47\uD83C\uDFFE\u200D\u2642\uFE0F":"1f647-1f3fe-2642","\uD83D\uDE47\uD83C\uDFFF\u200D\u2640\uFE0F":"1f647-1f3ff-2640","\uD83D\uDE47\uD83C\uDFFF\u200D\u2642\uFE0F":"1f647-1f3ff-2642","\uD83D\uDE4B\uD83C\uDFFB\u200D\u2640\uFE0F":"1f64b-1f3fb-2640","\uD83D\uDE4B\uD83C\uDFFB\u200D\u2642\uFE0F":"1f64b-1f3fb-2642","\uD83D\uDE4B\uD83C\uDFFC\u200D\u2640\uFE0F":"1f64b-1f3fc-2640","\uD83D\uDE4B\uD83C\uDFFC\u200D\u2642\uFE0F":"1f64b-1f3fc-2642","\uD83D\uDE4B\uD83C\uDFFD\u200D\u2640\uFE0F":"1f64b-1f3fd-2640","\uD83D\uDE4B\uD83C\uDFFD\u200D\u2642\uFE0F":"1f64b-1f3fd-2642","\uD83D\uDE4B\uD83C\uDFFE\u200D\u2640\uFE0F":"1f64b-1f3fe-2640","\uD83D\uDE4B\uD83C\uDFFE\u200D\u2642\uFE0F":"1f64b-1f3fe-2642","\uD83D\uDE4B\uD83C\uDFFF\u200D\u2640\uFE0F":"1f64b-1f3ff-2640","\uD83D\uDE4B\uD83C\uDFFF\u200D\u2642\uFE0F":"1f64b-1f3ff-2642","\uD83D\uDE4D\uD83C\uDFFB\u200D\u2640\uFE0F":"1f64d-1f3fb-2640","\uD83D\uDE4D\uD83C\uDFFB\u200D\u2642\uFE0F":"1f64d-1f3fb-2642","\uD83D\uDE4D\uD83C\uDFFC\u200D\u2640\uFE0F":"1f64d-1f3fc-2640","\uD83D\uDE4D\uD83C\uDFFC\u200D\u2642\uFE0F":"1f64d-1f3fc-2642","\uD83D\uDE4D\uD83C\uDFFD\u200D\u2640\uFE0F":"1f64d-1f3fd-2640","\uD83D\uDE4D\uD83C\uDFFD\u200D\u2642\uFE0F":"1f64d-1f3fd-2642","\uD83D\uDE4D\uD83C\uDFFE\u200D\u2640\uFE0F":"1f64d-1f3fe-2640","\uD83D\uDE4D\uD83C\uDFFE\u200D\u2642\uFE0F":"1f64d-1f3fe-2642","\uD83D\uDE4D\uD83C\uDFFF\u200D\u2640\uFE0F":"1f64d-1f3ff-2640","\uD83D\uDE4D\uD83C\uDFFF\u200D\u2642\uFE0F":"1f64d-1f3ff-2642","\uD83D\uDE4E\uD83C\uDFFB\u200D\u2640\uFE0F":"1f64e-1f3fb-2640","\uD83D\uDE4E\uD83C\uDFFB\u200D\u2642\uFE0F":"1f64e-1f3fb-2642","\uD83D\uDE4E\uD83C\uDFFC\u200D\u2640\uFE0F":"1f64e-1f3fc-2640","\uD83D\uDE4E\uD83C\uDFFC\u200D\u2642\uFE0F":"1f64e-1f3fc-2642","\uD83D\uDE4E\uD83C\uDFFD\u200D\u2640\uFE0F":"1f64e-1f3fd-2640","\uD83D\uDE4E\uD83C\uDFFD\u200D\u2642\uFE0F":"1f64e-1f3fd-2642","\uD83D\uDE4E\uD83C\uDFFE\u200D\u2640\uFE0F":"1f64e-1f3fe-2640","\uD83D\uDE4E\uD83C\uDFFE\u200D\u2642\uFE0F":"1f64e-1f3fe-2642","\uD83D\uDE4E\uD83C\uDFFF\u200D\u2640\uFE0F":"1f64e-1f3ff-2640","\uD83D\uDE4E\uD83C\uDFFF\u200D\u2642\uFE0F":"1f64e-1f3ff-2642","\uD83E\uDD26\uD83C\uDFFB\u200D\u2640\uFE0F":"1f926-1f3fb-2640","\uD83E\uDD26\uD83C\uDFFB\u200D\u2642\uFE0F":"1f926-1f3fb-2642","\uD83E\uDD26\uD83C\uDFFC\u200D\u2640\uFE0F":"1f926-1f3fc-2640","\uD83E\uDD26\uD83C\uDFFC\u200D\u2642\uFE0F":"1f926-1f3fc-2642","\uD83E\uDD26\uD83C\uDFFD\u200D\u2640\uFE0F":"1f926-1f3fd-2640","\uD83E\uDD26\uD83C\uDFFD\u200D\u2642\uFE0F":"1f926-1f3fd-2642","\uD83E\uDD26\uD83C\uDFFE\u200D\u2640\uFE0F":"1f926-1f3fe-2640","\uD83E\uDD26\uD83C\uDFFE\u200D\u2642\uFE0F":"1f926-1f3fe-2642","\uD83E\uDD26\uD83C\uDFFF\u200D\u2640\uFE0F":"1f926-1f3ff-2640","\uD83E\uDD26\uD83C\uDFFF\u200D\u2642\uFE0F":"1f926-1f3ff-2642","\uD83E\uDD37\uD83C\uDFFB\u200D\u2640\uFE0F":"1f937-1f3fb-2640","\uD83E\uDD37\uD83C\uDFFB\u200D\u2642\uFE0F":"1f937-1f3fb-2642","\uD83E\uDD37\uD83C\uDFFC\u200D\u2640\uFE0F":"1f937-1f3fc-2640","\uD83E\uDD37\uD83C\uDFFC\u200D\u2642\uFE0F":"1f937-1f3fc-2642","\uD83E\uDD37\uD83C\uDFFD\u200D\u2640\uFE0F":"1f937-1f3fd-2640","\uD83E\uDD37\uD83C\uDFFD\u200D\u2642\uFE0F":"1f937-1f3fd-2642","\uD83E\uDD37\uD83C\uDFFE\u200D\u2640\uFE0F":"1f937-1f3fe-2640","\uD83E\uDD37\uD83C\uDFFE\u200D\u2642\uFE0F":"1f937-1f3fe-2642","\uD83E\uDD37\uD83C\uDFFF\u200D\u2640\uFE0F":"1f937-1f3ff-2640","\uD83E\uDD37\uD83C\uDFFF\u200D\u2642\uFE0F":"1f937-1f3ff-2642","\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F":"1f441-1f5e8","\uD83D\uDD75\uD83C\uDFFB\u200D\u2640\uFE0F":"1f575-1f3fb-2640","\uD83D\uDD75\uD83C\uDFFB\u200D\u2642\uFE0F":"1f575-1f3fb-2642","\uD83D\uDD75\uD83C\uDFFC\u200D\u2640\uFE0F":"1f575-1f3fc-2640","\uD83D\uDD75\uD83C\uDFFC\u200D\u2642\uFE0F":"1f575-1f3fc-2642","\uD83D\uDD75\uD83C\uDFFD\u200D\u2640\uFE0F":"1f575-1f3fd-2640","\uD83D\uDD75\uD83C\uDFFD\u200D\u2642\uFE0F":"1f575-1f3fd-2642","\uD83D\uDD75\uD83C\uDFFE\u200D\u2640\uFE0F":"1f575-1f3fe-2640","\uD83D\uDD75\uD83C\uDFFE\u200D\u2642\uFE0F":"1f575-1f3fe-2642","\uD83D\uDD75\uD83C\uDFFF\u200D\u2640\uFE0F":"1f575-1f3ff-2640","\uD83D\uDD75\uD83C\uDFFF\u200D\u2642\uFE0F":"1f575-1f3ff-2642","\uD83C\uDFCB\uD83C\uDFFB\u200D\u2640\uFE0F":"1f3cb-1f3fb-2640","\uD83C\uDFCB\uD83C\uDFFB\u200D\u2642\uFE0F":"1f3cb-1f3fb-2642","\uD83C\uDFCB\uD83C\uDFFC\u200D\u2640\uFE0F":"1f3cb-1f3fc-2640","\uD83C\uDFCB\uD83C\uDFFC\u200D\u2642\uFE0F":"1f3cb-1f3fc-2642","\uD83C\uDFCB\uD83C\uDFFD\u200D\u2640\uFE0F":"1f3cb-1f3fd-2640","\uD83C\uDFCB\uD83C\uDFFD\u200D\u2642\uFE0F":"1f3cb-1f3fd-2642","\uD83C\uDFCB\uD83C\uDFFE\u200D\u2640\uFE0F":"1f3cb-1f3fe-2640","\uD83C\uDFCB\uD83C\uDFFE\u200D\u2642\uFE0F":"1f3cb-1f3fe-2642","\uD83C\uDFCB\uD83C\uDFFF\u200D\u2640\uFE0F":"1f3cb-1f3ff-2640","\uD83C\uDFCB\uD83C\uDFFF\u200D\u2642\uFE0F":"1f3cb-1f3ff-2642","\uD83C\uDFCC\uD83C\uDFFB\u200D\u2640\uFE0F":"1f3cc-1f3fb-2640","\uD83C\uDFCC\uD83C\uDFFB\u200D\u2642\uFE0F":"1f3cc-1f3fb-2642","\uD83C\uDFCC\uD83C\uDFFC\u200D\u2640\uFE0F":"1f3cc-1f3fc-2640","\uD83C\uDFCC\uD83C\uDFFC\u200D\u2642\uFE0F":"1f3cc-1f3fc-2642","\uD83C\uDFCC\uD83C\uDFFD\u200D\u2640\uFE0F":"1f3cc-1f3fd-2640","\uD83C\uDFCC\uD83C\uDFFD\u200D\u2642\uFE0F":"1f3cc-1f3fd-2642","\uD83C\uDFCC\uD83C\uDFFE\u200D\u2640\uFE0F":"1f3cc-1f3fe-2640","\uD83C\uDFCC\uD83C\uDFFE\u200D\u2642\uFE0F":"1f3cc-1f3fe-2642","\uD83C\uDFCC\uD83C\uDFFF\u200D\u2640\uFE0F":"1f3cc-1f3ff-2640","\uD83C\uDFCC\uD83C\uDFFF\u200D\u2642\uFE0F":"1f3cc-1f3ff-2642","\uD83E\uDDD9\uD83C\uDFFB\u200D\u2640\uFE0F":"1f9d9-1f3fb-2640","\uD83E\uDDD9\uD83C\uDFFB\u200D\u2642\uFE0F":"1f9d9-1f3fb-2642","\uD83E\uDDD9\uD83C\uDFFC\u200D\u2640\uFE0F":"1f9d9-1f3fc-2640","\uD83E\uDDD9\uD83C\uDFFC\u200D\u2642\uFE0F":"1f9d9-1f3fc-2642","\uD83E\uDDD9\uD83C\uDFFD\u200D\u2640\uFE0F":"1f9d9-1f3fd-2640","\uD83E\uDDD9\uD83C\uDFFD\u200D\u2642\uFE0F":"1f9d9-1f3fd-2642","\uD83E\uDDD9\uD83C\uDFFE\u200D\u2640\uFE0F":"1f9d9-1f3fe-2640","\uD83E\uDDD9\uD83C\uDFFE\u200D\u2642\uFE0F":"1f9d9-1f3fe-2642","\uD83E\uDDD9\uD83C\uDFFF\u200D\u2640\uFE0F":"1f9d9-1f3ff-2640","\uD83E\uDDD9\uD83C\uDFFF\u200D\u2642\uFE0F":"1f9d9-1f3ff-2642","\uD83E\uDDDA\uD83C\uDFFB\u200D\u2640\uFE0F":"1f9da-1f3fb-2640","\uD83E\uDDDA\uD83C\uDFFB\u200D\u2642\uFE0F":"1f9da-1f3fb-2642","\uD83E\uDDDA\uD83C\uDFFC\u200D\u2640\uFE0F":"1f9da-1f3fc-2640","\uD83E\uDDDA\uD83C\uDFFC\u200D\u2642\uFE0F":"1f9da-1f3fc-2642","\uD83E\uDDDA\uD83C\uDFFD\u200D\u2640\uFE0F":"1f9da-1f3fd-2640","\uD83E\uDDDA\uD83C\uDFFD\u200D\u2642\uFE0F":"1f9da-1f3fd-2642","\uD83E\uDDDA\uD83C\uDFFE\u200D\u2640\uFE0F":"1f9da-1f3fe-2640","\uD83E\uDDDA\uD83C\uDFFE\u200D\u2642\uFE0F":"1f9da-1f3fe-2642","\uD83E\uDDDA\uD83C\uDFFF\u200D\u2640\uFE0F":"1f9da-1f3ff-2640","\uD83E\uDDDA\uD83C\uDFFF\u200D\u2642\uFE0F":"1f9da-1f3ff-2642","\uD83E\uDDDB\uD83C\uDFFB\u200D\u2640\uFE0F":"1f9db-1f3fb-2640","\uD83E\uDDDB\uD83C\uDFFB\u200D\u2642\uFE0F":"1f9db-1f3fb-2642","\uD83E\uDDDB\uD83C\uDFFC\u200D\u2640\uFE0F":"1f9db-1f3fc-2640","\uD83E\uDDDB\uD83C\uDFFC\u200D\u2642\uFE0F":"1f9db-1f3fc-2642","\uD83E\uDDDB\uD83C\uDFFD\u200D\u2640\uFE0F":"1f9db-1f3fd-2640","\uD83E\uDDDB\uD83C\uDFFD\u200D\u2642\uFE0F":"1f9db-1f3fd-2642","\uD83E\uDDDB\uD83C\uDFFE\u200D\u2640\uFE0F":"1f9db-1f3fe-2640","\uD83E\uDDDB\uD83C\uDFFE\u200D\u2642\uFE0F":"1f9db-1f3fe-2642","\uD83E\uDDDB\uD83C\uDFFF\u200D\u2640\uFE0F":"1f9db-1f3ff-2640","\uD83E\uDDDB\uD83C\uDFFF\u200D\u2642\uFE0F":"1f9db-1f3ff-2642","\uD83E\uDDDC\uD83C\uDFFB\u200D\u2640\uFE0F":"1f9dc-1f3fb-2640","\uD83E\uDDDC\uD83C\uDFFB\u200D\u2642\uFE0F":"1f9dc-1f3fb-2642","\uD83E\uDDDC\uD83C\uDFFC\u200D\u2640\uFE0F":"1f9dc-1f3fc-2640","\uD83E\uDDDC\uD83C\uDFFC\u200D\u2642\uFE0F":"1f9dc-1f3fc-2642","\uD83E\uDDDC\uD83C\uDFFD\u200D\u2640\uFE0F":"1f9dc-1f3fd-2640","\uD83E\uDDDC\uD83C\uDFFD\u200D\u2642\uFE0F":"1f9dc-1f3fd-2642","\uD83E\uDDDC\uD83C\uDFFE\u200D\u2640\uFE0F":"1f9dc-1f3fe-2640","\uD83E\uDDDC\uD83C\uDFFE\u200D\u2642\uFE0F":"1f9dc-1f3fe-2642","\uD83E\uDDDC\uD83C\uDFFF\u200D\u2640\uFE0F":"1f9dc-1f3ff-2640","\uD83E\uDDDC\uD83C\uDFFF\u200D\u2642\uFE0F":"1f9dc-1f3ff-2642","\uD83E\uDDDD\uD83C\uDFFB\u200D\u2640\uFE0F":"1f9dd-1f3fb-2640","\uD83E\uDDDD\uD83C\uDFFB\u200D\u2642\uFE0F":"1f9dd-1f3fb-2642","\uD83E\uDDDD\uD83C\uDFFC\u200D\u2640\uFE0F":"1f9dd-1f3fc-2640","\uD83E\uDDDD\uD83C\uDFFC\u200D\u2642\uFE0F":"1f9dd-1f3fc-2642","\uD83E\uDDDD\uD83C\uDFFD\u200D\u2640\uFE0F":"1f9dd-1f3fd-2640","\uD83E\uDDDD\uD83C\uDFFD\u200D\u2642\uFE0F":"1f9dd-1f3fd-2642","\uD83E\uDDDD\uD83C\uDFFE\u200D\u2640\uFE0F":"1f9dd-1f3fe-2640","\uD83E\uDDDD\uD83C\uDFFE\u200D\u2642\uFE0F":"1f9dd-1f3fe-2642","\uD83E\uDDDD\uD83C\uDFFF\u200D\u2640\uFE0F":"1f9dd-1f3ff-2640","\uD83E\uDDDD\uD83C\uDFFF\u200D\u2642\uFE0F":"1f9dd-1f3ff-2642","\uD83E\uDDD6\uD83C\uDFFB\u200D\u2640\uFE0F":"1f9d6-1f3fb-2640","\uD83E\uDDD6\uD83C\uDFFB\u200D\u2642\uFE0F":"1f9d6-1f3fb-2642","\uD83E\uDDD6\uD83C\uDFFC\u200D\u2640\uFE0F":"1f9d6-1f3fc-2640","\uD83E\uDDD6\uD83C\uDFFC\u200D\u2642\uFE0F":"1f9d6-1f3fc-2642","\uD83E\uDDD6\uD83C\uDFFD\u200D\u2640\uFE0F":"1f9d6-1f3fd-2640","\uD83E\uDDD6\uD83C\uDFFD\u200D\u2642\uFE0F":"1f9d6-1f3fd-2642","\uD83E\uDDD6\uD83C\uDFFE\u200D\u2640\uFE0F":"1f9d6-1f3fe-2640","\uD83E\uDDD6\uD83C\uDFFE\u200D\u2642\uFE0F":"1f9d6-1f3fe-2642","\uD83E\uDDD6\uD83C\uDFFF\u200D\u2640\uFE0F":"1f9d6-1f3ff-2640","\uD83E\uDDD6\uD83C\uDFFF\u200D\u2642\uFE0F":"1f9d6-1f3ff-2642","\uD83E\uDDD7\uD83C\uDFFB\u200D\u2640\uFE0F":"1f9d7-1f3fb-2640","\uD83E\uDDD7\uD83C\uDFFB\u200D\u2642\uFE0F":"1f9d7-1f3fb-2642","\uD83E\uDDD7\uD83C\uDFFC\u200D\u2640\uFE0F":"1f9d7-1f3fc-2640","\uD83E\uDDD7\uD83C\uDFFC\u200D\u2642\uFE0F":"1f9d7-1f3fc-2642","\uD83E\uDDD7\uD83C\uDFFD\u200D\u2640\uFE0F":"1f9d7-1f3fd-2640","\uD83E\uDDD7\uD83C\uDFFD\u200D\u2642\uFE0F":"1f9d7-1f3fd-2642","\uD83E\uDDD7\uD83C\uDFFE\u200D\u2640\uFE0F":"1f9d7-1f3fe-2640","\uD83E\uDDD7\uD83C\uDFFE\u200D\u2642\uFE0F":"1f9d7-1f3fe-2642","\uD83E\uDDD7\uD83C\uDFFF\u200D\u2640\uFE0F":"1f9d7-1f3ff-2640","\uD83E\uDDD7\uD83C\uDFFF\u200D\u2642\uFE0F":"1f9d7-1f3ff-2642","\uD83E\uDDD8\uD83C\uDFFB\u200D\u2640\uFE0F":"1f9d8-1f3fb-2640","\uD83E\uDDD8\uD83C\uDFFB\u200D\u2642\uFE0F":"1f9d8-1f3fb-2642","\uD83E\uDDD8\uD83C\uDFFC\u200D\u2640\uFE0F":"1f9d8-1f3fc-2640","\uD83E\uDDD8\uD83C\uDFFC\u200D\u2642\uFE0F":"1f9d8-1f3fc-2642","\uD83E\uDDD8\uD83C\uDFFD\u200D\u2640\uFE0F":"1f9d8-1f3fd-2640","\uD83E\uDDD8\uD83C\uDFFD\u200D\u2642\uFE0F":"1f9d8-1f3fd-2642","\uD83E\uDDD8\uD83C\uDFFE\u200D\u2640\uFE0F":"1f9d8-1f3fe-2640","\uD83E\uDDD8\uD83C\uDFFE\u200D\u2642\uFE0F":"1f9d8-1f3fe-2642","\uD83E\uDDD8\uD83C\uDFFF\u200D\u2640\uFE0F":"1f9d8-1f3ff-2640","\uD83E\uDDD8\uD83C\uDFFF\u200D\u2642\uFE0F":"1f9d8-1f3ff-2642","\uD83E\uDDB8\uD83C\uDFFB\u200D\u2640\uFE0F":"1f9b8-1f3fb-2640","\uD83E\uDDB8\uD83C\uDFFB\u200D\u2642\uFE0F":"1f9b8-1f3fb-2642","\uD83E\uDDB8\uD83C\uDFFC\u200D\u2640\uFE0F":"1f9b8-1f3fc-2640","\uD83E\uDDB8\uD83C\uDFFC\u200D\u2642\uFE0F":"1f9b8-1f3fc-2642","\uD83E\uDDB8\uD83C\uDFFD\u200D\u2640\uFE0F":"1f9b8-1f3fd-2640","\uD83E\uDDB8\uD83C\uDFFD\u200D\u2642\uFE0F":"1f9b8-1f3fd-2642","\uD83E\uDDB8\uD83C\uDFFE\u200D\u2640\uFE0F":"1f9b8-1f3fe-2640","\uD83E\uDDB8\uD83C\uDFFE\u200D\u2642\uFE0F":"1f9b8-1f3fe-2642","\uD83E\uDDB8\uD83C\uDFFF\u200D\u2640\uFE0F":"1f9b8-1f3ff-2640","\uD83E\uDDB8\uD83C\uDFFF\u200D\u2642\uFE0F":"1f9b8-1f3ff-2642","\uD83E\uDDB9\uD83C\uDFFB\u200D\u2640\uFE0F":"1f9b9-1f3fb-2640","\uD83E\uDDB9\uD83C\uDFFB\u200D\u2642\uFE0F":"1f9b9-1f3fb-2642","\uD83E\uDDB9\uD83C\uDFFC\u200D\u2640\uFE0F":"1f9b9-1f3fc-2640","\uD83E\uDDB9\uD83C\uDFFC\u200D\u2642\uFE0F":"1f9b9-1f3fc-2642","\uD83E\uDDB9\uD83C\uDFFD\u200D\u2640\uFE0F":"1f9b9-1f3fd-2640","\uD83E\uDDB9\uD83C\uDFFD\u200D\u2642\uFE0F":"1f9b9-1f3fd-2642","\uD83E\uDDB9\uD83C\uDFFE\u200D\u2640\uFE0F":"1f9b9-1f3fe-2640","\uD83E\uDDB9\uD83C\uDFFE\u200D\u2642\uFE0F":"1f9b9-1f3fe-2642","\uD83E\uDDB9\uD83C\uDFFF\u200D\u2640\uFE0F":"1f9b9-1f3ff-2640","\uD83E\uDDB9\uD83C\uDFFF\u200D\u2642\uFE0F":"1f9b9-1f3ff-2642","\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F":"1f575-2640","\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F":"1f575-2642","\u26F9\uFE0F\uD83C\uDFFB\u2640\uFE0F":"26f9-1f3fb-2640","\u26F9\uFE0F\uD83C\uDFFB\u2642\uFE0F":"26f9-1f3fb-2642","\u26F9\uFE0F\uD83C\uDFFC\u2640\uFE0F":"26f9-1f3fc-2640","\u26F9\uFE0F\uD83C\uDFFC\u2642\uFE0F":"26f9-1f3fc-2642","\u26F9\uFE0F\uD83C\uDFFD\u2640\uFE0F":"26f9-1f3fd-2640","\u26F9\uFE0F\uD83C\uDFFD\u2642\uFE0F":"26f9-1f3fd-2642","\u26F9\uFE0F\uD83C\uDFFE\u2640\uFE0F":"26f9-1f3fe-2640","\u26F9\uFE0F\uD83C\uDFFE\u2642\uFE0F":"26f9-1f3fe-2642","\u26F9\uFE0F\uD83C\uDFFF\u2640\uFE0F":"26f9-1f3ff-2640","\u26F9\uFE0F\uD83C\uDFFF\u2642\uFE0F":"26f9-1f3ff-2642","\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F":"1f3cb-2640","\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F":"1f3cb-2642","\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F":"1f3cc-2640","\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F":"1f3cc-2642","\u26F9\uD83C\uDFFB\u200D\u2640\uFE0F":"26f9-1f3fb-2640","\u26F9\uD83C\uDFFB\u200D\u2642\uFE0F":"26f9-1f3fb-2642","\u26F9\uD83C\uDFFC\u200D\u2640\uFE0F":"26f9-1f3fc-2640","\u26F9\uD83C\uDFFC\u200D\u2642\uFE0F":"26f9-1f3fc-2642","\u26F9\uD83C\uDFFD\u200D\u2640\uFE0F":"26f9-1f3fd-2640","\u26F9\uD83C\uDFFD\u200D\u2642\uFE0F":"26f9-1f3fd-2642","\u26F9\uD83C\uDFFE\u200D\u2640\uFE0F":"26f9-1f3fe-2640","\u26F9\uD83C\uDFFE\u200D\u2642\uFE0F":"26f9-1f3fe-2642","\u26F9\uD83C\uDFFF\u200D\u2640\uFE0F":"26f9-1f3ff-2640","\u26F9\uD83C\uDFFF\u200D\u2642\uFE0F":"26f9-1f3ff-2642","\u26F9\uFE0F\u200D\u2640\uFE0F":"26f9-2640","\u26F9\uFE0F\u200D\u2642\uFE0F":"26f9-2642","\uD83D\uDC68\uD83D\uDC68\uD83D\uDC66\uD83D\uDC66":"1f468-1f468-1f466-1f466","\uD83D\uDC68\uD83D\uDC68\uD83D\uDC67\uD83D\uDC66":"1f468-1f468-1f467-1f466","\uD83D\uDC68\uD83D\uDC68\uD83D\uDC67\uD83D\uDC67":"1f468-1f468-1f467-1f467","\uD83D\uDC68\uD83D\uDC69\uD83D\uDC66\uD83D\uDC66":"1f468-1f469-1f466-1f466","\uD83D\uDC68\uD83D\uDC69\uD83D\uDC67\uD83D\uDC66":"1f468-1f469-1f467-1f466","\uD83D\uDC68\uD83D\uDC69\uD83D\uDC67\uD83D\uDC67":"1f468-1f469-1f467-1f467","\uD83D\uDC69\uD83D\uDC69\uD83D\uDC66\uD83D\uDC66":"1f469-1f469-1f466-1f466","\uD83D\uDC69\uD83D\uDC69\uD83D\uDC67\uD83D\uDC66":"1f469-1f469-1f467-1f466","\uD83D\uDC69\uD83D\uDC69\uD83D\uDC67\uD83D\uDC67":"1f469-1f469-1f467-1f467","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBB":"1f468-1f3ff-1f4bb","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBB":"1f468-1f3fe-1f4bb","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBB":"1f468-1f3fd-1f4bb","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBB":"1f468-1f3fc-1f4bb","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBB":"1f468-1f3fb-1f4bb","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBB":"1f469-1f3ff-1f4bb","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBB":"1f469-1f3fe-1f4bb","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBB":"1f469-1f3fd-1f4bb","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBB":"1f469-1f3fc-1f4bb","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBB":"1f469-1f3fb-1f4bb","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFEB":"1f468-1f3ff-1f3eb","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFEB":"1f468-1f3fe-1f3eb","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFEB":"1f468-1f3fd-1f3eb","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFEB":"1f468-1f3fc-1f3eb","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFEB":"1f468-1f3fb-1f3eb","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFEB":"1f469-1f3ff-1f3eb","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFEB":"1f469-1f3fe-1f3eb","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFEB":"1f469-1f3fd-1f3eb","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFEB":"1f469-1f3fc-1f3eb","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFEB":"1f469-1f3fb-1f3eb","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF93":"1f468-1f3ff-1f393","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF93":"1f468-1f3fe-1f393","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF93":"1f468-1f3fd-1f393","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF93":"1f468-1f3fc-1f393","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF93":"1f468-1f3fb-1f393","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF93":"1f469-1f3ff-1f393","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF93":"1f469-1f3fe-1f393","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF93":"1f469-1f3fd-1f393","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF93":"1f469-1f3fc-1f393","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF93":"1f469-1f3fb-1f393","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA4":"1f468-1f3ff-1f3a4","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA4":"1f468-1f3fe-1f3a4","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA4":"1f468-1f3fd-1f3a4","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA4":"1f468-1f3fc-1f3a4","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA4":"1f468-1f3fb-1f3a4","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA4":"1f469-1f3ff-1f3a4","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA4":"1f469-1f3fe-1f3a4","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA4":"1f469-1f3fd-1f3a4","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA4":"1f469-1f3fc-1f3a4","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA4":"1f469-1f3fb-1f3a4","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD2C":"1f468-1f3ff-1f52c","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD2C":"1f468-1f3fe-1f52c","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD2C":"1f468-1f3fd-1f52c","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD2C":"1f468-1f3fc-1f52c","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD2C":"1f468-1f3fb-1f52c","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD2C":"1f469-1f3ff-1f52c","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD2C":"1f469-1f3fe-1f52c","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD2C":"1f469-1f3fd-1f52c","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD2C":"1f469-1f3fc-1f52c","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD2C":"1f469-1f3fb-1f52c","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBC":"1f468-1f3ff-1f4bc","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBC":"1f468-1f3fe-1f4bc","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBC":"1f468-1f3fd-1f4bc","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBC":"1f468-1f3fc-1f4bc","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBC":"1f468-1f3fb-1f4bc","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBC":"1f469-1f3ff-1f4bc","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBC":"1f469-1f3fe-1f4bc","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBC":"1f469-1f3fd-1f4bc","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBC":"1f469-1f3fc-1f4bc","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBC":"1f469-1f3fb-1f4bc","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD27":"1f468-1f3ff-1f527","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD27":"1f468-1f3fe-1f527","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD27":"1f468-1f3fd-1f527","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD27":"1f468-1f3fc-1f527","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD27":"1f468-1f3fb-1f527","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD27":"1f469-1f3ff-1f527","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD27":"1f469-1f3fe-1f527","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD27":"1f469-1f3fd-1f527","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD27":"1f469-1f3fc-1f527","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD27":"1f469-1f3fb-1f527","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFED":"1f468-1f3ff-1f3ed","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFED":"1f468-1f3fe-1f3ed","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFED":"1f468-1f3fd-1f3ed","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFED":"1f468-1f3fc-1f3ed","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFED":"1f468-1f3fb-1f3ed","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFED":"1f469-1f3ff-1f3ed","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFED":"1f469-1f3fe-1f3ed","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFED":"1f469-1f3fd-1f3ed","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFED":"1f469-1f3fc-1f3ed","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFED":"1f469-1f3fb-1f3ed","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF73":"1f468-1f3ff-1f373","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF73":"1f468-1f3fe-1f373","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF73":"1f468-1f3fd-1f373","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF73":"1f468-1f3fc-1f373","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF73":"1f468-1f3fb-1f373","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF73":"1f469-1f3ff-1f373","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF73":"1f469-1f3fe-1f373","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF73":"1f469-1f3fd-1f373","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF73":"1f469-1f3fc-1f373","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF73":"1f469-1f3fb-1f373","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF3E":"1f468-1f3ff-1f33e","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF3E":"1f468-1f3fe-1f33e","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF3E":"1f468-1f3fd-1f33e","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF3E":"1f468-1f3fc-1f33e","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF3E":"1f468-1f3fb-1f33e","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF3E":"1f469-1f3ff-1f33e","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF3E":"1f469-1f3fe-1f33e","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF3E":"1f469-1f3fd-1f33e","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF3E":"1f469-1f3fc-1f33e","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF3E":"1f469-1f3fb-1f33e","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA8":"1f468-1f3fb-1f3a8","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA8":"1f468-1f3fc-1f3a8","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA8":"1f468-1f3fd-1f3a8","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA8":"1f468-1f3fe-1f3a8","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA8":"1f468-1f3ff-1f3a8","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA8":"1f469-1f3fb-1f3a8","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA8":"1f469-1f3fc-1f3a8","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA8":"1f469-1f3fd-1f3a8","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA8":"1f469-1f3fe-1f3a8","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA8":"1f469-1f3ff-1f3a8","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE80":"1f468-1f3fb-1f680","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE80":"1f468-1f3fc-1f680","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE80":"1f468-1f3fd-1f680","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE80":"1f468-1f3fe-1f680","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE80":"1f468-1f3ff-1f680","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE80":"1f469-1f3fb-1f680","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE80":"1f469-1f3fc-1f680","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE80":"1f469-1f3fd-1f680","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE80":"1f469-1f3fe-1f680","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE80":"1f469-1f3ff-1f680","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE92":"1f468-1f3fb-1f692","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE92":"1f468-1f3fc-1f692","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE92":"1f468-1f3fd-1f692","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE92":"1f468-1f3fe-1f692","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE92":"1f468-1f3ff-1f692","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE92":"1f469-1f3fb-1f692","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE92":"1f469-1f3fc-1f692","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE92":"1f469-1f3fd-1f692","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE92":"1f469-1f3fe-1f692","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE92":"1f469-1f3ff-1f692","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB0":"1f468-1f3fb-1f9b0","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB1":"1f468-1f3fb-1f9b1","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB2":"1f468-1f3fb-1f9b2","\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB3":"1f468-1f3fb-1f9b3","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB0":"1f468-1f3fc-1f9b0","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB1":"1f468-1f3fc-1f9b1","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB2":"1f468-1f3fc-1f9b2","\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB3":"1f468-1f3fc-1f9b3","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB0":"1f468-1f3fd-1f9b0","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB1":"1f468-1f3fd-1f9b1","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB2":"1f468-1f3fd-1f9b2","\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB3":"1f468-1f3fd-1f9b3","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB0":"1f468-1f3fe-1f9b0","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB1":"1f468-1f3fe-1f9b1","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB2":"1f468-1f3fe-1f9b2","\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB3":"1f468-1f3fe-1f9b3","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB0":"1f468-1f3ff-1f9b0","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB1":"1f468-1f3ff-1f9b1","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB2":"1f468-1f3ff-1f9b2","\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB3":"1f468-1f3ff-1f9b3","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB0":"1f469-1f3fb-1f9b0","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB1":"1f469-1f3fb-1f9b1","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB2":"1f469-1f3fb-1f9b2","\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB3":"1f469-1f3fb-1f9b3","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB0":"1f469-1f3fc-1f9b0","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB1":"1f469-1f3fc-1f9b1","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB2":"1f469-1f3fc-1f9b2","\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB3":"1f469-1f3fc-1f9b3","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB0":"1f469-1f3fd-1f9b0","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB1":"1f469-1f3fd-1f9b1","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB2":"1f469-1f3fd-1f9b2","\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB3":"1f469-1f3fd-1f9b3","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB0":"1f469-1f3fe-1f9b0","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB1":"1f469-1f3fe-1f9b1","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB2":"1f469-1f3fe-1f9b2","\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB3":"1f469-1f3fe-1f9b3","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB0":"1f469-1f3ff-1f9b0","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB1":"1f469-1f3ff-1f9b1","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB2":"1f469-1f3ff-1f9b2","\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB3":"1f469-1f3ff-1f9b3","\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08":"1f3f3-1f308","\uD83C\uDFCC\uD83C\uDFFB\u200D\u2642":"1f3cc-1f3fb-2642","\uD83C\uDFCC\uD83C\uDFFC\u200D\u2642":"1f3cc-1f3fc-2642","\uD83C\uDFCC\uD83C\uDFFD\u200D\u2642":"1f3cc-1f3fd-2642","\uD83C\uDFCC\uD83C\uDFFE\u200D\u2642":"1f3cc-1f3fe-2642","\uD83C\uDFCC\uD83C\uDFFF\u200D\u2642":"1f3cc-1f3ff-2642","\uD83C\uDFCC\uD83C\uDFFB\u200D\u2640":"1f3cc-1f3fb-2640","\uD83C\uDFCC\uD83C\uDFFC\u200D\u2640":"1f3cc-1f3fc-2640","\uD83C\uDFCC\uD83C\uDFFD\u200D\u2640":"1f3cc-1f3fd-2640","\uD83C\uDFCC\uD83C\uDFFE\u200D\u2640":"1f3cc-1f3fe-2640","\uD83C\uDFCC\uD83C\uDFFF\u200D\u2640":"1f3cc-1f3ff-2640","\uD83E\uDD39\uD83C\uDFFF\u200D\u2642":"1f939-1f3ff-2642","\uD83E\uDD39\uD83C\uDFFE\u200D\u2642":"1f939-1f3fe-2642","\uD83E\uDD39\uD83C\uDFFD\u200D\u2642":"1f939-1f3fd-2642","\uD83E\uDD39\uD83C\uDFFC\u200D\u2642":"1f939-1f3fc-2642","\uD83E\uDD39\uD83C\uDFFB\u200D\u2642":"1f939-1f3fb-2642","\uD83E\uDD39\uD83C\uDFFF\u200D\u2640":"1f939-1f3ff-2640","\uD83E\uDD39\uD83C\uDFFE\u200D\u2640":"1f939-1f3fe-2640","\uD83E\uDD39\uD83C\uDFFD\u200D\u2640":"1f939-1f3fd-2640","\uD83E\uDD39\uD83C\uDFFC\u200D\u2640":"1f939-1f3fc-2640","\uD83E\uDD39\uD83C\uDFFB\u200D\u2640":"1f939-1f3fb-2640","\uD83E\uDD3E\uD83C\uDFFF\u200D\u2642":"1f93e-1f3ff-2642","\uD83E\uDD3E\uD83C\uDFFE\u200D\u2642":"1f93e-1f3fe-2642","\uD83E\uDD3E\uD83C\uDFFD\u200D\u2642":"1f93e-1f3fd-2642","\uD83E\uDD3E\uD83C\uDFFC\u200D\u2642":"1f93e-1f3fc-2642","\uD83E\uDD3E\uD83C\uDFFB\u200D\u2642":"1f93e-1f3fb-2642","\uD83E\uDD3E\uD83C\uDFFF\u200D\u2640":"1f93e-1f3ff-2640","\uD83E\uDD3E\uD83C\uDFFE\u200D\u2640":"1f93e-1f3fe-2640","\uD83E\uDD3E\uD83C\uDFFD\u200D\u2640":"1f93e-1f3fd-2640","\uD83E\uDD3E\uD83C\uDFFC\u200D\u2640":"1f93e-1f3fc-2640","\uD83E\uDD3E\uD83C\uDFFB\u200D\u2640":"1f93e-1f3fb-2640","\uD83E\uDD3D\uD83C\uDFFF\u200D\u2642":"1f93d-1f3ff-2642","\uD83E\uDD3D\uD83C\uDFFE\u200D\u2642":"1f93d-1f3fe-2642","\uD83E\uDD3D\uD83C\uDFFD\u200D\u2642":"1f93d-1f3fd-2642","\uD83E\uDD3D\uD83C\uDFFC\u200D\u2642":"1f93d-1f3fc-2642","\uD83E\uDD3D\uD83C\uDFFB\u200D\u2642":"1f93d-1f3fb-2642","\uD83E\uDD3D\uD83C\uDFFF\u200D\u2640":"1f93d-1f3ff-2640","\uD83E\uDD3D\uD83C\uDFFE\u200D\u2640":"1f93d-1f3fe-2640","\uD83E\uDD3D\uD83C\uDFFD\u200D\u2640":"1f93d-1f3fd-2640","\uD83E\uDD3D\uD83C\uDFFC\u200D\u2640":"1f93d-1f3fc-2640","\uD83E\uDD3D\uD83C\uDFFB\u200D\u2640":"1f93d-1f3fb-2640","\uD83E\uDD38\uD83C\uDFFF\u200D\u2642":"1f938-1f3ff-2642","\uD83E\uDD38\uD83C\uDFFE\u200D\u2642":"1f938-1f3fe-2642","\uD83E\uDD38\uD83C\uDFFD\u200D\u2642":"1f938-1f3fd-2642","\uD83E\uDD38\uD83C\uDFFC\u200D\u2642":"1f938-1f3fc-2642","\uD83E\uDD38\uD83C\uDFFB\u200D\u2642":"1f938-1f3fb-2642","\uD83E\uDD38\uD83C\uDFFF\u200D\u2640":"1f938-1f3ff-2640","\uD83E\uDD38\uD83C\uDFFE\u200D\u2640":"1f938-1f3fe-2640","\uD83E\uDD38\uD83C\uDFFD\u200D\u2640":"1f938-1f3fd-2640","\uD83E\uDD38\uD83C\uDFFC\u200D\u2640":"1f938-1f3fc-2640","\uD83E\uDD38\uD83C\uDFFB\u200D\u2640":"1f938-1f3fb-2640","\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642":"1f6b6-1f3ff-2642","\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642":"1f6b6-1f3fe-2642","\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642":"1f6b6-1f3fd-2642","\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642":"1f6b6-1f3fc-2642","\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642":"1f6b6-1f3fb-2642","\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640":"1f6b6-1f3ff-2640","\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640":"1f6b6-1f3fe-2640","\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640":"1f6b6-1f3fd-2640","\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640":"1f6b6-1f3fc-2640","\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640":"1f6b6-1f3fb-2640","\uD83D\uDEB5\uD83C\uDFFF\u200D\u2642":"1f6b5-1f3ff-2642","\uD83D\uDEB5\uD83C\uDFFE\u200D\u2642":"1f6b5-1f3fe-2642","\uD83D\uDEB5\uD83C\uDFFD\u200D\u2642":"1f6b5-1f3fd-2642","\uD83D\uDEB5\uD83C\uDFFC\u200D\u2642":"1f6b5-1f3fc-2642","\uD83D\uDEB5\uD83C\uDFFB\u200D\u2642":"1f6b5-1f3fb-2642","\uD83D\uDEB5\uD83C\uDFFF\u200D\u2640":"1f6b5-1f3ff-2640","\uD83D\uDEB5\uD83C\uDFFE\u200D\u2640":"1f6b5-1f3fe-2640","\uD83D\uDEB5\uD83C\uDFFD\u200D\u2640":"1f6b5-1f3fd-2640","\uD83D\uDEB5\uD83C\uDFFC\u200D\u2640":"1f6b5-1f3fc-2640","\uD83D\uDEB5\uD83C\uDFFB\u200D\u2640":"1f6b5-1f3fb-2640","\uD83D\uDEB4\uD83C\uDFFF\u200D\u2642":"1f6b4-1f3ff-2642","\uD83D\uDEB4\uD83C\uDFFE\u200D\u2642":"1f6b4-1f3fe-2642","\uD83D\uDEB4\uD83C\uDFFD\u200D\u2642":"1f6b4-1f3fd-2642","\uD83D\uDEB4\uD83C\uDFFC\u200D\u2642":"1f6b4-1f3fc-2642","\uD83D\uDEB4\uD83C\uDFFB\u200D\u2642":"1f6b4-1f3fb-2642","\uD83D\uDEB4\uD83C\uDFFF\u200D\u2640":"1f6b4-1f3ff-2640","\uD83D\uDEB4\uD83C\uDFFE\u200D\u2640":"1f6b4-1f3fe-2640","\uD83D\uDEB4\uD83C\uDFFD\u200D\u2640":"1f6b4-1f3fd-2640","\uD83D\uDEB4\uD83C\uDFFC\u200D\u2640":"1f6b4-1f3fc-2640","\uD83D\uDEB4\uD83C\uDFFB\u200D\u2640":"1f6b4-1f3fb-2640","\uD83D\uDEA3\uD83C\uDFFF\u200D\u2642":"1f6a3-1f3ff-2642","\uD83D\uDEA3\uD83C\uDFFE\u200D\u2642":"1f6a3-1f3fe-2642","\uD83D\uDEA3\uD83C\uDFFD\u200D\u2642":"1f6a3-1f3fd-2642","\uD83D\uDEA3\uD83C\uDFFC\u200D\u2642":"1f6a3-1f3fc-2642","\uD83D\uDEA3\uD83C\uDFFB\u200D\u2642":"1f6a3-1f3fb-2642","\uD83D\uDEA3\uD83C\uDFFF\u200D\u2640":"1f6a3-1f3ff-2640","\uD83D\uDEA3\uD83C\uDFFE\u200D\u2640":"1f6a3-1f3fe-2640","\uD83D\uDEA3\uD83C\uDFFD\u200D\u2640":"1f6a3-1f3fd-2640","\uD83D\uDEA3\uD83C\uDFFC\u200D\u2640":"1f6a3-1f3fc-2640","\uD83D\uDEA3\uD83C\uDFFB\u200D\u2640":"1f6a3-1f3fb-2640","\uD83C\uDFCB\uD83C\uDFFF\u200D\u2642":"1f3cb-1f3ff-2642","\uD83C\uDFCB\uD83C\uDFFE\u200D\u2642":"1f3cb-1f3fe-2642","\uD83C\uDFCB\uD83C\uDFFD\u200D\u2642":"1f3cb-1f3fd-2642","\uD83C\uDFCB\uD83C\uDFFC\u200D\u2642":"1f3cb-1f3fc-2642","\uD83C\uDFCB\uD83C\uDFFB\u200D\u2642":"1f3cb-1f3fb-2642","\uD83C\uDFCB\uD83C\uDFFF\u200D\u2640":"1f3cb-1f3ff-2640","\uD83C\uDFCB\uD83C\uDFFE\u200D\u2640":"1f3cb-1f3fe-2640","\uD83C\uDFCB\uD83C\uDFFD\u200D\u2640":"1f3cb-1f3fd-2640","\uD83C\uDFCB\uD83C\uDFFC\u200D\u2640":"1f3cb-1f3fc-2640","\uD83C\uDFCB\uD83C\uDFFB\u200D\u2640":"1f3cb-1f3fb-2640","\uD83C\uDFCA\uD83C\uDFFF\u200D\u2642":"1f3ca-1f3ff-2642","\uD83C\uDFCA\uD83C\uDFFE\u200D\u2642":"1f3ca-1f3fe-2642","\uD83C\uDFCA\uD83C\uDFFD\u200D\u2642":"1f3ca-1f3fd-2642","\uD83C\uDFCA\uD83C\uDFFC\u200D\u2642":"1f3ca-1f3fc-2642","\uD83C\uDFCA\uD83C\uDFFB\u200D\u2642":"1f3ca-1f3fb-2642","\uD83C\uDFCA\uD83C\uDFFF\u200D\u2640":"1f3ca-1f3ff-2640","\uD83C\uDFCA\uD83C\uDFFE\u200D\u2640":"1f3ca-1f3fe-2640","\uD83C\uDFCA\uD83C\uDFFD\u200D\u2640":"1f3ca-1f3fd-2640","\uD83C\uDFCA\uD83C\uDFFC\u200D\u2640":"1f3ca-1f3fc-2640","\uD83C\uDFCA\uD83C\uDFFB\u200D\u2640":"1f3ca-1f3fb-2640","\uD83C\uDFC4\uD83C\uDFFF\u200D\u2642":"1f3c4-1f3ff-2642","\uD83C\uDFC4\uD83C\uDFFE\u200D\u2642":"1f3c4-1f3fe-2642","\uD83C\uDFC4\uD83C\uDFFD\u200D\u2642":"1f3c4-1f3fd-2642","\uD83C\uDFC4\uD83C\uDFFC\u200D\u2642":"1f3c4-1f3fc-2642","\uD83C\uDFC4\uD83C\uDFFB\u200D\u2642":"1f3c4-1f3fb-2642","\uD83C\uDFC4\uD83C\uDFFF\u200D\u2640":"1f3c4-1f3ff-2640","\uD83C\uDFC4\uD83C\uDFFE\u200D\u2640":"1f3c4-1f3fe-2640","\uD83C\uDFC4\uD83C\uDFFD\u200D\u2640":"1f3c4-1f3fd-2640","\uD83C\uDFC4\uD83C\uDFFC\u200D\u2640":"1f3c4-1f3fc-2640","\uD83C\uDFC4\uD83C\uDFFB\u200D\u2640":"1f3c4-1f3fb-2640","\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642":"1f3c3-1f3ff-2642","\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642":"1f3c3-1f3fe-2642","\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642":"1f3c3-1f3fd-2642","\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642":"1f3c3-1f3fc-2642","\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642":"1f3c3-1f3fb-2642","\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640":"1f3c3-1f3ff-2640","\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640":"1f3c3-1f3fe-2640","\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640":"1f3c3-1f3fd-2640","\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640":"1f3c3-1f3fc-2640","\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640":"1f3c3-1f3fb-2640","\uD83E\uDD37\uD83C\uDFFF\u200D\u2642":"1f937-1f3ff-2642","\uD83E\uDD37\uD83C\uDFFE\u200D\u2642":"1f937-1f3fe-2642","\uD83E\uDD37\uD83C\uDFFD\u200D\u2642":"1f937-1f3fd-2642","\uD83E\uDD37\uD83C\uDFFC\u200D\u2642":"1f937-1f3fc-2642","\uD83E\uDD37\uD83C\uDFFB\u200D\u2642":"1f937-1f3fb-2642","\uD83E\uDD37\uD83C\uDFFF\u200D\u2640":"1f937-1f3ff-2640","\uD83E\uDD37\uD83C\uDFFE\u200D\u2640":"1f937-1f3fe-2640","\uD83E\uDD37\uD83C\uDFFD\u200D\u2640":"1f937-1f3fd-2640","\uD83E\uDD37\uD83C\uDFFC\u200D\u2640":"1f937-1f3fc-2640","\uD83E\uDD37\uD83C\uDFFB\u200D\u2640":"1f937-1f3fb-2640","\uD83E\uDD26\uD83C\uDFFF\u200D\u2642":"1f926-1f3ff-2642","\uD83E\uDD26\uD83C\uDFFE\u200D\u2642":"1f926-1f3fe-2642","\uD83E\uDD26\uD83C\uDFFD\u200D\u2642":"1f926-1f3fd-2642","\uD83E\uDD26\uD83C\uDFFC\u200D\u2642":"1f926-1f3fc-2642","\uD83E\uDD26\uD83C\uDFFB\u200D\u2642":"1f926-1f3fb-2642","\uD83E\uDD26\uD83C\uDFFF\u200D\u2640":"1f926-1f3ff-2640","\uD83E\uDD26\uD83C\uDFFE\u200D\u2640":"1f926-1f3fe-2640","\uD83E\uDD26\uD83C\uDFFD\u200D\u2640":"1f926-1f3fd-2640","\uD83E\uDD26\uD83C\uDFFC\u200D\u2640":"1f926-1f3fc-2640","\uD83E\uDD26\uD83C\uDFFB\u200D\u2640":"1f926-1f3fb-2640","\uD83D\uDE4E\uD83C\uDFFF\u200D\u2642":"1f64e-1f3ff-2642","\uD83D\uDE4E\uD83C\uDFFE\u200D\u2642":"1f64e-1f3fe-2642","\uD83D\uDE4E\uD83C\uDFFD\u200D\u2642":"1f64e-1f3fd-2642","\uD83D\uDE4E\uD83C\uDFFC\u200D\u2642":"1f64e-1f3fc-2642","\uD83D\uDE4E\uD83C\uDFFB\u200D\u2642":"1f64e-1f3fb-2642","\uD83D\uDE4E\uD83C\uDFFF\u200D\u2640":"1f64e-1f3ff-2640","\uD83D\uDE4E\uD83C\uDFFE\u200D\u2640":"1f64e-1f3fe-2640","\uD83D\uDE4E\uD83C\uDFFD\u200D\u2640":"1f64e-1f3fd-2640","\uD83D\uDE4E\uD83C\uDFFC\u200D\u2640":"1f64e-1f3fc-2640","\uD83D\uDE4E\uD83C\uDFFB\u200D\u2640":"1f64e-1f3fb-2640","\uD83D\uDE4D\uD83C\uDFFF\u200D\u2642":"1f64d-1f3ff-2642","\uD83D\uDE4D\uD83C\uDFFE\u200D\u2642":"1f64d-1f3fe-2642","\uD83D\uDE4D\uD83C\uDFFD\u200D\u2642":"1f64d-1f3fd-2642","\uD83D\uDE4D\uD83C\uDFFC\u200D\u2642":"1f64d-1f3fc-2642","\uD83D\uDE4D\uD83C\uDFFB\u200D\u2642":"1f64d-1f3fb-2642","\uD83D\uDE4D\uD83C\uDFFF\u200D\u2640":"1f64d-1f3ff-2640","\uD83D\uDE4D\uD83C\uDFFE\u200D\u2640":"1f64d-1f3fe-2640","\uD83D\uDE4D\uD83C\uDFFD\u200D\u2640":"1f64d-1f3fd-2640","\uD83D\uDE4D\uD83C\uDFFC\u200D\u2640":"1f64d-1f3fc-2640","\uD83D\uDE4D\uD83C\uDFFB\u200D\u2640":"1f64d-1f3fb-2640","\uD83D\uDE4B\uD83C\uDFFF\u200D\u2642":"1f64b-1f3ff-2642","\uD83D\uDE4B\uD83C\uDFFE\u200D\u2642":"1f64b-1f3fe-2642","\uD83D\uDE4B\uD83C\uDFFD\u200D\u2642":"1f64b-1f3fd-2642","\uD83D\uDE4B\uD83C\uDFFC\u200D\u2642":"1f64b-1f3fc-2642","\uD83D\uDE4B\uD83C\uDFFB\u200D\u2642":"1f64b-1f3fb-2642","\uD83D\uDE4B\uD83C\uDFFF\u200D\u2640":"1f64b-1f3ff-2640","\uD83D\uDE4B\uD83C\uDFFE\u200D\u2640":"1f64b-1f3fe-2640","\uD83D\uDE4B\uD83C\uDFFD\u200D\u2640":"1f64b-1f3fd-2640","\uD83D\uDE4B\uD83C\uDFFC\u200D\u2640":"1f64b-1f3fc-2640","\uD83D\uDE4B\uD83C\uDFFB\u200D\u2640":"1f64b-1f3fb-2640","\uD83D\uDE47\uD83C\uDFFF\u200D\u2642":"1f647-1f3ff-2642","\uD83D\uDE47\uD83C\uDFFE\u200D\u2642":"1f647-1f3fe-2642","\uD83D\uDE47\uD83C\uDFFD\u200D\u2642":"1f647-1f3fd-2642","\uD83D\uDE47\uD83C\uDFFC\u200D\u2642":"1f647-1f3fc-2642","\uD83D\uDE47\uD83C\uDFFB\u200D\u2642":"1f647-1f3fb-2642","\uD83D\uDE47\uD83C\uDFFF\u200D\u2640":"1f647-1f3ff-2640","\uD83D\uDE47\uD83C\uDFFE\u200D\u2640":"1f647-1f3fe-2640","\uD83D\uDE47\uD83C\uDFFD\u200D\u2640":"1f647-1f3fd-2640","\uD83D\uDE47\uD83C\uDFFC\u200D\u2640":"1f647-1f3fc-2640","\uD83D\uDE47\uD83C\uDFFB\u200D\u2640":"1f647-1f3fb-2640","\uD83D\uDE46\uD83C\uDFFF\u200D\u2642":"1f646-1f3ff-2642","\uD83D\uDE46\uD83C\uDFFE\u200D\u2642":"1f646-1f3fe-2642","\uD83D\uDE46\uD83C\uDFFD\u200D\u2642":"1f646-1f3fd-2642","\uD83D\uDE46\uD83C\uDFFC\u200D\u2642":"1f646-1f3fc-2642","\uD83D\uDE46\uD83C\uDFFB\u200D\u2642":"1f646-1f3fb-2642","\uD83D\uDE46\uD83C\uDFFF\u200D\u2640":"1f646-1f3ff-2640","\uD83D\uDE46\uD83C\uDFFE\u200D\u2640":"1f646-1f3fe-2640","\uD83D\uDE46\uD83C\uDFFD\u200D\u2640":"1f646-1f3fd-2640","\uD83D\uDE46\uD83C\uDFFC\u200D\u2640":"1f646-1f3fc-2640","\uD83D\uDE46\uD83C\uDFFB\u200D\u2640":"1f646-1f3fb-2640","\uD83D\uDE45\uD83C\uDFFF\u200D\u2642":"1f645-1f3ff-2642","\uD83D\uDE45\uD83C\uDFFE\u200D\u2642":"1f645-1f3fe-2642","\uD83D\uDE45\uD83C\uDFFD\u200D\u2642":"1f645-1f3fd-2642","\uD83D\uDE45\uD83C\uDFFC\u200D\u2642":"1f645-1f3fc-2642","\uD83D\uDE45\uD83C\uDFFB\u200D\u2642":"1f645-1f3fb-2642","\uD83D\uDE45\uD83C\uDFFF\u200D\u2640":"1f645-1f3ff-2640","\uD83D\uDE45\uD83C\uDFFE\u200D\u2640":"1f645-1f3fe-2640","\uD83D\uDE45\uD83C\uDFFD\u200D\u2640":"1f645-1f3fd-2640","\uD83D\uDE45\uD83C\uDFFC\u200D\u2640":"1f645-1f3fc-2640","\uD83D\uDE45\uD83C\uDFFB\u200D\u2640":"1f645-1f3fb-2640","\uD83D\uDC87\uD83C\uDFFF\u200D\u2642":"1f487-1f3ff-2642","\uD83D\uDC87\uD83C\uDFFE\u200D\u2642":"1f487-1f3fe-2642","\uD83D\uDC87\uD83C\uDFFD\u200D\u2642":"1f487-1f3fd-2642","\uD83D\uDC87\uD83C\uDFFC\u200D\u2642":"1f487-1f3fc-2642","\uD83D\uDC87\uD83C\uDFFB\u200D\u2642":"1f487-1f3fb-2642","\uD83D\uDC87\uD83C\uDFFF\u200D\u2640":"1f487-1f3ff-2640","\uD83D\uDC87\uD83C\uDFFE\u200D\u2640":"1f487-1f3fe-2640","\uD83D\uDC87\uD83C\uDFFD\u200D\u2640":"1f487-1f3fd-2640","\uD83D\uDC87\uD83C\uDFFC\u200D\u2640":"1f487-1f3fc-2640","\uD83D\uDC87\uD83C\uDFFB\u200D\u2640":"1f487-1f3fb-2640","\uD83D\uDC86\uD83C\uDFFF\u200D\u2642":"1f486-1f3ff-2642","\uD83D\uDC86\uD83C\uDFFE\u200D\u2642":"1f486-1f3fe-2642","\uD83D\uDC86\uD83C\uDFFD\u200D\u2642":"1f486-1f3fd-2642","\uD83D\uDC86\uD83C\uDFFC\u200D\u2642":"1f486-1f3fc-2642","\uD83D\uDC86\uD83C\uDFFB\u200D\u2642":"1f486-1f3fb-2642","\uD83D\uDC86\uD83C\uDFFF\u200D\u2640":"1f486-1f3ff-2640","\uD83D\uDC86\uD83C\uDFFE\u200D\u2640":"1f486-1f3fe-2640","\uD83D\uDC86\uD83C\uDFFD\u200D\u2640":"1f486-1f3fd-2640","\uD83D\uDC86\uD83C\uDFFC\u200D\u2640":"1f486-1f3fc-2640","\uD83D\uDC86\uD83C\uDFFB\u200D\u2640":"1f486-1f3fb-2640","\uD83D\uDC81\uD83C\uDFFF\u200D\u2642":"1f481-1f3ff-2642","\uD83D\uDC81\uD83C\uDFFE\u200D\u2642":"1f481-1f3fe-2642","\uD83D\uDC81\uD83C\uDFFD\u200D\u2642":"1f481-1f3fd-2642","\uD83D\uDC81\uD83C\uDFFC\u200D\u2642":"1f481-1f3fc-2642","\uD83D\uDC81\uD83C\uDFFB\u200D\u2642":"1f481-1f3fb-2642","\uD83D\uDC81\uD83C\uDFFF\u200D\u2640":"1f481-1f3ff-2640","\uD83D\uDC81\uD83C\uDFFE\u200D\u2640":"1f481-1f3fe-2640","\uD83D\uDC81\uD83C\uDFFD\u200D\u2640":"1f481-1f3fd-2640","\uD83D\uDC81\uD83C\uDFFC\u200D\u2640":"1f481-1f3fc-2640","\uD83D\uDC81\uD83C\uDFFB\u200D\u2640":"1f481-1f3fb-2640","\uD83D\uDC71\uD83C\uDFFF\u200D\u2642":"1f471-1f3ff-2642","\uD83D\uDC71\uD83C\uDFFE\u200D\u2642":"1f471-1f3fe-2642","\uD83D\uDC71\uD83C\uDFFD\u200D\u2642":"1f471-1f3fd-2642","\uD83D\uDC71\uD83C\uDFFC\u200D\u2642":"1f471-1f3fc-2642","\uD83D\uDC71\uD83C\uDFFB\u200D\u2642":"1f471-1f3fb-2642","\uD83D\uDC71\uD83C\uDFFF\u200D\u2640":"1f471-1f3ff-2640","\uD83D\uDC71\uD83C\uDFFE\u200D\u2640":"1f471-1f3fe-2640","\uD83D\uDC71\uD83C\uDFFD\u200D\u2640":"1f471-1f3fd-2640","\uD83D\uDC71\uD83C\uDFFC\u200D\u2640":"1f471-1f3fc-2640","\uD83D\uDC71\uD83C\uDFFB\u200D\u2640":"1f471-1f3fb-2640","\uD83D\uDC73\uD83C\uDFFF\u200D\u2642":"1f473-1f3ff-2642","\uD83D\uDC73\uD83C\uDFFE\u200D\u2642":"1f473-1f3fe-2642","\uD83D\uDC73\uD83C\uDFFD\u200D\u2642":"1f473-1f3fd-2642","\uD83D\uDC73\uD83C\uDFFC\u200D\u2642":"1f473-1f3fc-2642","\uD83D\uDC73\uD83C\uDFFB\u200D\u2642":"1f473-1f3fb-2642","\uD83D\uDC73\uD83C\uDFFF\u200D\u2640":"1f473-1f3ff-2640","\uD83D\uDC73\uD83C\uDFFE\u200D\u2640":"1f473-1f3fe-2640","\uD83D\uDC73\uD83C\uDFFD\u200D\u2640":"1f473-1f3fd-2640","\uD83D\uDC73\uD83C\uDFFC\u200D\u2640":"1f473-1f3fc-2640","\uD83D\uDC73\uD83C\uDFFB\u200D\u2640":"1f473-1f3fb-2640","\uD83D\uDC82\uD83C\uDFFF\u200D\u2642":"1f482-1f3ff-2642","\uD83D\uDC82\uD83C\uDFFE\u200D\u2642":"1f482-1f3fe-2642","\uD83D\uDC82\uD83C\uDFFD\u200D\u2642":"1f482-1f3fd-2642","\uD83D\uDC82\uD83C\uDFFC\u200D\u2642":"1f482-1f3fc-2642","\uD83D\uDC82\uD83C\uDFFB\u200D\u2642":"1f482-1f3fb-2642","\uD83D\uDC82\uD83C\uDFFF\u200D\u2640":"1f482-1f3ff-2640","\uD83D\uDC82\uD83C\uDFFE\u200D\u2640":"1f482-1f3fe-2640","\uD83D\uDC82\uD83C\uDFFD\u200D\u2640":"1f482-1f3fd-2640","\uD83D\uDC82\uD83C\uDFFC\u200D\u2640":"1f482-1f3fc-2640","\uD83D\uDC82\uD83C\uDFFB\u200D\u2640":"1f482-1f3fb-2640","\uD83D\uDD75\uD83C\uDFFF\u200D\u2642":"1f575-1f3ff-2642","\uD83D\uDD75\uD83C\uDFFE\u200D\u2642":"1f575-1f3fe-2642","\uD83D\uDD75\uD83C\uDFFD\u200D\u2642":"1f575-1f3fd-2642","\uD83D\uDD75\uD83C\uDFFC\u200D\u2642":"1f575-1f3fc-2642","\uD83D\uDD75\uD83C\uDFFB\u200D\u2642":"1f575-1f3fb-2642","\uD83D\uDD75\uD83C\uDFFF\u200D\u2640":"1f575-1f3ff-2640","\uD83D\uDD75\uD83C\uDFFE\u200D\u2640":"1f575-1f3fe-2640","\uD83D\uDD75\uD83C\uDFFD\u200D\u2640":"1f575-1f3fd-2640","\uD83D\uDD75\uD83C\uDFFC\u200D\u2640":"1f575-1f3fc-2640","\uD83D\uDD75\uD83C\uDFFB\u200D\u2640":"1f575-1f3fb-2640","\uD83D\uDC77\uD83C\uDFFF\u200D\u2642":"1f477-1f3ff-2642","\uD83D\uDC77\uD83C\uDFFE\u200D\u2642":"1f477-1f3fe-2642","\uD83D\uDC77\uD83C\uDFFD\u200D\u2642":"1f477-1f3fd-2642","\uD83D\uDC77\uD83C\uDFFC\u200D\u2642":"1f477-1f3fc-2642","\uD83D\uDC77\uD83C\uDFFB\u200D\u2642":"1f477-1f3fb-2642","\uD83D\uDC77\uD83C\uDFFF\u200D\u2640":"1f477-1f3ff-2640","\uD83D\uDC77\uD83C\uDFFE\u200D\u2640":"1f477-1f3fe-2640","\uD83D\uDC77\uD83C\uDFFD\u200D\u2640":"1f477-1f3fd-2640","\uD83D\uDC77\uD83C\uDFFC\u200D\u2640":"1f477-1f3fc-2640","\uD83D\uDC77\uD83C\uDFFB\u200D\u2640":"1f477-1f3fb-2640","\uD83D\uDC6E\uD83C\uDFFF\u200D\u2642":"1f46e-1f3ff-2642","\uD83D\uDC6E\uD83C\uDFFE\u200D\u2642":"1f46e-1f3fe-2642","\uD83D\uDC6E\uD83C\uDFFD\u200D\u2642":"1f46e-1f3fd-2642","\uD83D\uDC6E\uD83C\uDFFC\u200D\u2642":"1f46e-1f3fc-2642","\uD83D\uDC6E\uD83C\uDFFB\u200D\u2642":"1f46e-1f3fb-2642","\uD83D\uDC6E\uD83C\uDFFF\u200D\u2640":"1f46e-1f3ff-2640","\uD83D\uDC6E\uD83C\uDFFE\u200D\u2640":"1f46e-1f3fe-2640","\uD83D\uDC6E\uD83C\uDFFD\u200D\u2640":"1f46e-1f3fd-2640","\uD83D\uDC6E\uD83C\uDFFC\u200D\u2640":"1f46e-1f3fc-2640","\uD83D\uDC6E\uD83C\uDFFB\u200D\u2640":"1f46e-1f3fb-2640","\uD83D\uDC68\uD83C\uDFFF\u200D\u2695":"1f468-1f3ff-2695","\uD83D\uDC68\uD83C\uDFFE\u200D\u2695":"1f468-1f3fe-2695","\uD83D\uDC68\uD83C\uDFFD\u200D\u2695":"1f468-1f3fd-2695","\uD83D\uDC68\uD83C\uDFFC\u200D\u2695":"1f468-1f3fc-2695","\uD83D\uDC68\uD83C\uDFFB\u200D\u2695":"1f468-1f3fb-2695","\uD83D\uDC69\uD83C\uDFFF\u200D\u2695":"1f469-1f3ff-2695","\uD83D\uDC69\uD83C\uDFFE\u200D\u2695":"1f469-1f3fe-2695","\uD83D\uDC69\uD83C\uDFFD\u200D\u2695":"1f469-1f3fd-2695","\uD83D\uDC69\uD83C\uDFFC\u200D\u2695":"1f469-1f3fc-2695","\uD83D\uDC69\uD83C\uDFFB\u200D\u2695":"1f469-1f3fb-2695","\uD83D\uDC68\uD83C\uDFFB\u200D\u2696":"1f468-1f3fb-2696","\uD83D\uDC68\uD83C\uDFFC\u200D\u2696":"1f468-1f3fc-2696","\uD83D\uDC68\uD83C\uDFFD\u200D\u2696":"1f468-1f3fd-2696","\uD83D\uDC68\uD83C\uDFFE\u200D\u2696":"1f468-1f3fe-2696","\uD83D\uDC68\uD83C\uDFFF\u200D\u2696":"1f468-1f3ff-2696","\uD83D\uDC69\uD83C\uDFFB\u200D\u2696":"1f469-1f3fb-2696","\uD83D\uDC69\uD83C\uDFFC\u200D\u2696":"1f469-1f3fc-2696","\uD83D\uDC69\uD83C\uDFFD\u200D\u2696":"1f469-1f3fd-2696","\uD83D\uDC69\uD83C\uDFFE\u200D\u2696":"1f469-1f3fe-2696","\uD83D\uDC69\uD83C\uDFFF\u200D\u2696":"1f469-1f3ff-2696","\uD83D\uDC68\uD83C\uDFFB\u200D\u2708":"1f468-1f3fb-2708","\uD83D\uDC68\uD83C\uDFFC\u200D\u2708":"1f468-1f3fc-2708","\uD83D\uDC68\uD83C\uDFFD\u200D\u2708":"1f468-1f3fd-2708","\uD83D\uDC68\uD83C\uDFFE\u200D\u2708":"1f468-1f3fe-2708","\uD83D\uDC68\uD83C\uDFFF\u200D\u2708":"1f468-1f3ff-2708","\uD83D\uDC69\uD83C\uDFFB\u200D\u2708":"1f469-1f3fb-2708","\uD83D\uDC69\uD83C\uDFFC\u200D\u2708":"1f469-1f3fc-2708","\uD83D\uDC69\uD83C\uDFFD\u200D\u2708":"1f469-1f3fd-2708","\uD83D\uDC69\uD83C\uDFFE\u200D\u2708":"1f469-1f3fe-2708","\uD83D\uDC69\uD83C\uDFFF\u200D\u2708":"1f469-1f3ff-2708","\uD83D\uDC68\u2764\uFE0F\uD83D\uDC68":"1f468-2764-1f468","\uD83D\uDC69\u2764\uFE0F\uD83D\uDC68":"1f469-2764-1f468","\uD83D\uDC69\u2764\uFE0F\uD83D\uDC69":"1f469-2764-1f469","\uD83D\uDC68\uD83C\uDFFB\u2695\uFE0F":"1f468-1f3fb-2695","\uD83D\uDC68\uD83C\uDFFB\u2696\uFE0F":"1f468-1f3fb-2696","\uD83D\uDC68\uD83C\uDFFB\u2708\uFE0F":"1f468-1f3fb-2708","\uD83D\uDC68\uD83C\uDFFC\u2695\uFE0F":"1f468-1f3fc-2695","\uD83D\uDC68\uD83C\uDFFC\u2696\uFE0F":"1f468-1f3fc-2696","\uD83D\uDC68\uD83C\uDFFC\u2708\uFE0F":"1f468-1f3fc-2708","\uD83D\uDC68\uD83C\uDFFD\u2695\uFE0F":"1f468-1f3fd-2695","\uD83D\uDC68\uD83C\uDFFD\u2696\uFE0F":"1f468-1f3fd-2696","\uD83D\uDC68\uD83C\uDFFD\u2708\uFE0F":"1f468-1f3fd-2708","\uD83D\uDC68\uD83C\uDFFE\u2695\uFE0F":"1f468-1f3fe-2695","\uD83D\uDC68\uD83C\uDFFE\u2696\uFE0F":"1f468-1f3fe-2696","\uD83D\uDC68\uD83C\uDFFE\u2708\uFE0F":"1f468-1f3fe-2708","\uD83D\uDC68\uD83C\uDFFF\u2695\uFE0F":"1f468-1f3ff-2695","\uD83D\uDC68\uD83C\uDFFF\u2696\uFE0F":"1f468-1f3ff-2696","\uD83D\uDC68\uD83C\uDFFF\u2708\uFE0F":"1f468-1f3ff-2708","\uD83D\uDC69\uD83C\uDFFB\u2695\uFE0F":"1f469-1f3fb-2695","\uD83D\uDC69\uD83C\uDFFB\u2696\uFE0F":"1f469-1f3fb-2696","\uD83D\uDC69\uD83C\uDFFB\u2708\uFE0F":"1f469-1f3fb-2708","\uD83D\uDC69\uD83C\uDFFC\u2695\uFE0F":"1f469-1f3fc-2695","\uD83D\uDC69\uD83C\uDFFC\u2696\uFE0F":"1f469-1f3fc-2696","\uD83D\uDC69\uD83C\uDFFC\u2708\uFE0F":"1f469-1f3fc-2708","\uD83D\uDC69\uD83C\uDFFD\u2695\uFE0F":"1f469-1f3fd-2695","\uD83D\uDC69\uD83C\uDFFD\u2696\uFE0F":"1f469-1f3fd-2696","\uD83D\uDC69\uD83C\uDFFD\u2708\uFE0F":"1f469-1f3fd-2708","\uD83D\uDC69\uD83C\uDFFE\u2695\uFE0F":"1f469-1f3fe-2695","\uD83D\uDC69\uD83C\uDFFE\u2696\uFE0F":"1f469-1f3fe-2696","\uD83D\uDC69\uD83C\uDFFE\u2708\uFE0F":"1f469-1f3fe-2708","\uD83D\uDC69\uD83C\uDFFF\u2695\uFE0F":"1f469-1f3ff-2695","\uD83D\uDC69\uD83C\uDFFF\u2696\uFE0F":"1f469-1f3ff-2696","\uD83D\uDC69\uD83C\uDFFF\u2708\uFE0F":"1f469-1f3ff-2708","\uD83D\uDC6E\uD83C\uDFFB\u2640\uFE0F":"1f46e-1f3fb-2640","\uD83D\uDC6E\uD83C\uDFFB\u2642\uFE0F":"1f46e-1f3fb-2642","\uD83D\uDC6E\uD83C\uDFFC\u2640\uFE0F":"1f46e-1f3fc-2640","\uD83D\uDC6E\uD83C\uDFFC\u2642\uFE0F":"1f46e-1f3fc-2642","\uD83D\uDC6E\uD83C\uDFFD\u2640\uFE0F":"1f46e-1f3fd-2640","\uD83D\uDC6E\uD83C\uDFFD\u2642\uFE0F":"1f46e-1f3fd-2642","\uD83D\uDC6E\uD83C\uDFFE\u2640\uFE0F":"1f46e-1f3fe-2640","\uD83D\uDC6E\uD83C\uDFFE\u2642\uFE0F":"1f46e-1f3fe-2642","\uD83D\uDC6E\uD83C\uDFFF\u2640\uFE0F":"1f46e-1f3ff-2640","\uD83D\uDC6E\uD83C\uDFFF\u2642\uFE0F":"1f46e-1f3ff-2642","\uD83D\uDC71\uD83C\uDFFB\u2640\uFE0F":"1f471-1f3fb-2640","\uD83D\uDC71\uD83C\uDFFB\u2642\uFE0F":"1f471-1f3fb-2642","\uD83D\uDC71\uD83C\uDFFC\u2640\uFE0F":"1f471-1f3fc-2640","\uD83D\uDC71\uD83C\uDFFC\u2642\uFE0F":"1f471-1f3fc-2642","\uD83D\uDC71\uD83C\uDFFD\u2640\uFE0F":"1f471-1f3fd-2640","\uD83D\uDC71\uD83C\uDFFD\u2642\uFE0F":"1f471-1f3fd-2642","\uD83D\uDC71\uD83C\uDFFE\u2640\uFE0F":"1f471-1f3fe-2640","\uD83D\uDC71\uD83C\uDFFE\u2642\uFE0F":"1f471-1f3fe-2642","\uD83D\uDC71\uD83C\uDFFF\u2640\uFE0F":"1f471-1f3ff-2640","\uD83D\uDC71\uD83C\uDFFF\u2642\uFE0F":"1f471-1f3ff-2642","\uD83D\uDC73\uD83C\uDFFB\u2640\uFE0F":"1f473-1f3fb-2640","\uD83D\uDC73\uD83C\uDFFB\u2642\uFE0F":"1f473-1f3fb-2642","\uD83D\uDC73\uD83C\uDFFC\u2640\uFE0F":"1f473-1f3fc-2640","\uD83D\uDC73\uD83C\uDFFC\u2642\uFE0F":"1f473-1f3fc-2642","\uD83D\uDC73\uD83C\uDFFD\u2640\uFE0F":"1f473-1f3fd-2640","\uD83D\uDC73\uD83C\uDFFD\u2642\uFE0F":"1f473-1f3fd-2642","\uD83D\uDC73\uD83C\uDFFE\u2640\uFE0F":"1f473-1f3fe-2640","\uD83D\uDC73\uD83C\uDFFE\u2642\uFE0F":"1f473-1f3fe-2642","\uD83D\uDC73\uD83C\uDFFF\u2640\uFE0F":"1f473-1f3ff-2640","\uD83D\uDC73\uD83C\uDFFF\u2642\uFE0F":"1f473-1f3ff-2642","\uD83D\uDC77\uD83C\uDFFB\u2640\uFE0F":"1f477-1f3fb-2640","\uD83D\uDC77\uD83C\uDFFB\u2642\uFE0F":"1f477-1f3fb-2642","\uD83D\uDC77\uD83C\uDFFC\u2640\uFE0F":"1f477-1f3fc-2640","\uD83D\uDC77\uD83C\uDFFC\u2642\uFE0F":"1f477-1f3fc-2642","\uD83D\uDC77\uD83C\uDFFD\u2640\uFE0F":"1f477-1f3fd-2640","\uD83D\uDC77\uD83C\uDFFD\u2642\uFE0F":"1f477-1f3fd-2642","\uD83D\uDC77\uD83C\uDFFE\u2640\uFE0F":"1f477-1f3fe-2640","\uD83D\uDC77\uD83C\uDFFE\u2642\uFE0F":"1f477-1f3fe-2642","\uD83D\uDC77\uD83C\uDFFF\u2640\uFE0F":"1f477-1f3ff-2640","\uD83D\uDC77\uD83C\uDFFF\u2642\uFE0F":"1f477-1f3ff-2642","\uD83D\uDC82\uD83C\uDFFB\u2640\uFE0F":"1f482-1f3fb-2640","\uD83D\uDC82\uD83C\uDFFB\u2642\uFE0F":"1f482-1f3fb-2642","\uD83D\uDC82\uD83C\uDFFC\u2640\uFE0F":"1f482-1f3fc-2640","\uD83D\uDC82\uD83C\uDFFC\u2642\uFE0F":"1f482-1f3fc-2642","\uD83D\uDC82\uD83C\uDFFD\u2640\uFE0F":"1f482-1f3fd-2640","\uD83D\uDC82\uD83C\uDFFD\u2642\uFE0F":"1f482-1f3fd-2642","\uD83D\uDC82\uD83C\uDFFE\u2640\uFE0F":"1f482-1f3fe-2640","\uD83D\uDC82\uD83C\uDFFE\u2642\uFE0F":"1f482-1f3fe-2642","\uD83D\uDC82\uD83C\uDFFF\u2640\uFE0F":"1f482-1f3ff-2640","\uD83D\uDC82\uD83C\uDFFF\u2642\uFE0F":"1f482-1f3ff-2642","\uD83C\uDFC3\uD83C\uDFFB\u2640\uFE0F":"1f3c3-1f3fb-2640","\uD83C\uDFC3\uD83C\uDFFB\u2642\uFE0F":"1f3c3-1f3fb-2642","\uD83C\uDFC3\uD83C\uDFFC\u2640\uFE0F":"1f3c3-1f3fc-2640","\uD83C\uDFC3\uD83C\uDFFC\u2642\uFE0F":"1f3c3-1f3fc-2642","\uD83C\uDFC3\uD83C\uDFFD\u2640\uFE0F":"1f3c3-1f3fd-2640","\uD83C\uDFC3\uD83C\uDFFD\u2642\uFE0F":"1f3c3-1f3fd-2642","\uD83C\uDFC3\uD83C\uDFFE\u2640\uFE0F":"1f3c3-1f3fe-2640","\uD83C\uDFC3\uD83C\uDFFE\u2642\uFE0F":"1f3c3-1f3fe-2642","\uD83C\uDFC3\uD83C\uDFFF\u2640\uFE0F":"1f3c3-1f3ff-2640","\uD83C\uDFC3\uD83C\uDFFF\u2642\uFE0F":"1f3c3-1f3ff-2642","\uD83C\uDFC4\uD83C\uDFFB\u2640\uFE0F":"1f3c4-1f3fb-2640","\uD83C\uDFC4\uD83C\uDFFB\u2642\uFE0F":"1f3c4-1f3fb-2642","\uD83C\uDFC4\uD83C\uDFFC\u2640\uFE0F":"1f3c4-1f3fc-2640","\uD83C\uDFC4\uD83C\uDFFC\u2642\uFE0F":"1f3c4-1f3fc-2642","\uD83C\uDFC4\uD83C\uDFFD\u2640\uFE0F":"1f3c4-1f3fd-2640","\uD83C\uDFC4\uD83C\uDFFD\u2642\uFE0F":"1f3c4-1f3fd-2642","\uD83C\uDFC4\uD83C\uDFFE\u2640\uFE0F":"1f3c4-1f3fe-2640","\uD83C\uDFC4\uD83C\uDFFE\u2642\uFE0F":"1f3c4-1f3fe-2642","\uD83C\uDFC4\uD83C\uDFFF\u2640\uFE0F":"1f3c4-1f3ff-2640","\uD83C\uDFC4\uD83C\uDFFF\u2642\uFE0F":"1f3c4-1f3ff-2642","\uD83C\uDFCA\uD83C\uDFFB\u2640\uFE0F":"1f3ca-1f3fb-2640","\uD83C\uDFCA\uD83C\uDFFB\u2642\uFE0F":"1f3ca-1f3fb-2642","\uD83C\uDFCA\uD83C\uDFFC\u2640\uFE0F":"1f3ca-1f3fc-2640","\uD83C\uDFCA\uD83C\uDFFC\u2642\uFE0F":"1f3ca-1f3fc-2642","\uD83C\uDFCA\uD83C\uDFFD\u2640\uFE0F":"1f3ca-1f3fd-2640","\uD83C\uDFCA\uD83C\uDFFD\u2642\uFE0F":"1f3ca-1f3fd-2642","\uD83C\uDFCA\uD83C\uDFFE\u2640\uFE0F":"1f3ca-1f3fe-2640","\uD83C\uDFCA\uD83C\uDFFE\u2642\uFE0F":"1f3ca-1f3fe-2642","\uD83C\uDFCA\uD83C\uDFFF\u2640\uFE0F":"1f3ca-1f3ff-2640","\uD83C\uDFCA\uD83C\uDFFF\u2642\uFE0F":"1f3ca-1f3ff-2642","\uD83D\uDC86\uD83C\uDFFB\u2640\uFE0F":"1f486-1f3fb-2640","\uD83D\uDC86\uD83C\uDFFB\u2642\uFE0F":"1f486-1f3fb-2642","\uD83D\uDC86\uD83C\uDFFC\u2640\uFE0F":"1f486-1f3fc-2640","\uD83D\uDC86\uD83C\uDFFC\u2642\uFE0F":"1f486-1f3fc-2642","\uD83D\uDC86\uD83C\uDFFD\u2640\uFE0F":"1f486-1f3fd-2640","\uD83D\uDC86\uD83C\uDFFD\u2642\uFE0F":"1f486-1f3fd-2642","\uD83D\uDC86\uD83C\uDFFE\u2640\uFE0F":"1f486-1f3fe-2640","\uD83D\uDC86\uD83C\uDFFE\u2642\uFE0F":"1f486-1f3fe-2642","\uD83D\uDC86\uD83C\uDFFF\u2640\uFE0F":"1f486-1f3ff-2640","\uD83D\uDC86\uD83C\uDFFF\u2642\uFE0F":"1f486-1f3ff-2642","\uD83D\uDC87\uD83C\uDFFB\u2640\uFE0F":"1f487-1f3fb-2640","\uD83D\uDC87\uD83C\uDFFB\u2642\uFE0F":"1f487-1f3fb-2642","\uD83D\uDC87\uD83C\uDFFC\u2640\uFE0F":"1f487-1f3fc-2640","\uD83D\uDC87\uD83C\uDFFC\u2642\uFE0F":"1f487-1f3fc-2642","\uD83D\uDC87\uD83C\uDFFD\u2640\uFE0F":"1f487-1f3fd-2640","\uD83D\uDC87\uD83C\uDFFD\u2642\uFE0F":"1f487-1f3fd-2642","\uD83D\uDC87\uD83C\uDFFE\u2640\uFE0F":"1f487-1f3fe-2640","\uD83D\uDC87\uD83C\uDFFE\u2642\uFE0F":"1f487-1f3fe-2642","\uD83D\uDC87\uD83C\uDFFF\u2640\uFE0F":"1f487-1f3ff-2640","\uD83D\uDC87\uD83C\uDFFF\u2642\uFE0F":"1f487-1f3ff-2642","\uD83D\uDEA3\uD83C\uDFFB\u2640\uFE0F":"1f6a3-1f3fb-2640","\uD83D\uDEA3\uD83C\uDFFB\u2642\uFE0F":"1f6a3-1f3fb-2642","\uD83D\uDEA3\uD83C\uDFFC\u2640\uFE0F":"1f6a3-1f3fc-2640","\uD83D\uDEA3\uD83C\uDFFC\u2642\uFE0F":"1f6a3-1f3fc-2642","\uD83D\uDEA3\uD83C\uDFFD\u2640\uFE0F":"1f6a3-1f3fd-2640","\uD83D\uDEA3\uD83C\uDFFD\u2642\uFE0F":"1f6a3-1f3fd-2642","\uD83D\uDEA3\uD83C\uDFFE\u2640\uFE0F":"1f6a3-1f3fe-2640","\uD83D\uDEA3\uD83C\uDFFE\u2642\uFE0F":"1f6a3-1f3fe-2642","\uD83D\uDEA3\uD83C\uDFFF\u2640\uFE0F":"1f6a3-1f3ff-2640","\uD83D\uDEA3\uD83C\uDFFF\u2642\uFE0F":"1f6a3-1f3ff-2642","\uD83D\uDEB4\uD83C\uDFFB\u2640\uFE0F":"1f6b4-1f3fb-2640","\uD83D\uDEB4\uD83C\uDFFB\u2642\uFE0F":"1f6b4-1f3fb-2642","\uD83D\uDEB4\uD83C\uDFFC\u2640\uFE0F":"1f6b4-1f3fc-2640","\uD83D\uDEB4\uD83C\uDFFC\u2642\uFE0F":"1f6b4-1f3fc-2642","\uD83D\uDEB4\uD83C\uDFFD\u2640\uFE0F":"1f6b4-1f3fd-2640","\uD83D\uDEB4\uD83C\uDFFD\u2642\uFE0F":"1f6b4-1f3fd-2642","\uD83D\uDEB4\uD83C\uDFFE\u2640\uFE0F":"1f6b4-1f3fe-2640","\uD83D\uDEB4\uD83C\uDFFE\u2642\uFE0F":"1f6b4-1f3fe-2642","\uD83D\uDEB4\uD83C\uDFFF\u2640\uFE0F":"1f6b4-1f3ff-2640","\uD83D\uDEB4\uD83C\uDFFF\u2642\uFE0F":"1f6b4-1f3ff-2642","\uD83D\uDEB5\uD83C\uDFFB\u2640\uFE0F":"1f6b5-1f3fb-2640","\uD83D\uDEB5\uD83C\uDFFB\u2642\uFE0F":"1f6b5-1f3fb-2642","\uD83D\uDEB5\uD83C\uDFFC\u2640\uFE0F":"1f6b5-1f3fc-2640","\uD83D\uDEB5\uD83C\uDFFC\u2642\uFE0F":"1f6b5-1f3fc-2642","\uD83D\uDEB5\uD83C\uDFFD\u2640\uFE0F":"1f6b5-1f3fd-2640","\uD83D\uDEB5\uD83C\uDFFD\u2642\uFE0F":"1f6b5-1f3fd-2642","\uD83D\uDEB5\uD83C\uDFFE\u2640\uFE0F":"1f6b5-1f3fe-2640","\uD83D\uDEB5\uD83C\uDFFE\u2642\uFE0F":"1f6b5-1f3fe-2642","\uD83D\uDEB5\uD83C\uDFFF\u2640\uFE0F":"1f6b5-1f3ff-2640","\uD83D\uDEB5\uD83C\uDFFF\u2642\uFE0F":"1f6b5-1f3ff-2642","\uD83D\uDEB6\uD83C\uDFFB\u2640\uFE0F":"1f6b6-1f3fb-2640","\uD83D\uDEB6\uD83C\uDFFB\u2642\uFE0F":"1f6b6-1f3fb-2642","\uD83D\uDEB6\uD83C\uDFFC\u2640\uFE0F":"1f6b6-1f3fc-2640","\uD83D\uDEB6\uD83C\uDFFC\u2642\uFE0F":"1f6b6-1f3fc-2642","\uD83D\uDEB6\uD83C\uDFFD\u2640\uFE0F":"1f6b6-1f3fd-2640","\uD83D\uDEB6\uD83C\uDFFD\u2642\uFE0F":"1f6b6-1f3fd-2642","\uD83D\uDEB6\uD83C\uDFFE\u2640\uFE0F":"1f6b6-1f3fe-2640","\uD83D\uDEB6\uD83C\uDFFE\u2642\uFE0F":"1f6b6-1f3fe-2642","\uD83D\uDEB6\uD83C\uDFFF\u2640\uFE0F":"1f6b6-1f3ff-2640","\uD83D\uDEB6\uD83C\uDFFF\u2642\uFE0F":"1f6b6-1f3ff-2642","\uD83E\uDD38\uD83C\uDFFB\u2640\uFE0F":"1f938-1f3fb-2640","\uD83E\uDD38\uD83C\uDFFB\u2642\uFE0F":"1f938-1f3fb-2642","\uD83E\uDD38\uD83C\uDFFC\u2640\uFE0F":"1f938-1f3fc-2640","\uD83E\uDD38\uD83C\uDFFC\u2642\uFE0F":"1f938-1f3fc-2642","\uD83E\uDD38\uD83C\uDFFD\u2640\uFE0F":"1f938-1f3fd-2640","\uD83E\uDD38\uD83C\uDFFD\u2642\uFE0F":"1f938-1f3fd-2642","\uD83E\uDD38\uD83C\uDFFE\u2640\uFE0F":"1f938-1f3fe-2640","\uD83E\uDD38\uD83C\uDFFE\u2642\uFE0F":"1f938-1f3fe-2642","\uD83E\uDD38\uD83C\uDFFF\u2640\uFE0F":"1f938-1f3ff-2640","\uD83E\uDD38\uD83C\uDFFF\u2642\uFE0F":"1f938-1f3ff-2642","\uD83E\uDD39\uD83C\uDFFB\u2640\uFE0F":"1f939-1f3fb-2640","\uD83E\uDD39\uD83C\uDFFB\u2642\uFE0F":"1f939-1f3fb-2642","\uD83E\uDD39\uD83C\uDFFC\u2640\uFE0F":"1f939-1f3fc-2640","\uD83E\uDD39\uD83C\uDFFC\u2642\uFE0F":"1f939-1f3fc-2642","\uD83E\uDD39\uD83C\uDFFD\u2640\uFE0F":"1f939-1f3fd-2640","\uD83E\uDD39\uD83C\uDFFD\u2642\uFE0F":"1f939-1f3fd-2642","\uD83E\uDD39\uD83C\uDFFE\u2640\uFE0F":"1f939-1f3fe-2640","\uD83E\uDD39\uD83C\uDFFE\u2642\uFE0F":"1f939-1f3fe-2642","\uD83E\uDD39\uD83C\uDFFF\u2640\uFE0F":"1f939-1f3ff-2640","\uD83E\uDD39\uD83C\uDFFF\u2642\uFE0F":"1f939-1f3ff-2642","\uD83E\uDD3D\uD83C\uDFFB\u2640\uFE0F":"1f93d-1f3fb-2640","\uD83E\uDD3D\uD83C\uDFFB\u2642\uFE0F":"1f93d-1f3fb-2642","\uD83E\uDD3D\uD83C\uDFFC\u2640\uFE0F":"1f93d-1f3fc-2640","\uD83E\uDD3D\uD83C\uDFFC\u2642\uFE0F":"1f93d-1f3fc-2642","\uD83E\uDD3D\uD83C\uDFFD\u2640\uFE0F":"1f93d-1f3fd-2640","\uD83E\uDD3D\uD83C\uDFFD\u2642\uFE0F":"1f93d-1f3fd-2642","\uD83E\uDD3D\uD83C\uDFFE\u2640\uFE0F":"1f93d-1f3fe-2640","\uD83E\uDD3D\uD83C\uDFFE\u2642\uFE0F":"1f93d-1f3fe-2642","\uD83E\uDD3D\uD83C\uDFFF\u2640\uFE0F":"1f93d-1f3ff-2640","\uD83E\uDD3D\uD83C\uDFFF\u2642\uFE0F":"1f93d-1f3ff-2642","\uD83E\uDD3E\uD83C\uDFFB\u2640\uFE0F":"1f93e-1f3fb-2640","\uD83E\uDD3E\uD83C\uDFFB\u2642\uFE0F":"1f93e-1f3fb-2642","\uD83E\uDD3E\uD83C\uDFFC\u2640\uFE0F":"1f93e-1f3fc-2640","\uD83E\uDD3E\uD83C\uDFFC\u2642\uFE0F":"1f93e-1f3fc-2642","\uD83E\uDD3E\uD83C\uDFFD\u2640\uFE0F":"1f93e-1f3fd-2640","\uD83E\uDD3E\uD83C\uDFFD\u2642\uFE0F":"1f93e-1f3fd-2642","\uD83E\uDD3E\uD83C\uDFFE\u2640\uFE0F":"1f93e-1f3fe-2640","\uD83E\uDD3E\uD83C\uDFFE\u2642\uFE0F":"1f93e-1f3fe-2642","\uD83E\uDD3E\uD83C\uDFFF\u2640\uFE0F":"1f93e-1f3ff-2640","\uD83E\uDD3E\uD83C\uDFFF\u2642\uFE0F":"1f93e-1f3ff-2642","\uD83D\uDC81\uD83C\uDFFB\u2640\uFE0F":"1f481-1f3fb-2640","\uD83D\uDC81\uD83C\uDFFB\u2642\uFE0F":"1f481-1f3fb-2642","\uD83D\uDC81\uD83C\uDFFC\u2640\uFE0F":"1f481-1f3fc-2640","\uD83D\uDC81\uD83C\uDFFC\u2642\uFE0F":"1f481-1f3fc-2642","\uD83D\uDC81\uD83C\uDFFD\u2640\uFE0F":"1f481-1f3fd-2640","\uD83D\uDC81\uD83C\uDFFD\u2642\uFE0F":"1f481-1f3fd-2642","\uD83D\uDC81\uD83C\uDFFE\u2640\uFE0F":"1f481-1f3fe-2640","\uD83D\uDC81\uD83C\uDFFE\u2642\uFE0F":"1f481-1f3fe-2642","\uD83D\uDC81\uD83C\uDFFF\u2640\uFE0F":"1f481-1f3ff-2640","\uD83D\uDC81\uD83C\uDFFF\u2642\uFE0F":"1f481-1f3ff-2642","\uD83D\uDE45\uD83C\uDFFB\u2640\uFE0F":"1f645-1f3fb-2640","\uD83D\uDE45\uD83C\uDFFB\u2642\uFE0F":"1f645-1f3fb-2642","\uD83D\uDE45\uD83C\uDFFC\u2640\uFE0F":"1f645-1f3fc-2640","\uD83D\uDE45\uD83C\uDFFC\u2642\uFE0F":"1f645-1f3fc-2642","\uD83D\uDE45\uD83C\uDFFD\u2640\uFE0F":"1f645-1f3fd-2640","\uD83D\uDE45\uD83C\uDFFD\u2642\uFE0F":"1f645-1f3fd-2642","\uD83D\uDE45\uD83C\uDFFE\u2640\uFE0F":"1f645-1f3fe-2640","\uD83D\uDE45\uD83C\uDFFE\u2642\uFE0F":"1f645-1f3fe-2642","\uD83D\uDE45\uD83C\uDFFF\u2640\uFE0F":"1f645-1f3ff-2640","\uD83D\uDE45\uD83C\uDFFF\u2642\uFE0F":"1f645-1f3ff-2642","\uD83D\uDE46\uD83C\uDFFB\u2640\uFE0F":"1f646-1f3fb-2640","\uD83D\uDE46\uD83C\uDFFB\u2642\uFE0F":"1f646-1f3fb-2642","\uD83D\uDE46\uD83C\uDFFC\u2640\uFE0F":"1f646-1f3fc-2640","\uD83D\uDE46\uD83C\uDFFC\u2642\uFE0F":"1f646-1f3fc-2642","\uD83D\uDE46\uD83C\uDFFD\u2640\uFE0F":"1f646-1f3fd-2640","\uD83D\uDE46\uD83C\uDFFD\u2642\uFE0F":"1f646-1f3fd-2642","\uD83D\uDE46\uD83C\uDFFE\u2640\uFE0F":"1f646-1f3fe-2640","\uD83D\uDE46\uD83C\uDFFE\u2642\uFE0F":"1f646-1f3fe-2642","\uD83D\uDE46\uD83C\uDFFF\u2640\uFE0F":"1f646-1f3ff-2640","\uD83D\uDE46\uD83C\uDFFF\u2642\uFE0F":"1f646-1f3ff-2642","\uD83D\uDE47\uD83C\uDFFB\u2640\uFE0F":"1f647-1f3fb-2640","\uD83D\uDE47\uD83C\uDFFB\u2642\uFE0F":"1f647-1f3fb-2642","\uD83D\uDE47\uD83C\uDFFC\u2640\uFE0F":"1f647-1f3fc-2640","\uD83D\uDE47\uD83C\uDFFC\u2642\uFE0F":"1f647-1f3fc-2642","\uD83D\uDE47\uD83C\uDFFD\u2640\uFE0F":"1f647-1f3fd-2640","\uD83D\uDE47\uD83C\uDFFD\u2642\uFE0F":"1f647-1f3fd-2642","\uD83D\uDE47\uD83C\uDFFE\u2640\uFE0F":"1f647-1f3fe-2640","\uD83D\uDE47\uD83C\uDFFE\u2642\uFE0F":"1f647-1f3fe-2642","\uD83D\uDE47\uD83C\uDFFF\u2640\uFE0F":"1f647-1f3ff-2640","\uD83D\uDE47\uD83C\uDFFF\u2642\uFE0F":"1f647-1f3ff-2642","\uD83D\uDE4B\uD83C\uDFFB\u2640\uFE0F":"1f64b-1f3fb-2640","\uD83D\uDE4B\uD83C\uDFFB\u2642\uFE0F":"1f64b-1f3fb-2642","\uD83D\uDE4B\uD83C\uDFFC\u2640\uFE0F":"1f64b-1f3fc-2640","\uD83D\uDE4B\uD83C\uDFFC\u2642\uFE0F":"1f64b-1f3fc-2642","\uD83D\uDE4B\uD83C\uDFFD\u2640\uFE0F":"1f64b-1f3fd-2640","\uD83D\uDE4B\uD83C\uDFFD\u2642\uFE0F":"1f64b-1f3fd-2642","\uD83D\uDE4B\uD83C\uDFFE\u2640\uFE0F":"1f64b-1f3fe-2640","\uD83D\uDE4B\uD83C\uDFFE\u2642\uFE0F":"1f64b-1f3fe-2642","\uD83D\uDE4B\uD83C\uDFFF\u2640\uFE0F":"1f64b-1f3ff-2640","\uD83D\uDE4B\uD83C\uDFFF\u2642\uFE0F":"1f64b-1f3ff-2642","\uD83D\uDE4D\uD83C\uDFFB\u2640\uFE0F":"1f64d-1f3fb-2640","\uD83D\uDE4D\uD83C\uDFFB\u2642\uFE0F":"1f64d-1f3fb-2642","\uD83D\uDE4D\uD83C\uDFFC\u2640\uFE0F":"1f64d-1f3fc-2640","\uD83D\uDE4D\uD83C\uDFFC\u2642\uFE0F":"1f64d-1f3fc-2642","\uD83D\uDE4D\uD83C\uDFFD\u2640\uFE0F":"1f64d-1f3fd-2640","\uD83D\uDE4D\uD83C\uDFFD\u2642\uFE0F":"1f64d-1f3fd-2642","\uD83D\uDE4D\uD83C\uDFFE\u2640\uFE0F":"1f64d-1f3fe-2640","\uD83D\uDE4D\uD83C\uDFFE\u2642\uFE0F":"1f64d-1f3fe-2642","\uD83D\uDE4D\uD83C\uDFFF\u2640\uFE0F":"1f64d-1f3ff-2640","\uD83D\uDE4D\uD83C\uDFFF\u2642\uFE0F":"1f64d-1f3ff-2642","\uD83D\uDE4E\uD83C\uDFFB\u2640\uFE0F":"1f64e-1f3fb-2640","\uD83D\uDE4E\uD83C\uDFFB\u2642\uFE0F":"1f64e-1f3fb-2642","\uD83D\uDE4E\uD83C\uDFFC\u2640\uFE0F":"1f64e-1f3fc-2640","\uD83D\uDE4E\uD83C\uDFFC\u2642\uFE0F":"1f64e-1f3fc-2642","\uD83D\uDE4E\uD83C\uDFFD\u2640\uFE0F":"1f64e-1f3fd-2640","\uD83D\uDE4E\uD83C\uDFFD\u2642\uFE0F":"1f64e-1f3fd-2642","\uD83D\uDE4E\uD83C\uDFFE\u2640\uFE0F":"1f64e-1f3fe-2640","\uD83D\uDE4E\uD83C\uDFFE\u2642\uFE0F":"1f64e-1f3fe-2642","\uD83D\uDE4E\uD83C\uDFFF\u2640\uFE0F":"1f64e-1f3ff-2640","\uD83D\uDE4E\uD83C\uDFFF\u2642\uFE0F":"1f64e-1f3ff-2642","\uD83E\uDD26\uD83C\uDFFB\u2640\uFE0F":"1f926-1f3fb-2640","\uD83E\uDD26\uD83C\uDFFB\u2642\uFE0F":"1f926-1f3fb-2642","\uD83E\uDD26\uD83C\uDFFC\u2640\uFE0F":"1f926-1f3fc-2640","\uD83E\uDD26\uD83C\uDFFC\u2642\uFE0F":"1f926-1f3fc-2642","\uD83E\uDD26\uD83C\uDFFD\u2640\uFE0F":"1f926-1f3fd-2640","\uD83E\uDD26\uD83C\uDFFD\u2642\uFE0F":"1f926-1f3fd-2642","\uD83E\uDD26\uD83C\uDFFE\u2640\uFE0F":"1f926-1f3fe-2640","\uD83E\uDD26\uD83C\uDFFE\u2642\uFE0F":"1f926-1f3fe-2642","\uD83E\uDD26\uD83C\uDFFF\u2640\uFE0F":"1f926-1f3ff-2640","\uD83E\uDD26\uD83C\uDFFF\u2642\uFE0F":"1f926-1f3ff-2642","\uD83E\uDD37\uD83C\uDFFB\u2640\uFE0F":"1f937-1f3fb-2640","\uD83E\uDD37\uD83C\uDFFB\u2642\uFE0F":"1f937-1f3fb-2642","\uD83E\uDD37\uD83C\uDFFC\u2640\uFE0F":"1f937-1f3fc-2640","\uD83E\uDD37\uD83C\uDFFC\u2642\uFE0F":"1f937-1f3fc-2642","\uD83E\uDD37\uD83C\uDFFD\u2640\uFE0F":"1f937-1f3fd-2640","\uD83E\uDD37\uD83C\uDFFD\u2642\uFE0F":"1f937-1f3fd-2642","\uD83E\uDD37\uD83C\uDFFE\u2640\uFE0F":"1f937-1f3fe-2640","\uD83E\uDD37\uD83C\uDFFE\u2642\uFE0F":"1f937-1f3fe-2642","\uD83E\uDD37\uD83C\uDFFF\u2640\uFE0F":"1f937-1f3ff-2640","\uD83E\uDD37\uD83C\uDFFF\u2642\uFE0F":"1f937-1f3ff-2642","\uD83D\uDC41\uFE0F\uD83D\uDDE8\uFE0F":"1f441-1f5e8","\uD83E\uDDD9\uD83C\uDFFB\u200D\u2640":"1f9d9-1f3fb-2640","\uD83E\uDDD9\uD83C\uDFFB\u2640\uFE0F":"1f9d9-1f3fb-2640","\uD83E\uDDD9\uD83C\uDFFB\u200D\u2642":"1f9d9-1f3fb-2642","\uD83E\uDDD9\uD83C\uDFFB\u2642\uFE0F":"1f9d9-1f3fb-2642","\uD83E\uDDD9\uD83C\uDFFC\u200D\u2640":"1f9d9-1f3fc-2640","\uD83E\uDDD9\uD83C\uDFFC\u2640\uFE0F":"1f9d9-1f3fc-2640","\uD83E\uDDD9\uD83C\uDFFC\u200D\u2642":"1f9d9-1f3fc-2642","\uD83E\uDDD9\uD83C\uDFFC\u2642\uFE0F":"1f9d9-1f3fc-2642","\uD83E\uDDD9\uD83C\uDFFD\u200D\u2640":"1f9d9-1f3fd-2640","\uD83E\uDDD9\uD83C\uDFFD\u2640\uFE0F":"1f9d9-1f3fd-2640","\uD83E\uDDD9\uD83C\uDFFD\u200D\u2642":"1f9d9-1f3fd-2642","\uD83E\uDDD9\uD83C\uDFFD\u2642\uFE0F":"1f9d9-1f3fd-2642","\uD83E\uDDD9\uD83C\uDFFE\u200D\u2640":"1f9d9-1f3fe-2640","\uD83E\uDDD9\uD83C\uDFFE\u2640\uFE0F":"1f9d9-1f3fe-2640","\uD83E\uDDD9\uD83C\uDFFE\u200D\u2642":"1f9d9-1f3fe-2642","\uD83E\uDDD9\uD83C\uDFFE\u2642\uFE0F":"1f9d9-1f3fe-2642","\uD83E\uDDD9\uD83C\uDFFF\u200D\u2640":"1f9d9-1f3ff-2640","\uD83E\uDDD9\uD83C\uDFFF\u2640\uFE0F":"1f9d9-1f3ff-2640","\uD83E\uDDD9\uD83C\uDFFF\u200D\u2642":"1f9d9-1f3ff-2642","\uD83E\uDDD9\uD83C\uDFFF\u2642\uFE0F":"1f9d9-1f3ff-2642","\uD83E\uDDDA\uD83C\uDFFB\u200D\u2640":"1f9da-1f3fb-2640","\uD83E\uDDDA\uD83C\uDFFB\u2640\uFE0F":"1f9da-1f3fb-2640","\uD83E\uDDDA\uD83C\uDFFB\u200D\u2642":"1f9da-1f3fb-2642","\uD83E\uDDDA\uD83C\uDFFB\u2642\uFE0F":"1f9da-1f3fb-2642","\uD83E\uDDDA\uD83C\uDFFC\u200D\u2640":"1f9da-1f3fc-2640","\uD83E\uDDDA\uD83C\uDFFC\u2640\uFE0F":"1f9da-1f3fc-2640","\uD83E\uDDDA\uD83C\uDFFC\u200D\u2642":"1f9da-1f3fc-2642","\uD83E\uDDDA\uD83C\uDFFC\u2642\uFE0F":"1f9da-1f3fc-2642","\uD83E\uDDDA\uD83C\uDFFD\u200D\u2640":"1f9da-1f3fd-2640","\uD83E\uDDDA\uD83C\uDFFD\u2640\uFE0F":"1f9da-1f3fd-2640","\uD83E\uDDDA\uD83C\uDFFD\u200D\u2642":"1f9da-1f3fd-2642","\uD83E\uDDDA\uD83C\uDFFD\u2642\uFE0F":"1f9da-1f3fd-2642","\uD83E\uDDDA\uD83C\uDFFE\u200D\u2640":"1f9da-1f3fe-2640","\uD83E\uDDDA\uD83C\uDFFE\u2640\uFE0F":"1f9da-1f3fe-2640","\uD83E\uDDDA\uD83C\uDFFE\u200D\u2642":"1f9da-1f3fe-2642","\uD83E\uDDDA\uD83C\uDFFE\u2642\uFE0F":"1f9da-1f3fe-2642","\uD83E\uDDDA\uD83C\uDFFF\u200D\u2640":"1f9da-1f3ff-2640","\uD83E\uDDDA\uD83C\uDFFF\u2640\uFE0F":"1f9da-1f3ff-2640","\uD83E\uDDDA\uD83C\uDFFF\u200D\u2642":"1f9da-1f3ff-2642","\uD83E\uDDDA\uD83C\uDFFF\u2642\uFE0F":"1f9da-1f3ff-2642","\uD83E\uDDDB\uD83C\uDFFB\u200D\u2640":"1f9db-1f3fb-2640","\uD83E\uDDDB\uD83C\uDFFB\u2640\uFE0F":"1f9db-1f3fb-2640","\uD83E\uDDDB\uD83C\uDFFB\u200D\u2642":"1f9db-1f3fb-2642","\uD83E\uDDDB\uD83C\uDFFB\u2642\uFE0F":"1f9db-1f3fb-2642","\uD83E\uDDDB\uD83C\uDFFC\u200D\u2640":"1f9db-1f3fc-2640","\uD83E\uDDDB\uD83C\uDFFC\u2640\uFE0F":"1f9db-1f3fc-2640","\uD83E\uDDDB\uD83C\uDFFC\u200D\u2642":"1f9db-1f3fc-2642","\uD83E\uDDDB\uD83C\uDFFC\u2642\uFE0F":"1f9db-1f3fc-2642","\uD83E\uDDDB\uD83C\uDFFD\u200D\u2640":"1f9db-1f3fd-2640","\uD83E\uDDDB\uD83C\uDFFD\u2640\uFE0F":"1f9db-1f3fd-2640","\uD83E\uDDDB\uD83C\uDFFD\u200D\u2642":"1f9db-1f3fd-2642","\uD83E\uDDDB\uD83C\uDFFD\u2642\uFE0F":"1f9db-1f3fd-2642","\uD83E\uDDDB\uD83C\uDFFE\u200D\u2640":"1f9db-1f3fe-2640","\uD83E\uDDDB\uD83C\uDFFE\u2640\uFE0F":"1f9db-1f3fe-2640","\uD83E\uDDDB\uD83C\uDFFE\u200D\u2642":"1f9db-1f3fe-2642","\uD83E\uDDDB\uD83C\uDFFE\u2642\uFE0F":"1f9db-1f3fe-2642","\uD83E\uDDDB\uD83C\uDFFF\u200D\u2640":"1f9db-1f3ff-2640","\uD83E\uDDDB\uD83C\uDFFF\u2640\uFE0F":"1f9db-1f3ff-2640","\uD83E\uDDDB\uD83C\uDFFF\u200D\u2642":"1f9db-1f3ff-2642","\uD83E\uDDDB\uD83C\uDFFF\u2642\uFE0F":"1f9db-1f3ff-2642","\uD83E\uDDDC\uD83C\uDFFB\u200D\u2640":"1f9dc-1f3fb-2640","\uD83E\uDDDC\uD83C\uDFFB\u2640\uFE0F":"1f9dc-1f3fb-2640","\uD83E\uDDDC\uD83C\uDFFB\u200D\u2642":"1f9dc-1f3fb-2642","\uD83E\uDDDC\uD83C\uDFFB\u2642\uFE0F":"1f9dc-1f3fb-2642","\uD83E\uDDDC\uD83C\uDFFC\u200D\u2640":"1f9dc-1f3fc-2640","\uD83E\uDDDC\uD83C\uDFFC\u2640\uFE0F":"1f9dc-1f3fc-2640","\uD83E\uDDDC\uD83C\uDFFC\u200D\u2642":"1f9dc-1f3fc-2642","\uD83E\uDDDC\uD83C\uDFFC\u2642\uFE0F":"1f9dc-1f3fc-2642","\uD83E\uDDDC\uD83C\uDFFD\u200D\u2640":"1f9dc-1f3fd-2640","\uD83E\uDDDC\uD83C\uDFFD\u2640\uFE0F":"1f9dc-1f3fd-2640","\uD83E\uDDDC\uD83C\uDFFD\u200D\u2642":"1f9dc-1f3fd-2642","\uD83E\uDDDC\uD83C\uDFFD\u2642\uFE0F":"1f9dc-1f3fd-2642","\uD83E\uDDDC\uD83C\uDFFE\u200D\u2640":"1f9dc-1f3fe-2640","\uD83E\uDDDC\uD83C\uDFFE\u2640\uFE0F":"1f9dc-1f3fe-2640","\uD83E\uDDDC\uD83C\uDFFE\u200D\u2642":"1f9dc-1f3fe-2642","\uD83E\uDDDC\uD83C\uDFFE\u2642\uFE0F":"1f9dc-1f3fe-2642","\uD83E\uDDDC\uD83C\uDFFF\u200D\u2640":"1f9dc-1f3ff-2640","\uD83E\uDDDC\uD83C\uDFFF\u2640\uFE0F":"1f9dc-1f3ff-2640","\uD83E\uDDDC\uD83C\uDFFF\u200D\u2642":"1f9dc-1f3ff-2642","\uD83E\uDDDC\uD83C\uDFFF\u2642\uFE0F":"1f9dc-1f3ff-2642","\uD83E\uDDDD\uD83C\uDFFB\u200D\u2640":"1f9dd-1f3fb-2640","\uD83E\uDDDD\uD83C\uDFFB\u2640\uFE0F":"1f9dd-1f3fb-2640","\uD83E\uDDDD\uD83C\uDFFB\u200D\u2642":"1f9dd-1f3fb-2642","\uD83E\uDDDD\uD83C\uDFFB\u2642\uFE0F":"1f9dd-1f3fb-2642","\uD83E\uDDDD\uD83C\uDFFC\u200D\u2640":"1f9dd-1f3fc-2640","\uD83E\uDDDD\uD83C\uDFFC\u2640\uFE0F":"1f9dd-1f3fc-2640","\uD83E\uDDDD\uD83C\uDFFC\u200D\u2642":"1f9dd-1f3fc-2642","\uD83E\uDDDD\uD83C\uDFFC\u2642\uFE0F":"1f9dd-1f3fc-2642","\uD83E\uDDDD\uD83C\uDFFD\u200D\u2640":"1f9dd-1f3fd-2640","\uD83E\uDDDD\uD83C\uDFFD\u2640\uFE0F":"1f9dd-1f3fd-2640","\uD83E\uDDDD\uD83C\uDFFD\u200D\u2642":"1f9dd-1f3fd-2642","\uD83E\uDDDD\uD83C\uDFFD\u2642\uFE0F":"1f9dd-1f3fd-2642","\uD83E\uDDDD\uD83C\uDFFE\u200D\u2640":"1f9dd-1f3fe-2640","\uD83E\uDDDD\uD83C\uDFFE\u2640\uFE0F":"1f9dd-1f3fe-2640","\uD83E\uDDDD\uD83C\uDFFE\u200D\u2642":"1f9dd-1f3fe-2642","\uD83E\uDDDD\uD83C\uDFFE\u2642\uFE0F":"1f9dd-1f3fe-2642","\uD83E\uDDDD\uD83C\uDFFF\u200D\u2640":"1f9dd-1f3ff-2640","\uD83E\uDDDD\uD83C\uDFFF\u2640\uFE0F":"1f9dd-1f3ff-2640","\uD83E\uDDDD\uD83C\uDFFF\u200D\u2642":"1f9dd-1f3ff-2642","\uD83E\uDDDD\uD83C\uDFFF\u2642\uFE0F":"1f9dd-1f3ff-2642","\uD83E\uDDD6\uD83C\uDFFB\u200D\u2640":"1f9d6-1f3fb-2640","\uD83E\uDDD6\uD83C\uDFFB\u2640\uFE0F":"1f9d6-1f3fb-2640","\uD83E\uDDD6\uD83C\uDFFB\u200D\u2642":"1f9d6-1f3fb-2642","\uD83E\uDDD6\uD83C\uDFFB\u2642\uFE0F":"1f9d6-1f3fb-2642","\uD83E\uDDD6\uD83C\uDFFC\u200D\u2640":"1f9d6-1f3fc-2640","\uD83E\uDDD6\uD83C\uDFFC\u2640\uFE0F":"1f9d6-1f3fc-2640","\uD83E\uDDD6\uD83C\uDFFC\u200D\u2642":"1f9d6-1f3fc-2642","\uD83E\uDDD6\uD83C\uDFFC\u2642\uFE0F":"1f9d6-1f3fc-2642","\uD83E\uDDD6\uD83C\uDFFD\u200D\u2640":"1f9d6-1f3fd-2640","\uD83E\uDDD6\uD83C\uDFFD\u2640\uFE0F":"1f9d6-1f3fd-2640","\uD83E\uDDD6\uD83C\uDFFD\u200D\u2642":"1f9d6-1f3fd-2642","\uD83E\uDDD6\uD83C\uDFFD\u2642\uFE0F":"1f9d6-1f3fd-2642","\uD83E\uDDD6\uD83C\uDFFE\u200D\u2640":"1f9d6-1f3fe-2640","\uD83E\uDDD6\uD83C\uDFFE\u2640\uFE0F":"1f9d6-1f3fe-2640","\uD83E\uDDD6\uD83C\uDFFE\u200D\u2642":"1f9d6-1f3fe-2642","\uD83E\uDDD6\uD83C\uDFFE\u2642\uFE0F":"1f9d6-1f3fe-2642","\uD83E\uDDD6\uD83C\uDFFF\u200D\u2640":"1f9d6-1f3ff-2640","\uD83E\uDDD6\uD83C\uDFFF\u2640\uFE0F":"1f9d6-1f3ff-2640","\uD83E\uDDD6\uD83C\uDFFF\u200D\u2642":"1f9d6-1f3ff-2642","\uD83E\uDDD6\uD83C\uDFFF\u2642\uFE0F":"1f9d6-1f3ff-2642","\uD83E\uDDD7\uD83C\uDFFB\u200D\u2640":"1f9d7-1f3fb-2640","\uD83E\uDDD7\uD83C\uDFFB\u2640\uFE0F":"1f9d7-1f3fb-2640","\uD83E\uDDD7\uD83C\uDFFB\u200D\u2642":"1f9d7-1f3fb-2642","\uD83E\uDDD7\uD83C\uDFFB\u2642\uFE0F":"1f9d7-1f3fb-2642","\uD83E\uDDD7\uD83C\uDFFC\u200D\u2640":"1f9d7-1f3fc-2640","\uD83E\uDDD7\uD83C\uDFFC\u2640\uFE0F":"1f9d7-1f3fc-2640","\uD83E\uDDD7\uD83C\uDFFC\u200D\u2642":"1f9d7-1f3fc-2642","\uD83E\uDDD7\uD83C\uDFFC\u2642\uFE0F":"1f9d7-1f3fc-2642","\uD83E\uDDD7\uD83C\uDFFD\u200D\u2640":"1f9d7-1f3fd-2640","\uD83E\uDDD7\uD83C\uDFFD\u2640\uFE0F":"1f9d7-1f3fd-2640","\uD83E\uDDD7\uD83C\uDFFD\u200D\u2642":"1f9d7-1f3fd-2642","\uD83E\uDDD7\uD83C\uDFFD\u2642\uFE0F":"1f9d7-1f3fd-2642","\uD83E\uDDD7\uD83C\uDFFE\u200D\u2640":"1f9d7-1f3fe-2640","\uD83E\uDDD7\uD83C\uDFFE\u2640\uFE0F":"1f9d7-1f3fe-2640","\uD83E\uDDD7\uD83C\uDFFE\u200D\u2642":"1f9d7-1f3fe-2642","\uD83E\uDDD7\uD83C\uDFFE\u2642\uFE0F":"1f9d7-1f3fe-2642","\uD83E\uDDD7\uD83C\uDFFF\u200D\u2640":"1f9d7-1f3ff-2640","\uD83E\uDDD7\uD83C\uDFFF\u2640\uFE0F":"1f9d7-1f3ff-2640","\uD83E\uDDD7\uD83C\uDFFF\u200D\u2642":"1f9d7-1f3ff-2642","\uD83E\uDDD7\uD83C\uDFFF\u2642\uFE0F":"1f9d7-1f3ff-2642","\uD83E\uDDD8\uD83C\uDFFB\u200D\u2640":"1f9d8-1f3fb-2640","\uD83E\uDDD8\uD83C\uDFFB\u2640\uFE0F":"1f9d8-1f3fb-2640","\uD83E\uDDD8\uD83C\uDFFB\u200D\u2642":"1f9d8-1f3fb-2642","\uD83E\uDDD8\uD83C\uDFFB\u2642\uFE0F":"1f9d8-1f3fb-2642","\uD83E\uDDD8\uD83C\uDFFC\u200D\u2640":"1f9d8-1f3fc-2640","\uD83E\uDDD8\uD83C\uDFFC\u2640\uFE0F":"1f9d8-1f3fc-2640","\uD83E\uDDD8\uD83C\uDFFC\u200D\u2642":"1f9d8-1f3fc-2642","\uD83E\uDDD8\uD83C\uDFFC\u2642\uFE0F":"1f9d8-1f3fc-2642","\uD83E\uDDD8\uD83C\uDFFD\u200D\u2640":"1f9d8-1f3fd-2640","\uD83E\uDDD8\uD83C\uDFFD\u2640\uFE0F":"1f9d8-1f3fd-2640","\uD83E\uDDD8\uD83C\uDFFD\u200D\u2642":"1f9d8-1f3fd-2642","\uD83E\uDDD8\uD83C\uDFFD\u2642\uFE0F":"1f9d8-1f3fd-2642","\uD83E\uDDD8\uD83C\uDFFE\u200D\u2640":"1f9d8-1f3fe-2640","\uD83E\uDDD8\uD83C\uDFFE\u2640\uFE0F":"1f9d8-1f3fe-2640","\uD83E\uDDD8\uD83C\uDFFE\u200D\u2642":"1f9d8-1f3fe-2642","\uD83E\uDDD8\uD83C\uDFFE\u2642\uFE0F":"1f9d8-1f3fe-2642","\uD83E\uDDD8\uD83C\uDFFF\u200D\u2640":"1f9d8-1f3ff-2640","\uD83E\uDDD8\uD83C\uDFFF\u2640\uFE0F":"1f9d8-1f3ff-2640","\uD83E\uDDD8\uD83C\uDFFF\u200D\u2642":"1f9d8-1f3ff-2642","\uD83E\uDDD8\uD83C\uDFFF\u2642\uFE0F":"1f9d8-1f3ff-2642","\uD83D\uDC41\u200D\uD83D\uDDE8\uFE0F":"1f441-1f5e8","\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8":"1f441-1f5e8","\uD83E\uDDB8\uD83C\uDFFB\u200D\u2640":"1f9b8-1f3fb-2640","\uD83E\uDDB8\uD83C\uDFFB\u2640\uFE0F":"1f9b8-1f3fb-2640","\uD83E\uDDB8\uD83C\uDFFB\u200D\u2642":"1f9b8-1f3fb-2642","\uD83E\uDDB8\uD83C\uDFFB\u2642\uFE0F":"1f9b8-1f3fb-2642","\uD83E\uDDB8\uD83C\uDFFC\u200D\u2640":"1f9b8-1f3fc-2640","\uD83E\uDDB8\uD83C\uDFFC\u2640\uFE0F":"1f9b8-1f3fc-2640","\uD83E\uDDB8\uD83C\uDFFC\u200D\u2642":"1f9b8-1f3fc-2642","\uD83E\uDDB8\uD83C\uDFFC\u2642\uFE0F":"1f9b8-1f3fc-2642","\uD83E\uDDB8\uD83C\uDFFD\u200D\u2640":"1f9b8-1f3fd-2640","\uD83E\uDDB8\uD83C\uDFFD\u2640\uFE0F":"1f9b8-1f3fd-2640","\uD83E\uDDB8\uD83C\uDFFD\u200D\u2642":"1f9b8-1f3fd-2642","\uD83E\uDDB8\uD83C\uDFFD\u2642\uFE0F":"1f9b8-1f3fd-2642","\uD83E\uDDB8\uD83C\uDFFE\u200D\u2640":"1f9b8-1f3fe-2640","\uD83E\uDDB8\uD83C\uDFFE\u2640\uFE0F":"1f9b8-1f3fe-2640","\uD83E\uDDB8\uD83C\uDFFE\u200D\u2642":"1f9b8-1f3fe-2642","\uD83E\uDDB8\uD83C\uDFFE\u2642\uFE0F":"1f9b8-1f3fe-2642","\uD83E\uDDB8\uD83C\uDFFF\u200D\u2640":"1f9b8-1f3ff-2640","\uD83E\uDDB8\uD83C\uDFFF\u2640\uFE0F":"1f9b8-1f3ff-2640","\uD83E\uDDB8\uD83C\uDFFF\u200D\u2642":"1f9b8-1f3ff-2642","\uD83E\uDDB8\uD83C\uDFFF\u2642\uFE0F":"1f9b8-1f3ff-2642","\uD83E\uDDB9\uD83C\uDFFB\u200D\u2640":"1f9b9-1f3fb-2640","\uD83E\uDDB9\uD83C\uDFFB\u2640\uFE0F":"1f9b9-1f3fb-2640","\uD83E\uDDB9\uD83C\uDFFB\u200D\u2642":"1f9b9-1f3fb-2642","\uD83E\uDDB9\uD83C\uDFFB\u2642\uFE0F":"1f9b9-1f3fb-2642","\uD83E\uDDB9\uD83C\uDFFC\u200D\u2640":"1f9b9-1f3fc-2640","\uD83E\uDDB9\uD83C\uDFFC\u2640\uFE0F":"1f9b9-1f3fc-2640","\uD83E\uDDB9\uD83C\uDFFC\u200D\u2642":"1f9b9-1f3fc-2642","\uD83E\uDDB9\uD83C\uDFFC\u2642\uFE0F":"1f9b9-1f3fc-2642","\uD83E\uDDB9\uD83C\uDFFD\u200D\u2640":"1f9b9-1f3fd-2640","\uD83E\uDDB9\uD83C\uDFFD\u2640\uFE0F":"1f9b9-1f3fd-2640","\uD83E\uDDB9\uD83C\uDFFD\u200D\u2642":"1f9b9-1f3fd-2642","\uD83E\uDDB9\uD83C\uDFFD\u2642\uFE0F":"1f9b9-1f3fd-2642","\uD83E\uDDB9\uD83C\uDFFE\u200D\u2640":"1f9b9-1f3fe-2640","\uD83E\uDDB9\uD83C\uDFFE\u2640\uFE0F":"1f9b9-1f3fe-2640","\uD83E\uDDB9\uD83C\uDFFE\u200D\u2642":"1f9b9-1f3fe-2642","\uD83E\uDDB9\uD83C\uDFFE\u2642\uFE0F":"1f9b9-1f3fe-2642","\uD83E\uDDB9\uD83C\uDFFF\u200D\u2640":"1f9b9-1f3ff-2640","\uD83E\uDDB9\uD83C\uDFFF\u2640\uFE0F":"1f9b9-1f3ff-2640","\uD83E\uDDB9\uD83C\uDFFF\u200D\u2642":"1f9b9-1f3ff-2642","\uD83E\uDDB9\uD83C\uDFFF\u2642\uFE0F":"1f9b9-1f3ff-2642","\u26F9\uD83C\uDFFF\u200D\u2642":"26f9-1f3ff-2642","\u26F9\uD83C\uDFFE\u200D\u2642":"26f9-1f3fe-2642","\u26F9\uD83C\uDFFD\u200D\u2642":"26f9-1f3fd-2642","\u26F9\uD83C\uDFFC\u200D\u2642":"26f9-1f3fc-2642","\u26F9\uD83C\uDFFB\u200D\u2642":"26f9-1f3fb-2642","\u26F9\uD83C\uDFFF\u200D\u2640":"26f9-1f3ff-2640","\u26F9\uD83C\uDFFE\u200D\u2640":"26f9-1f3fe-2640","\u26F9\uD83C\uDFFD\u200D\u2640":"26f9-1f3fd-2640","\u26F9\uD83C\uDFFC\u200D\u2640":"26f9-1f3fc-2640","\u26F9\uD83C\uDFFB\u200D\u2640":"26f9-1f3fb-2640","\uD83D\uDC68\u200D\u2695\uFE0F":"1f468-2695","\uD83D\uDC68\u200D\u2696\uFE0F":"1f468-2696","\uD83D\uDC68\u200D\u2708\uFE0F":"1f468-2708","\uD83D\uDC69\u200D\u2695\uFE0F":"1f469-2695","\uD83D\uDC69\u200D\u2696\uFE0F":"1f469-2696","\uD83D\uDC69\u200D\u2708\uFE0F":"1f469-2708","\uD83D\uDC6E\u200D\u2640\uFE0F":"1f46e-2640","\uD83D\uDC6E\u200D\u2642\uFE0F":"1f46e-2642","\uD83D\uDC71\u200D\u2640\uFE0F":"1f471-2640","\uD83D\uDC71\u200D\u2642\uFE0F":"1f471-2642","\uD83D\uDC73\u200D\u2640\uFE0F":"1f473-2640","\uD83D\uDC73\u200D\u2642\uFE0F":"1f473-2642","\uD83D\uDC77\u200D\u2640\uFE0F":"1f477-2640","\uD83D\uDC77\u200D\u2642\uFE0F":"1f477-2642","\uD83D\uDC82\u200D\u2640\uFE0F":"1f482-2640","\uD83D\uDC82\u200D\u2642\uFE0F":"1f482-2642","\uD83D\uDD75\uFE0F\u2640\uFE0F":"1f575-2640","\uD83D\uDD75\uFE0F\u2642\uFE0F":"1f575-2642","\uD83C\uDFC3\u200D\u2640\uFE0F":"1f3c3-2640","\uD83C\uDFC3\u200D\u2642\uFE0F":"1f3c3-2642","\uD83C\uDFC4\u200D\u2640\uFE0F":"1f3c4-2640","\uD83C\uDFC4\u200D\u2642\uFE0F":"1f3c4-2642","\uD83C\uDFCA\u200D\u2640\uFE0F":"1f3ca-2640","\uD83C\uDFCA\u200D\u2642\uFE0F":"1f3ca-2642","\uD83C\uDFCB\uFE0F\u2640\uFE0F":"1f3cb-2640","\uD83C\uDFCB\uFE0F\u2642\uFE0F":"1f3cb-2642","\uD83C\uDFCC\uFE0F\u2640\uFE0F":"1f3cc-2640","\uD83C\uDFCC\uFE0F\u2642\uFE0F":"1f3cc-2642","\uD83D\uDC6F\u200D\u2640\uFE0F":"1f46f-2640","\uD83D\uDC6F\u200D\u2642\uFE0F":"1f46f-2642","\uD83D\uDC86\u200D\u2640\uFE0F":"1f486-2640","\uD83D\uDC86\u200D\u2642\uFE0F":"1f486-2642","\uD83D\uDC87\u200D\u2640\uFE0F":"1f487-2640","\uD83D\uDC87\u200D\u2642\uFE0F":"1f487-2642","\uD83D\uDEA3\u200D\u2640\uFE0F":"1f6a3-2640","\uD83D\uDEA3\u200D\u2642\uFE0F":"1f6a3-2642","\uD83D\uDEB4\u200D\u2640\uFE0F":"1f6b4-2640","\uD83D\uDEB4\u200D\u2642\uFE0F":"1f6b4-2642","\uD83D\uDEB5\u200D\u2640\uFE0F":"1f6b5-2640","\uD83D\uDEB5\u200D\u2642\uFE0F":"1f6b5-2642","\uD83D\uDEB6\u200D\u2640\uFE0F":"1f6b6-2640","\uD83D\uDEB6\u200D\u2642\uFE0F":"1f6b6-2642","\uD83E\uDD38\u200D\u2640\uFE0F":"1f938-2640","\uD83E\uDD38\u200D\u2642\uFE0F":"1f938-2642","\uD83E\uDD39\u200D\u2640\uFE0F":"1f939-2640","\uD83E\uDD39\u200D\u2642\uFE0F":"1f939-2642","\uD83E\uDD3C\u200D\u2640\uFE0F":"1f93c-2640","\uD83E\uDD3C\u200D\u2642\uFE0F":"1f93c-2642","\uD83E\uDD3D\u200D\u2640\uFE0F":"1f93d-2640","\uD83E\uDD3D\u200D\u2642\uFE0F":"1f93d-2642","\uD83E\uDD3E\u200D\u2640\uFE0F":"1f93e-2640","\uD83E\uDD3E\u200D\u2642\uFE0F":"1f93e-2642","\uD83D\uDC81\u200D\u2640\uFE0F":"1f481-2640","\uD83D\uDC81\u200D\u2642\uFE0F":"1f481-2642","\uD83D\uDE45\u200D\u2640\uFE0F":"1f645-2640","\uD83D\uDE45\u200D\u2642\uFE0F":"1f645-2642","\uD83D\uDE46\u200D\u2640\uFE0F":"1f646-2640","\uD83D\uDE46\u200D\u2642\uFE0F":"1f646-2642","\uD83D\uDE47\u200D\u2640\uFE0F":"1f647-2640","\uD83D\uDE47\u200D\u2642\uFE0F":"1f647-2642","\uD83D\uDE4B\u200D\u2640\uFE0F":"1f64b-2640","\uD83D\uDE4B\u200D\u2642\uFE0F":"1f64b-2642","\uD83D\uDE4D\u200D\u2640\uFE0F":"1f64d-2640","\uD83D\uDE4D\u200D\u2642\uFE0F":"1f64d-2642","\uD83D\uDE4E\u200D\u2640\uFE0F":"1f64e-2640","\uD83D\uDE4E\u200D\u2642\uFE0F":"1f64e-2642","\uD83E\uDD26\u200D\u2640\uFE0F":"1f926-2640","\uD83E\uDD26\u200D\u2642\uFE0F":"1f926-2642","\uD83E\uDD37\u200D\u2640\uFE0F":"1f937-2640","\uD83E\uDD37\u200D\u2642\uFE0F":"1f937-2642","\uD83E\uDDD9\u200D\u2640\uFE0F":"1f9d9-2640","\uD83E\uDDD9\u200D\u2642\uFE0F":"1f9d9-2642","\uD83E\uDDDA\u200D\u2640\uFE0F":"1f9da-2640","\uD83E\uDDDA\u200D\u2642\uFE0F":"1f9da-2642","\uD83E\uDDDB\u200D\u2640\uFE0F":"1f9db-2640","\uD83E\uDDDB\u200D\u2642\uFE0F":"1f9db-2642","\uD83E\uDDDC\u200D\u2640\uFE0F":"1f9dc-2640","\uD83E\uDDDC\u200D\u2642\uFE0F":"1f9dc-2642","\uD83E\uDDDD\u200D\u2640\uFE0F":"1f9dd-2640","\uD83E\uDDDD\u200D\u2642\uFE0F":"1f9dd-2642","\uD83E\uDDDE\u200D\u2640\uFE0F":"1f9de-2640","\uD83E\uDDDE\u200D\u2642\uFE0F":"1f9de-2642","\uD83E\uDDDF\u200D\u2640\uFE0F":"1f9df-2640","\uD83E\uDDDF\u200D\u2642\uFE0F":"1f9df-2642","\uD83E\uDDD6\u200D\u2640\uFE0F":"1f9d6-2640","\uD83E\uDDD6\u200D\u2642\uFE0F":"1f9d6-2642","\uD83E\uDDD7\u200D\u2640\uFE0F":"1f9d7-2640","\uD83E\uDDD7\u200D\u2642\uFE0F":"1f9d7-2642","\uD83E\uDDD8\u200D\u2640\uFE0F":"1f9d8-2640","\uD83E\uDDD8\u200D\u2642\uFE0F":"1f9d8-2642","\uD83D\uDD75\u200D\u2640\uFE0F":"1f575-2640","\uD83D\uDD75\uFE0F\u200D\u2640":"1f575-2640","\uD83D\uDD75\u200D\u2642\uFE0F":"1f575-2642","\uD83D\uDD75\uFE0F\u200D\u2642":"1f575-2642","\uD83C\uDFCB\u200D\u2640\uFE0F":"1f3cb-2640","\uD83C\uDFCB\uFE0F\u200D\u2640":"1f3cb-2640","\uD83C\uDFCB\u200D\u2642\uFE0F":"1f3cb-2642","\uD83C\uDFCB\uFE0F\u200D\u2642":"1f3cb-2642","\uD83C\uDFCC\u200D\u2640\uFE0F":"1f3cc-2640","\uD83C\uDFCC\uFE0F\u200D\u2640":"1f3cc-2640","\uD83C\uDFCC\u200D\u2642\uFE0F":"1f3cc-2642","\uD83C\uDFCC\uFE0F\u200D\u2642":"1f3cc-2642","\uD83E\uDDB8\u200D\u2640\uFE0F":"1f9b8-2640","\uD83E\uDDB8\u200D\u2642\uFE0F":"1f9b8-2642","\uD83E\uDDB9\u200D\u2640\uFE0F":"1f9b9-2640","\uD83E\uDDB9\u200D\u2642\uFE0F":"1f9b9-2642","\uD83C\uDFF4\u200D\u2620\uFE0F":"1f3f4-2620","\u26F9\uFE0F\u2640\uFE0F":"26f9-2640","\u26F9\uFE0F\u2642\uFE0F":"26f9-2642","\u26F9\u200D\u2640\uFE0F":"26f9-2640","\u26F9\uFE0F\u200D\u2640":"26f9-2640","\u26F9\u200D\u2642\uFE0F":"26f9-2642","\u26F9\uFE0F\u200D\u2642":"26f9-2642","\uD83D\uDC68\uD83D\uDC68\uD83D\uDC66":"1f468-1f468-1f466","\uD83D\uDC68\uD83D\uDC68\uD83D\uDC67":"1f468-1f468-1f467","\uD83D\uDC68\uD83D\uDC69\uD83D\uDC67":"1f468-1f469-1f467","\uD83D\uDC69\uD83D\uDC69\uD83D\uDC66":"1f469-1f469-1f466","\uD83D\uDC69\uD83D\uDC69\uD83D\uDC67":"1f469-1f469-1f467","\uD83D\uDC68\uD83D\uDC66\uD83D\uDC66":"1f468-1f466-1f466","\uD83D\uDC68\uD83D\uDC67\uD83D\uDC66":"1f468-1f467-1f466","\uD83D\uDC69\uD83D\uDC66\uD83D\uDC66":"1f469-1f466-1f466","\uD83D\uDC69\uD83D\uDC67\uD83D\uDC66":"1f469-1f467-1f466","\uD83D\uDC69\uD83D\uDC67\uD83D\uDC67":"1f469-1f467-1f467","\uD83D\uDC68\uD83C\uDFFB\uD83C\uDFA8":"1f468-1f3fb-1f3a8","\uD83D\uDC68\uD83C\uDFFC\uD83C\uDFA8":"1f468-1f3fc-1f3a8","\uD83D\uDC68\uD83C\uDFFD\uD83C\uDFA8":"1f468-1f3fd-1f3a8","\uD83D\uDC68\uD83C\uDFFE\uD83C\uDFA8":"1f468-1f3fe-1f3a8","\uD83D\uDC68\uD83C\uDFFF\uD83C\uDFA8":"1f468-1f3ff-1f3a8","\uD83D\uDC69\uD83C\uDFFB\uD83C\uDFA8":"1f469-1f3fb-1f3a8","\uD83D\uDC69\uD83C\uDFFC\uD83C\uDFA8":"1f469-1f3fc-1f3a8","\uD83D\uDC69\uD83C\uDFFD\uD83C\uDFA8":"1f469-1f3fd-1f3a8","\uD83D\uDC69\uD83C\uDFFE\uD83C\uDFA8":"1f469-1f3fe-1f3a8","\uD83D\uDC69\uD83C\uDFFF\uD83C\uDFA8":"1f469-1f3ff-1f3a8","\uD83D\uDC68\uD83C\uDFFB\uD83D\uDE80":"1f468-1f3fb-1f680","\uD83D\uDC68\uD83C\uDFFC\uD83D\uDE80":"1f468-1f3fc-1f680","\uD83D\uDC68\uD83C\uDFFD\uD83D\uDE80":"1f468-1f3fd-1f680","\uD83D\uDC68\uD83C\uDFFE\uD83D\uDE80":"1f468-1f3fe-1f680","\uD83D\uDC68\uD83C\uDFFF\uD83D\uDE80":"1f468-1f3ff-1f680","\uD83D\uDC69\uD83C\uDFFB\uD83D\uDE80":"1f469-1f3fb-1f680","\uD83D\uDC69\uD83C\uDFFC\uD83D\uDE80":"1f469-1f3fc-1f680","\uD83D\uDC69\uD83C\uDFFD\uD83D\uDE80":"1f469-1f3fd-1f680","\uD83D\uDC69\uD83C\uDFFE\uD83D\uDE80":"1f469-1f3fe-1f680","\uD83D\uDC69\uD83C\uDFFF\uD83D\uDE80":"1f469-1f3ff-1f680","\uD83D\uDC68\uD83C\uDFFB\uD83D\uDE92":"1f468-1f3fb-1f692","\uD83D\uDC68\uD83C\uDFFC\uD83D\uDE92":"1f468-1f3fc-1f692","\uD83D\uDC68\uD83C\uDFFD\uD83D\uDE92":"1f468-1f3fd-1f692","\uD83D\uDC68\uD83C\uDFFE\uD83D\uDE92":"1f468-1f3fe-1f692","\uD83D\uDC68\uD83C\uDFFF\uD83D\uDE92":"1f468-1f3ff-1f692","\uD83D\uDC69\uD83C\uDFFB\uD83D\uDE92":"1f469-1f3fb-1f692","\uD83D\uDC69\uD83C\uDFFC\uD83D\uDE92":"1f469-1f3fc-1f692","\uD83D\uDC69\uD83C\uDFFD\uD83D\uDE92":"1f469-1f3fd-1f692","\uD83D\uDC69\uD83C\uDFFE\uD83D\uDE92":"1f469-1f3fe-1f692","\uD83D\uDC69\uD83C\uDFFF\uD83D\uDE92":"1f469-1f3ff-1f692","\uD83D\uDC68\uD83D\uDC69\uD83D\uDC66":"1f468-1f469-1f466","\uD83D\uDC68\uD83D\uDC67\uD83D\uDC67":"1f468-1f467-1f467","\uD83D\uDC68\uD83C\uDFFB\uD83C\uDF3E":"1f468-1f3fb-1f33e","\uD83D\uDC68\uD83C\uDFFB\uD83C\uDF73":"1f468-1f3fb-1f373","\uD83D\uDC68\uD83C\uDFFB\uD83C\uDF93":"1f468-1f3fb-1f393","\uD83D\uDC68\uD83C\uDFFB\uD83C\uDFA4":"1f468-1f3fb-1f3a4","\uD83D\uDC68\uD83C\uDFFB\uD83C\uDFEB":"1f468-1f3fb-1f3eb","\uD83D\uDC68\uD83C\uDFFB\uD83C\uDFED":"1f468-1f3fb-1f3ed","\uD83D\uDC68\uD83C\uDFFB\uD83D\uDCBB":"1f468-1f3fb-1f4bb","\uD83D\uDC68\uD83C\uDFFB\uD83D\uDCBC":"1f468-1f3fb-1f4bc","\uD83D\uDC68\uD83C\uDFFB\uD83D\uDD27":"1f468-1f3fb-1f527","\uD83D\uDC68\uD83C\uDFFB\uD83D\uDD2C":"1f468-1f3fb-1f52c","\uD83D\uDC68\uD83C\uDFFC\uD83C\uDF3E":"1f468-1f3fc-1f33e","\uD83D\uDC68\uD83C\uDFFC\uD83C\uDF73":"1f468-1f3fc-1f373","\uD83D\uDC68\uD83C\uDFFC\uD83C\uDF93":"1f468-1f3fc-1f393","\uD83D\uDC68\uD83C\uDFFC\uD83C\uDFA4":"1f468-1f3fc-1f3a4","\uD83D\uDC68\uD83C\uDFFC\uD83C\uDFEB":"1f468-1f3fc-1f3eb","\uD83D\uDC68\uD83C\uDFFC\uD83C\uDFED":"1f468-1f3fc-1f3ed","\uD83D\uDC68\uD83C\uDFFC\uD83D\uDCBB":"1f468-1f3fc-1f4bb","\uD83D\uDC68\uD83C\uDFFC\uD83D\uDCBC":"1f468-1f3fc-1f4bc","\uD83D\uDC68\uD83C\uDFFC\uD83D\uDD27":"1f468-1f3fc-1f527","\uD83D\uDC68\uD83C\uDFFC\uD83D\uDD2C":"1f468-1f3fc-1f52c","\uD83D\uDC68\uD83C\uDFFD\uD83C\uDF3E":"1f468-1f3fd-1f33e","\uD83D\uDC68\uD83C\uDFFD\uD83C\uDF73":"1f468-1f3fd-1f373","\uD83D\uDC68\uD83C\uDFFD\uD83C\uDF93":"1f468-1f3fd-1f393","\uD83D\uDC68\uD83C\uDFFD\uD83C\uDFA4":"1f468-1f3fd-1f3a4","\uD83D\uDC68\uD83C\uDFFD\uD83C\uDFEB":"1f468-1f3fd-1f3eb","\uD83D\uDC68\uD83C\uDFFD\uD83C\uDFED":"1f468-1f3fd-1f3ed","\uD83D\uDC68\uD83C\uDFFD\uD83D\uDCBB":"1f468-1f3fd-1f4bb","\uD83D\uDC68\uD83C\uDFFD\uD83D\uDCBC":"1f468-1f3fd-1f4bc","\uD83D\uDC68\uD83C\uDFFD\uD83D\uDD27":"1f468-1f3fd-1f527","\uD83D\uDC68\uD83C\uDFFD\uD83D\uDD2C":"1f468-1f3fd-1f52c","\uD83D\uDC68\uD83C\uDFFE\uD83C\uDF3E":"1f468-1f3fe-1f33e","\uD83D\uDC68\uD83C\uDFFE\uD83C\uDF73":"1f468-1f3fe-1f373","\uD83D\uDC68\uD83C\uDFFE\uD83C\uDF93":"1f468-1f3fe-1f393","\uD83D\uDC68\uD83C\uDFFE\uD83C\uDFA4":"1f468-1f3fe-1f3a4","\uD83D\uDC68\uD83C\uDFFE\uD83C\uDFEB":"1f468-1f3fe-1f3eb","\uD83D\uDC68\uD83C\uDFFE\uD83C\uDFED":"1f468-1f3fe-1f3ed","\uD83D\uDC68\uD83C\uDFFE\uD83D\uDCBB":"1f468-1f3fe-1f4bb","\uD83D\uDC68\uD83C\uDFFE\uD83D\uDCBC":"1f468-1f3fe-1f4bc","\uD83D\uDC68\uD83C\uDFFE\uD83D\uDD27":"1f468-1f3fe-1f527","\uD83D\uDC68\uD83C\uDFFE\uD83D\uDD2C":"1f468-1f3fe-1f52c","\uD83D\uDC68\uD83C\uDFFF\uD83C\uDF3E":"1f468-1f3ff-1f33e","\uD83D\uDC68\uD83C\uDFFF\uD83C\uDF73":"1f468-1f3ff-1f373","\uD83D\uDC68\uD83C\uDFFF\uD83C\uDF93":"1f468-1f3ff-1f393","\uD83D\uDC68\uD83C\uDFFF\uD83C\uDFA4":"1f468-1f3ff-1f3a4","\uD83D\uDC68\uD83C\uDFFF\uD83C\uDFEB":"1f468-1f3ff-1f3eb","\uD83D\uDC68\uD83C\uDFFF\uD83C\uDFED":"1f468-1f3ff-1f3ed","\uD83D\uDC68\uD83C\uDFFF\uD83D\uDCBB":"1f468-1f3ff-1f4bb","\uD83D\uDC68\uD83C\uDFFF\uD83D\uDCBC":"1f468-1f3ff-1f4bc","\uD83D\uDC68\uD83C\uDFFF\uD83D\uDD27":"1f468-1f3ff-1f527","\uD83D\uDC68\uD83C\uDFFF\uD83D\uDD2C":"1f468-1f3ff-1f52c","\uD83D\uDC69\uD83C\uDFFB\uD83C\uDF3E":"1f469-1f3fb-1f33e","\uD83D\uDC69\uD83C\uDFFB\uD83C\uDF73":"1f469-1f3fb-1f373","\uD83D\uDC69\uD83C\uDFFB\uD83C\uDF93":"1f469-1f3fb-1f393","\uD83D\uDC69\uD83C\uDFFB\uD83C\uDFA4":"1f469-1f3fb-1f3a4","\uD83D\uDC69\uD83C\uDFFB\uD83C\uDFEB":"1f469-1f3fb-1f3eb","\uD83D\uDC69\uD83C\uDFFB\uD83C\uDFED":"1f469-1f3fb-1f3ed","\uD83D\uDC69\uD83C\uDFFB\uD83D\uDCBB":"1f469-1f3fb-1f4bb","\uD83D\uDC69\uD83C\uDFFB\uD83D\uDCBC":"1f469-1f3fb-1f4bc","\uD83D\uDC69\uD83C\uDFFB\uD83D\uDD27":"1f469-1f3fb-1f527","\uD83D\uDC69\uD83C\uDFFB\uD83D\uDD2C":"1f469-1f3fb-1f52c","\uD83D\uDC69\uD83C\uDFFC\uD83C\uDF3E":"1f469-1f3fc-1f33e","\uD83D\uDC69\uD83C\uDFFC\uD83C\uDF73":"1f469-1f3fc-1f373","\uD83D\uDC69\uD83C\uDFFC\uD83C\uDF93":"1f469-1f3fc-1f393","\uD83D\uDC69\uD83C\uDFFC\uD83C\uDFA4":"1f469-1f3fc-1f3a4","\uD83D\uDC69\uD83C\uDFFC\uD83C\uDFEB":"1f469-1f3fc-1f3eb","\uD83D\uDC69\uD83C\uDFFC\uD83C\uDFED":"1f469-1f3fc-1f3ed","\uD83D\uDC69\uD83C\uDFFC\uD83D\uDCBB":"1f469-1f3fc-1f4bb","\uD83D\uDC69\uD83C\uDFFC\uD83D\uDCBC":"1f469-1f3fc-1f4bc","\uD83D\uDC69\uD83C\uDFFC\uD83D\uDD27":"1f469-1f3fc-1f527","\uD83D\uDC69\uD83C\uDFFC\uD83D\uDD2C":"1f469-1f3fc-1f52c","\uD83D\uDC69\uD83C\uDFFD\uD83C\uDF3E":"1f469-1f3fd-1f33e","\uD83D\uDC69\uD83C\uDFFD\uD83C\uDF73":"1f469-1f3fd-1f373","\uD83D\uDC69\uD83C\uDFFD\uD83C\uDF93":"1f469-1f3fd-1f393","\uD83D\uDC69\uD83C\uDFFD\uD83C\uDFA4":"1f469-1f3fd-1f3a4","\uD83D\uDC69\uD83C\uDFFD\uD83C\uDFEB":"1f469-1f3fd-1f3eb","\uD83D\uDC69\uD83C\uDFFD\uD83C\uDFED":"1f469-1f3fd-1f3ed","\uD83D\uDC69\uD83C\uDFFD\uD83D\uDCBB":"1f469-1f3fd-1f4bb","\uD83D\uDC69\uD83C\uDFFD\uD83D\uDCBC":"1f469-1f3fd-1f4bc","\uD83D\uDC69\uD83C\uDFFD\uD83D\uDD27":"1f469-1f3fd-1f527","\uD83D\uDC69\uD83C\uDFFD\uD83D\uDD2C":"1f469-1f3fd-1f52c","\uD83D\uDC69\uD83C\uDFFE\uD83C\uDF3E":"1f469-1f3fe-1f33e","\uD83D\uDC69\uD83C\uDFFE\uD83C\uDF73":"1f469-1f3fe-1f373","\uD83D\uDC69\uD83C\uDFFE\uD83C\uDF93":"1f469-1f3fe-1f393","\uD83D\uDC69\uD83C\uDFFE\uD83C\uDFA4":"1f469-1f3fe-1f3a4","\uD83D\uDC69\uD83C\uDFFE\uD83C\uDFEB":"1f469-1f3fe-1f3eb","\uD83D\uDC69\uD83C\uDFFE\uD83C\uDFED":"1f469-1f3fe-1f3ed","\uD83D\uDC69\uD83C\uDFFE\uD83D\uDCBB":"1f469-1f3fe-1f4bb","\uD83D\uDC69\uD83C\uDFFE\uD83D\uDCBC":"1f469-1f3fe-1f4bc","\uD83D\uDC69\uD83C\uDFFE\uD83D\uDD27":"1f469-1f3fe-1f527","\uD83D\uDC69\uD83C\uDFFE\uD83D\uDD2C":"1f469-1f3fe-1f52c","\uD83D\uDC69\uD83C\uDFFF\uD83C\uDF3E":"1f469-1f3ff-1f33e","\uD83D\uDC69\uD83C\uDFFF\uD83C\uDF73":"1f469-1f3ff-1f373","\uD83D\uDC69\uD83C\uDFFF\uD83C\uDF93":"1f469-1f3ff-1f393","\uD83D\uDC69\uD83C\uDFFF\uD83C\uDFA4":"1f469-1f3ff-1f3a4","\uD83D\uDC69\uD83C\uDFFF\uD83C\uDFEB":"1f469-1f3ff-1f3eb","\uD83D\uDC69\uD83C\uDFFF\uD83C\uDFED":"1f469-1f3ff-1f3ed","\uD83D\uDC69\uD83C\uDFFF\uD83D\uDCBB":"1f469-1f3ff-1f4bb","\uD83D\uDC69\uD83C\uDFFF\uD83D\uDCBC":"1f469-1f3ff-1f4bc","\uD83D\uDC69\uD83C\uDFFF\uD83D\uDD27":"1f469-1f3ff-1f527","\uD83D\uDC69\uD83C\uDFFF\uD83D\uDD2C":"1f469-1f3ff-1f52c","\uD83D\uDC68\uD83C\uDFFB\uD83E\uDDB0":"1f468-1f3fb-1f9b0","\uD83D\uDC68\uD83C\uDFFB\uD83E\uDDB1":"1f468-1f3fb-1f9b1","\uD83D\uDC68\uD83C\uDFFB\uD83E\uDDB2":"1f468-1f3fb-1f9b2","\uD83D\uDC68\uD83C\uDFFB\uD83E\uDDB3":"1f468-1f3fb-1f9b3","\uD83D\uDC68\uD83C\uDFFC\uD83E\uDDB0":"1f468-1f3fc-1f9b0","\uD83D\uDC68\uD83C\uDFFC\uD83E\uDDB1":"1f468-1f3fc-1f9b1","\uD83D\uDC68\uD83C\uDFFC\uD83E\uDDB2":"1f468-1f3fc-1f9b2","\uD83D\uDC68\uD83C\uDFFC\uD83E\uDDB3":"1f468-1f3fc-1f9b3","\uD83D\uDC68\uD83C\uDFFD\uD83E\uDDB0":"1f468-1f3fd-1f9b0","\uD83D\uDC68\uD83C\uDFFD\uD83E\uDDB1":"1f468-1f3fd-1f9b1","\uD83D\uDC68\uD83C\uDFFD\uD83E\uDDB2":"1f468-1f3fd-1f9b2","\uD83D\uDC68\uD83C\uDFFD\uD83E\uDDB3":"1f468-1f3fd-1f9b3","\uD83D\uDC68\uD83C\uDFFE\uD83E\uDDB0":"1f468-1f3fe-1f9b0","\uD83D\uDC68\uD83C\uDFFE\uD83E\uDDB1":"1f468-1f3fe-1f9b1","\uD83D\uDC68\uD83C\uDFFE\uD83E\uDDB2":"1f468-1f3fe-1f9b2","\uD83D\uDC68\uD83C\uDFFE\uD83E\uDDB3":"1f468-1f3fe-1f9b3","\uD83D\uDC68\uD83C\uDFFF\uD83E\uDDB0":"1f468-1f3ff-1f9b0","\uD83D\uDC68\uD83C\uDFFF\uD83E\uDDB1":"1f468-1f3ff-1f9b1","\uD83D\uDC68\uD83C\uDFFF\uD83E\uDDB2":"1f468-1f3ff-1f9b2","\uD83D\uDC68\uD83C\uDFFF\uD83E\uDDB3":"1f468-1f3ff-1f9b3","\uD83D\uDC69\uD83C\uDFFB\uD83E\uDDB0":"1f469-1f3fb-1f9b0","\uD83D\uDC69\uD83C\uDFFB\uD83E\uDDB1":"1f469-1f3fb-1f9b1","\uD83D\uDC69\uD83C\uDFFB\uD83E\uDDB2":"1f469-1f3fb-1f9b2","\uD83D\uDC69\uD83C\uDFFB\uD83E\uDDB3":"1f469-1f3fb-1f9b3","\uD83D\uDC69\uD83C\uDFFC\uD83E\uDDB0":"1f469-1f3fc-1f9b0","\uD83D\uDC69\uD83C\uDFFC\uD83E\uDDB1":"1f469-1f3fc-1f9b1","\uD83D\uDC69\uD83C\uDFFC\uD83E\uDDB2":"1f469-1f3fc-1f9b2","\uD83D\uDC69\uD83C\uDFFC\uD83E\uDDB3":"1f469-1f3fc-1f9b3","\uD83D\uDC69\uD83C\uDFFD\uD83E\uDDB0":"1f469-1f3fd-1f9b0","\uD83D\uDC69\uD83C\uDFFD\uD83E\uDDB1":"1f469-1f3fd-1f9b1","\uD83D\uDC69\uD83C\uDFFD\uD83E\uDDB2":"1f469-1f3fd-1f9b2","\uD83D\uDC69\uD83C\uDFFD\uD83E\uDDB3":"1f469-1f3fd-1f9b3","\uD83D\uDC69\uD83C\uDFFE\uD83E\uDDB0":"1f469-1f3fe-1f9b0","\uD83D\uDC69\uD83C\uDFFE\uD83E\uDDB1":"1f469-1f3fe-1f9b1","\uD83D\uDC69\uD83C\uDFFE\uD83E\uDDB2":"1f469-1f3fe-1f9b2","\uD83D\uDC69\uD83C\uDFFE\uD83E\uDDB3":"1f469-1f3fe-1f9b3","\uD83D\uDC69\uD83C\uDFFF\uD83E\uDDB0":"1f469-1f3ff-1f9b0","\uD83D\uDC69\uD83C\uDFFF\uD83E\uDDB1":"1f469-1f3ff-1f9b1","\uD83D\uDC69\uD83C\uDFFF\uD83E\uDDB2":"1f469-1f3ff-1f9b2","\uD83D\uDC69\uD83C\uDFFF\uD83E\uDDB3":"1f469-1f3ff-1f9b3","\uD83D\uDC41\u200D\uD83D\uDDE8":"1f441-1f5e8","\uD83D\uDC68\u200D\uD83D\uDCBB":"1f468-1f4bb","\uD83D\uDC69\u200D\uD83D\uDCBB":"1f469-1f4bb","\uD83D\uDC68\u200D\uD83C\uDFEB":"1f468-1f3eb","\uD83D\uDC69\u200D\uD83C\uDFEB":"1f469-1f3eb","\uD83D\uDC68\u200D\uD83C\uDF93":"1f468-1f393","\uD83D\uDC69\u200D\uD83C\uDF93":"1f469-1f393","\uD83D\uDC68\u200D\uD83C\uDFA4":"1f468-1f3a4","\uD83D\uDC69\u200D\uD83C\uDFA4":"1f469-1f3a4","\uD83D\uDC68\u200D\uD83D\uDD2C":"1f468-1f52c","\uD83D\uDC69\u200D\uD83D\uDD2C":"1f469-1f52c","\uD83D\uDC68\u200D\uD83D\uDCBC":"1f468-1f4bc","\uD83D\uDC69\u200D\uD83D\uDCBC":"1f469-1f4bc","\uD83D\uDC68\u200D\uD83D\uDD27":"1f468-1f527","\uD83D\uDC69\u200D\uD83D\uDD27":"1f469-1f527","\uD83D\uDC68\u200D\uD83C\uDFED":"1f468-1f3ed","\uD83D\uDC69\u200D\uD83C\uDFED":"1f469-1f3ed","\uD83D\uDC68\u200D\uD83C\uDF73":"1f468-1f373","\uD83D\uDC69\u200D\uD83C\uDF73":"1f469-1f373","\uD83D\uDC68\u200D\uD83C\uDF3E":"1f468-1f33e","\uD83D\uDC69\u200D\uD83C\uDF3E":"1f469-1f33e","\uD83D\uDC68\u200D\uD83D\uDC66":"1f468-1f466","\uD83D\uDC68\u200D\uD83D\uDC67":"1f468-1f467","\uD83D\uDC69\u200D\uD83D\uDC66":"1f469-1f466","\uD83D\uDC69\u200D\uD83D\uDC67":"1f469-1f467","\uD83D\uDC68\u200D\uD83C\uDFA8":"1f468-1f3a8","\uD83D\uDC69\u200D\uD83C\uDFA8":"1f469-1f3a8","\uD83D\uDC68\u200D\uD83D\uDE80":"1f468-1f680","\uD83D\uDC69\u200D\uD83D\uDE80":"1f469-1f680","\uD83D\uDC68\u200D\uD83D\uDE92":"1f468-1f692","\uD83D\uDC69\u200D\uD83D\uDE92":"1f469-1f692","\uD83C\uDFCB\uFE0F\uD83C\uDFFB":"1f3cb-1f3fb","\uD83C\uDFCB\uFE0F\uD83C\uDFFC":"1f3cb-1f3fc","\uD83C\uDFCB\uFE0F\uD83C\uDFFD":"1f3cb-1f3fd","\uD83C\uDFCB\uFE0F\uD83C\uDFFE":"1f3cb-1f3fe","\uD83C\uDFCB\uFE0F\uD83C\uDFFF":"1f3cb-1f3ff","\uD83C\uDFCC\uFE0F\uD83C\uDFFB":"1f3cc-1f3fb","\uD83C\uDFCC\uFE0F\uD83C\uDFFC":"1f3cc-1f3fc","\uD83C\uDFCC\uFE0F\uD83C\uDFFD":"1f3cc-1f3fd","\uD83C\uDFCC\uFE0F\uD83C\uDFFE":"1f3cc-1f3fe","\uD83C\uDFCC\uFE0F\uD83C\uDFFF":"1f3cc-1f3ff","\uD83D\uDD74\uFE0F\uD83C\uDFFB":"1f574-1f3fb","\uD83D\uDD74\uFE0F\uD83C\uDFFC":"1f574-1f3fc","\uD83D\uDD74\uFE0F\uD83C\uDFFD":"1f574-1f3fd","\uD83D\uDD74\uFE0F\uD83C\uDFFE":"1f574-1f3fe","\uD83D\uDD74\uFE0F\uD83C\uDFFF":"1f574-1f3ff","\uD83D\uDD75\uFE0F\uD83C\uDFFB":"1f575-1f3fb","\uD83D\uDD75\uFE0F\uD83C\uDFFC":"1f575-1f3fc","\uD83D\uDD75\uFE0F\uD83C\uDFFD":"1f575-1f3fd","\uD83D\uDD75\uFE0F\uD83C\uDFFE":"1f575-1f3fe","\uD83D\uDD75\uFE0F\uD83C\uDFFF":"1f575-1f3ff","\uD83D\uDD90\uFE0F\uD83C\uDFFB":"1f590-1f3fb","\uD83D\uDD90\uFE0F\uD83C\uDFFC":"1f590-1f3fc","\uD83D\uDD90\uFE0F\uD83C\uDFFD":"1f590-1f3fd","\uD83D\uDD90\uFE0F\uD83C\uDFFE":"1f590-1f3fe","\uD83D\uDD90\uFE0F\uD83C\uDFFF":"1f590-1f3ff","\uD83C\uDFF3\u200D\uD83C\uDF08":"1f3f3-1f308","\uD83C\uDFF3\uFE0F\uD83C\uDF08":"1f3f3-1f308","\uD83D\uDC68\u200D\uD83E\uDDB0":"1f468-1f9b0","\uD83D\uDC68\u200D\uD83E\uDDB1":"1f468-1f9b1","\uD83D\uDC68\u200D\uD83E\uDDB2":"1f468-1f9b2","\uD83D\uDC68\u200D\uD83E\uDDB3":"1f468-1f9b3","\uD83D\uDC69\u200D\uD83E\uDDB0":"1f469-1f9b0","\uD83D\uDC69\u200D\uD83E\uDDB1":"1f469-1f9b1","\uD83D\uDC69\u200D\uD83E\uDDB2":"1f469-1f9b2","\uD83D\uDC69\u200D\uD83E\uDDB3":"1f469-1f9b3","\uD83D\uDC6F\u200D\u2642":"1f46f-2642","\uD83D\uDC6F\u200D\u2640":"1f46f-2640","\uD83E\uDD3C\u200D\u2642":"1f93c-2642","\uD83E\uDD3C\u200D\u2640":"1f93c-2640","\uD83E\uDD39\u200D\u2642":"1f939-2642","\uD83E\uDD39\u200D\u2640":"1f939-2640","\uD83E\uDD3E\u200D\u2642":"1f93e-2642","\uD83E\uDD3E\u200D\u2640":"1f93e-2640","\uD83E\uDD3D\u200D\u2642":"1f93d-2642","\uD83E\uDD3D\u200D\u2640":"1f93d-2640","\uD83E\uDD38\u200D\u2642":"1f938-2642","\uD83E\uDD38\u200D\u2640":"1f938-2640","\uD83D\uDEB6\u200D\u2642":"1f6b6-2642","\uD83D\uDEB6\u200D\u2640":"1f6b6-2640","\uD83D\uDEB5\u200D\u2642":"1f6b5-2642","\uD83D\uDEB5\u200D\u2640":"1f6b5-2640","\uD83D\uDEB4\u200D\u2642":"1f6b4-2642","\uD83D\uDEB4\u200D\u2640":"1f6b4-2640","\uD83D\uDEA3\u200D\u2642":"1f6a3-2642","\uD83D\uDEA3\u200D\u2640":"1f6a3-2640","\uD83C\uDFCA\u200D\u2642":"1f3ca-2642","\uD83C\uDFCA\u200D\u2640":"1f3ca-2640","\uD83C\uDFC4\u200D\u2642":"1f3c4-2642","\uD83C\uDFC4\u200D\u2640":"1f3c4-2640","\uD83C\uDFC3\u200D\u2642":"1f3c3-2642","\uD83C\uDFC3\u200D\u2640":"1f3c3-2640","\uD83E\uDD37\u200D\u2642":"1f937-2642","\uD83E\uDD37\u200D\u2640":"1f937-2640","\uD83E\uDD26\u200D\u2642":"1f926-2642","\uD83E\uDD26\u200D\u2640":"1f926-2640","\uD83D\uDE4E\u200D\u2642":"1f64e-2642","\uD83D\uDE4E\u200D\u2640":"1f64e-2640","\uD83D\uDE4D\u200D\u2642":"1f64d-2642","\uD83D\uDE4D\u200D\u2640":"1f64d-2640","\uD83D\uDE4B\u200D\u2642":"1f64b-2642","\uD83D\uDE4B\u200D\u2640":"1f64b-2640","\uD83D\uDE47\u200D\u2642":"1f647-2642","\uD83D\uDE47\u200D\u2640":"1f647-2640","\uD83D\uDE46\u200D\u2642":"1f646-2642","\uD83D\uDE46\u200D\u2640":"1f646-2640","\uD83D\uDE45\u200D\u2642":"1f645-2642","\uD83D\uDE45\u200D\u2640":"1f645-2640","\uD83D\uDC87\u200D\u2642":"1f487-2642","\uD83D\uDC87\u200D\u2640":"1f487-2640","\uD83D\uDC86\u200D\u2642":"1f486-2642","\uD83D\uDC86\u200D\u2640":"1f486-2640","\uD83D\uDC81\u200D\u2642":"1f481-2642","\uD83D\uDC81\u200D\u2640":"1f481-2640","\uD83D\uDC71\u200D\u2642":"1f471-2642","\uD83D\uDC71\u200D\u2640":"1f471-2640","\uD83D\uDC73\u200D\u2642":"1f473-2642","\uD83D\uDC73\u200D\u2640":"1f473-2640","\uD83D\uDC82\u200D\u2642":"1f482-2642","\uD83D\uDC82\u200D\u2640":"1f482-2640","\uD83D\uDC77\u200D\u2642":"1f477-2642","\uD83D\uDC77\u200D\u2640":"1f477-2640","\uD83D\uDC6E\u200D\u2642":"1f46e-2642","\uD83D\uDC6E\u200D\u2640":"1f46e-2640","\uD83D\uDC68\u200D\u2695":"1f468-2695","\uD83D\uDC69\u200D\u2695":"1f469-2695","\uD83D\uDC68\u200D\u2696":"1f468-2696","\uD83D\uDC69\u200D\u2696":"1f469-2696","\uD83D\uDC68\u200D\u2708":"1f468-2708","\uD83D\uDC69\u200D\u2708":"1f469-2708","\u261D\uFE0F\uD83C\uDFFB":"261d-1f3fb","\u261D\uFE0F\uD83C\uDFFC":"261d-1f3fc","\u261D\uFE0F\uD83C\uDFFD":"261d-1f3fd","\u261D\uFE0F\uD83C\uDFFE":"261d-1f3fe","\u261D\uFE0F\uD83C\uDFFF":"261d-1f3ff","\u26F9\uFE0F\uD83C\uDFFB":"26f9-1f3fb","\u26F9\uFE0F\uD83C\uDFFC":"26f9-1f3fc","\u26F9\uFE0F\uD83C\uDFFD":"26f9-1f3fd","\u26F9\uFE0F\uD83C\uDFFE":"26f9-1f3fe","\u26F9\uFE0F\uD83C\uDFFF":"26f9-1f3ff","\u270C\uFE0F\uD83C\uDFFB":"270c-1f3fb","\u270C\uFE0F\uD83C\uDFFC":"270c-1f3fc","\u270C\uFE0F\uD83C\uDFFD":"270c-1f3fd","\u270C\uFE0F\uD83C\uDFFE":"270c-1f3fe","\u270C\uFE0F\uD83C\uDFFF":"270c-1f3ff","\u270D\uFE0F\uD83C\uDFFB":"270d-1f3fb","\u270D\uFE0F\uD83C\uDFFC":"270d-1f3fc","\u270D\uFE0F\uD83C\uDFFD":"270d-1f3fd","\u270D\uFE0F\uD83C\uDFFE":"270d-1f3fe","\u270D\uFE0F\uD83C\uDFFF":"270d-1f3ff","\uD83D\uDC68\u2695\uFE0F":"1f468-2695","\uD83D\uDC68\u2696\uFE0F":"1f468-2696","\uD83D\uDC68\u2708\uFE0F":"1f468-2708","\uD83D\uDC69\u2695\uFE0F":"1f469-2695","\uD83D\uDC69\u2696\uFE0F":"1f469-2696","\uD83D\uDC69\u2708\uFE0F":"1f469-2708","\uD83D\uDC6E\u2640\uFE0F":"1f46e-2640","\uD83D\uDC6E\u2642\uFE0F":"1f46e-2642","\uD83D\uDC71\u2640\uFE0F":"1f471-2640","\uD83D\uDC71\u2642\uFE0F":"1f471-2642","\uD83D\uDC73\u2640\uFE0F":"1f473-2640","\uD83D\uDC73\u2642\uFE0F":"1f473-2642","\uD83D\uDC77\u2640\uFE0F":"1f477-2640","\uD83D\uDC77\u2642\uFE0F":"1f477-2642","\uD83D\uDC82\u2640\uFE0F":"1f482-2640","\uD83D\uDC82\u2642\uFE0F":"1f482-2642","\uD83D\uDD75\u200D\u2640":"1f575-2640","\uD83D\uDD75\u200D\u2642":"1f575-2642","\uD83C\uDFC3\u2640\uFE0F":"1f3c3-2640","\uD83C\uDFC3\u2642\uFE0F":"1f3c3-2642","\uD83C\uDFC4\u2640\uFE0F":"1f3c4-2640","\uD83C\uDFC4\u2642\uFE0F":"1f3c4-2642","\uD83C\uDFCA\u2640\uFE0F":"1f3ca-2640","\uD83C\uDFCA\u2642\uFE0F":"1f3ca-2642","\uD83C\uDFCB\u200D\u2640":"1f3cb-2640","\uD83C\uDFCB\u200D\u2642":"1f3cb-2642","\uD83C\uDFCC\u200D\u2640":"1f3cc-2640","\uD83C\uDFCC\u200D\u2642":"1f3cc-2642","\uD83D\uDC6F\u2640\uFE0F":"1f46f-2640","\uD83D\uDC6F\u2642\uFE0F":"1f46f-2642","\uD83D\uDC86\u2640\uFE0F":"1f486-2640","\uD83D\uDC86\u2642\uFE0F":"1f486-2642","\uD83D\uDC87\u2640\uFE0F":"1f487-2640","\uD83D\uDC87\u2642\uFE0F":"1f487-2642","\uD83D\uDEA3\u2640\uFE0F":"1f6a3-2640","\uD83D\uDEA3\u2642\uFE0F":"1f6a3-2642","\uD83D\uDEB4\u2640\uFE0F":"1f6b4-2640","\uD83D\uDEB4\u2642\uFE0F":"1f6b4-2642","\uD83D\uDEB5\u2640\uFE0F":"1f6b5-2640","\uD83D\uDEB5\u2642\uFE0F":"1f6b5-2642","\uD83D\uDEB6\u2640\uFE0F":"1f6b6-2640","\uD83D\uDEB6\u2642\uFE0F":"1f6b6-2642","\uD83E\uDD38\u2640\uFE0F":"1f938-2640","\uD83E\uDD38\u2642\uFE0F":"1f938-2642","\uD83E\uDD39\u2640\uFE0F":"1f939-2640","\uD83E\uDD39\u2642\uFE0F":"1f939-2642","\uD83E\uDD3C\u2640\uFE0F":"1f93c-2640","\uD83E\uDD3C\u2642\uFE0F":"1f93c-2642","\uD83E\uDD3D\u2640\uFE0F":"1f93d-2640","\uD83E\uDD3D\u2642\uFE0F":"1f93d-2642","\uD83E\uDD3E\u2640\uFE0F":"1f93e-2640","\uD83E\uDD3E\u2642\uFE0F":"1f93e-2642","\uD83D\uDC81\u2640\uFE0F":"1f481-2640","\uD83D\uDC81\u2642\uFE0F":"1f481-2642","\uD83D\uDE45\u2640\uFE0F":"1f645-2640","\uD83D\uDE45\u2642\uFE0F":"1f645-2642","\uD83D\uDE46\u2640\uFE0F":"1f646-2640","\uD83D\uDE46\u2642\uFE0F":"1f646-2642","\uD83D\uDE47\u2640\uFE0F":"1f647-2640","\uD83D\uDE47\u2642\uFE0F":"1f647-2642","\uD83D\uDE4B\u2640\uFE0F":"1f64b-2640","\uD83D\uDE4B\u2642\uFE0F":"1f64b-2642","\uD83D\uDE4D\u2640\uFE0F":"1f64d-2640","\uD83D\uDE4D\u2642\uFE0F":"1f64d-2642","\uD83D\uDE4E\u2640\uFE0F":"1f64e-2640","\uD83D\uDE4E\u2642\uFE0F":"1f64e-2642","\uD83E\uDD26\u2640\uFE0F":"1f926-2640","\uD83E\uDD26\u2642\uFE0F":"1f926-2642","\uD83E\uDD37\u2640\uFE0F":"1f937-2640","\uD83E\uDD37\u2642\uFE0F":"1f937-2642","\uD83E\uDDD9\u200D\u2640":"1f9d9-2640","\uD83E\uDDD9\u2640\uFE0F":"1f9d9-2640","\uD83E\uDDD9\u200D\u2642":"1f9d9-2642","\uD83E\uDDD9\u2642\uFE0F":"1f9d9-2642","\uD83E\uDDDA\u200D\u2640":"1f9da-2640","\uD83E\uDDDA\u2640\uFE0F":"1f9da-2640","\uD83E\uDDDA\u200D\u2642":"1f9da-2642","\uD83E\uDDDA\u2642\uFE0F":"1f9da-2642","\uD83E\uDDDB\u200D\u2640":"1f9db-2640","\uD83E\uDDDB\u2640\uFE0F":"1f9db-2640","\uD83E\uDDDB\u200D\u2642":"1f9db-2642","\uD83E\uDDDB\u2642\uFE0F":"1f9db-2642","\uD83E\uDDDC\u200D\u2640":"1f9dc-2640","\uD83E\uDDDC\u2640\uFE0F":"1f9dc-2640","\uD83E\uDDDC\u200D\u2642":"1f9dc-2642","\uD83E\uDDDC\u2642\uFE0F":"1f9dc-2642","\uD83E\uDDDD\u200D\u2640":"1f9dd-2640","\uD83E\uDDDD\u2640\uFE0F":"1f9dd-2640","\uD83E\uDDDD\u200D\u2642":"1f9dd-2642","\uD83E\uDDDD\u2642\uFE0F":"1f9dd-2642","\uD83E\uDDDE\u200D\u2640":"1f9de-2640","\uD83E\uDDDE\u2640\uFE0F":"1f9de-2640","\uD83E\uDDDE\u200D\u2642":"1f9de-2642","\uD83E\uDDDE\u2642\uFE0F":"1f9de-2642","\uD83E\uDDDF\u200D\u2640":"1f9df-2640","\uD83E\uDDDF\u2640\uFE0F":"1f9df-2640","\uD83E\uDDDF\u200D\u2642":"1f9df-2642","\uD83E\uDDDF\u2642\uFE0F":"1f9df-2642","\uD83E\uDDD6\u200D\u2640":"1f9d6-2640","\uD83E\uDDD6\u2640\uFE0F":"1f9d6-2640","\uD83E\uDDD6\u200D\u2642":"1f9d6-2642","\uD83E\uDDD6\u2642\uFE0F":"1f9d6-2642","\uD83E\uDDD7\u200D\u2640":"1f9d7-2640","\uD83E\uDDD7\u2640\uFE0F":"1f9d7-2640","\uD83E\uDDD7\u200D\u2642":"1f9d7-2642","\uD83E\uDDD7\u2642\uFE0F":"1f9d7-2642","\uD83E\uDDD8\u200D\u2640":"1f9d8-2640","\uD83E\uDDD8\u2640\uFE0F":"1f9d8-2640","\uD83E\uDDD8\u200D\u2642":"1f9d8-2642","\uD83E\uDDD8\u2642\uFE0F":"1f9d8-2642","\uD83E\uDDB8\u200D\u2640":"1f9b8-2640","\uD83E\uDDB8\u2640\uFE0F":"1f9b8-2640","\uD83E\uDDB8\u200D\u2642":"1f9b8-2642","\uD83E\uDDB8\u2642\uFE0F":"1f9b8-2642","\uD83E\uDDB9\u200D\u2640":"1f9b9-2640","\uD83E\uDDB9\u2640\uFE0F":"1f9b9-2640","\uD83E\uDDB9\u200D\u2642":"1f9b9-2642","\uD83E\uDDB9\u2642\uFE0F":"1f9b9-2642","\uD83C\uDFF4\u200D\u2620":"1f3f4-2620","\uD83C\uDFF4\u2620\uFE0F":"1f3f4-2620","#\uFE0F\u20E3":"0023-20e3","0\uFE0F\u20E3":"0030-20e3","1\uFE0F\u20E3":"0031-20e3","2\uFE0F\u20E3":"0032-20e3","3\uFE0F\u20E3":"0033-20e3","4\uFE0F\u20E3":"0034-20e3","5\uFE0F\u20E3":"0035-20e3","6\uFE0F\u20E3":"0036-20e3","7\uFE0F\u20E3":"0037-20e3","8\uFE0F\u20E3":"0038-20e3","9\uFE0F\u20E3":"0039-20e3","*\uFE0F\u20E3":"002a-20e3","\u26F9\u200D\u2640":"26f9-2640","\u26F9\u200D\u2642":"26f9-2642","\uD83C\uDDE8\uD83C\uDDF3":"1f1e8-1f1f3","\uD83C\uDDE9\uD83C\uDDEA":"1f1e9-1f1ea","\uD83C\uDDEA\uD83C\uDDF8":"1f1ea-1f1f8","\uD83C\uDDEB\uD83C\uDDF7":"1f1eb-1f1f7","\uD83C\uDDEC\uD83C\uDDE7":"1f1ec-1f1e7","\uD83C\uDDEE\uD83C\uDDF9":"1f1ee-1f1f9","\uD83C\uDDEF\uD83C\uDDF5":"1f1ef-1f1f5","\uD83C\uDDF0\uD83C\uDDF7":"1f1f0-1f1f7","\uD83C\uDDFA\uD83C\uDDF8":"1f1fa-1f1f8","\uD83C\uDDF7\uD83C\uDDFA":"1f1f7-1f1fa","\uD83E\uDD34\uD83C\uDFFB":"1f934-1f3fb","\uD83E\uDD34\uD83C\uDFFC":"1f934-1f3fc","\uD83E\uDD34\uD83C\uDFFD":"1f934-1f3fd","\uD83E\uDD34\uD83C\uDFFE":"1f934-1f3fe","\uD83E\uDD34\uD83C\uDFFF":"1f934-1f3ff","\uD83E\uDD36\uD83C\uDFFB":"1f936-1f3fb","\uD83E\uDD36\uD83C\uDFFC":"1f936-1f3fc","\uD83E\uDD36\uD83C\uDFFD":"1f936-1f3fd","\uD83E\uDD36\uD83C\uDFFE":"1f936-1f3fe","\uD83E\uDD36\uD83C\uDFFF":"1f936-1f3ff","\uD83E\uDD35\uD83C\uDFFB":"1f935-1f3fb","\uD83E\uDD35\uD83C\uDFFC":"1f935-1f3fc","\uD83E\uDD35\uD83C\uDFFD":"1f935-1f3fd","\uD83E\uDD35\uD83C\uDFFE":"1f935-1f3fe","\uD83E\uDD35\uD83C\uDFFF":"1f935-1f3ff","\uD83E\uDD37\uD83C\uDFFB":"1f937-1f3fb","\uD83E\uDD37\uD83C\uDFFC":"1f937-1f3fc","\uD83E\uDD37\uD83C\uDFFD":"1f937-1f3fd","\uD83E\uDD37\uD83C\uDFFE":"1f937-1f3fe","\uD83E\uDD37\uD83C\uDFFF":"1f937-1f3ff","\uD83E\uDD26\uD83C\uDFFB":"1f926-1f3fb","\uD83E\uDD26\uD83C\uDFFC":"1f926-1f3fc","\uD83E\uDD26\uD83C\uDFFD":"1f926-1f3fd","\uD83E\uDD26\uD83C\uDFFE":"1f926-1f3fe","\uD83E\uDD26\uD83C\uDFFF":"1f926-1f3ff","\uD83E\uDD30\uD83C\uDFFB":"1f930-1f3fb","\uD83E\uDD30\uD83C\uDFFC":"1f930-1f3fc","\uD83E\uDD30\uD83C\uDFFD":"1f930-1f3fd","\uD83E\uDD30\uD83C\uDFFE":"1f930-1f3fe","\uD83E\uDD30\uD83C\uDFFF":"1f930-1f3ff","\uD83D\uDD7A\uD83C\uDFFB":"1f57a-1f3fb","\uD83D\uDD7A\uD83C\uDFFC":"1f57a-1f3fc","\uD83D\uDD7A\uD83C\uDFFD":"1f57a-1f3fd","\uD83D\uDD7A\uD83C\uDFFE":"1f57a-1f3fe","\uD83D\uDD7A\uD83C\uDFFF":"1f57a-1f3ff","\uD83E\uDD33\uD83C\uDFFB":"1f933-1f3fb","\uD83E\uDD33\uD83C\uDFFC":"1f933-1f3fc","\uD83E\uDD33\uD83C\uDFFD":"1f933-1f3fd","\uD83E\uDD33\uD83C\uDFFE":"1f933-1f3fe","\uD83E\uDD33\uD83C\uDFFF":"1f933-1f3ff","\uD83E\uDD1E\uD83C\uDFFB":"1f91e-1f3fb","\uD83E\uDD1E\uD83C\uDFFC":"1f91e-1f3fc","\uD83E\uDD1E\uD83C\uDFFD":"1f91e-1f3fd","\uD83E\uDD1E\uD83C\uDFFE":"1f91e-1f3fe","\uD83E\uDD1E\uD83C\uDFFF":"1f91e-1f3ff","\uD83E\uDD19\uD83C\uDFFB":"1f919-1f3fb","\uD83E\uDD19\uD83C\uDFFC":"1f919-1f3fc","\uD83E\uDD19\uD83C\uDFFD":"1f919-1f3fd","\uD83C\uDDE6\uD83C\uDDEB":"1f1e6-1f1eb","\uD83C\uDDE6\uD83C\uDDF1":"1f1e6-1f1f1","\uD83C\uDDE9\uD83C\uDDFF":"1f1e9-1f1ff","\uD83C\uDDE6\uD83C\uDDE9":"1f1e6-1f1e9","\uD83C\uDDE6\uD83C\uDDF4":"1f1e6-1f1f4","\uD83C\uDDE6\uD83C\uDDEC":"1f1e6-1f1ec","\uD83C\uDDE6\uD83C\uDDF7":"1f1e6-1f1f7","\uD83C\uDDE6\uD83C\uDDF2":"1f1e6-1f1f2","\uD83C\uDDE6\uD83C\uDDFA":"1f1e6-1f1fa","\uD83C\uDDE6\uD83C\uDDF9":"1f1e6-1f1f9","\uD83C\uDDE6\uD83C\uDDFF":"1f1e6-1f1ff","\uD83C\uDDE7\uD83C\uDDF8":"1f1e7-1f1f8","\uD83C\uDDE7\uD83C\uDDED":"1f1e7-1f1ed","\uD83C\uDDE7\uD83C\uDDE9":"1f1e7-1f1e9","\uD83C\uDDE7\uD83C\uDDE7":"1f1e7-1f1e7","\uD83C\uDDE7\uD83C\uDDFE":"1f1e7-1f1fe","\uD83C\uDDE7\uD83C\uDDEA":"1f1e7-1f1ea","\uD83C\uDDE7\uD83C\uDDFF":"1f1e7-1f1ff","\uD83C\uDDE7\uD83C\uDDEF":"1f1e7-1f1ef","\uD83C\uDDE7\uD83C\uDDF9":"1f1e7-1f1f9","\uD83C\uDDE7\uD83C\uDDF4":"1f1e7-1f1f4","\uD83C\uDDE7\uD83C\uDDE6":"1f1e7-1f1e6","\uD83C\uDDE7\uD83C\uDDFC":"1f1e7-1f1fc","\uD83C\uDDE7\uD83C\uDDF7":"1f1e7-1f1f7","\uD83C\uDDE7\uD83C\uDDF3":"1f1e7-1f1f3","\uD83C\uDDE7\uD83C\uDDEC":"1f1e7-1f1ec","\uD83C\uDDE7\uD83C\uDDEB":"1f1e7-1f1eb","\uD83C\uDDE7\uD83C\uDDEE":"1f1e7-1f1ee","\uD83C\uDDF0\uD83C\uDDED":"1f1f0-1f1ed","\uD83C\uDDE8\uD83C\uDDF2":"1f1e8-1f1f2","\uD83C\uDDE8\uD83C\uDDE6":"1f1e8-1f1e6","\uD83C\uDDE8\uD83C\uDDFB":"1f1e8-1f1fb","\uD83E\uDD19\uD83C\uDFFE":"1f919-1f3fe","\uD83C\uDDE8\uD83C\uDDEB":"1f1e8-1f1eb","\uD83C\uDDF9\uD83C\uDDE9":"1f1f9-1f1e9","\uD83C\uDDE8\uD83C\uDDF1":"1f1e8-1f1f1","\uD83C\uDDE8\uD83C\uDDF4":"1f1e8-1f1f4","\uD83C\uDDF0\uD83C\uDDF2":"1f1f0-1f1f2","\uD83C\uDDE8\uD83C\uDDF7":"1f1e8-1f1f7","\uD83C\uDDE8\uD83C\uDDEE":"1f1e8-1f1ee","\uD83C\uDDED\uD83C\uDDF7":"1f1ed-1f1f7","\uD83C\uDDE8\uD83C\uDDFA":"1f1e8-1f1fa","\uD83C\uDDE8\uD83C\uDDFE":"1f1e8-1f1fe","\uD83C\uDDE8\uD83C\uDDFF":"1f1e8-1f1ff","\uD83E\uDD19\uD83C\uDFFF":"1f919-1f3ff","\uD83C\uDDE8\uD83C\uDDE9":"1f1e8-1f1e9","\uD83E\uDD1B\uD83C\uDFFB":"1f91b-1f3fb","\uD83C\uDDE9\uD83C\uDDF0":"1f1e9-1f1f0","\uD83C\uDDE9\uD83C\uDDEF":"1f1e9-1f1ef","\uD83C\uDDE9\uD83C\uDDF2":"1f1e9-1f1f2","\uD83C\uDDE9\uD83C\uDDF4":"1f1e9-1f1f4","\uD83C\uDDF9\uD83C\uDDF1":"1f1f9-1f1f1","\uD83C\uDDEA\uD83C\uDDE8":"1f1ea-1f1e8","\uD83C\uDDEA\uD83C\uDDEC":"1f1ea-1f1ec","\uD83C\uDDF8\uD83C\uDDFB":"1f1f8-1f1fb","\uD83C\uDDEC\uD83C\uDDF6":"1f1ec-1f1f6","\uD83C\uDDEA\uD83C\uDDF7":"1f1ea-1f1f7","\uD83C\uDDEA\uD83C\uDDEA":"1f1ea-1f1ea","\uD83C\uDDEA\uD83C\uDDF9":"1f1ea-1f1f9","\uD83E\uDD1B\uD83C\uDFFC":"1f91b-1f3fc","\uD83C\uDDEB\uD83C\uDDEF":"1f1eb-1f1ef","\uD83C\uDDEB\uD83C\uDDEE":"1f1eb-1f1ee","\uD83C\uDDEC\uD83C\uDDE6":"1f1ec-1f1e6","\uD83C\uDDEC\uD83C\uDDF2":"1f1ec-1f1f2","\uD83C\uDDEC\uD83C\uDDEA":"1f1ec-1f1ea","\uD83C\uDDEC\uD83C\uDDED":"1f1ec-1f1ed","\uD83C\uDDEC\uD83C\uDDF7":"1f1ec-1f1f7","\uD83C\uDDEC\uD83C\uDDE9":"1f1ec-1f1e9","\uD83C\uDDEC\uD83C\uDDF9":"1f1ec-1f1f9","\uD83C\uDDEC\uD83C\uDDF3":"1f1ec-1f1f3","\uD83C\uDDEC\uD83C\uDDFC":"1f1ec-1f1fc","\uD83C\uDDEC\uD83C\uDDFE":"1f1ec-1f1fe","\uD83C\uDDED\uD83C\uDDF9":"1f1ed-1f1f9","\uD83C\uDDED\uD83C\uDDF3":"1f1ed-1f1f3","\uD83C\uDDED\uD83C\uDDFA":"1f1ed-1f1fa","\uD83C\uDDEE\uD83C\uDDF8":"1f1ee-1f1f8","\uD83C\uDDEE\uD83C\uDDF3":"1f1ee-1f1f3","\uD83C\uDDEE\uD83C\uDDE9":"1f1ee-1f1e9","\uD83C\uDDEE\uD83C\uDDF7":"1f1ee-1f1f7","\uD83C\uDDEE\uD83C\uDDF6":"1f1ee-1f1f6","\uD83C\uDDEE\uD83C\uDDEA":"1f1ee-1f1ea","\uD83C\uDDEE\uD83C\uDDF1":"1f1ee-1f1f1","\uD83C\uDDEF\uD83C\uDDF2":"1f1ef-1f1f2","\uD83C\uDDEF\uD83C\uDDF4":"1f1ef-1f1f4","\uD83C\uDDF0\uD83C\uDDFF":"1f1f0-1f1ff","\uD83C\uDDF0\uD83C\uDDEA":"1f1f0-1f1ea","\uD83C\uDDF0\uD83C\uDDEE":"1f1f0-1f1ee","\uD83C\uDDFD\uD83C\uDDF0":"1f1fd-1f1f0","\uD83C\uDDF0\uD83C\uDDFC":"1f1f0-1f1fc","\uD83C\uDDF0\uD83C\uDDEC":"1f1f0-1f1ec","\uD83E\uDD1B\uD83C\uDFFD":"1f91b-1f3fd","\uD83C\uDDF1\uD83C\uDDE6":"1f1f1-1f1e6","\uD83C\uDDF1\uD83C\uDDFB":"1f1f1-1f1fb","\uD83C\uDDF1\uD83C\uDDE7":"1f1f1-1f1e7","\uD83C\uDDF1\uD83C\uDDF8":"1f1f1-1f1f8","\uD83C\uDDF1\uD83C\uDDF7":"1f1f1-1f1f7","\uD83C\uDDF1\uD83C\uDDFE":"1f1f1-1f1fe","\uD83C\uDDF1\uD83C\uDDEE":"1f1f1-1f1ee","\uD83C\uDDF1\uD83C\uDDF9":"1f1f1-1f1f9","\uD83C\uDDF1\uD83C\uDDFA":"1f1f1-1f1fa","\uD83C\uDDF2\uD83C\uDDF0":"1f1f2-1f1f0","\uD83C\uDDF2\uD83C\uDDEC":"1f1f2-1f1ec","\uD83C\uDDF2\uD83C\uDDFC":"1f1f2-1f1fc","\uD83C\uDDF2\uD83C\uDDFE":"1f1f2-1f1fe","\uD83C\uDDF2\uD83C\uDDFB":"1f1f2-1f1fb","\uD83C\uDDF2\uD83C\uDDF1":"1f1f2-1f1f1","\uD83C\uDDF2\uD83C\uDDF9":"1f1f2-1f1f9","\uD83C\uDDF2\uD83C\uDDED":"1f1f2-1f1ed","\uD83C\uDDF2\uD83C\uDDF7":"1f1f2-1f1f7","\uD83C\uDDF2\uD83C\uDDFA":"1f1f2-1f1fa","\uD83C\uDDF2\uD83C\uDDFD":"1f1f2-1f1fd","\uD83C\uDDEB\uD83C\uDDF2":"1f1eb-1f1f2","\uD83C\uDDF2\uD83C\uDDE9":"1f1f2-1f1e9","\uD83C\uDDF2\uD83C\uDDE8":"1f1f2-1f1e8","\uD83C\uDDF2\uD83C\uDDF3":"1f1f2-1f1f3","\uD83C\uDDF2\uD83C\uDDEA":"1f1f2-1f1ea","\uD83C\uDDF2\uD83C\uDDE6":"1f1f2-1f1e6","\uD83C\uDDF2\uD83C\uDDFF":"1f1f2-1f1ff","\uD83C\uDDF2\uD83C\uDDF2":"1f1f2-1f1f2","\uD83C\uDDF3\uD83C\uDDE6":"1f1f3-1f1e6","\uD83C\uDDF3\uD83C\uDDF7":"1f1f3-1f1f7","\uD83C\uDDF3\uD83C\uDDF5":"1f1f3-1f1f5","\uD83C\uDDF3\uD83C\uDDF1":"1f1f3-1f1f1","\uD83C\uDDF3\uD83C\uDDFF":"1f1f3-1f1ff","\uD83C\uDDF3\uD83C\uDDEE":"1f1f3-1f1ee","\uD83C\uDDF3\uD83C\uDDEA":"1f1f3-1f1ea","\uD83C\uDDF3\uD83C\uDDEC":"1f1f3-1f1ec","\uD83C\uDDF0\uD83C\uDDF5":"1f1f0-1f1f5","\uD83C\uDDF3\uD83C\uDDF4":"1f1f3-1f1f4","\uD83C\uDDF4\uD83C\uDDF2":"1f1f4-1f1f2","\uD83C\uDDF5\uD83C\uDDF0":"1f1f5-1f1f0","\uD83C\uDDF5\uD83C\uDDFC":"1f1f5-1f1fc","\uD83C\uDDF5\uD83C\uDDE6":"1f1f5-1f1e6","\uD83C\uDDF5\uD83C\uDDEC":"1f1f5-1f1ec","\uD83E\uDD1B\uD83C\uDFFE":"1f91b-1f3fe","\uD83C\uDDF5\uD83C\uDDFE":"1f1f5-1f1fe","\uD83C\uDDF5\uD83C\uDDEA":"1f1f5-1f1ea","\uD83C\uDDF5\uD83C\uDDED":"1f1f5-1f1ed","\uD83C\uDDF5\uD83C\uDDF1":"1f1f5-1f1f1","\uD83C\uDDF5\uD83C\uDDF9":"1f1f5-1f1f9","\uD83C\uDDF6\uD83C\uDDE6":"1f1f6-1f1e6","\uD83C\uDDF9\uD83C\uDDFC":"1f1f9-1f1fc","\uD83C\uDDE8\uD83C\uDDEC":"1f1e8-1f1ec","\uD83C\uDDF7\uD83C\uDDF4":"1f1f7-1f1f4","\uD83C\uDDF7\uD83C\uDDFC":"1f1f7-1f1fc","\uD83C\uDDF0\uD83C\uDDF3":"1f1f0-1f1f3","\uD83C\uDDF1\uD83C\uDDE8":"1f1f1-1f1e8","\uD83C\uDDFB\uD83C\uDDE8":"1f1fb-1f1e8","\uD83C\uDDFC\uD83C\uDDF8":"1f1fc-1f1f8","\uD83C\uDDF8\uD83C\uDDF2":"1f1f8-1f1f2","\uD83C\uDDF8\uD83C\uDDF9":"1f1f8-1f1f9","\uD83C\uDDF8\uD83C\uDDE6":"1f1f8-1f1e6","\uD83E\uDD1B\uD83C\uDFFF":"1f91b-1f3ff","\uD83C\uDDF8\uD83C\uDDF3":"1f1f8-1f1f3","\uD83C\uDDF7\uD83C\uDDF8":"1f1f7-1f1f8","\uD83C\uDDF8\uD83C\uDDE8":"1f1f8-1f1e8","\uD83C\uDDF8\uD83C\uDDF1":"1f1f8-1f1f1","\uD83C\uDDF8\uD83C\uDDEC":"1f1f8-1f1ec","\uD83C\uDDF8\uD83C\uDDF0":"1f1f8-1f1f0","\uD83C\uDDF8\uD83C\uDDEE":"1f1f8-1f1ee","\uD83C\uDDF8\uD83C\uDDE7":"1f1f8-1f1e7","\uD83C\uDDF8\uD83C\uDDF4":"1f1f8-1f1f4","\uD83C\uDDFF\uD83C\uDDE6":"1f1ff-1f1e6","\uD83C\uDDF1\uD83C\uDDF0":"1f1f1-1f1f0","\uD83C\uDDF8\uD83C\uDDE9":"1f1f8-1f1e9","\uD83C\uDDF8\uD83C\uDDF7":"1f1f8-1f1f7","\uD83C\uDDF8\uD83C\uDDFF":"1f1f8-1f1ff","\uD83C\uDDF8\uD83C\uDDEA":"1f1f8-1f1ea","\uD83C\uDDE8\uD83C\uDDED":"1f1e8-1f1ed","\uD83C\uDDF8\uD83C\uDDFE":"1f1f8-1f1fe","\uD83C\uDDF9\uD83C\uDDEF":"1f1f9-1f1ef","\uD83C\uDDF9\uD83C\uDDFF":"1f1f9-1f1ff","\uD83C\uDDF9\uD83C\uDDED":"1f1f9-1f1ed","\uD83C\uDDF9\uD83C\uDDEC":"1f1f9-1f1ec","\uD83C\uDDF9\uD83C\uDDF4":"1f1f9-1f1f4","\uD83C\uDDF9\uD83C\uDDF9":"1f1f9-1f1f9","\uD83C\uDDF9\uD83C\uDDF3":"1f1f9-1f1f3","\uD83C\uDDF9\uD83C\uDDF7":"1f1f9-1f1f7","\uD83C\uDDF9\uD83C\uDDF2":"1f1f9-1f1f2","\uD83C\uDDF9\uD83C\uDDFB":"1f1f9-1f1fb","\uD83C\uDDFA\uD83C\uDDEC":"1f1fa-1f1ec","\uD83C\uDDFA\uD83C\uDDE6":"1f1fa-1f1e6","\uD83C\uDDE6\uD83C\uDDEA":"1f1e6-1f1ea","\uD83C\uDDFA\uD83C\uDDFE":"1f1fa-1f1fe","\uD83C\uDDFA\uD83C\uDDFF":"1f1fa-1f1ff","\uD83C\uDDFB\uD83C\uDDFA":"1f1fb-1f1fa","\uD83C\uDDFB\uD83C\uDDE6":"1f1fb-1f1e6","\uD83C\uDDFB\uD83C\uDDEA":"1f1fb-1f1ea","\uD83C\uDDFB\uD83C\uDDF3":"1f1fb-1f1f3","\uD83C\uDDEA\uD83C\uDDED":"1f1ea-1f1ed","\uD83E\uDD1C\uD83C\uDFFB":"1f91c-1f3fb","\uD83C\uDDFE\uD83C\uDDEA":"1f1fe-1f1ea","\uD83C\uDDFF\uD83C\uDDF2":"1f1ff-1f1f2","\uD83C\uDDFF\uD83C\uDDFC":"1f1ff-1f1fc","\uD83C\uDDF5\uD83C\uDDF7":"1f1f5-1f1f7","\uD83C\uDDF0\uD83C\uDDFE":"1f1f0-1f1fe","\uD83C\uDDE7\uD83C\uDDF2":"1f1e7-1f1f2","\uD83C\uDDF5\uD83C\uDDEB":"1f1f5-1f1eb","\uD83C\uDDF5\uD83C\uDDF8":"1f1f5-1f1f8","\uD83C\uDDF3\uD83C\uDDE8":"1f1f3-1f1e8","\uD83E\uDD1C\uD83C\uDFFC":"1f91c-1f3fc","\uD83C\uDDF8\uD83C\uDDED":"1f1f8-1f1ed","\uD83C\uDDE6\uD83C\uDDFC":"1f1e6-1f1fc","\uD83C\uDDFB\uD83C\uDDEE":"1f1fb-1f1ee","\uD83C\uDDED\uD83C\uDDF0":"1f1ed-1f1f0","\uD83C\uDDE6\uD83C\uDDE8":"1f1e6-1f1e8","\uD83C\uDDF2\uD83C\uDDF8":"1f1f2-1f1f8","\uD83C\uDDEC\uD83C\uDDFA":"1f1ec-1f1fa","\uD83C\uDDEC\uD83C\uDDF1":"1f1ec-1f1f1","\uD83C\uDDF3\uD83C\uDDFA":"1f1f3-1f1fa","\uD83C\uDDFC\uD83C\uDDEB":"1f1fc-1f1eb","\uD83C\uDDF2\uD83C\uDDF4":"1f1f2-1f1f4","\uD83E\uDD1C\uD83C\uDFFD":"1f91c-1f3fd","\uD83C\uDDEB\uD83C\uDDF4":"1f1eb-1f1f4","\uD83C\uDDEB\uD83C\uDDF0":"1f1eb-1f1f0","\uD83C\uDDEF\uD83C\uDDEA":"1f1ef-1f1ea","\uD83C\uDDE6\uD83C\uDDEE":"1f1e6-1f1ee","\uD83C\uDDEC\uD83C\uDDEE":"1f1ec-1f1ee","\uD83E\uDD1C\uD83C\uDFFE":"1f91c-1f3fe","\uD83E\uDD1C\uD83C\uDFFF":"1f91c-1f3ff","\uD83E\uDD1A\uD83C\uDFFB":"1f91a-1f3fb","\uD83E\uDD1A\uD83C\uDFFC":"1f91a-1f3fc","\uD83E\uDD1A\uD83C\uDFFD":"1f91a-1f3fd","\uD83E\uDD1A\uD83C\uDFFE":"1f91a-1f3fe","\uD83D\uDC76\uD83C\uDFFB":"1f476-1f3fb","\uD83D\uDC76\uD83C\uDFFC":"1f476-1f3fc","\uD83D\uDC76\uD83C\uDFFD":"1f476-1f3fd","\uD83D\uDC76\uD83C\uDFFE":"1f476-1f3fe","\uD83D\uDC76\uD83C\uDFFF":"1f476-1f3ff","\uD83D\uDC66\uD83C\uDFFB":"1f466-1f3fb","\uD83D\uDC66\uD83C\uDFFC":"1f466-1f3fc","\uD83D\uDC66\uD83C\uDFFD":"1f466-1f3fd","\uD83D\uDC66\uD83C\uDFFE":"1f466-1f3fe","\uD83D\uDC66\uD83C\uDFFF":"1f466-1f3ff","\uD83D\uDC67\uD83C\uDFFB":"1f467-1f3fb","\uD83D\uDC67\uD83C\uDFFC":"1f467-1f3fc","\uD83D\uDC67\uD83C\uDFFD":"1f467-1f3fd","\uD83D\uDC67\uD83C\uDFFE":"1f467-1f3fe","\uD83D\uDC67\uD83C\uDFFF":"1f467-1f3ff","\uD83D\uDC68\uD83C\uDFFB":"1f468-1f3fb","\uD83D\uDC68\uD83C\uDFFC":"1f468-1f3fc","\uD83D\uDC68\uD83C\uDFFD":"1f468-1f3fd","\uD83D\uDC68\uD83C\uDFFE":"1f468-1f3fe","\uD83D\uDC68\uD83C\uDFFF":"1f468-1f3ff","\uD83D\uDC69\uD83C\uDFFB":"1f469-1f3fb","\uD83D\uDC69\uD83C\uDFFC":"1f469-1f3fc","\uD83D\uDC69\uD83C\uDFFD":"1f469-1f3fd","\uD83D\uDC69\uD83C\uDFFE":"1f469-1f3fe","\uD83D\uDC69\uD83C\uDFFF":"1f469-1f3ff","\uD83D\uDC70\uD83C\uDFFB":"1f470-1f3fb","\uD83D\uDC70\uD83C\uDFFC":"1f470-1f3fc","\uD83E\uDD1A\uD83C\uDFFF":"1f91a-1f3ff","\uD83D\uDC70\uD83C\uDFFD":"1f470-1f3fd","\uD83D\uDC70\uD83C\uDFFE":"1f470-1f3fe","\uD83D\uDC70\uD83C\uDFFF":"1f470-1f3ff","\uD83D\uDC71\uD83C\uDFFB":"1f471-1f3fb","\uD83D\uDC71\uD83C\uDFFC":"1f471-1f3fc","\uD83D\uDC71\uD83C\uDFFD":"1f471-1f3fd","\uD83D\uDC71\uD83C\uDFFE":"1f471-1f3fe","\uD83D\uDC71\uD83C\uDFFF":"1f471-1f3ff","\uD83D\uDC72\uD83C\uDFFB":"1f472-1f3fb","\uD83D\uDC72\uD83C\uDFFC":"1f472-1f3fc","\uD83D\uDC72\uD83C\uDFFD":"1f472-1f3fd","\uD83D\uDC72\uD83C\uDFFE":"1f472-1f3fe","\uD83D\uDC72\uD83C\uDFFF":"1f472-1f3ff","\uD83D\uDC73\uD83C\uDFFB":"1f473-1f3fb","\uD83D\uDC73\uD83C\uDFFC":"1f473-1f3fc","\uD83D\uDC73\uD83C\uDFFD":"1f473-1f3fd","\uD83D\uDC73\uD83C\uDFFE":"1f473-1f3fe","\uD83D\uDC73\uD83C\uDFFF":"1f473-1f3ff","\uD83D\uDC74\uD83C\uDFFB":"1f474-1f3fb","\uD83D\uDC74\uD83C\uDFFC":"1f474-1f3fc","\uD83D\uDC74\uD83C\uDFFD":"1f474-1f3fd","\uD83D\uDC74\uD83C\uDFFE":"1f474-1f3fe","\uD83D\uDC74\uD83C\uDFFF":"1f474-1f3ff","\uD83D\uDC75\uD83C\uDFFB":"1f475-1f3fb","\uD83D\uDC75\uD83C\uDFFC":"1f475-1f3fc","\uD83D\uDC75\uD83C\uDFFD":"1f475-1f3fd","\uD83D\uDC75\uD83C\uDFFE":"1f475-1f3fe","\uD83D\uDC75\uD83C\uDFFF":"1f475-1f3ff","\uD83D\uDC6E\uD83C\uDFFB":"1f46e-1f3fb","\uD83D\uDC6E\uD83C\uDFFC":"1f46e-1f3fc","\uD83D\uDC6E\uD83C\uDFFD":"1f46e-1f3fd","\uD83D\uDC6E\uD83C\uDFFE":"1f46e-1f3fe","\uD83D\uDC6E\uD83C\uDFFF":"1f46e-1f3ff","\uD83D\uDC77\uD83C\uDFFB":"1f477-1f3fb","\uD83D\uDC77\uD83C\uDFFC":"1f477-1f3fc","\uD83D\uDC77\uD83C\uDFFD":"1f477-1f3fd","\uD83D\uDC77\uD83C\uDFFE":"1f477-1f3fe","\uD83D\uDC77\uD83C\uDFFF":"1f477-1f3ff","\uD83D\uDC78\uD83C\uDFFB":"1f478-1f3fb","\uD83D\uDC78\uD83C\uDFFC":"1f478-1f3fc","\uD83D\uDC78\uD83C\uDFFD":"1f478-1f3fd","\uD83D\uDC78\uD83C\uDFFE":"1f478-1f3fe","\uD83E\uDD38\uD83C\uDFFB":"1f938-1f3fb","\uD83D\uDC78\uD83C\uDFFF":"1f478-1f3ff","\uD83D\uDC82\uD83C\uDFFB":"1f482-1f3fb","\uD83D\uDC82\uD83C\uDFFC":"1f482-1f3fc","\uD83E\uDD38\uD83C\uDFFC":"1f938-1f3fc","\uD83D\uDC82\uD83C\uDFFD":"1f482-1f3fd","\uD83D\uDC82\uD83C\uDFFE":"1f482-1f3fe","\uD83D\uDC82\uD83C\uDFFF":"1f482-1f3ff","\uD83E\uDD38\uD83C\uDFFD":"1f938-1f3fd","\uD83D\uDC7C\uD83C\uDFFB":"1f47c-1f3fb","\uD83D\uDC7C\uD83C\uDFFC":"1f47c-1f3fc","\uD83D\uDC7C\uD83C\uDFFD":"1f47c-1f3fd","\uD83D\uDC7C\uD83C\uDFFE":"1f47c-1f3fe","\uD83D\uDC7C\uD83C\uDFFF":"1f47c-1f3ff","\uD83D\uDE47\uD83C\uDFFB":"1f647-1f3fb","\uD83D\uDE47\uD83C\uDFFC":"1f647-1f3fc","\uD83D\uDE47\uD83C\uDFFD":"1f647-1f3fd","\uD83D\uDE47\uD83C\uDFFE":"1f647-1f3fe","\uD83D\uDE47\uD83C\uDFFF":"1f647-1f3ff","\uD83D\uDC81\uD83C\uDFFB":"1f481-1f3fb","\uD83D\uDC81\uD83C\uDFFC":"1f481-1f3fc","\uD83D\uDC81\uD83C\uDFFD":"1f481-1f3fd","\uD83E\uDD38\uD83C\uDFFE":"1f938-1f3fe","\uD83D\uDC81\uD83C\uDFFE":"1f481-1f3fe","\uD83D\uDC81\uD83C\uDFFF":"1f481-1f3ff","\uD83D\uDE45\uD83C\uDFFB":"1f645-1f3fb","\uD83E\uDD38\uD83C\uDFFF":"1f938-1f3ff","\uD83D\uDE45\uD83C\uDFFC":"1f645-1f3fc","\uD83D\uDE45\uD83C\uDFFD":"1f645-1f3fd","\uD83D\uDE45\uD83C\uDFFE":"1f645-1f3fe","\uD83D\uDE45\uD83C\uDFFF":"1f645-1f3ff","\uD83D\uDE46\uD83C\uDFFB":"1f646-1f3fb","\uD83D\uDE46\uD83C\uDFFC":"1f646-1f3fc","\uD83D\uDE46\uD83C\uDFFD":"1f646-1f3fd","\uD83D\uDE46\uD83C\uDFFE":"1f646-1f3fe","\uD83D\uDE46\uD83C\uDFFF":"1f646-1f3ff","\uD83D\uDE4B\uD83C\uDFFB":"1f64b-1f3fb","\uD83D\uDE4B\uD83C\uDFFC":"1f64b-1f3fc","\uD83D\uDE4B\uD83C\uDFFD":"1f64b-1f3fd","\uD83D\uDE4B\uD83C\uDFFE":"1f64b-1f3fe","\uD83D\uDE4B\uD83C\uDFFF":"1f64b-1f3ff","\uD83D\uDE4E\uD83C\uDFFB":"1f64e-1f3fb","\uD83D\uDE4E\uD83C\uDFFC":"1f64e-1f3fc","\uD83D\uDE4E\uD83C\uDFFD":"1f64e-1f3fd","\uD83D\uDE4E\uD83C\uDFFE":"1f64e-1f3fe","\uD83D\uDE4E\uD83C\uDFFF":"1f64e-1f3ff","\uD83D\uDE4D\uD83C\uDFFB":"1f64d-1f3fb","\uD83D\uDE4D\uD83C\uDFFC":"1f64d-1f3fc","\uD83D\uDE4D\uD83C\uDFFD":"1f64d-1f3fd","\uD83D\uDE4D\uD83C\uDFFE":"1f64d-1f3fe","\uD83D\uDE4D\uD83C\uDFFF":"1f64d-1f3ff","\uD83D\uDC86\uD83C\uDFFB":"1f486-1f3fb","\uD83D\uDC86\uD83C\uDFFC":"1f486-1f3fc","\uD83D\uDC86\uD83C\uDFFD":"1f486-1f3fd","\uD83D\uDC86\uD83C\uDFFE":"1f486-1f3fe","\uD83D\uDC86\uD83C\uDFFF":"1f486-1f3ff","\uD83D\uDC87\uD83C\uDFFB":"1f487-1f3fb","\uD83D\uDC87\uD83C\uDFFC":"1f487-1f3fc","\uD83D\uDC87\uD83C\uDFFD":"1f487-1f3fd","\uD83D\uDC87\uD83C\uDFFE":"1f487-1f3fe","\uD83D\uDC87\uD83C\uDFFF":"1f487-1f3ff","\uD83D\uDE4C\uD83C\uDFFB":"1f64c-1f3fb","\uD83D\uDE4C\uD83C\uDFFC":"1f64c-1f3fc","\uD83D\uDE4C\uD83C\uDFFD":"1f64c-1f3fd","\uD83D\uDE4C\uD83C\uDFFE":"1f64c-1f3fe","\uD83D\uDE4C\uD83C\uDFFF":"1f64c-1f3ff","\uD83D\uDC4F\uD83C\uDFFB":"1f44f-1f3fb","\uD83D\uDC4F\uD83C\uDFFC":"1f44f-1f3fc","\uD83D\uDC4F\uD83C\uDFFD":"1f44f-1f3fd","\uD83E\uDD3D\uD83C\uDFFB":"1f93d-1f3fb","\uD83D\uDC4F\uD83C\uDFFE":"1f44f-1f3fe","\uD83D\uDC4F\uD83C\uDFFF":"1f44f-1f3ff","\uD83E\uDD3D\uD83C\uDFFC":"1f93d-1f3fc","\uD83D\uDC42\uD83C\uDFFB":"1f442-1f3fb","\uD83D\uDC42\uD83C\uDFFC":"1f442-1f3fc","\uD83D\uDC42\uD83C\uDFFD":"1f442-1f3fd","\uD83D\uDC42\uD83C\uDFFE":"1f442-1f3fe","\uD83D\uDC42\uD83C\uDFFF":"1f442-1f3ff","\uD83D\uDC43\uD83C\uDFFB":"1f443-1f3fb","\uD83D\uDC43\uD83C\uDFFC":"1f443-1f3fc","\uD83D\uDC43\uD83C\uDFFD":"1f443-1f3fd","\uD83D\uDC43\uD83C\uDFFE":"1f443-1f3fe","\uD83D\uDC43\uD83C\uDFFF":"1f443-1f3ff","\uD83D\uDC85\uD83C\uDFFB":"1f485-1f3fb","\uD83D\uDC85\uD83C\uDFFC":"1f485-1f3fc","\uD83D\uDC85\uD83C\uDFFD":"1f485-1f3fd","\uD83D\uDC85\uD83C\uDFFE":"1f485-1f3fe","\uD83D\uDC85\uD83C\uDFFF":"1f485-1f3ff","\uD83D\uDC4B\uD83C\uDFFB":"1f44b-1f3fb","\uD83D\uDC4B\uD83C\uDFFC":"1f44b-1f3fc","\uD83D\uDC4B\uD83C\uDFFD":"1f44b-1f3fd","\uD83D\uDC4B\uD83C\uDFFE":"1f44b-1f3fe","\uD83D\uDC4B\uD83C\uDFFF":"1f44b-1f3ff","\uD83D\uDC4D\uD83C\uDFFB":"1f44d-1f3fb","\uD83D\uDC4D\uD83C\uDFFC":"1f44d-1f3fc","\uD83D\uDC4D\uD83C\uDFFD":"1f44d-1f3fd","\uD83D\uDC4D\uD83C\uDFFE":"1f44d-1f3fe","\uD83D\uDC4D\uD83C\uDFFF":"1f44d-1f3ff","\uD83D\uDC4E\uD83C\uDFFB":"1f44e-1f3fb","\uD83D\uDC4E\uD83C\uDFFC":"1f44e-1f3fc","\uD83D\uDC4E\uD83C\uDFFD":"1f44e-1f3fd","\uD83D\uDC4E\uD83C\uDFFE":"1f44e-1f3fe","\uD83D\uDC4E\uD83C\uDFFF":"1f44e-1f3ff","\uD83D\uDC46\uD83C\uDFFB":"1f446-1f3fb","\uD83D\uDC46\uD83C\uDFFC":"1f446-1f3fc","\uD83D\uDC46\uD83C\uDFFD":"1f446-1f3fd","\uD83D\uDC46\uD83C\uDFFE":"1f446-1f3fe","\uD83D\uDC46\uD83C\uDFFF":"1f446-1f3ff","\uD83D\uDC47\uD83C\uDFFB":"1f447-1f3fb","\uD83D\uDC47\uD83C\uDFFC":"1f447-1f3fc","\uD83D\uDC47\uD83C\uDFFD":"1f447-1f3fd","\uD83D\uDC47\uD83C\uDFFE":"1f447-1f3fe","\uD83D\uDC47\uD83C\uDFFF":"1f447-1f3ff","\uD83D\uDC48\uD83C\uDFFB":"1f448-1f3fb","\uD83D\uDC48\uD83C\uDFFC":"1f448-1f3fc","\uD83D\uDC48\uD83C\uDFFD":"1f448-1f3fd","\uD83D\uDC48\uD83C\uDFFE":"1f448-1f3fe","\uD83D\uDC48\uD83C\uDFFF":"1f448-1f3ff","\uD83D\uDC49\uD83C\uDFFB":"1f449-1f3fb","\uD83D\uDC49\uD83C\uDFFC":"1f449-1f3fc","\uD83D\uDC49\uD83C\uDFFD":"1f449-1f3fd","\uD83D\uDC49\uD83C\uDFFE":"1f449-1f3fe","\uD83D\uDC49\uD83C\uDFFF":"1f449-1f3ff","\uD83D\uDC4C\uD83C\uDFFB":"1f44c-1f3fb","\uD83D\uDC4C\uD83C\uDFFC":"1f44c-1f3fc","\uD83E\uDD3D\uD83C\uDFFD":"1f93d-1f3fd","\uD83D\uDC4C\uD83C\uDFFD":"1f44c-1f3fd","\uD83D\uDC4C\uD83C\uDFFE":"1f44c-1f3fe","\uD83E\uDD3D\uD83C\uDFFE":"1f93d-1f3fe","\uD83D\uDC4C\uD83C\uDFFF":"1f44c-1f3ff","\uD83D\uDC4A\uD83C\uDFFB":"1f44a-1f3fb","\uD83D\uDC4A\uD83C\uDFFC":"1f44a-1f3fc","\uD83D\uDC4A\uD83C\uDFFD":"1f44a-1f3fd","\uD83D\uDC4A\uD83C\uDFFE":"1f44a-1f3fe","\uD83D\uDC4A\uD83C\uDFFF":"1f44a-1f3ff","\uD83D\uDCAA\uD83C\uDFFB":"1f4aa-1f3fb","\uD83D\uDCAA\uD83C\uDFFC":"1f4aa-1f3fc","\uD83D\uDCAA\uD83C\uDFFD":"1f4aa-1f3fd","\uD83D\uDCAA\uD83C\uDFFE":"1f4aa-1f3fe","\uD83D\uDCAA\uD83C\uDFFF":"1f4aa-1f3ff","\uD83D\uDC50\uD83C\uDFFB":"1f450-1f3fb","\uD83D\uDC50\uD83C\uDFFC":"1f450-1f3fc","\uD83D\uDC50\uD83C\uDFFD":"1f450-1f3fd","\uD83D\uDC50\uD83C\uDFFE":"1f450-1f3fe","\uD83D\uDC50\uD83C\uDFFF":"1f450-1f3ff","\uD83D\uDE4F\uD83C\uDFFB":"1f64f-1f3fb","\uD83E\uDD3D\uD83C\uDFFF":"1f93d-1f3ff","\uD83D\uDE4F\uD83C\uDFFC":"1f64f-1f3fc","\uD83D\uDE4F\uD83C\uDFFD":"1f64f-1f3fd","\uD83E\uDD3E\uD83C\uDFFB":"1f93e-1f3fb","\uD83D\uDE4F\uD83C\uDFFE":"1f64f-1f3fe","\uD83D\uDE4F\uD83C\uDFFF":"1f64f-1f3ff","\uD83E\uDD3E\uD83C\uDFFC":"1f93e-1f3fc","\uD83C\uDFC3\uD83C\uDFFB":"1f3c3-1f3fb","\uD83C\uDFC3\uD83C\uDFFC":"1f3c3-1f3fc","\uD83C\uDFC3\uD83C\uDFFD":"1f3c3-1f3fd","\uD83C\uDFC3\uD83C\uDFFE":"1f3c3-1f3fe","\uD83E\uDD3E\uD83C\uDFFD":"1f93e-1f3fd","\uD83C\uDFC3\uD83C\uDFFF":"1f3c3-1f3ff","\uD83D\uDEB6\uD83C\uDFFB":"1f6b6-1f3fb","\uD83D\uDEB6\uD83C\uDFFC":"1f6b6-1f3fc","\uD83D\uDEB6\uD83C\uDFFD":"1f6b6-1f3fd","\uD83D\uDEB6\uD83C\uDFFE":"1f6b6-1f3fe","\uD83D\uDEB6\uD83C\uDFFF":"1f6b6-1f3ff","\uD83D\uDC83\uD83C\uDFFB":"1f483-1f3fb","\uD83E\uDD3E\uD83C\uDFFE":"1f93e-1f3fe","\uD83D\uDC83\uD83C\uDFFC":"1f483-1f3fc","\uD83D\uDC83\uD83C\uDFFD":"1f483-1f3fd","\uD83E\uDD3E\uD83C\uDFFF":"1f93e-1f3ff","\uD83D\uDC83\uD83C\uDFFE":"1f483-1f3fe","\uD83D\uDC83\uD83C\uDFFF":"1f483-1f3ff","\uD83E\uDD39\uD83C\uDFFB":"1f939-1f3fb","\uD83D\uDEA3\uD83C\uDFFB":"1f6a3-1f3fb","\uD83D\uDEA3\uD83C\uDFFC":"1f6a3-1f3fc","\uD83D\uDEA3\uD83C\uDFFD":"1f6a3-1f3fd","\uD83D\uDEA3\uD83C\uDFFE":"1f6a3-1f3fe","\uD83D\uDEA3\uD83C\uDFFF":"1f6a3-1f3ff","\uD83C\uDFCA\uD83C\uDFFB":"1f3ca-1f3fb","\uD83C\uDFCA\uD83C\uDFFC":"1f3ca-1f3fc","\uD83E\uDD39\uD83C\uDFFC":"1f939-1f3fc","\uD83C\uDFCA\uD83C\uDFFD":"1f3ca-1f3fd","\uD83C\uDFCA\uD83C\uDFFE":"1f3ca-1f3fe","\uD83C\uDFCA\uD83C\uDFFF":"1f3ca-1f3ff","\uD83E\uDD39\uD83C\uDFFD":"1f939-1f3fd","\uD83C\uDFC4\uD83C\uDFFB":"1f3c4-1f3fb","\uD83C\uDFC4\uD83C\uDFFC":"1f3c4-1f3fc","\uD83C\uDFC4\uD83C\uDFFD":"1f3c4-1f3fd","\uD83C\uDFC4\uD83C\uDFFE":"1f3c4-1f3fe","\uD83C\uDFC4\uD83C\uDFFF":"1f3c4-1f3ff","\uD83D\uDEC0\uD83C\uDFFB":"1f6c0-1f3fb","\uD83D\uDEC0\uD83C\uDFFC":"1f6c0-1f3fc","\uD83E\uDD39\uD83C\uDFFE":"1f939-1f3fe","\uD83D\uDEC0\uD83C\uDFFD":"1f6c0-1f3fd","\uD83D\uDEC0\uD83C\uDFFE":"1f6c0-1f3fe","\uD83D\uDEC0\uD83C\uDFFF":"1f6c0-1f3ff","\uD83E\uDD39\uD83C\uDFFF":"1f939-1f3ff","\uD83D\uDEB4\uD83C\uDFFB":"1f6b4-1f3fb","\uD83D\uDEB4\uD83C\uDFFC":"1f6b4-1f3fc","\uD83D\uDEB4\uD83C\uDFFD":"1f6b4-1f3fd","\uD83D\uDEB4\uD83C\uDFFE":"1f6b4-1f3fe","\uD83D\uDEB4\uD83C\uDFFF":"1f6b4-1f3ff","\uD83D\uDEB5\uD83C\uDFFB":"1f6b5-1f3fb","\uD83D\uDEB5\uD83C\uDFFC":"1f6b5-1f3fc","\uD83D\uDEB5\uD83C\uDFFD":"1f6b5-1f3fd","\uD83D\uDEB5\uD83C\uDFFE":"1f6b5-1f3fe","\uD83D\uDEB5\uD83C\uDFFF":"1f6b5-1f3ff","\uD83C\uDFC7\uD83C\uDFFB":"1f3c7-1f3fb","\uD83C\uDFC7\uD83C\uDFFC":"1f3c7-1f3fc","\uD83C\uDFC7\uD83C\uDFFD":"1f3c7-1f3fd","\uD83C\uDFC7\uD83C\uDFFE":"1f3c7-1f3fe","\uD83C\uDFC7\uD83C\uDFFF":"1f3c7-1f3ff","\uD83D\uDD90\uD83C\uDFFB":"1f590-1f3fb","\uD83D\uDD90\uD83C\uDFFC":"1f590-1f3fc","\uD83D\uDD90\uD83C\uDFFD":"1f590-1f3fd","\uD83D\uDD90\uD83C\uDFFE":"1f590-1f3fe","\uD83D\uDD90\uD83C\uDFFF":"1f590-1f3ff","\uD83D\uDD95\uD83C\uDFFB":"1f595-1f3fb","\uD83D\uDD95\uD83C\uDFFC":"1f595-1f3fc","\uD83D\uDD95\uD83C\uDFFD":"1f595-1f3fd","\uD83D\uDD95\uD83C\uDFFE":"1f595-1f3fe","\uD83D\uDD95\uD83C\uDFFF":"1f595-1f3ff","\uD83D\uDD96\uD83C\uDFFB":"1f596-1f3fb","\uD83D\uDD96\uD83C\uDFFC":"1f596-1f3fc","\uD83D\uDD96\uD83C\uDFFD":"1f596-1f3fd","\uD83D\uDD96\uD83C\uDFFE":"1f596-1f3fe","\uD83D\uDD96\uD83C\uDFFF":"1f596-1f3ff","\uD83C\uDF85\uD83C\uDFFB":"1f385-1f3fb","\uD83C\uDF85\uD83C\uDFFC":"1f385-1f3fc","\uD83C\uDF85\uD83C\uDFFD":"1f385-1f3fd","\uD83C\uDF85\uD83C\uDFFE":"1f385-1f3fe","\uD83C\uDF85\uD83C\uDFFF":"1f385-1f3ff","\uD83E\uDD18\uD83C\uDFFB":"1f918-1f3fb","\uD83E\uDD18\uD83C\uDFFC":"1f918-1f3fc","\uD83E\uDD18\uD83C\uDFFD":"1f918-1f3fd","\uD83E\uDD18\uD83C\uDFFE":"1f918-1f3fe","\uD83E\uDD18\uD83C\uDFFF":"1f918-1f3ff","\uD83C\uDFCB\uD83C\uDFFB":"1f3cb-1f3fb","\uD83C\uDFCB\uD83C\uDFFC":"1f3cb-1f3fc","\uD83C\uDFCB\uD83C\uDFFD":"1f3cb-1f3fd","\uD83C\uDFCB\uD83C\uDFFE":"1f3cb-1f3fe","\uD83C\uDFCB\uD83C\uDFFF":"1f3cb-1f3ff","\uD83C\uDDE6\uD83C\uDDFD":"1f1e6-1f1fd","\uD83C\uDDF9\uD83C\uDDE6":"1f1f9-1f1e6","\uD83C\uDDEE\uD83C\uDDF4":"1f1ee-1f1f4","\uD83C\uDDE7\uD83C\uDDF6":"1f1e7-1f1f6","\uD83C\uDDE8\uD83C\uDDFD":"1f1e8-1f1fd","\uD83C\uDDE8\uD83C\uDDE8":"1f1e8-1f1e8","\uD83C\uDDEC\uD83C\uDDEC":"1f1ec-1f1ec","\uD83C\uDDEE\uD83C\uDDF2":"1f1ee-1f1f2","\uD83C\uDDFE\uD83C\uDDF9":"1f1fe-1f1f9","\uD83C\uDDF3\uD83C\uDDEB":"1f1f3-1f1eb","\uD83C\uDDF5\uD83C\uDDF3":"1f1f5-1f1f3","\uD83C\uDDE7\uD83C\uDDF1":"1f1e7-1f1f1","\uD83C\uDDF5\uD83C\uDDF2":"1f1f5-1f1f2","\uD83C\uDDEC\uD83C\uDDF8":"1f1ec-1f1f8","\uD83C\uDDF9\uD83C\uDDF0":"1f1f9-1f1f0","\uD83C\uDDE7\uD83C\uDDFB":"1f1e7-1f1fb","\uD83C\uDDED\uD83C\uDDF2":"1f1ed-1f1f2","\uD83C\uDDF8\uD83C\uDDEF":"1f1f8-1f1ef","\uD83C\uDDFA\uD83C\uDDF2":"1f1fa-1f1f2","\uD83C\uDDEE\uD83C\uDDE8":"1f1ee-1f1e8","\uD83C\uDDEA\uD83C\uDDE6":"1f1ea-1f1e6","\uD83C\uDDE8\uD83C\uDDF5":"1f1e8-1f1f5","\uD83C\uDDE9\uD83C\uDDEC":"1f1e9-1f1ec","\uD83C\uDDE6\uD83C\uDDF8":"1f1e6-1f1f8","\uD83C\uDDE6\uD83C\uDDF6":"1f1e6-1f1f6","\uD83C\uDDFB\uD83C\uDDEC":"1f1fb-1f1ec","\uD83C\uDDE8\uD83C\uDDF0":"1f1e8-1f1f0","\uD83C\uDDE8\uD83C\uDDFC":"1f1e8-1f1fc","\uD83C\uDDEA\uD83C\uDDFA":"1f1ea-1f1fa","\uD83C\uDDEC\uD83C\uDDEB":"1f1ec-1f1eb","\uD83C\uDDF9\uD83C\uDDEB":"1f1f9-1f1eb","\uD83C\uDDEC\uD83C\uDDF5":"1f1ec-1f1f5","\uD83C\uDDF2\uD83C\uDDF6":"1f1f2-1f1f6","\uD83C\uDDF2\uD83C\uDDF5":"1f1f2-1f1f5","\uD83C\uDDF7\uD83C\uDDEA":"1f1f7-1f1ea","\uD83C\uDDF8\uD83C\uDDFD":"1f1f8-1f1fd","\uD83C\uDDF8\uD83C\uDDF8":"1f1f8-1f1f8","\uD83C\uDDF9\uD83C\uDDE8":"1f1f9-1f1e8","\uD83C\uDDF2\uD83C\uDDEB":"1f1f2-1f1eb","\uD83D\uDD75\uD83C\uDFFB":"1f575-1f3fb","\uD83D\uDD75\uD83C\uDFFC":"1f575-1f3fc","\uD83D\uDD75\uD83C\uDFFD":"1f575-1f3fd","\uD83D\uDD75\uD83C\uDFFE":"1f575-1f3fe","\uD83D\uDD75\uD83C\uDFFF":"1f575-1f3ff","\uD83C\uDFC2\uD83C\uDFFB":"1f3c2-1f3fb","\uD83D\uDC68\uD83D\uDCBB":"1f468-1f4bb","\uD83D\uDC69\uD83D\uDCBB":"1f469-1f4bb","\uD83D\uDC68\uD83C\uDFEB":"1f468-1f3eb","\uD83D\uDC69\uD83C\uDFEB":"1f469-1f3eb","\uD83D\uDC68\uD83C\uDF93":"1f468-1f393","\uD83D\uDC69\uD83C\uDF93":"1f469-1f393","\uD83D\uDC68\uD83C\uDFA4":"1f468-1f3a4","\uD83D\uDC69\uD83C\uDFA4":"1f469-1f3a4","\uD83D\uDC68\uD83D\uDD2C":"1f468-1f52c","\uD83D\uDC69\uD83D\uDD2C":"1f469-1f52c","\uD83D\uDC68\uD83D\uDCBC":"1f468-1f4bc","\uD83D\uDC69\uD83D\uDCBC":"1f469-1f4bc","\uD83D\uDC68\uD83D\uDD27":"1f468-1f527","\uD83D\uDC69\uD83D\uDD27":"1f469-1f527","\uD83D\uDC68\uD83C\uDFED":"1f468-1f3ed","\uD83D\uDC69\uD83C\uDFED":"1f469-1f3ed","\uD83D\uDC68\uD83C\uDF73":"1f468-1f373","\uD83D\uDC69\uD83C\uDF73":"1f469-1f373","\uD83D\uDC68\uD83C\uDF3E":"1f468-1f33e","\uD83D\uDC69\uD83C\uDF3E":"1f469-1f33e","\uD83D\uDD74\uD83C\uDFFB":"1f574-1f3fb","\uD83D\uDD74\uD83C\uDFFC":"1f574-1f3fc","\uD83D\uDD74\uD83C\uDFFD":"1f574-1f3fd","\uD83D\uDD74\uD83C\uDFFE":"1f574-1f3fe","\uD83D\uDD74\uD83C\uDFFF":"1f574-1f3ff","\uD83D\uDECC\uD83C\uDFFB":"1f6cc-1f3fb","\uD83D\uDECC\uD83C\uDFFC":"1f6cc-1f3fc","\uD83D\uDECC\uD83C\uDFFD":"1f6cc-1f3fd","\uD83D\uDECC\uD83C\uDFFE":"1f6cc-1f3fe","\uD83D\uDECC\uD83C\uDFFF":"1f6cc-1f3ff","\uD83D\uDC68\uD83D\uDC66":"1f468-1f466","\uD83D\uDC68\uD83D\uDC67":"1f468-1f467","\uD83D\uDC69\uD83D\uDC66":"1f469-1f466","\uD83D\uDC69\uD83D\uDC67":"1f469-1f467","\uD83D\uDC68\uD83C\uDFA8":"1f468-1f3a8","\uD83D\uDC69\uD83C\uDFA8":"1f469-1f3a8","\uD83D\uDC68\uD83D\uDE80":"1f468-1f680","\uD83D\uDC69\uD83D\uDE80":"1f469-1f680","\uD83D\uDC68\uD83D\uDE92":"1f468-1f692","\uD83D\uDC69\uD83D\uDE92":"1f469-1f692","\uD83C\uDDFA\uD83C\uDDF3":"1f1fa-1f1f3","\uD83C\uDFC2\uD83C\uDFFC":"1f3c2-1f3fc","\uD83C\uDFC2\uD83C\uDFFD":"1f3c2-1f3fd","\uD83C\uDFC2\uD83C\uDFFE":"1f3c2-1f3fe","\uD83C\uDFC2\uD83C\uDFFF":"1f3c2-1f3ff","\uD83C\uDFCC\uD83C\uDFFB":"1f3cc-1f3fb","\uD83C\uDFCC\uD83C\uDFFC":"1f3cc-1f3fc","\uD83C\uDFCC\uD83C\uDFFD":"1f3cc-1f3fd","\uD83C\uDFCC\uD83C\uDFFE":"1f3cc-1f3fe","\uD83C\uDFCC\uD83C\uDFFF":"1f3cc-1f3ff","\uD83E\uDD1F\uD83C\uDFFB":"1f91f-1f3fb","\uD83E\uDD1F\uD83C\uDFFC":"1f91f-1f3fc","\uD83E\uDD1F\uD83C\uDFFD":"1f91f-1f3fd","\uD83E\uDD1F\uD83C\uDFFE":"1f91f-1f3fe","\uD83E\uDD1F\uD83C\uDFFF":"1f91f-1f3ff","\uD83E\uDD31\uD83C\uDFFB":"1f931-1f3fb","\uD83E\uDD31\uD83C\uDFFC":"1f931-1f3fc","\uD83E\uDD31\uD83C\uDFFD":"1f931-1f3fd","\uD83E\uDD31\uD83C\uDFFE":"1f931-1f3fe","\uD83E\uDD31\uD83C\uDFFF":"1f931-1f3ff","\uD83E\uDD32\uD83C\uDFFB":"1f932-1f3fb","\uD83E\uDD32\uD83C\uDFFC":"1f932-1f3fc","\uD83E\uDD32\uD83C\uDFFD":"1f932-1f3fd","\uD83E\uDD32\uD83C\uDFFE":"1f932-1f3fe","\uD83E\uDD32\uD83C\uDFFF":"1f932-1f3ff","\uD83E\uDDD1\uD83C\uDFFB":"1f9d1-1f3fb","\uD83E\uDDD1\uD83C\uDFFC":"1f9d1-1f3fc","\uD83E\uDDD1\uD83C\uDFFD":"1f9d1-1f3fd","\uD83E\uDDD1\uD83C\uDFFE":"1f9d1-1f3fe","\uD83E\uDDD1\uD83C\uDFFF":"1f9d1-1f3ff","\uD83E\uDDD2\uD83C\uDFFB":"1f9d2-1f3fb","\uD83E\uDDD2\uD83C\uDFFC":"1f9d2-1f3fc","\uD83E\uDDD2\uD83C\uDFFD":"1f9d2-1f3fd","\uD83E\uDDD2\uD83C\uDFFE":"1f9d2-1f3fe","\uD83E\uDDD2\uD83C\uDFFF":"1f9d2-1f3ff","\uD83E\uDDD3\uD83C\uDFFB":"1f9d3-1f3fb","\uD83E\uDDD3\uD83C\uDFFC":"1f9d3-1f3fc","\uD83E\uDDD3\uD83C\uDFFD":"1f9d3-1f3fd","\uD83E\uDDD3\uD83C\uDFFE":"1f9d3-1f3fe","\uD83E\uDDD3\uD83C\uDFFF":"1f9d3-1f3ff","\uD83E\uDDD4\uD83C\uDFFB":"1f9d4-1f3fb","\uD83E\uDDD4\uD83C\uDFFC":"1f9d4-1f3fc","\uD83E\uDDD4\uD83C\uDFFD":"1f9d4-1f3fd","\uD83E\uDDD4\uD83C\uDFFE":"1f9d4-1f3fe","\uD83E\uDDD4\uD83C\uDFFF":"1f9d4-1f3ff","\uD83E\uDDD5\uD83C\uDFFB":"1f9d5-1f3fb","\uD83E\uDDD5\uD83C\uDFFC":"1f9d5-1f3fc","\uD83E\uDDD5\uD83C\uDFFD":"1f9d5-1f3fd","\uD83E\uDDD5\uD83C\uDFFE":"1f9d5-1f3fe","\uD83E\uDDD5\uD83C\uDFFF":"1f9d5-1f3ff","\uD83E\uDDD6\uD83C\uDFFB":"1f9d6-1f3fb","\uD83E\uDDD6\uD83C\uDFFC":"1f9d6-1f3fc","\uD83E\uDDD6\uD83C\uDFFD":"1f9d6-1f3fd","\uD83E\uDDD6\uD83C\uDFFE":"1f9d6-1f3fe","\uD83E\uDDD6\uD83C\uDFFF":"1f9d6-1f3ff","\uD83E\uDDD7\uD83C\uDFFB":"1f9d7-1f3fb","\uD83E\uDDD7\uD83C\uDFFC":"1f9d7-1f3fc","\uD83E\uDDD7\uD83C\uDFFD":"1f9d7-1f3fd","\uD83E\uDDD7\uD83C\uDFFE":"1f9d7-1f3fe","\uD83E\uDDD7\uD83C\uDFFF":"1f9d7-1f3ff","\uD83E\uDDD8\uD83C\uDFFB":"1f9d8-1f3fb","\uD83E\uDDD8\uD83C\uDFFC":"1f9d8-1f3fc","\uD83E\uDDD8\uD83C\uDFFD":"1f9d8-1f3fd","\uD83E\uDDD8\uD83C\uDFFE":"1f9d8-1f3fe","\uD83E\uDDD8\uD83C\uDFFF":"1f9d8-1f3ff","\uD83E\uDDD9\uD83C\uDFFB":"1f9d9-1f3fb","\uD83E\uDDD9\uD83C\uDFFC":"1f9d9-1f3fc","\uD83E\uDDD9\uD83C\uDFFD":"1f9d9-1f3fd","\uD83E\uDDD9\uD83C\uDFFE":"1f9d9-1f3fe","\uD83E\uDDD9\uD83C\uDFFF":"1f9d9-1f3ff","\uD83E\uDDDA\uD83C\uDFFB":"1f9da-1f3fb","\uD83E\uDDDA\uD83C\uDFFC":"1f9da-1f3fc","\uD83E\uDDDA\uD83C\uDFFD":"1f9da-1f3fd","\uD83E\uDDDA\uD83C\uDFFE":"1f9da-1f3fe","\uD83E\uDDDA\uD83C\uDFFF":"1f9da-1f3ff","\uD83E\uDDDB\uD83C\uDFFB":"1f9db-1f3fb","\uD83E\uDDDB\uD83C\uDFFC":"1f9db-1f3fc","\uD83E\uDDDB\uD83C\uDFFD":"1f9db-1f3fd","\uD83E\uDDDB\uD83C\uDFFE":"1f9db-1f3fe","\uD83E\uDDDB\uD83C\uDFFF":"1f9db-1f3ff","\uD83E\uDDDC\uD83C\uDFFB":"1f9dc-1f3fb","\uD83E\uDDDC\uD83C\uDFFC":"1f9dc-1f3fc","\uD83E\uDDDC\uD83C\uDFFD":"1f9dc-1f3fd","\uD83E\uDDDC\uD83C\uDFFE":"1f9dc-1f3fe","\uD83E\uDDDC\uD83C\uDFFF":"1f9dc-1f3ff","\uD83E\uDDDD\uD83C\uDFFB":"1f9dd-1f3fb","\uD83E\uDDDD\uD83C\uDFFC":"1f9dd-1f3fc","\uD83E\uDDDD\uD83C\uDFFD":"1f9dd-1f3fd","\uD83E\uDDDD\uD83C\uDFFE":"1f9dd-1f3fe","\uD83E\uDDDD\uD83C\uDFFF":"1f9dd-1f3ff","\uD83E\uDDB5\uD83C\uDFFB":"1f9b5-1f3fb","\uD83E\uDDB5\uD83C\uDFFC":"1f9b5-1f3fc","\uD83E\uDDB5\uD83C\uDFFD":"1f9b5-1f3fd","\uD83E\uDDB5\uD83C\uDFFE":"1f9b5-1f3fe","\uD83E\uDDB5\uD83C\uDFFF":"1f9b5-1f3ff","\uD83E\uDDB6\uD83C\uDFFB":"1f9b6-1f3fb","\uD83E\uDDB6\uD83C\uDFFC":"1f9b6-1f3fc","\uD83E\uDDB6\uD83C\uDFFD":"1f9b6-1f3fd","\uD83E\uDDB6\uD83C\uDFFE":"1f9b6-1f3fe","\uD83E\uDDB6\uD83C\uDFFF":"1f9b6-1f3ff","\uD83E\uDDB8\uD83C\uDFFB":"1f9b8-1f3fb","\uD83E\uDDB8\uD83C\uDFFC":"1f9b8-1f3fc","\uD83E\uDDB8\uD83C\uDFFD":"1f9b8-1f3fd","\uD83E\uDDB8\uD83C\uDFFE":"1f9b8-1f3fe","\uD83E\uDDB8\uD83C\uDFFF":"1f9b8-1f3ff","\uD83E\uDDB9\uD83C\uDFFB":"1f9b9-1f3fb","\uD83E\uDDB9\uD83C\uDFFC":"1f9b9-1f3fc","\uD83E\uDDB9\uD83C\uDFFD":"1f9b9-1f3fd","\uD83E\uDDB9\uD83C\uDFFE":"1f9b9-1f3fe","\uD83E\uDDB9\uD83C\uDFFF":"1f9b9-1f3ff","\uD83D\uDC68\uD83E\uDDB0":"1f468-1f9b0","\uD83D\uDC68\uD83E\uDDB1":"1f468-1f9b1","\uD83D\uDC68\uD83E\uDDB2":"1f468-1f9b2","\uD83D\uDC68\uD83E\uDDB3":"1f468-1f9b3","\uD83D\uDC69\uD83E\uDDB0":"1f469-1f9b0","\uD83D\uDC69\uD83E\uDDB1":"1f469-1f9b1","\uD83D\uDC69\uD83E\uDDB2":"1f469-1f9b2","\uD83D\uDC69\uD83E\uDDB3":"1f469-1f9b3","\uD83C\uDD7F\uFE0F":"1f17f","\uD83C\uDE02\uFE0F":"1f202","\uD83C\uDE37\uFE0F":"1f237","\uD83C\uDF9E\uFE0F":"1f39e","\uD83C\uDF9F\uFE0F":"1f39f","\uD83C\uDFCB\uFE0F":"1f3cb","\uD83C\uDFCC\uFE0F":"1f3cc","\uD83C\uDFCD\uFE0F":"1f3cd","\uD83C\uDFCE\uFE0F":"1f3ce","\uD83C\uDF96\uFE0F":"1f396","\uD83C\uDF97\uFE0F":"1f397","\uD83C\uDF36\uFE0F":"1f336","\uD83C\uDF27\uFE0F":"1f327","\uD83C\uDF28\uFE0F":"1f328","\uD83C\uDF29\uFE0F":"1f329","\uD83C\uDF2A\uFE0F":"1f32a","\uD83C\uDF2B\uFE0F":"1f32b","\uD83C\uDF2C\uFE0F":"1f32c","\uD83D\uDC3F\uFE0F":"1f43f","\uD83D\uDD77\uFE0F":"1f577","\uD83D\uDD78\uFE0F":"1f578","\uD83C\uDF21\uFE0F":"1f321","\uD83C\uDF99\uFE0F":"1f399","\uD83C\uDF9A\uFE0F":"1f39a","\uD83C\uDF9B\uFE0F":"1f39b","\uD83C\uDFF3\uFE0F":"1f3f3","\uD83C\uDFF5\uFE0F":"1f3f5","\uD83C\uDFF7\uFE0F":"1f3f7","\uD83D\uDCFD\uFE0F":"1f4fd","\uD83D\uDD49\uFE0F":"1f549","\uD83D\uDD4A\uFE0F":"1f54a","\uD83D\uDD6F\uFE0F":"1f56f","\uD83D\uDD70\uFE0F":"1f570","\uD83D\uDD73\uFE0F":"1f573","\uD83D\uDD76\uFE0F":"1f576","\uD83D\uDD79\uFE0F":"1f579","\uD83D\uDD87\uFE0F":"1f587","\uD83D\uDD8A\uFE0F":"1f58a","\uD83D\uDD8B\uFE0F":"1f58b","\uD83D\uDD8C\uFE0F":"1f58c","\uD83D\uDD8D\uFE0F":"1f58d","\uD83D\uDDA5\uFE0F":"1f5a5","\uD83D\uDDA8\uFE0F":"1f5a8","\uD83D\uDDB2\uFE0F":"1f5b2","\uD83D\uDDBC\uFE0F":"1f5bc","\uD83D\uDDC2\uFE0F":"1f5c2","\uD83D\uDDC3\uFE0F":"1f5c3","\uD83D\uDDC4\uFE0F":"1f5c4","\uD83D\uDDD1\uFE0F":"1f5d1","\uD83D\uDDD2\uFE0F":"1f5d2","\uD83D\uDDD3\uFE0F":"1f5d3","\uD83D\uDDDC\uFE0F":"1f5dc","\uD83D\uDDDD\uFE0F":"1f5dd","\uD83D\uDDDE\uFE0F":"1f5de","\uD83D\uDDE1\uFE0F":"1f5e1","\uD83D\uDDE3\uFE0F":"1f5e3","\uD83D\uDDE8\uFE0F":"1f5e8","\uD83D\uDDEF\uFE0F":"1f5ef","\uD83D\uDDF3\uFE0F":"1f5f3","\uD83D\uDDFA\uFE0F":"1f5fa","\uD83D\uDEE0\uFE0F":"1f6e0","\uD83D\uDEE1\uFE0F":"1f6e1","\uD83D\uDEE2\uFE0F":"1f6e2","\uD83D\uDEF0\uFE0F":"1f6f0","\uD83C\uDF7D\uFE0F":"1f37d","\uD83D\uDC41\uFE0F":"1f441","\uD83D\uDD74\uFE0F":"1f574","\uD83D\uDD75\uFE0F":"1f575","\uD83D\uDD90\uFE0F":"1f590","\uD83C\uDFD4\uFE0F":"1f3d4","\uD83C\uDFD5\uFE0F":"1f3d5","\uD83C\uDFD6\uFE0F":"1f3d6","\uD83C\uDFD7\uFE0F":"1f3d7","\uD83C\uDFD8\uFE0F":"1f3d8","\uD83C\uDFD9\uFE0F":"1f3d9","\uD83C\uDFDA\uFE0F":"1f3da","\uD83C\uDFDB\uFE0F":"1f3db","\uD83C\uDFDC\uFE0F":"1f3dc","\uD83C\uDFDD\uFE0F":"1f3dd","\uD83C\uDFDE\uFE0F":"1f3de","\uD83C\uDFDF\uFE0F":"1f3df","\uD83D\uDECB\uFE0F":"1f6cb","\uD83D\uDECD\uFE0F":"1f6cd","\uD83D\uDECE\uFE0F":"1f6ce","\uD83D\uDECF\uFE0F":"1f6cf","\uD83D\uDEE3\uFE0F":"1f6e3","\uD83D\uDEE4\uFE0F":"1f6e4","\uD83D\uDEE5\uFE0F":"1f6e5","\uD83D\uDEE9\uFE0F":"1f6e9","\uD83D\uDEF3\uFE0F":"1f6f3","\u261D\uD83C\uDFFB":"261d-1f3fb","\u261D\uD83C\uDFFC":"261d-1f3fc","\u261D\uD83C\uDFFD":"261d-1f3fd","\u261D\uD83C\uDFFE":"261d-1f3fe","\u261D\uD83C\uDFFF":"261d-1f3ff","\u270C\uD83C\uDFFB":"270c-1f3fb","\u270C\uD83C\uDFFC":"270c-1f3fc","\u270C\uD83C\uDFFD":"270c-1f3fd","\u270C\uD83C\uDFFE":"270c-1f3fe","\u270C\uD83C\uDFFF":"270c-1f3ff","\u270A\uD83C\uDFFB":"270a-1f3fb","\u270A\uD83C\uDFFC":"270a-1f3fc","\u270A\uD83C\uDFFD":"270a-1f3fd","\u270A\uD83C\uDFFE":"270a-1f3fe","\u270A\uD83C\uDFFF":"270a-1f3ff","\u270B\uD83C\uDFFB":"270b-1f3fb","\u270B\uD83C\uDFFC":"270b-1f3fc","\u270B\uD83C\uDFFD":"270b-1f3fd","\u270B\uD83C\uDFFE":"270b-1f3fe","\u270B\uD83C\uDFFF":"270b-1f3ff","\u270D\uD83C\uDFFB":"270d-1f3fb","\u270D\uD83C\uDFFC":"270d-1f3fc","\u270D\uD83C\uDFFD":"270d-1f3fd","\u270D\uD83C\uDFFE":"270d-1f3fe","\u270D\uD83C\uDFFF":"270d-1f3ff","\uD83C\uDF24\uFE0F":"1f324","\uD83C\uDF25\uFE0F":"1f325","\uD83C\uDF26\uFE0F":"1f326","\uD83D\uDDB1\uFE0F":"1f5b1","\u26F9\uD83C\uDFFB":"26f9-1f3fb","\u26F9\uD83C\uDFFC":"26f9-1f3fc","\u26F9\uD83C\uDFFD":"26f9-1f3fd","\u26F9\uD83C\uDFFE":"26f9-1f3fe","\u26F9\uD83C\uDFFF":"26f9-1f3ff","\uD83C\uDD70\uFE0F":"1f170","\uD83C\uDD71\uFE0F":"1f171","\uD83C\uDD7E\uFE0F":"1f17e","\uD83C\uDC04\uFE0F":"1f004","\uD83C\uDE1A\uFE0F":"1f21a","\uD83C\uDE2F\uFE0F":"1f22f","\uD83C\uDF0D\uFE0F":"1f30d","\uD83C\uDF0E\uFE0F":"1f30e","\uD83C\uDF0F\uFE0F":"1f30f","\uD83C\uDF15\uFE0F":"1f315","\uD83C\uDF1C\uFE0F":"1f31c","\uD83C\uDF78\uFE0F":"1f378","\uD83C\uDF93\uFE0F":"1f393","\uD83C\uDFA7\uFE0F":"1f3a7","\uD83C\uDFAC\uFE0F":"1f3ac","\uD83C\uDFAD\uFE0F":"1f3ad","\uD83C\uDFAE\uFE0F":"1f3ae","\uD83C\uDFC2\uFE0F":"1f3c2","\uD83C\uDFC4\uFE0F":"1f3c4","\uD83C\uDFC6\uFE0F":"1f3c6","\uD83C\uDFCA\uFE0F":"1f3ca","\uD83C\uDFE0\uFE0F":"1f3e0","\uD83C\uDFED\uFE0F":"1f3ed","\uD83D\uDC08\uFE0F":"1f408","\uD83D\uDC15\uFE0F":"1f415","\uD83D\uDC1F\uFE0F":"1f41f","\uD83D\uDC26\uFE0F":"1f426","\uD83D\uDC42\uFE0F":"1f442","\uD83D\uDC46\uFE0F":"1f446","\uD83D\uDC47\uFE0F":"1f447","\uD83D\uDC48\uFE0F":"1f448","\uD83D\uDC49\uFE0F":"1f449","\uD83D\uDC4D\uFE0F":"1f44d","\uD83D\uDC4E\uFE0F":"1f44e","\uD83D\uDC53\uFE0F":"1f453","\uD83D\uDC6A\uFE0F":"1f46a","\uD83D\uDC7D\uFE0F":"1f47d","\uD83D\uDCA3\uFE0F":"1f4a3","\uD83D\uDCB0\uFE0F":"1f4b0","\uD83D\uDCB3\uFE0F":"1f4b3","\uD83D\uDCBB\uFE0F":"1f4bb","\uD83D\uDCBF\uFE0F":"1f4bf","\uD83D\uDCCB\uFE0F":"1f4cb","\uD83D\uDCDA\uFE0F":"1f4da","\uD83D\uDCDF\uFE0F":"1f4df","\uD83D\uDCE4\uFE0F":"1f4e4","\uD83D\uDCE5\uFE0F":"1f4e5","\uD83D\uDCE6\uFE0F":"1f4e6","\uD83D\uDCEA\uFE0F":"1f4ea","\uD83D\uDCEB\uFE0F":"1f4eb","\uD83D\uDCEC\uFE0F":"1f4ec","\uD83D\uDCED\uFE0F":"1f4ed","\uD83D\uDCF7\uFE0F":"1f4f7","\uD83D\uDCF9\uFE0F":"1f4f9","\uD83D\uDCFA\uFE0F":"1f4fa","\uD83D\uDCFB\uFE0F":"1f4fb","\uD83D\uDD08\uFE0F":"1f508","\uD83D\uDD0D\uFE0F":"1f50d","\uD83D\uDD12\uFE0F":"1f512","\uD83D\uDD13\uFE0F":"1f513","\uD83D\uDD50\uFE0F":"1f550","\uD83D\uDD51\uFE0F":"1f551","\uD83D\uDD52\uFE0F":"1f552","\uD83D\uDD53\uFE0F":"1f553","\uD83D\uDD54\uFE0F":"1f554","\uD83D\uDD55\uFE0F":"1f555","\uD83D\uDD56\uFE0F":"1f556","\uD83D\uDD57\uFE0F":"1f557","\uD83D\uDD58\uFE0F":"1f558","\uD83D\uDD59\uFE0F":"1f559","\uD83D\uDD5A\uFE0F":"1f55a","\uD83D\uDD5B\uFE0F":"1f55b","\uD83D\uDD5C\uFE0F":"1f55c","\uD83D\uDD5D\uFE0F":"1f55d","\uD83D\uDD5E\uFE0F":"1f55e","\uD83D\uDD5F\uFE0F":"1f55f","\uD83D\uDD60\uFE0F":"1f560","\uD83D\uDD61\uFE0F":"1f561","\uD83D\uDD62\uFE0F":"1f562","\uD83D\uDD63\uFE0F":"1f563","\uD83D\uDD64\uFE0F":"1f564","\uD83D\uDD65\uFE0F":"1f565","\uD83D\uDD66\uFE0F":"1f566","\uD83D\uDD67\uFE0F":"1f567","\uD83D\uDE10\uFE0F":"1f610","\uD83D\uDE87\uFE0F":"1f687","\uD83D\uDE8D\uFE0F":"1f68d","\uD83D\uDE91\uFE0F":"1f691","\uD83D\uDE94\uFE0F":"1f694","\uD83D\uDE98\uFE0F":"1f698","\uD83D\uDEAD\uFE0F":"1f6ad","\uD83D\uDEB2\uFE0F":"1f6b2","\uD83D\uDEB9\uFE0F":"1f6b9","\uD83D\uDEBA\uFE0F":"1f6ba","\uD83D\uDEBC\uFE0F":"1f6bc","#\u20E3":"0023-20e3","0\u20E3":"0030-20e3","1\u20E3":"0031-20e3","2\u20E3":"0032-20e3","3\u20E3":"0033-20e3","4\u20E3":"0034-20e3","5\u20E3":"0035-20e3","6\u20E3":"0036-20e3","7\u20E3":"0037-20e3","8\u20E3":"0038-20e3","9\u20E3":"0039-20e3","\u203C\uFE0F":"203c","\u2049\uFE0F":"2049","\u2139\uFE0F":"2139","\u2194\uFE0F":"2194","\u2195\uFE0F":"2195","\u2196\uFE0F":"2196","\u2197\uFE0F":"2197","\u2198\uFE0F":"2198","\u2199\uFE0F":"2199","\u21A9\uFE0F":"21a9","\u21AA\uFE0F":"21aa","\u24C2\uFE0F":"24c2","\u25AA\uFE0F":"25aa","\u25AB\uFE0F":"25ab","\u25B6\uFE0F":"25b6","\u25C0\uFE0F":"25c0","\u25FB\uFE0F":"25fb","\u25FC\uFE0F":"25fc","\u2600\uFE0F":"2600","\u2601\uFE0F":"2601","\u260E\uFE0F":"260e","\u2611\uFE0F":"2611","\u261D\uFE0F":"261d","\u263A\uFE0F":"263a","\u2660\uFE0F":"2660","\u2663\uFE0F":"2663","\u2665\uFE0F":"2665","\u2666\uFE0F":"2666","\u2668\uFE0F":"2668","\u267B\uFE0F":"267b","\u26A0\uFE0F":"26a0","\u2702\uFE0F":"2702","\u2708\uFE0F":"2708","\u2709\uFE0F":"2709","\u270C\uFE0F":"270c","\u270F\uFE0F":"270f","\u2712\uFE0F":"2712","\u2714\uFE0F":"2714","\u2716\uFE0F":"2716","\u2733\uFE0F":"2733","\u2734\uFE0F":"2734","\u2744\uFE0F":"2744","\u2747\uFE0F":"2747","\u2764\uFE0F":"2764","\u27A1\uFE0F":"27a1","\u2934\uFE0F":"2934","\u2935\uFE0F":"2935","\u2B05\uFE0F":"2b05","\u2B06\uFE0F":"2b06","\u2B07\uFE0F":"2b07","\u3030\uFE0F":"3030","\u303D\uFE0F":"303d","\u3297\uFE0F":"3297","\u3299\uFE0F":"3299","\u271D\uFE0F":"271d","\u2328\uFE0F":"2328","\u270D\uFE0F":"270d","*\u20E3":"002a-20e3","\u23CF\uFE0F":"23cf","\u23ED\uFE0F":"23ed","\u23EE\uFE0F":"23ee","\u23EF\uFE0F":"23ef","\u23F1\uFE0F":"23f1","\u23F2\uFE0F":"23f2","\u23F8\uFE0F":"23f8","\u23F9\uFE0F":"23f9","\u23FA\uFE0F":"23fa","\u2602\uFE0F":"2602","\u2603\uFE0F":"2603","\u2604\uFE0F":"2604","\u2618\uFE0F":"2618","\u2620\uFE0F":"2620","\u2622\uFE0F":"2622","\u2623\uFE0F":"2623","\u2626\uFE0F":"2626","\u262A\uFE0F":"262a","\u262E\uFE0F":"262e","\u262F\uFE0F":"262f","\u2638\uFE0F":"2638","\u2639\uFE0F":"2639","\u2692\uFE0F":"2692","\u2694\uFE0F":"2694","\u2696\uFE0F":"2696","\u2697\uFE0F":"2697","\u2699\uFE0F":"2699","\u269B\uFE0F":"269b","\u269C\uFE0F":"269c","\u26B0\uFE0F":"26b0","\u26B1\uFE0F":"26b1","\u26C8\uFE0F":"26c8","\u26CF\uFE0F":"26cf","\u26D1\uFE0F":"26d1","\u26D3\uFE0F":"26d3","\u26E9\uFE0F":"26e9","\u26F0\uFE0F":"26f0","\u26F1\uFE0F":"26f1","\u26F4\uFE0F":"26f4","\u26F7\uFE0F":"26f7","\u26F8\uFE0F":"26f8","\u26F9\uFE0F":"26f9","\u2721\uFE0F":"2721","\u2763\uFE0F":"2763","\u2640\uFE0F":"2640","\u2642\uFE0F":"2642","\u2695\uFE0F":"2695","\u265F\uFE0F":"265f","\u267E\uFE0F":"267e","\u231A\uFE0F":"231a","\u231B\uFE0F":"231b","\u23E9\uFE0F":"23e9","\u23EA\uFE0F":"23ea","\u23F3\uFE0F":"23f3","\u25FD\uFE0F":"25fd","\u25FE\uFE0F":"25fe","\u2614\uFE0F":"2614","\u2615\uFE0F":"2615","\u2648\uFE0F":"2648","\u2649\uFE0F":"2649","\u264A\uFE0F":"264a","\u264B\uFE0F":"264b","\u264C\uFE0F":"264c","\u264D\uFE0F":"264d","\u264E\uFE0F":"264e","\u264F\uFE0F":"264f","\u2650\uFE0F":"2650","\u2651\uFE0F":"2651","\u2652\uFE0F":"2652","\u2653\uFE0F":"2653","\u267F\uFE0F":"267f","\u2693\uFE0F":"2693","\u26A1\uFE0F":"26a1","\u26AA\uFE0F":"26aa","\u26AB\uFE0F":"26ab","\u26BD\uFE0F":"26bd","\u26BE\uFE0F":"26be","\u26C4\uFE0F":"26c4","\u26C5\uFE0F":"26c5","\u26D4\uFE0F":"26d4","\u26EA\uFE0F":"26ea","\u26F2\uFE0F":"26f2","\u26F3\uFE0F":"26f3","\u26F5\uFE0F":"26f5","\u26FA\uFE0F":"26fa","\u26FD\uFE0F":"26fd","\u2753\uFE0F":"2753","\u2757\uFE0F":"2757","\u2B1B\uFE0F":"2b1b","\u2B1C\uFE0F":"2b1c","\u2B50\uFE0F":"2b50","\u2B55\uFE0F":"2b55","\uD83E\uDD49":"1f949","\uD83E\uDD48":"1f948","\uD83E\uDD47":"1f947","\uD83E\uDD3A":"1f93a","\uD83E\uDD45":"1f945","\uD83E\uDD3E":"1f93e","\uD83C\uDDFF":"1f1ff","\uD83E\uDD3D":"1f93d","\uD83E\uDD4B":"1f94b","\uD83E\uDD4A":"1f94a","\uD83E\uDD3C":"1f93c","\uD83E\uDD39":"1f939","\uD83E\uDD38":"1f938","\uD83D\uDEF6":"1f6f6","\uD83D\uDEF5":"1f6f5","\uD83D\uDEF4":"1f6f4","\uD83D\uDED2":"1f6d2","\uD83C\uDC04":"1f004","\uD83C\uDCCF":"1f0cf","\uD83C\uDD70":"1f170","\uD83C\uDD71":"1f171","\uD83C\uDD7E":"1f17e","\uD83C\uDD7F":"1f17f","\uD83D\uDED1":"1f6d1","\uD83C\uDD8E":"1f18e","\uD83C\uDD91":"1f191","\uD83C\uDDFE":"1f1fe","\uD83C\uDD92":"1f192","\uD83C\uDD93":"1f193","\uD83C\uDD94":"1f194","\uD83C\uDD95":"1f195","\uD83C\uDD96":"1f196","\uD83C\uDD97":"1f197","\uD83C\uDD98":"1f198","\uD83E\uDD44":"1f944","\uD83C\uDD99":"1f199","\uD83C\uDD9A":"1f19a","\uD83E\uDD42":"1f942","\uD83E\uDD43":"1f943","\uD83C\uDE01":"1f201","\uD83C\uDE02":"1f202","\uD83C\uDE1A":"1f21a","\uD83C\uDE2F":"1f22f","\uD83E\uDD59":"1f959","\uD83C\uDE32":"1f232","\uD83C\uDE33":"1f233","\uD83C\uDE34":"1f234","\uD83C\uDE35":"1f235","\uD83C\uDE36":"1f236","\uD83E\uDD58":"1f958","\uD83C\uDE37":"1f237","\uD83C\uDE38":"1f238","\uD83C\uDE39":"1f239","\uD83E\uDD57":"1f957","\uD83C\uDE3A":"1f23a","\uD83C\uDE50":"1f250","\uD83C\uDE51":"1f251","\uD83C\uDF00":"1f300","\uD83E\uDD56":"1f956","\uD83C\uDF01":"1f301","\uD83C\uDF02":"1f302","\uD83C\uDF03":"1f303","\uD83C\uDF04":"1f304","\uD83C\uDF05":"1f305","\uD83C\uDF06":"1f306","\uD83E\uDD55":"1f955","\uD83C\uDF07":"1f307","\uD83C\uDF08":"1f308","\uD83E\uDD54":"1f954","\uD83C\uDF09":"1f309","\uD83C\uDF0A":"1f30a","\uD83C\uDF0B":"1f30b","\uD83C\uDF0C":"1f30c","\uD83C\uDF0F":"1f30f","\uD83C\uDF11":"1f311","\uD83E\uDD53":"1f953","\uD83C\uDF13":"1f313","\uD83C\uDF14":"1f314","\uD83C\uDF15":"1f315","\uD83C\uDF19":"1f319","\uD83C\uDF1B":"1f31b","\uD83C\uDF1F":"1f31f","\uD83E\uDD52":"1f952","\uD83C\uDF20":"1f320","\uD83C\uDF30":"1f330","\uD83E\uDD51":"1f951","\uD83C\uDF31":"1f331","\uD83C\uDF34":"1f334","\uD83C\uDF35":"1f335","\uD83C\uDF37":"1f337","\uD83C\uDF38":"1f338","\uD83C\uDF39":"1f339","\uD83C\uDF3A":"1f33a","\uD83C\uDF3B":"1f33b","\uD83C\uDF3C":"1f33c","\uD83C\uDF3D":"1f33d","\uD83E\uDD50":"1f950","\uD83C\uDF3E":"1f33e","\uD83C\uDF3F":"1f33f","\uD83C\uDF40":"1f340","\uD83C\uDF41":"1f341","\uD83C\uDF42":"1f342","\uD83C\uDF43":"1f343","\uD83C\uDF44":"1f344","\uD83C\uDF45":"1f345","\uD83C\uDF46":"1f346","\uD83C\uDF47":"1f347","\uD83C\uDF48":"1f348","\uD83C\uDF49":"1f349","\uD83C\uDF4A":"1f34a","\uD83E\uDD40":"1f940","\uD83C\uDF4C":"1f34c","\uD83C\uDF4D":"1f34d","\uD83C\uDF4E":"1f34e","\uD83C\uDF4F":"1f34f","\uD83C\uDF51":"1f351","\uD83C\uDF52":"1f352","\uD83C\uDF53":"1f353","\uD83E\uDD8F":"1f98f","\uD83C\uDF54":"1f354","\uD83C\uDF55":"1f355","\uD83C\uDF56":"1f356","\uD83E\uDD8E":"1f98e","\uD83C\uDF57":"1f357","\uD83C\uDF58":"1f358","\uD83C\uDF59":"1f359","\uD83E\uDD8D":"1f98d","\uD83C\uDF5A":"1f35a","\uD83C\uDF5B":"1f35b","\uD83E\uDD8C":"1f98c","\uD83C\uDF5C":"1f35c","\uD83C\uDF5D":"1f35d","\uD83C\uDF5E":"1f35e","\uD83C\uDF5F":"1f35f","\uD83E\uDD8B":"1f98b","\uD83C\uDF60":"1f360","\uD83C\uDF61":"1f361","\uD83E\uDD8A":"1f98a","\uD83C\uDF62":"1f362","\uD83C\uDF63":"1f363","\uD83E\uDD89":"1f989","\uD83C\uDF64":"1f364","\uD83C\uDF65":"1f365","\uD83E\uDD88":"1f988","\uD83C\uDF66":"1f366","\uD83E\uDD87":"1f987","\uD83C\uDF67":"1f367","\uD83C\uDDFD":"1f1fd","\uD83C\uDF68":"1f368","\uD83E\uDD86":"1f986","\uD83C\uDF69":"1f369","\uD83E\uDD85":"1f985","\uD83C\uDF6A":"1f36a","\uD83D\uDDA4":"1f5a4","\uD83C\uDF6B":"1f36b","\uD83C\uDF6C":"1f36c","\uD83C\uDF6D":"1f36d","\uD83C\uDF6E":"1f36e","\uD83C\uDF6F":"1f36f","\uD83E\uDD1E":"1f91e","\uD83C\uDF70":"1f370","\uD83C\uDF71":"1f371","\uD83C\uDF72":"1f372","\uD83E\uDD1D":"1f91d","\uD83C\uDF73":"1f373","\uD83C\uDF74":"1f374","\uD83C\uDF75":"1f375","\uD83C\uDF76":"1f376","\uD83C\uDF77":"1f377","\uD83C\uDF78":"1f378","\uD83C\uDF79":"1f379","\uD83C\uDF7A":"1f37a","\uD83C\uDF7B":"1f37b","\uD83C\uDF80":"1f380","\uD83C\uDF81":"1f381","\uD83C\uDF82":"1f382","\uD83C\uDF83":"1f383","\uD83E\uDD1B":"1f91b","\uD83E\uDD1C":"1f91c","\uD83C\uDF84":"1f384","\uD83C\uDF85":"1f385","\uD83C\uDF86":"1f386","\uD83E\uDD1A":"1f91a","\uD83C\uDF87":"1f387","\uD83C\uDF88":"1f388","\uD83C\uDF89":"1f389","\uD83C\uDF8A":"1f38a","\uD83C\uDF8B":"1f38b","\uD83C\uDF8C":"1f38c","\uD83E\uDD19":"1f919","\uD83C\uDF8D":"1f38d","\uD83D\uDD7A":"1f57a","\uD83C\uDF8E":"1f38e","\uD83E\uDD33":"1f933","\uD83C\uDF8F":"1f38f","\uD83E\uDD30":"1f930","\uD83C\uDF90":"1f390","\uD83E\uDD26":"1f926","\uD83E\uDD37":"1f937","\uD83C\uDF91":"1f391","\uD83C\uDF92":"1f392","\uD83C\uDF93":"1f393","\uD83C\uDFA0":"1f3a0","\uD83C\uDFA1":"1f3a1","\uD83C\uDFA2":"1f3a2","\uD83C\uDFA3":"1f3a3","\uD83C\uDFA4":"1f3a4","\uD83C\uDFA5":"1f3a5","\uD83C\uDFA6":"1f3a6","\uD83C\uDFA7":"1f3a7","\uD83E\uDD36":"1f936","\uD83C\uDFA8":"1f3a8","\uD83E\uDD35":"1f935","\uD83C\uDFA9":"1f3a9","\uD83C\uDFAA":"1f3aa","\uD83E\uDD34":"1f934","\uD83C\uDFAB":"1f3ab","\uD83C\uDFAC":"1f3ac","\uD83C\uDFAD":"1f3ad","\uD83E\uDD27":"1f927","\uD83C\uDFAE":"1f3ae","\uD83C\uDFAF":"1f3af","\uD83C\uDFB0":"1f3b0","\uD83C\uDFB1":"1f3b1","\uD83C\uDFB2":"1f3b2","\uD83C\uDFB3":"1f3b3","\uD83C\uDFB4":"1f3b4","\uD83E\uDD25":"1f925","\uD83C\uDFB5":"1f3b5","\uD83C\uDFB6":"1f3b6","\uD83C\uDFB7":"1f3b7","\uD83E\uDD24":"1f924","\uD83C\uDFB8":"1f3b8","\uD83C\uDFB9":"1f3b9","\uD83C\uDFBA":"1f3ba","\uD83E\uDD23":"1f923","\uD83C\uDFBB":"1f3bb","\uD83C\uDFBC":"1f3bc","\uD83C\uDFBD":"1f3bd","\uD83E\uDD22":"1f922","\uD83C\uDFBE":"1f3be","\uD83C\uDFBF":"1f3bf","\uD83C\uDFC0":"1f3c0","\uD83C\uDFC1":"1f3c1","\uD83E\uDD21":"1f921","\uD83C\uDFC2":"1f3c2","\uD83C\uDFC3":"1f3c3","\uD83C\uDFC4":"1f3c4","\uD83C\uDFC6":"1f3c6","\uD83C\uDFC8":"1f3c8","\uD83C\uDFCA":"1f3ca","\uD83C\uDFE0":"1f3e0","\uD83C\uDFE1":"1f3e1","\uD83C\uDFE2":"1f3e2","\uD83C\uDFE3":"1f3e3","\uD83C\uDFE5":"1f3e5","\uD83C\uDFE6":"1f3e6","\uD83C\uDFE7":"1f3e7","\uD83C\uDFE8":"1f3e8","\uD83C\uDFE9":"1f3e9","\uD83C\uDFEA":"1f3ea","\uD83C\uDFEB":"1f3eb","\uD83C\uDFEC":"1f3ec","\uD83E\uDD20":"1f920","\uD83C\uDFED":"1f3ed","\uD83C\uDFEE":"1f3ee","\uD83C\uDFEF":"1f3ef","\uD83C\uDFF0":"1f3f0","\uD83D\uDC0C":"1f40c","\uD83D\uDC0D":"1f40d","\uD83D\uDC0E":"1f40e","\uD83D\uDC11":"1f411","\uD83D\uDC12":"1f412","\uD83D\uDC14":"1f414","\uD83D\uDC17":"1f417","\uD83D\uDC18":"1f418","\uD83D\uDC19":"1f419","\uD83D\uDC1A":"1f41a","\uD83D\uDC1B":"1f41b","\uD83D\uDC1C":"1f41c","\uD83D\uDC1D":"1f41d","\uD83D\uDC1E":"1f41e","\uD83D\uDC1F":"1f41f","\uD83D\uDC20":"1f420","\uD83D\uDC21":"1f421","\uD83D\uDC22":"1f422","\uD83D\uDC23":"1f423","\uD83D\uDC24":"1f424","\uD83D\uDC25":"1f425","\uD83D\uDC26":"1f426","\uD83D\uDC27":"1f427","\uD83D\uDC28":"1f428","\uD83D\uDC29":"1f429","\uD83D\uDC2B":"1f42b","\uD83D\uDC2C":"1f42c","\uD83D\uDC2D":"1f42d","\uD83D\uDC2E":"1f42e","\uD83D\uDC2F":"1f42f","\uD83D\uDC30":"1f430","\uD83D\uDC31":"1f431","\uD83D\uDC32":"1f432","\uD83D\uDC33":"1f433","\uD83D\uDC34":"1f434","\uD83D\uDC35":"1f435","\uD83D\uDC36":"1f436","\uD83D\uDC37":"1f437","\uD83D\uDC38":"1f438","\uD83D\uDC39":"1f439","\uD83D\uDC3A":"1f43a","\uD83D\uDC3B":"1f43b","\uD83D\uDC3C":"1f43c","\uD83D\uDC3D":"1f43d","\uD83D\uDC3E":"1f43e","\uD83D\uDC40":"1f440","\uD83D\uDC42":"1f442","\uD83D\uDC43":"1f443","\uD83D\uDC44":"1f444","\uD83D\uDC45":"1f445","\uD83D\uDC46":"1f446","\uD83D\uDC47":"1f447","\uD83D\uDC48":"1f448","\uD83D\uDC49":"1f449","\uD83D\uDC4A":"1f44a","\uD83D\uDC4B":"1f44b","\uD83D\uDC4C":"1f44c","\uD83D\uDC4D":"1f44d","\uD83D\uDC4E":"1f44e","\uD83D\uDC4F":"1f44f","\uD83D\uDC50":"1f450","\uD83D\uDC51":"1f451","\uD83D\uDC52":"1f452","\uD83D\uDC53":"1f453","\uD83D\uDC54":"1f454","\uD83D\uDC55":"1f455","\uD83D\uDC56":"1f456","\uD83D\uDC57":"1f457","\uD83D\uDC58":"1f458","\uD83D\uDC59":"1f459","\uD83D\uDC5A":"1f45a","\uD83D\uDC5B":"1f45b","\uD83D\uDC5C":"1f45c","\uD83D\uDC5D":"1f45d","\uD83D\uDC5E":"1f45e","\uD83D\uDC5F":"1f45f","\uD83D\uDC60":"1f460","\uD83D\uDC61":"1f461","\uD83D\uDC62":"1f462","\uD83D\uDC63":"1f463","\uD83D\uDC64":"1f464","\uD83D\uDC66":"1f466","\uD83D\uDC67":"1f467","\uD83D\uDC68":"1f468","\uD83D\uDC69":"1f469","\uD83D\uDC6A":"1f46a","\uD83D\uDC6B":"1f46b","\uD83D\uDC6E":"1f46e","\uD83D\uDC6F":"1f46f","\uD83D\uDC70":"1f470","\uD83D\uDC71":"1f471","\uD83D\uDC72":"1f472","\uD83D\uDC73":"1f473","\uD83D\uDC74":"1f474","\uD83D\uDC75":"1f475","\uD83D\uDC76":"1f476","\uD83D\uDC77":"1f477","\uD83D\uDC78":"1f478","\uD83D\uDC79":"1f479","\uD83D\uDC7A":"1f47a","\uD83D\uDC7B":"1f47b","\uD83D\uDC7C":"1f47c","\uD83D\uDC7D":"1f47d","\uD83D\uDC7E":"1f47e","\uD83D\uDC7F":"1f47f","\uD83D\uDC80":"1f480","\uD83D\uDCC7":"1f4c7","\uD83D\uDC81":"1f481","\uD83D\uDC82":"1f482","\uD83D\uDC83":"1f483","\uD83D\uDC84":"1f484","\uD83D\uDC85":"1f485","\uD83D\uDCD2":"1f4d2","\uD83D\uDC86":"1f486","\uD83D\uDCD3":"1f4d3","\uD83D\uDC87":"1f487","\uD83D\uDCD4":"1f4d4","\uD83D\uDC88":"1f488","\uD83D\uDCD5":"1f4d5","\uD83D\uDC89":"1f489","\uD83D\uDCD6":"1f4d6","\uD83D\uDC8A":"1f48a","\uD83D\uDCD7":"1f4d7","\uD83D\uDC8B":"1f48b","\uD83D\uDCD8":"1f4d8","\uD83D\uDC8C":"1f48c","\uD83D\uDCD9":"1f4d9","\uD83D\uDC8D":"1f48d","\uD83D\uDCDA":"1f4da","\uD83D\uDC8E":"1f48e","\uD83D\uDCDB":"1f4db","\uD83D\uDC8F":"1f48f","\uD83D\uDCDC":"1f4dc","\uD83D\uDC90":"1f490","\uD83D\uDCDD":"1f4dd","\uD83D\uDC91":"1f491","\uD83D\uDCDE":"1f4de","\uD83D\uDC92":"1f492","\uD83D\uDCDF":"1f4df","\uD83D\uDCE0":"1f4e0","\uD83D\uDC93":"1f493","\uD83D\uDCE1":"1f4e1","\uD83D\uDCE2":"1f4e2","\uD83D\uDC94":"1f494","\uD83D\uDCE3":"1f4e3","\uD83D\uDCE4":"1f4e4","\uD83D\uDC95":"1f495","\uD83D\uDCE5":"1f4e5","\uD83D\uDCE6":"1f4e6","\uD83D\uDC96":"1f496","\uD83D\uDCE7":"1f4e7","\uD83D\uDCE8":"1f4e8","\uD83D\uDC97":"1f497","\uD83D\uDCE9":"1f4e9","\uD83D\uDCEA":"1f4ea","\uD83D\uDC98":"1f498","\uD83D\uDCEB":"1f4eb","\uD83D\uDCEE":"1f4ee","\uD83D\uDC99":"1f499","\uD83D\uDCF0":"1f4f0","\uD83D\uDCF1":"1f4f1","\uD83D\uDC9A":"1f49a","\uD83D\uDCF2":"1f4f2","\uD83D\uDCF3":"1f4f3","\uD83D\uDC9B":"1f49b","\uD83D\uDCF4":"1f4f4","\uD83D\uDCF6":"1f4f6","\uD83D\uDC9C":"1f49c","\uD83D\uDCF7":"1f4f7","\uD83D\uDCF9":"1f4f9","\uD83D\uDC9D":"1f49d","\uD83D\uDCFA":"1f4fa","\uD83D\uDCFB":"1f4fb","\uD83D\uDC9E":"1f49e","\uD83D\uDCFC":"1f4fc","\uD83D\uDD03":"1f503","\uD83D\uDC9F":"1f49f","\uD83D\uDD0A":"1f50a","\uD83D\uDD0B":"1f50b","\uD83D\uDCA0":"1f4a0","\uD83D\uDD0C":"1f50c","\uD83D\uDD0D":"1f50d","\uD83D\uDCA1":"1f4a1","\uD83D\uDD0E":"1f50e","\uD83D\uDD0F":"1f50f","\uD83D\uDCA2":"1f4a2","\uD83D\uDD10":"1f510","\uD83D\uDD11":"1f511","\uD83D\uDCA3":"1f4a3","\uD83D\uDD12":"1f512","\uD83D\uDD13":"1f513","\uD83D\uDCA4":"1f4a4","\uD83D\uDD14":"1f514","\uD83D\uDD16":"1f516","\uD83D\uDCA5":"1f4a5","\uD83D\uDD17":"1f517","\uD83D\uDD18":"1f518","\uD83D\uDCA6":"1f4a6","\uD83D\uDD19":"1f519","\uD83D\uDD1A":"1f51a","\uD83D\uDCA7":"1f4a7","\uD83D\uDD1B":"1f51b","\uD83D\uDD1C":"1f51c","\uD83D\uDCA8":"1f4a8","\uD83D\uDD1D":"1f51d","\uD83D\uDD1E":"1f51e","\uD83D\uDCA9":"1f4a9","\uD83D\uDD1F":"1f51f","\uD83D\uDCAA":"1f4aa","\uD83D\uDD20":"1f520","\uD83D\uDD21":"1f521","\uD83D\uDCAB":"1f4ab","\uD83D\uDD22":"1f522","\uD83D\uDD23":"1f523","\uD83D\uDCAC":"1f4ac","\uD83D\uDD24":"1f524","\uD83D\uDD25":"1f525","\uD83D\uDCAE":"1f4ae","\uD83D\uDD26":"1f526","\uD83D\uDD27":"1f527","\uD83D\uDCAF":"1f4af","\uD83D\uDD28":"1f528","\uD83D\uDD29":"1f529","\uD83D\uDCB0":"1f4b0","\uD83D\uDD2A":"1f52a","\uD83D\uDD2B":"1f52b","\uD83D\uDCB1":"1f4b1","\uD83D\uDD2E":"1f52e","\uD83D\uDCB2":"1f4b2","\uD83D\uDD2F":"1f52f","\uD83D\uDCB3":"1f4b3","\uD83D\uDD30":"1f530","\uD83D\uDD31":"1f531","\uD83D\uDCB4":"1f4b4","\uD83D\uDD32":"1f532","\uD83D\uDD33":"1f533","\uD83D\uDCB5":"1f4b5","\uD83D\uDD34":"1f534","\uD83D\uDD35":"1f535","\uD83D\uDCB8":"1f4b8","\uD83D\uDD36":"1f536","\uD83D\uDD37":"1f537","\uD83D\uDCB9":"1f4b9","\uD83D\uDD38":"1f538","\uD83D\uDD39":"1f539","\uD83D\uDCBA":"1f4ba","\uD83D\uDD3A":"1f53a","\uD83D\uDD3B":"1f53b","\uD83D\uDCBB":"1f4bb","\uD83D\uDD3C":"1f53c","\uD83D\uDCBC":"1f4bc","\uD83D\uDD3D":"1f53d","\uD83D\uDD50":"1f550","\uD83D\uDCBD":"1f4bd","\uD83D\uDD51":"1f551","\uD83D\uDCBE":"1f4be","\uD83D\uDD52":"1f552","\uD83D\uDCBF":"1f4bf","\uD83D\uDD53":"1f553","\uD83D\uDCC0":"1f4c0","\uD83D\uDD54":"1f554","\uD83D\uDD55":"1f555","\uD83D\uDCC1":"1f4c1","\uD83D\uDD56":"1f556","\uD83D\uDD57":"1f557","\uD83D\uDCC2":"1f4c2","\uD83D\uDD58":"1f558","\uD83D\uDD59":"1f559","\uD83D\uDCC3":"1f4c3","\uD83D\uDD5A":"1f55a","\uD83D\uDD5B":"1f55b","\uD83D\uDCC4":"1f4c4","\uD83D\uDDFB":"1f5fb","\uD83D\uDDFC":"1f5fc","\uD83D\uDCC5":"1f4c5","\uD83D\uDDFD":"1f5fd","\uD83D\uDDFE":"1f5fe","\uD83D\uDCC6":"1f4c6","\uD83D\uDDFF":"1f5ff","\uD83D\uDE01":"1f601","\uD83D\uDE02":"1f602","\uD83D\uDE03":"1f603","\uD83D\uDCC8":"1f4c8","\uD83D\uDE04":"1f604","\uD83D\uDE05":"1f605","\uD83D\uDCC9":"1f4c9","\uD83D\uDE06":"1f606","\uD83D\uDE09":"1f609","\uD83D\uDCCA":"1f4ca","\uD83D\uDE0A":"1f60a","\uD83D\uDE0B":"1f60b","\uD83D\uDCCB":"1f4cb","\uD83D\uDE0C":"1f60c","\uD83D\uDE0D":"1f60d","\uD83D\uDCCC":"1f4cc","\uD83D\uDE0F":"1f60f","\uD83D\uDE12":"1f612","\uD83D\uDCCD":"1f4cd","\uD83D\uDE13":"1f613","\uD83D\uDE14":"1f614","\uD83D\uDCCE":"1f4ce","\uD83D\uDE16":"1f616","\uD83D\uDE18":"1f618","\uD83D\uDCCF":"1f4cf","\uD83D\uDE1A":"1f61a","\uD83D\uDE1C":"1f61c","\uD83D\uDCD0":"1f4d0","\uD83D\uDE1D":"1f61d","\uD83D\uDE1E":"1f61e","\uD83D\uDCD1":"1f4d1","\uD83D\uDE20":"1f620","\uD83D\uDE21":"1f621","\uD83D\uDE22":"1f622","\uD83D\uDE23":"1f623","\uD83D\uDE24":"1f624","\uD83D\uDE25":"1f625","\uD83D\uDE28":"1f628","\uD83D\uDE29":"1f629","\uD83D\uDE2A":"1f62a","\uD83D\uDE2B":"1f62b","\uD83D\uDE2D":"1f62d","\uD83D\uDE30":"1f630","\uD83D\uDE31":"1f631","\uD83D\uDE32":"1f632","\uD83D\uDE33":"1f633","\uD83D\uDE35":"1f635","\uD83D\uDE37":"1f637","\uD83D\uDE38":"1f638","\uD83D\uDE39":"1f639","\uD83D\uDE3A":"1f63a","\uD83D\uDE3B":"1f63b","\uD83D\uDE3C":"1f63c","\uD83D\uDE3D":"1f63d","\uD83D\uDE3E":"1f63e","\uD83D\uDE3F":"1f63f","\uD83D\uDE40":"1f640","\uD83D\uDE45":"1f645","\uD83D\uDE46":"1f646","\uD83D\uDE47":"1f647","\uD83D\uDE48":"1f648","\uD83D\uDE49":"1f649","\uD83D\uDE4A":"1f64a","\uD83D\uDE4B":"1f64b","\uD83D\uDE4C":"1f64c","\uD83D\uDE4D":"1f64d","\uD83D\uDE4E":"1f64e","\uD83D\uDE4F":"1f64f","\uD83D\uDE80":"1f680","\uD83D\uDE83":"1f683","\uD83D\uDE84":"1f684","\uD83D\uDE85":"1f685","\uD83D\uDE87":"1f687","\uD83D\uDE89":"1f689","\uD83D\uDE8C":"1f68c","\uD83D\uDE8F":"1f68f","\uD83D\uDE91":"1f691","\uD83D\uDE92":"1f692","\uD83D\uDE93":"1f693","\uD83D\uDE95":"1f695","\uD83D\uDE97":"1f697","\uD83D\uDE99":"1f699","\uD83D\uDE9A":"1f69a","\uD83D\uDEA2":"1f6a2","\uD83D\uDEA4":"1f6a4","\uD83D\uDEA5":"1f6a5","\uD83D\uDEA7":"1f6a7","\uD83D\uDEA8":"1f6a8","\uD83D\uDEA9":"1f6a9","\uD83D\uDEAA":"1f6aa","\uD83D\uDEAB":"1f6ab","\uD83D\uDEAC":"1f6ac","\uD83D\uDEAD":"1f6ad","\uD83D\uDEB2":"1f6b2","\uD83D\uDEB6":"1f6b6","\uD83D\uDEB9":"1f6b9","\uD83D\uDEBA":"1f6ba","\uD83D\uDEBB":"1f6bb","\uD83D\uDEBC":"1f6bc","\uD83D\uDEBD":"1f6bd","\uD83D\uDEBE":"1f6be","\uD83D\uDEC0":"1f6c0","\uD83E\uDD18":"1f918","\uD83D\uDE00":"1f600","\uD83D\uDE07":"1f607","\uD83D\uDE08":"1f608","\uD83D\uDE0E":"1f60e","\uD83D\uDE10":"1f610","\uD83D\uDE11":"1f611","\uD83D\uDE15":"1f615","\uD83D\uDE17":"1f617","\uD83D\uDE19":"1f619","\uD83D\uDE1B":"1f61b","\uD83D\uDE1F":"1f61f","\uD83D\uDE26":"1f626","\uD83D\uDE27":"1f627","\uD83D\uDE2C":"1f62c","\uD83D\uDE2E":"1f62e","\uD83D\uDE2F":"1f62f","\uD83D\uDE34":"1f634","\uD83D\uDE36":"1f636","\uD83D\uDE81":"1f681","\uD83D\uDE82":"1f682","\uD83D\uDE86":"1f686","\uD83D\uDE88":"1f688","\uD83D\uDE8A":"1f68a","\uD83D\uDE8D":"1f68d","\uD83D\uDE8E":"1f68e","\uD83D\uDE90":"1f690","\uD83D\uDE94":"1f694","\uD83D\uDE96":"1f696","\uD83D\uDE98":"1f698","\uD83D\uDE9B":"1f69b","\uD83D\uDE9C":"1f69c","\uD83D\uDE9D":"1f69d","\uD83D\uDE9E":"1f69e","\uD83D\uDE9F":"1f69f","\uD83D\uDEA0":"1f6a0","\uD83D\uDEA1":"1f6a1","\uD83D\uDEA3":"1f6a3","\uD83D\uDEA6":"1f6a6","\uD83D\uDEAE":"1f6ae","\uD83D\uDEAF":"1f6af","\uD83D\uDEB0":"1f6b0","\uD83D\uDEB1":"1f6b1","\uD83D\uDEB3":"1f6b3","\uD83D\uDEB4":"1f6b4","\uD83D\uDEB5":"1f6b5","\uD83D\uDEB7":"1f6b7","\uD83D\uDEB8":"1f6b8","\uD83D\uDEBF":"1f6bf","\uD83D\uDEC1":"1f6c1","\uD83D\uDEC2":"1f6c2","\uD83D\uDEC3":"1f6c3","\uD83D\uDEC4":"1f6c4","\uD83D\uDEC5":"1f6c5","\uD83C\uDF0D":"1f30d","\uD83C\uDF0E":"1f30e","\uD83C\uDF10":"1f310","\uD83C\uDF12":"1f312","\uD83C\uDF16":"1f316","\uD83C\uDF17":"1f317","\uD83C\uDF18":"1f318","\uD83C\uDF1A":"1f31a","\uD83C\uDF1C":"1f31c","\uD83C\uDF1D":"1f31d","\uD83C\uDF1E":"1f31e","\uD83C\uDF32":"1f332","\uD83C\uDF33":"1f333","\uD83C\uDF4B":"1f34b","\uD83C\uDF50":"1f350","\uD83C\uDF7C":"1f37c","\uD83C\uDFC7":"1f3c7","\uD83C\uDFC9":"1f3c9","\uD83C\uDFE4":"1f3e4","\uD83D\uDC00":"1f400","\uD83D\uDC01":"1f401","\uD83D\uDC02":"1f402","\uD83D\uDC03":"1f403","\uD83D\uDC04":"1f404","\uD83D\uDC05":"1f405","\uD83D\uDC06":"1f406","\uD83D\uDC07":"1f407","\uD83D\uDC08":"1f408","\uD83D\uDC09":"1f409","\uD83D\uDC0A":"1f40a","\uD83D\uDC0B":"1f40b","\uD83D\uDC0F":"1f40f","\uD83D\uDC10":"1f410","\uD83D\uDC13":"1f413","\uD83D\uDC15":"1f415","\uD83D\uDC16":"1f416","\uD83D\uDC2A":"1f42a","\uD83D\uDC65":"1f465","\uD83D\uDC6C":"1f46c","\uD83D\uDC6D":"1f46d","\uD83D\uDCAD":"1f4ad","\uD83D\uDCB6":"1f4b6","\uD83D\uDCB7":"1f4b7","\uD83D\uDCEC":"1f4ec","\uD83D\uDCED":"1f4ed","\uD83D\uDCEF":"1f4ef","\uD83D\uDCF5":"1f4f5","\uD83D\uDD00":"1f500","\uD83D\uDD01":"1f501","\uD83D\uDD02":"1f502","\uD83D\uDD04":"1f504","\uD83D\uDD05":"1f505","\uD83D\uDD06":"1f506","\uD83D\uDD07":"1f507","\uD83D\uDD09":"1f509","\uD83D\uDD15":"1f515","\uD83D\uDD2C":"1f52c","\uD83D\uDD2D":"1f52d","\uD83D\uDD5C":"1f55c","\uD83D\uDD5D":"1f55d","\uD83D\uDD5E":"1f55e","\uD83D\uDD5F":"1f55f","\uD83D\uDD60":"1f560","\uD83D\uDD61":"1f561","\uD83D\uDD62":"1f562","\uD83D\uDD63":"1f563","\uD83D\uDD64":"1f564","\uD83D\uDD65":"1f565","\uD83D\uDD66":"1f566","\uD83D\uDD67":"1f567","\uD83D\uDD08":"1f508","\uD83D\uDE8B":"1f68b","\uD83C\uDF9E":"1f39e","\uD83C\uDF9F":"1f39f","\uD83C\uDFC5":"1f3c5","\uD83C\uDFCB":"1f3cb","\uD83C\uDFCC":"1f3cc","\uD83C\uDFCD":"1f3cd","\uD83C\uDFCE":"1f3ce","\uD83C\uDF96":"1f396","\uD83C\uDF97":"1f397","\uD83C\uDF36":"1f336","\uD83C\uDF27":"1f327","\uD83C\uDF28":"1f328","\uD83C\uDF29":"1f329","\uD83C\uDF2A":"1f32a","\uD83C\uDF2B":"1f32b","\uD83C\uDF2C":"1f32c","\uD83D\uDC3F":"1f43f","\uD83D\uDD77":"1f577","\uD83D\uDD78":"1f578","\uD83C\uDF21":"1f321","\uD83C\uDF99":"1f399","\uD83C\uDF9A":"1f39a","\uD83C\uDF9B":"1f39b","\uD83C\uDFF3":"1f3f3","\uD83C\uDFF4":"1f3f4","\uD83C\uDFF5":"1f3f5","\uD83C\uDFF7":"1f3f7","\uD83D\uDCF8":"1f4f8","\uD83D\uDCFD":"1f4fd","\uD83D\uDD4A":"1f54a","\uD83D\uDD6F":"1f56f","\uD83D\uDD70":"1f570","\uD83D\uDD73":"1f573","\uD83D\uDD76":"1f576","\uD83D\uDD79":"1f579","\uD83D\uDD87":"1f587","\uD83D\uDD8A":"1f58a","\uD83D\uDD8B":"1f58b","\uD83D\uDD8C":"1f58c","\uD83D\uDD8D":"1f58d","\uD83D\uDDA5":"1f5a5","\uD83D\uDDA8":"1f5a8","\uD83D\uDDB2":"1f5b2","\uD83D\uDDBC":"1f5bc","\uD83D\uDDC2":"1f5c2","\uD83D\uDDC3":"1f5c3","\uD83D\uDDC4":"1f5c4","\uD83D\uDDD1":"1f5d1","\uD83D\uDDD2":"1f5d2","\uD83D\uDDD3":"1f5d3","\uD83D\uDDDC":"1f5dc","\uD83D\uDDDE":"1f5de","\uD83D\uDDE1":"1f5e1","\uD83D\uDDE3":"1f5e3","\uD83D\uDDE8":"1f5e8","\uD83D\uDDEF":"1f5ef","\uD83D\uDDF3":"1f5f3","\uD83D\uDDFA":"1f5fa","\uD83D\uDECC":"1f6cc","\uD83D\uDEE0":"1f6e0","\uD83D\uDEE1":"1f6e1","\uD83D\uDEE2":"1f6e2","\uD83D\uDEF0":"1f6f0","\uD83C\uDF7D":"1f37d","\uD83D\uDC41":"1f441","\uD83D\uDD74":"1f574","\uD83D\uDD75":"1f575","\uD83D\uDD90":"1f590","\uD83D\uDD95":"1f595","\uD83D\uDD96":"1f596","\uD83D\uDE41":"1f641","\uD83D\uDE42":"1f642","\uD83C\uDFD4":"1f3d4","\uD83C\uDFD5":"1f3d5","\uD83C\uDFD6":"1f3d6","\uD83C\uDFD7":"1f3d7","\uD83C\uDFD8":"1f3d8","\uD83C\uDFD9":"1f3d9","\uD83C\uDFDA":"1f3da","\uD83C\uDFDB":"1f3db","\uD83C\uDFDC":"1f3dc","\uD83C\uDFDD":"1f3dd","\uD83C\uDFDE":"1f3de","\uD83C\uDFDF":"1f3df","\uD83D\uDECB":"1f6cb","\uD83D\uDECD":"1f6cd","\uD83D\uDECE":"1f6ce","\uD83D\uDECF":"1f6cf","\uD83D\uDEE3":"1f6e3","\uD83D\uDEE4":"1f6e4","\uD83D\uDEE5":"1f6e5","\uD83D\uDEE9":"1f6e9","\uD83D\uDEEB":"1f6eb","\uD83D\uDEEC":"1f6ec","\uD83D\uDEF3":"1f6f3","\uD83C\uDFFB":"1f3fb","\uD83C\uDFFC":"1f3fc","\uD83C\uDFFD":"1f3fd","\uD83C\uDFFE":"1f3fe","\uD83C\uDFFF":"1f3ff","\uD83C\uDF24":"1f324","\uD83C\uDF25":"1f325","\uD83C\uDF26":"1f326","\uD83D\uDDB1":"1f5b1","\uD83D\uDE43":"1f643","\uD83E\uDD11":"1f911","\uD83E\uDD13":"1f913","\uD83E\uDD17":"1f917","\uD83D\uDE44":"1f644","\uD83E\uDD14":"1f914","\uD83E\uDD10":"1f910","\uD83E\uDD12":"1f912","\uD83E\uDD15":"1f915","\uD83E\uDD16":"1f916","\uD83E\uDD81":"1f981","\uD83E\uDD84":"1f984","\uD83E\uDD82":"1f982","\uD83E\uDD80":"1f980","\uD83E\uDD83":"1f983","\uD83E\uDDC0":"1f9c0","\uD83C\uDF2D":"1f32d","\uD83C\uDF2E":"1f32e","\uD83C\uDF2F":"1f32f","\uD83C\uDF7F":"1f37f","\uD83C\uDF7E":"1f37e","\uD83C\uDFF9":"1f3f9","\uD83C\uDFFA":"1f3fa","\uD83D\uDED0":"1f6d0","\uD83D\uDD4B":"1f54b","\uD83D\uDD4C":"1f54c","\uD83D\uDD4D":"1f54d","\uD83D\uDD4E":"1f54e","\uD83D\uDCFF":"1f4ff","\uD83C\uDFCF":"1f3cf","\uD83C\uDFD0":"1f3d0","\uD83C\uDFD1":"1f3d1","\uD83C\uDFD2":"1f3d2","\uD83C\uDFD3":"1f3d3","\uD83C\uDFF8":"1f3f8","\uD83E\uDD41":"1f941","\uD83E\uDD90":"1f990","\uD83E\uDD91":"1f991","\uD83E\uDD5A":"1f95a","\uD83E\uDD5B":"1f95b","\uD83E\uDD5C":"1f95c","\uD83E\uDD5D":"1f95d","\uD83E\uDD5E":"1f95e","\uD83C\uDDFC":"1f1fc","\uD83C\uDDFB":"1f1fb","\uD83C\uDDFA":"1f1fa","\uD83C\uDDF9":"1f1f9","\uD83C\uDDF8":"1f1f8","\uD83C\uDDF7":"1f1f7","\uD83C\uDDF6":"1f1f6","\uD83C\uDDF5":"1f1f5","\uD83C\uDDF4":"1f1f4","\uD83C\uDDF3":"1f1f3","\uD83C\uDDF2":"1f1f2","\uD83C\uDDF1":"1f1f1","\uD83C\uDDF0":"1f1f0","\uD83C\uDDEF":"1f1ef","\uD83C\uDDEE":"1f1ee","\uD83C\uDDED":"1f1ed","\uD83C\uDDEC":"1f1ec","\uD83C\uDDEB":"1f1eb","\uD83C\uDDEA":"1f1ea","\uD83C\uDDE9":"1f1e9","\uD83C\uDDE8":"1f1e8","\uD83C\uDDE7":"1f1e7","\uD83C\uDDE6":"1f1e6","\uD83D\uDEF7":"1f6f7","\uD83D\uDEF8":"1f6f8","\uD83E\uDD1F":"1f91f","\uD83E\uDD28":"1f928","\uD83E\uDD29":"1f929","\uD83E\uDD2A":"1f92a","\uD83E\uDD2B":"1f92b","\uD83E\uDD2C":"1f92c","\uD83E\uDD2D":"1f92d","\uD83E\uDD2E":"1f92e","\uD83E\uDD2F":"1f92f","\uD83E\uDD31":"1f931","\uD83E\uDD32":"1f932","\uD83E\uDD4C":"1f94c","\uD83E\uDD5F":"1f95f","\uD83E\uDD60":"1f960","\uD83E\uDD61":"1f961","\uD83E\uDD62":"1f962","\uD83E\uDD63":"1f963","\uD83E\uDD64":"1f964","\uD83E\uDD65":"1f965","\uD83E\uDD66":"1f966","\uD83E\uDD67":"1f967","\uD83E\uDD68":"1f968","\uD83E\uDD69":"1f969","\uD83E\uDD6A":"1f96a","\uD83E\uDD6B":"1f96b","\uD83E\uDD92":"1f992","\uD83E\uDD93":"1f993","\uD83E\uDD94":"1f994","\uD83E\uDD95":"1f995","\uD83E\uDD96":"1f996","\uD83E\uDD97":"1f997","\uD83E\uDDD0":"1f9d0","\uD83E\uDDD1":"1f9d1","\uD83E\uDDD2":"1f9d2","\uD83E\uDDD3":"1f9d3","\uD83E\uDDD4":"1f9d4","\uD83E\uDDD5":"1f9d5","\uD83E\uDDD6":"1f9d6","\uD83E\uDDD7":"1f9d7","\uD83E\uDDD8":"1f9d8","\uD83E\uDDD9":"1f9d9","\uD83E\uDDDA":"1f9da","\uD83E\uDDDB":"1f9db","\uD83E\uDDDC":"1f9dc","\uD83E\uDDDD":"1f9dd","\uD83E\uDDDE":"1f9de","\uD83E\uDDDF":"1f9df","\uD83E\uDDE0":"1f9e0","\uD83E\uDDE1":"1f9e1","\uD83E\uDDE2":"1f9e2","\uD83E\uDDE3":"1f9e3","\uD83E\uDDE4":"1f9e4","\uD83E\uDDE5":"1f9e5","\uD83E\uDDE6":"1f9e6","\uD83D\uDEF9":"1f6f9","\uD83E\uDD4D":"1f94d","\uD83E\uDD4E":"1f94e","\uD83E\uDD4F":"1f94f","\uD83E\uDD6C":"1f96c","\uD83E\uDD6D":"1f96d","\uD83E\uDD6E":"1f96e","\uD83E\uDD6F":"1f96f","\uD83E\uDD70":"1f970","\uD83E\uDD73":"1f973","\uD83E\uDD74":"1f974","\uD83E\uDD75":"1f975","\uD83E\uDD76":"1f976","\uD83E\uDD7A":"1f97a","\uD83E\uDD7C":"1f97c","\uD83E\uDD7D":"1f97d","\uD83E\uDD7E":"1f97e","\uD83E\uDD7F":"1f97f","\uD83E\uDD98":"1f998","\uD83E\uDD99":"1f999","\uD83E\uDD9A":"1f99a","\uD83E\uDD9B":"1f99b","\uD83E\uDD9C":"1f99c","\uD83E\uDD9D":"1f99d","\uD83E\uDD9E":"1f99e","\uD83E\uDD9F":"1f99f","\uD83E\uDDA0":"1f9a0","\uD83E\uDDA1":"1f9a1","\uD83E\uDDA2":"1f9a2","\uD83E\uDDB0":"1f9b0","\uD83E\uDDB1":"1f9b1","\uD83E\uDDB2":"1f9b2","\uD83E\uDDB3":"1f9b3","\uD83E\uDDB4":"1f9b4","\uD83E\uDDB5":"1f9b5","\uD83E\uDDB6":"1f9b6","\uD83E\uDDB7":"1f9b7","\uD83E\uDDB8":"1f9b8","\uD83E\uDDB9":"1f9b9","\uD83E\uDDC1":"1f9c1","\uD83E\uDDC2":"1f9c2","\uD83E\uDDE7":"1f9e7","\uD83E\uDDE8":"1f9e8","\uD83E\uDDE9":"1f9e9","\uD83E\uDDEA":"1f9ea","\uD83E\uDDEB":"1f9eb","\uD83E\uDDEC":"1f9ec","\uD83E\uDDED":"1f9ed","\uD83E\uDDEE":"1f9ee","\uD83E\uDDEF":"1f9ef","\uD83E\uDDF0":"1f9f0","\uD83E\uDDF1":"1f9f1","\uD83E\uDDF2":"1f9f2","\uD83E\uDDF3":"1f9f3","\uD83E\uDDF4":"1f9f4","\uD83E\uDDF5":"1f9f5","\uD83E\uDDF6":"1f9f6","\uD83E\uDDF7":"1f9f7","\uD83E\uDDF8":"1f9f8","\uD83E\uDDF9":"1f9f9","\uD83E\uDDFA":"1f9fa","\uD83E\uDDFB":"1f9fb","\uD83E\uDDFC":"1f9fc","\uD83E\uDDFD":"1f9fd","\uD83E\uDDFE":"1f9fe","\uD83E\uDDFF":"1f9ff","\u231A":"231a","\u231B":"231b","\u23E9":"23e9","\u23EA":"23ea","\u23EB":"23eb","\u23EC":"23ec","\u23F0":"23f0","\u23F3":"23f3","\u24C2":"24c2","\u25FD":"25fd","\u25FE":"25fe","\u2600":"2600","\u2601":"2601","\u260E":"260e","\u2614":"2614","\u2615":"2615","\u261D":"261d","\u263A":"263a","\u2648":"2648","\u2649":"2649","\u264A":"264a","\u264B":"264b","\u264C":"264c","\u264D":"264d","\u264E":"264e","\u264F":"264f","\u2650":"2650","\u2651":"2651","\u2652":"2652","\u2653":"2653","\u2660":"2660","\u2663":"2663","\u2665":"2665","\u2666":"2666","\u2668":"2668","\u267B":"267b","\u267F":"267f","\u2693":"2693","\u26A1":"26a1","\u26AA":"26aa","\u26AB":"26ab","\u26BD":"26bd","\u26BE":"26be","\u26C4":"26c4","\u26C5":"26c5","\u26CE":"26ce","\u26D4":"26d4","\u26EA":"26ea","\u26F2":"26f2","\u26F3":"26f3","\u26F5":"26f5","\u26FA":"26fa","\u26FD":"26fd","\u2702":"2702","\u2705":"2705","\u2708":"2708","\u2709":"2709","\u270A":"270a","\u270B":"270b","\u270C":"270c","\u270F":"270f","\u2712":"2712","\u2728":"2728","\u2733":"2733","\u2734":"2734","\u2744":"2744","\u2747":"2747","\u274C":"274c","\u274E":"274e","\u2753":"2753","\u2754":"2754","\u2755":"2755","\u2757":"2757","\u2764":"2764","\u2795":"2795","\u2796":"2796","\u2797":"2797","\u27B0":"27b0","\u2B1B":"2b1b","\u2B1C":"2b1c","\u2B50":"2b50","\u2B55":"2b55","\u303D":"303d","\u3297":"3297","\u3299":"3299","\u27BF":"27bf","\u2328":"2328","\u270D":"270d","\u23F1":"23f1","\u23F2":"23f2","\u2602":"2602","\u2603":"2603","\u2604":"2604","\u2618":"2618","\u2620":"2620","\u2639":"2639","\u2692":"2692","\u2694":"2694","\u2696":"2696","\u2697":"2697","\u2699":"2699","\u269C":"269c","\u26B0":"26b0","\u26B1":"26b1","\u26C8":"26c8","\u26CF":"26cf","\u26D1":"26d1","\u26D3":"26d3","\u26E9":"26e9","\u26F0":"26f0","\u26F1":"26f1","\u26F4":"26f4","\u26F7":"26f7","\u26F8":"26f8","\u26F9":"26f9","\u2763":"2763","\u265F":"265f","\u267E":"267e"};

    ns.jsEscapeMapGreedy = {"\uD83D\uDC69\u2764\uD83D\uDC8B\uD83D\uDC69":"1f469-2764-1f48b-1f469","\uD83D\uDC68\u2764\uD83D\uDC8B\uD83D\uDC68":"1f468-2764-1f48b-1f468","\uD83D\uDC69\u2764\uD83D\uDC8B\uD83D\uDC68":"1f469-2764-1f48b-1f468","\uD83D\uDC69\u2764\uD83D\uDC69":"1f469-2764-1f469","\uD83D\uDC68\u2764\uD83D\uDC68":"1f468-2764-1f468","\uD83C\uDFCC\uD83C\uDFFB\u2642":"1f3cc-1f3fb-2642","\uD83C\uDFCC\uD83C\uDFFC\u2642":"1f3cc-1f3fc-2642","\uD83C\uDFCC\uD83C\uDFFD\u2642":"1f3cc-1f3fd-2642","\uD83C\uDFCC\uD83C\uDFFE\u2642":"1f3cc-1f3fe-2642","\uD83C\uDFCC\uD83C\uDFFF\u2642":"1f3cc-1f3ff-2642","\uD83C\uDFCC\uD83C\uDFFB\u2640":"1f3cc-1f3fb-2640","\uD83C\uDFCC\uD83C\uDFFC\u2640":"1f3cc-1f3fc-2640","\uD83C\uDFCC\uD83C\uDFFD\u2640":"1f3cc-1f3fd-2640","\uD83C\uDFCC\uD83C\uDFFE\u2640":"1f3cc-1f3fe-2640","\uD83C\uDFCC\uD83C\uDFFF\u2640":"1f3cc-1f3ff-2640","\uD83D\uDC68\uD83C\uDFFB\u2696":"1f468-1f3fb-2696","\uD83D\uDC68\uD83C\uDFFC\u2696":"1f468-1f3fc-2696","\uD83D\uDC68\uD83C\uDFFD\u2696":"1f468-1f3fd-2696","\uD83D\uDC68\uD83C\uDFFE\u2696":"1f468-1f3fe-2696","\uD83D\uDC68\uD83C\uDFFF\u2696":"1f468-1f3ff-2696","\uD83D\uDC69\uD83C\uDFFB\u2696":"1f469-1f3fb-2696","\uD83D\uDC69\uD83C\uDFFC\u2696":"1f469-1f3fc-2696","\uD83D\uDC69\uD83C\uDFFD\u2696":"1f469-1f3fd-2696","\uD83D\uDC69\uD83C\uDFFE\u2696":"1f469-1f3fe-2696","\uD83D\uDC69\uD83C\uDFFF\u2696":"1f469-1f3ff-2696","\uD83D\uDC68\uD83C\uDFFB\u2708":"1f468-1f3fb-2708","\uD83D\uDC68\uD83C\uDFFC\u2708":"1f468-1f3fc-2708","\uD83D\uDC68\uD83C\uDFFD\u2708":"1f468-1f3fd-2708","\uD83D\uDC68\uD83C\uDFFE\u2708":"1f468-1f3fe-2708","\uD83D\uDC68\uD83C\uDFFF\u2708":"1f468-1f3ff-2708","\uD83D\uDC69\uD83C\uDFFB\u2708":"1f469-1f3fb-2708","\uD83D\uDC69\uD83C\uDFFC\u2708":"1f469-1f3fc-2708","\uD83D\uDC69\uD83C\uDFFD\u2708":"1f469-1f3fd-2708","\uD83D\uDC69\uD83C\uDFFE\u2708":"1f469-1f3fe-2708","\uD83D\uDC69\uD83C\uDFFF\u2708":"1f469-1f3ff-2708","\uD83D\uDC69\u2764\uD83D\uDC68":"1f469-2764-1f468","\uD83D\uDC68\uD83C\uDFFB\u2695":"1f468-1f3fb-2695","\uD83D\uDC68\uD83C\uDFFC\u2695":"1f468-1f3fc-2695","\uD83D\uDC68\uD83C\uDFFD\u2695":"1f468-1f3fd-2695","\uD83D\uDC68\uD83C\uDFFE\u2695":"1f468-1f3fe-2695","\uD83D\uDC68\uD83C\uDFFF\u2695":"1f468-1f3ff-2695","\uD83D\uDC69\uD83C\uDFFB\u2695":"1f469-1f3fb-2695","\uD83D\uDC69\uD83C\uDFFC\u2695":"1f469-1f3fc-2695","\uD83D\uDC69\uD83C\uDFFD\u2695":"1f469-1f3fd-2695","\uD83D\uDC69\uD83C\uDFFE\u2695":"1f469-1f3fe-2695","\uD83D\uDC69\uD83C\uDFFF\u2695":"1f469-1f3ff-2695","\uD83D\uDC6E\uD83C\uDFFB\u2640":"1f46e-1f3fb-2640","\uD83D\uDC6E\uD83C\uDFFB\u2642":"1f46e-1f3fb-2642","\uD83D\uDC6E\uD83C\uDFFC\u2640":"1f46e-1f3fc-2640","\uD83D\uDC6E\uD83C\uDFFC\u2642":"1f46e-1f3fc-2642","\uD83D\uDC6E\uD83C\uDFFD\u2640":"1f46e-1f3fd-2640","\uD83D\uDC6E\uD83C\uDFFD\u2642":"1f46e-1f3fd-2642","\uD83D\uDC6E\uD83C\uDFFE\u2640":"1f46e-1f3fe-2640","\uD83D\uDC6E\uD83C\uDFFE\u2642":"1f46e-1f3fe-2642","\uD83D\uDC6E\uD83C\uDFFF\u2640":"1f46e-1f3ff-2640","\uD83D\uDC6E\uD83C\uDFFF\u2642":"1f46e-1f3ff-2642","\uD83D\uDC71\uD83C\uDFFB\u2640":"1f471-1f3fb-2640","\uD83D\uDC71\uD83C\uDFFB\u2642":"1f471-1f3fb-2642","\uD83D\uDC71\uD83C\uDFFC\u2640":"1f471-1f3fc-2640","\uD83D\uDC71\uD83C\uDFFC\u2642":"1f471-1f3fc-2642","\uD83D\uDC71\uD83C\uDFFD\u2640":"1f471-1f3fd-2640","\uD83D\uDC71\uD83C\uDFFD\u2642":"1f471-1f3fd-2642","\uD83D\uDC71\uD83C\uDFFE\u2640":"1f471-1f3fe-2640","\uD83D\uDC71\uD83C\uDFFE\u2642":"1f471-1f3fe-2642","\uD83D\uDC71\uD83C\uDFFF\u2640":"1f471-1f3ff-2640","\uD83D\uDC71\uD83C\uDFFF\u2642":"1f471-1f3ff-2642","\uD83D\uDC73\uD83C\uDFFB\u2640":"1f473-1f3fb-2640","\uD83D\uDC73\uD83C\uDFFB\u2642":"1f473-1f3fb-2642","\uD83D\uDC73\uD83C\uDFFC\u2640":"1f473-1f3fc-2640","\uD83D\uDC73\uD83C\uDFFC\u2642":"1f473-1f3fc-2642","\uD83D\uDC73\uD83C\uDFFD\u2640":"1f473-1f3fd-2640","\uD83D\uDC73\uD83C\uDFFD\u2642":"1f473-1f3fd-2642","\uD83D\uDC73\uD83C\uDFFE\u2640":"1f473-1f3fe-2640","\uD83D\uDC73\uD83C\uDFFE\u2642":"1f473-1f3fe-2642","\uD83D\uDC73\uD83C\uDFFF\u2640":"1f473-1f3ff-2640","\uD83D\uDC73\uD83C\uDFFF\u2642":"1f473-1f3ff-2642","\uD83D\uDC77\uD83C\uDFFB\u2640":"1f477-1f3fb-2640","\uD83D\uDC77\uD83C\uDFFB\u2642":"1f477-1f3fb-2642","\uD83D\uDC77\uD83C\uDFFC\u2640":"1f477-1f3fc-2640","\uD83D\uDC77\uD83C\uDFFC\u2642":"1f477-1f3fc-2642","\uD83D\uDC77\uD83C\uDFFD\u2640":"1f477-1f3fd-2640","\uD83D\uDC77\uD83C\uDFFD\u2642":"1f477-1f3fd-2642","\uD83D\uDC77\uD83C\uDFFE\u2640":"1f477-1f3fe-2640","\uD83D\uDC77\uD83C\uDFFE\u2642":"1f477-1f3fe-2642","\uD83D\uDC77\uD83C\uDFFF\u2640":"1f477-1f3ff-2640","\uD83D\uDC77\uD83C\uDFFF\u2642":"1f477-1f3ff-2642","\uD83D\uDC82\uD83C\uDFFB\u2640":"1f482-1f3fb-2640","\uD83D\uDC82\uD83C\uDFFB\u2642":"1f482-1f3fb-2642","\uD83D\uDC82\uD83C\uDFFC\u2640":"1f482-1f3fc-2640","\uD83D\uDC82\uD83C\uDFFC\u2642":"1f482-1f3fc-2642","\uD83D\uDC82\uD83C\uDFFD\u2640":"1f482-1f3fd-2640","\uD83D\uDC82\uD83C\uDFFD\u2642":"1f482-1f3fd-2642","\uD83D\uDC82\uD83C\uDFFE\u2640":"1f482-1f3fe-2640","\uD83D\uDC82\uD83C\uDFFE\u2642":"1f482-1f3fe-2642","\uD83D\uDC82\uD83C\uDFFF\u2640":"1f482-1f3ff-2640","\uD83D\uDC82\uD83C\uDFFF\u2642":"1f482-1f3ff-2642","\uD83D\uDD75\uD83C\uDFFB\u2640":"1f575-1f3fb-2640","\uD83D\uDD75\uD83C\uDFFB\u2642":"1f575-1f3fb-2642","\uD83D\uDD75\uD83C\uDFFC\u2640":"1f575-1f3fc-2640","\uD83D\uDD75\uD83C\uDFFC\u2642":"1f575-1f3fc-2642","\uD83D\uDD75\uD83C\uDFFD\u2640":"1f575-1f3fd-2640","\uD83D\uDD75\uD83C\uDFFD\u2642":"1f575-1f3fd-2642","\uD83D\uDD75\uD83C\uDFFE\u2640":"1f575-1f3fe-2640","\uD83D\uDD75\uD83C\uDFFE\u2642":"1f575-1f3fe-2642","\uD83D\uDD75\uD83C\uDFFF\u2640":"1f575-1f3ff-2640","\uD83D\uDD75\uD83C\uDFFF\u2642":"1f575-1f3ff-2642","\uD83C\uDFC3\uD83C\uDFFB\u2640":"1f3c3-1f3fb-2640","\uD83C\uDFC3\uD83C\uDFFB\u2642":"1f3c3-1f3fb-2642","\uD83C\uDFC3\uD83C\uDFFC\u2640":"1f3c3-1f3fc-2640","\uD83C\uDFC3\uD83C\uDFFC\u2642":"1f3c3-1f3fc-2642","\uD83C\uDFC3\uD83C\uDFFD\u2640":"1f3c3-1f3fd-2640","\uD83C\uDFC3\uD83C\uDFFD\u2642":"1f3c3-1f3fd-2642","\uD83C\uDFC3\uD83C\uDFFE\u2640":"1f3c3-1f3fe-2640","\uD83C\uDFC3\uD83C\uDFFE\u2642":"1f3c3-1f3fe-2642","\uD83C\uDFC3\uD83C\uDFFF\u2640":"1f3c3-1f3ff-2640","\uD83C\uDFC3\uD83C\uDFFF\u2642":"1f3c3-1f3ff-2642","\uD83C\uDFC4\uD83C\uDFFB\u2640":"1f3c4-1f3fb-2640","\uD83C\uDFC4\uD83C\uDFFB\u2642":"1f3c4-1f3fb-2642","\uD83C\uDFC4\uD83C\uDFFC\u2640":"1f3c4-1f3fc-2640","\uD83C\uDFC4\uD83C\uDFFC\u2642":"1f3c4-1f3fc-2642","\uD83C\uDFC4\uD83C\uDFFD\u2640":"1f3c4-1f3fd-2640","\uD83C\uDFC4\uD83C\uDFFD\u2642":"1f3c4-1f3fd-2642","\uD83C\uDFC4\uD83C\uDFFE\u2640":"1f3c4-1f3fe-2640","\uD83C\uDFC4\uD83C\uDFFE\u2642":"1f3c4-1f3fe-2642","\uD83C\uDFC4\uD83C\uDFFF\u2640":"1f3c4-1f3ff-2640","\uD83C\uDFC4\uD83C\uDFFF\u2642":"1f3c4-1f3ff-2642","\uD83C\uDFCA\uD83C\uDFFB\u2640":"1f3ca-1f3fb-2640","\uD83C\uDFCA\uD83C\uDFFB\u2642":"1f3ca-1f3fb-2642","\uD83C\uDFCA\uD83C\uDFFC\u2640":"1f3ca-1f3fc-2640","\uD83C\uDFCA\uD83C\uDFFC\u2642":"1f3ca-1f3fc-2642","\uD83C\uDFCA\uD83C\uDFFD\u2640":"1f3ca-1f3fd-2640","\uD83C\uDFCA\uD83C\uDFFD\u2642":"1f3ca-1f3fd-2642","\uD83C\uDFCA\uD83C\uDFFE\u2640":"1f3ca-1f3fe-2640","\uD83C\uDFCA\uD83C\uDFFE\u2642":"1f3ca-1f3fe-2642","\uD83C\uDFCA\uD83C\uDFFF\u2640":"1f3ca-1f3ff-2640","\uD83C\uDFCA\uD83C\uDFFF\u2642":"1f3ca-1f3ff-2642","\uD83C\uDFCB\uD83C\uDFFB\u2640":"1f3cb-1f3fb-2640","\uD83C\uDFCB\uD83C\uDFFB\u2642":"1f3cb-1f3fb-2642","\uD83C\uDFCB\uD83C\uDFFC\u2640":"1f3cb-1f3fc-2640","\uD83C\uDFCB\uD83C\uDFFC\u2642":"1f3cb-1f3fc-2642","\uD83C\uDFCB\uD83C\uDFFD\u2640":"1f3cb-1f3fd-2640","\uD83C\uDFCB\uD83C\uDFFD\u2642":"1f3cb-1f3fd-2642","\uD83C\uDFCB\uD83C\uDFFE\u2640":"1f3cb-1f3fe-2640","\uD83C\uDFCB\uD83C\uDFFE\u2642":"1f3cb-1f3fe-2642","\uD83C\uDFCB\uD83C\uDFFF\u2640":"1f3cb-1f3ff-2640","\uD83C\uDFCB\uD83C\uDFFF\u2642":"1f3cb-1f3ff-2642","\uD83D\uDC86\uD83C\uDFFB\u2640":"1f486-1f3fb-2640","\uD83D\uDC86\uD83C\uDFFB\u2642":"1f486-1f3fb-2642","\uD83D\uDC86\uD83C\uDFFC\u2640":"1f486-1f3fc-2640","\uD83D\uDC86\uD83C\uDFFC\u2642":"1f486-1f3fc-2642","\uD83D\uDC86\uD83C\uDFFD\u2640":"1f486-1f3fd-2640","\uD83D\uDC86\uD83C\uDFFD\u2642":"1f486-1f3fd-2642","\uD83D\uDC86\uD83C\uDFFE\u2640":"1f486-1f3fe-2640","\uD83D\uDC86\uD83C\uDFFE\u2642":"1f486-1f3fe-2642","\uD83D\uDC86\uD83C\uDFFF\u2640":"1f486-1f3ff-2640","\uD83D\uDC86\uD83C\uDFFF\u2642":"1f486-1f3ff-2642","\uD83D\uDC87\uD83C\uDFFB\u2640":"1f487-1f3fb-2640","\uD83D\uDC87\uD83C\uDFFB\u2642":"1f487-1f3fb-2642","\uD83D\uDC87\uD83C\uDFFC\u2640":"1f487-1f3fc-2640","\uD83D\uDC87\uD83C\uDFFC\u2642":"1f487-1f3fc-2642","\uD83D\uDC87\uD83C\uDFFD\u2640":"1f487-1f3fd-2640","\uD83D\uDC87\uD83C\uDFFD\u2642":"1f487-1f3fd-2642","\uD83D\uDC87\uD83C\uDFFE\u2640":"1f487-1f3fe-2640","\uD83D\uDC87\uD83C\uDFFE\u2642":"1f487-1f3fe-2642","\uD83D\uDC87\uD83C\uDFFF\u2640":"1f487-1f3ff-2640","\uD83D\uDC87\uD83C\uDFFF\u2642":"1f487-1f3ff-2642","\uD83D\uDEA3\uD83C\uDFFB\u2640":"1f6a3-1f3fb-2640","\uD83D\uDEA3\uD83C\uDFFB\u2642":"1f6a3-1f3fb-2642","\uD83D\uDEA3\uD83C\uDFFC\u2640":"1f6a3-1f3fc-2640","\uD83D\uDEA3\uD83C\uDFFC\u2642":"1f6a3-1f3fc-2642","\uD83D\uDEA3\uD83C\uDFFD\u2640":"1f6a3-1f3fd-2640","\uD83D\uDEA3\uD83C\uDFFD\u2642":"1f6a3-1f3fd-2642","\uD83D\uDEA3\uD83C\uDFFE\u2640":"1f6a3-1f3fe-2640","\uD83D\uDEA3\uD83C\uDFFE\u2642":"1f6a3-1f3fe-2642","\uD83D\uDEA3\uD83C\uDFFF\u2640":"1f6a3-1f3ff-2640","\uD83D\uDEA3\uD83C\uDFFF\u2642":"1f6a3-1f3ff-2642","\uD83D\uDEB4\uD83C\uDFFB\u2640":"1f6b4-1f3fb-2640","\uD83D\uDEB4\uD83C\uDFFB\u2642":"1f6b4-1f3fb-2642","\uD83D\uDEB4\uD83C\uDFFC\u2640":"1f6b4-1f3fc-2640","\uD83D\uDEB4\uD83C\uDFFC\u2642":"1f6b4-1f3fc-2642","\uD83D\uDEB4\uD83C\uDFFD\u2640":"1f6b4-1f3fd-2640","\uD83D\uDEB4\uD83C\uDFFD\u2642":"1f6b4-1f3fd-2642","\uD83D\uDEB4\uD83C\uDFFE\u2640":"1f6b4-1f3fe-2640","\uD83D\uDEB4\uD83C\uDFFE\u2642":"1f6b4-1f3fe-2642","\uD83D\uDEB4\uD83C\uDFFF\u2640":"1f6b4-1f3ff-2640","\uD83D\uDEB4\uD83C\uDFFF\u2642":"1f6b4-1f3ff-2642","\uD83D\uDEB5\uD83C\uDFFB\u2640":"1f6b5-1f3fb-2640","\uD83D\uDEB5\uD83C\uDFFB\u2642":"1f6b5-1f3fb-2642","\uD83D\uDEB5\uD83C\uDFFC\u2640":"1f6b5-1f3fc-2640","\uD83D\uDEB5\uD83C\uDFFC\u2642":"1f6b5-1f3fc-2642","\uD83D\uDEB5\uD83C\uDFFD\u2640":"1f6b5-1f3fd-2640","\uD83D\uDEB5\uD83C\uDFFD\u2642":"1f6b5-1f3fd-2642","\uD83D\uDEB5\uD83C\uDFFE\u2640":"1f6b5-1f3fe-2640","\uD83D\uDEB5\uD83C\uDFFE\u2642":"1f6b5-1f3fe-2642","\uD83D\uDEB5\uD83C\uDFFF\u2640":"1f6b5-1f3ff-2640","\uD83D\uDEB5\uD83C\uDFFF\u2642":"1f6b5-1f3ff-2642","\uD83D\uDEB6\uD83C\uDFFB\u2640":"1f6b6-1f3fb-2640","\uD83D\uDEB6\uD83C\uDFFB\u2642":"1f6b6-1f3fb-2642","\uD83D\uDEB6\uD83C\uDFFC\u2640":"1f6b6-1f3fc-2640","\uD83D\uDEB6\uD83C\uDFFC\u2642":"1f6b6-1f3fc-2642","\uD83D\uDEB6\uD83C\uDFFD\u2640":"1f6b6-1f3fd-2640","\uD83D\uDEB6\uD83C\uDFFD\u2642":"1f6b6-1f3fd-2642","\uD83D\uDEB6\uD83C\uDFFE\u2640":"1f6b6-1f3fe-2640","\uD83D\uDEB6\uD83C\uDFFE\u2642":"1f6b6-1f3fe-2642","\uD83D\uDEB6\uD83C\uDFFF\u2640":"1f6b6-1f3ff-2640","\uD83D\uDEB6\uD83C\uDFFF\u2642":"1f6b6-1f3ff-2642","\uD83E\uDD38\uD83C\uDFFB\u2640":"1f938-1f3fb-2640","\uD83E\uDD38\uD83C\uDFFB\u2642":"1f938-1f3fb-2642","\uD83E\uDD38\uD83C\uDFFC\u2640":"1f938-1f3fc-2640","\uD83E\uDD38\uD83C\uDFFC\u2642":"1f938-1f3fc-2642","\uD83E\uDD38\uD83C\uDFFD\u2640":"1f938-1f3fd-2640","\uD83E\uDD38\uD83C\uDFFD\u2642":"1f938-1f3fd-2642","\uD83E\uDD38\uD83C\uDFFE\u2640":"1f938-1f3fe-2640","\uD83E\uDD38\uD83C\uDFFE\u2642":"1f938-1f3fe-2642","\uD83E\uDD38\uD83C\uDFFF\u2640":"1f938-1f3ff-2640","\uD83E\uDD38\uD83C\uDFFF\u2642":"1f938-1f3ff-2642","\uD83E\uDD39\uD83C\uDFFB\u2640":"1f939-1f3fb-2640","\uD83E\uDD39\uD83C\uDFFB\u2642":"1f939-1f3fb-2642","\uD83E\uDD39\uD83C\uDFFC\u2640":"1f939-1f3fc-2640","\uD83E\uDD39\uD83C\uDFFC\u2642":"1f939-1f3fc-2642","\uD83E\uDD39\uD83C\uDFFD\u2640":"1f939-1f3fd-2640","\uD83E\uDD39\uD83C\uDFFD\u2642":"1f939-1f3fd-2642","\uD83E\uDD39\uD83C\uDFFE\u2640":"1f939-1f3fe-2640","\uD83E\uDD39\uD83C\uDFFE\u2642":"1f939-1f3fe-2642","\uD83E\uDD39\uD83C\uDFFF\u2640":"1f939-1f3ff-2640","\uD83E\uDD39\uD83C\uDFFF\u2642":"1f939-1f3ff-2642","\uD83E\uDD3D\uD83C\uDFFB\u2640":"1f93d-1f3fb-2640","\uD83E\uDD3D\uD83C\uDFFB\u2642":"1f93d-1f3fb-2642","\uD83E\uDD3D\uD83C\uDFFC\u2640":"1f93d-1f3fc-2640","\uD83E\uDD3D\uD83C\uDFFC\u2642":"1f93d-1f3fc-2642","\uD83E\uDD3D\uD83C\uDFFD\u2640":"1f93d-1f3fd-2640","\uD83E\uDD3D\uD83C\uDFFD\u2642":"1f93d-1f3fd-2642","\uD83E\uDD3D\uD83C\uDFFE\u2640":"1f93d-1f3fe-2640","\uD83E\uDD3D\uD83C\uDFFE\u2642":"1f93d-1f3fe-2642","\uD83E\uDD3D\uD83C\uDFFF\u2640":"1f93d-1f3ff-2640","\uD83E\uDD3D\uD83C\uDFFF\u2642":"1f93d-1f3ff-2642","\uD83E\uDD3E\uD83C\uDFFB\u2640":"1f93e-1f3fb-2640","\uD83E\uDD3E\uD83C\uDFFB\u2642":"1f93e-1f3fb-2642","\uD83E\uDD3E\uD83C\uDFFC\u2640":"1f93e-1f3fc-2640","\uD83E\uDD3E\uD83C\uDFFC\u2642":"1f93e-1f3fc-2642","\uD83E\uDD3E\uD83C\uDFFD\u2640":"1f93e-1f3fd-2640","\uD83E\uDD3E\uD83C\uDFFD\u2642":"1f93e-1f3fd-2642","\uD83E\uDD3E\uD83C\uDFFE\u2640":"1f93e-1f3fe-2640","\uD83E\uDD3E\uD83C\uDFFE\u2642":"1f93e-1f3fe-2642","\uD83E\uDD3E\uD83C\uDFFF\u2640":"1f93e-1f3ff-2640","\uD83E\uDD3E\uD83C\uDFFF\u2642":"1f93e-1f3ff-2642","\uD83D\uDC81\uD83C\uDFFB\u2640":"1f481-1f3fb-2640","\uD83D\uDC81\uD83C\uDFFB\u2642":"1f481-1f3fb-2642","\uD83D\uDC81\uD83C\uDFFC\u2640":"1f481-1f3fc-2640","\uD83D\uDC81\uD83C\uDFFC\u2642":"1f481-1f3fc-2642","\uD83D\uDC81\uD83C\uDFFD\u2640":"1f481-1f3fd-2640","\uD83D\uDC81\uD83C\uDFFD\u2642":"1f481-1f3fd-2642","\uD83D\uDC81\uD83C\uDFFE\u2640":"1f481-1f3fe-2640","\uD83D\uDC81\uD83C\uDFFE\u2642":"1f481-1f3fe-2642","\uD83D\uDC81\uD83C\uDFFF\u2640":"1f481-1f3ff-2640","\uD83D\uDC81\uD83C\uDFFF\u2642":"1f481-1f3ff-2642","\uD83D\uDE45\uD83C\uDFFB\u2640":"1f645-1f3fb-2640","\uD83D\uDE45\uD83C\uDFFB\u2642":"1f645-1f3fb-2642","\uD83D\uDE45\uD83C\uDFFC\u2640":"1f645-1f3fc-2640","\uD83D\uDE45\uD83C\uDFFC\u2642":"1f645-1f3fc-2642","\uD83D\uDE45\uD83C\uDFFD\u2640":"1f645-1f3fd-2640","\uD83D\uDE45\uD83C\uDFFD\u2642":"1f645-1f3fd-2642","\uD83D\uDE45\uD83C\uDFFE\u2640":"1f645-1f3fe-2640","\uD83D\uDE45\uD83C\uDFFE\u2642":"1f645-1f3fe-2642","\uD83D\uDE45\uD83C\uDFFF\u2640":"1f645-1f3ff-2640","\uD83D\uDE45\uD83C\uDFFF\u2642":"1f645-1f3ff-2642","\uD83D\uDE46\uD83C\uDFFB\u2640":"1f646-1f3fb-2640","\uD83D\uDE46\uD83C\uDFFB\u2642":"1f646-1f3fb-2642","\uD83D\uDE46\uD83C\uDFFC\u2640":"1f646-1f3fc-2640","\uD83D\uDE46\uD83C\uDFFC\u2642":"1f646-1f3fc-2642","\uD83D\uDE46\uD83C\uDFFD\u2640":"1f646-1f3fd-2640","\uD83D\uDE46\uD83C\uDFFD\u2642":"1f646-1f3fd-2642","\uD83D\uDE46\uD83C\uDFFE\u2640":"1f646-1f3fe-2640","\uD83D\uDE46\uD83C\uDFFE\u2642":"1f646-1f3fe-2642","\uD83D\uDE46\uD83C\uDFFF\u2640":"1f646-1f3ff-2640","\uD83D\uDE46\uD83C\uDFFF\u2642":"1f646-1f3ff-2642","\uD83D\uDE47\uD83C\uDFFB\u2640":"1f647-1f3fb-2640","\uD83D\uDE47\uD83C\uDFFB\u2642":"1f647-1f3fb-2642","\uD83D\uDE47\uD83C\uDFFC\u2640":"1f647-1f3fc-2640","\uD83D\uDE47\uD83C\uDFFC\u2642":"1f647-1f3fc-2642","\uD83D\uDE47\uD83C\uDFFD\u2640":"1f647-1f3fd-2640","\uD83D\uDE47\uD83C\uDFFD\u2642":"1f647-1f3fd-2642","\uD83D\uDE47\uD83C\uDFFE\u2640":"1f647-1f3fe-2640","\uD83D\uDE47\uD83C\uDFFE\u2642":"1f647-1f3fe-2642","\uD83D\uDE47\uD83C\uDFFF\u2640":"1f647-1f3ff-2640","\uD83D\uDE47\uD83C\uDFFF\u2642":"1f647-1f3ff-2642","\uD83D\uDE4B\uD83C\uDFFB\u2640":"1f64b-1f3fb-2640","\uD83D\uDE4B\uD83C\uDFFB\u2642":"1f64b-1f3fb-2642","\uD83D\uDE4B\uD83C\uDFFC\u2640":"1f64b-1f3fc-2640","\uD83D\uDE4B\uD83C\uDFFC\u2642":"1f64b-1f3fc-2642","\uD83D\uDE4B\uD83C\uDFFD\u2640":"1f64b-1f3fd-2640","\uD83D\uDE4B\uD83C\uDFFD\u2642":"1f64b-1f3fd-2642","\uD83D\uDE4B\uD83C\uDFFE\u2640":"1f64b-1f3fe-2640","\uD83D\uDE4B\uD83C\uDFFE\u2642":"1f64b-1f3fe-2642","\uD83D\uDE4B\uD83C\uDFFF\u2640":"1f64b-1f3ff-2640","\uD83D\uDE4B\uD83C\uDFFF\u2642":"1f64b-1f3ff-2642","\uD83D\uDE4D\uD83C\uDFFB\u2640":"1f64d-1f3fb-2640","\uD83D\uDE4D\uD83C\uDFFB\u2642":"1f64d-1f3fb-2642","\uD83D\uDE4D\uD83C\uDFFC\u2640":"1f64d-1f3fc-2640","\uD83D\uDE4D\uD83C\uDFFC\u2642":"1f64d-1f3fc-2642","\uD83D\uDE4D\uD83C\uDFFD\u2640":"1f64d-1f3fd-2640","\uD83D\uDE4D\uD83C\uDFFD\u2642":"1f64d-1f3fd-2642","\uD83D\uDE4D\uD83C\uDFFE\u2640":"1f64d-1f3fe-2640","\uD83D\uDE4D\uD83C\uDFFE\u2642":"1f64d-1f3fe-2642","\uD83D\uDE4D\uD83C\uDFFF\u2640":"1f64d-1f3ff-2640","\uD83D\uDE4D\uD83C\uDFFF\u2642":"1f64d-1f3ff-2642","\uD83D\uDE4E\uD83C\uDFFB\u2640":"1f64e-1f3fb-2640","\uD83D\uDE4E\uD83C\uDFFB\u2642":"1f64e-1f3fb-2642","\uD83D\uDE4E\uD83C\uDFFC\u2640":"1f64e-1f3fc-2640","\uD83D\uDE4E\uD83C\uDFFC\u2642":"1f64e-1f3fc-2642","\uD83D\uDE4E\uD83C\uDFFD\u2640":"1f64e-1f3fd-2640","\uD83D\uDE4E\uD83C\uDFFD\u2642":"1f64e-1f3fd-2642","\uD83D\uDE4E\uD83C\uDFFE\u2640":"1f64e-1f3fe-2640","\uD83D\uDE4E\uD83C\uDFFE\u2642":"1f64e-1f3fe-2642","\uD83D\uDE4E\uD83C\uDFFF\u2640":"1f64e-1f3ff-2640","\uD83D\uDE4E\uD83C\uDFFF\u2642":"1f64e-1f3ff-2642","\uD83E\uDD26\uD83C\uDFFB\u2640":"1f926-1f3fb-2640","\uD83E\uDD26\uD83C\uDFFB\u2642":"1f926-1f3fb-2642","\uD83E\uDD26\uD83C\uDFFC\u2640":"1f926-1f3fc-2640","\uD83E\uDD26\uD83C\uDFFC\u2642":"1f926-1f3fc-2642","\uD83E\uDD26\uD83C\uDFFD\u2640":"1f926-1f3fd-2640","\uD83E\uDD26\uD83C\uDFFD\u2642":"1f926-1f3fd-2642","\uD83E\uDD26\uD83C\uDFFE\u2640":"1f926-1f3fe-2640","\uD83E\uDD26\uD83C\uDFFE\u2642":"1f926-1f3fe-2642","\uD83E\uDD26\uD83C\uDFFF\u2640":"1f926-1f3ff-2640","\uD83E\uDD26\uD83C\uDFFF\u2642":"1f926-1f3ff-2642","\uD83E\uDD37\uD83C\uDFFB\u2640":"1f937-1f3fb-2640","\uD83E\uDD37\uD83C\uDFFB\u2642":"1f937-1f3fb-2642","\uD83E\uDD37\uD83C\uDFFC\u2640":"1f937-1f3fc-2640","\uD83E\uDD37\uD83C\uDFFC\u2642":"1f937-1f3fc-2642","\uD83E\uDD37\uD83C\uDFFD\u2640":"1f937-1f3fd-2640","\uD83E\uDD37\uD83C\uDFFD\u2642":"1f937-1f3fd-2642","\uD83E\uDD37\uD83C\uDFFE\u2640":"1f937-1f3fe-2640","\uD83E\uDD37\uD83C\uDFFE\u2642":"1f937-1f3fe-2642","\uD83E\uDD37\uD83C\uDFFF\u2640":"1f937-1f3ff-2640","\uD83E\uDD37\uD83C\uDFFF\u2642":"1f937-1f3ff-2642","\uD83E\uDDD9\uD83C\uDFFB\u2640":"1f9d9-1f3fb-2640","\uD83E\uDDD9\uD83C\uDFFB\u2642":"1f9d9-1f3fb-2642","\uD83E\uDDD9\uD83C\uDFFC\u2640":"1f9d9-1f3fc-2640","\uD83E\uDDD9\uD83C\uDFFC\u2642":"1f9d9-1f3fc-2642","\uD83E\uDDD9\uD83C\uDFFD\u2640":"1f9d9-1f3fd-2640","\uD83E\uDDD9\uD83C\uDFFD\u2642":"1f9d9-1f3fd-2642","\uD83E\uDDD9\uD83C\uDFFE\u2640":"1f9d9-1f3fe-2640","\uD83E\uDDD9\uD83C\uDFFE\u2642":"1f9d9-1f3fe-2642","\uD83E\uDDD9\uD83C\uDFFF\u2640":"1f9d9-1f3ff-2640","\uD83E\uDDD9\uD83C\uDFFF\u2642":"1f9d9-1f3ff-2642","\uD83E\uDDDA\uD83C\uDFFB\u2640":"1f9da-1f3fb-2640","\uD83E\uDDDA\uD83C\uDFFB\u2642":"1f9da-1f3fb-2642","\uD83E\uDDDA\uD83C\uDFFC\u2640":"1f9da-1f3fc-2640","\uD83E\uDDDA\uD83C\uDFFC\u2642":"1f9da-1f3fc-2642","\uD83E\uDDDA\uD83C\uDFFD\u2640":"1f9da-1f3fd-2640","\uD83E\uDDDA\uD83C\uDFFD\u2642":"1f9da-1f3fd-2642","\uD83E\uDDDA\uD83C\uDFFE\u2640":"1f9da-1f3fe-2640","\uD83E\uDDDA\uD83C\uDFFE\u2642":"1f9da-1f3fe-2642","\uD83E\uDDDA\uD83C\uDFFF\u2640":"1f9da-1f3ff-2640","\uD83E\uDDDA\uD83C\uDFFF\u2642":"1f9da-1f3ff-2642","\uD83E\uDDDB\uD83C\uDFFB\u2640":"1f9db-1f3fb-2640","\uD83E\uDDDB\uD83C\uDFFB\u2642":"1f9db-1f3fb-2642","\uD83E\uDDDB\uD83C\uDFFC\u2640":"1f9db-1f3fc-2640","\uD83E\uDDDB\uD83C\uDFFC\u2642":"1f9db-1f3fc-2642","\uD83E\uDDDB\uD83C\uDFFD\u2640":"1f9db-1f3fd-2640","\uD83E\uDDDB\uD83C\uDFFD\u2642":"1f9db-1f3fd-2642","\uD83E\uDDDB\uD83C\uDFFE\u2640":"1f9db-1f3fe-2640","\uD83E\uDDDB\uD83C\uDFFE\u2642":"1f9db-1f3fe-2642","\uD83E\uDDDB\uD83C\uDFFF\u2640":"1f9db-1f3ff-2640","\uD83E\uDDDB\uD83C\uDFFF\u2642":"1f9db-1f3ff-2642","\uD83E\uDDDC\uD83C\uDFFB\u2640":"1f9dc-1f3fb-2640","\uD83E\uDDDC\uD83C\uDFFB\u2642":"1f9dc-1f3fb-2642","\uD83E\uDDDC\uD83C\uDFFC\u2640":"1f9dc-1f3fc-2640","\uD83E\uDDDC\uD83C\uDFFC\u2642":"1f9dc-1f3fc-2642","\uD83E\uDDDC\uD83C\uDFFD\u2640":"1f9dc-1f3fd-2640","\uD83E\uDDDC\uD83C\uDFFD\u2642":"1f9dc-1f3fd-2642","\uD83E\uDDDC\uD83C\uDFFE\u2640":"1f9dc-1f3fe-2640","\uD83E\uDDDC\uD83C\uDFFE\u2642":"1f9dc-1f3fe-2642","\uD83E\uDDDC\uD83C\uDFFF\u2640":"1f9dc-1f3ff-2640","\uD83E\uDDDC\uD83C\uDFFF\u2642":"1f9dc-1f3ff-2642","\uD83E\uDDDD\uD83C\uDFFB\u2640":"1f9dd-1f3fb-2640","\uD83E\uDDDD\uD83C\uDFFB\u2642":"1f9dd-1f3fb-2642","\uD83E\uDDDD\uD83C\uDFFC\u2640":"1f9dd-1f3fc-2640","\uD83E\uDDDD\uD83C\uDFFC\u2642":"1f9dd-1f3fc-2642","\uD83E\uDDDD\uD83C\uDFFD\u2640":"1f9dd-1f3fd-2640","\uD83E\uDDDD\uD83C\uDFFD\u2642":"1f9dd-1f3fd-2642","\uD83E\uDDDD\uD83C\uDFFE\u2640":"1f9dd-1f3fe-2640","\uD83E\uDDDD\uD83C\uDFFE\u2642":"1f9dd-1f3fe-2642","\uD83E\uDDDD\uD83C\uDFFF\u2640":"1f9dd-1f3ff-2640","\uD83E\uDDDD\uD83C\uDFFF\u2642":"1f9dd-1f3ff-2642","\uD83E\uDDD6\uD83C\uDFFB\u2640":"1f9d6-1f3fb-2640","\uD83E\uDDD6\uD83C\uDFFB\u2642":"1f9d6-1f3fb-2642","\uD83E\uDDD6\uD83C\uDFFC\u2640":"1f9d6-1f3fc-2640","\uD83E\uDDD6\uD83C\uDFFC\u2642":"1f9d6-1f3fc-2642","\uD83E\uDDD6\uD83C\uDFFD\u2640":"1f9d6-1f3fd-2640","\uD83E\uDDD6\uD83C\uDFFD\u2642":"1f9d6-1f3fd-2642","\uD83E\uDDD6\uD83C\uDFFE\u2640":"1f9d6-1f3fe-2640","\uD83E\uDDD6\uD83C\uDFFE\u2642":"1f9d6-1f3fe-2642","\uD83E\uDDD6\uD83C\uDFFF\u2640":"1f9d6-1f3ff-2640","\uD83E\uDDD6\uD83C\uDFFF\u2642":"1f9d6-1f3ff-2642","\uD83E\uDDD7\uD83C\uDFFB\u2640":"1f9d7-1f3fb-2640","\uD83E\uDDD7\uD83C\uDFFB\u2642":"1f9d7-1f3fb-2642","\uD83E\uDDD7\uD83C\uDFFC\u2640":"1f9d7-1f3fc-2640","\uD83E\uDDD7\uD83C\uDFFC\u2642":"1f9d7-1f3fc-2642","\uD83E\uDDD7\uD83C\uDFFD\u2640":"1f9d7-1f3fd-2640","\uD83E\uDDD7\uD83C\uDFFD\u2642":"1f9d7-1f3fd-2642","\uD83E\uDDD7\uD83C\uDFFE\u2640":"1f9d7-1f3fe-2640","\uD83E\uDDD7\uD83C\uDFFE\u2642":"1f9d7-1f3fe-2642","\uD83E\uDDD7\uD83C\uDFFF\u2640":"1f9d7-1f3ff-2640","\uD83E\uDDD7\uD83C\uDFFF\u2642":"1f9d7-1f3ff-2642","\uD83E\uDDD8\uD83C\uDFFB\u2640":"1f9d8-1f3fb-2640","\uD83E\uDDD8\uD83C\uDFFB\u2642":"1f9d8-1f3fb-2642","\uD83E\uDDD8\uD83C\uDFFC\u2640":"1f9d8-1f3fc-2640","\uD83E\uDDD8\uD83C\uDFFC\u2642":"1f9d8-1f3fc-2642","\uD83E\uDDD8\uD83C\uDFFD\u2640":"1f9d8-1f3fd-2640","\uD83E\uDDD8\uD83C\uDFFD\u2642":"1f9d8-1f3fd-2642","\uD83E\uDDD8\uD83C\uDFFE\u2640":"1f9d8-1f3fe-2640","\uD83E\uDDD8\uD83C\uDFFE\u2642":"1f9d8-1f3fe-2642","\uD83E\uDDD8\uD83C\uDFFF\u2640":"1f9d8-1f3ff-2640","\uD83E\uDDD8\uD83C\uDFFF\u2642":"1f9d8-1f3ff-2642","\uD83E\uDDB8\uD83C\uDFFB\u2640":"1f9b8-1f3fb-2640","\uD83E\uDDB8\uD83C\uDFFB\u2642":"1f9b8-1f3fb-2642","\uD83E\uDDB8\uD83C\uDFFC\u2640":"1f9b8-1f3fc-2640","\uD83E\uDDB8\uD83C\uDFFC\u2642":"1f9b8-1f3fc-2642","\uD83E\uDDB8\uD83C\uDFFD\u2640":"1f9b8-1f3fd-2640","\uD83E\uDDB8\uD83C\uDFFD\u2642":"1f9b8-1f3fd-2642","\uD83E\uDDB8\uD83C\uDFFE\u2640":"1f9b8-1f3fe-2640","\uD83E\uDDB8\uD83C\uDFFE\u2642":"1f9b8-1f3fe-2642","\uD83E\uDDB8\uD83C\uDFFF\u2640":"1f9b8-1f3ff-2640","\uD83E\uDDB8\uD83C\uDFFF\u2642":"1f9b8-1f3ff-2642","\uD83E\uDDB9\uD83C\uDFFB\u2640":"1f9b9-1f3fb-2640","\uD83E\uDDB9\uD83C\uDFFB\u2642":"1f9b9-1f3fb-2642","\uD83E\uDDB9\uD83C\uDFFC\u2640":"1f9b9-1f3fc-2640","\uD83E\uDDB9\uD83C\uDFFC\u2642":"1f9b9-1f3fc-2642","\uD83E\uDDB9\uD83C\uDFFD\u2640":"1f9b9-1f3fd-2640","\uD83E\uDDB9\uD83C\uDFFD\u2642":"1f9b9-1f3fd-2642","\uD83E\uDDB9\uD83C\uDFFE\u2640":"1f9b9-1f3fe-2640","\uD83E\uDDB9\uD83C\uDFFE\u2642":"1f9b9-1f3fe-2642","\uD83E\uDDB9\uD83C\uDFFF\u2640":"1f9b9-1f3ff-2640","\uD83E\uDDB9\uD83C\uDFFF\u2642":"1f9b9-1f3ff-2642","\u26F9\uD83C\uDFFB\u2640":"26f9-1f3fb-2640","\u26F9\uD83C\uDFFB\u2642":"26f9-1f3fb-2642","\u26F9\uD83C\uDFFC\u2640":"26f9-1f3fc-2640","\u26F9\uD83C\uDFFC\u2642":"26f9-1f3fc-2642","\u26F9\uD83C\uDFFD\u2640":"26f9-1f3fd-2640","\u26F9\uD83C\uDFFD\u2642":"26f9-1f3fd-2642","\u26F9\uD83C\uDFFE\u2640":"26f9-1f3fe-2640","\u26F9\uD83C\uDFFE\u2642":"26f9-1f3fe-2642","\u26F9\uD83C\uDFFF\u2640":"26f9-1f3ff-2640","\u26F9\uD83C\uDFFF\u2642":"26f9-1f3ff-2642","\uD83C\uDFF3\uD83C\uDF08":"1f3f3-1f308","\uD83D\uDC41\uD83D\uDDE8":"1f441-1f5e8","\uD83D\uDC6F\u2642":"1f46f-2642","\uD83D\uDC6F\u2640":"1f46f-2640","\uD83C\uDFCC\u2642":"1f3cc-2642","\uD83C\uDFCC\u2640":"1f3cc-2640","\uD83E\uDD3C\u2642":"1f93c-2642","\uD83E\uDD3C\u2640":"1f93c-2640","\uD83E\uDD39\u2642":"1f939-2642","\uD83E\uDD39\u2640":"1f939-2640","\uD83E\uDD3E\u2642":"1f93e-2642","\uD83E\uDD3E\u2640":"1f93e-2640","\uD83E\uDD3D\u2642":"1f93d-2642","\uD83E\uDD3D\u2640":"1f93d-2640","\uD83E\uDD38\u2642":"1f938-2642","\uD83E\uDD38\u2640":"1f938-2640","\uD83D\uDEB6\u2642":"1f6b6-2642","\uD83D\uDEB6\u2640":"1f6b6-2640","\uD83D\uDEB5\u2642":"1f6b5-2642","\uD83D\uDEB5\u2640":"1f6b5-2640","\uD83D\uDEB4\u2642":"1f6b4-2642","\uD83D\uDEB4\u2640":"1f6b4-2640","\uD83D\uDEA3\u2642":"1f6a3-2642","\uD83D\uDEA3\u2640":"1f6a3-2640","\uD83C\uDFCB\u2642":"1f3cb-2642","\uD83C\uDFCB\u2640":"1f3cb-2640","\uD83C\uDFCA\u2642":"1f3ca-2642","\uD83C\uDFCA\u2640":"1f3ca-2640","\uD83C\uDFC4\u2642":"1f3c4-2642","\uD83C\uDFC4\u2640":"1f3c4-2640","\uD83C\uDFC3\u2642":"1f3c3-2642","\uD83C\uDFC3\u2640":"1f3c3-2640","\uD83E\uDD37\u2642":"1f937-2642","\uD83E\uDD37\u2640":"1f937-2640","\uD83E\uDD26\u2642":"1f926-2642","\uD83E\uDD26\u2640":"1f926-2640","\uD83D\uDE4E\u2642":"1f64e-2642","\uD83D\uDE4E\u2640":"1f64e-2640","\uD83D\uDE4D\u2642":"1f64d-2642","\uD83D\uDE4D\u2640":"1f64d-2640","\uD83D\uDE4B\u2642":"1f64b-2642","\uD83D\uDE4B\u2640":"1f64b-2640","\uD83D\uDE47\u2642":"1f647-2642","\uD83D\uDE47\u2640":"1f647-2640","\uD83D\uDE46\u2642":"1f646-2642","\uD83D\uDE46\u2640":"1f646-2640","\uD83D\uDE45\u2642":"1f645-2642","\uD83D\uDE45\u2640":"1f645-2640","\uD83D\uDC87\u2642":"1f487-2642","\uD83D\uDC87\u2640":"1f487-2640","\uD83D\uDC86\u2642":"1f486-2642","\uD83D\uDC86\u2640":"1f486-2640","\uD83D\uDC81\u2642":"1f481-2642","\uD83D\uDC81\u2640":"1f481-2640","\uD83D\uDC71\u2642":"1f471-2642","\uD83D\uDC71\u2640":"1f471-2640","\uD83D\uDC73\u2642":"1f473-2642","\uD83D\uDC73\u2640":"1f473-2640","\uD83D\uDC82\u2642":"1f482-2642","\uD83D\uDC82\u2640":"1f482-2640","\uD83D\uDD75\u2642":"1f575-2642","\uD83D\uDD75\u2640":"1f575-2640","\uD83D\uDC77\u2642":"1f477-2642","\uD83D\uDC77\u2640":"1f477-2640","\uD83D\uDC6E\u2642":"1f46e-2642","\uD83D\uDC6E\u2640":"1f46e-2640","\uD83D\uDC68\u2695":"1f468-2695","\uD83D\uDC69\u2695":"1f469-2695","\uD83D\uDC68\u2696":"1f468-2696","\uD83D\uDC69\u2696":"1f469-2696","\uD83D\uDC68\u2708":"1f468-2708","\uD83D\uDC69\u2708":"1f469-2708","\uD83E\uDDD9\u2640":"1f9d9-2640","\uD83E\uDDD9\u2642":"1f9d9-2642","\uD83E\uDDDA\u2640":"1f9da-2640","\uD83E\uDDDA\u2642":"1f9da-2642","\uD83E\uDDDB\u2640":"1f9db-2640","\uD83E\uDDDB\u2642":"1f9db-2642","\uD83E\uDDDC\u2640":"1f9dc-2640","\uD83E\uDDDC\u2642":"1f9dc-2642","\uD83E\uDDDD\u2640":"1f9dd-2640","\uD83E\uDDDD\u2642":"1f9dd-2642","\uD83E\uDDDE\u2640":"1f9de-2640","\uD83E\uDDDE\u2642":"1f9de-2642","\uD83E\uDDDF\u2640":"1f9df-2640","\uD83E\uDDDF\u2642":"1f9df-2642","\uD83E\uDDD6\u2640":"1f9d6-2640","\uD83E\uDDD6\u2642":"1f9d6-2642","\uD83E\uDDD7\u2640":"1f9d7-2640","\uD83E\uDDD7\u2642":"1f9d7-2642","\uD83E\uDDD8\u2640":"1f9d8-2640","\uD83E\uDDD8\u2642":"1f9d8-2642","\uD83E\uDDB8\u2640":"1f9b8-2640","\uD83E\uDDB8\u2642":"1f9b8-2642","\uD83E\uDDB9\u2640":"1f9b9-2640","\uD83E\uDDB9\u2642":"1f9b9-2642","\uD83C\uDFF4\u2620":"1f3f4-2620","\u26F9\u2642":"26f9-2642","\u26F9\u2640":"26f9-2640","\uD83D\uDD49":"1f549","\uD83D\uDDDD":"1f5dd","\u203C":"203c","\u2049":"2049","\u2139":"2139","\u2194":"2194","\u2195":"2195","\u2196":"2196","\u2197":"2197","\u2198":"2198","\u2199":"2199","\u21A9":"21a9","\u21AA":"21aa","\u25AA":"25aa","\u25AB":"25ab","\u25B6":"25b6","\u25C0":"25c0","\u25FB":"25fb","\u25FC":"25fc","\u2611":"2611","\u26A0":"26a0","\u2714":"2714","\u2716":"2716","\u27A1":"27a1","\u2934":"2934","\u2935":"2935","\u2B05":"2b05","\u2B06":"2b06","\u2B07":"2b07","\u3030":"3030","\u271D":"271d","\u23CF":"23cf","\u23ED":"23ed","\u23EE":"23ee","\u23EF":"23ef","\u23F8":"23f8","\u23F9":"23f9","\u23FA":"23fa","\u2622":"2622","\u2623":"2623","\u2626":"2626","\u262A":"262a","\u262E":"262e","\u262F":"262f","\u2638":"2638","\u269B":"269b","\u2721":"2721","\u2640":"2640","\u2642":"2642","\u2695":"2695"};

    ns.asciiList = {
        '*\\0/*':'1f646',
        '*\\O/*':'1f646',
        '-___-':'1f611',
        ':\'-)':'1f602',
        '\':-)':'1f605',
        '\':-D':'1f605',
        '>:-)':'1f606',
        '\':-(':'1f613',
        '>:-(':'1f620',
        ':\'-(':'1f622',
        'O:-)':'1f607',
        '0:-3':'1f607',
        '0:-)':'1f607',
        '0;^)':'1f607',
        'O;-)':'1f607',
        '0;-)':'1f607',
        'O:-3':'1f607',
        '-__-':'1f611',
        ':-Þ':'1f61b',
        '</3':'1f494',
        ':\')':'1f602',
        ':-D':'1f603',
        '\':)':'1f605',
        '\'=)':'1f605',
        '\':D':'1f605',
        '\'=D':'1f605',
        '>:)':'1f606',
        '>;)':'1f606',
        '>=)':'1f606',
        ';-)':'1f609',
        '*-)':'1f609',
        ';-]':'1f609',
        ';^)':'1f609',
        '\':(':'1f613',
        '\'=(':'1f613',
        ':-*':'1f618',
        ':^*':'1f618',
        '>:P':'1f61c',
        'X-P':'1f61c',
        '>:[':'1f61e',
        ':-(':'1f61e',
        ':-[':'1f61e',
        '>:(':'1f620',
        ':\'(':'1f622',
        ';-(':'1f622',
        '>.<':'1f623',
        '#-)':'1f635',
        '%-)':'1f635',
        'X-)':'1f635',
        '\\0/':'1f646',
        '\\O/':'1f646',
        '0:3':'1f607',
        '0:)':'1f607',
        'O:)':'1f607',
        'O=)':'1f607',
        'O:3':'1f607',
        'B-)':'1f60e',
        '8-)':'1f60e',
        'B-D':'1f60e',
        '8-D':'1f60e',
        '-_-':'1f611',
        '>:\\':'1f615',
        '>:/':'1f615',
        ':-/':'1f615',
        ':-.':'1f615',
        ':-P':'1f61b',
        ':Þ':'1f61b',
        ':-b':'1f61b',
        ':-O':'1f62e',
        'O_O':'1f62e',
        '>:O':'1f62e',
        ':-X':'1f636',
        ':-#':'1f636',
        ':-)':'1f642',
        '(y)':'1f44d',
        '<3':'2764',
        ':D':'1f603',
        '=D':'1f603',
        ';)':'1f609',
        '*)':'1f609',
        ';]':'1f609',
        ';D':'1f609',
        ':*':'1f618',
        '=*':'1f618',
        ':(':'1f61e',
        ':[':'1f61e',
        '=(':'1f61e',
        ':@':'1f620',
        ';(':'1f622',
        'D:':'1f628',
        ':$':'1f633',
        '=$':'1f633',
        '#)':'1f635',
        '%)':'1f635',
        'X)':'1f635',
        'B)':'1f60e',
        '8)':'1f60e',
        ':/':'1f615',
        ':\\':'1f615',
        '=/':'1f615',
        '=\\':'1f615',
        ':L':'1f615',
        '=L':'1f615',
        ':P':'1f61b',
        '=P':'1f61b',
        ':b':'1f61b',
        ':O':'1f62e',
        ':X':'1f636',
        ':#':'1f636',
        '=X':'1f636',
        '=#':'1f636',
        ':)':'1f642',
        '=]':'1f642',
        '=)':'1f642',
        ':]':'1f642'
    };

    ns.asciiRegexp = '(\\*\\\\0\\/\\*|\\*\\\\O\\/\\*|\\-___\\-|\\:\'\\-\\)|\'\\:\\-\\)|\'\\:\\-D|\\>\\:\\-\\)|>\\:\\-\\)|\'\\:\\-\\(|\\>\\:\\-\\(|>\\:\\-\\(|\\:\'\\-\\(|O\\:\\-\\)|0\\:\\-3|0\\:\\-\\)|0;\\^\\)|O;\\-\\)|0;\\-\\)|O\\:\\-3|\\-__\\-|\\:\\-Þ|\\:\\-Þ|\\<\\/3|<\\/3|\\:\'\\)|\\:\\-D|\'\\:\\)|\'\\=\\)|\'\\:D|\'\\=D|\\>\\:\\)|>\\:\\)|\\>;\\)|>;\\)|\\>\\=\\)|>\\=\\)|;\\-\\)|\\*\\-\\)|;\\-\\]|;\\^\\)|\'\\:\\(|\'\\=\\(|\\:\\-\\*|\\:\\^\\*|\\>\\:P|>\\:P|X\\-P|\\>\\:\\[|>\\:\\[|\\:\\-\\(|\\:\\-\\[|\\>\\:\\(|>\\:\\(|\\:\'\\(|;\\-\\(|\\>\\.\\<|>\\.<|#\\-\\)|%\\-\\)|X\\-\\)|\\\\0\\/|\\\\O\\/|0\\:3|0\\:\\)|O\\:\\)|O\\=\\)|O\\:3|B\\-\\)|8\\-\\)|B\\-D|8\\-D|\\-_\\-|\\>\\:\\\\|>\\:\\\\|\\>\\:\\/|>\\:\\/|\\:\\-\\/|\\:\\-\\.|\\:\\-P|\\:Þ|\\:Þ|\\:\\-b|\\:\\-O|O_O|\\>\\:O|>\\:O|\\:\\-X|\\:\\-#|\\:\\-\\)|\\(y\\)|\\<3|<3|\\:D|\\=D|;\\)|\\*\\)|;\\]|;D|\\:\\*|\\=\\*|\\:\\(|\\:\\[|\\=\\(|\\:@|;\\(|D\\:|\\:\\$|\\=\\$|#\\)|%\\)|X\\)|B\\)|8\\)|\\:\\/|\\:\\\\|\\=\\/|\\=\\\\|\\:L|\\=L|\\:P|\\=P|\\:b|\\:O|\\:X|\\:#|\\=X|\\=#|\\:\\)|\\=\\]|\\=\\)|\\:\\])';

    ns.emojiVersion = '4.5'; // you can [optionally] modify this to load alternate emoji versions. see readme for backwards compatibility and version options
    ns.emojiSize = '32';
    ns.greedyMatch = false; // set to true for greedy unicode matching
    ns.blacklistChars = '';
    ns.imagePathPNG = 'https://cdn.jsdelivr.net/emojione/assets/' + ns.emojiVersion + '/png/';
    ns.defaultPathPNG = ns.imagePathPNG;
    ns.fileExtension = '.png';
    ns.imageTitleTag = true; // set to false to remove title attribute from img tag
    ns.sprites = false; // if this is true then sprite markup will be used
    ns.unicodeAlt = true; // use the unicode char as the alt attribute (makes copy and pasting the resulting text better)
    ns.ascii = false; // change to true to convert ascii smileys
    ns.riskyMatchAscii = false; // set true to match ascii without leading/trailing space char

    ns.regShortNames = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|("+ns.shortnames+")", "gi");
    ns.regAscii = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|((\\s|^)"+ns.asciiRegexp+"(?=\\s|$|[!,.?]))", "gi");
    ns.regAsciiRisky = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(()"+ns.asciiRegexp+"())", "gi");

    ns.regUnicode = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|(?:\uD83C\uDFF3)\uFE0F?\u200D?(?:\uD83C\uDF08)|(?:\uD83D\uDC41)\uFE0F?\u200D?(?:\uD83D\uDDE8)\uFE0F?|[#-9]\uFE0F?\u20E3|(?:(?:\uD83C\uDFF4)(?:\uDB40[\uDC60-\uDCFF]){1,6})|(?:\uD83C[\uDDE0-\uDDFF]){2}|(?:(?:\uD83D[\uDC68\uDC69]))\uFE0F?(?:\uD83C[\uDFFA-\uDFFF])?\u200D?(?:[\u2695\u2696\u2708]|\uD83C[\uDF3E-\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83D[\uDC68\uDC69]|\uD83E[\uDDD0-\uDDDF])(?:\uD83C[\uDFFA-\uDFFF])?\u200D?[\u2640\u2642\u2695\u2696\u2708]?\uFE0F?|(?:(?:\u2764|\uD83D[\uDC66-\uDC69\uDC8B])[\u200D\uFE0F]{0,2}){1,3}(?:\u2764|\uD83D[\uDC66-\uDC69\uDC8B])|(?:(?:\u2764|\uD83D[\uDC66-\uDC69\uDC8B])\uFE0F?){2,4}|(?:\uD83D[\uDC68\uDC69\uDC6E\uDC71-\uDC87\uDD75\uDE45-\uDE4E]|\uD83E[\uDD26\uDD37]|\uD83C[\uDFC3-\uDFCC]|\uD83E[\uDD38-\uDD3E]|\uD83D[\uDEA3-\uDEB6]|\u26f9|\uD83D\uDC6F)\uFE0F?(?:\uD83C[\uDFFB-\uDFFF])?\u200D?[\u2640\u2642]?\uFE0F?|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85-\uDFCC]|\uD83D[\uDC42-\uDCAA\uDD74-\uDD96\uDE45-\uDE4F\uDEA3-\uDECC]|\uD83E[\uDD18-\uDD3E])\uFE0F?(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u2194-\u2199\u21a9-\u21aa]\uFE0F?|[\u0023\u002a]|[\u3030\u303d]\uFE0F?|(?:\ud83c[\udd70-\udd71]|\ud83c\udd8e|\ud83c[\udd91-\udd9a])\uFE0F?|\u24c2\uFE0F?|[\u3297\u3299]\uFE0F?|(?:\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51])\uFE0F?|[\u203c\u2049]\uFE0F?|[\u25aa-\u25ab\u25b6\u25c0\u25fb-\u25fe]\uFE0F?|[\u00a9\u00ae]\uFE0F?|[\u2122\u2139]\uFE0F?|\ud83c\udc04\uFE0F?|[\u2b05-\u2b07\u2b1b-\u2b1c\u2b50\u2b55]\uFE0F?|[\u231a-\u231b\u2328\u23cf\u23e9-\u23f3\u23f8-\u23fa]\uFE0F?|\ud83c\udccf|[\u2934\u2935]\uFE0F?)|[\u2700-\u27bf]\uFE0F?|[\ud800-\udbff][\udc00-\udfff]\uFE0F?|[\u2600-\u26FF]\uFE0F?|[\u0030-\u0039]\uFE0F", "g");

    ns.toImage = function(str) {
        str = ns.toShort(str);
        str = ns.shortnameToImage(str);
        str = ns.wipeVS16(str);
        return str;
    };

    ns.unicodeToImage = function(str) {
        return str;
    };

    ns.wipeVS16 = function(str) {
        var find = ns.vs16Regex();
        return ns.replaceAllVS16(str, find);
    };

    // Uses toShort to transform all unicode into a standard shortname
    // then transforms the shortname into unicode
    // This is done for standardization when converting several unicode types
    ns.unifyUnicode = function(str) {
        str = ns.toShort(str);
        str = ns.shortnameToUnicode(str);
        return str;
    };

    // Replace shortnames (:wink:) with Ascii equivalents ( ;^) )
    // Useful for systems that dont support unicode nor images
    ns.shortnameToAscii = function(str) {
        var unicode,
            // something to keep in mind here is that array flip will destroy
            // half of the ascii text "emojis" because the unicode numbers are duplicated
            // this is ok for what it's being used for
            unicodeToAscii = ns.objectFlip(ns.asciiList);

        str = str.replace(ns.regShortNames, function(shortname) {
            if( (typeof shortname === 'undefined') || (shortname === '') || (!(shortname in ns.emojioneList)) ) {
                // if the shortname doesnt exist just return the entire match
                return shortname;
            }
            else {
                unicode = ns.emojioneList[shortname].uc_output;
                if(typeof unicodeToAscii[unicode] !== 'undefined') {
                    return unicodeToAscii[unicode];
                } else {
                    return shortname;
                }
            }
        });
        return str;
    };

    // will output unicode from shortname
    // useful for sending emojis back to mobile devices
    ns.shortnameToUnicode = function(str) {
        // replace regular shortnames first
        var unicode,fname;
        str = str.replace(ns.regShortNames, function(shortname) {
            if( (typeof shortname === 'undefined') || (shortname === '') || (!(shortname in ns.emojioneList)) ) {
                // if the shortname doesnt exist just return the entire matchhju
                return shortname;
            }
            unicode = ns.emojioneList[shortname].uc_output.toUpperCase();
            fname = ns.emojioneList[shortname].uc_base;
            return ns.convert(unicode);
        });

        // if ascii smileys are turned on, then we'll replace them!
        if (ns.ascii) {

            var asciiRX = ns.riskyMatchAscii ? ns.regAsciiRisky : ns.regAscii;

            str = str.replace(asciiRX, function(entire, m1, m2, m3) {
                if( (typeof m3 === 'undefined') || (m3 === '') || (!(ns.unescapeHTML(m3) in ns.asciiList)) ) {
                    // if the ascii doesnt exist just return the entire match
                    return entire;
                }

                m3 = ns.unescapeHTML(m3);
                unicode = ns.asciiList[m3].toUpperCase();
                return m2+ns.convert(unicode);
            });
        }

        return str;
    };

    ns.shortnameToImage = function(str) {
        // replace regular shortnames first
        var replaceWith,shortname,unicode,fname,alt,category,title,size,ePath;
        var mappedUnicode = ns.mapUnicodeToShort();
        str = str.replace(ns.regShortNames, function(shortname) {
            if( (typeof shortname === 'undefined') || (shortname === '') || (ns.shortnames.indexOf(shortname) === -1) ) {
                // if the shortname doesnt exist just return the entire match
                return shortname;
            }
            else {
                // map shortname to parent
                if (!ns.emojioneList[shortname]) {
                    for ( var emoji in ns.emojioneList ) {
                        if (!ns.emojioneList.hasOwnProperty(emoji) || (emoji === '')) continue;
                        if (ns.emojioneList[emoji].shortnames.indexOf(shortname) === -1) continue;
                        shortname = emoji;
                        break;
                    }
                }
                unicode = ns.emojioneList[shortname].uc_output;
                fname = ns.emojioneList[shortname].uc_base;
                category = (fname.indexOf("-1f3f") >= 0) ? 'diversity' : ns.emojioneList[shortname].category;
                title = ns.imageTitleTag ? 'title="' + shortname + '"' : '';
                size = (ns.spriteSize == '32' || ns.spriteSize == '64') ? ns.spriteSize : '32';
                //if the emoji path has been set, we'll use the provided path, otherwise we'll use the default path
                ePath = (ns.defaultPathPNG !== ns.imagePathPNG) ? ns.imagePathPNG : ns.defaultPathPNG + ns.emojiSize + '/';

                // depending on the settings, we'll either add the native unicode as the alt tag, otherwise the shortname
                alt = (ns.unicodeAlt) ? ns.convert(unicode.toUpperCase()) : shortname;

                if(ns.sprites) {
                    replaceWith = '<span class="emojione emojione-' + size + '-' + category + ' _' + fname + '" ' + title + '>' + alt + '</span>';
                }
                else {
                    replaceWith = '<img class="emojione" alt="' + alt + '" ' + title + ' src="' + ePath + fname + ns.fileExtension + '"/>';
                }

                return replaceWith;
            }
        });

        // if ascii smileys are turned on, then we'll replace them!
        if (ns.ascii) {

            var asciiRX = ns.riskyMatchAscii ? ns.regAsciiRisky : ns.regAscii;

            str = str.replace(asciiRX, function(entire, m1, m2, m3) {
                if( (typeof m3 === 'undefined') || (m3 === '') || (!(ns.unescapeHTML(m3) in ns.asciiList)) ) {
                    // if the ascii doesnt exist just return the entire match
                    return entire;
                }

                m3 = ns.unescapeHTML(m3);
                unicode = ns.asciiList[m3];
                shortname = mappedUnicode[unicode];
                category = (unicode.indexOf("-1f3f") >= 0) ? 'diversity' : ns.emojioneList[shortname].category;
                title = ns.imageTitleTag ? 'title="' + ns.escapeHTML(m3) + '"' : '';
                size = (ns.spriteSize == '32' || ns.spriteSize == '64') ? ns.spriteSize : '32';
                //if the emoji path has been set, we'll use the provided path, otherwise we'll use the default path
                ePath = (ns.defaultPathPNG !== ns.imagePathPNG) ? ns.imagePathPNG : ns.defaultPathPNG + ns.emojiSize + '/';

                // depending on the settings, we'll either add the native unicode as the alt tag, otherwise the shortname
                alt = (ns.unicodeAlt) ? ns.convert(unicode.toUpperCase()) : ns.escapeHTML(m3);

                if(ns.sprites) {
                    replaceWith = m2+'<span class="emojione emojione-' + size + '-' + category + ' _' + unicode +'"  ' + title + '>' + alt + '</span>';
                }
                else {
                    replaceWith = m2+'<img class="emojione" alt="'+alt+'" ' + title + ' src="' + ePath + unicode + ns.fileExtension + '"/>';
                }

                return replaceWith;
            });
        }

        return str;
    };

    // this is really just unicodeToShortname() but I opted for the shorthand name to match toImage()
    ns.toShort = function(str) {
        var find = ns.unicodeCharRegex();
        str = ns.replaceAll(str, find);
        return  str;
    };

    // for converting unicode code points and code pairs to their respective characters
    ns.convert = function(unicode) {
        if(unicode.indexOf("-") > -1) {
            var parts = [];
            var s = unicode.split('-');
            for(var i = 0; i < s.length; i++) {
                var part = parseInt(s[i], 16);
                if (part >= 0x10000 && part <= 0x10FFFF) {
                    var hi = Math.floor((part - 0x10000) / 0x400) + 0xD800;
                    var lo = ((part - 0x10000) % 0x400) + 0xDC00;
                    part = (String.fromCharCode(hi) + String.fromCharCode(lo));
                }
                else {
                    part = String.fromCharCode(part);
                }
                parts.push(part);
            }
            return parts.join('');
        }
        else {
            var s = parseInt(unicode, 16);
            if (s >= 0x10000 && s <= 0x10FFFF) {
                var hi = Math.floor((s - 0x10000) / 0x400) + 0xD800;
                var lo = ((s - 0x10000) % 0x400) + 0xDC00;
                return (String.fromCharCode(hi) + String.fromCharCode(lo));
            }
            else {
                return String.fromCharCode(s);
            }
        }
    };

    ns.escapeHTML = function (string) {
        var escaped = {
            '&' : '&amp;',
            '<' : '&lt;',
            '>' : '&gt;',
            '"' : '&quot;',
            '\'': '&#039;'
        };

        return string.replace(/[&<>"']/g, function (match) {
            return escaped[match];
        });
    };
    ns.unescapeHTML = function (string) {
        var unescaped = {
            '&amp;'  : '&',
            '&#38;'  : '&',
            '&#x26;' : '&',
            '&lt;'   : '<',
            '&#60;'  : '<',
            '&#x3C;' : '<',
            '&gt;'   : '>',
            '&#62;'  : '>',
            '&#x3E;' : '>',
            '&quot;' : '"',
            '&#34;'  : '"',
            '&#x22;' : '"',
            '&apos;' : '\'',
            '&#39;'  : '\'',
            '&#x27;' : '\''
        };

        return string.replace(/&(?:amp|#38|#x26|lt|#60|#x3C|gt|#62|#x3E|apos|#39|#x27|quot|#34|#x22);/ig, function (match) {
            return unescaped[match];
        });
    };

    ns.shortnameConversionMap = function() {
        var map = [], emoji;
        for (emoji in ns.emojioneList) {
            if (!ns.emojioneList.hasOwnProperty(emoji) || (emoji === '')) continue;
            map[ns.convert(ns.emojioneList[emoji].uc_output)] = emoji;
        }
        return map;
    };

    ns.unicodeCharRegex = function() {
        var map = [];
        for (emoji in ns.emojioneList) {
            if (!ns.emojioneList.hasOwnProperty(emoji) || (emoji === '')) continue;
            map.push(ns.convert(ns.emojioneList[emoji].uc_output));
        }
        return map.join('|');
    };

    ns.vs16Regex = function() {
        return ns.convert('fe0f');
    };

    ns.mapEmojioneList = function (addToMapStorage) {
        for (var shortname in ns.emojioneList) {
            if (!ns.emojioneList.hasOwnProperty(shortname)) { continue; }
            var unicode = ns.emojioneList[shortname].uc_base;
            addToMapStorage(unicode, shortname);
        }
    };

    ns.mapUnicodeToShort = function() {
        if (!ns.memMapShortToUnicode) {
            ns.memMapShortToUnicode = {};
            ns.mapEmojioneList(function (unicode, shortname) {
                ns.memMapShortToUnicode[unicode] = shortname;
            });
        }
        return ns.memMapShortToUnicode;
    };

    ns.memorizeReplacement = function() {
        if (!ns.unicodeReplacementRegEx || !ns.memMapShortToUnicodeCharacters) {
            var unicodeList = [];
            ns.memMapShortToUnicodeCharacters = {};
            ns.mapEmojioneList(function (unicode, shortname) {
                var emojiCharacter = ns.convert(unicode);
                ns.memMapShortToUnicodeCharacters[emojiCharacter] = shortname;
                unicodeList.push(emojiCharacter);
            });
            ns.unicodeReplacementRegEx = unicodeList.join('|');
        }
    };

    ns.mapUnicodeCharactersToShort = function() {
        ns.memorizeReplacement();
        return ns.memMapShortToUnicodeCharacters;
    };

    //reverse an object
    ns.objectFlip = function (obj) {
        var key, tmp_obj = {};

        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                tmp_obj[obj[key]] = key;
            }
        }

        return tmp_obj;
    };

    ns.escapeRegExp = function(string) {
        return string.replace(/[-[\]{}()*+?.,;:&\\^$#\s]/g, "\\$&");
    };

    ns.replaceAll = function(string, find) {
        var escapedFind = ns.escapeRegExp(find); //sorted largest output to smallest output
        var search = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|("+escapedFind+")", "gi");
        // callback prevents replacing anything inside of these common html tags as well as between an <object></object> tag
        var replace = function(entire, m1) {
            return ((typeof m1 === 'undefined') || (m1 === '')) ? entire : ns.shortnameConversionMap()[m1];
        };
        return string.replace(search, replace);
    };

    ns.replaceAllVS16 = function(string, find) {
        var escapedFind = ns.escapeRegExp(find); //sorted largest output to smallest output
        var search = new RegExp("<object[^>]*>.*?<\/object>|<span[^>]*>.*?<\/span>|<(?:object|embed|svg|img|div|span|p|a)[^>]*>|("+escapedFind+")", "gi");
        // callback prevents replacing anything inside of these common html tags as well as between an <object></object> tag
        var replace = function(entire, m1) {
            return ((typeof m1 === 'undefined') || (m1 === '')) ? entire : '';
        };
        return string.replace(search, replace);
    };

}(this.emojione = this.emojione || {}));
if(true) module.exports = this.emojione;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (html, isPaste, self) {
  var result = html ? _dompurify2.default.sanitize(html, DOMPurifyCONFIG) : null;
  return result ? self._doc.importNode(result, true) : self._doc.createDocumentFragment();
};

var _dompurify = __webpack_require__(1923);

var _dompurify2 = _interopRequireDefault(_dompurify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DOMPurifyCONFIG = {
  ALLOWED_TAGS: ['div', 'p', 'ol', 'ul', 'li', 'br', 'span', 'b', 'i', 'u', 'img', 'svg', '#text', 'h1', 'h2', 'h3', 'a', 'input'],
  ALLOWED_ATTR: ['style', 'src', 'target', 'contenteditable', 'href', 'class', 'type', 'value', 'checked', 'name', 'id'],
  ALLOW_DATA_ATTR: false,
  KEEP_CONTENT: true,
  ADD_TAGS: false,
  ADD_ATTR: false,
  WHOLE_DOCUMENT: false,
  RETURN_DOM: true,
  RETURN_DOM_FRAGMENT: true
};
// src/helpers/sanitize-html.js

_dompurify2.default.addHook('uponSanitizeElement', function (node, data) {
  var tagName = node.nodeName.toLowerCase();
  if (tagName == 'img') {
    // 絵文字以外のimgタグは削除する
    var src = node.getAttribute('src');
    if (!src.match(/\/emojione\/.+\.(png|svg)$/)) {
      node.parentNode.removeChild(node);
    }
  } else if (tagName == 'h1' || tagName == 'h2' || tagName == 'h3') {
    var element = document.createElement('div');
    element.innerHTML = '<b>' + node.innerText + '</b>';
    node.parentNode.insertBefore(element, node);
    node.parentNode.removeChild(node);
  } else if (tagName == 'a') {
    if (node.className == 'googleDoc' || node.className == 'gambaUrl') {
      var element = node.cloneNode(true);
      element.setAttribute('contenteditable', false);
      element.setAttribute('target', '_blank');
      element.setAttribute('rel', 'noopener noreferrer');
      node.parentNode.insertBefore(element, node);
      node.parentNode.removeChild(node);
    } else {
      var element = document.createElement('a');
      var href = node.getAttribute('href');
      element.innerHTML = href;
      element.setAttribute('href', href);
      element.setAttribute('contenteditable', false);
      element.setAttribute('target', '_blank');
      element.setAttribute('rel', 'noopener noreferrer');
      node.parentNode.insertBefore(element, node);
      node.parentNode.removeChild(node);
    }
  } else if (tagName == 'input') {
    var element = node.cloneNode(true);
    element.setAttribute('type', element.getAttribute('type') || 'button');
    element.id = Math.random().toString().slice(2);
    element.removeAttribute('disabled');

    var span = document.createElement('span');
    span.setAttribute('contenteditable', 'false');
    span.appendChild(element);

    node.parentNode.insertBefore(span, node);
    node.parentNode.removeChild(node);
  }
});

_dompurify2.default.addHook('uponSanitizeAttribute', function (node, data) {
  if (data.attrName == 'style') {
    if (node.nodeName.toLowerCase() == 'span') {
      var result = data.attrValue.match(/(background(-color)?: ?rgb\(255, ?255, ?119\);?|color: ?rgb\(255, ?0, ?0\);?)/);
      if (result) {
        return data.attrValue = result[1];
      } else {
        return data.attrValue = '';
      }
    } else if (node.nodeName.toLowerCase() == 'img') return data;else return data.attrValue = '';
  } else if (data.attrName == 'class') {
    if (node.nodeName.toLowerCase() != 'a' || data.attrValue != 'googleDoc') data.attrValue = '';
    return data;
  }
});

function stripDiv(node) {
  if (node.nodeName.toLowerCase() == 'div' && node.childNodes.length == 1) return stripDiv(node.childNodes[0]);else return node.parentNode;
}

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function(factory) {
    'use strict';
    /* global window: false, define: false, module: false */
    var root = typeof window === 'undefined' ? null : window;

    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){ return factory(root); }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module !== 'undefined') {
        module.exports = factory(root);
    } else {
        root.DOMPurify = factory(root);
    }
}(function factory(window) {
    'use strict';

    var DOMPurify = function(window) {
        return factory(window);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '0.9.0';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
        // not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }

    var document = window.document;
    var originalDocument = document;
    var DocumentFragment = window.DocumentFragment;
    var HTMLTemplateElement = window.HTMLTemplateElement;
    var Node = window.Node;
    var NodeFilter = window.NodeFilter;
    var NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap;
    var Text = window.Text;
    var Comment = window.Comment;
    var DOMParser = window.DOMParser;
    var XMLHttpRequest = window.XMLHttpRequest;
    var encodeURI = window.encodeURI;
    var useXHR = false;
    var useDOMParser = false; // See comment below
    
    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
        var template = document.createElement('template');
        if (template.content && template.content.ownerDocument) {
            document = template.content.ownerDocument;
        }
    }
    var implementation = document.implementation;
    var createNodeIterator = document.createNodeIterator;
    var getElementsByTagName = document.getElementsByTagName;
    var createDocumentFragment = document.createDocumentFragment;
    var importNode = originalDocument.importNode;

    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported =
        typeof implementation.createHTMLDocument !== 'undefined' &&
        document.documentMode !== 9;

    /* Add properties to a lookup table */
    var _addToSet = function(set, array) {
        var l = array.length;
        while (l--) {
            if (typeof array[l] === 'string') {
                array[l] = array[l].toLowerCase();
            }
            set[array[l]] = true;
        }
        return set;
    };

    /* Shallow clone an object */
    var _cloneObj = function(object) {
        var newObject = {};
        var property;
        for (property in object) {
            if (object.hasOwnProperty(property)) {
                newObject[property] = object[property];
            }
        }
        return newObject;
    };

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */
    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = _addToSet({}, [

        // HTML
        'a','abbr','acronym','address','area','article','aside','audio','b',
        'bdi','bdo','big','blink','blockquote','body','br','button','canvas',
        'caption','center','cite','code','col','colgroup','content','data',
        'datalist','dd','decorator','del','details','dfn','dir','div','dl','dt',
        'element','em','fieldset','figcaption','figure','font','footer','form',
        'h1','h2','h3','h4','h5','h6','head','header','hgroup','hr','html','i',
        'img','input','ins','kbd','label','legend','li','main','map','mark',
        'marquee','menu','menuitem','meter','nav','nobr','ol','optgroup',
        'option','output','p','pre','progress','q','rp','rt','ruby','s','samp',
        'section','select','shadow','small','source','spacer','span','strike',
        'strong','style','sub','summary','sup','table','tbody','td','template',
        'textarea','tfoot','th','thead','time','tr','track','tt','u','ul','var',
        'video','wbr',

        // SVG
        'svg','altglyph','altglyphdef','altglyphitem','animatecolor',
        'animatemotion','animatetransform','circle','clippath','defs','desc',
        'ellipse','filter','font','g','glyph','glyphref','hkern','image','line',
        'lineargradient','marker','mask','metadata','mpath','path','pattern',
        'polygon','polyline','radialgradient','rect','stop','switch','symbol',
        'text','textpath','title','tref','tspan','view','vkern',

        // SVG Filters
        'feBlend','feColorMatrix','feComponentTransfer','feComposite',
        'feConvolveMatrix','feDiffuseLighting','feDisplacementMap',
        'feFlood','feFuncA','feFuncB','feFuncG','feFuncR','feGaussianBlur',
        'feMerge','feMergeNode','feMorphology','feOffset',
        'feSpecularLighting','feTile','feTurbulence',

        //MathML
        'math','menclose','merror','mfenced','mfrac','mglyph','mi','mlabeledtr',
        'mmuliscripts','mn','mo','mover','mpadded','mphantom','mroot','mrow',
        'ms','mpspace','msqrt','mystyle','msub','msup','msubsup','mtable','mtd',
        'mtext','mtr','munder','munderover',

        //Text
        '#text'
    ]);

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = _addToSet({}, [

        // HTML
        'accept','action','align','alt','autocomplete','background','bgcolor',
        'border','cellpadding','cellspacing','checked','cite','class','clear','color',
        'cols','colspan','coords','datetime','default','dir','disabled',
        'download','enctype','face','for','headers','height','hidden','high','href',
        'hreflang','id','ismap','label','lang','list','loop', 'low','max',
        'maxlength','media','method','min','multiple','name','noshade','novalidate',
        'nowrap','open','optimum','pattern','placeholder','poster','preload','pubdate',
        'radiogroup','readonly','rel','required','rev','reversed','role','rows',
        'rowspan','spellcheck','scope','selected','shape','size','span',
        'srclang','start','src','step','style','summary','tabindex','title',
        'type','usemap','valign','value','width','xmlns',

        // SVG
        'accent-height','accumulate','additivive','alignment-baseline',
        'ascent','attributename','attributetype','azimuth','basefrequency',
        'baseline-shift','begin','bias','by','clip','clip-path','clip-rule',
        'color','color-interpolation','color-interpolation-filters','color-profile',
        'color-rendering','cx','cy','d','dx','dy','diffuseconstant','direction',
        'display','divisor','dur','edgemode','elevation','end','fill','fill-opacity',
        'fill-rule','filter','flood-color','flood-opacity','font-family','font-size',
        'font-size-adjust','font-stretch','font-style','font-variant','font-weight',
        'fx', 'fy','g1','g2','glyph-name','glyphref','gradientunits','gradienttransform',
        'image-rendering','in','in2','k','k1','k2','k3','k4','kerning','keypoints',
        'keysplines','keytimes','lengthadjust','letter-spacing','kernelmatrix',
        'kernelunitlength','lighting-color','local','marker-end','marker-mid',
        'marker-start','markerheight','markerunits','markerwidth','maskcontentunits',
        'maskunits','max','mask','mode','min','numoctaves','offset','operator',
        'opacity','order','orient','orientation','origin','overflow','paint-order',
        'path','pathlength','patterncontentunits','patterntransform','patternunits',
        'points','preservealpha','r','rx','ry','radius','refx','refy','repeatcount',
        'repeatdur','restart','result','rotate','scale','seed','shape-rendering',
        'specularconstant','specularexponent','spreadmethod','stddeviation','stitchtiles',
        'stop-color','stop-opacity','stroke-dasharray','stroke-dashoffset','stroke-linecap',
        'stroke-linejoin','stroke-miterlimit','stroke-opacity','stroke','stroke-width',
        'surfacescale','targetx','targety','transform','text-anchor','text-decoration',
        'text-rendering','textlength','u1','u2','unicode','values','viewbox',
        'visibility','vert-adv-y','vert-origin-x','vert-origin-y','word-spacing',
        'wrap','writing-mode','xchannelselector','ychannelselector','x','x1','x2',
        'y','y1','y2','z','zoomandpan',

        // MathML
        'accent','accentunder','bevelled','close','columnsalign','columnlines',
        'columnspan','denomalign','depth','display','displaystyle','fence',
        'frame','largeop','length','linethickness','lspace','lquote',
        'mathbackground','mathcolor','mathsize','mathvariant','maxsize',
        'minsize','movablelimits','notation','numalign','open','rowalign',
        'rowlines','rowspacing','rowspan','rspace','rquote','scriptlevel',
        'scriptminsize','scriptsizemultiplier','selection','separator',
        'separators','stretchy','subscriptshift','supscriptshift','symmetric',
        'voffset',

        // XML
        'xlink:href','xml:id','xlink:title','xml:space','xmlns:xlink'
    ]);

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Output should be safe for jQuery's $() factory? */
    var SAFE_FOR_JQUERY = false;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Specify template detection regex for SAFE_FOR_TEMPLATES mode */
    var MUSTACHE_EXPR = /\{\{[\s\S]*|[\s\S]*\}\}/gm;
    var ERB_EXPR = /<%[\s\S]*|[\s\S]*%>/gm;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html string.
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html string */
    var RETURN_DOM_FRAGMENT = false;

    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
     * `Node` is imported into the current `Document`. If this flag is not enabled the
     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
     * DOMPurify. */
    var RETURN_DOM_IMPORT = false;

    /* Output should be free from DOM clobbering attacks? */
    var SANITIZE_DOM = true;

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = _addToSet({}, [
        'audio', 'head', 'math', 'script', 'style', 'template', 'svg', 'video'
    ]);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = _addToSet({}, [
        'audio', 'video', 'img', 'source', 'image'
    ]);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = _addToSet({}, [
        'alt','class','for','id','label','name','pattern','placeholder',
        'summary','title','value','style','xmlns'
    ]);

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');

    /**
     * _parseConfig
     *
     * @param  optional config literal
     */
    var _parseConfig = function(cfg) {
        /* Shield configuration object from tampering */
        if (typeof cfg !== 'object') {
            cfg = {};
        }

        /* Set configuration parameters */
        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ?
            _addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ?
            _addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
        FORBID_TAGS = 'FORBID_TAGS' in cfg ?
            _addToSet({}, cfg.FORBID_TAGS) : {};
        FORBID_ATTR = 'FORBID_ATTR' in cfg ?
            _addToSet({}, cfg.FORBID_ATTR) : {};
        ALLOW_ARIA_ATTR     = cfg.ALLOW_ARIA_ATTR     !== false; // Default true
        ALLOW_DATA_ATTR     = cfg.ALLOW_DATA_ATTR     !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        SAFE_FOR_JQUERY     = cfg.SAFE_FOR_JQUERY     ||  false; // Default false
        SAFE_FOR_TEMPLATES  = cfg.SAFE_FOR_TEMPLATES  ||  false; // Default false
        WHOLE_DOCUMENT      = cfg.WHOLE_DOCUMENT      ||  false; // Default false
        RETURN_DOM          = cfg.RETURN_DOM          ||  false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT ||  false; // Default false
        RETURN_DOM_IMPORT   = cfg.RETURN_DOM_IMPORT   ||  false; // Default false
        FORCE_BODY          = cfg.FORCE_BODY          ||  false; // Default false
        SANITIZE_DOM        = cfg.SANITIZE_DOM        !== false; // Default true
        KEEP_CONTENT        = cfg.KEEP_CONTENT        !== false; // Default true

        if (SAFE_FOR_TEMPLATES) {
            ALLOW_DATA_ATTR = false;
        }

        if (RETURN_DOM_FRAGMENT) {
            RETURN_DOM = true;
        }

        /* Merge configuration parameters */
        if (cfg.ADD_TAGS) {
            if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
                ALLOWED_TAGS = _cloneObj(ALLOWED_TAGS);
            }
            _addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
        }
        if (cfg.ADD_ATTR) {
            if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
                ALLOWED_ATTR = _cloneObj(ALLOWED_ATTR);
            }
            _addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
        }
        if (cfg.ADD_URI_SAFE_ATTR) {
            _addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
        }

        /* Add #text in case KEEP_CONTENT is set to true */
        if (KEEP_CONTENT) { ALLOWED_TAGS['#text'] = true; }

        // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if (Object && 'freeze' in Object) { Object.freeze(cfg); }

        CONFIG = cfg;
    };

   /**
     * _forceRemove
     *
     * @param  a DOM node
     */
    var _forceRemove = function(node) {
        DOMPurify.removed.push({element: node});
        try {
            node.parentNode.removeChild(node);
        } catch (e) {
            node.outerHTML = '';
        }
    };

   /**
     * _removeAttribute
     *
     * @param  an Attribute name
     * @param  a DOM node
     */
    var _removeAttribute = function(name, node) {
        DOMPurify.removed.push({
            attribute: node.getAttributeNode(name),
            from: node
        });
        node.removeAttribute(name);
    };

   /**
     * _initDocument
     *
     * @param  a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */
    var _initDocument = function(dirty) {
        /* Create a HTML document */
        var doc, body;

        /* Fill body with bogus element */
        if (FORCE_BODY) {
            dirty = '<remove></remove>' + dirty;
        }

        /* Use XHR if necessary because Safari 10.1 and newer are buggy */
        if (useXHR) {
            try {
                dirty = encodeURI(dirty);
            } catch (e) {}
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'document';
            xhr.open('GET', 'data:text/html;charset=utf-8,' + dirty, false);
            xhr.send(null);
            doc = xhr.response;
        }

        /* Use DOMParser to workaround Firefox bug (see comment below) */
        if (useDOMParser) {
            try {
                doc = new DOMParser().parseFromString(dirty, 'text/html');
            } catch (e) {}
        }

        /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
           Safari (see comment below) */
        if (!doc || !doc.documentElement) {
            doc = implementation.createHTMLDocument('');
            body = doc.body;
            body.parentNode.removeChild(body.parentNode.firstElementChild);
            body.outerHTML = dirty;
        }

        /* Work on whole document or just its body */
        return getElementsByTagName.call(doc,
            WHOLE_DOCUMENT ? 'html' : 'body')[0];
    };

    // Safari 10.1+ (unfixed as of time of writing) has a catastrophic bug in
    // its implementation of DOMParser such that the following executes the
    // JavaScript:
    //
    // new DOMParser()
    //   .parseFromString('<svg onload=alert(document.domain)>', 'text/html');
    //
    // Later, it was also noticed that even more assumed benign and inert ways
    // of creating a document are now insecure thanks to Safari. So we work 
    // around that with a feature test and use XHR to create the document in 
    // case we really have to. That one seems safe for now.
    //
    // However, Firefox uses a different parser for innerHTML rather than
    // DOMParser (see https://bugzilla.mozilla.org/show_bug.cgi?id=1205631)
    // which means that you *must* use DOMParser, otherwise the output may
    // not be safe if used in a document.write context later.
    //
    // So we feature detect the Firefox bug and use the DOMParser if necessary.
    if (DOMPurify.isSupported) {
        (function () {
            var doc  = _initDocument('<svg><g onload="this.parentNode.remove()"></g></svg>');
            if (!doc.querySelector('svg')) {
                useXHR = true;
            }
            doc = _initDocument('<svg><p><style><img src="</style><img src=x onerror=alert(1)//">');
            if (doc.querySelector('svg img')) {
                useDOMParser = true;
            }
        }());
    }

    /**
     * _createIterator
     *
     * @param  document/fragment to create iterator for
     * @return iterator instance
     */
    var _createIterator = function(root) {
        return createNodeIterator.call(root.ownerDocument || root,
            root,
            NodeFilter.SHOW_ELEMENT
            | NodeFilter.SHOW_COMMENT
            | NodeFilter.SHOW_TEXT,
            function() { return NodeFilter.FILTER_ACCEPT; },
            false
        );
    };

    /**
     * _isClobbered
     *
     * @param  element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */
    var _isClobbered = function(elm) {
        if (elm instanceof Text || elm instanceof Comment) {
            return false;
        }
        if (  typeof elm.nodeName !== 'string'
           || typeof elm.textContent !== 'string'
           || typeof elm.removeChild !== 'function'
           || !(elm.attributes instanceof NamedNodeMap)
           || typeof elm.removeAttribute !== 'function'
           || typeof elm.setAttribute !== 'function'
        ) {
            return true;
        }
        return false;
    };

    /**
     * _isNode
     *
     * @param object to check whether it's a DOM node
     * @return true is object is a DOM node
     */
    var _isNode = function(obj) {
        return (
            typeof Node === "object" ? obj instanceof Node : obj
                && typeof obj === "object" && typeof obj.nodeType === "number"
                && typeof obj.nodeName==="string"
        );
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   node to check for permission to exist
     * @return  true if node was killed, false if left alive
     */
    var _sanitizeElements = function(currentNode) {
        var tagName, content;

        /* Execute a hook if present */
        _executeHook('beforeSanitizeElements', currentNode, null);

        /* Check if element is clobbered or can clobber */
        if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }

        /* Now let's check the element's type and name */
        tagName = currentNode.nodeName.toLowerCase();

        /* Execute a hook if present */
        _executeHook('uponSanitizeElement', currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });

        /* Remove element if anything forbids its presence */
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
            /* Keep content except for black-listed elements */
            if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]
                    && typeof currentNode.insertAdjacentHTML === 'function') {
                try {
                    currentNode.insertAdjacentHTML('AfterEnd', currentNode.innerHTML);
                } catch (e) {}
            }
            _forceRemove(currentNode);
            return true;
        }

        /* Convert markup to cover jQuery behavior */
        if (SAFE_FOR_JQUERY && !currentNode.firstElementChild &&
                (!currentNode.content || !currentNode.content.firstElementChild) &&
                /</g.test(currentNode.textContent)) {
            DOMPurify.removed.push({element: currentNode.cloneNode()});
            currentNode.innerHTML = currentNode.textContent.replace(/</g, '&lt;');
        }

        /* Sanitize element content to be template-safe */
        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
            /* Get the element's text content */
            content = currentNode.textContent;
            content = content.replace(MUSTACHE_EXPR, ' ');
            content = content.replace(ERB_EXPR, ' ');
            if (currentNode.textContent !== content) {
                DOMPurify.removed.push({element: currentNode.cloneNode()});
                currentNode.textContent = content;
            }
        }

        /* Execute a hook if present */
        _executeHook('afterSanitizeElements', currentNode, null);

        return false;
    };

    var DATA_ATTR = /^data-[\-\w.\u00B7-\uFFFF]/;
    var ARIA_ATTR = /^aria-[\-\w]+$/;
    var IS_ALLOWED_URI = /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;
    var IS_SCRIPT_OR_DATA = /^(?:\w+script|data):/i;
    /* This needs to be extensive thanks to Webkit/Blink's behavior */
    var ATTR_WHITESPACE = /[\x00-\x20\xA0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param   node to sanitize
     * @return  void
     */
    var _sanitizeAttributes = function(currentNode) {
        var attr, name, value, lcName, idAttr, attributes, hookEvent, l;
        /* Execute a hook if present */
        _executeHook('beforeSanitizeAttributes', currentNode, null);

        attributes = currentNode.attributes;

        /* Check if we have attributes; if not we might have a text node */
        if (!attributes) { return; }

        hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR
        };
        l = attributes.length;

        /* Go backwards over all attributes; safely remove bad ones */
        while (l--) {
            attr = attributes[l];
            name = attr.name;
            value = attr.value.trim();
            lcName = name.toLowerCase();

            /* Execute a hook if present */
            hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            _executeHook('uponSanitizeAttribute', currentNode, hookEvent );
            value = hookEvent.attrValue;

            /* Remove attribute */
            // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
            // remove a "name" attribute from an <img> tag that has an "id"
            // attribute at the time.
            if (lcName === 'name'  &&
                    currentNode.nodeName === 'IMG' && attributes.id) {
                idAttr = attributes.id;
                attributes = Array.prototype.slice.apply(attributes);
                _removeAttribute('id', currentNode);
                _removeAttribute(name, currentNode);
                if (attributes.indexOf(idAttr) > l) {
                    currentNode.setAttribute('id', idAttr.value);
                }
            } else if (
                  // This works around a bug in Safari, where input[type=file]
                  // cannot be dynamically set after type has been removed
                  currentNode.nodeName === 'INPUT' && lcName === 'type' &&
                  value === 'file' && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
                  continue;
            } else {
                // This avoids a crash in Safari v9.0 with double-ids.
                // The trick is to first set the id to be empty and then to
                // remove the attribute
                if (name === 'id') {
                    currentNode.setAttribute(name, '');
                }
                _removeAttribute(name, currentNode);
            }

            /* Did the hooks approve of the attribute? */
            if (!hookEvent.keepAttr) {
                continue;
            }

            /* Make sure attribute cannot clobber */
            if (SANITIZE_DOM &&
                    (lcName === 'id' || lcName === 'name') &&
                    (value in window || value in document || value in formElement)) {
                continue;
            }

            /* Sanitize attribute content to be template-safe */
            if (SAFE_FOR_TEMPLATES) {
                value = value.replace(MUSTACHE_EXPR, ' ');
                value = value.replace(ERB_EXPR, ' ');
            }

            /* Allow valid data-* attributes: At least one character after "-"
               (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
               XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
               We don't need to check the value; it's always URI safe. */
            if (ALLOW_DATA_ATTR && DATA_ATTR.test(lcName)) {
                // This attribute is safe
            }
            else if (ALLOW_ARIA_ATTR && ARIA_ATTR.test(lcName)) {
                // This attribute is safe
            }
            /* Otherwise, check the name is permitted */
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                continue;
            }
            /* Check value is safe. First, is attr inert? If so, is safe */
            else if (URI_SAFE_ATTRIBUTES[lcName]) {
                // This attribute is safe
            }
            /* Check no script, data or unknown possibly unsafe URI
               unless we know URI values are safe for that attribute */
            else if (IS_ALLOWED_URI.test(value.replace(ATTR_WHITESPACE,''))) {
                // This attribute is safe
            }
            /* Keep image data URIs alive if src/xlink:href is allowed */
            else if (
                (lcName === 'src' || lcName === 'xlink:href') &&
                value.indexOf('data:') === 0 &&
                DATA_URI_TAGS[currentNode.nodeName.toLowerCase()]) {
                // This attribute is safe
            }
            /* Allow unknown protocols: This provides support for links that
               are handled by protocol handlers which may be unknown ahead of
               time, e.g. fb:, spotify: */
            else if (
                ALLOW_UNKNOWN_PROTOCOLS &&
                !IS_SCRIPT_OR_DATA.test(value.replace(ATTR_WHITESPACE,''))) {
                // This attribute is safe
            }
            /* Check for binary attributes */
            else if (!value) {
                // binary attributes are safe at this point
            }
            /* Anything else, presume unsafe, do not add it back */
            else {
                continue;
            }

            /* Handle invalid data-* attribute set by try-catching it */
            try {
                currentNode.setAttribute(name, value);
                DOMPurify.removed.pop();
            } catch (e) {}
        }

        /* Execute a hook if present */
        _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  fragment to iterate over recursively
     * @return void
     */
    var _sanitizeShadowDOM = function(fragment) {
        var shadowNode;
        var shadowIterator = _createIterator(fragment);

        /* Execute a hook if present */
        _executeHook('beforeSanitizeShadowDOM', fragment, null);

        while ( (shadowNode = shadowIterator.nextNode()) ) {
            /* Execute a hook if present */
            _executeHook('uponSanitizeShadowNode', shadowNode, null);

            /* Sanitize tags and elements */
            if (_sanitizeElements(shadowNode)) {
                continue;
            }

            /* Deep shadow DOM detected */
            if (shadowNode.content instanceof DocumentFragment) {
                _sanitizeShadowDOM(shadowNode.content);
            }

            /* Check attributes, sanitize if necessary */
            _sanitizeAttributes(shadowNode);
        }

        /* Execute a hook if present */
        _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode
     */
    var _executeHook = function(entryPoint, currentNode, data) {
        if (!hooks[entryPoint]) { return; }

        hooks[entryPoint].forEach(function(hook) {
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    };

    /**
     * sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    DOMPurify.sanitize = function(dirty, cfg) {
        var body, importedNode, currentNode, oldNode, nodeIterator, returnNode;
        /* Make sure we have a string to sanitize.
           DO NOT return early, as this will return the wrong type if
           the user has requested a DOM object rather than a string */
        if (!dirty) {
            dirty = '<!-->';
        }

        /* Stringify, in case dirty is an object */
        if (typeof dirty !== 'string' && !_isNode(dirty)) {
            if (typeof dirty.toString !== 'function') {
                throw new TypeError('toString is not a function');
            } else {
                dirty = dirty.toString();
            }
        }

        /* Check we can run. Otherwise fall back or ignore */
        if (!DOMPurify.isSupported) {
            if (typeof window.toStaticHTML === 'object'
                || typeof window.toStaticHTML === 'function') {
                if (typeof dirty === 'string') {
                    return window.toStaticHTML(dirty);
                } else if (_isNode(dirty)) {
                    return window.toStaticHTML(dirty.outerHTML);
                }
            }
            return dirty;
        }

        /* Assign config vars */
        if (!SET_CONFIG) {
            _parseConfig(cfg);
        }

        /* Clean up removed elements */
        DOMPurify.removed = [];

        if (dirty instanceof Node) {
            /* If dirty is a DOM element, append to an empty document to avoid
               elements being stripped by the parser */
            body = _initDocument('<!-->');
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
                /* Node is already a body, use as is */
                body = importedNode;
            } else {
                body.appendChild(importedNode);
            }
        } else {
            /* Exit directly if we have nothing to do */
            if (!RETURN_DOM && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
                return dirty;
            }

            /* Initialize the document to work on */
            body = _initDocument(dirty);

            /* Check we have a DOM node from the data */
            if (!body) {
                return RETURN_DOM ? null : '';
            }
        }

        /* Remove first element node (ours) if FORCE_BODY is set */
        if (FORCE_BODY) {
            _forceRemove(body.firstChild);
        }

        /* Get node iterator */
        nodeIterator = _createIterator(body);

        /* Now start iterating over the created document */
        while ( (currentNode = nodeIterator.nextNode()) ) {

            /* Fix IE's strange behavior with manipulated textNodes #89 */
            if (currentNode.nodeType === 3 && currentNode === oldNode) {
                continue;
            }

            /* Sanitize tags and elements */
            if (_sanitizeElements(currentNode)) {
                continue;
            }

            /* Shadow DOM detected, sanitize it */
            if (currentNode.content instanceof DocumentFragment) {
                _sanitizeShadowDOM(currentNode.content);
            }

            /* Check attributes, sanitize if necessary */
            _sanitizeAttributes(currentNode);

            oldNode = currentNode;
        }

        /* Return sanitized string or DOM */
        if (RETURN_DOM) {

            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);

                while (body.firstChild) {
                    returnNode.appendChild(body.firstChild);
                }
            } else {
                returnNode = body;
            }

            if (RETURN_DOM_IMPORT) {
                /* adoptNode() is not used because internal state is not reset
                   (e.g. the past names map of a HTMLFormElement), this is safe
                   in theory but we would rather not risk another attack vector.
                   The state that is cloned by importNode() is explicitly defined
                   by the specs. */
                returnNode = importNode.call(originalDocument, returnNode, true);
            }

            return returnNode;
        }

        return WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    };

    /**
     * setConfig
     * Public method to set the configuration once
     *
     * @param {Object} configuration object
     * @return void
     */
    DOMPurify.setConfig = function(cfg) {
        _parseConfig(cfg);
        SET_CONFIG = true;
    };

    /**
     * clearConfig
     * Public method to remove the configuration
     *
     * @return void
     */
    DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
    };

    /**
     * addHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint
     * @param {Function} hookFunction
     */
    DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') { return; }
        hooks[entryPoint] = hooks[entryPoint] || [];
        hooks[entryPoint].push(hookFunction);
    };

    /**
     * removeHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint
     * @return void
     */
    DOMPurify.removeHook = function(entryPoint) {
        if (hooks[entryPoint]) {
            hooks[entryPoint].pop();
        }
    };

    /**
     * removeHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint
     * @return void
     */
    DOMPurify.removeHooks = function(entryPoint) {
        if (hooks[entryPoint]) {
            hooks[entryPoint] = [];
        }
    };

    /**
     * removeAllHooks
     * Public method to remove all DOMPurify hooks
     *
     * @return void
     */
    DOMPurify.removeAllHooks = function() {
        hooks = {};
    };

    return DOMPurify;
}));


/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = exports.navigationFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Button = __webpack_require__(334);

var _Button2 = _interopRequireDefault(_Button);

var _Link = __webpack_require__(914);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var factory = function factory(Button, Link) {
  var Navigation = function Navigation(_ref) {
    var actions = _ref.actions,
        children = _ref.children,
        className = _ref.className,
        routes = _ref.routes,
        theme = _ref.theme,
        type = _ref.type;

    var _className = (0, _classnames2.default)(theme[type], className);
    var buttons = actions.map(function (action, index) {
      return _react2.default.createElement(Button, _extends({ className: theme.button, key: index }, action));
    }); // eslint-disable-line

    var links = routes.map(function (route, index) {
      return _react2.default.createElement(Link, _extends({ className: theme.link, key: index }, route));
    }); // eslint-disable-line

    return _react2.default.createElement(
      'nav',
      { 'data-react-toolbox': 'navigation', className: _className },
      links,
      buttons,
      children
    );
  };

  Navigation.propTypes = {
    actions: _propTypes2.default.array, // eslint-disable-line
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    routes: _propTypes2.default.array, // eslint-disable-line
    theme: _propTypes2.default.shape({
      button: _propTypes2.default.string,
      horizontal: _propTypes2.default.string,
      link: _propTypes2.default.string,
      vertical: _propTypes2.default.string
    }),
    type: _propTypes2.default.oneOf(['vertical', 'horizontal'])
  };

  Navigation.defaultProps = {
    actions: [],
    className: '',
    type: 'horizontal',
    routes: []
  };

  return Navigation;
};

var Navigation = factory(_Button2.default, _Link2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.NAVIGATION)(Navigation);
exports.navigationFactory = factory;
exports.Navigation = Navigation;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1926);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--icon--20klZX7K {\n  font-size: 18px;\n  margin-right: 10px;\n}\n.theme--link--31l4I5an {\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  line-height: 1.5;\n  position: relative;\n  transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--link--31l4I5an *,\n    .theme--link--31l4I5an *::after,\n    .theme--link--31l4I5an *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--link--31l4I5an:not(.theme--active--yU2Eh-Kd) {\n  opacity: 0.5;\n}\n.theme--link--31l4I5an:hover,\n  .theme--link--31l4I5an:active {\n  opacity: 1;\n}\n.theme--link--31l4I5an > * {\n  vertical-align: middle;\n}\n.theme--link--31l4I5an > abbr {\n  text-transform: capitalize;\n}\n.theme--link--31l4I5an > small {\n  font-size: 12px;\n  margin-left: 8px;\n  text-align: center;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/link/theme.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;CACpB;AACD;EACE,2BAA2B;MACvB,sBAAsB;EAC1B,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,uDAAuD;EACvD,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,aAAa;CACd;AACD;;EAEE,WAAW;CACZ;AACD;EACE,uBAAuB;CACxB;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;CACpB","file":"theme.css","sourcesContent":[".icon {\n  font-size: 18px;\n  margin-right: 10px;\n}\n.link {\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  line-height: 1.5;\n  position: relative;\n  transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.link *,\n    .link *::after,\n    .link *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.link:not(.active) {\n  opacity: 0.5;\n}\n.link:hover,\n  .link:active {\n  opacity: 1;\n}\n.link > * {\n  vertical-align: middle;\n}\n.link > abbr {\n  text-transform: capitalize;\n}\n.link > small {\n  font-size: 12px;\n  margin-left: 8px;\n  text-align: center;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"icon": "theme--icon--20klZX7K",
	"link": "theme--link--31l4I5an",
	"active": "theme--active--yU2Eh-Kd"
};

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1928);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--horizontal--1rKDNfl9 > [data-react-toolbox='button'],\n  .theme--horizontal--1rKDNfl9 > [data-react-toolbox='link'] {\n  display: inline-block;\n  margin: 0 5px;\n}\n.theme--vertical---2mppd1Q > [data-react-toolbox='button'],\n  .theme--vertical---2mppd1Q > [data-react-toolbox='link'] {\n  display: block;\n  margin: 5px;\n}\n.theme--vertical---2mppd1Q,\n.theme--horizontal--1rKDNfl9 {\n  padding: 5px;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--vertical---2mppd1Q *,\n    .theme--vertical---2mppd1Q *::after,\n    .theme--vertical---2mppd1Q *::before,\n    .theme--horizontal--1rKDNfl9 *,\n    .theme--horizontal--1rKDNfl9 *::after,\n    .theme--horizontal--1rKDNfl9 *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--vertical---2mppd1Q > [data-react-toolbox='link'], .theme--horizontal--1rKDNfl9 > [data-react-toolbox='link'] {\n  color: rgb(0, 0, 0);\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/navigation/theme.css"],"names":[],"mappings":"AAAA;;EAEE,sBAAsB;EACtB,cAAc;CACf;AACD;;EAEE,eAAe;EACf,YAAY;CACb;AACD;;EAEE,aAAa;EACb,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;;;;EAME,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,oBAAoB;CACrB","file":"theme.css","sourcesContent":[".horizontal > [data-react-toolbox='button'],\n  .horizontal > [data-react-toolbox='link'] {\n  display: inline-block;\n  margin: 0 5px;\n}\n.vertical > [data-react-toolbox='button'],\n  .vertical > [data-react-toolbox='link'] {\n  display: block;\n  margin: 5px;\n}\n.vertical,\n.horizontal {\n  padding: 5px;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.vertical *,\n    .vertical *::after,\n    .vertical *::before,\n    .horizontal *,\n    .horizontal *::after,\n    .horizontal *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.vertical > [data-react-toolbox='link'], .horizontal > [data-react-toolbox='link'] {\n  color: rgb(0, 0, 0);\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"horizontal": "theme--horizontal--1rKDNfl9",
	"vertical": "theme--vertical---2mppd1Q"
};

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _dec, _class;
// src/web/components/rich-text-editor-template-selection-dialog.js

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactI18next = __webpack_require__(2);

var _dialog = __webpack_require__(47);

var _list = __webpack_require__(25);

var _scrollableDialogPanel = __webpack_require__(163);

var _scrollableDialogPanel2 = _interopRequireDefault(_scrollableDialogPanel);

var _button = __webpack_require__(8);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _shallowEqual = __webpack_require__(264);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TIMESTAMP_SINCE_ONE_MONTH = (0, _moment2.default)().subtract(1, 'months').unix();
var TIMESTAMP_SINCE_TEN_DAYS = (0, _moment2.default)().subtract(10, 'days').unix();
var DEFAULT_DISPLAY_COUNT = 1;
var TemplateSelectionDialog = (_dec = (0, _reactI18next.translate)(), _dec(_class = function (_PureComponent) {
  _inherits(TemplateSelectionDialog, _PureComponent);

  function TemplateSelectionDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TemplateSelectionDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TemplateSelectionDialog.__proto__ || Object.getPrototypeOf(TemplateSelectionDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = { showOldTemplates: false, recentTemplates: undefined, oldTemplates: undefined }, _this.toggleShowOldTemplates = function () {
      return _this.setState({ showOldTemplates: !_this.state.showOldTemplates });
    }, _this.updateTemplatesList = function () {
      //  テンプレートの表示・非表示の条件
      // ・1ヶ月以内に使ったテンプレート→使った順に上から表示する（個数制限なし）
      // ・どのテンプレートも1度も使用したことがない場合(テンプレートが全て表示される)
      // ・過去に使用したことはあるが、1ヶ月以内に使ったテンプレートがない(最新のテンプレート１つが表示され、その他は全て非表示)
      if (_this.props.templates) {
        var recentTemplates = [],
            oldTemplates = [];
        var notFirstTimeList = _lodash2.default.find(_this.props.templates, function (item) {
          return item.used_at != 0;
        });
        var isFirstTime = !notFirstTimeList;
        _this.props.templates && _this.props.templates.map(function (item, index) {
          if (index < DEFAULT_DISPLAY_COUNT || item.used_at > TIMESTAMP_SINCE_ONE_MONTH || (0, _moment2.default)(item.created_at).unix() > TIMESTAMP_SINCE_TEN_DAYS || isFirstTime) recentTemplates.push(item);else oldTemplates.push(item);
        });
        _this.setState({ recentTemplates: recentTemplates, oldTemplates: oldTemplates });
      }
    }, _this.onClose = function () {
      _this.props.onClose();
      _this.setState({ showOldTemplates: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TemplateSelectionDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateTemplatesList();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.templates !== prevProps.templates) {
        this.updateTemplatesList();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      if (!(0, _shallowEqual2.default)(this.props.templates, nextProps.templates)) return true;
      return _get(TemplateSelectionDialog.prototype.__proto__ || Object.getPrototypeOf(TemplateSelectionDialog.prototype), 'shouldComponentUpdate', this).call(this, nextProps, nextState, nextContext);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          active = _props.active,
          onClose = _props.onClose,
          onSelect = _props.onSelect,
          templates = _props.templates,
          actions = _props.actions;


      if (!templates) return null;
      return _react2.default.createElement(
        _dialog.Dialog,
        { active: active,
          onEscKeyDown: this.onClose,
          onOverlayClick: this.onClose,
          title: t('label:テンプレートを選択'),
          actions: [{ label: t('label:取り消し'), onClick: this.onClose }] },
        _react2.default.createElement(
          _scrollableDialogPanel2.default,
          null,
          _react2.default.createElement(
            _list.List,
            { selectable: true, ripple: true },
            this.state.recentTemplates && this.state.recentTemplates.map(function (template) {
              return _react2.default.createElement(_list.ListItem, { key: template.template_id,
                caption: template.template_id != 'last_diary' && template.name || t('label:昨日の投稿内容'),
                onClick: function onClick() {
                  onSelect(template.template_id, template.name, template.template, template.attach_json);
                  _this2.onClose();
                } });
            }),
            this.state.showOldTemplates && this.state.oldTemplates.map(function (template) {
              return _react2.default.createElement(_list.ListItem, { key: template.template_id,
                caption: template.template_id != 'last_diary' && template.name || t('label:昨日の投稿内容'),
                onClick: function onClick() {
                  onSelect(template.template_id, template.name, template.template, template.attach_json);
                  _this2.onClose();
                } });
            }),
            this.state.oldTemplates && this.state.oldTemplates.length > 0 && _react2.default.createElement(_button.Button, {
              primary: true,
              onClick: this.toggleShowOldTemplates,
              icon: this.state.showOldTemplates && 'arrow_drop_up' || 'arrow_drop_down',
              label: this.state.showOldTemplates && t('label:隠す') || t('label:すべて表示') }),
            actions && _react2.default.createElement(_list.ListDivider, null),
            actions && actions.map(function (action) {
              return _react2.default.createElement(_list.ListItem, { key: action.name,
                caption: t('label:' + action.name),
                leftIcon: 'keyboard_arrow_right',
                onClick: function onClick() {
                  _this2.onClose();
                  action.callback && action.callback();
                } });
            })
          )
        )
      );
    }
  }]);

  return TemplateSelectionDialog;
}(_pureComponent2.default)) || _class);
exports.default = TemplateSelectionDialog;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1931);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./rich-text-editor-toolbar-navigation.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./rich-text-editor-toolbar-navigation.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.rich-text-editor-toolbar-navigation--horizontal--13p3hWAN {\n  padding: 0px;\n  background: #555;\n  padding: 0 10px;\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n}\n\n.rich-text-editor-toolbar-navigation--button--1bJg1rnO {\n  padding: 0;\n  min-width: 24px;\n  height: 24px;\n  border-radius: 0px;\n  line-height: normal;\n  line-height: initial;\n}\n\n.rich-text-editor-toolbar-navigation--button--1bJg1rnO > span:not([data-react-toolbox='tooltip']) {\n  line-height: 22px;\n}\n\n", "", {"version":3,"sources":["/./src/web/components/themes/rich-text-editor-toolbar-navigation.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,OAAO;CACR;;AAED;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;CACtB;;AAED;EACE,kBAAkB;CACnB","file":"rich-text-editor-toolbar-navigation.css","sourcesContent":["\n.horizontal {\n  padding: 0px;\n  background: #555;\n  padding: 0 10px;\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n}\n\n.button {\n  padding: 0;\n  min-width: 24px;\n  height: 24px;\n  border-radius: 0px;\n  line-height: normal;\n  line-height: initial;\n}\n\n.button > span:not([data-react-toolbox='tooltip']) {\n  line-height: 22px;\n}\n\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"horizontal": "rich-text-editor-toolbar-navigation--horizontal--13p3hWAN",
	"button": "rich-text-editor-toolbar-navigation--button--1bJg1rnO"
};

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1933);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./rich-text-editor.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./rich-text-editor.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.rich-text-editor--editor--3avN90M0[class~=chat_message]{\n  outline: none;\n  border: solid 1px rgba(0, 0, 0, .1);\n  border-radius: 5px;\n  padding: 5px;\n  max-height: 300px;\n  min-height: 100px;\n  background: #FFF;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;\n  color: rgba(0, 0, 0, .8);\n  line-height: 1.33;\n}\n\n.rich-text-editor--editor--3avN90M0 {\n  outline: none;\n  border: solid 1px rgba(0, 0, 0, .1);\n  border-radius: 5px;\n  padding: 2px 5px;\n  min-height: 100px;\n  background: #FFF;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;\n  color: rgba(0, 0, 0, .8);\n  line-height: 1.33;\n}\n\n.rich-text-editor--editor--3avN90M0 ul {\n  margin: 0;\n  padding-left:  25px;\n}\n\n.rich-text-editor--editor--3avN90M0 ol {\n  margin: 0;\n  padding-left: 1.5em;\n  text-indent: -1.5em;\n  list-style-position: inside;\n}\n\n.rich-text-editor--editor--3avN90M0 p {\n  margin: 0;\n}\n\n.rich-text-editor--editor--3avN90M0 a {\n  text-decoration: underline;\n  color: #00b2f3;\n}\n\n.rich-text-editor--editor--3avN90M0 a:hover {\n  color: #009fda;\n}\n\n.rich-text-editor--withToolbar--S_WDl25I {\n  border-radius: 0 0 5px 5px;\n}\n\n.rich-text-editor--dragEntered--1YI5qWAh {\n  border: solid 2px #99ccff;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/rich-text-editor.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,8DAA8D;EAC9D,yBAAyB;EACzB,kBAAkB;CACnB;;AAED;EACE,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,8DAA8D;EAC9D,yBAAyB;EACzB,kBAAkB;CACnB;;AAED;EACE,UAAU;EACV,oBAAoB;CACrB;;AAED;EACE,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,4BAA4B;CAC7B;;AAED;EACE,UAAU;CACX;;AAED;EACE,2BAA2B;EAC3B,eAAe;CAChB;;AAED;EACE,eAAe;CAChB;;AAED;EACE,2BAA2B;CAC5B;;AAED;EACE,0BAA0B;CAC3B","file":"rich-text-editor.css","sourcesContent":["\n.editor[class~=chat_message]{\n  outline: none;\n  border: solid 1px rgba(0, 0, 0, .1);\n  border-radius: 5px;\n  padding: 5px;\n  max-height: 300px;\n  min-height: 100px;\n  background: #FFF;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;\n  color: rgba(0, 0, 0, .8);\n  line-height: 1.33;\n}\n\n.editor {\n  outline: none;\n  border: solid 1px rgba(0, 0, 0, .1);\n  border-radius: 5px;\n  padding: 2px 5px;\n  min-height: 100px;\n  background: #FFF;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;\n  color: rgba(0, 0, 0, .8);\n  line-height: 1.33;\n}\n\n.editor ul {\n  margin: 0;\n  padding-left:  25px;\n}\n\n.editor ol {\n  margin: 0;\n  padding-left: 1.5em;\n  text-indent: -1.5em;\n  list-style-position: inside;\n}\n\n.editor p {\n  margin: 0;\n}\n\n.editor a {\n  text-decoration: underline;\n  color: #00b2f3;\n}\n\n.editor a:hover {\n  color: #009fda;\n}\n\n.withToolbar {\n  border-radius: 0 0 5px 5px;\n}\n\n.dragEntered {\n  border: solid 2px #99ccff;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"editor": "rich-text-editor--editor--3avN90M0",
	"withToolbar": "rich-text-editor--withToolbar--S_WDl25I",
	"dragEntered": "rich-text-editor--dragEntered--1YI5qWAh"
};

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.success-button--button--3K4-z93M:not([disabled]) {\n  background-color: rgb(91, 184, 92)!important;\n  color: #FFF!important;\n}\n.success-button--button--3K4-z93M:not([disabled]):hover {\n  background-color: rgba(91, 184, 92, .8)!important;\n  color: #FFF!important;\n}\n.success-button--button--3K4-z93M:not([disabled])[class~=templateImport] {\nmargin-left: 20px;\n} \n", "", {"version":3,"sources":["/./src/web/components/themes/success-button.css"],"names":[],"mappings":";AACA;EACE,6CAA6C;EAC7C,sBAAsB;CACvB;AACD;EACE,kDAAkD;EAClD,sBAAsB;CACvB;AACD;AACA,kBAAkB;CACjB","file":"success-button.css","sourcesContent":["\n.button:not([disabled]) {\n  background-color: rgb(91, 184, 92)!important;\n  color: #FFF!important;\n}\n.button:not([disabled]):hover {\n  background-color: rgba(91, 184, 92, .8)!important;\n  color: #FFF!important;\n}\n.button:not([disabled])[class~=templateImport] {\nmargin-left: 20px;\n} \n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"button": "success-button--button--3K4-z93M"
};

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '<!DOCTYPE html>' + '<html>' + '<head>' + '<meta charset="UTF-8">' + '<meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">' + '<title></title>' + '<style type="text/css">' + '  html {' + '    height: 100%;' + '  }' + '  body {' + '    -moz-box-sizing: border-box;' + '    -webkit-box-sizing: border-box;' + '    box-sizing: border-box;' + '    padding: 0px;' + '    margin: 0px;' + '    background: transparent;' + '    cursor: text;' + '    font-size: 14px;' + '    font-family: Lato,"Helvetica Neue",Arial,Helvetica,sans-serif;' + '    color: rgba(0, 0, 0, 0.8);' + '    line-height: 1.33;' + '    height: 100%;' + '  }' + '' + '  img[src*=emojione] {' + '    width: 20px;' + '    height: 20px;' + '  }' + '' + '  ul {' + '    margin: 0;' + '    padding-left: 25px;' + '  }' + '  ol {' + '    margin: 0;' + '    padding-left: 1.5em;' + '    text-indent: -1.5em;' + '    list-style-position: inside;' + '  }' + '' + '  p {' + '    margin: 0;' + '  }' + '' + '  a {' + '    text-decoration: underline;' + '    color: #00b2f3;' + '    word-break: break-all;' + '  }' + '' + '  a:hover {' + '    color: #009fda;' + '  }' + '</style>' + '</head>' + '<body>' + '</body>' + '</html>';

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleSheet = StyleSheet;

var _objectAssign = __webpack_require__(80);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* 

high performance StyleSheet for css-in-js systems 

- uses multiple style tags behind the scenes for millions of rules 
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side 


// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject() 
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }') 
- appends a css rule into the stylesheet 

styleSheet.flush() 
- empties the stylesheet of all its contents


*/

function last(arr) {
  return arr[arr.length - 1];
}

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }

  // this weirdness brought to you by firefox 
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}

var isBrowser = typeof window !== 'undefined';
var isDev = "production" === 'development' || !"production"; //(x => (x === 'development') || !x)(process.env.NODE_ENV)
var isTest = "production" === 'test';

var oldIE = function () {
  if (isBrowser) {
    var div = document.createElement('div');
    div.innerHTML = '<!--[if lt IE 10]><i></i><![endif]-->';
    return div.getElementsByTagName('i').length === 1;
  }
}();

function makeStyleTag() {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-glamor', '');
  tag.appendChild(document.createTextNode(''));
  (document.head || document.getElementsByTagName('head')[0]).appendChild(tag);
  return tag;
}

function StyleSheet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$speedy = _ref.speedy,
      speedy = _ref$speedy === undefined ? !isDev && !isTest : _ref$speedy,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === undefined ? isBrowser && oldIE ? 4000 : 65000 : _ref$maxLength;

  this.isSpeedy = speedy; // the big drawback here is that the css won't be editable in devtools
  this.sheet = undefined;
  this.tags = [];
  this.maxLength = maxLength;
  this.ctr = 0;
}

(0, _objectAssign2.default)(StyleSheet.prototype, {
  getSheet: function getSheet() {
    return sheetForTag(last(this.tags));
  },
  inject: function inject() {
    var _this = this;

    if (this.injected) {
      throw new Error('already injected stylesheet!');
    }
    if (isBrowser) {
      this.tags[0] = makeStyleTag();
    } else {
      // server side 'polyfill'. just enough behavior to be useful.
      this.sheet = {
        cssRules: [],
        insertRule: function insertRule(rule) {
          // enough 'spec compliance' to be able to extract the rules later  
          // in other words, just the cssText field 
          _this.sheet.cssRules.push({ cssText: rule });
        }
      };
    }
    this.injected = true;
  },
  speedy: function speedy(bool) {
    if (this.ctr !== 0) {
      throw new Error('cannot change speedy mode after inserting any rule to sheet. Either call speedy(' + bool + ') earlier in your app, or call flush() before speedy(' + bool + ')');
    }
    this.isSpeedy = !!bool;
  },
  _insert: function _insert(rule) {
    // this weirdness for perf, and chrome's weird bug 
    // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
    try {
      var sheet = this.getSheet();
      sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : sheet.cssRules.length);
    } catch (e) {
      if (isDev) {
        // might need beter dx for this 
        console.warn('whoops, illegal rule inserted', rule); //eslint-disable-line no-console
      }
    }
  },
  insert: function insert(rule) {

    if (isBrowser) {
      // this is the ultrafast version, works across browsers 
      if (this.isSpeedy && this.getSheet().insertRule) {
        this._insert(rule);
      }
      // more browser weirdness. I don't even know    
      // else if(this.tags.length > 0 && this.tags::last().styleSheet) {      
      //   this.tags::last().styleSheet.cssText+= rule
      // }
      else {
          if (rule.indexOf('@import') !== -1) {
            var tag = last(this.tags);
            tag.insertBefore(document.createTextNode(rule), tag.firstChild);
          } else {
            last(this.tags).appendChild(document.createTextNode(rule));
          }
        }
    } else {
      // server side is pretty simple         
      this.sheet.insertRule(rule, rule.indexOf('@import') !== -1 ? 0 : this.sheet.cssRules.length);
    }

    this.ctr++;
    if (isBrowser && this.ctr % this.maxLength === 0) {
      this.tags.push(makeStyleTag());
    }
    return this.ctr - 1;
  },

  // commenting this out till we decide on v3's decision 
  // _replace(index, rule) {
  //   // this weirdness for perf, and chrome's weird bug 
  //   // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
  //   try {  
  //     let sheet = this.getSheet()        
  //     sheet.deleteRule(index) // todo - correct index here     
  //     sheet.insertRule(rule, index)
  //   }
  //   catch(e) {
  //     if(isDev) {
  //       // might need beter dx for this 
  //       console.warn('whoops, problem replacing rule', rule) //eslint-disable-line no-console
  //     }          
  //   }          

  // }
  // replace(index, rule) {
  //   if(isBrowser) {
  //     if(this.isSpeedy && this.getSheet().insertRule) {
  //       this._replace(index, rule)
  //     }
  //     else {
  //       let _slot = Math.floor((index  + this.maxLength) / this.maxLength) - 1        
  //       let _index = (index % this.maxLength) + 1
  //       let tag = this.tags[_slot]
  //       tag.replaceChild(document.createTextNode(rule), tag.childNodes[_index])
  //     }
  //   }
  //   else {
  //     let rules = this.sheet.cssRules
  //     this.sheet.cssRules = [ ...rules.slice(0, index), { cssText: rule }, ...rules.slice(index + 1) ]
  //   }
  // }
  delete: function _delete(index) {
    // we insert a blank rule when 'deleting' so previously returned indexes remain stable
    return this.replace(index, '');
  },
  flush: function flush() {
    if (isBrowser) {
      this.tags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.sheet = null;
      this.ctr = 0;
      // todo - look for remnants in document.styleSheets
    } else {
      // simpler on server 
      this.sheet.cssRules = [];
    }
    this.injected = false;
  },
  rules: function rules() {
    if (!isBrowser) {
      return this.sheet.cssRules;
    }
    var arr = [];
    this.tags.forEach(function (tag) {
      return arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(Array.from(sheetForTag(tag).cssRules))));
    });
    return arr;
  }
});

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(1938);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CSSProperty = __webpack_require__(1940);

var _CSSProperty2 = _interopRequireDefault(_CSSProperty);

var _warning = __webpack_require__(104);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 */

var isUnitlessNumber = _CSSProperty2.default.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

exports.default = dangerousStyleValue;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */

/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridColumn: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true

  /**
   * @param {string} prefix vendor-specific prefix, eg: Webkit
   * @param {string} key style name, eg: transitionDuration
   * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
   * WebkitTransitionDuration
   */
};function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

exports.default = CSSProperty;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1942);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = clean;
// Returns true for null, false, undefined and {}
function isFalsy(value) {
  return value === null || value === undefined || value === false || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0;
}

function cleanObject(object) {
  if (isFalsy(object)) return null;
  if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') return object;

  var acc = {},
      keys = Object.keys(object),
      hasFalsy = false;
  for (var i = 0; i < keys.length; i++) {
    var value = object[keys[i]];
    var filteredValue = clean(value);
    if (filteredValue === null || filteredValue !== value) {
      hasFalsy = true;
    }
    if (filteredValue !== null) {
      acc[keys[i]] = filteredValue;
    }
  }
  return Object.keys(acc).length === 0 ? null : hasFalsy ? acc : object;
}

function cleanArray(rules) {
  var hasFalsy = false;
  var filtered = [];
  rules.forEach(function (rule) {
    var filteredRule = clean(rule);
    if (filteredRule === null || filteredRule !== rule) {
      hasFalsy = true;
    }
    if (filteredRule !== null) {
      filtered.push(filteredRule);
    }
  });
  return filtered.length == 0 ? null : hasFalsy ? filtered : rules;
}

// Takes style array or object provided by user and clears all the falsy data 
// If there is no styles left after filtration returns null
function clean(input) {
  return Array.isArray(input) ? cleanArray(input) : cleanObject(input);
}

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.PluginSet = PluginSet;
exports.fallbacks = fallbacks;
exports.contentWrap = contentWrap;
exports.prefixes = prefixes;

var _objectAssign = __webpack_require__(80);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _CSSPropertyOperations = __webpack_require__(916);

var _prefixer = __webpack_require__(1946);

var _prefixer2 = _interopRequireDefault(_prefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDev = function (x) {
  return x === 'development' || !x;
}("production");

function PluginSet(initial) {
  this.fns = initial || [];
}

(0, _objectAssign2.default)(PluginSet.prototype, {
  add: function add() {
    var _this = this;

    for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    fns.forEach(function (fn) {
      if (_this.fns.indexOf(fn) >= 0) {
        if (isDev) {
          console.warn('adding the same plugin again, ignoring'); //eslint-disable-line no-console
        }
      } else {
        _this.fns = [fn].concat(_this.fns);
      }
    });
  },
  remove: function remove(fn) {
    this.fns = this.fns.filter(function (x) {
      return x !== fn;
    });
  },
  clear: function clear() {
    this.fns = [];
  },
  transform: function transform(o) {
    return this.fns.reduce(function (o, fn) {
      return fn(o);
    }, o);
  }
});

function fallbacks(node) {
  var hasArray = Object.keys(node.style).map(function (x) {
    return Array.isArray(node.style[x]);
  }).indexOf(true) >= 0;
  if (hasArray) {
    var style = node.style;

    var flattened = Object.keys(style).reduce(function (o, key) {
      o[key] = Array.isArray(style[key]) ? style[key].join('; ' + (0, _CSSPropertyOperations.processStyleName)(key) + ': ') : style[key];
      return o;
    }, {});
    // todo - 
    // flatten arrays which haven't been flattened yet 
    return (0, _objectAssign2.default)({}, node, { style: flattened });
  }
  return node;
}

var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit'];

function contentWrap(node) {
  if (node.style.content) {
    var cont = node.style.content;
    if (contentValues.indexOf(cont) >= 0) {
      return node;
    }
    if (/^(attr|calc|counters?|url)\(/.test(cont)) {
      return node;
    }
    if (cont.charAt(0) === cont.charAt(cont.length - 1) && (cont.charAt(0) === '"' || cont.charAt(0) === "'")) {
      return node;
    }
    return _extends({}, node, { style: _extends({}, node.style, { content: '"' + cont + '"' }) });
  }
  return node;
}

function prefixes(node) {
  return (0, _objectAssign2.default)({}, node, { style: (0, _prefixer2.default)(_extends({}, node.style)) });
}

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixer;

var _staticData = __webpack_require__(1947);

var _staticData2 = _interopRequireDefault(_staticData);

var _prefixProperty = __webpack_require__(1948);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(1949);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _cursor = __webpack_require__(1950);

var _cursor2 = _interopRequireDefault(_cursor);

var _crossFade = __webpack_require__(1951);

var _crossFade2 = _interopRequireDefault(_crossFade);

var _filter = __webpack_require__(1952);

var _filter2 = _interopRequireDefault(_filter);

var _flex = __webpack_require__(1953);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxOld = __webpack_require__(1954);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(1955);

var _gradient2 = _interopRequireDefault(_gradient);

var _imageSet = __webpack_require__(1956);

var _imageSet2 = _interopRequireDefault(_imageSet);

var _position = __webpack_require__(1957);

var _position2 = _interopRequireDefault(_position);

var _sizing = __webpack_require__(1958);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(1959);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var plugins = [_crossFade2.default, _cursor2.default, _filter2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default, _flex2.default]; // custom facade for inline-style-prefixer

var prefixMap = _staticData2.default.prefixMap;

function prefixer(style) {
  for (var property in style) {
    var value = style[property];

    var processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

    // only modify the value if it was touched
    // by any plugin to prevent unnecessary mutations
    if (processedValue) {
      style[property] = processedValue;
    }

    (0, _prefixProperty2.default)(prefixMap, property, style);
  }
  return style;
}

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var w = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];

exports.default = {
  plugins: [],
  prefixMap: { "appearance": wm, "userSelect": wmms, "textEmphasisPosition": w, "textEmphasis": w, "textEmphasisStyle": w, "textEmphasisColor": w, "boxDecorationBreak": w, "clipPath": w, "maskImage": w, "maskMode": w, "maskRepeat": w, "maskPosition": w, "maskClip": w, "maskOrigin": w, "maskSize": w, "maskComposite": w, "mask": w, "maskBorderSource": w, "maskBorderMode": w, "maskBorderSlice": w, "maskBorderWidth": w, "maskBorderOutset": w, "maskBorderRepeat": w, "maskBorder": w, "maskType": w, "textDecorationStyle": w, "textDecorationSkip": w, "textDecorationLine": w, "textDecorationColor": w, "filter": w, "fontFeatureSettings": w, "breakAfter": wmms, "breakBefore": wmms, "breakInside": wmms, "columnCount": wm, "columnFill": wm, "columnGap": wm, "columnRule": wm, "columnRuleColor": wm, "columnRuleStyle": wm, "columnRuleWidth": wm, "columns": wm, "columnSpan": wm, "columnWidth": wm, "flex": w, "flexBasis": w, "flexDirection": w, "flexGrow": w, "flexFlow": w, "flexShrink": w, "flexWrap": w, "alignContent": w, "alignItems": w, "alignSelf": w, "justifyContent": w, "order": w, "transform": w, "transformOrigin": w, "transformOriginX": w, "transformOriginY": w, "backfaceVisibility": w, "perspective": w, "perspectiveOrigin": w, "transformStyle": w, "transformOriginZ": w, "animation": w, "animationDelay": w, "animationDirection": w, "animationFillMode": w, "animationDuration": w, "animationIterationCount": w, "animationName": w, "animationPlayState": w, "animationTimingFunction": w, "backdropFilter": w, "fontKerning": w, "scrollSnapType": wms, "scrollSnapPointsX": wms, "scrollSnapPointsY": wms, "scrollSnapDestination": wms, "scrollSnapCoordinate": wms, "shapeImageThreshold": w, "shapeImageMargin": w, "shapeImageOutside": w, "hyphens": wmms, "flowInto": wms, "flowFrom": wms, "regionFragment": wms, "textAlignLast": m, "tabSize": m, "wrapFlow": ms, "wrapThrough": ms, "wrapMargin": ms, "gridTemplateColumns": ms, "gridTemplateRows": ms, "gridTemplateAreas": ms, "gridTemplate": ms, "gridAutoColumns": ms, "gridAutoRows": ms, "gridAutoFlow": ms, "grid": ms, "gridRowStart": ms, "gridColumnStart": ms, "gridRowEnd": ms, "gridRow": ms, "gridColumn": ms, "gridColumnEnd": ms, "gridColumnGap": ms, "gridRowGap": ms, "gridArea": ms, "gridGap": ms, "textSizeAdjust": wms, "borderImage": w, "borderImageOutset": w, "borderImageRepeat": w, "borderImageSlice": w, "borderImageSource": w, "borderImageWidth": w, "transitionDelay": w, "transitionDuration": w, "transitionProperty": w, "transitionTimingFunction": w }
};
module.exports = exports["default"];

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(917);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    );if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(270);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(270);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(270);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(270);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
module.exports = exports['default'];

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(1960);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(270);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(917);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap
    // if the property is already prefixed
    );var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(1961);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = doHash;
// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// src/helpers/parse-attributes.js

function parseAttributes(str) {
  // アトリビュートの文字列をパースする：
  //   例: val1=value1 val2="value2 with quote" => { val1: 'value1', val2: 'value2 with quote' }
  var r;
  var result = {};
  while (r = str.match(/^([-a-z]+)=(['"](.*?)["']|([^'" ]+))/)) {
    // "'
    result[r[1]] = r[2].replace(/^['"]?(.*?)["']?$/, "$1");
    str = str.slice(r[0].length).trim();
  }
  return result;
}

exports.default = parseAttributes;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = purgeHtml;

var _htmlParseDom = __webpack_require__(1965);

var _htmlParseDom2 = _interopRequireDefault(_htmlParseDom);

var _isArray = __webpack_require__(62);

var _isArray2 = _interopRequireDefault(_isArray);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _isEqual = __webpack_require__(226);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// purge-html.js

function purgeDOM(dom) {
  if ((0, _isArray2.default)(dom)) {
    var children = [];
    //console.log('array', dom)
    (0, _each2.default)(dom, function (child) {
      return children = children.concat(purgeDOM(child));
    });
    return children;
  }

  var attribs = Object.assign({}, dom.attribs);
  if (!attribs.style) delete attribs.style;
  if (!attribs.class) delete attribs.class;

  if (dom.type == 'tag' && (dom.name == 'div' || dom.name == 'span') && (!attribs || (0, _isEqual2.default)(attribs, {}) || (0, _isEqual2.default)(attribs, { contenteditable: 'false' })) && (0, _filter2.default)(dom.children, function (child) {
    var _attribs = Object.assign({}, child.attribs);
    if (!_attribs.style) delete _attribs.style;
    if (!_attribs.class) delete _attribs.class;
    return child.type == 'tag' && child.name == dom.name && (!_attribs || (0, _isEqual2.default)(_attribs, {}) || (0, _isEqual2.default)(_attribs, { contenteditable: 'false' }));
  }).length == dom.children.length) {
    //console.log('tag', dom)
    var children = purgeDOM(dom.children);
    (0, _each2.default)(purgeDOM(children), function (child, i) {
      child.prev = i == 0 ? null : children[i - 1];
      child.next = i == children.length - 1 ? null : children[i + 1];
      child.parent = dom.parent;
    });
    return children;
  }

  if (dom.type == 'text') return dom;else {
    //console.log('else', dom)
    dom.children = purgeDOM(dom.children);
    return dom;
  }
}

var ELEMENT_TAGS = {
  img: true,
  input: true,
  br: true
};

function stringifyDOM(dom) {
  if ((0, _isArray2.default)(dom)) return (0, _map2.default)(dom, function (child) {
    return stringifyDOM(child);
  }).join('');

  if (dom.type == 'text') return dom.data;

  if (dom.children && dom.children.length > 0) return '<' + dom.name + (0, _map2.default)(dom.attribs, function (v, k) {
    return ' ' + k + '="' + v + '"';
  }).join('') + '>' + stringifyDOM(dom.children) + ('</' + dom.name + '>');

  if (ELEMENT_TAGS[dom.name]) return '<' + dom.name + (0, _map2.default)(dom.attribs, function (v, k) {
    return ' ' + k + '="' + v + '"';
  }).join('') + '>';else if (dom.attribs.length > 0) return '<' + dom.name + (0, _map2.default)(dom.attribs, function (v, k) {
    return ' ' + k + '="' + v + '"';
  }).join('') + '></' + dom.name + '>';else return '';
}

function purgeHtml(html) {
  var dom = (0, _htmlParseDom2.default)(html);
  var pdom = purgeDOM(dom);
  return stringifyDOM(pdom);
}

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _htmlparser = __webpack_require__(271);

exports.default = _htmlparser.parseDOM;
// src/helpers/html-parse-dom.js

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

module.exports = {
	"0": 65533,
	"128": 8364,
	"130": 8218,
	"131": 402,
	"132": 8222,
	"133": 8230,
	"134": 8224,
	"135": 8225,
	"136": 710,
	"137": 8240,
	"138": 352,
	"139": 8249,
	"140": 338,
	"142": 381,
	"145": 8216,
	"146": 8217,
	"147": 8220,
	"148": 8221,
	"149": 8226,
	"150": 8211,
	"151": 8212,
	"152": 732,
	"153": 8482,
	"154": 353,
	"155": 8250,
	"156": 339,
	"158": 382,
	"159": 376
};

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(272);

var re_whitespace = /\s+/g;
var NodePrototype = __webpack_require__(922);
var ElementPrototype = __webpack_require__(1968);

function DomHandler(callback, options, elementCB){
	if(typeof callback === "object"){
		elementCB = options;
		options = callback;
		callback = null;
	} else if(typeof options === "function"){
		elementCB = options;
		options = defaultOpts;
	}
	this._callback = callback;
	this._options = options || defaultOpts;
	this._elementCB = elementCB;
	this.dom = [];
	this._done = false;
	this._tagStack = [];
	this._parser = this._parser || null;
}

//default options
var defaultOpts = {
	normalizeWhitespace: false, //Replace all whitespace with single spaces
	withStartIndices: false, //Add startIndex properties to nodes
	withEndIndices: false, //Add endIndex properties to nodes
};

DomHandler.prototype.onparserinit = function(parser){
	this._parser = parser;
};

//Resets the handler back to starting state
DomHandler.prototype.onreset = function(){
	DomHandler.call(this, this._callback, this._options, this._elementCB);
};

//Signals the handler that parsing is done
DomHandler.prototype.onend = function(){
	if(this._done) return;
	this._done = true;
	this._parser = null;
	this._handleCallback(null);
};

DomHandler.prototype._handleCallback =
DomHandler.prototype.onerror = function(error){
	if(typeof this._callback === "function"){
		this._callback(error, this.dom);
	} else {
		if(error) throw error;
	}
};

DomHandler.prototype.onclosetag = function(){
	//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
	
	var elem = this._tagStack.pop();

	if(this._options.withEndIndices){
		elem.endIndex = this._parser.endIndex;
	}

	if(this._elementCB) this._elementCB(elem);
};

DomHandler.prototype._createDomElement = function(properties){
	if (!this._options.withDomLvl1) return properties;

	var element;
	if (properties.type === "tag") {
		element = Object.create(ElementPrototype);
	} else {
		element = Object.create(NodePrototype);
	}

	for (var key in properties) {
		if (properties.hasOwnProperty(key)) {
			element[key] = properties[key];
		}
	}

	return element;
};

DomHandler.prototype._addDomElement = function(element){
	var parent = this._tagStack[this._tagStack.length - 1];
	var siblings = parent ? parent.children : this.dom;
	var previousSibling = siblings[siblings.length - 1];

	element.next = null;

	if(this._options.withStartIndices){
		element.startIndex = this._parser.startIndex;
	}
	if(this._options.withEndIndices){
		element.endIndex = this._parser.endIndex;
	}

	if(previousSibling){
		element.prev = previousSibling;
		previousSibling.next = element;
	} else {
		element.prev = null;
	}

	siblings.push(element);
	element.parent = parent || null;
};

DomHandler.prototype.onopentag = function(name, attribs){
	var properties = {
		type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
		name: name,
		attribs: attribs,
		children: []
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);

	this._tagStack.push(element);
};

DomHandler.prototype.ontext = function(data){
	//the ignoreWhitespace is officially dropped, but for now,
	//it's an alias for normalizeWhitespace
	var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;

	var lastTag;

	if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
		if(normalize){
			lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
		} else {
			lastTag.data += data;
		}
	} else {
		if(
			this._tagStack.length &&
			(lastTag = this._tagStack[this._tagStack.length - 1]) &&
			(lastTag = lastTag.children[lastTag.children.length - 1]) &&
			lastTag.type === ElementType.Text
		){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(normalize){
				data = data.replace(re_whitespace, " ");
			}

			var element = this._createDomElement({
				data: data,
				type: ElementType.Text
			});

			this._addDomElement(element);
		}
	}
};

DomHandler.prototype.oncomment = function(data){
	var lastTag = this._tagStack[this._tagStack.length - 1];

	if(lastTag && lastTag.type === ElementType.Comment){
		lastTag.data += data;
		return;
	}

	var properties = {
		data: data,
		type: ElementType.Comment
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncdatastart = function(){
	var properties = {
		children: [{
			data: "",
			type: ElementType.Text
		}],
		type: ElementType.CDATA
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
	this._tagStack.pop();
};

DomHandler.prototype.onprocessinginstruction = function(name, data){
	var element = this._createDomElement({
		name: name,
		data: data,
		type: ElementType.Directive
	});

	this._addDomElement(element);
};

module.exports = DomHandler;


/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

// DOM-Level-1-compliant structure
var NodePrototype = __webpack_require__(922);
var ElementPrototype = module.exports = Object.create(NodePrototype);

var domLvl1 = {
	tagName: "name"
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(ElementPrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

var index = __webpack_require__(271),
    DomHandler = index.DomHandler,
    DomUtils = index.DomUtils;

//TODO: make this a streamable handler
function FeedHandler(callback, options){
	this.init(callback, options);
}

__webpack_require__(87)(FeedHandler, DomHandler);

FeedHandler.prototype.init = DomHandler;

function getElements(what, where){
	return DomUtils.getElementsByTagName(what, where, true);
}
function getOneElement(what, where){
	return DomUtils.getElementsByTagName(what, where, true, 1)[0];
}
function fetch(what, where, recurse){
	return DomUtils.getText(
		DomUtils.getElementsByTagName(what, where, recurse, 1)
	).trim();
}

function addConditionally(obj, prop, what, where, recurse){
	var tmp = fetch(what, where, recurse);
	if(tmp) obj[prop] = tmp;
}

var isValidFeed = function(value){
	return value === "rss" || value === "feed" || value === "rdf:RDF";
};

FeedHandler.prototype.onend = function(){
	var feed = {},
	    feedRoot = getOneElement(isValidFeed, this.dom),
	    tmp, childs;

	if(feedRoot){
		if(feedRoot.name === "feed"){
			childs = feedRoot.children;

			feed.type = "atom";
			addConditionally(feed, "id", "id", childs);
			addConditionally(feed, "title", "title", childs);
			if((tmp = getOneElement("link", childs)) && (tmp = tmp.attribs) && (tmp = tmp.href)) feed.link = tmp;
			addConditionally(feed, "description", "subtitle", childs);
			if((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
			addConditionally(feed, "author", "email", childs, true);

			feed.items = getElements("entry", childs).map(function(item){
				var entry = {}, tmp;

				item = item.children;

				addConditionally(entry, "id", "id", item);
				addConditionally(entry, "title", "title", item);
				if((tmp = getOneElement("link", item)) && (tmp = tmp.attribs) && (tmp = tmp.href)) entry.link = tmp;
				if((tmp = fetch("summary", item) || fetch("content", item))) entry.description = tmp;
				if((tmp = fetch("updated", item))) entry.pubDate = new Date(tmp);
				return entry;
			});
		} else {
			childs = getOneElement("channel", feedRoot.children).children;

			feed.type = feedRoot.name.substr(0, 3);
			feed.id = "";
			addConditionally(feed, "title", "title", childs);
			addConditionally(feed, "link", "link", childs);
			addConditionally(feed, "description", "description", childs);
			if((tmp = fetch("lastBuildDate", childs))) feed.updated = new Date(tmp);
			addConditionally(feed, "author", "managingEditor", childs, true);

			feed.items = getElements("item", feedRoot.children).map(function(item){
				var entry = {}, tmp;

				item = item.children;

				addConditionally(entry, "id", "guid", item);
				addConditionally(entry, "title", "title", item);
				addConditionally(entry, "link", "link", item);
				addConditionally(entry, "description", "description", item);
				if((tmp = fetch("pubDate", item))) entry.pubDate = new Date(tmp);
				return entry;
			});
		}
	}
	this.dom = feed;
	DomHandler.prototype._handleCallback.call(
		this, feedRoot ? null : Error("couldn't find root of feed")
	);
};

module.exports = FeedHandler;


/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(923);

function Stream(options){
	Parser.call(this, new Cbs(this), options);
}

__webpack_require__(87)(Stream, Parser);

Stream.prototype.readable = true;

function Cbs(scope){
	this.scope = scope;
}

var EVENTS = __webpack_require__(271).EVENTS;

Object.keys(EVENTS).forEach(function(name){
	if(EVENTS[name] === 0){
		Cbs.prototype["on" + name] = function(){
			this.scope.emit(name);
		};
	} else if(EVENTS[name] === 1){
		Cbs.prototype["on" + name] = function(a){
			this.scope.emit(name, a);
		};
	} else if(EVENTS[name] === 2){
		Cbs.prototype["on" + name] = function(a, b){
			this.scope.emit(name, a, b);
		};
	} else {
		throw Error("wrong number of arguments!");
	}
});

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(496).Buffer;
var util = __webpack_require__(1973);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(928);

/*<replacement>*/
var util = __webpack_require__(148);
util.inherits = __webpack_require__(87);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(497);


/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(185);


/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(495).Transform


/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(495).PassThrough


/***/ }),
/* 1979 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = ProxyHandler;

function ProxyHandler(cbs){
	this._cbs = cbs || {};
}

var EVENTS = __webpack_require__(271).EVENTS;
Object.keys(EVENTS).forEach(function(name){
	if(EVENTS[name] === 0){
		name = "on" + name;
		ProxyHandler.prototype[name] = function(){
			if(this._cbs[name]) this._cbs[name]();
		};
	} else if(EVENTS[name] === 1){
		name = "on" + name;
		ProxyHandler.prototype[name] = function(a){
			if(this._cbs[name]) this._cbs[name](a);
		};
	} else if(EVENTS[name] === 2){
		name = "on" + name;
		ProxyHandler.prototype[name] = function(a, b){
			if(this._cbs[name]) this._cbs[name](a, b);
		};
	} else {
		throw Error("wrong number of arguments");
	}
});

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

var DomUtils = module.exports;

[
	__webpack_require__(1982),
	__webpack_require__(1988),
	__webpack_require__(1989),
	__webpack_require__(1990),
	__webpack_require__(1991),
	__webpack_require__(1992)
].forEach(function(ext){
	Object.keys(ext).forEach(function(key){
		DomUtils[key] = ext[key].bind(DomUtils);
	});
});


/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(272),
    getOuterHTML = __webpack_require__(1983),
    isTag = ElementType.isTag;

module.exports = {
	getInnerHTML: getInnerHTML,
	getOuterHTML: getOuterHTML,
	getText: getText
};

function getInnerHTML(elem, opts){
	return elem.children ? elem.children.map(function(elem){
		return getOuterHTML(elem, opts);
	}).join("") : "";
}

function getText(elem){
	if(Array.isArray(elem)) return elem.map(getText).join("");
	if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
	if(elem.type === ElementType.CDATA) return getText(elem.children);
	if(elem.type === ElementType.Text) return elem.data;
	return "";
}


/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

/*
  Module dependencies
*/
var ElementType = __webpack_require__(1984);
var entities = __webpack_require__(1985);

/*
  Boolean Attributes
*/
var booleanAttributes = {
  __proto__: null,
  allowfullscreen: true,
  async: true,
  autofocus: true,
  autoplay: true,
  checked: true,
  controls: true,
  default: true,
  defer: true,
  disabled: true,
  hidden: true,
  ismap: true,
  loop: true,
  multiple: true,
  muted: true,
  open: true,
  readonly: true,
  required: true,
  reversed: true,
  scoped: true,
  seamless: true,
  selected: true,
  typemustmatch: true
};

var unencodedElements = {
  __proto__: null,
  style: true,
  script: true,
  xmp: true,
  iframe: true,
  noembed: true,
  noframes: true,
  plaintext: true,
  noscript: true
};

/*
  Format attributes
*/
function formatAttrs(attributes, opts) {
  if (!attributes) return;

  var output = '',
      value;

  // Loop through the attributes
  for (var key in attributes) {
    value = attributes[key];
    if (output) {
      output += ' ';
    }

    if (!value && booleanAttributes[key]) {
      output += key;
    } else {
      output += key + '="' + (opts.decodeEntities ? entities.encodeXML(value) : value) + '"';
    }
  }

  return output;
}

/*
  Self-enclosing tags (stolen from node-htmlparser)
*/
var singleTag = {
  __proto__: null,
  area: true,
  base: true,
  basefont: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  isindex: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
};


var render = module.exports = function(dom, opts) {
  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
  opts = opts || {};

  var output = '';

  for(var i = 0; i < dom.length; i++){
    var elem = dom[i];

    if (elem.type === 'root')
      output += render(elem.children, opts);
    else if (ElementType.isTag(elem))
      output += renderTag(elem, opts);
    else if (elem.type === ElementType.Directive)
      output += renderDirective(elem);
    else if (elem.type === ElementType.Comment)
      output += renderComment(elem);
    else if (elem.type === ElementType.CDATA)
      output += renderCdata(elem);
    else
      output += renderText(elem, opts);
  }

  return output;
};

function renderTag(elem, opts) {
  // Handle SVG
  if (elem.name === "svg") opts = {decodeEntities: opts.decodeEntities, xmlMode: true};

  var tag = '<' + elem.name,
      attribs = formatAttrs(elem.attribs, opts);

  if (attribs) {
    tag += ' ' + attribs;
  }

  if (
    opts.xmlMode
    && (!elem.children || elem.children.length === 0)
  ) {
    tag += '/>';
  } else {
    tag += '>';
    if (elem.children) {
      tag += render(elem.children, opts);
    }

    if (!singleTag[elem.name] || opts.xmlMode) {
      tag += '</' + elem.name + '>';
    }
  }

  return tag;
}

function renderDirective(elem) {
  return '<' + elem.data + '>';
}

function renderText(elem, opts) {
  var data = elem.data || '';

  // if entities weren't decoded, no need to encode them back
  if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
    data = entities.encodeXML(data);
  }

  return data;
}

function renderCdata(elem) {
  return '<![CDATA[' + elem.children[0].data + ']]>';
}

function renderComment(elem) {
  return '<!--' + elem.data + '-->';
}


/***/ }),
/* 1984 */
/***/ (function(module, exports) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__(1986),
    decode = __webpack_require__(1987);

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__(493)),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__(492)),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__(492),
    legacyMap = __webpack_require__(921),
    xmlMap    = __webpack_require__(493),
    decodeCodePoint = __webpack_require__(920);

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),
/* 1988 */
/***/ (function(module, exports) {

var getChildren = exports.getChildren = function(elem){
	return elem.children;
};

var getParent = exports.getParent = function(elem){
	return elem.parent;
};

exports.getSiblings = function(elem){
	var parent = getParent(elem);
	return parent ? getChildren(parent) : [elem];
};

exports.getAttributeValue = function(elem, name){
	return elem.attribs && elem.attribs[name];
};

exports.hasAttrib = function(elem, name){
	return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
};

exports.getName = function(elem){
	return elem.name;
};


/***/ }),
/* 1989 */
/***/ (function(module, exports) {

exports.removeElement = function(elem){
	if(elem.prev) elem.prev.next = elem.next;
	if(elem.next) elem.next.prev = elem.prev;

	if(elem.parent){
		var childs = elem.parent.children;
		childs.splice(childs.lastIndexOf(elem), 1);
	}
};

exports.replaceElement = function(elem, replacement){
	var prev = replacement.prev = elem.prev;
	if(prev){
		prev.next = replacement;
	}

	var next = replacement.next = elem.next;
	if(next){
		next.prev = replacement;
	}

	var parent = replacement.parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs[childs.lastIndexOf(elem)] = replacement;
	}
};

exports.appendChild = function(elem, child){
	child.parent = elem;

	if(elem.children.push(child) !== 1){
		var sibling = elem.children[elem.children.length - 2];
		sibling.next = child;
		child.prev = sibling;
		child.next = null;
	}
};

exports.append = function(elem, next){
	var parent = elem.parent,
		currNext = elem.next;

	next.next = currNext;
	next.prev = elem;
	elem.next = next;
	next.parent = parent;

	if(currNext){
		currNext.prev = next;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(currNext), 0, next);
		}
	} else if(parent){
		parent.children.push(next);
	}
};

exports.prepend = function(elem, prev){
	var parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs.splice(childs.lastIndexOf(elem), 0, prev);
	}

	if(elem.prev){
		elem.prev.next = prev;
	}
	
	prev.parent = parent;
	prev.prev = elem.prev;
	prev.next = elem;
	elem.prev = prev;
};




/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

var isTag = __webpack_require__(272).isTag;

module.exports = {
	filter: filter,
	find: find,
	findOneChild: findOneChild,
	findOne: findOne,
	existsOne: existsOne,
	findAll: findAll
};

function filter(test, element, recurse, limit){
	if(!Array.isArray(element)) element = [element];

	if(typeof limit !== "number" || !isFinite(limit)){
		limit = Infinity;
	}
	return find(test, element, recurse !== false, limit);
}

function find(test, elems, recurse, limit){
	var result = [], childs;

	for(var i = 0, j = elems.length; i < j; i++){
		if(test(elems[i])){
			result.push(elems[i]);
			if(--limit <= 0) break;
		}

		childs = elems[i].children;
		if(recurse && childs && childs.length > 0){
			childs = find(test, childs, recurse, limit);
			result = result.concat(childs);
			limit -= childs.length;
			if(limit <= 0) break;
		}
	}

	return result;
}

function findOneChild(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(test(elems[i])) return elems[i];
	}

	return null;
}

function findOne(test, elems){
	var elem = null;

	for(var i = 0, l = elems.length; i < l && !elem; i++){
		if(!isTag(elems[i])){
			continue;
		} else if(test(elems[i])){
			elem = elems[i];
		} else if(elems[i].children.length > 0){
			elem = findOne(test, elems[i].children);
		}
	}

	return elem;
}

function existsOne(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(
			isTag(elems[i]) && (
				test(elems[i]) || (
					elems[i].children.length > 0 &&
					existsOne(test, elems[i].children)
				)
			)
		){
			return true;
		}
	}

	return false;
}

function findAll(test, rootElems){
	var result = [];
	var stack = [rootElems];
	while(stack.length){
		var elems = stack.pop();
		for(var i = 0, j = elems.length; i < j; i++){
			if(!isTag(elems[i])) continue;
			if(test(elems[i])) result.push(elems[i]);
		}
		while(j-- > 0){
			if(elems[j].children && elems[j].children.length > 0){
				stack.push(elems[j].children);
			}
		}
	}
	return result;
}


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(272);
var isTag = exports.isTag = ElementType.isTag;

exports.testElement = function(options, element){
	for(var key in options){
		if(!options.hasOwnProperty(key));
		else if(key === "tag_name"){
			if(!isTag(element) || !options.tag_name(element.name)){
				return false;
			}
		} else if(key === "tag_type"){
			if(!options.tag_type(element.type)) return false;
		} else if(key === "tag_contains"){
			if(isTag(element) || !options.tag_contains(element.data)){
				return false;
			}
		} else if(!element.attribs || !options[key](element.attribs[key])){
			return false;
		}
	}
	return true;
};

var Checks = {
	tag_name: function(name){
		if(typeof name === "function"){
			return function(elem){ return isTag(elem) && name(elem.name); };
		} else if(name === "*"){
			return isTag;
		} else {
			return function(elem){ return isTag(elem) && elem.name === name; };
		}
	},
	tag_type: function(type){
		if(typeof type === "function"){
			return function(elem){ return type(elem.type); };
		} else {
			return function(elem){ return elem.type === type; };
		}
	},
	tag_contains: function(data){
		if(typeof data === "function"){
			return function(elem){ return !isTag(elem) && data(elem.data); };
		} else {
			return function(elem){ return !isTag(elem) && elem.data === data; };
		}
	}
};

function getAttribCheck(attrib, value){
	if(typeof value === "function"){
		return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
	} else {
		return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
	}
}

function combineFuncs(a, b){
	return function(elem){
		return a(elem) || b(elem);
	};
}

exports.getElements = function(options, element, recurse, limit){
	var funcs = Object.keys(options).map(function(key){
		var value = options[key];
		return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
	});

	return funcs.length === 0 ? [] : this.filter(
		funcs.reduce(combineFuncs),
		element, recurse, limit
	);
};

exports.getElementById = function(id, element, recurse){
	if(!Array.isArray(element)) element = [element];
	return this.findOne(getAttribCheck("id", id), element, recurse !== false);
};

exports.getElementsByTagName = function(name, element, recurse, limit){
	return this.filter(Checks.tag_name(name), element, recurse, limit);
};

exports.getElementsByTagType = function(type, element, recurse, limit){
	return this.filter(Checks.tag_type(type), element, recurse, limit);
};


/***/ }),
/* 1992 */
/***/ (function(module, exports) {

// removeSubsets
// Given an array of nodes, remove any member that is contained by another.
exports.removeSubsets = function(nodes) {
	var idx = nodes.length, node, ancestor, replace;

	// Check if each node (or one of its ancestors) is already contained in the
	// array.
	while (--idx > -1) {
		node = ancestor = nodes[idx];

		// Temporarily remove the node under consideration
		nodes[idx] = null;
		replace = true;

		while (ancestor) {
			if (nodes.indexOf(ancestor) > -1) {
				replace = false;
				nodes.splice(idx, 1);
				break;
			}
			ancestor = ancestor.parent;
		}

		// If the node has been found to be unique, re-insert it.
		if (replace) {
			nodes[idx] = node;
		}
	}

	return nodes;
};

// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
var POSITION = {
	DISCONNECTED: 1,
	PRECEDING: 2,
	FOLLOWING: 4,
	CONTAINS: 8,
	CONTAINED_BY: 16
};

// Compare the position of one node against another node in any other document.
// The return value is a bitmask with the following values:
//
// document order:
// > There is an ordering, document order, defined on all the nodes in the
// > document corresponding to the order in which the first character of the
// > XML representation of each node occurs in the XML representation of the
// > document after expansion of general entities. Thus, the document element
// > node will be the first node. Element nodes occur before their children.
// > Thus, document order orders element nodes in order of the occurrence of
// > their start-tag in the XML (after expansion of entities). The attribute
// > nodes of an element occur after the element and before its children. The
// > relative order of attribute nodes is implementation-dependent./
// Source:
// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
//
// @argument {Node} nodaA The first node to use in the comparison
// @argument {Node} nodeB The second node to use in the comparison
//
// @return {Number} A bitmask describing the input nodes' relative position.
//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
//         a description of these values.
var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
	var aParents = [];
	var bParents = [];
	var current, sharedParent, siblings, aSibling, bSibling, idx;

	if (nodeA === nodeB) {
		return 0;
	}

	current = nodeA;
	while (current) {
		aParents.unshift(current);
		current = current.parent;
	}
	current = nodeB;
	while (current) {
		bParents.unshift(current);
		current = current.parent;
	}

	idx = 0;
	while (aParents[idx] === bParents[idx]) {
		idx++;
	}

	if (idx === 0) {
		return POSITION.DISCONNECTED;
	}

	sharedParent = aParents[idx - 1];
	siblings = sharedParent.children;
	aSibling = aParents[idx];
	bSibling = bParents[idx];

	if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
		if (sharedParent === nodeB) {
			return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
		}
		return POSITION.FOLLOWING;
	} else {
		if (sharedParent === nodeA) {
			return POSITION.PRECEDING | POSITION.CONTAINS;
		}
		return POSITION.PRECEDING;
	}
};

// Sort an array of nodes based on their relative position in the document and
// remove any duplicate nodes. If the array contains nodes that do not belong
// to the same document, sort order is unspecified.
//
// @argument {Array} nodes Array of DOM nodes
//
// @returns {Array} collection of unique nodes, sorted in document order
exports.uniqueSort = function(nodes) {
	var idx = nodes.length, node, position;

	nodes = nodes.slice();

	while (--idx > -1) {
		node = nodes[idx];
		position = nodes.indexOf(node);
		if (position > -1 && position < idx) {
			nodes.splice(idx, 1);
		}
	}
	nodes.sort(function(a, b) {
		var relative = comparePos(a, b);
		if (relative & POSITION.PRECEDING) {
			return -1;
		} else if (relative & POSITION.FOLLOWING) {
			return 1;
		}
		return 0;
	});

	return nodes;
};


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = CollectingHandler;

function CollectingHandler(cbs){
	this._cbs = cbs || {};
	this.events = [];
}

var EVENTS = __webpack_require__(271).EVENTS;
Object.keys(EVENTS).forEach(function(name){
	if(EVENTS[name] === 0){
		name = "on" + name;
		CollectingHandler.prototype[name] = function(){
			this.events.push([name]);
			if(this._cbs[name]) this._cbs[name]();
		};
	} else if(EVENTS[name] === 1){
		name = "on" + name;
		CollectingHandler.prototype[name] = function(a){
			this.events.push([name, a]);
			if(this._cbs[name]) this._cbs[name](a);
		};
	} else if(EVENTS[name] === 2){
		name = "on" + name;
		CollectingHandler.prototype[name] = function(a, b){
			this.events.push([name, a, b]);
			if(this._cbs[name]) this._cbs[name](a, b);
		};
	} else {
		throw Error("wrong number of arguments");
	}
});

CollectingHandler.prototype.onreset = function(){
	this.events = [];
	if(this._cbs.onreset) this._cbs.onreset();
};

CollectingHandler.prototype.restart = function(){
	if(this._cbs.onreset) this._cbs.onreset();

	for(var i = 0, len = this.events.length; i < len; i++){
		if(this._cbs[this.events[i][0]]){

			var num = this.events[i].length;

			if(num === 1){
				this._cbs[this.events[i][0]]();
			} else if(num === 2){
				this._cbs[this.events[i][0]](this.events[i][1]);
			} else {
				this._cbs[this.events[i][0]](this.events[i][1], this.events[i][2]);
			}
		}
	}
};


/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1995)();
}


/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var ReactPropTypesSecret = __webpack_require__(1996);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1998);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./warning-icon.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./warning-icon.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n@-webkit-keyframes warning-icon--warningflash--1uPCCiFB {\n  0% { color: rgba(255, 0, 0, .2); }\n  50% { color: rgba(255, 0, 0, 1); }\n  100% { color: rgba(255, 0, 0, .2); }\n}\n\n@keyframes warning-icon--warningflash--1uPCCiFB {\n  0% { color: rgba(255, 0, 0, .2); }\n  50% { color: rgba(255, 0, 0, 1); }\n  100% { color: rgba(255, 0, 0, .2); }\n}\n\n.warning-icon--warning--1DE2JRZ6 {\n  animation: warning-icon--warningflash--1uPCCiFB 1.5s infinite;\n  -webkit-animation: warning-icon--warningflash--1uPCCiFB 1.5s infinite;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/warning-icon.css"],"names":[],"mappings":";AACA;EACE,KAAK,2BAA2B,EAAE;EAClC,MAAM,0BAA0B,EAAE;EAClC,OAAO,2BAA2B,EAAE;CACrC;;AAED;EACE,KAAK,2BAA2B,EAAE;EAClC,MAAM,0BAA0B,EAAE;EAClC,OAAO,2BAA2B,EAAE;CACrC;;AAED;EACE,8DAAsC;EACtC,sEAA8C;CAC/C","file":"warning-icon.css","sourcesContent":["\n@-webkit-keyframes warningflash {\n  0% { color: rgba(255, 0, 0, .2); }\n  50% { color: rgba(255, 0, 0, 1); }\n  100% { color: rgba(255, 0, 0, .2); }\n}\n\n@keyframes warningflash {\n  0% { color: rgba(255, 0, 0, .2); }\n  50% { color: rgba(255, 0, 0, 1); }\n  100% { color: rgba(255, 0, 0, .2); }\n}\n\n.warning {\n  animation: warningflash 1.5s infinite;\n  -webkit-animation: warningflash 1.5s infinite;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"warning": "warning-icon--warning--1DE2JRZ6",
	"warningflash": "warning-icon--warningflash--1uPCCiFB"
};

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.no-scrollbar--noScrollBar--1OBOAxho {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  -ms-overflow-style: none;\n}\n\n.no-scrollbar--noYScrollBar--2fM1EuMP {\n  overflow-x: scroll;\n  -ms-overflow-style: none;\n}\n\n.no-scrollbar--noYScrollBar--2fM1EuMP::-webkit-scrollbar {\n  display: none;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/no-scrollbar.css"],"names":[],"mappings":";AACA;EACE,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;CAC1B;;AAED;EACE,mBAAmB;EACnB,yBAAyB;CAC1B;;AAED;EACE,cAAc;CACf","file":"no-scrollbar.css","sourcesContent":["\n.noScrollBar {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  -ms-overflow-style: none;\n}\n\n.noYScrollBar {\n  overflow-x: scroll;\n  -ms-overflow-style: none;\n}\n\n.noYScrollBar::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"noScrollBar": "no-scrollbar--noScrollBar--1OBOAxho",
	"noYScrollBar": "no-scrollbar--noYScrollBar--2fM1EuMP"
};

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserSelectionDialogProvider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _propTypes = __webpack_require__(4);

var _userSelectionDialog = __webpack_require__(2001);

var _userSelectionDialog2 = _interopRequireDefault(_userSelectionDialog);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _dialog = __webpack_require__(47);

var _list = __webpack_require__(25);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _compactInput = __webpack_require__(178);

var _compactInput2 = _interopRequireDefault(_compactInput);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _scrollableDialogPanel = __webpack_require__(163);

var _scrollableDialogPanel2 = _interopRequireDefault(_scrollableDialogPanel);

var _infiniteScroller = __webpack_require__(75);

var _store = __webpack_require__(18);

var _reactNotificationBadge = __webpack_require__(186);

var _reactNotificationBadge2 = _interopRequireDefault(_reactNotificationBadge);

var _formValidator = __webpack_require__(41);

var _actionDialog = __webpack_require__(224);

var _actionDialog2 = _interopRequireDefault(_actionDialog);

var _noPaddingList = __webpack_require__(931);

var _noPaddingList2 = _interopRequireDefault(_noPaddingList);

var _noScrollbar = __webpack_require__(498);

var _noScrollbar2 = _interopRequireDefault(_noScrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/user-selection-dialog.jsx

var UserSelectionDialogProvider = function (_React$Component) {
  _inherits(UserSelectionDialogProvider, _React$Component);

  function UserSelectionDialogProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserSelectionDialogProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserSelectionDialogProvider.__proto__ || Object.getPrototypeOf(UserSelectionDialogProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleChange = function () {
      return _this.props.updateUI({ mode: _this.props.ui.mode == 'GROUP_MEMBERS' ? 'GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS' : 'GROUP_MEMBERS' });
    }, _this.memberChange = function () {
      return _this.props.updateUI({ mode: _this.props.ui.mode == 'GROUP_MEMBERS_MENTION' ? 'MENTION_TO_USERS' : 'GROUP_MEMBERS_MENTION' });
    }, _this.fetchUsers = function () {
      return !_this.props.isFetching && _this.props.fetchUsers(_this.props);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserSelectionDialogProvider, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          users = _props.users,
          hasMore = _props.hasMore,
          isFetching = _props.isFetching,
          updateUI = _props.updateUI,
          fetchUsers = _props.fetchUsers,
          onSelect = _props.onSelect,
          onFinish = _props.onFinish,
          children = _props.children;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _dialog.Dialog,
          { active: ui.active, theme: _actionDialog2.default,
            title: !ui.search && _react2.default.createElement(
              'div',
              { style: { display: 'flex' } },
              _react2.default.createElement(
                'div',
                null,
                ui.title,
                ui.selected && ui.selected.length > 0 && _react2.default.createElement(_reactNotificationBadge2.default, { count: ui.selected.length,
                  containerStyle: { display: 'inline' },
                  style: { top: 'auto', right: 'auto' } })
              ),
              _react2.default.createElement(
                'div',
                { style: { marginLeft: 'auto', marginRight: 0 } },
                _react2.default.createElement(_button.IconButton, { icon: 'search', onClick: function onClick() {
                    return updateUI({ search: true });
                  } })
              )
            ) || _react2.default.createElement(
              'div',
              { style: { display: 'flex' } },
              _react2.default.createElement(_compactInput2.default, { type: 'text', className: 'fluid',
                hint: t('label:名前で検索'),
                value: ui.query,
                hasFocus: true,
                onChange: (0, _formValidator.linkUI)(this, 'query', function (value) {
                  return !value && updateUI({ search: false });
                }) }),
              _react2.default.createElement(
                'div',
                { style: { marginLeft: 'auto', marginRight: 0 } },
                _react2.default.createElement(_button.IconButton, { icon: 'close', onClick: function onClick() {
                    return updateUI({ search: false, query: undefined });
                  } })
              )
            ),
            actions: _lodash2.default.filter([{ raised: true, label: t('label:取り消し'), onClick: function onClick() {
                return updateUI({ active: false });
              } }, ui.multiple && { primary: true, raised: true, icon: 'check', label: t('label:OK'), onClick: function onClick() {
                onFinish(_this2.props);
              } }], function (item) {
              return item;
            }),
            onOverlayClick: function onOverlayClick() {
              return updateUI({ active: false });
            },
            onEscKeyDown: function onEscKeyDown() {
              return updateUI({ active: false });
            } },
          (ui.mode == 'GROUP_MEMBERS' || ui.mode == 'GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS') && _react2.default.createElement(_checkbox2.default, {
            checked: ui.mode == 'GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS',
            label: t('label:削除したメンバーのみを表示'),
            onChange: this.handleChange }),
          ui.group && ui.group.members && ui.group.access_type && ui.group.access_type != 'private_access' && (ui.mode == 'GROUP_MEMBERS_MENTION' || ui.mode == 'MENTION_TO_USERS') && _react2.default.createElement(_checkbox2.default, {
            checked: ui.mode == 'GROUP_MEMBERS_MENTION',
            label: t('label:グループ所属'),
            onChange: this.memberChange }),
          ui.multiple && (ui.mode != 'OTHER_MEMBERS' || ui.mode != 'GROUP_MEMBERS' || ui.mode == 'ACCOUNT_MEMBERS' || ui.mode == 'GROUP_MEMBERS_MENTION') && (!ui.selected || ui.selected == '') && _react2.default.createElement(_button.Button, { label: t('label:すべて選択'), raised: true, style: { marginTop: 4 }, onClick: function onClick() {
              return _this2.props.selectAll(_this2.props, users);
            } }),
          ui.multiple && (ui.mode == 'MENTION_TO_USERS' || ui.mode == 'GROUP_MEMBERS' || ui.mode == 'ACCOUNT_MEMBERS' || ui.mode == 'GROUP_MEMBERS_MENTION') && ui.selected && ui.selected != '' && _react2.default.createElement(_button.Button, { label: t('label:すべて解除'), raised: true, style: { marginTop: 4 }, onClick: function onClick() {
              return _this2.props.unselectAll(_this2.props);
            } }),
          _react2.default.createElement(
            _scrollableDialogPanel2.default,
            { extraHeight: ui.multiple ? 71 : 0 },
            ui.active && _react2.default.createElement(
              _infiniteScroller.InfiniteScroll,
              { pageStart: 0,
                element: 'ul',
                className: (0, _classnames2.default)(_noPaddingList2.default.list),
                loadMore: this.fetchUsers,
                hasMore: hasMore,
                initialLoad: false,
                loader: isFetching && _react2.default.createElement(_list.ListItem, { caption: t('label:読み込み中') }),
                useWindow: false },
              users && users.map(function (user) {
                return _react2.default.createElement(_list.ListItem, { key: user.user_id, selectable: true,
                  onClick: function onClick() {
                    return ui.selected && ui.selected.find(function (v) {
                      return v.user_id == user.user_id;
                    }) ? updateUI({ selected: (0, _store.deleteArray)('user_id', ui.selected, user.user_id) }) : onSelect(_this2.props, user);
                  },
                  avatar: !(ui.selected && ui.selected.find(function (v) {
                    return v.user_id == user.user_id;
                  })) && _react2.default.createElement(_avatar2.default, { image: user.icon_image.thumb_url }) || _react2.default.createElement(_avatar2.default, { style: { backgroundColor: '#5067FF' }, icon: _react2.default.createElement(_font_icon2.default, { value: 'check', style: { width: 'inherit', marginTop: 8 } }) }),
                  caption: user.name });
              })
            )
          )
        ),
        children
      );
    }
  }]);

  return UserSelectionDialogProvider;
}(_react2.default.Component);

var RawUserSelectionDialogProvider = exports.RawUserSelectionDialogProvider = UserSelectionDialogProvider;
exports.default = (0, _userSelectionDialog2.default)(UserSelectionDialogProvider);

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _context = __webpack_require__(39);

var _store = __webpack_require__(18);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _mentionsStore = __webpack_require__(883);

var _mentionsStore2 = _interopRequireDefault(_mentionsStore);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _some = __webpack_require__(161);

var _some2 = _interopRequireDefault(_some);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    users: state.account.items,
    isFetching: state.account.isFetching,
    hasMore: state.account.hasMore
  };
};
// src/connects/user-selection-dialog.js

function _fetchUsers(dispatch, mode, offset, group, query) {
  switch (mode) {
    case 'ACCOUNT_MEMBERS':
      dispatch(_actions2.default.fetchAccountMembers(offset, query));
      return;
    case 'OTHER_MEMBERS':
      dispatch(_actions2.default.fetchOtherMembers(offset, group.group_id, query));
      return;
    case 'MENTION_TO_USERS':
      var mentions_ids = undefined;
      _mentionsStore2.default.get(function (mentions_list) {
        if (mentions_list && mentions_list.length > 0) {
          mentions_ids = (0, _map2.default)(mentions_list, function (_mentions_list) {
            return _mentions_list;
          }).join(',');
        }
        if (group) dispatch(_actions2.default.fetchMentionToUsers(offset, group.group_id, mentions_ids, query));
      });
      return;
    case 'GROUP_MEMBERS':
    case 'GROUP_MEMBERS_MENTION':
      dispatch(_actions2.default.fetchGroupMembersUsers(group.members, query));
      return;
    case 'GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS':
      dispatch(_actions2.default.fetchGroupMembersOnlyResignedMembers(offset, group.group_id, query));
      return;
  }
}

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willUpdate: function willUpdate(props, nextProps) {
      // clear users data when dialog close
      if (props.ui && nextProps.ui && props.ui.active && !nextProps.ui.active) {
        props.updateUI({
          selected: undefined,
          query: undefined,
          search: false,
          mode: undefined,
          group: undefined,
          mentions: undefined
        });
        dispatch(_actions2.default.clearFetchedUsers());
      }

      // reload when query change
      if (props.ui && nextProps.ui && nextProps.ui.active && (props.ui.group != nextProps.ui.group || props.ui.query != nextProps.ui.query || props.ui.mode != nextProps.ui.mode)) {
        _fetchUsers(dispatch, nextProps.ui.mode, 0, nextProps.ui.group, nextProps.ui.query);
      }

      //グループに所属していないユーザーも選択した状態から再度ダイアログを開いた時にmodeをMENTION_TO_USERSに変更させる
      if (props.ui && nextProps.ui && nextProps.ui.mode == 'GROUP_MEMBERS_MENTION' && nextProps.ui.group && props.ui.active != nextProps.ui.active && nextProps.ui.selected && nextProps.ui.selected.length > 0) {
        var groupMembersHash = nextProps.ui.group.members.reduce(function (r, member) {
          r[member.user_id] = true;
          return r;
        }, {});

        var notGroupMembers = (0, _some2.default)(nextProps.ui.selected, function (user) {
          return groupMembersHash[String(user.user_id)] == null;
        });
        if (notGroupMembers) {
          nextProps.updateUI({ mode: 'MENTION_TO_USERS' });
        }
      }

      //グループに所属していないユーザーも選択した状態からグループのみ表示に切り替えた時に、所属していないユーザーは除外する
      if (props.ui && nextProps.ui && props.ui.mode == 'MENTION_TO_USERS' && nextProps.ui.mode == 'GROUP_MEMBERS_MENTION' && props.ui.selected) {
        var _groupMembersHash = props.ui.group.members.reduce(function (r, member) {
          r[member.user_id] = true;
          return r;
        }, {});

        var changeMember = (0, _filter2.default)(props.ui.selected, function (user) {
          return _groupMembersHash[String(user.user_id)] == true;
        });
        nextProps.updateUI({
          selected: (0, _store.mergeArray)('user_id', [], changeMember),
          active: true
        });
      }
    },

    fetchUsers: function fetchUsers(props) {
      var offset = props.users && props.users.length || 0;
      _fetchUsers(dispatch, props.ui.mode, offset, props.ui.group, props.ui.query);
    },

    onSelect: function onSelect(props, user) {
      !props.ui.multiple && props.ui.callback && props.ui.callback(user);
      props.updateUI({
        selected: (0, _store.mergeArray)('user_id', props.ui.selected, [user]),
        active: props.ui.multiple
      });
    },

    selectAll: function selectAll(props) {
      props.updateUI({
        selected: (0, _store.mergeArray)('user_id', [], props.users),
        active: true
      });
    },

    unselectAll: function unselectAll(props) {
      props.updateUI({
        selected: undefined,
        active: true
      });
    },

    onFinish: function onFinish(props) {
      props.updateUI({ active: false });
      props.ui.callback && props.ui.callback(props.ui.selected);
      if (props.ui.mode == 'MENTION_TO_USERS') {
        _mentionsStore2.default.set(props.ui.selected && (0, _map2.default)(props.ui.selected, function (user) {
          return user.user_id;
        }) || []);
      }
    },

    showUserSelectionDialog: function showUserSelectionDialog(title, multiple, mode, group, selected, callback, props) {
      props.updateUI({
        active: true,
        title: title,
        multiple: multiple,
        mode: mode,
        group: group,
        callback: callback,
        selected: selected
      });
    }
    // title: dialog title
    // multiple: multiple selection or single selection dialog
    // mode: 'ACCOUNT_MEMBERS', 'OTHER_MEMBERS', 'MENTION_TO_USERS', 'GROUP_MEMBERS', 'GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS
    // group: Array<group>
    // callback: callback when selected
    // props: will be injected by 'inject'
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    active: false,
    title: undefined,
    multiple: false,
    mode: undefined,
    group: undefined,
    callback: undefined,
    query: undefined,
    selected: undefined,
    search: false,
    mentions: undefined
  } }), (0, _reactI18next.translate)(), _lifecycle2.default, (0, _context.inject)({ showUserSelectionDialog: _propTypes2.default.func }));

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2003);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--chip--WkYHfcjC {\n  background-color: rgb(238, 238, 238);\n  border-radius: 32px;\n  color: rgb(117, 117, 117);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 32px;\n  margin-right: 2.5px;\n  max-width: 100%;\n  overflow: hidden;\n  padding: 0 12px;\n  position: relative;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.theme--chip--WkYHfcjC *,\n    .theme--chip--WkYHfcjC *::after,\n    .theme--chip--WkYHfcjC *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--avatar--2IppxWTb {\n  padding-left: 0\n}\n.theme--avatar--2IppxWTb > [data-react-toolbox='avatar'] {\n  height: 32px;\n  margin-right: 8px;\n  vertical-align: middle;\n  width: 32px;\n}\n.theme--avatar--2IppxWTb > [data-react-toolbox='avatar'] > span {\n  font-size: 20px;\n  line-height: 32px;\n}\n.theme--deletable--29KFPNeX {\n  padding-right: 32px;\n}\n.theme--delete--2hlQdjST {\n  cursor: pointer;\n  display: inline-block;\n  height: 24px;\n  margin: 4px;\n  padding: 4px;\n  position: absolute;\n  right: 0;\n  width: 24px;\n}\n.theme--delete--2hlQdjST:hover .theme--deleteIcon--3o28dcCs {\n  background: rgb(158, 158, 158);\n}\n.theme--deleteIcon--3o28dcCs {\n  background: rgb(189, 189, 189);\n  border-radius: 24px;\n  vertical-align: top\n}\n.theme--deleteIcon--3o28dcCs .theme--deleteX--2FMIKSo9 {\n  fill: transparent;\n  stroke: rgb(255, 255, 255);\n  stroke-width: 4px;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/chip/theme.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;CAChC;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,eAAe;CAChB;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;CACb;AACD;EACE,+BAA+B;CAChC;AACD;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;CACpB;AACD;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;CACnB","file":"theme.css","sourcesContent":[".chip {\n  background-color: rgb(238, 238, 238);\n  border-radius: 32px;\n  color: rgb(117, 117, 117);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 32px;\n  margin-right: 2.5px;\n  max-width: 100%;\n  overflow: hidden;\n  padding: 0 12px;\n  position: relative;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.chip *,\n    .chip *::after,\n    .chip *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.avatar {\n  padding-left: 0\n}\n.avatar > [data-react-toolbox='avatar'] {\n  height: 32px;\n  margin-right: 8px;\n  vertical-align: middle;\n  width: 32px;\n}\n.avatar > [data-react-toolbox='avatar'] > span {\n  font-size: 20px;\n  line-height: 32px;\n}\n.deletable {\n  padding-right: 32px;\n}\n.delete {\n  cursor: pointer;\n  display: inline-block;\n  height: 24px;\n  margin: 4px;\n  padding: 4px;\n  position: absolute;\n  right: 0;\n  width: 24px;\n}\n.delete:hover .deleteIcon {\n  background: rgb(158, 158, 158);\n}\n.deleteIcon {\n  background: rgb(189, 189, 189);\n  border-radius: 24px;\n  vertical-align: top\n}\n.deleteIcon .deleteX {\n  fill: transparent;\n  stroke: rgb(255, 255, 255);\n  stroke-width: 4px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"chip": "theme--chip--WkYHfcjC",
	"avatar": "theme--avatar--2IppxWTb",
	"deletable": "theme--deletable--29KFPNeX",
	"delete": "theme--delete--2hlQdjST",
	"deleteIcon": "theme--deleteIcon--3o28dcCs",
	"deleteX": "theme--deleteX--2FMIKSo9"
};

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = (_temp = _class = function (_Component) {
  _inherits(InfiniteScroll, _Component);

  _createClass(InfiniteScroll, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        infiniteScrollComponent: this
      };
    }
  }]);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.ref = function (node) {
      if (node) {
        _this.scrollComponent = node;
        _this.scrollWindow = _this.props.useWindow === false ? node.parentNode : window;
      }
    };

    _this.scrollListener = _this.scrollListener.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.pageLoaded = this.props.pageStart;
      this.scrollWindow = this.props.useWindow === false ? this.scrollComponent.parentNode : window;
      this.attachScrollListener();
    }
  }, {
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate() {
      if (this.props.isReverse) {
        var scrollEl = window;
        if (this.props.useWindow === false) {
          scrollEl = this.scrollComponent.parentNode;
        }
        this.scrollHeight = scrollEl.scrollHeight;
        this.scrollTop = scrollEl.scrollTop;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.children !== this.props.children) this.attachScrollListener();
      if (this.props.isReverse) {
        var scrollEl = window;
        if (this.props.useWindow === false) {
          scrollEl = this.scrollComponent.parentNode;
        }
        scrollEl.scrollTop = this.scrollTop + (scrollEl.scrollHeight - this.scrollHeight);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
    }

    // Set a defaut loader for all your `InfiniteScroll` components

  }, {
    key: 'setDefaultLoader',
    value: function setDefaultLoader(loader) {
      this.defaultLoader = loader;
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.props.useCapture);
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      if (!this.props.hasMore) {
        return;
      }

      var scrollEl = window;
      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.addEventListener('scroll', this.scrollListener, this.props.useCapture);
      scrollEl.addEventListener('resize', this.scrollListener, this.props.useCapture);

      this.initialPosition();
    }
  }, {
    key: 'initialPosition',
    value: function initialPosition() {
      if ((this.props.useWindow ? window.innerHeight : this.scrollComponent.parentNode.clientHeight) > this.scrollComponent.clientHeight - this.props.loaderHeight && this.scrollComponent.clientHeight - this.props.loaderHeight > 0) {
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
        }
      }
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = window;

      var offset = void 0;
      if (this.props.useWindow) {
        var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
        if (this.props.isReverse) {
          offset = scrollTop;
        } else {
          offset = this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
        }
      } else if (this.props.isReverse) {
        offset = el.parentNode.scrollTop;
      } else {
        offset = el.scrollHeight - el.parentNode.scrollTop - el.parentNode.clientHeight;
      }

      if (offset < Number(this.props.threshold)) {
        this.detachScrollListener();
        // Call loadMore after detachScrollListener to allow for non-async loadMore functions
        if (typeof this.props.loadMore === 'function') {
          this.props.loadMore(this.pageLoaded += 1);
        }
      }
    }
  }, {
    key: 'calculateTopPosition',
    value: function calculateTopPosition(el) {
      if (!el) {
        return 0;
      }
      return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          element = _props.element,
          hasMore = _props.hasMore,
          initialLoad = _props.initialLoad,
          isReverse = _props.isReverse,
          loader = _props.loader,
          loadMore = _props.loadMore,
          pageStart = _props.pageStart,
          threshold = _props.threshold,
          useCapture = _props.useCapture,
          useWindow = _props.useWindow,
          props = _objectWithoutProperties(_props, ['children', 'element', 'hasMore', 'initialLoad', 'isReverse', 'loader', 'loadMore', 'pageStart', 'threshold', 'useCapture', 'useWindow']);

      props.ref = this.ref;

      return _react2.default.createElement(element, props, isReverse ? hasMore && (loader || this.defaultLoader) : children, isReverse ? children : hasMore && (loader || this.defaultLoader));
    }
  }]);

  return InfiniteScroll;
}(_react.Component), _class.propTypes = {
  element: _propTypes2.default.string,
  hasMore: _propTypes2.default.bool,
  initialLoad: _propTypes2.default.bool,
  isReverse: _propTypes2.default.bool,
  loadMore: _propTypes2.default.func.isRequired,
  pageStart: _propTypes2.default.number,
  threshold: _propTypes2.default.number,
  useCapture: _propTypes2.default.bool,
  useWindow: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired,
  loader: _propTypes2.default.object,
  loaderHeight: _propTypes2.default.number
}, _class.defaultProps = {
  element: 'div',
  hasMore: false,
  initialLoad: true,
  pageStart: 0,
  threshold: 250,
  useWindow: true,
  isReverse: false,
  useCapture: false,
  loader: null,
  loaderHeight: 64
}, _class.childContextTypes = {
  infiniteScrollComponent: _propTypes2.default.object
}, _temp);
exports.default = InfiniteScroll;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InviewSensor = (_temp = _class = function (_React$Component) {
  _inherits(InviewSensor, _React$Component);

  function InviewSensor(props) {
    _classCallCheck(this, InviewSensor);

    var _this = _possibleConstructorReturn(this, (InviewSensor.__proto__ || Object.getPrototypeOf(InviewSensor)).call(this, props));

    _this.state = {
      isVisible: null
    };
    _this.check = _.throttle(_this.check.bind(_this), 100);
    return _this;
  }

  _createClass(InviewSensor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.context.infiniteScrollComponent && this.context.infiniteScrollComponent.scrollWindow) {
        this.eventAdded = true;
        if (this.context.infiniteScrollComponent.scrollComponent.scrollHeight <= this.context.infiniteScrollComponent.scrollWindow.clientHeight) {
          this.setState({ isVisible: true });
          this.props.onChange(true);
        } else this.context.infiniteScrollComponent.scrollWindow.addEventListener('scroll', this.check);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.context.infiniteScrollComponent && this.context.infiniteScrollComponent.scrollWindow) {
        this.context.infiniteScrollComponent.scrollWindow.removeEventListener('scroll', this.check);
        this.check = undefined;
      }
    }
  }, {
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps, nextState, nextContext) {
      if (!this.eventAdded && this.context.infiniteScrollComponent && this.context.infiniteScrollComponent.scrollWindow) {
        this.context.infiniteScrollComponent.scrollWindow.addEventListener('scroll', this.check);
        this.eventAdded = true;
      }
    }
  }, {
    key: 'check',
    value: function check() {
      var forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!forced && !document.hasFocus() || !this.check) return;

      var el = _reactDom2.default.findDOMNode(this);
      if (!el || !this.context.infiniteScrollComponent || !this.context.infiniteScrollComponent.scrollWindow) return;

      var rect = el.getBoundingClientRect();
      var containmentRect = this.context.infiniteScrollComponent.scrollWindow.getBoundingClientRect();
      var isVisible = rect.top >= containmentRect.top && rect.bottom <= containmentRect.bottom;

      // notify the parent when the value changes
      if (this.state.isVisible !== isVisible) {
        this.setState({ isVisible: isVisible });
        if (isVisible) this.context.infiniteScrollComponent.scrollWindow.removeEventListener('scroll', this.check);
        this.props.onChange(isVisible);
      }

      return this.state;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.Children.only(this.props.children);
    }
  }]);

  return InviewSensor;
}(_react2.default.Component), _class.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  active: _propTypes2.default.bool,
  partialVisibility: _propTypes2.default.bool,
  delay: _propTypes2.default.number,
  delayedCall: _propTypes2.default.bool,
  children: _propTypes2.default.element,
  minTopValue: _propTypes2.default.number
}, _class.contextTypes = {
  infiniteScrollComponent: _propTypes2.default.object
}, _class.defaultProps = {
  active: true,
  partialVisibility: false,
  minTopValue: false,
  children: _react2.default.createElement('span')
}, _temp);
exports.default = InviewSensor;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AnimationCounter = __webpack_require__(2007);

var _AnimationCounter2 = _interopRequireDefault(_AnimationCounter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  container: {
    position: 'relative',
    width: '100%',
    height: '100%'
  },

  badge: {
    WebkitTransition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    MozTransition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    msTransition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    display: 'inline-block',
    position: 'absolute',
    minWidth: '10px',
    padding: '3px 7px',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '1',
    color: '#fff',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'baseline',
    backgroundColor: 'rgba(212, 19, 13, 1)',
    borderRadius: '10px',
    top: '-2px',
    right: '-2px'
  }
};

var NotificationBadge = function (_React$Component) {
  _inherits(NotificationBadge, _React$Component);

  function NotificationBadge(props) {
    _classCallCheck(this, NotificationBadge);

    var _this = _possibleConstructorReturn(this, (NotificationBadge.__proto__ || Object.getPrototypeOf(NotificationBadge)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(NotificationBadge, [{
    key: 'render',
    value: function render() {
      var badgeStyle = this.merge(styles.badge, this.props.style);
      var containerStyle = this.merge(styles.container, this.props.containerStyle);
      var value = this.props.count > 0 ? _react2.default.createElement(_AnimationCounter2.default, {
        key: 'badgekey',
        style: badgeStyle,
        className: this.props.className,
        count: this.props.count,
        label: this.props.label,
        effect: this.props.effect,
        fps: this.props.fps,
        frameLength: this.props.frameLength
      }) : undefined;

      return _react2.default.createElement(
        'div',
        { style: containerStyle },
        value
      );
    }
  }, {
    key: 'merge',
    value: function merge(obj1, obj2) {
      var obj = {};
      for (var attrname1 in obj1) {
        if (obj1.hasOwnProperty(attrname1)) {
          obj[attrname1] = obj1[attrname1];
        }
      }
      for (var attrname2 in obj2) {
        if (obj2.hasOwnProperty(attrname2)) {
          obj[attrname2] = obj2[attrname2];
        }
      }
      return obj;
    }
  }]);

  return NotificationBadge;
}(_react2.default.Component);

NotificationBadge.propTypes = {
  containerStyle: _propTypes2.default.object,
  count: _propTypes2.default.number,
  label: _propTypes2.default.string,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  effect: _propTypes2.default.array,
  fps: _propTypes2.default.number,
  frameLength: _propTypes2.default.number
};

NotificationBadge.defaultProps = {
  count: 0,
  style: {},
  containerStyle: {}
};

exports.default = NotificationBadge;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Effect = __webpack_require__(930);

var _Effect2 = _interopRequireDefault(_Effect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultSetTimeout = function defaultSetTimeout(callback) {
  setTimeout(callback, 1000.0 / 60.0);
};
var defaultClearTimeout = function defaultClearTimeout(timer) {
  clearTimeout(timer);
};

var requestAnimationFrame = function () {
  if (typeof window === 'undefined') {
    return defaultSetTimeout;
  } else {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || defaultSetTimeout;
  }
}();

var cancelAnimationFrame = function () {
  if (typeof window === 'undefined') {
    return defaultClearTimeout;
  } else {
    return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || window.msCancelAnimationFrame || defaultClearTimeout;
  }
}();

var now = typeof window !== 'undefined' && window.performance && (performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow);

var getTime = function getTime() {
  return now && now.call(performance) || Date.now();
};

var AnimationCounter = function (_React$Component) {
  _inherits(AnimationCounter, _React$Component);

  function AnimationCounter(props) {
    _classCallCheck(this, AnimationCounter);

    var _this = _possibleConstructorReturn(this, (AnimationCounter.__proto__ || Object.getPrototypeOf(AnimationCounter)).call(this, props));

    _this.state = {};
    _this.node = undefined;
    return _this;
  }

  _createClass(AnimationCounter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.count > 0) {
        this.node = _reactDom2.default.findDOMNode(this.refs.badge);
        this.animate();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.count > prevProps.count) {
        this.node = _reactDom2.default.findDOMNode(this.refs.badge);
        this.animate();
      }
    }
  }, {
    key: 'animate',
    value: function animate() {
      var _this2 = this;

      var style0 = {
        '-moz-transform': this.props.effect[0],
        '-webkit-transform': this.props.effect[0],
        '-o-transform': this.props.effect[0],
        transform: this.props.effect[0]
      };
      this.attachStyle(style0);
      if (this.props.effect[2]) {
        this.attachStyle(this.props.effect[2]);
      }

      var startTime = getTime();
      var timer = void 0;
      var waitOrFinish = function waitOrFinish() {
        var lastTime = getTime();
        var frame = Math.floor((lastTime - startTime) / (1000.0 / 60.0) % _this2.props.frameLength);
        if (frame === _this2.props.frameLength - 1) {
          cancelAnimationFrame(timer);
          var style1 = {
            '-moz-transform': _this2.props.effect[1],
            '-webkit-transform': _this2.props.effect[1],
            '-o-transform': _this2.props.effect[1],
            transform: _this2.props.effect[1]
          };
          _this2.attachStyle(style1);
          if (_this2.props.effect[3]) {
            _this2.attachStyle(_this2.props.effect[3]);
          }
        } else {
          timer = requestAnimationFrame(waitOrFinish);
        }
      };
      waitOrFinish();
    }
  }, {
    key: 'attachStyle',
    value: function attachStyle(style) {
      for (var key in style) {
        if (style.hasOwnProperty(key)) {
          this.node.style[key] = style[key];
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var value = this.props.label || this.props.count;
      return _react2.default.createElement(
        'span',
        { ref: 'badge', style: this.props.style, className: this.props.className },
        value
      );
    }
  }]);

  return AnimationCounter;
}(_react2.default.Component);

AnimationCounter.propTypes = {
  count: _propTypes2.default.number,
  label: _propTypes2.default.string,
  style: _propTypes2.default.object,
  effect: _propTypes2.default.array,
  frameLength: _propTypes2.default.number,
  className: _propTypes2.default.string
};

AnimationCounter.defaultProps = {
  count: 1,
  label: null,
  style: {},
  effect: _Effect2.default.SCALE,
  frameLength: 30.0
};

exports.default = AnimationCounter;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.no-padding-list--list--2jzt-_Xi {\n  padding: 0;\n  margin: 0;\n}\n\n.no-padding-list--itemAction--2wYl5xdL {\n  color: red;\n}", "", {"version":3,"sources":["/./src/web/components/themes/no-padding-list.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,UAAU;CACX;;AAED;EACE,WAAW;CACZ","file":"no-padding-list.css","sourcesContent":["\n.list {\n  padding: 0;\n  margin: 0;\n}\n\n.itemAction {\n  color: red;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"list": "no-padding-list--list--2jzt-_Xi",
	"itemAction": "no-padding-list--itemAction--2wYl5xdL"
};

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupSelectionDialogProvider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _propTypes = __webpack_require__(4);

var _groupSelectionDialog = __webpack_require__(2010);

var _groupSelectionDialog2 = _interopRequireDefault(_groupSelectionDialog);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _dialog = __webpack_require__(47);

var _list = __webpack_require__(25);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _compactInput = __webpack_require__(178);

var _compactInput2 = _interopRequireDefault(_compactInput);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _scrollableDialogPanel = __webpack_require__(163);

var _scrollableDialogPanel2 = _interopRequireDefault(_scrollableDialogPanel);

var _infiniteScroller = __webpack_require__(75);

var _store = __webpack_require__(18);

var _reactNotificationBadge = __webpack_require__(186);

var _reactNotificationBadge2 = _interopRequireDefault(_reactNotificationBadge);

var _formValidator = __webpack_require__(41);

var _actionDialog = __webpack_require__(224);

var _actionDialog2 = _interopRequireDefault(_actionDialog);

var _noPaddingList = __webpack_require__(931);

var _noPaddingList2 = _interopRequireDefault(_noPaddingList);

var _noScrollbar = __webpack_require__(498);

var _noScrollbar2 = _interopRequireDefault(_noScrollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-selection-dialog.jsx

var GroupSelectionDialogProvider = function (_React$Component) {
  _inherits(GroupSelectionDialogProvider, _React$Component);

  function GroupSelectionDialogProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GroupSelectionDialogProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupSelectionDialogProvider.__proto__ || Object.getPrototypeOf(GroupSelectionDialogProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.fetchGroups = function () {
      return !_this.props.isFetching && _this.props.fetchGroups(_this.props);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GroupSelectionDialogProvider, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          groups = _props.groups,
          hasMore = _props.hasMore,
          isFetching = _props.isFetching,
          updateUI = _props.updateUI,
          fetchGroups = _props.fetchGroups,
          onSelect = _props.onSelect,
          onFinish = _props.onFinish,
          children = _props.children;

      if (!groups) return null;
      var visibleGroups = ui.query ? groups.filter(function (group) {
        return group.name.includes(ui.query);
      }) : groups;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _dialog.Dialog,
          { active: ui.active, theme: _actionDialog2.default,
            title: !ui.search && _react2.default.createElement(
              'div',
              { style: { display: 'flex' } },
              _react2.default.createElement(
                'div',
                null,
                ui.title,
                ui.selected && ui.selected.length > 0 && _react2.default.createElement(_reactNotificationBadge2.default, { count: ui.selected.length,
                  containerStyle: { display: 'inline' },
                  style: { top: 'auto', right: 'auto' } })
              ),
              _react2.default.createElement(
                'div',
                { style: { marginLeft: 'auto', marginRight: 0 } },
                _react2.default.createElement(_button.IconButton, { icon: 'search', onClick: function onClick() {
                    return updateUI({ search: true });
                  } })
              )
            ) || _react2.default.createElement(
              'div',
              { style: { display: 'flex' } },
              _react2.default.createElement(_compactInput2.default, { type: 'text', className: 'fluid',
                hint: t('label:名前で検索'),
                value: ui.query,
                hasFocus: true,
                onChange: (0, _formValidator.linkUI)(this, 'query', function (value) {
                  return !value && updateUI({ search: false });
                }) }),
              _react2.default.createElement(
                'div',
                { style: { marginLeft: 'auto', marginRight: 0 } },
                _react2.default.createElement(_button.IconButton, { icon: 'close', onClick: function onClick() {
                    return updateUI({ search: false, query: undefined });
                  } })
              )
            ),
            actions: _lodash2.default.filter([{ raised: true, label: t('label:取り消し'), onClick: function onClick() {
                return updateUI({ active: false });
              } }, ui.multiple && { primary: true, raised: true, icon: 'check', label: t('label:OK'), onClick: function onClick() {
                onFinish(_this2.props);
              } }], function (item) {
              return item;
            }),
            onOverlayClick: function onOverlayClick() {
              return updateUI({ active: false });
            },
            onEscKeyDown: function onEscKeyDown() {
              return updateUI({ active: false });
            } },
          ui.multiple && (!ui.selected || ui.selected == '') && _react2.default.createElement(_button.Button, { label: t('label:すべて選択'), raised: true, style: { marginTop: 4 }, onClick: function onClick() {
              return _this2.props.selectAll(_this2.props, visibleGroups);
            } }),
          ui.multiple && ui.selected && ui.selected != '' && _react2.default.createElement(_button.Button, { label: t('label:すべて解除'), raised: true, style: { marginTop: 4 }, onClick: function onClick() {
              return _this2.props.unselectAll(_this2.props);
            } }),
          _react2.default.createElement(
            _scrollableDialogPanel2.default,
            { extraHeight: ui.multiple ? 71 : 0 },
            ui.active && _react2.default.createElement(
              _infiniteScroller.InfiniteScroll,
              { pageStart: 0,
                element: 'ul',
                className: (0, _classnames2.default)(_noPaddingList2.default.list),
                loadMore: this.fetchGroups,
                hasMore: hasMore,
                initialLoad: false,
                loader: isFetching && _react2.default.createElement(_list.ListItem, { caption: t('label:読み込み中') }),
                useWindow: false },
              visibleGroups && visibleGroups.map(function (group) {
                return _react2.default.createElement(
                  _list.ListItem,
                  { key: group.group_id, selectable: true,
                    onClick: function onClick() {
                      return ui.selected && ui.selected.find(function (v) {
                        return v.group_id == group.group_id;
                      }) ? updateUI({ selected: (0, _store.deleteArray)('group_id', ui.selected, group.group_id) }) : onSelect(_this2.props, group);
                    },
                    avatar: !(ui.selected && ui.selected.find(function (v) {
                      return v.group_id == group.group_id;
                    })) && _react2.default.createElement(_avatar2.default, { image: group.icon_image.thumb_url }) || _react2.default.createElement(_avatar2.default, { style: { backgroundColor: '#5067FF' }, icon: _react2.default.createElement(_font_icon2.default, { value: 'check', style: { width: 'inherit', marginTop: 8 } }) }),
                    caption: group.name },
                  _react2.default.createElement(
                    _list.ListItemContent,
                    null,
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'p',
                        { style: { color: 'rgb(33, 33, 33)', fontSize: 16 } },
                        group.name
                      ),
                      _react2.default.createElement(
                        'p',
                        { style: { color: 'rgb(117, 117, 117)' } },
                        t('label:persons_count', { value: group.members_count })
                      )
                    )
                  )
                );
              })
            )
          )
        ),
        children
      );
    }
  }]);

  return GroupSelectionDialogProvider;
}(_react2.default.Component);

var RawGroupSelectionDialogProvider = exports.RawGroupSelectionDialogProvider = GroupSelectionDialogProvider;
exports.default = (0, _groupSelectionDialog2.default)(GroupSelectionDialogProvider);

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _context = __webpack_require__(39);

var _store = __webpack_require__(18);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _some = __webpack_require__(161);

var _some2 = _interopRequireDefault(_some);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/group-selection-dialog.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var groups = state.groups.items;
  if (groups && state.divisions.items && state.divisions.currentId) {
    var divisions = state.divisions.items;
    divisions.forEach(function (division) {
      groups = groups.filter(function (group) {
        return group.is_free_group;
      });
    });
  }

  return {
    groups: groups,
    isFetching: state.account.isFetching
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willUpdate: function willUpdate(props, nextProps) {
      // clear users data when dialog close
      if (props.ui && nextProps.ui && props.ui.active && !nextProps.ui.active) {
        props.updateUI({
          selected: undefined,
          query: undefined,
          search: false,
          mode: undefined,
          group: undefined
        });
        dispatch(_actions2.default.clearFetchedUsers());
      }

      // reload when query change
      if (props.ui && nextProps.ui && nextProps.ui.active && (props.ui.group != nextProps.ui.group || props.ui.query != nextProps.ui.query || props.ui.mode != nextProps.ui.mode)) {
        dispatch(_actions2.default.fetchGroups());
      }
    },

    fetchGroups: function fetchGroups(props) {
      // do nothing
    },

    onSelect: function onSelect(props, group) {
      !props.ui.multiple && props.ui.callback && props.ui.callback(group);
      props.updateUI({
        selected: (0, _store.mergeArray)('group_id', props.ui.selected, [group]),
        active: props.ui.multiple
      });
    },

    selectAll: function selectAll(props) {
      var visibleGroups = props.ui.query ? props.groups.filter(function (group) {
        return group.name.includes(props.ui.query);
      }) : props.groups;
      props.updateUI({
        selected: (0, _store.mergeArray)('group_id', [], visibleGroups),
        active: true
      });
    },

    unselectAll: function unselectAll(props) {
      props.updateUI({
        selected: undefined,
        active: true
      });
    },

    onFinish: function onFinish(props) {
      props.updateUI({ active: false });
      props.ui.callback && props.ui.callback(props.ui.selected);
    },

    showGroupSelectionDialog: function showGroupSelectionDialog(title, multiple, mode, selected, callback, props) {
      props.updateUI({
        active: true,
        title: title,
        multiple: multiple,
        mode: mode,
        callback: callback,
        selected: selected
      });
    }
    // title: dialog title
    // multiple: multiple selection or single selection dialog
    // mode: OTHER_GROUPS
    // callback: callback when selected
    // props: will be injected by 'inject'
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    active: false,
    title: undefined,
    multiple: false,
    mode: undefined,
    callback: undefined,
    query: undefined,
    selected: undefined,
    search: false
  } }), (0, _reactI18next.translate)(), _lifecycle2.default, (0, _context.inject)({ showGroupSelectionDialog: _propTypes2.default.func }));

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;
// src/web/components/emoji-palette.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _propTypes = __webpack_require__(4);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _dialog = __webpack_require__(47);

var _layout = __webpack_require__(85);

var _button = __webpack_require__(8);

var _scrollableDialogPanel = __webpack_require__(163);

var _scrollableDialogPanel2 = _interopRequireDefault(_scrollableDialogPanel);

var _emojiPaletteChars = __webpack_require__(2012);

var _emojiPaletteChars2 = _interopRequireDefault(_emojiPaletteChars);

var _actionDialog = __webpack_require__(224);

var _actionDialog2 = _interopRequireDefault(_actionDialog);

var _emoji = __webpack_require__(187);

var _emoji2 = _interopRequireDefault(_emoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmojiPaletteProvider = (_temp2 = _class = function (_React$Component) {
  _inherits(EmojiPaletteProvider, _React$Component);

  function EmojiPaletteProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EmojiPaletteProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmojiPaletteProvider.__proto__ || Object.getPrototypeOf(EmojiPaletteProvider)).call.apply(_ref, [this].concat(args))), _this), _this.onClose = function () {
      return _this.props.updateUI({ active: false });
    }, _this.onSelect = function (event) {
      var shortname = event.currentTarget.attributes['data-shortname'].value;
      var unicode = event.currentTarget.attributes['data-unicode'].value;
      _this.props.ui.callback && _this.props.ui.callback(shortname, unicode);
      _this.props.updateUI({ active: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EmojiPaletteProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      return {
        showEmojiPalette: function showEmojiPalette(callback) {
          _this2.props.updateUI({ active: true, callback: callback });
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          children = _props.children,
          updateUI = _props.updateUI;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _dialog.Dialog,
          { active: ui.active, theme: _actionDialog2.default,
            title: t('label:絵文字を入力'),
            actions: [{ label: t('label:取り消し'), onClick: this.onClose }],
            onOverlayClick: this.onClose,
            onEscKeyDown: this.onClose },
          _react2.default.createElement(
            _scrollableDialogPanel2.default,
            null,
            _emojiPaletteChars2.default.map(function (char) {
              return _react2.default.createElement('img', { onClick: _this3.onSelect, key: char.unicode,
                src: _emoji2.default[char.unicode],
                'data-unicode': char.unicode,
                'data-shortname': char.shortname,
                width: '24px', height: '24px',
                style: { margin: '2px', cursor: 'pointer' } });
            })
          )
        ),
        children
      );
    }
  }]);

  return EmojiPaletteProvider;
}(_react2.default.Component), _class.childContextTypes = {
  showEmojiPalette: _propTypes.PropTypes.func
}, _temp2);
exports.default = (0, _reactI18next.translate)()((0, _uiState2.default)({ state: { active: false, callback: undefined } })(EmojiPaletteProvider));

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var emojiPaletteChars = [{ unicode: "1f600", shortname: ":grinning:" }, { unicode: "1f62c", shortname: ":grimacing:" }, { unicode: "1f601", shortname: ":grin:" }, { unicode: "1f602", shortname: ":joy:" }, { unicode: "1f603", shortname: ":smiley:" }, { unicode: "1f604", shortname: ":smile:" }, { unicode: "1f605", shortname: ":sweat_smile:" }, { unicode: "1f606", shortname: ":laughing:" }, { unicode: "1f607", shortname: ":innocent:" }, { unicode: "1f609", shortname: ":wink:" }, { unicode: "1f60a", shortname: ":blush:" }, { unicode: "1f642", shortname: ":slight_smile:" }, { unicode: "1f643", shortname: ":upside_down:" }, { unicode: "263a", shortname: ":relaxed:" }, { unicode: "1f60b", shortname: ":yum:" }, { unicode: "1f60c", shortname: ":relieved:" }, { unicode: "1f60d", shortname: ":heart_eyes:" }, { unicode: "1f618", shortname: ":kissing_heart:" }, { unicode: "1f617", shortname: ":kissing:" }, { unicode: "1f619", shortname: ":kissing_smiling_eyes:" }, { unicode: "1f61a", shortname: ":kissing_closed_eyes:" }, { unicode: "1f61c", shortname: ":stuck_out_tongue_winking_eye:" }, { unicode: "1f61d", shortname: ":stuck_out_tongue_closed_eyes:" }, { unicode: "1f61b", shortname: ":stuck_out_tongue:" }, { unicode: "1f911", shortname: ":money_mouth:" }, { unicode: "1f913", shortname: ":nerd:" }, { unicode: "1f60e", shortname: ":sunglasses:" }, { unicode: "1f917", shortname: ":hugging:" }, { unicode: "1f60f", shortname: ":smirk:" }, { unicode: "1f636", shortname: ":no_mouth:" }, { unicode: "1f610", shortname: ":neutral_face:" }, { unicode: "1f611", shortname: ":expressionless:" }, { unicode: "1f612", shortname: ":unamused:" }, { unicode: "1f644", shortname: ":rolling_eyes:" }, { unicode: "1f914", shortname: ":thinking:" }, { unicode: "1f633", shortname: ":flushed:" }, { unicode: "1f61e", shortname: ":disappointed:" }, { unicode: "1f61f", shortname: ":worried:" }, { unicode: "1f620", shortname: ":angry:" }, { unicode: "1f621", shortname: ":rage:" }, { unicode: "1f614", shortname: ":pensive:" }, { unicode: "1f615", shortname: ":confused:" }, { unicode: "1f641", shortname: ":slight_frown:" }, { unicode: "2639", shortname: ":frowning2:" }, { unicode: "1f623", shortname: ":persevere:" }, { unicode: "1f616", shortname: ":confounded:" }, { unicode: "1f62b", shortname: ":tired_face:" }, { unicode: "1f629", shortname: ":weary:" }, { unicode: "1f624", shortname: ":triumph:" }, { unicode: "1f62e", shortname: ":open_mouth:" }, { unicode: "1f631", shortname: ":scream:" }, { unicode: "1f628", shortname: ":fearful:" }, { unicode: "1f630", shortname: ":cold_sweat:" }, { unicode: "1f62f", shortname: ":hushed:" }, { unicode: "1f626", shortname: ":frowning:" }, { unicode: "1f627", shortname: ":anguished:" }, { unicode: "1f622", shortname: ":cry:" }, { unicode: "1f625", shortname: ":disappointed_relieved:" }, { unicode: "1f62a", shortname: ":sleepy:" }, { unicode: "1f613", shortname: ":sweat:" }, { unicode: "1f62d", shortname: ":sob:" }, { unicode: "1f635", shortname: ":dizzy_face:" }, { unicode: "1f632", shortname: ":astonished:" }, { unicode: "1f910", shortname: ":zipper_mouth:" }, { unicode: "1f637", shortname: ":mask:" }, { unicode: "1f912", shortname: ":thermometer_face:" }, { unicode: "1f915", shortname: ":head_bandage:" }, { unicode: "1f634", shortname: ":sleeping:" }, { unicode: "1f4a4", shortname: ":zzz:" }, { unicode: "1f480", shortname: ":skull:" }, { unicode: "1f47b", shortname: ":ghost:" }, { unicode: "1f47d", shortname: ":alien:" }, { unicode: "1f916", shortname: ":robot:" }, { unicode: "1f63a", shortname: ":smiley_cat:" }, { unicode: "1f638", shortname: ":smile_cat:" }, { unicode: "1f639", shortname: ":joy_cat:" }, { unicode: "1f63b", shortname: ":heart_eyes_cat:" }, { unicode: "1f63c", shortname: ":smirk_cat:" }, { unicode: "1f63d", shortname: ":kissing_cat:" }, { unicode: "1f640", shortname: ":scream_cat:" }, { unicode: "1f63f", shortname: ":crying_cat_face:" }, { unicode: "1f63e", shortname: ":pouting_cat:" }, { unicode: "1f64c", shortname: ":raised_hands:" }, { unicode: "1f44f", shortname: ":clap:" }, { unicode: "1f44b", shortname: ":wave:" }, { unicode: "1f44d", shortname: ":thumbsup:" }, { unicode: "1f44e", shortname: ":thumbsdown:" }, { unicode: "1f44a", shortname: ":punch:" }, { unicode: "270a", shortname: ":fist:" }, { unicode: "270c", shortname: ":v:" }, { unicode: "1f44c", shortname: ":ok_hand:" }, { unicode: "270b", shortname: ":raised_hand:" }, { unicode: "1f450", shortname: ":open_hands:" }, { unicode: "1f4aa", shortname: ":muscle:" }, { unicode: "1f64f", shortname: ":pray:" }, { unicode: "261d", shortname: ":point_up:" }, { unicode: "1f446", shortname: ":point_up_2:" }, { unicode: "1f447", shortname: ":point_down:" }, { unicode: "1f448", shortname: ":point_left:" }, { unicode: "1f449", shortname: ":point_right:" }, { unicode: "1f45a", shortname: ":womans_clothes:" }, { unicode: "1f455", shortname: ":shirt:" }, { unicode: "1f456", shortname: ":jeans:" }, { unicode: "1f454", shortname: ":necktie:" }, { unicode: "1f457", shortname: ":dress:" }, { unicode: "1f436", shortname: ":dog:" }, { unicode: "1f431", shortname: ":cat:" }, { unicode: "1f42d", shortname: ":mouse:" }, { unicode: "1f439", shortname: ":hamster:" }, { unicode: "1f430", shortname: ":rabbit:" }, { unicode: "1f43b", shortname: ":bear:" }, { unicode: "1f43c", shortname: ":panda_face:" }, { unicode: "1f428", shortname: ":koala:" }, { unicode: "1f42f", shortname: ":tiger:" }, { unicode: "1f981", shortname: ":lion_face:" }, { unicode: "1f42e", shortname: ":cow:" }, { unicode: "1f437", shortname: ":pig:" }, { unicode: "1f43d", shortname: ":pig_nose:" }, { unicode: "1f438", shortname: ":frog:" }, { unicode: "1f419", shortname: ":octopus:" }, { unicode: "1f435", shortname: ":monkey_face:" }, { unicode: "1f648", shortname: ":see_no_evil:" }, { unicode: "1f649", shortname: ":hear_no_evil:" }, { unicode: "1f64a", shortname: ":speak_no_evil:" }, { unicode: "1f412", shortname: ":monkey:" }, { unicode: "1f414", shortname: ":chicken:" }, { unicode: "1f427", shortname: ":penguin:" }, { unicode: "1f426", shortname: ":bird:" }, { unicode: "1f424", shortname: ":baby_chick:" }, { unicode: "1f423", shortname: ":hatching_chick:" }, { unicode: "1f425", shortname: ":hatched_chick:" }, { unicode: "1f43a", shortname: ":wolf:" }, { unicode: "1f417", shortname: ":boar:" }, { unicode: "1f434", shortname: ":horse:" }, { unicode: "1f984", shortname: ":unicorn:" }, { unicode: "1f41d", shortname: ":bee:" }, { unicode: "1f41b", shortname: ":bug:" }, { unicode: "1f40c", shortname: ":snail:" }, { unicode: "1f41e", shortname: ":beetle:" }, { unicode: "1f41c", shortname: ":ant:" }, { unicode: "1f577", shortname: ":spider:" }, { unicode: "1f982", shortname: ":scorpion:" }, { unicode: "1f980", shortname: ":crab:" }, { unicode: "1f40d", shortname: ":snake:" }, { unicode: "1f422", shortname: ":turtle:" }, { unicode: "1f420", shortname: ":tropical_fish:" }, { unicode: "1f41f", shortname: ":fish:" }, { unicode: "1f421", shortname: ":blowfish:" }, { unicode: "1f42c", shortname: ":dolphin:" }, { unicode: "1f433", shortname: ":whale:" }, { unicode: "1f40b", shortname: ":whale2:" }, { unicode: "1f40a", shortname: ":crocodile:" }, { unicode: "1f406", shortname: ":leopard:" }, { unicode: "1f405", shortname: ":tiger2:" }, { unicode: "1f403", shortname: ":water_buffalo:" }, { unicode: "1f402", shortname: ":ox:" }, { unicode: "1f404", shortname: ":cow2:" }, { unicode: "1f42a", shortname: ":dromedary_camel:" }, { unicode: "1f42b", shortname: ":camel:" }, { unicode: "1f418", shortname: ":elephant:" }, { unicode: "1f410", shortname: ":goat:" }, { unicode: "1f40f", shortname: ":ram:" }, { unicode: "1f411", shortname: ":sheep:" }, { unicode: "1f40e", shortname: ":racehorse:" }, { unicode: "1f416", shortname: ":pig2:" }, { unicode: "1f400", shortname: ":rat:" }, { unicode: "1f401", shortname: ":mouse2:" }, { unicode: "1f413", shortname: ":rooster:" }, { unicode: "1f983", shortname: ":turkey:" }, { unicode: "1f54a", shortname: ":dove:" }, { unicode: "1f415", shortname: ":dog2:" }, { unicode: "1f429", shortname: ":poodle:" }, { unicode: "1f408", shortname: ":cat2:" }, { unicode: "1f407", shortname: ":rabbit2:" }, { unicode: "1f43f", shortname: ":chipmunk:" }, { unicode: "1f43e", shortname: ":feet:" }, { unicode: "1f31e", shortname: ":sun_with_face:" }, { unicode: "1f319", shortname: ":crescent_moon:" }, { unicode: "2b50", shortname: ":star:" }, { unicode: "1f31f", shortname: ":star2:" }, { unicode: "1f4ab", shortname: ":dizzy:" }, { unicode: "2728", shortname: ":sparkles:" }, { unicode: "2604", shortname: ":comet:" }, { unicode: "2600", shortname: ":sunny:" }, { unicode: "1f324", shortname: ":white_sun_small_cloud:" }, { unicode: "26c5", shortname: ":partly_sunny:" }, { unicode: "1f325", shortname: ":white_sun_cloud:" }, { unicode: "1f326", shortname: ":white_sun_rain_cloud:" }, { unicode: "2601", shortname: ":cloud:" }, { unicode: "1f327", shortname: ":cloud_rain:" }, { unicode: "26c8", shortname: ":thunder_cloud_rain:" }, { unicode: "1f329", shortname: ":cloud_lightning:" }, { unicode: "26a1", shortname: ":zap:" }, { unicode: "1f525", shortname: ":fire:" }, { unicode: "1f4a5", shortname: ":boom:" }, { unicode: "2744", shortname: ":snowflake:" }, { unicode: "1f328", shortname: ":cloud_snow:" }, { unicode: "2603", shortname: ":snowman2:" }, { unicode: "26c4", shortname: ":snowman:" }, { unicode: "1f32c", shortname: ":wind_blowing_face:" }, { unicode: "1f4a8", shortname: ":dash:" }, { unicode: "1f32a", shortname: ":cloud_tornado:" }, { unicode: "1f32b", shortname: ":fog:" }, { unicode: "2602", shortname: ":umbrella2:" }, { unicode: "2614", shortname: ":umbrella:" }, { unicode: "1f4a7", shortname: ":droplet:" }, { unicode: "1f4a6", shortname: ":sweat_drops:" }, { unicode: "1f30a", shortname: ":ocean:" }, { unicode: "1f34f", shortname: ":green_apple:" }, { unicode: "1f34e", shortname: ":apple:" }, { unicode: "1f350", shortname: ":pear:" }, { unicode: "1f34a", shortname: ":tangerine:" }, { unicode: "1f34b", shortname: ":lemon:" }, { unicode: "1f34c", shortname: ":banana:" }, { unicode: "1f349", shortname: ":watermelon:" }, { unicode: "1f347", shortname: ":grapes:" }, { unicode: "1f353", shortname: ":strawberry:" }, { unicode: "1f348", shortname: ":melon:" }, { unicode: "1f352", shortname: ":cherries:" }, { unicode: "1f351", shortname: ":peach:" }, { unicode: "1f34d", shortname: ":pineapple:" }, { unicode: "1f345", shortname: ":tomato:" }, { unicode: "1f346", shortname: ":eggplant:" }, { unicode: "1f336", shortname: ":hot_pepper:" }, { unicode: "1f33d", shortname: ":corn:" }, { unicode: "1f360", shortname: ":sweet_potato:" }, { unicode: "1f36f", shortname: ":honey_pot:" }, { unicode: "1f35e", shortname: ":bread:" }, { unicode: "1f9c0", shortname: ":cheese:" }, { unicode: "1f357", shortname: ":poultry_leg:" }, { unicode: "1f356", shortname: ":meat_on_bone:" }, { unicode: "1f364", shortname: ":fried_shrimp:" }, { unicode: "1f354", shortname: ":hamburger:" }, { unicode: "1f35f", shortname: ":fries:" }, { unicode: "1f32d", shortname: ":hotdog:" }, { unicode: "1f355", shortname: ":pizza:" }, { unicode: "1f35d", shortname: ":spaghetti:" }, { unicode: "1f32e", shortname: ":taco:" }, { unicode: "1f32f", shortname: ":burrito:" }, { unicode: "1f35c", shortname: ":ramen:" }, { unicode: "1f372", shortname: ":stew:" }, { unicode: "1f365", shortname: ":fish_cake:" }, { unicode: "1f363", shortname: ":sushi:" }, { unicode: "1f371", shortname: ":bento:" }, { unicode: "1f35b", shortname: ":curry:" }, { unicode: "1f359", shortname: ":rice_ball:" }, { unicode: "1f35a", shortname: ":rice:" }, { unicode: "1f358", shortname: ":rice_cracker:" }, { unicode: "1f362", shortname: ":oden:" }, { unicode: "1f361", shortname: ":dango:" }, { unicode: "1f367", shortname: ":shaved_ice:" }, { unicode: "1f368", shortname: ":ice_cream:" }, { unicode: "1f366", shortname: ":icecream:" }, { unicode: "1f370", shortname: ":cake:" }, { unicode: "1f382", shortname: ":birthday:" }, { unicode: "1f36e", shortname: ":custard:" }, { unicode: "1f36c", shortname: ":candy:" }, { unicode: "1f36d", shortname: ":lollipop:" }, { unicode: "1f36b", shortname: ":chocolate_bar:" }, { unicode: "1f37f", shortname: ":popcorn:" }, { unicode: "1f369", shortname: ":doughnut:" }, { unicode: "1f36a", shortname: ":cookie:" }, { unicode: "1f37a", shortname: ":beer:" }, { unicode: "1f37b", shortname: ":beers:" }, { unicode: "1f377", shortname: ":wine_glass:" }, { unicode: "1f378", shortname: ":cocktail:" }, { unicode: "1f379", shortname: ":tropical_drink:" }, { unicode: "1f37e", shortname: ":champagne:" }, { unicode: "1f376", shortname: ":sake:" }, { unicode: "1f375", shortname: ":tea:" }, { unicode: "2615", shortname: ":coffee:" }, { unicode: "1f37c", shortname: ":baby_bottle:" }, { unicode: "1f374", shortname: ":fork_and_knife:" }, { unicode: "1f37d", shortname: ":fork_knife_plate:" }, { unicode: "1f697", shortname: ":red_car:" }, { unicode: "1f695", shortname: ":taxi:" }, { unicode: "1f699", shortname: ":blue_car:" }, { unicode: "1f68c", shortname: ":bus:" }, { unicode: "1f68e", shortname: ":trolleybus:" }, { unicode: "1f3ce", shortname: ":race_car:" }, { unicode: "1f693", shortname: ":police_car:" }, { unicode: "1f691", shortname: ":ambulance:" }, { unicode: "1f692", shortname: ":fire_engine:" }, { unicode: "1f690", shortname: ":minibus:" }, { unicode: "1f69a", shortname: ":truck:" }, { unicode: "1f69b", shortname: ":articulated_lorry:" }, { unicode: "1f69c", shortname: ":tractor:" }, { unicode: "1f3cd", shortname: ":motorcycle:" }, { unicode: "1f6b2", shortname: ":bike:" }, { unicode: "1f6a8", shortname: ":rotating_light:" }, { unicode: "1f694", shortname: ":oncoming_police_car:" }, { unicode: "1f68d", shortname: ":oncoming_bus:" }, { unicode: "1f698", shortname: ":oncoming_automobile:" }, { unicode: "1f696", shortname: ":oncoming_taxi:" }, { unicode: "1f6a1", shortname: ":aerial_tramway:" }, { unicode: "1f6a0", shortname: ":mountain_cableway:" }, { unicode: "1f69f", shortname: ":suspension_railway:" }, { unicode: "1f683", shortname: ":railway_car:" }, { unicode: "1f68b", shortname: ":train:" }, { unicode: "1f69d", shortname: ":monorail:" }, { unicode: "1f684", shortname: ":bullettrain_side:" }, { unicode: "1f685", shortname: ":bullettrain_front:" }, { unicode: "1f688", shortname: ":light_rail:" }, { unicode: "1f69e", shortname: ":mountain_railway:" }, { unicode: "1f682", shortname: ":steam_locomotive:" }, { unicode: "1f686", shortname: ":train2:" }, { unicode: "1f687", shortname: ":metro:" }, { unicode: "1f68a", shortname: ":tram:" }, { unicode: "1f689", shortname: ":station:" }, { unicode: "1f681", shortname: ":helicopter:" }, { unicode: "1f6e9", shortname: ":airplane_small:" }, { unicode: "2708", shortname: ":airplane:" }, { unicode: "1f6eb", shortname: ":airplane_departure:" }, { unicode: "1f6ec", shortname: ":airplane_arriving:" }, { unicode: "26f5", shortname: ":sailboat:" }, { unicode: "1f6e5", shortname: ":motorboat:" }, { unicode: "1f6a4", shortname: ":speedboat:" }, { unicode: "26f4", shortname: ":ferry:" }, { unicode: "1f6f3", shortname: ":cruise_ship:" }];

exports.default = emojiPaletteChars;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _stampPalette = __webpack_require__(2014);

var _stampPalette2 = _interopRequireDefault(_stampPalette);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactI18next = __webpack_require__(2);

var _propTypes = __webpack_require__(4);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _dialog = __webpack_require__(47);

var _layout = __webpack_require__(85);

var _button = __webpack_require__(8);

var _tabs = __webpack_require__(188);

var _scrollableDialogPanel = __webpack_require__(163);

var _scrollableDialogPanel2 = _interopRequireDefault(_scrollableDialogPanel);

var _stamps = __webpack_require__(2018);

var _stamps2 = _interopRequireDefault(_stamps);

__webpack_require__(2161);

var _actionDialog = __webpack_require__(224);

var _actionDialog2 = _interopRequireDefault(_actionDialog);

var _userAgent = __webpack_require__(491);

var _userAgent2 = _interopRequireDefault(_userAgent);

var _stampPalette3 = __webpack_require__(2163);

var _stampPalette4 = _interopRequireDefault(_stampPalette3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/stamp-palette.jsx

var GAMBA_KEY = 'gamba';
var HANKO_KEY = 'hanko';
var ANIMAL_KEY = 'animal';

var GAMBA_STAMP = _lodash2.default.filter(_stamps2.default, function (stamp) {
  return stamp.category == GAMBA_KEY;
});
var HANKO_STAMP = _lodash2.default.filter(_stamps2.default, function (stamp) {
  return stamp.category == HANKO_KEY;
});
var ANIMAL_STAMP = _lodash2.default.filter(_stamps2.default, function (stamp) {
  return stamp.category == ANIMAL_KEY;
});

var Stamp = function (_React$Component) {
  _inherits(Stamp, _React$Component);

  function Stamp() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Stamp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Stamp.__proto__ || Object.getPrototypeOf(Stamp)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (event) {
      if (typeof _this.props.ui.code == 'undefined') {
        _this.props.onSelect(event.currentTarget.attributes['data-code'].value, _this.props);
      } else {
        if (_this.props.ui.code == event.currentTarget.attributes['data-code'].value) {
          _this.props.onSend(_this.props);
        } else {
          _this.props.ui.code != event.currentTarget.attributes['data-code'].value && _this.props.onSelect(event.currentTarget.attributes['data-code'].value, _this.props);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Stamp, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onSend = _props.onSend,
          onSelect = _props.onSelect,
          stampPalette = _props.stampPalette,
          ui = _props.ui;

      return _react2.default.createElement(
        _scrollableDialogPanel2.default,
        { extraHeight: 52 },
        _lodash2.default.map(stampPalette, function (stamp) {
          return _react2.default.createElement(
            'div',
            { key: stamp.code, className: ui.code && stamp.code == ui.code && _stampPalette4.default.selected || _stampPalette4.default.nomal },
            _react2.default.createElement('span', { key: stamp.code,
              'data-code': stamp.code,
              onClick: _this2.props.ui.active && _this2.onSelect,
              style: { cursor: 'pointer', opacity: ui.code && stamp.code != ui.code && 0.3 || undefined },
              className: (0, _classnames2.default)('stamp', stamp.code) })
          );
        })
      );
    }
  }]);

  return Stamp;
}(_react2.default.Component);

var StampPaletteProvider = function (_React$Component2) {
  _inherits(StampPaletteProvider, _React$Component2);

  function StampPaletteProvider() {
    var _ref2;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, StampPaletteProvider);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = StampPaletteProvider.__proto__ || Object.getPrototypeOf(StampPaletteProvider)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = {}, _this3.changeTab = function (tabIndex) {
      _this3.props.changeStampTab();
      _this3.props.updateUI({ tabIndex: tabIndex });
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(StampPaletteProvider, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          t = _props2.t,
          ui = _props2.ui,
          children = _props2.children,
          updateUI = _props2.updateUI,
          onClose = _props2.onClose,
          onSelect = _props2.onSelect,
          onSend = _props2.onSend,
          changeStampTab = _props2.changeStampTab,
          showStampPalette = _props2.showStampPalette;


      var actions = [{ label: t('label:送信'), onClick: function onClick() {
          return onSend(_this4.props);
        }, disabled: ui.requiredConfirm && ui.code ? false : true, raised: true, primary: true }, { label: t('label:取り消し'), onClick: function onClick() {
          return onClose(_this4.props);
        }, raised: true }];

      return _react2.default.createElement(
        'div',
        { className: (0, _userAgent2.default)() == 'ie' ? 'no-svg' : 'svg' },
        _react2.default.createElement(
          _dialog.Dialog,
          { active: ui.active, theme: _actionDialog2.default,
            className: (0, _userAgent2.default)() == 'ie' ? 'no-svg' : 'svg',
            actions: ui.requiredConfirm && actions || [actions[1]],
            onOverlayClick: function onOverlayClick() {
              return onClose(_this4.props);
            },
            onEscKeyDown: function onEscKeyDown() {
              return onClose(_this4.props);
            } },
          _react2.default.createElement(
            _tabs.Tabs,
            { fixed: true, index: ui.tabIndex, onChange: this.changeTab },
            _react2.default.createElement(
              _tabs.Tab,
              { ripple: false, className: (0, _classnames2.default)(_stampPalette4.default.gambaIcon, _stampPalette4.default.label), activeClassName: (0, _classnames2.default)(_stampPalette4.default.activeGambaIcon, _stampPalette4.default.label) },
              _react2.default.createElement(Stamp, { ui: this.props.ui, stampPalette: GAMBA_STAMP, onSelect: onSelect, onSend: onSend })
            ),
            _react2.default.createElement(
              _tabs.Tab,
              { ripple: false, className: (0, _classnames2.default)(_stampPalette4.default.hankoIcon, _stampPalette4.default.label), activeClassName: (0, _classnames2.default)(_stampPalette4.default.activeHankoIcon, _stampPalette4.default.label) },
              _react2.default.createElement(Stamp, { ui: this.props.ui, stampPalette: HANKO_STAMP, onSelect: onSelect, onSend: onSend })
            ),
            _react2.default.createElement(
              _tabs.Tab,
              { ripple: false, className: (0, _classnames2.default)(_stampPalette4.default.animalIcon, _stampPalette4.default.label), activeClassName: (0, _classnames2.default)(_stampPalette4.default.activeAnimalIcon, _stampPalette4.default.label) },
              _react2.default.createElement(Stamp, { ui: this.props.ui, stampPalette: ANIMAL_STAMP, onSelect: onSelect, onSend: onSend })
            )
          )
        ),
        children
      );
    }
  }]);

  return StampPaletteProvider;
}(_react2.default.Component);

exports.default = (0, _stampPalette2.default)(StampPaletteProvider);

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _context = __webpack_require__(39);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onClose: function onClose(props) {
      props.ui && props.ui.callback && props.ui.callback(undefined);
      ownProps.updateUI({ active: false, requiredConfirm: false, code: undefined, callback: undefined });
    },

    onSelect: function onSelect(code, props) {
      ownProps.updateUI({ active: props.ui.requiredConfirm, code: props.ui.requiredConfirm && code || undefined });
      props.ui.callback && !props.ui.requiredConfirm && props.ui.callback(code) || undefined;
    },
    changeStampTab: function changeStampTab() {
      ownProps.updateUI({ code: undefined });
    },

    onSend: function onSend(props) {
      props.ui.callback && props.ui.code && props.ui.callback(props.ui.code);
      ownProps.updateUI({ active: false, requiredConfirm: false, code: undefined, callback: undefined });
    },

    showStampPalette: function showStampPalette(callback, requiredConfirm) {
      ownProps.updateUI({ active: true, requiredConfirm: requiredConfirm, callback: callback });
    }
  };
};
// src/connects/stamp-palette.js

exports.default = (0, _combineHoc2.default)((0, _uiState2.default)({ state: {
    active: false,
    requiredConfirm: false,
    code: undefined,
    callback: undefined,
    tabIndex: function tabIndex(props) {
      return props.params && props.params.tabIndex || 0;
    }
  } }), (0, _reactRedux.connect)(undefined, mapDispatchToProps), (0, _reactI18next.translate)(), _lifecycle2.default, (0, _context.inject)({ showStampPalette: _propTypes2.default.func }));

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = exports.tabsFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = __webpack_require__(14);

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _FontIcon = __webpack_require__(81);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _isComponentOfType = __webpack_require__(265);

var _isComponentOfType2 = _interopRequireDefault(_isComponentOfType);

var _Tab = __webpack_require__(932);

var _Tab2 = _interopRequireDefault(_Tab);

var _TabContent = __webpack_require__(933);

var _TabContent2 = _interopRequireDefault(_TabContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(Tab, TabContent, FontIcon) {
  var isTab = function isTab(child) {
    return (0, _isComponentOfType2.default)(Tab, child);
  };
  var isTabContent = function isTabContent(child) {
    return (0, _isComponentOfType2.default)(TabContent, child);
  };

  var Tabs = function (_Component) {
    _inherits(Tabs, _Component);

    function Tabs() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Tabs);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        pointer: {},
        arrows: {}
      }, _this.handleHeaderClick = function (idx) {
        if (_this.props.onChange) {
          _this.props.onChange(idx);
        }
      }, _this.handleResize = function () {
        if (_this.resizeTimeout) clearTimeout(_this.resizeTimeout);
        _this.resizeTimeout = setTimeout(function () {
          _this.updatePointer(_this.props.index);
          _this.updateArrows();
        }, 100);
      }, _this.updatePointer = function (idx) {
        if (_this.navigationNode && _this.navigationNode.children[idx]) {
          requestAnimationFrame(function () {
            var nav = _this.navigationNode.getBoundingClientRect();
            var label = _this.navigationNode.children[idx].getBoundingClientRect();
            var scrollLeft = _this.navigationNode.scrollLeft;
            _this.setState({
              pointer: {
                top: nav.height + 'px',
                left: label.left + scrollLeft - nav.left + 'px',
                width: label.width + 'px'
              }
            });
          });
        }
      }, _this.updateArrows = function () {
        var idx = _this.navigationNode.children.length - 2;

        if (idx >= 0) {
          var scrollLeft = _this.navigationNode.scrollLeft;
          var nav = _this.navigationNode.getBoundingClientRect();
          var lastLabel = _this.navigationNode.children[idx].getBoundingClientRect();

          _this.setState({
            arrows: {
              left: scrollLeft > 0,
              right: nav.right < lastLabel.right - 5
            }
          });
        }
      }, _this.scrollNavigation = function (factor) {
        var oldScrollLeft = _this.navigationNode.scrollLeft;
        _this.navigationNode.scrollLeft += factor * _this.navigationNode.clientWidth;
        if (_this.navigationNode.scrollLeft !== oldScrollLeft) {
          _this.updateArrows();
        }
      }, _this.scrollRight = function () {
        return _this.scrollNavigation(-1);
      }, _this.scrollLeft = function () {
        return _this.scrollNavigation(+1);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Tabs, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _props = this.props,
            index = _props.index,
            children = _props.children;
        var prevIndex = prevProps.index,
            prevChildren = prevProps.children;


        if (index !== prevIndex || children !== prevChildren) {
          this.updatePointer(index);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        clearTimeout(this.resizeTimeout);
      }
    }, {
      key: 'parseChildren',
      value: function parseChildren() {
        var _this2 = this;

        var headers = [];
        var contents = [];

        _react2.default.Children.forEach(this.props.children, function (item) {
          if (isTab(item)) {
            headers.push(item);
            if (item.props.children) {
              contents.push(_react2.default.createElement(
                TabContent,
                { theme: _this2.props.theme },
                item.props.children
              ));
            }
          } else if (isTabContent(item)) {
            contents.push(item);
          }
        });

        return { headers: headers, contents: contents };
      }
    }, {
      key: 'renderHeaders',
      value: function renderHeaders(headers) {
        var _this3 = this;

        return headers.map(function (item, idx) {
          return _react2.default.cloneElement(item, {
            children: null,
            key: idx, // eslint-disable-line
            index: idx,
            theme: _this3.props.theme,
            active: _this3.props.index === idx,
            onClick: function onClick(event, index) {
              _this3.handleHeaderClick(index);
              if (item.props.onClick) item.props.onClick(event);
            }
          });
        });
      }
    }, {
      key: 'renderContents',
      value: function renderContents(contents) {
        var _this4 = this;

        var contentElements = contents.map(function (item, idx) {
          return _react2.default.cloneElement(item, {
            key: idx, // eslint-disable-line
            theme: _this4.props.theme,
            active: _this4.props.index === idx,
            hidden: _this4.props.index !== idx && _this4.props.hideMode === 'display',
            tabIndex: idx
          });
        });

        return this.props.hideMode === 'display' ? contentElements : contentElements.filter(function (item, idx) {
          return idx === _this4.props.index;
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _classnames2,
            _this5 = this;

        var _props2 = this.props,
            className = _props2.className,
            disableAnimatedBottomBorder = _props2.disableAnimatedBottomBorder,
            theme = _props2.theme,
            fixed = _props2.fixed,
            inverse = _props2.inverse;
        var _state$arrows = this.state.arrows,
            hasLeftArrow = _state$arrows.left,
            hasRightArrow = _state$arrows.right;

        var _parseChildren = this.parseChildren(),
            headers = _parseChildren.headers,
            contents = _parseChildren.contents;

        var classNamePointer = (0, _classnames4.default)(theme.pointer, _defineProperty({}, theme.disableAnimation, disableAnimatedBottomBorder));

        var classNames = (0, _classnames4.default)(theme.tabs, (_classnames2 = {}, _defineProperty(_classnames2, theme.fixed, fixed), _defineProperty(_classnames2, theme.inverse, inverse), _classnames2), className);

        return _react2.default.createElement(
          'div',
          { 'data-react-toolbox': 'tabs', className: classNames },
          _react2.default.createElement(
            'div',
            { className: theme.navigationContainer },
            hasLeftArrow && _react2.default.createElement(
              'div',
              { className: theme.arrowContainer, onClick: this.scrollRight },
              _react2.default.createElement(FontIcon, { className: theme.arrow, value: 'keyboard_arrow_left' })
            ),
            _react2.default.createElement(
              'nav',
              {
                className: theme.navigation,
                ref: function ref(node) {
                  _this5.navigationNode = node;
                }
              },
              this.renderHeaders(headers),
              _react2.default.createElement('span', { className: classNamePointer, style: this.state.pointer })
            ),
            hasRightArrow && _react2.default.createElement(
              'div',
              { className: theme.arrowContainer, onClick: this.scrollLeft },
              _react2.default.createElement(FontIcon, {
                className: theme.arrow,
                value: 'keyboard_arrow_right'
              })
            )
          ),
          this.renderContents(contents)
        );
      }
    }]);

    return Tabs;
  }(_react.Component);

  Tabs.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disableAnimatedBottomBorder: _propTypes2.default.bool,
    fixed: _propTypes2.default.bool,
    hideMode: _propTypes2.default.oneOf(['display', 'unmounted']),
    index: _propTypes2.default.number,
    inverse: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
      arrow: _propTypes2.default.string,
      arrowContainer: _propTypes2.default.string,
      disableAnimation: _propTypes2.default.string,
      fixed: _propTypes2.default.string,
      inverse: _propTypes2.default.string,
      navigation: _propTypes2.default.string,
      navigationContainer: _propTypes2.default.string,
      pointer: _propTypes2.default.string,
      tabs: _propTypes2.default.string
    })
  };
  Tabs.defaultProps = {
    index: 0,
    fixed: false,
    inverse: false,
    hideMode: 'unmounted'
  };


  return Tabs;
};

var Tabs = factory(_Tab2.default, _TabContent2.default, _FontIcon2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.TABS)(Tabs);
exports.tabsFactory = factory;
exports.Tabs = Tabs;

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2017);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--tabs--v39TF7Yj {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.theme--tabs--v39TF7Yj *,\n    .theme--tabs--v39TF7Yj *::after,\n    .theme--tabs--v39TF7Yj *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--navigation--2s1O2VoH {\n  box-shadow: inset 0 -1px rgb(238, 238, 238);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  overflow-x: hidden;\n  position: relative;\n}\n.theme--navigationContainer--VuPTrWEJ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex\n}\n.theme--navigationContainer--VuPTrWEJ .theme--navigation--2s1O2VoH {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.theme--arrow--3ailXW_l {\n  color: rgb(0, 0, 0);\n  padding: 0 12px;\n}\n.theme--arrowContainer--1GZfrFuV {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  box-shadow: inset 0 -1px rgb(238, 238, 238);\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.theme--label--3t5-537h {\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n  padding: 17px 12px;\n  position: relative;\n  text-transform: uppercase;\n  transition-duration: 0.35s;\n  transition-property: box-shadow, color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)\n}\n.theme--label--3t5-537h > .theme--rippleWrapper--14tkaBzu {\n  overflow: hidden;\n}\n.theme--label--3t5-537h.theme--active--3R728Vbk {\n  color: rgb(0, 0, 0);\n}\n.theme--label--3t5-537h.theme--disabled--2XQGnlfd {\n  opacity: 0.2;\n}\n.theme--label--3t5-537h:not(.theme--disabled--2XQGnlfd) {\n  cursor: pointer;\n}\n.theme--label--3t5-537h.theme--hidden--1GKZKEfC {\n  display: none;\n}\n.theme--label--3t5-537h.theme--withIcon--3FXqYuZf {\n  padding-bottom: 13px;\n  padding-top: 13px;\n  text-align: center;\n}\n.theme--label--3t5-537h.theme--withText--3x1D7hta .theme--icon--10_BNMlS {\n  margin-bottom: 8px;\n}\n.theme--icon--10_BNMlS {\n  display: block;\n  height: 24px;\n  line-height: 24px;\n  margin: 0 auto;\n}\n.theme--pointer--2hcVkzcO {\n  background-color: rgb(63, 81, 181);\n  height: 2px;\n  margin-top: -2px;\n  position: absolute;\n  transition-duration: 0.35s;\n  transition-property: left, width;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: 0;\n}\n.theme--tab--QL3pzc4x {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 17px 12px\n}\n.theme--tab--QL3pzc4x:not(.theme--active--3R728Vbk) {\n  display: none;\n}\n.theme--tab--QL3pzc4x.theme--active--3R728Vbk {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.theme--fixed--36vhmcZT .theme--label--3t5-537h {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  text-align: center;\n}\n.theme--inverse--3NxAYaNf .theme--navigation--2s1O2VoH,\n  .theme--inverse--3NxAYaNf .theme--arrowContainer--1GZfrFuV {\n  background-color: rgb(63, 81, 181);\n}\n.theme--inverse--3NxAYaNf .theme--label--3t5-537h {\n  color: rgba(255, 255, 255, 0.3);\n}\n.theme--inverse--3NxAYaNf .theme--label--3t5-537h.theme--active--3R728Vbk {\n  color: rgb(255, 255, 255);\n}\n.theme--inverse--3NxAYaNf .theme--arrow--3ailXW_l {\n  color: rgb(255, 255, 255);\n}\n.theme--inverse--3NxAYaNf .theme--pointer--2hcVkzcO {\n  background-color: rgb(255, 64, 129);\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/tabs/theme.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;CAChC;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,4CAA4C;EAC5C,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;CACd;AACD;EACE,oBAAoB;MAChB,YAAY;UACR,QAAQ;CACjB;AACD;EACE,oBAAoB;EACpB,gBAAgB;CACjB;AACD;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,4CAA4C;EAC5C,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,wDAAwD;CACzD;AACD;EACE,iBAAiB;CAClB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,aAAa;CACd;AACD;EACE,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,eAAe;CAChB;AACD;EACE,mCAAmC;EACnC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,iCAAiC;EACjC,yDAAyD;EACzD,SAAS;CACV;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,kBAAkB;CACnB;AACD;EACE,cAAc;CACf;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;EACE,oBAAoB;MAChB,YAAY;UACR,QAAQ;EAChB,mBAAmB;CACpB;AACD;;EAEE,mCAAmC;CACpC;AACD;EACE,gCAAgC;CACjC;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,oCAAoC;CACrC","file":"theme.css","sourcesContent":[".tabs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.tabs *,\n    .tabs *::after,\n    .tabs *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.navigation {\n  box-shadow: inset 0 -1px rgb(238, 238, 238);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  overflow-x: hidden;\n  position: relative;\n}\n.navigationContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex\n}\n.navigationContainer .navigation {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.arrow {\n  color: rgb(0, 0, 0);\n  padding: 0 12px;\n}\n.arrowContainer {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  box-shadow: inset 0 -1px rgb(238, 238, 238);\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.label {\n  color: rgba(0, 0, 0, 0.7);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n  padding: 17px 12px;\n  position: relative;\n  text-transform: uppercase;\n  transition-duration: 0.35s;\n  transition-property: box-shadow, color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)\n}\n.label > .rippleWrapper {\n  overflow: hidden;\n}\n.label.active {\n  color: rgb(0, 0, 0);\n}\n.label.disabled {\n  opacity: 0.2;\n}\n.label:not(.disabled) {\n  cursor: pointer;\n}\n.label.hidden {\n  display: none;\n}\n.label.withIcon {\n  padding-bottom: 13px;\n  padding-top: 13px;\n  text-align: center;\n}\n.label.withText .icon {\n  margin-bottom: 8px;\n}\n.icon {\n  display: block;\n  height: 24px;\n  line-height: 24px;\n  margin: 0 auto;\n}\n.pointer {\n  background-color: rgb(63, 81, 181);\n  height: 2px;\n  margin-top: -2px;\n  position: absolute;\n  transition-duration: 0.35s;\n  transition-property: left, width;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: 0;\n}\n.tab {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 17px 12px\n}\n.tab:not(.active) {\n  display: none;\n}\n.tab.active {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.fixed .label {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  text-align: center;\n}\n.inverse .navigation,\n  .inverse .arrowContainer {\n  background-color: rgb(63, 81, 181);\n}\n.inverse .label {\n  color: rgba(255, 255, 255, 0.3);\n}\n.inverse .label.active {\n  color: rgb(255, 255, 255);\n}\n.inverse .arrow {\n  color: rgb(255, 255, 255);\n}\n.inverse .pointer {\n  background-color: rgb(255, 64, 129);\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"tabs": "theme--tabs--v39TF7Yj",
	"navigation": "theme--navigation--2s1O2VoH",
	"navigationContainer": "theme--navigationContainer--VuPTrWEJ",
	"arrow": "theme--arrow--3ailXW_l",
	"arrowContainer": "theme--arrowContainer--1GZfrFuV",
	"label": "theme--label--3t5-537h",
	"rippleWrapper": "theme--rippleWrapper--14tkaBzu",
	"active": "theme--active--3R728Vbk",
	"disabled": "theme--disabled--2XQGnlfd",
	"hidden": "theme--hidden--1GKZKEfC",
	"withIcon": "theme--withIcon--3FXqYuZf",
	"withText": "theme--withText--3x1D7hta",
	"icon": "theme--icon--10_BNMlS",
	"pointer": "theme--pointer--2hcVkzcO",
	"tab": "theme--tab--QL3pzc4x",
	"fixed": "theme--fixed--36vhmcZT",
	"inverse": "theme--inverse--3NxAYaNf"
};

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// src/config/stamps.js

// function require() {}

// スタンプの一覧
var stamps = [{
  category: 'animal',
  code: 'animal-dog-got-it',
  label: '承知しました',
  svg: 'animal-dog-got-it.svg',
  png: 'animal-dog-got-it.png',
  source: __webpack_require__(2019)
}, {
  category: 'animal',
  code: 'animal-dog-got-it2',
  label: '了解です',
  svg: 'animal-dog-got-it2.svg',
  png: 'animal-dog-got-it2.png',
  source: __webpack_require__(2020)
}, {
  category: 'animal',
  code: 'animal-cat-got-it',
  label: '承知いたしました',
  svg: 'animal-cat-got-it.svg',
  png: 'animal-cat-got-it.png',
  source: __webpack_require__(2021)
}, {
  category: 'animal',
  code: 'animal-cat-got-it2',
  label: '了解です',
  svg: 'animal-cat-got-it2.svg',
  png: 'animal-cat-got-it2.png',
  source: __webpack_require__(2022)
}, {
  category: 'animal',
  code: 'animal-rabbit-got-it',
  label: '承知いたしました',
  svg: 'animal-rabbit-got-it.svg',
  png: 'animal-rabbit-got-it.png',
  source: __webpack_require__(2023)
}, {
  category: 'animal',
  code: 'animal-rabbit-got-it2',
  label: '了解です',
  svg: 'animal-rabbit-got-it2.svg',
  png: 'animal-rabbit-got-it2.png',
  source: __webpack_require__(2024)
}, {
  category: 'animal',
  code: 'animal-penguin-got-it',
  label: '承知いたしました',
  svg: 'animal-penguin-got-it.svg',
  png: 'animal-penguin-got-it.png',
  source: __webpack_require__(2025)
}, {
  category: 'animal',
  code: 'animal-penguin-got-it2',
  label: '了解です',
  svg: 'animal-penguin-got-it2.svg',
  png: 'animal-penguin-got-it2.png',
  source: __webpack_require__(2026)
}, {
  category: 'animal',
  code: 'animal-kawauso-wakarimasu',
  label: 'わかります',
  svg: 'animal-kawauso-wakarimasu.svg',
  png: 'animal-kawauso-wakarimasu.png',
  source: __webpack_require__(2027)
}, {
  category: 'animal',
  code: 'animal-kawauso-yarimasita',
  label: 'やりました',
  svg: 'animal-kawauso-yarimasita.svg',
  png: 'animal-kawauso-yarimasita.png',
  source: __webpack_require__(2028)
}, {
  category: 'animal',
  code: 'animal-kawauso-hai',
  label: 'はい',
  svg: 'animal-kawauso-hai.svg',
  png: 'animal-kawauso-hai.png',
  source: __webpack_require__(2029)
}, {
  category: 'animal',
  code: 'animal-kawauso-iyaiya',
  label: 'いやいや',
  svg: 'animal-kawauso-iyaiya.svg',
  png: 'animal-kawauso-iyaiya.png',
  source: __webpack_require__(2030)
}, {
  category: 'animal',
  code: 'animal-kawauso-jidannda',
  label: 'じだんだ',
  svg: 'animal-kawauso-jidannda.svg',
  png: 'animal-kawauso-jidannda.png',
  source: __webpack_require__(2031)
}, {
  category: 'animal',
  code: 'animal-dog-thank-you',
  label: 'ありがとうございます',
  svg: 'animal-dog-thank-you.svg',
  png: 'animal-dog-thank-you.png',
  source: __webpack_require__(2032)
}, {
  category: 'animal',
  code: 'animal-cat-thank-you',
  label: 'ありがとうございます',
  svg: 'animal-cat-thank-you.svg',
  png: 'animal-cat-thank-you.png',
  source: __webpack_require__(2033)
}, {
  category: 'animal',
  code: 'animal-rabbit-thank-you',
  label: 'ありがとうございます',
  svg: 'animal-rabbit-thank-you.svg',
  png: 'animal-rabbit-thank-you.png',
  source: __webpack_require__(2034)
}, {
  category: 'animal',
  code: 'animal-penguin-thank-you',
  label: 'ありがとうございます',
  svg: 'animal-penguin-thank-you.svg',
  png: 'animal-penguin-thank-you.png',
  source: __webpack_require__(2035)
}, {
  category: 'animal',
  code: 'animal-cat-bow',
  label: 'お辞儀',
  svg: 'animal-cat-bow.svg',
  png: 'animal-cat-bow.png',
  source: __webpack_require__(2036)
}, {
  category: 'animal',
  code: 'animal-rabbit-bow',
  label: 'お辞儀',
  svg: 'animal-rabbit-bow.svg',
  png: 'animal-rabbit-bow.png',
  source: __webpack_require__(2037)
}, {
  category: 'animal',
  code: 'animal-kawauso-ojigi',
  label: 'お辞儀',
  svg: 'animal-kawauso-ojigi.svg',
  png: 'animal-kawauso-ojigi.png',
  source: __webpack_require__(2038)
}, {
  category: 'animal',
  code: 'animal-kawauso-utubuse',
  label: 'うつ伏せ',
  svg: 'animal-kawauso-utubuse.svg',
  png: 'animal-kawauso-utubuse.png',
  source: __webpack_require__(2039)
}, {
  category: 'animal',
  code: 'animal-dog-helpful',
  label: '助かります',
  svg: 'animal-dog-helpful.svg',
  png: 'animal-dog-helpful.png',
  source: __webpack_require__(2040)
}, {
  category: 'animal',
  code: 'animal-penguin-helpful',
  label: '助かります',
  svg: 'animal-penguin-helpful.svg',
  png: 'animal-penguin-helpful.png',
  source: __webpack_require__(2041)
}, {
  category: 'animal',
  code: 'animal-kawauso-tasukarimasu',
  label: '助かります',
  svg: 'animal-kawauso-tasukarimasu.svg',
  png: 'animal-kawauso-tasukarimasu.png',
  source: __webpack_require__(2042)
}, {
  category: 'animal',
  code: 'animal-kawauso-omedetou',
  label: 'おめでとう',
  svg: 'animal-kawauso-omedetou.svg',
  png: 'animal-kawauso-omedetou.png',
  source: __webpack_require__(2043)
}, {
  category: 'animal',
  code: 'animal-kawauso-omedetou-gozaimasu',
  label: 'おめでとうま',
  svg: 'animal-kawauso-omedetou-gozaimasu.svg',
  png: 'animal-kawauso-omedetou-gozaimasu.png',
  source: __webpack_require__(2044)
}, {
  category: 'animal',
  code: 'animal-dog-good-work',
  label: 'お疲れ様です',
  svg: 'animal-dog-good-work.svg',
  png: 'animal-dog-good-work.png',
  source: __webpack_require__(2045)
}, {
  category: 'animal',
  code: 'animal-rabbit-good-work',
  label: 'お疲れ様です',
  svg: 'animal-rabbit-good-work.svg',
  png: 'animal-rabbit-good-work.png',
  source: __webpack_require__(2046)
}, {
  category: 'animal',
  code: 'animal-dog-sincerely',
  label: 'よろしくお願いします',
  svg: 'animal-dog-sincerely.svg',
  png: 'animal-dog-sincerely.png',
  source: __webpack_require__(2047)
}, {
  category: 'animal',
  code: 'animal-cat-sincerely',
  label: 'よろしくお願いします',
  svg: 'animal-cat-sincerely.svg',
  png: 'animal-cat-sincerely.png',
  source: __webpack_require__(2048)
}, {
  category: 'animal',
  code: 'animal-cat-you-are-welcome',
  label: 'どういたしまして',
  svg: 'animal-cat-you-are-welcome.svg',
  png: 'animal-cat-you-are-welcome.png',
  source: __webpack_require__(2049)
}, {
  category: 'animal',
  code: 'animal-rabbit-you-are-welcome',
  label: 'どういたしまして',
  svg: 'animal-rabbit-you-are-welcome.svg',
  png: 'animal-rabbit-you-are-welcome.png',
  source: __webpack_require__(2050)
}, {
  category: 'animal',
  code: 'animal-kawauso-happy',
  label: 'うれしい',
  svg: 'animal-kawauso-happy.svg',
  png: 'animal-kawauso-happy.png',
  source: __webpack_require__(2051)
}, {
  category: 'animal',
  code: 'animal-cat-sorry',
  label: '申し訳ありません',
  svg: 'animal-cat-sorry.svg',
  png: 'animal-cat-sorry.png',
  source: __webpack_require__(2052)
}, {
  category: 'animal',
  code: 'animal-penguin-sorry',
  label: '申し訳ありません',
  svg: 'animal-penguin-sorry.svg',
  png: 'animal-penguin-sorry.png',
  source: __webpack_require__(2053)
}, {
  category: 'animal',
  code: 'animal-kawauso-oisoginotokorosumimasenn',
  label: 'お忙しいところ',
  svg: 'animal-kawauso-oisoginotokorosumimasenn.svg',
  png: 'animal-kawauso-oisoginotokorosumimasenn.png',
  source: __webpack_require__(2054)
}, {
  category: 'animal',
  code: 'animal-cat-dogeza',
  label: '土下座',
  svg: 'animal-cat-dogeza.svg',
  png: 'animal-cat-dogeza.png',
  source: __webpack_require__(2055)
}, {
  category: 'animal',
  code: 'animal-rabbit-dogeza',
  label: '土下座',
  svg: 'animal-rabbit-dogeza.svg',
  png: 'animal-rabbit-dogeza.png',
  source: __webpack_require__(2056)
}, {
  category: 'animal',
  code: 'animal-dog-shocking',
  label: 'ショック',
  svg: 'animal-dog-shocking.svg',
  png: 'animal-dog-shocking.png',
  source: __webpack_require__(2057)
}, {
  category: 'animal',
  code: 'animal-penguin-shocking',
  label: 'ショック',
  svg: 'animal-penguin-shocking.svg',
  png: 'animal-penguin-shocking.png',
  source: __webpack_require__(2058)
}, {
  category: 'animal',
  code: 'animal-kawauso-shock',
  label: 'ショック',
  svg: 'animal-kawauso-shock.svg',
  png: 'animal-kawauso-shock.png',
  source: __webpack_require__(2059)
}, {
  category: 'animal',
  code: 'animal-dog-hello',
  label: 'こんにちは',
  svg: 'animal-dog-hello.svg',
  png: 'animal-dog-hello.png',
  source: __webpack_require__(2060)
}, {
  category: 'animal',
  code: 'animal-penguin-hello',
  label: 'こんにちは',
  svg: 'animal-penguin-hello.svg',
  png: 'animal-penguin-hello.png',
  source: __webpack_require__(2061)
}, {
  category: 'animal',
  code: 'animal-rabbit-good-morning',
  label: 'おはようございます',
  svg: 'animal-rabbit-good-morning.svg',
  png: 'animal-rabbit-good-morning.png',
  source: __webpack_require__(2062)
}, {
  category: 'animal',
  code: 'animal-penguin-good-morning',
  label: 'おはようございます',
  svg: 'animal-penguin-good-morning.svg',
  png: 'animal-penguin-good-morning.png',
  source: __webpack_require__(2063)
}, {
  category: 'animal',
  code: 'animal-cat-I-agree',
  label: '同感です',
  svg: 'animal-cat-I-agree.svg',
  png: 'animal-cat-I-agree.png',
  source: __webpack_require__(2064)
}, {
  category: 'animal',
  code: 'animal-rabbit-I-agree',
  label: '同感です',
  svg: 'animal-rabbit-I-agree.svg',
  png: 'animal-rabbit-I-agree.png',
  source: __webpack_require__(2065)
}, {
  category: 'animal',
  code: 'animal-dog-no-problem',
  label: 'とんでもございません',
  svg: 'animal-dog-no-problem.svg',
  png: 'animal-dog-no-problem.png',
  source: __webpack_require__(2066)
}, {
  category: 'animal',
  code: 'animal-cat-no-problem',
  label: 'ありがとうございます',
  svg: 'animal-cat-no-problem.svg',
  png: 'animal-cat-no-problem.png',
  source: __webpack_require__(2067)
}, {
  category: 'animal',
  code: 'animal-bear-odaijini',
  label: 'お大事に',
  svg: 'animal-bear-odaijini.svg',
  png: 'animal-bear-odaijini.png',
  source: __webpack_require__(2068)
}, {
  category: 'animal',
  code: 'animal-kawauso-odaijini',
  label: 'お大事に',
  svg: 'animal-kawauso-odaijini.svg',
  png: 'animal-kawauso-odaijini.png',
  source: __webpack_require__(2069)
}, {
  category: 'animal',
  code: 'animal-kawauso-kakuninn-memo',
  label: '確認します',
  svg: 'animal-kawauso-kakuninn-memo.svg',
  png: 'animal-kawauso-kakuninn-memo.png',
  source: __webpack_require__(2070)
}, {
  category: 'animal',
  code: 'animal-kawauso-kakuninnsimasu',
  label: '確認します',
  svg: 'animal-kawauso-kakuninnsimasu.svg',
  png: 'animal-kawauso-kakuninnsimasu.png',
  source: __webpack_require__(2071)
}, {
  category: 'animal',
  code: 'animal-kawauso-sirabetemimasu',
  label: '調べてみます',
  svg: 'animal-kawauso-sirabetemimasu.svg',
  png: 'animal-kawauso-sirabetemimasu.png',
  source: __webpack_require__(2072)
}, {
  category: 'animal',
  code: 'animal-bear-soredesu',
  label: 'それです',
  svg: 'animal-bear-soredesu.svg',
  png: 'animal-bear-soredesu.png',
  source: __webpack_require__(2073)
}, {
  category: 'animal',
  code: 'animal-kawauso-niceidea',
  label: 'ナイスアイデア',
  svg: 'animal-kawauso-niceidea.svg',
  png: 'animal-kawauso-niceidea.png',
  source: __webpack_require__(2074)
}, {
  category: 'animal',
  code: 'animal-kawauso-yubisasi',
  label: '指差し',
  svg: 'animal-kawauso-yubisasi.svg',
  png: 'animal-kawauso-yubisasi.png',
  source: __webpack_require__(2075)
}, {
  category: 'animal',
  code: 'animal-dog-cheers',
  label: 'がんばってください',
  svg: 'animal-dog-cheers.svg',
  png: 'animal-dog-cheers.png',
  source: __webpack_require__(2076)
}, {
  category: 'animal',
  code: 'animal-rabbit-cheers',
  label: 'がんばってください',
  svg: 'animal-rabbit-cheers.svg',
  png: 'animal-rabbit-cheers.png',
  source: __webpack_require__(2077)
}, {
  category: 'animal',
  code: 'animal-dog-fist-pump',
  label: 'がんばってください',
  svg: 'animal-dog-fist-pump.svg',
  png: 'animal-dog-fist-pump.png',
  source: __webpack_require__(499)
}, {
  category: 'animal',
  code: 'animal-penguin-fist-pump',
  label: 'がんばってください',
  svg: 'animal-penguin-fist-pump.svg',
  png: 'animal-penguin-fist-pump.png',
  source: __webpack_require__(2078)
}, {
  category: 'animal',
  code: 'animal-kawauso-fist-pump',
  label: 'がんばってください',
  svg: 'animal-kawauso-fist-pump.svg',
  png: 'animal-kawauso-fist-pump.png',
  source: __webpack_require__(2079)
}, {
  category: 'animal',
  code: 'animal-kawauso-hourglass',
  label: 'お待ちください',
  svg: 'animal-kawauso-hourglass.svg',
  png: 'animal-kawauso-hourglass.png',
  source: __webpack_require__(2080)
}, {
  category: 'animal',
  code: 'animal-kawauso-makasete',
  label: 'まかせて',
  svg: 'animal-kawauso-makasete.svg',
  png: 'animal-kawauso-makasete.png',
  source: __webpack_require__(2081)
}, {
  category: 'animal',
  code: 'animal-kawauso-o',
  label: 'まあ',
  svg: 'animal-kawauso-o.svg',
  png: 'animal-kawauso-o.png',
  source: __webpack_require__(2082)
}, {
  category: 'animal',
  code: 'animal-kawauso-hus',
  label: 'えっ',
  svg: 'animal-kawauso-hus.svg',
  png: 'animal-kawauso-hus.png',
  source: __webpack_require__(2083)
}, {
  category: 'animal',
  code: 'animal-kawauso-koreha-yabai',
  label: 'これはヤバい',
  svg: 'animal-kawauso-koreha-yabai.svg',
  png: 'animal-kawauso-koreha-yabai.png',
  source: __webpack_require__(2084)
}, {
  category: 'animal',
  code: 'animal-kawauso-sounano',
  label: 'そうなの',
  svg: 'animal-kawauso-sounano.svg',
  png: 'animal-kawauso-sounano.png',
  source: __webpack_require__(2085)
}, {
  category: 'animal',
  code: 'animal-kawauso-wow',
  label: 'わあ',
  svg: 'animal-kawauso-wow.svg',
  png: 'animal-kawauso-wow.png',
  source: __webpack_require__(2086)
}, {
  category: 'animal',
  code: 'animal-kawauso-isogimasu',
  label: '急ぎます',
  svg: 'animal-kawauso-isogimasu.svg',
  png: 'animal-kawauso-isogimasu.png',
  source: __webpack_require__(2087)
}, {
  category: 'animal',
  code: 'animal-kawauso-doya',
  label: 'どやっ',
  svg: 'animal-kawauso-doya.svg',
  png: 'animal-kawauso-doya.png',
  source: __webpack_require__(2088)
}, {
  category: 'animal',
  code: 'animal-kawauso-doya-kiriri',
  label: 'どやっ',
  svg: 'animal-kawauso-doya-kiriri.svg',
  png: 'animal-kawauso-doya-kiriri.png',
  source: __webpack_require__(2089)
}, {
  category: 'animal',
  code: 'animal-kawauso-ganbarimasu',
  label: 'がんばります',
  svg: 'animal-kawauso-ganbarimasu.svg',
  png: 'animal-kawauso-ganbarimasu.png',
  source: __webpack_require__(2090)
}, {
  category: 'animal',
  code: 'animal-kawauso-gurasann',
  label: 'サングラス',
  svg: 'animal-kawauso-gurasann.svg',
  png: 'animal-kawauso-gurasann.png',
  source: __webpack_require__(2091)
}, {
  category: 'animal',
  code: 'animal-kawauso-kirakira',
  label: 'キラキラ',
  svg: 'animal-kawauso-kirakira.svg',
  png: 'animal-kawauso-kirakira.png',
  source: __webpack_require__(2092)
}, {
  category: 'animal',
  code: 'animal-kawauso-angry-face',
  label: '怒った',
  svg: 'animal-kawauso-angry-face.svg',
  png: 'animal-kawauso-angry-face.png',
  source: __webpack_require__(2093)
}, {
  category: 'animal',
  code: 'animal-kawauso-fire',
  label: '火',
  svg: 'animal-kawauso-fire.svg',
  png: 'animal-kawauso-fire.png',
  source: __webpack_require__(2094)
}, {
  category: 'animal',
  code: 'animal-kawauso-isi',
  label: 'いし',
  svg: 'animal-kawauso-isi.svg',
  png: 'animal-kawauso-isi.png',
  source: __webpack_require__(2095)
}, { category: 'hanko', code: 'hanko-arigatou', label: 'ありがとう', png: 'hanko-arigatou.png', svg: 'hanko-arigatou.svg', source: __webpack_require__(2096) }, { category: 'hanko', code: 'hanko-yokudekimashita', label: 'よくできました', png: 'hanko-yokudekimashita.png', svg: 'hanko-yokudekimashita.svg', source: __webpack_require__(500) }, { category: 'hanko', code: 'hanko-omedetou', label: 'おめでとう', png: 'hanko-omedetou.png', svg: 'hanko-omedetou.svg', source: __webpack_require__(2097) }, { category: 'hanko', code: 'hanko-gannbarimashou', label: 'がんばって', png: 'hanko-gannbarimashou.png', svg: 'hanko-gannbarimashou.svg', source: __webpack_require__(2098) }, { category: 'hanko', code: 'hanko-atohitoiki', label: 'あとひといき！', png: 'hanko-atohitoiki.png', svg: 'hanko-atohitoiki.svg', source: __webpack_require__(2099) }, { category: 'hanko', code: 'hanko-hyakytennmannten', label: '百点満点！', png: 'hanko-hyakytennmannten.png', svg: 'hanko-hyakytennmannten.svg', source: __webpack_require__(2100) }, { category: 'hanko', code: 'hanko-mokuhyoutassei', label: '目標達成', png: 'hanko-mokuhyoutassei.png', svg: 'hanko-mokuhyoutassei.svg', source: __webpack_require__(2101) }, { category: 'hanko', code: 'hanko-ryoukai', label: '了解', png: 'hanko-ryoukai.png', svg: 'hanko-ryoukai.svg', source: __webpack_require__(2102) }, { category: 'hanko', code: 'hanko-syounin', label: '承認', png: 'hanko-syounin.png', svg: 'hanko-syounin.svg', source: __webpack_require__(2103) }, { category: 'hanko', code: 'hanko-saiyou', label: '採用', png: 'hanko-saiyou.png', svg: 'hanko-saiyou.svg', source: __webpack_require__(2104) }, { category: 'hanko', code: 'hanko-saiteishutsu', label: '再提出', png: 'hanko-saiteishutsu.png', svg: 'hanko-saiteishutsu.svg', source: __webpack_require__(2105) }, { category: 'gamba', code: 'gamba-kun-arigatou', label: 'ありがとう！', png: 'gamba-kun-arigatou.png', svg: 'gamba-kun-arigatou.svg', source: __webpack_require__(501) }, { category: 'gamba', code: 'gamba-kun-onegai', label: 'お願い！', png: 'gamba-kun-onegai.png', svg: 'gamba-kun-onegai.svg', source: __webpack_require__(2106) }, { category: 'gamba', code: 'gamba-kun-yattaze', label: 'やったぜ！', png: 'gamba-kun-yattaze.png', svg: 'gamba-kun-yattaze.svg', source: __webpack_require__(472) }, { category: 'gamba', code: 'gamba-kun-oshigotochu', label: 'お仕事中', png: 'gamba-kun-oshigotochu.png', svg: 'gamba-kun-oshigotochu.svg', source: __webpack_require__(2107) }, { category: 'gamba', code: 'gamba-kun-ureshii', label: '嬉しい！', png: 'gamba-kun-ureshii.png', svg: 'gamba-kun-ureshii.svg', source: __webpack_require__(2108) }, { category: 'gamba', code: 'gamba-kun-niyari', label: 'ニヤリ', png: 'gamba-kun-niyari.png', svg: 'gamba-kun-niyari.svg', source: __webpack_require__(2109) }, { category: 'gamba', code: 'gamba-kun-kiri', label: 'キリッ！', png: 'gamba-kun-kiri.png', svg: 'gamba-kun-kiri.svg', source: __webpack_require__(2110) }, { category: 'gamba', code: 'gamba-kun-wakuwaku', label: 'ワクワク', png: 'gamba-kun-wakuwaku.png', svg: 'gamba-kun-wakuwaku.svg', source: __webpack_require__(2111) }, { category: 'gamba', code: 'gamba-kun-daibakusyo', label: '大爆笑www', png: 'gamba-kun-daibakusyo.png', svg: 'gamba-kun-daibakusyo.svg', source: __webpack_require__(2112) }, { category: 'gamba', code: 'gamba-kun-majika', label: 'まじかー！', png: 'gamba-kun-majika.png', svg: 'gamba-kun-majika.svg', source: __webpack_require__(2113) }, { category: 'gamba', code: 'gamba-kun-gahan', label: 'ガーン orz', png: 'gamba-kun-gahan.png', svg: 'gamba-kun-gahan.svg', source: __webpack_require__(2114) }, { category: 'gamba', code: 'gamba-kun-namidagaderuhodoureshii', label: '涙が出るほど嬉しい〜', png: 'gamba-kun-namidagaderuhodoureshii.png', svg: 'gamba-kun-namidagaderuhodoureshii.svg', source: __webpack_require__(2115) }, { category: 'gamba', code: 'gamba-kun-kanashii', label: '悲しい(T . T)', png: 'gamba-kun-kanashii.png', svg: 'gamba-kun-kanashii.svg', source: __webpack_require__(2116) }, { category: 'gamba', code: 'gamba-kun-eee', label: 'えーー！！', png: 'gamba-kun-eee.png', svg: 'gamba-kun-eee.svg', source: __webpack_require__(2117) }, { category: 'gamba', code: 'gamba-kun-oregawarukatta', label: '俺が悪かったー', png: 'gamba-kun-oregawarukatta.png', svg: 'gamba-kun-oregawarukatta.svg', source: __webpack_require__(2118) }, { category: 'gamba', code: 'gamba-kun-sorehododemo', label: 'てへっ', png: 'gamba-kun-sorehododemo.png', svg: 'gamba-kun-sorehododemo.svg', source: __webpack_require__(2119) }, { category: 'gamba', code: 'gamba-kun-runrunkibun', label: 'ルンルン気分', png: 'gamba-kun-runrunkibun.png', svg: 'gamba-kun-runrunkibun.svg', source: __webpack_require__(2120) }, { category: 'gamba', code: 'gamba-kun-mukatsuita', label: 'ムカついた〜', png: 'gamba-kun-mukatsuita.png', svg: 'gamba-kun-mukatsuita.svg', source: __webpack_require__(2121) }, { category: 'gamba', code: 'gamba-kun-kooritsuku', label: '凍りつく', png: 'gamba-kun-kooritsuku.png', svg: 'gamba-kun-kooritsuku.svg', source: __webpack_require__(2122) }, { category: 'gamba', code: 'gamba-kun-isogasii', label: '忙しい！', png: 'gamba-kun-isogasii.png', svg: 'gamba-kun-isogasii.svg', source: __webpack_require__(2123) }, { category: 'gamba', code: 'gamba-kun-sinisouda', label: '死にそうだー', png: 'gamba-kun-sinisouda.png', svg: 'gamba-kun-sinisouda.svg', source: __webpack_require__(2124) }, { category: 'gamba', code: 'gamba-kun-onakaippai', label: 'お腹いっぱい', png: 'gamba-kun-onakaippai.png', svg: 'gamba-kun-onakaippai.svg', source: __webpack_require__(2125) }, { category: 'gamba', code: 'gamba-kun-tasukete', label: '助けて〜〜', png: 'gamba-kun-tasukete.png', svg: 'gamba-kun-tasukete.svg', source: __webpack_require__(2126) }, { category: 'gamba', code: 'gamba-kun-beeruma', label: 'ビールうまー', png: 'gamba-kun-beeruma.png', svg: 'gamba-kun-beeruma.svg', source: __webpack_require__(2127) }, { category: 'gamba', code: 'gamba-kun-minnadekanpai', label: 'みんなでカンパーイ！', png: 'gamba-kun-minnadekanpai.png', svg: 'gamba-kun-minnadekanpai.svg', source: __webpack_require__(2128) }, { category: 'gamba', code: 'gamba-kun-yoroshikuonegaishimasu', label: 'よろしくお願いします', png: 'gamba-kun-yoroshikuonegaishimasu.png', svg: 'gamba-kun-yoroshikuonegaishimasu.svg', source: __webpack_require__(2129) }, { category: 'gamba', code: 'gamba-kun-ittekimasu', label: '行ってきまーす', png: 'gamba-kun-ittekimasu.png', svg: 'gamba-kun-ittekimasu.svg', source: __webpack_require__(2130) }, { category: 'gamba', code: 'gamba-kun-oukankabutteittousyou', label: '一等賞やったぜ！', png: 'gamba-kun-oukankabutteittousyou.png', svg: 'gamba-kun-oukankabutteittousyou.svg', source: __webpack_require__(2131) }, { category: 'gamba', code: 'gamba-kun-kanashiikedosayonara', label: 'さようならー(泣)', png: 'gamba-kun-kanashiikedosayonara.png', svg: 'gamba-kun-kanashiikedosayonara.svg', source: __webpack_require__(2132) }, { category: 'gamba', code: 'gamba-kun-ryoukaishimashita', label: '了解しました！', png: 'gamba-kun-ryoukaishimashita.png', svg: 'gamba-kun-ryoukaishimashita.svg', source: __webpack_require__(2133) }, { category: 'gamba', code: 'gamba-kun-moeagarutoushi', label: '燃え上がる闘志', png: 'gamba-kun-moeagarutoushi.png', svg: 'gamba-kun-moeagarutoushi.svg', source: __webpack_require__(2134) }, { category: 'gamba', code: 'gamba-chan-arigatougozaimasu', label: 'ありがとうございます', png: 'gamba-chan-arigatougozaimasu.png', svg: 'gamba-chan-arigatougozaimasu.svg', source: __webpack_require__(2135) }, { category: 'gamba', code: 'gamba-chan-yorosikuonegaisimasu', label: 'よろしくお願いします', png: 'gamba-chan-yorosikuonegaisimasu.png', svg: 'gamba-chan-yorosikuonegaisimasu.svg', source: __webpack_require__(2136) }, { category: 'gamba', code: 'gamba-chan-mechakutyaureshii', label: '嬉しい！', png: 'gamba-chan-mechakutyaureshii.png', svg: 'gamba-chan-mechakutyaureshii.svg', source: __webpack_require__(2137) }, { category: 'gamba', code: 'gamba-chan-naicyaisou', label: '泣いちゃいそう', png: 'gamba-chan-naicyaisou.png', svg: 'gamba-chan-naicyaisou.svg', source: __webpack_require__(2138) }, { category: 'gamba', code: 'gamba-chan-yumemigokochi', label: 'ワクワク', png: 'gamba-chan-yumemigokochi.png', svg: 'gamba-chan-yumemigokochi.svg', source: __webpack_require__(2139) }, { category: 'gamba', code: 'gamba-chan-tasuketekudasai', label: '助けてください〜', png: 'gamba-chan-tasuketekudasai.png', svg: 'gamba-chan-tasuketekudasai.svg', source: __webpack_require__(2140) }, { category: 'gamba', code: 'gamba-chan-senpaisugoi', label: '先輩すごい！', png: 'gamba-chan-senpaisugoi.png', svg: 'gamba-chan-senpaisugoi.svg', source: __webpack_require__(2141) }, { category: 'gamba', code: 'gamba-chan-senpaiganbatte', label: '先輩頑張って！', png: 'gamba-chan-senpaiganbatte.png', svg: 'gamba-chan-senpaiganbatte.svg', source: __webpack_require__(2142) }, { category: 'gamba', code: 'gamba-chan-unun', label: 'うんうん！', png: 'gamba-chan-unun.png', svg: 'gamba-chan-unun.svg', source: __webpack_require__(2143) }, { category: 'gamba', code: 'gamba-chan-isogasii', label: '忙しい！', png: 'gamba-chan-isogasii.png', svg: 'gamba-chan-isogasii.svg', source: __webpack_require__(2144) }, { category: 'gamba', code: 'gamba-chan-senpaigomennasai', label: 'ゴメンナサイ！', png: 'gamba-chan-senpaigomennasai.png', svg: 'gamba-chan-senpaigomennasai.svg', source: __webpack_require__(2145) }, { category: 'gamba', code: 'gamba-chan-minnadebanzai', label: 'みんなでバンザーイ', png: 'gamba-chan-minnadebanzai.png', svg: 'gamba-chan-minnadebanzai.svg', source: __webpack_require__(2146) }, { category: 'gamba', code: 'gamba-bucho-subarasisugiru', label: '素晴らしすぎる〜', png: 'gamba-bucho-subarasisugiru.png', svg: 'gamba-bucho-subarasisugiru.svg', source: __webpack_require__(2147) }, { category: 'gamba', code: 'gamba-bucho-wakattaryoukai', label: 'わかった！了解', png: 'gamba-bucho-wakattaryoukai.png', svg: 'gamba-bucho-wakattaryoukai.svg', source: __webpack_require__(2148) }, { category: 'gamba', code: 'gamba-bucho-wahaha', label: 'わははは', png: 'gamba-bucho-wahaha.png', svg: 'gamba-bucho-wahaha.svg', source: __webpack_require__(2149) }, { category: 'gamba', code: 'gamba-bucho-bozen', label: 'ボーゼン', png: 'gamba-bucho-bozen.png', svg: 'gamba-bucho-bozen.svg', source: __webpack_require__(2150) }, { category: 'gamba', code: 'gamba-bucho-kiminaradaijyoubu', label: '君なら大丈夫だよ', png: 'gamba-bucho-kiminaradaijyoubu.png', svg: 'gamba-bucho-kiminaradaijyoubu.svg', source: __webpack_require__(2151) }, { category: 'gamba', code: 'gamba-bucho-ouenshiteru', label: '応援してるぞー！', png: 'gamba-bucho-ouenshiteru.png', svg: 'gamba-bucho-ouenshiteru.svg', source: __webpack_require__(2152) }, { category: 'gamba', code: 'gamba-bucho-totsugekida', label: '突撃だ！', png: 'gamba-bucho-totsugekida.png', svg: 'gamba-bucho-totsugekida.svg', source: __webpack_require__(2153) }, { category: 'gamba', code: 'gamba-bucho-orenimakasetoke', label: '俺に任せとけ！', png: 'gamba-bucho-orenimakasetoke.png', svg: 'gamba-bucho-orenimakasetoke.svg', source: __webpack_require__(2154) }, { category: 'gamba', code: 'gamba-bucho-namidagaderuhodoureshii', label: '涙が出るほど嬉しい〜', png: 'gamba-bucho-namidagaderuhodoureshii.png', svg: 'gamba-bucho-namidagaderuhodoureshii.svg', source: __webpack_require__(2155) }, { category: 'gamba', code: 'gamba-bucho-yattane', label: 'やったね！', png: 'gamba-bucho-yattane.png', svg: 'gamba-bucho-yattane.svg', source: __webpack_require__(2156) }, { category: 'gamba', code: 'gamba-bucho-majika', label: 'まじかー！', png: 'gamba-bucho-majika.png', svg: 'gamba-bucho-majika.svg', source: __webpack_require__(2157) }, { category: 'gamba', code: 'gamba-bucho-kinmedaruwoganbakunni', label: '金メダルおめでとう', png: 'gamba-bucho-kinmedaruwoganbakunni.png', svg: 'gamba-bucho-kinmedaruwoganbakunni.svg', source: __webpack_require__(2158) }, { category: 'gamba', code: 'gamba-bucho-nihonnichi', label: 'よ！日本一', png: 'gamba-bucho-nihonnichi.png', svg: 'gamba-bucho-nihonnichi.svg', source: __webpack_require__(2159) }, { category: 'gamba', code: 'gamba-bucho-zannenjikaikoso', label: '残念！次回こそ', png: 'gamba-bucho-zannenjikaikoso.png', svg: 'gamba-bucho-zannenjikaikoso.svg', source: __webpack_require__(2160) }];

exports.default = stamps;
//module.exports.default = stamps

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0d230b380fa59bed8f7c6f2d8873f598.png";

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "50ad7c97bfaa2a021d57c4bd3bd539cf.png";

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d80c7566e32fe4ff9617020d78d7481b.png";

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9bbf5800dc27e0ccc38c344b69f19a40.png";

/***/ }),
/* 2023 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ac65a04f3a95591b9ce1b1cd129d3942.png";

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9a5ddd51723d6b92c118a4670ed910c9.png";

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8bbfbd3f5907e56ca6ef3e38ffb98d51.png";

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "76f17ae1a57e8cd02adb5b5aa75a17ce.png";

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "36b99fba97a9398bde77414790224d3a.png";

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ebdafb4dfb8f0366cc322fdf8a279d14.png";

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2c318ee7ac43d590ca9badebfa32e660.png";

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c5f6ac345b473f918c87175af2ef316c.png";

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3e96ed4afe38a571e717699d6af71fcd.png";

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b13b27b2929af0f09ac30e1555c9fea0.png";

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ce58d4379d609420be90edc8be0a0b7a.png";

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "22c8f9a6e4fbdb1136a629e369ad605e.png";

/***/ }),
/* 2037 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d7b2ea59d782e8a05b9ac7df0eace1ef.png";

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6c41ce9c378ec09ac2351c3dcfafbe77.png";

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d9a86f7dd2a042309b7ee21462fa3e6f.png";

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "71a07ec4e2ada303c2f2dafaebb6bb77.png";

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e58db0fb2ab988f3c7d43f9b3ab15805.png";

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "00d98fb6c42e0088b9dc5823f3843baf.png";

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4608f5a70ee122603822272bcdcdbca1.png";

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2b6fc08745b1739a7ae7b03f8a3db8e6.png";

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9302f49db0771985a0802985ce219ff9.png";

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0bf4a7d619a31d986b2ac1e9f80cfbc1.png";

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "18abb463ffc37b9337f34b698ed78a22.png";

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6602ba518a04d572c1324c53d34a7849.png";

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "824f571139f63e1460af796d6aeed84e.png";

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de3e37e291ffee2c8edb7d3288009d35.png";

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2636e0dbf191f858748a9f70db1ef996.png";

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2ce817cc743f7ffeffadfd9d8b2e8ca6.png";

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "34f815f73b055bedeb3d46af9fbbbd70.png";

/***/ }),
/* 2056 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5c2c62d1d15e2a1911dc3e26ca354b65.png";

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3ba97b998baf0231a500c76f5d6fbce8.png";

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "704911eced7c071f1dc1128b6b2b1581.png";

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "85fbd5bd5f41579580f210134302a24f.png";

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f27572681857d69739d37c26749ec2a7.png";

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9cf4a9494005a3a233bb2fd3b9cfa14e.png";

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f102ef0720cbf68b16820eff11593e38.png";

/***/ }),
/* 2065 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "80216e9766f7c61e85c9be8e0ab5bdbd.png";

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "feeafbd69456f7e0fdb2d4daba7bd837.png";

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "94548e33e2b269640beeb64b1c3dfa0d.png";

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c3f3463fbb7e5faeac3ef0de6aef04bb.png";

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "86c2a4aef36e9059746036699e4bce4c.png";

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7fd7f16f731064bcbc043c6565451773.png";

/***/ }),
/* 2073 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d8c862b31ada25ad08493fd6b1f687ad.png";

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6649e2e4059f9c40309001309e607f2e.png";

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2466739bbb16e928a55291bd8e2c7eae.png";

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "80981339dfbbacde0140ef1ffc710849.png";

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f51215adc0b68949b6deb1645d87de5a.png";

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4ef44c24ad6e4abd1cabd44d2ad0108f.png";

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aa3814f4c7b5364ae2d767581069f709.png";

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9da7284294715417dc1fed4d483e0ccd.png";

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "609b46396832862336ca98fda76996fd.png";

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6ee0a808f4af84a11fa84f3f5291215d.png";

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4cec569b058292d325684e26a37c40cd.png";

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1031a1e67aea1d5e03709b2415438935.png";

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d6fda81d25083d578b2ad1d0e0c7ccde.png";

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f4f577b11a9d85dec4145a2bcc1a9b0e.png";

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4d1a9c8f2f700ba55d3d6663265b4e3d.png";

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c4e633943c2b97c22739690696e28f04.png";

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "19098ea66373e49fc9a57e1b777beb66.png";

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "77a230140970142814fea88af3802772.png";

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf41a3163197f9fd7b650921f7f979dc.png";

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "086fc9f303ff4d07ac669044bbc11c10.png";

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e7858765e7d25bba626ad1ec7a69e705.png";

/***/ }),
/* 2096 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAC2VBMVEVHcEzVAADcAADcAAD/AADcAAD/AADcAADcAAD/AADbAADcAADfAADcAADbAADcAADcAADcAADcAAC/AADcAADdAADhAADjAADMAADYAADcAADcAADVAADcAADdAADcAADcAADbAADcAADcAADXAADcAADmAADcAADRAADdAADcAADcAADdAADdAADgAADcAADcAADcAADbAADdAADcAADcAADeAADcAADdAADcAADcAADcAADcAADcAADjAADdAADdAADeAADcAADcAADcAADcAADbAADdAADcAADfAADcAADdAADcAADeAADbAADbAADcAADcAADbAADcAADaAADdAADbAADcAADcAADcAADbAADcAADcAADbAADcAADdAADZAADdAADcAADcAADaAADdAADdAADdAADcAADcAADbAADcAADcAADdAADbAADbAADbAADcAADbAADcAADcAADdAADcAADdAADcAADcAADcAADcAADcAADcAADdAADbAADcAADeAADcAADcAADhAADdAADcAADcAADbAADcAADdAADbAADZAADcAADbAADcAADdAADcAADfAADdAADcAADcAADcAADcAADbAADcAADcAADdAADcAADbAADcAADcAADcAADbAADbAADcAADcAADcAADaAADcAADdAADdAADdAADcAADdAADdAADbAADdAADdAADbAADbAADcAADdAADeAADcAADeAADdAADdAADdAADdAADdAADcAADbAADbAADbAADbAADcAADdAADdAADcAADdAADdAADbAADcAADcAADbAADeAADYAADcAADbAADcAADcAADbAADcAADbAADbAADcAADcAADdAADcAADdAADcAADcAADdAADcAADbAADcAADdAADcAADbAADdAADdAADbAADeAADbAADcAADdAADYAADbAADcAADbAADdAADdAADcAADbAACBIGN3AAAA8XRSTlMABvn8AvoD/v0BgPgI+weZFunrBMyqEQkFDaIzDPP38alGsZET9QrAC0TyjN/0Gb/ualZTvh0fmjS2QadeoRIPlC5fh4K8I2g9EO/88DYp15vhuucibxU6l90rpkwc7I4U/VfGMK2VeH2SXKjUPE+IMcUO0kktJFr2QoTLZtOj9DsX4iwY0HHarOUm7Rt8nuZwkCCvmLDkij+7rktss9zH2/uP0dXZN+p7WXeFf344JWGWybhRRXMvHrXIStjWKk5U0OOcynW5waXDSDInGs5kZW2Bk0Bj6J9DwrK0dKtQcon4pPr+9vm3/s01IZ1geualbl96LwAADE5JREFUGBntwfV/VPeCx+FPkpk5M3F3QWJQLLi7e3C3i3twL1zcnVAoVnd3pe7u3m172+t33/wF+52EsjvJzJyD9LW/8Dy67rrrjIzp0+5PqPNN09SzqW+0S0voeXdOrv5ovuUj65Vb1PLy09/muPRHWfJQ2p1UKy851SGhclFlwvh6LRt5qdLscJ/OuvY8y8avwii6KXra4lL9X7Hdzu99Og8j5sTCCF1TU3ruB7wV0cfjFVzK6L0to4Dkyia6ZhKjBwLli3orvCYj/wZEZq/QNZE4Mx/c+x5QoOJRI6aPSCxVoMUzV4F730RdNVfHZIjMXqFLppx8ok3JcIuLPq945bWFTXTJqOj+UBQdoavTdi3E3LBFFy158eCtFkE837VFZ13U+ePGsL6vrkLmDV4YtkvVXA2yGxNa1E0dM1TtqRNgJWToSj1VAfs7qtrEyuHY2f1Jb1VbPQSe36wr830zyM5Sld5tIvld1O31Kj+oO+iF1umtBrdt8FCPE7fF8bu4DeNUJfYTyJurK+DrYVH0kKrsyY6jmrW0/sJ+qin32Rv+5qWad0dvVWkxEB726HJ5hsJz3eSXMrKAauWLViiUPSO3Um1VdKz8njoDRzN0eTK+hna58ht9K1W8dTb6FFbbL9xU2f64/OI7QEkXXY5+FbAhU4ZvpBs/d/Zg2WtdfxV+Vv0IGa768NImOZfxFcxxyUgcRpV6I1TLgpaTVcue8VT501PyG2mxNF1OpdSD++X3wH78Gr2oIIb+whLVtnoIfrsfl18fi6axcsb3CsyU37LGGNacYtWSxu+83ytQxBovRuTd8rsL6qXIkTXwpkvGSjdGQXMFMebGG+O4cKPRv65qar8fw3pCfnNgppxYZtErXkaZhbH2kEKYQWN9eGuOgmhSgt99MnydYK7sTUzm9iwZd3sxemUplFN48+G59goiogN+22TEp5L3ruykvEX+YhlfxmC8makQ4ut7qXafgvBNxrA6yug9kPXFsnEv9JExqDHGwy6FkNEU2D2f+WN/mbpcwfTEiGwg4zwcUXjj3NSRkV6O0cGlUF6B/+CFBccH/LpGQd2C0eyQjK5YnyocX1MmFUryHcXoFa9QHvRaG+pbkKZDWF0VlGsexjOZkjLGMj9TYTwE3WW8hvF+rkK6OdJa9nqctb5YH0Xmr1NwEW9g/Cjjbdim0NKTeMsnKccNFKxQaNtivF54fkv8EwNI7qcQmiQB1pcyjtJwj0L6kbjlklxnMFYqjEMNL/Brz8Q5edB/kEJqHwVsj5XUuog2CqVzQ8bI6INxRGFt+tfKfpoG/6lMVBj3YuyV0ZPIVgohGvc/JBVOAoZ3kZ1SpXz6nsKLGAKsGiGpsCH1FVxuMp1kPIzRXHZmURIhWw0w0mTcQH4TBfUa3sGStuQDw2TrOZi5/eyPSxTePMA7TlKTfBYpGN92dsiYDHhfkJ0ploVx7hGXwmoVA2TLeJikTAUxGt6WVJgHfCdbb08dQP6spXGRjym8BCBqhaS2MEFBjGGnR9JswFosWx9dgJN69px3vMIbEQfMkbGeOqotYhKVknyngadlbw08I42C52SjE5AcIWkW+f1Uy2OwXNICjGdlL/pn978ll8VZ2bgDY6GkiV4+Uy1HuE1GGyApRfY+Kir6QMqCt2RnCLBDxlukqZbt1JcU0R+YLAc2RsW8JvUd8PMR2bkLiOkiKZpJLtWwB76X1BdjuhwoTo57XOrk9taVndYWsFBSX+imGjriTZd0H7BTjhRnSRP+aj3jk62lwEFJEY05oBr2kSqjBOgkh2JnRZHUWvZuAZbKeJR6qiGVrpJi84F/yZnpyfB+KznwImBtkhRNIwXy5XGzpDswWsuZFt61c31yoksUcFLS3XgzFGAiPC6pO7BbTm3JkkO3Az9IWgzdFOBLaCWpB1Ahhyb+GndSUuHx9oWy8TWQIKnU4rwClFHkkjQD2CeH1uVHzpU0Hk7IRiVQIuNlZivAGobIWA/MkkMzLGtT6bxtv8EbsvEBMFzGV4xRgPo8ImMnsFJOlL6zsoBmC3rHUQ4nZKMu4JbRjp8U4J/0kpEHTJAD31rgnQotm0/lpwWdZWM0RrykedRTgDSOSvJ5gU/lwP0M7z/VOwNvn8l4X5CdzRhTJA2lpQK0Y4OkXIwcOVHaJf+Xp3Ujp5p4B/y37LTG+IekyaxVgKYMlTQKY5wc2RY14FkN5HWdIT9DNkZhjJN0L/MVoB0/SSrF+Luc8BwjyTMF6yfN/pn2snEIo7WkgzyiAHWoJ8kXBayWE+fPxc3WZzGrPlSrM52WyEY3jM6S/kkvBXiFljIKgIVywLX9grtsRYnlbSUnNmJESErjsALcwqsyjgFz5UBforYy9a9Tf5Mjy4AYGe3IVoCe3C5jK7BXDvQbNmlc17gBA96RI32Al2VUMFMB1hHjkVQHyJZTWz4YLWduAXrJGM4sBTgOIyR9DDwih3wjoxPlTDugq6Qu8JgCbIJlklYCA+XQkxfcs+XMWOAjSYNgsAL154CkdzB2yZm+UTHRcmSKF6graS5R8Qr0DAmSMhsDfeRMXXfMbDlyHohKl3QvZ1XDGObLeBSoI2dWuyN7KHNBN9kaA7wqo4Q01TANa4uke4A7fXLkQXi+5L+IjJWd24FFkopjKFMNiRbTJA3CGC1HNnoB6/RdsjMYo66kuvCualpPgiTP58AROZAy9AJWRfdC2esB5BVL6sFO1VKfsTJuAQZmyN7MmKnPPSknfI2ATjLWskG1vA0PSFqMcV62Cr0UjZIj7TEel7QLVqqWlOHMlHEr8CfZamvxvJw5DOz0SOpJXq5qm8zueEk/YByXnUQvUz/LlAPLLaCHJN9Y9imI6fCYpNxk4HXZOhgJjc9ubdSsvJXC6gDkvyepL7RXMC/xqIxojAdkx9d9voVf5LsKZ3AU0FXGBspdCqYM2krq3BBI9chebKtBG6ePyFVY7QB3a0m947hLQcXvZIaMHhh9ZKv5xy/IVnOMoTLaUNBPwT2BtVlS1jGgWaLsbIfT88o8CifrGFDQRNLESHoqhNJkxstojrFDdjZXYCxQOG0wymR8Qt4UhfJvrI0y2mHcLFuDerTsVaowmmOkeiRtdlOpkDIasT5T0oONgZgchZOyes6fB8DW0QptV0PAnSPJ15RJhQrtRdgmozvG2FEK432Mv3g5102hLLkV4wkZ3aG7wvmahntkdMJ4qYtCG8LpH1rp078OOKwQIoZhPO2TlJ7EWz6F81RjWnokld6G0TJeIaVvlt9fuFPBudIw/jxFxpvEPanwDsBsGbvuxNgRofA850hWUJ42GAXvyCiDnrLhO4y3gYy2DTFaLlFYD1jWbwomog5GZF0Z3Vbxhkd2Opezf5OM1TEYqYkKI/ZM1LmTCiL3dQxvcxldzpL0nuwNimRtlowWkRhjcxRSt1ex3lQQg+djeNfJiBiGt66cKINhETLaF2C47/EpmJQ+ZyyYk6LaOuZhRE6T4UqDvXJmDXRwyWibhN+MRAXxLMR9/XfVlt4Jv4L28jsIY+SQrw2Mccl48Db8+pd5VEvszRNyVZuvexJ+jabLbw1855JTnu/gRKyM4i+okjpaziz+iioz+snwPAxNY+Vc7GEYliW/uXlUqZgge9PTLPzc9/hkxO+AXlm6HJ42sHaL/FY8SrWK5rEKJ2LhMKpVLJdfelOoE6/LdA8k1VWV88eoNnBoX5eC893RNZlqdz7kk1/OWOjq0mUrcxN1n0d+WfcWcNGkGWWDVVPvDzskcVHRwc7y8x2IJGqWrsQd5dBroqqk37+bSxqmjr+/e4sGg55s2+CxjndlPzKQSxouSlSVUUdh+GpdmS5pUBQdoSq5B17CzpBZ6ari65gMTZvoSvkOFMHSvrrohehyQmuWsMCnajmvQuRel67CoaNgzVuu341Yl9af2opuim6QqYt2fREFN72rqzShEVin7tAlKU82nz0+tVGzKMDbrHzrvI/vzonQJeOy42B/R129jHuSgNfPx6qG2PRi1ZA5oZ4FzaKzdE3Er3sZGJjdwKewxi36HEiO7qdrJn7d+xjl++a+p+ASpyWcxrhtZLGurc2Vx/AbMvTbCQ+m6H95ei/bdmSphZFUP0d/AE+DyVu9VHE3Si35pk5Ch1NNU0/HUG3+nJOZ+sMUtuhaMYma+j+TMG2T/niFGz+7rzKhw6mbvpmXcEP0h8cTdd111/0/+h8p+XYRS6X3dwAAAABJRU5ErkJggg=="

/***/ }),
/* 2097 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2101 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2102 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a33b5cdb09b25a15fb2ffe844d9580e7.png";

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2107 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2109 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2110 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2111 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2112 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2115 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2116 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2117 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2118 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2120 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAABgCAMAAADhP0YWAAAC+lBMVEVHcEwEAAAGAQEAAAAFAAEEAAAAAAAFAAAFAAAAAAAFAAAEAAAGAgIEAAAFAAAEAAAAAAAFAAAAAAAEAAD65+ADAAALBwcGAQEEAAAHAAD14twDAAAEAAAHAQIWGh8EAAAHAAAEAAADAAAFAAAGAAAAAAAAAAAAAAADAAAIBAQKBAUsJSUEAAAFAAHz4doEAAAEAAABAAAOCw0DAAADAAAEAAAIAwQEAABOcYUFAAADAAAOCgs4Ly9YgJYbFBQvQExAXGwEAAArOkU3TVvQv7kGAgIFAAFNRURYT00RCgqPgn5fiqMRFBgEAABmXVwiGxtkkqwFAAAEAAAgKzMmISF/vN1DYXL249xxZmQDAAAEAAD65+C4qKQaISfi0Mr45d3i0csSDQ2KfXoDAACAvd+cj4oEAAAnNT96tdQNDxFpmbUdFxfu3NUfGRp3r8+voZxDPDvPvrgUDw8JBQZsY2FXTkx+cm6mmZQFAAB5bWrx39gPEhW/sKoDAABNR0jZx8E8NjYYEREEAAAKCAoEAAAvKSc2MS/65+AaFBQDAACHe3fVw71kWlZwpML9/f3IuLLw3tc9NTRdU1L35d7KubPkBSdCOjkmICAGAQE0SFVzqcgdJi7l1M1+uttTd43Uw735598jLzinmJQuAQiCdnLFta96AxSdj4r09PRuAxH///+5BSBua2ysnZjp2dH///9JQD8wKCiViIO0paBahJvg3999uNp4stIHBAVqX1wMBwe2tbXLysrp2NH35d68radsnbqjlJDcy8WTAxnIBSL3BirwBin35d2YBBqKh4lGAQwMAAIgAQUlAQYVAARTAQ6Cf4Dt29SHBBaopqfr2dPAv787VGNGZnjaysOnBBxgVlNhWFYnAQdiAxDbBCVTSkiwoZzq6elCOjm2BB+TkJFdWVnj4uIRDg8nIiDl083dy8VcUk/m1c/z4dqbmZrBwMDY19evrKzu7u7X1dU1jwAEAP8E1/6B5wAEAACBvuD65+AFAAD6Biv///+icLq/AAAA9HRSTlMA1ekZ+PUM/voFMvzke+7xCGUVcv6d2qm/JfpNyevHhyE9WPMrAgER4PzdxYLE3rmtHdSXXNDjzMijX9bCzuzAwrW/wN438MDN9cXUykLJyddu68Hk/MTjwlJ399PE6v3M88SQ/sqxwfXQ3MzX6u7A1MTS38e/w8xpw/fN10jR5NjQRteM3tr0ztzC4cDk6cL1wb/q2+vAx+fB6MLu+srF78HAw8TYwsDYwfzTx8/w8cDExtHSyPjx4b/3wMPR7cHfwObF2vz26MjCweDKyNS+w/TCv/LVw8TIzcrKxcDkz9DOwc3Bv+fFtc7Jy8/4wMHhzvDEof4NXwAACjBJREFUGBntwXVUlOkaAPAHJr4ZBkZiqKG7G6S7DRBFBUUUFAu7u7sxsbvbXV12dTtdt7s7buc/z/u8wzn3m0ABuUcZ9syeew+/H/Tq1atXr17/U3zhd5IaDJZT6DAwGEyc/MBiHATEXHtQFroDQFyMEizEV1r3p37o7G6F6KoESExaCpZhh88TVQktuGIt+gBAYGgcWEQCTiF6Lgvrjr3+jDQOABaMBYuIxM+IaDt+QTQPEwBArnaErtgXJi5wWCqB30JQYKByFZYQ0bM4jyhaJQsBgFwHeIjcIUaBeoKngxJ6qjAUMcA5AJ8lisYZRDQHnQBgQQJ0Ivcpwges/KCH3LBkUxYirh1JtFaIJpoihCoBJE7QQVBaM3agGgE94xk2ktafkCKeIJqOC4moDBdAZ+6e+BA76BEnnLOeaDtiPdH6rLDhRNFhRRLoyEGGDxPSoCeUbrg2mmgh/plIMx2nE9EmjAUAOUBIEOhJXLFLChvoCaWdImsX7aqbqiH6I24iol11OBDA2QYkoUmxrq5RUvwvkpTQIxV4gmgh/oVoCpaQ6AS6Abi7AiwVsEuyPySjXiSYy3esrdtSZXOlhsZgCdFwlEYT0XNhgiNAEgCswa7YnqYCW9TzTAsCM9ivUaAoKQnHkKYSx5BmBma9uJ5oHa4CsAIApSc+bGUtES2RooGVDXSbMgpLzx7dPqcOcSHRZ8IyomNzVLid6Ev0B5CDyLcIO1EVa0nvFBopEqG7nLBkF4lGTpeuJaKjM0k0/Oh6ojKsBgN7j2TsKLyGTJrQSOUP3RSJ9a/vGrN9OFH0FOqgBKsBIMg/VoYdqZ/WUhvtLDSSBUL3SEJRrzSaOpuBhSAaGIodqIsPUTsvNaNRLnSTfESUlXMkzqHOVqAv6MlHDMY2qlkLF5GBtr5pw4a9NURPKNBA8AVzuIUNp05mYAgYJUdd2+DS4rKhqd8VMlkym3MvNRd2ElWhUQWYww+/1BDRsZF0XxmuAoNCvpeIausX9nufTK40y6p+aW39R7zqCtF1NHAGs+Ri/Uiis19oyEQzE63koOfDTxPNlXLOiy4Tjf6BiL7jO1tFv4TLFhEtWo1SAXE8dF+cO8SF4orn6PVnplMbzTrMVYLI01pD9Xzfx//6OF2tpS3xRLTDS3r955/3SflKEi234qrwqPHQffJIgJBcDFt2tjLsWTLRDJ+KCQAQooogiuh7obW19Wf+0W7pPBIVbFBxztNdZFoS9S0ty+LOYAY7D4Ag/xgZImZFU5spdVgB4MHnEW0R5n78z2JFuTa9r5YMruy+wYt38idIdF11bP0MhQS6L2i82wgJgDJRcFGV3piiIaM/PqNaChW8hkjrwjmXZuzYgquXk4nGK72GzyVRFR9DM3k1mCHIz6fZzh5gBMZLEbO+nTc9mkRHcbBkDX+JiLymLuPziWoaA4oayCRCVRuwgUSn+Ys0k/uDeSSuVnIITlUMy45XIGLY8yTahDGpitFEy/lPt/kSEmmfuNywJaMxPr28YR7v1yhdRESj+3xLZYIvmCvV1RfsPdUvsMOTM3P64EwiWl+JbgFEdIPf+ZAXaC9v2lnezE0U83nGFv4diRpLn+exYDb5WPVAkNiGP8VEmULpcCIagxsVGqIt/NxdXnuNi4SpK8rufnjn5ns8w6VxCZ9LormcWzlCD/h7AtjIFg9loglYoiGidWi1g6iJbyuTajP4v89tu9BqdJN71R4afX0+iZ7mMY7QFQ/P8R7B8GhBawDAXzg4jjF2ywVfJKJ1mFRAVB52YUU47eXbWkVXz928/d6yLM5Pk0kTj4OuxMkQ0dMPHpMT5jFRfymWzTyL1rJTRBvqLtSVUxO/c/tuSSXX83rnLf40mawsCoYu+NminpDqCI82EAB8MJ+JjlgjouxXnkHUWHqOF1MjF6nfOfnuBz/u0eleU5WT0Q5pDHTBXd0soIE6DR6pIsEegp2FYUx0K2XChMlb+1prqUm4yy/TbNsPLu7R3RfeQkYN3AkMlNBOyMaWaZO9BdQrqoZHsityAGWs6lPWJo/X03zOXTRaxdu69k6qdpBBuWDjYZca1SwgDnazCwEDpVvRZMbYZG8BNzrI4TFIIgGUsaphzGSrIn407dxXQJv5m7r2vuZLSK/AdiOiYLt4SN7+7CHxwmB30HNWZDKDI+gEj085XhjGTIbwKtKbz8/o2nuZnyK9CC/v/f1vMZPJ1q4gssMcZjSkKAS6QTlelcOMpllLd5Ooin+ua+8VXkyiBu7N2suWygEchDxmdEDmA48t0RdA6YwTxjGDI6qW5UR0jX+ja+81IYKIllsHbGXt9ceBkKgawkwmyBzhsTnm2gAER+Kow8wgn9tuJiqXvqrrwHoWUe1sVQrrYCLG+gijxjGjaQFroBtCrAIBoEIY8BQzyFepT5HLPV1H7zTT7nCezzpRoyx7HDPJlkqgOwY2+wFAdUDLIGaQouaNsrd0Jq/q9rxx/swrXwlVMkUO68zFm903UZ0A3RPoACJ3K+kwZnDAm/M3dXp73r2nCojytFLzAM5tM9lD4gew+/ar3MEs8lg8+BQzyOHndaKLzfzeV8knX774+UmBH5zIHrZ4Emtzq9kZzBRcIWtOYXrDOFep1W/3kZ159a03dHou/AgzOjyUPTAgnbX5BMdKwFzubuh9gDGWx2dcujSVS3/Uff2yzuBtPozpHZitQmm491ZmNMCFmRy2bVaoYhLlAO5+0H3BaWpZ3jTmzb9vvVrJz+t03+iM3uT5TG/ihOz9xwdgDjNaPJuZ5AiDpn2SjgHO1UUYCWZwHCuVDUkXrrZ+yFXvnv/gjYuv7HlNp9Od4dnsvomYz4wWuzCjoS0DmOiF7BYU2YE54nwGF1W2tv7E75Nah9/jx9l941R5zGjSamb0KfZnBk+i3ggwi4Rfam3ddmlqGG9nFHtAfZwZTYpnBuNcJjGj/qgnLABz2HDp1HXL5rz3t9t/v3Pz+3Pbrl5o3cYHvHCLtek7ihnFT2IGKZjJjPqjgZAGZpAneAbwdkorVyzjyYiD072P56dkZmb29WZGLqszn+w/aNCg1YpRQ/Lyc1KeHJSCRqo0MEuwr4eda7KaP5CwyiEy1W2jAvUmMSNbNHGLsmqWokFUcmgAIgoV0AMhhf4jfBJcY3JTK+wBQGK3xr/Q19c3ZjUz6hNrYxAIevaSQD8PjyAAUEoC/Tzk8JuxKq6fu+9X17FJtkOZ3lDBBywioIBEhxrmNjaPSpnI2DR0Aouwi7+sIfruNNGiGxHWowZtxUSwjGrP2Xv3Nmlo93Kiv/YLP4irwFJ8k/ZqDu0r1i4aTfT+SrQBSxm7V1PrMp/6ZXxEBfSSKg4sJPG6ZvSsBmq4Ttpr84m87MFConZTVQRtDv/oUHkN0eZksBTX6xkBmymi/v2VNUS1s/zBUuyrPayWbG7R/lBM1M/aCSzJJjWmb73XvpoMz0CwtDTnSEWAnRJ+D/ZK6NWrV6//T/8BQgA3ndiBEU4AAAAASUVORK5CYII="

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2128 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAABgCAMAAADhP0YWAAAC91BMVEVHcEwGAQEFAAAFAAAEAAAEAAAAAAAEAAACAAAGAQEEAAAnIiMFAAEFAAF1dXUGAAADAAAHAgILCAgEAAAEAAAHAgMOCQouKioGAAAEAAAFAAAGAgICAAAAAAD21k8EAADt7e0FAAAhHBwEAAAFAQEFAAAEAAAEAAD99dE/PDwLBgYGAQEEAAAYFBQDAAA2MDAdGBdORkUPCQsFAABVTkwFAABramp+e3sEAACqnJQDAABFPjw5MzIFAAATERItJyX759YEAAAFAACHhoYQCQoEAAFVUlEFAAAdBAS7rKaShYEdBARzc3MFAAAyRlIpIyBwcHAFAAAPCwydj4oVEBD22Fj211MAAAAEAAD333UEAACdm5sYExTj0sz55t9cVlXfzsX45d54bWdmla9vaWb76qDy4NkUDw+GenJlXFoVGR7HtrCxr6/z8/MxKij22l9nY2MQAQEiGxiMf3hHRUXx39Sml41fiqJxpsRlEQwgKC/BsqzbysLo19B/c3C1pp6AvN46NTQZIyr45Yz45dZzcHAmPVObGhRhX1/249wjLzlaDwv///5DPDzRwLinHRWOFxF1dXU8Cgj111Hs2tT88L1cW1sjGBU/ODDOvbH+/PIdHB8FAADu28y1pp7MvLb759YOCAiXjox7ttdzEw7433KDd3Pz4Ni/r6QqY5pOSkvPIxr9+OXk4+JHaHz222SBvuDNy8vZJRv9/Pra2dmBv+CCveBAW2tjYmK2tbW1HxdRdYk4T13k0cbo2tXEIRjGxMTWxL5nZmanpaVMDApHPz4LBgYsBgaBbyl2r8+CFhAaBAT++uVMSkr77rBFOhfCwcHbJhtMboKBvuCBvuD35NP6+fgWEBDv28zZ2NhVe5Hu7u7988r544f44XwoU337+/nbJhzaJhzbJRrcJhvbJBxag5rbJhzdIhrcJhy+IRhxn7qUgS/gxEjBqD69pDyxmjlhAAAWAOME/2AcBAQEAAD65+D11k91dXXbJhz86NeBvuD///9vEeMlAAAA9XRSTlMA5fL99fwB+Brp/sbu7N0nVuPZyorg1sAhfmbeEwP2oe/Ex6y8LdQ71MTcs0DOmMLMv9DPwDbswl/OTsDZwMjD/HeoxPSR0NkH1MUO/EbA4/Vvy8rR8eEJhMK3x8Xs/r/o+sHYwcP11MO/x9rG9N7Oxdfnw8j1wNLmwcLX5u/D0vzAw8Dlw8LQ3fbBwPzV39bK/sD788XY/9bE77cx88Dd7b/C9sTZxNzA+9Hz4ufF5t/b+vfhqbrD4dHdysHM0OnB4ubFv9P4xMPux8zHycK/1qrH7s763PDUxcrRz9DW1+2NdUhgMdHMHubjtcjOwtfSwPvKy8SSBgIAAAyqSURBVGje7ZpnWFNZGoBTbrjclIUEEiAhg4ReQq9SDU060hUUaQoICqgUQSl2xIKMjr33uo7uOo46ztidGctUps9sc3v5MScEkh97zr0hJEhzhzz7h+95xJtw7nnv952vnXOh0aZlWqZlWqZlWowjeS4h4hCX2caaXkozoYkdxfCn1OD7VAcMIGF4mRmFa86gMwhGGZdgEFx6oO5ra0egE5ZlqvWUc13o64OrY25oamIKYgp8PYYfBxiKv/nUcmcyfK5pdBLjTLOluCzwithJpxJs6a3Rkxe4ibmdKc10Dg5GkbipBAcyYmo0we6VMfeuajRRmCXNmg3GErbnlNoaYAXC5z7uePALEcjPn02zGxMMHKcSbAoC+FG9/f2PMa6b3EbheCBv3tgqm00peMYb/Uj+/R9Xjo0Yhi19bJXnGAGc8/FJCB5nhUnHNgL4pOYZBNMU44LnGcPUP/S6cjycrEcmDvCw4oxRweVXL7tyfI/SPHkG2KWHjgxGpxvT1OVf5rhyAsKsabY2XC2GubXhq0Ekh4bAs4xh6v5+CC5CVcISNDQsbzhz+8igVo7EasEHjAHOQeAolKpD8OhBQ1lOcSU0Y4A/hs5lhRbR1D59cLBN4NOGkF+EhoYeHDxNRZkNzVimdjaFfYEFKxwSoxNbEbiVwwnbNjgYj7i8ZBfLQOOAgUUyzQl4PYDEJN+Dera+jcAJ9rExjHmeMwONAIZkM2AJNT7IApWDyxcODi4h5F9A8lK4wulfv695rxps7fOcIvAyipu7j9OZBixsnXlwjaOzGW3RIogsAwDiB/eEP3RIJ2v2l5r3eWLTqQDf0Hy3du7ctbuuzhDdUkNyoDPp1dGDoYKVUPWwEhRQrL0VEbz3u0l0d/VTIk6vCZOaeQYmT66vdBLneynibFJR55rPEngXrQ+uDZPjkU/UiGzNpPJGqIyzUrvGZ/B1FQTO+PZe+JckuzrYX9cVeqGEgysmLJlScw9dPmZYwrg1DYlzcIxQxDljTWooG4C9pGHIqbQBHZ0ev/chK6qEmf64nlL7W4KaLdlyqEvCQyboOCQGuZg37Cgu7FUIrO6CGZq0NSegokNGovfCFtcOe7EMuuE/69cj8D0qbZsl6LUJ4vHU9RpZfFgzdb9UsEqHyGcQ7uBy34oKZOx1fV4upjby70gf/Ne5b6vXx/elojs8DWoZa2xvl45SbhlOutXCI0mwehWI/UoviI/ssZhNyyPuUd6fs4crAzaBJp6zbEIww6lwe3OT0cH5o1V3C12/bAm+IcHtnaBvr467bmkCjB6x4ALFfda7NiZBmuc4eqvgkfcK1MNCHMgadbBuj2DLFQqqGktvXrpVBcCevetIbEMsMqFJQsxcEvxMc3KfQEzzGqtJ8RppZGvHOjo3YtSxFtrlt7AAILiDh0no2ZHfNPoBUB++p54Nez+2o+dM4gKZ4C6f/GFuNZFnyxoLzDQIK+ksPrDf+Xad/eiDybFi4bGiFzEaTc217poXjHY1HwDfkpKshb4gDUYMo3ItVcN+6r3gY0lzGbsv028WZqNWOeLRRpw/9lgbXG8zc5VofMJmAkaWstgNgCYRrwq7mEOCv/9+7hVmIM3slTl0mx4H/Q0S+iLCr26EpWXu2gsFHMOvHubO8MWaXgIR8GFV7gcsVvsqtjysvH+olHjD4Sb+uln4Mujb2aeEgEuQnyP00jF6GrY/zjPsIGWbD2PDnYVddo2mWyS08q3VXONgjTB1poGCWsJfJuerrwPWtVySWv79sos48gknisLraMti4FEti+RM7/k+5Ff2w+BZ5IPw7xuuMGezUplE+QgbpvjZDlh2MO/x8+d4DD0bV6ur8JcgSoZjIl62uhRwXCl1c97YFZDJRbXJ1s5P5ttWvCAgu2y1crVc3qJUykaa2gMphW1sttDnhi1QQjnF1HnXTLqV4B9w7seC5xfBcbVE0AQSjm74MRJ0qtsx36tU9ujNreHu9yPjzyEUTbD6TfhjSUAiuo4i57IcBiOgv2RH8/C6AGyNkpISUmcXlKqJC1qtcn8CTceZncfB0bdWrVoM0tRqETtgHxXG5etFqg5ybvttytCoysNwjuKV1FwdhlmBRkM+ZWEvBM46ruAwNbSlTJmF1hnlayd8HzV190kNXvoSXFczMt/i1BeCTz8t7QKEqNp1bm5/7lWhm2o3Gfj+rVBVb8IXzdPaAj8oK8ll0+sRtFmG0AWT9yKKu7LoA3gznQKbghoSfPLjnG6i8RYQ0JkJb23gHAWNbMACN29BF5jRrTnGT1H10GExNcc/UL4Z2lK8Gs6TBD1NNF+ZRJ6V6J+vGEaRe2XRfK2hlehi4X5HdMiQBy6i3NR7+Vn/PvebafDZeVj92Q0WWHsVoDNvqjuBBBfIiA6VqkcWQssTihKVS0TAW9mCVm0RWuvQV1pgfa/CAjYnLinWchOFImj0radwZB/8ChkyuzQ5F7IvtcvB9S7QdfZHvkhdyl51XA1jKtXaXNHRo1KpdtvTXGRRWeQUi0StylaCjyyehSxtcC5lPox1gzouWEJ6NLR3IvRupTI8iw5LYzJ2gwTn/NDv6nNLfRN0Xgcbzp5ld6k/ZVfBklWKlLGxgtyeHlGgtSCM8s+OMGS0JOTip+gRQsPTCinVdbD4jqSNt+F8uLar6VnKlYsJGAixOD8PpbcCbbvZ/10U9OQqdhrYf3YDuFSKCZ+gYsmFm9RAPxWSFfYmdjzSrUIJaONtlP18IxYT5qPUYWxObN9tMngBKIHatn5AjT+Ny1GytuDHUOBdl3e5danVTRgBjp7tBKV8BtWYRDKkNCkRRJIz50jFPujmMjxqobKkhAIThwNGHEkh97I3i0tavpwMeh+5zrugHMPRzoXmQZRRoXq5tzygE4JuAeD8ozPhBx2LlDQAFyTOmwQH8WdK3TcryeTRplQWLUSXSdnKihE7aHPMAeaIuKTTseuGcIcTlYvkKOEs6qM2nzasIgrc37u2DC1quwCw9sPdWhrFVb8EsJszE6aQ5Hfc53hlKQ2kOLtioWBEq2lGHv0eiD0TXjk0bKU8m478QlmroCoJ0z5srXaN1wZnIlIjE8B4qNJy1cdZSB3HFSpK50w6svUaHyvfMB9kyAXePC6WP3rP5SkJrz80RF7QQvrEsQTq9FJM7LQaKn3lBQJt0weT3PEhsFqAqliqO6WyqseN24YMlrimJAmFireD1HbMo23Lc0tZxwzMs0aiDTyHR1tk+2BS7M9dtksTLCFJT3iA16TjqrvY6Bkd3VRaeer+pm6i+T6K8Q7Uky1tzJy3vqdTeu/SedrUmod9eIIIvgJr8sUbtXL8ktaf+N8Mc9WXqJxOz9CCIz3kQ+RQwmPCs908G8aDQ++t23z6dlJ6gq4PTsXPDzTXkaWKmEfP/A2U30L5++eff/5rKJ999lm7uokqeV4ciruJHo8JslAuCpULmY4hE+/ZkkMcYL3oC09a6mA2ZJ+4nwcGBs6zUq2tYS454DT6jQoyPSRL4knw/o4M4gpByGR8n4L1fvHOk9gtJs+yS0fp+nT4Hniew/BX5IfwmyF4O5jUbjOVjrJIRkShSrhY8mijP6f7BT9IddRpEqfjBUupdV7z9YMd23ds2fkRn3EHgk8Qk9tT5/tBz3aLJO5GFpR9dL5OEiaMV3lLJj4Es01YX98A007xoYfsLQN6stNjku9tImCtyFxhxbEqC2AzRTV87x6O6Kn/xNy6++dqmekPYkFw8If64LrJntzZJrhl8DKCuG7Z2Pb7nKLIjMLMjB6e6USPW3d+47na2K2s2vTw8O163Dssl8keYJjRrTJVUZGbwM6BHQz33SIZtH2hePx75nD/NjCw40T413jB1o3v6iu8hT/59ywH5lltwoJS8I0DH2K7rchi6aYY/7CF0UxSmh+9u4Wy87sntp8n/+e9zgG8RXxPoUwlaL7Dc1NlEE8h+C5v3Oe2q3t7wFDuswGTJ6wjgOI1XixJuSmqDD/vwp0/F6a4CTM3IZUl4wWUKb5jBHfghNDWxVwsNn+tt3hmArIq+zF4VvzI3fASFi3OeBazkYzkDmxkvv77UhPzQjJrMgAzktR2dyZsiMZbZOctr4DvgP/hrU4+jOR4vxXxVndVKe+gxgD6V5BwnABkb38FPIClvj7YDpnWOxMpW5gJC+VdEbyi246dZvEh13r7r3/+5JPf/f6Pf/hTcojt64MdYaEIsiKtLEPgILTmkWNrMMufgv3ll74Gd4b27aHKYwpZMiTwc9TY3mUNGzsTExOpyS89e+UNdQNaSeGjFOJl9L8ekDr/aoTw4b8ixf/hDxnMaNMyLdMyLdMyLZOS/wIeLSEqFwEtMgAAAABJRU5ErkJggg=="

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2130 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2131 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2132 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2133 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2134 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2137 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2138 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2141 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2145 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAC/VBMVEVHcEwGAAAGAAEGAAEHAAAIAAAHAAEHAAIGAAAHAAAGAAEGAAEAAAAAAAAAAAAAAAAAAAAGAAEGAAEGAAEHAAEGAAEAAAAAAAAHAAAGAAEGAAAFAAIAAAAGAAEGAAIGAAEHAAEGAAIFAAAHAAAGAAAIAAAFAAAIAAAHAAIGAAAGAAEEAAAHAAAGAAEGAAELAAAHAAAGAAAGAAIFAAAGAAIGAAAHAAAJBAUGAAEFAAAGAAEcBAUHAQIGAAEGAAAAAAAGAAEFAAAGAAIHAAIGAAAGAAEFAAAGAAAGAAIGAAIGAAEJAAAGAAEGAAEIAAAGAAAFAAIKAAAGAAEFAAAGAAAGAAEHAgIIAQIHAQIMAQIGAAEFAAEHAAAHAAAFAAEFAAAGAAAGAAEGAAAAAAAOAQITAgRNDAs+CQkGAAInISIFAAAPCQrkJR8fGBktJCQFAAIWDw8HAAIGAALi0MmmGhYEAAAFAADlJSDNIBzQIhx+FBEHAACQFxNUDQvhJB+bGRUoBQZwEQ6ko6MwKysYExQSDAwkHBwOBwgNBQZ5bWoVAgQuBwdMSEi3t7ciBAWrHBg7CQkeBAUxBwhEQEDDHxpaDgzdIh9HCwslHx9XT00tJyc3Li3aycHVw71GPT2ik46snJiOgXyfGRYGAAHaIh68vLxlEA0FAACXlpaamZlgDwxkYmKgGhatrKwUDxBHQ0PUIR43CAihoKAgBAVaWFjWIx54ExAgGxyMi4u3HBm6HhpcDwydnJy5ubnNvbRpZmb55duIene1pqDn1s5XTEn759314tqUhYAaFBR1aGXi0Mvq2NJORELgzcihGha+Hhs9OTpIDAqkGhd/fHyzs7NyEQ4SAgJUDQuXGBUaBAQ8ODneJB+DFRJ4dXVsamqUk5OGFhNqEQ/HHxwfGhuIh4eDgYF3dXVqEQ7HHxsXEBDRwLa1p6JjWVbw3tinmZRoXFn55t+zpJ/ezMXRwLrt29XYxsBoXFlqADYYlv/mveAGAAHmJSC9vb365+D86N7VN/LUAAAA+XRSTlMAf/78SUTCm3hs+fYGAggBBOK48O3ZEAsV9YCSDsqI7+mhMiN8Hj9BmVrNOiay0BdLK6Q1lU5v4txm+Mvn1XYStTeonHvFaVGmhccb6/MhKIwZrC9VsN/h5d6uu0d1vl5X0lIU2dS/wIrEYNf9ycWP05ae6dE9Y/7o6sRzycD6zcbC5cLM1cnb3cLRxMD3yNTBysPA4L/1wMbAw8Lj4sDLzcbO0/T9wGrb3cDEz+zPwO7B4snB78PG09ncwN753cX8xNLsv/76x87C6/HA6M7dxcXVzfTD1r/LzL/3xsrG18jB5MfQzsnC49Ld08H2y8D90Obf8+O/iC+/3PXjAAAI8UlEQVRo3u3ad1gTaRoA8GFCDaQICRBpAeklKJ0sSHOlhrKwBEHKqodY0BNdV8WzK9a9s62KfZvb1133buttL7fF63de743r/Y93Ep6bSTKZyWTCzDfDA/cH7x95fGIyP75873zl/QbD5mIu5mIupim0swUvLpwluO3u2WpyTtIswUXBswRXVc8WnCfzAn4Sv1dzQyYcLu1rSXr17MDh/jLMBTLgcjmNDXTDhdn0e4tKRcLZ0wL7BVDdVkW++AeJ++7CzOmDQ4IRYMwaOTuw2iq7xRpJcH+MXLhSJQVepI+WC+doJcBp+nbZt1NOGDpcm9mMyYa71chwoz4Xw2LzOsvuiZUDRyHDIdTEEp+hVYV0T/m5qNqY7sCeRL98DR/s+KvR4IIO8iWIGroaUnx/KjfdAK7o6lV7w9Xo8NBW8mV59XLyXxm+888IrJhX6A1HIsMZG6nX4KUYtiTE12dSzeAReDAXzqtAhqP19Kq6YIWPj0SWATdGuXA0+u0U0+rKHutKH2mV5+UCXuoJJ+aiw+q4ZKrNsZVLfHxgCfCEYsADHmmTMHKpY0ytyYldRZ5vJmXMj09PT6yJiS/ng0FZyIZrGiVNEpH+W/2j2P1e1MdOp4g7Cr4297PgoBRp87HnnJHHcW4R3y7ja3RBLLXfc8Dp8uHoRJwLPE4QN0/yybq6umwnvKlZLlyr877+0RcGH99RBglUcO7oXtdPXbBAHqwJxsFnHHuUIIhVHm9ValxwTLYsWFMDU0XnFuJhjzdKKujk2igPjoGpQzHo0dXWFHdWb2yRA5cCUphSmNupdZEMONuA5CZGse7joXbpsCoOhS0P8Bgy42XAHQhsT5rGc5KoT5IMq+5DgIO483F9vmR4BcoPbYjkwPOlw/ciZdZSLlwlFY40I8GVHNgvSyq8Fu0eDlV7wsn3S4Xr0GDIYpLDsUpJpV9QYT0ivNTz68GUGaZBh6NwRLiAU4ZNc+9M0OD7EV3I8fz+aIBEeCsqHMf5w5t54ShBuBcVVvQtXsS/CWTBFcLlr3iQEDqdPnBTR7RvGLtHsBwdhIpaTtELT0VOocoX7D8iBHejwlbigWdO0aNdyYCGH1aXTDu8ilz4Edu/ZSFbfKATIDOLP6szhcoMeajw5whHfHkwFPC33rKCIl7LBz8ilNc1qPCDhCvOLAPzGydOKyA8yhtOjZO7vvSKL9Ewsb0JDthsr3RBoJoLq0xpggUJVPgpN0zsBXyfzbbPCnXusTrAOaJmCJ44NMahwrsZ+CEDvGSz2V5MAKqccmMxdcEwx2U3pQq4uV2gRIS3MzBxFPaTsO13eAS5PY9k1RWKNgrA6TDxLpprZLnEHniZgm3nuXOWWqiPdfDm26EILA66mx7wsAPeZza3cabpqQ/S1BA6OXkQAb4wDKtZ8A9hjQO2rQFOHSVo4dQtjoBLk+8jzEyb/whdLHgV/MgJvwJ6j+tW6MOExq0NH7wpHj40+YFSwbg/VsLTTvixLmAfq6h7BoS2axY48FGxaPjq5GUoY+AtAC86Yds4sKqD0Q1FwrVyHYDohXXX2x8eglMM/AUoc7m2p4EZMqIfWSFi6VMRXBmoEwkffH8MdNvYXbyGhp8AEzPhUTXZ0c558wSP4wfE93Lnq4x7BuCnNHwCT6CvFltCDqAt1Wqs0SR0nKYJFzc9nL2zcxcrp8+B7qs0bGsCegJu7yFf8qnjnYwhoSa3GcVMxOsJj9jV5BwwnVEM9BJwQZxjs19agTUHCvZ0qnCC6c54usRXAH+Sgccgn95vW6mVQUu6Fos2CefYgELANX+d465fRs3G7ljnhrGRDvp0ulJMYW9qOeFhjkvsAPitB1xFX6qlM9c1BYk5042dcg9l/QbX3WWF51gu2cfMSnptJtXfqt4GMcfx5B7qpC9bsfpRL/cswG/YcBM0slKmIXxopDNR1EntDTCv33KUH36G3bW/2v3L1XdZyY55me2ewHEt+3Ithf4ijy0LHAvmLce4tTZdopI9E+51/3/TPjb8BEg9EK6EPc511M7V9C+Od/XMD9Bi9WBmljtUSTPh4Jrnf/bzE2z3u89zt68IhYFB17V/ApCRnZTf3uxKjcgIuMOCDzxr48Rj3zlP/g6lEuFQ2Ou+P+M0nH3d993wLfg1h33ym45N3L0qaa4aYCc9IAHn4ZA0wLcxcNfxNxj12QvrXP0yX2KDcwG+SN+f3Ge8wizwPRp+0DGaPDd++vhLx0/vH2ZGWqlwNsBr9IDktTINhGPs5OINqXAKwKuuyd17StlEbxGpJTwdmX5F/X3y4UjXT70boJBncLE84IIPuyXqYLKaA6uGrCV1VUhwmCu57gK9d3qmAtDZxZx/1VNPJnDgEMc/R6IQ4AXO/edruGP/5Z159KjJbDuSqRIL61wmLjOzxAK615cBmFaKh7PIqeDo4O49YOSZUbQ4/MLpbmMk6gm0RO8k27H+Dg59GtFwL7gGYd4jXQs9uvyAEZZTpVtvuOwm8Xt2pVUgtMZ1771zkVrZ5/D9TPPgdSf8FCNQFb1a3iI+2YRa8YXFI3YyLl2/gluSvbPrPjjHGj+cfarhLbI71zF3i0wvVT1efNvujGsT0Or9qAnceohy/2CGclZSY1gr2zTFdDSrWgL6+7PEdnENjP/byf7l0J8vF+u9PkBmr+HkubMvNIGxzercnzuneW26o6CgNOUFL0d/fiYXH//kyiefUm0+wjSGNaoVuQsligCsudsC0Oeuo67Mz8qW+MgOFqs0Gs7b91+1/82+wdIRzK2bLFVC6MV3P94wUXxwTOHovIoobHpioQk+uo7fvvZ5+7oGnnLF2J8+dCXAEfH3ibjIgM8MY/avHbYbeZ43ylQeOjzuhP8qeZ3hq9pFblSHPwbLOzjPo7SN1YYIgxN+rzMie3rlXH9yw0ju3Mr58yRIaf+n3b7Z/um/Isq10ytj6rW1YStGfSzBc4z2i//ZPGwfv3oEFmIzGOUTfy+7fllx+4JiYmZh0+F/wJVL8Nl/oSldNZPwKOig+BqYxyLCsBkNVXzDkBlwvaEUm/lo90vF5mIu/g/jf4vFaVOjZONrAAAAAElFTkSuQmCC"

/***/ }),
/* 2146 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2149 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2150 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAC6FBMVEVHcEwjIyMCAQEAAAAAAAAAAAABAAACAQEAAAABAAAAAAABAAAAAAAqKSkAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAABkZGQAAAAAAAAAAAACAgIBAAAcHBwODg4uLi4AAAAAAAAJBQQzMTAIBQUAAADbJx0AAAAAAAAAAAAAAAA/OzkAAAAAAAAfBQQVFRUEBARKSkoRERECAAAAAAAAAADZJRwAAABSUlIXBAMvCAUAAABGDAg1NTUAAAAAAABNDQlBQUF0dHQAAABvb28AAAD63t0AAABGRkYAAADXJRtxcXERAwIVExMAAAAHAwPvmZQJCQkZGBcBAQGxHhYAAAANDQ0AAABtbW3RJBv55t9zc3MAAAAAAAAAAAAHBwf///9ZWVnFIhkjISAAAAA5CQclBgQAAADcKR8AAABeXl4AAAB+FhHzs6/249xhYWFmEQz////9+vrKIhrk08wAAADhSUH+/v4BAQFZU1F5b2yXGhQBAQHdLCJvFA4EBAT3z8zvoJv+9/cAAACdGxQAAACOGBLgPjUPDg3wqaX//f1ra2s+CwcIAQHVJRtJREI7Ozu9IBjmaGIAAAAoJSVWVlbdMilZEAvg4ODhRDtoaGgdHBz2xcJSS0rCs66kHBTQIxpUDwu5IBjpfHX//f341dPocGrRwbveLyT77+6HFxFeEAx/FhClmZSqnZmtHRYMCwvOIxllX1z53Nr++vrlXFT74+ECAgLqgXv+9PT77OveOC50FA/n1s8kBgXKu7V+dHFtZWHZJhvfz8mdko3cy8TodG6Ee3ahoaFoaGiSh4P//v6Tk5PjUknsi4b0vLj99PSmHRXBIhh2dnaFhYW8rqnBIRjw3tecGxTXJRvskIq0pqDt29Wwo557e3s6CgdkYV/IIxnBIRgrBwbBIRgVExOWi4e1HxegHBT//PyzpqD98vAQAFUH5yAADhbeFSEVLo3//wB1AODbJhx1dXUAAAD65+D///9GSdl+AAAA7HRSTlMAwOIUCvrt5f3nAvP1waCq6wQrgvjYDuOlGTHc3sHJwFnF08LWB/7AybRuwIvTyMPXysbvUEH8RtHKwl6/wmfxv8b9O/QdxgHIJvr3z86U3cLPy8/chs9y8fT++zh3Vdr41urHY8HEmvw03CPHv/vfwvzm7u1J3/WwwMLPufnD4cLB2Y/Se8vp08Ds7b7Z+MDD5NAgxdTzwObk6cjAv9fW1cDhyejDzOD20MnDwM3PwtfxwMTf1si+x9XO7sXu39zDwevpy+XJxMrBxvDH28XA2M/kwsTW5/TA5MPS89HC07vN5dvJucjEv+fR07txX54AAAodSURBVBgZ7cFlQFTpGgDgd7phaIYaQDqkmwGUlhQFFVRQFBMV7Byxa7Gxe+2uXWPD7XC7e/f29d6f7/ed8/eeIVap4QB73PuD54EhQ4YMkbrlwp8irWKMFP4Eznoqo5pw13GZdvBcefvF44Tdm07VqTTBIdnw/NhmYLvTC5IcgyZlw/Mh1Y7Fp27OHe74cooUnoPYEuxs4eVIedheEJxNKnZzYrjW1g2EZRdzAnswdbo2eBYIKUERgD1amKpxzQbhzJiOvZlapw2TgEDUqg3Yu7FJGgcJCCJTH4/WbCjU2GSCANYnYx/GTk932mgPfzSPTdinCXOHaz3WJ0jhD+SW3ox8TLiUbJb5OCyWwB/EoQ55O70m+QWleNnGBAkMXvhc7JcJKzOGe8jkgXNgcPK1E7D/mjco58DgTBqOAzE3HAYp6BUciDoHGByDbCEOwKh0NxickCTkBDRdvH0O+2GTBwxS4ALk1LOffcbmfBKAfCWHweBIZFMRcebjnAC8za5D3NyCfMSrMmFwphUiZzPbhNjE1re8xLIXz7Vgnzao1MCLOi7Mdtn6BDV0FXwAOQHbPjt0aB275GjN1k8a2W0zN29G66bPAF5inWgrp0zozNlxN1q8u41l2XXYeBbxHpuDRxtK6z/GVgHYE/Ni4EFqQzsoJ0En3pFosba+5cxZth633UYsZe8FNNac3VZz98zHiFi67hB2MzbdH/rmHEifEeamhqdsM9DiB/b2J3caDuHahrWfLl164S57FLeyT+6wWxEfbJuJ3aS6Qt+cg2hnqhA7aOevGYut9uTceVKKeOHTbSybg0fZu5jTsGTm0nX4sOGlh9jNC5OhT+pg2o2tHbSJ9cCuNh89F9DYGHBh6UU8xOZgKcuyD5ZgZ6cdncE6N5twJ9oDB2hjswN7sLqpFO+xTbiVvYcP2K177txHvPDxBeTMXIKcA8Fg3TQZ7ZmjBCzs5CewF+cubsb7Sy88bLiPWM8+3POYrTnagriHLUVE32lgVb4j7U0aWMQpArB3Fy7exlL2NmJOTcuLD/bUszVbcS27BHGqTAJWldNe2YBF8XS0KgDXskubtjacPcceQrzPnpn54jpEXBAI1gXT3y349/Xr17+7cvk12iYIOLmKldiXzUef1OS0vMvexdWNj1fvYesRMSkErHOlHX6Nx3Zv/v3Ka5TScOBM1McjDwGILY1PPv0vexvXsksQbzpmg3XTaDvtX07+5eTJN7HdySsavRQAwpKRryU5j2vYM/jDWUR8ZQz0wT+IttOKlZTSmF/X/Ot7tHhTmQ0A7puwH0rXrS6teRcRh2+EvjjbyCgV/+O3d5idJcv3yUI/DN0ie+3KScTvqQTAPr0Z+6ep4Qxis9Ye+ubmd77yHV167YfMf44cX1FbtOLbMkr/9t11WgzgUIf9tRoRLzkBD4YbDGfRo+MMw+wrCn17HnOLWvhq7CF8Lg5EXTnwIDUzXVyjFit3rDLQpIxLu7G/RsknAg/e2kpm3pb0a8yK1xnmWvWwSuY4tUi9KU8rO7IqXCZPyth0E/thpTgX+qb2qH6d+UlD3/jJbx7DhFLZt8x5ynFUxF+WvX9ECv6z0mzclSXJcxciT9OLgQfDltBHDHP+auWxYwzDvLr8KsMcp/RDc6THpVHmg7bQxhC7fozML2Ms8hCgiAMe7MxvmBjOIvlbDPPoLYbzulxeeUs/KWnhvq9S4CmJt6um5NRU7MsJuR3w4a03M5yrsqK3mUVlXzOc92qZUKXBMeOrI2nQiTQ2WFu3G61LtQF+DEFfM5x33nubYebNYximski3U0ElttqDCnc1dLG3WJPajNaUxAJP3jqm3atXGc4bY2jqVMe9i8s+WuDhDd3Y+5R8jr0bq5UCT3ZO5xnm1dCiimp5LcMwPzvl03jU20/+Ujd1wZhc6EY9TrOjGXuTsQx4m1xUyTBM5aJFDOe4PLiYvrJSNdH1YCE2qxKgB/k+JRuwF34pwJ/rMabDNZXWNMwo8vKQF72v3I0Zy6An6nHpdV9gT76ROQN/0qCd8xiLecsj50cbiUXUByZ5XfNpmQF6ZLBJT72J3V1eBf3grVBWv7eIWbTCLDPud1EcJsQUGaPzyvIsHOWbBr2YtSrm1ATsqjAN+EuLPGyi+hK9I435cnmRu6epIFp75NaRCEKi15xaBb3KDIzZ8VfsZKHMALxNjtxOiG964weaNcklB38TjYgw3jLVLtdpqsiIQv0ksGKirbZuZTw+tcYHeMtWuBBCEqm4VjzqwI0bYpfESK+3bhRVDKMuxKgMAeuyy1WKHZ9jh6RJwNsME7GIVCw1++o/+io6y91RX0v/+eMKZZaL2Bv6pI6bEaOoW/MFciZo5wBfakUBIbPziIl+qTnwwi9FidEihesWXe3OLRUicSzw4h/nEOioKEw+kBoOvBn8CCGHfaMTlbJCXOBebRpdVW0/JrQstFofJgH+pJkpDq5BacCbnXgkIWTkMLOMJjd/Q3d5GsnoOO8YszjFH4TluotYVI2IlqcXyhKniKuiVaFbVMtggOzsgJ/F2ijSZuSUKF2FWKvQis0mx2AYINc44Kfcy9czizzjsHLnz8vLyubAQPgXlwNPPruqdArjePK7/foV+1TLjyVAv9nnp9gkAE9S2XxCtotUEXlZpI2LSnSsIrRCAv1m8I7LBZDEAh8JMcQi2std4RdhTHTZPjKr+sdH+8xhMECSwMXAR3kFsXAxjSezR4hkVCzXK5XmYT6zYEBiHXwWAy/BIvKMxChCiHxnSYo/DIzBDXjyyCNdjJcdXAaCkypdCKfANJ90mFL2URoIbpZ2JOEME1UQzhRjASEjftEZQHCTI4nF7AoT4YwW7SIk4uAqEF6IF3nGLi8XUlD2/jgQXrkn6SLqA9NeEN6MCBfSLms/schTvQzCk/r4uutHi0KnFBASMZpYjLBRg+AkQSJCCqbs8hwtj/RyV5mMRpHINwUEt9dpGOngkndYJ9IZTcZ0KQjN3mME6c7PDQQ2UZFIfldFOhgdQFiZiv2kw+wIvRdpNz8cBDVRsZ+0Gx/hkeYcbCTt3PNBQPbiRNIuT7zRDkBiTiRtRCEgnGyPKNJmpChyFljEmQtIqyhbEIx0zC7SJsvLVgptwkSk1XYnEEqurYi0Ge9brIZ2zmIXYlGlAqGM8xpJWo33mwRPhXgSiymBIBB78XbSKstvIzxDIiYWonEgDLVPFGlVVbEenmUnJxbu+SCMadGkTYRNLjxLqiKc+eEgDLXTbNLKGOgPncyJJBxjOQhjcjRpFeUkgc4SognHzw2E4RpFLFwU9tDFOB0hZL4TCMRpNuFU+aZAV655hBCdAwjDXkndPfPG62ygmyDz6GhPcT4Iw5ZaKN2doZvJ1MIZBGGvpBzlDAn0wJZyJoIgbCnHxw165B9IKZ0GQlCrKBV750Iv/IuVNAwEMcfHQQpWOLsZYMiQIUP+T/wPS+Qp5IaNjI0AAAAASUVORK5CYII="

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2156 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2158 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2159 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAABgCAMAAADhP0YWAAAC61BMVEVHcEwGBQUCAgIEBAUAAAADAgIAAAAAAAABAQEBAQEGBQX///+BvuB+u9wyMjIDAgOBvuAAAAAAAAAAAAANEBGBvd8HBwcAAAB1dXWBvuA5ODgAAAAGBQVllK8OFRn65+CBvuA/Pj4AAABLboIAAACBvuDIurQAAAAAAAAQDw+BvuBCYXM0MTBgYGAOAABPS0mBvuAdJycdKzMJDA0bHB0AAAAAAAAAAABEQ0OBv+GBvuH///9GaHtzamfo19D++PgtQ05fjKUAAADkARMAAAAqKikAAAAAAAAAAAAAAAAdHR18uNjVxL4mOEJyqcd0dHQZGBh0dHRKR0dNTU0AAABsbGwAAACoqKiCAAlZWVl6enr55+CuAA1xcXGXl5fhABKnmpYZJSv+8/QVICZ6tNTzho9pZWM9WmuFweCBveHydX9FAAUAAABBPDoAAAAHCgwAAACMgX6cj4sZFxYdAANycnLFABAiMTpjAwghHx93sM/1mqHs2tRQUFD//Pz35d755t/p2NHoGysSEhK6rKf5+fklAAPz8/Px3tjW1tY8AAXnCBr95ebi1M5rnLg4VGPMw8DsOUdZg5oVFRXt29RdXV0ZGRkjIyNkXVrnESKDeXX//v6Av+Hf39+Li4vOAA8AAAA1T173rrRUAAcxMC/HurZzBAnbysPqLTz4vMHbysTvVmKTiISAvuCCvuB3f4H24tyCvuH+7e53goiBvOCfAAxxcXExAATYABFmY2JVVVVbWFa5q6VVfZPz4dp8cm/82dtNDQqBv+B2fYH6zdGBv+F4FQ91dneBvd+QAApwpsTs7OztRlPpIjLwZHD6wMSmpqbj0sssBwasHRaYGxOzs7N5g4piYmJUWl+fzudmcnt1rcxtoL1OdInw3ti5AA7d5+3XJhvHIxnPIxrbJhx2gIRXYGMhISF3g4hhj6kbAAPn8vkTExMhMDd3k6FYDwsAAP/lvv8AAADlABKBvuD////65+B1dXXbJhx4nSwXAAAA8HRSTlMA8Ond+OTw/fT71vzO+8bg7wYNUc/82sz7/sMb+NnL/NHCQMeQ3sNsSuzZxNrE0c/lA8LTx7yZFMHU9fTFw9HdwNR4/WTJgbM4xtX3xsDq9cvtwMBa0J/NxsLC8tXbx/rKw9bF9MLIwhEixb+r1IcxIsLF6sji5MDB5O/A88Dn6ffw6eLU+cX12eDA98vL2sHc2M/e1cPZ0cjwwu1D5sXqJ8S/vsHaw+XewMjNwpq7YOIz0XtZ0MLC8sPA0cDN3sPGzKpww8bCVIjK5e/T5cnBvuzcw7/QkuGDwzvr4tD23M3jzNT4mZi/knbJ24ZmtslCHF3AAAAL8UlEQVRo3u2aaVQUVxbH093VXdUNNIRNNkF2URZlE0VAkUUWCasiCAIKGVk0gqjEgIpbNG5xFxONu4mOo84kRoxGE2OWyW72yTrJ7Ns5r1915ePcV1W9d3W3c3A+zHA5p6rX96t73//e+141Dz00aqM2aqP2/2CTgx/+r7EiCjoL0314nneuHFFzg8nDZemdSyMe5EVMKUJq/xQZUvgER6SrUGpdOKOKnTy5gJZpKKTMm/yguA8XMUc3sazbPA1CiNHuZln22XKUqEHaLeyWeb5ozHMPCLyUnse6AQ3QdfO2sII1loc2io+UiikPhDtbPcw6tK2qwgcSaI1ik2MwexT5PIDciUXzWGdWLvceeUXL8p1y2a1U1IiDo6hnnYPZKuqxEeY+RmW4wGW3yDtHGDyX+a05wO3TcF9PlSL1qLXeXkKzR9Zhdb85tk6JRFMNW6I3KYpG1mGVmcO7/ZGZ+e+2IDeiaucVYfbDLjs83yyaFLIwxjLNfD2djuqTm5brGjrd5LBbOLI2qtEcfBrlujBidacr5ClUpZGbj2yNlqfWbTGS81WulGyfAhc+VGDK4SAkYbKjrlWR2KhqwdfOYKdcb9kpU7ZIm1H3GWofn9iCpVHp6elRBbHVERaEKc/lpfEZN975jMTSW8l4zzbW1akdgFGdCK5EamXiis1XO7Zdvbo5UaFCqrRc81btXUjIk/OctgdFKglgOY2cGCNOiGb1LJ25raztSKTH5JnU5J3mUi/xQf/83q2RQs5NqKpb6O90NnbspNxzvGnp5lIvGZOC8U7GBS5S8VVsHjNLZ8cWnqSijKuyQheEH4GmY7wIuWSfEvD+RJ19W6BMM/AiXFgxFMo9cAnjGvgaAad2SIB1xxIVrq8Hn6NnYDzTNS7i007+thRYt3CzKs9VcDr1O4xvSIB6euDQFWJ8Hvrl39it6JhO2mqZQteWCt7MIgzasmUmATM+G1Isvj7eBMZ+Xx5VwvhPHZYir1xBRQW7AI5FYwHsJ7fGZi+HQz0cutbq24wv+8JnV22G4U8MPCXp9IuJ6kIfp4nsD7kEdtwKq38FoVfD9tEoa51e32TmMcYpq2Hw59nMIwMtd56WkPc2pVpTGOE4lyJ5sEeoqRUd2qfXl9I9Mfr6+J5SPVip8b1mjEuoBTB0TmYO2XO4vS+Qnm551xI9a8EZT4ftqVDpwYPx4mSxCWU9CaiY+Jh1+rBDF+oJV3/TCCYJQC0EEHuHTHQrmwOn98jzIzZFReNI38Ekl0TbmYzih2IIKiw7mxxjntSLFmcAPwqTkshHenvr07N07WyLTneOzRwYYNk771uh5eMdbdOox41gXIaA9NHG3U8ItPowA1d/yACeCTVuGwRyIBMCnXmlhf0ACK3CTo9tec8ipellDrZL8mYTFy9GMLlNsEWVp57meeuzTpWXV+7WE6Xxpi7BWFmr051nTwy23gE32fOA2H7kcCbbAvAWi7RCDsp1NXHBaH5oB8GdzTrlm8GDU0grVFTq9fsMC04SlpWQTCwv51Y28yly/OBdlj3ntr293SKpKAeRLtJgc5PF6C1s3fr1QtjXmkQdKYdB17BXTrSf091hb4H3bm7vnWBzDlv6CyVMIc1dRsRiZindAAmSUf5wziJOb8zK2kjAYeIaAdrYnBUw6OHtZE4HMtl23WAm65ZzhL1ynhe4ma1Oc1CmmcUW4ORDALlQrvHt1q+XAXE96VnkYvRCtaahqvue5IcdbL91BOR1GBIpZ80Ary0r8La5Dsp0sgUX7+ozRrlSwaure4j3mIB7aAQT48G8KBQIyOL27a3w6P1BiPxA63b2ik73wYl3jZV0xVInZdrMItFakfsRc818suvB3ZgdFFznWPXLthWy3W0NSOx5kt4Q91trBsmLibEOlzzmNlaGSkVSEENU1SRmtP4SgC/p28DjRzX2ajP4f37gHNF5C78peB78VkquQWajiRbcxb5JXUMC6CxVvh5OpzVNIvmFPpiFC0qMm69KNiWhcJ1bcwUy+pZulnqZ9H7JXFoezTRKGuoRqtVZGVKnAvq00hDxviF9WDw0RcUZnVMbXJPDDh5Dwa5Ja4aspwkklC1wvl0enn8Wzk98Kzzfh0ovtdF78OPoO50rdli3gJK6D5hnLq1AD9UrTx5qi0dZoodPnLWoJGQNooKZuaFaeXKFp1Lu/9eO2pcdoms9XZPWTNR3s610CFG8rjeWezatMwMvV0XuiiTtZIaaTpkzPfKbXcm+KjrxjAP26iLJqmUhrUj1jqTsF2L60HIC6taokfK0kRsjrhYwDvXdSYp6oBeIYk+yktosueDc1ikprRJLj9dm3Sy9AKLim3AYc/djjaEt7qDmGGZEdoM/e40Tnu4JpTW1drcVus1RrlUtD1XpzZi1VFYS6iIxDkP37qHdIlfWHGhYKyChfU9yN3zv61WM5xl7aKn6kWddtVIP6bP1SXFtr6h5fSn+9SMSqmVpiLrZkHcTFcJ5QrTpi4+vojQv2oKl6scYy4aI8fQQWPRcorouDaHlEONXkYz6iLjeTWe0IfkNsYssEs7jvMy/+s4iesVK62pCzZaQ1i4rcIkKmnE3pPELiLoO0m6qJFVrH+RRb0BcPiX0T43YRt2xl2WxVTInF1ruoiTqR5T5Wkuw5i6AkurIjFXIuonEwnZcp1EI6uUqtTUMyYEStTg/U+HPwh5FSLPAYmVNT7a/1lpkzcV7YKlHdPVqCvY47ol64rvikHr+jhh1ANdLVbQxsEjaw4hr4WjsbvllD6UmitpmltZvKyXuAeyxAbsr+BQupSNxIPab2YxQn4z60K1xA8dxB+dz/crFeIavYXUWGI2tXR4/WyNfvdBJ/Sj09LMBTzgeF0ZqhZizqxATD3dikpIOAnj/AS6guBmnGvIZe3lZfdvDswhutasUtSK6o9PZMt5oXmWkQ8SoxJz1RwcRug33UrUAfoRp4BpCxsoNBQxPwl62LsOtpgKVvGOldP3Ipd+x5Qb6aS7Uwx5RVsaLnJZXIfTDD7Qso6IqP059jePC/VGZMTx4nB2XSWGqTqM1HQsWJtq9yaUItXV4Ki6jQtSo76X9fKLtpIv3I3TvTFzbcK98Q80j4HYvpTR+epy1uqC4IHHLEpybRjFUtYMdoqW28ATqw++PZOZ8KP+a1JO4/IQ42W11XVIC17tBGwBgLjzU/NPYxuUxpqyJiLW3P54r87AFQ/AUSfFxzN78AyChEkVx/vxi9e27VFwNx1Uw+wm4QV1mio8XlnRZelW7CtvRFnb3zWiogPFr4C7QKqTVDmvR6p8+hvrBDW8goYasMmoyGgd6OXLZtf5AGhwMM25GED88t/ebmTJtUJBWi+7+/CMVwDUwNcIbCZ6GNjUt0Lp2ueBykb8dh0Gk0WPl/FRy/aGK+RnhbbAp/uTn3++FDM4QuJBVxj3eNFt1OXP5MXQc29MWjKXgPQuooA9y4ZXzVf0AvpfP9e+FQF//E3krf44pkSfg+3S5wCQRM4sGLp4jxro4gQuqCj/wSNztn+9WCoEOQmSaE/xNWrRVF/ZTOHLZXhLjwGngA2wlBBFVhnPa/oCDWm3ITx8nHKgiLyWh63CsoMuMUxPodX8u201iQiWh0yTw4IYETlvFVWzYgD5B+Qf4if8c8RN9YKJpaqben8tzLRd5Jm2RGjhxb4CoIwBzDTLoxlQD/zyAPkVOGYtMX3C3M850yd95vVXJ2D7YnddlgggOIgGugf14v/iCMpUcr8mNmrCnLgcuW971MNOWELnpYqnggirJsQoVG0IwxpccK9A7hnSypy4HLqcpsH1tkWkmK3ahLCeE8FMaMNwrcrlUT6G4RBoT2Z66JF2224l5hwP9xL1qcQ1XkSFLCecs7ZSav6KgOSY5Tr0Pl4OX/uWtt976Jdhrr7128eLFN9zd3aOjo9+YNMkwYx675AwVWjZDawXOQJ+T03CoMZHtqstJLkvYL8CWLFmy7KvLz/zj71+9+eabvwJ7/fXXfw32BfXFnz/77A9/1FyEa50K1zpt2ji/+5rl//ifJixOxt+shGtdcvny5WfAfgO2dKR/zHf1vytG/zlr1Ebtf87+DQ3ZlqZbQvMJAAAAAElFTkSuQmCC"

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2162);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../shared/rnclient/node_modules/css-loader/index.js?importLoaders=1!../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js!../../../../../../shared/rnclient/node_modules/extract-text-webpack-plugin/loader.js??ref--12-0!../../../../../../shared/rnclient/node_modules/style-loader/index.js!../../../../../../shared/rnclient/node_modules/css-loader/index.js?sourceMap&localIdentName=[local]___[hash:base64:5]!../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js?outputStyle=expanded!./stamps.scss", function() {
			var newContent = require("!!../../../../../../shared/rnclient/node_modules/css-loader/index.js?importLoaders=1!../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js!../../../../../../shared/rnclient/node_modules/extract-text-webpack-plugin/loader.js??ref--12-0!../../../../../../shared/rnclient/node_modules/style-loader/index.js!../../../../../../shared/rnclient/node_modules/css-loader/index.js?sourceMap&localIdentName=[local]___[hash:base64:5]!../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js?outputStyle=expanded!./stamps.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2164);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./stamp-palette.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./stamp-palette.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".stamp-palette--nomal--3lrHorcn {\n  display: inline;\n  cursor: pointer;\n}\n\n.stamp-palette--selected--3sSBuOJB {\n  display: inline;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n          filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n  cursor: pointer;\n}\n\n.stamp-palette--label--OnJmC02U {\n  padding: 30px 12px;\n}\n\n.stamp-palette--gambaIcon--yf0tWWC5 {\n  background-image:url(" + __webpack_require__(501) + ");\n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 0.3;\n}\n\n.stamp-palette--activeGambaIcon--2VlPNdEz {\n  background-image:url(" + __webpack_require__(501) + ");\n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 1;\n  display: inline;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n          filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n}\n\n.stamp-palette--hankoIcon--33cl7VTu {\n  background-image:url(" + __webpack_require__(500) + "); \n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 0.3;\n}\n\n.stamp-palette--activeHankoIcon--VYwmvt96 {\n  background-image:url(" + __webpack_require__(500) + "); \n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 1;\n  display: inline;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n          filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n}\n\n.stamp-palette--animalIcon--2jryDTJF {\n  background-image:url(" + __webpack_require__(499) + ");\n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 0.3;\n}\n\n.stamp-palette--activeAnimalIcon--2A9Zzoqw {\n  background-image:url(" + __webpack_require__(499) + ");\n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 1;\n  display: inline;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n          filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n}\n\n@media screen and (max-width: 600px) {\n  [class*=\"dialog\"],\n  [class*=\"dialog\"] > div,\n  [class*=\"scrollable\"],\n  [class*=\"tabs\"],\n  [class*=\"stampGrid\"] {\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box !important;\n    overflow-x: hidden !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  [class*=\"dialog\"] {\n    left: 0 !important;\n  }\n\n  [class*=\"stampGrid\"] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    gap: 5px;\n    padding: 10px 5px !important;\n  }\n\n  .stamp-palette--nomal--3lrHorcn,\n  .stamp-palette--selected--3sSBuOJB {\n    width: 30%;\n    margin: 0;\n    padding: 5px;\n    display: inline-block;\n    text-align: center;\n    box-sizing: border-box;\n    cursor: pointer;\n  }\n\n  .stamp-palette--selected--3sSBuOJB {\n    filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n    -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n            filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n  }\n\n  .stamp-palette--stamp--zBI14vre {\n    width: 40px !important;\n    height: 40px !important;\n    display: block !important;\n    margin: 0 auto !important;\n    background-size: contain !important;\n  }\n\n  .stamp-palette--label--OnJmC02U {\n    padding: 8px 6px;\n    min-height: 70px;\n    box-sizing: border-box;\n  }\n\n  .stamp-palette--gambaIcon--yf0tWWC5, .stamp-palette--hankoIcon--33cl7VTu, .stamp-palette--animalIcon--2jryDTJF,\n  .stamp-palette--activeGambaIcon--2VlPNdEz, .stamp-palette--activeHankoIcon--VYwmvt96, .stamp-palette--activeAnimalIcon--2A9Zzoqw {\n    background-size: 45px auto;\n    height: 65px;\n    background-position: center center;\n  }\n\n  .stamp-palette--gambaIcon--yf0tWWC5, .stamp-palette--hankoIcon--33cl7VTu, .stamp-palette--animalIcon--2jryDTJF {\n    opacity: 0.3;\n  }\n\n  .stamp-palette--activeGambaIcon--2VlPNdEz, .stamp-palette--activeHankoIcon--VYwmvt96, .stamp-palette--activeAnimalIcon--2A9Zzoqw {\n    opacity: 1;\n    display: inline;\n    filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n    -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n            filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n  }\n}", "", {"version":3,"sources":["/./src/web/components/themes/stamp-palette.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;CACjB;;AAED;EACE,gBAAgB;EAChB,8XAA8X;EAC9X,0DAA0D;UAClD,kDAAkD;EAC1D,gBAAgB;CACjB;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,+CAAoE;EACpE,8BAA8B;EAC9B,mCAAmC;EACnC,yBAAyB;EACzB,aAAa;CACd;;AAED;EACE,+CAAoE;EACpE,8BAA8B;EAC9B,mCAAmC;EACnC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,8XAA8X;EAC9X,0DAA0D;UAClD,kDAAkD;CAC3D;;AAED;EACE,+CAAuE;EACvE,8BAA8B;EAC9B,mCAAmC;EACnC,yBAAyB;EACzB,aAAa;CACd;;AAED;EACE,+CAAuE;EACvE,8BAA8B;EAC9B,mCAAmC;EACnC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,8XAA8X;EAC9X,0DAA0D;UAClD,kDAAkD;CAC3D;;AAED;EACE,+CAAsE;EACtE,8BAA8B;EAC9B,mCAAmC;EACnC,yBAAyB;EACzB,aAAa;CACd;;AAED;EACE,+CAAsE;EACtE,8BAA8B;EAC9B,mCAAmC;EACnC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,8XAA8X;EAC9X,0DAA0D;UAClD,kDAAkD;CAC3D;;AAED;EACE;;;;;IAKE,uBAAuB;IACvB,2BAA2B;IAC3B,kCAAkC;IAClC,8BAA8B;IAC9B,qBAAqB;IACrB,sBAAsB;GACvB;;EAED;IACE,mBAAmB;GACpB;;EAED;IACE,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,oBAAoB;QAChB,gBAAgB;IACpB,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;IAChC,SAAS;IACT,6BAA6B;GAC9B;;EAED;;IAEE,WAAW;IACX,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;GACjB;;EAED;IACE,8XAA8X;IAC9X,0DAA0D;YAClD,kDAAkD;GAC3D;;EAED;IACE,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;GACrC;;EAED;IACE,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;GACxB;;EAED;;IAEE,2BAA2B;IAC3B,aAAa;IACb,mCAAmC;GACpC;;EAED;IACE,aAAa;GACd;;EAED;IACE,WAAW;IACX,gBAAgB;IAChB,8XAA8X;IAC9X,0DAA0D;YAClD,kDAAkD;GAC3D;CACF","file":"stamp-palette.css","sourcesContent":[".nomal {\n  display: inline;\n  cursor: pointer;\n}\n\n.selected {\n  display: inline;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n          filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n  cursor: pointer;\n}\n\n.label {\n  padding: 30px 12px;\n}\n\n.gambaIcon {\n  background-image:url(../../../assets/stamps/gamba-kun-arigatou.png);\n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 0.3;\n}\n\n.activeGambaIcon {\n  background-image:url(../../../assets/stamps/gamba-kun-arigatou.png);\n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 1;\n  display: inline;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n          filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n}\n\n.hankoIcon {\n  background-image:url(../../../assets/stamps/hanko-yokudekimashita.png); \n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 0.3;\n}\n\n.activeHankoIcon {\n  background-image:url(../../../assets/stamps/hanko-yokudekimashita.png); \n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 1;\n  display: inline;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n          filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n}\n\n.animalIcon {\n  background-image:url(../../../assets/stamps/animal-dog-fist-pump.png);\n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 0.3;\n}\n\n.activeAnimalIcon {\n  background-image:url(../../../assets/stamps/animal-dog-fist-pump.png);\n  background-repeat:  no-repeat;\n  background-position: center center;\n  background-size: contain;\n  opacity: 1;\n  display: inline;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n          filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n}\n\n@media screen and (max-width: 600px) {\n  [class*=\"dialog\"],\n  [class*=\"dialog\"] > div,\n  [class*=\"scrollable\"],\n  [class*=\"tabs\"],\n  [class*=\"stampGrid\"] {\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box !important;\n    overflow-x: hidden !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  [class*=\"dialog\"] {\n    left: 0 !important;\n  }\n\n  [class*=\"stampGrid\"] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    gap: 5px;\n    padding: 10px 5px !important;\n  }\n\n  .nomal,\n  .selected {\n    width: 30%;\n    margin: 0;\n    padding: 5px;\n    display: inline-block;\n    text-align: center;\n    box-sizing: border-box;\n    cursor: pointer;\n  }\n\n  .selected {\n    filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n    -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n            filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n  }\n\n  .stamp {\n    width: 40px !important;\n    height: 40px !important;\n    display: block !important;\n    margin: 0 auto !important;\n    background-size: contain !important;\n  }\n\n  .label {\n    padding: 8px 6px;\n    min-height: 70px;\n    box-sizing: border-box;\n  }\n\n  .gambaIcon, .hankoIcon, .animalIcon,\n  .activeGambaIcon, .activeHankoIcon, .activeAnimalIcon {\n    background-size: 45px auto;\n    height: 65px;\n    background-position: center center;\n  }\n\n  .gambaIcon, .hankoIcon, .animalIcon {\n    opacity: 0.3;\n  }\n\n  .activeGambaIcon, .activeHankoIcon, .activeAnimalIcon {\n    opacity: 1;\n    display: inline;\n    filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"3\" /><feOffset dx=\"4\" dy=\"4\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(0,0,0,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n    -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n            filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 1));\n  }\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"nomal": "stamp-palette--nomal--3lrHorcn",
	"selected": "stamp-palette--selected--3sSBuOJB",
	"label": "stamp-palette--label--OnJmC02U",
	"gambaIcon": "stamp-palette--gambaIcon--yf0tWWC5",
	"activeGambaIcon": "stamp-palette--activeGambaIcon--2VlPNdEz",
	"hankoIcon": "stamp-palette--hankoIcon--33cl7VTu",
	"activeHankoIcon": "stamp-palette--activeHankoIcon--VYwmvt96",
	"animalIcon": "stamp-palette--animalIcon--2jryDTJF",
	"activeAnimalIcon": "stamp-palette--activeAnimalIcon--2A9Zzoqw",
	"stamp": "stamp-palette--stamp--zBI14vre"
};

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _imagesView = __webpack_require__(2166);

var _imagesView2 = _interopRequireDefault(_imagesView);

var _dialog = __webpack_require__(47);

var _dialog2 = _interopRequireDefault(_dialog);

var _button = __webpack_require__(8);

var _reactI18next = __webpack_require__(2);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _imagesView3 = __webpack_require__(2167);

var _imagesView4 = _interopRequireDefault(_imagesView3);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _videoViewer = __webpack_require__(353);

var _videoViewer2 = _interopRequireDefault(_videoViewer);

var _videoViewer3 = __webpack_require__(934);

var _videoViewer4 = _interopRequireDefault(_videoViewer3);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/images-view.jsx

var ImagesViewProvider = function (_React$Component) {
  _inherits(ImagesViewProvider, _React$Component);

  function ImagesViewProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImagesViewProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImagesViewProvider.__proto__ || Object.getPrototypeOf(ImagesViewProvider)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (ev) {
      if (!_this.props.ui.isVideo || ev.target == _reactDom2.default.findDOMNode(_this.videoviewer_div)) {
        _this.onClose();
      } else {
        undefined;
      }
    }, _this.onClose = function () {
      return _this.props.closeImagesView(_this.props);
    }, _this.showPrevImage = function () {
      if (_this.props.imagesViewFiles.length - 1 > _this.props.ui.index) {
        var index = _this.props.ui.index + 1;
        _this.props.updateUI({
          index: index,
          isVideo: !!_this.props.imagesViewFiles[index].file.content_type.match(/^video|audio/)
        });
      }
    }, _this.showNextImage = function () {
      if (_this.props.ui.index > 0) {
        var index = _this.props.ui.index - 1;
        _this.props.updateUI({
          index: index,
          isVideo: !!_this.props.imagesViewFiles[index].file.content_type.match(/^video|audio/)
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImagesViewProvider, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          imagesViewFiles = _props.imagesViewFiles,
          onClose = _props.onClose,
          children = _props.children;


      var file;
      if (ui.active && ui.mode == 'OUT_OF_LIST') {
        file = ui.selected_file;
      } else if (ui.active && imagesViewFiles) {
        if (imagesViewFiles.length < 1) return null; // esc key pressed
        file = imagesViewFiles[ui.index].file;
      }

      var left_btn = ui.active ? ui.index == imagesViewFiles.length - 1 || typeof ui.index == 'undefined' : undefined;
      var right_btn = ui.active ? ui.index == 0 || typeof ui.index == 'undefined' : undefined;

      return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        ui.active && _react2.default.createElement(
          _dialog2.default,
          {
            className: _imagesView4.default.dialog,
            active: ui.active,
            onEscKeyDown: this.onClose,
            onOverlayClick: this.onClose,
            type: 'fullscreen' },
          _react2.default.createElement(_button.IconButton, { className: _imagesView4.default.close,
            icon: 'close',
            onClick: this.onClose,
            ref: function ref(c) {
              return _this2.iconbutton = c;
            } }),
          file.content_type.match(/^video/) && _react2.default.createElement(
            'a',
            { key: file.video_id, style: { right: 0, marginRight: 100, marginTop: -15, position: 'absolute', zIndex: 1 }, href: file.file.orig_url },
            _react2.default.createElement(_avatar2.default, { className: _videoViewer4.default.avatar,
              icon: 'file_download' })
          ),
          _react2.default.createElement(
            'nav',
            { className: _imagesView4.default.nav },
            ui.mode != 'OUT_OF_LIST' && _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)(_imagesView4.default.navArea, _imagesView4.default.navPrev), onClick: this.showPrevImage },
              _react2.default.createElement(_button.IconButton, { icon: 'keyboard_arrow_left', disabled: left_btn })
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick(ev) {
                  return _this2.onClick(ev);
                },
                className: _imagesView4.default.imageArea,
                ref: function ref(c) {
                  return _this2.videoviewer_div = c;
                } },
              ui.isVideo && _react2.default.createElement(_videoViewer2.default, { key: file.imagesViewFiles_id, video: file, t: t }),
              !ui.isVideo && _react2.default.createElement('img', { src: file.file.url, className: _imagesView4.default.image })
            ),
            ui.mode != 'OUT_OF_LIST' && _react2.default.createElement(
              'div',
              { className: (0, _classnames2.default)(_imagesView4.default.navArea, _imagesView4.default.navNext), onClick: this.showNextImage },
              _react2.default.createElement(_button.IconButton, { icon: 'keyboard_arrow_right', disabled: right_btn })
            )
          )
        ),
        children
      );
    }
  }]);

  return ImagesViewProvider;
}(_react2.default.Component);

exports.default = (0, _imagesView2.default)(ImagesViewProvider);

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/images-view.js

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _context = __webpack_require__(39);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _reactI18next = __webpack_require__(2);

var _alertMessage = __webpack_require__(13);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _findIndex = __webpack_require__(263);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _agentType = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    files: state.imagesView.items,
    isFetchFailed: state.imagesView.isFetchFailed
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var imagesViewFiles = [];
  var _files = [];
  _files = (0, _filter2.default)(stateProps.files, function (file) {
    return file.content_type.match(/^image|video|audio/);
  });

  stateProps.files && (0, _each2.default)(_files, function (file) {
    imagesViewFiles.push({
      imagesViewFiles_id: file.file_id && file.file_id || file.video_id,
      file: file
    });
  });

  return _extends({}, stateProps, dispatchProps, ownProps, {
    imagesViewFiles: imagesViewFiles
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willUpdate: function willUpdate(props, nextProps) {
      if (props.imagesViewFiles.length == 0 && nextProps.imagesViewFiles.length > 0 && nextProps.ui.mode == 'CHAT_ROOM') {
        var index = 0;
        if (!nextProps.ui.isVideo) {
          index = (0, _findIndex2.default)(nextProps.imagesViewFiles, function (file) {
            return file.imagesViewFiles_id == nextProps.ui.selected_file.file_id && file.file.content_type.match(/^image/);
          });
        } else {
          index = (0, _findIndex2.default)(nextProps.imagesViewFiles, function (file) {
            return file.imagesViewFiles_id == nextProps.ui.selected_file.video_id && file.file.content_type.match(/^video|audio/);
          });
        }

        if (index < 0) {
          nextProps.updateUI({ mode: 'OUT_OF_LIST', index: undefined });
        } else {
          nextProps.updateUI({ active: true, index: index });
        }
      }

      if (props.ui.mode != nextProps.ui.mode && nextProps.ui.mode == 'OUT_OF_LIST') {
        nextProps.updateUI({ active: true });
      }
      //ui.modoがGROUP_TIMELINE・GROUP_COMMENTだった場合は下記の処理を通る
      if (props.imagesViewFiles.length == 0 && nextProps.imagesViewFiles.length > 0 && (nextProps.ui.mode == 'GROUP_TIMELINE' || nextProps.ui.mode == 'GROUP_COMMENT')) {
        var index = 0;
        if (!nextProps.ui.isVideo) {
          index = (0, _findIndex2.default)(nextProps.imagesViewFiles, function (file) {
            return file.imagesViewFiles_id == nextProps.ui.selected_file.file_id && file.file.content_type.match(/^image/);
          });
        } else {
          index = (0, _findIndex2.default)(nextProps.imagesViewFiles, function (file) {
            return file.imagesViewFiles_id == nextProps.ui.selected_file.video_id && file.file.content_type.match(/^video|audio/);
          });
        }

        if (nextProps.imagesViewFiles.length == 1 || index < 0) {
          nextProps.updateUI({ mode: 'OUT_OF_LIST', index: undefined });
        } else {
          nextProps.updateUI({ active: true, index: index });
        }
      }
    },

    photoSaved: function photoSaved() {
      return dispatch((0, _alertMessage.emitAlertMessage)("label:フォトライブラリに保存しました"));
    },
    savePhotoFailed: function savePhotoFailed() {
      return dispatch((0, _alertMessage.emitAlertMessage)("error:フォトライブラリに保存できませんでした"));
    },

    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearImagesView());
    },

    closeImagesView: function closeImagesView(props) {
      dispatch(_actions2.default.clearImagesView());
      props.updateUI({ active: false, selected_file: undefined, mode: undefined });
    },

    showImagesView: function showImagesView(mode, parent_id, selected_file, props) {
      switch (mode) {
        case 'CHAT_ROOM':
          dispatch(_actions2.default.fetchChatImagesView(parent_id));
          break;
        case 'GROUP_TIMELINE':
          _agentType.isSmartPhone ? dispatch(_actions2.default.fetchGroupTimelineImagesView(parent_id, true)) : dispatch(_actions2.default.fetchGroupTimelineImagesView(parent_id, false));
          break;
        case 'GROUP_COMMENT':
          dispatch(_actions2.default.fetchGroupTimelineCommentImagesView(parent_id));
          break;
        case 'OUT_OF_LIST':
          break;
      }
      props.updateUI({ mode: mode, selected_file: selected_file, isVideo: !!selected_file.content_type.match(/^video|audio/) });
    }
    // mode: 'CHAT_ROOM', 'GROUP_TIMELINE','GROUP_COMMENT', 'OUT_OF_LIST'
    // parent_id: chat_room_id / group_id
    // selected_file: image
    // props: will be injected by 'inject'
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({
  state: {
    active: false,
    mode: undefined,
    selected_file: undefined,
    isVideo: false,
    index: 0
  }
}), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _context.inject)({ showImagesView: _propTypes2.default.func }));

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2168);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./images-view.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./images-view.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".images-view--nav--2yubUGZX {\n  position: absolute;\n  top: 0; bottom: 0; right: 0; left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 5px;\n}\n\n.images-view--navArea--2wxXmDiC {\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100%;\n  width: 40px;\n}\n\n.images-view--navNext--2HJft9lq {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  margin-right: 5px;\n}\n\n.images-view--navPrev--3mGQvpDa {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  margin-left: 5px;\n}\n\n.images-view--navArea--2wxXmDiC:hover {\n  background: rgba(0, 0, 0, .1);\n}\n\n.images-view--dialog--3v3K0nU8 {\n  height: 100vh;\n}\n\n.images-view--imageArea--3ZGstcKz {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow-y: auto;\n  width: calc(100% - 72px);\n  height: calc(100vh - 56px);\n  cursor: pointer;\n}\n\n.images-view--image--1f7zLkhW {\n  display: block;\n  max-width: 100%;\n  margin: auto;\n}\n\n.images-view--video--2J14b3y4 {\n  margin: auto;\n}\n\n.images-view--close--VVVeVa0X {\n  color: #ffffff !important;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: start;\n  position: absolute;\n  right: 0;\n  margin-right: 60px;\n  margin-top: -15px;\n  background-color: rgb(158, 158, 158);\n  border-radius: 50%;\n  z-index: 1;\n  width: 40px;\n  height: 40px;\n  padding-top: 2px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/images-view.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,OAAO,CAAC,UAAU,CAAC,SAAS,CAAC,QAAQ;EACrC,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;EACvC,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,aAAa;CACd;;AAED;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,aAAa;EACb,YAAY;CACb;;AAED;EACE,uBAAuB;MACnB,oBAAoB;UAChB,sBAAsB;EAC9B,kBAAkB;CACnB;;AAED;EACE,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,iBAAiB;CAClB;;AAED;EACE,8BAA8B;CAC/B;;AAED;EACE,cAAc;CACf;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;CACjB;;AAED;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;CACd;;AAED;EACE,aAAa;CACd;;AAED;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,wBAAwB;MACpB,qBAAqB;UACjB,uBAAuB;EAC/B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;CAClB","file":"images-view.css","sourcesContent":[".nav {\n  position: absolute;\n  top: 0; bottom: 0; right: 0; left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 5px;\n}\n\n.navArea {\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100%;\n  width: 40px;\n}\n\n.navNext {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  margin-right: 5px;\n}\n\n.navPrev {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  margin-left: 5px;\n}\n\n.navArea:hover {\n  background: rgba(0, 0, 0, .1);\n}\n\n.dialog {\n  height: 100vh;\n}\n\n.imageArea {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow-y: auto;\n  width: calc(100% - 72px);\n  height: calc(100vh - 56px);\n  cursor: pointer;\n}\n\n.image {\n  display: block;\n  max-width: 100%;\n  margin: auto;\n}\n\n.video {\n  margin: auto;\n}\n\n.close {\n  color: #ffffff !important;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: start;\n  position: absolute;\n  right: 0;\n  margin-right: 60px;\n  margin-top: -15px;\n  background-color: rgb(158, 158, 158);\n  border-radius: 50%;\n  z-index: 1;\n  width: 40px;\n  height: 40px;\n  padding-top: 2px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"nav": "images-view--nav--2yubUGZX",
	"navArea": "images-view--navArea--2wxXmDiC",
	"navNext": "images-view--navNext--2HJft9lq",
	"navPrev": "images-view--navPrev--3mGQvpDa",
	"dialog": "images-view--dialog--3v3K0nU8",
	"imageArea": "images-view--imageArea--3ZGstcKz",
	"image": "images-view--image--1f7zLkhW",
	"video": "images-view--video--2J14b3y4",
	"close": "images-view--close--VVVeVa0X"
};

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Hls = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

},{}],2:[function(_dereq_,module,exports){
// see https://tools.ietf.org/html/rfc1808

/* jshint ignore:start */
(function(root) { 
/* jshint ignore:end */

  var URL_REGEX = /^((?:[^\/;?#]+:)?)(\/\/[^\/\;?#]*)?(.*?)??(;.*?)?(\?.*?)?(#.*?)?$/;
  var FIRST_SEGMENT_REGEX = /^([^\/;?#]*)(.*)$/;
  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g;

  var URLToolkit = { // jshint ignore:line
    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
    // E.g
    // With opts.alwaysNormalize = false (default, spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
    // With opts.alwaysNormalize = true (default, not spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
    buildAbsoluteURL: function(baseURL, relativeURL, opts) {
      opts = opts || {};
      // remove any remaining space and CRLF
      baseURL = baseURL.trim();
      relativeURL = relativeURL.trim();
      if (!relativeURL) {
        // 2a) If the embedded URL is entirely empty, it inherits the
        // entire base URL (i.e., is set equal to the base URL)
        // and we are done.
        if (!opts.alwaysNormalize) {
          return baseURL;
        }
        var basePartsForNormalise = this.parseURL(baseURL);
        if (!baseParts) {
          throw new Error('Error trying to parse base URL.');
        }
        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
        return URLToolkit.buildURLFromParts(basePartsForNormalise);
      }
      var relativeParts = this.parseURL(relativeURL);
      if (!relativeParts) {
        throw new Error('Error trying to parse relative URL.');
      }
      if (relativeParts.scheme) {
        // 2b) If the embedded URL starts with a scheme name, it is
        // interpreted as an absolute URL and we are done.
        if (!opts.alwaysNormalize) {
          return relativeURL;
        }
        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
        return URLToolkit.buildURLFromParts(relativeParts);
      }
      var baseParts = this.parseURL(baseURL);
      if (!baseParts) {
        throw new Error('Error trying to parse base URL.');
      }
      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
        baseParts.netLoc = pathParts[1];
        baseParts.path = pathParts[2];
      }
      if (baseParts.netLoc && !baseParts.path) {
        baseParts.path = '/';
      }
      var builtParts = {
        // 2c) Otherwise, the embedded URL inherits the scheme of
        // the base URL.
        scheme: baseParts.scheme,
        netLoc: relativeParts.netLoc,
        path: null,
        params: relativeParts.params,
        query: relativeParts.query,
        fragment: relativeParts.fragment
      };
      if (!relativeParts.netLoc) {
        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
        // (if any) of the base URL.
        builtParts.netLoc = baseParts.netLoc;
        // 4) If the embedded URL path is preceded by a slash "/", the
        // path is not relative and we skip to Step 7.
        if (relativeParts.path[0] !== '/') {
          if (!relativeParts.path) {
            // 5) If the embedded URL path is empty (and not preceded by a
            // slash), then the embedded URL inherits the base URL path
            builtParts.path = baseParts.path;
            // 5a) if the embedded URL's <params> is non-empty, we skip to
            // step 7; otherwise, it inherits the <params> of the base
            // URL (if any) and
            if (!relativeParts.params) {
              builtParts.params = baseParts.params;
              // 5b) if the embedded URL's <query> is non-empty, we skip to
              // step 7; otherwise, it inherits the <query> of the base
              // URL (if any) and we skip to step 7.
              if (!relativeParts.query) {
                builtParts.query = baseParts.query;
              }
            }
          } else {
            // 6) The last segment of the base URL's path (anything
            // following the rightmost slash "/", or the entire path if no
            // slash is present) is removed and the embedded URL's path is
            // appended in its place.
            var baseURLPath = baseParts.path;
            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
            builtParts.path = URLToolkit.normalizePath(newPath);
          }
        }
      }
      if (builtParts.path === null) {
        builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
      }
      return URLToolkit.buildURLFromParts(builtParts);
    },
    parseURL: function(url) {
      var parts = URL_REGEX.exec(url);
      if (!parts) {
        return null;
      }
      return {
        scheme: parts[1] || '',
        netLoc: parts[2] || '',
        path: parts[3] || '',
        params: parts[4] || '',
        query: parts[5] || '',
        fragment: parts[6] || ''
      };
    },
    normalizePath: function(path) {
      // The following operations are
      // then applied, in order, to the new path:
      // 6a) All occurrences of "./", where "." is a complete path
      // segment, are removed.
      // 6b) If the path ends with "." as a complete path segment,
      // that "." is removed.
      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
      // 6c) All occurrences of "<segment>/../", where <segment> is a
      // complete path segment not equal to "..", are removed.
      // Removal of these path segments is performed iteratively,
      // removing the leftmost matching pattern on each iteration,
      // until no matching pattern remains.
      // 6d) If the path ends with "<segment>/..", where <segment> is a
      // complete path segment not equal to "..", that
      // "<segment>/.." is removed.
      while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length) {} // jshint ignore:line
      return path.split('').reverse().join('');
    },
    buildURLFromParts: function(parts) {
      return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
    }
  };

/* jshint ignore:start */
  if(typeof exports === 'object' && typeof module === 'object')
    module.exports = URLToolkit;
  else if(typeof define === 'function' && define.amd)
    define([], function() { return URLToolkit; });
  else if(typeof exports === 'object')
    exports["URLToolkit"] = URLToolkit;
  else
    root["URLToolkit"] = URLToolkit;
})(this);
/* jshint ignore:end */

},{}],3:[function(_dereq_,module,exports){
var bundleFn = arguments[3];
var sources = arguments[4];
var cache = arguments[5];

var stringify = JSON.stringify;

module.exports = function (fn, options) {
    var wkey;
    var cacheKeys = Object.keys(cache);

    for (var i = 0, l = cacheKeys.length; i < l; i++) {
        var key = cacheKeys[i];
        var exp = cache[key].exports;
        // Using babel as a transpiler to use esmodule, the export will always
        // be an object with the default export as a property of it. To ensure
        // the existing api and babel esmodule exports are both supported we
        // check for both
        if (exp === fn || exp && exp.default === fn) {
            wkey = key;
            break;
        }
    }

    if (!wkey) {
        wkey = Math.floor(Math.pow(16, 8) * Math.random()).toString(16);
        var wcache = {};
        for (var i = 0, l = cacheKeys.length; i < l; i++) {
            var key = cacheKeys[i];
            wcache[key] = key;
        }
        sources[wkey] = [
            Function(['require','module','exports'], '(' + fn + ')(self)'),
            wcache
        ];
    }
    var skey = Math.floor(Math.pow(16, 8) * Math.random()).toString(16);

    var scache = {}; scache[wkey] = wkey;
    sources[skey] = [
        Function(['require'], (
            // try to call default if defined to also support babel esmodule
            // exports
            'var f = require(' + stringify(wkey) + ');' +
            '(f.default ? f.default : f)(self);'
        )),
        scache
    ];

    var workerSources = {};
    resolveSources(skey);

    function resolveSources(key) {
        workerSources[key] = true;

        for (var depPath in sources[key][1]) {
            var depKey = sources[key][1][depPath];
            if (!workerSources[depKey]) {
                resolveSources(depKey);
            }
        }
    }

    var src = '(' + bundleFn + ')({'
        + Object.keys(workerSources).map(function (key) {
            return stringify(key) + ':['
                + sources[key][0]
                + ',' + stringify(sources[key][1]) + ']'
            ;
        }).join(',')
        + '},{},[' + stringify(skey) + '])'
    ;

    var URL = window.URL || window.webkitURL || window.mozURL || window.msURL;

    var blob = new Blob([src], { type: 'text/javascript' });
    if (options && options.bare) { return blob; }
    var workerUrl = URL.createObjectURL(blob);
    var worker = new Worker(workerUrl);
    worker.objectURL = workerUrl;
    return worker;
};

},{}],4:[function(_dereq_,module,exports){
/**
 * HLS config
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
      value: true
});
exports.hlsDefaultConfig = undefined;

var _abrController = _dereq_(5);

var _abrController2 = _interopRequireDefault(_abrController);

var _bufferController = _dereq_(8);

var _bufferController2 = _interopRequireDefault(_bufferController);

var _capLevelController = _dereq_(9);

var _capLevelController2 = _interopRequireDefault(_capLevelController);

var _fpsController = _dereq_(10);

var _fpsController2 = _interopRequireDefault(_fpsController);

var _xhrLoader = _dereq_(59);

var _xhrLoader2 = _interopRequireDefault(_xhrLoader);

var _audioTrackController = _dereq_(7);

var _audioTrackController2 = _interopRequireDefault(_audioTrackController);

var _audioStreamController = _dereq_(6);

var _audioStreamController2 = _interopRequireDefault(_audioStreamController);

var _cues = _dereq_(50);

var _cues2 = _interopRequireDefault(_cues);

var _timelineController = _dereq_(16);

var _timelineController2 = _interopRequireDefault(_timelineController);

var _subtitleTrackController = _dereq_(15);

var _subtitleTrackController2 = _interopRequireDefault(_subtitleTrackController);

var _subtitleStreamController = _dereq_(14);

var _subtitleStreamController2 = _interopRequireDefault(_subtitleStreamController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//#endif

//#endif

//#if subtitle

//import FetchLoader from './utils/fetch-loader';
//#if altaudio
var hlsDefaultConfig = exports.hlsDefaultConfig = {
      autoStartLoad: true, // used by stream-controller
      startPosition: -1, // used by stream-controller
      defaultAudioCodec: undefined, // used by stream-controller
      debug: false, // used by logger
      capLevelOnFPSDrop: false, // used by fps-controller
      capLevelToPlayerSize: false, // used by cap-level-controller
      initialLiveManifestSize: 1, // used by stream-controller
      maxBufferLength: 30, // used by stream-controller
      maxBufferSize: 60 * 1000 * 1000, // used by stream-controller
      maxBufferHole: 0.5, // used by stream-controller
      maxSeekHole: 2, // used by stream-controller
      lowBufferWatchdogPeriod: 0.5, // used by stream-controller
      highBufferWatchdogPeriod: 3, // used by stream-controller
      nudgeOffset: 0.1, // used by stream-controller
      nudgeMaxRetry: 3, // used by stream-controller
      maxFragLookUpTolerance: 0.25, // used by stream-controller
      liveSyncDurationCount: 3, // used by stream-controller
      liveMaxLatencyDurationCount: Infinity, // used by stream-controller
      liveSyncDuration: undefined, // used by stream-controller
      liveMaxLatencyDuration: undefined, // used by stream-controller
      maxMaxBufferLength: 600, // used by stream-controller
      enableWorker: true, // used by demuxer
      enableSoftwareAES: true, // used by decrypter
      manifestLoadingTimeOut: 10000, // used by playlist-loader
      manifestLoadingMaxRetry: 1, // used by playlist-loader
      manifestLoadingRetryDelay: 1000, // used by playlist-loader
      manifestLoadingMaxRetryTimeout: 64000, // used by playlist-loader
      startLevel: undefined, // used by level-controller
      levelLoadingTimeOut: 10000, // used by playlist-loader
      levelLoadingMaxRetry: 4, // used by playlist-loader
      levelLoadingRetryDelay: 1000, // used by playlist-loader
      levelLoadingMaxRetryTimeout: 64000, // used by playlist-loader
      fragLoadingTimeOut: 20000, // used by fragment-loader
      fragLoadingMaxRetry: 6, // used by fragment-loader
      fragLoadingRetryDelay: 1000, // used by fragment-loader
      fragLoadingMaxRetryTimeout: 64000, // used by fragment-loader
      fragLoadingLoopThreshold: 3, // used by stream-controller
      startFragPrefetch: false, // used by stream-controller
      fpsDroppedMonitoringPeriod: 5000, // used by fps-controller
      fpsDroppedMonitoringThreshold: 0.2, // used by fps-controller
      appendErrorMaxRetry: 3, // used by buffer-controller
      loader: _xhrLoader2.default,
      //loader: FetchLoader,
      fLoader: undefined,
      pLoader: undefined,
      xhrSetup: undefined,
      fetchSetup: undefined,
      abrController: _abrController2.default,
      bufferController: _bufferController2.default,
      capLevelController: _capLevelController2.default,
      fpsController: _fpsController2.default,
      //#if altaudio
      audioStreamController: _audioStreamController2.default,
      audioTrackController: _audioTrackController2.default,
      //#endif
      //#if subtitle
      subtitleStreamController: _subtitleStreamController2.default,
      subtitleTrackController: _subtitleTrackController2.default,
      timelineController: _timelineController2.default,
      cueHandler: _cues2.default,
      enableCEA708Captions: true, // used by timeline-controller
      enableWebVTT: true, // used by timeline-controller
      captionsTextTrack1Label: 'English', // used by timeline-controller
      captionsTextTrack1LanguageCode: 'en', // used by timeline-controller
      captionsTextTrack2Label: 'Spanish', // used by timeline-controller
      captionsTextTrack2LanguageCode: 'es', // used by timeline-controller
      //#endif
      stretchShortVideoTrack: false, // used by mp4-remuxer
      forceKeyFrameOnDiscontinuity: true, // used by ts-demuxer
      abrEwmaFastLive: 3, // used by abr-controller
      abrEwmaSlowLive: 9, // used by abr-controller
      abrEwmaFastVoD: 3, // used by abr-controller
      abrEwmaSlowVoD: 9, // used by abr-controller
      abrEwmaDefaultEstimate: 5e5, // 500 kbps  // used by abr-controller
      abrBandWidthFactor: 0.95, // used by abr-controller
      abrBandWidthUpFactor: 0.7, // used by abr-controller
      abrMaxWithRealBitrate: false, // used by abr-controller
      maxStarvationDelay: 4, // used by abr-controller
      maxLoadingDelay: 4, // used by abr-controller
      minAutoBitrate: 0 // used by hls
};

},{"10":10,"14":14,"15":15,"16":16,"5":5,"50":50,"59":59,"6":6,"7":7,"8":8,"9":9}],5:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _bufferHelper = _dereq_(37);

var _bufferHelper2 = _interopRequireDefault(_bufferHelper);

var _errors = _dereq_(33);

var _logger = _dereq_(54);

var _ewmaBandwidthEstimator = _dereq_(52);

var _ewmaBandwidthEstimator2 = _interopRequireDefault(_ewmaBandwidthEstimator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * simple ABR Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  - compute next level based on last fragment bw heuristics
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  - implement an abandon rules triggered if we have less than 2 frag buffered and if computed bw shows that we risk buffer stalling
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var AbrController = function (_EventHandler) {
  _inherits(AbrController, _EventHandler);

  function AbrController(hls) {
    _classCallCheck(this, AbrController);

    var _this = _possibleConstructorReturn(this, (AbrController.__proto__ || Object.getPrototypeOf(AbrController)).call(this, hls, _events2.default.FRAG_LOADING, _events2.default.FRAG_LOADED, _events2.default.FRAG_BUFFERED, _events2.default.ERROR));

    _this.lastLoadedFragLevel = 0;
    _this._nextAutoLevel = -1;
    _this.hls = hls;
    _this.timer = null;
    _this._bwEstimator = null;
    _this.onCheck = _this._abandonRulesCheck.bind(_this);
    return _this;
  }

  _createClass(AbrController, [{
    key: 'destroy',
    value: function destroy() {
      this.clearTimer();
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onFragLoading',
    value: function onFragLoading(data) {
      var frag = data.frag;
      if (frag.type === 'main') {
        if (!this.timer) {
          this.timer = setInterval(this.onCheck, 100);
        }
        // lazy init of bw Estimator, rationale is that we use different params for Live/VoD
        // so we need to wait for stream manifest / playlist type to instantiate it.
        if (!this._bwEstimator) {
          var hls = this.hls,
              level = data.frag.level,
              isLive = hls.levels[level].details.live,
              config = hls.config,
              ewmaFast = void 0,
              ewmaSlow = void 0;

          if (isLive) {
            ewmaFast = config.abrEwmaFastLive;
            ewmaSlow = config.abrEwmaSlowLive;
          } else {
            ewmaFast = config.abrEwmaFastVoD;
            ewmaSlow = config.abrEwmaSlowVoD;
          }
          this._bwEstimator = new _ewmaBandwidthEstimator2.default(hls, ewmaSlow, ewmaFast, config.abrEwmaDefaultEstimate);
        }
        this.fragCurrent = frag;
      }
    }
  }, {
    key: '_abandonRulesCheck',
    value: function _abandonRulesCheck() {
      /*
        monitor fragment retrieval time...
        we compute expected time of arrival of the complete fragment.
        we compare it to expected time of buffer starvation
      */
      var hls = this.hls,
          v = hls.media,
          frag = this.fragCurrent,
          loader = frag.loader,
          minAutoLevel = hls.minAutoLevel;

      // if loader has been destroyed or loading has been aborted, stop timer and return
      if (!loader || loader.stats && loader.stats.aborted) {
        _logger.logger.warn('frag loader destroy or aborted, disarm abandonRules');
        this.clearTimer();
        return;
      }
      var stats = loader.stats;
      /* only monitor frag retrieval time if
      (video not paused OR first fragment being loaded(ready state === HAVE_NOTHING = 0)) AND autoswitching enabled AND not lowest level (=> means that we have several levels) */
      if (v && stats && (!v.paused && v.playbackRate !== 0 || !v.readyState) && frag.autoLevel && frag.level) {
        var requestDelay = performance.now() - stats.trequest,
            playbackRate = Math.abs(v.playbackRate);
        // monitor fragment load progress after half of expected fragment duration,to stabilize bitrate
        if (requestDelay > 500 * frag.duration / playbackRate) {
          var levels = hls.levels,
              loadRate = Math.max(1, stats.bw ? stats.bw / 8 : stats.loaded * 1000 / requestDelay),
              // byte/s; at least 1 byte/s to avoid division by zero
          // compute expected fragment length using frag duration and level bitrate. also ensure that expected len is gte than already loaded size
          level = levels[frag.level],
              levelBitrate = level.realBitrate ? Math.max(level.realBitrate, level.bitrate) : level.bitrate,
              expectedLen = stats.total ? stats.total : Math.max(stats.loaded, Math.round(frag.duration * levelBitrate / 8)),
              pos = v.currentTime,
              fragLoadedDelay = (expectedLen - stats.loaded) / loadRate,
              bufferStarvationDelay = (_bufferHelper2.default.bufferInfo(v, pos, hls.config.maxBufferHole).end - pos) / playbackRate;
          // consider emergency switch down only if we have less than 2 frag buffered AND
          // time to finish loading current fragment is bigger than buffer starvation delay
          // ie if we risk buffer starvation if bw does not increase quickly
          if (bufferStarvationDelay < 2 * frag.duration / playbackRate && fragLoadedDelay > bufferStarvationDelay) {
            var fragLevelNextLoadedDelay = void 0,
                nextLoadLevel = void 0;
            // lets iterate through lower level and try to find the biggest one that could avoid rebuffering
            // we start from current level - 1 and we step down , until we find a matching level
            for (nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
              // compute time to load next fragment at lower level
              // 0.8 : consider only 80% of current bw to be conservative
              // 8 = bits per byte (bps/Bps)
              var levelNextBitrate = levels[nextLoadLevel].realBitrate ? Math.max(levels[nextLoadLevel].realBitrate, levels[nextLoadLevel].bitrate) : levels[nextLoadLevel].bitrate;
              fragLevelNextLoadedDelay = frag.duration * levelNextBitrate / (8 * 0.8 * loadRate);
              if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
                // we found a lower level that be rebuffering free with current estimated bw !
                break;
              }
            }
            // only emergency switch down if it takes less time to load new fragment at lowest level instead
            // of finishing loading current one ...
            if (fragLevelNextLoadedDelay < fragLoadedDelay) {
              _logger.logger.warn('loading too slow, abort fragment loading and switch to level ' + nextLoadLevel + ':fragLoadedDelay[' + nextLoadLevel + ']<fragLoadedDelay[' + (frag.level - 1) + '];bufferStarvationDelay:' + fragLevelNextLoadedDelay.toFixed(1) + '<' + fragLoadedDelay.toFixed(1) + ':' + bufferStarvationDelay.toFixed(1));
              // force next load level in auto mode
              hls.nextLoadLevel = nextLoadLevel;
              // update bw estimate for this fragment before cancelling load (this will help reducing the bw)
              this._bwEstimator.sample(requestDelay, stats.loaded);
              //abort fragment loading
              loader.abort();
              // stop abandon rules timer
              this.clearTimer();
              hls.trigger(_events2.default.FRAG_LOAD_EMERGENCY_ABORTED, { frag: frag, stats: stats });
            }
          }
        }
      }
    }
  }, {
    key: 'onFragLoaded',
    value: function onFragLoaded(data) {
      var frag = data.frag;
      if (frag.type === 'main' && !isNaN(frag.sn)) {
        // stop monitoring bw once frag loaded
        this.clearTimer();
        // store level id after successful fragment load
        this.lastLoadedFragLevel = frag.level;
        // reset forced auto level value so that next level will be selected
        this._nextAutoLevel = -1;

        // compute level average bitrate
        if (this.hls.config.abrMaxWithRealBitrate) {
          var level = this.hls.levels[frag.level];
          var loadedBytes = (level.loaded ? level.loaded.bytes : 0) + data.stats.loaded;
          var loadedDuration = (level.loaded ? level.loaded.duration : 0) + data.frag.duration;
          level.loaded = { bytes: loadedBytes, duration: loadedDuration };
          level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
        }
        // if fragment has been loaded to perform a bitrate test,
        if (data.frag.bitrateTest) {
          var stats = data.stats;
          stats.tparsed = stats.tbuffered = stats.tload;
          this.onFragBuffered(data);
        }
      }
    }
  }, {
    key: 'onFragBuffered',
    value: function onFragBuffered(data) {
      var stats = data.stats,
          frag = data.frag;
      // only update stats on first frag buffering
      // if same frag is loaded multiple times, it might be in browser cache, and loaded quickly
      // and leading to wrong bw estimation
      // on bitrate test, also only update stats once (if tload = tbuffered == on FRAG_LOADED)
      if (stats.aborted !== true && frag.loadCounter === 1 && frag.type === 'main' && !isNaN(frag.sn) && (!frag.bitrateTest || stats.tload === stats.tbuffered)) {
        // use tparsed-trequest instead of tbuffered-trequest to compute fragLoadingProcessing; rationale is that  buffer appending only happens once media is attached
        // in case we use config.startFragPrefetch while media is not attached yet, fragment might be parsed while media not attached yet, but it will only be buffered on media attached
        // as a consequence it could happen really late in the process. meaning that appending duration might appears huge ... leading to underestimated throughput estimation
        var fragLoadingProcessingMs = stats.tparsed - stats.trequest;
        _logger.logger.log('latency/loading/parsing/append/kbps:' + Math.round(stats.tfirst - stats.trequest) + '/' + Math.round(stats.tload - stats.tfirst) + '/' + Math.round(stats.tparsed - stats.tload) + '/' + Math.round(stats.tbuffered - stats.tparsed) + '/' + Math.round(8 * stats.loaded / (stats.tbuffered - stats.trequest)));
        this._bwEstimator.sample(fragLoadingProcessingMs, stats.loaded);
        stats.bwEstimate = this._bwEstimator.getEstimate();
        // if fragment has been loaded to perform a bitrate test, (hls.startLevel = -1), store bitrate test delay duration
        if (frag.bitrateTest) {
          this.bitrateTestDelay = fragLoadingProcessingMs / 1000;
        } else {
          this.bitrateTestDelay = 0;
        }
      }
    }
  }, {
    key: 'onError',
    value: function onError(data) {
      // stop timer in case of frag loading error
      switch (data.details) {
        case _errors.ErrorDetails.FRAG_LOAD_ERROR:
        case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
          this.clearTimer();
          break;
        default:
          break;
      }
    }
  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    }

    // return next auto level

  }, {
    key: '_findBestLevel',
    value: function _findBestLevel(currentLevel, currentFragDuration, currentBw, minAutoLevel, maxAutoLevel, maxFetchDuration, bwFactor, bwUpFactor, levels) {
      for (var i = maxAutoLevel; i >= minAutoLevel; i--) {
        var levelInfo = levels[i],
            levelDetails = levelInfo.details,
            avgDuration = levelDetails ? levelDetails.totalduration / levelDetails.fragments.length : currentFragDuration,
            live = levelDetails ? levelDetails.live : false,
            adjustedbw = void 0;
        // follow algorithm captured from stagefright :
        // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
        // Pick the highest bandwidth stream below or equal to estimated bandwidth.
        // consider only 80% of the available bandwidth, but if we are switching up,
        // be even more conservative (70%) to avoid overestimating and immediately
        // switching back.
        if (i <= currentLevel) {
          adjustedbw = bwFactor * currentBw;
        } else {
          adjustedbw = bwUpFactor * currentBw;
        }
        var bitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate,
            fetchDuration = bitrate * avgDuration / adjustedbw;

        _logger.logger.trace('level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: ' + i + '/' + Math.round(adjustedbw) + '/' + bitrate + '/' + avgDuration + '/' + maxFetchDuration + '/' + fetchDuration);
        // if adjusted bw is greater than level bitrate AND
        if (adjustedbw > bitrate && (
        // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that _findBestLevel will return -1
        !fetchDuration || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration)) {
          // as we are looping from highest to lowest, this will return the best achievable quality level
          return i;
        }
      }
      // not enough time budget even with quality level 0 ... rebuffering might happen
      return -1;
    }
  }, {
    key: 'nextAutoLevel',
    get: function get() {
      var forcedAutoLevel = this._nextAutoLevel;
      var bwEstimator = this._bwEstimator;
      // in case next auto level has been forced, and bw not available or not reliable, return forced value
      if (forcedAutoLevel !== -1 && (!bwEstimator || !bwEstimator.canEstimate())) {
        return forcedAutoLevel;
      }
      // compute next level using ABR logic
      var nextABRAutoLevel = this._nextABRAutoLevel;
      // if forced auto level has been defined, use it to cap ABR computed quality level
      if (forcedAutoLevel !== -1) {
        nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);
      }
      return nextABRAutoLevel;
    },
    set: function set(nextLevel) {
      this._nextAutoLevel = nextLevel;
    }
  }, {
    key: '_nextABRAutoLevel',
    get: function get() {
      var hls = this.hls,
          maxAutoLevel = hls.maxAutoLevel,
          levels = hls.levels,
          config = hls.config,
          minAutoLevel = hls.minAutoLevel;
      var v = hls.media,
          currentLevel = this.lastLoadedFragLevel,
          currentFragDuration = this.fragCurrent ? this.fragCurrent.duration : 0,
          pos = v ? v.currentTime : 0,

      // playbackRate is the absolute value of the playback rate; if v.playbackRate is 0, we use 1 to load as
      // if we're playing back at the normal rate.
      playbackRate = v && v.playbackRate !== 0 ? Math.abs(v.playbackRate) : 1.0,
          avgbw = this._bwEstimator ? this._bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate,

      // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
      bufferStarvationDelay = (_bufferHelper2.default.bufferInfo(v, pos, config.maxBufferHole).end - pos) / playbackRate;

      // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
      var bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, config.abrBandWidthFactor, config.abrBandWidthUpFactor, levels);
      if (bestLevel >= 0) {
        return bestLevel;
      } else {
        _logger.logger.trace('rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering');
        // not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
        // if no matching level found, logic will return 0
        var maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay,
            bwFactor = config.abrBandWidthFactor,
            bwUpFactor = config.abrBandWidthUpFactor;
        if (bufferStarvationDelay === 0) {
          // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
          var bitrateTestDelay = this.bitrateTestDelay;
          if (bitrateTestDelay) {
            // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
            // max video loading delay used in  automatic start level selection :
            // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
            // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
            // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
            var maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
            maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
            _logger.logger.trace('bitrate test took ' + Math.round(1000 * bitrateTestDelay) + 'ms, set first fragment max fetchDuration to ' + Math.round(1000 * maxStarvationDelay) + ' ms');
            // don't use conservative factor on bitrate test
            bwFactor = bwUpFactor = 1;
          }
        }
        bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay + maxStarvationDelay, bwFactor, bwUpFactor, levels);
        return Math.max(bestLevel, 0);
      }
    }
  }]);

  return AbrController;
}(_eventHandler2.default);

exports.default = AbrController;

},{"33":33,"34":34,"35":35,"37":37,"52":52,"54":54}],6:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _binarySearch = _dereq_(48);

var _binarySearch2 = _interopRequireDefault(_binarySearch);

var _bufferHelper = _dereq_(37);

var _bufferHelper2 = _interopRequireDefault(_bufferHelper);

var _demuxer = _dereq_(25);

var _demuxer2 = _interopRequireDefault(_demuxer);

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _levelHelper = _dereq_(38);

var _levelHelper2 = _interopRequireDefault(_levelHelper);

var _timeRanges = _dereq_(55);

var _timeRanges2 = _interopRequireDefault(_timeRanges);

var _errors = _dereq_(33);

var _logger = _dereq_(54);

var _discontinuities = _dereq_(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Audio Stream Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var State = {
  STOPPED: 'STOPPED',
  STARTING: 'STARTING',
  IDLE: 'IDLE',
  PAUSED: 'PAUSED',
  KEY_LOADING: 'KEY_LOADING',
  FRAG_LOADING: 'FRAG_LOADING',
  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
  WAITING_TRACK: 'WAITING_TRACK',
  PARSING: 'PARSING',
  PARSED: 'PARSED',
  BUFFER_FLUSHING: 'BUFFER_FLUSHING',
  ENDED: 'ENDED',
  ERROR: 'ERROR',
  WAITING_INIT_PTS: 'WAITING_INIT_PTS'
};

var AudioStreamController = function (_EventHandler) {
  _inherits(AudioStreamController, _EventHandler);

  function AudioStreamController(hls) {
    _classCallCheck(this, AudioStreamController);

    var _this = _possibleConstructorReturn(this, (AudioStreamController.__proto__ || Object.getPrototypeOf(AudioStreamController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.AUDIO_TRACKS_UPDATED, _events2.default.AUDIO_TRACK_SWITCHING, _events2.default.AUDIO_TRACK_LOADED, _events2.default.KEY_LOADED, _events2.default.FRAG_LOADED, _events2.default.FRAG_PARSING_INIT_SEGMENT, _events2.default.FRAG_PARSING_DATA, _events2.default.FRAG_PARSED, _events2.default.ERROR, _events2.default.BUFFER_CREATED, _events2.default.BUFFER_APPENDED, _events2.default.BUFFER_FLUSHED, _events2.default.INIT_PTS_FOUND));

    _this.config = hls.config;
    _this.audioCodecSwap = false;
    _this.ticks = 0;
    _this._state = State.STOPPED;
    _this.ontick = _this.tick.bind(_this);
    _this.initPTS = [];
    _this.waitingFragment = null;
    _this.videoTrackCC = null;
    return _this;
  }

  _createClass(AudioStreamController, [{
    key: 'destroy',
    value: function destroy() {
      this.stopLoad();
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      _eventHandler2.default.prototype.destroy.call(this);
      this.state = State.STOPPED;
    }

    //Signal that video PTS was found

  }, {
    key: 'onInitPtsFound',
    value: function onInitPtsFound(data) {
      var demuxerId = data.id,
          cc = data.frag.cc,
          initPTS = data.initPTS;
      if (demuxerId === 'main') {
        //Always update the new INIT PTS
        //Can change due level switch
        this.initPTS[cc] = initPTS;
        this.videoTrackCC = cc;
        _logger.logger.log('InitPTS for cc:' + cc + ' found from video track:' + initPTS);

        //If we are waiting we need to demux/remux the waiting frag
        //With the new initPTS
        if (this.state === State.WAITING_INIT_PTS) {
          this.tick();
        }
      }
    }
  }, {
    key: 'startLoad',
    value: function startLoad(startPosition) {
      if (this.tracks) {
        var lastCurrentTime = this.lastCurrentTime;
        this.stopLoad();
        if (!this.timer) {
          this.timer = setInterval(this.ontick, 100);
        }
        this.fragLoadError = 0;
        if (lastCurrentTime > 0 && startPosition === -1) {
          _logger.logger.log('audio:override startPosition with lastCurrentTime @' + lastCurrentTime.toFixed(3));
          this.state = State.IDLE;
        } else {
          this.lastCurrentTime = this.startPosition ? this.startPosition : startPosition;
          this.state = State.STARTING;
        }
        this.nextLoadPosition = this.startPosition = this.lastCurrentTime;
        this.tick();
      } else {
        this.startPosition = startPosition;
        this.state = State.STOPPED;
      }
    }
  }, {
    key: 'stopLoad',
    value: function stopLoad() {
      var frag = this.fragCurrent;
      if (frag) {
        if (frag.loader) {
          frag.loader.abort();
        }
        this.fragCurrent = null;
      }
      this.fragPrevious = null;
      if (this.demuxer) {
        this.demuxer.destroy();
        this.demuxer = null;
      }
      this.state = State.STOPPED;
    }
  }, {
    key: 'tick',
    value: function tick() {
      this.ticks++;
      if (this.ticks === 1) {
        this.doTick();
        if (this.ticks > 1) {
          setTimeout(this.tick, 1);
        }
        this.ticks = 0;
      }
    }
  }, {
    key: 'doTick',
    value: function doTick() {
      var pos,
          track,
          trackDetails,
          hls = this.hls,
          config = hls.config;
      //logger.log('audioStream:' + this.state);
      switch (this.state) {
        case State.ERROR:
        //don't do anything in error state to avoid breaking further ...
        case State.PAUSED:
        //don't do anything in paused state either ...
        case State.BUFFER_FLUSHING:
          break;
        case State.STARTING:
          this.state = State.WAITING_TRACK;
          this.loadedmetadata = false;
          break;
        case State.IDLE:
          var tracks = this.tracks;
          // audio tracks not received => exit loop
          if (!tracks) {
            break;
          }
          // if video not attached AND
          // start fragment already requested OR start frag prefetch disable
          // exit loop
          // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
          if (!this.media && (this.startFragRequested || !config.startFragPrefetch)) {
            break;
          }
          // determine next candidate fragment to be loaded, based on current position and
          //  end of buffer position
          // if we have not yet loaded any fragment, start loading from start position
          if (this.loadedmetadata) {
            pos = this.media.currentTime;
          } else {
            pos = this.nextLoadPosition;
            if (pos === undefined) {
              break;
            }
          }
          var media = this.mediaBuffer ? this.mediaBuffer : this.media,
              bufferInfo = _bufferHelper2.default.bufferInfo(media, pos, config.maxBufferHole),
              bufferLen = bufferInfo.len,
              bufferEnd = bufferInfo.end,
              fragPrevious = this.fragPrevious,
              maxBufLen = config.maxMaxBufferLength,
              audioSwitch = this.audioSwitch,
              trackId = this.trackId;

          // if buffer length is less than maxBufLen try to load a new fragment
          if ((bufferLen < maxBufLen || audioSwitch) && trackId < tracks.length) {
            trackDetails = tracks[trackId].details;
            // if track info not retrieved yet, switch state and wait for track retrieval
            if (typeof trackDetails === 'undefined') {
              this.state = State.WAITING_TRACK;
              break;
            }

            // we just got done loading the final fragment, check if we need to finalize media stream
            if (!audioSwitch && !trackDetails.live && fragPrevious && fragPrevious.sn === trackDetails.endSN) {
              // if we are not seeking or if we are seeking but everything (almost) til the end is buffered, let's signal eos
              // we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference when switching
              // between different renditions. using half frag duration should help cope with these cases.
              if (!this.media.seeking || this.media.duration - bufferEnd < fragPrevious.duration / 2) {
                // Finalize the media stream
                this.hls.trigger(_events2.default.BUFFER_EOS, { type: 'audio' });
                this.state = State.ENDED;
                break;
              }
            }

            // find fragment index, contiguous with end of buffer position
            var fragments = trackDetails.fragments,
                fragLen = fragments.length,
                start = fragments[0].start,
                end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration,
                frag = void 0;

            // When switching audio track, reload audio as close as possible to currentTime
            if (audioSwitch) {
              if (trackDetails.live && !trackDetails.PTSKnown) {
                _logger.logger.log('switching audiotrack, live stream, unknown PTS,load first fragment');
                bufferEnd = 0;
              } else {
                bufferEnd = pos;
                // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
                if (trackDetails.PTSKnown && pos < start) {
                  // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
                  if (bufferInfo.end > start || bufferInfo.nextStart) {
                    _logger.logger.log('alt audio track ahead of main track, seek to start of alt audio track');
                    this.media.currentTime = start + 0.05;
                  } else {
                    return;
                  }
                }
              }
            }
            if (trackDetails.initSegment && !trackDetails.initSegment.data) {
              frag = trackDetails.initSegment;
            }
            // if bufferEnd before start of playlist, load first fragment
            else if (bufferEnd <= start) {
                frag = fragments[0];
                if (this.videoTrackCC !== null && frag.cc !== this.videoTrackCC) {
                  // Ensure we find a fragment which matches the continuity of the video track
                  frag = (0, _discontinuities.findFragWithCC)(fragments, this.videoTrackCC);
                }
                if (trackDetails.live && frag.loadIdx && frag.loadIdx === this.fragLoadIdx) {
                  // we just loaded this first fragment, and we are still lagging behind the start of the live playlist
                  // let's force seek to start
                  var nextBuffered = bufferInfo.nextStart ? bufferInfo.nextStart : start;
                  _logger.logger.log('no alt audio available @currentTime:' + this.media.currentTime + ', seeking @' + (nextBuffered + 0.05));
                  this.media.currentTime = nextBuffered + 0.05;
                  return;
                }
              } else {
                var foundFrag = void 0;
                var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
                var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
                var fragmentWithinToleranceTest = function fragmentWithinToleranceTest(candidate) {
                  // offset should be within fragment boundary - config.maxFragLookUpTolerance
                  // this is to cope with situations like
                  // bufferEnd = 9.991
                  // frag[Ø] : [0,10]
                  // frag[1] : [10,20]
                  // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
                  //              frag start               frag start+duration
                  //                  |-----------------------------|
                  //              <--->                         <--->
                  //  ...--------><-----------------------------><---------....
                  // previous frag         matching fragment         next frag
                  //  return -1             return 0                 return 1
                  //logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
                  // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
                  var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration);
                  if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
                    return 1;
                  } // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
                  else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
                      return -1;
                    }
                  return 0;
                };

                if (bufferEnd < end) {
                  if (bufferEnd > end - maxFragLookUpTolerance) {
                    maxFragLookUpTolerance = 0;
                  }
                  // Prefer the next fragment if it's within tolerance
                  if (fragNext && !fragmentWithinToleranceTest(fragNext)) {
                    foundFrag = fragNext;
                  } else {
                    foundFrag = _binarySearch2.default.search(fragments, fragmentWithinToleranceTest);
                  }
                } else {
                  // reach end of playlist
                  foundFrag = fragments[fragLen - 1];
                }
                if (foundFrag) {
                  frag = foundFrag;
                  start = foundFrag.start;
                  //logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
                  if (fragPrevious && frag.level === fragPrevious.level && frag.sn === fragPrevious.sn) {
                    if (frag.sn < trackDetails.endSN) {
                      frag = fragments[frag.sn + 1 - trackDetails.startSN];
                      _logger.logger.log('SN just loaded, load next one: ' + frag.sn);
                    } else {
                      frag = null;
                    }
                  }
                }
              }
            if (frag) {
              //logger.log('      loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
              if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
                _logger.logger.log('Loading key for ' + frag.sn + ' of [' + trackDetails.startSN + ' ,' + trackDetails.endSN + '],track ' + trackId);
                this.state = State.KEY_LOADING;
                hls.trigger(_events2.default.KEY_LOADING, { frag: frag });
              } else {
                _logger.logger.log('Loading ' + frag.sn + ', cc: ' + frag.cc + ' of [' + trackDetails.startSN + ' ,' + trackDetails.endSN + '],track ' + trackId + ', currentTime:' + pos + ',bufferEnd:' + bufferEnd.toFixed(3));
                // ensure that we are not reloading the same fragments in loop ...
                if (this.fragLoadIdx !== undefined) {
                  this.fragLoadIdx++;
                } else {
                  this.fragLoadIdx = 0;
                }
                if (frag.loadCounter) {
                  frag.loadCounter++;
                  var maxThreshold = config.fragLoadingLoopThreshold;
                  // if this frag has already been loaded 3 times, and if it has been reloaded recently
                  if (frag.loadCounter > maxThreshold && Math.abs(this.fragLoadIdx - frag.loadIdx) < maxThreshold) {
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR, fatal: false, frag: frag });
                    return;
                  }
                } else {
                  frag.loadCounter = 1;
                }
                frag.loadIdx = this.fragLoadIdx;
                this.fragCurrent = frag;
                this.startFragRequested = true;
                if (!isNaN(frag.sn)) {
                  this.nextLoadPosition = frag.start + frag.duration;
                }
                hls.trigger(_events2.default.FRAG_LOADING, { frag: frag });
                this.state = State.FRAG_LOADING;
              }
            }
          }
          break;
        case State.WAITING_TRACK:
          track = this.tracks[this.trackId];
          // check if playlist is already loaded
          if (track && track.details) {
            this.state = State.IDLE;
          }
          break;
        case State.FRAG_LOADING_WAITING_RETRY:
          var now = performance.now();
          var retryDate = this.retryDate;
          media = this.media;
          var isSeeking = media && media.seeking;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || isSeeking) {
            _logger.logger.log('audioStreamController: retryDate reached, switch back to IDLE state');
            this.state = State.IDLE;
          }
          break;
        case State.WAITING_INIT_PTS:
          var videoTrackCC = this.videoTrackCC;
          if (this.initPTS[videoTrackCC] === undefined) {
            break;
          }

          // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
          var waitingFrag = this.waitingFragment;
          if (waitingFrag) {
            var waitingFragCC = waitingFrag.frag.cc;
            if (videoTrackCC !== waitingFragCC) {
              track = this.tracks[this.trackId];
              if (track.details && track.details.live) {
                _logger.logger.warn('Waiting fragment CC (' + waitingFragCC + ') does not match video track CC (' + videoTrackCC + ')');
                this.waitingFragment = null;
                this.state = State.IDLE;
              }
            } else {
              this.state = State.FRAG_LOADING;
              this.onFragLoaded(this.waitingFragment);
              this.waitingFragment = null;
            }
          } else {
            this.state = State.IDLE;
          }

          break;
        case State.STOPPED:
        case State.FRAG_LOADING:
        case State.PARSING:
        case State.PARSED:
        case State.ENDED:
          break;
        default:
          break;
      }
    }
  }, {
    key: 'onMediaAttached',
    value: function onMediaAttached(data) {
      var media = this.media = this.mediaBuffer = data.media;
      this.onvseeking = this.onMediaSeeking.bind(this);
      this.onvended = this.onMediaEnded.bind(this);
      media.addEventListener('seeking', this.onvseeking);
      media.addEventListener('ended', this.onvended);
      var config = this.config;
      if (this.tracks && config.autoStartLoad) {
        this.startLoad(config.startPosition);
      }
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      var media = this.media;
      if (media && media.ended) {
        _logger.logger.log('MSE detaching and video ended, reset startPosition');
        this.startPosition = this.lastCurrentTime = 0;
      }

      // reset fragment loading counter on MSE detaching to avoid reporting FRAG_LOOP_LOADING_ERROR after error recovery
      var tracks = this.tracks;
      if (tracks) {
        // reset fragment load counter
        tracks.forEach(function (track) {
          if (track.details) {
            track.details.fragments.forEach(function (fragment) {
              fragment.loadCounter = undefined;
            });
          }
        });
      }
      // remove video listeners
      if (media) {
        media.removeEventListener('seeking', this.onvseeking);
        media.removeEventListener('ended', this.onvended);
        this.onvseeking = this.onvseeked = this.onvended = null;
      }
      this.media = this.mediaBuffer = null;
      this.loadedmetadata = false;
      this.stopLoad();
    }
  }, {
    key: 'onMediaSeeking',
    value: function onMediaSeeking() {
      if (this.state === State.ENDED) {
        // switch to IDLE state to check for potential new fragment
        this.state = State.IDLE;
      }
      if (this.media) {
        this.lastCurrentTime = this.media.currentTime;
      }
      // avoid reporting fragment loop loading error in case user is seeking several times on same position
      if (this.fragLoadIdx !== undefined) {
        this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
      }
      // tick to speed up processing
      this.tick();
    }
  }, {
    key: 'onMediaEnded',
    value: function onMediaEnded() {
      // reset startPosition and lastCurrentTime to restart playback @ stream beginning
      this.startPosition = this.lastCurrentTime = 0;
    }
  }, {
    key: 'onAudioTracksUpdated',
    value: function onAudioTracksUpdated(data) {
      _logger.logger.log('audio tracks updated');
      this.tracks = data.audioTracks;
    }
  }, {
    key: 'onAudioTrackSwitching',
    value: function onAudioTrackSwitching(data) {
      // if any URL found on new audio track, it is an alternate audio track
      var altAudio = !!data.url;
      this.trackId = data.id;

      this.fragCurrent = null;
      this.state = State.PAUSED;
      this.waitingFragment = null;
      // destroy useless demuxer when switching audio to main
      if (!altAudio) {
        if (this.demuxer) {
          this.demuxer.destroy();
          this.demuxer = null;
        }
      } else {
        // switching to audio track, start timer if not already started
        if (!this.timer) {
          this.timer = setInterval(this.ontick, 100);
        }
      }

      //should we switch tracks ?
      if (altAudio) {
        this.audioSwitch = true;
        //main audio track are handled by stream-controller, just do something if switching to alt audio track
        this.state = State.IDLE;
        // increase fragment load Index to avoid frag loop loading error after buffer flush
        if (this.fragLoadIdx !== undefined) {
          this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
        }
      }
      this.tick();
    }
  }, {
    key: 'onAudioTrackLoaded',
    value: function onAudioTrackLoaded(data) {
      var newDetails = data.details,
          trackId = data.id,
          track = this.tracks[trackId],
          duration = newDetails.totalduration,
          sliding = 0;

      _logger.logger.log('track ' + trackId + ' loaded [' + newDetails.startSN + ',' + newDetails.endSN + '],duration:' + duration);

      if (newDetails.live) {
        var curDetails = track.details;
        if (curDetails && newDetails.fragments.length > 0) {
          // we already have details for that level, merge them
          _levelHelper2.default.mergeDetails(curDetails, newDetails);
          sliding = newDetails.fragments[0].start;
          // TODO
          //this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
          if (newDetails.PTSKnown) {
            _logger.logger.log('live audio playlist sliding:' + sliding.toFixed(3));
          } else {
            _logger.logger.log('live audio playlist - outdated PTS, unknown sliding');
          }
        } else {
          newDetails.PTSKnown = false;
          _logger.logger.log('live audio playlist - first load, unknown sliding');
        }
      } else {
        newDetails.PTSKnown = false;
      }
      track.details = newDetails;

      // compute start position
      if (!this.startFragRequested) {
        // compute start position if set to -1. use it straight away if value is defined
        if (this.startPosition === -1) {
          // first, check if start time offset has been set in playlist, if yes, use this value
          var startTimeOffset = newDetails.startTimeOffset;
          if (!isNaN(startTimeOffset)) {
            _logger.logger.log('start time offset found in playlist, adjust startPosition to ' + startTimeOffset);
            this.startPosition = startTimeOffset;
          } else {
            this.startPosition = 0;
          }
        }
        this.nextLoadPosition = this.startPosition;
      }
      // only switch batck to IDLE state if we were waiting for track to start downloading a new fragment
      if (this.state === State.WAITING_TRACK) {
        this.state = State.IDLE;
      }
      //trigger handler right now
      this.tick();
    }
  }, {
    key: 'onKeyLoaded',
    value: function onKeyLoaded() {
      if (this.state === State.KEY_LOADING) {
        this.state = State.IDLE;
        this.tick();
      }
    }
  }, {
    key: 'onFragLoaded',
    value: function onFragLoaded(data) {
      var fragCurrent = this.fragCurrent,
          fragLoaded = data.frag;
      if (this.state === State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'audio' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
        var track = this.tracks[this.trackId],
            details = track.details,
            duration = details.totalduration,
            trackId = fragCurrent.level,
            sn = fragCurrent.sn,
            cc = fragCurrent.cc,
            audioCodec = this.config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2',
            stats = this.stats = data.stats;
        if (sn === 'initSegment') {
          this.state = State.IDLE;

          stats.tparsed = stats.tbuffered = performance.now();
          details.initSegment.data = data.payload;
          this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'audio' });
          this.tick();
        } else {
          this.state = State.PARSING;
          // transmux the MPEG-TS data to ISO-BMFF segments
          this.appended = false;
          if (!this.demuxer) {
            this.demuxer = new _demuxer2.default(this.hls, 'audio');
          }
          //Check if we have video initPTS
          // If not we need to wait for it
          var initPTS = this.initPTS[cc];
          var initSegmentData = details.initSegment ? details.initSegment.data : [];
          if (details.initSegment || initPTS !== undefined) {
            this.pendingBuffering = true;
            _logger.logger.log('Demuxing ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],track ' + trackId);
            // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
            var accurateTimeOffset = false; //details.PTSKnown || !details.live;
            this.demuxer.push(data.payload, initSegmentData, audioCodec, null, fragCurrent, duration, accurateTimeOffset, initPTS);
          } else {
            _logger.logger.log('unknown video PTS for continuity counter ' + cc + ', waiting for video PTS before demuxing audio frag ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],track ' + trackId);
            this.waitingFragment = data;
            this.state = State.WAITING_INIT_PTS;
          }
        }
      }
      this.fragLoadError = 0;
    }
  }, {
    key: 'onFragParsingInitSegment',
    value: function onFragParsingInitSegment(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        var tracks = data.tracks,
            track = void 0;

        // delete any video track found on audio demuxer
        if (tracks.video) {
          delete tracks.video;
        }

        // include levelCodec in audio and video tracks
        track = tracks.audio;
        if (track) {
          track.levelCodec = track.codec;
          track.id = data.id;
          this.hls.trigger(_events2.default.BUFFER_CODECS, tracks);
          _logger.logger.log('audio track:audio,container:' + track.container + ',codecs[level/parsed]=[' + track.levelCodec + '/' + track.codec + ']');
          var initSegment = track.initSegment;
          if (initSegment) {
            var appendObj = { type: 'audio', data: initSegment, parent: 'audio', content: 'initSegment' };
            if (this.audioSwitch) {
              this.pendingData = [appendObj];
            } else {
              this.appended = true;
              // arm pending Buffering flag before appending a segment
              this.pendingBuffering = true;
              this.hls.trigger(_events2.default.BUFFER_APPENDING, appendObj);
            }
          }
          //trigger handler right now
          this.tick();
        }
      }
    }
  }, {
    key: 'onFragParsingData',
    value: function onFragParsingData(data) {
      var _this2 = this;

      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'audio' && data.type === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        var trackId = this.trackId,
            track = this.tracks[trackId],
            hls = this.hls;

        if (isNaN(data.endPTS)) {
          data.endPTS = data.startPTS + fragCurrent.duration;
          data.endDTS = data.startDTS + fragCurrent.duration;
        }

        _logger.logger.log('parsed ' + data.type + ',PTS:[' + data.startPTS.toFixed(3) + ',' + data.endPTS.toFixed(3) + '],DTS:[' + data.startDTS.toFixed(3) + '/' + data.endDTS.toFixed(3) + '],nb:' + data.nb);
        _levelHelper2.default.updateFragPTSDTS(track.details, fragCurrent, data.startPTS, data.endPTS);

        var audioSwitch = this.audioSwitch,
            media = this.media,
            appendOnBufferFlush = false;
        //Only flush audio from old audio tracks when PTS is known on new audio track
        if (audioSwitch && media) {
          if (media.readyState) {
            var currentTime = media.currentTime;
            _logger.logger.log('switching audio track : currentTime:' + currentTime);
            if (currentTime >= data.startPTS) {
              _logger.logger.log('switching audio track : flushing all audio');
              this.state = State.BUFFER_FLUSHING;
              hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
              appendOnBufferFlush = true;
              //Lets announce that the initial audio track switch flush occur
              this.audioSwitch = false;
              hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: trackId });
            }
          } else {
            //Lets announce that the initial audio track switch flush occur
            this.audioSwitch = false;
            hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: trackId });
          }
        }

        var pendingData = this.pendingData;
        if (!this.audioSwitch) {
          [data.data1, data.data2].forEach(function (buffer) {
            if (buffer && buffer.length) {
              pendingData.push({ type: data.type, data: buffer, parent: 'audio', content: 'data' });
            }
          });
          if (!appendOnBufferFlush && pendingData.length) {
            pendingData.forEach(function (appendObj) {
              // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
              // in that case it is useless to append following segments
              if (_this2.state === State.PARSING) {
                // arm pending Buffering flag before appending a segment
                _this2.pendingBuffering = true;
                _this2.hls.trigger(_events2.default.BUFFER_APPENDING, appendObj);
              }
            });
            this.pendingData = [];
            this.appended = true;
          }
        }
        //trigger handler right now
        this.tick();
      }
    }
  }, {
    key: 'onFragParsed',
    value: function onFragParsed(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        this.stats.tparsed = performance.now();
        this.state = State.PARSED;
        this._checkAppendedParsed();
      }
    }
  }, {
    key: 'onBufferCreated',
    value: function onBufferCreated(data) {
      var audioTrack = data.tracks.audio;
      if (audioTrack) {
        this.mediaBuffer = audioTrack.buffer;
        this.loadedmetadata = true;
      }
    }
  }, {
    key: 'onBufferAppended',
    value: function onBufferAppended(data) {
      if (data.parent === 'audio') {
        var state = this.state;
        if (state === State.PARSING || state === State.PARSED) {
          // check if all buffers have been appended
          this.pendingBuffering = data.pending > 0;
          this._checkAppendedParsed();
        }
      }
    }
  }, {
    key: '_checkAppendedParsed',
    value: function _checkAppendedParsed() {
      //trigger handler right now
      if (this.state === State.PARSED && (!this.appended || !this.pendingBuffering)) {
        var frag = this.fragCurrent,
            stats = this.stats,
            hls = this.hls;
        if (frag) {
          this.fragPrevious = frag;
          stats.tbuffered = performance.now();
          hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: frag, id: 'audio' });
          var media = this.mediaBuffer ? this.mediaBuffer : this.media;
          _logger.logger.log('audio buffered : ' + _timeRanges2.default.toString(media.buffered));
          if (this.audioSwitch && this.appended) {
            this.audioSwitch = false;
            hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: this.trackId });
          }
          this.state = State.IDLE;
        }
        this.tick();
      }
    }
  }, {
    key: 'onError',
    value: function onError(data) {
      var frag = data.frag;
      // don't handle frag error not related to audio fragment
      if (frag && frag.type !== 'audio') {
        return;
      }
      switch (data.details) {
        case _errors.ErrorDetails.FRAG_LOAD_ERROR:
        case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
          if (!data.fatal) {
            var loadError = this.fragLoadError;
            if (loadError) {
              loadError++;
            } else {
              loadError = 1;
            }
            var config = this.config;
            if (loadError <= config.fragLoadingMaxRetry) {
              this.fragLoadError = loadError;
              // reset load counter to avoid frag loop loading error
              frag.loadCounter = 0;
              // exponential backoff capped to config.fragLoadingMaxRetryTimeout
              var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
              _logger.logger.warn('audioStreamController: frag loading failed, retry in ' + delay + ' ms');
              this.retryDate = performance.now() + delay;
              // retry loading state
              this.state = State.FRAG_LOADING_WAITING_RETRY;
            } else {
              _logger.logger.error('audioStreamController: ' + data.details + ' reaches max retry, redispatch as fatal ...');
              // switch error to fatal
              data.fatal = true;
              this.state = State.ERROR;
            }
          }
          break;
        case _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
        case _errors.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
        case _errors.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
        case _errors.ErrorDetails.KEY_LOAD_ERROR:
        case _errors.ErrorDetails.KEY_LOAD_TIMEOUT:
          //  when in ERROR state, don't switch back to IDLE state in case a non-fatal error is received
          if (this.state !== State.ERROR) {
            // if fatal error, stop processing, otherwise move to IDLE to retry loading
            this.state = data.fatal ? State.ERROR : State.IDLE;
            _logger.logger.warn('audioStreamController: ' + data.details + ' while loading frag,switch to ' + this.state + ' state ...');
          }
          break;
        case _errors.ErrorDetails.BUFFER_FULL_ERROR:
          // if in appending state
          if (data.parent === 'audio' && (this.state === State.PARSING || this.state === State.PARSED)) {
            var media = this.mediaBuffer,
                currentTime = this.media.currentTime,
                mediaBuffered = media && _bufferHelper2.default.isBuffered(media, currentTime) && _bufferHelper2.default.isBuffered(media, currentTime + 0.5);
            // reduce max buf len if current position is buffered
            if (mediaBuffered) {
              var _config = this.config;
              if (_config.maxMaxBufferLength >= _config.maxBufferLength) {
                // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
                _config.maxMaxBufferLength /= 2;
                _logger.logger.warn('audio:reduce max buffer length to ' + _config.maxMaxBufferLength + 's');
                // increase fragment load Index to avoid frag loop loading error after buffer flush
                this.fragLoadIdx += 2 * _config.fragLoadingLoopThreshold;
              }
              this.state = State.IDLE;
            } else {
              // current position is not buffered, but browser is still complaining about buffer full error
              // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
              // in that case flush the whole audio buffer to recover
              _logger.logger.warn('buffer full error also media.currentTime is not buffered, flush audio buffer');
              this.fragCurrent = null;
              // flush everything
              this.state = State.BUFFER_FLUSHING;
              this.hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
            }
          }
          break;
        default:
          break;
      }
    }
  }, {
    key: 'onBufferFlushed',
    value: function onBufferFlushed() {
      var _this3 = this;

      var pendingData = this.pendingData;
      if (pendingData && pendingData.length) {
        _logger.logger.log('appending pending audio data on Buffer Flushed');
        pendingData.forEach(function (appendObj) {
          _this3.hls.trigger(_events2.default.BUFFER_APPENDING, appendObj);
        });
        this.appended = true;
        this.pendingData = [];
        this.state = State.PARSED;
      } else {
        // move to IDLE once flush complete. this should trigger new fragment loading
        this.state = State.IDLE;
        // reset reference to frag
        this.fragPrevious = null;
        this.tick();
      }
    }
  }, {
    key: 'state',
    set: function set(nextState) {
      if (this.state !== nextState) {
        var previousState = this.state;
        this._state = nextState;
        _logger.logger.log('audio stream:' + previousState + '->' + nextState);
      }
    },
    get: function get() {
      return this._state;
    }
  }]);

  return AudioStreamController;
}(_eventHandler2.default);

exports.default = AudioStreamController;

},{"25":25,"33":33,"34":34,"35":35,"37":37,"38":38,"48":48,"51":51,"54":54,"55":55}],7:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = _dereq_(54);

var _errors = _dereq_(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * audio track controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var AudioTrackController = function (_EventHandler) {
  _inherits(AudioTrackController, _EventHandler);

  function AudioTrackController(hls) {
    _classCallCheck(this, AudioTrackController);

    var _this = _possibleConstructorReturn(this, (AudioTrackController.__proto__ || Object.getPrototypeOf(AudioTrackController)).call(this, hls, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_LOADED, _events2.default.AUDIO_TRACK_LOADED, _events2.default.ERROR));

    _this.ticks = 0;
    _this.ontick = _this.tick.bind(_this);
    return _this;
  }

  _createClass(AudioTrackController, [{
    key: 'destroy',
    value: function destroy() {
      this.cleanTimer();
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'cleanTimer',
    value: function cleanTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }, {
    key: 'tick',
    value: function tick() {
      this.ticks++;
      if (this.ticks === 1) {
        this.doTick();
        if (this.ticks > 1) {
          setTimeout(this.tick, 1);
        }
        this.ticks = 0;
      }
    }
  }, {
    key: 'doTick',
    value: function doTick() {
      this.updateTrack(this.trackId);
    }
  }, {
    key: 'onError',
    value: function onError(data) {
      if (data.fatal && data.type === _errors.ErrorTypes.NETWORK_ERROR) {
        this.cleanTimer();
      }
    }
  }, {
    key: 'onManifestLoading',
    value: function onManifestLoading() {
      // reset audio tracks on manifest loading
      this.tracks = [];
      this.trackId = -1;
    }
  }, {
    key: 'onManifestLoaded',
    value: function onManifestLoaded(data) {
      var _this2 = this;

      var tracks = data.audioTracks || [];
      var defaultFound = false;
      this.tracks = tracks;
      this.hls.trigger(_events2.default.AUDIO_TRACKS_UPDATED, { audioTracks: tracks });
      // loop through available audio tracks and autoselect default if needed
      var id = 0;
      tracks.forEach(function (track) {
        if (track.default && !defaultFound) {
          _this2.audioTrack = id;
          defaultFound = true;
          return;
        }
        id++;
      });
      if (defaultFound === false && tracks.length) {
        _logger.logger.log('no default audio track defined, use first audio track as default');
        this.audioTrack = 0;
      }
    }
  }, {
    key: 'onAudioTrackLoaded',
    value: function onAudioTrackLoaded(data) {
      if (data.id < this.tracks.length) {
        _logger.logger.log('audioTrack ' + data.id + ' loaded');
        this.tracks[data.id].details = data.details;
        // check if current playlist is a live playlist
        if (data.details.live && !this.timer) {
          // if live playlist we will have to reload it periodically
          // set reload period to playlist target duration
          this.timer = setInterval(this.ontick, 1000 * data.details.targetduration);
        }
        if (!data.details.live && this.timer) {
          // playlist is not live and timer is armed : stopping it
          this.cleanTimer();
        }
      }
    }

    /** get alternate audio tracks list from playlist **/

  }, {
    key: 'setAudioTrackInternal',
    value: function setAudioTrackInternal(newId) {
      // check if level idx is valid
      if (newId >= 0 && newId < this.tracks.length) {
        // stopping live reloading timer if any
        this.cleanTimer();
        this.trackId = newId;
        _logger.logger.log('switching to audioTrack ' + newId);
        var audioTrack = this.tracks[newId],
            hls = this.hls,
            type = audioTrack.type,
            url = audioTrack.url,
            eventObj = { id: newId, type: type, url: url };
        // keep AUDIO_TRACK_SWITCH for legacy reason
        hls.trigger(_events2.default.AUDIO_TRACK_SWITCH, eventObj);
        hls.trigger(_events2.default.AUDIO_TRACK_SWITCHING, eventObj);
        // check if we need to load playlist for this audio Track
        var details = audioTrack.details;
        if (url && (details === undefined || details.live === true)) {
          // track not retrieved yet, or live playlist we need to (re)load it
          _logger.logger.log('(re)loading playlist for audioTrack ' + newId);
          hls.trigger(_events2.default.AUDIO_TRACK_LOADING, { url: url, id: newId });
        }
      }
    }
  }, {
    key: 'updateTrack',
    value: function updateTrack(newId) {
      // check if level idx is valid
      if (newId >= 0 && newId < this.tracks.length) {
        // stopping live reloading timer if any
        this.cleanTimer();
        this.trackId = newId;
        _logger.logger.log('updating audioTrack ' + newId);
        var audioTrack = this.tracks[newId],
            url = audioTrack.url;
        // check if we need to load playlist for this audio Track
        var details = audioTrack.details;
        if (url && (details === undefined || details.live === true)) {
          // track not retrieved yet, or live playlist we need to (re)load it
          _logger.logger.log('(re)loading playlist for audioTrack ' + newId);
          this.hls.trigger(_events2.default.AUDIO_TRACK_LOADING, { url: url, id: newId });
        }
      }
    }
  }, {
    key: 'audioTracks',
    get: function get() {
      return this.tracks;
    }

    /** get index of the selected audio track (index in audio track lists) **/

  }, {
    key: 'audioTrack',
    get: function get() {
      return this.trackId;
    }

    /** select an audio track, based on its index in audio track lists**/
    ,
    set: function set(audioTrackId) {
      if (this.trackId !== audioTrackId || this.tracks[audioTrackId].details === undefined) {
        this.setAudioTrackInternal(audioTrackId);
      }
    }
  }]);

  return AudioTrackController;
}(_eventHandler2.default);

exports.default = AudioTrackController;

},{"33":33,"34":34,"35":35,"54":54}],8:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = _dereq_(54);

var _errors = _dereq_(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Buffer Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var BufferController = function (_EventHandler) {
  _inherits(BufferController, _EventHandler);

  function BufferController(hls) {
    _classCallCheck(this, BufferController);

    // the value that we have set mediasource.duration to
    // (the actual duration may be tweaked slighly by the browser)
    var _this = _possibleConstructorReturn(this, (BufferController.__proto__ || Object.getPrototypeOf(BufferController)).call(this, hls, _events2.default.MEDIA_ATTACHING, _events2.default.MEDIA_DETACHING, _events2.default.MANIFEST_PARSED, _events2.default.BUFFER_RESET, _events2.default.BUFFER_APPENDING, _events2.default.BUFFER_CODECS, _events2.default.BUFFER_EOS, _events2.default.BUFFER_FLUSHING, _events2.default.LEVEL_PTS_UPDATED, _events2.default.LEVEL_UPDATED));

    _this._msDuration = null;
    // the value that we want to set mediaSource.duration to
    _this._levelDuration = null;

    // Source Buffer listeners
    _this.onsbue = _this.onSBUpdateEnd.bind(_this);
    _this.onsbe = _this.onSBUpdateError.bind(_this);
    _this.pendingTracks = {};
    _this.tracks = {};
    return _this;
  }

  _createClass(BufferController, [{
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onLevelPtsUpdated',
    value: function onLevelPtsUpdated(data) {
      var type = data.type;
      var audioTrack = this.tracks.audio;

      // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
      // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
      // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos). At the time of change we issue
      // `SourceBuffer.abort()` and adjusting `SourceBuffer.timestampOffset` if `SourceBuffer.updating` is false or awaiting `updateend`
      // event if SB is in updating state.
      // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486

      if (type === 'audio' && audioTrack && audioTrack.container === 'audio/mpeg') {
        // Chrome audio mp3 track
        var audioBuffer = this.sourceBuffer.audio;
        var delta = Math.abs(audioBuffer.timestampOffset - data.start);

        // adjust timestamp offset if time delta is greater than 100ms
        if (delta > 0.1) {
          var updating = audioBuffer.updating;

          try {
            audioBuffer.abort();
          } catch (err) {
            updating = true;
            _logger.logger.warn('can not abort audio buffer: ' + err);
          }

          if (!updating) {
            _logger.logger.warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + data.start);
            audioBuffer.timestampOffset = data.start;
          } else {
            this.audioTimestampOffset = data.start;
          }
        }
      }
    }
  }, {
    key: 'onManifestParsed',
    value: function onManifestParsed(data) {
      var audioExpected = data.audio,
          videoExpected = data.video || data.levels.length && data.audio,
          sourceBufferNb = 0;
      // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
      // sourcebuffers will be created all at once when the expected nb of tracks will be reached
      // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
      // it will contain the expected nb of source buffers, no need to compute it
      if (data.altAudio && (audioExpected || videoExpected)) {
        sourceBufferNb = (audioExpected ? 1 : 0) + (videoExpected ? 1 : 0);
        _logger.logger.log(sourceBufferNb + ' sourceBuffer(s) expected');
      }
      this.sourceBufferNb = sourceBufferNb;
    }
  }, {
    key: 'onMediaAttaching',
    value: function onMediaAttaching(data) {
      var media = this.media = data.media;
      if (media) {
        // setup the media source
        var ms = this.mediaSource = new MediaSource();
        //Media Source listeners
        this.onmso = this.onMediaSourceOpen.bind(this);
        this.onmse = this.onMediaSourceEnded.bind(this);
        this.onmsc = this.onMediaSourceClose.bind(this);
        ms.addEventListener('sourceopen', this.onmso);
        ms.addEventListener('sourceended', this.onmse);
        ms.addEventListener('sourceclose', this.onmsc);
        // link video and media Source
        media.src = URL.createObjectURL(ms);
      }
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      _logger.logger.log('media source detaching');
      var ms = this.mediaSource;
      if (ms) {
        if (ms.readyState === 'open') {
          try {
            // endOfStream could trigger exception if any sourcebuffer is in updating state
            // we don't really care about checking sourcebuffer state here,
            // as we are anyway detaching the MediaSource
            // let's just avoid this exception to propagate
            ms.endOfStream();
          } catch (err) {
            _logger.logger.warn('onMediaDetaching:' + err.message + ' while calling endOfStream');
          }
        }
        ms.removeEventListener('sourceopen', this.onmso);
        ms.removeEventListener('sourceended', this.onmse);
        ms.removeEventListener('sourceclose', this.onmsc);

        // Detach properly the MediaSource from the HTMLMediaElement as
        // suggested in https://github.com/w3c/media-source/issues/53.
        if (this.media) {
          URL.revokeObjectURL(this.media.src);
          this.media.removeAttribute('src');
          this.media.load();
        }

        this.mediaSource = null;
        this.media = null;
        this.pendingTracks = {};
        this.tracks = {};
        this.sourceBuffer = {};
        this.flushRange = [];
        this.segments = [];
        this.appended = 0;
      }
      this.onmso = this.onmse = this.onmsc = null;
      this.hls.trigger(_events2.default.MEDIA_DETACHED);
    }
  }, {
    key: 'onMediaSourceOpen',
    value: function onMediaSourceOpen() {
      _logger.logger.log('media source opened');
      this.hls.trigger(_events2.default.MEDIA_ATTACHED, { media: this.media });
      var mediaSource = this.mediaSource;
      if (mediaSource) {
        // once received, don't listen anymore to sourceopen event
        mediaSource.removeEventListener('sourceopen', this.onmso);
      }
      this.checkPendingTracks();
    }
  }, {
    key: 'checkPendingTracks',
    value: function checkPendingTracks() {
      // if any buffer codecs pending, check if we have enough to create sourceBuffers
      var pendingTracks = this.pendingTracks,
          pendingTracksNb = Object.keys(pendingTracks).length;
      // if any pending tracks and (if nb of pending tracks gt or equal than expected nb or if unknown expected nb)
      if (pendingTracksNb && (this.sourceBufferNb <= pendingTracksNb || this.sourceBufferNb === 0)) {
        // ok, let's create them now !
        this.createSourceBuffers(pendingTracks);
        this.pendingTracks = {};
        // append any pending segments now !
        this.doAppending();
      }
    }
  }, {
    key: 'onMediaSourceClose',
    value: function onMediaSourceClose() {
      _logger.logger.log('media source closed');
    }
  }, {
    key: 'onMediaSourceEnded',
    value: function onMediaSourceEnded() {
      _logger.logger.log('media source ended');
    }
  }, {
    key: 'onSBUpdateEnd',
    value: function onSBUpdateEnd() {
      // update timestampOffset
      if (this.audioTimestampOffset) {
        var audioBuffer = this.sourceBuffer.audio;
        _logger.logger.warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + this.audioTimestampOffset);
        audioBuffer.timestampOffset = this.audioTimestampOffset;
        delete this.audioTimestampOffset;
      }

      if (this._needsFlush) {
        this.doFlush();
      }

      if (this._needsEos) {
        this.checkEos();
      }
      this.appending = false;
      var parent = this.parent;
      // count nb of pending segments waiting for appending on this sourcebuffer
      var pending = this.segments.reduce(function (counter, segment) {
        return segment.parent === parent ? counter + 1 : counter;
      }, 0);
      this.hls.trigger(_events2.default.BUFFER_APPENDED, { parent: parent, pending: pending });

      // don't append in flushing mode
      if (!this._needsFlush) {
        this.doAppending();
      }

      this.updateMediaElementDuration();
    }
  }, {
    key: 'onSBUpdateError',
    value: function onSBUpdateError(event) {
      _logger.logger.error('sourceBuffer error:', event);
      // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
      // this error might not always be fatal (it is fatal if decode error is set, in that case
      // it will be followed by a mediaElement error ...)
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: false });
      // we don't need to do more than that, as accordin to the spec, updateend will be fired just after
    }
  }, {
    key: 'onBufferReset',
    value: function onBufferReset() {
      var sourceBuffer = this.sourceBuffer;
      for (var type in sourceBuffer) {
        var sb = sourceBuffer[type];
        try {
          this.mediaSource.removeSourceBuffer(sb);
          sb.removeEventListener('updateend', this.onsbue);
          sb.removeEventListener('error', this.onsbe);
        } catch (err) {}
      }
      this.sourceBuffer = {};
      this.flushRange = [];
      this.segments = [];
      this.appended = 0;
    }
  }, {
    key: 'onBufferCodecs',
    value: function onBufferCodecs(tracks) {
      // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
      // if sourcebuffers already created, do nothing ...
      if (Object.keys(this.sourceBuffer).length === 0) {
        for (var trackName in tracks) {
          this.pendingTracks[trackName] = tracks[trackName];
        }
        var mediaSource = this.mediaSource;
        if (mediaSource && mediaSource.readyState === 'open') {
          // try to create sourcebuffers if mediasource opened
          this.checkPendingTracks();
        }
      }
    }
  }, {
    key: 'createSourceBuffers',
    value: function createSourceBuffers(tracks) {
      var sourceBuffer = this.sourceBuffer,
          mediaSource = this.mediaSource;

      for (var trackName in tracks) {
        if (!sourceBuffer[trackName]) {
          var track = tracks[trackName];
          // use levelCodec as first priority
          var codec = track.levelCodec || track.codec;
          var mimeType = track.container + ';codecs=' + codec;
          _logger.logger.log('creating sourceBuffer(' + mimeType + ')');
          try {
            var sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
            sb.addEventListener('updateend', this.onsbue);
            sb.addEventListener('error', this.onsbe);
            this.tracks[trackName] = { codec: codec, container: track.container };
            track.buffer = sb;
          } catch (err) {
            _logger.logger.error('error while trying to add sourceBuffer:' + err.message);
            this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_ADD_CODEC_ERROR, fatal: false, err: err, mimeType: mimeType });
          }
        }
      }
      this.hls.trigger(_events2.default.BUFFER_CREATED, { tracks: tracks });
    }
  }, {
    key: 'onBufferAppending',
    value: function onBufferAppending(data) {
      if (!this._needsFlush) {
        if (!this.segments) {
          this.segments = [data];
        } else {
          this.segments.push(data);
        }
        this.doAppending();
      }
    }
  }, {
    key: 'onBufferAppendFail',
    value: function onBufferAppendFail(data) {
      _logger.logger.error('sourceBuffer error:', data.event);
      // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
      // this error might not always be fatal (it is fatal if decode error is set, in that case
      // it will be followed by a mediaElement error ...)
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: false });
    }

    // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()

  }, {
    key: 'onBufferEos',
    value: function onBufferEos(data) {
      var sb = this.sourceBuffer;
      var dataType = data.type;
      for (var type in sb) {
        if (!dataType || type === dataType) {
          if (!sb[type].ended) {
            sb[type].ended = true;
            _logger.logger.log(type + ' sourceBuffer now EOS');
          }
        }
      }
      this.checkEos();
    }

    // if all source buffers are marked as ended, signal endOfStream() to MediaSource.

  }, {
    key: 'checkEos',
    value: function checkEos() {
      var sb = this.sourceBuffer,
          mediaSource = this.mediaSource;
      if (!mediaSource || mediaSource.readyState !== 'open') {
        this._needsEos = false;
        return;
      }
      for (var type in sb) {
        var sbobj = sb[type];
        if (!sbobj.ended) {
          return;
        }
        if (sbobj.updating) {
          this._needsEos = true;
          return;
        }
      }
      _logger.logger.log('all media data available, signal endOfStream() to MediaSource and stop loading fragment');
      //Notify the media element that it now has all of the media data
      try {
        mediaSource.endOfStream();
      } catch (e) {
        _logger.logger.warn('exception while calling mediaSource.endOfStream()');
      }
      this._needsEos = false;
    }
  }, {
    key: 'onBufferFlushing',
    value: function onBufferFlushing(data) {
      this.flushRange.push({ start: data.startOffset, end: data.endOffset, type: data.type });
      // attempt flush immediatly
      this.flushBufferCounter = 0;
      this.doFlush();
    }
  }, {
    key: 'onLevelUpdated',
    value: function onLevelUpdated(event) {
      var details = event.details;
      if (details.fragments.length === 0) {
        return;
      }
      this._levelDuration = details.totalduration + details.fragments[0].start;
      this.updateMediaElementDuration();
    }

    // https://github.com/video-dev/hls.js/issues/355

  }, {
    key: 'updateMediaElementDuration',
    value: function updateMediaElementDuration() {
      var media = this.media,
          mediaSource = this.mediaSource,
          sourceBuffer = this.sourceBuffer,
          levelDuration = this._levelDuration;
      if (levelDuration === null || !media || !mediaSource || !sourceBuffer || media.readyState === 0 || mediaSource.readyState !== 'open') {
        return;
      }
      for (var type in sourceBuffer) {
        if (sourceBuffer[type].updating) {
          // can't set duration whilst a buffer is updating
          return;
        }
      }
      if (this._msDuration === null) {
        // initialise to the value that the media source is reporting
        this._msDuration = mediaSource.duration;
      }
      var duration = media.duration;
      // levelDuration was the last value we set.
      // not using mediaSource.duration as the browser may tweak this value
      // only update mediasource duration if its value increase, this is to avoid
      // flushing already buffered portion when switching between quality level
      if (levelDuration > this._msDuration && levelDuration > duration || duration === Infinity || isNaN(duration)) {
        _logger.logger.log('Updating mediasource duration to ' + levelDuration.toFixed(3));
        this._msDuration = mediaSource.duration = levelDuration;
      }
    }
  }, {
    key: 'doFlush',
    value: function doFlush() {
      // loop through all buffer ranges to flush
      while (this.flushRange.length) {
        var range = this.flushRange[0];
        // flushBuffer will abort any buffer append in progress and flush Audio/Video Buffer
        if (this.flushBuffer(range.start, range.end, range.type)) {
          // range flushed, remove from flush array
          this.flushRange.shift();
          this.flushBufferCounter = 0;
        } else {
          this._needsFlush = true;
          // avoid looping, wait for SB update end to retrigger a flush
          return;
        }
      }
      if (this.flushRange.length === 0) {
        // everything flushed
        this._needsFlush = false;

        // let's recompute this.appended, which is used to avoid flush looping
        var appended = 0;
        var sourceBuffer = this.sourceBuffer;
        try {
          for (var type in sourceBuffer) {
            appended += sourceBuffer[type].buffered.length;
          }
        } catch (error) {
          // error could be thrown while accessing buffered, in case sourcebuffer has already been removed from MediaSource
          // this is harmess at this stage, catch this to avoid reporting an internal exception
          _logger.logger.error('error while accessing sourceBuffer.buffered');
        }
        this.appended = appended;
        this.hls.trigger(_events2.default.BUFFER_FLUSHED);
      }
    }
  }, {
    key: 'doAppending',
    value: function doAppending() {
      var hls = this.hls,
          sourceBuffer = this.sourceBuffer,
          segments = this.segments;
      if (Object.keys(sourceBuffer).length) {
        if (this.media.error) {
          this.segments = [];
          _logger.logger.error('trying to append although a media error occured, flush segment and abort');
          return;
        }
        if (this.appending) {
          //logger.log(`sb appending in progress`);
          return;
        }
        if (segments && segments.length) {
          var segment = segments.shift();
          try {
            var type = segment.type,
                sb = sourceBuffer[type];
            if (sb) {
              if (!sb.updating) {
                // reset sourceBuffer ended flag before appending segment
                sb.ended = false;
                //logger.log(`appending ${segment.content} ${type} SB, size:${segment.data.length}, ${segment.parent}`);
                this.parent = segment.parent;
                sb.appendBuffer(segment.data);
                this.appendError = 0;
                this.appended++;
                this.appending = true;
              } else {
                segments.unshift(segment);
              }
            } else {
              // in case we don't have any source buffer matching with this segment type,
              // it means that Mediasource fails to create sourcebuffer
              // discard this segment, and trigger update end
              this.onSBUpdateEnd();
            }
          } catch (err) {
            // in case any error occured while appending, put back segment in segments table
            _logger.logger.error('error while trying to append buffer:' + err.message);
            segments.unshift(segment);
            var event = { type: _errors.ErrorTypes.MEDIA_ERROR, parent: segment.parent };
            if (err.code !== 22) {
              if (this.appendError) {
                this.appendError++;
              } else {
                this.appendError = 1;
              }
              event.details = _errors.ErrorDetails.BUFFER_APPEND_ERROR;
              /* with UHD content, we could get loop of quota exceeded error until
                browser is able to evict some data from sourcebuffer. retrying help recovering this
              */
              if (this.appendError > hls.config.appendErrorMaxRetry) {
                _logger.logger.log('fail ' + hls.config.appendErrorMaxRetry + ' times to append segment in sourceBuffer');
                segments = [];
                event.fatal = true;
                hls.trigger(_events2.default.ERROR, event);
                return;
              } else {
                event.fatal = false;
                hls.trigger(_events2.default.ERROR, event);
              }
            } else {
              // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
              // let's stop appending any segments, and report BUFFER_FULL_ERROR error
              this.segments = [];
              event.details = _errors.ErrorDetails.BUFFER_FULL_ERROR;
              event.fatal = false;
              hls.trigger(_events2.default.ERROR, event);
              return;
            }
          }
        }
      }
    }

    /*
      flush specified buffered range,
      return true once range has been flushed.
      as sourceBuffer.remove() is asynchronous, flushBuffer will be retriggered on sourceBuffer update end
    */

  }, {
    key: 'flushBuffer',
    value: function flushBuffer(startOffset, endOffset, typeIn) {
      var sb,
          i,
          bufStart,
          bufEnd,
          flushStart,
          flushEnd,
          sourceBuffer = this.sourceBuffer;
      if (Object.keys(sourceBuffer).length) {
        _logger.logger.log('flushBuffer,pos/start/end: ' + this.media.currentTime.toFixed(3) + '/' + startOffset + '/' + endOffset);
        // safeguard to avoid infinite looping : don't try to flush more than the nb of appended segments
        if (this.flushBufferCounter < this.appended) {
          for (var type in sourceBuffer) {
            // check if sourcebuffer type is defined (typeIn): if yes, let's only flush this one
            // if no, let's flush all sourcebuffers
            if (typeIn && type !== typeIn) {
              continue;
            }
            sb = sourceBuffer[type];
            // we are going to flush buffer, mark source buffer as 'not ended'
            sb.ended = false;
            if (!sb.updating) {
              try {
                for (i = 0; i < sb.buffered.length; i++) {
                  bufStart = sb.buffered.start(i);
                  bufEnd = sb.buffered.end(i);
                  // workaround firefox not able to properly flush multiple buffered range.
                  if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1 && endOffset === Number.POSITIVE_INFINITY) {
                    flushStart = startOffset;
                    flushEnd = endOffset;
                  } else {
                    flushStart = Math.max(bufStart, startOffset);
                    flushEnd = Math.min(bufEnd, endOffset);
                  }
                  /* sometimes sourcebuffer.remove() does not flush
                     the exact expected time range.
                     to avoid rounding issues/infinite loop,
                     only flush buffer range of length greater than 500ms.
                  */
                  if (Math.min(flushEnd, bufEnd) - flushStart > 0.5) {
                    this.flushBufferCounter++;
                    _logger.logger.log('flush ' + type + ' [' + flushStart + ',' + flushEnd + '], of [' + bufStart + ',' + bufEnd + '], pos:' + this.media.currentTime);
                    sb.remove(flushStart, flushEnd);
                    return false;
                  }
                }
              } catch (e) {
                _logger.logger.warn('exception while accessing sourcebuffer, it might have been removed from MediaSource');
              }
            } else {
              //logger.log('abort ' + type + ' append in progress');
              // this will abort any appending in progress
              //sb.abort();
              _logger.logger.warn('cannot flush, sb updating in progress');
              return false;
            }
          }
        } else {
          _logger.logger.warn('abort flushing too many retries');
        }
        _logger.logger.log('buffer flushed');
      }
      // everything flushed !
      return true;
    }
  }]);

  return BufferController;
}(_eventHandler2.default);

exports.default = BufferController;

},{"33":33,"34":34,"35":35,"54":54}],9:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * cap stream level to media size dimension controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var CapLevelController = function (_EventHandler) {
  _inherits(CapLevelController, _EventHandler);

  function CapLevelController(hls) {
    _classCallCheck(this, CapLevelController);

    return _possibleConstructorReturn(this, (CapLevelController.__proto__ || Object.getPrototypeOf(CapLevelController)).call(this, hls, _events2.default.FPS_DROP_LEVEL_CAPPING, _events2.default.MEDIA_ATTACHING, _events2.default.MANIFEST_PARSED));
  }

  _createClass(CapLevelController, [{
    key: 'destroy',
    value: function destroy() {
      if (this.hls.config.capLevelToPlayerSize) {
        this.media = this.restrictedLevels = null;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        if (this.timer) {
          this.timer = clearInterval(this.timer);
        }
      }
    }
  }, {
    key: 'onFpsDropLevelCapping',
    value: function onFpsDropLevelCapping(data) {
      // Don't add a restricted level more than once
      if (CapLevelController.isLevelAllowed(data.droppedLevel, this.restrictedLevels)) {
        this.restrictedLevels.push(data.droppedLevel);
      }
    }
  }, {
    key: 'onMediaAttaching',
    value: function onMediaAttaching(data) {
      this.media = data.media instanceof HTMLVideoElement ? data.media : null;
    }
  }, {
    key: 'onManifestParsed',
    value: function onManifestParsed(data) {
      var hls = this.hls;
      this.restrictedLevels = [];
      if (hls.config.capLevelToPlayerSize) {
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        this.levels = data.levels;
        hls.firstLevel = this.getMaxLevel(data.firstLevel);
        clearInterval(this.timer);
        this.timer = setInterval(this.detectPlayerSize.bind(this), 1000);
        this.detectPlayerSize();
      }
    }
  }, {
    key: 'detectPlayerSize',
    value: function detectPlayerSize() {
      if (this.media) {
        var levelsLength = this.levels ? this.levels.length : 0;
        if (levelsLength) {
          var hls = this.hls;
          hls.autoLevelCapping = this.getMaxLevel(levelsLength - 1);
          if (hls.autoLevelCapping > this.autoLevelCapping) {
            // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
            // usually happen when the user go to the fullscreen mode.
            hls.streamController.nextLevelSwitch();
          }
          this.autoLevelCapping = hls.autoLevelCapping;
        }
      }
    }

    /*
    * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
    */

  }, {
    key: 'getMaxLevel',
    value: function getMaxLevel(capLevelIndex) {
      var _this2 = this;

      if (!this.levels) {
        return -1;
      }

      var validLevels = this.levels.filter(function (level, index) {
        return CapLevelController.isLevelAllowed(index, _this2.restrictedLevels) && index <= capLevelIndex;
      });

      return CapLevelController.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
    }
  }, {
    key: 'mediaWidth',
    get: function get() {
      var width = void 0;
      var media = this.media;
      if (media) {
        width = media.width || media.clientWidth || media.offsetWidth;
        width *= CapLevelController.contentScaleFactor;
      }
      return width;
    }
  }, {
    key: 'mediaHeight',
    get: function get() {
      var height = void 0;
      var media = this.media;
      if (media) {
        height = media.height || media.clientHeight || media.offsetHeight;
        height *= CapLevelController.contentScaleFactor;
      }
      return height;
    }
  }], [{
    key: 'isLevelAllowed',
    value: function isLevelAllowed(level) {
      var restrictedLevels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      return restrictedLevels.indexOf(level) === -1;
    }
  }, {
    key: 'getMaxLevelByMediaSize',
    value: function getMaxLevelByMediaSize(levels, width, height) {
      if (!levels || levels && !levels.length) {
        return -1;
      }

      // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
      // to determine whether we've chosen the greatest bandwidth for the media's dimensions
      var atGreatestBandiwdth = function atGreatestBandiwdth(curLevel, nextLevel) {
        if (!nextLevel) {
          return true;
        }
        return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
      };

      // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
      // the max level
      var maxLevelIndex = levels.length - 1;

      for (var i = 0; i < levels.length; i += 1) {
        var level = levels[i];
        if ((level.width >= width || level.height >= height) && atGreatestBandiwdth(level, levels[i + 1])) {
          maxLevelIndex = i;
          break;
        }
      }

      return maxLevelIndex;
    }
  }, {
    key: 'contentScaleFactor',
    get: function get() {
      var pixelRatio = 1;
      try {
        pixelRatio = window.devicePixelRatio;
      } catch (e) {}
      return pixelRatio;
    }
  }]);

  return CapLevelController;
}(_eventHandler2.default);

exports.default = CapLevelController;

},{"34":34,"35":35}],10:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = _dereq_(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FPS Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var FPSController = function (_EventHandler) {
  _inherits(FPSController, _EventHandler);

  function FPSController(hls) {
    _classCallCheck(this, FPSController);

    return _possibleConstructorReturn(this, (FPSController.__proto__ || Object.getPrototypeOf(FPSController)).call(this, hls, _events2.default.MEDIA_ATTACHING));
  }

  _createClass(FPSController, [{
    key: 'destroy',
    value: function destroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.isVideoPlaybackQualityAvailable = false;
    }
  }, {
    key: 'onMediaAttaching',
    value: function onMediaAttaching(data) {
      var config = this.hls.config;
      if (config.capLevelOnFPSDrop) {
        var video = this.video = data.media instanceof HTMLVideoElement ? data.media : null;
        if (typeof video.getVideoPlaybackQuality === 'function') {
          this.isVideoPlaybackQualityAvailable = true;
        }
        clearInterval(this.timer);
        this.timer = setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
      }
    }
  }, {
    key: 'checkFPS',
    value: function checkFPS(video, decodedFrames, droppedFrames) {
      var currentTime = performance.now();
      if (decodedFrames) {
        if (this.lastTime) {
          var currentPeriod = currentTime - this.lastTime,
              currentDropped = droppedFrames - this.lastDroppedFrames,
              currentDecoded = decodedFrames - this.lastDecodedFrames,
              droppedFPS = 1000 * currentDropped / currentPeriod,
              hls = this.hls;
          hls.trigger(_events2.default.FPS_DROP, { currentDropped: currentDropped, currentDecoded: currentDecoded, totalDroppedFrames: droppedFrames });
          if (droppedFPS > 0) {
            //logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
            if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
              var currentLevel = hls.currentLevel;
              _logger.logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
              if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
                currentLevel = currentLevel - 1;
                hls.trigger(_events2.default.FPS_DROP_LEVEL_CAPPING, { level: currentLevel, droppedLevel: hls.currentLevel });
                hls.autoLevelCapping = currentLevel;
                hls.streamController.nextLevelSwitch();
              }
            }
          }
        }
        this.lastTime = currentTime;
        this.lastDroppedFrames = droppedFrames;
        this.lastDecodedFrames = decodedFrames;
      }
    }
  }, {
    key: 'checkFPSInterval',
    value: function checkFPSInterval() {
      var video = this.video;
      if (video) {
        if (this.isVideoPlaybackQualityAvailable) {
          var videoPlaybackQuality = video.getVideoPlaybackQuality();
          this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
        } else {
          this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
        }
      }
    }
  }]);

  return FPSController;
}(_eventHandler2.default);

exports.default = FPSController;

},{"34":34,"35":35,"54":54}],11:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _id = _dereq_(27);

var _id2 = _interopRequireDefault(_id);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * id3 metadata track controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var ID3TrackController = function (_EventHandler) {
  _inherits(ID3TrackController, _EventHandler);

  function ID3TrackController(hls) {
    _classCallCheck(this, ID3TrackController);

    var _this = _possibleConstructorReturn(this, (ID3TrackController.__proto__ || Object.getPrototypeOf(ID3TrackController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.FRAG_PARSING_METADATA));

    _this.id3Track = undefined;
    _this.media = undefined;
    return _this;
  }

  _createClass(ID3TrackController, [{
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }

    // Add ID3 metatadata text track.

  }, {
    key: 'onMediaAttached',
    value: function onMediaAttached(data) {
      this.media = data.media;
      if (!this.media) {
        return;
      }

      this.id3Track = this.media.addTextTrack('metadata', 'id3');
      this.id3Track.mode = 'hidden';
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      this.media = undefined;
    }
  }, {
    key: 'onFragParsingMetadata',
    value: function onFragParsingMetadata(data) {
      var fragment = data.frag;
      var samples = data.samples;

      // Attempt to recreate Safari functionality by creating
      // WebKitDataCue objects when available and store the decoded
      // ID3 data in the value property of the cue
      var Cue = window.WebKitDataCue || window.VTTCue || window.TextTrackCue;

      for (var i = 0; i < samples.length; i++) {
        var frames = _id2.default.getID3Frames(samples[i].data);
        if (frames) {
          var startTime = samples[i].pts;
          var endTime = i < samples.length - 1 ? samples[i + 1].pts : fragment.endPTS;

          // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
          if (startTime === endTime) {
            endTime += 0.0001;
          }

          for (var j = 0; j < frames.length; j++) {
            var frame = frames[j];
            // Safari doesn't put the timestamp frame in the TextTrack
            if (!_id2.default.isTimeStampFrame(frame)) {
              var cue = new Cue(startTime, endTime, '');
              cue.value = frame;
              this.id3Track.addCue(cue);
            }
          }
        }
      }
    }
  }]);

  return ID3TrackController;
}(_eventHandler2.default);

exports.default = ID3TrackController;

},{"27":27,"34":34,"35":35}],12:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = _dereq_(54);

var _errors = _dereq_(33);

var _bufferHelper = _dereq_(37);

var _bufferHelper2 = _interopRequireDefault(_bufferHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Level Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var LevelController = function (_EventHandler) {
  _inherits(LevelController, _EventHandler);

  function LevelController(hls) {
    _classCallCheck(this, LevelController);

    var _this = _possibleConstructorReturn(this, (LevelController.__proto__ || Object.getPrototypeOf(LevelController)).call(this, hls, _events2.default.MANIFEST_LOADED, _events2.default.LEVEL_LOADED, _events2.default.FRAG_LOADED, _events2.default.ERROR));

    _this.ontick = _this.tick.bind(_this);
    _this._manualLevel = -1;
    return _this;
  }

  _createClass(LevelController, [{
    key: 'destroy',
    value: function destroy() {
      this.cleanTimer();
      this._manualLevel = -1;
    }
  }, {
    key: 'cleanTimer',
    value: function cleanTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }, {
    key: 'startLoad',
    value: function startLoad() {
      this.canload = true;
      var levels = this._levels;
      // clean up live level details to force reload them, and reset load errors
      if (levels) {
        levels.forEach(function (level) {
          level.loadError = 0;
          var levelDetails = level.details;
          if (levelDetails && levelDetails.live) {
            level.details = undefined;
          }
        });
      }
      // speed up live playlist refresh if timer exists
      if (this.timer) {
        this.tick();
      }
    }
  }, {
    key: 'stopLoad',
    value: function stopLoad() {
      this.canload = false;
    }
  }, {
    key: 'onManifestLoaded',
    value: function onManifestLoaded(data) {
      var levels0 = [],
          levels = [],
          bitrateStart,
          bitrateSet = {},
          videoCodecFound = false,
          audioCodecFound = false,
          hls = this.hls,
          brokenmp4inmp3 = /chrome|firefox/.test(navigator.userAgent.toLowerCase()),
          checkSupported = function checkSupported(type, codec) {
        return MediaSource.isTypeSupported(type + '/mp4;codecs=' + codec);
      };

      // regroup redundant level together
      data.levels.forEach(function (level) {
        if (level.videoCodec) {
          videoCodecFound = true;
        }
        // erase audio codec info if browser does not support mp4a.40.34. demuxer will autodetect codec and fallback to mpeg/audio
        if (brokenmp4inmp3 && level.audioCodec && level.audioCodec.indexOf('mp4a.40.34') !== -1) {
          level.audioCodec = undefined;
        }
        if (level.audioCodec || level.attrs && level.attrs.AUDIO) {
          audioCodecFound = true;
        }
        var redundantLevelId = bitrateSet[level.bitrate];
        if (redundantLevelId === undefined) {
          bitrateSet[level.bitrate] = levels0.length;
          level.url = [level.url];
          level.urlId = 0;
          levels0.push(level);
        } else {
          levels0[redundantLevelId].url.push(level.url);
        }
      });

      // remove audio-only level if we also have levels with audio+video codecs signalled
      if (videoCodecFound && audioCodecFound) {
        levels0.forEach(function (level) {
          if (level.videoCodec) {
            levels.push(level);
          }
        });
      } else {
        levels = levels0;
      }
      // only keep level with supported audio/video codecs
      levels = levels.filter(function (level) {
        var audioCodec = level.audioCodec,
            videoCodec = level.videoCodec;
        return (!audioCodec || checkSupported('audio', audioCodec)) && (!videoCodec || checkSupported('video', videoCodec));
      });

      if (levels.length) {
        // start bitrate is the first bitrate of the manifest
        bitrateStart = levels[0].bitrate;
        // sort level on bitrate
        levels.sort(function (a, b) {
          return a.bitrate - b.bitrate;
        });
        this._levels = levels;
        // find index of first level in sorted levels
        for (var i = 0; i < levels.length; i++) {
          if (levels[i].bitrate === bitrateStart) {
            this._firstLevel = i;
            _logger.logger.log('manifest loaded,' + levels.length + ' level(s) found, first bitrate:' + bitrateStart);
            break;
          }
        }
        hls.trigger(_events2.default.MANIFEST_PARSED, { levels: levels, firstLevel: this._firstLevel, stats: data.stats, audio: audioCodecFound, video: videoCodecFound, altAudio: data.audioTracks.length > 0 });
      } else {
        hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR, fatal: true, url: hls.url, reason: 'no level with compatible codecs found in manifest' });
      }
      return;
    }
  }, {
    key: 'setLevelInternal',
    value: function setLevelInternal(newLevel) {
      var levels = this._levels;
      var hls = this.hls;
      // check if level idx is valid
      if (newLevel >= 0 && newLevel < levels.length) {
        // stopping live reloading timer if any
        this.cleanTimer();
        if (this._level !== newLevel) {
          _logger.logger.log('switching to level ' + newLevel);
          this._level = newLevel;
          var levelProperties = levels[newLevel];
          levelProperties.level = newLevel;
          // LEVEL_SWITCH to be deprecated in next major release
          hls.trigger(_events2.default.LEVEL_SWITCH, levelProperties);
          hls.trigger(_events2.default.LEVEL_SWITCHING, levelProperties);
        }
        var level = levels[newLevel],
            levelDetails = level.details;
        // check if we need to load playlist for this level
        if (!levelDetails || levelDetails.live === true) {
          // level not retrieved yet, or live playlist we need to (re)load it
          var urlId = level.urlId;
          hls.trigger(_events2.default.LEVEL_LOADING, { url: level.url[urlId], level: newLevel, id: urlId });
        }
      } else {
        // invalid level id given, trigger error
        hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.OTHER_ERROR, details: _errors.ErrorDetails.LEVEL_SWITCH_ERROR, level: newLevel, fatal: false, reason: 'invalid level idx' });
      }
    }
  }, {
    key: 'onError',
    value: function onError(data) {
      if (data.fatal) {
        if (data.type === _errors.ErrorTypes.NETWORK_ERROR) {
          this.cleanTimer();
        }
        return;
      }

      var details = data.details,
          hls = this.hls,
          levelId = void 0,
          level = void 0,
          levelError = false;
      // try to recover not fatal errors
      switch (details) {
        case _errors.ErrorDetails.FRAG_LOAD_ERROR:
        case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
        case _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
        case _errors.ErrorDetails.KEY_LOAD_ERROR:
        case _errors.ErrorDetails.KEY_LOAD_TIMEOUT:
          levelId = data.frag.level;
          break;
        case _errors.ErrorDetails.LEVEL_LOAD_ERROR:
        case _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT:
          levelId = data.context.level;
          levelError = true;
          break;
        case _errors.ErrorDetails.REMUX_ALLOC_ERROR:
          levelId = data.level;
          break;
        default:
          break;
      }
      /* try to switch to a redundant stream if any available.
       * if no redundant stream available, emergency switch down (if in auto mode and current level not 0)
       * otherwise, we cannot recover this network error ...
       */
      if (levelId !== undefined) {
        level = this._levels[levelId];
        if (!level.loadError) {
          level.loadError = 1;
        } else {
          level.loadError++;
        }
        // if any redundant streams available and if we haven't try them all (level.loadError is reseted on successful frag/level load.
        // if level.loadError reaches nbRedundantLevel it means that we tried them all, no hope  => let's switch down
        var nbRedundantLevel = level.url.length;
        if (nbRedundantLevel > 1 && level.loadError < nbRedundantLevel) {
          level.urlId = (level.urlId + 1) % nbRedundantLevel;
          level.details = undefined;
          _logger.logger.warn('level controller,' + details + ' for level ' + levelId + ': switching to redundant stream id ' + level.urlId);
        } else {
          // we could try to recover if in auto mode and current level not lowest level (0)
          var recoverable = this._manualLevel === -1 && levelId;
          if (recoverable) {
            _logger.logger.warn('level controller,' + details + ': switch-down for next fragment');
            hls.nextAutoLevel = Math.max(0, levelId - 1);
          } else if (level && level.details && level.details.live) {
            _logger.logger.warn('level controller,' + details + ' on live stream, discard');
            if (levelError) {
              // reset this._level so that another call to set level() will retrigger a frag load
              this._level = undefined;
            }
            // other errors are handled by stream controller
          } else if (details === _errors.ErrorDetails.LEVEL_LOAD_ERROR || details === _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT) {
            var media = hls.media,

            // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
            mediaBuffered = media && _bufferHelper2.default.isBuffered(media, media.currentTime) && _bufferHelper2.default.isBuffered(media, media.currentTime + 0.5);
            if (mediaBuffered) {
              var retryDelay = hls.config.levelLoadingRetryDelay;
              _logger.logger.warn('level controller,' + details + ', but media buffered, retry in ' + retryDelay + 'ms');
              this.timer = setTimeout(this.ontick, retryDelay);
              // boolean used to inform stream controller not to switch back to IDLE on non fatal error
              data.levelRetry = true;
            } else {
              _logger.logger.error('cannot recover ' + details + ' error');
              this._level = undefined;
              // stopping live reloading timer if any
              this.cleanTimer();
              // switch error to fatal
              data.fatal = true;
            }
          }
        }
      }
    }

    // reset level load error counter on successful frag loaded

  }, {
    key: 'onFragLoaded',
    value: function onFragLoaded(data) {
      var fragLoaded = data.frag;
      if (fragLoaded && fragLoaded.type === 'main') {
        var level = this._levels[fragLoaded.level];
        if (level) {
          level.loadError = 0;
        }
      }
    }
  }, {
    key: 'onLevelLoaded',
    value: function onLevelLoaded(data) {
      var levelId = data.level;
      // only process level loaded events matching with expected level
      if (levelId === this._level) {
        var curLevel = this._levels[levelId];
        // reset level load error counter on successful level loaded
        curLevel.loadError = 0;
        var newDetails = data.details;
        // if current playlist is a live playlist, arm a timer to reload it
        if (newDetails.live) {
          var reloadInterval = 1000 * (newDetails.averagetargetduration ? newDetails.averagetargetduration : newDetails.targetduration),
              curDetails = curLevel.details;
          if (curDetails && newDetails.endSN === curDetails.endSN) {
            // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
            // changed then it MUST wait for a period of one-half the target
            // duration before retrying.
            reloadInterval /= 2;
            _logger.logger.log('same live playlist, reload twice faster');
          }
          // decrement reloadInterval with level loading delay
          reloadInterval -= performance.now() - data.stats.trequest;
          // in any case, don't reload more than every second
          reloadInterval = Math.max(1000, Math.round(reloadInterval));
          _logger.logger.log('live playlist, reload in ' + reloadInterval + ' ms');
          this.timer = setTimeout(this.ontick, reloadInterval);
        } else {
          this.timer = null;
        }
      }
    }
  }, {
    key: 'tick',
    value: function tick() {
      var levelId = this._level;
      if (levelId !== undefined && this.canload) {
        var level = this._levels[levelId];
        if (level && level.url) {
          var urlId = level.urlId;
          this.hls.trigger(_events2.default.LEVEL_LOADING, { url: level.url[urlId], level: levelId, id: urlId });
        }
      }
    }
  }, {
    key: 'levels',
    get: function get() {
      return this._levels;
    }
  }, {
    key: 'level',
    get: function get() {
      return this._level;
    },
    set: function set(newLevel) {
      var levels = this._levels;
      if (levels && levels.length > newLevel) {
        if (this._level !== newLevel || levels[newLevel].details === undefined) {
          this.setLevelInternal(newLevel);
        }
      }
    }
  }, {
    key: 'manualLevel',
    get: function get() {
      return this._manualLevel;
    },
    set: function set(newLevel) {
      this._manualLevel = newLevel;
      if (this._startLevel === undefined) {
        this._startLevel = newLevel;
      }
      if (newLevel !== -1) {
        this.level = newLevel;
      }
    }
  }, {
    key: 'firstLevel',
    get: function get() {
      return this._firstLevel;
    },
    set: function set(newLevel) {
      this._firstLevel = newLevel;
    }
  }, {
    key: 'startLevel',
    get: function get() {
      // hls.startLevel takes precedence over config.startLevel
      // if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
      if (this._startLevel === undefined) {
        var configStartLevel = this.hls.config.startLevel;
        if (configStartLevel !== undefined) {
          return configStartLevel;
        } else {
          return this._firstLevel;
        }
      } else {
        return this._startLevel;
      }
    },
    set: function set(newLevel) {
      this._startLevel = newLevel;
    }
  }, {
    key: 'nextLoadLevel',
    get: function get() {
      if (this._manualLevel !== -1) {
        return this._manualLevel;
      } else {
        return this.hls.nextAutoLevel;
      }
    },
    set: function set(nextLevel) {
      this.level = nextLevel;
      if (this._manualLevel === -1) {
        this.hls.nextAutoLevel = nextLevel;
      }
    }
  }]);

  return LevelController;
}(_eventHandler2.default);

exports.default = LevelController;

},{"33":33,"34":34,"35":35,"37":37,"54":54}],13:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _binarySearch = _dereq_(48);

var _binarySearch2 = _interopRequireDefault(_binarySearch);

var _bufferHelper = _dereq_(37);

var _bufferHelper2 = _interopRequireDefault(_bufferHelper);

var _demuxer = _dereq_(25);

var _demuxer2 = _interopRequireDefault(_demuxer);

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _levelHelper = _dereq_(38);

var _levelHelper2 = _interopRequireDefault(_levelHelper);

var _timeRanges = _dereq_(55);

var _timeRanges2 = _interopRequireDefault(_timeRanges);

var _errors = _dereq_(33);

var _logger = _dereq_(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Stream Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var State = {
  STOPPED: 'STOPPED',
  IDLE: 'IDLE',
  KEY_LOADING: 'KEY_LOADING',
  FRAG_LOADING: 'FRAG_LOADING',
  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
  WAITING_LEVEL: 'WAITING_LEVEL',
  PARSING: 'PARSING',
  PARSED: 'PARSED',
  BUFFER_FLUSHING: 'BUFFER_FLUSHING',
  ENDED: 'ENDED',
  ERROR: 'ERROR'
};

var StreamController = function (_EventHandler) {
  _inherits(StreamController, _EventHandler);

  function StreamController(hls) {
    _classCallCheck(this, StreamController);

    var _this = _possibleConstructorReturn(this, (StreamController.__proto__ || Object.getPrototypeOf(StreamController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_PARSED, _events2.default.LEVEL_LOADED, _events2.default.KEY_LOADED, _events2.default.FRAG_LOADED, _events2.default.FRAG_LOAD_EMERGENCY_ABORTED, _events2.default.FRAG_PARSING_INIT_SEGMENT, _events2.default.FRAG_PARSING_DATA, _events2.default.FRAG_PARSED, _events2.default.ERROR, _events2.default.AUDIO_TRACK_SWITCHING, _events2.default.AUDIO_TRACK_SWITCHED, _events2.default.BUFFER_CREATED, _events2.default.BUFFER_APPENDED, _events2.default.BUFFER_FLUSHED));

    _this.config = hls.config;
    _this.audioCodecSwap = false;
    _this.ticks = 0;
    _this._state = State.STOPPED;
    _this.ontick = _this.tick.bind(_this);
    return _this;
  }

  _createClass(StreamController, [{
    key: 'destroy',
    value: function destroy() {
      this.stopLoad();
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      _eventHandler2.default.prototype.destroy.call(this);
      this.state = State.STOPPED;
    }
  }, {
    key: 'startLoad',
    value: function startLoad(startPosition) {
      if (this.levels) {
        var lastCurrentTime = this.lastCurrentTime,
            hls = this.hls;
        this.stopLoad();
        if (!this.timer) {
          this.timer = setInterval(this.ontick, 100);
        }
        this.level = -1;
        this.fragLoadError = 0;
        if (!this.startFragRequested) {
          // determine load level
          var startLevel = hls.startLevel;
          if (startLevel === -1) {
            // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
            startLevel = 0;
            this.bitrateTest = true;
          }
          // set new level to playlist loader : this will trigger start level load
          // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
          this.level = hls.nextLoadLevel = startLevel;
          this.loadedmetadata = false;
        }
        // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
        if (lastCurrentTime > 0 && startPosition === -1) {
          _logger.logger.log('override startPosition with lastCurrentTime @' + lastCurrentTime.toFixed(3));
          startPosition = lastCurrentTime;
        }
        this.state = State.IDLE;
        this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
        this.tick();
      } else {
        this.forceStartLoad = true;
        this.state = State.STOPPED;
      }
    }
  }, {
    key: 'stopLoad',
    value: function stopLoad() {
      var frag = this.fragCurrent;
      if (frag) {
        if (frag.loader) {
          frag.loader.abort();
        }
        this.fragCurrent = null;
      }
      this.fragPrevious = null;
      if (this.demuxer) {
        this.demuxer.destroy();
        this.demuxer = null;
      }
      this.state = State.STOPPED;
      this.forceStartLoad = false;
    }
  }, {
    key: 'tick',
    value: function tick() {
      this.ticks++;
      if (this.ticks === 1) {
        this.doTick();
        if (this.ticks > 1) {
          setTimeout(this.tick, 1);
        }
        this.ticks = 0;
      }
    }
  }, {
    key: 'doTick',
    value: function doTick() {
      switch (this.state) {
        case State.ERROR:
          //don't do anything in error state to avoid breaking further ...
          break;
        case State.BUFFER_FLUSHING:
          // in buffer flushing state, reset fragLoadError counter
          this.fragLoadError = 0;
          break;
        case State.IDLE:
          this._doTickIdle();
          break;
        case State.WAITING_LEVEL:
          var level = this.levels[this.level];
          // check if playlist is already loaded
          if (level && level.details) {
            this.state = State.IDLE;
          }
          break;
        case State.FRAG_LOADING_WAITING_RETRY:
          var now = performance.now();
          var retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || this.media && this.media.seeking) {
            _logger.logger.log('mediaController: retryDate reached, switch back to IDLE state');
            this.state = State.IDLE;
          }
          break;
        case State.ERROR:
        case State.STOPPED:
        case State.FRAG_LOADING:
        case State.PARSING:
        case State.PARSED:
        case State.ENDED:
          break;
        default:
          break;
      }
      // check buffer
      this._checkBuffer();
      // check/update current fragment
      this._checkFragmentChanged();
    }

    // Ironically the "idle" state is the on we do the most logic in it seems ....
    // NOTE: Maybe we could rather schedule a check for buffer length after half of the currently
    //       played segment, or on pause/play/seek instead of naively checking every 100ms?

  }, {
    key: '_doTickIdle',
    value: function _doTickIdle() {
      var hls = this.hls,
          config = hls.config,
          media = this.media;

      // if video not attached AND
      // start fragment already requested OR start frag prefetch disable
      // exit loop
      // => if start level loaded and media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
      if (this.levelLastLoaded !== undefined && !media && (this.startFragRequested || !config.startFragPrefetch)) {
        return;
      }

      // if we have not yet loaded any fragment, start loading from start position
      var pos = void 0;
      if (this.loadedmetadata) {
        pos = media.currentTime;
      } else {
        pos = this.nextLoadPosition;
      }
      // determine next load level
      var level = hls.nextLoadLevel,
          levelInfo = this.levels[level];

      if (!levelInfo) {
        return;
      }

      var levelBitrate = levelInfo.bitrate,
          maxBufLen = void 0;

      // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
      if (levelBitrate) {
        maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
      } else {
        maxBufLen = config.maxBufferLength;
      }
      maxBufLen = Math.min(maxBufLen, config.maxMaxBufferLength);

      // determine next candidate fragment to be loaded, based on current position and end of buffer position
      // ensure up to `config.maxMaxBufferLength` of buffer upfront

      var bufferInfo = _bufferHelper2.default.bufferInfo(this.mediaBuffer ? this.mediaBuffer : media, pos, config.maxBufferHole),
          bufferLen = bufferInfo.len;
      // Stay idle if we are still with buffer margins
      if (bufferLen >= maxBufLen) {
        return;
      }

      // if buffer length is less than maxBufLen try to load a new fragment ...
      _logger.logger.trace('buffer length of ' + bufferLen.toFixed(3) + ' is below max of ' + maxBufLen.toFixed(3) + '. checking for more payload ...');

      // set next load level : this will trigger a playlist load if needed
      this.level = hls.nextLoadLevel = level;

      var levelDetails = levelInfo.details;
      // if level info not retrieved yet, switch state and wait for level retrieval
      // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
      // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
      if (typeof levelDetails === 'undefined' || levelDetails.live && this.levelLastLoaded !== level) {
        this.state = State.WAITING_LEVEL;
        return;
      }

      // we just got done loading the final fragment, and currentPos is buffered, and there is no other buffered range after ...
      // rationale is that in case there are any buffered rangesafter, it means that there are unbuffered portion in between
      // so we should not switch to ENDED in that case, to be able to buffer themx
      var fragPrevious = this.fragPrevious;
      if (!levelDetails.live && fragPrevious && fragPrevious.sn === levelDetails.endSN && bufferLen && !bufferInfo.nextStart) {
        // fragPrevious is last fragment. retrieve level duration using last frag start offset + duration
        // real duration might be lower than initial duration if there are drifts between real frag duration and playlist signaling
        var duration = Math.min(media.duration, fragPrevious.start + fragPrevious.duration);
        // if everything (almost) til the end is buffered, let's signal eos
        // we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference (audio/video offsets...)
        // tolerate up to one frag duration to cope with these cases.
        // also cope with almost zero last frag duration (max last frag duration with 200ms) refer to https://github.com/video-dev/hls.js/pull/657
        if (duration - Math.max(bufferInfo.end, fragPrevious.start) <= Math.max(0.2, fragPrevious.duration)) {
          // Finalize the media stream
          var data = {};
          if (this.altAudio) {
            data.type = 'video';
          }
          this.hls.trigger(_events2.default.BUFFER_EOS, data);
          this.state = State.ENDED;
          return;
        }
      }

      // if we have the levelDetails for the selected variant, lets continue enrichen our stream (load keys/fragments or trigger EOS, etc..)
      this._fetchPayloadOrEos(pos, bufferInfo, levelDetails);
    }
  }, {
    key: '_fetchPayloadOrEos',
    value: function _fetchPayloadOrEos(pos, bufferInfo, levelDetails) {
      var fragPrevious = this.fragPrevious,
          level = this.level,
          fragments = levelDetails.fragments,
          fragLen = fragments.length;

      // empty playlist
      if (fragLen === 0) {
        return;
      }

      // find fragment index, contiguous with end of buffer position
      var start = fragments[0].start,
          end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration,
          bufferEnd = bufferInfo.end,
          frag = void 0;

      if (levelDetails.initSegment && !levelDetails.initSegment.data) {
        frag = levelDetails.initSegment;
      } else {
        // in case of live playlist we need to ensure that requested position is not located before playlist start
        if (levelDetails.live) {
          var initialLiveManifestSize = this.config.initialLiveManifestSize;
          if (fragLen < initialLiveManifestSize) {
            _logger.logger.warn('Can not start playback of a level, reason: not enough fragments ' + fragLen + ' < ' + initialLiveManifestSize);
            return;
          }

          frag = this._ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen);
          // if it explicitely returns null don't load any fragment and exit function now
          if (frag === null) {
            return;
          }
        } else {
          // VoD playlist: if bufferEnd before start of playlist, load first fragment
          if (bufferEnd < start) {
            frag = fragments[0];
          }
        }
      }
      if (!frag) {
        frag = this._findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails);
      }
      if (frag) {
        this._loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd);
      }
      return;
    }
  }, {
    key: '_ensureFragmentAtLivePoint',
    value: function _ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen) {
      var config = this.hls.config,
          media = this.media;

      var frag = void 0;

      // check if requested position is within seekable boundaries :
      //logger.log(`start/pos/bufEnd/seeking:${start.toFixed(3)}/${pos.toFixed(3)}/${bufferEnd.toFixed(3)}/${this.media.seeking}`);
      var maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;

      if (bufferEnd < Math.max(start - config.maxFragLookUpTolerance, end - maxLatency)) {
        var liveSyncPosition = this.liveSyncPosition = this.computeLivePosition(start, levelDetails);
        _logger.logger.log('buffer end: ' + bufferEnd.toFixed(3) + ' is located too far from the end of live sliding playlist, reset currentTime to : ' + liveSyncPosition.toFixed(3));
        bufferEnd = liveSyncPosition;
        if (media && media.readyState && media.duration > liveSyncPosition) {
          media.currentTime = liveSyncPosition;
        }
        this.nextLoadPosition = liveSyncPosition;
      }

      // if end of buffer greater than live edge, don't load any fragment
      // this could happen if live playlist intermittently slides in the past.
      // level 1 loaded [182580161,182580167]
      // level 1 loaded [182580162,182580169]
      // Loading 182580168 of [182580162 ,182580169],level 1 ..
      // Loading 182580169 of [182580162 ,182580169],level 1 ..
      // level 1 loaded [182580162,182580168] <============= here we should have bufferEnd > end. in that case break to avoid reloading 182580168
      // level 1 loaded [182580164,182580171]
      //
      // don't return null in case media not loaded yet (readystate === 0)
      if (levelDetails.PTSKnown && bufferEnd > end && media && media.readyState) {
        return null;
      }

      if (this.startFragRequested && !levelDetails.PTSKnown) {
        /* we are switching level on live playlist, but we don't have any PTS info for that quality level ...
           try to load frag matching with next SN.
           even if SN are not synchronized between playlists, loading this frag will help us
           compute playlist sliding and find the right one after in case it was not the right consecutive one */
        if (fragPrevious) {
          var targetSN = fragPrevious.sn + 1;
          if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
            var fragNext = fragments[targetSN - levelDetails.startSN];
            if (fragPrevious.cc === fragNext.cc) {
              frag = fragNext;
              _logger.logger.log('live playlist, switching playlist, load frag with next SN: ' + frag.sn);
            }
          }
          // next frag SN not available (or not with same continuity counter)
          // look for a frag sharing the same CC
          if (!frag) {
            frag = _binarySearch2.default.search(fragments, function (frag) {
              return fragPrevious.cc - frag.cc;
            });
            if (frag) {
              _logger.logger.log('live playlist, switching playlist, load frag with same CC: ' + frag.sn);
            }
          }
        }
        if (!frag) {
          /* we have no idea about which fragment should be loaded.
             so let's load mid fragment. it will help computing playlist sliding and find the right one
          */
          frag = fragments[Math.min(fragLen - 1, Math.round(fragLen / 2))];
          _logger.logger.log('live playlist, switching playlist, unknown, load middle frag : ' + frag.sn);
        }
      }
      return frag;
    }
  }, {
    key: '_findFragment',
    value: function _findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails) {
      var config = this.hls.config;
      var frag = void 0;
      var foundFrag = void 0;
      var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
      var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
      var fragmentWithinToleranceTest = function fragmentWithinToleranceTest(candidate) {
        // offset should be within fragment boundary - config.maxFragLookUpTolerance
        // this is to cope with situations like
        // bufferEnd = 9.991
        // frag[Ø] : [0,10]
        // frag[1] : [10,20]
        // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
        //              frag start               frag start+duration
        //                  |-----------------------------|
        //              <--->                         <--->
        //  ...--------><-----------------------------><---------....
        // previous frag         matching fragment         next frag
        //  return -1             return 0                 return 1
        //logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
        // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
        var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration);
        if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
          return 1;
        } // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
        else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
            return -1;
          }
        return 0;
      };

      if (bufferEnd < end) {
        if (bufferEnd > end - maxFragLookUpTolerance) {
          maxFragLookUpTolerance = 0;
        }
        // Prefer the next fragment if it's within tolerance
        if (fragNext && !fragmentWithinToleranceTest(fragNext)) {
          foundFrag = fragNext;
        } else {
          foundFrag = _binarySearch2.default.search(fragments, fragmentWithinToleranceTest);
        }
      } else {
        // reach end of playlist
        foundFrag = fragments[fragLen - 1];
      }
      if (foundFrag) {
        frag = foundFrag;
        var curSNIdx = frag.sn - levelDetails.startSN;
        var sameLevel = fragPrevious && frag.level === fragPrevious.level;
        var prevFrag = fragments[curSNIdx - 1];
        var nextFrag = fragments[curSNIdx + 1];
        //logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
        if (fragPrevious && frag.sn === fragPrevious.sn) {
          if (sameLevel && !frag.backtracked) {
            if (frag.sn < levelDetails.endSN) {
              var deltaPTS = fragPrevious.deltaPTS;
              // if there is a significant delta between audio and video, larger than max allowed hole,
              // and if previous remuxed fragment did not start with a keyframe. (fragPrevious.dropped)
              // let's try to load previous fragment again to get last keyframe
              // then we will reload again current fragment (that way we should be able to fill the buffer hole ...)
              if (deltaPTS && deltaPTS > config.maxBufferHole && fragPrevious.dropped && curSNIdx) {
                frag = prevFrag;
                _logger.logger.warn('SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this');
                // decrement previous frag load counter to avoid frag loop loading error when next fragment will get reloaded
                fragPrevious.loadCounter--;
              } else {
                frag = nextFrag;
                _logger.logger.log('SN just loaded, load next one: ' + frag.sn);
              }
            } else {
              frag = null;
            }
          } else if (frag.backtracked) {
            // Only backtrack a max of 1 consecutive fragment to prevent sliding back too far when little or no frags start with keyframes
            if (nextFrag && nextFrag.backtracked) {
              _logger.logger.warn('Already backtracked from fragment ' + nextFrag.sn + ', will not backtrack to fragment ' + frag.sn + '. Loading fragment ' + nextFrag.sn);
              frag = nextFrag;
            } else {
              // If a fragment has dropped frames and it's in a same level/sequence, load the previous fragment to try and find the keyframe
              // Reset the dropped count now since it won't be reset until we parse the fragment again, which prevents infinite backtracking on the same segment
              _logger.logger.warn('Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe');
              frag.dropped = 0;
              if (prevFrag) {
                if (prevFrag.loadCounter) {
                  prevFrag.loadCounter--;
                }
                frag = prevFrag;
                frag.backtracked = true;
              } else if (curSNIdx) {
                // can't backtrack on very first fragment
                frag = null;
              }
            }
          }
        }
      }
      return frag;
    }
  }, {
    key: '_loadFragmentOrKey',
    value: function _loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd) {
      var hls = this.hls,
          config = hls.config;

      //logger.log('loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
      if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
        _logger.logger.log('Loading key for ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level);
        this.state = State.KEY_LOADING;
        hls.trigger(_events2.default.KEY_LOADING, { frag: frag });
      } else {
        _logger.logger.log('Loading ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level + ', currentTime:' + pos.toFixed(3) + ',bufferEnd:' + bufferEnd.toFixed(3));
        // ensure that we are not reloading the same fragments in loop ...
        if (this.fragLoadIdx !== undefined) {
          this.fragLoadIdx++;
        } else {
          this.fragLoadIdx = 0;
        }
        if (frag.loadCounter) {
          frag.loadCounter++;
          var maxThreshold = config.fragLoadingLoopThreshold;
          // if this frag has already been loaded 3 times, and if it has been reloaded recently
          if (frag.loadCounter > maxThreshold && Math.abs(this.fragLoadIdx - frag.loadIdx) < maxThreshold) {
            hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR, fatal: false, frag: frag });
            return;
          }
        } else {
          frag.loadCounter = 1;
        }
        frag.loadIdx = this.fragLoadIdx;
        this.fragCurrent = frag;
        this.startFragRequested = true;
        if (!isNaN(frag.sn)) {
          this.nextLoadPosition = frag.start + frag.duration;
        }
        frag.autoLevel = hls.autoLevelEnabled;
        frag.bitrateTest = this.bitrateTest;
        hls.trigger(_events2.default.FRAG_LOADING, { frag: frag });
        // lazy demuxer init, as this could take some time ... do it during frag loading
        if (!this.demuxer) {
          this.demuxer = new _demuxer2.default(hls, 'main');
        }
        this.state = State.FRAG_LOADING;
        return;
      }
    }
  }, {
    key: 'getBufferedFrag',
    value: function getBufferedFrag(position) {
      return _binarySearch2.default.search(this._bufferedFrags, function (frag) {
        if (position < frag.startPTS) {
          return -1;
        } else if (position > frag.endPTS) {
          return 1;
        }
        return 0;
      });
    }
  }, {
    key: 'followingBufferedFrag',
    value: function followingBufferedFrag(frag) {
      if (frag) {
        // try to get range of next fragment (500ms after this range)
        return this.getBufferedFrag(frag.endPTS + 0.5);
      }
      return null;
    }
  }, {
    key: '_checkFragmentChanged',
    value: function _checkFragmentChanged() {
      var fragPlayingCurrent,
          currentTime,
          video = this.media;
      if (video && video.readyState && video.seeking === false) {
        currentTime = video.currentTime;
        /* if video element is in seeked state, currentTime can only increase.
          (assuming that playback rate is positive ...)
          As sometimes currentTime jumps back to zero after a
          media decode error, check this, to avoid seeking back to
          wrong position after a media decode error
        */
        if (currentTime > video.playbackRate * this.lastCurrentTime) {
          this.lastCurrentTime = currentTime;
        }
        if (_bufferHelper2.default.isBuffered(video, currentTime)) {
          fragPlayingCurrent = this.getBufferedFrag(currentTime);
        } else if (_bufferHelper2.default.isBuffered(video, currentTime + 0.1)) {
          /* ensure that FRAG_CHANGED event is triggered at startup,
            when first video frame is displayed and playback is paused.
            add a tolerance of 100ms, in case current position is not buffered,
            check if current pos+100ms is buffered and use that buffer range
            for FRAG_CHANGED event reporting */
          fragPlayingCurrent = this.getBufferedFrag(currentTime + 0.1);
        }
        if (fragPlayingCurrent) {
          var fragPlaying = fragPlayingCurrent;
          if (fragPlaying !== this.fragPlaying) {
            this.hls.trigger(_events2.default.FRAG_CHANGED, { frag: fragPlaying });
            var fragPlayingLevel = fragPlaying.level;
            if (!this.fragPlaying || this.fragPlaying.level !== fragPlayingLevel) {
              this.hls.trigger(_events2.default.LEVEL_SWITCHED, { level: fragPlayingLevel });
            }
            this.fragPlaying = fragPlaying;
          }
        }
      }
    }

    /*
      on immediate level switch :
       - pause playback if playing
       - cancel any pending load request
       - and trigger a buffer flush
    */

  }, {
    key: 'immediateLevelSwitch',
    value: function immediateLevelSwitch() {
      _logger.logger.log('immediateLevelSwitch');
      if (!this.immediateSwitch) {
        this.immediateSwitch = true;
        var media = this.media,
            previouslyPaused = void 0;
        if (media) {
          previouslyPaused = media.paused;
          media.pause();
        } else {
          // don't restart playback after instant level switch in case media not attached
          previouslyPaused = true;
        }
        this.previouslyPaused = previouslyPaused;
      }
      var fragCurrent = this.fragCurrent;
      if (fragCurrent && fragCurrent.loader) {
        fragCurrent.loader.abort();
      }
      this.fragCurrent = null;
      // increase fragment load Index to avoid frag loop loading error after buffer flush
      this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
      // flush everything
      this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
    }

    /*
       on immediate level switch end, after new fragment has been buffered :
        - nudge video decoder by slightly adjusting video currentTime (if currentTime buffered)
        - resume the playback if needed
    */

  }, {
    key: 'immediateLevelSwitchEnd',
    value: function immediateLevelSwitchEnd() {
      var media = this.media;
      if (media && media.buffered.length) {
        this.immediateSwitch = false;
        if (_bufferHelper2.default.isBuffered(media, media.currentTime)) {
          // only nudge if currentTime is buffered
          media.currentTime -= 0.0001;
        }
        if (!this.previouslyPaused) {
          media.play();
        }
      }
    }
  }, {
    key: 'nextLevelSwitch',
    value: function nextLevelSwitch() {
      /* try to switch ASAP without breaking video playback :
         in order to ensure smooth but quick level switching,
        we need to find the next flushable buffer range
        we should take into account new segment fetch time
      */
      var media = this.media;
      // ensure that media is defined and that metadata are available (to retrieve currentTime)
      if (media && media.readyState) {
        var fetchdelay = void 0,
            fragPlayingCurrent = void 0,
            nextBufferedFrag = void 0;
        // increase fragment load Index to avoid frag loop loading error after buffer flush
        this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
        fragPlayingCurrent = this.getBufferedFrag(media.currentTime);
        if (fragPlayingCurrent && fragPlayingCurrent.startPTS > 1) {
          // flush buffer preceding current fragment (flush until current fragment start offset)
          // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
          this.flushMainBuffer(0, fragPlayingCurrent.startPTS - 1);
        }
        if (!media.paused) {
          // add a safety delay of 1s
          var nextLevelId = this.hls.nextLoadLevel,
              nextLevel = this.levels[nextLevelId],
              fragLastKbps = this.fragLastKbps;
          if (fragLastKbps && this.fragCurrent) {
            fetchdelay = this.fragCurrent.duration * nextLevel.bitrate / (1000 * fragLastKbps) + 1;
          } else {
            fetchdelay = 0;
          }
        } else {
          fetchdelay = 0;
        }
        //logger.log('fetchdelay:'+fetchdelay);
        // find buffer range that will be reached once new fragment will be fetched
        nextBufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
        if (nextBufferedFrag) {
          // we can flush buffer range following this one without stalling playback
          nextBufferedFrag = this.followingBufferedFrag(nextBufferedFrag);
          if (nextBufferedFrag) {
            // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
            var fragCurrent = this.fragCurrent;
            if (fragCurrent && fragCurrent.loader) {
              fragCurrent.loader.abort();
            }
            this.fragCurrent = null;
            // start flush position is the start PTS of next buffered frag.
            // we use frag.naxStartPTS which is max(audio startPTS, video startPTS).
            // in case there is a small PTS Delta between audio and video, using maxStartPTS avoids flushing last samples from current fragment
            this.flushMainBuffer(nextBufferedFrag.maxStartPTS, Number.POSITIVE_INFINITY);
          }
        }
      }
    }
  }, {
    key: 'flushMainBuffer',
    value: function flushMainBuffer(startOffset, endOffset) {
      this.state = State.BUFFER_FLUSHING;
      var flushScope = { startOffset: startOffset, endOffset: endOffset };
      // if alternate audio tracks are used, only flush video, otherwise flush everything
      if (this.altAudio) {
        flushScope.type = 'video';
      }
      this.hls.trigger(_events2.default.BUFFER_FLUSHING, flushScope);
    }
  }, {
    key: 'onMediaAttached',
    value: function onMediaAttached(data) {
      var media = this.media = this.mediaBuffer = data.media;
      this.onvseeking = this.onMediaSeeking.bind(this);
      this.onvseeked = this.onMediaSeeked.bind(this);
      this.onvended = this.onMediaEnded.bind(this);
      media.addEventListener('seeking', this.onvseeking);
      media.addEventListener('seeked', this.onvseeked);
      media.addEventListener('ended', this.onvended);
      var config = this.config;
      if (this.levels && config.autoStartLoad) {
        this.hls.startLoad(config.startPosition);
      }
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      var media = this.media;
      if (media && media.ended) {
        _logger.logger.log('MSE detaching and video ended, reset startPosition');
        this.startPosition = this.lastCurrentTime = 0;
      }

      // reset fragment loading counter on MSE detaching to avoid reporting FRAG_LOOP_LOADING_ERROR after error recovery
      var levels = this.levels;
      if (levels) {
        // reset fragment load counter
        levels.forEach(function (level) {
          if (level.details) {
            level.details.fragments.forEach(function (fragment) {
              fragment.loadCounter = undefined;
              fragment.backtracked = undefined;
            });
          }
        });
      }
      // remove video listeners
      if (media) {
        media.removeEventListener('seeking', this.onvseeking);
        media.removeEventListener('seeked', this.onvseeked);
        media.removeEventListener('ended', this.onvended);
        this.onvseeking = this.onvseeked = this.onvended = null;
      }
      this.media = this.mediaBuffer = null;
      this.loadedmetadata = false;
      this.stopLoad();
    }
  }, {
    key: 'onMediaSeeking',
    value: function onMediaSeeking() {
      var media = this.media,
          currentTime = media ? media.currentTime : undefined,
          config = this.config;
      if (!isNaN(currentTime)) {
        _logger.logger.log('media seeking to ' + currentTime.toFixed(3));
      }
      var mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
      var bufferInfo = _bufferHelper2.default.bufferInfo(mediaBuffer, currentTime, this.config.maxBufferHole);
      if (this.state === State.FRAG_LOADING) {
        var fragCurrent = this.fragCurrent;
        // check if we are seeking to a unbuffered area AND if frag loading is in progress
        if (bufferInfo.len === 0 && fragCurrent) {
          var tolerance = config.maxFragLookUpTolerance,
              fragStartOffset = fragCurrent.start - tolerance,
              fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
          // check if we seek position will be out of currently loaded frag range : if out cancel frag load, if in, don't do anything
          if (currentTime < fragStartOffset || currentTime > fragEndOffset) {
            if (fragCurrent.loader) {
              _logger.logger.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
              fragCurrent.loader.abort();
            }
            this.fragCurrent = null;
            this.fragPrevious = null;
            // switch to IDLE state to load new fragment
            this.state = State.IDLE;
          } else {
            _logger.logger.log('seeking outside of buffer but within currently loaded fragment range');
          }
        }
      } else if (this.state === State.ENDED) {
        // if seeking to unbuffered area, clean up fragPrevious
        if (bufferInfo.len === 0) {
          this.fragPrevious = 0;
        }
        // switch to IDLE state to check for potential new fragment
        this.state = State.IDLE;
      }
      if (media) {
        this.lastCurrentTime = currentTime;
      }
      // avoid reporting fragment loop loading error in case user is seeking several times on same position
      if (this.state !== State.FRAG_LOADING && this.fragLoadIdx !== undefined) {
        this.fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
      }
      // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
      if (!this.loadedmetadata) {
        this.nextLoadPosition = this.startPosition = currentTime;
      }
      // tick to speed up processing
      this.tick();
    }
  }, {
    key: 'onMediaSeeked',
    value: function onMediaSeeked() {
      var media = this.media,
          currentTime = media ? media.currentTime : undefined;
      if (!isNaN(currentTime)) {
        _logger.logger.log('media seeked to ' + currentTime.toFixed(3));
      }
      // tick to speed up FRAGMENT_PLAYING triggering
      this.tick();
    }
  }, {
    key: 'onMediaEnded',
    value: function onMediaEnded() {
      _logger.logger.log('media ended');
      // reset startPosition and lastCurrentTime to restart playback @ stream beginning
      this.startPosition = this.lastCurrentTime = 0;
    }
  }, {
    key: 'onManifestLoading',
    value: function onManifestLoading() {
      // reset buffer on manifest loading
      _logger.logger.log('trigger BUFFER_RESET');
      this.hls.trigger(_events2.default.BUFFER_RESET);
      this._bufferedFrags = [];
      this.stalled = false;
      this.startPosition = this.lastCurrentTime = 0;
    }
  }, {
    key: 'onManifestParsed',
    value: function onManifestParsed(data) {
      var aac = false,
          heaac = false,
          codec;
      data.levels.forEach(function (level) {
        // detect if we have different kind of audio codecs used amongst playlists
        codec = level.audioCodec;
        if (codec) {
          if (codec.indexOf('mp4a.40.2') !== -1) {
            aac = true;
          }
          if (codec.indexOf('mp4a.40.5') !== -1) {
            heaac = true;
          }
        }
      });
      this.audioCodecSwitch = aac && heaac;
      if (this.audioCodecSwitch) {
        _logger.logger.log('both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
      }
      this.levels = data.levels;
      this.startLevelLoaded = false;
      this.startFragRequested = false;
      var config = this.config;
      if (config.autoStartLoad || this.forceStartLoad) {
        this.hls.startLoad(config.startPosition);
      }
    }
  }, {
    key: 'onLevelLoaded',
    value: function onLevelLoaded(data) {
      var newDetails = data.details,
          newLevelId = data.level,
          curLevel = this.levels[newLevelId],
          duration = newDetails.totalduration,
          sliding = 0;

      _logger.logger.log('level ' + newLevelId + ' loaded [' + newDetails.startSN + ',' + newDetails.endSN + '],duration:' + duration);
      this.levelLastLoaded = newLevelId;

      if (newDetails.live) {
        var curDetails = curLevel.details;
        if (curDetails && newDetails.fragments.length > 0) {
          // we already have details for that level, merge them
          _levelHelper2.default.mergeDetails(curDetails, newDetails);
          sliding = newDetails.fragments[0].start;
          this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
          if (newDetails.PTSKnown) {
            _logger.logger.log('live playlist sliding:' + sliding.toFixed(3));
          } else {
            _logger.logger.log('live playlist - outdated PTS, unknown sliding');
          }
        } else {
          newDetails.PTSKnown = false;
          _logger.logger.log('live playlist - first load, unknown sliding');
        }
      } else {
        newDetails.PTSKnown = false;
      }
      // override level info
      curLevel.details = newDetails;
      this.hls.trigger(_events2.default.LEVEL_UPDATED, { details: newDetails, level: newLevelId });

      if (this.startFragRequested === false) {
        // compute start position if set to -1. use it straight away if value is defined
        if (this.startPosition === -1 || this.lastCurrentTime === -1) {
          // first, check if start time offset has been set in playlist, if yes, use this value
          var startTimeOffset = newDetails.startTimeOffset;
          if (!isNaN(startTimeOffset)) {
            if (startTimeOffset < 0) {
              _logger.logger.log('negative start time offset ' + startTimeOffset + ', count from end of last fragment');
              startTimeOffset = sliding + duration + startTimeOffset;
            }
            _logger.logger.log('start time offset found in playlist, adjust startPosition to ' + startTimeOffset);
            this.startPosition = startTimeOffset;
          } else {
            // if live playlist, set start position to be fragment N-this.config.liveSyncDurationCount (usually 3)
            if (newDetails.live) {
              this.startPosition = this.computeLivePosition(sliding, newDetails);
              _logger.logger.log('configure startPosition to ' + this.startPosition);
            } else {
              this.startPosition = 0;
            }
          }
          this.lastCurrentTime = this.startPosition;
        }
        this.nextLoadPosition = this.startPosition;
      }
      // only switch batck to IDLE state if we were waiting for level to start downloading a new fragment
      if (this.state === State.WAITING_LEVEL) {
        this.state = State.IDLE;
      }
      //trigger handler right now
      this.tick();
    }
  }, {
    key: 'onKeyLoaded',
    value: function onKeyLoaded() {
      if (this.state === State.KEY_LOADING) {
        this.state = State.IDLE;
        this.tick();
      }
    }
  }, {
    key: 'onFragLoaded',
    value: function onFragLoaded(data) {
      var fragCurrent = this.fragCurrent,
          fragLoaded = data.frag;
      if (this.state === State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'main' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
        var stats = data.stats,
            currentLevel = this.levels[fragCurrent.level],
            details = currentLevel.details;
        _logger.logger.log('Loaded  ' + fragCurrent.sn + ' of [' + details.startSN + ' ,' + details.endSN + '],level ' + fragCurrent.level);
        // reset frag bitrate test in any case after frag loaded event
        this.bitrateTest = false;
        this.stats = stats;
        // if this frag was loaded to perform a bitrate test AND if hls.nextLoadLevel is greater than 0
        // then this means that we should be able to load a fragment at a higher quality level
        if (fragLoaded.bitrateTest === true && this.hls.nextLoadLevel) {
          // switch back to IDLE state ... we just loaded a fragment to determine adequate start bitrate and initialize autoswitch algo
          this.state = State.IDLE;
          this.startFragRequested = false;
          stats.tparsed = stats.tbuffered = performance.now();
          this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
          this.tick();
        } else if (fragLoaded.sn === 'initSegment') {
          this.state = State.IDLE;
          stats.tparsed = stats.tbuffered = performance.now();
          details.initSegment.data = data.payload;
          this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
          this.tick();
        } else {
          this.state = State.PARSING;
          // transmux the MPEG-TS data to ISO-BMFF segments
          var duration = details.totalduration,
              level = fragCurrent.level,
              sn = fragCurrent.sn,
              audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
          if (this.audioCodecSwap) {
            _logger.logger.log('swapping playlist audio codec');
            if (audioCodec === undefined) {
              audioCodec = this.lastAudioCodec;
            }
            if (audioCodec) {
              if (audioCodec.indexOf('mp4a.40.5') !== -1) {
                audioCodec = 'mp4a.40.2';
              } else {
                audioCodec = 'mp4a.40.5';
              }
            }
          }
          this.pendingBuffering = true;
          this.appended = false;
          _logger.logger.log('Parsing ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],level ' + level + ', cc ' + fragCurrent.cc);
          var demuxer = this.demuxer;
          if (!demuxer) {
            demuxer = this.demuxer = new _demuxer2.default(this.hls, 'main');
          }
          // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live) and if media is not seeking (this is to overcome potential timestamp drifts between playlists and fragments)
          var media = this.media;
          var mediaSeeking = media && media.seeking;
          var accurateTimeOffset = !mediaSeeking && (details.PTSKnown || !details.live);
          var initSegmentData = details.initSegment ? details.initSegment.data : [];
          demuxer.push(data.payload, initSegmentData, audioCodec, currentLevel.videoCodec, fragCurrent, duration, accurateTimeOffset, undefined);
        }
      }
      this.fragLoadError = 0;
    }
  }, {
    key: 'onFragParsingInitSegment',
    value: function onFragParsingInitSegment(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        var tracks = data.tracks,
            trackName,
            track;

        // if audio track is expected to come from audio stream controller, discard any coming from main
        if (tracks.audio && this.altAudio) {
          delete tracks.audio;
        }
        // include levelCodec in audio and video tracks
        track = tracks.audio;
        if (track) {
          var audioCodec = this.levels[this.level].audioCodec,
              ua = navigator.userAgent.toLowerCase();
          if (audioCodec && this.audioCodecSwap) {
            _logger.logger.log('swapping playlist audio codec');
            if (audioCodec.indexOf('mp4a.40.5') !== -1) {
              audioCodec = 'mp4a.40.2';
            } else {
              audioCodec = 'mp4a.40.5';
            }
          }
          // in case AAC and HE-AAC audio codecs are signalled in manifest
          // force HE-AAC , as it seems that most browsers prefers that way,
          // except for mono streams OR on FF
          // these conditions might need to be reviewed ...
          if (this.audioCodecSwitch) {
            // don't force HE-AAC if mono stream
            if (track.metadata.channelCount !== 1 &&
            // don't force HE-AAC if firefox
            ua.indexOf('firefox') === -1) {
              audioCodec = 'mp4a.40.5';
            }
          }
          // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
          if (ua.indexOf('android') !== -1 && track.container !== 'audio/mpeg') {
            // Exclude mpeg audio
            audioCodec = 'mp4a.40.2';
            _logger.logger.log('Android: force audio codec to ' + audioCodec);
          }
          track.levelCodec = audioCodec;
          track.id = data.id;
        }
        track = tracks.video;
        if (track) {
          track.levelCodec = this.levels[this.level].videoCodec;
          track.id = data.id;
        }
        this.hls.trigger(_events2.default.BUFFER_CODECS, tracks);
        // loop through tracks that are going to be provided to bufferController
        for (trackName in tracks) {
          track = tracks[trackName];
          _logger.logger.log('main track:' + trackName + ',container:' + track.container + ',codecs[level/parsed]=[' + track.levelCodec + '/' + track.codec + ']');
          var initSegment = track.initSegment;
          if (initSegment) {
            this.appended = true;
            // arm pending Buffering flag before appending a segment
            this.pendingBuffering = true;
            this.hls.trigger(_events2.default.BUFFER_APPENDING, { type: trackName, data: initSegment, parent: 'main', content: 'initSegment' });
          }
        }
        //trigger handler right now
        this.tick();
      }
    }
  }, {
    key: 'onFragParsingData',
    value: function onFragParsingData(data) {
      var _this2 = this;

      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && !(data.type === 'audio' && this.altAudio) && // filter out main audio if audio track is loaded through audio stream controller
      this.state === State.PARSING) {
        var level = this.levels[this.level],
            frag = fragCurrent;
        if (isNaN(data.endPTS)) {
          data.endPTS = data.startPTS + fragCurrent.duration;
          data.endDTS = data.startDTS + fragCurrent.duration;
        }

        _logger.logger.log('Parsed ' + data.type + ',PTS:[' + data.startPTS.toFixed(3) + ',' + data.endPTS.toFixed(3) + '],DTS:[' + data.startDTS.toFixed(3) + '/' + data.endDTS.toFixed(3) + '],nb:' + data.nb + ',dropped:' + (data.dropped || 0));

        // Detect gaps in a fragment  and try to fix it by finding a keyframe in the previous fragment (see _findFragments)
        if (data.type === 'video') {
          frag.dropped = data.dropped;
          if (frag.dropped) {
            if (!frag.backtracked) {
              _logger.logger.warn('missing video frame(s), backtracking fragment');
              // Return back to the IDLE state without appending to buffer
              // Causes findFragments to backtrack a segment and find the keyframe
              // Audio fragments arriving before video sets the nextLoadPosition, causing _findFragments to skip the backtracked fragment
              frag.backtracked = true;
              this.nextLoadPosition = data.startPTS;
              this.state = State.IDLE;
              this.fragPrevious = frag;
              this.tick();
              return;
            } else {
              _logger.logger.warn('Already backtracked on this fragment, appending with the gap');
            }
          } else {
            // Only reset the backtracked flag if we've loaded the frag without any dropped frames
            frag.backtracked = false;
          }
        }

        var drift = _levelHelper2.default.updateFragPTSDTS(level.details, frag, data.startPTS, data.endPTS, data.startDTS, data.endDTS),
            hls = this.hls;
        hls.trigger(_events2.default.LEVEL_PTS_UPDATED, { details: level.details, level: this.level, drift: drift, type: data.type, start: data.startPTS, end: data.endPTS });

        // has remuxer dropped video frames located before first keyframe ?
        [data.data1, data.data2].forEach(function (buffer) {
          // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
          // in that case it is useless to append following segments
          if (buffer && buffer.length && _this2.state === State.PARSING) {
            _this2.appended = true;
            // arm pending Buffering flag before appending a segment
            _this2.pendingBuffering = true;
            hls.trigger(_events2.default.BUFFER_APPENDING, { type: data.type, data: buffer, parent: 'main', content: 'data' });
          }
        });
        //trigger handler right now
        this.tick();
      }
    }
  }, {
    key: 'onFragParsed',
    value: function onFragParsed(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        this.stats.tparsed = performance.now();
        this.state = State.PARSED;
        this._checkAppendedParsed();
      }
    }
  }, {
    key: 'onAudioTrackSwitching',
    value: function onAudioTrackSwitching(data) {
      // if any URL found on new audio track, it is an alternate audio track
      var altAudio = !!data.url,
          trackId = data.id;
      // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
      // don't do anything if we switch to alt audio: audio stream controller is handling it.
      // we will just have to change buffer scheduling on audioTrackSwitched
      if (!altAudio) {
        if (this.mediaBuffer !== this.media) {
          _logger.logger.log('switching on main audio, use media.buffered to schedule main fragment loading');
          this.mediaBuffer = this.media;
          var fragCurrent = this.fragCurrent;
          // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
          if (fragCurrent.loader) {
            _logger.logger.log('switching to main audio track, cancel main fragment load');
            fragCurrent.loader.abort();
          }
          this.fragCurrent = null;
          this.fragPrevious = null;
          // destroy demuxer to force init segment generation (following audio switch)
          if (this.demuxer) {
            this.demuxer.destroy();
            this.demuxer = null;
          }
          // switch to IDLE state to load new fragment
          this.state = State.IDLE;
        }
        var hls = this.hls;
        // switching to main audio, flush all audio and trigger track switched
        hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
        hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: trackId });
        this.altAudio = false;
      }
    }
  }, {
    key: 'onAudioTrackSwitched',
    value: function onAudioTrackSwitched(data) {
      var trackId = data.id,
          altAudio = !!this.hls.audioTracks[trackId].url;
      if (altAudio) {
        var videoBuffer = this.videoBuffer;
        // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
        if (videoBuffer && this.mediaBuffer !== videoBuffer) {
          _logger.logger.log('switching on alternate audio, use video.buffered to schedule main fragment loading');
          this.mediaBuffer = videoBuffer;
        }
      }
      this.altAudio = altAudio;
      this.tick();
    }
  }, {
    key: 'onBufferCreated',
    value: function onBufferCreated(data) {
      var tracks = data.tracks,
          mediaTrack = void 0,
          name = void 0,
          alternate = false;
      for (var type in tracks) {
        var track = tracks[type];
        if (track.id === 'main') {
          name = type;
          mediaTrack = track;
          // keep video source buffer reference
          if (type === 'video') {
            this.videoBuffer = tracks[type].buffer;
          }
        } else {
          alternate = true;
        }
      }
      if (alternate && mediaTrack) {
        _logger.logger.log('alternate track found, use ' + name + '.buffered to schedule main fragment loading');
        this.mediaBuffer = mediaTrack.buffer;
      } else {
        this.mediaBuffer = this.media;
      }
    }
  }, {
    key: 'onBufferAppended',
    value: function onBufferAppended(data) {
      if (data.parent === 'main') {
        var state = this.state;
        if (state === State.PARSING || state === State.PARSED) {
          // check if all buffers have been appended
          this.pendingBuffering = data.pending > 0;
          this._checkAppendedParsed();
        }
      }
    }
  }, {
    key: '_checkAppendedParsed',
    value: function _checkAppendedParsed() {
      //trigger handler right now
      if (this.state === State.PARSED && (!this.appended || !this.pendingBuffering)) {
        var frag = this.fragCurrent;
        if (frag) {
          var media = this.mediaBuffer ? this.mediaBuffer : this.media;
          _logger.logger.log('main buffered : ' + _timeRanges2.default.toString(media.buffered));
          // filter fragments potentially evicted from buffer. this is to avoid memleak on live streams
          var bufferedFrags = this._bufferedFrags.filter(function (frag) {
            return _bufferHelper2.default.isBuffered(media, (frag.startPTS + frag.endPTS) / 2);
          });
          // push new range
          bufferedFrags.push(frag);
          // sort frags, as we use BinarySearch for lookup in getBufferedFrag ...
          this._bufferedFrags = bufferedFrags.sort(function (a, b) {
            return a.startPTS - b.startPTS;
          });
          this.fragPrevious = frag;
          var stats = this.stats;
          stats.tbuffered = performance.now();
          // we should get rid of this.fragLastKbps
          this.fragLastKbps = Math.round(8 * stats.total / (stats.tbuffered - stats.tfirst));
          this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: frag, id: 'main' });
          this.state = State.IDLE;
        }
        this.tick();
      }
    }
  }, {
    key: 'onError',
    value: function onError(data) {
      var frag = data.frag || this.fragCurrent;
      // don't handle frag error not related to main fragment
      if (frag && frag.type !== 'main') {
        return;
      }
      var media = this.media,

      // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
      mediaBuffered = media && _bufferHelper2.default.isBuffered(media, media.currentTime) && _bufferHelper2.default.isBuffered(media, media.currentTime + 0.5);
      switch (data.details) {
        case _errors.ErrorDetails.FRAG_LOAD_ERROR:
        case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
        case _errors.ErrorDetails.KEY_LOAD_ERROR:
        case _errors.ErrorDetails.KEY_LOAD_TIMEOUT:
          if (!data.fatal) {
            var loadError = this.fragLoadError;
            if (loadError) {
              loadError++;
            } else {
              loadError = 1;
            }
            var config = this.config;
            // keep retrying / don't raise fatal network error if current position is buffered or if in automode with current level not 0
            if (loadError <= config.fragLoadingMaxRetry || mediaBuffered || frag.autoLevel && frag.level) {
              this.fragLoadError = loadError;
              // reset load counter to avoid frag loop loading error
              frag.loadCounter = 0;
              // exponential backoff capped to config.fragLoadingMaxRetryTimeout
              var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
              _logger.logger.warn('mediaController: frag loading failed, retry in ' + delay + ' ms');
              this.retryDate = performance.now() + delay;
              // retry loading state
              // if loadedmetadata is not set, it means that we are emergency switch down on first frag
              // in that case, reset startFragRequested flag
              if (!this.loadedmetadata) {
                this.startFragRequested = false;
                this.nextLoadPosition = this.startPosition;
              }
              this.state = State.FRAG_LOADING_WAITING_RETRY;
            } else {
              _logger.logger.error('mediaController: ' + data.details + ' reaches max retry, redispatch as fatal ...');
              // switch error to fatal
              data.fatal = true;
              this.state = State.ERROR;
            }
          }
          break;
        case _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
          if (!data.fatal) {
            // if buffer is not empty
            if (mediaBuffered) {
              // try to reduce max buffer length : rationale is that we could get
              // frag loop loading error because of buffer eviction
              this._reduceMaxBufferLength(frag.duration);
              this.state = State.IDLE;
            } else {
              // buffer empty. report as fatal if in manual mode or if lowest level.
              // level controller takes care of emergency switch down logic
              if (!frag.autoLevel || frag.level === 0) {
                // switch error to fatal
                data.fatal = true;
                this.state = State.ERROR;
              }
            }
          }
          break;
        case _errors.ErrorDetails.LEVEL_LOAD_ERROR:
        case _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT:
          if (this.state !== State.ERROR) {
            if (data.fatal) {
              // if fatal error, stop processing
              this.state = State.ERROR;
              _logger.logger.warn('streamController: ' + data.details + ',switch to ' + this.state + ' state ...');
            } else {
              // in case of non fatal error while loading level, if level controller is not retrying to load level , switch back to IDLE
              if (!data.levelRetry && this.state === State.WAITING_LEVEL) {
                this.state = State.IDLE;
              }
            }
          }
          break;
        case _errors.ErrorDetails.BUFFER_FULL_ERROR:
          // if in appending state
          if (data.parent === 'main' && (this.state === State.PARSING || this.state === State.PARSED)) {
            // reduce max buf len if current position is buffered
            if (mediaBuffered) {
              this._reduceMaxBufferLength(this.config.maxBufferLength);
              this.state = State.IDLE;
            } else {
              // current position is not buffered, but browser is still complaining about buffer full error
              // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
              // in that case flush the whole buffer to recover
              _logger.logger.warn('buffer full error also media.currentTime is not buffered, flush everything');
              this.fragCurrent = null;
              // flush everything
              this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
            }
          }
          break;
        default:
          break;
      }
    }
  }, {
    key: '_reduceMaxBufferLength',
    value: function _reduceMaxBufferLength(minLength) {
      var config = this.config;
      if (config.maxMaxBufferLength >= minLength) {
        // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
        config.maxMaxBufferLength /= 2;
        _logger.logger.warn('main:reduce max buffer length to ' + config.maxMaxBufferLength + 's');
        // increase fragment load Index to avoid frag loop loading error after buffer flush
        this.fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
      }
    }
  }, {
    key: '_checkBuffer',
    value: function _checkBuffer() {
      var media = this.media,
          config = this.config;
      // if ready state different from HAVE_NOTHING (numeric value 0), we are allowed to seek
      if (media && media.readyState) {
        var currentTime = media.currentTime,
            mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media,
            buffered = mediaBuffer.buffered;
        // adjust currentTime to start position on loaded metadata
        if (!this.loadedmetadata && buffered.length) {
          this.loadedmetadata = true;
          // only adjust currentTime if different from startPosition or if startPosition not buffered
          // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
          var startPosition = media.seeking ? currentTime : this.startPosition,
              startPositionBuffered = _bufferHelper2.default.isBuffered(mediaBuffer, startPosition),
              firstbufferedPosition = buffered.start(0);
          // if currentTime not matching with expected startPosition or startPosition not buffered
          if (currentTime !== startPosition || !startPositionBuffered && Math.abs(startPosition - firstbufferedPosition) < config.maxSeekHole) {
            _logger.logger.log('target start position:' + startPosition);
            // if startPosition not buffered, let's seek to buffered.start(0)
            if (!startPositionBuffered) {
              startPosition = firstbufferedPosition;
              _logger.logger.log('target start position not buffered, seek to buffered.start(0) ' + startPosition);
            }
            _logger.logger.log('adjust currentTime from ' + currentTime + ' to ' + startPosition);
            media.currentTime = startPosition;
          }
        } else if (this.immediateSwitch) {
          this.immediateLevelSwitchEnd();
        } else {
          var bufferInfo = _bufferHelper2.default.bufferInfo(media, currentTime, 0),
              expectedPlaying = !(media.paused || // not playing when media is paused
          media.ended || // not playing when media is ended
          media.buffered.length === 0),
              // not playing if nothing buffered
          jumpThreshold = 0.5,
              // tolerance needed as some browsers stalls playback before reaching buffered range end
          playheadMoving = currentTime !== this.lastCurrentTime;

          if (playheadMoving) {
            // played moving, but was previously stalled => now not stuck anymore
            if (this.stallReported) {
              _logger.logger.warn('playback not stuck anymore @' + currentTime + ', after ' + Math.round(performance.now() - this.stalled) + 'ms');
              this.stallReported = false;
            }
            this.stalled = undefined;
            this.nudgeRetry = 0;
          } else {
            // playhead not moving
            if (expectedPlaying) {
              // playhead not moving BUT media expected to play
              var tnow = performance.now();
              var hls = this.hls;
              if (!this.stalled) {
                // stall just detected, store current time
                this.stalled = tnow;
                this.stallReported = false;
              } else {
                // playback already stalled, check stalling duration
                // if stalling for more than a given threshold, let's try to recover
                var stalledDuration = tnow - this.stalled;
                var bufferLen = bufferInfo.len;
                var nudgeRetry = this.nudgeRetry || 0;
                // have we reached stall deadline ?
                if (bufferLen <= jumpThreshold && stalledDuration > config.lowBufferWatchdogPeriod * 1000) {
                  // report stalled error once
                  if (!this.stallReported) {
                    this.stallReported = true;
                    _logger.logger.warn('playback stalling in low buffer @' + currentTime);
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_STALLED_ERROR, fatal: false, buffer: bufferLen });
                  }
                  // if buffer len is below threshold, try to jump to start of next buffer range if close
                  // no buffer available @ currentTime, check if next buffer is close (within a config.maxSeekHole second range)
                  var nextBufferStart = bufferInfo.nextStart,
                      delta = nextBufferStart - currentTime;
                  if (nextBufferStart && delta < config.maxSeekHole && delta > 0) {
                    this.nudgeRetry = ++nudgeRetry;
                    var nudgeOffset = nudgeRetry * config.nudgeOffset;
                    // next buffer is close ! adjust currentTime to nextBufferStart
                    // this will ensure effective video decoding
                    _logger.logger.log('adjust currentTime from ' + media.currentTime + ' to next buffered @ ' + nextBufferStart + ' + nudge ' + nudgeOffset);
                    media.currentTime = nextBufferStart + nudgeOffset;
                    // reset stalled so to rearm watchdog timer
                    this.stalled = undefined;
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_SEEK_OVER_HOLE, fatal: false, hole: nextBufferStart + nudgeOffset - currentTime });
                  }
                } else if (bufferLen > jumpThreshold && stalledDuration > config.highBufferWatchdogPeriod * 1000) {
                  // report stalled error once
                  if (!this.stallReported) {
                    this.stallReported = true;
                    _logger.logger.warn('playback stalling in high buffer @' + currentTime);
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_STALLED_ERROR, fatal: false, buffer: bufferLen });
                  }
                  // reset stalled so to rearm watchdog timer
                  this.stalled = undefined;
                  this.nudgeRetry = ++nudgeRetry;
                  if (nudgeRetry < config.nudgeMaxRetry) {
                    var _currentTime = media.currentTime;
                    var targetTime = _currentTime + nudgeRetry * config.nudgeOffset;
                    _logger.logger.log('adjust currentTime from ' + _currentTime + ' to ' + targetTime);
                    // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
                    media.currentTime = targetTime;
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_NUDGE_ON_STALL, fatal: false });
                  } else {
                    _logger.logger.error('still stuck in high buffer @' + currentTime + ' after ' + config.nudgeMaxRetry + ', raise fatal error');
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_STALLED_ERROR, fatal: true });
                  }
                }
              }
            }
          }
        }
      }
    }
  }, {
    key: 'onFragLoadEmergencyAborted',
    value: function onFragLoadEmergencyAborted() {
      this.state = State.IDLE;
      // if loadedmetadata is not set, it means that we are emergency switch down on first frag
      // in that case, reset startFragRequested flag
      if (!this.loadedmetadata) {
        this.startFragRequested = false;
        this.nextLoadPosition = this.startPosition;
      }
      this.tick();
    }
  }, {
    key: 'onBufferFlushed',
    value: function onBufferFlushed() {
      /* after successful buffer flushing, filter flushed fragments from bufferedFrags
        use mediaBuffered instead of media (so that we will check against video.buffered ranges in case of alt audio track)
      */
      var media = this.mediaBuffer ? this.mediaBuffer : this.media;
      this._bufferedFrags = this._bufferedFrags.filter(function (frag) {
        return _bufferHelper2.default.isBuffered(media, (frag.startPTS + frag.endPTS) / 2);
      });

      // increase fragment load Index to avoid frag loop loading error after buffer flush
      this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
      // move to IDLE once flush complete. this should trigger new fragment loading
      this.state = State.IDLE;
      // reset reference to frag
      this.fragPrevious = null;
    }
  }, {
    key: 'swapAudioCodec',
    value: function swapAudioCodec() {
      this.audioCodecSwap = !this.audioCodecSwap;
    }
  }, {
    key: 'computeLivePosition',
    value: function computeLivePosition(sliding, levelDetails) {
      var targetLatency = this.config.liveSyncDuration !== undefined ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * levelDetails.targetduration;
      return sliding + Math.max(0, levelDetails.totalduration - targetLatency);
    }
  }, {
    key: 'state',
    set: function set(nextState) {
      if (this.state !== nextState) {
        var previousState = this.state;
        this._state = nextState;
        _logger.logger.log('main stream:' + previousState + '->' + nextState);
        this.hls.trigger(_events2.default.STREAM_STATE_TRANSITION, { previousState: previousState, nextState: nextState });
      }
    },
    get: function get() {
      return this._state;
    }
  }, {
    key: 'currentLevel',
    get: function get() {
      var media = this.media;
      if (media) {
        var frag = this.getBufferedFrag(media.currentTime);
        if (frag) {
          return frag.level;
        }
      }
      return -1;
    }
  }, {
    key: 'nextBufferedFrag',
    get: function get() {
      var media = this.media;
      if (media) {
        // first get end range of current fragment
        return this.followingBufferedFrag(this.getBufferedFrag(media.currentTime));
      } else {
        return null;
      }
    }
  }, {
    key: 'nextLevel',
    get: function get() {
      var frag = this.nextBufferedFrag;
      if (frag) {
        return frag.level;
      } else {
        return -1;
      }
    }
  }, {
    key: 'liveSyncPosition',
    get: function get() {
      return this._liveSyncPosition;
    },
    set: function set(value) {
      this._liveSyncPosition = value;
    }
  }]);

  return StreamController;
}(_eventHandler2.default);

exports.default = StreamController;

},{"25":25,"33":33,"34":34,"35":35,"37":37,"38":38,"48":48,"54":54,"55":55}],14:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = _dereq_(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Subtitle Stream Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var SubtitleStreamController = function (_EventHandler) {
  _inherits(SubtitleStreamController, _EventHandler);

  function SubtitleStreamController(hls) {
    _classCallCheck(this, SubtitleStreamController);

    var _this = _possibleConstructorReturn(this, (SubtitleStreamController.__proto__ || Object.getPrototypeOf(SubtitleStreamController)).call(this, hls, _events2.default.ERROR, _events2.default.SUBTITLE_TRACKS_UPDATED, _events2.default.SUBTITLE_TRACK_SWITCH, _events2.default.SUBTITLE_TRACK_LOADED, _events2.default.SUBTITLE_FRAG_PROCESSED));

    _this.config = hls.config;
    _this.vttFragSNsProcessed = {};
    _this.vttFragQueues = undefined;
    _this.currentlyProcessing = null;
    _this.currentTrackId = -1;
    return _this;
  }

  _createClass(SubtitleStreamController, [{
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }

    // Remove all queued items and create a new, empty queue for each track.

  }, {
    key: 'clearVttFragQueues',
    value: function clearVttFragQueues() {
      var _this2 = this;

      this.vttFragQueues = {};
      this.tracks.forEach(function (track) {
        _this2.vttFragQueues[track.id] = [];
      });
    }

    // If no frag is being processed and queue isn't empty, initiate processing of next frag in line.

  }, {
    key: 'nextFrag',
    value: function nextFrag() {
      if (this.currentlyProcessing === null && this.currentTrackId > -1 && this.vttFragQueues[this.currentTrackId].length) {
        var frag = this.currentlyProcessing = this.vttFragQueues[this.currentTrackId].shift();
        this.hls.trigger(_events2.default.FRAG_LOADING, { frag: frag });
      }
    }

    // When fragment has finished processing, add sn to list of completed if successful.

  }, {
    key: 'onSubtitleFragProcessed',
    value: function onSubtitleFragProcessed(data) {
      if (data.success) {
        this.vttFragSNsProcessed[data.frag.trackId].push(data.frag.sn);
      }
      this.currentlyProcessing = null;
      this.nextFrag();
    }

    // If something goes wrong, procede to next frag, if we were processing one.

  }, {
    key: 'onError',
    value: function onError(data) {
      var frag = data.frag;
      // don't handle frag error not related to subtitle fragment
      if (frag && frag.type !== 'subtitle') {
        return;
      }
      if (this.currentlyProcessing) {
        this.currentlyProcessing = null;
        this.nextFrag();
      }
    }

    // Got all new subtitle tracks.

  }, {
    key: 'onSubtitleTracksUpdated',
    value: function onSubtitleTracksUpdated(data) {
      var _this3 = this;

      _logger.logger.log('subtitle tracks updated');
      this.tracks = data.subtitleTracks;
      this.clearVttFragQueues();
      this.vttFragSNsProcessed = {};
      this.tracks.forEach(function (track) {
        _this3.vttFragSNsProcessed[track.id] = [];
      });
    }
  }, {
    key: 'onSubtitleTrackSwitch',
    value: function onSubtitleTrackSwitch(data) {
      this.currentTrackId = data.id;
      this.clearVttFragQueues();
    }

    // Got a new set of subtitle fragments.

  }, {
    key: 'onSubtitleTrackLoaded',
    value: function onSubtitleTrackLoaded(data) {
      var processedFragSNs = this.vttFragSNsProcessed[data.id],
          fragQueue = this.vttFragQueues[data.id],
          currentFragSN = !!this.currentlyProcessing ? this.currentlyProcessing.sn : -1;

      var alreadyProcessed = function alreadyProcessed(frag) {
        return processedFragSNs.indexOf(frag.sn) > -1;
      };

      var alreadyInQueue = function alreadyInQueue(frag) {
        return fragQueue.some(function (fragInQueue) {
          return fragInQueue.sn === frag.sn;
        });
      };

      // Add all fragments that haven't been, aren't currently being and aren't waiting to be processed, to queue.
      data.details.fragments.forEach(function (frag) {
        if (!(alreadyProcessed(frag) || frag.sn === currentFragSN || alreadyInQueue(frag))) {
          // Frags don't know their subtitle track ID, so let's just add that...
          frag.trackId = data.id;
          fragQueue.push(frag);
        }
      });

      this.nextFrag();
    }
  }]);

  return SubtitleStreamController;
}(_eventHandler2.default);

exports.default = SubtitleStreamController;

},{"34":34,"35":35,"54":54}],15:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = _dereq_(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * audio track controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

function filterSubtitleTracks(textTrackList) {
  var tracks = [];
  for (var i = 0; i < textTrackList.length; i++) {
    if (textTrackList[i].kind === 'subtitles') {
      tracks.push(textTrackList[i]);
    }
  }
  return tracks;
}

var SubtitleTrackController = function (_EventHandler) {
  _inherits(SubtitleTrackController, _EventHandler);

  function SubtitleTrackController(hls) {
    _classCallCheck(this, SubtitleTrackController);

    var _this = _possibleConstructorReturn(this, (SubtitleTrackController.__proto__ || Object.getPrototypeOf(SubtitleTrackController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_LOADED, _events2.default.SUBTITLE_TRACK_LOADED));

    _this.tracks = [];
    _this.trackId = -1;
    _this.media = undefined;
    return _this;
  }

  _createClass(SubtitleTrackController, [{
    key: '_onTextTracksChanged',
    value: function _onTextTracksChanged() {
      // Media is undefined when switching streams via loadSource()
      if (!this.media) {
        return;
      }

      var trackId = -1;
      var tracks = filterSubtitleTracks(this.media.textTracks);
      for (var id = 0; id < tracks.length; id++) {
        if (tracks[id].mode === 'showing') {
          trackId = id;
        }
      }

      // Setting current subtitleTrack will invoke code.
      this.subtitleTrack = trackId;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }

    // Listen for subtitle track change, then extract the current track ID.

  }, {
    key: 'onMediaAttached',
    value: function onMediaAttached(data) {
      this.media = data.media;
      if (!this.media) {
        return;
      }

      this.trackChangeListener = this._onTextTracksChanged.bind(this);
      this.media.textTracks.addEventListener('change', this.trackChangeListener);
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      if (!this.media) {
        return;
      }

      this.media.textTracks.removeEventListener('change', this.trackChangeListener);

      this.media = undefined;
    }

    // Reset subtitle tracks on manifest loading

  }, {
    key: 'onManifestLoading',
    value: function onManifestLoading() {
      this.tracks = [];
      this.trackId = -1;
    }

    // Fired whenever a new manifest is loaded.

  }, {
    key: 'onManifestLoaded',
    value: function onManifestLoaded(data) {
      var _this2 = this;

      var tracks = data.subtitles || [];
      var defaultFound = false;
      this.tracks = tracks;
      this.trackId = -1;
      this.hls.trigger(_events2.default.SUBTITLE_TRACKS_UPDATED, { subtitleTracks: tracks });

      // loop through available subtitle tracks and autoselect default if needed
      // TODO: improve selection logic to handle forced, etc
      tracks.forEach(function (track) {
        if (track.default) {
          _this2.subtitleTrack = track.id;
          defaultFound = true;
        }
      });
    }

    // Trigger subtitle track playlist reload.

  }, {
    key: 'onTick',
    value: function onTick() {
      var trackId = this.trackId;
      var subtitleTrack = this.tracks[trackId];
      if (!subtitleTrack) {
        return;
      }

      var details = subtitleTrack.details;
      // check if we need to load playlist for this subtitle Track
      if (details === undefined || details.live === true) {
        // track not retrieved yet, or live playlist we need to (re)load it
        _logger.logger.log('(re)loading playlist for subtitle track ' + trackId);
        this.hls.trigger(_events2.default.SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: trackId });
      }
    }
  }, {
    key: 'onSubtitleTrackLoaded',
    value: function onSubtitleTrackLoaded(data) {
      var _this3 = this;

      if (data.id < this.tracks.length) {
        _logger.logger.log('subtitle track ' + data.id + ' loaded');
        this.tracks[data.id].details = data.details;
        // check if current playlist is a live playlist
        if (data.details.live && !this.timer) {
          // if live playlist we will have to reload it periodically
          // set reload period to playlist target duration
          this.timer = setInterval(function () {
            _this3.onTick();
          }, 1000 * data.details.targetduration, this);
        }
        if (!data.details.live && this.timer) {
          // playlist is not live and timer is armed : stopping it
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    /** get alternate subtitle tracks list from playlist **/

  }, {
    key: 'setSubtitleTrackInternal',
    value: function setSubtitleTrackInternal(newId) {
      // check if level idx is valid
      if (newId >= 0 && newId < this.tracks.length) {
        // stopping live reloading timer if any
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.trackId = newId;
        _logger.logger.log('switching to subtitle track ' + newId);
        var subtitleTrack = this.tracks[newId];
        this.hls.trigger(_events2.default.SUBTITLE_TRACK_SWITCH, { id: newId });
        // check if we need to load playlist for this subtitle Track
        var details = subtitleTrack.details;
        if (details === undefined || details.live === true) {
          // track not retrieved yet, or live playlist we need to (re)load it
          _logger.logger.log('(re)loading playlist for subtitle track ' + newId);
          this.hls.trigger(_events2.default.SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: newId });
        }
      }
    }
  }, {
    key: 'subtitleTracks',
    get: function get() {
      return this.tracks;
    }

    /** get index of the selected subtitle track (index in subtitle track lists) **/

  }, {
    key: 'subtitleTrack',
    get: function get() {
      return this.trackId;
    }

    /** select a subtitle track, based on its index in subtitle track lists**/
    ,
    set: function set(subtitleTrackId) {
      if (this.trackId !== subtitleTrackId) {
        // || this.tracks[subtitleTrackId].details === undefined) {
        this.setSubtitleTrackInternal(subtitleTrackId);
      }
    }
  }]);

  return SubtitleTrackController;
}(_eventHandler2.default);

exports.default = SubtitleTrackController;

},{"34":34,"35":35,"54":54}],16:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _cea608Parser = _dereq_(49);

var _cea608Parser2 = _interopRequireDefault(_cea608Parser);

var _webvttParser = _dereq_(58);

var _webvttParser2 = _interopRequireDefault(_webvttParser);

var _logger = _dereq_(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Timeline Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

function clearCurrentCues(track) {
  if (track && track.cues) {
    while (track.cues.length > 0) {
      track.removeCue(track.cues[0]);
    }
  }
}

function reuseVttTextTrack(inUseTrack, manifestTrack) {
  return inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
}

function intersection(x1, x2, y1, y2) {
  return Math.min(x2, y2) - Math.max(x1, y1);
}

var TimelineController = function (_EventHandler) {
  _inherits(TimelineController, _EventHandler);

  function TimelineController(hls) {
    _classCallCheck(this, TimelineController);

    var _this = _possibleConstructorReturn(this, (TimelineController.__proto__ || Object.getPrototypeOf(TimelineController)).call(this, hls, _events2.default.MEDIA_ATTACHING, _events2.default.MEDIA_DETACHING, _events2.default.FRAG_PARSING_USERDATA, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_LOADED, _events2.default.FRAG_LOADED, _events2.default.LEVEL_SWITCHING, _events2.default.INIT_PTS_FOUND));

    _this.hls = hls;
    _this.config = hls.config;
    _this.enabled = true;
    _this.Cues = hls.config.cueHandler;
    _this.textTracks = [];
    _this.tracks = [];
    _this.unparsedVttFrags = [];
    _this.initPTS = undefined;
    _this.cueRanges = [];

    if (_this.config.enableCEA708Captions) {
      var self = _this;
      var sendAddTrackEvent = function sendAddTrackEvent(track, media) {
        var e = null;
        try {
          e = new window.Event('addtrack');
        } catch (err) {
          //for IE11
          e = document.createEvent('Event');
          e.initEvent('addtrack', false, false);
        }
        e.track = track;
        media.dispatchEvent(e);
      };

      var channel1 = {
        'newCue': function newCue(startTime, endTime, screen) {
          if (!self.textTrack1) {
            //Enable reuse of existing text track.
            var existingTrack1 = self.getExistingTrack('1');
            if (!existingTrack1) {
              var textTrack1 = self.createTextTrack('captions', self.config.captionsTextTrack1Label, self.config.captionsTextTrack1LanguageCode);
              if (textTrack1) {
                textTrack1.textTrack1 = true;
                self.textTrack1 = textTrack1;
              }
            } else {
              self.textTrack1 = existingTrack1;
              clearCurrentCues(self.textTrack1);

              sendAddTrackEvent(self.textTrack1, self.media);
            }
          }
          self.addCues('textTrack1', startTime, endTime, screen);
        }
      };

      var channel2 = {
        'newCue': function newCue(startTime, endTime, screen) {
          if (!self.textTrack2) {
            //Enable reuse of existing text track.
            var existingTrack2 = self.getExistingTrack('2');
            if (!existingTrack2) {
              var textTrack2 = self.createTextTrack('captions', self.config.captionsTextTrack2Label, self.config.captionsTextTrack1LanguageCode);
              if (textTrack2) {
                textTrack2.textTrack2 = true;
                self.textTrack2 = textTrack2;
              }
            } else {
              self.textTrack2 = existingTrack2;
              clearCurrentCues(self.textTrack2);

              sendAddTrackEvent(self.textTrack2, self.media);
            }
          }
          self.addCues('textTrack2', startTime, endTime, screen);
        }
      };

      _this.cea608Parser = new _cea608Parser2.default(0, channel1, channel2);
    }
    return _this;
  }

  _createClass(TimelineController, [{
    key: 'addCues',
    value: function addCues(channel, startTime, endTime, screen) {
      // skip cues which overlap more than 50% with previously parsed time ranges
      var ranges = this.cueRanges;
      var merged = false;
      for (var i = ranges.length; i--;) {
        var cueRange = ranges[i];
        var overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
        if (overlap >= 0) {
          cueRange[0] = Math.min(cueRange[0], startTime);
          cueRange[1] = Math.max(cueRange[1], endTime);
          merged = true;
          if (overlap / (endTime - startTime) > 0.5) {
            return;
          }
        }
      }
      if (!merged) {
        ranges.push([startTime, endTime]);
      }
      this.Cues.newCue(this[channel], startTime, endTime, screen);
    }

    // Triggered when an initial PTS is found; used for synchronisation of WebVTT.

  }, {
    key: 'onInitPtsFound',
    value: function onInitPtsFound(data) {
      var _this2 = this;

      if (typeof this.initPTS === 'undefined') {
        this.initPTS = data.initPTS;
      }

      // Due to asynchrony, initial PTS may arrive later than the first VTT fragments are loaded.
      // Parse any unparsed fragments upon receiving the initial PTS.
      if (this.unparsedVttFrags.length) {
        this.unparsedVttFrags.forEach(function (frag) {
          _this2.onFragLoaded(frag);
        });
        this.unparsedVttFrags = [];
      }
    }
  }, {
    key: 'getExistingTrack',
    value: function getExistingTrack(channelNumber) {
      var media = this.media;
      if (media) {
        for (var i = 0; i < media.textTracks.length; i++) {
          var textTrack = media.textTracks[i];
          var propName = 'textTrack' + channelNumber;
          if (textTrack[propName] === true) {
            return textTrack;
          }
        }
      }
      return null;
    }
  }, {
    key: 'createTextTrack',
    value: function createTextTrack(kind, label, lang) {
      var media = this.media;
      if (media) {
        return media.addTextTrack(kind, label, lang);
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onMediaAttaching',
    value: function onMediaAttaching(data) {
      this.media = data.media;
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      clearCurrentCues(this.textTrack1);
      clearCurrentCues(this.textTrack2);
    }
  }, {
    key: 'onManifestLoading',
    value: function onManifestLoading() {
      this.lastSn = -1; // Detect discontiguity in fragment parsing
      this.prevCC = -1;
      this.vttCCs = { ccOffset: 0, presentationOffset: 0 }; // Detect discontinuity in subtitle manifests

      // clear outdated subtitles
      var media = this.media;
      if (media) {
        var textTracks = media.textTracks;
        if (textTracks) {
          for (var i = 0; i < textTracks.length; i++) {
            clearCurrentCues(textTracks[i]);
          }
        }
      }
    }
  }, {
    key: 'onManifestLoaded',
    value: function onManifestLoaded(data) {
      var _this3 = this;

      this.textTracks = [];
      this.unparsedVttFrags = this.unparsedVttFrags || [];
      this.initPTS = undefined;
      this.cueRanges = [];

      if (this.config.enableWebVTT) {
        this.tracks = data.subtitles || [];
        var inUseTracks = this.media ? this.media.textTracks : [];

        this.tracks.forEach(function (track, index) {
          var textTrack = void 0;
          if (index < inUseTracks.length) {
            var inUseTrack = inUseTracks[index];
            // Reuse tracks with the same label, but do not reuse 608/708 tracks
            if (reuseVttTextTrack(inUseTrack, track)) {
              textTrack = inUseTrack;
            }
          }
          if (!textTrack) {
            textTrack = _this3.createTextTrack('subtitles', track.name, track.lang);
          }
          textTrack.mode = track.default ? 'showing' : 'hidden';
          _this3.textTracks.push(textTrack);
        });
      }
    }
  }, {
    key: 'onLevelSwitching',
    value: function onLevelSwitching() {
      this.enabled = this.hls.currentLevel.closedCaptions !== 'NONE';
    }
  }, {
    key: 'onFragLoaded',
    value: function onFragLoaded(data) {
      var frag = data.frag,
          payload = data.payload;
      if (frag.type === 'main') {
        var sn = frag.sn;
        // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
        if (sn !== this.lastSn + 1) {
          var cea608Parser = this.cea608Parser;
          if (cea608Parser) {
            cea608Parser.reset();
          }
        }
        this.lastSn = sn;
      }
      // If fragment is subtitle type, parse as WebVTT.
      else if (frag.type === 'subtitle') {
          if (payload.byteLength) {
            // We need an initial synchronisation PTS. Store fragments as long as none has arrived.
            if (typeof this.initPTS === 'undefined') {
              this.unparsedVttFrags.push(data);
              return;
            }
            var vttCCs = this.vttCCs;
            if (!vttCCs[frag.cc]) {
              vttCCs[frag.cc] = { start: frag.start, prevCC: this.prevCC, new: true };
              this.prevCC = frag.cc;
            }
            var textTracks = this.textTracks,
                hls = this.hls;

            // Parse the WebVTT file contents.
            _webvttParser2.default.parse(payload, this.initPTS, vttCCs, frag.cc, function (cues) {
              var currentTrack = textTracks[frag.trackId];
              // Add cues and trigger event with success true.
              cues.forEach(function (cue) {
                // Sometimes there are cue overlaps on segmented vtts so the same
                // cue can appear more than once in different vtt files.
                // This avoid showing duplicated cues with same timecode and text.
                if (!currentTrack.cues.getCueById(cue.id)) {
                  try {
                    currentTrack.addCue(cue);
                  } catch (err) {
                    var textTrackCue = new window.TextTrackCue(cue.startTime, cue.endTime, cue.text);
                    textTrackCue.id = cue.id;
                    currentTrack.addCue(textTrackCue);
                  }
                }
              });
              hls.trigger(_events2.default.SUBTITLE_FRAG_PROCESSED, { success: true, frag: frag });
            }, function (e) {
              // Something went wrong while parsing. Trigger event with success false.
              _logger.logger.log('Failed to parse VTT cue: ' + e);
              hls.trigger(_events2.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
            });
          } else {
            // In case there is no payload, finish unsuccessfully.
            this.hls.trigger(_events2.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
          }
        }
    }
  }, {
    key: 'onFragParsingUserdata',
    value: function onFragParsingUserdata(data) {
      // push all of the CEA-708 messages into the interpreter
      // immediately. It will create the proper timestamps based on our PTS value
      if (this.enabled && this.config.enableCEA708Captions) {
        for (var i = 0; i < data.samples.length; i++) {
          var ccdatas = this.extractCea608Data(data.samples[i].bytes);
          this.cea608Parser.addData(data.samples[i].pts, ccdatas);
        }
      }
    }
  }, {
    key: 'extractCea608Data',
    value: function extractCea608Data(byteArray) {
      var count = byteArray[0] & 31;
      var position = 2;
      var tmpByte, ccbyte1, ccbyte2, ccValid, ccType;
      var actualCCBytes = [];

      for (var j = 0; j < count; j++) {
        tmpByte = byteArray[position++];
        ccbyte1 = 0x7F & byteArray[position++];
        ccbyte2 = 0x7F & byteArray[position++];
        ccValid = (4 & tmpByte) !== 0;
        ccType = 3 & tmpByte;

        if (ccbyte1 === 0 && ccbyte2 === 0) {
          continue;
        }

        if (ccValid) {
          if (ccType === 0) // || ccType === 1
            {
              actualCCBytes.push(ccbyte1);
              actualCCBytes.push(ccbyte2);
            }
        }
      }
      return actualCCBytes;
    }
  }]);

  return TimelineController;
}(_eventHandler2.default);

exports.default = TimelineController;

},{"34":34,"35":35,"49":49,"54":54,"58":58}],17:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AESCrypto = function () {
  function AESCrypto(subtle, iv) {
    _classCallCheck(this, AESCrypto);

    this.subtle = subtle;
    this.aesIV = iv;
  }

  _createClass(AESCrypto, [{
    key: 'decrypt',
    value: function decrypt(data, key) {
      return this.subtle.decrypt({ name: 'AES-CBC', iv: this.aesIV }, key, data);
    }
  }]);

  return AESCrypto;
}();

exports.default = AESCrypto;

},{}],18:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AESDecryptor = function () {
  function AESDecryptor() {
    _classCallCheck(this, AESDecryptor);

    // Static after running initTable
    this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
    this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.sBox = new Uint32Array(256);
    this.invSBox = new Uint32Array(256);

    // Changes during runtime
    this.key = new Uint32Array(0);

    this.initTable();
  }

  // Using view.getUint32() also swaps the byte order.


  _createClass(AESDecryptor, [{
    key: 'uint8ArrayToUint32Array_',
    value: function uint8ArrayToUint32Array_(arrayBuffer) {
      var view = new DataView(arrayBuffer);
      var newArray = new Uint32Array(4);
      for (var i = 0; i < 4; i++) {
        newArray[i] = view.getUint32(i * 4);
      }
      return newArray;
    }
  }, {
    key: 'initTable',
    value: function initTable() {
      var sBox = this.sBox;
      var invSBox = this.invSBox;
      var subMix = this.subMix;
      var subMix0 = subMix[0];
      var subMix1 = subMix[1];
      var subMix2 = subMix[2];
      var subMix3 = subMix[3];
      var invSubMix = this.invSubMix;
      var invSubMix0 = invSubMix[0];
      var invSubMix1 = invSubMix[1];
      var invSubMix2 = invSubMix[2];
      var invSubMix3 = invSubMix[3];

      var d = new Uint32Array(256);
      var x = 0;
      var xi = 0;
      var i = 0;
      for (i = 0; i < 256; i++) {
        if (i < 128) {
          d[i] = i << 1;
        } else {
          d[i] = i << 1 ^ 0x11b;
        }
      }

      for (i = 0; i < 256; i++) {
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        sBox[x] = sx;
        invSBox[sx] = x;

        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];

        // Compute sub/invSub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        subMix0[x] = t << 24 | t >>> 8;
        subMix1[x] = t << 16 | t >>> 16;
        subMix2[x] = t << 8 | t >>> 24;
        subMix3[x] = t;

        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        invSubMix0[sx] = t << 24 | t >>> 8;
        invSubMix1[sx] = t << 16 | t >>> 16;
        invSubMix2[sx] = t << 8 | t >>> 24;
        invSubMix3[sx] = t;

        // Compute next counter
        if (!x) {
          x = xi = 1;
        } else {
          x = x2 ^ d[d[d[x8 ^ x2]]];
          xi ^= d[d[xi]];
        }
      }
    }
  }, {
    key: 'expandKey',
    value: function expandKey(keyBuffer) {
      // convert keyBuffer to Uint32Array
      var key = this.uint8ArrayToUint32Array_(keyBuffer);
      var sameKey = true;
      var offset = 0;

      while (offset < key.length && sameKey) {
        sameKey = key[offset] === this.key[offset];
        offset++;
      }

      if (sameKey) {
        return;
      }

      this.key = key;
      var keySize = this.keySize = key.length;

      if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
        throw new Error('Invalid aes key size=' + keySize);
      }

      var ksRows = this.ksRows = (keySize + 6 + 1) * 4;
      var ksRow = void 0;
      var invKsRow = void 0;

      var keySchedule = this.keySchedule = new Uint32Array(ksRows);
      var invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
      var sbox = this.sBox;
      var rcon = this.rcon;

      var invSubMix = this.invSubMix;
      var invSubMix0 = invSubMix[0];
      var invSubMix1 = invSubMix[1];
      var invSubMix2 = invSubMix[2];
      var invSubMix3 = invSubMix[3];

      var prev = void 0;
      var t = void 0;

      for (ksRow = 0; ksRow < ksRows; ksRow++) {
        if (ksRow < keySize) {
          prev = keySchedule[ksRow] = key[ksRow];
          continue;
        }
        t = prev;

        if (ksRow % keySize === 0) {
          // Rot word
          t = t << 8 | t >>> 24;

          // Sub word
          t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];

          // Mix Rcon
          t ^= rcon[ksRow / keySize | 0] << 24;
        } else if (keySize > 6 && ksRow % keySize === 4) {
          // Sub word
          t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
        }

        keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
      }

      for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
        ksRow = ksRows - invKsRow;
        if (invKsRow & 3) {
          t = keySchedule[ksRow];
        } else {
          t = keySchedule[ksRow - 4];
        }

        if (invKsRow < 4 || ksRow <= 4) {
          invKeySchedule[invKsRow] = t;
        } else {
          invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
        }

        invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
      }
    }

    // Adding this as a method greatly improves performance.

  }, {
    key: 'networkToHostOrderSwap',
    value: function networkToHostOrderSwap(word) {
      return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
    }
  }, {
    key: 'decrypt',
    value: function decrypt(inputArrayBuffer, offset, aesIV) {
      var nRounds = this.keySize + 6;
      var invKeySchedule = this.invKeySchedule;
      var invSBOX = this.invSBox;

      var invSubMix = this.invSubMix;
      var invSubMix0 = invSubMix[0];
      var invSubMix1 = invSubMix[1];
      var invSubMix2 = invSubMix[2];
      var invSubMix3 = invSubMix[3];

      var initVector = this.uint8ArrayToUint32Array_(aesIV);
      var initVector0 = initVector[0];
      var initVector1 = initVector[1];
      var initVector2 = initVector[2];
      var initVector3 = initVector[3];

      var inputInt32 = new Int32Array(inputArrayBuffer);
      var outputInt32 = new Int32Array(inputInt32.length);

      var t0 = void 0,
          t1 = void 0,
          t2 = void 0,
          t3 = void 0;
      var s0 = void 0,
          s1 = void 0,
          s2 = void 0,
          s3 = void 0;
      var inputWords0 = void 0,
          inputWords1 = void 0,
          inputWords2 = void 0,
          inputWords3 = void 0;

      var ksRow, i;
      var swapWord = this.networkToHostOrderSwap;

      while (offset < inputInt32.length) {
        inputWords0 = swapWord(inputInt32[offset]);
        inputWords1 = swapWord(inputInt32[offset + 1]);
        inputWords2 = swapWord(inputInt32[offset + 2]);
        inputWords3 = swapWord(inputInt32[offset + 3]);

        s0 = inputWords0 ^ invKeySchedule[0];
        s1 = inputWords3 ^ invKeySchedule[1];
        s2 = inputWords2 ^ invKeySchedule[2];
        s3 = inputWords1 ^ invKeySchedule[3];

        ksRow = 4;

        // Iterate through the rounds of decryption
        for (i = 1; i < nRounds; i++) {
          t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
          t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
          t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
          t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
          // Update state
          s0 = t0;
          s1 = t1;
          s2 = t2;
          s3 = t3;

          ksRow = ksRow + 4;
        }

        // Shift rows, sub bytes, add round key
        t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
        t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
        t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
        t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
        ksRow = ksRow + 3;

        // Write
        outputInt32[offset] = swapWord(t0 ^ initVector0);
        outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
        outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
        outputInt32[offset + 3] = swapWord(t1 ^ initVector3);

        // reset initVector to last 4 unsigned int
        initVector0 = inputWords0;
        initVector1 = inputWords1;
        initVector2 = inputWords2;
        initVector3 = inputWords3;

        offset = offset + 4;
      }

      return outputInt32.buffer;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.key = undefined;
      this.keySize = undefined;
      this.ksRows = undefined;

      this.sBox = undefined;
      this.invSBox = undefined;
      this.subMix = undefined;
      this.invSubMix = undefined;
      this.keySchedule = undefined;
      this.invKeySchedule = undefined;

      this.rcon = undefined;
    }
  }]);

  return AESDecryptor;
}();

exports.default = AESDecryptor;

},{}],19:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _aesCrypto = _dereq_(17);

var _aesCrypto2 = _interopRequireDefault(_aesCrypto);

var _fastAesKey = _dereq_(20);

var _fastAesKey2 = _interopRequireDefault(_fastAesKey);

var _aesDecryptor = _dereq_(18);

var _aesDecryptor2 = _interopRequireDefault(_aesDecryptor);

var _errors = _dereq_(33);

var _logger = _dereq_(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*globals self: false */

var Decrypter = function () {
  function Decrypter(observer, config) {
    _classCallCheck(this, Decrypter);

    this.observer = observer;
    this.config = config;
    this.logEnabled = true;
    try {
      var browserCrypto = crypto ? crypto : self.crypto;
      this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
    } catch (e) {}
    this.disableWebCrypto = !this.subtle;
  }

  _createClass(Decrypter, [{
    key: 'isSync',
    value: function isSync() {
      return this.disableWebCrypto && this.config.enableSoftwareAES;
    }
  }, {
    key: 'decrypt',
    value: function decrypt(data, key, iv, callback) {
      var _this = this;

      if (this.disableWebCrypto && this.config.enableSoftwareAES) {
        if (this.logEnabled) {
          _logger.logger.log('JS AES decrypt');
          this.logEnabled = false;
        }
        var decryptor = this.decryptor;
        if (!decryptor) {
          this.decryptor = decryptor = new _aesDecryptor2.default();
        }
        decryptor.expandKey(key);
        callback(decryptor.decrypt(data, 0, iv));
      } else {
        if (this.logEnabled) {
          _logger.logger.log('WebCrypto AES decrypt');
          this.logEnabled = false;
        }
        var subtle = this.subtle;
        if (this.key !== key) {
          this.key = key;
          this.fastAesKey = new _fastAesKey2.default(subtle, key);
        }

        this.fastAesKey.expandKey().then(function (aesKey) {
          // decrypt using web crypto
          var crypto = new _aesCrypto2.default(subtle, iv);
          crypto.decrypt(data, aesKey).catch(function (err) {
            _this.onWebCryptoError(err, data, key, iv, callback);
          }).then(function (result) {
            callback(result);
          });
        }).catch(function (err) {
          _this.onWebCryptoError(err, data, key, iv, callback);
        });
      }
    }
  }, {
    key: 'onWebCryptoError',
    value: function onWebCryptoError(err, data, key, iv, callback) {
      if (this.config.enableSoftwareAES) {
        _logger.logger.log('WebCrypto Error, disable WebCrypto API');
        this.disableWebCrypto = true;
        this.logEnabled = true;
        this.decrypt(data, key, iv, callback);
      } else {
        _logger.logger.error('decrypting error : ' + err.message);
        this.observer.trigger(Event.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_DECRYPT_ERROR, fatal: true, reason: err.message });
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var decryptor = this.decryptor;
      if (decryptor) {
        decryptor.destroy();
        this.decryptor = undefined;
      }
    }
  }]);

  return Decrypter;
}();

exports.default = Decrypter;

},{"17":17,"18":18,"20":20,"33":33,"54":54}],20:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FastAESKey = function () {
  function FastAESKey(subtle, key) {
    _classCallCheck(this, FastAESKey);

    this.subtle = subtle;
    this.key = key;
  }

  _createClass(FastAESKey, [{
    key: 'expandKey',
    value: function expandKey() {
      return this.subtle.importKey('raw', this.key, { name: 'AES-CBC' }, false, ['encrypt', 'decrypt']);
    }
  }]);

  return FastAESKey;
}();

exports.default = FastAESKey;

},{}],21:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * AAC demuxer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _adts = _dereq_(22);

var _adts2 = _interopRequireDefault(_adts);

var _logger = _dereq_(54);

var _id = _dereq_(27);

var _id2 = _interopRequireDefault(_id);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AACDemuxer = function () {
  function AACDemuxer(observer, remuxer, config) {
    _classCallCheck(this, AACDemuxer);

    this.observer = observer;
    this.config = config;
    this.remuxer = remuxer;
  }

  _createClass(AACDemuxer, [{
    key: 'resetInitSegment',
    value: function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      this._audioTrack = { container: 'audio/adts', type: 'audio', id: -1, sequenceNumber: 0, isAAC: true, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
    }
  }, {
    key: 'resetTimeStamp',
    value: function resetTimeStamp() {}
  }, {
    key: 'append',


    // feed incoming data to the front of the parsing pipeline
    value: function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var track = this._audioTrack,
          id3Data = _id2.default.getID3Data(data, 0),
          pts = 90 * _id2.default.getTimeStamp(id3Data),
          frameIndex = 0,
          stamp = pts,
          length = data.length,
          offset = id3Data.length;

      var id3Samples = [{ pts: stamp, dts: stamp, data: id3Data }];

      while (offset < length - 1) {
        if (_adts2.default.isHeader(data, offset) && offset + 5 < length) {
          _adts2.default.initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
          var frame = _adts2.default.appendFrame(track, data, offset, pts, frameIndex);
          if (frame) {
            offset += frame.length;
            stamp = frame.sample.pts;
            frameIndex++;
          } else {
            _logger.logger.log('Unable to parse AAC frame');
            break;
          }
        } else if (_id2.default.isHeader(data, offset)) {
          id3Data = _id2.default.getID3Data(data, offset);
          id3Samples.push({ pts: stamp, dts: stamp, data: id3Data });
          offset += id3Data.length;
        } else {
          //nothing found, keep looking
          offset++;
        }
      }

      this.remuxer.remux(track, { samples: [] }, { samples: id3Samples, inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
    }
  }, {
    key: 'destroy',
    value: function destroy() {}
  }], [{
    key: 'probe',
    value: function probe(data) {
      // check if data contains ID3 timestamp and ADTS sync word
      var offset, length;
      var id3Data = _id2.default.getID3Data(data, 0);
      if (id3Data && _id2.default.getTimeStamp(id3Data) !== undefined) {
        // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
        // Layer bits (position 14 and 15) in header should be always 0 for ADTS
        // More info https://wiki.multimedia.cx/index.php?title=ADTS
        for (offset = id3Data.length, length = Math.min(data.length - 1, offset + 100); offset < length; offset++) {
          if (_adts2.default.probe(data, offset)) {
            _logger.logger.log('ADTS sync word found !');
            return true;
          }
        }
      }
      return false;
    }
  }]);

  return AACDemuxer;
}();

exports.default = AACDemuxer;

},{"22":22,"27":27,"54":54}],22:[function(_dereq_,module,exports){
'use strict';

var _logger = _dereq_(54);

var _errors = _dereq_(33);

/**
 *  ADTS parser helper
 */
var ADTS = {
  getAudioConfig: function getAudioConfig(observer, data, offset, audioCodec) {
    var adtsObjectType,
        // :int
    adtsSampleingIndex,
        // :int
    adtsExtensionSampleingIndex,
        // :int
    adtsChanelConfig,
        // :int
    config,
        userAgent = navigator.userAgent.toLowerCase(),
        manifestCodec = audioCodec,
        adtsSampleingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
    // byte 2
    adtsObjectType = ((data[offset + 2] & 0xC0) >>> 6) + 1;
    adtsSampleingIndex = (data[offset + 2] & 0x3C) >>> 2;
    if (adtsSampleingIndex > adtsSampleingRates.length - 1) {
      observer.trigger(Event.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_PARSING_ERROR, fatal: true, reason: 'invalid ADTS sampling index:' + adtsSampleingIndex });
      return;
    }
    adtsChanelConfig = (data[offset + 2] & 0x01) << 2;
    // byte 3
    adtsChanelConfig |= (data[offset + 3] & 0xC0) >>> 6;
    _logger.logger.log('manifest codec:' + audioCodec + ',ADTS data:type:' + adtsObjectType + ',sampleingIndex:' + adtsSampleingIndex + '[' + adtsSampleingRates[adtsSampleingIndex] + 'Hz],channelConfig:' + adtsChanelConfig);
    // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
    if (/firefox/i.test(userAgent)) {
      if (adtsSampleingIndex >= 6) {
        adtsObjectType = 5;
        config = new Array(4);
        // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
        // there is a factor 2 between frame sample rate and output sample rate
        // multiply frequency by 2 (see table below, equivalent to substract 3)
        adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
      } else {
        adtsObjectType = 2;
        config = new Array(2);
        adtsExtensionSampleingIndex = adtsSampleingIndex;
      }
      // Android : always use AAC
    } else if (userAgent.indexOf('android') !== -1) {
      adtsObjectType = 2;
      config = new Array(2);
      adtsExtensionSampleingIndex = adtsSampleingIndex;
    } else {
      /*  for other browsers (Chrome/Vivaldi/Opera ...)
          always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
      */
      adtsObjectType = 5;
      config = new Array(4);
      // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
      if (audioCodec && (audioCodec.indexOf('mp4a.40.29') !== -1 || audioCodec.indexOf('mp4a.40.5') !== -1) || !audioCodec && adtsSampleingIndex >= 6) {
        // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
        // there is a factor 2 between frame sample rate and output sample rate
        // multiply frequency by 2 (see table below, equivalent to substract 3)
        adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
      } else {
        // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
        // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
        if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && (adtsSampleingIndex >= 6 && adtsChanelConfig === 1 || /vivaldi/i.test(userAgent)) || !audioCodec && adtsChanelConfig === 1) {
          adtsObjectType = 2;
          config = new Array(2);
        }
        adtsExtensionSampleingIndex = adtsSampleingIndex;
      }
    }
    /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
        ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
      Audio Profile / Audio Object Type
      0: Null
      1: AAC Main
      2: AAC LC (Low Complexity)
      3: AAC SSR (Scalable Sample Rate)
      4: AAC LTP (Long Term Prediction)
      5: SBR (Spectral Band Replication)
      6: AAC Scalable
     sampling freq
      0: 96000 Hz
      1: 88200 Hz
      2: 64000 Hz
      3: 48000 Hz
      4: 44100 Hz
      5: 32000 Hz
      6: 24000 Hz
      7: 22050 Hz
      8: 16000 Hz
      9: 12000 Hz
      10: 11025 Hz
      11: 8000 Hz
      12: 7350 Hz
      13: Reserved
      14: Reserved
      15: frequency is written explictly
      Channel Configurations
      These are the channel configurations:
      0: Defined in AOT Specifc Config
      1: 1 channel: front-center
      2: 2 channels: front-left, front-right
    */
    // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
    config[0] = adtsObjectType << 3;
    // samplingFrequencyIndex
    config[0] |= (adtsSampleingIndex & 0x0E) >> 1;
    config[1] |= (adtsSampleingIndex & 0x01) << 7;
    // channelConfiguration
    config[1] |= adtsChanelConfig << 3;
    if (adtsObjectType === 5) {
      // adtsExtensionSampleingIndex
      config[1] |= (adtsExtensionSampleingIndex & 0x0E) >> 1;
      config[2] = (adtsExtensionSampleingIndex & 0x01) << 7;
      // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
      //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
      config[2] |= 2 << 2;
      config[3] = 0;
    }
    return { config: config, samplerate: adtsSampleingRates[adtsSampleingIndex], channelCount: adtsChanelConfig, codec: 'mp4a.40.' + adtsObjectType, manifestCodec: manifestCodec };
  },

  isHeaderPattern: function isHeaderPattern(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
  },

  getHeaderLength: function getHeaderLength(data, offset) {
    return !!(data[offset + 1] & 0x01) ? 7 : 9;
  },

  getFullFrameLength: function getFullFrameLength(data, offset) {
    return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xE0) >>> 5;
  },

  isHeader: function isHeader(data, offset) {
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
      return true;
    }
    return false;
  },

  probe: function probe(data, offset) {
    // same as isHeader but we also check that ADTS frame follows last ADTS frame
    // or end of data is reached
    if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
      // ADTS header Length
      var headerLength = this.getHeaderLength(data, offset);
      // ADTS frame Length
      var frameLength = headerLength;
      if (offset + 5 < data.length) {
        frameLength = this.getFullFrameLength(data, offset);
      }
      var newOffset = offset + frameLength;
      if (newOffset === data.length || newOffset + 1 < data.length && this.isHeaderPattern(data, newOffset)) {
        return true;
      }
    }
    return false;
  },

  initTrackConfig: function initTrackConfig(track, observer, data, offset, audioCodec) {
    if (!track.samplerate) {
      var config = this.getAudioConfig(observer, data, offset, audioCodec);
      track.config = config.config;
      track.samplerate = config.samplerate;
      track.channelCount = config.channelCount;
      track.codec = config.codec;
      track.manifestCodec = config.manifestCodec;
      _logger.logger.log('parsed codec:' + track.codec + ',rate:' + config.samplerate + ',nb channel:' + config.channelCount);
    }
  },

  getFrameDuration: function getFrameDuration(samplerate) {
    return 1024 * 90000 / samplerate;
  },

  appendFrame: function appendFrame(track, data, offset, pts, frameIndex) {
    var frameDuration = this.getFrameDuration(track.samplerate);
    var header = this.parseFrameHeader(data, offset, pts, frameIndex, frameDuration);
    if (header) {
      var stamp = header.stamp;
      var headerLength = header.headerLength;
      var frameLength = header.frameLength;

      //logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
      var aacSample = { unit: data.subarray(offset + headerLength, offset + headerLength + frameLength), pts: stamp, dts: stamp };

      track.samples.push(aacSample);
      track.len += frameLength;

      return { sample: aacSample, length: frameLength + headerLength };
    }

    return undefined;
  },

  parseFrameHeader: function parseFrameHeader(data, offset, pts, frameIndex, frameDuration) {
    var headerLength, frameLength, stamp;
    var length = data.length;

    // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
    headerLength = this.getHeaderLength(data, offset);
    // retrieve frame size
    frameLength = this.getFullFrameLength(data, offset);
    frameLength -= headerLength;

    if (frameLength > 0 && offset + headerLength + frameLength <= length) {
      stamp = pts + frameIndex * frameDuration;
      //logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
      return { headerLength: headerLength, frameLength: frameLength, stamp: stamp };
    }

    return undefined;
  }
};

module.exports = ADTS;

},{"33":33,"54":54}],23:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*  inline demuxer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *   probe fragments and instantiate appropriate demuxer depending on content type (TSDemuxer, AACDemuxer, ...)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _errors = _dereq_(33);

var _decrypter = _dereq_(19);

var _decrypter2 = _interopRequireDefault(_decrypter);

var _aacdemuxer = _dereq_(21);

var _aacdemuxer2 = _interopRequireDefault(_aacdemuxer);

var _mp4demuxer = _dereq_(29);

var _mp4demuxer2 = _interopRequireDefault(_mp4demuxer);

var _tsdemuxer = _dereq_(32);

var _tsdemuxer2 = _interopRequireDefault(_tsdemuxer);

var _mp3demuxer = _dereq_(28);

var _mp3demuxer2 = _interopRequireDefault(_mp3demuxer);

var _mp4Remuxer = _dereq_(45);

var _mp4Remuxer2 = _interopRequireDefault(_mp4Remuxer);

var _passthroughRemuxer = _dereq_(46);

var _passthroughRemuxer2 = _interopRequireDefault(_passthroughRemuxer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DemuxerInline = function () {
  function DemuxerInline(observer, typeSupported, config, vendor) {
    _classCallCheck(this, DemuxerInline);

    this.observer = observer;
    this.typeSupported = typeSupported;
    this.config = config;
    this.vendor = vendor;
  }

  _createClass(DemuxerInline, [{
    key: 'destroy',
    value: function destroy() {
      var demuxer = this.demuxer;
      if (demuxer) {
        demuxer.destroy();
      }
    }
  }, {
    key: 'push',
    value: function push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
      if (data.byteLength > 0 && decryptdata != null && decryptdata.key != null && decryptdata.method === 'AES-128') {
        var decrypter = this.decrypter;
        if (decrypter == null) {
          decrypter = this.decrypter = new _decrypter2.default(this.observer, this.config);
        }
        var localthis = this;
        // performance.now() not available on WebWorker, at least on Safari Desktop
        var startTime;
        try {
          startTime = performance.now();
        } catch (error) {
          startTime = Date.now();
        }
        decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function (decryptedData) {
          var endTime;
          try {
            endTime = performance.now();
          } catch (error) {
            endTime = Date.now();
          }
          localthis.observer.trigger(_events2.default.FRAG_DECRYPTED, { stats: { tstart: startTime, tdecrypt: endTime } });
          localthis.pushDecrypted(new Uint8Array(decryptedData), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
        });
      } else {
        this.pushDecrypted(new Uint8Array(data), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
      }
    }
  }, {
    key: 'pushDecrypted',
    value: function pushDecrypted(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
      var demuxer = this.demuxer;
      if (!demuxer ||
      // in case of continuity change, we might switch from content type (AAC container to TS container for example)
      // so let's check that current demuxer is still valid
      discontinuity && !this.probe(data)) {
        var observer = this.observer;
        var typeSupported = this.typeSupported;
        var config = this.config;
        // probing order is AAC/MP3/TS/MP4
        var muxConfig = [{ demux: _aacdemuxer2.default, remux: _mp4Remuxer2.default }, { demux: _mp3demuxer2.default, remux: _mp4Remuxer2.default }, { demux: _tsdemuxer2.default, remux: _mp4Remuxer2.default }, { demux: _mp4demuxer2.default, remux: _passthroughRemuxer2.default }];

        // probe for content type
        for (var i = 0, len = muxConfig.length; i < len; i++) {
          var mux = muxConfig[i];
          var probe = mux.demux.probe;
          if (probe(data)) {
            var _remuxer = this.remuxer = new mux.remux(observer, config, typeSupported, this.vendor);
            demuxer = new mux.demux(observer, _remuxer, config, typeSupported);
            this.probe = probe;
            break;
          }
        }
        if (!demuxer) {
          observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_PARSING_ERROR, fatal: true, reason: 'no demux matching with content found' });
          return;
        }
        this.demuxer = demuxer;
      }
      var remuxer = this.remuxer;

      if (discontinuity || trackSwitch) {
        demuxer.resetInitSegment(initSegment, audioCodec, videoCodec, duration);
        remuxer.resetInitSegment();
      }
      if (discontinuity) {
        demuxer.resetTimeStamp(defaultInitPTS);
        remuxer.resetTimeStamp(defaultInitPTS);
      }
      if (typeof demuxer.setDecryptData === 'function') {
        demuxer.setDecryptData(decryptdata);
      }
      demuxer.append(data, timeOffset, contiguous, accurateTimeOffset);
    }
  }]);

  return DemuxerInline;
}();

exports.default = DemuxerInline;

},{"19":19,"21":21,"28":28,"29":29,"32":32,"33":33,"35":35,"45":45,"46":46}],24:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _demuxerInline = _dereq_(23);

var _demuxerInline2 = _interopRequireDefault(_demuxerInline);

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _logger = _dereq_(54);

var _events3 = _dereq_(1);

var _events4 = _interopRequireDefault(_events3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* demuxer web worker.
 *  - listen to worker message, and trigger DemuxerInline upon reception of Fragments.
 *  - provides MP4 Boxes back to main thread using [transferable objects](https://developers.google.com/web/updates/2011/12/Transferable-Objects-Lightning-Fast) in order to minimize message passing overhead.
 */

var DemuxerWorker = function DemuxerWorker(self) {
  // observer setup
  var observer = new _events4.default();
  observer.trigger = function trigger(event) {
    for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }

    observer.emit.apply(observer, [event, event].concat(data));
  };

  observer.off = function off(event) {
    for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      data[_key2 - 1] = arguments[_key2];
    }

    observer.removeListener.apply(observer, [event].concat(data));
  };

  var forwardMessage = function forwardMessage(ev, data) {
    self.postMessage({ event: ev, data: data });
  };

  self.addEventListener('message', function (ev) {
    var data = ev.data;
    //console.log('demuxer cmd:' + data.cmd);
    switch (data.cmd) {
      case 'init':
        var config = JSON.parse(data.config);
        self.demuxer = new _demuxerInline2.default(observer, data.typeSupported, config, data.vendor);
        try {
          (0, _logger.enableLogs)(config.debug === true);
        } catch (err) {
          console.warn('demuxerWorker: unable to enable logs');
        }
        // signal end of worker init
        forwardMessage('init', null);
        break;
      case 'demux':
        self.demuxer.push(data.data, data.decryptdata, data.initSegment, data.audioCodec, data.videoCodec, data.timeOffset, data.discontinuity, data.trackSwitch, data.contiguous, data.duration, data.accurateTimeOffset, data.defaultInitPTS);
        break;
      default:
        break;
    }
  });

  // forward events to main thread
  observer.on(_events2.default.FRAG_DECRYPTED, forwardMessage);
  observer.on(_events2.default.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
  observer.on(_events2.default.FRAG_PARSED, forwardMessage);
  observer.on(_events2.default.ERROR, forwardMessage);
  observer.on(_events2.default.FRAG_PARSING_METADATA, forwardMessage);
  observer.on(_events2.default.FRAG_PARSING_USERDATA, forwardMessage);
  observer.on(_events2.default.INIT_PTS_FOUND, forwardMessage);

  // special case for FRAG_PARSING_DATA: pass data1/data2 as transferable object (no copy)
  observer.on(_events2.default.FRAG_PARSING_DATA, function (ev, data) {
    var transferable = [];
    var message = { event: ev, data: data };
    if (data.data1) {
      message.data1 = data.data1.buffer;
      transferable.push(data.data1.buffer);
      delete data.data1;
    }
    if (data.data2) {
      message.data2 = data.data2.buffer;
      transferable.push(data.data2.buffer);
      delete data.data2;
    }
    self.postMessage(message, transferable);
  });
};

exports.default = DemuxerWorker;

},{"1":1,"23":23,"35":35,"54":54}],25:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _demuxerInline = _dereq_(23);

var _demuxerInline2 = _interopRequireDefault(_demuxerInline);

var _demuxerWorker = _dereq_(24);

var _demuxerWorker2 = _interopRequireDefault(_demuxerWorker);

var _logger = _dereq_(54);

var _errors = _dereq_(33);

var _events3 = _dereq_(1);

var _events4 = _interopRequireDefault(_events3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Demuxer = function () {
  function Demuxer(hls, id) {
    _classCallCheck(this, Demuxer);

    this.hls = hls;
    this.id = id;
    // observer setup
    var observer = this.observer = new _events4.default();
    var config = hls.config;
    observer.trigger = function trigger(event) {
      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        data[_key - 1] = arguments[_key];
      }

      observer.emit.apply(observer, [event, event].concat(data));
    };

    observer.off = function off(event) {
      for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        data[_key2 - 1] = arguments[_key2];
      }

      observer.removeListener.apply(observer, [event].concat(data));
    };

    var forwardMessage = function (ev, data) {
      data = data || {};
      data.frag = this.frag;
      data.id = this.id;
      hls.trigger(ev, data);
    }.bind(this);

    // forward events to main thread
    observer.on(_events2.default.FRAG_DECRYPTED, forwardMessage);
    observer.on(_events2.default.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
    observer.on(_events2.default.FRAG_PARSING_DATA, forwardMessage);
    observer.on(_events2.default.FRAG_PARSED, forwardMessage);
    observer.on(_events2.default.ERROR, forwardMessage);
    observer.on(_events2.default.FRAG_PARSING_METADATA, forwardMessage);
    observer.on(_events2.default.FRAG_PARSING_USERDATA, forwardMessage);
    observer.on(_events2.default.INIT_PTS_FOUND, forwardMessage);

    var typeSupported = {
      mp4: MediaSource.isTypeSupported('video/mp4'),
      mpeg: MediaSource.isTypeSupported('audio/mpeg'),
      mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"')
    };
    // navigator.vendor is not always available in Web Worker
    // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
    var vendor = navigator.vendor;
    if (config.enableWorker && typeof Worker !== 'undefined') {
      _logger.logger.log('demuxing in webworker');
      var w = void 0;
      try {
        var work = _dereq_(3);
        w = this.w = work(_demuxerWorker2.default);
        this.onwmsg = this.onWorkerMessage.bind(this);
        w.addEventListener('message', this.onwmsg);
        w.onerror = function (event) {
          hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.OTHER_ERROR, details: _errors.ErrorDetails.INTERNAL_EXCEPTION, fatal: true, event: 'demuxerWorker', err: { message: event.message + ' (' + event.filename + ':' + event.lineno + ')' } });
        };
        w.postMessage({ cmd: 'init', typeSupported: typeSupported, vendor: vendor, id: id, config: JSON.stringify(config) });
      } catch (err) {
        _logger.logger.error('error while initializing DemuxerWorker, fallback on DemuxerInline');
        if (w) {
          // revoke the Object URL that was used to create demuxer worker, so as not to leak it
          URL.revokeObjectURL(w.objectURL);
        }
        this.demuxer = new _demuxerInline2.default(observer, typeSupported, config, vendor);
        this.w = undefined;
      }
    } else {
      this.demuxer = new _demuxerInline2.default(observer, typeSupported, config, vendor);
    }
  }

  _createClass(Demuxer, [{
    key: 'destroy',
    value: function destroy() {
      var w = this.w;
      if (w) {
        w.removeEventListener('message', this.onwmsg);
        w.terminate();
        this.w = null;
      } else {
        var demuxer = this.demuxer;
        if (demuxer) {
          demuxer.destroy();
          this.demuxer = null;
        }
      }
      var observer = this.observer;
      if (observer) {
        observer.removeAllListeners();
        this.observer = null;
      }
    }
  }, {
    key: 'push',
    value: function push(data, initSegment, audioCodec, videoCodec, frag, duration, accurateTimeOffset, defaultInitPTS) {
      var w = this.w;
      var timeOffset = !isNaN(frag.startDTS) ? frag.startDTS : frag.start;
      var decryptdata = frag.decryptdata;
      var lastFrag = this.frag;
      var discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
      var trackSwitch = !(lastFrag && frag.level === lastFrag.level);
      var nextSN = lastFrag && frag.sn === lastFrag.sn + 1;
      var contiguous = !trackSwitch && nextSN;
      if (discontinuity) {
        _logger.logger.log(this.id + ':discontinuity detected');
      }
      if (trackSwitch) {
        _logger.logger.log(this.id + ':switch detected');
      }
      this.frag = frag;
      if (w) {
        // post fragment payload as transferable objects (no copy)
        w.postMessage({ cmd: 'demux', data: data, decryptdata: decryptdata, initSegment: initSegment, audioCodec: audioCodec, videoCodec: videoCodec, timeOffset: timeOffset, discontinuity: discontinuity, trackSwitch: trackSwitch, contiguous: contiguous, duration: duration, accurateTimeOffset: accurateTimeOffset, defaultInitPTS: defaultInitPTS }, [data]);
      } else {
        var demuxer = this.demuxer;
        if (demuxer) {
          demuxer.push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
        }
      }
    }
  }, {
    key: 'onWorkerMessage',
    value: function onWorkerMessage(ev) {
      var data = ev.data,
          hls = this.hls;
      //console.log('onWorkerMessage:' + data.event);
      switch (data.event) {
        case 'init':
          // revoke the Object URL that was used to create demuxer worker, so as not to leak it
          URL.revokeObjectURL(this.w.objectURL);
          break;
        // special case for FRAG_PARSING_DATA: data1 and data2 are transferable objects
        case _events2.default.FRAG_PARSING_DATA:
          data.data.data1 = new Uint8Array(data.data1);
          if (data.data2) {
            data.data.data2 = new Uint8Array(data.data2);
          }
        /* falls through */
        default:
          data.data = data.data || {};
          data.data.frag = this.frag;
          data.data.id = this.id;
          hls.trigger(data.event, data.data);
          break;
      }
    }
  }]);

  return Demuxer;
}();

exports.default = Demuxer;

},{"1":1,"23":23,"24":24,"3":3,"33":33,"35":35,"54":54}],26:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _logger = _dereq_(54);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpGolomb = function () {
  function ExpGolomb(data) {
    _classCallCheck(this, ExpGolomb);

    this.data = data;
    // the number of bytes left to examine in this.data
    this.bytesAvailable = data.byteLength;
    // the current word being examined
    this.word = 0; // :uint
    // the number of bits left to examine in the current word
    this.bitsAvailable = 0; // :uint
  }

  // ():void


  _createClass(ExpGolomb, [{
    key: 'loadWord',
    value: function loadWord() {
      var data = this.data,
          bytesAvailable = this.bytesAvailable,
          position = data.byteLength - bytesAvailable,
          workingBytes = new Uint8Array(4),
          availableBytes = Math.min(4, bytesAvailable);
      if (availableBytes === 0) {
        throw new Error('no bytes available');
      }
      workingBytes.set(data.subarray(position, position + availableBytes));
      this.word = new DataView(workingBytes.buffer).getUint32(0);
      // track the amount of this.data that has been processed
      this.bitsAvailable = availableBytes * 8;
      this.bytesAvailable -= availableBytes;
    }

    // (count:int):void

  }, {
    key: 'skipBits',
    value: function skipBits(count) {
      var skipBytes; // :int
      if (this.bitsAvailable > count) {
        this.word <<= count;
        this.bitsAvailable -= count;
      } else {
        count -= this.bitsAvailable;
        skipBytes = count >> 3;
        count -= skipBytes >> 3;
        this.bytesAvailable -= skipBytes;
        this.loadWord();
        this.word <<= count;
        this.bitsAvailable -= count;
      }
    }

    // (size:int):uint

  }, {
    key: 'readBits',
    value: function readBits(size) {
      var bits = Math.min(this.bitsAvailable, size),
          // :uint
      valu = this.word >>> 32 - bits; // :uint
      if (size > 32) {
        _logger.logger.error('Cannot read more than 32 bits at a time');
      }
      this.bitsAvailable -= bits;
      if (this.bitsAvailable > 0) {
        this.word <<= bits;
      } else if (this.bytesAvailable > 0) {
        this.loadWord();
      }
      bits = size - bits;
      if (bits > 0 && this.bitsAvailable) {
        return valu << bits | this.readBits(bits);
      } else {
        return valu;
      }
    }

    // ():uint

  }, {
    key: 'skipLZ',
    value: function skipLZ() {
      var leadingZeroCount; // :uint
      for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) {
        if (0 !== (this.word & 0x80000000 >>> leadingZeroCount)) {
          // the first bit of working word is 1
          this.word <<= leadingZeroCount;
          this.bitsAvailable -= leadingZeroCount;
          return leadingZeroCount;
        }
      }
      // we exhausted word and still have not found a 1
      this.loadWord();
      return leadingZeroCount + this.skipLZ();
    }

    // ():void

  }, {
    key: 'skipUEG',
    value: function skipUEG() {
      this.skipBits(1 + this.skipLZ());
    }

    // ():void

  }, {
    key: 'skipEG',
    value: function skipEG() {
      this.skipBits(1 + this.skipLZ());
    }

    // ():uint

  }, {
    key: 'readUEG',
    value: function readUEG() {
      var clz = this.skipLZ(); // :uint
      return this.readBits(clz + 1) - 1;
    }

    // ():int

  }, {
    key: 'readEG',
    value: function readEG() {
      var valu = this.readUEG(); // :int
      if (0x01 & valu) {
        // the number is odd if the low order bit is set
        return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
      } else {
        return -1 * (valu >>> 1); // divide by two then make it negative
      }
    }

    // Some convenience functions
    // :Boolean

  }, {
    key: 'readBoolean',
    value: function readBoolean() {
      return 1 === this.readBits(1);
    }

    // ():int

  }, {
    key: 'readUByte',
    value: function readUByte() {
      return this.readBits(8);
    }

    // ():int

  }, {
    key: 'readUShort',
    value: function readUShort() {
      return this.readBits(16);
    }
    // ():int

  }, {
    key: 'readUInt',
    value: function readUInt() {
      return this.readBits(32);
    }

    /**
     * Advance the ExpGolomb decoder past a scaling list. The scaling
     * list is optionally transmitted as part of a sequence parameter
     * set and is not relevant to transmuxing.
     * @param count {number} the number of entries in this scaling list
     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
     */

  }, {
    key: 'skipScalingList',
    value: function skipScalingList(count) {
      var lastScale = 8,
          nextScale = 8,
          j,
          deltaScale;
      for (j = 0; j < count; j++) {
        if (nextScale !== 0) {
          deltaScale = this.readEG();
          nextScale = (lastScale + deltaScale + 256) % 256;
        }
        lastScale = nextScale === 0 ? lastScale : nextScale;
      }
    }

    /**
     * Read a sequence parameter set and return some interesting video
     * properties. A sequence parameter set is the H264 metadata that
     * describes the properties of upcoming video frames.
     * @param data {Uint8Array} the bytes of a sequence parameter set
     * @return {object} an object with configuration parsed from the
     * sequence parameter set, including the dimensions of the
     * associated video frames.
     */

  }, {
    key: 'readSPS',
    value: function readSPS() {
      var frameCropLeftOffset = 0,
          frameCropRightOffset = 0,
          frameCropTopOffset = 0,
          frameCropBottomOffset = 0,
          profileIdc,
          profileCompat,
          levelIdc,
          numRefFramesInPicOrderCntCycle,
          picWidthInMbsMinus1,
          picHeightInMapUnitsMinus1,
          frameMbsOnlyFlag,
          scalingListCount,
          i,
          readUByte = this.readUByte.bind(this),
          readBits = this.readBits.bind(this),
          readUEG = this.readUEG.bind(this),
          readBoolean = this.readBoolean.bind(this),
          skipBits = this.skipBits.bind(this),
          skipEG = this.skipEG.bind(this),
          skipUEG = this.skipUEG.bind(this),
          skipScalingList = this.skipScalingList.bind(this);

      readUByte();
      profileIdc = readUByte(); // profile_idc
      profileCompat = readBits(5); // constraint_set[0-4]_flag, u(5)
      skipBits(3); // reserved_zero_3bits u(3),
      levelIdc = readUByte(); //level_idc u(8)
      skipUEG(); // seq_parameter_set_id
      // some profiles have more optional data we don't need
      if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
        var chromaFormatIdc = readUEG();
        if (chromaFormatIdc === 3) {
          skipBits(1); // separate_colour_plane_flag
        }
        skipUEG(); // bit_depth_luma_minus8
        skipUEG(); // bit_depth_chroma_minus8
        skipBits(1); // qpprime_y_zero_transform_bypass_flag
        if (readBoolean()) {
          // seq_scaling_matrix_present_flag
          scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
          for (i = 0; i < scalingListCount; i++) {
            if (readBoolean()) {
              // seq_scaling_list_present_flag[ i ]
              if (i < 6) {
                skipScalingList(16);
              } else {
                skipScalingList(64);
              }
            }
          }
        }
      }
      skipUEG(); // log2_max_frame_num_minus4
      var picOrderCntType = readUEG();
      if (picOrderCntType === 0) {
        readUEG(); //log2_max_pic_order_cnt_lsb_minus4
      } else if (picOrderCntType === 1) {
        skipBits(1); // delta_pic_order_always_zero_flag
        skipEG(); // offset_for_non_ref_pic
        skipEG(); // offset_for_top_to_bottom_field
        numRefFramesInPicOrderCntCycle = readUEG();
        for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
          skipEG(); // offset_for_ref_frame[ i ]
        }
      }
      skipUEG(); // max_num_ref_frames
      skipBits(1); // gaps_in_frame_num_value_allowed_flag
      picWidthInMbsMinus1 = readUEG();
      picHeightInMapUnitsMinus1 = readUEG();
      frameMbsOnlyFlag = readBits(1);
      if (frameMbsOnlyFlag === 0) {
        skipBits(1); // mb_adaptive_frame_field_flag
      }
      skipBits(1); // direct_8x8_inference_flag
      if (readBoolean()) {
        // frame_cropping_flag
        frameCropLeftOffset = readUEG();
        frameCropRightOffset = readUEG();
        frameCropTopOffset = readUEG();
        frameCropBottomOffset = readUEG();
      }
      var pixelRatio = [1, 1];
      if (readBoolean()) {
        // vui_parameters_present_flag
        if (readBoolean()) {
          // aspect_ratio_info_present_flag
          var aspectRatioIdc = readUByte();
          switch (aspectRatioIdc) {
            case 1:
              pixelRatio = [1, 1];break;
            case 2:
              pixelRatio = [12, 11];break;
            case 3:
              pixelRatio = [10, 11];break;
            case 4:
              pixelRatio = [16, 11];break;
            case 5:
              pixelRatio = [40, 33];break;
            case 6:
              pixelRatio = [24, 11];break;
            case 7:
              pixelRatio = [20, 11];break;
            case 8:
              pixelRatio = [32, 11];break;
            case 9:
              pixelRatio = [80, 33];break;
            case 10:
              pixelRatio = [18, 11];break;
            case 11:
              pixelRatio = [15, 11];break;
            case 12:
              pixelRatio = [64, 33];break;
            case 13:
              pixelRatio = [160, 99];break;
            case 14:
              pixelRatio = [4, 3];break;
            case 15:
              pixelRatio = [3, 2];break;
            case 16:
              pixelRatio = [2, 1];break;
            case 255:
              {
                pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
                break;
              }
          }
        }
      }
      return {
        width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
        height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
        pixelRatio: pixelRatio
      };
    }
  }, {
    key: 'readSliceType',
    value: function readSliceType() {
      // skip NALu type
      this.readUByte();
      // discard first_mb_in_slice
      this.readUEG();
      // return slice_type
      return this.readUEG();
    }
  }]);

  return ExpGolomb;
}();

exports.default = ExpGolomb;

},{"54":54}],27:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * ID3 parser
 */
var ID3 = function () {
  function ID3() {
    _classCallCheck(this, ID3);
  }

  _createClass(ID3, null, [{
    key: 'isHeader',

    /**
     * Returns true if an ID3 header can be found at offset in data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {boolean} - True if an ID3 header is found
     */
    value: function isHeader(data, offset) {
      /*
      * http://id3.org/id3v2.3.0
      * [0]     = 'I'
      * [1]     = 'D'
      * [2]     = '3'
      * [3,4]   = {Version}
      * [5]     = {Flags}
      * [6-9]   = {ID3 Size}
      *
      * An ID3v2 tag can be detected with the following pattern:
      *  $49 44 33 yy yy xx zz zz zz zz
      * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
      */
      if (offset + 10 <= data.length) {
        //look for 'ID3' identifier
        if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) {
          //check version is within range
          if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
            //check size is within range
            if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
              return true;
            }
          }
        }
      }

      return false;
    }

    /**
     * Returns true if an ID3 footer can be found at offset in data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {boolean} - True if an ID3 footer is found
     */

  }, {
    key: 'isFooter',
    value: function isFooter(data, offset) {
      /*
      * The footer is a copy of the header, but with a different identifier
      */
      if (offset + 10 <= data.length) {
        //look for '3DI' identifier
        if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) {
          //check version is within range
          if (data[offset + 3] < 0xFF && data[offset + 4] < 0xFF) {
            //check size is within range
            if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) {
              return true;
            }
          }
        }
      }

      return false;
    }

    /**
     * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
     * @param {Uint8Array} data - The data to search in
     * @param {number} offset - The offset at which to start searching
     * @return {Uint8Array} - The block of data containing any ID3 tags found
     */

  }, {
    key: 'getID3Data',
    value: function getID3Data(data, offset) {
      var front = offset;
      var length = 0;

      while (ID3.isHeader(data, offset)) {
        //ID3 header is 10 bytes
        length += 10;

        var size = ID3._readSize(data, offset + 6);
        length += size;

        if (ID3.isFooter(data, offset + 10)) {
          //ID3 footer is 10 bytes
          length += 10;
        }

        offset += length;
      }

      if (length > 0) {
        return data.subarray(front, front + length);
      }

      return undefined;
    }
  }, {
    key: '_readSize',
    value: function _readSize(data, offset) {
      var size = 0;
      size = (data[offset] & 0x7f) << 21;
      size |= (data[offset + 1] & 0x7f) << 14;
      size |= (data[offset + 2] & 0x7f) << 7;
      size |= data[offset + 3] & 0x7f;
      return size;
    }

    /**
     * Searches for the Elementary Stream timestamp found in the ID3 data chunk
     * @param {Uint8Array} data - Block of data containing one or more ID3 tags
     * @return {number} - The timestamp
     */

  }, {
    key: 'getTimeStamp',
    value: function getTimeStamp(data) {
      var frames = ID3.getID3Frames(data);
      for (var i = 0; i < frames.length; i++) {
        var frame = frames[i];
        if (ID3.isTimeStampFrame(frame)) {
          return ID3._readTimeStamp(frame);
        }
      }

      return undefined;
    }

    /**
     * Returns true if the ID3 frame is an Elementary Stream timestamp frame
     * @param {ID3 frame} frame
     */

  }, {
    key: 'isTimeStampFrame',
    value: function isTimeStampFrame(frame) {
      return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
    }
  }, {
    key: '_getFrameData',
    value: function _getFrameData(data) {
      /*
      Frame ID       $xx xx xx xx (four characters)
      Size           $xx xx xx xx
      Flags          $xx xx
      */
      var type = String.fromCharCode(data[0], data[1], data[2], data[3]);
      var size = ID3._readSize(data, 4);

      //skip frame id, size, and flags
      var offset = 10;

      return { type: type, size: size, data: data.subarray(offset, offset + size) };
    }

    /**
     * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
     * @param {Uint8Array} id3Data - The ID3 data containing one or more ID3 tags
     * @return {ID3 frame[]} - Array of ID3 frame objects
     */

  }, {
    key: 'getID3Frames',
    value: function getID3Frames(id3Data) {
      var offset = 0;
      var frames = [];

      while (ID3.isHeader(id3Data, offset)) {
        var size = ID3._readSize(id3Data, offset + 6);
        //skip past ID3 header
        offset += 10;
        var end = offset + size;
        //loop through frames in the ID3 tag
        while (offset + 8 < end) {
          var frameData = ID3._getFrameData(id3Data.subarray(offset));
          var frame = ID3._decodeFrame(frameData);
          if (frame) {
            frames.push(frame);
          }
          //skip frame header and frame data
          offset += frameData.size + 10;
        }

        if (ID3.isFooter(id3Data, offset)) {
          offset += 10;
        }
      }

      return frames;
    }
  }, {
    key: '_decodeFrame',
    value: function _decodeFrame(frame) {
      if (frame.type === 'PRIV') {
        return ID3._decodePrivFrame(frame);
      } else if (frame.type[0] === 'T') {
        return ID3._decodeTextFrame(frame);
      } else if (frame.type[0] === 'W') {
        return ID3._decodeURLFrame(frame);
      }

      return undefined;
    }
  }, {
    key: '_readTimeStamp',
    value: function _readTimeStamp(timeStampFrame) {
      if (timeStampFrame.data.byteLength === 8) {
        var data = new Uint8Array(timeStampFrame.data);
        // timestamp is 33 bit expressed as a big-endian eight-octet number,
        // with the upper 31 bits set to zero.
        var pts33Bit = data[3] & 0x1;
        var timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
        timestamp /= 45;

        if (pts33Bit) {
          timestamp += 47721858.84; // 2^32 / 90
        }

        return Math.round(timestamp);
      }

      return undefined;
    }
  }, {
    key: '_decodePrivFrame',
    value: function _decodePrivFrame(frame) {
      /*
      Format: <text string>\0<binary data>
      */
      if (frame.size < 2) {
        return undefined;
      }

      var owner = ID3._utf8ArrayToStr(frame.data);
      var privateData = new Uint8Array(frame.data.subarray(owner.length + 1));

      return { key: frame.type, info: owner, data: privateData.buffer };
    }
  }, {
    key: '_decodeTextFrame',
    value: function _decodeTextFrame(frame) {
      if (frame.size < 2) {
        return undefined;
      }

      if (frame.type === 'TXXX') {
        /*
        Format:
        [0]   = {Text Encoding}
        [1-?] = {Description}\0{Value}
        */
        var index = 1;
        var description = ID3._utf8ArrayToStr(frame.data.subarray(index));

        index += description.length + 1;
        var value = ID3._utf8ArrayToStr(frame.data.subarray(index));

        return { key: frame.type, info: description, data: value };
      } else {
        /*
        Format:
        [0]   = {Text Encoding}
        [1-?] = {Value}
        */
        var text = ID3._utf8ArrayToStr(frame.data.subarray(1));
        return { key: frame.type, data: text };
      }
    }
  }, {
    key: '_decodeURLFrame',
    value: function _decodeURLFrame(frame) {
      if (frame.type === 'WXXX') {
        /*
        Format:
        [0]   = {Text Encoding}
        [1-?] = {Description}\0{URL}
        */
        if (frame.size < 2) {
          return undefined;
        }

        var index = 1;
        var description = ID3._utf8ArrayToStr(frame.data.subarray(index));

        index += description.length + 1;
        var value = ID3._utf8ArrayToStr(frame.data.subarray(index));

        return { key: frame.type, info: description, data: value };
      } else {
        /*
        Format:
        [0-?] = {URL}
        */
        var url = ID3._utf8ArrayToStr(frame.data);
        return { key: frame.type, data: url };
      }
    }

    // http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
    // http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
    /* utf.js - UTF-8 <=> UTF-16 convertion
     *
     * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
     * Version: 1.0
     * LastModified: Dec 25 1999
     * This library is free.  You can redistribute it and/or modify it.
     */

  }, {
    key: '_utf8ArrayToStr',
    value: function _utf8ArrayToStr(array) {

      var char2 = void 0;
      var char3 = void 0;
      var out = '';
      var i = 0;
      var length = array.length;

      while (i < length) {
        var c = array[i++];
        switch (c >> 4) {
          case 0:
            return out;
          case 1:case 2:case 3:case 4:case 5:case 6:case 7:
            // 0xxxxxxx
            out += String.fromCharCode(c);
            break;
          case 12:case 13:
            // 110x xxxx   10xx xxxx
            char2 = array[i++];
            out += String.fromCharCode((c & 0x1F) << 6 | char2 & 0x3F);
            break;
          case 14:
            // 1110 xxxx  10xx xxxx  10xx xxxx
            char2 = array[i++];
            char3 = array[i++];
            out += String.fromCharCode((c & 0x0F) << 12 | (char2 & 0x3F) << 6 | (char3 & 0x3F) << 0);
            break;
        }
      }

      return out;
    }
  }]);

  return ID3;
}();

exports.default = ID3;

},{}],28:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * MP3 demuxer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _id = _dereq_(27);

var _id2 = _interopRequireDefault(_id);

var _logger = _dereq_(54);

var _mpegaudio = _dereq_(30);

var _mpegaudio2 = _interopRequireDefault(_mpegaudio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MP3Demuxer = function () {
  function MP3Demuxer(observer, remuxer, config) {
    _classCallCheck(this, MP3Demuxer);

    this.observer = observer;
    this.config = config;
    this.remuxer = remuxer;
  }

  _createClass(MP3Demuxer, [{
    key: 'resetInitSegment',
    value: function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      this._audioTrack = { container: 'audio/mpeg', type: 'audio', id: -1, sequenceNumber: 0, isAAC: false, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
    }
  }, {
    key: 'resetTimeStamp',
    value: function resetTimeStamp() {}
  }, {
    key: 'append',


    // feed incoming data to the front of the parsing pipeline
    value: function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var id3Data = _id2.default.getID3Data(data, 0);
      var pts = 90 * _id2.default.getTimeStamp(id3Data);
      var offset = id3Data.length;
      var length = data.length;
      var frameIndex = 0,
          stamp = 0;
      var track = this._audioTrack;

      var id3Samples = [{ pts: pts, dts: pts, data: id3Data }];

      while (offset < length) {
        if (_mpegaudio2.default.isHeader(data, offset)) {
          var frame = _mpegaudio2.default.appendFrame(track, data, offset, pts, frameIndex);
          if (frame) {
            offset += frame.length;
            stamp = frame.sample.pts;
            frameIndex++;
          } else {
            //logger.log('Unable to parse Mpeg audio frame');
            break;
          }
        } else if (_id2.default.isHeader(data, offset)) {
          id3Data = _id2.default.getID3Data(data, offset);
          id3Samples.push({ pts: stamp, dts: stamp, data: id3Data });
          offset += id3Data.length;
        } else {
          //nothing found, keep looking
          offset++;
        }
      }

      this.remuxer.remux(track, { samples: [] }, { samples: id3Samples, inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
    }
  }, {
    key: 'destroy',
    value: function destroy() {}
  }], [{
    key: 'probe',
    value: function probe(data) {
      // check if data contains ID3 timestamp and MPEG sync word
      var offset, length;
      var id3Data = _id2.default.getID3Data(data, 0);
      if (id3Data && _id2.default.getTimeStamp(id3Data) !== undefined) {
        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
        // More info http://www.mp3-tech.org/programmer/frame_header.html
        for (offset = id3Data.length, length = Math.min(data.length - 1, offset + 100); offset < length; offset++) {
          if (_mpegaudio2.default.probe(data, offset)) {
            _logger.logger.log('MPEG Audio sync word found !');
            return true;
          }
        }
      }
      return false;
    }
  }]);

  return MP3Demuxer;
}();

exports.default = MP3Demuxer;

},{"27":27,"30":30,"54":54}],29:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * MP4 demuxer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
//import {logger} from '../utils/logger';


var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UINT32_MAX = Math.pow(2, 32) - 1;

var MP4Demuxer = function () {
  function MP4Demuxer(observer, remuxer) {
    _classCallCheck(this, MP4Demuxer);

    this.observer = observer;
    this.remuxer = remuxer;
  }

  _createClass(MP4Demuxer, [{
    key: 'resetTimeStamp',
    value: function resetTimeStamp(initPTS) {
      this.initPTS = initPTS;
    }
  }, {
    key: 'resetInitSegment',
    value: function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      //jshint unused:false
      if (initSegment && initSegment.byteLength) {
        var initData = this.initData = MP4Demuxer.parseInitSegment(initSegment);
        var tracks = {};
        if (initData.audio) {
          tracks.audio = { container: 'audio/mp4', codec: audioCodec, initSegment: duration ? initSegment : null };
        }
        if (initData.video) {
          tracks.video = { container: 'video/mp4', codec: videoCodec, initSegment: duration ? initSegment : null };
        }
        this.observer.trigger(_events2.default.FRAG_PARSING_INIT_SEGMENT, { tracks: tracks });
      } else {
        if (audioCodec) {
          this.audioCodec = audioCodec;
        }
        if (videoCodec) {
          this.videoCodec = videoCodec;
        }
      }
    }
  }, {
    key: 'append',


    // feed incoming data to the front of the parsing pipeline
    value: function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var initData = this.initData;
      if (!initData) {
        this.resetInitSegment(data, this.audioCodec, this.videoCodec);
        initData = this.initData;
      }
      var startDTS = void 0,
          initPTS = this.initPTS;
      if (initPTS === undefined) {
        var _startDTS = MP4Demuxer.getStartDTS(initData, data);
        this.initPTS = initPTS = _startDTS - timeOffset;
        this.observer.trigger(_events2.default.INIT_PTS_FOUND, { initPTS: initPTS });
      }
      MP4Demuxer.offsetStartDTS(initData, data, initPTS);
      startDTS = MP4Demuxer.getStartDTS(initData, data);
      this.remuxer.remux(initData.audio, initData.video, null, null, startDTS, contiguous, accurateTimeOffset, data);
    }
  }, {
    key: 'destroy',
    value: function destroy() {}
  }], [{
    key: 'probe',
    value: function probe(data) {
      if (data.length >= 8) {
        var dataType = MP4Demuxer.bin2str(data.subarray(4, 8));
        return ['moof', 'ftyp', 'styp'].indexOf(dataType) >= 0;
      }
      return false;
    }
  }, {
    key: 'bin2str',
    value: function bin2str(buffer) {
      return String.fromCharCode.apply(null, buffer);
    }
  }, {
    key: 'readUint32',
    value: function readUint32(buffer, offset) {
      if (buffer.data) {
        offset += buffer.start;
        buffer = buffer.data;
      }

      var val = buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
      return val < 0 ? 4294967296 + val : val;
    }
  }, {
    key: 'writeUint32',
    value: function writeUint32(buffer, offset, value) {
      if (buffer.data) {
        offset += buffer.start;
        buffer = buffer.data;
      }
      buffer[offset] = value >> 24;
      buffer[offset + 1] = value >> 16 & 0xff;
      buffer[offset + 2] = value >> 8 & 0xff;
      buffer[offset + 3] = value & 0xff;
    }

    // Find the data for a box specified by its path

  }, {
    key: 'findBox',
    value: function findBox(data, path) {
      var results = [],
          i,
          size,
          type,
          end,
          subresults,
          start,
          endbox;

      if (data.data) {
        start = data.start;
        end = data.end;
        data = data.data;
      } else {
        start = 0;
        end = data.byteLength;
      }

      if (!path.length) {
        // short-circuit the search for empty paths
        return null;
      }

      for (i = start; i < end;) {
        size = MP4Demuxer.readUint32(data, i);
        type = MP4Demuxer.bin2str(data.subarray(i + 4, i + 8));
        endbox = size > 1 ? i + size : end;

        if (type === path[0]) {

          if (path.length === 1) {
            // this is the end of the path and we've found the box we were
            // looking for
            results.push({ data: data, start: i + 8, end: endbox });
          } else {
            // recursively search for the next box along the path
            subresults = MP4Demuxer.findBox({ data: data, start: i + 8, end: endbox }, path.slice(1));
            if (subresults.length) {
              results = results.concat(subresults);
            }
          }
        }
        i = endbox;
      }

      // we've finished searching all of data
      return results;
    }

    /**
     * Parses an MP4 initialization segment and extracts stream type and
     * timescale values for any declared tracks. Timescale values indicate the
     * number of clock ticks per second to assume for time-based values
     * elsewhere in the MP4.
     *
     * To determine the start time of an MP4, you need two pieces of
     * information: the timescale unit and the earliest base media decode
     * time. Multiple timescales can be specified within an MP4 but the
     * base media decode time is always expressed in the timescale from
     * the media header box for the track:
     * ```
     * moov > trak > mdia > mdhd.timescale
     * moov > trak > mdia > hdlr
     * ```
     * @param init {Uint8Array} the bytes of the init segment
     * @return {object} a hash of track type to timescale values or null if
     * the init segment is malformed.
     */

  }, {
    key: 'parseInitSegment',
    value: function parseInitSegment(initSegment) {
      var result = [];
      var traks = MP4Demuxer.findBox(initSegment, ['moov', 'trak']);

      traks.forEach(function (trak) {
        var tkhd = MP4Demuxer.findBox(trak, ['tkhd'])[0];
        if (tkhd) {
          var version = tkhd.data[tkhd.start];
          var index = version === 0 ? 12 : 20;
          var trackId = MP4Demuxer.readUint32(tkhd, index);

          var mdhd = MP4Demuxer.findBox(trak, ['mdia', 'mdhd'])[0];
          if (mdhd) {
            version = mdhd.data[mdhd.start];
            index = version === 0 ? 12 : 20;
            var timescale = MP4Demuxer.readUint32(mdhd, index);

            var hdlr = MP4Demuxer.findBox(trak, ['mdia', 'hdlr'])[0];
            if (hdlr) {
              var hdlrType = MP4Demuxer.bin2str(hdlr.data.subarray(hdlr.start + 8, hdlr.start + 12));
              var type = { 'soun': 'audio', 'vide': 'video' }[hdlrType];
              if (type) {
                result[trackId] = { timescale: timescale, type: type };
                result[type] = { timescale: timescale, id: trackId };
              }
            }
          }
        }
      });
      return result;
    }

    /**
     * Determine the base media decode start time, in seconds, for an MP4
     * fragment. If multiple fragments are specified, the earliest time is
     * returned.
     *
     * The base media decode time can be parsed from track fragment
     * metadata:
     * ```
     * moof > traf > tfdt.baseMediaDecodeTime
     * ```
     * It requires the timescale value from the mdhd to interpret.
     *
     * @param timescale {object} a hash of track ids to timescale values.
     * @return {number} the earliest base media decode start time for the
     * fragment, in seconds
     */

  }, {
    key: 'getStartDTS',
    value: function getStartDTS(initData, fragment) {
      var trafs, baseTimes, result;

      // we need info from two childrend of each track fragment box
      trafs = MP4Demuxer.findBox(fragment, ['moof', 'traf']);

      // determine the start times for each track
      baseTimes = [].concat.apply([], trafs.map(function (traf) {
        return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
          var id, scale, baseTime;

          // get the track id from the tfhd
          id = MP4Demuxer.readUint32(tfhd, 4);
          // assume a 90kHz clock if no timescale was specified
          scale = initData[id].timescale || 90e3;

          // get the base media decode time from the tfdt
          baseTime = MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
            var version, result;

            version = tfdt.data[tfdt.start];
            result = MP4Demuxer.readUint32(tfdt, 4);
            if (version === 1) {
              result *= Math.pow(2, 32);

              result += MP4Demuxer.readUint32(tfdt, 8);
            }
            return result;
          })[0];
          baseTime = baseTime || Infinity;

          // convert base time to seconds
          return baseTime / scale;
        });
      }));

      // return the minimum
      result = Math.min.apply(null, baseTimes);
      return isFinite(result) ? result : 0;
    }
  }, {
    key: 'offsetStartDTS',
    value: function offsetStartDTS(initData, fragment, timeOffset) {
      MP4Demuxer.findBox(fragment, ['moof', 'traf']).map(function (traf) {
        return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
          // get the track id from the tfhd
          var id = MP4Demuxer.readUint32(tfhd, 4);
          // assume a 90kHz clock if no timescale was specified
          var timescale = initData[id].timescale || 90e3;

          // get the base media decode time from the tfdt
          MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
            var version = tfdt.data[tfdt.start];
            var baseMediaDecodeTime = MP4Demuxer.readUint32(tfdt, 4);
            if (version === 0) {
              MP4Demuxer.writeUint32(tfdt, 4, baseMediaDecodeTime - timeOffset * timescale);
            } else {
              baseMediaDecodeTime *= Math.pow(2, 32);
              baseMediaDecodeTime += MP4Demuxer.readUint32(tfdt, 8);
              baseMediaDecodeTime -= timeOffset * timescale;
              var upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
              var lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
              MP4Demuxer.writeUint32(tfdt, 4, upper);
              MP4Demuxer.writeUint32(tfdt, 8, lower);
            }
          });
        });
      });
    }
  }]);

  return MP4Demuxer;
}();

exports.default = MP4Demuxer;

},{"35":35}],30:[function(_dereq_,module,exports){
"use strict";

/**
 *  MPEG parser helper
 */

var MpegAudio = {

    BitratesMap: [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160],

    SamplingRateMap: [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000],

    appendFrame: function appendFrame(track, data, offset, pts, frameIndex) {
        // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
        if (offset + 24 > data.length) {
            return undefined;
        }

        var header = this.parseHeader(data, offset);
        if (header && offset + header.frameLength <= data.length) {
            var frameDuration = 1152 * 90000 / header.sampleRate;
            var stamp = pts + frameIndex * frameDuration;
            var sample = { unit: data.subarray(offset, offset + header.frameLength), pts: stamp, dts: stamp };

            track.config = [];
            track.channelCount = header.channelCount;
            track.samplerate = header.sampleRate;
            track.samples.push(sample);
            track.len += header.frameLength;

            return { sample: sample, length: header.frameLength };
        }

        return undefined;
    },

    parseHeader: function parseHeader(data, offset) {
        var headerB = data[offset + 1] >> 3 & 3;
        var headerC = data[offset + 1] >> 1 & 3;
        var headerE = data[offset + 2] >> 4 & 15;
        var headerF = data[offset + 2] >> 2 & 3;
        var headerG = !!(data[offset + 2] & 2);
        if (headerB !== 1 && headerE !== 0 && headerE !== 15 && headerF !== 3) {
            var columnInBitrates = headerB === 3 ? 3 - headerC : headerC === 3 ? 3 : 4;
            var bitRate = MpegAudio.BitratesMap[columnInBitrates * 14 + headerE - 1] * 1000;
            var columnInSampleRates = headerB === 3 ? 0 : headerB === 2 ? 1 : 2;
            var sampleRate = MpegAudio.SamplingRateMap[columnInSampleRates * 3 + headerF];
            var padding = headerG ? 1 : 0;
            var channelCount = data[offset + 3] >> 6 === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
            var frameLength = headerC === 3 ? (headerB === 3 ? 12 : 6) * bitRate / sampleRate + padding << 2 : (headerB === 3 ? 144 : 72) * bitRate / sampleRate + padding | 0;

            return { sampleRate: sampleRate, channelCount: channelCount, frameLength: frameLength };
        }

        return undefined;
    },

    isHeaderPattern: function isHeaderPattern(data, offset) {
        return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
    },

    isHeader: function isHeader(data, offset) {
        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
        // More info http://www.mp3-tech.org/programmer/frame_header.html
        if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
            return true;
        }
        return false;
    },

    probe: function probe(data, offset) {
        // same as isHeader but we also check that MPEG frame follows last MPEG frame 
        // or end of data is reached
        if (offset + 1 < data.length && this.isHeaderPattern(data, offset)) {
            // MPEG header Length
            var headerLength = 4;
            // MPEG frame Length
            var header = this.parseHeader(data, offset);
            var frameLength = headerLength;
            if (header && header.frameLength) {
                frameLength = header.frameLength;
            }
            var newOffset = offset + frameLength;
            if (newOffset === data.length || newOffset + 1 < data.length && this.isHeaderPattern(data, newOffset)) {
                return true;
            }
        }
        return false;
    }
};

module.exports = MpegAudio;

},{}],31:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SAMPLE-AES decrypter
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _decrypter = _dereq_(19);

var _decrypter2 = _interopRequireDefault(_decrypter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SampleAesDecrypter = function () {
  function SampleAesDecrypter(observer, config, decryptdata, discardEPB) {
    _classCallCheck(this, SampleAesDecrypter);

    this.decryptdata = decryptdata;
    this.discardEPB = discardEPB;
    this.decrypter = new _decrypter2.default(observer, config);
  }

  _createClass(SampleAesDecrypter, [{
    key: 'decryptBuffer',
    value: function decryptBuffer(encryptedData, callback) {
      this.decrypter.decrypt(encryptedData, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, callback);
    }

    // AAC - encrypt all full 16 bytes blocks starting from offset 16

  }, {
    key: 'decryptAacSample',
    value: function decryptAacSample(samples, sampleIndex, callback, sync) {
      var curUnit = samples[sampleIndex].unit;
      var encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
      var encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);

      var localthis = this;
      this.decryptBuffer(encryptedBuffer, function (decryptedData) {
        decryptedData = new Uint8Array(decryptedData);
        curUnit.set(decryptedData, 16);

        if (!sync) {
          localthis.decryptAacSamples(samples, sampleIndex + 1, callback);
        }
      });
    }
  }, {
    key: 'decryptAacSamples',
    value: function decryptAacSamples(samples, sampleIndex, callback) {
      for (;; sampleIndex++) {
        if (sampleIndex >= samples.length) {
          callback();
          return;
        }

        if (samples[sampleIndex].unit.length < 32) {
          continue;
        }

        var sync = this.decrypter.isSync();

        this.decryptAacSample(samples, sampleIndex, callback, sync);

        if (!sync) {
          return;
        }
      }
    }

    // AVC - encrypt one 16 bytes block out of ten, starting from offset 32

  }, {
    key: 'getAvcEncryptedData',
    value: function getAvcEncryptedData(decodedData) {
      var encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
      var encryptedData = new Int8Array(encryptedDataLen);
      var outputPos = 0;
      for (var inputPos = 32; inputPos <= decodedData.length - 16; inputPos += 160, outputPos += 16) {
        encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
      }
      return encryptedData;
    }
  }, {
    key: 'getAvcDecryptedUnit',
    value: function getAvcDecryptedUnit(decodedData, decryptedData) {
      decryptedData = new Uint8Array(decryptedData);
      var inputPos = 0;
      for (var outputPos = 32; outputPos <= decodedData.length - 16; outputPos += 160, inputPos += 16) {
        decodedData.set(decryptedData.subarray(inputPos, inputPos + 16), outputPos);
      }
      return decodedData;
    }
  }, {
    key: 'decryptAvcSample',
    value: function decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync) {
      var decodedData = this.discardEPB(curUnit.data);
      var encryptedData = this.getAvcEncryptedData(decodedData);
      var localthis = this;

      this.decryptBuffer(encryptedData.buffer, function (decryptedData) {
        curUnit.data = localthis.getAvcDecryptedUnit(decodedData, decryptedData);

        if (!sync) {
          localthis.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
        }
      });
    }
  }, {
    key: 'decryptAvcSamples',
    value: function decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
      for (;; sampleIndex++, unitIndex = 0) {
        if (sampleIndex >= samples.length) {
          callback();
          return;
        }

        var curUnits = samples[sampleIndex].units;
        for (;; unitIndex++) {
          if (unitIndex >= curUnits.length) {
            break;
          }

          var curUnit = curUnits[unitIndex];
          if (curUnit.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) {
            continue;
          }

          var sync = this.decrypter.isSync();

          this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync);

          if (!sync) {
            return;
          }
        }
      }
    }
  }]);

  return SampleAesDecrypter;
}();

exports.default = SampleAesDecrypter;

},{"19":19}],32:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * highly optimized TS demuxer:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * parse PAT, PMT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * extract PES packet from audio and video PIDs
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * extract AVC/H264 NAL units and AAC/ADTS samples from PES packet
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * trigger the remuxer upon parsing completion
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * it also tries to workaround as best as it can audio codec switch (HE-AAC to AAC and vice versa), without having to restart the MediaSource.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * it also controls the remuxing process :
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * upon discontinuity or level switch detection, it will also notifies the remuxer so that it can reset its state.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

// import Hex from '../utils/hex';


var _adts = _dereq_(22);

var _adts2 = _interopRequireDefault(_adts);

var _mpegaudio = _dereq_(30);

var _mpegaudio2 = _interopRequireDefault(_mpegaudio);

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _expGolomb = _dereq_(26);

var _expGolomb2 = _interopRequireDefault(_expGolomb);

var _sampleAes = _dereq_(31);

var _sampleAes2 = _interopRequireDefault(_sampleAes);

var _logger = _dereq_(54);

var _errors = _dereq_(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TSDemuxer = function () {
  function TSDemuxer(observer, remuxer, config, typeSupported) {
    _classCallCheck(this, TSDemuxer);

    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    this.remuxer = remuxer;
    this.sampleAes = null;
  }

  _createClass(TSDemuxer, [{
    key: 'setDecryptData',
    value: function setDecryptData(decryptdata) {
      if (decryptdata != null && decryptdata.key != null && decryptdata.method === 'SAMPLE-AES') {
        this.sampleAes = new _sampleAes2.default(this.observer, this.config, decryptdata, this.discardEPB);
      } else {
        this.sampleAes = null;
      }
    }
  }, {
    key: 'resetInitSegment',
    value: function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      this.pmtParsed = false;
      this._pmtId = -1;
      this._avcTrack = { container: 'video/mp2t', type: 'video', id: -1, inputTimeScale: 90000, sequenceNumber: 0, samples: [], len: 0, dropped: 0 };
      this._audioTrack = { container: 'video/mp2t', type: 'audio', id: -1, inputTimeScale: 90000, duration: duration, sequenceNumber: 0, samples: [], len: 0, isAAC: true };
      this._id3Track = { type: 'id3', id: -1, inputTimeScale: 90000, sequenceNumber: 0, samples: [], len: 0 };
      this._txtTrack = { type: 'text', id: -1, inputTimeScale: 90000, sequenceNumber: 0, samples: [], len: 0 };
      // flush any partial content
      this.aacOverFlow = null;
      this.aacLastPTS = null;
      this.avcSample = null;
      this.audioCodec = audioCodec;
      this.videoCodec = videoCodec;
      this._duration = duration;
    }
  }, {
    key: 'resetTimeStamp',
    value: function resetTimeStamp() {}

    // feed incoming data to the front of the parsing pipeline

  }, {
    key: 'append',
    value: function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var start,
          len = data.length,
          stt,
          pid,
          atf,
          offset,
          pes,
          unknownPIDs = false;
      this.contiguous = contiguous;
      var pmtParsed = this.pmtParsed,
          avcTrack = this._avcTrack,
          audioTrack = this._audioTrack,
          id3Track = this._id3Track,
          avcId = avcTrack.id,
          audioId = audioTrack.id,
          id3Id = id3Track.id,
          pmtId = this._pmtId,
          avcData = avcTrack.pesData,
          audioData = audioTrack.pesData,
          id3Data = id3Track.pesData,
          parsePAT = this._parsePAT,
          parsePMT = this._parsePMT,
          parsePES = this._parsePES,
          parseAVCPES = this._parseAVCPES.bind(this),
          parseAACPES = this._parseAACPES.bind(this),
          parseMPEGPES = this._parseMPEGPES.bind(this),
          parseID3PES = this._parseID3PES.bind(this);

      // don't parse last TS packet if incomplete
      len -= len % 188;
      // loop through TS packets
      for (start = 0; start < len; start += 188) {
        if (data[start] === 0x47) {
          stt = !!(data[start + 1] & 0x40);
          // pid is a 13-bit field starting at the last bit of TS[1]
          pid = ((data[start + 1] & 0x1f) << 8) + data[start + 2];
          atf = (data[start + 3] & 0x30) >> 4;
          // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
          if (atf > 1) {
            offset = start + 5 + data[start + 4];
            // continue if there is only adaptation field
            if (offset === start + 188) {
              continue;
            }
          } else {
            offset = start + 4;
          }
          switch (pid) {
            case avcId:
              if (stt) {
                if (avcData && (pes = parsePES(avcData))) {
                  parseAVCPES(pes, false);
                }
                avcData = { data: [], size: 0 };
              }
              if (avcData) {
                avcData.data.push(data.subarray(offset, start + 188));
                avcData.size += start + 188 - offset;
              }
              break;
            case audioId:
              if (stt) {
                if (audioData && (pes = parsePES(audioData))) {
                  if (audioTrack.isAAC) {
                    parseAACPES(pes);
                  } else {
                    parseMPEGPES(pes);
                  }
                }
                audioData = { data: [], size: 0 };
              }
              if (audioData) {
                audioData.data.push(data.subarray(offset, start + 188));
                audioData.size += start + 188 - offset;
              }
              break;
            case id3Id:
              if (stt) {
                if (id3Data && (pes = parsePES(id3Data))) {
                  parseID3PES(pes);
                }
                id3Data = { data: [], size: 0 };
              }
              if (id3Data) {
                id3Data.data.push(data.subarray(offset, start + 188));
                id3Data.size += start + 188 - offset;
              }
              break;
            case 0:
              if (stt) {
                offset += data[offset] + 1;
              }
              pmtId = this._pmtId = parsePAT(data, offset);
              break;
            case pmtId:
              if (stt) {
                offset += data[offset] + 1;
              }
              var parsedPIDs = parsePMT(data, offset, this.typeSupported.mpeg === true || this.typeSupported.mp3 === true, this.sampleAes != null);

              // only update track id if track PID found while parsing PMT
              // this is to avoid resetting the PID to -1 in case
              // track PID transiently disappears from the stream
              // this could happen in case of transient missing audio samples for example
              avcId = parsedPIDs.avc;
              if (avcId > 0) {
                avcTrack.id = avcId;
              }
              audioId = parsedPIDs.audio;
              if (audioId > 0) {
                audioTrack.id = audioId;
                audioTrack.isAAC = parsedPIDs.isAAC;
              }
              id3Id = parsedPIDs.id3;
              if (id3Id > 0) {
                id3Track.id = id3Id;
              }
              if (unknownPIDs && !pmtParsed) {
                _logger.logger.log('reparse from beginning');
                unknownPIDs = false;
                // we set it to -188, the += 188 in the for loop will reset start to 0
                start = -188;
              }
              pmtParsed = this.pmtParsed = true;
              break;
            case 17:
            case 0x1fff:
              break;
            default:
              unknownPIDs = true;
              break;
          }
        } else {
          this.observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_PARSING_ERROR, fatal: false, reason: 'TS packet did not start with 0x47' });
        }
      }
      // try to parse last PES packets
      if (avcData && (pes = parsePES(avcData))) {
        parseAVCPES(pes, true);
        avcTrack.pesData = null;
      } else {
        // either avcData null or PES truncated, keep it for next frag parsing
        avcTrack.pesData = avcData;
      }

      if (audioData && (pes = parsePES(audioData))) {
        if (audioTrack.isAAC) {
          parseAACPES(pes);
        } else {
          parseMPEGPES(pes);
        }
        audioTrack.pesData = null;
      } else {
        if (audioData && audioData.size) {
          _logger.logger.log('last AAC PES packet truncated,might overlap between fragments');
        }
        // either audioData null or PES truncated, keep it for next frag parsing
        audioTrack.pesData = audioData;
      }

      if (id3Data && (pes = parsePES(id3Data))) {
        parseID3PES(pes);
        id3Track.pesData = null;
      } else {
        // either id3Data null or PES truncated, keep it for next frag parsing
        id3Track.pesData = id3Data;
      }

      if (this.sampleAes == null) {
        this.remuxer.remux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
      } else {
        this.decryptAndRemux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
      }
    }
  }, {
    key: 'decryptAndRemux',
    value: function decryptAndRemux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
      if (audioTrack.samples && audioTrack.isAAC) {
        var localthis = this;
        this.sampleAes.decryptAacSamples(audioTrack.samples, 0, function () {
          localthis.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
        });
      } else {
        this.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
      }
    }
  }, {
    key: 'decryptAndRemuxAvc',
    value: function decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
      if (videoTrack.samples) {
        var localthis = this;
        this.sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, function () {
          localthis.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
        });
      } else {
        this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._initPTS = this._initDTS = undefined;
      this._duration = 0;
    }
  }, {
    key: '_parsePAT',
    value: function _parsePAT(data, offset) {
      // skip the PSI header and parse the first PMT entry
      return (data[offset + 10] & 0x1F) << 8 | data[offset + 11];
      //logger.log('PMT PID:'  + this._pmtId);
    }
  }, {
    key: '_parsePMT',
    value: function _parsePMT(data, offset, mpegSupported, isSampleAes) {
      var sectionLength,
          tableEnd,
          programInfoLength,
          pid,
          result = { audio: -1, avc: -1, id3: -1, isAAC: true };
      sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
      tableEnd = offset + 3 + sectionLength - 4;
      // to determine where the table is, we have to figure out how
      // long the program info descriptors are
      programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
      // advance the offset to the first entry in the mapping table
      offset += 12 + programInfoLength;
      while (offset < tableEnd) {
        pid = (data[offset + 1] & 0x1F) << 8 | data[offset + 2];
        switch (data[offset]) {
          case 0xcf:
            // SAMPLE-AES AAC
            if (!isSampleAes) {
              _logger.logger.log('unkown stream type:' + data[offset]);
              break;
            }
          /* falls through */

          // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
          case 0x0f:
            //logger.log('AAC PID:'  + pid);
            if (result.audio === -1) {
              result.audio = pid;
            }
            break;

          // Packetized metadata (ID3)
          case 0x15:
            //logger.log('ID3 PID:'  + pid);
            if (result.id3 === -1) {
              result.id3 = pid;
            }
            break;

          case 0xdb:
            // SAMPLE-AES AVC
            if (!isSampleAes) {
              _logger.logger.log('unkown stream type:' + data[offset]);
              break;
            }
          /* falls through */

          // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
          case 0x1b:
            //logger.log('AVC PID:'  + pid);
            if (result.avc === -1) {
              result.avc = pid;
            }
            break;

          // ISO/IEC 11172-3 (MPEG-1 audio)
          // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
          case 0x03:
          case 0x04:
            //logger.log('MPEG PID:'  + pid);
            if (!mpegSupported) {
              _logger.logger.log('MPEG audio found, not supported in this browser for now');
            } else if (result.audio === -1) {
              result.audio = pid;
              result.isAAC = false;
            }
            break;

          case 0x24:
            _logger.logger.warn('HEVC stream type found, not supported for now');
            break;

          default:
            _logger.logger.log('unkown stream type:' + data[offset]);
            break;
        }
        // move to the next table entry
        // skip past the elementary stream descriptors, if present
        offset += ((data[offset + 3] & 0x0F) << 8 | data[offset + 4]) + 5;
      }
      return result;
    }
  }, {
    key: '_parsePES',
    value: function _parsePES(stream) {
      var i = 0,
          frag,
          pesFlags,
          pesPrefix,
          pesLen,
          pesHdrLen,
          pesData,
          pesPts,
          pesDts,
          payloadStartOffset,
          data = stream.data;
      // safety check
      if (!stream || stream.size === 0) {
        return null;
      }

      // we might need up to 19 bytes to read PES header
      // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
      // usually only one merge is needed (and this is rare ...)
      while (data[0].length < 19 && data.length > 1) {
        var newData = new Uint8Array(data[0].length + data[1].length);
        newData.set(data[0]);
        newData.set(data[1], data[0].length);
        data[0] = newData;
        data.splice(1, 1);
      }
      //retrieve PTS/DTS from first fragment
      frag = data[0];
      pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
      if (pesPrefix === 1) {
        pesLen = (frag[4] << 8) + frag[5];
        // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
        // minus 6 : PES header size
        if (pesLen && pesLen > stream.size - 6) {
          return null;
        }
        pesFlags = frag[7];
        if (pesFlags & 0xC0) {
          /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
              as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
              as Bitwise operators treat their operands as a sequence of 32 bits */
          pesPts = (frag[9] & 0x0E) * 536870912 + // 1 << 29
          (frag[10] & 0xFF) * 4194304 + // 1 << 22
          (frag[11] & 0xFE) * 16384 + // 1 << 14
          (frag[12] & 0xFF) * 128 + // 1 << 7
          (frag[13] & 0xFE) / 2;
          // check if greater than 2^32 -1
          if (pesPts > 4294967295) {
            // decrement 2^33
            pesPts -= 8589934592;
          }
          if (pesFlags & 0x40) {
            pesDts = (frag[14] & 0x0E) * 536870912 + // 1 << 29
            (frag[15] & 0xFF) * 4194304 + // 1 << 22
            (frag[16] & 0xFE) * 16384 + // 1 << 14
            (frag[17] & 0xFF) * 128 + // 1 << 7
            (frag[18] & 0xFE) / 2;
            // check if greater than 2^32 -1
            if (pesDts > 4294967295) {
              // decrement 2^33
              pesDts -= 8589934592;
            }
            if (pesPts - pesDts > 60 * 90000) {
              _logger.logger.warn(Math.round((pesPts - pesDts) / 90000) + 's delta between PTS and DTS, align them');
              pesPts = pesDts;
            }
          } else {
            pesDts = pesPts;
          }
        }
        pesHdrLen = frag[8];
        // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
        payloadStartOffset = pesHdrLen + 9;

        stream.size -= payloadStartOffset;
        //reassemble PES packet
        pesData = new Uint8Array(stream.size);
        for (var j = 0, dataLen = data.length; j < dataLen; j++) {
          frag = data[j];
          var len = frag.byteLength;
          if (payloadStartOffset) {
            if (payloadStartOffset > len) {
              // trim full frag if PES header bigger than frag
              payloadStartOffset -= len;
              continue;
            } else {
              // trim partial frag if PES header smaller than frag
              frag = frag.subarray(payloadStartOffset);
              len -= payloadStartOffset;
              payloadStartOffset = 0;
            }
          }
          pesData.set(frag, i);
          i += len;
        }
        if (pesLen) {
          // payload size : remove PES header + PES extension
          pesLen -= pesHdrLen + 3;
        }
        return { data: pesData, pts: pesPts, dts: pesDts, len: pesLen };
      } else {
        return null;
      }
    }
  }, {
    key: 'pushAccesUnit',
    value: function pushAccesUnit(avcSample, avcTrack) {
      if (avcSample.units.length && avcSample.frame) {
        var samples = avcTrack.samples;
        var nbSamples = samples.length;
        // only push AVC sample if starting with a keyframe is not mandatory OR
        //    if keyframe already found in this fragment OR
        //       keyframe found in last fragment (track.sps) AND
        //          samples already appended (we already found a keyframe in this fragment) OR fragment is contiguous
        if (!this.config.forceKeyFrameOnDiscontinuity || avcSample.key === true || avcTrack.sps && (nbSamples || this.contiguous)) {
          avcSample.id = nbSamples;
          samples.push(avcSample);
        } else {
          // dropped samples, track it
          avcTrack.dropped++;
        }
      }
      if (avcSample.debug.length) {
        _logger.logger.log(avcSample.pts + '/' + avcSample.dts + ':' + avcSample.debug);
      }
    }
  }, {
    key: '_parseAVCPES',
    value: function _parseAVCPES(pes, last) {
      var _this = this;

      //logger.log('parse new PES');
      var track = this._avcTrack,
          units = this._parseAVCNALu(pes.data),
          debug = false,
          expGolombDecoder,
          avcSample = this.avcSample,
          push,
          spsfound = false,
          i,
          pushAccesUnit = this.pushAccesUnit.bind(this),
          createAVCSample = function createAVCSample(key, pts, dts, debug) {
        return { key: key, pts: pts, dts: dts, units: [], debug: debug };
      };
      //free pes.data to save up some memory
      pes.data = null;

      // if new NAL units found and last sample still there, let's push ...
      // this helps parsing streams with missing AUD
      if (avcSample && units.length) {
        pushAccesUnit(avcSample, track);
        avcSample = this.avcSample = createAVCSample(false, pes.pts, pes.dts, '');
      }

      units.forEach(function (unit) {
        switch (unit.type) {
          //NDR
          case 1:
            push = true;
            if (debug && avcSample) {
              avcSample.debug += 'NDR ';
            }
            avcSample.frame = true;
            var data = unit.data;
            // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
            if (spsfound && data.length > 4) {
              // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
              var sliceType = new _expGolomb2.default(data).readSliceType();
              // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
              // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
              // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
              // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
              //if (sliceType === 2 || sliceType === 7) {
              if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) {
                avcSample.key = true;
              }
            }
            break;
          //IDR
          case 5:
            push = true;
            // handle PES not starting with AUD
            if (!avcSample) {
              avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, '');
            }
            if (debug) {
              avcSample.debug += 'IDR ';
            }
            avcSample.key = true;
            avcSample.frame = true;
            break;
          //SEI
          case 6:
            push = true;
            if (debug && avcSample) {
              avcSample.debug += 'SEI ';
            }
            expGolombDecoder = new _expGolomb2.default(_this.discardEPB(unit.data));

            // skip frameType
            expGolombDecoder.readUByte();

            var payloadType = 0;
            var payloadSize = 0;
            var endOfCaptions = false;
            var b = 0;

            while (!endOfCaptions && expGolombDecoder.bytesAvailable > 1) {
              payloadType = 0;
              do {
                b = expGolombDecoder.readUByte();
                payloadType += b;
              } while (b === 0xFF);

              // Parse payload size.
              payloadSize = 0;
              do {
                b = expGolombDecoder.readUByte();
                payloadSize += b;
              } while (b === 0xFF);

              // TODO: there can be more than one payload in an SEI packet...
              // TODO: need to read type and size in a while loop to get them all
              if (payloadType === 4 && expGolombDecoder.bytesAvailable !== 0) {

                endOfCaptions = true;

                var countryCode = expGolombDecoder.readUByte();

                if (countryCode === 181) {
                  var providerCode = expGolombDecoder.readUShort();

                  if (providerCode === 49) {
                    var userStructure = expGolombDecoder.readUInt();

                    if (userStructure === 0x47413934) {
                      var userDataType = expGolombDecoder.readUByte();

                      // Raw CEA-608 bytes wrapped in CEA-708 packet
                      if (userDataType === 3) {
                        var firstByte = expGolombDecoder.readUByte();
                        var secondByte = expGolombDecoder.readUByte();

                        var totalCCs = 31 & firstByte;
                        var byteArray = [firstByte, secondByte];

                        for (i = 0; i < totalCCs; i++) {
                          // 3 bytes per CC
                          byteArray.push(expGolombDecoder.readUByte());
                          byteArray.push(expGolombDecoder.readUByte());
                          byteArray.push(expGolombDecoder.readUByte());
                        }

                        _this._insertSampleInOrder(_this._txtTrack.samples, { type: 3, pts: pes.pts, bytes: byteArray });
                      }
                    }
                  }
                }
              } else if (payloadSize < expGolombDecoder.bytesAvailable) {
                for (i = 0; i < payloadSize; i++) {
                  expGolombDecoder.readUByte();
                }
              }
            }
            break;
          //SPS
          case 7:
            push = true;
            spsfound = true;
            if (debug && avcSample) {
              avcSample.debug += 'SPS ';
            }
            if (!track.sps) {
              expGolombDecoder = new _expGolomb2.default(unit.data);
              var config = expGolombDecoder.readSPS();
              track.width = config.width;
              track.height = config.height;
              track.pixelRatio = config.pixelRatio;
              track.sps = [unit.data];
              track.duration = _this._duration;
              var codecarray = unit.data.subarray(1, 4);
              var codecstring = 'avc1.';
              for (i = 0; i < 3; i++) {
                var h = codecarray[i].toString(16);
                if (h.length < 2) {
                  h = '0' + h;
                }
                codecstring += h;
              }
              track.codec = codecstring;
            }
            break;
          //PPS
          case 8:
            push = true;
            if (debug && avcSample) {
              avcSample.debug += 'PPS ';
            }
            if (!track.pps) {
              track.pps = [unit.data];
            }
            break;
          // AUD
          case 9:
            push = false;
            if (avcSample) {
              pushAccesUnit(avcSample, track);
            }
            avcSample = _this.avcSample = createAVCSample(false, pes.pts, pes.dts, debug ? 'AUD ' : '');
            break;
          // Filler Data
          case 12:
            push = false;
            break;
          default:
            push = false;
            if (avcSample) {
              avcSample.debug += 'unknown NAL ' + unit.type + ' ';
            }
            break;
        }
        if (avcSample && push) {
          var _units = avcSample.units;
          _units.push(unit);
        }
      });
      // if last PES packet, push samples
      if (last && avcSample) {
        pushAccesUnit(avcSample, track);
        this.avcSample = null;
      }
    }
  }, {
    key: '_insertSampleInOrder',
    value: function _insertSampleInOrder(arr, data) {
      var len = arr.length;
      if (len > 0) {
        if (data.pts >= arr[len - 1].pts) {
          arr.push(data);
        } else {
          for (var pos = len - 1; pos >= 0; pos--) {
            if (data.pts < arr[pos].pts) {
              arr.splice(pos, 0, data);
              break;
            }
          }
        }
      } else {
        arr.push(data);
      }
    }
  }, {
    key: '_getLastNalUnit',
    value: function _getLastNalUnit() {
      var avcSample = this.avcSample,
          lastUnit = void 0;
      // try to fallback to previous sample if current one is empty
      if (!avcSample || avcSample.units.length === 0) {
        var track = this._avcTrack,
            samples = track.samples;
        avcSample = samples[samples.length - 1];
      }
      if (avcSample) {
        var units = avcSample.units;
        lastUnit = units[units.length - 1];
      }
      return lastUnit;
    }
  }, {
    key: '_parseAVCNALu',
    value: function _parseAVCNALu(array) {
      var i = 0,
          len = array.byteLength,
          value,
          overflow,
          track = this._avcTrack,
          state = track.naluState || 0,
          lastState = state;
      var units = [],
          unit,
          unitType,
          lastUnitStart = -1,
          lastUnitType;
      //logger.log('PES:' + Hex.hexDump(array));

      if (state === -1) {
        // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
        lastUnitStart = 0;
        // NALu type is value read from offset 0
        lastUnitType = array[0] & 0x1f;
        state = 0;
        i = 1;
      }

      while (i < len) {
        value = array[i++];
        // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
        if (!state) {
          state = value ? 0 : 1;
          continue;
        }
        if (state === 1) {
          state = value ? 0 : 2;
          continue;
        }
        // here we have state either equal to 2 or 3
        if (!value) {
          state = 3;
        } else if (value === 1) {
          if (lastUnitStart >= 0) {
            unit = { data: array.subarray(lastUnitStart, i - state - 1), type: lastUnitType };
            //logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
            units.push(unit);
          } else {
            // lastUnitStart is undefined => this is the first start code found in this PES packet
            // first check if start code delimiter is overlapping between 2 PES packets,
            // ie it started in last packet (lastState not zero)
            // and ended at the beginning of this PES packet (i <= 4 - lastState)
            var lastUnit = this._getLastNalUnit();
            if (lastUnit) {
              if (lastState && i <= 4 - lastState) {
                // start delimiter overlapping between PES packets
                // strip start delimiter bytes from the end of last NAL unit
                // check if lastUnit had a state different from zero
                if (lastUnit.state) {
                  // strip last bytes
                  lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                }
              }
              // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
              overflow = i - state - 1;
              if (overflow > 0) {
                //logger.log('first NALU found with overflow:' + overflow);
                var tmp = new Uint8Array(lastUnit.data.byteLength + overflow);
                tmp.set(lastUnit.data, 0);
                tmp.set(array.subarray(0, overflow), lastUnit.data.byteLength);
                lastUnit.data = tmp;
              }
            }
          }
          // check if we can read unit type
          if (i < len) {
            unitType = array[i] & 0x1f;
            //logger.log('find NALU @ offset:' + i + ',type:' + unitType);
            lastUnitStart = i;
            lastUnitType = unitType;
            state = 0;
          } else {
            // not enough byte to read unit type. let's read it on next PES parsing
            state = -1;
          }
        } else {
          state = 0;
        }
      }
      if (lastUnitStart >= 0 && state >= 0) {
        unit = { data: array.subarray(lastUnitStart, len), type: lastUnitType, state: state };
        units.push(unit);
        //logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
      }
      // no NALu found
      if (units.length === 0) {
        // append pes.data to previous NAL unit
        var _lastUnit = this._getLastNalUnit();
        if (_lastUnit) {
          var _tmp = new Uint8Array(_lastUnit.data.byteLength + array.byteLength);
          _tmp.set(_lastUnit.data, 0);
          _tmp.set(array, _lastUnit.data.byteLength);
          _lastUnit.data = _tmp;
        }
      }
      track.naluState = state;
      return units;
    }

    /**
     * remove Emulation Prevention bytes from a RBSP
     */

  }, {
    key: 'discardEPB',
    value: function discardEPB(data) {
      var length = data.byteLength,
          EPBPositions = [],
          i = 1,
          newLength,
          newData;

      // Find all `Emulation Prevention Bytes`
      while (i < length - 2) {
        if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
          EPBPositions.push(i + 2);
          i += 2;
        } else {
          i++;
        }
      }

      // If no Emulation Prevention Bytes were found just return the original
      // array
      if (EPBPositions.length === 0) {
        return data;
      }

      // Create a new array to hold the NAL unit data
      newLength = length - EPBPositions.length;
      newData = new Uint8Array(newLength);
      var sourceIndex = 0;

      for (i = 0; i < newLength; sourceIndex++, i++) {
        if (sourceIndex === EPBPositions[0]) {
          // Skip this byte
          sourceIndex++;
          // Remove this position index
          EPBPositions.shift();
        }
        newData[i] = data[sourceIndex];
      }
      return newData;
    }
  }, {
    key: '_parseAACPES',
    value: function _parseAACPES(pes) {
      var track = this._audioTrack,
          data = pes.data,
          pts = pes.pts,
          startOffset = 0,
          aacOverFlow = this.aacOverFlow,
          aacLastPTS = this.aacLastPTS,
          frameDuration,
          frameIndex,
          offset,
          stamp,
          len;
      if (aacOverFlow) {
        var tmp = new Uint8Array(aacOverFlow.byteLength + data.byteLength);
        tmp.set(aacOverFlow, 0);
        tmp.set(data, aacOverFlow.byteLength);
        //logger.log(`AAC: append overflowing ${aacOverFlow.byteLength} bytes to beginning of new PES`);
        data = tmp;
      }
      // look for ADTS header (0xFFFx)
      for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
        if (_adts2.default.isHeader(data, offset)) {
          break;
        }
      }
      // if ADTS header does not start straight from the beginning of the PES payload, raise an error
      if (offset) {
        var reason, fatal;
        if (offset < len - 1) {
          reason = 'AAC PES did not start with ADTS header,offset:' + offset;
          fatal = false;
        } else {
          reason = 'no ADTS header found in AAC PES';
          fatal = true;
        }
        _logger.logger.warn('parsing error:' + reason);
        this.observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_PARSING_ERROR, fatal: fatal, reason: reason });
        if (fatal) {
          return;
        }
      }

      _adts2.default.initTrackConfig(track, this.observer, data, offset, this.audioCodec);
      frameIndex = 0;
      frameDuration = _adts2.default.getFrameDuration(track.samplerate);

      // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
      // first sample PTS should be equal to last sample PTS + frameDuration
      if (aacOverFlow && aacLastPTS) {
        var newPTS = aacLastPTS + frameDuration;
        if (Math.abs(newPTS - pts) > 1) {
          _logger.logger.log('AAC: align PTS for overlapping frames by ' + Math.round((newPTS - pts) / 90));
          pts = newPTS;
        }
      }

      //scan for aac samples
      while (offset < len) {
        if (_adts2.default.isHeader(data, offset) && offset + 5 < len) {
          var frame = _adts2.default.appendFrame(track, data, offset, pts, frameIndex);
          if (frame) {
            //logger.log(`${Math.round(frame.sample.pts)} : AAC`);
            offset += frame.length;
            stamp = frame.sample.pts;
            frameIndex++;
          } else {
            //logger.log('Unable to parse AAC frame');
            break;
          }
        } else {
          //nothing found, keep looking
          offset++;
        }
      }

      if (offset < len) {
        aacOverFlow = data.subarray(offset, len);
        //logger.log(`AAC: overflow detected:${len-offset}`);
      } else {
        aacOverFlow = null;
      }
      this.aacOverFlow = aacOverFlow;
      this.aacLastPTS = stamp;
    }
  }, {
    key: '_parseMPEGPES',
    value: function _parseMPEGPES(pes) {
      var data = pes.data;
      var length = data.length;
      var frameIndex = 0;
      var offset = 0;
      var pts = pes.pts;

      while (offset < length) {
        if (_mpegaudio2.default.isHeader(data, offset)) {
          var frame = _mpegaudio2.default.appendFrame(this._audioTrack, data, offset, pts, frameIndex);
          if (frame) {
            offset += frame.length;
            frameIndex++;
          } else {
            //logger.log('Unable to parse Mpeg audio frame');
            break;
          }
        } else {
          //nothing found, keep looking
          offset++;
        }
      }
    }
  }, {
    key: '_parseID3PES',
    value: function _parseID3PES(pes) {
      this._id3Track.samples.push(pes);
    }
  }], [{
    key: 'probe',
    value: function probe(data) {
      // a TS fragment should contain at least 3 TS packets, a PAT, a PMT, and one PID, each starting with 0x47
      if (data.length >= 3 * 188 && data[0] === 0x47 && data[188] === 0x47 && data[2 * 188] === 0x47) {
        return true;
      } else {
        return false;
      }
    }
  }]);

  return TSDemuxer;
}();

exports.default = TSDemuxer;

},{"22":22,"26":26,"30":30,"31":31,"33":33,"35":35,"54":54}],33:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ErrorTypes = exports.ErrorTypes = {
  // Identifier for a network error (loading error / timeout ...)
  NETWORK_ERROR: 'networkError',
  // Identifier for a media Error (video/parsing/mediasource error)
  MEDIA_ERROR: 'mediaError',
  // Identifier for a mux Error (demuxing/remuxing)
  MUX_ERROR: 'muxError',
  // Identifier for all other errors
  OTHER_ERROR: 'otherError'
};

var ErrorDetails = exports.ErrorDetails = {
  // Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
  MANIFEST_LOAD_ERROR: 'manifestLoadError',
  // Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
  MANIFEST_LOAD_TIMEOUT: 'manifestLoadTimeOut',
  // Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
  MANIFEST_PARSING_ERROR: 'manifestParsingError',
  // Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
  MANIFEST_INCOMPATIBLE_CODECS_ERROR: 'manifestIncompatibleCodecsError',
  // Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
  LEVEL_LOAD_ERROR: 'levelLoadError',
  // Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
  LEVEL_LOAD_TIMEOUT: 'levelLoadTimeOut',
  // Identifier for a level switch error - data: { level : faulty level Id, event : error description}
  LEVEL_SWITCH_ERROR: 'levelSwitchError',
  // Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
  AUDIO_TRACK_LOAD_ERROR: 'audioTrackLoadError',
  // Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
  AUDIO_TRACK_LOAD_TIMEOUT: 'audioTrackLoadTimeOut',
  // Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
  FRAG_LOAD_ERROR: 'fragLoadError',
  // Identifier for fragment loop loading error - data: { frag : fragment object}
  FRAG_LOOP_LOADING_ERROR: 'fragLoopLoadingError',
  // Identifier for fragment load timeout error - data: { frag : fragment object}
  FRAG_LOAD_TIMEOUT: 'fragLoadTimeOut',
  // Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
  FRAG_DECRYPT_ERROR: 'fragDecryptError',
  // Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
  // will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
  FRAG_PARSING_ERROR: 'fragParsingError',
  // Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
  REMUX_ALLOC_ERROR: 'remuxAllocError',
  // Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
  KEY_LOAD_ERROR: 'keyLoadError',
  // Identifier for decrypt key load timeout error - data: { frag : fragment object}
  KEY_LOAD_TIMEOUT: 'keyLoadTimeOut',
  // Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : {  err : exception , mimeType : mimeType }
  BUFFER_ADD_CODEC_ERROR: 'bufferAddCodecError',
  // Identifier for a buffer append error - data: append error description
  BUFFER_APPEND_ERROR: 'bufferAppendError',
  // Identifier for a buffer appending error event - data: appending error description
  BUFFER_APPENDING_ERROR: 'bufferAppendingError',
  // Identifier for a buffer stalled error event
  BUFFER_STALLED_ERROR: 'bufferStalledError',
  // Identifier for a buffer full event
  BUFFER_FULL_ERROR: 'bufferFullError',
  // Identifier for a buffer seek over hole event
  BUFFER_SEEK_OVER_HOLE: 'bufferSeekOverHole',
  // Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
  BUFFER_NUDGE_ON_STALL: 'bufferNudgeOnStall',
  // Identifier for an internal exception happening inside hls.js while handling an event
  INTERNAL_EXCEPTION: 'internalException',
  // Malformed WebVTT contents
  WEBVTT_EXCEPTION: 'webVTTException'
};

},{}],34:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * All objects in the event handling chain should inherit from this class
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _logger = _dereq_(54);

var _errors = _dereq_(33);

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventHandler = function () {
  function EventHandler(hls) {
    _classCallCheck(this, EventHandler);

    this.hls = hls;
    this.onEvent = this.onEvent.bind(this);

    for (var _len = arguments.length, events = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      events[_key - 1] = arguments[_key];
    }

    this.handledEvents = events;
    this.useGenericHandler = true;

    this.registerListeners();
  }

  _createClass(EventHandler, [{
    key: 'destroy',
    value: function destroy() {
      this.unregisterListeners();
    }
  }, {
    key: 'isEventHandler',
    value: function isEventHandler() {
      return _typeof(this.handledEvents) === 'object' && this.handledEvents.length && typeof this.onEvent === 'function';
    }
  }, {
    key: 'registerListeners',
    value: function registerListeners() {
      if (this.isEventHandler()) {
        this.handledEvents.forEach(function (event) {
          if (event === 'hlsEventGeneric') {
            throw new Error('Forbidden event name: ' + event);
          }
          this.hls.on(event, this.onEvent);
        }, this);
      }
    }
  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {
      if (this.isEventHandler()) {
        this.handledEvents.forEach(function (event) {
          this.hls.off(event, this.onEvent);
        }, this);
      }
    }

    /**
     * arguments: event (string), data (any)
     */

  }, {
    key: 'onEvent',
    value: function onEvent(event, data) {
      this.onEventGeneric(event, data);
    }
  }, {
    key: 'onEventGeneric',
    value: function onEventGeneric(event, data) {
      var eventToFunction = function eventToFunction(event, data) {
        var funcName = 'on' + event.replace('hls', '');
        if (typeof this[funcName] !== 'function') {
          throw new Error('Event ' + event + ' has no generic handler in this ' + this.constructor.name + ' class (tried ' + funcName + ')');
        }
        return this[funcName].bind(this, data);
      };
      try {
        eventToFunction.call(this, event, data).call();
      } catch (err) {
        _logger.logger.error('internal error happened while processing ' + event + ':' + err.message);
        this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.OTHER_ERROR, details: _errors.ErrorDetails.INTERNAL_EXCEPTION, fatal: false, event: event, err: err });
      }
    }
  }]);

  return EventHandler;
}();

exports.default = EventHandler;

},{"33":33,"35":35,"54":54}],35:[function(_dereq_,module,exports){
'use strict';

module.exports = {
  // fired before MediaSource is attaching to media element - data: { media }
  MEDIA_ATTACHING: 'hlsMediaAttaching',
  // fired when MediaSource has been succesfully attached to media element - data: { }
  MEDIA_ATTACHED: 'hlsMediaAttached',
  // fired before detaching MediaSource from media element - data: { }
  MEDIA_DETACHING: 'hlsMediaDetaching',
  // fired when MediaSource has been detached from media element - data: { }
  MEDIA_DETACHED: 'hlsMediaDetached',
  // fired when we buffer is going to be reset - data: { }
  BUFFER_RESET: 'hlsBufferReset',
  // fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
  BUFFER_CODECS: 'hlsBufferCodecs',
  // fired when sourcebuffers have been created - data: { tracks : tracks }
  BUFFER_CREATED: 'hlsBufferCreated',
  // fired when we append a segment to the buffer - data: { segment: segment object }
  BUFFER_APPENDING: 'hlsBufferAppending',
  // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
  BUFFER_APPENDED: 'hlsBufferAppended',
  // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
  BUFFER_EOS: 'hlsBufferEos',
  // fired when the media buffer should be flushed - data { startOffset, endOffset }
  BUFFER_FLUSHING: 'hlsBufferFlushing',
  // fired when the media buffer has been flushed - data: { }
  BUFFER_FLUSHED: 'hlsBufferFlushed',
  // fired to signal that a manifest loading starts - data: { url : manifestURL}
  MANIFEST_LOADING: 'hlsManifestLoading',
  // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks], url : manifestURL, stats : { trequest, tfirst, tload, mtime}}
  MANIFEST_LOADED: 'hlsManifestLoaded',
  // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
  MANIFEST_PARSED: 'hlsManifestParsed',
  // fired when a level switch is requested - data: { level : id of new level } // deprecated in favor LEVEL_SWITCHING
  LEVEL_SWITCH: 'hlsLevelSwitch',
  // fired when a level switch is requested - data: { level : id of new level }
  LEVEL_SWITCHING: 'hlsLevelSwitching',
  // fired when a level switch is effective - data: { level : id of new level }
  LEVEL_SWITCHED: 'hlsLevelSwitched',
  // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
  LEVEL_LOADING: 'hlsLevelLoading',
  // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : { trequest, tfirst, tload, mtime} }
  LEVEL_LOADED: 'hlsLevelLoaded',
  // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
  LEVEL_UPDATED: 'hlsLevelUpdated',
  // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
  LEVEL_PTS_UPDATED: 'hlsLevelPtsUpdated',
  // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
  AUDIO_TRACKS_UPDATED: 'hlsAudioTracksUpdated',
  // fired when an audio track switch occurs - data: { id : audio track id } // deprecated in favor AUDIO_TRACK_SWITCHING
  AUDIO_TRACK_SWITCH: 'hlsAudioTrackSwitch',
  // fired when an audio track switching is requested - data: { id : audio track id }
  AUDIO_TRACK_SWITCHING: 'hlsAudioTrackSwitching',
  // fired when an audio track switch actually occurs - data: { id : audio track id }
  AUDIO_TRACK_SWITCHED: 'hlsAudioTrackSwitched',
  // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
  AUDIO_TRACK_LOADING: 'hlsAudioTrackLoading',
  // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : { trequest, tfirst, tload, mtime } }
  AUDIO_TRACK_LOADED: 'hlsAudioTrackLoaded',
  // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
  SUBTITLE_TRACKS_UPDATED: 'hlsSubtitleTracksUpdated',
  // fired when an subtitle track switch occurs - data: { id : subtitle track id }
  SUBTITLE_TRACK_SWITCH: 'hlsSubtitleTrackSwitch',
  // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
  SUBTITLE_TRACK_LOADING: 'hlsSubtitleTrackLoading',
  // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : { trequest, tfirst, tload, mtime } }
  SUBTITLE_TRACK_LOADED: 'hlsSubtitleTrackLoaded',
  // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
  SUBTITLE_FRAG_PROCESSED: 'hlsSubtitleFragProcessed',
  // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, frag : fragment object }
  INIT_PTS_FOUND: 'hlsInitPtsFound',
  // fired when a fragment loading starts - data: { frag : fragment object }
  FRAG_LOADING: 'hlsFragLoading',
  // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
  FRAG_LOAD_PROGRESS: 'hlsFragLoadProgress',
  // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
  FRAG_LOAD_EMERGENCY_ABORTED: 'hlsFragLoadEmergencyAborted',
  // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : { trequest, tfirst, tload, length } }
  FRAG_LOADED: 'hlsFragLoaded',
  // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, stats : { tstart, tdecrypt } }
  FRAG_DECRYPTED: 'hlsFragDecrypted',
  // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
  FRAG_PARSING_INIT_SEGMENT: 'hlsFragParsingInitSegment',
  // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
  FRAG_PARSING_USERDATA: 'hlsFragParsingUserdata',
  // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
  FRAG_PARSING_METADATA: 'hlsFragParsingMetadata',
  // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
  FRAG_PARSING_DATA: 'hlsFragParsingData',
  // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
  FRAG_PARSED: 'hlsFragParsed',
  // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : { trequest, tfirst, tload, tparsed, tbuffered, length, bwEstimate } }
  FRAG_BUFFERED: 'hlsFragBuffered',
  // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
  FRAG_CHANGED: 'hlsFragChanged',
  // Identifier for a FPS drop event - data: { curentDropped, currentDecoded, totalDroppedFrames }
  FPS_DROP: 'hlsFpsDrop',
  //triggered when FPS drop triggers auto level capping - data: { level, droppedlevel }
  FPS_DROP_LEVEL_CAPPING: 'hlsFpsDropLevelCapping',
  // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
  ERROR: 'hlsError',
  // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
  DESTROYING: 'hlsDestroying',
  // fired when a decrypt key loading starts - data: { frag : fragment object }
  KEY_LOADING: 'hlsKeyLoading',
  // fired when a decrypt key loading is completed - data: { frag : fragment object, payload : key payload, stats : { trequest, tfirst, tload, length } }
  KEY_LOADED: 'hlsKeyLoaded',
  // fired upon stream controller state transitions - data: { previousState, nextState }
  STREAM_STATE_TRANSITION: 'hlsStreamStateTransition'
};

},{}],36:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  AAC helper
 */

var AAC = function () {
  function AAC() {
    _classCallCheck(this, AAC);
  }

  _createClass(AAC, null, [{
    key: 'getSilentFrame',
    value: function getSilentFrame(codec, channelCount) {
      switch (codec) {
        case 'mp4a.40.2':
          if (channelCount === 1) {
            return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);
          } else if (channelCount === 2) {
            return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);
          } else if (channelCount === 3) {
            return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);
          } else if (channelCount === 4) {
            return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);
          } else if (channelCount === 5) {
            return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);
          } else if (channelCount === 6) {
            return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);
          }
          break;
        // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
        default:
          if (channelCount === 1) {
            // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
            return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x4e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x1c, 0x6, 0xf1, 0xc1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
          } else if (channelCount === 2) {
            // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
            return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
          } else if (channelCount === 3) {
            // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
            return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
          }
          break;
      }
      return null;
    }
  }]);

  return AAC;
}();

exports.default = AAC;

},{}],37:[function(_dereq_,module,exports){
"use strict";

/**
 * Buffer Helper utils, providing methods dealing buffer length retrieval
*/

var BufferHelper = {
  isBuffered: function isBuffered(media, position) {
    if (media) {
      var buffered = media.buffered;
      for (var i = 0; i < buffered.length; i++) {
        if (position >= buffered.start(i) && position <= buffered.end(i)) {
          return true;
        }
      }
    }
    return false;
  },

  bufferInfo: function bufferInfo(media, pos, maxHoleDuration) {
    if (media) {
      var vbuffered = media.buffered,
          buffered = [],
          i;
      for (i = 0; i < vbuffered.length; i++) {
        buffered.push({ start: vbuffered.start(i), end: vbuffered.end(i) });
      }
      return this.bufferedInfo(buffered, pos, maxHoleDuration);
    } else {
      return { len: 0, start: pos, end: pos, nextStart: undefined };
    }
  },

  bufferedInfo: function bufferedInfo(buffered, pos, maxHoleDuration) {
    var buffered2 = [],

    // bufferStart and bufferEnd are buffer boundaries around current video position
    bufferLen,
        bufferStart,
        bufferEnd,
        bufferStartNext,
        i;
    // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
    buffered.sort(function (a, b) {
      var diff = a.start - b.start;
      if (diff) {
        return diff;
      } else {
        return b.end - a.end;
      }
    });
    // there might be some small holes between buffer time range
    // consider that holes smaller than maxHoleDuration are irrelevant and build another
    // buffer time range representations that discards those holes
    for (i = 0; i < buffered.length; i++) {
      var buf2len = buffered2.length;
      if (buf2len) {
        var buf2end = buffered2[buf2len - 1].end;
        // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
        if (buffered[i].start - buf2end < maxHoleDuration) {
          // merge overlapping time ranges
          // update lastRange.end only if smaller than item.end
          // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
          // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
          if (buffered[i].end > buf2end) {
            buffered2[buf2len - 1].end = buffered[i].end;
          }
        } else {
          // big hole
          buffered2.push(buffered[i]);
        }
      } else {
        // first value
        buffered2.push(buffered[i]);
      }
    }
    for (i = 0, bufferLen = 0, bufferStart = bufferEnd = pos; i < buffered2.length; i++) {
      var start = buffered2[i].start,
          end = buffered2[i].end;
      //logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
      if (pos + maxHoleDuration >= start && pos < end) {
        // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
        bufferStart = start;
        bufferEnd = end;
        bufferLen = bufferEnd - pos;
      } else if (pos + maxHoleDuration < start) {
        bufferStartNext = start;
        break;
      }
    }
    return { len: bufferLen, start: bufferStart, end: bufferEnd, nextStart: bufferStartNext };
  }
};

module.exports = BufferHelper;

},{}],38:[function(_dereq_,module,exports){
'use strict';

var _logger = _dereq_(54);

var LevelHelper = {

  mergeDetails: function mergeDetails(oldDetails, newDetails) {
    var start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN,
        end = Math.min(oldDetails.endSN, newDetails.endSN) - newDetails.startSN,
        delta = newDetails.startSN - oldDetails.startSN,
        oldfragments = oldDetails.fragments,
        newfragments = newDetails.fragments,
        ccOffset = 0,
        PTSFrag;

    // check if old/new playlists have fragments in common
    if (end < start) {
      newDetails.PTSKnown = false;
      return;
    }
    // loop through overlapping SN and update startPTS , cc, and duration if any found
    for (var i = start; i <= end; i++) {
      var oldFrag = oldfragments[delta + i],
          newFrag = newfragments[i];
      if (newFrag && oldFrag) {
        ccOffset = oldFrag.cc - newFrag.cc;
        if (!isNaN(oldFrag.startPTS)) {
          newFrag.start = newFrag.startPTS = oldFrag.startPTS;
          newFrag.endPTS = oldFrag.endPTS;
          newFrag.duration = oldFrag.duration;
          newFrag.backtracked = oldFrag.backtracked;
          newFrag.dropped = oldFrag.dropped;
          PTSFrag = newFrag;
        }
      }
    }

    if (ccOffset) {
      _logger.logger.log('discontinuity sliding from playlist, take drift into account');
      for (i = 0; i < newfragments.length; i++) {
        newfragments[i].cc += ccOffset;
      }
    }

    // if at least one fragment contains PTS info, recompute PTS information for all fragments
    if (PTSFrag) {
      LevelHelper.updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
    } else {
      // ensure that delta is within oldfragments range
      // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
      // in that case we also need to adjust start offset of all fragments
      if (delta >= 0 && delta < oldfragments.length) {
        // adjust start by sliding offset
        var sliding = oldfragments[delta].start;
        for (i = 0; i < newfragments.length; i++) {
          newfragments[i].start += sliding;
        }
      }
    }
    // if we are here, it means we have fragments overlapping between
    // old and new level. reliable PTS info is thus relying on old level
    newDetails.PTSKnown = oldDetails.PTSKnown;
    return;
  },

  updateFragPTSDTS: function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
    // update frag PTS/DTS
    var maxStartPTS = startPTS;
    if (!isNaN(frag.startPTS)) {
      // delta PTS between audio and video
      var deltaPTS = Math.abs(frag.startPTS - startPTS);
      if (isNaN(frag.deltaPTS)) {
        frag.deltaPTS = deltaPTS;
      } else {
        frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
      }
      maxStartPTS = Math.max(startPTS, frag.startPTS);
      startPTS = Math.min(startPTS, frag.startPTS);
      endPTS = Math.max(endPTS, frag.endPTS);
      startDTS = Math.min(startDTS, frag.startDTS);
      endDTS = Math.max(endDTS, frag.endDTS);
    }

    var drift = startPTS - frag.start;
    frag.start = frag.startPTS = startPTS;
    frag.maxStartPTS = maxStartPTS;
    frag.endPTS = endPTS;
    frag.startDTS = startDTS;
    frag.endDTS = endDTS;
    frag.duration = endPTS - startPTS;

    var sn = frag.sn;
    // exit if sn out of range
    if (!details || sn < details.startSN || sn > details.endSN) {
      return 0;
    }
    var fragIdx, fragments, i;
    fragIdx = sn - details.startSN;
    fragments = details.fragments;
    // update frag reference in fragments array
    // rationale is that fragments array might not contain this frag object.
    // this will happpen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
    // if we don't update frag, we won't be able to propagate PTS info on the playlist
    // resulting in invalid sliding computation
    fragments[fragIdx] = frag;
    // adjust fragment PTS/duration from seqnum-1 to frag 0
    for (i = fragIdx; i > 0; i--) {
      LevelHelper.updatePTS(fragments, i, i - 1);
    }

    // adjust fragment PTS/duration from seqnum to last frag
    for (i = fragIdx; i < fragments.length - 1; i++) {
      LevelHelper.updatePTS(fragments, i, i + 1);
    }
    details.PTSKnown = true;
    //logger.log(`                                            frag start/end:${startPTS.toFixed(3)}/${endPTS.toFixed(3)}`);

    return drift;
  },

  updatePTS: function updatePTS(fragments, fromIdx, toIdx) {
    var fragFrom = fragments[fromIdx],
        fragTo = fragments[toIdx],
        fragToPTS = fragTo.startPTS;
    // if we know startPTS[toIdx]
    if (!isNaN(fragToPTS)) {
      // update fragment duration.
      // it helps to fix drifts between playlist reported duration and fragment real duration
      if (toIdx > fromIdx) {
        fragFrom.duration = fragToPTS - fragFrom.start;
        if (fragFrom.duration < 0) {
          _logger.logger.warn('negative duration computed for frag ' + fragFrom.sn + ',level ' + fragFrom.level + ', there should be some duration drift between playlist and fragment!');
        }
      } else {
        fragTo.duration = fragFrom.start - fragToPTS;
        if (fragTo.duration < 0) {
          _logger.logger.warn('negative duration computed for frag ' + fragTo.sn + ',level ' + fragTo.level + ', there should be some duration drift between playlist and fragment!');
        }
      }
    } else {
      // we dont know startPTS[toIdx]
      if (toIdx > fromIdx) {
        fragTo.start = fragFrom.start + fragFrom.duration;
      } else {
        fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
      }
    }
  }
}; /**
    * Level Helper class, providing methods dealing with playlist sliding and drift
   */

module.exports = LevelHelper;

},{"54":54}],39:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * HLS interface
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _urlToolkit = _dereq_(2);

var _urlToolkit2 = _interopRequireDefault(_urlToolkit);

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _errors = _dereq_(33);

var _playlistLoader = _dereq_(43);

var _playlistLoader2 = _interopRequireDefault(_playlistLoader);

var _fragmentLoader = _dereq_(41);

var _fragmentLoader2 = _interopRequireDefault(_fragmentLoader);

var _keyLoader = _dereq_(42);

var _keyLoader2 = _interopRequireDefault(_keyLoader);

var _streamController = _dereq_(13);

var _streamController2 = _interopRequireDefault(_streamController);

var _levelController = _dereq_(12);

var _levelController2 = _interopRequireDefault(_levelController);

var _id3TrackController = _dereq_(11);

var _id3TrackController2 = _interopRequireDefault(_id3TrackController);

var _logger = _dereq_(54);

var _events3 = _dereq_(1);

var _events4 = _interopRequireDefault(_events3);

var _config = _dereq_(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Hls = function () {
  _createClass(Hls, null, [{
    key: 'isSupported',
    value: function isSupported() {
      var mediaSource = window.MediaSource = window.MediaSource || window.WebKitMediaSource;
      var sourceBuffer = window.SourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
      var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');

      // if SourceBuffer is exposed ensure its API is valid
      // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
      var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
      return isTypeSupported && sourceBufferValidAPI;
    }
  }, {
    key: 'version',
    get: function get() {
      // replaced with browserify-versionify transform
      return '0.7.11';
    }
  }, {
    key: 'Events',
    get: function get() {
      return _events2.default;
    }
  }, {
    key: 'ErrorTypes',
    get: function get() {
      return _errors.ErrorTypes;
    }
  }, {
    key: 'ErrorDetails',
    get: function get() {
      return _errors.ErrorDetails;
    }
  }, {
    key: 'DefaultConfig',
    get: function get() {
      if (!Hls.defaultConfig) {
        return _config.hlsDefaultConfig;
      }
      return Hls.defaultConfig;
    },
    set: function set(defaultConfig) {
      Hls.defaultConfig = defaultConfig;
    }
  }]);

  function Hls() {
    var _this = this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Hls);

    var defaultConfig = Hls.DefaultConfig;

    if ((config.liveSyncDurationCount || config.liveMaxLatencyDurationCount) && (config.liveSyncDuration || config.liveMaxLatencyDuration)) {
      throw new Error('Illegal hls.js config: don\'t mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration');
    }

    for (var prop in defaultConfig) {
      if (prop in config) {
        continue;
      }
      config[prop] = defaultConfig[prop];
    }

    if (config.liveMaxLatencyDurationCount !== undefined && config.liveMaxLatencyDurationCount <= config.liveSyncDurationCount) {
      throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
    }

    if (config.liveMaxLatencyDuration !== undefined && (config.liveMaxLatencyDuration <= config.liveSyncDuration || config.liveSyncDuration === undefined)) {
      throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
    }

    (0, _logger.enableLogs)(config.debug);
    this.config = config;
    this._autoLevelCapping = -1;
    // observer setup
    var observer = this.observer = new _events4.default();
    observer.trigger = function trigger(event) {
      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        data[_key - 1] = arguments[_key];
      }

      observer.emit.apply(observer, [event, event].concat(data));
    };

    observer.off = function off(event) {
      for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        data[_key2 - 1] = arguments[_key2];
      }

      observer.removeListener.apply(observer, [event].concat(data));
    };
    this.on = observer.on.bind(observer);
    this.off = observer.off.bind(observer);
    this.trigger = observer.trigger.bind(observer);

    // core controllers and network loaders
    var abrController = this.abrController = new config.abrController(this);
    var bufferController = new config.bufferController(this);
    var capLevelController = new config.capLevelController(this);
    var fpsController = new config.fpsController(this);
    var playListLoader = new _playlistLoader2.default(this);
    var fragmentLoader = new _fragmentLoader2.default(this);
    var keyLoader = new _keyLoader2.default(this);
    var id3TrackController = new _id3TrackController2.default(this);

    // network controllers
    var levelController = this.levelController = new _levelController2.default(this);
    var streamController = this.streamController = new _streamController2.default(this);
    var networkControllers = [levelController, streamController];

    // optional audio stream controller
    var Controller = config.audioStreamController;
    if (Controller) {
      networkControllers.push(new Controller(this));
    }
    this.networkControllers = networkControllers;

    var coreComponents = [playListLoader, fragmentLoader, keyLoader, abrController, bufferController, capLevelController, fpsController, id3TrackController];

    // optional audio track and subtitle controller
    Controller = config.audioTrackController;
    if (Controller) {
      var audioTrackController = new Controller(this);
      this.audioTrackController = audioTrackController;
      coreComponents.push(audioTrackController);
    }

    Controller = config.subtitleTrackController;
    if (Controller) {
      var subtitleTrackController = new Controller(this);
      this.subtitleTrackController = subtitleTrackController;
      coreComponents.push(subtitleTrackController);
    }

    // optional subtitle controller
    [config.subtitleStreamController, config.timelineController].forEach(function (Controller) {
      if (Controller) {
        coreComponents.push(new Controller(_this));
      }
    });
    this.coreComponents = coreComponents;
  }

  _createClass(Hls, [{
    key: 'destroy',
    value: function destroy() {
      _logger.logger.log('destroy');
      this.trigger(_events2.default.DESTROYING);
      this.detachMedia();
      this.coreComponents.concat(this.networkControllers).forEach(function (component) {
        component.destroy();
      });
      this.url = null;
      this.observer.removeAllListeners();
      this._autoLevelCapping = -1;
    }
  }, {
    key: 'attachMedia',
    value: function attachMedia(media) {
      _logger.logger.log('attachMedia');
      this.media = media;
      this.trigger(_events2.default.MEDIA_ATTACHING, { media: media });
    }
  }, {
    key: 'detachMedia',
    value: function detachMedia() {
      _logger.logger.log('detachMedia');
      this.trigger(_events2.default.MEDIA_DETACHING);
      this.media = null;
    }
  }, {
    key: 'loadSource',
    value: function loadSource(url) {
      url = _urlToolkit2.default.buildAbsoluteURL(window.location.href, url, { alwaysNormalize: true });
      _logger.logger.log('loadSource:' + url);
      this.url = url;
      // when attaching to a source URL, trigger a playlist load
      this.trigger(_events2.default.MANIFEST_LOADING, { url: url });
    }
  }, {
    key: 'startLoad',
    value: function startLoad() {
      var startPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;

      _logger.logger.log('startLoad(' + startPosition + ')');
      this.networkControllers.forEach(function (controller) {
        controller.startLoad(startPosition);
      });
    }
  }, {
    key: 'stopLoad',
    value: function stopLoad() {
      _logger.logger.log('stopLoad');
      this.networkControllers.forEach(function (controller) {
        controller.stopLoad();
      });
    }
  }, {
    key: 'swapAudioCodec',
    value: function swapAudioCodec() {
      _logger.logger.log('swapAudioCodec');
      this.streamController.swapAudioCodec();
    }
  }, {
    key: 'recoverMediaError',
    value: function recoverMediaError() {
      _logger.logger.log('recoverMediaError');
      var media = this.media;
      this.detachMedia();
      this.attachMedia(media);
    }

    /** Return all quality levels **/

  }, {
    key: 'levels',
    get: function get() {
      return this.levelController.levels;
    }

    /** Return current playback quality level **/

  }, {
    key: 'currentLevel',
    get: function get() {
      return this.streamController.currentLevel;
    }

    /* set quality level immediately (-1 for automatic level selection) */
    ,
    set: function set(newLevel) {
      _logger.logger.log('set currentLevel:' + newLevel);
      this.loadLevel = newLevel;
      this.streamController.immediateLevelSwitch();
    }

    /** Return next playback quality level (quality level of next fragment) **/

  }, {
    key: 'nextLevel',
    get: function get() {
      return this.streamController.nextLevel;
    }

    /* set quality level for next fragment (-1 for automatic level selection) */
    ,
    set: function set(newLevel) {
      _logger.logger.log('set nextLevel:' + newLevel);
      this.levelController.manualLevel = newLevel;
      this.streamController.nextLevelSwitch();
    }

    /** Return the quality level of current/last loaded fragment **/

  }, {
    key: 'loadLevel',
    get: function get() {
      return this.levelController.level;
    }

    /* set quality level for current/next loaded fragment (-1 for automatic level selection) */
    ,
    set: function set(newLevel) {
      _logger.logger.log('set loadLevel:' + newLevel);
      this.levelController.manualLevel = newLevel;
    }

    /** Return the quality level of next loaded fragment **/

  }, {
    key: 'nextLoadLevel',
    get: function get() {
      return this.levelController.nextLoadLevel;
    }

    /** set quality level of next loaded fragment **/
    ,
    set: function set(level) {
      this.levelController.nextLoadLevel = level;
    }

    /** Return first level (index of first level referenced in manifest)
    **/

  }, {
    key: 'firstLevel',
    get: function get() {
      return Math.max(this.levelController.firstLevel, this.minAutoLevel);
    }

    /** set first level (index of first level referenced in manifest)
    **/
    ,
    set: function set(newLevel) {
      _logger.logger.log('set firstLevel:' + newLevel);
      this.levelController.firstLevel = newLevel;
    }

    /** Return start level (level of first fragment that will be played back)
        if not overrided by user, first level appearing in manifest will be used as start level
        if -1 : automatic start level selection, playback will start from level matching download bandwidth (determined from download of first segment)
    **/

  }, {
    key: 'startLevel',
    get: function get() {
      return this.levelController.startLevel;
    }

    /** set  start level (level of first fragment that will be played back)
        if not overrided by user, first level appearing in manifest will be used as start level
        if -1 : automatic start level selection, playback will start from level matching download bandwidth (determined from download of first segment)
    **/
    ,
    set: function set(newLevel) {
      _logger.logger.log('set startLevel:' + newLevel);
      var hls = this;
      // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
      if (newLevel !== -1) {
        newLevel = Math.max(newLevel, hls.minAutoLevel);
      }
      hls.levelController.startLevel = newLevel;
    }

    /** Return the capping/max level value that could be used by automatic level selection algorithm **/

  }, {
    key: 'autoLevelCapping',
    get: function get() {
      return this._autoLevelCapping;
    }

    /** set the capping/max level value that could be used by automatic level selection algorithm **/
    ,
    set: function set(newLevel) {
      _logger.logger.log('set autoLevelCapping:' + newLevel);
      this._autoLevelCapping = newLevel;
    }

    /* check if we are in automatic level selection mode */

  }, {
    key: 'autoLevelEnabled',
    get: function get() {
      return this.levelController.manualLevel === -1;
    }

    /* return manual level */

  }, {
    key: 'manualLevel',
    get: function get() {
      return this.levelController.manualLevel;
    }

    /* return min level selectable in auto mode according to config.minAutoBitrate */

  }, {
    key: 'minAutoLevel',
    get: function get() {
      var hls = this,
          levels = hls.levels,
          minAutoBitrate = hls.config.minAutoBitrate,
          len = levels ? levels.length : 0;
      for (var i = 0; i < len; i++) {
        var levelNextBitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate;
        if (levelNextBitrate > minAutoBitrate) {
          return i;
        }
      }
      return 0;
    }

    /* return max level selectable in auto mode according to autoLevelCapping */

  }, {
    key: 'maxAutoLevel',
    get: function get() {
      var hls = this;
      var levels = hls.levels;
      var autoLevelCapping = hls.autoLevelCapping;
      var maxAutoLevel = void 0;
      if (autoLevelCapping === -1 && levels && levels.length) {
        maxAutoLevel = levels.length - 1;
      } else {
        maxAutoLevel = autoLevelCapping;
      }
      return maxAutoLevel;
    }

    // return next auto level

  }, {
    key: 'nextAutoLevel',
    get: function get() {
      var hls = this;
      // ensure next auto level is between  min and max auto level
      return Math.min(Math.max(hls.abrController.nextAutoLevel, hls.minAutoLevel), hls.maxAutoLevel);
    }

    // this setter is used to force next auto level
    // this is useful to force a switch down in auto mode : in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
    // forced value is valid for one fragment. upon succesful frag loading at forced level, this value will be resetted to -1 by ABR controller
    ,
    set: function set(nextLevel) {
      var hls = this;
      hls.abrController.nextAutoLevel = Math.max(hls.minAutoLevel, nextLevel);
    }

    /** get alternate audio tracks list from playlist **/

  }, {
    key: 'audioTracks',
    get: function get() {
      var audioTrackController = this.audioTrackController;
      return audioTrackController ? audioTrackController.audioTracks : [];
    }

    /** get index of the selected audio track (index in audio track lists) **/

  }, {
    key: 'audioTrack',
    get: function get() {
      var audioTrackController = this.audioTrackController;
      return audioTrackController ? audioTrackController.audioTrack : -1;
    }

    /** select an audio track, based on its index in audio track lists**/
    ,
    set: function set(audioTrackId) {
      var audioTrackController = this.audioTrackController;
      if (audioTrackController) {
        audioTrackController.audioTrack = audioTrackId;
      }
    }
  }, {
    key: 'liveSyncPosition',
    get: function get() {
      return this.streamController.liveSyncPosition;
    }

    /** get alternate subtitle tracks list from playlist **/

  }, {
    key: 'subtitleTracks',
    get: function get() {
      var subtitleTrackController = this.subtitleTrackController;
      return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
    }

    /** get index of the selected subtitle track (index in subtitle track lists) **/

  }, {
    key: 'subtitleTrack',
    get: function get() {
      var subtitleTrackController = this.subtitleTrackController;
      return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
    }

    /** select an subtitle track, based on its index in subtitle track lists**/
    ,
    set: function set(subtitleTrackId) {
      var subtitleTrackController = this.subtitleTrackController;
      if (subtitleTrackController) {
        subtitleTrackController.subtitleTrack = subtitleTrackId;
      }
    }
  }]);

  return Hls;
}();

exports.default = Hls;

},{"1":1,"11":11,"12":12,"13":13,"2":2,"33":33,"35":35,"4":4,"41":41,"42":42,"43":43,"54":54}],40:[function(_dereq_,module,exports){
'use strict';

// This is mostly for support of the es6 module export
// syntax with the babel compiler, it looks like it doesnt support
// function exports like we are used to in node/commonjs
module.exports = _dereq_(39).default;

},{"39":39}],41:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _errors = _dereq_(33);

var _logger = _dereq_(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Fragment Loader
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var FragmentLoader = function (_EventHandler) {
  _inherits(FragmentLoader, _EventHandler);

  function FragmentLoader(hls) {
    _classCallCheck(this, FragmentLoader);

    var _this = _possibleConstructorReturn(this, (FragmentLoader.__proto__ || Object.getPrototypeOf(FragmentLoader)).call(this, hls, _events2.default.FRAG_LOADING));

    _this.loaders = {};
    return _this;
  }

  _createClass(FragmentLoader, [{
    key: 'destroy',
    value: function destroy() {
      var loaders = this.loaders;
      for (var loaderName in loaders) {
        var loader = loaders[loaderName];
        if (loader) {
          loader.destroy();
        }
      }
      this.loaders = {};
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onFragLoading',
    value: function onFragLoading(data) {
      var frag = data.frag,
          type = frag.type,
          loader = this.loaders[type],
          config = this.hls.config;

      frag.loaded = 0;
      if (loader) {
        _logger.logger.warn('abort previous fragment loader for type:' + type);
        loader.abort();
      }
      loader = this.loaders[type] = frag.loader = typeof config.fLoader !== 'undefined' ? new config.fLoader(config) : new config.loader(config);

      var loaderContext = void 0,
          loaderConfig = void 0,
          loaderCallbacks = void 0;
      loaderContext = { url: frag.url, frag: frag, responseType: 'arraybuffer', progressData: false };
      var start = frag.byteRangeStartOffset,
          end = frag.byteRangeEndOffset;
      if (!isNaN(start) && !isNaN(end)) {
        loaderContext.rangeStart = start;
        loaderContext.rangeEnd = end;
      }
      loaderConfig = { timeout: config.fragLoadingTimeOut, maxRetry: 0, retryDelay: 0, maxRetryDelay: config.fragLoadingMaxRetryTimeout };
      loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this), onProgress: this.loadprogress.bind(this) };
      loader.load(loaderContext, loaderConfig, loaderCallbacks);
    }
  }, {
    key: 'loadsuccess',
    value: function loadsuccess(response, stats, context) {
      var networkDetails = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var payload = response.data,
          frag = context.frag;
      // detach fragment loader on load success
      frag.loader = undefined;
      this.loaders[frag.type] = undefined;
      this.hls.trigger(_events2.default.FRAG_LOADED, { payload: payload, frag: frag, stats: stats, networkDetails: networkDetails });
    }
  }, {
    key: 'loaderror',
    value: function loaderror(response, context) {
      var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var loader = context.loader;
      if (loader) {
        loader.abort();
      }
      this.loaders[context.type] = undefined;
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.FRAG_LOAD_ERROR, fatal: false, frag: context.frag, response: response, networkDetails: networkDetails });
    }
  }, {
    key: 'loadtimeout',
    value: function loadtimeout(stats, context) {
      var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var loader = context.loader;
      if (loader) {
        loader.abort();
      }
      this.loaders[context.type] = undefined;
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.FRAG_LOAD_TIMEOUT, fatal: false, frag: context.frag, networkDetails: networkDetails });
    }

    // data will be used for progressive parsing

  }, {
    key: 'loadprogress',
    value: function loadprogress(stats, context, data) {
      var networkDetails = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      // jshint ignore:line
      var frag = context.frag;
      frag.loaded = stats.loaded;
      this.hls.trigger(_events2.default.FRAG_LOAD_PROGRESS, { frag: frag, stats: stats, networkDetails: networkDetails });
    }
  }]);

  return FragmentLoader;
}(_eventHandler2.default);

exports.default = FragmentLoader;

},{"33":33,"34":34,"35":35,"54":54}],42:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _errors = _dereq_(33);

var _logger = _dereq_(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Decrypt key Loader
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var KeyLoader = function (_EventHandler) {
  _inherits(KeyLoader, _EventHandler);

  function KeyLoader(hls) {
    _classCallCheck(this, KeyLoader);

    var _this = _possibleConstructorReturn(this, (KeyLoader.__proto__ || Object.getPrototypeOf(KeyLoader)).call(this, hls, _events2.default.KEY_LOADING));

    _this.loaders = {};
    _this.decryptkey = null;
    _this.decrypturl = null;
    return _this;
  }

  _createClass(KeyLoader, [{
    key: 'destroy',
    value: function destroy() {
      for (var loaderName in this.loaders) {
        var loader = this.loaders[loaderName];
        if (loader) {
          loader.destroy();
        }
      }
      this.loaders = {};
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onKeyLoading',
    value: function onKeyLoading(data) {
      var frag = data.frag,
          type = frag.type,
          loader = this.loaders[type],
          decryptdata = frag.decryptdata,
          uri = decryptdata.uri;
      // if uri is different from previous one or if decrypt key not retrieved yet
      if (uri !== this.decrypturl || this.decryptkey === null) {
        var config = this.hls.config;

        if (loader) {
          _logger.logger.warn('abort previous key loader for type:' + type);
          loader.abort();
        }
        frag.loader = this.loaders[type] = new config.loader(config);
        this.decrypturl = uri;
        this.decryptkey = null;

        var loaderContext = void 0,
            loaderConfig = void 0,
            loaderCallbacks = void 0;
        loaderContext = { url: uri, frag: frag, responseType: 'arraybuffer' };
        loaderConfig = { timeout: config.fragLoadingTimeOut, maxRetry: config.fragLoadingMaxRetry, retryDelay: config.fragLoadingRetryDelay, maxRetryDelay: config.fragLoadingMaxRetryTimeout };
        loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
        frag.loader.load(loaderContext, loaderConfig, loaderCallbacks);
      } else if (this.decryptkey) {
        // we already loaded this key, return it
        decryptdata.key = this.decryptkey;
        this.hls.trigger(_events2.default.KEY_LOADED, { frag: frag });
      }
    }
  }, {
    key: 'loadsuccess',
    value: function loadsuccess(response, stats, context) {
      var frag = context.frag;
      this.decryptkey = frag.decryptdata.key = new Uint8Array(response.data);
      // detach fragment loader on load success
      frag.loader = undefined;
      this.loaders[frag.type] = undefined;
      this.hls.trigger(_events2.default.KEY_LOADED, { frag: frag });
    }
  }, {
    key: 'loaderror',
    value: function loaderror(response, context) {
      var frag = context.frag,
          loader = frag.loader;
      if (loader) {
        loader.abort();
      }
      this.loaders[context.type] = undefined;
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.KEY_LOAD_ERROR, fatal: false, frag: frag, response: response });
    }
  }, {
    key: 'loadtimeout',
    value: function loadtimeout(stats, context) {
      var frag = context.frag,
          loader = frag.loader;
      if (loader) {
        loader.abort();
      }
      this.loaders[context.type] = undefined;
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.KEY_LOAD_TIMEOUT, fatal: false, frag: frag });
    }
  }]);

  return KeyLoader;
}(_eventHandler2.default);

exports.default = KeyLoader;

},{"33":33,"34":34,"35":35,"54":54}],43:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Playlist Loader
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _urlToolkit = _dereq_(2);

var _urlToolkit2 = _interopRequireDefault(_urlToolkit);

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = _dereq_(34);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _errors = _dereq_(33);

var _attrList = _dereq_(47);

var _attrList2 = _interopRequireDefault(_attrList);

var _logger = _dereq_(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://regex101.com is your friend
var MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g;
var MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;

var LEVEL_PLAYLIST_REGEX_FAST = new RegExp([/#EXTINF:(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source, // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
/|(?!#)(\S+)/.source, // segment URI, group 3 => the URI (note newline is not eaten)
/|#EXT-X-BYTERANGE:*(.+)/.source, // next segment's byterange, group 4 => range spec (x@y)
/|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source, // next segment's program date/time group 5 => the datetime spec
/|#.*/.source // All other non-segment oriented tags will match with all groups empty
].join(''), 'g');

var LEVEL_PLAYLIST_REGEX_SLOW = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)(.*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/;

var LevelKey = function () {
  function LevelKey() {
    _classCallCheck(this, LevelKey);

    this.method = null;
    this.key = null;
    this.iv = null;
    this._uri = null;
  }

  _createClass(LevelKey, [{
    key: 'uri',
    get: function get() {
      if (!this._uri && this.reluri) {
        this._uri = _urlToolkit2.default.buildAbsoluteURL(this.baseuri, this.reluri, { alwaysNormalize: true });
      }
      return this._uri;
    }
  }]);

  return LevelKey;
}();

var Fragment = function () {
  function Fragment() {
    _classCallCheck(this, Fragment);

    this._url = null;
    this._byteRange = null;
    this._decryptdata = null;
    this.tagList = [];
  }

  _createClass(Fragment, [{
    key: 'createInitializationVector',


    /**
     * Utility method for parseLevelPlaylist to create an initialization vector for a given segment
     * @returns {Uint8Array}
     */
    value: function createInitializationVector(segmentNumber) {
      var uint8View = new Uint8Array(16);

      for (var i = 12; i < 16; i++) {
        uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
      }

      return uint8View;
    }

    /**
     * Utility method for parseLevelPlaylist to get a fragment's decryption data from the currently parsed encryption key data
     * @param levelkey - a playlist's encryption info
     * @param segmentNumber - the fragment's segment number
     * @returns {*} - an object to be applied as a fragment's decryptdata
     */

  }, {
    key: 'fragmentDecryptdataFromLevelkey',
    value: function fragmentDecryptdataFromLevelkey(levelkey, segmentNumber) {
      var decryptdata = levelkey;

      if (levelkey && levelkey.method && levelkey.uri && !levelkey.iv) {
        decryptdata = new LevelKey();
        decryptdata.method = levelkey.method;
        decryptdata.baseuri = levelkey.baseuri;
        decryptdata.reluri = levelkey.reluri;
        decryptdata.iv = this.createInitializationVector(segmentNumber);
      }

      return decryptdata;
    }
  }, {
    key: 'cloneObj',
    value: function cloneObj(obj) {
      return JSON.parse(JSON.stringify(obj));
    }
  }, {
    key: 'url',
    get: function get() {
      if (!this._url && this.relurl) {
        this._url = _urlToolkit2.default.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: true });
      }
      return this._url;
    },
    set: function set(value) {
      this._url = value;
    }
  }, {
    key: 'programDateTime',
    get: function get() {
      if (!this._programDateTime && this.rawProgramDateTime) {
        this._programDateTime = new Date(Date.parse(this.rawProgramDateTime));
      }
      return this._programDateTime;
    }
  }, {
    key: 'byteRange',
    get: function get() {
      if (!this._byteRange) {
        var byteRange = this._byteRange = [];
        if (this.rawByteRange) {
          var params = this.rawByteRange.split('@', 2);
          if (params.length === 1) {
            var lastByteRangeEndOffset = this.lastByteRangeEndOffset;
            byteRange[0] = lastByteRangeEndOffset ? lastByteRangeEndOffset : 0;
          } else {
            byteRange[0] = parseInt(params[1]);
          }
          byteRange[1] = parseInt(params[0]) + byteRange[0];
        }
      }
      return this._byteRange;
    }
  }, {
    key: 'byteRangeStartOffset',
    get: function get() {
      return this.byteRange[0];
    }
  }, {
    key: 'byteRangeEndOffset',
    get: function get() {
      return this.byteRange[1];
    }
  }, {
    key: 'decryptdata',
    get: function get() {
      if (!this._decryptdata) {
        this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn);
      }
      return this._decryptdata;
    }
  }]);

  return Fragment;
}();

var PlaylistLoader = function (_EventHandler) {
  _inherits(PlaylistLoader, _EventHandler);

  function PlaylistLoader(hls) {
    _classCallCheck(this, PlaylistLoader);

    var _this = _possibleConstructorReturn(this, (PlaylistLoader.__proto__ || Object.getPrototypeOf(PlaylistLoader)).call(this, hls, _events2.default.MANIFEST_LOADING, _events2.default.LEVEL_LOADING, _events2.default.AUDIO_TRACK_LOADING, _events2.default.SUBTITLE_TRACK_LOADING));

    _this.loaders = {};
    return _this;
  }

  _createClass(PlaylistLoader, [{
    key: 'destroy',
    value: function destroy() {
      for (var loaderName in this.loaders) {
        var loader = this.loaders[loaderName];
        if (loader) {
          loader.destroy();
        }
      }
      this.loaders = {};
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onManifestLoading',
    value: function onManifestLoading(data) {
      this.load(data.url, { type: 'manifest' });
    }
  }, {
    key: 'onLevelLoading',
    value: function onLevelLoading(data) {
      this.load(data.url, { type: 'level', level: data.level, id: data.id });
    }
  }, {
    key: 'onAudioTrackLoading',
    value: function onAudioTrackLoading(data) {
      this.load(data.url, { type: 'audioTrack', id: data.id });
    }
  }, {
    key: 'onSubtitleTrackLoading',
    value: function onSubtitleTrackLoading(data) {
      this.load(data.url, { type: 'subtitleTrack', id: data.id });
    }
  }, {
    key: 'load',
    value: function load(url, context) {
      var loader = this.loaders[context.type];
      if (loader) {
        var loaderContext = loader.context;
        if (loaderContext && loaderContext.url === url) {
          _logger.logger.trace('playlist request ongoing');
          return;
        } else {
          _logger.logger.warn('abort previous loader for type:' + context.type);
          loader.abort();
        }
      }
      var config = this.hls.config,
          retry = void 0,
          timeout = void 0,
          retryDelay = void 0,
          maxRetryDelay = void 0;
      if (context.type === 'manifest') {
        retry = config.manifestLoadingMaxRetry;
        timeout = config.manifestLoadingTimeOut;
        retryDelay = config.manifestLoadingRetryDelay;
        maxRetryDelay = config.manifestLoadingMaxRetryTimeout;
      } else {
        retry = config.levelLoadingMaxRetry;
        timeout = config.levelLoadingTimeOut;
        retryDelay = config.levelLoadingRetryDelay;
        maxRetryDelay = config.levelLoadingMaxRetryTimeout;
        _logger.logger.log('loading playlist for ' + context.type + ' ' + (context.level || context.id));
      }
      loader = this.loaders[context.type] = context.loader = typeof config.pLoader !== 'undefined' ? new config.pLoader(config) : new config.loader(config);
      context.url = url;
      context.responseType = '';

      var loaderConfig = void 0,
          loaderCallbacks = void 0;
      loaderConfig = { timeout: timeout, maxRetry: retry, retryDelay: retryDelay, maxRetryDelay: maxRetryDelay };
      loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
      loader.load(context, loaderConfig, loaderCallbacks);
    }
  }, {
    key: 'resolve',
    value: function resolve(url, baseUrl) {
      return _urlToolkit2.default.buildAbsoluteURL(baseUrl, url, { alwaysNormalize: true });
    }
  }, {
    key: 'parseMasterPlaylist',
    value: function parseMasterPlaylist(string, baseurl) {
      var levels = [],
          result = void 0;
      MASTER_PLAYLIST_REGEX.lastIndex = 0;
      while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
        var level = {};

        var attrs = level.attrs = new _attrList2.default(result[1]);
        level.url = this.resolve(result[2], baseurl);

        var resolution = attrs.decimalResolution('RESOLUTION');
        if (resolution) {
          level.width = resolution.width;
          level.height = resolution.height;
        }
        level.bitrate = attrs.decimalInteger('AVERAGE-BANDWIDTH') || attrs.decimalInteger('BANDWIDTH');
        level.name = attrs.NAME;

        var codecs = attrs.CODECS;
        if (codecs) {
          codecs = codecs.split(/[ ,]+/);
          for (var i = 0; i < codecs.length; i++) {
            var codec = codecs[i];
            if (codec.indexOf('avc1') !== -1) {
              level.videoCodec = this.avc1toavcoti(codec);
            } else if (codec.indexOf('hvc1') !== -1) {
              level.videoCodec = codec;
            } else {
              level.audioCodec = codec;
            }
          }
        }

        levels.push(level);
      }
      return levels;
    }
  }, {
    key: 'parseMasterPlaylistMedia',
    value: function parseMasterPlaylistMedia(string, baseurl, type) {
      var audioCodec = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var result = void 0,
          medias = [],
          id = 0;
      MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
      while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) != null) {
        var media = {};
        var attrs = new _attrList2.default(result[1]);
        if (attrs.TYPE === type) {
          media.groupId = attrs['GROUP-ID'];
          media.name = attrs.NAME;
          media.type = type;
          media.default = attrs.DEFAULT === 'YES';
          media.autoselect = attrs.AUTOSELECT === 'YES';
          media.forced = attrs.FORCED === 'YES';
          if (attrs.URI) {
            media.url = this.resolve(attrs.URI, baseurl);
          }
          media.lang = attrs.LANGUAGE;
          if (!media.name) {
            media.name = media.lang;
          }
          if (audioCodec) {
            media.audioCodec = audioCodec;
          }
          media.id = id++;
          medias.push(media);
        }
      }
      return medias;
    }
  }, {
    key: 'avc1toavcoti',
    value: function avc1toavcoti(codec) {
      var result,
          avcdata = codec.split('.');
      if (avcdata.length > 2) {
        result = avcdata.shift() + '.';
        result += parseInt(avcdata.shift()).toString(16);
        result += ('000' + parseInt(avcdata.shift()).toString(16)).substr(-4);
      } else {
        result = codec;
      }
      return result;
    }
  }, {
    key: 'parseLevelPlaylist',
    value: function parseLevelPlaylist(string, baseurl, id, type) {
      var currentSN = 0,
          totalduration = 0,
          level = { type: null, version: null, url: baseurl, fragments: [], live: true, startSN: 0 },
          levelkey = new LevelKey(),
          cc = 0,
          prevFrag = null,
          frag = new Fragment(),
          result,
          i;

      LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;

      while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
        var duration = result[1];
        if (duration) {
          // INF
          frag.duration = parseFloat(duration);
          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          var title = (' ' + result[2]).slice(1);
          frag.title = title ? title : null;
          frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
        } else if (result[3]) {
          // url
          if (!isNaN(frag.duration)) {
            var sn = currentSN++;
            frag.type = type;
            frag.start = totalduration;
            frag.levelkey = levelkey;
            frag.sn = sn;
            frag.level = id;
            frag.cc = cc;
            frag.baseurl = baseurl;
            // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
            frag.relurl = (' ' + result[3]).slice(1);

            level.fragments.push(frag);
            prevFrag = frag;
            totalduration += frag.duration;

            frag = new Fragment();
          }
        } else if (result[4]) {
          // X-BYTERANGE
          frag.rawByteRange = (' ' + result[4]).slice(1);
          if (prevFrag) {
            var lastByteRangeEndOffset = prevFrag.byteRangeEndOffset;
            if (lastByteRangeEndOffset) {
              frag.lastByteRangeEndOffset = lastByteRangeEndOffset;
            }
          }
        } else if (result[5]) {
          // PROGRAM-DATE-TIME
          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          frag.rawProgramDateTime = (' ' + result[5]).slice(1);
          frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
        } else {
          result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
          for (i = 1; i < result.length; i++) {
            if (result[i] !== undefined) {
              break;
            }
          }

          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          var value1 = (' ' + result[i + 1]).slice(1);
          var value2 = (' ' + result[i + 2]).slice(1);

          switch (result[i]) {
            case '#':
              frag.tagList.push(value2 ? [value1, value2] : [value1]);
              break;
            case 'PLAYLIST-TYPE':
              level.type = value1.toUpperCase();
              break;
            case 'MEDIA-SEQUENCE':
              currentSN = level.startSN = parseInt(value1);
              break;
            case 'TARGETDURATION':
              level.targetduration = parseFloat(value1);
              break;
            case 'VERSION':
              level.version = parseInt(value1);
              break;
            case 'EXTM3U':
              break;
            case 'ENDLIST':
              level.live = false;
              break;
            case 'DIS':
              cc++;
              frag.tagList.push(['DIS']);
              break;
            case 'DISCONTINUITY-SEQ':
              cc = parseInt(value1);
              break;
            case 'KEY':
              // https://tools.ietf.org/html/draft-pantos-http-live-streaming-08#section-3.4.4
              var decryptparams = value1;
              var keyAttrs = new _attrList2.default(decryptparams);
              var decryptmethod = keyAttrs.enumeratedString('METHOD'),
                  decrypturi = keyAttrs.URI,
                  decryptiv = keyAttrs.hexadecimalInteger('IV');
              if (decryptmethod) {
                levelkey = new LevelKey();
                if (decrypturi && ['AES-128', 'SAMPLE-AES'].indexOf(decryptmethod) >= 0) {
                  levelkey.method = decryptmethod;
                  // URI to get the key
                  levelkey.baseuri = baseurl;
                  levelkey.reluri = decrypturi;
                  levelkey.key = null;
                  // Initialization Vector (IV)
                  levelkey.iv = decryptiv;
                }
              }
              break;
            case 'START':
              var startParams = value1;
              var startAttrs = new _attrList2.default(startParams);
              var startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
              //TIME-OFFSET can be 0
              if (!isNaN(startTimeOffset)) {
                level.startTimeOffset = startTimeOffset;
              }
              break;
            case 'MAP':
              var mapAttrs = new _attrList2.default(value1);
              frag.relurl = mapAttrs.URI;
              frag.rawByteRange = mapAttrs.BYTERANGE;
              frag.baseurl = baseurl;
              frag.level = id;
              frag.type = type;
              frag.sn = 'initSegment';
              level.initSegment = frag;
              frag = new Fragment();
              break;
            default:
              _logger.logger.warn('line parsed but not handled: ' + result);
              break;
          }
        }
      }
      frag = prevFrag;
      //logger.log('found ' + level.fragments.length + ' fragments');
      if (frag && !frag.relurl) {
        level.fragments.pop();
        totalduration -= frag.duration;
      }
      level.totalduration = totalduration;
      level.averagetargetduration = totalduration / level.fragments.length;
      level.endSN = currentSN - 1;
      return level;
    }
  }, {
    key: 'loadsuccess',
    value: function loadsuccess(response, stats, context) {
      var networkDetails = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var string = response.data,
          url = response.url,
          type = context.type,
          id = context.id,
          level = context.level,
          hls = this.hls;

      this.loaders[type] = undefined;
      // responseURL not supported on some browsers (it is used to detect URL redirection)
      // data-uri mode also not supported (but no need to detect redirection)
      if (url === undefined || url.indexOf('data:') === 0) {
        // fallback to initial URL
        url = context.url;
      }
      stats.tload = performance.now();
      //stats.mtime = new Date(target.getResponseHeader('Last-Modified'));
      if (string.indexOf('#EXTM3U') === 0) {
        if (string.indexOf('#EXTINF:') > 0) {
          var isLevel = type !== 'audioTrack' && type !== 'subtitleTrack',
              levelId = !isNaN(level) ? level : !isNaN(id) ? id : 0,
              levelDetails = this.parseLevelPlaylist(string, url, levelId, type === 'audioTrack' ? 'audio' : type === 'subtitleTrack' ? 'subtitle' : 'main');
          levelDetails.tload = stats.tload;
          if (type === 'manifest') {
            // first request, stream manifest (no master playlist), fire manifest loaded event with level details
            hls.trigger(_events2.default.MANIFEST_LOADED, { levels: [{ url: url, details: levelDetails }], audioTracks: [], url: url, stats: stats, networkDetails: networkDetails });
          }
          stats.tparsed = performance.now();
          if (levelDetails.targetduration) {
            if (isLevel) {
              hls.trigger(_events2.default.LEVEL_LOADED, { details: levelDetails, level: level || 0, id: id || 0, stats: stats, networkDetails: networkDetails });
            } else {
              if (type === 'audioTrack') {
                hls.trigger(_events2.default.AUDIO_TRACK_LOADED, { details: levelDetails, id: id, stats: stats, networkDetails: networkDetails });
              } else if (type === 'subtitleTrack') {
                hls.trigger(_events2.default.SUBTITLE_TRACK_LOADED, { details: levelDetails, id: id, stats: stats, networkDetails: networkDetails });
              }
            }
          } else {
            hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.MANIFEST_PARSING_ERROR, fatal: true, url: url, reason: 'invalid targetduration', networkDetails: networkDetails });
          }
        } else {
          var levels = this.parseMasterPlaylist(string, url);
          // multi level playlist, parse level info
          if (levels.length) {
            var audioTracks = this.parseMasterPlaylistMedia(string, url, 'AUDIO', levels[0].audioCodec);
            var subtitles = this.parseMasterPlaylistMedia(string, url, 'SUBTITLES');
            if (audioTracks.length) {
              // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
              var embeddedAudioFound = false;
              audioTracks.forEach(function (audioTrack) {
                if (!audioTrack.url) {
                  embeddedAudioFound = true;
                }
              });
              // if no embedded audio track defined, but audio codec signaled in quality level, we need to signal this main audio track
              // this could happen with playlists with alt audio rendition in which quality levels (main) contains both audio+video. but with mixed audio track not signaled
              if (embeddedAudioFound === false && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
                _logger.logger.log('audio codec signaled in quality level, but no embedded audio track signaled, create one');
                audioTracks.unshift({ type: 'main', name: 'main' });
              }
            }
            hls.trigger(_events2.default.MANIFEST_LOADED, { levels: levels, audioTracks: audioTracks, subtitles: subtitles, url: url, stats: stats, networkDetails: networkDetails });
          } else {
            hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.MANIFEST_PARSING_ERROR, fatal: true, url: url, reason: 'no level found in manifest', networkDetails: networkDetails });
          }
        }
      } else {
        hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.MANIFEST_PARSING_ERROR, fatal: true, url: url, reason: 'no EXTM3U delimiter', networkDetails: networkDetails });
      }
    }
  }, {
    key: 'loaderror',
    value: function loaderror(response, context) {
      var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var details,
          fatal,
          loader = context.loader;
      switch (context.type) {
        case 'manifest':
          details = _errors.ErrorDetails.MANIFEST_LOAD_ERROR;
          fatal = true;
          break;
        case 'level':
          details = _errors.ErrorDetails.LEVEL_LOAD_ERROR;
          fatal = false;
          break;
        case 'audioTrack':
          details = _errors.ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
          fatal = false;
          break;
      }
      if (loader) {
        loader.abort();
        this.loaders[context.type] = undefined;
      }
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: details, fatal: fatal, url: loader.url, loader: loader, response: response, context: context, networkDetails: networkDetails });
    }
  }, {
    key: 'loadtimeout',
    value: function loadtimeout(stats, context) {
      var networkDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var details,
          fatal,
          loader = context.loader;
      switch (context.type) {
        case 'manifest':
          details = _errors.ErrorDetails.MANIFEST_LOAD_TIMEOUT;
          fatal = true;
          break;
        case 'level':
          details = _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT;
          fatal = false;
          break;
        case 'audioTrack':
          details = _errors.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT;
          fatal = false;
          break;
      }
      if (loader) {
        loader.abort();
        this.loaders[context.type] = undefined;
      }
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: details, fatal: fatal, url: loader.url, loader: loader, context: context, networkDetails: networkDetails });
    }
  }]);

  return PlaylistLoader;
}(_eventHandler2.default);

exports.default = PlaylistLoader;

},{"2":2,"33":33,"34":34,"35":35,"47":47,"54":54}],44:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Generate MP4 Box
*/

//import Hex from '../utils/hex';

var UINT32_MAX = Math.pow(2, 32) - 1;

var MP4 = function () {
  function MP4() {
    _classCallCheck(this, MP4);
  }

  _createClass(MP4, null, [{
    key: 'init',
    value: function init() {
      MP4.types = {
        avc1: [], // codingname
        avcC: [],
        btrt: [],
        dinf: [],
        dref: [],
        esds: [],
        ftyp: [],
        hdlr: [],
        mdat: [],
        mdhd: [],
        mdia: [],
        mfhd: [],
        minf: [],
        moof: [],
        moov: [],
        mp4a: [],
        '.mp3': [],
        mvex: [],
        mvhd: [],
        pasp: [],
        sdtp: [],
        stbl: [],
        stco: [],
        stsc: [],
        stsd: [],
        stsz: [],
        stts: [],
        tfdt: [],
        tfhd: [],
        traf: [],
        trak: [],
        trun: [],
        trex: [],
        tkhd: [],
        vmhd: [],
        smhd: []
      };

      var i;
      for (i in MP4.types) {
        if (MP4.types.hasOwnProperty(i)) {
          MP4.types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
        }
      }

      var videoHdlr = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, // pre_defined
      0x76, 0x69, 0x64, 0x65, // handler_type: 'vide'
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
      ]);

      var audioHdlr = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, // pre_defined
      0x73, 0x6f, 0x75, 0x6e, // handler_type: 'soun'
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
      ]);

      MP4.HDLR_TYPES = {
        'video': videoHdlr,
        'audio': audioHdlr
      };

      var dref = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x01, // entry_count
      0x00, 0x00, 0x00, 0x0c, // entry_size
      0x75, 0x72, 0x6c, 0x20, // 'url' type
      0x00, // version 0
      0x00, 0x00, 0x01 // entry_flags
      ]);

      var stco = new Uint8Array([0x00, // version
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00 // entry_count
      ]);

      MP4.STTS = MP4.STSC = MP4.STCO = stco;

      MP4.STSZ = new Uint8Array([0x00, // version
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, // sample_size
      0x00, 0x00, 0x00, 0x00]);
      MP4.VMHD = new Uint8Array([0x00, // version
      0x00, 0x00, 0x01, // flags
      0x00, 0x00, // graphicsmode
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
      ]);
      MP4.SMHD = new Uint8Array([0x00, // version
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, // balance
      0x00, 0x00 // reserved
      ]);

      MP4.STSD = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x01]); // entry_count

      var majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
      var avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
      var minorVersion = new Uint8Array([0, 0, 0, 1]);

      MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
      MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
    }
  }, {
    key: 'box',
    value: function box(type) {
      var payload = Array.prototype.slice.call(arguments, 1),
          size = 8,
          i = payload.length,
          len = i,
          result;
      // calculate the total size we need to allocate
      while (i--) {
        size += payload[i].byteLength;
      }
      result = new Uint8Array(size);
      result[0] = size >> 24 & 0xff;
      result[1] = size >> 16 & 0xff;
      result[2] = size >> 8 & 0xff;
      result[3] = size & 0xff;
      result.set(type, 4);
      // copy the payload into the result
      for (i = 0, size = 8; i < len; i++) {
        // copy payload[i] array @ offset size
        result.set(payload[i], size);
        size += payload[i].byteLength;
      }
      return result;
    }
  }, {
    key: 'hdlr',
    value: function hdlr(type) {
      return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
    }
  }, {
    key: 'mdat',
    value: function mdat(data) {
      return MP4.box(MP4.types.mdat, data);
    }
  }, {
    key: 'mdhd',
    value: function mdhd(timescale, duration) {
      duration *= timescale;
      var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
      var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
      return MP4.box(MP4.types.mdhd, new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
      timescale >> 24 & 0xFF, timescale >> 16 & 0xFF, timescale >> 8 & 0xFF, timescale & 0xFF, // timescale
      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x55, 0xc4, // 'und' language (undetermined)
      0x00, 0x00]));
    }
  }, {
    key: 'mdia',
    value: function mdia(track) {
      return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
    }
  }, {
    key: 'mfhd',
    value: function mfhd(sequenceNumber) {
      return MP4.box(MP4.types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // flags
      sequenceNumber >> 24, sequenceNumber >> 16 & 0xFF, sequenceNumber >> 8 & 0xFF, sequenceNumber & 0xFF]) // sequence_number
      );
    }
  }, {
    key: 'minf',
    value: function minf(track) {
      if (track.type === 'audio') {
        return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
      } else {
        return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
      }
    }
  }, {
    key: 'moof',
    value: function moof(sn, baseMediaDecodeTime, track) {
      return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
    }
    /**
     * @param tracks... (optional) {array} the tracks associated with this movie
     */

  }, {
    key: 'moov',
    value: function moov(tracks) {
      var i = tracks.length,
          boxes = [];

      while (i--) {
        boxes[i] = MP4.trak(tracks[i]);
      }

      return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale, tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));
    }
  }, {
    key: 'mvex',
    value: function mvex(tracks) {
      var i = tracks.length,
          boxes = [];

      while (i--) {
        boxes[i] = MP4.trex(tracks[i]);
      }
      return MP4.box.apply(null, [MP4.types.mvex].concat(boxes));
    }
  }, {
    key: 'mvhd',
    value: function mvhd(timescale, duration) {
      duration *= timescale;
      var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
      var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
      var bytes = new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
      timescale >> 24 & 0xFF, timescale >> 16 & 0xFF, timescale >> 8 & 0xFF, timescale & 0xFF, // timescale
      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x00, 0x01, 0x00, 0x00, // 1.0 rate
      0x01, 0x00, // 1.0 volume
      0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
      0xff, 0xff, 0xff, 0xff // next_track_ID
      ]);
      return MP4.box(MP4.types.mvhd, bytes);
    }
  }, {
    key: 'sdtp',
    value: function sdtp(track) {
      var samples = track.samples || [],
          bytes = new Uint8Array(4 + samples.length),
          flags,
          i;
      // leave the full box header (4 bytes) all zero
      // write the sample table
      for (i = 0; i < samples.length; i++) {
        flags = samples[i].flags;
        bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
      }

      return MP4.box(MP4.types.sdtp, bytes);
    }
  }, {
    key: 'stbl',
    value: function stbl(track) {
      return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
    }
  }, {
    key: 'avc1',
    value: function avc1(track) {
      var sps = [],
          pps = [],
          i,
          data,
          len;
      // assemble the SPSs

      for (i = 0; i < track.sps.length; i++) {
        data = track.sps[i];
        len = data.byteLength;
        sps.push(len >>> 8 & 0xFF);
        sps.push(len & 0xFF);
        sps = sps.concat(Array.prototype.slice.call(data)); // SPS
      }

      // assemble the PPSs
      for (i = 0; i < track.pps.length; i++) {
        data = track.pps[i];
        len = data.byteLength;
        pps.push(len >>> 8 & 0xFF);
        pps.push(len & 0xFF);
        pps = pps.concat(Array.prototype.slice.call(data));
      }

      var avcc = MP4.box(MP4.types.avcC, new Uint8Array([0x01, // version
      sps[3], // profile
      sps[4], // profile compat
      sps[5], // level
      0xfc | 3, // lengthSizeMinusOne, hard-coded to 4 bytes
      0xE0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
      ].concat(sps).concat([track.pps.length // numOfPictureParameterSets
      ]).concat(pps))),
          // "PPS"
      width = track.width,
          height = track.height,
          hSpacing = track.pixelRatio[0],
          vSpacing = track.pixelRatio[1];
      //console.log('avcc:' + Hex.hexDump(avcc));
      return MP4.box(MP4.types.avc1, new Uint8Array([0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // data_reference_index
      0x00, 0x00, // pre_defined
      0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
      width >> 8 & 0xFF, width & 0xff, // width
      height >> 8 & 0xFF, height & 0xff, // height
      0x00, 0x48, 0x00, 0x00, // horizresolution
      0x00, 0x48, 0x00, 0x00, // vertresolution
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // frame_count
      0x12, 0x64, 0x61, 0x69, 0x6C, //dailymotion/hls.js
      0x79, 0x6D, 0x6F, 0x74, 0x69, 0x6F, 0x6E, 0x2F, 0x68, 0x6C, 0x73, 0x2E, 0x6A, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // compressorname
      0x00, 0x18, // depth = 24
      0x11, 0x11]), // pre_defined = -1
      avcc, MP4.box(MP4.types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80, // bufferSizeDB
      0x00, 0x2d, 0xc6, 0xc0, // maxBitrate
      0x00, 0x2d, 0xc6, 0xc0])), // avgBitrate
      MP4.box(MP4.types.pasp, new Uint8Array([hSpacing >> 24, // hSpacing
      hSpacing >> 16 & 0xFF, hSpacing >> 8 & 0xFF, hSpacing & 0xFF, vSpacing >> 24, // vSpacing
      vSpacing >> 16 & 0xFF, vSpacing >> 8 & 0xFF, vSpacing & 0xFF])));
    }
  }, {
    key: 'esds',
    value: function esds(track) {
      var configlen = track.config.length;
      return new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags

      0x03, // descriptor_type
      0x17 + configlen, // length
      0x00, 0x01, //es_id
      0x00, // stream_priority

      0x04, // descriptor_type
      0x0f + configlen, // length
      0x40, //codec : mpeg4_audio
      0x15, // stream_type
      0x00, 0x00, 0x00, // buffer_size
      0x00, 0x00, 0x00, 0x00, // maxBitrate
      0x00, 0x00, 0x00, 0x00, // avgBitrate

      0x05 // descriptor_type
      ].concat([configlen]).concat(track.config).concat([0x06, 0x01, 0x02])); // GASpecificConfig)); // length + audio config descriptor
    }
  }, {
    key: 'mp4a',
    value: function mp4a(track) {
      var samplerate = track.samplerate;
      return MP4.box(MP4.types.mp4a, new Uint8Array([0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // data_reference_index
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
      0x00, track.channelCount, // channelcount
      0x00, 0x10, // sampleSize:16bits
      0x00, 0x00, 0x00, 0x00, // reserved2
      samplerate >> 8 & 0xFF, samplerate & 0xff, //
      0x00, 0x00]), MP4.box(MP4.types.esds, MP4.esds(track)));
    }
  }, {
    key: 'mp3',
    value: function mp3(track) {
      var samplerate = track.samplerate;
      return MP4.box(MP4.types['.mp3'], new Uint8Array([0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // data_reference_index
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
      0x00, track.channelCount, // channelcount
      0x00, 0x10, // sampleSize:16bits
      0x00, 0x00, 0x00, 0x00, // reserved2
      samplerate >> 8 & 0xFF, samplerate & 0xff, //
      0x00, 0x00]));
    }
  }, {
    key: 'stsd',
    value: function stsd(track) {
      if (track.type === 'audio') {
        if (!track.isAAC && track.codec === 'mp3') {
          return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
        }
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
      } else {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
      }
    }
  }, {
    key: 'tkhd',
    value: function tkhd(track) {
      var id = track.id,
          duration = track.duration * track.timescale,
          width = track.width,
          height = track.height,
          upperWordDuration = Math.floor(duration / (UINT32_MAX + 1)),
          lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
      return MP4.box(MP4.types.tkhd, new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x07, // flags
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
      id >> 24 & 0xFF, id >> 16 & 0xFF, id >> 8 & 0xFF, id & 0xFF, // track_ID
      0x00, 0x00, 0x00, 0x00, // reserved
      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, // layer
      0x00, 0x00, // alternate_group
      0x00, 0x00, // non-audio track volume
      0x00, 0x00, // reserved
      0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
      width >> 8 & 0xFF, width & 0xFF, 0x00, 0x00, // width
      height >> 8 & 0xFF, height & 0xFF, 0x00, 0x00 // height
      ]));
    }
  }, {
    key: 'traf',
    value: function traf(track, baseMediaDecodeTime) {
      var sampleDependencyTable = MP4.sdtp(track),
          id = track.id,
          upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1)),
          lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
      return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      id >> 24, id >> 16 & 0XFF, id >> 8 & 0XFF, id & 0xFF]) // track_ID
      ), MP4.box(MP4.types.tfdt, new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x00, // flags
      upperWordBaseMediaDecodeTime >> 24, upperWordBaseMediaDecodeTime >> 16 & 0XFF, upperWordBaseMediaDecodeTime >> 8 & 0XFF, upperWordBaseMediaDecodeTime & 0xFF, lowerWordBaseMediaDecodeTime >> 24, lowerWordBaseMediaDecodeTime >> 16 & 0XFF, lowerWordBaseMediaDecodeTime >> 8 & 0XFF, lowerWordBaseMediaDecodeTime & 0xFF])), MP4.trun(track, sampleDependencyTable.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8), // mdat header
      sampleDependencyTable);
    }

    /**
     * Generate a track box.
     * @param track {object} a track definition
     * @return {Uint8Array} the track box
     */

  }, {
    key: 'trak',
    value: function trak(track) {
      track.duration = track.duration || 0xffffffff;
      return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
    }
  }, {
    key: 'trex',
    value: function trex(track) {
      var id = track.id;
      return MP4.box(MP4.types.trex, new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      id >> 24, id >> 16 & 0XFF, id >> 8 & 0XFF, id & 0xFF, // track_ID
      0x00, 0x00, 0x00, 0x01, // default_sample_description_index
      0x00, 0x00, 0x00, 0x00, // default_sample_duration
      0x00, 0x00, 0x00, 0x00, // default_sample_size
      0x00, 0x01, 0x00, 0x01 // default_sample_flags
      ]));
    }
  }, {
    key: 'trun',
    value: function trun(track, offset) {
      var samples = track.samples || [],
          len = samples.length,
          arraylen = 12 + 16 * len,
          array = new Uint8Array(arraylen),
          i,
          sample,
          duration,
          size,
          flags,
          cts;
      offset += 8 + arraylen;
      array.set([0x00, // version 0
      0x00, 0x0f, 0x01, // flags
      len >>> 24 & 0xFF, len >>> 16 & 0xFF, len >>> 8 & 0xFF, len & 0xFF, // sample_count
      offset >>> 24 & 0xFF, offset >>> 16 & 0xFF, offset >>> 8 & 0xFF, offset & 0xFF // data_offset
      ], 0);
      for (i = 0; i < len; i++) {
        sample = samples[i];
        duration = sample.duration;
        size = sample.size;
        flags = sample.flags;
        cts = sample.cts;
        array.set([duration >>> 24 & 0xFF, duration >>> 16 & 0xFF, duration >>> 8 & 0xFF, duration & 0xFF, // sample_duration
        size >>> 24 & 0xFF, size >>> 16 & 0xFF, size >>> 8 & 0xFF, size & 0xFF, // sample_size
        flags.isLeading << 2 | flags.dependsOn, flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync, flags.degradPrio & 0xF0 << 8, flags.degradPrio & 0x0F, // sample_flags
        cts >>> 24 & 0xFF, cts >>> 16 & 0xFF, cts >>> 8 & 0xFF, cts & 0xFF // sample_composition_time_offset
        ], 12 + 16 * i);
      }
      return MP4.box(MP4.types.trun, array);
    }
  }, {
    key: 'initSegment',
    value: function initSegment(tracks) {
      if (!MP4.types) {
        MP4.init();
      }
      var movie = MP4.moov(tracks),
          result;
      result = new Uint8Array(MP4.FTYP.byteLength + movie.byteLength);
      result.set(MP4.FTYP);
      result.set(movie, MP4.FTYP.byteLength);
      return result;
    }
  }]);

  return MP4;
}();

exports.default = MP4;

},{}],45:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * fMP4 remuxer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _aac = _dereq_(36);

var _aac2 = _interopRequireDefault(_aac);

var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

var _logger = _dereq_(54);

var _mp4Generator = _dereq_(44);

var _mp4Generator2 = _interopRequireDefault(_mp4Generator);

var _errors = _dereq_(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// 10 seconds
var MAX_SILENT_FRAME_DURATION = 10 * 1000;

var MP4Remuxer = function () {
  function MP4Remuxer(observer, config, typeSupported, vendor) {
    _classCallCheck(this, MP4Remuxer);

    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    var userAgent = navigator.userAgent;
    this.isSafari = vendor && vendor.indexOf('Apple') > -1 && userAgent && !userAgent.match('CriOS');
    this.ISGenerated = false;
  }

  _createClass(MP4Remuxer, [{
    key: 'destroy',
    value: function destroy() {}
  }, {
    key: 'resetTimeStamp',
    value: function resetTimeStamp(defaultTimeStamp) {
      this._initPTS = this._initDTS = defaultTimeStamp;
    }
  }, {
    key: 'resetInitSegment',
    value: function resetInitSegment() {
      this.ISGenerated = false;
    }
  }, {
    key: 'remux',
    value: function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
      // generate Init Segment if needed
      if (!this.ISGenerated) {
        this.generateIS(audioTrack, videoTrack, timeOffset);
      } else {
        if (accurateTimeOffset) {
          // check timestamp consistency. it there is more than 10s gap between expected PTS/DTS, recompute initPTS/DTS
          var refPTS = this._initPTS;
          var ptsNormalize = this._PTSNormalize;
          var timeScale = audioTrack.inputTimeScale || videoTrack.inputTimeScale;
          var initPTS = Infinity,
              initDTS = Infinity;
          var samples = audioTrack.samples;
          if (samples.length) {
            initPTS = initDTS = ptsNormalize(samples[0].pts - timeScale * timeOffset, refPTS);
          }
          samples = videoTrack.samples;
          if (samples.length) {
            var sample = samples[0];
            initPTS = Math.min(initPTS, ptsNormalize(sample.pts - timeScale * timeOffset, refPTS));
            initDTS = Math.min(initDTS, ptsNormalize(sample.dts - timeScale * timeOffset, refPTS));
          }
          if (initPTS !== Infinity) {
            var initPTSDelta = refPTS - initPTS;
            if (Math.abs(initPTSDelta) > 10 * timeScale) {
              _logger.logger.warn('timestamp inconsistency, ' + (initPTSDelta / timeScale).toFixed(3) + 's delta against expected value: missing discontinuity ? reset initPTS/initDTS');
              this._initPTS = initPTS;
              this._initDTS = initDTS;
              this.observer.trigger(_events2.default.INIT_PTS_FOUND, { initPTS: initPTS });
            }
          }
        }
      }

      if (this.ISGenerated) {
        // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is
        // calculated in remuxAudio.
        //logger.log('nb AAC samples:' + audioTrack.samples.length);
        if (audioTrack.samples.length) {
          // if initSegment was generated without video samples, regenerate it again
          if (!audioTrack.timescale) {
            _logger.logger.warn('regenerate InitSegment as audio detected');
            this.generateIS(audioTrack, videoTrack, timeOffset);
          }
          var audioData = this.remuxAudio(audioTrack, timeOffset, contiguous, accurateTimeOffset);
          //logger.log('nb AVC samples:' + videoTrack.samples.length);
          if (videoTrack.samples.length) {
            var audioTrackLength = void 0;
            if (audioData) {
              audioTrackLength = audioData.endPTS - audioData.startPTS;
            }
            // if initSegment was generated without video samples, regenerate it again
            if (!videoTrack.timescale) {
              _logger.logger.warn('regenerate InitSegment as video detected');
              this.generateIS(audioTrack, videoTrack, timeOffset);
            }
            this.remuxVideo(videoTrack, timeOffset, contiguous, audioTrackLength, accurateTimeOffset);
          }
        } else {
          var videoData = void 0;
          //logger.log('nb AVC samples:' + videoTrack.samples.length);
          if (videoTrack.samples.length) {
            videoData = this.remuxVideo(videoTrack, timeOffset, contiguous, accurateTimeOffset);
          }
          if (videoData && audioTrack.codec) {
            this.remuxEmptyAudio(audioTrack, timeOffset, contiguous, videoData);
          }
        }
      }
      //logger.log('nb ID3 samples:' + audioTrack.samples.length);
      if (id3Track.samples.length) {
        this.remuxID3(id3Track, timeOffset);
      }
      //logger.log('nb ID3 samples:' + audioTrack.samples.length);
      if (textTrack.samples.length) {
        this.remuxText(textTrack, timeOffset);
      }
      //notify end of parsing
      this.observer.trigger(_events2.default.FRAG_PARSED);
    }
  }, {
    key: 'generateIS',
    value: function generateIS(audioTrack, videoTrack, timeOffset) {
      var observer = this.observer,
          audioSamples = audioTrack.samples,
          videoSamples = videoTrack.samples,
          typeSupported = this.typeSupported,
          container = 'audio/mp4',
          tracks = {},
          data = { tracks: tracks },
          computePTSDTS = this._initPTS === undefined,
          initPTS,
          initDTS;

      if (computePTSDTS) {
        initPTS = initDTS = Infinity;
      }
      if (audioTrack.config && audioSamples.length) {
        // let's use audio sampling rate as MP4 time scale.
        // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
        // using audio sampling rate here helps having an integer MP4 frame duration
        // this avoids potential rounding issue and AV sync issue
        audioTrack.timescale = audioTrack.samplerate;
        _logger.logger.log('audio sampling rate : ' + audioTrack.samplerate);
        if (!audioTrack.isAAC) {
          if (typeSupported.mpeg) {
            // Chrome and Safari
            container = 'audio/mpeg';
            audioTrack.codec = '';
          } else if (typeSupported.mp3) {
            // Firefox
            audioTrack.codec = 'mp3';
          }
        }
        tracks.audio = {
          container: container,
          codec: audioTrack.codec,
          initSegment: !audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : _mp4Generator2.default.initSegment([audioTrack]),
          metadata: {
            channelCount: audioTrack.channelCount
          }
        };
        if (computePTSDTS) {
          // remember first PTS of this demuxing context. for audio, PTS = DTS
          initPTS = initDTS = audioSamples[0].pts - audioTrack.inputTimeScale * timeOffset;
        }
      }

      if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
        // let's use input time scale as MP4 video timescale
        // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
        var inputTimeScale = videoTrack.inputTimeScale;
        videoTrack.timescale = inputTimeScale;
        tracks.video = {
          container: 'video/mp4',
          codec: videoTrack.codec,
          initSegment: _mp4Generator2.default.initSegment([videoTrack]),
          metadata: {
            width: videoTrack.width,
            height: videoTrack.height
          }
        };
        if (computePTSDTS) {
          initPTS = Math.min(initPTS, videoSamples[0].pts - inputTimeScale * timeOffset);
          initDTS = Math.min(initDTS, videoSamples[0].dts - inputTimeScale * timeOffset);
          this.observer.trigger(_events2.default.INIT_PTS_FOUND, { initPTS: initPTS });
        }
      }

      if (Object.keys(tracks).length) {
        observer.trigger(_events2.default.FRAG_PARSING_INIT_SEGMENT, data);
        this.ISGenerated = true;
        if (computePTSDTS) {
          this._initPTS = initPTS;
          this._initDTS = initDTS;
        }
      } else {
        observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_PARSING_ERROR, fatal: false, reason: 'no audio/video samples found' });
      }
    }
  }, {
    key: 'remuxVideo',
    value: function remuxVideo(track, timeOffset, contiguous, audioTrackLength, accurateTimeOffset) {
      var offset = 8,
          timeScale = track.timescale,
          mp4SampleDuration,
          mdat,
          moof,
          firstPTS,
          firstDTS,
          nextDTS,
          lastPTS,
          lastDTS,
          inputSamples = track.samples,
          outputSamples = [],
          nbSamples = inputSamples.length,
          ptsNormalize = this._PTSNormalize,
          initDTS = this._initDTS;

      // for (let i = 0; i < track.samples.length; i++) {
      //   let avcSample = track.samples[i];
      //   let units = avcSample.units;
      //   let unitsString = '';
      //   for (let j = 0; j < units.length ; j++) {
      //     unitsString += units[j].type + ',';
      //     if (units[j].data.length < 500) {
      //       unitsString += Hex.hexDump(units[j].data);
      //     }
      //   }
      //   logger.log(avcSample.pts + '/' + avcSample.dts + ',' + unitsString + avcSample.units.length);
      // }

      // if parsed fragment is contiguous with last one, let's use last DTS value as reference
      var nextAvcDts = this.nextAvcDts;

      var isSafari = this.isSafari;

      // Safari does not like overlapping DTS on consecutive fragments. let's use nextAvcDts to overcome this if fragments are consecutive
      if (isSafari) {
        // also consider consecutive fragments as being contiguous (even if a level switch occurs),
        // for sake of clarity:
        // consecutive fragments are frags with
        //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
        //  - less than 200 ms PTS gaps (timeScale/5)
        contiguous |= inputSamples.length && nextAvcDts && (accurateTimeOffset && Math.abs(timeOffset - nextAvcDts / timeScale) < 0.1 || Math.abs(inputSamples[0].pts - nextAvcDts - initDTS) < timeScale / 5);
      }

      if (!contiguous) {
        // if not contiguous, let's use target timeOffset
        nextAvcDts = timeOffset * timeScale;
      }

      // PTS is coded on 33bits, and can loop from -2^32 to 2^32
      // ptsNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
      inputSamples.forEach(function (sample) {
        sample.pts = ptsNormalize(sample.pts - initDTS, nextAvcDts);
        sample.dts = ptsNormalize(sample.dts - initDTS, nextAvcDts);
      });

      // sort video samples by DTS then PTS then demux id order
      inputSamples.sort(function (a, b) {
        var deltadts = a.dts - b.dts;
        var deltapts = a.pts - b.pts;
        return deltadts ? deltadts : deltapts ? deltapts : a.id - b.id;
      });

      // handle broken streams with PTS < DTS, tolerance up 200ms (18000 in 90kHz timescale)
      var PTSDTSshift = inputSamples.reduce(function (prev, curr) {
        return Math.max(Math.min(prev, curr.pts - curr.dts), -18000);
      }, 0);
      if (PTSDTSshift < 0) {
        _logger.logger.warn('PTS < DTS detected in video samples, shifting DTS by ' + Math.round(PTSDTSshift / 90) + ' ms to overcome this issue');
        for (var i = 0; i < inputSamples.length; i++) {
          inputSamples[i].dts += PTSDTSshift;
        }
      }

      // compute first DTS and last DTS, normalize them against reference value
      var sample = inputSamples[0];
      firstDTS = Math.max(sample.dts, 0);
      firstPTS = Math.max(sample.pts, 0);

      // check timestamp continuity accross consecutive fragments (this is to remove inter-fragment gap/hole)
      var delta = Math.round((firstDTS - nextAvcDts) / 90);
      // if fragment are contiguous, detect hole/overlapping between fragments
      if (contiguous) {
        if (delta) {
          if (delta > 1) {
            _logger.logger.log('AVC:' + delta + ' ms hole between fragments detected,filling it');
          } else if (delta < -1) {
            _logger.logger.log('AVC:' + -delta + ' ms overlapping between fragments detected');
          }
          // remove hole/gap : set DTS to next expected DTS
          firstDTS = nextAvcDts;
          inputSamples[0].dts = firstDTS;
          // offset PTS as well, ensure that PTS is smaller or equal than new DTS
          firstPTS = Math.max(firstPTS - delta, nextAvcDts);
          inputSamples[0].pts = firstPTS;
          _logger.logger.log('Video/PTS/DTS adjusted: ' + Math.round(firstPTS / 90) + '/' + Math.round(firstDTS / 90) + ',delta:' + delta + ' ms');
        }
      }
      nextDTS = firstDTS;

      // compute lastPTS/lastDTS
      sample = inputSamples[inputSamples.length - 1];
      lastDTS = Math.max(sample.dts, 0);
      lastPTS = Math.max(sample.pts, 0, lastDTS);

      // on Safari let's signal the same sample duration for all samples
      // sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
      // set this constant duration as being the avg delta between consecutive DTS.
      if (isSafari) {
        mp4SampleDuration = Math.round((lastDTS - firstDTS) / (inputSamples.length - 1));
      }

      var nbNalu = 0,
          naluLen = 0;
      for (var _i = 0; _i < nbSamples; _i++) {
        // compute total/avc sample length and nb of NAL units
        var _sample = inputSamples[_i],
            units = _sample.units,
            nbUnits = units.length,
            sampleLen = 0;
        for (var j = 0; j < nbUnits; j++) {
          sampleLen += units[j].data.length;
        }
        naluLen += sampleLen;
        nbNalu += nbUnits;
        _sample.length = sampleLen;

        // normalize PTS/DTS
        if (isSafari) {
          // sample DTS is computed using a constant decoding offset (mp4SampleDuration) between samples
          _sample.dts = firstDTS + _i * mp4SampleDuration;
        } else {
          // ensure sample monotonic DTS
          _sample.dts = Math.max(_sample.dts, firstDTS);
        }
        // ensure that computed value is greater or equal than sample DTS
        _sample.pts = Math.max(_sample.pts, _sample.dts);
      }

      /* concatenate the video data and construct the mdat in place
        (need 8 more bytes to fill length and mpdat type) */
      var mdatSize = naluLen + 4 * nbNalu + 8;
      try {
        mdat = new Uint8Array(mdatSize);
      } catch (err) {
        this.observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MUX_ERROR, details: _errors.ErrorDetails.REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: 'fail allocating video mdat ' + mdatSize });
        return;
      }
      var view = new DataView(mdat.buffer);
      view.setUint32(0, mdatSize);
      mdat.set(_mp4Generator2.default.types.mdat, 4);

      for (var _i2 = 0; _i2 < nbSamples; _i2++) {
        var avcSample = inputSamples[_i2],
            avcSampleUnits = avcSample.units,
            mp4SampleLength = 0,
            compositionTimeOffset = void 0;
        // convert NALU bitstream to MP4 format (prepend NALU with size field)
        for (var _j = 0, _nbUnits = avcSampleUnits.length; _j < _nbUnits; _j++) {
          var unit = avcSampleUnits[_j],
              unitData = unit.data,
              unitDataLen = unit.data.byteLength;
          view.setUint32(offset, unitDataLen);
          offset += 4;
          mdat.set(unitData, offset);
          offset += unitDataLen;
          mp4SampleLength += 4 + unitDataLen;
        }

        if (!isSafari) {
          // expected sample duration is the Decoding Timestamp diff of consecutive samples
          if (_i2 < nbSamples - 1) {
            mp4SampleDuration = inputSamples[_i2 + 1].dts - avcSample.dts;
          } else {
            var config = this.config,
                lastFrameDuration = avcSample.dts - inputSamples[_i2 > 0 ? _i2 - 1 : _i2].dts;
            if (config.stretchShortVideoTrack) {
              // In some cases, a segment's audio track duration may exceed the video track duration.
              // Since we've already remuxed audio, and we know how long the audio track is, we look to
              // see if the delta to the next segment is longer than the minimum of maxBufferHole and
              // maxSeekHole. If so, playback would potentially get stuck, so we artificially inflate
              // the duration of the last frame to minimize any potential gap between segments.
              var maxBufferHole = config.maxBufferHole,
                  maxSeekHole = config.maxSeekHole,
                  gapTolerance = Math.floor(Math.min(maxBufferHole, maxSeekHole) * timeScale),
                  deltaToFrameEnd = (audioTrackLength ? firstPTS + audioTrackLength * timeScale : this.nextAudioPts) - avcSample.pts;
              if (deltaToFrameEnd > gapTolerance) {
                // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                // frame overlap. maxBufferHole/maxSeekHole should be >> lastFrameDuration anyway.
                mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                if (mp4SampleDuration < 0) {
                  mp4SampleDuration = lastFrameDuration;
                }
                _logger.logger.log('It is approximately ' + deltaToFrameEnd / 90 + ' ms to the next segment; using duration ' + mp4SampleDuration / 90 + ' ms for the last video frame.');
              } else {
                mp4SampleDuration = lastFrameDuration;
              }
            } else {
              mp4SampleDuration = lastFrameDuration;
            }
          }
          compositionTimeOffset = Math.round(avcSample.pts - avcSample.dts);
        } else {
          compositionTimeOffset = Math.max(0, mp4SampleDuration * Math.round((avcSample.pts - avcSample.dts) / mp4SampleDuration));
        }

        //console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${avcSample.pts}/${avcSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(avcSample.pts/4294967296).toFixed(3)}');
        outputSamples.push({
          size: mp4SampleLength,
          // constant duration
          duration: mp4SampleDuration,
          cts: compositionTimeOffset,
          flags: {
            isLeading: 0,
            isDependedOn: 0,
            hasRedundancy: 0,
            degradPrio: 0,
            dependsOn: avcSample.key ? 2 : 1,
            isNonSync: avcSample.key ? 0 : 1
          }
        });
      }
      // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
      this.nextAvcDts = lastDTS + mp4SampleDuration;
      var dropped = track.dropped;
      track.len = 0;
      track.nbNalu = 0;
      track.dropped = 0;
      if (outputSamples.length && navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
        var flags = outputSamples[0].flags;
        // chrome workaround, mark first sample as being a Random Access Point to avoid sourcebuffer append issue
        // https://code.google.com/p/chromium/issues/detail?id=229412
        flags.dependsOn = 2;
        flags.isNonSync = 0;
      }
      track.samples = outputSamples;
      moof = _mp4Generator2.default.moof(track.sequenceNumber++, firstDTS, track);
      track.samples = [];

      var data = {
        data1: moof,
        data2: mdat,
        startPTS: firstPTS / timeScale,
        endPTS: (lastPTS + mp4SampleDuration) / timeScale,
        startDTS: firstDTS / timeScale,
        endDTS: this.nextAvcDts / timeScale,
        type: 'video',
        nb: outputSamples.length,
        dropped: dropped
      };
      this.observer.trigger(_events2.default.FRAG_PARSING_DATA, data);
      return data;
    }
  }, {
    key: 'remuxAudio',
    value: function remuxAudio(track, timeOffset, contiguous, accurateTimeOffset) {
      var inputTimeScale = track.inputTimeScale,
          mp4timeScale = track.timescale,
          scaleFactor = inputTimeScale / mp4timeScale,
          mp4SampleDuration = track.isAAC ? 1024 : 1152,
          inputSampleDuration = mp4SampleDuration * scaleFactor,
          ptsNormalize = this._PTSNormalize,
          initDTS = this._initDTS,
          rawMPEG = !track.isAAC && this.typeSupported.mpeg;

      var offset,
          mp4Sample,
          fillFrame,
          mdat,
          moof,
          firstPTS,
          lastPTS,
          inputSamples = track.samples,
          outputSamples = [],
          nextAudioPts = this.nextAudioPts;

      // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
      // for sake of clarity:
      // consecutive fragments are frags with
      //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
      //  - less than 20 audio frames distance
      // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
      // this helps ensuring audio continuity
      // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
      contiguous |= inputSamples.length && nextAudioPts && (accurateTimeOffset && Math.abs(timeOffset - nextAudioPts / inputTimeScale) < 0.1 || Math.abs(inputSamples[0].pts - nextAudioPts - initDTS) < 20 * inputSampleDuration);

      if (!contiguous) {
        // if fragments are not contiguous, let's use timeOffset to compute next Audio PTS
        nextAudioPts = timeOffset * inputTimeScale;
      }

      // compute normalized PTS
      inputSamples.forEach(function (sample) {
        sample.pts = sample.dts = ptsNormalize(sample.pts - initDTS, nextAudioPts);
      });

      // sort based on normalized PTS (this is to avoid sorting issues in case timestamp
      // reloop in the middle of our samples array)
      inputSamples.sort(function (a, b) {
        return a.pts - b.pts;
      });

      // If the audio track is missing samples, the frames seem to get "left-shifted" within the
      // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
      // In an effort to prevent this from happening, we inject frames here where there are gaps.
      // When possible, we inject a silent frame; when that's not possible, we duplicate the last
      // frame.

      // only inject/drop audio frames in case time offset is accurate
      if (accurateTimeOffset && track.isAAC) {
        for (var i = 0, nextPts = nextAudioPts; i < inputSamples.length;) {
          // First, let's see how far off this frame is from where we expect it to be
          var sample = inputSamples[i],
              delta;
          var pts = sample.pts;
          delta = pts - nextPts;

          var duration = Math.abs(1000 * delta / inputTimeScale);

          // If we're overlapping by more than a duration, drop this sample
          if (delta <= -inputSampleDuration) {
            _logger.logger.warn('Dropping 1 audio frame @ ' + (nextPts / inputTimeScale).toFixed(3) + 's due to ' + duration + ' ms overlap.');
            inputSamples.splice(i, 1);
            track.len -= sample.unit.length;
            // Don't touch nextPtsNorm or i
          }

          // Insert missing frames if:
          // 1: We're more than one frame away
          // 2: Not more than MAX_SILENT_FRAME_DURATION away
          // 3: currentTime (aka nextPtsNorm) is not 0
          else if (delta >= inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && nextPts) {
              var missing = Math.round(delta / inputSampleDuration);
              _logger.logger.warn('Injecting ' + missing + ' audio frame @ ' + (nextPts / inputTimeScale).toFixed(3) + 's due to ' + Math.round(1000 * delta / inputTimeScale) + ' ms gap.');
              for (var j = 0; j < missing; j++) {
                var newStamp = Math.max(nextPts, 0);
                fillFrame = _aac2.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                if (!fillFrame) {
                  _logger.logger.log('Unable to get silent frame for given audio codec; duplicating last frame instead.');
                  fillFrame = sample.unit.subarray();
                }
                inputSamples.splice(i, 0, { unit: fillFrame, pts: newStamp, dts: newStamp });
                track.len += fillFrame.length;
                nextPts += inputSampleDuration;
                i++;
              }

              // Adjust sample to next expected pts
              sample.pts = sample.dts = nextPts;
              nextPts += inputSampleDuration;
              i++;
            } else {
              // Otherwise, just adjust pts
              if (Math.abs(delta) > 0.1 * inputSampleDuration) {
                //logger.log(`Invalid frame delta ${Math.round(delta + inputSampleDuration)} at PTS ${Math.round(pts / 90)} (should be ${Math.round(inputSampleDuration)}).`);
              }
              sample.pts = sample.dts = nextPts;
              nextPts += inputSampleDuration;
              i++;
            }
        }
      }

      for (var _j2 = 0, _nbSamples = inputSamples.length; _j2 < _nbSamples; _j2++) {
        var audioSample = inputSamples[_j2];
        var unit = audioSample.unit;
        var _pts = audioSample.pts;
        //logger.log(`Audio/PTS:${Math.round(pts/90)}`);
        // if not first sample
        if (lastPTS !== undefined) {
          mp4Sample.duration = Math.round((_pts - lastPTS) / scaleFactor);
        } else {
          var _delta = Math.round(1000 * (_pts - nextAudioPts) / inputTimeScale),
              numMissingFrames = 0;
          // if fragment are contiguous, detect hole/overlapping between fragments
          // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
          if (contiguous && track.isAAC) {
            // log delta
            if (_delta) {
              if (_delta > 0 && _delta < MAX_SILENT_FRAME_DURATION) {
                numMissingFrames = Math.round((_pts - nextAudioPts) / inputSampleDuration);
                _logger.logger.log(_delta + ' ms hole between AAC samples detected,filling it');
                if (numMissingFrames > 0) {
                  fillFrame = _aac2.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                  if (!fillFrame) {
                    fillFrame = unit.subarray();
                  }
                  track.len += numMissingFrames * fillFrame.length;
                }
                // if we have frame overlap, overlapping for more than half a frame duraion
              } else if (_delta < -12) {
                // drop overlapping audio frames... browser will deal with it
                _logger.logger.log('drop overlapping AAC sample, expected/parsed/delta:' + (nextAudioPts / inputTimeScale).toFixed(3) + 's/' + (_pts / inputTimeScale).toFixed(3) + 's/' + -_delta + 'ms');
                track.len -= unit.byteLength;
                continue;
              }
              // set PTS/DTS to expected PTS/DTS
              _pts = nextAudioPts;
            }
          }
          // remember first PTS of our audioSamples, ensure value is positive
          firstPTS = Math.max(0, _pts);
          if (track.len > 0) {
            /* concatenate the audio data and construct the mdat in place
              (need 8 more bytes to fill length and mdat type) */
            var mdatSize = rawMPEG ? track.len : track.len + 8;
            offset = rawMPEG ? 0 : 8;
            try {
              mdat = new Uint8Array(mdatSize);
            } catch (err) {
              this.observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MUX_ERROR, details: _errors.ErrorDetails.REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: 'fail allocating audio mdat ' + mdatSize });
              return;
            }
            if (!rawMPEG) {
              var view = new DataView(mdat.buffer);
              view.setUint32(0, mdatSize);
              mdat.set(_mp4Generator2.default.types.mdat, 4);
            }
          } else {
            // no audio samples
            return;
          }
          for (var _i3 = 0; _i3 < numMissingFrames; _i3++) {
            fillFrame = _aac2.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
            if (!fillFrame) {
              _logger.logger.log('Unable to get silent frame for given audio codec; duplicating this frame instead.');
              fillFrame = unit.subarray();
            }
            mdat.set(fillFrame, offset);
            offset += fillFrame.byteLength;
            mp4Sample = {
              size: fillFrame.byteLength,
              cts: 0,
              duration: 1024,
              flags: {
                isLeading: 0,
                isDependedOn: 0,
                hasRedundancy: 0,
                degradPrio: 0,
                dependsOn: 1
              }
            };
            outputSamples.push(mp4Sample);
          }
        }
        mdat.set(unit, offset);
        var unitLen = unit.byteLength;
        offset += unitLen;
        //console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${audioSample.pts}/${audioSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(audioSample.pts/4294967296).toFixed(3)}');
        mp4Sample = {
          size: unitLen,
          cts: 0,
          duration: 0,
          flags: {
            isLeading: 0,
            isDependedOn: 0,
            hasRedundancy: 0,
            degradPrio: 0,
            dependsOn: 1
          }
        };
        outputSamples.push(mp4Sample);
        lastPTS = _pts;
      }
      var lastSampleDuration = 0;
      var nbSamples = outputSamples.length;
      //set last sample duration as being identical to previous sample
      if (nbSamples >= 2) {
        lastSampleDuration = outputSamples[nbSamples - 2].duration;
        mp4Sample.duration = lastSampleDuration;
      }
      if (nbSamples) {
        // next audio sample PTS should be equal to last sample PTS + duration
        this.nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSampleDuration;
        //logger.log('Audio/PTS/PTSend:' + audioSample.pts.toFixed(0) + '/' + this.nextAacDts.toFixed(0));
        track.len = 0;
        track.samples = outputSamples;
        if (rawMPEG) {
          moof = new Uint8Array();
        } else {
          moof = _mp4Generator2.default.moof(track.sequenceNumber++, firstPTS / scaleFactor, track);
        }
        track.samples = [];
        var start = firstPTS / inputTimeScale;
        var end = nextAudioPts / inputTimeScale;
        var audioData = {
          data1: moof,
          data2: mdat,
          startPTS: start,
          endPTS: end,
          startDTS: start,
          endDTS: end,
          type: 'audio',
          nb: nbSamples
        };
        this.observer.trigger(_events2.default.FRAG_PARSING_DATA, audioData);
        return audioData;
      }
      return null;
    }
  }, {
    key: 'remuxEmptyAudio',
    value: function remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
      var inputTimeScale = track.inputTimeScale,
          mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale,
          scaleFactor = inputTimeScale / mp4timeScale,
          nextAudioPts = this.nextAudioPts,


      // sync with video's timestamp
      startDTS = (nextAudioPts !== undefined ? nextAudioPts : videoData.startDTS * inputTimeScale) + this._initDTS,
          endDTS = videoData.endDTS * inputTimeScale + this._initDTS,

      // one sample's duration value
      sampleDuration = 1024,
          frameDuration = scaleFactor * sampleDuration,


      // samples count of this segment's duration
      nbSamples = Math.ceil((endDTS - startDTS) / frameDuration),


      // silent frame
      silentFrame = _aac2.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);

      _logger.logger.warn('remux empty Audio');
      // Can't remux if we can't generate a silent frame...
      if (!silentFrame) {
        _logger.logger.trace('Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!');
        return;
      }

      var samples = [];
      for (var i = 0; i < nbSamples; i++) {
        var stamp = startDTS + i * frameDuration;
        samples.push({ unit: silentFrame, pts: stamp, dts: stamp });
        track.len += silentFrame.length;
      }
      track.samples = samples;

      this.remuxAudio(track, timeOffset, contiguous);
    }
  }, {
    key: 'remuxID3',
    value: function remuxID3(track, timeOffset) {
      var length = track.samples.length,
          sample;
      var inputTimeScale = track.inputTimeScale;
      var initPTS = this._initPTS;
      var initDTS = this._initDTS;
      // consume samples
      if (length) {
        for (var index = 0; index < length; index++) {
          sample = track.samples[index];
          // setting id3 pts, dts to relative time
          // using this._initPTS and this._initDTS to calculate relative time
          sample.pts = (sample.pts - initPTS) / inputTimeScale;
          sample.dts = (sample.dts - initDTS) / inputTimeScale;
        }
        this.observer.trigger(_events2.default.FRAG_PARSING_METADATA, {
          samples: track.samples
        });
      }

      track.samples = [];
      timeOffset = timeOffset;
    }
  }, {
    key: 'remuxText',
    value: function remuxText(track, timeOffset) {
      track.samples.sort(function (a, b) {
        return a.pts - b.pts;
      });

      var length = track.samples.length,
          sample;
      var inputTimeScale = track.inputTimeScale;
      var initPTS = this._initPTS;
      // consume samples
      if (length) {
        for (var index = 0; index < length; index++) {
          sample = track.samples[index];
          // setting text pts, dts to relative time
          // using this._initPTS and this._initDTS to calculate relative time
          sample.pts = (sample.pts - initPTS) / inputTimeScale;
        }
        this.observer.trigger(_events2.default.FRAG_PARSING_USERDATA, {
          samples: track.samples
        });
      }

      track.samples = [];
      timeOffset = timeOffset;
    }
  }, {
    key: '_PTSNormalize',
    value: function _PTSNormalize(value, reference) {
      var offset;
      if (reference === undefined) {
        return value;
      }
      if (reference < value) {
        // - 2^33
        offset = -8589934592;
      } else {
        // + 2^33
        offset = 8589934592;
      }
      /* PTS is 33bit (from 0 to 2^33 -1)
        if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
        PTS looping occured. fill the gap */
      while (Math.abs(value - reference) > 4294967296) {
        value += offset;
      }
      return value;
    }
  }]);

  return MP4Remuxer;
}();

exports.default = MP4Remuxer;

},{"33":33,"35":35,"36":36,"44":44,"54":54}],46:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * passthrough remuxer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */


var _events = _dereq_(35);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PassThroughRemuxer = function () {
  function PassThroughRemuxer(observer) {
    _classCallCheck(this, PassThroughRemuxer);

    this.observer = observer;
  }

  _createClass(PassThroughRemuxer, [{
    key: 'destroy',
    value: function destroy() {}
  }, {
    key: 'resetTimeStamp',
    value: function resetTimeStamp() {}
  }, {
    key: 'resetInitSegment',
    value: function resetInitSegment() {}
  }, {
    key: 'remux',
    value: function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset, rawData) {
      var observer = this.observer;
      var streamType = '';
      if (audioTrack) {
        streamType += 'audio';
      }
      if (videoTrack) {
        streamType += 'video';
      }
      observer.trigger(_events2.default.FRAG_PARSING_DATA, {
        data1: rawData,
        startPTS: timeOffset,
        startDTS: timeOffset,
        type: streamType,
        nb: 1,
        dropped: 0
      });
      //notify end of parsing
      observer.trigger(_events2.default.FRAG_PARSED);
    }
  }]);

  return PassThroughRemuxer;
}();

exports.default = PassThroughRemuxer;

},{"35":35}],47:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
var ATTR_LIST_REGEX = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g;

// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js

var AttrList = function () {
  function AttrList(attrs) {
    _classCallCheck(this, AttrList);

    if (typeof attrs === 'string') {
      attrs = AttrList.parseAttrList(attrs);
    }
    for (var attr in attrs) {
      if (attrs.hasOwnProperty(attr)) {
        this[attr] = attrs[attr];
      }
    }
  }

  _createClass(AttrList, [{
    key: 'decimalInteger',
    value: function decimalInteger(attrName) {
      var intValue = parseInt(this[attrName], 10);
      if (intValue > Number.MAX_SAFE_INTEGER) {
        return Infinity;
      }
      return intValue;
    }
  }, {
    key: 'hexadecimalInteger',
    value: function hexadecimalInteger(attrName) {
      if (this[attrName]) {
        var stringValue = (this[attrName] || '0x').slice(2);
        stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;

        var value = new Uint8Array(stringValue.length / 2);
        for (var i = 0; i < stringValue.length / 2; i++) {
          value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
        }
        return value;
      } else {
        return null;
      }
    }
  }, {
    key: 'hexadecimalIntegerAsNumber',
    value: function hexadecimalIntegerAsNumber(attrName) {
      var intValue = parseInt(this[attrName], 16);
      if (intValue > Number.MAX_SAFE_INTEGER) {
        return Infinity;
      }
      return intValue;
    }
  }, {
    key: 'decimalFloatingPoint',
    value: function decimalFloatingPoint(attrName) {
      return parseFloat(this[attrName]);
    }
  }, {
    key: 'enumeratedString',
    value: function enumeratedString(attrName) {
      return this[attrName];
    }
  }, {
    key: 'decimalResolution',
    value: function decimalResolution(attrName) {
      var res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
      if (res === null) {
        return undefined;
      }
      return {
        width: parseInt(res[1], 10),
        height: parseInt(res[2], 10)
      };
    }
  }], [{
    key: 'parseAttrList',
    value: function parseAttrList(input) {
      var match,
          attrs = {};
      ATTR_LIST_REGEX.lastIndex = 0;
      while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
        var value = match[2],
            quote = '"';

        if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) {
          value = value.slice(1, -1);
        }
        attrs[match[1]] = value;
      }
      return attrs;
    }
  }]);

  return AttrList;
}();

exports.default = AttrList;

},{}],48:[function(_dereq_,module,exports){
"use strict";

var BinarySearch = {
    /**
     * Searches for an item in an array which matches a certain condition.
     * This requires the condition to only match one item in the array,
     * and for the array to be ordered.
     *
     * @param {Array} list The array to search.
     * @param {Function} comparisonFunction
     *      Called and provided a candidate item as the first argument.
     *      Should return:
     *          > -1 if the item should be located at a lower index than the provided item.
     *          > 1 if the item should be located at a higher index than the provided item.
     *          > 0 if the item is the item you're looking for.
     *
     * @return {*} The object if it is found or null otherwise.
     */
    search: function search(list, comparisonFunction) {
        var minIndex = 0;
        var maxIndex = list.length - 1;
        var currentIndex = null;
        var currentElement = null;

        while (minIndex <= maxIndex) {
            currentIndex = (minIndex + maxIndex) / 2 | 0;
            currentElement = list[currentIndex];

            var comparisonResult = comparisonFunction(currentElement);
            if (comparisonResult > 0) {
                minIndex = currentIndex + 1;
            } else if (comparisonResult < 0) {
                maxIndex = currentIndex - 1;
            } else {
                return currentElement;
            }
        }

        return null;
    }
};

module.exports = BinarySearch;

},{}],49:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */

var specialCea608CharsCodes = {
    0x2a: 0xe1, // lowercase a, acute accent
    0x5c: 0xe9, // lowercase e, acute accent
    0x5e: 0xed, // lowercase i, acute accent
    0x5f: 0xf3, // lowercase o, acute accent
    0x60: 0xfa, // lowercase u, acute accent
    0x7b: 0xe7, // lowercase c with cedilla
    0x7c: 0xf7, // division symbol
    0x7d: 0xd1, // uppercase N tilde
    0x7e: 0xf1, // lowercase n tilde
    0x7f: 0x2588, // Full block
    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
    0x80: 0xae, // Registered symbol (R)
    0x81: 0xb0, // degree sign
    0x82: 0xbd, // 1/2 symbol
    0x83: 0xbf, // Inverted (open) question mark
    0x84: 0x2122, // Trademark symbol (TM)
    0x85: 0xa2, // Cents symbol
    0x86: 0xa3, // Pounds sterling
    0x87: 0x266a, // Music 8'th note
    0x88: 0xe0, // lowercase a, grave accent
    0x89: 0x20, // transparent space (regular)
    0x8a: 0xe8, // lowercase e, grave accent
    0x8b: 0xe2, // lowercase a, circumflex accent
    0x8c: 0xea, // lowercase e, circumflex accent
    0x8d: 0xee, // lowercase i, circumflex accent
    0x8e: 0xf4, // lowercase o, circumflex accent
    0x8f: 0xfb, // lowercase u, circumflex accent
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
    0x90: 0xc1, // capital letter A with acute
    0x91: 0xc9, // capital letter E with acute
    0x92: 0xd3, // capital letter O with acute
    0x93: 0xda, // capital letter U with acute
    0x94: 0xdc, // capital letter U with diaresis
    0x95: 0xfc, // lowercase letter U with diaeresis
    0x96: 0x2018, // opening single quote
    0x97: 0xa1, // inverted exclamation mark
    0x98: 0x2a, // asterisk
    0x99: 0x2019, // closing single quote
    0x9a: 0x2501, // box drawings heavy horizontal
    0x9b: 0xa9, // copyright sign
    0x9c: 0x2120, // Service mark
    0x9d: 0x2022, // (round) bullet
    0x9e: 0x201c, // Left double quotation mark
    0x9f: 0x201d, // Right double quotation mark
    0xa0: 0xc0, // uppercase A, grave accent
    0xa1: 0xc2, // uppercase A, circumflex
    0xa2: 0xc7, // uppercase C with cedilla
    0xa3: 0xc8, // uppercase E, grave accent
    0xa4: 0xca, // uppercase E, circumflex
    0xa5: 0xcb, // capital letter E with diaresis
    0xa6: 0xeb, // lowercase letter e with diaresis
    0xa7: 0xce, // uppercase I, circumflex
    0xa8: 0xcf, // uppercase I, with diaresis
    0xa9: 0xef, // lowercase i, with diaresis
    0xaa: 0xd4, // uppercase O, circumflex
    0xab: 0xd9, // uppercase U, grave accent
    0xac: 0xf9, // lowercase u, grave accent
    0xad: 0xdb, // uppercase U, circumflex
    0xae: 0xab, // left-pointing double angle quotation mark
    0xaf: 0xbb, // right-pointing double angle quotation mark
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
    0xb0: 0xc3, // Uppercase A, tilde
    0xb1: 0xe3, // Lowercase a, tilde
    0xb2: 0xcd, // Uppercase I, acute accent
    0xb3: 0xcc, // Uppercase I, grave accent
    0xb4: 0xec, // Lowercase i, grave accent
    0xb5: 0xd2, // Uppercase O, grave accent
    0xb6: 0xf2, // Lowercase o, grave accent
    0xb7: 0xd5, // Uppercase O, tilde
    0xb8: 0xf5, // Lowercase o, tilde
    0xb9: 0x7b, // Open curly brace
    0xba: 0x7d, // Closing curly brace
    0xbb: 0x5c, // Backslash
    0xbc: 0x5e, // Caret
    0xbd: 0x5f, // Underscore
    0xbe: 0x7c, // Pipe (vertical line)
    0xbf: 0x223c, // Tilde operator
    0xc0: 0xc4, // Uppercase A, umlaut
    0xc1: 0xe4, // Lowercase A, umlaut
    0xc2: 0xd6, // Uppercase O, umlaut
    0xc3: 0xf6, // Lowercase o, umlaut
    0xc4: 0xdf, // Esszett (sharp S)
    0xc5: 0xa5, // Yen symbol
    0xc6: 0xa4, // Generic currency sign
    0xc7: 0x2503, // Box drawings heavy vertical
    0xc8: 0xc5, // Uppercase A, ring
    0xc9: 0xe5, // Lowercase A, ring
    0xca: 0xd8, // Uppercase O, stroke
    0xcb: 0xf8, // Lowercase o, strok
    0xcc: 0x250f, // Box drawings heavy down and right
    0xcd: 0x2513, // Box drawings heavy down and left
    0xce: 0x2517, // Box drawings heavy up and right
    0xcf: 0x251b // Box drawings heavy up and left
};

/**
 * Utils
 */
var getCharForByte = function getCharForByte(byte) {
    var charCode = byte;
    if (specialCea608CharsCodes.hasOwnProperty(byte)) {
        charCode = specialCea608CharsCodes[byte];
    }
    return String.fromCharCode(charCode);
};

var NR_ROWS = 15,
    NR_COLS = 100;
// Tables to look up row from PAC data
var rowsLowCh1 = { 0x11: 1, 0x12: 3, 0x15: 5, 0x16: 7, 0x17: 9, 0x10: 11, 0x13: 12, 0x14: 14 };
var rowsHighCh1 = { 0x11: 2, 0x12: 4, 0x15: 6, 0x16: 8, 0x17: 10, 0x13: 13, 0x14: 15 };
var rowsLowCh2 = { 0x19: 1, 0x1A: 3, 0x1D: 5, 0x1E: 7, 0x1F: 9, 0x18: 11, 0x1B: 12, 0x1C: 14 };
var rowsHighCh2 = { 0x19: 2, 0x1A: 4, 0x1D: 6, 0x1E: 8, 0x1F: 10, 0x1B: 13, 0x1C: 15 };

var backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];

/**
 * Simple logger class to be able to write with time-stamps and filter on level.
 */
var logger = {
    verboseFilter: { 'DATA': 3, 'DEBUG': 3, 'INFO': 2, 'WARNING': 2, 'TEXT': 1, 'ERROR': 0 },
    time: null,
    verboseLevel: 0, // Only write errors
    setTime: function setTime(newTime) {
        this.time = newTime;
    },
    log: function log(severity, msg) {
        var minLevel = this.verboseFilter[severity];
        if (this.verboseLevel >= minLevel) {
            console.log(this.time + ' [' + severity + '] ' + msg);
        }
    }
};

var numArrayToHexArray = function numArrayToHexArray(numArray) {
    var hexArray = [];
    for (var j = 0; j < numArray.length; j++) {
        hexArray.push(numArray[j].toString(16));
    }
    return hexArray;
};

var PenState = function () {
    function PenState(foreground, underline, italics, background, flash) {
        _classCallCheck(this, PenState);

        this.foreground = foreground || 'white';
        this.underline = underline || false;
        this.italics = italics || false;
        this.background = background || 'black';
        this.flash = flash || false;
    }

    _createClass(PenState, [{
        key: 'reset',
        value: function reset() {
            this.foreground = 'white';
            this.underline = false;
            this.italics = false;
            this.background = 'black';
            this.flash = false;
        }
    }, {
        key: 'setStyles',
        value: function setStyles(styles) {
            var attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
            for (var i = 0; i < attribs.length; i++) {
                var style = attribs[i];
                if (styles.hasOwnProperty(style)) {
                    this[style] = styles[style];
                }
            }
        }
    }, {
        key: 'isDefault',
        value: function isDefault() {
            return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
        }
    }, {
        key: 'equals',
        value: function equals(other) {
            return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
        }
    }, {
        key: 'copy',
        value: function copy(newPenState) {
            this.foreground = newPenState.foreground;
            this.underline = newPenState.underline;
            this.italics = newPenState.italics;
            this.background = newPenState.background;
            this.flash = newPenState.flash;
        }
    }, {
        key: 'toString',
        value: function toString() {
            return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
        }
    }]);

    return PenState;
}();

/**
 * Unicode character with styling and background.
 * @constructor
 */


var StyledUnicodeChar = function () {
    function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
        _classCallCheck(this, StyledUnicodeChar);

        this.uchar = uchar || ' '; // unicode character
        this.penState = new PenState(foreground, underline, italics, background, flash);
    }

    _createClass(StyledUnicodeChar, [{
        key: 'reset',
        value: function reset() {
            this.uchar = ' ';
            this.penState.reset();
        }
    }, {
        key: 'setChar',
        value: function setChar(uchar, newPenState) {
            this.uchar = uchar;
            this.penState.copy(newPenState);
        }
    }, {
        key: 'setPenState',
        value: function setPenState(newPenState) {
            this.penState.copy(newPenState);
        }
    }, {
        key: 'equals',
        value: function equals(other) {
            return this.uchar === other.uchar && this.penState.equals(other.penState);
        }
    }, {
        key: 'copy',
        value: function copy(newChar) {
            this.uchar = newChar.uchar;
            this.penState.copy(newChar.penState);
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            return this.uchar === ' ' && this.penState.isDefault();
        }
    }]);

    return StyledUnicodeChar;
}();

/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */


var Row = function () {
    function Row() {
        _classCallCheck(this, Row);

        this.chars = [];
        for (var i = 0; i < NR_COLS; i++) {
            this.chars.push(new StyledUnicodeChar());
        }
        this.pos = 0;
        this.currPenState = new PenState();
    }

    _createClass(Row, [{
        key: 'equals',
        value: function equals(other) {
            var equal = true;
            for (var i = 0; i < NR_COLS; i++) {
                if (!this.chars[i].equals(other.chars[i])) {
                    equal = false;
                    break;
                }
            }
            return equal;
        }
    }, {
        key: 'copy',
        value: function copy(other) {
            for (var i = 0; i < NR_COLS; i++) {
                this.chars[i].copy(other.chars[i]);
            }
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            var empty = true;
            for (var i = 0; i < NR_COLS; i++) {
                if (!this.chars[i].isEmpty()) {
                    empty = false;
                    break;
                }
            }
            return empty;
        }

        /**
         *  Set the cursor to a valid column.
         */

    }, {
        key: 'setCursor',
        value: function setCursor(absPos) {
            if (this.pos !== absPos) {
                this.pos = absPos;
            }
            if (this.pos < 0) {
                logger.log('ERROR', 'Negative cursor position ' + this.pos);
                this.pos = 0;
            } else if (this.pos > NR_COLS) {
                logger.log('ERROR', 'Too large cursor position ' + this.pos);
                this.pos = NR_COLS;
            }
        }

        /**
         * Move the cursor relative to current position.
         */

    }, {
        key: 'moveCursor',
        value: function moveCursor(relPos) {
            var newPos = this.pos + relPos;
            if (relPos > 1) {
                for (var i = this.pos + 1; i < newPos + 1; i++) {
                    this.chars[i].setPenState(this.currPenState);
                }
            }
            this.setCursor(newPos);
        }

        /**
         * Backspace, move one step back and clear character.
         */

    }, {
        key: 'backSpace',
        value: function backSpace() {
            this.moveCursor(-1);
            this.chars[this.pos].setChar(' ', this.currPenState);
        }
    }, {
        key: 'insertChar',
        value: function insertChar(byte) {
            if (byte >= 0x90) {
                //Extended char
                this.backSpace();
            }
            var char = getCharForByte(byte);
            if (this.pos >= NR_COLS) {
                logger.log('ERROR', 'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
                return;
            }
            this.chars[this.pos].setChar(char, this.currPenState);
            this.moveCursor(1);
        }
    }, {
        key: 'clearFromPos',
        value: function clearFromPos(startPos) {
            var i;
            for (i = startPos; i < NR_COLS; i++) {
                this.chars[i].reset();
            }
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.clearFromPos(0);
            this.pos = 0;
            this.currPenState.reset();
        }
    }, {
        key: 'clearToEndOfRow',
        value: function clearToEndOfRow() {
            this.clearFromPos(this.pos);
        }
    }, {
        key: 'getTextString',
        value: function getTextString() {
            var chars = [];
            var empty = true;
            for (var i = 0; i < NR_COLS; i++) {
                var char = this.chars[i].uchar;
                if (char !== ' ') {
                    empty = false;
                }
                chars.push(char);
            }
            if (empty) {
                return '';
            } else {
                return chars.join('');
            }
        }
    }, {
        key: 'setPenStyles',
        value: function setPenStyles(styles) {
            this.currPenState.setStyles(styles);
            var currChar = this.chars[this.pos];
            currChar.setPenState(this.currPenState);
        }
    }]);

    return Row;
}();

/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
*/


var CaptionScreen = function () {
    function CaptionScreen() {
        _classCallCheck(this, CaptionScreen);

        this.rows = [];
        for (var i = 0; i < NR_ROWS; i++) {
            this.rows.push(new Row()); // Note that we use zero-based numbering (0-14)
        }
        this.currRow = NR_ROWS - 1;
        this.nrRollUpRows = null;
        this.reset();
    }

    _createClass(CaptionScreen, [{
        key: 'reset',
        value: function reset() {
            for (var i = 0; i < NR_ROWS; i++) {
                this.rows[i].clear();
            }
            this.currRow = NR_ROWS - 1;
        }
    }, {
        key: 'equals',
        value: function equals(other) {
            var equal = true;
            for (var i = 0; i < NR_ROWS; i++) {
                if (!this.rows[i].equals(other.rows[i])) {
                    equal = false;
                    break;
                }
            }
            return equal;
        }
    }, {
        key: 'copy',
        value: function copy(other) {
            for (var i = 0; i < NR_ROWS; i++) {
                this.rows[i].copy(other.rows[i]);
            }
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            var empty = true;
            for (var i = 0; i < NR_ROWS; i++) {
                if (!this.rows[i].isEmpty()) {
                    empty = false;
                    break;
                }
            }
            return empty;
        }
    }, {
        key: 'backSpace',
        value: function backSpace() {
            var row = this.rows[this.currRow];
            row.backSpace();
        }
    }, {
        key: 'clearToEndOfRow',
        value: function clearToEndOfRow() {
            var row = this.rows[this.currRow];
            row.clearToEndOfRow();
        }

        /**
         * Insert a character (without styling) in the current row.
         */

    }, {
        key: 'insertChar',
        value: function insertChar(char) {
            var row = this.rows[this.currRow];
            row.insertChar(char);
        }
    }, {
        key: 'setPen',
        value: function setPen(styles) {
            var row = this.rows[this.currRow];
            row.setPenStyles(styles);
        }
    }, {
        key: 'moveCursor',
        value: function moveCursor(relPos) {
            var row = this.rows[this.currRow];
            row.moveCursor(relPos);
        }
    }, {
        key: 'setCursor',
        value: function setCursor(absPos) {
            logger.log('INFO', 'setCursor: ' + absPos);
            var row = this.rows[this.currRow];
            row.setCursor(absPos);
        }
    }, {
        key: 'setPAC',
        value: function setPAC(pacData) {
            logger.log('INFO', 'pacData = ' + JSON.stringify(pacData));
            var newRow = pacData.row - 1;
            if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
                newRow = this.nrRollUpRows - 1;
            }

            //Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
            if (this.nrRollUpRows && this.currRow !== newRow) {
                //clear all rows first
                for (var i = 0; i < NR_ROWS; i++) {
                    this.rows[i].clear();
                }

                //Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
                //topRowIndex - the start of rows to copy (inclusive index)
                var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
                //We only copy if the last position was already shown.
                //We use the cueStartTime value to check this.
                var lastOutputScreen = this.lastOutputScreen;
                if (lastOutputScreen) {
                    var prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
                    if (prevLineTime && prevLineTime < logger.time) {
                        for (var _i = 0; _i < this.nrRollUpRows; _i++) {
                            this.rows[newRow - this.nrRollUpRows + _i + 1].copy(lastOutputScreen.rows[topRowIndex + _i]);
                        }
                    }
                }
            }

            this.currRow = newRow;
            var row = this.rows[this.currRow];
            if (pacData.indent !== null) {
                var indent = pacData.indent;
                var prevPos = Math.max(indent - 1, 0);
                row.setCursor(pacData.indent);
                pacData.color = row.chars[prevPos].penState.foreground;
            }
            var styles = { foreground: pacData.color, underline: pacData.underline, italics: pacData.italics, background: 'black', flash: false };
            this.setPen(styles);
        }

        /**
         * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
         */

    }, {
        key: 'setBkgData',
        value: function setBkgData(bkgData) {

            logger.log('INFO', 'bkgData = ' + JSON.stringify(bkgData));
            this.backSpace();
            this.setPen(bkgData);
            this.insertChar(0x20); //Space
        }
    }, {
        key: 'setRollUpRows',
        value: function setRollUpRows(nrRows) {
            this.nrRollUpRows = nrRows;
        }
    }, {
        key: 'rollUp',
        value: function rollUp() {
            if (this.nrRollUpRows === null) {
                logger.log('DEBUG', 'roll_up but nrRollUpRows not set yet');
                return; //Not properly setup
            }
            logger.log('TEXT', this.getDisplayText());
            var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
            var topRow = this.rows.splice(topRowIndex, 1)[0];
            topRow.clear();
            this.rows.splice(this.currRow, 0, topRow);
            logger.log('INFO', 'Rolling up');
            //logger.log('TEXT', this.get_display_text())
        }

        /**
         * Get all non-empty rows with as unicode text.
         */

    }, {
        key: 'getDisplayText',
        value: function getDisplayText(asOneRow) {
            asOneRow = asOneRow || false;
            var displayText = [];
            var text = '';
            var rowNr = -1;
            for (var i = 0; i < NR_ROWS; i++) {
                var rowText = this.rows[i].getTextString();
                if (rowText) {
                    rowNr = i + 1;
                    if (asOneRow) {
                        displayText.push('Row ' + rowNr + ': \'' + rowText + '\'');
                    } else {
                        displayText.push(rowText.trim());
                    }
                }
            }
            if (displayText.length > 0) {
                if (asOneRow) {
                    text = '[' + displayText.join(' | ') + ']';
                } else {
                    text = displayText.join('\n');
                }
            }
            return text;
        }
    }, {
        key: 'getTextAndFormat',
        value: function getTextAndFormat() {
            return this.rows;
        }
    }]);

    return CaptionScreen;
}();

//var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];

var Cea608Channel = function () {
    function Cea608Channel(channelNumber, outputFilter) {
        _classCallCheck(this, Cea608Channel);

        this.chNr = channelNumber;
        this.outputFilter = outputFilter;
        this.mode = null;
        this.verbose = 0;
        this.displayedMemory = new CaptionScreen();
        this.nonDisplayedMemory = new CaptionScreen();
        this.lastOutputScreen = new CaptionScreen();
        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null; // Keeps track of where a cue started.
    }

    _createClass(Cea608Channel, [{
        key: 'reset',
        value: function reset() {
            this.mode = null;
            this.displayedMemory.reset();
            this.nonDisplayedMemory.reset();
            this.lastOutputScreen.reset();
            this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
            this.writeScreen = this.displayedMemory;
            this.mode = null;
            this.cueStartTime = null;
            this.lastCueEndTime = null;
        }
    }, {
        key: 'getHandler',
        value: function getHandler() {
            return this.outputFilter;
        }
    }, {
        key: 'setHandler',
        value: function setHandler(newHandler) {
            this.outputFilter = newHandler;
        }
    }, {
        key: 'setPAC',
        value: function setPAC(pacData) {
            this.writeScreen.setPAC(pacData);
        }
    }, {
        key: 'setBkgData',
        value: function setBkgData(bkgData) {
            this.writeScreen.setBkgData(bkgData);
        }
    }, {
        key: 'setMode',
        value: function setMode(newMode) {
            if (newMode === this.mode) {
                return;
            }
            this.mode = newMode;
            logger.log('INFO', 'MODE=' + newMode);
            if (this.mode === 'MODE_POP-ON') {
                this.writeScreen = this.nonDisplayedMemory;
            } else {
                this.writeScreen = this.displayedMemory;
                this.writeScreen.reset();
            }
            if (this.mode !== 'MODE_ROLL-UP') {
                this.displayedMemory.nrRollUpRows = null;
                this.nonDisplayedMemory.nrRollUpRows = null;
            }
            this.mode = newMode;
        }
    }, {
        key: 'insertChars',
        value: function insertChars(chars) {
            for (var i = 0; i < chars.length; i++) {
                this.writeScreen.insertChar(chars[i]);
            }
            var screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
            logger.log('INFO', screen + ': ' + this.writeScreen.getDisplayText(true));
            if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
                logger.log('TEXT', 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
                this.outputDataUpdate();
            }
        }
    }, {
        key: 'ccRCL',
        value: function ccRCL() {
            // Resume Caption Loading (switch mode to Pop On)
            logger.log('INFO', 'RCL - Resume Caption Loading');
            this.setMode('MODE_POP-ON');
        }
    }, {
        key: 'ccBS',
        value: function ccBS() {
            // BackSpace
            logger.log('INFO', 'BS - BackSpace');
            if (this.mode === 'MODE_TEXT') {
                return;
            }
            this.writeScreen.backSpace();
            if (this.writeScreen === this.displayedMemory) {
                this.outputDataUpdate();
            }
        }
    }, {
        key: 'ccAOF',
        value: function ccAOF() {
            // Reserved (formerly Alarm Off)
            return;
        }
    }, {
        key: 'ccAON',
        value: function ccAON() {
            // Reserved (formerly Alarm On)
            return;
        }
    }, {
        key: 'ccDER',
        value: function ccDER() {
            // Delete to End of Row
            logger.log('INFO', 'DER- Delete to End of Row');
            this.writeScreen.clearToEndOfRow();
            this.outputDataUpdate();
        }
    }, {
        key: 'ccRU',
        value: function ccRU(nrRows) {
            //Roll-Up Captions-2,3,or 4 Rows
            logger.log('INFO', 'RU(' + nrRows + ') - Roll Up');
            this.writeScreen = this.displayedMemory;
            this.setMode('MODE_ROLL-UP');
            this.writeScreen.setRollUpRows(nrRows);
        }
    }, {
        key: 'ccFON',
        value: function ccFON() {
            //Flash On
            logger.log('INFO', 'FON - Flash On');
            this.writeScreen.setPen({ flash: true });
        }
    }, {
        key: 'ccRDC',
        value: function ccRDC() {
            // Resume Direct Captioning (switch mode to PaintOn)
            logger.log('INFO', 'RDC - Resume Direct Captioning');
            this.setMode('MODE_PAINT-ON');
        }
    }, {
        key: 'ccTR',
        value: function ccTR() {
            // Text Restart in text mode (not supported, however)
            logger.log('INFO', 'TR');
            this.setMode('MODE_TEXT');
        }
    }, {
        key: 'ccRTD',
        value: function ccRTD() {
            // Resume Text Display in Text mode (not supported, however)
            logger.log('INFO', 'RTD');
            this.setMode('MODE_TEXT');
        }
    }, {
        key: 'ccEDM',
        value: function ccEDM() {
            // Erase Displayed Memory
            logger.log('INFO', 'EDM - Erase Displayed Memory');
            this.displayedMemory.reset();
            this.outputDataUpdate();
        }
    }, {
        key: 'ccCR',
        value: function ccCR() {
            // Carriage Return
            logger.log('CR - Carriage Return');
            this.writeScreen.rollUp();
            this.outputDataUpdate();
        }
    }, {
        key: 'ccENM',
        value: function ccENM() {
            //Erase Non-Displayed Memory
            logger.log('INFO', 'ENM - Erase Non-displayed Memory');
            this.nonDisplayedMemory.reset();
        }
    }, {
        key: 'ccEOC',
        value: function ccEOC() {
            //End of Caption (Flip Memories)
            logger.log('INFO', 'EOC - End Of Caption');
            if (this.mode === 'MODE_POP-ON') {
                var tmp = this.displayedMemory;
                this.displayedMemory = this.nonDisplayedMemory;
                this.nonDisplayedMemory = tmp;
                this.writeScreen = this.nonDisplayedMemory;
                logger.log('TEXT', 'DISP: ' + this.displayedMemory.getDisplayText());
            }
            this.outputDataUpdate();
        }
    }, {
        key: 'ccTO',
        value: function ccTO(nrCols) {
            // Tab Offset 1,2, or 3 columns
            logger.log('INFO', 'TO(' + nrCols + ') - Tab Offset');
            this.writeScreen.moveCursor(nrCols);
        }
    }, {
        key: 'ccMIDROW',
        value: function ccMIDROW(secondByte) {
            // Parse MIDROW command
            var styles = { flash: false };
            styles.underline = secondByte % 2 === 1;
            styles.italics = secondByte >= 0x2e;
            if (!styles.italics) {
                var colorIndex = Math.floor(secondByte / 2) - 0x10;
                var colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
                styles.foreground = colors[colorIndex];
            } else {
                styles.foreground = 'white';
            }
            logger.log('INFO', 'MIDROW: ' + JSON.stringify(styles));
            this.writeScreen.setPen(styles);
        }
    }, {
        key: 'outputDataUpdate',
        value: function outputDataUpdate() {
            var t = logger.time;
            if (t === null) {
                return;
            }
            if (this.outputFilter) {
                if (this.outputFilter.updateData) {
                    this.outputFilter.updateData(t, this.displayedMemory);
                }
                if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
                    // Start of a new cue
                    this.cueStartTime = t;
                } else {
                    if (!this.displayedMemory.equals(this.lastOutputScreen)) {
                        if (this.outputFilter.newCue) {
                            this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen);
                        }
                        this.cueStartTime = this.displayedMemory.isEmpty() ? null : t;
                    }
                }
                this.lastOutputScreen.copy(this.displayedMemory);
            }
        }
    }, {
        key: 'cueSplitAtTime',
        value: function cueSplitAtTime(t) {
            if (this.outputFilter) {
                if (!this.displayedMemory.isEmpty()) {
                    if (this.outputFilter.newCue) {
                        this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
                    }
                    this.cueStartTime = t;
                }
            }
        }
    }]);

    return Cea608Channel;
}();

var Cea608Parser = function () {
    function Cea608Parser(field, out1, out2) {
        _classCallCheck(this, Cea608Parser);

        this.field = field || 1;
        this.outputs = [out1, out2];
        this.channels = [new Cea608Channel(1, out1), new Cea608Channel(2, out2)];
        this.currChNr = -1; // Will be 1 or 2
        this.lastCmdA = null; // First byte of last command
        this.lastCmdB = null; // Second byte of last command
        this.bufferedData = [];
        this.startTime = null;
        this.lastTime = null;
        this.dataCounters = { 'padding': 0, 'char': 0, 'cmd': 0, 'other': 0 };
    }

    _createClass(Cea608Parser, [{
        key: 'getHandler',
        value: function getHandler(index) {
            return this.channels[index].getHandler();
        }
    }, {
        key: 'setHandler',
        value: function setHandler(index, newHandler) {
            this.channels[index].setHandler(newHandler);
        }

        /**
         * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
         */

    }, {
        key: 'addData',
        value: function addData(t, byteList) {
            var cmdFound,
                a,
                b,
                charsFound = false;

            this.lastTime = t;
            logger.setTime(t);

            for (var i = 0; i < byteList.length; i += 2) {
                a = byteList[i] & 0x7f;
                b = byteList[i + 1] & 0x7f;
                if (a === 0 && b === 0) {
                    this.dataCounters.padding += 2;
                    continue;
                } else {
                    logger.log('DATA', '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
                }
                cmdFound = this.parseCmd(a, b);
                if (!cmdFound) {
                    cmdFound = this.parseMidrow(a, b);
                }
                if (!cmdFound) {
                    cmdFound = this.parsePAC(a, b);
                }
                if (!cmdFound) {
                    cmdFound = this.parseBackgroundAttributes(a, b);
                }
                if (!cmdFound) {
                    charsFound = this.parseChars(a, b);
                    if (charsFound) {
                        if (this.currChNr && this.currChNr >= 0) {
                            var channel = this.channels[this.currChNr - 1];
                            channel.insertChars(charsFound);
                        } else {
                            logger.log('WARNING', 'No channel found yet. TEXT-MODE?');
                        }
                    }
                }
                if (cmdFound) {
                    this.dataCounters.cmd += 2;
                } else if (charsFound) {
                    this.dataCounters.char += 2;
                } else {
                    this.dataCounters.other += 2;
                    logger.log('WARNING', 'Couldn\'t parse cleaned data ' + numArrayToHexArray([a, b]) + ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
                }
            }
        }

        /**
         * Parse Command.
         * @returns {Boolean} Tells if a command was found
         */

    }, {
        key: 'parseCmd',
        value: function parseCmd(a, b) {
            var chNr = null;

            var cond1 = (a === 0x14 || a === 0x1C) && 0x20 <= b && b <= 0x2F;
            var cond2 = (a === 0x17 || a === 0x1F) && 0x21 <= b && b <= 0x23;
            if (!(cond1 || cond2)) {
                return false;
            }

            if (a === this.lastCmdA && b === this.lastCmdB) {
                this.lastCmdA = null;
                this.lastCmdB = null; // Repeated commands are dropped (once)
                logger.log('DEBUG', 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
                return true;
            }

            if (a === 0x14 || a === 0x17) {
                chNr = 1;
            } else {
                chNr = 2; // (a === 0x1C || a=== 0x1f)
            }

            var channel = this.channels[chNr - 1];

            if (a === 0x14 || a === 0x1C) {
                if (b === 0x20) {
                    channel.ccRCL();
                } else if (b === 0x21) {
                    channel.ccBS();
                } else if (b === 0x22) {
                    channel.ccAOF();
                } else if (b === 0x23) {
                    channel.ccAON();
                } else if (b === 0x24) {
                    channel.ccDER();
                } else if (b === 0x25) {
                    channel.ccRU(2);
                } else if (b === 0x26) {
                    channel.ccRU(3);
                } else if (b === 0x27) {
                    channel.ccRU(4);
                } else if (b === 0x28) {
                    channel.ccFON();
                } else if (b === 0x29) {
                    channel.ccRDC();
                } else if (b === 0x2A) {
                    channel.ccTR();
                } else if (b === 0x2B) {
                    channel.ccRTD();
                } else if (b === 0x2C) {
                    channel.ccEDM();
                } else if (b === 0x2D) {
                    channel.ccCR();
                } else if (b === 0x2E) {
                    channel.ccENM();
                } else if (b === 0x2F) {
                    channel.ccEOC();
                }
            } else {
                //a == 0x17 || a == 0x1F
                channel.ccTO(b - 0x20);
            }
            this.lastCmdA = a;
            this.lastCmdB = b;
            this.currChNr = chNr;
            return true;
        }

        /**
         * Parse midrow styling command
         * @returns {Boolean}
         */

    }, {
        key: 'parseMidrow',
        value: function parseMidrow(a, b) {
            var chNr = null;

            if ((a === 0x11 || a === 0x19) && 0x20 <= b && b <= 0x2f) {
                if (a === 0x11) {
                    chNr = 1;
                } else {
                    chNr = 2;
                }
                if (chNr !== this.currChNr) {
                    logger.log('ERROR', 'Mismatch channel in midrow parsing');
                    return false;
                }
                var channel = this.channels[chNr - 1];
                channel.ccMIDROW(b);
                logger.log('DEBUG', 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
                return true;
            }
            return false;
        }
        /**
         * Parse Preable Access Codes (Table 53).
         * @returns {Boolean} Tells if PAC found
         */

    }, {
        key: 'parsePAC',
        value: function parsePAC(a, b) {

            var chNr = null;
            var row = null;

            var case1 = (0x11 <= a && a <= 0x17 || 0x19 <= a && a <= 0x1F) && 0x40 <= b && b <= 0x7F;
            var case2 = (a === 0x10 || a === 0x18) && 0x40 <= b && b <= 0x5F;
            if (!(case1 || case2)) {
                return false;
            }

            if (a === this.lastCmdA && b === this.lastCmdB) {
                this.lastCmdA = null;
                this.lastCmdB = null;
                return true; // Repeated commands are dropped (once)
            }

            chNr = a <= 0x17 ? 1 : 2;

            if (0x40 <= b && b <= 0x5F) {
                row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
            } else {
                // 0x60 <= b <= 0x7F
                row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
            }
            var pacData = this.interpretPAC(row, b);
            var channel = this.channels[chNr - 1];
            channel.setPAC(pacData);
            this.lastCmdA = a;
            this.lastCmdB = b;
            this.currChNr = chNr;
            return true;
        }

        /**
         * Interpret the second byte of the pac, and return the information.
         * @returns {Object} pacData with style parameters.
         */

    }, {
        key: 'interpretPAC',
        value: function interpretPAC(row, byte) {
            var pacIndex = byte;
            var pacData = { color: null, italics: false, indent: null, underline: false, row: row };

            if (byte > 0x5F) {
                pacIndex = byte - 0x60;
            } else {
                pacIndex = byte - 0x40;
            }
            pacData.underline = (pacIndex & 1) === 1;
            if (pacIndex <= 0xd) {
                pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
            } else if (pacIndex <= 0xf) {
                pacData.italics = true;
                pacData.color = 'white';
            } else {
                pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
            }
            return pacData; // Note that row has zero offset. The spec uses 1.
        }

        /**
         * Parse characters.
         * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
         */

    }, {
        key: 'parseChars',
        value: function parseChars(a, b) {

            var channelNr = null,
                charCodes = null,
                charCode1 = null;

            if (a >= 0x19) {
                channelNr = 2;
                charCode1 = a - 8;
            } else {
                channelNr = 1;
                charCode1 = a;
            }
            if (0x11 <= charCode1 && charCode1 <= 0x13) {
                // Special character
                var oneCode = b;
                if (charCode1 === 0x11) {
                    oneCode = b + 0x50;
                } else if (charCode1 === 0x12) {
                    oneCode = b + 0x70;
                } else {
                    oneCode = b + 0x90;
                }
                logger.log('INFO', 'Special char \'' + getCharForByte(oneCode) + '\' in channel ' + channelNr);
                charCodes = [oneCode];
            } else if (0x20 <= a && a <= 0x7f) {
                charCodes = b === 0 ? [a] : [a, b];
            }
            if (charCodes) {
                var hexCodes = numArrayToHexArray(charCodes);
                logger.log('DEBUG', 'Char codes =  ' + hexCodes.join(','));
                this.lastCmdA = null;
                this.lastCmdB = null;
            }
            return charCodes;
        }

        /**
        * Parse extended background attributes as well as new foreground color black.
        * @returns{Boolean} Tells if background attributes are found
        */

    }, {
        key: 'parseBackgroundAttributes',
        value: function parseBackgroundAttributes(a, b) {
            var bkgData, index, chNr, channel;

            var case1 = (a === 0x10 || a === 0x18) && 0x20 <= b && b <= 0x2f;
            var case2 = (a === 0x17 || a === 0x1f) && 0x2d <= b && b <= 0x2f;
            if (!(case1 || case2)) {
                return false;
            }
            bkgData = {};
            if (a === 0x10 || a === 0x18) {
                index = Math.floor((b - 0x20) / 2);
                bkgData.background = backgroundColors[index];
                if (b % 2 === 1) {
                    bkgData.background = bkgData.background + '_semi';
                }
            } else if (b === 0x2d) {
                bkgData.background = 'transparent';
            } else {
                bkgData.foreground = 'black';
                if (b === 0x2f) {
                    bkgData.underline = true;
                }
            }
            chNr = a < 0x18 ? 1 : 2;
            channel = this.channels[chNr - 1];
            channel.setBkgData(bkgData);
            this.lastCmdA = null;
            this.lastCmdB = null;
            return true;
        }

        /**
         * Reset state of parser and its channels.
         */

    }, {
        key: 'reset',
        value: function reset() {
            for (var i = 0; i < this.channels.length; i++) {
                if (this.channels[i]) {
                    this.channels[i].reset();
                }
            }
            this.lastCmdA = null;
            this.lastCmdB = null;
        }

        /**
         * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
         */

    }, {
        key: 'cueSplitAtTime',
        value: function cueSplitAtTime(t) {
            for (var i = 0; i < this.channels.length; i++) {
                if (this.channels[i]) {
                    this.channels[i].cueSplitAtTime(t);
                }
            }
        }
    }]);

    return Cea608Parser;
}();

exports.default = Cea608Parser;

},{}],50:[function(_dereq_,module,exports){
'use strict';

var _vttparser = _dereq_(57);

var Cues = {

  newCue: function newCue(track, startTime, endTime, captionScreen) {
    var row;
    var cue;
    var indenting;
    var indent;
    var text;
    var VTTCue = window.VTTCue || window.TextTrackCue;

    for (var r = 0; r < captionScreen.rows.length; r++) {
      row = captionScreen.rows[r];
      indenting = true;
      indent = 0;
      text = '';

      if (!row.isEmpty()) {
        for (var c = 0; c < row.chars.length; c++) {
          if (row.chars[c].uchar.match(/\s/) && indenting) {
            indent++;
          } else {
            text += row.chars[c].uchar;
            indenting = false;
          }
        }
        //To be used for cleaning-up orphaned roll-up captions
        row.cueStartTime = startTime;

        // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
        if (startTime === endTime) {
          endTime += 0.0001;
        }

        cue = new VTTCue(startTime, endTime, (0, _vttparser.fixLineBreaks)(text.trim()));

        if (indent >= 16) {
          indent--;
        } else {
          indent++;
        }

        // VTTCue.line get's flakey when using controls, so let's now include line 13&14
        // also, drop line 1 since it's to close to the top
        if (navigator.userAgent.match(/Firefox\//)) {
          cue.line = r + 1;
        } else {
          cue.line = r > 7 ? r - 2 : r + 1;
        }
        cue.align = 'left';
        // Clamp the position between 0 and 100 - if out of these bounds, Firefox throws an exception and captions break
        cue.position = Math.max(0, Math.min(100, 100 * (indent / 32) + (navigator.userAgent.match(/Firefox\//) ? 50 : 0)));
        track.addCue(cue);
      }
    }
  }

};

module.exports = Cues;

},{"57":57}],51:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
   value: true
});
exports.findFragWithCC = findFragWithCC;

var _binarySearch = _dereq_(48);

var _binarySearch2 = _interopRequireDefault(_binarySearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findFragWithCC(fragments, CC) {
   return _binarySearch2.default.search(fragments, function (candidate) {
      if (candidate.cc < CC) {
         return 1;
      } else if (candidate.cc > CC) {
         return -1;
      } else {
         return 0;
      }
   });
}

},{"48":48}],52:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * EWMA Bandwidth Estimator
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  - heavily inspired from shaka-player
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Tracks bandwidth samples and estimates available bandwidth.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Based on the minimum of two exponentially-weighted moving averages with
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * different half-lives.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _ewma = _dereq_(53);

var _ewma2 = _interopRequireDefault(_ewma);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EwmaBandWidthEstimator = function () {
  function EwmaBandWidthEstimator(hls, slow, fast, defaultEstimate) {
    _classCallCheck(this, EwmaBandWidthEstimator);

    this.hls = hls;
    this.defaultEstimate_ = defaultEstimate;
    this.minWeight_ = 0.001;
    this.minDelayMs_ = 50;
    this.slow_ = new _ewma2.default(slow);
    this.fast_ = new _ewma2.default(fast);
  }

  _createClass(EwmaBandWidthEstimator, [{
    key: 'sample',
    value: function sample(durationMs, numBytes) {
      durationMs = Math.max(durationMs, this.minDelayMs_);
      var bandwidth = 8000 * numBytes / durationMs,

      //console.log('instant bw:'+ Math.round(bandwidth));
      // we weight sample using loading duration....
      weight = durationMs / 1000;
      this.fast_.sample(weight, bandwidth);
      this.slow_.sample(weight, bandwidth);
    }
  }, {
    key: 'canEstimate',
    value: function canEstimate() {
      var fast = this.fast_;
      return fast && fast.getTotalWeight() >= this.minWeight_;
    }
  }, {
    key: 'getEstimate',
    value: function getEstimate() {
      if (this.canEstimate()) {
        //console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
        //console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
        // Take the minimum of these two estimates.  This should have the effect of
        // adapting down quickly, but up more slowly.
        return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
      } else {
        return this.defaultEstimate_;
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {}
  }]);

  return EwmaBandWidthEstimator;
}();

exports.default = EwmaBandWidthEstimator;

},{"53":53}],53:[function(_dereq_,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */

var EWMA = function () {

  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  function EWMA(halfLife) {
    _classCallCheck(this, EWMA);

    // Larger values of alpha expire historical data more slowly.
    this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
    this.estimate_ = 0;
    this.totalWeight_ = 0;
  }

  _createClass(EWMA, [{
    key: "sample",
    value: function sample(weight, value) {
      var adjAlpha = Math.pow(this.alpha_, weight);
      this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
      this.totalWeight_ += weight;
    }
  }, {
    key: "getTotalWeight",
    value: function getTotalWeight() {
      return this.totalWeight_;
    }
  }, {
    key: "getEstimate",
    value: function getEstimate() {
      if (this.alpha_) {
        var zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
        return this.estimate_ / zeroFactor;
      } else {
        return this.estimate_;
      }
    }
  }]);

  return EWMA;
}();

exports.default = EWMA;

},{}],54:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function noop() {}

var fakeLogger = {
  trace: noop,
  debug: noop,
  log: noop,
  warn: noop,
  info: noop,
  error: noop
};

var exportedLogger = fakeLogger;

/*globals self: false */

//let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }

function formatMsg(type, msg) {
  msg = '[' + type + '] > ' + msg;
  return msg;
}

function consolePrintFn(type) {
  var func = self.console[type];
  if (func) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (args[0]) {
        args[0] = formatMsg(type, args[0]);
      }
      func.apply(self.console, args);
    };
  }
  return noop;
}

function exportLoggerFunctions(debugConfig) {
  for (var _len2 = arguments.length, functions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    functions[_key2 - 1] = arguments[_key2];
  }

  functions.forEach(function (type) {
    exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
  });
}

var enableLogs = exports.enableLogs = function enableLogs(debugConfig) {
  if (debugConfig === true || (typeof debugConfig === 'undefined' ? 'undefined' : _typeof(debugConfig)) === 'object') {
    exportLoggerFunctions(debugConfig,
    // Remove out from list here to hard-disable a log-level
    //'trace',
    'debug', 'log', 'info', 'warn', 'error');
    // Some browsers don't allow to use bind on console object anyway
    // fallback to default if needed
    try {
      exportedLogger.log();
    } catch (e) {
      exportedLogger = fakeLogger;
    }
  } else {
    exportedLogger = fakeLogger;
  }
};

var logger = exports.logger = exportedLogger;

},{}],55:[function(_dereq_,module,exports){
'use strict';

/**
 *  TimeRanges to string helper
 */

var TimeRanges = {
  toString: function toString(r) {
    var log = '',
        len = r.length;
    for (var i = 0; i < len; i++) {
      log += '[' + r.start(i).toFixed(3) + ',' + r.end(i).toFixed(3) + ']';
    }
    return log;
  }
};

module.exports = TimeRanges;

},{}],56:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.default = function () {
  if (typeof window !== 'undefined' && window.VTTCue) {
    return window.VTTCue;
  }

  var autoKeyword = 'auto';
  var directionSetting = {
    '': true,
    lr: true,
    rl: true
  };
  var alignSetting = {
    start: true,
    middle: true,
    end: true,
    left: true,
    right: true
  };

  function findDirectionSetting(value) {
    if (typeof value !== 'string') {
      return false;
    }
    var dir = directionSetting[value.toLowerCase()];
    return dir ? value.toLowerCase() : false;
  }

  function findAlignSetting(value) {
    if (typeof value !== 'string') {
      return false;
    }
    var align = alignSetting[value.toLowerCase()];
    return align ? value.toLowerCase() : false;
  }

  function extend(obj) {
    var i = 1;
    for (; i < arguments.length; i++) {
      var cobj = arguments[i];
      for (var p in cobj) {
        obj[p] = cobj[p];
      }
    }

    return obj;
  }

  function VTTCue(startTime, endTime, text) {
    var cue = this;
    var isIE8 = function () {
      if (typeof navigator === 'undefined') {
        return;
      }
      return (/MSIE\s8\.0/.test(navigator.userAgent)
      );
    }();
    var baseObj = {};

    if (isIE8) {
      cue = document.createElement('custom');
    } else {
      baseObj.enumerable = true;
    }

    /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */

    // Lets us know when the VTTCue's data has changed in such a way that we need
    // to recompute its display state. This lets us compute its display state
    // lazily.
    cue.hasBeenReset = false;

    /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */

    var _id = '';
    var _pauseOnExit = false;
    var _startTime = startTime;
    var _endTime = endTime;
    var _text = text;
    var _region = null;
    var _vertical = '';
    var _snapToLines = true;
    var _line = 'auto';
    var _lineAlign = 'start';
    var _position = 50;
    var _positionAlign = 'middle';
    var _size = 50;
    var _align = 'middle';

    Object.defineProperty(cue, 'id', extend({}, baseObj, {
      get: function get() {
        return _id;
      },
      set: function set(value) {
        _id = '' + value;
      }
    }));

    Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
      get: function get() {
        return _pauseOnExit;
      },
      set: function set(value) {
        _pauseOnExit = !!value;
      }
    }));

    Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
      get: function get() {
        return _startTime;
      },
      set: function set(value) {
        if (typeof value !== 'number') {
          throw new TypeError('Start time must be set to a number.');
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
      get: function get() {
        return _endTime;
      },
      set: function set(value) {
        if (typeof value !== 'number') {
          throw new TypeError('End time must be set to a number.');
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'text', extend({}, baseObj, {
      get: function get() {
        return _text;
      },
      set: function set(value) {
        _text = '' + value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'region', extend({}, baseObj, {
      get: function get() {
        return _region;
      },
      set: function set(value) {
        _region = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
      get: function get() {
        return _vertical;
      },
      set: function set(value) {
        var setting = findDirectionSetting(value);
        // Have to check for false because the setting an be an empty string.
        if (setting === false) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
      get: function get() {
        return _snapToLines;
      },
      set: function set(value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'line', extend({}, baseObj, {
      get: function get() {
        return _line;
      },
      set: function set(value) {
        if (typeof value !== 'number' && value !== autoKeyword) {
          throw new SyntaxError('An invalid number or illegal string was specified.');
        }
        _line = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
      get: function get() {
        return _lineAlign;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _lineAlign = setting;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'position', extend({}, baseObj, {
      get: function get() {
        return _position;
      },
      set: function set(value) {
        if (value < 0 || value > 100) {
          throw new Error('Position must be between 0 and 100.');
        }
        _position = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
      get: function get() {
        return _positionAlign;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _positionAlign = setting;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'size', extend({}, baseObj, {
      get: function get() {
        return _size;
      },
      set: function set(value) {
        if (value < 0 || value > 100) {
          throw new Error('Size must be between 0 and 100.');
        }
        _size = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'align', extend({}, baseObj, {
      get: function get() {
        return _align;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }));

    /**
     * Other <track> spec defined properties
     */

    // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
    cue.displayState = undefined;

    if (isIE8) {
      return cue;
    }
  }

  /**
   * VTTCue methods
   */

  VTTCue.prototype.getCueAsHTML = function () {
    // Assume WebVTT.convertCueToDOMTree is on the global.
    var WebVTT = window.WebVTT;
    return WebVTT.convertCueToDOMTree(window, this.text);
  };

  return VTTCue;
}();

},{}],57:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixLineBreaks = undefined;

var _vttcue = _dereq_(56);

var _vttcue2 = _interopRequireDefault(_vttcue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StringDecoder = function StringDecoder() {
  return {
    decode: function decode(data) {
      if (!data) {
        return '';
      }
      if (typeof data !== 'string') {
        throw new Error('Error - expected string data.');
      }
      return decodeURIComponent(encodeURIComponent(data));
    }
  };
}; /*
    * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js#L1716
    */

function VTTParser() {
  this.window = window;
  this.state = 'INITIAL';
  this.buffer = '';
  this.decoder = new StringDecoder();
  this.regionList = [];
}

// Try to parse input as a time stamp.
function parseTimeStamp(input) {

  function computeSeconds(h, m, s, f) {
    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
  }

  var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
  if (!m) {
    return null;
  }

  if (m[3]) {
    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3].replace(':', ''), m[4]);
  } else if (m[1] > 59) {
    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[1], m[2], 0, m[4]);
  } else {
    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
    return computeSeconds(0, m[1], m[2], m[4]);
  }
}

// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function Settings() {
  this.values = Object.create(null);
}

Settings.prototype = {
  // Only accept the first assignment to any key.
  set: function set(k, v) {
    if (!this.get(k) && v !== '') {
      this.values[k] = v;
    }
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function get(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  },
  // Check whether we have a value for a key.
  has: function has(k) {
    return k in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function alt(k, v, a) {
    for (var n = 0; n < a.length; ++n) {
      if (v === a[n]) {
        this.set(k, v);
        break;
      }
    }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function integer(k, v) {
    if (/^-?\d+$/.test(v)) {
      // integer
      this.set(k, parseInt(v, 10));
    }
  },
  // Accept a setting if its a valid percentage.
  percent: function percent(k, v) {
    var m;
    if (m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
      v = parseFloat(v);
      if (v >= 0 && v <= 100) {
        this.set(k, v);
        return true;
      }
    }
    return false;
  }
};

// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
  var groups = groupDelim ? input.split(groupDelim) : [input];
  for (var i in groups) {
    if (typeof groups[i] !== 'string') {
      continue;
    }
    var kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    var k = kv[0];
    var v = kv[1];
    callback(k, v);
  }
}

var defaults = new _vttcue2.default(0, 0, 0);
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
// Chrome and Safari don't yet support this change, but FF does
var center = defaults.align === 'middle' ? 'middle' : 'center';

function parseCue(input, cue, regionList) {
  // Remember the original input if we need to throw an error.
  var oInput = input;
  // 4.1 WebVTT timestamp
  function consumeTimeStamp() {
    var ts = parseTimeStamp(input);
    if (ts === null) {
      throw new Error('Malformed timestamp: ' + oInput);
    }
    // Remove time stamp from input.
    input = input.replace(/^[^\sa-zA-Z-]+/, '');
    return ts;
  }

  // 4.4.2 WebVTT cue settings
  function consumeCueSettings(input, cue) {
    var settings = new Settings();

    parseOptions(input, function (k, v) {
      switch (k) {
        case 'region':
          // Find the last region we parsed with the same region id.
          for (var i = regionList.length - 1; i >= 0; i--) {
            if (regionList[i].id === v) {
              settings.set(k, regionList[i].region);
              break;
            }
          }
          break;
        case 'vertical':
          settings.alt(k, v, ['rl', 'lr']);
          break;
        case 'line':
          var vals = v.split(','),
              vals0 = vals[0];
          settings.integer(k, vals0);
          if (settings.percent(k, vals0)) {
            settings.set('snapToLines', false);
          }
          settings.alt(k, vals0, ['auto']);
          if (vals.length === 2) {
            settings.alt('lineAlign', vals[1], ['start', center, 'end']);
          }
          break;
        case 'position':
          vals = v.split(',');
          settings.percent(k, vals[0]);
          if (vals.length === 2) {
            settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);
          }
          break;
        case 'size':
          settings.percent(k, v);
          break;
        case 'align':
          settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
          break;
      }
    }, /:/, /\s/);

    // Apply default values for any missing fields.
    cue.region = settings.get('region', null);
    cue.vertical = settings.get('vertical', '');
    var line = settings.get('line', 'auto');
    if (line === 'auto' && defaults.line === -1) {
      // set numeric line number for Safari
      line = -1;
    }
    cue.line = line;
    cue.lineAlign = settings.get('lineAlign', 'start');
    cue.snapToLines = settings.get('snapToLines', true);
    cue.size = settings.get('size', 100);
    cue.align = settings.get('align', center);
    var position = settings.get('position', 'auto');
    if (position === 'auto' && defaults.position === 50) {
      // set numeric position for Safari
      position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
    }
    cue.position = position;
  }

  function skipWhitespace() {
    input = input.replace(/^\s+/, '');
  }

  // 4.1 WebVTT cue timings.
  skipWhitespace();
  cue.startTime = consumeTimeStamp(); // (1) collect cue start time
  skipWhitespace();
  if (input.substr(0, 3) !== '-->') {
    // (3) next characters must match '-->'
    throw new Error('Malformed time stamp (time stamps must be separated by \'-->\'): ' + oInput);
  }
  input = input.substr(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp(); // (5) collect cue end time

  // 4.1 WebVTT cue settings list.
  skipWhitespace();
  consumeCueSettings(input, cue);
}

function fixLineBreaks(input) {
  return input.replace(/<br(?: \/)?>/gi, '\n');
}

VTTParser.prototype = {
  parse: function parse(data) {
    var self = this;

    // If there is no data then we won't decode it, but will just try to parse
    // whatever is in buffer already. This may occur in circumstances, for
    // example when flush() is called.
    if (data) {
      // Try to decode the data that we received.
      self.buffer += self.decoder.decode(data, { stream: true });
    }

    function collectNextLine() {
      var buffer = self.buffer;
      var pos = 0;

      buffer = fixLineBreaks(buffer);

      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
        ++pos;
      }
      var line = buffer.substr(0, pos);
      // Advance the buffer early in case we fail below.
      if (buffer[pos] === '\r') {
        ++pos;
      }
      if (buffer[pos] === '\n') {
        ++pos;
      }
      self.buffer = buffer.substr(pos);
      return line;
    }

    // 3.2 WebVTT metadata header syntax
    function parseHeader(input) {
      parseOptions(input, function (k, v) {
        switch (k) {
          case 'Region':
            // 3.3 WebVTT region metadata header syntax
            console.log('parse region', v);
            //parseRegion(v);
            break;
        }
      }, /:/);
    }

    // 5.1 WebVTT file parsing.
    try {
      var line;
      if (self.state === 'INITIAL') {
        // We can't start parsing until we have the first line.
        if (!/\r\n|\n/.test(self.buffer)) {
          return this;
        }

        line = collectNextLine();

        var m = line.match(/^WEBVTT([ \t].*)?$/);
        if (!m || !m[0]) {
          throw new Error('Malformed WebVTT signature.');
        }

        self.state = 'HEADER';
      }

      var alreadyCollectedLine = false;
      while (self.buffer) {
        // We can't parse a line until we have the full line.
        if (!/\r\n|\n/.test(self.buffer)) {
          return this;
        }

        if (!alreadyCollectedLine) {
          line = collectNextLine();
        } else {
          alreadyCollectedLine = false;
        }

        switch (self.state) {
          case 'HEADER':
            // 13-18 - Allow a header (metadata) under the WEBVTT line.
            if (/:/.test(line)) {
              parseHeader(line);
            } else if (!line) {
              // An empty line terminates the header and starts the body (cues).
              self.state = 'ID';
            }
            continue;
          case 'NOTE':
            // Ignore NOTE blocks.
            if (!line) {
              self.state = 'ID';
            }
            continue;
          case 'ID':
            // Check for the start of NOTE blocks.
            if (/^NOTE($|[ \t])/.test(line)) {
              self.state = 'NOTE';
              break;
            }
            // 19-29 - Allow any number of line terminators, then initialize new cue values.
            if (!line) {
              continue;
            }
            self.cue = new _vttcue2.default(0, 0, '');
            self.state = 'CUE';
            // 30-39 - Check if self line contains an optional identifier or timing data.
            if (line.indexOf('-->') === -1) {
              self.cue.id = line;
              continue;
            }
          // Process line as start of a cue.
          /*falls through*/
          case 'CUE':
            // 40 - Collect cue timings and settings.
            try {
              parseCue(line, self.cue, self.regionList);
            } catch (e) {
              // In case of an error ignore rest of the cue.
              self.cue = null;
              self.state = 'BADCUE';
              continue;
            }
            self.state = 'CUETEXT';
            continue;
          case 'CUETEXT':
            var hasSubstring = line.indexOf('-->') !== -1;
            // 34 - If we have an empty line then report the cue.
            // 35 - If we have the special substring '-->' then report the cue,
            // but do not collect the line as we need to process the current
            // one as a new cue.
            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
              // We are done parsing self cue.
              if (self.oncue) {
                self.oncue(self.cue);
              }
              self.cue = null;
              self.state = 'ID';
              continue;
            }
            if (self.cue.text) {
              self.cue.text += '\n';
            }
            self.cue.text += line;
            continue;
          case 'BADCUE':
            // BADCUE
            // 54-62 - Collect and discard the remaining cue.
            if (!line) {
              self.state = 'ID';
            }
            continue;
        }
      }
    } catch (e) {

      // If we are currently parsing a cue, report what we have.
      if (self.state === 'CUETEXT' && self.cue && self.oncue) {
        self.oncue(self.cue);
      }
      self.cue = null;
      // Enter BADWEBVTT state if header was not parsed correctly otherwise
      // another exception occurred so enter BADCUE state.
      self.state = self.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
    }
    return this;
  },
  flush: function flush() {
    var self = this;
    try {
      // Finish decoding the stream.
      self.buffer += self.decoder.decode();
      // Synthesize the end of the current cue or region.
      if (self.cue || self.state === 'HEADER') {
        self.buffer += '\n\n';
        self.parse();
      }
      // If we've flushed, parsed, and we're still on the INITIAL state then
      // that means we don't have enough of the stream to parse the first
      // line.
      if (self.state === 'INITIAL') {
        throw new Error('Malformed WebVTT signature.');
      }
    } catch (e) {
      throw e;
    }
    if (self.onflush) {
      self.onflush();
    }
    return this;
  }
};

exports.fixLineBreaks = fixLineBreaks;
exports.default = VTTParser;

},{"56":56}],58:[function(_dereq_,module,exports){
'use strict';

var _vttparser = _dereq_(57);

var _vttparser2 = _interopRequireDefault(_vttparser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// String.prototype.startsWith is not supported in IE11
var startsWith = function startsWith(inputString, searchString, position) {
    return inputString.substr(position || 0, searchString.length) === searchString;
};

var cueString2millis = function cueString2millis(timeString) {
    var ts = parseInt(timeString.substr(-3));
    var secs = parseInt(timeString.substr(-6, 2));
    var mins = parseInt(timeString.substr(-9, 2));
    var hours = timeString.length > 9 ? parseInt(timeString.substr(0, timeString.indexOf(':'))) : 0;

    if (isNaN(ts) || isNaN(secs) || isNaN(mins) || isNaN(hours)) {
        return -1;
    }

    ts += 1000 * secs;
    ts += 60 * 1000 * mins;
    ts += 60 * 60 * 1000 * hours;

    return ts;
};

// From https://github.com/darkskyapp/string-hash
var hash = function hash(text) {
    var hash = 5381;
    var i = text.length;
    while (i) {
        hash = hash * 33 ^ text.charCodeAt(--i);
    }
    return (hash >>> 0).toString();
};

var calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
    var currCC = vttCCs[cc];
    var prevCC = vttCCs[currCC.prevCC];

    // This is the first discontinuity or cues have been processed since the last discontinuity
    // Offset = current discontinuity time
    if (!prevCC || !prevCC.new && currCC.new) {
        vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
        currCC.new = false;
        return;
    }

    // There have been discontinuities since cues were last parsed.
    // Offset = time elapsed
    while (prevCC && prevCC.new) {
        vttCCs.ccOffset += currCC.start - prevCC.start;
        currCC.new = false;
        currCC = prevCC;
        prevCC = vttCCs[currCC.prevCC];
    }

    vttCCs.presentationOffset = presentationTime;
};

var WebVTTParser = {
    parse: function parse(vttByteArray, syncPTS, vttCCs, cc, callBack, errorCallBack) {
        // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
        var re = /\r\n|\n\r|\n|\r/g;
        var vttLines = String.fromCharCode.apply(null, new Uint8Array(vttByteArray)).trim().replace(re, '\n').split('\n');
        var cueTime = '00:00.000';
        var mpegTs = 0;
        var localTime = 0;
        var presentationTime = 0;
        var cues = [];
        var parsingError = void 0;
        var inHeader = true;
        // let VTTCue = VTTCue || window.TextTrackCue;

        // Create parser object using VTTCue with TextTrackCue fallback on certain browsers.
        var parser = new _vttparser2.default();

        parser.oncue = function (cue) {
            // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
            var currCC = vttCCs[cc];
            var cueOffset = vttCCs.ccOffset;

            // Update offsets for new discontinuities
            if (currCC && currCC.new) {
                if (localTime !== undefined) {
                    // When local time is provided, offset = discontinuity start time - local time
                    cueOffset = vttCCs.ccOffset = currCC.start;
                } else {
                    calculateOffset(vttCCs, cc, presentationTime);
                }
            }

            if (presentationTime) {
                // If we have MPEGTS, offset = presentation time + discontinuity offset
                cueOffset = presentationTime + vttCCs.ccOffset - vttCCs.presentationOffset;
            }

            cue.startTime += cueOffset - localTime;
            cue.endTime += cueOffset - localTime;

            // Create a unique hash id for a cue based on start/end times and text.
            // This helps timeline-controller to avoid showing repeated captions.
            cue.id = hash(cue.startTime) + hash(cue.endTime) + hash(cue.text);

            // Fix encoding of special characters. TODO: Test with all sorts of weird characters.
            cue.text = decodeURIComponent(escape(cue.text));
            if (cue.endTime > 0) {
                cues.push(cue);
            }
        };

        parser.onparsingerror = function (e) {
            parsingError = e;
        };

        parser.onflush = function () {
            if (parsingError && errorCallBack) {
                errorCallBack(parsingError);
                return;
            }
            callBack(cues);
        };

        // Go through contents line by line.
        vttLines.forEach(function (line) {
            if (inHeader) {
                // Look for X-TIMESTAMP-MAP in header.
                if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
                    // Once found, no more are allowed anyway, so stop searching.
                    inHeader = false;
                    // Extract LOCAL and MPEGTS.
                    line.substr(16).split(',').forEach(function (timestamp) {
                        if (startsWith(timestamp, 'LOCAL:')) {
                            cueTime = timestamp.substr(6);
                        } else if (startsWith(timestamp, 'MPEGTS:')) {
                            mpegTs = parseInt(timestamp.substr(7));
                        }
                    });
                    try {
                        // Calculate subtitle offset in milliseconds.
                        // If sync PTS is less than zero, we have a 33-bit wraparound, which is fixed by adding 2^33 = 8589934592.
                        syncPTS = syncPTS < 0 ? syncPTS + 8589934592 : syncPTS;
                        // Adjust MPEGTS by sync PTS.
                        mpegTs -= syncPTS;
                        // Convert cue time to seconds
                        localTime = cueString2millis(cueTime) / 1000;
                        // Convert MPEGTS to seconds from 90kHz.
                        presentationTime = mpegTs / 90000;

                        if (localTime === -1) {
                            parsingError = new Error('Malformed X-TIMESTAMP-MAP: ' + line);
                        }
                    } catch (e) {
                        parsingError = new Error('Malformed X-TIMESTAMP-MAP: ' + line);
                    }
                    // Return without parsing X-TIMESTAMP-MAP line.
                    return;
                } else if (line === '') {
                    inHeader = false;
                }
            }
            // Parse line by default.
            parser.parse(line + '\n');
        });

        parser.flush();
    }
};

module.exports = WebVTTParser;

},{"57":57}],59:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * XHR based logger
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _logger = _dereq_(54);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var XhrLoader = function () {
  function XhrLoader(config) {
    _classCallCheck(this, XhrLoader);

    if (config && config.xhrSetup) {
      this.xhrSetup = config.xhrSetup;
    }
  }

  _createClass(XhrLoader, [{
    key: 'destroy',
    value: function destroy() {
      this.abort();
      this.loader = null;
    }
  }, {
    key: 'abort',
    value: function abort() {
      var loader = this.loader;
      if (loader && loader.readyState !== 4) {
        this.stats.aborted = true;
        loader.abort();
      }

      window.clearTimeout(this.requestTimeout);
      this.requestTimeout = null;
      window.clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    }
  }, {
    key: 'load',
    value: function load(context, config, callbacks) {
      this.context = context;
      this.config = config;
      this.callbacks = callbacks;
      this.stats = { trequest: performance.now(), retry: 0 };
      this.retryDelay = config.retryDelay;
      this.loadInternal();
    }
  }, {
    key: 'loadInternal',
    value: function loadInternal() {
      var xhr,
          context = this.context;

      if (typeof XDomainRequest !== 'undefined') {
        xhr = this.loader = new XDomainRequest();
      } else {
        xhr = this.loader = new XMLHttpRequest();
      }
      var stats = this.stats;
      stats.tfirst = 0;
      stats.loaded = 0;
      var xhrSetup = this.xhrSetup;

      try {
        if (xhrSetup) {
          try {
            xhrSetup(xhr, context.url);
          } catch (e) {
            // fix xhrSetup: (xhr, url) => {xhr.setRequestHeader("Content-Language", "test");}
            // not working, as xhr.setRequestHeader expects xhr.readyState === OPEN
            xhr.open('GET', context.url, true);
            xhrSetup(xhr, context.url);
          }
        }
        if (!xhr.readyState) {
          xhr.open('GET', context.url, true);
        }
      } catch (e) {
        // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
        this.callbacks.onError({ code: xhr.status, text: e.message }, context, xhr);
        return;
      }

      if (context.rangeEnd) {
        xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
      }
      xhr.onreadystatechange = this.readystatechange.bind(this);
      xhr.onprogress = this.loadprogress.bind(this);
      xhr.responseType = context.responseType;

      // setup timeout before we perform request
      this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout);
      xhr.send();
    }
  }, {
    key: 'readystatechange',
    value: function readystatechange(event) {
      var xhr = event.currentTarget,
          readyState = xhr.readyState,
          stats = this.stats,
          context = this.context,
          config = this.config;

      // don't proceed if xhr has been aborted
      if (stats.aborted) {
        return;
      }

      // >= HEADERS_RECEIVED
      if (readyState >= 2) {
        // clear xhr timeout and rearm it if readyState less than 4
        window.clearTimeout(this.requestTimeout);
        if (stats.tfirst === 0) {
          stats.tfirst = Math.max(performance.now(), stats.trequest);
        }
        if (readyState === 4) {
          var status = xhr.status;
          // http status between 200 to 299 are all successful
          if (status >= 200 && status < 300) {
            stats.tload = Math.max(stats.tfirst, performance.now());
            var data = void 0,
                len = void 0;
            if (context.responseType === 'arraybuffer') {
              data = xhr.response;
              len = data.byteLength;
            } else {
              data = xhr.responseText;
              len = data.length;
            }
            stats.loaded = stats.total = len;
            var response = { url: xhr.responseURL, data: data };
            this.callbacks.onSuccess(response, stats, context, xhr);
          } else {
            // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
            if (stats.retry >= config.maxRetry || status >= 400 && status < 499) {
              _logger.logger.error(status + ' while loading ' + context.url);
              this.callbacks.onError({ code: status, text: xhr.statusText }, context, xhr);
            } else {
              // retry
              _logger.logger.warn(status + ' while loading ' + context.url + ', retrying in ' + this.retryDelay + '...');
              // aborts and resets internal state
              this.destroy();
              // schedule retry
              this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay);
              // set exponential backoff
              this.retryDelay = Math.min(2 * this.retryDelay, config.maxRetryDelay);
              stats.retry++;
            }
          }
        } else {
          // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
          this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), config.timeout);
        }
      }
    }
  }, {
    key: 'loadtimeout',
    value: function loadtimeout() {
      _logger.logger.warn('timeout while loading ' + this.context.url);
      this.callbacks.onTimeout(this.stats, this.context, null);
    }
  }, {
    key: 'loadprogress',
    value: function loadprogress(event) {
      var xhr = event.currentTarget,
          stats = this.stats;

      stats.loaded = event.loaded;
      if (event.lengthComputable) {
        stats.total = event.total;
      }
      var onProgress = this.callbacks.onProgress;
      if (onProgress) {
        // third arg is to provide on progress data
        onProgress(stats, this.context, null, xhr);
      }
    }
  }]);

  return XhrLoader;
}();

exports.default = XhrLoader;

},{"54":54}]},{},[40])(40)
});
//# sourceMappingURL=hls.js.map


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".video-viewer--baseDiv--wJMR0LPc {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: auto;\n  height: 280px;\n}\n\n.video-viewer--iconDiv--2Sd9Yjsq {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n\n.video-viewer--avatar--sxBu4fey {\n  cursor: pointer;\n  margin: 5px;\n  margin-top: 0px;\n}\n\n.video-viewer--tooltipAvatar--1pLL09-K {\n  height: 30px;\n  width: 30px;\n  bottom: 5px;\n  margin-right: 10px;\n}\n\n.video-viewer--tooltipAvatar--1pLL09-K span {\n  font-size: 18px;\n  line-height: 32px;\n}\n\n.video-viewer--video--biI4ryJP {\n  max-width: 100%;\n  max-height: 230px;\n  display: block;\n  margin: 0 auto;\n  cursor: pointer; \n}\n\n.video-viewer--dialogVideo--FQiYGzJp {\n  max-width: 100%;\n  display: block;\n  margin: 0 auto;\n}\n\n.video-viewer--dialogAudio--2_ETbzPV {\n  max-width: 100%;\n  height: 100%;\n  display: block;\n  cursor: pointer;\n  margin: 0px 10%; \n  padding: 0 10px 10px 10px;\n  background-color: rgba(0, 0, 0, .15);\n}\n\n.video-viewer--audio--_hsj0Q1V {\n  max-width: 100%;\n  max-height: 250px;\n  display: block;\n  cursor: pointer;\n  margin: 0px 10%; \n  padding: 0 10px 10px 10px;\n\n  background-color: rgba(0, 0, 0, .15);\n}\n\n.video-viewer--audioArea--1Zm3KMEu {\n  position: relative; \n  margin: 0px 10%\n}\n\n.video-viewer--audioChip--3E6z-Clj {\n  position: absolute;\n  color: rgb(0, 0, 0);\n  top: 10px;\n  left: 10px;\n}\n\n.video-viewer--avatar--sxBu4fey[class~=audiotrack] {\n  background-color: blue;\n  margin: 0px;\n  height: 32px;\n  margin-right: 8px;\n  vertical-align: middle;\n  width: 32px;\n}\n\n*:focus {\n  outline: none;\n  }", "", {"version":3,"sources":["/./src/web/components/themes/video-viewer.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,aAAa;EACb,cAAc;CACf;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,sBAAsB;MAClB,mBAAmB;UACf,0BAA0B;CACnC;;AAED;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;;AAED;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;CACpB;;AAED;EACE,gBAAgB;EAChB,kBAAkB;CACnB;;AAED;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;CACjB;;AAED;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;CAChB;;AAED;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;CACtC;;AAED;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;;EAE1B,qCAAqC;CACtC;;AAED;EACE,mBAAmB;EACnB,eAAe;CAChB;;AAED;EACE,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,WAAW;CACZ;;AAED;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;CACb;;AAED;EACE,cAAc;GACb","file":"video-viewer.css","sourcesContent":[".baseDiv {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: auto;\n  height: 280px;\n}\n\n.iconDiv {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n\n.avatar {\n  cursor: pointer;\n  margin: 5px;\n  margin-top: 0px;\n}\n\n.tooltipAvatar {\n  height: 30px;\n  width: 30px;\n  bottom: 5px;\n  margin-right: 10px;\n}\n\n.tooltipAvatar span {\n  font-size: 18px;\n  line-height: 32px;\n}\n\n.video {\n  max-width: 100%;\n  max-height: 230px;\n  display: block;\n  margin: 0 auto;\n  cursor: pointer; \n}\n\n.dialogVideo {\n  max-width: 100%;\n  display: block;\n  margin: 0 auto;\n}\n\n.dialogAudio {\n  max-width: 100%;\n  height: 100%;\n  display: block;\n  cursor: pointer;\n  margin: 0px 10%; \n  padding: 0 10px 10px 10px;\n  background-color: rgba(0, 0, 0, .15);\n}\n\n.audio {\n  max-width: 100%;\n  max-height: 250px;\n  display: block;\n  cursor: pointer;\n  margin: 0px 10%; \n  padding: 0 10px 10px 10px;\n\n  background-color: rgba(0, 0, 0, .15);\n}\n\n.audioArea {\n  position: relative; \n  margin: 0px 10%\n}\n\n.audioChip {\n  position: absolute;\n  color: rgb(0, 0, 0);\n  top: 10px;\n  left: 10px;\n}\n\n.avatar[class~=audiotrack] {\n  background-color: blue;\n  margin: 0px;\n  height: 32px;\n  margin-right: 8px;\n  vertical-align: middle;\n  width: 32px;\n}\n\n*:focus {\n  outline: none;\n  }"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"baseDiv": "video-viewer--baseDiv--wJMR0LPc",
	"iconDiv": "video-viewer--iconDiv--2Sd9Yjsq",
	"avatar": "video-viewer--avatar--sxBu4fey",
	"tooltipAvatar": "video-viewer--tooltipAvatar--1pLL09-K",
	"video": "video-viewer--video--biI4ryJP",
	"dialogVideo": "video-viewer--dialogVideo--FQiYGzJp",
	"dialogAudio": "video-viewer--dialogAudio--2_ETbzPV",
	"audio": "video-viewer--audio--_hsj0Q1V",
	"audioArea": "video-viewer--audioArea--1Zm3KMEu",
	"audioChip": "video-viewer--audioChip--3E6z-Clj"
};

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2172);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./help-button.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./help-button.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".help-button--helpButtonArea--U35BQqT4 {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(191, 0, 0, .85);\n  color: #ffffff;\n  font-family: 'Century Bold', Questrial, sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  padding: 4px;\n  height: 30px;\n}\n\n.help-button--helpButtonGambaKun--1y-f9DsR {\n  float:left;\n  margin-left: 50px;\n  width: 30px;\n  height: 23px;\n  content: url('data:image/png;base64,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');\n}\n\n.help-button--helpText--1JBOmtch {\n  float:left;\n  margin-left: 10px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/help-button.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,mDAAmD;EACnD,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,aAAa;CACd;;AAED;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,upUAAupU;CACxpU;;AAED;EACE,WAAW;EACX,kBAAkB;CACnB","file":"help-button.css","sourcesContent":[".helpButtonArea {\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(191, 0, 0, .85);\n  color: #ffffff;\n  font-family: 'Century Bold', Questrial, sans-serif;\n  font-size: 20px;\n  font-weight: bold;\n  padding: 4px;\n  height: 30px;\n}\n\n.helpButtonGambaKun {\n  float:left;\n  margin-left: 50px;\n  width: 30px;\n  height: 23px;\n  content: url('data:image/png;base64,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');\n}\n\n.helpText {\n  float:left;\n  margin-left: 10px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"helpButtonArea": "help-button--helpButtonArea--U35BQqT4",
	"helpButtonGambaKun": "help-button--helpButtonGambaKun--1y-f9DsR",
	"helpText": "help-button--helpText--1JBOmtch"
};

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2174);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./drawer.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./drawer.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.drawer--navDrawerDrawer--pgK5Swab {\n  background-color: #f3f0f0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  border-right: 0!important;\n  overflow: hidden;\n  -ms-overflow-style: none;\n}\n\n/* スマホ表示用のスタイル */\n\n@media screen and (max-width: 768px) {\n  .drawer--navDrawerDrawer--pgK5Swab {\n    background-color: #ffffff;\n  }\n }", "", {"version":3,"sources":["/./src/web/components/themes/drawer.css"],"names":[],"mappings":";AACA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;CAC1B;;AAED,iBAAiB;;AAEjB;EACE;IACE,0BAA0B;GAC3B;EACD","file":"drawer.css","sourcesContent":["\n.navDrawerDrawer {\n  background-color: #f3f0f0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  border-right: 0!important;\n  overflow: hidden;\n  -ms-overflow-style: none;\n}\n\n/* スマホ表示用のスタイル */\n\n@media screen and (max-width: 768px) {\n  .navDrawerDrawer {\n    background-color: #ffffff;\n  }\n }"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"navDrawerDrawer": "drawer--navDrawerDrawer--pgK5Swab"
};

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawUserSettingsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userSettingsPage = __webpack_require__(2176);

var _userSettingsPage2 = _interopRequireDefault(_userSettingsPage);

var _settingsPage = __webpack_require__(268);

var _userEmailPanel = __webpack_require__(2177);

var _userEmailPanel2 = _interopRequireDefault(_userEmailPanel);

var _userPasswordPanel = __webpack_require__(2179);

var _userPasswordPanel2 = _interopRequireDefault(_userPasswordPanel);

var _userFavoritesPanel = __webpack_require__(2181);

var _userFavoritesPanel2 = _interopRequireDefault(_userFavoritesPanel);

var _userProfilePanel = __webpack_require__(2183);

var _userProfilePanel2 = _interopRequireDefault(_userProfilePanel);

var _userTemplatesPanel = __webpack_require__(2192);

var _userTemplatesPanel2 = _interopRequireDefault(_userTemplatesPanel);

var _userNotificationPanel = __webpack_require__(2196);

var _userNotificationPanel2 = _interopRequireDefault(_userNotificationPanel);

var _templateFormPanel = __webpack_require__(967);

var _templateFormPanel2 = _interopRequireDefault(_templateFormPanel);

var _userLogoutPanel = __webpack_require__(2264);

var _userLogoutPanel2 = _interopRequireDefault(_userLogoutPanel);

var _groupSortingPage = __webpack_require__(2266);

var _groupSortingPage2 = _interopRequireDefault(_groupSortingPage);

var _userBlockPanel = __webpack_require__(2270);

var _userBlockPanel2 = _interopRequireDefault(_userBlockPanel);

var _userExtensionsPanel = __webpack_require__(2272);

var _userExtensionsPanel2 = _interopRequireDefault(_userExtensionsPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/user-settings-page.jsx

var UserSettingsPage = function (_React$Component) {
    _inherits(UserSettingsPage, _React$Component);

    function UserSettingsPage() {
        _classCallCheck(this, UserSettingsPage);

        return _possibleConstructorReturn(this, (UserSettingsPage.__proto__ || Object.getPrototypeOf(UserSettingsPage)).apply(this, arguments));
    }

    _createClass(UserSettingsPage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                t = _props.t,
                user = _props.user,
                active = _props.active,
                onClose = _props.onClose,
                name = _props.name,
                usersAdminUrl = _props.usersAdminUrl,
                blockUsers = _props.blockUsers;


            return _react2.default.createElement(
                _settingsPage.SettingsPage,
                { title: t('label:個人設定'),
                    active: active,
                    onCloseDialog: onClose,
                    name: name,
                    initialName: 'profile' },
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'profile',
                    label: t('label:プロフィール設定'),
                    icon: 'person',
                    component: _userProfilePanel2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'favorite',
                    label: t('label:お気に入り登録'),
                    icon: 'flag',
                    component: _userFavoritesPanel2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'groupSorting',
                    label: t('label:並べ替え'),
                    icon: 'swap_vert',
                    component: _groupSortingPage2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'email',
                    label: t('label:メールアドレス'),
                    icon: 'email',
                    component: _userEmailPanel2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'password',
                    label: t('label:パスワード変更'),
                    icon: 'lock',
                    component: _userPasswordPanel2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'notification',
                    label: t('label:通知設定'),
                    icon: 'alarm',
                    component: _userNotificationPanel2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'templates',
                    label: t('label:自分用テンプレート'),
                    icon: 'edit',
                    component: _userTemplatesPanel2.default,
                    subPanel: {
                        new: { component: _templateFormPanel2.default, label: t('label:新規作成') },
                        edit: { component: _templateFormPanel2.default, label: t('label:編集') }
                    } }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'extensions',
                    label: t('label:拡張機能'),
                    icon: 'extensions',
                    component: _userExtensionsPanel2.default }),
                blockUsers && blockUsers.length > 0 && _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'block',
                    label: t('label:ブロックリスト'),
                    icon: 'block',
                    component: _userBlockPanel2.default }),
                user && user.account_admin && _react2.default.createElement(_settingsPage.LinkPanel, {
                    label: t('label:アカウント管理'),
                    icon: 'settings_applications',
                    onClose: onClose,
                    url: usersAdminUrl }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'logout',
                    label: t('label:ログアウト'),
                    icon: 'power_settings_new',
                    component: _userLogoutPanel2.default })
            );
        }
    }]);

    return UserSettingsPage;
}(_react2.default.Component);

var RawUserSettingsPage = exports.RawUserSettingsPage = UserSettingsPage;
exports.default = (0, _userSettingsPage2.default)(UserSettingsPage);

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeProps = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/user-settings-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.current,
    name: state.userSettings.name,
    active: state.userSettings.active,
    access_token: state.sessions.access_token,
    blockUsers: state.block.users
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch(_actions2.default.closeUserSettingsPage());
    },
    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.closeUserSettingsPage());
    }
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    usersAdminUrl: _config2.default.baseUrl + 'v3/session/redirect?login=true&redirect_to=/v3/users&access_token=' + stateProps.access_token
  });
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserEmailPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _input = __webpack_require__(59);

var _userEmailPanel = __webpack_require__(2178);

var _userEmailPanel2 = _interopRequireDefault(_userEmailPanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _reactI18next = __webpack_require__(2);

var _formValidator = __webpack_require__(41);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserEmailPanel = function (_React$Component) {
  _inherits(UserEmailPanel, _React$Component);

  function UserEmailPanel() {
    _classCallCheck(this, UserEmailPanel);

    return _possibleConstructorReturn(this, (UserEmailPanel.__proto__ || Object.getPrototypeOf(UserEmailPanel)).apply(this, arguments));
  }

  _createClass(UserEmailPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          user = _props.user,
          ui = _props.ui,
          isEmailUpdating = _props.isEmailUpdating,
          updateUI = _props.updateUI,
          validateAndSubmit = _props.validateAndSubmit; // declare all props here to easy to see what props should be passed.

      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return validateAndSubmit(_this2.props, e);
            } },
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                '\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9'
              )
            ),
            _react2.default.createElement(_input.Input, { name: 'email', required: true,
              label: t('label:メールアドレス'),
              value: ui.email,
              icon: 'email',
              error: ui.emailError && t('error:メールアドレスを入力してください'),
              onChange: (0, _formValidator.linkUI)(this, 'email') }),
            user && user.unconfirmed_email && _react2.default.createElement(
              'span',
              null,
              t('label:メールアドレス確認待ち', { email: user.unconfirmed_email })
            )
          ),
          _react2.default.createElement(
            _card.CardActions,
            null,
            _react2.default.createElement(_button.Button, { raised: true, primary: true,
              disabled: isEmailUpdating,
              type: 'submit',
              style: { width: '100%' },
              label: t('label:更新') })
          )
        )
      );
    }
  }]);

  return UserEmailPanel;
}(_react2.default.Component);

var RawUserEmailPanel = exports.RawUserEmailPanel = UserEmailPanel;
exports.default = (0, _userEmailPanel2.default)(UserEmailPanel);

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _formValidator = __webpack_require__(41);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/user-email-panel.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.current,
    isEmailUpdating: state.user.isEmailUpdating,
    isEmailUpdateFailed: state.user.isEmailUpdateFailed
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    validateAndSubmit: function validateAndSubmit(props) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (event && event.preventDefault) event.preventDefault();
      (0, _formValidator.validate)(props.ui, {
        email: { rule: 'isEmail' }
      }, function (errors, nextUI) {
        props.updateUI(nextUI);
        if (!errors) dispatch(_actions2.default.updateEmail(props.ui.email));
      });
      return false;
    },

    willUpdate: function willUpdate(props, nextProps) {
      // changing isFetching true => false
      if (props.isEmailUpdating && !nextProps.isEmailUpdating) {
        if (!nextProps.isEmailUpdateFailed) {
          // successfully updated
          dispatch((0, _alertMessage.emitAlertMessage)("label:メールアドレスを更新しました", "success"));
          nextProps.resetUI();
        }
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    email: function email(props, state) {
      return props.user && props.user.email;
    },
    emailError: undefined
  }
}), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserPasswordPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userPasswordPanel = __webpack_require__(2180);

var _userPasswordPanel2 = _interopRequireDefault(_userPasswordPanel);

var _input = __webpack_require__(59);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _formValidator = __webpack_require__(41);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/user-password-panel.jsx

var UserPasswordPanel = function (_React$Component) {
  _inherits(UserPasswordPanel, _React$Component);

  function UserPasswordPanel() {
    _classCallCheck(this, UserPasswordPanel);

    return _possibleConstructorReturn(this, (UserPasswordPanel.__proto__ || Object.getPrototypeOf(UserPasswordPanel)).apply(this, arguments));
  }

  _createClass(UserPasswordPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          isPasswordUpdating = _props.isPasswordUpdating,
          updateUI = _props.updateUI,
          validateAndSubmit = _props.validateAndSubmit;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return validateAndSubmit(_this2.props, e);
            } },
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:現在のパスワード')
              )
            ),
            _react2.default.createElement(_input.Input, _defineProperty({ name: 'currentPassword', required: true,
              label: t('label:現在のパスワード'),
              value: ui.currentPassword,
              icon: 'lock_open',
              type: 'password',
              error: ui.currentPasswordError && t('error:パスワードを入力してください'),
              onChange: (0, _formValidator.linkUI)(this, 'currentPassword')
            }, 'type', 'password'))
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:新しいパスワード')
              )
            ),
            _react2.default.createElement(_input.Input, { name: 'newPassword', required: true,
              label: t('label:新しいパスワード'),
              value: ui.newPassword,
              icon: 'lock_open',
              type: 'password',
              error: ui.newPasswordError && t('error:パスワードを入力してください'),
              onChange: (0, _formValidator.linkUI)(this, 'newPassword') }),
            _react2.default.createElement(_input.Input, { name: 'confirmNewPassword', required: true,
              label: t('label:新しいパスワード(再入力)'),
              value: ui.confirmNewPassword,
              icon: 'lock_open',
              type: 'password',
              error: ui.confirmNewPasswordError && t('error:パスワードを入力してください'),
              onChange: (0, _formValidator.linkUI)(this, 'confirmNewPassword') })
          ),
          _react2.default.createElement(
            _card.CardActions,
            null,
            _react2.default.createElement(_button.Button, { raised: true, primary: true,
              disabled: isPasswordUpdating,
              type: 'submit',
              style: { width: '100%' },
              label: t('label:更新') })
          )
        )
      );
    }
  }]);

  return UserPasswordPanel;
}(_react2.default.Component);

var RawUserPasswordPanel = exports.RawUserPasswordPanel = UserPasswordPanel;
exports.default = (0, _userPasswordPanel2.default)(UserPasswordPanel);

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _formValidator = __webpack_require__(41);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/user-password-panel.jsx

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.current,
    isPasswordUpdating: state.user.isPasswordUpdating,
    isPasswordUpdateFailed: state.user.isPasswordUpdateFailed
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    validateAndSubmit: function validateAndSubmit(props) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (event && event.preventDefault) event.preventDefault();

      // check newPassword and confirmNewPassword are the same
      if (props.ui.newPassword != props.ui.confirmNewPassword) {
        props.updateUI({ confirmNewPasswordError: true });
        return false;
      }
      (0, _formValidator.validate)(props.ui, {
        currentPassword: { rule: 'isRequired' },
        newPassword: { rule: 'isRequired' },
        confirmNewPassword: { rule: 'isRequired' }
      }, function (errors, nextUI) {
        props.updateUI(nextUI);
        if (!errors) {
          dispatch(_actions2.default.updatePassword(props.ui.currentPassword, props.ui.newPassword, props.ui.confirmNewPassword));
        }
      });

      return false;
    },

    willUpdate: function willUpdate(props, nextProps) {
      // changing isFetching true => false
      if (props.isPasswordUpdating && !nextProps.isPasswordUpdating) {
        if (!nextProps.isPasswordUpdateFailed) {
          // successfully updated
          dispatch((0, _alertMessage.emitAlertMessage)("label:パスワードを更新しました", "success"));
          nextProps.resetUI();
        }
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    currentPassword: '',
    currentPasswordError: undefined,
    newPassword: '',
    newPasswordError: undefined,
    confirmNewPassword: '',
    confirmNewPasswordError: undefined
  }
}), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserFavoritesPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userFavoritesPanel = __webpack_require__(2182);

var _userFavoritesPanel2 = _interopRequireDefault(_userFavoritesPanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _list = __webpack_require__(25);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/user-favorites-panel.jsx

var UserFavoritesPanel = function (_React$Component) {
  _inherits(UserFavoritesPanel, _React$Component);

  function UserFavoritesPanel() {
    _classCallCheck(this, UserFavoritesPanel);

    return _possibleConstructorReturn(this, (UserFavoritesPanel.__proto__ || Object.getPrototypeOf(UserFavoritesPanel)).apply(this, arguments));
  }

  _createClass(UserFavoritesPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          isFetching = _props.isFetching,
          favorites = _props.favorites,
          current = _props.current,
          groups = _props.groups,
          favoriteGroup = _props.favoriteGroup,
          favoriteUser = _props.favoriteUser,
          setFavoriteUser = _props.setFavoriteUser,
          showUserSelectionDialog = _props.showUserSelectionDialog;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(
            'normal',
            null,
            _react2.default.createElement(
              'strong',
              null,
              t('label:グループ')
            )
          ),
          _react2.default.createElement(
            _list.List,
            { selectable: true },
            groups && groups.length > 0 && groups.map(function (group) {
              return _react2.default.createElement(_list.ListItem, { key: group.group_id,
                disabled: isFetching,
                caption: group.name,
                avatar: group.icon_image.thumb_url,
                rightIcon: _react2.default.createElement(_font_icon2.default, { value: group.favorite ? 'flag' : 'outlined_flag',
                  style: { color: group.favorite && '#FFCC00' || '#000', fontSize: '24px' } }),
                onClick: function onClick() {
                  return favoriteGroup(group, !group.favorite);
                } });
            }),
            groups && groups.length == 0 && _react2.default.createElement(_list.ListItem, { caption: t('label:お気に入り登録されたグループはありません') })
          )
        ),
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(
            'normal',
            null,
            _react2.default.createElement(
              'strong',
              null,
              t('label:ユーザ')
            )
          ),
          _react2.default.createElement(
            _card.CardActions,
            null,
            _react2.default.createElement(_button.Button, { theme: _successButton2.default,
              raised: true,
              floating: true,
              mini: true,
              label: t('label:ユーザ追加'),
              icon: 'add',
              style: { verticalAlign: 'bottom', mergin: '2px 5px' },
              onClick: function onClick() {
                return showUserSelectionDialog(t('label:ユーザを選択'), true, 'ACCOUNT_MEMBERS', undefined, undefined, function (users) {
                  return setFavoriteUser(users, _this2.props);
                });
              } })
          ),
          _react2.default.createElement(
            _list.List,
            { selectable: true },
            favorites && favorites.length > 0 && favorites.map(function (user) {
              return _react2.default.createElement(_list.ListItem, { key: user.user_id,
                disabled: isFetching,
                caption: user.name,
                avatar: user.icon_image.thumb_url,
                rightIcon: _react2.default.createElement(_font_icon2.default, { value: 'flag', style: { color: '#FFCC00', fontSize: '24px' } }),
                onClick: function onClick() {
                  return favoriteUser(user, false);
                } });
            }),
            favorites && favorites.length == 0 && _react2.default.createElement(_list.ListItem, { caption: t('label:お気に入り登録されたユーザはありません') })
          )
        )
      );
    }
  }]);

  return UserFavoritesPanel;
}(_react2.default.Component);

var RawUserFavoritesPanel = exports.RawUserFavoritesPanel = UserFavoritesPanel;
exports.default = (0, _userFavoritesPanel2.default)(UserFavoritesPanel);

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/user-favorites-panel.js

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _alertMessage = __webpack_require__(13);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.favorite.isFetching,
    favorites: state.favorite.users,
    _groups: state.groups.items,
    current: state.user.current
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var groups = (0, _filter2.default)(stateProps._groups, function (item) {
    return !item.is_member && item.can_read || item.favorite;
  });

  return _extends({}, stateProps, dispatchProps, ownProps, {
    groups: groups
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    favoriteGroup: function favoriteGroup(group, favorite) {
      dispatch(_actions2.default.updateFavoriteGroup(group.group_id, favorite));
      if (favorite) dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:お気に入りグループに追加しました', name: group.name }, 'success'));else dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:お気に入りグループから削除しました', name: group.name }, 'success'));
    },

    favoriteUser: function favoriteUser(user, favorite) {
      dispatch(_actions2.default.updateFavoriteUser(user.user_id, favorite));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:お気に入りユーザから削除しました', name: user.name }, 'success'));
    },

    setFavoriteUser: function setFavoriteUser(users, props) {
      if (!users) return;
      var unfavorites = (0, _filter2.default)((0, _filter2.default)(users, function (user) {
        return user.user_id != props.current.user_id;
      }), // 自分以外のユーザのリストを作り、
      function (user) {
        return !(0, _find2.default)(props.favorites, function (fav) {
          return fav.user_id == user.user_id;
        });
      } // favoritesに含まれていないものを抽出
      );
      (0, _each2.default)(unfavorites, function (user) {
        dispatch(_actions2.default.updateFavoriteUser(user.user_id, true));
      });
      if (unfavorites.length > 0) {
        var names = (0, _map2.default)(unfavorites, function (user) {
          return user.name;
        }).join(', ');
        dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:お気に入りユーザに追加しました', name: names }, 'success'));
      } else {
        if (users.length == 1 && users.find(function (user) {
          return user.user_id == props.current.user_id;
        })) {
          dispatch((0, _alertMessage.emitAlertMessage)('label:自身のフォローはできません', 'error'));
        } else {
          dispatch((0, _alertMessage.emitAlertMessage)('label:すでにフォロー設定済みです', 'success'));
        }
      }
    },

    willMount: function willMount() {
      return dispatch(_actions2.default.fetchFavoriteUsers());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _context2.default)({ showUserSelectionDialog: _propTypes2.default.func }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserProfilePanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userProfilePanel = __webpack_require__(2184);

var _userProfilePanel2 = _interopRequireDefault(_userProfilePanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _input = __webpack_require__(59);

var _reactRangeslider = __webpack_require__(348);

var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);

__webpack_require__(349);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _fileUploadButton = __webpack_require__(180);

var _fileUploadButton2 = _interopRequireDefault(_fileUploadButton);

var _richTextEditor = __webpack_require__(181);

var _richTextEditor2 = _interopRequireDefault(_richTextEditor);

var _formValidator = __webpack_require__(41);

var _reactAvatarEditor = __webpack_require__(352);

var _reactAvatarEditor2 = _interopRequireDefault(_reactAvatarEditor);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _datePicker = __webpack_require__(165);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/user-profile-panel.jsx

// import Slider from 'react-toolbox/lib/slider' Slide in React Toolbx is buggy...


function calcCrop(avatar) {
  // Check if avatar and necessary nested properties exist
  if (!avatar || !avatar.state || !avatar.state.image || !avatar.state.image.resource) {
    return undefined;
  }

  var rect = avatar.getCroppingRect();
  var width = avatar.state.image.resource.width;
  var height = avatar.state.image.resource.height;
  //console.log(`rect x:${rect.x} y:${rect.y} w:${rect.width} h:${rect.height}, image: w:${width} h:${height}`)
  //console.log(`calc x:${width * rect.x} y:${height * rect.y} w:${width * rect.width} h:${height * rect.height}`)

  return {
    x: width * rect.x,
    y: height * rect.y,
    width: width * rect.width,
    height: height * rect.height
  };
}

var UserProfilePanel = function (_React$Component) {
  _inherits(UserProfilePanel, _React$Component);

  function UserProfilePanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserProfilePanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserProfilePanel.__proto__ || Object.getPrototypeOf(UserProfilePanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = { scale: 1.5, importConfirm: false }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserProfilePanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          isProfileUpdating = _props.isProfileUpdating,
          user = _props.user,
          updateUI = _props.updateUI,
          uploadFile = _props.uploadFile,
          uploadedFile = _props.uploadedFile,
          validateAndSubmit = _props.validateAndSubmit,
          isUploading = _props.isUploading,
          importUserProfileTemplate = _props.importUserProfileTemplate,
          userProfileTemplate = _props.userProfileTemplate,
          clearUserProfileTemplate = _props.clearUserProfileTemplate;


      var departmentDropDownList = [{ value: 0, label: t('label:部署を選択') }];

      if (user && user.department_list) {
        departmentDropDownList = [{ value: 0, label: t(user.department_list.length > 0 ? 'label:部署を選択' : 'label:部署が設定されていません') }].concat(_toConsumableArray(user.department_list.map(function (item) {
          return { value: item.id, label: item.name };
        })));
      }

      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return validateAndSubmit(_this2.props, calcCrop(_this2.refs.avatar), e);
            } },
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:ユーザ名')
              )
            ),
            _react2.default.createElement(_input.Input, { name: 'userName', required: true,
              label: t('label:ユーザ名'),
              value: ui.name,
              icon: 'person',
              error: ui.nameError && t('error:ユーザ名を入力してください'),
              onChange: (0, _formValidator.linkUI)(this, 'name') })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:アイコン画像')
              )
            ),
            _react2.default.createElement('br', null),
            !uploadedFile && !isUploading && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('img', { style: { width: 100, height: 100, borderRadius: '50%' }, src: user.icon_image.thumb_url })
            ),
            uploadedFile && !isUploading && uploadedFile.file && _react2.default.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'column', width: 210 } },
              _react2.default.createElement(_reactAvatarEditor2.default, { ref: 'avatar',
                image: uploadedFile.file.thumb_url,
                width: 200,
                height: 200,
                border: 5,
                scale: this.state.scale,
                style: { cursor: 'move' } }),
              _react2.default.createElement(_reactRangeslider2.default, {
                min: 1,
                max: 5,
                step: 0.05,
                tooltip: false,
                value: this.state.scale,
                onChange: function onChange(value) {
                  return _this2.setState({ scale: value });
                } })
            ),
            isUploading && _react2.default.createElement(
              'div',
              { style: { height: '100%', width: '100%', display: 'flex', justifyContent: 'flex-start', marginLeft: '10px' } },
              _react2.default.createElement(_progress_bar2.default, { type: 'circular', multicolor: true, mode: 'indeterminate' })
            ),
            _react2.default.createElement(_fileUploadButton2.default, { raised: true,
              icon: 'add_a_photo',
              label: '\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E',
              single: true,
              onChange: function onChange(file) {
                return uploadFile(_this2.props, file);
              } })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:社員番号')
              )
            ),
            _react2.default.createElement(_input.Input, { name: 'employmentNumber',
              label: t('label:社員番号'),
              value: ui.employmentNumber,
              icon: 'badge',
              onChange: (0, _formValidator.linkUI)(this, 'employmentNumber') })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:部署')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _flatCard2.default.departmentContainer },
              _react2.default.createElement(_font_icon2.default, { value: 'school', className: _flatCard2.default.fontIcon }),
              _react2.default.createElement(_dropdown2.default, { auto: true,
                label: t('label:部署'),
                className: _flatCard2.default.department_dropdown,
                source: departmentDropDownList,
                value: ui.department_id,
                onChange: function onChange(value) {
                  return updateUI({ department_id: value });
                }
              })
            )
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:誕生日')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _flatCard2.default.datePickerContainer },
              _react2.default.createElement(_font_icon2.default, { value: 'event_note', className: _flatCard2.default.fontIcon }),
              !ui.isUpdateBirthday && _react2.default.createElement(_button.Button, { theme: _flatCard2.default, raised: true, neutral: true, ripple: true,
                icon: "add",
                onClick: function onClick() {
                  return updateUI({ isUpdateBirthday: true });
                },
                label: t('label:誕生日を追加') }),
              ui.isUpdateBirthday && _react2.default.createElement(
                'div',
                { style: { display: 'flex' } },
                _react2.default.createElement(_datePicker2.default, {
                  label: t('label:誕生日'),
                  value: ui.birthday.toDate(),
                  onChange: function onChange(date) {
                    return updateUI({ birthday: (0, _moment2.default)(date) });
                  } }),
                _react2.default.createElement(_button.Button, { theme: _flatCard2.default, raised: true, neutral: true, ripple: true,
                  className: _flatCard2.default.cancelBirthdayBtn,
                  icon: "close",
                  onClick: function onClick() {
                    return updateUI({ isUpdateBirthday: false });
                  },
                  label: t('label:削除') })
              )
            )
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:自己紹介')
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_richTextEditor2.default, {
              userDescription: true,
              value: user && user.description,
              userProfileTemplate: userProfileTemplate && userProfileTemplate,
              importUserProfileTemplate: importUserProfileTemplate,
              clearUserProfileTemplate: clearUserProfileTemplate,
              onEditorInitialized: function onEditorInitialized(handlers) {
                updateUI({ handlers: handlers });
                user.description && setTimeout(function () {
                  return handlers.insertValue(user.description);
                }, 0);
              } })
          ),
          _react2.default.createElement(
            _card.CardActions,
            null,
            _react2.default.createElement(_button.Button, { raised: true, primary: true,
              type: 'submit',
              disabled: isProfileUpdating,
              style: { width: '100%' },
              label: t('label:更新') })
          )
        )
      );
    }
  }]);

  return UserProfilePanel;
}(_react2.default.Component);

var RawUserProfilePanel = exports.RawUserProfilePanel = UserProfilePanel;
exports.default = (0, _userProfilePanel2.default)(UserProfilePanel);

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/user-profile-panel.js

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _fileUpload = __webpack_require__(179);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _componentId = __webpack_require__(164);

var _componentId2 = _interopRequireDefault(_componentId);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _formValidator = __webpack_require__(41);

var _alertMessage = __webpack_require__(13);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var uploadFile = state.uploadFile[ownProps.componentId];

  return {
    user: state.user.current,
    isProfileUpdating: state.user.isProfileUpdating,
    isProfileUpdateFailed: state.user.isProfileUpdateFailed,
    _uploadFile: state.uploadFile[ownProps.componentId],
    userProfileTemplate: state.templates && state.templates.userProfileTemplate && state.templates.userProfileTemplate
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var uploadFile;
  if (stateProps._uploadFile) {
    uploadFile = (0, _find2.default)(stateProps._uploadFile, function (value, key) {
      return value;
    });
  }

  return _extends({
    isUploading: uploadFile && uploadFile.isUploading,
    uploadedFile: uploadFile && uploadFile.item
  }, ownProps, stateProps, dispatchProps);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    validateAndSubmit: function validateAndSubmit(props, crop) {
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      if (event && event.preventDefault) event.preventDefault();

      (0, _formValidator.validate)(props.ui, {
        name: { rule: 'isRequired' }
      }, function (errors, nextUI) {
        props.updateUI(nextUI);
        if (!errors) props.ui.handlers && props.ui.handlers.getValue(function (desc) {
          dispatch(_actions2.default.updateUserProfile(props.ui.name, props.uploadedFile && props.uploadedFile.file_id, props.ui.employmentNumber, props.ui.department_id, props.ui.birthday.format('YYYY-MM-DD'), props.ui.isUpdateBirthday, crop, desc));
        });
      });
      return false;
    },

    uploadFile: function uploadFile(props, file) {
      return !props.isUploading && (0, _fileUpload2.default)(file, dispatch, props.user.user_id, 'user', ownProps.componentId, true);
    },

    importUserProfileTemplate: function importUserProfileTemplate() {
      dispatch(_actions2.default.importUserProfileTemplate());
    },

    clearUserProfileTemplate: function clearUserProfileTemplate() {
      dispatch(_actions2.default.clearUserProfileTemplate());
    },

    willUpdate: function willUpdate(props, nextProps) {
      // changing isFetching true => false
      if (props.isProfileUpdating && !nextProps.isProfileUpdating) {
        if (!nextProps.isProfileUpdateFailed) {
          // successfully updated
          dispatch(_actions2.default.clearUploadFilesAndVideos(nextProps.componentId));
          nextProps.updateUI({
            name: nextProps.user.name,
            nameError: undefined
          });
          dispatch((0, _alertMessage.emitAlertMessage)("label:プロフィールを更新しました", "success"));
        }
      }
    },

    willUnmount: function willUnmount(props) {
      dispatch(_actions2.default.clearUploadFilesAndVideos(props.componentId));
    }
  };
};

exports.default = (0, _combineHoc2.default)(_componentId2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: {
    name: function name(props) {
      return props.user && props.user.name;
    },
    nameError: undefined,
    handlers: undefined,
    employmentNumber: function employmentNumber(props) {
      return props.user && props.user.employment_number;
    },
    department_id: function department_id(props) {
      return props.user && props.user.department ? props.user.department.id : 0;
    },
    birthday: function birthday(props) {
      return props.user && props.user.birthday ? (0, _moment2.default)(props.user.birthday) : (0, _moment2.default)(new Date());
    },
    isUpdateBirthday: function isUpdateBirthday(props) {
      return props.user && props.user.birthday ? true : false;
    }
  } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('user_profile'));

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = exports.Calendar = exports.datePickerFactory = exports.DatePickerDialog = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _events = __webpack_require__(143);

var _events2 = _interopRequireDefault(_events);

var _time = __webpack_require__(145);

var _time2 = _interopRequireDefault(_time);

var _IconButton = __webpack_require__(338);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Input = __webpack_require__(223);

var _Input2 = _interopRequireDefault(_Input);

var _Dialog = __webpack_require__(477);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Calendar = __webpack_require__(935);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _DatePickerDialog = __webpack_require__(936);

var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(Input, DatePickerDialog) {
  var DatePicker = function (_Component) {
    _inherits(DatePicker, _Component);

    function DatePicker() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, DatePicker);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: _this.props.active
      }, _this.handleDismiss = function () {
        _this.setState({ active: false });
        if (_this.props.onDismiss) {
          _this.props.onDismiss();
        }
      }, _this.handleInputFocus = function (event) {
        _events2.default.pauseEvent(event);
        _this.setState({ active: true });
      }, _this.handleInputBlur = function (event) {
        _events2.default.pauseEvent(event);
        _this.setState({ active: false });
      }, _this.handleInputClick = function (event) {
        _events2.default.pauseEvent(event);
        _this.setState({ active: true });
        if (_this.props.onClick) _this.props.onClick(event);
      }, _this.handleInputKeyPress = function (event) {
        if (event.charCode === 13) {
          _events2.default.pauseEvent(event);
          _this.setState({ active: true });
        }
        if (_this.props.onKeyPress) _this.props.onKeyPress(event);
      }, _this.handleSelect = function (value, event) {
        if (_this.props.onChange) _this.props.onChange(value, event);
        _this.setState({ active: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(DatePicker, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.active !== this.props.active && this.state.active !== nextProps.active) {
          this.setState({ active: nextProps.active });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            active = _props.active,
            onDismiss = _props.onDismiss,
            autoOk = _props.autoOk,
            cancelLabel = _props.cancelLabel,
            enabledDates = _props.enabledDates,
            disabledDates = _props.disabledDates,
            inputClassName = _props.inputClassName,
            inputFormat = _props.inputFormat,
            locale = _props.locale,
            maxDate = _props.maxDate,
            minDate = _props.minDate,
            okLabel = _props.okLabel,
            onEscKeyDown = _props.onEscKeyDown,
            onOverlayClick = _props.onOverlayClick,
            readonly = _props.readonly,
            sundayFirstDayOfWeek = _props.sundayFirstDayOfWeek,
            value = _props.value,
            others = _objectWithoutProperties(_props, ['active', 'onDismiss', 'autoOk', 'cancelLabel', 'enabledDates', 'disabledDates', 'inputClassName', 'inputFormat', 'locale', 'maxDate', 'minDate', 'okLabel', 'onEscKeyDown', 'onOverlayClick', 'readonly', 'sundayFirstDayOfWeek', 'value']);

        var finalInputFormat = inputFormat || _time2.default.formatDate;
        var date = Object.prototype.toString.call(value) === '[object Date]' ? value : undefined;
        var formattedDate = date === undefined ? '' : finalInputFormat(value, locale);

        return _react2.default.createElement(
          'div',
          {
            'data-react-toolbox': 'date-picker',
            className: this.props.theme.container
          },
          _react2.default.createElement(Input, _extends({}, others, {
            className: (0, _classnames3.default)(this.props.theme.input, _defineProperty({}, inputClassName, inputClassName)),
            disabled: readonly,
            error: this.props.error,
            icon: this.props.icon,
            label: this.props.label,
            name: this.props.name,
            onFocus: this.handleInputFocus,
            onKeyPress: this.handleInputKeyPress,
            onClick: this.handleInputClick,
            readOnly: true,
            type: 'text',
            value: formattedDate
          })),
          _react2.default.createElement(DatePickerDialog, {
            active: this.state.active,
            autoOk: autoOk,
            cancelLabel: cancelLabel,
            className: this.props.className,
            disabledDates: disabledDates,
            enabledDates: enabledDates,
            locale: locale,
            maxDate: maxDate,
            minDate: minDate,
            name: this.props.name,
            onDismiss: this.handleDismiss,
            okLabel: okLabel,
            onEscKeyDown: onEscKeyDown || this.handleDismiss,
            onOverlayClick: onOverlayClick || this.handleDismiss,
            onSelect: this.handleSelect,
            sundayFirstDayOfWeek: sundayFirstDayOfWeek,
            theme: this.props.theme,
            value: date
          })
        );
      }
    }]);

    return DatePicker;
  }(_react.Component);

  DatePicker.propTypes = {
    active: _propTypes2.default.bool,
    autoOk: _propTypes2.default.bool,
    cancelLabel: _propTypes2.default.string,
    className: _propTypes2.default.string,
    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
    error: _propTypes2.default.string,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    inputClassName: _propTypes2.default.string,
    inputFormat: _propTypes2.default.func,
    label: _propTypes2.default.string,
    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    maxDate: _propTypes2.default.instanceOf(Date),
    minDate: _propTypes2.default.instanceOf(Date),
    name: _propTypes2.default.string,
    okLabel: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    onDismiss: _propTypes2.default.func,
    onEscKeyDown: _propTypes2.default.func,
    onKeyPress: _propTypes2.default.func,
    onOverlayClick: _propTypes2.default.func,
    readonly: _propTypes2.default.bool,
    sundayFirstDayOfWeek: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      container: _propTypes2.default.string,
      input: _propTypes2.default.string
    }),
    value: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.string])
  };
  DatePicker.defaultProps = {
    active: false,
    locale: 'en',
    sundayFirstDayOfWeek: false
  };


  return DatePicker;
};

var Calendar = (0, _Calendar2.default)(_IconButton2.default);
var DatePickerDialog = (0, _DatePickerDialog2.default)(_Dialog2.default, Calendar);
var DatePicker = factory(_Input2.default, DatePickerDialog);

exports.default = (0, _reactCssThemr.themr)(_identifiers.DATE_PICKER)(DatePicker);
exports.DatePickerDialog = DatePickerDialog;
exports.datePickerFactory = factory;
exports.Calendar = Calendar;
exports.DatePicker = DatePicker;

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(106);

var _time = __webpack_require__(145);

var _time2 = _interopRequireDefault(_time);

var _CalendarDay = __webpack_require__(2187);

var _CalendarDay2 = _interopRequireDefault(_CalendarDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.handleDayClick = function (day) {
      if (_this.props.onDayClick) _this.props.onDayClick(day);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'isDayDisabled',
    value: function isDayDisabled(date) {
      var _props = this.props,
          minDate = _props.minDate,
          maxDate = _props.maxDate,
          enabledDates = _props.enabledDates,
          disabledDates = _props.disabledDates;

      var compareDate = function compareDate(compDate) {
        return date.getTime() === compDate.getTime();
      };
      var dateInDisabled = disabledDates.filter(compareDate).length > 0;
      var dateInEnabled = enabledDates.filter(compareDate).length > 0;
      return _time2.default.dateOutOfRange(date, minDate, maxDate) || enabledDates.length > 0 && !dateInEnabled || dateInDisabled;
    }
  }, {
    key: 'renderWeeks',
    value: function renderWeeks() {
      var _this2 = this;

      var days = (0, _utils.range)(0, 7).map(function (d) {
        return _time2.default.getDayOfWeekLetter(d, _this2.props.locale);
      });
      var source = this.props.sundayFirstDayOfWeek ? days : [].concat(_toConsumableArray(days.slice(1)), [days[0]]);
      return source.map(function (day, i) {
        return _react2.default.createElement(
          'span',
          { key: i },
          day
        );
      }); // eslint-disable-line
    }
  }, {
    key: 'renderDays',
    value: function renderDays() {
      var _this3 = this;

      return (0, _utils.range)(1, _time2.default.getDaysInMonth(this.props.viewDate) + 1).map(function (i) {
        var date = new Date(_this3.props.viewDate.getFullYear(), _this3.props.viewDate.getMonth(), i);
        return _react2.default.createElement(_CalendarDay2.default, {
          key: i,
          day: i,
          disabled: _this3.isDayDisabled(date),
          onClick: _this3.handleDayClick,
          selectedDate: _this3.props.selectedDate,
          theme: _this3.props.theme,
          viewDate: _this3.props.viewDate,
          sundayFirstDayOfWeek: _this3.props.sundayFirstDayOfWeek
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var fullMonth = _time2.default.getFullMonth(this.props.viewDate, this.props.locale);
      var fullYear = this.props.viewDate.getFullYear();
      return _react2.default.createElement(
        'div',
        { 'data-react-toolbox': 'month', className: this.props.theme.month },
        _react2.default.createElement(
          'span',
          { className: this.props.theme.title },
          fullMonth,
          ' ',
          fullYear
        ),
        _react2.default.createElement(
          'div',
          { className: this.props.theme.week },
          this.renderWeeks()
        ),
        _react2.default.createElement(
          'div',
          { className: this.props.theme.days },
          this.renderDays()
        )
      );
    }
  }]);

  return Month;
}(_react.Component);

Month.propTypes = {
  disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
  enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
  locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  maxDate: _propTypes2.default.instanceOf(Date),
  minDate: _propTypes2.default.instanceOf(Date),
  onDayClick: _propTypes2.default.func,
  selectedDate: _propTypes2.default.instanceOf(Date),
  sundayFirstDayOfWeek: _propTypes2.default.bool,
  theme: _propTypes2.default.shape({
    days: _propTypes2.default.string,
    month: _propTypes2.default.string,
    title: _propTypes2.default.string,
    week: _propTypes2.default.string
  }),
  viewDate: _propTypes2.default.instanceOf(Date)
};
Month.defaultProps = {
  disabledDates: [],
  enabledDates: []
};
exports.default = Month;

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _time = __webpack_require__(145);

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Day.__proto__ || Object.getPrototypeOf(Day)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      if (!_this.props.disabled && _this.props.onClick) {
        _this.props.onClick(_this.props.day);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Day, [{
    key: 'dayStyle',
    value: function dayStyle() {
      if (this.props.day === 1) {
        var e = this.props.sundayFirstDayOfWeek ? 0 : 1;
        var firstDay = _time2.default.getFirstWeekDay(this.props.viewDate) - e;
        return {
          marginLeft: (firstDay >= 0 ? firstDay : 6) * (100 / 7) + '%'
        };
      }
      return undefined;
    }
  }, {
    key: 'isSelected',
    value: function isSelected() {
      var sameYear = this.props.viewDate.getFullYear() === this.props.selectedDate.getFullYear();
      var sameMonth = this.props.viewDate.getMonth() === this.props.selectedDate.getMonth();
      var sameDay = this.props.day === this.props.selectedDate.getDate();
      return sameYear && sameMonth && sameDay;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var className = (0, _classnames3.default)(this.props.theme.day, (_classnames = {}, _defineProperty(_classnames, this.props.theme.active, this.isSelected()), _defineProperty(_classnames, this.props.theme.disabled, this.props.disabled), _classnames));

      return _react2.default.createElement(
        'div',
        {
          'data-react-toolbox': 'day',
          className: className,
          style: this.dayStyle()
        },
        _react2.default.createElement(
          'span',
          { onClick: this.handleClick },
          this.props.day
        )
      );
    }
  }]);

  return Day;
}(_react.Component);

Day.propTypes = {
  day: _propTypes2.default.number,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  selectedDate: _propTypes2.default.instanceOf(Date),
  sundayFirstDayOfWeek: _propTypes2.default.bool,
  theme: _propTypes2.default.shape({
    active: _propTypes2.default.string,
    day: _propTypes2.default.string,
    disabled: _propTypes2.default.string
  }),
  viewDate: _propTypes2.default.instanceOf(Date)
};
exports.default = Day;

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2189);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--input--3HJ20iKU:not(.theme--disabled--1kt8XdpH) > .theme--inputElement--bb4VFelH {\n  cursor: pointer;\n}\n.theme--header--2fVa-1ox {\n  background-color: rgb(63, 81, 181);\n  color: rgb(255, 255, 255);\n  cursor: pointer;\n  padding: 16px 20px;\n}\n.theme--year--3E7zdM8x {\n  display: inline-block;\n  font-size: 14px;\n  transition: opacity, font-size 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.theme--date--1yJLuTVD {\n  display: block;\n  font-size: 34px;\n  font-weight: 400;\n  font-weight: 500;\n  line-height: 40px;\n  margin: 0;\n  text-transform: capitalize;\n  transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.theme--calendarWrapper--2F05vCNb {\n  padding: 10px 5px 0;\n}\n.theme--yearsDisplay--tCooy5xm .theme--date--1yJLuTVD {\n  opacity: 0.6;\n}\n.theme--yearsDisplay--tCooy5xm .theme--year--3E7zdM8x {\n  font-size: 16px;\n}\n.theme--monthsDisplay--3Zom5Zkc .theme--year--3E7zdM8x {\n  opacity: 0.6;\n}\n.theme--dialog--2cJZUls- {\n  width: 330px\n}\n.theme--dialog--2cJZUls- > [role='body'] {\n  padding: 0;\n}\n.theme--dialog--2cJZUls- > [role='navigation'] > .theme--button--1MjRXuiu {\n  color: rgb(63, 81, 181);\n}\n.theme--dialog--2cJZUls- > [role='navigation'] > .theme--button--1MjRXuiu:hover {\n  background: rgba(63, 81, 181, 0.2);\n}\n.theme--dialog--2cJZUls- > [role='navigation'] > .theme--button--1MjRXuiu:focus:not(:active) {\n  background: rgba(63, 81, 181, 0.2);\n}\n.theme--calendar--3qUAcevG {\n  background: rgb(255, 255, 255);\n  font-size: 14px;\n  height: 312px;\n  line-height: 36px;\n  overflow: hidden;\n  position: relative;\n  text-align: center\n}\n.theme--calendar--3qUAcevG .theme--prev--bzQZVAxK,\n  .theme--calendar--3qUAcevG .theme--next--3dYhrjdF {\n  cursor: pointer;\n  height: 36px;\n  opacity: 0.7;\n  position: absolute;\n  top: 0;\n  z-index: 100;\n}\n.theme--calendar--3qUAcevG .theme--prev--bzQZVAxK > span, .theme--calendar--3qUAcevG .theme--next--3dYhrjdF > span {\n  vertical-align: top;\n}\n.theme--calendar--3qUAcevG .theme--prev--bzQZVAxK {\n  left: 0;\n}\n.theme--calendar--3qUAcevG .theme--next--3dYhrjdF {\n  right: 0;\n}\n.theme--title--z-ZtHF9Z {\n  display: inline-block;\n  font-weight: 500;\n  line-height: 36px;\n}\n.theme--years--35bJHs2B {\n  font-size: 18px;\n  height: 100%;\n  list-style: none;\n  margin: 0;\n  overflow-y: auto;\n  padding: 0\n}\n.theme--years--35bJHs2B > li {\n  cursor: pointer;\n  line-height: 2.4;\n}\n.theme--years--35bJHs2B > li.theme--active--26lIv7gc {\n  color: rgb(63, 81, 181);\n  font-size: 2.4;\n  font-weight: 500;\n}\n.theme--week--1Ujd1ydn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  font-size: 13px;\n  height: 36px;\n  line-height: 36px;\n  opacity: 0.5\n}\n.theme--week--1Ujd1ydn > span {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 14.28571%;\n          flex: 0 0 14.28571%;\n}\n.theme--days--1eNexT94 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  font-size: 13px;\n}\n.theme--day--3b-GZwNh {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 14.28571%;\n          flex: 0 0 14.28571%;\n  padding: 2px 0\n}\n.theme--day--3b-GZwNh > span {\n  border-radius: 50%;\n  display: inline-block;\n  height: 36px;\n  line-height: 36px;\n  width: 36px;\n}\n.theme--day--3b-GZwNh:hover:not(.theme--active--26lIv7gc):not(.theme--disabled--1kt8XdpH) > span {\n  background: rgba(63, 81, 181, 0.21);\n  color: rgb(255, 255, 255);\n}\n.theme--day--3b-GZwNh.theme--active--26lIv7gc > span {\n  background: rgb(63, 81, 181);\n  color: rgb(255, 255, 255);\n}\n.theme--day--3b-GZwNh:hover:not(.theme--disabled--1kt8XdpH) > span {\n  cursor: pointer;\n}\n.theme--day--3b-GZwNh.theme--disabled--1kt8XdpH {\n  opacity: 0.25;\n}\n.theme--month--2I9sxkJ6 {\n  background-color: rgb(255, 255, 255);\n}\n.theme--slideRightEnter--1AvSnwra,\n.theme--slideRightLeave--esBCVM60 {\n  position: absolute;\n}\n.theme--slideRightEnterActive--32doyHBD,\n.theme--slideRightLeaveActive--MohFpgWQ {\n  transition-duration: 350ms;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  transition-timing-function: ease-in-out;\n}\n.theme--slideRightEnter--1AvSnwra {\n  opacity: 0;\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%)\n}\n.theme--slideRightEnter--1AvSnwra.theme--slideRightEnterActive--32doyHBD {\n  opacity: 1;\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n}\n.theme--slideRightLeave--esBCVM60 {\n  opacity: 1;\n  -webkit-transform: translateX(0);\n          transform: translateX(0)\n}\n.theme--slideRightLeave--esBCVM60.theme--slideRightLeaveActive--MohFpgWQ {\n  opacity: 0;\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.theme--slideLeftEnter--2FFk_Hfg,\n.theme--slideLeftLeave--1XadboFG {\n  position: absolute;\n  transition-duration: 0.35s;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  transition-timing-function: ease-in-out;\n}\n.theme--slideLeftEnter--2FFk_Hfg {\n  opacity: 0;\n  -webkit-transform: translate3d(-100%, 0, 0);\n          transform: translate3d(-100%, 0, 0)\n}\n.theme--slideLeftEnter--2FFk_Hfg.theme--slideLeftEnterActive--93ac80Cx {\n  opacity: 1;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n.theme--slideLeftLeave--1XadboFG {\n  opacity: 1;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0)\n}\n.theme--slideLeftLeave--1XadboFG.theme--slideLeftLeaveActive--RUan23kG {\n  opacity: 0;\n  -webkit-transform: translate3d(100%, 0, 0);\n          transform: translate3d(100%, 0, 0);\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/date_picker/theme.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;CACjB;AACD;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;CACpB;AACD;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kEAAkE;CACnE;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,uDAAuD;CACxD;AACD;EACE,oBAAoB;CACrB;AACD;EACE,aAAa;CACd;AACD;EACE,gBAAgB;CACjB;AACD;EACE,aAAa;CACd;AACD;EACE,YAAY;CACb;AACD;EACE,WAAW;CACZ;AACD;EACE,wBAAwB;CACzB;AACD;EACE,mCAAmC;CACpC;AACD;EACE,mCAAmC;CACpC;AACD;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;CACnB;AACD;;EAEE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;CACd;AACD;EACE,oBAAoB;CACrB;AACD;EACE,QAAQ;CACT;AACD;EACE,SAAS;CACV;AACD;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,UAAU;CACX;AACD;EACE,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;CAClB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;MAChB,gBAAgB;EACpB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;CACb;AACD;EACE,oBAAoB;MAChB,wBAAwB;UACpB,oBAAoB;CAC7B;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;MAChB,gBAAgB;EACpB,gBAAgB;CACjB;AACD;EACE,oBAAoB;MAChB,wBAAwB;UACpB,oBAAoB;EAC5B,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,YAAY;CACb;AACD;EACE,oCAAoC;EACpC,0BAA0B;CAC3B;AACD;EACE,6BAA6B;EAC7B,0BAA0B;CAC3B;AACD;EACE,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,qCAAqC;CACtC;AACD;;EAEE,mBAAmB;CACpB;AACD;;EAEE,2BAA2B;EAC3B,gDAAgD;EAChD,wCAAwC;EACxC,2DAA2D;EAC3D,wCAAwC;CACzC;AACD;EACE,WAAW;EACX,oCAAoC;UAC5B,2BAA2B;CACpC;AACD;EACE,WAAW;EACX,iCAAiC;UACzB,yBAAyB;CAClC;AACD;EACE,WAAW;EACX,iCAAiC;UACzB,wBAAwB;CACjC;AACD;EACE,WAAW;EACX,qCAAqC;UAC7B,6BAA6B;CACtC;AACD;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,gDAAgD;EAChD,wCAAwC;EACxC,2DAA2D;EAC3D,wCAAwC;CACzC;AACD;EACE,WAAW;EACX,4CAA4C;UACpC,mCAAmC;CAC5C;AACD;EACE,WAAW;EACX,wCAAwC;UAChC,gCAAgC;CACzC;AACD;EACE,WAAW;EACX,wCAAwC;UAChC,+BAA+B;CACxC;AACD;EACE,WAAW;EACX,2CAA2C;UACnC,mCAAmC;CAC5C","file":"theme.css","sourcesContent":[".input:not(.disabled) > .inputElement {\n  cursor: pointer;\n}\n.header {\n  background-color: rgb(63, 81, 181);\n  color: rgb(255, 255, 255);\n  cursor: pointer;\n  padding: 16px 20px;\n}\n.year {\n  display: inline-block;\n  font-size: 14px;\n  transition: opacity, font-size 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.date {\n  display: block;\n  font-size: 34px;\n  font-weight: 400;\n  font-weight: 500;\n  line-height: 40px;\n  margin: 0;\n  text-transform: capitalize;\n  transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.calendarWrapper {\n  padding: 10px 5px 0;\n}\n.yearsDisplay .date {\n  opacity: 0.6;\n}\n.yearsDisplay .year {\n  font-size: 16px;\n}\n.monthsDisplay .year {\n  opacity: 0.6;\n}\n.dialog {\n  width: 330px\n}\n.dialog > [role='body'] {\n  padding: 0;\n}\n.dialog > [role='navigation'] > .button {\n  color: rgb(63, 81, 181);\n}\n.dialog > [role='navigation'] > .button:hover {\n  background: rgba(63, 81, 181, 0.2);\n}\n.dialog > [role='navigation'] > .button:focus:not(:active) {\n  background: rgba(63, 81, 181, 0.2);\n}\n.calendar {\n  background: rgb(255, 255, 255);\n  font-size: 14px;\n  height: 312px;\n  line-height: 36px;\n  overflow: hidden;\n  position: relative;\n  text-align: center\n}\n.calendar .prev,\n  .calendar .next {\n  cursor: pointer;\n  height: 36px;\n  opacity: 0.7;\n  position: absolute;\n  top: 0;\n  z-index: 100;\n}\n.calendar .prev > span, .calendar .next > span {\n  vertical-align: top;\n}\n.calendar .prev {\n  left: 0;\n}\n.calendar .next {\n  right: 0;\n}\n.title {\n  display: inline-block;\n  font-weight: 500;\n  line-height: 36px;\n}\n.years {\n  font-size: 18px;\n  height: 100%;\n  list-style: none;\n  margin: 0;\n  overflow-y: auto;\n  padding: 0\n}\n.years > li {\n  cursor: pointer;\n  line-height: 2.4;\n}\n.years > li.active {\n  color: rgb(63, 81, 181);\n  font-size: 2.4;\n  font-weight: 500;\n}\n.week {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  font-size: 13px;\n  height: 36px;\n  line-height: 36px;\n  opacity: 0.5\n}\n.week > span {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 14.28571%;\n          flex: 0 0 14.28571%;\n}\n.days {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  font-size: 13px;\n}\n.day {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 14.28571%;\n          flex: 0 0 14.28571%;\n  padding: 2px 0\n}\n.day > span {\n  border-radius: 50%;\n  display: inline-block;\n  height: 36px;\n  line-height: 36px;\n  width: 36px;\n}\n.day:hover:not(.active):not(.disabled) > span {\n  background: rgba(63, 81, 181, 0.21);\n  color: rgb(255, 255, 255);\n}\n.day.active > span {\n  background: rgb(63, 81, 181);\n  color: rgb(255, 255, 255);\n}\n.day:hover:not(.disabled) > span {\n  cursor: pointer;\n}\n.day.disabled {\n  opacity: 0.25;\n}\n.month {\n  background-color: rgb(255, 255, 255);\n}\n.slideRightEnter,\n.slideRightLeave {\n  position: absolute;\n}\n.slideRightEnterActive,\n.slideRightLeaveActive {\n  transition-duration: 350ms;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  transition-timing-function: ease-in-out;\n}\n.slideRightEnter {\n  opacity: 0;\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%)\n}\n.slideRightEnter.slideRightEnterActive {\n  opacity: 1;\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n}\n.slideRightLeave {\n  opacity: 1;\n  -webkit-transform: translateX(0);\n          transform: translateX(0)\n}\n.slideRightLeave.slideRightLeaveActive {\n  opacity: 0;\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.slideLeftEnter,\n.slideLeftLeave {\n  position: absolute;\n  transition-duration: 0.35s;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  transition-timing-function: ease-in-out;\n}\n.slideLeftEnter {\n  opacity: 0;\n  -webkit-transform: translate3d(-100%, 0, 0);\n          transform: translate3d(-100%, 0, 0)\n}\n.slideLeftEnter.slideLeftEnterActive {\n  opacity: 1;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n.slideLeftLeave {\n  opacity: 1;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0)\n}\n.slideLeftLeave.slideLeftLeaveActive {\n  opacity: 0;\n  -webkit-transform: translate3d(100%, 0, 0);\n          transform: translate3d(100%, 0, 0);\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"input": "theme--input--3HJ20iKU",
	"disabled": "theme--disabled--1kt8XdpH",
	"inputElement": "theme--inputElement--bb4VFelH",
	"header": "theme--header--2fVa-1ox",
	"year": "theme--year--3E7zdM8x",
	"date": "theme--date--1yJLuTVD",
	"calendarWrapper": "theme--calendarWrapper--2F05vCNb",
	"yearsDisplay": "theme--yearsDisplay--tCooy5xm",
	"monthsDisplay": "theme--monthsDisplay--3Zom5Zkc",
	"dialog": "theme--dialog--2cJZUls-",
	"button": "theme--button--1MjRXuiu",
	"calendar": "theme--calendar--3qUAcevG",
	"prev": "theme--prev--bzQZVAxK",
	"next": "theme--next--3dYhrjdF",
	"title": "theme--title--z-ZtHF9Z",
	"years": "theme--years--35bJHs2B",
	"active": "theme--active--26lIv7gc",
	"week": "theme--week--1Ujd1ydn",
	"days": "theme--days--1eNexT94",
	"day": "theme--day--3b-GZwNh",
	"month": "theme--month--2I9sxkJ6",
	"slideRightEnter": "theme--slideRightEnter--1AvSnwra",
	"slideRightLeave": "theme--slideRightLeave--esBCVM60",
	"slideRightEnterActive": "theme--slideRightEnterActive--32doyHBD",
	"slideRightLeaveActive": "theme--slideRightLeaveActive--MohFpgWQ",
	"slideLeftEnter": "theme--slideLeftEnter--2FFk_Hfg",
	"slideLeftLeave": "theme--slideLeftLeave--1XadboFG",
	"slideLeftEnterActive": "theme--slideLeftEnterActive--93ac80Cx",
	"slideLeftLeaveActive": "theme--slideLeftLeaveActive--RUan23kG"
};

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2191);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./date-picker.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./date-picker.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.date-picker--label--3wBjSZoV {\n  top: 12px;\n  color: rgb(33, 33, 33);\n}\n\n.date-picker--header--1YIibbwI {\n  background-color: rgb(255, 255, 255);\n  color: #757575;\n  cursor: auto;\n  padding: 10px 20px;\n}\n\n.date-picker--yearsDisplay--1w2AnSmw .date-picker--year--3whKxvUU {\n  font-size: 32px;\n  cursor: pointer;\n  color: #666;\n  padding: 5px;\n}\n\n.date-picker--monthsDisplay--32jLcG67 .date-picker--year--3whKxvUU {\n  opacity: 1;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.date-picker--monthsDisplay--32jLcG67 .date-picker--year--3whKxvUU:hover {\n  opacity: 1;\n  font-size: 24px;\n  cursor: pointer;\n  background: #DDDDDD;\n  padding: 5px;\n}\n\n.date-picker--date--3rbpz3Us {\n  display: none;\n}\n\n.date-picker--input--3bgP4Qmt {\n  padding: 0;\n}\n\n.date-picker--hint--1bXq6UXM {\n  top: 12px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/date-picker.css"],"names":[],"mappings":";AACA;EACE,UAAU;EACV,uBAAuB;CACxB;;AAED;EACE,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,mBAAmB;CACpB;;AAED;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;CACd;;AAED;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;CACd;;AAED;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;CACd;;AAED;EACE,cAAc;CACf;;AAED;EACE,WAAW;CACZ;;AAED;EACE,UAAU;CACX","file":"date-picker.css","sourcesContent":["\n.label {\n  top: 12px;\n  color: rgb(33, 33, 33);\n}\n\n.header {\n  background-color: rgb(255, 255, 255);\n  color: #757575;\n  cursor: auto;\n  padding: 10px 20px;\n}\n\n.yearsDisplay .year {\n  font-size: 32px;\n  cursor: pointer;\n  color: #666;\n  padding: 5px;\n}\n\n.monthsDisplay .year {\n  opacity: 1;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.monthsDisplay .year:hover {\n  opacity: 1;\n  font-size: 24px;\n  cursor: pointer;\n  background: #DDDDDD;\n  padding: 5px;\n}\n\n.date {\n  display: none;\n}\n\n.input {\n  padding: 0;\n}\n\n.hint {\n  top: 12px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"label": "date-picker--label--3wBjSZoV",
	"header": "date-picker--header--1YIibbwI",
	"yearsDisplay": "date-picker--yearsDisplay--1w2AnSmw",
	"year": "date-picker--year--3whKxvUU",
	"monthsDisplay": "date-picker--monthsDisplay--32jLcG67",
	"date": "date-picker--date--3rbpz3Us",
	"input": "date-picker--input--3bgP4Qmt",
	"hint": "date-picker--hint--1bXq6UXM"
};

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templatesPanel = __webpack_require__(937);

var _templatesPanel2 = _interopRequireDefault(_templatesPanel);

var _userTemplatesPanel = __webpack_require__(2195);

var _userTemplatesPanel2 = _interopRequireDefault(_userTemplatesPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/web/components/user-templates-panel.jsx

exports.default = (0, _userTemplatesPanel2.default)(_templatesPanel2.default);

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2194);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./template-panel.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./template-panel.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.template-panel--listItem--1rV1UfRM .template-panel--itemContentRoot--3nHHR_r5{\n    overflow: hidden;\n}\n\n.template-panel--listItem--1rV1UfRM .template-panel--itemText--2F4vKICf{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}", "", {"version":3,"sources":["/./src/web/components/themes/template-panel.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;CACpB;;AAED;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;CAC3B","file":"template-panel.css","sourcesContent":["\n.listItem .itemContentRoot{\n    overflow: hidden;\n}\n\n.listItem .itemText{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listItem": "template-panel--listItem--1rV1UfRM",
	"itemContentRoot": "template-panel--itemContentRoot--3nHHR_r5",
	"itemText": "template-panel--itemText--2F4vKICf"
};

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/user-templates-panel.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.current,
    templates: state.templates.items,
    isFetching: state.templates.isFetching
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    editTemplate: function editTemplate(props, template_id) {
      return ownProps.selectPanel('templates', 'edit', { template_id: template_id });
    },
    newTemplate: function newTemplate(props) {
      var cloneTemplate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return ownProps.selectPanel('templates', 'new', { template_id: undefined, type: 'user', id: props.user.user_id, cloneTemplate: cloneTemplate });
    },
    deleteTemplate: function deleteTemplate(template) {
      dispatch(_actions2.default.deleteTemplate(template.template_id));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: "label:テンプレートを削除しました", name: template.name }, "success"));
    },

    willMount: function willMount(props) {
      if (props.user) {
        dispatch(_actions2.default.fetchTemplates(props.user.user_id, 'user'));
      }
    },

    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearTemplates());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('user_templates'));

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserNotificationPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userNotificationPanel = __webpack_require__(2197);

var _userNotificationPanel2 = _interopRequireDefault(_userNotificationPanel);

var _reactToolbox = __webpack_require__(502);

var _list = __webpack_require__(25);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _userNotificationList = __webpack_require__(966);

var _userNotificationList2 = _interopRequireDefault(_userNotificationList);

var _switch = __webpack_require__(227);

var _switch2 = _interopRequireDefault(_switch);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
// src/web/components/user-notification-panel.jsx

var settingsMenuItems = [{ value: 'none', icon: 'notifications_off', caption: 'label:通知none', isMail: false, isPush: false }, { value: 'mail', icon: 'mail_outline', caption: 'label:通知mail', isMail: true, isPush: false }, { value: 'push', icon: 'tap_and_play', caption: 'label:通知push', isMail: false, isPush: true }, { value: 'all', icon: 'notifications_active', caption: 'label:通知all', isMail: true, isPush: true }];

// notify_alert_disyplay: mail means the flag for showing new message or not
// notify_alert_disyplay: push means the flag for showing message content or not

var scheduleTypeList = [{ value: 'everyday', label: '毎日' }, { value: 'weekday', label: '平日' }, { value: 'custom', label: 'カスタム' }];

var timeList = _lodash2.default.times(48, function (index) {
  var hour = Math.floor(index / 2).toString().padStart(2, '0');
  var minute = index % 2 === 0 ? '00' : '30';

  return { value: hour + ':' + minute, label: hour + ':' + minute };
});

// Add "none" option at the beginning to custom start time list
var customTimeList = [{ value: 'none', label: 'なし' }].concat(_toConsumableArray(timeList));

function SettingMenu(props) {
  var t = props.t,
      selected = props.selected,
      target = props.target,
      notification = props.notification,
      disableNone = props.disableNone,
      updateSetting = props.updateSetting,
      updateCollectiveSetting = props.updateCollectiveSetting,
      group = props.group,
      groups = props.groups,
      isSameSetting = props.isSameSetting,
      setAllSettingToStore = props.setAllSettingToStore,
      updateUI = props.updateUI;


  var _onChange = function _onChange(value) {
    var list = _lodash2.default.filter(settingsMenuItems, function (item) {
      return item.isMail == value.isMail && item.isPush == value.isPush;
    });
    if (group && groups) {
      updateSetting(target, notification, list[0].value, group, groups, false, undefined);
    } else if (isSameSetting && groups) {
      updateCollectiveSetting && updateCollectiveSetting(value.type, value.type == 'mail' ? value.isMail : value.isPush);
      setAllSettingToStore(list[0].value);
      updateUI({ allSetting: list[0].value });
    } else {
      updateSetting(target, notification, list[0].value);
    }
  };

  var initialState = _lodash2.default.filter(settingsMenuItems, function (item) {
    return item.value == (selected ? selected : 'none');
  })[0];

  return _react2.default.createElement(
    'div',
    { className: _flatCard2.default.rightButton },
    _react2.default.createElement(_switch2.default, { className: disableNone ? _flatCard2.default.singleSwitch : _flatCard2.default.switch,
      checked: initialState.isMail,
      onChange: function onChange(value) {
        return _onChange({ isMail: value, isPush: initialState.isPush, isAllPush: false, type: 'mail' });
      } }),
    !disableNone && _react2.default.createElement(_switch2.default, {
      className: _flatCard2.default.switch,
      checked: disableNone ? true : initialState.isPush,
      disabled: disableNone,
      onChange: function onChange(value) {
        return _onChange({ isMail: initialState.isMail, isPush: disableNone ? true : value, isAllPush: true, type: 'push' });
      } })
  );
}

var UserNotificationPanel = function (_React$Component) {
  _inherits(UserNotificationPanel, _React$Component);

  function UserNotificationPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserNotificationPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserNotificationPanel.__proto__ || Object.getPrototypeOf(UserNotificationPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onChangeActive = function (status) {
      _this.props.updateScheduleActive(status);
    }, _this.onUpdateType = function (value) {
      _this.props.updateScheduleType(value);
    }, _this.onUpdateDaySchedule = function (value) {
      _this.props.updateDaySchedule(value.schedule_type, value.type, value.time);
    }, _this.onUpdateCustomSchedule = function (value) {
      _this.props.updateCustomSchedule(value.day_of_week, value.type, value.time);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserNotificationPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          isNotificationUpdating = _props.isNotificationUpdating,
          notificationSettings = _props.notificationSettings,
          updateSetting = _props.updateSetting,
          updateCollectiveSetting = _props.updateCollectiveSetting,
          setAllSettingToStore = _props.setAllSettingToStore,
          updateScheduleType = _props.updateScheduleType,
          updateScheduleActive = _props.updateScheduleActive,
          updateDaySchedule = _props.updateDaySchedule,
          updateCustomSchedule = _props.updateCustomSchedule;
      var _props$notificationSe = this.props.notificationSettings,
          groups = _props$notificationSe.groups,
          others = _props$notificationSe.others,
          schedule = _props$notificationSe.schedule;


      return _react2.default.createElement(
        _reactToolbox.Card,
        { theme: _flatCard2.default },
        isNotificationUpdating && !groups && !others && _react2.default.createElement(_loading2.default, null),
        _react2.default.createElement(
          _reactToolbox.CardText,
          { theme: _userNotificationList2.default },
          _react2.default.createElement(
            _list.List,
            { selectable: false, ripple: false },
            schedule && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_list.ListItem, { key: 'head-other',
                className: _userNotificationList2.default.head,
                selectable: false,
                ripple: false,
                caption: t('label:通知スケジュールを設定する'),
                rightActions: [_react2.default.createElement(_switch2.default, { className: _flatCard2.default.switch, checked: schedule.is_active, onChange: this.onChangeActive })]
              }),
              _react2.default.createElement(_list.ListDivider, { key: 'div', theme: _userNotificationList2.default }),
              _react2.default.createElement(
                'p',
                {
                  style: {
                    marginTop: 10,
                    marginLeft: 15,
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    whiteSpace: 'normal',
                    maxWidth: '100%'
                  }
                },
                t('label:通知スケジュールを設定文言')
              ),
              _react2.default.createElement(_dropdown2.default, { auto: true,
                className: _userNotificationList2.default.type_dropdown,
                source: scheduleTypeList,
                value: schedule.schedule_type,
                onChange: this.onUpdateType
              }),
              schedule.schedule_type != 'custom' && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: _userNotificationList2.default.schedule_title },
                  t('label:時間')
                ),
                _react2.default.createElement(_dropdown2.default, { auto: true,
                  className: _userNotificationList2.default.schedule_dropdown,
                  source: timeList,
                  value: schedule.schedule_type == 'everyday' ? schedule.everyday_start : schedule.weekday_start,
                  onChange: function onChange(value) {
                    return _this2.onUpdateDaySchedule({ schedule_type: schedule.schedule_type, type: 'start', time: value });
                  }
                }),
                _react2.default.createElement(
                  'span',
                  { className: _userNotificationList2.default.schedule_desc },
                  '\u304B\u3089'
                ),
                _react2.default.createElement(_dropdown2.default, { auto: true,
                  className: _userNotificationList2.default.schedule_dropdown,
                  source: timeList,
                  value: schedule.schedule_type == 'everyday' ? schedule.everyday_end : schedule.weekday_end,
                  onChange: function onChange(value) {
                    return _this2.onUpdateDaySchedule({ schedule_type: schedule.schedule_type, type: 'end', time: value });
                  }
                })
              ),
              schedule.schedule_type == 'custom' && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _userNotificationList2.default.schedule_title },
                    t('label:send_on_mon')
                  ),
                  _react2.default.createElement(_dropdown2.default, { auto: true,
                    className: _userNotificationList2.default.schedule_dropdown,
                    source: customTimeList,
                    value: schedule.monday_start,
                    onChange: function onChange(value) {
                      return _this2.onUpdateCustomSchedule({ day_of_week: 'monday', type: 'start', time: value });
                    }
                  }),
                  schedule.monday_start != 'none' && _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block' } },
                    _react2.default.createElement(
                      'span',
                      { className: _userNotificationList2.default.schedule_desc },
                      '\u304B\u3089'
                    ),
                    _react2.default.createElement(_dropdown2.default, { auto: true,
                      className: _userNotificationList2.default.schedule_dropdown,
                      source: timeList,
                      value: schedule.monday_end,
                      onChange: function onChange(value) {
                        return _this2.onUpdateCustomSchedule({ day_of_week: 'monday', type: 'end', time: value });
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _userNotificationList2.default.schedule_title },
                    t('label:send_on_tue')
                  ),
                  _react2.default.createElement(_dropdown2.default, { auto: true,
                    className: _userNotificationList2.default.schedule_dropdown,
                    source: customTimeList,
                    value: schedule.tuesday_start,
                    onChange: function onChange(value) {
                      return _this2.onUpdateCustomSchedule({ day_of_week: 'tuesday', type: 'start', time: value });
                    }
                  }),
                  schedule.tuesday_start != 'none' && _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block' } },
                    _react2.default.createElement(
                      'span',
                      { className: _userNotificationList2.default.schedule_desc },
                      '\u304B\u3089'
                    ),
                    _react2.default.createElement(_dropdown2.default, { auto: true,
                      className: _userNotificationList2.default.schedule_dropdown,
                      source: timeList,
                      value: schedule.tuesday_end,
                      onChange: function onChange(value) {
                        return _this2.onUpdateCustomSchedule({ day_of_week: 'tuesday', type: 'end', time: value });
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _userNotificationList2.default.schedule_title },
                    t('label:send_on_wed')
                  ),
                  _react2.default.createElement(_dropdown2.default, { auto: true,
                    className: _userNotificationList2.default.schedule_dropdown,
                    source: customTimeList,
                    value: schedule.wednesday_start,
                    onChange: function onChange(value) {
                      return _this2.onUpdateCustomSchedule({ day_of_week: 'wednesday', type: 'start', time: value });
                    }
                  }),
                  schedule.wednesday_start != 'none' && _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block' } },
                    _react2.default.createElement(
                      'span',
                      { className: _userNotificationList2.default.schedule_desc },
                      '\u304B\u3089'
                    ),
                    _react2.default.createElement(_dropdown2.default, { auto: true,
                      className: _userNotificationList2.default.schedule_dropdown,
                      source: timeList,
                      value: schedule.wednesday_end,
                      onChange: function onChange(value) {
                        return _this2.onUpdateCustomSchedule({ day_of_week: 'wednesday', type: 'end', time: value });
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _userNotificationList2.default.schedule_title },
                    t('label:send_on_thu')
                  ),
                  _react2.default.createElement(_dropdown2.default, { auto: true,
                    className: _userNotificationList2.default.schedule_dropdown,
                    source: customTimeList,
                    value: schedule.thursday_start,
                    onChange: function onChange(value) {
                      return _this2.onUpdateCustomSchedule({ day_of_week: 'thursday', type: 'start', time: value });
                    }
                  }),
                  schedule.thursday_start != 'none' && _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block' } },
                    _react2.default.createElement(
                      'span',
                      { className: _userNotificationList2.default.schedule_desc },
                      '\u304B\u3089'
                    ),
                    _react2.default.createElement(_dropdown2.default, { auto: true,
                      className: _userNotificationList2.default.schedule_dropdown,
                      source: timeList,
                      value: schedule.thursday_end,
                      onChange: function onChange(value) {
                        return _this2.onUpdateCustomSchedule({ day_of_week: 'thursday', type: 'end', time: value });
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _userNotificationList2.default.schedule_title },
                    t('label:send_on_fri')
                  ),
                  _react2.default.createElement(_dropdown2.default, { auto: true,
                    className: _userNotificationList2.default.schedule_dropdown,
                    source: customTimeList,
                    value: schedule.friday_start,
                    onChange: function onChange(value) {
                      return _this2.onUpdateCustomSchedule({ day_of_week: 'friday', type: 'start', time: value });
                    }
                  }),
                  schedule.friday_start != 'none' && _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block' } },
                    _react2.default.createElement(
                      'span',
                      { className: _userNotificationList2.default.schedule_desc },
                      '\u304B\u3089'
                    ),
                    _react2.default.createElement(_dropdown2.default, { auto: true,
                      className: _userNotificationList2.default.schedule_dropdown,
                      source: timeList,
                      value: schedule.friday_end,
                      onChange: function onChange(value) {
                        return _this2.onUpdateCustomSchedule({ day_of_week: 'friday', type: 'end', time: value });
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _userNotificationList2.default.schedule_title },
                    t('label:send_on_sat')
                  ),
                  _react2.default.createElement(_dropdown2.default, { auto: true,
                    className: _userNotificationList2.default.schedule_dropdown,
                    source: customTimeList,
                    value: schedule.saturday_start,
                    onChange: function onChange(value) {
                      return _this2.onUpdateCustomSchedule({ day_of_week: 'saturday', type: 'start', time: value });
                    }
                  }),
                  schedule.saturday_start != 'none' && _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block' } },
                    _react2.default.createElement(
                      'span',
                      { className: _userNotificationList2.default.schedule_desc },
                      '\u304B\u3089'
                    ),
                    _react2.default.createElement(_dropdown2.default, { auto: true,
                      className: _userNotificationList2.default.schedule_dropdown,
                      source: timeList,
                      value: schedule.saturday_end,
                      onChange: function onChange(value) {
                        return _this2.onUpdateCustomSchedule({ day_of_week: 'saturday', type: 'end', time: value });
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _userNotificationList2.default.schedule_title },
                    t('label:send_on_sun')
                  ),
                  _react2.default.createElement(_dropdown2.default, { auto: true,
                    className: _userNotificationList2.default.schedule_dropdown,
                    source: customTimeList,
                    value: schedule.sunday_start,
                    onChange: function onChange(value) {
                      return _this2.onUpdateCustomSchedule({ day_of_week: 'sunday', type: 'start', time: value });
                    }
                  }),
                  schedule.sunday_start != 'none' && _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block' } },
                    _react2.default.createElement(
                      'span',
                      { className: _userNotificationList2.default.schedule_desc },
                      '\u304B\u3089'
                    ),
                    _react2.default.createElement(_dropdown2.default, { auto: true,
                      className: _userNotificationList2.default.schedule_dropdown,
                      source: timeList,
                      value: schedule.sunday_end,
                      onChange: function onChange(value) {
                        return _this2.onUpdateCustomSchedule({ day_of_week: 'sunday', type: 'end', time: value });
                      }
                    })
                  )
                )
              )
            ),
            others && [_react2.default.createElement(_list.ListItem, { key: 'head-other',
              className: _userNotificationList2.default.head,
              selectable: false,
              ripple: false,
              caption: t('label:共通設定') }), _react2.default.createElement(
              'div',
              { key: 'title', className: _flatCard2.default.notificationContainer },
              _react2.default.createElement(
                'div',
                { key: 'new_message', className: _flatCard2.default.leftLabel },
                t('label:通知を表示')
              ),
              _react2.default.createElement(
                'div',
                { key: 'display_message', className: _flatCard2.default.rightLabel },
                t('label:内容を表示')
              )
            ), _react2.default.createElement(_list.ListItem, { key: 'chat-alert-display',
              disabled: isNotificationUpdating,
              ripple: false,
              legend: t('label:チャット通知設定'),
              rightActions: [_react2.default.createElement(SettingMenu, { key: 'chat-alert-display', t: t, selected: others.notify_on_alert_display_to_chat, updateSetting: updateSetting, target: 'chat', notification: 'alert_display' })] }), _react2.default.createElement(
              'div',
              { key: 'title', className: _flatCard2.default.notificationContainer },
              _react2.default.createElement(
                'div',
                { key: 'mail', className: _flatCard2.default.leftLabel },
                t('label:通知mail')
              ),
              _react2.default.createElement(
                'div',
                { key: 'app', className: _flatCard2.default.rightLabel },
                t('label:通知push')
              )
            ), _react2.default.createElement(_list.ListItem, { key: 'reply-other',
              disabled: isNotificationUpdating,
              ripple: false,
              legend: t('label:返信があった時'),
              rightActions: [_react2.default.createElement(SettingMenu, { key: 'reply', t: t, selected: others.notify_on_reply_to_me, updateSetting: updateSetting, target: 'me', notification: 'reply' })] }), _react2.default.createElement(_list.ListItem, { key: 'mention-other',
              disabled: isNotificationUpdating,
              ripple: false,
              legend: t('label:読んでみてがあった時'),
              rightActions: [_react2.default.createElement(SettingMenu, { key: 'mention', t: t, selected: others.notify_on_mention_to_me, updateSetting: updateSetting, target: 'me', notification: 'mention' })] }), _react2.default.createElement(_list.ListItem, { key: 'mention-delivered-other',
              disabled: isNotificationUpdating,
              ripple: false,
              legend: t('label:読んでみてが開封された時'),
              rightActions: [_react2.default.createElement(SettingMenu, { key: 'mention-deliver', t: t, selected: others.notify_on_mention_delivered_to_me, updateSetting: updateSetting, target: 'me', notification: 'mention_delivered' })] }), _react2.default.createElement(_list.ListItem, { key: 'post-other',
              disabled: isNotificationUpdating,
              ripple: false,
              legend: t('label:お気に入りに投稿があった時'),
              rightActions: [_react2.default.createElement(SettingMenu, { key: 'post', t: t, selected: others.notify_on_post_to_favorite, updateSetting: updateSetting, target: 'favorite', notification: 'post' })] }), _react2.default.createElement(_list.ListItem, { key: 'chat-other',
              disabled: isNotificationUpdating,
              ripple: false,
              legend: t('label:チャットを受信した時'),
              rightActions: [_react2.default.createElement(SettingMenu, { key: 'chat', t: t, disableNone: true, selected: others.notify_on_message_to_chat, updateSetting: updateSetting, target: 'chat', notification: 'message' })] })],
            _react2.default.createElement(_list.ListItem, { key: 'head-other',
              className: _userNotificationList2.default.head,
              selectable: false,
              ripple: false,
              caption: t('label:グループ設定') }),
            _react2.default.createElement(
              'div',
              { key: 'title', className: _flatCard2.default.notificationContainer },
              _react2.default.createElement(
                'div',
                { key: 'mail', className: _flatCard2.default.leftLabel },
                t('label:通知mail')
              ),
              _react2.default.createElement(
                'div',
                { key: 'app', className: _flatCard2.default.rightLabel },
                t('label:通知push')
              )
            ),
            _react2.default.createElement(_list.ListItem, { key: 'allsetting',
              ripple: false,
              disabled: isNotificationUpdating,
              caption: t('label:一括設定'),
              legend: t('label:一括設定説明'),
              rightActions: [_react2.default.createElement(SettingMenu, { key: 'all', t: t, selected: ui.allSetting || 'all', updateSetting: updateSetting, updateCollectiveSetting: updateCollectiveSetting, target: 'group', notification: 'post', groups: groups, isSameSetting: true, setAllSettingToStore: setAllSettingToStore, updateUI: updateUI })] }),
            groups && _lodash2.default.map(groups, function (group) {
              return [_react2.default.createElement(_list.ListSubHeader, { key: 'head' + group.group_id,
                theme: _userNotificationList2.default,
                caption: _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(_avatar2.default, { image: group.icon_image.thumb_url }),
                  '\xA0',
                  group.name
                ) }), _react2.default.createElement(
                'div',
                { key: 'title', className: _flatCard2.default.notificationContainer },
                _react2.default.createElement(
                  'div',
                  { key: 'mail', className: _flatCard2.default.leftLabel },
                  t('label:通知mail')
                ),
                _react2.default.createElement(
                  'div',
                  { key: 'app', className: _flatCard2.default.rightLabel },
                  t('label:通知push')
                )
              ), _react2.default.createElement(_list.ListItem, { key: 'post' + group.group_id,
                ripple: false,
                disabled: isNotificationUpdating,
                legend: t('label:投稿があった時'),
                rightActions: [_react2.default.createElement(SettingMenu, { key: 'post', t: t, selected: group.notify_on_post_to_group, updateSetting: updateSetting, target: 'group', notification: 'post', group: group, groups: groups, isSameSetting: false })] }), _react2.default.createElement(_list.ListItem, { key: 'comment' + group.group_id,
                ripple: false,
                disabled: isNotificationUpdating,
                legend: t('label:コメントがあった時'),
                rightActions: [_react2.default.createElement(SettingMenu, { key: 'comment', t: t, selected: group.notify_on_comment_to_group, updateSetting: updateSetting, target: 'group', notification: 'comment', group: group, groups: groups, isSameSetting: false })] }), _react2.default.createElement(_list.ListItem, { key: 'like' + group.group_id,
                ripple: false,
                disabled: isNotificationUpdating,
                legend: t('label:いいねがあった時'),
                rightActions: [_react2.default.createElement(SettingMenu, { key: 'like', t: t, selected: group.notify_on_like_to_group, updateSetting: updateSetting, target: 'group', notification: 'like', group: group, groups: groups, isSameSetting: false })] })];
            })
          )
        )
      );
    }
  }]);

  return UserNotificationPanel;
}(_react2.default.Component);

var RawUserNotificationPanel = exports.RawUserNotificationPanel = UserNotificationPanel;
exports.default = (0, _userNotificationPanel2.default)(UserNotificationPanel);

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

var _notificationAllSettingStore = __webpack_require__(2198);

var _notificationAllSettingStore2 = _interopRequireDefault(_notificationAllSettingStore);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isNotificationUpdating: state.user.isNotificationUpdating,
    isNotificationUpdateFailed: state.user.isNotificationUpdateFailed,
    notificationSettings: state.user.notificationSettings || { groups: undefined, others: undefined }
  };
};
// src/connects/user-notification-panel.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount(props) {
      _notificationAllSettingStore2.default.get(function (allSetting) {
        props.updateUI({ allSetting: allSetting });
      });
      dispatch(_actions2.default.fetchNotificationSettings());
    },
    updateCollectiveSetting: function updateCollectiveSetting(mediaType, notifyAll) {
      dispatch(_actions2.default.updateNotificationCollectiveSetting(mediaType, notifyAll));
      dispatch((0, _alertMessage.emitAlertMessage)('label:一括変更しました', 'success'));
    },
    updateSetting: function updateSetting(target, notification, media) {
      var group = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var groups = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
      var isSameSetting = arguments[5];
      var isAllPush = arguments[6];

      dispatch(_actions2.default.updateNotificationSettings(target, notification, media, group && group.group_id || undefined));
      if (group) {
        dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:グループの通知設定を変更しました', name: group.name }, 'success'));
      } else {
        dispatch((0, _alertMessage.emitAlertMessage)('label:通知設定を変更しました', 'success'));
      }
    },

    setAllSettingToStore: function setAllSettingToStore(allSetting) {
      return _notificationAllSettingStore2.default.set(allSetting);
    },

    updateScheduleActive: function updateScheduleActive(status) {
      dispatch(_actions2.default.updateScheduleActive(status));
    },

    updateScheduleType: function updateScheduleType(schedule_type) {
      dispatch(_actions2.default.updateScheduleType(schedule_type));
    },

    updateDaySchedule: function updateDaySchedule(schedule_type, time_type, time_value) {
      dispatch(_actions2.default.updateDaySchedule(schedule_type, time_type, time_value));
    },

    updateCustomSchedule: function updateCustomSchedule(day_of_week, time_type, time_value) {
      dispatch(_actions2.default.updateCustomSchedule(day_of_week, time_type, time_value));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    allSetting: 'all'
  } }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _permanentStore = __webpack_require__(118);

var _permanentStore2 = _interopRequireDefault(_permanentStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY = "gambaApp.notification-all-setting"; /**
                                                * src/actions/notification-same-setting-store.js
                                                * localStorageに対し、メンバー招待ダイアログ（トライアル中表示）の表示／非表示を格納、取得、クリア
                                                */

exports.default = (0, _permanentStore2.default)(KEY);

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Autocomplete = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Autocomplete = __webpack_require__(2200);

var _chip = __webpack_require__(91);

var _input = __webpack_require__(59);

var _theme = __webpack_require__(2201);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Autocomplete = (0, _Autocomplete.autocompleteFactory)(_chip.Chip, _input.Input);
var ThemedAutocomplete = (0, _reactCssThemr.themr)(_identifiers.AUTOCOMPLETE, _theme2.default)(Autocomplete);

exports.default = ThemedAutocomplete;
exports.Autocomplete = ThemedAutocomplete;

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Autocomplete = exports.autocompleteFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames4 = __webpack_require__(14);

var _classnames5 = _interopRequireDefault(_classnames4);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Chip = __webpack_require__(929);

var _Chip2 = _interopRequireDefault(_Chip);

var _Input = __webpack_require__(223);

var _Input2 = _interopRequireDefault(_Input);

var _events = __webpack_require__(143);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


var POSITION = {
  AUTO: 'auto',
  DOWN: 'down',
  UP: 'up'
};

var factory = function factory(Chip, Input) {
  var Autocomplete = function (_Component) {
    _inherits(Autocomplete, _Component);

    function Autocomplete() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Autocomplete);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        direction: _this.props.direction,
        focus: false,
        showAllSuggestions: _this.props.showSuggestionsWhenValueIsSet,
        query: _this.props.query ? _this.props.query : _this.query(_this.props.value),
        isValueAnObject: false
      }, _this.handleChange = function (values, event) {
        var value = _this.props.multiple ? values : values[0];
        var showAllSuggestions = _this.props.showSuggestionsWhenValueIsSet;

        var query = _this.query(value);
        if (_this.props.onChange) _this.props.onChange(value, event);
        if (_this.props.keepFocusOnChange) {
          _this.setState({ query: query, showAllSuggestions: showAllSuggestions });
        } else {
          _this.setState({ focus: false, query: query, showAllSuggestions: showAllSuggestions }, function () {
            _reactDom2.default.findDOMNode(_this).querySelector('input').blur();
          });
        }
        _this.updateQuery(query, _this.props.query);
      }, _this.handleMouseDown = function (event) {
        _this.selectOrCreateActiveItem(event);
      }, _this.handleQueryBlur = function (event) {
        if (_this.state.focus) _this.setState({ focus: false });
        if (_this.props.onBlur) _this.props.onBlur(event, _this.state.active);
      }, _this.updateQuery = function (query, notify) {
        if (notify && _this.props.onQueryChange) _this.props.onQueryChange(query);
        _this.setState({ query: query });
      }, _this.handleQueryChange = function (value) {
        var query = _this.clearQuery ? '' : value;
        _this.clearQuery = false;

        _this.updateQuery(query, true);
        _this.setState({ showAllSuggestions: query ? false : _this.props.showSuggestionsWhenValueIsSet, active: null });
      }, _this.handleQueryFocus = function (event) {
        _this.suggestionsNode.scrollTop = 0;
        _this.setState({ active: '', focus: true });
        if (_this.props.onFocus) _this.props.onFocus(event);
      }, _this.handleQueryKeyDown = function (event) {
        // Mark query for clearing in handleQueryChange when pressing backspace and showing all suggestions.
        _this.clearQuery = event.which === 8 && _this.props.showSuggestionsWhenValueIsSet && _this.state.showAllSuggestions;

        if (event.which === 13) {
          _this.selectOrCreateActiveItem(event);
        }
      }, _this.handleQueryKeyUp = function (event) {
        if (event.which === 27) _reactDom2.default.findDOMNode(_this).querySelector('input').blur();

        if ([40, 38].indexOf(event.which) !== -1) {
          var suggestionsKeys = [].concat(_toConsumableArray(_this.suggestions().keys()));
          var index = suggestionsKeys.indexOf(_this.state.active) + (event.which === 40 ? +1 : -1);
          if (index < 0) index = suggestionsKeys.length - 1;
          if (index >= suggestionsKeys.length) index = 0;
          _this.setState({ active: suggestionsKeys[index] });
        }
      }, _this.handleSuggestionHover = function (event) {
        _this.setState({ active: event.target.id });
      }, _this.select = function (event, target) {
        _events2.default.pauseEvent(event);
        var values = _this.values(_this.props.value);
        var source = _this.source();
        var newValue = target === void 0 ? event.target.id : target;

        if (_this.isValueAnObject()) {
          var newItem = Array.from(source).reduce(function (obj, _ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                k = _ref3[0],
                value = _ref3[1];

            if (k === newValue) {
              obj[k] = value;
            }
            return obj;
          }, {});

          if (Object.keys(newItem).length === 0 && newValue) {
            newItem[newValue] = newValue;
          }

          return _this.handleChange(Object.assign(_this.mapToObject(values), newItem), event);
        }

        _this.handleChange([newValue].concat(_toConsumableArray(values.keys())), event);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Autocomplete, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!this.props.multiple) {
          var query = nextProps.query ? nextProps.query : this.query(nextProps.value);
          this.updateQuery(query, false);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        if (!this.state.focus && nextState.focus && this.props.direction === POSITION.AUTO) {
          var direction = this.calculateDirection();
          if (this.state.direction !== direction) {
            this.setState({ direction: direction });
          }
        }
        return true;
      }
    }, {
      key: 'calculateDirection',
      value: function calculateDirection() {
        if (this.props.direction === 'auto') {
          var client = _reactDom2.default.findDOMNode(this.inputNode).getBoundingClientRect();
          var screen_height = window.innerHeight || document.documentElement.offsetHeight;
          var up = client.top > screen_height / 2 + client.height;
          return up ? 'up' : 'down';
        }
        return this.props.direction;
      }
    }, {
      key: 'query',
      value: function query(key) {
        var query_value = '';
        if (!this.props.multiple && key) {
          var source_value = this.source().get('' + key);
          query_value = source_value || key;
        }
        return query_value;
      }
    }, {
      key: 'selectOrCreateActiveItem',
      value: function selectOrCreateActiveItem(event) {
        var target = this.state.active;
        if (!target) {
          target = this.props.allowCreate ? this.state.query : [].concat(_toConsumableArray(this.suggestions().keys()))[0];
          this.setState({ active: target });
        }
        this.select(event, target);
      }
    }, {
      key: 'normalise',
      value: function normalise(value) {
        var sdiak = 'áâäąáâäąččććççĉĉďđďđééěëēėęéěëēėęĝĝğğġġģģĥĥħħíîíîĩĩīīĭĭįįi̇ıĵĵķķĸĺĺļļŀŀłłĺľĺľňńņŋŋņňńŉóöôőøōōóöőôøřřŕŕŗŗššśśŝŝşşţţťťŧŧũũūūŭŭůůűűúüúüűųųŵŵýyŷŷýyžžźźżżß';
        var bdiak = 'AAAAAAAACCCCCCCCDDDDEEEEEEEEEEEEEGGGGGGGGHHHHIIIIIIIIIIIIIIJJKKKLLLLLLLLLLLLNNNNNNNNNOOOOOOOOOOOORRRRRRSSSSSSSSTTTTTTUUUUUUUUUUUUUUUUUWWYYYYYYZZZZZZS';

        var normalised = '';
        for (var p = 0; p < value.length; p++) {
          if (sdiak.indexOf(value.charAt(p)) !== -1) {
            normalised += bdiak.charAt(sdiak.indexOf(value.charAt(p)));
          } else {
            normalised += value.charAt(p);
          }
        }

        return normalised.toLowerCase().trim();
      }
    }, {
      key: 'suggestions',
      value: function suggestions() {
        var suggest = new Map();
        var rawQuery = this.state.query || (this.props.multiple ? '' : this.props.value);
        var query = this.normalise('' + rawQuery);
        var values = this.values();
        var source = this.source();

        // Suggest any non-set value which matches the query
        if (this.props.multiple) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = source[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _step$value = _slicedToArray(_step.value, 2),
                  key = _step$value[0],
                  value = _step$value[1];

              if (!values.has(key) && this.matches(this.normalise(value), query)) {
                suggest.set(key, value);
              }
            }

            // When multiple is false, suggest any value which matches the query if showAllSuggestions is false
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else if (query && !this.state.showAllSuggestions) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = source[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _step2$value = _slicedToArray(_step2.value, 2),
                  key = _step2$value[0],
                  value = _step2$value[1];

              if (this.matches(this.normalise(value), query)) {
                suggest.set(key, value);
              }
            }

            // When multiple is false, suggest all values when showAllSuggestions is true
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        } else {
          suggest = source;
        }

        return suggest;
      }
    }, {
      key: 'matches',
      value: function matches(value, query) {
        var suggestionMatch = this.props.suggestionMatch;


        if (suggestionMatch === 'disabled') {
          return true;
        } else if (suggestionMatch === 'start') {
          return value.startsWith(query);
        } else if (suggestionMatch === 'anywhere') {
          return value.includes(query);
        } else if (suggestionMatch === 'word') {
          var re = new RegExp('\\b' + query, 'g');
          return re.test(value);
        } else if (suggestionMatch === 'none') {
          return value;
        }

        return false;
      }
    }, {
      key: 'source',
      value: function source() {
        var src = this.props.source;

        if (src.hasOwnProperty('length')) {
          return new Map(src.map(function (item) {
            return Array.isArray(item) ? [].concat(_toConsumableArray(item)) : [item, item];
          }));
        }
        return new Map(Object.keys(src).map(function (key) {
          return ['' + key, src[key]];
        }));
      }
    }, {
      key: 'values',
      value: function values() {
        var vals = this.props.multiple ? this.props.value : [this.props.value];

        if (!vals) vals = [];

        if (this.props.showSelectedWhenNotInSource && this.isValueAnObject()) {
          return new Map(Object.entries(vals));
        }

        var valueMap = new Map();

        var stringVals = vals.map(function (v) {
          return '' + v;
        });
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = this.source()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _step3$value = _slicedToArray(_step3.value, 2),
                k = _step3$value[0],
                v = _step3$value[1];

            if (stringVals.indexOf(k) !== -1) valueMap.set(k, v);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return valueMap;
      }
    }, {
      key: 'unselect',
      value: function unselect(key, event) {
        if (!this.props.disabled) {
          var values = this.values(this.props.value);

          values.delete(key);

          if (this.isValueAnObject()) {
            return this.handleChange(this.mapToObject(values), event);
          }

          this.handleChange([].concat(_toConsumableArray(values.keys())), event);
        }
      }
    }, {
      key: 'isValueAnObject',
      value: function isValueAnObject() {
        return !Array.isArray(this.props.value) && _typeof(this.props.value) === 'object';
      }
    }, {
      key: 'mapToObject',
      value: function mapToObject(map) {
        return Array.from(map).reduce(function (obj, _ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              k = _ref5[0],
              value = _ref5[1];

          obj[k] = value;
          return obj;
        }, {});
      }
    }, {
      key: 'renderSelected',
      value: function renderSelected() {
        var _this2 = this;

        if (this.props.multiple) {
          var selectedItems = [].concat(_toConsumableArray(this.values())).map(function (_ref6) {
            var _ref7 = _slicedToArray(_ref6, 2),
                key = _ref7[0],
                value = _ref7[1];

            return _react2.default.createElement(
              Chip,
              {
                key: key,
                className: _this2.props.theme.value,
                deletable: true,
                onDeleteClick: _this2.unselect.bind(_this2, key)
              },
              value
            );
          });

          return _react2.default.createElement(
            'ul',
            { className: this.props.theme.values },
            selectedItems
          );
        }
      }
    }, {
      key: 'renderSuggestions',
      value: function renderSuggestions() {
        var _this3 = this;

        var theme = this.props.theme;

        var suggestions = [].concat(_toConsumableArray(this.suggestions())).map(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
              key = _ref9[0],
              value = _ref9[1];

          var className = (0, _classnames5.default)(theme.suggestion, _defineProperty({}, theme.active, _this3.state.active === key));
          return _react2.default.createElement(
            'li',
            {
              id: key,
              key: key,
              className: className,
              onMouseDown: _this3.handleMouseDown,
              onMouseOver: _this3.handleSuggestionHover
            },
            value
          );
        });

        return _react2.default.createElement(
          'ul',
          {
            className: (0, _classnames5.default)(theme.suggestions, _defineProperty({}, theme.up, this.state.direction === 'up')),
            ref: function ref(node) {
              _this3.suggestionsNode = node;
            }
          },
          suggestions
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            allowCreate = _props.allowCreate,
            error = _props.error,
            label = _props.label,
            source = _props.source,
            suggestionMatch = _props.suggestionMatch,
            query = _props.query,
            selectedPosition = _props.selectedPosition,
            keepFocusOnChange = _props.keepFocusOnChange,
            showSuggestionsWhenValueIsSet = _props.showSuggestionsWhenValueIsSet,
            showSelectedWhenNotInSource = _props.showSelectedWhenNotInSource,
            onQueryChange = _props.onQueryChange,
            theme = _props.theme,
            other = _objectWithoutProperties(_props, ['allowCreate', 'error', 'label', 'source', 'suggestionMatch', 'query', 'selectedPosition', 'keepFocusOnChange', 'showSuggestionsWhenValueIsSet', 'showSelectedWhenNotInSource', 'onQueryChange', 'theme']);

        var className = (0, _classnames5.default)(theme.autocomplete, _defineProperty({}, theme.focus, this.state.focus), this.props.className);

        return _react2.default.createElement(
          'div',
          { 'data-react-toolbox': 'autocomplete', className: className },
          this.props.selectedPosition === 'above' ? this.renderSelected() : null,
          _react2.default.createElement(Input, _extends({}, other, {
            ref: function ref(node) {
              _this4.inputNode = node;
            },
            autoComplete: 'off',
            className: theme.input,
            error: error,
            label: label,
            onBlur: this.handleQueryBlur,
            onChange: this.handleQueryChange,
            onFocus: this.handleQueryFocus,
            onKeyDown: this.handleQueryKeyDown,
            onKeyUp: this.handleQueryKeyUp,
            theme: theme,
            themeNamespace: 'input',
            value: this.state.query
          })),
          this.renderSuggestions(),
          this.props.selectedPosition === 'below' ? this.renderSelected() : null
        );
      }
    }]);

    return Autocomplete;
  }(_react.Component);

  Autocomplete.propTypes = {
    allowCreate: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    direction: _propTypes2.default.oneOf(['auto', 'up', 'down']),
    disabled: _propTypes2.default.bool,
    error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    keepFocusOnChange: _propTypes2.default.bool,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    multiple: _propTypes2.default.bool,
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onQueryChange: _propTypes2.default.func,
    query: _propTypes2.default.string,
    selectedPosition: _propTypes2.default.oneOf(['above', 'below', 'none']),
    showSelectedWhenNotInSource: _propTypes2.default.bool,
    showSuggestionsWhenValueIsSet: _propTypes2.default.bool,
    source: _propTypes2.default.any,
    suggestionMatch: _propTypes2.default.oneOf(['disabled', 'start', 'anywhere', 'word', 'none']),
    theme: _propTypes2.default.shape({
      active: _propTypes2.default.string,
      autocomplete: _propTypes2.default.string,
      focus: _propTypes2.default.string,
      input: _propTypes2.default.string,
      suggestion: _propTypes2.default.string,
      suggestions: _propTypes2.default.string,
      up: _propTypes2.default.string,
      value: _propTypes2.default.string,
      values: _propTypes2.default.string
    }),
    value: _propTypes2.default.any
  };
  Autocomplete.defaultProps = {
    allowCreate: false,
    className: '',
    direction: 'auto',
    keepFocusOnChange: false,
    multiple: true,
    selectedPosition: 'above',
    showSelectedWhenNotInSource: false,
    showSuggestionsWhenValueIsSet: false,
    source: {},
    suggestionMatch: 'start'
  };


  return Autocomplete;
};

var Autocomplete = factory(_Chip2.default, _Input2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.AUTOCOMPLETE)(Autocomplete);
exports.autocompleteFactory = factory;
exports.Autocomplete = Autocomplete;

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2202);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--autocomplete--39zAtBfY {\n  padding: 10px 0;\n  position: relative;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--autocomplete--39zAtBfY *,\n    .theme--autocomplete--39zAtBfY *::after,\n    .theme--autocomplete--39zAtBfY *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--autocomplete--39zAtBfY.theme--focus--2c7naWz2 .theme--suggestions--1cKh4dfB {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, .12), 0 1px 4px rgba(0, 0, 0, .24);\n  max-height: 45vh;\n  visibility: visible;\n}\n.theme--values--35qMc1F4 {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  list-style: none;\n  margin: 0;\n  padding: 0 0 5px 0;\n}\n.theme--value--l-QNMuLK {\n  margin: 2.5px 5px 2.5px 0;\n}\n.theme--suggestions--1cKh4dfB {\n  background-color: rgb(255, 255, 255);\n  list-style: none;\n  max-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 0;\n  position: absolute;\n  transition-duration: 0.35s;\n  transition-property: max-height, box-shadow;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  visibility: hidden;\n  width: 100%;\n  z-index: 100\n}\n.theme--suggestions--1cKh4dfB:not(.theme--up--e19MGh-r) {\n  margin-top: -20px;\n}\n.theme--suggestions--1cKh4dfB.theme--up--e19MGh-r {\n  bottom: 0;\n}\n.theme--suggestions--1cKh4dfB::-webkit-scrollbar {\n  height: 0;\n  width: 0;\n}\n.theme--suggestion--14lzzioH {\n  cursor: pointer;\n  font-size: 16px;\n  padding: 10px\n}\n.theme--suggestion--14lzzioH.theme--active--jNfqizir {\n  background-color: rgb(238, 238, 238);\n}\n.theme--input--3wqiOHee {\n  position: relative\n}\n.theme--input--3wqiOHee::after {\n  border-left: 5.48571px solid transparent;\n  border-right: 5.48571px solid transparent;\n  border-top: 5.48571px solid rgba(0, 0, 0, 0.12);\n  content: '';\n  height: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transition: -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 0;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/autocomplete/theme.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,uEAAuE;EACvE,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,oBAAoB;MAChB,gBAAgB;EACpB,iBAAiB;EACjB,UAAU;EACV,mBAAmB;CACpB;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;EAC5C,yDAAyD;EACzD,mBAAmB;EACnB,YAAY;EACZ,YAAY;CACb;AACD;EACE,kBAAkB;CACnB;AACD;EACE,UAAU;CACX;AACD;EACE,UAAU;EACV,SAAS;CACV;AACD;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;CACd;AACD;EACE,qCAAqC;CACtC;AACD;EACE,kBAAkB;CACnB;AACD;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,gDAAgD;EAChD,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,iEAAiE;EACjE,yDAAyD;EACzD,+GAA+G;EAC/G,SAAS;CACV","file":"theme.css","sourcesContent":[".autocomplete {\n  padding: 10px 0;\n  position: relative;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.autocomplete *,\n    .autocomplete *::after,\n    .autocomplete *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.autocomplete.focus .suggestions {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, .12), 0 1px 4px rgba(0, 0, 0, .24);\n  max-height: 45vh;\n  visibility: visible;\n}\n.values {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  list-style: none;\n  margin: 0;\n  padding: 0 0 5px 0;\n}\n.value {\n  margin: 2.5px 5px 2.5px 0;\n}\n.suggestions {\n  background-color: rgb(255, 255, 255);\n  list-style: none;\n  max-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 0;\n  position: absolute;\n  transition-duration: 0.35s;\n  transition-property: max-height, box-shadow;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  visibility: hidden;\n  width: 100%;\n  z-index: 100\n}\n.suggestions:not(.up) {\n  margin-top: -20px;\n}\n.suggestions.up {\n  bottom: 0;\n}\n.suggestions::-webkit-scrollbar {\n  height: 0;\n  width: 0;\n}\n.suggestion {\n  cursor: pointer;\n  font-size: 16px;\n  padding: 10px\n}\n.suggestion.active {\n  background-color: rgb(238, 238, 238);\n}\n.input {\n  position: relative\n}\n.input::after {\n  border-left: 5.48571px solid transparent;\n  border-right: 5.48571px solid transparent;\n  border-top: 5.48571px solid rgba(0, 0, 0, 0.12);\n  content: '';\n  height: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transition: -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 0;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"autocomplete": "theme--autocomplete--39zAtBfY",
	"focus": "theme--focus--2c7naWz2",
	"suggestions": "theme--suggestions--1cKh4dfB",
	"values": "theme--values--35qMc1F4",
	"value": "theme--value--l-QNMuLK",
	"up": "theme--up--e19MGh-r",
	"suggestion": "theme--suggestion--14lzzioH",
	"active": "theme--active--jNfqizir",
	"input": "theme--input--3wqiOHee"
};

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = exports.radioGroupFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _RadioButton = __webpack_require__(939);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _isComponentOfType = __webpack_require__(265);

var _isComponentOfType2 = _interopRequireDefault(_isComponentOfType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(RadioButton) {
  var RadioGroup = function (_Component) {
    _inherits(RadioGroup, _Component);

    function RadioGroup() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, RadioGroup);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (value) {
        if (_this.props.onChange) _this.props.onChange(value);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RadioGroup, [{
      key: 'renderRadioButtons',
      value: function renderRadioButtons() {
        var _this2 = this;

        return _react2.default.Children.map(this.props.children, function (child) {
          return !(0, _isComponentOfType2.default)(RadioButton, child) ? child : _react2.default.cloneElement(child, {
            checked: child.props.value === _this2.props.value,
            disabled: _this2.props.disabled || child.props.disabled,
            onChange: _this2.handleChange.bind(_this2, child.props.value)
          });
        });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          { 'data-react-toolbox': 'radio-group', className: this.props.className },
          this.renderRadioButtons()
        );
      }
    }]);

    return RadioGroup;
  }(_react.Component);

  RadioGroup.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    value: _propTypes2.default.string
  };
  RadioGroup.defaultProps = {
    className: '',
    disabled: false
  };


  return RadioGroup;
};

var RadioGroup = factory(_RadioButton2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.RADIO)(RadioGroup);
exports.radioGroupFactory = factory;
exports.RadioGroup = RadioGroup;

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2205);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--radio--3_C2yI-t {\n  border: 2px solid rgb(0, 0, 0);\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  height: 20px;\n  position: relative;\n  vertical-align: top;\n  width: 20px;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--radio--3_C2yI-t *,\n    .theme--radio--3_C2yI-t *::after,\n    .theme--radio--3_C2yI-t *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--radio--3_C2yI-t::before {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50%;\n  content: '';\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  transition: -webkit-transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 100%;\n}\n.theme--radio--3_C2yI-t .theme--ripple--2h7J6Qd3 {\n  background-color: rgb(63, 81, 181);\n  opacity: 0.3;\n  transition-duration: 650ms;\n}\n.theme--radioChecked--2nsF1s2l {\n  border: 2px solid rgb(63, 81, 181)\n}\n.theme--radioChecked--2nsF1s2l::before {\n  -webkit-transform: scale(0.65);\n          transform: scale(0.65);\n}\n.theme--field--2L4RBYwu {\n  display: block;\n  height: 20px;\n  margin-bottom: 15px;\n  position: relative;\n  white-space: nowrap;\n}\n.theme--text--26di08ff {\n  color: rgb(0, 0, 0);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 20px;\n  padding-left: 10px;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.theme--input--FPGnsfE- {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: 0;\n  height: 0;\n  margin: 0;\n  opacity: 0;\n  padding: 0;\n  position: absolute;\n  width: 0\n}\n.theme--input--FPGnsfE-:focus ~ .theme--radio--3_C2yI-t {\n  box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.1);\n}\n.theme--input--FPGnsfE-:focus ~ .theme--radioChecked--2nsF1s2l {\n  box-shadow: 0 0 0 10px rgba(63, 81, 181, 0.26);\n}\n.theme--disabled--2nBzRwXU {\n}\n.theme--disabled--2nBzRwXU .theme--text--26di08ff {\n  color: rgba(0, 0, 0, 0.26);\n}\n.theme--disabled--2nBzRwXU .theme--radio--3_C2yI-t {\n  border-color: rgba(0, 0, 0, 0.26);\n  cursor: auto;\n}\n.theme--disabled--2nBzRwXU .theme--radioChecked--2nsF1s2l {\n  border-color: rgba(0, 0, 0, 0.26);\n  cursor: auto;\n}\n.theme--disabled--2nBzRwXU .theme--radioChecked--2nsF1s2l::before {\n  background-color: rgba(0, 0, 0, 0.26);\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/radio/theme.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,OAAO;EACP,4BAA4B;UACpB,oBAAoB;EAC5B,gEAAgE;EAChE,wDAAwD;EACxD,6GAA6G;EAC7G,YAAY;CACb;AACD;EACE,mCAAmC;EACnC,aAAa;EACb,2BAA2B;CAC5B;AACD;EACE,kCAAmC;CAEpC;AACD;EACE,+BAA+B;UACvB,uBAAuB;CAChC;AACD;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;CACrB;AACD;EACE,yBAAyB;KACtB,sBAAsB;UACjB,iBAAiB;EACzB,UAAU;EACV,UAAU;EACV,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,QAAQ;CACT;AACD;EACE,0CAA0C;CAC3C;AACD;EACE,+CAA+C;CAChD;AACD;CAEC;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,kCAAkC;EAClC,aAAa;CACd;AACD;EACE,kCAAkC;EAClC,aAAa;CACd;AACD;EACE,sCAAsC;CACvC","file":"theme.css","sourcesContent":[".radio {\n  border: 2px solid rgb(0, 0, 0);\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  height: 20px;\n  position: relative;\n  vertical-align: top;\n  width: 20px;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.radio *,\n    .radio *::after,\n    .radio *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.radio::before {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50%;\n  content: '';\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  transition: -webkit-transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 100%;\n}\n.radio .ripple {\n  background-color: rgb(63, 81, 181);\n  opacity: 0.3;\n  transition-duration: 650ms;\n}\n.radioChecked {\n  border: 2px solid rgb(63, 81, 181);\n  composes: radio\n}\n.radioChecked::before {\n  -webkit-transform: scale(0.65);\n          transform: scale(0.65);\n}\n.field {\n  display: block;\n  height: 20px;\n  margin-bottom: 15px;\n  position: relative;\n  white-space: nowrap;\n}\n.text {\n  color: rgb(0, 0, 0);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 20px;\n  padding-left: 10px;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.input {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border: 0;\n  height: 0;\n  margin: 0;\n  opacity: 0;\n  padding: 0;\n  position: absolute;\n  width: 0\n}\n.input:focus ~ .radio {\n  box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.1);\n}\n.input:focus ~ .radioChecked {\n  box-shadow: 0 0 0 10px rgba(63, 81, 181, 0.26);\n}\n.disabled {\n  composes: field\n}\n.disabled .text {\n  color: rgba(0, 0, 0, 0.26);\n}\n.disabled .radio {\n  border-color: rgba(0, 0, 0, 0.26);\n  cursor: auto;\n}\n.disabled .radioChecked {\n  border-color: rgba(0, 0, 0, 0.26);\n  cursor: auto;\n}\n.disabled .radioChecked::before {\n  background-color: rgba(0, 0, 0, 0.26);\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"radio": "theme--radio--3_C2yI-t",
	"ripple": "theme--ripple--2h7J6Qd3",
	"radioChecked": "theme--radioChecked--2nsF1s2l theme--radio--3_C2yI-t",
	"field": "theme--field--2L4RBYwu",
	"text": "theme--text--26di08ff",
	"input": "theme--input--FPGnsfE-",
	"disabled": "theme--disabled--2nBzRwXU theme--field--2L4RBYwu"
};

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _progress_bar = __webpack_require__(78);

var _input = __webpack_require__(59);

var _Slider = __webpack_require__(2207);

var _theme = __webpack_require__(2208);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedSlider = (0, _reactCssThemr.themr)(_identifiers.SLIDER, _theme2.default)((0, _Slider.sliderFactory)(_progress_bar.ProgressBar, _input.Input));
exports.default = ThemedSlider;
exports.Slider = ThemedSlider;

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = exports.sliderFactory = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactStyleProptype = __webpack_require__(478);

var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);

var _reactCssThemr = __webpack_require__(10);

var _utils = __webpack_require__(106);

var _identifiers = __webpack_require__(16);

var _events = __webpack_require__(143);

var _events2 = _interopRequireDefault(_events);

var _ProgressBar = __webpack_require__(913);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Input = __webpack_require__(223);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(ProgressBar, Input) {
  var Slider = function (_Component) {
    _inherits(Slider, _Component);

    function Slider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Slider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Slider.__proto__ || Object.getPrototypeOf(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        inputFocused: false,
        inputValue: null,
        sliderLength: 0,
        sliderStart: 0
      }, _this.handleInputFocus = function () {
        _this.setState({
          inputFocused: true,
          inputValue: _this.valueForInput(_this.props.value)
        });
      }, _this.handleInputChange = function (value) {
        _this.setState({ inputValue: value });
      }, _this.handleInputBlur = function (event) {
        var value = _this.state.inputValue || 0;
        _this.setState({ inputFocused: false, inputValue: null }, function () {
          _this.props.onChange(_this.trimValue(value), event);
        });
      }, _this.handleKeyDown = function (event) {
        if ([13, 27].indexOf(event.keyCode) !== -1) _this.getInput().blur();
        if (event.keyCode === 38) _this.addToValue(_this.props.step);
        if (event.keyCode === 40) _this.addToValue(-_this.props.step);
      }, _this.handleMouseDown = function (event) {
        if (_this.state.inputFocused) _this.getInput().blur();
        _events2.default.addEventsToDocument(_this.getMouseEventMap());
        _this.start(_events2.default.getMousePosition(event));
        _events2.default.pauseEvent(event);
      }, _this.handleMouseMove = function (event) {
        _events2.default.pauseEvent(event);
        _this.move(_events2.default.getMousePosition(event));
      }, _this.handleMouseUp = function () {
        _this.end(_this.getMouseEventMap());
      }, _this.handleResize = function (event, callback) {
        var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(_this.progressbarNode).getBoundingClientRect(),
            left = _ReactDOM$findDOMNode.left,
            right = _ReactDOM$findDOMNode.right;

        var cb = callback || function () {};
        _this.setState({ sliderStart: left, sliderLength: right - left }, cb);
      }, _this.handleSliderBlur = function () {
        _events2.default.removeEventsFromDocument(_this.getKeyboardEvents());
      }, _this.handleSliderFocus = function () {
        _events2.default.addEventsToDocument(_this.getKeyboardEvents());
      }, _this.handleTouchEnd = function () {
        _this.end(_this.getTouchEventMap());
      }, _this.handleTouchMove = function (event) {
        _this.move(_events2.default.getTouchPosition(event));
      }, _this.handleTouchStart = function (event) {
        if (_this.state.inputFocused) _this.getInput().blur();
        _this.start(_events2.default.getTouchPosition(event));
        _events2.default.addEventsToDocument(_this.getTouchEventMap());
        _events2.default.pauseEvent(event);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Slider, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.state.inputFocused && this.props.value !== nextProps.value) {
          this.setState({ inputValue: this.valueForInput(nextProps.value) });
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return this.state.inputFocused || !nextState.inputFocused;
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps, nextState) {
        if (nextState.pressed !== this.state.pressed) {
          if (nextState.pressed) {
            this.props.onDragStart();
          } else {
            this.props.onDragStop();
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        _events2.default.removeEventsFromDocument(this.getMouseEventMap());
        _events2.default.removeEventsFromDocument(this.getTouchEventMap());
        _events2.default.removeEventsFromDocument(this.getKeyboardEvents());
      }
    }, {
      key: 'getInput',
      value: function getInput() {
        return this.inputNode;
      }
    }, {
      key: 'getKeyboardEvents',
      value: function getKeyboardEvents() {
        return {
          keydown: this.handleKeyDown
        };
      }
    }, {
      key: 'getMouseEventMap',
      value: function getMouseEventMap() {
        return {
          mousemove: this.handleMouseMove,
          mouseup: this.handleMouseUp
        };
      }
    }, {
      key: 'getTouchEventMap',
      value: function getTouchEventMap() {
        return {
          touchmove: this.handleTouchMove,
          touchend: this.handleTouchEnd
        };
      }
    }, {
      key: 'addToValue',
      value: function addToValue(increment) {
        var value = this.state.inputFocused ? parseFloat(this.state.inputValue) : this.props.value;
        value = this.trimValue(value + increment);
        if (value !== this.props.value) this.props.onChange(value);
      }
    }, {
      key: 'end',
      value: function end(revents) {
        _events2.default.removeEventsFromDocument(revents);
        this.setState({ pressed: false });
      }
    }, {
      key: 'knobOffset',
      value: function knobOffset() {
        var _props = this.props,
            max = _props.max,
            min = _props.min,
            value = _props.value;

        return 100 * ((value - min) / (max - min));
      }
    }, {
      key: 'move',
      value: function move(position) {
        var newValue = this.positionToValue(position);
        if (newValue !== this.props.value) this.props.onChange(newValue);
      }
    }, {
      key: 'positionToValue',
      value: function positionToValue(position) {
        var _state = this.state,
            start = _state.sliderStart,
            length = _state.sliderLength;
        var _props2 = this.props,
            max = _props2.max,
            min = _props2.min,
            step = _props2.step;

        var pos = (position.x - start) / length * (max - min);
        return this.trimValue(Math.round(pos / step) * step + min);
      }
    }, {
      key: 'start',
      value: function start(position) {
        var _this2 = this;

        this.handleResize(null, function () {
          _this2.setState({ pressed: true });
          _this2.props.onChange(_this2.positionToValue(position));
        });
      }
    }, {
      key: 'stepDecimals',
      value: function stepDecimals() {
        return (this.props.step.toString().split('.')[1] || []).length;
      }
    }, {
      key: 'trimValue',
      value: function trimValue(value) {
        if (value < this.props.min) return this.props.min;
        if (value > this.props.max) return this.props.max;
        return (0, _utils.round)(value, this.stepDecimals());
      }
    }, {
      key: 'valueForInput',
      value: function valueForInput(value) {
        var decimals = this.stepDecimals();
        return decimals > 0 ? value.toFixed(decimals) : value.toString();
      }
    }, {
      key: 'renderSnaps',
      value: function renderSnaps() {
        var _this3 = this;

        if (!this.props.snaps) return undefined;
        return _react2.default.createElement(
          'div',
          { className: this.props.theme.snaps },
          (0, _utils.range)(0, (this.props.max - this.props.min) / this.props.step).map(function (i) {
            return _react2.default.createElement('div', { key: 'span-' + i, className: _this3.props.theme.snap });
          })
        );
      }
    }, {
      key: 'renderInput',
      value: function renderInput() {
        var _this4 = this;

        if (!this.props.editable) return undefined;
        return _react2.default.createElement(Input, {
          className: this.props.theme.input,
          disabled: this.props.disabled,
          innerRef: function innerRef(node) {
            _this4.inputNode = node;
          },
          onBlur: this.handleInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.handleInputFocus,
          value: this.state.inputFocused ? this.state.inputValue : this.valueForInput(this.props.value)
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _classnames,
            _this5 = this;

        var theme = this.props.theme;

        var knobStyles = { left: this.knobOffset() + '%' };
        var className = (0, _classnames3.default)(theme.slider, (_classnames = {}, _defineProperty(_classnames, theme.editable, this.props.editable), _defineProperty(_classnames, theme.disabled, this.props.disabled), _defineProperty(_classnames, theme.pinned, this.props.pinned), _defineProperty(_classnames, theme.pressed, this.state.pressed), _defineProperty(_classnames, theme.ring, this.props.value === this.props.min), _classnames), this.props.className);

        return _react2.default.createElement(
          'div',
          {
            className: className,
            disabled: this.props.disabled,
            'data-react-toolbox': 'slider',
            onBlur: this.handleSliderBlur,
            onFocus: this.handleSliderFocus,
            style: this.props.style,
            tabIndex: '0'
          },
          _react2.default.createElement(
            'div',
            {
              ref: function ref(node) {
                _this5.sliderNode = node;
              },
              className: theme.container,
              onMouseDown: this.handleMouseDown,
              onTouchStart: this.handleTouchStart
            },
            _react2.default.createElement(
              'div',
              {
                ref: function ref(node) {
                  _this5.knobNode = node;
                },
                className: theme.knob,
                onMouseDown: this.handleMouseDown,
                onTouchStart: this.handleTouchStart,
                style: knobStyles
              },
              _react2.default.createElement('div', {
                className: theme.innerknob,
                'data-value': parseInt(this.props.value, 10)
              })
            ),
            _react2.default.createElement(
              'div',
              { className: theme.progress },
              _react2.default.createElement(ProgressBar, {
                disabled: this.props.disabled,
                ref: function ref(node) {
                  _this5.progressbarNode = node;
                },
                className: theme.innerprogress,
                max: this.props.max,
                min: this.props.min,
                mode: 'determinate',
                value: this.props.value,
                buffer: this.props.buffer
              }),
              this.renderSnaps()
            )
          ),
          this.renderInput()
        );
      }
    }]);

    return Slider;
  }(_react.Component);

  Slider.propTypes = {
    buffer: _propTypes2.default.number,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    editable: _propTypes2.default.bool,
    max: _propTypes2.default.number,
    min: _propTypes2.default.number,
    onChange: _propTypes2.default.func,
    onDragStart: _propTypes2.default.func,
    onDragStop: _propTypes2.default.func,
    pinned: _propTypes2.default.bool,
    snaps: _propTypes2.default.bool,
    step: _propTypes2.default.number,
    style: _reactStyleProptype2.default,
    theme: _propTypes2.default.shape({
      container: _propTypes2.default.string,
      editable: _propTypes2.default.string,
      innerknob: _propTypes2.default.string,
      innerprogress: _propTypes2.default.string,
      input: _propTypes2.default.string,
      knob: _propTypes2.default.string,
      pinned: _propTypes2.default.string,
      pressed: _propTypes2.default.string,
      progress: _propTypes2.default.string,
      ring: _propTypes2.default.string,
      slider: _propTypes2.default.string,
      snap: _propTypes2.default.string,
      snaps: _propTypes2.default.string
    }),
    value: _propTypes2.default.number
  };
  Slider.defaultProps = {
    buffer: 0,
    className: '',
    editable: false,
    max: 100,
    min: 0,
    onDragStart: function onDragStart() {},
    onDragStop: function onDragStop() {},
    pinned: false,
    snaps: false,
    step: 0.01,
    value: 0
  };


  return Slider;
};

var Slider = factory(_ProgressBar2.default, _Input2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.SLIDER)(Slider);
exports.sliderFactory = factory;
exports.Slider = Slider;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2209);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--container--3zHuUteX {\n  height: 32px;\n  margin-right: 32px;\n  position: relative;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: calc(100% - 32px);\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--container--3zHuUteX *,\n    .theme--container--3zHuUteX *::after,\n    .theme--container--3zHuUteX *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--container--3zHuUteX:not(:last-child) {\n  margin-right: 42px;\n}\n.theme--container--3zHuUteX:not(:first-child) {\n  margin-left: 10px;\n}\n.theme--knob--3yfj7-Wh {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: transparent;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  height: 32px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  left: 0;\n  position: relative;\n  top: 0;\n  width: 32px;\n  z-index: 200;\n}\n.theme--innerknob--3Lo33Yd2 {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50%;\n  height: 12px;\n  transition-duration: 0.1s;\n  transition-property: height, width, background-color, border;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: 12px;\n  z-index: 100;\n}\n.theme--snaps--MJvMdXQV {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  height: 2px;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 15px;\n  width: calc(100% + 2px)\n}\n.theme--snaps--MJvMdXQV::after {\n  background-color: rgb(0, 0, 0);\n  border-radius: 50%;\n  content: '';\n  display: block;\n  height: 2px;\n  width: 2px;\n}\n.theme--snap--1NtZ08eQ {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1\n}\n.theme--snap--1NtZ08eQ::after {\n  background-color: rgb(0, 0, 0);\n  border-radius: 50%;\n  content: '';\n  display: block;\n  height: 2px;\n  width: 2px;\n}\n.theme--input--1p5hUDAD {\n  margin-bottom: 0;\n  padding: 0;\n  width: 50px\n}\n.theme--input--1p5hUDAD > input {\n  text-align: center;\n}\n.theme--progress--1e50k9pC {\n  height: 100%;\n  left: 16px;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n.theme--progress--1e50k9pC .theme--innerprogress--VR5zjas5 {\n  height: 2px;\n  position: absolute;\n  top: 15px;\n}\n.theme--progress--1e50k9pC .theme--innerprogress--VR5zjas5 [data-ref='value'] {\n  transition-duration: 0s;\n}\n.theme--slider--1j4aHZna:focus .theme--knob--3yfj7-Wh::before {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50%;\n  bottom: 0;\n  content: '';\n  left: 0;\n  opacity: 0.26;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n.theme--slider--1j4aHZna[disabled] {\n  cursor: auto;\n  pointer-events: none;\n}\n.theme--slider--1j4aHZna[disabled] .theme--innerknob--3Lo33Yd2 {\n  background-color: rgba(177, 177, 177, 1);\n}\n.theme--slider--1j4aHZna.theme--editable--1eFK7hK5 {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.theme--slider--1j4aHZna.theme--pinned--1L0wgb9r .theme--innerknob--3Lo33Yd2::before {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50% 50% 50% 0;\n  content: '';\n  height: 26px;\n  left: 0;\n  margin-left: 3px;\n  position: absolute;\n  top: 0;\n  -webkit-transform: rotate(-45deg) scale(0) translate(0);\n          transform: rotate(-45deg) scale(0) translate(0);\n  transition:\n        background-color 0.18s ease,\n        -webkit-transform 0.2s ease;\n  transition:\n        transform 0.2s ease,\n        background-color 0.18s ease;\n  transition:\n        transform 0.2s ease,\n        background-color 0.18s ease,\n        -webkit-transform 0.2s ease;\n  width: 26px;\n}\n.theme--slider--1j4aHZna.theme--pinned--1L0wgb9r .theme--innerknob--3Lo33Yd2::after {\n  color: rgb(255, 255, 255);\n  content: attr(data-value);\n  font-size: 10px;\n  height: 26px;\n  left: 0;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  -webkit-transform: scale(0) translate(0);\n          transform: scale(0) translate(0);\n  transition:\n        background-color 0.18s ease,\n        -webkit-transform 0.2s ease;\n  transition:\n        transform 0.2s ease,\n        background-color 0.18s ease;\n  transition:\n        transform 0.2s ease,\n        background-color 0.18s ease,\n        -webkit-transform 0.2s ease;\n  width: 32px;\n}\n.theme--slider--1j4aHZna.theme--pressed--Hh4blIMJ.theme--pinned--1L0wgb9r .theme--innerknob--3Lo33Yd2::before {\n  -webkit-transform: rotate(-45deg) scale(1) translate(17px, -17px);\n          transform: rotate(-45deg) scale(1) translate(17px, -17px);\n  transition-delay: 100ms;\n}\n.theme--slider--1j4aHZna.theme--pressed--Hh4blIMJ.theme--pinned--1L0wgb9r .theme--innerknob--3Lo33Yd2::after {\n  -webkit-transform: scale(1) translate(0, -17px);\n          transform: scale(1) translate(0, -17px);\n  transition-delay: 100ms;\n}\n.theme--slider--1j4aHZna.theme--pressed--Hh4blIMJ:not(.theme--pinned--1L0wgb9r).theme--ring--3dDzMdAI .theme--progress--1e50k9pC {\n  left: 30px;\n  width: calc(100% - 14px);\n}\n.theme--slider--1j4aHZna.theme--pressed--Hh4blIMJ:not(.theme--pinned--1L0wgb9r) .theme--innerknob--3Lo33Yd2 {\n  height: 100%;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n  width: 100%;\n}\n.theme--slider--1j4aHZna.theme--ring--3dDzMdAI .theme--innerknob--3Lo33Yd2 {\n  background-color: transparent;\n  border: 2px solid rgb(238, 238, 238);\n}\n.theme--slider--1j4aHZna.theme--ring--3dDzMdAI .theme--innerknob--3Lo33Yd2::before {\n  background-color: rgb(63, 81, 181);\n}\n.theme--slider--1j4aHZna.theme--ring--3dDzMdAI .theme--progress--1e50k9pC {\n  left: 20px;\n  transition:\n        left 0.18s ease,\n        width 0.18s ease;\n  width: calc(100% - 2px * 2);\n}\n.theme--slider--1j4aHZna.theme--ring--3dDzMdAI.theme--pinned--1L0wgb9r .theme--innerknob--3Lo33Yd2 {\n  background-color: rgb(255, 255, 255);\n}\n.theme--slider--1j4aHZna.theme--ring--3dDzMdAI.theme--pinned--1L0wgb9r .theme--progress--1e50k9pC {\n  left: 16px;\n  width: 100%;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/slider/theme.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;KACvB,uBAAuB;MACtB,sBAAsB;UAClB,kBAAkB;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,aAAa;EACb,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,QAAQ;EACR,mBAAmB;EACnB,OAAO;EACP,YAAY;EACZ,aAAa;CACd;AACD;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,6DAA6D;EAC7D,yDAAyD;EACzD,YAAY;EACZ,aAAa;CACd;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,YAAY;EACZ,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,uBAAuB;CACxB;AACD;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;CACZ;AACD;EACE,oBAAoB;MAChB,YAAY;UACR,OAAO;CAChB;AACD;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;CACZ;AACD;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;CACZ;AACD;EACE,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,OAAO;EACP,WAAW;CACZ;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,UAAU;CACX;AACD;EACE,wBAAwB;CACzB;AACD;EACE,mCAAmC;EACnC,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,WAAW;CACZ;AACD;EACE,aAAa;EACb,qBAAqB;CACtB;AACD;EACE,yCAAyC;CAC1C;AACD;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;CAC7B;AACD;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,OAAO;EACP,wDAAwD;UAChD,gDAAgD;EACxD;;oCAEkC;EAClC;;oCAEkC;EAClC;;;oCAGkC;EAClC,YAAY;CACb;AACD;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,OAAO;EACP,yCAAyC;UACjC,iCAAiC;EACzC;;oCAEkC;EAClC;;oCAEkC;EAClC;;;oCAGkC;EAClC,YAAY;CACb;AACD;EACE,kEAAkE;UAC1D,0DAA0D;EAClE,wBAAwB;CACzB;AACD;EACE,gDAAgD;UACxC,wCAAwC;EAChD,wBAAwB;CACzB;AACD;EACE,WAAW;EACX,yBAAyB;CAC1B;AACD;EACE,aAAa;EACb,iCAAiC;UACzB,yBAAyB;EACjC,YAAY;CACb;AACD;EACE,8BAA8B;EAC9B,qCAAqC;CACtC;AACD;EACE,mCAAmC;CACpC;AACD;EACE,WAAW;EACX;;yBAEuB;EACvB,4BAA4B;CAC7B;AACD;EACE,qCAAqC;CACtC;AACD;EACE,WAAW;EACX,YAAY;CACb","file":"theme.css","sourcesContent":[".container {\n  height: 32px;\n  margin-right: 32px;\n  position: relative;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: calc(100% - 32px);\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.container *,\n    .container *::after,\n    .container *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.container:not(:last-child) {\n  margin-right: 42px;\n}\n.container:not(:first-child) {\n  margin-left: 10px;\n}\n.knob {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: transparent;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  height: 32px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  left: 0;\n  position: relative;\n  top: 0;\n  width: 32px;\n  z-index: 200;\n}\n.innerknob {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50%;\n  height: 12px;\n  transition-duration: 0.1s;\n  transition-property: height, width, background-color, border;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: 12px;\n  z-index: 100;\n}\n.snaps {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  height: 2px;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 15px;\n  width: calc(100% + 2px)\n}\n.snaps::after {\n  background-color: rgb(0, 0, 0);\n  border-radius: 50%;\n  content: '';\n  display: block;\n  height: 2px;\n  width: 2px;\n}\n.snap {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1\n}\n.snap::after {\n  background-color: rgb(0, 0, 0);\n  border-radius: 50%;\n  content: '';\n  display: block;\n  height: 2px;\n  width: 2px;\n}\n.input {\n  margin-bottom: 0;\n  padding: 0;\n  width: 50px\n}\n.input > input {\n  text-align: center;\n}\n.progress {\n  height: 100%;\n  left: 16px;\n  position: absolute;\n  top: 0;\n  width: 100%\n}\n.progress .innerprogress {\n  height: 2px;\n  position: absolute;\n  top: 15px;\n}\n.progress .innerprogress [data-ref='value'] {\n  transition-duration: 0s;\n}\n.slider:focus .knob::before {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50%;\n  bottom: 0;\n  content: '';\n  left: 0;\n  opacity: 0.26;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n.slider[disabled] {\n  cursor: auto;\n  pointer-events: none;\n}\n.slider[disabled] .innerknob {\n  background-color: rgba(177, 177, 177, 1);\n}\n.slider.editable {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n}\n.slider.pinned .innerknob::before {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50% 50% 50% 0;\n  content: '';\n  height: 26px;\n  left: 0;\n  margin-left: 3px;\n  position: absolute;\n  top: 0;\n  -webkit-transform: rotate(-45deg) scale(0) translate(0);\n          transform: rotate(-45deg) scale(0) translate(0);\n  transition:\n        background-color 0.18s ease,\n        -webkit-transform 0.2s ease;\n  transition:\n        transform 0.2s ease,\n        background-color 0.18s ease;\n  transition:\n        transform 0.2s ease,\n        background-color 0.18s ease,\n        -webkit-transform 0.2s ease;\n  width: 26px;\n}\n.slider.pinned .innerknob::after {\n  color: rgb(255, 255, 255);\n  content: attr(data-value);\n  font-size: 10px;\n  height: 26px;\n  left: 0;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  -webkit-transform: scale(0) translate(0);\n          transform: scale(0) translate(0);\n  transition:\n        background-color 0.18s ease,\n        -webkit-transform 0.2s ease;\n  transition:\n        transform 0.2s ease,\n        background-color 0.18s ease;\n  transition:\n        transform 0.2s ease,\n        background-color 0.18s ease,\n        -webkit-transform 0.2s ease;\n  width: 32px;\n}\n.slider.pressed.pinned .innerknob::before {\n  -webkit-transform: rotate(-45deg) scale(1) translate(17px, -17px);\n          transform: rotate(-45deg) scale(1) translate(17px, -17px);\n  transition-delay: 100ms;\n}\n.slider.pressed.pinned .innerknob::after {\n  -webkit-transform: scale(1) translate(0, -17px);\n          transform: scale(1) translate(0, -17px);\n  transition-delay: 100ms;\n}\n.slider.pressed:not(.pinned).ring .progress {\n  left: 30px;\n  width: calc(100% - 14px);\n}\n.slider.pressed:not(.pinned) .innerknob {\n  height: 100%;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n  width: 100%;\n}\n.slider.ring .innerknob {\n  background-color: transparent;\n  border: 2px solid rgb(238, 238, 238);\n}\n.slider.ring .innerknob::before {\n  background-color: rgb(63, 81, 181);\n}\n.slider.ring .progress {\n  left: 20px;\n  transition:\n        left 0.18s ease,\n        width 0.18s ease;\n  width: calc(100% - 2px * 2);\n}\n.slider.ring.pinned .innerknob {\n  background-color: rgb(255, 255, 255);\n}\n.slider.ring.pinned .progress {\n  left: 16px;\n  width: 100%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"container": "theme--container--3zHuUteX",
	"knob": "theme--knob--3yfj7-Wh",
	"innerknob": "theme--innerknob--3Lo33Yd2",
	"snaps": "theme--snaps--MJvMdXQV",
	"snap": "theme--snap--1NtZ08eQ",
	"input": "theme--input--1p5hUDAD",
	"progress": "theme--progress--1e50k9pC",
	"innerprogress": "theme--innerprogress--VR5zjas5",
	"slider": "theme--slider--1j4aHZna",
	"editable": "theme--editable--1eFK7hK5",
	"pinned": "theme--pinned--1L0wgb9r",
	"pressed": "theme--pressed--Hh4blIMJ",
	"ring": "theme--ring--3dDzMdAI"
};

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = exports.switchFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _Ripple = __webpack_require__(121);

var _Ripple2 = _interopRequireDefault(_Ripple);

var _Thumb = __webpack_require__(940);

var _Thumb2 = _interopRequireDefault(_Thumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(Thumb) {
  var Switch = function (_Component) {
    _inherits(Switch, _Component);

    function Switch() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Switch);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Switch.__proto__ || Object.getPrototypeOf(Switch)).call.apply(_ref, [this].concat(args))), _this), _this.handleToggle = function (event) {
        if (event.pageX !== 0 && event.pageY !== 0) _this.blur();
        if (!_this.props.disabled && _this.props.onChange) {
          _this.props.onChange(!_this.props.checked, event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Switch, [{
      key: 'blur',
      value: function blur() {
        this.inputNode.blur();
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.inputNode.focus();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            checked = _props.checked,
            className = _props.className,
            disabled = _props.disabled,
            onChange = _props.onChange,
            ripple = _props.ripple,
            theme = _props.theme,
            others = _objectWithoutProperties(_props, ['checked', 'className', 'disabled', 'onChange', 'ripple', 'theme']);

        var _className = (0, _classnames2.default)(theme[disabled ? 'disabled' : 'field'], className);
        return _react2.default.createElement(
          'label',
          { 'data-react-toolbox': 'switch', className: _className },
          _react2.default.createElement('input', _extends({}, others, {
            checked: this.props.checked,
            className: theme.input,
            onClick: this.handleToggle,
            readOnly: true,
            ref: function ref(node) {
              _this2.inputNode = node;
            },
            type: 'checkbox'
          })),
          _react2.default.createElement(
            'span',
            { className: theme[checked ? 'on' : 'off'] },
            _react2.default.createElement(Thumb, {
              disabled: this.props.disabled,
              theme: theme,
              ripple: ripple
            })
          ),
          this.props.label ? _react2.default.createElement(
            'span',
            { className: theme.text },
            this.props.label
          ) : null
        );
      }
    }]);

    return Switch;
  }(_react.Component);

  Switch.propTypes = {
    checked: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    label: _propTypes2.default.string,
    name: _propTypes2.default.string,
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    ripple: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      disabled: _propTypes2.default.string,
      field: _propTypes2.default.string,
      input: _propTypes2.default.string,
      off: _propTypes2.default.string,
      on: _propTypes2.default.string,
      ripple: _propTypes2.default.string,
      text: _propTypes2.default.string,
      thumb: _propTypes2.default.string
    })
  };
  Switch.defaultProps = {
    checked: false,
    className: '',
    disabled: false
  };


  return Switch;
};

var Thumb = (0, _Thumb2.default)((0, _Ripple2.default)({ centered: true, spread: 2.6 }));
var Switch = factory(Thumb);

exports.default = (0, _reactCssThemr.themr)(_identifiers.SWITCH)(Switch);
exports.switchFactory = factory;
exports.Switch = Switch;

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2212);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--field--3bGHeVaw {\n  display: block;\n  margin-bottom: 15px;\n  position: relative;\n  white-space: normal;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.theme--field--3bGHeVaw *,\n    .theme--field--3bGHeVaw *::after,\n    .theme--field--3bGHeVaw *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--text--279X5fg- {\n  color: rgb(0, 0, 0);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 24px;\n  padding-left: 10px;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.theme--thumb--29AL5TmQ {\n  border-radius: 50%;\n  cursor: pointer;\n  height: 20px;\n  position: absolute;\n  top: -3px;\n  transition-duration: 0.28s;\n  transition-property: left;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: 20px;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.theme--thumb--29AL5TmQ *,\n    .theme--thumb--29AL5TmQ *::after,\n    .theme--thumb--29AL5TmQ *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--thumb--29AL5TmQ .theme--ripple--2shy2Wi3 {\n  background-color: rgb(63, 81, 181);\n  opacity: 0.3;\n  transition-duration: 650ms;\n}\n.theme--on--lHsjAjus,\n.theme--off--3zh6zWeG {\n  border-radius: 14px;\n  cursor: pointer;\n  display: inline-block;\n  height: 14px;\n  margin-top: 5px;\n  position: relative;\n  vertical-align: top;\n  width: 36px;\n}\n.theme--on--lHsjAjus {\n  background: rgba(63, 81, 181, 0.5)\n}\n.theme--on--lHsjAjus .theme--thumb--29AL5TmQ {\n  background: rgb(63, 81, 181);\n  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, .14),\n    0 3px 3px -2px rgba(0, 0, 0, .2),\n    0 1px 8px 0 rgba(0, 0, 0, .12);\n  left: 16px;\n}\n.theme--off--3zh6zWeG {\n  background: rgba(0, 0, 0, 0.26)\n}\n.theme--off--3zh6zWeG .theme--thumb--29AL5TmQ {\n  background: rgb(250, 250, 250);\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n  left: 0;\n}\n.theme--off--3zh6zWeG .theme--ripple--2shy2Wi3 {\n  background: rgba(0, 0, 0, 0.4);\n}\n.theme--input--3KUmflWL {\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n  width: 0\n}\n.theme--input--3KUmflWL:focus:not(:active) + .theme--switch-on--IbaCMqGJ > .theme--thumb--29AL5TmQ::before,\n    .theme--input--3KUmflWL:focus:not(:active) + .theme--switch-off--oPE86zH4 > .theme--thumb--29AL5TmQ::before {\n  background-color: transparent;\n  border-radius: 50%;\n  box-sizing: border-box;\n  content: '';\n  display: inline-block;\n  height: 8px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(-4px, -4px);\n          transform: translate(-4px, -4px);\n  width: 8px;\n}\n.theme--input--3KUmflWL:focus:not(:active) + .theme--switch-on--IbaCMqGJ > .theme--thumb--29AL5TmQ::before {\n  background-color: rgba(63, 81, 181, 0.26);\n  box-shadow: 0 0 0 20px rgba(63, 81, 181, 0.26);\n}\n.theme--input--3KUmflWL:focus:not(:active) + .theme--switch-off--oPE86zH4 > .theme--thumb--29AL5TmQ::before {\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 0 20px rgba(0, 0, 0, 0.1);\n}\n.theme--disabled--1y9LMfDb {\n}\n.theme--disabled--1y9LMfDb .theme--text--279X5fg- {\n  color: rgba(0, 0, 0, 0.26);\n}\n.theme--disabled--1y9LMfDb .theme--on--lHsjAjus,\n  .theme--disabled--1y9LMfDb .theme--off--3zh6zWeG {\n  background: rgba(0, 0, 0, 0.12);\n  cursor: auto;\n}\n.theme--disabled--1y9LMfDb .theme--thumb--29AL5TmQ {\n  background-color: rgb(189, 189, 189);\n  border-color: transparent;\n  cursor: auto;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/switch/theme.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;CAChC;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;CACrB;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,0BAA0B;EAC1B,yDAAyD;EACzD,YAAY;EACZ,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,sBAAsB;CAC/B;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,mCAAmC;EACnC,aAAa;EACb,2BAA2B;CAC5B;AACD;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;CACb;AACD;EACE,kCAAkC;CACnC;AACD;EACE,6BAA6B;EAC7B;;mCAEiC;EACjC,WAAW;CACZ;AACD;EACE,+BAA+B;CAChC;AACD;EACE,+BAA+B;EAC/B;;mCAEiC;EACjC,QAAQ;CACT;AACD;EACE,+BAA+B;CAChC;AACD;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,QAAQ;CACT;AACD;;EAEE,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,yCAAyC;UACjC,iCAAiC;EACzC,WAAW;CACZ;AACD;EACE,0CAA0C;EAC1C,+CAA+C;CAChD;AACD;EACE,qCAAqC;EACrC,0CAA0C;CAC3C;AACD;CAEC;AACD;EACE,2BAA2B;CAC5B;AACD;;EAEE,gCAAgC;EAChC,aAAa;CACd;AACD;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;CACd","file":"theme.css","sourcesContent":[".field {\n  display: block;\n  margin-bottom: 15px;\n  position: relative;\n  white-space: normal;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.field *,\n    .field *::after,\n    .field *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.text {\n  color: rgb(0, 0, 0);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 24px;\n  padding-left: 10px;\n  vertical-align: top;\n  white-space: nowrap;\n}\n.thumb {\n  border-radius: 50%;\n  cursor: pointer;\n  height: 20px;\n  position: absolute;\n  top: -3px;\n  transition-duration: 0.28s;\n  transition-property: left;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  width: 20px;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%\n}\n.thumb *,\n    .thumb *::after,\n    .thumb *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.thumb .ripple {\n  background-color: rgb(63, 81, 181);\n  opacity: 0.3;\n  transition-duration: 650ms;\n}\n.on,\n.off {\n  border-radius: 14px;\n  cursor: pointer;\n  display: inline-block;\n  height: 14px;\n  margin-top: 5px;\n  position: relative;\n  vertical-align: top;\n  width: 36px;\n}\n.on {\n  background: rgba(63, 81, 181, 0.5)\n}\n.on .thumb {\n  background: rgb(63, 81, 181);\n  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, .14),\n    0 3px 3px -2px rgba(0, 0, 0, .2),\n    0 1px 8px 0 rgba(0, 0, 0, .12);\n  left: 16px;\n}\n.off {\n  background: rgba(0, 0, 0, 0.26)\n}\n.off .thumb {\n  background: rgb(250, 250, 250);\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14),\n    0 3px 1px -2px rgba(0, 0, 0, .2),\n    0 1px 5px 0 rgba(0, 0, 0, .12);\n  left: 0;\n}\n.off .ripple {\n  background: rgba(0, 0, 0, 0.4);\n}\n.input {\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n  width: 0\n}\n.input:focus:not(:active) + .switch-on > .thumb::before,\n    .input:focus:not(:active) + .switch-off > .thumb::before {\n  background-color: transparent;\n  border-radius: 50%;\n  box-sizing: border-box;\n  content: '';\n  display: inline-block;\n  height: 8px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(-4px, -4px);\n          transform: translate(-4px, -4px);\n  width: 8px;\n}\n.input:focus:not(:active) + .switch-on > .thumb::before {\n  background-color: rgba(63, 81, 181, 0.26);\n  box-shadow: 0 0 0 20px rgba(63, 81, 181, 0.26);\n}\n.input:focus:not(:active) + .switch-off > .thumb::before {\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 0 20px rgba(0, 0, 0, 0.1);\n}\n.disabled {\n  composes: field\n}\n.disabled .text {\n  color: rgba(0, 0, 0, 0.26);\n}\n.disabled .on,\n  .disabled .off {\n  background: rgba(0, 0, 0, 0.12);\n  cursor: auto;\n}\n.disabled .thumb {\n  background-color: rgb(189, 189, 189);\n  border-color: transparent;\n  cursor: auto;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"field": "theme--field--3bGHeVaw",
	"text": "theme--text--279X5fg-",
	"thumb": "theme--thumb--29AL5TmQ",
	"ripple": "theme--ripple--2shy2Wi3",
	"on": "theme--on--lHsjAjus",
	"off": "theme--off--3zh6zWeG",
	"input": "theme--input--3KUmflWL",
	"switch-on": "theme--switch-on--IbaCMqGJ",
	"switch-off": "theme--switch-off--oPE86zH4",
	"disabled": "theme--disabled--1y9LMfDb theme--field--3bGHeVaw"
};

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = exports.tableFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = __webpack_require__(10);

var _filterReactChildren = __webpack_require__(874);

var _filterReactChildren2 = _interopRequireDefault(_filterReactChildren);

var _isComponentOfType = __webpack_require__(265);

var _isComponentOfType2 = _interopRequireDefault(_isComponentOfType);

var _identifiers = __webpack_require__(16);

var _TableHead = __webpack_require__(941);

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TableRow = __webpack_require__(942);

var _TableRow2 = _interopRequireDefault(_TableRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(TableHead, TableRow) {
  var isTableHead = function isTableHead(child) {
    return (0, _isComponentOfType2.default)(TableHead, child);
  };
  var isTableRow = function isTableRow(child) {
    return (0, _isComponentOfType2.default)(TableRow, child);
  };

  var Table = function (_Component) {
    _inherits(Table, _Component);

    function Table() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Table);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.getRowTuples = function () {
        return _react2.default.Children.toArray((0, _filterReactChildren2.default)(_this.props.children, isTableRow)).map(function (child, index) {
          return [index, Boolean(child.props.selected)];
        });
      }, _this.handleHeadSelect = function (value) {
        if (_this.props.onRowSelect) {
          _this.props.onRowSelect(value ? _this.getRowTuples().map(function (item) {
            return item[0];
          }) : []);
        }
      }, _this.handleRowSelect = function (idx) {
        if (_this.props.onRowSelect) {
          if (_this.props.multiSelectable) {
            var current = _this.getRowTuples().filter(function (item) {
              return item[1];
            }).map(function (item) {
              return item[0];
            });
            var rowIndex = current.indexOf(idx);
            var indexes = rowIndex !== -1 ? [].concat(_toConsumableArray(current.slice(0, rowIndex)), _toConsumableArray(current.slice(rowIndex + 1))) : [].concat(_toConsumableArray(current), [idx]);
            _this.props.onRowSelect(indexes);
          } else {
            _this.props.onRowSelect([idx]);
          }
        }
      }, _this.renderHead = function () {
        var tuples = _this.getRowTuples();
        var selected = tuples.filter(function (item) {
          return item[1];
        }).length === tuples.length;
        return _react2.default.Children.map((0, _filterReactChildren2.default)(_this.props.children, isTableHead), function (child) {
          return (0, _react.cloneElement)(child, {
            selected: selected,
            multiSelectable: _this.props.multiSelectable,
            onSelect: _this.handleHeadSelect,
            selectable: _this.props.selectable
          });
        });
      }, _this.renderRows = function () {
        return _react2.default.Children.map((0, _filterReactChildren2.default)(_this.props.children, isTableRow), function (child, idx) {
          return (0, _react.cloneElement)(child, {
            idx: idx,
            onSelect: _this.handleRowSelect,
            selectable: _this.props.selectable
          });
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Table, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            multiSelectable = _props.multiSelectable,
            onRowSelect = _props.onRowSelect,
            selectable = _props.selectable,
            theme = _props.theme,
            rest = _objectWithoutProperties(_props, ['className', 'multiSelectable', 'onRowSelect', 'selectable', 'theme']);

        return _react2.default.createElement(
          'table',
          _extends({}, rest, { className: (0, _classnames2.default)(theme.table, className) }),
          _react2.default.createElement(
            'thead',
            { className: theme.head },
            this.renderHead()
          ),
          _react2.default.createElement(
            'tbody',
            null,
            this.renderRows()
          )
        );
      }
    }]);

    return Table;
  }(_react.Component);

  Table.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    multiSelectable: _propTypes2.default.bool,
    onRowSelect: _propTypes2.default.func,
    selectable: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      head: _propTypes2.default.string,
      table: _propTypes2.default.string
    })
  };
  Table.defaultProps = {
    className: '',
    multiSelectable: false,
    selectable: true
  };


  return Table;
};

var Table = factory(_TableHead2.default, _TableRow2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.TABLE)(Table);
exports.tableFactory = factory;
exports.Table = Table;

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2215);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--table--15DxjO3a {\n  background-color: rgb(255, 255, 255);\n  border-collapse: collapse;\n  font-size: 13px;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.theme--table--15DxjO3a *,\n    .theme--table--15DxjO3a *::after,\n    .theme--table--15DxjO3a *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme--head--1aVi-0kI {\n  padding-bottom: 3px;\n  white-space: nowrap;\n}\n.theme--row--1iBiNpDz {\n  color: rgba(0, 0, 0, 0.87);\n  height: 48px;\n  transition-duration: 0.28s;\n  transition-property: background-color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)\n}\n.theme--row--1iBiNpDz:hover {\n  background-color: #eee;\n}\n.theme--row--1iBiNpDz.theme--selected--1m0Qb-UP {\n  background-color: #f5f5f5;\n}\n.theme--rowCell--2H7oC2xp,\n.theme--headCell--2N4evaQ_ {\n  padding: 0 18px 12px 18px;\n  text-align: left\n}\n.theme--rowCell--2H7oC2xp:first-of-type, .theme--headCell--2N4evaQ_:first-of-type {\n  padding-left: 24px;\n}\n.theme--rowCell--2H7oC2xp:last-of-type, .theme--headCell--2N4evaQ_:last-of-type {\n  padding-right: 24px;\n}\n.theme--rowCell--2H7oC2xp.theme--numeric--btaCbAU1, .theme--headCell--2N4evaQ_.theme--numeric--btaCbAU1 {\n  text-align: right;\n}\n.theme--rowCell--2H7oC2xp {\n  border-bottom: 1px solid #e6e6e6;\n  border-top: 1px solid #e6e6e6;\n  height: 48px;\n  padding-top: 12px;\n  vertical-align: middle\n}\n.theme--rowCell--2H7oC2xp.theme--checkboxCell--1Lp27hKn {\n  width: 18px;\n}\n.theme--rowCell--2H7oC2xp.theme--checkboxCell--1Lp27hKn > * {\n  margin: 0;\n}\n.theme--headCell--2N4evaQ_ {\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 12px;\n  font-weight: 500;\n  height: 48px;\n  line-height: 24px;\n  padding-bottom: 8px;\n  text-overflow: ellipsis;\n  vertical-align: bottom\n}\n.theme--headCell--2N4evaQ_.theme--checkboxCell--1Lp27hKn {\n  width: 18px;\n}\n.theme--headCell--2N4evaQ_.theme--checkboxCell--1Lp27hKn > * {\n  margin: 0 0 3px;\n}\n.theme--headCell--2N4evaQ_.theme--sorted--3sJE9TX0 {\n  color: rgba(0, 0, 0, 0.87);\n  cursor: pointer;\n}\n.theme--headCell--2N4evaQ_.theme--sorted--3sJE9TX0:hover .theme--sortIcon--2RyW2WS3 {\n  color: rgba(0, 0, 0, 0.26);\n}\n.theme--sortIcon--2RyW2WS3 {\n  display: inline-block;\n  font-size: 16px;\n  margin-right: 3px;\n  transition: 0.28s -webkit-transform cubic-bezier(0.4, 0, 0.2, 1);\n  transition: 0.28s transform cubic-bezier(0.4, 0, 0.2, 1);\n  transition: 0.28s transform cubic-bezier(0.4, 0, 0.2, 1), 0.28s -webkit-transform cubic-bezier(0.4, 0, 0.2, 1);\n  vertical-align: sub\n}\n.theme--sortIcon--2RyW2WS3.theme--asc--1rWKrsBI {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/table/theme.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;CAChC;AACD;;;EAGE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;MAC3B,2BAA2B;UACvB,uBAAuB;EAC/B,4BAA4B;CAC7B;AACD;EACE,oBAAoB;EACpB,oBAAoB;CACrB;AACD;EACE,2BAA2B;EAC3B,aAAa;EACb,2BAA2B;EAC3B,sCAAsC;EACtC,wDAAwD;CACzD;AACD;EACE,uBAAuB;CACxB;AACD;EACE,0BAA0B;CAC3B;AACD;;EAEE,0BAA0B;EAC1B,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,sBAAsB;CACvB;AACD;EACE,YAAY;CACb;AACD;EACE,UAAU;CACX;AACD;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;CACvB;AACD;EACE,YAAY;CACb;AACD;EACE,gBAAgB;CACjB;AACD;EACE,2BAA2B;EAC3B,gBAAgB;CACjB;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,iEAAiE;EACjE,yDAAyD;EACzD,+GAA+G;EAC/G,mBAAmB;CACpB;AACD;EACE,kCAAkC;UAC1B,0BAA0B;CACnC","file":"theme.css","sourcesContent":[".table {\n  background-color: rgb(255, 255, 255);\n  border-collapse: collapse;\n  font-size: 13px;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\n.table *,\n    .table *::after,\n    .table *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.head {\n  padding-bottom: 3px;\n  white-space: nowrap;\n}\n.row {\n  color: rgba(0, 0, 0, 0.87);\n  height: 48px;\n  transition-duration: 0.28s;\n  transition-property: background-color;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)\n}\n.row:hover {\n  background-color: #eee;\n}\n.row.selected {\n  background-color: #f5f5f5;\n}\n.rowCell,\n.headCell {\n  padding: 0 18px 12px 18px;\n  text-align: left\n}\n.rowCell:first-of-type, .headCell:first-of-type {\n  padding-left: 24px;\n}\n.rowCell:last-of-type, .headCell:last-of-type {\n  padding-right: 24px;\n}\n.rowCell.numeric, .headCell.numeric {\n  text-align: right;\n}\n.rowCell {\n  border-bottom: 1px solid #e6e6e6;\n  border-top: 1px solid #e6e6e6;\n  height: 48px;\n  padding-top: 12px;\n  vertical-align: middle\n}\n.rowCell.checkboxCell {\n  width: 18px;\n}\n.rowCell.checkboxCell > * {\n  margin: 0;\n}\n.headCell {\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 12px;\n  font-weight: 500;\n  height: 48px;\n  line-height: 24px;\n  padding-bottom: 8px;\n  text-overflow: ellipsis;\n  vertical-align: bottom\n}\n.headCell.checkboxCell {\n  width: 18px;\n}\n.headCell.checkboxCell > * {\n  margin: 0 0 3px;\n}\n.headCell.sorted {\n  color: rgba(0, 0, 0, 0.87);\n  cursor: pointer;\n}\n.headCell.sorted:hover .sortIcon {\n  color: rgba(0, 0, 0, 0.26);\n}\n.sortIcon {\n  display: inline-block;\n  font-size: 16px;\n  margin-right: 3px;\n  transition: 0.28s -webkit-transform cubic-bezier(0.4, 0, 0.2, 1);\n  transition: 0.28s transform cubic-bezier(0.4, 0, 0.2, 1);\n  transition: 0.28s transform cubic-bezier(0.4, 0, 0.2, 1), 0.28s -webkit-transform cubic-bezier(0.4, 0, 0.2, 1);\n  vertical-align: sub\n}\n.sortIcon.asc {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"table": "theme--table--15DxjO3a",
	"head": "theme--head--1aVi-0kI",
	"row": "theme--row--1iBiNpDz",
	"selected": "theme--selected--1m0Qb-UP",
	"rowCell": "theme--rowCell--2H7oC2xp",
	"headCell": "theme--headCell--2N4evaQ_",
	"numeric": "theme--numeric--btaCbAU1",
	"checkboxCell": "theme--checkboxCell--1Lp27hKn",
	"sorted": "theme--sorted--3sJE9TX0",
	"sortIcon": "theme--sortIcon--2RyW2WS3",
	"asc": "theme--asc--1rWKrsBI"
};

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePicker = undefined;

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _TimePicker = __webpack_require__(2217);

var _TimePickerDialog = __webpack_require__(943);

var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);

var _dialog = __webpack_require__(47);

var _input = __webpack_require__(59);

var _theme = __webpack_require__(2221);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimePickerDialog = (0, _TimePickerDialog2.default)(_dialog.Dialog);
var ThemedTimePicker = (0, _reactCssThemr.themr)(_identifiers.TIME_PICKER, _theme2.default)((0, _TimePicker.timePickerFactory)(TimePickerDialog, _input.Input));
exports.default = ThemedTimePicker;
exports.TimePicker = ThemedTimePicker;

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePicker = exports.timePickerFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(14);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactCssThemr = __webpack_require__(10);

var _identifiers = __webpack_require__(16);

var _events = __webpack_require__(143);

var _events2 = _interopRequireDefault(_events);

var _time = __webpack_require__(145);

var _time2 = _interopRequireDefault(_time);

var _Dialog = __webpack_require__(477);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Input = __webpack_require__(223);

var _Input2 = _interopRequireDefault(_Input);

var _TimePickerDialog = __webpack_require__(943);

var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory = function factory(TimePickerDialog, Input) {
  var TimePicker = function (_Component) {
    _inherits(TimePicker, _Component);

    function TimePicker() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TimePicker);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: _this.props.active
      }, _this.handleDismiss = function () {
        _this.setState({ active: false });
        if (_this.props.onDismiss) {
          _this.props.onDismiss();
        }
      }, _this.handleInputFocus = function (event) {
        _events2.default.pauseEvent(event);
        _this.setState({ active: true });
      }, _this.handleInputBlur = function (event) {
        _events2.default.pauseEvent(event);
        _this.setState({ active: false });
      }, _this.handleInputClick = function (event) {
        _events2.default.pauseEvent(event);
        _this.setState({ active: true });
        if (_this.props.onClick) _this.props.onClick(event);
      }, _this.handleInputKeyPress = function (event) {
        if (event.charCode === 13) {
          _events2.default.pauseEvent(event);
          _this.setState({ active: true });
        }
        if (_this.props.onKeyPress) _this.props.onKeyPress(event);
      }, _this.handleSelect = function (value, event) {
        if (_this.props.onChange) _this.props.onChange(value, event);
        _this.setState({ active: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TimePicker, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.active !== this.props.active && this.state.active !== nextProps.active) {
          this.setState({ active: nextProps.active });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            active = _props.active,
            onDismiss = _props.onDismiss,
            cancelLabel = _props.cancelLabel,
            format = _props.format,
            inputClassName = _props.inputClassName,
            okLabel = _props.okLabel,
            onEscKeyDown = _props.onEscKeyDown,
            onOverlayClick = _props.onOverlayClick,
            readonly = _props.readonly,
            value = _props.value,
            others = _objectWithoutProperties(_props, ['active', 'onDismiss', 'cancelLabel', 'format', 'inputClassName', 'okLabel', 'onEscKeyDown', 'onOverlayClick', 'readonly', 'value']);

        var formattedTime = value ? _time2.default.formatTime(value, format) : '';
        return _react2.default.createElement(
          'div',
          {
            'data-react-toolbox': 'time-picker',
            className: this.props.theme.container
          },
          _react2.default.createElement(Input, _extends({}, others, {
            className: (0, _classnames3.default)(this.props.theme.input, _defineProperty({}, inputClassName, inputClassName)),
            disabled: readonly,
            error: this.props.error,
            label: this.props.label,
            name: this.props.name,
            onKeyPress: this.handleInputKeyPress,
            onClick: this.handleInputClick,
            readOnly: true,
            type: 'text',
            value: formattedTime
          })),
          _react2.default.createElement(TimePickerDialog, {
            active: this.state.active,
            cancelLabel: cancelLabel,
            className: this.props.className,
            format: format,
            name: this.props.name,
            okLabel: okLabel,
            onDismiss: this.handleDismiss,
            onEscKeyDown: onEscKeyDown,
            onOverlayClick: onOverlayClick,
            onSelect: this.handleSelect,
            theme: this.props.theme,
            value: this.props.value
          })
        );
      }
    }]);

    return TimePicker;
  }(_react.Component);

  TimePicker.propTypes = {
    active: _propTypes2.default.bool,
    cancelLabel: _propTypes2.default.string,
    className: _propTypes2.default.string,
    error: _propTypes2.default.string,
    format: _propTypes2.default.oneOf(['24hr', 'ampm']),
    inputClassName: _propTypes2.default.string,
    label: _propTypes2.default.string,
    name: _propTypes2.default.string,
    okLabel: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    onDismiss: _propTypes2.default.func,
    onEscKeyDown: _propTypes2.default.func,
    onKeyPress: _propTypes2.default.func,
    onOverlayClick: _propTypes2.default.func,
    readonly: _propTypes2.default.bool,
    theme: _propTypes2.default.shape({
      container: _propTypes2.default.string,
      input: _propTypes2.default.string
    }),
    value: _propTypes2.default.instanceOf(Date)
  };
  TimePicker.defaultProps = {
    active: false,
    className: '',
    format: '24hr'
  };


  return TimePicker;
};

var TimePickerDialog = (0, _TimePickerDialog2.default)(_Dialog2.default);
var TimePicker = factory(TimePickerDialog, _Input2.default);
exports.default = (0, _reactCssThemr.themr)(_identifiers.TIME_PICKER)(TimePicker);
exports.timePickerFactory = factory;
exports.TimePicker = TimePicker;

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSTransitionGroup = __webpack_require__(469);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _utils = __webpack_require__(106);

var _time = __webpack_require__(145);

var _time2 = _interopRequireDefault(_time);

var _ClockHours = __webpack_require__(2219);

var _ClockHours2 = _interopRequireDefault(_ClockHours);

var _ClockMinutes = __webpack_require__(2220);

var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Clock = function (_Component) {
  _inherits(Clock, _Component);

  function Clock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Clock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Clock.__proto__ || Object.getPrototypeOf(Clock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      center: { x: null, y: null },
      radius: 0
    }, _this.handleHourChange = function (hours) {
      if (_this.props.time.getHours() !== hours) {
        _this.props.onChange(_time2.default.setHours(_this.props.time, _this.adaptHourToFormat(hours)));
      }
    }, _this.handleMinuteChange = function (minutes) {
      if (_this.props.time.getMinutes() !== minutes) {
        _this.props.onChange(_time2.default.setMinutes(_this.props.time, minutes));
      }
    }, _this.handleCalculateShape = function () {
      var _this$placeholderNode = _this.placeholderNode.getBoundingClientRect(),
          top = _this$placeholderNode.top,
          left = _this$placeholderNode.left,
          width = _this$placeholderNode.width;

      _this.setState({
        center: {
          x: left + (width / 2 - window.pageXOffset),
          y: top + (width / 2 - window.pageXOffset)
        },
        radius: width / 2
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Clock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.handleCalculateShape);
      setTimeout(function () {
        _this2.handleCalculateShape();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleCalculateShape);
    }
  }, {
    key: 'adaptHourToFormat',
    value: function adaptHourToFormat(hour) {
      if (this.props.format === 'ampm') {
        if (_time2.default.getTimeMode(this.props.time) === 'pm') {
          return hour < 12 ? hour + 12 : hour;
        }
        return hour === 12 ? 0 : hour;
      }
      return hour;
    }
  }, {
    key: 'renderHours',
    value: function renderHours() {
      return _react2.default.createElement(_ClockHours2.default, {
        center: this.state.center,
        format: this.props.format,
        onChange: this.handleHourChange,
        radius: this.state.radius,
        selected: this.props.time.getHours(),
        spacing: this.state.radius * 0.18,
        onHandMoved: this.props.onHandMoved,
        theme: this.props.theme
      });
    }
  }, {
    key: 'renderMinutes',
    value: function renderMinutes() {
      return _react2.default.createElement(_ClockMinutes2.default, {
        center: this.state.center,
        onChange: this.handleMinuteChange,
        radius: this.state.radius,
        selected: this.props.time.getMinutes(),
        spacing: this.state.radius * 0.18,
        onHandMoved: this.props.onHandMoved,
        theme: this.props.theme
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var theme = this.props.theme;

      var animation = this.state.display === 'hours' ? 'zoomOut' : 'zoomIn';
      var animationModule = (0, _utils.getAnimationModule)(animation, theme);
      return _react2.default.createElement(
        'div',
        { 'data-react-toolbox': 'clock', className: theme.clock },
        _react2.default.createElement(
          'div',
          {
            className: theme.placeholder,
            style: { height: this.state.radius * 2 },
            ref: function ref(node) {
              _this3.placeholderNode = node;
            }
          },
          _react2.default.createElement(
            _CSSTransitionGroup2.default,
            {
              transitionName: animationModule,
              transitionEnterTimeout: 500,
              transitionLeaveTimeout: 500
            },
            _react2.default.createElement(
              'div',
              {
                key: this.props.display,
                className: theme.clockWrapper,
                style: { height: this.state.radius * 2 }
              },
              this.props.display === 'hours' ? this.renderHours() : null,
              this.props.display === 'minutes' ? this.renderMinutes() : null
            )
          )
        )
      );
    }
  }]);

  return Clock;
}(_react.Component);

Clock.propTypes = {
  display: _propTypes2.default.oneOf(['hours', 'minutes']),
  format: _propTypes2.default.oneOf(['24hr', 'ampm']),
  onChange: _propTypes2.default.func,
  onHandMoved: _propTypes2.default.func,
  theme: _propTypes2.default.shape({
    clock: _propTypes2.default.string,
    clockWrapper: _propTypes2.default.string,
    placeholder: _propTypes2.default.string
  }),
  time: _propTypes2.default.instanceOf(Date)
};
Clock.defaultProps = {
  className: '',
  display: 'hours',
  format: '24hr',
  time: new Date()
};
exports.default = Clock;

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(106);

var _ClockHand = __webpack_require__(944);

var _ClockHand2 = _interopRequireDefault(_ClockHand);

var _ClockFace = __webpack_require__(945);

var _ClockFace2 = _interopRequireDefault(_ClockFace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var outerNumbers = [0].concat(_toConsumableArray((0, _utils.range)(13, 24)));
var innerNumbers = [12].concat(_toConsumableArray((0, _utils.range)(1, 12)));
var innerSpacing = 1.7;
var step = 360 / 12;

var Hours = function (_Component) {
  _inherits(Hours, _Component);

  function Hours() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Hours);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hours.__proto__ || Object.getPrototypeOf(Hours)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inner: _this.props.format === '24hr' && _this.props.selected > 0 && _this.props.selected <= 12
    }, _this.handleHandMove = function (degrees, radius) {
      var currentInner = radius < _this.props.radius - _this.props.spacing * innerSpacing;
      if (_this.props.format === '24hr' && _this.state.inner !== currentInner) {
        _this.setState({ inner: currentInner }, function () {
          _this.props.onChange(_this.valueFromDegrees(degrees));
        });
      } else {
        _this.props.onChange(_this.valueFromDegrees(degrees));
      }
    }, _this.handleMouseDown = function (event) {
      _this.handNode.mouseStart(event);
    }, _this.handleTouchStart = function (event) {
      _this.handNode.touchStart(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hours, [{
    key: 'valueFromDegrees',
    value: function valueFromDegrees(degrees) {
      if (this.props.format === 'ampm' || this.props.format === '24hr' && this.state.inner) {
        return innerNumbers[degrees / step];
      }
      return outerNumbers[degrees / step];
    }
  }, {
    key: 'renderInnerFace',
    value: function renderInnerFace(innerRadius) {
      if (this.props.format !== '24hr') return undefined;
      return _react2.default.createElement(_ClockFace2.default, {
        onTouchStart: this.handleTouchStart,
        onMouseDown: this.handleMouseDown,
        numbers: innerNumbers,
        spacing: this.props.spacing,
        radius: innerRadius,
        theme: this.props.theme,
        active: this.props.selected
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          format = _props.format,
          selected = _props.selected,
          radius = _props.radius,
          spacing = _props.spacing,
          center = _props.center,
          onHandMoved = _props.onHandMoved;

      var is24hr = format === '24hr';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ClockFace2.default, {
          onTouchStart: this.handleTouchStart,
          onMouseDown: this.handleMouseDown,
          numbers: is24hr ? outerNumbers : innerNumbers,
          spacing: spacing,
          radius: radius,
          twoDigits: is24hr,
          active: is24hr ? selected : selected % 12 || 12,
          theme: this.props.theme
        }),
        this.renderInnerFace(radius - spacing * innerSpacing),
        _react2.default.createElement(_ClockHand2.default, {
          ref: function ref(node) {
            _this2.handNode = node;
          },
          angle: selected * step,
          length: (this.state.inner ? radius - spacing * innerSpacing : radius) - spacing,
          onMove: this.handleHandMove,
          theme: this.props.theme,
          onMoved: onHandMoved,
          origin: center,
          step: step
        })
      );
    }
  }]);

  return Hours;
}(_react.Component);

Hours.propTypes = {
  center: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),
  format: _propTypes2.default.oneOf(['24hr', 'ampm']),
  onChange: _propTypes2.default.func,
  onHandMoved: _propTypes2.default.func,
  radius: _propTypes2.default.number,
  selected: _propTypes2.default.number,
  spacing: _propTypes2.default.number,
  theme: _propTypes2.default.object };
exports.default = Hours;

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(106);

var _ClockHand = __webpack_require__(944);

var _ClockHand2 = _interopRequireDefault(_ClockHand);

var _ClockFace = __webpack_require__(945);

var _ClockFace2 = _interopRequireDefault(_ClockFace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var minutes = (0, _utils.range)(0, 60, 5);
var step = 360 / 60;

var Minutes = function (_Component) {
  _inherits(Minutes, _Component);

  function Minutes() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Minutes);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Minutes.__proto__ || Object.getPrototypeOf(Minutes)).call.apply(_ref, [this].concat(args))), _this), _this.handleHandMove = function (degrees) {
      _this.props.onChange(degrees / step);
    }, _this.handleMouseDown = function (event) {
      _this.handNode.mouseStart(event);
    }, _this.handleTouchStart = function (event) {
      _this.handNode.touchStart(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Minutes, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ClockFace2.default, {
          onTouchStart: this.handleTouchStart,
          onMouseDown: this.handleMouseDown,
          numbers: minutes,
          spacing: this.props.spacing,
          radius: this.props.radius,
          active: this.props.selected,
          theme: this.props.theme,
          twoDigits: true
        }),
        _react2.default.createElement(_ClockHand2.default, {
          ref: function ref(node) {
            _this2.handNode = node;
          },
          className: minutes.indexOf(this.props.selected) === -1 ? this.props.theme.small : '',
          angle: this.props.selected * step,
          length: this.props.radius - this.props.spacing,
          onMove: this.handleHandMove,
          origin: this.props.center,
          theme: this.props.theme,
          step: step
        })
      );
    }
  }]);

  return Minutes;
}(_react.Component);

Minutes.propTypes = {
  center: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),
  onChange: _propTypes2.default.func,
  radius: _propTypes2.default.number,
  selected: _propTypes2.default.number,
  spacing: _propTypes2.default.number,
  theme: _propTypes2.default.shape({
    small: _propTypes2.default.string
  })
};
Minutes.defaultProps = {
  selected: 0,
  onChange: null
};
exports.default = Minutes;

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2222);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css", function() {
			var newContent = require("!!../../../css-loader/index.js??ref--1-1!../../../postcss-loader/lib/index.js!./theme.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".theme--input--12X-HavI:not(.theme--disabled--1ugmjqvn) > .theme--inputElement--BMzf8HMw {\n  cursor: pointer;\n}\n.theme--header--1Tl0ADNR {\n  background: rgb(63, 81, 181);\n  color: rgb(255, 255, 255);\n  font-size: 52px;\n  padding: 10px;\n  position: relative;\n  text-align: center;\n  width: 100%;\n}\n.theme--hours--1w8iAeIu,\n.theme--minutes--1x1mC0lw {\n  cursor: pointer;\n  display: inline-block;\n  opacity: 0.6;\n}\n.theme--separator--3nL_QGJd {\n  margin: 0 5px;\n  opacity: 0.6;\n}\n.theme--ampm--1LQjzuCT {\n  font-size: 16px;\n  height: 44px;\n  line-height: 22px;\n  margin-top: -22px;\n  position: absolute;\n  right: 20px;\n  text-align: center;\n  top: 50%;\n  width: 40px;\n}\n.theme--am--3Y9UIl78,\n.theme--pm--1unEK8G0 {\n  cursor: pointer;\n  display: block;\n  opacity: 0.6;\n}\n.theme--dialog--13dIQfBr {\n  width: 300px\n}\n.theme--dialog--13dIQfBr > [role='body'] {\n  overflow-y: visible;\n  padding: 0;\n}\n.theme--dialog--13dIQfBr > [role='navigation'] > .theme--button--PQRyDY17 {\n  color: rgb(63, 81, 181);\n}\n.theme--dialog--13dIQfBr > [role='navigation'] > .theme--button--PQRyDY17:hover {\n  background: rgba(63, 81, 181, 0.2);\n}\n.theme--dialog--13dIQfBr > [role='navigation'] > .theme--button--PQRyDY17:focus:not(:active) {\n  background: rgba(63, 81, 181, 0.2);\n}\n.theme--dialog--13dIQfBr.theme--hoursDisplay--YU7eR8_b .theme--hours--1w8iAeIu,\n  .theme--dialog--13dIQfBr.theme--minutesDisplay--17AlX3FF .theme--minutes--1x1mC0lw,\n  .theme--dialog--13dIQfBr.theme--amFormat--3G7MbvId .theme--am--3Y9UIl78,\n  .theme--dialog--13dIQfBr.theme--pmFormat--1THSaSnr .theme--pm--1unEK8G0 {\n  opacity: 1;\n}\n.theme--clock--j0Vud1wY {\n  padding: 15px 20px;\n}\n.theme--placeholder--1qekNaG9 {\n  position: relative;\n  z-index: 100;\n}\n.theme--clockWrapper--15-DPsIF {\n  background-color: rgb(238, 238, 238);\n  border-radius: 50%;\n  position: absolute;\n  width: 100%;\n}\n.theme--face--1xGuMGBI {\n  border-radius: 50%;\n  cursor: pointer;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n          transform: translateX(-50%) translateY(-50%);\n  z-index: 100;\n}\n.theme--number--saULIOEO {\n  height: 20px;\n  margin-left: -10px;\n  margin-top: -10px;\n  pointer-events: none;\n  position: relative;\n  text-align: center;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: 20px\n}\n.theme--number--saULIOEO.theme--active--1XapeE6y {\n  color: rgb(255, 255, 255);\n}\n.theme--hand--3u0MIdGG {\n  background-color: rgb(63, 81, 181);\n  bottom: 50%;\n  display: block;\n  left: 50%;\n  margin-left: -2px;\n  position: absolute;\n  -webkit-transform-origin: 50% 100%;\n          transform-origin: 50% 100%;\n  width: 4px\n}\n.theme--hand--3u0MIdGG::before {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50%;\n  bottom: 0;\n  content: '';\n  height: 10px;\n  left: 50%;\n  margin-bottom: -5px;\n  margin-left: -5px;\n  position: absolute;\n  width: 10px;\n}\n.theme--hand--3u0MIdGG.theme--small--1iq814zd > .theme--knob--2eaTrmO- {\n  background-color: rgba(63, 81, 181, 0.2);\n}\n.theme--hand--3u0MIdGG.theme--small--1iq814zd > .theme--knob--2eaTrmO-::after {\n  background: rgb(63, 81, 181);\n  border-radius: 50%;\n  content: '';\n  height: 12px;\n  left: 50%;\n  margin-left: -6px;\n  margin-top: -6px;\n  position: absolute;\n  top: 50%;\n  width: 12px;\n}\n.theme--hand--3u0MIdGG.theme--small--1iq814zd > .theme--knob--2eaTrmO-::before {\n  background: rgb(63, 81, 181);\n  bottom: 0;\n  content: '';\n  height: 22px;\n  left: 50%;\n  margin-left: -2px;\n  position: absolute;\n  width: 4px;\n}\n.theme--knob--2eaTrmO- {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50%;\n  cursor: pointer;\n  height: 34px;\n  left: 50%;\n  margin-left: -17px;\n  position: absolute;\n  top: -34px;\n  width: 34px;\n}\n.theme--zoomInEnter--1pScdHdT,\n.theme--zoomInLeave--1tIDJwtj {\n  position: absolute;\n}\n.theme--zoomInEnterActive--386tv5h3,\n.theme--zoomInLeaveActive--3kKGoSwB {\n  transition: opacity, -webkit-transform;\n  transition: transform, opacity;\n  transition: transform, opacity, -webkit-transform;\n  transition-duration: 500ms;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.theme--zoomInEnter--1pScdHdT {\n  opacity: 0;\n  -webkit-transform: scale(0.85);\n          transform: scale(0.85)\n}\n.theme--zoomInEnter--1pScdHdT.theme--zoomInEnterActive--386tv5h3 {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.theme--zoomInLeave--1tIDJwtj {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1)\n}\n.theme--zoomInLeave--1tIDJwtj.theme--zoomInLeaveActive--3kKGoSwB {\n  opacity: 0;\n  -webkit-transform: scale(1.25);\n          transform: scale(1.25);\n}\n.theme--zoomOutEnter--Mcjk3BvC,\n.theme--zoomOutLeave--3Zo5Ez08 {\n  position: absolute;\n}\n.theme--zoomOutEnterActive--1s2Ze9HW,\n.theme--zoomOutLeaveActive--2RMpxJO5 {\n  transition: opacity, -webkit-transform;\n  transition: transform, opacity;\n  transition: transform, opacity, -webkit-transform;\n  transition-duration: 500ms;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.theme--zoomOutEnter--Mcjk3BvC {\n  opacity: 0;\n  -webkit-transform: scale(1.25);\n          transform: scale(1.25)\n}\n.theme--zoomOutEnter--Mcjk3BvC.theme--zoomOutEnterActive--1s2Ze9HW {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.theme--zoomOutLeave--3Zo5Ez08 {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1)\n}\n.theme--zoomOutLeave--3Zo5Ez08.theme--zoomOutLeaveActive--2RMpxJO5 {\n  opacity: 0;\n  -webkit-transform: scale(0.85);\n          transform: scale(0.85);\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-toolbox/lib/time_picker/theme.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;CACjB;AACD;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;CACb;AACD;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;CACd;AACD;EACE,cAAc;EACd,aAAa;CACd;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,YAAY;CACb;AACD;;EAEE,gBAAgB;EAChB,eAAe;EACf,aAAa;CACd;AACD;EACE,YAAY;CACb;AACD;EACE,oBAAoB;EACpB,WAAW;CACZ;AACD;EACE,wBAAwB;CACzB;AACD;EACE,mCAAmC;CACpC;AACD;EACE,mCAAmC;CACpC;AACD;;;;EAIE,WAAW;CACZ;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,qDAAqD;UAC7C,6CAA6C;EACrD,aAAa;CACd;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;KACvB,uBAAuB;MACtB,sBAAsB;UAClB,kBAAkB;EAC1B,WAAW;CACZ;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,mCAAmC;EACnC,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;UAC3B,2BAA2B;EACnC,UAAU;CACX;AACD;EACE,mCAAmC;EACnC,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,yCAAyC;CAC1C;AACD;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,YAAY;CACb;AACD;EACE,6BAA6B;EAC7B,UAAU;EACV,YAAY;EACZ,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;CACZ;AACD;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;CACb;AACD;;EAEE,mBAAmB;CACpB;AACD;;EAEE,uCAAuC;EACvC,+BAA+B;EAC/B,kDAAkD;EAClD,2BAA2B;EAC3B,yDAAyD;CAC1D;AACD;EACE,WAAW;EACX,+BAA+B;UACvB,sBAAsB;CAC/B;AACD;EACE,WAAW;EACX,4BAA4B;UACpB,oBAAoB;CAC7B;AACD;EACE,WAAW;EACX,4BAA4B;UACpB,mBAAmB;CAC5B;AACD;EACE,WAAW;EACX,+BAA+B;UACvB,uBAAuB;CAChC;AACD;;EAEE,mBAAmB;CACpB;AACD;;EAEE,uCAAuC;EACvC,+BAA+B;EAC/B,kDAAkD;EAClD,2BAA2B;EAC3B,yDAAyD;CAC1D;AACD;EACE,WAAW;EACX,+BAA+B;UACvB,sBAAsB;CAC/B;AACD;EACE,WAAW;EACX,4BAA4B;UACpB,oBAAoB;CAC7B;AACD;EACE,WAAW;EACX,4BAA4B;UACpB,mBAAmB;CAC5B;AACD;EACE,WAAW;EACX,+BAA+B;UACvB,uBAAuB;CAChC","file":"theme.css","sourcesContent":[".input:not(.disabled) > .inputElement {\n  cursor: pointer;\n}\n.header {\n  background: rgb(63, 81, 181);\n  color: rgb(255, 255, 255);\n  font-size: 52px;\n  padding: 10px;\n  position: relative;\n  text-align: center;\n  width: 100%;\n}\n.hours,\n.minutes {\n  cursor: pointer;\n  display: inline-block;\n  opacity: 0.6;\n}\n.separator {\n  margin: 0 5px;\n  opacity: 0.6;\n}\n.ampm {\n  font-size: 16px;\n  height: 44px;\n  line-height: 22px;\n  margin-top: -22px;\n  position: absolute;\n  right: 20px;\n  text-align: center;\n  top: 50%;\n  width: 40px;\n}\n.am,\n.pm {\n  cursor: pointer;\n  display: block;\n  opacity: 0.6;\n}\n.dialog {\n  width: 300px\n}\n.dialog > [role='body'] {\n  overflow-y: visible;\n  padding: 0;\n}\n.dialog > [role='navigation'] > .button {\n  color: rgb(63, 81, 181);\n}\n.dialog > [role='navigation'] > .button:hover {\n  background: rgba(63, 81, 181, 0.2);\n}\n.dialog > [role='navigation'] > .button:focus:not(:active) {\n  background: rgba(63, 81, 181, 0.2);\n}\n.dialog.hoursDisplay .hours,\n  .dialog.minutesDisplay .minutes,\n  .dialog.amFormat .am,\n  .dialog.pmFormat .pm {\n  opacity: 1;\n}\n.clock {\n  padding: 15px 20px;\n}\n.placeholder {\n  position: relative;\n  z-index: 100;\n}\n.clockWrapper {\n  background-color: rgb(238, 238, 238);\n  border-radius: 50%;\n  position: absolute;\n  width: 100%;\n}\n.face {\n  border-radius: 50%;\n  cursor: pointer;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n          transform: translateX(-50%) translateY(-50%);\n  z-index: 100;\n}\n.number {\n  height: 20px;\n  margin-left: -10px;\n  margin-top: -10px;\n  pointer-events: none;\n  position: relative;\n  text-align: center;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: 20px\n}\n.number.active {\n  color: rgb(255, 255, 255);\n}\n.hand {\n  background-color: rgb(63, 81, 181);\n  bottom: 50%;\n  display: block;\n  left: 50%;\n  margin-left: -2px;\n  position: absolute;\n  -webkit-transform-origin: 50% 100%;\n          transform-origin: 50% 100%;\n  width: 4px\n}\n.hand::before {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50%;\n  bottom: 0;\n  content: '';\n  height: 10px;\n  left: 50%;\n  margin-bottom: -5px;\n  margin-left: -5px;\n  position: absolute;\n  width: 10px;\n}\n.hand.small > .knob {\n  background-color: rgba(63, 81, 181, 0.2);\n}\n.hand.small > .knob::after {\n  background: rgb(63, 81, 181);\n  border-radius: 50%;\n  content: '';\n  height: 12px;\n  left: 50%;\n  margin-left: -6px;\n  margin-top: -6px;\n  position: absolute;\n  top: 50%;\n  width: 12px;\n}\n.hand.small > .knob::before {\n  background: rgb(63, 81, 181);\n  bottom: 0;\n  content: '';\n  height: 22px;\n  left: 50%;\n  margin-left: -2px;\n  position: absolute;\n  width: 4px;\n}\n.knob {\n  background-color: rgb(63, 81, 181);\n  border-radius: 50%;\n  cursor: pointer;\n  height: 34px;\n  left: 50%;\n  margin-left: -17px;\n  position: absolute;\n  top: -34px;\n  width: 34px;\n}\n.zoomInEnter,\n.zoomInLeave {\n  position: absolute;\n}\n.zoomInEnterActive,\n.zoomInLeaveActive {\n  transition: opacity, -webkit-transform;\n  transition: transform, opacity;\n  transition: transform, opacity, -webkit-transform;\n  transition-duration: 500ms;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.zoomInEnter {\n  opacity: 0;\n  -webkit-transform: scale(0.85);\n          transform: scale(0.85)\n}\n.zoomInEnter.zoomInEnterActive {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.zoomInLeave {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1)\n}\n.zoomInLeave.zoomInLeaveActive {\n  opacity: 0;\n  -webkit-transform: scale(1.25);\n          transform: scale(1.25);\n}\n.zoomOutEnter,\n.zoomOutLeave {\n  position: absolute;\n}\n.zoomOutEnterActive,\n.zoomOutLeaveActive {\n  transition: opacity, -webkit-transform;\n  transition: transform, opacity;\n  transition: transform, opacity, -webkit-transform;\n  transition-duration: 500ms;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.zoomOutEnter {\n  opacity: 0;\n  -webkit-transform: scale(1.25);\n          transform: scale(1.25)\n}\n.zoomOutEnter.zoomOutEnterActive {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.zoomOutLeave {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1)\n}\n.zoomOutLeave.zoomOutLeaveActive {\n  opacity: 0;\n  -webkit-transform: scale(0.85);\n          transform: scale(0.85);\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"input": "theme--input--12X-HavI",
	"disabled": "theme--disabled--1ugmjqvn",
	"inputElement": "theme--inputElement--BMzf8HMw",
	"header": "theme--header--1Tl0ADNR",
	"hours": "theme--hours--1w8iAeIu",
	"minutes": "theme--minutes--1x1mC0lw",
	"separator": "theme--separator--3nL_QGJd",
	"ampm": "theme--ampm--1LQjzuCT",
	"am": "theme--am--3Y9UIl78",
	"pm": "theme--pm--1unEK8G0",
	"dialog": "theme--dialog--13dIQfBr",
	"button": "theme--button--PQRyDY17",
	"hoursDisplay": "theme--hoursDisplay--YU7eR8_b",
	"minutesDisplay": "theme--minutesDisplay--17AlX3FF",
	"amFormat": "theme--amFormat--3G7MbvId",
	"pmFormat": "theme--pmFormat--1THSaSnr",
	"clock": "theme--clock--j0Vud1wY",
	"placeholder": "theme--placeholder--1qekNaG9",
	"clockWrapper": "theme--clockWrapper--15-DPsIF",
	"face": "theme--face--1xGuMGBI",
	"number": "theme--number--saULIOEO",
	"active": "theme--active--1XapeE6y",
	"hand": "theme--hand--3u0MIdGG",
	"small": "theme--small--1iq814zd",
	"knob": "theme--knob--2eaTrmO-",
	"zoomInEnter": "theme--zoomInEnter--1pScdHdT",
	"zoomInLeave": "theme--zoomInLeave--1tIDJwtj",
	"zoomInEnterActive": "theme--zoomInEnterActive--386tv5h3",
	"zoomInLeaveActive": "theme--zoomInLeaveActive--3kKGoSwB",
	"zoomOutEnter": "theme--zoomOutEnter--Mcjk3BvC",
	"zoomOutLeave": "theme--zoomOutLeave--3Zo5Ez08",
	"zoomOutEnterActive": "theme--zoomOutEnterActive--1s2Ze9HW",
	"zoomOutLeaveActive": "theme--zoomOutLeaveActive--2RMpxJO5"
};

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2224);

__webpack_require__(2226);

__webpack_require__(2227);

__webpack_require__(2229);

__webpack_require__(2230);

__webpack_require__(2231);

__webpack_require__(2232);

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(355);
__webpack_require__(949);
module.exports = __webpack_require__(51).Array.from;


/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(274)('native-function-to-string', Function.toString);


/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(359);
module.exports = __webpack_require__(51).Array.values;


/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(952);
module.exports = __webpack_require__(51).Array.findIndex;


/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40);
var isArray = __webpack_require__(360);
var SPECIES = __webpack_require__(52)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(276);
__webpack_require__(355);
__webpack_require__(361);
__webpack_require__(516);
__webpack_require__(954);
__webpack_require__(957);
__webpack_require__(958);
module.exports = __webpack_require__(51).Map;


/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(959);
module.exports = __webpack_require__(51).String.startsWith;


/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(960);
module.exports = __webpack_require__(51).String.includes;


/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(961);
__webpack_require__(276);
__webpack_require__(964);
__webpack_require__(965);
module.exports = __webpack_require__(51).Symbol;


/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(192);
var gOPS = __webpack_require__(366);
var pIE = __webpack_require__(277);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".user-notification-list--cardText--3VDYaS3O {\n  padding-top: 0px;\n}\n\n.user-notification-list--head--29wN1CCr {\n  background-color: #EEE;\n}\n\n.user-notification-list--divider--Vxr4yxGu {\n  height: 2px;\n  margin-top: 0px!important;\n  margin-bottom: 0px!important;\n}\n\n.user-notification-list--listItem--39I8S0YU {\n  padding: 0px;\n}\n\n.user-notification-list--checkbox--33o1-COW {\n  margin: 0px;\n}\n\n.user-notification-list--checkText--2tzkI3s7 {\n  margin-top: 0px;\n  margin-right: 40px;\n}\n\n.user-notification-list--subheader--2zrU2_jP {\n  margin-top: 8px!important;\n  color: black !important;\n}\n\n.user-notification-list--type_dropdown--3B0gL9uY {\n  width: 100px;\n  margin-left: 20px;\n}\n\n.user-notification-list--schedule_dropdown--1K3FY-RO {\n  width: 100px;\n  display: inline-block;\n}\n\n.user-notification-list--schedule_title---tuo8_Uk {\n  margin-left: 20px;\n  color: black;\n  display: inline-block;\n  width: 120px;\n}\n\n.user-notification-list--schedule_desc--1C-yKgjo {\n  margin-left: 10px;\n  margin-right: 10px;\n  color: black;\n}\n\n@media (max-width: 768px) {\n  .user-notification-list--schedule_title---tuo8_Uk {\n  margin-left: 20px;\n  color: black;\n  display: inline-block;\n  width: 60px;\n}\n\n}", "", {"version":3,"sources":["/./src/web/components/themes/user-notification-list.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;CAClB;;AAED;EACE,uBAAuB;CACxB;;AAED;EACE,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;CAC9B;;AAED;EACE,aAAa;CACd;;AAED;EACE,YAAY;CACb;;AAED;EACE,gBAAgB;EAChB,mBAAmB;CACpB;;AAED;EACE,0BAA0B;EAC1B,wBAAwB;CACzB;;AAED;EACE,aAAa;EACb,kBAAkB;CACnB;;AAED;EACE,aAAa;EACb,sBAAsB;CACvB;;AAED;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;CACd;;AAED;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;CACd;;AAED;EACE;EACA,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;CACb;;CAEA","file":"user-notification-list.css","sourcesContent":[".cardText {\n  padding-top: 0px;\n}\n\n.head {\n  background-color: #EEE;\n}\n\n.divider {\n  height: 2px;\n  margin-top: 0px!important;\n  margin-bottom: 0px!important;\n}\n\n.listItem {\n  padding: 0px;\n}\n\n.checkbox {\n  margin: 0px;\n}\n\n.checkText {\n  margin-top: 0px;\n  margin-right: 40px;\n}\n\n.subheader {\n  margin-top: 8px!important;\n  color: black !important;\n}\n\n.type_dropdown {\n  width: 100px;\n  margin-left: 20px;\n}\n\n.schedule_dropdown {\n  width: 100px;\n  display: inline-block;\n}\n\n.schedule_title {\n  margin-left: 20px;\n  color: black;\n  display: inline-block;\n  width: 120px;\n}\n\n.schedule_desc {\n  margin-left: 10px;\n  margin-right: 10px;\n  color: black;\n}\n\n@media (max-width: 768px) {\n  .schedule_title {\n  margin-left: 20px;\n  color: black;\n  display: inline-block;\n  width: 60px;\n}\n\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"cardText": "user-notification-list--cardText--3VDYaS3O",
	"head": "user-notification-list--head--29wN1CCr",
	"divider": "user-notification-list--divider--Vxr4yxGu",
	"listItem": "user-notification-list--listItem--39I8S0YU",
	"checkbox": "user-notification-list--checkbox--33o1-COW",
	"checkText": "user-notification-list--checkText--2tzkI3s7",
	"subheader": "user-notification-list--subheader--2zrU2_jP",
	"type_dropdown": "user-notification-list--type_dropdown--3B0gL9uY",
	"schedule_dropdown": "user-notification-list--schedule_dropdown--1K3FY-RO",
	"schedule_title": "user-notification-list--schedule_title---tuo8_Uk",
	"schedule_desc": "user-notification-list--schedule_desc--1C-yKgjo"
};

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _formValidator = __webpack_require__(41);

var _alertMessage = __webpack_require__(13);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/template-form-panel.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isUpdating: state.templates.isUpdating,
    isUpdateFailed: state.templates.isUpdateFailed,
    template: ownProps.cloneTemplate || ownProps.template_id && state.templates.items && (0, _find2.default)(state.templates.items, function (item) {
      return item.template_id == ownProps.template_id;
    })
  };
};

function cloneTemplate(props, suffix) {
  if (props) return props.name + ' ' + suffix;
}

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    validateAndSubmit: function validateAndSubmit(props) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (event && event.preventDefault) event.preventDefault();

      (0, _formValidator.validate)(props.ui, {
        name: { rule: 'isRequired' }
      }, function (errors, nextUI) {
        props.ui.handlers && props.ui.handlers.getValue(function (template) {
          template = template.replace(/<div><\/div>/g, '');
          if (!template || template.length == 0) {
            nextUI.templateError = true;
            errors = true;
          }
          props.updateUI(nextUI);
          if (!errors && (0, _filter2.default)(props.ui.fields, function (field, index) {
            return !props.validateField(props, index);
          }).length == 0) {
            if (props.template) {
              if (!props.cloneTemplate) {
                dispatch(_actions2.default.updateTemplate(props.template.template_id, props.ui.name, template, { fields: props.ui.fields, category: props.ui.category }));
              } else {
                dispatch(_actions2.default.createTemplate(props.ui.name, template, props.id, props.type, { fields: props.ui.fields, category: props.ui.category }));
              }
            } else {
              dispatch(_actions2.default.createTemplate(props.ui.name, template, props.id, props.type, { fields: props.ui.fields, category: props.ui.category }));
            }
          }
        }, true);
      });
      return false;
    },

    pasteTemplate: function pasteTemplate(props, template) {
      props.updateUI({
        name: template.name,
        fields: template.attach_json && template.attach_json.fields || [],
        category: template.attach_json && template.attach_json.category ? template.attach_json.category : 'diary'
      });
      props.ui.handlers.insertValue(template.template, undefined, true);
    },

    willMount: function willMount(props) {
      props.template_id && dispatch(_actions2.default.fetchTemplate(props.template_id));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (!props.template && nextProps.template) {
        nextProps.updateUI({
          name: nextProps.template.name,
          fields: nextProps.template.attach_json && nextProps.template.attach_json.fields || [],
          category: nextProps.template.attach_json && nextProps.template.attach_json.category || 'diary'
        });
        if (nextProps.ui.handlers) nextProps.ui.handlers.insertValue(nextProps.template.template);
      }

      if (props.isUpdating && !nextProps.isUpdating && !nextProps.isUpdateFailed) {
        nextProps.updateUI({ fields: [] });
        nextProps.selectPanel('templates');
        if (nextProps.template_id) dispatch((0, _alertMessage.emitAlertMessage)({ message: "label:テンプレートを更新しました", name: nextProps.template.name }, "inputSuccess"));else dispatch((0, _alertMessage.emitAlertMessage)("label:テンプレートを作成しました", "inputSuccess"));
      }
    },

    addField: function addField(props, field) {
      return props.updateUI({ fields: props.ui.fields.concat(field) });
    },
    updateField: function updateField(props, index, field) {
      return props.updateUI({ fields: props.ui.fields.map(function (f, i) {
          return i == index ? field : f;
        }) });
    },
    deleteField: function deleteField(props, index) {
      return props.updateUI({ fields: props.ui.fields.filter(function (f, i) {
          return i != index;
        }) });
    },
    sortField: function sortField(props, fields, fieldsError) {
      return props.updateUI({ fields: fields, fieldsError: fieldsError });
    },
    validateField: function validateField(props, index) {
      var noError = true;
      var errors = { name: undefined, options: undefined };
      var fieldsError = props.ui.fieldsError.concat();
      var fields = props.ui.fields.concat();
      var field = fields[index];

      if (field.type == 'new') {
        errors.type = props.t('error:フィールド種別を選択してください');
        noError = false;
      }
      if (!field.name) {
        errors.name = props.t('error:フィールド名を入力してください');
        noError = false;
      }
      if (field.type == 'dropdown') {
        var options = field.options && (0, _filter2.default)(field.options.map(function (option) {
          return option.trim();
        }), function (option) {
          return option;
        }) || [];
        field.options = options;
        if (options.length < 1) {
          errors.options = props.t('error:フィールドの選択肢を入力してください');
          noError = false;
        }
      }

      fieldsError[index] = noError ? undefined : errors;
      props.updateUI({ fieldsError: fieldsError, fields: fields });

      return noError;
    },
    onChangeCategory: function onChangeCategory(props, category) {
      props.updateUI({ category: category });
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactI18next.translate)(), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    name: function name(props) {
      return cloneTemplate(props.cloneTemplate, props.t('label:コピー')) || props.template && props.template.name || '';
    },
    nameError: undefined,
    templateError: undefined,
    handlers: undefined,
    category: function category(props) {
      return props.template && props.template.attach_json && props.template.attach_json.category || 'diary';
    },
    fields: function fields(props) {
      return props.template && props.template.attach_json && props.template.attach_json.fields || [];
    },
    fieldsError: [],
    keyboard: undefined
  }
}), _lifecycle2.default);

/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayWithHoles__ = __webpack_require__(2238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_iterableToArrayLimit__ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_unsupportedIterableToArray__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_nonIterableRest__ = __webpack_require__(2240);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_iterableToArrayLimit__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_unsupportedIterableToArray__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(970);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(971);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_setPrototypeOf__ = __webpack_require__(2248);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2250)();
}


/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var ReactPropTypesSecret = __webpack_require__(2251);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayWithoutHoles__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_iterableToArray__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_unsupportedIterableToArray__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_nonIterableSpread__ = __webpack_require__(2256);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_unsupportedIterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__ = __webpack_require__(969);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_arrayLikeToArray__["a" /* default */])(arr);
}

/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2258);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./time-picker-dialog.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./time-picker-dialog.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.time-picker-dialog--wrapper--3M_oXEDy {\n  width: 300px;\n  margin: 0 auto;\n}\n\n.time-picker-dialog--input--1WB1w3l4 {\n  display: inline-block;\n  margin: 0 10px;\n}\n\n.time-picker-dialog--input--1WB1w3l4 input {\n  text-align: center;\n  width: 100px;\n  font-size: 30px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/time-picker-dialog.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,eAAe;CAChB;;AAED;EACE,sBAAsB;EACtB,eAAe;CAChB;;AAED;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;CACjB","file":"time-picker-dialog.css","sourcesContent":["\n.wrapper {\n  width: 300px;\n  margin: 0 auto;\n}\n\n.input {\n  display: inline-block;\n  margin: 0 10px;\n}\n\n.input input {\n  text-align: center;\n  width: 100px;\n  font-size: 30px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"wrapper": "time-picker-dialog--wrapper--3M_oXEDy",
	"input": "time-picker-dialog--input--1WB1w3l4"
};

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _importTemplateSelectionDialog = __webpack_require__(2260);

var _importTemplateSelectionDialog2 = _interopRequireDefault(_importTemplateSelectionDialog);

var _dialog = __webpack_require__(47);

var _button = __webpack_require__(8);

var _list = __webpack_require__(25);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _scrollableDialogPanel = __webpack_require__(163);

var _scrollableDialogPanel2 = _interopRequireDefault(_scrollableDialogPanel);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/template-selection-dialog.jsx

var ImportTemplateSelectionDialog = function (_React$Component) {
  _inherits(ImportTemplateSelectionDialog, _React$Component);

  function ImportTemplateSelectionDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImportTemplateSelectionDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImportTemplateSelectionDialog.__proto__ || Object.getPrototypeOf(ImportTemplateSelectionDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = { group_id: undefined }, _this.onGroupClick = function (group_id) {
      if (_this.state.group_id != group_id) {
        _this.props.fetchTemplateList(group_id);
        _this.setState({ group_id: group_id });
      } else {
        _this.setState({ group_id: undefined });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImportTemplateSelectionDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          active = _props.active,
          t = _props.t,
          ui = _props.ui,
          groups = _props.groups,
          templates = _props.templates,
          onClose = _props.onClose,
          onTemplateSelect = _props.onTemplateSelect,
          isFetching = _props.isFetching,
          fetchTemplateList = _props.fetchTemplateList;


      var index = this.state.group_id ? _.findIndex(groups, function (group) {
        return group.group_id == _this2.state.group_id;
      }) : undefined;
      var groups_before = index >= 0 ? _.filter(groups, function (group, i) {
        return i <= index;
      }) : groups;
      var groups_after = index >= 0 ? _.filter(groups, function (group, i) {
        return i > index;
      }) : [];

      return _react2.default.createElement(
        _dialog.Dialog,
        { active: active, title: t('label:テンプレートを選択'),
          actions: [{ raised: true, label: t('label:取り消し'), onClick: onClose }],
          onOverlayClick: onClose,
          onEscKeyDown: onClose },
        _react2.default.createElement(
          _scrollableDialogPanel2.default,
          null,
          _react2.default.createElement(
            _list.List,
            null,
            groups_before.map(function (group) {
              return group.is_member && _react2.default.createElement(_list.ListItem, { key: group.group_id,
                avatar: _react2.default.createElement(_avatar2.default, { image: group.icon_image.thumb_url }),
                selectable: group.group_id != _this2.state.group_id,
                ripple: group.group_id != _this2.state.group_id,
                caption: group.name,
                rightIcon: group.group_id == _this2.state.group_id ? "expand_more" : "navigate_next",
                onClick: function onClick() {
                  return _this2.onGroupClick(group.group_id);
                } });
            }),
            index >= 0 && _react2.default.createElement(_list.ListItem, { itemContent: _react2.default.createElement(
                _list.List,
                { selectable: true, ripple: true },
                !isFetching && templates && templates.map(function (template) {
                  return _react2.default.createElement(_list.ListItem, { key: template.template_id,
                    caption: template.name,
                    rightIcon: '',
                    onClick: function onClick() {
                      return onTemplateSelect(template);
                    } });
                }),
                isFetching && _react2.default.createElement(_list.ListItem, { caption: t('label:読み込み中') })
              ) }),
            groups_after.map(function (group) {
              return group.is_member && _react2.default.createElement(_list.ListItem, { key: group.group_id,
                ripple: true, selectable: true,
                avatar: _react2.default.createElement(_avatar2.default, { image: group.icon_image.thumb_url }),
                caption: group.name,
                rightIcon: 'navigate_next',
                onClick: function onClick() {
                  return _this2.onGroupClick(group.group_id);
                } });
            })
          )
        )
      );
    }
  }]);

  return ImportTemplateSelectionDialog;
}(_react2.default.Component);

exports.default = (0, _importTemplateSelectionDialog2.default)(ImportTemplateSelectionDialog);

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/import-template-selection-dialog.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    groups: (0, _store.stripArray)(state.groups.items),
    templates: state.templates.list,
    isFetching: state.templates.isFetching
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchTemplateList: function fetchTemplateList(group_id) {
      return dispatch(_actions2.default.fetchTemplateList(group_id, 'group'));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2262);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./field-edit-list-item.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./field-edit-list-item.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".field-edit-list-item--input--1Xkog-w7 {\n  width: 100%;\n  padding-bottom: 0px!important;\n}\n\n.field-edit-list-item--input--1Xkog-w7 input, .field-edit-list-item--input--1Xkog-w7 textarea {\n  font-size: 14px;\n  line-height: 1.2em;\n  background: white;\n}\n\n.field-edit-list-item--field--38PP7Don {\n  margin-bottom: 0px!important;\n  -ms-flex-item-align: center!important;\n      -ms-grid-row-align: center!important;\n      align-self: center!important;\n  margin-right: 10px!important;\n}\n\n.field-edit-list-item--listItem--3uZM3Efu[class~=easyInputText] .field-edit-list-item--itemText--12lhhDaQ{\n  max-width: 1000px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}", "", {"version":3,"sources":["/./src/web/components/themes/field-edit-list-item.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,8BAA8B;CAC/B;;AAED;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;CACnB;;AAED;EACE,6BAA6B;EAC7B,sCAAsC;MAClC,qCAAqC;MACrC,6BAA6B;EACjC,6BAA6B;CAC9B;;AAED;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;CACrB","file":"field-edit-list-item.css","sourcesContent":[".input {\n  width: 100%;\n  padding-bottom: 0px!important;\n}\n\n.input input, .input textarea {\n  font-size: 14px;\n  line-height: 1.2em;\n  background: white;\n}\n\n.field {\n  margin-bottom: 0px!important;\n  -ms-flex-item-align: center!important;\n      -ms-grid-row-align: center!important;\n      align-self: center!important;\n  margin-right: 10px!important;\n}\n\n.listItem[class~=easyInputText] .itemText{\n  max-width: 1000px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"input": "field-edit-list-item--input--1Xkog-w7",
	"field": "field-edit-list-item--field--38PP7Don",
	"listItem": "field-edit-list-item--listItem--3uZM3Efu",
	"itemText": "field-edit-list-item--itemText--12lhhDaQ"
};

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.sortable--sortable--Ql0Lor1_ {\n  z-index: 1000;\n  list-style-type: none;\n}", "", {"version":3,"sources":["/./src/web/components/themes/sortable.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,sBAAsB;CACvB","file":"sortable.css","sourcesContent":["\n.sortable {\n  z-index: 1000;\n  list-style-type: none;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"sortable": "sortable--sortable--Ql0Lor1_"
};

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserLogoutPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userLogoutPanel = __webpack_require__(2265);

var _userLogoutPanel2 = _interopRequireDefault(_userLogoutPanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/user-logout-panel.jsx

var UserLogoutPanel = function (_React$Component) {
  _inherits(UserLogoutPanel, _React$Component);

  function UserLogoutPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserLogoutPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserLogoutPanel.__proto__ || Object.getPrototypeOf(UserLogoutPanel)).call.apply(_ref, [this].concat(args))), _this), _this.onCheck = function () {
      return _this.props.updateUI({ allLogout: !_this.props.ui.allLogout });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserLogoutPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          logout = _props.logout;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(_checkbox2.default, {
            theme: _flatCard2.default,
            className: 'logoutCheck',
            checked: ui.allLogout,
            onChange: this.onCheck,
            label: t('label:全ての端末でログアウト') })
        ),
        _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(_button.Button, { raised: true, primary: true,
            onClick: function onClick() {
              return logout(ui.allLogout);
            },
            style: { width: '80%', margin: 'auto' },
            label: t('label:ログアウトします') })
        )
      );
    }
  }]);

  return UserLogoutPanel;
}(_react2.default.Component);

var RawUserLogoutPanel = exports.RawUserLogoutPanel = UserLogoutPanel;
exports.default = (0, _userLogoutPanel2.default)(UserLogoutPanel);

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _saveSearchQueryTemp = __webpack_require__(488);

var _saveSearchQueryTemp2 = _interopRequireDefault(_saveSearchQueryTemp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/user-logout-panel.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    logout: function logout(allLogout) {
      dispatch(_actions2.default.logout(allLogout));
      dispatch(_actions2.default.closeUserSettingsPage());
      //検索条件の保持をログアウトした時にクリアする
      _saveSearchQueryTemp2.default.clear();
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    allLogout: false
  }
}), (0, _reactI18next.translate)());

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawSortGroupsPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupSortingPanel = __webpack_require__(2267);

var _groupSortingPanel2 = _interopRequireDefault(_groupSortingPanel);

var _list = __webpack_require__(25);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _sortable = __webpack_require__(278);

var _sortable2 = _interopRequireDefault(_sortable);

var _groupSortingPage = __webpack_require__(2268);

var _groupSortingPage2 = _interopRequireDefault(_groupSortingPage);

var _reactSortableHoc = __webpack_require__(231);

var _highcharts = __webpack_require__(974);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _leftSidebarGroupListItem = __webpack_require__(347);

var _leftSidebarGroupListItem2 = _interopRequireDefault(_leftSidebarGroupListItem);

var _logo = __webpack_require__(490);

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-sorting-page.jsx

var SortableListItem = (0, _reactSortableHoc.SortableElement)(_list.ListItem);
var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);

var GroupsList = function (_React$Component) {
  _inherits(GroupsList, _React$Component);

  function GroupsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GroupsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupsList.__proto__ || Object.getPrototypeOf(GroupsList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GroupsList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          groups = _props.groups,
          MemberGroups = _props.MemberGroups,
          divisions = _props.divisions,
          menuItems = _props.menuItems,
          flashNewFreeGroupId = _props.flashNewFreeGroupId,
          expandedDivisionSort = _props.expandedDivisionSort,
          sorting = _props.sorting,
          selectSorting = _props.selectSorting,
          setFreeMenu = _props.setFreeMenu,
          setNotFreeMenu = _props.setNotFreeMenu,
          expandDivisionSort = _props.expandDivisionSort,
          collapseDivisionSort = _props.collapseDivisionSort,
          expandDivisionSortNotSetGroup = _props.expandDivisionSortNotSetGroup,
          canExpandDivSortNotSetGroup = _props.canExpandDivSortNotSetGroup,
          sortingMenu = _props.sortingMenu;


      var groupsOnSet = MemberGroups ? MemberGroups.filter(function (item) {
        return !item.is_free_group;
      }) : [];
      var groupsNotSet = MemberGroups ? MemberGroups.filter(function (g) {
        return g.is_free_group && (g.is_member || g.favorite);
      }) : [];
      var totalDivision = menuItems.filter(function (menuItem) {
        var subGroupsId = menuItems.filter(function (menu) {
          return menu.type == 'group' && menu.parent_id == menuItem.item_id;
        }).map(function (menu) {
          return menu.item_id;
        });
        var hasSubMenu = groupsOnSet.find(function (group) {
          return subGroupsId.includes(group.group_id);
        });
        return menuItem.type == 'division' && hasSubMenu;
      }).length;
      return _react2.default.createElement(
        'div',
        { style: { cursor: sorting && 'move' } },
        _react2.default.createElement(_font_icon2.default, { value: 'info', style: { verticalAlign: 'bottom', marginLeft: 25 } }),
        _react2.default.createElement(
          'span',
          { style: { marginLeft: 20 } },
          t('label:ドラッグして並べ替え')
        ),
        _react2.default.createElement(
          _list.List,
          null,
          _.map(menuItems, function (menuItem, i) {
            var menuExtra = menuItem.type == 'division' ? divisions.find(function (d) {
              return d.division_id == menuItem.item_id;
            }) : MemberGroups.find(function (g) {
              return g.group_id == menuItem.item_id && !g.is_free_group;
            });
            var subGroupsId = menuItems.filter(function (menu) {
              return menu.type == 'group' && menu.parent_id == menuItem.item_id;
            }).map(function (menu) {
              return menu.item_id;
            });
            var hasSubMenu = MemberGroups.find(function (group) {
              return subGroupsId.includes(group.group_id);
            });

            if (menuItem.type == 'division' && !hasSubMenu) return null;
            if (menuItem.type == 'group' && !expandedDivisionSort.includes(menuItem.parent_id)) return null;

            var rightAction = void 0;
            if (menuItem.type == 'division' && !expandedDivisionSort.includes(menuItem.item_id)) rightAction = _react2.default.createElement(_button.IconButton, { key: 'expand_sub_groups', icon: 'expand_more', onClick: function onClick() {
                return expandDivisionSort(menuItem.item_id);
              } });
            if (menuItem.type == 'division' && expandedDivisionSort.includes(menuItem.item_id)) rightAction = _react2.default.createElement(_button.IconButton, { key: 'collapse_sub_groups', icon: 'expand_less', onClick: function onClick() {
                return collapseDivisionSort(menuItem.item_id);
              } });
            var isSortable = true;
            if (sortingMenu && sortingMenu.type != menuItem.type) isSortable = false;
            if (sortingMenu && sortingMenu.type == 'group' && sortingMenu.parent_id != menuItem.parent_id) isSortable = false;

            return menuExtra && _react2.default.createElement(SortableListItem, { key: menuItem.position, selectable: false, ripple: false, index: menuItem.position,
              theme: _groupSortingPage2.default,
              className: menuExtra.access_type + ' ' + (menuItem.type == 'division' ? '' : 'indent') + ' ' + (isSortable ? '' : 'disabled'),
              disabled: !sorting,
              avatar: menuExtra.icon_image.thumb_url,
              caption: menuExtra.name,
              rightActions: [rightAction]
            });
          }),
          totalDivision > 0 && groupsNotSet.length > 0 && _react2.default.createElement(_list.ListItem, { theme: _leftSidebarGroupListItem2.default,
            key: 'division_group_not_set',
            caption: this.props.t('label:セクションなし'),
            avatar: _logo2.default,
            style: { height: 5, width: 5, backgroundColor: '#000', borderRadius: 20 },
            className: !sortingMenu ? '' : 'disabled',
            rightActions: [_react2.default.createElement(_button.IconButton, {
              key: !canExpandDivSortNotSetGroup ? "expand_sub_groups" : "collapse_sub_groups",
              icon: !canExpandDivSortNotSetGroup ? "expand_more" : "expand_less",
              onClick: expandDivisionSortNotSetGroup
            })]
          }),
          (totalDivision == 0 ? true : canExpandDivSortNotSetGroup) && groupsNotSet && _.map(menuItems, function (menuItem, i) {
            var menuExtra = groupsNotSet.find(function (g) {
              return g.group_id == menuItem.item_id && menuItem.is_free_group;
            });
            return menuExtra && _react2.default.createElement(SortableListItem, { key: menuItem.position, selectable: false, ripple: false, index: menuItem.position,
              theme: _groupSortingPage2.default,
              className: menuExtra.access_type + ' ' + (totalDivision > 0 ? 'indent' : '') + ' ' + (sortingMenu && (sortingMenu.type != 'group' || !sortingMenu.is_free_group) ? 'disabled' : ''),
              disabled: !sorting,
              avatar: menuExtra.icon_image.thumb_url,
              caption: menuExtra.name
            });
          })
        )
      );
    }
  }]);

  return GroupsList;
}(_react2.default.Component);

var SortableGroupsList = (0, _reactSortableHoc.SortableContainer)(GroupsList);

var SortGroupsPage = function (_React$Component2) {
  _inherits(SortGroupsPage, _React$Component2);

  function SortGroupsPage() {
    var _ref2;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, SortGroupsPage);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = SortGroupsPage.__proto__ || Object.getPrototypeOf(SortGroupsPage)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = { sorting: true, selectSorting: false }, _this2.onSortEnd = function (index) {
      document.body.style.userSelect = ''; // Restore default behavior
      _this2.props.sortMenu(index.oldIndex, index.newIndex);
      _this2.props.setSortingMenuPosition(null);
      _this2.setState({ selectSorting: !_this2.state.selectSorting });
    }, _this2.onSortStart = function (index) {
      document.body.style.userSelect = 'none'; // Prevent text selection
      _this2.props.setSortingMenuPosition(index.index);
      _this2.setState({ selectSorting: !_this2.state.selectSorting });
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(SortGroupsPage, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          menuItems = _props2.menuItems;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        menuItems && _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(SortableGroupsList, _extends({}, this.props, {
            onSortStart: this.onSortStart,
            onSortEnd: this.onSortEnd,
            helperClass: _sortable2.default.sortable,
            sorting: this.state.sorting,
            selectSorting: this.state.selectSorting }))
        ) || _react2.default.createElement(
          _list.List,
          { selectable: true },
          _react2.default.createElement(_list.ListItem, { caption: t('label:セクション/グループはありません') })
        )
      );
    }
  }]);

  return SortGroupsPage;
}(_react2.default.Component);

var RawSortGroupsPage = exports.RawSortGroupsPage = SortGroupsPage;
exports.default = (0, _groupSortingPanel2.default)(SortGroupsPage);

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/group-sorting-page.js

var _reactRedux = __webpack_require__(11);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _store = __webpack_require__(18);

var _reactI18next = __webpack_require__(2);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    return {
        groups: state.groups.items,
        divisions: state.divisions.items,
        menuItems: state.menus.items,
        flashNewFreeGroupId: state.menus.flashNewFreeGroupId,
        sortingMenu: state.menus.sortingMenu,
        expandedDivisionSort: state.menus.expandedDivisionSort,
        userMenuItems: state.user && state.user.current ? state.user.current.menu_items : null,
        canExpandDivSortNotSetGroup: state.menus.canExpandDivSortNotSetGroup
    };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps) {
    var groups = stateProps.groups;
    var memberGroups = (0, _filter2.default)(groups, function (group) {
        return group.is_member || group.favorite;
    });

    return _extends({}, stateProps, dispatchProps, {
        MemberGroups: (0, _store.stripArray)(memberGroups)
    });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        setNewMenuPositions: function setNewMenuPositions(newPositions) {
            dispatch(_actions2.default.setNewMenuPositions(newPositions));
        },
        sortMenu: function sortMenu(oldPosition, newPosition) {
            dispatch(_actions2.default.sortMenu(oldPosition, newPosition));
        },
        setFreeMenu: function setFreeMenu(menuItem) {
            dispatch(_actions2.default.setFreeMenu(menuItem.position));
            dispatch(_actions2.default.setFlashNewFreeGroupId(menuItem.item_id));
            setTimeout(function () {
                return dispatch(_actions2.default.setFlashNewFreeGroupId(null));
            }, 2000);
        },
        setSortingMenuPosition: function setSortingMenuPosition(position) {
            dispatch(_actions2.default.setSortingMenuPosition(position));
        },
        setNotFreeMenu: function setNotFreeMenu(position, groupDivisionIds) {
            dispatch(_actions2.default.setNotFreeMenu(position, groupDivisionIds));
        },
        expandDivisionSort: function expandDivisionSort(division_id) {
            dispatch(_actions2.default.expandDivisionSort(division_id));
        },
        collapseDivisionSort: function collapseDivisionSort(division_id) {
            dispatch(_actions2.default.collapseDivisionSort(division_id));
        },
        willMount: function willMount(props) {
            dispatch(_actions2.default.initMenus(props.userMenuItems, props.divisions, props.groups));
        },
        willUpdate: function willUpdate(props, nextProps) {
            if (!_lodash2.default.isEqual(props.menuItems, nextProps.menuItems)) dispatch(_actions2.default.updateUserMenuItems(nextProps.menuItems));
        },
        expandDivisionSortNotSetGroup: function expandDivisionSortNotSetGroup() {
            dispatch(_actions2.default.expandDivisionSortNotSetGroup());
        }
    };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2269);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./group-sorting-page.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./group-sorting-page.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".group-sorting-page--listItem--2nKW3VLb[class~=is_active]{\n    background-color:  #FFF!important;\n}\n\n.group-sorting-page--listItem--2nKW3VLb:hover {\n    background-color:  #f3f0f0;\n}\n\n.group-sorting-page--listItem--2nKW3VLb:hover .group-sorting-page--itemAction--2sJtYCDD::after{\n    background-color:  #FFF;\n}\n\n[class~=private_access] .group-sorting-page--itemAction--2sJtYCDD::after {\n    position: absolute;\n    font-family: 'Material Icons';\n    font-weight: normal;\n    font-style: normal;\n    content: 'vpn_key';\n    color: #757575;\n    background-color: #f3f0f0;\n    border-radius: 80%;\n    text-shadow: 5px 5px 10px #FFF;\n    top: 25px;\n    left: 46px;\n    padding: 3px;\n}\n\n/*並べ替え時のドラッグ要素スタイル*/\n\nbody > .group-sorting-page--listItem--2nKW3VLb {\n    background-color:  #f3f0f0;\n}\n\nbody > [class~=private_access] .group-sorting-page--itemAction--2sJtYCDD::after {\n    background-color: #FFF;\n}\n\n.group-sorting-page--listItem--2nKW3VLb[class~=indent] .group-sorting-page--itemAction--2sJtYCDD {\n    padding-left: 20px;\n}\n\n.group-sorting-page--listItem--2nKW3VLb[class~=indent][class~=private_access] .group-sorting-page--itemAction--2sJtYCDD::after {\n  left: 66px;\n}\n\n.group-sorting-page--listItem--2nKW3VLb[class~=flash] {\n    -webkit-animation-name: group-sorting-page--flash_color_change--3rNFk3C6;\n            animation-name: group-sorting-page--flash_color_change--3rNFk3C6;\n    -webkit-animation-duration: 2s;\n            animation-duration: 2s;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-animation-iteration-count: initial;\n            animation-iteration-count: initial;\n}\n\n.group-sorting-page--listItem--2nKW3VLb[class~=disabled]{\n    background-color:  \t#3b3b3b!important;\n}\n\n@-webkit-keyframes group-sorting-page--flash_color_change--3rNFk3C6 {\n    from {\n        background-color: #f3f0f0;\n    }\n    to {\n        background-color: none;\n    }\n}\n\n@keyframes group-sorting-page--flash_color_change--3rNFk3C6 {\n    from {\n        background-color: #f3f0f0;\n    }\n    to {\n        background-color: none;\n    }\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/group-sorting-page.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;CACrC;;AAED;IACI,2BAA2B;CAC9B;;AAED;IACI,wBAAwB;CAC3B;;AAED;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,+BAA+B;IAC/B,UAAU;IACV,WAAW;IACX,aAAa;CAChB;;AAED,oBAAoB;;AAEpB;IACI,2BAA2B;CAC9B;;AAED;IACI,uBAAuB;CAC1B;;AAED;IACI,mBAAmB;CACtB;;AAED;EACE,WAAW;CACZ;;AAED;IACI,yEAA2C;YACnC,iEAAmC;IAC3C,+BAA+B;YACvB,uBAAuB;IAC/B,qCAAqC;YAC7B,6BAA6B;IACrC,2CAA2C;YACnC,mCAAmC;CAC9C;;AAED;IACI,sCAAsC;CACzC;;AAED;IACI;QACI,0BAA0B;KAC7B;IACD;QACI,uBAAuB;KAC1B;CACJ;;AAED;IACI;QACI,0BAA0B;KAC7B;IACD;QACI,uBAAuB;KAC1B;CACJ","file":"group-sorting-page.css","sourcesContent":[".listItem[class~=is_active]{\n    background-color:  #FFF!important;\n}\n\n.listItem:hover {\n    background-color:  #f3f0f0;\n}\n\n.listItem:hover .itemAction::after{\n    background-color:  #FFF;\n}\n\n[class~=private_access] .itemAction::after {\n    position: absolute;\n    font-family: 'Material Icons';\n    font-weight: normal;\n    font-style: normal;\n    content: 'vpn_key';\n    color: #757575;\n    background-color: #f3f0f0;\n    border-radius: 80%;\n    text-shadow: 5px 5px 10px #FFF;\n    top: 25px;\n    left: 46px;\n    padding: 3px;\n}\n\n/*並べ替え時のドラッグ要素スタイル*/\n\nbody > .listItem {\n    background-color:  #f3f0f0;\n}\n\nbody > [class~=private_access] .itemAction::after {\n    background-color: #FFF;\n}\n\n.listItem[class~=indent] .itemAction {\n    padding-left: 20px;\n}\n\n.listItem[class~=indent][class~=private_access] .itemAction::after {\n  left: 66px;\n}\n\n.listItem[class~=flash] {\n    -webkit-animation-name: flash_color_change;\n            animation-name: flash_color_change;\n    -webkit-animation-duration: 2s;\n            animation-duration: 2s;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-animation-iteration-count: initial;\n            animation-iteration-count: initial;\n}\n\n.listItem[class~=disabled]{\n    background-color:  \t#3b3b3b!important;\n}\n\n@-webkit-keyframes flash_color_change {\n    from {\n        background-color: #f3f0f0;\n    }\n    to {\n        background-color: none;\n    }\n}\n\n@keyframes flash_color_change {\n    from {\n        background-color: #f3f0f0;\n    }\n    to {\n        background-color: none;\n    }\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listItem": "group-sorting-page--listItem--2nKW3VLb",
	"itemAction": "group-sorting-page--itemAction--2sJtYCDD",
	"flash_color_change": "group-sorting-page--flash_color_change--3rNFk3C6"
};

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserBlockPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userBlockPanel = __webpack_require__(2271);

var _userBlockPanel2 = _interopRequireDefault(_userBlockPanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _list = __webpack_require__(25);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/user-block-panel.jsx

var UserBlockPanel = function (_React$Component) {
  _inherits(UserBlockPanel, _React$Component);

  function UserBlockPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserBlockPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserBlockPanel.__proto__ || Object.getPrototypeOf(UserBlockPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserBlockPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          isFetching = _props.isFetching,
          favorites = _props.favorites,
          current = _props.current,
          groups = _props.groups,
          favoriteGroup = _props.favoriteGroup,
          favoriteUser = _props.favoriteUser,
          setFavoriteUser = _props.setFavoriteUser,
          showUserSelectionDialog = _props.showUserSelectionDialog,
          blockUsers = _props.blockUsers,
          updateBlockUser = _props.updateBlockUser,
          onClose = _props.onClose;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(
            'normal',
            null,
            _react2.default.createElement(
              'strong',
              null,
              t('label:ブロックされたユーザ')
            )
          ),
          _react2.default.createElement(
            _list.List,
            { selectable: true },
            blockUsers && blockUsers.length > 0 && blockUsers.map(function (user) {
              return _react2.default.createElement(_list.ListItem, { key: user.user_id,
                disabled: isFetching,
                caption: user.name,
                avatar: user.icon_image.thumb_url,
                rightActions: _.filter([_react2.default.createElement(_button.IconButton, { key: 'button', icon: 'close',
                  disabled: isFetching,
                  onClick: function onClick() {
                    return _this2.setState(_defineProperty({}, user.user_id, true));
                  } }), _react2.default.createElement(_confirmDialog2.default, { key: 'confirm' + user.user_id,
                  title: t('label:ブロックユーザの解除', { name: user.name }),
                  description: t('label:ブロックユーザの解除説明'),
                  open: _this2.state[user.user_id],
                  onYes: function onYes() {
                    _this2.setState(_defineProperty({}, user.user_id, false));
                    updateBlockUser(user, false);
                    blockUsers && blockUsers.length == 1 && onClose();
                  },
                  onNo: function onNo() {
                    _this2.setState(_defineProperty({}, user.user_id, false));
                  },
                  yesLabel: t('label:ブロック解除'),
                  noLabel: t('label:取り消し') })]) });
            }),
            blockUsers && blockUsers.length == 0 && _react2.default.createElement(_list.ListItem, { caption: t('label:ブロックされたユーザはありません') })
          )
        )
      );
    }
  }]);

  return UserBlockPanel;
}(_react2.default.Component);

var RawUserBlockPanel = exports.RawUserBlockPanel = UserBlockPanel;
exports.default = (0, _userBlockPanel2.default)(UserBlockPanel);

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/user-block-panel.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    current: state.user.current,
    blockUsers: state.block.users
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateBlockUser: function updateBlockUser(user, block) {
      dispatch(_actions2.default.updateBlockUser(user.user_id, block));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:ユーザをブロック解除しました', name: user.name }, 'success'));
    },
    onClose: function onClose() {
      dispatch(_actions2.default.closeUserSettingsPage());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _context2.default)({ showUserSelectionDialog: _propTypes2.default.func }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserExtensionsPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userExtensionsPanel = __webpack_require__(2273);

var _userExtensionsPanel2 = _interopRequireDefault(_userExtensionsPanel);

var _reactToolbox = __webpack_require__(502);

var _list = __webpack_require__(25);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _userNotificationList = __webpack_require__(966);

var _userNotificationList2 = _interopRequireDefault(_userNotificationList);

var _switch = __webpack_require__(227);

var _switch2 = _interopRequireDefault(_switch);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/user-extensions-panel.jsx

function SettingMenu(props) {
  var t = props.t,
      ui = props.ui,
      selected = props.selected,
      target = props.target,
      updateUI = props.updateUI,
      isEnable = props.isEnable,
      updateReviewSetting = props.updateReviewSetting;


  var onChange = function onChange() {
    updateReviewSetting();
  };

  return _react2.default.createElement(
    'div',
    { className: _flatCard2.default.rightButton },
    _react2.default.createElement(_switch2.default, { className: _flatCard2.default.switch,
      checked: isEnable,
      disabled: true,
      onChange: function onChange() {
        return updateReviewSetting();
      } })
  );
}

var UserExtensionsPanel = function (_React$Component) {
  _inherits(UserExtensionsPanel, _React$Component);

  function UserExtensionsPanel() {
    _classCallCheck(this, UserExtensionsPanel);

    return _possibleConstructorReturn(this, (UserExtensionsPanel.__proto__ || Object.getPrototypeOf(UserExtensionsPanel)).apply(this, arguments));
  }

  _createClass(UserExtensionsPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          isEnable = _props.isEnable,
          updateReviewSetting = _props.updateReviewSetting;


      return _react2.default.createElement(
        _reactToolbox.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _reactToolbox.CardText,
          { theme: _userNotificationList2.default },
          _react2.default.createElement(
            _list.List,
            { selectable: false, ripple: false },
            _react2.default.createElement(_list.ListItem, { key: 'reply-other',
              ripple: false,
              caption: t('label:レビュー機能'),
              legend: !isEnable && t('label:レビュー機能OFF') || t('label:レビュー機能ON'),
              rightActions: [_react2.default.createElement(SettingMenu, { key: 'review', t: t, ui: ui, updateUI: updateUI, isEnable: isEnable, updateReviewSetting: updateReviewSetting })] })
          )
        )
      );
    }
  }]);

  return UserExtensionsPanel;
}(_react2.default.Component);

var RawUserExtensionsPanel = exports.RawUserExtensionsPanel = UserExtensionsPanel;
exports.default = (0, _userExtensionsPanel2.default)(UserExtensionsPanel);

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/user-extensions-panel.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isEnable: state.reviewSetting.isEnable
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchReviewSetting: function fetchReviewSetting() {
      return dispatch(_actions2.default.fetchReviewSetting());
    }
    // updateReviewSetting: ()=> dispatch(actions.updateReviewSetting()),
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    review: true
  }
}), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2275);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2291);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PERMISSION_GRANTED = 'granted';
var PERMISSION_DENIED = 'denied';

var seqGen = function seqGen() {
  var i = 0;
  return function () {
    return i++;
  };
};
var seq = seqGen();

var Notification = function (_React$Component) {
  _inherits(Notification, _React$Component);

  function Notification(props) {
    _classCallCheck(this, Notification);

    var _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, props));

    var supported = false;
    var granted = false;
    if ('Notification' in window && window.Notification) {
      supported = true;
      if (window.Notification.permission === PERMISSION_GRANTED) {
        granted = true;
      }
    }

    _this.state = {
      supported: supported,
      granted: granted
    };
    // Do not save Notification instance in state
    _this.notifications = {};
    _this.windowFocus = true;
    _this.onWindowFocus = _this._onWindowFocus.bind(_this);
    _this.onWindowBlur = _this._onWindowBlur.bind(_this);
    return _this;
  }

  _createClass(Notification, [{
    key: '_onWindowFocus',
    value: function _onWindowFocus() {
      this.windowFocus = true;
    }
  }, {
    key: '_onWindowBlur',
    value: function _onWindowBlur() {
      this.windowFocus = false;
    }
  }, {
    key: '_askPermission',
    value: function _askPermission() {
      var _this2 = this;

      window.Notification.requestPermission(function (permission) {
        var result = permission === PERMISSION_GRANTED;
        _this2.setState({
          granted: result
        }, function () {
          if (result) {
            _this2.props.onPermissionGranted();
          } else {
            _this2.props.onPermissionDenied();
          }
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.disableActiveWindow) {
        if (window.addEventListener) {
          window.addEventListener('focus', this.onWindowFocus);
          window.addEventListener('blur', this.onWindowBlur);
        } else if (window.attachEvent) {
          window.attachEvent('focus', this.onWindowFocus);
          window.attachEvent('blur', this.onWindowBlur);
        }
      }

      if (!this.state.supported) {
        this.props.notSupported();
      } else if (this.state.granted) {
        this.props.onPermissionGranted();
      } else {
        if (window.Notification.permission === PERMISSION_DENIED) {
          if (this.props.askAgain) {
            this._askPermission();
          } else {
            this.props.onPermissionDenied();
          }
        } else {
          this._askPermission();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.disableActiveWindow) {
        if (window.removeEventListner) {
          window.removeEventListener('focus', this.onWindowFocus);
          window.removeEventListener('blur', this.onWindowBlur);
        } else if (window.detachEvent) {
          window.detachEvent('focus', this.onWindowFocus);
          window.detachEvent('blur', this.onWindowBlur);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var doNotShowOnActiveWindow = this.props.disableActiveWindow && this.windowFocus;
      if (!this.props.ignore && this.props.title && this.state.supported && this.state.granted && !doNotShowOnActiveWindow) {

        var opt = this.props.options;
        if (typeof opt.tag !== 'string') {
          opt.tag = 'web-notification-' + seq();
        }

        if (!this.notifications[opt.tag]) {
          var n = new window.Notification(this.props.title, opt);
          n.onshow = function (e) {
            _this3.props.onShow(e, opt.tag);
            setTimeout(function () {
              _this3.close(n);
            }, _this3.props.timeout);
          };
          n.onclick = function (e) {
            _this3.props.onClick(e, opt.tag);
          };
          n.onclose = function (e) {
            _this3.props.onClose(e, opt.tag);
          };
          n.onerror = function (e) {
            _this3.props.onError(e, opt.tag);
          };

          this.notifications[opt.tag] = n;
        }
      }

      // return null cause
      // Error: Invariant Violation: Notification.render(): A valid ReactComponent must be returned. You may have returned undefined, an array or some other invalid object.
      return _react2.default.createElement('input', { type: 'hidden', name: 'dummy-for-react-web-notification', style: { display: 'none' } });
    }
  }, {
    key: 'close',
    value: function close(n) {
      if (n && typeof n.close === 'function') {
        n.close();
      }
    }

    // for debug

  }, {
    key: '_getNotificationInstance',
    value: function _getNotificationInstance(tag) {
      return this.notifications[tag];
    }
  }]);

  return Notification;
}(_react2.default.Component);

Notification.propTypes = {
  ignore: _propTypes.bool,
  disableActiveWindow: _propTypes.bool,
  askAgain: _propTypes.bool,
  notSupported: _propTypes.func,
  onPermissionGranted: _propTypes.func,
  onPermissionDenied: _propTypes.func,
  onShow: _propTypes.func,
  onClick: _propTypes.func,
  onClose: _propTypes.func,
  onError: _propTypes.func,
  timeout: _propTypes.number,
  title: _propTypes.string.isRequired,
  options: _propTypes.object
};

Notification.defaultProps = {
  ignore: false,
  disableActiveWindow: false,
  askAgain: false,
  notSupported: function notSupported() {},
  onPermissionGranted: function onPermissionGranted() {},
  onPermissionDenied: function onPermissionDenied() {},
  onShow: function onShow() {},
  onClick: function onClick() {},
  onClose: function onClose() {},
  onError: function onError() {},
  timeout: 5000,
  options: {}
};

exports.default = Notification;

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(2276);


/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(80);

var ReactBaseClasses = __webpack_require__(975);
var ReactChildren = __webpack_require__(2278);
var ReactDOMFactories = __webpack_require__(2283);
var ReactElement = __webpack_require__(232);
var ReactPropTypes = __webpack_require__(2284);
var ReactVersion = __webpack_require__(2288);

var createReactClass = __webpack_require__(2289);
var onlyChild = __webpack_require__(2290);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(2279);
var ReactElement = __webpack_require__(232);

var emptyFunction = __webpack_require__(84);
var traverseAllChildren = __webpack_require__(2280);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(367);

var invariant = __webpack_require__(60);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(367);

var ReactCurrentOwner = __webpack_require__(978);
var REACT_ELEMENT_TYPE = __webpack_require__(979);

var getIteratorFn = __webpack_require__(2281);
var invariant = __webpack_require__(60);
var KeyEscapeUtils = __webpack_require__(2282);
var warning = __webpack_require__(104);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(232);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(232),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(2285);

module.exports = factory(isValidElement);

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(2286);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var warning = __webpack_require__(104);

var ReactPropTypesSecret = __webpack_require__(980);
var checkPropTypes = __webpack_require__(2287);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(975),
    Component = _require.Component;

var _require2 = __webpack_require__(232),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(976);
var factory = __webpack_require__(406);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(367);

var ReactElement = __webpack_require__(232);

var invariant = __webpack_require__(60);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2292)();
}


/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var ReactPropTypesSecret = __webpack_require__(980);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_types__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["x"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["A"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(991);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__client__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(280);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_3__helpers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_4__eventbuilder__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sdk__ = __webpack_require__(2326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__version__ = __webpack_require__(2327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__version__["a"]; });







//# sourceMappingURL=exports.js.map

/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogLevel */
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SessionStatus; });
/**
 * Session Status
 */
var SessionStatus;
(function (SessionStatus) {
    /** JSDoc */
    SessionStatus["Ok"] = "ok";
    /** JSDoc */
    SessionStatus["Exited"] = "exited";
    /** JSDoc */
    SessionStatus["Crashed"] = "crashed";
    /** JSDoc */
    SessionStatus["Abnormal"] = "abnormal";
})(SessionStatus || (SessionStatus = {}));
//# sourceMappingURL=session.js.map

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Severity; });
/** JSDoc */
// eslint-disable-next-line import/export
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));
//# sourceMappingURL=severity.js.map

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Status; });
/** The status of an event. */
// eslint-disable-next-line import/export
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status || (Status = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map

/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TransactionSamplingMethod */
var TransactionSamplingMethod;
(function (TransactionSamplingMethod) {
    TransactionSamplingMethod["Explicit"] = "explicitly_set";
    TransactionSamplingMethod["Sampler"] = "client_sampler";
    TransactionSamplingMethod["Rate"] = "client_rate";
    TransactionSamplingMethod["Inheritance"] = "inheritance";
})(TransactionSamplingMethod || (TransactionSamplingMethod = {}));
//# sourceMappingURL=transaction.js.map

/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export forget */
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map

/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dsn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(523);


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        }
        else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, publicKey = _a.publicKey;
        return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
        }
        var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __read */])(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) {
                projectId = projectMatch[0];
            }
        }
        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        // TODO this is for backwards compatibility, and can be removed in a future version
        if ('user' in components && !('publicKey' in components)) {
            components.publicKey = components.user;
        }
        this.user = components.publicKey || '';
        this.protocol = components.protocol;
        this.publicKey = components.publicKey || '';
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'publicKey', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": " + component + " missing");
            }
        });
        if (!this.projectId.match(/^\d+$/)) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
        }
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
        }
        if (this.port && isNaN(parseInt(this.port, 10))) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid port " + this.port);
        }
    };
    return Dsn;
}());

//# sourceMappingURL=dsn.js.map

/***/ }),
/* 2301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPrototypeOf; });
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        // eslint-disable-next-line no-prototype-builtins
        if (!obj.hasOwnProperty(prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addInstrumentationHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__object__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stacktrace__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__supports__ = __webpack_require__(987);







var global = Object(__WEBPACK_IMPORTED_MODULE_3__misc__["e" /* getGlobalObject */])();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(handler) {
    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
        return;
    }
    handlers[handler.type] = handlers[handler.type] || [];
    handlers[handler.type].push(handler.callback);
    instrument(handler.type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + Object(__WEBPACK_IMPORTED_MODULE_5__stacktrace__["a" /* getFunctionName */])(handler) + "\nError: " + e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(global.console, level, function (originalConsoleLevel) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleLevel) {
                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__supports__["c" /* supportsNativeFetch */])()) {
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
    var requestKeys = [];
    var requestValues = [];
    var xhrproto = XMLHttpRequest.prototype;
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) {
                            xhr.__sentry_xhr__.status_code = xhr.status;
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    try {
                        var requestPos = requestKeys.indexOf(xhr);
                        if (requestPos !== -1) {
                            // Make sure to pop both key and value to keep it in sync.
                            requestKeys.splice(requestPos);
                            var args_1 = requestValues.splice(requestPos)[0];
                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
                                xhr.__sentry_xhr__.body = args_1[0];
                            }
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            requestKeys.push(this);
            requestValues.push(args);
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__supports__["b" /* supportsHistory */])()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            return oldOnPopState.apply(this, args);
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(global.history, 'pushState', historyReplacementFunction);
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(global.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) {
        return true;
    }
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) {
        return true;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) {
            return true;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') {
        return false;
    }
    try {
        var target = event.target;
        if (!target || !target.tagName) {
            return true;
        }
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return false;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) { globalListener = false; }
    return function (event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) {
            return;
        }
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = global.setTimeout(function () {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    global.document.addEventListener('click', globalDOMEventHandler, false);
    global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    ['EventTarget', 'Node'].forEach(function (target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(proto, 'addEventListener', function (originalAddEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["c" /* fill */])(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers_2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map

/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolve */
/* unused harmony export relative */
/* unused harmony export normalizePath */
/* unused harmony export isAbsolute */
/* unused harmony export join */
/* unused harmony export dirname */
/* unused harmony export basename */
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        // eslint-disable-next-line no-plusplus
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    /* eslint-disable no-param-reassign */
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    /* eslint-enable no-param-reassign */
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
//# sourceMappingURL=path.js.map

/***/ }),
/* 2304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromiseBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncpromise__ = __webpack_require__(988);


/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        var _this = this;
        if (!this.isReady()) {
            return __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* SentryError */]('Not adding Promise due to buffer limit reached.'));
        }
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        task
            .then(function () { return _this.remove(task); })
            .then(null, function () {
            return _this.remove(task).then(null, function () {
                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */](function (resolve) {
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].all(_this._buffer)
                .then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            })
                .then(null, function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}());

//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateTimestampInSeconds; });
/* unused harmony export timestampInSeconds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timestampWithMs; });
/* unused harmony export usingPerformanceAPI */
/* unused harmony export browserPerformanceTimeOrigin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node__ = __webpack_require__(525);


/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["e" /* getGlobalObject */])().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = Object(__WEBPACK_IMPORTED_MODULE_1__node__["a" /* dynamicRequire */])(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = Object(__WEBPACK_IMPORTED_MODULE_1__node__["b" /* isNodeEnv */])() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    var performance = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["e" /* getGlobalObject */])().performance;
    if (!performance) {
        return undefined;
    }
    if (performance.timeOrigin) {
        return performance.timeOrigin;
    }
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    return (performance.timing && performance.timing.navigationStart) || Date.now();
})();
//# sourceMappingURL=time.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2306)(module)))

/***/ }),
/* 2306 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hub; });
/* unused harmony export getMainCarrier */
/* harmony export (immutable) */ __webpack_exports__["d"] = makeMain;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCurrentHub;
/* unused harmony export getActiveDomain */
/* harmony export (immutable) */ __webpack_exports__["c"] = getHubFromCarrier;
/* unused harmony export setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scope__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session__ = __webpack_require__(989);

/* eslint-disable max-lines */




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new __WEBPACK_IMPORTED_MODULE_3__scope__["a" /* Scope */](); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        this.bindClient(client);
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = __WEBPACK_IMPORTED_MODULE_3__scope__["a" /* Scope */].clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["O" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["O" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["O" /* uuid4 */])());
        this._invokeClient('captureEvent', event, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["i" /* dateTimestampInSeconds */])();
        var mergedBreadcrumb = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* consoleSandbox */])(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureSession = function (endSession) {
        if (endSession === void 0) { endSession = false; }
        // both send the update and pull the session from the scope
        if (endSession) {
            return this.endSession();
        }
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var _a, _b, _c, _d, _e;
        (_c = (_b = (_a = this.getStackTop()) === null || _a === void 0 ? void 0 : _a.scope) === null || _b === void 0 ? void 0 : _b.getSession()) === null || _c === void 0 ? void 0 : _c.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        (_e = (_d = this.getStackTop()) === null || _d === void 0 ? void 0 : _d.scope) === null || _e === void 0 ? void 0 : _e.setSession();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        var session = new __WEBPACK_IMPORTED_MODULE_4__session__["a" /* Session */](Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["a" /* SessionStatus */].Ok) {
                currentSession.update({ status: __WEBPACK_IMPORTED_MODULE_1__sentry_types__["a" /* SessionStatus */].Exited });
            }
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */
    Hub.prototype._sendSessionUpdate = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) {
                client.captureSession(session);
            }
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/** Returns the global shim registry. */
function getMainCarrier() {
    var carrier = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["o" /* getGlobalObject */])();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["y" /* isNodeEnv */])()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Returns the active domain, if one exists
 * @deprecated No longer used; remove in v7
 * @returns The domain, or undefined if there is no active domain
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveDomain() {
    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = getMainCarrier().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    var _a, _b, _c;
    try {
        var activeDomain = (_c = (_b = (_a = getMainCarrier().__SENTRY__) === null || _a === void 0 ? void 0 : _a.extensions) === null || _b === void 0 ? void 0 : _b.domain) === null || _c === void 0 ? void 0 : _c.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, __WEBPACK_IMPORTED_MODULE_3__scope__["a" /* Scope */].clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
        return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map

/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(45);

var SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 **/
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn, metadata) {
        if (metadata === void 0) { metadata = {}; }
        this.dsn = dsn;
        this._dsnObject = new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["a" /* Dsn */](dsn);
        this.metadata = metadata;
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */
    API.prototype.getBaseApiEndpoint = function () {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
    };
    /** Returns the store endpoint URL. */
    API.prototype.getStoreEndpoint = function () {
        return this._getIngestEndpoint('store');
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        return this.getStoreEndpoint() + "?" + this._encodedAuth();
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /**
     * Returns an object that can be used in request headers.
     * This is needed for node and the old /store endpoint in sentry
     */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
        var dsn = this._dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.publicKey);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this._dsnObject;
        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'dsn') {
                continue;
            }
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    /** Returns the envelope endpoint URL. */
    API.prototype._getEnvelopeEndpoint = function () {
        return this._getIngestEndpoint('envelope');
    };
    /** Returns the ingest API endpoint for target. */
    API.prototype._getIngestEndpoint = function (target) {
        var base = this.getBaseApiEndpoint();
        var dsn = this._dsnObject;
        return "" + base + dsn.projectId + "/" + target + "/";
    };
    /** Returns a URL-encoded string with auth config suitable for a query string. */
    API.prototype._encodedAuth = function () {
        var dsn = this._dsnObject;
        var auth = {
            // We send only the minimum set of required information. See
            // https://github.com/getsentry/sentry-javascript/issues/2572.
            sentry_key: dsn.publicKey,
            sentry_version: SENTRY_API_VERSION,
        };
        return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["N" /* urlEncode */])(auth);
    };
    return API;
}());

//# sourceMappingURL=api.js.map

/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integration__ = __webpack_require__(2310);

/* eslint-disable max-lines */




/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Number of call being processed */
        this._processing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["a" /* Dsn */](options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._process(this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* isPrimitive */])(message)
            ? this._getBackend().eventFromMessage(String(message), level, hint)
            : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureSession = function (session) {
        if (!session.release) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* logger */].warn('Discarded session because of missing release');
        }
        else {
            this._sendSession(session);
            // After sending, we set init false to inidcate it's not the first occurence
            session.update({ init: false });
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function (ready) {
            return _this._getBackend()
                .getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return ready && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled()) {
            this._integrations = Object(__WEBPACK_IMPORTED_MODULE_4__integration__["a" /* setupIntegrations */])(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */
    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var userAgent;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for (var exceptions_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __values */])(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var user = event.user;
        if (!session.userAgent) {
            var headers = event.request ? event.request.headers : {};
            for (var key in headers) {
                if (key.toLowerCase() === 'user-agent') {
                    userAgent = headers[key];
                    break;
                }
            }
        }
        session.update(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (crashed && { status: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* SessionStatus */].Crashed })), { user: user,
            userAgent: userAgent, errors: session.errors + Number(errored || crashed) }));
        this.captureSession(session);
    };
    /** Deliver captured session to Sentry */
    BaseClient.prototype._sendSession = function (session) {
        this._getBackend().sendSession(session);
    };
    /** Waits for the client to be done with processing. */
    BaseClient.prototype._isClientProcessing = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */](function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function () {
                if (_this._processing == 0) {
                    clearInterval(interval);
                    resolve(true);
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
        var prepared = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["O" /* uuid4 */])()), timestamp: event.timestamp || Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["i" /* dateTimestampInSeconds */])() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* Scope */].clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth) {
        if (!event) {
            return null;
        }
        var normalized = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, b), (b.data && {
                data: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* normalize */])(b.data, depth),
            }))); }),
        })), (event.user && {
            user: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* normalize */])(event.user, depth),
        })), (event.contexts && {
            contexts: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* normalize */])(event.contexts, depth),
        })), (event.extra && {
            extra: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* normalize */])(event.extra, depth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) {
            event.environment = 'environment' in options ? environment : 'production';
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["M" /* truncate */])(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["M" /* truncate */])(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["M" /* truncate */])(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var sdkInfo = event.sdk;
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) {
            sdkInfo.integrations = integrationsArray;
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
    BaseClient.prototype._captureEvent = function (event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function (finalEvent) {
            return finalEvent.event_id;
        }, function (reason) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* logger */].error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('SDK not enabled, will not send event.'));
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint)
            .then(function (prepared) {
            if (prepared === null) {
                throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) {
                return prepared;
            }
            var beforeSendResult = beforeSend(prepared, hint);
            if (typeof beforeSendResult === 'undefined') {
                throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('`beforeSend` method has to return `null` or a valid event.');
            }
            else if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* isThenable */])(beforeSendResult)) {
                return beforeSendResult.then(function (event) { return event; }, function (e) {
                    throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]("beforeSend rejected with " + e);
                });
            }
            return beforeSendResult;
        })
            .then(function (processedEvent) {
            if (processedEvent === null) {
                throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) {
                _this._updateSessionFromEvent(session, processedEvent);
            }
            _this._sendEvent(processedEvent);
            return processedEvent;
        })
            .then(null, function (reason) {
            if (reason instanceof __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]) {
                throw reason;
            }
            _this.captureException(reason, {
                data: {
                    __sentry__: true,
                },
                originalException: reason,
            });
            throw new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SentryError */]("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */
    BaseClient.prototype._process = function (promise) {
        var _this = this;
        this._processing += 1;
        promise.then(function (value) {
            _this._processing -= 1;
            return value;
        }, function (reason) {
            _this._processing -= 1;
            return reason;
        });
    };
    return BaseClient;
}());

//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export installedIntegrations */
/* unused harmony export getIntegrationsToSetup */
/* unused harmony export setupIntegration */
/* harmony export (immutable) */ __webpack_exports__["a"] = setupIntegrations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);



var installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function (defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function (userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    else {
        integrations = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(defaultIntegrations);
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c" /* addGlobalEventProcessor */], __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["d" /* getCurrentHub */]);
    installedIntegrations.push(integration.name);
    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    return integrations;
}
//# sourceMappingURL=integration.js.map

/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transports_noop__ = __webpack_require__(990);


/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* logger */].warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        this._transport.sendEvent(event).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* logger */].error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendSession = function (session) {
        if (!this._transport.sendSession) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* logger */].warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        this._transport.sendSession(session).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* logger */].error("Error while sending session: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__transports_noop__["a" /* NoopTransport */]();
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sessionToSentryRequest;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventToSentryRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);

/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) {
        return;
    }
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return { name: name, version: version };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) {
        return event;
    }
    event.sdk = event.sdk || {
        name: sdkInfo.name,
        version: sdkInfo.version,
    };
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])((event.sdk.integrations || []), (sdkInfo.integrations || []));
    event.sdk.packages = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])((event.sdk.packages || []), (sdkInfo.packages || []));
    return event;
}
/** Creates a SentryRequest from an event. */
function sessionToSentryRequest(session, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })));
    var itemHeaders = JSON.stringify({
        type: 'session',
    });
    return {
        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
        type: 'session',
        url: api.getEnvelopeEndpointWithUrlEncodedAuth(),
    };
}
/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction';
    var _a = event.debug_meta || {}, transactionSampling = _a.transactionSampling, metadata = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __rest */])(_a, ["transactionSampling"]);
    var _b = transactionSampling || {}, samplingMethod = _b.method, sampleRate = _b.rate;
    if (Object.keys(metadata).length === 0) {
        delete event.debug_meta;
    }
    else {
        event.debug_meta = metadata;
    }
    var req = {
        body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        type: eventType,
        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })));
        var itemHeaders = JSON.stringify({
            type: event.type,
            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
            // explicitly-set sampling decisions). Are we good with that?
            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
        });
        // The trailing newline is optional. We intentionally don't send it to avoid
        // sending unnecessary bytes.
        //
        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
        req.body = envelope;
    }
    return req;
}
//# sourceMappingURL=request.js.map

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAndBind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_hub__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(45);


/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* logger */].enable();
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_hub__["d" /* getCurrentHub */])();
    var client = new clientClass(options);
    hub.bindClient(client);
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_VERSION; });
var SDK_VERSION = '6.2.1';
//# sourceMappingURL=version.js.map

/***/ }),
/* 2315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functiontostring__ = __webpack_require__(2316);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionToString", function() { return __WEBPACK_IMPORTED_MODULE_0__functiontostring__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inboundfilters__ = __webpack_require__(2317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InboundFilters", function() { return __WEBPACK_IMPORTED_MODULE_1__inboundfilters__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 2316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionToString; });
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry_original__ || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 2317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InboundFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c" /* addGlobalEventProcessor */])(function (event) {
            var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["d" /* getCurrentHub */])();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) {
                    return null;
                }
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].warn("Event dropped due to being internal Sentry Error.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* getEventDescription */])(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* getEventDescription */])(event));
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            return ((event &&
                event.exception &&
                event.exception.values &&
                event.exception.values[0] &&
                event.exception.values[0].type === 'SentryError') ||
                false);
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["x" /* isMatchingPattern */])(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isDeniedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["x" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isAllowedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["x" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            allowUrls: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
            denyUrls: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
            ignoreErrors: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].error("Cannot extract message for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* getEventDescription */])(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
            }
            return null;
        }
        catch (oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* logger */].error("Cannot extract url for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* getEventDescription */])(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 2318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(993);






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["a" /* eventFromException */])(this._options, exception, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Severity */].Info; }
        return Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromMessage */])(this._options, message, level, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this._options.transportOptions), { dsn: this._options.dsn, _metadata: this._options._metadata });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["J" /* supportsFetch */])()) {
            return new __WEBPACK_IMPORTED_MODULE_5__transports__["FetchTransport"](transportOptions);
        }
        return new __WEBPACK_IMPORTED_MODULE_5__transports__["XHRTransport"](transportOptions);
    };
    return BrowserBackend;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["b" /* BaseBackend */]));

//# sourceMappingURL=backend.js.map

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(530);




var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["o" /* getGlobalObject */])();
/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* eventToSentryRequest */])(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendSession = function (session) {
        return this._sendRequest(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["s" /* sessionToSentryRequest */])(session, this._api), session);
    };
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["K" /* supportsReferrerPolicy */])() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            global
                .fetch(sentryRequest.url, options)
                .then(function (response) {
                var headers = {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After'),
                };
                _this._handleResponse({
                    requestType: sentryRequest.type,
                    response: response,
                    headers: headers,
                    resolve: resolve,
                    reject: reject,
                });
            })
                .catch(reject);
        }));
    };
    return FetchTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]));

//# sourceMappingURL=fetch.js.map

/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XHRTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(530);




/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* eventToSentryRequest */])(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendSession = function (session) {
        return this._sendRequest(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["s" /* sessionToSentryRequest */])(session, this._api), session);
    };
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState === 4) {
                    var headers = {
                        'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': request.getResponseHeader('Retry-After'),
                    };
                    _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
                }
            };
            request.open('POST', sentryRequest.url);
            for (var header in _this.options.headers) {
                if (_this.options.headers.hasOwnProperty(header)) {
                    request.setRequestHeader(header, _this.options.headers[header]);
                }
            }
            request.send(sentryRequest.body);
        }));
    };
    return XHRTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]));

//# sourceMappingURL=xhr.js.map

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(280);

/* eslint-disable @typescript-eslint/no-unsafe-member-access */





/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /** JSDoc */
        this._onErrorHandlerInstalled = false;
        /** JSDoc */
        this._onUnhandledRejectionHandlerInstalled = false;
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* logger */].log('Global Handler attached: onerror');
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["D" /* logger */].log('Global Handler attached: onunhandledrejection');
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
        var _this = this;
        if (this._onErrorHandlerInstalled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function (data) {
                var error = data.error;
                var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                    return;
                }
                var client = currentHub.getClient();
                var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* isPrimitive */])(error)
                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
                    : _this._enhanceEventWithInitialFrame(Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["c" /* eventFromUnknownInput */])(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: false,
                    }), data.url, data.line, data.column);
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                    handled: false,
                    type: 'onerror',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
            },
            type: 'error',
        });
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
        var _this = this;
        if (this._onUnhandledRejectionHandlerInstalled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function (e) {
                var error = e;
                // dig the object of the rejection out of known event types
                try {
                    // PromiseRejectionEvents store the object of the rejection under 'reason'
                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                    if ('reason' in e) {
                        error = e.reason;
                    }
                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
                    // https://github.com/getsentry/sentry-javascript/issues/2380
                    else if ('detail' in e && 'reason' in e.detail) {
                        error = e.detail.reason;
                    }
                }
                catch (_oO) {
                    // no-empty
                }
                var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                    return true;
                }
                var client = currentHub.getClient();
                var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* isPrimitive */])(error)
                    ? _this._eventFromRejectionWithPrimitive(error)
                    : Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["c" /* eventFromUnknownInput */])(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: true,
                    });
                event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Severity */].Error;
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                    handled: false,
                    type: 'onunhandledrejection',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
                return;
            },
            type: 'unhandledrejection',
        });
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["u" /* isErrorEvent */])(msg) ? msg.message : msg;
        var name;
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* isString */])(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || 'Error',
                        value: message,
                    },
                ],
            },
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * Create an event from a promise rejection where the `reason` is a primitive.
     *
     * @param reason: The `reason` property of the promise rejection
     * @returns An Event object with an appropriate `exception` value
     */
    GlobalHandlers.prototype._eventFromRejectionWithPrimitive = function (reason) {
        return {
            exception: {
                values: [
                    {
                        type: 'UnhandledRejection',
                        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                        value: "Non-Error promise rejection captured with value: " + String(reason),
                    },
                ],
            },
        };
    };
    /** JSDoc */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* isString */])(url) && url.length > 0 ? url : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["p" /* getLocationHref */])();
        if (event.exception.values[0].stacktrace.frames.length === 0) {
            event.exception.values[0].stacktrace.frames.push({
                colno: colno,
                filename: filename,
                function: '?',
                in_app: true,
                lineno: lineno,
            });
        }
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TryCatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(280);



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getGlobalObject */])();
        if (this._options.setTimeout) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* fill */])(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        }
        if (this._options.setInterval) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* fill */])(global, 'setInterval', this._wrapTimeFunction.bind(this));
        }
        if (this._options.requestAnimationFrame) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* fill */])(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* fill */])(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
        }
        if (this._options.eventTarget) {
            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(this._wrapEventTarget.bind(this));
        }
    };
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(originalCallback, {
                mechanism: {
                    data: { function: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getFunctionName */])(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TryCatch.prototype._wrapRAF = function (original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function (callback) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return original.call(this, Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getFunctionName */])(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getGlobalObject */])();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getFunctionName */])(fn),
                                    target: target,
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    }
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, 
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getFunctionName */])(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }), options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* fill */])(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (eventName, fn, options) {
                var _a;
                /**
                 * There are 2 possible scenarios here:
                 *
                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
                 * as a pass-through, and call original `removeEventListener` with it.
                 *
                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
                 *
                 * When someone adds a handler prior to initialization, and then do it again, but after,
                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
                 * to get rid of the initial handler and it'd stick there forever.
                 */
                var wrappedEventHandler = fn;
                try {
                    var originalEventHandler = (_a = wrappedEventHandler) === null || _a === void 0 ? void 0 : _a.__sentry_wrapped__;
                    if (originalEventHandler) {
                        originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                    }
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
            };
        });
    };
    /** JSDoc */
    TryCatch.prototype._wrapXHR = function (originalSend) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
            xmlHttpRequestProps.forEach(function (prop) {
                if (prop in xhr && typeof xhr[prop] === 'function') {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* fill */])(xhr, prop, function (original) {
                        var wrapOptions = {
                            mechanism: {
                                data: {
                                    function: prop,
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getFunctionName */])(original),
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        };
                        // If Instrument integration has been called before TryCatch, get the name of original function
                        if (original.__sentry_original__) {
                            wrapOptions.mechanism.data.handler = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["n" /* getFunctionName */])(original.__sentry_original__);
                        }
                        // Otherwise wrap directly
                        return Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["c" /* wrap */])(original, wrapOptions);
                    });
                }
            });
            return originalSend.apply(this, args);
        };
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumbs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(45);

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable max-lines */



/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["m" /* getEventDescription */])(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        var _this = this;
        if (this._options.console) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._consoleBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
                },
                type: 'console',
            });
        }
        if (this._options.dom) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._domBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
                },
                type: 'dom',
            });
        }
        if (this._options.xhr) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._xhrBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
                },
                type: 'xhr',
            });
        }
        if (this._options.fetch) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._fetchBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
                },
                type: 'fetch',
            });
        }
        if (this._options.history) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._historyBreadcrumb.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(args));
                },
                type: 'history',
            });
        }
    };
    /**
     * Creates breadcrumbs from console API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console',
            },
            level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Severity */].fromString(handlerData.level),
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["I" /* safeJoin */])(handlerData.args, ' '),
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["I" /* safeJoin */])(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.arguments = handlerData.args.slice(1);
            }
            else {
                // Don't capture a breadcrumb for passed assertions
                return;
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level,
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
        var target;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["q" /* htmlTreeAsString */])(handlerData.event.target)
                : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["q" /* htmlTreeAsString */])(handlerData.event);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global,
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) {
                return;
            }
            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])().addBreadcrumb({
                category: 'xhr',
                data: {
                    method: method,
                    url: url,
                    status_code: status_code,
                },
                type: 'http',
            }, {
                xhr: handlerData.xhr,
                input: body,
            });
            return;
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) {
            return;
        }
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
            return;
        }
        if (handlerData.error) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: handlerData.fetchData,
                level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Severity */].Error,
                type: 'http',
            }, {
                data: handlerData.error,
                input: handlerData.args,
            });
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, handlerData.fetchData), { status_code: handlerData.response.status }),
                type: 'http',
            }, {
                input: handlerData.args,
                response: handlerData.response,
            });
        }
    };
    /**
     * Creates breadcrumbs from history API calls
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["o" /* getGlobalObject */])();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["H" /* parseUrl */])(global.location.href);
        var parsedFrom = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["H" /* parseUrl */])(from);
        var parsedTo = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["H" /* parseUrl */])(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            from = parsedFrom.relative;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])().addBreadcrumb({
            category: 'navigation',
            data: {
                from: from,
                to: to,
            },
        });
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracekit__ = __webpack_require__(529);





var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* addGlobalEventProcessor */])(function (event, hint) {
            var self = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])().getIntegration(LinkedErrors);
            if (self) {
                return self._handler(event, hint);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["w" /* isInstanceOf */])(hint.originalException, Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])(linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["w" /* isInstanceOf */])(error[key], Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_4__tracekit__["a" /* computeStackTrace */])(error[key]);
        var exception = Object(__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* exceptionFromStacktrace */])(stacktrace);
        return this._walkErrorTree(error[key], key, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __spread */])([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserAgent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);



var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["o" /* getGlobalObject */])();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* addGlobalEventProcessor */])(function (event) {
            var _a, _b, _c;
            if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["o" /* getCurrentHub */])().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!global.navigator && !global.location && !global.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = global.location) === null || _b === void 0 ? void 0 : _b.href);
                var referrer = (global.document || {}).referrer;
                var userAgent = (global.navigator || {}).userAgent;
                var headers = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (url && { url: url })), { headers: headers });
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map

/***/ }),
/* 2326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultIntegrations; });
/* harmony export (immutable) */ __webpack_exports__["e"] = init;
/* harmony export (immutable) */ __webpack_exports__["h"] = showReportDialog;
/* harmony export (immutable) */ __webpack_exports__["f"] = lastEventId;
/* harmony export (immutable) */ __webpack_exports__["d"] = forceLoad;
/* harmony export (immutable) */ __webpack_exports__["g"] = onLoad;
/* harmony export (immutable) */ __webpack_exports__["c"] = flush;
/* harmony export (immutable) */ __webpack_exports__["a"] = close;
/* harmony export (immutable) */ __webpack_exports__["i"] = wrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(531);





var defaultIntegrations = [
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["e" /* Integrations */].InboundFilters(),
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["e" /* Integrations */].FunctionToString(),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["TryCatch"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["Breadcrumbs"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["GlobalHandlers"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["LinkedErrors"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["UserAgent"](),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getGlobalObject */])();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["q" /* initAndBind */])(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* BrowserClient */], options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        options.eventId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["o" /* getCurrentHub */])().lastEventId();
    }
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["o" /* getCurrentHub */])().getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["o" /* getCurrentHub */])().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function flush(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["o" /* getCurrentHub */])().getClient();
    if (client) {
        return client.flush(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function close(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["o" /* getCurrentHub */])().getClient();
    if (client) {
        return client.close(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* wrap */])(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getGlobalObject */])();
    var document = window.document;
    if (typeof document === 'undefined') {
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["D" /* logger */].warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["o" /* getCurrentHub */])();
    hub.startSession();
    hub.captureSession();
    // We want to create a session for every navigation as well
    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["g" /* addInstrumentationHandler */])({
        callback: function () {
            hub.startSession();
            hub.captureSession();
        },
        type: 'history',
    });
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_NAME; });
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var SDK_NAME = 'sentry.javascript.browser';
//# sourceMappingURL=version.js.map

/***/ }),
/* 2328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_browser__ = __webpack_require__(368);

/**
 * Inits the React SDK
 */
function init(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = {
        name: 'sentry.javascript.react',
        packages: [
            {
                name: 'npm:@sentry/react',
                version: __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["e" /* SDK_VERSION */],
            },
        ],
        version: __WEBPACK_IMPORTED_MODULE_0__sentry_browser__["e" /* SDK_VERSION */],
    };
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_browser__["x" /* init */])(options);
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 2329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNKNOWN_COMPONENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return withProfiler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Profiler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useProfiler; });
/* unused harmony export getActiveTransaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_browser__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);

/* eslint-disable @typescript-eslint/no-explicit-any */




var UNKNOWN_COMPONENT = 'unknown';
var TRACING_GETTER = {
    id: 'Tracing',
};
var globalTracingIntegration = null;
/** @deprecated remove when @sentry/apm no longer used */
var getTracingIntegration = function () {
    if (globalTracingIntegration) {
        return globalTracingIntegration;
    }
    globalTracingIntegration = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["v" /* getCurrentHub */])().getIntegration(TRACING_GETTER);
    return globalTracingIntegration;
};
/**
 * pushActivity creates an new react activity.
 * Is a no-op if Tracing integration is not valid
 * @param name displayName of component that started activity
 * @deprecated remove when @sentry/apm no longer used
 */
function pushActivity(name, op) {
    if (globalTracingIntegration === null) {
        return null;
    }
    return globalTracingIntegration.constructor.pushActivity(name, {
        description: "<" + name + ">",
        op: "react." + op,
    });
}
/**
 * popActivity removes a React activity.
 * Is a no-op if Tracing integration is not valid.
 * @param activity id of activity that is being popped
 * @deprecated remove when @sentry/apm no longer used
 */
function popActivity(activity) {
    if (activity === null || globalTracingIntegration === null) {
        return;
    }
    globalTracingIntegration.constructor.popActivity(activity);
}
/**
 * Obtain a span given an activity id.
 * Is a no-op if Tracing integration is not valid.
 * @param activity activity id associated with obtained span
 * @deprecated remove when @sentry/apm no longer used
 */
function getActivitySpan(activity) {
    if (activity === null || globalTracingIntegration === null) {
        return undefined;
    }
    return globalTracingIntegration.constructor.getActivitySpan(activity);
}
/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */
var Profiler = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Profiler, _super);
    function Profiler(props) {
        var _this = _super.call(this, props) || this;
        // The activity representing how long it takes to mount a component.
        _this._mountActivity = null;
        // The span of the mount activity
        _this._mountSpan = undefined;
        var _a = _this.props, name = _a.name, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
        if (disabled) {
            return _this;
        }
        // If they are using @sentry/apm, we need to push/pop activities
        // eslint-disable-next-line deprecation/deprecation
        if (getTracingIntegration()) {
            // eslint-disable-next-line deprecation/deprecation
            _this._mountActivity = pushActivity(name, 'mount');
        }
        else {
            var activeTransaction = getActiveTransaction();
            if (activeTransaction) {
                _this._mountSpan = activeTransaction.startChild({
                    description: "<" + name + ">",
                    op: 'react.mount',
                });
            }
        }
        return _this;
    }
    // If a component mounted, we can finish the mount activity.
    Profiler.prototype.componentDidMount = function () {
        if (this._mountSpan) {
            this._mountSpan.finish();
        }
        else {
            // eslint-disable-next-line deprecation/deprecation
            this._mountSpan = getActivitySpan(this._mountActivity);
            // eslint-disable-next-line deprecation/deprecation
            popActivity(this._mountActivity);
            this._mountActivity = null;
        }
    };
    Profiler.prototype.componentDidUpdate = function (_a) {
        var _this = this;
        var updateProps = _a.updateProps, _b = _a.includeUpdates, includeUpdates = _b === void 0 ? true : _b;
        // Only generate an update span if hasUpdateSpan is true, if there is a valid mountSpan,
        // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
        // We are just trying to give baseline clues for further investigation.
        if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
            // See what props haved changed between the previous props, and the current props. This is
            // set as data on the span. We just store the prop keys as the values could be potenially very large.
            var changedProps = Object.keys(updateProps).filter(function (k) { return updateProps[k] !== _this.props.updateProps[k]; });
            if (changedProps.length > 0) {
                // The update span is a point in time span with 0 duration, just signifying that the component
                // has been updated.
                var now = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["L" /* timestampWithMs */])();
                this._mountSpan.startChild({
                    data: {
                        changedProps: changedProps,
                    },
                    description: "<" + this.props.name + ">",
                    endTimestamp: now,
                    op: "react.update",
                    startTimestamp: now,
                });
            }
        }
    };
    // If a component is unmounted, we can say it is no longer on the screen.
    // This means we can finish the span representing the component render.
    Profiler.prototype.componentWillUnmount = function () {
        var _a = this.props, name = _a.name, _b = _a.includeRender, includeRender = _b === void 0 ? true : _b;
        if (this._mountSpan && includeRender) {
            // If we were able to obtain the spanId of the mount activity, we should set the
            // next activity as a child to the component mount activity.
            this._mountSpan.startChild({
                description: "<" + name + ">",
                endTimestamp: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["L" /* timestampWithMs */])(),
                op: "react.render",
                startTimestamp: this._mountSpan.endTimestamp,
            });
        }
    };
    Profiler.prototype.render = function () {
        return this.props.children;
    };
    // eslint-disable-next-line @typescript-eslint/member-ordering
    Profiler.defaultProps = {
        disabled: false,
        includeRender: true,
        includeUpdates: true,
    };
    return Profiler;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]));
/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */
function withProfiler(WrappedComponent, 
// We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
    var componentDisplayName = (options && options.name) || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    var Wrapped = function (props) { return (__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Profiler, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options, { name: componentDisplayName, updateProps: props }),
        __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props)))); };
    Wrapped.displayName = "profiler(" + componentDisplayName + ")";
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(Wrapped, WrappedComponent);
    return Wrapped;
}
/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */
function useProfiler(name, options) {
    if (options === void 0) { options = {
        disabled: false,
        hasRenderSpan: true,
    }; }
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __read */])(__WEBPACK_IMPORTED_MODULE_4_react__["useState"](function () {
        if (options && options.disabled) {
            return undefined;
        }
        var activeTransaction = getActiveTransaction();
        if (activeTransaction) {
            return activeTransaction.startChild({
                description: "<" + name + ">",
                op: 'react.mount',
            });
        }
        return undefined;
    }), 1), mountSpan = _a[0];
    __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"](function () {
        if (mountSpan) {
            mountSpan.finish();
        }
        return function () {
            if (mountSpan && options.hasRenderSpan) {
                mountSpan.startChild({
                    description: "<" + name + ">",
                    endTimestamp: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["L" /* timestampWithMs */])(),
                    op: "react.render",
                    startTimestamp: mountSpan.endTimestamp,
                });
            }
        };
        // We only want this to run once.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

/** Grabs active transaction off scope */
function getActiveTransaction(hub) {
    if (hub === void 0) { hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["v" /* getCurrentHub */])(); }
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            return scope.getTransaction();
        }
    }
    return undefined;
}
//# sourceMappingURL=profiler.js.map

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2331);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 2332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNKNOWN_COMPONENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withErrorBoundary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_browser__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);




var UNKNOWN_COMPONENT = 'unknown';
var INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null,
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * Requires React >= 16
 */
var ErrorBoundary = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = INITIAL_STATE;
        _this.resetErrorBoundary = function () {
            var onReset = _this.props.onReset;
            var _a = _this.state, error = _a.error, componentStack = _a.componentStack, eventId = _a.eventId;
            if (onReset) {
                onReset(error, componentStack, eventId);
            }
            _this.setState(INITIAL_STATE);
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, _a) {
        var _this = this;
        var componentStack = _a.componentStack;
        var _b = this.props, beforeCapture = _b.beforeCapture, onError = _b.onError, showDialog = _b.showDialog, dialogOptions = _b.dialogOptions;
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["K" /* withScope */])(function (scope) {
            if (beforeCapture) {
                beforeCapture(scope, error, componentStack);
            }
            var eventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["m" /* captureException */])(error, { contexts: { react: { componentStack: componentStack } } });
            if (onError) {
                onError(error, componentStack, eventId);
            }
            if (showDialog) {
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_browser__["I" /* showReportDialog */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, dialogOptions), { eventId: eventId }));
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            _this.setState({ error: error, componentStack: componentStack, eventId: eventId });
        });
    };
    ErrorBoundary.prototype.componentDidMount = function () {
        var onMount = this.props.onMount;
        if (onMount) {
            onMount();
        }
    };
    ErrorBoundary.prototype.componentWillUnmount = function () {
        var _a = this.state, error = _a.error, componentStack = _a.componentStack, eventId = _a.eventId;
        var onUnmount = this.props.onUnmount;
        if (onUnmount) {
            onUnmount(error, componentStack, eventId);
        }
    };
    ErrorBoundary.prototype.render = function () {
        var fallback = this.props.fallback;
        var _a = this.state, error = _a.error, componentStack = _a.componentStack, eventId = _a.eventId;
        if (error) {
            if (__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](fallback)) {
                return fallback;
            }
            if (typeof fallback === 'function') {
                return fallback({ error: error, componentStack: componentStack, resetError: this.resetErrorBoundary, eventId: eventId });
            }
            // Fail gracefully if no fallback provided
            return null;
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
    var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    var Wrapped = function (props) { return (__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ErrorBoundary, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, errorBoundaryOptions),
        __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props)))); };
    Wrapped.displayName = "errorBoundary(" + componentDisplayName + ")";
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Wrapped, WrappedComponent);
    return Wrapped;
}

//# sourceMappingURL=errorboundary.js.map

/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createReduxEnhancer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_minimal__ = __webpack_require__(982);

/* eslint-disable @typescript-eslint/no-explicit-any */

var ACTION_BREADCRUMB_CATEGORY = 'redux.action';
var ACTION_BREADCRUMB_TYPE = 'info';
var STATE_CONTEXT_KEY = 'redux.state';
var defaultOptions = {
    actionTransformer: function (action) { return action; },
    stateTransformer: function (state) { return state || null; },
};
/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */
function createReduxEnhancer(enhancerOptions) {
    // Note: We return an any type as to not have type conflicts.
    var options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, defaultOptions), enhancerOptions);
    return function (next) { return function (reducer, initialState) {
        var sentryReducer = function (state, action) {
            var newState = reducer(state, action);
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_minimal__["e" /* configureScope */])(function (scope) {
                /* Action breadcrumbs */
                var transformedAction = options.actionTransformer(action);
                if (typeof transformedAction !== 'undefined' && transformedAction !== null) {
                    scope.addBreadcrumb({
                        category: ACTION_BREADCRUMB_CATEGORY,
                        data: transformedAction,
                        type: ACTION_BREADCRUMB_TYPE,
                    });
                }
                /* Set latest state to scope */
                var transformedState = options.stateTransformer(newState);
                if (typeof transformedState !== 'undefined' && transformedState !== null) {
                    scope.setContext(STATE_CONTEXT_KEY, transformedState);
                }
                else {
                    scope.setContext(STATE_CONTEXT_KEY, null);
                }
                /* Allow user to configure scope with latest state */
                // eslint-disable-next-line @typescript-eslint/unbound-method
                var configureScopeWithState = options.configureScopeWithState;
                if (typeof configureScopeWithState === 'function') {
                    configureScopeWithState(scope, newState);
                }
            });
            return newState;
        };
        return next(sentryReducer, initialState);
    }; };
}

//# sourceMappingURL=redux.js.map

/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reactRouterV3Instrumentation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(45);

var global = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["o" /* getGlobalObject */])();
/**
 * Creates routing instrumentation for React Router v3
 * Works for React Router >= 3.2.0 and < 4.0.0
 *
 * @param history object from the `history` library
 * @param routes a list of all routes, should be
 * @param match `Router.match` utility
 */
function reactRouterV3Instrumentation(history, routes, match) {
    return function (startTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
        if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
        if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
        var activeTransaction;
        var prevName;
        // Have to use global.location because history.location might not be defined.
        if (startTransactionOnPageLoad && global && global.location) {
            normalizeTransactionName(routes, global.location, match, function (localName) {
                prevName = localName;
                activeTransaction = startTransaction({
                    name: prevName,
                    op: 'pageload',
                    tags: {
                        'routing.instrumentation': 'react-router-v3',
                    },
                });
            });
        }
        if (startTransactionOnLocationChange && history.listen) {
            history.listen(function (location) {
                if (location.action === 'PUSH' || location.action === 'POP') {
                    if (activeTransaction) {
                        activeTransaction.finish();
                    }
                    var tags_1 = {
                        'routing.instrumentation': 'react-router-v3',
                    };
                    if (prevName) {
                        tags_1.from = prevName;
                    }
                    normalizeTransactionName(routes, location, match, function (localName) {
                        prevName = localName;
                        activeTransaction = startTransaction({
                            name: prevName,
                            op: 'navigation',
                            tags: tags_1,
                        });
                    });
                }
            });
        }
    };
}
/**
 * Normalize transaction names using `Router.match`
 */
function normalizeTransactionName(appRoutes, location, match, callback) {
    var name = location.pathname;
    match({
        location: location,
        routes: appRoutes,
    }, function (error, _redirectLocation, renderProps) {
        if (error || !renderProps) {
            return callback(name);
        }
        var routePath = getRouteStringFromRoutes(renderProps.routes || []);
        if (routePath.length === 0 || routePath === '/*') {
            return callback(name);
        }
        name = routePath;
        return callback(name);
    });
}
/**
 * Generate route name from array of routes
 */
function getRouteStringFromRoutes(routes) {
    if (!Array.isArray(routes) || routes.length === 0) {
        return '';
    }
    var routesWithPaths = routes.filter(function (route) { return !!route.path; });
    var index = -1;
    for (var x = routesWithPaths.length - 1; x >= 0; x--) {
        var route = routesWithPaths[x];
        if (route.path && route.path.startsWith('/')) {
            index = x;
            break;
        }
    }
    return routesWithPaths
        .slice(index)
        .filter(function (_a) {
        var path = _a.path;
        return !!path;
    })
        .map(function (_a) {
        var path = _a.path;
        return path;
    })
        .join('');
}
//# sourceMappingURL=reactrouterv3.js.map

/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reactRouterV4Instrumentation;
/* harmony export (immutable) */ __webpack_exports__["b"] = reactRouterV5Instrumentation;
/* harmony export (immutable) */ __webpack_exports__["c"] = withSentryRouting;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);




/* eslint-enable @typescript-eslint/no-explicit-any */
var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* getGlobalObject */])();
var activeTransaction;
function reactRouterV4Instrumentation(history, routes, matchPath) {
    return reactRouterInstrumentation(history, 'react-router-v4', routes, matchPath);
}
function reactRouterV5Instrumentation(history, routes, matchPath) {
    return reactRouterInstrumentation(history, 'react-router-v5', routes, matchPath);
}
function reactRouterInstrumentation(history, name, allRoutes, matchPath) {
    if (allRoutes === void 0) { allRoutes = []; }
    function getName(pathname) {
        if (allRoutes === [] || !matchPath) {
            return pathname;
        }
        var branches = matchRoutes(allRoutes, pathname, matchPath);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var x = 0; x < branches.length; x++) {
            if (branches[x].match.isExact) {
                return branches[x].match.path;
            }
        }
        return pathname;
    }
    return function (startTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
        if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
        if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
        if (startTransactionOnPageLoad && global && global.location) {
            activeTransaction = startTransaction({
                name: getName(global.location.pathname),
                op: 'pageload',
                tags: {
                    'routing.instrumentation': name,
                },
            });
        }
        if (startTransactionOnLocationChange && history.listen) {
            history.listen(function (location, action) {
                if (action && (action === 'PUSH' || action === 'POP')) {
                    if (activeTransaction) {
                        activeTransaction.finish();
                    }
                    var tags = {
                        'routing.instrumentation': name,
                    };
                    activeTransaction = startTransaction({
                        name: getName(location.pathname),
                        op: 'navigation',
                        tags: tags,
                    });
                }
            });
        }
    };
}
/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */
function matchRoutes(routes, pathname, matchPath, branch) {
    if (branch === void 0) { branch = []; }
    routes.some(function (route) {
        var match = route.path
            ? matchPath(pathname, route)
            : branch.length
                ? branch[branch.length - 1].match // use parent match
                : computeRootMatch(pathname); // use default "root" match
        if (match) {
            branch.push({ route: route, match: match });
            if (route.routes) {
                matchRoutes(route.routes, pathname, matchPath, branch);
            }
        }
        return !!match;
    });
    return branch;
}
function computeRootMatch(pathname) {
    return { path: '/', url: '/', params: {}, isExact: pathname === '/' };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryRouting(Route) {
    var componentDisplayName = Route.displayName || Route.name;
    var WrappedRoute = function (props) {
        if (activeTransaction && props && props.computedMatch && props.computedMatch.isExact) {
            activeTransaction.setName(props.computedMatch.path);
        }
        return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Route, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props));
    };
    WrappedRoute.displayName = "sentryRoute(" + componentDisplayName + ")";
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(WrappedRoute, Route);
    return WrappedRoute;
}
//# sourceMappingURL=reactrouter.js.map

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _liveChat = __webpack_require__(2337);

var _liveChat2 = _interopRequireDefault(_liveChat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FAB_POS_STORAGE_KEY = 'chat-fab-pos';

var HubspotChat = function (_Component) {
  _inherits(HubspotChat, _Component);

  function HubspotChat(props) {
    _classCallCheck(this, HubspotChat);

    var _this = _possibleConstructorReturn(this, (HubspotChat.__proto__ || Object.getPrototypeOf(HubspotChat)).call(this, props));

    _this.updateWindowSize = function () {
      // when resize the window by the user
      _this.setState({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight
      });
      // check mobile view or not
      _this.setState({ isMobileView: window.innerWidth <= 768 });

      var fab = document.getElementById("custom-chat-fab");
      if (fab && fab.style) {
        // if there is hubspot FAB and it has style

        var originalRight = fab.style.right ? parseInt(fab.style.right, 10) : 0;
        var originalBottom = fab.style.bottom ? parseInt(fab.style.bottom, 10) : 0;

        var savedPos = localStorage.getItem(FAB_POS_STORAGE_KEY);
        if (savedPos) {
          // if there is saved positoin in local storage

          var parsedPos = void 0;
          try {
            parsedPos = JSON.parse(savedPos);
          } catch (e) {
            console.error('Failed to parse saved FAB position:', e);
            localStorage.removeItem(FAB_POS_STORAGE_KEY);
            parsedPos = null;
          }

          var top = parsedPos && parsedPos.top !== undefined ? parsedPos.top : 80;
          var left = parsedPos && parsedPos.left !== undefined ? parsedPos.left : 80;
          // when resize the window and fab position is out of window
          if (originalBottom > _this.state.windowHeight - 80) {
            // assume initial gap as 80px
            top = 80;
            localStorage.setItem(FAB_POS_STORAGE_KEY, JSON.stringify({
              top: top,
              left: left
            }));
            fab.style.bottom = _this.state.windowHeight - 80 + "px";
          }
          if (originalRight > _this.state.windowWidth - 80) {
            // assume initial gap as 80px
            left = 80;
            localStorage.setItem(FAB_POS_STORAGE_KEY, JSON.stringify({
              top: top,
              left: left
            }));
            fab.style.right = _this.state.windowWidth - 80 + "px";
          }
        } else {
          localStorage.setItem(FAB_POS_STORAGE_KEY, JSON.stringify({
            top: _this.state.windowHeight - 80,
            left: _this.state.windowWidth - 80
          }));
          fab.style.right = _this.state.windowWidth - 80 + "px";
          fab.style.bottom = _this.state.windowHeight - 80 + "px";
        }
      }
    };

    _this.handleHubSpotLoad = function () {
      if (window.HubSpotConversations) {
        if (window._hsq && _this.props.user) {
          window._hsq.push(["identify", { email: _this.props.user.email }]);
          window._hsq.push(["trackPageView"]);
        }

        _this.eventRef = function (payload) {
          _this.setState({
            activeConversation: payload.conversation.conversationId
          });
        };
        window.HubSpotConversations.on("conversationStarted", _this.eventRef);

        // ✅ Listen for widget open/close events
        window.HubSpotConversations.on("widgetOpened", function () {
          _this.openHandler(true); // pass true to indicate internal event
        });

        window.HubSpotConversations.on("widgetClosed", function () {
          _this.closeHandler(true); // pass true to indicate internal event
        });

        // ✅ Observe DOM changes to catch the container as soon as it's added
        var observer = new MutationObserver(function (mutations, obs) {
          var chat = document.querySelector("#hubspot-messages-iframe-container");
          if (chat) {
            chat.classList.add("hide-chat");
            obs.disconnect(); // ✅ Stop observing once found and hidden
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

        if (!_this.state.isMobileView) {
          // when mobile view, there is no need to customize the chat position.

          var tryOpenChat = setInterval(function () {
            if (window.HubSpotConversations && window.HubSpotConversations.widget) {
              window.HubSpotConversations.widget.open(); // ✅ Automatically opens the chat widget
              clearInterval(tryOpenChat); // ✅ Stop polling
              setTimeout(function () {
                var chat = document.querySelector("#hubspot-messages-iframe-container");
                if (chat) {
                  // store the width and height of the whole opend widget to the state
                  _this.setState({ chatWidth: chat.offsetWidth, chatHeight: chat.offsetHeight });
                }
              }, 1000);
            }
          }, 3000);
        }

        // ✅ Proceed to add the custom FAB
        _this.injectDraggableFAB();
      }
    };

    _this.toggleHubSpotVisibility = function () {
      var fabContainer = document.querySelector("#custom-chat-fab");
      if (fabContainer) {
        if (_this.props.rightSidePage) {
          fabContainer.classList.add("hide-chat");
          fabContainer.classList.remove("show-chat");
        } else {
          fabContainer.classList.remove("hide-chat");
          fabContainer.classList.add("show-chat");
        }
      }

      var chatContainer = document.querySelector('#hubspot-messages-iframe-container');
      if (chatContainer) {
        if (_this.props.rightSidePage) {
          chatContainer.classList.add("hide-chat");
          chatContainer.classList.remove("show-chat");
        }
      }
    };

    _this.injectDraggableFAB = function () {
      if (document.getElementById("custom-chat-fab")) return;

      var fab = document.createElement("div");
      fab.id = "custom-chat-fab";

      // Replace emoji with an SVG icon (similar to HubSpot's)
      fab.innerHTML = "\n       <!-- Chat bubble SVG icon -->\n        <svg width=\"28\" height=\"28\" viewBox=\"0 0 24 24\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path d=\"M4 4H20C21.1 4 22 4.9 22 6V16C22 17.1 21.1 18 20 18H6L2 22V6C2 4.9 2.9 4 4 4Z\" />\n        </svg>\n    ";

      fab.style.cssText = "\n      position: fixed;\n      bottom: 25px;\n      right: 24px;\n      width: 60px;\n      height: 60px;\n      border-radius: 50%;\n      background-color: rgb(223, 0, 21);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: 0 4px 8px rgba(0,0,0,0.3);\n      cursor: pointer;\n      z-index: 1000;\n      user-select: none;\n      transition: transform 0.2s ease;\n      touch-action: manipulation;\n      -webkit-user-select: none;\n      -webkit-tap-highlight-color: transparent;\n    ";

      fab.addEventListener("mouseenter", function () {
        fab.style.transform = "scale(1.1)";
      });

      fab.addEventListener("mouseleave", function () {
        fab.style.transform = "scale(1)";
      });

      var savedPos = localStorage.getItem(FAB_POS_STORAGE_KEY);
      if (savedPos) {
        // set the fab postion with stored position if saved pos in the desired window
        var parsedPos = void 0;
        try {
          parsedPos = JSON.parse(savedPos);
        } catch (e) {
          console.error('Failed to parse saved FAB position:', e);
          localStorage.removeItem(FAB_POS_STORAGE_KEY);
          parsedPos = null;
        }

        var top = parsedPos && parsedPos.top !== undefined ? parsedPos.top : 80;
        var left = parsedPos && parsedPos.left !== undefined ? parsedPos.left : 80;

        if (top > 0 && top < _this.state.windowHeight && left < _this.state.windowWidth && left > 0) {
          fab.style.bottom = _this.state.windowHeight - top + "px";
          fab.style.right = _this.state.windowWidth - left + "px";
        }
      }

      document.body.appendChild(fab);
      setTimeout(function () {
        return fab.blur();
      }, 100);

      var offsetX = 0,
          offsetY = 0,
          dragging = false;
      var startX = 0,
          startY = 0,
          moved = false;

      // ✅ Capture `this.openHandler` in a local variable to preserve scope
      var openHandler = _this.openHandler;

      fab.addEventListener("pointerdown", function (e) {
        dragging = true;
        startX = e.clientX;
        startY = e.clientY;
        moved = false;
        offsetX = e.clientX - fab.getBoundingClientRect().left;
        offsetY = e.clientY - fab.getBoundingClientRect().top;
        fab.setPointerCapture(e.pointerId);
        fab.style.cursor = "grabbing";
      });

      fab.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        var newLeft = e.clientX + offsetX;
        // manual position check whether it's outside of the width
        if (newLeft < 80) newLeft = 80;
        if (newLeft > _this.state.windowWidth) newLeft = _this.state.windowWidth - 25;

        var newTop = e.clientY + offsetY;
        // manual position check whether it's outside of the height
        if (newTop < 80) newTop = 80;
        if (newTop > _this.state.windowHeight) newTop = _this.state.windowHeight - 25;

        fab.style.bottom = _this.state.windowHeight - newTop + "px";
        fab.style.right = _this.state.windowWidth - newLeft + "px";

        if (Math.abs(e.clientX - startX) > 3 || Math.abs(e.clientY - startY) > 3) {
          moved = true;
        }
      });

      fab.addEventListener("pointerup", function (e) {
        dragging = false;
        fab.releasePointerCapture(e.pointerId);
        fab.style.cursor = "grab";

        localStorage.setItem(FAB_POS_STORAGE_KEY, JSON.stringify({
          top: fab.offsetTop,
          left: fab.offsetLeft
        }));

        if (!moved && openHandler) {
          var chat = document.querySelector("#hubspot-messages-iframe-container");
          if (!chat) return;

          if (_this.state.isMobileView) {
            // Mobile or responsive view (small screen)

            chat.classList.remove("hide-chat");
            chat.classList.add("show-chat");

            openHandler();

            fab.classList.remove("show-chat");
            fab.classList.add("hide-chat");

            return;
          }

          if (_this.state.chatHeight) // only after getting the width and height of the real opend widget
            {
              chat.style.position = "fixed";
              var fabRect = fab.getBoundingClientRect(); // actual position

              var fabPostionY = fabRect.top;
              var fabPostionX = fabRect.left;

              if (_this.state.windowHeight - fabPostionY < _this.state.chatHeight - 80) {
                if (fabPostionY - _this.state.chatHeight + 80 < -100) // when top position is less than -100, set as 15
                  chat.style.top = "15px";else chat.style.top = fabPostionY - _this.state.chatHeight + 80 + "px";
              } else {
                chat.style.top = fabPostionY - 20 + "px";
              }

              if (fabPostionX > _this.state.chatWidth - 80) {
                chat.style.left = fabPostionX - _this.state.chatWidth + 80 + "px";
              } else {
                chat.style.left = fabPostionX - 20 + "px";
              }

              chat.style.bottom = "";
              chat.style.right = "";

              chat.classList.remove("hide-chat");
              chat.classList.add("show-chat");

              openHandler(); // ✅ properly scoped

              fab.classList.remove('show-chat');
              fab.classList.add('hide-chat');
            }
        }
      });

      fab.addEventListener("pointercancel", function (e) {
        dragging = false;
        fab.releasePointerCapture(e.pointerId);
        fab.style.cursor = "grab";
        fab.blur(); // remove focus
      });
    };

    _this.openHandler = function () {
      var fromHubspot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.state.hasLoaded && window.HubSpotConversations) {
        window.HubSpotConversations.widget.open();

        if (!fromHubspot) {
          var chat = document.querySelector("#hubspot-messages-iframe-container");
          if (chat) {
            chat.classList.remove("hide-chat");
            chat.classList.add("show-chat");
          }
        }
      }
    };

    _this.closeHandler = function () {
      var fromHubspot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.close();
        if (fromHubspot) {
          var fab = document.getElementById("custom-chat-fab");
          if (fab) {
            fab.classList.remove("hide-chat");
            fab.classList.add("show-chat");
          }

          var chat = document.querySelector("#hubspot-messages-iframe-container");
          if (chat) {
            chat.classList.remove("show-chat");
            chat.classList.add("hide-chat");
          }
        }
      }
    };

    _this.state = {
      hasLoaded: false,
      activeConversation: false,
      chatWidth: "",
      chatHeight: "",
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      isMobileView: window.innerWidth <= 768
    };
    _this.eventRef = null;
    _this.fallbackTimeout = null;
    return _this;
  }

  _createClass(HubspotChat, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.rightSidePage) return;

      window.addEventListener('resize', this.updateWindowSize);

      // Inject HubSpot script
      if (!document.body.querySelector("script[src=\"//js.hs-scripts.com/" + this.props.portalId + ".js\"]")) {
        var script = document.createElement("script");
        script.src = "//js.hs-scripts.com/" + this.props.portalId + ".js";
        script.async = true;

        script.onload = function () {
          console.log("✅ HubSpot script loaded successfully.");
          _this2.setState({ hasLoaded: true });
          // after hubspot loading, need to load all including FAB
          _this2.fallbackTimeout = setTimeout(function () {
            if (window.HubSpotConversations) {
              _this2.handleHubSpotLoad();
            }
          }, 2000);
        };
        script.onerror = function () {
          return console.error("❌ HubSpot script failed to load.");
        };

        document.body.appendChild(script);
        this.scriptElement = script;
      }

      // Inject CSS
      var style = document.createElement("style");
      style.innerHTML = "\n      .hide-chat {\n        opacity: 0 !important;\n        pointer-events: none !important;\n      }\n      .show-chat {\n        opacity: 1 !important;\n        \n        pointer-events: auto !important;\n      }\n      #hubspot-messages-iframe-container {\n        transition: opacity 0.3s ease, transform 0.3s ease;\n      }\n        \n      @media (max-width: 768px) {\n        .hide-chat {\n          opacity: 0 !important;\n          pointer-events: none !important;\n          visibility: hidden !important;\n        }\n      }\n    ";
      document.head.appendChild(style);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.rightSidePage !== this.props.rightSidePage) {
        this.toggleHubSpotVisibility();
      }

      if (this.state.hasLoaded && !prevState.hasLoaded) {
        this.handleHubSpotLoad();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.addEventListener('resize', this.updateWindowSize);
      window.hsConversationsOnReady = [];

      if (this.eventRef && window.HubSpotConversations) {
        window.HubSpotConversations.off("conversationStarted", this.eventRef);
      }

      if (window.HubSpotConversations) {
        window.HubSpotConversations.widget.close();
      }

      if (this.fallbackTimeout) {
        clearTimeout(this.fallbackTimeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        hasLoaded: this.state.hasLoaded,
        activeConversation: this.state.activeConversation,
        openHandler: this.openHandler,
        closeHandler: this.closeHandler
      });
    }
  }]);

  return HubspotChat;
}(_react.Component);

var LiveChat = function (_React$Component) {
  _inherits(LiveChat, _React$Component);

  function LiveChat() {
    _classCallCheck(this, LiveChat);

    return _possibleConstructorReturn(this, (LiveChat.__proto__ || Object.getPrototypeOf(LiveChat)).apply(this, arguments));
  }

  _createClass(LiveChat, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.rightSidePage !== this.props.rightSidePage;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          rightSidePage = _props.rightSidePage,
          user = _props.user;

      return _react2.default.createElement(
        HubspotChat,
        {
          portalId: "20714277",
          rightSidePage: rightSidePage,
          user: user
        },
        function (_ref) {
          var hasLoaded = _ref.hasLoaded,
              activeConversation = _ref.activeConversation,
              openHandler = _ref.openHandler,
              closeHandler = _ref.closeHandler;
          return _react2.default.createElement("div", null);
        }
      );
    }
  }]);

  return LiveChat;
}(_react2.default.Component);

exports.default = (0, _liveChat2.default)(LiveChat);

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    rightSidePage: state.rightSidePage.name ? true : false,
    user: state.user.current
  };
}; /**
    * src/connects/live-chat.js
    */

exports.default = (0, _combineHoc2.default)((0, _reactI18next.translate)(), (0, _reactRedux.connect)(mapStateToProps), _lifecycle2.default);

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupsPage = __webpack_require__(2339);

var _groupsPage2 = _interopRequireDefault(_groupsPage);

var _groupNav = __webpack_require__(2340);

var _groupNav2 = _interopRequireDefault(_groupNav);

var _groupAlbum = __webpack_require__(2378);

var _groupAlbum2 = _interopRequireDefault(_groupAlbum);

var _layout = __webpack_require__(85);

var _pdfPreviewDialog = __webpack_require__(373);

var _pdfPreviewDialog2 = _interopRequireDefault(_pdfPreviewDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/groups-page.jsx

var GroupsPage = function (_React$Component) {
  _inherits(GroupsPage, _React$Component);

  function GroupsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GroupsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupsPage.__proto__ || Object.getPrototypeOf(GroupsPage)).call.apply(_ref, [this].concat(args))), _this), _this.openAlbum = function () {
      _this.props.updateUI({ openAlbum: true });
    }, _this.closeAlbum = function () {
      _this.props.updateUI({ openAlbum: false });
    }, _this.openPdf = function (pdf, open) {
      _this.props.updateUI({ pdf: pdf, openPdf: open });
    }, _this.closePdf = function () {
      _this.props.updateUI({ pdf: false, openPdf: false });
    }, _this.openSearchDrawer = function () {
      return _this.props.updateUI({ openDrawer: !_this.props.ui.openDrawer });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GroupsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          children = _props.children,
          params = _props.params,
          location = _props.location,
          group = _props.group,
          closeDialog = _props.closeDialog;


      return _react2.default.createElement(
        _layout.Panel,
        { style: { height: '100vh', position: 'fixed' } },
        group && _react2.default.createElement(_groupNav2.default, { group: group, openAlbum: this.openAlbum, openSearchDrawer: this.openSearchDrawer, openDrawer: ui.openDrawer }),
        ui.openPdf && _react2.default.createElement(_pdfPreviewDialog2.default, { file: ui.pdf, open: ui.openPdf, onClose: this.closePdf, t: t }),
        ui.openAlbum && _react2.default.createElement(_groupAlbum2.default, { group: group, open: ui.openAlbum, closeAlbum: this.closeAlbum, openPdf: this.openPdf, t: t }),
        children
      );
    }
  }]);

  return GroupsPage;
}(_react2.default.Component);

var RawGroupsPage = exports.RawGroupsPage = GroupsPage;
exports.default = (0, _groupsPage2.default)(GroupsPage);

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _store = __webpack_require__(18);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _groupIdStore = __webpack_require__(341);

var _groupIdStore2 = _interopRequireDefault(_groupIdStore);

var _socketRsync = __webpack_require__(144);

var _socketRsync2 = _interopRequireDefault(_socketRsync);

var _route = __webpack_require__(67);

var _context = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/groups-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: state.user.current,
    group: (0, _store.getArray)('group_id', state.groups.items, ownProps.params.group_id),
    current: state.savedDiaries.current,
    isFetchGroupFailed: state.groups.isFetchGroupFailed,
    rightSidePage: state.rightSidePage,
    groupSettings: state.groupSettings
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willMount: function willMount(props) {
      dispatch(_actions2.default.fetchGroup(ownProps.params.group_id));
      dispatch(_actions2.default.fetchGroupUnreadCount(ownProps.params.group_id));
      dispatch(_actions2.default.fetchNotificationsUnreadCount(ownProps.params.group_id));
      _groupIdStore2.default.set(ownProps.params.group_id);
    },

    willUnmount: function willUnmount() {
      dispatch(_actions2.default.clearPreservedQueries());
      dispatch(_actions2.default.clearKpis());
      dispatch(_actions2.default.closeRightSidePage(true));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (!nextProps.group) {
        (0, _route.replaceRoute)('main');
      }

      if (props.params.group_id != nextProps.params.group_id) {
        dispatch(_actions2.default.fetchGroup(nextProps.params.group_id));
        dispatch(_actions2.default.fetchGroupUnreadCount(nextProps.params.group_id));
        dispatch(_actions2.default.fetchNotificationsUnreadCount(nextProps.params.group_id));
        _groupIdStore2.default.set(nextProps.params.group_id);
      }

      if (props.isFetchGroupFailed != nextProps.isFetchGroupFailed && nextProps.isFetchGroupFailed) {
        dispatch(_actions2.default.fetchGroups());
      }
    },

    receiveSocket: function receiveSocket(message) {
      if (message.group_id == ownProps.params.group_id) dispatch(_actions2.default.loadNotificationUnreadCount(message.group_id, message.count));
    },

    requestSync: function requestSync() {
      dispatch(_actions2.default.fetchNotificationsUnreadCount(ownProps.params.group_id));
      dispatch(_actions2.default.fetchGroup(ownProps.params.group_id));
      dispatch(_actions2.default.fetchGroupUnreadCount(ownProps.params.group_id));
    },
    openDiaryForms: function openDiaryForms(props) {
      return dispatch(_actions2.default.openRightSidePage('create_diary', { group: props.group }));
    },
    openSearchDrawer: function openSearchDrawer(props) {
      return dispatch(_actions2.default.openRightSidePage('search_drawer', { group: props.group }));
    },
    closeRightSidePage: function closeRightSidePage(force) {
      return dispatch(_actions2.default.closeRightSidePage(force));
    },
    closeGroupSettingsPage: function closeGroupSettingsPage() {
      return dispatch(_actions2.default.closeGroupSettingsPage());
    },
    // webでsearch-drawerを開くために必要
    editSearchDrawer: function editSearchDrawer(props) {
      return props.updateUI({ openDrawer: true });
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _socketRsync2.default)('notification'), (0, _uiState2.default)({ state: {
    active: false,
    openAlbum: false,
    openPdf: false,
    openDrawer: false
  } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _context.inject)({ editSearchDrawer: _propTypes2.default.func }));

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupNav = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactNotificationBadge = __webpack_require__(186);

var _reactNotificationBadge2 = _interopRequireDefault(_reactNotificationBadge);

var _groupNav = __webpack_require__(2341);

var _groupNav2 = _interopRequireDefault(_groupNav);

var _app_bar = __webpack_require__(122);

var _button = __webpack_require__(8);

var _menu = __webpack_require__(63);

var _navigation = __webpack_require__(147);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _groupSettingsPage = __webpack_require__(2342);

var _groupSettingsPage2 = _interopRequireDefault(_groupSettingsPage);

var _searchDrawer = __webpack_require__(370);

var _searchDrawer2 = _interopRequireDefault(_searchDrawer);

var _zIndexMenu = __webpack_require__(536);

var _zIndexMenu2 = _interopRequireDefault(_zIndexMenu);

var _noWrappedNavigation = __webpack_require__(371);

var _noWrappedNavigation2 = _interopRequireDefault(_noWrappedNavigation);

var _appBar = __webpack_require__(372);

var _appBar2 = _interopRequireDefault(_appBar);

var _animationCss = __webpack_require__(184);

var _animationCss2 = _interopRequireDefault(_animationCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-nav.jsx

var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);
var TooltipIconMenu = (0, _tooltip2.default)(_menu.IconMenu);

var GroupNav = function (_React$Component) {
  _inherits(GroupNav, _React$Component);

  function GroupNav() {
    _classCallCheck(this, GroupNav);

    return _possibleConstructorReturn(this, (GroupNav.__proto__ || Object.getPrototypeOf(GroupNav)).apply(this, arguments));
  }

  _createClass(GroupNav, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.title = this.props.notificationUnreadCount > 0 ? '(' + this.props.notificationUnreadCount + ') ' + this.props.group.name + ' - gamba!' : this.props.group.name + ' - gamba!';
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.group && prevProps.group && this.props.group.group_id != prevProps.group.group_id || this.props.group && !prevProps.group || this.props.notificationUnreadCount != prevProps.notificationUnreadCount) document.title = this.props.notificationUnreadCount > 0 ? '(' + this.props.notificationUnreadCount + ') ' + this.props.group.name + ' - gamba!' : this.props.group.name + ' - gamba!';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          group = _props.group,
          user = _props.user,
          onLeftIconClick = _props.onLeftIconClick,
          isPhone = _props.isPhone,
          notificationUnreadCount = _props.notificationUnreadCount,
          showNotifications = _props.showNotifications,
          showChatRooms = _props.showChatRooms,
          chatUnreadCount = _props.chatUnreadCount,
          openGroupSettingsPage = _props.openGroupSettingsPage,
          openMembersPage = _props.openMembersPage,
          openDashboardPage = _props.openDashboardPage,
          openReportStatusPage = _props.openReportStatusPage,
          openKPIPage = _props.openKPIPage,
          openAlbum = _props.openAlbum,
          toggleFavorite = _props.toggleFavorite,
          updateUI = _props.updateUI,
          blinkChatButton = _props.blinkChatButton,
          openSearchDrawer = _props.openSearchDrawer,
          openDrawer = _props.openDrawer;


      return _react2.default.createElement(
        _app_bar.AppBar,
        { leftIcon: isPhone && 'menu' || '',
          onLeftIconClick: onLeftIconClick,
          theme: _appBar2.default },
        _react2.default.createElement(
          'div',
          { className: _appBar2.default.header, style: { marginRight: 'auto', whiteSpace: 'nowrap', overflow: 'hidden', cursor: group.is_admin ? 'pointer' : undefined },
            onClick: group.is_admin ? openGroupSettingsPage : undefined },
          !isPhone && _react2.default.createElement(
            'div',
            { style: { display: 'inline' } },
            _react2.default.createElement(_avatar2.default, { image: group.icon_image.thumb_url }),
            '\xA0'
          ),
          _react2.default.createElement(
            'b',
            null,
            group.name
          )
        ),
        _react2.default.createElement(
          _navigation.Navigation,
          { type: 'horizontal', theme: _noWrappedNavigation2.default },
          _react2.default.createElement(_reactNotificationBadge2.default, { count: notificationUnreadCount,
            containerStyle: { position: 'absolute', top: '10px', right: '50px' },
            effect: _reactNotificationBadge.Effect.SCALE }),
          _react2.default.createElement(_reactNotificationBadge2.default, { count: chatUnreadCount,
            containerStyle: { position: 'absolute', top: '10px', right: '0px' },
            effect: _reactNotificationBadge.Effect.SCALE }),
          _react2.default.createElement(TooltipIconButton, { inverse: !isPhone,
            tooltip: t('label:検索'),
            icon: 'search',
            onClick: openSearchDrawer }),
          _react2.default.createElement(
            TooltipIconMenu,
            { inverse: !isPhone, tooltip: t('label:メニュー'), icon: 'more_vert', theme: _zIndexMenu2.default },
            _react2.default.createElement(_menu.MenuItem, { icon: 'people', caption: t('label:メンバー'), onClick: openMembersPage }),
            _react2.default.createElement(_menu.MenuItem, { icon: 'check_box', caption: t('label:日報提出状況'), onClick: openReportStatusPage }),
            _react2.default.createElement(_menu.MenuItem, { icon: 'insert_chart', caption: t('label:KPI進捗状況'), onClick: openKPIPage }),
            _react2.default.createElement(_menu.MenuItem, { icon: 'photo_library', caption: t('label:アルバム'), onClick: openAlbum }),
            _react2.default.createElement(_menu.MenuItem, { icon: 'insights', caption: t('label:インサイト'), onClick: openDashboardPage }),
            !group.is_member && _react2.default.createElement(_menu.MenuItem, { icon: group.favorite && 'outlined_flag' || 'flag',
              onClick: toggleFavorite,
              caption: group.favorite && t('label:お気に入りから削除') || t('label:お気に入りに追加') }),
            group.is_admin && _react2.default.createElement(_menu.MenuItem, { icon: 'settings', caption: t('label:グループ設定'), onClick: openGroupSettingsPage })
          ),
          _react2.default.createElement(TooltipIconButton, { inverse: !isPhone,
            tooltip: t('label:新着の通知'),
            icon: 'notifications' + (!notificationUnreadCount && '_none' || ''),
            onClick: showNotifications }),
          _react2.default.createElement(TooltipIconButton, _extends({ inverse: !isPhone
          }, (0, _animationCss2.default)(blinkChatButton), {
            tooltip: t('label:チャット'),
            icon: 'comment',
            onClick: showChatRooms })),
          group.is_admin && _react2.default.createElement(_groupSettingsPage2.default, { group: group, user: user }),
          _react2.default.createElement(_searchDrawer2.default, { group: group, active: openDrawer, onClose: openSearchDrawer })
        )
      );
    }
  }]);

  return GroupNav;
}(_react2.default.Component);

var RawGroupNav = exports.RawGroupNav = GroupNav;
exports.default = (0, _groupNav2.default)(GroupNav);

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/group-nav.js

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var unreadCount = state.notifications.unreadCount;

  return {
    isPhone: state.media.isPhone,
    user: state.user.current,
    notificationUnreadCount: unreadCount && unreadCount[ownProps.group.group_id],
    chatUnreadCount: state.chatRooms.unreadCount,
    announce: !state.announce.close,
    firstLogin: state.user.firstLogin,
    productTour: state.productTour.state
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, stateProps, dispatchProps, ownProps, {
    blinkChatButton: stateProps.firstLogin && (!stateProps.productTour || stateProps.productTour.chatRoom != 'hide')
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var params = {
    group_id: ownProps.group.group_id,
    group: ownProps.group
  };
  return {
    onLeftIconClick: function onLeftIconClick() {
      return dispatch(_actions2.default.openSidebar());
    },
    showNotifications: function showNotifications() {
      return dispatch(_actions2.default.openRightSidePage('notifications', params));
    },
    showChatRooms: function showChatRooms() {
      return dispatch(_actions2.default.openRightSidePage('chat_rooms', {}));
    },
    openGroupSettingsPage: function openGroupSettingsPage() {
      return dispatch(_actions2.default.openGroupSettingsPage());
    },
    openGroupDetailsPage: function openGroupDetailsPage() {
      return dispatch(_actions2.default.openRightSidePage('group_details', params));
    },
    openMembersPage: function openMembersPage() {
      return dispatch(_actions2.default.openRightSidePage('group_members', params));
    },
    openDashboardPage: function openDashboardPage() {
      return dispatch(_actions2.default.openRightSidePage('dashboard', params));
    },
    openReportStatusPage: function openReportStatusPage() {
      return dispatch(_actions2.default.openRightSidePage('report_status', params));
    },
    openKPIPage: function openKPIPage() {
      dispatch(_actions2.default.openRightSidePage('kpi_page', params));
      dispatch(_actions2.default.clearClosedKpis());
    },
    toggleFavorite: function toggleFavorite() {
      dispatch(_actions2.default.updateFavoriteGroup(ownProps.group.group_id, !ownProps.group.favorite));
      if (!ownProps.group.favorite) dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:お気に入りグループに追加しました', name: ownProps.group.name }, 'success'));else dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:お気に入りグループから削除しました', name: ownProps.group.name }, 'success'));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: { searchDrawer: false } }), (0, _reactI18next.translate)(), _lifecycle2.default);

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RawGroupSettingsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupSettingsPage = __webpack_require__(2343);

var _groupSettingsPage2 = _interopRequireDefault(_groupSettingsPage);

var _settingsPage = __webpack_require__(268);

var _groupFormPanel = __webpack_require__(912);

var _groupFormPanel2 = _interopRequireDefault(_groupFormPanel);

var _groupMembersPanel = __webpack_require__(2344);

var _groupMembersPanel2 = _interopRequireDefault(_groupMembersPanel);

var _groupTemplatesPanel = __webpack_require__(2350);

var _groupTemplatesPanel2 = _interopRequireDefault(_groupTemplatesPanel);

var _templateFormPanel = __webpack_require__(967);

var _templateFormPanel2 = _interopRequireDefault(_templateFormPanel);

var _groupKpiPanel = __webpack_require__(2352);

var _groupKpiPanel2 = _interopRequireDefault(_groupKpiPanel);

var _kpiFormPanel = __webpack_require__(2355);

var _kpiFormPanel2 = _interopRequireDefault(_kpiFormPanel);

var _groupExportPanel = __webpack_require__(2363);

var _groupExportPanel2 = _interopRequireDefault(_groupExportPanel);

var _groupRemindPanel = __webpack_require__(2366);

var _groupRemindPanel2 = _interopRequireDefault(_groupRemindPanel);

var _groupReportPanel = __webpack_require__(2368);

var _groupReportPanel2 = _interopRequireDefault(_groupReportPanel);

var _groupDeletePage = __webpack_require__(2370);

var _groupDeletePage2 = _interopRequireDefault(_groupDeletePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-settings-page.jsx

var GroupSettingsPage = function (_React$Component) {
    _inherits(GroupSettingsPage, _React$Component);

    function GroupSettingsPage() {
        _classCallCheck(this, GroupSettingsPage);

        return _possibleConstructorReturn(this, (GroupSettingsPage.__proto__ || Object.getPrototypeOf(GroupSettingsPage)).apply(this, arguments));
    }

    _createClass(GroupSettingsPage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                t = _props.t,
                user = _props.user,
                group = _props.group,
                active = _props.active,
                onClose = _props.onClose,
                name = _props.name;


            return _react2.default.createElement(
                _settingsPage.SettingsPage,
                { title: t('label:グループ設定'),
                    active: active,
                    onCloseDialog: onClose,
                    name: name,
                    initialName: 'members' },
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'profile',
                    params: { group: group },
                    label: t('label:基本設定'),
                    icon: 'group_work',
                    component: _groupFormPanel2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'members',
                    params: { group: group },
                    label: t('label:メンバー管理'),
                    icon: 'people',
                    component: _groupMembersPanel2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'remind',
                    params: { group: group },
                    label: t('label:リマインド通知'),
                    icon: 'alarm',
                    component: _groupRemindPanel2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'report',
                    params: { group: group },
                    label: t('label:レポート'),
                    icon: 'event_note',
                    component: _groupReportPanel2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'templates',
                    params: { group: group },
                    label: t('label:共通テンプレート'),
                    icon: 'edit',
                    component: _groupTemplatesPanel2.default,
                    subPanel: {
                        new: { component: _templateFormPanel2.default, label: t('label:新規作成') },
                        edit: { component: _templateFormPanel2.default, label: t('label:編集') }
                    } }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'kpi',
                    params: { group: group },
                    label: t('label:KPI設定'),
                    icon: 'insert_chart',
                    component: _groupKpiPanel2.default,
                    subPanel: {
                        new: { component: _kpiFormPanel2.default, label: t('label:新規作成') },
                        edit: { component: _kpiFormPanel2.default, label: t('label:編集') }
                    } }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'export',
                    params: { group: group, user: user },
                    label: t('label:エクスポート'),
                    icon: 'cloud_download',
                    component: _groupExportPanel2.default }),
                _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'delete',
                    params: { group: group, user: user },
                    label: t('label:ごみ箱に移動'),
                    icon: 'delete',
                    component: _groupDeletePage2.default })
            );
        }
    }]);

    return GroupSettingsPage;
}(_react2.default.Component);

var RawGroupSettingsPage = exports.RawGroupSettingsPage = GroupSettingsPage;
exports.default = (0, _groupSettingsPage2.default)(GroupSettingsPage);

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var group = ownProps.group && (0, _store.getArray)('group_id', state.groups.items, ownProps.group.group_id) || undefined;

  return {
    group: group,
    name: state.groupSettings.name,
    active: state.groupSettings.active
  };
};
// src/connects/group-settings-page.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch(_actions2.default.closeGroupSettingsPage());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupMembersPanel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupMembersPanel = __webpack_require__(2345);

var _groupMembersPanel2 = _interopRequireDefault(_groupMembersPanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _list = __webpack_require__(25);

var _menu = __webpack_require__(63);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _switch = __webpack_require__(227);

var _switch2 = _interopRequireDefault(_switch);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _guideMessage = __webpack_require__(533);

var _guideMessage2 = _interopRequireDefault(_guideMessage);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _lightButton = __webpack_require__(369);

var _lightButton2 = _interopRequireDefault(_lightButton);

var _sortable = __webpack_require__(278);

var _sortable2 = _interopRequireDefault(_sortable);

var _groupMembersSorting = __webpack_require__(534);

var _groupMembersSorting2 = _interopRequireDefault(_groupMembersSorting);

var _reactSortableHoc = __webpack_require__(231);

var _analytics = __webpack_require__(27);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-members-panel.jsx

function AdminMenu(props) {
  var disabled = props.disabled,
      member = props.member,
      updateGroupMembership = props.updateGroupMembership;

  return _react2.default.createElement(
    'div',
    { style: { width: 150, height: 52, right: 0, paddingTop: 15 } },
    _react2.default.createElement(_switch2.default, {
      checked: member.is_admin,
      disabled: disabled,
      onChange: function onChange(value) {
        return updateGroupMembership(props, member, value ? 'admin' : 'member');
      } })
  );
}

var SortableListItem = (0, _reactSortableHoc.SortableElement)(_list.ListItem);

var GroupMemberList = function (_React$Component) {
  _inherits(GroupMemberList, _React$Component);

  function GroupMemberList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GroupMemberList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupMemberList.__proto__ || Object.getPrototypeOf(GroupMemberList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GroupMemberList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          group = _props.group,
          user = _props.user,
          sorting = _props.sorting,
          selectSorting = _props.selectSorting,
          isMembershipUpdating = _props.isMembershipUpdating,
          addGroupMembership = _props.addGroupMembership,
          updateGroupMembership = _props.updateGroupMembership,
          showUserSelectionDialog = _props.showUserSelectionDialog,
          usersAdminUrl = _props.usersAdminUrl,
          usersAccountUrl = _props.usersAccountUrl;


      if (!group.members || group.members.length == 0) return null;

      return _react2.default.createElement(
        'div',
        { style: { cursor: sorting && 'move' || 'inherit' } },
        _react2.default.createElement(
          'div',
          { key: 'title', className: _flatCard2.default.labelContainer },
          _react2.default.createElement(
            'div',
            { key: 'membership', className: _flatCard2.default.adminLabel },
            t('label:管理者')
          )
        ),
        _react2.default.createElement(
          _list.List,
          null,
          _lodash2.default.map(group.members, function (member, i) {
            return _react2.default.createElement(SortableListItem, { key: member.user_id, selectable: false, ripple: false, index: i,
              theme: _groupMembersSorting2.default,
              className: selectSorting ? 'active_sorting' : '',
              disabled: !sorting,
              avatar: member.icon_image.thumb_url,
              caption: member.name,
              rightActions: _lodash2.default.filter([_react2.default.createElement(AdminMenu, { key: 'admin_menu', t: t, disabled: user.user_id == member.user_id, group: group, member: member, isMembershipUpdating: isMembershipUpdating, updateGroupMembership: updateGroupMembership }), _react2.default.createElement(_button.IconButton, { key: 'remove', icon: 'close', disabled: user.user_id == member.user_id, onClick: function onClick() {
                  return _this2.setState(_defineProperty({}, 'deleteConfirm' + member.user_id, true));
                } }), _react2.default.createElement(_confirmDialog2.default, { key: 'remove_dialog',
                title: t('label:ユーザを削除してもいいですか', { name: member.name }),
                description: t('label:ユーザを削除しても過去の投稿は閲覧することができます'),
                open: _this2.state['deleteConfirm' + member.user_id],
                yesLabel: t('label:外す'),
                noLabel: t('label:取り消し'),
                onYes: function onYes() {
                  _this2.setState(_defineProperty({}, 'deleteConfirm' + member.user_id, false));
                  updateGroupMembership(_this2.props, member, 'delete');
                  updateUI({ active: true });
                },
                onNo: function onNo() {
                  return _this2.setState(_defineProperty({}, 'deleteConfirm' + member.user_id, false));
                } })], function (item) {
                return item;
              }) });
          })
        ),
        user && user.account_admin && _react2.default.createElement(_confirmDialog2.default, { key: 'delete_user_dialog',
          title: t('label:アカウント管理画面から操作'),
          open: ui.active,
          onYes: function onYes() {
            return updateUI({ active: false });
          },
          onNo: function onNo() {
            return updateUI({ active: false });
          },
          yesHref: usersAccountUrl,
          yesLabel: t('label:アカウント管理画面へ'),
          noLabel: t('label:閉じる') })
      );
    }
  }]);

  return GroupMemberList;
}(_react2.default.Component);

var SortableGroupMemberList = (0, _reactSortableHoc.SortableContainer)(GroupMemberList);

var GroupMembersPanel = function (_React$Component2) {
  _inherits(GroupMembersPanel, _React$Component2);

  function GroupMembersPanel() {
    var _ref2;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, GroupMembersPanel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = GroupMembersPanel.__proto__ || Object.getPrototypeOf(GroupMembersPanel)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = { selectSorting: false }, _this3.openURL = function () {
      return (0, _analytics.track)('invite_users');
    }, _this3.showUserSelectionDialog = function () {
      _this3.props.showUserSelectionDialog(_this3.props.t('label:ユーザを選択'), true, 'OTHER_MEMBERS', _this3.props.group && _this3.props.group, undefined, function (users) {
        return _this3.props.addGroupMembership(_this3.props, users);
      });
      (0, _analytics.track)('group_members_add');
    }, _this3.onSortEnd = function (index) {
      _this3.setState({ sorting: false });
      _this3.props.sortGroupMembers(_this3.props, (0, _reactSortableHoc.arrayMove)(_this3.props.group.members.map(function (item) {
        return item.user_id;
      }), index.oldIndex, index.newIndex));
    }, _this3.startSorting = function () {
      _this3.setState({ sorting: !_this3.state.sorting });
      !_this3.state.sorting && _this3.props.startSorting();
    }, _this3.onSortStart = function () {
      _this3.setState({ selectSorting: !_this3.state.selectSorting });
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(GroupMembersPanel, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          group = _props2.group,
          user = _props2.user,
          isMembershipUpdating = _props2.isMembershipUpdating,
          addGroupMembership = _props2.addGroupMembership,
          updateGroupMembership = _props2.updateGroupMembership,
          showUserSelectionDialog = _props2.showUserSelectionDialog,
          startSorting = _props2.startSorting,
          usersAdminUrl = _props2.usersAdminUrl,
          hasMembers = _props2.hasMembers,
          firstLogin = _props2.firstLogin,
          otherMembers = _props2.otherMembers;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardActions,
          null,
          user && user.account_admin && _react2.default.createElement(_button.Button, { raised: true, primary: true,
            icon: 'add',
            label: t('label:新規ユーザを招待'),
            onClick: this.openURL,
            href: usersAdminUrl,
            target: '_blank',
            rel: 'noopener noreferrer' }),
          otherMembers && _react2.default.createElement(_button.Button, { raised: true, theme: _successButton2.default,
            icon: 'add',
            label: t('label:既存ユーザを追加'),
            onClick: this.showUserSelectionDialog }),
          _react2.default.createElement(_button.Button, { raised: this.state.sorting,
            theme: _lightButton2.default,
            icon: 'sort',
            label: t('label:並べ替え'),
            onClick: this.startSorting })
        ),
        user && user.account_admin && firstLogin && !hasMembers && _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(_guideMessage2.default, { showMessage: true,
            message: t('label:ここをクリックして招待してみよう') })
        ),
        _react2.default.createElement(
          _card.CardText,
          null,
          (!group.members || group.members.length == 0) && _react2.default.createElement(
            _list.List,
            null,
            _react2.default.createElement(_list.ListItem, { caption: t('label:メンバーは登録されていません') })
          ),
          _react2.default.createElement(SortableGroupMemberList, _extends({}, this.props, {
            onSortEnd: this.onSortEnd,
            onSortStart: this.onSortStart,
            helperClass: _sortable2.default.sortable,
            sorting: this.state.sorting,
            selectSorting: this.state.selectSorting }))
        )
      );
    }
  }]);

  return GroupMembersPanel;
}(_react2.default.Component);

var RawGroupMembersPanel = exports.RawGroupMembersPanel = GroupMembersPanel;
exports.default = (0, _groupMembersPanel2.default)(GroupMembersPanel);

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeProps = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    group: (0, _store.getArray)('group_id', state.groups.items, ownProps.group.group_id),
    user: state.user.current,
    isMembershipUpdating: state.groups.isMembershipUpdating,
    isMembershipUpdateFailed: state.groups.isMembershipUpdateFailed,
    access_token: state.sessions.access_token,
    firstLogin: state.user.firstLogin,
    hasMembers: state.account.hasMembers,
    otherMembers: state.accountOtherMembersCount.otherMembers
  };
};
// src/connects/group-members-panel.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount(props) {
      dispatch(_actions2.default.fetchOtherMembersCount(props.group.group_id));
      dispatch(_actions2.default.fetchAccountOtherMembersCount(props.group.group_id));
      if (!props.productTour || props.productTour.openGroupMemberPanel != 'hide') {
        dispatch(_actions2.default.hideProductTour('openGroupMemberPanel'));
      }
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (!nextProps.hasMembers) {
        dispatch(_actions2.default.fetchAccountOtherMembersCount(nextProps.group.group_id));
      }
    },

    addGroupMembership: function addGroupMembership(props, users) {
      var userNames = (0, _map2.default)(users, function (user) {
        dispatch(_actions2.default.updateGroupMembership(props.group.group_id, user.user_id, 'member'));
        return user.name;
      }).join(', ');
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:ユーザを追加しました', name: userNames }, 'success'));
    },

    updateGroupMembership: function updateGroupMembership(props, user, membership) {
      if (membership == 'delete') dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:グループからユーザを削除しました', name: user.name }, 'success'));else if (membership == 'admin') dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:グループの管理権限を付与しました', name: user.name }, 'success'));else if (membership == 'member') dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:グループの管理権限を削除しました', name: user.name }, 'success'));
      dispatch(_actions2.default.updateGroupMembership(props.group.group_id, user.user_id, membership));
    },

    updateRemindMailSetting: function updateRemindMailSetting(props, user, delivery) {
      dispatch(_actions2.default.updateRemindMailSetting(props.group.group_id, user.user_id, delivery));
      if (delivery) dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:ユーザへのリマインドメールの送信を開始します', name: user.name }, 'success'));else dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:ユーザへのリマインドメールの送信を停止しました', name: user.name }, 'success'));
    },

    sortGroupMembers: function sortGroupMembers(props, sort) {
      dispatch(_actions2.default.sortGroupMembers(props.group.group_id, sort));
    },

    startSorting: function startSorting() {
      dispatch((0, _alertMessage.emitAlertMessage)('label:ドラッグして並べ替え', 'success'));
    }
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    usersAdminUrl: _config2.default.baseUrl + 'v3/session/redirect?login=true&redirect_to=/v3/users/new?group_id=' + ownProps.group.group_id + '&access_token=' + stateProps.access_token,
    usersAccountUrl: _config2.default.baseUrl + 'v3/session/redirect?login=true&redirect_to=/v3/users&access_token=' + stateProps.access_token
  });
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: {
    active: false
  } }), (0, _context2.default)({ showUserSelectionDialog: _propTypes2.default.func }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('group_members'));

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2347);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./guide-message.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./guide-message.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.guide-message--message--3xHFbxfp {\n  display: inline-block;\n  background: #FFFFA0;\n  color: #111;\n  padding: 4px 15px;\n  margin: 0;\n  border-radius: 5px;\n  position: relative;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.guide-message--message--3xHFbxfp:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  top: -6px;\n  left: 30px;\n  width: 0px;\n  border: 9px solid transparent;\n  border-bottom-color: red;\n  border-top-width: 0;\n}\n\n.guide-message--diaryGuidance--3yR3fq8q {\n  display: inline-block;\n  background: #FFFFA0;\n  color: #111;\n  padding: 4px 15px;\n  margin: 0;\n  border-radius: 5px;\n  position: relative;\n  font-size: 12px;\n  font-style: italic;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  left: 50%;\n}\n\n.guide-message--diaryGuidance--3yR3fq8q:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  top: -6px;\n  left: 30px;\n  width: 0px;\n  border: 9px solid transparent;\n  border-bottom-color: red;\n  border-top-width: 0;\n  left: 50%;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/guide-message.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;CACpB;;AAED;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,yBAAyB;EACzB,oBAAoB;CACrB;;AAED;EACE,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;UAC5B,4BAA4B;EACpC,UAAU;CACX;;AAED;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;CACX","file":"guide-message.css","sourcesContent":["\n.message {\n  display: inline-block;\n  background: #FFFFA0;\n  color: #111;\n  padding: 4px 15px;\n  margin: 0;\n  border-radius: 5px;\n  position: relative;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.message:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  top: -6px;\n  left: 30px;\n  width: 0px;\n  border: 9px solid transparent;\n  border-bottom-color: red;\n  border-top-width: 0;\n}\n\n.diaryGuidance {\n  display: inline-block;\n  background: #FFFFA0;\n  color: #111;\n  padding: 4px 15px;\n  margin: 0;\n  border-radius: 5px;\n  position: relative;\n  font-size: 12px;\n  font-style: italic;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  left: 50%;\n}\n\n.diaryGuidance:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  top: -6px;\n  left: 30px;\n  width: 0px;\n  border: 9px solid transparent;\n  border-bottom-color: red;\n  border-top-width: 0;\n  left: 50%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"message": "guide-message--message--3xHFbxfp",
	"diaryGuidance": "guide-message--diaryGuidance--3yR3fq8q"
};

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.light-button--button--2OC6DGc-[class*=raised] {\n  background-color: #666!important;\n  color: #FFF!important;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/light-button.css"],"names":[],"mappings":";AACA;EACE,iCAAiC;EACjC,sBAAsB;CACvB","file":"light-button.css","sourcesContent":["\n.button[class*=raised] {\n  background-color: #666!important;\n  color: #FFF!important;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"button": "light-button--button--2OC6DGc-"
};

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.group-members-sorting--listItem--WIjdPN4f[class~=active_sorting]{\n    background-color:  #FFF!important;\n}\n\n.group-members-sorting--listItem--WIjdPN4f:hover {\n    background-color:  #f3f0f0;\n}\n\n/*並べ替え時のドラッグ要素スタイル*/\n\nbody > .group-members-sorting--listItem--WIjdPN4f {\n    background-color:  #f3f0f0;\n}\n\n.group-members-sorting--listItem--WIjdPN4f[class~=text_ellipsis] .group-members-sorting--itemContentRoot--28YR3HfK{\n    overflow: hidden;\n    pointer-events: none;\n}\n\n.group-members-sorting--listItem--WIjdPN4f[class~=text_ellipsis] .group-members-sorting--itemText--Sjx7YWPZ{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n[class~=private_access] .group-members-sorting--itemAction--3JqFsOnO::after {\n    position: absolute;\n    font-family: 'Material Icons';\n    font-weight: normal;\n    font-style: normal;\n    content: 'vpn_key';\n    color: #757575;\n    background-color: #FFF;\n    border-radius: 80%;\n    text-shadow: 5px 5px 10px #FFF;\n    top: 25px;\n    left: 46px;\n    padding: 3px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/group-members-sorting.css"],"names":[],"mappings":";AACA;IACI,kCAAkC;CACrC;;AAED;IACI,2BAA2B;CAC9B;;AAED,oBAAoB;;AAEpB;IACI,2BAA2B;CAC9B;;AAED;IACI,iBAAiB;IACjB,qBAAqB;CACxB;;AAED;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;CAC3B;;AAED;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,UAAU;IACV,WAAW;IACX,aAAa;CAChB","file":"group-members-sorting.css","sourcesContent":["\n.listItem[class~=active_sorting]{\n    background-color:  #FFF!important;\n}\n\n.listItem:hover {\n    background-color:  #f3f0f0;\n}\n\n/*並べ替え時のドラッグ要素スタイル*/\n\nbody > .listItem {\n    background-color:  #f3f0f0;\n}\n\n.listItem[class~=text_ellipsis] .itemContentRoot{\n    overflow: hidden;\n    pointer-events: none;\n}\n\n.listItem[class~=text_ellipsis] .itemText{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n[class~=private_access] .itemAction::after {\n    position: absolute;\n    font-family: 'Material Icons';\n    font-weight: normal;\n    font-style: normal;\n    content: 'vpn_key';\n    color: #757575;\n    background-color: #FFF;\n    border-radius: 80%;\n    text-shadow: 5px 5px 10px #FFF;\n    top: 25px;\n    left: 46px;\n    padding: 3px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listItem": "group-members-sorting--listItem--WIjdPN4f",
	"itemContentRoot": "group-members-sorting--itemContentRoot--28YR3HfK",
	"itemText": "group-members-sorting--itemText--Sjx7YWPZ",
	"itemAction": "group-members-sorting--itemAction--3JqFsOnO"
};

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templatesPanel = __webpack_require__(937);

var _templatesPanel2 = _interopRequireDefault(_templatesPanel);

var _groupTemplatesPanel = __webpack_require__(2351);

var _groupTemplatesPanel2 = _interopRequireDefault(_groupTemplatesPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/web/components/group-templates-panel.jsx

exports.default = (0, _groupTemplatesPanel2.default)(_templatesPanel2.default);

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/group-templates-panel.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    templates: state.templates.items,
    isFetching: state.templates.isFetching
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    editTemplate: function editTemplate(props, template_id) {
      return ownProps.selectPanel('templates', 'edit', { template_id: template_id });
    },
    newTemplate: function newTemplate(props) {
      var cloneTemplate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return ownProps.selectPanel('templates', 'new', { template_id: undefined, type: 'group', id: props.group.group_id, cloneTemplate: cloneTemplate });
    },
    deleteTemplate: function deleteTemplate(template) {
      dispatch(_actions2.default.deleteTemplate(template.template_id));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: "label:テンプレートを削除しました", name: template.name }, "success"));
    },
    willMount: function willMount(props) {
      return dispatch(_actions2.default.fetchTemplates(props.group.group_id, 'group'));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('group_templates'), (0, _analytics.trackHandlers)('editTemplate', 'group_template_edit'), (0, _analytics.trackHandlers)('newTemplate', 'group_template_new'));

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _kpiPanel = __webpack_require__(2353);

var _kpiPanel2 = _interopRequireDefault(_kpiPanel);

var _groupKpiPanel = __webpack_require__(2354);

var _groupKpiPanel2 = _interopRequireDefault(_groupKpiPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/web/components/group-kpi-panel.jsx

exports.default = (0, _groupKpiPanel2.default)(_kpiPanel2.default);

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _menu = __webpack_require__(63);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _list = __webpack_require__(25);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _formatNumber = __webpack_require__(201);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _lightButton = __webpack_require__(369);

var _lightButton2 = _interopRequireDefault(_lightButton);

var _sortable = __webpack_require__(278);

var _sortable2 = _interopRequireDefault(_sortable);

var _groupMembersSorting = __webpack_require__(534);

var _groupMembersSorting2 = _interopRequireDefault(_groupMembersSorting);

var _reactSortableHoc = __webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * src/web/components/kpi-panel.jsx
 * グループ設定のKPI設定ページ
 */

function formatKpi(kpi, t) {
  var assignedMembers;
  if (kpi.assignments.length == 0) assignedMembers = t('label:割り当てられていません');else assignedMembers = kpi.assignments.slice(0, 3).map(function (assignment) {
    return assignment.name;
  }).join(',');
  if (kpi.assignments.length > 3) assignedMembers += '... ' + t('label:他n人', { n: kpi.assignments.length - 3 });

  var dateRange = (0, _moment2.default)(kpi.start_date).format('llll') + ' - ' + (0, _moment2.default)(kpi.end_date).format('llll');
  var targetNum = (0, _formatNumber.formatNumber)(kpi.target, kpi.display_format);

  return dateRange + ', ' + t('label:目標値', { value: targetNum }) + ', ' + t('label:担当者', { assignments: assignedMembers });
}

var _KPIListItem = function (_React$Component) {
  _inherits(_KPIListItem, _React$Component);

  function _KPIListItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _KPIListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _KPIListItem.__proto__ || Object.getPrototypeOf(_KPIListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = { showMenu: false, kpiSelect: false }, _this.onSelectKpi = function (kpi) {
      _this.setState({ kpiSelect: true });
      _this.props.pushKpi(_this.props, kpi);
    }, _this.onExclusionKpi = function (kpi) {
      _this.setState({ kpiSelect: false });
      _this.props.exclusionKpi(_this.props, kpi);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(_KPIListItem, [{
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps) {
      if (this.props.ui.onCheck != nextProps.ui.onCheck) {
        this.setState({ kpiSelect: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          kpi = _props.kpi,
          newKpi = _props.newKpi,
          editKpi = _props.editKpi,
          downloadUrl = _props.downloadUrl,
          deleteKpi = _props.deleteKpi,
          isFetching = _props.isFetching,
          onCheck = _props.onCheck,
          pushKpi = _props.pushKpi,
          exclusionKpi = _props.exclusionKpi,
          updateUI = _props.updateUI;


      return _react2.default.createElement(_list.ListItem, { key: kpi.kpi_id, selectable: true, ripple: true,
        theme: _groupMembersSorting2.default,
        className: 'text_ellipsis',
        leftIcon: this.props.ui.onCheck ? _react2.default.createElement(_checkbox2.default, { checked: this.state.kpiSelect, onChange: function onChange() {
            return _this2.props.ui.checkKpi && _this2.props.ui.checkKpi.find(function (v) {
              return v.kpi_id == kpi.kpi_id;
            }) ? _this2.onExclusionKpi(kpi) : _this2.onSelectKpi(kpi);
          } }) : "insert_chart",
        caption: kpi.name,
        legend: formatKpi(kpi, t),
        onClick: !this.props.ui.onCheck ? function () {
          return editKpi(_this2.props, kpi.kpi_id);
        } : null,
        rightActions: !this.props.ui.onCheck && [_react2.default.createElement(
          _menu.IconMenu,
          { key: 'menu', icon: 'more_vert', onClick: function onClick() {
              return _this2.setState({ showMenu: true });
            } },
          _react2.default.createElement(_menu.MenuItem, { disabled: isFetching,
            icon: 'content_copy',
            onClick: function onClick() {
              return newKpi(_this2.props, kpi, false);
            },
            caption: t('label:コピーして新規作成') }),
          _react2.default.createElement(_menu.MenuItem, { disabled: isFetching,
            icon: 'content_copy',
            onClick: function onClick() {
              return newKpi(_this2.props, kpi, true);
            },
            caption: t('label:コピーして翌期分を作成') }),
          _react2.default.createElement(_menu.MenuItem, { disabled: isFetching,
            icon: 'delete_forever',
            onClick: function onClick() {
              return _this2.setState({ deleteConfirm: true });
            },
            caption: t('label:データごと削除') })
        ), _react2.default.createElement(_confirmDialog2.default, { key: 'dialog',
          title: t('label:KPIを削除してもいいですか', { name: kpi.name }),
          description: t('label:この操作は取り消せません'),
          open: this.state.deleteConfirm,
          yesLabel: t('label:削除'),
          noLabel: t('label:取り消し'),
          onYes: function onYes() {
            _this2.setState({ deleteConfirm: false });deleteKpi(kpi);
          },
          onNo: function onNo() {
            return _this2.setState({ deleteConfirm: false });
          } })] });
    }
  }]);

  return _KPIListItem;
}(_react2.default.Component);

var RawKPIListItem = _KPIListItem;
var KPIListItem = (0, _reactSortableHoc.SortableElement)(_KPIListItem);

var SortableKPIList = (0, _reactSortableHoc.SortableContainer)(function (props) {
  var t = props.t,
      ui = props.ui,
      kpis = props.kpis,
      isFetching = props.isFetching,
      sorting = props.sorting,
      onCheck = props.onCheck,
      pushKpi = props.pushKpi,
      exclusionKpi = props.exclusionKpi,
      updateUI = props.updateUI;


  return _react2.default.createElement(
    'div',
    { style: { cursor: sorting && 'move' || 'inherit' } },
    _react2.default.createElement(
      _list.List,
      { selectable: true },
      _react2.default.createElement(_list.ListItem, { caption: t('label:現在のKPI'), selectable: false, ripple: false }),
      isFetching && (!kpis || kpis.length == 0) && _react2.default.createElement(_loading2.default, null),
      !isFetching && (!kpis || kpis.length == 0) && _react2.default.createElement(_list.ListItem, { caption: t('label:KPIは登録されていません'), selectable: false, ripple: false }),
      kpis && kpis.length > 0 && _lodash2.default.map(kpis, function (kpi, i) {
        return _react2.default.createElement(KPIListItem, _extends({ key: kpi.kpi_id }, props, { kpi: kpi, index: i, disabled: !sorting }));
      })
    )
  );
});

var KPIPanel = function (_React$Component2) {
  _inherits(KPIPanel, _React$Component2);

  function KPIPanel() {
    var _ref2;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, KPIPanel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = KPIPanel.__proto__ || Object.getPrototypeOf(KPIPanel)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = {}, _this3.newKpi = function (props) {
      _this3.props.updateUI({ checkKpi: undefined });
      _this3.props.newKpi(props);
    }, _this3.onSortEnd = function (index) {
      _this3.props.sortKpis(_this3.props, (0, _reactSortableHoc.arrayMove)(_this3.props.kpis.map(function (item) {
        return item.kpi_id;
      }), index.oldIndex, index.newIndex));
    }, _this3.startSorting = function () {
      _this3.setState({ sorting: !_this3.state.sorting });
      !_this3.state.sorting && _this3.props.startSorting();
    }, _this3.finishSort = function () {
      _this3.setState({ sorting: false });
    }, _this3.onCheck = function () {
      _this3.props.updateUI({ onCheck: true });
    }, _this3.onCancel = function () {
      _this3.props.updateUI({ checkKpi: undefined });
      _this3.props.updateUI({ onCheck: false });
    }, _this3.downloadKpi = function (kpi) {
      if (kpi && kpi.length != 0) {
        var kpiList = kpi.map(function (item) {
          return item['kpi_id'];
        });
        window.open(_this3.props.downloadUrl(kpiList));
      } else {
        _this3.props.notKpiMessage();
      }
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(KPIPanel, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          t = _props2.t,
          ui = _props2.ui,
          kpis = _props2.kpis,
          closedKpis = _props2.closedKpis,
          sortKpis = _props2.sortKpis,
          newKpi = _props2.newKpi,
          editKpi = _props2.editKpi,
          deleteKpi = _props2.deleteKpi,
          downloadUrl = _props2.downloadUrl,
          pushKpi = _props2.pushKpi,
          exclusionKpi = _props2.exclusionKpi,
          isFetching = _props2.isFetching,
          hasMoreClosedKpis = _props2.hasMoreClosedKpis,
          updateUI = _props2.updateUI,
          fetchClosedKpis = _props2.fetchClosedKpis,
          startSorting = _props2.startSorting;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(_button.Button, { raised: true, theme: _successButton2.default,
            icon: 'add',
            label: t('label:新規作成'),
            onClick: function onClick() {
              return _this4.newKpi(_this4.props);
            } }),
          !this.props.ui.onCheck && kpis && kpis.length > 1 && _react2.default.createElement(_button.Button, { raised: this.state.sorting,
            theme: _lightButton2.default,
            icon: !this.state.sorting ? 'sort' : 'check',
            label: !this.state.sorting ? t('label:並べ替え') : t('label:並べ替えを終了'),
            onClick: !this.state.sorting ? this.startSorting : this.finishSort })
        ),
        _react2.default.createElement(
          _card.CardActions,
          { style: { marginLeft: 'auto' } },
          this.props.ui.onCheck && _react2.default.createElement(_button.Button, { raised: true, theme: _successButton2.default,
            icon: 'download',
            label: t('label:Excelダウンロード'),
            onClick: function onClick() {
              return _this4.downloadKpi(ui.checkKpi);
            }
          }),
          _react2.default.createElement(_button.Button, { raised: true, primary: true,
            icon: this.props.ui.onCheck ? 'close' : 'add',
            label: this.props.ui.onCheck ? "キャンセル" : "KPIを選択",
            onClick: this.props.ui.onCheck ? this.onCancel : this.onCheck })
        ),
        this.props.ui.onCheck && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_font_icon2.default, { value: 'info', style: { verticalAlign: 'bottom', marginLeft: 30 } }),
          _react2.default.createElement(
            'span',
            { style: { marginLeft: 10 } },
            t('label:KPIを選択してください')
          )
        ),
        this.state.sorting && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_font_icon2.default, { value: 'info', style: { verticalAlign: 'bottom', marginLeft: 30 } }),
          _react2.default.createElement(
            'span',
            { style: { marginLeft: 10 } },
            t('label:並べ替え終了を選択')
          )
        ),
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(SortableKPIList, _extends({}, this.props, {
            sorting: this.state.sorting,
            onSortEnd: this.onSortEnd,
            onCheck: this.props.ui.onCheck,
            pushKpi: pushKpi,
            exclusionKpi: exclusionKpi,
            updateUI: updateUI,
            helperClass: _sortable2.default.sortable })),
          _react2.default.createElement(
            _list.List,
            { selectable: true },
            _react2.default.createElement(_list.ListItem, { caption: t('label:終了したKPI'),
              selectable: true,
              rightIcon: ui.showClosedKpi && "arrow_drop_up" || "arrow_drop_down",
              onClick: function onClick() {
                !ui.showClosedKpi && fetchClosedKpis(_this4.props, true);
                updateUI({ showClosedKpi: !ui.showClosedKpi });
              } }),
            isFetching && kpis && kpis.length > 0 && ui.showClosedKpi && (!closedKpis || closedKpis.length == 0) && _react2.default.createElement(_loading2.default, null),
            !isFetching && ui.showClosedKpi && (!closedKpis || closedKpis.length == 0) && _react2.default.createElement(_list.ListItem, { caption: t('label:KPIは登録されていません'), selectable: false, ripple: false }),
            ui.showClosedKpi && closedKpis && closedKpis.length > 0 && _lodash2.default.map(closedKpis, function (kpi) {
              return _react2.default.createElement(RawKPIListItem, _extends({ key: kpi.kpi_id }, _this4.props, { kpi: kpi, pushKpi: pushKpi, exclusionKpi: exclusionKpi, onCheck: _this4.props.ui.onCheck, disabled: true }));
            }),
            !isFetching && ui.showClosedKpi && closedKpis && closedKpis.length > 0 && hasMoreClosedKpis && _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false, rightActions: [_react2.default.createElement(_button.Button, { flat: true, key: 'more', icon: 'arrow_drop_down',
                label: t('label:続きを表示'),
                onClick: function onClick() {
                  return fetchClosedKpis(_this4.props);
                } })] })
          )
        )
      );
    }
  }]);

  return KPIPanel;
}(_react2.default.Component);

exports.default = KPIPanel;

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeProps = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/group-kpi-panel.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    kpis: state.kpi.items,
    closedKpis: state.kpi.closedItems,
    isFetching: state.kpi.isFetching,
    hasMoreClosedKpis: state.kpi.hasMoreClosedItems,
    access_token: state.sessions.access_token
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchKpis: function fetchKpis(props) {
      return dispatch(_actions2.default.fetchKpis(props.group.group_id));
    },
    sortKpis: function sortKpis(props, sort) {
      return dispatch(_actions2.default.sortKpis(sort, props.group.group_id));
    },
    fetchClosedKpis: function fetchClosedKpis(props) {
      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return dispatch(_actions2.default.fetchClosedKpis(props.group.group_id, refresh ? 0 : props.closedKpis && props.closedKpis.length || 0));
    },
    editKpi: function editKpi(props, kpi_id) {
      return ownProps.selectPanel('kpi', 'edit', { kpi_id: kpi_id });
    },
    newKpi: function newKpi(props) {
      var cloneKpi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var nextPeriod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return ownProps.selectPanel('kpi', 'new', { kpi_id: undefined, type: 'group', id: props.group.group_id, cloneKpi: cloneKpi, nextPeriod: nextPeriod });
    },
    deleteKpi: function deleteKpi(kpi) {
      dispatch(_actions2.default.deleteKpi(kpi.kpi_id));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:KPIを削除しました', name: kpi.name }, 'success'));
    },
    pushKpi: function pushKpi(props, kpi) {
      props.updateUI({ checkKpi: (0, _store.mergeArray)('kpi_id', props.ui.checkKpi, [kpi]) });
    },
    exclusionKpi: function exclusionKpi(props, kpi) {
      props.updateUI({ checkKpi: (0, _store.deleteArray)('kpi_id', props.ui.checkKpi, kpi.kpi_id) });
    },
    notKpiMessage: function notKpiMessage() {
      return dispatch((0, _alertMessage.emitAlertMessage)('label:KPIが選択されていません', 'error'));
    },
    willMount: function willMount(props) {
      return dispatch(_actions2.default.fetchKpis(props.group.group_id));
    },
    willUnmount: function willUnmount(props) {
      return dispatch(_actions2.default.fetchDiaryKpi(props.group.group_id, new Date()));
    },
    startSorting: function startSorting() {
      dispatch((0, _alertMessage.emitAlertMessage)('label:ドラッグして並べ替え', 'success'));
    }
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    downloadUrl: function downloadUrl(kpi_id) {
      return _config2.default.baseUrl + 'v3/export/kpi_status.xlsx?kpi_id=' + kpi_id + '&access_token=' + stateProps.access_token;
    }
  });
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), _lifecycle2.default, (0, _uiState2.default)({ state: { showClosedKpi: false, onCheck: false, checkKpi: undefined } }), (0, _reactI18next.translate)(), (0, _analytics.trackPage)('group_kpi'), (0, _analytics.trackHandlers)('editKpi', 'group_kpi_edit'), (0, _analytics.trackHandlers)('newKpi', 'group_kpi_new'));

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawKPIFormPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _kpiFormPanel = __webpack_require__(2356);

var _kpiFormPanel2 = _interopRequireDefault(_kpiFormPanel);

var _card = __webpack_require__(28);

var _list = __webpack_require__(25);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _button = __webpack_require__(8);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _input = __webpack_require__(59);

var _compactInput = __webpack_require__(178);

var _compactInput2 = _interopRequireDefault(_compactInput);

var _datePicker = __webpack_require__(165);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _menu = __webpack_require__(63);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _formValidator = __webpack_require__(41);

var _reportedDatePicker = __webpack_require__(535);

var _reportedDatePicker2 = _interopRequireDefault(_reportedDatePicker);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _kpiPreview = __webpack_require__(2358);

var _kpiPreview2 = _interopRequireDefault(_kpiPreview);

var _kpiFormPanel3 = __webpack_require__(2361);

var _kpiFormPanel4 = _interopRequireDefault(_kpiFormPanel3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/kpi-form-panel.jsx

var displayFormats = [{ value: '', label: '123456' }, { value: 'separate_1000', label: '123,456' }, { value: 'decimal_1 separate_1000', label: '123,456.0' }, { value: 'decimal_2 separate_1000', label: '123,456.00' }, { value: 'separate_1000 signed', label: '+123,456/-123,456' }, { value: 'decimal_1 separate_1000 signed', label: '+123,456.0/-123,456.0' }, { value: 'decimal_2 separate_1000 signed', label: '+123,456.00/-123,456.00' }];

function accumulationMethods(t) {
  return [{ value: true, label: t('label:実績値を期間内で累計する'), legend: t('label:実績値を期間内で累計の説明') }, { value: false, label: t('label:実績値を日毎に集計する'), legend: t('label:実績値を日毎に集計の説明') }];
}

function prependUnits(t) {
  return [{ value: true, label: t('label:値の前に表示') }, { value: false, label: t('label:値の後に表示') }];
}
var styles = {
  containerPreview: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 16
  }
};

var KPIFormPanel = function (_React$Component) {
  _inherits(KPIFormPanel, _React$Component);

  function KPIFormPanel() {
    _classCallCheck(this, KPIFormPanel);

    return _possibleConstructorReturn(this, (KPIFormPanel.__proto__ || Object.getPrototypeOf(KPIFormPanel)).apply(this, arguments));
  }

  _createClass(KPIFormPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          kpi = _props.kpi,
          isUpdating = _props.isUpdating,
          updateUI = _props.updateUI,
          validateAndSubmit = _props.validateAndSubmit;


      var step = 1;
      if (ui.displayFormat.indexOf('decimal_1') >= 0) step = 0.1;else if (ui.displayFormat.indexOf('decimal_2') >= 0) step = 0.01;else if (ui.displayFormat.indexOf('decimal_3') >= 0) step = 0.001;

      var format = _.find(displayFormats, function (item) {
        return item.value == ui.displayFormat;
      });
      var formatLabel = format && format.label || '123456';

      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return validateAndSubmit(_this2.props, e);
            } },
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:KPI名')
              )
            ),
            _react2.default.createElement(_input.Input, { name: 'name', required: true,
              label: t('label:KPI名の説明'),
              value: ui.name,
              error: ui.nameError && t('error:KPI名を入力してください'),
              onChange: (0, _formValidator.linkUI)(this, 'name') }),
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:開始日'),
                '\xA0/\xA0',
                t('label:終了日')
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', marginBottom: '20px' } },
              _react2.default.createElement(
                'div',
                { style: { flexGrow: 1 } },
                _react2.default.createElement(_datePicker2.default, { label: t('label:開始日'),
                  value: ui.startDate.toDate(),
                  onChange: function onChange(date) {
                    return updateUI({ startDate: (0, _moment2.default)(date) });
                  },
                  color: ui.startDateError ? 'red' : undefined })
              ),
              _react2.default.createElement(
                'div',
                null,
                '\xA0\xA0'
              ),
              _react2.default.createElement(
                'div',
                { style: { flexGrow: 1 } },
                _react2.default.createElement(_datePicker2.default, { label: t('label:終了日'),
                  value: ui.endDate.toDate(),
                  minDate: ui.todayDate.toDate(),
                  onChange: function onChange(date) {
                    return updateUI({ endDate: (0, _moment2.default)(date) });
                  },
                  color: ui.endDateError ? 'red' : undefined })
              )
            ),
            _react2.default.createElement(_checkbox2.default, { key: 'checkbox', label: t('label:翌期分自動作成'),
              checked: ui.generateNextAtDaysTarget,
              onChange: function onChange(value) {
                return updateUI({ generateNextAtDaysTarget: !ui.generateNextAtDaysTarget });
              } }),
            ui.generateNextAtDaysTarget && _react2.default.createElement(
              'div',
              { style: { display: 'flex', marginBottom: '20px' } },
              _react2.default.createElement(
                'div',
                { style: { flexGrow: 1 } },
                _react2.default.createElement(_datePicker2.default, {
                  value: ui.generateNextAtDays.toDate(),
                  onChange: function onChange(date) {
                    return updateUI({ generateNextAtDays: (0, _moment2.default)(date) });
                  },
                  color: ui.generateNextAtDaysError ? 'red' : undefined })
              )
            ),
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:単位')
              )
            ),
            _react2.default.createElement(_input.Input, { name: 'unit', required: true,
              label: t('label:単位の説明'),
              value: ui.unit,
              error: ui.unitError && t('error:単位を入力してください'),
              onChange: (0, _formValidator.linkUI)(this, 'unit') }),
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:単位の表示位置')
              )
            ),
            _react2.default.createElement(_dropdown2.default, { source: prependUnits(t),
              value: ui.prependUnit,
              onChange: function onChange(value) {
                return updateUI({ prependUnit: value });
              } }),
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:表示形式')
              )
            ),
            _react2.default.createElement(_dropdown2.default, { source: displayFormats,
              value: ui.displayFormat,
              onChange: function onChange(value) {
                return updateUI({ displayFormat: value });
              } }),
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:実績値の集計方法')
              )
            ),
            _react2.default.createElement(_dropdown2.default, { source: accumulationMethods(t),
              disabled: kpi,
              template: function template(item) {
                return _react2.default.createElement(
                  'div',
                  { style: { display: 'flex', flexDirection: 'column' } },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      item.label
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { fontSize: '80%' } },
                    item.legend
                  )
                );
              },
              value: ui.accumulatedTotal,
              onChange: function onChange(value) {
                return updateUI({ accumulatedTotal: value });
              } })
          ),
          _react2.default.createElement(
            _card.CardText,
            { style: styles.containerPreview },
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:プレビュー')
              )
            ),
            _react2.default.createElement(_kpiPreview2.default, { ui: ui, t: t, formatLabel: formatLabel, label: ui.displayFormat })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:担当者と目標値の割り当て')
              )
            ),
            _react2.default.createElement(
              _list.List,
              null,
              _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false,
                leftActions: [_react2.default.createElement(_checkbox2.default, { key: 'checkbox', checked: (0, _kpiFormPanel.isAssignAll)(ui.assignments),
                  onChange: function onChange(value) {
                    return updateUI({ assignAll: !(0, _kpiFormPanel.isAssignAll)(ui.assignments), assignments: (0, _kpiFormPanel.assignAll)(ui.assignments, value) });
                  } }), _react2.default.createElement(
                  'div',
                  { key: 'label', style: { marginTop: '-16px' } },
                  t('label:すべて選択')
                )],
                rightActions: [_react2.default.createElement(_checkbox2.default, { key: 'checkbox', checked: ui.assignSameTarget,
                  onChange: function onChange(value) {
                    return updateUI({ assignSameTarget: !ui.assignSameTarget, assignmentAllValue: undefined });
                  } }), _react2.default.createElement(
                  'div',
                  { key: 'text', style: { marginTop: '-16px' } },
                  t('label:同じ値を設定')
                )] }),
              ui.assignSameTarget && _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false,
                rightActions: [_react2.default.createElement(_compactInput2.default, { name: 'target.all',
                  type: 'number',
                  step: step,
                  hint: t('label:目標値を入力'),
                  error: ui.assignmentAllError && t('error:目標値を入力してください'),
                  value: ui.assignmentAllValue,
                  onChange: function onChange(value) {
                    return updateUI({
                      assignments: (0, _kpiFormPanel.assignTargetAll)(ui.assignments, value),
                      assignmentAllValue: value
                    });
                  }
                })] }),
              ui.assignments && _.map(ui.assignments, function (assign, i) {
                return _react2.default.createElement(_list.ListItem, { key: assign.id, selectable: false, ripple: false, theme: _kpiFormPanel4.default, className: !assign.assign && 'checked' || '',
                  leftActions: [_react2.default.createElement(_checkbox2.default, { checked: assign.assign,
                    onChange: function onChange(value) {
                      return updateUI({
                        assignments: Object.assign({}, ui.assignments, _defineProperty({}, i, Object.assign({}, assign, { assign: value }))) });
                    },
                    name: 'assign.' + assign.id,
                    key: 'checkbox' })],
                  itemContent: _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', width: '100%' } },
                    _react2.default.createElement(
                      'div',
                      null,
                      assign.name
                    ),
                    _react2.default.createElement(
                      'div',
                      { style: { marginLeft: 'auto' } },
                      _react2.default.createElement(_compactInput2.default, { name: 'target.' + assign.id,
                        required: assign.assign,
                        type: 'number',
                        step: step,
                        disabled: !assign.assign,
                        hint: t('label:目標値を入力'),
                        error: assign.targetError && t('error:目標値を入力してください'),
                        value: assign.target,
                        onChange: function onChange(value) {
                          return updateUI({
                            assignments: Object.assign({}, ui.assignments, _defineProperty({}, i, Object.assign({}, assign, { target: value })))
                          });
                        } })
                    )
                  ) });
              })
            )
          ),
          _react2.default.createElement(
            _card.CardActions,
            null,
            _react2.default.createElement(_button.Button, { raised: true, primary: true,
              disabled: isUpdating,
              type: 'submit',
              style: { width: '100%' },
              label: kpi ? t('label:更新') : t('label:登録') })
          )
        )
      );
    }
  }]);

  return KPIFormPanel;
}(_react2.default.Component);

var RawKPIFormPanel = exports.RawKPIFormPanel = KPIFormPanel;
exports.default = (0, _kpiFormPanel2.default)(KPIFormPanel);

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;
exports.assignAll = assignAll;
exports.assignTargetAll = assignTargetAll;
exports.isAssignAll = isAssignAll;
exports.calcStartDate = calcStartDate;
exports.calcEndDate = calcEndDate;
exports.calcGenerateNextAtDays = calcGenerateNextAtDays;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _store = __webpack_require__(18);

var _formValidator = __webpack_require__(41);

var _alertMessage = __webpack_require__(13);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _some = __webpack_require__(161);

var _some2 = _interopRequireDefault(_some);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _keys = __webpack_require__(138);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/kpi-form-panel.js

function cloneProps(props, key, value) {
  if (props.kpi) return props.kpi[key];else if (props.cloneKpi) return props.cloneKpi[key];else return value;
}

function copyName(props, suffix) {
  if (props.kpi) return props.kpi.name;else if (props.cloneKpi && suffix) return props.cloneKpi.name + ' ' + suffix;else return '';
}

function cloneAssignments(props) {
  var clone = cloneProps(props, 'assignments', props.group.members);
  return (0, _map2.default)(props.group.members, function (member) {
    var assign = (0, _find2.default)(clone, function (item) {
      return item.user_id == member.user_id;
    });
    return {
      id: member.user_id,
      name: member.name,
      icon_image: member.icon_image,
      assign: typeof assign != 'undefined',
      target: assign && assign.target || ''
    };
  });
}

function assignAll(assignments, value) {
  return (0, _map2.default)(assignments, function (assign) {
    return Object.assign({}, assign, { assign: value });
  });
}

function assignTargetAll(assignments, value) {
  return (0, _map2.default)(assignments, function (assign) {
    if (assign.assign) return Object.assign({}, assign, { target: value });else return assign;
  });
}

function isAssignAll(assignments) {
  return !(0, _some2.default)(assignments, function (assign) {
    return !assign.assign;
  });
}

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    group: (0, _store.getArray)('group_id', state.groups.items, ownProps.group.group_id),
    isUpdating: state.kpi.isUpdating,
    isUpdateFailed: state.kpi.isUpdateFailed,
    kpi: ownProps.kpi_id && state.kpi.items && (0, _find2.default)(state.kpi.items, function (item) {
      return item.kpi_id == ownProps.kpi_id;
    })
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    validateAndSubmit: function validateAndSubmit(props) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (event && event.preventDefault) event.preventDefault();
      var rules = {
        name: { rule: 'isRequired' },
        unit: { rule: 'isRequired' }
      };
      (0, _formValidator.validate)(props.ui, rules, function (errors, nextUI) {
        (0, _each2.default)(props.ui.assignments, function (assign, i) {
          if (assign.assign && !assign.target.toString().match(/^[-.,0-9]+$/)) {
            if (!nextUI.assignments) nextUI.assignments = Object.assign({}, props.ui.assignments);
            nextUI.assignments[i].targetError = true;
            errors = true;
          }
        });
        if ((0, _moment2.default)(props.ui.startDate).isAfter((0, _moment2.default)(props.ui.endDate))) {
          nextUI.startDateError = true;
          nextUI.endDateError = true;
          errors = true;
          dispatch((0, _alertMessage.emitAlertMessage)('label:開始日は終了日より前に設定してください', 'error'));
        }
        if (props.ui.generateNextAtDaysTarget && (0, _moment2.default)(props.ui.generateNextAtDays).isBefore((0, _moment2.default)(props.ui.startDate))) {
          nextUI.generateNextAtDaysError = true;
          nextUI.startDateError = true;
          errors = true;
          dispatch((0, _alertMessage.emitAlertMessage)('label:自動作成日は開始日より後に設定してください', 'error'));
        }
        if (props.ui.generateNextAtDaysTarget && (0, _moment2.default)(props.ui.generateNextAtDays).isAfter((0, _moment2.default)(props.ui.endDate))) {
          nextUI.generateNextAtDaysError = true;
          nextUI.endDateError = true;
          errors = true;
          dispatch((0, _alertMessage.emitAlertMessage)('label:自動作成日は終了日より前に設定してください', 'error'));
        }
        props.updateUI(nextUI);
        var copyStart = props.ui.generateNextAtDaysTarget ? props.ui.generateNextAtDays && (0, _moment2.default)(props.ui.generateNextAtDays) || undefined : undefined;
        var end_date = props.ui.generateNextAtDaysTarget ? (0, _moment2.default)(props.ui.endDate) : undefined;
        var diff_date = props.ui.generateNextAtDaysTarget ? copyStart >= 0 && end_date.diff(copyStart, 'days') || 0 : undefined; //終了日と自動作成が同じ日の場合0を返す。

        if (!errors) {
          if (props.kpi) dispatch(_actions2.default.updateKpi(props.kpi.kpi_id, props.ui.name, props.ui.unit, props.group.group_id, props.ui.startDate.format('YYYY-MM-DD'), props.ui.endDate.format('YYYY-MM-DD'), diff_date, props.ui.displayFormat, props.ui.prependUnit, props.ui.accumulatedTotal, JSON.stringify((0, _filter2.default)(props.ui.assignments, function (assign) {
            return assign.assign;
          }).map(function (assign) {
            return { user_id: assign.id, target: assign.target };
          }))));else dispatch(_actions2.default.createKpi(props.ui.name, props.ui.unit, props.group.group_id, props.ui.startDate.format('YYYY-MM-DD'), props.ui.endDate.format('YYYY-MM-DD'), diff_date, props.ui.displayFormat, props.ui.prependUnit, props.ui.accumulatedTotal, JSON.stringify((0, _filter2.default)(props.ui.assignments, function (assign) {
            return assign.assign;
          }).map(function (assign) {
            return { user_id: assign.id, target: assign.target };
          }))));
        }
      });
      return false;
    },

    willMount: function willMount(props) {
      return props.kpi_id && dispatch(_actions2.default.fetchKpi(props.kpi_id));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (!props.kpi && nextProps.kpi) {
        nextProps.updateUI({
          name: nextProps.kpi.name,
          unit: nextProps.kpi.unit,
          startDate: (0, _moment2.default)(nextProps.kpi.start_date),
          endDate: (0, _moment2.default)(nextProps.kpi.end_date),
          generateNextAtDays: calcGenerateNextAtDays(nextProps),
          displayFormat: (0, _keys2.default)(nextProps.kpi.display_format).sort().join(' ') || '',
          prependUnit: nextProps.kpi.prepend_unit,
          accumulatedTotal: nextProps.kpi.accumulated_total,
          generateNextAtDaysTarget: nextProps.kpi.generate_next_at_days >= 0,
          assignments: cloneAssignments(nextProps)
        });
      }

      if (props.isUpdating && !nextProps.isUpdating && !nextProps.isUpdateFailed) {
        nextProps.selectPanel('kpi');
        if (nextProps.kpi_id) dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:KPIを更新しました', name: nextProps.kpi.name }, 'inputSuccess'));else dispatch((0, _alertMessage.emitAlertMessage)('label:KPIを作成しました', 'inputSuccess'));
      }
    },

    willUnmount: function willUnmount(props) {
      dispatch(_actions2.default.fetchDiaryKpi(props.group.group_id, new Date()));
    }
  };
};

function calcStartDate(props) {
  if (props.kpi) {
    return (0, _moment2.default)(props.kpi.start_date).hours(0).minutes(0).seconds(0).milliseconds(0);
  }
  if (props.cloneKpi && !props.nextPeriod) {
    return (0, _moment2.default)(props.cloneKpi.start_date).hours(0).minutes(0).seconds(0).milliseconds(0);
  }
  if (props.cloneKpi && props.nextPeriod) {
    return (0, _moment2.default)(props.cloneKpi.end_date).add(1, 'day').hours(0).minutes(0).seconds(0).milliseconds(0);
  }
  return (0, _moment2.default)().startOf('day');
}

function calcEndDate(props) {
  if (props.kpi) {
    return (0, _moment2.default)(props.kpi.end_date).hours(0).minutes(0).seconds(0).milliseconds(0);
  }
  if (props.cloneKpi && !props.nextPeriod) return (0, _moment2.default)(props.cloneKpi.end_date).hours(0).minutes(0).seconds(0).milliseconds(0);
  if (props.cloneKpi && props.nextPeriod) {
    var start_date = (0, _moment2.default)(props.cloneKpi.start_date);
    var end_date = (0, _moment2.default)(props.cloneKpi.end_date);
    if (start_date.clone().startOf('month').isSame(start_date, 'day') && end_date.clone().endOf('month').isSame(end_date, 'day')) {
      var diff_month = end_date.year() * 12 + end_date.month() - (start_date.year() * 12 + start_date.month()) + 1;
      return end_date.clone().add(diff_month, 'month').endOf('month').startOf('day');
    } else {
      var diff_days = _moment2.default.duration(end_date.toDate() - start_date.toDate()).days() + 1;
      return end_date.clone().add(diff_days, 'days');
    }
  }
  return (0, _moment2.default)().endOf('month');
}

function calcGenerateNextAtDays(props) {
  if (props.kpi) {
    // generate_next_at_daysが入っている場合は、その日付を計算する
    // 入っていない場合は、end_dateを設定する
    if (props.kpi.generate_next_at_days >= 0) return (0, _moment2.default)(props.kpi.end_date).subtract(props.kpi.generate_next_at_days, 'days').startOf('days');else return (0, _moment2.default)(props.kpi.end_date).startOf('days');
  } else {
    // 新規作成の場合は、endDateを初期値に設定する
    return calcEndDate(props).startOf('days');
  }
}

exports.default = (0, _combineHoc2.default)((0, _reactI18next.translate)(), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    name: function name(props) {
      return copyName(props, props.t('label:コピー'));
    },
    nameError: undefined,
    unit: function unit(props) {
      return cloneProps(props, 'unit', '');
    },
    unitError: undefined,
    todayDate: (0, _moment2.default)().startOf('days'),
    startDate: function startDate(props) {
      return calcStartDate(props);
    },
    startDateError: undefined,
    endDate: function endDate(props) {
      return calcEndDate(props);
    },
    endDateError: undefined,
    generateNextAtDays: function generateNextAtDays(props) {
      return calcGenerateNextAtDays(props);
    }, // generateNextAtDays: KPIを生成する日付(moment)
    generateNextAtDaysError: undefined,
    generateNextAtDaysTarget: function generateNextAtDaysTarget(props) {
      return props.kpi && props.kpi.generate_next_at_days >= 0;
    }, // generateNextAtDaysTarget: チェックON/OFF
    displayFormat: function displayFormat(props) {
      return (0, _keys2.default)(cloneProps(props, 'display_format', { separate_1000: true })).sort().join(' ') || '';
    },
    prependUnit: function prependUnit(props) {
      return cloneProps(props, 'prepend_unit', false);
    },
    accumulatedTotal: function accumulatedTotal(props) {
      return cloneProps(props, 'accumulated_total', true);
    },
    assignments: function assignments(props) {
      return cloneAssignments(props);
    },
    assignSameTarget: false,
    assignAll: function assignAll(props) {
      return isAssignAll(cloneAssignments(props));
    },
    isEdited: false,
    assignmentAllValue: undefined,
    assignmentAllError: false
  } }), _lifecycle2.default);

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.reported-date-picker--label--2WC9FhDd {\n  font-size: 105%;\n  font-weight: bold;\n}\n\n.reported-date-picker--header--DvB9l1KA {\n  display: none;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/reported-date-picker.css"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,kBAAkB;CACnB;;AAED;EACE,cAAc;CACf","file":"reported-date-picker.css","sourcesContent":["\n.label {\n  font-size: 105%;\n  font-weight: bold;\n}\n\n.header {\n  display: none;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"label": "reported-date-picker--label--2WC9FhDd",
	"header": "reported-date-picker--header--DvB9l1KA"
};

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/kpi-preview.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = __webpack_require__(10);

var _kpiPreview = __webpack_require__(2359);

var _kpiPreview2 = _interopRequireDefault(_kpiPreview);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _formatNumber = __webpack_require__(201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Row(props) {
  var t = props.t,
      theme = props.theme,
      label = props.label,
      value = props.value,
      isPercent = props.isPercent,
      format = props.format,
      unit = props.unit,
      formatLabel = props.formatLabel,
      prependUnit = props.prependUnit;

  var renderUnit = function renderUnit() {
    if (unit) {
      return _react2.default.createElement(
        'span',
        null,
        prependUnit && _react2.default.createElement(
          'span',
          { className: theme.unit },
          unit
        ),
        _react2.default.createElement(
          'span',
          { className: theme.number },
          ' ' + formatLabel + ' '
        ),
        !prependUnit && _react2.default.createElement(
          'span',
          { className: theme.unit },
          unit
        )
      );
    } else {
      return _react2.default.createElement(
        'span',
        null,
        prependUnit && _react2.default.createElement(
          'span',
          { className: theme.unitError },
          '__'
        ),
        _react2.default.createElement(
          'span',
          { className: theme.number },
          ' ' + formatLabel + ' '
        ),
        !prependUnit && _react2.default.createElement(
          'span',
          { className: theme.unitError },
          '__'
        )
      );
    }
  };
  return _react2.default.createElement(
    'div',
    { className: theme.row },
    _react2.default.createElement(
      'div',
      { className: theme.label },
      label
    ),
    _react2.default.createElement(
      'div',
      { className: theme.value },
      !isPercent && renderUnit(),
      isPercent && _react2.default.createElement(
        'span',
        { className: theme.achieved },
        t('label:達成')
      ),
      isPercent && _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { className: theme.number },
          (0, _formatNumber.percent)(1)
        ),
        _react2.default.createElement(
          'span',
          { className: theme.unit },
          '%'
        )
      )
    )
  );
}

var KPIPreview = (_dec = (0, _reactCssThemr.themr)('KPIPreview', _kpiPreview2.default), _dec(_class = function (_React$Component) {
  _inherits(KPIPreview, _React$Component);

  function KPIPreview() {
    _classCallCheck(this, KPIPreview);

    return _possibleConstructorReturn(this, (KPIPreview.__proto__ || Object.getPrototypeOf(KPIPreview)).apply(this, arguments));
  }

  _createClass(KPIPreview, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          kpi = _props.kpi,
          group = _props.group,
          ui = _props.ui,
          formatLabel = _props.formatLabel;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(theme.kpi) },
        _react2.default.createElement(
          'div',
          { className: theme.desc },
          t('label:プレビュー説明')
        ),
        _react2.default.createElement(
          'h3',
          { className: ui.name ? theme.title : theme.titleError },
          ui.name && ui.name || '\u2191 ' + t('error:KPI名を入力してください') + ' '
        ),
        _react2.default.createElement(
          'h3',
          { className: ui.unit ? theme.title : theme.titleError },
          !ui.unit && '\u2191 ' + t('error:単位を入力してください') + ' '
        ),
        _react2.default.createElement(
          'div',
          { className: theme.rows },
          _react2.default.createElement(Row, { theme: theme, label: t('label:目標'), value: ui.target, formatLabel: formatLabel, unit: ui.unit, prependUnit: ui.prependUnit }),
          _react2.default.createElement(Row, { theme: theme, label: t('label:実績'), value: ui.actual, formatLabel: formatLabel, unit: ui.unit, prependUnit: ui.prependUnit }),
          ui.accumulatedTotal && _react2.default.createElement(Row, { theme: theme, label: t('label:累計'), value: ui.total, formatLabel: formatLabel, unit: ui.unit, prependUnit: ui.prependUnit }),
          _react2.default.createElement(Row, { t: t, theme: theme, label: t('label:達成率'), value: (ui.total || ui.actual) / ui.target, isPercent: true, prependUnit: ui.prependUnit })
        )
      );
    }
  }]);

  return KPIPreview;
}(_react2.default.Component)) || _class);
exports.default = KPIPreview;

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2360);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./kpi-preview.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./kpi-preview.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.kpi-preview--kpi--3t9jCD2b {\n  width: calc(60% - 10px);\n  margin: 5px;\n  border-radius: 3px;\n  border: solid 2px #EEE;\n  padding: 16px;\n}\n\n@media screen and (max-width: 600px) {\n  .kpi-preview--kpi--3t9jCD2b {\n    width: calc(100% - 10px);\n  }\n}\n\n.kpi-preview--desc--eSSnSmJd {\n  font-size: 12px;\n  color: gray;\n  text-align: center;\n}\n\n.kpi-preview--title--2yQvC4Q_ {\n  margin: 8px 0;\n  font-size: 14px;\n  font-weight: bold;\n  color: #444;\n}\n\n.kpi-preview--titleError--17eTJGAd {\n  margin: 8px 0;\n  font-size: 14px;\n  font-weight: bold;\n  color: red;\n}\n\n.kpi-preview--rows--3XAjRgOK {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  border-radius: 3px;\n  border: solid 1px #EEE;\n  background: #FFF;\n  font-size: 14px;\n}\n\n.kpi-preview--row--2kl3Dts8 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px;\n  margin: 0 5px;\n  border-top: solid 1px #EEE;\n}\n\n.kpi-preview--row--2kl3Dts8:first-child {\n  border-top: 0;\n  border-top: initial;\n}\n\n.kpi-preview--label--3aBeuuX4 {\n  color: #444;\n}\n\n.kpi-preview--value--1FKShFGi {\n  margin-left: auto;\n}\n\n.kpi-preview--number--3w87pOUM {\n  font-weight: bold;\n  font-size: 105%;\n}\n\n.kpi-preview--unit--17FQCRdW {\n  font-weight: bold;\n  color: #666;\n}\n\n.kpi-preview--unitError--3KoFtYzC {\n  color: red;\n  font-weight: bold;\n}\n\n.kpi-preview--achieved--NBUBYlex {\n  background: red;\n  padding: 4px;\n  border-radius: 3px;\n  color: #FFF;\n  font-size: 50%;\n  margin: 0 4px;\n}\n\n.kpi-preview--input--2ELkR9Kc {\n  font-size: 14px;\n  text-align: right;\n  border: none;\n  margin-left: auto;\n  background: rgba(0, 0, 0, .1);\n  padding: 0 5px;\n}\n\n.kpi-preview--input--2ELkR9Kc:focus {\n  outline: none;\n  border-bottom: solid 2px rgb(48, 63, 159);\n}\n\n.kpi-preview--error--IwUEOyJM {\n  background: rgba(255, 0, 0, .1);\n  border-bottom: solid 2px rgba(255, 0, 0, 1)!important;\n}\n\n.kpi-preview--error--IwUEOyJM::-webkit-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n\n.kpi-preview--error--IwUEOyJM:-ms-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n\n.kpi-preview--error--IwUEOyJM::placeholder {\n  color: red;\n  font-size: 80%;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/kpi-preview.css"],"names":[],"mappings":";AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;CACf;;AAED;EACE;IACE,yBAAyB;GAC1B;CACF;;AAED;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;CACpB;;AAED;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;CACb;;AAED;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;CACZ;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;CACjB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,cAAc;EACd,2BAA2B;CAC5B;;AAED;EACE,cAAc;EACd,oBAAoB;CACrB;;AAED;EACE,YAAY;CACb;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,kBAAkB;EAClB,gBAAgB;CACjB;;AAED;EACE,kBAAkB;EAClB,YAAY;CACb;;AAED;EACE,WAAW;EACX,kBAAkB;CACnB;;AAED;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;CACf;;AAED;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;CAChB;;AAED;EACE,cAAc;EACd,0CAA0C;CAC3C;;AAED;EACE,gCAAgC;EAChC,sDAAsD;CACvD;;AAED;EACE,WAAW;EACX,eAAe;CAChB;;AAED;EACE,WAAW;EACX,eAAe;CAChB;;AAED;EACE,WAAW;EACX,eAAe;CAChB","file":"kpi-preview.css","sourcesContent":["\n.kpi {\n  width: calc(60% - 10px);\n  margin: 5px;\n  border-radius: 3px;\n  border: solid 2px #EEE;\n  padding: 16px;\n}\n\n@media screen and (max-width: 600px) {\n  .kpi {\n    width: calc(100% - 10px);\n  }\n}\n\n.desc {\n  font-size: 12px;\n  color: gray;\n  text-align: center;\n}\n\n.title {\n  margin: 8px 0;\n  font-size: 14px;\n  font-weight: bold;\n  color: #444;\n}\n\n.titleError {\n  margin: 8px 0;\n  font-size: 14px;\n  font-weight: bold;\n  color: red;\n}\n\n.rows {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  border-radius: 3px;\n  border: solid 1px #EEE;\n  background: #FFF;\n  font-size: 14px;\n}\n\n.row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px;\n  margin: 0 5px;\n  border-top: solid 1px #EEE;\n}\n\n.row:first-child {\n  border-top: 0;\n  border-top: initial;\n}\n\n.label {\n  color: #444;\n}\n\n.value {\n  margin-left: auto;\n}\n\n.number {\n  font-weight: bold;\n  font-size: 105%;\n}\n\n.unit {\n  font-weight: bold;\n  color: #666;\n}\n\n.unitError {\n  color: red;\n  font-weight: bold;\n}\n\n.achieved {\n  background: red;\n  padding: 4px;\n  border-radius: 3px;\n  color: #FFF;\n  font-size: 50%;\n  margin: 0 4px;\n}\n\n.input {\n  font-size: 14px;\n  text-align: right;\n  border: none;\n  margin-left: auto;\n  background: rgba(0, 0, 0, .1);\n  padding: 0 5px;\n}\n\n.input:focus {\n  outline: none;\n  border-bottom: solid 2px rgb(48, 63, 159);\n}\n\n.error {\n  background: rgba(255, 0, 0, .1);\n  border-bottom: solid 2px rgba(255, 0, 0, 1)!important;\n}\n\n.error::-webkit-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n\n.error:-ms-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n\n.error::placeholder {\n  color: red;\n  font-size: 80%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"kpi": "kpi-preview--kpi--3t9jCD2b",
	"desc": "kpi-preview--desc--eSSnSmJd",
	"title": "kpi-preview--title--2yQvC4Q_",
	"titleError": "kpi-preview--titleError--17eTJGAd",
	"rows": "kpi-preview--rows--3XAjRgOK",
	"row": "kpi-preview--row--2kl3Dts8",
	"label": "kpi-preview--label--3aBeuuX4",
	"value": "kpi-preview--value--1FKShFGi",
	"number": "kpi-preview--number--3w87pOUM",
	"unit": "kpi-preview--unit--17FQCRdW",
	"unitError": "kpi-preview--unitError--3KoFtYzC",
	"achieved": "kpi-preview--achieved--NBUBYlex",
	"input": "kpi-preview--input--2ELkR9Kc",
	"error": "kpi-preview--error--IwUEOyJM"
};

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2362);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./kpi-form-panel.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./kpi-form-panel.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.kpi-form-panel--list--2L0xjuYU {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.kpi-form-panel--listItem--Yn_wLvGn[class~=checked]{\n  background-color: #dcdcdc!important;\n}\n\n.kpi-form-panel--itemContentRoot--3QVk4G-M {\n  height: auto!important;\n  min-width: 183px;\n}\n\n.kpi-form-panel--subheader--bg-MLq0z {\n  line-height: 30px;\n  margin: 0;\n}\n\n.kpi-form-panel--itemText--E8MGACZw {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}", "", {"version":3,"sources":["/./src/web/components/themes/kpi-form-panel.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,kBAAkB;CACnB;;AAED;EACE,oCAAoC;CACrC;;AAED;EACE,uBAAuB;EACvB,iBAAiB;CAClB;;AAED;EACE,kBAAkB;EAClB,UAAU;CACX;;AAED;EACE,wBAAwB;EACxB,iBAAiB;CAClB","file":"kpi-form-panel.css","sourcesContent":["\n.list {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.listItem[class~=checked]{\n  background-color: #dcdcdc!important;\n}\n\n.itemContentRoot {\n  height: auto!important;\n  min-width: 183px;\n}\n\n.subheader {\n  line-height: 30px;\n  margin: 0;\n}\n\n.itemText {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"list": "kpi-form-panel--list--2L0xjuYU",
	"listItem": "kpi-form-panel--listItem--Yn_wLvGn",
	"itemContentRoot": "kpi-form-panel--itemContentRoot--3QVk4G-M",
	"subheader": "kpi-form-panel--subheader--bg-MLq0z",
	"itemText": "kpi-form-panel--itemText--E8MGACZw"
};

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupExportPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupExportPanel = __webpack_require__(2364);

var _groupExportPanel2 = _interopRequireDefault(_groupExportPanel);

var _card = __webpack_require__(28);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _button = __webpack_require__(8);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _formValidator = __webpack_require__(41);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _datePicker = __webpack_require__(165);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _googleSigninProvider = __webpack_require__(200);

var _reportStatus = __webpack_require__(994);

var _reportStatus2 = _interopRequireDefault(_reportStatus);

var _list = __webpack_require__(25);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _menu = __webpack_require__(63);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _input = __webpack_require__(59);

var _radio = __webpack_require__(503);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-export-panel.jsx

var GroupExportPanel = function (_React$Component) {
  _inherits(GroupExportPanel, _React$Component);

  function GroupExportPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GroupExportPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupExportPanel.__proto__ || Object.getPrototypeOf(GroupExportPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      exportAll: true,
      fields: [],
      showMenu: false,
      checkDates: true,
      checkRefreshToken: true,
      sendingMethodValue: 'mail',
      checkFolder: true,
      checkSaveFolder: true
    }, _this.toggleExportAll = function () {
      return _this.setState({ exportAll: !_this.state.exportAll });
    }, _this.toggleField = function (field) {
      if (_this.state.fields.includes(field)) _this.setState({ fields: _.filter(_this.state.fields, function (_field) {
          return _field != field;
        }) });else _this.setState({ fields: _this.state.fields.concat(field) });
    }, _this.unLinkGoogleDrive = function () {
      _this.props.cancelGoogleDrive();
      _this.props.ui.gapiReady && _googleSigninProvider.GoogleLogin.signOut();
      _this.props.updateUI({ gapiReady: false, folder_id: 'undefined' });
    }, _this.onGoogleSignSuccess = function () {
      _this.props.fetchUserInfo();
      _this.props.fetchFolders();
      _this.props.updateUI({ gapiReady: true });
    }, _this.onGoogleCodeSuccess = function () {
      _this.props.fetchRefreshToken();
    }, _this.onSelectFolder = function (folder_id) {
      _this.props.updateUI({ folder_id: folder_id });
      _this.setState({ checkFolder: true });
    }, _this.toggleIsScheduled = function () {
      _this.props.updateUI({ isScheduled: !_this.props.ui.isScheduled });
    }, _this.onSelectScheduledFolder = function (save_folder_id) {
      _this.props.updateUI({ save_folder_id: save_folder_id });
      _this.setState({ checkSaveFolder: true });
    }, _this.onSelectInterval = function (interval) {
      _this.props.updateUI({ interval: interval });
    }, _this.onUpdateScheduledSettings = function () {
      if (_this.props.ui.refreshToken) {
        _this.setState({ checkRefreshToken: true });

        // check GoogleDrive folder validation
        if (_this.props.ui.save_folder_id == 'undefined') {
          _this.setState({ checkSaveFolder: false });
        } else {
          _this.setState({ checkSaveFolder: true });
          _this.props.updateScheduledSettings(_this.props);
        }
      } else {
        _this.setState({ checkRefreshToken: false });
      }
    }, _this.onDownloadFile = function (fields) {
      // Parse the start and end dates using moment
      var startDate = (0, _moment2.default)(_this.props.ui.startDate);
      var endDate = (0, _moment2.default)(_this.props.ui.endDate);
      // Calculate the difference in days
      var dateDifference = endDate.diff(startDate, 'days');
      // Check if the difference is greater than 366 days
      if (dateDifference > 366) {
        _this.setState({ checkDates: false });
      } else {
        _this.setState({ checkDates: true });
        if (_this.state.sendingMethodValue == 'mail') {
          window.open(_this.props.groupExportUrl(_this.props.ui.startDate, _this.props.ui.endDate, fields));
        } else {
          // check GoogleDrive folder validation
          if (_this.props.ui.folder_id == 'undefined') {
            _this.setState({ checkFolder: false });
          } else {
            _this.setState({ checkFolder: true });
            _this.props.downloadFile(_this.props, fields);
          }
        }
      }
    }, _this.sendingMethodChange = function (value) {
      _this.setState({ sendingMethodValue: value });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GroupExportPanel, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isFoldersFetchFailed && this.props.isFoldersFetchFailed) {
        _googleSigninProvider.GoogleLogin.signOut();
        this.props.updateUI({ gapiReady: false });
      }

      if (!prevProps.refresh_token && this.props.refresh_token) {
        this.props.updateUI({ refreshToken: this.props.refresh_token });
        this.setState({ checkRefreshToken: true });
      }

      if (!prevProps.scheduled_settings && this.props.scheduled_settings) {
        var settings = this.props.scheduled_settings;
        if (settings.generate_next_at) this.props.updateUI({ scheduledDate: (0, _moment2.default)(settings.generate_next_at) });
        if (settings.is_active) this.props.updateUI({ isScheduled: settings.is_active });
        if (settings.folder_id) this.props.updateUI({ save_folder_id: settings.folder_id });
        if (settings.interval) this.props.updateUI({ interval: settings.interval });
        if (settings.refresh_token) this.props.updateUI({ refreshToken: settings.refresh_token });
      }
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.field_list != nextProps.field_list) this.setState({ fields: nextProps.field_list });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          groupExportUrl = _props.groupExportUrl,
          field_list = _props.field_list,
          folders = _props.folders,
          userinfo = _props.userinfo,
          isFoldersFetching = _props.isFoldersFetching,
          isFoldersFetchFailed = _props.isFoldersFetchFailed,
          fetchFolders = _props.fetchFolders,
          fetchUserInfo = _props.fetchUserInfo,
          cancelGoogleDrive = _props.cancelGoogleDrive,
          isUserInfoFetching = _props.isUserInfoFetching,
          isUserInfoFetchFailed = _props.isUserInfoFetchFailed,
          isUploadFetching = _props.isUploadFetching,
          isUploadFetchFailed = _props.isUploadFetchFailed,
          downloadFile = _props.downloadFile,
          fetchRefreshToken = _props.fetchRefreshToken,
          isRefreshTokenFetching = _props.isRefreshTokenFetching,
          isRefreshTokenFailed = _props.isRefreshTokenFailed,
          refresh_token = _props.refresh_token,
          fetchScheduledSettings = _props.fetchScheduledSettings,
          isScheduledSettingsFetching = _props.isScheduledSettingsFetching,
          isScheduledSettingsFailed = _props.isScheduledSettingsFailed,
          updateScheduledSettings = _props.updateScheduledSettings,
          isUpdateScheduledSettingsFetching = _props.isUpdateScheduledSettingsFetching,
          isUpdateScheduledSettingsFailed = _props.isUpdateScheduledSettingsFailed,
          scheduled_settings = _props.scheduled_settings,
          currentUser = _props.currentUser;


      var arrowClassName = ui.isScheduled ? 'keyboard_arrow_down' : 'keyboard_arrow_right';

      var dropDownSource = [{ value: 'undefined', label: t('label:フォルダを選択して下さい') }];

      var scheduledDropDownSource = [{ value: 'undefined', label: t('label:フォルダを選択して下さい') }];

      if (folders && folders.length > 0) {
        var folderOptions = folders.map(function (folder) {
          return {
            value: folder.id,
            label: folder.name
          };
        });
        dropDownSource = dropDownSource.concat(folderOptions);
        scheduledDropDownSource = scheduledDropDownSource.concat(folderOptions);
      }

      var intervalDropDownSource = [{ value: 'week', label: t('label:週') }, { value: 'month', label: t('label:月次') }];

      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(
            'strong',
            null,
            t('label:開始日')
          ),
          _react2.default.createElement(_datePicker2.default, { label: t('label:開始日'),
            value: ui.startDate.toDate(),
            maxDate: ui.endDate.toDate(),
            onChange: function onChange(date) {
              return updateUI({ startDate: (0, _moment2.default)(date) });
            } })
        ),
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(
            'strong',
            null,
            t('label:終了日')
          ),
          _react2.default.createElement(_datePicker2.default, { label: t('label:終了日'),
            value: ui.endDate.toDate(),
            minDate: ui.startDate.toDate(),
            onChange: function onChange(date) {
              return updateUI({ endDate: (0, _moment2.default)(date) });
            } })
        ),
        !this.state.checkDates && _react2.default.createElement(
          _card.CardText,
          { style: { color: 'red' } },
          _react2.default.createElement(_font_icon2.default, { value: 'error', style: { verticalAlign: 'bottom', fontSize: 18 } }),
          _react2.default.createElement(
            'span',
            { style: { marginLeft: 5 } },
            t('label:日報のエクスポートは最大1年分')
          )
        ),
        field_list && field_list.length > 0 && _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_checkbox2.default, { checked: this.state.exportAll,
              label: t('label:すべて抽出'),
              onChange: this.toggleExportAll }),
            _react2.default.createElement(
              'ul',
              null,
              !this.state.exportAll && _.map(field_list, function (field, i) {
                return _react2.default.createElement(
                  'li',
                  { key: i },
                  _react2.default.createElement(_checkbox2.default, { checked: _this2.state.fields.includes(field),
                    label: field, onChange: function onChange() {
                      return _this2.toggleField(field);
                    } })
                );
              })
            )
          )
        ),
        (isFoldersFetching || isUploadFetching || isUserInfoFetching) && _react2.default.createElement(_loading2.default, null),
        _react2.default.createElement(
          _card.CardText,
          { className: _reportStatus2.default.sendingMethod },
          _react2.default.createElement(
            'strong',
            null,
            t('label:送信方法')
          ),
          _react2.default.createElement(
            _radio.RadioGroup,
            {
              className: _reportStatus2.default.radioGroup,
              value: this.state.sendingMethodValue,
              onChange: this.sendingMethodChange
            },
            _react2.default.createElement(
              _radio.RadioButton,
              { label: t('label:メール'), value: 'mail' },
              _react2.default.createElement(
                'span',
                { className: _reportStatus2.default.mailContent },
                currentUser.email,
                ' \u3078\u9001\u4FE1\u3057\u307E\u3059'
              )
            ),
            _react2.default.createElement(_radio.RadioButton, { label: 'Google\u30C9\u30E9\u30A4\u30D6', value: 'drive' })
          )
        ),
        this.state.sendingMethodValue == 'drive' && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _card.CardText,
            { className: _reportStatus2.default.googleSignInBtn },
            !ui.gapiReady && _react2.default.createElement(_googleSigninProvider.GoogleLogin, { label: t('label:Googleドライブに接続する'), onSuccess: this.onGoogleSignSuccess, type: 'google_drive' }),
            !isUserInfoFetchFailed && ui.gapiReady && userinfo && _react2.default.createElement(
              _list.List,
              null,
              _react2.default.createElement(
                'span',
                { className: _reportStatus2.default.normalTitle },
                t('label:アカウント')
              ),
              _react2.default.createElement(
                _list.ListItem,
                {
                  className: _reportStatus2.default.userInfo,
                  rightActions: [_react2.default.createElement(
                    _menu.IconMenu,
                    { key: 'menu', icon: 'more_vert', onClick: function onClick() {
                        return _this2.setState({ showMenu: true });
                      } },
                    _react2.default.createElement(_menu.MenuItem, {
                      icon: 'delete_forever',
                      onClick: this.unLinkGoogleDrive,
                      caption: t('label:Googleドライブを解除')
                    })
                  )]
                },
                _react2.default.createElement(
                  'span',
                  null,
                  userinfo.displayName
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  '(',
                  userinfo.emailAddress,
                  ')'
                )
              )
            ),
            ui.gapiReady && _react2.default.createElement(
              _list.List,
              null,
              _react2.default.createElement(
                'span',
                { className: _reportStatus2.default.normalTitle },
                t('label:フォルダの選択')
              ),
              folders && folders.length == 0 && _react2.default.createElement(_list.ListItem, { caption: t('label:フォルダがありません'), selectable: false }),
              _react2.default.createElement(_dropdown2.default, { auto: true,
                source: dropDownSource,
                value: ui.folder_id,
                onChange: this.onSelectFolder
              }),
              !this.state.checkFolder && _react2.default.createElement(
                _card.CardText,
                { style: { color: 'red', paddingLeft: 0, paddingTop: 0 } },
                _react2.default.createElement(_font_icon2.default, { value: 'error', style: { verticalAlign: 'bottom', fontSize: 18 } }),
                _react2.default.createElement(
                  'span',
                  { style: { marginLeft: 5 } },
                  t('label:フォルダを選択して下さい1')
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(_button.Button, { raised: true, primary: true,
            disabled: this.state.sendingMethodValue == 'drive' && !ui.gapiReady,
            onClick: function onClick() {
              return _this2.onDownloadFile(_this2.state.exportAll ? undefined : _.filter(field_list, function (item) {
                return _this2.state.fields.includes(item);
              }));
            },
            style: { width: '100%' },
            label: t('label:エクスポート')
          })
        ),
        _react2.default.createElement(
          _card.CardText,
          { style: { marginTop: 10 } },
          _react2.default.createElement(
            _checkbox2.default,
            {
              label: t('label:定期的にGoogleドライブへ自動保存する'),
              checked: ui.isScheduled,
              onChange: this.toggleIsScheduled
            },
            _react2.default.createElement(_font_icon2.default, { style: { display: 'inline-block', marginTop: -2 }, value: arrowClassName })
          )
        ),
        ui.isScheduled && _react2.default.createElement(
          'div',
          null,
          (isRefreshTokenFetching || isScheduledSettingsFetching || isUpdateScheduledSettingsFetching) && _react2.default.createElement(_loading2.default, null),
          !ui.refreshToken && _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(_googleSigninProvider.GoogleLogin, { label: t('label:Googleドライブに連携する'), onCodeSuccess: this.onGoogleCodeSuccess, type: 'refresh_token' })
          ),
          ui.refreshToken && _react2.default.createElement(
            _card.CardText,
            { style: { color: 'green' } },
            _react2.default.createElement(_font_icon2.default, { value: 'check_circle', style: { verticalAlign: 'bottom', fontSize: 18 } }),
            _react2.default.createElement(
              'span',
              { style: { marginLeft: 5, color: 'black' } },
              t('label:連携済み')
            )
          ),
          !this.state.checkRefreshToken && _react2.default.createElement(
            _card.CardText,
            { style: { color: 'red' } },
            _react2.default.createElement(_font_icon2.default, { value: 'error', style: { verticalAlign: 'bottom', fontSize: 18 } }),
            _react2.default.createElement(
              'span',
              { style: { marginLeft: 5 } },
              t('label:Googleドライブが設定されていません')
            )
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'strong',
              null,
              t('label:フォルダの選択')
            ),
            folders && folders.length == 0 && _react2.default.createElement(
              _list.List,
              null,
              _react2.default.createElement(_list.ListItem, { caption: t('label:フォルダがありません'), selectable: false })
            ),
            !ui.gapiReady && _react2.default.createElement(
              _list.List,
              null,
              _react2.default.createElement(_list.ListItem, { className: _reportStatus2.default.folderItem, caption: t('label:Googleドライブが設定されていません'), selectable: false })
            ),
            ui.gapiReady && _react2.default.createElement(_dropdown2.default, { auto: true,
              source: scheduledDropDownSource,
              value: ui.save_folder_id,
              onChange: this.onSelectScheduledFolder
            }),
            !this.state.checkSaveFolder && _react2.default.createElement(
              _card.CardText,
              { style: { color: 'red', paddingLeft: 0, paddingTop: 0 } },
              _react2.default.createElement(_font_icon2.default, { value: 'error', style: { verticalAlign: 'bottom', fontSize: 18 } }),
              _react2.default.createElement(
                'span',
                { style: { marginLeft: 5 } },
                t('label:フォルダを選択して下さい1')
              )
            )
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'span',
              { style: { fontSize: 16, fontWeight: 'bold' } },
              t('label:期間設定')
            )
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'strong',
              null,
              t('label:日付')
            ),
            _react2.default.createElement(_datePicker2.default, { label: t('label:日付'),
              value: ui.scheduledDate.toDate(),
              minDate: (0, _moment2.default)().toDate(),
              onChange: function onChange(date) {
                return updateUI({ scheduledDate: (0, _moment2.default)(date) });
              } })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'strong',
              null,
              t('label:間隔')
            ),
            _react2.default.createElement(_dropdown2.default, { auto: true,
              source: intervalDropDownSource,
              value: ui.interval,
              onChange: this.onSelectInterval
            }),
            _react2.default.createElement(_button.Button, { raised: true, primary: true,
              onClick: this.onUpdateScheduledSettings,
              style: { width: '100%' },
              label: t('label:更新する')
            })
          )
        )
      );
    }
  }]);

  return GroupExportPanel;
}(_react2.default.Component);

var RawGroupExportPanel = exports.RawGroupExportPanel = GroupExportPanel;
exports.default = (0, _groupExportPanel2.default)(GroupExportPanel);

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeProps = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
// src/connects/group-export-panel.js

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    access_token: state.sessions.access_token,
    field_list: state.templates.field_list,
    isFoldersFetching: state.googleApi.isFoldersFetching,
    isFoldersFetchFailed: state.googleApi.isFoldersFetchFailed,
    folders: state.googleApi.folders,
    isUserInfoFetching: state.googleApi.isUserInfoFetching,
    isUserInfoFetchFailed: state.googleApi.isUserInfoFetchFailed,
    userinfo: state.googleApi.userinfo,
    isUploadFetching: state.googleApi.isUploadFetching,
    isUploadFetchFailed: state.googleApi.isUploadFetchFailed,
    refresh_token: state.googleApi.refresh_token,
    isRefreshTokenFetching: state.googleApi.isRefreshTokenFetching,
    isRefreshTokenFailed: state.googleApi.isRefreshTokenFailed,
    scheduled_settings: state.groups.scheduled_settings,
    isScheduledSettingsFetching: state.groups.isScheduledSettingsFetching,
    isScheduledSettingsFailed: state.groups.isScheduledSettingsFailed,
    isUpdateScheduledSettingsFetching: state.groups.isUpdateScheduledSettingsFetching,
    isUpdateScheduledSettingsFailed: state.groups.isUpdateScheduledSettingsFailed,
    currentUser: state.user.current
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount(props) {
      if (props.user && props.group) {
        dispatch(_actions2.default.fetchTemplateFields(props.group.group_id, props.user.user_id));
        props.fetchScheduledSettings(props.group.group_id);
      }
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (!props.isFoldersFetchFailed && nextProps.isFoldersFetchFailed) {
        nextProps.updateUI({ gapiReady: false });
        dispatch((0, _alertMessage.emitAlertMessage)({ message: "label:Googleカレンダーの取得に失敗しました" }, 'error'));
      }
    },

    willUnmount: function willUnmount() {
      dispatch(_actions2.default.clearGoogleDriveFolders());
      dispatch(_actions2.default.clearScheduledSettings());
    },

    fetchUserInfo: function fetchUserInfo() {
      return dispatch(_actions2.default.fetchGoogleDriveUserInfo());
    },

    fetchFolders: function fetchFolders() {
      dispatch(_actions2.default.fetchGoogleDriveFolders());
    },

    fetchRefreshToken: function fetchRefreshToken() {
      dispatch(_actions2.default.fetchRefreshToken());
    },

    fetchScheduledSettings: function fetchScheduledSettings(group_id) {
      dispatch(_actions2.default.fetchScheduledSettings(group_id));
    },

    updateScheduledSettings: function updateScheduledSettings(props) {
      dispatch(_actions2.default.updateScheduledSettings(props.group.group_id, props.ui.refreshToken, props.ui.isScheduled, props.ui.save_folder_id, props.ui.interval, (0, _moment2.default)(props.ui.scheduledDate).format('YYYY-MM-DD'), props.access_token));
    },

    cancelGoogleDrive: function cancelGoogleDrive() {
      dispatch(_actions2.default.clearGoogleDriveFolders());
    },

    downloadFile: function downloadFile(props, fields) {
      var file_name = 'diaries_summary.xlsx';

      var params = {
        group_id: props.group.group_id,
        start_date: (0, _moment2.default)(props.ui.startDate).format('YYYY-MM-DD'),
        end_date: (0, _moment2.default)(props.ui.endDate).format('YYYY-MM-DD'),
        access_token: props.access_token
      };
      if (fields) params.field_names = fields.join(',');
      var createQueryString = function createQueryString(params) {
        return Object.entries(params).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          return encodeURIComponent(key) + '=' + encodeURIComponent(value);
        }).join('&');
      };
      var queryString = createQueryString(params);

      var file_url = _config2.default.baseUrl + 'v3/export/diaries_summary?' + queryString;

      dispatch(_actions2.default.uploadGoogleDriveFile(props.ui.folder_id, file_name, file_url));
    }
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    groupExportUrl: function groupExportUrl(startDate, endDate, fields) {
      var params = {
        group_id: ownProps.group.group_id,
        start_date: (0, _moment2.default)(startDate).format('YYYY-MM-DD'),
        end_date: (0, _moment2.default)(endDate).format('YYYY-MM-DD'),
        access_token: stateProps.access_token
      };
      if (fields) params.field_names = fields.join(',');
      return _config2.default.baseUrl + 'v3/export/diaries?' + (0, _map2.default)(params, function (value, key) {
        return key + '=' + encodeURI(value);
      }).join('&');
    }
  });
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: {
    startDate: (0, _moment2.default)().startOf('month'),
    endDate: (0, _moment2.default)(),
    folder_id: 'undefined',
    save_folder_id: function save_folder_id(props) {
      return props.scheduled_settings && props.scheduled_settings.folder_id ? props.scheduled_settings.folder_id : 'undefined';
    },
    scheduledDate: function scheduledDate(props) {
      return props.scheduled_settings && props.scheduled_settings.generate_next_at ? (0, _moment2.default)(props.scheduled_settings.generate_next_at) : (0, _moment2.default)();
    },
    interval: function interval(props) {
      return props.scheduled_settings && props.scheduled_settings.interval ? props.scheduled_settings.interval : 'week';
    },
    isScheduled: function isScheduled(props) {
      return props.scheduled_settings && props.scheduled_settings.is_active ? props.scheduled_settings.is_active : false;
    },
    refreshToken: function refreshToken(props) {
      return props.scheduled_settings && props.scheduled_settings.refresh_token ? props.scheduled_settings.refresh_token : '';
    },
    gapiReady: false
  } }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.report-status--activityEmptyBadge--2zsKWcTY {\n  width: 22px;\n  display: inline-block;\n}\n\n.report-status--activityIcon--rJwCoNxE {\n  display: inline-block;\n  margin-right: 4px;\n  cursor: pointer;\n}\n\n.report-status--activityBadge--3h8B6qTj {\n  border-radius: 50%;\n  background: #999;\n  color: #FFF;\n  height: 16px;\n  width: 16px;\n  display: inline-block;\n  margin-left: -10px;\n  font-size: 10px;\n}\n\n.report-status--activityFontIcon--ypVSGvcy {\n  font-size: 18px;\n}\n\n.report-status--headerBlack--aLC0xZ3t {\n  text-align: center;\n  color: black;\n  cursor: inherit;\n}\n\n.report-status--headerRed--GtD5cplf {\n  text-align: center;\n  color: red;\n  cursor: pointer;\n}\n\n.report-status--headerBlue--2ONvXRNa {\n  text-align: center;\n  color: blue;\n  cursor: pointer;\n}\n\n.report-status--headerBody--mYa5zBBN {\n  font-size: 70%;\n}\n\n.report-status--headerFontIcon--45AWvSld {\n  vertical-align: middle;\n  font-size: 80%\n}\n\n.report-status--cellBody--22fcEMJz {\n  text-align: center;\n}\n\n.report-status--checkbox--399pbHYL {\n  margin-left: 20px;\n}\n\n.report-status--startDay--1kkqcAca {\n  display: table-cell;\n  height: 30px;\n  width: 200px;\n  padding-right: 5px;\n  text-align: right;\n  vertical-align: middle;\n  font-size: small;\n}\n\n.report-status--users--46iTRKSp {\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.report-status--noMember--WjJ2PsxS {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.report-status--failed--1sSsYpbf {\n  margin-top: 10px;\n  text-align: center;\n}\n\n.report-status--userInfo--3ui4xFs5 {\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.report-status--sendingMethod--2s5RnL7_ strong {\n  color: black;\n  font-weight: normal;\n}\n\n.report-status--radioGroup--xcXrTH_a {\n  margin-top: 10px;\n}\n\n.report-status--mailContent--1HmJX6eD {\n  padding-left: 20px;\n  color: #757575;\n}\n\n.report-status--googleSignInBtn--bhguzv7o {\n  padding-top: 0px;\n  margin-left: 30px;\n}\n\n.report-status--normalTitle--3lHSLlXc {\n  color: black;\n}\n\n.report-status--folderItem--2vbhwHfE span {\n  padding-left: 0px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/report-status.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,sBAAsB;CACvB;;AAED;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;CACjB;;AAED;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;CACjB;;AAED;EACE,gBAAgB;CACjB;;AAED;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;CACjB;;AAED;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;CACjB;;AAED;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;CACjB;;AAED;EACE,eAAe;CAChB;;AAED;EACE,uBAAuB;EACvB,cAAc;CACf;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;CAClB;;AAED;EACE,oBAAoB;EACpB,gBAAgB;CACjB;;AAED;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;;AAED;EACE,iBAAiB;EACjB,mBAAmB;CACpB;;AAED;EACE,iCAAiC;CAClC;;AAED;EACE,aAAa;EACb,oBAAoB;CACrB;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,mBAAmB;EACnB,eAAe;CAChB;;AAED;EACE,iBAAiB;EACjB,kBAAkB;CACnB;;AAED;EACE,aAAa;CACd;;AAED;EACE,kBAAkB;CACnB","file":"report-status.css","sourcesContent":["\n.activityEmptyBadge {\n  width: 22px;\n  display: inline-block;\n}\n\n.activityIcon {\n  display: inline-block;\n  margin-right: 4px;\n  cursor: pointer;\n}\n\n.activityBadge {\n  border-radius: 50%;\n  background: #999;\n  color: #FFF;\n  height: 16px;\n  width: 16px;\n  display: inline-block;\n  margin-left: -10px;\n  font-size: 10px;\n}\n\n.activityFontIcon {\n  font-size: 18px;\n}\n\n.headerBlack {\n  text-align: center;\n  color: black;\n  cursor: inherit;\n}\n\n.headerRed {\n  text-align: center;\n  color: red;\n  cursor: pointer;\n}\n\n.headerBlue {\n  text-align: center;\n  color: blue;\n  cursor: pointer;\n}\n\n.headerBody {\n  font-size: 70%;\n}\n\n.headerFontIcon {\n  vertical-align: middle;\n  font-size: 80%\n}\n\n.cellBody {\n  text-align: center;\n}\n\n.checkbox {\n  margin-left: 20px;\n}\n\n.startDay {\n  display: table-cell;\n  height: 30px;\n  width: 200px;\n  padding-right: 5px;\n  text-align: right;\n  vertical-align: middle;\n  font-size: small;\n}\n\n.users {\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.noMember {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.failed {\n  margin-top: 10px;\n  text-align: center;\n}\n\n.userInfo {\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.sendingMethod strong {\n  color: black;\n  font-weight: normal;\n}\n\n.radioGroup {\n  margin-top: 10px;\n}\n\n.mailContent {\n  padding-left: 20px;\n  color: #757575;\n}\n\n.googleSignInBtn {\n  padding-top: 0px;\n  margin-left: 30px;\n}\n\n.normalTitle {\n  color: black;\n}\n\n.folderItem span {\n  padding-left: 0px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"activityEmptyBadge": "report-status--activityEmptyBadge--2zsKWcTY",
	"activityIcon": "report-status--activityIcon--rJwCoNxE",
	"activityBadge": "report-status--activityBadge--3h8B6qTj",
	"activityFontIcon": "report-status--activityFontIcon--ypVSGvcy",
	"headerBlack": "report-status--headerBlack--aLC0xZ3t",
	"headerRed": "report-status--headerRed--GtD5cplf",
	"headerBlue": "report-status--headerBlue--2ONvXRNa",
	"headerBody": "report-status--headerBody--mYa5zBBN",
	"headerFontIcon": "report-status--headerFontIcon--45AWvSld",
	"cellBody": "report-status--cellBody--22fcEMJz",
	"checkbox": "report-status--checkbox--399pbHYL",
	"startDay": "report-status--startDay--1kkqcAca",
	"users": "report-status--users--46iTRKSp",
	"noMember": "report-status--noMember--WjJ2PsxS",
	"failed": "report-status--failed--1sSsYpbf",
	"userInfo": "report-status--userInfo--3ui4xFs5",
	"sendingMethod": "report-status--sendingMethod--2s5RnL7_",
	"radioGroup": "report-status--radioGroup--xcXrTH_a",
	"mailContent": "report-status--mailContent--1HmJX6eD",
	"googleSignInBtn": "report-status--googleSignInBtn--bhguzv7o",
	"normalTitle": "report-status--normalTitle--3lHSLlXc",
	"folderItem": "report-status--folderItem--2vbhwHfE"
};

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupRemindPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupRemindPanel = __webpack_require__(2367);

var _groupRemindPanel2 = _interopRequireDefault(_groupRemindPanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _list = __webpack_require__(25);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _menu = __webpack_require__(63);

var _switch = __webpack_require__(227);

var _switch2 = _interopRequireDefault(_switch);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-remind-panel.jsx

var sendAtList = _lodash2.default.times(24, function (hour) {
  return { value: hour, label: hour + ':00' };
});
var weekDayList = ['send_on_sun', 'send_on_mon', 'send_on_tue', 'send_on_wed', 'send_on_thu', 'send_on_fri', 'send_on_sat', 'send_on_holiday'];

function RemindMailMenu(props) {
  var t = props.t,
      isMembershipUpdating = props.isMembershipUpdating,
      group = props.group,
      member = props.member,
      updateRemindMailSetting = props.updateRemindMailSetting;

  var onChange = function onChange(value) {
    console.log('onChnage');
  };
  return _react2.default.createElement(
    'div',
    { style: { width: 150, height: 52, right: 0, paddingTop: 15 } },
    _react2.default.createElement(_switch2.default, {
      checked: member.remind_mail,
      disabled: isMembershipUpdating,
      onChange: function onChange(value) {
        return updateRemindMailSetting(props, member, value);
      } })
  );
}

var GroupRemindPanel = function (_React$Component) {
  _inherits(GroupRemindPanel, _React$Component);

  function GroupRemindPanel() {
    _classCallCheck(this, GroupRemindPanel);

    return _possibleConstructorReturn(this, (GroupRemindPanel.__proto__ || Object.getPrototypeOf(GroupRemindPanel)).apply(this, arguments));
  }

  _createClass(GroupRemindPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          group = _props.group,
          isRemindSettingUpdating = _props.isRemindSettingUpdating,
          remindSchedule = _props.remindSchedule,
          updateRemindSchedule = _props.updateRemindSchedule,
          cancelAllRemind = _props.cancelAllRemind,
          updateRemindMailSetting = _props.updateRemindMailSetting,
          isMembershipUpdating = _props.isMembershipUpdating;

      var isNoReminder = remindSchedule && _lodash2.default.reduce(weekDayList, function (result, item) {
        return result && !remindSchedule[item];
      }, true) || false;
      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          !remindSchedule && _react2.default.createElement(_loading2.default, null),
          remindSchedule && _react2.default.createElement(
            'strong',
            null,
            t('label:タイムゾーン')
          ),
          remindSchedule && _react2.default.createElement(_dropdown2.default, { auto: true,
            value: remindSchedule.timezone,
            template: function template(item) {
              return _react2.default.createElement(
                'span',
                null,
                item.label,
                ':\xA0',
                t('timezone:' + item.label)
              );
            },
            source: _lodash2.default.map(_lodash2.default.range(-12, 15), function (i) {
              return { value: i, label: 'UTC' + (i < 0 ? '-' : '+') + Math.abs(i) };
            }),
            onChange: function onChange(value) {
              return updateRemindSchedule(_this2.props, 'timezone', value);
            } }),
          remindSchedule && _react2.default.createElement(
            'strong',
            null,
            t('label:リマインド通知時刻')
          ),
          remindSchedule && _react2.default.createElement(_dropdown2.default, { auto: true,
            source: sendAtList,
            value: remindSchedule.send_at,
            template: function template(time) {
              return _react2.default.createElement(
                'span',
                null,
                t('label:時ごろに通知', { time: time.label })
              );
            },
            onChange: function onChange(value) {
              return updateRemindSchedule(_this2.props, 'send_at', value);
            } }),
          remindSchedule && _react2.default.createElement(
            'strong',
            null,
            t('label:リマインド通知日')
          ),
          remindSchedule && _react2.default.createElement(
            _list.List,
            null,
            _react2.default.createElement(_list.ListCheckbox, { disabled: isRemindSettingUpdating,
              caption: t('label:すべてのリマインド通知を送らない'),
              checked: isNoReminder,
              onChange: function onChange() {
                return cancelAllRemind(_this2.props);
              } }),
            _lodash2.default.map(weekDayList, function (item) {
              return _react2.default.createElement(_list.ListCheckbox, { key: item, disabled: isRemindSettingUpdating,
                caption: t('label:' + item),
                checked: remindSchedule[item],
                onChange: function onChange() {
                  return updateRemindSchedule(_this2.props, item, !remindSchedule[item]);
                } });
            })
          ),
          remindSchedule && !isNoReminder && _react2.default.createElement(
            'strong',
            null,
            t('label:個別リマインド通知')
          ),
          remindSchedule && !isNoReminder && _react2.default.createElement(
            'div',
            { key: 'title', className: _flatCard2.default.labelContainer },
            _react2.default.createElement(
              'div',
              { key: 'remider', className: _flatCard2.default.remindLabel },
              t('label:リマインド通知')
            )
          ),
          remindSchedule && !isNoReminder && _react2.default.createElement(
            _list.List,
            null,
            _lodash2.default.map(group.members, function (member, i) {
              return _react2.default.createElement(_list.ListItem, { key: member.user_id, selectable: false, ripple: false, index: i,
                avatar: member.icon_image.thumb_url,
                caption: member.name,
                rightActions: [_react2.default.createElement(RemindMailMenu, { key: 'remind_menu', t: t, group: group, member: member,
                  isMembershipUpdating: isMembershipUpdating,
                  updateRemindMailSetting: updateRemindMailSetting })]
              });
            })
          )
        )
      );
    }
  }]);

  return GroupRemindPanel;
}(_react2.default.Component);

var RawGroupRemindPanel = exports.RawGroupRemindPanel = GroupRemindPanel;
exports.default = (0, _groupRemindPanel2.default)(GroupRemindPanel);

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    group: (0, _store.getArray)('group_id', state.groups.items, ownProps.group.group_id),
    isRemindSettingUpdating: state.groups.isRemindSettingUpdating,
    isRemindSettingUpdateFailed: state.groups.isRemindSettingUpdateFailed,
    remindSchedule: state.groups.remindSchedule,
    isMembershipUpdating: state.groups.isMembershipUpdating
  };
};
// src/connects/group-remind-panel.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    updateRemindSchedule: function updateRemindSchedule(props, item, value) {
      dispatch(_actions2.default.updateRemindMailSchedule(props.group.group_id, item == 'send_on_sun' ? value : props.remindSchedule.send_on_sun, item == 'send_on_mon' ? value : props.remindSchedule.send_on_mon, item == 'send_on_tue' ? value : props.remindSchedule.send_on_tue, item == 'send_on_wed' ? value : props.remindSchedule.send_on_wed, item == 'send_on_thu' ? value : props.remindSchedule.send_on_thu, item == 'send_on_fri' ? value : props.remindSchedule.send_on_fri, item == 'send_on_sat' ? value : props.remindSchedule.send_on_sat, item == 'send_on_holiday' ? value : props.remindSchedule.send_on_holiday, item == 'send_at' ? value : props.remindSchedule.send_at, item == 'timezone' ? value : props.remindSchedule.timezone));
      dispatch((0, _alertMessage.emitAlertMessage)('label:リマインド通知の送信スケジュールを変更しました', 'success'));
    },

    cancelAllRemind: function cancelAllRemind(props) {
      dispatch(_actions2.default.updateRemindMailSchedule(props.group.group_id, false, false, false, false, false, false, false, false, props.remindSchedule.send_at, props.remindSchedule.timezone));
      dispatch((0, _alertMessage.emitAlertMessage)('label:リマインド通知の送信スケジュールを変更しました', 'success'));
    },

    willMount: function willMount(props) {
      return dispatch(_actions2.default.fetchRemindMailSettings(props.group.group_id));
    },

    updateRemindMailSetting: function updateRemindMailSetting(props, user, delivery) {
      dispatch(_actions2.default.updateRemindMailSetting(props.group.group_id, user.user_id, delivery));
      if (delivery) dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:ユーザへのリマインドメールの送信を開始します', name: user.name }, 'success'));else dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:ユーザへのリマインドメールの送信を停止しました', name: user.name }, 'success'));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupReportPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupReportPanel = __webpack_require__(2369);

var _groupReportPanel2 = _interopRequireDefault(_groupReportPanel);

var _card = __webpack_require__(28);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _datePicker = __webpack_require__(165);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _input = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-remind-panel.jsx

var GroupReportPanel = function (_React$Component) {
  _inherits(GroupReportPanel, _React$Component);

  function GroupReportPanel() {
    _classCallCheck(this, GroupReportPanel);

    return _possibleConstructorReturn(this, (GroupReportPanel.__proto__ || Object.getPrototypeOf(GroupReportPanel)).apply(this, arguments));
  }

  _createClass(GroupReportPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          group = _props.group,
          isWeeklyReport = _props.isWeeklyReport,
          isMonthlyReport = _props.isMonthlyReport,
          weeklyReportStartDate = _props.weeklyReportStartDate,
          monthlyReportStartDate = _props.monthlyReportStartDate,
          inputDiaryUserCount = _props.inputDiaryUserCount,
          updateIsWeeklyReport = _props.updateIsWeeklyReport,
          updateIsMonthlyReport = _props.updateIsMonthlyReport,
          updateWeeklyReportStartDate = _props.updateWeeklyReportStartDate,
          updateMonthlyReportStartDate = _props.updateMonthlyReportStartDate,
          updateInputDiaryUserCount = _props.updateInputDiaryUserCount;

      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default, className: _flatCard2.default.settingsCard },
        _react2.default.createElement(
          _card.CardText,
          { className: _flatCard2.default.settingsCardContent },
          _react2.default.createElement(
            'strong',
            null,
            t('label:週間レポート')
          ),
          _react2.default.createElement(_checkbox2.default, { label: t('label:週間レポートを出力する'),
            className: _flatCard2.default.settingsCheckbox,
            checked: isWeeklyReport,
            onChange: function onChange(value) {
              return updateIsWeeklyReport(_this2.props, value);
            } }),
          _react2.default.createElement(
            _card.CardText,
            { className: _flatCard2.default.settingsSubSection },
            _react2.default.createElement(
              'strong',
              null,
              t('label:週間レポート出力開始日')
            ),
            _react2.default.createElement(_datePicker2.default, { value: weeklyReportStartDate,
              className: _flatCard2.default.settingsDatePicker,
              onChange: function onChange(date) {
                return updateWeeklyReportStartDate(_this2.props, date);
              } })
          ),
          _react2.default.createElement(
            'strong',
            null,
            t('label:月間レポート')
          ),
          _react2.default.createElement(_checkbox2.default, { label: t('label:月間レポートを出力する'),
            className: _flatCard2.default.settingsCheckbox,
            checked: isMonthlyReport,
            onChange: function onChange(value) {
              return updateIsMonthlyReport(_this2.props, value);
            } }),
          _react2.default.createElement(
            _card.CardText,
            { className: _flatCard2.default.settingsSubSection },
            _react2.default.createElement(
              'strong',
              null,
              t('label:月間レポート出力開始日')
            ),
            _react2.default.createElement(_datePicker2.default, { value: monthlyReportStartDate ? monthlyReportStartDate : new Date("2024-09-01"),
              className: _flatCard2.default.settingsDatePicker,
              onChange: function onChange(date) {
                return updateMonthlyReportStartDate(_this2.props, date);
              } })
          )
        )
      );
    }
  }]);

  return GroupReportPanel;
}(_react2.default.Component);

var RawGroupReportPanel = exports.RawGroupReportPanel = GroupReportPanel;
exports.default = (0, _groupReportPanel2.default)(GroupReportPanel);

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

var _diaryReport = __webpack_require__(467);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {

  var weeklyReportStartDate = null;
  if (state.diaryReport.weeklyReportStartDate) {
    weeklyReportStartDate = (0, _moment2.default)(state.diaryReport.weeklyReportStartDate).toDate();
  }

  var monthlyReportStartDate = null;
  if (state.diaryReport.monthlyReportStartDate) {
    monthlyReportStartDate = (0, _moment2.default)(state.diaryReport.monthlyReportStartDate).toDate();
  }
  return {
    group: (0, _store.getArray)('group_id', state.groups.items, ownProps.group.group_id),
    isWeeklyReport: state.diaryReport.isWeeklyReport,
    isMonthlyReport: state.diaryReport.isMonthlyReport,
    weeklyReportStartDate: weeklyReportStartDate,
    monthlyReportStartDate: monthlyReportStartDate,
    inputDiaryUserCount: state.diaryReport.inputDiaryUserCount
  };
};
// src/connects/group-remind-panel.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willMount: function willMount(props) {
      if (props.group) {
        dispatch(_actions2.default.fetchDiary(props.group.group_id));
      }
    },
    updateIsWeeklyReport: function updateIsWeeklyReport(props, value) {
      dispatch(_actions2.default.putDiaryReportReport(props.group.group_id, value, props.isMonthlyReport, formatDate(props.weeklyReportStartDate), formatDate(props.monthlyReportStartDate), props.inputDiaryUserCount));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:レポート設定を更新しました' }, 'inputSuccess'));
    },
    updateIsMonthlyReport: function updateIsMonthlyReport(props, value) {
      dispatch(_actions2.default.putDiaryReportReport(props.group.group_id, props.isWeeklyReport, value, formatDate(props.weeklyReportStartDate), formatDate(props.monthlyReportStartDate), props.inputDiaryUserCount));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:レポート設定を更新しました' }, 'inputSuccess'));
    },
    updateWeeklyReportStartDate: function updateWeeklyReportStartDate(props, value) {
      dispatch(_actions2.default.putDiaryReportReport(props.group.group_id, props.isWeeklyReport, props.isMonthlyReport, formatDate(value), formatDate(props.monthlyReportStartDate), props.inputDiaryUserCount));
    },
    updateMonthlyReportStartDate: function updateMonthlyReportStartDate(props, value) {
      dispatch(_actions2.default.putDiaryReportReport(props.group.group_id, props.isWeeklyReport, props.isMonthlyReport, formatDate(props.weeklyReportStartDate), formatDate(value), props.inputDiaryUserCount));
    },
    updateInputDiaryUserCount: function updateInputDiaryUserCount(props, value) {
      dispatch(_actions2.default.putDiaryReportReport(props.group.group_id, props.isWeeklyReport, props.isMonthlyReport, formatDate(props.weeklyReportStartDate), formatDate(props.monthlyReportStartDate), value));
    }
  };
};

function formatDate(value) {
  if (!value) {
    return null;
  }
  return (0, _moment2.default)(value).format('YYYY-MM-DD');
}

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupDeletePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _groupDeletePanel = __webpack_require__(2371);

var _groupDeletePanel2 = _interopRequireDefault(_groupDeletePanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-delete-page.jsx

var GroupDeletePage = function (_React$Component) {
  _inherits(GroupDeletePage, _React$Component);

  function GroupDeletePage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GroupDeletePage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupDeletePage.__proto__ || Object.getPrototypeOf(GroupDeletePage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { deleteConfirm: false, deleteCheck: false }, _this.toggleConfirmDialog = function () {
      return _this.setState({ deleteConfirm: !_this.state.deleteConfirm });
    }, _this.onCancel = function () {
      _this.setState({ deleteConfirm: !_this.state.deleteConfirm, deleteCheck: !_this.state.deleteCheck });
    }, _this.deleteGroup = function () {
      _this.toggleConfirmDialog();
      _this.props.deleteGroup();
    }, _this.onCheck = function () {
      _this.setState({ deleteCheck: !_this.state.deleteCheck });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GroupDeletePage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(
            'p',
            { style: { fontSize: 16, color: 'black', marginBottom: 5 } },
            t('label:グループをごみ箱に移動')
          ),
          _react2.default.createElement(
            'p',
            { style: { fontSize: 16, color: 'black', marginBottom: 5 } },
            t('label:グループをごみ箱に移動してもよろしいですか')
          ),
          _react2.default.createElement(_checkbox2.default, {
            theme: _flatCard2.default,
            className: 'deleteCheck',
            checked: this.state.deleteCheck,
            onChange: this.onCheck,
            label: t('label:この操作はグループに参加している全てのユーザーに影響します') }),
          _react2.default.createElement(
            'div',
            { style: { marginLeft: 28 } },
            t('label:完全削除復元説明文')
          )
        ),
        _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(_button.Button, { raised: true, primary: true,
            type: 'submit',
            style: { width: '100%' },
            label: t('label:ごみ箱に移動'),
            disabled: !this.state.deleteCheck,
            onClick: this.toggleConfirmDialog
          })
        ),
        _react2.default.createElement(_confirmDialog2.default, { key: 'dialog',
          open: this.state.deleteConfirm,
          title: t('label:グループをごみ箱に移動してもよろしいですか'),
          description: _react2.default.createElement(
            'div',
            { style: { flexDirection: 'column' } },
            _react2.default.createElement(
              'div',
              null,
              t('label:この操作はグループに参加している全てのユーザーに影響します')
            ),
            _react2.default.createElement(
              'div',
              null,
              t('label:完全削除復元説明文')
            )
          ),
          yesLabel: t('label:ごみ箱に移動'),
          noLabel: t('label:取り消し'),
          onNo: this.onCancel,
          onYes: function onYes() {
            return _this2.deleteGroup();
          } })
      );
    }
  }]);

  return GroupDeletePage;
}(_react2.default.Component);

var RawGroupDeletePage = exports.RawGroupDeletePage = GroupDeletePage;
exports.default = (0, _groupDeletePanel2.default)(GroupDeletePage);

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * src/connects/group-delete-panel.js
 */

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    deleteGroup: function deleteGroup() {
      ownProps.onCloseDialog && ownProps.onCloseDialog();
      dispatch(_actions2.default.deleteGroup(ownProps.group.group_id));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:ごみ箱に移動トースト', name: ownProps.group.name }, 'success'));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(undefined, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

var _saveSearchQueryTemp = __webpack_require__(488);

var _saveSearchQueryTemp2 = _interopRequireDefault(_saveSearchQueryTemp);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _agentType = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
// src/connects/search-drawer.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: state.user.current,
    isFetching: state.preservedQueries.isFetching,
    preservedQueries: state.preservedQueries.items,
    isHome: ownProps.params && ownProps.params.group_id == 'home' || false // スマホ版用
  };
};

var initialUIState = {
  group_id: 'home',
  queryText: '',
  category: 'all',
  liked_by: undefined,
  files_attached: false,
  users: undefined,
  reported_at: undefined,
  datePicker: false,
  deleteConfirm: false,
  deleteQueryName: undefined,
  deleteQuery: undefined,
  keyboardHeight: undefined

  /*
   * 検索条件の一時保存(savedTempSearchQuery)
   * 下記のようにグループ毎に検索条件が保存される
   *
   * [{"group_id":1,"queryText":"tem","category":"all"...
   * {"group_id":2,"queryText":"temddeede","category":"all"...
   * {"group_id":"home","queryText":"rlprfr","category":"all"...}]
   *
   */

};var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willMount: function willMount(props) {
      var group = props.group,
          updateUI = props.updateUI,
          isHome = props.isHome;

      if (group && group.group_id || isHome) {
        updateUI({ group_id: isHome ? 'home' : group.group_id });
        _saveSearchQueryTemp2.default.get(function (items) {
          if (items) {
            // 検索条件の一時保存 読み込み
            var groupSearchHistory = (0, _find2.default)(items, function (_item) {
              return isHome && _item.group_id == 'home' || _item.group_id == group.group_id;
            });
            groupSearchHistory && updateUI(groupSearchHistory);
          }
        });
      }
      if (_agentType.isSmartPhone) {
        updateUI({ openSearchDrawer: true });
      }
    },
    willUpdate: function willUpdate(props, nextProps) {
      var group = nextProps.group,
          updateUI = nextProps.updateUI,
          active = nextProps.active,
          isHome = nextProps.isHome;

      if (!props.active && active || !props.ui.openSearchDrawer && nextProps.ui.openSearchDrawer) {
        dispatch(_actions2.default.fetchPreservedQueries(group && group.group_id != 'home' && !isHome && group.group_id || undefined));
        if (group && group.group_id || isHome) {
          _saveSearchQueryTemp2.default.get(function (items) {
            // 検索条件の一時保存 読み込み
            var groupSearchHistory = isHome && (0, _find2.default)(items, function (_item) {
              return _item.group_id == 'home';
            }) || group && (0, _find2.default)(items, function (_item) {
              return _item.group_id == group.group_id;
            });
            groupSearchHistory && updateUI(groupSearchHistory) || updateUI({ group_id: isHome ? 'home' : group.group_id });
          });
        }
      }

      if (props.active && !active) {
        nextProps.updateUI(initialUIState);
      }
    },

    submitQuery: function submitQuery(props, ev) {
      var onClose = props.onClose,
          ui = props.ui,
          group = props.group,
          isHome = props.isHome,
          updateUI = props.updateUI;

      ev && ev.preventDefault && ev.preventDefault();
      onClose && onClose();
      dispatch(_actions2.default.openRightSidePage('search_timeline', {
        category: ui.category,
        files_attached: ui.files_attached,
        liked_by: ui.liked_by,
        users: ui.users,
        reported_at: ui.reported_at,
        group_id: group && group.group_id != 'home' && !isHome && group.group_id || undefined,
        query: ui.queryText,
        isHome: _agentType.isSmartPhone ? isHome : undefined
      }));
      if (group && group.group_id || isHome) {
        _saveSearchQueryTemp2.default.get(function (items) {
          if (items) {
            // 検索条件の一時保存 上書き処理
            var noChangeList = isHome && (0, _filter2.default)(items, function (_item) {
              return _item.group_id != 'home';
            }) || (0, _filter2.default)(items, function (_item) {
              return group && group.group_id != _item.group_id;
            });
            _saveSearchQueryTemp2.default.set([].concat(_toConsumableArray(noChangeList), [ui]));
          } else {
            // 検索条件の一時保存 新規作成
            var initialFirstHistory = [];
            _saveSearchQueryTemp2.default.set([].concat(initialFirstHistory, [ui]));
          }
        });
        updateUI(initialUIState);
      }
    },

    selectPreservedQuery: function selectPreservedQuery(props, query) {
      var onClose = props.onClose,
          group = props.group,
          isHome = props.isHome,
          updateUI = props.updateUI;

      onClose && onClose();
      dispatch(_actions2.default.openRightSidePage('search_timeline', _agentType.isSmartPhone ? { query_id: query.query_id, isHome: isHome } : { query_id: query.query_id }));
      if (group && group.group_id || isHome) {
        var overWriteQuery = query && JSON.parse(query.query_text);
        var overWriteState = {
          group_id: isHome || group.group_id == 'home' ? 'home' : query.group_id,
          queryText: overWriteQuery.queryText,
          liked_by: overWriteQuery.liked_by,
          category: overWriteQuery.category,
          files_attached: overWriteQuery.files_attached,
          users: query.users,
          reported_at: overWriteQuery.reported_at,
          datePicker: false,
          deleteConfirm: false,
          deleteQueryName: undefined,
          deleteQuery: undefined,
          keyboardHeight: undefined
        };
        _saveSearchQueryTemp2.default.get(function (items) {
          if (items) {
            // 検索条件の上書き
            var noChangeList = isHome && (0, _filter2.default)(items, function (_item) {
              return _item.group_id != 'home';
            }) || (0, _filter2.default)(items, function (_item) {
              return group && group.group_id != _item.group_id;
            });
            _saveSearchQueryTemp2.default.set([].concat(_toConsumableArray(noChangeList), [overWriteState]));
          } else {
            // 検索条件の一時保存 新規作成
            var initialFirstHistory = [];
            _saveSearchQueryTemp2.default.set([].concat(initialFirstHistory, [overWriteState]));
          }
        });
        updateUI(initialUIState);
      }
    },
    deletePreservedQuery: function deletePreservedQuery(query, shouldClosePage) {
      dispatch(_actions2.default.deletePreservedQuery(query.query_id));
      shouldClosePage && dispatch(_actions2.default.closeRightSidePage()); //Webの場合、検索結果を開いた状態で削除を行うと検索結果内で再度条件の保存ができないため、サイドページを閉じるようにした
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:検索条件を削除しました', name: query.name }, 'topSuccess'));
    },
    clearSearchQuery: function clearSearchQuery(props) {
      var ui = props.ui,
          group = props.group,
          isHome = props.isHome,
          updateUI = props.updateUI;

      updateUI(initialUIState);
      _saveSearchQueryTemp2.default.get(function (items) {
        if (items) {
          // 検索条件の一時保存 削除処理
          var noChangeList = isHome && (0, _filter2.default)(items, function (_item) {
            return _item.group_id != 'home';
          }) || (0, _filter2.default)(items, function (_item) {
            return group && group.group_id != _item.group_id;
          });
          _saveSearchQueryTemp2.default.set([].concat(_toConsumableArray(noChangeList)));
        }
      });
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: initialUIState
}), _lifecycle2.default, (0, _context2.default)({ showUserSelectionDialog: _propTypes2.default.func }), (0, _reactI18next.translate)());

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2374);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js?importLoaders=1!../../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js!../../../../../../../shared/rnclient/node_modules/extract-text-webpack-plugin/loader.js??ref--12-0!../../../../../../../shared/rnclient/node_modules/style-loader/index.js!../../../../../../../shared/rnclient/node_modules/css-loader/index.js?sourceMap&localIdentName=[local]___[hash:base64:5]!../../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js?outputStyle=expanded!./search-drawer.scss", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js?importLoaders=1!../../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js!../../../../../../../shared/rnclient/node_modules/extract-text-webpack-plugin/loader.js??ref--12-0!../../../../../../../shared/rnclient/node_modules/style-loader/index.js!../../../../../../../shared/rnclient/node_modules/css-loader/index.js?sourceMap&localIdentName=[local]___[hash:base64:5]!../../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js?outputStyle=expanded!./search-drawer.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.z-index-menu--menu--tHwgxZRJ {\n  z-index: 1200!important;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/z-index-menu.css"],"names":[],"mappings":";AACA;EACE,wBAAwB;CACzB","file":"z-index-menu.css","sourcesContent":["\n.menu {\n  z-index: 1200!important;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"menu": "z-index-menu--menu--tHwgxZRJ"
};

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.no-wrapped-navigation--horizontal--Wxu4eLB4 {\n  white-space: nowrap;\n  position: relative;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/no-wrapped-navigation.css"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,mBAAmB;CACpB","file":"no-wrapped-navigation.css","sourcesContent":["\n.horizontal {\n  white-space: nowrap;\n  position: relative;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"horizontal": "no-wrapped-navigation--horizontal--Wxu4eLB4"
};

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.app-bar--appBar--28uRPVTO {\n  height: 46px;\n  background: #252525;\n}\n\n/* スマホ用スタイル */\n\n@media screen and (max-width: 768px) {\n  .app-bar--appBar--28uRPVTO {\n    background: #ffffff;\n    color: #555555;\n    border-bottom: 1px solid rgba(0, 0, 0, .1)!important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, .1)!important;\n    z-index: 1!important;\n  }\n\n  .app-bar--appBar--28uRPVTO [data-react-toolbox=\"button\"] {\n    color: #555555;\n  }\n\n  .app-bar--appBar--28uRPVTO [data-react-toolbox=\"font-icon\"] {\n    color: #555555;\n  }\n\n  .app-bar--appBar--28uRPVTO [data-react-toolbox=\"avatar\"] {\n    background: #f5f5f5;\n    color: #555555;\n  }\n\n  .app-bar--navigation--c1QdVuXD {\n    background: transparent;\n    color: #555555;\n  }\n}", "", {"version":3,"sources":["/./src/web/components/themes/app-bar.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,oBAAoB;CACrB;;AAED,cAAc;;AAEd;EACE;IACE,oBAAoB;IACpB,eAAe;IACf,qDAAqD;IACrD,kDAAkD;IAClD,qBAAqB;GACtB;;EAED;IACE,eAAe;GAChB;;EAED;IACE,eAAe;GAChB;;EAED;IACE,oBAAoB;IACpB,eAAe;GAChB;;EAED;IACE,wBAAwB;IACxB,eAAe;GAChB;CACF","file":"app-bar.css","sourcesContent":["\n.appBar {\n  height: 46px;\n  background: #252525;\n}\n\n/* スマホ用スタイル */\n\n@media screen and (max-width: 768px) {\n  .appBar {\n    background: #ffffff;\n    color: #555555;\n    border-bottom: 1px solid rgba(0, 0, 0, .1)!important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, .1)!important;\n    z-index: 1!important;\n  }\n\n  .appBar [data-react-toolbox=\"button\"] {\n    color: #555555;\n  }\n\n  .appBar [data-react-toolbox=\"font-icon\"] {\n    color: #555555;\n  }\n\n  .appBar [data-react-toolbox=\"avatar\"] {\n    background: #f5f5f5;\n    color: #555555;\n  }\n\n  .navigation {\n    background: transparent;\n    color: #555555;\n  }\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"appBar": "app-bar--appBar--28uRPVTO",
	"navigation": "app-bar--navigation--c1QdVuXD"
};

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _albumPage = __webpack_require__(995);

var _albumPage2 = _interopRequireDefault(_albumPage);

var _groupAlbum = __webpack_require__(2382);

var _groupAlbum2 = _interopRequireDefault(_groupAlbum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/web/components/group-album.jsx

exports.default = (0, _groupAlbum2.default)(_albumPage2.default);

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/chat-album-image-item.jsx

var AlbumImageItem = function (_React$Component) {
  _inherits(AlbumImageItem, _React$Component);

  function AlbumImageItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AlbumImageItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumImageItem.__proto__ || Object.getPrototypeOf(AlbumImageItem)).call.apply(_ref, [this].concat(args))), _this), _this.showImagesView = function (image) {
      return _this.props.showImagesView('OUT_OF_LIST', undefined, image);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AlbumImageItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          image = _props.image,
          users = _props.users,
          showImagesView = _props.showImagesView;


      var num = image && image.name.lastIndexOf('.');
      var basename = num != -1 && image.name.slice(0, num) || image.name;
      var extension = num != -1 && image.name.slice(num + 1, image.name.length).toLowerCase() || '';
      // ファイル名が長い場合は途中を...で省略する
      var imagename = basename.length > 20 ? basename.slice(0, 20) + '...' + extension : image.name;

      return _react2.default.createElement(
        'div',
        { style: { padding: '2.5%', cursor: 'pointer' }, onClick: function onClick() {
            return _this2.showImagesView(image);
          } },
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '75%', borderTopLeftRadius: 10, borderTopRightRadius: 10 } },
          _react2.default.createElement('img', { src: image.file.url,
            style: { height: '100%', width: '100%', objectFit: 'cover', borderTopLeftRadius: 10, borderTopRightRadius: 10 } })
        ),
        _react2.default.createElement(
          'div',
          { style: { backgroundColor: '#dadce0', height: '25%', padding: '5px 16px 5px 16px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10 } },
          _react2.default.createElement(
            'p',
            { style: { color: 'rgb(33, 33, 33)' } },
            imagename
          ),
          _react2.default.createElement(
            'p',
            { style: { color: 'rgb(117, 117, 117)' } },
            image.user.name
          ),
          _react2.default.createElement(
            'p',
            { style: { color: 'rgb(117, 117, 117)' } },
            (0, _moment2.default)(image.created_at).format('LLL')
          )
        )
      );
    }
  }]);

  return AlbumImageItem;
}(_react2.default.Component);

exports.default = AlbumImageItem;

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/chat-album-video-item.jsx

var AlbumVideoItem = function (_React$Component) {
  _inherits(AlbumVideoItem, _React$Component);

  function AlbumVideoItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AlbumVideoItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumVideoItem.__proto__ || Object.getPrototypeOf(AlbumVideoItem)).call.apply(_ref, [this].concat(args))), _this), _this.showImagesView = function (video) {
      return _this.props.showImagesView('OUT_OF_LIST', undefined, video);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AlbumVideoItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          video = _props.video,
          users = _props.users,
          postName = _props.postName,
          showImagesView = _props.showImagesView;


      var num = video && video.name.lastIndexOf('.');
      var basename = num != -1 && video.name.slice(0, num) || video.name;
      var extension = num != -1 && video.name.slice(num + 1, video.name.length).toLowerCase() || '';
      // ファイル名が長い場合は途中を...で省略する
      var videoname = basename.length > 20 ? basename.slice(0, 20) + '...' + extension : video.name;

      //動画の再生時間
      var minutes = video.duration && Math.floor(video.duration / 60) || '0';
      var seconds = video.duration && video.duration % 60 || '0';
      var duration = minutes + ":" + (seconds < 10 ? '0' : '') + seconds;

      return video.content_type.match(/^video/) && video.status == 'committed' && _react2.default.createElement(
        'div',
        { style: { padding: '2.5%', cursor: 'pointer' }, onClick: function onClick() {
            return _this2.showImagesView(video);
          } },
        _react2.default.createElement(
          'div',
          { style: { position: 'relative', height: '75%' } },
          _react2.default.createElement('img', {
            style: { height: '100%', width: '100%', borderTopLeftRadius: 10, borderTopRightRadius: 10 },
            src: video.file.thumb_url }),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, justifyContent: 'center', alignItems: 'center' } },
            _react2.default.createElement(_avatar2.default, { icon: 'play_arrow' })
          ),
          video.duration ? _react2.default.createElement(
            'div',
            { style: { position: 'absolute', borderRadius: 5, margin: 5, padding: 3, right: 0, bottom: 0, backgroundColor: '#000', justifyContent: 'center', alignItems: 'center' } },
            _react2.default.createElement(
              'p',
              { style: { color: '#FFFFFF' } },
              duration
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { style: { backgroundColor: '#dadce0', height: '25%', padding: '5px 16px 5px 16px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10 } },
          _react2.default.createElement(
            'p',
            { style: { color: 'rgb(33, 33, 33)' } },
            videoname
          ),
          _react2.default.createElement(
            'p',
            { style: { color: 'rgb(117, 117, 117)' } },
            video.user.name
          ),
          _react2.default.createElement(
            'p',
            { style: { color: 'rgb(117, 117, 117)' } },
            (0, _moment2.default)(video.created_at).format('LLL')
          )
        )
      ) || _react2.default.createElement(
        'div',
        { style: { padding: '2.5%', cursor: 'pointer' }, onClick: function onClick() {
            return _this2.showImagesView(video);
          } },
        _react2.default.createElement(
          'div',
          { style: { position: 'relative', justifyContent: 'center', alignItems: 'center', height: '75%', backgroundColor: 'whitesmoke', borderTopLeftRadius: 10, borderTopRightRadius: 10 } },
          _react2.default.createElement(_font_icon2.default, { value: 'music_note', style: { fontSize: 50, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', WebkitTransform: 'translate(-50%, -50%)', msTransform: 'translate(-50%, -50%)' } }),
          video.duration ? _react2.default.createElement(
            'div',
            { style: { position: 'absolute', borderRadius: 5, margin: 5, padding: 3, right: 0, bottom: 0, backgroundColor: '#000', justifyContent: 'center', alignItems: 'center' } },
            _react2.default.createElement(
              'p',
              { style: { color: '#FFFFFF' } },
              duration
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { style: { backgroundColor: '#dadce0', height: '25%', padding: '5px 16px 5px 16px', borderBottomLeftRadius: 10, borderBottomRightRadius: 10 } },
          _react2.default.createElement(
            'p',
            { style: { color: 'rgb(33, 33, 33)' } },
            videoname
          ),
          _react2.default.createElement(
            'p',
            { style: { color: 'rgb(117, 117, 117)' } },
            video.user.name
          ),
          _react2.default.createElement(
            'p',
            { style: { color: 'rgb(117, 117, 117)' } },
            (0, _moment2.default)(video.created_at).format('LLL')
          )
        )
      );
    }
  }]);

  return AlbumVideoItem;
}(_react2.default.Component);

exports.default = AlbumVideoItem;

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _list = __webpack_require__(25);

var _link = __webpack_require__(183);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/chat-album-file-item.jsx

var AlbumFileItem = function (_React$Component) {
  _inherits(AlbumFileItem, _React$Component);

  function AlbumFileItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AlbumFileItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlbumFileItem.__proto__ || Object.getPrototypeOf(AlbumFileItem)).call.apply(_ref, [this].concat(args))), _this), _this.showPdf = function (file) {
      return _this.props.openPdf(file, true);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AlbumFileItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          file = _props.file,
          users = _props.users,
          openPdf = _props.openPdf;


      return _react2.default.createElement(
        _list.List,
        null,
        _react2.default.createElement(
          _list.ListItem,
          { selectable: true, leftIcon: file.content_type.match(/^application\/pdf/) ? 'picture_as_pdf' : 'attach_file' },
          _react2.default.createElement(
            _list.ListItemContent,
            null,
            file.content_type.match(/^application\/pdf/) && _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.showPdf(file);
                }, style: { height: 72, display: 'flex', flexDirection: 'column', justifyContent: 'center' } },
              _react2.default.createElement(
                'p',
                { style: { color: 'rgb(33, 33, 33)', fontSize: 16 } },
                file.name
              ),
              _react2.default.createElement(
                'p',
                { style: { color: 'rgb(117, 117, 117)' } },
                file.user.name
              ),
              _react2.default.createElement(
                'p',
                { style: { color: 'rgb(117, 117, 117)', fontSize: 14, paddingTop: 3, whiteSpace: 'normal' } },
                (0, _moment2.default)(file.created_at).format('LLL')
              )
            ) || _react2.default.createElement(
              _link2.default,
              {
                href: file.file.url,
                target: "_blank",
                rel: "noopener noreferrer",
                style: { display: 'inline', textDecoration: 'none' },
                download: true },
              _react2.default.createElement(
                'div',
                { style: { height: 72, display: 'flex', flexDirection: 'column', justifyContent: 'center' } },
                _react2.default.createElement(
                  'p',
                  { style: { color: 'rgb(33, 33, 33)', fontSize: 16 } },
                  file.name
                ),
                _react2.default.createElement(
                  'p',
                  { style: { color: 'rgb(117, 117, 117)' } },
                  file.user.name
                ),
                _react2.default.createElement(
                  'p',
                  { style: { color: 'rgb(117, 117, 117)', fontSize: 14, paddingTop: 3, whiteSpace: 'normal' } },
                  (0, _moment2.default)(file.created_at).format('LLL')
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AlbumFileItem;
}(_react2.default.Component);

exports.default = AlbumFileItem;

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/group-album.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isFetching: state.groups.isFetching,
    isFetchFailed: state.groups.isFetchFailed,
    images: state.groups.imageItems,
    files: state.groups.fileItems,
    videos: state.groups.videoItems,
    hasMoreImage: state.groups.hasMoreImage,
    hasMoreFile: state.groups.hasMoreFile,
    hasMoreVideo: state.groups.hasMoreVideo,
    group: ownProps.group || ownProps.params.group
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var group = ownProps.group || ownProps.params.group;
  var group_id = group && group.group_id;
  return {
    willMount: function willMount(props) {
      dispatch(_actions2.default.fetchAlbumGroupImage(group_id, 'image', 0));
    },
    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearGroupAlbum());
    },
    fetchImage: function fetchImage(props) {
      var offset = props.images && props.images.length || 0;
      dispatch(_actions2.default.fetchAlbumGroupImage(group_id, 'image', offset));
    },
    fetchFile: function fetchFile(props) {
      var offset = props.files && props.files.length || 0;
      dispatch(_actions2.default.fetchAlbumGroupFile(group_id, 'others', offset));
    },
    fetchVideo: function fetchVideo(props) {
      var offset = props.videos && props.videos.length || 0;
      dispatch(_actions2.default.fetchAlbumGroupVideo(group_id, offset));
    },
    onChangeTab: function onChangeTab(tabIndex, props) {
      switch (tabIndex) {
        case 0:
          if (!props.images) {
            dispatch(_actions2.default.fetchAlbumGroupImage(group_id, 'image', 0));
          }
          break;
        case 1:
          if (!props.videos) dispatch(_actions2.default.fetchAlbumGroupVideo(group_id, 0));
          break;
        case 2:
          if (!props.files) dispatch(_actions2.default.fetchAlbumGroupFile(group_id, 'others', 0));
          break;
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    tabIndex: function tabIndex(props) {
      return props.params && props.params.tabIndex || 0;
    }
  }
}), (0, _context2.default)({ showImagesView: _propTypes2.default.func }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(374);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(379);

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = __webpack_require__(997);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(548);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(129);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(132);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(133);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mergeClassNames = __webpack_require__(286);

var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);

var _LinkService = __webpack_require__(1015);

var _LinkService2 = _interopRequireDefault(_LinkService);

var _utils = __webpack_require__(134);

var _events = __webpack_require__(385);

var _propTypes3 = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Document = function (_Component) {
  (0, _inherits3.default)(Document, _Component);

  function Document() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Document);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Document.__proto__ || (0, _getPrototypeOf2.default)(Document)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      pdf: null
    }, _this.viewer = {
      scrollPageIntoView: function scrollPageIntoView(_ref2) {
        var pageNumber = _ref2.pageNumber;

        // Handling jumping to internal links target

        // First, check if custom handling of onItemClick was provided
        if (_this.props.onItemClick) {
          _this.props.onItemClick({ pageNumber: pageNumber });
          return;
        }

        // If not, try to look for target page within the <Document>.
        var page = _this.pages[pageNumber - 1];

        if (page) {
          // Scroll to the page automatically
          page.scrollIntoView();
          return;
        }

        (0, _utils.warnOnDev)('Warning: An internal link leading to page ' + pageNumber + ' was clicked, but neither <Document> was provided with onItemClick nor it was able to find the page within itself. Either provide onItemClick to <Document> and handle navigating by yourself or ensure that all pages are rendered within <Document>.');
      }
    }, _this.linkService = new _LinkService2.default(), _this.onSourceSuccess = function (source) {
      (0, _utils.callIfDefined)(_this.props.onSourceSuccess);

      if (!PDFJS) {
        throw new Error('Could not load the document. PDF.js is not loaded.');
      }

      if (!source) {
        return null;
      }

      _this.runningTask = (0, _utils.makeCancellable)(PDFJS.getDocument(source));

      return _this.runningTask.promise.then(_this.onLoadSuccess).catch(_this.onLoadError);
    }, _this.onSourceError = function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      (0, _utils.errorOnDev)(error.message, error);

      (0, _utils.callIfDefined)(_this.props.onSourceError, error);

      _this.setState({ pdf: false });
    }, _this.onLoadSuccess = function (pdf) {
      _this.setState({ pdf: pdf }, function () {
        (0, _utils.callIfDefined)(_this.props.onLoadSuccess, pdf);

        _this.pages = new Array(pdf.numPages);
        _this.linkService.setDocument(pdf);
      });
    }, _this.onLoadError = function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      (0, _utils.errorOnDev)(error.message, error);

      (0, _utils.callIfDefined)(_this.props.onLoadError, error);

      _this.setState({ pdf: false });
    }, _this.findDocumentSource = function () {
      var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.file;
      return new _promise2.default(function (resolve, reject) {
        if (!file) {
          return resolve(null);
        }

        // File is a string
        if ((0, _utils.isString)(file)) {
          if ((0, _utils.isDataURI)(file)) {
            var fileUint8Array = (0, _utils.dataURItoUint8Array)(file);
            return resolve(fileUint8Array);
          }

          (0, _utils.displayCORSWarning)();
          return resolve(file);
        }

        if ((0, _utils.isArrayBuffer)(file)) {
          return resolve(file);
        }

        if ((0, _utils.isParamObject)(file)) {
          // Prevent from modifying props
          var modifiedFile = (0, _assign2.default)({}, file);

          if ('url' in modifiedFile) {
            // File is data URI
            if ((0, _utils.isDataURI)(modifiedFile.url)) {
              var _fileUint8Array = (0, _utils.dataURItoUint8Array)(modifiedFile.url);
              return resolve(_fileUint8Array);
            }

            (0, _utils.displayCORSWarning)();
          }

          return resolve(modifiedFile);
        }

        /**
         * The cases below are browser-only.
         * If you're running on a non-browser environment, these cases will be of no use.
         */
        if (_utils.isBrowser) {
          // File is a Blob
          if ((0, _utils.isBlob)(file) || (0, _utils.isFile)(file)) {
            var reader = new FileReader();

            reader.onload = function () {
              return resolve(new Uint8Array(reader.result));
            };
            reader.onerror = function (event) {
              switch (event.target.error.code) {
                case event.target.error.NOT_FOUND_ERR:
                  return reject(new Error('Error while reading a file: File not found.'));
                case event.target.error.NOT_READABLE_ERR:
                  return reject(new Error('Error while reading a file: File not readable.'));
                case event.target.error.SECURITY_ERR:
                  return reject(new Error('Error while reading a file: Security error.'));
                case event.target.error.ABORT_ERR:
                  return reject(new Error('Error while reading a file: Aborted.'));
                default:
                  return reject(new Error('Error while reading a file.'));
              }
            };
            reader.readAsArrayBuffer(file);

            return null;
          }
        }

        // No supported loading method worked
        return reject(new Error('Unsupported loading method.'));
      });
    }, _this.registerPage = function (pageIndex, ref) {
      _this.pages[pageIndex] = ref;
    }, _this.unregisterPage = function (pageIndex) {
      delete _this.pages[pageIndex];
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Document, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadDocument();

      this.linkService.setViewer(this.viewer);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.shouldLoadDocument(nextProps)) {
        if (this.state.pdf !== null) {
          this.setState({ pdf: null });
        }

        this.loadDocument(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _utils.cancelRunningTask)(this.runningTask);
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var linkService = this.linkService,
          registerPage = this.registerPage,
          unregisterPage = this.unregisterPage;
      var rotate = this.props.rotate;


      return {
        linkService: linkService,
        pdf: this.state.pdf,
        registerPage: registerPage,
        rotate: rotate,
        unregisterPage: unregisterPage
      };
    }
  }, {
    key: 'shouldLoadDocument',
    value: function shouldLoadDocument(nextProps) {
      var nextFile = nextProps.file;
      var file = this.props.file;

      // We got file of different type - clearly there was a change

      if ((typeof nextFile === 'undefined' ? 'undefined' : (0, _typeof3.default)(nextFile)) !== (typeof file === 'undefined' ? 'undefined' : (0, _typeof3.default)(file))) {
        return true;
      }

      // We got an object and previously it was an object too - we need to compare deeply
      if ((0, _utils.isParamObject)(nextFile) && (0, _utils.isParamObject)(file)) {
        return nextFile.data !== file.data || nextFile.range !== file.range || nextFile.url !== file.url;
        // We either have or had an object - most likely there was a change
      } else if ((0, _utils.isParamObject)(nextFile) || (0, _utils.isParamObject)(file)) {
        return true;
      }

      /**
       * The cases below are browser-only.
       * If you're running on a non-browser environment, these cases will be of no use.
       */
      if (_utils.isBrowser && (
      // File is a Blob or a File
      (0, _utils.isBlob)(nextFile) || (0, _utils.isFile)(nextFile)) && ((0, _utils.isBlob)(file) || (0, _utils.isFile)(file))) {
        /**
         * Theoretically, we could compare files here by reading them, but that would severely affect
         * performance. Therefore, we're making a compromise here, agreeing on not loading the next
         * file if its size is identical as the previous one's.
         */
        return nextFile.size !== file.size;
      }

      return nextFile !== file;
    }
  }, {
    key: 'loadDocument',
    value: function loadDocument() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      (0, _utils.cancelRunningTask)(this.runningTask);

      this.runningTask = (0, _utils.makeCancellable)(this.findDocumentSource(props.file));

      return this.runningTask.promise.then(this.onSourceSuccess).catch(this.onSourceError);
    }

    /**
     * Attempts to find a document source based on props.
     */

  }, {
    key: 'renderNoData',
    value: function renderNoData() {
      return _react2.default.createElement(
        'div',
        { className: 'react-pdf__message react-pdf__message--no-data' },
        this.props.noData
      );
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      return _react2.default.createElement(
        'div',
        { className: 'react-pdf__message react-pdf__message--error' },
        this.props.error
      );
    }
  }, {
    key: 'renderLoader',
    value: function renderLoader() {
      return _react2.default.createElement(
        'div',
        { className: 'react-pdf__message react-pdf__message--loading' },
        this.props.loading
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          file = _props.file,
          inputRef = _props.inputRef;
      var pdf = this.state.pdf;


      var content = void 0;
      if (!file) {
        content = this.renderNoData();
      } else if (pdf === null) {
        content = this.renderLoader();
      } else if (pdf === false) {
        content = this.renderError();
      } else {
        content = this.props.children;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          className: (0, _mergeClassNames2.default)('react-pdf__Document', className),
          ref: inputRef
        }, this.eventProps),
        content
      );
    }
  }, {
    key: 'eventProps',
    get: function get() {
      var _this2 = this;

      return (0, _events.makeEventProps)(this.props, function () {
        return _this2.state.pdf;
      });
    }

    /**
     * Called when a document source is resolved correctly
     */


    /**
     * Called when a document source failed to be resolved correctly
     */


    /**
     * Called when a document is read successfully
     */


    /**
     * Called when a document failed to read successfully
     */

  }]);
  return Document;
}(_react.Component); /**
                      * Loads a PDF document. Passes it to all children.
                      */


exports.default = Document;


Document.childContextTypes = {
  linkService: _propTypes3.isLinkService,
  pdf: _propTypes3.isPdf,
  registerPage: _propTypes2.default.func,
  rotate: _propTypes2.default.number,
  unregisterPage: _propTypes2.default.func
};

Document.defaultProps = {
  error: 'Failed to load PDF file.',
  loading: 'Loading PDF…',
  noData: 'No PDF file specified.'
};

Document.propTypes = (0, _extends3.default)({
  children: _propTypes2.default.node,
  className: _propTypes3.isClassName,
  error: _propTypes2.default.node,
  file: _utils.isFile,
  inputRef: _propTypes2.default.func,
  loading: _propTypes2.default.node,
  noData: _propTypes2.default.node,
  onItemClick: _propTypes2.default.func,
  onLoadError: _propTypes2.default.func,
  onLoadSuccess: _propTypes2.default.func,
  onSourceError: _propTypes2.default.func,
  onSourceSuccess: _propTypes2.default.func,
  rotate: _propTypes2.default.number
}, (0, _propTypes3.eventsProps)());

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2385);
module.exports = __webpack_require__(70).Object.assign;


/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(127);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(2386) });


/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(149);
var getKeys = __webpack_require__(282);
var gOPS = __webpack_require__(544);
var pIE = __webpack_require__(378);
var toObject = __webpack_require__(285);
var IObject = __webpack_require__(1000);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(235)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(236);
var toLength = __webpack_require__(1001);
var toAbsoluteIndex = __webpack_require__(2388);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(540);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2390), __esModule: true };

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(380);
__webpack_require__(382);
module.exports = __webpack_require__(546).f('iterator');


/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(540);
var defined = __webpack_require__(539);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(545);
var descriptor = __webpack_require__(376);
var setToStringTag = __webpack_require__(381);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(202)(IteratorPrototype, __webpack_require__(89)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(169);
var anObject = __webpack_require__(128);
var getKeys = __webpack_require__(282);

module.exports = __webpack_require__(149) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(2395);
var step = __webpack_require__(2396);
var Iterators = __webpack_require__(237);
var toIObject = __webpack_require__(236);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(1002)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 2395 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 2396 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2398), __esModule: true };

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2399);
__webpack_require__(1008);
__webpack_require__(2404);
__webpack_require__(2405);
module.exports = __webpack_require__(70).Symbol;


/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(88);
var has = __webpack_require__(203);
var DESCRIPTORS = __webpack_require__(149);
var $export = __webpack_require__(127);
var redefine = __webpack_require__(1003);
var META = __webpack_require__(2400).KEY;
var $fails = __webpack_require__(235);
var shared = __webpack_require__(542);
var setToStringTag = __webpack_require__(381);
var uid = __webpack_require__(377);
var wks = __webpack_require__(89);
var wksExt = __webpack_require__(546);
var wksDefine = __webpack_require__(547);
var enumKeys = __webpack_require__(2401);
var isArray = __webpack_require__(2402);
var anObject = __webpack_require__(128);
var isObject = __webpack_require__(170);
var toObject = __webpack_require__(285);
var toIObject = __webpack_require__(236);
var toPrimitive = __webpack_require__(538);
var createDesc = __webpack_require__(376);
var _create = __webpack_require__(545);
var gOPNExt = __webpack_require__(2403);
var $GOPD = __webpack_require__(1007);
var $GOPS = __webpack_require__(544);
var $DP = __webpack_require__(169);
var $keys = __webpack_require__(282);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(1006).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(378).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(284)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(202)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(377)('meta');
var isObject = __webpack_require__(170);
var has = __webpack_require__(203);
var setDesc = __webpack_require__(169).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(235)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(282);
var gOPS = __webpack_require__(544);
var pIE = __webpack_require__(378);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(283);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(236);
var gOPN = __webpack_require__(1006).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(547)('asyncIterator');


/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(547)('observable');


/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1008);
__webpack_require__(380);
__webpack_require__(382);
__webpack_require__(2407);
__webpack_require__(2418);
__webpack_require__(2419);
module.exports = __webpack_require__(70).Promise;


/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(284);
var global = __webpack_require__(88);
var ctx = __webpack_require__(281);
var classof = __webpack_require__(549);
var $export = __webpack_require__(127);
var isObject = __webpack_require__(170);
var aFunction = __webpack_require__(375);
var anInstance = __webpack_require__(2408);
var forOf = __webpack_require__(2409);
var speciesConstructor = __webpack_require__(1010);
var task = __webpack_require__(1011).set;
var microtask = __webpack_require__(2413)();
var newPromiseCapabilityModule = __webpack_require__(550);
var perform = __webpack_require__(1012);
var userAgent = __webpack_require__(2414);
var promiseResolve = __webpack_require__(1013);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(89)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(2415)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(381)($Promise, PROMISE);
__webpack_require__(2416)(PROMISE);
Wrapper = __webpack_require__(70)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(2417)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 2408 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(281);
var call = __webpack_require__(2410);
var isArrayIter = __webpack_require__(2411);
var anObject = __webpack_require__(128);
var toLength = __webpack_require__(1001);
var getIterFn = __webpack_require__(1009);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(128);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(237);
var ITERATOR = __webpack_require__(89)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 2412 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(88);
var macrotask = __webpack_require__(1011).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(283)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(88);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(202);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(88);
var core = __webpack_require__(70);
var dP = __webpack_require__(169);
var DESCRIPTORS = __webpack_require__(149);
var SPECIES = __webpack_require__(89)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(89)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(127);
var core = __webpack_require__(70);
var global = __webpack_require__(88);
var speciesConstructor = __webpack_require__(1010);
var promiseResolve = __webpack_require__(1013);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(127);
var newPromiseCapability = __webpack_require__(550);
var perform = __webpack_require__(1012);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2421);
module.exports = __webpack_require__(70).Object.getPrototypeOf;


/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(285);
var $getPrototypeOf = __webpack_require__(1005);

__webpack_require__(1014)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2423), __esModule: true };

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2424);
var $Object = __webpack_require__(70).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(127);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(149), 'Object', { defineProperty: __webpack_require__(169).f });


/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2426), __esModule: true };

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2427);
module.exports = __webpack_require__(70).Object.setPrototypeOf;


/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(127);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(2428).set });


/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(170);
var anObject = __webpack_require__(128);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(281)(Function.call, __webpack_require__(1007).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2430), __esModule: true };

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2431);
var $Object = __webpack_require__(70).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(127);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(545) });


/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(2433);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleLinkService = exports.PDFLinkService = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom_events = __webpack_require__(2435);

var _ui_utils = __webpack_require__(1016);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PDFLinkService = function () {
  function PDFLinkService() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        eventBus = _ref.eventBus;

    _classCallCheck(this, PDFLinkService);

    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
    this.baseUrl = null;
    this.pdfDocument = null;
    this.pdfViewer = null;
    this.pdfHistory = null;
    this._pagesRefCache = null;
  }

  _createClass(PDFLinkService, [{
    key: 'setDocument',
    value: function setDocument(pdfDocument, baseUrl) {
      this.baseUrl = baseUrl;
      this.pdfDocument = pdfDocument;
      this._pagesRefCache = Object.create(null);
    }
  }, {
    key: 'setViewer',
    value: function setViewer(pdfViewer) {
      this.pdfViewer = pdfViewer;
    }
  }, {
    key: 'setHistory',
    value: function setHistory(pdfHistory) {
      this.pdfHistory = pdfHistory;
    }
  }, {
    key: 'navigateTo',
    value: function navigateTo(dest) {
      var _this = this;

      var goToDestination = function goToDestination(_ref2) {
        var namedDest = _ref2.namedDest,
            explicitDest = _ref2.explicitDest;

        var destRef = explicitDest[0],
            pageNumber = void 0;
        if (destRef instanceof Object) {
          pageNumber = _this._cachedPageNumber(destRef);
          if (pageNumber === null) {
            _this.pdfDocument.getPageIndex(destRef).then(function (pageIndex) {
              _this.cachePageRef(pageIndex + 1, destRef);
              goToDestination({
                namedDest: namedDest,
                explicitDest: explicitDest
              });
            }).catch(function () {
              console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid page reference, for dest="' + dest + '".'));
            });
            return;
          }
        } else if (Number.isInteger(destRef)) {
          pageNumber = destRef + 1;
        } else {
          console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid destination reference, for dest="' + dest + '".'));
          return;
        }
        if (!pageNumber || pageNumber < 1 || pageNumber > _this.pagesCount) {
          console.error('PDFLinkService.navigateTo: "' + pageNumber + '" is not ' + ('a valid page number, for dest="' + dest + '".'));
          return;
        }
        if (_this.pdfHistory) {
          _this.pdfHistory.pushCurrentPosition();
          _this.pdfHistory.push({
            namedDest: namedDest,
            explicitDest: explicitDest,
            pageNumber: pageNumber
          });
        }
        _this.pdfViewer.scrollPageIntoView({
          pageNumber: pageNumber,
          destArray: explicitDest
        });
      };
      new Promise(function (resolve, reject) {
        if (typeof dest === 'string') {
          _this.pdfDocument.getDestination(dest).then(function (destArray) {
            resolve({
              namedDest: dest,
              explicitDest: destArray
            });
          });
          return;
        }
        resolve({
          namedDest: '',
          explicitDest: dest
        });
      }).then(function (data) {
        if (!(data.explicitDest instanceof Array)) {
          console.error('PDFLinkService.navigateTo: "' + data.explicitDest + '" is' + (' not a valid destination array, for dest="' + dest + '".'));
          return;
        }
        goToDestination(data);
      });
    }
  }, {
    key: 'getDestinationHash',
    value: function getDestinationHash(dest) {
      if (typeof dest === 'string') {
        return this.getAnchorUrl('#' + escape(dest));
      }
      if (dest instanceof Array) {
        var str = JSON.stringify(dest);
        return this.getAnchorUrl('#' + escape(str));
      }
      return this.getAnchorUrl('');
    }
  }, {
    key: 'getAnchorUrl',
    value: function getAnchorUrl(anchor) {
      return (this.baseUrl || '') + anchor;
    }
  }, {
    key: 'setHash',
    value: function setHash(hash) {
      var pageNumber = void 0,
          dest = void 0;
      if (hash.indexOf('=') >= 0) {
        var params = (0, _ui_utils.parseQueryString)(hash);
        if ('search' in params) {
          this.eventBus.dispatch('findfromurlhash', {
            source: this,
            query: params['search'].replace(/"/g, ''),
            phraseSearch: params['phrase'] === 'true'
          });
        }
        if ('nameddest' in params) {
          this.navigateTo(params.nameddest);
          return;
        }
        if ('page' in params) {
          pageNumber = params.page | 0 || 1;
        }
        if ('zoom' in params) {
          var zoomArgs = params.zoom.split(',');
          var zoomArg = zoomArgs[0];
          var zoomArgNumber = parseFloat(zoomArg);
          if (zoomArg.indexOf('Fit') === -1) {
            dest = [null, { name: 'XYZ' }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null, zoomArgs.length > 2 ? zoomArgs[2] | 0 : null, zoomArgNumber ? zoomArgNumber / 100 : zoomArg];
          } else {
            if (zoomArg === 'Fit' || zoomArg === 'FitB') {
              dest = [null, { name: zoomArg }];
            } else if (zoomArg === 'FitH' || zoomArg === 'FitBH' || zoomArg === 'FitV' || zoomArg === 'FitBV') {
              dest = [null, { name: zoomArg }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null];
            } else if (zoomArg === 'FitR') {
              if (zoomArgs.length !== 5) {
                console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
              } else {
                dest = [null, { name: zoomArg }, zoomArgs[1] | 0, zoomArgs[2] | 0, zoomArgs[3] | 0, zoomArgs[4] | 0];
              }
            } else {
              console.error('PDFLinkService.setHash: "' + zoomArg + '" is not ' + 'a valid zoom value.');
            }
          }
        }
        if (dest) {
          this.pdfViewer.scrollPageIntoView({
            pageNumber: pageNumber || this.page,
            destArray: dest,
            allowNegativeOffset: true
          });
        } else if (pageNumber) {
          this.page = pageNumber;
        }
        if ('pagemode' in params) {
          this.eventBus.dispatch('pagemode', {
            source: this,
            mode: params.pagemode
          });
        }
      } else {
        dest = unescape(hash);
        try {
          dest = JSON.parse(dest);
          if (!(dest instanceof Array)) {
            dest = dest.toString();
          }
        } catch (ex) {}
        if (typeof dest === 'string' || isValidExplicitDestination(dest)) {
          this.navigateTo(dest);
          return;
        }
        console.error('PDFLinkService.setHash: "' + unescape(hash) + '" is not ' + 'a valid destination.');
      }
    }
  }, {
    key: 'executeNamedAction',
    value: function executeNamedAction(action) {
      switch (action) {
        case 'GoBack':
          if (this.pdfHistory) {
            this.pdfHistory.back();
          }
          break;
        case 'GoForward':
          if (this.pdfHistory) {
            this.pdfHistory.forward();
          }
          break;
        case 'NextPage':
          if (this.page < this.pagesCount) {
            this.page++;
          }
          break;
        case 'PrevPage':
          if (this.page > 1) {
            this.page--;
          }
          break;
        case 'LastPage':
          this.page = this.pagesCount;
          break;
        case 'FirstPage':
          this.page = 1;
          break;
        default:
          break;
      }
      this.eventBus.dispatch('namedaction', {
        source: this,
        action: action
      });
    }
  }, {
    key: 'onFileAttachmentAnnotation',
    value: function onFileAttachmentAnnotation(_ref3) {
      var id = _ref3.id,
          filename = _ref3.filename,
          content = _ref3.content;

      this.eventBus.dispatch('fileattachmentannotation', {
        source: this,
        id: id,
        filename: filename,
        content: content
      });
    }
  }, {
    key: 'cachePageRef',
    value: function cachePageRef(pageNum, pageRef) {
      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
      this._pagesRefCache[refStr] = pageNum;
    }
  }, {
    key: '_cachedPageNumber',
    value: function _cachedPageNumber(pageRef) {
      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
      return this._pagesRefCache && this._pagesRefCache[refStr] || null;
    }
  }, {
    key: 'pagesCount',
    get: function get() {
      return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
  }, {
    key: 'page',
    get: function get() {
      return this.pdfViewer.currentPageNumber;
    },
    set: function set(value) {
      this.pdfViewer.currentPageNumber = value;
    }
  }, {
    key: 'rotation',
    get: function get() {
      return this.pdfViewer.pagesRotation;
    },
    set: function set(value) {
      this.pdfViewer.pagesRotation = value;
    }
  }]);

  return PDFLinkService;
}();

function isValidExplicitDestination(dest) {
  if (!(dest instanceof Array)) {
    return false;
  }
  var destLength = dest.length,
      allowNull = true;
  if (destLength < 2) {
    return false;
  }
  var page = dest[0];
  if (!((typeof page === 'undefined' ? 'undefined' : _typeof(page)) === 'object' && Number.isInteger(page.num) && Number.isInteger(page.gen)) && !(Number.isInteger(page) && page >= 0)) {
    return false;
  }
  var zoom = dest[1];
  if (!((typeof zoom === 'undefined' ? 'undefined' : _typeof(zoom)) === 'object' && typeof zoom.name === 'string')) {
    return false;
  }
  switch (zoom.name) {
    case 'XYZ':
      if (destLength !== 5) {
        return false;
      }
      break;
    case 'Fit':
    case 'FitB':
      return destLength === 2;
    case 'FitH':
    case 'FitBH':
    case 'FitV':
    case 'FitBV':
      if (destLength !== 3) {
        return false;
      }
      break;
    case 'FitR':
      if (destLength !== 6) {
        return false;
      }
      allowNull = false;
      break;
    default:
      return false;
  }
  for (var i = 2; i < destLength; i++) {
    var param = dest[i];
    if (!(typeof param === 'number' || allowNull && param === null)) {
      return false;
    }
  }
  return true;
}

var SimpleLinkService = function () {
  function SimpleLinkService() {
    _classCallCheck(this, SimpleLinkService);
  }

  _createClass(SimpleLinkService, [{
    key: 'navigateTo',
    value: function navigateTo(dest) {}
  }, {
    key: 'getDestinationHash',
    value: function getDestinationHash(dest) {
      return '#';
    }
  }, {
    key: 'getAnchorUrl',
    value: function getAnchorUrl(hash) {
      return '#';
    }
  }, {
    key: 'setHash',
    value: function setHash(hash) {}
  }, {
    key: 'executeNamedAction',
    value: function executeNamedAction(action) {}
  }, {
    key: 'onFileAttachmentAnnotation',
    value: function onFileAttachmentAnnotation(_ref4) {
      var id = _ref4.id,
          filename = _ref4.filename,
          content = _ref4.content;
    }
  }, {
    key: 'cachePageRef',
    value: function cachePageRef(pageNum, pageRef) {}
  }, {
    key: 'page',
    get: function get() {
      return 0;
    },
    set: function set(value) {}
  }, {
    key: 'rotation',
    get: function get() {
      return 0;
    },
    set: function set(value) {}
  }]);

  return SimpleLinkService;
}();

exports.PDFLinkService = PDFLinkService;
exports.SimpleLinkService = SimpleLinkService;

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobalEventBus = exports.attachDOMEventsToEventBus = undefined;

var _ui_utils = __webpack_require__(1016);

function attachDOMEventsToEventBus(eventBus) {
  eventBus.on('documentload', function () {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('documentload', true, true, {});
    window.dispatchEvent(event);
  });
  eventBus.on('pagerendered', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagerendered', true, true, {
      pageNumber: evt.pageNumber,
      cssTransform: evt.cssTransform
    });
    evt.source.div.dispatchEvent(event);
  });
  eventBus.on('textlayerrendered', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('textlayerrendered', true, true, { pageNumber: evt.pageNumber });
    evt.source.textLayerDiv.dispatchEvent(event);
  });
  eventBus.on('pagechange', function (evt) {
    var event = document.createEvent('UIEvents');
    event.initUIEvent('pagechange', true, true, window, 0);
    event.pageNumber = evt.pageNumber;
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('pagesinit', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagesinit', true, true, null);
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('pagesloaded', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagesloaded', true, true, { pagesCount: evt.pagesCount });
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('scalechange', function (evt) {
    var event = document.createEvent('UIEvents');
    event.initUIEvent('scalechange', true, true, window, 0);
    event.scale = evt.scale;
    event.presetValue = evt.presetValue;
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('updateviewarea', function (evt) {
    var event = document.createEvent('UIEvents');
    event.initUIEvent('updateviewarea', true, true, window, 0);
    event.location = evt.location;
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('find', function (evt) {
    if (evt.source === window) {
      return;
    }
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('find' + evt.type, true, true, {
      query: evt.query,
      phraseSearch: evt.phraseSearch,
      caseSensitive: evt.caseSensitive,
      highlightAll: evt.highlightAll,
      findPrevious: evt.findPrevious
    });
    window.dispatchEvent(event);
  });
  eventBus.on('attachmentsloaded', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('attachmentsloaded', true, true, { attachmentsCount: evt.attachmentsCount });
    evt.source.container.dispatchEvent(event);
  });
  eventBus.on('sidebarviewchanged', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('sidebarviewchanged', true, true, { view: evt.view });
    evt.source.outerContainer.dispatchEvent(event);
  });
  eventBus.on('pagemode', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('pagemode', true, true, { mode: evt.mode });
    evt.source.pdfViewer.container.dispatchEvent(event);
  });
  eventBus.on('namedaction', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('namedaction', true, true, { action: evt.action });
    evt.source.pdfViewer.container.dispatchEvent(event);
  });
  eventBus.on('presentationmodechanged', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('presentationmodechanged', true, true, {
      active: evt.active,
      switchInProgress: evt.switchInProgress
    });
    window.dispatchEvent(event);
  });
  eventBus.on('outlineloaded', function (evt) {
    var event = document.createEvent('CustomEvent');
    event.initCustomEvent('outlineloaded', true, true, { outlineCount: evt.outlineCount });
    evt.source.container.dispatchEvent(event);
  });
}
var globalEventBus = null;
function getGlobalEventBus() {
  if (globalEventBus) {
    return globalEventBus;
  }
  globalEventBus = new _ui_utils.EventBus();
  attachDOMEventsToEventBus(globalEventBus);
  return globalEventBus;
}
exports.attachDOMEventsToEventBus = attachDOMEventsToEventBus;
exports.getGlobalEventBus = getGlobalEventBus;

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


var pdfjsVersion = '2.0.305';
var pdfjsBuild = '9c6a8801';
var pdfjsSharedUtil = __webpack_require__(73);
var pdfjsDisplayGlobal = __webpack_require__(2447);
var pdfjsDisplayAPI = __webpack_require__(1034);
var pdfjsDisplayTextLayer = __webpack_require__(1037);
var pdfjsDisplayAnnotationLayer = __webpack_require__(1036);
var pdfjsDisplayDOMUtils = __webpack_require__(204);
var pdfjsDisplaySVG = __webpack_require__(1038);
{
  var isNodeJS = __webpack_require__(405);
  if (isNodeJS()) {
    var PDFNodeStream = __webpack_require__(2468).PDFNodeStream;
    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFNodeStream(params);
    });
  } else if (typeof Response !== 'undefined' && 'body' in Response.prototype && typeof ReadableStream !== 'undefined') {
    var PDFFetchStream = __webpack_require__(2473).PDFFetchStream;
    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFFetchStream(params);
    });
  } else {
    var PDFNetworkStream = __webpack_require__(2474).PDFNetworkStream;
    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFNetworkStream(params);
    });
  }
}
exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
exports.build = pdfjsDisplayAPI.build;
exports.version = pdfjsDisplayAPI.version;
exports.getDocument = pdfjsDisplayAPI.getDocument;
exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
exports.OPS = pdfjsSharedUtil.OPS;
exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
exports.shadow = pdfjsSharedUtil.shadow;
exports.createBlob = pdfjsSharedUtil.createBlob;
exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
  var globalScope = __webpack_require__(287);
  var isNodeJS = __webpack_require__(405);
  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
  var isAndroid = /Android/.test(userAgent);
  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
  var isIE = userAgent.indexOf('Trident') >= 0;
  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
  if (typeof PDFJS === 'undefined') {
    globalScope.PDFJS = {};
  }
  PDFJS.compatibilityChecked = true;
  (function checkNodeBtoa() {
    if (globalScope.btoa || !isNodeJS()) {
      return;
    }
    globalScope.btoa = function (chars) {
      return Buffer.from(chars, 'binary').toString('base64');
    };
  })();
  (function checkNodeAtob() {
    if (globalScope.atob || !isNodeJS()) {
      return;
    }
    globalScope.atob = function (input) {
      return Buffer.from(input, 'base64').toString('binary');
    };
  })();
  (function checkOnBlobSupport() {
    if (isIE || isIOSChrome) {
      PDFJS.disableCreateObjectURL = true;
    }
  })();
  (function checkNavigatorLanguage() {
    if (typeof navigator === 'undefined') {
      return;
    }
    if ('language' in navigator) {
      return;
    }
    PDFJS.locale = navigator.userLanguage || 'en-US';
  })();
  (function checkRangeRequests() {
    if (isSafari || isIOS) {
      PDFJS.disableRange = true;
      PDFJS.disableStream = true;
    }
  })();
  (function checkCanvasSizeLimitation() {
    if (isIOS || isAndroid) {
      PDFJS.maxCanvasPixels = 5242880;
    }
  })();
  (function checkFullscreenSupport() {
    if (!hasDOM) {
      return;
    }
    if (isIE && window.parent !== window) {
      PDFJS.disableFullscreen = true;
    }
  })();
  (function checkCurrentScript() {
    if (!hasDOM) {
      return;
    }
    if ('currentScript' in document) {
      return;
    }
    Object.defineProperty(document, 'currentScript', {
      get: function get() {
        var scripts = document.getElementsByTagName('script');
        return scripts[scripts.length - 1];
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkChildNodeRemove() {
    if (!hasDOM) {
      return;
    }
    if (typeof Element.prototype.remove !== 'undefined') {
      return;
    }
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  })();
  (function checkArrayIncludes() {
    if (Array.prototype.includes) {
      return;
    }
    Array.prototype.includes = __webpack_require__(2438);
  })();
  (function checkMathLog2() {
    if (Math.log2) {
      return;
    }
    Math.log2 = __webpack_require__(2439);
  })();
  (function checkNumberIsNaN() {
    if (Number.isNaN) {
      return;
    }
    Number.isNaN = __webpack_require__(2440);
  })();
  (function checkNumberIsInteger() {
    if (Number.isInteger) {
      return;
    }
    Number.isInteger = __webpack_require__(2441);
  })();
  (function checkPromise() {
    if (globalScope.Promise) {
      return;
    }
    globalScope.Promise = __webpack_require__(2442);
  })();
  (function checkWeakMap() {
    if (globalScope.WeakMap) {
      return;
    }
    globalScope.WeakMap = __webpack_require__(2443);
  })();
  (function checkURLConstructor() {
    var hasWorkingUrl = false;
    try {
      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
        var u = new URL('b', 'http://a');
        u.pathname = 'c%20d';
        hasWorkingUrl = u.href === 'http://a/c%20d';
      }
    } catch (e) {}
    if (hasWorkingUrl) {
      return;
    }
    var relative = Object.create(null);
    relative['ftp'] = 21;
    relative['file'] = 0;
    relative['gopher'] = 70;
    relative['http'] = 80;
    relative['https'] = 443;
    relative['ws'] = 80;
    relative['wss'] = 443;
    var relativePathDotMapping = Object.create(null);
    relativePathDotMapping['%2e'] = '.';
    relativePathDotMapping['.%2e'] = '..';
    relativePathDotMapping['%2e.'] = '..';
    relativePathDotMapping['%2e%2e'] = '..';
    function isRelativeScheme(scheme) {
      return relative[scheme] !== undefined;
    }
    function invalid() {
      clear.call(this);
      this._isInvalid = true;
    }
    function IDNAToASCII(h) {
      if (h === '') {
        invalid.call(this);
      }
      return h.toLowerCase();
    }
    function percentEscape(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    function percentEscapeQuery(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    var EOF,
        ALPHA = /[a-zA-Z]/,
        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
    function parse(input, stateOverride, base) {
      function err(message) {
        errors.push(message);
      }
      var state = stateOverride || 'scheme start',
          cursor = 0,
          buffer = '',
          seenAt = false,
          seenBracket = false,
          errors = [];
      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
        var c = input[cursor];
        switch (state) {
          case 'scheme start':
            if (c && ALPHA.test(c)) {
              buffer += c.toLowerCase();
              state = 'scheme';
            } else if (!stateOverride) {
              buffer = '';
              state = 'no scheme';
              continue;
            } else {
              err('Invalid scheme.');
              break loop;
            }
            break;
          case 'scheme':
            if (c && ALPHANUMERIC.test(c)) {
              buffer += c.toLowerCase();
            } else if (c === ':') {
              this._scheme = buffer;
              buffer = '';
              if (stateOverride) {
                break loop;
              }
              if (isRelativeScheme(this._scheme)) {
                this._isRelative = true;
              }
              if (this._scheme === 'file') {
                state = 'relative';
              } else if (this._isRelative && base && base._scheme === this._scheme) {
                state = 'relative or authority';
              } else if (this._isRelative) {
                state = 'authority first slash';
              } else {
                state = 'scheme data';
              }
            } else if (!stateOverride) {
              buffer = '';
              cursor = 0;
              state = 'no scheme';
              continue;
            } else if (c === EOF) {
              break loop;
            } else {
              err('Code point not allowed in scheme: ' + c);
              break loop;
            }
            break;
          case 'scheme data':
            if (c === '?') {
              this._query = '?';
              state = 'query';
            } else if (c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else {
              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
                this._schemeData += percentEscape(c);
              }
            }
            break;
          case 'no scheme':
            if (!base || !isRelativeScheme(base._scheme)) {
              err('Missing scheme.');
              invalid.call(this);
            } else {
              state = 'relative';
              continue;
            }
            break;
          case 'relative or authority':
            if (c === '/' && input[cursor + 1] === '/') {
              state = 'authority ignore slashes';
            } else {
              err('Expected /, got: ' + c);
              state = 'relative';
              continue;
            }
            break;
          case 'relative':
            this._isRelative = true;
            if (this._scheme !== 'file') {
              this._scheme = base._scheme;
            }
            if (c === EOF) {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._username = base._username;
              this._password = base._password;
              break loop;
            } else if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              state = 'relative slash';
            } else if (c === '?') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = '?';
              this._username = base._username;
              this._password = base._password;
              state = 'query';
            } else if (c === '#') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._fragment = '#';
              this._username = base._username;
              this._password = base._password;
              state = 'fragment';
            } else {
              var nextC = input[cursor + 1];
              var nextNextC = input[cursor + 2];
              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
                this._path = base._path.slice();
                this._path.pop();
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'relative slash':
            if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              if (this._scheme === 'file') {
                state = 'file host';
              } else {
                state = 'authority ignore slashes';
              }
            } else {
              if (this._scheme !== 'file') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'authority first slash':
            if (c === '/') {
              state = 'authority second slash';
            } else {
              err('Expected \'/\', got: ' + c);
              state = 'authority ignore slashes';
              continue;
            }
            break;
          case 'authority second slash':
            state = 'authority ignore slashes';
            if (c !== '/') {
              err('Expected \'/\', got: ' + c);
              continue;
            }
            break;
          case 'authority ignore slashes':
            if (c !== '/' && c !== '\\') {
              state = 'authority';
              continue;
            } else {
              err('Expected authority, got: ' + c);
            }
            break;
          case 'authority':
            if (c === '@') {
              if (seenAt) {
                err('@ already seen.');
                buffer += '%40';
              }
              seenAt = true;
              for (var i = 0; i < buffer.length; i++) {
                var cp = buffer[i];
                if (cp === '\t' || cp === '\n' || cp === '\r') {
                  err('Invalid whitespace in authority.');
                  continue;
                }
                if (cp === ':' && this._password === null) {
                  this._password = '';
                  continue;
                }
                var tempC = percentEscape(cp);
                if (this._password !== null) {
                  this._password += tempC;
                } else {
                  this._username += tempC;
                }
              }
              buffer = '';
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              cursor -= buffer.length;
              buffer = '';
              state = 'host';
              continue;
            } else {
              buffer += c;
            }
            break;
          case 'file host':
            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
                state = 'relative path';
              } else if (buffer.length === 0) {
                state = 'relative path start';
              } else {
                this._host = IDNAToASCII.call(this, buffer);
                buffer = '';
                state = 'relative path start';
              }
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid whitespace in file host.');
            } else {
              buffer += c;
            }
            break;
          case 'host':
          case 'hostname':
            if (c === ':' && !seenBracket) {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'port';
              if (stateOverride === 'hostname') {
                break loop;
              }
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'relative path start';
              if (stateOverride) {
                break loop;
              }
              continue;
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              if (c === '[') {
                seenBracket = true;
              } else if (c === ']') {
                seenBracket = false;
              }
              buffer += c;
            } else {
              err('Invalid code point in host/hostname: ' + c);
            }
            break;
          case 'port':
            if (/[0-9]/.test(c)) {
              buffer += c;
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
              if (buffer !== '') {
                var temp = parseInt(buffer, 10);
                if (temp !== relative[this._scheme]) {
                  this._port = temp + '';
                }
                buffer = '';
              }
              if (stateOverride) {
                break loop;
              }
              state = 'relative path start';
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid code point in port: ' + c);
            } else {
              invalid.call(this);
            }
            break;
          case 'relative path start':
            if (c === '\\') {
              err('\'\\\' not allowed in path.');
            }
            state = 'relative path';
            if (c !== '/' && c !== '\\') {
              continue;
            }
            break;
          case 'relative path':
            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
              if (c === '\\') {
                err('\\ not allowed in relative path.');
              }
              var tmp;
              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
                buffer = tmp;
              }
              if (buffer === '..') {
                this._path.pop();
                if (c !== '/' && c !== '\\') {
                  this._path.push('');
                }
              } else if (buffer === '.' && c !== '/' && c !== '\\') {
                this._path.push('');
              } else if (buffer !== '.') {
                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
                  buffer = buffer[0] + ':';
                }
                this._path.push(buffer);
              }
              buffer = '';
              if (c === '?') {
                this._query = '?';
                state = 'query';
              } else if (c === '#') {
                this._fragment = '#';
                state = 'fragment';
              }
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              buffer += percentEscape(c);
            }
            break;
          case 'query':
            if (!stateOverride && c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._query += percentEscapeQuery(c);
            }
            break;
          case 'fragment':
            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._fragment += c;
            }
            break;
        }
        cursor++;
      }
    }
    function clear() {
      this._scheme = '';
      this._schemeData = '';
      this._username = '';
      this._password = null;
      this._host = '';
      this._port = '';
      this._path = [];
      this._query = '';
      this._fragment = '';
      this._isInvalid = false;
      this._isRelative = false;
    }
    function JURL(url, base) {
      if (base !== undefined && !(base instanceof JURL)) {
        base = new JURL(String(base));
      }
      this._url = url;
      clear.call(this);
      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
      parse.call(this, input, null, base);
    }
    JURL.prototype = {
      toString: function toString() {
        return this.href;
      },

      get href() {
        if (this._isInvalid) {
          return this._url;
        }
        var authority = '';
        if (this._username !== '' || this._password !== null) {
          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
        }
        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
      },
      set href(value) {
        clear.call(this);
        parse.call(this, value);
      },
      get protocol() {
        return this._scheme + ':';
      },
      set protocol(value) {
        if (this._isInvalid) {
          return;
        }
        parse.call(this, value + ':', 'scheme start');
      },
      get host() {
        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
      },
      set host(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'host');
      },
      get hostname() {
        return this._host;
      },
      set hostname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'hostname');
      },
      get port() {
        return this._port;
      },
      set port(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'port');
      },
      get pathname() {
        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
      },
      set pathname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._path = [];
        parse.call(this, value, 'relative path start');
      },
      get search() {
        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
      },
      set search(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._query = '?';
        if (value[0] === '?') {
          value = value.slice(1);
        }
        parse.call(this, value, 'query');
      },
      get hash() {
        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
      },
      set hash(value) {
        if (this._isInvalid) {
          return;
        }
        this._fragment = '#';
        if (value[0] === '#') {
          value = value.slice(1);
        }
        parse.call(this, value, 'fragment');
      },
      get origin() {
        var host;
        if (this._isInvalid || !this._scheme) {
          return '';
        }
        switch (this._scheme) {
          case 'data':
          case 'file':
          case 'javascript':
          case 'mailto':
            return 'null';
          case 'blob':
            try {
              return new JURL(this._schemeData).origin || 'null';
            } catch (_) {}
            return 'null';
        }
        host = this.host;
        if (!host) {
          return '';
        }
        return this._scheme + '://' + host;
      }
    };
    var OriginalURL = globalScope.URL;
    if (OriginalURL) {
      JURL.createObjectURL = function (blob) {
        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
      };
      JURL.revokeObjectURL = function (url) {
        OriginalURL.revokeObjectURL(url);
      };
    }
    globalScope.URL = JURL;
  })();
  (function checkObjectValues() {
    if (Object.values) {
      return;
    }
    Object.values = __webpack_require__(2444);
  })();
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(76).Buffer))

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1017);
module.exports = __webpack_require__(51).Array.includes;


/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1018);
module.exports = __webpack_require__(51).Math.log2;


/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1019);
module.exports = __webpack_require__(51).Number.isNaN;


/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1020);
module.exports = __webpack_require__(51).Number.isInteger;


/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(276);
__webpack_require__(355);
__webpack_require__(361);
__webpack_require__(1022);
__webpack_require__(1026);
__webpack_require__(1027);
module.exports = __webpack_require__(51).Promise;


/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(276);
__webpack_require__(361);
__webpack_require__(554);
__webpack_require__(1030);
__webpack_require__(1031);
module.exports = __webpack_require__(51).WeakMap;


/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1032);
module.exports = __webpack_require__(51).Object.values;


/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


var isReadableStreamSupported = false;
if (typeof ReadableStream !== 'undefined') {
  try {
    new ReadableStream({
      start: function start(controller) {
        controller.close();
      }
    });
    isReadableStreamSupported = true;
  } catch (e) {}
}
if (isReadableStreamSupported) {
  exports.ReadableStream = ReadableStream;
} else {
  exports.ReadableStream = __webpack_require__(2446).ReadableStream;
}

/***/ }),
/* 2446 */
/***/ (function(module, exports) {

/*
 * To the extent possible under law, the authors have dedicated all copyright
 * and related and neighboring rights to this software to the public
 * domain worldwide. This software is distributed without any warranty.
 *
 * You should have received a copy of the CC0 Public Domain Dedication along
 * with this software. If not, see https://creativecommons.org/publicdomain/zero/1.0/.
 */

(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/  // The module cache
/******/  var installedModules = {};
/******/
/******/  // The require function
/******/  function __webpack_require__(moduleId) {
/******/
/******/    // Check if module is in cache
/******/    if(installedModules[moduleId])
/******/      return installedModules[moduleId].exports;
/******/
/******/    // Create a new module (and put it into the cache)
/******/    var module = installedModules[moduleId] = {
/******/      i: moduleId,
/******/      l: false,
/******/      exports: {}
/******/    };
/******/
/******/    // Execute the module function
/******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/    // Flag the module as loaded
/******/    module.l = true;
/******/
/******/    // Return the exports of the module
/******/    return module.exports;
/******/  }
/******/
/******/
/******/  // expose the modules object (__webpack_modules__)
/******/  __webpack_require__.m = modules;
/******/
/******/  // expose the module cache
/******/  __webpack_require__.c = installedModules;
/******/
/******/  // identity function for calling harmony imports with the correct context
/******/  __webpack_require__.i = function(value) { return value; };
/******/
/******/  // define getter function for harmony exports
/******/  __webpack_require__.d = function(exports, name, getter) {
/******/    if(!__webpack_require__.o(exports, name)) {
/******/      Object.defineProperty(exports, name, {
/******/        configurable: false,
/******/        enumerable: true,
/******/        get: getter
/******/      });
/******/    }
/******/  };
/******/
/******/  // getDefaultExport function for compatibility with non-harmony modules
/******/  __webpack_require__.n = function(module) {
/******/    var getter = module && module.__esModule ?
/******/      function getDefault() { return module['default']; } :
/******/      function getModuleExports() { return module; };
/******/    __webpack_require__.d(getter, 'a', getter);
/******/    return getter;
/******/  };
/******/
/******/  // Object.prototype.hasOwnProperty.call
/******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/  // __webpack_public_path__
/******/  __webpack_require__.p = "";
/******/
/******/  // Load entry module and return exports
/******/  return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _require = __webpack_require__(1),
    assert = _require.assert;

function IsPropertyKey(argument) {
  return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
}

exports.typeIsObject = function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
};

exports.createDataProperty = function (o, p, v) {
  assert(exports.typeIsObject(o));
  Object.defineProperty(o, p, { value: v, writable: true, enumerable: true, configurable: true });
};

exports.createArrayFromList = function (elements) {
  // We use arrays to represent lists, so this is basically a no-op.
  // Do a slice though just in case we happen to depend on the unique-ness.
  return elements.slice();
};

exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
  new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
};

exports.CreateIterResultObject = function (value, done) {
  assert(typeof done === 'boolean');
  var obj = {};
  Object.defineProperty(obj, 'value', { value: value, enumerable: true, writable: true, configurable: true });
  Object.defineProperty(obj, 'done', { value: done, enumerable: true, writable: true, configurable: true });
  return obj;
};

exports.IsFiniteNonNegativeNumber = function (v) {
  if (Number.isNaN(v)) {
    return false;
  }
  if (v === Infinity) {
    return false;
  }
  if (v < 0) {
    return false;
  }

  return true;
};

function Call(F, V, args) {
  if (typeof F !== 'function') {
    throw new TypeError('Argument is not a function');
  }

  return Function.prototype.apply.call(F, V, args);
}

exports.InvokeOrNoop = function (O, P, args) {
  assert(O !== undefined);
  assert(IsPropertyKey(P));
  assert(Array.isArray(args));

  var method = O[P];
  if (method === undefined) {
    return undefined;
  }

  return Call(method, O, args);
};

exports.PromiseInvokeOrNoop = function (O, P, args) {
  assert(O !== undefined);
  assert(IsPropertyKey(P));
  assert(Array.isArray(args));
  try {
    return Promise.resolve(exports.InvokeOrNoop(O, P, args));
  } catch (returnValueE) {
    return Promise.reject(returnValueE);
  }
};

exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
  assert(O !== undefined);
  assert(IsPropertyKey(P));
  assert(Array.isArray(args));
  assert(Array.isArray(argsF));

  var method = void 0;
  try {
    method = O[P];
  } catch (methodE) {
    return Promise.reject(methodE);
  }

  if (method === undefined) {
    return F.apply(null, argsF);
  }

  try {
    return Promise.resolve(Call(method, O, args));
  } catch (e) {
    return Promise.reject(e);
  }
};

// Not implemented correctly
exports.TransferArrayBuffer = function (O) {
  return O.slice();
};

exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
  highWaterMark = Number(highWaterMark);
  if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
    throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
  }

  return highWaterMark;
};

exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
  if (size !== undefined && typeof size !== 'function') {
    throw new TypeError('size property of a queuing strategy must be a function');
  }

  highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);

  return { size: size, highWaterMark: highWaterMark };
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function rethrowAssertionErrorRejection(e) {
  // Used throughout the reference implementation, as `.catch(rethrowAssertionErrorRejection)`, to ensure any errors
  // get shown. There are places in the spec where we do promise transformations and purposefully ignore or don't
  // expect any errors, but assertion errors are always problematic.
  if (e && e.constructor === AssertionError) {
    setTimeout(function () {
      throw e;
    }, 0);
  }
};

function AssertionError(message) {
  this.name = 'AssertionError';
  this.message = message || '';
  this.stack = new Error().stack;
}
AssertionError.prototype = Object.create(Error.prototype);
AssertionError.prototype.constructor = AssertionError;

function assert(value, message) {
  if (!value) {
    throw new AssertionError(message);
  }
}

module.exports = {
  rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
  AssertionError: AssertionError,
  assert: assert
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    InvokeOrNoop = _require.InvokeOrNoop,
    PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
    ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
    typeIsObject = _require.typeIsObject;

var _require2 = __webpack_require__(1),
    assert = _require2.assert,
    rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;

var _require3 = __webpack_require__(3),
    DequeueValue = _require3.DequeueValue,
    EnqueueValueWithSize = _require3.EnqueueValueWithSize,
    PeekQueueValue = _require3.PeekQueueValue,
    ResetQueue = _require3.ResetQueue;

var WritableStream = function () {
  function WritableStream() {
    var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        size = _ref.size,
        _ref$highWaterMark = _ref.highWaterMark,
        highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;

    _classCallCheck(this, WritableStream);

    this._state = 'writable';

    // The error that will be reported by new method calls once the state becomes errored. Only set when [[state]] is
    // 'erroring' or 'errored'. May be set to an undefined value.
    this._storedError = undefined;

    this._writer = undefined;

    // Initialize to undefined first because the constructor of the controller checks this
    // variable to validate the caller.
    this._writableStreamController = undefined;

    // This queue is placed here instead of the writer class in order to allow for passing a writer to the next data
    // producer without waiting for the queued writes to finish.
    this._writeRequests = [];

    // Write requests are removed from _writeRequests when write() is called on the underlying sink. This prevents
    // them from being erroneously rejected on error. If a write() call is in-flight, the request is stored here.
    this._inFlightWriteRequest = undefined;

    // The promise that was returned from writer.close(). Stored here because it may be fulfilled after the writer
    // has been detached.
    this._closeRequest = undefined;

    // Close request is removed from _closeRequest when close() is called on the underlying sink. This prevents it
    // from being erroneously rejected on error. If a close() call is in-flight, the request is stored here.
    this._inFlightCloseRequest = undefined;

    // The promise that was returned from writer.abort(). This may also be fulfilled after the writer has detached.
    this._pendingAbortRequest = undefined;

    // The backpressure signal set by the controller.
    this._backpressure = false;

    var type = underlyingSink.type;

    if (type !== undefined) {
      throw new RangeError('Invalid type is specified');
    }

    this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
    this._writableStreamController.__startSteps();
  }

  _createClass(WritableStream, [{
    key: 'abort',
    value: function abort(reason) {
      if (IsWritableStream(this) === false) {
        return Promise.reject(streamBrandCheckException('abort'));
      }

      if (IsWritableStreamLocked(this) === true) {
        return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
      }

      return WritableStreamAbort(this, reason);
    }
  }, {
    key: 'getWriter',
    value: function getWriter() {
      if (IsWritableStream(this) === false) {
        throw streamBrandCheckException('getWriter');
      }

      return AcquireWritableStreamDefaultWriter(this);
    }
  }, {
    key: 'locked',
    get: function get() {
      if (IsWritableStream(this) === false) {
        throw streamBrandCheckException('locked');
      }

      return IsWritableStreamLocked(this);
    }
  }]);

  return WritableStream;
}();

module.exports = {
  AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
  IsWritableStream: IsWritableStream,
  IsWritableStreamLocked: IsWritableStreamLocked,
  WritableStream: WritableStream,
  WritableStreamAbort: WritableStreamAbort,
  WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
  WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
  WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
  WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
  WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
};

// Abstract operations for the WritableStream.

function AcquireWritableStreamDefaultWriter(stream) {
  return new WritableStreamDefaultWriter(stream);
}

function IsWritableStream(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
    return false;
  }

  return true;
}

function IsWritableStreamLocked(stream) {
  assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');

  if (stream._writer === undefined) {
    return false;
  }

  return true;
}

function WritableStreamAbort(stream, reason) {
  var state = stream._state;
  if (state === 'closed') {
    return Promise.resolve(undefined);
  }
  if (state === 'errored') {
    return Promise.reject(stream._storedError);
  }
  var error = new TypeError('Requested to abort');
  if (stream._pendingAbortRequest !== undefined) {
    return Promise.reject(error);
  }

  assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');

  var wasAlreadyErroring = false;
  if (state === 'erroring') {
    wasAlreadyErroring = true;
    // reason will not be used, so don't keep a reference to it.
    reason = undefined;
  }

  var promise = new Promise(function (resolve, reject) {
    stream._pendingAbortRequest = {
      _resolve: resolve,
      _reject: reject,
      _reason: reason,
      _wasAlreadyErroring: wasAlreadyErroring
    };
  });

  if (wasAlreadyErroring === false) {
    WritableStreamStartErroring(stream, error);
  }

  return promise;
}

// WritableStream API exposed for controllers.

function WritableStreamAddWriteRequest(stream) {
  assert(IsWritableStreamLocked(stream) === true);
  assert(stream._state === 'writable');

  var promise = new Promise(function (resolve, reject) {
    var writeRequest = {
      _resolve: resolve,
      _reject: reject
    };

    stream._writeRequests.push(writeRequest);
  });

  return promise;
}

function WritableStreamDealWithRejection(stream, error) {
  var state = stream._state;

  if (state === 'writable') {
    WritableStreamStartErroring(stream, error);
    return;
  }

  assert(state === 'erroring');
  WritableStreamFinishErroring(stream);
}

function WritableStreamStartErroring(stream, reason) {
  assert(stream._storedError === undefined, 'stream._storedError === undefined');
  assert(stream._state === 'writable', 'state must be writable');

  var controller = stream._writableStreamController;
  assert(controller !== undefined, 'controller must not be undefined');

  stream._state = 'erroring';
  stream._storedError = reason;
  var writer = stream._writer;
  if (writer !== undefined) {
    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
  }

  if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
    WritableStreamFinishErroring(stream);
  }
}

function WritableStreamFinishErroring(stream) {
  assert(stream._state === 'erroring', 'stream._state === erroring');
  assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
  stream._state = 'errored';
  stream._writableStreamController.__errorSteps();

  var storedError = stream._storedError;
  for (var i = 0; i < stream._writeRequests.length; i++) {
    var writeRequest = stream._writeRequests[i];
    writeRequest._reject(storedError);
  }
  stream._writeRequests = [];

  if (stream._pendingAbortRequest === undefined) {
    WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    return;
  }

  var abortRequest = stream._pendingAbortRequest;
  stream._pendingAbortRequest = undefined;

  if (abortRequest._wasAlreadyErroring === true) {
    abortRequest._reject(storedError);
    WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    return;
  }

  var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
  promise.then(function () {
    abortRequest._resolve();
    WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
  }, function (reason) {
    abortRequest._reject(reason);
    WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
  });
}

function WritableStreamFinishInFlightWrite(stream) {
  assert(stream._inFlightWriteRequest !== undefined);
  stream._inFlightWriteRequest._resolve(undefined);
  stream._inFlightWriteRequest = undefined;
}

function WritableStreamFinishInFlightWriteWithError(stream, error) {
  assert(stream._inFlightWriteRequest !== undefined);
  stream._inFlightWriteRequest._reject(error);
  stream._inFlightWriteRequest = undefined;

  assert(stream._state === 'writable' || stream._state === 'erroring');

  WritableStreamDealWithRejection(stream, error);
}

function WritableStreamFinishInFlightClose(stream) {
  assert(stream._inFlightCloseRequest !== undefined);
  stream._inFlightCloseRequest._resolve(undefined);
  stream._inFlightCloseRequest = undefined;

  var state = stream._state;

  assert(state === 'writable' || state === 'erroring');

  if (state === 'erroring') {
    // The error was too late to do anything, so it is ignored.
    stream._storedError = undefined;
    if (stream._pendingAbortRequest !== undefined) {
      stream._pendingAbortRequest._resolve();
      stream._pendingAbortRequest = undefined;
    }
  }

  stream._state = 'closed';

  var writer = stream._writer;
  if (writer !== undefined) {
    defaultWriterClosedPromiseResolve(writer);
  }

  assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
  assert(stream._storedError === undefined, 'stream._storedError === undefined');
}

function WritableStreamFinishInFlightCloseWithError(stream, error) {
  assert(stream._inFlightCloseRequest !== undefined);
  stream._inFlightCloseRequest._reject(error);
  stream._inFlightCloseRequest = undefined;

  assert(stream._state === 'writable' || stream._state === 'erroring');

  // Never execute sink abort() after sink close().
  if (stream._pendingAbortRequest !== undefined) {
    stream._pendingAbortRequest._reject(error);
    stream._pendingAbortRequest = undefined;
  }
  WritableStreamDealWithRejection(stream, error);
}

// TODO(ricea): Fix alphabetical order.
function WritableStreamCloseQueuedOrInFlight(stream) {
  if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
    return false;
  }

  return true;
}

function WritableStreamHasOperationMarkedInFlight(stream) {
  if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
    return false;
  }

  return true;
}

function WritableStreamMarkCloseRequestInFlight(stream) {
  assert(stream._inFlightCloseRequest === undefined);
  assert(stream._closeRequest !== undefined);
  stream._inFlightCloseRequest = stream._closeRequest;
  stream._closeRequest = undefined;
}

function WritableStreamMarkFirstWriteRequestInFlight(stream) {
  assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
  assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
  stream._inFlightWriteRequest = stream._writeRequests.shift();
}

function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
  assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
  if (stream._closeRequest !== undefined) {
    assert(stream._inFlightCloseRequest === undefined);

    stream._closeRequest._reject(stream._storedError);
    stream._closeRequest = undefined;
  }
  var writer = stream._writer;
  if (writer !== undefined) {
    defaultWriterClosedPromiseReject(writer, stream._storedError);
    writer._closedPromise.catch(function () {});
  }
}

function WritableStreamUpdateBackpressure(stream, backpressure) {
  assert(stream._state === 'writable');
  assert(WritableStreamCloseQueuedOrInFlight(stream) === false);

  var writer = stream._writer;
  if (writer !== undefined && backpressure !== stream._backpressure) {
    if (backpressure === true) {
      defaultWriterReadyPromiseReset(writer);
    } else {
      assert(backpressure === false);

      defaultWriterReadyPromiseResolve(writer);
    }
  }

  stream._backpressure = backpressure;
}

var WritableStreamDefaultWriter = function () {
  function WritableStreamDefaultWriter(stream) {
    _classCallCheck(this, WritableStreamDefaultWriter);

    if (IsWritableStream(stream) === false) {
      throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
    }
    if (IsWritableStreamLocked(stream) === true) {
      throw new TypeError('This stream has already been locked for exclusive writing by another writer');
    }

    this._ownerWritableStream = stream;
    stream._writer = this;

    var state = stream._state;

    if (state === 'writable') {
      if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
        defaultWriterReadyPromiseInitialize(this);
      } else {
        defaultWriterReadyPromiseInitializeAsResolved(this);
      }

      defaultWriterClosedPromiseInitialize(this);
    } else if (state === 'erroring') {
      defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
      this._readyPromise.catch(function () {});
      defaultWriterClosedPromiseInitialize(this);
    } else if (state === 'closed') {
      defaultWriterReadyPromiseInitializeAsResolved(this);
      defaultWriterClosedPromiseInitializeAsResolved(this);
    } else {
      assert(state === 'errored', 'state must be errored');

      var storedError = stream._storedError;
      defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
      this._readyPromise.catch(function () {});
      defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
      this._closedPromise.catch(function () {});
    }
  }

  _createClass(WritableStreamDefaultWriter, [{
    key: 'abort',
    value: function abort(reason) {
      if (IsWritableStreamDefaultWriter(this) === false) {
        return Promise.reject(defaultWriterBrandCheckException('abort'));
      }

      if (this._ownerWritableStream === undefined) {
        return Promise.reject(defaultWriterLockException('abort'));
      }

      return WritableStreamDefaultWriterAbort(this, reason);
    }
  }, {
    key: 'close',
    value: function close() {
      if (IsWritableStreamDefaultWriter(this) === false) {
        return Promise.reject(defaultWriterBrandCheckException('close'));
      }

      var stream = this._ownerWritableStream;

      if (stream === undefined) {
        return Promise.reject(defaultWriterLockException('close'));
      }

      if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
        return Promise.reject(new TypeError('cannot close an already-closing stream'));
      }

      return WritableStreamDefaultWriterClose(this);
    }
  }, {
    key: 'releaseLock',
    value: function releaseLock() {
      if (IsWritableStreamDefaultWriter(this) === false) {
        throw defaultWriterBrandCheckException('releaseLock');
      }

      var stream = this._ownerWritableStream;

      if (stream === undefined) {
        return;
      }

      assert(stream._writer !== undefined);

      WritableStreamDefaultWriterRelease(this);
    }
  }, {
    key: 'write',
    value: function write(chunk) {
      if (IsWritableStreamDefaultWriter(this) === false) {
        return Promise.reject(defaultWriterBrandCheckException('write'));
      }

      if (this._ownerWritableStream === undefined) {
        return Promise.reject(defaultWriterLockException('write to'));
      }

      return WritableStreamDefaultWriterWrite(this, chunk);
    }
  }, {
    key: 'closed',
    get: function get() {
      if (IsWritableStreamDefaultWriter(this) === false) {
        return Promise.reject(defaultWriterBrandCheckException('closed'));
      }

      return this._closedPromise;
    }
  }, {
    key: 'desiredSize',
    get: function get() {
      if (IsWritableStreamDefaultWriter(this) === false) {
        throw defaultWriterBrandCheckException('desiredSize');
      }

      if (this._ownerWritableStream === undefined) {
        throw defaultWriterLockException('desiredSize');
      }

      return WritableStreamDefaultWriterGetDesiredSize(this);
    }
  }, {
    key: 'ready',
    get: function get() {
      if (IsWritableStreamDefaultWriter(this) === false) {
        return Promise.reject(defaultWriterBrandCheckException('ready'));
      }

      return this._readyPromise;
    }
  }]);

  return WritableStreamDefaultWriter;
}();

// Abstract operations for the WritableStreamDefaultWriter.

function IsWritableStreamDefaultWriter(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
    return false;
  }

  return true;
}

// A client of WritableStreamDefaultWriter may use these functions directly to bypass state check.

function WritableStreamDefaultWriterAbort(writer, reason) {
  var stream = writer._ownerWritableStream;

  assert(stream !== undefined);

  return WritableStreamAbort(stream, reason);
}

function WritableStreamDefaultWriterClose(writer) {
  var stream = writer._ownerWritableStream;

  assert(stream !== undefined);

  var state = stream._state;
  if (state === 'closed' || state === 'errored') {
    return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
  }

  assert(state === 'writable' || state === 'erroring');
  assert(WritableStreamCloseQueuedOrInFlight(stream) === false);

  var promise = new Promise(function (resolve, reject) {
    var closeRequest = {
      _resolve: resolve,
      _reject: reject
    };

    stream._closeRequest = closeRequest;
  });

  if (stream._backpressure === true && state === 'writable') {
    defaultWriterReadyPromiseResolve(writer);
  }

  WritableStreamDefaultControllerClose(stream._writableStreamController);

  return promise;
}

function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
  var stream = writer._ownerWritableStream;

  assert(stream !== undefined);

  var state = stream._state;
  if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
    return Promise.resolve();
  }

  if (state === 'errored') {
    return Promise.reject(stream._storedError);
  }

  assert(state === 'writable' || state === 'erroring');

  return WritableStreamDefaultWriterClose(writer);
}

function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
  if (writer._closedPromiseState === 'pending') {
    defaultWriterClosedPromiseReject(writer, error);
  } else {
    defaultWriterClosedPromiseResetToRejected(writer, error);
  }
  writer._closedPromise.catch(function () {});
}

function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
  if (writer._readyPromiseState === 'pending') {
    defaultWriterReadyPromiseReject(writer, error);
  } else {
    defaultWriterReadyPromiseResetToRejected(writer, error);
  }
  writer._readyPromise.catch(function () {});
}

function WritableStreamDefaultWriterGetDesiredSize(writer) {
  var stream = writer._ownerWritableStream;
  var state = stream._state;

  if (state === 'errored' || state === 'erroring') {
    return null;
  }

  if (state === 'closed') {
    return 0;
  }

  return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
}

function WritableStreamDefaultWriterRelease(writer) {
  var stream = writer._ownerWritableStream;
  assert(stream !== undefined);
  assert(stream._writer === writer);

  var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');

  WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);

  // The state transitions to "errored" before the sink abort() method runs, but the writer.closed promise is not
  // rejected until afterwards. This means that simply testing state will not work.
  WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);

  stream._writer = undefined;
  writer._ownerWritableStream = undefined;
}

function WritableStreamDefaultWriterWrite(writer, chunk) {
  var stream = writer._ownerWritableStream;

  assert(stream !== undefined);

  var controller = stream._writableStreamController;

  var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);

  if (stream !== writer._ownerWritableStream) {
    return Promise.reject(defaultWriterLockException('write to'));
  }

  var state = stream._state;
  if (state === 'errored') {
    return Promise.reject(stream._storedError);
  }
  if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
    return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
  }
  if (state === 'erroring') {
    return Promise.reject(stream._storedError);
  }

  assert(state === 'writable');

  var promise = WritableStreamAddWriteRequest(stream);

  WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);

  return promise;
}

var WritableStreamDefaultController = function () {
  function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
    _classCallCheck(this, WritableStreamDefaultController);

    if (IsWritableStream(stream) === false) {
      throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
    }

    if (stream._writableStreamController !== undefined) {
      throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
    }

    this._controlledWritableStream = stream;

    this._underlyingSink = underlyingSink;

    // Need to set the slots so that the assert doesn't fire. In the spec the slots already exist implicitly.
    this._queue = undefined;
    this._queueTotalSize = undefined;
    ResetQueue(this);

    this._started = false;

    var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
    this._strategySize = normalizedStrategy.size;
    this._strategyHWM = normalizedStrategy.highWaterMark;

    var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
    WritableStreamUpdateBackpressure(stream, backpressure);
  }

  _createClass(WritableStreamDefaultController, [{
    key: 'error',
    value: function error(e) {
      if (IsWritableStreamDefaultController(this) === false) {
        throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
      }
      var state = this._controlledWritableStream._state;
      if (state !== 'writable') {
        // The stream is closed, errored or will be soon. The sink can't do anything useful if it gets an error here, so
        // just treat it as a no-op.
        return;
      }

      WritableStreamDefaultControllerError(this, e);
    }
  }, {
    key: '__abortSteps',
    value: function __abortSteps(reason) {
      return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
    }
  }, {
    key: '__errorSteps',
    value: function __errorSteps() {
      ResetQueue(this);
    }
  }, {
    key: '__startSteps',
    value: function __startSteps() {
      var _this = this;

      var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
      var stream = this._controlledWritableStream;

      Promise.resolve(startResult).then(function () {
        assert(stream._state === 'writable' || stream._state === 'erroring');
        _this._started = true;
        WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
      }, function (r) {
        assert(stream._state === 'writable' || stream._state === 'erroring');
        _this._started = true;
        WritableStreamDealWithRejection(stream, r);
      }).catch(rethrowAssertionErrorRejection);
    }
  }]);

  return WritableStreamDefaultController;
}();

// Abstract operations implementing interface required by the WritableStream.

function WritableStreamDefaultControllerClose(controller) {
  EnqueueValueWithSize(controller, 'close', 0);
  WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
}

function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
  var strategySize = controller._strategySize;

  if (strategySize === undefined) {
    return 1;
  }

  try {
    return strategySize(chunk);
  } catch (chunkSizeE) {
    WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
    return 1;
  }
}

function WritableStreamDefaultControllerGetDesiredSize(controller) {
  return controller._strategyHWM - controller._queueTotalSize;
}

function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
  var writeRecord = { chunk: chunk };

  try {
    EnqueueValueWithSize(controller, writeRecord, chunkSize);
  } catch (enqueueE) {
    WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
    return;
  }

  var stream = controller._controlledWritableStream;
  if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
    var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
    WritableStreamUpdateBackpressure(stream, backpressure);
  }

  WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
}

// Abstract operations for the WritableStreamDefaultController.

function IsWritableStreamDefaultController(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
    return false;
  }

  return true;
}

function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
  var stream = controller._controlledWritableStream;

  if (controller._started === false) {
    return;
  }

  if (stream._inFlightWriteRequest !== undefined) {
    return;
  }

  var state = stream._state;
  if (state === 'closed' || state === 'errored') {
    return;
  }
  if (state === 'erroring') {
    WritableStreamFinishErroring(stream);
    return;
  }

  if (controller._queue.length === 0) {
    return;
  }

  var writeRecord = PeekQueueValue(controller);
  if (writeRecord === 'close') {
    WritableStreamDefaultControllerProcessClose(controller);
  } else {
    WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
  }
}

function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
  if (controller._controlledWritableStream._state === 'writable') {
    WritableStreamDefaultControllerError(controller, error);
  }
}

function WritableStreamDefaultControllerProcessClose(controller) {
  var stream = controller._controlledWritableStream;

  WritableStreamMarkCloseRequestInFlight(stream);

  DequeueValue(controller);
  assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');

  var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
  sinkClosePromise.then(function () {
    WritableStreamFinishInFlightClose(stream);
  }, function (reason) {
    WritableStreamFinishInFlightCloseWithError(stream, reason);
  }).catch(rethrowAssertionErrorRejection);
}

function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
  var stream = controller._controlledWritableStream;

  WritableStreamMarkFirstWriteRequestInFlight(stream);

  var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
  sinkWritePromise.then(function () {
    WritableStreamFinishInFlightWrite(stream);

    var state = stream._state;
    assert(state === 'writable' || state === 'erroring');

    DequeueValue(controller);

    if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }

    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }, function (reason) {
    WritableStreamFinishInFlightWriteWithError(stream, reason);
  }).catch(rethrowAssertionErrorRejection);
}

function WritableStreamDefaultControllerGetBackpressure(controller) {
  var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
  return desiredSize <= 0;
}

// A client of WritableStreamDefaultController may use these functions directly to bypass state check.

function WritableStreamDefaultControllerError(controller, error) {
  var stream = controller._controlledWritableStream;

  assert(stream._state === 'writable');

  WritableStreamStartErroring(stream, error);
}

// Helper functions for the WritableStream.

function streamBrandCheckException(name) {
  return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
}

// Helper functions for the WritableStreamDefaultWriter.

function defaultWriterBrandCheckException(name) {
  return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
}

function defaultWriterLockException(name) {
  return new TypeError('Cannot ' + name + ' a stream using a released writer');
}

function defaultWriterClosedPromiseInitialize(writer) {
  writer._closedPromise = new Promise(function (resolve, reject) {
    writer._closedPromise_resolve = resolve;
    writer._closedPromise_reject = reject;
    writer._closedPromiseState = 'pending';
  });
}

function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
  writer._closedPromise = Promise.reject(reason);
  writer._closedPromise_resolve = undefined;
  writer._closedPromise_reject = undefined;
  writer._closedPromiseState = 'rejected';
}

function defaultWriterClosedPromiseInitializeAsResolved(writer) {
  writer._closedPromise = Promise.resolve(undefined);
  writer._closedPromise_resolve = undefined;
  writer._closedPromise_reject = undefined;
  writer._closedPromiseState = 'resolved';
}

function defaultWriterClosedPromiseReject(writer, reason) {
  assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
  assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
  assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');

  writer._closedPromise_reject(reason);
  writer._closedPromise_resolve = undefined;
  writer._closedPromise_reject = undefined;
  writer._closedPromiseState = 'rejected';
}

function defaultWriterClosedPromiseResetToRejected(writer, reason) {
  assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
  assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
  assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');

  writer._closedPromise = Promise.reject(reason);
  writer._closedPromiseState = 'rejected';
}

function defaultWriterClosedPromiseResolve(writer) {
  assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
  assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
  assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');

  writer._closedPromise_resolve(undefined);
  writer._closedPromise_resolve = undefined;
  writer._closedPromise_reject = undefined;
  writer._closedPromiseState = 'resolved';
}

function defaultWriterReadyPromiseInitialize(writer) {
  writer._readyPromise = new Promise(function (resolve, reject) {
    writer._readyPromise_resolve = resolve;
    writer._readyPromise_reject = reject;
  });
  writer._readyPromiseState = 'pending';
}

function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
  writer._readyPromise = Promise.reject(reason);
  writer._readyPromise_resolve = undefined;
  writer._readyPromise_reject = undefined;
  writer._readyPromiseState = 'rejected';
}

function defaultWriterReadyPromiseInitializeAsResolved(writer) {
  writer._readyPromise = Promise.resolve(undefined);
  writer._readyPromise_resolve = undefined;
  writer._readyPromise_reject = undefined;
  writer._readyPromiseState = 'fulfilled';
}

function defaultWriterReadyPromiseReject(writer, reason) {
  assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
  assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');

  writer._readyPromise_reject(reason);
  writer._readyPromise_resolve = undefined;
  writer._readyPromise_reject = undefined;
  writer._readyPromiseState = 'rejected';
}

function defaultWriterReadyPromiseReset(writer) {
  assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
  assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');

  writer._readyPromise = new Promise(function (resolve, reject) {
    writer._readyPromise_resolve = resolve;
    writer._readyPromise_reject = reject;
  });
  writer._readyPromiseState = 'pending';
}

function defaultWriterReadyPromiseResetToRejected(writer, reason) {
  assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
  assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');

  writer._readyPromise = Promise.reject(reason);
  writer._readyPromiseState = 'rejected';
}

function defaultWriterReadyPromiseResolve(writer) {
  assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
  assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');

  writer._readyPromise_resolve(undefined);
  writer._readyPromise_resolve = undefined;
  writer._readyPromise_reject = undefined;
  writer._readyPromiseState = 'fulfilled';
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;

var _require2 = __webpack_require__(1),
    assert = _require2.assert;

exports.DequeueValue = function (container) {
  assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
  assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');

  var pair = container._queue.shift();
  container._queueTotalSize -= pair.size;
  if (container._queueTotalSize < 0) {
    container._queueTotalSize = 0;
  }

  return pair.value;
};

exports.EnqueueValueWithSize = function (container, value, size) {
  assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');

  size = Number(size);
  if (!IsFiniteNonNegativeNumber(size)) {
    throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
  }

  container._queue.push({ value: value, size: size });
  container._queueTotalSize += size;
};

exports.PeekQueueValue = function (container) {
  assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
  assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');

  var pair = container._queue[0];
  return pair.value;
};

exports.ResetQueue = function (container) {
  assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');

  container._queue = [];
  container._queueTotalSize = 0;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    ArrayBufferCopy = _require.ArrayBufferCopy,
    CreateIterResultObject = _require.CreateIterResultObject,
    IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
    InvokeOrNoop = _require.InvokeOrNoop,
    PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
    TransferArrayBuffer = _require.TransferArrayBuffer,
    ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
    ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;

var _require2 = __webpack_require__(0),
    createArrayFromList = _require2.createArrayFromList,
    createDataProperty = _require2.createDataProperty,
    typeIsObject = _require2.typeIsObject;

var _require3 = __webpack_require__(1),
    assert = _require3.assert,
    rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;

var _require4 = __webpack_require__(3),
    DequeueValue = _require4.DequeueValue,
    EnqueueValueWithSize = _require4.EnqueueValueWithSize,
    ResetQueue = _require4.ResetQueue;

var _require5 = __webpack_require__(2),
    AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
    IsWritableStream = _require5.IsWritableStream,
    IsWritableStreamLocked = _require5.IsWritableStreamLocked,
    WritableStreamAbort = _require5.WritableStreamAbort,
    WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
    WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
    WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
    WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;

var ReadableStream = function () {
  function ReadableStream() {
    var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        size = _ref.size,
        highWaterMark = _ref.highWaterMark;

    _classCallCheck(this, ReadableStream);

    // Exposed to controllers.
    this._state = 'readable';

    this._reader = undefined;
    this._storedError = undefined;

    this._disturbed = false;

    // Initialize to undefined first because the constructor of the controller checks this
    // variable to validate the caller.
    this._readableStreamController = undefined;
    var type = underlyingSource.type;
    var typeString = String(type);
    if (typeString === 'bytes') {
      if (highWaterMark === undefined) {
        highWaterMark = 0;
      }
      this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
    } else if (type === undefined) {
      if (highWaterMark === undefined) {
        highWaterMark = 1;
      }
      this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
    } else {
      throw new RangeError('Invalid type is specified');
    }
  }

  _createClass(ReadableStream, [{
    key: 'cancel',
    value: function cancel(reason) {
      if (IsReadableStream(this) === false) {
        return Promise.reject(streamBrandCheckException('cancel'));
      }

      if (IsReadableStreamLocked(this) === true) {
        return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
      }

      return ReadableStreamCancel(this, reason);
    }
  }, {
    key: 'getReader',
    value: function getReader() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          mode = _ref2.mode;

      if (IsReadableStream(this) === false) {
        throw streamBrandCheckException('getReader');
      }

      if (mode === undefined) {
        return AcquireReadableStreamDefaultReader(this);
      }

      mode = String(mode);

      if (mode === 'byob') {
        return AcquireReadableStreamBYOBReader(this);
      }

      throw new RangeError('Invalid mode is specified');
    }
  }, {
    key: 'pipeThrough',
    value: function pipeThrough(_ref3, options) {
      var writable = _ref3.writable,
          readable = _ref3.readable;

      var promise = this.pipeTo(writable, options);

      ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);

      return readable;
    }
  }, {
    key: 'pipeTo',
    value: function pipeTo(dest) {
      var _this = this;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          preventClose = _ref4.preventClose,
          preventAbort = _ref4.preventAbort,
          preventCancel = _ref4.preventCancel;

      if (IsReadableStream(this) === false) {
        return Promise.reject(streamBrandCheckException('pipeTo'));
      }
      if (IsWritableStream(dest) === false) {
        return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
      }

      preventClose = Boolean(preventClose);
      preventAbort = Boolean(preventAbort);
      preventCancel = Boolean(preventCancel);

      if (IsReadableStreamLocked(this) === true) {
        return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
      }
      if (IsWritableStreamLocked(dest) === true) {
        return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
      }

      var reader = AcquireReadableStreamDefaultReader(this);
      var writer = AcquireWritableStreamDefaultWriter(dest);

      var shuttingDown = false;

      // This is used to keep track of the spec's requirement that we wait for ongoing writes during shutdown.
      var currentWrite = Promise.resolve();

      return new Promise(function (resolve, reject) {
        // Using reader and writer, read all chunks from this and write them to dest
        // - Backpressure must be enforced
        // - Shutdown must stop all activity
        function pipeLoop() {
          currentWrite = Promise.resolve();

          if (shuttingDown === true) {
            return Promise.resolve();
          }

          return writer._readyPromise.then(function () {
            return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
              var value = _ref5.value,
                  done = _ref5.done;

              if (done === true) {
                return;
              }

              currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
            });
          }).then(pipeLoop);
        }

        // Errors must be propagated forward
        isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
          if (preventAbort === false) {
            shutdownWithAction(function () {
              return WritableStreamAbort(dest, storedError);
            }, true, storedError);
          } else {
            shutdown(true, storedError);
          }
        });

        // Errors must be propagated backward
        isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
          if (preventCancel === false) {
            shutdownWithAction(function () {
              return ReadableStreamCancel(_this, storedError);
            }, true, storedError);
          } else {
            shutdown(true, storedError);
          }
        });

        // Closing must be propagated forward
        isOrBecomesClosed(_this, reader._closedPromise, function () {
          if (preventClose === false) {
            shutdownWithAction(function () {
              return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
            });
          } else {
            shutdown();
          }
        });

        // Closing must be propagated backward
        if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
          var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');

          if (preventCancel === false) {
            shutdownWithAction(function () {
              return ReadableStreamCancel(_this, destClosed);
            }, true, destClosed);
          } else {
            shutdown(true, destClosed);
          }
        }

        pipeLoop().catch(function (err) {
          currentWrite = Promise.resolve();
          rethrowAssertionErrorRejection(err);
        });

        function waitForWritesToFinish() {
          // Another write may have started while we were waiting on this currentWrite, so we have to be sure to wait
          // for that too.
          var oldCurrentWrite = currentWrite;
          return currentWrite.then(function () {
            return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
          });
        }

        function isOrBecomesErrored(stream, promise, action) {
          if (stream._state === 'errored') {
            action(stream._storedError);
          } else {
            promise.catch(action).catch(rethrowAssertionErrorRejection);
          }
        }

        function isOrBecomesClosed(stream, promise, action) {
          if (stream._state === 'closed') {
            action();
          } else {
            promise.then(action).catch(rethrowAssertionErrorRejection);
          }
        }

        function shutdownWithAction(action, originalIsError, originalError) {
          if (shuttingDown === true) {
            return;
          }
          shuttingDown = true;

          if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
            waitForWritesToFinish().then(doTheRest);
          } else {
            doTheRest();
          }

          function doTheRest() {
            action().then(function () {
              return finalize(originalIsError, originalError);
            }, function (newError) {
              return finalize(true, newError);
            }).catch(rethrowAssertionErrorRejection);
          }
        }

        function shutdown(isError, error) {
          if (shuttingDown === true) {
            return;
          }
          shuttingDown = true;

          if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
            waitForWritesToFinish().then(function () {
              return finalize(isError, error);
            }).catch(rethrowAssertionErrorRejection);
          } else {
            finalize(isError, error);
          }
        }

        function finalize(isError, error) {
          WritableStreamDefaultWriterRelease(writer);
          ReadableStreamReaderGenericRelease(reader);

          if (isError) {
            reject(error);
          } else {
            resolve(undefined);
          }
        }
      });
    }
  }, {
    key: 'tee',
    value: function tee() {
      if (IsReadableStream(this) === false) {
        throw streamBrandCheckException('tee');
      }

      var branches = ReadableStreamTee(this, false);
      return createArrayFromList(branches);
    }
  }, {
    key: 'locked',
    get: function get() {
      if (IsReadableStream(this) === false) {
        throw streamBrandCheckException('locked');
      }

      return IsReadableStreamLocked(this);
    }
  }]);

  return ReadableStream;
}();

module.exports = {
  ReadableStream: ReadableStream,
  IsReadableStreamDisturbed: IsReadableStreamDisturbed,
  ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
  ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
  ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
  ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
};

// Abstract operations for the ReadableStream.

function AcquireReadableStreamBYOBReader(stream) {
  return new ReadableStreamBYOBReader(stream);
}

function AcquireReadableStreamDefaultReader(stream) {
  return new ReadableStreamDefaultReader(stream);
}

function IsReadableStream(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
    return false;
  }

  return true;
}

function IsReadableStreamDisturbed(stream) {
  assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');

  return stream._disturbed;
}

function IsReadableStreamLocked(stream) {
  assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');

  if (stream._reader === undefined) {
    return false;
  }

  return true;
}

function ReadableStreamTee(stream, cloneForBranch2) {
  assert(IsReadableStream(stream) === true);
  assert(typeof cloneForBranch2 === 'boolean');

  var reader = AcquireReadableStreamDefaultReader(stream);

  var teeState = {
    closedOrErrored: false,
    canceled1: false,
    canceled2: false,
    reason1: undefined,
    reason2: undefined
  };
  teeState.promise = new Promise(function (resolve) {
    teeState._resolve = resolve;
  });

  var pull = create_ReadableStreamTeePullFunction();
  pull._reader = reader;
  pull._teeState = teeState;
  pull._cloneForBranch2 = cloneForBranch2;

  var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
  cancel1._stream = stream;
  cancel1._teeState = teeState;

  var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
  cancel2._stream = stream;
  cancel2._teeState = teeState;

  var underlyingSource1 = Object.create(Object.prototype);
  createDataProperty(underlyingSource1, 'pull', pull);
  createDataProperty(underlyingSource1, 'cancel', cancel1);
  var branch1Stream = new ReadableStream(underlyingSource1);

  var underlyingSource2 = Object.create(Object.prototype);
  createDataProperty(underlyingSource2, 'pull', pull);
  createDataProperty(underlyingSource2, 'cancel', cancel2);
  var branch2Stream = new ReadableStream(underlyingSource2);

  pull._branch1 = branch1Stream._readableStreamController;
  pull._branch2 = branch2Stream._readableStreamController;

  reader._closedPromise.catch(function (r) {
    if (teeState.closedOrErrored === true) {
      return;
    }

    ReadableStreamDefaultControllerError(pull._branch1, r);
    ReadableStreamDefaultControllerError(pull._branch2, r);
    teeState.closedOrErrored = true;
  });

  return [branch1Stream, branch2Stream];
}

function create_ReadableStreamTeePullFunction() {
  function f() {
    var reader = f._reader,
        branch1 = f._branch1,
        branch2 = f._branch2,
        teeState = f._teeState;


    return ReadableStreamDefaultReaderRead(reader).then(function (result) {
      assert(typeIsObject(result));
      var value = result.value;
      var done = result.done;
      assert(typeof done === 'boolean');

      if (done === true && teeState.closedOrErrored === false) {
        if (teeState.canceled1 === false) {
          ReadableStreamDefaultControllerClose(branch1);
        }
        if (teeState.canceled2 === false) {
          ReadableStreamDefaultControllerClose(branch2);
        }
        teeState.closedOrErrored = true;
      }

      if (teeState.closedOrErrored === true) {
        return;
      }

      var value1 = value;
      var value2 = value;

      // There is no way to access the cloning code right now in the reference implementation.
      // If we add one then we'll need an implementation for serializable objects.
      // if (teeState.canceled2 === false && cloneForBranch2 === true) {
      //   value2 = StructuredDeserialize(StructuredSerialize(value2));
      // }

      if (teeState.canceled1 === false) {
        ReadableStreamDefaultControllerEnqueue(branch1, value1);
      }

      if (teeState.canceled2 === false) {
        ReadableStreamDefaultControllerEnqueue(branch2, value2);
      }
    });
  }
  return f;
}

function create_ReadableStreamTeeBranch1CancelFunction() {
  function f(reason) {
    var stream = f._stream,
        teeState = f._teeState;


    teeState.canceled1 = true;
    teeState.reason1 = reason;
    if (teeState.canceled2 === true) {
      var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
      var cancelResult = ReadableStreamCancel(stream, compositeReason);
      teeState._resolve(cancelResult);
    }
    return teeState.promise;
  }
  return f;
}

function create_ReadableStreamTeeBranch2CancelFunction() {
  function f(reason) {
    var stream = f._stream,
        teeState = f._teeState;


    teeState.canceled2 = true;
    teeState.reason2 = reason;
    if (teeState.canceled1 === true) {
      var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
      var cancelResult = ReadableStreamCancel(stream, compositeReason);
      teeState._resolve(cancelResult);
    }
    return teeState.promise;
  }
  return f;
}

// ReadableStream API exposed for controllers.

function ReadableStreamAddReadIntoRequest(stream) {
  assert(IsReadableStreamBYOBReader(stream._reader) === true);
  assert(stream._state === 'readable' || stream._state === 'closed');

  var promise = new Promise(function (resolve, reject) {
    var readIntoRequest = {
      _resolve: resolve,
      _reject: reject
    };

    stream._reader._readIntoRequests.push(readIntoRequest);
  });

  return promise;
}

function ReadableStreamAddReadRequest(stream) {
  assert(IsReadableStreamDefaultReader(stream._reader) === true);
  assert(stream._state === 'readable');

  var promise = new Promise(function (resolve, reject) {
    var readRequest = {
      _resolve: resolve,
      _reject: reject
    };

    stream._reader._readRequests.push(readRequest);
  });

  return promise;
}

function ReadableStreamCancel(stream, reason) {
  stream._disturbed = true;

  if (stream._state === 'closed') {
    return Promise.resolve(undefined);
  }
  if (stream._state === 'errored') {
    return Promise.reject(stream._storedError);
  }

  ReadableStreamClose(stream);

  var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
  return sourceCancelPromise.then(function () {
    return undefined;
  });
}

function ReadableStreamClose(stream) {
  assert(stream._state === 'readable');

  stream._state = 'closed';

  var reader = stream._reader;

  if (reader === undefined) {
    return undefined;
  }

  if (IsReadableStreamDefaultReader(reader) === true) {
    for (var i = 0; i < reader._readRequests.length; i++) {
      var _resolve = reader._readRequests[i]._resolve;

      _resolve(CreateIterResultObject(undefined, true));
    }
    reader._readRequests = [];
  }

  defaultReaderClosedPromiseResolve(reader);

  return undefined;
}

function ReadableStreamError(stream, e) {
  assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
  assert(stream._state === 'readable', 'state must be readable');

  stream._state = 'errored';
  stream._storedError = e;

  var reader = stream._reader;

  if (reader === undefined) {
    return undefined;
  }

  if (IsReadableStreamDefaultReader(reader) === true) {
    for (var i = 0; i < reader._readRequests.length; i++) {
      var readRequest = reader._readRequests[i];
      readRequest._reject(e);
    }

    reader._readRequests = [];
  } else {
    assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');

    for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
      var readIntoRequest = reader._readIntoRequests[_i];
      readIntoRequest._reject(e);
    }

    reader._readIntoRequests = [];
  }

  defaultReaderClosedPromiseReject(reader, e);
  reader._closedPromise.catch(function () {});
}

function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
  var reader = stream._reader;

  assert(reader._readIntoRequests.length > 0);

  var readIntoRequest = reader._readIntoRequests.shift();
  readIntoRequest._resolve(CreateIterResultObject(chunk, done));
}

function ReadableStreamFulfillReadRequest(stream, chunk, done) {
  var reader = stream._reader;

  assert(reader._readRequests.length > 0);

  var readRequest = reader._readRequests.shift();
  readRequest._resolve(CreateIterResultObject(chunk, done));
}

function ReadableStreamGetNumReadIntoRequests(stream) {
  return stream._reader._readIntoRequests.length;
}

function ReadableStreamGetNumReadRequests(stream) {
  return stream._reader._readRequests.length;
}

function ReadableStreamHasBYOBReader(stream) {
  var reader = stream._reader;

  if (reader === undefined) {
    return false;
  }

  if (IsReadableStreamBYOBReader(reader) === false) {
    return false;
  }

  return true;
}

function ReadableStreamHasDefaultReader(stream) {
  var reader = stream._reader;

  if (reader === undefined) {
    return false;
  }

  if (IsReadableStreamDefaultReader(reader) === false) {
    return false;
  }

  return true;
}

// Readers

var ReadableStreamDefaultReader = function () {
  function ReadableStreamDefaultReader(stream) {
    _classCallCheck(this, ReadableStreamDefaultReader);

    if (IsReadableStream(stream) === false) {
      throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
    }
    if (IsReadableStreamLocked(stream) === true) {
      throw new TypeError('This stream has already been locked for exclusive reading by another reader');
    }

    ReadableStreamReaderGenericInitialize(this, stream);

    this._readRequests = [];
  }

  _createClass(ReadableStreamDefaultReader, [{
    key: 'cancel',
    value: function cancel(reason) {
      if (IsReadableStreamDefaultReader(this) === false) {
        return Promise.reject(defaultReaderBrandCheckException('cancel'));
      }

      if (this._ownerReadableStream === undefined) {
        return Promise.reject(readerLockException('cancel'));
      }

      return ReadableStreamReaderGenericCancel(this, reason);
    }
  }, {
    key: 'read',
    value: function read() {
      if (IsReadableStreamDefaultReader(this) === false) {
        return Promise.reject(defaultReaderBrandCheckException('read'));
      }

      if (this._ownerReadableStream === undefined) {
        return Promise.reject(readerLockException('read from'));
      }

      return ReadableStreamDefaultReaderRead(this);
    }
  }, {
    key: 'releaseLock',
    value: function releaseLock() {
      if (IsReadableStreamDefaultReader(this) === false) {
        throw defaultReaderBrandCheckException('releaseLock');
      }

      if (this._ownerReadableStream === undefined) {
        return;
      }

      if (this._readRequests.length > 0) {
        throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
      }

      ReadableStreamReaderGenericRelease(this);
    }
  }, {
    key: 'closed',
    get: function get() {
      if (IsReadableStreamDefaultReader(this) === false) {
        return Promise.reject(defaultReaderBrandCheckException('closed'));
      }

      return this._closedPromise;
    }
  }]);

  return ReadableStreamDefaultReader;
}();

var ReadableStreamBYOBReader = function () {
  function ReadableStreamBYOBReader(stream) {
    _classCallCheck(this, ReadableStreamBYOBReader);

    if (!IsReadableStream(stream)) {
      throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
    }
    if (IsReadableByteStreamController(stream._readableStreamController) === false) {
      throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
    }
    if (IsReadableStreamLocked(stream)) {
      throw new TypeError('This stream has already been locked for exclusive reading by another reader');
    }

    ReadableStreamReaderGenericInitialize(this, stream);

    this._readIntoRequests = [];
  }

  _createClass(ReadableStreamBYOBReader, [{
    key: 'cancel',
    value: function cancel(reason) {
      if (!IsReadableStreamBYOBReader(this)) {
        return Promise.reject(byobReaderBrandCheckException('cancel'));
      }

      if (this._ownerReadableStream === undefined) {
        return Promise.reject(readerLockException('cancel'));
      }

      return ReadableStreamReaderGenericCancel(this, reason);
    }
  }, {
    key: 'read',
    value: function read(view) {
      if (!IsReadableStreamBYOBReader(this)) {
        return Promise.reject(byobReaderBrandCheckException('read'));
      }

      if (this._ownerReadableStream === undefined) {
        return Promise.reject(readerLockException('read from'));
      }

      if (!ArrayBuffer.isView(view)) {
        return Promise.reject(new TypeError('view must be an array buffer view'));
      }

      if (view.byteLength === 0) {
        return Promise.reject(new TypeError('view must have non-zero byteLength'));
      }

      return ReadableStreamBYOBReaderRead(this, view);
    }
  }, {
    key: 'releaseLock',
    value: function releaseLock() {
      if (!IsReadableStreamBYOBReader(this)) {
        throw byobReaderBrandCheckException('releaseLock');
      }

      if (this._ownerReadableStream === undefined) {
        return;
      }

      if (this._readIntoRequests.length > 0) {
        throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
      }

      ReadableStreamReaderGenericRelease(this);
    }
  }, {
    key: 'closed',
    get: function get() {
      if (!IsReadableStreamBYOBReader(this)) {
        return Promise.reject(byobReaderBrandCheckException('closed'));
      }

      return this._closedPromise;
    }
  }]);

  return ReadableStreamBYOBReader;
}();

// Abstract operations for the readers.

function IsReadableStreamBYOBReader(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
    return false;
  }

  return true;
}

function IsReadableStreamDefaultReader(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
    return false;
  }

  return true;
}

function ReadableStreamReaderGenericInitialize(reader, stream) {
  reader._ownerReadableStream = stream;
  stream._reader = reader;

  if (stream._state === 'readable') {
    defaultReaderClosedPromiseInitialize(reader);
  } else if (stream._state === 'closed') {
    defaultReaderClosedPromiseInitializeAsResolved(reader);
  } else {
    assert(stream._state === 'errored', 'state must be errored');

    defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
    reader._closedPromise.catch(function () {});
  }
}

// A client of ReadableStreamDefaultReader and ReadableStreamBYOBReader may use these functions directly to bypass state
// check.

function ReadableStreamReaderGenericCancel(reader, reason) {
  var stream = reader._ownerReadableStream;
  assert(stream !== undefined);
  return ReadableStreamCancel(stream, reason);
}

function ReadableStreamReaderGenericRelease(reader) {
  assert(reader._ownerReadableStream !== undefined);
  assert(reader._ownerReadableStream._reader === reader);

  if (reader._ownerReadableStream._state === 'readable') {
    defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
  } else {
    defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
  }
  reader._closedPromise.catch(function () {});

  reader._ownerReadableStream._reader = undefined;
  reader._ownerReadableStream = undefined;
}

function ReadableStreamBYOBReaderRead(reader, view) {
  var stream = reader._ownerReadableStream;

  assert(stream !== undefined);

  stream._disturbed = true;

  if (stream._state === 'errored') {
    return Promise.reject(stream._storedError);
  }

  // Controllers must implement this.
  return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
}

function ReadableStreamDefaultReaderRead(reader) {
  var stream = reader._ownerReadableStream;

  assert(stream !== undefined);

  stream._disturbed = true;

  if (stream._state === 'closed') {
    return Promise.resolve(CreateIterResultObject(undefined, true));
  }

  if (stream._state === 'errored') {
    return Promise.reject(stream._storedError);
  }

  assert(stream._state === 'readable');

  return stream._readableStreamController.__pullSteps();
}

// Controllers

var ReadableStreamDefaultController = function () {
  function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
    _classCallCheck(this, ReadableStreamDefaultController);

    if (IsReadableStream(stream) === false) {
      throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
    }

    if (stream._readableStreamController !== undefined) {
      throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
    }

    this._controlledReadableStream = stream;

    this._underlyingSource = underlyingSource;

    // Need to set the slots so that the assert doesn't fire. In the spec the slots already exist implicitly.
    this._queue = undefined;
    this._queueTotalSize = undefined;
    ResetQueue(this);

    this._started = false;
    this._closeRequested = false;
    this._pullAgain = false;
    this._pulling = false;

    var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
    this._strategySize = normalizedStrategy.size;
    this._strategyHWM = normalizedStrategy.highWaterMark;

    var controller = this;

    var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
    Promise.resolve(startResult).then(function () {
      controller._started = true;

      assert(controller._pulling === false);
      assert(controller._pullAgain === false);

      ReadableStreamDefaultControllerCallPullIfNeeded(controller);
    }, function (r) {
      ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
    }).catch(rethrowAssertionErrorRejection);
  }

  _createClass(ReadableStreamDefaultController, [{
    key: 'close',
    value: function close() {
      if (IsReadableStreamDefaultController(this) === false) {
        throw defaultControllerBrandCheckException('close');
      }

      if (this._closeRequested === true) {
        throw new TypeError('The stream has already been closed; do not close it again!');
      }

      var state = this._controlledReadableStream._state;
      if (state !== 'readable') {
        throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
      }

      ReadableStreamDefaultControllerClose(this);
    }
  }, {
    key: 'enqueue',
    value: function enqueue(chunk) {
      if (IsReadableStreamDefaultController(this) === false) {
        throw defaultControllerBrandCheckException('enqueue');
      }

      if (this._closeRequested === true) {
        throw new TypeError('stream is closed or draining');
      }

      var state = this._controlledReadableStream._state;
      if (state !== 'readable') {
        throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
      }

      return ReadableStreamDefaultControllerEnqueue(this, chunk);
    }
  }, {
    key: 'error',
    value: function error(e) {
      if (IsReadableStreamDefaultController(this) === false) {
        throw defaultControllerBrandCheckException('error');
      }

      var stream = this._controlledReadableStream;
      if (stream._state !== 'readable') {
        throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
      }

      ReadableStreamDefaultControllerError(this, e);
    }
  }, {
    key: '__cancelSteps',
    value: function __cancelSteps(reason) {
      ResetQueue(this);
      return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
    }
  }, {
    key: '__pullSteps',
    value: function __pullSteps() {
      var stream = this._controlledReadableStream;

      if (this._queue.length > 0) {
        var chunk = DequeueValue(this);

        if (this._closeRequested === true && this._queue.length === 0) {
          ReadableStreamClose(stream);
        } else {
          ReadableStreamDefaultControllerCallPullIfNeeded(this);
        }

        return Promise.resolve(CreateIterResultObject(chunk, false));
      }

      var pendingPromise = ReadableStreamAddReadRequest(stream);
      ReadableStreamDefaultControllerCallPullIfNeeded(this);
      return pendingPromise;
    }
  }, {
    key: 'desiredSize',
    get: function get() {
      if (IsReadableStreamDefaultController(this) === false) {
        throw defaultControllerBrandCheckException('desiredSize');
      }

      return ReadableStreamDefaultControllerGetDesiredSize(this);
    }
  }]);

  return ReadableStreamDefaultController;
}();

// Abstract operations for the ReadableStreamDefaultController.

function IsReadableStreamDefaultController(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
    return false;
  }

  return true;
}

function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
  var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
  if (shouldPull === false) {
    return undefined;
  }

  if (controller._pulling === true) {
    controller._pullAgain = true;
    return undefined;
  }

  assert(controller._pullAgain === false);

  controller._pulling = true;

  var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
  pullPromise.then(function () {
    controller._pulling = false;

    if (controller._pullAgain === true) {
      controller._pullAgain = false;
      return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
    }
    return undefined;
  }, function (e) {
    ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
  }).catch(rethrowAssertionErrorRejection);

  return undefined;
}

function ReadableStreamDefaultControllerShouldCallPull(controller) {
  var stream = controller._controlledReadableStream;

  if (stream._state === 'closed' || stream._state === 'errored') {
    return false;
  }

  if (controller._closeRequested === true) {
    return false;
  }

  if (controller._started === false) {
    return false;
  }

  if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
    return true;
  }

  var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
  if (desiredSize > 0) {
    return true;
  }

  return false;
}

// A client of ReadableStreamDefaultController may use these functions directly to bypass state check.

function ReadableStreamDefaultControllerClose(controller) {
  var stream = controller._controlledReadableStream;

  assert(controller._closeRequested === false);
  assert(stream._state === 'readable');

  controller._closeRequested = true;

  if (controller._queue.length === 0) {
    ReadableStreamClose(stream);
  }
}

function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
  var stream = controller._controlledReadableStream;

  assert(controller._closeRequested === false);
  assert(stream._state === 'readable');

  if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
    ReadableStreamFulfillReadRequest(stream, chunk, false);
  } else {
    var chunkSize = 1;

    if (controller._strategySize !== undefined) {
      var strategySize = controller._strategySize;
      try {
        chunkSize = strategySize(chunk);
      } catch (chunkSizeE) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
        throw chunkSizeE;
      }
    }

    try {
      EnqueueValueWithSize(controller, chunk, chunkSize);
    } catch (enqueueE) {
      ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
      throw enqueueE;
    }
  }

  ReadableStreamDefaultControllerCallPullIfNeeded(controller);

  return undefined;
}

function ReadableStreamDefaultControllerError(controller, e) {
  var stream = controller._controlledReadableStream;

  assert(stream._state === 'readable');

  ResetQueue(controller);

  ReadableStreamError(stream, e);
}

function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
  if (controller._controlledReadableStream._state === 'readable') {
    ReadableStreamDefaultControllerError(controller, e);
  }
}

function ReadableStreamDefaultControllerGetDesiredSize(controller) {
  var stream = controller._controlledReadableStream;
  var state = stream._state;

  if (state === 'errored') {
    return null;
  }
  if (state === 'closed') {
    return 0;
  }

  return controller._strategyHWM - controller._queueTotalSize;
}

var ReadableStreamBYOBRequest = function () {
  function ReadableStreamBYOBRequest(controller, view) {
    _classCallCheck(this, ReadableStreamBYOBRequest);

    this._associatedReadableByteStreamController = controller;
    this._view = view;
  }

  _createClass(ReadableStreamBYOBRequest, [{
    key: 'respond',
    value: function respond(bytesWritten) {
      if (IsReadableStreamBYOBRequest(this) === false) {
        throw byobRequestBrandCheckException('respond');
      }

      if (this._associatedReadableByteStreamController === undefined) {
        throw new TypeError('This BYOB request has been invalidated');
      }

      ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
    }
  }, {
    key: 'respondWithNewView',
    value: function respondWithNewView(view) {
      if (IsReadableStreamBYOBRequest(this) === false) {
        throw byobRequestBrandCheckException('respond');
      }

      if (this._associatedReadableByteStreamController === undefined) {
        throw new TypeError('This BYOB request has been invalidated');
      }

      if (!ArrayBuffer.isView(view)) {
        throw new TypeError('You can only respond with array buffer views');
      }

      ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
    }
  }, {
    key: 'view',
    get: function get() {
      return this._view;
    }
  }]);

  return ReadableStreamBYOBRequest;
}();

var ReadableByteStreamController = function () {
  function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
    _classCallCheck(this, ReadableByteStreamController);

    if (IsReadableStream(stream) === false) {
      throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
    }

    if (stream._readableStreamController !== undefined) {
      throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
    }

    this._controlledReadableStream = stream;

    this._underlyingByteSource = underlyingByteSource;

    this._pullAgain = false;
    this._pulling = false;

    ReadableByteStreamControllerClearPendingPullIntos(this);

    // Need to set the slots so that the assert doesn't fire. In the spec the slots already exist implicitly.
    this._queue = this._queueTotalSize = undefined;
    ResetQueue(this);

    this._closeRequested = false;
    this._started = false;

    this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);

    var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
    if (autoAllocateChunkSize !== undefined) {
      if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
        throw new RangeError('autoAllocateChunkSize must be a positive integer');
      }
    }
    this._autoAllocateChunkSize = autoAllocateChunkSize;

    this._pendingPullIntos = [];

    var controller = this;

    var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
    Promise.resolve(startResult).then(function () {
      controller._started = true;

      assert(controller._pulling === false);
      assert(controller._pullAgain === false);

      ReadableByteStreamControllerCallPullIfNeeded(controller);
    }, function (r) {
      if (stream._state === 'readable') {
        ReadableByteStreamControllerError(controller, r);
      }
    }).catch(rethrowAssertionErrorRejection);
  }

  _createClass(ReadableByteStreamController, [{
    key: 'close',
    value: function close() {
      if (IsReadableByteStreamController(this) === false) {
        throw byteStreamControllerBrandCheckException('close');
      }

      if (this._closeRequested === true) {
        throw new TypeError('The stream has already been closed; do not close it again!');
      }

      var state = this._controlledReadableStream._state;
      if (state !== 'readable') {
        throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
      }

      ReadableByteStreamControllerClose(this);
    }
  }, {
    key: 'enqueue',
    value: function enqueue(chunk) {
      if (IsReadableByteStreamController(this) === false) {
        throw byteStreamControllerBrandCheckException('enqueue');
      }

      if (this._closeRequested === true) {
        throw new TypeError('stream is closed or draining');
      }

      var state = this._controlledReadableStream._state;
      if (state !== 'readable') {
        throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
      }

      if (!ArrayBuffer.isView(chunk)) {
        throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
      }

      ReadableByteStreamControllerEnqueue(this, chunk);
    }
  }, {
    key: 'error',
    value: function error(e) {
      if (IsReadableByteStreamController(this) === false) {
        throw byteStreamControllerBrandCheckException('error');
      }

      var stream = this._controlledReadableStream;
      if (stream._state !== 'readable') {
        throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
      }

      ReadableByteStreamControllerError(this, e);
    }
  }, {
    key: '__cancelSteps',
    value: function __cancelSteps(reason) {
      if (this._pendingPullIntos.length > 0) {
        var firstDescriptor = this._pendingPullIntos[0];
        firstDescriptor.bytesFilled = 0;
      }

      ResetQueue(this);

      return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
    }
  }, {
    key: '__pullSteps',
    value: function __pullSteps() {
      var stream = this._controlledReadableStream;
      assert(ReadableStreamHasDefaultReader(stream) === true);

      if (this._queueTotalSize > 0) {
        assert(ReadableStreamGetNumReadRequests(stream) === 0);

        var entry = this._queue.shift();
        this._queueTotalSize -= entry.byteLength;

        ReadableByteStreamControllerHandleQueueDrain(this);

        var view = void 0;
        try {
          view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
        } catch (viewE) {
          return Promise.reject(viewE);
        }

        return Promise.resolve(CreateIterResultObject(view, false));
      }

      var autoAllocateChunkSize = this._autoAllocateChunkSize;
      if (autoAllocateChunkSize !== undefined) {
        var buffer = void 0;
        try {
          buffer = new ArrayBuffer(autoAllocateChunkSize);
        } catch (bufferE) {
          return Promise.reject(bufferE);
        }

        var pullIntoDescriptor = {
          buffer: buffer,
          byteOffset: 0,
          byteLength: autoAllocateChunkSize,
          bytesFilled: 0,
          elementSize: 1,
          ctor: Uint8Array,
          readerType: 'default'
        };

        this._pendingPullIntos.push(pullIntoDescriptor);
      }

      var promise = ReadableStreamAddReadRequest(stream);

      ReadableByteStreamControllerCallPullIfNeeded(this);

      return promise;
    }
  }, {
    key: 'byobRequest',
    get: function get() {
      if (IsReadableByteStreamController(this) === false) {
        throw byteStreamControllerBrandCheckException('byobRequest');
      }

      if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
        var firstDescriptor = this._pendingPullIntos[0];
        var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);

        this._byobRequest = new ReadableStreamBYOBRequest(this, view);
      }

      return this._byobRequest;
    }
  }, {
    key: 'desiredSize',
    get: function get() {
      if (IsReadableByteStreamController(this) === false) {
        throw byteStreamControllerBrandCheckException('desiredSize');
      }

      return ReadableByteStreamControllerGetDesiredSize(this);
    }
  }]);

  return ReadableByteStreamController;
}();

// Abstract operations for the ReadableByteStreamController.

function IsReadableByteStreamController(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
    return false;
  }

  return true;
}

function IsReadableStreamBYOBRequest(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
    return false;
  }

  return true;
}

function ReadableByteStreamControllerCallPullIfNeeded(controller) {
  var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
  if (shouldPull === false) {
    return undefined;
  }

  if (controller._pulling === true) {
    controller._pullAgain = true;
    return undefined;
  }

  assert(controller._pullAgain === false);

  controller._pulling = true;

  // TODO: Test controller argument
  var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
  pullPromise.then(function () {
    controller._pulling = false;

    if (controller._pullAgain === true) {
      controller._pullAgain = false;
      ReadableByteStreamControllerCallPullIfNeeded(controller);
    }
  }, function (e) {
    if (controller._controlledReadableStream._state === 'readable') {
      ReadableByteStreamControllerError(controller, e);
    }
  }).catch(rethrowAssertionErrorRejection);

  return undefined;
}

function ReadableByteStreamControllerClearPendingPullIntos(controller) {
  ReadableByteStreamControllerInvalidateBYOBRequest(controller);
  controller._pendingPullIntos = [];
}

function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
  assert(stream._state !== 'errored', 'state must not be errored');

  var done = false;
  if (stream._state === 'closed') {
    assert(pullIntoDescriptor.bytesFilled === 0);
    done = true;
  }

  var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
  if (pullIntoDescriptor.readerType === 'default') {
    ReadableStreamFulfillReadRequest(stream, filledView, done);
  } else {
    assert(pullIntoDescriptor.readerType === 'byob');
    ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
  }
}

function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
  var bytesFilled = pullIntoDescriptor.bytesFilled;
  var elementSize = pullIntoDescriptor.elementSize;

  assert(bytesFilled <= pullIntoDescriptor.byteLength);
  assert(bytesFilled % elementSize === 0);

  return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
}

function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
  controller._queue.push({ buffer: buffer, byteOffset: byteOffset, byteLength: byteLength });
  controller._queueTotalSize += byteLength;
}

function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
  var elementSize = pullIntoDescriptor.elementSize;

  var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;

  var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
  var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
  var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;

  var totalBytesToCopyRemaining = maxBytesToCopy;
  var ready = false;
  if (maxAlignedBytes > currentAlignedBytes) {
    totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
    ready = true;
  }

  var queue = controller._queue;

  while (totalBytesToCopyRemaining > 0) {
    var headOfQueue = queue[0];

    var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);

    var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
    ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);

    if (headOfQueue.byteLength === bytesToCopy) {
      queue.shift();
    } else {
      headOfQueue.byteOffset += bytesToCopy;
      headOfQueue.byteLength -= bytesToCopy;
    }
    controller._queueTotalSize -= bytesToCopy;

    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);

    totalBytesToCopyRemaining -= bytesToCopy;
  }

  if (ready === false) {
    assert(controller._queueTotalSize === 0, 'queue must be empty');
    assert(pullIntoDescriptor.bytesFilled > 0);
    assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
  }

  return ready;
}

function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
  assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);

  ReadableByteStreamControllerInvalidateBYOBRequest(controller);
  pullIntoDescriptor.bytesFilled += size;
}

function ReadableByteStreamControllerHandleQueueDrain(controller) {
  assert(controller._controlledReadableStream._state === 'readable');

  if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
    ReadableStreamClose(controller._controlledReadableStream);
  } else {
    ReadableByteStreamControllerCallPullIfNeeded(controller);
  }
}

function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
  if (controller._byobRequest === undefined) {
    return;
  }

  controller._byobRequest._associatedReadableByteStreamController = undefined;
  controller._byobRequest._view = undefined;
  controller._byobRequest = undefined;
}

function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
  assert(controller._closeRequested === false);

  while (controller._pendingPullIntos.length > 0) {
    if (controller._queueTotalSize === 0) {
      return;
    }

    var pullIntoDescriptor = controller._pendingPullIntos[0];

    if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
      ReadableByteStreamControllerShiftPendingPullInto(controller);

      ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
    }
  }
}

function ReadableByteStreamControllerPullInto(controller, view) {
  var stream = controller._controlledReadableStream;

  var elementSize = 1;
  if (view.constructor !== DataView) {
    elementSize = view.constructor.BYTES_PER_ELEMENT;
  }

  var ctor = view.constructor;

  var pullIntoDescriptor = {
    buffer: view.buffer,
    byteOffset: view.byteOffset,
    byteLength: view.byteLength,
    bytesFilled: 0,
    elementSize: elementSize,
    ctor: ctor,
    readerType: 'byob'
  };

  if (controller._pendingPullIntos.length > 0) {
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    controller._pendingPullIntos.push(pullIntoDescriptor);

    // No ReadableByteStreamControllerCallPullIfNeeded() call since:
    // - No change happens on desiredSize
    // - The source has already been notified of that there's at least 1 pending read(view)

    return ReadableStreamAddReadIntoRequest(stream);
  }

  if (stream._state === 'closed') {
    var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
    return Promise.resolve(CreateIterResultObject(emptyView, true));
  }

  if (controller._queueTotalSize > 0) {
    if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
      var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);

      ReadableByteStreamControllerHandleQueueDrain(controller);

      return Promise.resolve(CreateIterResultObject(filledView, false));
    }

    if (controller._closeRequested === true) {
      var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
      ReadableByteStreamControllerError(controller, e);

      return Promise.reject(e);
    }
  }

  pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
  controller._pendingPullIntos.push(pullIntoDescriptor);

  var promise = ReadableStreamAddReadIntoRequest(stream);

  ReadableByteStreamControllerCallPullIfNeeded(controller);

  return promise;
}

function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
  firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);

  assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');

  var stream = controller._controlledReadableStream;
  if (ReadableStreamHasBYOBReader(stream) === true) {
    while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
      var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
      ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
    }
  }
}

function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
  if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
    throw new RangeError('bytesWritten out of range');
  }

  ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);

  if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
    // TODO: Figure out whether we should detach the buffer or not here.
    return;
  }

  ReadableByteStreamControllerShiftPendingPullInto(controller);

  var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
  if (remainderSize > 0) {
    var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
    var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
    ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
  }

  pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
  pullIntoDescriptor.bytesFilled -= remainderSize;
  ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);

  ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
}

function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
  var firstDescriptor = controller._pendingPullIntos[0];

  var stream = controller._controlledReadableStream;

  if (stream._state === 'closed') {
    if (bytesWritten !== 0) {
      throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
    }

    ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
  } else {
    assert(stream._state === 'readable');

    ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
  }
}

function ReadableByteStreamControllerShiftPendingPullInto(controller) {
  var descriptor = controller._pendingPullIntos.shift();
  ReadableByteStreamControllerInvalidateBYOBRequest(controller);
  return descriptor;
}

function ReadableByteStreamControllerShouldCallPull(controller) {
  var stream = controller._controlledReadableStream;

  if (stream._state !== 'readable') {
    return false;
  }

  if (controller._closeRequested === true) {
    return false;
  }

  if (controller._started === false) {
    return false;
  }

  if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
    return true;
  }

  if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
    return true;
  }

  if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
    return true;
  }

  return false;
}

// A client of ReadableByteStreamController may use these functions directly to bypass state check.

function ReadableByteStreamControllerClose(controller) {
  var stream = controller._controlledReadableStream;

  assert(controller._closeRequested === false);
  assert(stream._state === 'readable');

  if (controller._queueTotalSize > 0) {
    controller._closeRequested = true;

    return;
  }

  if (controller._pendingPullIntos.length > 0) {
    var firstPendingPullInto = controller._pendingPullIntos[0];
    if (firstPendingPullInto.bytesFilled > 0) {
      var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
      ReadableByteStreamControllerError(controller, e);

      throw e;
    }
  }

  ReadableStreamClose(stream);
}

function ReadableByteStreamControllerEnqueue(controller, chunk) {
  var stream = controller._controlledReadableStream;

  assert(controller._closeRequested === false);
  assert(stream._state === 'readable');

  var buffer = chunk.buffer;
  var byteOffset = chunk.byteOffset;
  var byteLength = chunk.byteLength;
  var transferredBuffer = TransferArrayBuffer(buffer);

  if (ReadableStreamHasDefaultReader(stream) === true) {
    if (ReadableStreamGetNumReadRequests(stream) === 0) {
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
    } else {
      assert(controller._queue.length === 0);

      var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
      ReadableStreamFulfillReadRequest(stream, transferredView, false);
    }
  } else if (ReadableStreamHasBYOBReader(stream) === true) {
    // TODO: Ideally in this branch detaching should happen only if the buffer is not consumed fully.
    ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
  } else {
    assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
    ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
  }
}

function ReadableByteStreamControllerError(controller, e) {
  var stream = controller._controlledReadableStream;

  assert(stream._state === 'readable');

  ReadableByteStreamControllerClearPendingPullIntos(controller);

  ResetQueue(controller);
  ReadableStreamError(stream, e);
}

function ReadableByteStreamControllerGetDesiredSize(controller) {
  var stream = controller._controlledReadableStream;
  var state = stream._state;

  if (state === 'errored') {
    return null;
  }
  if (state === 'closed') {
    return 0;
  }

  return controller._strategyHWM - controller._queueTotalSize;
}

function ReadableByteStreamControllerRespond(controller, bytesWritten) {
  bytesWritten = Number(bytesWritten);
  if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
    throw new RangeError('bytesWritten must be a finite');
  }

  assert(controller._pendingPullIntos.length > 0);

  ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
}

function ReadableByteStreamControllerRespondWithNewView(controller, view) {
  assert(controller._pendingPullIntos.length > 0);

  var firstDescriptor = controller._pendingPullIntos[0];

  if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
    throw new RangeError('The region specified by view does not match byobRequest');
  }
  if (firstDescriptor.byteLength !== view.byteLength) {
    throw new RangeError('The buffer of view has different capacity than byobRequest');
  }

  firstDescriptor.buffer = view.buffer;

  ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
}

// Helper functions for the ReadableStream.

function streamBrandCheckException(name) {
  return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
}

// Helper functions for the readers.

function readerLockException(name) {
  return new TypeError('Cannot ' + name + ' a stream using a released reader');
}

// Helper functions for the ReadableStreamDefaultReader.

function defaultReaderBrandCheckException(name) {
  return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
}

function defaultReaderClosedPromiseInitialize(reader) {
  reader._closedPromise = new Promise(function (resolve, reject) {
    reader._closedPromise_resolve = resolve;
    reader._closedPromise_reject = reject;
  });
}

function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
  reader._closedPromise = Promise.reject(reason);
  reader._closedPromise_resolve = undefined;
  reader._closedPromise_reject = undefined;
}

function defaultReaderClosedPromiseInitializeAsResolved(reader) {
  reader._closedPromise = Promise.resolve(undefined);
  reader._closedPromise_resolve = undefined;
  reader._closedPromise_reject = undefined;
}

function defaultReaderClosedPromiseReject(reader, reason) {
  assert(reader._closedPromise_resolve !== undefined);
  assert(reader._closedPromise_reject !== undefined);

  reader._closedPromise_reject(reason);
  reader._closedPromise_resolve = undefined;
  reader._closedPromise_reject = undefined;
}

function defaultReaderClosedPromiseResetToRejected(reader, reason) {
  assert(reader._closedPromise_resolve === undefined);
  assert(reader._closedPromise_reject === undefined);

  reader._closedPromise = Promise.reject(reason);
}

function defaultReaderClosedPromiseResolve(reader) {
  assert(reader._closedPromise_resolve !== undefined);
  assert(reader._closedPromise_reject !== undefined);

  reader._closedPromise_resolve(undefined);
  reader._closedPromise_resolve = undefined;
  reader._closedPromise_reject = undefined;
}

// Helper functions for the ReadableStreamDefaultReader.

function byobReaderBrandCheckException(name) {
  return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
}

// Helper functions for the ReadableStreamDefaultController.

function defaultControllerBrandCheckException(name) {
  return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
}

// Helper functions for the ReadableStreamBYOBRequest.

function byobRequestBrandCheckException(name) {
  return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
}

// Helper functions for the ReadableByteStreamController.

function byteStreamControllerBrandCheckException(name) {
  return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
}

// Helper function for ReadableStream pipeThrough

function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
  try {
    // This relies on the brand-check that is enforced by Promise.prototype.then(). As with the rest of the reference
    // implementation, it doesn't attempt to do the right thing if someone has modified the global environment.
    Promise.prototype.then.call(promise, undefined, function () {});
  } catch (e) {
    // The brand check failed, therefore the internal slot is not present and there's nothing further to do.
  }
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var transformStream = __webpack_require__(6);
var readableStream = __webpack_require__(4);
var writableStream = __webpack_require__(2);

exports.TransformStream = transformStream.TransformStream;
exports.ReadableStream = readableStream.ReadableStream;
exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
exports.IsWritableStream = writableStream.IsWritableStream;
exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
exports.WritableStream = writableStream.WritableStream;
exports.WritableStreamAbort = writableStream.WritableStreamAbort;
exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(1),
    assert = _require.assert;

var _require2 = __webpack_require__(0),
    InvokeOrNoop = _require2.InvokeOrNoop,
    PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
    PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
    typeIsObject = _require2.typeIsObject;

var _require3 = __webpack_require__(4),
    ReadableStream = _require3.ReadableStream,
    ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
    ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
    ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
    ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;

var _require4 = __webpack_require__(2),
    WritableStream = _require4.WritableStream,
    WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;

// Methods on the transform stream controller object

function TransformStreamCloseReadable(transformStream) {
  // console.log('TransformStreamCloseReadable()');

  if (transformStream._errored === true) {
    throw new TypeError('TransformStream is already errored');
  }

  if (transformStream._readableClosed === true) {
    throw new TypeError('Readable side is already closed');
  }

  TransformStreamCloseReadableInternal(transformStream);
}

function TransformStreamEnqueueToReadable(transformStream, chunk) {
  // console.log('TransformStreamEnqueueToReadable()');

  if (transformStream._errored === true) {
    throw new TypeError('TransformStream is already errored');
  }

  if (transformStream._readableClosed === true) {
    throw new TypeError('Readable side is already closed');
  }

  // We throttle transformer.transform invocation based on the backpressure of the ReadableStream, but we still
  // accept TransformStreamEnqueueToReadable() calls.

  var controller = transformStream._readableController;

  try {
    ReadableStreamDefaultControllerEnqueue(controller, chunk);
  } catch (e) {
    // This happens when readableStrategy.size() throws.
    // The ReadableStream has already errored itself.
    transformStream._readableClosed = true;
    TransformStreamErrorIfNeeded(transformStream, e);

    throw transformStream._storedError;
  }

  var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
  var maybeBackpressure = desiredSize <= 0;

  if (maybeBackpressure === true && transformStream._backpressure === false) {
    // This allows pull() again. When desiredSize is 0, it's possible that a pull() will happen immediately (but
    // asynchronously) after this because of pending read()s and set _backpressure back to false.
    //
    // If pull() could be called from inside enqueue(), then this logic would be wrong. This cannot happen
    // because there is always a promise pending from start() or pull() when _backpressure is false.
    TransformStreamSetBackpressure(transformStream, true);
  }
}

function TransformStreamError(transformStream, e) {
  if (transformStream._errored === true) {
    throw new TypeError('TransformStream is already errored');
  }

  TransformStreamErrorInternal(transformStream, e);
}

// Abstract operations.

function TransformStreamCloseReadableInternal(transformStream) {
  assert(transformStream._errored === false);
  assert(transformStream._readableClosed === false);

  try {
    ReadableStreamDefaultControllerClose(transformStream._readableController);
  } catch (e) {
    assert(false);
  }

  transformStream._readableClosed = true;
}

function TransformStreamErrorIfNeeded(transformStream, e) {
  if (transformStream._errored === false) {
    TransformStreamErrorInternal(transformStream, e);
  }
}

function TransformStreamErrorInternal(transformStream, e) {
  // console.log('TransformStreamErrorInternal()');

  assert(transformStream._errored === false);

  transformStream._errored = true;
  transformStream._storedError = e;

  if (transformStream._writableDone === false) {
    WritableStreamDefaultControllerError(transformStream._writableController, e);
  }
  if (transformStream._readableClosed === false) {
    ReadableStreamDefaultControllerError(transformStream._readableController, e);
  }
}

// Used for preventing the next write() call on TransformStreamSink until there
// is no longer backpressure.
function TransformStreamReadableReadyPromise(transformStream) {
  assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');

  if (transformStream._backpressure === false) {
    return Promise.resolve();
  }

  assert(transformStream._backpressure === true, '_backpressure should have been initialized');

  return transformStream._backpressureChangePromise;
}

function TransformStreamSetBackpressure(transformStream, backpressure) {
  // console.log(`TransformStreamSetBackpressure(${backpressure})`);

  // Passes also when called during construction.
  assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');

  if (transformStream._backpressureChangePromise !== undefined) {
    // The fulfillment value is just for a sanity check.
    transformStream._backpressureChangePromise_resolve(backpressure);
  }

  transformStream._backpressureChangePromise = new Promise(function (resolve) {
    transformStream._backpressureChangePromise_resolve = resolve;
  });

  transformStream._backpressureChangePromise.then(function (resolution) {
    assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
  });

  transformStream._backpressure = backpressure;
}

function TransformStreamDefaultTransform(chunk, transformStreamController) {
  var transformStream = transformStreamController._controlledTransformStream;
  TransformStreamEnqueueToReadable(transformStream, chunk);
  return Promise.resolve();
}

function TransformStreamTransform(transformStream, chunk) {
  // console.log('TransformStreamTransform()');

  assert(transformStream._errored === false);
  assert(transformStream._transforming === false);
  assert(transformStream._backpressure === false);

  transformStream._transforming = true;

  var transformer = transformStream._transformer;
  var controller = transformStream._transformStreamController;

  var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);

  return transformPromise.then(function () {
    transformStream._transforming = false;

    return TransformStreamReadableReadyPromise(transformStream);
  }, function (e) {
    TransformStreamErrorIfNeeded(transformStream, e);
    return Promise.reject(e);
  });
}

function IsTransformStreamDefaultController(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
    return false;
  }

  return true;
}

function IsTransformStream(x) {
  if (!typeIsObject(x)) {
    return false;
  }

  if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
    return false;
  }

  return true;
}

var TransformStreamSink = function () {
  function TransformStreamSink(transformStream, startPromise) {
    _classCallCheck(this, TransformStreamSink);

    this._transformStream = transformStream;
    this._startPromise = startPromise;
  }

  _createClass(TransformStreamSink, [{
    key: 'start',
    value: function start(c) {
      var transformStream = this._transformStream;

      transformStream._writableController = c;

      return this._startPromise.then(function () {
        return TransformStreamReadableReadyPromise(transformStream);
      });
    }
  }, {
    key: 'write',
    value: function write(chunk) {
      // console.log('TransformStreamSink.write()');

      var transformStream = this._transformStream;

      return TransformStreamTransform(transformStream, chunk);
    }
  }, {
    key: 'abort',
    value: function abort() {
      var transformStream = this._transformStream;
      transformStream._writableDone = true;
      TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
    }
  }, {
    key: 'close',
    value: function close() {
      // console.log('TransformStreamSink.close()');

      var transformStream = this._transformStream;

      assert(transformStream._transforming === false);

      transformStream._writableDone = true;

      var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
      // Return a promise that is fulfilled with undefined on success.
      return flushPromise.then(function () {
        if (transformStream._errored === true) {
          return Promise.reject(transformStream._storedError);
        }
        if (transformStream._readableClosed === false) {
          TransformStreamCloseReadableInternal(transformStream);
        }
        return Promise.resolve();
      }).catch(function (r) {
        TransformStreamErrorIfNeeded(transformStream, r);
        return Promise.reject(transformStream._storedError);
      });
    }
  }]);

  return TransformStreamSink;
}();

var TransformStreamSource = function () {
  function TransformStreamSource(transformStream, startPromise) {
    _classCallCheck(this, TransformStreamSource);

    this._transformStream = transformStream;
    this._startPromise = startPromise;
  }

  _createClass(TransformStreamSource, [{
    key: 'start',
    value: function start(c) {
      var transformStream = this._transformStream;

      transformStream._readableController = c;

      return this._startPromise.then(function () {
        // Prevent the first pull() call until there is backpressure.

        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');

        if (transformStream._backpressure === true) {
          return Promise.resolve();
        }

        assert(transformStream._backpressure === false, '_backpressure should have been initialized');

        return transformStream._backpressureChangePromise;
      });
    }
  }, {
    key: 'pull',
    value: function pull() {
      // console.log('TransformStreamSource.pull()');

      var transformStream = this._transformStream;

      // Invariant. Enforced by the promises returned by start() and pull().
      assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');

      assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');

      TransformStreamSetBackpressure(transformStream, false);

      // Prevent the next pull() call until there is backpressure.
      return transformStream._backpressureChangePromise;
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      var transformStream = this._transformStream;
      transformStream._readableClosed = true;
      TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
    }
  }]);

  return TransformStreamSource;
}();

var TransformStreamDefaultController = function () {
  function TransformStreamDefaultController(transformStream) {
    _classCallCheck(this, TransformStreamDefaultController);

    if (IsTransformStream(transformStream) === false) {
      throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
    }

    if (transformStream._transformStreamController !== undefined) {
      throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
    }

    this._controlledTransformStream = transformStream;
  }

  _createClass(TransformStreamDefaultController, [{
    key: 'enqueue',
    value: function enqueue(chunk) {
      if (IsTransformStreamDefaultController(this) === false) {
        throw defaultControllerBrandCheckException('enqueue');
      }

      TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
    }
  }, {
    key: 'close',
    value: function close() {
      if (IsTransformStreamDefaultController(this) === false) {
        throw defaultControllerBrandCheckException('close');
      }

      TransformStreamCloseReadable(this._controlledTransformStream);
    }
  }, {
    key: 'error',
    value: function error(reason) {
      if (IsTransformStreamDefaultController(this) === false) {
        throw defaultControllerBrandCheckException('error');
      }

      TransformStreamError(this._controlledTransformStream, reason);
    }
  }, {
    key: 'desiredSize',
    get: function get() {
      if (IsTransformStreamDefaultController(this) === false) {
        throw defaultControllerBrandCheckException('desiredSize');
      }

      var transformStream = this._controlledTransformStream;
      var readableController = transformStream._readableController;

      return ReadableStreamDefaultControllerGetDesiredSize(readableController);
    }
  }]);

  return TransformStreamDefaultController;
}();

var TransformStream = function () {
  function TransformStream() {
    var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TransformStream);

    this._transformer = transformer;
    var readableStrategy = transformer.readableStrategy,
        writableStrategy = transformer.writableStrategy;


    this._transforming = false;
    this._errored = false;
    this._storedError = undefined;

    this._writableController = undefined;
    this._readableController = undefined;
    this._transformStreamController = undefined;

    this._writableDone = false;
    this._readableClosed = false;

    this._backpressure = undefined;
    this._backpressureChangePromise = undefined;
    this._backpressureChangePromise_resolve = undefined;

    this._transformStreamController = new TransformStreamDefaultController(this);

    var startPromise_resolve = void 0;
    var startPromise = new Promise(function (resolve) {
      startPromise_resolve = resolve;
    });

    var source = new TransformStreamSource(this, startPromise);

    this._readable = new ReadableStream(source, readableStrategy);

    var sink = new TransformStreamSink(this, startPromise);

    this._writable = new WritableStream(sink, writableStrategy);

    assert(this._writableController !== undefined);
    assert(this._readableController !== undefined);

    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
    // Set _backpressure based on desiredSize. As there is no read() at this point, we can just interpret
    // desiredSize being non-positive as backpressure.
    TransformStreamSetBackpressure(this, desiredSize <= 0);

    var transformStream = this;
    var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
    startPromise_resolve(startResult);
    startPromise.catch(function (e) {
      // The underlyingSink and underlyingSource will error the readable and writable ends on their own.
      if (transformStream._errored === false) {
        transformStream._errored = true;
        transformStream._storedError = e;
      }
    });
  }

  _createClass(TransformStream, [{
    key: 'readable',
    get: function get() {
      if (IsTransformStream(this) === false) {
        throw streamBrandCheckException('readable');
      }

      return this._readable;
    }
  }, {
    key: 'writable',
    get: function get() {
      if (IsTransformStream(this) === false) {
        throw streamBrandCheckException('writable');
      }

      return this._writable;
    }
  }]);

  return TransformStream;
}();

module.exports = { TransformStream: TransformStream };

// Helper functions for the TransformStreamDefaultController.

function defaultControllerBrandCheckException(name) {
  return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
}

// Helper functions for the TransformStream.

function streamBrandCheckException(name) {
  return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ })
/******/ ])));

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFJS = exports.globalScope = undefined;

var _dom_utils = __webpack_require__(204);

var _util = __webpack_require__(73);

var _api = __webpack_require__(1034);

var _annotation_layer = __webpack_require__(1036);

var _global_scope = __webpack_require__(287);

var _global_scope2 = _interopRequireDefault(_global_scope);

var _metadata = __webpack_require__(1035);

var _text_layer = __webpack_require__(1037);

var _svg = __webpack_require__(1038);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!_global_scope2.default.PDFJS) {
  _global_scope2.default.PDFJS = {};
}
var PDFJS = _global_scope2.default.PDFJS;
{
  PDFJS.version = '2.0.305';
  PDFJS.build = '9c6a8801';
}
PDFJS.pdfBug = false;
if (PDFJS.verbosity !== undefined) {
  (0, _util.setVerbosityLevel)(PDFJS.verbosity);
}
delete PDFJS.verbosity;
Object.defineProperty(PDFJS, 'verbosity', {
  get: function get() {
    return (0, _util.getVerbosityLevel)();
  },
  set: function set(level) {
    (0, _util.setVerbosityLevel)(level);
  },

  enumerable: true,
  configurable: true
});
PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
PDFJS.OPS = _util.OPS;
PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
PDFJS.isValidUrl = _dom_utils.isValidUrl;
PDFJS.shadow = _util.shadow;
PDFJS.createBlob = _util.createBlob;
PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
  return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
};
Object.defineProperty(PDFJS, 'isLittleEndian', {
  configurable: true,
  get: function PDFJS_isLittleEndian() {
    return (0, _util.shadow)(PDFJS, 'isLittleEndian', (0, _util.isLittleEndian)());
  }
});
PDFJS.removeNullCharacters = _util.removeNullCharacters;
PDFJS.PasswordResponses = _util.PasswordResponses;
PDFJS.PasswordException = _util.PasswordException;
PDFJS.UnknownErrorException = _util.UnknownErrorException;
PDFJS.InvalidPDFException = _util.InvalidPDFException;
PDFJS.MissingPDFException = _util.MissingPDFException;
PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
PDFJS.Util = _util.Util;
PDFJS.PageViewport = _util.PageViewport;
PDFJS.createPromiseCapability = _util.createPromiseCapability;
PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? '' : PDFJS.imageResourcesPath;
PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
PDFJS.getDocument = _api.getDocument;
PDFJS.LoopbackPort = _api.LoopbackPort;
PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
PDFJS.PDFWorker = _api.PDFWorker;
PDFJS.LinkTarget = _dom_utils.LinkTarget;
PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
PDFJS.renderTextLayer = _text_layer.renderTextLayer;
PDFJS.Metadata = _metadata.Metadata;
PDFJS.SVGGraphics = _svg.SVGGraphics;
exports.globalScope = _global_scope2.default;
exports.PDFJS = PDFJS;

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontLoader = exports.FontFaceObject = undefined;

var _util = __webpack_require__(73);

function FontLoader(docId) {
  this.docId = docId;
  this.styleElement = null;
  this.nativeFontFaces = [];
  this.loadTestFontId = 0;
  this.loadingContext = {
    requests: [],
    nextRequestId: 0
  };
}
FontLoader.prototype = {
  insertRule: function fontLoaderInsertRule(rule) {
    var styleElement = this.styleElement;
    if (!styleElement) {
      styleElement = this.styleElement = document.createElement('style');
      styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
      document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    var styleSheet = styleElement.sheet;
    styleSheet.insertRule(rule, styleSheet.cssRules.length);
  },
  clear: function fontLoaderClear() {
    if (this.styleElement) {
      this.styleElement.remove();
      this.styleElement = null;
    }
    this.nativeFontFaces.forEach(function (nativeFontFace) {
      document.fonts.delete(nativeFontFace);
    });
    this.nativeFontFaces.length = 0;
  }
};
{
  var getLoadTestFont = function getLoadTestFont() {
    return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ' + 'AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA' + 'AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm' + 'FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA' + 'AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A' + 'ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA' + 'MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA' + 'AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA' + 'AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ' + 'AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA' + 'AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA' + 'EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA' + 'AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA' + 'AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc' + 'A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF' + 'hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA' + 'AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg' + 'ABAAAAAAAAAAAD6AAAAAAAAA==');
  };
  Object.defineProperty(FontLoader.prototype, 'loadTestFont', {
    get: function get() {
      return (0, _util.shadow)(this, 'loadTestFont', getLoadTestFont());
    },

    configurable: true
  });
  FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
    this.nativeFontFaces.push(nativeFontFace);
    document.fonts.add(nativeFontFace);
  };
  FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
    var rules = [];
    var fontsToLoad = [];
    var fontLoadPromises = [];
    var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
      return nativeFontFace.loaded.catch(function (e) {
        (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + e);
      });
    };
    var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
    for (var i = 0, ii = fonts.length; i < ii; i++) {
      var font = fonts[i];
      if (font.attached || font.loading === false) {
        continue;
      }
      font.attached = true;
      if (isFontLoadingAPISupported) {
        var nativeFontFace = font.createNativeFontFace();
        if (nativeFontFace) {
          this.addNativeFontFace(nativeFontFace);
          fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
        }
      } else {
        var rule = font.createFontFaceRule();
        if (rule) {
          this.insertRule(rule);
          rules.push(rule);
          fontsToLoad.push(font);
        }
      }
    }
    var request = this.queueLoadingCallback(callback);
    if (isFontLoadingAPISupported) {
      Promise.all(fontLoadPromises).then(function () {
        request.complete();
      });
    } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
      this.prepareFontLoadEvent(rules, fontsToLoad, request);
    } else {
      request.complete();
    }
  };
  FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
    function LoadLoader_completeRequest() {
      (0, _util.assert)(!request.end, 'completeRequest() cannot be called twice');
      request.end = Date.now();
      while (context.requests.length > 0 && context.requests[0].end) {
        var otherRequest = context.requests.shift();
        setTimeout(otherRequest.callback, 0);
      }
    }
    var context = this.loadingContext;
    var requestId = 'pdfjs-font-loading-' + context.nextRequestId++;
    var request = {
      id: requestId,
      complete: LoadLoader_completeRequest,
      callback: callback,
      started: Date.now()
    };
    context.requests.push(request);
    return request;
  };
  FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
    function int32(data, offset) {
      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
    }
    function spliceString(s, offset, remove, insert) {
      var chunk1 = s.substr(0, offset);
      var chunk2 = s.substr(offset + remove);
      return chunk1 + insert + chunk2;
    }
    var i, ii;
    var canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    var ctx = canvas.getContext('2d');
    var called = 0;
    function isFontReady(name, callback) {
      called++;
      if (called > 30) {
        (0, _util.warn)('Load test font never loaded.');
        callback();
        return;
      }
      ctx.font = '30px ' + name;
      ctx.fillText('.', 0, 20);
      var imageData = ctx.getImageData(0, 0, 1, 1);
      if (imageData.data[3] > 0) {
        callback();
        return;
      }
      setTimeout(isFontReady.bind(null, name, callback));
    }
    var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
    var data = this.loadTestFont;
    var COMMENT_OFFSET = 976;
    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
    var CFF_CHECKSUM_OFFSET = 16;
    var XXXX_VALUE = 0x58585858;
    var checksum = int32(data, CFF_CHECKSUM_OFFSET);
    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
    }
    if (i < loadTestFontId.length) {
      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
    }
    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
    var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
    var rule = '@font-face { font-family:"' + loadTestFontId + '";src:' + url + '}';
    this.insertRule(rule);
    var names = [];
    for (i = 0, ii = fonts.length; i < ii; i++) {
      names.push(fonts[i].loadedName);
    }
    names.push(loadTestFontId);
    var div = document.createElement('div');
    div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
    for (i = 0, ii = names.length; i < ii; ++i) {
      var span = document.createElement('span');
      span.textContent = 'Hi';
      span.style.fontFamily = names[i];
      div.appendChild(span);
    }
    document.body.appendChild(div);
    isFontReady(loadTestFontId, function () {
      document.body.removeChild(div);
      request.complete();
    });
  };
}
{
  FontLoader.isFontLoadingAPISupported = typeof document !== 'undefined' && !!document.fonts;
}
{
  var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
    if (typeof navigator === 'undefined') {
      return true;
    }
    var supported = false;
    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
    if (m && m[1] >= 14) {
      supported = true;
    }
    return supported;
  };
  Object.defineProperty(FontLoader, 'isSyncFontLoadingSupported', {
    get: function get() {
      return (0, _util.shadow)(FontLoader, 'isSyncFontLoadingSupported', isSyncFontLoadingSupported());
    },

    enumerable: true,
    configurable: true
  });
}
var IsEvalSupportedCached = {
  get value() {
    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
  }
};
var FontFaceObject = function FontFaceObjectClosure() {
  function FontFaceObject(translatedData, options) {
    this.compiledGlyphs = Object.create(null);
    for (var i in translatedData) {
      this[i] = translatedData[i];
    }
    this.options = options;
  }
  FontFaceObject.prototype = {
    createNativeFontFace: function FontFaceObject_createNativeFontFace() {
      if (!this.data) {
        return null;
      }
      if (this.options.disableFontFace) {
        this.disableFontFace = true;
        return null;
      }
      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
      if (this.options.fontRegistry) {
        this.options.fontRegistry.registerFont(this);
      }
      return nativeFontFace;
    },
    createFontFaceRule: function FontFaceObject_createFontFaceRule() {
      if (!this.data) {
        return null;
      }
      if (this.options.disableFontFace) {
        this.disableFontFace = true;
        return null;
      }
      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
      var fontName = this.loadedName;
      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
      var rule = '@font-face { font-family:"' + fontName + '";src:' + url + '}';
      if (this.options.fontRegistry) {
        this.options.fontRegistry.registerFont(this, url);
      }
      return rule;
    },
    getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
      if (!(character in this.compiledGlyphs)) {
        var cmds = objs.get(this.loadedName + '_path_' + character);
        var current, i, len;
        if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
          var args,
              js = '';
          for (i = 0, len = cmds.length; i < len; i++) {
            current = cmds[i];
            if (current.args !== undefined) {
              args = current.args.join(',');
            } else {
              args = '';
            }
            js += 'c.' + current.cmd + '(' + args + ');\n';
          }
          this.compiledGlyphs[character] = new Function('c', 'size', js);
        } else {
          this.compiledGlyphs[character] = function (c, size) {
            for (i = 0, len = cmds.length; i < len; i++) {
              current = cmds[i];
              if (current.cmd === 'scale') {
                current.args = [size, -size];
              }
              c[current.cmd].apply(c, current.args);
            }
          };
        }
      }
      return this.compiledGlyphs[character];
    }
  };
  return FontFaceObject;
}();
exports.FontFaceObject = FontFaceObject;
exports.FontLoader = FontLoader;

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasGraphics = undefined;

var _util = __webpack_require__(73);

var _pattern_helper = __webpack_require__(2450);

var MIN_FONT_SIZE = 16;
var MAX_FONT_SIZE = 100;
var MAX_GROUP_SIZE = 4096;
var MIN_WIDTH_FACTOR = 0.65;
var COMPILE_TYPE3_GLYPHS = true;
var MAX_SIZE_TO_COMPILE = 1000;
var FULL_CHUNK_HEIGHT = 16;
var IsLittleEndianCached = {
  get value() {
    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
  }
};
function addContextCurrentTransform(ctx) {
  if (!ctx.mozCurrentTransform) {
    ctx._originalSave = ctx.save;
    ctx._originalRestore = ctx.restore;
    ctx._originalRotate = ctx.rotate;
    ctx._originalScale = ctx.scale;
    ctx._originalTranslate = ctx.translate;
    ctx._originalTransform = ctx.transform;
    ctx._originalSetTransform = ctx.setTransform;
    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
    ctx._transformStack = [];
    Object.defineProperty(ctx, 'mozCurrentTransform', {
      get: function getCurrentTransform() {
        return this._transformMatrix;
      }
    });
    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
      get: function getCurrentTransformInverse() {
        var m = this._transformMatrix;
        var a = m[0],
            b = m[1],
            c = m[2],
            d = m[3],
            e = m[4],
            f = m[5];
        var ad_bc = a * d - b * c;
        var bc_ad = b * c - a * d;
        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
      }
    });
    ctx.save = function ctxSave() {
      var old = this._transformMatrix;
      this._transformStack.push(old);
      this._transformMatrix = old.slice(0, 6);
      this._originalSave();
    };
    ctx.restore = function ctxRestore() {
      var prev = this._transformStack.pop();
      if (prev) {
        this._transformMatrix = prev;
        this._originalRestore();
      }
    };
    ctx.translate = function ctxTranslate(x, y) {
      var m = this._transformMatrix;
      m[4] = m[0] * x + m[2] * y + m[4];
      m[5] = m[1] * x + m[3] * y + m[5];
      this._originalTranslate(x, y);
    };
    ctx.scale = function ctxScale(x, y) {
      var m = this._transformMatrix;
      m[0] = m[0] * x;
      m[1] = m[1] * x;
      m[2] = m[2] * y;
      m[3] = m[3] * y;
      this._originalScale(x, y);
    };
    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
      ctx._originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
      this._transformMatrix = [a, b, c, d, e, f];
      ctx._originalSetTransform(a, b, c, d, e, f);
    };
    ctx.rotate = function ctxRotate(angle) {
      var cosValue = Math.cos(angle);
      var sinValue = Math.sin(angle);
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
      this._originalRotate(angle);
    };
  }
}
var CachedCanvases = function CachedCanvasesClosure() {
  function CachedCanvases(canvasFactory) {
    this.canvasFactory = canvasFactory;
    this.cache = Object.create(null);
  }
  CachedCanvases.prototype = {
    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
      var canvasEntry;
      if (this.cache[id] !== undefined) {
        canvasEntry = this.cache[id];
        this.canvasFactory.reset(canvasEntry, width, height);
        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
      } else {
        canvasEntry = this.canvasFactory.create(width, height);
        this.cache[id] = canvasEntry;
      }
      if (trackTransform) {
        addContextCurrentTransform(canvasEntry.context);
      }
      return canvasEntry;
    },
    clear: function clear() {
      for (var id in this.cache) {
        var canvasEntry = this.cache[id];
        this.canvasFactory.destroy(canvasEntry);
        delete this.cache[id];
      }
    }
  };
  return CachedCanvases;
}();
function compileType3Glyph(imgData) {
  var POINT_TO_PROCESS_LIMIT = 1000;
  var width = imgData.width,
      height = imgData.height;
  var i,
      j,
      j0,
      width1 = width + 1;
  var points = new Uint8Array(width1 * (height + 1));
  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
  var lineSize = width + 7 & ~7,
      data0 = imgData.data;
  var data = new Uint8Array(lineSize * height),
      pos = 0,
      ii;
  for (i = 0, ii = data0.length; i < ii; i++) {
    var mask = 128,
        elem = data0[i];
    while (mask > 0) {
      data[pos++] = elem & mask ? 0 : 255;
      mask >>= 1;
    }
  }
  var count = 0;
  pos = 0;
  if (data[pos] !== 0) {
    points[0] = 1;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j] = data[pos] ? 2 : 1;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j] = 2;
    ++count;
  }
  for (i = 1; i < height; i++) {
    pos = i * lineSize;
    j0 = i * width1;
    if (data[pos - lineSize] !== data[pos]) {
      points[j0] = data[pos] ? 1 : 8;
      ++count;
    }
    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
    for (j = 1; j < width; j++) {
      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
      if (POINT_TYPES[sum]) {
        points[j0 + j] = POINT_TYPES[sum];
        ++count;
      }
      pos++;
    }
    if (data[pos - lineSize] !== data[pos]) {
      points[j0 + j] = data[pos] ? 2 : 4;
      ++count;
    }
    if (count > POINT_TO_PROCESS_LIMIT) {
      return null;
    }
  }
  pos = lineSize * (height - 1);
  j0 = i * width1;
  if (data[pos] !== 0) {
    points[j0] = 8;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j0 + j] = data[pos] ? 4 : 8;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j0 + j] = 4;
    ++count;
  }
  if (count > POINT_TO_PROCESS_LIMIT) {
    return null;
  }
  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
  var outlines = [];
  for (i = 0; count && i <= height; i++) {
    var p = i * width1;
    var end = p + width;
    while (p < end && !points[p]) {
      p++;
    }
    if (p === end) {
      continue;
    }
    var coords = [p % width1, i];
    var type = points[p],
        p0 = p,
        pp;
    do {
      var step = steps[type];
      do {
        p += step;
      } while (!points[p]);
      pp = points[p];
      if (pp !== 5 && pp !== 10) {
        type = pp;
        points[p] = 0;
      } else {
        type = pp & 0x33 * type >> 4;
        points[p] &= type >> 2 | type << 2;
      }
      coords.push(p % width1);
      coords.push(p / width1 | 0);
      --count;
    } while (p0 !== p);
    outlines.push(coords);
    --i;
  }
  var drawOutline = function drawOutline(c) {
    c.save();
    c.scale(1 / width, -1 / height);
    c.translate(0, -height);
    c.beginPath();
    for (var i = 0, ii = outlines.length; i < ii; i++) {
      var o = outlines[i];
      c.moveTo(o[0], o[1]);
      for (var j = 2, jj = o.length; j < jj; j += 2) {
        c.lineTo(o[j], o[j + 1]);
      }
    }
    c.fill();
    c.beginPath();
    c.restore();
  };
  return drawOutline;
}
var CanvasExtraState = function CanvasExtraStateClosure() {
  function CanvasExtraState() {
    this.alphaIsShape = false;
    this.fontSize = 0;
    this.fontSizeScale = 1;
    this.textMatrix = _util.IDENTITY_MATRIX;
    this.textMatrixScale = 1;
    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
    this.leading = 0;
    this.x = 0;
    this.y = 0;
    this.lineX = 0;
    this.lineY = 0;
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.textHScale = 1;
    this.textRenderingMode = _util.TextRenderingMode.FILL;
    this.textRise = 0;
    this.fillColor = '#000000';
    this.strokeColor = '#000000';
    this.patternFill = false;
    this.fillAlpha = 1;
    this.strokeAlpha = 1;
    this.lineWidth = 1;
    this.activeSMask = null;
    this.resumeSMaskCtx = null;
  }
  CanvasExtraState.prototype = {
    clone: function CanvasExtraState_clone() {
      return Object.create(this);
    },
    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
      this.x = x;
      this.y = y;
    }
  };
  return CanvasExtraState;
}();
var CanvasGraphics = function CanvasGraphicsClosure() {
  var EXECUTION_TIME = 15;
  var EXECUTION_STEPS = 10;
  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, webGLContext, imageLayer) {
    this.ctx = canvasCtx;
    this.current = new CanvasExtraState();
    this.stateStack = [];
    this.pendingClip = null;
    this.pendingEOFill = false;
    this.res = null;
    this.xobjs = null;
    this.commonObjs = commonObjs;
    this.objs = objs;
    this.canvasFactory = canvasFactory;
    this.webGLContext = webGLContext;
    this.imageLayer = imageLayer;
    this.groupStack = [];
    this.processingType3 = null;
    this.baseTransform = null;
    this.baseTransformStack = [];
    this.groupLevel = 0;
    this.smaskStack = [];
    this.smaskCounter = 0;
    this.tempSMask = null;
    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
    if (canvasCtx) {
      addContextCurrentTransform(canvasCtx);
    }
    this.cachedGetSinglePixelWidth = null;
  }
  function putBinaryImageData(ctx, imgData) {
    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
      ctx.putImageData(imgData, 0, 0);
      return;
    }
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0,
        destPos;
    var src = imgData.data;
    var dest = chunkImgData.data;
    var i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
      var srcLength = src.byteLength;
      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
      var dest32DataLength = dest32.length;
      var fullSrcDiff = width + 7 >> 3;
      var white = 0xFFFFFFFF;
      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
      for (i = 0; i < totalChunks; i++) {
        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
        destPos = 0;
        for (j = 0; j < thisChunkHeight; j++) {
          var srcDiff = srcLength - srcPos;
          var k = 0;
          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
          var kEndUnrolled = kEnd & ~7;
          var mask = 0;
          var srcByte = 0;
          for (; k < kEndUnrolled; k += 8) {
            srcByte = src[srcPos++];
            dest32[destPos++] = srcByte & 128 ? white : black;
            dest32[destPos++] = srcByte & 64 ? white : black;
            dest32[destPos++] = srcByte & 32 ? white : black;
            dest32[destPos++] = srcByte & 16 ? white : black;
            dest32[destPos++] = srcByte & 8 ? white : black;
            dest32[destPos++] = srcByte & 4 ? white : black;
            dest32[destPos++] = srcByte & 2 ? white : black;
            dest32[destPos++] = srcByte & 1 ? white : black;
          }
          for (; k < kEnd; k++) {
            if (mask === 0) {
              srcByte = src[srcPos++];
              mask = 128;
            }
            dest32[destPos++] = srcByte & mask ? white : black;
            mask >>= 1;
          }
        }
        while (destPos < dest32DataLength) {
          dest32[destPos++] = 0;
        }
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
      j = 0;
      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
      for (i = 0; i < fullChunks; i++) {
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        srcPos += elemsInThisChunk;
        ctx.putImageData(chunkImgData, 0, j);
        j += FULL_CHUNK_HEIGHT;
      }
      if (i < totalChunks) {
        elemsInThisChunk = width * partialChunkHeight * 4;
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        ctx.putImageData(chunkImgData, 0, j);
      }
    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
      thisChunkHeight = FULL_CHUNK_HEIGHT;
      elemsInThisChunk = width * thisChunkHeight;
      for (i = 0; i < totalChunks; i++) {
        if (i >= fullChunks) {
          thisChunkHeight = partialChunkHeight;
          elemsInThisChunk = width * thisChunkHeight;
        }
        destPos = 0;
        for (j = elemsInThisChunk; j--;) {
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = 255;
        }
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else {
      throw new Error('bad image kind: ' + imgData.kind);
    }
  }
  function putBinaryImageMask(ctx, imgData) {
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0;
    var src = imgData.data;
    var dest = chunkImgData.data;
    for (var i = 0; i < totalChunks; i++) {
      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
      var destPos = 3;
      for (var j = 0; j < thisChunkHeight; j++) {
        var mask = 0;
        for (var k = 0; k < width; k++) {
          if (!mask) {
            var elem = src[srcPos++];
            mask = 128;
          }
          dest[destPos] = elem & mask ? 0 : 255;
          destPos += 4;
          mask >>= 1;
        }
      }
      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  }
  function copyCtxState(sourceCtx, destCtx) {
    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
    for (var i = 0, ii = properties.length; i < ii; i++) {
      var property = properties[i];
      if (sourceCtx[property] !== undefined) {
        destCtx[property] = sourceCtx[property];
      }
    }
    if (sourceCtx.setLineDash !== undefined) {
      destCtx.setLineDash(sourceCtx.getLineDash());
      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
  }
  function resetCtxToDefault(ctx) {
    ctx.strokeStyle = '#000000';
    ctx.fillStyle = '#000000';
    ctx.fillRule = 'nonzero';
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = 'source-over';
    ctx.font = '10px sans-serif';
    if (ctx.setLineDash !== undefined) {
      ctx.setLineDash([]);
      ctx.lineDashOffset = 0;
    }
  }
  function composeSMaskBackdrop(bytes, r0, g0, b0) {
    var length = bytes.length;
    for (var i = 3; i < length; i += 4) {
      var alpha = bytes[i];
      if (alpha === 0) {
        bytes[i - 3] = r0;
        bytes[i - 2] = g0;
        bytes[i - 1] = b0;
      } else if (alpha < 255) {
        var alpha_ = 255 - alpha;
        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
      }
    }
  }
  function composeSMaskAlpha(maskData, layerData, transferMap) {
    var length = maskData.length;
    var scale = 1 / 255;
    for (var i = 3; i < length; i += 4) {
      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
      layerData[i] = layerData[i] * alpha * scale | 0;
    }
  }
  function composeSMaskLuminosity(maskData, layerData, transferMap) {
    var length = maskData.length;
    for (var i = 3; i < length; i += 4) {
      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
    }
  }
  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
    var hasBackdrop = !!backdrop;
    var r0 = hasBackdrop ? backdrop[0] : 0;
    var g0 = hasBackdrop ? backdrop[1] : 0;
    var b0 = hasBackdrop ? backdrop[2] : 0;
    var composeFn;
    if (subtype === 'Luminosity') {
      composeFn = composeSMaskLuminosity;
    } else {
      composeFn = composeSMaskAlpha;
    }
    var PIXELS_TO_PROCESS = 1048576;
    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
    for (var row = 0; row < height; row += chunkSize) {
      var chunkHeight = Math.min(chunkSize, height - row);
      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
      if (hasBackdrop) {
        composeSMaskBackdrop(maskData.data, r0, g0, b0);
      }
      composeFn(maskData.data, layerData.data, transferMap);
      maskCtx.putImageData(layerData, 0, row);
    }
  }
  function composeSMask(ctx, smask, layerCtx, webGLContext) {
    var mask = smask.canvas;
    var maskCtx = smask.context;
    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
    var backdrop = smask.backdrop || null;
    if (!smask.transferMap && webGLContext.isEnabled) {
      var composed = webGLContext.composeSMask({
        layer: layerCtx.canvas,
        mask: mask,
        properties: {
          subtype: smask.subtype,
          backdrop: backdrop
        }
      });
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
      return;
    }
    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
    ctx.drawImage(mask, 0, 0);
  }
  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
  var NORMAL_CLIP = {};
  var EO_CLIP = {};
  CanvasGraphics.prototype = {
    beginDrawing: function beginDrawing(_ref) {
      var transform = _ref.transform,
          viewport = _ref.viewport,
          transparency = _ref.transparency,
          _ref$background = _ref.background,
          background = _ref$background === undefined ? null : _ref$background;

      var width = this.ctx.canvas.width;
      var height = this.ctx.canvas.height;
      this.ctx.save();
      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
      this.ctx.fillRect(0, 0, width, height);
      this.ctx.restore();
      if (transparency) {
        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
        this.compositeCtx = this.ctx;
        this.transparentCanvas = transparentCanvas.canvas;
        this.ctx = transparentCanvas.context;
        this.ctx.save();
        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
      }
      this.ctx.save();
      resetCtxToDefault(this.ctx);
      if (transform) {
        this.ctx.transform.apply(this.ctx, transform);
      }
      this.ctx.transform.apply(this.ctx, viewport.transform);
      this.baseTransform = this.ctx.mozCurrentTransform.slice();
      if (this.imageLayer) {
        this.imageLayer.beginLayout();
      }
    },

    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
      var argsArray = operatorList.argsArray;
      var fnArray = operatorList.fnArray;
      var i = executionStartIdx || 0;
      var argsArrayLen = argsArray.length;
      if (argsArrayLen === i) {
        return i;
      }
      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
      var steps = 0;
      var commonObjs = this.commonObjs;
      var objs = this.objs;
      var fnId;
      while (true) {
        if (stepper !== undefined && i === stepper.nextBreakPoint) {
          stepper.breakIt(i, continueCallback);
          return i;
        }
        fnId = fnArray[i];
        if (fnId !== _util.OPS.dependency) {
          this[fnId].apply(this, argsArray[i]);
        } else {
          var deps = argsArray[i];
          for (var n = 0, nn = deps.length; n < nn; n++) {
            var depObjId = deps[n];
            var common = depObjId[0] === 'g' && depObjId[1] === '_';
            var objsPool = common ? commonObjs : objs;
            if (!objsPool.isResolved(depObjId)) {
              objsPool.get(depObjId, continueCallback);
              return i;
            }
          }
        }
        i++;
        if (i === argsArrayLen) {
          return i;
        }
        if (chunkOperations && ++steps > EXECUTION_STEPS) {
          if (Date.now() > endTime) {
            continueCallback();
            return i;
          }
          steps = 0;
        }
      }
    },
    endDrawing: function CanvasGraphics_endDrawing() {
      if (this.current.activeSMask !== null) {
        this.endSMaskGroup();
      }
      this.ctx.restore();
      if (this.transparentCanvas) {
        this.ctx = this.compositeCtx;
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.drawImage(this.transparentCanvas, 0, 0);
        this.ctx.restore();
        this.transparentCanvas = null;
      }
      this.cachedCanvases.clear();
      this.webGLContext.clear();
      if (this.imageLayer) {
        this.imageLayer.endLayout();
      }
    },
    setLineWidth: function CanvasGraphics_setLineWidth(width) {
      this.current.lineWidth = width;
      this.ctx.lineWidth = width;
    },
    setLineCap: function CanvasGraphics_setLineCap(style) {
      this.ctx.lineCap = LINE_CAP_STYLES[style];
    },
    setLineJoin: function CanvasGraphics_setLineJoin(style) {
      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
    },
    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
      this.ctx.miterLimit = limit;
    },
    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
      var ctx = this.ctx;
      if (ctx.setLineDash !== undefined) {
        ctx.setLineDash(dashArray);
        ctx.lineDashOffset = dashPhase;
      }
    },
    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
    setGState: function CanvasGraphics_setGState(states) {
      for (var i = 0, ii = states.length; i < ii; i++) {
        var state = states[i];
        var key = state[0];
        var value = state[1];
        switch (key) {
          case 'LW':
            this.setLineWidth(value);
            break;
          case 'LC':
            this.setLineCap(value);
            break;
          case 'LJ':
            this.setLineJoin(value);
            break;
          case 'ML':
            this.setMiterLimit(value);
            break;
          case 'D':
            this.setDash(value[0], value[1]);
            break;
          case 'RI':
            this.setRenderingIntent(value);
            break;
          case 'FL':
            this.setFlatness(value);
            break;
          case 'Font':
            this.setFont(value[0], value[1]);
            break;
          case 'CA':
            this.current.strokeAlpha = state[1];
            break;
          case 'ca':
            this.current.fillAlpha = state[1];
            this.ctx.globalAlpha = state[1];
            break;
          case 'BM':
            this.ctx.globalCompositeOperation = value;
            break;
          case 'SMask':
            if (this.current.activeSMask) {
              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
                this.suspendSMaskGroup();
              } else {
                this.endSMaskGroup();
              }
            }
            this.current.activeSMask = value ? this.tempSMask : null;
            if (this.current.activeSMask) {
              this.beginSMaskGroup();
            }
            this.tempSMask = null;
            break;
        }
      }
    },
    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
      var activeSMask = this.current.activeSMask;
      var drawnWidth = activeSMask.canvas.width;
      var drawnHeight = activeSMask.canvas.height;
      var cacheId = 'smaskGroupAt' + this.groupLevel;
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var currentCtx = this.ctx;
      var currentTransform = currentCtx.mozCurrentTransform;
      this.ctx.save();
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
      this.ctx.restore();
      this.ctx.save();
      copyCtxState(groupCtx, this.ctx);
      this.current.resumeSMaskCtx = groupCtx;
      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
      this.ctx.transform.apply(this.ctx, deltaTransform);
      groupCtx.save();
      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
      groupCtx.restore();
    },
    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.current.resumeSMaskCtx;
      var currentCtx = this.ctx;
      this.ctx = groupCtx;
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
      this.ctx.restore();
      copyCtxState(groupCtx, this.ctx);
      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
      this.ctx.transform.apply(this.ctx, deltaTransform);
    },
    save: function CanvasGraphics_save() {
      this.ctx.save();
      var old = this.current;
      this.stateStack.push(old);
      this.current = old.clone();
      this.current.resumeSMaskCtx = null;
    },
    restore: function CanvasGraphics_restore() {
      if (this.current.resumeSMaskCtx) {
        this.resumeSMaskGroup();
      }
      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
        this.endSMaskGroup();
      }
      if (this.stateStack.length !== 0) {
        this.current = this.stateStack.pop();
        this.ctx.restore();
        this.pendingClip = null;
        this.cachedGetSinglePixelWidth = null;
      }
    },
    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
      this.ctx.transform(a, b, c, d, e, f);
      this.cachedGetSinglePixelWidth = null;
    },
    constructPath: function CanvasGraphics_constructPath(ops, args) {
      var ctx = this.ctx;
      var current = this.current;
      var x = current.x,
          y = current.y;
      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
        switch (ops[i] | 0) {
          case _util.OPS.rectangle:
            x = args[j++];
            y = args[j++];
            var width = args[j++];
            var height = args[j++];
            if (width === 0) {
              width = this.getSinglePixelWidth();
            }
            if (height === 0) {
              height = this.getSinglePixelWidth();
            }
            var xw = x + width;
            var yh = y + height;
            this.ctx.moveTo(x, y);
            this.ctx.lineTo(xw, y);
            this.ctx.lineTo(xw, yh);
            this.ctx.lineTo(x, yh);
            this.ctx.lineTo(x, y);
            this.ctx.closePath();
            break;
          case _util.OPS.moveTo:
            x = args[j++];
            y = args[j++];
            ctx.moveTo(x, y);
            break;
          case _util.OPS.lineTo:
            x = args[j++];
            y = args[j++];
            ctx.lineTo(x, y);
            break;
          case _util.OPS.curveTo:
            x = args[j + 4];
            y = args[j + 5];
            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
            j += 6;
            break;
          case _util.OPS.curveTo2:
            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
            x = args[j + 2];
            y = args[j + 3];
            j += 4;
            break;
          case _util.OPS.curveTo3:
            x = args[j + 2];
            y = args[j + 3];
            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
            j += 4;
            break;
          case _util.OPS.closePath:
            ctx.closePath();
            break;
        }
      }
      current.setCurrentPoint(x, y);
    },
    closePath: function CanvasGraphics_closePath() {
      this.ctx.closePath();
    },
    stroke: function CanvasGraphics_stroke(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var strokeColor = this.current.strokeColor;
      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
      ctx.globalAlpha = this.current.strokeAlpha;
      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
        ctx.save();
        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
        ctx.stroke();
        ctx.restore();
      } else {
        ctx.stroke();
      }
      if (consumePath) {
        this.consumePath();
      }
      ctx.globalAlpha = this.current.fillAlpha;
    },
    closeStroke: function CanvasGraphics_closeStroke() {
      this.closePath();
      this.stroke();
    },
    fill: function CanvasGraphics_fill(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var needRestore = false;
      if (isPatternFill) {
        ctx.save();
        if (this.baseTransform) {
          ctx.setTransform.apply(ctx, this.baseTransform);
        }
        ctx.fillStyle = fillColor.getPattern(ctx, this);
        needRestore = true;
      }
      if (this.pendingEOFill) {
        ctx.fill('evenodd');
        this.pendingEOFill = false;
      } else {
        ctx.fill();
      }
      if (needRestore) {
        ctx.restore();
      }
      if (consumePath) {
        this.consumePath();
      }
    },
    eoFill: function CanvasGraphics_eoFill() {
      this.pendingEOFill = true;
      this.fill();
    },
    fillStroke: function CanvasGraphics_fillStroke() {
      this.fill(false);
      this.stroke(false);
      this.consumePath();
    },
    eoFillStroke: function CanvasGraphics_eoFillStroke() {
      this.pendingEOFill = true;
      this.fillStroke();
    },
    closeFillStroke: function CanvasGraphics_closeFillStroke() {
      this.closePath();
      this.fillStroke();
    },
    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
      this.pendingEOFill = true;
      this.closePath();
      this.fillStroke();
    },
    endPath: function CanvasGraphics_endPath() {
      this.consumePath();
    },
    clip: function CanvasGraphics_clip() {
      this.pendingClip = NORMAL_CLIP;
    },
    eoClip: function CanvasGraphics_eoClip() {
      this.pendingClip = EO_CLIP;
    },
    beginText: function CanvasGraphics_beginText() {
      this.current.textMatrix = _util.IDENTITY_MATRIX;
      this.current.textMatrixScale = 1;
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    endText: function CanvasGraphics_endText() {
      var paths = this.pendingTextPaths;
      var ctx = this.ctx;
      if (paths === undefined) {
        ctx.beginPath();
        return;
      }
      ctx.save();
      ctx.beginPath();
      for (var i = 0; i < paths.length; i++) {
        var path = paths[i];
        ctx.setTransform.apply(ctx, path.transform);
        ctx.translate(path.x, path.y);
        path.addToPath(ctx, path.fontSize);
      }
      ctx.restore();
      ctx.clip();
      ctx.beginPath();
      delete this.pendingTextPaths;
    },
    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
      this.current.charSpacing = spacing;
    },
    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
      this.current.wordSpacing = spacing;
    },
    setHScale: function CanvasGraphics_setHScale(scale) {
      this.current.textHScale = scale / 100;
    },
    setLeading: function CanvasGraphics_setLeading(leading) {
      this.current.leading = -leading;
    },
    setFont: function CanvasGraphics_setFont(fontRefName, size) {
      var fontObj = this.commonObjs.get(fontRefName);
      var current = this.current;
      if (!fontObj) {
        throw new Error('Can\'t find font for ' + fontRefName);
      }
      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
      }
      if (size < 0) {
        size = -size;
        current.fontDirection = -1;
      } else {
        current.fontDirection = 1;
      }
      this.current.font = fontObj;
      this.current.fontSize = size;
      if (fontObj.isType3Font) {
        return;
      }
      var name = fontObj.loadedName || 'sans-serif';
      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
      var italic = fontObj.italic ? 'italic' : 'normal';
      var typeface = '"' + name + '", ' + fontObj.fallbackName;
      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
      this.current.fontSizeScale = size / browserFontSize;
      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
      this.ctx.font = rule;
    },
    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
      this.current.textRenderingMode = mode;
    },
    setTextRise: function CanvasGraphics_setTextRise(rise) {
      this.current.textRise = rise;
    },
    moveText: function CanvasGraphics_moveText(x, y) {
      this.current.x = this.current.lineX += x;
      this.current.y = this.current.lineY += y;
    },
    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
      this.setLeading(-y);
      this.moveText(x, y);
    },
    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
      this.current.textMatrix = [a, b, c, d, e, f];
      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    nextLine: function CanvasGraphics_nextLine() {
      this.moveText(0, this.current.leading);
    },
    paintChar: function paintChar(character, x, y, patternTransform) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var textRenderingMode = current.textRenderingMode;
      var fontSize = current.fontSize / current.fontSizeScale;
      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
      var patternFill = current.patternFill && font.data;
      var addToPath;
      if (font.disableFontFace || isAddToPathSet || patternFill) {
        addToPath = font.getPathGenerator(this.commonObjs, character);
      }
      if (font.disableFontFace || patternFill) {
        ctx.save();
        ctx.translate(x, y);
        ctx.beginPath();
        addToPath(ctx, fontSize);
        if (patternTransform) {
          ctx.setTransform.apply(ctx, patternTransform);
        }
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fill();
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.stroke();
        }
        ctx.restore();
      } else {
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fillText(character, x, y);
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.strokeText(character, x, y);
        }
      }
      if (isAddToPathSet) {
        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
        paths.push({
          transform: ctx.mozCurrentTransform,
          x: x,
          y: y,
          fontSize: fontSize,
          addToPath: addToPath
        });
      }
    },

    get isFontSubpixelAAEnabled() {
      var ctx = this.canvasFactory.create(10, 10).context;
      ctx.scale(1.5, 1);
      ctx.fillText('I', 0, 10);
      var data = ctx.getImageData(0, 0, 10, 10).data;
      var enabled = false;
      for (var i = 3; i < data.length; i += 4) {
        if (data[i] > 0 && data[i] < 255) {
          enabled = true;
          break;
        }
      }
      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
    },
    showText: function CanvasGraphics_showText(glyphs) {
      var current = this.current;
      var font = current.font;
      if (font.isType3Font) {
        return this.showType3Text(glyphs);
      }
      var fontSize = current.fontSize;
      if (fontSize === 0) {
        return;
      }
      var ctx = this.ctx;
      var fontSizeScale = current.fontSizeScale;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var fontDirection = current.fontDirection;
      var textHScale = current.textHScale * fontDirection;
      var glyphsLength = glyphs.length;
      var vertical = font.vertical;
      var spacingDir = vertical ? 1 : -1;
      var defaultVMetrics = font.defaultVMetrics;
      var widthAdvanceScale = fontSize * current.fontMatrix[0];
      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
      ctx.save();
      var patternTransform = void 0;
      if (current.patternFill) {
        ctx.save();
        var pattern = current.fillColor.getPattern(ctx, this);
        patternTransform = ctx.mozCurrentTransform;
        ctx.restore();
        ctx.fillStyle = pattern;
      }
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y + current.textRise);
      if (fontDirection > 0) {
        ctx.scale(textHScale, -1);
      } else {
        ctx.scale(textHScale, 1);
      }
      var lineWidth = current.lineWidth;
      var scale = current.textMatrixScale;
      if (scale === 0 || lineWidth === 0) {
        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          this.cachedGetSinglePixelWidth = null;
          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
        }
      } else {
        lineWidth /= scale;
      }
      if (fontSizeScale !== 1.0) {
        ctx.scale(fontSizeScale, fontSizeScale);
        lineWidth /= fontSizeScale;
      }
      ctx.lineWidth = lineWidth;
      var x = 0,
          i;
      for (i = 0; i < glyphsLength; ++i) {
        var glyph = glyphs[i];
        if ((0, _util.isNum)(glyph)) {
          x += spacingDir * glyph * fontSize / 1000;
          continue;
        }
        var restoreNeeded = false;
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var character = glyph.fontChar;
        var accent = glyph.accent;
        var scaledX, scaledY, scaledAccentX, scaledAccentY;
        var width = glyph.width;
        if (vertical) {
          var vmetric, vx, vy;
          vmetric = glyph.vmetric || defaultVMetrics;
          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
          vx = -vx * widthAdvanceScale;
          vy = vmetric[2] * widthAdvanceScale;
          width = vmetric ? -vmetric[0] : width;
          scaledX = vx / fontSizeScale;
          scaledY = (x + vy) / fontSizeScale;
        } else {
          scaledX = x / fontSizeScale;
          scaledY = 0;
        }
        if (font.remeasure && width > 0) {
          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
            var characterScaleX = width / measuredWidth;
            restoreNeeded = true;
            ctx.save();
            ctx.scale(characterScaleX, 1);
            scaledX /= characterScaleX;
          } else if (width !== measuredWidth) {
            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
          }
        }
        if (glyph.isInFont || font.missingFile) {
          if (simpleFillText && !accent) {
            ctx.fillText(character, scaledX, scaledY);
          } else {
            this.paintChar(character, scaledX, scaledY, patternTransform);
            if (accent) {
              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
            }
          }
        }
        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
        x += charWidth;
        if (restoreNeeded) {
          ctx.restore();
        }
      }
      if (vertical) {
        current.y -= x * textHScale;
      } else {
        current.x += x * textHScale;
      }
      ctx.restore();
    },
    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var fontSize = current.fontSize;
      var fontDirection = current.fontDirection;
      var spacingDir = font.vertical ? 1 : -1;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var textHScale = current.textHScale * fontDirection;
      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
      var glyphsLength = glyphs.length;
      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
      var i, glyph, width, spacingLength;
      if (isTextInvisible || fontSize === 0) {
        return;
      }
      this.cachedGetSinglePixelWidth = null;
      ctx.save();
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y);
      ctx.scale(textHScale, fontDirection);
      for (i = 0; i < glyphsLength; ++i) {
        glyph = glyphs[i];
        if ((0, _util.isNum)(glyph)) {
          spacingLength = spacingDir * glyph * fontSize / 1000;
          this.ctx.translate(spacingLength, 0);
          current.x += spacingLength * textHScale;
          continue;
        }
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var operatorList = font.charProcOperatorList[glyph.operatorListId];
        if (!operatorList) {
          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
          continue;
        }
        this.processingType3 = glyph;
        this.save();
        ctx.scale(fontSize, fontSize);
        ctx.transform.apply(ctx, fontMatrix);
        this.executeOperatorList(operatorList);
        this.restore();
        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
        width = transformed[0] * fontSize + spacing;
        ctx.translate(width, 0);
        current.x += width * textHScale;
      }
      ctx.restore();
      this.processingType3 = null;
    },
    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
      this.ctx.rect(llx, lly, urx - llx, ury - lly);
      this.clip();
      this.endPath();
    },
    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
      var _this = this;

      var pattern;
      if (IR[0] === 'TilingPattern') {
        var color = IR[1];
        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
        var canvasGraphicsFactory = {
          createCanvasGraphics: function createCanvasGraphics(ctx) {
            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory, _this.webGLContext);
          }
        };
        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
      } else {
        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
      }
      return pattern;
    },
    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
      this.current.strokeColor = this.getColorN_Pattern(arguments);
    },
    setFillColorN: function CanvasGraphics_setFillColorN() {
      this.current.fillColor = this.getColorN_Pattern(arguments);
      this.current.patternFill = true;
    },
    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);
      this.ctx.strokeStyle = color;
      this.current.strokeColor = color;
    },
    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);
      this.ctx.fillStyle = color;
      this.current.fillColor = color;
      this.current.patternFill = false;
    },
    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
      var ctx = this.ctx;
      this.save();
      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
      ctx.fillStyle = pattern.getPattern(ctx, this, true);
      var inv = ctx.mozCurrentTransformInverse;
      if (inv) {
        var canvas = ctx.canvas;
        var width = canvas.width;
        var height = canvas.height;
        var bl = _util.Util.applyTransform([0, 0], inv);
        var br = _util.Util.applyTransform([0, height], inv);
        var ul = _util.Util.applyTransform([width, 0], inv);
        var ur = _util.Util.applyTransform([width, height], inv);
        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
      } else {
        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
      }
      this.restore();
    },
    beginInlineImage: function CanvasGraphics_beginInlineImage() {
      (0, _util.unreachable)('Should not call beginInlineImage');
    },
    beginImageData: function CanvasGraphics_beginImageData() {
      (0, _util.unreachable)('Should not call beginImageData');
    },
    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
      this.save();
      this.baseTransformStack.push(this.baseTransform);
      if (Array.isArray(matrix) && matrix.length === 6) {
        this.transform.apply(this, matrix);
      }
      this.baseTransform = this.ctx.mozCurrentTransform;
      if (Array.isArray(bbox) && bbox.length === 4) {
        var width = bbox[2] - bbox[0];
        var height = bbox[3] - bbox[1];
        this.ctx.rect(bbox[0], bbox[1], width, height);
        this.clip();
        this.endPath();
      }
    },
    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
      this.restore();
      this.baseTransform = this.baseTransformStack.pop();
    },
    beginGroup: function CanvasGraphics_beginGroup(group) {
      this.save();
      var currentCtx = this.ctx;
      if (!group.isolated) {
        (0, _util.info)('TODO: Support non-isolated groups.');
      }
      if (group.knockout) {
        (0, _util.warn)('Knockout groups not supported.');
      }
      var currentTransform = currentCtx.mozCurrentTransform;
      if (group.matrix) {
        currentCtx.transform.apply(currentCtx, group.matrix);
      }
      if (!group.bbox) {
        throw new Error('Bounding box is required.');
      }
      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
      var offsetX = Math.floor(bounds[0]);
      var offsetY = Math.floor(bounds[1]);
      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
      var scaleX = 1,
          scaleY = 1;
      if (drawnWidth > MAX_GROUP_SIZE) {
        scaleX = drawnWidth / MAX_GROUP_SIZE;
        drawnWidth = MAX_GROUP_SIZE;
      }
      if (drawnHeight > MAX_GROUP_SIZE) {
        scaleY = drawnHeight / MAX_GROUP_SIZE;
        drawnHeight = MAX_GROUP_SIZE;
      }
      var cacheId = 'groupAt' + this.groupLevel;
      if (group.smask) {
        cacheId += '_smask_' + this.smaskCounter++ % 2;
      }
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / scaleX, 1 / scaleY);
      groupCtx.translate(-offsetX, -offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      if (group.smask) {
        this.smaskStack.push({
          canvas: scratchCanvas.canvas,
          context: groupCtx,
          offsetX: offsetX,
          offsetY: offsetY,
          scaleX: scaleX,
          scaleY: scaleY,
          subtype: group.smask.subtype,
          backdrop: group.smask.backdrop,
          transferMap: group.smask.transferMap || null,
          startTransformInverse: null
        });
      } else {
        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
        currentCtx.translate(offsetX, offsetY);
        currentCtx.scale(scaleX, scaleY);
      }
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
      this.current.activeSMask = null;
    },
    endGroup: function CanvasGraphics_endGroup(group) {
      this.groupLevel--;
      var groupCtx = this.ctx;
      this.ctx = this.groupStack.pop();
      if (this.ctx.imageSmoothingEnabled !== undefined) {
        this.ctx.imageSmoothingEnabled = false;
      } else {
        this.ctx.mozImageSmoothingEnabled = false;
      }
      if (group.smask) {
        this.tempSMask = this.smaskStack.pop();
      } else {
        this.ctx.drawImage(groupCtx.canvas, 0, 0);
      }
      this.restore();
    },
    beginAnnotations: function CanvasGraphics_beginAnnotations() {
      this.save();
      if (this.baseTransform) {
        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
      }
    },
    endAnnotations: function CanvasGraphics_endAnnotations() {
      this.restore();
    },
    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
      this.save();
      resetCtxToDefault(this.ctx);
      this.current = new CanvasExtraState();
      if (Array.isArray(rect) && rect.length === 4) {
        var width = rect[2] - rect[0];
        var height = rect[3] - rect[1];
        this.ctx.rect(rect[0], rect[1], width, height);
        this.clip();
        this.endPath();
      }
      this.transform.apply(this, transform);
      this.transform.apply(this, matrix);
    },
    endAnnotation: function CanvasGraphics_endAnnotation() {
      this.restore();
    },
    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
      var domImage = this.objs.get(objId);
      if (!domImage) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      this.save();
      var ctx = this.ctx;
      ctx.scale(1 / w, -1 / h);
      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
      if (this.imageLayer) {
        var currentTransform = ctx.mozCurrentTransformInverse;
        var position = this.getCanvasPosition(0, 0);
        this.imageLayer.appendImage({
          objId: objId,
          left: position[0],
          top: position[1],
          width: w / currentTransform[0],
          height: h / currentTransform[3]
        });
      }
      this.restore();
    },
    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
      var ctx = this.ctx;
      var width = img.width,
          height = img.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var glyph = this.processingType3;
      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
          glyph.compiled = compileType3Glyph({
            data: img.data,
            width: width,
            height: height
          });
        } else {
          glyph.compiled = null;
        }
      }
      if (glyph && glyph.compiled) {
        glyph.compiled(ctx);
        return;
      }
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, img);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      this.paintInlineImageXObject(maskCanvas.canvas);
    },
    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
      var width = imgData.width;
      var height = imgData.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, imgData);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      var ctx = this.ctx;
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        ctx.save();
        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      for (var i = 0, ii = images.length; i < ii; i++) {
        var image = images[i];
        var width = image.width,
            height = image.height;
        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
        var maskCtx = maskCanvas.context;
        maskCtx.save();
        putBinaryImageMask(maskCtx, image);
        maskCtx.globalCompositeOperation = 'source-in';
        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
        maskCtx.fillRect(0, 0, width, height);
        maskCtx.restore();
        ctx.save();
        ctx.transform.apply(ctx, image.transform);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
      var imgData = this.objs.get(objId);
      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      this.paintInlineImageXObject(imgData);
    },
    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
      var imgData = this.objs.get(objId);
      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      var width = imgData.width;
      var height = imgData.height;
      var map = [];
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        map.push({
          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
          x: 0,
          y: 0,
          w: width,
          h: height
        });
      }
      this.paintInlineImageXObjectGroup(imgData, map);
    },
    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
      var width = imgData.width;
      var height = imgData.height;
      var ctx = this.ctx;
      this.save();
      ctx.scale(1 / width, -1 / height);
      var currentTransform = ctx.mozCurrentTransformInverse;
      var a = currentTransform[0],
          b = currentTransform[1];
      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
      var c = currentTransform[2],
          d = currentTransform[3];
      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
      var imgToPaint, tmpCanvas;
      if (imgData instanceof HTMLElement || !imgData.data) {
        imgToPaint = imgData;
      } else {
        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
        var tmpCtx = tmpCanvas.context;
        putBinaryImageData(tmpCtx, imgData);
        imgToPaint = tmpCanvas.canvas;
      }
      var paintWidth = width,
          paintHeight = height;
      var tmpCanvasId = 'prescale1';
      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
        var newWidth = paintWidth,
            newHeight = paintHeight;
        if (widthScale > 2 && paintWidth > 1) {
          newWidth = Math.ceil(paintWidth / 2);
          widthScale /= paintWidth / newWidth;
        }
        if (heightScale > 2 && paintHeight > 1) {
          newHeight = Math.ceil(paintHeight / 2);
          heightScale /= paintHeight / newHeight;
        }
        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
        tmpCtx = tmpCanvas.context;
        tmpCtx.clearRect(0, 0, newWidth, newHeight);
        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
        imgToPaint = tmpCanvas.canvas;
        paintWidth = newWidth;
        paintHeight = newHeight;
        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
      }
      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
      if (this.imageLayer) {
        var position = this.getCanvasPosition(0, -height);
        this.imageLayer.appendImage({
          imgData: imgData,
          left: position[0],
          top: position[1],
          width: width / currentTransform[0],
          height: height / currentTransform[3]
        });
      }
      this.restore();
    },
    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
      var ctx = this.ctx;
      var w = imgData.width;
      var h = imgData.height;
      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
      var tmpCtx = tmpCanvas.context;
      putBinaryImageData(tmpCtx, imgData);
      for (var i = 0, ii = map.length; i < ii; i++) {
        var entry = map[i];
        ctx.save();
        ctx.transform.apply(ctx, entry.transform);
        ctx.scale(1, -1);
        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
        if (this.imageLayer) {
          var position = this.getCanvasPosition(entry.x, entry.y);
          this.imageLayer.appendImage({
            imgData: imgData,
            left: position[0],
            top: position[1],
            width: w,
            height: h
          });
        }
        ctx.restore();
      }
    },
    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
      this.ctx.fillRect(0, 0, 1, 1);
    },
    paintXObject: function CanvasGraphics_paintXObject() {
      (0, _util.warn)('Unsupported \'paintXObject\' command.');
    },
    markPoint: function CanvasGraphics_markPoint(tag) {},
    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
    beginCompat: function CanvasGraphics_beginCompat() {},
    endCompat: function CanvasGraphics_endCompat() {},
    consumePath: function CanvasGraphics_consumePath() {
      var ctx = this.ctx;
      if (this.pendingClip) {
        if (this.pendingClip === EO_CLIP) {
          ctx.clip('evenodd');
        } else {
          ctx.clip();
        }
        this.pendingClip = null;
      }
      ctx.beginPath();
    },
    getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
      if (this.cachedGetSinglePixelWidth === null) {
        this.ctx.save();
        var inverse = this.ctx.mozCurrentTransformInverse;
        this.ctx.restore();
        this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
      }
      return this.cachedGetSinglePixelWidth;
    },
    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
      var transform = this.ctx.mozCurrentTransform;
      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
    }
  };
  for (var op in _util.OPS) {
    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
  }
  return CanvasGraphics;
}();
exports.CanvasGraphics = CanvasGraphics;

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TilingPattern = exports.getShadingPatternFromIR = undefined;

var _util = __webpack_require__(73);

var ShadingIRs = {};
ShadingIRs.RadialAxial = {
  fromIR: function RadialAxial_fromIR(raw) {
    var type = raw[1];
    var colorStops = raw[2];
    var p0 = raw[3];
    var p1 = raw[4];
    var r0 = raw[5];
    var r1 = raw[6];
    return {
      type: 'Pattern',
      getPattern: function RadialAxial_getPattern(ctx) {
        var grad;
        if (type === 'axial') {
          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
        } else if (type === 'radial') {
          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
        }
        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
          var c = colorStops[i];
          grad.addColorStop(c[0], c[1]);
        }
        return grad;
      }
    };
  }
};
var createMeshCanvas = function createMeshCanvasClosure() {
  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    var coords = context.coords,
        colors = context.colors;
    var bytes = data.data,
        rowSize = data.width * 4;
    var tmp;
    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }
    if (coords[p2 + 1] > coords[p3 + 1]) {
      tmp = p2;
      p2 = p3;
      p3 = tmp;
      tmp = c2;
      c2 = c3;
      c3 = tmp;
    }
    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }
    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) {
      return;
    }
    var c1r = colors[c1],
        c1g = colors[c1 + 1],
        c1b = colors[c1 + 2];
    var c2r = colors[c2],
        c2g = colors[c2 + 1],
        c2b = colors[c2 + 2];
    var c3r = colors[c3],
        c3g = colors[c3 + 1],
        c3b = colors[c3 + 2];
    var minY = Math.round(y1),
        maxY = Math.round(y3);
    var xa, car, cag, cab;
    var xb, cbr, cbg, cbb;
    var k;
    for (var y = minY; y <= maxY; y++) {
      if (y < y2) {
        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
        xa = x1 - (x1 - x2) * k;
        car = c1r - (c1r - c2r) * k;
        cag = c1g - (c1g - c2g) * k;
        cab = c1b - (c1b - c2b) * k;
      } else {
        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
        xa = x2 - (x2 - x3) * k;
        car = c2r - (c2r - c3r) * k;
        cag = c2g - (c2g - c3g) * k;
        cab = c2b - (c2b - c3b) * k;
      }
      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
      xb = x1 - (x1 - x3) * k;
      cbr = c1r - (c1r - c3r) * k;
      cbg = c1g - (c1g - c3g) * k;
      cbb = c1b - (c1b - c3b) * k;
      var x1_ = Math.round(Math.min(xa, xb));
      var x2_ = Math.round(Math.max(xa, xb));
      var j = rowSize * y + x1_ * 4;
      for (var x = x1_; x <= x2_; x++) {
        k = (xa - x) / (xa - xb);
        k = k < 0 ? 0 : k > 1 ? 1 : k;
        bytes[j++] = car - (car - cbr) * k | 0;
        bytes[j++] = cag - (cag - cbg) * k | 0;
        bytes[j++] = cab - (cab - cbb) * k | 0;
        bytes[j++] = 255;
      }
    }
  }
  function drawFigure(data, figure, context) {
    var ps = figure.coords;
    var cs = figure.colors;
    var i, ii;
    switch (figure.type) {
      case 'lattice':
        var verticesPerRow = figure.verticesPerRow;
        var rows = Math.floor(ps.length / verticesPerRow) - 1;
        var cols = verticesPerRow - 1;
        for (i = 0; i < rows; i++) {
          var q = i * verticesPerRow;
          for (var j = 0; j < cols; j++, q++) {
            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
          }
        }
        break;
      case 'triangles':
        for (i = 0, ii = ps.length; i < ii; i += 3) {
          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
        }
        break;
      default:
        throw new Error('illegal figure');
    }
  }
  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases, webGLContext) {
    var EXPECTED_SCALE = 1.1;
    var MAX_PATTERN_SIZE = 3000;
    var BORDER_SIZE = 2;
    var offsetX = Math.floor(bounds[0]);
    var offsetY = Math.floor(bounds[1]);
    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var scaleX = boundsWidth / width;
    var scaleY = boundsHeight / height;
    var context = {
      coords: coords,
      colors: colors,
      offsetX: -offsetX,
      offsetY: -offsetY,
      scaleX: 1 / scaleX,
      scaleY: 1 / scaleY
    };
    var paddedWidth = width + BORDER_SIZE * 2;
    var paddedHeight = height + BORDER_SIZE * 2;
    var canvas, tmpCanvas, i, ii;
    if (webGLContext.isEnabled) {
      canvas = webGLContext.drawFigures({
        width: width,
        height: height,
        backgroundColor: backgroundColor,
        figures: figures,
        context: context
      });
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    } else {
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      var tmpCtx = tmpCanvas.context;
      var data = tmpCtx.createImageData(width, height);
      if (backgroundColor) {
        var bytes = data.data;
        for (i = 0, ii = bytes.length; i < ii; i += 4) {
          bytes[i] = backgroundColor[0];
          bytes[i + 1] = backgroundColor[1];
          bytes[i + 2] = backgroundColor[2];
          bytes[i + 3] = 255;
        }
      }
      for (i = 0; i < figures.length; i++) {
        drawFigure(data, figures[i], context);
      }
      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    }
    return {
      canvas: canvas,
      offsetX: offsetX - BORDER_SIZE * scaleX,
      offsetY: offsetY - BORDER_SIZE * scaleY,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }
  return createMeshCanvas;
}();
ShadingIRs.Mesh = {
  fromIR: function Mesh_fromIR(raw) {
    var coords = raw[2];
    var colors = raw[3];
    var figures = raw[4];
    var bounds = raw[5];
    var matrix = raw[6];
    var background = raw[8];
    return {
      type: 'Pattern',
      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
        var scale;
        if (shadingFill) {
          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
        } else {
          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
          if (matrix) {
            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
          }
        }
        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases, owner.webGLContext);
        if (!shadingFill) {
          ctx.setTransform.apply(ctx, owner.baseTransform);
          if (matrix) {
            ctx.transform.apply(ctx, matrix);
          }
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
      }
    };
  }
};
ShadingIRs.Dummy = {
  fromIR: function Dummy_fromIR() {
    return {
      type: 'Pattern',
      getPattern: function Dummy_fromIR_getPattern() {
        return 'hotpink';
      }
    };
  }
};
function getShadingPatternFromIR(raw) {
  var shadingIR = ShadingIRs[raw[0]];
  if (!shadingIR) {
    throw new Error('Unknown IR type: ' + raw[0]);
  }
  return shadingIR.fromIR(raw);
}
var TilingPattern = function TilingPatternClosure() {
  var PaintType = {
    COLORED: 1,
    UNCOLORED: 2
  };
  var MAX_PATTERN_SIZE = 3000;
  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
    this.operatorList = IR[2];
    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
    this.bbox = IR[4];
    this.xstep = IR[5];
    this.ystep = IR[6];
    this.paintType = IR[7];
    this.tilingType = IR[8];
    this.color = color;
    this.canvasGraphicsFactory = canvasGraphicsFactory;
    this.baseTransform = baseTransform;
    this.type = 'Pattern';
    this.ctx = ctx;
  }
  TilingPattern.prototype = {
    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
      var operatorList = this.operatorList;
      var bbox = this.bbox;
      var xstep = this.xstep;
      var ystep = this.ystep;
      var paintType = this.paintType;
      var tilingType = this.tilingType;
      var color = this.color;
      var canvasGraphicsFactory = this.canvasGraphicsFactory;
      (0, _util.info)('TilingType: ' + tilingType);
      var x0 = bbox[0],
          y0 = bbox[1],
          x1 = bbox[2],
          y1 = bbox[3];
      var topLeft = [x0, y0];
      var botRight = [x0 + xstep, y0 + ystep];
      var width = botRight[0] - topLeft[0];
      var height = botRight[1] - topLeft[1];
      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
      var tmpCtx = tmpCanvas.context;
      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
      graphics.groupLevel = owner.groupLevel;
      this.setFillAndStrokeStyleToContext(graphics, paintType, color);
      this.setScale(width, height, xstep, ystep);
      this.transformToScale(graphics);
      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
      graphics.transform.apply(graphics, tmpTranslate);
      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
      graphics.executeOperatorList(operatorList);
      return tmpCanvas.canvas;
    },
    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
      this.scale = [width / xstep, height / ystep];
    },
    transformToScale: function TilingPattern_transformToScale(graphics) {
      var scale = this.scale;
      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
      graphics.transform.apply(graphics, tmpScale);
    },
    scaleToContext: function TilingPattern_scaleToContext() {
      var scale = this.scale;
      this.ctx.scale(1 / scale[0], 1 / scale[1]);
    },
    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
      if (Array.isArray(bbox) && bbox.length === 4) {
        var bboxWidth = x1 - x0;
        var bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        graphics.clip();
        graphics.endPath();
      }
    },
    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
      var context = graphics.ctx,
          current = graphics.current;
      switch (paintType) {
        case PaintType.COLORED:
          var ctx = this.ctx;
          context.fillStyle = ctx.fillStyle;
          context.strokeStyle = ctx.strokeStyle;
          current.fillColor = ctx.fillStyle;
          current.strokeColor = ctx.strokeStyle;
          break;
        case PaintType.UNCOLORED:
          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
          context.fillStyle = cssColor;
          context.strokeStyle = cssColor;
          current.fillColor = cssColor;
          current.strokeColor = cssColor;
          break;
        default:
          throw new _util.FormatError('Unsupported paint type: ' + paintType);
      }
    },
    getPattern: function TilingPattern_getPattern(ctx, owner) {
      var temporaryPatternCanvas = this.createPatternCanvas(owner);
      ctx = this.ctx;
      ctx.setTransform.apply(ctx, this.baseTransform);
      ctx.transform.apply(ctx, this.matrix);
      this.scaleToContext();
      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
    }
  };
  return TilingPattern;
}();
exports.getShadingPatternFromIR = getShadingPatternFromIR;
exports.TilingPattern = TilingPattern;

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFDataTransportStream = undefined;

var _util = __webpack_require__(73);

var PDFDataTransportStream = function PDFDataTransportStreamClosure() {
  function PDFDataTransportStream(params, pdfDataRangeTransport) {
    var _this = this;

    (0, _util.assert)(pdfDataRangeTransport);
    this._queuedChunks = [];
    var initialData = params.initialData;
    if (initialData && initialData.length > 0) {
      var buffer = new Uint8Array(initialData).buffer;
      this._queuedChunks.push(buffer);
    }
    this._pdfDataRangeTransport = pdfDataRangeTransport;
    this._isRangeSupported = !params.disableRange;
    this._isStreamingSupported = !params.disableStream;
    this._contentLength = params.length;
    this._fullRequestReader = null;
    this._rangeReaders = [];
    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
      _this._onReceiveData({
        begin: begin,
        chunk: chunk
      });
    });
    this._pdfDataRangeTransport.addProgressListener(function (loaded) {
      _this._onProgress({ loaded: loaded });
    });
    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
      _this._onReceiveData({ chunk: chunk });
    });
    this._pdfDataRangeTransport.transportReady();
  }
  PDFDataTransportStream.prototype = {
    _onReceiveData: function PDFDataTransportStream_onReceiveData(args) {
      var buffer = new Uint8Array(args.chunk).buffer;
      if (args.begin === undefined) {
        if (this._fullRequestReader) {
          this._fullRequestReader._enqueue(buffer);
        } else {
          this._queuedChunks.push(buffer);
        }
      } else {
        var found = this._rangeReaders.some(function (rangeReader) {
          if (rangeReader._begin !== args.begin) {
            return false;
          }
          rangeReader._enqueue(buffer);
          return true;
        });
        (0, _util.assert)(found);
      }
    },
    _onProgress: function PDFDataTransportStream_onDataProgress(evt) {
      if (this._rangeReaders.length > 0) {
        var firstReader = this._rangeReaders[0];
        if (firstReader.onProgress) {
          firstReader.onProgress({ loaded: evt.loaded });
        }
      }
    },
    _removeRangeReader: function PDFDataTransportStream_removeRangeReader(reader) {
      var i = this._rangeReaders.indexOf(reader);
      if (i >= 0) {
        this._rangeReaders.splice(i, 1);
      }
    },
    getFullReader: function PDFDataTransportStream_getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      var queuedChunks = this._queuedChunks;
      this._queuedChunks = null;
      return new PDFDataTransportStreamReader(this, queuedChunks);
    },
    getRangeReader: function PDFDataTransportStream_getRangeReader(begin, end) {
      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
      this._pdfDataRangeTransport.requestDataRange(begin, end);
      this._rangeReaders.push(reader);
      return reader;
    },
    cancelAllRequests: function PDFDataTransportStream_cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }
      var readers = this._rangeReaders.slice(0);
      readers.forEach(function (rangeReader) {
        rangeReader.cancel(reason);
      });
      this._pdfDataRangeTransport.abort();
    }
  };
  function PDFDataTransportStreamReader(stream, queuedChunks) {
    this._stream = stream;
    this._done = false;
    this._filename = null;
    this._queuedChunks = queuedChunks || [];
    this._requests = [];
    this._headersReady = Promise.resolve();
    stream._fullRequestReader = this;
    this.onProgress = null;
  }
  PDFDataTransportStreamReader.prototype = {
    _enqueue: function PDFDataTransportStreamReader_enqueue(chunk) {
      if (this._done) {
        return;
      }
      if (this._requests.length > 0) {
        var requestCapability = this._requests.shift();
        requestCapability.resolve({
          value: chunk,
          done: false
        });
        return;
      }
      this._queuedChunks.push(chunk);
    },
    get headersReady() {
      return this._headersReady;
    },
    get filename() {
      return this._filename;
    },
    get isRangeSupported() {
      return this._stream._isRangeSupported;
    },
    get isStreamingSupported() {
      return this._stream._isStreamingSupported;
    },
    get contentLength() {
      return this._stream._contentLength;
    },
    read: function PDFDataTransportStreamReader_read() {
      if (this._queuedChunks.length > 0) {
        var chunk = this._queuedChunks.shift();
        return Promise.resolve({
          value: chunk,
          done: false
        });
      }
      if (this._done) {
        return Promise.resolve({
          value: undefined,
          done: true
        });
      }
      var requestCapability = (0, _util.createPromiseCapability)();
      this._requests.push(requestCapability);
      return requestCapability.promise;
    },
    cancel: function PDFDataTransportStreamReader_cancel(reason) {
      this._done = true;
      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });
      this._requests = [];
    }
  };
  function PDFDataTransportStreamRangeReader(stream, begin, end) {
    this._stream = stream;
    this._begin = begin;
    this._end = end;
    this._queuedChunk = null;
    this._requests = [];
    this._done = false;
    this.onProgress = null;
  }
  PDFDataTransportStreamRangeReader.prototype = {
    _enqueue: function PDFDataTransportStreamRangeReader_enqueue(chunk) {
      if (this._done) {
        return;
      }
      if (this._requests.length === 0) {
        this._queuedChunk = chunk;
      } else {
        var requestsCapability = this._requests.shift();
        requestsCapability.resolve({
          value: chunk,
          done: false
        });
        this._requests.forEach(function (requestCapability) {
          requestCapability.resolve({
            value: undefined,
            done: true
          });
        });
        this._requests = [];
      }
      this._done = true;
      this._stream._removeRangeReader(this);
    },
    get isStreamingSupported() {
      return false;
    },
    read: function PDFDataTransportStreamRangeReader_read() {
      if (this._queuedChunk) {
        var chunk = this._queuedChunk;
        this._queuedChunk = null;
        return Promise.resolve({
          value: chunk,
          done: false
        });
      }
      if (this._done) {
        return Promise.resolve({
          value: undefined,
          done: true
        });
      }
      var requestCapability = (0, _util.createPromiseCapability)();
      this._requests.push(requestCapability);
      return requestCapability.promise;
    },
    cancel: function PDFDataTransportStreamRangeReader_cancel(reason) {
      this._done = true;
      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });
      this._requests = [];
      this._stream._removeRangeReader(this);
    }
  };
  return PDFDataTransportStream;
}();
exports.PDFDataTransportStream = PDFDataTransportStream;

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebGLContext = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__(73);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebGLContext = function () {
  function WebGLContext(_ref) {
    var _ref$enable = _ref.enable,
        enable = _ref$enable === undefined ? false : _ref$enable;

    _classCallCheck(this, WebGLContext);

    this._enabled = enable === true;
  }

  _createClass(WebGLContext, [{
    key: 'composeSMask',
    value: function composeSMask(_ref2) {
      var layer = _ref2.layer,
          mask = _ref2.mask,
          properties = _ref2.properties;

      return WebGLUtils.composeSMask(layer, mask, properties);
    }
  }, {
    key: 'drawFigures',
    value: function drawFigures(_ref3) {
      var width = _ref3.width,
          height = _ref3.height,
          backgroundColor = _ref3.backgroundColor,
          figures = _ref3.figures,
          context = _ref3.context;

      return WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
    }
  }, {
    key: 'clear',
    value: function clear() {
      WebGLUtils.cleanup();
    }
  }, {
    key: 'isEnabled',
    get: function get() {
      var enabled = this._enabled;
      if (enabled) {
        enabled = WebGLUtils.tryInitGL();
      }
      return (0, _util.shadow)(this, 'isEnabled', enabled);
    }
  }]);

  return WebGLContext;
}();

var WebGLUtils = function WebGLUtilsClosure() {
  function loadShader(gl, code, shaderType) {
    var shader = gl.createShader(shaderType);
    gl.shaderSource(shader, code);
    gl.compileShader(shader);
    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    if (!compiled) {
      var errorMsg = gl.getShaderInfoLog(shader);
      throw new Error('Error during shader compilation: ' + errorMsg);
    }
    return shader;
  }
  function createVertexShader(gl, code) {
    return loadShader(gl, code, gl.VERTEX_SHADER);
  }
  function createFragmentShader(gl, code) {
    return loadShader(gl, code, gl.FRAGMENT_SHADER);
  }
  function createProgram(gl, shaders) {
    var program = gl.createProgram();
    for (var i = 0, ii = shaders.length; i < ii; ++i) {
      gl.attachShader(program, shaders[i]);
    }
    gl.linkProgram(program);
    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
    if (!linked) {
      var errorMsg = gl.getProgramInfoLog(program);
      throw new Error('Error during program linking: ' + errorMsg);
    }
    return program;
  }
  function createTexture(gl, image, textureId) {
    gl.activeTexture(textureId);
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
    return texture;
  }
  var currentGL, currentCanvas;
  function generateGL() {
    if (currentGL) {
      return;
    }
    currentCanvas = document.createElement('canvas');
    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
  }
  var smaskVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec2 a_texCoord;                                    \
                                                                \
  uniform vec2 u_resolution;                                    \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_texCoord = a_texCoord;                                    \
  }                                                             ';
  var smaskFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  uniform vec4 u_backdrop;                                      \
  uniform int u_subtype;                                        \
  uniform sampler2D u_image;                                    \
  uniform sampler2D u_mask;                                     \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec4 imageColor = texture2D(u_image, v_texCoord);           \
    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
    if (u_backdrop.a > 0.0) {                                   \
      maskColor.rgb = maskColor.rgb * maskColor.a +             \
                      u_backdrop.rgb * (1.0 - maskColor.a);     \
    }                                                           \
    float lum;                                                  \
    if (u_subtype == 0) {                                       \
      lum = maskColor.a;                                        \
    } else {                                                    \
      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
            maskColor.b * 0.11;                                 \
    }                                                           \
    imageColor.a *= lum;                                        \
    imageColor.rgb *= imageColor.a;                             \
    gl_FragColor = imageColor;                                  \
  }                                                             ';
  var smaskCache = null;
  function initSmaskGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
    var texCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(texCoordLocation);
    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
    gl.uniform1i(texLayerLocation, 0);
    gl.uniform1i(texMaskLocation, 1);
    smaskCache = cache;
  }
  function composeSMask(layer, mask, properties) {
    var width = layer.width,
        height = layer.height;
    if (!smaskCache) {
      initSmaskGL();
    }
    var cache = smaskCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    if (properties.backdrop) {
      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
    } else {
      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
    }
    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
    var texture = createTexture(gl, layer, gl.TEXTURE0);
    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    gl.clearColor(0, 0, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    gl.flush();
    gl.deleteTexture(texture);
    gl.deleteTexture(maskTexture);
    gl.deleteBuffer(buffer);
    return canvas;
  }
  var figuresVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec3 a_color;                                       \
                                                                \
  uniform vec2 u_resolution;                                    \
  uniform vec2 u_scale;                                         \
  uniform vec2 u_offset;                                        \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    vec2 position = (a_position + u_offset) * u_scale;          \
    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_color = vec4(a_color / 255.0, 1.0);                       \
  }                                                             ';
  var figuresFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    gl_FragColor = v_color;                                     \
  }                                                             ';
  var figuresCache = null;
  function initFiguresGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
    figuresCache = cache;
  }
  function drawFigures(width, height, backgroundColor, figures, context) {
    if (!figuresCache) {
      initFiguresGL();
    }
    var cache = figuresCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    var count = 0;
    var i, ii, rows;
    for (i = 0, ii = figures.length; i < ii; i++) {
      switch (figures[i].type) {
        case 'lattice':
          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
          break;
        case 'triangles':
          count += figures[i].coords.length;
          break;
      }
    }
    var coords = new Float32Array(count * 2);
    var colors = new Uint8Array(count * 3);
    var coordsMap = context.coords,
        colorsMap = context.colors;
    var pIndex = 0,
        cIndex = 0;
    for (i = 0, ii = figures.length; i < ii; i++) {
      var figure = figures[i],
          ps = figure.coords,
          cs = figure.colors;
      switch (figure.type) {
        case 'lattice':
          var cols = figure.verticesPerRow;
          rows = ps.length / cols | 0;
          for (var row = 1; row < rows; row++) {
            var offset = row * cols + 1;
            for (var col = 1; col < cols; col++, offset++) {
              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
              coords[pIndex + 6] = coords[pIndex + 2];
              coords[pIndex + 7] = coords[pIndex + 3];
              coords[pIndex + 8] = coords[pIndex + 4];
              coords[pIndex + 9] = coords[pIndex + 5];
              coords[pIndex + 10] = coordsMap[ps[offset]];
              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
              colors[cIndex + 9] = colors[cIndex + 3];
              colors[cIndex + 10] = colors[cIndex + 4];
              colors[cIndex + 11] = colors[cIndex + 5];
              colors[cIndex + 12] = colors[cIndex + 6];
              colors[cIndex + 13] = colors[cIndex + 7];
              colors[cIndex + 14] = colors[cIndex + 8];
              colors[cIndex + 15] = colorsMap[cs[offset]];
              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
              pIndex += 12;
              cIndex += 18;
            }
          }
          break;
        case 'triangles':
          for (var j = 0, jj = ps.length; j < jj; j++) {
            coords[pIndex] = coordsMap[ps[j]];
            coords[pIndex + 1] = coordsMap[ps[j] + 1];
            colors[cIndex] = colorsMap[cs[j]];
            colors[cIndex + 1] = colorsMap[cs[j] + 1];
            colors[cIndex + 2] = colorsMap[cs[j] + 2];
            pIndex += 2;
            cIndex += 3;
          }
          break;
      }
    }
    if (backgroundColor) {
      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
    } else {
      gl.clearColor(0, 0, 0, 0);
    }
    gl.clear(gl.COLOR_BUFFER_BIT);
    var coordsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    var colorsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.colorLocation);
    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
    gl.drawArrays(gl.TRIANGLES, 0, count);
    gl.flush();
    gl.deleteBuffer(coordsBuffer);
    gl.deleteBuffer(colorsBuffer);
    return canvas;
  }
  return {
    tryInitGL: function tryInitGL() {
      try {
        generateGL();
        return !!currentGL;
      } catch (ex) {}
      return false;
    },

    composeSMask: composeSMask,
    drawFigures: drawFigures,
    cleanup: function cleanup() {
      if (smaskCache && smaskCache.canvas) {
        smaskCache.canvas.width = 0;
        smaskCache.canvas.height = 0;
      }
      if (figuresCache && figuresCache.canvas) {
        figuresCache.canvas.width = 0;
        figuresCache.canvas.height = 0;
      }
      smaskCache = null;
      figuresCache = null;
    }
  };
}();
exports.WebGLContext = WebGLContext;

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2454)


/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(289);

/*<replacement>*/
var util = __webpack_require__(148);
util.inherits = __webpack_require__(87);
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er, data) {
      done(stream, er, data);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data !== null && data !== undefined) stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('Calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

module.exports = Readable;

/*<replacement>*/
var processNextTick = __webpack_require__(555);
/*</replacement>*/

/*<replacement>*/
var isArray = __webpack_require__(457);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(141).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = __webpack_require__(494);
  } catch (_) {} finally {
    if (!Stream) Stream = __webpack_require__(141).EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = __webpack_require__(76).Buffer;
/*<replacement>*/
var bufferShim = __webpack_require__(556);
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(148);
util.inherits = __webpack_require__(87);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(2456);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(2457);
var StringDecoder;

util.inherits(Readable, Stream);

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') {
    return emitter.prependListener(event, fn);
  } else {
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
  }
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(289);

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(273).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(289);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options && typeof options.read === 'function') this._read = options.read;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;

  if (!state.objectMode && typeof chunk === 'string') {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = bufferShim.from(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var _e = new Error('stream.unshift() after end event');
      stream.emit('error', _e);
    } else {
      var skipAdd;
      if (state.decoder && !addToFront && !encoding) {
        chunk = state.decoder.write(chunk);
        skipAdd = !state.objectMode && chunk.length === 0;
      }

      if (!addToFront) state.reading = false;

      // Don't add to the buffer if we've decoded to an empty string chunk and
      // we're not in object mode
      if (!skipAdd) {
        // if we want the data now, just emit it.
        if (state.flowing && state.length === 0 && !state.sync) {
          stream.emit('data', chunk);
          stream.read(0);
        } else {
          // update the buffer info.
          state.length += state.objectMode ? 1 : chunk.length;
          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

          if (state.needReadable) emitReadable(stream);
        }
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(273).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function (ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = bufferShim.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66)))

/***/ }),
/* 2456 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(76).Buffer;
/*<replacement>*/
var bufferShim = __webpack_require__(556);
/*</replacement>*/

module.exports = BufferList;

function BufferList() {
  this.head = null;
  this.tail = null;
  this.length = 0;
}

BufferList.prototype.push = function (v) {
  var entry = { data: v, next: null };
  if (this.length > 0) this.tail.next = entry;else this.head = entry;
  this.tail = entry;
  ++this.length;
};

BufferList.prototype.unshift = function (v) {
  var entry = { data: v, next: this.head };
  if (this.length === 0) this.tail = entry;
  this.head = entry;
  ++this.length;
};

BufferList.prototype.shift = function () {
  if (this.length === 0) return;
  var ret = this.head.data;
  if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
  --this.length;
  return ret;
};

BufferList.prototype.clear = function () {
  this.head = this.tail = null;
  this.length = 0;
};

BufferList.prototype.join = function (s) {
  if (this.length === 0) return '';
  var p = this.head;
  var ret = '' + p.data;
  while (p = p.next) {
    ret += s + p.data;
  }return ret;
};

BufferList.prototype.concat = function (n) {
  if (this.length === 0) return bufferShim.alloc(0);
  if (this.length === 1) return this.head.data;
  var ret = bufferShim.allocUnsafe(n >>> 0);
  var p = this.head;
  var i = 0;
  while (p) {
    p.data.copy(ret, i);
    i += p.data.length;
    p = p.next;
  }
  return ret;
};

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/*<replacement>*/
var processNextTick = __webpack_require__(555);
/*</replacement>*/

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(148);
util.inherits = __webpack_require__(87);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(927)
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = __webpack_require__(494);
  } catch (_) {} finally {
    if (!Stream) Stream = __webpack_require__(141).EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = __webpack_require__(76).Buffer;
/*<replacement>*/
var bufferShim = __webpack_require__(556);
/*</replacement>*/

util.inherits(Writable, Stream);

function nop() {}

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(289);

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(289);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;
  // Always throw error if a null is written
  // if we are not in object mode then throw
  // if it is not a buffer, string, or undefined.
  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = bufferShim.from(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) processNextTick(cb, er);else cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
        afterWrite(stream, state, finished, cb);
      }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    while (entry) {
      buffer[count] = entry;
      entry = entry.next;
      count += 1;
    }

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else {
      prefinish(stream, state);
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function (err) {
    var entry = _this.entry;
    _this.entry = null;
    while (entry) {
      var cb = entry.callback;
      state.pendingcb--;
      cb(err);
      entry = entry.next;
    }
    if (state.corkedRequestsFree) {
      state.corkedRequestsFree.next = _this;
    } else {
      state.corkedRequestsFree = _this;
    }
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66), __webpack_require__(439).setImmediate))

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer) {var msg = __webpack_require__(1040);
var zstream = __webpack_require__(2460);
var zlib_deflate = __webpack_require__(2461);
var zlib_inflate = __webpack_require__(2463);
var constants = __webpack_require__(2466);

for (var key in constants) {
  exports[key] = constants[key];
}

// zlib modes
exports.NONE = 0;
exports.DEFLATE = 1;
exports.INFLATE = 2;
exports.GZIP = 3;
exports.GUNZIP = 4;
exports.DEFLATERAW = 5;
exports.INFLATERAW = 6;
exports.UNZIP = 7;

/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */
function Zlib(mode) {
  if (mode < exports.DEFLATE || mode > exports.UNZIP)
    throw new TypeError("Bad argument");
    
  this.mode = mode;
  this.init_done = false;
  this.write_in_progress = false;
  this.pending_close = false;
  this.windowBits = 0;
  this.level = 0;
  this.memLevel = 0;
  this.strategy = 0;
  this.dictionary = null;
}

Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
  this.windowBits = windowBits;
  this.level = level;
  this.memLevel = memLevel;
  this.strategy = strategy;
  // dictionary not supported.
  
  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP)
    this.windowBits += 16;
    
  if (this.mode === exports.UNZIP)
    this.windowBits += 32;
    
  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW)
    this.windowBits = -this.windowBits;
    
  this.strm = new zstream();
  
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      var status = zlib_deflate.deflateInit2(
        this.strm,
        this.level,
        exports.Z_DEFLATED,
        this.windowBits,
        this.memLevel,
        this.strategy
      );
      break;
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
    case exports.UNZIP:
      var status  = zlib_inflate.inflateInit2(
        this.strm,
        this.windowBits
      );
      break;
    default:
      throw new Error("Unknown mode " + this.mode);
  }
  
  if (status !== exports.Z_OK) {
    this._error(status);
    return;
  }
  
  this.write_in_progress = false;
  this.init_done = true;
};

Zlib.prototype.params = function() {
  throw new Error("deflateParams Not supported");
};

Zlib.prototype._writeCheck = function() {
  if (!this.init_done)
    throw new Error("write before init");
    
  if (this.mode === exports.NONE)
    throw new Error("already finalized");
    
  if (this.write_in_progress)
    throw new Error("write already in progress");
    
  if (this.pending_close)
    throw new Error("close is pending");
};

Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {    
  this._writeCheck();
  this.write_in_progress = true;
  
  var self = this;
  process.nextTick(function() {
    self.write_in_progress = false;
    var res = self._write(flush, input, in_off, in_len, out, out_off, out_len);
    self.callback(res[0], res[1]);
    
    if (self.pending_close)
      self.close();
  });
  
  return this;
};

// set method for Node buffers, used by pako
function bufferSet(data, offset) {
  for (var i = 0; i < data.length; i++) {
    this[offset + i] = data[i];
  }
}

Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
  this._writeCheck();
  return this._write(flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype._write = function(flush, input, in_off, in_len, out, out_off, out_len) {
  this.write_in_progress = true;
  
  if (flush !== exports.Z_NO_FLUSH &&
      flush !== exports.Z_PARTIAL_FLUSH &&
      flush !== exports.Z_SYNC_FLUSH &&
      flush !== exports.Z_FULL_FLUSH &&
      flush !== exports.Z_FINISH &&
      flush !== exports.Z_BLOCK) {
    throw new Error("Invalid flush value");
  }
  
  if (input == null) {
    input = new Buffer(0);
    in_len = 0;
    in_off = 0;
  }
  
  if (out._set)
    out.set = out._set;
  else
    out.set = bufferSet;
  
  var strm = this.strm;
  strm.avail_in = in_len;
  strm.input = input;
  strm.next_in = in_off;
  strm.avail_out = out_len;
  strm.output = out;
  strm.next_out = out_off;
  
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      var status = zlib_deflate.deflate(strm, flush);
      break;
    case exports.UNZIP:
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
      var status = zlib_inflate.inflate(strm, flush);
      break;
    default:
      throw new Error("Unknown mode " + this.mode);
  }
  
  if (status !== exports.Z_STREAM_END && status !== exports.Z_OK) {
    this._error(status);
  }
  
  this.write_in_progress = false;
  return [strm.avail_in, strm.avail_out];
};

Zlib.prototype.close = function() {
  if (this.write_in_progress) {
    this.pending_close = true;
    return;
  }
  
  this.pending_close = false;
  
  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
    zlib_deflate.deflateEnd(this.strm);
  } else {
    zlib_inflate.inflateEnd(this.strm);
  }
  
  this.mode = exports.NONE;
};

Zlib.prototype.reset = function() {
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
      var status = zlib_deflate.deflateReset(this.strm);
      break;
    case exports.INFLATE:
    case exports.INFLATERAW:
      var status = zlib_inflate.inflateReset(this.strm);
      break;
  }
  
  if (status !== exports.Z_OK) {
    this._error(status);
  }
};

Zlib.prototype._error = function(status) {
  this.onerror(msg[status] + ': ' + this.strm.msg, status);
  
  this.write_in_progress = false;
  if (this.pending_close)
    this.close();
};

exports.Zlib = Zlib;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(66), __webpack_require__(76).Buffer))

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;


/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils   = __webpack_require__(384);
var trees   = __webpack_require__(2462);
var adler32 = __webpack_require__(1041);
var crc32   = __webpack_require__(1042);
var msg     = __webpack_require__(1040);

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
                );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/


/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var utils = __webpack_require__(384);

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;


/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var utils         = __webpack_require__(384);
var adler32       = __webpack_require__(1041);
var crc32         = __webpack_require__(1042);
var inflate_fast  = __webpack_require__(2464);
var inflate_table = __webpack_require__(2465);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
    case HEAD:
      if (state.wrap === 0) {
        state.mode = TYPEDO;
        break;
      }
      //=== NEEDBITS(16);
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//

        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = FLAGS;
        break;
      }
      state.flags = 0;           /* expect zlib header */
      if (state.head) {
        state.head.done = false;
      }
      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
        strm.msg = 'incorrect header check';
        state.mode = BAD;
        break;
      }
      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
      len = (hold & 0x0f)/*BITS(4)*/ + 8;
      if (state.wbits === 0) {
        state.wbits = len;
      }
      else if (len > state.wbits) {
        strm.msg = 'invalid window size';
        state.mode = BAD;
        break;
      }
      state.dmax = 1 << len;
      //Tracev((stderr, "inflate:   zlib header ok\n"));
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = hold & 0x200 ? DICTID : TYPE;
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      break;
    case FLAGS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.flags = hold;
      if ((state.flags & 0xff) !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      if (state.flags & 0xe000) {
        strm.msg = 'unknown header flags set';
        state.mode = BAD;
        break;
      }
      if (state.head) {
        state.head.text = ((hold >> 8) & 1);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = TIME;
      /* falls through */
    case TIME:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.time = hold;
      }
      if (state.flags & 0x0200) {
        //=== CRC4(state.check, hold)
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        hbuf[2] = (hold >>> 16) & 0xff;
        hbuf[3] = (hold >>> 24) & 0xff;
        state.check = crc32(state.check, hbuf, 4, 0);
        //===
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = OS;
      /* falls through */
    case OS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.xflags = (hold & 0xff);
        state.head.os = (hold >> 8);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = EXLEN;
      /* falls through */
    case EXLEN:
      if (state.flags & 0x0400) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length = hold;
        if (state.head) {
          state.head.extra_len = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      else if (state.head) {
        state.head.extra = null/*Z_NULL*/;
      }
      state.mode = EXTRA;
      /* falls through */
    case EXTRA:
      if (state.flags & 0x0400) {
        copy = state.length;
        if (copy > have) { copy = have; }
        if (copy) {
          if (state.head) {
            len = state.head.extra_len - state.length;
            if (!state.head.extra) {
              // Use untyped array for more conveniend processing later
              state.head.extra = new Array(state.head.extra_len);
            }
            utils.arraySet(
              state.head.extra,
              input,
              next,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              copy,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              len
            );
            //zmemcpy(state.head.extra + len, next,
            //        len + copy > state.head.extra_max ?
            //        state.head.extra_max - len : copy);
          }
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          state.length -= copy;
        }
        if (state.length) { break inf_leave; }
      }
      state.length = 0;
      state.mode = NAME;
      /* falls through */
    case NAME:
      if (state.flags & 0x0800) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          // TODO: 2 or 1 bytes?
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.name_max*/)) {
            state.head.name += String.fromCharCode(len);
          }
        } while (len && copy < have);

        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.name = null;
      }
      state.length = 0;
      state.mode = COMMENT;
      /* falls through */
    case COMMENT:
      if (state.flags & 0x1000) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.comm_max*/)) {
            state.head.comment += String.fromCharCode(len);
          }
        } while (len && copy < have);
        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.comment = null;
      }
      state.mode = HCRC;
      /* falls through */
    case HCRC:
      if (state.flags & 0x0200) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.check & 0xffff)) {
          strm.msg = 'header crc mismatch';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      if (state.head) {
        state.head.hcrc = ((state.flags >> 9) & 1);
        state.head.done = true;
      }
      strm.adler = state.check = 0;
      state.mode = TYPE;
      break;
    case DICTID:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      strm.adler = state.check = zswap32(hold);
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = DICT;
      /* falls through */
    case DICT:
      if (state.havedict === 0) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        return Z_NEED_DICT;
      }
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      /* falls through */
    case TYPE:
      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case TYPEDO:
      if (state.last) {
        //--- BYTEBITS() ---//
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        state.mode = CHECK;
        break;
      }
      //=== NEEDBITS(3); */
      while (bits < 3) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.last = (hold & 0x01)/*BITS(1)*/;
      //--- DROPBITS(1) ---//
      hold >>>= 1;
      bits -= 1;
      //---//

      switch ((hold & 0x03)/*BITS(2)*/) {
      case 0:                             /* stored block */
        //Tracev((stderr, "inflate:     stored block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = STORED;
        break;
      case 1:                             /* fixed block */
        fixedtables(state);
        //Tracev((stderr, "inflate:     fixed codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = LEN_;             /* decode codes */
        if (flush === Z_TREES) {
          //--- DROPBITS(2) ---//
          hold >>>= 2;
          bits -= 2;
          //---//
          break inf_leave;
        }
        break;
      case 2:                             /* dynamic block */
        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = TABLE;
        break;
      case 3:
        strm.msg = 'invalid block type';
        state.mode = BAD;
      }
      //--- DROPBITS(2) ---//
      hold >>>= 2;
      bits -= 2;
      //---//
      break;
    case STORED:
      //--- BYTEBITS() ---// /* go to byte boundary */
      hold >>>= bits & 7;
      bits -= bits & 7;
      //---//
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
        strm.msg = 'invalid stored block lengths';
        state.mode = BAD;
        break;
      }
      state.length = hold & 0xffff;
      //Tracev((stderr, "inflate:       stored length %u\n",
      //        state.length));
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = COPY_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case COPY_:
      state.mode = COPY;
      /* falls through */
    case COPY:
      copy = state.length;
      if (copy) {
        if (copy > have) { copy = have; }
        if (copy > left) { copy = left; }
        if (copy === 0) { break inf_leave; }
        //--- zmemcpy(put, next, copy); ---
        utils.arraySet(output, input, next, copy, put);
        //---//
        have -= copy;
        next += copy;
        left -= copy;
        put += copy;
        state.length -= copy;
        break;
      }
      //Tracev((stderr, "inflate:       stored end\n"));
      state.mode = TYPE;
      break;
    case TABLE:
      //=== NEEDBITS(14); */
      while (bits < 14) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
//#ifndef PKZIP_BUG_WORKAROUND
      if (state.nlen > 286 || state.ndist > 30) {
        strm.msg = 'too many length or distance symbols';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracev((stderr, "inflate:       table sizes ok\n"));
      state.have = 0;
      state.mode = LENLENS;
      /* falls through */
    case LENLENS:
      while (state.have < state.ncode) {
        //=== NEEDBITS(3);
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
        //--- DROPBITS(3) ---//
        hold >>>= 3;
        bits -= 3;
        //---//
      }
      while (state.have < 19) {
        state.lens[order[state.have++]] = 0;
      }
      // We have separate tables & no pointers. 2 commented lines below not needed.
      //state.next = state.codes;
      //state.lencode = state.next;
      // Switch to use dynamic table
      state.lencode = state.lendyn;
      state.lenbits = 7;

      opts = { bits: state.lenbits };
      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
      state.lenbits = opts.bits;

      if (ret) {
        strm.msg = 'invalid code lengths set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, "inflate:       code lengths ok\n"));
      state.have = 0;
      state.mode = CODELENS;
      /* falls through */
    case CODELENS:
      while (state.have < state.nlen + state.ndist) {
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_val < 16) {
          //--- DROPBITS(here.bits) ---//
          hold >>>= here_bits;
          bits -= here_bits;
          //---//
          state.lens[state.have++] = here_val;
        }
        else {
          if (here_val === 16) {
            //=== NEEDBITS(here.bits + 2);
            n = here_bits + 2;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            if (state.have === 0) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            len = state.lens[state.have - 1];
            copy = 3 + (hold & 0x03);//BITS(2);
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            //---//
          }
          else if (here_val === 17) {
            //=== NEEDBITS(here.bits + 3);
            n = here_bits + 3;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 3 + (hold & 0x07);//BITS(3);
            //--- DROPBITS(3) ---//
            hold >>>= 3;
            bits -= 3;
            //---//
          }
          else {
            //=== NEEDBITS(here.bits + 7);
            n = here_bits + 7;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 11 + (hold & 0x7f);//BITS(7);
            //--- DROPBITS(7) ---//
            hold >>>= 7;
            bits -= 7;
            //---//
          }
          if (state.have + copy > state.nlen + state.ndist) {
            strm.msg = 'invalid bit length repeat';
            state.mode = BAD;
            break;
          }
          while (copy--) {
            state.lens[state.have++] = len;
          }
        }
      }

      /* handle error breaks in while */
      if (state.mode === BAD) { break; }

      /* check for end-of-block code (better have one) */
      if (state.lens[256] === 0) {
        strm.msg = 'invalid code -- missing end-of-block';
        state.mode = BAD;
        break;
      }

      /* build code tables -- note: do not change the lenbits or distbits
         values here (9 and 6) without reading the comments in inftrees.h
         concerning the ENOUGH constants, which depend on those values */
      state.lenbits = 9;

      opts = { bits: state.lenbits };
      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.lenbits = opts.bits;
      // state.lencode = state.next;

      if (ret) {
        strm.msg = 'invalid literal/lengths set';
        state.mode = BAD;
        break;
      }

      state.distbits = 6;
      //state.distcode.copy(state.codes);
      // Switch to use dynamic table
      state.distcode = state.distdyn;
      opts = { bits: state.distbits };
      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.distbits = opts.bits;
      // state.distcode = state.next;

      if (ret) {
        strm.msg = 'invalid distances set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, 'inflate:       codes ok\n'));
      state.mode = LEN_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case LEN_:
      state.mode = LEN;
      /* falls through */
    case LEN:
      if (have >= 6 && left >= 258) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        inflate_fast(strm, _out);
        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        if (state.mode === TYPE) {
          state.back = -1;
        }
        break;
      }
      state.back = 0;
      for (;;) {
        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if (here_bits <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if (here_op && (here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.lencode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      state.length = here_val;
      if (here_op === 0) {
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        state.mode = LIT;
        break;
      }
      if (here_op & 32) {
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.back = -1;
        state.mode = TYPE;
        break;
      }
      if (here_op & 64) {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break;
      }
      state.extra = here_op & 15;
      state.mode = LENEXT;
      /* falls through */
    case LENEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
      //Tracevv((stderr, "inflate:         length %u\n", state.length));
      state.was = state.length;
      state.mode = DIST;
      /* falls through */
    case DIST:
      for (;;) {
        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if ((here_bits) <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if ((here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.distcode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      if (here_op & 64) {
        strm.msg = 'invalid distance code';
        state.mode = BAD;
        break;
      }
      state.offset = here_val;
      state.extra = (here_op) & 15;
      state.mode = DISTEXT;
      /* falls through */
    case DISTEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
//#ifdef INFLATE_STRICT
      if (state.offset > state.dmax) {
        strm.msg = 'invalid distance too far back';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
      state.mode = MATCH;
      /* falls through */
    case MATCH:
      if (left === 0) { break inf_leave; }
      copy = _out - left;
      if (state.offset > copy) {         /* copy from window */
        copy = state.offset - copy;
        if (copy > state.whave) {
          if (state.sane) {
            strm.msg = 'invalid distance too far back';
            state.mode = BAD;
            break;
          }
// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
        }
        if (copy > state.wnext) {
          copy -= state.wnext;
          from = state.wsize - copy;
        }
        else {
          from = state.wnext - copy;
        }
        if (copy > state.length) { copy = state.length; }
        from_source = state.window;
      }
      else {                              /* copy from output */
        from_source = output;
        from = put - state.offset;
        copy = state.length;
      }
      if (copy > left) { copy = left; }
      left -= copy;
      state.length -= copy;
      do {
        output[put++] = from_source[from++];
      } while (--copy);
      if (state.length === 0) { state.mode = LEN; }
      break;
    case LIT:
      if (left === 0) { break inf_leave; }
      output[put++] = state.length;
      left--;
      state.mode = LEN;
      break;
    case CHECK:
      if (state.wrap) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          // Use '|' insdead of '+' to make sure that result is signed
          hold |= input[next++] << bits;
          bits += 8;
        }
        //===//
        _out -= left;
        strm.total_out += _out;
        state.total += _out;
        if (_out) {
          strm.adler = state.check =
              /*UPDATE(state.check, put - _out, _out);*/
              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

        }
        _out = left;
        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
          strm.msg = 'incorrect data check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   check matches trailer\n"));
      }
      state.mode = LENGTH;
      /* falls through */
    case LENGTH:
      if (state.wrap && state.flags) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.total & 0xffffffff)) {
          strm.msg = 'incorrect length check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   length matches trailer\n"));
      }
      state.mode = DONE;
      /* falls through */
    case DONE:
      ret = Z_STREAM_END;
      break inf_leave;
    case BAD:
      ret = Z_DATA_ERROR;
      break inf_leave;
    case MEM:
      return Z_MEM_ERROR;
    case SYNC:
      /* falls through */
    default:
      return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/


/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};


/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var utils = __webpack_require__(384);

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  var i = 0;
  /* process all codes and make table entries */
  for (;;) {
    i++;
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};


/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(454);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFNodeStream = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__(73);

var _network_utils = __webpack_require__(557);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fs = __webpack_require__(2470);
var http = __webpack_require__(2471);
var https = __webpack_require__(2472);
var url = __webpack_require__(459);

var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;

var PDFNodeStream = function () {
  function PDFNodeStream(source) {
    _classCallCheck(this, PDFNodeStream);

    this.source = source;
    this.url = url.parse(source.url);
    this.isHttp = this.url.protocol === 'http:' || this.url.protocol === 'https:';
    this.isFsUrl = this.url.protocol === 'file:' || !this.url.host;
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequest = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFNodeStream, [{
    key: 'getFullReader',
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequest);
      this._fullRequest = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
      return this._fullRequest;
    }
  }, {
    key: 'getRangeReader',
    value: function getRangeReader(start, end) {
      var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
      this._rangeRequestReaders.push(rangeReader);
      return rangeReader;
    }
  }, {
    key: 'cancelAllRequests',
    value: function cancelAllRequests(reason) {
      if (this._fullRequest) {
        this._fullRequest.cancel(reason);
      }
      var readers = this._rangeRequestReaders.slice(0);
      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }]);

  return PDFNodeStream;
}();

var BaseFullReader = function () {
  function BaseFullReader(stream) {
    _classCallCheck(this, BaseFullReader);

    this._url = stream.url;
    this._done = false;
    this._errored = false;
    this._reason = null;
    this.onProgress = null;
    var source = stream.source;
    this._contentLength = source.length;
    this._loaded = 0;
    this._filename = null;
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._readableStream = null;
    this._readCapability = (0, _util.createPromiseCapability)();
    this._headersCapability = (0, _util.createPromiseCapability)();
  }

  _createClass(BaseFullReader, [{
    key: 'read',
    value: function read() {
      var _this = this;

      return this._readCapability.promise.then(function () {
        if (_this._done) {
          return Promise.resolve({
            value: undefined,
            done: true
          });
        }
        if (_this._errored) {
          return Promise.reject(_this._reason);
        }
        var chunk = _this._readableStream.read();
        if (chunk === null) {
          _this._readCapability = (0, _util.createPromiseCapability)();
          return _this.read();
        }
        _this._loaded += chunk.length;
        if (_this.onProgress) {
          _this.onProgress({
            loaded: _this._loaded,
            total: _this._contentLength
          });
        }
        var buffer = new Uint8Array(chunk).buffer;
        return Promise.resolve({
          value: buffer,
          done: false
        });
      });
    }
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);
        return;
      }
      this._readableStream.destroy(reason);
    }
  }, {
    key: '_error',
    value: function _error(reason) {
      this._errored = true;
      this._reason = reason;
      this._readCapability.resolve();
    }
  }, {
    key: '_setReadableStream',
    value: function _setReadableStream(readableStream) {
      var _this2 = this;

      this._readableStream = readableStream;
      readableStream.on('readable', function () {
        _this2._readCapability.resolve();
      });
      readableStream.on('end', function () {
        readableStream.destroy();
        _this2._done = true;
        _this2._readCapability.resolve();
      });
      readableStream.on('error', function (reason) {
        _this2._error(reason);
      });
      if (!this._isStreamingSupported && this._isRangeSupported) {
        this._error(new _util.AbortException('streaming is disabled'));
      }
      if (this._errored) {
        this._readableStream.destroy(this._reason);
      }
    }
  }, {
    key: 'headersReady',
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: 'filename',
    get: function get() {
      return this._filename;
    }
  }, {
    key: 'contentLength',
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: 'isRangeSupported',
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return BaseFullReader;
}();

var BaseRangeReader = function () {
  function BaseRangeReader(stream) {
    _classCallCheck(this, BaseRangeReader);

    this._url = stream.url;
    this._done = false;
    this._errored = false;
    this._reason = null;
    this.onProgress = null;
    this._loaded = 0;
    this._readableStream = null;
    this._readCapability = (0, _util.createPromiseCapability)();
    var source = stream.source;
    this._isStreamingSupported = !source.disableStream;
  }

  _createClass(BaseRangeReader, [{
    key: 'read',
    value: function read() {
      var _this3 = this;

      return this._readCapability.promise.then(function () {
        if (_this3._done) {
          return Promise.resolve({
            value: undefined,
            done: true
          });
        }
        if (_this3._errored) {
          return Promise.reject(_this3._reason);
        }
        var chunk = _this3._readableStream.read();
        if (chunk === null) {
          _this3._readCapability = (0, _util.createPromiseCapability)();
          return _this3.read();
        }
        _this3._loaded += chunk.length;
        if (_this3.onProgress) {
          _this3.onProgress({ loaded: _this3._loaded });
        }
        var buffer = new Uint8Array(chunk).buffer;
        return Promise.resolve({
          value: buffer,
          done: false
        });
      });
    }
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);
        return;
      }
      this._readableStream.destroy(reason);
    }
  }, {
    key: '_error',
    value: function _error(reason) {
      this._errored = true;
      this._reason = reason;
      this._readCapability.resolve();
    }
  }, {
    key: '_setReadableStream',
    value: function _setReadableStream(readableStream) {
      var _this4 = this;

      this._readableStream = readableStream;
      readableStream.on('readable', function () {
        _this4._readCapability.resolve();
      });
      readableStream.on('end', function () {
        readableStream.destroy();
        _this4._done = true;
        _this4._readCapability.resolve();
      });
      readableStream.on('error', function (reason) {
        _this4._error(reason);
      });
      if (this._errored) {
        this._readableStream.destroy(this._reason);
      }
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return BaseRangeReader;
}();

function createRequestOptions(url, headers) {
  return {
    protocol: url.protocol,
    auth: url.auth,
    host: url.hostname,
    port: url.port,
    path: url.path,
    method: 'GET',
    headers: headers
  };
}

var PDFNodeStreamFullReader = function (_BaseFullReader) {
  _inherits(PDFNodeStreamFullReader, _BaseFullReader);

  function PDFNodeStreamFullReader(stream) {
    _classCallCheck(this, PDFNodeStreamFullReader);

    var _this5 = _possibleConstructorReturn(this, (PDFNodeStreamFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFullReader)).call(this, stream));

    var handleResponse = function handleResponse(response) {
      _this5._headersCapability.resolve();
      _this5._setReadableStream(response);
      var getResponseHeader = function getResponseHeader(name) {
        return _this5._readableStream.headers[name.toLowerCase()];
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: stream.isHttp,
        rangeChunkSize: _this5._rangeChunkSize,
        disableRange: _this5._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      if (allowRangeRequests) {
        _this5._isRangeSupported = true;
      }
      _this5._contentLength = suggestedLength;
      _this5._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
    };
    _this5._request = null;
    if (_this5._url.protocol === 'http:') {
      _this5._request = http.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
    } else {
      _this5._request = https.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
    }
    _this5._request.on('error', function (reason) {
      _this5._errored = true;
      _this5._reason = reason;
      _this5._headersCapability.reject(reason);
    });
    _this5._request.end();
    return _this5;
  }

  return PDFNodeStreamFullReader;
}(BaseFullReader);

var PDFNodeStreamRangeReader = function (_BaseRangeReader) {
  _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);

  function PDFNodeStreamRangeReader(stream, start, end) {
    _classCallCheck(this, PDFNodeStreamRangeReader);

    var _this6 = _possibleConstructorReturn(this, (PDFNodeStreamRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamRangeReader)).call(this, stream));

    _this6._httpHeaders = {};
    for (var property in stream.httpHeaders) {
      var value = stream.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      _this6._httpHeaders[property] = value;
    }
    _this6._httpHeaders['Range'] = 'bytes=' + start + '-' + (end - 1);
    _this6._request = null;
    if (_this6._url.protocol === 'http:') {
      _this6._request = http.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
        _this6._setReadableStream(response);
      });
    } else {
      _this6._request = https.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
        _this6._setReadableStream(response);
      });
    }
    _this6._request.on('error', function (reason) {
      _this6._errored = true;
      _this6._reason = reason;
    });
    _this6._request.end();
    return _this6;
  }

  return PDFNodeStreamRangeReader;
}(BaseRangeReader);

var PDFNodeStreamFsFullReader = function (_BaseFullReader2) {
  _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);

  function PDFNodeStreamFsFullReader(stream) {
    _classCallCheck(this, PDFNodeStreamFsFullReader);

    var _this7 = _possibleConstructorReturn(this, (PDFNodeStreamFsFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsFullReader)).call(this, stream));

    var path = decodeURIComponent(_this7._url.path);
    if (fileUriRegex.test(_this7._url.href)) {
      path = path.replace(/^\//, '');
    }
    fs.lstat(path, function (error, stat) {
      if (error) {
        _this7._errored = true;
        _this7._reason = error;
        _this7._headersCapability.reject(error);
        return;
      }
      _this7._contentLength = stat.size;
      _this7._setReadableStream(fs.createReadStream(path));
      _this7._headersCapability.resolve();
    });
    return _this7;
  }

  return PDFNodeStreamFsFullReader;
}(BaseFullReader);

var PDFNodeStreamFsRangeReader = function (_BaseRangeReader2) {
  _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);

  function PDFNodeStreamFsRangeReader(stream, start, end) {
    _classCallCheck(this, PDFNodeStreamFsRangeReader);

    var _this8 = _possibleConstructorReturn(this, (PDFNodeStreamFsRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsRangeReader)).call(this, stream));

    var path = decodeURIComponent(_this8._url.path);
    if (fileUriRegex.test(_this8._url.href)) {
      path = path.replace(/^\//, '');
    }
    _this8._setReadableStream(fs.createReadStream(path, {
      start: start,
      end: end - 1
    }));
    return _this8;
  }

  return PDFNodeStreamFsRangeReader;
}(BaseRangeReader);

exports.PDFNodeStream = PDFNodeStream;

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function getFilenameFromContentDispositionHeader(contentDisposition) {
  var needsEncodingFixup = true;
  var tmp = /(?:^|;)\s*filename\*\s*=\s*([^;\s]+)/i.exec(contentDisposition);
  if (tmp) {
    tmp = tmp[1];
    var filename = rfc2616unquote(tmp);
    filename = unescape(filename);
    filename = rfc5987decode(filename);
    filename = rfc2047decode(filename);
    return fixupEncoding(filename);
  }
  tmp = rfc2231getparam(contentDisposition);
  if (tmp) {
    var _filename = rfc2047decode(tmp);
    return fixupEncoding(_filename);
  }
  tmp = /(?:^|;)\s*filename\s*=\s*([^;\s]+)/.exec(contentDisposition);
  if (tmp) {
    tmp = tmp[1];
    var _filename2 = rfc2616unquote(tmp);
    _filename2 = rfc2047decode(_filename2);
    return fixupEncoding(_filename2);
  }
  function textdecode(encoding, value) {
    if (encoding) {
      if (!/^[^\x00-\xFF]+$/.test(value)) {
        return value;
      }
      try {
        var decoder = new TextDecoder(encoding, { fatal: true });
        var bytes = new Array(value.length);
        for (var i = 0; i < value.length; ++i) {
          bytes[i] = value.charCodeAt(0);
        }
        value = decoder.decode(new Uint8Array(bytes));
        needsEncodingFixup = false;
      } catch (e) {
        if (/^utf-?8$/i.test(encoding)) {
          value = decodeURIComponent(escape(value));
          needsEncodingFixup = false;
        }
      }
    }
    return value;
  }
  function fixupEncoding(value) {
    if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
      return textdecode('utf-8', value);
    }
    return value;
  }
  function rfc2231getparam(contentDisposition) {
    var matches = [],
        match = void 0;
    var iter = /(?:^|;)\s*filename\*((?!0\d)\d+)(\*?)\s*=\s*([^;\s]+)/ig;
    while ((match = iter.exec(contentDisposition)) !== null) {
      var _match = match,
          _match2 = _slicedToArray(_match, 4),
          n = _match2[1],
          quot = _match2[2],
          part = _match2[3];

      n = parseInt(n, 10);
      if (n in matches) {
        if (n === 0) {
          break;
        }
        continue;
      }
      matches[n] = [quot, part];
    }
    var parts = [];
    for (var _n = 0; _n < matches.length; ++_n) {
      if (!(_n in matches)) {
        break;
      }

      var _matches$_n = _slicedToArray(matches[_n], 2),
          _quot = _matches$_n[0],
          _part = _matches$_n[1];

      _part = rfc2616unquote(_part);
      if (_quot) {
        _part = unescape(_part);
        if (_n === 0) {
          _part = rfc5987decode(_part);
        }
      }
      parts.push(_part);
    }
    return parts.join('');
  }
  function rfc2616unquote(value) {
    if (value.charAt(0) === '"') {
      var parts = value.slice(1).split('\\"');
      for (var i = 0; i < parts.length; ++i) {
        var quotindex = parts[i].indexOf('"');
        if (quotindex !== -1) {
          parts[i] = parts[i].slice(0, quotindex);
          parts.length = i + 1;
        }
        parts[i] = parts[i].replace(/\\(.)/g, '$1');
      }
      value = parts.join('"');
    }
    return value;
  }
  function rfc5987decode(extvalue) {
    var encodingend = extvalue.indexOf('\'');
    if (encodingend === -1) {
      return extvalue;
    }
    var encoding = extvalue.slice(0, encodingend);
    var langvalue = extvalue.slice(encodingend + 1);
    var value = langvalue.replace(/^[^']*'/, '');
    return textdecode(encoding, value);
  }
  function rfc2047decode(value) {
    if (value.slice(0, 2) !== '=?' || /[\x00-\x19\x80-\xff]/.test(value)) {
      return value;
    }
    return value.replace(/=\?([\w\-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (_, charset, encoding, text) {
      if (encoding === 'q' || encoding === 'Q') {
        text = text.replace(/_/g, ' ');
        text = text.replace(/=([0-9a-fA-F]{2})/g, function (_, hex) {
          return String.fromCharCode(parseInt(hex, 16));
        });
        return textdecode(charset, text);
      }
      try {
        return atob(text);
      } catch (e) {
        return text;
      }
    });
  }
  return '';
}
exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;

/***/ }),
/* 2470 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2471 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2472 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFFetchStream = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__(73);

var _network_utils = __webpack_require__(557);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createFetchOptions(headers, withCredentials) {
  return {
    method: 'GET',
    headers: headers,
    mode: 'cors',
    credentials: withCredentials ? 'include' : 'same-origin',
    redirect: 'follow'
  };
}

var PDFFetchStream = function () {
  function PDFFetchStream(source) {
    _classCallCheck(this, PDFFetchStream);

    this.source = source;
    this.isHttp = /^https?:/i.test(source.url);
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFFetchStream, [{
    key: 'getFullReader',
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      this._fullRequestReader = new PDFFetchStreamReader(this);
      return this._fullRequestReader;
    }
  }, {
    key: 'getRangeReader',
    value: function getRangeReader(begin, end) {
      var reader = new PDFFetchStreamRangeReader(this, begin, end);
      this._rangeRequestReaders.push(reader);
      return reader;
    }
  }, {
    key: 'cancelAllRequests',
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }
      var readers = this._rangeRequestReaders.slice(0);
      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }]);

  return PDFFetchStream;
}();

var PDFFetchStreamReader = function () {
  function PDFFetchStreamReader(stream) {
    var _this = this;

    _classCallCheck(this, PDFFetchStreamReader);

    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    this._filename = null;
    var source = stream.source;
    this._withCredentials = source.withCredentials;
    this._contentLength = source.length;
    this._headersCapability = (0, _util.createPromiseCapability)();
    this._disableRange = source.disableRange;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._isRangeSupported = !source.disableRange;
    this._isStreamingSupported = !source.disableStream;
    this._headers = new Headers();
    for (var property in this._stream.httpHeaders) {
      var value = this._stream.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      this._headers.append(property, value);
    }
    var url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }
      _this._reader = response.body.getReader();
      _this._headersCapability.resolve();
      var getResponseHeader = function getResponseHeader(name) {
        return response.headers.get(name);
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: _this._stream.isHttp,
        rangeChunkSize: _this._rangeChunkSize,
        disableRange: _this._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      _this._contentLength = suggestedLength;
      _this._isRangeSupported = allowRangeRequests;
      _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
      if (!_this._isStreamingSupported && _this._isRangeSupported) {
        _this.cancel(new _util.AbortException('streaming is disabled'));
      }
    }).catch(this._headersCapability.reject);
    this.onProgress = null;
  }

  _createClass(PDFFetchStreamReader, [{
    key: 'read',
    value: function read() {
      var _this2 = this;

      return this._headersCapability.promise.then(function () {
        return _this2._reader.read().then(function (_ref) {
          var value = _ref.value,
              done = _ref.done;

          if (done) {
            return Promise.resolve({
              value: value,
              done: done
            });
          }
          _this2._loaded += value.byteLength;
          if (_this2.onProgress) {
            _this2.onProgress({
              loaded: _this2._loaded,
              total: _this2._contentLength
            });
          }
          var buffer = new Uint8Array(value).buffer;
          return Promise.resolve({
            value: buffer,
            done: false
          });
        });
      });
    }
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (this._reader) {
        this._reader.cancel(reason);
      }
    }
  }, {
    key: 'headersReady',
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: 'filename',
    get: function get() {
      return this._filename;
    }
  }, {
    key: 'contentLength',
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: 'isRangeSupported',
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return PDFFetchStreamReader;
}();

var PDFFetchStreamRangeReader = function () {
  function PDFFetchStreamRangeReader(stream, begin, end) {
    var _this3 = this;

    _classCallCheck(this, PDFFetchStreamRangeReader);

    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    var source = stream.source;
    this._withCredentials = source.withCredentials;
    this._readCapability = (0, _util.createPromiseCapability)();
    this._isStreamingSupported = !source.disableStream;
    this._headers = new Headers();
    for (var property in this._stream.httpHeaders) {
      var value = this._stream.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      this._headers.append(property, value);
    }
    var rangeStr = begin + '-' + (end - 1);
    this._headers.append('Range', 'bytes=' + rangeStr);
    var url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }
      _this3._readCapability.resolve();
      _this3._reader = response.body.getReader();
    });
    this.onProgress = null;
  }

  _createClass(PDFFetchStreamRangeReader, [{
    key: 'read',
    value: function read() {
      var _this4 = this;

      return this._readCapability.promise.then(function () {
        return _this4._reader.read().then(function (_ref2) {
          var value = _ref2.value,
              done = _ref2.done;

          if (done) {
            return Promise.resolve({
              value: value,
              done: done
            });
          }
          _this4._loaded += value.byteLength;
          if (_this4.onProgress) {
            _this4.onProgress({ loaded: _this4._loaded });
          }
          var buffer = new Uint8Array(value).buffer;
          return Promise.resolve({
            value: buffer,
            done: false
          });
        });
      });
    }
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (this._reader) {
        this._reader.cancel(reason);
      }
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return PDFFetchStreamRangeReader;
}();

exports.PDFFetchStream = PDFFetchStream;

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkManager = exports.PDFNetworkStream = undefined;

var _util = __webpack_require__(73);

var _network_utils = __webpack_require__(557);

var _global_scope = __webpack_require__(287);

var _global_scope2 = _interopRequireDefault(_global_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
var OK_RESPONSE = 200;
var PARTIAL_CONTENT_RESPONSE = 206;
function NetworkManager(url, args) {
  this.url = url;
  args = args || {};
  this.isHttp = /^https?:/i.test(url);
  this.httpHeaders = this.isHttp && args.httpHeaders || {};
  this.withCredentials = args.withCredentials || false;
  this.getXhr = args.getXhr || function NetworkManager_getXhr() {
    return new XMLHttpRequest();
  };
  this.currXhrId = 0;
  this.pendingRequests = Object.create(null);
  this.loadedRequests = Object.create(null);
}
function getArrayBuffer(xhr) {
  var data = xhr.response;
  if (typeof data !== 'string') {
    return data;
  }
  var array = (0, _util.stringToBytes)(data);
  return array.buffer;
}
var supportsMozChunked = function supportsMozChunkedClosure() {
  try {
    var x = new XMLHttpRequest();
    x.open('GET', _global_scope2.default.location.href);
    x.responseType = 'moz-chunked-arraybuffer';
    return x.responseType === 'moz-chunked-arraybuffer';
  } catch (e) {
    return false;
  }
}();
NetworkManager.prototype = {
  requestRange: function NetworkManager_requestRange(begin, end, listeners) {
    var args = {
      begin: begin,
      end: end
    };
    for (var prop in listeners) {
      args[prop] = listeners[prop];
    }
    return this.request(args);
  },
  requestFull: function NetworkManager_requestFull(listeners) {
    return this.request(listeners);
  },
  request: function NetworkManager_request(args) {
    var xhr = this.getXhr();
    var xhrId = this.currXhrId++;
    var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
    xhr.open('GET', this.url);
    xhr.withCredentials = this.withCredentials;
    for (var property in this.httpHeaders) {
      var value = this.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      xhr.setRequestHeader(property, value);
    }
    if (this.isHttp && 'begin' in args && 'end' in args) {
      var rangeStr = args.begin + '-' + (args.end - 1);
      xhr.setRequestHeader('Range', 'bytes=' + rangeStr);
      pendingRequest.expectedStatus = 206;
    } else {
      pendingRequest.expectedStatus = 200;
    }
    var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
    if (useMozChunkedLoading) {
      xhr.responseType = 'moz-chunked-arraybuffer';
      pendingRequest.onProgressiveData = args.onProgressiveData;
      pendingRequest.mozChunked = true;
    } else {
      xhr.responseType = 'arraybuffer';
    }
    if (args.onError) {
      xhr.onerror = function (evt) {
        args.onError(xhr.status);
      };
    }
    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
    xhr.onprogress = this.onProgress.bind(this, xhrId);
    pendingRequest.onHeadersReceived = args.onHeadersReceived;
    pendingRequest.onDone = args.onDone;
    pendingRequest.onError = args.onError;
    pendingRequest.onProgress = args.onProgress;
    xhr.send(null);
    return xhrId;
  },
  onProgress: function NetworkManager_onProgress(xhrId, evt) {
    var pendingRequest = this.pendingRequests[xhrId];
    if (!pendingRequest) {
      return;
    }
    if (pendingRequest.mozChunked) {
      var chunk = getArrayBuffer(pendingRequest.xhr);
      pendingRequest.onProgressiveData(chunk);
    }
    var onProgress = pendingRequest.onProgress;
    if (onProgress) {
      onProgress(evt);
    }
  },
  onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
    var pendingRequest = this.pendingRequests[xhrId];
    if (!pendingRequest) {
      return;
    }
    var xhr = pendingRequest.xhr;
    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
      pendingRequest.onHeadersReceived();
      delete pendingRequest.onHeadersReceived;
    }
    if (xhr.readyState !== 4) {
      return;
    }
    if (!(xhrId in this.pendingRequests)) {
      return;
    }
    delete this.pendingRequests[xhrId];
    if (xhr.status === 0 && this.isHttp) {
      if (pendingRequest.onError) {
        pendingRequest.onError(xhr.status);
      }
      return;
    }
    var xhrStatus = xhr.status || OK_RESPONSE;
    var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
      if (pendingRequest.onError) {
        pendingRequest.onError(xhr.status);
      }
      return;
    }
    this.loadedRequests[xhrId] = true;
    var chunk = getArrayBuffer(xhr);
    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
      var rangeHeader = xhr.getResponseHeader('Content-Range');
      var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
      var begin = parseInt(matches[1], 10);
      pendingRequest.onDone({
        begin: begin,
        chunk: chunk
      });
    } else if (pendingRequest.onProgressiveData) {
      pendingRequest.onDone(null);
    } else if (chunk) {
      pendingRequest.onDone({
        begin: 0,
        chunk: chunk
      });
    } else if (pendingRequest.onError) {
      pendingRequest.onError(xhr.status);
    }
  },
  hasPendingRequests: function NetworkManager_hasPendingRequests() {
    for (var xhrId in this.pendingRequests) {
      return true;
    }
    return false;
  },
  getRequestXhr: function NetworkManager_getXhr(xhrId) {
    return this.pendingRequests[xhrId].xhr;
  },
  isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
    return !!this.pendingRequests[xhrId].onProgressiveData;
  },
  isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
    return xhrId in this.pendingRequests;
  },
  isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
    return xhrId in this.loadedRequests;
  },
  abortAllRequests: function NetworkManager_abortAllRequests() {
    for (var xhrId in this.pendingRequests) {
      this.abortRequest(xhrId | 0);
    }
  },
  abortRequest: function NetworkManager_abortRequest(xhrId) {
    var xhr = this.pendingRequests[xhrId].xhr;
    delete this.pendingRequests[xhrId];
    xhr.abort();
  }
};
function PDFNetworkStream(source) {
  this._source = source;
  this._manager = new NetworkManager(source.url, {
    httpHeaders: source.httpHeaders,
    withCredentials: source.withCredentials
  });
  this._rangeChunkSize = source.rangeChunkSize;
  this._fullRequestReader = null;
  this._rangeRequestReaders = [];
}
PDFNetworkStream.prototype = {
  _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
    var i = this._rangeRequestReaders.indexOf(reader);
    if (i >= 0) {
      this._rangeRequestReaders.splice(i, 1);
    }
  },
  getFullReader: function PDFNetworkStream_getFullReader() {
    (0, _util.assert)(!this._fullRequestReader);
    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
    return this._fullRequestReader;
  },
  getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
    var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
    this._rangeRequestReaders.push(reader);
    return reader;
  },
  cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
    if (this._fullRequestReader) {
      this._fullRequestReader.cancel(reason);
    }
    var readers = this._rangeRequestReaders.slice(0);
    readers.forEach(function (reader) {
      reader.cancel(reason);
    });
  }
};
function PDFNetworkStreamFullRequestReader(manager, source) {
  this._manager = manager;
  var args = {
    onHeadersReceived: this._onHeadersReceived.bind(this),
    onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
    onDone: this._onDone.bind(this),
    onError: this._onError.bind(this),
    onProgress: this._onProgress.bind(this)
  };
  this._url = source.url;
  this._fullRequestId = manager.requestFull(args);
  this._headersReceivedCapability = (0, _util.createPromiseCapability)();
  this._disableRange = source.disableRange || false;
  this._contentLength = source.length;
  this._rangeChunkSize = source.rangeChunkSize;
  if (!this._rangeChunkSize && !this._disableRange) {
    this._disableRange = true;
  }
  this._isStreamingSupported = false;
  this._isRangeSupported = false;
  this._cachedChunks = [];
  this._requests = [];
  this._done = false;
  this._storedError = undefined;
  this._filename = null;
  this.onProgress = null;
}
PDFNetworkStreamFullRequestReader.prototype = {
  _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
    var fullRequestXhrId = this._fullRequestId;
    var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
    var getResponseHeader = function getResponseHeader(name) {
      return fullRequestXhr.getResponseHeader(name);
    };

    var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
      getResponseHeader: getResponseHeader,
      isHttp: this._manager.isHttp,
      rangeChunkSize: this._rangeChunkSize,
      disableRange: this._disableRange
    }),
        allowRangeRequests = _validateRangeRequest.allowRangeRequests,
        suggestedLength = _validateRangeRequest.suggestedLength;

    this._contentLength = suggestedLength || this._contentLength;
    if (allowRangeRequests) {
      this._isRangeSupported = true;
    }
    this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
    var networkManager = this._manager;
    if (networkManager.isStreamingRequest(fullRequestXhrId)) {
      this._isStreamingSupported = true;
    } else if (this._isRangeSupported) {
      networkManager.abortRequest(fullRequestXhrId);
    }
    this._headersReceivedCapability.resolve();
  },
  _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
    if (this._requests.length > 0) {
      var requestCapability = this._requests.shift();
      requestCapability.resolve({
        value: chunk,
        done: false
      });
    } else {
      this._cachedChunks.push(chunk);
    }
  },
  _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
    if (args) {
      this._onProgressiveData(args.chunk);
    }
    this._done = true;
    if (this._cachedChunks.length > 0) {
      return;
    }
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
  },
  _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
    var url = this._url;
    var exception = (0, _network_utils.createResponseStatusError)(status, url);
    this._storedError = exception;
    this._headersReceivedCapability.reject(exception);
    this._requests.forEach(function (requestCapability) {
      requestCapability.reject(exception);
    });
    this._requests = [];
    this._cachedChunks = [];
  },
  _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
    if (this.onProgress) {
      this.onProgress({
        loaded: data.loaded,
        total: data.lengthComputable ? data.total : this._contentLength
      });
    }
  },
  get filename() {
    return this._filename;
  },
  get isRangeSupported() {
    return this._isRangeSupported;
  },
  get isStreamingSupported() {
    return this._isStreamingSupported;
  },
  get contentLength() {
    return this._contentLength;
  },
  get headersReady() {
    return this._headersReceivedCapability.promise;
  },
  read: function PDFNetworkStreamFullRequestReader_read() {
    if (this._storedError) {
      return Promise.reject(this._storedError);
    }
    if (this._cachedChunks.length > 0) {
      var chunk = this._cachedChunks.shift();
      return Promise.resolve({
        value: chunk,
        done: false
      });
    }
    if (this._done) {
      return Promise.resolve({
        value: undefined,
        done: true
      });
    }
    var requestCapability = (0, _util.createPromiseCapability)();
    this._requests.push(requestCapability);
    return requestCapability.promise;
  },
  cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
    this._done = true;
    this._headersReceivedCapability.reject(reason);
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    if (this._manager.isPendingRequest(this._fullRequestId)) {
      this._manager.abortRequest(this._fullRequestId);
    }
    this._fullRequestReader = null;
  }
};
function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
  this._manager = manager;
  var args = {
    onDone: this._onDone.bind(this),
    onProgress: this._onProgress.bind(this)
  };
  this._requestId = manager.requestRange(begin, end, args);
  this._requests = [];
  this._queuedChunk = null;
  this._done = false;
  this.onProgress = null;
  this.onClosed = null;
}
PDFNetworkStreamRangeRequestReader.prototype = {
  _close: function PDFNetworkStreamRangeRequestReader_close() {
    if (this.onClosed) {
      this.onClosed(this);
    }
  },
  _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
    var chunk = data.chunk;
    if (this._requests.length > 0) {
      var requestCapability = this._requests.shift();
      requestCapability.resolve({
        value: chunk,
        done: false
      });
    } else {
      this._queuedChunk = chunk;
    }
    this._done = true;
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    this._close();
  },
  _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
    if (!this.isStreamingSupported && this.onProgress) {
      this.onProgress({ loaded: evt.loaded });
    }
  },
  get isStreamingSupported() {
    return false;
  },
  read: function PDFNetworkStreamRangeRequestReader_read() {
    if (this._queuedChunk !== null) {
      var chunk = this._queuedChunk;
      this._queuedChunk = null;
      return Promise.resolve({
        value: chunk,
        done: false
      });
    }
    if (this._done) {
      return Promise.resolve({
        value: undefined,
        done: true
      });
    }
    var requestCapability = (0, _util.createPromiseCapability)();
    this._requests.push(requestCapability);
    return requestCapability.promise;
  },
  cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
    this._done = true;
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    if (this._manager.isPendingRequest(this._requestId)) {
      this._manager.abortRequest(this._requestId);
    }
    this._close();
  }
};
exports.PDFNetworkStream = PDFNetworkStream;
exports.NetworkManager = NetworkManager;

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(374);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(129);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(132);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(133);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mergeClassNames = __webpack_require__(286);

var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);

var _OutlineItem = __webpack_require__(2476);

var _OutlineItem2 = _interopRequireDefault(_OutlineItem);

var _utils = __webpack_require__(134);

var _events = __webpack_require__(385);

var _propTypes3 = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Outline = function (_Component) {
  (0, _inherits3.default)(Outline, _Component);

  function Outline() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Outline);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Outline.__proto__ || (0, _getPrototypeOf2.default)(Outline)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      outline: null
    }, _this.onLoadSuccess = function (outline) {
      _this.setState({ outline: outline }, function () {
        (0, _utils.callIfDefined)(_this.props.onLoadSuccess, outline);
      });
    }, _this.onLoadError = function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      (0, _utils.errorOnDev)(error.message, error);

      (0, _utils.callIfDefined)(_this.props.onLoadError, error);

      _this.setState({ outline: false });
    }, _this.onItemClick = function (_ref2) {
      var pageIndex = _ref2.pageIndex,
          pageNumber = _ref2.pageNumber;

      (0, _utils.callIfDefined)(_this.props.onItemClick, {
        pageIndex: pageIndex,
        pageNumber: pageNumber
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Outline, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadOutline();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (this.getPdf(nextProps, nextContext) !== this.getPdf()) {
        this.loadOutline(nextProps, nextContext);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _utils.cancelRunningTask)(this.runningTask);
    }
  }, {
    key: 'getPdf',
    value: function getPdf() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

      return props.pdf || context.pdf;
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        pdf: this.getPdf(),
        onClick: this.onItemClick
      };
    }
  }, {
    key: 'loadOutline',
    value: function loadOutline() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

      var pdf = this.getPdf(props, context);

      if (!pdf) {
        throw new Error('Attempted to load an outline, but no document was specified.');
      }

      if (this.state.outline !== null) {
        this.setState({ outline: null });
      }

      this.runningTask = (0, _utils.makeCancellable)(pdf.getOutline());

      return this.runningTask.promise.then(this.onLoadSuccess).catch(this.onLoadError);
    }
  }, {
    key: 'renderOutline',
    value: function renderOutline() {
      var outline = this.state.outline;


      return _react2.default.createElement(
        'ul',
        null,
        outline.map(function (item, itemIndex) {
          return _react2.default.createElement(_OutlineItem2.default, {
            key: typeof item.destination === 'string' ? item.destination : itemIndex,
            item: item
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var pdf = this.getPdf();
      var outline = this.state.outline;


      if (!pdf || !outline) {
        return null;
      }

      var className = this.props.className;


      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          className: (0, _mergeClassNames2.default)('react-pdf__Outline', className),
          ref: this.props.inputRef
        }, this.eventProps),
        this.renderOutline()
      );
    }
  }, {
    key: 'eventProps',
    get: function get() {
      var _this2 = this;

      return (0, _events.makeEventProps)(this.props, function () {
        return _this2.state.outline;
      });
    }

    /**
     * Called when an outline is read successfully
     */


    /**
     * Called when an outline failed to read successfully
     */

  }]);
  return Outline;
}(_react.Component);

exports.default = Outline;


Outline.childContextTypes = {
  onClick: _propTypes2.default.func,
  pdf: _propTypes3.isPdf
};

Outline.contextTypes = {
  pdf: _propTypes3.isPdf
};

Outline.propTypes = (0, _extends3.default)({
  className: _propTypes3.isClassName,
  inputRef: _propTypes2.default.func,
  onItemClick: _propTypes2.default.func,
  onLoadError: _propTypes2.default.func,
  onLoadSuccess: _propTypes2.default.func
}, (0, _propTypes3.eventsProps)());

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(1044);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = __webpack_require__(1045);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(1046);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(129);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(132);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(133);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Ref = __webpack_require__(2485);

var _Ref2 = _interopRequireDefault(_Ref);

var _utils = __webpack_require__(134);

var _propTypes3 = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OutlineItem = function (_Component) {
  (0, _inherits3.default)(OutlineItem, _Component);

  function OutlineItem() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, OutlineItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OutlineItem.__proto__ || (0, _getPrototypeOf2.default)(OutlineItem)).call.apply(_ref, [this].concat(args))), _this), _this.getDestination = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var pdf, item;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pdf = _this.context.pdf;
              item = _this.props.item;

              if ((0, _utils.isDefined)(_this.destination)) {
                _context.next = 10;
                break;
              }

              if (!(typeof item.dest === 'string')) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return pdf.getDestination(item.dest);

            case 6:
              _this.destination = _context.sent;
              _context.next = 10;
              break;

            case 9:
              _this.destination = item.dest;

            case 10:
              return _context.abrupt('return', _this.destination);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _this.getPageIndex = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var pdf, destination, _destination, ref;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              pdf = _this.context.pdf;

              if ((0, _utils.isDefined)(_this.pageIndex)) {
                _context2.next = 10;
                break;
              }

              _context2.next = 4;
              return _this.getDestination();

            case 4:
              destination = _context2.sent;

              if (!destination) {
                _context2.next = 10;
                break;
              }

              _destination = (0, _slicedToArray3.default)(destination, 1), ref = _destination[0];
              _context2.next = 9;
              return pdf.getPageIndex(new _Ref2.default(ref));

            case 9:
              _this.pageIndex = _context2.sent;

            case 10:
              return _context2.abrupt('return', _this.pageIndex);

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _this.getPageNumber = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if ((0, _utils.isDefined)(_this.pageNumber)) {
                _context3.next = 5;
                break;
              }

              _context3.next = 3;
              return _this.getPageIndex();

            case 3:
              _context3.t0 = _context3.sent;
              _this.pageNumber = _context3.t0 + 1;

            case 5:
              return _context3.abrupt('return', _this.pageNumber);

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    })), _this.onClick = function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(event) {
        var pageIndex, pageNumber;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                event.preventDefault();

                _context4.next = 3;
                return _this.getPageIndex();

              case 3:
                pageIndex = _context4.sent;
                _context4.next = 6;
                return _this.getPageNumber();

              case 6:
                pageNumber = _context4.sent;


                (0, _utils.callIfDefined)(_this.context.onClick, {
                  pageIndex: pageIndex,
                  pageNumber: pageNumber
                });

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(OutlineItem, [{
    key: 'renderSubitems',
    value: function renderSubitems() {
      var item = this.props.item;


      if (!item.items || !item.items.length) {
        return null;
      }

      var subitems = item.items;


      return _react2.default.createElement(
        'ul',
        null,
        subitems.map(function (subitem, subitemIndex) {
          return _react2.default.createElement(OutlineItem, {
            key: typeof subitem.destination === 'string' ? subitem.destination : subitemIndex,
            item: subitem
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item;
      var onClick = this.onClick;


      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          {
            href: '#',
            onClick: onClick
          },
          item.title
        ),
        this.renderSubitems()
      );
    }
  }]);
  return OutlineItem;
}(_react.Component);

exports.default = OutlineItem;


var isDestination = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.any)]);

OutlineItem.contextTypes = {
  onClick: _propTypes2.default.func,
  pdf: _propTypes3.isPdf.isRequired
};

OutlineItem.propTypes = {
  item: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    destination: isDestination,
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      title: _propTypes2.default.string,
      destination: isDestination
    }))
  }).isRequired
};

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2478), __esModule: true };

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(382);
__webpack_require__(380);
module.exports = __webpack_require__(2479);


/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(549);
var ITERATOR = __webpack_require__(89)('iterator');
var Iterators = __webpack_require__(237);
module.exports = __webpack_require__(70).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2481), __esModule: true };

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(382);
__webpack_require__(380);
module.exports = __webpack_require__(2482);


/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(128);
var get = __webpack_require__(1009);
module.exports = __webpack_require__(70).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(2484);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 2484 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ref = function () {
  function Ref(_ref) {
    var num = _ref.num,
        gen = _ref.gen;
    (0, _classCallCheck3.default)(this, Ref);

    this.num = num;
    this.gen = gen;
  }

  (0, _createClass3.default)(Ref, [{
    key: "toString",
    value: function toString() {
      var str = this.num + "R";
      if (this.gen !== 0) {
        str += this.gen;
      }
      return str;
    }
  }]);
  return Ref;
}();

exports.default = Ref;

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(374);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(129);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(132);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(133);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mergeClassNames = __webpack_require__(286);

var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);

var _PageCanvas = __webpack_require__(2487);

var _PageCanvas2 = _interopRequireDefault(_PageCanvas);

var _PageSVG = __webpack_require__(2488);

var _PageSVG2 = _interopRequireDefault(_PageSVG);

var _TextLayer = __webpack_require__(2489);

var _TextLayer2 = _interopRequireDefault(_TextLayer);

var _AnnotationLayer = __webpack_require__(2491);

var _AnnotationLayer2 = _interopRequireDefault(_AnnotationLayer);

var _utils = __webpack_require__(134);

var _events = __webpack_require__(385);

var _propTypes3 = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultScale = 1.0;

var Page = function (_Component) {
  (0, _inherits3.default)(Page, _Component);

  function Page() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Page);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Page.__proto__ || (0, _getPrototypeOf2.default)(Page)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      page: null
    }, _this.onLoadSuccess = function (page) {
      _this.setState({ page: page }, function () {
        (0, _utils.callIfDefined)(_this.props.onLoadSuccess, (0, _utils.makePageCallback)(page, _this.scale));

        (0, _utils.callIfDefined)(_this.context.registerPage, page.pageIndex, _this.ref);
      });
    }, _this.onLoadError = function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      (0, _utils.errorOnDev)(error.message, error);

      (0, _utils.callIfDefined)(_this.props.onLoadError, error);

      _this.setState({ page: false });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Page, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadPage();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (this.getPdf(nextProps, nextContext) !== this.getPdf() || this.getPageNumber(nextProps) !== this.getPageNumber()) {
        (0, _utils.callIfDefined)(this.context.unregisterPage, this.pageIndex);

        if (this.state.page !== null) {
          this.setState({ page: null });
        }

        this.loadPage(nextProps, nextContext);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _utils.callIfDefined)(this.context.unregisterPage, this.pageIndex);

      (0, _utils.cancelRunningTask)(this.runningTask);
    }
  }, {
    key: 'getPdf',
    value: function getPdf() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

      return props.pdf || context.pdf;
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      if (!this.state.page) {
        return {};
      }

      var context = {
        page: this.state.page,
        pdf: this.getPdf(),
        rotate: this.rotate,
        scale: this.scale
      };

      if (this.props.onRenderError) {
        context.onRenderError = this.props.onRenderError;
      }
      if (this.props.onRenderSuccess) {
        context.onRenderSuccess = this.props.onRenderSuccess;
      }
      if (this.props.onGetAnnotationsError) {
        context.onGetAnnotationsError = this.props.onGetAnnotationsError;
      }
      if (this.props.onGetAnnotationsSuccess) {
        context.onGetAnnotationsSuccess = this.props.onGetAnnotationsSuccess;
      }
      if (this.props.onGetTextError) {
        context.onGetTextError = this.props.onGetTextError;
      }
      if (this.props.onGetTextSuccess) {
        context.onGetTextSuccess = this.props.onGetTextSuccess;
      }
      if (this.props.customTextRenderer) {
        context.customTextRenderer = this.props.customTextRenderer;
      }
      return context;
    }

    /**
     * Called when a page is loaded successfully
     */


    /**
     * Called when a page failed to load
     */

  }, {
    key: 'getPageIndex',
    value: function getPageIndex() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if ((0, _utils.isProvided)(props.pageNumber)) {
        return props.pageNumber - 1;
      }

      if ((0, _utils.isProvided)(props.pageIndex)) {
        return props.pageIndex;
      }

      return null;
    }
  }, {
    key: 'getPageNumber',
    value: function getPageNumber() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if ((0, _utils.isProvided)(props.pageNumber)) {
        return props.pageNumber;
      }

      if ((0, _utils.isProvided)(props.pageIndex)) {
        return props.pageIndex + 1;
      }

      return null;
    }
  }, {
    key: 'loadPage',
    value: function loadPage() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

      var pdf = this.getPdf(props, context);

      if (!pdf) {
        throw new Error('Attempted to load a page, but no document was specified.');
      }

      var pageNumber = this.getPageNumber(props);

      if (!pageNumber) {
        return null;
      }

      this.runningTask = (0, _utils.makeCancellable)(pdf.getPage(pageNumber));

      return this.runningTask.promise.then(this.onLoadSuccess).catch(this.onLoadError);
    }
  }, {
    key: 'renderTextLayer',
    value: function renderTextLayer() {
      var renderTextLayer = this.props.renderTextLayer;


      if (!renderTextLayer) {
        return null;
      }

      return _react2.default.createElement(_TextLayer2.default, { key: this.pageKey + '_text' });
    }
  }, {
    key: 'renderAnnotations',
    value: function renderAnnotations() {
      var renderAnnotations = this.props.renderAnnotations;


      if (!renderAnnotations) {
        return null;
      }

      return _react2.default.createElement(_AnnotationLayer2.default, { key: this.pageKey + '_annotations' });
    }
  }, {
    key: 'renderSVG',
    value: function renderSVG() {
      return [_react2.default.createElement(_PageSVG2.default, { key: this.pageKeyNoScale + '_svg' }),
      /**
       * As of now, PDF.js 2.0.120 returns warnings on unimplemented annotations.
       * Therefore, as a fallback, we render "traditional" AnnotationLayer component.
       */
      this.renderAnnotations()];
    }
  }, {
    key: 'renderCanvas',
    value: function renderCanvas() {
      return [_react2.default.createElement(_PageCanvas2.default, { key: this.pageKey + '_canvas' }), this.renderTextLayer(), this.renderAnnotations()];
    }
  }, {
    key: 'renderNoData',
    value: function renderNoData() {
      return _react2.default.createElement(
        'div',
        { className: 'react-pdf__message react-pdf__message--no-data' },
        this.props.noData
      );
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      return _react2.default.createElement(
        'div',
        { className: 'react-pdf__message react-pdf__message--error' },
        this.props.error
      );
    }
  }, {
    key: 'renderLoader',
    value: function renderLoader() {
      return _react2.default.createElement(
        'div',
        { className: 'react-pdf__message react-pdf__message--loading' },
        this.props.loading
      );
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          children = _props.children,
          renderMode = _props.renderMode;


      return [renderMode === 'svg' ? this.renderSVG() : this.renderCanvas(), children];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var pageNumber = this.pageNumber;

      var pdf = this.getPdf();
      var className = this.props.className;
      var page = this.state.page;


      var content = void 0;
      if (!pageNumber) {
        content = this.renderNoData();
      } else if (pdf === null || page === null) {
        content = this.renderLoader();
      } else if (pdf === false || page === false) {
        content = this.renderError();
      } else {
        content = this.renderChildren();
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          className: (0, _mergeClassNames2.default)('react-pdf__Page', className),
          ref: function ref(_ref2) {
            var inputRef = _this2.props.inputRef;

            if (inputRef) {
              inputRef(_ref2);
            }

            _this2.ref = _ref2;
          },
          style: { position: 'relative' },
          'data-page-number': pageNumber
        }, this.eventProps),
        content
      );
    }
  }, {
    key: 'pageIndex',
    get: function get() {
      return this.getPageIndex();
    }
  }, {
    key: 'pageNumber',
    get: function get() {
      return this.getPageNumber();
    }
  }, {
    key: 'rotate',
    get: function get() {
      if ((0, _utils.isProvided)(this.props.rotate)) {
        return this.props.rotate;
      }

      if ((0, _utils.isProvided)(this.context.rotate)) {
        return this.context.rotate;
      }

      var page = this.state.page;


      return page.rotate;
    }
  }, {
    key: 'scale',
    get: function get() {
      var _props2 = this.props,
          scale = _props2.scale,
          width = _props2.width;
      var page = this.state.page;
      var rotate = this.rotate;

      // Be default, we'll render page at 100% * scale width.

      var pageScale = 1;

      // If width is defined, calculate the scale of the page so it could be of desired width.
      if (width) {
        var viewport = page.getViewport(scale, rotate);
        pageScale = width / viewport.width;
      }

      // Passing scale explicitly null would cause the page not to render
      var scaleWithDefault = scale === null ? defaultScale : scale;

      return scaleWithDefault * pageScale;
    }
  }, {
    key: 'eventProps',
    get: function get() {
      var _this3 = this;

      return (0, _events.makeEventProps)(this.props, function () {
        var page = _this3.state.page;

        return (0, _utils.makePageCallback)(page, _this3.scale);
      });
    }
  }, {
    key: 'pageKey',
    get: function get() {
      return this.state.page.pageIndex + '@' + this.scale + '/' + this.rotate;
    }
  }, {
    key: 'pageKeyNoScale',
    get: function get() {
      return this.state.page.pageIndex + '/' + this.rotate;
    }
  }, {
    key: 'pageProps',
    get: function get() {
      return {
        page: this.state.page,
        rotate: this.rotate,
        scale: this.scale
      };
    }
  }]);
  return Page;
}(_react.Component);

exports.default = Page;


Page.defaultProps = {
  error: 'Failed to load the page.',
  loading: 'Loading page…',
  noData: 'No page specified.',
  renderAnnotations: true,
  renderMode: 'canvas',
  renderTextLayer: true,
  scale: defaultScale
};

Page.childContextTypes = {
  customTextRenderer: _propTypes2.default.func,
  onGetTextError: _propTypes2.default.func,
  onGetTextSuccess: _propTypes2.default.func,
  onRenderError: _propTypes2.default.func,
  onRenderSuccess: _propTypes2.default.func,
  page: _propTypes3.isPage,
  pdf: _propTypes3.isPdf,
  rotate: _propTypes3.isRotate,
  scale: _propTypes2.default.number
};

Page.contextTypes = {
  linkService: _propTypes3.isLinkService,
  pdf: _propTypes3.isPdf,
  registerPage: _propTypes2.default.func,
  rotate: _propTypes3.isRotate,
  unregisterPage: _propTypes2.default.func
};

Page.propTypes = (0, _extends3.default)({
  children: _propTypes2.default.node,
  className: _propTypes3.isClassName,
  customTextRenderer: _propTypes2.default.func,
  error: _propTypes2.default.node,
  inputRef: _propTypes2.default.func,
  loading: _propTypes2.default.node,
  noData: _propTypes2.default.node,
  onGetTextError: _propTypes2.default.func,
  onGetTextSuccess: _propTypes2.default.func,
  onLoadError: _propTypes2.default.func,
  onLoadSuccess: _propTypes2.default.func,
  onRenderError: _propTypes2.default.func,
  onRenderSuccess: _propTypes2.default.func,
  pageIndex: _propTypes3.isPageIndex,
  pageNumber: _propTypes3.isPageNumber,
  renderAnnotations: _propTypes2.default.bool,
  renderMode: _propTypes2.default.oneOf(['canvas', 'svg']),
  renderTextLayer: _propTypes2.default.bool,
  rotate: _propTypes3.isRotate,
  scale: _propTypes2.default.number,
  width: _propTypes2.default.number
}, (0, _propTypes3.eventsProps)());

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(129);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(132);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(133);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(134);

var _propTypes3 = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageCanvas = function (_Component) {
  (0, _inherits3.default)(PageCanvas, _Component);

  function PageCanvas() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PageCanvas);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PageCanvas.__proto__ || (0, _getPrototypeOf2.default)(PageCanvas)).call.apply(_ref, [this].concat(args))), _this), _this.onRenderSuccess = function () {
      _this.renderer = null;

      var _this$context = _this.context,
          page = _this$context.page,
          scale = _this$context.scale;


      (0, _utils.callIfDefined)(_this.context.onRenderSuccess, (0, _utils.makePageCallback)(page, scale));
    }, _this.onRenderError = function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      (0, _utils.errorOnDev)(error.message, error);

      (0, _utils.callIfDefined)(_this.context.onRenderError, error);
    }, _this.drawPageOnCanvas = function (canvas) {
      if (!canvas) {
        return null;
      }

      var page = _this.context.page;
      var _this2 = _this,
          renderViewport = _this2.renderViewport,
          viewport = _this2.viewport;


      canvas.width = renderViewport.width;
      canvas.height = renderViewport.height;

      canvas.style.width = Math.floor(viewport.width) + 'px';
      canvas.style.height = Math.floor(viewport.height) + 'px';

      var renderContext = {
        get canvasContext() {
          return canvas.getContext('2d');
        },
        viewport: renderViewport
      };

      // If another render is in progress, let's cancel it
      /* eslint-disable no-underscore-dangle */
      if (_this.renderer && _this.renderer._internalRenderTask.running) {
        _this.renderer._internalRenderTask.cancel();
      }
      /* eslint-enable no-underscore-dangle */

      _this.renderer = page.render(renderContext);

      return _this.renderer.then(_this.onRenderSuccess).catch(_this.onRenderError);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PageCanvas, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      /* eslint-disable no-underscore-dangle */
      if (this.renderer && this.renderer._internalRenderTask.running) {
        this.renderer._internalRenderTask.cancel();
      }
      /* eslint-enable no-underscore-dangle */
    }

    /**
     * Called when a page is rendered successfully.
     */


    /**
     * Called when a page fails to render.
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('canvas', {
        className: 'react-pdf__Page__canvas',
        style: {
          display: 'block',
          userSelect: 'none'
        },
        ref: this.drawPageOnCanvas
      });
    }
  }, {
    key: 'renderViewport',
    get: function get() {
      var _context = this.context,
          page = _context.page,
          rotate = _context.rotate,
          scale = _context.scale;


      var pixelRatio = (0, _utils.getPixelRatio)();

      return page.getViewport(scale * pixelRatio, rotate);
    }
  }, {
    key: 'viewport',
    get: function get() {
      var _context2 = this.context,
          page = _context2.page,
          rotate = _context2.rotate,
          scale = _context2.scale;


      return page.getViewport(scale, rotate);
    }
  }]);
  return PageCanvas;
}(_react.Component);

exports.default = PageCanvas;


PageCanvas.contextTypes = {
  onRenderError: _propTypes2.default.func,
  onRenderSuccess: _propTypes2.default.func,
  page: _propTypes3.isPage.isRequired,
  rotate: _propTypes3.isRotate,
  scale: _propTypes2.default.number
};

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(129);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(132);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(133);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(134);

var _propTypes3 = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageSVG = function (_Component) {
  (0, _inherits3.default)(PageSVG, _Component);

  function PageSVG() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PageSVG);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PageSVG.__proto__ || (0, _getPrototypeOf2.default)(PageSVG)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      svg: null
    }, _this.onRenderSuccess = function () {
      _this.renderer = null;

      var _this$context = _this.context,
          page = _this$context.page,
          scale = _this$context.scale;


      (0, _utils.callIfDefined)(_this.context.onRenderSuccess, (0, _utils.makePageCallback)(page, scale));
    }, _this.onRenderError = function (error) {
      if (error.name === 'RenderingCancelledException') {
        return;
      }

      (0, _utils.callIfDefined)(_this.context.onRenderError, error);
    }, _this.renderSVG = function () {
      var page = _this.context.page;


      _this.renderer = page.getOperatorList();

      return _this.renderer.then(function (operatorList) {
        var svgGfx = new PDFJS.SVGGraphics(page.commonObjs, page.objs);
        _this.renderer = svgGfx.getSVG(operatorList, _this.viewport).then(function (svg) {
          svg.style.maxWidth = '100%';
          svg.style.height = 'auto';
          _this.setState({ svg: svg }, function () {
            return _this.onRenderSuccess();
          });
        }).catch(_this.onRenderError);
      }).catch(_this.onRenderError);
    }, _this.drawPageOnContainer = function (element) {
      var svg = _this.state.svg;


      if (!element || !svg) {
        return;
      }

      var renderedPage = element.firstElementChild;
      if (renderedPage) {
        var _this$viewport = _this.viewport,
            width = _this$viewport.width,
            height = _this$viewport.height;

        renderedPage.setAttribute('width', width);
        renderedPage.setAttribute('height', height);
      } else {
        element.appendChild(svg);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PageSVG, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderSVG();
    }

    /**
     * Called when a page is rendered successfully.
     */


    /**
     * Called when a page fails to render.
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', {
        className: 'react-pdf__Page__svg',
        style: {
          display: 'block',
          backgroundColor: 'white'
        }
        // Note: This cannot be shortened, as we need this function to be called with each render.
        , ref: function ref(_ref2) {
          return _this2.drawPageOnContainer(_ref2);
        }
      });
    }
  }, {
    key: 'viewport',
    get: function get() {
      var _context = this.context,
          page = _context.page,
          rotate = _context.rotate,
          scale = _context.scale;


      return page.getViewport(scale, rotate);
    }
  }]);
  return PageSVG;
}(_react.Component);

exports.default = PageSVG;


PageSVG.contextTypes = {
  onRenderError: _propTypes2.default.func,
  onRenderSuccess: _propTypes2.default.func,
  page: _propTypes3.isPage.isRequired,
  rotate: _propTypes3.isRotate,
  scale: _propTypes2.default.number
};

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(374);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(129);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(132);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(133);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextLayerItem = __webpack_require__(2490);

var _TextLayerItem2 = _interopRequireDefault(_TextLayerItem);

var _utils = __webpack_require__(134);

var _propTypes3 = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextLayer = function (_Component) {
  (0, _inherits3.default)(TextLayer, _Component);

  function TextLayer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TextLayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextLayer.__proto__ || (0, _getPrototypeOf2.default)(TextLayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      textItems: null
    }, _this.onGetTextSuccess = function (textContent) {
      var textItems = null;
      if (textContent) {
        textItems = textContent.items;
      }

      (0, _utils.callIfDefined)(_this.context.onGetTextSuccess, textItems);

      _this.setState({ textItems: textItems });
    }, _this.onGetTextError = function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      (0, _utils.errorOnDev)(error.message, error);

      (0, _utils.callIfDefined)(_this.context.onGetTextError, error);

      _this.setState({ textItems: false });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TextLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getTextContent();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (nextContext.page !== this.context.page) {
        if (this.state.textItems !== null) {
          this.setState({ textItems: null });
        }

        this.getTextContent(nextContext);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _utils.cancelRunningTask)(this.runningTask);
    }
  }, {
    key: 'getTextContent',
    value: function getTextContent() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
      var page = context.page;


      if (!page) {
        throw new Error('Attempted to load page text content, but no page was specified.');
      }

      this.runningTask = (0, _utils.makeCancellable)(page.getTextContent());

      return this.runningTask.promise.then(this.onGetTextSuccess).catch(this.onGetTextError);
    }
  }, {
    key: 'renderTextItems',
    value: function renderTextItems() {
      var textItems = this.state.textItems;


      if (!textItems) {
        return null;
      }

      return textItems.map(function (textItem, itemIndex) {
        return _react2.default.createElement(_TextLayerItem2.default
        // eslint-disable-next-line react/no-array-index-key
        , (0, _extends3.default)({ key: itemIndex,
          itemIndex: itemIndex
        }, textItem));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var viewport = this.unrotatedViewport,
          rotate = this.rotate;


      return _react2.default.createElement(
        'div',
        {
          className: 'react-pdf__Page__textContent',
          style: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: viewport.width + 'px',
            height: viewport.height + 'px',
            color: 'transparent',
            transform: 'translate(-50%, -50%) rotate(' + rotate + 'deg)',
            pointerEvents: 'none'
          }
        },
        this.renderTextItems()
      );
    }
  }, {
    key: 'unrotatedViewport',
    get: function get() {
      var _context = this.context,
          page = _context.page,
          scale = _context.scale;


      return page.getViewport(scale);
    }

    /**
     * It might happen that the page is rotated by default. In such cases, we shouldn't rotate
     * text content.
     */

  }, {
    key: 'rotate',
    get: function get() {
      var _context2 = this.context,
          page = _context2.page,
          rotate = _context2.rotate;

      return rotate - page.rotate;
    }
  }]);
  return TextLayer;
}(_react.Component);

exports.default = TextLayer;


TextLayer.contextTypes = {
  onGetTextError: _propTypes2.default.func,
  onGetTextSuccess: _propTypes2.default.func,
  page: _propTypes3.isPage.isRequired,
  rotate: _propTypes3.isRotate,
  scale: _propTypes2.default.number
};

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(1044);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _regenerator = __webpack_require__(1045);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(1046);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(129);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(132);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(133);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Render disproportion above which font will be considered broken and fallback will be used
var BROKEN_FONT_ALARM_THRESHOLD = 0.1;

var TextLayerItem = function (_PureComponent) {
  (0, _inherits3.default)(TextLayerItem, _PureComponent);

  function TextLayerItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TextLayerItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextLayerItem.__proto__ || (0, _getPrototypeOf2.default)(TextLayerItem)).call.apply(_ref, [this].concat(args))), _this), _this.getElementWidth = function (element) {
      var _this2 = _this,
          sideways = _this2.sideways;

      return element.getBoundingClientRect()[sideways ? 'height' : 'width'];
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TextLayerItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.alignTextItem();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.alignTextItem();
    }
  }, {
    key: 'getFontData',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fontFamily) {
        var page, font;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = this.context.page;
                _context.next = 3;
                return page.commonObjs.ensureObj(fontFamily);

              case 3:
                font = _context.sent;
                return _context.abrupt('return', font.data);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFontData(_x) {
        return _ref2.apply(this, arguments);
      }

      return getFontData;
    }()
  }, {
    key: 'alignTextItem',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var element, scale, _props, fontName, width, targetWidth, fontData, actualWidth, widthDisproportion, repairsNeeded, fallbackFontName, ascent;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.item) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                element = this.item;

                element.style.transform = '';

                scale = this.context.scale;
                _props = this.props, fontName = _props.fontName, width = _props.width;
                targetWidth = width * scale;
                _context2.next = 9;
                return this.getFontData(fontName);

              case 9:
                fontData = _context2.sent;
                actualWidth = this.getElementWidth(element);
                widthDisproportion = Math.abs(targetWidth / actualWidth - 1);
                repairsNeeded = widthDisproportion > BROKEN_FONT_ALARM_THRESHOLD;

                if (repairsNeeded) {
                  fallbackFontName = fontData ? fontData.fallbackName : 'sans-serif';

                  element.style.fontFamily = fallbackFontName;

                  actualWidth = this.getElementWidth(element);
                }

                ascent = fontData ? fontData.ascent : 1;


                element.style.transform = 'scaleX(' + targetWidth / actualWidth + ') translateY(' + (1 - ascent) * 100 + '%)';

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function alignTextItem() {
        return _ref3.apply(this, arguments);
      }

      return alignTextItem;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var fontSize = this.fontSize,
          top = this.top,
          left = this.left;
      var scale = this.context.scale;
      var _props2 = this.props,
          fontName = _props2.fontName,
          text = _props2.str;


      return _react2.default.createElement(
        'div',
        {
          style: {
            height: '1em',
            fontFamily: fontName,
            fontSize: fontSize * scale + 'px',
            position: 'absolute',
            top: top * scale + 'px',
            left: left * scale + 'px',
            transformOrigin: 'left bottom',
            whiteSpace: 'pre',
            pointerEvents: 'all'
          },
          ref: function ref(_ref4) {
            _this3.item = _ref4;
          }
        },
        this.context.customTextRenderer ? this.context.customTextRenderer(this.props) : text
      );
    }
  }, {
    key: 'unrotatedViewport',
    get: function get() {
      var _context3 = this.context,
          page = _context3.page,
          scale = _context3.scale;


      return page.getViewport(scale);
    }

    /**
     * It might happen that the page is rotated by default. In such cases, we shouldn't rotate
     * text content.
     */

  }, {
    key: 'rotate',
    get: function get() {
      var _context4 = this.context,
          page = _context4.page,
          rotate = _context4.rotate;

      return rotate - page.rotate;
    }
  }, {
    key: 'sideways',
    get: function get() {
      var rotate = this.rotate;

      return rotate % 180 !== 0;
    }
  }, {
    key: 'defaultSideways',
    get: function get() {
      var rotation = this.unrotatedViewport.rotation;

      return rotation % 180 !== 0;
    }
  }, {
    key: 'fontSize',
    get: function get() {
      var transform = this.props.transform;
      var defaultSideways = this.defaultSideways;

      var _transform = (0, _slicedToArray3.default)(transform, 2),
          fontHeightPx = _transform[0],
          fontWidthPx = _transform[1];

      return defaultSideways ? fontWidthPx : fontHeightPx;
    }
  }, {
    key: 'top',
    get: function get() {
      var transform = this.props.transform;
      var viewport = this.unrotatedViewport,
          defaultSideways = this.defaultSideways;

      var _transform2 = (0, _slicedToArray3.default)(transform, 6),
          /* fontHeightPx */offsetX = _transform2[2],
          offsetY = _transform2[3],
          x = _transform2[4],
          y = _transform2[5];

      var _viewport$viewBox = (0, _slicedToArray3.default)(viewport.viewBox, 4),
          /* xMin */yMin = _viewport$viewBox[1],
          /* xMax */yMax = _viewport$viewBox[3];

      return defaultSideways ? x + offsetX + yMin : yMax - (y + offsetY);
    }
  }, {
    key: 'left',
    get: function get() {
      var transform = this.props.transform;
      var viewport = this.unrotatedViewport,
          defaultSideways = this.defaultSideways;

      var _transform3 = (0, _slicedToArray3.default)(transform, 6),
          /* fontHeightPx */ /* fontWidthPx */ /* offsetX */x = _transform3[4],
          y = _transform3[5];

      var _viewport$viewBox2 = (0, _slicedToArray3.default)(viewport.viewBox, 1),
          xMin = _viewport$viewBox2[0];

      return defaultSideways ? y - xMin : x - xMin;
    }
  }]);
  return TextLayerItem;
}(_react.PureComponent);

exports.default = TextLayerItem;


TextLayerItem.contextTypes = {
  customTextRenderer: _propTypes2.default.func,
  page: _propTypes3.isPage.isRequired,
  rotate: _propTypes3.isRotate,
  scale: _propTypes2.default.number
};

TextLayerItem.propTypes = {
  fontName: _propTypes2.default.string.isRequired,
  itemIndex: _propTypes2.default.number.isRequired, // eslint-disable-line react/no-unused-prop-types
  str: _propTypes2.default.string.isRequired,
  transform: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
  width: _propTypes2.default.number.isRequired
};

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(129);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(110);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(130);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(131);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(132);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(133);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(134);

var _propTypes3 = __webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnnotationLayer = function (_Component) {
  (0, _inherits3.default)(AnnotationLayer, _Component);

  function AnnotationLayer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AnnotationLayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AnnotationLayer.__proto__ || (0, _getPrototypeOf2.default)(AnnotationLayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      annotations: null
    }, _this.onGetAnnotationsSuccess = function (annotations) {
      (0, _utils.callIfDefined)(_this.context.onGetAnnotationsSuccess, annotations);

      _this.setState({ annotations: annotations });
    }, _this.onGetAnnotationsError = function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      (0, _utils.errorOnDev)(error.message, error);

      (0, _utils.callIfDefined)(_this.context.onGetAnnotationsError, error);

      _this.setState({ annotations: false });
    }, _this.onRenderSuccess = function () {
      (0, _utils.callIfDefined)(_this.context.onRenderAnnotationsSuccess);
    }, _this.onRenderError = function (error) {
      if (error.name === 'RenderingCancelledException' || error.name === 'PromiseCancelledException') {
        return;
      }

      (0, _utils.errorOnDev)(error.message, error);

      (0, _utils.callIfDefined)(_this.context.onRenderError, error);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AnnotationLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getAnnotations();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (nextContext.page !== this.context.page) {
        if (this.state.annotations !== null) {
          this.setState({ annotations: null });
        }

        this.getAnnotations(nextContext);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _utils.cancelRunningTask)(this.runningTask);
    }

    /**
     * Called when a annotations fails to render.
     */

  }, {
    key: 'getAnnotations',
    value: function getAnnotations() {
      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
      var page = context.page;


      if (!page) {
        throw new Error('Attempted to load page annotations, but no page was specified.');
      }

      this.runningTask = (0, _utils.makeCancellable)(page.getAnnotations());

      return this.runningTask.promise.then(this.onGetAnnotationsSuccess).catch(this.onGetAnnotationsError);
    }
  }, {
    key: 'renderAnnotations',
    value: function renderAnnotations() {
      var annotations = this.state.annotations;


      if (!annotations) {
        return;
      }

      var _context = this.context,
          linkService = _context.linkService,
          page = _context.page;

      var viewport = this.viewport.clone({ dontFlip: true });

      var parameters = {
        annotations: annotations,
        div: this.annotationLayer,
        linkService: linkService,
        page: page,
        viewport: viewport
      };

      this.annotationLayer.innerHTML = '';

      try {
        PDFJS.AnnotationLayer.render(parameters);
        this.onRenderSuccess();
      } catch (error) {
        this.onRenderError(error);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          className: 'react-pdf__Page__annotations annotationLayer',
          ref: function ref(_ref2) {
            _this2.annotationLayer = _ref2;
          }
        },
        this.renderAnnotations()
      );
    }
  }, {
    key: 'viewport',
    get: function get() {
      var _context2 = this.context,
          page = _context2.page,
          rotate = _context2.rotate,
          scale = _context2.scale;


      return page.getViewport(scale, rotate);
    }
  }]);
  return AnnotationLayer;
}(_react.Component);

exports.default = AnnotationLayer;


AnnotationLayer.contextTypes = {
  linkService: _propTypes3.isLinkService,
  onGetAnnotationsError: _propTypes2.default.func,
  onGetAnnotationsSuccess: _propTypes2.default.func,
  onRenderAnnotationsError: _propTypes2.default.func,
  onRenderAnnotationsSuccess: _propTypes2.default.func,
  page: _propTypes3.isPage,
  rotate: _propTypes3.isRotate,
  scale: _propTypes2.default.number
};

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(2493);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allowedProperties = ['cMapUrl', 'cMapPacked', 'disableWorker', 'workerSrc', 'workerPort'];

var makeSetOptions = function makeSetOptions(pdfjs) {
  return function (options) {
    if (!(options instanceof Object)) {
      return;
    }

    /* eslint-disable no-param-reassign */
    (0, _keys2.default)(options).filter(function (property) {
      return allowedProperties.includes(property);
    }).forEach(function (property) {
      pdfjs.PDFJS[property] = options[property];
    });
  };
};

exports.default = makeSetOptions;

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2494), __esModule: true };

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2495);
module.exports = __webpack_require__(70).Object.keys;


/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(285);
var $keys = __webpack_require__(282);

__webpack_require__(1014)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process, Buffer) {/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2017 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/build/pdf", [], factory);
	else if(typeof exports === 'object')
		exports["pdfjs-dist/build/pdf"] = factory();
	else
		root["pdfjs-dist/build/pdf"] = root.pdfjsDistBuildPdf = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __w_pdfjs_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__w_pdfjs_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__w_pdfjs_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__w_pdfjs_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__w_pdfjs_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 63);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isSpace = exports.isString = exports.isNum = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.info = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__w_pdfjs_require__(64);

var _streams_polyfill = __w_pdfjs_require__(113);

var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
var NativeImageDecoding = {
  NONE: 'none',
  DECODE: 'decode',
  DISPLAY: 'display'
};
var TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
};
var ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
};
var AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
};
var AnnotationFlag = {
  INVISIBLE: 0x01,
  HIDDEN: 0x02,
  PRINT: 0x04,
  NOZOOM: 0x08,
  NOROTATE: 0x10,
  NOVIEW: 0x20,
  READONLY: 0x40,
  LOCKED: 0x80,
  TOGGLENOVIEW: 0x100,
  LOCKEDCONTENTS: 0x200
};
var AnnotationFieldFlag = {
  READONLY: 0x0000001,
  REQUIRED: 0x0000002,
  NOEXPORT: 0x0000004,
  MULTILINE: 0x0001000,
  PASSWORD: 0x0002000,
  NOTOGGLETOOFF: 0x0004000,
  RADIO: 0x0008000,
  PUSHBUTTON: 0x0010000,
  COMBO: 0x0020000,
  EDIT: 0x0040000,
  SORT: 0x0080000,
  FILESELECT: 0x0100000,
  MULTISELECT: 0x0200000,
  DONOTSPELLCHECK: 0x0400000,
  DONOTSCROLL: 0x0800000,
  COMB: 0x1000000,
  RICHTEXT: 0x2000000,
  RADIOSINUNISON: 0x2000000,
  COMMITONSELCHANGE: 0x4000000
};
var AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
};
var StreamType = {
  UNKNOWN: 0,
  FLATE: 1,
  LZW: 2,
  DCT: 3,
  JPX: 4,
  JBIG: 5,
  A85: 6,
  AHX: 7,
  CCF: 8,
  RL: 9
};
var FontType = {
  UNKNOWN: 0,
  TYPE1: 1,
  TYPE1C: 2,
  CIDFONTTYPE0: 3,
  CIDFONTTYPE0C: 4,
  TRUETYPE: 5,
  CIDFONTTYPE2: 6,
  TYPE3: 7,
  OPENTYPE: 8,
  TYPE0: 9,
  MMTYPE1: 10
};
var VERBOSITY_LEVELS = {
  errors: 0,
  warnings: 1,
  infos: 5
};
var CMapCompressionType = {
  NONE: 0,
  BINARY: 1,
  STREAM: 2
};
var OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotations: 78,
  endAnnotations: 79,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintJpegXObject: 82,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91
};
var verbosity = VERBOSITY_LEVELS.warnings;
function setVerbosityLevel(level) {
  verbosity = level;
}
function getVerbosityLevel() {
  return verbosity;
}
function info(msg) {
  if (verbosity >= VERBOSITY_LEVELS.infos) {
    console.log('Info: ' + msg);
  }
}
function warn(msg) {
  if (verbosity >= VERBOSITY_LEVELS.warnings) {
    console.log('Warning: ' + msg);
  }
}
function deprecated(details) {
  console.log('Deprecated API usage: ' + details);
}
function unreachable(msg) {
  throw new Error(msg);
}
function assert(cond, msg) {
  if (!cond) {
    unreachable(msg);
  }
}
var UNSUPPORTED_FEATURES = {
  unknown: 'unknown',
  forms: 'forms',
  javaScript: 'javaScript',
  smask: 'smask',
  shadingPattern: 'shadingPattern',
  font: 'font'
};
function isSameOrigin(baseUrl, otherUrl) {
  try {
    var base = new URL(baseUrl);
    if (!base.origin || base.origin === 'null') {
      return false;
    }
  } catch (e) {
    return false;
  }
  var other = new URL(otherUrl, base);
  return base.origin === other.origin;
}
function isValidProtocol(url) {
  if (!url) {
    return false;
  }
  switch (url.protocol) {
    case 'http:':
    case 'https:':
    case 'ftp:':
    case 'mailto:':
    case 'tel:':
      return true;
    default:
      return false;
  }
}
function createValidAbsoluteUrl(url, baseUrl) {
  if (!url) {
    return null;
  }
  try {
    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
    if (isValidProtocol(absoluteUrl)) {
      return absoluteUrl;
    }
  } catch (ex) {}
  return null;
}
function shadow(obj, prop, value) {
  Object.defineProperty(obj, prop, {
    value: value,
    enumerable: true,
    configurable: true,
    writable: false
  });
  return value;
}
function getLookupTableFactory(initializer) {
  var lookup;
  return function () {
    if (initializer) {
      lookup = Object.create(null);
      initializer(lookup);
      initializer = null;
    }
    return lookup;
  };
}
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
var PasswordException = function PasswordExceptionClosure() {
  function PasswordException(msg, code) {
    this.name = 'PasswordException';
    this.message = msg;
    this.code = code;
  }
  PasswordException.prototype = new Error();
  PasswordException.constructor = PasswordException;
  return PasswordException;
}();
var UnknownErrorException = function UnknownErrorExceptionClosure() {
  function UnknownErrorException(msg, details) {
    this.name = 'UnknownErrorException';
    this.message = msg;
    this.details = details;
  }
  UnknownErrorException.prototype = new Error();
  UnknownErrorException.constructor = UnknownErrorException;
  return UnknownErrorException;
}();
var InvalidPDFException = function InvalidPDFExceptionClosure() {
  function InvalidPDFException(msg) {
    this.name = 'InvalidPDFException';
    this.message = msg;
  }
  InvalidPDFException.prototype = new Error();
  InvalidPDFException.constructor = InvalidPDFException;
  return InvalidPDFException;
}();
var MissingPDFException = function MissingPDFExceptionClosure() {
  function MissingPDFException(msg) {
    this.name = 'MissingPDFException';
    this.message = msg;
  }
  MissingPDFException.prototype = new Error();
  MissingPDFException.constructor = MissingPDFException;
  return MissingPDFException;
}();
var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
  function UnexpectedResponseException(msg, status) {
    this.name = 'UnexpectedResponseException';
    this.message = msg;
    this.status = status;
  }
  UnexpectedResponseException.prototype = new Error();
  UnexpectedResponseException.constructor = UnexpectedResponseException;
  return UnexpectedResponseException;
}();
var NotImplementedException = function NotImplementedExceptionClosure() {
  function NotImplementedException(msg) {
    this.message = msg;
  }
  NotImplementedException.prototype = new Error();
  NotImplementedException.prototype.name = 'NotImplementedException';
  NotImplementedException.constructor = NotImplementedException;
  return NotImplementedException;
}();
var MissingDataException = function MissingDataExceptionClosure() {
  function MissingDataException(begin, end) {
    this.begin = begin;
    this.end = end;
    this.message = 'Missing data [' + begin + ', ' + end + ')';
  }
  MissingDataException.prototype = new Error();
  MissingDataException.prototype.name = 'MissingDataException';
  MissingDataException.constructor = MissingDataException;
  return MissingDataException;
}();
var XRefParseException = function XRefParseExceptionClosure() {
  function XRefParseException(msg) {
    this.message = msg;
  }
  XRefParseException.prototype = new Error();
  XRefParseException.prototype.name = 'XRefParseException';
  XRefParseException.constructor = XRefParseException;
  return XRefParseException;
}();
var FormatError = function FormatErrorClosure() {
  function FormatError(msg) {
    this.message = msg;
  }
  FormatError.prototype = new Error();
  FormatError.prototype.name = 'FormatError';
  FormatError.constructor = FormatError;
  return FormatError;
}();
var AbortException = function AbortExceptionClosure() {
  function AbortException(msg) {
    this.name = 'AbortException';
    this.message = msg;
  }
  AbortException.prototype = new Error();
  AbortException.constructor = AbortException;
  return AbortException;
}();
var NullCharactersRegExp = /\x00/g;
function removeNullCharacters(str) {
  if (typeof str !== 'string') {
    warn('The argument for removeNullCharacters must be a string.');
    return str;
  }
  return str.replace(NullCharactersRegExp, '');
}
function bytesToString(bytes) {
  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
  var length = bytes.length;
  var MAX_ARGUMENT_COUNT = 8192;
  if (length < MAX_ARGUMENT_COUNT) {
    return String.fromCharCode.apply(null, bytes);
  }
  var strBuf = [];
  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
    var chunk = bytes.subarray(i, chunkEnd);
    strBuf.push(String.fromCharCode.apply(null, chunk));
  }
  return strBuf.join('');
}
function stringToBytes(str) {
  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
  var length = str.length;
  var bytes = new Uint8Array(length);
  for (var i = 0; i < length; ++i) {
    bytes[i] = str.charCodeAt(i) & 0xFF;
  }
  return bytes;
}
function arrayByteLength(arr) {
  if (arr.length !== undefined) {
    return arr.length;
  }
  assert(arr.byteLength !== undefined);
  return arr.byteLength;
}
function arraysToBytes(arr) {
  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
    return arr[0];
  }
  var resultLength = 0;
  var i,
      ii = arr.length;
  var item, itemLength;
  for (i = 0; i < ii; i++) {
    item = arr[i];
    itemLength = arrayByteLength(item);
    resultLength += itemLength;
  }
  var pos = 0;
  var data = new Uint8Array(resultLength);
  for (i = 0; i < ii; i++) {
    item = arr[i];
    if (!(item instanceof Uint8Array)) {
      if (typeof item === 'string') {
        item = stringToBytes(item);
      } else {
        item = new Uint8Array(item);
      }
    }
    itemLength = item.byteLength;
    data.set(item, pos);
    pos += itemLength;
  }
  return data;
}
function string32(value) {
  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function log2(x) {
  if (x <= 0) {
    return 0;
  }
  return Math.ceil(Math.log2(x));
}
function readInt8(data, start) {
  return data[start] << 24 >> 24;
}
function readUint16(data, offset) {
  return data[offset] << 8 | data[offset + 1];
}
function readUint32(data, offset) {
  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
}
function isLittleEndian() {
  var buffer8 = new Uint8Array(4);
  buffer8[0] = 1;
  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
  return view32[0] === 1;
}
function isEvalSupported() {
  try {
    new Function('');
    return true;
  } catch (e) {
    return false;
  }
}
var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
var Util = function UtilClosure() {
  function Util() {}
  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
    rgbBuf[1] = r;
    rgbBuf[3] = g;
    rgbBuf[5] = b;
    return rgbBuf.join('');
  };
  Util.transform = function Util_transform(m1, m2) {
    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
  };
  Util.applyTransform = function Util_applyTransform(p, m) {
    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
    return [xt, yt];
  };
  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
    var d = m[0] * m[3] - m[1] * m[2];
    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    return [xt, yt];
  };
  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
    var p1 = Util.applyTransform(r, m);
    var p2 = Util.applyTransform(r.slice(2, 4), m);
    var p3 = Util.applyTransform([r[0], r[3]], m);
    var p4 = Util.applyTransform([r[2], r[1]], m);
    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
  };
  Util.inverseTransform = function Util_inverseTransform(m) {
    var d = m[0] * m[3] - m[1] * m[2];
    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
  };
  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
  };
  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
    var transpose = [m[0], m[2], m[1], m[3]];
    var a = m[0] * transpose[0] + m[1] * transpose[2];
    var b = m[0] * transpose[1] + m[1] * transpose[3];
    var c = m[2] * transpose[0] + m[3] * transpose[2];
    var d = m[2] * transpose[1] + m[3] * transpose[3];
    var first = (a + d) / 2;
    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
    var sx = first + second || 1;
    var sy = first - second || 1;
    return [Math.sqrt(sx), Math.sqrt(sy)];
  };
  Util.normalizeRect = function Util_normalizeRect(rect) {
    var r = rect.slice(0);
    if (rect[0] > rect[2]) {
      r[0] = rect[2];
      r[2] = rect[0];
    }
    if (rect[1] > rect[3]) {
      r[1] = rect[3];
      r[3] = rect[1];
    }
    return r;
  };
  Util.intersect = function Util_intersect(rect1, rect2) {
    function compare(a, b) {
      return a - b;
    }
    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
        result = [];
    rect1 = Util.normalizeRect(rect1);
    rect2 = Util.normalizeRect(rect2);
    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
      result[0] = orderedX[1];
      result[2] = orderedX[2];
    } else {
      return false;
    }
    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
      result[1] = orderedY[1];
      result[3] = orderedY[2];
    } else {
      return false;
    }
    return result;
  };
  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
  Util.toRoman = function Util_toRoman(number, lowerCase) {
    assert(Number.isInteger(number) && number > 0, 'The number should be a positive integer.');
    var pos,
        romanBuf = [];
    while (number >= 1000) {
      number -= 1000;
      romanBuf.push('M');
    }
    pos = number / 100 | 0;
    number %= 100;
    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
    pos = number / 10 | 0;
    number %= 10;
    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
    var romanStr = romanBuf.join('');
    return lowerCase ? romanStr.toLowerCase() : romanStr;
  };
  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
    Array.prototype.push.apply(arr1, arr2);
  };
  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
    Array.prototype.unshift.apply(arr1, arr2);
  };
  Util.extendObj = function extendObj(obj1, obj2) {
    for (var key in obj2) {
      obj1[key] = obj2[key];
    }
  };
  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
    while (dict && !dict.has(name)) {
      dict = dict.get('Parent');
    }
    if (!dict) {
      return null;
    }
    return getArray ? dict.getArray(name) : dict.get(name);
  };
  Util.inherit = function Util_inherit(sub, base, prototype) {
    sub.prototype = Object.create(base.prototype);
    sub.prototype.constructor = sub;
    for (var prop in prototype) {
      sub.prototype[prop] = prototype[prop];
    }
  };
  Util.loadScript = function Util_loadScript(src, callback) {
    var script = document.createElement('script');
    var loaded = false;
    script.setAttribute('src', src);
    if (callback) {
      script.onload = function () {
        if (!loaded) {
          callback();
        }
        loaded = true;
      };
    }
    document.getElementsByTagName('head')[0].appendChild(script);
  };
  return Util;
}();
var PageViewport = function PageViewportClosure() {
  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
    this.viewBox = viewBox;
    this.scale = scale;
    this.rotation = rotation;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    var centerX = (viewBox[2] + viewBox[0]) / 2;
    var centerY = (viewBox[3] + viewBox[1]) / 2;
    var rotateA, rotateB, rotateC, rotateD;
    rotation = rotation % 360;
    rotation = rotation < 0 ? rotation + 360 : rotation;
    switch (rotation) {
      case 180:
        rotateA = -1;
        rotateB = 0;
        rotateC = 0;
        rotateD = 1;
        break;
      case 90:
        rotateA = 0;
        rotateB = 1;
        rotateC = 1;
        rotateD = 0;
        break;
      case 270:
        rotateA = 0;
        rotateB = -1;
        rotateC = -1;
        rotateD = 0;
        break;
      default:
        rotateA = 1;
        rotateB = 0;
        rotateC = 0;
        rotateD = -1;
        break;
    }
    if (dontFlip) {
      rotateC = -rotateC;
      rotateD = -rotateD;
    }
    var offsetCanvasX, offsetCanvasY;
    var width, height;
    if (rotateA === 0) {
      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
    } else {
      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
    }
    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
    this.width = width;
    this.height = height;
    this.fontScale = scale;
  }
  PageViewport.prototype = {
    clone: function PageViewPort_clone(args) {
      args = args || {};
      var scale = 'scale' in args ? args.scale : this.scale;
      var rotation = 'rotation' in args ? args.rotation : this.rotation;
      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
    },
    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
      return Util.applyTransform([x, y], this.transform);
    },
    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
      return [tl[0], tl[1], br[0], br[1]];
    },
    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
      return Util.applyInverseTransform([x, y], this.transform);
    }
  };
  return PageViewport;
}();
var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
function stringToPDFString(str) {
  var i,
      n = str.length,
      strBuf = [];
  if (str[0] === '\xFE' && str[1] === '\xFF') {
    for (i = 2; i < n; i += 2) {
      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
    }
  } else {
    for (i = 0; i < n; ++i) {
      var code = PDFStringTranslateTable[str.charCodeAt(i)];
      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
  }
  return strBuf.join('');
}
function stringToUTF8String(str) {
  return decodeURIComponent(escape(str));
}
function utf8StringToString(str) {
  return unescape(encodeURIComponent(str));
}
function isEmptyObj(obj) {
  for (var key in obj) {
    return false;
  }
  return true;
}
function isBool(v) {
  return typeof v === 'boolean';
}
function isNum(v) {
  return typeof v === 'number';
}
function isString(v) {
  return typeof v === 'string';
}
function isArrayBuffer(v) {
  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
}
function isSpace(ch) {
  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
}
function createPromiseCapability() {
  var capability = {};
  capability.promise = new Promise(function (resolve, reject) {
    capability.resolve = resolve;
    capability.reject = reject;
  });
  return capability;
}
var createBlob = function createBlob(data, contentType) {
  if (typeof Blob !== 'undefined') {
    return new Blob([data], { type: contentType });
  }
  throw new Error('The "Blob" constructor is not supported.');
};
var createObjectURL = function createObjectURLClosure() {
  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  return function createObjectURL(data, contentType) {
    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!forceDataSchema && URL.createObjectURL) {
      var blob = createBlob(data, contentType);
      return URL.createObjectURL(blob);
    }
    var buffer = 'data:' + contentType + ';base64,';
    for (var i = 0, ii = data.length; i < ii; i += 3) {
      var b1 = data[i] & 0xFF;
      var b2 = data[i + 1] & 0xFF;
      var b3 = data[i + 2] & 0xFF;
      var d1 = b1 >> 2,
          d2 = (b1 & 3) << 4 | b2 >> 4;
      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
    }
    return buffer;
  };
}();
function resolveCall(fn, args) {
  var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!fn) {
    return Promise.resolve(undefined);
  }
  return new Promise(function (resolve, reject) {
    resolve(fn.apply(thisArg, args));
  });
}
function wrapReason(reason) {
  if ((typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object') {
    return reason;
  }
  switch (reason.name) {
    case 'AbortException':
      return new AbortException(reason.message);
    case 'MissingPDFException':
      return new MissingPDFException(reason.message);
    case 'UnexpectedResponseException':
      return new UnexpectedResponseException(reason.message, reason.status);
    default:
      return new UnknownErrorException(reason.message, reason.details);
  }
}
function makeReasonSerializable(reason) {
  if (!(reason instanceof Error) || reason instanceof AbortException || reason instanceof MissingPDFException || reason instanceof UnexpectedResponseException || reason instanceof UnknownErrorException) {
    return reason;
  }
  return new UnknownErrorException(reason.message, reason.toString());
}
function resolveOrReject(capability, success, reason) {
  if (success) {
    capability.resolve();
  } else {
    capability.reject(reason);
  }
}
function finalize(promise) {
  return Promise.resolve(promise).catch(function () {});
}
function MessageHandler(sourceName, targetName, comObj) {
  var _this = this;

  this.sourceName = sourceName;
  this.targetName = targetName;
  this.comObj = comObj;
  this.callbackId = 1;
  this.streamId = 1;
  this.postMessageTransfers = true;
  this.streamSinks = Object.create(null);
  this.streamControllers = Object.create(null);
  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
  var ah = this.actionHandler = Object.create(null);
  this._onComObjOnMessage = function (event) {
    var data = event.data;
    if (data.targetName !== _this.sourceName) {
      return;
    }
    if (data.stream) {
      _this._processStreamMessage(data);
    } else if (data.isReply) {
      var callbackId = data.callbackId;
      if (data.callbackId in callbacksCapabilities) {
        var callback = callbacksCapabilities[callbackId];
        delete callbacksCapabilities[callbackId];
        if ('error' in data) {
          callback.reject(wrapReason(data.error));
        } else {
          callback.resolve(data.data);
        }
      } else {
        throw new Error('Cannot resolve callback ' + callbackId);
      }
    } else if (data.action in ah) {
      var action = ah[data.action];
      if (data.callbackId) {
        var _sourceName = _this.sourceName;
        var _targetName = data.sourceName;
        Promise.resolve().then(function () {
          return action[0].call(action[1], data.data);
        }).then(function (result) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            data: result
          });
        }, function (reason) {
          comObj.postMessage({
            sourceName: _sourceName,
            targetName: _targetName,
            isReply: true,
            callbackId: data.callbackId,
            error: makeReasonSerializable(reason)
          });
        });
      } else if (data.streamId) {
        _this._createStreamSink(data);
      } else {
        action[0].call(action[1], data.data);
      }
    } else {
      throw new Error('Unknown action from worker: ' + data.action);
    }
  };
  comObj.addEventListener('message', this._onComObjOnMessage);
}
MessageHandler.prototype = {
  on: function on(actionName, handler, scope) {
    var ah = this.actionHandler;
    if (ah[actionName]) {
      throw new Error('There is already an actionName called "' + actionName + '"');
    }
    ah[actionName] = [handler, scope];
  },
  send: function send(actionName, data, transfers) {
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data
    };
    this.postMessage(message, transfers);
  },
  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
    var callbackId = this.callbackId++;
    var message = {
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data: data,
      callbackId: callbackId
    };
    var capability = createPromiseCapability();
    this.callbacksCapabilities[callbackId] = capability;
    try {
      this.postMessage(message, transfers);
    } catch (e) {
      capability.reject(e);
    }
    return capability.promise;
  },
  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
    var _this2 = this;

    var streamId = this.streamId++;
    var sourceName = this.sourceName;
    var targetName = this.targetName;
    return new _streams_polyfill.ReadableStream({
      start: function start(controller) {
        var startCapability = createPromiseCapability();
        _this2.streamControllers[streamId] = {
          controller: controller,
          startCall: startCapability,
          isClosed: false
        };
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          action: actionName,
          streamId: streamId,
          data: data,
          desiredSize: controller.desiredSize
        });
        return startCapability.promise;
      },
      pull: function pull(controller) {
        var pullCapability = createPromiseCapability();
        _this2.streamControllers[streamId].pullCall = pullCapability;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'pull',
          streamId: streamId,
          desiredSize: controller.desiredSize
        });
        return pullCapability.promise;
      },
      cancel: function cancel(reason) {
        var cancelCapability = createPromiseCapability();
        _this2.streamControllers[streamId].cancelCall = cancelCapability;
        _this2.streamControllers[streamId].isClosed = true;
        _this2.postMessage({
          sourceName: sourceName,
          targetName: targetName,
          stream: 'cancel',
          reason: reason,
          streamId: streamId
        });
        return cancelCapability.promise;
      }
    }, queueingStrategy);
  },
  _createStreamSink: function _createStreamSink(data) {
    var _this3 = this;

    var self = this;
    var action = this.actionHandler[data.action];
    var streamId = data.streamId;
    var desiredSize = data.desiredSize;
    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var capability = createPromiseCapability();
    var sendStreamRequest = function sendStreamRequest(_ref) {
      var stream = _ref.stream,
          chunk = _ref.chunk,
          transfers = _ref.transfers,
          success = _ref.success,
          reason = _ref.reason;

      _this3.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        streamId: streamId,
        chunk: chunk,
        success: success,
        reason: reason
      }, transfers);
    };
    var streamSink = {
      enqueue: function enqueue(chunk) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var transfers = arguments[2];

        if (this.isCancelled) {
          return;
        }
        var lastDesiredSize = this.desiredSize;
        this.desiredSize -= size;
        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
          this.sinkCapability = createPromiseCapability();
          this.ready = this.sinkCapability.promise;
        }
        sendStreamRequest({
          stream: 'enqueue',
          chunk: chunk,
          transfers: transfers
        });
      },
      close: function close() {
        if (this.isCancelled) {
          return;
        }
        this.isCancelled = true;
        sendStreamRequest({ stream: 'close' });
        delete self.streamSinks[streamId];
      },
      error: function error(reason) {
        if (this.isCancelled) {
          return;
        }
        this.isCancelled = true;
        sendStreamRequest({
          stream: 'error',
          reason: reason
        });
      },

      sinkCapability: capability,
      onPull: null,
      onCancel: null,
      isCancelled: false,
      desiredSize: desiredSize,
      ready: null
    };
    streamSink.sinkCapability.resolve();
    streamSink.ready = streamSink.sinkCapability.promise;
    this.streamSinks[streamId] = streamSink;
    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
      sendStreamRequest({
        stream: 'start_complete',
        success: true
      });
    }, function (reason) {
      sendStreamRequest({
        stream: 'start_complete',
        success: false,
        reason: reason
      });
    });
  },
  _processStreamMessage: function _processStreamMessage(data) {
    var _this4 = this;

    var sourceName = this.sourceName;
    var targetName = data.sourceName;
    var streamId = data.streamId;
    var sendStreamResponse = function sendStreamResponse(_ref2) {
      var stream = _ref2.stream,
          success = _ref2.success,
          reason = _ref2.reason;

      _this4.comObj.postMessage({
        sourceName: sourceName,
        targetName: targetName,
        stream: stream,
        success: success,
        streamId: streamId,
        reason: reason
      });
    };
    var deleteStreamController = function deleteStreamController() {
      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
        return capability && finalize(capability.promise);
      })).then(function () {
        delete _this4.streamControllers[data.streamId];
      });
    };
    switch (data.stream) {
      case 'start_complete':
        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
        break;
      case 'pull_complete':
        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
        break;
      case 'pull':
        if (!this.streamSinks[data.streamId]) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
          break;
        }
        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
          this.streamSinks[data.streamId].sinkCapability.resolve();
        }
        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
          sendStreamResponse({
            stream: 'pull_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'pull_complete',
            success: false,
            reason: reason
          });
        });
        break;
      case 'enqueue':
        assert(this.streamControllers[data.streamId], 'enqueue should have stream controller');
        if (!this.streamControllers[data.streamId].isClosed) {
          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
        }
        break;
      case 'close':
        assert(this.streamControllers[data.streamId], 'close should have stream controller');
        if (this.streamControllers[data.streamId].isClosed) {
          break;
        }
        this.streamControllers[data.streamId].isClosed = true;
        this.streamControllers[data.streamId].controller.close();
        deleteStreamController();
        break;
      case 'error':
        assert(this.streamControllers[data.streamId], 'error should have stream controller');
        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
        deleteStreamController();
        break;
      case 'cancel_complete':
        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
        deleteStreamController();
        break;
      case 'cancel':
        if (!this.streamSinks[data.streamId]) {
          break;
        }
        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: true
          });
        }, function (reason) {
          sendStreamResponse({
            stream: 'cancel_complete',
            success: false,
            reason: reason
          });
        });
        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
        this.streamSinks[data.streamId].isCancelled = true;
        delete this.streamSinks[data.streamId];
        break;
      default:
        throw new Error('Unexpected stream case');
    }
  },
  postMessage: function postMessage(message, transfers) {
    if (transfers && this.postMessageTransfers) {
      this.comObj.postMessage(message, transfers);
    } else {
      this.comObj.postMessage(message);
    }
  },
  destroy: function destroy() {
    this.comObj.removeEventListener('message', this._onComObjOnMessage);
  }
};
function loadJpegStream(id, imageUrl, objs) {
  var img = new Image();
  img.onload = function loadJpegStream_onloadClosure() {
    objs.resolve(id, img);
  };
  img.onerror = function loadJpegStream_onerrorClosure() {
    objs.resolve(id, null);
    warn('Error during JPEG image loading');
  };
  img.src = imageUrl;
}
exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
exports.OPS = OPS;
exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
exports.AnnotationFieldFlag = AnnotationFieldFlag;
exports.AnnotationFlag = AnnotationFlag;
exports.AnnotationType = AnnotationType;
exports.FontType = FontType;
exports.ImageKind = ImageKind;
exports.CMapCompressionType = CMapCompressionType;
exports.AbortException = AbortException;
exports.InvalidPDFException = InvalidPDFException;
exports.MessageHandler = MessageHandler;
exports.MissingDataException = MissingDataException;
exports.MissingPDFException = MissingPDFException;
exports.NativeImageDecoding = NativeImageDecoding;
exports.NotImplementedException = NotImplementedException;
exports.PageViewport = PageViewport;
exports.PasswordException = PasswordException;
exports.PasswordResponses = PasswordResponses;
exports.StreamType = StreamType;
exports.TextRenderingMode = TextRenderingMode;
exports.UnexpectedResponseException = UnexpectedResponseException;
exports.UnknownErrorException = UnknownErrorException;
exports.Util = Util;
exports.XRefParseException = XRefParseException;
exports.FormatError = FormatError;
exports.arrayByteLength = arrayByteLength;
exports.arraysToBytes = arraysToBytes;
exports.assert = assert;
exports.bytesToString = bytesToString;
exports.createBlob = createBlob;
exports.createPromiseCapability = createPromiseCapability;
exports.createObjectURL = createObjectURL;
exports.deprecated = deprecated;
exports.getLookupTableFactory = getLookupTableFactory;
exports.getVerbosityLevel = getVerbosityLevel;
exports.info = info;
exports.isArrayBuffer = isArrayBuffer;
exports.isBool = isBool;
exports.isEmptyObj = isEmptyObj;
exports.isNum = isNum;
exports.isString = isString;
exports.isSpace = isSpace;
exports.isSameOrigin = isSameOrigin;
exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
exports.isLittleEndian = isLittleEndian;
exports.isEvalSupported = isEvalSupported;
exports.loadJpegStream = loadJpegStream;
exports.log2 = log2;
exports.readInt8 = readInt8;
exports.readUint16 = readUint16;
exports.readUint32 = readUint32;
exports.removeNullCharacters = removeNullCharacters;
exports.ReadableStream = _streams_polyfill.ReadableStream;
exports.setVerbosityLevel = setVerbosityLevel;
exports.shadow = shadow;
exports.string32 = string32;
exports.stringToBytes = stringToBytes;
exports.stringToPDFString = stringToPDFString;
exports.stringToUTF8String = stringToUTF8String;
exports.utf8StringToString = utf8StringToString;
exports.warn = warn;
exports.unreachable = unreachable;

/***/ }),
/* 1 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var store = __w_pdfjs_require__(44)('wks');
var uid = __w_pdfjs_require__(20);
var _Symbol = __w_pdfjs_require__(3).Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';
var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};
$exports.store = store;

/***/ }),
/* 3 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = global;

/***/ }),
/* 4 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(3);
var core = __w_pdfjs_require__(5);
var hide = __w_pdfjs_require__(11);
var redefine = __w_pdfjs_require__(8);
var ctx = __w_pdfjs_require__(9);
var PROTOTYPE = 'prototype';
var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    own = !IS_FORCED && target && target[key] !== undefined;
    out = (own ? target : source)[key];
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    if (target) redefine(target, key, out, type & $export.U);
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
$export.F = 1;
$export.G = 2;
$export.S = 4;
$export.P = 8;
$export.B = 16;
$export.W = 32;
$export.U = 64;
$export.R = 128;
module.exports = $export;

/***/ }),
/* 5 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core;

/***/ }),
/* 6 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(1);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(3);
var hide = __w_pdfjs_require__(11);
var has = __w_pdfjs_require__(7);
var SRC = __w_pdfjs_require__(20)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);
__w_pdfjs_require__(5).inspectSource = function (it) {
  return $toString.call(it);
};
(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var aFunction = __w_pdfjs_require__(16);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () {
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DummyStatTimer = exports.StatTimer = exports.SimpleXMLParser = exports.DOMSVGFactory = exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(0);

var _global_scope = __w_pdfjs_require__(14);

var _global_scope2 = _interopRequireDefault(_global_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
var SVG_NS = 'http://www.w3.org/2000/svg';

var DOMCanvasFactory = function () {
  function DOMCanvasFactory() {
    _classCallCheck(this, DOMCanvasFactory);
  }

  _createClass(DOMCanvasFactory, [{
    key: 'create',
    value: function create(width, height) {
      if (width <= 0 || height <= 0) {
        throw new Error('invalid canvas size');
      }
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      return {
        canvas: canvas,
        context: context
      };
    }
  }, {
    key: 'reset',
    value: function reset(canvasAndContext, width, height) {
      if (!canvasAndContext.canvas) {
        throw new Error('canvas is not specified');
      }
      if (width <= 0 || height <= 0) {
        throw new Error('invalid canvas size');
      }
      canvasAndContext.canvas.width = width;
      canvasAndContext.canvas.height = height;
    }
  }, {
    key: 'destroy',
    value: function destroy(canvasAndContext) {
      if (!canvasAndContext.canvas) {
        throw new Error('canvas is not specified');
      }
      canvasAndContext.canvas.width = 0;
      canvasAndContext.canvas.height = 0;
      canvasAndContext.canvas = null;
      canvasAndContext.context = null;
    }
  }]);

  return DOMCanvasFactory;
}();

var DOMCMapReaderFactory = function () {
  function DOMCMapReaderFactory(_ref) {
    var _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
        _ref$isCompressed = _ref.isCompressed,
        isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;

    _classCallCheck(this, DOMCMapReaderFactory);

    this.baseUrl = baseUrl;
    this.isCompressed = isCompressed;
  }

  _createClass(DOMCMapReaderFactory, [{
    key: 'fetch',
    value: function fetch(_ref2) {
      var _this = this;

      var name = _ref2.name;

      if (!this.baseUrl) {
        return Promise.reject(new Error('CMap baseUrl must be specified, ' + 'see "PDFJS.cMapUrl" (and also "PDFJS.cMapPacked").'));
      }
      if (!name) {
        return Promise.reject(new Error('CMap name must be specified.'));
      }
      return new Promise(function (resolve, reject) {
        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        if (_this.isCompressed) {
          request.responseType = 'arraybuffer';
        }
        request.onreadystatechange = function () {
          if (request.readyState !== XMLHttpRequest.DONE) {
            return;
          }
          if (request.status === 200 || request.status === 0) {
            var data = void 0;
            if (_this.isCompressed && request.response) {
              data = new Uint8Array(request.response);
            } else if (!_this.isCompressed && request.responseText) {
              data = (0, _util.stringToBytes)(request.responseText);
            }
            if (data) {
              resolve({
                cMapData: data,
                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
              });
              return;
            }
          }
          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
        };
        request.send(null);
      });
    }
  }]);

  return DOMCMapReaderFactory;
}();

var DOMSVGFactory = function () {
  function DOMSVGFactory() {
    _classCallCheck(this, DOMSVGFactory);
  }

  _createClass(DOMSVGFactory, [{
    key: 'create',
    value: function create(width, height) {
      (0, _util.assert)(width > 0 && height > 0, 'Invalid SVG dimensions');
      var svg = document.createElementNS(SVG_NS, 'svg:svg');
      svg.setAttribute('version', '1.1');
      svg.setAttribute('width', width + 'px');
      svg.setAttribute('height', height + 'px');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
      return svg;
    }
  }, {
    key: 'createElement',
    value: function createElement(type) {
      (0, _util.assert)(typeof type === 'string', 'Invalid SVG element type');
      return document.createElementNS(SVG_NS, type);
    }
  }]);

  return DOMSVGFactory;
}();

var SimpleDOMNode = function () {
  function SimpleDOMNode(nodeName, nodeValue) {
    _classCallCheck(this, SimpleDOMNode);

    this.nodeName = nodeName;
    this.nodeValue = nodeValue;
    Object.defineProperty(this, 'parentNode', {
      value: null,
      writable: true
    });
  }

  _createClass(SimpleDOMNode, [{
    key: 'hasChildNodes',
    value: function hasChildNodes() {
      return this.childNodes && this.childNodes.length > 0;
    }
  }, {
    key: 'firstChild',
    get: function get() {
      return this.childNodes[0];
    }
  }, {
    key: 'nextSibling',
    get: function get() {
      var index = this.parentNode.childNodes.indexOf(this);
      return this.parentNode.childNodes[index + 1];
    }
  }, {
    key: 'textContent',
    get: function get() {
      if (!this.childNodes) {
        return this.nodeValue || '';
      }
      return this.childNodes.map(function (child) {
        return child.textContent;
      }).join('');
    }
  }]);

  return SimpleDOMNode;
}();

var SimpleXMLParser = function () {
  function SimpleXMLParser() {
    _classCallCheck(this, SimpleXMLParser);
  }

  _createClass(SimpleXMLParser, [{
    key: 'parseFromString',
    value: function parseFromString(data) {
      var _this2 = this;

      var nodes = [];
      data = data.replace(/<\?[\s\S]*?\?>|<!--[\s\S]*?-->/g, '').trim();
      data = data.replace(/<!DOCTYPE[^>\[]+(\[[^\]]+)?[^>]+>/g, '').trim();
      data = data.replace(/>([^<][\s\S]*?)</g, function (all, text) {
        var length = nodes.length;
        var node = new SimpleDOMNode('#text', _this2._decodeXML(text));
        nodes.push(node);
        if (node.textContent.trim().length === 0) {
          return '><';
        }
        return '>' + length + ',<';
      });
      data = data.replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, function (all, text) {
        var length = nodes.length;
        var node = new SimpleDOMNode('#text', text);
        nodes.push(node);
        return length + ',';
      });
      var regex = /<([\w\:]+)((?:[\s\w:=]|'[^']*'|"[^"]*")*)(?:\/>|>([\d,]*)<\/[^>]+>)/g;
      var lastLength = void 0;
      do {
        lastLength = nodes.length;
        data = data.replace(regex, function (all, name, attrs, data) {
          var length = nodes.length;
          var node = new SimpleDOMNode(name);
          var children = [];
          if (data) {
            data = data.split(',');
            data.pop();
            data.forEach(function (child) {
              var childNode = nodes[+child];
              childNode.parentNode = node;
              children.push(childNode);
            });
          }
          node.childNodes = children;
          nodes.push(node);
          return length + ',';
        });
      } while (lastLength < nodes.length);
      return { documentElement: nodes.pop() };
    }
  }, {
    key: '_decodeXML',
    value: function _decodeXML(text) {
      if (text.indexOf('&') < 0) {
        return text;
      }
      return text.replace(/&(#(x[0-9a-f]+|\d+)|\w+);/gi, function (all, entityName, number) {
        if (number) {
          if (number[0] === 'x') {
            number = parseInt(number.substring(1), 16);
          } else {
            number = +number;
          }
          return String.fromCharCode(number);
        }
        switch (entityName) {
          case 'amp':
            return '&';
          case 'lt':
            return '<';
          case 'gt':
            return '>';
          case 'quot':
            return '\"';
          case 'apos':
            return '\'';
        }
        return '&' + entityName + ';';
      });
    }
  }]);

  return SimpleXMLParser;
}();

var RenderingCancelledException = function RenderingCancelledException() {
  function RenderingCancelledException(msg, type) {
    this.message = msg;
    this.type = type;
  }
  RenderingCancelledException.prototype = new Error();
  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
  RenderingCancelledException.constructor = RenderingCancelledException;
  return RenderingCancelledException;
}();
var LinkTarget = {
  NONE: 0,
  SELF: 1,
  BLANK: 2,
  PARENT: 3,
  TOP: 4
};
var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
function addLinkAttributes(link, params) {
  var url = params && params.url;
  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
  if (url) {
    var target = params.target;
    if (typeof target === 'undefined') {
      target = getDefaultSetting('externalLinkTarget');
    }
    link.target = LinkTargetStringMap[target];
    var rel = params.rel;
    if (typeof rel === 'undefined') {
      rel = getDefaultSetting('externalLinkRel');
    }
    link.rel = rel;
  }
}
function getFilenameFromUrl(url) {
  var anchor = url.indexOf('#');
  var query = url.indexOf('?');
  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
  return url.substring(url.lastIndexOf('/', end) + 1, end);
}
function getDefaultSetting(id) {
  var globalSettings = _global_scope2.default.PDFJS;
  switch (id) {
    case 'pdfBug':
      return globalSettings ? globalSettings.pdfBug : false;
    case 'disableAutoFetch':
      return globalSettings ? globalSettings.disableAutoFetch : false;
    case 'disableStream':
      return globalSettings ? globalSettings.disableStream : false;
    case 'disableRange':
      return globalSettings ? globalSettings.disableRange : false;
    case 'disableFontFace':
      return globalSettings ? globalSettings.disableFontFace : false;
    case 'disableCreateObjectURL':
      return globalSettings ? globalSettings.disableCreateObjectURL : false;
    case 'disableWebGL':
      return globalSettings ? globalSettings.disableWebGL : true;
    case 'cMapUrl':
      return globalSettings ? globalSettings.cMapUrl : null;
    case 'cMapPacked':
      return globalSettings ? globalSettings.cMapPacked : false;
    case 'postMessageTransfers':
      return globalSettings ? globalSettings.postMessageTransfers : true;
    case 'workerPort':
      return globalSettings ? globalSettings.workerPort : null;
    case 'workerSrc':
      return globalSettings ? globalSettings.workerSrc : null;
    case 'disableWorker':
      return globalSettings ? globalSettings.disableWorker : false;
    case 'maxImageSize':
      return globalSettings ? globalSettings.maxImageSize : -1;
    case 'imageResourcesPath':
      return globalSettings ? globalSettings.imageResourcesPath : '';
    case 'isEvalSupported':
      return globalSettings ? globalSettings.isEvalSupported : true;
    case 'externalLinkTarget':
      if (!globalSettings) {
        return LinkTarget.NONE;
      }
      switch (globalSettings.externalLinkTarget) {
        case LinkTarget.NONE:
        case LinkTarget.SELF:
        case LinkTarget.BLANK:
        case LinkTarget.PARENT:
        case LinkTarget.TOP:
          return globalSettings.externalLinkTarget;
      }
      (0, _util.warn)('PDFJS.externalLinkTarget is invalid: ' + globalSettings.externalLinkTarget);
      globalSettings.externalLinkTarget = LinkTarget.NONE;
      return LinkTarget.NONE;
    case 'externalLinkRel':
      return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
    case 'enableStats':
      return !!(globalSettings && globalSettings.enableStats);
    default:
      throw new Error('Unknown default setting: ' + id);
  }
}
function isExternalLinkTargetSet() {
  var externalLinkTarget = getDefaultSetting('externalLinkTarget');
  switch (externalLinkTarget) {
    case LinkTarget.NONE:
      return false;
    case LinkTarget.SELF:
    case LinkTarget.BLANK:
    case LinkTarget.PARENT:
    case LinkTarget.TOP:
      return true;
  }
}

var StatTimer = function () {
  function StatTimer() {
    var enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    _classCallCheck(this, StatTimer);

    this.enabled = !!enable;
    this.started = Object.create(null);
    this.times = [];
  }

  _createClass(StatTimer, [{
    key: 'time',
    value: function time(name) {
      if (!this.enabled) {
        return;
      }
      if (name in this.started) {
        (0, _util.warn)('Timer is already running for ' + name);
      }
      this.started[name] = Date.now();
    }
  }, {
    key: 'timeEnd',
    value: function timeEnd(name) {
      if (!this.enabled) {
        return;
      }
      if (!(name in this.started)) {
        (0, _util.warn)('Timer has not been started for ' + name);
      }
      this.times.push({
        'name': name,
        'start': this.started[name],
        'end': Date.now()
      });
      delete this.started[name];
    }
  }, {
    key: 'toString',
    value: function toString() {
      var times = this.times;
      var out = '',
          longest = 0;
      for (var i = 0, ii = times.length; i < ii; ++i) {
        var name = times[i]['name'];
        if (name.length > longest) {
          longest = name.length;
        }
      }
      for (var _i = 0, _ii = times.length; _i < _ii; ++_i) {
        var span = times[_i];
        var duration = span.end - span.start;
        out += span['name'].padEnd(longest) + ' ' + duration + 'ms\n';
      }
      return out;
    }
  }]);

  return StatTimer;
}();

var DummyStatTimer = function () {
  function DummyStatTimer() {
    _classCallCheck(this, DummyStatTimer);

    (0, _util.unreachable)('Cannot initialize DummyStatTimer.');
  }

  _createClass(DummyStatTimer, null, [{
    key: 'time',
    value: function time(name) {}
  }, {
    key: 'timeEnd',
    value: function timeEnd(name) {}
  }, {
    key: 'toString',
    value: function toString() {
      return '';
    }
  }]);

  return DummyStatTimer;
}();

exports.RenderingCancelledException = RenderingCancelledException;
exports.addLinkAttributes = addLinkAttributes;
exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
exports.getFilenameFromUrl = getFilenameFromUrl;
exports.LinkTarget = LinkTarget;
exports.getDefaultSetting = getDefaultSetting;
exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
exports.DOMCanvasFactory = DOMCanvasFactory;
exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
exports.DOMSVGFactory = DOMSVGFactory;
exports.SimpleXMLParser = SimpleXMLParser;
exports.StatTimer = StatTimer;
exports.DummyStatTimer = DummyStatTimer;

/***/ }),
/* 11 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var dP = __w_pdfjs_require__(15);
var createDesc = __w_pdfjs_require__(26);
module.exports = __w_pdfjs_require__(12) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = !__w_pdfjs_require__(13)(function () {
  return Object.defineProperty({}, 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : {};

/***/ }),
/* 15 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(6);
var IE8_DOM_DEFINE = __w_pdfjs_require__(40);
var toPrimitive = __w_pdfjs_require__(41);
var dP = Object.defineProperty;
exports.f = __w_pdfjs_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var IObject = __w_pdfjs_require__(27);
var defined = __w_pdfjs_require__(28);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toString = {}.toString;
module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = {};

/***/ }),
/* 20 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $keys = __w_pdfjs_require__(81);
var enumBugKeys = __w_pdfjs_require__(48);
module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var def = __w_pdfjs_require__(15).f;
var has = __w_pdfjs_require__(7);
var TAG = __w_pdfjs_require__(2)('toStringTag');
module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
    configurable: true,
    value: tag
  });
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ctx = __w_pdfjs_require__(9);
var call = __w_pdfjs_require__(86);
var isArrayIter = __w_pdfjs_require__(87);
var anObject = __w_pdfjs_require__(6);
var toLength = __w_pdfjs_require__(29);
var getIterFn = __w_pdfjs_require__(88);
var BREAK = {};
var RETURN = {};
var _exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
_exports.BREAK = BREAK;
_exports.RETURN = RETURN;

/***/ }),
/* 24 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function isNodeJS() {
  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(1);
var document = __w_pdfjs_require__(3).document;
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var cof = __w_pdfjs_require__(18);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toInteger = __w_pdfjs_require__(30);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0;
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var cof = __w_pdfjs_require__(18);
var TAG = __w_pdfjs_require__(2)('toStringTag');
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {}
};
module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T : ARG ? cof(O) : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var shared = __w_pdfjs_require__(44)('keys');
var uid = __w_pdfjs_require__(20);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var defined = __w_pdfjs_require__(28);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }
  return it;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var aFunction = __w_pdfjs_require__(16);
function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}
module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var redefine = __w_pdfjs_require__(8);
module.exports = function (target, src, safe) {
  for (var key in src) {
    redefine(target, key, src[key], safe);
  }return target;
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var META = __w_pdfjs_require__(20)('meta');
var isObject = __w_pdfjs_require__(1);
var has = __w_pdfjs_require__(7);
var setDesc = __w_pdfjs_require__(15).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__w_pdfjs_require__(13)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, {
    value: {
      i: 'O' + ++id,
      w: {}
    }
  });
};
var fastKey = function fastKey(it, create) {
  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    if (!isExtensible(it)) return 'F';
    if (!create) return 'E';
    setMeta(it);
  }
  return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    if (!isExtensible(it)) return true;
    if (!create) return false;
    setMeta(it);
  }
  return it[META].w;
};
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 39 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateResponseStatus = exports.validateRangeRequestCapabilities = exports.extractFilenameFromHeader = exports.createResponseStatusError = undefined;

var _util = __w_pdfjs_require__(0);

var _content_disposition = __w_pdfjs_require__(122);

function validateRangeRequestCapabilities(_ref) {
  var getResponseHeader = _ref.getResponseHeader,
      isHttp = _ref.isHttp,
      rangeChunkSize = _ref.rangeChunkSize,
      disableRange = _ref.disableRange;

  (0, _util.assert)(rangeChunkSize > 0, 'Range chunk size must be larger than zero');
  var returnValues = {
    allowRangeRequests: false,
    suggestedLength: undefined
  };
  if (disableRange || !isHttp) {
    return returnValues;
  }
  if (getResponseHeader('Accept-Ranges') !== 'bytes') {
    return returnValues;
  }
  var contentEncoding = getResponseHeader('Content-Encoding') || 'identity';
  if (contentEncoding !== 'identity') {
    return returnValues;
  }
  var length = parseInt(getResponseHeader('Content-Length'), 10);
  if (!Number.isInteger(length)) {
    return returnValues;
  }
  returnValues.suggestedLength = length;
  if (length <= 2 * rangeChunkSize) {
    return returnValues;
  }
  returnValues.allowRangeRequests = true;
  return returnValues;
}
function extractFilenameFromHeader(getResponseHeader) {
  var contentDisposition = getResponseHeader('Content-Disposition');
  if (contentDisposition) {
    var filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
    if (/\.pdf$/i.test(filename)) {
      return filename;
    }
  }
  return null;
}
function createResponseStatusError(status, url) {
  if (status === 404 || status === 0 && /^file:/.test(url)) {
    return new _util.MissingPDFException('Missing PDF "' + url + '".');
  }
  return new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
}
function validateResponseStatus(status) {
  return status === 200 || status === 206;
}
exports.createResponseStatusError = createResponseStatusError;
exports.extractFilenameFromHeader = extractFilenameFromHeader;
exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
exports.validateResponseStatus = validateResponseStatus;

/***/ }),
/* 40 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = !__w_pdfjs_require__(12) && !__w_pdfjs_require__(13)(function () {
  return Object.defineProperty(__w_pdfjs_require__(25)('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

/***/ }),
/* 41 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(1);
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toIObject = __w_pdfjs_require__(17);
var toLength = __w_pdfjs_require__(29);
var toAbsoluteIndex = __w_pdfjs_require__(67);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      if (value != value) return true;
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var UNSCOPABLES = __w_pdfjs_require__(2)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __w_pdfjs_require__(11)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var classof = __w_pdfjs_require__(31);
var test = {};
test[__w_pdfjs_require__(2)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __w_pdfjs_require__(8)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var LIBRARY = __w_pdfjs_require__(47);
var $export = __w_pdfjs_require__(4);
var redefine = __w_pdfjs_require__(8);
var hide = __w_pdfjs_require__(11);
var has = __w_pdfjs_require__(7);
var Iterators = __w_pdfjs_require__(19);
var $iterCreate = __w_pdfjs_require__(78);
var setToStringTag = __w_pdfjs_require__(22);
var getPrototypeOf = __w_pdfjs_require__(82);
var ITERATOR = __w_pdfjs_require__(2)('iterator');
var BUGGY = !([].keys && 'next' in [].keys());
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';
var returnThis = function returnThis() {
  return this;
};
module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }
    return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = !BUGGY && $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      setToStringTag(IteratorPrototype, TAG, true);
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = false;

/***/ }),
/* 48 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 49 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var document = __w_pdfjs_require__(3).document;
module.exports = document && document.documentElement;

/***/ }),
/* 50 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $iterators = __w_pdfjs_require__(83);
var getKeys = __w_pdfjs_require__(21);
var redefine = __w_pdfjs_require__(8);
var global = __w_pdfjs_require__(3);
var hide = __w_pdfjs_require__(11);
var Iterators = __w_pdfjs_require__(19);
var wks = __w_pdfjs_require__(2);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;
var DOMIterables = {
  CSSRuleList: true,
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true,
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true,
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};
for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) {
      if (!proto[key]) redefine(proto, key, $iterators[key], true);
    }
  }
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(6);
var aFunction = __w_pdfjs_require__(16);
var SPECIES = __w_pdfjs_require__(2)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ctx = __w_pdfjs_require__(9);
var invoke = __w_pdfjs_require__(89);
var html = __w_pdfjs_require__(49);
var cel = __w_pdfjs_require__(25);
var global = __w_pdfjs_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function run() {
  var id = +this;
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function listener(event) {
  run.call(event.data);
};
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }queue[++counter] = function () {
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  if (__w_pdfjs_require__(18)(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(ctx(run, id, 1));
    };
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (exec) {
  try {
    return {
      e: false,
      v: exec()
    };
  } catch (e) {
    return {
      e: true,
      v: e
    };
  }
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(6);
var isObject = __w_pdfjs_require__(1);
var newPromiseCapability = __w_pdfjs_require__(35);
module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ITERATOR = __w_pdfjs_require__(2)('iterator');
var SAFE_CLOSING = false;
try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {}
module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {}
  return safe;
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var ctx = __w_pdfjs_require__(9);
var IObject = __w_pdfjs_require__(27);
var toObject = __w_pdfjs_require__(33);
var toLength = __w_pdfjs_require__(29);
var asc = __w_pdfjs_require__(96);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res;else if (res) switch (TYPE) {
            case 3:
              return true;
            case 5:
              return val;
            case 6:
              return index;
            case 2:
              result.push(val);
          } else if (IS_EVERY) return false;
        }
      }
    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(1);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.build = exports.version = exports.setPDFNetworkStreamFactory = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __w_pdfjs_require__(0);

var _dom_utils = __w_pdfjs_require__(10);

var _font_loader = __w_pdfjs_require__(116);

var _canvas = __w_pdfjs_require__(117);

var _global_scope = __w_pdfjs_require__(14);

var _global_scope2 = _interopRequireDefault(_global_scope);

var _metadata = __w_pdfjs_require__(59);

var _transport_stream = __w_pdfjs_require__(119);

var _webgl = __w_pdfjs_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_RANGE_CHUNK_SIZE = 65536;
var isWorkerDisabled = false;
var workerSrc;
var isPostMessageTransfersDisabled = false;
var pdfjsFilePath = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : null;
var fakeWorkerFilesLoader = null;
var useRequireEnsure = false;
{
  if (typeof window === 'undefined') {
    isWorkerDisabled = true;
    if (false) {
      require.ensure = require('node-ensure');
    }
    useRequireEnsure = true;
  } else if (true) {
    useRequireEnsure = true;
  }
  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
    workerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
  }
  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
  fakeWorkerFilesLoader = useRequireEnsure ? function (callback) {
    __webpack_require__.e/* require.ensure */(2).then((function () {
      var worker;
      worker = __webpack_require__(3085);
      callback(worker.WorkerMessageHandler);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  } : dynamicLoaderSupported ? function (callback) {
    requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
      callback(worker.WorkerMessageHandler);
    });
  } : null;
}
var createPDFNetworkStream;
function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
  createPDFNetworkStream = pdfNetworkStreamFactory;
}
function getDocument(src) {
  var task = new PDFDocumentLoadingTask();
  var source;
  if (typeof src === 'string') {
    source = { url: src };
  } else if ((0, _util.isArrayBuffer)(src)) {
    source = { data: src };
  } else if (src instanceof PDFDataRangeTransport) {
    source = { range: src };
  } else {
    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
    }
    if (!src.url && !src.data && !src.range) {
      throw new Error('Invalid parameter object: need either .data, .range or .url');
    }
    source = src;
  }
  var params = {};
  var rangeTransport = null;
  var worker = null;
  var CMapReaderFactory = _dom_utils.DOMCMapReaderFactory;
  for (var key in source) {
    if (key === 'url' && typeof window !== 'undefined') {
      params[key] = new URL(source[key], window.location).href;
      continue;
    } else if (key === 'range') {
      rangeTransport = source[key];
      continue;
    } else if (key === 'worker') {
      worker = source[key];
      continue;
    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
      var pdfBytes = source[key];
      if (typeof pdfBytes === 'string') {
        params[key] = (0, _util.stringToBytes)(pdfBytes);
      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
        params[key] = new Uint8Array(pdfBytes);
      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
        params[key] = new Uint8Array(pdfBytes);
      } else {
        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
      }
      continue;
    } else if (key === 'CMapReaderFactory') {
      CMapReaderFactory = source[key];
      continue;
    }
    params[key] = source[key];
  }
  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
  params.ignoreErrors = params.stopAtErrors !== true;
  var nativeImageDecoderValues = Object.values(_util.NativeImageDecoding);
  if (params.nativeImageDecoderSupport === undefined || !nativeImageDecoderValues.includes(params.nativeImageDecoderSupport)) {
    params.nativeImageDecoderSupport = _util.NativeImageDecoding.DECODE;
  }
  if (!worker) {
    var workerPort = (0, _dom_utils.getDefaultSetting)('workerPort');
    worker = workerPort ? PDFWorker.fromPort(workerPort) : new PDFWorker();
    task._worker = worker;
  }
  var docId = task.docId;
  worker.promise.then(function () {
    if (task.destroyed) {
      throw new Error('Loading aborted');
    }
    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
      if (task.destroyed) {
        throw new Error('Loading aborted');
      }
      var networkStream = void 0;
      if (rangeTransport) {
        networkStream = new _transport_stream.PDFDataTransportStream(params, rangeTransport);
      } else if (!params.data) {
        networkStream = createPDFNetworkStream(params);
      }
      var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
      messageHandler.postMessageTransfers = worker.postMessageTransfers;
      var transport = new WorkerTransport(messageHandler, task, networkStream, CMapReaderFactory);
      task._transport = transport;
      messageHandler.send('Ready', null);
    });
  }).catch(task._capability.reject);
  return task;
}
function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
  if (worker.destroyed) {
    return Promise.reject(new Error('Worker was destroyed'));
  }
  var apiVersion = '2.0.305';
  source.disableRange = (0, _dom_utils.getDefaultSetting)('disableRange');
  source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)('disableAutoFetch');
  source.disableStream = (0, _dom_utils.getDefaultSetting)('disableStream');
  if (pdfDataRangeTransport) {
    source.length = pdfDataRangeTransport.length;
    source.initialData = pdfDataRangeTransport.initialData;
  }
  return worker.messageHandler.sendWithPromise('GetDocRequest', {
    docId: docId,
    apiVersion: apiVersion,
    source: {
      data: source.data,
      url: source.url,
      password: source.password,
      disableAutoFetch: source.disableAutoFetch,
      rangeChunkSize: source.rangeChunkSize,
      length: source.length
    },
    maxImageSize: (0, _dom_utils.getDefaultSetting)('maxImageSize'),
    disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
    disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)('disableCreateObjectURL'),
    postMessageTransfers: (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled,
    docBaseUrl: source.docBaseUrl,
    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
    ignoreErrors: source.ignoreErrors,
    isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported')
  }).then(function (workerId) {
    if (worker.destroyed) {
      throw new Error('Worker was destroyed');
    }
    return workerId;
  });
}
var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
  var nextDocumentId = 0;
  function PDFDocumentLoadingTask() {
    this._capability = (0, _util.createPromiseCapability)();
    this._transport = null;
    this._worker = null;
    this.docId = 'd' + nextDocumentId++;
    this.destroyed = false;
    this.onPassword = null;
    this.onProgress = null;
    this.onUnsupportedFeature = null;
  }
  PDFDocumentLoadingTask.prototype = {
    get promise() {
      return this._capability.promise;
    },
    destroy: function destroy() {
      var _this = this;

      this.destroyed = true;
      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
      return transportDestroyed.then(function () {
        _this._transport = null;
        if (_this._worker) {
          _this._worker.destroy();
          _this._worker = null;
        }
      });
    },

    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
      return this.promise.then.apply(this.promise, arguments);
    }
  };
  return PDFDocumentLoadingTask;
}();
var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
  function PDFDataRangeTransport(length, initialData) {
    this.length = length;
    this.initialData = initialData;
    this._rangeListeners = [];
    this._progressListeners = [];
    this._progressiveReadListeners = [];
    this._readyCapability = (0, _util.createPromiseCapability)();
  }
  PDFDataRangeTransport.prototype = {
    addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
      this._rangeListeners.push(listener);
    },
    addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
      this._progressListeners.push(listener);
    },
    addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
      this._progressiveReadListeners.push(listener);
    },
    onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
      var listeners = this._rangeListeners;
      for (var i = 0, n = listeners.length; i < n; ++i) {
        listeners[i](begin, chunk);
      }
    },
    onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
      var _this2 = this;

      this._readyCapability.promise.then(function () {
        var listeners = _this2._progressListeners;
        for (var i = 0, n = listeners.length; i < n; ++i) {
          listeners[i](loaded);
        }
      });
    },
    onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
      var _this3 = this;

      this._readyCapability.promise.then(function () {
        var listeners = _this3._progressiveReadListeners;
        for (var i = 0, n = listeners.length; i < n; ++i) {
          listeners[i](chunk);
        }
      });
    },
    transportReady: function PDFDataRangeTransport_transportReady() {
      this._readyCapability.resolve();
    },
    requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
      (0, _util.unreachable)('Abstract method PDFDataRangeTransport.requestDataRange');
    },
    abort: function PDFDataRangeTransport_abort() {}
  };
  return PDFDataRangeTransport;
}();
var PDFDocumentProxy = function PDFDocumentProxyClosure() {
  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
    this.pdfInfo = pdfInfo;
    this.transport = transport;
    this.loadingTask = loadingTask;
  }
  PDFDocumentProxy.prototype = {
    get numPages() {
      return this.pdfInfo.numPages;
    },
    get fingerprint() {
      return this.pdfInfo.fingerprint;
    },
    getPage: function getPage(pageNumber) {
      return this.transport.getPage(pageNumber);
    },

    getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
      return this.transport.getPageIndex(ref);
    },
    getDestinations: function PDFDocumentProxy_getDestinations() {
      return this.transport.getDestinations();
    },
    getDestination: function PDFDocumentProxy_getDestination(id) {
      return this.transport.getDestination(id);
    },
    getPageLabels: function PDFDocumentProxy_getPageLabels() {
      return this.transport.getPageLabels();
    },
    getPageMode: function getPageMode() {
      return this.transport.getPageMode();
    },

    getAttachments: function PDFDocumentProxy_getAttachments() {
      return this.transport.getAttachments();
    },
    getJavaScript: function getJavaScript() {
      return this.transport.getJavaScript();
    },

    getOutline: function PDFDocumentProxy_getOutline() {
      return this.transport.getOutline();
    },
    getMetadata: function PDFDocumentProxy_getMetadata() {
      return this.transport.getMetadata();
    },
    getData: function PDFDocumentProxy_getData() {
      return this.transport.getData();
    },
    getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
      return this.transport.downloadInfoCapability.promise;
    },
    getStats: function PDFDocumentProxy_getStats() {
      return this.transport.getStats();
    },
    cleanup: function PDFDocumentProxy_cleanup() {
      this.transport.startCleanup();
    },
    destroy: function PDFDocumentProxy_destroy() {
      return this.loadingTask.destroy();
    }
  };
  return PDFDocumentProxy;
}();
var PDFPageProxy = function PDFPageProxyClosure() {
  function PDFPageProxy(pageIndex, pageInfo, transport) {
    this.pageIndex = pageIndex;
    this.pageInfo = pageInfo;
    this.transport = transport;
    this._stats = (0, _dom_utils.getDefaultSetting)('enableStats') ? new _dom_utils.StatTimer() : _dom_utils.DummyStatTimer;
    this.commonObjs = transport.commonObjs;
    this.objs = new PDFObjects();
    this.cleanupAfterRender = false;
    this.pendingCleanup = false;
    this.intentStates = Object.create(null);
    this.destroyed = false;
  }
  PDFPageProxy.prototype = {
    get pageNumber() {
      return this.pageIndex + 1;
    },
    get rotate() {
      return this.pageInfo.rotate;
    },
    get ref() {
      return this.pageInfo.ref;
    },
    get userUnit() {
      return this.pageInfo.userUnit;
    },
    get view() {
      return this.pageInfo.view;
    },
    getViewport: function getViewport(scale) {
      var rotate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.rotate;
      var dontFlip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      return new _util.PageViewport(this.view, scale, rotate, 0, 0, dontFlip);
    },

    getAnnotations: function PDFPageProxy_getAnnotations(params) {
      var intent = params && params.intent || null;
      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
        this.annotationsIntent = intent;
      }
      return this.annotationsPromise;
    },
    render: function PDFPageProxy_render(params) {
      var _this4 = this;

      var stats = this._stats;
      stats.time('Overall');
      this.pendingCleanup = false;
      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
      var webGLContext = new _webgl.WebGLContext({ enable: !(0, _dom_utils.getDefaultSetting)('disableWebGL') });
      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }
      var intentState = this.intentStates[renderingIntent];
      if (!intentState.displayReadyCapability) {
        intentState.receivingOperatorList = true;
        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        stats.time('Page Request');
        this.transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageNumber - 1,
          intent: renderingIntent,
          renderInteractiveForms: params.renderInteractiveForms === true
        });
      }
      var complete = function complete(error) {
        var i = intentState.renderTasks.indexOf(internalRenderTask);
        if (i >= 0) {
          intentState.renderTasks.splice(i, 1);
        }
        if (_this4.cleanupAfterRender) {
          _this4.pendingCleanup = true;
        }
        _this4._tryCleanup();
        if (error) {
          internalRenderTask.capability.reject(error);
        } else {
          internalRenderTask.capability.resolve();
        }
        stats.timeEnd('Rendering');
        stats.timeEnd('Overall');
      };
      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory, webGLContext);
      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
      if (!intentState.renderTasks) {
        intentState.renderTasks = [];
      }
      intentState.renderTasks.push(internalRenderTask);
      var renderTask = internalRenderTask.task;
      intentState.displayReadyCapability.promise.then(function (transparency) {
        if (_this4.pendingCleanup) {
          complete();
          return;
        }
        stats.time('Rendering');
        internalRenderTask.initializeGraphics(transparency);
        internalRenderTask.operatorListChanged();
      }).catch(complete);
      return renderTask;
    },
    getOperatorList: function PDFPageProxy_getOperatorList() {
      function operatorListChanged() {
        if (intentState.operatorList.lastChunk) {
          intentState.opListReadCapability.resolve(intentState.operatorList);
          var i = intentState.renderTasks.indexOf(opListTask);
          if (i >= 0) {
            intentState.renderTasks.splice(i, 1);
          }
        }
      }
      var renderingIntent = 'oplist';
      if (!this.intentStates[renderingIntent]) {
        this.intentStates[renderingIntent] = Object.create(null);
      }
      var intentState = this.intentStates[renderingIntent];
      var opListTask;
      if (!intentState.opListReadCapability) {
        opListTask = {};
        opListTask.operatorListChanged = operatorListChanged;
        intentState.receivingOperatorList = true;
        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
        intentState.renderTasks = [];
        intentState.renderTasks.push(opListTask);
        intentState.operatorList = {
          fnArray: [],
          argsArray: [],
          lastChunk: false
        };
        this.transport.messageHandler.send('RenderPageRequest', {
          pageIndex: this.pageIndex,
          intent: renderingIntent
        });
      }
      return intentState.opListReadCapability.promise;
    },
    streamTextContent: function streamTextContent() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var TEXT_CONTENT_CHUNK_SIZE = 100;
      return this.transport.messageHandler.sendWithStream('GetTextContent', {
        pageIndex: this.pageNumber - 1,
        normalizeWhitespace: params.normalizeWhitespace === true,
        combineTextItems: params.disableCombineTextItems !== true
      }, {
        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
        size: function size(textContent) {
          return textContent.items.length;
        }
      });
    },

    getTextContent: function PDFPageProxy_getTextContent(params) {
      params = params || {};
      var readableStream = this.streamTextContent(params);
      return new Promise(function (resolve, reject) {
        function pump() {
          reader.read().then(function (_ref) {
            var value = _ref.value,
                done = _ref.done;

            if (done) {
              resolve(textContent);
              return;
            }
            _util.Util.extendObj(textContent.styles, value.styles);
            _util.Util.appendToArray(textContent.items, value.items);
            pump();
          }, reject);
        }
        var reader = readableStream.getReader();
        var textContent = {
          items: [],
          styles: Object.create(null)
        };
        pump();
      });
    },
    _destroy: function PDFPageProxy_destroy() {
      this.destroyed = true;
      this.transport.pageCache[this.pageIndex] = null;
      var waitOn = [];
      Object.keys(this.intentStates).forEach(function (intent) {
        if (intent === 'oplist') {
          return;
        }
        var intentState = this.intentStates[intent];
        intentState.renderTasks.forEach(function (renderTask) {
          var renderCompleted = renderTask.capability.promise.catch(function () {});
          waitOn.push(renderCompleted);
          renderTask.cancel();
        });
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      this.pendingCleanup = false;
      return Promise.all(waitOn);
    },
    cleanup: function cleanup() {
      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.pendingCleanup = true;
      this._tryCleanup(resetStats);
    },
    _tryCleanup: function _tryCleanup() {
      var resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
        var intentState = this.intentStates[intent];
        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
      }, this)) {
        return;
      }
      Object.keys(this.intentStates).forEach(function (intent) {
        delete this.intentStates[intent];
      }, this);
      this.objs.clear();
      this.annotationsPromise = null;
      if (resetStats && this._stats instanceof _dom_utils.StatTimer) {
        this._stats = new _dom_utils.StatTimer();
      }
      this.pendingCleanup = false;
    },

    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
      var intentState = this.intentStates[intent];
      if (intentState.displayReadyCapability) {
        intentState.displayReadyCapability.resolve(transparency);
      }
    },
    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
      var intentState = this.intentStates[intent];
      var i, ii;
      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
      }
      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
      for (i = 0; i < intentState.renderTasks.length; i++) {
        intentState.renderTasks[i].operatorListChanged();
      }
      if (operatorListChunk.lastChunk) {
        intentState.receivingOperatorList = false;
        this._tryCleanup();
      }
    },
    get stats() {
      return this._stats instanceof _dom_utils.StatTimer ? this._stats : null;
    }
  };
  return PDFPageProxy;
}();

var LoopbackPort = function () {
  function LoopbackPort(defer) {
    _classCallCheck(this, LoopbackPort);

    this._listeners = [];
    this._defer = defer;
    this._deferred = Promise.resolve(undefined);
  }

  _createClass(LoopbackPort, [{
    key: 'postMessage',
    value: function postMessage(obj, transfers) {
      var _this5 = this;

      function cloneValue(value) {
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
          return value;
        }
        if (cloned.has(value)) {
          return cloned.get(value);
        }
        var result;
        var buffer;
        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
          var transferable = transfers && transfers.indexOf(buffer) >= 0;
          if (value === buffer) {
            result = value;
          } else if (transferable) {
            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
          } else {
            result = new value.constructor(value);
          }
          cloned.set(value, result);
          return result;
        }
        result = Array.isArray(value) ? [] : {};
        cloned.set(value, result);
        for (var i in value) {
          var desc,
              p = value;
          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
            p = Object.getPrototypeOf(p);
          }
          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
            continue;
          }
          result[i] = cloneValue(desc.value);
        }
        return result;
      }
      if (!this._defer) {
        this._listeners.forEach(function (listener) {
          listener.call(this, { data: obj });
        }, this);
        return;
      }
      var cloned = new WeakMap();
      var e = { data: cloneValue(obj) };
      this._deferred.then(function () {
        _this5._listeners.forEach(function (listener) {
          listener.call(this, e);
        }, _this5);
      });
    }
  }, {
    key: 'addEventListener',
    value: function addEventListener(name, listener) {
      this._listeners.push(listener);
    }
  }, {
    key: 'removeEventListener',
    value: function removeEventListener(name, listener) {
      var i = this._listeners.indexOf(listener);
      this._listeners.splice(i, 1);
    }
  }, {
    key: 'terminate',
    value: function terminate() {
      this._listeners = [];
    }
  }]);

  return LoopbackPort;
}();

var PDFWorker = function PDFWorkerClosure() {
  var nextFakeWorkerId = 0;
  function getWorkerSrc() {
    if (typeof workerSrc !== 'undefined') {
      return workerSrc;
    }
    if ((0, _dom_utils.getDefaultSetting)('workerSrc')) {
      return (0, _dom_utils.getDefaultSetting)('workerSrc');
    }
    if (pdfjsFilePath) {
      return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
    }
    throw new Error('No PDFJS.workerSrc specified');
  }
  var fakeWorkerFilesLoadedCapability = void 0;
  function setupFakeWorkerGlobal() {
    var WorkerMessageHandler;
    if (fakeWorkerFilesLoadedCapability) {
      return fakeWorkerFilesLoadedCapability.promise;
    }
    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
    var loader = fakeWorkerFilesLoader || function (callback) {
      _util.Util.loadScript(getWorkerSrc(), function () {
        callback(window.pdfjsDistBuildPdfWorker.WorkerMessageHandler);
      });
    };
    loader(fakeWorkerFilesLoadedCapability.resolve);
    return fakeWorkerFilesLoadedCapability.promise;
  }
  function createCDNWrapper(url) {
    var wrapper = 'importScripts(\'' + url + '\');';
    return URL.createObjectURL(new Blob([wrapper]));
  }
  var pdfWorkerPorts = new WeakMap();
  function PDFWorker(name, port) {
    if (port && pdfWorkerPorts.has(port)) {
      throw new Error('Cannot use more than one PDFWorker per port');
    }
    this.name = name;
    this.destroyed = false;
    this.postMessageTransfers = true;
    this._readyCapability = (0, _util.createPromiseCapability)();
    this._port = null;
    this._webWorker = null;
    this._messageHandler = null;
    if (port) {
      pdfWorkerPorts.set(port, this);
      this._initializeFromPort(port);
      return;
    }
    this._initialize();
  }
  PDFWorker.prototype = {
    get promise() {
      return this._readyCapability.promise;
    },
    get port() {
      return this._port;
    },
    get messageHandler() {
      return this._messageHandler;
    },
    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
      this._port = port;
      this._messageHandler = new _util.MessageHandler('main', 'worker', port);
      this._messageHandler.on('ready', function () {});
      this._readyCapability.resolve();
    },
    _initialize: function PDFWorker_initialize() {
      var _this6 = this;

      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker') && typeof Worker !== 'undefined') {
        var workerSrc = getWorkerSrc();
        try {
          if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
            workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
          }
          var worker = new Worker(workerSrc);
          var messageHandler = new _util.MessageHandler('main', 'worker', worker);
          var terminateEarly = function terminateEarly() {
            worker.removeEventListener('error', onWorkerError);
            messageHandler.destroy();
            worker.terminate();
            if (_this6.destroyed) {
              _this6._readyCapability.reject(new Error('Worker was destroyed'));
            } else {
              _this6._setupFakeWorker();
            }
          };
          var onWorkerError = function onWorkerError() {
            if (!_this6._webWorker) {
              terminateEarly();
            }
          };
          worker.addEventListener('error', onWorkerError);
          messageHandler.on('test', function (data) {
            worker.removeEventListener('error', onWorkerError);
            if (_this6.destroyed) {
              terminateEarly();
              return;
            }
            var supportTypedArray = data && data.supportTypedArray;
            if (supportTypedArray) {
              _this6._messageHandler = messageHandler;
              _this6._port = worker;
              _this6._webWorker = worker;
              if (!data.supportTransfers) {
                _this6.postMessageTransfers = false;
                isPostMessageTransfersDisabled = true;
              }
              _this6._readyCapability.resolve();
              messageHandler.send('configure', { verbosity: (0, _util.getVerbosityLevel)() });
            } else {
              _this6._setupFakeWorker();
              messageHandler.destroy();
              worker.terminate();
            }
          });
          messageHandler.on('ready', function (data) {
            worker.removeEventListener('error', onWorkerError);
            if (_this6.destroyed) {
              terminateEarly();
              return;
            }
            try {
              sendTest();
            } catch (e) {
              _this6._setupFakeWorker();
            }
          });
          var sendTest = function sendTest() {
            var postMessageTransfers = (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled;
            var testObj = new Uint8Array([postMessageTransfers ? 255 : 0]);
            try {
              messageHandler.send('test', testObj, [testObj.buffer]);
            } catch (ex) {
              (0, _util.info)('Cannot use postMessage transfers');
              testObj[0] = 0;
              messageHandler.send('test', testObj);
            }
          };
          sendTest();
          return;
        } catch (e) {
          (0, _util.info)('The worker has been disabled.');
        }
      }
      this._setupFakeWorker();
    },
    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
      var _this7 = this;

      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker')) {
        (0, _util.warn)('Setting up fake worker.');
        isWorkerDisabled = true;
      }
      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
        if (_this7.destroyed) {
          _this7._readyCapability.reject(new Error('Worker was destroyed'));
          return;
        }
        var isTypedArraysPresent = Uint8Array !== Float32Array;
        var port = new LoopbackPort(isTypedArraysPresent);
        _this7._port = port;
        var id = 'fake' + nextFakeWorkerId++;
        var workerHandler = new _util.MessageHandler(id + '_worker', id, port);
        WorkerMessageHandler.setup(workerHandler, port);
        var messageHandler = new _util.MessageHandler(id, id + '_worker', port);
        _this7._messageHandler = messageHandler;
        _this7._readyCapability.resolve();
      });
    },
    destroy: function PDFWorker_destroy() {
      this.destroyed = true;
      if (this._webWorker) {
        this._webWorker.terminate();
        this._webWorker = null;
      }
      pdfWorkerPorts.delete(this._port);
      this._port = null;
      if (this._messageHandler) {
        this._messageHandler.destroy();
        this._messageHandler = null;
      }
    }
  };
  PDFWorker.fromPort = function (port) {
    if (pdfWorkerPorts.has(port)) {
      return pdfWorkerPorts.get(port);
    }
    return new PDFWorker(null, port);
  };
  return PDFWorker;
}();
var WorkerTransport = function WorkerTransportClosure() {
  function WorkerTransport(messageHandler, loadingTask, networkStream, CMapReaderFactory) {
    this.messageHandler = messageHandler;
    this.loadingTask = loadingTask;
    this.commonObjs = new PDFObjects();
    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
    this.CMapReaderFactory = new CMapReaderFactory({
      baseUrl: (0, _dom_utils.getDefaultSetting)('cMapUrl'),
      isCompressed: (0, _dom_utils.getDefaultSetting)('cMapPacked')
    });
    this.destroyed = false;
    this.destroyCapability = null;
    this._passwordCapability = null;
    this._networkStream = networkStream;
    this._fullReader = null;
    this._lastProgress = null;
    this.pageCache = [];
    this.pagePromises = [];
    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
    this.setupMessageHandler();
  }
  WorkerTransport.prototype = {
    destroy: function WorkerTransport_destroy() {
      var _this8 = this;

      if (this.destroyCapability) {
        return this.destroyCapability.promise;
      }
      this.destroyed = true;
      this.destroyCapability = (0, _util.createPromiseCapability)();
      if (this._passwordCapability) {
        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
      }
      var waitOn = [];
      this.pageCache.forEach(function (page) {
        if (page) {
          waitOn.push(page._destroy());
        }
      });
      this.pageCache = [];
      this.pagePromises = [];
      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
      waitOn.push(terminated);
      Promise.all(waitOn).then(function () {
        _this8.fontLoader.clear();
        if (_this8._networkStream) {
          _this8._networkStream.cancelAllRequests();
        }
        if (_this8.messageHandler) {
          _this8.messageHandler.destroy();
          _this8.messageHandler = null;
        }
        _this8.destroyCapability.resolve();
      }, this.destroyCapability.reject);
      return this.destroyCapability.promise;
    },
    setupMessageHandler: function WorkerTransport_setupMessageHandler() {
      var messageHandler = this.messageHandler;
      var loadingTask = this.loadingTask;
      messageHandler.on('GetReader', function (data, sink) {
        var _this9 = this;

        (0, _util.assert)(this._networkStream);
        this._fullReader = this._networkStream.getFullReader();
        this._fullReader.onProgress = function (evt) {
          _this9._lastProgress = {
            loaded: evt.loaded,
            total: evt.total
          };
        };
        sink.onPull = function () {
          _this9._fullReader.read().then(function (_ref2) {
            var value = _ref2.value,
                done = _ref2.done;

            if (done) {
              sink.close();
              return;
            }
            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          }).catch(function (reason) {
            sink.error(reason);
          });
        };
        sink.onCancel = function (reason) {
          _this9._fullReader.cancel(reason);
        };
      }, this);
      messageHandler.on('ReaderHeadersReady', function (data) {
        var _this10 = this;

        var headersCapability = (0, _util.createPromiseCapability)();
        var fullReader = this._fullReader;
        fullReader.headersReady.then(function () {
          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
            if (_this10._lastProgress) {
              var _loadingTask = _this10.loadingTask;
              if (_loadingTask.onProgress) {
                _loadingTask.onProgress(_this10._lastProgress);
              }
            }
            fullReader.onProgress = function (evt) {
              var loadingTask = _this10.loadingTask;
              if (loadingTask.onProgress) {
                loadingTask.onProgress({
                  loaded: evt.loaded,
                  total: evt.total
                });
              }
            };
          }
          headersCapability.resolve({
            isStreamingSupported: fullReader.isStreamingSupported,
            isRangeSupported: fullReader.isRangeSupported,
            contentLength: fullReader.contentLength
          });
        }, headersCapability.reject);
        return headersCapability.promise;
      }, this);
      messageHandler.on('GetRangeReader', function (data, sink) {
        (0, _util.assert)(this._networkStream);
        var _rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
        sink.onPull = function () {
          _rangeReader.read().then(function (_ref3) {
            var value = _ref3.value,
                done = _ref3.done;

            if (done) {
              sink.close();
              return;
            }
            (0, _util.assert)((0, _util.isArrayBuffer)(value));
            sink.enqueue(new Uint8Array(value), 1, [value]);
          }).catch(function (reason) {
            sink.error(reason);
          });
        };
        sink.onCancel = function (reason) {
          _rangeReader.cancel(reason);
        };
      }, this);
      messageHandler.on('GetDoc', function transportDoc(_ref4) {
        var pdfInfo = _ref4.pdfInfo;

        this.numPages = pdfInfo.numPages;
        var loadingTask = this.loadingTask;
        var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
        this.pdfDocument = pdfDocument;
        loadingTask._capability.resolve(pdfDocument);
      }, this);
      messageHandler.on('PasswordRequest', function transportPasswordRequest(exception) {
        var _this11 = this;

        this._passwordCapability = (0, _util.createPromiseCapability)();
        if (loadingTask.onPassword) {
          var updatePassword = function updatePassword(password) {
            _this11._passwordCapability.resolve({ password: password });
          };
          loadingTask.onPassword(updatePassword, exception.code);
        } else {
          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
        }
        return this._passwordCapability.promise;
      }, this);
      messageHandler.on('PasswordException', function transportPasswordException(exception) {
        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
      }, this);
      messageHandler.on('InvalidPDF', function transportInvalidPDF(exception) {
        this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
      }, this);
      messageHandler.on('MissingPDF', function transportMissingPDF(exception) {
        this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
      }, this);
      messageHandler.on('UnexpectedResponse', function transportUnexpectedResponse(exception) {
        this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
      }, this);
      messageHandler.on('UnknownError', function transportUnknownError(exception) {
        this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
      }, this);
      messageHandler.on('DataLoaded', function transportPage(data) {
        this.downloadInfoCapability.resolve(data);
      }, this);
      messageHandler.on('PDFManagerReady', function transportPage(data) {}, this);
      messageHandler.on('StartRenderPage', function transportRender(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageIndex];
        page._stats.timeEnd('Page Request');
        page._startRenderPage(data.transparency, data.intent);
      }, this);
      messageHandler.on('RenderPageChunk', function transportRender(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageIndex];
        page._renderPageChunk(data.operatorList, data.intent);
      }, this);
      messageHandler.on('commonobj', function transportObj(data) {
        var _this12 = this;

        if (this.destroyed) {
          return;
        }
        var id = data[0];
        var type = data[1];
        if (this.commonObjs.hasData(id)) {
          return;
        }
        switch (type) {
          case 'Font':
            var exportedData = data[2];
            if ('error' in exportedData) {
              var exportedError = exportedData.error;
              (0, _util.warn)('Error during font loading: ' + exportedError);
              this.commonObjs.resolve(id, exportedError);
              break;
            }
            var fontRegistry = null;
            if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.FontInspector && _global_scope2.default['FontInspector'].enabled) {
              fontRegistry = {
                registerFont: function registerFont(font, url) {
                  _global_scope2.default['FontInspector'].fontAdded(font, url);
                }
              };
            }
            var font = new _font_loader.FontFaceObject(exportedData, {
              isEvalSupported: (0, _dom_utils.getDefaultSetting)('isEvalSupported'),
              disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
              fontRegistry: fontRegistry
            });
            var fontReady = function fontReady(fontObjs) {
              _this12.commonObjs.resolve(id, font);
            };
            this.fontLoader.bind([font], fontReady);
            break;
          case 'FontPath':
            this.commonObjs.resolve(id, data[2]);
            break;
          default:
            throw new Error('Got unknown common object type ' + type);
        }
      }, this);
      messageHandler.on('obj', function transportObj(data) {
        if (this.destroyed) {
          return;
        }
        var id = data[0];
        var pageIndex = data[1];
        var type = data[2];
        var pageProxy = this.pageCache[pageIndex];
        var imageData;
        if (pageProxy.objs.hasData(id)) {
          return;
        }
        switch (type) {
          case 'JpegStream':
            imageData = data[3];
            (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
            break;
          case 'Image':
            imageData = data[3];
            pageProxy.objs.resolve(id, imageData);
            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
              pageProxy.cleanupAfterRender = true;
            }
            break;
          default:
            throw new Error('Got unknown object type ' + type);
        }
      }, this);
      messageHandler.on('DocProgress', function transportDocProgress(data) {
        if (this.destroyed) {
          return;
        }
        var loadingTask = this.loadingTask;
        if (loadingTask.onProgress) {
          loadingTask.onProgress({
            loaded: data.loaded,
            total: data.total
          });
        }
      }, this);
      messageHandler.on('PageError', function transportError(data) {
        if (this.destroyed) {
          return;
        }
        var page = this.pageCache[data.pageNum - 1];
        var intentState = page.intentStates[data.intent];
        if (intentState.displayReadyCapability) {
          intentState.displayReadyCapability.reject(data.error);
        } else {
          throw new Error(data.error);
        }
        if (intentState.operatorList) {
          intentState.operatorList.lastChunk = true;
          for (var i = 0; i < intentState.renderTasks.length; i++) {
            intentState.renderTasks[i].operatorListChanged();
          }
        }
      }, this);
      messageHandler.on('UnsupportedFeature', function (data) {
        if (this.destroyed) {
          return;
        }
        var loadingTask = this.loadingTask;
        if (loadingTask.onUnsupportedFeature) {
          loadingTask.onUnsupportedFeature(data.featureId);
        }
      }, this);
      messageHandler.on('JpegDecode', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }
        if (typeof document === 'undefined') {
          return Promise.reject(new Error('"document" is not defined.'));
        }
        var imageUrl = data[0];
        var components = data[1];
        if (components !== 3 && components !== 1) {
          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
        }
        return new Promise(function (resolve, reject) {
          var img = new Image();
          img.onload = function () {
            var width = img.width;
            var height = img.height;
            var size = width * height;
            var rgbaLength = size * 4;
            var buf = new Uint8Array(size * components);
            var tmpCanvas = document.createElement('canvas');
            tmpCanvas.width = width;
            tmpCanvas.height = height;
            var tmpCtx = tmpCanvas.getContext('2d');
            tmpCtx.drawImage(img, 0, 0);
            var data = tmpCtx.getImageData(0, 0, width, height).data;
            var i, j;
            if (components === 3) {
              for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
                buf[j] = data[i];
                buf[j + 1] = data[i + 1];
                buf[j + 2] = data[i + 2];
              }
            } else if (components === 1) {
              for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
                buf[j] = data[i];
              }
            }
            resolve({
              data: buf,
              width: width,
              height: height
            });
          };
          img.onerror = function () {
            reject(new Error('JpegDecode failed to load image'));
          };
          img.src = imageUrl;
        });
      }, this);
      messageHandler.on('FetchBuiltInCMap', function (data) {
        if (this.destroyed) {
          return Promise.reject(new Error('Worker was destroyed'));
        }
        return this.CMapReaderFactory.fetch({ name: data.name });
      }, this);
    },
    getData: function WorkerTransport_getData() {
      return this.messageHandler.sendWithPromise('GetData', null);
    },
    getPage: function getPage(pageNumber) {
      var _this13 = this;

      if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
        return Promise.reject(new Error('Invalid page request'));
      }
      var pageIndex = pageNumber - 1;
      if (pageIndex in this.pagePromises) {
        return this.pagePromises[pageIndex];
      }
      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
        if (_this13.destroyed) {
          throw new Error('Transport destroyed');
        }
        var page = new PDFPageProxy(pageIndex, pageInfo, _this13);
        _this13.pageCache[pageIndex] = page;
        return page;
      });
      this.pagePromises[pageIndex] = promise;
      return promise;
    },

    getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
        return Promise.reject(new Error(reason));
      });
    },
    getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
      return this.messageHandler.sendWithPromise('GetAnnotations', {
        pageIndex: pageIndex,
        intent: intent
      });
    },
    getDestinations: function WorkerTransport_getDestinations() {
      return this.messageHandler.sendWithPromise('GetDestinations', null);
    },
    getDestination: function WorkerTransport_getDestination(id) {
      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
    },
    getPageLabels: function WorkerTransport_getPageLabels() {
      return this.messageHandler.sendWithPromise('GetPageLabels', null);
    },
    getPageMode: function getPageMode() {
      return this.messageHandler.sendWithPromise('GetPageMode', null);
    },

    getAttachments: function WorkerTransport_getAttachments() {
      return this.messageHandler.sendWithPromise('GetAttachments', null);
    },
    getJavaScript: function WorkerTransport_getJavaScript() {
      return this.messageHandler.sendWithPromise('GetJavaScript', null);
    },
    getOutline: function WorkerTransport_getOutline() {
      return this.messageHandler.sendWithPromise('GetOutline', null);
    },
    getMetadata: function WorkerTransport_getMetadata() {
      var _this14 = this;

      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function (results) {
        return {
          info: results[0],
          metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
          contentDispositionFilename: _this14._fullReader ? _this14._fullReader.filename : null
        };
      });
    },
    getStats: function WorkerTransport_getStats() {
      return this.messageHandler.sendWithPromise('GetStats', null);
    },
    startCleanup: function WorkerTransport_startCleanup() {
      var _this15 = this;

      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
        for (var i = 0, ii = _this15.pageCache.length; i < ii; i++) {
          var page = _this15.pageCache[i];
          if (page) {
            page.cleanup();
          }
        }
        _this15.commonObjs.clear();
        _this15.fontLoader.clear();
      });
    }
  };
  return WorkerTransport;
}();
var PDFObjects = function PDFObjectsClosure() {
  function PDFObjects() {
    this.objs = Object.create(null);
  }
  PDFObjects.prototype = {
    ensureObj: function PDFObjects_ensureObj(objId) {
      if (this.objs[objId]) {
        return this.objs[objId];
      }
      var obj = {
        capability: (0, _util.createPromiseCapability)(),
        data: null,
        resolved: false
      };
      this.objs[objId] = obj;
      return obj;
    },
    get: function PDFObjects_get(objId, callback) {
      if (callback) {
        this.ensureObj(objId).capability.promise.then(callback);
        return null;
      }
      var obj = this.objs[objId];
      if (!obj || !obj.resolved) {
        throw new Error('Requesting object that isn\'t resolved yet ' + objId);
      }
      return obj.data;
    },
    resolve: function PDFObjects_resolve(objId, data) {
      var obj = this.ensureObj(objId);
      obj.resolved = true;
      obj.data = data;
      obj.capability.resolve(data);
    },
    isResolved: function PDFObjects_isResolved(objId) {
      var objs = this.objs;
      if (!objs[objId]) {
        return false;
      }
      return objs[objId].resolved;
    },
    hasData: function PDFObjects_hasData(objId) {
      return this.isResolved(objId);
    },
    getData: function PDFObjects_getData(objId) {
      var objs = this.objs;
      if (!objs[objId] || !objs[objId].resolved) {
        return null;
      }
      return objs[objId].data;
    },
    clear: function PDFObjects_clear() {
      this.objs = Object.create(null);
    }
  };
  return PDFObjects;
}();
var RenderTask = function RenderTaskClosure() {
  function RenderTask(internalRenderTask) {
    this._internalRenderTask = internalRenderTask;
    this.onContinue = null;
  }
  RenderTask.prototype = {
    get promise() {
      return this._internalRenderTask.capability.promise;
    },
    cancel: function RenderTask_cancel() {
      this._internalRenderTask.cancel();
    },
    then: function RenderTask_then(onFulfilled, onRejected) {
      return this.promise.then.apply(this.promise, arguments);
    }
  };
  return RenderTask;
}();
var InternalRenderTask = function InternalRenderTaskClosure() {
  var canvasInRendering = new WeakMap();
  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory, webGLContext) {
    this.callback = callback;
    this.params = params;
    this.objs = objs;
    this.commonObjs = commonObjs;
    this.operatorListIdx = null;
    this.operatorList = operatorList;
    this.pageNumber = pageNumber;
    this.canvasFactory = canvasFactory;
    this.webGLContext = webGLContext;
    this.running = false;
    this.graphicsReadyCallback = null;
    this.graphicsReady = false;
    this.useRequestAnimationFrame = false;
    this.cancelled = false;
    this.capability = (0, _util.createPromiseCapability)();
    this.task = new RenderTask(this);
    this._continueBound = this._continue.bind(this);
    this._scheduleNextBound = this._scheduleNext.bind(this);
    this._nextBound = this._next.bind(this);
    this._canvas = params.canvasContext.canvas;
  }
  InternalRenderTask.prototype = {
    initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
      if (this._canvas) {
        if (canvasInRendering.has(this._canvas)) {
          throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
        }
        canvasInRendering.set(this._canvas, this);
      }
      if (this.cancelled) {
        return;
      }
      if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _global_scope2.default.StepperManager && _global_scope2.default.StepperManager.enabled) {
        this.stepper = _global_scope2.default.StepperManager.create(this.pageNumber - 1);
        this.stepper.init(this.operatorList);
        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
      }
      var params = this.params;
      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext, params.imageLayer);
      this.gfx.beginDrawing({
        transform: params.transform,
        viewport: params.viewport,
        transparency: transparency,
        background: params.background
      });
      this.operatorListIdx = 0;
      this.graphicsReady = true;
      if (this.graphicsReadyCallback) {
        this.graphicsReadyCallback();
      }
    },
    cancel: function InternalRenderTask_cancel() {
      this.running = false;
      this.cancelled = true;
      if (this._canvas) {
        canvasInRendering.delete(this._canvas);
      }
      this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
    },
    operatorListChanged: function InternalRenderTask_operatorListChanged() {
      if (!this.graphicsReady) {
        if (!this.graphicsReadyCallback) {
          this.graphicsReadyCallback = this._continueBound;
        }
        return;
      }
      if (this.stepper) {
        this.stepper.updateOperatorList(this.operatorList);
      }
      if (this.running) {
        return;
      }
      this._continue();
    },
    _continue: function InternalRenderTask__continue() {
      this.running = true;
      if (this.cancelled) {
        return;
      }
      if (this.task.onContinue) {
        this.task.onContinue(this._scheduleNextBound);
      } else {
        this._scheduleNext();
      }
    },
    _scheduleNext: function InternalRenderTask__scheduleNext() {
      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
        window.requestAnimationFrame(this._nextBound);
      } else {
        Promise.resolve(undefined).then(this._nextBound);
      }
    },
    _next: function InternalRenderTask__next() {
      if (this.cancelled) {
        return;
      }
      this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
      if (this.operatorListIdx === this.operatorList.argsArray.length) {
        this.running = false;
        if (this.operatorList.lastChunk) {
          this.gfx.endDrawing();
          if (this._canvas) {
            canvasInRendering.delete(this._canvas);
          }
          this.callback();
        }
      }
    }
  };
  return InternalRenderTask;
}();
var version, build;
{
  exports.version = version = '2.0.305';
  exports.build = build = '9c6a8801';
}
exports.getDocument = getDocument;
exports.LoopbackPort = LoopbackPort;
exports.PDFDataRangeTransport = PDFDataRangeTransport;
exports.PDFWorker = PDFWorker;
exports.PDFDocumentProxy = PDFDocumentProxy;
exports.PDFPageProxy = PDFPageProxy;
exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
exports.version = version;
exports.build = build;

/***/ }),
/* 59 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(0);

var _dom_utils = __w_pdfjs_require__(10);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Metadata = function () {
  function Metadata(data) {
    _classCallCheck(this, Metadata);

    (0, _util.assert)(typeof data === 'string', 'Metadata: input is not a string');
    data = this._repair(data);
    var parser = new _dom_utils.SimpleXMLParser();
    data = parser.parseFromString(data);
    this._metadata = Object.create(null);
    this._parse(data);
  }

  _createClass(Metadata, [{
    key: '_repair',
    value: function _repair(data) {
      return data.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
        var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
          return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
        }).replace(/&(amp|apos|gt|lt|quot);/g, function (str, name) {
          switch (name) {
            case 'amp':
              return '&';
            case 'apos':
              return '\'';
            case 'gt':
              return '>';
            case 'lt':
              return '<';
            case 'quot':
              return '\"';
          }
          throw new Error('_repair: ' + name + ' isn\'t defined.');
        });
        var chars = '';
        for (var i = 0, ii = bytes.length; i < ii; i += 2) {
          var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
          if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) {
            chars += String.fromCharCode(code);
          } else {
            chars += '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
          }
        }
        return '>' + chars;
      });
    }
  }, {
    key: '_parse',
    value: function _parse(domDocument) {
      var rdf = domDocument.documentElement;
      if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
        rdf = rdf.firstChild;
        while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
          rdf = rdf.nextSibling;
        }
      }
      var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
      if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
        return;
      }
      var children = rdf.childNodes;
      for (var i = 0, ii = children.length; i < ii; i++) {
        var desc = children[i];
        if (desc.nodeName.toLowerCase() !== 'rdf:description') {
          continue;
        }
        for (var j = 0, jj = desc.childNodes.length; j < jj; j++) {
          if (desc.childNodes[j].nodeName.toLowerCase() !== '#text') {
            var entry = desc.childNodes[j];
            var name = entry.nodeName.toLowerCase();
            this._metadata[name] = entry.textContent.trim();
          }
        }
      }
    }
  }, {
    key: 'get',
    value: function get(name) {
      return this._metadata[name] || null;
    }
  }, {
    key: 'getAll',
    value: function getAll() {
      return this._metadata;
    }
  }, {
    key: 'has',
    value: function has(name) {
      return typeof this._metadata[name] !== 'undefined';
    }
  }]);

  return Metadata;
}();

exports.Metadata = Metadata;

/***/ }),
/* 60 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnotationLayer = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dom_utils = __w_pdfjs_require__(10);

var _util = __w_pdfjs_require__(0);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnnotationElementFactory = function () {
  function AnnotationElementFactory() {
    _classCallCheck(this, AnnotationElementFactory);
  }

  _createClass(AnnotationElementFactory, null, [{
    key: 'create',
    value: function create(parameters) {
      var subtype = parameters.data.annotationType;
      switch (subtype) {
        case _util.AnnotationType.LINK:
          return new LinkAnnotationElement(parameters);
        case _util.AnnotationType.TEXT:
          return new TextAnnotationElement(parameters);
        case _util.AnnotationType.WIDGET:
          var fieldType = parameters.data.fieldType;
          switch (fieldType) {
            case 'Tx':
              return new TextWidgetAnnotationElement(parameters);
            case 'Btn':
              if (parameters.data.radioButton) {
                return new RadioButtonWidgetAnnotationElement(parameters);
              } else if (parameters.data.checkBox) {
                return new CheckboxWidgetAnnotationElement(parameters);
              }
              return new PushButtonWidgetAnnotationElement(parameters);
            case 'Ch':
              return new ChoiceWidgetAnnotationElement(parameters);
          }
          return new WidgetAnnotationElement(parameters);
        case _util.AnnotationType.POPUP:
          return new PopupAnnotationElement(parameters);
        case _util.AnnotationType.LINE:
          return new LineAnnotationElement(parameters);
        case _util.AnnotationType.SQUARE:
          return new SquareAnnotationElement(parameters);
        case _util.AnnotationType.CIRCLE:
          return new CircleAnnotationElement(parameters);
        case _util.AnnotationType.POLYLINE:
          return new PolylineAnnotationElement(parameters);
        case _util.AnnotationType.POLYGON:
          return new PolygonAnnotationElement(parameters);
        case _util.AnnotationType.HIGHLIGHT:
          return new HighlightAnnotationElement(parameters);
        case _util.AnnotationType.UNDERLINE:
          return new UnderlineAnnotationElement(parameters);
        case _util.AnnotationType.SQUIGGLY:
          return new SquigglyAnnotationElement(parameters);
        case _util.AnnotationType.STRIKEOUT:
          return new StrikeOutAnnotationElement(parameters);
        case _util.AnnotationType.STAMP:
          return new StampAnnotationElement(parameters);
        case _util.AnnotationType.FILEATTACHMENT:
          return new FileAttachmentAnnotationElement(parameters);
        default:
          return new AnnotationElement(parameters);
      }
    }
  }]);

  return AnnotationElementFactory;
}();

var AnnotationElement = function () {
  function AnnotationElement(parameters) {
    var isRenderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var ignoreBorder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, AnnotationElement);

    this.isRenderable = isRenderable;
    this.data = parameters.data;
    this.layer = parameters.layer;
    this.page = parameters.page;
    this.viewport = parameters.viewport;
    this.linkService = parameters.linkService;
    this.downloadManager = parameters.downloadManager;
    this.imageResourcesPath = parameters.imageResourcesPath;
    this.renderInteractiveForms = parameters.renderInteractiveForms;
    this.svgFactory = parameters.svgFactory;
    if (isRenderable) {
      this.container = this._createContainer(ignoreBorder);
    }
  }

  _createClass(AnnotationElement, [{
    key: '_createContainer',
    value: function _createContainer() {
      var ignoreBorder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var data = this.data,
          page = this.page,
          viewport = this.viewport;
      var container = document.createElement('section');
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      container.setAttribute('data-annotation-id', data.id);
      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
      container.style.transform = 'matrix(' + viewport.transform.join(',') + ')';
      container.style.transformOrigin = -rect[0] + 'px ' + -rect[1] + 'px';
      if (!ignoreBorder && data.borderStyle.width > 0) {
        container.style.borderWidth = data.borderStyle.width + 'px';
        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
          width = width - 2 * data.borderStyle.width;
          height = height - 2 * data.borderStyle.width;
        }
        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
        var verticalRadius = data.borderStyle.verticalCornerRadius;
        if (horizontalRadius > 0 || verticalRadius > 0) {
          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
          container.style.borderRadius = radius;
        }
        switch (data.borderStyle.style) {
          case _util.AnnotationBorderStyleType.SOLID:
            container.style.borderStyle = 'solid';
            break;
          case _util.AnnotationBorderStyleType.DASHED:
            container.style.borderStyle = 'dashed';
            break;
          case _util.AnnotationBorderStyleType.BEVELED:
            (0, _util.warn)('Unimplemented border style: beveled');
            break;
          case _util.AnnotationBorderStyleType.INSET:
            (0, _util.warn)('Unimplemented border style: inset');
            break;
          case _util.AnnotationBorderStyleType.UNDERLINE:
            container.style.borderBottomStyle = 'solid';
            break;
          default:
            break;
        }
        if (data.color) {
          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
        } else {
          container.style.borderWidth = 0;
        }
      }
      container.style.left = rect[0] + 'px';
      container.style.top = rect[1] + 'px';
      container.style.width = width + 'px';
      container.style.height = height + 'px';
      return container;
    }
  }, {
    key: '_createPopup',
    value: function _createPopup(container, trigger, data) {
      if (!trigger) {
        trigger = document.createElement('div');
        trigger.style.height = container.style.height;
        trigger.style.width = container.style.width;
        container.appendChild(trigger);
      }
      var popupElement = new PopupElement({
        container: container,
        trigger: trigger,
        color: data.color,
        title: data.title,
        contents: data.contents,
        hideWrapper: true
      });
      var popup = popupElement.render();
      popup.style.left = container.style.width;
      container.appendChild(popup);
    }
  }, {
    key: 'render',
    value: function render() {
      (0, _util.unreachable)('Abstract method `AnnotationElement.render` called');
    }
  }]);

  return AnnotationElement;
}();

var LinkAnnotationElement = function (_AnnotationElement) {
  _inherits(LinkAnnotationElement, _AnnotationElement);

  function LinkAnnotationElement(parameters) {
    _classCallCheck(this, LinkAnnotationElement);

    var isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action);
    return _possibleConstructorReturn(this, (LinkAnnotationElement.__proto__ || Object.getPrototypeOf(LinkAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(LinkAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'linkAnnotation';
      var link = document.createElement('a');
      (0, _dom_utils.addLinkAttributes)(link, {
        url: this.data.url,
        target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
      });
      if (!this.data.url) {
        if (this.data.action) {
          this._bindNamedAction(link, this.data.action);
        } else {
          this._bindLink(link, this.data.dest);
        }
      }
      this.container.appendChild(link);
      return this.container;
    }
  }, {
    key: '_bindLink',
    value: function _bindLink(link, destination) {
      var _this2 = this;

      link.href = this.linkService.getDestinationHash(destination);
      link.onclick = function () {
        if (destination) {
          _this2.linkService.navigateTo(destination);
        }
        return false;
      };
      if (destination) {
        link.className = 'internalLink';
      }
    }
  }, {
    key: '_bindNamedAction',
    value: function _bindNamedAction(link, action) {
      var _this3 = this;

      link.href = this.linkService.getAnchorUrl('');
      link.onclick = function () {
        _this3.linkService.executeNamedAction(action);
        return false;
      };
      link.className = 'internalLink';
    }
  }]);

  return LinkAnnotationElement;
}(AnnotationElement);

var TextAnnotationElement = function (_AnnotationElement2) {
  _inherits(TextAnnotationElement, _AnnotationElement2);

  function TextAnnotationElement(parameters) {
    _classCallCheck(this, TextAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (TextAnnotationElement.__proto__ || Object.getPrototypeOf(TextAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(TextAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'textAnnotation';
      var image = document.createElement('img');
      image.style.height = this.container.style.height;
      image.style.width = this.container.style.width;
      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
      image.alt = '[{{type}} Annotation]';
      image.dataset.l10nId = 'text_annotation_type';
      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
      if (!this.data.hasPopup) {
        this._createPopup(this.container, image, this.data);
      }
      this.container.appendChild(image);
      return this.container;
    }
  }]);

  return TextAnnotationElement;
}(AnnotationElement);

var WidgetAnnotationElement = function (_AnnotationElement3) {
  _inherits(WidgetAnnotationElement, _AnnotationElement3);

  function WidgetAnnotationElement() {
    _classCallCheck(this, WidgetAnnotationElement);

    return _possibleConstructorReturn(this, (WidgetAnnotationElement.__proto__ || Object.getPrototypeOf(WidgetAnnotationElement)).apply(this, arguments));
  }

  _createClass(WidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      return this.container;
    }
  }]);

  return WidgetAnnotationElement;
}(AnnotationElement);

var TextWidgetAnnotationElement = function (_WidgetAnnotationElem) {
  _inherits(TextWidgetAnnotationElement, _WidgetAnnotationElem);

  function TextWidgetAnnotationElement(parameters) {
    _classCallCheck(this, TextWidgetAnnotationElement);

    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
    return _possibleConstructorReturn(this, (TextWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(TextWidgetAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(TextWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      var TEXT_ALIGNMENT = ['left', 'center', 'right'];
      this.container.className = 'textWidgetAnnotation';
      var element = null;
      if (this.renderInteractiveForms) {
        if (this.data.multiLine) {
          element = document.createElement('textarea');
          element.textContent = this.data.fieldValue;
        } else {
          element = document.createElement('input');
          element.type = 'text';
          element.setAttribute('value', this.data.fieldValue);
        }
        element.disabled = this.data.readOnly;
        if (this.data.maxLen !== null) {
          element.maxLength = this.data.maxLen;
        }
        if (this.data.comb) {
          var fieldWidth = this.data.rect[2] - this.data.rect[0];
          var combWidth = fieldWidth / this.data.maxLen;
          element.classList.add('comb');
          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
        }
      } else {
        element = document.createElement('div');
        element.textContent = this.data.fieldValue;
        element.style.verticalAlign = 'middle';
        element.style.display = 'table-cell';
        var font = null;
        if (this.data.fontRefName) {
          font = this.page.commonObjs.getData(this.data.fontRefName);
        }
        this._setTextStyle(element, font);
      }
      if (this.data.textAlignment !== null) {
        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
      }
      this.container.appendChild(element);
      return this.container;
    }
  }, {
    key: '_setTextStyle',
    value: function _setTextStyle(element, font) {
      var style = element.style;
      style.fontSize = this.data.fontSize + 'px';
      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
      if (!font) {
        return;
      }
      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
      style.fontStyle = font.italic ? 'italic' : 'normal';
      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
      style.fontFamily = fontFamily + fallbackName;
    }
  }]);

  return TextWidgetAnnotationElement;
}(WidgetAnnotationElement);

var CheckboxWidgetAnnotationElement = function (_WidgetAnnotationElem2) {
  _inherits(CheckboxWidgetAnnotationElement, _WidgetAnnotationElem2);

  function CheckboxWidgetAnnotationElement(parameters) {
    _classCallCheck(this, CheckboxWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (CheckboxWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(CheckboxWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(CheckboxWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'buttonWidgetAnnotation checkBox';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'checkbox';
      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
        element.setAttribute('checked', true);
      }
      this.container.appendChild(element);
      return this.container;
    }
  }]);

  return CheckboxWidgetAnnotationElement;
}(WidgetAnnotationElement);

var RadioButtonWidgetAnnotationElement = function (_WidgetAnnotationElem3) {
  _inherits(RadioButtonWidgetAnnotationElement, _WidgetAnnotationElem3);

  function RadioButtonWidgetAnnotationElement(parameters) {
    _classCallCheck(this, RadioButtonWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (RadioButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(RadioButtonWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(RadioButtonWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'buttonWidgetAnnotation radioButton';
      var element = document.createElement('input');
      element.disabled = this.data.readOnly;
      element.type = 'radio';
      element.name = this.data.fieldName;
      if (this.data.fieldValue === this.data.buttonValue) {
        element.setAttribute('checked', true);
      }
      this.container.appendChild(element);
      return this.container;
    }
  }]);

  return RadioButtonWidgetAnnotationElement;
}(WidgetAnnotationElement);

var PushButtonWidgetAnnotationElement = function (_LinkAnnotationElemen) {
  _inherits(PushButtonWidgetAnnotationElement, _LinkAnnotationElemen);

  function PushButtonWidgetAnnotationElement() {
    _classCallCheck(this, PushButtonWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (PushButtonWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(PushButtonWidgetAnnotationElement)).apply(this, arguments));
  }

  _createClass(PushButtonWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      var container = _get(PushButtonWidgetAnnotationElement.prototype.__proto__ || Object.getPrototypeOf(PushButtonWidgetAnnotationElement.prototype), 'render', this).call(this);
      container.className = 'buttonWidgetAnnotation pushButton';
      return container;
    }
  }]);

  return PushButtonWidgetAnnotationElement;
}(LinkAnnotationElement);

var ChoiceWidgetAnnotationElement = function (_WidgetAnnotationElem4) {
  _inherits(ChoiceWidgetAnnotationElement, _WidgetAnnotationElem4);

  function ChoiceWidgetAnnotationElement(parameters) {
    _classCallCheck(this, ChoiceWidgetAnnotationElement);

    return _possibleConstructorReturn(this, (ChoiceWidgetAnnotationElement.__proto__ || Object.getPrototypeOf(ChoiceWidgetAnnotationElement)).call(this, parameters, parameters.renderInteractiveForms));
  }

  _createClass(ChoiceWidgetAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'choiceWidgetAnnotation';
      var selectElement = document.createElement('select');
      selectElement.disabled = this.data.readOnly;
      if (!this.data.combo) {
        selectElement.size = this.data.options.length;
        if (this.data.multiSelect) {
          selectElement.multiple = true;
        }
      }
      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
        var option = this.data.options[i];
        var optionElement = document.createElement('option');
        optionElement.textContent = option.displayValue;
        optionElement.value = option.exportValue;
        if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
          optionElement.setAttribute('selected', true);
        }
        selectElement.appendChild(optionElement);
      }
      this.container.appendChild(selectElement);
      return this.container;
    }
  }]);

  return ChoiceWidgetAnnotationElement;
}(WidgetAnnotationElement);

var PopupAnnotationElement = function (_AnnotationElement4) {
  _inherits(PopupAnnotationElement, _AnnotationElement4);

  function PopupAnnotationElement(parameters) {
    _classCallCheck(this, PopupAnnotationElement);

    var isRenderable = !!(parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (PopupAnnotationElement.__proto__ || Object.getPrototypeOf(PopupAnnotationElement)).call(this, parameters, isRenderable));
  }

  _createClass(PopupAnnotationElement, [{
    key: 'render',
    value: function render() {
      var IGNORE_TYPES = ['Line', 'Square', 'Circle', 'PolyLine', 'Polygon'];
      this.container.className = 'popupAnnotation';
      if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
        return this.container;
      }
      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
      var parentElement = this.layer.querySelector(selector);
      if (!parentElement) {
        return this.container;
      }
      var popup = new PopupElement({
        container: this.container,
        trigger: parentElement,
        color: this.data.color,
        title: this.data.title,
        contents: this.data.contents
      });
      var parentLeft = parseFloat(parentElement.style.left);
      var parentWidth = parseFloat(parentElement.style.width);
      this.container.style.transformOrigin = -(parentLeft + parentWidth) + 'px -' + parentElement.style.top;
      this.container.style.left = parentLeft + parentWidth + 'px';
      this.container.appendChild(popup.render());
      return this.container;
    }
  }]);

  return PopupAnnotationElement;
}(AnnotationElement);

var PopupElement = function () {
  function PopupElement(parameters) {
    _classCallCheck(this, PopupElement);

    this.container = parameters.container;
    this.trigger = parameters.trigger;
    this.color = parameters.color;
    this.title = parameters.title;
    this.contents = parameters.contents;
    this.hideWrapper = parameters.hideWrapper || false;
    this.pinned = false;
  }

  _createClass(PopupElement, [{
    key: 'render',
    value: function render() {
      var BACKGROUND_ENLIGHT = 0.7;
      var wrapper = document.createElement('div');
      wrapper.className = 'popupWrapper';
      this.hideElement = this.hideWrapper ? wrapper : this.container;
      this.hideElement.setAttribute('hidden', true);
      var popup = document.createElement('div');
      popup.className = 'popup';
      var color = this.color;
      if (color) {
        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
      }
      var contents = this._formatContents(this.contents);
      var title = document.createElement('h1');
      title.textContent = this.title;
      this.trigger.addEventListener('click', this._toggle.bind(this));
      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
      popup.addEventListener('click', this._hide.bind(this, true));
      popup.appendChild(title);
      popup.appendChild(contents);
      wrapper.appendChild(popup);
      return wrapper;
    }
  }, {
    key: '_formatContents',
    value: function _formatContents(contents) {
      var p = document.createElement('p');
      var lines = contents.split(/(?:\r\n?|\n)/);
      for (var i = 0, ii = lines.length; i < ii; ++i) {
        var line = lines[i];
        p.appendChild(document.createTextNode(line));
        if (i < ii - 1) {
          p.appendChild(document.createElement('br'));
        }
      }
      return p;
    }
  }, {
    key: '_toggle',
    value: function _toggle() {
      if (this.pinned) {
        this._hide(true);
      } else {
        this._show(true);
      }
    }
  }, {
    key: '_show',
    value: function _show() {
      var pin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (pin) {
        this.pinned = true;
      }
      if (this.hideElement.hasAttribute('hidden')) {
        this.hideElement.removeAttribute('hidden');
        this.container.style.zIndex += 1;
      }
    }
  }, {
    key: '_hide',
    value: function _hide() {
      var unpin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (unpin) {
        this.pinned = false;
      }
      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
        this.hideElement.setAttribute('hidden', true);
        this.container.style.zIndex -= 1;
      }
    }
  }]);

  return PopupElement;
}();

var LineAnnotationElement = function (_AnnotationElement5) {
  _inherits(LineAnnotationElement, _AnnotationElement5);

  function LineAnnotationElement(parameters) {
    _classCallCheck(this, LineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (LineAnnotationElement.__proto__ || Object.getPrototypeOf(LineAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(LineAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'lineAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var line = this.svgFactory.createElement('svg:line');
      line.setAttribute('x1', data.rect[2] - data.lineCoordinates[0]);
      line.setAttribute('y1', data.rect[3] - data.lineCoordinates[1]);
      line.setAttribute('x2', data.rect[2] - data.lineCoordinates[2]);
      line.setAttribute('y2', data.rect[3] - data.lineCoordinates[3]);
      line.setAttribute('stroke-width', data.borderStyle.width);
      line.setAttribute('stroke', 'transparent');
      svg.appendChild(line);
      this.container.append(svg);
      this._createPopup(this.container, line, data);
      return this.container;
    }
  }]);

  return LineAnnotationElement;
}(AnnotationElement);

var SquareAnnotationElement = function (_AnnotationElement6) {
  _inherits(SquareAnnotationElement, _AnnotationElement6);

  function SquareAnnotationElement(parameters) {
    _classCallCheck(this, SquareAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (SquareAnnotationElement.__proto__ || Object.getPrototypeOf(SquareAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(SquareAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'squareAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var borderWidth = data.borderStyle.width;
      var square = this.svgFactory.createElement('svg:rect');
      square.setAttribute('x', borderWidth / 2);
      square.setAttribute('y', borderWidth / 2);
      square.setAttribute('width', width - borderWidth);
      square.setAttribute('height', height - borderWidth);
      square.setAttribute('stroke-width', borderWidth);
      square.setAttribute('stroke', 'transparent');
      square.setAttribute('fill', 'none');
      svg.appendChild(square);
      this.container.append(svg);
      this._createPopup(this.container, square, data);
      return this.container;
    }
  }]);

  return SquareAnnotationElement;
}(AnnotationElement);

var CircleAnnotationElement = function (_AnnotationElement7) {
  _inherits(CircleAnnotationElement, _AnnotationElement7);

  function CircleAnnotationElement(parameters) {
    _classCallCheck(this, CircleAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (CircleAnnotationElement.__proto__ || Object.getPrototypeOf(CircleAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(CircleAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'circleAnnotation';
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var borderWidth = data.borderStyle.width;
      var circle = this.svgFactory.createElement('svg:ellipse');
      circle.setAttribute('cx', width / 2);
      circle.setAttribute('cy', height / 2);
      circle.setAttribute('rx', width / 2 - borderWidth / 2);
      circle.setAttribute('ry', height / 2 - borderWidth / 2);
      circle.setAttribute('stroke-width', borderWidth);
      circle.setAttribute('stroke', 'transparent');
      circle.setAttribute('fill', 'none');
      svg.appendChild(circle);
      this.container.append(svg);
      this._createPopup(this.container, circle, data);
      return this.container;
    }
  }]);

  return CircleAnnotationElement;
}(AnnotationElement);

var PolylineAnnotationElement = function (_AnnotationElement8) {
  _inherits(PolylineAnnotationElement, _AnnotationElement8);

  function PolylineAnnotationElement(parameters) {
    _classCallCheck(this, PolylineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);

    var _this15 = _possibleConstructorReturn(this, (PolylineAnnotationElement.__proto__ || Object.getPrototypeOf(PolylineAnnotationElement)).call(this, parameters, isRenderable, true));

    _this15.containerClassName = 'polylineAnnotation';
    _this15.svgElementName = 'svg:polyline';
    return _this15;
  }

  _createClass(PolylineAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = this.containerClassName;
      var data = this.data;
      var width = data.rect[2] - data.rect[0];
      var height = data.rect[3] - data.rect[1];
      var svg = this.svgFactory.create(width, height);
      var vertices = data.vertices;
      var points = [];
      for (var i = 0, ii = vertices.length; i < ii; i++) {
        var x = vertices[i].x - data.rect[0];
        var y = data.rect[3] - vertices[i].y;
        points.push(x + ',' + y);
      }
      points = points.join(' ');
      var borderWidth = data.borderStyle.width;
      var polyline = this.svgFactory.createElement(this.svgElementName);
      polyline.setAttribute('points', points);
      polyline.setAttribute('stroke-width', borderWidth);
      polyline.setAttribute('stroke', 'transparent');
      polyline.setAttribute('fill', 'none');
      svg.appendChild(polyline);
      this.container.append(svg);
      this._createPopup(this.container, polyline, data);
      return this.container;
    }
  }]);

  return PolylineAnnotationElement;
}(AnnotationElement);

var PolygonAnnotationElement = function (_PolylineAnnotationEl) {
  _inherits(PolygonAnnotationElement, _PolylineAnnotationEl);

  function PolygonAnnotationElement(parameters) {
    _classCallCheck(this, PolygonAnnotationElement);

    var _this16 = _possibleConstructorReturn(this, (PolygonAnnotationElement.__proto__ || Object.getPrototypeOf(PolygonAnnotationElement)).call(this, parameters));

    _this16.containerClassName = 'polygonAnnotation';
    _this16.svgElementName = 'svg:polygon';
    return _this16;
  }

  return PolygonAnnotationElement;
}(PolylineAnnotationElement);

var HighlightAnnotationElement = function (_AnnotationElement9) {
  _inherits(HighlightAnnotationElement, _AnnotationElement9);

  function HighlightAnnotationElement(parameters) {
    _classCallCheck(this, HighlightAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (HighlightAnnotationElement.__proto__ || Object.getPrototypeOf(HighlightAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(HighlightAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'highlightAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return HighlightAnnotationElement;
}(AnnotationElement);

var UnderlineAnnotationElement = function (_AnnotationElement10) {
  _inherits(UnderlineAnnotationElement, _AnnotationElement10);

  function UnderlineAnnotationElement(parameters) {
    _classCallCheck(this, UnderlineAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (UnderlineAnnotationElement.__proto__ || Object.getPrototypeOf(UnderlineAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(UnderlineAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'underlineAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return UnderlineAnnotationElement;
}(AnnotationElement);

var SquigglyAnnotationElement = function (_AnnotationElement11) {
  _inherits(SquigglyAnnotationElement, _AnnotationElement11);

  function SquigglyAnnotationElement(parameters) {
    _classCallCheck(this, SquigglyAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (SquigglyAnnotationElement.__proto__ || Object.getPrototypeOf(SquigglyAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(SquigglyAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'squigglyAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return SquigglyAnnotationElement;
}(AnnotationElement);

var StrikeOutAnnotationElement = function (_AnnotationElement12) {
  _inherits(StrikeOutAnnotationElement, _AnnotationElement12);

  function StrikeOutAnnotationElement(parameters) {
    _classCallCheck(this, StrikeOutAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (StrikeOutAnnotationElement.__proto__ || Object.getPrototypeOf(StrikeOutAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(StrikeOutAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'strikeoutAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return StrikeOutAnnotationElement;
}(AnnotationElement);

var StampAnnotationElement = function (_AnnotationElement13) {
  _inherits(StampAnnotationElement, _AnnotationElement13);

  function StampAnnotationElement(parameters) {
    _classCallCheck(this, StampAnnotationElement);

    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
    return _possibleConstructorReturn(this, (StampAnnotationElement.__proto__ || Object.getPrototypeOf(StampAnnotationElement)).call(this, parameters, isRenderable, true));
  }

  _createClass(StampAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'stampAnnotation';
      if (!this.data.hasPopup) {
        this._createPopup(this.container, null, this.data);
      }
      return this.container;
    }
  }]);

  return StampAnnotationElement;
}(AnnotationElement);

var FileAttachmentAnnotationElement = function (_AnnotationElement14) {
  _inherits(FileAttachmentAnnotationElement, _AnnotationElement14);

  function FileAttachmentAnnotationElement(parameters) {
    _classCallCheck(this, FileAttachmentAnnotationElement);

    var _this22 = _possibleConstructorReturn(this, (FileAttachmentAnnotationElement.__proto__ || Object.getPrototypeOf(FileAttachmentAnnotationElement)).call(this, parameters, true));

    var file = _this22.data.file;
    _this22.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
    _this22.content = file.content;
    _this22.linkService.onFileAttachmentAnnotation({
      id: (0, _util.stringToPDFString)(file.filename),
      filename: file.filename,
      content: file.content
    });
    return _this22;
  }

  _createClass(FileAttachmentAnnotationElement, [{
    key: 'render',
    value: function render() {
      this.container.className = 'fileAttachmentAnnotation';
      var trigger = document.createElement('div');
      trigger.style.height = this.container.style.height;
      trigger.style.width = this.container.style.width;
      trigger.addEventListener('dblclick', this._download.bind(this));
      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
        this._createPopup(this.container, trigger, this.data);
      }
      this.container.appendChild(trigger);
      return this.container;
    }
  }, {
    key: '_download',
    value: function _download() {
      if (!this.downloadManager) {
        (0, _util.warn)('Download cannot be started due to unavailable download manager');
        return;
      }
      this.downloadManager.downloadData(this.content, this.filename, '');
    }
  }]);

  return FileAttachmentAnnotationElement;
}(AnnotationElement);

var AnnotationLayer = function () {
  function AnnotationLayer() {
    _classCallCheck(this, AnnotationLayer);
  }

  _createClass(AnnotationLayer, null, [{
    key: 'render',
    value: function render(parameters) {
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        if (!data) {
          continue;
        }
        var element = AnnotationElementFactory.create({
          data: data,
          layer: parameters.div,
          page: parameters.page,
          viewport: parameters.viewport,
          linkService: parameters.linkService,
          downloadManager: parameters.downloadManager,
          imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)('imageResourcesPath'),
          renderInteractiveForms: parameters.renderInteractiveForms || false,
          svgFactory: new _dom_utils.DOMSVGFactory()
        });
        if (element.isRenderable) {
          parameters.div.appendChild(element.render());
        }
      }
    }
  }, {
    key: 'update',
    value: function update(parameters) {
      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
        var data = parameters.annotations[i];
        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
        if (element) {
          element.style.transform = 'matrix(' + parameters.viewport.transform.join(',') + ')';
        }
      }
      parameters.div.removeAttribute('hidden');
    }
  }]);

  return AnnotationLayer;
}();

exports.AnnotationLayer = AnnotationLayer;

/***/ }),
/* 61 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderTextLayer = undefined;

var _util = __w_pdfjs_require__(0);

var _dom_utils = __w_pdfjs_require__(10);

var renderTextLayer = function renderTextLayerClosure() {
  var MAX_TEXT_DIVS_TO_RENDER = 100000;
  var NonWhitespaceRegexp = /\S/;
  function isAllWhitespace(str) {
    return !NonWhitespaceRegexp.test(str);
  }
  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
  function appendText(task, geom, styles) {
    var textDiv = document.createElement('div');
    var textDivProperties = {
      style: null,
      angle: 0,
      canvasWidth: 0,
      isWhitespace: false,
      originalTransform: null,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      scale: 1
    };
    task._textDivs.push(textDiv);
    if (isAllWhitespace(geom.str)) {
      textDivProperties.isWhitespace = true;
      task._textDivProperties.set(textDiv, textDivProperties);
      return;
    }
    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
    var angle = Math.atan2(tx[1], tx[0]);
    var style = styles[geom.fontName];
    if (style.vertical) {
      angle += Math.PI / 2;
    }
    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
    var fontAscent = fontHeight;
    if (style.ascent) {
      fontAscent = style.ascent * fontAscent;
    } else if (style.descent) {
      fontAscent = (1 + style.descent) * fontAscent;
    }
    var left;
    var top;
    if (angle === 0) {
      left = tx[4];
      top = tx[5] - fontAscent;
    } else {
      left = tx[4] + fontAscent * Math.sin(angle);
      top = tx[5] - fontAscent * Math.cos(angle);
    }
    styleBuf[1] = left;
    styleBuf[3] = top;
    styleBuf[5] = fontHeight;
    styleBuf[7] = style.fontFamily;
    textDivProperties.style = styleBuf.join('');
    textDiv.setAttribute('style', textDivProperties.style);
    textDiv.textContent = geom.str;
    if ((0, _dom_utils.getDefaultSetting)('pdfBug')) {
      textDiv.dataset.fontName = geom.fontName;
    }
    if (angle !== 0) {
      textDivProperties.angle = angle * (180 / Math.PI);
    }
    if (geom.str.length > 1) {
      if (style.vertical) {
        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
      } else {
        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
      }
    }
    task._textDivProperties.set(textDiv, textDivProperties);
    if (task._textContentStream) {
      task._layoutText(textDiv);
    }
    if (task._enhanceTextSelection) {
      var angleCos = 1,
          angleSin = 0;
      if (angle !== 0) {
        angleCos = Math.cos(angle);
        angleSin = Math.sin(angle);
      }
      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
      var divHeight = fontHeight;
      var m, b;
      if (angle !== 0) {
        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
      } else {
        b = [left, top, left + divWidth, top + divHeight];
      }
      task._bounds.push({
        left: b[0],
        top: b[1],
        right: b[2],
        bottom: b[3],
        div: textDiv,
        size: [divWidth, divHeight],
        m: m
      });
    }
  }
  function render(task) {
    if (task._canceled) {
      return;
    }
    var textDivs = task._textDivs;
    var capability = task._capability;
    var textDivsLength = textDivs.length;
    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
      task._renderingDone = true;
      capability.resolve();
      return;
    }
    if (!task._textContentStream) {
      for (var i = 0; i < textDivsLength; i++) {
        task._layoutText(textDivs[i]);
      }
    }
    task._renderingDone = true;
    capability.resolve();
  }
  function expand(task) {
    var bounds = task._bounds;
    var viewport = task._viewport;
    var expanded = expandBounds(viewport.width, viewport.height, bounds);
    for (var i = 0; i < expanded.length; i++) {
      var div = bounds[i].div;
      var divProperties = task._textDivProperties.get(div);
      if (divProperties.angle === 0) {
        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
        divProperties.paddingTop = bounds[i].top - expanded[i].top;
        divProperties.paddingRight = expanded[i].right - bounds[i].right;
        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
        task._textDivProperties.set(div, divProperties);
        continue;
      }
      var e = expanded[i],
          b = bounds[i];
      var m = b.m,
          c = m[0],
          s = m[1];
      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
      var ts = new Float64Array(64);
      points.forEach(function (p, i) {
        var t = _util.Util.applyTransform(p, m);
        ts[i + 0] = c && (e.left - t[0]) / c;
        ts[i + 4] = s && (e.top - t[1]) / s;
        ts[i + 8] = c && (e.right - t[0]) / c;
        ts[i + 12] = s && (e.bottom - t[1]) / s;
        ts[i + 16] = s && (e.left - t[0]) / -s;
        ts[i + 20] = c && (e.top - t[1]) / c;
        ts[i + 24] = s && (e.right - t[0]) / -s;
        ts[i + 28] = c && (e.bottom - t[1]) / c;
        ts[i + 32] = c && (e.left - t[0]) / -c;
        ts[i + 36] = s && (e.top - t[1]) / -s;
        ts[i + 40] = c && (e.right - t[0]) / -c;
        ts[i + 44] = s && (e.bottom - t[1]) / -s;
        ts[i + 48] = s && (e.left - t[0]) / s;
        ts[i + 52] = c && (e.top - t[1]) / -c;
        ts[i + 56] = s && (e.right - t[0]) / s;
        ts[i + 60] = c && (e.bottom - t[1]) / -c;
      });
      var findPositiveMin = function findPositiveMin(ts, offset, count) {
        var result = 0;
        for (var i = 0; i < count; i++) {
          var t = ts[offset++];
          if (t > 0) {
            result = result ? Math.min(t, result) : t;
          }
        }
        return result;
      };
      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
      task._textDivProperties.set(div, divProperties);
    }
  }
  function expandBounds(width, height, boxes) {
    var bounds = boxes.map(function (box, i) {
      return {
        x1: box.left,
        y1: box.top,
        x2: box.right,
        y2: box.bottom,
        index: i,
        x1New: undefined,
        x2New: undefined
      };
    });
    expandBoundsLTR(width, bounds);
    var expanded = new Array(boxes.length);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i] = {
        left: b.x1New,
        top: 0,
        right: b.x2New,
        bottom: 0
      };
    });
    boxes.map(function (box, i) {
      var e = expanded[i],
          b = bounds[i];
      b.x1 = box.top;
      b.y1 = width - e.right;
      b.x2 = box.bottom;
      b.y2 = width - e.left;
      b.index = i;
      b.x1New = undefined;
      b.x2New = undefined;
    });
    expandBoundsLTR(height, bounds);
    bounds.forEach(function (b) {
      var i = b.index;
      expanded[i].top = b.x1New;
      expanded[i].bottom = b.x2New;
    });
    return expanded;
  }
  function expandBoundsLTR(width, bounds) {
    bounds.sort(function (a, b) {
      return a.x1 - b.x1 || a.index - b.index;
    });
    var fakeBoundary = {
      x1: -Infinity,
      y1: -Infinity,
      x2: 0,
      y2: Infinity,
      index: -1,
      x1New: 0,
      x2New: 0
    };
    var horizon = [{
      start: -Infinity,
      end: Infinity,
      boundary: fakeBoundary
    }];
    bounds.forEach(function (boundary) {
      var i = 0;
      while (i < horizon.length && horizon[i].end <= boundary.y1) {
        i++;
      }
      var j = horizon.length - 1;
      while (j >= 0 && horizon[j].start >= boundary.y2) {
        j--;
      }
      var horizonPart, affectedBoundary;
      var q,
          k,
          maxXNew = -Infinity;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var xNew;
        if (affectedBoundary.x2 > boundary.x1) {
          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
        } else if (affectedBoundary.x2New === undefined) {
          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
        } else {
          xNew = affectedBoundary.x2New;
        }
        if (xNew > maxXNew) {
          maxXNew = xNew;
        }
      }
      boundary.x1New = maxXNew;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        if (affectedBoundary.x2New === undefined) {
          if (affectedBoundary.x2 > boundary.x1) {
            if (affectedBoundary.index > boundary.index) {
              affectedBoundary.x2New = affectedBoundary.x2;
            }
          } else {
            affectedBoundary.x2New = maxXNew;
          }
        } else if (affectedBoundary.x2New > maxXNew) {
          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
        }
      }
      var changedHorizon = [],
          lastBoundary = null;
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
        if (lastBoundary === useBoundary) {
          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
        } else {
          changedHorizon.push({
            start: horizonPart.start,
            end: horizonPart.end,
            boundary: useBoundary
          });
          lastBoundary = useBoundary;
        }
      }
      if (horizon[i].start < boundary.y1) {
        changedHorizon[0].start = boundary.y1;
        changedHorizon.unshift({
          start: horizon[i].start,
          end: boundary.y1,
          boundary: horizon[i].boundary
        });
      }
      if (boundary.y2 < horizon[j].end) {
        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
        changedHorizon.push({
          start: boundary.y2,
          end: horizon[j].end,
          boundary: horizon[j].boundary
        });
      }
      for (q = i; q <= j; q++) {
        horizonPart = horizon[q];
        affectedBoundary = horizonPart.boundary;
        if (affectedBoundary.x2New !== undefined) {
          continue;
        }
        var used = false;
        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
          used = horizon[k].boundary === affectedBoundary;
        }
        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
          used = horizon[k].boundary === affectedBoundary;
        }
        for (k = 0; !used && k < changedHorizon.length; k++) {
          used = changedHorizon[k].boundary === affectedBoundary;
        }
        if (!used) {
          affectedBoundary.x2New = maxXNew;
        }
      }
      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
    });
    horizon.forEach(function (horizonPart) {
      var affectedBoundary = horizonPart.boundary;
      if (affectedBoundary.x2New === undefined) {
        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
      }
    });
  }
  function TextLayerRenderTask(_ref) {
    var textContent = _ref.textContent,
        textContentStream = _ref.textContentStream,
        container = _ref.container,
        viewport = _ref.viewport,
        textDivs = _ref.textDivs,
        textContentItemsStr = _ref.textContentItemsStr,
        enhanceTextSelection = _ref.enhanceTextSelection;

    this._textContent = textContent;
    this._textContentStream = textContentStream;
    this._container = container;
    this._viewport = viewport;
    this._textDivs = textDivs || [];
    this._textContentItemsStr = textContentItemsStr || [];
    this._enhanceTextSelection = !!enhanceTextSelection;
    this._reader = null;
    this._layoutTextLastFontSize = null;
    this._layoutTextLastFontFamily = null;
    this._layoutTextCtx = null;
    this._textDivProperties = new WeakMap();
    this._renderingDone = false;
    this._canceled = false;
    this._capability = (0, _util.createPromiseCapability)();
    this._renderTimer = null;
    this._bounds = [];
  }
  TextLayerRenderTask.prototype = {
    get promise() {
      return this._capability.promise;
    },
    cancel: function TextLayer_cancel() {
      if (this._reader) {
        this._reader.cancel(new _util.AbortException('text layer task cancelled'));
        this._reader = null;
      }
      this._canceled = true;
      if (this._renderTimer !== null) {
        clearTimeout(this._renderTimer);
        this._renderTimer = null;
      }
      this._capability.reject('canceled');
    },
    _processItems: function _processItems(items, styleCache) {
      for (var i = 0, len = items.length; i < len; i++) {
        this._textContentItemsStr.push(items[i].str);
        appendText(this, items[i], styleCache);
      }
    },
    _layoutText: function _layoutText(textDiv) {
      var textLayerFrag = this._container;
      var textDivProperties = this._textDivProperties.get(textDiv);
      if (textDivProperties.isWhitespace) {
        return;
      }
      var fontSize = textDiv.style.fontSize;
      var fontFamily = textDiv.style.fontFamily;
      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
        this._lastFontSize = fontSize;
        this._lastFontFamily = fontFamily;
      }
      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
      var transform = '';
      if (textDivProperties.canvasWidth !== 0 && width > 0) {
        textDivProperties.scale = textDivProperties.canvasWidth / width;
        transform = 'scaleX(' + textDivProperties.scale + ')';
      }
      if (textDivProperties.angle !== 0) {
        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
      }
      if (transform !== '') {
        textDivProperties.originalTransform = transform;
        textDiv.style.transform = transform;
      }
      this._textDivProperties.set(textDiv, textDivProperties);
      textLayerFrag.appendChild(textDiv);
    },

    _render: function TextLayer_render(timeout) {
      var _this = this;

      var capability = (0, _util.createPromiseCapability)();
      var styleCache = Object.create(null);
      var canvas = document.createElement('canvas');
      canvas.mozOpaque = true;
      this._layoutTextCtx = canvas.getContext('2d', { alpha: false });
      if (this._textContent) {
        var textItems = this._textContent.items;
        var textStyles = this._textContent.styles;
        this._processItems(textItems, textStyles);
        capability.resolve();
      } else if (this._textContentStream) {
        var pump = function pump() {
          _this._reader.read().then(function (_ref2) {
            var value = _ref2.value,
                done = _ref2.done;

            if (done) {
              capability.resolve();
              return;
            }
            _util.Util.extendObj(styleCache, value.styles);
            _this._processItems(value.items, styleCache);
            pump();
          }, capability.reject);
        };
        this._reader = this._textContentStream.getReader();
        pump();
      } else {
        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
      }
      capability.promise.then(function () {
        styleCache = null;
        if (!timeout) {
          render(_this);
        } else {
          _this._renderTimer = setTimeout(function () {
            render(_this);
            _this._renderTimer = null;
          }, timeout);
        }
      }, this._capability.reject);
    },
    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
      if (!this._enhanceTextSelection || !this._renderingDone) {
        return;
      }
      if (this._bounds !== null) {
        expand(this);
        this._bounds = null;
      }
      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
        var div = this._textDivs[i];
        var divProperties = this._textDivProperties.get(div);
        if (divProperties.isWhitespace) {
          continue;
        }
        if (expandDivs) {
          var transform = '',
              padding = '';
          if (divProperties.scale !== 1) {
            transform = 'scaleX(' + divProperties.scale + ')';
          }
          if (divProperties.angle !== 0) {
            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
          }
          if (divProperties.paddingLeft !== 0) {
            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
          }
          if (divProperties.paddingTop !== 0) {
            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
          }
          if (divProperties.paddingRight !== 0) {
            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
          }
          if (divProperties.paddingBottom !== 0) {
            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
          }
          if (padding !== '') {
            div.setAttribute('style', divProperties.style + padding);
          }
          if (transform !== '') {
            div.style.transform = transform;
          }
        } else {
          div.style.padding = 0;
          div.style.transform = divProperties.originalTransform || '';
        }
      }
    }
  };
  function renderTextLayer(renderParameters) {
    var task = new TextLayerRenderTask({
      textContent: renderParameters.textContent,
      textContentStream: renderParameters.textContentStream,
      container: renderParameters.container,
      viewport: renderParameters.viewport,
      textDivs: renderParameters.textDivs,
      textContentItemsStr: renderParameters.textContentItemsStr,
      enhanceTextSelection: renderParameters.enhanceTextSelection
    });
    task._render(renderParameters.timeout);
    return task;
  }
  return renderTextLayer;
}();
exports.renderTextLayer = renderTextLayer;

/***/ }),
/* 62 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVGGraphics = undefined;

var _util = __w_pdfjs_require__(0);

var _dom_utils = __w_pdfjs_require__(10);

var _is_node = __w_pdfjs_require__(24);

var _is_node2 = _interopRequireDefault(_is_node);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVGGraphics = function SVGGraphics() {
  throw new Error('Not implemented: SVGGraphics');
};
{
  var SVG_DEFAULTS = {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fillColor: '#000000'
  };
  var convertImgDataToPng = function convertImgDataToPngClosure() {
    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
    var CHUNK_WRAPPER_SIZE = 12;
    var crcTable = new Int32Array(256);
    for (var i = 0; i < 256; i++) {
      var c = i;
      for (var h = 0; h < 8; h++) {
        if (c & 1) {
          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
        } else {
          c = c >> 1 & 0x7fffffff;
        }
      }
      crcTable[i] = c;
    }
    function crc32(data, start, end) {
      var crc = -1;
      for (var i = start; i < end; i++) {
        var a = (crc ^ data[i]) & 0xff;
        var b = crcTable[a];
        crc = crc >>> 8 ^ b;
      }
      return crc ^ -1;
    }
    function writePngChunk(type, body, data, offset) {
      var p = offset;
      var len = body.length;
      data[p] = len >> 24 & 0xff;
      data[p + 1] = len >> 16 & 0xff;
      data[p + 2] = len >> 8 & 0xff;
      data[p + 3] = len & 0xff;
      p += 4;
      data[p] = type.charCodeAt(0) & 0xff;
      data[p + 1] = type.charCodeAt(1) & 0xff;
      data[p + 2] = type.charCodeAt(2) & 0xff;
      data[p + 3] = type.charCodeAt(3) & 0xff;
      p += 4;
      data.set(body, p);
      p += body.length;
      var crc = crc32(data, offset + 4, p);
      data[p] = crc >> 24 & 0xff;
      data[p + 1] = crc >> 16 & 0xff;
      data[p + 2] = crc >> 8 & 0xff;
      data[p + 3] = crc & 0xff;
    }
    function adler32(data, start, end) {
      var a = 1;
      var b = 0;
      for (var i = start; i < end; ++i) {
        a = (a + (data[i] & 0xff)) % 65521;
        b = (b + a) % 65521;
      }
      return b << 16 | a;
    }
    function deflateSync(literals) {
      if (!(0, _is_node2.default)()) {
        return deflateSyncUncompressed(literals);
      }
      try {
        var input;
        if (parseInt(process.versions.node) >= 8) {
          input = literals;
        } else {
          input = new Buffer(literals);
        }
        var output = __webpack_require__(1039).deflateSync(input, { level: 9 });
        return output instanceof Uint8Array ? output : new Uint8Array(output);
      } catch (e) {
        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
      }
      return deflateSyncUncompressed(literals);
    }
    function deflateSyncUncompressed(literals) {
      var len = literals.length;
      var maxBlockLength = 0xFFFF;
      var deflateBlocks = Math.ceil(len / maxBlockLength);
      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
      var pi = 0;
      idat[pi++] = 0x78;
      idat[pi++] = 0x9c;
      var pos = 0;
      while (len > maxBlockLength) {
        idat[pi++] = 0x00;
        idat[pi++] = 0xff;
        idat[pi++] = 0xff;
        idat[pi++] = 0x00;
        idat[pi++] = 0x00;
        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
        pi += maxBlockLength;
        pos += maxBlockLength;
        len -= maxBlockLength;
      }
      idat[pi++] = 0x01;
      idat[pi++] = len & 0xff;
      idat[pi++] = len >> 8 & 0xff;
      idat[pi++] = ~len & 0xffff & 0xff;
      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
      idat.set(literals.subarray(pos), pi);
      pi += literals.length - pos;
      var adler = adler32(literals, 0, literals.length);
      idat[pi++] = adler >> 24 & 0xff;
      idat[pi++] = adler >> 16 & 0xff;
      idat[pi++] = adler >> 8 & 0xff;
      idat[pi++] = adler & 0xff;
      return idat;
    }
    function encode(imgData, kind, forceDataSchema, isMask) {
      var width = imgData.width;
      var height = imgData.height;
      var bitDepth, colorType, lineSize;
      var bytes = imgData.data;
      switch (kind) {
        case _util.ImageKind.GRAYSCALE_1BPP:
          colorType = 0;
          bitDepth = 1;
          lineSize = width + 7 >> 3;
          break;
        case _util.ImageKind.RGB_24BPP:
          colorType = 2;
          bitDepth = 8;
          lineSize = width * 3;
          break;
        case _util.ImageKind.RGBA_32BPP:
          colorType = 6;
          bitDepth = 8;
          lineSize = width * 4;
          break;
        default:
          throw new Error('invalid format');
      }
      var literals = new Uint8Array((1 + lineSize) * height);
      var offsetLiterals = 0,
          offsetBytes = 0;
      var y, i;
      for (y = 0; y < height; ++y) {
        literals[offsetLiterals++] = 0;
        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
        offsetBytes += lineSize;
        offsetLiterals += lineSize;
      }
      if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
        offsetLiterals = 0;
        for (y = 0; y < height; y++) {
          offsetLiterals++;
          for (i = 0; i < lineSize; i++) {
            literals[offsetLiterals++] ^= 0xFF;
          }
        }
      }
      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
      var idat = deflateSync(literals);
      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
      var data = new Uint8Array(pngLength);
      var offset = 0;
      data.set(PNG_HEADER, offset);
      offset += PNG_HEADER.length;
      writePngChunk('IHDR', ihdr, data, offset);
      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
      writePngChunk('IDATA', idat, data, offset);
      offset += CHUNK_WRAPPER_SIZE + idat.length;
      writePngChunk('IEND', new Uint8Array(0), data, offset);
      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
    }
    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
      return encode(imgData, kind, forceDataSchema, isMask);
    };
  }();
  var SVGExtraState = function SVGExtraStateClosure() {
    function SVGExtraState() {
      this.fontSizeScale = 1;
      this.fontWeight = SVG_DEFAULTS.fontWeight;
      this.fontSize = 0;
      this.textMatrix = _util.IDENTITY_MATRIX;
      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
      this.leading = 0;
      this.x = 0;
      this.y = 0;
      this.lineX = 0;
      this.lineY = 0;
      this.charSpacing = 0;
      this.wordSpacing = 0;
      this.textHScale = 1;
      this.textRise = 0;
      this.fillColor = SVG_DEFAULTS.fillColor;
      this.strokeColor = '#000000';
      this.fillAlpha = 1;
      this.strokeAlpha = 1;
      this.lineWidth = 1;
      this.lineJoin = '';
      this.lineCap = '';
      this.miterLimit = 0;
      this.dashArray = [];
      this.dashPhase = 0;
      this.dependencies = [];
      this.activeClipUrl = null;
      this.clipGroup = null;
      this.maskId = '';
    }
    SVGExtraState.prototype = {
      clone: function SVGExtraState_clone() {
        return Object.create(this);
      },
      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
        this.x = x;
        this.y = y;
      }
    };
    return SVGExtraState;
  }();
  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
    function opListToTree(opList) {
      var opTree = [];
      var tmp = [];
      var opListLen = opList.length;
      for (var x = 0; x < opListLen; x++) {
        if (opList[x].fn === 'save') {
          opTree.push({
            'fnId': 92,
            'fn': 'group',
            'items': []
          });
          tmp.push(opTree);
          opTree = opTree[opTree.length - 1].items;
          continue;
        }
        if (opList[x].fn === 'restore') {
          opTree = tmp.pop();
        } else {
          opTree.push(opList[x]);
        }
      }
      return opTree;
    }
    function pf(value) {
      if (Number.isInteger(value)) {
        return value.toString();
      }
      var s = value.toFixed(10);
      var i = s.length - 1;
      if (s[i] !== '0') {
        return s;
      }
      do {
        i--;
      } while (s[i] === '0');
      return s.substr(0, s[i] === '.' ? i : i + 1);
    }
    function pm(m) {
      if (m[4] === 0 && m[5] === 0) {
        if (m[1] === 0 && m[2] === 0) {
          if (m[0] === 1 && m[3] === 1) {
            return '';
          }
          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
        }
        if (m[0] === m[3] && m[1] === -m[2]) {
          var a = Math.acos(m[0]) * 180 / Math.PI;
          return 'rotate(' + pf(a) + ')';
        }
      } else {
        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
        }
      }
      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
    }
    function SVGGraphics(commonObjs, objs, forceDataSchema) {
      this.svgFactory = new _dom_utils.DOMSVGFactory();
      this.current = new SVGExtraState();
      this.transformMatrix = _util.IDENTITY_MATRIX;
      this.transformStack = [];
      this.extraStack = [];
      this.commonObjs = commonObjs;
      this.objs = objs;
      this.pendingClip = null;
      this.pendingEOFill = false;
      this.embedFonts = false;
      this.embeddedFonts = Object.create(null);
      this.cssStyle = null;
      this.forceDataSchema = !!forceDataSchema;
    }
    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
    var XLINK_NS = 'http://www.w3.org/1999/xlink';
    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
    var clipCount = 0;
    var maskCount = 0;
    SVGGraphics.prototype = {
      save: function SVGGraphics_save() {
        this.transformStack.push(this.transformMatrix);
        var old = this.current;
        this.extraStack.push(old);
        this.current = old.clone();
      },
      restore: function SVGGraphics_restore() {
        this.transformMatrix = this.transformStack.pop();
        this.current = this.extraStack.pop();
        this.pendingClip = null;
        this.tgrp = null;
      },
      group: function SVGGraphics_group(items) {
        this.save();
        this.executeOpTree(items);
        this.restore();
      },
      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
        var _this = this;

        var fnArray = operatorList.fnArray;
        var fnArrayLen = fnArray.length;
        var argsArray = operatorList.argsArray;
        for (var i = 0; i < fnArrayLen; i++) {
          if (_util.OPS.dependency === fnArray[i]) {
            var deps = argsArray[i];
            for (var n = 0, nn = deps.length; n < nn; n++) {
              var obj = deps[n];
              var common = obj.substring(0, 2) === 'g_';
              var promise;
              if (common) {
                promise = new Promise(function (resolve) {
                  _this.commonObjs.get(obj, resolve);
                });
              } else {
                promise = new Promise(function (resolve) {
                  _this.objs.get(obj, resolve);
                });
              }
              this.current.dependencies.push(promise);
            }
          }
        }
        return Promise.all(this.current.dependencies);
      },
      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
        var transformMatrix = [a, b, c, d, e, f];
        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
        this.tgrp = null;
      },
      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
        var _this2 = this;

        this.viewport = viewport;
        var svgElement = this._initialize(viewport);
        return this.loadDependencies(operatorList).then(function () {
          _this2.transformMatrix = _util.IDENTITY_MATRIX;
          var opTree = _this2.convertOpList(operatorList);
          _this2.executeOpTree(opTree);
          return svgElement;
        });
      },
      convertOpList: function SVGGraphics_convertOpList(operatorList) {
        var argsArray = operatorList.argsArray;
        var fnArray = operatorList.fnArray;
        var fnArrayLen = fnArray.length;
        var REVOPS = [];
        var opList = [];
        for (var op in _util.OPS) {
          REVOPS[_util.OPS[op]] = op;
        }
        for (var x = 0; x < fnArrayLen; x++) {
          var fnId = fnArray[x];
          opList.push({
            'fnId': fnId,
            'fn': REVOPS[fnId],
            'args': argsArray[x]
          });
        }
        return opListToTree(opList);
      },
      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
        var opTreeLen = opTree.length;
        for (var x = 0; x < opTreeLen; x++) {
          var fn = opTree[x].fn;
          var fnId = opTree[x].fnId;
          var args = opTree[x].args;
          switch (fnId | 0) {
            case _util.OPS.beginText:
              this.beginText();
              break;
            case _util.OPS.setLeading:
              this.setLeading(args);
              break;
            case _util.OPS.setLeadingMoveText:
              this.setLeadingMoveText(args[0], args[1]);
              break;
            case _util.OPS.setFont:
              this.setFont(args);
              break;
            case _util.OPS.showText:
              this.showText(args[0]);
              break;
            case _util.OPS.showSpacedText:
              this.showText(args[0]);
              break;
            case _util.OPS.endText:
              this.endText();
              break;
            case _util.OPS.moveText:
              this.moveText(args[0], args[1]);
              break;
            case _util.OPS.setCharSpacing:
              this.setCharSpacing(args[0]);
              break;
            case _util.OPS.setWordSpacing:
              this.setWordSpacing(args[0]);
              break;
            case _util.OPS.setHScale:
              this.setHScale(args[0]);
              break;
            case _util.OPS.setTextMatrix:
              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
              break;
            case _util.OPS.setTextRise:
              this.setTextRise(args[0]);
              break;
            case _util.OPS.setLineWidth:
              this.setLineWidth(args[0]);
              break;
            case _util.OPS.setLineJoin:
              this.setLineJoin(args[0]);
              break;
            case _util.OPS.setLineCap:
              this.setLineCap(args[0]);
              break;
            case _util.OPS.setMiterLimit:
              this.setMiterLimit(args[0]);
              break;
            case _util.OPS.setFillRGBColor:
              this.setFillRGBColor(args[0], args[1], args[2]);
              break;
            case _util.OPS.setStrokeRGBColor:
              this.setStrokeRGBColor(args[0], args[1], args[2]);
              break;
            case _util.OPS.setDash:
              this.setDash(args[0], args[1]);
              break;
            case _util.OPS.setGState:
              this.setGState(args[0]);
              break;
            case _util.OPS.fill:
              this.fill();
              break;
            case _util.OPS.eoFill:
              this.eoFill();
              break;
            case _util.OPS.stroke:
              this.stroke();
              break;
            case _util.OPS.fillStroke:
              this.fillStroke();
              break;
            case _util.OPS.eoFillStroke:
              this.eoFillStroke();
              break;
            case _util.OPS.clip:
              this.clip('nonzero');
              break;
            case _util.OPS.eoClip:
              this.clip('evenodd');
              break;
            case _util.OPS.paintSolidColorImageMask:
              this.paintSolidColorImageMask();
              break;
            case _util.OPS.paintJpegXObject:
              this.paintJpegXObject(args[0], args[1], args[2]);
              break;
            case _util.OPS.paintImageXObject:
              this.paintImageXObject(args[0]);
              break;
            case _util.OPS.paintInlineImageXObject:
              this.paintInlineImageXObject(args[0]);
              break;
            case _util.OPS.paintImageMaskXObject:
              this.paintImageMaskXObject(args[0]);
              break;
            case _util.OPS.paintFormXObjectBegin:
              this.paintFormXObjectBegin(args[0], args[1]);
              break;
            case _util.OPS.paintFormXObjectEnd:
              this.paintFormXObjectEnd();
              break;
            case _util.OPS.closePath:
              this.closePath();
              break;
            case _util.OPS.closeStroke:
              this.closeStroke();
              break;
            case _util.OPS.closeFillStroke:
              this.closeFillStroke();
              break;
            case _util.OPS.closeEOFillStroke:
              this.closeEOFillStroke();
              break;
            case _util.OPS.nextLine:
              this.nextLine();
              break;
            case _util.OPS.transform:
              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
              break;
            case _util.OPS.constructPath:
              this.constructPath(args[0], args[1]);
              break;
            case _util.OPS.endPath:
              this.endPath();
              break;
            case 92:
              this.group(opTree[x].items);
              break;
            default:
              (0, _util.warn)('Unimplemented operator ' + fn);
              break;
          }
        }
      },
      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
        this.current.wordSpacing = wordSpacing;
      },
      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
        this.current.charSpacing = charSpacing;
      },
      nextLine: function SVGGraphics_nextLine() {
        this.moveText(0, this.current.leading);
      },
      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
        var current = this.current;
        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        current.xcoords = [];
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.txtElement = this.svgFactory.createElement('svg:text');
        current.txtElement.appendChild(current.tspan);
      },
      beginText: function SVGGraphics_beginText() {
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        this.current.textMatrix = _util.IDENTITY_MATRIX;
        this.current.lineMatrix = _util.IDENTITY_MATRIX;
        this.current.tspan = this.svgFactory.createElement('svg:tspan');
        this.current.txtElement = this.svgFactory.createElement('svg:text');
        this.current.txtgrp = this.svgFactory.createElement('svg:g');
        this.current.xcoords = [];
      },
      moveText: function SVGGraphics_moveText(x, y) {
        var current = this.current;
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
        current.xcoords = [];
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
      },
      showText: function SVGGraphics_showText(glyphs) {
        var current = this.current;
        var font = current.font;
        var fontSize = current.fontSize;
        if (fontSize === 0) {
          return;
        }
        var charSpacing = current.charSpacing;
        var wordSpacing = current.wordSpacing;
        var fontDirection = current.fontDirection;
        var textHScale = current.textHScale * fontDirection;
        var glyphsLength = glyphs.length;
        var vertical = font.vertical;
        var widthAdvanceScale = fontSize * current.fontMatrix[0];
        var x = 0,
            i;
        for (i = 0; i < glyphsLength; ++i) {
          var glyph = glyphs[i];
          if (glyph === null) {
            x += fontDirection * wordSpacing;
            continue;
          } else if ((0, _util.isNum)(glyph)) {
            x += -glyph * fontSize * 0.001;
            continue;
          }
          var width = glyph.width;
          var character = glyph.fontChar;
          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
          if (!glyph.isInFont && !font.missingFile) {
            x += charWidth;
            continue;
          }
          current.xcoords.push(current.x + x * textHScale);
          current.tspan.textContent += character;
          x += charWidth;
        }
        if (vertical) {
          current.y -= x * textHScale;
        } else {
          current.x += x * textHScale;
        }
        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
        }
        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
        }
        if (current.fillColor !== SVG_DEFAULTS.fillColor) {
          current.tspan.setAttributeNS(null, 'fill', current.fillColor);
        }
        var textMatrix = current.textMatrix;
        if (current.textRise !== 0) {
          textMatrix = textMatrix.slice();
          textMatrix[5] += current.textRise;
        }
        current.txtElement.setAttributeNS(null, 'transform', pm(textMatrix) + ' scale(1, -1)');
        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
        current.txtElement.appendChild(current.tspan);
        current.txtgrp.appendChild(current.txtElement);
        this._ensureTransformGroup().appendChild(current.txtElement);
      },
      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
        this.setLeading(-y);
        this.moveText(x, y);
      },
      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
        if (!this.cssStyle) {
          this.cssStyle = this.svgFactory.createElement('svg:style');
          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
          this.defs.appendChild(this.cssStyle);
        }
        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
      },
      setFont: function SVGGraphics_setFont(details) {
        var current = this.current;
        var fontObj = this.commonObjs.get(details[0]);
        var size = details[1];
        this.current.font = fontObj;
        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
          this.addFontStyle(fontObj);
          this.embeddedFonts[fontObj.loadedName] = fontObj;
        }
        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
        var italic = fontObj.italic ? 'italic' : 'normal';
        if (size < 0) {
          size = -size;
          current.fontDirection = -1;
        } else {
          current.fontDirection = 1;
        }
        current.fontSize = size;
        current.fontFamily = fontObj.loadedName;
        current.fontWeight = bold;
        current.fontStyle = italic;
        current.tspan = this.svgFactory.createElement('svg:tspan');
        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
        current.xcoords = [];
      },
      endText: function SVGGraphics_endText() {},
      setLineWidth: function SVGGraphics_setLineWidth(width) {
        this.current.lineWidth = width;
      },
      setLineCap: function SVGGraphics_setLineCap(style) {
        this.current.lineCap = LINE_CAP_STYLES[style];
      },
      setLineJoin: function SVGGraphics_setLineJoin(style) {
        this.current.lineJoin = LINE_JOIN_STYLES[style];
      },
      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
        this.current.miterLimit = limit;
      },
      setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
        this.current.strokeAlpha = strokeAlpha;
      },
      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
        var color = _util.Util.makeCssRgb(r, g, b);
        this.current.strokeColor = color;
      },
      setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
        this.current.fillAlpha = fillAlpha;
      },
      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
        var color = _util.Util.makeCssRgb(r, g, b);
        this.current.fillColor = color;
        this.current.tspan = this.svgFactory.createElement('svg:tspan');
        this.current.xcoords = [];
      },
      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
        this.current.dashArray = dashArray;
        this.current.dashPhase = dashPhase;
      },
      constructPath: function SVGGraphics_constructPath(ops, args) {
        var current = this.current;
        var x = current.x,
            y = current.y;
        current.path = this.svgFactory.createElement('svg:path');
        var d = [];
        var opLength = ops.length;
        for (var i = 0, j = 0; i < opLength; i++) {
          switch (ops[i] | 0) {
            case _util.OPS.rectangle:
              x = args[j++];
              y = args[j++];
              var width = args[j++];
              var height = args[j++];
              var xw = x + width;
              var yh = y + height;
              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
              break;
            case _util.OPS.moveTo:
              x = args[j++];
              y = args[j++];
              d.push('M', pf(x), pf(y));
              break;
            case _util.OPS.lineTo:
              x = args[j++];
              y = args[j++];
              d.push('L', pf(x), pf(y));
              break;
            case _util.OPS.curveTo:
              x = args[j + 4];
              y = args[j + 5];
              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
              j += 6;
              break;
            case _util.OPS.curveTo2:
              x = args[j + 2];
              y = args[j + 3];
              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
              j += 4;
              break;
            case _util.OPS.curveTo3:
              x = args[j + 2];
              y = args[j + 3];
              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
              j += 4;
              break;
            case _util.OPS.closePath:
              d.push('Z');
              break;
          }
        }
        current.path.setAttributeNS(null, 'd', d.join(' '));
        current.path.setAttributeNS(null, 'fill', 'none');
        this._ensureTransformGroup().appendChild(current.path);
        current.element = current.path;
        current.setCurrentPoint(x, y);
      },
      endPath: function SVGGraphics_endPath() {
        if (!this.pendingClip) {
          return;
        }
        var current = this.current;
        var clipId = 'clippath' + clipCount;
        clipCount++;
        var clipPath = this.svgFactory.createElement('svg:clipPath');
        clipPath.setAttributeNS(null, 'id', clipId);
        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
        var clipElement = current.element.cloneNode();
        if (this.pendingClip === 'evenodd') {
          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
        } else {
          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
        }
        this.pendingClip = null;
        clipPath.appendChild(clipElement);
        this.defs.appendChild(clipPath);
        if (current.activeClipUrl) {
          current.clipGroup = null;
          this.extraStack.forEach(function (prev) {
            prev.clipGroup = null;
          });
        }
        current.activeClipUrl = 'url(#' + clipId + ')';
        this.tgrp = null;
      },
      clip: function SVGGraphics_clip(type) {
        this.pendingClip = type;
      },
      closePath: function SVGGraphics_closePath() {
        var current = this.current;
        if (current.path) {
          var d = current.path.getAttributeNS(null, 'd');
          d += 'Z';
          current.path.setAttributeNS(null, 'd', d);
        }
      },
      setLeading: function SVGGraphics_setLeading(leading) {
        this.current.leading = -leading;
      },
      setTextRise: function SVGGraphics_setTextRise(textRise) {
        this.current.textRise = textRise;
      },
      setHScale: function SVGGraphics_setHScale(scale) {
        this.current.textHScale = scale / 100;
      },
      setGState: function SVGGraphics_setGState(states) {
        for (var i = 0, ii = states.length; i < ii; i++) {
          var state = states[i];
          var key = state[0];
          var value = state[1];
          switch (key) {
            case 'LW':
              this.setLineWidth(value);
              break;
            case 'LC':
              this.setLineCap(value);
              break;
            case 'LJ':
              this.setLineJoin(value);
              break;
            case 'ML':
              this.setMiterLimit(value);
              break;
            case 'D':
              this.setDash(value[0], value[1]);
              break;
            case 'Font':
              this.setFont(value);
              break;
            case 'CA':
              this.setStrokeAlpha(value);
              break;
            case 'ca':
              this.setFillAlpha(value);
              break;
            default:
              (0, _util.warn)('Unimplemented graphic state ' + key);
              break;
          }
        }
      },
      fill: function SVGGraphics_fill() {
        var current = this.current;
        if (current.element) {
          current.element.setAttributeNS(null, 'fill', current.fillColor);
          current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
        }
      },
      stroke: function SVGGraphics_stroke() {
        var current = this.current;
        if (current.element) {
          current.element.setAttributeNS(null, 'stroke', current.strokeColor);
          current.element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
          current.element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
          current.element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
          current.element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
          current.element.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
          current.element.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
          current.element.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
          current.element.setAttributeNS(null, 'fill', 'none');
        }
      },
      eoFill: function SVGGraphics_eoFill() {
        if (this.current.element) {
          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        }
        this.fill();
      },
      fillStroke: function SVGGraphics_fillStroke() {
        this.stroke();
        this.fill();
      },
      eoFillStroke: function SVGGraphics_eoFillStroke() {
        if (this.current.element) {
          this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
        }
        this.fillStroke();
      },
      closeStroke: function SVGGraphics_closeStroke() {
        this.closePath();
        this.stroke();
      },
      closeFillStroke: function SVGGraphics_closeFillStroke() {
        this.closePath();
        this.fillStroke();
      },
      closeEOFillStroke: function closeEOFillStroke() {
        this.closePath();
        this.eoFillStroke();
      },

      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
        var current = this.current;
        var rect = this.svgFactory.createElement('svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', '1px');
        rect.setAttributeNS(null, 'height', '1px');
        rect.setAttributeNS(null, 'fill', current.fillColor);
        this._ensureTransformGroup().appendChild(rect);
      },
      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
        var imgObj = this.objs.get(objId);
        var imgEl = this.svgFactory.createElement('svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
        imgEl.setAttributeNS(null, 'width', pf(w));
        imgEl.setAttributeNS(null, 'height', pf(h));
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-h));
        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
        this._ensureTransformGroup().appendChild(imgEl);
      },
      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
        var imgData = this.objs.get(objId);
        if (!imgData) {
          (0, _util.warn)('Dependent image isn\'t ready yet');
          return;
        }
        this.paintInlineImageXObject(imgData);
      },
      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
        var width = imgData.width;
        var height = imgData.height;
        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
        var cliprect = this.svgFactory.createElement('svg:rect');
        cliprect.setAttributeNS(null, 'x', '0');
        cliprect.setAttributeNS(null, 'y', '0');
        cliprect.setAttributeNS(null, 'width', pf(width));
        cliprect.setAttributeNS(null, 'height', pf(height));
        this.current.element = cliprect;
        this.clip('nonzero');
        var imgEl = this.svgFactory.createElement('svg:image');
        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
        imgEl.setAttributeNS(null, 'x', '0');
        imgEl.setAttributeNS(null, 'y', pf(-height));
        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
        if (mask) {
          mask.appendChild(imgEl);
        } else {
          this._ensureTransformGroup().appendChild(imgEl);
        }
      },
      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
        var current = this.current;
        var width = imgData.width;
        var height = imgData.height;
        var fillColor = current.fillColor;
        current.maskId = 'mask' + maskCount++;
        var mask = this.svgFactory.createElement('svg:mask');
        mask.setAttributeNS(null, 'id', current.maskId);
        var rect = this.svgFactory.createElement('svg:rect');
        rect.setAttributeNS(null, 'x', '0');
        rect.setAttributeNS(null, 'y', '0');
        rect.setAttributeNS(null, 'width', pf(width));
        rect.setAttributeNS(null, 'height', pf(height));
        rect.setAttributeNS(null, 'fill', fillColor);
        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
        this.defs.appendChild(mask);
        this._ensureTransformGroup().appendChild(rect);
        this.paintInlineImageXObject(imgData, mask);
      },
      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
        if (Array.isArray(matrix) && matrix.length === 6) {
          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
        }
        if (Array.isArray(bbox) && bbox.length === 4) {
          var width = bbox[2] - bbox[0];
          var height = bbox[3] - bbox[1];
          var cliprect = this.svgFactory.createElement('svg:rect');
          cliprect.setAttributeNS(null, 'x', bbox[0]);
          cliprect.setAttributeNS(null, 'y', bbox[1]);
          cliprect.setAttributeNS(null, 'width', pf(width));
          cliprect.setAttributeNS(null, 'height', pf(height));
          this.current.element = cliprect;
          this.clip('nonzero');
          this.endPath();
        }
      },
      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
      _initialize: function _initialize(viewport) {
        var svg = this.svgFactory.create(viewport.width, viewport.height);
        var definitions = this.svgFactory.createElement('svg:defs');
        svg.appendChild(definitions);
        this.defs = definitions;
        var rootGroup = this.svgFactory.createElement('svg:g');
        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
        svg.appendChild(rootGroup);
        this.svg = rootGroup;
        return svg;
      },

      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
        if (!this.current.clipGroup) {
          var clipGroup = this.svgFactory.createElement('svg:g');
          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
          this.svg.appendChild(clipGroup);
          this.current.clipGroup = clipGroup;
        }
        return this.current.clipGroup;
      },
      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
        if (!this.tgrp) {
          this.tgrp = this.svgFactory.createElement('svg:g');
          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
          if (this.current.activeClipUrl) {
            this._ensureClipGroup().appendChild(this.tgrp);
          } else {
            this.svg.appendChild(this.tgrp);
          }
        }
        return this.tgrp;
      }
    };
    return SVGGraphics;
  }();
}
exports.SVGGraphics = SVGGraphics;

/***/ }),
/* 63 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pdfjsVersion = '2.0.305';
var pdfjsBuild = '9c6a8801';
var pdfjsSharedUtil = __w_pdfjs_require__(0);
var pdfjsDisplayGlobal = __w_pdfjs_require__(115);
var pdfjsDisplayAPI = __w_pdfjs_require__(58);
var pdfjsDisplayTextLayer = __w_pdfjs_require__(61);
var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(60);
var pdfjsDisplayDOMUtils = __w_pdfjs_require__(10);
var pdfjsDisplaySVG = __w_pdfjs_require__(62);
{
  var isNodeJS = __w_pdfjs_require__(24);
  if (isNodeJS()) {
    var PDFNodeStream = __w_pdfjs_require__(121).PDFNodeStream;
    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFNodeStream(params);
    });
  } else if (typeof Response !== 'undefined' && 'body' in Response.prototype && typeof ReadableStream !== 'undefined') {
    var PDFFetchStream = __w_pdfjs_require__(123).PDFFetchStream;
    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFFetchStream(params);
    });
  } else {
    var PDFNetworkStream = __w_pdfjs_require__(124).PDFNetworkStream;
    pdfjsDisplayAPI.setPDFNetworkStreamFactory(function (params) {
      return new PDFNetworkStream(params);
    });
  }
}
exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
exports.build = pdfjsDisplayAPI.build;
exports.version = pdfjsDisplayAPI.version;
exports.getDocument = pdfjsDisplayAPI.getDocument;
exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
exports.OPS = pdfjsSharedUtil.OPS;
exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
exports.shadow = pdfjsSharedUtil.shadow;
exports.createBlob = pdfjsSharedUtil.createBlob;
exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;

/***/ }),
/* 64 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
  var globalScope = __w_pdfjs_require__(14);
  var isNodeJS = __w_pdfjs_require__(24);
  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
  var isAndroid = /Android/.test(userAgent);
  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
  var isIE = userAgent.indexOf('Trident') >= 0;
  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
  if (typeof PDFJS === 'undefined') {
    globalScope.PDFJS = {};
  }
  PDFJS.compatibilityChecked = true;
  (function checkNodeBtoa() {
    if (globalScope.btoa || !isNodeJS()) {
      return;
    }
    globalScope.btoa = function (chars) {
      return Buffer.from(chars, 'binary').toString('base64');
    };
  })();
  (function checkNodeAtob() {
    if (globalScope.atob || !isNodeJS()) {
      return;
    }
    globalScope.atob = function (input) {
      return Buffer.from(input, 'base64').toString('binary');
    };
  })();
  (function checkOnBlobSupport() {
    if (isIE || isIOSChrome) {
      PDFJS.disableCreateObjectURL = true;
    }
  })();
  (function checkNavigatorLanguage() {
    if (typeof navigator === 'undefined') {
      return;
    }
    if ('language' in navigator) {
      return;
    }
    PDFJS.locale = navigator.userLanguage || 'en-US';
  })();
  (function checkRangeRequests() {
    if (isSafari || isIOS) {
      PDFJS.disableRange = true;
      PDFJS.disableStream = true;
    }
  })();
  (function checkCanvasSizeLimitation() {
    if (isIOS || isAndroid) {
      PDFJS.maxCanvasPixels = 5242880;
    }
  })();
  (function checkFullscreenSupport() {
    if (!hasDOM) {
      return;
    }
    if (isIE && window.parent !== window) {
      PDFJS.disableFullscreen = true;
    }
  })();
  (function checkCurrentScript() {
    if (!hasDOM) {
      return;
    }
    if ('currentScript' in document) {
      return;
    }
    Object.defineProperty(document, 'currentScript', {
      get: function get() {
        var scripts = document.getElementsByTagName('script');
        return scripts[scripts.length - 1];
      },

      enumerable: true,
      configurable: true
    });
  })();
  (function checkChildNodeRemove() {
    if (!hasDOM) {
      return;
    }
    if (typeof Element.prototype.remove !== 'undefined') {
      return;
    }
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  })();
  (function checkArrayIncludes() {
    if (Array.prototype.includes) {
      return;
    }
    Array.prototype.includes = __w_pdfjs_require__(65);
  })();
  (function checkMathLog2() {
    if (Math.log2) {
      return;
    }
    Math.log2 = __w_pdfjs_require__(68);
  })();
  (function checkNumberIsNaN() {
    if (Number.isNaN) {
      return;
    }
    Number.isNaN = __w_pdfjs_require__(70);
  })();
  (function checkNumberIsInteger() {
    if (Number.isInteger) {
      return;
    }
    Number.isInteger = __w_pdfjs_require__(72);
  })();
  (function checkPromise() {
    if (globalScope.Promise) {
      return;
    }
    globalScope.Promise = __w_pdfjs_require__(75);
  })();
  (function checkWeakMap() {
    if (globalScope.WeakMap) {
      return;
    }
    globalScope.WeakMap = __w_pdfjs_require__(94);
  })();
  (function checkURLConstructor() {
    var hasWorkingUrl = false;
    try {
      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
        var u = new URL('b', 'http://a');
        u.pathname = 'c%20d';
        hasWorkingUrl = u.href === 'http://a/c%20d';
      }
    } catch (e) {}
    if (hasWorkingUrl) {
      return;
    }
    var relative = Object.create(null);
    relative['ftp'] = 21;
    relative['file'] = 0;
    relative['gopher'] = 70;
    relative['http'] = 80;
    relative['https'] = 443;
    relative['ws'] = 80;
    relative['wss'] = 443;
    var relativePathDotMapping = Object.create(null);
    relativePathDotMapping['%2e'] = '.';
    relativePathDotMapping['.%2e'] = '..';
    relativePathDotMapping['%2e.'] = '..';
    relativePathDotMapping['%2e%2e'] = '..';
    function isRelativeScheme(scheme) {
      return relative[scheme] !== undefined;
    }
    function invalid() {
      clear.call(this);
      this._isInvalid = true;
    }
    function IDNAToASCII(h) {
      if (h === '') {
        invalid.call(this);
      }
      return h.toLowerCase();
    }
    function percentEscape(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    function percentEscapeQuery(c) {
      var unicode = c.charCodeAt(0);
      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
        return c;
      }
      return encodeURIComponent(c);
    }
    var EOF,
        ALPHA = /[a-zA-Z]/,
        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
    function parse(input, stateOverride, base) {
      function err(message) {
        errors.push(message);
      }
      var state = stateOverride || 'scheme start',
          cursor = 0,
          buffer = '',
          seenAt = false,
          seenBracket = false,
          errors = [];
      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
        var c = input[cursor];
        switch (state) {
          case 'scheme start':
            if (c && ALPHA.test(c)) {
              buffer += c.toLowerCase();
              state = 'scheme';
            } else if (!stateOverride) {
              buffer = '';
              state = 'no scheme';
              continue;
            } else {
              err('Invalid scheme.');
              break loop;
            }
            break;
          case 'scheme':
            if (c && ALPHANUMERIC.test(c)) {
              buffer += c.toLowerCase();
            } else if (c === ':') {
              this._scheme = buffer;
              buffer = '';
              if (stateOverride) {
                break loop;
              }
              if (isRelativeScheme(this._scheme)) {
                this._isRelative = true;
              }
              if (this._scheme === 'file') {
                state = 'relative';
              } else if (this._isRelative && base && base._scheme === this._scheme) {
                state = 'relative or authority';
              } else if (this._isRelative) {
                state = 'authority first slash';
              } else {
                state = 'scheme data';
              }
            } else if (!stateOverride) {
              buffer = '';
              cursor = 0;
              state = 'no scheme';
              continue;
            } else if (c === EOF) {
              break loop;
            } else {
              err('Code point not allowed in scheme: ' + c);
              break loop;
            }
            break;
          case 'scheme data':
            if (c === '?') {
              this._query = '?';
              state = 'query';
            } else if (c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else {
              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
                this._schemeData += percentEscape(c);
              }
            }
            break;
          case 'no scheme':
            if (!base || !isRelativeScheme(base._scheme)) {
              err('Missing scheme.');
              invalid.call(this);
            } else {
              state = 'relative';
              continue;
            }
            break;
          case 'relative or authority':
            if (c === '/' && input[cursor + 1] === '/') {
              state = 'authority ignore slashes';
            } else {
              err('Expected /, got: ' + c);
              state = 'relative';
              continue;
            }
            break;
          case 'relative':
            this._isRelative = true;
            if (this._scheme !== 'file') {
              this._scheme = base._scheme;
            }
            if (c === EOF) {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._username = base._username;
              this._password = base._password;
              break loop;
            } else if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              state = 'relative slash';
            } else if (c === '?') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = '?';
              this._username = base._username;
              this._password = base._password;
              state = 'query';
            } else if (c === '#') {
              this._host = base._host;
              this._port = base._port;
              this._path = base._path.slice();
              this._query = base._query;
              this._fragment = '#';
              this._username = base._username;
              this._password = base._password;
              state = 'fragment';
            } else {
              var nextC = input[cursor + 1];
              var nextNextC = input[cursor + 2];
              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
                this._path = base._path.slice();
                this._path.pop();
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'relative slash':
            if (c === '/' || c === '\\') {
              if (c === '\\') {
                err('\\ is an invalid code point.');
              }
              if (this._scheme === 'file') {
                state = 'file host';
              } else {
                state = 'authority ignore slashes';
              }
            } else {
              if (this._scheme !== 'file') {
                this._host = base._host;
                this._port = base._port;
                this._username = base._username;
                this._password = base._password;
              }
              state = 'relative path';
              continue;
            }
            break;
          case 'authority first slash':
            if (c === '/') {
              state = 'authority second slash';
            } else {
              err('Expected \'/\', got: ' + c);
              state = 'authority ignore slashes';
              continue;
            }
            break;
          case 'authority second slash':
            state = 'authority ignore slashes';
            if (c !== '/') {
              err('Expected \'/\', got: ' + c);
              continue;
            }
            break;
          case 'authority ignore slashes':
            if (c !== '/' && c !== '\\') {
              state = 'authority';
              continue;
            } else {
              err('Expected authority, got: ' + c);
            }
            break;
          case 'authority':
            if (c === '@') {
              if (seenAt) {
                err('@ already seen.');
                buffer += '%40';
              }
              seenAt = true;
              for (var i = 0; i < buffer.length; i++) {
                var cp = buffer[i];
                if (cp === '\t' || cp === '\n' || cp === '\r') {
                  err('Invalid whitespace in authority.');
                  continue;
                }
                if (cp === ':' && this._password === null) {
                  this._password = '';
                  continue;
                }
                var tempC = percentEscape(cp);
                if (this._password !== null) {
                  this._password += tempC;
                } else {
                  this._username += tempC;
                }
              }
              buffer = '';
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              cursor -= buffer.length;
              buffer = '';
              state = 'host';
              continue;
            } else {
              buffer += c;
            }
            break;
          case 'file host':
            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
                state = 'relative path';
              } else if (buffer.length === 0) {
                state = 'relative path start';
              } else {
                this._host = IDNAToASCII.call(this, buffer);
                buffer = '';
                state = 'relative path start';
              }
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid whitespace in file host.');
            } else {
              buffer += c;
            }
            break;
          case 'host':
          case 'hostname':
            if (c === ':' && !seenBracket) {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'port';
              if (stateOverride === 'hostname') {
                break loop;
              }
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
              this._host = IDNAToASCII.call(this, buffer);
              buffer = '';
              state = 'relative path start';
              if (stateOverride) {
                break loop;
              }
              continue;
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              if (c === '[') {
                seenBracket = true;
              } else if (c === ']') {
                seenBracket = false;
              }
              buffer += c;
            } else {
              err('Invalid code point in host/hostname: ' + c);
            }
            break;
          case 'port':
            if (/[0-9]/.test(c)) {
              buffer += c;
            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
              if (buffer !== '') {
                var temp = parseInt(buffer, 10);
                if (temp !== relative[this._scheme]) {
                  this._port = temp + '';
                }
                buffer = '';
              }
              if (stateOverride) {
                break loop;
              }
              state = 'relative path start';
              continue;
            } else if (c === '\t' || c === '\n' || c === '\r') {
              err('Invalid code point in port: ' + c);
            } else {
              invalid.call(this);
            }
            break;
          case 'relative path start':
            if (c === '\\') {
              err('\'\\\' not allowed in path.');
            }
            state = 'relative path';
            if (c !== '/' && c !== '\\') {
              continue;
            }
            break;
          case 'relative path':
            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
              if (c === '\\') {
                err('\\ not allowed in relative path.');
              }
              var tmp;
              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
                buffer = tmp;
              }
              if (buffer === '..') {
                this._path.pop();
                if (c !== '/' && c !== '\\') {
                  this._path.push('');
                }
              } else if (buffer === '.' && c !== '/' && c !== '\\') {
                this._path.push('');
              } else if (buffer !== '.') {
                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
                  buffer = buffer[0] + ':';
                }
                this._path.push(buffer);
              }
              buffer = '';
              if (c === '?') {
                this._query = '?';
                state = 'query';
              } else if (c === '#') {
                this._fragment = '#';
                state = 'fragment';
              }
            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
              buffer += percentEscape(c);
            }
            break;
          case 'query':
            if (!stateOverride && c === '#') {
              this._fragment = '#';
              state = 'fragment';
            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._query += percentEscapeQuery(c);
            }
            break;
          case 'fragment':
            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
              this._fragment += c;
            }
            break;
        }
        cursor++;
      }
    }
    function clear() {
      this._scheme = '';
      this._schemeData = '';
      this._username = '';
      this._password = null;
      this._host = '';
      this._port = '';
      this._path = [];
      this._query = '';
      this._fragment = '';
      this._isInvalid = false;
      this._isRelative = false;
    }
    function JURL(url, base) {
      if (base !== undefined && !(base instanceof JURL)) {
        base = new JURL(String(base));
      }
      this._url = url;
      clear.call(this);
      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
      parse.call(this, input, null, base);
    }
    JURL.prototype = {
      toString: function toString() {
        return this.href;
      },

      get href() {
        if (this._isInvalid) {
          return this._url;
        }
        var authority = '';
        if (this._username !== '' || this._password !== null) {
          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
        }
        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
      },
      set href(value) {
        clear.call(this);
        parse.call(this, value);
      },
      get protocol() {
        return this._scheme + ':';
      },
      set protocol(value) {
        if (this._isInvalid) {
          return;
        }
        parse.call(this, value + ':', 'scheme start');
      },
      get host() {
        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
      },
      set host(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'host');
      },
      get hostname() {
        return this._host;
      },
      set hostname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'hostname');
      },
      get port() {
        return this._port;
      },
      set port(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        parse.call(this, value, 'port');
      },
      get pathname() {
        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
      },
      set pathname(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._path = [];
        parse.call(this, value, 'relative path start');
      },
      get search() {
        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
      },
      set search(value) {
        if (this._isInvalid || !this._isRelative) {
          return;
        }
        this._query = '?';
        if (value[0] === '?') {
          value = value.slice(1);
        }
        parse.call(this, value, 'query');
      },
      get hash() {
        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
      },
      set hash(value) {
        if (this._isInvalid) {
          return;
        }
        this._fragment = '#';
        if (value[0] === '#') {
          value = value.slice(1);
        }
        parse.call(this, value, 'fragment');
      },
      get origin() {
        var host;
        if (this._isInvalid || !this._scheme) {
          return '';
        }
        switch (this._scheme) {
          case 'data':
          case 'file':
          case 'javascript':
          case 'mailto':
            return 'null';
          case 'blob':
            try {
              return new JURL(this._schemeData).origin || 'null';
            } catch (_) {}
            return 'null';
        }
        host = this.host;
        if (!host) {
          return '';
        }
        return this._scheme + '://' + host;
      }
    };
    var OriginalURL = globalScope.URL;
    if (OriginalURL) {
      JURL.createObjectURL = function (blob) {
        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
      };
      JURL.revokeObjectURL = function (url) {
        OriginalURL.revokeObjectURL(url);
      };
    }
    globalScope.URL = JURL;
  })();
  (function checkObjectValues() {
    if (Object.values) {
      return;
    }
    Object.values = __w_pdfjs_require__(110);
  })();
}

/***/ }),
/* 65 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(66);
module.exports = __w_pdfjs_require__(5).Array.includes;

/***/ }),
/* 66 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(4);
var $includes = __w_pdfjs_require__(42)(true);
$export($export.P, 'Array', {
  includes: function includes(el) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__w_pdfjs_require__(43)('includes');

/***/ }),
/* 67 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toInteger = __w_pdfjs_require__(30);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(69);
module.exports = __w_pdfjs_require__(5).Math.log2;

/***/ }),
/* 69 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(4);
$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 70 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(71);
module.exports = __w_pdfjs_require__(5).Number.isNaN;

/***/ }),
/* 71 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(4);
$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    return number != number;
  }
});

/***/ }),
/* 72 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(73);
module.exports = __w_pdfjs_require__(5).Number.isInteger;

/***/ }),
/* 73 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(4);
$export($export.S, 'Number', { isInteger: __w_pdfjs_require__(74) });

/***/ }),
/* 74 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(1);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(45);
__w_pdfjs_require__(76);
__w_pdfjs_require__(50);
__w_pdfjs_require__(85);
__w_pdfjs_require__(92);
__w_pdfjs_require__(93);
module.exports = __w_pdfjs_require__(5).Promise;

/***/ }),
/* 76 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $at = __w_pdfjs_require__(77)(true);
__w_pdfjs_require__(46)(String, 'String', function (iterated) {
  this._t = String(iterated);
  this._i = 0;
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return {
    value: undefined,
    done: true
  };
  point = $at(O, index);
  this._i += point.length;
  return {
    value: point,
    done: false
  };
});

/***/ }),
/* 77 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var toInteger = __w_pdfjs_require__(30);
var defined = __w_pdfjs_require__(28);
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var create = __w_pdfjs_require__(79);
var descriptor = __w_pdfjs_require__(26);
var setToStringTag = __w_pdfjs_require__(22);
var IteratorPrototype = {};
__w_pdfjs_require__(11)(IteratorPrototype, __w_pdfjs_require__(2)('iterator'), function () {
  return this;
});
module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(6);
var dPs = __w_pdfjs_require__(80);
var enumBugKeys = __w_pdfjs_require__(48);
var IE_PROTO = __w_pdfjs_require__(32)('IE_PROTO');
var Empty = function Empty() {};
var PROTOTYPE = 'prototype';
var _createDict = function createDict() {
  var iframe = __w_pdfjs_require__(25)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __w_pdfjs_require__(49).appendChild(iframe);
  iframe.src = 'javascript:';
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var dP = __w_pdfjs_require__(15);
var anObject = __w_pdfjs_require__(6);
var getKeys = __w_pdfjs_require__(21);
module.exports = __w_pdfjs_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var has = __w_pdfjs_require__(7);
var toIObject = __w_pdfjs_require__(17);
var arrayIndexOf = __w_pdfjs_require__(42)(false);
var IE_PROTO = __w_pdfjs_require__(32)('IE_PROTO');
module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  }while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var has = __w_pdfjs_require__(7);
var toObject = __w_pdfjs_require__(33);
var IE_PROTO = __w_pdfjs_require__(32)('IE_PROTO');
var ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }
  return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var addToUnscopables = __w_pdfjs_require__(43);
var step = __w_pdfjs_require__(84);
var Iterators = __w_pdfjs_require__(19);
var toIObject = __w_pdfjs_require__(17);
module.exports = __w_pdfjs_require__(46)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated);
  this._i = 0;
  this._k = kind;
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');
Iterators.Arguments = Iterators.Array;
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 84 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (done, value) {
  return {
    value: value,
    done: !!done
  };
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var LIBRARY = __w_pdfjs_require__(47);
var global = __w_pdfjs_require__(3);
var ctx = __w_pdfjs_require__(9);
var classof = __w_pdfjs_require__(31);
var $export = __w_pdfjs_require__(4);
var isObject = __w_pdfjs_require__(1);
var aFunction = __w_pdfjs_require__(16);
var anInstance = __w_pdfjs_require__(34);
var forOf = __w_pdfjs_require__(23);
var speciesConstructor = __w_pdfjs_require__(51);
var task = __w_pdfjs_require__(52).set;
var microtask = __w_pdfjs_require__(90)();
var newPromiseCapabilityModule = __w_pdfjs_require__(35);
var perform = __w_pdfjs_require__(53);
var promiseResolve = __w_pdfjs_require__(54);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function empty() {};
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
var USE_NATIVE = !!function () {
  try {
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__w_pdfjs_require__(2)('species')] = function (exec) {
      exec(empty, empty);
    };
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) {}
}();
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) {
      run(chain[i++]);
    }promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({
            promise: promise,
            reason: value
          });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }
    promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function isUnhandled(promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({
        promise: promise,
        reason: promise._v
      });
    }
  });
};
var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise;
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise;
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = {
          _w: promise,
          _d: false
        };
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({
      _w: promise,
      _d: false
    }, e);
  }
};
if (!USE_NATIVE) {
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor) {
    this._c = [];
    this._a = undefined;
    this._s = 0;
    this._d = false;
    this._v = undefined;
    this._h = 0;
    this._n = false;
  };
  Internal.prototype = __w_pdfjs_require__(36)($Promise.prototype, {
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}
$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__w_pdfjs_require__(22)($Promise, PROMISE);
__w_pdfjs_require__(91)(PROMISE);
Wrapper = __w_pdfjs_require__(5)[PROMISE];
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __w_pdfjs_require__(55)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

/***/ }),
/* 86 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var anObject = __w_pdfjs_require__(6);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var Iterators = __w_pdfjs_require__(19);
var ITERATOR = __w_pdfjs_require__(2)('iterator');
var ArrayProto = Array.prototype;
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var classof = __w_pdfjs_require__(31);
var ITERATOR = __w_pdfjs_require__(2)('iterator');
var Iterators = __w_pdfjs_require__(19);
module.exports = __w_pdfjs_require__(5).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0:
      return un ? fn() : fn.call(that);
    case 1:
      return un ? fn(args[0]) : fn.call(that, args[0]);
    case 2:
      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
    case 3:
      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
    case 4:
      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
  }
  return fn.apply(that, args);
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(3);
var macrotask = __w_pdfjs_require__(52).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __w_pdfjs_require__(18)(process) == 'process';
module.exports = function () {
  var head, last, notify;
  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }
    last = undefined;
    if (parent) parent.enter();
  };
  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true });
    notify = function notify() {
      node.data = toggle = !toggle;
    };
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function notify() {
      promise.then(flush);
    };
  } else {
    notify = function notify() {
      macrotask.call(global, flush);
    };
  }
  return function (fn) {
    var task = {
      fn: fn,
      next: undefined
    };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }
    last = task;
  };
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(3);
var dP = __w_pdfjs_require__(15);
var DESCRIPTORS = __w_pdfjs_require__(12);
var SPECIES = __w_pdfjs_require__(2)('species');
module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(4);
var core = __w_pdfjs_require__(5);
var global = __w_pdfjs_require__(3);
var speciesConstructor = __w_pdfjs_require__(51);
var promiseResolve = __w_pdfjs_require__(54);
$export($export.P + $export.R, 'Promise', {
  'finally': function _finally(onFinally) {
    var C = speciesConstructor(this, core.Promise || global.Promise);
    var isFunction = typeof onFinally == 'function';
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(4);
var newPromiseCapability = __w_pdfjs_require__(35);
var perform = __w_pdfjs_require__(53);
$export($export.S, 'Promise', {
  'try': function _try(callbackfn) {
    var promiseCapability = newPromiseCapability.f(this);
    var result = perform(callbackfn);
    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
    return promiseCapability.promise;
  }
});

/***/ }),
/* 94 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(45);
__w_pdfjs_require__(50);
__w_pdfjs_require__(95);
__w_pdfjs_require__(106);
__w_pdfjs_require__(108);
module.exports = __w_pdfjs_require__(5).WeakMap;

/***/ }),
/* 95 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var each = __w_pdfjs_require__(56)(0);
var redefine = __w_pdfjs_require__(8);
var meta = __w_pdfjs_require__(37);
var assign = __w_pdfjs_require__(99);
var weak = __w_pdfjs_require__(101);
var isObject = __w_pdfjs_require__(1);
var fails = __w_pdfjs_require__(13);
var validate = __w_pdfjs_require__(57);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;
var wrapper = function wrapper(get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};
var methods = {
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};
var $WeakMap = module.exports = __w_pdfjs_require__(102)(WEAK_MAP, wrapper, methods, weak, true, true);
if (fails(function () {
  return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
})) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      }
      return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 96 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var speciesConstructor = __w_pdfjs_require__(97);
module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(1);
var isArray = __w_pdfjs_require__(98);
var SPECIES = __w_pdfjs_require__(2)('species');
module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }
  return C === undefined ? Array : C;
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var cof = __w_pdfjs_require__(18);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var getKeys = __w_pdfjs_require__(21);
var gOPS = __w_pdfjs_require__(100);
var pIE = __w_pdfjs_require__(38);
var toObject = __w_pdfjs_require__(33);
var IObject = __w_pdfjs_require__(27);
var $assign = Object.assign;
module.exports = !$assign || __w_pdfjs_require__(13)(function () {
  var A = {};
  var B = {};
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    }
  }
  return T;
} : $assign;

/***/ }),
/* 100 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 101 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var redefineAll = __w_pdfjs_require__(36);
var getWeak = __w_pdfjs_require__(37).getWeak;
var anObject = __w_pdfjs_require__(6);
var isObject = __w_pdfjs_require__(1);
var anInstance = __w_pdfjs_require__(34);
var forOf = __w_pdfjs_require__(23);
var createArrayMethod = __w_pdfjs_require__(56);
var $has = __w_pdfjs_require__(7);
var validate = __w_pdfjs_require__(57);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;
var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function UncaughtFrozenStore() {
  this.a = [];
};
var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function get(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function has(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function set(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;else this.a.push([key, value]);
  },
  'delete': function _delete(key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};
module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;
      that._i = id++;
      that._l = undefined;
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      'delete': function _delete(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var global = __w_pdfjs_require__(3);
var $export = __w_pdfjs_require__(4);
var redefine = __w_pdfjs_require__(8);
var redefineAll = __w_pdfjs_require__(36);
var meta = __w_pdfjs_require__(37);
var forOf = __w_pdfjs_require__(23);
var anInstance = __w_pdfjs_require__(34);
var isObject = __w_pdfjs_require__(1);
var fails = __w_pdfjs_require__(13);
var $iterDetect = __w_pdfjs_require__(55);
var setToStringTag = __w_pdfjs_require__(22);
var inheritIfRequired = __w_pdfjs_require__(103);
module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function fixMethod(KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY, KEY == 'delete' ? function (a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'has' ? function has(a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'get' ? function get(a) {
      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'add' ? function add(a) {
      fn.call(this, a === 0 ? 0 : a);
      return this;
    } : function set(a, b) {
      fn.call(this, a === 0 ? 0 : a, b);
      return this;
    });
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    var THROWS_ON_PRIMITIVES = fails(function () {
      instance.has(1);
    });
    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
      new C(iter);
    });
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      var $instance = new C();
      var index = 5;
      while (index--) {
        $instance[ADDER](index, index);
      }return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    if (IS_WEAK && proto.clear) delete proto.clear;
  }
  setToStringTag(C, NAME);
  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);
  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
  return C;
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(1);
var setPrototypeOf = __w_pdfjs_require__(104).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  }
  return that;
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isObject = __w_pdfjs_require__(1);
var anObject = __w_pdfjs_require__(6);
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? function (test, buggy, set) {
    try {
      set = __w_pdfjs_require__(9)(Function.call, __w_pdfjs_require__(105).f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var pIE = __w_pdfjs_require__(38);
var createDesc = __w_pdfjs_require__(26);
var toIObject = __w_pdfjs_require__(17);
var toPrimitive = __w_pdfjs_require__(41);
var has = __w_pdfjs_require__(7);
var IE8_DOM_DEFINE = __w_pdfjs_require__(40);
var gOPD = Object.getOwnPropertyDescriptor;
exports.f = __w_pdfjs_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(107)('WeakMap');

/***/ }),
/* 107 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(4);
module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, {
    of: function of() {
      var length = arguments.length;
      var A = new Array(length);
      while (length--) {
        A[length] = arguments[length];
      }return new this(A);
    }
  });
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(109)('WeakMap');

/***/ }),
/* 109 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(4);
var aFunction = __w_pdfjs_require__(16);
var ctx = __w_pdfjs_require__(9);
var forOf = __w_pdfjs_require__(23);
module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, {
    from: function from(source) {
      var mapFn = arguments[1];
      var mapping, A, n, cb;
      aFunction(this);
      mapping = mapFn !== undefined;
      if (mapping) aFunction(mapFn);
      if (source == undefined) return new this();
      A = [];
      if (mapping) {
        n = 0;
        cb = ctx(mapFn, arguments[2], 2);
        forOf(source, false, function (nextItem) {
          A.push(cb(nextItem, n++));
        });
      } else {
        forOf(source, false, A.push, A);
      }
      return new this(A);
    }
  });
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


__w_pdfjs_require__(111);
module.exports = __w_pdfjs_require__(5).Object.values;

/***/ }),
/* 111 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var $export = __w_pdfjs_require__(4);
var $values = __w_pdfjs_require__(112)(false);
$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),
/* 112 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var getKeys = __w_pdfjs_require__(21);
var toIObject = __w_pdfjs_require__(17);
var isEnum = __w_pdfjs_require__(38).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      if (isEnum.call(O, key = keys[i++])) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }return result;
  };
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var isReadableStreamSupported = false;
if (typeof ReadableStream !== 'undefined') {
  try {
    new ReadableStream({
      start: function start(controller) {
        controller.close();
      }
    });
    isReadableStreamSupported = true;
  } catch (e) {}
}
if (isReadableStreamSupported) {
  exports.ReadableStream = ReadableStream;
} else {
  exports.ReadableStream = __w_pdfjs_require__(114).ReadableStream;
}

/***/ }),
/* 114 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports, function (modules) {
  var installedModules = {};
  function __w_pdfjs_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: false,
      exports: {}
    };
    modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
    module.l = true;
    return module.exports;
  }
  __w_pdfjs_require__.m = modules;
  __w_pdfjs_require__.c = installedModules;
  __w_pdfjs_require__.i = function (value) {
    return value;
  };
  __w_pdfjs_require__.d = function (exports, name, getter) {
    if (!__w_pdfjs_require__.o(exports, name)) {
      Object.defineProperty(exports, name, {
        configurable: false,
        enumerable: true,
        get: getter
      });
    }
  };
  __w_pdfjs_require__.n = function (module) {
    var getter = module && module.__esModule ? function getDefault() {
      return module['default'];
    } : function getModuleExports() {
      return module;
    };
    __w_pdfjs_require__.d(getter, 'a', getter);
    return getter;
  };
  __w_pdfjs_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  __w_pdfjs_require__.p = "";
  return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
}([function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
  };
  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;
  function IsPropertyKey(argument) {
    return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
  }
  exports.typeIsObject = function (x) {
    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
  };
  exports.createDataProperty = function (o, p, v) {
    assert(exports.typeIsObject(o));
    Object.defineProperty(o, p, {
      value: v,
      writable: true,
      enumerable: true,
      configurable: true
    });
  };
  exports.createArrayFromList = function (elements) {
    return elements.slice();
  };
  exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
    new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
  };
  exports.CreateIterResultObject = function (value, done) {
    assert(typeof done === 'boolean');
    var obj = {};
    Object.defineProperty(obj, 'value', {
      value: value,
      enumerable: true,
      writable: true,
      configurable: true
    });
    Object.defineProperty(obj, 'done', {
      value: done,
      enumerable: true,
      writable: true,
      configurable: true
    });
    return obj;
  };
  exports.IsFiniteNonNegativeNumber = function (v) {
    if (Number.isNaN(v)) {
      return false;
    }
    if (v === Infinity) {
      return false;
    }
    if (v < 0) {
      return false;
    }
    return true;
  };
  function Call(F, V, args) {
    if (typeof F !== 'function') {
      throw new TypeError('Argument is not a function');
    }
    return Function.prototype.apply.call(F, V, args);
  }
  exports.InvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    var method = O[P];
    if (method === undefined) {
      return undefined;
    }
    return Call(method, O, args);
  };
  exports.PromiseInvokeOrNoop = function (O, P, args) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    try {
      return Promise.resolve(exports.InvokeOrNoop(O, P, args));
    } catch (returnValueE) {
      return Promise.reject(returnValueE);
    }
  };
  exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
    assert(O !== undefined);
    assert(IsPropertyKey(P));
    assert(Array.isArray(args));
    assert(Array.isArray(argsF));
    var method = void 0;
    try {
      method = O[P];
    } catch (methodE) {
      return Promise.reject(methodE);
    }
    if (method === undefined) {
      return F.apply(null, argsF);
    }
    try {
      return Promise.resolve(Call(method, O, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  exports.TransferArrayBuffer = function (O) {
    return O.slice();
  };
  exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
    highWaterMark = Number(highWaterMark);
    if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
      throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
    }
    return highWaterMark;
  };
  exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
    if (size !== undefined && typeof size !== 'function') {
      throw new TypeError('size property of a queuing strategy must be a function');
    }
    highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
    return {
      size: size,
      highWaterMark: highWaterMark
    };
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  function rethrowAssertionErrorRejection(e) {
    if (e && e.constructor === AssertionError) {
      setTimeout(function () {
        throw e;
      }, 0);
    }
  }
  function AssertionError(message) {
    this.name = 'AssertionError';
    this.message = message || '';
    this.stack = new Error().stack;
  }
  AssertionError.prototype = Object.create(Error.prototype);
  AssertionError.prototype.constructor = AssertionError;
  function assert(value, message) {
    if (!value) {
      throw new AssertionError(message);
    }
  }
  module.exports = {
    rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
    AssertionError: AssertionError,
    assert: assert
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(0),
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      typeIsObject = _require.typeIsObject;
  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert,
      rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
  var _require3 = __w_pdfjs_require__(3),
      DequeueValue = _require3.DequeueValue,
      EnqueueValueWithSize = _require3.EnqueueValueWithSize,
      PeekQueueValue = _require3.PeekQueueValue,
      ResetQueue = _require3.ResetQueue;
  var WritableStream = function () {
    function WritableStream() {
      var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          _ref$highWaterMark = _ref.highWaterMark,
          highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
      _classCallCheck(this, WritableStream);
      this._state = 'writable';
      this._storedError = undefined;
      this._writer = undefined;
      this._writableStreamController = undefined;
      this._writeRequests = [];
      this._inFlightWriteRequest = undefined;
      this._closeRequest = undefined;
      this._inFlightCloseRequest = undefined;
      this._pendingAbortRequest = undefined;
      this._backpressure = false;
      var type = underlyingSink.type;
      if (type !== undefined) {
        throw new RangeError('Invalid type is specified');
      }
      this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
      this._writableStreamController.__startSteps();
    }
    _createClass(WritableStream, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('abort'));
        }
        if (IsWritableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
        }
        return WritableStreamAbort(this, reason);
      }
    }, {
      key: 'getWriter',
      value: function getWriter() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('getWriter');
        }
        return AcquireWritableStreamDefaultWriter(this);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsWritableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }
        return IsWritableStreamLocked(this);
      }
    }]);
    return WritableStream;
  }();
  module.exports = {
    AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
    IsWritableStream: IsWritableStream,
    IsWritableStreamLocked: IsWritableStreamLocked,
    WritableStream: WritableStream,
    WritableStreamAbort: WritableStreamAbort,
    WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
    WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
    WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
    WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
    WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
  };
  function AcquireWritableStreamDefaultWriter(stream) {
    return new WritableStreamDefaultWriter(stream);
  }
  function IsWritableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
      return false;
    }
    return true;
  }
  function IsWritableStreamLocked(stream) {
    assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');
    if (stream._writer === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamAbort(stream, reason) {
    var state = stream._state;
    if (state === 'closed') {
      return Promise.resolve(undefined);
    }
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    var error = new TypeError('Requested to abort');
    if (stream._pendingAbortRequest !== undefined) {
      return Promise.reject(error);
    }
    assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
    var wasAlreadyErroring = false;
    if (state === 'erroring') {
      wasAlreadyErroring = true;
      reason = undefined;
    }
    var promise = new Promise(function (resolve, reject) {
      stream._pendingAbortRequest = {
        _resolve: resolve,
        _reject: reject,
        _reason: reason,
        _wasAlreadyErroring: wasAlreadyErroring
      };
    });
    if (wasAlreadyErroring === false) {
      WritableStreamStartErroring(stream, error);
    }
    return promise;
  }
  function WritableStreamAddWriteRequest(stream) {
    assert(IsWritableStreamLocked(stream) === true);
    assert(stream._state === 'writable');
    var promise = new Promise(function (resolve, reject) {
      var writeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._writeRequests.push(writeRequest);
    });
    return promise;
  }
  function WritableStreamDealWithRejection(stream, error) {
    var state = stream._state;
    if (state === 'writable') {
      WritableStreamStartErroring(stream, error);
      return;
    }
    assert(state === 'erroring');
    WritableStreamFinishErroring(stream);
  }
  function WritableStreamStartErroring(stream, reason) {
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
    assert(stream._state === 'writable', 'state must be writable');
    var controller = stream._writableStreamController;
    assert(controller !== undefined, 'controller must not be undefined');
    stream._state = 'erroring';
    stream._storedError = reason;
    var writer = stream._writer;
    if (writer !== undefined) {
      WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
    }
    if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
      WritableStreamFinishErroring(stream);
    }
  }
  function WritableStreamFinishErroring(stream) {
    assert(stream._state === 'erroring', 'stream._state === erroring');
    assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
    stream._state = 'errored';
    stream._writableStreamController.__errorSteps();
    var storedError = stream._storedError;
    for (var i = 0; i < stream._writeRequests.length; i++) {
      var writeRequest = stream._writeRequests[i];
      writeRequest._reject(storedError);
    }
    stream._writeRequests = [];
    if (stream._pendingAbortRequest === undefined) {
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }
    var abortRequest = stream._pendingAbortRequest;
    stream._pendingAbortRequest = undefined;
    if (abortRequest._wasAlreadyErroring === true) {
      abortRequest._reject(storedError);
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
      return;
    }
    var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
    promise.then(function () {
      abortRequest._resolve();
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    }, function (reason) {
      abortRequest._reject(reason);
      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
    });
  }
  function WritableStreamFinishInFlightWrite(stream) {
    assert(stream._inFlightWriteRequest !== undefined);
    stream._inFlightWriteRequest._resolve(undefined);
    stream._inFlightWriteRequest = undefined;
  }
  function WritableStreamFinishInFlightWriteWithError(stream, error) {
    assert(stream._inFlightWriteRequest !== undefined);
    stream._inFlightWriteRequest._reject(error);
    stream._inFlightWriteRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    WritableStreamDealWithRejection(stream, error);
  }
  function WritableStreamFinishInFlightClose(stream) {
    assert(stream._inFlightCloseRequest !== undefined);
    stream._inFlightCloseRequest._resolve(undefined);
    stream._inFlightCloseRequest = undefined;
    var state = stream._state;
    assert(state === 'writable' || state === 'erroring');
    if (state === 'erroring') {
      stream._storedError = undefined;
      if (stream._pendingAbortRequest !== undefined) {
        stream._pendingAbortRequest._resolve();
        stream._pendingAbortRequest = undefined;
      }
    }
    stream._state = 'closed';
    var writer = stream._writer;
    if (writer !== undefined) {
      defaultWriterClosedPromiseResolve(writer);
    }
    assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
    assert(stream._storedError === undefined, 'stream._storedError === undefined');
  }
  function WritableStreamFinishInFlightCloseWithError(stream, error) {
    assert(stream._inFlightCloseRequest !== undefined);
    stream._inFlightCloseRequest._reject(error);
    stream._inFlightCloseRequest = undefined;
    assert(stream._state === 'writable' || stream._state === 'erroring');
    if (stream._pendingAbortRequest !== undefined) {
      stream._pendingAbortRequest._reject(error);
      stream._pendingAbortRequest = undefined;
    }
    WritableStreamDealWithRejection(stream, error);
  }
  function WritableStreamCloseQueuedOrInFlight(stream) {
    if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamHasOperationMarkedInFlight(stream) {
    if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
      return false;
    }
    return true;
  }
  function WritableStreamMarkCloseRequestInFlight(stream) {
    assert(stream._inFlightCloseRequest === undefined);
    assert(stream._closeRequest !== undefined);
    stream._inFlightCloseRequest = stream._closeRequest;
    stream._closeRequest = undefined;
  }
  function WritableStreamMarkFirstWriteRequestInFlight(stream) {
    assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
    assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
    stream._inFlightWriteRequest = stream._writeRequests.shift();
  }
  function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
    assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
    if (stream._closeRequest !== undefined) {
      assert(stream._inFlightCloseRequest === undefined);
      stream._closeRequest._reject(stream._storedError);
      stream._closeRequest = undefined;
    }
    var writer = stream._writer;
    if (writer !== undefined) {
      defaultWriterClosedPromiseReject(writer, stream._storedError);
      writer._closedPromise.catch(function () {});
    }
  }
  function WritableStreamUpdateBackpressure(stream, backpressure) {
    assert(stream._state === 'writable');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var writer = stream._writer;
    if (writer !== undefined && backpressure !== stream._backpressure) {
      if (backpressure === true) {
        defaultWriterReadyPromiseReset(writer);
      } else {
        assert(backpressure === false);
        defaultWriterReadyPromiseResolve(writer);
      }
    }
    stream._backpressure = backpressure;
  }
  var WritableStreamDefaultWriter = function () {
    function WritableStreamDefaultWriter(stream) {
      _classCallCheck(this, WritableStreamDefaultWriter);
      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
      }
      if (IsWritableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive writing by another writer');
      }
      this._ownerWritableStream = stream;
      stream._writer = this;
      var state = stream._state;
      if (state === 'writable') {
        if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
          defaultWriterReadyPromiseInitialize(this);
        } else {
          defaultWriterReadyPromiseInitializeAsResolved(this);
        }
        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'erroring') {
        defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
        this._readyPromise.catch(function () {});
        defaultWriterClosedPromiseInitialize(this);
      } else if (state === 'closed') {
        defaultWriterReadyPromiseInitializeAsResolved(this);
        defaultWriterClosedPromiseInitializeAsResolved(this);
      } else {
        assert(state === 'errored', 'state must be errored');
        var storedError = stream._storedError;
        defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
        this._readyPromise.catch(function () {});
        defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
        this._closedPromise.catch(function () {});
      }
    }
    _createClass(WritableStreamDefaultWriter, [{
      key: 'abort',
      value: function abort(reason) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('abort'));
        }
        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('abort'));
        }
        return WritableStreamDefaultWriterAbort(this, reason);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('close'));
        }
        var stream = this._ownerWritableStream;
        if (stream === undefined) {
          return Promise.reject(defaultWriterLockException('close'));
        }
        if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
          return Promise.reject(new TypeError('cannot close an already-closing stream'));
        }
        return WritableStreamDefaultWriterClose(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('releaseLock');
        }
        var stream = this._ownerWritableStream;
        if (stream === undefined) {
          return;
        }
        assert(stream._writer !== undefined);
        WritableStreamDefaultWriterRelease(this);
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('write'));
        }
        if (this._ownerWritableStream === undefined) {
          return Promise.reject(defaultWriterLockException('write to'));
        }
        return WritableStreamDefaultWriterWrite(this, chunk);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          throw defaultWriterBrandCheckException('desiredSize');
        }
        if (this._ownerWritableStream === undefined) {
          throw defaultWriterLockException('desiredSize');
        }
        return WritableStreamDefaultWriterGetDesiredSize(this);
      }
    }, {
      key: 'ready',
      get: function get() {
        if (IsWritableStreamDefaultWriter(this) === false) {
          return Promise.reject(defaultWriterBrandCheckException('ready'));
        }
        return this._readyPromise;
      }
    }]);
    return WritableStreamDefaultWriter;
  }();
  function IsWritableStreamDefaultWriter(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
      return false;
    }
    return true;
  }
  function WritableStreamDefaultWriterAbort(writer, reason) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    return WritableStreamAbort(stream, reason);
  }
  function WritableStreamDefaultWriterClose(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;
    if (state === 'closed' || state === 'errored') {
      return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
    }
    assert(state === 'writable' || state === 'erroring');
    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
    var promise = new Promise(function (resolve, reject) {
      var closeRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._closeRequest = closeRequest;
    });
    if (stream._backpressure === true && state === 'writable') {
      defaultWriterReadyPromiseResolve(writer);
    }
    WritableStreamDefaultControllerClose(stream._writableStreamController);
    return promise;
  }
  function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var state = stream._state;
    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.resolve();
    }
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    assert(state === 'writable' || state === 'erroring');
    return WritableStreamDefaultWriterClose(writer);
  }
  function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
    if (writer._closedPromiseState === 'pending') {
      defaultWriterClosedPromiseReject(writer, error);
    } else {
      defaultWriterClosedPromiseResetToRejected(writer, error);
    }
    writer._closedPromise.catch(function () {});
  }
  function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
    if (writer._readyPromiseState === 'pending') {
      defaultWriterReadyPromiseReject(writer, error);
    } else {
      defaultWriterReadyPromiseResetToRejected(writer, error);
    }
    writer._readyPromise.catch(function () {});
  }
  function WritableStreamDefaultWriterGetDesiredSize(writer) {
    var stream = writer._ownerWritableStream;
    var state = stream._state;
    if (state === 'errored' || state === 'erroring') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
  }
  function WritableStreamDefaultWriterRelease(writer) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    assert(stream._writer === writer);
    var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
    WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
    stream._writer = undefined;
    writer._ownerWritableStream = undefined;
  }
  function WritableStreamDefaultWriterWrite(writer, chunk) {
    var stream = writer._ownerWritableStream;
    assert(stream !== undefined);
    var controller = stream._writableStreamController;
    var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
    if (stream !== writer._ownerWritableStream) {
      return Promise.reject(defaultWriterLockException('write to'));
    }
    var state = stream._state;
    if (state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
      return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
    }
    if (state === 'erroring') {
      return Promise.reject(stream._storedError);
    }
    assert(state === 'writable');
    var promise = WritableStreamAddWriteRequest(stream);
    WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
    return promise;
  }
  var WritableStreamDefaultController = function () {
    function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
      _classCallCheck(this, WritableStreamDefaultController);
      if (IsWritableStream(stream) === false) {
        throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
      }
      if (stream._writableStreamController !== undefined) {
        throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
      }
      this._controlledWritableStream = stream;
      this._underlyingSink = underlyingSink;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }
    _createClass(WritableStreamDefaultController, [{
      key: 'error',
      value: function error(e) {
        if (IsWritableStreamDefaultController(this) === false) {
          throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
        }
        var state = this._controlledWritableStream._state;
        if (state !== 'writable') {
          return;
        }
        WritableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__abortSteps',
      value: function __abortSteps(reason) {
        return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
      }
    }, {
      key: '__errorSteps',
      value: function __errorSteps() {
        ResetQueue(this);
      }
    }, {
      key: '__startSteps',
      value: function __startSteps() {
        var _this = this;
        var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
        var stream = this._controlledWritableStream;
        Promise.resolve(startResult).then(function () {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
        }, function (r) {
          assert(stream._state === 'writable' || stream._state === 'erroring');
          _this._started = true;
          WritableStreamDealWithRejection(stream, r);
        }).catch(rethrowAssertionErrorRejection);
      }
    }]);
    return WritableStreamDefaultController;
  }();
  function WritableStreamDefaultControllerClose(controller) {
    EnqueueValueWithSize(controller, 'close', 0);
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }
  function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
    var strategySize = controller._strategySize;
    if (strategySize === undefined) {
      return 1;
    }
    try {
      return strategySize(chunk);
    } catch (chunkSizeE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
      return 1;
    }
  }
  function WritableStreamDefaultControllerGetDesiredSize(controller) {
    return controller._strategyHWM - controller._queueTotalSize;
  }
  function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
    var writeRecord = { chunk: chunk };
    try {
      EnqueueValueWithSize(controller, writeRecord, chunkSize);
    } catch (enqueueE) {
      WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
      return;
    }
    var stream = controller._controlledWritableStream;
    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
      WritableStreamUpdateBackpressure(stream, backpressure);
    }
    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
  }
  function IsWritableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
      return false;
    }
    return true;
  }
  function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
    var stream = controller._controlledWritableStream;
    if (controller._started === false) {
      return;
    }
    if (stream._inFlightWriteRequest !== undefined) {
      return;
    }
    var state = stream._state;
    if (state === 'closed' || state === 'errored') {
      return;
    }
    if (state === 'erroring') {
      WritableStreamFinishErroring(stream);
      return;
    }
    if (controller._queue.length === 0) {
      return;
    }
    var writeRecord = PeekQueueValue(controller);
    if (writeRecord === 'close') {
      WritableStreamDefaultControllerProcessClose(controller);
    } else {
      WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
    }
  }
  function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
    if (controller._controlledWritableStream._state === 'writable') {
      WritableStreamDefaultControllerError(controller, error);
    }
  }
  function WritableStreamDefaultControllerProcessClose(controller) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkCloseRequestInFlight(stream);
    DequeueValue(controller);
    assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
    var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
    sinkClosePromise.then(function () {
      WritableStreamFinishInFlightClose(stream);
    }, function (reason) {
      WritableStreamFinishInFlightCloseWithError(stream, reason);
    }).catch(rethrowAssertionErrorRejection);
  }
  function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
    var stream = controller._controlledWritableStream;
    WritableStreamMarkFirstWriteRequestInFlight(stream);
    var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
    sinkWritePromise.then(function () {
      WritableStreamFinishInFlightWrite(stream);
      var state = stream._state;
      assert(state === 'writable' || state === 'erroring');
      DequeueValue(controller);
      if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
        WritableStreamUpdateBackpressure(stream, backpressure);
      }
      WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
    }, function (reason) {
      WritableStreamFinishInFlightWriteWithError(stream, reason);
    }).catch(rethrowAssertionErrorRejection);
  }
  function WritableStreamDefaultControllerGetBackpressure(controller) {
    var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
    return desiredSize <= 0;
  }
  function WritableStreamDefaultControllerError(controller, error) {
    var stream = controller._controlledWritableStream;
    assert(stream._state === 'writable');
    WritableStreamStartErroring(stream, error);
  }
  function streamBrandCheckException(name) {
    return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
  }
  function defaultWriterBrandCheckException(name) {
    return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
  }
  function defaultWriterLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released writer');
  }
  function defaultWriterClosedPromiseInitialize(writer) {
    writer._closedPromise = new Promise(function (resolve, reject) {
      writer._closedPromise_resolve = resolve;
      writer._closedPromise_reject = reject;
      writer._closedPromiseState = 'pending';
    });
  }
  function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseInitializeAsResolved(writer) {
    writer._closedPromise = Promise.resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }
  function defaultWriterClosedPromiseReject(writer, reason) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
    writer._closedPromise_reject(reason);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseResetToRejected(writer, reason) {
    assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
    assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
    assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
    writer._closedPromise = Promise.reject(reason);
    writer._closedPromiseState = 'rejected';
  }
  function defaultWriterClosedPromiseResolve(writer) {
    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
    writer._closedPromise_resolve(undefined);
    writer._closedPromise_resolve = undefined;
    writer._closedPromise_reject = undefined;
    writer._closedPromiseState = 'resolved';
  }
  function defaultWriterReadyPromiseInitialize(writer) {
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }
  function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseInitializeAsResolved(writer) {
    writer._readyPromise = Promise.resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
  function defaultWriterReadyPromiseReject(writer, reason) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
    writer._readyPromise_reject(reason);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseReset(writer) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = new Promise(function (resolve, reject) {
      writer._readyPromise_resolve = resolve;
      writer._readyPromise_reject = reject;
    });
    writer._readyPromiseState = 'pending';
  }
  function defaultWriterReadyPromiseResetToRejected(writer, reason) {
    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
    writer._readyPromise = Promise.reject(reason);
    writer._readyPromiseState = 'rejected';
  }
  function defaultWriterReadyPromiseResolve(writer) {
    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
    writer._readyPromise_resolve(undefined);
    writer._readyPromise_resolve = undefined;
    writer._readyPromise_reject = undefined;
    writer._readyPromiseState = 'fulfilled';
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _require = __w_pdfjs_require__(0),
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
  var _require2 = __w_pdfjs_require__(1),
      assert = _require2.assert;
  exports.DequeueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');
    var pair = container._queue.shift();
    container._queueTotalSize -= pair.size;
    if (container._queueTotalSize < 0) {
      container._queueTotalSize = 0;
    }
    return pair.value;
  };
  exports.EnqueueValueWithSize = function (container, value, size) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
    size = Number(size);
    if (!IsFiniteNonNegativeNumber(size)) {
      throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
    }
    container._queue.push({
      value: value,
      size: size
    });
    container._queueTotalSize += size;
  };
  exports.PeekQueueValue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
    var pair = container._queue[0];
    return pair.value;
  };
  exports.ResetQueue = function (container) {
    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
    container._queue = [];
    container._queueTotalSize = 0;
  };
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(0),
      ArrayBufferCopy = _require.ArrayBufferCopy,
      CreateIterResultObject = _require.CreateIterResultObject,
      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
      InvokeOrNoop = _require.InvokeOrNoop,
      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
      TransferArrayBuffer = _require.TransferArrayBuffer,
      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
      ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
  var _require2 = __w_pdfjs_require__(0),
      createArrayFromList = _require2.createArrayFromList,
      createDataProperty = _require2.createDataProperty,
      typeIsObject = _require2.typeIsObject;
  var _require3 = __w_pdfjs_require__(1),
      assert = _require3.assert,
      rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
  var _require4 = __w_pdfjs_require__(3),
      DequeueValue = _require4.DequeueValue,
      EnqueueValueWithSize = _require4.EnqueueValueWithSize,
      ResetQueue = _require4.ResetQueue;
  var _require5 = __w_pdfjs_require__(2),
      AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
      IsWritableStream = _require5.IsWritableStream,
      IsWritableStreamLocked = _require5.IsWritableStreamLocked,
      WritableStreamAbort = _require5.WritableStreamAbort,
      WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
      WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
      WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
      WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
  var ReadableStream = function () {
    function ReadableStream() {
      var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          size = _ref.size,
          highWaterMark = _ref.highWaterMark;
      _classCallCheck(this, ReadableStream);
      this._state = 'readable';
      this._reader = undefined;
      this._storedError = undefined;
      this._disturbed = false;
      this._readableStreamController = undefined;
      var type = underlyingSource.type;
      var typeString = String(type);
      if (typeString === 'bytes') {
        if (highWaterMark === undefined) {
          highWaterMark = 0;
        }
        this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
      } else if (type === undefined) {
        if (highWaterMark === undefined) {
          highWaterMark = 1;
        }
        this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
      } else {
        throw new RangeError('Invalid type is specified');
      }
    }
    _createClass(ReadableStream, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('cancel'));
        }
        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
        }
        return ReadableStreamCancel(this, reason);
      }
    }, {
      key: 'getReader',
      value: function getReader() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            mode = _ref2.mode;
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('getReader');
        }
        if (mode === undefined) {
          return AcquireReadableStreamDefaultReader(this);
        }
        mode = String(mode);
        if (mode === 'byob') {
          return AcquireReadableStreamBYOBReader(this);
        }
        throw new RangeError('Invalid mode is specified');
      }
    }, {
      key: 'pipeThrough',
      value: function pipeThrough(_ref3, options) {
        var writable = _ref3.writable,
            readable = _ref3.readable;
        var promise = this.pipeTo(writable, options);
        ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
        return readable;
      }
    }, {
      key: 'pipeTo',
      value: function pipeTo(dest) {
        var _this = this;
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            preventClose = _ref4.preventClose,
            preventAbort = _ref4.preventAbort,
            preventCancel = _ref4.preventCancel;
        if (IsReadableStream(this) === false) {
          return Promise.reject(streamBrandCheckException('pipeTo'));
        }
        if (IsWritableStream(dest) === false) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
        }
        preventClose = Boolean(preventClose);
        preventAbort = Boolean(preventAbort);
        preventCancel = Boolean(preventCancel);
        if (IsReadableStreamLocked(this) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
        }
        if (IsWritableStreamLocked(dest) === true) {
          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
        }
        var reader = AcquireReadableStreamDefaultReader(this);
        var writer = AcquireWritableStreamDefaultWriter(dest);
        var shuttingDown = false;
        var currentWrite = Promise.resolve();
        return new Promise(function (resolve, reject) {
          function pipeLoop() {
            currentWrite = Promise.resolve();
            if (shuttingDown === true) {
              return Promise.resolve();
            }
            return writer._readyPromise.then(function () {
              return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
                var value = _ref5.value,
                    done = _ref5.done;
                if (done === true) {
                  return;
                }
                currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
              });
            }).then(pipeLoop);
          }
          isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
            if (preventAbort === false) {
              shutdownWithAction(function () {
                return WritableStreamAbort(dest, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, storedError);
              }, true, storedError);
            } else {
              shutdown(true, storedError);
            }
          });
          isOrBecomesClosed(_this, reader._closedPromise, function () {
            if (preventClose === false) {
              shutdownWithAction(function () {
                return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
              });
            } else {
              shutdown();
            }
          });
          if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
            var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');
            if (preventCancel === false) {
              shutdownWithAction(function () {
                return ReadableStreamCancel(_this, destClosed);
              }, true, destClosed);
            } else {
              shutdown(true, destClosed);
            }
          }
          pipeLoop().catch(function (err) {
            currentWrite = Promise.resolve();
            rethrowAssertionErrorRejection(err);
          });
          function waitForWritesToFinish() {
            var oldCurrentWrite = currentWrite;
            return currentWrite.then(function () {
              return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
            });
          }
          function isOrBecomesErrored(stream, promise, action) {
            if (stream._state === 'errored') {
              action(stream._storedError);
            } else {
              promise.catch(action).catch(rethrowAssertionErrorRejection);
            }
          }
          function isOrBecomesClosed(stream, promise, action) {
            if (stream._state === 'closed') {
              action();
            } else {
              promise.then(action).catch(rethrowAssertionErrorRejection);
            }
          }
          function shutdownWithAction(action, originalIsError, originalError) {
            if (shuttingDown === true) {
              return;
            }
            shuttingDown = true;
            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(doTheRest);
            } else {
              doTheRest();
            }
            function doTheRest() {
              action().then(function () {
                return finalize(originalIsError, originalError);
              }, function (newError) {
                return finalize(true, newError);
              }).catch(rethrowAssertionErrorRejection);
            }
          }
          function shutdown(isError, error) {
            if (shuttingDown === true) {
              return;
            }
            shuttingDown = true;
            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
              waitForWritesToFinish().then(function () {
                return finalize(isError, error);
              }).catch(rethrowAssertionErrorRejection);
            } else {
              finalize(isError, error);
            }
          }
          function finalize(isError, error) {
            WritableStreamDefaultWriterRelease(writer);
            ReadableStreamReaderGenericRelease(reader);
            if (isError) {
              reject(error);
            } else {
              resolve(undefined);
            }
          }
        });
      }
    }, {
      key: 'tee',
      value: function tee() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('tee');
        }
        var branches = ReadableStreamTee(this, false);
        return createArrayFromList(branches);
      }
    }, {
      key: 'locked',
      get: function get() {
        if (IsReadableStream(this) === false) {
          throw streamBrandCheckException('locked');
        }
        return IsReadableStreamLocked(this);
      }
    }]);
    return ReadableStream;
  }();
  module.exports = {
    ReadableStream: ReadableStream,
    IsReadableStreamDisturbed: IsReadableStreamDisturbed,
    ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
    ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
    ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
    ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
  };
  function AcquireReadableStreamBYOBReader(stream) {
    return new ReadableStreamBYOBReader(stream);
  }
  function AcquireReadableStreamDefaultReader(stream) {
    return new ReadableStreamDefaultReader(stream);
  }
  function IsReadableStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamDisturbed(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
    return stream._disturbed;
  }
  function IsReadableStreamLocked(stream) {
    assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');
    if (stream._reader === undefined) {
      return false;
    }
    return true;
  }
  function ReadableStreamTee(stream, cloneForBranch2) {
    assert(IsReadableStream(stream) === true);
    assert(typeof cloneForBranch2 === 'boolean');
    var reader = AcquireReadableStreamDefaultReader(stream);
    var teeState = {
      closedOrErrored: false,
      canceled1: false,
      canceled2: false,
      reason1: undefined,
      reason2: undefined
    };
    teeState.promise = new Promise(function (resolve) {
      teeState._resolve = resolve;
    });
    var pull = create_ReadableStreamTeePullFunction();
    pull._reader = reader;
    pull._teeState = teeState;
    pull._cloneForBranch2 = cloneForBranch2;
    var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
    cancel1._stream = stream;
    cancel1._teeState = teeState;
    var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
    cancel2._stream = stream;
    cancel2._teeState = teeState;
    var underlyingSource1 = Object.create(Object.prototype);
    createDataProperty(underlyingSource1, 'pull', pull);
    createDataProperty(underlyingSource1, 'cancel', cancel1);
    var branch1Stream = new ReadableStream(underlyingSource1);
    var underlyingSource2 = Object.create(Object.prototype);
    createDataProperty(underlyingSource2, 'pull', pull);
    createDataProperty(underlyingSource2, 'cancel', cancel2);
    var branch2Stream = new ReadableStream(underlyingSource2);
    pull._branch1 = branch1Stream._readableStreamController;
    pull._branch2 = branch2Stream._readableStreamController;
    reader._closedPromise.catch(function (r) {
      if (teeState.closedOrErrored === true) {
        return;
      }
      ReadableStreamDefaultControllerError(pull._branch1, r);
      ReadableStreamDefaultControllerError(pull._branch2, r);
      teeState.closedOrErrored = true;
    });
    return [branch1Stream, branch2Stream];
  }
  function create_ReadableStreamTeePullFunction() {
    function f() {
      var reader = f._reader,
          branch1 = f._branch1,
          branch2 = f._branch2,
          teeState = f._teeState;
      return ReadableStreamDefaultReaderRead(reader).then(function (result) {
        assert(typeIsObject(result));
        var value = result.value;
        var done = result.done;
        assert(typeof done === 'boolean');
        if (done === true && teeState.closedOrErrored === false) {
          if (teeState.canceled1 === false) {
            ReadableStreamDefaultControllerClose(branch1);
          }
          if (teeState.canceled2 === false) {
            ReadableStreamDefaultControllerClose(branch2);
          }
          teeState.closedOrErrored = true;
        }
        if (teeState.closedOrErrored === true) {
          return;
        }
        var value1 = value;
        var value2 = value;
        if (teeState.canceled1 === false) {
          ReadableStreamDefaultControllerEnqueue(branch1, value1);
        }
        if (teeState.canceled2 === false) {
          ReadableStreamDefaultControllerEnqueue(branch2, value2);
        }
      });
    }
    return f;
  }
  function create_ReadableStreamTeeBranch1CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled1 = true;
      teeState.reason1 = reason;
      if (teeState.canceled2 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);
        teeState._resolve(cancelResult);
      }
      return teeState.promise;
    }
    return f;
  }
  function create_ReadableStreamTeeBranch2CancelFunction() {
    function f(reason) {
      var stream = f._stream,
          teeState = f._teeState;
      teeState.canceled2 = true;
      teeState.reason2 = reason;
      if (teeState.canceled1 === true) {
        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
        var cancelResult = ReadableStreamCancel(stream, compositeReason);
        teeState._resolve(cancelResult);
      }
      return teeState.promise;
    }
    return f;
  }
  function ReadableStreamAddReadIntoRequest(stream) {
    assert(IsReadableStreamBYOBReader(stream._reader) === true);
    assert(stream._state === 'readable' || stream._state === 'closed');
    var promise = new Promise(function (resolve, reject) {
      var readIntoRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._reader._readIntoRequests.push(readIntoRequest);
    });
    return promise;
  }
  function ReadableStreamAddReadRequest(stream) {
    assert(IsReadableStreamDefaultReader(stream._reader) === true);
    assert(stream._state === 'readable');
    var promise = new Promise(function (resolve, reject) {
      var readRequest = {
        _resolve: resolve,
        _reject: reject
      };
      stream._reader._readRequests.push(readRequest);
    });
    return promise;
  }
  function ReadableStreamCancel(stream, reason) {
    stream._disturbed = true;
    if (stream._state === 'closed') {
      return Promise.resolve(undefined);
    }
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    ReadableStreamClose(stream);
    var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
    return sourceCancelPromise.then(function () {
      return undefined;
    });
  }
  function ReadableStreamClose(stream) {
    assert(stream._state === 'readable');
    stream._state = 'closed';
    var reader = stream._reader;
    if (reader === undefined) {
      return undefined;
    }
    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var _resolve = reader._readRequests[i]._resolve;
        _resolve(CreateIterResultObject(undefined, true));
      }
      reader._readRequests = [];
    }
    defaultReaderClosedPromiseResolve(reader);
    return undefined;
  }
  function ReadableStreamError(stream, e) {
    assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
    assert(stream._state === 'readable', 'state must be readable');
    stream._state = 'errored';
    stream._storedError = e;
    var reader = stream._reader;
    if (reader === undefined) {
      return undefined;
    }
    if (IsReadableStreamDefaultReader(reader) === true) {
      for (var i = 0; i < reader._readRequests.length; i++) {
        var readRequest = reader._readRequests[i];
        readRequest._reject(e);
      }
      reader._readRequests = [];
    } else {
      assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');
      for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
        var readIntoRequest = reader._readIntoRequests[_i];
        readIntoRequest._reject(e);
      }
      reader._readIntoRequests = [];
    }
    defaultReaderClosedPromiseReject(reader, e);
    reader._closedPromise.catch(function () {});
  }
  function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readIntoRequests.length > 0);
    var readIntoRequest = reader._readIntoRequests.shift();
    readIntoRequest._resolve(CreateIterResultObject(chunk, done));
  }
  function ReadableStreamFulfillReadRequest(stream, chunk, done) {
    var reader = stream._reader;
    assert(reader._readRequests.length > 0);
    var readRequest = reader._readRequests.shift();
    readRequest._resolve(CreateIterResultObject(chunk, done));
  }
  function ReadableStreamGetNumReadIntoRequests(stream) {
    return stream._reader._readIntoRequests.length;
  }
  function ReadableStreamGetNumReadRequests(stream) {
    return stream._reader._readRequests.length;
  }
  function ReadableStreamHasBYOBReader(stream) {
    var reader = stream._reader;
    if (reader === undefined) {
      return false;
    }
    if (IsReadableStreamBYOBReader(reader) === false) {
      return false;
    }
    return true;
  }
  function ReadableStreamHasDefaultReader(stream) {
    var reader = stream._reader;
    if (reader === undefined) {
      return false;
    }
    if (IsReadableStreamDefaultReader(reader) === false) {
      return false;
    }
    return true;
  }
  var ReadableStreamDefaultReader = function () {
    function ReadableStreamDefaultReader(stream) {
      _classCallCheck(this, ReadableStreamDefaultReader);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
      }
      if (IsReadableStreamLocked(stream) === true) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }
      ReadableStreamReaderGenericInitialize(this, stream);
      this._readRequests = [];
    }
    _createClass(ReadableStreamDefaultReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('cancel'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }
        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('read'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }
        return ReadableStreamDefaultReaderRead(this);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (IsReadableStreamDefaultReader(this) === false) {
          throw defaultReaderBrandCheckException('releaseLock');
        }
        if (this._ownerReadableStream === undefined) {
          return;
        }
        if (this._readRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }
        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (IsReadableStreamDefaultReader(this) === false) {
          return Promise.reject(defaultReaderBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }]);
    return ReadableStreamDefaultReader;
  }();
  var ReadableStreamBYOBReader = function () {
    function ReadableStreamBYOBReader(stream) {
      _classCallCheck(this, ReadableStreamBYOBReader);
      if (!IsReadableStream(stream)) {
        throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
      }
      if (IsReadableByteStreamController(stream._readableStreamController) === false) {
        throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
      }
      if (IsReadableStreamLocked(stream)) {
        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
      }
      ReadableStreamReaderGenericInitialize(this, stream);
      this._readIntoRequests = [];
    }
    _createClass(ReadableStreamBYOBReader, [{
      key: 'cancel',
      value: function cancel(reason) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('cancel'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('cancel'));
        }
        return ReadableStreamReaderGenericCancel(this, reason);
      }
    }, {
      key: 'read',
      value: function read(view) {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('read'));
        }
        if (this._ownerReadableStream === undefined) {
          return Promise.reject(readerLockException('read from'));
        }
        if (!ArrayBuffer.isView(view)) {
          return Promise.reject(new TypeError('view must be an array buffer view'));
        }
        if (view.byteLength === 0) {
          return Promise.reject(new TypeError('view must have non-zero byteLength'));
        }
        return ReadableStreamBYOBReaderRead(this, view);
      }
    }, {
      key: 'releaseLock',
      value: function releaseLock() {
        if (!IsReadableStreamBYOBReader(this)) {
          throw byobReaderBrandCheckException('releaseLock');
        }
        if (this._ownerReadableStream === undefined) {
          return;
        }
        if (this._readIntoRequests.length > 0) {
          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
        }
        ReadableStreamReaderGenericRelease(this);
      }
    }, {
      key: 'closed',
      get: function get() {
        if (!IsReadableStreamBYOBReader(this)) {
          return Promise.reject(byobReaderBrandCheckException('closed'));
        }
        return this._closedPromise;
      }
    }]);
    return ReadableStreamBYOBReader;
  }();
  function IsReadableStreamBYOBReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamDefaultReader(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
      return false;
    }
    return true;
  }
  function ReadableStreamReaderGenericInitialize(reader, stream) {
    reader._ownerReadableStream = stream;
    stream._reader = reader;
    if (stream._state === 'readable') {
      defaultReaderClosedPromiseInitialize(reader);
    } else if (stream._state === 'closed') {
      defaultReaderClosedPromiseInitializeAsResolved(reader);
    } else {
      assert(stream._state === 'errored', 'state must be errored');
      defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
      reader._closedPromise.catch(function () {});
    }
  }
  function ReadableStreamReaderGenericCancel(reader, reason) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    return ReadableStreamCancel(stream, reason);
  }
  function ReadableStreamReaderGenericRelease(reader) {
    assert(reader._ownerReadableStream !== undefined);
    assert(reader._ownerReadableStream._reader === reader);
    if (reader._ownerReadableStream._state === 'readable') {
      defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    } else {
      defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
    }
    reader._closedPromise.catch(function () {});
    reader._ownerReadableStream._reader = undefined;
    reader._ownerReadableStream = undefined;
  }
  function ReadableStreamBYOBReaderRead(reader, view) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
  }
  function ReadableStreamDefaultReaderRead(reader) {
    var stream = reader._ownerReadableStream;
    assert(stream !== undefined);
    stream._disturbed = true;
    if (stream._state === 'closed') {
      return Promise.resolve(CreateIterResultObject(undefined, true));
    }
    if (stream._state === 'errored') {
      return Promise.reject(stream._storedError);
    }
    assert(stream._state === 'readable');
    return stream._readableStreamController.__pullSteps();
  }
  var ReadableStreamDefaultController = function () {
    function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
      _classCallCheck(this, ReadableStreamDefaultController);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
      }
      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
      }
      this._controlledReadableStream = stream;
      this._underlyingSource = underlyingSource;
      this._queue = undefined;
      this._queueTotalSize = undefined;
      ResetQueue(this);
      this._started = false;
      this._closeRequested = false;
      this._pullAgain = false;
      this._pulling = false;
      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
      this._strategySize = normalizedStrategy.size;
      this._strategyHWM = normalizedStrategy.highWaterMark;
      var controller = this;
      var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }, function (r) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
      }).catch(rethrowAssertionErrorRejection);
    }
    _createClass(ReadableStreamDefaultController, [{
      key: 'close',
      value: function close() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }
        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }
        ReadableStreamDefaultControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }
        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }
        return ReadableStreamDefaultControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }
        var stream = this._controlledReadableStream;
        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }
        ReadableStreamDefaultControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        if (this._queue.length > 0) {
          var chunk = DequeueValue(this);
          if (this._closeRequested === true && this._queue.length === 0) {
            ReadableStreamClose(stream);
          } else {
            ReadableStreamDefaultControllerCallPullIfNeeded(this);
          }
          return Promise.resolve(CreateIterResultObject(chunk, false));
        }
        var pendingPromise = ReadableStreamAddReadRequest(stream);
        ReadableStreamDefaultControllerCallPullIfNeeded(this);
        return pendingPromise;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }
        return ReadableStreamDefaultControllerGetDesiredSize(this);
      }
    }]);
    return ReadableStreamDefaultController;
  }();
  function IsReadableStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
      return false;
    }
    return true;
  }
  function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
    if (shouldPull === false) {
      return undefined;
    }
    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }
    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;
      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
      }
      return undefined;
    }, function (e) {
      ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
    }).catch(rethrowAssertionErrorRejection);
    return undefined;
  }
  function ReadableStreamDefaultControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;
    if (stream._state === 'closed' || stream._state === 'errored') {
      return false;
    }
    if (controller._closeRequested === true) {
      return false;
    }
    if (controller._started === false) {
      return false;
    }
    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }
    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    if (desiredSize > 0) {
      return true;
    }
    return false;
  }
  function ReadableStreamDefaultControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    controller._closeRequested = true;
    if (controller._queue.length === 0) {
      ReadableStreamClose(stream);
    }
  }
  function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      ReadableStreamFulfillReadRequest(stream, chunk, false);
    } else {
      var chunkSize = 1;
      if (controller._strategySize !== undefined) {
        var strategySize = controller._strategySize;
        try {
          chunkSize = strategySize(chunk);
        } catch (chunkSizeE) {
          ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
          throw chunkSizeE;
        }
      }
      try {
        EnqueueValueWithSize(controller, chunk, chunkSize);
      } catch (enqueueE) {
        ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
        throw enqueueE;
      }
    }
    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
    return undefined;
  }
  function ReadableStreamDefaultControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }
  function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
    if (controller._controlledReadableStream._state === 'readable') {
      ReadableStreamDefaultControllerError(controller, e);
    }
  }
  function ReadableStreamDefaultControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;
    if (state === 'errored') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return controller._strategyHWM - controller._queueTotalSize;
  }
  var ReadableStreamBYOBRequest = function () {
    function ReadableStreamBYOBRequest(controller, view) {
      _classCallCheck(this, ReadableStreamBYOBRequest);
      this._associatedReadableByteStreamController = controller;
      this._view = view;
    }
    _createClass(ReadableStreamBYOBRequest, [{
      key: 'respond',
      value: function respond(bytesWritten) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }
        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }
        ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
      }
    }, {
      key: 'respondWithNewView',
      value: function respondWithNewView(view) {
        if (IsReadableStreamBYOBRequest(this) === false) {
          throw byobRequestBrandCheckException('respond');
        }
        if (this._associatedReadableByteStreamController === undefined) {
          throw new TypeError('This BYOB request has been invalidated');
        }
        if (!ArrayBuffer.isView(view)) {
          throw new TypeError('You can only respond with array buffer views');
        }
        ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
      }
    }, {
      key: 'view',
      get: function get() {
        return this._view;
      }
    }]);
    return ReadableStreamBYOBRequest;
  }();
  var ReadableByteStreamController = function () {
    function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
      _classCallCheck(this, ReadableByteStreamController);
      if (IsReadableStream(stream) === false) {
        throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
      }
      if (stream._readableStreamController !== undefined) {
        throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
      }
      this._controlledReadableStream = stream;
      this._underlyingByteSource = underlyingByteSource;
      this._pullAgain = false;
      this._pulling = false;
      ReadableByteStreamControllerClearPendingPullIntos(this);
      this._queue = this._queueTotalSize = undefined;
      ResetQueue(this);
      this._closeRequested = false;
      this._started = false;
      this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
      var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
      if (autoAllocateChunkSize !== undefined) {
        if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
          throw new RangeError('autoAllocateChunkSize must be a positive integer');
        }
      }
      this._autoAllocateChunkSize = autoAllocateChunkSize;
      this._pendingPullIntos = [];
      var controller = this;
      var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
      Promise.resolve(startResult).then(function () {
        controller._started = true;
        assert(controller._pulling === false);
        assert(controller._pullAgain === false);
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }, function (r) {
        if (stream._state === 'readable') {
          ReadableByteStreamControllerError(controller, r);
        }
      }).catch(rethrowAssertionErrorRejection);
    }
    _createClass(ReadableByteStreamController, [{
      key: 'close',
      value: function close() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('close');
        }
        if (this._closeRequested === true) {
          throw new TypeError('The stream has already been closed; do not close it again!');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
        }
        ReadableByteStreamControllerClose(this);
      }
    }, {
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('enqueue');
        }
        if (this._closeRequested === true) {
          throw new TypeError('stream is closed or draining');
        }
        var state = this._controlledReadableStream._state;
        if (state !== 'readable') {
          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
        }
        if (!ArrayBuffer.isView(chunk)) {
          throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
        }
        ReadableByteStreamControllerEnqueue(this, chunk);
      }
    }, {
      key: 'error',
      value: function error(e) {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('error');
        }
        var stream = this._controlledReadableStream;
        if (stream._state !== 'readable') {
          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
        }
        ReadableByteStreamControllerError(this, e);
      }
    }, {
      key: '__cancelSteps',
      value: function __cancelSteps(reason) {
        if (this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          firstDescriptor.bytesFilled = 0;
        }
        ResetQueue(this);
        return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
      }
    }, {
      key: '__pullSteps',
      value: function __pullSteps() {
        var stream = this._controlledReadableStream;
        assert(ReadableStreamHasDefaultReader(stream) === true);
        if (this._queueTotalSize > 0) {
          assert(ReadableStreamGetNumReadRequests(stream) === 0);
          var entry = this._queue.shift();
          this._queueTotalSize -= entry.byteLength;
          ReadableByteStreamControllerHandleQueueDrain(this);
          var view = void 0;
          try {
            view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
          } catch (viewE) {
            return Promise.reject(viewE);
          }
          return Promise.resolve(CreateIterResultObject(view, false));
        }
        var autoAllocateChunkSize = this._autoAllocateChunkSize;
        if (autoAllocateChunkSize !== undefined) {
          var buffer = void 0;
          try {
            buffer = new ArrayBuffer(autoAllocateChunkSize);
          } catch (bufferE) {
            return Promise.reject(bufferE);
          }
          var pullIntoDescriptor = {
            buffer: buffer,
            byteOffset: 0,
            byteLength: autoAllocateChunkSize,
            bytesFilled: 0,
            elementSize: 1,
            ctor: Uint8Array,
            readerType: 'default'
          };
          this._pendingPullIntos.push(pullIntoDescriptor);
        }
        var promise = ReadableStreamAddReadRequest(stream);
        ReadableByteStreamControllerCallPullIfNeeded(this);
        return promise;
      }
    }, {
      key: 'byobRequest',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('byobRequest');
        }
        if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
          var firstDescriptor = this._pendingPullIntos[0];
          var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
          this._byobRequest = new ReadableStreamBYOBRequest(this, view);
        }
        return this._byobRequest;
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsReadableByteStreamController(this) === false) {
          throw byteStreamControllerBrandCheckException('desiredSize');
        }
        return ReadableByteStreamControllerGetDesiredSize(this);
      }
    }]);
    return ReadableByteStreamController;
  }();
  function IsReadableByteStreamController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
      return false;
    }
    return true;
  }
  function IsReadableStreamBYOBRequest(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
      return false;
    }
    return true;
  }
  function ReadableByteStreamControllerCallPullIfNeeded(controller) {
    var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
    if (shouldPull === false) {
      return undefined;
    }
    if (controller._pulling === true) {
      controller._pullAgain = true;
      return undefined;
    }
    assert(controller._pullAgain === false);
    controller._pulling = true;
    var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
    pullPromise.then(function () {
      controller._pulling = false;
      if (controller._pullAgain === true) {
        controller._pullAgain = false;
        ReadableByteStreamControllerCallPullIfNeeded(controller);
      }
    }, function (e) {
      if (controller._controlledReadableStream._state === 'readable') {
        ReadableByteStreamControllerError(controller, e);
      }
    }).catch(rethrowAssertionErrorRejection);
    return undefined;
  }
  function ReadableByteStreamControllerClearPendingPullIntos(controller) {
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    controller._pendingPullIntos = [];
  }
  function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
    assert(stream._state !== 'errored', 'state must not be errored');
    var done = false;
    if (stream._state === 'closed') {
      assert(pullIntoDescriptor.bytesFilled === 0);
      done = true;
    }
    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
    if (pullIntoDescriptor.readerType === 'default') {
      ReadableStreamFulfillReadRequest(stream, filledView, done);
    } else {
      assert(pullIntoDescriptor.readerType === 'byob');
      ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
    }
  }
  function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
    var bytesFilled = pullIntoDescriptor.bytesFilled;
    var elementSize = pullIntoDescriptor.elementSize;
    assert(bytesFilled <= pullIntoDescriptor.byteLength);
    assert(bytesFilled % elementSize === 0);
    return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
  }
  function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
    controller._queue.push({
      buffer: buffer,
      byteOffset: byteOffset,
      byteLength: byteLength
    });
    controller._queueTotalSize += byteLength;
  }
  function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
    var elementSize = pullIntoDescriptor.elementSize;
    var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
    var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
    var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
    var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
    var totalBytesToCopyRemaining = maxBytesToCopy;
    var ready = false;
    if (maxAlignedBytes > currentAlignedBytes) {
      totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
      ready = true;
    }
    var queue = controller._queue;
    while (totalBytesToCopyRemaining > 0) {
      var headOfQueue = queue[0];
      var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
      var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
      if (headOfQueue.byteLength === bytesToCopy) {
        queue.shift();
      } else {
        headOfQueue.byteOffset += bytesToCopy;
        headOfQueue.byteLength -= bytesToCopy;
      }
      controller._queueTotalSize -= bytesToCopy;
      ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
      totalBytesToCopyRemaining -= bytesToCopy;
    }
    if (ready === false) {
      assert(controller._queueTotalSize === 0, 'queue must be empty');
      assert(pullIntoDescriptor.bytesFilled > 0);
      assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
    }
    return ready;
  }
  function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
    assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    pullIntoDescriptor.bytesFilled += size;
  }
  function ReadableByteStreamControllerHandleQueueDrain(controller) {
    assert(controller._controlledReadableStream._state === 'readable');
    if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
      ReadableStreamClose(controller._controlledReadableStream);
    } else {
      ReadableByteStreamControllerCallPullIfNeeded(controller);
    }
  }
  function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
    if (controller._byobRequest === undefined) {
      return;
    }
    controller._byobRequest._associatedReadableByteStreamController = undefined;
    controller._byobRequest._view = undefined;
    controller._byobRequest = undefined;
  }
  function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
    assert(controller._closeRequested === false);
    while (controller._pendingPullIntos.length > 0) {
      if (controller._queueTotalSize === 0) {
        return;
      }
      var pullIntoDescriptor = controller._pendingPullIntos[0];
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
      }
    }
  }
  function ReadableByteStreamControllerPullInto(controller, view) {
    var stream = controller._controlledReadableStream;
    var elementSize = 1;
    if (view.constructor !== DataView) {
      elementSize = view.constructor.BYTES_PER_ELEMENT;
    }
    var ctor = view.constructor;
    var pullIntoDescriptor = {
      buffer: view.buffer,
      byteOffset: view.byteOffset,
      byteLength: view.byteLength,
      bytesFilled: 0,
      elementSize: elementSize,
      ctor: ctor,
      readerType: 'byob'
    };
    if (controller._pendingPullIntos.length > 0) {
      pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
      controller._pendingPullIntos.push(pullIntoDescriptor);
      return ReadableStreamAddReadIntoRequest(stream);
    }
    if (stream._state === 'closed') {
      var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
      return Promise.resolve(CreateIterResultObject(emptyView, true));
    }
    if (controller._queueTotalSize > 0) {
      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
        ReadableByteStreamControllerHandleQueueDrain(controller);
        return Promise.resolve(CreateIterResultObject(filledView, false));
      }
      if (controller._closeRequested === true) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        return Promise.reject(e);
      }
    }
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    controller._pendingPullIntos.push(pullIntoDescriptor);
    var promise = ReadableStreamAddReadIntoRequest(stream);
    ReadableByteStreamControllerCallPullIfNeeded(controller);
    return promise;
  }
  function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
    firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
    assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
    var stream = controller._controlledReadableStream;
    if (ReadableStreamHasBYOBReader(stream) === true) {
      while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
        var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
        ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
      }
    }
  }
  function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
    if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
      throw new RangeError('bytesWritten out of range');
    }
    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
    if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
      return;
    }
    ReadableByteStreamControllerShiftPendingPullInto(controller);
    var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
    if (remainderSize > 0) {
      var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
      var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
    }
    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
    pullIntoDescriptor.bytesFilled -= remainderSize;
    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
  }
  function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
    var firstDescriptor = controller._pendingPullIntos[0];
    var stream = controller._controlledReadableStream;
    if (stream._state === 'closed') {
      if (bytesWritten !== 0) {
        throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
      }
      ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
    } else {
      assert(stream._state === 'readable');
      ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
    }
  }
  function ReadableByteStreamControllerShiftPendingPullInto(controller) {
    var descriptor = controller._pendingPullIntos.shift();
    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
    return descriptor;
  }
  function ReadableByteStreamControllerShouldCallPull(controller) {
    var stream = controller._controlledReadableStream;
    if (stream._state !== 'readable') {
      return false;
    }
    if (controller._closeRequested === true) {
      return false;
    }
    if (controller._started === false) {
      return false;
    }
    if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
      return true;
    }
    if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
      return true;
    }
    if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
      return true;
    }
    return false;
  }
  function ReadableByteStreamControllerClose(controller) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    if (controller._queueTotalSize > 0) {
      controller._closeRequested = true;
      return;
    }
    if (controller._pendingPullIntos.length > 0) {
      var firstPendingPullInto = controller._pendingPullIntos[0];
      if (firstPendingPullInto.bytesFilled > 0) {
        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
        ReadableByteStreamControllerError(controller, e);
        throw e;
      }
    }
    ReadableStreamClose(stream);
  }
  function ReadableByteStreamControllerEnqueue(controller, chunk) {
    var stream = controller._controlledReadableStream;
    assert(controller._closeRequested === false);
    assert(stream._state === 'readable');
    var buffer = chunk.buffer;
    var byteOffset = chunk.byteOffset;
    var byteLength = chunk.byteLength;
    var transferredBuffer = TransferArrayBuffer(buffer);
    if (ReadableStreamHasDefaultReader(stream) === true) {
      if (ReadableStreamGetNumReadRequests(stream) === 0) {
        ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      } else {
        assert(controller._queue.length === 0);
        var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
        ReadableStreamFulfillReadRequest(stream, transferredView, false);
      }
    } else if (ReadableStreamHasBYOBReader(stream) === true) {
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
      ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
    } else {
      assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
    }
  }
  function ReadableByteStreamControllerError(controller, e) {
    var stream = controller._controlledReadableStream;
    assert(stream._state === 'readable');
    ReadableByteStreamControllerClearPendingPullIntos(controller);
    ResetQueue(controller);
    ReadableStreamError(stream, e);
  }
  function ReadableByteStreamControllerGetDesiredSize(controller) {
    var stream = controller._controlledReadableStream;
    var state = stream._state;
    if (state === 'errored') {
      return null;
    }
    if (state === 'closed') {
      return 0;
    }
    return controller._strategyHWM - controller._queueTotalSize;
  }
  function ReadableByteStreamControllerRespond(controller, bytesWritten) {
    bytesWritten = Number(bytesWritten);
    if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
      throw new RangeError('bytesWritten must be a finite');
    }
    assert(controller._pendingPullIntos.length > 0);
    ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
  }
  function ReadableByteStreamControllerRespondWithNewView(controller, view) {
    assert(controller._pendingPullIntos.length > 0);
    var firstDescriptor = controller._pendingPullIntos[0];
    if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
      throw new RangeError('The region specified by view does not match byobRequest');
    }
    if (firstDescriptor.byteLength !== view.byteLength) {
      throw new RangeError('The buffer of view has different capacity than byobRequest');
    }
    firstDescriptor.buffer = view.buffer;
    ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
  }
  function streamBrandCheckException(name) {
    return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
  }
  function readerLockException(name) {
    return new TypeError('Cannot ' + name + ' a stream using a released reader');
  }
  function defaultReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
  }
  function defaultReaderClosedPromiseInitialize(reader) {
    reader._closedPromise = new Promise(function (resolve, reject) {
      reader._closedPromise_resolve = resolve;
      reader._closedPromise_reject = reject;
    });
  }
  function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
    reader._closedPromise = Promise.reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseInitializeAsResolved(reader) {
    reader._closedPromise = Promise.resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseReject(reader, reason) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);
    reader._closedPromise_reject(reason);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function defaultReaderClosedPromiseResetToRejected(reader, reason) {
    assert(reader._closedPromise_resolve === undefined);
    assert(reader._closedPromise_reject === undefined);
    reader._closedPromise = Promise.reject(reason);
  }
  function defaultReaderClosedPromiseResolve(reader) {
    assert(reader._closedPromise_resolve !== undefined);
    assert(reader._closedPromise_reject !== undefined);
    reader._closedPromise_resolve(undefined);
    reader._closedPromise_resolve = undefined;
    reader._closedPromise_reject = undefined;
  }
  function byobReaderBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
  }
  function defaultControllerBrandCheckException(name) {
    return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
  }
  function byobRequestBrandCheckException(name) {
    return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
  }
  function byteStreamControllerBrandCheckException(name) {
    return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
  }
  function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
    try {
      Promise.prototype.then.call(promise, undefined, function () {});
    } catch (e) {}
  }
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var transformStream = __w_pdfjs_require__(6);
  var readableStream = __w_pdfjs_require__(4);
  var writableStream = __w_pdfjs_require__(2);
  exports.TransformStream = transformStream.TransformStream;
  exports.ReadableStream = readableStream.ReadableStream;
  exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
  exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
  exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
  exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
  exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
  exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
  exports.IsWritableStream = writableStream.IsWritableStream;
  exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
  exports.WritableStream = writableStream.WritableStream;
  exports.WritableStreamAbort = writableStream.WritableStreamAbort;
  exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
  exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
  exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
  exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
}, function (module, exports, __w_pdfjs_require__) {
  "use strict";

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var _require = __w_pdfjs_require__(1),
      assert = _require.assert;
  var _require2 = __w_pdfjs_require__(0),
      InvokeOrNoop = _require2.InvokeOrNoop,
      PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
      PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
      typeIsObject = _require2.typeIsObject;
  var _require3 = __w_pdfjs_require__(4),
      ReadableStream = _require3.ReadableStream,
      ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
      ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
      ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
      ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
  var _require4 = __w_pdfjs_require__(2),
      WritableStream = _require4.WritableStream,
      WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
  function TransformStreamCloseReadable(transformStream) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }
    TransformStreamCloseReadableInternal(transformStream);
  }
  function TransformStreamEnqueueToReadable(transformStream, chunk) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    if (transformStream._readableClosed === true) {
      throw new TypeError('Readable side is already closed');
    }
    var controller = transformStream._readableController;
    try {
      ReadableStreamDefaultControllerEnqueue(controller, chunk);
    } catch (e) {
      transformStream._readableClosed = true;
      TransformStreamErrorIfNeeded(transformStream, e);
      throw transformStream._storedError;
    }
    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
    var maybeBackpressure = desiredSize <= 0;
    if (maybeBackpressure === true && transformStream._backpressure === false) {
      TransformStreamSetBackpressure(transformStream, true);
    }
  }
  function TransformStreamError(transformStream, e) {
    if (transformStream._errored === true) {
      throw new TypeError('TransformStream is already errored');
    }
    TransformStreamErrorInternal(transformStream, e);
  }
  function TransformStreamCloseReadableInternal(transformStream) {
    assert(transformStream._errored === false);
    assert(transformStream._readableClosed === false);
    try {
      ReadableStreamDefaultControllerClose(transformStream._readableController);
    } catch (e) {
      assert(false);
    }
    transformStream._readableClosed = true;
  }
  function TransformStreamErrorIfNeeded(transformStream, e) {
    if (transformStream._errored === false) {
      TransformStreamErrorInternal(transformStream, e);
    }
  }
  function TransformStreamErrorInternal(transformStream, e) {
    assert(transformStream._errored === false);
    transformStream._errored = true;
    transformStream._storedError = e;
    if (transformStream._writableDone === false) {
      WritableStreamDefaultControllerError(transformStream._writableController, e);
    }
    if (transformStream._readableClosed === false) {
      ReadableStreamDefaultControllerError(transformStream._readableController, e);
    }
  }
  function TransformStreamReadableReadyPromise(transformStream) {
    assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
    if (transformStream._backpressure === false) {
      return Promise.resolve();
    }
    assert(transformStream._backpressure === true, '_backpressure should have been initialized');
    return transformStream._backpressureChangePromise;
  }
  function TransformStreamSetBackpressure(transformStream, backpressure) {
    assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');
    if (transformStream._backpressureChangePromise !== undefined) {
      transformStream._backpressureChangePromise_resolve(backpressure);
    }
    transformStream._backpressureChangePromise = new Promise(function (resolve) {
      transformStream._backpressureChangePromise_resolve = resolve;
    });
    transformStream._backpressureChangePromise.then(function (resolution) {
      assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
    });
    transformStream._backpressure = backpressure;
  }
  function TransformStreamDefaultTransform(chunk, transformStreamController) {
    var transformStream = transformStreamController._controlledTransformStream;
    TransformStreamEnqueueToReadable(transformStream, chunk);
    return Promise.resolve();
  }
  function TransformStreamTransform(transformStream, chunk) {
    assert(transformStream._errored === false);
    assert(transformStream._transforming === false);
    assert(transformStream._backpressure === false);
    transformStream._transforming = true;
    var transformer = transformStream._transformer;
    var controller = transformStream._transformStreamController;
    var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
    return transformPromise.then(function () {
      transformStream._transforming = false;
      return TransformStreamReadableReadyPromise(transformStream);
    }, function (e) {
      TransformStreamErrorIfNeeded(transformStream, e);
      return Promise.reject(e);
    });
  }
  function IsTransformStreamDefaultController(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
      return false;
    }
    return true;
  }
  function IsTransformStream(x) {
    if (!typeIsObject(x)) {
      return false;
    }
    if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
      return false;
    }
    return true;
  }
  var TransformStreamSink = function () {
    function TransformStreamSink(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSink);
      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }
    _createClass(TransformStreamSink, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._writableController = c;
        return this._startPromise.then(function () {
          return TransformStreamReadableReadyPromise(transformStream);
        });
      }
    }, {
      key: 'write',
      value: function write(chunk) {
        var transformStream = this._transformStream;
        return TransformStreamTransform(transformStream, chunk);
      }
    }, {
      key: 'abort',
      value: function abort() {
        var transformStream = this._transformStream;
        transformStream._writableDone = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
      }
    }, {
      key: 'close',
      value: function close() {
        var transformStream = this._transformStream;
        assert(transformStream._transforming === false);
        transformStream._writableDone = true;
        var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
        return flushPromise.then(function () {
          if (transformStream._errored === true) {
            return Promise.reject(transformStream._storedError);
          }
          if (transformStream._readableClosed === false) {
            TransformStreamCloseReadableInternal(transformStream);
          }
          return Promise.resolve();
        }).catch(function (r) {
          TransformStreamErrorIfNeeded(transformStream, r);
          return Promise.reject(transformStream._storedError);
        });
      }
    }]);
    return TransformStreamSink;
  }();
  var TransformStreamSource = function () {
    function TransformStreamSource(transformStream, startPromise) {
      _classCallCheck(this, TransformStreamSource);
      this._transformStream = transformStream;
      this._startPromise = startPromise;
    }
    _createClass(TransformStreamSource, [{
      key: 'start',
      value: function start(c) {
        var transformStream = this._transformStream;
        transformStream._readableController = c;
        return this._startPromise.then(function () {
          assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
          if (transformStream._backpressure === true) {
            return Promise.resolve();
          }
          assert(transformStream._backpressure === false, '_backpressure should have been initialized');
          return transformStream._backpressureChangePromise;
        });
      }
    }, {
      key: 'pull',
      value: function pull() {
        var transformStream = this._transformStream;
        assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
        TransformStreamSetBackpressure(transformStream, false);
        return transformStream._backpressureChangePromise;
      }
    }, {
      key: 'cancel',
      value: function cancel() {
        var transformStream = this._transformStream;
        transformStream._readableClosed = true;
        TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
      }
    }]);
    return TransformStreamSource;
  }();
  var TransformStreamDefaultController = function () {
    function TransformStreamDefaultController(transformStream) {
      _classCallCheck(this, TransformStreamDefaultController);
      if (IsTransformStream(transformStream) === false) {
        throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
      }
      if (transformStream._transformStreamController !== undefined) {
        throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
      }
      this._controlledTransformStream = transformStream;
    }
    _createClass(TransformStreamDefaultController, [{
      key: 'enqueue',
      value: function enqueue(chunk) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('enqueue');
        }
        TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
      }
    }, {
      key: 'close',
      value: function close() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('close');
        }
        TransformStreamCloseReadable(this._controlledTransformStream);
      }
    }, {
      key: 'error',
      value: function error(reason) {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('error');
        }
        TransformStreamError(this._controlledTransformStream, reason);
      }
    }, {
      key: 'desiredSize',
      get: function get() {
        if (IsTransformStreamDefaultController(this) === false) {
          throw defaultControllerBrandCheckException('desiredSize');
        }
        var transformStream = this._controlledTransformStream;
        var readableController = transformStream._readableController;
        return ReadableStreamDefaultControllerGetDesiredSize(readableController);
      }
    }]);
    return TransformStreamDefaultController;
  }();
  var TransformStream = function () {
    function TransformStream() {
      var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, TransformStream);
      this._transformer = transformer;
      var readableStrategy = transformer.readableStrategy,
          writableStrategy = transformer.writableStrategy;
      this._transforming = false;
      this._errored = false;
      this._storedError = undefined;
      this._writableController = undefined;
      this._readableController = undefined;
      this._transformStreamController = undefined;
      this._writableDone = false;
      this._readableClosed = false;
      this._backpressure = undefined;
      this._backpressureChangePromise = undefined;
      this._backpressureChangePromise_resolve = undefined;
      this._transformStreamController = new TransformStreamDefaultController(this);
      var startPromise_resolve = void 0;
      var startPromise = new Promise(function (resolve) {
        startPromise_resolve = resolve;
      });
      var source = new TransformStreamSource(this, startPromise);
      this._readable = new ReadableStream(source, readableStrategy);
      var sink = new TransformStreamSink(this, startPromise);
      this._writable = new WritableStream(sink, writableStrategy);
      assert(this._writableController !== undefined);
      assert(this._readableController !== undefined);
      var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
      TransformStreamSetBackpressure(this, desiredSize <= 0);
      var transformStream = this;
      var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
      startPromise_resolve(startResult);
      startPromise.catch(function (e) {
        if (transformStream._errored === false) {
          transformStream._errored = true;
          transformStream._storedError = e;
        }
      });
    }
    _createClass(TransformStream, [{
      key: 'readable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('readable');
        }
        return this._readable;
      }
    }, {
      key: 'writable',
      get: function get() {
        if (IsTransformStream(this) === false) {
          throw streamBrandCheckException('writable');
        }
        return this._writable;
      }
    }]);
    return TransformStream;
  }();
  module.exports = { TransformStream: TransformStream };
  function defaultControllerBrandCheckException(name) {
    return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
  }
  function streamBrandCheckException(name) {
    return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
  }
}, function (module, exports, __w_pdfjs_require__) {
  module.exports = __w_pdfjs_require__(5);
}]));

/***/ }),
/* 115 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFJS = exports.globalScope = undefined;

var _dom_utils = __w_pdfjs_require__(10);

var _util = __w_pdfjs_require__(0);

var _api = __w_pdfjs_require__(58);

var _annotation_layer = __w_pdfjs_require__(60);

var _global_scope = __w_pdfjs_require__(14);

var _global_scope2 = _interopRequireDefault(_global_scope);

var _metadata = __w_pdfjs_require__(59);

var _text_layer = __w_pdfjs_require__(61);

var _svg = __w_pdfjs_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!_global_scope2.default.PDFJS) {
  _global_scope2.default.PDFJS = {};
}
var PDFJS = _global_scope2.default.PDFJS;
{
  PDFJS.version = '2.0.305';
  PDFJS.build = '9c6a8801';
}
PDFJS.pdfBug = false;
if (PDFJS.verbosity !== undefined) {
  (0, _util.setVerbosityLevel)(PDFJS.verbosity);
}
delete PDFJS.verbosity;
Object.defineProperty(PDFJS, 'verbosity', {
  get: function get() {
    return (0, _util.getVerbosityLevel)();
  },
  set: function set(level) {
    (0, _util.setVerbosityLevel)(level);
  },

  enumerable: true,
  configurable: true
});
PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
PDFJS.OPS = _util.OPS;
PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
PDFJS.isValidUrl = _dom_utils.isValidUrl;
PDFJS.shadow = _util.shadow;
PDFJS.createBlob = _util.createBlob;
PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
  return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
};
Object.defineProperty(PDFJS, 'isLittleEndian', {
  configurable: true,
  get: function PDFJS_isLittleEndian() {
    return (0, _util.shadow)(PDFJS, 'isLittleEndian', (0, _util.isLittleEndian)());
  }
});
PDFJS.removeNullCharacters = _util.removeNullCharacters;
PDFJS.PasswordResponses = _util.PasswordResponses;
PDFJS.PasswordException = _util.PasswordException;
PDFJS.UnknownErrorException = _util.UnknownErrorException;
PDFJS.InvalidPDFException = _util.InvalidPDFException;
PDFJS.MissingPDFException = _util.MissingPDFException;
PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
PDFJS.Util = _util.Util;
PDFJS.PageViewport = _util.PageViewport;
PDFJS.createPromiseCapability = _util.createPromiseCapability;
PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? '' : PDFJS.imageResourcesPath;
PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
PDFJS.getDocument = _api.getDocument;
PDFJS.LoopbackPort = _api.LoopbackPort;
PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
PDFJS.PDFWorker = _api.PDFWorker;
PDFJS.LinkTarget = _dom_utils.LinkTarget;
PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
PDFJS.renderTextLayer = _text_layer.renderTextLayer;
PDFJS.Metadata = _metadata.Metadata;
PDFJS.SVGGraphics = _svg.SVGGraphics;
exports.globalScope = _global_scope2.default;
exports.PDFJS = PDFJS;

/***/ }),
/* 116 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontLoader = exports.FontFaceObject = undefined;

var _util = __w_pdfjs_require__(0);

function FontLoader(docId) {
  this.docId = docId;
  this.styleElement = null;
  this.nativeFontFaces = [];
  this.loadTestFontId = 0;
  this.loadingContext = {
    requests: [],
    nextRequestId: 0
  };
}
FontLoader.prototype = {
  insertRule: function fontLoaderInsertRule(rule) {
    var styleElement = this.styleElement;
    if (!styleElement) {
      styleElement = this.styleElement = document.createElement('style');
      styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
      document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    var styleSheet = styleElement.sheet;
    styleSheet.insertRule(rule, styleSheet.cssRules.length);
  },
  clear: function fontLoaderClear() {
    if (this.styleElement) {
      this.styleElement.remove();
      this.styleElement = null;
    }
    this.nativeFontFaces.forEach(function (nativeFontFace) {
      document.fonts.delete(nativeFontFace);
    });
    this.nativeFontFaces.length = 0;
  }
};
{
  var getLoadTestFont = function getLoadTestFont() {
    return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ' + 'AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA' + 'AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm' + 'FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA' + 'AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A' + 'ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA' + 'MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA' + 'AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA' + 'AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ' + 'AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA' + 'AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA' + 'EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA' + 'AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA' + 'AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc' + 'A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF' + 'hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA' + 'AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg' + 'ABAAAAAAAAAAAD6AAAAAAAAA==');
  };
  Object.defineProperty(FontLoader.prototype, 'loadTestFont', {
    get: function get() {
      return (0, _util.shadow)(this, 'loadTestFont', getLoadTestFont());
    },

    configurable: true
  });
  FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
    this.nativeFontFaces.push(nativeFontFace);
    document.fonts.add(nativeFontFace);
  };
  FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
    var rules = [];
    var fontsToLoad = [];
    var fontLoadPromises = [];
    var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
      return nativeFontFace.loaded.catch(function (e) {
        (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + e);
      });
    };
    var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
    for (var i = 0, ii = fonts.length; i < ii; i++) {
      var font = fonts[i];
      if (font.attached || font.loading === false) {
        continue;
      }
      font.attached = true;
      if (isFontLoadingAPISupported) {
        var nativeFontFace = font.createNativeFontFace();
        if (nativeFontFace) {
          this.addNativeFontFace(nativeFontFace);
          fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
        }
      } else {
        var rule = font.createFontFaceRule();
        if (rule) {
          this.insertRule(rule);
          rules.push(rule);
          fontsToLoad.push(font);
        }
      }
    }
    var request = this.queueLoadingCallback(callback);
    if (isFontLoadingAPISupported) {
      Promise.all(fontLoadPromises).then(function () {
        request.complete();
      });
    } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
      this.prepareFontLoadEvent(rules, fontsToLoad, request);
    } else {
      request.complete();
    }
  };
  FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
    function LoadLoader_completeRequest() {
      (0, _util.assert)(!request.end, 'completeRequest() cannot be called twice');
      request.end = Date.now();
      while (context.requests.length > 0 && context.requests[0].end) {
        var otherRequest = context.requests.shift();
        setTimeout(otherRequest.callback, 0);
      }
    }
    var context = this.loadingContext;
    var requestId = 'pdfjs-font-loading-' + context.nextRequestId++;
    var request = {
      id: requestId,
      complete: LoadLoader_completeRequest,
      callback: callback,
      started: Date.now()
    };
    context.requests.push(request);
    return request;
  };
  FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
    function int32(data, offset) {
      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
    }
    function spliceString(s, offset, remove, insert) {
      var chunk1 = s.substr(0, offset);
      var chunk2 = s.substr(offset + remove);
      return chunk1 + insert + chunk2;
    }
    var i, ii;
    var canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    var ctx = canvas.getContext('2d');
    var called = 0;
    function isFontReady(name, callback) {
      called++;
      if (called > 30) {
        (0, _util.warn)('Load test font never loaded.');
        callback();
        return;
      }
      ctx.font = '30px ' + name;
      ctx.fillText('.', 0, 20);
      var imageData = ctx.getImageData(0, 0, 1, 1);
      if (imageData.data[3] > 0) {
        callback();
        return;
      }
      setTimeout(isFontReady.bind(null, name, callback));
    }
    var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
    var data = this.loadTestFont;
    var COMMENT_OFFSET = 976;
    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
    var CFF_CHECKSUM_OFFSET = 16;
    var XXXX_VALUE = 0x58585858;
    var checksum = int32(data, CFF_CHECKSUM_OFFSET);
    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
    }
    if (i < loadTestFontId.length) {
      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
    }
    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
    var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
    var rule = '@font-face { font-family:"' + loadTestFontId + '";src:' + url + '}';
    this.insertRule(rule);
    var names = [];
    for (i = 0, ii = fonts.length; i < ii; i++) {
      names.push(fonts[i].loadedName);
    }
    names.push(loadTestFontId);
    var div = document.createElement('div');
    div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
    for (i = 0, ii = names.length; i < ii; ++i) {
      var span = document.createElement('span');
      span.textContent = 'Hi';
      span.style.fontFamily = names[i];
      div.appendChild(span);
    }
    document.body.appendChild(div);
    isFontReady(loadTestFontId, function () {
      document.body.removeChild(div);
      request.complete();
    });
  };
}
{
  FontLoader.isFontLoadingAPISupported = typeof document !== 'undefined' && !!document.fonts;
}
{
  var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
    if (typeof navigator === 'undefined') {
      return true;
    }
    var supported = false;
    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
    if (m && m[1] >= 14) {
      supported = true;
    }
    return supported;
  };
  Object.defineProperty(FontLoader, 'isSyncFontLoadingSupported', {
    get: function get() {
      return (0, _util.shadow)(FontLoader, 'isSyncFontLoadingSupported', isSyncFontLoadingSupported());
    },

    enumerable: true,
    configurable: true
  });
}
var IsEvalSupportedCached = {
  get value() {
    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
  }
};
var FontFaceObject = function FontFaceObjectClosure() {
  function FontFaceObject(translatedData, options) {
    this.compiledGlyphs = Object.create(null);
    for (var i in translatedData) {
      this[i] = translatedData[i];
    }
    this.options = options;
  }
  FontFaceObject.prototype = {
    createNativeFontFace: function FontFaceObject_createNativeFontFace() {
      if (!this.data) {
        return null;
      }
      if (this.options.disableFontFace) {
        this.disableFontFace = true;
        return null;
      }
      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
      if (this.options.fontRegistry) {
        this.options.fontRegistry.registerFont(this);
      }
      return nativeFontFace;
    },
    createFontFaceRule: function FontFaceObject_createFontFaceRule() {
      if (!this.data) {
        return null;
      }
      if (this.options.disableFontFace) {
        this.disableFontFace = true;
        return null;
      }
      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
      var fontName = this.loadedName;
      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
      var rule = '@font-face { font-family:"' + fontName + '";src:' + url + '}';
      if (this.options.fontRegistry) {
        this.options.fontRegistry.registerFont(this, url);
      }
      return rule;
    },
    getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
      if (!(character in this.compiledGlyphs)) {
        var cmds = objs.get(this.loadedName + '_path_' + character);
        var current, i, len;
        if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
          var args,
              js = '';
          for (i = 0, len = cmds.length; i < len; i++) {
            current = cmds[i];
            if (current.args !== undefined) {
              args = current.args.join(',');
            } else {
              args = '';
            }
            js += 'c.' + current.cmd + '(' + args + ');\n';
          }
          this.compiledGlyphs[character] = new Function('c', 'size', js);
        } else {
          this.compiledGlyphs[character] = function (c, size) {
            for (i = 0, len = cmds.length; i < len; i++) {
              current = cmds[i];
              if (current.cmd === 'scale') {
                current.args = [size, -size];
              }
              c[current.cmd].apply(c, current.args);
            }
          };
        }
      }
      return this.compiledGlyphs[character];
    }
  };
  return FontFaceObject;
}();
exports.FontFaceObject = FontFaceObject;
exports.FontLoader = FontLoader;

/***/ }),
/* 117 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasGraphics = undefined;

var _util = __w_pdfjs_require__(0);

var _pattern_helper = __w_pdfjs_require__(118);

var MIN_FONT_SIZE = 16;
var MAX_FONT_SIZE = 100;
var MAX_GROUP_SIZE = 4096;
var MIN_WIDTH_FACTOR = 0.65;
var COMPILE_TYPE3_GLYPHS = true;
var MAX_SIZE_TO_COMPILE = 1000;
var FULL_CHUNK_HEIGHT = 16;
var IsLittleEndianCached = {
  get value() {
    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
  }
};
function addContextCurrentTransform(ctx) {
  if (!ctx.mozCurrentTransform) {
    ctx._originalSave = ctx.save;
    ctx._originalRestore = ctx.restore;
    ctx._originalRotate = ctx.rotate;
    ctx._originalScale = ctx.scale;
    ctx._originalTranslate = ctx.translate;
    ctx._originalTransform = ctx.transform;
    ctx._originalSetTransform = ctx.setTransform;
    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
    ctx._transformStack = [];
    Object.defineProperty(ctx, 'mozCurrentTransform', {
      get: function getCurrentTransform() {
        return this._transformMatrix;
      }
    });
    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
      get: function getCurrentTransformInverse() {
        var m = this._transformMatrix;
        var a = m[0],
            b = m[1],
            c = m[2],
            d = m[3],
            e = m[4],
            f = m[5];
        var ad_bc = a * d - b * c;
        var bc_ad = b * c - a * d;
        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
      }
    });
    ctx.save = function ctxSave() {
      var old = this._transformMatrix;
      this._transformStack.push(old);
      this._transformMatrix = old.slice(0, 6);
      this._originalSave();
    };
    ctx.restore = function ctxRestore() {
      var prev = this._transformStack.pop();
      if (prev) {
        this._transformMatrix = prev;
        this._originalRestore();
      }
    };
    ctx.translate = function ctxTranslate(x, y) {
      var m = this._transformMatrix;
      m[4] = m[0] * x + m[2] * y + m[4];
      m[5] = m[1] * x + m[3] * y + m[5];
      this._originalTranslate(x, y);
    };
    ctx.scale = function ctxScale(x, y) {
      var m = this._transformMatrix;
      m[0] = m[0] * x;
      m[1] = m[1] * x;
      m[2] = m[2] * y;
      m[3] = m[3] * y;
      this._originalScale(x, y);
    };
    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
      ctx._originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
      this._transformMatrix = [a, b, c, d, e, f];
      ctx._originalSetTransform(a, b, c, d, e, f);
    };
    ctx.rotate = function ctxRotate(angle) {
      var cosValue = Math.cos(angle);
      var sinValue = Math.sin(angle);
      var m = this._transformMatrix;
      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
      this._originalRotate(angle);
    };
  }
}
var CachedCanvases = function CachedCanvasesClosure() {
  function CachedCanvases(canvasFactory) {
    this.canvasFactory = canvasFactory;
    this.cache = Object.create(null);
  }
  CachedCanvases.prototype = {
    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
      var canvasEntry;
      if (this.cache[id] !== undefined) {
        canvasEntry = this.cache[id];
        this.canvasFactory.reset(canvasEntry, width, height);
        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
      } else {
        canvasEntry = this.canvasFactory.create(width, height);
        this.cache[id] = canvasEntry;
      }
      if (trackTransform) {
        addContextCurrentTransform(canvasEntry.context);
      }
      return canvasEntry;
    },
    clear: function clear() {
      for (var id in this.cache) {
        var canvasEntry = this.cache[id];
        this.canvasFactory.destroy(canvasEntry);
        delete this.cache[id];
      }
    }
  };
  return CachedCanvases;
}();
function compileType3Glyph(imgData) {
  var POINT_TO_PROCESS_LIMIT = 1000;
  var width = imgData.width,
      height = imgData.height;
  var i,
      j,
      j0,
      width1 = width + 1;
  var points = new Uint8Array(width1 * (height + 1));
  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
  var lineSize = width + 7 & ~7,
      data0 = imgData.data;
  var data = new Uint8Array(lineSize * height),
      pos = 0,
      ii;
  for (i = 0, ii = data0.length; i < ii; i++) {
    var mask = 128,
        elem = data0[i];
    while (mask > 0) {
      data[pos++] = elem & mask ? 0 : 255;
      mask >>= 1;
    }
  }
  var count = 0;
  pos = 0;
  if (data[pos] !== 0) {
    points[0] = 1;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j] = data[pos] ? 2 : 1;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j] = 2;
    ++count;
  }
  for (i = 1; i < height; i++) {
    pos = i * lineSize;
    j0 = i * width1;
    if (data[pos - lineSize] !== data[pos]) {
      points[j0] = data[pos] ? 1 : 8;
      ++count;
    }
    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
    for (j = 1; j < width; j++) {
      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
      if (POINT_TYPES[sum]) {
        points[j0 + j] = POINT_TYPES[sum];
        ++count;
      }
      pos++;
    }
    if (data[pos - lineSize] !== data[pos]) {
      points[j0 + j] = data[pos] ? 2 : 4;
      ++count;
    }
    if (count > POINT_TO_PROCESS_LIMIT) {
      return null;
    }
  }
  pos = lineSize * (height - 1);
  j0 = i * width1;
  if (data[pos] !== 0) {
    points[j0] = 8;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j0 + j] = data[pos] ? 4 : 8;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j0 + j] = 4;
    ++count;
  }
  if (count > POINT_TO_PROCESS_LIMIT) {
    return null;
  }
  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
  var outlines = [];
  for (i = 0; count && i <= height; i++) {
    var p = i * width1;
    var end = p + width;
    while (p < end && !points[p]) {
      p++;
    }
    if (p === end) {
      continue;
    }
    var coords = [p % width1, i];
    var type = points[p],
        p0 = p,
        pp;
    do {
      var step = steps[type];
      do {
        p += step;
      } while (!points[p]);
      pp = points[p];
      if (pp !== 5 && pp !== 10) {
        type = pp;
        points[p] = 0;
      } else {
        type = pp & 0x33 * type >> 4;
        points[p] &= type >> 2 | type << 2;
      }
      coords.push(p % width1);
      coords.push(p / width1 | 0);
      --count;
    } while (p0 !== p);
    outlines.push(coords);
    --i;
  }
  var drawOutline = function drawOutline(c) {
    c.save();
    c.scale(1 / width, -1 / height);
    c.translate(0, -height);
    c.beginPath();
    for (var i = 0, ii = outlines.length; i < ii; i++) {
      var o = outlines[i];
      c.moveTo(o[0], o[1]);
      for (var j = 2, jj = o.length; j < jj; j += 2) {
        c.lineTo(o[j], o[j + 1]);
      }
    }
    c.fill();
    c.beginPath();
    c.restore();
  };
  return drawOutline;
}
var CanvasExtraState = function CanvasExtraStateClosure() {
  function CanvasExtraState() {
    this.alphaIsShape = false;
    this.fontSize = 0;
    this.fontSizeScale = 1;
    this.textMatrix = _util.IDENTITY_MATRIX;
    this.textMatrixScale = 1;
    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
    this.leading = 0;
    this.x = 0;
    this.y = 0;
    this.lineX = 0;
    this.lineY = 0;
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.textHScale = 1;
    this.textRenderingMode = _util.TextRenderingMode.FILL;
    this.textRise = 0;
    this.fillColor = '#000000';
    this.strokeColor = '#000000';
    this.patternFill = false;
    this.fillAlpha = 1;
    this.strokeAlpha = 1;
    this.lineWidth = 1;
    this.activeSMask = null;
    this.resumeSMaskCtx = null;
  }
  CanvasExtraState.prototype = {
    clone: function CanvasExtraState_clone() {
      return Object.create(this);
    },
    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
      this.x = x;
      this.y = y;
    }
  };
  return CanvasExtraState;
}();
var CanvasGraphics = function CanvasGraphicsClosure() {
  var EXECUTION_TIME = 15;
  var EXECUTION_STEPS = 10;
  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, webGLContext, imageLayer) {
    this.ctx = canvasCtx;
    this.current = new CanvasExtraState();
    this.stateStack = [];
    this.pendingClip = null;
    this.pendingEOFill = false;
    this.res = null;
    this.xobjs = null;
    this.commonObjs = commonObjs;
    this.objs = objs;
    this.canvasFactory = canvasFactory;
    this.webGLContext = webGLContext;
    this.imageLayer = imageLayer;
    this.groupStack = [];
    this.processingType3 = null;
    this.baseTransform = null;
    this.baseTransformStack = [];
    this.groupLevel = 0;
    this.smaskStack = [];
    this.smaskCounter = 0;
    this.tempSMask = null;
    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
    if (canvasCtx) {
      addContextCurrentTransform(canvasCtx);
    }
    this.cachedGetSinglePixelWidth = null;
  }
  function putBinaryImageData(ctx, imgData) {
    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
      ctx.putImageData(imgData, 0, 0);
      return;
    }
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0,
        destPos;
    var src = imgData.data;
    var dest = chunkImgData.data;
    var i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
      var srcLength = src.byteLength;
      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
      var dest32DataLength = dest32.length;
      var fullSrcDiff = width + 7 >> 3;
      var white = 0xFFFFFFFF;
      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
      for (i = 0; i < totalChunks; i++) {
        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
        destPos = 0;
        for (j = 0; j < thisChunkHeight; j++) {
          var srcDiff = srcLength - srcPos;
          var k = 0;
          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
          var kEndUnrolled = kEnd & ~7;
          var mask = 0;
          var srcByte = 0;
          for (; k < kEndUnrolled; k += 8) {
            srcByte = src[srcPos++];
            dest32[destPos++] = srcByte & 128 ? white : black;
            dest32[destPos++] = srcByte & 64 ? white : black;
            dest32[destPos++] = srcByte & 32 ? white : black;
            dest32[destPos++] = srcByte & 16 ? white : black;
            dest32[destPos++] = srcByte & 8 ? white : black;
            dest32[destPos++] = srcByte & 4 ? white : black;
            dest32[destPos++] = srcByte & 2 ? white : black;
            dest32[destPos++] = srcByte & 1 ? white : black;
          }
          for (; k < kEnd; k++) {
            if (mask === 0) {
              srcByte = src[srcPos++];
              mask = 128;
            }
            dest32[destPos++] = srcByte & mask ? white : black;
            mask >>= 1;
          }
        }
        while (destPos < dest32DataLength) {
          dest32[destPos++] = 0;
        }
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
      j = 0;
      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
      for (i = 0; i < fullChunks; i++) {
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        srcPos += elemsInThisChunk;
        ctx.putImageData(chunkImgData, 0, j);
        j += FULL_CHUNK_HEIGHT;
      }
      if (i < totalChunks) {
        elemsInThisChunk = width * partialChunkHeight * 4;
        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
        ctx.putImageData(chunkImgData, 0, j);
      }
    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
      thisChunkHeight = FULL_CHUNK_HEIGHT;
      elemsInThisChunk = width * thisChunkHeight;
      for (i = 0; i < totalChunks; i++) {
        if (i >= fullChunks) {
          thisChunkHeight = partialChunkHeight;
          elemsInThisChunk = width * thisChunkHeight;
        }
        destPos = 0;
        for (j = elemsInThisChunk; j--;) {
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = src[srcPos++];
          dest[destPos++] = 255;
        }
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
      }
    } else {
      throw new Error('bad image kind: ' + imgData.kind);
    }
  }
  function putBinaryImageMask(ctx, imgData) {
    var height = imgData.height,
        width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0;
    var src = imgData.data;
    var dest = chunkImgData.data;
    for (var i = 0; i < totalChunks; i++) {
      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
      var destPos = 3;
      for (var j = 0; j < thisChunkHeight; j++) {
        var mask = 0;
        for (var k = 0; k < width; k++) {
          if (!mask) {
            var elem = src[srcPos++];
            mask = 128;
          }
          dest[destPos] = elem & mask ? 0 : 255;
          destPos += 4;
          mask >>= 1;
        }
      }
      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  }
  function copyCtxState(sourceCtx, destCtx) {
    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
    for (var i = 0, ii = properties.length; i < ii; i++) {
      var property = properties[i];
      if (sourceCtx[property] !== undefined) {
        destCtx[property] = sourceCtx[property];
      }
    }
    if (sourceCtx.setLineDash !== undefined) {
      destCtx.setLineDash(sourceCtx.getLineDash());
      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
  }
  function resetCtxToDefault(ctx) {
    ctx.strokeStyle = '#000000';
    ctx.fillStyle = '#000000';
    ctx.fillRule = 'nonzero';
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = 'butt';
    ctx.lineJoin = 'miter';
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = 'source-over';
    ctx.font = '10px sans-serif';
    if (ctx.setLineDash !== undefined) {
      ctx.setLineDash([]);
      ctx.lineDashOffset = 0;
    }
  }
  function composeSMaskBackdrop(bytes, r0, g0, b0) {
    var length = bytes.length;
    for (var i = 3; i < length; i += 4) {
      var alpha = bytes[i];
      if (alpha === 0) {
        bytes[i - 3] = r0;
        bytes[i - 2] = g0;
        bytes[i - 1] = b0;
      } else if (alpha < 255) {
        var alpha_ = 255 - alpha;
        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
      }
    }
  }
  function composeSMaskAlpha(maskData, layerData, transferMap) {
    var length = maskData.length;
    var scale = 1 / 255;
    for (var i = 3; i < length; i += 4) {
      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
      layerData[i] = layerData[i] * alpha * scale | 0;
    }
  }
  function composeSMaskLuminosity(maskData, layerData, transferMap) {
    var length = maskData.length;
    for (var i = 3; i < length; i += 4) {
      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
    }
  }
  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
    var hasBackdrop = !!backdrop;
    var r0 = hasBackdrop ? backdrop[0] : 0;
    var g0 = hasBackdrop ? backdrop[1] : 0;
    var b0 = hasBackdrop ? backdrop[2] : 0;
    var composeFn;
    if (subtype === 'Luminosity') {
      composeFn = composeSMaskLuminosity;
    } else {
      composeFn = composeSMaskAlpha;
    }
    var PIXELS_TO_PROCESS = 1048576;
    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
    for (var row = 0; row < height; row += chunkSize) {
      var chunkHeight = Math.min(chunkSize, height - row);
      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
      if (hasBackdrop) {
        composeSMaskBackdrop(maskData.data, r0, g0, b0);
      }
      composeFn(maskData.data, layerData.data, transferMap);
      maskCtx.putImageData(layerData, 0, row);
    }
  }
  function composeSMask(ctx, smask, layerCtx, webGLContext) {
    var mask = smask.canvas;
    var maskCtx = smask.context;
    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
    var backdrop = smask.backdrop || null;
    if (!smask.transferMap && webGLContext.isEnabled) {
      var composed = webGLContext.composeSMask({
        layer: layerCtx.canvas,
        mask: mask,
        properties: {
          subtype: smask.subtype,
          backdrop: backdrop
        }
      });
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
      return;
    }
    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
    ctx.drawImage(mask, 0, 0);
  }
  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
  var NORMAL_CLIP = {};
  var EO_CLIP = {};
  CanvasGraphics.prototype = {
    beginDrawing: function beginDrawing(_ref) {
      var transform = _ref.transform,
          viewport = _ref.viewport,
          transparency = _ref.transparency,
          _ref$background = _ref.background,
          background = _ref$background === undefined ? null : _ref$background;

      var width = this.ctx.canvas.width;
      var height = this.ctx.canvas.height;
      this.ctx.save();
      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
      this.ctx.fillRect(0, 0, width, height);
      this.ctx.restore();
      if (transparency) {
        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
        this.compositeCtx = this.ctx;
        this.transparentCanvas = transparentCanvas.canvas;
        this.ctx = transparentCanvas.context;
        this.ctx.save();
        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
      }
      this.ctx.save();
      resetCtxToDefault(this.ctx);
      if (transform) {
        this.ctx.transform.apply(this.ctx, transform);
      }
      this.ctx.transform.apply(this.ctx, viewport.transform);
      this.baseTransform = this.ctx.mozCurrentTransform.slice();
      if (this.imageLayer) {
        this.imageLayer.beginLayout();
      }
    },

    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
      var argsArray = operatorList.argsArray;
      var fnArray = operatorList.fnArray;
      var i = executionStartIdx || 0;
      var argsArrayLen = argsArray.length;
      if (argsArrayLen === i) {
        return i;
      }
      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
      var steps = 0;
      var commonObjs = this.commonObjs;
      var objs = this.objs;
      var fnId;
      while (true) {
        if (stepper !== undefined && i === stepper.nextBreakPoint) {
          stepper.breakIt(i, continueCallback);
          return i;
        }
        fnId = fnArray[i];
        if (fnId !== _util.OPS.dependency) {
          this[fnId].apply(this, argsArray[i]);
        } else {
          var deps = argsArray[i];
          for (var n = 0, nn = deps.length; n < nn; n++) {
            var depObjId = deps[n];
            var common = depObjId[0] === 'g' && depObjId[1] === '_';
            var objsPool = common ? commonObjs : objs;
            if (!objsPool.isResolved(depObjId)) {
              objsPool.get(depObjId, continueCallback);
              return i;
            }
          }
        }
        i++;
        if (i === argsArrayLen) {
          return i;
        }
        if (chunkOperations && ++steps > EXECUTION_STEPS) {
          if (Date.now() > endTime) {
            continueCallback();
            return i;
          }
          steps = 0;
        }
      }
    },
    endDrawing: function CanvasGraphics_endDrawing() {
      if (this.current.activeSMask !== null) {
        this.endSMaskGroup();
      }
      this.ctx.restore();
      if (this.transparentCanvas) {
        this.ctx = this.compositeCtx;
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.drawImage(this.transparentCanvas, 0, 0);
        this.ctx.restore();
        this.transparentCanvas = null;
      }
      this.cachedCanvases.clear();
      this.webGLContext.clear();
      if (this.imageLayer) {
        this.imageLayer.endLayout();
      }
    },
    setLineWidth: function CanvasGraphics_setLineWidth(width) {
      this.current.lineWidth = width;
      this.ctx.lineWidth = width;
    },
    setLineCap: function CanvasGraphics_setLineCap(style) {
      this.ctx.lineCap = LINE_CAP_STYLES[style];
    },
    setLineJoin: function CanvasGraphics_setLineJoin(style) {
      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
    },
    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
      this.ctx.miterLimit = limit;
    },
    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
      var ctx = this.ctx;
      if (ctx.setLineDash !== undefined) {
        ctx.setLineDash(dashArray);
        ctx.lineDashOffset = dashPhase;
      }
    },
    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
    setGState: function CanvasGraphics_setGState(states) {
      for (var i = 0, ii = states.length; i < ii; i++) {
        var state = states[i];
        var key = state[0];
        var value = state[1];
        switch (key) {
          case 'LW':
            this.setLineWidth(value);
            break;
          case 'LC':
            this.setLineCap(value);
            break;
          case 'LJ':
            this.setLineJoin(value);
            break;
          case 'ML':
            this.setMiterLimit(value);
            break;
          case 'D':
            this.setDash(value[0], value[1]);
            break;
          case 'RI':
            this.setRenderingIntent(value);
            break;
          case 'FL':
            this.setFlatness(value);
            break;
          case 'Font':
            this.setFont(value[0], value[1]);
            break;
          case 'CA':
            this.current.strokeAlpha = state[1];
            break;
          case 'ca':
            this.current.fillAlpha = state[1];
            this.ctx.globalAlpha = state[1];
            break;
          case 'BM':
            this.ctx.globalCompositeOperation = value;
            break;
          case 'SMask':
            if (this.current.activeSMask) {
              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
                this.suspendSMaskGroup();
              } else {
                this.endSMaskGroup();
              }
            }
            this.current.activeSMask = value ? this.tempSMask : null;
            if (this.current.activeSMask) {
              this.beginSMaskGroup();
            }
            this.tempSMask = null;
            break;
        }
      }
    },
    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
      var activeSMask = this.current.activeSMask;
      var drawnWidth = activeSMask.canvas.width;
      var drawnHeight = activeSMask.canvas.height;
      var cacheId = 'smaskGroupAt' + this.groupLevel;
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var currentCtx = this.ctx;
      var currentTransform = currentCtx.mozCurrentTransform;
      this.ctx.save();
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
      this.ctx.restore();
      this.ctx.save();
      copyCtxState(groupCtx, this.ctx);
      this.current.resumeSMaskCtx = groupCtx;
      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
      this.ctx.transform.apply(this.ctx, deltaTransform);
      groupCtx.save();
      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
      groupCtx.restore();
    },
    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.current.resumeSMaskCtx;
      var currentCtx = this.ctx;
      this.ctx = groupCtx;
      this.groupStack.push(currentCtx);
      this.groupLevel++;
    },
    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
      var groupCtx = this.ctx;
      this.groupLevel--;
      this.ctx = this.groupStack.pop();
      composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
      this.ctx.restore();
      copyCtxState(groupCtx, this.ctx);
      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
      this.ctx.transform.apply(this.ctx, deltaTransform);
    },
    save: function CanvasGraphics_save() {
      this.ctx.save();
      var old = this.current;
      this.stateStack.push(old);
      this.current = old.clone();
      this.current.resumeSMaskCtx = null;
    },
    restore: function CanvasGraphics_restore() {
      if (this.current.resumeSMaskCtx) {
        this.resumeSMaskGroup();
      }
      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
        this.endSMaskGroup();
      }
      if (this.stateStack.length !== 0) {
        this.current = this.stateStack.pop();
        this.ctx.restore();
        this.pendingClip = null;
        this.cachedGetSinglePixelWidth = null;
      }
    },
    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
      this.ctx.transform(a, b, c, d, e, f);
      this.cachedGetSinglePixelWidth = null;
    },
    constructPath: function CanvasGraphics_constructPath(ops, args) {
      var ctx = this.ctx;
      var current = this.current;
      var x = current.x,
          y = current.y;
      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
        switch (ops[i] | 0) {
          case _util.OPS.rectangle:
            x = args[j++];
            y = args[j++];
            var width = args[j++];
            var height = args[j++];
            if (width === 0) {
              width = this.getSinglePixelWidth();
            }
            if (height === 0) {
              height = this.getSinglePixelWidth();
            }
            var xw = x + width;
            var yh = y + height;
            this.ctx.moveTo(x, y);
            this.ctx.lineTo(xw, y);
            this.ctx.lineTo(xw, yh);
            this.ctx.lineTo(x, yh);
            this.ctx.lineTo(x, y);
            this.ctx.closePath();
            break;
          case _util.OPS.moveTo:
            x = args[j++];
            y = args[j++];
            ctx.moveTo(x, y);
            break;
          case _util.OPS.lineTo:
            x = args[j++];
            y = args[j++];
            ctx.lineTo(x, y);
            break;
          case _util.OPS.curveTo:
            x = args[j + 4];
            y = args[j + 5];
            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
            j += 6;
            break;
          case _util.OPS.curveTo2:
            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
            x = args[j + 2];
            y = args[j + 3];
            j += 4;
            break;
          case _util.OPS.curveTo3:
            x = args[j + 2];
            y = args[j + 3];
            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
            j += 4;
            break;
          case _util.OPS.closePath:
            ctx.closePath();
            break;
        }
      }
      current.setCurrentPoint(x, y);
    },
    closePath: function CanvasGraphics_closePath() {
      this.ctx.closePath();
    },
    stroke: function CanvasGraphics_stroke(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var strokeColor = this.current.strokeColor;
      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
      ctx.globalAlpha = this.current.strokeAlpha;
      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
        ctx.save();
        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
        ctx.stroke();
        ctx.restore();
      } else {
        ctx.stroke();
      }
      if (consumePath) {
        this.consumePath();
      }
      ctx.globalAlpha = this.current.fillAlpha;
    },
    closeStroke: function CanvasGraphics_closeStroke() {
      this.closePath();
      this.stroke();
    },
    fill: function CanvasGraphics_fill(consumePath) {
      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var needRestore = false;
      if (isPatternFill) {
        ctx.save();
        if (this.baseTransform) {
          ctx.setTransform.apply(ctx, this.baseTransform);
        }
        ctx.fillStyle = fillColor.getPattern(ctx, this);
        needRestore = true;
      }
      if (this.pendingEOFill) {
        ctx.fill('evenodd');
        this.pendingEOFill = false;
      } else {
        ctx.fill();
      }
      if (needRestore) {
        ctx.restore();
      }
      if (consumePath) {
        this.consumePath();
      }
    },
    eoFill: function CanvasGraphics_eoFill() {
      this.pendingEOFill = true;
      this.fill();
    },
    fillStroke: function CanvasGraphics_fillStroke() {
      this.fill(false);
      this.stroke(false);
      this.consumePath();
    },
    eoFillStroke: function CanvasGraphics_eoFillStroke() {
      this.pendingEOFill = true;
      this.fillStroke();
    },
    closeFillStroke: function CanvasGraphics_closeFillStroke() {
      this.closePath();
      this.fillStroke();
    },
    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
      this.pendingEOFill = true;
      this.closePath();
      this.fillStroke();
    },
    endPath: function CanvasGraphics_endPath() {
      this.consumePath();
    },
    clip: function CanvasGraphics_clip() {
      this.pendingClip = NORMAL_CLIP;
    },
    eoClip: function CanvasGraphics_eoClip() {
      this.pendingClip = EO_CLIP;
    },
    beginText: function CanvasGraphics_beginText() {
      this.current.textMatrix = _util.IDENTITY_MATRIX;
      this.current.textMatrixScale = 1;
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    endText: function CanvasGraphics_endText() {
      var paths = this.pendingTextPaths;
      var ctx = this.ctx;
      if (paths === undefined) {
        ctx.beginPath();
        return;
      }
      ctx.save();
      ctx.beginPath();
      for (var i = 0; i < paths.length; i++) {
        var path = paths[i];
        ctx.setTransform.apply(ctx, path.transform);
        ctx.translate(path.x, path.y);
        path.addToPath(ctx, path.fontSize);
      }
      ctx.restore();
      ctx.clip();
      ctx.beginPath();
      delete this.pendingTextPaths;
    },
    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
      this.current.charSpacing = spacing;
    },
    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
      this.current.wordSpacing = spacing;
    },
    setHScale: function CanvasGraphics_setHScale(scale) {
      this.current.textHScale = scale / 100;
    },
    setLeading: function CanvasGraphics_setLeading(leading) {
      this.current.leading = -leading;
    },
    setFont: function CanvasGraphics_setFont(fontRefName, size) {
      var fontObj = this.commonObjs.get(fontRefName);
      var current = this.current;
      if (!fontObj) {
        throw new Error('Can\'t find font for ' + fontRefName);
      }
      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
      }
      if (size < 0) {
        size = -size;
        current.fontDirection = -1;
      } else {
        current.fontDirection = 1;
      }
      this.current.font = fontObj;
      this.current.fontSize = size;
      if (fontObj.isType3Font) {
        return;
      }
      var name = fontObj.loadedName || 'sans-serif';
      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
      var italic = fontObj.italic ? 'italic' : 'normal';
      var typeface = '"' + name + '", ' + fontObj.fallbackName;
      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
      this.current.fontSizeScale = size / browserFontSize;
      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
      this.ctx.font = rule;
    },
    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
      this.current.textRenderingMode = mode;
    },
    setTextRise: function CanvasGraphics_setTextRise(rise) {
      this.current.textRise = rise;
    },
    moveText: function CanvasGraphics_moveText(x, y) {
      this.current.x = this.current.lineX += x;
      this.current.y = this.current.lineY += y;
    },
    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
      this.setLeading(-y);
      this.moveText(x, y);
    },
    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
      this.current.textMatrix = [a, b, c, d, e, f];
      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
      this.current.x = this.current.lineX = 0;
      this.current.y = this.current.lineY = 0;
    },
    nextLine: function CanvasGraphics_nextLine() {
      this.moveText(0, this.current.leading);
    },
    paintChar: function paintChar(character, x, y, patternTransform) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var textRenderingMode = current.textRenderingMode;
      var fontSize = current.fontSize / current.fontSizeScale;
      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
      var patternFill = current.patternFill && font.data;
      var addToPath;
      if (font.disableFontFace || isAddToPathSet || patternFill) {
        addToPath = font.getPathGenerator(this.commonObjs, character);
      }
      if (font.disableFontFace || patternFill) {
        ctx.save();
        ctx.translate(x, y);
        ctx.beginPath();
        addToPath(ctx, fontSize);
        if (patternTransform) {
          ctx.setTransform.apply(ctx, patternTransform);
        }
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fill();
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.stroke();
        }
        ctx.restore();
      } else {
        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.fillText(character, x, y);
        }
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          ctx.strokeText(character, x, y);
        }
      }
      if (isAddToPathSet) {
        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
        paths.push({
          transform: ctx.mozCurrentTransform,
          x: x,
          y: y,
          fontSize: fontSize,
          addToPath: addToPath
        });
      }
    },

    get isFontSubpixelAAEnabled() {
      var ctx = this.canvasFactory.create(10, 10).context;
      ctx.scale(1.5, 1);
      ctx.fillText('I', 0, 10);
      var data = ctx.getImageData(0, 0, 10, 10).data;
      var enabled = false;
      for (var i = 3; i < data.length; i += 4) {
        if (data[i] > 0 && data[i] < 255) {
          enabled = true;
          break;
        }
      }
      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
    },
    showText: function CanvasGraphics_showText(glyphs) {
      var current = this.current;
      var font = current.font;
      if (font.isType3Font) {
        return this.showType3Text(glyphs);
      }
      var fontSize = current.fontSize;
      if (fontSize === 0) {
        return;
      }
      var ctx = this.ctx;
      var fontSizeScale = current.fontSizeScale;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var fontDirection = current.fontDirection;
      var textHScale = current.textHScale * fontDirection;
      var glyphsLength = glyphs.length;
      var vertical = font.vertical;
      var spacingDir = vertical ? 1 : -1;
      var defaultVMetrics = font.defaultVMetrics;
      var widthAdvanceScale = fontSize * current.fontMatrix[0];
      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
      ctx.save();
      var patternTransform = void 0;
      if (current.patternFill) {
        ctx.save();
        var pattern = current.fillColor.getPattern(ctx, this);
        patternTransform = ctx.mozCurrentTransform;
        ctx.restore();
        ctx.fillStyle = pattern;
      }
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y + current.textRise);
      if (fontDirection > 0) {
        ctx.scale(textHScale, -1);
      } else {
        ctx.scale(textHScale, 1);
      }
      var lineWidth = current.lineWidth;
      var scale = current.textMatrixScale;
      if (scale === 0 || lineWidth === 0) {
        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
          this.cachedGetSinglePixelWidth = null;
          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
        }
      } else {
        lineWidth /= scale;
      }
      if (fontSizeScale !== 1.0) {
        ctx.scale(fontSizeScale, fontSizeScale);
        lineWidth /= fontSizeScale;
      }
      ctx.lineWidth = lineWidth;
      var x = 0,
          i;
      for (i = 0; i < glyphsLength; ++i) {
        var glyph = glyphs[i];
        if ((0, _util.isNum)(glyph)) {
          x += spacingDir * glyph * fontSize / 1000;
          continue;
        }
        var restoreNeeded = false;
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var character = glyph.fontChar;
        var accent = glyph.accent;
        var scaledX, scaledY, scaledAccentX, scaledAccentY;
        var width = glyph.width;
        if (vertical) {
          var vmetric, vx, vy;
          vmetric = glyph.vmetric || defaultVMetrics;
          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
          vx = -vx * widthAdvanceScale;
          vy = vmetric[2] * widthAdvanceScale;
          width = vmetric ? -vmetric[0] : width;
          scaledX = vx / fontSizeScale;
          scaledY = (x + vy) / fontSizeScale;
        } else {
          scaledX = x / fontSizeScale;
          scaledY = 0;
        }
        if (font.remeasure && width > 0) {
          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
            var characterScaleX = width / measuredWidth;
            restoreNeeded = true;
            ctx.save();
            ctx.scale(characterScaleX, 1);
            scaledX /= characterScaleX;
          } else if (width !== measuredWidth) {
            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
          }
        }
        if (glyph.isInFont || font.missingFile) {
          if (simpleFillText && !accent) {
            ctx.fillText(character, scaledX, scaledY);
          } else {
            this.paintChar(character, scaledX, scaledY, patternTransform);
            if (accent) {
              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
            }
          }
        }
        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
        x += charWidth;
        if (restoreNeeded) {
          ctx.restore();
        }
      }
      if (vertical) {
        current.y -= x * textHScale;
      } else {
        current.x += x * textHScale;
      }
      ctx.restore();
    },
    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
      var ctx = this.ctx;
      var current = this.current;
      var font = current.font;
      var fontSize = current.fontSize;
      var fontDirection = current.fontDirection;
      var spacingDir = font.vertical ? 1 : -1;
      var charSpacing = current.charSpacing;
      var wordSpacing = current.wordSpacing;
      var textHScale = current.textHScale * fontDirection;
      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
      var glyphsLength = glyphs.length;
      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
      var i, glyph, width, spacingLength;
      if (isTextInvisible || fontSize === 0) {
        return;
      }
      this.cachedGetSinglePixelWidth = null;
      ctx.save();
      ctx.transform.apply(ctx, current.textMatrix);
      ctx.translate(current.x, current.y);
      ctx.scale(textHScale, fontDirection);
      for (i = 0; i < glyphsLength; ++i) {
        glyph = glyphs[i];
        if ((0, _util.isNum)(glyph)) {
          spacingLength = spacingDir * glyph * fontSize / 1000;
          this.ctx.translate(spacingLength, 0);
          current.x += spacingLength * textHScale;
          continue;
        }
        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
        var operatorList = font.charProcOperatorList[glyph.operatorListId];
        if (!operatorList) {
          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
          continue;
        }
        this.processingType3 = glyph;
        this.save();
        ctx.scale(fontSize, fontSize);
        ctx.transform.apply(ctx, fontMatrix);
        this.executeOperatorList(operatorList);
        this.restore();
        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
        width = transformed[0] * fontSize + spacing;
        ctx.translate(width, 0);
        current.x += width * textHScale;
      }
      ctx.restore();
      this.processingType3 = null;
    },
    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
      this.ctx.rect(llx, lly, urx - llx, ury - lly);
      this.clip();
      this.endPath();
    },
    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
      var _this = this;

      var pattern;
      if (IR[0] === 'TilingPattern') {
        var color = IR[1];
        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
        var canvasGraphicsFactory = {
          createCanvasGraphics: function createCanvasGraphics(ctx) {
            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory, _this.webGLContext);
          }
        };
        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
      } else {
        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
      }
      return pattern;
    },
    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
      this.current.strokeColor = this.getColorN_Pattern(arguments);
    },
    setFillColorN: function CanvasGraphics_setFillColorN() {
      this.current.fillColor = this.getColorN_Pattern(arguments);
      this.current.patternFill = true;
    },
    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);
      this.ctx.strokeStyle = color;
      this.current.strokeColor = color;
    },
    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
      var color = _util.Util.makeCssRgb(r, g, b);
      this.ctx.fillStyle = color;
      this.current.fillColor = color;
      this.current.patternFill = false;
    },
    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
      var ctx = this.ctx;
      this.save();
      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
      ctx.fillStyle = pattern.getPattern(ctx, this, true);
      var inv = ctx.mozCurrentTransformInverse;
      if (inv) {
        var canvas = ctx.canvas;
        var width = canvas.width;
        var height = canvas.height;
        var bl = _util.Util.applyTransform([0, 0], inv);
        var br = _util.Util.applyTransform([0, height], inv);
        var ul = _util.Util.applyTransform([width, 0], inv);
        var ur = _util.Util.applyTransform([width, height], inv);
        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
      } else {
        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
      }
      this.restore();
    },
    beginInlineImage: function CanvasGraphics_beginInlineImage() {
      (0, _util.unreachable)('Should not call beginInlineImage');
    },
    beginImageData: function CanvasGraphics_beginImageData() {
      (0, _util.unreachable)('Should not call beginImageData');
    },
    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
      this.save();
      this.baseTransformStack.push(this.baseTransform);
      if (Array.isArray(matrix) && matrix.length === 6) {
        this.transform.apply(this, matrix);
      }
      this.baseTransform = this.ctx.mozCurrentTransform;
      if (Array.isArray(bbox) && bbox.length === 4) {
        var width = bbox[2] - bbox[0];
        var height = bbox[3] - bbox[1];
        this.ctx.rect(bbox[0], bbox[1], width, height);
        this.clip();
        this.endPath();
      }
    },
    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
      this.restore();
      this.baseTransform = this.baseTransformStack.pop();
    },
    beginGroup: function CanvasGraphics_beginGroup(group) {
      this.save();
      var currentCtx = this.ctx;
      if (!group.isolated) {
        (0, _util.info)('TODO: Support non-isolated groups.');
      }
      if (group.knockout) {
        (0, _util.warn)('Knockout groups not supported.');
      }
      var currentTransform = currentCtx.mozCurrentTransform;
      if (group.matrix) {
        currentCtx.transform.apply(currentCtx, group.matrix);
      }
      if (!group.bbox) {
        throw new Error('Bounding box is required.');
      }
      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
      var offsetX = Math.floor(bounds[0]);
      var offsetY = Math.floor(bounds[1]);
      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
      var scaleX = 1,
          scaleY = 1;
      if (drawnWidth > MAX_GROUP_SIZE) {
        scaleX = drawnWidth / MAX_GROUP_SIZE;
        drawnWidth = MAX_GROUP_SIZE;
      }
      if (drawnHeight > MAX_GROUP_SIZE) {
        scaleY = drawnHeight / MAX_GROUP_SIZE;
        drawnHeight = MAX_GROUP_SIZE;
      }
      var cacheId = 'groupAt' + this.groupLevel;
      if (group.smask) {
        cacheId += '_smask_' + this.smaskCounter++ % 2;
      }
      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
      var groupCtx = scratchCanvas.context;
      groupCtx.scale(1 / scaleX, 1 / scaleY);
      groupCtx.translate(-offsetX, -offsetY);
      groupCtx.transform.apply(groupCtx, currentTransform);
      if (group.smask) {
        this.smaskStack.push({
          canvas: scratchCanvas.canvas,
          context: groupCtx,
          offsetX: offsetX,
          offsetY: offsetY,
          scaleX: scaleX,
          scaleY: scaleY,
          subtype: group.smask.subtype,
          backdrop: group.smask.backdrop,
          transferMap: group.smask.transferMap || null,
          startTransformInverse: null
        });
      } else {
        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
        currentCtx.translate(offsetX, offsetY);
        currentCtx.scale(scaleX, scaleY);
      }
      copyCtxState(currentCtx, groupCtx);
      this.ctx = groupCtx;
      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
      this.groupStack.push(currentCtx);
      this.groupLevel++;
      this.current.activeSMask = null;
    },
    endGroup: function CanvasGraphics_endGroup(group) {
      this.groupLevel--;
      var groupCtx = this.ctx;
      this.ctx = this.groupStack.pop();
      if (this.ctx.imageSmoothingEnabled !== undefined) {
        this.ctx.imageSmoothingEnabled = false;
      } else {
        this.ctx.mozImageSmoothingEnabled = false;
      }
      if (group.smask) {
        this.tempSMask = this.smaskStack.pop();
      } else {
        this.ctx.drawImage(groupCtx.canvas, 0, 0);
      }
      this.restore();
    },
    beginAnnotations: function CanvasGraphics_beginAnnotations() {
      this.save();
      if (this.baseTransform) {
        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
      }
    },
    endAnnotations: function CanvasGraphics_endAnnotations() {
      this.restore();
    },
    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
      this.save();
      resetCtxToDefault(this.ctx);
      this.current = new CanvasExtraState();
      if (Array.isArray(rect) && rect.length === 4) {
        var width = rect[2] - rect[0];
        var height = rect[3] - rect[1];
        this.ctx.rect(rect[0], rect[1], width, height);
        this.clip();
        this.endPath();
      }
      this.transform.apply(this, transform);
      this.transform.apply(this, matrix);
    },
    endAnnotation: function CanvasGraphics_endAnnotation() {
      this.restore();
    },
    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
      var domImage = this.objs.get(objId);
      if (!domImage) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      this.save();
      var ctx = this.ctx;
      ctx.scale(1 / w, -1 / h);
      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
      if (this.imageLayer) {
        var currentTransform = ctx.mozCurrentTransformInverse;
        var position = this.getCanvasPosition(0, 0);
        this.imageLayer.appendImage({
          objId: objId,
          left: position[0],
          top: position[1],
          width: w / currentTransform[0],
          height: h / currentTransform[3]
        });
      }
      this.restore();
    },
    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
      var ctx = this.ctx;
      var width = img.width,
          height = img.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var glyph = this.processingType3;
      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
          glyph.compiled = compileType3Glyph({
            data: img.data,
            width: width,
            height: height
          });
        } else {
          glyph.compiled = null;
        }
      }
      if (glyph && glyph.compiled) {
        glyph.compiled(ctx);
        return;
      }
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, img);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      this.paintInlineImageXObject(maskCanvas.canvas);
    },
    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
      var width = imgData.width;
      var height = imgData.height;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
      var maskCtx = maskCanvas.context;
      maskCtx.save();
      putBinaryImageMask(maskCtx, imgData);
      maskCtx.globalCompositeOperation = 'source-in';
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      var ctx = this.ctx;
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        ctx.save();
        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
      var ctx = this.ctx;
      var fillColor = this.current.fillColor;
      var isPatternFill = this.current.patternFill;
      for (var i = 0, ii = images.length; i < ii; i++) {
        var image = images[i];
        var width = image.width,
            height = image.height;
        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
        var maskCtx = maskCanvas.context;
        maskCtx.save();
        putBinaryImageMask(maskCtx, image);
        maskCtx.globalCompositeOperation = 'source-in';
        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
        maskCtx.fillRect(0, 0, width, height);
        maskCtx.restore();
        ctx.save();
        ctx.transform.apply(ctx, image.transform);
        ctx.scale(1, -1);
        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
        ctx.restore();
      }
    },
    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
      var imgData = this.objs.get(objId);
      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      this.paintInlineImageXObject(imgData);
    },
    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
      var imgData = this.objs.get(objId);
      if (!imgData) {
        (0, _util.warn)('Dependent image isn\'t ready yet');
        return;
      }
      var width = imgData.width;
      var height = imgData.height;
      var map = [];
      for (var i = 0, ii = positions.length; i < ii; i += 2) {
        map.push({
          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
          x: 0,
          y: 0,
          w: width,
          h: height
        });
      }
      this.paintInlineImageXObjectGroup(imgData, map);
    },
    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
      var width = imgData.width;
      var height = imgData.height;
      var ctx = this.ctx;
      this.save();
      ctx.scale(1 / width, -1 / height);
      var currentTransform = ctx.mozCurrentTransformInverse;
      var a = currentTransform[0],
          b = currentTransform[1];
      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
      var c = currentTransform[2],
          d = currentTransform[3];
      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
      var imgToPaint, tmpCanvas;
      if (imgData instanceof HTMLElement || !imgData.data) {
        imgToPaint = imgData;
      } else {
        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
        var tmpCtx = tmpCanvas.context;
        putBinaryImageData(tmpCtx, imgData);
        imgToPaint = tmpCanvas.canvas;
      }
      var paintWidth = width,
          paintHeight = height;
      var tmpCanvasId = 'prescale1';
      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
        var newWidth = paintWidth,
            newHeight = paintHeight;
        if (widthScale > 2 && paintWidth > 1) {
          newWidth = Math.ceil(paintWidth / 2);
          widthScale /= paintWidth / newWidth;
        }
        if (heightScale > 2 && paintHeight > 1) {
          newHeight = Math.ceil(paintHeight / 2);
          heightScale /= paintHeight / newHeight;
        }
        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
        tmpCtx = tmpCanvas.context;
        tmpCtx.clearRect(0, 0, newWidth, newHeight);
        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
        imgToPaint = tmpCanvas.canvas;
        paintWidth = newWidth;
        paintHeight = newHeight;
        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
      }
      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
      if (this.imageLayer) {
        var position = this.getCanvasPosition(0, -height);
        this.imageLayer.appendImage({
          imgData: imgData,
          left: position[0],
          top: position[1],
          width: width / currentTransform[0],
          height: height / currentTransform[3]
        });
      }
      this.restore();
    },
    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
      var ctx = this.ctx;
      var w = imgData.width;
      var h = imgData.height;
      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
      var tmpCtx = tmpCanvas.context;
      putBinaryImageData(tmpCtx, imgData);
      for (var i = 0, ii = map.length; i < ii; i++) {
        var entry = map[i];
        ctx.save();
        ctx.transform.apply(ctx, entry.transform);
        ctx.scale(1, -1);
        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
        if (this.imageLayer) {
          var position = this.getCanvasPosition(entry.x, entry.y);
          this.imageLayer.appendImage({
            imgData: imgData,
            left: position[0],
            top: position[1],
            width: w,
            height: h
          });
        }
        ctx.restore();
      }
    },
    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
      this.ctx.fillRect(0, 0, 1, 1);
    },
    paintXObject: function CanvasGraphics_paintXObject() {
      (0, _util.warn)('Unsupported \'paintXObject\' command.');
    },
    markPoint: function CanvasGraphics_markPoint(tag) {},
    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
    beginCompat: function CanvasGraphics_beginCompat() {},
    endCompat: function CanvasGraphics_endCompat() {},
    consumePath: function CanvasGraphics_consumePath() {
      var ctx = this.ctx;
      if (this.pendingClip) {
        if (this.pendingClip === EO_CLIP) {
          ctx.clip('evenodd');
        } else {
          ctx.clip();
        }
        this.pendingClip = null;
      }
      ctx.beginPath();
    },
    getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
      if (this.cachedGetSinglePixelWidth === null) {
        this.ctx.save();
        var inverse = this.ctx.mozCurrentTransformInverse;
        this.ctx.restore();
        this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
      }
      return this.cachedGetSinglePixelWidth;
    },
    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
      var transform = this.ctx.mozCurrentTransform;
      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
    }
  };
  for (var op in _util.OPS) {
    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
  }
  return CanvasGraphics;
}();
exports.CanvasGraphics = CanvasGraphics;

/***/ }),
/* 118 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TilingPattern = exports.getShadingPatternFromIR = undefined;

var _util = __w_pdfjs_require__(0);

var ShadingIRs = {};
ShadingIRs.RadialAxial = {
  fromIR: function RadialAxial_fromIR(raw) {
    var type = raw[1];
    var colorStops = raw[2];
    var p0 = raw[3];
    var p1 = raw[4];
    var r0 = raw[5];
    var r1 = raw[6];
    return {
      type: 'Pattern',
      getPattern: function RadialAxial_getPattern(ctx) {
        var grad;
        if (type === 'axial') {
          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
        } else if (type === 'radial') {
          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
        }
        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
          var c = colorStops[i];
          grad.addColorStop(c[0], c[1]);
        }
        return grad;
      }
    };
  }
};
var createMeshCanvas = function createMeshCanvasClosure() {
  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    var coords = context.coords,
        colors = context.colors;
    var bytes = data.data,
        rowSize = data.width * 4;
    var tmp;
    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }
    if (coords[p2 + 1] > coords[p3 + 1]) {
      tmp = p2;
      p2 = p3;
      p3 = tmp;
      tmp = c2;
      c2 = c3;
      c3 = tmp;
    }
    if (coords[p1 + 1] > coords[p2 + 1]) {
      tmp = p1;
      p1 = p2;
      p2 = tmp;
      tmp = c1;
      c1 = c2;
      c2 = tmp;
    }
    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) {
      return;
    }
    var c1r = colors[c1],
        c1g = colors[c1 + 1],
        c1b = colors[c1 + 2];
    var c2r = colors[c2],
        c2g = colors[c2 + 1],
        c2b = colors[c2 + 2];
    var c3r = colors[c3],
        c3g = colors[c3 + 1],
        c3b = colors[c3 + 2];
    var minY = Math.round(y1),
        maxY = Math.round(y3);
    var xa, car, cag, cab;
    var xb, cbr, cbg, cbb;
    var k;
    for (var y = minY; y <= maxY; y++) {
      if (y < y2) {
        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
        xa = x1 - (x1 - x2) * k;
        car = c1r - (c1r - c2r) * k;
        cag = c1g - (c1g - c2g) * k;
        cab = c1b - (c1b - c2b) * k;
      } else {
        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
        xa = x2 - (x2 - x3) * k;
        car = c2r - (c2r - c3r) * k;
        cag = c2g - (c2g - c3g) * k;
        cab = c2b - (c2b - c3b) * k;
      }
      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
      xb = x1 - (x1 - x3) * k;
      cbr = c1r - (c1r - c3r) * k;
      cbg = c1g - (c1g - c3g) * k;
      cbb = c1b - (c1b - c3b) * k;
      var x1_ = Math.round(Math.min(xa, xb));
      var x2_ = Math.round(Math.max(xa, xb));
      var j = rowSize * y + x1_ * 4;
      for (var x = x1_; x <= x2_; x++) {
        k = (xa - x) / (xa - xb);
        k = k < 0 ? 0 : k > 1 ? 1 : k;
        bytes[j++] = car - (car - cbr) * k | 0;
        bytes[j++] = cag - (cag - cbg) * k | 0;
        bytes[j++] = cab - (cab - cbb) * k | 0;
        bytes[j++] = 255;
      }
    }
  }
  function drawFigure(data, figure, context) {
    var ps = figure.coords;
    var cs = figure.colors;
    var i, ii;
    switch (figure.type) {
      case 'lattice':
        var verticesPerRow = figure.verticesPerRow;
        var rows = Math.floor(ps.length / verticesPerRow) - 1;
        var cols = verticesPerRow - 1;
        for (i = 0; i < rows; i++) {
          var q = i * verticesPerRow;
          for (var j = 0; j < cols; j++, q++) {
            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
          }
        }
        break;
      case 'triangles':
        for (i = 0, ii = ps.length; i < ii; i += 3) {
          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
        }
        break;
      default:
        throw new Error('illegal figure');
    }
  }
  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases, webGLContext) {
    var EXPECTED_SCALE = 1.1;
    var MAX_PATTERN_SIZE = 3000;
    var BORDER_SIZE = 2;
    var offsetX = Math.floor(bounds[0]);
    var offsetY = Math.floor(bounds[1]);
    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    var scaleX = boundsWidth / width;
    var scaleY = boundsHeight / height;
    var context = {
      coords: coords,
      colors: colors,
      offsetX: -offsetX,
      offsetY: -offsetY,
      scaleX: 1 / scaleX,
      scaleY: 1 / scaleY
    };
    var paddedWidth = width + BORDER_SIZE * 2;
    var paddedHeight = height + BORDER_SIZE * 2;
    var canvas, tmpCanvas, i, ii;
    if (webGLContext.isEnabled) {
      canvas = webGLContext.drawFigures({
        width: width,
        height: height,
        backgroundColor: backgroundColor,
        figures: figures,
        context: context
      });
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    } else {
      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
      var tmpCtx = tmpCanvas.context;
      var data = tmpCtx.createImageData(width, height);
      if (backgroundColor) {
        var bytes = data.data;
        for (i = 0, ii = bytes.length; i < ii; i += 4) {
          bytes[i] = backgroundColor[0];
          bytes[i + 1] = backgroundColor[1];
          bytes[i + 2] = backgroundColor[2];
          bytes[i + 3] = 255;
        }
      }
      for (i = 0; i < figures.length; i++) {
        drawFigure(data, figures[i], context);
      }
      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
      canvas = tmpCanvas.canvas;
    }
    return {
      canvas: canvas,
      offsetX: offsetX - BORDER_SIZE * scaleX,
      offsetY: offsetY - BORDER_SIZE * scaleY,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }
  return createMeshCanvas;
}();
ShadingIRs.Mesh = {
  fromIR: function Mesh_fromIR(raw) {
    var coords = raw[2];
    var colors = raw[3];
    var figures = raw[4];
    var bounds = raw[5];
    var matrix = raw[6];
    var background = raw[8];
    return {
      type: 'Pattern',
      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
        var scale;
        if (shadingFill) {
          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
        } else {
          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
          if (matrix) {
            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
          }
        }
        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases, owner.webGLContext);
        if (!shadingFill) {
          ctx.setTransform.apply(ctx, owner.baseTransform);
          if (matrix) {
            ctx.transform.apply(ctx, matrix);
          }
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
      }
    };
  }
};
ShadingIRs.Dummy = {
  fromIR: function Dummy_fromIR() {
    return {
      type: 'Pattern',
      getPattern: function Dummy_fromIR_getPattern() {
        return 'hotpink';
      }
    };
  }
};
function getShadingPatternFromIR(raw) {
  var shadingIR = ShadingIRs[raw[0]];
  if (!shadingIR) {
    throw new Error('Unknown IR type: ' + raw[0]);
  }
  return shadingIR.fromIR(raw);
}
var TilingPattern = function TilingPatternClosure() {
  var PaintType = {
    COLORED: 1,
    UNCOLORED: 2
  };
  var MAX_PATTERN_SIZE = 3000;
  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
    this.operatorList = IR[2];
    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
    this.bbox = IR[4];
    this.xstep = IR[5];
    this.ystep = IR[6];
    this.paintType = IR[7];
    this.tilingType = IR[8];
    this.color = color;
    this.canvasGraphicsFactory = canvasGraphicsFactory;
    this.baseTransform = baseTransform;
    this.type = 'Pattern';
    this.ctx = ctx;
  }
  TilingPattern.prototype = {
    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
      var operatorList = this.operatorList;
      var bbox = this.bbox;
      var xstep = this.xstep;
      var ystep = this.ystep;
      var paintType = this.paintType;
      var tilingType = this.tilingType;
      var color = this.color;
      var canvasGraphicsFactory = this.canvasGraphicsFactory;
      (0, _util.info)('TilingType: ' + tilingType);
      var x0 = bbox[0],
          y0 = bbox[1],
          x1 = bbox[2],
          y1 = bbox[3];
      var topLeft = [x0, y0];
      var botRight = [x0 + xstep, y0 + ystep];
      var width = botRight[0] - topLeft[0];
      var height = botRight[1] - topLeft[1];
      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
      var tmpCtx = tmpCanvas.context;
      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
      graphics.groupLevel = owner.groupLevel;
      this.setFillAndStrokeStyleToContext(graphics, paintType, color);
      this.setScale(width, height, xstep, ystep);
      this.transformToScale(graphics);
      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
      graphics.transform.apply(graphics, tmpTranslate);
      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
      graphics.executeOperatorList(operatorList);
      return tmpCanvas.canvas;
    },
    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
      this.scale = [width / xstep, height / ystep];
    },
    transformToScale: function TilingPattern_transformToScale(graphics) {
      var scale = this.scale;
      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
      graphics.transform.apply(graphics, tmpScale);
    },
    scaleToContext: function TilingPattern_scaleToContext() {
      var scale = this.scale;
      this.ctx.scale(1 / scale[0], 1 / scale[1]);
    },
    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
      if (Array.isArray(bbox) && bbox.length === 4) {
        var bboxWidth = x1 - x0;
        var bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        graphics.clip();
        graphics.endPath();
      }
    },
    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
      var context = graphics.ctx,
          current = graphics.current;
      switch (paintType) {
        case PaintType.COLORED:
          var ctx = this.ctx;
          context.fillStyle = ctx.fillStyle;
          context.strokeStyle = ctx.strokeStyle;
          current.fillColor = ctx.fillStyle;
          current.strokeColor = ctx.strokeStyle;
          break;
        case PaintType.UNCOLORED:
          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
          context.fillStyle = cssColor;
          context.strokeStyle = cssColor;
          current.fillColor = cssColor;
          current.strokeColor = cssColor;
          break;
        default:
          throw new _util.FormatError('Unsupported paint type: ' + paintType);
      }
    },
    getPattern: function TilingPattern_getPattern(ctx, owner) {
      var temporaryPatternCanvas = this.createPatternCanvas(owner);
      ctx = this.ctx;
      ctx.setTransform.apply(ctx, this.baseTransform);
      ctx.transform.apply(ctx, this.matrix);
      this.scaleToContext();
      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
    }
  };
  return TilingPattern;
}();
exports.getShadingPatternFromIR = getShadingPatternFromIR;
exports.TilingPattern = TilingPattern;

/***/ }),
/* 119 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFDataTransportStream = undefined;

var _util = __w_pdfjs_require__(0);

var PDFDataTransportStream = function PDFDataTransportStreamClosure() {
  function PDFDataTransportStream(params, pdfDataRangeTransport) {
    var _this = this;

    (0, _util.assert)(pdfDataRangeTransport);
    this._queuedChunks = [];
    var initialData = params.initialData;
    if (initialData && initialData.length > 0) {
      var buffer = new Uint8Array(initialData).buffer;
      this._queuedChunks.push(buffer);
    }
    this._pdfDataRangeTransport = pdfDataRangeTransport;
    this._isRangeSupported = !params.disableRange;
    this._isStreamingSupported = !params.disableStream;
    this._contentLength = params.length;
    this._fullRequestReader = null;
    this._rangeReaders = [];
    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
      _this._onReceiveData({
        begin: begin,
        chunk: chunk
      });
    });
    this._pdfDataRangeTransport.addProgressListener(function (loaded) {
      _this._onProgress({ loaded: loaded });
    });
    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
      _this._onReceiveData({ chunk: chunk });
    });
    this._pdfDataRangeTransport.transportReady();
  }
  PDFDataTransportStream.prototype = {
    _onReceiveData: function PDFDataTransportStream_onReceiveData(args) {
      var buffer = new Uint8Array(args.chunk).buffer;
      if (args.begin === undefined) {
        if (this._fullRequestReader) {
          this._fullRequestReader._enqueue(buffer);
        } else {
          this._queuedChunks.push(buffer);
        }
      } else {
        var found = this._rangeReaders.some(function (rangeReader) {
          if (rangeReader._begin !== args.begin) {
            return false;
          }
          rangeReader._enqueue(buffer);
          return true;
        });
        (0, _util.assert)(found);
      }
    },
    _onProgress: function PDFDataTransportStream_onDataProgress(evt) {
      if (this._rangeReaders.length > 0) {
        var firstReader = this._rangeReaders[0];
        if (firstReader.onProgress) {
          firstReader.onProgress({ loaded: evt.loaded });
        }
      }
    },
    _removeRangeReader: function PDFDataTransportStream_removeRangeReader(reader) {
      var i = this._rangeReaders.indexOf(reader);
      if (i >= 0) {
        this._rangeReaders.splice(i, 1);
      }
    },
    getFullReader: function PDFDataTransportStream_getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      var queuedChunks = this._queuedChunks;
      this._queuedChunks = null;
      return new PDFDataTransportStreamReader(this, queuedChunks);
    },
    getRangeReader: function PDFDataTransportStream_getRangeReader(begin, end) {
      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
      this._pdfDataRangeTransport.requestDataRange(begin, end);
      this._rangeReaders.push(reader);
      return reader;
    },
    cancelAllRequests: function PDFDataTransportStream_cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }
      var readers = this._rangeReaders.slice(0);
      readers.forEach(function (rangeReader) {
        rangeReader.cancel(reason);
      });
      this._pdfDataRangeTransport.abort();
    }
  };
  function PDFDataTransportStreamReader(stream, queuedChunks) {
    this._stream = stream;
    this._done = false;
    this._filename = null;
    this._queuedChunks = queuedChunks || [];
    this._requests = [];
    this._headersReady = Promise.resolve();
    stream._fullRequestReader = this;
    this.onProgress = null;
  }
  PDFDataTransportStreamReader.prototype = {
    _enqueue: function PDFDataTransportStreamReader_enqueue(chunk) {
      if (this._done) {
        return;
      }
      if (this._requests.length > 0) {
        var requestCapability = this._requests.shift();
        requestCapability.resolve({
          value: chunk,
          done: false
        });
        return;
      }
      this._queuedChunks.push(chunk);
    },
    get headersReady() {
      return this._headersReady;
    },
    get filename() {
      return this._filename;
    },
    get isRangeSupported() {
      return this._stream._isRangeSupported;
    },
    get isStreamingSupported() {
      return this._stream._isStreamingSupported;
    },
    get contentLength() {
      return this._stream._contentLength;
    },
    read: function PDFDataTransportStreamReader_read() {
      if (this._queuedChunks.length > 0) {
        var chunk = this._queuedChunks.shift();
        return Promise.resolve({
          value: chunk,
          done: false
        });
      }
      if (this._done) {
        return Promise.resolve({
          value: undefined,
          done: true
        });
      }
      var requestCapability = (0, _util.createPromiseCapability)();
      this._requests.push(requestCapability);
      return requestCapability.promise;
    },
    cancel: function PDFDataTransportStreamReader_cancel(reason) {
      this._done = true;
      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });
      this._requests = [];
    }
  };
  function PDFDataTransportStreamRangeReader(stream, begin, end) {
    this._stream = stream;
    this._begin = begin;
    this._end = end;
    this._queuedChunk = null;
    this._requests = [];
    this._done = false;
    this.onProgress = null;
  }
  PDFDataTransportStreamRangeReader.prototype = {
    _enqueue: function PDFDataTransportStreamRangeReader_enqueue(chunk) {
      if (this._done) {
        return;
      }
      if (this._requests.length === 0) {
        this._queuedChunk = chunk;
      } else {
        var requestsCapability = this._requests.shift();
        requestsCapability.resolve({
          value: chunk,
          done: false
        });
        this._requests.forEach(function (requestCapability) {
          requestCapability.resolve({
            value: undefined,
            done: true
          });
        });
        this._requests = [];
      }
      this._done = true;
      this._stream._removeRangeReader(this);
    },
    get isStreamingSupported() {
      return false;
    },
    read: function PDFDataTransportStreamRangeReader_read() {
      if (this._queuedChunk) {
        var chunk = this._queuedChunk;
        this._queuedChunk = null;
        return Promise.resolve({
          value: chunk,
          done: false
        });
      }
      if (this._done) {
        return Promise.resolve({
          value: undefined,
          done: true
        });
      }
      var requestCapability = (0, _util.createPromiseCapability)();
      this._requests.push(requestCapability);
      return requestCapability.promise;
    },
    cancel: function PDFDataTransportStreamRangeReader_cancel(reason) {
      this._done = true;
      this._requests.forEach(function (requestCapability) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      });
      this._requests = [];
      this._stream._removeRangeReader(this);
    }
  };
  return PDFDataTransportStream;
}();
exports.PDFDataTransportStream = PDFDataTransportStream;

/***/ }),
/* 120 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebGLContext = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebGLContext = function () {
  function WebGLContext(_ref) {
    var _ref$enable = _ref.enable,
        enable = _ref$enable === undefined ? false : _ref$enable;

    _classCallCheck(this, WebGLContext);

    this._enabled = enable === true;
  }

  _createClass(WebGLContext, [{
    key: 'composeSMask',
    value: function composeSMask(_ref2) {
      var layer = _ref2.layer,
          mask = _ref2.mask,
          properties = _ref2.properties;

      return WebGLUtils.composeSMask(layer, mask, properties);
    }
  }, {
    key: 'drawFigures',
    value: function drawFigures(_ref3) {
      var width = _ref3.width,
          height = _ref3.height,
          backgroundColor = _ref3.backgroundColor,
          figures = _ref3.figures,
          context = _ref3.context;

      return WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
    }
  }, {
    key: 'clear',
    value: function clear() {
      WebGLUtils.cleanup();
    }
  }, {
    key: 'isEnabled',
    get: function get() {
      var enabled = this._enabled;
      if (enabled) {
        enabled = WebGLUtils.tryInitGL();
      }
      return (0, _util.shadow)(this, 'isEnabled', enabled);
    }
  }]);

  return WebGLContext;
}();

var WebGLUtils = function WebGLUtilsClosure() {
  function loadShader(gl, code, shaderType) {
    var shader = gl.createShader(shaderType);
    gl.shaderSource(shader, code);
    gl.compileShader(shader);
    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    if (!compiled) {
      var errorMsg = gl.getShaderInfoLog(shader);
      throw new Error('Error during shader compilation: ' + errorMsg);
    }
    return shader;
  }
  function createVertexShader(gl, code) {
    return loadShader(gl, code, gl.VERTEX_SHADER);
  }
  function createFragmentShader(gl, code) {
    return loadShader(gl, code, gl.FRAGMENT_SHADER);
  }
  function createProgram(gl, shaders) {
    var program = gl.createProgram();
    for (var i = 0, ii = shaders.length; i < ii; ++i) {
      gl.attachShader(program, shaders[i]);
    }
    gl.linkProgram(program);
    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
    if (!linked) {
      var errorMsg = gl.getProgramInfoLog(program);
      throw new Error('Error during program linking: ' + errorMsg);
    }
    return program;
  }
  function createTexture(gl, image, textureId) {
    gl.activeTexture(textureId);
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
    return texture;
  }
  var currentGL, currentCanvas;
  function generateGL() {
    if (currentGL) {
      return;
    }
    currentCanvas = document.createElement('canvas');
    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
  }
  var smaskVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec2 a_texCoord;                                    \
                                                                \
  uniform vec2 u_resolution;                                    \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_texCoord = a_texCoord;                                    \
  }                                                             ';
  var smaskFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  uniform vec4 u_backdrop;                                      \
  uniform int u_subtype;                                        \
  uniform sampler2D u_image;                                    \
  uniform sampler2D u_mask;                                     \
                                                                \
  varying vec2 v_texCoord;                                      \
                                                                \
  void main() {                                                 \
    vec4 imageColor = texture2D(u_image, v_texCoord);           \
    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
    if (u_backdrop.a > 0.0) {                                   \
      maskColor.rgb = maskColor.rgb * maskColor.a +             \
                      u_backdrop.rgb * (1.0 - maskColor.a);     \
    }                                                           \
    float lum;                                                  \
    if (u_subtype == 0) {                                       \
      lum = maskColor.a;                                        \
    } else {                                                    \
      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
            maskColor.b * 0.11;                                 \
    }                                                           \
    imageColor.a *= lum;                                        \
    imageColor.rgb *= imageColor.a;                             \
    gl_FragColor = imageColor;                                  \
  }                                                             ';
  var smaskCache = null;
  function initSmaskGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
    var texCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(texCoordLocation);
    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
    gl.uniform1i(texLayerLocation, 0);
    gl.uniform1i(texMaskLocation, 1);
    smaskCache = cache;
  }
  function composeSMask(layer, mask, properties) {
    var width = layer.width,
        height = layer.height;
    if (!smaskCache) {
      initSmaskGL();
    }
    var cache = smaskCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    if (properties.backdrop) {
      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
    } else {
      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
    }
    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
    var texture = createTexture(gl, layer, gl.TEXTURE0);
    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
    var buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    gl.clearColor(0, 0, 0, 0);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
    gl.flush();
    gl.deleteTexture(texture);
    gl.deleteTexture(maskTexture);
    gl.deleteBuffer(buffer);
    return canvas;
  }
  var figuresVertexShaderCode = '\
  attribute vec2 a_position;                                    \
  attribute vec3 a_color;                                       \
                                                                \
  uniform vec2 u_resolution;                                    \
  uniform vec2 u_scale;                                         \
  uniform vec2 u_offset;                                        \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    vec2 position = (a_position + u_offset) * u_scale;          \
    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
                                                                \
    v_color = vec4(a_color / 255.0, 1.0);                       \
  }                                                             ';
  var figuresFragmentShaderCode = '\
  precision mediump float;                                      \
                                                                \
  varying vec4 v_color;                                         \
                                                                \
  void main() {                                                 \
    gl_FragColor = v_color;                                     \
  }                                                             ';
  var figuresCache = null;
  function initFiguresGL() {
    var canvas, gl;
    generateGL();
    canvas = currentCanvas;
    currentCanvas = null;
    gl = currentGL;
    currentGL = null;
    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
    var program = createProgram(gl, [vertexShader, fragmentShader]);
    gl.useProgram(program);
    var cache = {};
    cache.gl = gl;
    cache.canvas = canvas;
    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
    figuresCache = cache;
  }
  function drawFigures(width, height, backgroundColor, figures, context) {
    if (!figuresCache) {
      initFiguresGL();
    }
    var cache = figuresCache,
        canvas = cache.canvas,
        gl = cache.gl;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    gl.uniform2f(cache.resolutionLocation, width, height);
    var count = 0;
    var i, ii, rows;
    for (i = 0, ii = figures.length; i < ii; i++) {
      switch (figures[i].type) {
        case 'lattice':
          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
          break;
        case 'triangles':
          count += figures[i].coords.length;
          break;
      }
    }
    var coords = new Float32Array(count * 2);
    var colors = new Uint8Array(count * 3);
    var coordsMap = context.coords,
        colorsMap = context.colors;
    var pIndex = 0,
        cIndex = 0;
    for (i = 0, ii = figures.length; i < ii; i++) {
      var figure = figures[i],
          ps = figure.coords,
          cs = figure.colors;
      switch (figure.type) {
        case 'lattice':
          var cols = figure.verticesPerRow;
          rows = ps.length / cols | 0;
          for (var row = 1; row < rows; row++) {
            var offset = row * cols + 1;
            for (var col = 1; col < cols; col++, offset++) {
              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
              coords[pIndex + 6] = coords[pIndex + 2];
              coords[pIndex + 7] = coords[pIndex + 3];
              coords[pIndex + 8] = coords[pIndex + 4];
              coords[pIndex + 9] = coords[pIndex + 5];
              coords[pIndex + 10] = coordsMap[ps[offset]];
              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
              colors[cIndex + 9] = colors[cIndex + 3];
              colors[cIndex + 10] = colors[cIndex + 4];
              colors[cIndex + 11] = colors[cIndex + 5];
              colors[cIndex + 12] = colors[cIndex + 6];
              colors[cIndex + 13] = colors[cIndex + 7];
              colors[cIndex + 14] = colors[cIndex + 8];
              colors[cIndex + 15] = colorsMap[cs[offset]];
              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
              pIndex += 12;
              cIndex += 18;
            }
          }
          break;
        case 'triangles':
          for (var j = 0, jj = ps.length; j < jj; j++) {
            coords[pIndex] = coordsMap[ps[j]];
            coords[pIndex + 1] = coordsMap[ps[j] + 1];
            colors[cIndex] = colorsMap[cs[j]];
            colors[cIndex + 1] = colorsMap[cs[j] + 1];
            colors[cIndex + 2] = colorsMap[cs[j] + 2];
            pIndex += 2;
            cIndex += 3;
          }
          break;
      }
    }
    if (backgroundColor) {
      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
    } else {
      gl.clearColor(0, 0, 0, 0);
    }
    gl.clear(gl.COLOR_BUFFER_BIT);
    var coordsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.positionLocation);
    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
    var colorsBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
    gl.enableVertexAttribArray(cache.colorLocation);
    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
    gl.drawArrays(gl.TRIANGLES, 0, count);
    gl.flush();
    gl.deleteBuffer(coordsBuffer);
    gl.deleteBuffer(colorsBuffer);
    return canvas;
  }
  return {
    tryInitGL: function tryInitGL() {
      try {
        generateGL();
        return !!currentGL;
      } catch (ex) {}
      return false;
    },

    composeSMask: composeSMask,
    drawFigures: drawFigures,
    cleanup: function cleanup() {
      if (smaskCache && smaskCache.canvas) {
        smaskCache.canvas.width = 0;
        smaskCache.canvas.height = 0;
      }
      if (figuresCache && figuresCache.canvas) {
        figuresCache.canvas.width = 0;
        figuresCache.canvas.height = 0;
      }
      smaskCache = null;
      figuresCache = null;
    }
  };
}();
exports.WebGLContext = WebGLContext;

/***/ }),
/* 121 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFNodeStream = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(0);

var _network_utils = __w_pdfjs_require__(39);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var fs = __webpack_require__(2497);
var http = __webpack_require__(2498);
var https = __webpack_require__(2499);
var url = __webpack_require__(459);

var fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;

var PDFNodeStream = function () {
  function PDFNodeStream(source) {
    _classCallCheck(this, PDFNodeStream);

    this.source = source;
    this.url = url.parse(source.url);
    this.isHttp = this.url.protocol === 'http:' || this.url.protocol === 'https:';
    this.isFsUrl = this.url.protocol === 'file:' || !this.url.host;
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequest = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFNodeStream, [{
    key: 'getFullReader',
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequest);
      this._fullRequest = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
      return this._fullRequest;
    }
  }, {
    key: 'getRangeReader',
    value: function getRangeReader(start, end) {
      var rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
      this._rangeRequestReaders.push(rangeReader);
      return rangeReader;
    }
  }, {
    key: 'cancelAllRequests',
    value: function cancelAllRequests(reason) {
      if (this._fullRequest) {
        this._fullRequest.cancel(reason);
      }
      var readers = this._rangeRequestReaders.slice(0);
      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }]);

  return PDFNodeStream;
}();

var BaseFullReader = function () {
  function BaseFullReader(stream) {
    _classCallCheck(this, BaseFullReader);

    this._url = stream.url;
    this._done = false;
    this._errored = false;
    this._reason = null;
    this.onProgress = null;
    var source = stream.source;
    this._contentLength = source.length;
    this._loaded = 0;
    this._filename = null;
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._readableStream = null;
    this._readCapability = (0, _util.createPromiseCapability)();
    this._headersCapability = (0, _util.createPromiseCapability)();
  }

  _createClass(BaseFullReader, [{
    key: 'read',
    value: function read() {
      var _this = this;

      return this._readCapability.promise.then(function () {
        if (_this._done) {
          return Promise.resolve({
            value: undefined,
            done: true
          });
        }
        if (_this._errored) {
          return Promise.reject(_this._reason);
        }
        var chunk = _this._readableStream.read();
        if (chunk === null) {
          _this._readCapability = (0, _util.createPromiseCapability)();
          return _this.read();
        }
        _this._loaded += chunk.length;
        if (_this.onProgress) {
          _this.onProgress({
            loaded: _this._loaded,
            total: _this._contentLength
          });
        }
        var buffer = new Uint8Array(chunk).buffer;
        return Promise.resolve({
          value: buffer,
          done: false
        });
      });
    }
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);
        return;
      }
      this._readableStream.destroy(reason);
    }
  }, {
    key: '_error',
    value: function _error(reason) {
      this._errored = true;
      this._reason = reason;
      this._readCapability.resolve();
    }
  }, {
    key: '_setReadableStream',
    value: function _setReadableStream(readableStream) {
      var _this2 = this;

      this._readableStream = readableStream;
      readableStream.on('readable', function () {
        _this2._readCapability.resolve();
      });
      readableStream.on('end', function () {
        readableStream.destroy();
        _this2._done = true;
        _this2._readCapability.resolve();
      });
      readableStream.on('error', function (reason) {
        _this2._error(reason);
      });
      if (!this._isStreamingSupported && this._isRangeSupported) {
        this._error(new _util.AbortException('streaming is disabled'));
      }
      if (this._errored) {
        this._readableStream.destroy(this._reason);
      }
    }
  }, {
    key: 'headersReady',
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: 'filename',
    get: function get() {
      return this._filename;
    }
  }, {
    key: 'contentLength',
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: 'isRangeSupported',
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return BaseFullReader;
}();

var BaseRangeReader = function () {
  function BaseRangeReader(stream) {
    _classCallCheck(this, BaseRangeReader);

    this._url = stream.url;
    this._done = false;
    this._errored = false;
    this._reason = null;
    this.onProgress = null;
    this._loaded = 0;
    this._readableStream = null;
    this._readCapability = (0, _util.createPromiseCapability)();
    var source = stream.source;
    this._isStreamingSupported = !source.disableStream;
  }

  _createClass(BaseRangeReader, [{
    key: 'read',
    value: function read() {
      var _this3 = this;

      return this._readCapability.promise.then(function () {
        if (_this3._done) {
          return Promise.resolve({
            value: undefined,
            done: true
          });
        }
        if (_this3._errored) {
          return Promise.reject(_this3._reason);
        }
        var chunk = _this3._readableStream.read();
        if (chunk === null) {
          _this3._readCapability = (0, _util.createPromiseCapability)();
          return _this3.read();
        }
        _this3._loaded += chunk.length;
        if (_this3.onProgress) {
          _this3.onProgress({ loaded: _this3._loaded });
        }
        var buffer = new Uint8Array(chunk).buffer;
        return Promise.resolve({
          value: buffer,
          done: false
        });
      });
    }
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (!this._readableStream) {
        this._error(reason);
        return;
      }
      this._readableStream.destroy(reason);
    }
  }, {
    key: '_error',
    value: function _error(reason) {
      this._errored = true;
      this._reason = reason;
      this._readCapability.resolve();
    }
  }, {
    key: '_setReadableStream',
    value: function _setReadableStream(readableStream) {
      var _this4 = this;

      this._readableStream = readableStream;
      readableStream.on('readable', function () {
        _this4._readCapability.resolve();
      });
      readableStream.on('end', function () {
        readableStream.destroy();
        _this4._done = true;
        _this4._readCapability.resolve();
      });
      readableStream.on('error', function (reason) {
        _this4._error(reason);
      });
      if (this._errored) {
        this._readableStream.destroy(this._reason);
      }
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return BaseRangeReader;
}();

function createRequestOptions(url, headers) {
  return {
    protocol: url.protocol,
    auth: url.auth,
    host: url.hostname,
    port: url.port,
    path: url.path,
    method: 'GET',
    headers: headers
  };
}

var PDFNodeStreamFullReader = function (_BaseFullReader) {
  _inherits(PDFNodeStreamFullReader, _BaseFullReader);

  function PDFNodeStreamFullReader(stream) {
    _classCallCheck(this, PDFNodeStreamFullReader);

    var _this5 = _possibleConstructorReturn(this, (PDFNodeStreamFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFullReader)).call(this, stream));

    var handleResponse = function handleResponse(response) {
      _this5._headersCapability.resolve();
      _this5._setReadableStream(response);
      var getResponseHeader = function getResponseHeader(name) {
        return _this5._readableStream.headers[name.toLowerCase()];
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: stream.isHttp,
        rangeChunkSize: _this5._rangeChunkSize,
        disableRange: _this5._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      if (allowRangeRequests) {
        _this5._isRangeSupported = true;
      }
      _this5._contentLength = suggestedLength;
      _this5._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
    };
    _this5._request = null;
    if (_this5._url.protocol === 'http:') {
      _this5._request = http.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
    } else {
      _this5._request = https.request(createRequestOptions(_this5._url, stream.httpHeaders), handleResponse);
    }
    _this5._request.on('error', function (reason) {
      _this5._errored = true;
      _this5._reason = reason;
      _this5._headersCapability.reject(reason);
    });
    _this5._request.end();
    return _this5;
  }

  return PDFNodeStreamFullReader;
}(BaseFullReader);

var PDFNodeStreamRangeReader = function (_BaseRangeReader) {
  _inherits(PDFNodeStreamRangeReader, _BaseRangeReader);

  function PDFNodeStreamRangeReader(stream, start, end) {
    _classCallCheck(this, PDFNodeStreamRangeReader);

    var _this6 = _possibleConstructorReturn(this, (PDFNodeStreamRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamRangeReader)).call(this, stream));

    _this6._httpHeaders = {};
    for (var property in stream.httpHeaders) {
      var value = stream.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      _this6._httpHeaders[property] = value;
    }
    _this6._httpHeaders['Range'] = 'bytes=' + start + '-' + (end - 1);
    _this6._request = null;
    if (_this6._url.protocol === 'http:') {
      _this6._request = http.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
        _this6._setReadableStream(response);
      });
    } else {
      _this6._request = https.request(createRequestOptions(_this6._url, _this6._httpHeaders), function (response) {
        _this6._setReadableStream(response);
      });
    }
    _this6._request.on('error', function (reason) {
      _this6._errored = true;
      _this6._reason = reason;
    });
    _this6._request.end();
    return _this6;
  }

  return PDFNodeStreamRangeReader;
}(BaseRangeReader);

var PDFNodeStreamFsFullReader = function (_BaseFullReader2) {
  _inherits(PDFNodeStreamFsFullReader, _BaseFullReader2);

  function PDFNodeStreamFsFullReader(stream) {
    _classCallCheck(this, PDFNodeStreamFsFullReader);

    var _this7 = _possibleConstructorReturn(this, (PDFNodeStreamFsFullReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsFullReader)).call(this, stream));

    var path = decodeURIComponent(_this7._url.path);
    if (fileUriRegex.test(_this7._url.href)) {
      path = path.replace(/^\//, '');
    }
    fs.lstat(path, function (error, stat) {
      if (error) {
        _this7._errored = true;
        _this7._reason = error;
        _this7._headersCapability.reject(error);
        return;
      }
      _this7._contentLength = stat.size;
      _this7._setReadableStream(fs.createReadStream(path));
      _this7._headersCapability.resolve();
    });
    return _this7;
  }

  return PDFNodeStreamFsFullReader;
}(BaseFullReader);

var PDFNodeStreamFsRangeReader = function (_BaseRangeReader2) {
  _inherits(PDFNodeStreamFsRangeReader, _BaseRangeReader2);

  function PDFNodeStreamFsRangeReader(stream, start, end) {
    _classCallCheck(this, PDFNodeStreamFsRangeReader);

    var _this8 = _possibleConstructorReturn(this, (PDFNodeStreamFsRangeReader.__proto__ || Object.getPrototypeOf(PDFNodeStreamFsRangeReader)).call(this, stream));

    var path = decodeURIComponent(_this8._url.path);
    if (fileUriRegex.test(_this8._url.href)) {
      path = path.replace(/^\//, '');
    }
    _this8._setReadableStream(fs.createReadStream(path, {
      start: start,
      end: end - 1
    }));
    return _this8;
  }

  return PDFNodeStreamFsRangeReader;
}(BaseRangeReader);

exports.PDFNodeStream = PDFNodeStream;

/***/ }),
/* 122 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function getFilenameFromContentDispositionHeader(contentDisposition) {
  var needsEncodingFixup = true;
  var tmp = /(?:^|;)\s*filename\*\s*=\s*([^;\s]+)/i.exec(contentDisposition);
  if (tmp) {
    tmp = tmp[1];
    var filename = rfc2616unquote(tmp);
    filename = unescape(filename);
    filename = rfc5987decode(filename);
    filename = rfc2047decode(filename);
    return fixupEncoding(filename);
  }
  tmp = rfc2231getparam(contentDisposition);
  if (tmp) {
    var _filename = rfc2047decode(tmp);
    return fixupEncoding(_filename);
  }
  tmp = /(?:^|;)\s*filename\s*=\s*([^;\s]+)/.exec(contentDisposition);
  if (tmp) {
    tmp = tmp[1];
    var _filename2 = rfc2616unquote(tmp);
    _filename2 = rfc2047decode(_filename2);
    return fixupEncoding(_filename2);
  }
  function textdecode(encoding, value) {
    if (encoding) {
      if (!/^[^\x00-\xFF]+$/.test(value)) {
        return value;
      }
      try {
        var decoder = new TextDecoder(encoding, { fatal: true });
        var bytes = new Array(value.length);
        for (var i = 0; i < value.length; ++i) {
          bytes[i] = value.charCodeAt(0);
        }
        value = decoder.decode(new Uint8Array(bytes));
        needsEncodingFixup = false;
      } catch (e) {
        if (/^utf-?8$/i.test(encoding)) {
          value = decodeURIComponent(escape(value));
          needsEncodingFixup = false;
        }
      }
    }
    return value;
  }
  function fixupEncoding(value) {
    if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
      return textdecode('utf-8', value);
    }
    return value;
  }
  function rfc2231getparam(contentDisposition) {
    var matches = [],
        match = void 0;
    var iter = /(?:^|;)\s*filename\*((?!0\d)\d+)(\*?)\s*=\s*([^;\s]+)/ig;
    while ((match = iter.exec(contentDisposition)) !== null) {
      var _match = match,
          _match2 = _slicedToArray(_match, 4),
          n = _match2[1],
          quot = _match2[2],
          part = _match2[3];

      n = parseInt(n, 10);
      if (n in matches) {
        if (n === 0) {
          break;
        }
        continue;
      }
      matches[n] = [quot, part];
    }
    var parts = [];
    for (var _n = 0; _n < matches.length; ++_n) {
      if (!(_n in matches)) {
        break;
      }

      var _matches$_n = _slicedToArray(matches[_n], 2),
          _quot = _matches$_n[0],
          _part = _matches$_n[1];

      _part = rfc2616unquote(_part);
      if (_quot) {
        _part = unescape(_part);
        if (_n === 0) {
          _part = rfc5987decode(_part);
        }
      }
      parts.push(_part);
    }
    return parts.join('');
  }
  function rfc2616unquote(value) {
    if (value.charAt(0) === '"') {
      var parts = value.slice(1).split('\\"');
      for (var i = 0; i < parts.length; ++i) {
        var quotindex = parts[i].indexOf('"');
        if (quotindex !== -1) {
          parts[i] = parts[i].slice(0, quotindex);
          parts.length = i + 1;
        }
        parts[i] = parts[i].replace(/\\(.)/g, '$1');
      }
      value = parts.join('"');
    }
    return value;
  }
  function rfc5987decode(extvalue) {
    var encodingend = extvalue.indexOf('\'');
    if (encodingend === -1) {
      return extvalue;
    }
    var encoding = extvalue.slice(0, encodingend);
    var langvalue = extvalue.slice(encodingend + 1);
    var value = langvalue.replace(/^[^']*'/, '');
    return textdecode(encoding, value);
  }
  function rfc2047decode(value) {
    if (value.slice(0, 2) !== '=?' || /[\x00-\x19\x80-\xff]/.test(value)) {
      return value;
    }
    return value.replace(/=\?([\w\-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (_, charset, encoding, text) {
      if (encoding === 'q' || encoding === 'Q') {
        text = text.replace(/_/g, ' ');
        text = text.replace(/=([0-9a-fA-F]{2})/g, function (_, hex) {
          return String.fromCharCode(parseInt(hex, 16));
        });
        return textdecode(charset, text);
      }
      try {
        return atob(text);
      } catch (e) {
        return text;
      }
    });
  }
  return '';
}
exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;

/***/ }),
/* 123 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFFetchStream = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __w_pdfjs_require__(0);

var _network_utils = __w_pdfjs_require__(39);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createFetchOptions(headers, withCredentials) {
  return {
    method: 'GET',
    headers: headers,
    mode: 'cors',
    credentials: withCredentials ? 'include' : 'same-origin',
    redirect: 'follow'
  };
}

var PDFFetchStream = function () {
  function PDFFetchStream(source) {
    _classCallCheck(this, PDFFetchStream);

    this.source = source;
    this.isHttp = /^https?:/i.test(source.url);
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }

  _createClass(PDFFetchStream, [{
    key: 'getFullReader',
    value: function getFullReader() {
      (0, _util.assert)(!this._fullRequestReader);
      this._fullRequestReader = new PDFFetchStreamReader(this);
      return this._fullRequestReader;
    }
  }, {
    key: 'getRangeReader',
    value: function getRangeReader(begin, end) {
      var reader = new PDFFetchStreamRangeReader(this, begin, end);
      this._rangeRequestReaders.push(reader);
      return reader;
    }
  }, {
    key: 'cancelAllRequests',
    value: function cancelAllRequests(reason) {
      if (this._fullRequestReader) {
        this._fullRequestReader.cancel(reason);
      }
      var readers = this._rangeRequestReaders.slice(0);
      readers.forEach(function (reader) {
        reader.cancel(reason);
      });
    }
  }]);

  return PDFFetchStream;
}();

var PDFFetchStreamReader = function () {
  function PDFFetchStreamReader(stream) {
    var _this = this;

    _classCallCheck(this, PDFFetchStreamReader);

    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    this._filename = null;
    var source = stream.source;
    this._withCredentials = source.withCredentials;
    this._contentLength = source.length;
    this._headersCapability = (0, _util.createPromiseCapability)();
    this._disableRange = source.disableRange;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._isRangeSupported = !source.disableRange;
    this._isStreamingSupported = !source.disableStream;
    this._headers = new Headers();
    for (var property in this._stream.httpHeaders) {
      var value = this._stream.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      this._headers.append(property, value);
    }
    var url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }
      _this._reader = response.body.getReader();
      _this._headersCapability.resolve();
      var getResponseHeader = function getResponseHeader(name) {
        return response.headers.get(name);
      };

      var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader: getResponseHeader,
        isHttp: _this._stream.isHttp,
        rangeChunkSize: _this._rangeChunkSize,
        disableRange: _this._disableRange
      }),
          allowRangeRequests = _validateRangeRequest.allowRangeRequests,
          suggestedLength = _validateRangeRequest.suggestedLength;

      _this._contentLength = suggestedLength;
      _this._isRangeSupported = allowRangeRequests;
      _this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
      if (!_this._isStreamingSupported && _this._isRangeSupported) {
        _this.cancel(new _util.AbortException('streaming is disabled'));
      }
    }).catch(this._headersCapability.reject);
    this.onProgress = null;
  }

  _createClass(PDFFetchStreamReader, [{
    key: 'read',
    value: function read() {
      var _this2 = this;

      return this._headersCapability.promise.then(function () {
        return _this2._reader.read().then(function (_ref) {
          var value = _ref.value,
              done = _ref.done;

          if (done) {
            return Promise.resolve({
              value: value,
              done: done
            });
          }
          _this2._loaded += value.byteLength;
          if (_this2.onProgress) {
            _this2.onProgress({
              loaded: _this2._loaded,
              total: _this2._contentLength
            });
          }
          var buffer = new Uint8Array(value).buffer;
          return Promise.resolve({
            value: buffer,
            done: false
          });
        });
      });
    }
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (this._reader) {
        this._reader.cancel(reason);
      }
    }
  }, {
    key: 'headersReady',
    get: function get() {
      return this._headersCapability.promise;
    }
  }, {
    key: 'filename',
    get: function get() {
      return this._filename;
    }
  }, {
    key: 'contentLength',
    get: function get() {
      return this._contentLength;
    }
  }, {
    key: 'isRangeSupported',
    get: function get() {
      return this._isRangeSupported;
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return PDFFetchStreamReader;
}();

var PDFFetchStreamRangeReader = function () {
  function PDFFetchStreamRangeReader(stream, begin, end) {
    var _this3 = this;

    _classCallCheck(this, PDFFetchStreamRangeReader);

    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    var source = stream.source;
    this._withCredentials = source.withCredentials;
    this._readCapability = (0, _util.createPromiseCapability)();
    this._isStreamingSupported = !source.disableStream;
    this._headers = new Headers();
    for (var property in this._stream.httpHeaders) {
      var value = this._stream.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      this._headers.append(property, value);
    }
    var rangeStr = begin + '-' + (end - 1);
    this._headers.append('Range', 'bytes=' + rangeStr);
    var url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials)).then(function (response) {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }
      _this3._readCapability.resolve();
      _this3._reader = response.body.getReader();
    });
    this.onProgress = null;
  }

  _createClass(PDFFetchStreamRangeReader, [{
    key: 'read',
    value: function read() {
      var _this4 = this;

      return this._readCapability.promise.then(function () {
        return _this4._reader.read().then(function (_ref2) {
          var value = _ref2.value,
              done = _ref2.done;

          if (done) {
            return Promise.resolve({
              value: value,
              done: done
            });
          }
          _this4._loaded += value.byteLength;
          if (_this4.onProgress) {
            _this4.onProgress({ loaded: _this4._loaded });
          }
          var buffer = new Uint8Array(value).buffer;
          return Promise.resolve({
            value: buffer,
            done: false
          });
        });
      });
    }
  }, {
    key: 'cancel',
    value: function cancel(reason) {
      if (this._reader) {
        this._reader.cancel(reason);
      }
    }
  }, {
    key: 'isStreamingSupported',
    get: function get() {
      return this._isStreamingSupported;
    }
  }]);

  return PDFFetchStreamRangeReader;
}();

exports.PDFFetchStream = PDFFetchStream;

/***/ }),
/* 124 */
/***/ (function(module, exports, __w_pdfjs_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkManager = exports.PDFNetworkStream = undefined;

var _util = __w_pdfjs_require__(0);

var _network_utils = __w_pdfjs_require__(39);

var _global_scope = __w_pdfjs_require__(14);

var _global_scope2 = _interopRequireDefault(_global_scope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
var OK_RESPONSE = 200;
var PARTIAL_CONTENT_RESPONSE = 206;
function NetworkManager(url, args) {
  this.url = url;
  args = args || {};
  this.isHttp = /^https?:/i.test(url);
  this.httpHeaders = this.isHttp && args.httpHeaders || {};
  this.withCredentials = args.withCredentials || false;
  this.getXhr = args.getXhr || function NetworkManager_getXhr() {
    return new XMLHttpRequest();
  };
  this.currXhrId = 0;
  this.pendingRequests = Object.create(null);
  this.loadedRequests = Object.create(null);
}
function getArrayBuffer(xhr) {
  var data = xhr.response;
  if (typeof data !== 'string') {
    return data;
  }
  var array = (0, _util.stringToBytes)(data);
  return array.buffer;
}
var supportsMozChunked = function supportsMozChunkedClosure() {
  try {
    var x = new XMLHttpRequest();
    x.open('GET', _global_scope2.default.location.href);
    x.responseType = 'moz-chunked-arraybuffer';
    return x.responseType === 'moz-chunked-arraybuffer';
  } catch (e) {
    return false;
  }
}();
NetworkManager.prototype = {
  requestRange: function NetworkManager_requestRange(begin, end, listeners) {
    var args = {
      begin: begin,
      end: end
    };
    for (var prop in listeners) {
      args[prop] = listeners[prop];
    }
    return this.request(args);
  },
  requestFull: function NetworkManager_requestFull(listeners) {
    return this.request(listeners);
  },
  request: function NetworkManager_request(args) {
    var xhr = this.getXhr();
    var xhrId = this.currXhrId++;
    var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
    xhr.open('GET', this.url);
    xhr.withCredentials = this.withCredentials;
    for (var property in this.httpHeaders) {
      var value = this.httpHeaders[property];
      if (typeof value === 'undefined') {
        continue;
      }
      xhr.setRequestHeader(property, value);
    }
    if (this.isHttp && 'begin' in args && 'end' in args) {
      var rangeStr = args.begin + '-' + (args.end - 1);
      xhr.setRequestHeader('Range', 'bytes=' + rangeStr);
      pendingRequest.expectedStatus = 206;
    } else {
      pendingRequest.expectedStatus = 200;
    }
    var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
    if (useMozChunkedLoading) {
      xhr.responseType = 'moz-chunked-arraybuffer';
      pendingRequest.onProgressiveData = args.onProgressiveData;
      pendingRequest.mozChunked = true;
    } else {
      xhr.responseType = 'arraybuffer';
    }
    if (args.onError) {
      xhr.onerror = function (evt) {
        args.onError(xhr.status);
      };
    }
    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
    xhr.onprogress = this.onProgress.bind(this, xhrId);
    pendingRequest.onHeadersReceived = args.onHeadersReceived;
    pendingRequest.onDone = args.onDone;
    pendingRequest.onError = args.onError;
    pendingRequest.onProgress = args.onProgress;
    xhr.send(null);
    return xhrId;
  },
  onProgress: function NetworkManager_onProgress(xhrId, evt) {
    var pendingRequest = this.pendingRequests[xhrId];
    if (!pendingRequest) {
      return;
    }
    if (pendingRequest.mozChunked) {
      var chunk = getArrayBuffer(pendingRequest.xhr);
      pendingRequest.onProgressiveData(chunk);
    }
    var onProgress = pendingRequest.onProgress;
    if (onProgress) {
      onProgress(evt);
    }
  },
  onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
    var pendingRequest = this.pendingRequests[xhrId];
    if (!pendingRequest) {
      return;
    }
    var xhr = pendingRequest.xhr;
    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
      pendingRequest.onHeadersReceived();
      delete pendingRequest.onHeadersReceived;
    }
    if (xhr.readyState !== 4) {
      return;
    }
    if (!(xhrId in this.pendingRequests)) {
      return;
    }
    delete this.pendingRequests[xhrId];
    if (xhr.status === 0 && this.isHttp) {
      if (pendingRequest.onError) {
        pendingRequest.onError(xhr.status);
      }
      return;
    }
    var xhrStatus = xhr.status || OK_RESPONSE;
    var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
      if (pendingRequest.onError) {
        pendingRequest.onError(xhr.status);
      }
      return;
    }
    this.loadedRequests[xhrId] = true;
    var chunk = getArrayBuffer(xhr);
    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
      var rangeHeader = xhr.getResponseHeader('Content-Range');
      var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
      var begin = parseInt(matches[1], 10);
      pendingRequest.onDone({
        begin: begin,
        chunk: chunk
      });
    } else if (pendingRequest.onProgressiveData) {
      pendingRequest.onDone(null);
    } else if (chunk) {
      pendingRequest.onDone({
        begin: 0,
        chunk: chunk
      });
    } else if (pendingRequest.onError) {
      pendingRequest.onError(xhr.status);
    }
  },
  hasPendingRequests: function NetworkManager_hasPendingRequests() {
    for (var xhrId in this.pendingRequests) {
      return true;
    }
    return false;
  },
  getRequestXhr: function NetworkManager_getXhr(xhrId) {
    return this.pendingRequests[xhrId].xhr;
  },
  isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
    return !!this.pendingRequests[xhrId].onProgressiveData;
  },
  isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
    return xhrId in this.pendingRequests;
  },
  isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
    return xhrId in this.loadedRequests;
  },
  abortAllRequests: function NetworkManager_abortAllRequests() {
    for (var xhrId in this.pendingRequests) {
      this.abortRequest(xhrId | 0);
    }
  },
  abortRequest: function NetworkManager_abortRequest(xhrId) {
    var xhr = this.pendingRequests[xhrId].xhr;
    delete this.pendingRequests[xhrId];
    xhr.abort();
  }
};
function PDFNetworkStream(source) {
  this._source = source;
  this._manager = new NetworkManager(source.url, {
    httpHeaders: source.httpHeaders,
    withCredentials: source.withCredentials
  });
  this._rangeChunkSize = source.rangeChunkSize;
  this._fullRequestReader = null;
  this._rangeRequestReaders = [];
}
PDFNetworkStream.prototype = {
  _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
    var i = this._rangeRequestReaders.indexOf(reader);
    if (i >= 0) {
      this._rangeRequestReaders.splice(i, 1);
    }
  },
  getFullReader: function PDFNetworkStream_getFullReader() {
    (0, _util.assert)(!this._fullRequestReader);
    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
    return this._fullRequestReader;
  },
  getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
    var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
    this._rangeRequestReaders.push(reader);
    return reader;
  },
  cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
    if (this._fullRequestReader) {
      this._fullRequestReader.cancel(reason);
    }
    var readers = this._rangeRequestReaders.slice(0);
    readers.forEach(function (reader) {
      reader.cancel(reason);
    });
  }
};
function PDFNetworkStreamFullRequestReader(manager, source) {
  this._manager = manager;
  var args = {
    onHeadersReceived: this._onHeadersReceived.bind(this),
    onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
    onDone: this._onDone.bind(this),
    onError: this._onError.bind(this),
    onProgress: this._onProgress.bind(this)
  };
  this._url = source.url;
  this._fullRequestId = manager.requestFull(args);
  this._headersReceivedCapability = (0, _util.createPromiseCapability)();
  this._disableRange = source.disableRange || false;
  this._contentLength = source.length;
  this._rangeChunkSize = source.rangeChunkSize;
  if (!this._rangeChunkSize && !this._disableRange) {
    this._disableRange = true;
  }
  this._isStreamingSupported = false;
  this._isRangeSupported = false;
  this._cachedChunks = [];
  this._requests = [];
  this._done = false;
  this._storedError = undefined;
  this._filename = null;
  this.onProgress = null;
}
PDFNetworkStreamFullRequestReader.prototype = {
  _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
    var fullRequestXhrId = this._fullRequestId;
    var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
    var getResponseHeader = function getResponseHeader(name) {
      return fullRequestXhr.getResponseHeader(name);
    };

    var _validateRangeRequest = (0, _network_utils.validateRangeRequestCapabilities)({
      getResponseHeader: getResponseHeader,
      isHttp: this._manager.isHttp,
      rangeChunkSize: this._rangeChunkSize,
      disableRange: this._disableRange
    }),
        allowRangeRequests = _validateRangeRequest.allowRangeRequests,
        suggestedLength = _validateRangeRequest.suggestedLength;

    this._contentLength = suggestedLength || this._contentLength;
    if (allowRangeRequests) {
      this._isRangeSupported = true;
    }
    this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
    var networkManager = this._manager;
    if (networkManager.isStreamingRequest(fullRequestXhrId)) {
      this._isStreamingSupported = true;
    } else if (this._isRangeSupported) {
      networkManager.abortRequest(fullRequestXhrId);
    }
    this._headersReceivedCapability.resolve();
  },
  _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
    if (this._requests.length > 0) {
      var requestCapability = this._requests.shift();
      requestCapability.resolve({
        value: chunk,
        done: false
      });
    } else {
      this._cachedChunks.push(chunk);
    }
  },
  _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
    if (args) {
      this._onProgressiveData(args.chunk);
    }
    this._done = true;
    if (this._cachedChunks.length > 0) {
      return;
    }
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
  },
  _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
    var url = this._url;
    var exception = (0, _network_utils.createResponseStatusError)(status, url);
    this._storedError = exception;
    this._headersReceivedCapability.reject(exception);
    this._requests.forEach(function (requestCapability) {
      requestCapability.reject(exception);
    });
    this._requests = [];
    this._cachedChunks = [];
  },
  _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
    if (this.onProgress) {
      this.onProgress({
        loaded: data.loaded,
        total: data.lengthComputable ? data.total : this._contentLength
      });
    }
  },
  get filename() {
    return this._filename;
  },
  get isRangeSupported() {
    return this._isRangeSupported;
  },
  get isStreamingSupported() {
    return this._isStreamingSupported;
  },
  get contentLength() {
    return this._contentLength;
  },
  get headersReady() {
    return this._headersReceivedCapability.promise;
  },
  read: function PDFNetworkStreamFullRequestReader_read() {
    if (this._storedError) {
      return Promise.reject(this._storedError);
    }
    if (this._cachedChunks.length > 0) {
      var chunk = this._cachedChunks.shift();
      return Promise.resolve({
        value: chunk,
        done: false
      });
    }
    if (this._done) {
      return Promise.resolve({
        value: undefined,
        done: true
      });
    }
    var requestCapability = (0, _util.createPromiseCapability)();
    this._requests.push(requestCapability);
    return requestCapability.promise;
  },
  cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
    this._done = true;
    this._headersReceivedCapability.reject(reason);
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    if (this._manager.isPendingRequest(this._fullRequestId)) {
      this._manager.abortRequest(this._fullRequestId);
    }
    this._fullRequestReader = null;
  }
};
function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
  this._manager = manager;
  var args = {
    onDone: this._onDone.bind(this),
    onProgress: this._onProgress.bind(this)
  };
  this._requestId = manager.requestRange(begin, end, args);
  this._requests = [];
  this._queuedChunk = null;
  this._done = false;
  this.onProgress = null;
  this.onClosed = null;
}
PDFNetworkStreamRangeRequestReader.prototype = {
  _close: function PDFNetworkStreamRangeRequestReader_close() {
    if (this.onClosed) {
      this.onClosed(this);
    }
  },
  _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
    var chunk = data.chunk;
    if (this._requests.length > 0) {
      var requestCapability = this._requests.shift();
      requestCapability.resolve({
        value: chunk,
        done: false
      });
    } else {
      this._queuedChunk = chunk;
    }
    this._done = true;
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    this._close();
  },
  _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
    if (!this.isStreamingSupported && this.onProgress) {
      this.onProgress({ loaded: evt.loaded });
    }
  },
  get isStreamingSupported() {
    return false;
  },
  read: function PDFNetworkStreamRangeRequestReader_read() {
    if (this._queuedChunk !== null) {
      var chunk = this._queuedChunk;
      this._queuedChunk = null;
      return Promise.resolve({
        value: chunk,
        done: false
      });
    }
    if (this._done) {
      return Promise.resolve({
        value: undefined,
        done: true
      });
    }
    var requestCapability = (0, _util.createPromiseCapability)();
    this._requests.push(requestCapability);
    return requestCapability.promise;
  },
  cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
    this._done = true;
    this._requests.forEach(function (requestCapability) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    });
    this._requests = [];
    if (this._manager.isPendingRequest(this._requestId)) {
      this._manager.abortRequest(this._requestId);
    }
    this._close();
  }
};
exports.PDFNetworkStream = PDFNetworkStream;
exports.NetworkManager = NetworkManager;

/***/ })
/******/ ]);
});
//# sourceMappingURL=pdf.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(66), __webpack_require__(76).Buffer))

/***/ }),
/* 2497 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2498 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2499 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.pdf-preview--nav--3zuM92b8 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\ndiv[class~=react-pdf__Page] {\n  margin: 5px 0;\n}\n\n/**\n.navArea {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: rgba(0,0,0,0.1);\n}\n*/\n\n.pdf-preview--navAreaLeft--19bFxngk {\n  margin-left: 15px;\n  background: rgba(0, 0, 0, .1);\n}\n\n.pdf-preview--navAreaRight--wy9X71Ta {\n  margin-right: 15px;\n  background: rgba(0, 0, 0, .1);\n}\n\n/**\n.navArea:hover {\n  background: rgba(0,0,0,0.1);\n}\n*/\n\n.pdf-preview--navCenter--33YXwImG {\n  margin-left: 3px;\n  margin-right: 3px;\n  background: rgba(0, 0, 0, .1);\n}\n\n.pdf-preview--navPage--297Kx3jI {\n  display: inline;\n  margin: 10px;\n  padding: 5px 5px;\n  border-radius: 5px;\n  background: rgba(0, 0, 0, .1);\n}\n\n.pdf-preview--navScale--2X45vr2T {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  padding: 0px 10px;\n  border-radius: 5px;\n}\n\n.pdf-preview--pdfView--3qKyJku2 {\n  overflow: scroll;\n  height: 80vh;\n}\n\n.pdf-preview--pdfDialog--2VPuhvqf {\n  width: 80vw;\n}\n\n.pdf-preview--docDialog--7Uhh6MYE {\n  width: 80vw;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/pdf-preview.css"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;CACjC;;AAED;EACE,cAAc;CACf;;AAED;;;;;;;;EAQE;;AAEF;EACE,kBAAkB;EAClB,8BAA8B;CAC/B;;AAED;EACE,mBAAmB;EACnB,8BAA8B;CAC/B;;AAED;;;;EAIE;;AAEF;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;CAC/B;;AAED;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;CAC/B;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,kBAAkB;EAClB,mBAAmB;CACpB;;AAED;EACE,iBAAiB;EACjB,aAAa;CACd;;AAED;EACE,YAAY;CACb;;AAED;EACE,YAAY;CACb","file":"pdf-preview.css","sourcesContent":["\n.nav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\ndiv[class~=react-pdf__Page] {\n  margin: 5px 0;\n}\n\n/**\n.navArea {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: rgba(0,0,0,0.1);\n}\n*/\n\n.navAreaLeft {\n  margin-left: 15px;\n  background: rgba(0, 0, 0, .1);\n}\n\n.navAreaRight {\n  margin-right: 15px;\n  background: rgba(0, 0, 0, .1);\n}\n\n/**\n.navArea:hover {\n  background: rgba(0,0,0,0.1);\n}\n*/\n\n.navCenter {\n  margin-left: 3px;\n  margin-right: 3px;\n  background: rgba(0, 0, 0, .1);\n}\n\n.navPage {\n  display: inline;\n  margin: 10px;\n  padding: 5px 5px;\n  border-radius: 5px;\n  background: rgba(0, 0, 0, .1);\n}\n\n.navScale {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  padding: 0px 10px;\n  border-radius: 5px;\n}\n\n.pdfView {\n  overflow: scroll;\n  height: 80vh;\n}\n\n.pdfDialog {\n  width: 80vw;\n}\n\n.docDialog {\n  width: 80vw;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"nav": "pdf-preview--nav--3zuM92b8",
	"navAreaLeft": "pdf-preview--navAreaLeft--19bFxngk",
	"navAreaRight": "pdf-preview--navAreaRight--wy9X71Ta",
	"navCenter": "pdf-preview--navCenter--33YXwImG",
	"navPage": "pdf-preview--navPage--297Kx3jI",
	"navScale": "pdf-preview--navScale--2X45vr2T",
	"pdfView": "pdf-preview--pdfView--3qKyJku2",
	"pdfDialog": "pdf-preview--pdfDialog--2VPuhvqf",
	"docDialog": "pdf-preview--docDialog--7Uhh6MYE"
};

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n\n.right-side-page-app-bar--baseDiv--ns5NYQnw {\n  overflow: auto;\n  height: 100%;\n  -webkit-transform: translate3d(0,0,0);\n          transform: translate3d(0,0,0);\n  will-change: scroll-position;\n  -webkit-overflow-scrolling: touch; \n}\n\n.right-side-page-app-bar--titleDiv--399xyZeL {\n  margin-right: auto;\n  white-space: nowrap;\n  overflow: hidden;\n  width: calc(100% - 140px);\n  margin-left: 16px;\n}\n\n.right-side-page-app-bar--appBar--1isWdOaY {\n  background: none;\n  color: black;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n\n.right-side-page-app-bar--rightIcon--3X2rjGP3 {\n  color: black!important;\n}\n\n.right-side-page-app-bar--leftIcon--3Bp9DQ4r {\n  color: black!important;\n  margin-right: 8px;\n  pointer-events: none;\n}\n\n.right-side-page-app-bar--subTitleDiv--3vj2o8eu {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.right-side-page-app-bar--subTitle--1T2_TNIO {\n  font-size: 90%;\n  color: #999;\n}\n\n.right-side-page-app-bar--horizontal--3xzNHuEn {\n  white-space: nowrap;\n}\n\n.right-side-page-app-bar--childrenDiv--39Bk4lnz {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin-top: 5px;\n  height: calc(100vh - 121px);\n}\n\n.right-side-page-app-bar--childrenScroll--17uZxlmD {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  overflow-y: scroll;\n  -webkit-transform: translate3d(0,0,0);\n          transform: translate3d(0,0,0);\n  will-change: scroll-position;\n  -webkit-overflow-scrolling: touch; \n  box-sizing: content-box!important;\n}\n\n.right-side-page-app-bar--absoluteFooter--2pW4JYGW {\n  position: absolute;\n  bottom: 10px; right: 0; left: 0;\n}\n\n.right-side-page-app-bar--avatar--oGld-3mh {\n  z-index: 3;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"0\" /><feOffset dx=\"3\" dy=\"1\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(255,255,255,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(2px 0px 0 rgb(255, 255, 255));\n          filter: drop-shadow(2px 0px 0 rgb(255, 255, 255))\n}\n\n.right-side-page-app-bar--avatar--oGld-3mh[class~=secondAvatar] {\n  margin-left: -34px;\n  z-index: 2;\n}\n\n.right-side-page-app-bar--avatar--oGld-3mh[class~=thirdAvatar] {\n  margin-left: -34px;\n  z-index: 1;\n}\n\n@media screen and (max-width: 768px) {\n  .right-side-page-app-bar--appBar--1isWdOaY {\n    min-height: 40px !important;\n    height: 40px !important;\n    padding: 0 8px !important;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .right-side-page-app-bar--appBar--1isWdOaY [class*=\"avatar\"] {\n    width: 30px !important;\n    height: 30px !important;\n    min-width: 30px !important;\n    min-height: 30px !important;\n    margin: 0 4px !important;\n    -webkit-transform: translateY(0px) !important;\n            transform: translateY(0px) !important;\n    overflow: hidden !important;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n    -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n            justify-content: center !important;\n  }\n\n\n  .right-side-page-app-bar--appBar--1isWdOaY [class*=\"leftIcon\"] {\n    width: 20px !important;\n    height: 20px !important;\n    min-width: 20px !important;\n    min-height: 20px !important;\n    margin: 0 4px 0 12px !important; /* 右マージンを増やす */\n    padding: 0 !important;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n    -webkit-transform: translateY(0px) !important;\n            transform: translateY(0px) !important;\n    position: relative !important;\n    left: 4px !important; /* さらに右に移動 */\n  }\n\n  .right-side-page-app-bar--appBar--1isWdOaY [class*=\"leftIcon\"] > div {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n  }\n}", "", {"version":3,"sources":["/./src/web/components/themes/right-side-page-app-bar.css"],"names":[],"mappings":";;AAEA;EACE,eAAe;EACf,aAAa;EACb,sCAAsC;UAC9B,8BAA8B;EACtC,6BAA6B;EAC7B,kCAAkC;CACnC;;AAED;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;CACnB;;AAED;EACE,iBAAiB;EACjB,aAAa;EACb,6GAA6G;CAC9G;;AAED;EACE,uBAAuB;CACxB;;AAED;EACE,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;CACtB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;CAChC;;AAED;EACE,eAAe;EACf,YAAY;CACb;;AAED;EACE,oBAAoB;CACrB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,gBAAgB;EAChB,4BAA4B;CAC7B;;AAED;EACE,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;EACrB,mBAAmB;EACnB,sCAAsC;UAC9B,8BAA8B;EACtC,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;CACnC;;AAED;EACE,mBAAmB;EACnB,aAAa,CAAC,SAAS,CAAC,QAAQ;CACjC;;AAED;EACE,WAAW;EACX,oYAAoY;EACpY,0DAA0D;UAClD,iDAAiD;CAC1D;;AAED;EACE,mBAAmB;EACnB,WAAW;CACZ;;AAED;EACE,mBAAmB;EACnB,WAAW;CACZ;;AAED;EACE;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,0BAA0B;IAC1B,qCAAqC;QACjC,kCAAkC;YAC9B,+BAA+B;IACvC,gCAAgC;IAChC,gCAAgC;IAChC,yBAAyB;GAC1B;;EAED;IACE,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,8CAA8C;YACtC,sCAAsC;IAC9C,4BAA4B;IAC5B,gCAAgC;IAChC,gCAAgC;IAChC,yBAAyB;IACzB,qCAAqC;QACjC,kCAAkC;YAC9B,+BAA+B;IACvC,oCAAoC;QAChC,iCAAiC;YAC7B,mCAAmC;GAC5C;;;EAGD;IACE,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,gCAAgC,CAAC,eAAe;IAChD,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,yBAAyB;IACzB,qCAAqC;QACjC,kCAAkC;YAC9B,+BAA+B;IACvC,8CAA8C;YACtC,sCAAsC;IAC9C,8BAA8B;IAC9B,qBAAqB,CAAC,aAAa;GACpC;;EAED;IACE,gCAAgC;IAChC,gCAAgC;IAChC,yBAAyB;IACzB,qCAAqC;QACjC,kCAAkC;YAC9B,+BAA+B;GACxC;CACF","file":"right-side-page-app-bar.css","sourcesContent":["\n\n.baseDiv {\n  overflow: auto;\n  height: 100%;\n  -webkit-transform: translate3d(0,0,0);\n          transform: translate3d(0,0,0);\n  will-change: scroll-position;\n  -webkit-overflow-scrolling: touch; \n}\n\n.titleDiv {\n  margin-right: auto;\n  white-space: nowrap;\n  overflow: hidden;\n  width: calc(100% - 140px);\n  margin-left: 16px;\n}\n\n.appBar {\n  background: none;\n  color: black;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n\n.rightIcon {\n  color: black!important;\n}\n\n.leftIcon {\n  color: black!important;\n  margin-right: 8px;\n  pointer-events: none;\n}\n\n.subTitleDiv {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.subTitle {\n  font-size: 90%;\n  color: #999;\n}\n\n.horizontal {\n  white-space: nowrap;\n}\n\n.childrenDiv {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin-top: 5px;\n  height: calc(100vh - 121px);\n}\n\n.childrenScroll {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  overflow-y: scroll;\n  -webkit-transform: translate3d(0,0,0);\n          transform: translate3d(0,0,0);\n  will-change: scroll-position;\n  -webkit-overflow-scrolling: touch; \n  box-sizing: content-box!important;\n}\n\n.absoluteFooter {\n  position: absolute;\n  bottom: 10px; right: 0; left: 0;\n}\n\n.avatar {\n  z-index: 3;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"0\" /><feOffset dx=\"3\" dy=\"1\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(255,255,255,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(2px 0px 0 rgb(255, 255, 255));\n          filter: drop-shadow(2px 0px 0 rgb(255, 255, 255))\n}\n\n.avatar[class~=secondAvatar] {\n  margin-left: -34px;\n  z-index: 2;\n}\n\n.avatar[class~=thirdAvatar] {\n  margin-left: -34px;\n  z-index: 1;\n}\n\n@media screen and (max-width: 768px) {\n  .appBar {\n    min-height: 40px !important;\n    height: 40px !important;\n    padding: 0 8px !important;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .appBar [class*=\"avatar\"] {\n    width: 30px !important;\n    height: 30px !important;\n    min-width: 30px !important;\n    min-height: 30px !important;\n    margin: 0 4px !important;\n    -webkit-transform: translateY(0px) !important;\n            transform: translateY(0px) !important;\n    overflow: hidden !important;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n    -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n            justify-content: center !important;\n  }\n\n\n  .appBar [class*=\"leftIcon\"] {\n    width: 20px !important;\n    height: 20px !important;\n    min-width: 20px !important;\n    min-height: 20px !important;\n    margin: 0 4px 0 12px !important; /* 右マージンを増やす */\n    padding: 0 !important;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n    -webkit-transform: translateY(0px) !important;\n            transform: translateY(0px) !important;\n    position: relative !important;\n    left: 4px !important; /* さらに右に移動 */\n  }\n\n  .appBar [class*=\"leftIcon\"] > div {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n            align-items: center !important;\n  }\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"baseDiv": "right-side-page-app-bar--baseDiv--ns5NYQnw",
	"titleDiv": "right-side-page-app-bar--titleDiv--399xyZeL",
	"appBar": "right-side-page-app-bar--appBar--1isWdOaY",
	"rightIcon": "right-side-page-app-bar--rightIcon--3X2rjGP3",
	"leftIcon": "right-side-page-app-bar--leftIcon--3Bp9DQ4r",
	"subTitleDiv": "right-side-page-app-bar--subTitleDiv--3vj2o8eu",
	"subTitle": "right-side-page-app-bar--subTitle--1T2_TNIO",
	"horizontal": "right-side-page-app-bar--horizontal--3xzNHuEn",
	"childrenDiv": "right-side-page-app-bar--childrenDiv--39Bk4lnz",
	"childrenScroll": "right-side-page-app-bar--childrenScroll--17uZxlmD",
	"absoluteFooter": "right-side-page-app-bar--absoluteFooter--2pW4JYGW",
	"avatar": "right-side-page-app-bar--avatar--oGld-3mh"
};

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGroupTimelinePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _groupTimelinePage = __webpack_require__(2503);

var _groupTimelinePage2 = _interopRequireDefault(_groupTimelinePage);

var _layout = __webpack_require__(85);

var _button = __webpack_require__(8);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _infiniteScroller = __webpack_require__(75);

var _twoColumnLayout = __webpack_require__(205);

var _twoColumnLayout2 = _interopRequireDefault(_twoColumnLayout);

var _oneColumnLayout = __webpack_require__(386);

var _oneColumnLayout2 = _interopRequireDefault(_oneColumnLayout);

var _diary = __webpack_require__(171);

var _diary2 = _interopRequireDefault(_diary);

var _groupMemberIcons = __webpack_require__(1061);

var _groupMemberIcons2 = _interopRequireDefault(_groupMemberIcons);

var _rightSidebar = __webpack_require__(389);

var _rightSidebar2 = _interopRequireDefault(_rightSidebar);

var _diaryForm = __webpack_require__(2766);

var _diaryForm2 = _interopRequireDefault(_diaryForm);

var _unreadDiariesCard = __webpack_require__(2784);

var _unreadDiariesCard2 = _interopRequireDefault(_unreadDiariesCard);

var _guideMessage = __webpack_require__(533);

var _guideMessage2 = _interopRequireDefault(_guideMessage);

var _inviteMembersDialog = __webpack_require__(2786);

var _inviteMembersDialog2 = _interopRequireDefault(_inviteMembersDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-timeline-page.js

var GroupTimelinePage = function (_PureComponent) {
  _inherits(GroupTimelinePage, _PureComponent);

  function GroupTimelinePage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GroupTimelinePage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupTimelinePage.__proto__ || Object.getPrototypeOf(GroupTimelinePage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { already_display: false, responses: [], reviewTarget: undefined }, _this.loadMore = function () {
      return _this.props.fetchDiaries(_this.props);
    }, _this.loader = _react2.default.createElement(
      'div',
      { style: { width: '100%', textAlign: 'center' } },
      _react2.default.createElement(_progress_bar2.default, { type: 'circular', mode: 'indeterminate', multicolor: true })
    ), _this.onScrollTop = function () {
      return _this.refs.panel && (_reactDom2.default.findDOMNode(_this.refs.panel).scrollTop = 0);
    }, _this.onReplyScrollFrom = function (offset) {
      //COMMENT_FORM_HEIGHTはコメントフォームの高さ
      var COMMENT_FORM_HEIGHT = 222;
      //返信コメントへの返信の場合、コメントフォームまでスクロールする
      _this.refs.panel && (_reactDom2.default.findDOMNode(_this.refs.panel).scrollTop += offset + COMMENT_FORM_HEIGHT);
    }, _this.setReviewTarget = function (target) {
      return _this.setState({ reviewTarget: target });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GroupTimelinePage, [{
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps) {
      var _this2 = this;

      // 日報を投稿した際、うまくタイムラインに反映されない原因不明の不具合があるための対処
      if (this.props.diaries && nextProps.diaries && this.props.diaries.length != nextProps.diaries.length) setTimeout(function () {
        return _this2.setState({ udpate: Math.random() });
      }, 300);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.ws) {
        this.state.ws.close();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          diaries = _props.diaries,
          user = _props.user,
          group = _props.group,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          isRightSidebar = _props.isRightSidebar,
          hasMore = _props.hasMore,
          children = _props.children,
          params = _props.params,
          location = _props.location,
          fetchDiaries = _props.fetchDiaries,
          showUser = _props.showUser,
          openGroupMembersPanel = _props.openGroupMembersPanel,
          usersAdminUrl = _props.usersAdminUrl,
          productTour = _props.productTour,
          firstLogin = _props.firstLogin,
          likeConfig = _props.likeConfig,
          blockDiaries = _props.blockDiaries,
          blockUsers = _props.blockUsers;

      var parentTheme = isRightSidebar ? _twoColumnLayout2.default : _oneColumnLayout2.default;

      return _react2.default.createElement(
        _layout.Layout,
        { theme: parentTheme },
        _react2.default.createElement(
          _layout.Panel,
          { bodyScroll: true, theme: parentTheme, style: { left: 0 }, ref: 'panel' },
          group && _react2.default.createElement(_groupMemberIcons2.default, { group: group,
            user: user,
            users: group.members,
            showUser: showUser,
            openGroupMembersPanel: openGroupMembersPanel,
            usersAdminUrl: usersAdminUrl,
            productTour: productTour,
            firstLogin: firstLogin }),
          group && group.is_admin && _react2.default.createElement(_guideMessage2.default, { showMessage: firstLogin && (!productTour || productTour.openGroupMemberPanel != 'hide'),
            message: t('label:ここをクリックして招待してみよう'),
            style: { marginTop: '10px' } }),
          group && group.can_write && diaries && _react2.default.createElement(_diaryForm2.default, { chatGptReview: this.state.responses, clearGptReview: this.clearGptReview, sendChatGPT: this.sendMessage, reviewTarget: this.state.reviewTarget, setReviewTarget: this.setReviewTarget, onScrollTop: this.onScrollTop, group: group, diary: true }),
          group && group.can_write && diaries && _react2.default.createElement(_guideMessage2.default, { diaryGuidance: true,
            showMessage: firstLogin && (!productTour || productTour.submitDiary != 'hide'),
            message: t('label:ここをクリックして日報を投稿してみよう'),
            style: { marginTop: '5px' } }),
          !diaries && isFetching && _react2.default.createElement(_loading2.default, null),
          !isFetching && group && _react2.default.createElement(_unreadDiariesCard2.default, { group: group }),
          group && _react2.default.createElement(
            _infiniteScroller.InfiniteScroll,
            { pageStart: 0,
              initialLoad: false,
              hasMore: hasMore && !isFetchFailed,
              loadMore: this.loadMore,
              loader: diaries && this.loader,
              useWindow: false },
            diaries && diaries.map(function (diary) {
              return _react2.default.createElement(_diary2.default, { chatGptReview: _this3.state.responses, clearGptReview: _this3.clearGptReview, sendChatGPT: _this3.sendMessage, reviewTarget: _this3.state.reviewTarget,
                key: diary.diary_id, diary: diary, user: user, group: group, onReplyScrollFrom: _this3.onReplyScrollFrom, likeConfig: likeConfig, openSidePage: isRightSidebar, blockDiaries: blockDiaries, blockUsers: blockUsers, setReviewTarget: _this3.setReviewTarget });
            }) || []
          ),
          diaries && diaries.length == 0 && !hasMore && !isFetchFailed && _react2.default.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'center', paddingTop: '20px' } },
            t('label:投稿がありません')
          ),
          diaries && diaries.length > 0 && !hasMore && !isFetchFailed && _react2.default.createElement(
            'div',
            { style: { fontSize: '80%', padding: '0 20px', color: '#999' } },
            t('label:一番最後の投稿です')
          ),
          isFetchFailed && _react2.default.createElement(
            'div',
            { style: { padding: '20px' } },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '90%', marginBottom: '10px' } },
              t('error:読み込みに失敗しました')
            ),
            _react2.default.createElement(_button.Button, { raised: true,
              onClick: function onClick() {
                return fetchDiaries(_this3.props, true);
              },
              label: t('label:再読み込み'),
              style: { width: '100%' } })
          )
        ),
        isRightSidebar && _react2.default.createElement(
          _layout.Sidebar,
          { theme: _twoColumnLayout2.default, pinned: true, scrollY: true, width: 50 },
          _react2.default.createElement(
            _rightSidebar2.default,
            { user: user, group: group },
            children
          )
        ),
        null && user && user.account_admin && user.trial && user.is_alone && group && _react2.default.createElement(_inviteMembersDialog2.default, { group: group,
          usersAdminUrl: usersAdminUrl,
          already_display: this.state.already_display,
          onHide: function onHide() {
            return _this3.setState({ already_display: true });
          } })
      );
    }
  }]);

  return GroupTimelinePage;
}(_pureComponent2.default);

var RawGroupTimelinePage = exports.RawGroupTimelinePage = GroupTimelinePage;
exports.default = (0, _groupTimelinePage2.default)(GroupTimelinePage);

/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _context = __webpack_require__(39);

var _analytics = __webpack_require__(27);

var _store = __webpack_require__(18);

var _socketRsync = __webpack_require__(144);

var _socketRsync2 = _interopRequireDefault(_socketRsync);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _agentType = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var diaries = state.diaries.groups[ownProps.params.group_id];

  return {
    group: (0, _store.getArray)('group_id', state.groups.items, ownProps.params.group_id),
    user: state.user.current,
    isFetching: diaries && diaries.isFetching,
    isFetchFailed: diaries && diaries.isFetchFailed,
    hasMore: diaries && diaries.hasMore,
    diaries: diaries && diaries.items,
    isRightSidebar: (state.rightSidePage.name || ownProps.children) && true,
    isPhone: state.media.isPhone,
    firstLogin: state.user.firstLogin,
    productTour: state.productTour.state,
    access_token: state.sessions.access_token,
    likeConfig: state.likes.likeConfig,
    binding: true,
    blockDiaries: state.block.diaries,
    blockUsers: state.block.users
  };
};
// src/connects/group-timeline-page.js

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var redirect_url = '/v3/users/new?group_id=' + ownProps.params.group_id;
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    usersAdminUrl: _config2.default.baseUrl + 'v3/session/redirect?login=true&access_token=' + stateProps.access_token + '&redirect_to=' + encodeURIComponent(redirect_url),
    fetchDiaries: dispatchProps.fetchDiaries.bind(stateProps)
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  function _readDiary(props, diary) {
    var read = diary.user.user_id == props.user.user_id || diary.readers && (0, _find2.default)(diary.readers, function (reader) {
      return reader.user.user_id == props.user.user_id;
    });
    if (!read) {
      !props.emitSocket('mark_as_read', { diary_id: diary.diary_id }) && dispatch(_actions2.default.markDiaryRead(diary.diary_id));
    }
  }

  return {
    fetchDiaries: function fetchDiaries(props) {
      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this && this.binding) props = this;
      if (props.isFetching || props.isFetchFailed && !reset) return;
      var offset = reset ? 0 : props.diaries && props.diaries.length || 0;
      offset == 0 && dispatch(_actions2.default.fetchGroupUnreadCount(ownProps.params.group_id));
      dispatch(_actions2.default.fetchDiaries(ownProps.params.group_id, offset));
    },

    fetchGroup: function fetchGroup() {
      return dispatch(_actions2.default.fetchGroup(ownProps.params.group_id));
    },

    clearDiaries: function clearDiaries() {
      return dispatch(_actions2.default.clearDiaries(ownProps.params.group_id));
    },

    readDiary: _readDiary,
    _readDiary: _readDiary,

    showUser: function showUser(user) {
      return dispatch(_actions2.default.openRightSidePage('user_timeline', { group_id: ownProps.params.group_id, user_id: user.user_id, user: user }));
    },
    closeRightSidePage: function closeRightSidePage() {
      return dispatch(_actions2.default.closeRightSidePage(true));
    },

    willMount: function willMount(props) {
      dispatch(_actions2.default.fetchDiaries(props.params.group_id, 0));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (props.params.group_id != nextProps.params.group_id) {
        dispatch(_actions2.default.closeRightSidePage(true));
        dispatch(_actions2.default.fetchDiaries(nextProps.params.group_id, 0));
      }
    },

    willUnmount: function willUnmount() {
      if (!_agentType.isSmartPhone) dispatch(_actions2.default.closeRightSidePage(true));
    },

    openGroupMembersPanel: function openGroupMembersPanel() {
      return dispatch(_actions2.default.openGroupSettingsPage('members'));
    },

    receiveSocket: function receiveSocket(message, message_type, props) {
      if (message.group_id == ownProps.params.group_id) {
        switch (message_type) {
          case 'diary':
            dispatch(_actions2.default.loadDiary(message.diary, {
              appending: message.appending,
              own_post: message.diary.user.user_id == props.user.user_id,
              group_id: message.group_id
            }));
            break;
          case 'diary_delete':
            dispatch(_actions2.default.loadDiary(message.diary, {
              deleted: true,
              group_id: message.group_id
            }));
            break;
        }
      }
    },

    requestSync: function requestSync() {
      return dispatch(_actions2.default.fetchDiaries(ownProps.params.group_id, 0));
    }
  };
};

exports.default = (0, _combineHoc2.default)(_socketRsync.requireSocketEmit, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _context.inject)({ _readDiary: _propTypes2.default.func }), (0, _socketRsync2.default)('diary', 'diary_delete'), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('group_timeline'));

/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.two-column-layout--layout--2QWheu80 {\n  overflow: hidden;\n  color: #353535;\n}\n\n.two-column-layout--panel--1yjPqPto {\n  overflow: auto;\n  height: calc(100vh - 46px);\n  background: #f7f7f7;\n  padding: 3px;\n  -webkit-overflow-scrolling: touch;\n  will-change: scroll-position;\n  -webkit-transform: translate3d(0,0,0);\n          transform: translate3d(0,0,0);\n}\n\n.two-column-layout--sidebarDrawer--3_4Fj-er {\n  border: none!important;\n  background: #f7f7f7;\n  padding: 3px;\n  position: absolute;\n  height: calc(100vh - 46px);\n  color: #353535;\n}\n\n.two-column-layout--sidebarWrapper--3bZ6doq3 {\n  position: static!important;\n  position: initial!important;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/two-column-layout.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,eAAe;CAChB;;AAED;EACE,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B,sCAAsC;UAC9B,8BAA8B;CACvC;;AAED;EACE,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;CAChB;;AAED;EACE,2BAA2B;EAC3B,4BAA4B;CAC7B","file":"two-column-layout.css","sourcesContent":["\n.layout {\n  overflow: hidden;\n  color: #353535;\n}\n\n.panel {\n  overflow: auto;\n  height: calc(100vh - 46px);\n  background: #f7f7f7;\n  padding: 3px;\n  -webkit-overflow-scrolling: touch;\n  will-change: scroll-position;\n  -webkit-transform: translate3d(0,0,0);\n          transform: translate3d(0,0,0);\n}\n\n.sidebarDrawer {\n  border: none!important;\n  background: #f7f7f7;\n  padding: 3px;\n  position: absolute;\n  height: calc(100vh - 46px);\n  color: #353535;\n}\n\n.sidebarWrapper {\n  position: static!important;\n  position: initial!important;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"layout": "two-column-layout--layout--2QWheu80",
	"panel": "two-column-layout--panel--1yjPqPto",
	"sidebarDrawer": "two-column-layout--sidebarDrawer--3_4Fj-er",
	"sidebarWrapper": "two-column-layout--sidebarWrapper--3bZ6doq3"
};

/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.one-column-layout--layout--3vAyFvU4 {\n  overflow: hidden;\n  color: #353535;\n}\n\n.one-column-layout--panel--3G_YW2oH {\n  overflow: auto;\n  height: calc(100vh - 46px);\n  background: #f7f7f7;\n  padding: 3px;\n  -webkit-overflow-scrolling: touch;\n  will-change: scroll-position;\n  -webkit-transform: translate3d(0,0,0);\n          transform: translate3d(0,0,0);\n}\n\n.one-column-layout--sidebarDrawer--1ng11f3G {\n  border: none!important;\n  background: #f7f7f7;\n  padding: 3px;\n  position: absolute;\n  height: calc(100vh - 46px);\n  color: #353535;\n}\n\n.one-column-layout--sidebarWrapper--1nrD7AiO {\n  position: static!important;\n  position: initial!important;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/one-column-layout.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,eAAe;CAChB;;AAED;EACE,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B,sCAAsC;UAC9B,8BAA8B;CACvC;;AAED;EACE,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;CAChB;;AAED;EACE,2BAA2B;EAC3B,4BAA4B;CAC7B","file":"one-column-layout.css","sourcesContent":["\n.layout {\n  overflow: hidden;\n  color: #353535;\n}\n\n.panel {\n  overflow: auto;\n  height: calc(100vh - 46px);\n  background: #f7f7f7;\n  padding: 3px;\n  -webkit-overflow-scrolling: touch;\n  will-change: scroll-position;\n  -webkit-transform: translate3d(0,0,0);\n          transform: translate3d(0,0,0);\n}\n\n.sidebarDrawer {\n  border: none!important;\n  background: #f7f7f7;\n  padding: 3px;\n  position: absolute;\n  height: calc(100vh - 46px);\n  color: #353535;\n}\n\n.sidebarWrapper {\n  position: static!important;\n  position: initial!important;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"layout": "one-column-layout--layout--3vAyFvU4",
	"panel": "one-column-layout--panel--3G_YW2oH",
	"sidebarDrawer": "one-column-layout--sidebarDrawer--1ng11f3G",
	"sidebarWrapper": "one-column-layout--sidebarWrapper--1nrD7AiO"
};

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\nem {\n  background: rgb(157, 225, 255)\n}\n\n.diary--button--1nXn8Ihm[class~=user] {\n  padding: 0 3px;\n  min-width: 0;\n  min-width: initial;\n  line-height: 24px;\n  height: 18px;\n  font-weight: bold;\n}\n\n.diary--button--1nXn8Ihm[class~=user]:hover {\n  opacity: 0.6;\n}\n\n.diary--button--1nXn8Ihm[class~=touchable] {\n  padding: 0 3px;\n  font-size: 12px;\n  line-height: 22px;\n  height: 22px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n}\n\n.diary--button--1nXn8Ihm[class~=touchable]:hover {\n  color: #111;\n}\n\n.diary--button--1nXn8Ihm[class~=touchable] .diary--icon--2U9bwrUv {\n  font-size: 12px;\n  line-height: 22px;\n  height: 22px;\n}\n\n.diary--button--1nXn8Ihm[class~=comment] {\n  font-size: 12px;\n  line-height: 22px;\n  height: 22px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  font-weight: bold;\n}\n\n.diary--button--1nXn8Ihm[class~=comment]:hover {\n  color: #111;\n  text-decoration: underline;\n}\n\n.diary--button--1nXn8Ihm[class~=comment] .diary--icon--2U9bwrUv {\n  font-size: 12px;\n  line-height: 22px;\n  height: 22px;\n}\n\n.diary--button--1nXn8Ihm[class~=diary] {\n  padding: 0 3px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  width: 140px;\n  font-weight: bold;\n}\n\n/* スマホ対応のスタイルを追加 */\n\n@media screen and (max-width: 600px) {\n  .diary--button--1nXn8Ihm[class~=diary] {\n    padding: 0 2px;\n    font-size: 11px;\n    line-height: 20px;\n    width: auto;\n    min-width: 0;\n    min-width: initial;\n  }\n  \n  .diary--button--1nXn8Ihm[class~=diary] .diary--icon--2U9bwrUv {\n    font-size: 11px;\n    line-height: 20px;\n  }\n\n  /* AIレビューボタンが無効時の幅調整 */\n  .diary--button--1nXn8Ihm[disabled][class~=diary] {\n    padding: 0 2px;\n    font-size: 11px;\n    line-height: 20px;\n    width: auto;\n    min-width: 0;\n    min-width: initial;\n  }\n\n  /* アクション領域の余白も調整 */\n  .diary--cardText--wUzygvJn[class~=actions] {\n    padding: 4px 6px !important;\n    gap: 2px;\n  }\n}\n\n.diary--button--1nXn8Ihm[disabled][class~=diary] {\n  padding: 0 3px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  background: #EEE;\n  min-width: 0;\n  min-width: initial;\n  width: 170px;\n  font-weight: bold;\n}\n\n.diary--button--1nXn8Ihm[class~=transparent] {\n  display: none;\n}\n\n.diary--button--1nXn8Ihm[class~=profile] {\n  padding: 0 3px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  width: 180px;\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.diary--button--1nXn8Ihm[class~=chat] {\n  padding: 0 3px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  width: 180px;\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.diary--button--1nXn8Ihm[class~=block] {\n  font-size: 10px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  width: 160px;\n  height: 25px;\n}\n\n.diary--button--1nXn8Ihm[class~=diary]:hover {\n  background: #EEE;\n}\n\n.diary--button--1nXn8Ihm[class~=diary] .diary--icon--2U9bwrUv {\n  font-size: 13px;\n  line-height: 23px;\n  height: 23px;\n}\n\n.diary--button--1nXn8Ihm[class~=profile] .diary--icon--2U9bwrUv {\n  font-size: 13px;\n  line-height: 23px;\n  height: 23px;\n}\n\n.diary--button--1nXn8Ihm[class~=chat] .diary--icon--2U9bwrUv {\n  font-size: 13px;\n  line-height: 23px;\n  height: 23px;\n}\n\n.diary--button--1nXn8Ihm:not([disabled])[class~=chat] {\n  background-color: rgb(91, 184, 92)!important;\n  color: #FFF!important;\n}\n\n.diary--avatar--1weJDRfP {\n  height: 20px;\n  width: 20px;\n  margin-right: 0px!important;\n}\n\n.diary--tooltip--s58j1BA6 {\n  text-align: left;\n}\n\n.diary--tooltipInner--1SfoFOtE {\n  background: #fdfdfd!important;\n  border: solid 1px #EEE;\n  border-radius: 3px;\n  color: #666!important;\n  min-width: 100px;\n  max-width: 200px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.diary--content--Z0N1cAXd {\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 19px;\n}\n\n.diary--content--Z0N1cAXd p {\n  font-size: 14px;\n  line-height: 19px;\n}\n\n.diary--content--Z0N1cAXd ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.diary--content--Z0N1cAXd ol {\n  margin: 0;\n  padding-left: 1.5em;\n  text-indent: -1.5em;\n  list-style-position: inside;\n}\n\n/* <span>でアイコンを表示するとWebでコピーした時にspan内の文字までコピーされるため、CSS側で表示 */\n\na[class~=googleDocIcon]::before {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  content: 'insert_drive_file';\n  white-space: nowrap;\n}\n\na[class~=materialIcon]::before {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  content: 'link';\n  white-space: nowrap;\n}\n\na[class~=chatMaterialIcon]::before {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  content: 'link';\n  margin-top: 5px;\n  white-space: nowrap;\n}\n\n/* これは箇条書きにURLリンクがある時のスタイル + image画像やチェックボックスとURLリンクを一緒にした時のスタイル */\n\n.diary--content--Z0N1cAXd ul li div,.diary--content--Z0N1cAXd ol li div, .diary--content--Z0N1cAXd input ~ div, .diary--content--Z0N1cAXd img ~ div, .diary--content--Z0N1cAXd input ~ span div, .diary--content--Z0N1cAXd img ~ span div, .diary--content--Z0N1cAXd span ~ div {\n  display: inline;\n}\n\n/* 箇条書きにURLリンクがあり、class=googleDocかgoogleDocIconにimageが適用した時のスタイル */\n\n.diary--content--Z0N1cAXd ol li div a[class~=googleDoc]{\n  padding: 3px 10px 3px 25px!important;\n  margin-top: 10px!important; \n  margin-bottom: 10px!important;\n}\n\n/* 箇条書きにURLリンクがあり、class=materialIconが適用された時のスタイル */\n\n.diary--content--Z0N1cAXd ol li div a[class~=materialIcon],.diary--content--Z0N1cAXd ol li div a[class~=googleDocIcon] {\n  padding: 3px 10px 3px 25px!important;\n}\n\n/* URLリンクでかつ、class=materialIconの時に適用されるスタイル */\n\n.diary--content--Z0N1cAXd div a[class~=materialIcon] {\n  padding: 3px 10px 3px 10px!important;\n}\n\n.diary--content--Z0N1cAXd[class~=all] {\n  max-height: none!important;\n  max-height: initial!important;\n}\n\n.diary--content--Z0N1cAXd[class~=modal] {\n  max-height: 400px!important;\n  overflow: scroll;\n}\n\n.diary--content--Z0N1cAXd[class~=profile] {\n  margin-left: 10px;\n}\n\n.diary--card--3IWoqIbS:not([class~=comment]) {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  overflow: visible;\n  overflow: initial;\n}\n\n.diary--card--3IWoqIbS[class~=comment] {\n  margin: 2px 5px;\n  width: calc(100% - 10px);\n  background: #f8f8f8;\n  border-radius: 16px;\n  box-shadow: none;\n  overflow: visible;\n}\n\n.diary--card--3IWoqIbS[class~=diaryCommentForm] {\n  margin: 0 5px;\n  width: calc(100% - 10px);\n  background: #f8f8f8;\n  box-shadow: none;\n  margin-top: 3px;\n}\n\n.diary--card--3IWoqIbS[class~=replyCommentForm] {\n  margin: 0 5px;\n  background: #f8f8f8;\n  box-shadow: none;\n  margin-top: 3px;\n}\n\n.diary--cardTitle--10SFLA1A:not([class~=comment]) {\n  padding: 8px 8px 0px 8px!important;\n}\n\n.diary--cardTitle--10SFLA1A[class~=comment] {\n  padding: 4px 8px 0px 8px!important;\n}\n\n.diary--cardText--wUzygvJn {\n  padding-top: 2px!important;\n  padding-bottom: 3px;\n  padding-right: 16px;\n  padding-left: 16px;\n}\n\n.diary--cardText--wUzygvJn[class~=uploads],\n.diary--cardText--wUzygvJn[class~=links] {\n  padding-left: 5px!important;\n}\n\n.diary--cardText--wUzygvJn[class~=chatLinks] {\n  padding-left: 5px!important;\n  max-height: 80px;\n  overflow: scroll;\n}\n\n.diary--cardText--wUzygvJn[class~=interaction] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 14px;\n  padding-bottom: 5px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.diary--cardText--wUzygvJn[class~=diaryComment] {\n  margin-top: 2px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 0px!important;\n}\n\n.diary--cardText--wUzygvJn[class~=diaryReply] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: 40px;\n  padding-bottom: 0px!important;\n}\n\n.diary--cardText--wUzygvJn[class~=diaryCommentForm] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 0px!important;\n}\n\n.diary--cardText--wUzygvJn[class~=replyCommentForm] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left:  64px;\n  padding-bottom: 0px!important;\n}\n\n.diary--cardText--wUzygvJn[class~=review] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 10px!important;\n  font-weight: bold!important;\n  padding-bottom: 0px!important;\n}\n\ndiv[class~=reactionField] {\n  position: absolute; \n  padding: 8px; \n  bottom: 45px; \n  border: solid 0.5px;\n  border-radius: 20px; \n  border-color: #DDDDDD; \n  background-color: #ffffff;\n  -webkit-animation: diary--fadeIn--3I4MLMOt 0.5s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: diary--fadeIn--3I4MLMOt 0.5s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n\ndiv[class~=reactionCommentField] {\n  position: absolute; \n  padding: 8px; \n  bottom: 30px; \n  border: solid 0.5px;\n  border-radius: 20px; \n  border-color: #DDDDDD; \n  background-color: #ffffff;\n  -webkit-animation: diary--fadeIn--3I4MLMOt 0.5s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: diary--fadeIn--3I4MLMOt 0.5s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n\n.diary--cardActions--jcZ7RCdw {\n  padding-top: 0px;\n}\n\n/* チェックボックスのスタイル変更 */\n\ninput[type=\"checkbox\"][checked]{\n  background: #2C7CFF !important;\n  border-radius: 20%;\n  -webkit-appearance: none;\n  height: 12px;\n  width: 12px;\n}\n\ninput[type=\"checkbox\"][checked]::before{\n  display: block;\n  color: #f8f8f8;\n  content: \"\\2714\";\n  font-size: 10px;\n  margin-left: 2px;\n}\n\n@-webkit-keyframes diary--fadeIn--3I4MLMOt {\n  0% {\n    -webkit-transform: translateY(20px);\n            transform: translateY(20px);\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n  }\n}\n\n@keyframes diary--fadeIn--3I4MLMOt {\n  0% {\n    -webkit-transform: translateY(20px);\n            transform: translateY(20px);\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .diary--cardText--wUzygvJn {\n    padding-left: 8px;\n  }\n}\n\n.diary--cardText--wUzygvJn[class~=actions] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-top: solid 1px #EEE;\n  border-bottom: solid 1px #EEE;\n  padding-bottom: 4px!important;\n}\n\n.diary--cardText--wUzygvJn[class~=subactions] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-top: solid 1px #EEE;\n  padding-bottom: 4px!important;\n  padding-left: 10px!important;\n}\n\n.diary--cardText--wUzygvJn[class~=showReply] {\n  margin: 0 8px;\n  padding-bottom: 4px!important;\n  margin-left: 50px;\n}\n\n.diary--circular--3uoEUw9e {\n  width: 32px!important;\n  height: 32px!important;\n  vertical-align: middle;\n}\n\n.diary--itemText--1C0GxZLL {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.diary--avatar--1weJDRfP[class~=avatar] {\n  height: 32px;\n  width: 32px;\n  min-width: 32px;\n  margin-right: 5px;\n  margin-top: 5px;\n  cursor: pointer;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/diary.css"],"names":[],"mappings":";AACA;EACE,8BAA8B;CAC/B;;AAED;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;CACnB;;AAED;EACE,aAAa;CACd;;AAED;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;CACpB;;AAED;EACE,YAAY;CACb;;AAED;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;CACd;;AAED;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;CACnB;;AAED;EACE,YAAY;EACZ,2BAA2B;CAC5B;;AAED;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;CACd;;AAED;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;CACnB;;AAED,mBAAmB;;AAEnB;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;GACpB;;EAED;IACE,gBAAgB;IAChB,kBAAkB;GACnB;;EAED,uBAAuB;EACvB;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;GACpB;;EAED,mBAAmB;EACnB;IACE,4BAA4B;IAC5B,SAAS;GACV;CACF;;AAED;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;CACnB;;AAED;EACE,cAAc;CACf;;AAED;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;CACpB;;AAED;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;CACpB;;AAED;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,aAAa;CACd;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;CACd;;AAED;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;CACd;;AAED;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;CACd;;AAED;EACE,6CAA6C;EAC7C,sBAAsB;CACvB;;AAED;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;CAC7B;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;CACrB;;AAED;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;CACnB;;AAED;EACE,gBAAgB;EAChB,kBAAkB;CACnB;;AAED;EACE,UAAU;EACV,mBAAmB;CACpB;;AAED;EACE,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,4BAA4B;CAC7B;;AAED,4DAA4D;;AAE5D;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;CACrB;;AAED;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;CACrB;;AAED;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;CACrB;;AAED,mEAAmE;;AAEnE;EACE,gBAAgB;CACjB;;AAED,mEAAmE;;AAEnE;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,8BAA8B;CAC/B;;AAED,mDAAmD;;AAEnD;EACE,qCAAqC;CACtC;;AAED,8CAA8C;;AAE9C;EACE,qCAAqC;CACtC;;AAED;EACE,2BAA2B;EAC3B,8BAA8B;CAC/B;;AAED;EACE,4BAA4B;EAC5B,iBAAiB;CAClB;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;CACnB;;AAED;EACE,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;CACjB;;AAED;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;CACjB;;AAED;EACE,mCAAmC;CACpC;;AAED;EACE,mCAAmC;CACpC;;AAED;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;CACpB;;AAED;;EAEE,4BAA4B;CAC7B;;AAED;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;CAClB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;MAChB,gBAAgB;CACrB;;AAED;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,8BAA8B;CAC/B;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;CAC/B;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,8BAA8B;CAC/B;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,8BAA8B;CAC/B;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;CAC/B;;AAED;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,yFAAwE;UAChE,iFAAgE;CACzE;;AAED;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,yFAAwE;UAChE,iFAAgE;CACzE;;AAED;EACE,iBAAiB;CAClB;;AAED,qBAAqB;;AAErB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,YAAY;CACb;;AAED;EACE,eAAe;EACf,eAAe;EACf,iBAAa;EACb,gBAAgB;EAChB,iBAAiB;CAClB;;AAED;EACE;IACE,oCAAoC;YAC5B,4BAA4B;IACpC,WAAW;GACZ;EACD;IACE,aAAa;GACd;EACD;IACE,WAAW;IACX,iCAAiC;YACzB,yBAAyB;GAClC;CACF;;AAED;EACE;IACE,oCAAoC;YAC5B,4BAA4B;IACpC,WAAW;GACZ;EACD;IACE,aAAa;GACd;EACD;IACE,WAAW;IACX,iCAAiC;YACzB,yBAAyB;GAClC;CACF;;AAED;EACE;IACE,kBAAkB;GACnB;CACF;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;CAC/B;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;CAC9B;;AAED;EACE,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;CACnB;;AAED;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;CACxB;;AAED;EACE,sBAAsB;EACtB,uBAAuB;CACxB;;AAED;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;CACjB","file":"diary.css","sourcesContent":["\nem {\n  background: rgb(157, 225, 255)\n}\n\n.button[class~=user] {\n  padding: 0 3px;\n  min-width: 0;\n  min-width: initial;\n  line-height: 24px;\n  height: 18px;\n  font-weight: bold;\n}\n\n.button[class~=user]:hover {\n  opacity: 0.6;\n}\n\n.button[class~=touchable] {\n  padding: 0 3px;\n  font-size: 12px;\n  line-height: 22px;\n  height: 22px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n}\n\n.button[class~=touchable]:hover {\n  color: #111;\n}\n\n.button[class~=touchable] .icon {\n  font-size: 12px;\n  line-height: 22px;\n  height: 22px;\n}\n\n.button[class~=comment] {\n  font-size: 12px;\n  line-height: 22px;\n  height: 22px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  font-weight: bold;\n}\n\n.button[class~=comment]:hover {\n  color: #111;\n  text-decoration: underline;\n}\n\n.button[class~=comment] .icon {\n  font-size: 12px;\n  line-height: 22px;\n  height: 22px;\n}\n\n.button[class~=diary] {\n  padding: 0 3px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  width: 140px;\n  font-weight: bold;\n}\n\n/* スマホ対応のスタイルを追加 */\n\n@media screen and (max-width: 600px) {\n  .button[class~=diary] {\n    padding: 0 2px;\n    font-size: 11px;\n    line-height: 20px;\n    width: auto;\n    min-width: 0;\n    min-width: initial;\n  }\n  \n  .button[class~=diary] .icon {\n    font-size: 11px;\n    line-height: 20px;\n  }\n\n  /* AIレビューボタンが無効時の幅調整 */\n  .button[disabled][class~=diary] {\n    padding: 0 2px;\n    font-size: 11px;\n    line-height: 20px;\n    width: auto;\n    min-width: 0;\n    min-width: initial;\n  }\n\n  /* アクション領域の余白も調整 */\n  .cardText[class~=actions] {\n    padding: 4px 6px !important;\n    gap: 2px;\n  }\n}\n\n.button[disabled][class~=diary] {\n  padding: 0 3px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  background: #EEE;\n  min-width: 0;\n  min-width: initial;\n  width: 170px;\n  font-weight: bold;\n}\n\n.button[class~=transparent] {\n  display: none;\n}\n\n.button[class~=profile] {\n  padding: 0 3px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  width: 180px;\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.button[class~=chat] {\n  padding: 0 3px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  width: 180px;\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.button[class~=block] {\n  font-size: 10px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  width: 160px;\n  height: 25px;\n}\n\n.button[class~=diary]:hover {\n  background: #EEE;\n}\n\n.button[class~=diary] .icon {\n  font-size: 13px;\n  line-height: 23px;\n  height: 23px;\n}\n\n.button[class~=profile] .icon {\n  font-size: 13px;\n  line-height: 23px;\n  height: 23px;\n}\n\n.button[class~=chat] .icon {\n  font-size: 13px;\n  line-height: 23px;\n  height: 23px;\n}\n\n.button:not([disabled])[class~=chat] {\n  background-color: rgb(91, 184, 92)!important;\n  color: #FFF!important;\n}\n\n.avatar {\n  height: 20px;\n  width: 20px;\n  margin-right: 0px!important;\n}\n\n.tooltip {\n  text-align: left;\n}\n\n.tooltipInner {\n  background: #fdfdfd!important;\n  border: solid 1px #EEE;\n  border-radius: 3px;\n  color: #666!important;\n  min-width: 100px;\n  max-width: 200px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.content {\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 19px;\n}\n\n.content p {\n  font-size: 14px;\n  line-height: 19px;\n}\n\n.content ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.content ol {\n  margin: 0;\n  padding-left: 1.5em;\n  text-indent: -1.5em;\n  list-style-position: inside;\n}\n\n/* <span>でアイコンを表示するとWebでコピーした時にspan内の文字までコピーされるため、CSS側で表示 */\n\na[class~=googleDocIcon]::before {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  content: 'insert_drive_file';\n  white-space: nowrap;\n}\n\na[class~=materialIcon]::before {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  content: 'link';\n  white-space: nowrap;\n}\n\na[class~=chatMaterialIcon]::before {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  content: 'link';\n  margin-top: 5px;\n  white-space: nowrap;\n}\n\n/* これは箇条書きにURLリンクがある時のスタイル + image画像やチェックボックスとURLリンクを一緒にした時のスタイル */\n\n.content ul li div,.content ol li div, .content input ~ div, .content img ~ div, .content input ~ span div, .content img ~ span div, .content span ~ div {\n  display: inline;\n}\n\n/* 箇条書きにURLリンクがあり、class=googleDocかgoogleDocIconにimageが適用した時のスタイル */\n\n.content ol li div a[class~=googleDoc]{\n  padding: 3px 10px 3px 25px!important;\n  margin-top: 10px!important; \n  margin-bottom: 10px!important;\n}\n\n/* 箇条書きにURLリンクがあり、class=materialIconが適用された時のスタイル */\n\n.content ol li div a[class~=materialIcon],.content ol li div a[class~=googleDocIcon] {\n  padding: 3px 10px 3px 25px!important;\n}\n\n/* URLリンクでかつ、class=materialIconの時に適用されるスタイル */\n\n.content div a[class~=materialIcon] {\n  padding: 3px 10px 3px 10px!important;\n}\n\n.content[class~=all] {\n  max-height: none!important;\n  max-height: initial!important;\n}\n\n.content[class~=modal] {\n  max-height: 400px!important;\n  overflow: scroll;\n}\n\n.content[class~=profile] {\n  margin-left: 10px;\n}\n\n.card:not([class~=comment]) {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  overflow: visible;\n  overflow: initial;\n}\n\n.card[class~=comment] {\n  margin: 2px 5px;\n  width: calc(100% - 10px);\n  background: #f8f8f8;\n  border-radius: 16px;\n  box-shadow: none;\n  overflow: visible;\n}\n\n.card[class~=diaryCommentForm] {\n  margin: 0 5px;\n  width: calc(100% - 10px);\n  background: #f8f8f8;\n  box-shadow: none;\n  margin-top: 3px;\n}\n\n.card[class~=replyCommentForm] {\n  margin: 0 5px;\n  background: #f8f8f8;\n  box-shadow: none;\n  margin-top: 3px;\n}\n\n.cardTitle:not([class~=comment]) {\n  padding: 8px 8px 0px 8px!important;\n}\n\n.cardTitle[class~=comment] {\n  padding: 4px 8px 0px 8px!important;\n}\n\n.cardText {\n  padding-top: 2px!important;\n  padding-bottom: 3px;\n  padding-right: 16px;\n  padding-left: 16px;\n}\n\n.cardText[class~=uploads],\n.cardText[class~=links] {\n  padding-left: 5px!important;\n}\n\n.cardText[class~=chatLinks] {\n  padding-left: 5px!important;\n  max-height: 80px;\n  overflow: scroll;\n}\n\n.cardText[class~=interaction] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 14px;\n  padding-bottom: 5px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.cardText[class~=diaryComment] {\n  margin-top: 2px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 0px!important;\n}\n\n.cardText[class~=diaryReply] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: 40px;\n  padding-bottom: 0px!important;\n}\n\n.cardText[class~=diaryCommentForm] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 0px!important;\n}\n\n.cardText[class~=replyCommentForm] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left:  64px;\n  padding-bottom: 0px!important;\n}\n\n.cardText[class~=review] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 10px!important;\n  font-weight: bold!important;\n  padding-bottom: 0px!important;\n}\n\ndiv[class~=reactionField] {\n  position: absolute; \n  padding: 8px; \n  bottom: 45px; \n  border: solid 0.5px;\n  border-radius: 20px; \n  border-color: #DDDDDD; \n  background-color: #ffffff;\n  -webkit-animation: fadeIn 0.5s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: fadeIn 0.5s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n\ndiv[class~=reactionCommentField] {\n  position: absolute; \n  padding: 8px; \n  bottom: 30px; \n  border: solid 0.5px;\n  border-radius: 20px; \n  border-color: #DDDDDD; \n  background-color: #ffffff;\n  -webkit-animation: fadeIn 0.5s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n          animation: fadeIn 0.5s cubic-bezier(0.25, 1, 0.5, 1) 1 forwards;\n}\n\n.cardActions {\n  padding-top: 0px;\n}\n\n/* チェックボックスのスタイル変更 */\n\ninput[type=\"checkbox\"][checked]{\n  background: #2C7CFF !important;\n  border-radius: 20%;\n  -webkit-appearance: none;\n  height: 12px;\n  width: 12px;\n}\n\ninput[type=\"checkbox\"][checked]::before{\n  display: block;\n  color: #f8f8f8;\n  content: \"✔\";\n  font-size: 10px;\n  margin-left: 2px;\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    -webkit-transform: translateY(20px);\n            transform: translateY(20px);\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    -webkit-transform: translateY(20px);\n            transform: translateY(20px);\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .cardText {\n    padding-left: 8px;\n  }\n}\n\n.cardText[class~=actions] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-top: solid 1px #EEE;\n  border-bottom: solid 1px #EEE;\n  padding-bottom: 4px!important;\n}\n\n.cardText[class~=subactions] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-top: solid 1px #EEE;\n  padding-bottom: 4px!important;\n  padding-left: 10px!important;\n}\n\n.cardText[class~=showReply] {\n  margin: 0 8px;\n  padding-bottom: 4px!important;\n  margin-left: 50px;\n}\n\n.circular {\n  width: 32px!important;\n  height: 32px!important;\n  vertical-align: middle;\n}\n\n.itemText {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.avatar[class~=avatar] {\n  height: 32px;\n  width: 32px;\n  min-width: 32px;\n  margin-right: 5px;\n  margin-top: 5px;\n  cursor: pointer;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"button": "diary--button--1nXn8Ihm",
	"icon": "diary--icon--2U9bwrUv",
	"cardText": "diary--cardText--wUzygvJn",
	"avatar": "diary--avatar--1weJDRfP",
	"tooltip": "diary--tooltip--s58j1BA6",
	"tooltipInner": "diary--tooltipInner--1SfoFOtE",
	"content": "diary--content--Z0N1cAXd",
	"card": "diary--card--3IWoqIbS",
	"cardTitle": "diary--cardTitle--10SFLA1A",
	"fadeIn": "diary--fadeIn--3I4MLMOt",
	"cardActions": "diary--cardActions--jcZ7RCdw",
	"circular": "diary--circular--3uoEUw9e",
	"itemText": "diary--itemText--1C0GxZLL"
};

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/diary.js

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _analytics = __webpack_require__(27);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _route = __webpack_require__(67);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _socketRsync = __webpack_require__(144);

var _some = __webpack_require__(161);

var _some2 = _interopRequireDefault(_some);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _uniq = __webpack_require__(486);

var _uniq2 = _interopRequireDefault(_uniq);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _agentType = __webpack_require__(142);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isPhone: state.media.isPhone,
    access_token: state.sessions.access_token,
    isRightSidePage: false, // state.rightSidePage.name? true : false 一時対処
    _blockUsers: state.block.users,
    _blockDiaries: state.block.diaries,
    review: state.lambdaApi.stream,
    isFetching: state.lambdaApi.isFetching,
    isFetchFailed: state.lambdaApi.isFetchFailed,
    isOpenReviewPanel: state.lambdaApi.isOpenReviewPanel,
    isReviewCompleted: state.lambdaApi.isCompleted,
    isReviewEnable: state.reviewSetting.isEnable,
    isShowTimeStamp: state.showTimeStamp.isEnable
  };
};

var START_EM_TAG_REGEXP = /<em>/g;
var END_EM_TAG_REGEXP = /<\/em>/g;

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var blockUser = ownProps.diary && ownProps.diary.user && (0, _find2.default)(stateProps._blockUsers, function (user) {
    return user.user_id == ownProps.diary.user.user_id;
  });
  var blockDiary = ownProps.diary && (0, _find2.default)(stateProps._blockDiaries, function (blockDiary) {
    return blockDiary.diary_id == ownProps.diary.diary_id;
  });
  var highlights = [];
  if (ownProps.diary.highlights) {
    ownProps.diary.highlights.content && (highlights = highlights.concat(ownProps.diary.highlights.content));
    ownProps.diary.highlights.comments && (highlights = highlights.concat(ownProps.diary.highlights.comments));
  }
  var hits = [];
  var match, matchEnd;
  if (highlights.length > 0) {
    (0, _each2.default)(highlights, function (item) {
      while (match = START_EM_TAG_REGEXP.exec(item)) {
        END_EM_TAG_REGEXP.lastIndex = match.index + 4;
        matchEnd = END_EM_TAG_REGEXP.exec(item);
        hits.push(item.slice(match.index + 4, matchEnd && matchEnd.index || undefined).trim());
      }
    });
    hits = (0, _uniq2.default)(hits);
  }

  var isAttachment = false;
  if (ownProps.diary.comments && ownProps.diary.comments.length > 3) {
    var _comments = ownProps.diary.comments.slice(0, ownProps.diary.comments.length - 3);
    isAttachment = (0, _some2.default)(_comments, function (comment) {
      return comment.files.length > 0;
    });
  }

  return _extends({
    blockUser: blockUser,
    blockDiary: blockDiary,
    searchHits: hits && hits.length > 0 && hits,
    isAttachment: isAttachment
  }, ownProps, stateProps, dispatchProps);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    deleteDiary: function deleteDiary() {
      return dispatch(_actions2.default.deleteDiary(ownProps.params ? ownProps.params.diary.diary_id : ownProps.diary.diary_id));
    },
    editDiary: function editDiary() {
      return dispatch(_actions2.default.editDiary(ownProps.params ? ownProps.params.diary.diary_id : ownProps.diary.diary_id));
    },
    likeDiary: function likeDiary() {
      return dispatch(_actions2.default.likeDiary(ownProps.diary.diary_id));
    },
    pinDiary: function pinDiary() {
      return dispatch(_actions2.default.pinDiary(ownProps.params ? ownProps.params.diary.diary_id : ownProps.diary.diary_id));
    },
    unpinDiary: function unpinDiary() {
      return dispatch(_actions2.default.unpinDiary(ownProps.params ? ownProps.params.diary.diary_id : ownProps.diary.diary_id, ownProps.group.group_id));
    },
    reactionDiary: function reactionDiary(like_type) {
      return dispatch(_actions2.default.likeDiary(ownProps.diary.diary_id, like_type));
    },
    pickupDiary: function pickupDiary() {
      return dispatch(_actions2.default.openRightSidePage('pickup_diaries', _agentType.isSmartPhone ? {
        group_id: !ownProps.diary.group && ownProps.group && ownProps.group.group_id || undefined,
        diary_ids: [ownProps.diary.diary_id],
        diaries: [ownProps.diary]
      } : {
        group_id: !ownProps.diary.group && ownProps.group && ownProps.group.group_id || undefined,
        append: { diary_ids: [ownProps.diary.diary_id] }
      }, true));
    },
    readDiary: function readDiary() {
      if (ownProps._readDiary) ownProps._readDiary(ownProps, ownProps.diary);else dispatch(_actions2.default.markDiaryRead(ownProps.diary.diary_id));
    },
    unlikeDiary: function unlikeDiary() {
      var like = (0, _find2.default)(ownProps.diary.likes, function (_like) {
        return _like.user.user_id == ownProps.user.user_id;
      });
      like && dispatch(_actions2.default.deleteLike(like.like_id));
    },

    submitStamp: function submitStamp(code, props) {
      if (!code) return;
      dispatch(_actions2.default.postComment(props.parent.comment_id ? 'comment_id' : 'diary_id', props.parent.comment_id || props.parent.diary_id, '<div><span class="stamp ' + code + '"></span></div>'));
    },

    navigateDiaryDetail: function navigateDiaryDetail(parent, isComment, editComment) {
      dispatch(_actions2.default.openRightSidePage('diary_details', {
        diary: ownProps.diary,
        group: ownProps.group ? ownProps.group : ownProps.diary.group,
        initialParent: parent,
        isComment: isComment, editComment: editComment
      }));
    },

    translateDiary: function translateDiary() {
      var diary_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      dispatch(_actions2.default.translateDiary(ownProps.group && ownProps.group.group_id || 'home', ownProps.diary && ownProps.diary.diary_id || diary_id));
    },

    showGroup: function showGroup() {
      dispatch(_actions2.default.closeRightSidePage());
      (0, _route.pushRoute)('group_timeline', { group_id: ownProps.diary.group.group_id });
    },
    showUser: function showUser() {
      dispatch(_actions2.default.openRightSidePage('user_timeline', {
        group_id: !ownProps.diary.group && ownProps.group && ownProps.group.group_id || undefined,
        user_id: ownProps.diary.user.user_id
      }));
    },
    showReaders: function showReaders(props) {
      return dispatch(_actions2.default.openRightSidePage('likes_readers', { diary_id: ownProps.diary.diary_id, tab: props.types }, true));
    },
    showAttachments: function showAttachments() {
      return dispatch(_actions2.default.openRightSidePage('attachments', { diary_id: ownProps.diary.diary_id }, true));
    },
    appAlertMessage: function appAlertMessage() {
      return dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:ファイルを開けません' }, 'error'));
    },
    updateBlockDiary: function updateBlockDiary(diary, isBlock) {
      dispatch(_actions2.default.updateBlockDiary(diary.diary_id, isBlock));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: isBlock ? 'label:投稿をブロックしました' : 'label:投稿をブロック解除しました', name: diary && diary.user.name }, 'success'));
    },
    postContentReport: function postContentReport(props) {
      var user_id = ownProps.user && ownProps.user.user_id || props.user.user_id;
      dispatch(_actions2.default.postContentReport(user_id, props.diary.diary_id));
    },
    askGpt: function askGpt(message) {
      return dispatch(_actions2.default.fetchReview(message));
    },
    onOpenReview: function onOpenReview() {
      return dispatch(_actions2.default.openReviewPanel());
    },
    onCloseReview: function onCloseReview() {
      return dispatch(_actions2.default.closeReviewPanel());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _uiState2.default)({
  state: {
    openReaction: false
  }
}), (0, _context2.default)({ _readDiary: _propTypes2.default.func, emitSocket: _propTypes2.default.func, showImagesView: _propTypes2.default.func, showStampPalette: _propTypes2.default.func }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _reactI18next.translate)(), (0, _analytics.trackHandlers)('pinDiary', 'pin_diary_submit'), (0, _analytics.trackHandlers)('unpinDiary', 'unpin_diary_submit'), (0, _analytics.trackHandlers)('askGpt', 'ask_gpt_diary'), (0, _analytics.trackHandlers)('likeDiary', 'like_diary'), (0, _analytics.trackHandlers)('reactionDiary', 'reaction_diary'));

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactI18next = __webpack_require__(2);

var _emojiHelpers = __webpack_require__(146);

var _font_icon = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var groupStyle = {
  color: '#999',
  marginLeft: '1em',
  fontSize: '80%',
  cursor: 'pointer',
  display: 'inline-block'
};
// src/web/components/diary-title.jsx

var unreadMarkStyle = {
  background: '#20B2AA',
  width: '0.8em',
  height: '0.8em',
  borderRadius: '50%',
  display: 'inline-block',
  verticalAlign: 'middle',
  marginLeft: '5px'
};

function DiaryTitlte(props) {
  var t = props.t,
      diary = props.diary,
      unread = props.unread,
      showGroup = props.showGroup;


  var subject;
  if (diary.subject) {
    subject = _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: (0, _emojiHelpers.convertEmojiHTML)(diary.subject) } });
  } else {
    subject = _react2.default.createElement(
      'span',
      null,
      t('format:diary_subject', {
        reported_at: diary.reported_at,
        category: t('diary:' + diary.category)
      })
    );
  }

  var group;
  if (diary.group) {
    group = _react2.default.createElement(
      'div',
      { style: groupStyle, onClick: showGroup },
      _react2.default.createElement(_font_icon.FontIcon, { style: { fontSize: '80%' }, value: 'keyboard_arrow_right' }),
      diary.group.name
    );
  }

  var unreadMark;
  if (unread) unreadMark = _react2.default.createElement('span', { style: unreadMarkStyle });

  return group && _react2.default.createElement(
    'span',
    null,
    subject,
    group,
    ' ',
    unreadMark
  ) || _react2.default.createElement(
    'span',
    null,
    subject,
    ' ',
    unreadMark
  );
}

exports.default = (0, _reactI18next.translate)()(DiaryTitlte);

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _menu = __webpack_require__(63);

var _button = __webpack_require__(8);

var _emojiHelpers = __webpack_require__(146);

var _route = __webpack_require__(67);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _stripHtml = __webpack_require__(2510);

var _stripHtml2 = _interopRequireDefault(_stripHtml);

var _emoji = __webpack_require__(187);

var _emoji2 = _interopRequireDefault(_emoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clipboardCopy(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE only
    window.clipboardData.setData('Text', (0, _stripHtml2.default)(text));
  } else {
    var input = document.createElement('div');
    input.style.position = "absolute";
    input.style.top = '-100px';
    input.style.width = '1px';
    input.style.height = '1px';
    input.innerHTML = text;
    document.body.appendChild(input);
    var range = document.createRange();
    range.selectNode(input);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    document.body.removeChild(input);
  }
}
// src/web/components/diary-dropdown-menu.jsx

function DiaryDropdownMenu(props) {
  var t = props.t,
      diary = props.diary,
      group = props.group,
      user = props.user,
      pin = props.pin,
      onPin = props.onPin,
      translated = props.translated,
      onShowOriginal = props.onShowOriginal,
      onShowTranslate = props.onShowTranslate,
      deleteDiary = props.deleteDiary,
      editDiary = props.editDiary,
      access_token = props.access_token,
      updateBlockDiary = props.updateBlockDiary,
      onUnBlockConfirm = props.onUnBlockConfirm,
      blockDiary = props.blockDiary;


  return _react2.default.createElement(
    _menu.IconMenu,
    { icon: 'more_vert', position: 'topRight' },
    diary.user.user_id == user.user_id && !diary.group && _react2.default.createElement(_menu.MenuItem, { caption: t('label:投稿を編集'), onClick: editDiary, icon: 'mode_edit' }),
    (diary.user.user_id == user.user_id || !diary.group && group && group.is_admin) && _react2.default.createElement(_menu.MenuItem, { caption: t('label:投稿を削除'), onClick: deleteDiary, icon: 'delete_forever' }),
    _react2.default.createElement(_menu.MenuItem, { caption: t('label:投稿を印刷'), onClick: function onClick() {
        return window.open().location.href = _config2.default.baseUrl + 'v3/session/redirect?redirect_to=/v3/export/diary/' + diary.diary_id + '&access_token=' + access_token;
      }, icon: 'print' }),
    !translated && _react2.default.createElement(_menu.MenuItem, { caption: t('label:投稿を翻訳'), onClick: onShowTranslate, icon: 'g_translate' }),
    translated && _react2.default.createElement(_menu.MenuItem, { caption: t('label:元の表示に戻す'), onClick: onShowOriginal, icon: 'g_translate' }),
    _react2.default.createElement(_menu.MenuItem, { caption: t('label:リンクをコピー'), onClick: function onClick() {
        return clipboardCopy(_config2.default.baseUrl + 'n/#/groups/' + (diary.group ? 'home' : group.group_id + '/timeline') + '/pickup?diary_ids=' + diary.diary_id);
      }, icon: 'link' }),
    _react2.default.createElement(_menu.MenuItem, { caption: t('label:本文をコピー'), onClick: function onClick() {
        return clipboardCopy((0, _emojiHelpers.convertEmojiHTML)(diary.content));
      }, icon: 'content_copy' }),
    blockDiary && _react2.default.createElement(_menu.MenuItem, { caption: t('label:投稿ブロック解除'), onClick: onUnBlockConfirm, icon: 'do_not_disturb_on' }),
    group && group.is_admin && _react2.default.createElement(_menu.MenuItem, {
      caption: pin ? t('label:ピン留め解除') : t('label:ピン留め'),
      onClick: onPin,
      icon: _react2.default.createElement('img', { src: _emoji2.default[pin ? "1f4cc-unpin" : "1f4cc-pin"], style: { width: 22, height: 22, verticalAlign: 'middle' } }) })
  );
}

exports.default = (0, _reactI18next.translate)()(DiaryDropdownMenu);

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stripHtml;

// src/helpers/strip-html.js

function stripHtml(html) {
  return html.replace(/<br>/g, '\n').replace(/<li[^>]*>/ig, '* ').replace(/<\/li>/ig, '\n').replace(/<\/?[^>]+>/g, '').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ');
}

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-readers.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = __webpack_require__(10);

var _reactI18next = __webpack_require__(2);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _button = __webpack_require__(8);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _font_icon = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipButton = (0, _tooltip2.default)(_button.Button);

var DiaryReaders = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryReaders, _React$Component);

  function DiaryReaders() {
    _classCallCheck(this, DiaryReaders);

    return _possibleConstructorReturn(this, (DiaryReaders.__proto__ || Object.getPrototypeOf(DiaryReaders)).apply(this, arguments));
  }

  _createClass(DiaryReaders, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          readers = _props.readers,
          readers_count = _props.readers_count,
          myself = _props.myself,
          theme = _props.theme,
          showReaders = _props.showReaders;

      //issues/5432

      var count = typeof readers_count != 'undefined' ? readers_count : readers.length;

      if (!readers || readers.length == 0) return null;

      var tooltip = readers.map(function (reader) {
        return _react2.default.createElement(
          'div',
          { key: reader.user.user_id },
          _react2.default.createElement(_avatar2.default, { key: reader.user.user_id, image: reader.user.icon_image.thumb_url, theme: theme }),
          '\xA0',
          reader.user.name
        );
      });
      if (readers_count && readers_count > readers.length) tooltip.push(_react2.default.createElement(
        'div',
        { key: 'count' },
        '...',
        t('label:他n人', { n: readers_count - readers.length })
      ));

      return _react2.default.createElement(
        TooltipButton,
        { neutral: false, ripple: false,
          theme: theme,
          className: 'touchable',
          tooltipPosition: 'vertical',
          tooltip: tooltip,
          onClick: function onClick() {
            return showReaders({ types: 'readers' });
          } },
        _react2.default.createElement(_font_icon.FontIcon, { value: 'check', style: { fontSize: 16, color: 'green', lineHeight: 1 } }),
        '\xA0',
        readers.slice(0, 3).map(function (reader) {
          return _react2.default.createElement(_avatar2.default, { key: reader.user.user_id, image: reader.user.icon_image.thumb_url, theme: theme });
        }),
        '\xA0',
        count > 3 && t('label:他n人', { n: count - 3 }),
        t('label:が開封')
      );
    }
  }]);

  return DiaryReaders;
}(_react2.default.Component)) || _class);
exports.default = (0, _reactI18next.translate)()(DiaryReaders);

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-mentions-by.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = __webpack_require__(10);

var _reactI18next = __webpack_require__(2);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _button = __webpack_require__(8);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _font_icon = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipButton = (0, _tooltip2.default)(_button.Button);

var DiaryMentionsBy = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryMentionsBy, _React$Component);

  function DiaryMentionsBy() {
    _classCallCheck(this, DiaryMentionsBy);

    return _possibleConstructorReturn(this, (DiaryMentionsBy.__proto__ || Object.getPrototypeOf(DiaryMentionsBy)).apply(this, arguments));
  }

  _createClass(DiaryMentionsBy, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          mentions = _props.mentions,
          theme = _props.theme,
          showReaders = _props.showReaders;


      if (!mentions || mentions.length == 0) return null;

      var tooltip = mentions.map(function (mention) {
        return _react2.default.createElement(
          'div',
          { key: mention.user_id },
          _react2.default.createElement(_avatar2.default, { key: mention.user_id, image: mention.icon_image.thumb_url, theme: theme }),
          '\xA0',
          mention.name
        );
      });

      return _react2.default.createElement(
        TooltipButton,
        { neutral: false, ripple: false,
          theme: theme,
          className: 'touchable',
          tooltipPosition: 'vertical',
          tooltip: tooltip,
          onClick: function onClick() {
            return showReaders({ types: 'mentions' });
          } },
        _react2.default.createElement(_font_icon.FontIcon, { value: 'priority_high', style: { fontSize: 16, color: 'orange', lineHeight: '1' } }),
        '\xA0',
        mentions.slice(0, 3).map(function (mention) {
          return _react2.default.createElement(_avatar2.default, { key: mention.user_id, image: mention.icon_image.thumb_url, theme: theme });
        }),
        '\xA0',
        mentions.length > 3 && t('label:他n人', { n: mentions.length - 3 }),
        t('label:が読んでみて')
      );
    }
  }]);

  return DiaryMentionsBy;
}(_react2.default.Component)) || _class);
exports.default = (0, _reactI18next.translate)()(DiaryMentionsBy);

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _reactI18next = __webpack_require__(2);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
}; /* src/connects/diary-actions.js */

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(undefined, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    disableLike: false,
    /* アプリで使用するui.state */
    openReaction: false,
    openCommentReaction: false,
    openReplyReaction: false,
    isTouch: false,
    selectImage: undefined,
    currentImageFocus: undefined,
    currentImageRelease: undefined,
    isLongTouch: false,
    fieldHeight: 0,
    /* webで使用するui.state */
    reactionFocus: false,
    timer: false,
    innerWidth: 0
  }
}), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2515);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary-like.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./diary-like.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".diary-like--button--3sVO55c3[class~=reaction] {\n  padding: 0 5px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  font-weight: bold;\n}\n\n.diary-like--button--3sVO55c3[class~=ShrinkReaction] {\n  padding: 0 5px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  font-weight: bold;\n  height: 0px;\n}\n\n.diary-like--button--3sVO55c3[class~=ShrinkReaction] > span:not([data-react-toolbox='tooltip']) {\n  line-height: 22px;\n}\n\n.diary-like--tooltip--3BqzAGZ2 {\n  text-align: center;\n}\n\n.diary-like--tooltipInner--1eA0aXf0 {\n  font-size: 14px;\n  border: solid 1px #EEE;\n  border-radius: 20px;\n  min-width: 50px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.diary-like--image--1iXUqLD6 {\n  width: 35px;\n  height: 35px;\n  vertical-align: middle;\n}\n\n.diary-like--minImage--1PxcvsR3 {\n  width: 25px;\n  height: 25px;\n  vertical-align: middle;\n  margin-bottom: 5px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/diary-like.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;CACnB;;AAED;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;CACb;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;CACrB;;AAED;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;CACxB;;AAED;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB","file":"diary-like.css","sourcesContent":[".button[class~=reaction] {\n  padding: 0 5px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  font-weight: bold;\n}\n\n.button[class~=ShrinkReaction] {\n  padding: 0 5px;\n  font-size: 13px;\n  line-height: 23px;\n  color: #666;\n  min-width: 0;\n  min-width: initial;\n  font-weight: bold;\n  height: 0px;\n}\n\n.button[class~=ShrinkReaction] > span:not([data-react-toolbox='tooltip']) {\n  line-height: 22px;\n}\n\n.tooltip {\n  text-align: center;\n}\n\n.tooltipInner {\n  font-size: 14px;\n  border: solid 1px #EEE;\n  border-radius: 20px;\n  min-width: 50px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.image {\n  width: 35px;\n  height: 35px;\n  vertical-align: middle;\n}\n\n.minImage {\n  width: 25px;\n  height: 25px;\n  vertical-align: middle;\n  margin-bottom: 5px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"button": "diary-like--button--3sVO55c3",
	"tooltip": "diary-like--tooltip--3BqzAGZ2",
	"tooltipInner": "diary-like--tooltipInner--1eA0aXf0",
	"image": "diary-like--image--1iXUqLD6",
	"minImage": "diary-like--minImage--1PxcvsR3"
};

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(105);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".diary-form-button--button--1ET_eDcb {\n  margin: 0 4px;\n  text-transform: none;\n}\n\n.diary-form-button--button--1ET_eDcb:first-child {\n  margin-left: 0;\n}\n\n.diary-form-button--button--1ET_eDcb:last-child {\n  margin-right: 0;\n}\n\n.diary-form-button--error_msg--2bEmTlMW {\n  font-size: 80%;\n  color: red;\n}\n\n.diary-form-button--save_msg--3B6HbQZL {\n  font-size: 80%;\n  color: green;\n}\n\n.diary-form-button--save_button--1DXY_I_8 {\n  padding: 0 12px 0 6px;\n}\n\n.diary-form-button--dropdown--eyhnzZaF .diary-form-button--field--2rJ_jACR {\n  padding: 3px 0px;\n}\n\n.diary-form-button--dropdown--eyhnzZaF .diary-form-button--value--Zs-kMjy- {\n  background: #FFF;\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, .12);\n  padding: 6px 8px;\n}\n\n.diary-form-button--dropdown--eyhnzZaF .diary-form-button--value--Zs-kMjy-::after {\n  right: unset!important;\n  margin-left: 14px;\n  border-top: 5.48571px solid rgba(0, 0, 0, .9)!important;\n}\n\n.diary-form-button--circle--132Cmx7B {\n  display: inline-block;\n  width: 8px;\n  height:8px;\n  background-color: red;\n  border-radius: 50%;\n  -webkit-animation: diary-form-button--pulse--31W1h5cd 2s infinite ease-in-out;\n          animation: diary-form-button--pulse--31W1h5cd 2s infinite ease-in-out;\n  opacity: 0.6;\n}\n\n@-webkit-keyframes diary-form-button--pulse--31W1h5cd {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    -webkit-transform: scale(1.5);\n            transform: scale(1.5);\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n\n@keyframes diary-form-button--pulse--31W1h5cd {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    -webkit-transform: scale(1.5);\n            transform: scale(1.5);\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n\n.diary-form-button--reviewCard--2tPIhBcF {\n  margin: 8px 8px 8px 8px;\n  width: 80%;\n}\n\n.diary-form-button--reviewFooter--2d8Lg2gj {\n  background: #f4f4f4;\n  font-size: 14px;\n  min-height: 40px;\n  height: auto;\n  padding: 8px;\n}\n\n.diary-form-button--reviewFooterContent--3nihenca {\n  font-weight: bold;\n  font-size: 10px;\n  margin-top: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 8px;\n}\n\n.diary-form-button--warningFooter--XqRh9LBy {\n  background: #f4f4f4;\n  padding: 4px 12px !important;\n}\n\n.diary-form-button--warningContent--f0vj591I {\n  font-weight: bold;\n  font-size: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.diary-form-button--warningTextGroup--1g8prh4e {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n}\n\n.diary-form-button--warningActionGroup--1dz6nczS {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.diary-form-button--settingsIcon--3dXVAYmk {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n/* スマホ対応のスタイル */\n\n@media screen and (max-width: 600px) {\n  .diary-form-button--button--1ET_eDcb {\n    margin: 0 2px !important;\n    font-size: 12px !important;\n    padding: 0 4px !important;\n    min-width: auto !important;\n    height: 32px !important;\n    line-height: 32px !important;\n  }\n\n  .diary-form-button--button--1ET_eDcb .diary-form-button--material-icons--oiVT4lEz {\n    font-size: 16px !important;\n    width: 16px !important;\n    height: 16px !important;\n    margin-right: 3px !important;\n  }\n\n  .diary-form-button--button--1ET_eDcb img {\n    width: 16px !important;\n    height: 16px !important;\n    margin-right: 3px !important;\n  }\n\n  .diary-form-button--save_button--1DXY_I_8 {\n    padding: 0 6px 0 3px !important;\n  }\n\n  .diary-form-button--dropdown--eyhnzZaF .diary-form-button--value--Zs-kMjy- {\n    padding: 4px 6px !important;\n    font-size: 12px !important;\n  }\n\n  .diary-form-button--dropdown--eyhnzZaF .diary-form-button--value--Zs-kMjy-::after {\n    margin-left: 6px !important;\n  }\n\n  /* フレックスコンテナの調整 */\n  div[style*=\"display: flex\"] {\n    gap: 2px !important;\n  }\n\n  /* AIレビューボタンが無効時の幅も調整 */\n  .diary-form-button--button--1ET_eDcb[disabled] {\n    width: auto !important;\n  }\n\n  .diary-form-button--reviewCard--2tPIhBcF {\n    width: calc(100% - 16px) !important;\n    margin: 8px !important;\n  }\n\n  .diary-form-button--reviewFooter--2d8Lg2gj {\n    padding: 12px 8px;\n  }\n\n  .diary-form-button--warningFooter--XqRh9LBy {\n    padding: 4px 8px !important;\n  }\n\n  .diary-form-button--warningContent--f0vj591I {\n    gap: 4px;\n  }\n\n  .diary-form-button--warningTextGroup--1g8prh4e {\n    width: 100%;\n  }\n\n  .diary-form-button--warningActionGroup--1dz6nczS {\n    width: 100%;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    margin-left: 0;\n  }\n\n  .diary-form-button--warningActionGroup--1dz6nczS [data-react-toolbox=\"button\"] {\n    display: none !important;\n  }\n\n  .diary-form-button--settingsIcon--3dXVAYmk {\n    display: none !important;  /* 設定アイコンを非表示 */\n  }\n}", "", {"version":3,"sources":["/./src/web/components/themes/diary-form-button.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,qBAAqB;CACtB;;AAED;EACE,eAAe;CAChB;;AAED;EACE,gBAAgB;CACjB;;AAED;EACE,eAAe;EACf,WAAW;CACZ;;AAED;EACE,eAAe;EACf,aAAa;CACd;;AAED;EACE,sBAAsB;CACvB;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;CAClB;;AAED;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wDAAwD;CACzD;;AAED;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,8EAAiD;UACzC,sEAAyC;EACjD,aAAa;CACd;;AAED;EACE;IACE,4BAA4B;YACpB,oBAAoB;GAC7B;EACD;IACE,8BAA8B;YACtB,sBAAsB;GAC/B;EACD;IACE,4BAA4B;YACpB,oBAAoB;GAC7B;CACF;;AAED;EACE;IACE,4BAA4B;YACpB,oBAAoB;GAC7B;EACD;IACE,8BAA8B;YACtB,sBAAsB;GAC/B;EACD;IACE,4BAA4B;YACpB,oBAAoB;GAC7B;CACF;;AAED;EACE,wBAAwB;EACxB,WAAW;CACZ;;AAED;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,aAAa;CACd;;AAED;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,oBAAoB;MAChB,gBAAgB;EACpB,SAAS;CACV;;AAED;EACE,oBAAoB;EACpB,6BAA6B;CAC9B;;AAED;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,SAAS;EACT,oBAAoB;MAChB,gBAAgB;CACrB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,SAAS;CACV;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,SAAS;EACT,kBAAkB;CACnB;;AAED;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;CACtB;;AAED,gBAAgB;;AAEhB;EACE;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;IACxB,6BAA6B;GAC9B;;EAED;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;GAC9B;;EAED;IACE,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;GAC9B;;EAED;IACE,gCAAgC;GACjC;;EAED;IACE,4BAA4B;IAC5B,2BAA2B;GAC5B;;EAED;IACE,4BAA4B;GAC7B;;EAED,kBAAkB;EAClB;IACE,oBAAoB;GACrB;;EAED,wBAAwB;EACxB;IACE,uBAAuB;GACxB;;EAED;IACE,oCAAoC;IACpC,uBAAuB;GACxB;;EAED;IACE,kBAAkB;GACnB;;EAED;IACE,4BAA4B;GAC7B;;EAED;IACE,SAAS;GACV;;EAED;IACE,YAAY;GACb;;EAED;IACE,YAAY;IACZ,sBAAsB;QAClB,mBAAmB;YACf,0BAA0B;IAClC,eAAe;GAChB;;EAED;IACE,yBAAyB;GAC1B;;EAED;IACE,yBAAyB,EAAE,gBAAgB;GAC5C;CACF","file":"diary-form-button.css","sourcesContent":[".button {\n  margin: 0 4px;\n  text-transform: none;\n}\n\n.button:first-child {\n  margin-left: 0;\n}\n\n.button:last-child {\n  margin-right: 0;\n}\n\n.error_msg {\n  font-size: 80%;\n  color: red;\n}\n\n.save_msg {\n  font-size: 80%;\n  color: green;\n}\n\n.save_button {\n  padding: 0 12px 0 6px;\n}\n\n.dropdown .field {\n  padding: 3px 0px;\n}\n\n.dropdown .value {\n  background: #FFF;\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, .12);\n  padding: 6px 8px;\n}\n\n.dropdown .value::after {\n  right: unset!important;\n  margin-left: 14px;\n  border-top: 5.48571px solid rgba(0, 0, 0, .9)!important;\n}\n\n.circle {\n  display: inline-block;\n  width: 8px;\n  height:8px;\n  background-color: red;\n  border-radius: 50%;\n  -webkit-animation: pulse 2s infinite ease-in-out;\n          animation: pulse 2s infinite ease-in-out;\n  opacity: 0.6;\n}\n\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    -webkit-transform: scale(1.5);\n            transform: scale(1.5);\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    -webkit-transform: scale(1.5);\n            transform: scale(1.5);\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n\n.reviewCard {\n  margin: 8px 8px 8px 8px;\n  width: 80%;\n}\n\n.reviewFooter {\n  background: #f4f4f4;\n  font-size: 14px;\n  min-height: 40px;\n  height: auto;\n  padding: 8px;\n}\n\n.reviewFooterContent {\n  font-weight: bold;\n  font-size: 10px;\n  margin-top: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 8px;\n}\n\n.warningFooter {\n  background: #f4f4f4;\n  padding: 4px 12px !important;\n}\n\n.warningContent {\n  font-weight: bold;\n  font-size: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.warningTextGroup {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n}\n\n.warningActionGroup {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.settingsIcon {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n/* スマホ対応のスタイル */\n\n@media screen and (max-width: 600px) {\n  .button {\n    margin: 0 2px !important;\n    font-size: 12px !important;\n    padding: 0 4px !important;\n    min-width: auto !important;\n    height: 32px !important;\n    line-height: 32px !important;\n  }\n\n  .button .material-icons {\n    font-size: 16px !important;\n    width: 16px !important;\n    height: 16px !important;\n    margin-right: 3px !important;\n  }\n\n  .button img {\n    width: 16px !important;\n    height: 16px !important;\n    margin-right: 3px !important;\n  }\n\n  .save_button {\n    padding: 0 6px 0 3px !important;\n  }\n\n  .dropdown .value {\n    padding: 4px 6px !important;\n    font-size: 12px !important;\n  }\n\n  .dropdown .value::after {\n    margin-left: 6px !important;\n  }\n\n  /* フレックスコンテナの調整 */\n  div[style*=\"display: flex\"] {\n    gap: 2px !important;\n  }\n\n  /* AIレビューボタンが無効時の幅も調整 */\n  .button[disabled] {\n    width: auto !important;\n  }\n\n  .reviewCard {\n    width: calc(100% - 16px) !important;\n    margin: 8px !important;\n  }\n\n  .reviewFooter {\n    padding: 12px 8px;\n  }\n\n  .warningFooter {\n    padding: 4px 8px !important;\n  }\n\n  .warningContent {\n    gap: 4px;\n  }\n\n  .warningTextGroup {\n    width: 100%;\n  }\n\n  .warningActionGroup {\n    width: 100%;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    margin-left: 0;\n  }\n\n  .warningActionGroup [data-react-toolbox=\"button\"] {\n    display: none !important;\n  }\n\n  .settingsIcon {\n    display: none !important;  /* 設定アイコンを非表示 */\n  }\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"button": "diary-form-button--button--1ET_eDcb",
	"error_msg": "diary-form-button--error_msg--2bEmTlMW",
	"save_msg": "diary-form-button--save_msg--3B6HbQZL",
	"save_button": "diary-form-button--save_button--1DXY_I_8",
	"dropdown": "diary-form-button--dropdown--eyhnzZaF",
	"field": "diary-form-button--field--2rJ_jACR",
	"value": "diary-form-button--value--Zs-kMjy-",
	"circle": "diary-form-button--circle--132Cmx7B",
	"pulse": "diary-form-button--pulse--31W1h5cd",
	"reviewCard": "diary-form-button--reviewCard--2tPIhBcF",
	"reviewFooter": "diary-form-button--reviewFooter--2d8Lg2gj",
	"reviewFooterContent": "diary-form-button--reviewFooterContent--3nihenca",
	"warningFooter": "diary-form-button--warningFooter--XqRh9LBy",
	"warningContent": "diary-form-button--warningContent--f0vj591I",
	"warningTextGroup": "diary-form-button--warningTextGroup--1g8prh4e",
	"warningActionGroup": "diary-form-button--warningActionGroup--1dz6nczS",
	"settingsIcon": "diary-form-button--settingsIcon--3dXVAYmk",
	"material-icons": "diary-form-button--material-icons--oiVT4lEz"
};

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-report-graph.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHighcharts = __webpack_require__(387);

var _reactHighcharts2 = _interopRequireDefault(_reactHighcharts);

var _reactCssThemr = __webpack_require__(10);

var _button = __webpack_require__(8);

var _diaryReportGraph = __webpack_require__(2519);

var _diaryReportGraph2 = _interopRequireDefault(_diaryReportGraph);

var _diaryReport = __webpack_require__(1050);

var _diaryReport2 = _interopRequireDefault(_diaryReport);

var _eventEmitter = __webpack_require__(1051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiaryReportGraph = (_dec = (0, _reactCssThemr.themr)('DiaryReportGraph', _diaryReport2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryReportGraph, _React$Component);

  function DiaryReportGraph() {
    _classCallCheck(this, DiaryReportGraph);

    return _possibleConstructorReturn(this, (DiaryReportGraph.__proto__ || Object.getPrototypeOf(DiaryReportGraph)).apply(this, arguments));
  }

  _createClass(DiaryReportGraph, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          group = _props.group,
          diary = _props.diary,
          user = _props.user,
          attach_json = _props.attach_json,
          openGroupSettingsPage = _props.openGroupSettingsPage,
          openReportStatusPage = _props.openReportStatusPage;


      if (!attach_json) return null;

      var report_data = attach_json.report_data;

      if (!report_data || Object.keys(report_data) == 0) return null;

      var graph_data = report_data.graph_data;

      if (!graph_data || Object.keys(graph_data) == 0) return null;

      var membership = user.group_memberships.find(function (membership) {
        return membership.group_id === group.group_id;
      });
      var isGroupAdmin = membership ? membership.admin : false;

      return _react2.default.createElement(
        'div',
        { className: theme.report },
        _react2.default.createElement(
          'div',
          {
            style: { marginLeft: '20px', marginRight: '20px', paddingLeft: '20px', paddingRight: '20px', width: '100%' } },
          _react2.default.createElement(_reactHighcharts2.default, { config: graph_data })
        ),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: '20px', marginBottom: '20px' } },
          group && group.group_id && !diary.group && isGroupAdmin && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_button.Button, { key: 1, raised: true, onClick: openGroupSettingsPage, icon: 'edit', style: { marginRight: '10px', marginBottom: '20px' }, label: t('label:設定') }),
            _react2.default.createElement(_button.Button, { key: 2, raised: true, onClick: function onClick() {
                openReportStatusPage();
                setTimeout(function () {
                  var emitted = _eventEmitter.eventEmitter.emit("updateShowDownloadState", { showDownload: true });
                }, 500); // Adjust the delay as needed
              },
              icon: 'check_box',
              style: { marginRight: '10px', marginBottom: '20px' },
              label: t('label:提出状況')
            })
          )
        )
      );
    }
  }]);

  return DiaryReportGraph;
}(_react2.default.Component)) || _class);
exports.default = (0, _diaryReportGraph2.default)(DiaryReportGraph);

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/group-nav.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var params = {
    group_id: ownProps.group.group_id,
    group: ownProps.group
  };

  return {
    openGroupSettingsPage: function openGroupSettingsPage() {
      return dispatch(_actions2.default.openGroupSettingsPage('report'));
    },
    openReportStatusPage: function openReportStatusPage() {
      return dispatch(_actions2.default.openRightSidePage('report_status', params));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: { searchDrawer: false } }), (0, _reactI18next.translate)(), _lifecycle2.default);

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "[class^=\"one-column-layout\"],\n[class*=\" one-column-layout\"] .diary-report--report--1wQkXIux {\n  display: inline-block;\n  width: calc(50% - 10px);\n  min-width: 500px;\n  margin: 5px;\n}\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .diary-report--report--1wQkXIux {\n  display: inline-block;\n  width: calc(100% - 10px);\n  margin: 5px;\n}\n.diary-report--clickable--1yXlD74p {\n  cursor: pointer;\n}\n.diary-report--title--2wWmzE8S {\n  margin: 5px 0;\n  font-size: 14px;\n  font-weight: bold;\n  color: #303f9f;\n}\n.diary-report--title--2wWmzE8S:hover {\n  color: #303f9f;\n  opacity: 0.8;\n  text-decoration: underline;\n}\n.diary-report--rows--2f5aYyR2 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  border-radius: 3px;\n  border: solid 1px #EEE;\n  background: #FFF;\n  font-size: 14px;\n}\n.diary-report--row--GdOiBX3G {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px;\n  margin: 0 5px;\n  border-top: solid 1px #EEE;\n  min-width: 50px\n}\n.diary-report--row--GdOiBX3G:first-child {\n  border-top: 0;\n  border-top: initial;\n}\n.diary-report--label--isbaRkF0 {\n  color: #444;\n  min-width: 50px;\n}\n.diary-report--value--3L4OnK4R {\n  margin-left: auto;\n}\n.diary-report--number--3R5F3Mpc {\n  font-weight: bold;\n  font-size: 105%;\n}\n.diary-report--unit--1kpDYmZI {\n  font-size: 90%;\n  color: #666;\n}\n.diary-report--achieved--BffF7QHc {\n  background: red;\n  padding: 4px;\n  border-radius: 3px;\n  color: #FFF;\n  font-size: 50%;\n  margin: 0 4px;\n}\n.diary-report--input--2ai92b8D {\n  font-size: 14px;\n  text-align: right;\n  border: none;\n  margin-left: auto;\n  background: rgba(0, 0, 0, .1);\n  padding: 0 5px;\n}\n.diary-report--input--2ai92b8D:focus {\n  outline: none;\n  border-bottom: solid 2px rgb(48, 63, 159);\n}\n.diary-report--error--1wAcZ5SM {\n  background: rgba(255, 0, 0, .1);\n  border-bottom: solid 2px rgba(255, 0, 0, 1)!important;\n}\n.diary-report--error--1wAcZ5SM::-webkit-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n.diary-report--error--1wAcZ5SM:-ms-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n.diary-report--error--1wAcZ5SM::placeholder {\n  color: red;\n  font-size: 80%;\n}\n/* モバイル対応の追加 */\n@media screen and (max-width: 600px) {\n  [class^=\"one-column-layout\"] .diary-report--report--1wQkXIux,\n  [class*=\" one-column-layout\"] .diary-report--report--1wQkXIux,\n  [class^=\"two-column-layout\"] .diary-report--report--1wQkXIux,\n  [class*=\" two-column-layout\"] .diary-report--report--1wQkXIux {\n    width: 100% !important;\n    min-width: 0 !important;\n    margin: 10px 0 !important;\n    padding: 10px !important;\n  }\n\n  .diary-report--report--1wQkXIux {\n    margin: 10px 0 !important;\n    padding: 10px !important;\n  }\n\n  .diary-report--report--1wQkXIux > div:first-child {\n    font-size: 18px !important;\n    margin-bottom: 15px !important;\n  }\n\n  .diary-report--report--1wQkXIux > div:nth-child(2) {\n    font-size: 16px !important;\n  }\n\n  .diary-report--report--1wQkXIux > div:nth-child(n+4) {\n    font-size: 12px !important;\n    margin-top: 8px !important;\n  }\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/diary-report.css"],"names":[],"mappings":"AAAA;;EAEE,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;CACb;AACD;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;CACb;AACD;EACE,gBAAgB;CACjB;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;CAChB;AACD;EACE,eAAe;EACf,aAAa;EACb,2BAA2B;CAC5B;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,eAAe;CAChB;AACD;EACE,cAAc;EACd,oBAAoB;CACrB;AACD;EACE,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,eAAe;EACf,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;CAChB;AACD;EACE,cAAc;EACd,0CAA0C;CAC3C;AACD;EACE,gCAAgC;EAChC,sDAAsD;CACvD;AACD;EACE,WAAW;EACX,eAAe;CAChB;AACD;EACE,WAAW;EACX,eAAe;CAChB;AACD;EACE,WAAW;EACX,eAAe;CAChB;AACD,eAAe;AACf;EACE;;;;IAIE,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,yBAAyB;GAC1B;;EAED;IACE,0BAA0B;IAC1B,yBAAyB;GAC1B;;EAED;IACE,2BAA2B;IAC3B,+BAA+B;GAChC;;EAED;IACE,2BAA2B;GAC5B;;EAED;IACE,2BAA2B;IAC3B,2BAA2B;GAC5B;CACF","file":"diary-report.css","sourcesContent":["[class^=\"one-column-layout\"],\n[class*=\" one-column-layout\"] .report {\n  display: inline-block;\n  width: calc(50% - 10px);\n  min-width: 500px;\n  margin: 5px;\n}\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .report {\n  display: inline-block;\n  width: calc(100% - 10px);\n  margin: 5px;\n}\n.clickable {\n  cursor: pointer;\n}\n.title {\n  margin: 5px 0;\n  font-size: 14px;\n  font-weight: bold;\n  color: #303f9f;\n}\n.title:hover {\n  color: #303f9f;\n  opacity: 0.8;\n  text-decoration: underline;\n}\n.rows {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  border-radius: 3px;\n  border: solid 1px #EEE;\n  background: #FFF;\n  font-size: 14px;\n}\n.row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px;\n  margin: 0 5px;\n  border-top: solid 1px #EEE;\n  min-width: 50px\n}\n.row:first-child {\n  border-top: 0;\n  border-top: initial;\n}\n.label {\n  color: #444;\n  min-width: 50px;\n}\n.value {\n  margin-left: auto;\n}\n.number {\n  font-weight: bold;\n  font-size: 105%;\n}\n.unit {\n  font-size: 90%;\n  color: #666;\n}\n.achieved {\n  background: red;\n  padding: 4px;\n  border-radius: 3px;\n  color: #FFF;\n  font-size: 50%;\n  margin: 0 4px;\n}\n.input {\n  font-size: 14px;\n  text-align: right;\n  border: none;\n  margin-left: auto;\n  background: rgba(0, 0, 0, .1);\n  padding: 0 5px;\n}\n.input:focus {\n  outline: none;\n  border-bottom: solid 2px rgb(48, 63, 159);\n}\n.error {\n  background: rgba(255, 0, 0, .1);\n  border-bottom: solid 2px rgba(255, 0, 0, 1)!important;\n}\n.error::-webkit-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n.error:-ms-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n.error::placeholder {\n  color: red;\n  font-size: 80%;\n}\n/* モバイル対応の追加 */\n@media screen and (max-width: 600px) {\n  [class^=\"one-column-layout\"] .report,\n  [class*=\" one-column-layout\"] .report,\n  [class^=\"two-column-layout\"] .report,\n  [class*=\" two-column-layout\"] .report {\n    width: 100% !important;\n    min-width: 0 !important;\n    margin: 10px 0 !important;\n    padding: 10px !important;\n  }\n\n  .report {\n    margin: 10px 0 !important;\n    padding: 10px !important;\n  }\n\n  .report > div:first-child {\n    font-size: 18px !important;\n    margin-bottom: 15px !important;\n  }\n\n  .report > div:nth-child(2) {\n    font-size: 16px !important;\n  }\n\n  .report > div:nth-child(n+4) {\n    font-size: 12px !important;\n    margin-top: 8px !important;\n  }\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"report": "diary-report--report--1wQkXIux",
	"clickable": "diary-report--clickable--1yXlD74p",
	"title": "diary-report--title--2wWmzE8S",
	"rows": "diary-report--rows--2f5aYyR2",
	"row": "diary-report--row--GdOiBX3G",
	"label": "diary-report--label--isbaRkF0",
	"value": "diary-report--value--3L4OnK4R",
	"number": "diary-report--number--3R5F3Mpc",
	"unit": "diary-report--unit--1kpDYmZI",
	"achieved": "diary-report--achieved--BffF7QHc",
	"input": "diary-report--input--2ai92b8D",
	"error": "diary-report--error--1wAcZ5SM"
};

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // src/web/components/diary-report-active-user-bar.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _reactCssThemr = __webpack_require__(10);

var _diaryReport = __webpack_require__(1050);

var _diaryReport2 = _interopRequireDefault(_diaryReport);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _diaryReportActiveUserBar = __webpack_require__(2522);

var _diaryReportActiveUserBar2 = _interopRequireDefault(_diaryReportActiveUserBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiaryReportActiveUserBar = (_dec = (0, _reactCssThemr.themr)('DiaryReportActiveUserBar', _diaryReport2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryReportActiveUserBar, _React$Component);

  function DiaryReportActiveUserBar() {
    _classCallCheck(this, DiaryReportActiveUserBar);

    return _possibleConstructorReturn(this, (DiaryReportActiveUserBar.__proto__ || Object.getPrototypeOf(DiaryReportActiveUserBar)).apply(this, arguments));
  }

  _createClass(DiaryReportActiveUserBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          attach_json = _props.attach_json,
          group = _props.group,
          diary = _props.diary,
          lang = _props.lang,
          openReportStatusPage = _props.openReportStatusPage;


      if (!attach_json) return null;

      var report_data = attach_json.report_data;

      if (!report_data || Object.keys(report_data).length === 0) return null;

      var active_user_bar_data = report_data.active_user_bar_data;

      if (!active_user_bar_data || Object.keys(active_user_bar_data).length === 0) return null;

      var isNewTemplate = Object.keys(active_user_bar_data).includes('posts');

      if (isNewTemplate) {
        var subject = t('label:report_subject', {
          month: (0, _moment2.default)(diary.created_at).format(t('format:month')),
          group_name: group.name
        });

        var collectionDate = t('label:report_collection', {
          start_date: active_user_bar_data.collection_start_date,
          end_date: active_user_bar_data.collection_end_date
        });

        return _react2.default.createElement(
          'div',
          { className: theme.report, style: { margin: '20px', paddingLeft: '20px', paddingRight: '20px' } },
          _react2.default.createElement(
            'div',
            { style: { fontSize: '14px', fontWeight: 'bold', marginBottom: '20px' } },
            subject,
            ' ',
            _react2.default.createElement('br', null),
            collectionDate
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '20px', fontSize: '14px' } },
            lang === 'en' ? _react2.default.createElement(
              'span',
              null,
              '\u30FBPlease see',
              _react2.default.createElement(
                'a',
                {
                  onClick: function onClick() {
                    openReportStatusPage();
                  },
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  style: { color: 'blue', margin: '0 4px', textDecoration: 'underline', cursor: 'pointer' }
                },
                'here'
              ),
              'for the specific submission status.'
            ) : _react2.default.createElement(
              'span',
              null,
              '\u30FB\u5177\u4F53\u7684\u306A\u63D0\u51FA\u72B6\u6CC1\u306F',
              _react2.default.createElement(
                'a',
                {
                  onClick: function onClick() {
                    openReportStatusPage();
                  },
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  style: { color: 'blue', textDecoration: 'underline', cursor: 'pointer' }
                },
                '\u3053\u3061\u3089'
              ),
              '\u304B\u3089\u3054\u89A7\u304F\u3060\u3055\u3044\u3002'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { fontSize: '14px' } },
            lang === 'en' ? _react2.default.createElement(
              'span',
              null,
              '\u30FBPlease refer to',
              _react2.default.createElement(
                'a',
                {
                  href: 'https://support.getgamba.com/hc/ja/articles/15569764486553-%E6%97%A5%E5%A0%B1%E3%81%AE%E6%8F%90%E5%87%BA%E4%BA%88%E5%AE%9A%E6%97%A5%E3%82%92%E7%99%BB%E9%8C%B2%E3%81%99%E3%82%8B',
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  style: { color: 'blue', margin: '0 4px' }
                },
                'this user guide'
              ),
              'for instructions on how to set the planned submission date.'
            ) : _react2.default.createElement(
              'span',
              null,
              '\u30FB\u63D0\u51FA\u4E88\u5B9A\u65E5\u306E\u8A2D\u5B9A\u65B9\u6CD5\u306F',
              _react2.default.createElement(
                'a',
                {
                  href: 'https://support.getgamba.com/hc/ja/articles/15569764486553-%E6%97%A5%E5%A0%B1%E3%81%AE%E6%8F%90%E5%87%BA%E4%BA%88%E5%AE%9A%E6%97%A5%E3%82%92%E7%99%BB%E9%8C%B2%E3%81%99%E3%82%8B',
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  style: { color: 'blue' }
                },
                '\u3053\u3061\u3089\u306E\u4F7F\u3044\u65B9\u30AC\u30A4\u30C9'
              ),
              '\u3092\u3054\u89A7\u4E0B\u3055\u3044\u3002'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { fontSize: '14px' } },
            '\u30FB',
            t('label:gamba!にご相談')
          ),
          _react2.default.createElement(
            'div',
            { style: { fontSize: '14px' } },
            t('label:ご予約はこちら'),
            ':',
            _react2.default.createElement(
              'a',
              {
                href: 'https://meetings.hubspot.com/na-yamada/meeting',
                target: '_blank',
                rel: 'noopener noreferrer',
                style: { color: 'blue' }
              },
              t('label:gamba!活用サポート予約窓口')
            )
          )
        );
      } else {
        var before_active_user_percentage = active_user_bar_data.before_active_user_percentage,
            active_user_percentage = active_user_bar_data.active_user_percentage,
            response_kind = active_user_bar_data.response_kind,
            response_change_amount = active_user_bar_data.response_change_amount;


        var report_message = '';
        if (active_user_percentage === 0) {
          report_message = t('label:日報の提出数がなし');
        } else if (active_user_percentage >= 90) {
          report_message = t('label:日報の提出数が90%以上');
        } else if (before_active_user_percentage <= active_user_percentage) {
          report_message = t('label:日報の提出数が増加');
        } else {
          report_message = t('label:日報の提出数が減少');
        }

        var response_kind_message = response_kind === 'nothing' ? t('label:レスポンスなし') : response_kind === 'like_only' ? t('label:レスポンスいいねのみ') : '';

        var response_change_amount_message = response_change_amount === 'up' ? t('label:レスポンス量増加') : response_change_amount === 'down' ? t('label:レスポンス量減少') : '';

        var _subject = report_data.interval === 'monthly' ? t('label:月間レポート') : t('label:週間レポート');

        return _react2.default.createElement(
          'div',
          { className: theme.report, style: { margin: '20px', paddingLeft: '20px', paddingRight: '20px' } },
          _react2.default.createElement(
            'div',
            { style: { fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' } },
            _subject
          ),
          _react2.default.createElement(
            'div',
            {
              style: {
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '20px',
                fontWeight: 'bold',
                marginBottom: '20px'
              }
            },
            _react2.default.createElement(
              'div',
              null,
              '\u63D0\u51FA\u7387'
            ),
            _react2.default.createElement(
              'div',
              null,
              active_user_percentage,
              '\uFF05'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: { backgroundColor: '#3C82F6', height: '10px', width: '100%', borderRadius: '5px' } },
              _react2.default.createElement('div', {
                style: {
                  backgroundColor: '#1C4ED8',
                  height: '10px',
                  width: active_user_percentage + '%',
                  borderRadius: '5px'
                }
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '10px', fontSize: '14px' } },
            report_message
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '10px', fontSize: '14px' } },
            response_kind_message
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '10px', fontSize: '14px' } },
            response_change_amount_message
          )
        );
      }
    }
  }]);

  return DiaryReportActiveUserBar;
}(_react2.default.Component)) || _class);
exports.default = (0, _diaryReportActiveUserBar2.default)(DiaryReportActiveUserBar);

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/group-nav.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var params = {
    group_id: ownProps.group.group_id,
    group: ownProps.group
  };

  return {
    openReportStatusPage: function openReportStatusPage() {
      return dispatch(_actions2.default.openRightSidePage('report_status', params));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: { searchDrawer: false } }), (0, _reactI18next.translate)(), _lifecycle2.default);

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDiaryKPI = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-kpi.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _diaryKpi = __webpack_require__(2524);

var _diaryKpi2 = _interopRequireDefault(_diaryKpi);

var _reactCssThemr = __webpack_require__(10);

var _button = __webpack_require__(8);

var _diaryKpi3 = __webpack_require__(564);

var _diaryKpi4 = _interopRequireDefault(_diaryKpi3);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _formatNumber = __webpack_require__(201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Row(props) {
  var t = props.t,
      theme = props.theme,
      label = props.label,
      value = props.value,
      isPercent = props.isPercent,
      format = props.format,
      unit = props.unit;


  return _react2.default.createElement(
    'div',
    { className: theme.row },
    _react2.default.createElement(
      'div',
      { className: theme.label },
      label
    ),
    _react2.default.createElement(
      'div',
      { className: theme.value },
      !isPercent && _react2.default.createElement(
        'span',
        null,
        format.prepend_unit && _react2.default.createElement(
          'span',
          { className: theme.unit },
          unit
        ),
        _react2.default.createElement(
          'span',
          { className: theme.number },
          (0, _formatNumber.formatNumber)(value, format)
        ),
        !format.prepend_unit && _react2.default.createElement(
          'span',
          { className: theme.unit },
          unit
        )
      ),
      isPercent && value >= 1.0 && isFinite(value) && _react2.default.createElement(
        'span',
        { className: theme.achieved },
        t('label:達成')
      ),
      isPercent && _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { className: theme.number },
          (0, _formatNumber.percent)(value)
        ),
        _react2.default.createElement(
          'span',
          { className: theme.unit },
          '%'
        )
      )
    )
  );
}

var DiaryKPI = (_dec = (0, _reactCssThemr.themr)('DiaryKPI', _diaryKpi4.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryKPI, _React$Component);

  function DiaryKPI() {
    _classCallCheck(this, DiaryKPI);

    return _possibleConstructorReturn(this, (DiaryKPI.__proto__ || Object.getPrototypeOf(DiaryKPI)).apply(this, arguments));
  }

  _createClass(DiaryKPI, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          kpi = _props.kpi,
          group = _props.group,
          showKpi = _props.showKpi,
          isRightSidePage = _props.isRightSidePage;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(theme.kpi, theme.clickable), onClick: showKpi },
        _react2.default.createElement(
          'h3',
          { className: theme.title },
          kpi.name,
          _react2.default.createElement(_button.IconButton, { icon: 'arrow_forward' })
        ),
        _react2.default.createElement(
          'div',
          { className: theme.rows },
          _react2.default.createElement(Row, { theme: theme, label: t('label:目標'), value: kpi.target, format: kpi.display_format, unit: kpi.unit }),
          _react2.default.createElement(Row, { theme: theme, label: t('label:実績'), value: kpi.actual, format: kpi.display_format, unit: kpi.unit }),
          typeof kpi.total != 'undefined' && _react2.default.createElement(Row, { theme: theme, label: t('label:累計'), value: kpi.total, format: kpi.display_format, unit: kpi.unit }),
          _react2.default.createElement(Row, { t: t, theme: theme, label: t('label:達成率'), value: (kpi.total || kpi.actual) / kpi.target, isPercent: true })
        )
      );
    }
  }]);

  return DiaryKPI;
}(_react2.default.Component)) || _class);
var RawDiaryKPI = exports.RawDiaryKPI = DiaryKPI;
exports.default = (0, _diaryKpi2.default)(DiaryKPI);

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _route = __webpack_require__(67);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isPhone: state.media.isPhone
  };
};
// src/connects/diary-kpi.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    showKpi: function showKpi() {
      return dispatch(_actions2.default.openRightSidePage('kpi_chart', { group_id: ownProps.kpi.group_id, kpi_id: ownProps.kpi.kpi_id }));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "[class^=\"one-column-layout\"],\n[class*=\" one-column-layout\"] .diary-kpi--kpi--1kfaxpJT {\n  display: inline-block;\n  width: calc(50% - 10px);\n  margin: 5px;\n}\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .diary-kpi--kpi--1kfaxpJT {\n  display: inline-block;\n  width: calc(100% - 10px);\n  margin: 5px;\n}\n.diary-kpi--clickable--Cf9i3NWB {\n  cursor: pointer;\n}\n@media screen and (max-width: 600px) {\n  [class^=\"one-column-layout\"] .diary-kpi--kpi--1kfaxpJT,\n  [class*=\" one-column-layout\"] .diary-kpi--kpi--1kfaxpJT {\n    width: calc(100% - 10px) !important;\n  }\n}\n.diary-kpi--title--3UKwZAVf {\n  margin: 5px 0;\n  font-size: 14px;\n  font-weight: bold;\n  color: #303f9f;\n}\n.diary-kpi--title--3UKwZAVf:hover {\n  color: #303f9f;\n  opacity: 0.8;\n  text-decoration: underline;\n}\n.diary-kpi--rows--1OXMabwy {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  border-radius: 3px;\n  border: solid 1px #EEE;\n  background: #FFF;\n  font-size: 14px;\n}\n.diary-kpi--row--SDJ1NhmC {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px;\n  margin: 0 5px;\n  border-top: solid 1px #EEE;\n  min-width: 50px\n}\n.diary-kpi--row--SDJ1NhmC:first-child {\n  border-top: 0;\n  border-top: initial;\n}\n.diary-kpi--label--1Ye5PVVG {\n  color: #444;\n  min-width: 50px;\n}\n.diary-kpi--value--3m0X9abl {\n  margin-left: auto;\n}\n.diary-kpi--number--1z3tp55f {\n  font-weight: bold;\n  font-size: 105%;\n}\n.diary-kpi--unit--1-PWTxw3 {\n  font-size: 90%;\n  color: #666;\n}\n.diary-kpi--achieved--3FeGQpIr {\n  background: red;\n  padding: 4px;\n  border-radius: 3px;\n  color: #FFF;\n  font-size: 50%;\n  margin: 0 4px;\n}\n.diary-kpi--input--179R6uLX {\n  font-size: 14px;\n  text-align: right;\n  border: none;\n  margin-left: auto;\n  background: rgba(0, 0, 0, .1);\n  padding: 0 5px;\n}\n.diary-kpi--input--179R6uLX:focus {\n  outline: none;\n  border-bottom: solid 2px rgb(48, 63, 159);\n}\n.diary-kpi--error--o7_sFm1M {\n  background: rgba(255, 0, 0, .1);\n  border-bottom: solid 2px rgba(255, 0, 0, 1)!important;\n}\n.diary-kpi--error--o7_sFm1M::-webkit-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n.diary-kpi--error--o7_sFm1M:-ms-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n.diary-kpi--error--o7_sFm1M::placeholder {\n  color: red;\n  font-size: 80%;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/diary-kpi.css"],"names":[],"mappings":"AAAA;;EAEE,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;CACb;AACD;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;CACb;AACD;EACE,gBAAgB;CACjB;AACD;EACE;;IAEE,oCAAoC;GACrC;CACF;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;CAChB;AACD;EACE,eAAe;EACf,aAAa;EACb,2BAA2B;CAC5B;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,eAAe;CAChB;AACD;EACE,cAAc;EACd,oBAAoB;CACrB;AACD;EACE,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,eAAe;EACf,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;CACf;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;CAChB;AACD;EACE,cAAc;EACd,0CAA0C;CAC3C;AACD;EACE,gCAAgC;EAChC,sDAAsD;CACvD;AACD;EACE,WAAW;EACX,eAAe;CAChB;AACD;EACE,WAAW;EACX,eAAe;CAChB;AACD;EACE,WAAW;EACX,eAAe;CAChB","file":"diary-kpi.css","sourcesContent":["[class^=\"one-column-layout\"],\n[class*=\" one-column-layout\"] .kpi {\n  display: inline-block;\n  width: calc(50% - 10px);\n  margin: 5px;\n}\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .kpi {\n  display: inline-block;\n  width: calc(100% - 10px);\n  margin: 5px;\n}\n.clickable {\n  cursor: pointer;\n}\n@media screen and (max-width: 600px) {\n  [class^=\"one-column-layout\"] .kpi,\n  [class*=\" one-column-layout\"] .kpi {\n    width: calc(100% - 10px) !important;\n  }\n}\n.title {\n  margin: 5px 0;\n  font-size: 14px;\n  font-weight: bold;\n  color: #303f9f;\n}\n.title:hover {\n  color: #303f9f;\n  opacity: 0.8;\n  text-decoration: underline;\n}\n.rows {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  border-radius: 3px;\n  border: solid 1px #EEE;\n  background: #FFF;\n  font-size: 14px;\n}\n.row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px;\n  margin: 0 5px;\n  border-top: solid 1px #EEE;\n  min-width: 50px\n}\n.row:first-child {\n  border-top: 0;\n  border-top: initial;\n}\n.label {\n  color: #444;\n  min-width: 50px;\n}\n.value {\n  margin-left: auto;\n}\n.number {\n  font-weight: bold;\n  font-size: 105%;\n}\n.unit {\n  font-size: 90%;\n  color: #666;\n}\n.achieved {\n  background: red;\n  padding: 4px;\n  border-radius: 3px;\n  color: #FFF;\n  font-size: 50%;\n  margin: 0 4px;\n}\n.input {\n  font-size: 14px;\n  text-align: right;\n  border: none;\n  margin-left: auto;\n  background: rgba(0, 0, 0, .1);\n  padding: 0 5px;\n}\n.input:focus {\n  outline: none;\n  border-bottom: solid 2px rgb(48, 63, 159);\n}\n.error {\n  background: rgba(255, 0, 0, .1);\n  border-bottom: solid 2px rgba(255, 0, 0, 1)!important;\n}\n.error::-webkit-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n.error:-ms-input-placeholder {\n  color: red;\n  font-size: 80%;\n}\n.error::placeholder {\n  color: red;\n  font-size: 80%;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"kpi": "diary-kpi--kpi--1kfaxpJT",
	"clickable": "diary-kpi--clickable--Cf9i3NWB",
	"title": "diary-kpi--title--3UKwZAVf",
	"rows": "diary-kpi--rows--1OXMabwy",
	"row": "diary-kpi--row--SDJ1NhmC",
	"label": "diary-kpi--label--1Ye5PVVG",
	"value": "diary-kpi--value--3m0X9abl",
	"number": "diary-kpi--number--1z3tp55f",
	"unit": "diary-kpi--unit--1-PWTxw3",
	"achieved": "diary-kpi--achieved--3FeGQpIr",
	"input": "diary-kpi--input--179R6uLX",
	"error": "diary-kpi--error--o7_sFm1M"
};

/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _route = __webpack_require__(67);

var _reactRedux = __webpack_require__(11);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
* src/connects/diary-content.js
* 
*/

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showGoogleDoc: function showGoogleDoc(url) {
      dispatch(_actions2.default.openRightSidePage('google_doc', { url: url }, true));
    },

    openGambaURL: function openGambaURL(url) {
      var paths = url.replace(/^.+groups\//, '').split('/');
      var kpi_id, diary_id, chat_room_id, match;
      var group_id = parseInt(paths[0]);
      if (paths.length == 2 && paths[1] == 'timeline') {
        (0, _route.pushRoute)('group_timeline', { group_id: group_id });
      } else if (paths.length == 1 && paths[0] == 'home') {
        (0, _route.pushRoute)('home_group');
      } else if (paths.length == 4 && paths[2] == 'kpi_chart') {
        kpi_id = parseInt(paths[3]);
        dispatch(_actions2.default.openRightSidePage('kpi_chart', { group_id: group_id, kpi_id: kpi_id }));
      } else if (paths.length == 3 && (match = paths[2].match(/^pickup\?diary_ids=([0-9]+)$/)) || paths.length == 2 && (match = paths[1].match(/^pickup\?diary_ids=([0-9]+)$/))) {
        diary_id = parseInt(match[1]);
        dispatch(_actions2.default.openRightSidePage('pickup_diaries', { diary_ids: [diary_id] }));
      } else if (paths.length == 3 && paths[1] == 'messages') {
        chat_room_id = parseInt(paths[2]);
        dispatch(_actions2.default.openRightSidePage('chat_messages', { chat_room_id: chat_room_id }));
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(undefined, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @author Félix Girault <felix.girault@gmail.com>
 * @license MIT
 */


var warning = __webpack_require__(104);
var shallowEqual = __webpack_require__(2528);



/**
 * Tells if a component should update given it's next props
 * and state.
 *
 * @param object nextProps Next props.
 * @param object nextState Next state.
 */
function shouldComponentUpdate(nextProps, nextState) {
  return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
}

/**
 * Returns a text description of the component that can be
 * used to identify it in error messages.
 *
 * @see https://github.com/facebook/react/blob/v15.4.0-rc.3/src/renderers/shared/stack/reconciler/ReactCompositeComponent.js#L1143
 * @param {function} component The component.
 * @return {string} The name of the component.
 */
function getComponentName(component) {
  var constructor = component.prototype && component.prototype.constructor;

  return (
    component.displayName
    || (constructor && constructor.displayName)
    || component.name
    || (constructor && constructor.name)
    || 'a component'
  );
}

/**
 * Makes the given component "pure".
 *
 * @param object component Component.
 */
function pureRenderDecorator(component) {
  if (component.prototype.shouldComponentUpdate !== undefined) {
    // We're not using the condition mecanism of warning()
    // here to avoid useless calls to getComponentName().
    warning(
      false,
      'Cannot decorate `%s` with @pureRenderDecorator, '
      + 'because it already implements `shouldComponentUpdate().',
      getComponentName(component)
    )
  }

  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
  return component;
}



module.exports = pureRenderDecorator;


/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2530);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./toggle-button.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./toggle-button.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.toggle-button--button--2nsDCg0v {\n  padding: 0 3px;\n  font-size: 12px;\n  line-height: 18px;\n  height: 36px;\n  color: #3f50b5!important;\n  min-width: 0;\n  min-width: initial;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.toggle-button--button--2nsDCg0v:hover {\n  color: #111;\n}\n\n.toggle-button--button--2nsDCg0v .toggle-button--icon--3EVxraFr {\n  font-size: 12px;\n  line-height: 18px!important;\n  height: 18px;\n}\n\n.toggle-button--button--2nsDCg0v[class~=fluid] {\n  width: 100%;\n  color: #3f50b5!important;\n  text-align: left;\n}\n\n.toggle-button--fontIcon--I3vdeC7X {\n  color: #666;\n  font-size: 18px;\n  line-height: 18px!important;\n  height: 18px;\n  padding-left: 5px;\n  margin-bottom: 2px;\n}\n\n.toggle-button--avatar--31pyrdIk {\n  height: 20px;\n  width: 20px;\n  margin-right: 8px!important;\n}", "", {"version":3,"sources":["/./src/web/components/themes/toggle-button.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;CACpB;;AAED;EACE,YAAY;CACb;;AAED;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;CACd;;AAED;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;CAClB;;AAED;EACE,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;CACpB;;AAED;EACE,aAAa;EACb,YAAY;EACZ,4BAA4B;CAC7B","file":"toggle-button.css","sourcesContent":["\n.button {\n  padding: 0 3px;\n  font-size: 12px;\n  line-height: 18px;\n  height: 36px;\n  color: #3f50b5!important;\n  min-width: 0;\n  min-width: initial;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.button:hover {\n  color: #111;\n}\n\n.button .icon {\n  font-size: 12px;\n  line-height: 18px!important;\n  height: 18px;\n}\n\n.button[class~=fluid] {\n  width: 100%;\n  color: #3f50b5!important;\n  text-align: left;\n}\n\n.fontIcon {\n  color: #666;\n  font-size: 18px;\n  line-height: 18px!important;\n  height: 18px;\n  padding-left: 5px;\n  margin-bottom: 2px;\n}\n\n.avatar {\n  height: 20px;\n  width: 20px;\n  margin-right: 8px!important;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"button": "toggle-button--button--2nsDCg0v",
	"icon": "toggle-button--icon--3EVxraFr",
	"fontIcon": "toggle-button--fontIcon--I3vdeC7X",
	"avatar": "toggle-button--avatar--31pyrdIk"
};

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _reactI18next = __webpack_require__(2);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/diary-attachments.js

function isImageVideo(file) {
  return file.content_type.match(/^image/) || file.content_type.match(/^video|audio/);
}

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willUpdate: function willUpdate(props, nextProps) {
      //添付ファイルの中に変動があった場合、処理を行う
      if (props.files.length != nextProps.files.length) {
        var imageVideos = _lodash2.default.filter(props.files, function (file) {
          return isImageVideo(file);
        });
        var nextImageVideos = _lodash2.default.filter(nextProps.files, function (file) {
          return isImageVideo(file);
        });
        //ui.imgindexの最後を閲覧した状態からそのファイルを削除した場合時に-1をしたものをimgIndexに渡す。
        if (nextImageVideos.length > 0 && imageVideos.length != nextImageVideos.length) {
          nextProps.updateUI({ imgIndex: 0 });
        }
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(undefined, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    imgIndex: 0,
    isVideo: false
  }
}), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".attachments--tooltip--34dhsbXv {\n  text-align: left;\n}\n\n.attachments--tooltipInner--UvsEB1L- {\n  background: #fdfdfd!important;\n  border: solid 1px #EEE;\n  border-radius: 3px;\n  color: #666!important;\n  width: 100%;\n  overflow: hidden;\n}\n\n.attachments--chip--2auAtT5G {\n  color: black;\n  margin: 5px;\n}\n\n.attachments--chipChat--22aVv1XV {\n  color: black;\n}\n\n.attachments--avatar--F4AmiW2s[class~=picture_as_pdf] {\n  background-color: red;\n}\n\n.attachments--avatar--F4AmiW2s[class~=audiotrack] {\n  background-color: blue;\n}\n\n.attachments--avatar--F4AmiW2s[class~=attach_file] {\n  background-color: green;\n}\n\n.attachments--link--2um-NzDd:not(:active) {\n  opacity: 0.7;\n}\n\n.attachments--link--2um-NzDd:hover,\n  .attachments--link--2um-NzDd:active {\n  opacity: 1;\n}\n\n.attachments--nav--1VI-FiM9 {\n  top: 0; bottom: 0; right: 0; left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 5px;\n}\n\n.attachments--navArea--eZO2uu-f {\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 40px;\n}\n\n.attachments--navNext--1y0iz6mZ {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n\n.attachments--navPrev--1meWwoHx {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.attachments--navArea--eZO2uu-f:hover {\n  background: rgba(0, 0, 0, .1);\n}\n\n.attachments--navAttachmentsArea--3DE5OO-i {\n  height: 100%;\n  width: 50%;\n  margin: 15px; \n}\n\n.attachments--navAttachmentsField--JaBtkzz3 {\n  max-width: 580px;\n  text-align: center;\n  margin: 0 auto 0 0;\n  background-color: #f3f0f0;\n}\n\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .attachments--navAttachmentsField--JaBtkzz3 {\n  max-width: 580px;\n  text-align: center;\n  margin: 0 auto;\n  background-color: #f3f0f0;\n}\n\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .attachments--navAttachmentsArea--3DE5OO-i {\n  position: relative;\n  overflow: hidden; \n  height: 100%;\n  width: 100%;\n  display: inline-block; \n  margin: 15px; \n  text-align: center;\n}\n\n.attachments--navAttachmentsCommentArea--19yVLRcJ {\n  position: relative;\n  overflow: hidden; \n  height: 100%;\n  width: 50%;\n  display: inline-block; \n  margin: 15px; \n  text-align: center;\n}\n\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .attachments--navAttachmentsCommentArea--19yVLRcJ {\n  position: relative;\n  overflow: hidden; \n  height: 100%;\n  width: 100%;\n  display: inline-block; \n  margin: 15px; \n  text-align: center;\n  background-color: #f3f0f0;\n}\n\n.attachments--navImage--1st0yZZo {\n  max-height: 250px;\n  max-width: 90%; \n  min-width: 100px;\n  min-height: 100px;\n  cursor: pointer; \n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%,-50%);\n          transform: translate(-50%,-50%);\n}\n\n.attachments--navAvatarArea--1pD2ne2p {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n\n.attachments--navSelectDots--6x0NtPN_ > span {\n  font-size: 10px!important;\n}\n\n.attachments--navNotSelectDots--cZQcvSRq > span {\n  font-size: 10px!important;\n  color: #a0a0a0;\n}\n\n.attachments--navChip--2FLtyPaQ {\n  position: absolute;\n  margin: 5px 0px 0px 10px;\n  color: rgb(0, 0, 0);\n  background:#f3f0f0;\n  top: 20%;\n  left: 0%;\n  transform: translate(0%, -200%);\n  -webkit-transform: translate(0%, -200%);\n  -ms-transform: translate(0%, -200%);\n}\n\n.attachments--fileName--2CFp95I5 {\n  position: absolute;\n  top: 0; \n  left: 0; \n  color: #EEE; \n  padding: 3px 20px; \n  background: rgba(0, 0, 0, .6);\n}\n\n.attachments--navDots--2xZ-nly4 {\n  list-style: 'none';\n  width: 100%;\n  padding: 0px; \n  margin: 5px; \n  text-align: center;\n}\n\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .attachments--navDots--2xZ-nly4 {\n  list-style: 'none';\n  width: 100%; \n  padding: 0px; \n  margin: 5px; \n  text-align: center;\n}\n\n/* モバイル用の調整を追加 */\n\n@media screen and (max-width: 600px) {\n  .attachments--navAttachmentsArea--3DE5OO-i,\n  .attachments--navAttachmentsCommentArea--19yVLRcJ {\n    width: 100% !important;\n    margin: 0 !important;\n  }\n\n  .attachments--navAttachmentsField--JaBtkzz3 {\n    width: 100% !important;\n    max-width: none !important;\n    margin: 0 !important;\n  }\n\n  .attachments--navImage--1st0yZZo {\n    max-width: 100% !important;\n    width: auto !important;\n    height: auto !important;\n    max-height: 100% !important;\n    padding: 10px !important;\n  }\n\n  div[style*=\"height: 280\"] {\n    height: auto !important;\n    min-height: 280px;\n    padding: 0 !important;\n  }\n}\n\n/* 2カラムレイアウト用 */\n\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .attachments--navImage--1st0yZZo {\n}\n\n@media screen and (max-width: 600px) {\n\n  [class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .attachments--navImage--1st0yZZo {\n    max-width: 100% !important;\n    width: auto !important;\n    height: auto !important;\n    padding: 10px !important;\n  }\n  }", "", {"version":3,"sources":["/./src/web/components/themes/attachments.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;CAClB;;AAED;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;CAClB;;AAED;EACE,aAAa;EACb,YAAY;CACb;;AAED;EACE,aAAa;CACd;;AAED;EACE,sBAAsB;CACvB;;AAED;EACE,uBAAuB;CACxB;;AAED;EACE,wBAAwB;CACzB;;AAED;EACE,aAAa;CACd;;AAED;;EAEE,WAAW;CACZ;;AAED;EACE,OAAO,CAAC,UAAU,CAAC,SAAS,CAAC,QAAQ;EACrC,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,aAAa;CACd;;AAED;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,YAAY;CACb;;AAED;EACE,uBAAuB;MACnB,oBAAoB;UAChB,sBAAsB;CAC/B;;AAED;EACE,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;CACjC;;AAED;EACE,8BAA8B;CAC/B;;AAED;EACE,aAAa;EACb,WAAW;EACX,aAAa;CACd;;AAED;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;CAC3B;;AAED;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;CAC3B;;AAED;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;CACpB;;AAED;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB;CACpB;;AAED;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;CAC3B;;AAED;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,wCAAwC;UAChC,gCAAgC;CACzC;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,sBAAsB;MAClB,mBAAmB;UACf,0BAA0B;CACnC;;AAED;EACE,0BAA0B;CAC3B;;AAED;EACE,0BAA0B;EAC1B,eAAe;CAChB;;AAED;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,oCAAoC;CACrC;;AAED;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;CAC/B;;AAED;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;CACpB;;AAED;;EAEE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;CACpB;;AAED,iBAAiB;;AAEjB;EACE;;IAEE,uBAAuB;IACvB,qBAAqB;GACtB;;EAED;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;GACtB;;EAED;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;IAC5B,yBAAyB;GAC1B;;EAED;IACE,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;GACvB;CACF;;AAED,gBAAgB;;AAEhB;;CAEC;;AAED;;EAEE;;IAEE,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;GAC1B;GACA","file":"attachments.css","sourcesContent":[".tooltip {\n  text-align: left;\n}\n\n.tooltipInner {\n  background: #fdfdfd!important;\n  border: solid 1px #EEE;\n  border-radius: 3px;\n  color: #666!important;\n  width: 100%;\n  overflow: hidden;\n}\n\n.chip {\n  color: black;\n  margin: 5px;\n}\n\n.chipChat {\n  color: black;\n}\n\n.avatar[class~=picture_as_pdf] {\n  background-color: red;\n}\n\n.avatar[class~=audiotrack] {\n  background-color: blue;\n}\n\n.avatar[class~=attach_file] {\n  background-color: green;\n}\n\n.link:not(:active) {\n  opacity: 0.7;\n}\n\n.link:hover,\n  .link:active {\n  opacity: 1;\n}\n\n.nav {\n  top: 0; bottom: 0; right: 0; left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 5px;\n}\n\n.navArea {\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 40px;\n}\n\n.navNext {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n\n.navPrev {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n\n.navArea:hover {\n  background: rgba(0, 0, 0, .1);\n}\n\n.navAttachmentsArea {\n  height: 100%;\n  width: 50%;\n  margin: 15px; \n}\n\n.navAttachmentsField {\n  max-width: 580px;\n  text-align: center;\n  margin: 0 auto 0 0;\n  background-color: #f3f0f0;\n}\n\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .navAttachmentsField {\n  max-width: 580px;\n  text-align: center;\n  margin: 0 auto;\n  background-color: #f3f0f0;\n}\n\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .navAttachmentsArea {\n  position: relative;\n  overflow: hidden; \n  height: 100%;\n  width: 100%;\n  display: inline-block; \n  margin: 15px; \n  text-align: center;\n}\n\n.navAttachmentsCommentArea {\n  position: relative;\n  overflow: hidden; \n  height: 100%;\n  width: 50%;\n  display: inline-block; \n  margin: 15px; \n  text-align: center;\n}\n\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .navAttachmentsCommentArea {\n  position: relative;\n  overflow: hidden; \n  height: 100%;\n  width: 100%;\n  display: inline-block; \n  margin: 15px; \n  text-align: center;\n  background-color: #f3f0f0;\n}\n\n.navImage {\n  max-height: 250px;\n  max-width: 90%; \n  min-width: 100px;\n  min-height: 100px;\n  cursor: pointer; \n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%,-50%);\n          transform: translate(-50%,-50%);\n}\n\n.navAvatarArea {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n\n.navSelectDots > span {\n  font-size: 10px!important;\n}\n\n.navNotSelectDots > span {\n  font-size: 10px!important;\n  color: #a0a0a0;\n}\n\n.navChip {\n  position: absolute;\n  margin: 5px 0px 0px 10px;\n  color: rgb(0, 0, 0);\n  background:#f3f0f0;\n  top: 20%;\n  left: 0%;\n  transform: translate(0%, -200%);\n  -webkit-transform: translate(0%, -200%);\n  -ms-transform: translate(0%, -200%);\n}\n\n.fileName {\n  position: absolute;\n  top: 0; \n  left: 0; \n  color: #EEE; \n  padding: 3px 20px; \n  background: rgba(0, 0, 0, .6);\n}\n\n.navDots {\n  list-style: 'none';\n  width: 100%;\n  padding: 0px; \n  margin: 5px; \n  text-align: center;\n}\n\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .navDots {\n  list-style: 'none';\n  width: 100%; \n  padding: 0px; \n  margin: 5px; \n  text-align: center;\n}\n\n/* モバイル用の調整を追加 */\n\n@media screen and (max-width: 600px) {\n  .navAttachmentsArea,\n  .navAttachmentsCommentArea {\n    width: 100% !important;\n    margin: 0 !important;\n  }\n\n  .navAttachmentsField {\n    width: 100% !important;\n    max-width: none !important;\n    margin: 0 !important;\n  }\n\n  .navImage {\n    max-width: 100% !important;\n    width: auto !important;\n    height: auto !important;\n    max-height: 100% !important;\n    padding: 10px !important;\n  }\n\n  div[style*=\"height: 280\"] {\n    height: auto !important;\n    min-height: 280px;\n    padding: 0 !important;\n  }\n}\n\n/* 2カラムレイアウト用 */\n\n[class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .navImage {\n}\n\n@media screen and (max-width: 600px) {\n\n  [class^=\"two-column-layout\"],\n[class*=\" two-column-layout\"] .navImage {\n    max-width: 100% !important;\n    width: auto !important;\n    height: auto !important;\n    padding: 10px !important;\n  }\n  }"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"tooltip": "attachments--tooltip--34dhsbXv",
	"tooltipInner": "attachments--tooltipInner--UvsEB1L-",
	"chip": "attachments--chip--2auAtT5G",
	"chipChat": "attachments--chipChat--22aVv1XV",
	"avatar": "attachments--avatar--F4AmiW2s",
	"link": "attachments--link--2um-NzDd",
	"nav": "attachments--nav--1VI-FiM9",
	"navArea": "attachments--navArea--eZO2uu-f",
	"navNext": "attachments--navNext--1y0iz6mZ",
	"navPrev": "attachments--navPrev--1meWwoHx",
	"navAttachmentsArea": "attachments--navAttachmentsArea--3DE5OO-i",
	"navAttachmentsField": "attachments--navAttachmentsField--JaBtkzz3",
	"navAttachmentsCommentArea": "attachments--navAttachmentsCommentArea--19yVLRcJ",
	"navImage": "attachments--navImage--1st0yZZo",
	"navAvatarArea": "attachments--navAvatarArea--1pD2ne2p",
	"navSelectDots": "attachments--navSelectDots--6x0NtPN_",
	"navNotSelectDots": "attachments--navNotSelectDots--cZQcvSRq",
	"navChip": "attachments--navChip--2FLtyPaQ",
	"fileName": "attachments--fileName--2CFp95I5",
	"navDots": "attachments--navDots--2xZ-nly4"
};

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _formValidator = __webpack_require__(41);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showPdfPreview: function showPdfPreview(file) {
      dispatch(_actions2.default.openRightSidePage('pdf_preview', { file: file }, true));
    },

    showVoicePlayer: function showVoicePlayer(file, diary_id, comment_id) {
      dispatch(_actions2.default.openRightSidePage('voice_player', { file: file, diary_id: diary_id, comment_id: comment_id, isAudio: true }, true));
    }
  };
};
/**
* src/connects/attachment-file.js
* 
*/

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(undefined, mapDispatchToProps), (0, _uiState2.default)({ state: { openDialog: false } }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2535);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./attachments-thumbnail.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./attachments-thumbnail.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".attachments-thumbnail--tooltip--1cjyhZ-1 {\n  text-align: left;\n  width: 360px;\n  max-width: 360px!important;\n}\n\n.attachments-thumbnail--tooltipInner--1a1MajWP {\n  background: #fdfdfd!important;\n  border: solid 1px #EEE;\n  color: #666!important;\n  width: 100%;\n  overflow: hidden;\n}\n\n.attachments-thumbnail--link--1dTJAuS6:not(:active) {\n  opacity: 0.7;\n}\n\n.attachments-thumbnail--link--1dTJAuS6:hover,\n  .attachments-thumbnail--link--1dTJAuS6:active {\n  opacity: 1;\n}", "", {"version":3,"sources":["/./src/web/components/themes/attachments-thumbnail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;CAC5B;;AAED;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;CAClB;;AAED;EACE,aAAa;CACd;;AAED;;EAEE,WAAW;CACZ","file":"attachments-thumbnail.css","sourcesContent":[".tooltip {\n  text-align: left;\n  width: 360px;\n  max-width: 360px!important;\n}\n\n.tooltipInner {\n  background: #fdfdfd!important;\n  border: solid 1px #EEE;\n  color: #666!important;\n  width: 100%;\n  overflow: hidden;\n}\n\n.link:not(:active) {\n  opacity: 0.7;\n}\n\n.link:hover,\n  .link:active {\n  opacity: 1;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"tooltip": "attachments-thumbnail--tooltip--1cjyhZ-1",
	"tooltipInner": "attachments-thumbnail--tooltipInner--1a1MajWP",
	"link": "attachments-thumbnail--link--1dTJAuS6"
};

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactI18next = __webpack_require__(2);

var _card = __webpack_require__(28);

var _list = __webpack_require__(25);

var _fieldListItem = __webpack_require__(1053);

var _fieldListItem2 = _interopRequireDefault(_fieldListItem);

var _fieldIcons = __webpack_require__(522);

var _fieldIcons2 = _interopRequireDefault(_fieldIcons);

var _urlRegexp = __webpack_require__(182);

var _numberRegexp = __webpack_require__(973);

var _numberRegexp2 = _interopRequireDefault(_numberRegexp);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/diary-fields.jsx

var Regex = (0, _urlRegexp.urlRegex)();

var EmailRegex = (0, _urlRegexp.urlRegex)({ email: true });
var PhoneRegex = (0, _urlRegexp.urlRegex)({ phoneNumber: true });

var DiaryFields = function (_React$Component) {
  _inherits(DiaryFields, _React$Component);

  function DiaryFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DiaryFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiaryFields.__proto__ || Object.getPrototypeOf(DiaryFields)).call.apply(_ref, [this].concat(args))), _this), _this.getHTMLText = function (value) {
      return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: _this.convertHighlight(value) } });
    }, _this.renderLink = function (text, i) {
      // Return the link on the URL, Email, Phone Number case
      if (Regex.test(text)) {
        return (0, _urlRegexp.textUrl)(text).map(function (value, i) {
          return Regex.test(value) ? _react2.default.createElement(
            'a',
            { key: i, href: value, target: '_blank', rel: 'noopener noreferrer' },
            _this.getHTMLText(value)
          ) : _this.getHTMLText(value);
        });
      }
      if (EmailRegex.test(text)) {
        return _react2.default.createElement(
          'a',
          { key: i, href: 'mailto:' + text },
          _this.getHTMLText(text)
        );
      }
      if (PhoneRegex.test(text)) {
        return _react2.default.createElement(
          'a',
          { key: i, href: 'tel:' + text },
          _this.getHTMLText(text)
        );
      }

      return _this.getHTMLText(text);
    }, _this.convertHighlight = function (text) {
      var query = _this.props.query;
      var searchHits = '';
      if (query && query.query) {
        var value = query.query;
        // Split by both spaces and commas, then extract values after '='
        searchHits = value.split(/[\s,]+/).map(function (item) {
          return item.includes('=') ? item.split('=')[1] : item;
        });
      }

      if (text && searchHits) {
        _lodash2.default.each(searchHits, function (hit) {
          var escapedHit = hit.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          var regexPattern = new RegExp('(?!<[^>]*?)(' + escapedHit + ')(?![^<]*?>)', 'gi');
          text = text.replace(regexPattern, '<em>$1</em>');
        });
      }

      return text;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DiaryFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          fields = _props.fields,
          query = _props.query;


      if (!fields || fields.length == 0) return null;

      return _react2.default.createElement(
        _list.List,
        null,
        _lodash2.default.map(fields, function (field, i) {
          return field.type == 'text' && _react2.default.createElement(
            _list.ListItem,
            { key: i, theme: _fieldListItem2.default, ripple: false },
            _react2.default.createElement(
              _list.ListItemContent,
              { theme: _fieldListItem2.default },
              _react2.default.createElement(
                _list.ListItemText,
                { primary: true, theme: _fieldListItem2.default },
                field.name
              ),
              _react2.default.createElement(
                _list.ListItemText,
                { theme: _fieldListItem2.default },
                _this2.getHTMLText(field.value)
              )
            )
          ) || _react2.default.createElement(_list.ListItem, { key: i, theme: _fieldListItem2.default,
            caption: field.name,
            legend: field.type == 'date' && (field.value && _this2.getHTMLText((0, _moment2.default)(field.value).format('YYYY-MM-DD')) || t('label:未入力')) || field.type == 'numeric' && _this2.getHTMLText((0, _numberRegexp2.default)(field.value)) || field.type === 'string' && _this2.renderLink(field.value, i) || _this2.getHTMLText(field.value),
            ripple: false });
        })
      );
    }
  }]);

  return DiaryFields;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)()(DiaryFields);

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".field-list-item--item--3v0nbS9I {\n  min-height: 40px;\n  padding-left: 32px!important;\n}\n\n.field-list-item--listItem--2OMpT0wt[class~=error] {\n  background: rgba(255, 0, 0, .1);\n}\n\n.field-list-item--left--5y_88t8F {\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n}\n\n.field-list-item--itemContentRoot--1hcZQ7xZ {\n  height: auto!important;\n}\n\n.field-list-item--itemAction--11hCdtpS {\n  margin-right: 0px!important;\n}\n\n.field-list-item--itemAction--11hCdtpS > [data-react-toolbox='font-icon'] {\n  font-size: 18px!important;\n  margin-right: 5px!important;\n}\n\n.field-list-item--itemAction--11hCdtpS:nth-child(2) {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n.field-list-item--primary--sESLHnua {\n  font-size: 12px!important;\n  color: rgb(117, 117, 117)!important;\n}\n\n.field-list-item--itemText--2sgI2J-z:not(.field-list-item--primary--sESLHnua) {\n  line-height: 1.1em;\n  color: rgb(33, 33, 33)!important;\n}\n\n[class~=error] .field-list-item--itemText--2sgI2J-z:not(.field-list-item--primary--sESLHnua) {\n  color: red!important;\n}\n\n[class~=error] .field-list-item--itemText--2sgI2J-z.field-list-item--primary--sESLHnua {\n  color: red!important;\n}\n\n.field-list-item--itemText--2sgI2J-z:nth-child(2) {\n  padding-top: 0px!important\n}\n\n.field-list-item--input--2CxvGC4I input, .field-list-item--input--2CxvGC4I textarea {\n  font-size: 14px;\n  line-height: 1.2em;\n  background: white;\n}\n\n.field-list-item--itemText--2sgI2J-z {\n  white-space: pre-line!important;\n  word-break: break-all!important;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/field-list-item.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6BAA6B;CAC9B;;AAED;EACE,gCAAgC;CACjC;;AAED;EACE,2BAA2B;MACvB,uBAAuB;CAC5B;;AAED;EACE,uBAAuB;CACxB;;AAED;EACE,4BAA4B;CAC7B;;AAED;EACE,0BAA0B;EAC1B,4BAA4B;CAC7B;;AAED;EACE,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;CACtB;;AAED;EACE,0BAA0B;EAC1B,oCAAoC;CACrC;;AAED;EACE,mBAAmB;EACnB,iCAAiC;CAClC;;AAED;EACE,qBAAqB;CACtB;;AAED;EACE,qBAAqB;CACtB;;AAED;EACE,0BAA0B;CAC3B;;AAED;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;CACnB;;AAED;EACE,gCAAgC;EAChC,gCAAgC;CACjC","file":"field-list-item.css","sourcesContent":[".item {\n  min-height: 40px;\n  padding-left: 32px!important;\n}\n\n.listItem[class~=error] {\n  background: rgba(255, 0, 0, .1);\n}\n\n.left {\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n}\n\n.itemContentRoot {\n  height: auto!important;\n}\n\n.itemAction {\n  margin-right: 0px!important;\n}\n\n.itemAction > [data-react-toolbox='font-icon'] {\n  font-size: 18px!important;\n  margin-right: 5px!important;\n}\n\n.itemAction:nth-child(2) {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n.primary {\n  font-size: 12px!important;\n  color: rgb(117, 117, 117)!important;\n}\n\n.itemText:not(.primary) {\n  line-height: 1.1em;\n  color: rgb(33, 33, 33)!important;\n}\n\n[class~=error] .itemText:not(.primary) {\n  color: red!important;\n}\n\n[class~=error] .itemText.primary {\n  color: red!important;\n}\n\n.itemText:nth-child(2) {\n  padding-top: 0px!important\n}\n\n.input input, .input textarea {\n  font-size: 14px;\n  line-height: 1.2em;\n  background: white;\n}\n\n.itemText {\n  white-space: pre-line!important;\n  word-break: break-all!important;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"item": "field-list-item--item--3v0nbS9I",
	"listItem": "field-list-item--listItem--2OMpT0wt",
	"left": "field-list-item--left--5y_88t8F",
	"itemContentRoot": "field-list-item--itemContentRoot--1hcZQ7xZ",
	"itemAction": "field-list-item--itemAction--11hCdtpS",
	"primary": "field-list-item--primary--sESLHnua",
	"itemText": "field-list-item--itemText--2sgI2J-z",
	"input": "field-list-item--input--2CxvGC4I"
};

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDiaryComment = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-comment.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _diaryComment = __webpack_require__(1054);

var _diaryComment2 = _interopRequireDefault(_diaryComment);

var _reactCssThemr = __webpack_require__(10);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _button = __webpack_require__(8);

var _card = __webpack_require__(28);

var _avatar = __webpack_require__(26);

var _menu = __webpack_require__(63);

var _diaryUser = __webpack_require__(560);

var _diaryUser2 = _interopRequireDefault(_diaryUser);

var _diaryTimestamp = __webpack_require__(238);

var _diaryTimestamp2 = _interopRequireDefault(_diaryTimestamp);

var _diaryLikes = __webpack_require__(561);

var _diaryLikes2 = _interopRequireDefault(_diaryLikes);

var _diaryContent = __webpack_require__(239);

var _diaryContent2 = _interopRequireDefault(_diaryContent);

var _diaryActions = __webpack_require__(563);

var _diaryActions2 = _interopRequireDefault(_diaryActions);

var _diaryAttachments = __webpack_require__(566);

var _diaryAttachments2 = _interopRequireDefault(_diaryAttachments);

var _diaryMentionsTo = __webpack_require__(562);

var _diaryMentionsTo2 = _interopRequireDefault(_diaryMentionsTo);

var _diaryCommentCount = __webpack_require__(1048);

var _diaryCommentCount2 = _interopRequireDefault(_diaryCommentCount);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _cardTitleRightActionsComment = __webpack_require__(1055);

var _cardTitleRightActionsComment2 = _interopRequireDefault(_cardTitleRightActionsComment);

var _cardTitleRightActions = __webpack_require__(911);

var _cardTitleRightActions2 = _interopRequireDefault(_cardTitleRightActions);

var _diaryCommentChild = __webpack_require__(2541);

var _diaryCommentChild2 = _interopRequireDefault(_diaryCommentChild);

var _diaryCommentForm = __webpack_require__(568);

var _diaryCommentForm2 = _interopRequireDefault(_diaryCommentForm);

var _toggleButton = __webpack_require__(388);

var _toggleButton2 = _interopRequireDefault(_toggleButton);

var _isStamp = __webpack_require__(1058);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiaryComment = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_PureComponent) {
  _inherits(DiaryComment, _PureComponent);

  function DiaryComment() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DiaryComment);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiaryComment.__proto__ || Object.getPrototypeOf(DiaryComment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onComment = function () {
      return _this.setState({ showCommentForm: true, showAllComments: true });
    }, _this.onReplyComment = function () {
      _this.setState({ ReplyCommentForm: true });
      var childBottom = _reactDom2.default.findDOMNode(_this.refs.child).getBoundingClientRect().bottom;
      var innerHeight = window.innerHeight;
      var offset = childBottom - innerHeight;
      //this.props.onReplyScrollFromがundefindでない場合、返信コメントの末尾とwindow.innerHeight渡す
      _this.props.onReplyScrollFrom && _this.props.onReplyScrollFrom(offset);
    }, _this.onStamp = function () {
      return _this.props.showStampPalette(function (code) {
        return _this.props.submitStamp(code, _this.props);
      });
    }, _this.onCommentClose = function () {
      return _this.setState({ showCommentForm: false });
    }, _this.onReplyClose = function () {
      return _this.setState({ ReplyCommentForm: false });
    }, _this.showAllComments = function () {
      return _this.setState({ showAllComments: !_this.state.showAllComments });
    }, _this.onDeleteConfirm = function () {
      return _this.setState({ deleteConfirm: true });
    }, _this.onDeleteConfirmYes = function () {
      _this.setState({ deleteConfirm: false });_this.props.deleteComment();
    }, _this.onDeleteConfirmNo = function () {
      return _this.setState({ deleteConfirm: false });
    }, _this.onCommentEdit = function () {
      return _this.setState({ editComment: !_this.state.editComment });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DiaryComment, [{
    key: 'render',
    value: function render() {
      var _React$createElement,
          _this2 = this;

      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          comment = _props.comment,
          user = _props.user,
          group = _props.group,
          diary = _props.diary,
          cont = _props.cont,
          searchHits = _props.searchHits,
          commentForm = _props.commentForm,
          disableLike = _props.disableLike,
          showUser = _props.showUser,
          likeComment = _props.likeComment,
          unlikeComment = _props.unlikeComment,
          reactionComment = _props.reactionComment,
          deleteComment = _props.deleteComment,
          showAttachments = _props.showAttachments,
          showReaders = _props.showReaders,
          showMentions = _props.showMentions,
          isShowAllComments = _props.isShowAllComments,
          onReplyScrollFrom = _props.onReplyScrollFrom,
          showComments = _props.showComments,
          likeConfig = _props.likeConfig,
          showImagesView = _props.showImagesView,
          isShowTimeStamp = _props.isShowTimeStamp;


      var myself = comment.user.user_id == user.user_id;
      var like = _.find(comment.likes, function (like) {
        return like.user.user_id == user.user_id;
      });
      var isReplyAttachment = _.some(comment.comments, function (_comment) {
        return _comment.files.length > 0;
      });
      var isStamp = (0, _isStamp.isCommentStamp)(comment.comment); // コメントの内容がスタンプの場合は編集させないようにする

      return _react2.default.createElement(
        'div',
        null,
        !this.state.editComment && _react2.default.createElement(
          _card.CardText,
          { className: 'diaryComment', theme: theme },
          _react2.default.createElement(_avatar.Avatar, { theme: theme, className: 'avatar', image: comment.user.icon_image.thumb_url, onClick: showUser }),
          _react2.default.createElement(
            _card.Card,
            { theme: theme, className: 'comment' },
            _react2.default.createElement(_cardTitleRightActionsComment2.default, {
              className: 'comment',
              subtitle: [_react2.default.createElement(_diaryUser2.default, { key: 'user', user: comment.user, showUser: showUser }), isShowTimeStamp ? _react2.default.createElement(_diaryTimestamp2.default, { key: 'timestamp', timestamp: comment.created_at, updated: comment.updated_at }) : null],
              rightActions: (isStamp && user.user_id == comment.user.user_id || user.user_id != comment.user.user_id && group && group.is_admin) && _react2.default.createElement(_button.IconButton, { icon: 'close', style: { width: 27, height: 27 }, onClick: this.onDeleteConfirm }) || !isStamp && user.user_id == comment.user.user_id && _react2.default.createElement(
                _menu.IconMenu,
                { icon: 'more_vert', position: 'topRight' },
                _react2.default.createElement(_menu.MenuItem, { caption: t('label:コメントを編集'), onClick: this.onCommentEdit, icon: 'mode_edit' }),
                _react2.default.createElement(_menu.MenuItem, { caption: t('label:コメントを削除'), onClick: this.onDeleteConfirm, icon: 'delete_forever' })
              ) }),
            _react2.default.createElement(_diaryContent2.default, { content: comment.comment, comment: true, searchHits: searchHits }),
            _react2.default.createElement(_diaryAttachments2.default, { comment: true, comment_id: comment.comment_id, files: comment.files, showAttachments: showAttachments, showImagesView: showImagesView }),
            _react2.default.createElement(
              _card.CardText,
              { theme: theme, className: 'interaction' },
              _react2.default.createElement(_diaryLikes2.default, (_React$createElement = { myself: myself, key: 'likes', likes: comment.likes, likes_count: comment.likes_count }, _defineProperty(_React$createElement, 'myself', comment.user.user_id == user.user_id), _defineProperty(_React$createElement, 'showReaders', showReaders), _defineProperty(_React$createElement, 'likeConfig', likeConfig), _React$createElement)),
              _react2.default.createElement(_diaryMentionsTo2.default, { key: 'mentions', mentions: comment.mentions, showReaders: showMentions, reply_requested: comment.reply_requested })
            ),
            _react2.default.createElement(_diaryActions2.default, {
              like: like,
              disableLike: disableLike,
              onLike: like && unlikeComment || likeComment,
              onReaction: reactionComment,
              onComment: this.onComment,
              onStamp: this.onStamp,
              isComment: true,
              parent: comment,
              likeConfig: likeConfig }),
            _react2.default.createElement(_confirmDialog2.default, { open: this.state.deleteConfirm,
              title: t('label:コメントを削除してもいいですか'),
              description: t('label:この操作は取り消せません'),
              yesLabel: t('label:削除'),
              noLabel: t('label:取り消し'),
              onYes: this.onDeleteConfirmYes,
              onNo: this.onDeleteConfirmNo })
          )
        ),
        this.state.editComment && _react2.default.createElement(_diaryCommentForm2.default, {
          diary: diary,
          group: group,
          user: user,
          parent: diary,
          editComment: comment,
          onClose: this.onCommentEdit }),
        !isShowAllComments && comment.comments && _react2.default.createElement(
          _card.CardText,
          { theme: theme, className: 'showReply' },
          _react2.default.createElement(_toggleButton2.default, {
            flag: !this.state.showAllComments,
            className: 'fluid',
            image: comment.comments[comment.comments.length - 1].user.icon_image.thumb_url,
            trueLabel: '' + comment.comments[comment.comments.length - 1].user.name + (comment.comments.length > 1 ? t('label:が返信しました', { count: comment.comments.length }) : t('label:が返信しました(1件)')),
            falseLabel: t('label:返信を隠す'),
            isAttachment: !this.state.showAllComments ? isReplyAttachment : undefined,
            onClick: this.showAllComments })
        ),
        this.state.showCommentForm && _react2.default.createElement(_diaryCommentForm2.default, {
          diary: diary,
          group: group,
          user: user,
          parent: comment,
          onClose: this.onCommentClose }),
        (this.state.showAllComments || isShowAllComments) && comment.comments && _.map(comment.comments, function (_comment, i) {
          var _React$createElement2;

          return _react2.default.createElement(_diaryCommentChild2.default, (_React$createElement2 = { ref: 'child',
            key: _comment.comment_id,
            user: user,
            group: group,
            diary: diary,
            parent: comment,
            comment: _comment,
            searchHits: searchHits,
            cont: _comment.comment_id != diary.comments[diary.comments.length - 1].comment_id,
            commentForm: _this2.state.showCommentForm,
            onReplyComment: _this2.onReplyComment,
            onStamp: _this2.onStamp,
            isComment: true
          }, _defineProperty(_React$createElement2, 'parent', comment), _defineProperty(_React$createElement2, 'isShowTimeStamp', isShowTimeStamp), _defineProperty(_React$createElement2, 'likeConfig', likeConfig), _React$createElement2));
        }),
        this.state.ReplyCommentForm && _react2.default.createElement(_diaryCommentForm2.default, {
          diary: diary,
          group: group,
          user: user,
          parent: comment,
          onReplyComment: this.onReplyComment,
          onClose: this.onReplyClose })
      );
    }
  }]);

  return DiaryComment;
}(_pureComponent2.default)) || _class);
/*
コメントのハイライトがあった場合の処理
*/

var RawDiaryComment = exports.RawDiaryComment = DiaryComment;
exports.default = (0, _diaryComment2.default)(DiaryComment);

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2540);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./card-title-right-actions-comment.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./card-title-right-actions-comment.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.card-title-right-actions-comment--cardTitle--352ET8Ac {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-width: 100%;\n  padding-top: 8px;\n  padding-left: 13px;\n}\n\n.card-title-right-actions-comment--content--yVOZL_Wz {\n  width: calc(100% - 120px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 25px\n}\n\n.card-title-right-actions-comment--title--ugPVPEzi {\n  font-size: 16.5px;\n  font-weight: bold;\n}\n\n.card-title-right-actions-comment--subtitle--3ijxunCv {\n  color: #757575;\n}\n\n.card-title-right-actions-comment--rightIcons--3XkZFReR {\n  margin-left: auto;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/card-title-right-actions-comment.css"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;CACpB;;AAED;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;CACb;;AAED;EACE,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,eAAe;CAChB;;AAED;EACE,kBAAkB;CACnB","file":"card-title-right-actions-comment.css","sourcesContent":["\n.cardTitle {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-width: 100%;\n  padding-top: 8px;\n  padding-left: 13px;\n}\n\n.content {\n  width: calc(100% - 120px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 25px\n}\n\n.title {\n  font-size: 16.5px;\n  font-weight: bold;\n}\n\n.subtitle {\n  color: #757575;\n}\n\n.rightIcons {\n  margin-left: auto;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"cardTitle": "card-title-right-actions-comment--cardTitle--352ET8Ac",
	"content": "card-title-right-actions-comment--content--yVOZL_Wz",
	"title": "card-title-right-actions-comment--title--ugPVPEzi",
	"subtitle": "card-title-right-actions-comment--subtitle--3ijxunCv",
	"rightIcons": "card-title-right-actions-comment--rightIcons--3XkZFReR"
};

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDiaryCommentChild = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-comment.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _diaryComment = __webpack_require__(1054);

var _diaryComment2 = _interopRequireDefault(_diaryComment);

var _reactCssThemr = __webpack_require__(10);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _button = __webpack_require__(8);

var _card = __webpack_require__(28);

var _avatar = __webpack_require__(26);

var _menu = __webpack_require__(63);

var _diaryUser = __webpack_require__(560);

var _diaryUser2 = _interopRequireDefault(_diaryUser);

var _diaryTimestamp = __webpack_require__(238);

var _diaryTimestamp2 = _interopRequireDefault(_diaryTimestamp);

var _diaryLikes = __webpack_require__(561);

var _diaryLikes2 = _interopRequireDefault(_diaryLikes);

var _diaryContent = __webpack_require__(239);

var _diaryContent2 = _interopRequireDefault(_diaryContent);

var _diaryActions = __webpack_require__(563);

var _diaryActions2 = _interopRequireDefault(_diaryActions);

var _diaryAttachments = __webpack_require__(566);

var _diaryAttachments2 = _interopRequireDefault(_diaryAttachments);

var _diaryMentionsTo = __webpack_require__(562);

var _diaryMentionsTo2 = _interopRequireDefault(_diaryMentionsTo);

var _diaryCommentForm = __webpack_require__(568);

var _diaryCommentForm2 = _interopRequireDefault(_diaryCommentForm);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _cardTitleRightActionsComment = __webpack_require__(1055);

var _cardTitleRightActionsComment2 = _interopRequireDefault(_cardTitleRightActionsComment);

var _isStamp = __webpack_require__(1058);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiaryCommentChild = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_PureComponent) {
  _inherits(DiaryCommentChild, _PureComponent);

  function DiaryCommentChild() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DiaryCommentChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiaryCommentChild.__proto__ || Object.getPrototypeOf(DiaryCommentChild)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onDeleteConfirm = function () {
      return _this.setState({ deleteConfirm: true });
    }, _this.onDeleteConfirmYes = function () {
      _this.setState({ deleteConfirm: false });_this.props.deleteComment();
    }, _this.onDeleteConfirmNo = function () {
      return _this.setState({ deleteConfirm: false });
    }, _this.onCommentEdit = function () {
      return _this.setState({ editComment: !_this.state.editComment });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DiaryCommentChild, [{
    key: 'render',
    value: function render() {
      var _React$createElement;

      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          comment = _props.comment,
          diary = _props.diary,
          parent = _props.parent,
          user = _props.user,
          group = _props.group,
          cont = _props.cont,
          searchHits = _props.searchHits,
          commentForm = _props.commentForm,
          disableLike = _props.disableLike,
          showUser = _props.showUser,
          likeComment = _props.likeComment,
          unlikeComment = _props.unlikeComment,
          reactionComment = _props.reactionComment,
          deleteComment = _props.deleteComment,
          showAttachments = _props.showAttachments,
          showReaders = _props.showReaders,
          showMentions = _props.showMentions,
          onReplyComment = _props.onReplyComment,
          onStamp = _props.onStamp,
          likeConfig = _props.likeConfig,
          showImagesView = _props.showImagesView,
          isShowTimeStamp = _props.isShowTimeStamp;


      var myself = comment.user.user_id == user.user_id;
      var like = _.find(comment.likes, function (like) {
        return like.user.user_id == user.user_id;
      });
      var isStamp = (0, _isStamp.isCommentStamp)(comment.comment); // コメントの内容がスタンプの場合は編集させないようにする

      return _react2.default.createElement(
        'div',
        null,
        !this.state.editComment && _react2.default.createElement(
          _card.CardText,
          { className: 'diaryReply', theme: theme },
          _react2.default.createElement(_avatar.Avatar, { theme: theme, className: 'avatar', image: comment.user.icon_image.thumb_url, onClick: showUser }),
          _react2.default.createElement(
            _card.Card,
            { theme: theme, className: 'comment' },
            _react2.default.createElement(_cardTitleRightActionsComment2.default, {
              className: 'comment',
              subtitle: [_react2.default.createElement(_diaryUser2.default, { key: 'user', user: comment.user, showUser: showUser }), isShowTimeStamp ? _react2.default.createElement(_diaryTimestamp2.default, { key: 'timestamp', timestamp: comment.created_at, updated: comment.updated_at }) : null],
              rightActions: (isStamp && user.user_id == comment.user.user_id || user.user_id != comment.user.user_id && group && group.is_admin) && _react2.default.createElement(_button.IconButton, { icon: 'close', style: { width: 27, height: 27 }, onClick: this.onDeleteConfirm }) || !isStamp && user.user_id == comment.user.user_id && _react2.default.createElement(
                _menu.IconMenu,
                { icon: 'more_vert', position: 'topRight' },
                _react2.default.createElement(_menu.MenuItem, { caption: t('label:コメントを編集'), onClick: this.onCommentEdit, icon: 'mode_edit' }),
                _react2.default.createElement(_menu.MenuItem, { caption: t('label:コメントを削除'), onClick: this.onDeleteConfirm, icon: 'delete_forever' })
              ) }),
            _react2.default.createElement(_diaryContent2.default, { content: comment.comment, comment: true, searchHits: searchHits }),
            _react2.default.createElement(_diaryAttachments2.default, { comment: true, comment_id: comment.comment_id, files: comment.files, showAttachments: showAttachments, showImagesView: showImagesView }),
            _react2.default.createElement(
              _card.CardText,
              { theme: theme, className: 'interaction' },
              _react2.default.createElement(_diaryLikes2.default, (_React$createElement = { myself: myself, key: 'likes', comment_id: comment.comment_id, likes: comment.likes, likes_count: comment.likes_count }, _defineProperty(_React$createElement, 'myself', comment.user.user_id == user.user_id), _defineProperty(_React$createElement, 'showReaders', showReaders), _defineProperty(_React$createElement, 'likeConfig', likeConfig), _React$createElement)),
              _react2.default.createElement(_diaryMentionsTo2.default, { key: 'mentions', comment_id: comment.comment_id, mentions: comment.mentions, showReaders: showMentions, reply_requested: comment.reply_requested })
            ),
            _react2.default.createElement(_diaryActions2.default, {
              like: like,
              disableLike: disableLike,
              onLike: like && unlikeComment || likeComment,
              onReaction: reactionComment,
              onComment: onReplyComment,
              onStamp: onStamp,
              isComment: true,
              parent: parent,
              likeConfig: likeConfig }),
            _react2.default.createElement(_confirmDialog2.default, { open: this.state.deleteConfirm,
              title: t('label:コメントを削除してもいいですか'),
              description: t('label:この操作は取り消せません'),
              yesLabel: t('label:削除'),
              noLabel: t('label:取り消し'),
              onYes: this.onDeleteConfirmYes,
              onNo: this.onDeleteConfirmNo })
          )
        ),
        this.state.editComment && _react2.default.createElement(_diaryCommentForm2.default, {
          diary: diary,
          group: group,
          user: user,
          parent: comment,
          editComment: comment,
          onClose: this.onCommentEdit })
      );
    }
  }]);

  return DiaryCommentChild;
}(_pureComponent2.default)) || _class);
var RawDiaryCommentChild = exports.RawDiaryCommentChild = DiaryCommentChild;
exports.default = (0, _diaryComment2.default)(DiaryCommentChild);

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/diary-comment-form.js

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _route = __webpack_require__(67);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _componentId = __webpack_require__(164);

var _componentId2 = _interopRequireDefault(_componentId);

var _fileUpload = __webpack_require__(179);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isPosting: state.comments.isPosting,
    isPostFailed: state.comments.isPostFailed,
    uploadedFiles: state.uploadFile[ownProps.componentId],
    uploadedVideos: state.uploadVideo[ownProps.componentId]
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var isUploading;
  (0, _each2.default)(stateProps.uploadedFiles, function (value, key) {
    value && value.isUploading && (isUploading = true);
  });
  (0, _each2.default)(stateProps.uploadedVideos, function (value, key) {
    value && value.isUploading && (isUploading = true);
  });
  return _extends({
    isUploading: isUploading
  }, stateProps, dispatchProps, ownProps);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    submitComment: function submitComment(props) {
      props.ui.handlers && props.ui.handlers.getValue(function (value) {
        var files = (0, _filter2.default)((0, _map2.default)(props.uploadedFiles, function (file) {
          return file && file.item && file.item.file_id;
        }), function (file) {
          return file;
        });
        var videos = (0, _filter2.default)((0, _map2.default)(props.uploadedVideos, function (file) {
          return file && file.item && file.item.video_id;
        }), function (file) {
          return file;
        });
        var mentions = (0, _map2.default)(props.ui.mentions, function (mention) {
          return mention.user_id;
        });
        if (!value || value.length == 0) return;
        if (props.editComment && props.editComment.comment_id) dispatch(_actions2.default.putComment(props.editComment.comment_id, value, files, videos, mentions, props.ui.reply_requested));else dispatch(_actions2.default.postComment(props.parent.comment_id ? 'comment_id' : 'diary_id', props.parent.comment_id || props.parent.diary_id, value, files, videos, mentions, props.ui.reply_requested));
      });
    },

    uploadFiles: function uploadFiles(files) {
      return (0, _fileUpload2.default)(files, dispatch, ownProps.group.group_id, 'group', ownProps.componentId);
    },

    willMount: function willMount(props) {
      if (props.editComment) {
        (0, _each2.default)((0, _filter2.default)(props.editComment.files, function (file) {
          return file.file_id;
        }), function (file, i) {
          return dispatch(_actions2.default.uploadFileCompleted(file, ownProps.componentId, i, false));
        });
        (0, _each2.default)((0, _filter2.default)(props.editComment.files, function (file) {
          return file.video_id;
        }), function (file, i) {
          return dispatch(_actions2.default.uploadVideoCompleted(file, ownProps.componentId, i, false));
        });
      }
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (props.isPosting && !nextProps.isPosting && !nextProps.isPostFailed) {
        ownProps.onClose();
      }
      if (!props.ui.handlers && nextProps.ui.handlers && nextProps.editComment) {
        setTimeout(function () {
          return nextProps.ui.handlers.insertValue(nextProps.editComment.comment);
        }, 300);
      }
    },

    willUnmount: function willUnmount() {
      dispatch(_actions2.default.clearUploadFilesAndVideos(ownProps.componentId));
    }
  };
};

exports.default = (0, _combineHoc2.default)(_componentId2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({
  state: {
    handlers: undefined,
    mentions: function mentions(props) {
      return props.editComment && props.editComment.mentions;
    },
    reply_requested: function reply_requested(props) {
      return props.editComment && props.editComment.reply_requested;
    }
  }
}), (0, _reactI18next.translate)(), (0, _context2.default)({ showUserSelectionDialog: _propTypes2.default.func }), _lifecycle2.default);

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".image-chip--chip--1nDgbYRY {\n  padding-left: 0px!important;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.image-chip--chip--1nDgbYRY img {\n  margin-right: 2px;\n}\n\n.image-chip--image--3eHhhUSL {\n  border-radius: 5px;\n  vertical-align: middle;\n  height: 32px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/image-chip.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;CAChC;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;CACd","file":"image-chip.css","sourcesContent":[".chip {\n  padding-left: 0px!important;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.chip img {\n  margin-right: 2px;\n}\n\n.image {\n  border-radius: 5px;\n  vertical-align: middle;\n  height: 32px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"chip": "image-chip--chip--1nDgbYRY",
	"image": "image-chip--image--3eHhhUSL"
};

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-v2-progress-chart.js

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = __webpack_require__(10);

var _diaryKpi = __webpack_require__(564);

var _diaryKpi2 = _interopRequireDefault(_diaryKpi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var style = {
  container: {
    backggroundColor: '#FFF',
    borderColor: '#DDD',
    borderWidth: 0.5,
    padding: 5,
    margin: 3
  }
};

var DiaryV2ProgressChart = (_dec = (0, _reactCssThemr.themr)('DiaryKPI', _diaryKpi2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryV2ProgressChart, _React$Component);

  function DiaryV2ProgressChart() {
    _classCallCheck(this, DiaryV2ProgressChart);

    return _possibleConstructorReturn(this, (DiaryV2ProgressChart.__proto__ || Object.getPrototypeOf(DiaryV2ProgressChart)).apply(this, arguments));
  }

  _createClass(DiaryV2ProgressChart, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          attach_json = _props.attach_json;

      if (!attach_json) return null;

      var v2progress_chart = attach_json.v2progress_chart;

      if (!v2progress_chart) return null;

      return _react2.default.createElement(
        'div',
        { className: theme.kpi },
        _react2.default.createElement(
          'h3',
          { className: theme.title },
          v2progress_chart.name
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'row', justifyContent: 'space-around' } },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold' } },
            v2progress_chart.performance
          ),
          _react2.default.createElement(
            'div',
            { style: {} },
            v2progress_chart.goal
          ),
          _react2.default.createElement(
            'div',
            { style: {} },
            v2progress_chart.percentage
          )
        )
      );
    }
  }]);

  return DiaryV2ProgressChart;
}(_react2.default.Component)) || _class);
exports.default = DiaryV2ProgressChart;

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DiaryCalendarData;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _list = __webpack_require__(25);

var _compactList = __webpack_require__(489);

var _compactList2 = _interopRequireDefault(_compactList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CalendarItem(props) {
  var item = props.item;

  var time;

  if (item.startTime) time = (0, _moment2.default)(item.startTime).format('HH:mm') + '-' + (0, _moment2.default)(item.endTime).format('HH:mm');else time = "終日";

  return _react2.default.createElement(_list.ListItem, { ripple: false, theme: _compactList2.default,
    caption: time + ' ' + item.title,
    legend: item.description });
}
// src/web/components/diary-calendar-data.jsx

function DiaryCalendarData(props) {
  var attach_json = props.attach_json;


  if (!attach_json) return null;

  var googleCalendars = attach_json.googleCalendars;


  if (!googleCalendars) return null;

  return _react2.default.createElement(
    'div',
    null,
    _lodash2.default.map(googleCalendars, function (calendar, i) {
      return _react2.default.createElement(
        _list.List,
        { theme: _compactList2.default },
        _react2.default.createElement(_list.ListSubHeader, { key: i, theme: _compactList2.default, caption: (0, _moment2.default)(calendar.date).format('LLLL') }),
        _lodash2.default.map(calendar.items, function (item, j) {
          return _react2.default.createElement(CalendarItem, { key: j, item: item });
        })
      );
    })
  );
}

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isEnable: state.reviewSetting.isEnable,
    isFetching: state.lambdaApi.isFetching
  };
};
// src/connects/review-card.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    openSettingsPage: function openSettingsPage() {
      return dispatch(_actions2.default.openUserSettingsPage('extensions'));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)(), (0, _analytics.trackPage)('review-card'));

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2548);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./user-icon.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./user-icon.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "div[class~=newBadgeField] {\n  position: fixed;\n}\n\nimg[class~=newBadgeIcon] {\n  background-color: rgb(158, 158, 158);\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n}\n\nimg[class~=reportUserIcon] {\n    background-color: rgb(245, 245, 245);\n    border-radius: 50%;\n    height: 40px;\n    width: 40px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/user-icon.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;CACjB;;AAED;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,YAAY;CACb;;AAED;IACI,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,YAAY;CACf","file":"user-icon.css","sourcesContent":["div[class~=newBadgeField] {\n  position: fixed;\n}\n\nimg[class~=newBadgeIcon] {\n  background-color: rgb(158, 158, 158);\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n}\n\nimg[class~=reportUserIcon] {\n    background-color: rgb(245, 245, 245);\n    border-radius: 50%;\n    height: 40px;\n    width: 40px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports


/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".new-badge--box--1icbhRKp {\n  position: relative;\n  display: inline-block;\n  height: 40px;\n  width: 40px;\n}\n.new-badge--badge--1Yhd8ofO {\n  position: absolute;\n  top: -2px;\n  right: 0;\n  height: 10px;\n  width: 25px;\n  font-size: 10px;\n  font-family: 'Arial Narrow';\n  font-weight: bold;\n  line-height: 10px;\n  color: white;\n  background-color: red;\n  border-radius: 10px;\n  overflow: hidden;\n  text-align: center;\n}\n.new-badge--notification--1NIvURs- {\n  height: 10px;\n  width: 10px;\n  background-color: red;\n  border-radius: 25px;\n  text-align: center;\n  margin-left: 15px;\n}\n.new-badge--kpi--3LRJUBOm {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  font-weight: bold;\n  background-color: red;\n  padding: 3px;\n  border-radius: 5px;\n  color: #FFF;\n  font-size: 60%;\n  margin: 0 4px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/new-badge.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;CACnB;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;CACf","file":"new-badge.css","sourcesContent":[".box {\n  position: relative;\n  display: inline-block;\n  height: 40px;\n  width: 40px;\n}\n.badge {\n  position: absolute;\n  top: -2px;\n  right: 0;\n  height: 10px;\n  width: 25px;\n  font-size: 10px;\n  font-family: 'Arial Narrow';\n  font-weight: bold;\n  line-height: 10px;\n  color: white;\n  background-color: red;\n  border-radius: 10px;\n  overflow: hidden;\n  text-align: center;\n}\n.notification {\n  height: 10px;\n  width: 10px;\n  background-color: red;\n  border-radius: 25px;\n  text-align: center;\n  margin-left: 15px;\n}\n.kpi {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  font-weight: bold;\n  background-color: red;\n  padding: 3px;\n  border-radius: 5px;\n  color: #FFF;\n  font-size: 60%;\n  margin: 0 4px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"box": "new-badge--box--1icbhRKp",
	"badge": "new-badge--badge--1Yhd8ofO",
	"notification": "new-badge--notification--1NIvURs-",
	"kpi": "new-badge--kpi--3LRJUBOm"
};

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _reactI18next = __webpack_require__(2);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/group-member-icons.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willUpdate: function willUpdate(props, nextProps) {
      if (props.ui.is_details != nextProps.ui.is_details && !nextProps.ui.is_details) {
        if (nextProps.ui.is_pc && nextProps.ui.show_summary) {
          nextProps.updateUI({ is_summary: true, is_pc: false, show_summary: false });
        }
      }
    },
    openMembersPage: function openMembersPage() {
      return dispatch(_actions2.default.openRightSidePage('group_members', { group_id: ownProps.group.group_id }));
    },
    showUserTimeline: function showUserTimeline(group_id, user) {
      return dispatch(_actions2.default.openRightSidePage('user_timeline', { group_id: group_id, user_id: user.user_id, user: user }));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(undefined, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    showAll: false,
    is_details: false,
    is_summary: false,
    user: undefined,
    is_pc: false,
    show_summary: false
  } }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    name: state.rightSidePage.name,
    params: state.rightSidePage.params,
    route: state.routing
  };
};
// src/connects/right-sidebar.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/pickup-diaries-page.js

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _store = __webpack_require__(18);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var group_id = ownProps.params && ownProps.params.group_id || ownProps.params && ownProps.params.group_id;
  var group = ownProps.group || (0, _store.getArray)('group_id', state.groups.items, group_id);

  return {
    group_id: group_id, group: group,
    diary_ids: ownProps.params && ownProps.params.diary_ids || ownProps.location && ownProps.location.query && ownProps.location.query.diary_ids,
    reported_at: ownProps.params && ownProps.params.reported_at || ownProps.location && ownProps.location.query && ownProps.location.query.reported_at,
    diaries: state.subDiaries.items || ownProps.params && ownProps.params.diaries,
    user: state.user.current,
    _hasMore: state.subDiaries.hasMore,
    isFetching: state.subDiaries.isFetching,
    isFetchFailed: state.subDiaries.isFetchFailed,
    likeConfig: state.likes.likeConfig,
    rightSidePage: state.rightSidePage.name
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({
    hasMore: stateProps.diary_ids ? false : stateProps._hasMore
  }, stateProps, dispatchProps, ownProps);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchDiaries: function fetchDiaries(props) {
      if (props.group_id && props.diary_ids) dispatch(_actions2.default.fetchSubDiaries(props.group_id, 0, { 'diary_ids[]': props.diary_ids }));else if (props.group_id && !props.diary_ids) dispatch(_actions2.default.fetchSubDiaries(props.group_id, props.diaries && props.diaries.length || 0, {
        reported_at_only: props.reported_at,
        category: props.params && props.params.category,
        user_id: props.params && props.params.user_id
      }));else dispatch(_actions2.default.fetchHomeSubDiaries(0, { 'diary_ids[]': props.diary_ids }));
    },

    readDiary: function readDiary(props, diary) {
      var read = diary.user && diary.user.user_id == props.user.user_id || diary.readers && (0, _find2.default)(diary.readers, function (reader) {
        return reader.user.user_id == props.user.user_id;
      });
      !read && dispatch(_actions2.default.markDiaryRead(diary.diary_id));
    },

    willMount: function willMount(props) {
      props.fetchDiaries(props);
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (props.group_id != nextProps.group_id || props.reported_at != nextProps.reported_at || props.params && nextProps.params && props.params.category != nextProps.params.category || props.params && nextProps.params && props.params.user_id != nextProps.params.user_id) dispatch(_actions2.default.clearSubDiaries());

      if (props.diary_ids != nextProps.diary_ids && nextProps.diary_ids) nextProps.fetchDiaries(nextProps);
    },

    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearSubDiaries());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _reactRouter = __webpack_require__(245);

var _isNaN = __webpack_require__(1063);

var _isNaN2 = _interopRequireDefault(_isNaN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/right-side-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    route: state.routing,
    rightSidePage: state.rightSidePage.name
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeRightSidePage: function closeRightSidePage(props) {
      if (props && !props.rightSidePage && props.route && props.route.locationBeforeTransitions) {
        var pathname = props.route.locationBeforeTransitions.pathname;
        var paths = pathname.split('/');
        !(0, _isNaN2.default)(parseInt(paths[paths.length - 1])) && paths.pop();

        _reactRouter.hashHistory.push(paths.slice(0, paths.length - 1).join('/'));
      } else {
        dispatch(_actions2.default.closeRightSidePage());
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(174),
    isObjectLike = __webpack_require__(117);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawNotificationsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _notificationsPage = __webpack_require__(2556);

var _notificationsPage2 = _interopRequireDefault(_notificationsPage);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _diaryFormsTab = __webpack_require__(570);

var _diaryFormsTab2 = _interopRequireDefault(_diaryFormsTab);

var _announcesTab = __webpack_require__(2558);

var _announcesTab2 = _interopRequireDefault(_announcesTab);

var _notificationsTab = __webpack_require__(2563);

var _notificationsTab2 = _interopRequireDefault(_notificationsTab);

var _newBadge = __webpack_require__(291);

var _newBadge2 = _interopRequireDefault(_newBadge);

var _tabs = __webpack_require__(188);

var _button = __webpack_require__(8);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/notifications-page.jsx

var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);

var NotificationsPage = function (_React$Component) {
  _inherits(NotificationsPage, _React$Component);

  function NotificationsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationsPage.__proto__ || Object.getPrototypeOf(NotificationsPage)).call.apply(_ref, [this].concat(args))), _this), _this.fetchNotifications = function () {
      return !_this.props.isFetching && _this.props.fetchNotifications(_this.props);
    }, _this.changeTab = function (tabIndex) {
      return _this.props.updateUI({ tabIndex: tabIndex });
    }, _this.openUrlPage = function (url) {
      return window.open(url);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          group_id = _props.group_id,
          openNotificationrSettingsPage = _props.openNotificationrSettingsPage;


      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: t('label:新着の通知'), icon: 'notifications',
          rightAction: [_react2.default.createElement(TooltipIconButton, { icon: 'settings', key: 'settings-notification', tooltip: t('label:通知設定'),
            onClick: function onClick() {
              return openNotificationrSettingsPage();
            } })] },
        _react2.default.createElement(
          _tabs.Tabs,
          { fixed: true, index: ui.tabIndex, onChange: this.changeTab, theme: _diaryFormsTab2.default },
          _react2.default.createElement(
            _tabs.Tab,
            { label: t('label:通知') },
            _react2.default.createElement(_notificationsTab2.default, { group_id: group_id })
          ),
          _react2.default.createElement(
            _tabs.Tab,
            { label: _react2.default.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'center', textTransform: 'none' } },
                t('label:gambaから'),
                !this.props.close && _react2.default.createElement('div', { className: _newBadge2.default.notification }) || null
              ) },
            _react2.default.createElement(_announcesTab2.default, null)
          )
        )
      );
    }
  }]);

  return NotificationsPage;
}(_react2.default.Component);

var RawNotificationsPage = exports.RawNotificationsPage = NotificationsPage;
exports.default = (0, _notificationsPage2.default)(NotificationsPage);

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _announceUnreadFlag = __webpack_require__(485);

var _announceUnreadFlag2 = _interopRequireDefault(_announceUnreadFlag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/notifications-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var group_id = ownProps.params.group_id;
  var latest = state.announce.latest;
  var close = state.announce.close;
  var user = state.user.current;
  return {
    group_id: group_id,
    latest: latest,
    close: close,
    user: user
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willUpdate: function willUpdate(props, nextProps) {
      /* お知らせタブから通知タブの切り替わったタイミングで条件が通る */
      if (props.ui.tabIndex == 1 && nextProps.ui.tabIndex == 0) {
        if (nextProps.user && nextProps.latest && (!nextProps.user.announce_last_seen_at || nextProps.user.announce_last_seen_at < nextProps.latest)) {
          dispatch(_actions2.default.saveAnnounceLastSeenTime(nextProps.latest));
          dispatch(_actions2.default.closeAnnounce());
        }
      }
    },
    willUnmount: function willUnmount(props) {
      /* 新着の通知ページ内のお知らせタブにいる状態でページを閉じた時、nextProps.user.announce_last_seen_atがnullか、announce_last_seen_atがlatestより過去の場合はannounce_last_seen_atを更新させる */
      if (props.ui.tabIndex == 1 && props.user && props.latest && (!props.user.announce_last_seen_at || props.user.announce_last_seen_at < props.latest)) {
        dispatch(_actions2.default.saveAnnounceLastSeenTime(props.latest));
        dispatch(_actions2.default.closeAnnounce());
      }
    },
    openNotificationrSettingsPage: function openNotificationrSettingsPage() {
      return dispatch(_actions2.default.openUserSettingsPage("notification"));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    tabIndex: function tabIndex(props) {
      return props.params && props.params.tabIndex || 0;
    }
  }
}), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('notifications'));

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.diary-forms-tab--label--83X5Fc-R {\n  padding: 7px 12px;\n}\n\n.diary-forms-tab--label--83X5Fc-R[class~=tab-label] {\n  padding: 3px 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; \n  -webkit-box-pack: center; \n      -ms-flex-pack: center; \n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.diary-forms-tab--tabs--Vwuw8Zow {\n  height: 100%;\n  overflow: hidden;\n}\n\n.diary-forms-tab--tab--3toMQot6 {\n  padding: 5px 0px 0px;\n  overflow: scroll !important;\n}\n\n.diary-forms-tab--tab--3toMQot6:focus {\n  outline: none;\n}\n\n.diary-forms-tab--fontIcon--1dmFBVnD {\n  vertical-align: middle;\n  margin-right: 3px;\n}\n\n[class~=icon-favorite] .diary-forms-tab--icon--3_nzRh5E {\n  font-size: 16px;\n  color: red;\n  line-height: 2;\n  margin-right: 5px;\n}\n\n[class~=icon-comment] .diary-forms-tab--icon--3_nzRh5E {\n  font-size: 16px;\n  color: blue;\n  line-height: 2;\n  margin-right: 5px;\n}\n\n[class~=icon-priority_high] .diary-forms-tab--icon--3_nzRh5E {\n  font-size: 16px;\n  color: orange;\n  line-height: 2;\n  margin-right: 5px;\n}\n\n[class~=icon-check] .diary-forms-tab--icon--3_nzRh5E {\n  font-size: 16px;\n  color: green;\n  line-height: 2;\n  margin-right: 5px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/diary-forms-tab.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB;;AAED;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;;AAED;EACE,aAAa;EACb,iBAAiB;CAClB;;AAED;EACE,qBAAqB;EACrB,4BAA4B;CAC7B;;AAED;EACE,cAAc;CACf;;AAED;EACE,uBAAuB;EACvB,kBAAkB;CACnB;;AAED;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;CACnB;;AAED;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;CACnB;;AAED;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;CACnB;;AAED;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kBAAkB;CACnB","file":"diary-forms-tab.css","sourcesContent":["\n.label {\n  padding: 7px 12px;\n}\n\n.label[class~=tab-label] {\n  padding: 3px 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; \n  -webkit-box-pack: center; \n      -ms-flex-pack: center; \n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.tabs {\n  height: 100%;\n  overflow: hidden;\n}\n\n.tab {\n  padding: 5px 0px 0px;\n  overflow: scroll !important;\n}\n\n.tab:focus {\n  outline: none;\n}\n\n.fontIcon {\n  vertical-align: middle;\n  margin-right: 3px;\n}\n\n[class~=icon-favorite] .icon {\n  font-size: 16px;\n  color: red;\n  line-height: 2;\n  margin-right: 5px;\n}\n\n[class~=icon-comment] .icon {\n  font-size: 16px;\n  color: blue;\n  line-height: 2;\n  margin-right: 5px;\n}\n\n[class~=icon-priority_high] .icon {\n  font-size: 16px;\n  color: orange;\n  line-height: 2;\n  margin-right: 5px;\n}\n\n[class~=icon-check] .icon {\n  font-size: 16px;\n  color: green;\n  line-height: 2;\n  margin-right: 5px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"label": "diary-forms-tab--label--83X5Fc-R",
	"tabs": "diary-forms-tab--tabs--Vwuw8Zow",
	"tab": "diary-forms-tab--tab--3toMQot6",
	"fontIcon": "diary-forms-tab--fontIcon--1dmFBVnD",
	"icon": "diary-forms-tab--icon--3_nzRh5E"
};

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawAnnouncesPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _announcesTab = __webpack_require__(2559);

var _announcesTab2 = _interopRequireDefault(_announcesTab);

var _list = __webpack_require__(25);

var _theme = __webpack_require__(266);

var _theme2 = _interopRequireDefault(_theme);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _wrapedList = __webpack_require__(1064);

var _wrapedList2 = _interopRequireDefault(_wrapedList);

var _announcesItem = __webpack_require__(2561);

var _announcesItem2 = _interopRequireDefault(_announcesItem);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/announces-tab.jsx

var AnnouncesPage = function (_React$Component) {
  _inherits(AnnouncesPage, _React$Component);

  function AnnouncesPage() {
    _classCallCheck(this, AnnouncesPage);

    return _possibleConstructorReturn(this, (AnnouncesPage.__proto__ || Object.getPrototypeOf(AnnouncesPage)).apply(this, arguments));
  }

  _createClass(AnnouncesPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          announces = _props.announces;


      return _react2.default.createElement(
        _list.List,
        { selectable: true, className: (0, _classnames2.default)(_theme2.default.list, _wrapedList2.default.list) },
        announces && announces.length > 0 && announces.map(function (announce) {
          return _react2.default.createElement(_announcesItem2.default, { key: announce.announce_id, isUnread: ui.currentDate < (0, _moment2.default)(announce.start_at).format('YYYY-MM-DD HH:mm:SS'), announce: announce });
        }),
        (!announces || announces.length == 0) && _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'center' } },
          t('label:通知がありません')
        )
      );
    }
  }]);

  return AnnouncesPage;
}(_react2.default.Component);

var RawAnnouncesPage = exports.RawAnnouncesPage = AnnouncesPage;
exports.default = (0, _announcesTab2.default)(AnnouncesPage);

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _announceUnreadFlag = __webpack_require__(485);

var _announceUnreadFlag2 = _interopRequireDefault(_announceUnreadFlag);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var announces = state.announce.announces;
  var latest = state.announce.latest;
  var close = state.announce.close;
  var user = state.user.current;
  return {
    announces: announces,
    latest: latest,
    close: close,
    user: user
  };
}; // src/connects/announces-tab.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willMount: function willMount(props) {
      /* announce_last_seen_atがnullの場合、以前の実装で既読情報をAnnouncesUnread.get/setで格納していたのでこちらの比較する*/
      if (props.user && !props.user.announce_last_seen_at) {
        _announceUnreadFlag2.default.get(function (currentDate) {
          if (!currentDate) {
            props.updateUI({ currentDate: (0, _moment2.default)(props.ui.currentDate).format('YYYY-MM-DD HH:mm:SS') });
          } else if ((0, _moment2.default)(props.ui.currentDate).isBefore((0, _moment2.default)(currentDate))) {
            props.updateUI({ currentDate: (0, _moment2.default)(currentDate).format('YYYY-MM-DD HH:mm:SS') });
          }
        });
      }
      /* announce_last_seen_atにデータがあり、ui.currnetDateよりも最新だった場合はこちらを格納する */
      if (props.user && props.user.announce_last_seen_at > props.ui.currentDate) {
        props.updateUI({ currentDate: props.user.announce_last_seen_at });
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    currentDate: '2021-01-01 00:00:00'
  }
}), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('notifications'));

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.wraped-list--list--3Gvfq7GV {\n  white-space: normal;\n  white-space: initial;\n}\n\n.wraped-list--itemText--2XzlY71Q {\n  font-size: 14px!important;\n}\n\n.wraped-list--itemContentRoot--fJiRum0x {\n  height: auto!important;\n}\n\n.wraped-list--listItem--ROF4mT7J[class~=\"priority\"] {\n  background-color: #FAFAD2;\n}\n\n.wraped-list--listItem--ROF4mT7J[class~=\"priority\"]:hover {\n  background-color: #FAFAD2;\n}\n\n.wraped-list--listItem--ROF4mT7J[class~=\"unread\"] {\n  font-weight: bold;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/wraped-list.css"],"names":[],"mappings":";AACA;EACE,oBAAoB;EACpB,qBAAqB;CACtB;;AAED;EACE,0BAA0B;CAC3B;;AAED;EACE,uBAAuB;CACxB;;AAED;EACE,0BAA0B;CAC3B;;AAED;EACE,0BAA0B;CAC3B;;AAED;EACE,kBAAkB;CACnB","file":"wraped-list.css","sourcesContent":["\n.list {\n  white-space: normal;\n  white-space: initial;\n}\n\n.itemText {\n  font-size: 14px!important;\n}\n\n.itemContentRoot {\n  height: auto!important;\n}\n\n.listItem[class~=\"priority\"] {\n  background-color: #FAFAD2;\n}\n\n.listItem[class~=\"priority\"]:hover {\n  background-color: #FAFAD2;\n}\n\n.listItem[class~=\"unread\"] {\n  font-weight: bold;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"list": "wraped-list--list--3Gvfq7GV",
	"itemText": "wraped-list--itemText--2XzlY71Q",
	"itemContentRoot": "wraped-list--itemContentRoot--fJiRum0x",
	"listItem": "wraped-list--listItem--ROF4mT7J"
};

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emojiHelpers = __webpack_require__(146);

var _list = __webpack_require__(25);

var _announcesList = __webpack_require__(1065);

var _announcesList2 = _interopRequireDefault(_announcesList);

var _diaryTimestamp = __webpack_require__(238);

var _diaryTimestamp2 = _interopRequireDefault(_diaryTimestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // src/web/components/announces-item.jsx

var AnnouncesItem = function (_React$Component) {
  _inherits(AnnouncesItem, _React$Component);

  function AnnouncesItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AnnouncesItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnnouncesItem.__proto__ || Object.getPrototypeOf(AnnouncesItem)).call.apply(_ref, [this].concat(args))), _this), _this.openURL = function (url) {
      return window.open(url);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AnnouncesItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          key = _props.key,
          isUnread = _props.isUnread,
          announce = _props.announce;
      var start_at = announce.start_at,
          text = announce.text,
          url = announce.url,
          icon_url = announce.icon_url;

      var description = (0, _emojiHelpers.convertEmojiHTML)(text).replace(/\r?\n/g, '<br>');

      return _react2.default.createElement(_list.ListItem, { selectable: true,
        key: key,
        className: isUnread ? 'unread' : '',
        onClick: function onClick() {
          return _this2.openURL(url);
        },
        caption: _react2.default.createElement(_diaryTimestamp2.default, { timestamp: start_at }),
        legend: _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: description } }),
        avatar: icon_url,
        theme: _announcesList2.default });
    }
  }]);

  return AnnouncesItem;
}(_react2.default.Component);

exports.default = AnnouncesItem;

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.announces-list--list--1Qa3-v7G {\n    white-space: normal;\n    white-space: initial;\n  }\n  \n  .announces-list--itemText--1hZ0qw67 {\n    font-size: 14px!important;\n  }\n  \n  .announces-list--itemContentRoot--2CEU9yyt {\n    height: auto!important;\n  }\n  \n  .announces-list--listItem--3KcKiYeK[class~=\"priority\"] {\n    background-color: #FAFAD2;\n  }\n  \n  .announces-list--listItem--3KcKiYeK[class~=\"priority\"]:hover {\n    background-color: #FAFAD2;\n  }\n  \n  .announces-list--listItem--3KcKiYeK[class~=\"unread\"] {\n    font-weight: bold;\n  }\n  \n  .announces-list--listItem--3KcKiYeK .announces-list--item--1HwIITvZ {\n    -webkit-box-align: start!important;\n        -ms-flex-align: start!important;\n            align-items: start!important;\n  }\n  \n  .announces-list--listItem--3KcKiYeK .announces-list--left--Dm4Ka1p3 {\n    margin-top: 10px;\n  }\n  \n  .announces-list--listItem--3KcKiYeK .announces-list--itemContentRoot--2CEU9yyt {\n    margin-top: 10px;\n  }\n  \n  .announces-list--listItem--3KcKiYeK .announces-list--itemText--1hZ0qw67 {\n    color: rgb(33, 33, 33)!important;\n  }\n", "", {"version":3,"sources":["/./src/web/components/themes/announces-list.css"],"names":[],"mappings":";AACA;IACI,oBAAoB;IACpB,qBAAqB;GACtB;;EAED;IACE,0BAA0B;GAC3B;;EAED;IACE,uBAAuB;GACxB;;EAED;IACE,0BAA0B;GAC3B;;EAED;IACE,0BAA0B;GAC3B;;EAED;IACE,kBAAkB;GACnB;;EAED;IACE,mCAAmC;QAC/B,gCAAgC;YAC5B,6BAA6B;GACtC;;EAED;IACE,iBAAiB;GAClB;;EAED;IACE,iBAAiB;GAClB;;EAED;IACE,iCAAiC;GAClC","file":"announces-list.css","sourcesContent":["\n.list {\n    white-space: normal;\n    white-space: initial;\n  }\n  \n  .itemText {\n    font-size: 14px!important;\n  }\n  \n  .itemContentRoot {\n    height: auto!important;\n  }\n  \n  .listItem[class~=\"priority\"] {\n    background-color: #FAFAD2;\n  }\n  \n  .listItem[class~=\"priority\"]:hover {\n    background-color: #FAFAD2;\n  }\n  \n  .listItem[class~=\"unread\"] {\n    font-weight: bold;\n  }\n  \n  .listItem .item {\n    -webkit-box-align: start!important;\n        -ms-flex-align: start!important;\n            align-items: start!important;\n  }\n  \n  .listItem .left {\n    margin-top: 10px;\n  }\n  \n  .listItem .itemContentRoot {\n    margin-top: 10px;\n  }\n  \n  .listItem .itemText {\n    color: rgb(33, 33, 33)!important;\n  }\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"list": "announces-list--list--1Qa3-v7G",
	"itemText": "announces-list--itemText--1hZ0qw67",
	"itemContentRoot": "announces-list--itemContentRoot--2CEU9yyt",
	"listItem": "announces-list--listItem--3KcKiYeK",
	"item": "announces-list--item--1HwIITvZ",
	"left": "announces-list--left--Dm4Ka1p3"
};

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawNotificationsTab = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _notificationsTab = __webpack_require__(2564);

var _notificationsTab2 = _interopRequireDefault(_notificationsTab);

var _theme = __webpack_require__(266);

var _theme2 = _interopRequireDefault(_theme);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _infiniteScroller = __webpack_require__(75);

var _notificationsItem = __webpack_require__(2565);

var _notificationsItem2 = _interopRequireDefault(_notificationsItem);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _wrapedList = __webpack_require__(1064);

var _wrapedList2 = _interopRequireDefault(_wrapedList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/notifications-tab.jsx

var NotificationsTab = function (_React$Component) {
  _inherits(NotificationsTab, _React$Component);

  function NotificationsTab() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotificationsTab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationsTab.__proto__ || Object.getPrototypeOf(NotificationsTab)).call.apply(_ref, [this].concat(args))), _this), _this.fetchNotifications = function () {
      return !_this.props.isFetching && _this.props.fetchNotifications(_this.props);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotificationsTab, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          group_id = _props.group_id,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          hasMore = _props.hasMore,
          notifications = _props.notifications;


      if (!isFetchFailed && notifications && notifications.length > 0) return _react2.default.createElement(
        _infiniteScroller.InfiniteScroll,
        { pageStart: 0,
          element: 'ul',
          initialLoad: false,
          className: (0, _classnames2.default)(_theme2.default.list, _wrapedList2.default.list),
          hasMore: hasMore && !isFetchFailed,
          loadMore: this.fetchNotifications,
          loader: notifications && _react2.default.createElement(
            'div',
            { style: { width: '100%', textAlign: 'center' } },
            _react2.default.createElement(_progress_bar2.default, { type: 'circular', mode: 'indeterminate', multicolor: true })
          ),
          useWindow: false },
        notifications && notifications.map(function (notification) {
          return _react2.default.createElement(_notificationsItem2.default, { key: notification.notification_id, notification: notification, group_id: group_id });
        })
      );else if (isFetchFailed) return _react2.default.createElement(
        'div',
        { style: { marginTop: '10px', textAlign: 'center' } },
        t('label:通知の取得に失敗しました')
      );else if (!isFetchFailed && !notifications && isFetching) return _react2.default.createElement(_loading2.default, null);else return _react2.default.createElement(
        'div',
        { style: { display: 'flex', justifyContent: 'center', padding: 8 } },
        t('label:通知がありません')
      );
    }
  }]);

  return NotificationsTab;
}(_react2.default.Component);

var RawNotificationsTab = exports.RawNotificationsTab = NotificationsTab;
exports.default = (0, _notificationsTab2.default)(NotificationsTab);

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var group = state.notifications.groups[ownProps.group_id] || {};
  return {
    isFetching: group.isFetching,
    isFetchFailed: group.isFetchFailed,
    hasMore: group.hasMore,
    notifications: group.items,
    currentDivisionId: state.divisions.currentId
  };
};
// src/connects/notifications-tab.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchNotifications: function fetchNotifications(props) {
      var offset = props.notifications && props.notifications.length || 0;
      if (ownProps.group_id == 'home') {
        var currentDivisionId = props.currentDivisionId;

        dispatch(_actions2.default.fetchHomeNotifications(offset, currentDivisionId));
      } else dispatch(_actions2.default.fetchNotifications(ownProps.group_id, offset));
    },
    willMount: function willMount(props) {
      if (ownProps.group_id == 'home') {
        var currentDivisionId = props.currentDivisionId;

        dispatch(_actions2.default.fetchHomeNotifications(0, currentDivisionId));
        dispatch(_actions2.default.flushUnreadHomeNotifications(currentDivisionId));
      } else {
        dispatch(_actions2.default.fetchNotifications(ownProps.group_id, 0));
        dispatch(_actions2.default.flushUnreadNotifications(ownProps.group_id));
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawNotificationsItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _notificationsItem = __webpack_require__(2566);

var _notificationsItem2 = _interopRequireDefault(_notificationsItem);

var _infiniteScroller = __webpack_require__(75);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactI18next = __webpack_require__(2);

var _emojiHelpers = __webpack_require__(146);

var _button = __webpack_require__(8);

var _list = __webpack_require__(25);

var _announcesList = __webpack_require__(1065);

var _announcesList2 = _interopRequireDefault(_announcesList);

var _diaryTimestamp = __webpack_require__(238);

var _diaryTimestamp2 = _interopRequireDefault(_diaryTimestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/notifications-item.jsx

var NotificationsItem = function (_React$Component) {
  _inherits(NotificationsItem, _React$Component);

  function NotificationsItem(props) {
    _classCallCheck(this, NotificationsItem);

    var _this = _possibleConstructorReturn(this, (NotificationsItem.__proto__ || Object.getPrototypeOf(NotificationsItem)).call(this, props));

    _this.state = { prioritized: !!props.notification.priority };
    return _this;
  }

  _createClass(NotificationsItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          notification = _props.notification,
          onClick = _props.onClick,
          togglePriority = _props.togglePriority;
      var priority = notification.priority,
          category = notification.category,
          delivered_at = notification.delivered_at,
          created_at = notification.created_at;

      var description = (0, _emojiHelpers.convertEmojiHTML)(notification.description);

      return _react2.default.createElement(_list.ListItem, { selectable: true,
        className: !delivered_at && 'unread' || '',
        onClick: onClick,
        caption: _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: description } }),
        legend: _react2.default.createElement(_diaryTimestamp2.default, { timestamp: created_at }),
        avatar: notification.icon_image.thumb_url,
        rightActions: [this.state.prioritized && _react2.default.createElement(_button.IconButton, { key: 'button', icon: priority ? "star" : "star_border", style: { color: priority ? '#FFCC00' : '#000' }, onClick: togglePriority })],
        theme: _announcesList2.default });
    }
  }]);

  return NotificationsItem;
}(_react2.default.Component);

var RawNotificationsItem = exports.RawNotificationsItem = NotificationsItem;
exports.default = (0, _notificationsItem2.default)(NotificationsItem);

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _route = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {};
};
// src/connects/notifications-item.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var notification = ownProps.notification;

  return {
    togglePriority: function togglePriority() {
      dispatch(_actions2.default.updateNotificationStatus(notification.notification_id, {
        priority: notification.priority > 0 ? 0 : 3
      }));
    },

    onClick: function onClick() {
      if (!notification.delivered_at) dispatch(_actions2.default.updateNotificationStatus(notification.notification_id, { delivered: true, priority: 0 }));

      switch (notification.category) {
        case 'group_profile_updated':
        case 'user_profile_updated':
          dispatch(_actions2.default.openRightSidePage('group_members', { group_id: notification.group_id }, true));
          break;
        case 'kpi_updated':
          dispatch(_actions2.default.openRightSidePage('kpi_chart', { kpi_id: notification.kpi_id, group_id: notification.group_id }, true));
          break;
        case 'diary_replied':
          dispatch(_actions2.default.openRightSidePage('pickup_diaries', { diary_ids: [notification.diary_id] }, true));
          break;
        case 'diary_reported':
        case 'memo_repoted':
        case 'kpi_repoted':
        default:
          if (notification.diary_id) dispatch(_actions2.default.openRightSidePage('pickup_diaries', { diary_ids: [notification.diary_id] }, true));else if (notification.reported_at && ownProps.group_id == 'home') {
            dispatch(_actions2.default.closeRightSidePage());
            (0, _route.pushRoute)('group_timeline', { group_id: notification.group_id });
          } else if (notification.reported_at && ownProps.group_id != 'home') {
            var params = {
              reported_at: notification.reported_at,
              group_id: notification.group_id
            };
            if (notification.category != 'favorite_reported') params.category = notification.category.replace(/(diary|memo|kpi)_.*/, '$1');
            if (notification.parent_user_id) params.user_id = notification.parent_user_id;
            dispatch(_actions2.default.openRightSidePage('pickup_diaries', params, true));
          }
          break;
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawAttachmentsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _attachmentsPage = __webpack_require__(2568);

var _attachmentsPage2 = _interopRequireDefault(_attachmentsPage);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _videoViewer = __webpack_require__(353);

var _videoViewer2 = _interopRequireDefault(_videoViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // src/web/components/attachments-page.jsx

function isVideo(video) {
  return video.content_type.match(/^video/) && video.status == 'committed';
}

var AttachmentsPage = function (_React$Component) {
  _inherits(AttachmentsPage, _React$Component);

  function AttachmentsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AttachmentsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AttachmentsPage.__proto__ || Object.getPrototypeOf(AttachmentsPage)).call.apply(_ref, [this].concat(args))), _this), _this.showImagesView = function (image) {
      _this.props.showImagesView('GROUP_TIMELINE', _this.props.params.diary_id, image);
    }, _this.onClick = function (image) {
      _this.showImagesView(image);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AttachmentsPage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          params = _props.params,
          files = _props.files,
          images = _props.images,
          videos = _props.videos,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          showImagesView = _props.showImagesView;


      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: t('label:添付ファイル'), icon: 'photo_library' },
        !isFetchFailed && isFetching && _react2.default.createElement(_loading2.default, null),
        !isFetchFailed && !isFetching && !params.file && images && images.length > 0 && _lodash2.default.map(images, function (image, i) {
          return _react2.default.createElement(
            'div',
            { key: image.file_id },
            _react2.default.createElement(
              'span',
              { style: { margin: '0 0 5px 30px' } },
              image.name
            ),
            _react2.default.createElement('img', { key: image.file_id,
              src: image.file.url,
              style: { maxWidth: '100%', display: 'block', margin: '3px auto', cursor: 'pointer', marginBottom: '30px', paddingRight: '30px', paddingLeft: '30px' },
              onClick: function onClick() {
                return _this2.showImagesView(image);
              } })
          );
        }),
        !isFetchFailed && !isFetching && !params.file && videos && videos.length > 0 && _lodash2.default.map(videos, function (video, i) {
          return _react2.default.createElement(
            'div',
            { key: video.video_id, style: { marginBottom: '30px' } },
            _react2.default.createElement(_videoViewer2.default, { video: video, t: t, parent_component: 'ATTACHMENTS_PAGE', params: params })
          );
        }),
        !isFetchFailed && !isFetching && params.file && _react2.default.createElement(
          'div',
          { key: params.file.video_id, style: { marginBottom: '20px' } },
          _react2.default.createElement(
            'span',
            { style: { display: 'block', textAlign: 'center' } },
            params.file.name
          ),
          _react2.default.createElement(_videoViewer2.default, { video: params.file, t: t, parent_component: 'ATTACHMENTS_PAGE', params: params })
        ),
        isFetchFailed && _react2.default.createElement(
          'div',
          { style: { marginTop: '10px', textAlign: 'center' } },
          t('label:添付ファイルの取得に失敗しました')
        )
      );
    }
  }]);

  return AttachmentsPage;
}(_react2.default.Component);

var RawAttachmentsPage = exports.RawAttachmentsPage = AttachmentsPage;
exports.default = (0, _attachmentsPage2.default)(AttachmentsPage);

/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/attachments-page.js

function isImage(file) {
  return file.content_type.match(/^image/);
}

function isVideo(file) {
  return file.content_type.match(/^video/) && (file.file_id || file.status == 'committed');
}

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var items = state.attachments.items;
  return {
    isFetching: state.attachments.isFetching,
    isFetchFailed: state.attachments.isFetchFailed,
    files: items,
    images: items && (0, _filter2.default)(items, isImage) || undefined,
    videos: items && (0, _filter2.default)(items, isVideo) || undefined
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willMount: function willMount() {
      if (ownProps.params.comment_id) {
        ownProps.params.comment_id && dispatch(_actions2.default.fetchCommentAttachments(ownProps.params.comment_id));
      } else {
        ownProps.params.diary_id && dispatch(_actions2.default.fetchDiaryAttachments(ownProps.params.diary_id));
      }
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (nextProps.params.comment_id && props.params.comment_id != nextProps.params.comment_id) dispatch(_actions2.default.fetchCommentAttachments(nextProps.params.comment_id));else if (nextProps.params.diary_id && (props.params.diary_id != nextProps.params.diary_id || props.params.comment_id && !nextProps.params.comment_id))
        //コメントの添付ファイルを表示後、同じdiary_idの日報の添付ファイルをクリックした場合、nextProps.params.comment_id = undefined となる
        dispatch(_actions2.default.fetchDiaryAttachments(nextProps.params.diary_id));
    },

    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearAttachments());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _context2.default)({ showImagesView: _propTypes2.default.func }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUserTimelinePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _userTimelinePage = __webpack_require__(2570);

var _userTimelinePage2 = _interopRequireDefault(_userTimelinePage);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _diary = __webpack_require__(171);

var _diary2 = _interopRequireDefault(_diary);

var _diaryContent = __webpack_require__(239);

var _diaryContent2 = _interopRequireDefault(_diaryContent);

var _userMonthlySummaryPage = __webpack_require__(1066);

var _userMonthlySummaryPage2 = _interopRequireDefault(_userMonthlySummaryPage);

var _infiniteScroller = __webpack_require__(75);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _layout = __webpack_require__(85);

var _twoColumnLayout = __webpack_require__(205);

var _twoColumnLayout2 = _interopRequireDefault(_twoColumnLayout);

var _profile = __webpack_require__(2579);

var _profile2 = _interopRequireDefault(_profile);

var _diary3 = __webpack_require__(71);

var _diary4 = _interopRequireDefault(_diary3);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/user-timeline-page.jsx

var UserTimelinePage = function (_React$Component) {
  _inherits(UserTimelinePage, _React$Component);

  function UserTimelinePage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserTimelinePage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserTimelinePage.__proto__ || Object.getPrototypeOf(UserTimelinePage)).call.apply(_ref, [this].concat(args))), _this), _this.updateFavoriteUser = function () {
      return _this.props.updateFavoriteUser(_this.props, !_this.props.isFavorite);
    }, _this.updateBlockUser = function () {
      return _this.props.updateBlockUser(_this.props.targetUser, !_this.props.isBlock);
    }, _this.onReplyScrollFrom = function (offset) {
      //COMMENT_FORM_HEIGHTはコメントフォームの高さ
      var COMMENT_FORM_HEIGHT = 222;
      //返信コメントへの返信の場合、コメントフォームまでスクロールする
      _this.rightSidePage.scrollTo(offset += COMMENT_FORM_HEIGHT);
    }, _this.openMonthlySummary = function () {
      return typeof _this.props.targetUser.is_member != 'undefined' ? _this.props.updateUI({ is_summary: true }) : _this.props.notIsMember();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserTimelinePage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          hasMore = _props.hasMore,
          diaries = _props.diaries,
          user = _props.user,
          targetUser = _props.targetUser,
          group = _props.group,
          fetchDiaries = _props.fetchDiaries,
          isFavorite = _props.isFavorite,
          isBlock = _props.isBlock,
          updateUI = _props.updateUI,
          openChatRoom = _props.openChatRoom,
          openUserSettingsPage = _props.openUserSettingsPage,
          updateFavoriteUser = _props.updateFavoriteUser,
          updateBlockUser = _props.updateBlockUser,
          likeConfig = _props.likeConfig,
          rightSidePage = _props.rightSidePage,
          notIsMember = _props.notIsMember;


      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: targetUser && targetUser.name || null, innerRef: function innerRef(c) {
            return _this2.rightSidePage = c;
          },
          icon: !targetUser && "person",
          image: targetUser && targetUser.icon_image.thumb_url,
          rightAction: targetUser && !targetUser.dummy_user && targetUser.user_id != user.user_id && _react2.default.createElement(_button.Button, { theme: _diary4.default, className: 'profile', ripple: false, neutral: false,
            icon: _react2.default.createElement(_font_icon2.default, { value: isFavorite && 'flag' || 'outlined_flag', style: isFavorite && { color: '#FFCC00' } || undefined }),
            onClick: this.updateFavoriteUser,
            label: isFavorite ? t('label:フォロー中') : t('label:お気に入りに追加') }) },
        !isFetchFailed && !diaries && isFetching && _react2.default.createElement(_loading2.default, null),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', marginBottom: 10 } },
          _react2.default.createElement(_avatar2.default, { theme: _profile2.default, icon: !targetUser && "person", image: targetUser && targetUser.icon_image.thumb_url }),
          _react2.default.createElement(
            'div',
            { style: { marginTop: 10, marginLeft: 15 } },
            targetUser && _react2.default.createElement(
              'div',
              { className: _profile2.default.information_wrap },
              _react2.default.createElement(
                'div',
                { className: _profile2.default.information_item },
                _react2.default.createElement(
                  'div',
                  null,
                  t('label:社員番号'),
                  ':'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  ' ',
                  targetUser.employment_number
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _profile2.default.information_item },
                _react2.default.createElement(
                  'div',
                  null,
                  t('label:部署'),
                  ':'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  ' ',
                  targetUser.department && targetUser.department.name || ''
                )
              ),
              _react2.default.createElement(
                'div',
                { className: _profile2.default.information_item },
                _react2.default.createElement(
                  'div',
                  null,
                  t('label:誕生日'),
                  ':'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  ' ',
                  targetUser.birthday && (0, _moment2.default)(targetUser.birthday).format('MM月 DD日') || ''
                )
              )
            ),
            group && targetUser && !targetUser.dummy_user && _react2.default.createElement(_button.Button, { raised: true, primary: true, theme: _diary4.default, className: 'profile',
              icon: _react2.default.createElement(_font_icon2.default, { value: 'check_box' }),
              onClick: this.openMonthlySummary,
              label: t('label:日報提出状況') }),
            targetUser && !targetUser.dummy_user && targetUser.user_id != user.user_id && _react2.default.createElement(_button.Button, { raised: true, theme: _diary4.default, className: 'chat',
              icon: _react2.default.createElement(_font_icon2.default, { value: 'comment' }),
              onClick: function onClick() {
                return openChatRoom(_this2.props);
              },
              label: t('label:チャットをする') }),
            targetUser && !targetUser.dummy_user && targetUser.user_id == user.user_id && _react2.default.createElement(_button.Button, { raised: true, theme: _diary4.default, className: 'profile',
              icon: _react2.default.createElement(_font_icon2.default, { value: 'edit', style: { color: 'black' } }),
              onClick: function onClick() {
                return openUserSettingsPage();
              },
              label: t('label:プロフィールを編集') })
          )
        ),
        !isFetchFailed && targetUser && targetUser.description && _react2.default.createElement(_diaryContent2.default, { profile: true, component: 'div', content: targetUser.description }),
        !isFetchFailed && _react2.default.createElement(
          _infiniteScroller.InfiniteScroll,
          { pageStart: 0,
            hasMore: hasMore && !isFetchFailed,
            initialLoad: false,
            loadMore: function loadMore() {
              return !isFetching && fetchDiaries(_this2.props);
            },
            loader: diaries && _react2.default.createElement(_loading2.default, null),
            useWindow: false },
          diaries && diaries.map(function (diary) {
            return _react2.default.createElement(_diary2.default, { key: diary.diary_id, diary: diary, group: group, user: user, onReplyScrollFrom: _this2.onReplyScrollFrom, likeConfig: likeConfig, openSidePage: rightSidePage, isBlockDisable: true, isReviewButtonDisplay: false });
          })
        ),
        !isFetchFailed && diaries && diaries.length == 0 && !hasMore && _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'center' } },
          t('label:投稿がありません')
        ),
        !isFetchFailed && diaries && diaries.length > 0 && !hasMore && _react2.default.createElement(
          'div',
          { style: { fontSize: '80%', padding: '0 20px', color: '#999' } },
          t('label:一番最後の投稿です')
        ),
        isFetchFailed && _react2.default.createElement(
          'div',
          { style: { marginTop: '10px', textAlign: 'center' } },
          t('label:投稿の取得に失敗しました')
        ),
        group && targetUser && !targetUser.dummy_user && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_userMonthlySummaryPage2.default, {
            group: group,
            currentUser: user,
            user: targetUser,
            onClose: function onClose() {
              return updateUI({ is_summary: false });
            },
            open: ui.is_summary })
        )
      );
    }
  }]);

  return UserTimelinePage;
}(_react2.default.Component);

var RawUserTimelinePage = exports.RawUserTimelinePage = UserTimelinePage;
exports.default = (0, _userTimelinePage2.default)(UserTimelinePage);

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/user-timeline-page.js

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isFetching: state.subDiaries.isFetching,
    isFetchFailed: state.subDiaries.isFetchFailed,
    hasMore: state.subDiaries.hasMore,
    diaries: state.subDiaries.items,
    _groups: state.groups.items,
    user: state.user.current,
    users: state.users.items,
    _favoriteUsers: state.favorite.users,
    _blockUsers: state.block.users,
    isCreating: state.chatRooms.isCreating,
    isCreateFailed: state.chatRooms.isCreateFailed,
    created: state.chatRooms.created,
    likeConfig: state.likes.likeConfig,
    rightSidePage: state.rightSidePage.name
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var group = ownProps.params.group_id && (0, _find2.default)(stateProps._groups, function (item) {
    return item.group_id == ownProps.params.group_id;
  }) || undefined;
  var targetUser = group && group.members && (0, _find2.default)(group.members, function (item) {
    return item.user_id == ownProps.params.user_id;
  }) || stateProps.users && stateProps.users[ownProps.params.user_id];
  var isFavorite = targetUser && (0, _find2.default)(stateProps._favoriteUsers, function (user) {
    return user.user_id == targetUser.user_id;
  });
  var isBlock = targetUser && (0, _find2.default)(stateProps._blockUsers, function (user) {
    return user.user_id == targetUser.user_id;
  });

  return _extends({
    isFavorite: !!isFavorite,
    isBlock: !!isBlock,
    group: group,
    targetUser: targetUser
  }, stateProps, dispatchProps, ownProps);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchDiaries: function fetchDiaries(props) {
      if (props.isFetching || props.isFetchFailed || !props.hasMore) return;
      if (props.params.group_id) dispatch(_actions2.default.fetchSubDiaries(props.params.group_id, props.diaries && props.diaries.length || 0, { user_id: props.params.user_id }));else dispatch(_actions2.default.fetchHomeSubUserDiaries(props.diaries && props.diaries.length || 0, props.params.user_id));
    },

    updateFavoriteUser: function updateFavoriteUser(props, favorite) {
      dispatch(_actions2.default.updateFavoriteUser(props.targetUser.user_id, favorite));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: favorite ? 'label:お気に入りユーザに追加しました' : 'label:お気に入りユーザから削除しました', name: props.targetUser && props.targetUser.name }, 'success'));
    },

    updateBlockUser: function updateBlockUser(user, block) {
      dispatch(_actions2.default.updateBlockUser(user.user_id, block));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: block ? 'label:ユーザをブロックしました' : 'label:ユーザをブロック解除しました', name: user && user.name }, 'success'));
    },

    openChatRoom: function openChatRoom(props) {
      if (props.targetUser.user_id != props.user.user_id) {
        var chatuser = [props.targetUser.user_id];
        dispatch(_actions2.default.createChatRoom(chatuser));
      } else {
        dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:ご自身のユーザーでチャットを行うことはできません' }, 'error'));
      }
    },

    notIsMember: function notIsMember() {
      return dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:対象ユーザーはこのグループに所属していません' }, 'error'));
    },

    openUserSettingsPage: function openUserSettingsPage() {
      dispatch(_actions2.default.openUserSettingsPage("profile"));
    },

    readDiary: function readDiary(props, diary) {
      var read = diary.user && diary.user.user_id == props.user.user_id || diary.readers && (0, _find2.default)(diary.readers, function (reader) {
        return reader.user.user_id == props.user.user_id;
      });
      !read && dispatch(_actions2.default.markDiaryRead(diary.diary_id));
    },

    willMount: function willMount(props) {
      if (!props.targetUser) dispatch(_actions2.default.fetchUserInfo(props.params.user_id));
      dispatch(_actions2.default.fetchFavoriteUsers());
      if (props.params.group_id) dispatch(_actions2.default.fetchSubDiaries(props.params.group_id, 0, { user_id: props.params.user_id }));else dispatch(_actions2.default.fetchHomeSubUserDiaries(0, props.params.user_id));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (props.params.group_id && props.params.group_id != nextProps.params.group_id || props.params.user_id != nextProps.params.user_id) {
        dispatch(_actions2.default.fetchUserInfo(nextProps.params.user_id));
        if (nextProps.params.group_id) {
          dispatch(_actions2.default.fetchSubDiaries(nextProps.params.group_id, 0, { user_id: nextProps.params.user_id }));
        } else {
          dispatch(_actions2.default.fetchHomeSubUserDiaries(0, nextProps.params.user_id));
        }
      }
      if (props.isCreating && !nextProps.isCreating && !nextProps.isCreateFailed && nextProps.created) {
        dispatch(_actions2.default.openRightSidePage('chat_messages', { chat_room_id: nextProps.created.chat_room_id }));
      }
    },

    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearSubDiaries());
    },
    postUserReport: function postUserReport(props) {
      dispatch(_actions2.default.postUserReport(props.user.user_id, props.targetUser.user_id));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({
  state: {
    is_summary: false
  } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('user_timeline'));

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _formValidator = __webpack_require__(41);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isPhone: state.media.isPhone,
    access_token: state.sessions.access_token
  };
};
/**
* src/connects/user-monthly-summary-page.js
*/

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps), (0, _uiState2.default)({ state: {
    date: (0, _moment2.default)(),
    edit: false
  } }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".user-monthly-summary-page--dialog--2RxdYShT {\n  width: calc(100% - 50px);\n  max-width: 900px;\n}\n\n.user-monthly-summary-page--body--3Yzd-CAX {\n  text-align: center;\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.user-monthly-summary-page--displayMonth--Cjadc7Mt {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.user-monthly-summary-page--cursor--1_Aqa502 {\n  cursor: pointer;\n}\n\n.user-monthly-summary-page--notAllowed--3nPIO-Oe {\n  cursor: not-allowed;\n}\n\n.user-monthly-summary-page--icons--1dekrDQH {\n  display: inherit;\n  text-align: right;\n  margin-right: 60px;\n}\n\n.user-monthly-summary-page--icon--2-cP5MXD {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin-right: 5px;\n  margin-left: 5px;\n\n}\n\n.user-monthly-summary-page--descFontIcon--IEVbMeU7 {\n  color: green;\n  font-size: 19.2px;\n  font-size: 1.2rem;\n}\n\n.user-monthly-summary-page--scheduleIcon--1ajNE40P {\n  color: #AAAAAA; \n  font-size: 19.2px; \n  font-size: 1.2rem;\n}\n\n.user-monthly-summary-page--descText--_Iaq1dq5 {\n  font-size: 13px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/user-monthly-summary-page.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;CAClB;;AAED;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;CACrB;;AAED;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;CACtB;;AAED;EACE,gBAAgB;CACjB;;AAED;EACE,oBAAoB;CACrB;;AAED;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;CACpB;;AAED;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;;CAElB;;AAED;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,gBAAgB;CACjB","file":"user-monthly-summary-page.css","sourcesContent":[".dialog {\n  width: calc(100% - 50px);\n  max-width: 900px;\n}\n\n.body {\n  text-align: center;\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.displayMonth {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.notAllowed {\n  cursor: not-allowed;\n}\n\n.icons {\n  display: inherit;\n  text-align: right;\n  margin-right: 60px;\n}\n\n.icon {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin-right: 5px;\n  margin-left: 5px;\n\n}\n\n.descFontIcon {\n  color: green;\n  font-size: 19.2px;\n  font-size: 1.2rem;\n}\n\n.scheduleIcon {\n  color: #AAAAAA; \n  font-size: 19.2px; \n  font-size: 1.2rem;\n}\n\n.descText {\n  font-size: 13px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"dialog": "user-monthly-summary-page--dialog--2RxdYShT",
	"body": "user-monthly-summary-page--body--3Yzd-CAX",
	"displayMonth": "user-monthly-summary-page--displayMonth--Cjadc7Mt",
	"cursor": "user-monthly-summary-page--cursor--1_Aqa502",
	"notAllowed": "user-monthly-summary-page--notAllowed--3nPIO-Oe",
	"icons": "user-monthly-summary-page--icons--1dekrDQH",
	"icon": "user-monthly-summary-page--icon--2-cP5MXD",
	"descFontIcon": "user-monthly-summary-page--descFontIcon--IEVbMeU7",
	"scheduleIcon": "user-monthly-summary-page--scheduleIcon--1ajNE40P",
	"descText": "user-monthly-summary-page--descText--_Iaq1dq5"
};

/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/**
* src/connects/user-monthly-activities-table.js
* 
*/

var _reactRedux = __webpack_require__(11);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _times = __webpack_require__(2574);

var _times2 = _interopRequireDefault(_times);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _checkHoliday = __webpack_require__(2575);

var _checkHoliday2 = _interopRequireDefault(_checkHoliday);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isMonthlyFetching: state.activityReport.isMonthlyFetching,
    isMonthlyFetchFailed: state.activityReport.isMonthlyFetchFailed,
    activityReport: state.activityReport.monthly_item,
    isPhone: state.media.isPhone,
    isSaving: state.submissionSchedules.isSaving,
    isSaveFailed: state.submissionSchedules.isSaveFailed
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var _day = [{ day: 0, label: ownProps.t('label:日') }, { day: 1, label: ownProps.t('label:月') }, { day: 2, label: ownProps.t('label:火') }, { day: 3, label: ownProps.t('label:水') }, { day: 4, label: ownProps.t('label:木') }, { day: 5, label: ownProps.t('label:金') }, { day: 6, label: ownProps.t('label:土') }];

  var start_date = ownProps.date.clone().startOf('month');

  var report_status = stateProps.activityReport && stateProps.activityReport.activity && (0, _map2.default)(stateProps.activityReport.activity, function (activity, i) {
    var dt = start_date.clone().add(i, 'days');
    var is_holiday = (0, _checkHoliday2.default)(dt);
    var date = dt.date();
    var day = _day[dt.day()].label;
    var theme = _day[dt.day()].day == 0 || is_holiday ? 'holiday' : _day[dt.day()].day == 6 && 'saturday' || 'default';
    var item = {
      diary: activity.diary,
      memo: activity.memo,
      kpi: activity.kpi,
      like: activity.like,
      comment: activity.comment
    };
    var schedule_data = (0, _find2.default)(stateProps.activityReport.submission_schedules, function (schedules) {
      return schedules.date === dt.format('YYYY-MM-DD');
    });
    return {
      reported_at: dt.format('YYYY-MM-DD'),
      date: date,
      day: day,
      theme: theme,
      activity: item,
      submission: schedule_data ? schedule_data.submission : undefined
    };
  });

  var report_two_rows = report_status && (0, _times2.default)(16, function (i) {
    return {
      first_half: report_status[i],
      latter_half: report_status[i + 16]
    };
  });

  return _extends({
    report_status: report_status,
    report_two_rows: report_two_rows
  }, stateProps, dispatchProps, ownProps);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willMount: function willMount(props) {
      return dispatch(_actions2.default.fetchMonthlyActivityReport(props.group_id, props.user_id, (0, _moment2.default)(props.date).format('YYYY-MM-DD')));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (props.date != nextProps.date || props.user_id != nextProps.user_id) {
        dispatch(_actions2.default.fetchMonthlyActivityReport(nextProps.group_id, nextProps.user_id, (0, _moment2.default)(nextProps.date).format('YYYY-MM-DD')));
      }
      if (props.isSaving && !nextProps.isSaving && !nextProps.isSaveFailed) {
        //モーダル内の月ごとの提出データを更新させる
        dispatch(_actions2.default.fetchMonthlyActivityReport(nextProps.group_id, nextProps.user_id, (0, _moment2.default)(nextProps.date).format('YYYY-MM-DD')));
        nextProps.updateUI({ save: true });
        setTimeout(function () {
          return nextProps.updateUI({ save: false });
        }, 3000);
      }

      // 任意の日付を保存後、activityReportが更新されたタイミングで編集中の場合、report_status内のsubmissionが一つでもfalseだった場合はweekdaySelectを更新させる
      if (props.isMonthlyFetching && !nextProps.isMonthlyFetching && nextProps.edit) {
        var weekdaySelect = nextProps.report_status.some(function (status) {
          return status.theme === 'default' && status.submission === false;
        });
        nextProps.updateUI({ weekdaySelect: !weekdaySelect });
      }
      //編集時にreport_status内のsubmissionが一つでもfalseだった場合はweekdaySelectを更新させる
      if (props.edit != nextProps.edit && nextProps.edit === true) {
        var _weekdaySelect = nextProps.report_status.some(function (status) {
          if (typeof status.submission != 'undefined') {
            return status.theme === 'default' && status.submission === false;
          } else {
            return true;
          }
        });
        nextProps.updateUI({ weekdaySelect: !_weekdaySelect });
      }
      if (props.edit != nextProps.edit && nextProps.edit === false && nextProps.reportDate) {
        dispatch(_actions2.default.fetchActivityReports(nextProps.group_id, nextProps.reportDate.format('YYYY-MM-DD')));
      }
    },

    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearMonthlyActivityReport());
    },

    saveSchedules: function saveSchedules(group_id, schedule_data, user_id) {
      var start_date = ownProps.date.clone().startOf('month').format('YYYY-MM-DD');
      var end_date = ownProps.date.clone().endOf('month').format('YYYY-MM-DD');
      dispatch(_actions2.default.saveSubmissionSchedules(group_id, start_date, end_date, schedule_data, user_id));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactI18next.translate)(), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: {
    weekdaySelect: false,
    save: false
  } }), _lifecycle2.default);

/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(755),
    castFunction = __webpack_require__(817),
    toInteger = __webpack_require__(854);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHoliday;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _holidaysJa = __webpack_require__(2576);

var _holidaysJa2 = _interopRequireDefault(_holidaysJa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * src/helpers/check-holiday.js
 * 祝日の場合、trueを返す
 */

function isHoliday(date) {
  var checkDate = (0, _moment2.default)(date).format('MM-DD');
  var checkYear = (0, _moment2.default)(date).year();

  return !!(_holidaysJa2.default[checkYear] && _holidaysJa2.default[checkYear][checkDate]);
}

/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * src/i18n/holidays-ja.js
 */

var holidaysList = {
  2012: {
    '01-01': true,
    '01-02': true,
    '01-09': true,
    '02-11': true,
    '03-20': true,
    '04-29': true,
    '04-30': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '07-16': true,
    '09-17': true,
    '09-22': true,
    '10-08': true,
    '11-03': true,
    '11-23': true,
    '12-23': true,
    '12-24': true
  },
  2013: {
    '01-01': true,
    '01-14': true,
    '02-11': true,
    '03-20': true,
    '04-29': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '05-06': true,
    '07-15': true,
    '09-16': true,
    '09-23': true,
    '10-14': true,
    '11-03': true,
    '11-04': true,
    '11-23': true,
    '12-23': true
  },
  2014: {
    '01-01': true,
    '01-13': true,
    '02-11': true,
    '03-21': true,
    '04-29': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '05-06': true,
    '07-21': true,
    '09-15': true,
    '09-23': true,
    '10-13': true,
    '11-03': true,
    '11-23': true,
    '11-24': true,
    '12-23': true
  },
  2015: {
    '01-01': true,
    '01-12': true,
    '02-11': true,
    '03-21': true,
    '04-29': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '05-06': true,
    '07-20': true,
    '09-21': true,
    '09-22': true,
    '09-23': true,
    '10-12': true,
    '11-03': true,
    '11-23': true,
    '12-23': true
  },
  2016: {
    '01-01': true,
    '01-11': true,
    '02-11': true,
    '03-20': true,
    '03-21': true,
    '04-29': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '07-18': true,
    '08-11': true,
    '09-19': true,
    '09-22': true,
    '10-10': true,
    '11-03': true,
    '11-23': true,
    '12-23': true
  },
  2017: {
    '01-01': true,
    '01-02': true,
    '01-09': true,
    '02-11': true,
    '03-20': true,
    '04-29': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '07-17': true,
    '08-11': true,
    '09-18': true,
    '09-23': true,
    '10-09': true,
    '11-03': true,
    '11-23': true,
    '12-23': true
  },
  2018: {
    '01-01': true,
    '01-08': true,
    '02-11': true,
    '02-12': true,
    '03-21': true,
    '04-29': true,
    '04-30': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '07-16': true,
    '08-11': true,
    '09-17': true,
    '09-23': true,
    '09-24': true,
    '10-08': true,
    '11-03': true,
    '11-23': true,
    '12-23': true,
    '12-24': true
  },
  2019: {
    '01-01': true,
    '01-14': true,
    '02-11': true,
    '03-21': true,
    '04-29': true,
    '04-30': true,
    '05-01': true,
    '05-02': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '05-06': true,
    '07-15': true,
    '08-11': true,
    '08-12': true,
    '09-16': true,
    '09-23': true,
    '10-14': true,
    '10-22': true,
    '11-03': true,
    '11-04': true,
    '11-23': true
  },
  2020: {
    '01-01': true,
    '01-13': true,
    '02-11': true,
    '02-23': true,
    '02-24': true,
    '03-20': true,
    '04-29': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '05-06': true,
    '07-23': true,
    '07-24': true,
    '08-10': true,
    '09-21': true,
    '09-22': true,
    '11-03': true,
    '11-23': true
  },
  2021: {
    '01-01': true,
    '01-11': true,
    '02-11': true,
    '02-23': true,
    '03-20': true,
    '04-29': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '07-19': true,
    '08-11': true,
    '09-20': true,
    '09-23': true,
    '10-11': true,
    '11-03': true,
    '11-23': true
  },
  2022: {
    '01-01': true,
    '01-10': true,
    '02-11': true,
    '02-23': true,
    '03-21': true,
    '04-29': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '07-18': true,
    '08-11': true,
    '09-19': true,
    '09-23': true,
    '10-10': true,
    '11-03': true,
    '11-23': true
  },
  2023: {
    '01-01': true,
    '01-02': true,
    '01-09': true,
    '02-11': true,
    '02-23': true,
    '03-21': true,
    '04-29': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '07-17': true,
    '08-11': true,
    '09-18': true,
    '09-23': true,
    '10-09': true,
    '11-03': true,
    '11-23': true
  },
  2024: {
    '01-01': true,
    '01-02': true,
    '01-08': true,
    '02-11': true,
    '02-12': true,
    '02-23': true,
    '03-20': true,
    '04-29': true,
    '05-03': true,
    '05-04': true,
    '05-05': true,
    '05-06': true,
    '07-15': true,
    '08-11': true,
    '08-12': true,
    '09-16': true,
    '09-22': true,
    '09-23': true,
    '10-14': true,
    '11-03': true,
    '11-04': true,
    '11-23': true
  }
};

exports.default = holidaysList;

/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2578);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./user-monthly-activities-table.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./user-monthly-activities-table.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".user-monthly-activities-table--activeTable--3kka-pPM {\n  overflow-y: auto;\n  height: calc(100vh - 200px);\n  max-height: 500px;\n}\n\n.user-monthly-activities-table--table--3WGNQpJP {\n  display: inline-block;\n  padding-left: 2px;\n  padding-right: 2px;\n  width: calc(50% - 50px);\n  min-width: 250px;\n}\n\n.user-monthly-activities-table--field--JBz4kaMM[class~=userMonthly] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  top: 5px;\n  margin-left: 15px;\n  width: 8%;\n}\n\n.user-monthly-activities-table--checkbox--2fSbRQqT {\n  margin: 15px 20px 0px 0px;\n}\n\n.user-monthly-activities-table--save_msg--g9WvwCRr {\n  font-size: 100%;\n  color: green;\n  vertical-align: middle;\n  margin-right: 5px;\n}\n\n@media screen and (max-width: 600px) {\n  .user-monthly-activities-table--table--3WGNQpJP {\n    width: calc(100% - 100px);\n  }\n}\n\n.user-monthly-activities-table--holiday--2MJQvMox {\n  background-color: #FFCCFF;\n  padding: 0px;\n}\n\n.user-monthly-activities-table--saturday--p0EVnd_M {\n  background-color: lightskyblue;\n  padding: 0px;\n}\n\n.user-monthly-activities-table--default--1nDSXkAS {\n  background-color: white;\n  padding: 0px;\n}\n\n.user-monthly-activities-table--fontIcon--2zpMd5VT {\n  color: green; \n}\n\n.user-monthly-activities-table--scheduleIcon--1X8ey5h1 {\n  color: #AAAAAA; \n}\n\n.user-monthly-activities-table--text--2eHXOzhi {\n  display: inline-block;\n  color: black;\n  width: 30px;\n  vertical-align: middle;\n  text-align: center;\n}\n\n.user-monthly-activities-table--totalText--1tmS_7is {\n  color: black;\n  font-weight: bold;\n  padding: 0px;\n}\n\n.user-monthly-activities-table--empty--3Wu-f39v {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle;\n  height: 30.5px;\n  width: 100%;\n}\n\n.user-monthly-activities-table--rows--1gfPceq6 {\n  vertical-align: middle;\n  text-align: center;\n}\n\n.user-monthly-activities-table--totalTitle--1jogxId7 {\n  display: inline-block;\n  padding: 0px;\n  border: 0px;\n  width: 70px;\n  text-align: center;\n  vertical-align: middle;\n  height: 31px;\n}\n\n.user-monthly-activities-table--borderLeft--oLHID4Qm {\n  border-left: solid 0.5px gray;\n  height: 31px;\n}\n\n.user-monthly-activities-table--borderNoTop--3-zSsf0O {\n  border-left: solid 0.5px gray !important;\n  border-right: solid 0.5px gray !important;\n  border-bottom: solid 0.5px gray !important;\n  height: 31px;\n}\n\n.user-monthly-activities-table--borderAll--3D_rv9rf {\n  border: solid 0.5px gray;\n  height: 31px;\n}\n\n.user-monthly-activities-table--border--3k2U1msE {\n  border-left: solid 0.5px gray;\n  border-right: solid 0.5px gray;\n  height: 31px;\n}\n\n.user-monthly-activities-table--date--2txM3pGk {\n  display: inline-block;\n  text-align: center;\n  padding: 0px;\n  width: 35px;\n  height: 30px;\n}\n\n.user-monthly-activities-table--status--1sQVw4E7 {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 2px;\n  padding: 0px;\n  text-align: center;\n  vertical-align: middle;\n  width: 55px;\n}\n\n.user-monthly-activities-table--scheduleStatus--2AN3MsWI {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 2px 0px 2px 75px;\n  padding: 0px;\n  text-align: center;\n  vertical-align: middle;\n  width: 55px;\n}\n\n.user-monthly-activities-table--activitiesCell--QFTfB6Z_ {\n  display: inline-block;\n  white-space: nowrap;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  height: 30px;\n  width: calc(100% - 70px);\n}\n\n.user-monthly-activities-table--activitiesCount--1nLKl3yU {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.user-monthly-activities-table--noStatus--2sAUiVf7 {\n  border-left: solid 0.5px gray !important;\n  border-right: solid 0.5px gray !important;\n  height: 31px;\n}\n\n.user-monthly-activities-table--scroll--1m-wowoa {\n  overflow: scroll;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/user-monthly-activities-table.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;CACnB;;AAED;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;CAClB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,UAAU;CACX;;AAED;EACE,0BAA0B;CAC3B;;AAED;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;CACnB;;AAED;EACE;IACE,0BAA0B;GAC3B;CACF;;AAED;EACE,0BAA0B;EAC1B,aAAa;CACd;;AAED;EACE,+BAA+B;EAC/B,aAAa;CACd;;AAED;EACE,wBAAwB;EACxB,aAAa;CACd;;AAED;EACE,aAAa;CACd;;AAED;EACE,eAAe;CAChB;;AAED;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;CACpB;;AAED;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;CACd;;AAED;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,YAAY;CACb;;AAED;EACE,uBAAuB;EACvB,mBAAmB;CACpB;;AAED;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;CACd;;AAED;EACE,8BAA8B;EAC9B,aAAa;CACd;;AAED;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;CACd;;AAED;EACE,yBAAyB;EACzB,aAAa;CACd;;AAED;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;CACd;;AAED;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;CACd;;AAED;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;CACb;;AAED;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;CACb;;AAED;EACE,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;CAC1B;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;MAC1B,wBAAwB;UACpB,oBAAoB;EAC5B,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;CACxC;;AAED;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,aAAa;CACd;;AAED;EACE,iBAAiB;EACjB,iCAAiC;UACzB,yBAAyB;CAClC","file":"user-monthly-activities-table.css","sourcesContent":[".activeTable {\n  overflow-y: auto;\n  height: calc(100vh - 200px);\n  max-height: 500px;\n}\n\n.table {\n  display: inline-block;\n  padding-left: 2px;\n  padding-right: 2px;\n  width: calc(50% - 50px);\n  min-width: 250px;\n}\n\n.field[class~=userMonthly] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  top: 5px;\n  margin-left: 15px;\n  width: 8%;\n}\n\n.checkbox {\n  margin: 15px 20px 0px 0px;\n}\n\n.save_msg {\n  font-size: 100%;\n  color: green;\n  vertical-align: middle;\n  margin-right: 5px;\n}\n\n@media screen and (max-width: 600px) {\n  .table {\n    width: calc(100% - 100px);\n  }\n}\n\n.holiday {\n  background-color: #FFCCFF;\n  padding: 0px;\n}\n\n.saturday {\n  background-color: lightskyblue;\n  padding: 0px;\n}\n\n.default {\n  background-color: white;\n  padding: 0px;\n}\n\n.fontIcon {\n  color: green; \n}\n\n.scheduleIcon {\n  color: #AAAAAA; \n}\n\n.text {\n  display: inline-block;\n  color: black;\n  width: 30px;\n  vertical-align: middle;\n  text-align: center;\n}\n\n.totalText {\n  color: black;\n  font-weight: bold;\n  padding: 0px;\n}\n\n.empty {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle;\n  height: 30.5px;\n  width: 100%;\n}\n\n.rows {\n  vertical-align: middle;\n  text-align: center;\n}\n\n.totalTitle {\n  display: inline-block;\n  padding: 0px;\n  border: 0px;\n  width: 70px;\n  text-align: center;\n  vertical-align: middle;\n  height: 31px;\n}\n\n.borderLeft {\n  border-left: solid 0.5px gray;\n  height: 31px;\n}\n\n.borderNoTop {\n  border-left: solid 0.5px gray !important;\n  border-right: solid 0.5px gray !important;\n  border-bottom: solid 0.5px gray !important;\n  height: 31px;\n}\n\n.borderAll {\n  border: solid 0.5px gray;\n  height: 31px;\n}\n\n.border {\n  border-left: solid 0.5px gray;\n  border-right: solid 0.5px gray;\n  height: 31px;\n}\n\n.date {\n  display: inline-block;\n  text-align: center;\n  padding: 0px;\n  width: 35px;\n  height: 30px;\n}\n\n.status {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 2px;\n  padding: 0px;\n  text-align: center;\n  vertical-align: middle;\n  width: 55px;\n}\n\n.scheduleStatus {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin: 2px 0px 2px 75px;\n  padding: 0px;\n  text-align: center;\n  vertical-align: middle;\n  width: 55px;\n}\n\n.activitiesCell {\n  display: inline-block;\n  white-space: nowrap;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  height: 30px;\n  width: calc(100% - 70px);\n}\n\n.activitiesCount {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.noStatus {\n  border-left: solid 0.5px gray !important;\n  border-right: solid 0.5px gray !important;\n  height: 31px;\n}\n\n.scroll {\n  overflow: scroll;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"activeTable": "user-monthly-activities-table--activeTable--3kka-pPM",
	"table": "user-monthly-activities-table--table--3WGNQpJP",
	"field": "user-monthly-activities-table--field--JBz4kaMM",
	"checkbox": "user-monthly-activities-table--checkbox--2fSbRQqT",
	"save_msg": "user-monthly-activities-table--save_msg--g9WvwCRr",
	"holiday": "user-monthly-activities-table--holiday--2MJQvMox",
	"saturday": "user-monthly-activities-table--saturday--p0EVnd_M",
	"default": "user-monthly-activities-table--default--1nDSXkAS",
	"fontIcon": "user-monthly-activities-table--fontIcon--2zpMd5VT",
	"scheduleIcon": "user-monthly-activities-table--scheduleIcon--1X8ey5h1",
	"text": "user-monthly-activities-table--text--2eHXOzhi",
	"totalText": "user-monthly-activities-table--totalText--1tmS_7is",
	"empty": "user-monthly-activities-table--empty--3Wu-f39v",
	"rows": "user-monthly-activities-table--rows--1gfPceq6",
	"totalTitle": "user-monthly-activities-table--totalTitle--1jogxId7",
	"borderLeft": "user-monthly-activities-table--borderLeft--oLHID4Qm",
	"borderNoTop": "user-monthly-activities-table--borderNoTop--3-zSsf0O",
	"borderAll": "user-monthly-activities-table--borderAll--3D_rv9rf",
	"border": "user-monthly-activities-table--border--3k2U1msE",
	"date": "user-monthly-activities-table--date--2txM3pGk",
	"status": "user-monthly-activities-table--status--1sQVw4E7",
	"scheduleStatus": "user-monthly-activities-table--scheduleStatus--2AN3MsWI",
	"activitiesCell": "user-monthly-activities-table--activitiesCell--QFTfB6Z_",
	"activitiesCount": "user-monthly-activities-table--activitiesCount--1nLKl3yU",
	"noStatus": "user-monthly-activities-table--noStatus--2sAUiVf7",
	"scroll": "user-monthly-activities-table--scroll--1m-wowoa"
};

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2580);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./profile.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./profile.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".profile--avatar--33DdHBX9 {\n  min-width: 100px;\n  min-height: 100px;\n  margin-left: 10px;\n}\n\n.profile--information_wrap--2B5U_0aG {\n  margin-bottom: 10px;\n}\n\n.profile--information_item--BFVKowZV {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.profile--information_item--BFVKowZV div {\n  width: 80px;\n  font-weight: bold;\n}\n\n.profile--avatar--33DdHBX9 img {\n  height: 100% !important;\n}\n\n[data-react-toolbox=\"avatar\"] img {\n  height: 100% !important;\n}", "", {"version":3,"sources":["/./src/web/components/themes/profile.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,oBAAoB;CACrB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;;AAED;EACE,YAAY;EACZ,kBAAkB;CACnB;;AAED;EACE,wBAAwB;CACzB;;AAED;EACE,wBAAwB;CACzB","file":"profile.css","sourcesContent":[".avatar {\n  min-width: 100px;\n  min-height: 100px;\n  margin-left: 10px;\n}\n\n.information_wrap {\n  margin-bottom: 10px;\n}\n\n.information_item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.information_item div {\n  width: 80px;\n  font-weight: bold;\n}\n\n.avatar img {\n  height: 100% !important;\n}\n\n[data-react-toolbox=\"avatar\"] img {\n  height: 100% !important;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"avatar": "profile--avatar--33DdHBX9",
	"information_wrap": "profile--information_wrap--2B5U_0aG",
	"information_item": "profile--information_item--BFVKowZV"
};

/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawSearchTimelinePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _searchTimelinePage = __webpack_require__(2582);

var _searchTimelinePage2 = _interopRequireDefault(_searchTimelinePage);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _diary = __webpack_require__(171);

var _diary2 = _interopRequireDefault(_diary);

var _infiniteScroller = __webpack_require__(75);

var _searchTimelinePageConditions = __webpack_require__(2583);

var _searchTimelinePageConditions2 = _interopRequireDefault(_searchTimelinePageConditions);

var _button = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/search-timeline-page.jsx

var SearchTimelinePage = function (_React$Component) {
  _inherits(SearchTimelinePage, _React$Component);

  function SearchTimelinePage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchTimelinePage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchTimelinePage.__proto__ || Object.getPrototypeOf(SearchTimelinePage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeHighlightIndex: 0,
      totalHighlights: 0,
      initialScroll: true
    }, _this.scrollToHighlightedText = function (activeIndex) {
      var containerElement = _reactDom2.default.findDOMNode(_this.containerRef);
      if (containerElement) {
        var highlightedElements = containerElement.querySelectorAll('em');
        if (highlightedElements && highlightedElements.length > 0 && highlightedElements[activeIndex]) {
          highlightedElements[activeIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    }, _this.handleNextHighlight = function () {
      if (!_this.props.isFetching) {
        var totalCount = _this.state.totalHighlights;
        var activeIndex = _this.state.activeHighlightIndex + 1;
        if (activeIndex >= totalCount) activeIndex = totalCount - 1;

        _this.setState({ activeHighlightIndex: activeIndex });
        _this.scrollToHighlightedText(activeIndex);
      }
    }, _this.handlePrevHighlight = function () {
      var totalCount = _this.state.totalHighlights;
      var activeIndex = _this.state.activeHighlightIndex - 1;
      if (activeIndex < 0) activeIndex = 0;

      _this.setState({ activeHighlightIndex: activeIndex });
      _this.scrollToHighlightedText(activeIndex);
    }, _this.onReplyScrollFrom = function (offset) {
      //COMMENT_FORM_HEIGHTはコメントフォームの高さ
      var COMMENT_FORM_HEIGHT = 222;
      //返信コメントへの返信の場合、コメントフォームまでスクロールする
      _this.rightSidePage.scrollTo(offset += COMMENT_FORM_HEIGHT);
    }, _this.editSearchDrawer = function () {
      _this.props.editSearchDrawer();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // Add two new state variables: activeHighlightIndex and totalHighlights


  _createClass(SearchTimelinePage, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      // Initialize the states when the search text is changed
      if (prevProps.params.query != this.props.params.query) {
        this.setState({
          activeHighlightIndex: 0,
          totalHighlights: 0,
          initialScroll: true
        });
      }
      var containerElement = _reactDom2.default.findDOMNode(this.containerRef);
      var highlightedElements = containerElement.querySelectorAll('em');

      // Update totalHighlights
      if (highlightedElements.length > prevState.totalHighlights) {
        this.setState({ totalHighlights: highlightedElements.length });
      }

      if (this.state.initialScroll && this.props.diaries && !this.props.isFetching && containerElement) {
        setTimeout(function () {
          var highlightedElements = containerElement.querySelectorAll('em');
          _this2.setState({
            totalHighlights: highlightedElements.length,
            initialScroll: false
          });
          _this2.scrollToHighlightedText(0);
        }, 0);
      }
    }

    // Handle clicking the "Next" button


    // Handle clicking the "Prev" button

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          hasMore = _props.hasMore,
          diaries = _props.diaries,
          user = _props.user,
          group = _props.group,
          fetchDiaries = _props.fetchDiaries,
          likeConfig = _props.likeConfig,
          rightSidePage = _props.rightSidePage,
          editSearchDrawer = _props.editSearchDrawer,
          params = _props.params;


      return _react2.default.createElement(
        _rightSidePage2.default,
        {
          title: t('label:検索結果'),
          icon: 'search',
          innerRef: function innerRef(c) {
            return _this3.rightSidePage = c;
          },
          rightAction: [_react2.default.createElement(_button.IconButton, { icon: 'arrow_upward', onClick: this.handlePrevHighlight }), _react2.default.createElement(_button.IconButton, { icon: 'arrow_downward', onClick: this.handleNextHighlight })] },
        !diaries && isFetching && _react2.default.createElement(_loading2.default, null),
        !isFetching && _react2.default.createElement(_searchTimelinePageConditions2.default, this.props),
        _react2.default.createElement(
          _infiniteScroller.InfiniteScroll,
          {
            ref: function ref(content) {
              return _this3.containerRef = content;
            },
            pageStart: 0,
            hasMore: hasMore && !isFetchFailed,
            loadMore: function loadMore() {
              return !isFetching && fetchDiaries(_this3.props);
            },
            loader: diaries && _react2.default.createElement(_loading2.default, null),
            useWindow: false },
          diaries && diaries.map(function (diary) {
            return _react2.default.createElement(_diary2.default, { key: diary.diary_id, diary: diary, group: group, user: user, onReplyScrollFrom: _this3.onReplyScrollFrom, likeConfig: likeConfig, openSidePage: rightSidePage, isBlockDisable: true, isReviewButtonDisplay: false, query: params });
          })
        ),
        diaries && diaries.length == 0 && !hasMore && !isFetching && _react2.default.createElement(
          'div',
          { style: { width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: '20px' } },
          t('label:投稿がありません')
        ),
        diaries && diaries.length > 0 && !hasMore && _react2.default.createElement(
          'div',
          { style: { fontSize: '80%', padding: '0 20px', color: '#999' } },
          t('label:一番最後の投稿です')
        )
      );
    }
  }]);

  return SearchTimelinePage;
}(_react2.default.Component);

var RawSearchTimelinePage = exports.RawSearchTimelinePage = SearchTimelinePage;
exports.default = (0, _searchTimelinePage2.default)(SearchTimelinePage);

/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _isEqual = __webpack_require__(226);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _isNaN = __webpack_require__(1063);

var _isNaN2 = _interopRequireDefault(_isNaN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var preservedQuery = ownProps.params.query_id && state.preservedQueries.items && (0, _find2.default)(state.preservedQueries.items, function (query) {
    return query.query_id == ownProps.params.query_id;
  }) || undefined;
  var group_id = ownProps.params.group_id || preservedQuery && preservedQuery.group_id || undefined;

  return {
    isFetching: state.subDiaries.isFetching,
    isFetchFailed: state.subDiaries.isFetchFailed,
    isCreating: state.preservedQueries.isCreating,
    created_query_id: state.preservedQueries.created_query_id,
    hasMore: state.subDiaries.hasMore,
    diaries: state.subDiaries.items,
    group: group_id && (0, _find2.default)(state.groups.items, function (item) {
      return item.group_id == group_id;
    }) || undefined,
    user: state.user.current,
    preservedQuery: preservedQuery && Object.assign({}, JSON.parse(preservedQuery.query_text), { query_id: preservedQuery.query_id, name: preservedQuery.name, group_id: preservedQuery.group_id, users: preservedQuery.users }),
    rightSidePage: state.rightSidePage.name,
    likeConfig: state.likes.likeConfig,
    currentDivisionId: state.divisions.currentId
  };
};
// src/connects/search-timeline-page.js

function mapFetchGroupId(props) {
  return props.preservedQuery ? props.preservedQuery.group_id : props.params.group_id;
}

function mapFetchQuery(props) {
  var query = {};
  if (props.preservedQuery) {
    if (props.preservedQuery.category) query.category = props.preservedQuery.category;
    if (props.preservedQuery.user_ids) query.user_ids = props.preservedQuery.user_ids;
    if (props.preservedQuery.reported_at) query.start_date = props.preservedQuery.reported_at;
    if (props.preservedQuery.files_attached) query.files_attached = true;
    if (props.preservedQuery.liked_by) query.liked_by = props.preservedQuery.liked_by;
    if (props.preservedQuery.queryText) query.query = props.preservedQuery.queryText;
  } else {
    if (props.params.category && props.params.category != 'all') query.category = props.params.category;
    if (props.params.users) query.user_ids = (0, _map2.default)(props.params.users, function (user) {
      return user.user_id;
    }).join(',');
    if (props.params.reported_at) query.start_date = (0, _moment2.default)(props.params.reported_at).format('YYYY-MM-DD');
    if (props.params.files_attached) query.files_attached = true;
    if (props.params.liked_by) query.liked_by = props.params.liked_by;
    if (props.params.query && props.params.query.length > 0) query.query = props.params.query;
  }
  if (!(0, _isNaN2.default)(props.currentDivisionId)) query.division_id = props.currentDivisionId;
  return query;
}

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchDiaries: function fetchDiaries(props) {
      if (props.isFetching || props.isFetchFailed || !props.hasMore) return;
      var query = mapFetchQuery(props);
      var group_id = mapFetchGroupId(props);
      if (group_id) dispatch(_actions2.default.searchDiaries(group_id, props.diaries && props.diaries.length || 0, query));else dispatch(_actions2.default.searchHomeDiaries(props.diaries && props.diaries.length || 0, query));
    },

    willMount: function willMount(props) {
      var query = mapFetchQuery(props);
      var group_id = mapFetchGroupId(props);
      if (group_id) dispatch(_actions2.default.searchDiaries(group_id, 0, query));else dispatch(_actions2.default.searchHomeDiaries(0, query));
    },

    deletePreservedQuery: function deletePreservedQuery(query) {
      dispatch(_actions2.default.deletePreservedQuery(query.query_id));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:検索条件を削除しました', name: query.name }, 'success'));
      dispatch(_actions2.default.closeRightSidePage());
    },

    createPreservedQuery: function createPreservedQuery(name) {
      if (!ownProps.params.query_id) {
        dispatch(_actions2.default.createPreservedQuery(name, JSON.stringify({
          category: ownProps.params.category == 'all' ? undefined : ownProps.params.category,
          files_attached: ownProps.params.files_attached,
          liked_by: ownProps.params.liked_by,
          user_ids: ownProps.params.users && ownProps.params.users.map(function (user) {
            return user.user_id;
          }).join(','),
          reported_at: ownProps.params.reported_at && (0, _moment2.default)(ownProps.params.reported_at).format('YYYY-MM-DD') || undefined,
          queryText: ownProps.params.query
        }), ownProps.params.group_id));
      }
    },

    readDiary: function readDiary(props, diary) {
      var read = diary.user && diary.user.user_id == props.user.user_id || diary.readers && (0, _find2.default)(diary.readers, function (reader) {
        return reader.user.user_id == props.user.user_id;
      });
      !read && dispatch(_actions2.default.markDiaryRead(diary.diary_id));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (!(0, _isEqual2.default)(props.params, nextProps.params)) {
        var query = mapFetchQuery(nextProps);
        var group_id = mapFetchGroupId(nextProps);
        if (group_id) dispatch(_actions2.default.searchDiaries(group_id, 0, query));else dispatch(_actions2.default.searchHomeDiaries(0, query));
      }

      if (props.isCreating && !nextProps.isCreating && nextProps.created_query_id) {
        dispatch((0, _alertMessage.emitAlertMessage)('label:検索条件を保存しました', 'inputSuccess'));
        dispatch(_actions2.default.openRightSidePage('search_timeline', ownProps.params && ownProps.params.isHome ? { query_id: nextProps.created_query_id, isHome: ownProps.params.isHome } : { query_id: nextProps.created_query_id }));
      }
    },

    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearSubDiaries());
    },

    // アプリでsearch-drawerを開くために必要
    appEditSearchDrawer: function appEditSearchDrawer(group) {
      var isHome = ownProps.params.isHome;
      dispatch(_actions2.default.openRightSidePage('search_drawer', isHome ? { group_id: 'home' } : { group: group }));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    keyboardHeight: undefined
  } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('search_timeline'), (0, _context2.default)({ editSearchDrawer: _propTypes2.default.func }));

/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _compactInput = __webpack_require__(178);

var _compactInput2 = _interopRequireDefault(_compactInput);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _button = __webpack_require__(8);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _primaryButton = __webpack_require__(2584);

var _primaryButton2 = _interopRequireDefault(_primaryButton);

var _formValidator = __webpack_require__(41);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__(4);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/search-timeline-page-conditions.jsx

var MAX_DISPLAY_COUNT = 10;

var SearchConditions = function (_React$Component) {
  _inherits(SearchConditions, _React$Component);

  function SearchConditions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchConditions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchConditions.__proto__ || Object.getPrototypeOf(SearchConditions)).call.apply(_ref, [this].concat(args))), _this), _this.showAllUser = function () {
      return _this.props.updateUI({ showAllUser: !_this.props.ui.showAllUser });
    }, _this.editSearchDrawer = function () {
      return _this.props.editSearchDrawer();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchConditions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          preservedQuery = _props.preservedQuery,
          updateUI = _props.updateUI,
          deletePreservedQuery = _props.deletePreservedQuery,
          createPreservedQuery = _props.createPreservedQuery,
          editSearchDrawer = _props.editSearchDrawer;
      var _props$params = this.props.params,
          category = _props$params.category,
          user_ids = _props$params.user_ids,
          users = _props$params.users,
          reported_at = _props$params.reported_at,
          files_attached = _props$params.files_attached,
          liked_by = _props$params.liked_by,
          query = _props$params.query;


      var queryName = preservedQuery && preservedQuery.name;
      var queryText = preservedQuery ? preservedQuery.queryText : query;
      var categoryData = preservedQuery ? preservedQuery.category : category;
      var filesAttachedData = preservedQuery ? preservedQuery.files_attached : files_attached;
      var liked_status = preservedQuery ? preservedQuery.liked_by : liked_by;
      var reportedAtData = preservedQuery ? preservedQuery.reported_at : reported_at;
      var usersData = preservedQuery ? preservedQuery.users : users;

      if (ui.savingQuery) return _react2.default.createElement(
        'form',
        { style: { display: 'flex', width: '100%', padding: '0 5px' },
          onSubmit: function onSubmit(ev) {
            ev.preventDefault();createPreservedQuery(ui.name);
          } },
        _react2.default.createElement(
          'div',
          { style: { width: '100%' } },
          _react2.default.createElement(_compactInput2.default, { hasFocus: true, value: ui.name, onChange: (0, _formValidator.linkUI)(this, 'name') })
        ),
        _react2.default.createElement(_button.Button, { type: 'submit', label: t('label:保存'), primary: true, raised: true, style: { minWidth: 'auto' } })
      );else return _react2.default.createElement(
        'div',
        { style: { maxHeight: 160, overflow: 'scroll' } },
        preservedQuery && _react2.default.createElement(_button.Button, { theme: _successButton2.default, raised: true,
          icon: "edit",
          label: t("label:検索条件を編集"),
          onClick: this.editSearchDrawer,
          style: { verticalAlign: 'bottom', margin: '4px 6px 6px' } }),
        _react2.default.createElement(_button.Button, { theme: preservedQuery ? _primaryButton2.default : _successButton2.default, raised: true,
          icon: preservedQuery ? "close" : "add",
          label: preservedQuery ? t('label:検索条件を削除') : t('label:検索条件を保存'),
          onClick: preservedQuery ? function () {
            return updateUI({ deleteConfirm: true });
          } : function () {
            return updateUI({ savingQuery: true });
          },
          style: { verticalAlign: 'bottom', margin: '4px 6px 6px' } }),
        queryName && _react2.default.createElement(
          _chip2.default,
          null,
          _react2.default.createElement(_avatar2.default, { icon: 'save' }),
          queryName
        ),
        queryText && queryText.length > 0 && _react2.default.createElement(
          _chip2.default,
          null,
          _react2.default.createElement(_avatar2.default, { icon: 'search' }),
          queryText
        ),
        categoryData == 'diary' && _react2.default.createElement(
          _chip2.default,
          null,
          _react2.default.createElement(_avatar2.default, { icon: 'event_note' }),
          t('label:日報のみ')
        ),
        categoryData == 'kpi' && _react2.default.createElement(
          _chip2.default,
          null,
          _react2.default.createElement(_avatar2.default, { icon: 'insert_chart' }),
          t('label:KPIのみ')
        ),
        categoryData == 'memo' && _react2.default.createElement(
          _chip2.default,
          null,
          _react2.default.createElement(_avatar2.default, { icon: 'assignment' }),
          t('label:ノートのみ')
        ),
        liked_status && _react2.default.createElement(
          _chip2.default,
          null,
          _react2.default.createElement(_avatar2.default, { icon: 'search' }),
          t('label:いいねした投稿')
        ),
        filesAttachedData && _react2.default.createElement(
          _chip2.default,
          null,
          _react2.default.createElement(_avatar2.default, { icon: 'attachment' }),
          t('label:添付ファイル付き')
        ),
        reportedAtData && _react2.default.createElement(
          _chip2.default,
          null,
          _react2.default.createElement(_avatar2.default, { icon: 'date_range' }),
          t('label:より後の投稿', { reported_at: (0, _moment2.default)(reportedAtData).format('LLLL') })
        ),
        ui.showAllUser && usersData && usersData.length > 0 && _.map(usersData, function (user) {
          return _react2.default.createElement(
            _chip2.default,
            null,
            _react2.default.createElement(_avatar2.default, { image: user.icon_image.thumb_url }),
            user.name
          );
        }),
        ui.showAllUser && _react2.default.createElement(_button.Button, {
          style: { bottom: 10 },
          primary: true,
          onClick: this.showAllUser,
          icon: 'arrow_forward',
          label: t('label:表示を隠す') }),
        !ui.showAllUser && usersData && usersData.length > 0 && _.map(usersData.slice(0, MAX_DISPLAY_COUNT), function (user, i) {
          return _react2.default.createElement(
            _chip2.default,
            null,
            _react2.default.createElement(_avatar2.default, { image: user.icon_image.thumb_url }),
            user.name
          );
        }),
        !ui.showAllUser && usersData && usersData.length > MAX_DISPLAY_COUNT && _react2.default.createElement(_button.Button, {
          style: { bottom: 10 },
          primary: true,
          onClick: this.showAllUser,
          icon: 'arrow_forward',
          label: t('label:他n人', { n: usersData.length - MAX_DISPLAY_COUNT }) + 'を' + t('label:すべて表示') }),
        preservedQuery && _react2.default.createElement(_confirmDialog2.default, { open: ui.deleteConfirm,
          title: t('label:検索条件を削除してもいいですか', { name: preservedQuery.name }),
          description: t('label:この操作は取り消せません'),
          yesLabel: t('label:削除'),
          noLabel: t('label:取り消し'),
          onYes: function onYes() {
            updateUI({ deleteConfirm: false });deletePreservedQuery(preservedQuery);
          },
          onNo: function onNo() {
            return updateUI({ deleteConfirm: false });
          } })
      );
    }
  }]);

  return SearchConditions;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)()((0, _uiState2.default)({ state: {
    deleteConfirm: false,
    savingQuery: false,
    showAllUser: false,
    name: function name(props) {
      return props.t('label:新しい検索条件');
    }
  } })(SearchConditions));

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2585);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./primary-button.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./primary-button.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".primary-button--button--2M1csxZ8:not([disabled]) {\n  background-color: rgb(63, 81, 181)!important;\n  color: #FFF!important;\n}\n.primary-button--button--2M1csxZ8:not([disabled]):hover {\n  background-color: rgba(63, 81, 181, .8)!important;\n  color: #FFF!important;\n}\n.primary-button--button--2M1csxZ8:not([disabled])[class~=templateImport] {\nmargin-left: 20px;\n} ", "", {"version":3,"sources":["/./src/web/components/themes/primary-button.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;EAC7C,sBAAsB;CACvB;AACD;EACE,kDAAkD;EAClD,sBAAsB;CACvB;AACD;AACA,kBAAkB;CACjB","file":"primary-button.css","sourcesContent":[".button:not([disabled]) {\n  background-color: rgb(63, 81, 181)!important;\n  color: #FFF!important;\n}\n.button:not([disabled]):hover {\n  background-color: rgba(63, 81, 181, .8)!important;\n  color: #FFF!important;\n}\n.button:not([disabled])[class~=templateImport] {\nmargin-left: 20px;\n} "],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"button": "primary-button--button--2M1csxZ8"
};

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUnreadTimelinePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _unreadTimelinePage = __webpack_require__(2587);

var _unreadTimelinePage2 = _interopRequireDefault(_unreadTimelinePage);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _diary = __webpack_require__(171);

var _diary2 = _interopRequireDefault(_diary);

var _infiniteScroller = __webpack_require__(75);

var _layout = __webpack_require__(85);

var _twoColumnLayout = __webpack_require__(205);

var _twoColumnLayout2 = _interopRequireDefault(_twoColumnLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/unread-timeline-page.jsx

var UnreadTimelinePage = function (_React$Component) {
  _inherits(UnreadTimelinePage, _React$Component);

  function UnreadTimelinePage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnreadTimelinePage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnreadTimelinePage.__proto__ || Object.getPrototypeOf(UnreadTimelinePage)).call.apply(_ref, [this].concat(args))), _this), _this.onReplyScrollFrom = function (offset) {
      //COMMENT_FORM_HEIGHTはコメントフォームの高さ
      var COMMENT_FORM_HEIGHT = 222;
      //返信コメントへの返信の場合、コメントフォームまでスクロールする
      _this.rightSidePage.scrollTo(offset += COMMENT_FORM_HEIGHT);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnreadTimelinePage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          diaries = _props.diaries,
          user = _props.user,
          group = _props.group,
          likeConfig = _props.likeConfig,
          rightSidePage = _props.rightSidePage;


      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: t('label:未読の投稿'), icon: 'label_outline', innerRef: function innerRef(c) {
            return _this2.rightSidePage = c;
          } },
        !isFetchFailed && !diaries && isFetching && _react2.default.createElement(_loading2.default, null),
        !isFetchFailed && _react2.default.createElement(
          _infiniteScroller.InfiniteScroll,
          { pageStart: 0,
            hasMore: false,
            loader: diaries && _react2.default.createElement(_loading2.default, null),
            useWindow: false },
          diaries && diaries.map(function (diary) {
            return _react2.default.createElement(_diary2.default, { key: diary.diary_id, diary: diary, group: group, user: user, onReplyScrollFrom: _this2.onReplyScrollFrom, likeConfig: likeConfig, openSidePage: rightSidePage, isReviewButtonDisplay: false });
          })
        ),
        !isFetchFailed && diaries && diaries.length == 0 && _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'center' } },
          t('label:投稿がありません')
        ),
        isFetchFailed && _react2.default.createElement(
          'div',
          { style: { marginTop: '10px', textAlign: 'center' } },
          t('label:投稿の取得に失敗しました')
        )
      );
    }
  }]);

  return UnreadTimelinePage;
}(_react2.default.Component);

var RawUnreadTimelinePage = exports.RawUnreadTimelinePage = UnreadTimelinePage;
exports.default = (0, _unreadTimelinePage2.default)(UnreadTimelinePage);

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/unread-timeline-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isFetching: state.subDiaries.isFetching,
    isFetchFailed: state.subDiaries.isFetchFailed,
    diaries: state.subDiaries.items,
    group: ownProps.params.group_id && (0, _find2.default)(state.groups.items, function (item) {
      return item.group_id == ownProps.params.group_id;
    }) || undefined,
    user: state.user.current,
    likeConfig: state.likes.likeConfig,
    rightSidePage: state.rightSidePage.name
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    // 未読の投稿に対しては無限スクロールは行わず、まとめて50剣を先に取得してしまうように
    // 開封処理が行われることで未読のリストが変動してしまいoffsetが意味をなさないため
    willMount: function willMount(props) {
      dispatch(_actions2.default.fetchSubDiaries(props.params.group_id, 0, { unread: true, length: 50 }));
    },

    readDiary: function readDiary(props, diary) {
      var read = diary.user && diary.user.user_id == props.user.user_id || diary.readers && (0, _find2.default)(diary.readers, function (reader) {
        return reader.user.user_id == props.user.user_id;
      });
      !read && dispatch(_actions2.default.markDiaryRead(diary.diary_id));
    },

    willUnmount: function willUnmount() {
      dispatch(_actions2.default.clearSubDiaries());
      dispatch(_actions2.default.fetchGroupUnreadCount(ownProps.params.group_id));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawMembersPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _membersPage = __webpack_require__(2589);

var _membersPage2 = _interopRequireDefault(_membersPage);

var _list = __webpack_require__(25);

var _button = __webpack_require__(8);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _diaryContent = __webpack_require__(239);

var _diaryContent2 = _interopRequireDefault(_diaryContent);

var _membersPageNoDescription = __webpack_require__(2590);

var _membersPageNoDescription2 = _interopRequireDefault(_membersPageNoDescription);

var _membersPageWithDescription = __webpack_require__(2592);

var _membersPageWithDescription2 = _interopRequireDefault(_membersPageWithDescription);

var _favoriteButton = __webpack_require__(1069);

var _favoriteButton2 = _interopRequireDefault(_favoriteButton);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/members-page.jsx

var MemberItem = function (_React$Component) {
  _inherits(MemberItem, _React$Component);

  function MemberItem() {
    _classCallCheck(this, MemberItem);

    return _possibleConstructorReturn(this, (MemberItem.__proto__ || Object.getPrototypeOf(MemberItem)).apply(this, arguments));
  }

  _createClass(MemberItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          user = _props.user,
          member = _props.member,
          isFavorite = _props.isFavorite,
          toggleFavoriteUser = _props.toggleFavoriteUser,
          openUserProfilePanel = _props.openUserProfilePanel;


      return _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false,
        theme: !member.description && _membersPageNoDescription2.default || _membersPageWithDescription2.default,
        avatar: member.icon_image.thumb_url,
        rightActions: member.user_id == user.user_id && [_react2.default.createElement(_button.Button, { key: 1, raised: true, onClick: openUserProfilePanel, icon: 'edit', label: t('label:編集') })] || [_react2.default.createElement(_button.Button, { key: 2, className: isFavorite ? 'favorite' : '', icon: isFavorite ? "flag" : "outlined_flag", theme: _favoriteButton2.default,
          label: isFavorite ? t("label:フォロー中") : t("label:フォロー"),
          onClick: function onClick() {
            return toggleFavoriteUser(member, isFavorite);
          } })],
        caption: member.name,
        legend: member.description && _react2.default.createElement(_diaryContent2.default, { component: 'div', comment: true, content: member.description }) });
    }
  }]);

  return MemberItem;
}(_react2.default.Component);

var MembersPage = function (_React$Component2) {
  _inherits(MembersPage, _React$Component2);

  function MembersPage() {
    _classCallCheck(this, MembersPage);

    return _possibleConstructorReturn(this, (MembersPage.__proto__ || Object.getPrototypeOf(MembersPage)).apply(this, arguments));
  }

  _createClass(MembersPage, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          t = _props2.t,
          group = _props2.group,
          user = _props2.user,
          openUserProfilePanel = _props2.openUserProfilePanel,
          openGroupProfilePanel = _props2.openGroupProfilePanel,
          isFavorite = _props2.isFavorite,
          isFetching = _props2.isFetching,
          isFetchGroupFailed = _props2.isFetchGroupFailed,
          toggleFavoriteUser = _props2.toggleFavoriteUser;


      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: t("label:メンバーリスト"), icon: 'people' },
        !isFetchGroupFailed && isFetching && _react2.default.createElement(_loading2.default, null),
        !isFetchGroupFailed && _react2.default.createElement(
          _list.List,
          null,
          group && (group.description || group.is_admin) && _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false,
            rightActions: group.is_admin && [_react2.default.createElement(_button.Button, { key: 1, raised: true, onClick: openGroupProfilePanel, icon: 'edit', label: t('label:編集') })] || [],
            theme: _membersPageNoDescription2.default,
            legend: _react2.default.createElement(_diaryContent2.default, { component: 'div', comment: true, content: group.description || t('label:ミッションが設定されていません') }) }) || null,
          group && group.members && group.members.length > 0 && _.map(group.members, function (member) {
            return _react2.default.createElement(MemberItem, { key: member.user_id, t: t, user: user,
              member: member, isFavorite: isFavorite(member, _this3.props),
              toggleFavoriteUser: toggleFavoriteUser,
              openUserProfilePanel: openUserProfilePanel });
          })
        ),
        !isFetchGroupFailed && !isFetching && group && (!group.members || group.members.length == 0) && _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'center' } },
          t('label:メンバーは登録されていません')
        ),
        isFetchGroupFailed && _react2.default.createElement(
          'div',
          { style: { marginTop: '10px', textAlign: 'center' } },
          t('label:メンバーの取得に失敗しました')
        )
      );
    }
  }]);

  return MembersPage;
}(_react2.default.Component);

var RawMembersPage = exports.RawMembersPage = MembersPage;
exports.default = (0, _membersPage2.default)(MembersPage);

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _alertMessage = __webpack_require__(13);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: state.user.current,
    favoriteUsers: state.favorite.users,
    group: ownProps.params.group_id && (0, _find2.default)(state.groups.items, function (item) {
      return item.group_id == ownProps.params.group_id;
    }) || undefined,
    isFetching: state.groups.isFetching,
    blockUsers: state.block.users
  };
};
// src/connects/members-page.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openGroupProfilePanel: function openGroupProfilePanel() {
      return dispatch(_actions2.default.openGroupSettingsPage('profile'));
    },
    openUserProfilePanel: function openUserProfilePanel() {
      return dispatch(_actions2.default.openUserSettingsPage('profile'));
    },
    isFavorite: function isFavorite(user, props) {
      return !!(0, _find2.default)(props.favoriteUsers, function (_user) {
        return _user.user_id == user.user_id;
      });
    },
    toggleFavoriteUser: function toggleFavoriteUser(user, isFavorite) {
      dispatch(_actions2.default.updateFavoriteUser(user.user_id, !isFavorite));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: !isFavorite ? 'label:お気に入りユーザに追加しました' : 'label:お気に入りユーザから削除しました', name: user && user.name }, 'success'));
    },

    willMount: function willMount(props) {
      dispatch(_actions2.default.fetchFavoriteUsers());
      if (!props.group || !props.group.members) dispatch(_actions2.default.fetchGroup(props.params.group_id));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    showAll: false,
    is_details: false,
    is_summary: false,
    user: undefined,
    is_pc: false,
    show_summary: false
  } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('members'));

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2591);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./members-page-no-description.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./members-page-no-description.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.members-page-no-description--listItem--3iLq9HDa {\n  margin: 5px 0;\n}\n\n.members-page-no-description--itemContentRoot--1Oc85k2Y {\n  height: auto!important;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/members-page-no-description.css"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;;AAED;EACE,uBAAuB;CACxB","file":"members-page-no-description.css","sourcesContent":["\n.listItem {\n  margin: 5px 0;\n}\n\n.itemContentRoot {\n  height: auto!important;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listItem": "members-page-no-description--listItem--3iLq9HDa",
	"itemContentRoot": "members-page-no-description--itemContentRoot--1Oc85k2Y"
};

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2593);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./members-page-with-description.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./members-page-with-description.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.members-page-with-description--listItem--3550H7Ta {\n  margin: 5px 0;\n}\n\n.members-page-with-description--itemContentRoot--3AyEITke {\n  height: auto!important;\n  margin-top: 8px;\n}\n\n.members-page-with-description--item--1D7Y1sLm {\n  -webkit-box-align: initial;\n      -ms-flex-align: initial;\n          align-items: initial;\n}\n\n.members-page-with-description--left--3HD5unFG {\n  -webkit-box-align: initial;\n      -ms-flex-align: initial;\n          align-items: initial;\n}\n\n.members-page-with-description--right--aKAx3gHa {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/members-page-with-description.css"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;;AAED;EACE,uBAAuB;EACvB,gBAAgB;CACjB;;AAED;EACE,2BAA2B;MACvB,wBAAwB;UACpB,qBAAqB;CAC9B;;AAED;EACE,2BAA2B;MACvB,wBAAwB;UACpB,qBAAqB;CAC9B;;AAED;EACE,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B","file":"members-page-with-description.css","sourcesContent":["\n.listItem {\n  margin: 5px 0;\n}\n\n.itemContentRoot {\n  height: auto!important;\n  margin-top: 8px;\n}\n\n.item {\n  -webkit-box-align: initial;\n      -ms-flex-align: initial;\n          align-items: initial;\n}\n\n.left {\n  -webkit-box-align: initial;\n      -ms-flex-align: initial;\n          align-items: initial;\n}\n\n.right {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listItem": "members-page-with-description--listItem--3550H7Ta",
	"itemContentRoot": "members-page-with-description--itemContentRoot--3AyEITke",
	"item": "members-page-with-description--item--1D7Y1sLm",
	"left": "members-page-with-description--left--3HD5unFG",
	"right": "members-page-with-description--right--aKAx3gHa"
};

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".favorite-button--button--GztiO0k3 {\n  padding: 0 7px;\n}\n\n.favorite-button--button--GztiO0k3[class~=favorite] .favorite-button--icon--ohOxQo7Y {\n  color: #FFCC00!important;\n}\n\n.favorite-button--icon--ohOxQo7Y {\n  font-size: 140%!important;\n  color: #888;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/favorite-button.css"],"names":[],"mappings":"AAAA;EACE,eAAe;CAChB;;AAED;EACE,yBAAyB;CAC1B;;AAED;EACE,0BAA0B;EAC1B,YAAY;CACb","file":"favorite-button.css","sourcesContent":[".button {\n  padding: 0 7px;\n}\n\n.button[class~=favorite] .icon {\n  color: #FFCC00!important;\n}\n\n.icon {\n  font-size: 140%!important;\n  color: #888;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"button": "favorite-button--button--GztiO0k3",
	"icon": "favorite-button--icon--ohOxQo7Y"
};

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawLikesReadersPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _likesReadersPage = __webpack_require__(2596);

var _likesReadersPage2 = _interopRequireDefault(_likesReadersPage);

var _list = __webpack_require__(25);

var _tabs = __webpack_require__(188);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _emojiHelpers = __webpack_require__(146);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _diaryFormsTab = __webpack_require__(570);

var _diaryFormsTab2 = _interopRequireDefault(_diaryFormsTab);

var _likesReaders = __webpack_require__(2597);

var _likesReaders2 = _interopRequireDefault(_likesReaders);

var _uniqWith = __webpack_require__(1049);

var _uniqWith2 = _interopRequireDefault(_uniqWith);

var _maxBy = __webpack_require__(1070);

var _maxBy2 = _interopRequireDefault(_maxBy);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _emoji = __webpack_require__(187);

var _emoji2 = _interopRequireDefault(_emoji);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // src/web/components/likes-readers-page.jsx

var TooltipButton = (0, _tooltip2.default)(_button.Button);

function UserReactionIcon(props) {
  var like = props.like,
      likeConfig = props.likeConfig;

  return _react2.default.createElement(
    'div',
    { theme: _likesReaders2.default },
    _react2.default.createElement('img', { className: 'avatarIcon', src: like.user.icon_image.thumb_url }),
    _react2.default.createElement('img', { className: 'reactionIcon', theme: _likesReaders2.default, src: likeConfig && _emoji2.default[likeConfig[like.like_type].icon.replace('\\u', '')] })
  );
}

function LikesList(props) {
  var t = props.t,
      likes = props.likes,
      likeConfig = props.likeConfig,
      showUser = props.showUser;


  return _react2.default.createElement(
    _list.List,
    null,
    _lodash2.default.map(likes, function (like) {
      return _react2.default.createElement(_list.ListItem, { key: like.like_id, theme: _likesReaders2.default, className: (0, _classnames2.default)("avatarReaction", "pointer"),
        avatar: _react2.default.createElement(UserReactionIcon, { like: like, likeConfig: likeConfig }),
        onClick: function onClick() {
          return showUser(like.user.user_id);
        },
        caption: like.user.name,
        legend: _react2.default.createElement(TooltipButton, { neutral: false, ripple: false, theme: _likesReaders2.default,
          label: t('label:時間前にリアクション', { timestamp: (0, _moment2.default)(like.created_at).fromNow(), n: likeConfig && likeConfig[like.like_type].label }),
          tooltip: _react2.default.createElement(
            'div',
            null,
            (0, _moment2.default)(like.created_at).format('LLLL HH:mm'),
            ' '
          ) })
      });
    }),
    (!likes || likes.length == 0) && _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false,
      legend: t('label:いいねといっている人はまだいません') })
  );
}

function ReadersList(props) {
  var t = props.t,
      readers = props.readers,
      showUser = props.showUser;


  return _react2.default.createElement(
    _list.List,
    null,
    _lodash2.default.map(readers, function (reader) {
      return _react2.default.createElement(_list.ListItem, { key: reader.reader_id, theme: _likesReaders2.default, className: 'pointer',
        selectable: false, ripple: false,
        avatar: reader.user.icon_image.thumb_url,
        caption: reader.user.name,
        onClick: function onClick() {
          return showUser(reader.user.user_id);
        },
        legend: _react2.default.createElement(TooltipButton, { neutral: false, ripple: false, theme: _likesReaders2.default,
          label: t('label:時間前に開封', { timestamp: (0, _moment2.default)(reader.created_at).fromNow() }),
          tooltip: _react2.default.createElement(
            'div',
            null,
            (0, _moment2.default)(reader.created_at).format('LLLL HH:mm'),
            ' '
          ) })
      });
    }),
    (!readers || readers.length == 0) && _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false,
      legend: t('label:開封した人はまだいません') })
  );
}

function MentionsList(props) {
  var t = props.t,
      mentions = props.mentions,
      showUser = props.showUser;


  return _react2.default.createElement(
    _list.List,
    null,
    _lodash2.default.map(mentions, function (mention) {
      return _react2.default.createElement(_list.ListItem, { key: mention.user_id, theme: _likesReaders2.default, className: 'pointer',
        selectable: false, ripple: false,
        avatar: mention.icon_image.thumb_url,
        onClick: function onClick() {
          return showUser(mention.user_id);
        },
        caption: mention.name,
        legend: mention.delivered_at && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(TooltipButton, { neutral: false, ripple: false, theme: _likesReaders2.default,
            label: t('label:時間前に開封', { timestamp: (0, _moment2.default)(mention.delivered_at).fromNow() }),
            tooltip: _react2.default.createElement(
              'div',
              null,
              (0, _moment2.default)(mention.delivered_at).format('LLLL HH:mm'),
              ' '
            ) }),
          mention.replied_at && _react2.default.createElement(TooltipButton, { neutral: false, ripple: false, theme: _likesReaders2.default,
            label: '(' + t('label:時間前に返信', { timestamp: (0, _moment2.default)(mention.replied_at).fromNow() }) + ')',
            tooltip: _react2.default.createElement(
              'div',
              null,
              (0, _moment2.default)(mention.replied_at).format('LLLL HH:mm'),
              ' '
            ) }),
          _react2.default.createElement(_font_icon.FontIcon, { value: 'check', style: { fontSize: 16, color: 'green' } })
        )
      });
    }),
    (!mentions || mentions.length == 0) && _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false,
      legend: t('label:読んでみてといっている人はまだいません') })
  );
}

function CommentList(props) {
  var t = props.t,
      comments = props.comments,
      reply = props.reply,
      showUser = props.showUser;

  var users = comments && comments.map(function (item) {
    return item.user;
  });
  var uniq_users = users && (0, _uniqWith2.default)(users, function (user1, user2) {
    return user1.user_id == user2.user_id;
  });
  return _react2.default.createElement(
    _list.List,
    null,
    _lodash2.default.map(uniq_users, function (user) {
      var userComments = comments.filter(function (item) {
        return item.user.user_id == user.user_id;
      });
      var latestComment = (0, _maxBy2.default)(userComments, function (comment) {
        return comment.created_at;
      });
      return _react2.default.createElement(_list.ListItem, { key: user.user_id, theme: _likesReaders2.default, className: 'pointer',
        selectable: false, ripple: false,
        avatar: user.icon_image.thumb_url,
        onClick: function onClick() {
          return showUser(user.user_id);
        },
        caption: user.name,
        legend: _react2.default.createElement(TooltipButton, { neutral: false, ripple: false, theme: _likesReaders2.default,
          label: !reply ? t('label:時間前にコメント', { timestamp: (0, _moment2.default)(latestComment.created_at).fromNow() }) : t('label:時間前に返信(tab)', { timestamp: (0, _moment2.default)(latestComment.created_at).fromNow() }),
          tooltip: _react2.default.createElement(
            'div',
            null,
            (0, _moment2.default)(latestComment.created_at).format('LLLL HH:mm'),
            ' '
          ) })
      });
    }),
    (!comments || comments.length == 0) && _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false,
      legend: !reply ? t('label:コメントした人はまだいません') : t('label:返信した人はまだいません') })
  );
}

var LikesReadersPage = function (_React$Component) {
  _inherits(LikesReadersPage, _React$Component);

  function LikesReadersPage() {
    _classCallCheck(this, LikesReadersPage);

    return _possibleConstructorReturn(this, (LikesReadersPage.__proto__ || Object.getPrototypeOf(LikesReadersPage)).apply(this, arguments));
  }

  _createClass(LikesReadersPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          diary = _props.diary,
          comment = _props.comment,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          updateUI = _props.updateUI,
          likeConfig = _props.likeConfig,
          showUser = _props.showUser;


      var subject, subtitle;
      if (comment) {
        subject = _react2.default.createElement(
          'span',
          null,
          t('label:ユーザのコメント', { name: comment.user.name })
        );
        subtitle = t('label:時間前に送信', { timestamp: (0, _moment2.default)(comment.created_at).fromNow() });
      } else if (diary && diary.subject) {
        subtitle = diary.user.name;
        subject = _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: (0, _emojiHelpers.convertEmojiHTML)(diary.subject) } });
      } else if (diary) {
        subtitle = diary.user.name;
        subject = _react2.default.createElement(
          'span',
          null,
          t('format:diary_subject', {
            reported_at: diary.reported_at,
            category: t('diary:' + diary.category)
          })
        );
      }

      var children;
      if (diary && comment) {
        children = [_react2.default.createElement(
          _tabs.Tab,
          { key: 1, className: (0, _classnames2.default)('tab-label', 'icon-favorite'), icon: 'favorite', label: t('label:リアクション') },
          _react2.default.createElement(LikesList, { t: t, likes: comment.likes, likeConfig: likeConfig, showUser: showUser })
        ), _react2.default.createElement(
          _tabs.Tab,
          { key: 2, className: (0, _classnames2.default)('tab-label', 'icon-priority_high'), icon: 'priority_high', label: t('label:読んでみて') },
          _react2.default.createElement(MentionsList, { t: t, mentions: comment.mentions, showUser: showUser })
        )];
        var isParent = comment.hasOwnProperty('comments');
        isParent && children.push(_react2.default.createElement(
          _tabs.Tab,
          { key: 3, className: (0, _classnames2.default)('tab-label', 'icon-comment'), icon: 'comment', label: t('label:返信') },
          _react2.default.createElement(CommentList, { t: t, comments: comment.comments, showUser: showUser, reply: true })
        ));
      } else if (diary) children = [_react2.default.createElement(
        _tabs.Tab,
        { key: 1, className: (0, _classnames2.default)('tab-label', 'icon-favorite'), icon: 'favorite', label: t('label:リアクション') },
        _react2.default.createElement(LikesList, { t: t, likes: diary.likes, likeConfig: likeConfig, showUser: showUser })
      ), _react2.default.createElement(
        _tabs.Tab,
        { key: 2, className: (0, _classnames2.default)('tab-label', 'icon-comment'), icon: 'comment', label: t('label:コメント') },
        _react2.default.createElement(CommentList, { t: t, comments: diary.comments, showUser: showUser })
      ), _react2.default.createElement(
        _tabs.Tab,
        { key: 3, className: (0, _classnames2.default)('tab-label', 'icon-priority_high'), icon: 'priority_high', label: t('label:読んでみて') },
        _react2.default.createElement(MentionsList, { t: t, mentions: diary.mentions, showUser: showUser })
      ), _react2.default.createElement(
        _tabs.Tab,
        { key: 4, className: (0, _classnames2.default)('tab-label', 'icon-check'), icon: 'check', label: t('label:開封') },
        _react2.default.createElement(ReadersList, { t: t, readers: diary.readers, showUser: showUser })
      )];else children = [];

      return _react2.default.createElement(
        _rightSidePage2.default,
        {
          title: subject,
          image: comment && comment.user.icon_image.thumb_url || diary && diary.user.icon_image.thumb_url,
          subTitle: subtitle },
        !isFetchFailed && isFetching && _react2.default.createElement(_loading2.default, null),
        !isFetchFailed && !isFetching && diary && _react2.default.createElement(
          _tabs.Tabs,
          { index: ui.index, onChange: function onChange(index) {
              return updateUI({ index: index });
            }, theme: _diaryFormsTab2.default },
          children
        ),
        isFetchFailed && _react2.default.createElement(
          'div',
          { style: { marginTop: '10px', textAlign: 'center' } },
          t('label:データの取得に失敗しました')
        )
      );
    }
  }]);

  return LikesReadersPage;
}(_react2.default.Component);

var RawLikesReadersPage = exports.RawLikesReadersPage = LikesReadersPage;
exports.default = (0, _likesReadersPage2.default)(LikesReadersPage);

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/likes-readers-page.js

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _flatten = __webpack_require__(479);

var _flatten2 = _interopRequireDefault(_flatten);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    diaries: state.subDiaries.items,
    isFetching: state.subDiaries.isFetching,
    likeConfig: state.likes.likeConfig
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var diary = (0, _find2.default)(stateProps.diaries, function (item) {
    return item.diary_id == ownProps.params.diary_id;
  });

  var comments = ownProps.params.comment_id && diary && (0, _flatten2.default)(diary.comments.concat(diary.comments.map(function (c) {
    return c.comments;
  })));
  var comment = comments && (0, _find2.default)(comments, function (item) {
    return item && item.comment_id == ownProps.params.comment_id;
  });
  return _extends({
    diary: diary,
    comment: comment
  }, stateProps, dispatchProps, ownProps);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    showUser: function showUser(userId) {
      dispatch(_actions2.default.openRightSidePage('user_timeline', {
        group_id: ownProps.group && ownProps.group.group_id || undefined,
        user_id: userId
      }));
    },
    willMount: function willMount() {
      dispatch(_actions2.default.fetchSubDiary(ownProps.params.diary_id, true));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (props.params.diary_id != nextProps.params.diary_id) dispatch(_actions2.default.fetchSubDiary(nextProps.params.diary_id, true));
      if (props.params.diary_id != nextProps.params.diary_id || props.params.comment_id != nextProps.params.comment_id) {
        switch (nextProps.params.tab) {
          case 'likes':
            nextProps.updateUI({ index: 0 });
            break;
          case 'comments':
            nextProps.updateUI({ index: 1 });
            break;
          case 'mentions':
            nextProps.params.diary_id && nextProps.params.comment_id ? nextProps.updateUI({ index: 1 }) : nextProps.updateUI({ index: 2 });
            break;
          case 'readers':
            nextProps.updateUI({ index: 3 });
            break;
          default:
            nextProps.updateUI({ index: 0 });
        }
      } else if (props.params.tab != nextProps.params.tab) {
        switch (nextProps.params.tab) {
          case 'likes':
            nextProps.updateUI({ index: 0 });
            break;
          case 'comments':
            nextProps.updateUI({ index: 1 });
            break;
          case 'mentions':
            nextProps.params.diary_id && nextProps.params.comment_id ? nextProps.updateUI({ index: 1 }) : nextProps.updateUI({ index: 2 });
            break;
          case 'readers':
            nextProps.updateUI({ index: 3 });
            break;
          default:
            nextProps.updateUI({ index: 0 });
        }
      }
    },

    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearSubDiaries());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({
  state: {
    index: function index(props) {
      switch (props.params.tab) {
        case 'likes':
          return 0;
        case 'comments':
          return 1;
        case 'mentions':
          if (props.params.diary_id && props.params.comment_id) return 1;else return 2;
        case 'readers':
          return 3;
        default:
          return 0;
      }
    }
  }
}), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2598);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./likes-readers.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./likes-readers.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".likes-readers--tooltip--3kobKKbf {\n  text-align: left;\n}\n\n.likes-readers--tooltipInner--vYV_h7xY {\n  background: #fdfdfd!important;\n  border: solid 1px #EEE;\n  border-radius: 3px;\n  color: #666!important;\n  min-width: 100px;\n  max-width: 150px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.likes-readers--listItem--2b4ffxKc[class~=pointer] {\n  cursor: pointer;\n}\n\n[class~=avatarReaction] .likes-readers--itemAction--jsY1Hhdo > div {\n  position: static;\n}\n\nimg[class~=avatarIcon] {\n  background-color: rgb(158, 158, 158);\n  border-radius: 50%;\n  height: 40px;\n}\n\nimg[class~=reactionIcon] {\n  position: absolute;\n  top: 40px;\n  left: 40px;\n  padding: 3px;\n  width: 25px;\n  height: auto;\n}", "", {"version":3,"sources":["/./src/web/components/themes/likes-readers.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;CAClB;;AAED;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;CACrB;;AAED;EACE,gBAAgB;CACjB;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;CACd;;AAED;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;CACd","file":"likes-readers.css","sourcesContent":[".tooltip {\n  text-align: left;\n}\n\n.tooltipInner {\n  background: #fdfdfd!important;\n  border: solid 1px #EEE;\n  border-radius: 3px;\n  color: #666!important;\n  min-width: 100px;\n  max-width: 150px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.listItem[class~=pointer] {\n  cursor: pointer;\n}\n\n[class~=avatarReaction] .itemAction > div {\n  position: static;\n}\n\nimg[class~=avatarIcon] {\n  background-color: rgb(158, 158, 158);\n  border-radius: 50%;\n  height: 40px;\n}\n\nimg[class~=reactionIcon] {\n  position: absolute;\n  top: 40px;\n  left: 40px;\n  padding: 3px;\n  width: 25px;\n  height: auto;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"tooltip": "likes-readers--tooltip--3kobKKbf",
	"tooltipInner": "likes-readers--tooltipInner--vYV_h7xY",
	"listItem": "likes-readers--listItem--2b4ffxKc",
	"itemAction": "likes-readers--itemAction--jsY1Hhdo"
};

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(219);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 2600 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawKPIPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _kpiPage = __webpack_require__(2602);

var _kpiPage2 = _interopRequireDefault(_kpiPage);

var _list = __webpack_require__(25);

var _button = __webpack_require__(8);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _formatNumber = __webpack_require__(201);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _kpi = __webpack_require__(1071);

var _kpi2 = _interopRequireDefault(_kpi);

var _newBadge = __webpack_require__(291);

var _newBadge2 = _interopRequireDefault(_newBadge);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reactCircle = __webpack_require__(1072);

var _reactCircle2 = _interopRequireDefault(_reactCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * src/web/components/kpi-page.jsx
 * KPI進捗状況のTOPページ（現在のKPIと終了したKPIの一覧）
 */

function formatKpi(kpi, t) {
  var assignedMembers;
  if (kpi.assignments.length == 0) assignedMembers = t('label:割り当てられていません');else assignedMembers = kpi.assignments.slice(0, 3).map(function (assignment) {
    return assignment.name;
  }).join(',');
  if (kpi.assignments.length > 3) assignedMembers += '... ' + t('label:他n人', { n: kpi.assignments.length - 3 });

  var dateRange = (0, _moment2.default)(kpi.start_date).format('llll') + ' - ' + (0, _moment2.default)(kpi.end_date).format('llll');
  var targetNum = (0, _formatNumber.formatNumber)(kpi.target, kpi.display_format);

  return dateRange + ', ' + t('label:目標値', { value: targetNum }) + ', ' + t('label:担当者', { assignments: assignedMembers });
}

var KPIPage = function (_React$Component) {
  _inherits(KPIPage, _React$Component);

  function KPIPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, KPIPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KPIPage.__proto__ || Object.getPrototypeOf(KPIPage)).call.apply(_ref, [this].concat(args))), _this), _this.openKPIChartPage = function (props, kpi_id, closedKpis) {
      var offset = _this.rightSidePage.kpiScrollPosition();
      _this.props.openKPIChartPage(props, kpi_id, closedKpis, offset);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(KPIPage, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!this.props.closedKpis && prevProps.closedKpis) {
        this.props.updateUI({ showClosedKpi: false });
        this.rightSidePage && this.rightSidePage.scrollTo();
      } else {
        this.props.scrollPosition && this.rightSidePage && this.rightSidePage.scrollTo(this.props.scrollPosition);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          kpis = _props.kpis,
          group = _props.group,
          closedKpis = _props.closedKpis,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          hasMoreClosedKpis = _props.hasMoreClosedKpis,
          scrollPosition = _props.scrollPosition,
          fetchKpis = _props.fetchKpis,
          fetchClosedKpis = _props.fetchClosedKpis,
          openKPIChartPage = _props.openKPIChartPage,
          openGroupKPIPanel = _props.openGroupKPIPanel,
          updateUI = _props.updateUI;


      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: t('label:KPI進捗状況'), icon: 'insert_chart', innerRef: function innerRef(c) {
            return _this2.rightSidePage = c;
          } },
        !isFetchFailed && group && group.is_admin && _react2.default.createElement(_button.Button, { icon: 'add', theme: _successButton2.default, raised: true,
          label: t('label:KPIを作成'),
          onClick: openGroupKPIPanel }),
        !isFetchFailed && _react2.default.createElement(
          _list.List,
          { selectable: true },
          _react2.default.createElement(_list.ListItem, { caption: t('label:現在のKPI'), selectable: false, ripple: false }),
          isFetching && (!kpis || kpis.length == 0) && _react2.default.createElement(_loading2.default, null),
          !isFetching && (!kpis || kpis.length == 0) && _react2.default.createElement(_list.ListItem, { caption: t('label:KPIは登録されていません'), selectable: false, ripple: false }),
          kpis && kpis.length > 0 && _.map(kpis, function (kpi) {
            return _react2.default.createElement(_list.ListItem, { key: kpi.kpi_id,
              theme: _kpi2.default,
              className: 'kpi_name',
              leftIcon: 'insert_chart',
              caption: kpi.name,
              legend: formatKpi(kpi, t),
              onClick: function onClick() {
                return openKPIChartPage(_this2.props, kpi.kpi_id);
              },
              rightActions: [kpi && kpi.accumulated_total && kpi.total / kpi.target >= 1.0 && isFinite(kpi.total / kpi.target) && _react2.default.createElement(
                'div',
                { key: kpi.kpi_id, className: _newBadge2.default.kpi },
                t('label:達成')
              ), kpi.accumulated_total && kpi.target && kpi.target != 0 && _react2.default.createElement(_reactCircle2.default, { key: kpi.kpi_id,
                size: '60',
                lineWidth: '45',
                textStyle: { font: 'bold 7rem Helvetica, Arial, sans-serif' },
                progress: Math.round(kpi.total / kpi.target * 100) }) || undefined] });
          }),
          _react2.default.createElement(_list.ListItem, { caption: t('label:終了したKPI'),
            selectable: true,
            rightIcon: ui.showClosedKpi && "arrow_drop_up" || "arrow_drop_down",
            onClick: function onClick() {
              !ui.showClosedKpi && fetchClosedKpis(_this2.props, true);
              updateUI({ showClosedKpi: !ui.showClosedKpi });
            } }),
          isFetching && kpis && kpis.length > 0 && ui.showClosedKpi && (!closedKpis || closedKpis.length == 0) && _react2.default.createElement(_loading2.default, null),
          !isFetching && ui.showClosedKpi && (!closedKpis || closedKpis.length == 0) && _react2.default.createElement(_list.ListItem, { caption: t('label:KPIは登録されていません'), selectable: false, ripple: false }),
          ui.showClosedKpi && closedKpis && closedKpis.length > 0 && _.map(closedKpis, function (kpi) {
            return _react2.default.createElement(_list.ListItem, { key: kpi.kpi_id,
              theme: _kpi2.default,
              className: 'kpi_name',
              leftIcon: 'insert_chart',
              caption: kpi.name,
              legend: formatKpi(kpi, t),
              onClick: function onClick() {
                return _this2.openKPIChartPage(_this2.props, kpi.kpi_id, closedKpis);
              },
              rightActions: [kpi && kpi.accumulated_total && kpi.total / kpi.target >= 1.0 && isFinite(kpi.total / kpi.target) && _react2.default.createElement(
                'div',
                { key: kpi.kpi_id, className: _newBadge2.default.kpi },
                t('label:達成')
              ), kpi.accumulated_total && kpi.target && kpi.target != 0 && _react2.default.createElement(_reactCircle2.default, { key: kpi.kpi_id,
                size: '60',
                lineWidth: '45',
                textStyle: { font: 'bold 7rem Helvetica, Arial, sans-serif' },
                progress: Math.round(kpi.total / kpi.target * 100) }) || undefined] });
          }),
          !isFetching && ui.showClosedKpi && closedKpis && closedKpis.length > 0 && hasMoreClosedKpis && _react2.default.createElement(_list.ListItem, { selectable: false, ripple: false, rightActions: [_react2.default.createElement(_button.Button, { flat: true, key: 'more', icon: 'arrow_drop_down',
              label: t('label:続きを表示'),
              onClick: function onClick() {
                return fetchClosedKpis(_this2.props);
              } })] })
        ),
        isFetchFailed && _react2.default.createElement(
          'div',
          { style: { marginTop: '10px', textAlign: 'center' } },
          t('label:KPIの取得に失敗しました')
        )
      );
    }
  }]);

  return KPIPage;
}(_react2.default.Component);

var RawKPIPage = exports.RawKPIPage = KPIPage;
exports.default = (0, _kpiPage2.default)(KPIPage);

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/kpi-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    group: state.groups.items && (0, _find2.default)(state.groups.items, function (item) {
      return item.group_id == ownProps.params.group_id;
    }) || undefined,
    kpis: state.kpi.items,
    closedKpis: state.kpi.closedItems,
    isFetching: state.kpi.isFetching,
    hasMoreClosedKpis: state.kpi.hasMoreClosedItems,
    scrollPosition: state.kpi.scrollPosition || undefined
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchKpis: function fetchKpis(props) {
      return dispatch(_actions2.default.fetchKpis(props.params.group_id));
    },
    fetchClosedKpis: function fetchClosedKpis(props) {
      var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return dispatch(_actions2.default.fetchClosedKpis(props.params.group_id, refresh ? 0 : props.closedKpis && props.closedKpis.length || 0));
    },
    willMount: function willMount(props) {
      if (props.closedKpis) {
        props.updateUI({ showClosedKpi: true });
      }
      dispatch(_actions2.default.fetchKpis(props.params.group_id));
    },
    willUnmount: function willUnmount(props) {
      if (!props.ui.showKpiChart) {
        dispatch(_actions2.default.clearKpis());
      }
    },
    openKPIChartPage: function openKPIChartPage(props, kpi_id, closedKpis, offset) {
      if (closedKpis) {
        props.updateUI({ showKpiChart: true });
        offset && dispatch(_actions2.default.keepScrollPosition(offset));
      }
      dispatch(_actions2.default.openRightSidePage('kpi_chart', { kpi_id: kpi_id, group_id: props.params.group_id }, true));
    },
    openGroupKPIPanel: function openGroupKPIPanel() {
      return dispatch(_actions2.default.openGroupSettingsPage('kpi'));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: { showClosedKpi: false, showKpiChart: false } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('kpi'));

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.kpi--listItem--6VNjvZT7[class~=kpi_name] .kpi--itemContentRoot--2aHEIvE7{\n  overflow: hidden;\n}\n\n.kpi--listItem--6VNjvZT7[class~=kpi_name] .kpi--itemText--3fUccHJk{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.kpi--whiteDiv--3nOubElL {\n  background-color: white;\n}\n\n.kpi--settingTitle--3XG8Ecc9 {\n  background-color: #f9fafb;\n  margin: 0px 15px 0px;\n  border: 1px solid #e7e7e7;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.kpi--settingTitle--3XG8Ecc9.kpi--closed--rBpazkf0 {\n  border-radius: 5px!important;\n}\n\n.kpi--settingWrap--16PM-wpN {\n  padding: 0px 15px 0px;\n  border: 1px solid #e7e7e7;\n  margin: 0px 15px 0px;\n  border-top: 0px;\n  border-radius: 0px 0px 5px 5px;\n}\n\n.kpi--itemWrap--1Hhc05jj {\n  padding: 15px 0px 15px!important;\n}\n\n.kpi--cardItem--1FTkoZ3Q {\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  padding: 15px!important;\n}\n\n.kpi--dateItem--2JnhDQ7P {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n.kpi--dateItem--2JnhDQ7P > div:first-child {\n  width: 100%;\n}\n\n.kpi--dateItem--2JnhDQ7P div div input {\n  border: 1px solid #e7e7e7;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.kpi--kpiItem--29G6uxA3 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border: 1px solid #e7e7e7;\n  padding: 10px;\n  border-radius: 5px;\n  height: 40px;\n  margin-bottom: 5px;\n  cursor: move;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.kpi--kpiTitle--gl1hb-lR {\n  width: 100%;\n}\n\n.kpi--removeBtn--23VC4aUP {\n  margin-top: -8px;\n}\n\n.kpi--dropDownList--3iwlxYoz div {\n  padding: 0px;\n}\n\n.kpi--dropDownList--3iwlxYoz div input {\n  border: 1px dashed #e7e7e7;\n  border-radius: 5px;\n  padding: 10px;\n  color: #306ced;\n  text-align: center;\n}\n\n.kpi--dropDownList--3iwlxYoz div::after {\n  display: none;\n}\n\n.kpi--itemTitle--3d4V29YN {\n  margin-bottom: 10px;\n}\n\n.kpi--chartTypeDropDownList--jZAXVXHU div {\n  padding: 0px;\n  margin-left: 15px;\n}\n\n.kpi--chartTypeDropDownList--jZAXVXHU div input {\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  padding: 10px;\n}\n\n.kpi--checkBox--1PUjDttF {\n  margin-left: 5px;\n  padding-top: 8px;\n  min-width: 90px;\n}\n\n.kpi--checkBox--1PUjDttF:nth-of-type(1) {\n  min-width: 65px;\n}\n\n.kpi--checkBox--1PUjDttF:nth-of-type(3) {\n  min-width: 78px;\n}\n\n.kpi--checkBox--1PUjDttF:nth-of-type(4) {\n  min-width: 78px;\n}\n\n.kpi--checkBox--1PUjDttF:last-of-type {\n  min-width: 65px;\n}\n\n.kpi--checkBox--1PUjDttF span {\n  padding-left: 5px;\n}\n\n.kpi--checkBox--1PUjDttF span button {\n  padding: 0px;\n  margin-top: -9px;\n  color: black;\n  text-align: left;\n}\n\n.kpi--navItem--26MrWSu2 {\n  margin-left: 15px;\n}\n\n.kpi--navItem--26MrWSu2 section {\n  border: 1px solid #CCCCCC;\n}\n\n.kpi--dayItem--1qx0R7NU {\n  border: 1px solid #CCCCCC;\n  border-bottom: none;\n  border-radius: 5px 0 0 0;\n}\n\n.kpi--monthItem--2-hQuZHe {\n  border-top: 1px solid #CCCCCC;\n}\n\n.kpi--yearItem--35hSOJBC {\n  border: 1px solid #CCCCCC;\n  border-bottom: none;\n  border-radius: 0 5px 0 0;\n}\n\n.kpi--kpiComparisonItem--10ynyiiE {\n  margin: 15px;\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  padding: 0px 0px 10px;\n}\n\n.kpi--kpiComparisonItem--10ynyiiE .kpi--kpiItem--29G6uxA3 {\n  border: 0;\n}\n\n.kpi--kpiComparisonName--Fnme_Kug {\n  padding-top: 10px;\n  width: 100%;\n}\n\n.kpi--tooltip--1j7Pc0uU {\n  text-align: left;\n}\n\n.kpi--tooltipInner--2GRMzbNW {\n  background: #fdfdfd!important;\n  border: solid 1px #EEE;\n  border-radius: 3px;\n  color: #666!important;\n  min-width: 150px;\n  max-width: 150px;\n  overflow: hidden;\n  white-space: normal;\n}\n\n.kpi--fontIcon--29j6Dx6p {\n  vertical-align: bottom;\n  font-size: 16px;\n  margin-right: 5px;\n}\n\n.kpi--buttonFontIcon--36GA5xO4 {\n  vertical-align: middle;\n  font-size: 20px;\n  margin-right: 5px;\n  margin-top: -1px;\n}\n\n.kpi--disabledDatePicker--bVCuVkrP input {\n  pointer-events: none;\n  background-color: #f0f0f0;\n  color: #a0a0a0;\n  cursor: not-allowed;\n}\n\n.kpi--aggregationDatesWrap--2irpHXJW {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-top: 20px;\n  margin-left: 15px;\n}\n\n.kpi--aggregationTypeList--PVJAIbx2 div {\n  padding: 0px;\n}\n\n.kpi--aggregationTypeList--PVJAIbx2 ul {\n  top: 0px!important;\n  bottom: auto!important;\n}\n\n.kpi--aggregationTypeList--PVJAIbx2 div input {\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  padding: 10px;\n  width: 100px;\n}\n\n.kpi--dateButton--1GSiyIE4 {\n  margin-left: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.kpi--dateButton--1GSiyIE4 div div input {\n  border-radius: 5px;\n  border: 1px solid #cccccc;\n  width: 165px;\n  text-align: center;\n  padding: 10px;\n  caret-color: transparent;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}", "", {"version":3,"sources":["/./src/web/components/themes/kpi.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB;;AAED;EACE,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;CACzB;;AAED;EACE,wBAAwB;CACzB;;AAED;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;CAChC;;AAED;EACE,6BAA6B;CAC9B;;AAED;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;CAChC;;AAED;EACE,iCAAiC;CAClC;;AAED;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;CACzB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;MAChB,qBAAqB;UACjB,aAAa;CACtB;;AAED;EACE,YAAY;CACb;;AAED;EACE,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;CACpB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0BAA0B;KACvB,uBAAuB;MACtB,sBAAsB;UAClB,kBAAkB;CAC3B;;AAED;EACE,YAAY;CACb;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,aAAa;CACd;;AAED;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;CACpB;;AAED;EACE,cAAc;CACf;;AAED;EACE,oBAAoB;CACrB;;AAED;EACE,aAAa;EACb,kBAAkB;CACnB;;AAED;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;CACf;;AAED;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;CACjB;;AAED;EACE,gBAAgB;CACjB;;AAED;EACE,gBAAgB;CACjB;;AAED;EACE,gBAAgB;CACjB;;AAED;EACE,gBAAgB;CACjB;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,iBAAiB;CAClB;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,0BAA0B;CAC3B;;AAED;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;CAC1B;;AAED;EACE,8BAA8B;CAC/B;;AAED;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;CAC1B;;AAED;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;CACvB;;AAED;EACE,UAAU;CACX;;AAED;EACE,kBAAkB;EAClB,YAAY;CACb;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;CACrB;;AAED;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;CACnB;;AAED;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;CAClB;;AAED;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;CACrB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,aAAa;CACd;;AAED;EACE,mBAAmB;EACnB,uBAAuB;CACxB;;AAED;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,aAAa;CACd;;AAED;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;;AAED;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,0BAA0B;KACvB,uBAAuB;MACtB,sBAAsB;UAClB,kBAAkB;CAC3B","file":"kpi.css","sourcesContent":["\n.listItem[class~=kpi_name] .itemContentRoot{\n  overflow: hidden;\n}\n\n.listItem[class~=kpi_name] .itemText{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.whiteDiv {\n  background-color: white;\n}\n\n.settingTitle {\n  background-color: #f9fafb;\n  margin: 0px 15px 0px;\n  border: 1px solid #e7e7e7;\n  border-radius: 5px 5px 0px 0px;\n}\n\n.settingTitle.closed {\n  border-radius: 5px!important;\n}\n\n.settingWrap {\n  padding: 0px 15px 0px;\n  border: 1px solid #e7e7e7;\n  margin: 0px 15px 0px;\n  border-top: 0px;\n  border-radius: 0px 0px 5px 5px;\n}\n\n.itemWrap {\n  padding: 15px 0px 15px!important;\n}\n\n.cardItem {\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  padding: 15px!important;\n}\n\n.dateItem {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n.dateItem > div:first-child {\n  width: 100%;\n}\n\n.dateItem div div input {\n  border: 1px solid #e7e7e7;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.kpiItem {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border: 1px solid #e7e7e7;\n  padding: 10px;\n  border-radius: 5px;\n  height: 40px;\n  margin-bottom: 5px;\n  cursor: move;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.kpiTitle {\n  width: 100%;\n}\n\n.removeBtn {\n  margin-top: -8px;\n}\n\n.dropDownList div {\n  padding: 0px;\n}\n\n.dropDownList div input {\n  border: 1px dashed #e7e7e7;\n  border-radius: 5px;\n  padding: 10px;\n  color: #306ced;\n  text-align: center;\n}\n\n.dropDownList div::after {\n  display: none;\n}\n\n.itemTitle {\n  margin-bottom: 10px;\n}\n\n.chartTypeDropDownList div {\n  padding: 0px;\n  margin-left: 15px;\n}\n\n.chartTypeDropDownList div input {\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  padding: 10px;\n}\n\n.checkBox {\n  margin-left: 5px;\n  padding-top: 8px;\n  min-width: 90px;\n}\n\n.checkBox:nth-of-type(1) {\n  min-width: 65px;\n}\n\n.checkBox:nth-of-type(3) {\n  min-width: 78px;\n}\n\n.checkBox:nth-of-type(4) {\n  min-width: 78px;\n}\n\n.checkBox:last-of-type {\n  min-width: 65px;\n}\n\n.checkBox span {\n  padding-left: 5px;\n}\n\n.checkBox span button {\n  padding: 0px;\n  margin-top: -9px;\n  color: black;\n  text-align: left;\n}\n\n.navItem {\n  margin-left: 15px;\n}\n\n.navItem section {\n  border: 1px solid #CCCCCC;\n}\n\n.dayItem {\n  border: 1px solid #CCCCCC;\n  border-bottom: none;\n  border-radius: 5px 0 0 0;\n}\n\n.monthItem {\n  border-top: 1px solid #CCCCCC;\n}\n\n.yearItem {\n  border: 1px solid #CCCCCC;\n  border-bottom: none;\n  border-radius: 0 5px 0 0;\n}\n\n.kpiComparisonItem {\n  margin: 15px;\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  padding: 0px 0px 10px;\n}\n\n.kpiComparisonItem .kpiItem {\n  border: 0;\n}\n\n.kpiComparisonName {\n  padding-top: 10px;\n  width: 100%;\n}\n\n.tooltip {\n  text-align: left;\n}\n\n.tooltipInner {\n  background: #fdfdfd!important;\n  border: solid 1px #EEE;\n  border-radius: 3px;\n  color: #666!important;\n  min-width: 150px;\n  max-width: 150px;\n  overflow: hidden;\n  white-space: normal;\n}\n\n.fontIcon {\n  vertical-align: bottom;\n  font-size: 16px;\n  margin-right: 5px;\n}\n\n.buttonFontIcon {\n  vertical-align: middle;\n  font-size: 20px;\n  margin-right: 5px;\n  margin-top: -1px;\n}\n\n.disabledDatePicker input {\n  pointer-events: none;\n  background-color: #f0f0f0;\n  color: #a0a0a0;\n  cursor: not-allowed;\n}\n\n.aggregationDatesWrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-top: 20px;\n  margin-left: 15px;\n}\n\n.aggregationTypeList div {\n  padding: 0px;\n}\n\n.aggregationTypeList ul {\n  top: 0px!important;\n  bottom: auto!important;\n}\n\n.aggregationTypeList div input {\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  padding: 10px;\n  width: 100px;\n}\n\n.dateButton {\n  margin-left: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.dateButton div div input {\n  border-radius: 5px;\n  border: 1px solid #cccccc;\n  width: 165px;\n  text-align: center;\n  padding: 10px;\n  caret-color: transparent;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listItem": "kpi--listItem--6VNjvZT7",
	"itemContentRoot": "kpi--itemContentRoot--2aHEIvE7",
	"itemText": "kpi--itemText--3fUccHJk",
	"whiteDiv": "kpi--whiteDiv--3nOubElL",
	"settingTitle": "kpi--settingTitle--3XG8Ecc9",
	"closed": "kpi--closed--rBpazkf0",
	"settingWrap": "kpi--settingWrap--16PM-wpN",
	"itemWrap": "kpi--itemWrap--1Hhc05jj",
	"cardItem": "kpi--cardItem--1FTkoZ3Q",
	"dateItem": "kpi--dateItem--2JnhDQ7P",
	"kpiItem": "kpi--kpiItem--29G6uxA3",
	"kpiTitle": "kpi--kpiTitle--gl1hb-lR",
	"removeBtn": "kpi--removeBtn--23VC4aUP",
	"dropDownList": "kpi--dropDownList--3iwlxYoz",
	"itemTitle": "kpi--itemTitle--3d4V29YN",
	"chartTypeDropDownList": "kpi--chartTypeDropDownList--jZAXVXHU",
	"checkBox": "kpi--checkBox--1PUjDttF",
	"navItem": "kpi--navItem--26MrWSu2",
	"dayItem": "kpi--dayItem--1qx0R7NU",
	"monthItem": "kpi--monthItem--2-hQuZHe",
	"yearItem": "kpi--yearItem--35hSOJBC",
	"kpiComparisonItem": "kpi--kpiComparisonItem--10ynyiiE",
	"kpiComparisonName": "kpi--kpiComparisonName--Fnme_Kug",
	"tooltip": "kpi--tooltip--1j7Pc0uU",
	"tooltipInner": "kpi--tooltipInner--2GRMzbNW",
	"fontIcon": "kpi--fontIcon--29j6Dx6p",
	"buttonFontIcon": "kpi--buttonFontIcon--36GA5xO4",
	"disabledDatePicker": "kpi--disabledDatePicker--bVCuVkrP",
	"aggregationDatesWrap": "kpi--aggregationDatesWrap--2irpHXJW",
	"aggregationTypeList": "kpi--aggregationTypeList--PVJAIbx2",
	"dateButton": "kpi--dateButton--1GSiyIE4"
};

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawKPIChatPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _kpiChartPage = __webpack_require__(2605);

var _kpiChartPage2 = _interopRequireDefault(_kpiChartPage);

var _reactHighcharts = __webpack_require__(387);

var _reactHighcharts2 = _interopRequireDefault(_reactHighcharts);

var _tabs = __webpack_require__(188);

var _list = __webpack_require__(25);

var _button = __webpack_require__(8);

var _card = __webpack_require__(28);

var _datePicker = __webpack_require__(165);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _menu = __webpack_require__(63);

var _diaryFormsTab = __webpack_require__(570);

var _diaryFormsTab2 = _interopRequireDefault(_diaryFormsTab);

var _kpi = __webpack_require__(1071);

var _kpi2 = _interopRequireDefault(_kpi);

var _newBadge = __webpack_require__(291);

var _newBadge2 = _interopRequireDefault(_newBadge);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _kpiChartRankingTable = __webpack_require__(2606);

var _kpiChartRankingTable2 = _interopRequireDefault(_kpiChartRankingTable);

var _kpiChartDetailTable = __webpack_require__(2614);

var _kpiChartDetailTable2 = _interopRequireDefault(_kpiChartDetailTable);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _reactCircle = __webpack_require__(1072);

var _reactCircle2 = _interopRequireDefault(_reactCircle);

var _html2canvas = __webpack_require__(1075);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

var _jspdf = __webpack_require__(2616);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _uuid = __webpack_require__(2618);

var _reactSortableHoc = __webpack_require__(231);

var _link = __webpack_require__(183);

var _link2 = _interopRequireDefault(_link);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * src/web/components/kpi-chart-page.jsx
 * kpi-pageの一覧から選択されたKPIの進捗状況ページ
 */

var TooltipButton = (0, _tooltip2.default)(_button.Button);

function KPIChart(props) {
  var t = props.t,
      kpi = props.kpi,
      kpis = props.kpis,
      comparison_kpis = props.comparison_kpis,
      selectedKPIs = props.selectedKPIs,
      periodType = props.periodType,
      ui = props.ui,
      monthly = props.monthly,
      onClickLegend = props.onClickLegend,
      width = props.width;


  var data = void 0;

  if (ui.isComparison) {
    data = (0, _kpiChartPage.calcComparisonHighchartData)(comparison_kpis, t, ui);
  } else {
    data = ui.chartType == 'pie' ? (0, _kpiChartPage.calcPieHighchartData)(selectedKPIs, kpis, t, ui) : (0, _kpiChartPage.calcColumnLineHighchartData)(selectedKPIs, kpis, t, periodType, ui);
  }

  return _react2.default.createElement(_reactHighcharts2.default, { config: data });
}

var chartTypeList = [{ value: 'column', label: '棒グラフ' }, { value: 'line', label: '折れ線グラフ' }, { value: 'pie', label: '円グラフ' }];

var aggregationTypeList = [{ value: 'cumulative', label: '累計' }, { value: 'daily_total_01', label: '日毎一覧' }, { value: 'daily_total_02', label: '日毎累積' }];

var linkURL = 'https://support.getgamba.com/hc/ja/articles/42544928549017';

// Define each sortable item with the DragHandle
var SortableKPIItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var selectedKPI = _ref.selectedKPI,
      onRemoveKPI = _ref.onRemoveKPI,
      props = _ref.props;
  return _react2.default.createElement(
    'div',
    { className: _kpi2.default.kpiItem, style: { backgroundColor: '#f9fafb' } },
    _react2.default.createElement(
      'div',
      { className: _kpi2.default.kpiTitle },
      selectedKPI.label
    ),
    _react2.default.createElement(_button.IconButton, { style: { color: 'rgb(117, 117, 117)' },
      icon: 'close',
      className: _kpi2.default.removeBtn,
      onClick: function onClick() {
        return onRemoveKPI(selectedKPI.id, props);
      }
    })
  );
});

// Define the sortable list container
var SortableKPIList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
  var selectedKPIs = _ref2.selectedKPIs,
      onRemoveKPI = _ref2.onRemoveKPI,
      props = _ref2.props;
  return _react2.default.createElement(
    'div',
    null,
    selectedKPIs.map(function (selectedKPI, index) {
      return _react2.default.createElement(SortableKPIItem, {
        key: selectedKPI.id,
        index: index,
        selectedKPI: selectedKPI,
        onRemoveKPI: onRemoveKPI,
        props: props
      });
    })
  );
});

var KPIChatPage = function (_PureComponent) {
  _inherits(KPIChatPage, _PureComponent);

  function KPIChatPage() {
    var _this2 = this;

    _classCallCheck(this, KPIChatPage);

    var _this = _possibleConstructorReturn(this, (KPIChatPage.__proto__ || Object.getPrototypeOf(KPIChatPage)).call(this));

    _this.generateKPIPDF = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(kpi_name) {
        var file_name, chartDiv, kpiTitle, kpiPeriod, imgs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, img, chartCanvas, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _img, chartImgData, pdf, marginLeft, marginTop, marginBottom, availableWidth, availableHeight, chartScale;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file_name = kpi_name + "_kpi_progress.pdf";
                chartDiv = document.getElementById('chartContainer');
                kpiTitle = document.getElementById('kpi_title');
                kpiPeriod = document.getElementById('kpi_period');

                if (!(!chartDiv || !kpiTitle || !kpiPeriod)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt('return');

              case 6:
                imgs = chartDiv.getElementsByTagName('img');
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;


                for (_iterator = imgs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  img = _step.value;

                  if (img.parentElement) {
                    img.parentElement.style.display = 'none'; // Hide avatar img
                  }
                }
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](10);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 18:
                _context.prev = 18;
                _context.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 21:
                _context.prev = 21;

                if (!_didIteratorError) {
                  _context.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context.finish(21);

              case 25:
                return _context.finish(18);

              case 26:
                kpiTitle.style.display = 'block'; // Display kpi title
                kpiPeriod.style.display = 'block'; // Display kpi period

                _context.next = 30;
                return (0, _html2canvas2.default)(chartDiv, { scale: 1, useCORS: true });

              case 30:
                chartCanvas = _context.sent;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context.prev = 34;


                for (_iterator2 = imgs[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _img = _step2.value;

                  if (_img.parentElement) {
                    _img.parentElement.style.display = 'inline-block'; // Display avatar img
                  }
                }
                _context.next = 42;
                break;

              case 38:
                _context.prev = 38;
                _context.t1 = _context['catch'](34);
                _didIteratorError2 = true;
                _iteratorError2 = _context.t1;

              case 42:
                _context.prev = 42;
                _context.prev = 43;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 45:
                _context.prev = 45;

                if (!_didIteratorError2) {
                  _context.next = 48;
                  break;
                }

                throw _iteratorError2;

              case 48:
                return _context.finish(45);

              case 49:
                return _context.finish(42);

              case 50:
                kpiTitle.style.display = 'none'; // Hide kpi title
                kpiPeriod.style.display = 'none'; // Hide kpi peroiod

                // Get the image data
                chartImgData = chartCanvas.toDataURL('image/png');

                // Initialize jsPDF

                pdf = new _jspdf2.default({
                  orientation: 'portrait',
                  unit: 'px',
                  format: [chartCanvas.width, chartCanvas.height]
                });

                // Define margins

                marginLeft = 30;
                marginTop = 30;
                marginBottom = 30;

                // Calculate the available width and height considering the margins

                availableWidth = pdf.internal.pageSize.getWidth() - marginLeft * 2;
                availableHeight = pdf.internal.pageSize.getHeight() - marginTop - marginBottom;

                // Calculate the scale factor based on the available width and height

                chartScale = Math.min(availableWidth / chartCanvas.width, availableHeight / chartCanvas.height);

                // Add the image to the PDF using the scale factor and margins for x and y coordinates

                pdf.addImage(chartImgData, 'PNG', marginLeft, marginTop, chartCanvas.width * chartScale, chartCanvas.height * chartScale);

                // Save the PDF with chartContainer
                pdf.save(file_name);

              case 62:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[10, 14, 18, 26], [19,, 21, 25], [34, 38, 42, 50], [43,, 45, 49]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.generateKPIPNG = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(kpi_name) {
        var file_name, svgDiv, svgCanvas, svgImgData, link;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                file_name = kpi_name + "_kpi_progress.png";
                svgDiv = document.getElementById('svgContainer');
                _context2.next = 4;
                return (0, _html2canvas2.default)(svgDiv, { scale: 1, useCORS: true });

              case 4:
                svgCanvas = _context2.sent;


                // Get the image data URL
                svgImgData = svgCanvas.toDataURL('image/png');

                // Create a link element

                link = document.createElement('a');

                link.href = svgImgData;
                link.download = file_name;

                // Append link to the body
                document.body.appendChild(link);

                // Trigger click event on the link to start the download
                link.click();

                // Clean up and remove the link
                document.body.removeChild(link);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.getYearList = function (start_date, end_date) {
      var startYear = (0, _moment2.default)(start_date).year();
      var endYear = (0, _moment2.default)(end_date).year();
      var years = [];

      for (var year = startYear; year <= endYear; year++) {
        years.push({ value: year.toString(), label: year.toString() + ' \u5E74' });
      }
      return years;
    };

    _this.onAddKPI = function (kpi_id, props) {
      if (kpi_id == 0) return; // Do nothing if the initial value is selected

      // Find the selected KPI object from the list of KPIs
      var selectedKPI = _this.props.group_kpis.find(function (item) {
        return item.kpi_id == kpi_id;
      });
      var year_list = _this.getYearList(selectedKPI.start_date, selectedKPI.end_date);

      var updatedKPIs = [].concat(_toConsumableArray(_this.props.ui.selectedKPIs), [{ id: (0, _uuid.v4)(), kpi_id: kpi_id, label: selectedKPI.name, year: year_list[year_list.length - 1].value, year_list: year_list }]);

      _this.props.updateUI({ selectedKPIs: updatedKPIs });
      _this.props.fetchChartKpis(updatedKPIs, props);
      _this.props.fetchComparisonKpis(updatedKPIs, props);
    };

    _this.onRemoveKPI = function (id, props) {
      var updatedKPIs = _this.props.ui.selectedKPIs.filter(function (k) {
        return k.id !== id;
      });

      _this.props.updateUI({ selectedKPIs: updatedKPIs });
      _this.props.fetchComparisonKpis(updatedKPIs, props);
    };

    _this.onUpdateKPIDate = function (dateType, date) {
      _this.props.updateUI(_defineProperty({}, dateType, date));
    };

    _this.onChangeComparisonYear = function (id, year, props) {
      // Update only the specific KPI in the selectedKPIs array in a single pass
      var updatedKPIs = _this.props.ui.selectedKPIs.map(function (kpi) {
        return kpi.id == id ? _extends({}, kpi, { year: year }) : kpi;
      });

      _this.props.updateUI({ selectedKPIs: updatedKPIs });
      _this.props.fetchComparisonKpis(updatedKPIs, props);
    };

    _this.onSortEnd = function (_ref5) {
      var oldIndex = _ref5.oldIndex,
          newIndex = _ref5.newIndex;
      var selectedKPIs = _this.props.ui.selectedKPIs;

      var newOrder = (0, _reactSortableHoc.arrayMove)(selectedKPIs, oldIndex, newIndex);
      _this.props.updateUI({ selectedKPIs: newOrder });
    };

    _this.selectUser = function (index) {
      _this.props.updateUI({ selected_user_id: index.dataKey != 'percent' && index.dataKey || undefined });
    };
    // Bind the generateKPIPDF method to the current instance
    _this.generateKPIPDF = _this.generateKPIPDF.bind(_this);
    _this.generateKPIPNG = _this.generateKPIPNG.bind(_this);
    return _this;
  }

  _createClass(KPIChatPage, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var kpi = this.props.kpi;

      // Check if the kpi changed or was set and selectedKPIs is still empty and add current KPI as default

      if (kpi && kpi != prevProps.kpi || kpi && this.props.ui.selectedKPIs.length == 0) {
        var year_list = this.getYearList(kpi.start_date, kpi.end_date);
        this.props.updateUI({ selectedKPIs: [{ id: (0, _uuid.v4)(), kpi_id: kpi.kpi_id, label: kpi.name, year: year_list[year_list.length - 1].value, year_list: year_list }] });
        // Set kpiStartDate and kpiEndDate of current kpi
        this.props.updateUI({
          kpiStartDate: (0, _moment2.default)(kpi.start_date),
          kpiEndDate: (0, _moment2.default)(kpi.end_date),
          isCumulative: kpi.accumulated_total,
          aggregationType: kpi.accumulated_total ? 'cumulative' : 'daily_total_01',
          tableSelectedDate: (0, _moment2.default)(kpi.start_date),
          tableStartDate: (0, _moment2.default)(kpi.start_date),
          tableEndDate: (0, _moment2.default)(kpi.end_date)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateActualRecord = _props.updateActualRecord,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          isUpdating = _props.isUpdating,
          isUpdateFailed = _props.isUpdateFailed,
          kpis = _props.kpis,
          group_kpis = _props.group_kpis,
          comparison_kpis = _props.comparison_kpis,
          kpi = _props.kpi,
          user = _props.user,
          group = _props.group,
          updateUI = _props.updateUI,
          openKPIChartPage = _props.openKPIChartPage,
          openGroupKPIPanel = _props.openGroupKPIPanel,
          fetchChartKpis = _props.fetchChartKpis,
          fetchComparisonKpis = _props.fetchComparisonKpis;


      var otherKpis = kpi && kpis && _.filter(kpis, function (item) {
        return item.kpi_id != kpi.kpi_id;
      });
      var kpi_name = kpi && kpi.name || '';

      var selectedKPIs = ui.selectedKPIs;


      var dropDownKPISource = [{ value: 0, label: t('label:KPIを追加') }];

      if (kpi && group_kpis) {
        var groupKPIOptions = group_kpis.map(function (item) {
          return {
            value: item.kpi_id,
            label: item.name
          };
        });

        // Concatenate KPI options with the default option initially
        dropDownKPISource = dropDownKPISource.concat(groupKPIOptions);
      }

      return _react2.default.createElement(
        _rightSidePage2.default,
        {
          title: t('label:KPIの進捗状況', { name: kpi && kpi.name || '' }),
          icon: 'insert_chart',
          rightAction: [!ui.selected_user_id && _react2.default.createElement(
            _menu.IconMenu,
            { icon: 'download', position: 'topRight' },
            _react2.default.createElement(_menu.MenuItem, { caption: t('label:PDFで保存'), onClick: function onClick() {
                return _this3.generateKPIPDF(kpi_name);
              }, icon: 'content_copy' }),
            _react2.default.createElement(_menu.MenuItem, { caption: t('label:画像で保存'), onClick: function onClick() {
                return _this3.generateKPIPNG(kpi_name);
              }, icon: 'image' })
          )] },
        _react2.default.createElement(
          _list.List,
          { selectable: true, className: _kpi2.default.whiteDiv },
          _react2.default.createElement(_list.ListItem, {
            className: _kpi2.default.settingTitle + ' ' + (ui.showKPIDataSetting ? '' : _kpi2.default.closed),
            caption: t('label:KPIデータ設定'),
            selectable: true,
            rightIcon: ui.showKPIDataSetting && "expand_less" || "expand_more",
            onClick: function onClick() {
              !ui.showKPIDataSetting;
              updateUI({ showKPIDataSetting: !ui.showKPIDataSetting });
            }
          }),
          ui.showKPIDataSetting && _react2.default.createElement(
            'div',
            { className: _kpi2.default.settingWrap },
            _react2.default.createElement(
              _card.CardText,
              { className: _kpi2.default.itemWrap },
              _react2.default.createElement(
                'div',
                { className: _kpi2.default.itemTitle },
                t('label:開始日'),
                '\xA0/\xA0',
                t('label:終了日')
              ),
              ui.kpiStartDate && ui.kpiEndDate && _react2.default.createElement(
                'div',
                { style: { display: 'flex' }, className: ui.isComparison ? _kpi2.default.disabledDatePicker : '' },
                _react2.default.createElement(
                  'div',
                  { className: _kpi2.default.dateItem },
                  _react2.default.createElement(_datePicker2.default, { label: t('label:開始日'),
                    value: ui.kpiStartDate.toDate(),
                    maxDate: ui.kpiEndDate.toDate(),
                    onChange: function onChange(date) {
                      return _this3.onUpdateKPIDate('kpiStartDate', (0, _moment2.default)(date));
                    } })
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  '\xA0\xA0'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _kpi2.default.dateItem },
                  _react2.default.createElement(_datePicker2.default, { label: t('label:終了日'),
                    value: ui.kpiEndDate.toDate(),
                    minDate: ui.kpiStartDate.toDate(),
                    onChange: function onChange(date) {
                      return _this3.onUpdateKPIDate('kpiEndDate', (0, _moment2.default)(date));
                    } })
                )
              )
            ),
            _react2.default.createElement(
              _card.CardText,
              { className: _kpi2.default.itemWrap },
              _react2.default.createElement(
                'div',
                { className: _kpi2.default.itemTitle },
                t('label:データ選択')
              ),
              _react2.default.createElement(SortableKPIList, {
                selectedKPIs: selectedKPIs,
                onRemoveKPI: this.onRemoveKPI,
                onSortEnd: this.onSortEnd,
                props: this.props,
                lockAxis: 'y' // locks movement to the vertical axis
              }),
              _react2.default.createElement(_dropdown2.default, { auto: true,
                className: _kpi2.default.dropDownList,
                source: dropDownKPISource,
                value: 0 // Show the default selected option
                , onChange: function onChange(value) {
                  return _this3.onAddKPI(value, _this3.props);
                }
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', paddingTop: 15 } },
            _react2.default.createElement(_dropdown2.default, { auto: true,
              className: _kpi2.default.chartTypeDropDownList,
              source: chartTypeList,
              value: ui.chartType,
              onChange: function onChange(value) {
                return updateUI({ chartType: value });
              }
            }),
            _react2.default.createElement(
              _link2.default,
              {
                href: linkURL,
                target: "_blank",
                rel: "noopener noreferrer",
                style: { display: 'inline', textDecoration: 'none', opacity: 1 }
              },
              _react2.default.createElement(
                'div',
                { style: { fontSize: 16, color: '#306ced', marginLeft: 15 } },
                _react2.default.createElement(_font_icon2.default, { value: 'info', className: _kpi2.default.buttonFontIcon }),
                t('label:使い方')
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', paddingTop: 10, paddingBottom: 10, marginLeft: 10 } },
            _react2.default.createElement(_checkbox2.default, {
              label: _react2.default.createElement(TooltipButton, { neutral: false, ripple: false, className: 'touchable',
                style: { color: ui.isIndividual || ui.isConversion || ui.isComparison ? '#00000042' : 'black' },
                tooltipPosition: 'left',
                theme: _kpi2.default,
                tooltip: _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_font_icon2.default, { value: 'info', className: _kpi2.default.fontIcon }),
                  _react2.default.createElement(
                    'span',
                    null,
                    t('label:累計説明')
                  )
                ),
                label: t('label:累計') }),
              className: _kpi2.default.checkBox,
              checked: ui.isCumulative,
              disabled: ui.isIndividual || ui.isConversion || ui.isComparison ? true : false,
              onChange: function onChange() {
                return updateUI({ isCumulative: !ui.isCumulative });
              } }),
            _react2.default.createElement(_checkbox2.default, {
              label: _react2.default.createElement(TooltipButton, { neutral: false, ripple: false, className: 'touchable',
                style: { color: ui.isConversion || ui.isComparison || ui.isCumulative ? '#00000042' : 'black' },
                tooltipPosition: 'left',
                theme: _kpi2.default,
                tooltip: _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_font_icon2.default, { value: 'info', className: _kpi2.default.fontIcon }),
                  _react2.default.createElement(
                    'span',
                    null,
                    t('label:個人データ説明')
                  )
                ),
                label: t('label:個人データ') }),
              className: _kpi2.default.checkBox,
              checked: ui.isIndividual,
              disabled: ui.isConversion || ui.isComparison || ui.isCumulative ? true : false,
              onChange: function onChange() {
                return updateUI({ isIndividual: !ui.isIndividual, isConversion: false, isComparison: false });
              } }),
            ui.chartType == 'column' && _react2.default.createElement(_checkbox2.default, {
              label: _react2.default.createElement(TooltipButton, { neutral: false, ripple: false, className: 'touchable',
                style: { color: ui.isConversion ? '#00000042' : 'black' },
                tooltipPosition: 'left',
                theme: _kpi2.default,
                tooltip: _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_font_icon2.default, { value: 'info', className: _kpi2.default.fontIcon }),
                  _react2.default.createElement(
                    'span',
                    null,
                    t('label:積み上げ説明')
                  )
                ),
                label: t('label:積み上げ') }),
              className: _kpi2.default.checkBox,
              checked: ui.isStacked,
              disabled: ui.isConversion ? true : false,
              onChange: function onChange() {
                return updateUI({ isStacked: !ui.isStacked, isConversion: false, isComparison: false });
              } }),
            _react2.default.createElement(_checkbox2.default, {
              label: _react2.default.createElement(TooltipButton, { neutral: false, ripple: false, className: 'touchable',
                style: { color: ui.isStacked || ui.isIndividual || ui.isCumulative ? '#00000042' : 'black' },
                tooltipPosition: 'left',
                theme: _kpi2.default,
                tooltip: _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_font_icon2.default, { value: 'info', className: _kpi2.default.fontIcon }),
                  _react2.default.createElement(
                    'span',
                    null,
                    t('label:歩留まり説明')
                  )
                ),
                label: t('label:歩留まり') }),
              className: _kpi2.default.checkBox,
              checked: ui.isConversion,
              disabled: ui.isStacked || ui.isIndividual || ui.isCumulative ? true : false,
              onChange: function onChange() {
                return updateUI({ isConversion: !ui.isConversion, isStacked: false, isIndividual: false, isComparison: false });
              } }),
            _react2.default.createElement(_checkbox2.default, {
              label: _react2.default.createElement(TooltipButton, { neutral: false, ripple: false, className: 'touchable',
                style: { color: ui.isStacked || ui.isIndividual || ui.isConversion || ui.isCumulative ? '#00000042' : 'black' },
                tooltipPosition: 'left',
                theme: _kpi2.default,
                tooltip: _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(_font_icon2.default, { value: 'info', className: _kpi2.default.fontIcon }),
                  _react2.default.createElement(
                    'span',
                    null,
                    t('label:比較説明')
                  )
                ),
                label: t('label:比較') }),
              className: _kpi2.default.checkBox,
              checked: ui.isComparison,
              disabled: ui.isStacked || ui.isIndividual || ui.isConversion || ui.isCumulative ? true : false,
              onChange: function onChange() {
                return updateUI({ isComparison: !ui.isComparison, isIndividual: false, index: !ui.isComparison ? 1 : 0 });
              } })
          ),
          ui.isComparison && _react2.default.createElement(
            'div',
            { style: { marginTop: 10 } },
            _react2.default.createElement(_font_icon2.default, { value: 'info', style: { verticalAlign: 'bottom', marginLeft: 15, marginBottom: -2 } }),
            _react2.default.createElement(
              'span',
              { style: { marginLeft: 5 } },
              t('label:比較説明メッセージ')
            )
          ),
          ui.isComparison && _react2.default.createElement(
            'div',
            { className: _kpi2.default.kpiComparisonItem },
            selectedKPIs.map(function (selectedKPI) {
              return _react2.default.createElement(
                'div',
                { key: selectedKPI.id, className: _kpi2.default.kpiItem, style: { cursor: 'default' } },
                _react2.default.createElement(
                  'div',
                  { className: _kpi2.default.kpiComparisonName },
                  selectedKPI.label
                ),
                _react2.default.createElement(_dropdown2.default, { auto: true,
                  className: _kpi2.default.dropDownList,
                  source: selectedKPI.year_list,
                  value: selectedKPI.year,
                  onChange: function onChange(year) {
                    return _this3.onChangeComparisonYear(selectedKPI.id, year, _this3.props);
                  }
                })
              );
            })
          )
        ),
        !isFetchFailed && isFetching && _react2.default.createElement(_loading2.default, null),
        _react2.default.createElement(
          'div',
          { id: 'chartContainer', className: _kpi2.default.whiteDiv },
          _react2.default.createElement(
            'p',
            { id: 'kpi_title', style: { fontSize: 18, fontWeight: 'bold', display: 'none' } },
            kpi_name,
            ' KPI\u306E\u9032\u6357\u72B6\u6CC1'
          ),
          _react2.default.createElement(
            'div',
            { id: 'svgContainer' },
            !isFetchFailed && !isFetching && kpis && _react2.default.createElement(
              _tabs.Tabs,
              { theme: _diaryFormsTab2.default, index: ui.index, onChange: function onChange(index) {
                  return updateUI({ index: index });
                }, className: _kpi2.default.navItem },
              _react2.default.createElement(
                _tabs.Tab,
                { label: t('label:日次'), className: _kpi2.default.dayItem, disabled: ui.isComparison },
                _react2.default.createElement(KPIChart, {
                  t: t,
                  kpi: kpi,
                  kpis: kpis,
                  comparison_kpis: comparison_kpis,
                  ui: ui,
                  selectedKPIs: selectedKPIs,
                  periodType: 'daily',
                  onClickLegend: this.selectUser
                })
              ),
              _react2.default.createElement(
                _tabs.Tab,
                { label: t('label:月次'), className: _kpi2.default.monthItem },
                _react2.default.createElement(KPIChart, {
                  t: t,
                  kpi: kpi,
                  kpis: kpis,
                  comparison_kpis: comparison_kpis,
                  ui: ui,
                  selectedKPIs: selectedKPIs,
                  periodType: 'monthly',
                  onClickLegend: this.selectUser
                })
              ),
              _react2.default.createElement(
                _tabs.Tab,
                { label: t('label:年次'), className: _kpi2.default.yearItem, disabled: ui.isComparison },
                _react2.default.createElement(KPIChart, {
                  t: t,
                  kpi: kpi,
                  kpis: kpis,
                  comparison_kpis: comparison_kpis,
                  ui: ui,
                  selectedKPIs: selectedKPIs,
                  periodType: 'yearly',
                  onClickLegend: this.selectUser
                })
              )
            )
          ),
          !isFetchFailed && !isFetching && kpis && !ui.isComparison && _react2.default.createElement(
            'div',
            { id: 'kpi_period', className: _kpi2.default.aggregationDatesWrap },
            _react2.default.createElement(_dropdown2.default, { auto: true,
              className: _kpi2.default.aggregationTypeList,
              source: aggregationTypeList,
              value: ui.aggregationType,
              onChange: function onChange(value) {
                return updateUI({ aggregationType: value });
              }
            }),
            ui.tableSelectedDate && !ui.selected_user_id && (ui.aggregationType == 'daily_total_01' || ui.aggregationType == 'daily_total_02') && _react2.default.createElement(
              'div',
              { className: _kpi2.default.dateButton },
              _react2.default.createElement(
                'div',
                { style: { paddingTop: 7, marginRight: 5 } },
                t('label:集計日'),
                ':'
              ),
              _react2.default.createElement(_datePicker2.default, {
                value: ui.tableSelectedDate.toDate(),
                minDate: ui.kpiStartDate.toDate(),
                maxDate: ui.kpiEndDate.toDate(),
                onChange: function onChange(date) {
                  return updateUI({ tableSelectedDate: (0, _moment2.default)(date) });
                }
              })
            ),
            ui.tableStartDate && ui.tableEndDate && (!ui.selected_user_id && ui.aggregationType == 'cumulative' || ui.selected_user_id) && _react2.default.createElement(
              'div',
              { className: _kpi2.default.dateButton },
              _react2.default.createElement(
                'div',
                { style: { paddingTop: 7, marginRight: 5 } },
                t('label:集計期間'),
                ':'
              ),
              _react2.default.createElement(_datePicker2.default, {
                value: ui.tableStartDate.toDate(),
                minDate: ui.kpiStartDate.toDate(),
                maxDate: ui.kpiEndDate.toDate(),
                onChange: function onChange(date) {
                  return updateUI({ tableStartDate: (0, _moment2.default)(date) });
                }
              }),
              _react2.default.createElement(
                'div',
                { style: { paddingTop: 10, marginLeft: 5, marginRight: 5 } },
                '~'
              ),
              _react2.default.createElement(_datePicker2.default, {
                value: ui.tableEndDate.toDate(),
                minDate: ui.tableStartDate.toDate(),
                maxDate: ui.kpiEndDate.toDate(),
                onChange: function onChange(date) {
                  return updateUI({ tableEndDate: (0, _moment2.default)(date) });
                }
              })
            )
          ),
          !isFetchFailed && !isFetching && kpis && !ui.selected_user_id && !ui.isComparison && _react2.default.createElement(
            'div',
            { id: 'tableContainer', style: { padding: 15, overflow: 'auto' } },
            _react2.default.createElement(_kpiChartRankingTable2.default, {
              selectUser: function selectUser(user_id, user_name) {
                return group && updateUI({ selected_user_id: user_id, selected_user_name: user_name });
              },
              selectedKPIs: selectedKPIs,
              kpis: kpis,
              kpiUI: ui
            })
          ),
          !isFetchFailed && !isFetching && kpis && ui.selected_user_id && group && !ui.isComparison && _react2.default.createElement(_kpiChartDetailTable2.default, { kpi: kpi,
            width: ui.clientWidth,
            selected_user_id: ui.selected_user_id,
            selected_user_name: ui.selected_user_name,
            selectedKPIs: selectedKPIs,
            fetchChartKpis: fetchChartKpis,
            fetchComparisonKpis: fetchComparisonKpis,
            parentProps: this.props,
            kpis: kpis,
            kpiUI: ui,
            user: user,
            group: group,
            onClose: function onClose() {
              return updateUI({ selected_user_id: undefined });
            } })
        ),
        isFetchFailed && _react2.default.createElement(
          'div',
          { style: { marginTop: '10px', textAlign: 'center' } },
          t('label:KPIの取得に失敗しました')
        )
      );
    }
  }]);

  return KPIChatPage;
}(_pureComponent2.default);

var RawKPIChatPage = exports.RawKPIChatPage = KPIChatPage;
exports.default = (0, _kpiChartPage2.default)(KPIChatPage);

/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
// src/connects/kpi-chart-page.js

exports.filterMonthlyProgress = filterMonthlyProgress;
exports.calcHighchartData = calcHighchartData;
exports.calcComparisonHighchartData = calcComparisonHighchartData;
exports.calcColumnLineHighchartData = calcColumnLineHighchartData;
exports.calcPieHighchartData = calcPieHighchartData;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _reduce = __webpack_require__(160);

var _reduce2 = _interopRequireDefault(_reduce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterMonthlyProgress(progress) {
  return (0, _map2.default)(progress, function (item) {
    return Object.assign({}, item, {
      actual_records: (0, _filter2.default)(item.actual_records, function (record) {
        return (0, _moment2.default)(record.reported_at).endOf('month').isSame(record.reported_at, 'date');
      })
    });
  });
}

function calcHighchartData(kpi, progress, t) {
  var totals = [];
  var targets = [];
  var series = (0, _map2.default)(progress, function (item) {
    return {
      user_id: item.user_id,
      name: item.name,
      type: 'column',
      data: (0, _map2.default)(item.actual_records, function (record, i) {
        var actual = typeof record.total == 'undefined' ? record.actual : record.total;
        totals[i] = totals[i] ? totals[i] + actual : actual;
        targets[i] = targets[i] ? targets[i] + record.target : record.target;
        return actual;
      })
    };
  });
  series.push({
    name: t('label:達成率'),
    type: 'line',
    yAxis: 1,
    data: (0, _map2.default)(targets, function (target, i) {
      return targets[i] > 0 && Math.floor(totals[i] * 1000 / targets[i]) / 10 || 0;
    })
  });
  // yAxisで定義されているplotLinesの指定だけだとデータ範囲によっては達成ラインが見えない時があるため、seriesとplotLinesを併用している
  series.push({
    name: t('label:達成ライン'),
    type: 'line',
    yAxis: 1,
    color: '#ff0000',
    data: (0, _map2.default)(targets, function (target) {
      return 100;
    }),
    marker: { enabled: false },
    lineWidth: 1,
    dashStyle: 'ShortDash'
  });
  return {
    chart: {
      type: 'column',
      events: {
        load: function load() {
          var chart = this;
          chart.series.forEach(function (item, i) {
            var legendItem = chart.legend.allItems[i].legendGroup.element;
            legendItem.addEventListener('click', function () {
              var tableRows = document.querySelectorAll('#tableContainer table tr');
              var targetRow = null;
              tableRows.forEach(function (row) {
                if (row.getAttribute('user_id') == item.userOptions.user_id) {
                  targetRow = row;
                }
              });
              if (targetRow) {
                targetRow.style.backgroundColor = item.visible ? 'white' : 'lightgray';
              }
            });
          });
        }
      }
    },
    title: { text: '' },
    credits: { enabled: false },
    exporting: { enabled: false },
    xAxis: {
      categories: (0, _map2.default)(progress[0].actual_records, function (item) {
        return item.reported_at;
      })
    },
    yAxis: [{ title: { text: '' }, labels: { format: '{value}' + kpi.unit }
    }, { title: { text: '' }, labels: { format: '{value}%' }, opposite: true, min: 0, tickAmount: 1,
      plotLines: [{ // 100%ラベルの表示
        width: 0,
        value: 100,
        label: {
          text: '100%',
          align: 'right',
          x: 45,
          y: 5,
          style: {
            fontWeight: 'bold'
          }
        }
      }] }],
    plotOptions: { column: { stacking: 'normal' } },
    series: series
  };
}

function calcComparisonHighchartData(comparison_kpis, t, ui) {
  if (!Array.isArray(comparison_kpis) || comparison_kpis.length == 0) {
    return {};
  }

  // Helper function to calculate monthly totals for each KPI
  var calcMonthlyTotals = function calcMonthlyTotals(comparisonKpis) {
    return comparisonKpis.map(function (kpi) {
      var monthlyTotals = Array(12).fill(0);

      kpi.assignments.forEach(function (assignment) {
        assignment.progress.monthly_totals.forEach(function (monthlyData, index) {
          monthlyTotals[index] += monthlyData.actual_total || 0; // Safeguard for missing data
        });
      });

      var kpiYear = kpi.assignments && kpi.assignments[0] && kpi.assignments[0].progress && kpi.assignments[0].progress.monthly_totals && kpi.assignments[0].progress.monthly_totals[0] ? kpi.assignments[0].progress.monthly_totals[0].month : '';
      var formattedYear = kpiYear ? ' [' + (0, _moment2.default)(kpiYear).format('YYYY') + ']' : '';

      return {
        kpi_id: kpi.kpi_id,
        name: '' + kpi.name + formattedYear,
        type: 'column',
        data: monthlyTotals
      };
    });
  };

  // Generate series data
  var series = calcMonthlyTotals(comparison_kpis);

  return {
    chart: {
      type: 'column',
      events: {
        load: function load() {
          // Optional: Add custom chart load logic here
        }
      }
    },
    title: { text: '' },
    credits: { enabled: false },
    exporting: { enabled: false },
    xAxis: {
      categories: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
    },
    yAxis: [{
      title: { text: '' },
      labels: {
        format: '{value}' + (comparison_kpis[0] && comparison_kpis[0].unit ? comparison_kpis[0].unit : '') // Safeguard for missing unit
      }
    }],
    plotOptions: {
      column: {
        stacking: ui.isStacked ? 'normal' : null,
        grouping: !ui.isStacked
      }
    },
    series: series
  };
}

function calcColumnLineHighchartData(selectedKPIs, kpis, t) {
  var period = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'daily';
  var ui = arguments[4];

  if (!kpis || !Array.isArray(kpis) || kpis.length == 0) {
    return {};
  }

  var kpiActuals = {}; // Store KPI actuals by KPI ID
  var kpiTotalValues = {}; // Store KPI values for all KPIs
  var kpiTargets = {}; // Store KPI targets by KPI ID
  var kpiCumulativeActuals = {}; // Store KPI cumulative actuals by KPI ID
  var format = period == 'daily' ? 'YYYY-MM-DD' : period == 'monthly' ? 'YYYY-MM' : 'YYYY';

  // Helper function to aggregate data
  function aggregateData(records) {
    var groupedData = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = records[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var record = _step.value;

        var dateKey = (0, _moment2.default)(record.reported_at).format(format);
        if (!groupedData[dateKey]) {
          groupedData[dateKey] = { totalActual: 0, totalTarget: 0 };
        }
        groupedData[dateKey].totalActual += record.actual || 0;
        groupedData[dateKey].totalTarget += record.target || 0;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return Object.entries(groupedData).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          values = _ref2[1];

      return {
        key: key,
        totalActual: values.totalActual,
        totalTarget: values.totalTarget
      };
    });
  }

  var xAxisCategories = void 0; // Generate x-axis categories

  var record_length = kpis[0].assignments[0] ? kpis[0].assignments[0].progress.actual_records.length : 0;
  var kpiTotalTargetsArray = Array(record_length).fill(0); // total targets for all KPIs

  // Generate series data
  var series = selectedKPIs.flatMap(function (selected_kpi) {
    var kpi = kpis.find(function (k) {
      return k.kpi_id == selected_kpi.kpi_id;
    });
    if (!kpi) return null;

    if (kpi.accumulated_total) {
      kpiTotalTargetsArray = kpiTotalTargetsArray.map(function (item) {
        return item + kpi.target;
      });
    }

    if (!kpiActuals[kpi.kpi_id]) {
      kpiActuals[kpi.kpi_id] = [];
    }

    if (!kpiTotalValues[kpi.kpi_id]) {
      kpiTotalValues[kpi.kpi_id] = [];
    }

    if (!kpiTargets[kpi.kpi_id]) {
      kpiTargets[kpi.kpi_id] = [];
    }

    if (!kpiCumulativeActuals[kpi.kpi_id]) {
      kpiCumulativeActuals[kpi.kpi_id] = [];
    }

    if (ui.isIndividual) {
      // Create individual user series
      return kpi.assignments.map(function (assignment) {
        var aggregatedData = aggregateData(assignment.progress.actual_records);

        xAxisCategories = aggregatedData.map(function (item) {
          return item.key;
        });

        return {
          kpi_id: kpi.kpi_id,
          name: assignment.name + ' (' + kpi.name + ')',
          type: ui.chartType,
          data: aggregatedData.map(function (data, i) {
            var actual = data.totalActual;
            var target = data.totalTarget;

            kpiActuals[kpi.kpi_id][i] = actual;
            kpiTargets[kpi.kpi_id][i] = target;

            return actual;
          })
        };
      });
    } else {
      // Aggregate data for all users under this KPI
      var aggregatedAssignmentData = kpi.assignments.map(function (assignment) {
        return aggregateData(assignment.progress.actual_records);
      });

      var aggregatedData = aggregatedAssignmentData.reduce(function (resultData, assignmentData) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = assignmentData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var data = _step2.value;

            if (!resultData[data.key]) {
              resultData[data.key] = { totalActual: 0, totalTarget: 0 };
            }
            resultData[data.key].totalActual += data.totalActual;
            resultData[data.key].totalTarget += data.totalTarget;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return resultData;
      }, {});

      xAxisCategories = Object.keys(aggregatedData);

      return {
        kpi_id: kpi.kpi_id,
        name: kpi.name,
        type: ui.chartType,
        data: Object.values(aggregatedData).map(function (data, i) {

          var actual = data.totalActual;
          var target = data.totalTarget;

          kpiActuals[kpi.kpi_id][i] = actual;

          var daily_target = record_length > 0 ? target / record_length : 0;
          kpiTargets[kpi.kpi_id][i] = kpi.accumulated_total ? daily_target * (i + 1) : target;

          kpiCumulativeActuals[kpi.kpi_id][i] = (kpiCumulativeActuals[kpi.kpi_id][i - 1] || 0) + actual;
          kpiTotalValues[kpi.kpi_id][i] = kpi.accumulated_total ? kpiCumulativeActuals[kpi.kpi_id][i] : actual;
          if (!kpi.accumulated_total) kpiTotalTargetsArray[i] = kpiTotalTargetsArray[i] + (i + 1) * kpi.target;
          return ui.isCumulative ? kpiCumulativeActuals[kpi.kpi_id][i] : actual;
        })
      };
    }
  }).filter(Boolean);

  if (ui.isConversion && !ui.isIndividual) {
    var _loop = function _loop(i) {
      var kpiAData = kpiActuals[selectedKPIs[i].kpi_id];
      var kpiBData = kpiActuals[selectedKPIs[i + 1].kpi_id];

      if (kpiAData && kpiBData) {
        var conversionRates = kpiBData.map(function (value, index) {
          return kpiAData[index] > 0 ? Math.floor(value * 1000 / kpiAData[index]) / 10 : 0;
        });

        series.push({
          name: t('label:歩留まり') + ': ' + selectedKPIs[i + 1].label + ' / ' + selectedKPIs[i].label,
          type: 'line',
          yAxis: 1,
          dashStyle: 'ShortDash',
          data: conversionRates,
          tooltip: { valueSuffix: '%' }
        });
      }
    };

    // Add conversion rate series
    for (var i = 0; i < selectedKPIs.length - 1; i++) {
      _loop(i);
    }
  }

  if (ui.isCumulative) {
    // calculate cumulative totals for all KPIs
    var kpiCumulativeTotals = Object.values(kpiCumulativeActuals).reduce(function (acc, arr) {
      arr.forEach(function (value, index) {
        acc[index] = (acc[index] || 0) + value;
      });
      return acc;
    }, []);

    // add cumulative yellow line
    series.push({
      name: t('label:達成率'),
      type: "line",
      yAxis: 1,
      color: '#ff9205',
      data: (0, _map2.default)(kpiCumulativeTotals, function (total, i) {
        return kpiTotalTargetsArray[i] > 0 && Math.floor(kpiCumulativeTotals[i] * 1000 / kpiTotalTargetsArray[i]) / 10 || 0;
      })
    });

    // add 100% cumulative red line
    series.push({
      name: t('label:達成ライン'),
      type: 'line',
      yAxis: 1,
      color: '#ff0000',
      data: (0, _map2.default)(kpiCumulativeTotals, function (total) {
        return 100;
      }),
      marker: { enabled: false },
      lineWidth: 1,
      dashStyle: 'ShortDash'
    });
  }

  if (!ui.isCumulative && !ui.isIndividual && !ui.isComparison) {
    // calculate total actuals for all KPIs
    var kpiTotals = Object.values(kpiActuals).reduce(function (acc, arr) {
      arr.forEach(function (value, index) {
        acc[index] = (acc[index] || 0) + value;
      });
      return acc;
    }, []);

    // calculate total actuals for all KPIs
    var kpiAllValues = Object.values(kpiTotalValues).reduce(function (acc, arr) {
      arr.forEach(function (value, index) {
        acc[index] = (acc[index] || 0) + value;
      });
      return acc;
    }, []);

    // calculate total daily targets for all KPIs
    var kpiTotalTargets = Object.values(kpiTargets).reduce(function (acc, arr) {
      arr.forEach(function (value, index) {
        acc[index] = (acc[index] || 0) + value;
      });
      return acc;
    }, []);

    // add achievement rate yellow line
    series.push({
      name: t('label:達成率'),
      type: "line",
      yAxis: 1,
      color: '#ff9205',
      data: (0, _map2.default)(kpiTotals, function (total, i) {
        return kpiTotalTargets[i] > 0 && Math.floor(kpiAllValues[i] * 1000 / kpiTotalTargets[i]) / 10 || 0;
      })
    });

    // add 100% cumulative red line
    series.push({
      name: t('label:達成ライン'),
      type: 'line',
      yAxis: 1,
      color: '#ff0000',
      data: (0, _map2.default)(kpiTotals, function (total) {
        return 100;
      }),
      marker: { enabled: false },
      lineWidth: 1,
      dashStyle: 'ShortDash'
    });
  }

  // Final chart configuration
  return {
    chart: {
      type: ui.chartType,
      height: 500,
      events: {
        load: function load() {
          var chart = this;
        }
      }
    },
    title: { text: '' },
    credits: { enabled: false },
    exporting: { enabled: false },
    xAxis: { categories: xAxisCategories },
    yAxis: [{ title: { text: '' }, labels: { format: '{value}' + kpis[0].unit } }, { title: { text: '' }, labels: { format: '{value}%' }, opposite: true, min: 0, tickAmount: 1,
      plotLines: [{
        width: 0,
        value: 100,
        label: {
          text: '100%',
          align: 'right',
          x: 45,
          y: 5,
          style: { fontWeight: 'bold' }
        }
      }]
    }],
    legend: {
      enabled: true,
      align: 'center',
      layout: 'horizontal',
      verticalAlign: 'bottom',
      itemStyle: {
        fontWeight: 'bold',
        color: '#333'
      },
      maxHeight: 100
    },
    plotOptions: {
      column: {
        stacking: ui.isStacked ? 'normal' : null,
        grouping: !ui.isStacked
      }
    },
    series: series
  };
}

function calcPieHighchartData(selectedKPIs, kpis, t, ui) {
  if (!kpis || !Array.isArray(kpis) || kpis.length == 0 || !Array.isArray(selectedKPIs)) {
    return {};
  }

  // Helper function to aggregate data for pie slices
  function aggregateData(records) {
    return records.reduce(function (total, record) {
      return total + (record.actual || 0);
    }, 0);
  }

  // Generate data for the pie chart
  var pieData = selectedKPIs.flatMap(function (selected_kpi) {
    var kpi = kpis.find(function (k) {
      return k.kpi_id === selected_kpi.kpi_id;
    });
    if (!kpi) return null;

    if (ui.isIndividual) {
      // Individual user slices
      return kpi.assignments.map(function (assignment) {
        var totalActual = aggregateData(assignment.progress.actual_records);
        return {
          name: assignment.name + ' (' + kpi.name + ')',
          y: totalActual
        };
      });
    } else {
      // Aggregated KPI slice
      var totalActual = kpi.assignments.reduce(function (sum, assignment) {
        return sum + aggregateData(assignment.progress.actual_records);
      }, 0);
      return {
        name: kpi.name,
        y: totalActual
      };
    }
  }).filter(Boolean);

  // Final chart configuration for a pie chart
  return {
    chart: {
      type: 'pie',
      height: 500
    },
    title: { text: '' },
    credits: { enabled: false },
    exporting: { enabled: false },
    tooltip: {
      pointFormat: '<b>{point.percentage:.1f}%</b> ({point.y})'
    },
    legend: {
      enabled: true,
      align: 'center',
      layout: 'horizontal',
      verticalAlign: 'bottom',
      itemStyle: {
        fontWeight: 'bold',
        color: '#333'
      },
      maxHeight: 100
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      }
    },
    series: [{
      name: t('label:合計'), // Localized label
      colorByPoint: true,
      data: pieData
    }]
  };
}

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var kpi = state.kpiChart.current && state.kpiChart.current.kpi_id == ownProps.params.kpi_id && state.kpiChart.current || undefined;

  return {
    isFetching: state.kpiChart.isFetching,
    isUpdating: state.kpiChart.isUpdating,
    isUpdateFailed: state.kpiChart.isUpdateFailed,
    kpis: state.kpi.chart_items,
    group_kpis: state.kpi.group_items,
    comparison_kpis: state.kpi.comparison_items,
    kpi: kpi,
    group: state.groups.items && (0, _find2.default)(state.groups.items, function (item) {
      return item.group_id == ownProps.params.group_id;
    }) || undefined,
    user: state.user.current
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, stateProps, dispatchProps, ownProps, {
    group: stateProps.group || ownProps.group
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willMount: function willMount(props) {
      return dispatch(_actions2.default.fetchKpiChart(props.params.kpi_id, props.params.group_id));
    },
    willUnmount: function willUnmount() {
      dispatch(_actions2.default.clearKpiChart());
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (!props.kpi && nextProps.kpi || props.kpi && nextProps.kpi && props.kpi.kpi_id != nextProps.kpi.kpi_id) {
        dispatch(_actions2.default.fetchChartKpis(nextProps.params.group_id, (0, _moment2.default)(nextProps.kpi.start_date).format('YYYY-MM-DD'), (0, _moment2.default)(nextProps.kpi.end_date).format('YYYY-MM-DD'), [{ kpi_id: nextProps.kpi.kpi_id }]));
        // Get group kpis list
        dispatch(_actions2.default.fetchGroupKpis(nextProps.params.group_id));
        // Initialize comparison kpi list
        dispatch(_actions2.default.fetchComparisonKpis([{ kpi_id: nextProps.kpi.kpi_id, year: (0, _moment2.default)(nextProps.kpi.end_date).format('YYYY') }], nextProps.params.group_id));
      }

      if (props.ui.kpiStartDate && props.ui.kpiStartDate != nextProps.ui.kpiStartDate || props.ui.kpiEndDate && props.ui.kpiEndDate != nextProps.ui.kpiEndDate) {
        dispatch(_actions2.default.fetchChartKpis(nextProps.params.group_id, (0, _moment2.default)(nextProps.ui.kpiStartDate).format('YYYY-MM-DD'), (0, _moment2.default)(nextProps.ui.kpiEndDate).format('YYYY-MM-DD'), nextProps.ui.selectedKPIs));
      }

      if (props.params.kpi_id != nextProps.params.kpi_id) dispatch(_actions2.default.fetchKpiChart(nextProps.params.kpi_id, nextProps.params.group_id));
    },

    openKPIChartPage: function openKPIChartPage(props, kpi_id) {
      return dispatch(_actions2.default.openRightSidePage('kpi_chart', { kpi_id: kpi_id, group_id: props.params.group_id }));
    },
    openGroupKPIPanel: function openGroupKPIPanel() {
      return dispatch(_actions2.default.openGroupSettingsPage('kpi'));
    },

    fetchChartKpis: function fetchChartKpis(selected_kpis, props) {
      dispatch(_actions2.default.fetchChartKpis(props.params.group_id, (0, _moment2.default)(props.ui.kpiStartDate).format('YYYY-MM-DD'), (0, _moment2.default)(props.ui.kpiEndDate).format('YYYY-MM-DD'), selected_kpis));
    },

    fetchComparisonKpis: function fetchComparisonKpis(selected_kpis, props) {
      if (selected_kpis.length == 0) {
        selected_kpis = [{ kpi_id: props.kpi.kpi_id, year: (0, _moment2.default)(props.kpi.end_date).format('YYYY') }];
      }

      dispatch(_actions2.default.fetchComparisonKpis(selected_kpis, props.params.group_id));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: {
    index: 0,
    clientWidth: 1000,
    selected_user_id: undefined,
    selected_user_name: undefined,
    showKPIDataSetting: true,
    selectedKPIs: [],
    kpiStartDate: null,
    kpiEndDate: null,
    chartType: 'column',
    isStacked: false,
    isIndividual: false,
    isConversion: false,
    isComparison: false,
    isCumulative: false,
    aggregationType: 'cumulative',
    tableSelectedDate: null,
    tableStartDate: null,
    tableEndDate: null
  } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('kpi_chart'));

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _kpiChartRankingTable = __webpack_require__(2607);

var _kpiChartRankingTable2 = _interopRequireDefault(_kpiChartRankingTable);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _table = __webpack_require__(504);

var _datePicker = __webpack_require__(165);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _formatNumber = __webpack_require__(201);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _kpiChartTable = __webpack_require__(1074);

var _kpiChartTable2 = _interopRequireDefault(_kpiChartTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * src/web/components/kpi-chart-ranking-table.jsx
 * KPIに登録されているメンバーの一覧テーブル（kpi-chart-page のグラフの下に表示されている）
 */

var displayFormat = { separate_1000: true };

var KPIChartRankingTable = function (_React$Component) {
  _inherits(KPIChartRankingTable, _React$Component);

  function KPIChartRankingTable() {
    _classCallCheck(this, KPIChartRankingTable);

    return _possibleConstructorReturn(this, (KPIChartRankingTable.__proto__ || Object.getPrototypeOf(KPIChartRankingTable)).apply(this, arguments));
  }

  _createClass(KPIChartRankingTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          selectUser = _props.selectUser,
          updateUI = _props.updateUI,
          selectedKPIs = _props.selectedKPIs,
          kpis = _props.kpis,
          kpiUI = _props.kpiUI;


      var userData = (0, _kpiChartRankingTable.calcUserTableData)(selectedKPIs, kpis, t, kpiUI.aggregationType, (0, _moment2.default)(kpiUI.tableSelectedDate).format('YYYY-MM-DD'), (0, _moment2.default)(kpiUI.tableStartDate).format('YYYY-MM-DD'), (0, _moment2.default)(kpiUI.tableEndDate).format('YYYY-MM-DD'));

      // Set kpi unit for kpi detail table
      var kpi_unit = Object.keys(userData).length > 0 ? userData[Object.keys(userData)[0]].unit : '';

      // Generate kpiData from userData
      var userKPIData = selectedKPIs.reduce(function (acc, selected_kpi) {
        var kpiId = selected_kpi.kpi_id;

        var kpiTotals = Object.values(userData).reduce(function (kpiAcc, userItem) {
          var kpiData = userItem.kpiData[kpiId];

          if (kpiData) {
            return {
              actualTotal: kpiAcc.actualTotal + kpiData.totalActual,
              achievementRateTotal: kpiAcc.achievementRateTotal + kpiData.achievementRate,
              kpiLength: kpiAcc.kpiLength + 1
            };
          }
          return kpiAcc;
        }, {
          actualTotal: 0,
          achievementRateTotal: 0,
          kpiLength: 0
        });

        acc[kpiId] = kpiTotals;
        return acc;
      }, {});

      // Generate globalKPIData from userKPIData
      var globalTotal = 0;
      var globalAchievementRateTotal = 0;

      _lodash2.default.map(userKPIData, function (item, i) {
        globalTotal += item.actualTotal;
        globalAchievementRateTotal += item.kpiLength > 0 ? item.achievementRateTotal / item.kpiLength : 0;
      });
      var isMultiKPI = selectedKPIs.length > 1 ? true : false;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _table.Table,
          { selectable: false, theme: _kpiChartTable2.default },
          _react2.default.createElement(
            _table.TableHead,
            null,
            _react2.default.createElement(
              _table.TableCell,
              { numeric: true, style: { textAlign: 'left' } },
              t('label:メンバー')
            ),
            _lodash2.default.map(selectedKPIs, function (selected_kpi, i) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: i },
                _react2.default.createElement(
                  _table.TableCell,
                  { tagName: 'th', numeric: true },
                  selected_kpi.label,
                  ' ',
                  t('label:実績'),
                  ' (',
                  kpi_unit,
                  ')'
                ),
                _react2.default.createElement(
                  _table.TableCell,
                  { tagName: 'th', numeric: true },
                  selected_kpi.label,
                  ' ',
                  t('label:達成率')
                )
              );
            }),
            isMultiKPI && _react2.default.createElement(
              _table.TableCell,
              { numeric: true },
              t('label:合計実績'),
              ' (',
              kpi_unit,
              ')'
            ),
            isMultiKPI && _react2.default.createElement(
              _table.TableCell,
              { numeric: true },
              t('label:合計達成率')
            )
          ),
          _lodash2.default.map(userData, function (item, i) {
            return _react2.default.createElement(
              _table.TableRow,
              {
                key: i,
                user_id: item.user_id,
                style: { cursor: 'pointer' },
                onClick: function onClick() {
                  return selectUser(item.user_id, item.name);
                } },
              _react2.default.createElement(
                _table.TableCell,
                { style: { whiteSpace: 'nowrap' } },
                _react2.default.createElement(_avatar2.default, { image: item.icon_image.thumb_url }),
                '\xA0',
                item.name
              ),
              _lodash2.default.map(selectedKPIs, function (selected_kpi, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  _react2.default.createElement(
                    _table.TableCell,
                    { numeric: true },
                    item.kpiData[selected_kpi.kpi_id] ? (0, _formatNumber.formatNumber)(item.kpiData[selected_kpi.kpi_id].totalActual, displayFormat) : '-'
                  ),
                  _react2.default.createElement(
                    _table.TableCell,
                    { numeric: true },
                    item.kpiData[selected_kpi.kpi_id] ? (0, _formatNumber.percent)(item.kpiData[selected_kpi.kpi_id].achievementRate) + ' %' : '-'
                  )
                );
              }),
              isMultiKPI && _react2.default.createElement(
                _table.TableCell,
                { numeric: true },
                (0, _formatNumber.formatNumber)(item.userTotalActual, displayFormat)
              ),
              isMultiKPI && _react2.default.createElement(
                _table.TableCell,
                { numeric: true },
                (0, _formatNumber.percent)(item.kpiLength > 0 ? item.userAchievementRate / item.kpiLength : 0),
                ' %'
              )
            );
          }),
          _react2.default.createElement(
            _table.TableRow,
            { className: 'total' },
            _react2.default.createElement(
              _table.TableCell,
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:合計')
              )
            ),
            _lodash2.default.map(selectedKPIs, function (selected_kpi, index) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: index },
                _react2.default.createElement(
                  _table.TableCell,
                  { numeric: true },
                  _react2.default.createElement(
                    'strong',
                    null,
                    userKPIData[selected_kpi.kpi_id] && (0, _formatNumber.formatNumber)(userKPIData[selected_kpi.kpi_id].actualTotal, displayFormat) + ' ' + kpi_unit
                  )
                ),
                _react2.default.createElement(
                  _table.TableCell,
                  { numeric: true },
                  _react2.default.createElement(
                    'strong',
                    null,
                    userKPIData[selected_kpi.kpi_id] && (0, _formatNumber.percent)(userKPIData[selected_kpi.kpi_id].kpiLength > 0 ? userKPIData[selected_kpi.kpi_id].achievementRateTotal / userKPIData[selected_kpi.kpi_id].kpiLength : 0) + ' %'
                  )
                )
              );
            }),
            isMultiKPI && _react2.default.createElement(
              _table.TableCell,
              { numeric: true },
              _react2.default.createElement(
                'strong',
                null,
                (0, _formatNumber.formatNumber)(globalTotal, displayFormat),
                ' ',
                kpi_unit
              )
            ),
            isMultiKPI && _react2.default.createElement(
              _table.TableCell,
              { numeric: true },
              _react2.default.createElement(
                'strong',
                null,
                (0, _formatNumber.percent)(Object.keys(userKPIData).length > 0 ? globalAchievementRateTotal / Object.keys(userKPIData).length : 0),
                ' %'
              )
            )
          )
        )
      );
    }
  }]);

  return KPIChartRankingTable;
}(_react2.default.Component);

exports.default = (0, _kpiChartRankingTable2.default)(KPIChartRankingTable);

/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/kpi-chart-ranking-table.js

exports.calcUserTableData = calcUserTableData;
exports.calcRankingData = calcRankingData;
exports.calcRankingTotal = calcRankingTotal;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _sortBy2 = __webpack_require__(2608);

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _reduce = __webpack_require__(160);

var _reduce2 = _interopRequireDefault(_reduce);

var _lodash = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ensure lodash is imported for data manipulation

function calcUserTableData(selectedKPIs, kpis, t, aggregationType, tableSelectedDate, tableStartDate, tableEndDate) {
  if (!kpis || !Array.isArray(kpis) || kpis.length == 0) {
    return {};
  }

  // Data structure to hold total data per user for each KPI
  var userData = {};

  // Loop over each selected KPI
  (0, _map2.default)(selectedKPIs, function (selected_kpi) {
    var kpiId = selected_kpi.kpi_id;
    var kpi = kpis.find(function (kpi) {
      return kpi.kpi_id == kpiId;
    });
    if (!kpi) return null;

    // For each user in this KPI, aggregate their data
    kpi.assignments.forEach(function (assignment) {
      var userId = assignment.user_id;
      // Filter the actual_records by date ranges from original actual_records and re-calculate the "total" field based on filtered_records
      var dateRange = aggregationType == 'cumulative' ? [new Date(tableStartDate), new Date(tableEndDate)] : [new Date(tableSelectedDate), new Date(tableSelectedDate)];
      var filtered_records = assignment.progress.actual_records.filter(function (item) {
        var reportedDate = new Date(item.reported_at);
        return reportedDate >= dateRange[0] && reportedDate <= dateRange[1];
      });
      var cumulativeTotal = 0;
      var updated_records = filtered_records.map(function (record) {
        cumulativeTotal += record.actual;
        return _extends({}, record, { total: cumulativeTotal });
      });

      var last_record = updated_records[updated_records.length - 1];

      // If this user doesn't exist in userData yet, initialize
      if (!userData[userId]) {
        userData[userId] = {
          name: assignment.name,
          icon_image: assignment.icon_image,
          userTotalActual: 0,
          userAchievementRate: 0,
          kpiLength: 0,
          kpiData: {},
          user_id: userId,
          unit: kpi.unit
        };
      }

      // Initialize KPI-specific data for the user if not already present
      var total_target = kpi.accumulated_total ? last_record.target : last_record.target * updated_records.length;
      if (!userData[userId].kpiData[kpiId]) {
        userData[userId].kpiData[kpiId] = {
          totalActual: last_record.total,
          totalTarget: last_record.target,
          achievementRate: total_target > 0 && last_record.total / total_target || 0
        };
      }

      // Sum totalAcutal and achievementRate for a user
      userData[userId].userTotalActual += userData[userId].kpiData[kpiId].totalActual;
      userData[userId].userAchievementRate += userData[userId].kpiData[kpiId].achievementRate;
      userData[userId].kpiLength += 1;
    });
  });

  return userData;
}

function calcRankingData(progress, reported_at, sortBy) {
  var reportdAt = (0, _moment2.default)(reported_at).format('YYYY-MM-DD').toString();
  var items = (0, _map2.default)(progress, function (item) {
    var record = (0, _find2.default)(item.actual_records, function (record) {
      return reportdAt == record.reported_at;
    });
    var total = typeof record.total == 'undefined' ? record.actual : record.total;
    return {
      user_id: item.user_id,
      name: item.name,
      icon_image: item.icon_image,
      target: record.target,
      total: total,
      percent: record.target > 0 ? Math.floor(total * 1000 / record.target) / 1000 : undefined
    };
  });

  return (0, _sortBy3.default)(items, function (item) {
    return item[sortBy] * -1;
  });
}

function calcRankingTotal(progress, reported_at) {
  var result = (0, _reduce2.default)(progress, function (r, item) {
    var record = (0, _find2.default)(item.actual_records, function (record) {
      return reported_at.isSame(record.reported_at, 'date');
    });
    var total = typeof record.total == 'undefined' ? record.actual : record.total;
    var target = record.target;

    return {
      target: r.target + target,
      total: r.total + total
    };
  }, { target: 0, total: 0 });

  return {
    target: result.target,
    total: result.total,
    percent: result.target > 0 && Math.floor(result.total * 1000 / result.target) / 1000 || undefined
  };
}

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

exports.default = (0, _combineHoc2.default)((0, _uiState2.default)({ state: {
    sortBy: 'total',
    reported_at: function reported_at(props) {
      return _moment2.default.max(_moment2.default.min((0, _moment2.default)(), (0, _moment2.default)(props.kpiUI.kpiEndDate)), (0, _moment2.default)(props.kpiUI.kpiStartDate));
    }
  } }), (0, _reactI18next.translate)());

/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(340),
    baseOrderBy = __webpack_require__(2609),
    baseRest = __webpack_require__(425),
    isIterateeCall = __webpack_require__(426);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(318),
    baseIteratee = __webpack_require__(139),
    baseMap = __webpack_require__(903),
    baseSortBy = __webpack_require__(2610),
    baseUnary = __webpack_require__(251),
    compareMultiple = __webpack_require__(2611),
    identity = __webpack_require__(250);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 2610 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(2612);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(219);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.kpi-chart-table--table--3iVpSMfA th, .kpi-chart-table--table--3iVpSMfA td {\n  height: 32px; \n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n\n.kpi-chart-table--table--3iVpSMfA tr {\n  height: auto;\n}\n\n.kpi-chart-table--table--3iVpSMfA tr[class~=total] {\n  height: 20px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/kpi-chart-table.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;CACrB;;AAED;EACE,aAAa;CACd;;AAED;EACE,aAAa;CACd","file":"kpi-chart-table.css","sourcesContent":["\n.table th, .table td {\n  height: 32px; \n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n\n.table tr {\n  height: auto;\n}\n\n.table tr[class~=total] {\n  height: 20px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"table": "kpi-chart-table--table--3iVpSMfA"
};

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _kpiChartDetailTable = __webpack_require__(2615);

var _kpiChartDetailTable2 = _interopRequireDefault(_kpiChartDetailTable);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _button = __webpack_require__(8);

var _table = __webpack_require__(504);

var _compactInput = __webpack_require__(178);

var _compactInput2 = _interopRequireDefault(_compactInput);

var _formatNumber = __webpack_require__(201);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _kpiChartTable = __webpack_require__(1074);

var _kpiChartTable2 = _interopRequireDefault(_kpiChartTable);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _userAgent = __webpack_require__(491);

var _userAgent2 = _interopRequireDefault(_userAgent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * src/web/components/kpi-chart-detail-table.jsx
 * kpi-chart-ranking-table のメンバーの一覧から選択されたユーザのKPI実績
 */

function ActualCell(props) {
  var i = props.i,
      j = props.j,
      t = props.t,
      ui = props.ui,
      value = props.value,
      display = props.display,
      format = props.format,
      updatable = props.updatable,
      reported_at = props.reported_at,
      updateUI = props.updateUI,
      updateActualRecord = props.updateActualRecord,
      kpi_name = props.kpi_name,
      kpi_id = props.kpi_id,
      group = props.group,
      displayGroupMemberErrorMessage = props.displayGroupMemberErrorMessage;


  var step = 1;
  if (format && format.decimal_1) step = 0.1;else if (format && format.decimal_2) step = 0.01;else if (format && format.decimal_3) step = 0.001;

  if (updatable && ui.editRows[i] && ui.editRows[i][j]) return _react2.default.createElement(
    _table.TableCell,
    null,
    _react2.default.createElement(
      'form',
      { onSubmit: function onSubmit(ev) {
          ev.preventDefault();
          updateActualRecord(kpi_id, kpi_name, reported_at, ui.editRows[i][j].value);
        } },
      _react2.default.createElement(_compactInput2.default, { value: ui.editRows[i][j].value, hasFocus: true,
        type: 'number',
        step: step,
        style: { padding: 0, fontSize: 13, textAlign: 'right' },
        onBlur: function onBlur(ev) {
          // Firefoxではinput type=numberだとonBlurイベントがおかしくなる
          // https://tirdadc.github.io/blog/2015/06/11/react-dot-js-firefox-issue-with-onblur/
          if (ev.nativeEvent.explicitOriginalTarget && ev.nativeEvent.explicitOriginalTarget == ev.nativeEvent.originalTarget) return;
          updateActualRecord(kpi_id, kpi_name, reported_at, ui.editRows[i][j].value);
        },
        onChange: function onChange(value) {
          return updateUI({ editRows: Object.assign({}, ui.editRows, _defineProperty({}, i, Object.assign({}, ui.editRows[i], _defineProperty({}, j, { value: value })))) });
        } })
    )
  );else {
    var TooltipTableCell = updatable ? (0, _tooltip2.default)(_table.TableCell) : _table.TableCell;
    return _react2.default.createElement(
      TooltipTableCell,
      { numeric: true,
        style: { cursor: 'pointer' },
        tooltip: t('label:クリックして値を更新'),
        onClick: function onClick() {
          if (updatable && !group.is_member) {
            displayGroupMemberErrorMessage(group.name);
            return;
          }
          updatable && updateUI({ editRows: Object.assign({}, ui.editRows, _defineProperty({}, i, Object.assign({}, ui.editRows[i], _defineProperty({}, j, { value: value })))) });
        } },
      display
    );
  }
}

var KPIChartDetailTable = function (_React$Component) {
  _inherits(KPIChartDetailTable, _React$Component);

  function KPIChartDetailTable() {
    _classCallCheck(this, KPIChartDetailTable);

    return _possibleConstructorReturn(this, (KPIChartDetailTable.__proto__ || Object.getPrototypeOf(KPIChartDetailTable)).apply(this, arguments));
  }

  _createClass(KPIChartDetailTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          kpi = _props.kpi,
          selected_user_id = _props.selected_user_id,
          selected_user_name = _props.selected_user_name,
          selectedKPIs = _props.selectedKPIs,
          kpis = _props.kpis,
          kpiUI = _props.kpiUI,
          user = _props.user,
          group = _props.group,
          skipRows = _props.skipRows,
          updateUI = _props.updateUI,
          updateActualRecord = _props.updateActualRecord,
          toggleSkipRows = _props.toggleSkipRows,
          onClose = _props.onClose,
          displayGroupMemberErrorMessage = _props.displayGroupMemberErrorMessage;


      var total_actual_records = [];
      _lodash2.default.map(selectedKPIs, function (selected_kpi) {
        var kpi = kpis.find(function (item) {
          return item.kpi_id == selected_kpi.kpi_id;
        });
        if (kpi) {
          var kpi_actual_records = (0, _kpiChartDetailTable.getActualRecords)(kpi.assignments, selected_user_id, kpi.accumulated_total, kpiUI.aggregationType, (0, _moment2.default)(kpiUI.tableSelectedDate).format('YYYY-MM-DD'), (0, _moment2.default)(kpiUI.tableStartDate).format('YYYY-MM-DD'), (0, _moment2.default)(kpiUI.tableEndDate).format('YYYY-MM-DD'));
          var last_record = kpi_actual_records[kpi_actual_records.length - 1];
          total_actual_records.push({
            kpi_id: kpi.kpi_id,
            accumulated_total: kpi.accumulated_total,
            name: kpi.name,
            display_format: kpi.display_format,
            prepend_unit: kpi.prepend_unit,
            unit: kpi.unit,
            actual_records: kpi_actual_records,
            last_record: last_record
          });
        }
      });

      // Set initial KPI index
      var lastKpiIndex = -1;

      return _react2.default.createElement(
        'div',
        { style: { padding: 15 } },
        _react2.default.createElement(
          'div',
          { style: { display: 'flex' } },
          _react2.default.createElement(
            'strong',
            { style: { paddingLeft: 5, paddingTop: 5 } },
            t('label:担当者の実績', { name: selected_user_name })
          ),
          _react2.default.createElement(_button.Button, { label: t('label:戻る'), icon: 'arrow_back', onClick: onClose, style: { marginLeft: 'auto' } })
        ),
        _react2.default.createElement(
          _table.Table,
          { selectable: false, theme: _kpiChartTable2.default },
          _lodash2.default.map(total_actual_records, function (total_actual_record, i) {
            // Display the KPI title whenever the kpi changes
            var isNewKpi = lastKpiIndex != i;
            lastKpiIndex = i;
            return [isNewKpi && total_actual_record.actual_records.length > 0 && _react2.default.createElement(
              _table.TableRow,
              { key: 'kpi_title_' + i, style: { fontWeight: 'bold' } },
              _react2.default.createElement(
                _table.TableCell,
                null,
                total_actual_record.name
              ),
              _react2.default.createElement(
                _table.TableCell,
                { numeric: true },
                t('label:目標値2')
              ),
              _react2.default.createElement(
                _table.TableCell,
                { numeric: true },
                t('label:実績')
              ),
              _react2.default.createElement(
                _table.TableCell,
                { numeric: true },
                t('label:累計')
              ),
              _react2.default.createElement(
                _table.TableCell,
                { numeric: true },
                t('label:達成率')
              )
            ), _lodash2.default.map(total_actual_record.actual_records, function (item, j) {
              return ui.skipRows[i] && ui.skipRows[i][j] && !ui.skipRows[i][j].skip && _react2.default.createElement(
                _table.TableRow,
                { key: 'kpi_row_' + i + '_' + j },
                _react2.default.createElement(
                  _table.TableCell,
                  {
                    onClick: function onClick() {
                      return toggleSkipRows(_this2.props, i, j);
                    },
                    style: { cursor: 'pointer' } },
                  ui.skipRows[i][j].skip_count > 0 && _react2.default.createElement(_font_icon2.default, { value: 'arrow_drop_down' }),
                  !ui.skipRows[i][j].skip_count && _react2.default.createElement('span', { style: { width: 24, display: 'inline-block' } }),
                  (0, _moment2.default)(item.reported_at).format('LLLL')
                ),
                _react2.default.createElement(
                  _table.TableCell,
                  { numeric: true },
                  total_actual_record.prepend_unit && total_actual_record.unit,
                  typeof item.total != 'undefined' && (0, _formatNumber.formatNumber)(item.tbl_target, { decimal_1: true }),
                  !total_actual_record.prepend_unit && total_actual_record.unit
                ),
                _react2.default.createElement(ActualCell, { i: i, j: j, ui: ui, t: t,
                  kpi_id: total_actual_record.kpi_id,
                  kpi_name: total_actual_record.name,
                  updatable: group.is_admin || user.user_id == selected_user_id,
                  group: group,
                  displayGroupMemberErrorMessage: displayGroupMemberErrorMessage,
                  value: item.actual,
                  reported_at: item.reported_at,
                  format: total_actual_record.display_format,
                  display: (total_actual_record.prepend_unit && total_actual_record.unit || '') + (0, _formatNumber.formatNumber)(item.actual, total_actual_record.display_format) + (!total_actual_record.prepend_unit && total_actual_record.unit || ''),
                  updateUI: updateUI,
                  updateActualRecord: updateActualRecord }),
                _react2.default.createElement(
                  _table.TableCell,
                  { numeric: true },
                  total_actual_record.prepend_unit && total_actual_record.unit,
                  typeof item.total != 'undefined' && kpiUI.aggregationType == 'daily_total_01' ? '-' : (0, _formatNumber.formatNumber)(item.tbl_total, total_actual_record.display_format),
                  kpiUI.aggregationType != 'daily_total_01' && !total_actual_record.prepend_unit && total_actual_record.unit
                ),
                _react2.default.createElement(
                  _table.TableCell,
                  { numeric: true },
                  (0, _formatNumber.percent)(item.percent),
                  '%'
                )
              );
            }), isNewKpi && total_actual_record.actual_records.length > 0 && _react2.default.createElement(
              _table.TableRow,
              { key: 'kpi_total_' + i, style: { fontWeight: 'bold' } },
              _react2.default.createElement(
                _table.TableCell,
                { style: { textAlign: 'right' } },
                t('label:合計')
              ),
              _react2.default.createElement(
                _table.TableCell,
                { numeric: true },
                (0, _formatNumber.formatNumber)(total_actual_record.last_record.total_target, total_actual_record.display_format),
                !total_actual_record.prepend_unit && total_actual_record.unit
              ),
              _react2.default.createElement(
                _table.TableCell,
                { numeric: true },
                kpiUI.aggregationType == 'daily_total_01' ? '-' : total_actual_record.last_record.total,
                kpiUI.aggregationType != 'daily_total_01' && !total_actual_record.prepend_unit && total_actual_record.unit
              ),
              _react2.default.createElement(
                _table.TableCell,
                { numeric: true },
                kpiUI.aggregationType == 'daily_total_01' ? '-' : total_actual_record.last_record.total,
                kpiUI.aggregationType != 'daily_total_01' && !total_actual_record.prepend_unit && total_actual_record.unit
              ),
              _react2.default.createElement(
                _table.TableCell,
                { numeric: true },
                kpiUI.aggregationType == 'daily_total_01' ? '-' : (0, _formatNumber.percent)(total_actual_record.last_record.percent) + '%'
              )
            )];
          })
        )
      );
    }
  }]);

  return KPIChartDetailTable;
}(_react2.default.Component);

exports.default = (0, _kpiChartDetailTable2.default)(KPIChartDetailTable);

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/kpi-chart-detail-table.js

exports.initSkipRows = initSkipRows;
exports.filterActualRecords = filterActualRecords;
exports.initTotalSkipRows = initTotalSkipRows;
exports.prepareActualRecords = prepareActualRecords;
exports.getActualRecords = getActualRecords;
exports.arrayInTotal = arrayInTotal;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initSkipRows(progress, user_id) {
  var actual_records = (0, _find2.default)(progress, function (item) {
    return item.user_id == user_id;
  }).actual_records;
  var result = [];
  (0, _each2.default)(actual_records, function (record, i) {
    if (record.actual || i == 0) {
      var j;
      for (j = 0; i + j + 1 < actual_records.length && !actual_records[i + j + 1].actual; j++) {
        result[i + j + 1] = { skip: true };
      }result[i] = { skip_count: j };
    }
  });
  return result;
}

// This function is used to filter the actual_records by date ranges from original actual_records and re-calculate the "total" field based on filtered_records
function filterActualRecords(actual_records, accumulated_total, aggregationType, tableSelectedDate, tableStartDate, tableEndDate) {
  var dateRange = [new Date(tableStartDate), new Date(tableEndDate)];
  var filtered_records = actual_records.filter(function (item) {
    var reportedDate = new Date(item.reported_at);
    return reportedDate >= dateRange[0] && reportedDate <= dateRange[1];
  });
  // Calculate the cumulative daily target
  if (filtered_records.length > 0) {
    var daily_target = accumulated_total ? filtered_records[0].target / filtered_records.length : filtered_records[0].target;
    filtered_records.forEach(function (item, index) {
      item.cumulative_target = daily_target * (index + 1);
      item.daily_target = daily_target;
      item.total_target = daily_target * filtered_records.length;
    });
  }
  var cumulativeTotal = 0;
  filtered_records = filtered_records.map(function (record) {
    cumulativeTotal += record.actual;
    return _extends({}, record, { total: cumulativeTotal });
  });
  // if (aggregationType != 'cumulative') {
  //   const selectedDateRange =  [new Date(tableSelectedDate), new Date(tableSelectedDate)]
  //   filtered_records = filtered_records.filter(item => {
  //     const reportedDate = new Date(item.reported_at)
  //     return reportedDate >= selectedDateRange[0] && reportedDate <= selectedDateRange[1]
  //   })
  // }
  return filtered_records;
}

function initTotalSkipRows(selectedKPIs, kpis, user_id, aggregationType, tableSelectedDate, tableStartDate, tableEndDate) {
  var result = [];
  (0, _map2.default)(selectedKPIs, function (selected_kpi, i) {
    var kpi = kpis.find(function (item) {
      return item.kpi_id == selected_kpi.kpi_id;
    });
    if (kpi) {
      var assignment = (0, _find2.default)(kpi.assignments, function (item) {
        return item.user_id == user_id;
      });

      if (assignment && assignment.progress && assignment.progress.actual_records) {
        var filtered_records = filterActualRecords(assignment.progress.actual_records, true, aggregationType, tableSelectedDate, tableStartDate, tableEndDate);

        // Ensure result[i] is initialized as an array
        result[i] = result[i] || [];

        (0, _each2.default)(filtered_records, function (record, j) {
          // Ensure result[i][j] is initialized as an object
          result[i][j] = result[i][j] || {};

          if (record.actual || j == 0) {
            var k = void 0;
            for (k = 0; j + k + 1 < filtered_records.length && !filtered_records[j + k + 1].actual; k++) {
              result[i][j + k + 1] = result[i][j + k + 1] || {}; // Initialize if undefined
              result[i][j + k + 1].skip = true;
            }
            result[i][j].skip_count = k;
          }
        });
      }
    }
  });

  return result;
}

function prepareActualRecords(progress, user_id) {
  return (0, _map2.default)((0, _find2.default)(progress, function (item) {
    return item.user_id == user_id;
  }).actual_records, function (record) {
    var total = typeof record.total == 'undefined' ? record.actual : record.total;
    return Object.assign({}, record, {
      percent: Math.floor(total * 1000 / record.target) / 1000
    });
  });
}

function getActualRecords(assignments, user_id, accumulated_total, aggregationType, tableSelectedDate, tableStartDate, tableEndDate) {
  var assignment = (0, _find2.default)(assignments, function (item) {
    return item.user_id == user_id;
  });

  if (!assignment || !assignment.progress || !assignment.progress.actual_records) {
    return []; // Return an empty array if progress or actual_records is missing
  }
  var filtered_records = filterActualRecords(assignment.progress.actual_records, accumulated_total, aggregationType, tableSelectedDate, tableStartDate, tableEndDate);

  var total = 0;
  var target = 0;
  return (0, _map2.default)(filtered_records, function (record) {
    switch (aggregationType) {
      case 'cumulative':
        total = record.total;
        target = accumulated_total ? record.target : record.total_target;
        break;
      case 'daily_total_01':
        total = record.actual;
        target = record.daily_target;
        break;
      case 'daily_total_02':
        total = record.total;
        target = record.cumulative_target;
        break;
    }

    return Object.assign({}, record, {
      tbl_total: total,
      tbl_target: target,
      percent: Math.floor(total * 1000 / target) / 1000
    });
  });
}

function arrayInTotal(progress, user_id) {
  if (progress) {
    //actual_records内にtotalがある場合か判定
    var recordDate = (0, _find2.default)(progress, function (item) {
      return item.user_id == user_id;
    }).actual_records;
    if (recordDate) return "total" in recordDate[0];
  }
  return false;
}

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isUpdating: state.kpiChart.isUpdating,
    isUpdateFailed: state.kpiChart.isUpdateFailed
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    toggleSkipRows: function toggleSkipRows(props, i, j) {
      var skip_count = props.ui.skipRows[i][j] && props.ui.skipRows[i][j].skip_count || 0;
      var skipRows = (0, _map2.default)(props.ui.skipRows, function (rowGroup, rowIndex) {
        if (rowIndex != i) return rowGroup;

        return (0, _map2.default)(rowGroup, function (row, colIndex) {
          if (colIndex <= j) return row;
          if (colIndex > j + skip_count) return row;
          return _extends({}, row, { skip: !row.skip });
        });
      });

      props.updateUI({ skipRows: skipRows });
    },

    displayGroupMemberErrorMessage: function displayGroupMemberErrorMessage(group_name) {
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:この値は変更できない', group_name: group_name }, 'error'));
    },

    updateActualRecord: function updateActualRecord(kpi_id, kpi_name, reported_at, value) {
      dispatch(_actions2.default.updateKpiActualRecord(kpi_id, reported_at, value, ownProps.group.group_id, ownProps.selected_user_id)).then(function () {
        // fetch Update data from selectedKPIs
        ownProps.fetchChartKpis(ownProps.selectedKPIs, ownProps.parentProps);
        ownProps.fetchComparisonKpis(ownProps.selectedKPIs, ownProps.parentProps);
      });
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:KPIの実績値を更新しました', name: kpi_name, reported_at: (0, _moment2.default)(reported_at).format('llll') }, 'inputSuccess'));
    },

    willUpdate: function willUpdate(props, nextProps) {
      // re-generate skipRows object whenever selected kpis has been changed or aggregationType, tableSelectedDate, tableStartDate, tableEndDate has been changed
      if (props.kpis && nextProps.kpis && props.kpis.length != nextProps.kpis.length || props.kpiUI.aggregationType != nextProps.kpiUI.aggregationType || props.kpiUI.tableSelectedDate != nextProps.kpiUI.tableSelectedDate || props.kpiUI.tableStartDate != nextProps.kpiUI.tableStartDate || props.kpiUI.tableEndDate != nextProps.kpiUI.tableEndDate) {
        var skipRows = initTotalSkipRows(nextProps.selectedKPIs, nextProps.kpis, nextProps.selected_user_id, nextProps.kpiUI.aggregationType, (0, _moment2.default)(nextProps.kpiUI.tableSelectedDate).format('YYYY-MM-DD'), (0, _moment2.default)(nextProps.kpiUI.tableStartDate).format('YYYY-MM-DD'), (0, _moment2.default)(nextProps.kpiUI.tableEndDate).format('YYYY-MM-DD'));
        nextProps.updateUI({ skipRows: skipRows });
      }
      if (props.isUpdating && !nextProps.isUpdating && !nextProps.isUpdateFailed) {
        nextProps.updateUI({ editRows: [] });
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    editRows: [],
    skipRows: function skipRows(props) {
      return props.selectedKPIs && props.kpis && initTotalSkipRows(props.selectedKPIs, props.kpis, props.selected_user_id, props.kpiUI.aggregationType, (0, _moment2.default)(props.kpiUI.tableSelectedDate).format('YYYY-MM-DD'), (0, _moment2.default)(props.kpiUI.tableStartDate).format('YYYY-MM-DD'), (0, _moment2.default)(props.kpiUI.tableEndDate).format('YYYY-MM-DD')) || undefined;
    }
  } }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroForm", function() { return St; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormAppearance", function() { return At; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormButton", function() { return mt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormCheckBox", function() { return wt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormChoiceField", function() { return ft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormComboBox", function() { return pt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormEditBox", function() { return gt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormListBox", function() { return dt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormPasswordField", function() { return Lt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormPushButton", function() { return vt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormRadioButton", function() { return bt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AcroFormTextField", function() { return Nt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GState", function() { return j; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShadingPattern", function() { return B; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TilingPattern", function() { return M; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jsPDF", function() { return E; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fflate__ = __webpack_require__(2617);
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.2 Built on 2024-09-17T13:29:57.859Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */

var n=function(){return"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this}();function i(){n.console&&"function"==typeof n.console.log&&n.console.log.apply(n.console,arguments)}var a={log:i,warn:function(t){n.console&&("function"==typeof n.console.warn?n.console.warn.apply(n.console,arguments):i.call(null,arguments))},error:function(t){n.console&&("function"==typeof n.console.error?n.console.error.apply(n.console,arguments):i(t))}};function o(t,e,r){var n=new XMLHttpRequest;n.open("GET",t),n.responseType="blob",n.onload=function(){l(n.response,e,r)},n.onerror=function(){a.error("could not download file")},n.send()}function s(t){var e=new XMLHttpRequest;e.open("HEAD",t,!1);try{e.send()}catch(t){}return e.status>=200&&e.status<=299}function c(t){try{t.dispatchEvent(new MouseEvent("click"))}catch(r){var e=document.createEvent("MouseEvents");e.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),t.dispatchEvent(e)}}var u,h,l=n.saveAs||("object"!==("undefined"==typeof window?"undefined":__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(window))||window!==n?function(){}:"undefined"!=typeof HTMLAnchorElement&&"download"in HTMLAnchorElement.prototype?function(t,e,r){var i=n.URL||n.webkitURL,a=document.createElement("a");e=e||t.name||"download",a.download=e,a.rel="noopener","string"==typeof t?(a.href=t,a.origin!==location.origin?s(a.href)?o(t,e,r):c(a,a.target="_blank"):c(a)):(a.href=i.createObjectURL(t),setTimeout((function(){i.revokeObjectURL(a.href)}),4e4),setTimeout((function(){c(a)}),0))}:"msSaveOrOpenBlob"in navigator?function(e,r,n){if(r=r||e.name||"download","string"==typeof e)if(s(e))o(e,r,n);else{var i=document.createElement("a");i.href=e,i.target="_blank",setTimeout((function(){c(i)}))}else navigator.msSaveOrOpenBlob(function(e,r){return void 0===r?r={autoBom:!1}:"object"!==__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(r)&&(a.warn("Deprecated: Expected third argument to be a object"),r={autoBom:!r}),r.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)?new Blob([String.fromCharCode(65279),e],{type:e.type}):e}(e,n),r)}:function(e,r,i,a){if((a=a||open("","_blank"))&&(a.document.title=a.document.body.innerText="downloading..."),"string"==typeof e)return o(e,r,i);var s="application/octet-stream"===e.type,c=/constructor/i.test(n.HTMLElement)||n.safari,u=/CriOS\/[\d]+/.test(navigator.userAgent);if((u||s&&c)&&"object"===("undefined"==typeof FileReader?"undefined":__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(FileReader))){var h=new FileReader;h.onloadend=function(){var t=h.result;t=u?t:t.replace(/^data:[^;]*;/,"data:attachment/file;"),a?a.location.href=t:location=t,a=null},h.readAsDataURL(e)}else{var l=n.URL||n.webkitURL,f=l.createObjectURL(e);a?a.location=f:location.href=f,a=null,setTimeout((function(){l.revokeObjectURL(f)}),4e4)}});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */function f(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6));t={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"}[t=(t=t.replace(/ /g,"")).toLowerCase()]||t;for(var r=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],n=0;n<r.length;n++){var i=r[n].re,a=r[n].process,o=i.exec(t);o&&(e=a(o),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:this.r>255?255:this.r,this.g=this.g<0||isNaN(this.g)?0:this.g>255?255:this.g,this.b=this.b<0||isNaN(this.b)?0:this.b>255?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),r=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==r.length&&(r="0"+r),"#"+t+e+r}}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function d(t,e){var r=t[0],n=t[1],i=t[2],a=t[3];r=g(r,n,i,a,e[0],7,-680876936),a=g(a,r,n,i,e[1],12,-389564586),i=g(i,a,r,n,e[2],17,606105819),n=g(n,i,a,r,e[3],22,-1044525330),r=g(r,n,i,a,e[4],7,-176418897),a=g(a,r,n,i,e[5],12,1200080426),i=g(i,a,r,n,e[6],17,-1473231341),n=g(n,i,a,r,e[7],22,-45705983),r=g(r,n,i,a,e[8],7,1770035416),a=g(a,r,n,i,e[9],12,-1958414417),i=g(i,a,r,n,e[10],17,-42063),n=g(n,i,a,r,e[11],22,-1990404162),r=g(r,n,i,a,e[12],7,1804603682),a=g(a,r,n,i,e[13],12,-40341101),i=g(i,a,r,n,e[14],17,-1502002290),r=m(r,n=g(n,i,a,r,e[15],22,1236535329),i,a,e[1],5,-165796510),a=m(a,r,n,i,e[6],9,-1069501632),i=m(i,a,r,n,e[11],14,643717713),n=m(n,i,a,r,e[0],20,-373897302),r=m(r,n,i,a,e[5],5,-701558691),a=m(a,r,n,i,e[10],9,38016083),i=m(i,a,r,n,e[15],14,-660478335),n=m(n,i,a,r,e[4],20,-405537848),r=m(r,n,i,a,e[9],5,568446438),a=m(a,r,n,i,e[14],9,-1019803690),i=m(i,a,r,n,e[3],14,-187363961),n=m(n,i,a,r,e[8],20,1163531501),r=m(r,n,i,a,e[13],5,-1444681467),a=m(a,r,n,i,e[2],9,-51403784),i=m(i,a,r,n,e[7],14,1735328473),r=v(r,n=m(n,i,a,r,e[12],20,-1926607734),i,a,e[5],4,-378558),a=v(a,r,n,i,e[8],11,-2022574463),i=v(i,a,r,n,e[11],16,1839030562),n=v(n,i,a,r,e[14],23,-35309556),r=v(r,n,i,a,e[1],4,-1530992060),a=v(a,r,n,i,e[4],11,1272893353),i=v(i,a,r,n,e[7],16,-155497632),n=v(n,i,a,r,e[10],23,-1094730640),r=v(r,n,i,a,e[13],4,681279174),a=v(a,r,n,i,e[0],11,-358537222),i=v(i,a,r,n,e[3],16,-722521979),n=v(n,i,a,r,e[6],23,76029189),r=v(r,n,i,a,e[9],4,-640364487),a=v(a,r,n,i,e[12],11,-421815835),i=v(i,a,r,n,e[15],16,530742520),r=b(r,n=v(n,i,a,r,e[2],23,-995338651),i,a,e[0],6,-198630844),a=b(a,r,n,i,e[7],10,1126891415),i=b(i,a,r,n,e[14],15,-1416354905),n=b(n,i,a,r,e[5],21,-57434055),r=b(r,n,i,a,e[12],6,1700485571),a=b(a,r,n,i,e[3],10,-1894986606),i=b(i,a,r,n,e[10],15,-1051523),n=b(n,i,a,r,e[1],21,-2054922799),r=b(r,n,i,a,e[8],6,1873313359),a=b(a,r,n,i,e[15],10,-30611744),i=b(i,a,r,n,e[6],15,-1560198380),n=b(n,i,a,r,e[13],21,1309151649),r=b(r,n,i,a,e[4],6,-145523070),a=b(a,r,n,i,e[11],10,-1120210379),i=b(i,a,r,n,e[2],15,718787259),n=b(n,i,a,r,e[9],21,-343485551),t[0]=_(r,t[0]),t[1]=_(n,t[1]),t[2]=_(i,t[2]),t[3]=_(a,t[3])}function p(t,e,r,n,i,a){return e=_(_(e,t),_(n,a)),_(e<<i|e>>>32-i,r)}function g(t,e,r,n,i,a,o){return p(e&r|~e&n,t,e,i,a,o)}function m(t,e,r,n,i,a,o){return p(e&n|r&~n,t,e,i,a,o)}function v(t,e,r,n,i,a,o){return p(e^r^n,t,e,i,a,o)}function b(t,e,r,n,i,a,o){return p(r^(e|~n),t,e,i,a,o)}function y(t){var e,r=t.length,n=[1732584193,-271733879,-1732584194,271733878];for(e=64;e<=t.length;e+=64)d(n,w(t.substring(e-64,e)));t=t.substring(e-64);var i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<t.length;e++)i[e>>2]|=t.charCodeAt(e)<<(e%4<<3);if(i[e>>2]|=128<<(e%4<<3),e>55)for(d(n,i),e=0;e<16;e++)i[e]=0;return i[14]=8*r,d(n,i),n}function w(t){var e,r=[];for(e=0;e<64;e+=4)r[e>>2]=t.charCodeAt(e)+(t.charCodeAt(e+1)<<8)+(t.charCodeAt(e+2)<<16)+(t.charCodeAt(e+3)<<24);return r}u=n.atob.bind(n),h=n.btoa.bind(n);var N="0123456789abcdef".split("");function L(t){for(var e="",r=0;r<4;r++)e+=N[t>>8*r+4&15]+N[t>>8*r&15];return e}function A(t){return String.fromCharCode((255&t)>>0,(65280&t)>>8,(16711680&t)>>16,(4278190080&t)>>24)}function x(t){return y(t).map(A).join("")}var S="5d41402abc4b2a76b9719d911017c592"!=function(t){for(var e=0;e<t.length;e++)t[e]=L(t[e]);return t.join("")}(y("hello"));function _(t,e){if(S){var r=(65535&t)+(65535&e);return(t>>16)+(e>>16)+(r>>16)<<16|65535&r}return t+e&4294967295}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */function P(t,e){var r,n,i,a;if(t!==r){for(var o=(i=t,a=1+(256/t.length>>0),new Array(a+1).join(i)),s=[],c=0;c<256;c++)s[c]=c;var u=0;for(c=0;c<256;c++){var h=s[c];u=(u+h+o.charCodeAt(c))%256,s[c]=s[u],s[u]=h}r=t,n=s}else s=n;var l=e.length,f=0,d=0,p="";for(c=0;c<l;c++)d=(d+(h=s[f=(f+1)%256]))%256,s[f]=s[d],s[d]=h,o=s[(s[f]+s[d])%256],p+=String.fromCharCode(e.charCodeAt(c)^o);return p}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */var k={print:4,modify:8,copy:16,"annot-forms":32};function I(t,e,r,n){this.v=1,this.r=2;var i=192;t.forEach((function(t){if(void 0!==k.perm)throw new Error("Invalid permission: "+t);i+=k[t]})),this.padding="(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";var a=(e+this.padding).substr(0,32),o=(r+this.padding).substr(0,32);this.O=this.processOwnerPassword(a,o),this.P=-(1+(255^i)),this.encryptionKey=x(a+this.O+this.lsbFirstWord(this.P)+this.hexToBytes(n)).substr(0,5),this.U=P(this.encryptionKey,this.padding)}function F(t){if(/[^\u0000-\u00ff]/.test(t))throw new Error("Invalid PDF Name Object: "+t+", Only accept ASCII characters.");for(var e="",r=t.length,n=0;n<r;n++){var i=t.charCodeAt(n);if(i<33||35===i||37===i||40===i||41===i||47===i||60===i||62===i||91===i||93===i||123===i||125===i||i>126)e+="#"+("0"+i.toString(16)).slice(-2);else e+=t[n]}return e}function C(e){if("object"!==__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var r={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");r.hasOwnProperty(t)||(r[t]={});var i=Math.random().toString(35);return r[t][i]=[e,!!n],i},this.unsubscribe=function(t){for(var e in r)if(r[e][t])return delete r[e][t],0===Object.keys(r[e]).length&&delete r[e],!0;return!1},this.publish=function(t){if(r.hasOwnProperty(t)){var i=Array.prototype.slice.call(arguments,1),o=[];for(var s in r[t]){var c=r[t][s];try{c[0].apply(e,i)}catch(t){n.console&&a.error("jsPDF PubSub Error",t.message,t)}c[1]&&o.push(s)}o.length&&o.forEach(this.unsubscribe)}},this.getTopics=function(){return r}}function j(t){if(!(this instanceof j))return new j(t);var e="opacity,stroke-opacity".split(",");for(var r in t)t.hasOwnProperty(r)&&e.indexOf(r)>=0&&(this[r]=t[r]);this.id="",this.objectNumber=-1}function O(t,e){this.gState=t,this.matrix=e,this.id="",this.objectNumber=-1}function B(t,e,r,n,i){if(!(this instanceof B))return new B(t,e,r,n,i);this.type="axial"===t?2:3,this.coords=e,this.colors=r,O.call(this,n,i)}function M(t,e,r,n,i){if(!(this instanceof M))return new M(t,e,r,n,i);this.boundingBox=t,this.xStep=e,this.yStep=r,this.stream="",this.cloneIndex=0,O.call(this,n,i)}function E(e){var r,i="string"==typeof arguments[0]?arguments[0]:"p",o=arguments[1],s=arguments[2],c=arguments[3],u=[],d=1,p=16,g="S",m=null;"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e=e||{})&&(i=e.orientation,o=e.unit||o,s=e.format||s,c=e.compress||e.compressPdf||c,null!==(m=e.encryption||null)&&(m.userPassword=m.userPassword||"",m.ownerPassword=m.ownerPassword||"",m.userPermissions=m.userPermissions||[]),d="number"==typeof e.userUnit?Math.abs(e.userUnit):1,void 0!==e.precision&&(r=e.precision),void 0!==e.floatPrecision&&(p=e.floatPrecision),g=e.defaultPathOperation||"S"),u=e.filters||(!0===c?["FlateEncode"]:u),o=o||"mm",i=(""+(i||"P")).toLowerCase();var v=e.putOnlyUsedFonts||!1,b={},y={internal:{},__private__:{}};y.__private__.PubSub=C;var w="1.3",N=y.__private__.getPdfVersion=function(){return w};y.__private__.setPdfVersion=function(t){w=t};var L={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};y.__private__.getPageFormats=function(){return L};var A=y.__private__.getPageFormat=function(t){return L[t]};s=s||"a4";var x={COMPAT:"compat",ADVANCED:"advanced"},S=x.COMPAT;function _(){this.saveGraphicsState(),lt(new Vt(_t,0,0,-_t,0,Rr()*_t).toString()+" cm"),this.setFontSize(this.getFontSize()/_t),g="n",S=x.ADVANCED}function P(){this.restoreGraphicsState(),g="S",S=x.COMPAT}var k=y.__private__.combineFontStyleAndFontWeight=function(t,e){if("bold"==t&&"normal"==e||"bold"==t&&400==e||"normal"==t&&"italic"==e||"bold"==t&&"italic"==e)throw new Error("Invalid Combination of fontweight and fontstyle");return e&&(t=400==e||"normal"===e?"italic"===t?"italic":"normal":700!=e&&"bold"!==e||"normal"!==t?(700==e?"bold":e)+""+t:"bold"),t};y.advancedAPI=function(t){var e=S===x.COMPAT;return e&&_.call(this),"function"!=typeof t||(t(this),e&&P.call(this)),this},y.compatAPI=function(t){var e=S===x.ADVANCED;return e&&P.call(this),"function"!=typeof t||(t(this),e&&_.call(this)),this},y.isAdvancedAPI=function(){return S===x.ADVANCED};var O,q=function(t){if(S!==x.ADVANCED)throw new Error(t+" is only available in 'advanced' API mode. You need to call advancedAPI() first.")},D=y.roundToPrecision=y.__private__.roundToPrecision=function(t,e){var n=r||e;if(isNaN(t)||isNaN(n))throw new Error("Invalid argument passed to jsPDF.roundToPrecision");return t.toFixed(n).replace(/0+$/,"")};O=y.hpf=y.__private__.hpf="number"==typeof p?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,p)}:"smart"===p?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,t>-1&&t<1?16:5)}:function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,16)};var R=y.f2=y.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return D(t,2)},T=y.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return D(t,3)},U=y.scale=y.__private__.scale=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.scale");return S===x.COMPAT?t*_t:S===x.ADVANCED?t:void 0},z=function(t){return S===x.COMPAT?Rr()-t:S===x.ADVANCED?t:void 0},H=function(t){return U(z(t))};y.__private__.setPrecision=y.setPrecision=function(t){"number"==typeof parseInt(t,10)&&(r=parseInt(t,10))};var W,V="00000000000000000000000000000000",G=y.__private__.getFileId=function(){return V},Y=y.__private__.setFileId=function(t){return V=void 0!==t&&/^[a-fA-F0-9]{32}$/.test(t)?t.toUpperCase():V.split("").map((function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))})).join(""),null!==m&&(Ye=new I(m.userPermissions,m.userPassword,m.ownerPassword,V)),V};y.setFileId=function(t){return Y(t),this},y.getFileId=function(){return G()};var J=y.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),r=e<0?"+":"-",n=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),a=[r,Q(n),"'",Q(i),"'"].join("");return["D:",t.getFullYear(),Q(t.getMonth()+1),Q(t.getDate()),Q(t.getHours()),Q(t.getMinutes()),Q(t.getSeconds()),a].join("")},X=y.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),r=parseInt(t.substr(6,2),10)-1,n=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),a=parseInt(t.substr(12,2),10),o=parseInt(t.substr(14,2),10);return new Date(e,r,n,i,a,o,0)},K=y.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),t instanceof Date)e=J(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return W=e},Z=y.__private__.getCreationDate=function(t){var e=W;return"jsDate"===t&&(e=X(W)),e};y.setCreationDate=function(t){return K(t),this},y.getCreationDate=function(t){return Z(t)};var $,Q=y.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},tt=y.__private__.padd2Hex=function(t){return("00"+(t=t.toString())).substr(t.length)},et=0,rt=[],nt=[],it=0,at=[],ot=[],st=!1,ct=nt,ut=function(){et=0,it=0,nt=[],rt=[],at=[],Qt=Kt(),te=Kt()};y.__private__.setCustomOutputDestination=function(t){st=!0,ct=t};var ht=function(t){st||(ct=t)};y.__private__.resetCustomOutputDestination=function(){st=!1,ct=nt};var lt=y.__private__.out=function(t){return t=t.toString(),it+=t.length+1,ct.push(t),ct},ft=y.__private__.write=function(t){return lt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},dt=y.__private__.getArrayBuffer=function(t){for(var e=t.length,r=new ArrayBuffer(e),n=new Uint8Array(r);e--;)n[e]=t.charCodeAt(e);return r},pt=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]];y.__private__.getStandardFonts=function(){return pt};var gt=e.fontSize||16;y.__private__.setFontSize=y.setFontSize=function(t){return gt=S===x.ADVANCED?t/_t:t,this};var mt,vt=y.__private__.getFontSize=y.getFontSize=function(){return S===x.COMPAT?gt:gt*_t},bt=e.R2L||!1;y.__private__.setR2L=y.setR2L=function(t){return bt=t,this},y.__private__.getR2L=y.getR2L=function(){return bt};var yt,wt=y.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t))mt=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');mt=t}else mt=parseInt(t,10)};y.__private__.getZoomMode=function(){return mt};var Nt,Lt=y.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');yt=t};y.__private__.getPageMode=function(){return yt};var At=y.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');Nt=t};y.__private__.getLayoutMode=function(){return Nt},y.__private__.setDisplayMode=y.setDisplayMode=function(t,e,r){return wt(t),At(e),Lt(r),this};var xt={title:"",subject:"",author:"",keywords:"",creator:""};y.__private__.getDocumentProperty=function(t){if(-1===Object.keys(xt).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return xt[t]},y.__private__.getDocumentProperties=function(){return xt},y.__private__.setDocumentProperties=y.setProperties=y.setDocumentProperties=function(t){for(var e in xt)xt.hasOwnProperty(e)&&t[e]&&(xt[e]=t[e]);return this},y.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(xt).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return xt[t]=e};var St,_t,Pt,kt,It,Ft={},Ct={},jt=[],Ot={},Bt={},Mt={},Et={},qt=null,Dt=0,Rt=[],Tt=new C(y),Ut=e.hotfixes||[],zt={},Ht={},Wt=[],Vt=function t(e,r,n,i,a,o){if(!(this instanceof __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a))return new __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a(e,r,n,i,a,o);isNaN(e)&&(e=1),isNaN(r)&&(r=0),isNaN(n)&&(n=0),isNaN(i)&&(i=1),isNaN(a)&&(a=0),isNaN(o)&&(o=0),this._matrix=[e,r,n,i,a,o]};Object.defineProperty(Vt.prototype,"sx",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t}}),Object.defineProperty(Vt.prototype,"shy",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t}}),Object.defineProperty(Vt.prototype,"shx",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t}}),Object.defineProperty(Vt.prototype,"sy",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t}}),Object.defineProperty(Vt.prototype,"tx",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t}}),Object.defineProperty(Vt.prototype,"ty",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t}}),Object.defineProperty(Vt.prototype,"a",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t}}),Object.defineProperty(Vt.prototype,"b",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t}}),Object.defineProperty(Vt.prototype,"c",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t}}),Object.defineProperty(Vt.prototype,"d",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t}}),Object.defineProperty(Vt.prototype,"e",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t}}),Object.defineProperty(Vt.prototype,"f",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t}}),Object.defineProperty(Vt.prototype,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(Vt.prototype,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(Vt.prototype,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(Vt.prototype,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),Vt.prototype.join=function(t){return[this.sx,this.shy,this.shx,this.sy,this.tx,this.ty].map(O).join(t)},Vt.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,r=t.sx*this.shy+t.shy*this.sy,n=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,a=t.tx*this.sx+t.ty*this.shx+this.tx,o=t.tx*this.shy+t.ty*this.sy+this.ty;return new Vt(e,r,n,i,a,o)},Vt.prototype.decompose=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=Math.sqrt(t*t+e*e),s=(t/=o)*r+(e/=o)*n;r-=t*s,n-=e*s;var c=Math.sqrt(r*r+n*n);return s/=c,t*(n/=c)<e*(r/=c)&&(t=-t,e=-e,s=-s,o=-o),{scale:new Vt(o,0,0,c,0,0),translate:new Vt(1,0,0,1,i,a),rotate:new Vt(t,e,-e,t,0,0),skew:new Vt(1,0,s,1,0,0)}},Vt.prototype.toString=function(t){return this.join(" ")},Vt.prototype.inversed=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=1/(t*n-e*r),s=n*o,c=-e*o,u=-r*o,h=t*o;return new Vt(s,c,u,h,-s*i-u*a,-c*i-h*a)},Vt.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,r=t.x*this.shy+t.y*this.sy+this.ty;return new Cr(e,r)},Vt.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),r=this.applyToPoint(new Cr(t.x+t.w,t.y+t.h));return new jr(e.x,e.y,r.x-e.x,r.y-e.y)},Vt.prototype.clone=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty;return new Vt(t,e,r,n,i,a)},y.Matrix=Vt;var Gt=y.matrixMult=function(t,e){return e.multiply(t)},Yt=new Vt(1,0,0,1,0,0);y.unitMatrix=y.identityMatrix=Yt;var Jt=function(t,e){if(!Bt[t]){var r=(e instanceof B?"Sh":"P")+(Object.keys(Ot).length+1).toString(10);e.id=r,Bt[t]=r,Ot[r]=e,Tt.publish("addPattern",e)}};y.ShadingPattern=B,y.TilingPattern=M,y.addShadingPattern=function(t,e){return q("addShadingPattern()"),Jt(t,e),this},y.beginTilingPattern=function(t){q("beginTilingPattern()"),Br(t.boundingBox[0],t.boundingBox[1],t.boundingBox[2]-t.boundingBox[0],t.boundingBox[3]-t.boundingBox[1],t.matrix)},y.endTilingPattern=function(t,e){q("endTilingPattern()"),e.stream=ot[$].join("\n"),Jt(t,e),Tt.publish("endTilingPattern",e),Wt.pop().restore()};var Xt=y.__private__.newObject=function(){var t=Kt();return Zt(t,!0),t},Kt=y.__private__.newObjectDeferred=function(){return et++,rt[et]=function(){return it},et},Zt=function(t,e){return e="boolean"==typeof e&&e,rt[t]=it,e&&lt(t+" 0 obj"),t},$t=y.__private__.newAdditionalObject=function(){var t={objId:Kt(),content:""};return at.push(t),t},Qt=Kt(),te=Kt(),ee=y.__private__.decodeColorString=function(t){var e=t.split(" ");if(2!==e.length||"g"!==e[1]&&"G"!==e[1]){if(5===e.length&&("k"===e[4]||"K"===e[4])){e=[(1-e[0])*(1-e[3]),(1-e[1])*(1-e[3]),(1-e[2])*(1-e[3]),"r"]}}else{var r=parseFloat(e[0]);e=[r,r,r,"r"]}for(var n="#",i=0;i<3;i++)n+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return n},re=y.__private__.encodeColorString=function(e){var r;"string"==typeof e&&(e={ch1:e});var n=e.ch1,i=e.ch2,a=e.ch3,o=e.ch4,s="draw"===e.pdfColorType?["G","RG","K"]:["g","rg","k"];if("string"==typeof n&&"#"!==n.charAt(0)){var c=new f(n);if(c.ok)n=c.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var u=parseInt(n.substr(1),16);n=u>>16&255,i=u>>8&255,a=255&u}if(void 0===i||void 0===o&&n===i&&i===a)if("string"==typeof n)r=n+" "+s[0];else switch(e.precision){case 2:r=R(n/255)+" "+s[0];break;case 3:default:r=T(n/255)+" "+s[0]}else if(void 0===o||"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(o)){if(o&&!isNaN(o.a)&&0===o.a)return r=["1.","1.","1.",s[1]].join(" ");if("string"==typeof n)r=[n,i,a,s[1]].join(" ");else switch(e.precision){case 2:r=[R(n/255),R(i/255),R(a/255),s[1]].join(" ");break;default:case 3:r=[T(n/255),T(i/255),T(a/255),s[1]].join(" ")}}else if("string"==typeof n)r=[n,i,a,o,s[2]].join(" ");else switch(e.precision){case 2:r=[R(n),R(i),R(a),R(o),s[2]].join(" ");break;case 3:default:r=[T(n),T(i),T(a),T(o),s[2]].join(" ")}return r},ne=y.__private__.getFilters=function(){return u},ie=y.__private__.putStream=function(t){var e=(t=t||{}).data||"",r=t.filters||ne(),n=t.alreadyAppliedFilters||[],i=t.addLength1||!1,a=e.length,o=t.objectId,s=function(t){return t};if(null!==m&&void 0===o)throw new Error("ObjectId must be passed to putStream for file encryption");null!==m&&(s=Ye.encryptor(o,0));var c={};!0===r&&(r=["FlateEncode"]);var u=t.additionalKeyValues||[],h=(c=void 0!==E.API.processDataByFilters?E.API.processDataByFilters(e,r):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(n)?n.join(" "):n.toString());if(0!==c.data.length&&(u.push({key:"Length",value:c.data.length}),!0===i&&u.push({key:"Length1",value:a})),0!=h.length)if(h.split("/").length-1==1)u.push({key:"Filter",value:h});else{u.push({key:"Filter",value:"["+h+"]"});for(var l=0;l<u.length;l+=1)if("DecodeParms"===u[l].key){for(var f=[],d=0;d<c.reverseChain.split("/").length-1;d+=1)f.push("null");f.push(u[l].value),u[l].value="["+f.join(" ")+"]"}}lt("<<");for(var p=0;p<u.length;p++)lt("/"+u[p].key+" "+u[p].value);lt(">>"),0!==c.data.length&&(lt("stream"),lt(s(c.data)),lt("endstream"))},ae=y.__private__.putPage=function(t){var e=t.number,r=t.data,n=t.objId,i=t.contentsObjId;Zt(n,!0),lt("<</Type /Page"),lt("/Parent "+t.rootDictionaryObjId+" 0 R"),lt("/Resources "+t.resourceDictionaryObjId+" 0 R"),lt("/MediaBox ["+parseFloat(O(t.mediaBox.bottomLeftX))+" "+parseFloat(O(t.mediaBox.bottomLeftY))+" "+O(t.mediaBox.topRightX)+" "+O(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&lt("/CropBox ["+O(t.cropBox.bottomLeftX)+" "+O(t.cropBox.bottomLeftY)+" "+O(t.cropBox.topRightX)+" "+O(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&lt("/BleedBox ["+O(t.bleedBox.bottomLeftX)+" "+O(t.bleedBox.bottomLeftY)+" "+O(t.bleedBox.topRightX)+" "+O(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&lt("/TrimBox ["+O(t.trimBox.bottomLeftX)+" "+O(t.trimBox.bottomLeftY)+" "+O(t.trimBox.topRightX)+" "+O(t.trimBox.topRightY)+"]"),null!==t.artBox&&lt("/ArtBox ["+O(t.artBox.bottomLeftX)+" "+O(t.artBox.bottomLeftY)+" "+O(t.artBox.topRightX)+" "+O(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&lt("/UserUnit "+t.userUnit),Tt.publish("putPage",{objId:n,pageContext:Rt[e],pageNumber:e,page:r}),lt("/Contents "+i+" 0 R"),lt(">>"),lt("endobj");var a=r.join("\n");return S===x.ADVANCED&&(a+="\nQ"),Zt(i,!0),ie({data:a,filters:ne(),objectId:i}),lt("endobj"),n},oe=y.__private__.putPages=function(){var t,e,r=[];for(t=1;t<=Dt;t++)Rt[t].objId=Kt(),Rt[t].contentsObjId=Kt();for(t=1;t<=Dt;t++)r.push(ae({number:t,data:ot[t],objId:Rt[t].objId,contentsObjId:Rt[t].contentsObjId,mediaBox:Rt[t].mediaBox,cropBox:Rt[t].cropBox,bleedBox:Rt[t].bleedBox,trimBox:Rt[t].trimBox,artBox:Rt[t].artBox,userUnit:Rt[t].userUnit,rootDictionaryObjId:Qt,resourceDictionaryObjId:te}));Zt(Qt,!0),lt("<</Type /Pages");var n="/Kids [";for(e=0;e<Dt;e++)n+=r[e]+" 0 R ";lt(n+"]"),lt("/Count "+Dt),lt(">>"),lt("endobj"),Tt.publish("postPutPages")},se=function(t){Tt.publish("putFont",{font:t,out:lt,newObject:Xt,putStream:ie}),!0!==t.isAlreadyPutted&&(t.objectNumber=Xt(),lt("<<"),lt("/Type /Font"),lt("/BaseFont /"+F(t.postScriptName)),lt("/Subtype /Type1"),"string"==typeof t.encoding&&lt("/Encoding /"+t.encoding),lt("/FirstChar 32"),lt("/LastChar 255"),lt(">>"),lt("endobj"))},ce=function(){for(var t in Ft)Ft.hasOwnProperty(t)&&(!1===v||!0===v&&b.hasOwnProperty(t))&&se(Ft[t])},ue=function(t){t.objectNumber=Xt();var e=[];e.push({key:"Type",value:"/XObject"}),e.push({key:"Subtype",value:"/Form"}),e.push({key:"BBox",value:"["+[O(t.x),O(t.y),O(t.x+t.width),O(t.y+t.height)].join(" ")+"]"}),e.push({key:"Matrix",value:"["+t.matrix.toString()+"]"});var r=t.pages[1].join("\n");ie({data:r,additionalKeyValues:e,objectId:t.objectNumber}),lt("endobj")},he=function(){for(var t in zt)zt.hasOwnProperty(t)&&ue(zt[t])},le=function(t,e){var r,n=[],i=1/(e-1);for(r=0;r<1;r+=i)n.push(r);if(n.push(1),0!=t[0].offset){var a={offset:0,color:t[0].color};t.unshift(a)}if(1!=t[t.length-1].offset){var o={offset:1,color:t[t.length-1].color};t.push(o)}for(var s="",c=0,u=0;u<n.length;u++){for(r=n[u];r>t[c+1].offset;)c++;var h=t[c].offset,l=(r-h)/(t[c+1].offset-h),f=t[c].color,d=t[c+1].color;s+=tt(Math.round((1-l)*f[0]+l*d[0]).toString(16))+tt(Math.round((1-l)*f[1]+l*d[1]).toString(16))+tt(Math.round((1-l)*f[2]+l*d[2]).toString(16))}return s.trim()},fe=function(t,e){e||(e=21);var r=Xt(),n=le(t.colors,e),i=[];i.push({key:"FunctionType",value:"0"}),i.push({key:"Domain",value:"[0.0 1.0]"}),i.push({key:"Size",value:"["+e+"]"}),i.push({key:"BitsPerSample",value:"8"}),i.push({key:"Range",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),i.push({key:"Decode",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),ie({data:n,additionalKeyValues:i,alreadyAppliedFilters:["/ASCIIHexDecode"],objectId:r}),lt("endobj"),t.objectNumber=Xt(),lt("<< /ShadingType "+t.type),lt("/ColorSpace /DeviceRGB");var a="/Coords ["+O(parseFloat(t.coords[0]))+" "+O(parseFloat(t.coords[1]))+" ";2===t.type?a+=O(parseFloat(t.coords[2]))+" "+O(parseFloat(t.coords[3])):a+=O(parseFloat(t.coords[2]))+" "+O(parseFloat(t.coords[3]))+" "+O(parseFloat(t.coords[4]))+" "+O(parseFloat(t.coords[5])),lt(a+="]"),t.matrix&&lt("/Matrix ["+t.matrix.toString()+"]"),lt("/Function "+r+" 0 R"),lt("/Extend [true true]"),lt(">>"),lt("endobj")},de=function(t,e){var r=Kt(),n=Xt();e.push({resourcesOid:r,objectOid:n}),t.objectNumber=n;var i=[];i.push({key:"Type",value:"/Pattern"}),i.push({key:"PatternType",value:"1"}),i.push({key:"PaintType",value:"1"}),i.push({key:"TilingType",value:"1"}),i.push({key:"BBox",value:"["+t.boundingBox.map(O).join(" ")+"]"}),i.push({key:"XStep",value:O(t.xStep)}),i.push({key:"YStep",value:O(t.yStep)}),i.push({key:"Resources",value:r+" 0 R"}),t.matrix&&i.push({key:"Matrix",value:"["+t.matrix.toString()+"]"}),ie({data:t.stream,additionalKeyValues:i,objectId:t.objectNumber}),lt("endobj")},pe=function(t){var e;for(e in Ot)Ot.hasOwnProperty(e)&&(Ot[e]instanceof B?fe(Ot[e]):Ot[e]instanceof M&&de(Ot[e],t))},ge=function(t){for(var e in t.objectNumber=Xt(),lt("<<"),t)switch(e){case"opacity":lt("/ca "+R(t[e]));break;case"stroke-opacity":lt("/CA "+R(t[e]))}lt(">>"),lt("endobj")},me=function(){var t;for(t in Mt)Mt.hasOwnProperty(t)&&ge(Mt[t])},ve=function(){for(var t in lt("/XObject <<"),zt)zt.hasOwnProperty(t)&&zt[t].objectNumber>=0&&lt("/"+t+" "+zt[t].objectNumber+" 0 R");Tt.publish("putXobjectDict"),lt(">>")},be=function(){Ye.oid=Xt(),lt("<<"),lt("/Filter /Standard"),lt("/V "+Ye.v),lt("/R "+Ye.r),lt("/U <"+Ye.toHexString(Ye.U)+">"),lt("/O <"+Ye.toHexString(Ye.O)+">"),lt("/P "+Ye.P),lt(">>"),lt("endobj")},ye=function(){for(var t in lt("/Font <<"),Ft)Ft.hasOwnProperty(t)&&(!1===v||!0===v&&b.hasOwnProperty(t))&&lt("/"+t+" "+Ft[t].objectNumber+" 0 R");lt(">>")},we=function(){if(Object.keys(Ot).length>0){for(var t in lt("/Shading <<"),Ot)Ot.hasOwnProperty(t)&&Ot[t]instanceof B&&Ot[t].objectNumber>=0&&lt("/"+t+" "+Ot[t].objectNumber+" 0 R");Tt.publish("putShadingPatternDict"),lt(">>")}},Ne=function(t){if(Object.keys(Ot).length>0){for(var e in lt("/Pattern <<"),Ot)Ot.hasOwnProperty(e)&&Ot[e]instanceof y.TilingPattern&&Ot[e].objectNumber>=0&&Ot[e].objectNumber<t&&lt("/"+e+" "+Ot[e].objectNumber+" 0 R");Tt.publish("putTilingPatternDict"),lt(">>")}},Le=function(){if(Object.keys(Mt).length>0){var t;for(t in lt("/ExtGState <<"),Mt)Mt.hasOwnProperty(t)&&Mt[t].objectNumber>=0&&lt("/"+t+" "+Mt[t].objectNumber+" 0 R");Tt.publish("putGStateDict"),lt(">>")}},Ae=function(t){Zt(t.resourcesOid,!0),lt("<<"),lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),ye(),we(),Ne(t.objectOid),Le(),ve(),lt(">>"),lt("endobj")},xe=function(){var t=[];ce(),me(),he(),pe(t),Tt.publish("putResources"),t.forEach(Ae),Ae({resourcesOid:te,objectOid:Number.MAX_SAFE_INTEGER}),Tt.publish("postPutResources")},Se=function(){Tt.publish("putAdditionalObjects");for(var t=0;t<at.length;t++){var e=at[t];Zt(e.objId,!0),lt(e.content),lt("endobj")}Tt.publish("postPutAdditionalObjects")},_e=function(t){Ct[t.fontName]=Ct[t.fontName]||{},Ct[t.fontName][t.fontStyle]=t.id},Pe=function(t,e,r,n,i){var a={id:"F"+(Object.keys(Ft).length+1).toString(10),postScriptName:t,fontName:e,fontStyle:r,encoding:n,isStandardFont:i||!1,metadata:{}};return Tt.publish("addFont",{font:a,instance:this}),Ft[a.id]=a,_e(a),a.id},ke=function(t){for(var e=0,r=pt.length;e<r;e++){var n=Pe.call(this,t[e][0],t[e][1],t[e][2],pt[e][3],!0);!1===v&&(b[n]=!0);var i=t[e][0].split("-");_e({id:n,fontName:i[0],fontStyle:i[1]||""})}Tt.publish("addFonts",{fonts:Ft,dictionary:Ct})},Ie=function(t){return t.foo=function(){try{return t.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var r="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!n.console)throw new Error(r);n.console.error(r,t),n.alert&&alert(r)}},t.foo.bar=t,t.foo},Fe=function(t,e){var r,n,i,a,o,s,c,u,h;if(i=(e=e||{}).sourceEncoding||"Unicode",o=e.outputEncoding,(e.autoencode||o)&&Ft[St].metadata&&Ft[St].metadata[i]&&Ft[St].metadata[i].encoding&&(a=Ft[St].metadata[i].encoding,!o&&Ft[St].encoding&&(o=Ft[St].encoding),!o&&a.codePages&&(o=a.codePages[0]),"string"==typeof o&&(o=a[o]),o)){for(c=!1,s=[],r=0,n=t.length;r<n;r++)(u=o[t.charCodeAt(r)])?s.push(String.fromCharCode(u)):s.push(t[r]),s[r].charCodeAt(0)>>8&&(c=!0);t=s.join("")}for(r=t.length;void 0===c&&0!==r;)t.charCodeAt(r-1)>>8&&(c=!0),r--;if(!c)return t;for(s=e.noBOM?[]:[254,255],r=0,n=t.length;r<n;r++){if((h=(u=t.charCodeAt(r))>>8)>>8)throw new Error("Character at position "+r+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(h),s.push(u-(h<<8))}return String.fromCharCode.apply(void 0,s)},Ce=y.__private__.pdfEscape=y.pdfEscape=function(t,e){return Fe(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},je=y.__private__.beginPage=function(t){ot[++Dt]=[],Rt[Dt]={objId:0,contentsObjId:0,userUnit:Number(d),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t[0]),topRightY:Number(t[1])}},Me(Dt),ht(ot[$])},Oe=function(t,e){var r,n,o;switch(i=e||i,"string"==typeof t&&(r=A(t.toLowerCase()),Array.isArray(r)&&(n=r[0],o=r[1])),Array.isArray(t)&&(n=t[0]*_t,o=t[1]*_t),isNaN(n)&&(n=s[0],o=s[1]),(n>14400||o>14400)&&(a.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),n=Math.min(14400,n),o=Math.min(14400,o)),s=[n,o],i.substr(0,1)){case"l":o>n&&(s=[o,n]);break;case"p":n>o&&(s=[o,n])}je(s),pr(fr),lt(Lr),0!==kr&&lt(kr+" J"),0!==Ir&&lt(Ir+" j"),Tt.publish("addPage",{pageNumber:Dt})},Be=function(t){t>0&&t<=Dt&&(ot.splice(t,1),Rt.splice(t,1),Dt--,$>Dt&&($=Dt),this.setPage($))},Me=function(t){t>0&&t<=Dt&&($=t)},Ee=y.__private__.getNumberOfPages=y.getNumberOfPages=function(){return ot.length-1},qe=function(t,e,r){var n,i=void 0;return r=r||{},t=void 0!==t?t:Ft[St].fontName,e=void 0!==e?e:Ft[St].fontStyle,n=t.toLowerCase(),void 0!==Ct[n]&&void 0!==Ct[n][e]?i=Ct[n][e]:void 0!==Ct[t]&&void 0!==Ct[t][e]?i=Ct[t][e]:!1===r.disableWarning&&a.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||r.noFallback||null==(i=Ct.times[e])&&(i=Ct.times.normal),i},De=y.__private__.putInfo=function(){var t=Xt(),e=function(t){return t};for(var r in null!==m&&(e=Ye.encryptor(t,0)),lt("<<"),lt("/Producer ("+Ce(e("jsPDF "+E.version))+")"),xt)xt.hasOwnProperty(r)&&xt[r]&&lt("/"+r.substr(0,1).toUpperCase()+r.substr(1)+" ("+Ce(e(xt[r]))+")");lt("/CreationDate ("+Ce(e(W))+")"),lt(">>"),lt("endobj")},Re=y.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||Qt;switch(Xt(),lt("<<"),lt("/Type /Catalog"),lt("/Pages "+e+" 0 R"),mt||(mt="fullwidth"),mt){case"fullwidth":lt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":lt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":lt("/OpenAction [3 0 R /Fit]");break;case"original":lt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var r=""+mt;"%"===r.substr(r.length-1)&&(mt=parseInt(mt)/100),"number"==typeof mt&&lt("/OpenAction [3 0 R /XYZ null null "+R(mt)+"]")}switch(Nt||(Nt="continuous"),Nt){case"continuous":lt("/PageLayout /OneColumn");break;case"single":lt("/PageLayout /SinglePage");break;case"two":case"twoleft":lt("/PageLayout /TwoColumnLeft");break;case"tworight":lt("/PageLayout /TwoColumnRight")}yt&&lt("/PageMode /"+yt),Tt.publish("putCatalog"),lt(">>"),lt("endobj")},Te=y.__private__.putTrailer=function(){lt("trailer"),lt("<<"),lt("/Size "+(et+1)),lt("/Root "+et+" 0 R"),lt("/Info "+(et-1)+" 0 R"),null!==m&&lt("/Encrypt "+Ye.oid+" 0 R"),lt("/ID [ <"+V+"> <"+V+"> ]"),lt(">>")},Ue=y.__private__.putHeader=function(){lt("%PDF-"+w),lt("%ºß¬à")},ze=y.__private__.putXRef=function(){var t="0000000000";lt("xref"),lt("0 "+(et+1)),lt("0000000000 65535 f ");for(var e=1;e<=et;e++){"function"==typeof rt[e]?lt((t+rt[e]()).slice(-10)+" 00000 n "):void 0!==rt[e]?lt((t+rt[e]).slice(-10)+" 00000 n "):lt("0000000000 00000 n ")}},He=y.__private__.buildDocument=function(){ut(),ht(nt),Tt.publish("buildDocument"),Ue(),oe(),Se(),xe(),null!==m&&be(),De(),Re();var t=it;return ze(),Te(),lt("startxref"),lt(""+t),lt("%%EOF"),ht(ot[$]),nt.join("\n")},We=y.__private__.getBlob=function(t){return new Blob([dt(t)],{type:"application/pdf"})},Ve=y.output=y.__private__.output=Ie((function(t,e){switch("string"==typeof(e=e||{})?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return He();case"save":y.save(e.filename);break;case"arraybuffer":return dt(He());case"blob":return We(He());case"bloburi":case"bloburl":if(void 0!==n.URL&&"function"==typeof n.URL.createObjectURL)return n.URL&&n.URL.createObjectURL(We(He()))||void 0;a.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":var r="",i=He();try{r=h(i)}catch(t){r=h(unescape(encodeURIComponent(i)))}return"data:application/pdf;filename="+e.filename+";base64,"+r;case"pdfobjectnewwindow":if("[object Window]"===Object.prototype.toString.call(n)){var o="https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js",s=' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';e.pdfObjectUrl&&(o=e.pdfObjectUrl,s="");var c='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="'+o+'"'+s+'><\/script><script >PDFObject.embed("'+this.output("dataurlstring")+'", '+JSON.stringify(e)+");<\/script></body></html>",u=n.open();return null!==u&&u.document.write(c),u}throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");case"pdfjsnewwindow":if("[object Window]"===Object.prototype.toString.call(n)){var l='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="'+(e.pdfJsUrl||"examples/PDF.js/web/viewer.html")+"?file=&downloadName="+e.filename+'" width="500px" height="400px" /></body></html>',f=n.open();if(null!==f){f.document.write(l);var d=this;f.document.documentElement.querySelector("#pdfViewer").onload=function(){f.document.title=e.filename,f.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(d.output("bloburl"))}}return f}throw new Error("The option pdfjsnewwindow just works in a browser-environment.");case"dataurlnewwindow":if("[object Window]"!==Object.prototype.toString.call(n))throw new Error("The option dataurlnewwindow just works in a browser-environment.");var p='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring",e)+'"></iframe></body></html>',g=n.open();if(null!==g&&(g.document.write(p),g.document.title=e.filename),g||"undefined"==typeof safari)return g;break;case"datauri":case"dataurl":return n.document.location.href=this.output("datauristring",e);default:return null}})),Ge=function(t){return!0===Array.isArray(Ut)&&Ut.indexOf(t)>-1};switch(o){case"pt":_t=1;break;case"mm":_t=72/25.4;break;case"cm":_t=72/2.54;break;case"in":_t=72;break;case"px":_t=1==Ge("px_scaling")?.75:96/72;break;case"pc":case"em":_t=12;break;case"ex":_t=6;break;default:if("number"!=typeof o)throw new Error("Invalid unit: "+o);_t=o}var Ye=null;K(),Y();var Je=function(t){return null!==m?Ye.encryptor(t,0):function(t){return t}},Xe=y.__private__.getPageInfo=y.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:Rt[t].objId,pageNumber:t,pageContext:Rt[t]}},Ke=y.__private__.getPageInfoByObjId=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");for(var e in Rt)if(Rt[e].objId===t)break;return Xe(e)},Ze=y.__private__.getCurrentPageInfo=y.getCurrentPageInfo=function(){return{objId:Rt[$].objId,pageNumber:$,pageContext:Rt[$]}};y.addPage=function(){return Oe.apply(this,arguments),this},y.setPage=function(){return Me.apply(this,arguments),ht.call(this,ot[$]),this},y.insertPage=function(t){return this.addPage(),this.movePage($,t),this},y.movePage=function(t,e){var r,n;if(t>e){r=ot[t],n=Rt[t];for(var i=t;i>e;i--)ot[i]=ot[i-1],Rt[i]=Rt[i-1];ot[e]=r,Rt[e]=n,this.setPage(e)}else if(t<e){r=ot[t],n=Rt[t];for(var a=t;a<e;a++)ot[a]=ot[a+1],Rt[a]=Rt[a+1];ot[e]=r,Rt[e]=n,this.setPage(e)}return this},y.deletePage=function(){return Be.apply(this,arguments),this},y.__private__.text=y.text=function(e,r,n,i,a){var o,s,c,u,h,l,f,d,p,g=(i=i||{}).scope||this;if("number"==typeof e&&"number"==typeof r&&("string"==typeof n||Array.isArray(n))){var m=n;n=r,r=e,e=m}if(arguments[3]instanceof Vt==!1?(c=arguments[4],u=arguments[5],"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(f=arguments[3])&&null!==f||("string"==typeof c&&(u=c,c=null),"string"==typeof f&&(u=f,f=null),"number"==typeof f&&(c=f,f=null),i={flags:f,angle:c,align:u})):(q("The transform parameter of text() with a Matrix value"),p=a),isNaN(r)||isNaN(n)||null==e)throw new Error("Invalid arguments passed to jsPDF.text");if(0===e.length)return g;var v="",y=!1,w="number"==typeof i.lineHeightFactor?i.lineHeightFactor:lr,N=g.internal.scaleFactor;function L(t){return t=t.split("\t").join(Array(i.TabLen||9).join(" ")),Ce(t,f)}function A(t){for(var e,r=t.concat(),n=[],i=r.length;i--;)"string"==typeof(e=r.shift())?n.push(e):Array.isArray(t)&&(1===e.length||void 0===e[1]&&void 0===e[2])?n.push(e[0]):n.push([e[0],e[1],e[2]]);return n}function _(t,e){var r;if("string"==typeof t)r=e(t)[0];else if(Array.isArray(t)){for(var n,i,a=t.concat(),o=[],s=a.length;s--;)"string"==typeof(n=a.shift())?o.push(e(n)[0]):Array.isArray(n)&&"string"==typeof n[0]&&(i=e(n[0],n[1],n[2]),o.push([i[0],i[1],i[2]]));r=o}return r}var P=!1,k=!0;if("string"==typeof e)P=!0;else if(Array.isArray(e)){var I=e.concat();s=[];for(var F,C=I.length;C--;)("string"!=typeof(F=I.shift())||Array.isArray(F)&&"string"!=typeof F[0])&&(k=!1);P=k}if(!1===P)throw new Error('Type of text must be string or Array. "'+e+'" is not recognized.');"string"==typeof e&&(e=e.match(/[\r?\n]/)?e.split(/\r\n|\r|\n/g):[e]);var j=gt/g.internal.scaleFactor,B=j*(w-1);switch(i.baseline){case"bottom":n-=B;break;case"top":n+=j-B;break;case"hanging":n+=j-2*B;break;case"middle":n+=j/2-B}if((l=i.maxWidth||0)>0&&("string"==typeof e?e=g.splitTextToSize(e,l):"[object Array]"===Object.prototype.toString.call(e)&&(e=e.reduce((function(t,e){return t.concat(g.splitTextToSize(e,l))}),[]))),o={text:e,x:r,y:n,options:i,mutex:{pdfEscape:Ce,activeFontKey:St,fonts:Ft,activeFontSize:gt}},Tt.publish("preProcessText",o),e=o.text,c=(i=o.options).angle,p instanceof Vt==!1&&c&&"number"==typeof c){c*=Math.PI/180,0===i.rotationDirection&&(c=-c),S===x.ADVANCED&&(c=-c);var M=Math.cos(c),E=Math.sin(c);p=new Vt(M,E,-E,M,0,0)}else c&&c instanceof Vt&&(p=c);S!==x.ADVANCED||p||(p=Yt),void 0!==(h=i.charSpace||_r)&&(v+=O(U(h))+" Tc\n",this.setCharSpace(this.getCharSpace()||0)),void 0!==(d=i.horizontalScale)&&(v+=O(100*d)+" Tz\n");i.lang;var D=-1,R=void 0!==i.renderingMode?i.renderingMode:i.stroke,T=g.internal.getCurrentPageInfo().pageContext;switch(R){case 0:case!1:case"fill":D=0;break;case 1:case!0:case"stroke":D=1;break;case 2:case"fillThenStroke":D=2;break;case 3:case"invisible":D=3;break;case 4:case"fillAndAddForClipping":D=4;break;case 5:case"strokeAndAddPathForClipping":D=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":D=6;break;case 7:case"addToPathForClipping":D=7}var z=void 0!==T.usedRenderingMode?T.usedRenderingMode:-1;-1!==D?v+=D+" Tr\n":-1!==z&&(v+="0 Tr\n"),-1!==D&&(T.usedRenderingMode=D),u=i.align||"left";var H,W=gt*w,V=g.internal.pageSize.getWidth(),G=Ft[St];h=i.charSpace||_r,l=i.maxWidth||0,f=Object.assign({autoencode:!0,noBOM:!0},i.flags);var Y=[],J=function(t){return g.getStringUnitWidth(t,{font:G,charSpace:h,fontSize:gt,doKerning:!1})*gt/N};if("[object Array]"===Object.prototype.toString.call(e)){var X;s=A(e),"left"!==u&&(H=s.map(J));var K,Z=0;if("right"===u){r-=H[0],e=[],C=s.length;for(var $=0;$<C;$++)0===$?(K=br(r),X=yr(n)):(K=U(Z-H[$]),X=-W),e.push([s[$],K,X]),Z=H[$]}else if("center"===u){r-=H[0]/2,e=[],C=s.length;for(var Q=0;Q<C;Q++)0===Q?(K=br(r),X=yr(n)):(K=U((Z-H[Q])/2),X=-W),e.push([s[Q],K,X]),Z=H[Q]}else if("left"===u){e=[],C=s.length;for(var tt=0;tt<C;tt++)e.push(s[tt])}else if("justify"===u&&"Identity-H"===G.encoding){e=[],C=s.length,l=0!==l?l:V;for(var et=0,rt=0;rt<C;rt++)if(X=0===rt?yr(n):-W,K=0===rt?br(r):et,rt<C-1){var nt=U((l-H[rt])/(s[rt].split(" ").length-1)),it=s[rt].split(" ");e.push([it[0]+" ",K,X]),et=0;for(var at=1;at<it.length;at++){var ot=(J(it[at-1]+" "+it[at])-J(it[at]))*N+nt;at==it.length-1?e.push([it[at],ot,0]):e.push([it[at]+" ",ot,0]),et-=ot}}else e.push([s[rt],K,X]);e.push(["",et,0])}else{if("justify"!==u)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');e=[],C=s.length,l=0!==l?l:V;for(rt=0;rt<C;rt++)X=0===rt?yr(n):-W,K=0===rt?br(r):0,rt<C-1?Y.push(O(U((l-H[rt])/(s[rt].split(" ").length-1)))):Y.push(0),e.push([s[rt],K,X])}}var st="boolean"==typeof i.R2L?i.R2L:bt;!0===st&&(e=_(e,(function(t,e,r){return[t.split("").reverse().join(""),e,r]}))),o={text:e,x:r,y:n,options:i,mutex:{pdfEscape:Ce,activeFontKey:St,fonts:Ft,activeFontSize:gt}},Tt.publish("postProcessText",o),e=o.text,y=o.mutex.isHex||!1;var ct=Ft[St].encoding;"WinAnsiEncoding"!==ct&&"StandardEncoding"!==ct||(e=_(e,(function(t,e,r){return[L(t),e,r]}))),s=A(e),e=[];for(var ut,ht,ft,dt=0,pt=1,mt=Array.isArray(s[0])?pt:dt,vt="",yt=function(t,e,r){var n="";return r instanceof Vt?(r="number"==typeof i.angle?Gt(r,new Vt(1,0,0,1,t,e)):Gt(new Vt(1,0,0,1,t,e),r),S===x.ADVANCED&&(r=Gt(new Vt(1,0,0,-1,0,0),r)),n=r.join(" ")+" Tm\n"):n=O(t)+" "+O(e)+" Td\n",n},wt=0;wt<s.length;wt++){switch(vt="",mt){case pt:ft=(y?"<":"(")+s[wt][0]+(y?">":")"),ut=parseFloat(s[wt][1]),ht=parseFloat(s[wt][2]);break;case dt:ft=(y?"<":"(")+s[wt]+(y?">":")"),ut=br(r),ht=yr(n)}void 0!==Y&&void 0!==Y[wt]&&(vt=Y[wt]+" Tw\n"),0===wt?e.push(vt+yt(ut,ht,p)+ft):mt===dt?e.push(vt+ft):mt===pt&&e.push(vt+yt(ut,ht,p)+ft)}e=mt===dt?e.join(" Tj\nT* "):e.join(" Tj\n"),e+=" Tj\n";var Nt="BT\n/";return Nt+=St+" "+gt+" Tf\n",Nt+=O(gt*w)+" TL\n",Nt+=xr+"\n",Nt+=v,Nt+=e,lt(Nt+="ET"),b[St]=!0,g};var $e=y.__private__.clip=y.clip=function(t){return lt("evenodd"===t?"W*":"W"),this};y.clipEvenOdd=function(){return $e("evenodd")},y.__private__.discardPath=y.discardPath=function(){return lt("n"),this};var Qe=y.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","D","F","DF","FD","f","f*","B","B*","n"].indexOf(t)&&(e=!0),e};y.__private__.setDefaultPathOperation=y.setDefaultPathOperation=function(t){return Qe(t)&&(g=t),this};var tr=y.__private__.getStyle=y.getStyle=function(t){var e=g;switch(t){case"D":case"S":e="S";break;case"F":e="f";break;case"FD":case"DF":e="B";break;case"f":case"f*":case"B":case"B*":e=t}return e},er=y.close=function(){return lt("h"),this};y.stroke=function(){return lt("S"),this},y.fill=function(t){return rr("f",t),this},y.fillEvenOdd=function(t){return rr("f*",t),this},y.fillStroke=function(t){return rr("B",t),this},y.fillStrokeEvenOdd=function(t){return rr("B*",t),this};var rr=function(e,r){"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(r)?ar(r,e):lt(e)},nr=function(t){null===t||S===x.ADVANCED&&void 0===t||(t=tr(t),lt(t))};function ir(t,e,r,n,i){var a=new M(e||this.boundingBox,r||this.xStep,n||this.yStep,this.gState,i||this.matrix);a.stream=this.stream;var o=t+"$$"+this.cloneIndex+++"$$";return Jt(o,a),a}var ar=function(t,e){var r=Bt[t.key],n=Ot[r];if(n instanceof B)lt("q"),lt(or(e)),n.gState&&y.setGState(n.gState),lt(t.matrix.toString()+" cm"),lt("/"+r+" sh"),lt("Q");else if(n instanceof M){var i=new Vt(1,0,0,-1,0,Rr());t.matrix&&(i=i.multiply(t.matrix||Yt),r=ir.call(n,t.key,t.boundingBox,t.xStep,t.yStep,i).id),lt("q"),lt("/Pattern cs"),lt("/"+r+" scn"),n.gState&&y.setGState(n.gState),lt(e),lt("Q")}},or=function(t){switch(t){case"f":case"F":return"W n";case"f*":return"W* n";case"B":return"W S";case"B*":return"W* S";case"S":return"W S";case"n":return"W n"}},sr=y.moveTo=function(t,e){return lt(O(U(t))+" "+O(H(e))+" m"),this},cr=y.lineTo=function(t,e){return lt(O(U(t))+" "+O(H(e))+" l"),this},ur=y.curveTo=function(t,e,r,n,i,a){return lt([O(U(t)),O(H(e)),O(U(r)),O(H(n)),O(U(i)),O(H(a)),"c"].join(" ")),this};y.__private__.line=y.line=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.line");return S===x.COMPAT?this.lines([[r-t,n-e]],t,e,[1,1],i||"S"):this.lines([[r-t,n-e]],t,e,[1,1]).stroke()},y.__private__.lines=y.lines=function(t,e,r,n,i,a){var o,s,c,u,h,l,f,d,p,g,m,v;if("number"==typeof t&&(v=r,r=e,e=t,t=v),n=n||[1,1],a=a||!1,isNaN(e)||isNaN(r)||!Array.isArray(t)||!Array.isArray(n)||!Qe(i)||"boolean"!=typeof a)throw new Error("Invalid arguments passed to jsPDF.lines");for(sr(e,r),o=n[0],s=n[1],u=t.length,g=e,m=r,c=0;c<u;c++)2===(h=t[c]).length?(g=h[0]*o+g,m=h[1]*s+m,cr(g,m)):(l=h[0]*o+g,f=h[1]*s+m,d=h[2]*o+g,p=h[3]*s+m,g=h[4]*o+g,m=h[5]*s+m,ur(l,f,d,p,g,m));return a&&er(),nr(i),this},y.path=function(t){for(var e=0;e<t.length;e++){var r=t[e],n=r.c;switch(r.op){case"m":sr(n[0],n[1]);break;case"l":cr(n[0],n[1]);break;case"c":ur.apply(this,n);break;case"h":er()}}return this},y.__private__.rect=y.rect=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.rect");return S===x.COMPAT&&(n=-n),lt([O(U(t)),O(H(e)),O(U(r)),O(U(n)),"re"].join(" ")),nr(i),this},y.__private__.triangle=y.triangle=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Qe(o))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[r-t,n-e],[i-r,a-n],[t-i,e-a]],t,e,[1,1],o,!0),this},y.__private__.roundedRect=y.roundedRect=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Qe(o))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return i=Math.min(i,.5*r),a=Math.min(a,.5*n),this.lines([[r-2*i,0],[i*s,0,i,a-a*s,i,a],[0,n-2*a],[0,a*s,-i*s,a,-i,a],[2*i-r,0],[-i*s,0,-i,-a*s,-i,-a],[0,2*a-n],[0,-a*s,i*s,-a,i,-a]],t+i,e,[1,1],o,!0),this},y.__private__.ellipse=y.ellipse=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var a=4/3*(Math.SQRT2-1)*r,o=4/3*(Math.SQRT2-1)*n;return sr(t+r,e),ur(t+r,e-o,t+a,e-n,t,e-n),ur(t-a,e-n,t-r,e-o,t-r,e),ur(t-r,e+o,t-a,e+n,t,e+n),ur(t+a,e+n,t+r,e+o,t+r,e),nr(i),this},y.__private__.circle=y.circle=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||!Qe(n))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,r,r,n)},y.setFont=function(t,e,r){return r&&(e=k(e,r)),St=qe(t,e,{disableWarning:!1}),this};var hr=y.__private__.getFont=y.getFont=function(){return Ft[qe.apply(y,arguments)]};y.__private__.getFontList=y.getFontList=function(){var t,e,r={};for(t in Ct)if(Ct.hasOwnProperty(t))for(e in r[t]=[],Ct[t])Ct[t].hasOwnProperty(e)&&r[t].push(e);return r},y.addFont=function(t,e,r,n,i){var a=["StandardEncoding","MacRomanEncoding","Identity-H","WinAnsiEncoding"];return arguments[3]&&-1!==a.indexOf(arguments[3])?i=arguments[3]:arguments[3]&&-1==a.indexOf(arguments[3])&&(r=k(r,n)),i=i||"Identity-H",Pe.call(this,t,e,r,i)};var lr,fr=e.lineWidth||.200025,dr=y.__private__.getLineWidth=y.getLineWidth=function(){return fr},pr=y.__private__.setLineWidth=y.setLineWidth=function(t){return fr=t,lt(O(U(t))+" w"),this};y.__private__.setLineDash=E.API.setLineDash=E.API.setLineDashPattern=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map((function(t){return O(U(t))})).join(" "),e=O(U(e)),lt("["+t+"] "+e+" d"),this};var gr=y.__private__.getLineHeight=y.getLineHeight=function(){return gt*lr};y.__private__.getLineHeight=y.getLineHeight=function(){return gt*lr};var mr=y.__private__.setLineHeightFactor=y.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(lr=t),this},vr=y.__private__.getLineHeightFactor=y.getLineHeightFactor=function(){return lr};mr(e.lineHeight);var br=y.__private__.getHorizontalCoordinate=function(t){return U(t)},yr=y.__private__.getVerticalCoordinate=function(t){return S===x.ADVANCED?t:Rt[$].mediaBox.topRightY-Rt[$].mediaBox.bottomLeftY-U(t)},wr=y.__private__.getHorizontalCoordinateString=y.getHorizontalCoordinateString=function(t){return O(br(t))},Nr=y.__private__.getVerticalCoordinateString=y.getVerticalCoordinateString=function(t){return O(yr(t))},Lr=e.strokeColor||"0 G";y.__private__.getStrokeColor=y.getDrawColor=function(){return ee(Lr)},y.__private__.setStrokeColor=y.setDrawColor=function(t,e,r,n){return Lr=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"draw",precision:2}),lt(Lr),this};var Ar=e.fillColor||"0 g";y.__private__.getFillColor=y.getFillColor=function(){return ee(Ar)},y.__private__.setFillColor=y.setFillColor=function(t,e,r,n){return Ar=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"fill",precision:2}),lt(Ar),this};var xr=e.textColor||"0 g",Sr=y.__private__.getTextColor=y.getTextColor=function(){return ee(xr)};y.__private__.setTextColor=y.setTextColor=function(t,e,r,n){return xr=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"text",precision:3}),this};var _r=e.charSpace,Pr=y.__private__.getCharSpace=y.getCharSpace=function(){return parseFloat(_r||0)};y.__private__.setCharSpace=y.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return _r=t,this};var kr=0;y.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},y.__private__.setLineCap=y.setLineCap=function(t){var e=y.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return kr=e,lt(e+" J"),this};var Ir=0;y.__private__.setLineJoin=y.setLineJoin=function(t){var e=y.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return Ir=e,lt(e+" j"),this},y.__private__.setLineMiterLimit=y.__private__.setMiterLimit=y.setLineMiterLimit=y.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");return lt(O(U(t))+" M"),this},y.GState=j,y.setGState=function(t){(t="string"==typeof t?Mt[Et[t]]:Fr(null,t)).equals(qt)||(lt("/"+t.id+" gs"),qt=t)};var Fr=function(t,e){if(!t||!Et[t]){var r=!1;for(var n in Mt)if(Mt.hasOwnProperty(n)&&Mt[n].equals(e)){r=!0;break}if(r)e=Mt[n];else{var i="GS"+(Object.keys(Mt).length+1).toString(10);Mt[i]=e,e.id=i}return t&&(Et[t]=e.id),Tt.publish("addGState",e),e}};y.addGState=function(t,e){return Fr(t,e),this},y.saveGraphicsState=function(){return lt("q"),jt.push({key:St,size:gt,color:xr}),this},y.restoreGraphicsState=function(){lt("Q");var t=jt.pop();return St=t.key,gt=t.size,xr=t.color,qt=null,this},y.setCurrentTransformationMatrix=function(t){return lt(t.toString()+" cm"),this},y.comment=function(t){return lt("#"+t),this};var Cr=function(t,e){var r=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var n=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},jr=function(t,e,r,n){Cr.call(this,t,e),this.type="rect";var i=r||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var a=n||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return a},set:function(t){isNaN(t)||(a=parseFloat(t))}}),this},Or=function(){this.page=Dt,this.currentPage=$,this.pages=ot.slice(0),this.pagesContext=Rt.slice(0),this.x=Pt,this.y=kt,this.matrix=It,this.width=qr($),this.height=Rr($),this.outputDestination=ct,this.id="",this.objectNumber=-1};Or.prototype.restore=function(){Dt=this.page,$=this.currentPage,Rt=this.pagesContext,ot=this.pages,Pt=this.x,kt=this.y,It=this.matrix,Dr($,this.width),Tr($,this.height),ct=this.outputDestination};var Br=function(t,e,r,n,i){Wt.push(new Or),Dt=$=0,ot=[],Pt=t,kt=e,It=i,je([r,n])},Mr=function(t){if(Ht[t])Wt.pop().restore();else{var e=new Or,r="Xo"+(Object.keys(zt).length+1).toString(10);e.id=r,Ht[t]=r,zt[r]=e,Tt.publish("addFormObject",e),Wt.pop().restore()}};for(var Er in y.beginFormObject=function(t,e,r,n,i){return Br(t,e,r,n,i),this},y.endFormObject=function(t){return Mr(t),this},y.doFormObject=function(t,e){var r=zt[Ht[t]];return lt("q"),lt(e.toString()+" cm"),lt("/"+r.id+" Do"),lt("Q"),this},y.getFormObject=function(t){var e=zt[Ht[t]];return{x:e.x,y:e.y,width:e.width,height:e.height,matrix:e.matrix}},y.save=function(t,e){return t=t||"generated.pdf",(e=e||{}).returnPromise=e.returnPromise||!1,!1===e.returnPromise?(l(We(He()),t),"function"==typeof l.unload&&n.setTimeout&&setTimeout(l.unload,911),this):new Promise((function(e,r){try{var i=l(We(He()),t);"function"==typeof l.unload&&n.setTimeout&&setTimeout(l.unload,911),e(i)}catch(t){r(t.message)}}))},E.API)E.API.hasOwnProperty(Er)&&("events"===Er&&E.API.events.length?function(t,e){var r,n,i;for(i=e.length-1;-1!==i;i--)r=e[i][0],n=e[i][1],t.subscribe.apply(t,[r].concat("function"==typeof n?[n]:n))}(Tt,E.API.events):y[Er]=E.API[Er]);var qr=y.getPageWidth=function(t){return(Rt[t=t||$].mediaBox.topRightX-Rt[t].mediaBox.bottomLeftX)/_t},Dr=y.setPageWidth=function(t,e){Rt[t].mediaBox.topRightX=e*_t+Rt[t].mediaBox.bottomLeftX},Rr=y.getPageHeight=function(t){return(Rt[t=t||$].mediaBox.topRightY-Rt[t].mediaBox.bottomLeftY)/_t},Tr=y.setPageHeight=function(t,e){Rt[t].mediaBox.topRightY=e*_t+Rt[t].mediaBox.bottomLeftY};return y.internal={pdfEscape:Ce,getStyle:tr,getFont:hr,getFontSize:vt,getCharSpace:Pr,getTextColor:Sr,getLineHeight:gr,getLineHeightFactor:vr,getLineWidth:dr,write:ft,getHorizontalCoordinate:br,getVerticalCoordinate:yr,getCoordinateString:wr,getVerticalCoordinateString:Nr,collections:{},newObject:Xt,newAdditionalObject:$t,newObjectDeferred:Kt,newObjectDeferredBegin:Zt,getFilters:ne,putStream:ie,events:Tt,scaleFactor:_t,pageSize:{getWidth:function(){return qr($)},setWidth:function(t){Dr($,t)},getHeight:function(){return Rr($)},setHeight:function(t){Tr($,t)}},encryptionOptions:m,encryption:Ye,getEncryptor:Je,output:Ve,getNumberOfPages:Ee,pages:ot,out:lt,f2:R,f3:T,getPageInfo:Xe,getPageInfoByObjId:Ke,getCurrentPageInfo:Ze,getPDFVersion:N,Point:Cr,Rectangle:jr,Matrix:Vt,hasHotfix:Ge},Object.defineProperty(y.internal.pageSize,"width",{get:function(){return qr($)},set:function(t){Dr($,t)},enumerable:!0,configurable:!0}),Object.defineProperty(y.internal.pageSize,"height",{get:function(){return Rr($)},set:function(t){Tr($,t)},enumerable:!0,configurable:!0}),ke.call(y,pt),St="F1",Oe(s,i),Tt.publish("initialized"),y}I.prototype.lsbFirstWord=function(t){return String.fromCharCode(t>>0&255,t>>8&255,t>>16&255,t>>24&255)},I.prototype.toHexString=function(t){return t.split("").map((function(t){return("0"+(255&t.charCodeAt(0)).toString(16)).slice(-2)})).join("")},I.prototype.hexToBytes=function(t){for(var e=[],r=0;r<t.length;r+=2)e.push(String.fromCharCode(parseInt(t.substr(r,2),16)));return e.join("")},I.prototype.processOwnerPassword=function(t,e){return P(x(e).substr(0,5),t)},I.prototype.encryptor=function(t,e){var r=x(this.encryptionKey+String.fromCharCode(255&t,t>>8&255,t>>16&255,255&e,e>>8&255)).substr(0,10);return function(t){return P(r,t)}},j.prototype.equals=function(e){var r,n="id,objectNumber,equals";if(!e||__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)!==__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(this))return!1;var i=0;for(r in this)if(!(n.indexOf(r)>=0)){if(this.hasOwnProperty(r)&&!e.hasOwnProperty(r))return!1;if(this[r]!==e[r])return!1;i++}for(r in e)e.hasOwnProperty(r)&&n.indexOf(r)<0&&i--;return 0===i},E.API={events:[]},E.version="2.5.2";var q=E.API,D=1,R=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},T=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},U=function(t){return t.toFixed(2)},z=function(t){return t.toFixed(5)};q.__acroform__={};var H=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},W=function(t){return t*D},V=function(t){var e=new ut,r=At.internal.getHeight(t)||0,n=At.internal.getWidth(t)||0;return e.BBox=[0,0,Number(U(n)),Number(U(r))],e},G=q.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},Y=q.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},J=q.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},X=q.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return J(t,e-1)},K=q.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return G(t,e-1)},Z=q.__acroform__.clearBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return Y(t,e-1)},$=q.__acroform__.calculateCoordinates=function(t,e){var r=e.internal.getHorizontalCoordinate,n=e.internal.getVerticalCoordinate,i=t[0],a=t[1],o=t[2],s=t[3],c={};return c.lowerLeft_X=r(i)||0,c.lowerLeft_Y=n(a+s)||0,c.upperRight_X=r(i+o)||0,c.upperRight_Y=n(a)||0,[Number(U(c.lowerLeft_X)),Number(U(c.lowerLeft_Y)),Number(U(c.upperRight_X)),Number(U(c.upperRight_Y))]},Q=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],r=t._V||t.DV,n=tt(t,r),i=t.scope.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(t.scope.__private__.encodeColorString(t.color)),e.push("/"+i+" "+U(n.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(n.text),e.push("ET"),e.push("Q"),e.push("EMC");var a=V(t);return a.scope=t.scope,a.stream=e.join("\n"),a}},tt=function(t,e){var r=0===t.fontSize?t.maxFontSize:t.fontSize,n={text:"",fontSize:""},i=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" ");i=t.multiline?i.map((function(t){return t.split("\n")})):i.map((function(t){return[t]}));var a=r,o=At.internal.getHeight(t)||0;o=o<0?-o:o;var s=At.internal.getWidth(t)||0;s=s<0?-s:s;var c=function(e,r,n){if(e+1<i.length){var a=r+" "+i[e+1][0];return et(a,t,n).width<=s-4}return!1};a++;t:for(;a>0;){e="",a--;var u,h,l=et("3",t,a).height,f=t.multiline?o-a:(o-l)/2,d=f+=2,p=0,g=0,m=0;if(a<=0){e="(...) Tj\n",e+="% Width of Text: "+et(e,t,a=12).width+", FieldWidth:"+s+"\n";break}for(var v="",b=0,y=0;y<i.length;y++)if(i.hasOwnProperty(y)){var w=!1;if(1!==i[y].length&&m!==i[y].length-1){if((l+2)*(b+2)+2>o)continue t;v+=i[y][m],w=!0,g=y,y--}else{v=" "==(v+=i[y][m]+" ").substr(v.length-1)?v.substr(0,v.length-1):v;var N=parseInt(y),L=c(N,v,a),A=y>=i.length-1;if(L&&!A){v+=" ",m=0;continue}if(L||A){if(A)g=N;else if(t.multiline&&(l+2)*(b+2)+2>o)continue t}else{if(!t.multiline)continue t;if((l+2)*(b+2)+2>o)continue t;g=N}}for(var x="",S=p;S<=g;S++){var _=i[S];if(t.multiline){if(S===g){x+=_[m]+" ",m=(m+1)%_.length;continue}if(S===p){x+=_[_.length-1]+" ";continue}}x+=_[0]+" "}switch(x=" "==x.substr(x.length-1)?x.substr(0,x.length-1):x,h=et(x,t,a).width,t.textAlign){case"right":u=s-h-2;break;case"center":u=(s-h)/2;break;case"left":default:u=2}e+=U(u)+" "+U(d)+" Td\n",e+="("+R(x)+") Tj\n",e+=-U(u)+" 0 Td\n",d=-(a+2),h=0,p=w?g:g+1,b++,v=""}else;break}return n.text=e,n.fontSize=a,n},et=function(t,e,r){var n=e.scope.internal.getFont(e.fontName,e.fontStyle),i=e.scope.getStringUnitWidth(t,{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r);return{height:e.scope.getStringUnitWidth("3",{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r)*1.5,width:i}},rt={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},nt=function(t,e){var r={type:"reference",object:t};void 0===e.internal.getPageInfo(t.page).pageContext.annotations.find((function(t){return t.type===r.type&&t.object===r.object}))&&e.internal.getPageInfo(t.page).pageContext.annotations.push(r)},it=function(e,r){for(var n in e)if(e.hasOwnProperty(n)){var i=n,a=e[n];r.internal.newObjectDeferredBegin(a.objId,!0),"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(a)&&"function"==typeof a.putStream&&a.putStream(),delete e[i]}},at=function(e,r){if(r.scope=e,void 0!==e.internal&&(void 0===e.internal.acroformPlugin||!1===e.internal.acroformPlugin.isInitialized)){if(lt.FieldNum=0,e.internal.acroformPlugin=JSON.parse(JSON.stringify(rt)),e.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");D=e.internal.scaleFactor,e.internal.acroformPlugin.acroFormDictionaryRoot=new ht,e.internal.acroformPlugin.acroFormDictionaryRoot.scope=e,e.internal.acroformPlugin.acroFormDictionaryRoot._eventID=e.internal.events.subscribe("postPutResources",(function(){!function(t){t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID,t.internal.acroformPlugin.printedOut=!0}(e)})),e.internal.events.subscribe("buildDocument",(function(){!function(t){t.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var e=t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var r in e)if(e.hasOwnProperty(r)){var n=e[r];n.objId=void 0,n.hasAnnotation&&nt(n,t)}}(e)})),e.internal.events.subscribe("putCatalog",(function(){!function(t){if(void 0===t.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");t.internal.write("/AcroForm "+t.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")}(e)})),e.internal.events.subscribe("postPutPages",(function(r){!function(e,r){var n=!e;for(var i in e||(r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()),e=e||r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if(e.hasOwnProperty(i)){var a=e[i],o=[],s=a.Rect;if(a.Rect&&(a.Rect=$(a.Rect,r)),r.internal.newObjectDeferredBegin(a.objId,!0),a.DA=At.createDefaultAppearanceStream(a),"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(a)&&"function"==typeof a.getKeyValueListForStream&&(o=a.getKeyValueListForStream()),a.Rect=s,a.hasAppearanceStream&&!a.appearanceStreamContent){var c=Q(a);o.push({key:"AP",value:"<</N "+c+">>"}),r.internal.acroformPlugin.xForms.push(c)}if(a.appearanceStreamContent){var u="";for(var h in a.appearanceStreamContent)if(a.appearanceStreamContent.hasOwnProperty(h)){var l=a.appearanceStreamContent[h];if(u+="/"+h+" ",u+="<<",Object.keys(l).length>=1||Array.isArray(l)){for(var i in l)if(l.hasOwnProperty(i)){var f=l[i];"function"==typeof f&&(f=f.call(r,a)),u+="/"+i+" "+f+" ",r.internal.acroformPlugin.xForms.indexOf(f)>=0||r.internal.acroformPlugin.xForms.push(f)}}else"function"==typeof(f=l)&&(f=f.call(r,a)),u+="/"+i+" "+f,r.internal.acroformPlugin.xForms.indexOf(f)>=0||r.internal.acroformPlugin.xForms.push(f);u+=">>"}o.push({key:"AP",value:"<<\n"+u+">>"})}r.internal.putStream({additionalKeyValues:o,objectId:a.objId}),r.internal.out("endobj")}n&&it(r.internal.acroformPlugin.xForms,r)}(r,e)})),e.internal.acroformPlugin.isInitialized=!0}},ot=q.__acroform__.arrayToPdfArray=function(e,r,n){var i=function(t){return t};if(Array.isArray(e)){for(var a="[",o=0;o<e.length;o++)switch(0!==o&&(a+=" "),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e[o])){case"boolean":case"number":case"object":a+=e[o].toString();break;case"string":"/"!==e[o].substr(0,1)?(void 0!==r&&n&&(i=n.internal.getEncryptor(r)),a+="("+R(i(e[o].toString()))+")"):a+=e[o].toString()}return a+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var st=function(t,e,r){var n=function(t){return t};return void 0!==e&&r&&(n=r.internal.getEncryptor(e)),(t=t||"").toString(),t="("+R(n(t))+")"},ct=function(){this._objId=void 0,this._scope=void 0,Object.defineProperty(this,"objId",{get:function(){if(void 0===this._objId){if(void 0===this.scope)return;this._objId=this.scope.internal.newObjectDeferred()}return this._objId},set:function(t){this._objId=t}}),Object.defineProperty(this,"scope",{value:this._scope,writable:!0})};ct.prototype.toString=function(){return this.objId+" 0 R"},ct.prototype.putStream=function(){var t=this.getKeyValueListForStream();this.scope.internal.putStream({data:this.stream,additionalKeyValues:t,objectId:this.objId}),this.scope.internal.out("endobj")},ct.prototype.getKeyValueListForStream=function(){var t=[],e=Object.getOwnPropertyNames(this).filter((function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"scope"!=t&&"objId"!=t&&"_"!=t.substring(0,1)}));for(var r in e)if(!1===Object.getOwnPropertyDescriptor(this,e[r]).configurable){var n=e[r],i=this[n];i&&(Array.isArray(i)?t.push({key:n,value:ot(i,this.objId,this.scope)}):i instanceof ct?(i.scope=this.scope,t.push({key:n,value:i.objId+" 0 R"})):"function"!=typeof i&&t.push({key:n,value:i}))}return t};var ut=function(){ct.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writable:!0});var t,e=[];Object.defineProperty(this,"BBox",{configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(e){t=e.trim()},get:function(){return t||null}})};H(ut,ct);var ht=function(){ct.call(this);var t,e=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return e.length>0?e:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return e}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(t){var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+R(e(t))+")"}},set:function(e){t=e}})};H(ht,ct);var lt=function t(){ct.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(e,3))},set:function(t){!0===Boolean(t)?this.F=K(e,3):this.F=Z(e,3)}});var r=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');r=t}});var n=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==n.length)return n},set:function(t){n=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[0])?0:n[0]},set:function(t){n[0]=t}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[1])?0:n[1]},set:function(t){n[1]=t}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[2])?0:n[2]},set:function(t){n[2]=t}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[3])?0:n[3]},set:function(t){n[3]=t}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var a=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!a||a.length<1){if(this instanceof yt)return;a="FieldObject"+__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a.FieldNum++}var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+R(e(a))+")"},set:function(t){a=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return a},set:function(t){a=t}});var o="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return o},set:function(t){o=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var c=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return c},set:function(t){c=t}});var u=void 0;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return void 0===u?50/D:u},set:function(t){u=t}});var h="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return h},set:function(t){h=t}});var l="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!l||this instanceof yt||this instanceof Nt))return st(l,this.objId,this.scope)},set:function(t){t=t.toString(),l=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof mt==!1?st(f,this.objId,this.scope):f},set:function(t){t=t.toString(),f=this instanceof mt==!1?"("===t.substr(0,1)?T(t.substr(1,t.length-2)):T(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof mt==!0?T(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof mt==!0?"/"+t:t}});var d=null;Object.defineProperty(this,"_V",{enumerable:!1,configurable:!1,get:function(){if(d)return d},set:function(t){this.V=t}}),Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(d)return this instanceof mt==!1?st(d,this.objId,this.scope):d},set:function(t){t=t.toString(),d=this instanceof mt==!1?"("===t.substr(0,1)?T(t.substr(1,t.length-2)):T(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof mt==!0?T(d.substr(1,d.length-1)):d},set:function(t){t=t.toString(),d=this instanceof mt==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var p,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,get:function(){if(p)return p},set:function(t){p=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,1):this.Ff=Z(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,2):this.Ff=Z(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,3):this.Ff=Z(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t;switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};H(lt,ct);var ft=function(){lt.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var t=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){t=e}});var e=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return ot(e,this.objId,this.scope)},set:function(t){var r,n;n=[],"string"==typeof(r=t)&&(n=function(t,e,r){r||(r=1);for(var n,i=[];n=e.exec(t);)i.push(n[r]);return i}(r,/\((.*?)\)/g)),e=n}}),this.getOptions=function(){return e},this.setOptions=function(t){e=t,this.sort&&e.sort()},this.addOption=function(t){t=(t=t||"").toString(),e.push(t),this.sort&&e.sort()},this.removeOption=function(t,r){for(r=r||!1,t=(t=t||"").toString();-1!==e.indexOf(t)&&(e.splice(e.indexOf(t),1),!1!==r););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,18):this.Ff=Z(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=K(this.Ff,19):this.Ff=Z(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=K(this.Ff,20),e.sort()):this.Ff=Z(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,22):this.Ff=Z(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,23):this.Ff=Z(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,27):this.Ff=Z(this.Ff,27)}}),this.hasAppearanceStream=!1};H(ft,lt);var dt=function(){ft.call(this),this.fontName="helvetica",this.combo=!1};H(dt,ft);var pt=function(){dt.call(this),this.combo=!0};H(pt,dt);var gt=function(){pt.call(this),this.edit=!0};H(gt,pt);var mt=function(){lt.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,15):this.Ff=Z(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,16):this.Ff=Z(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,17):this.Ff=Z(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,26):this.Ff=Z(this.Ff,26)}});var e,r={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};if(this.scope&&(t=this.scope.internal.getEncryptor(this.objId)),0!==Object.keys(r).length){var e,n=[];for(e in n.push("<<"),r)n.push("/"+e+" ("+R(t(r[e]))+")");return n.push(">>"),n.join("\n")}},set:function(e){"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)&&(r=e)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return r.CA||""},set:function(t){"string"==typeof t&&(r.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t}})};H(mt,lt);var vt=function(){mt.call(this),this.pushButton=!0};H(vt,mt);var bt=function(){mt.call(this),this.radio=!0,this.pushButton=!1;var t=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=void 0!==e?e:[]}})};H(bt,mt);var yt=function(){var e,r;lt.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return r},set:function(t){r=t}});var n,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};this.scope&&(t=this.scope.internal.getEncryptor(this.objId));var e,r=[];for(e in r.push("<<"),i)r.push("/"+e+" ("+R(t(i[e]))+")");return r.push(">>"),r.join("\n")},set:function(e){"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)&&(i=e)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return n.substr(1,n.length-1)},set:function(t){n="/"+t}}),this.caption="l",this.appearanceState="Off",this._AppearanceType=At.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(this.optionName)};H(yt,lt),bt.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t)||!("getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var r=this.Kids[e];r.appearanceStreamContent=t.createAppearanceStream(r.optionName),r.caption=t.getCA()}},bt.prototype.createOption=function(t){var e=new yt;return e.Parent=this,e.optionName=t,this.Kids.push(e),xt.call(this.scope,e),e};var wt=function(){mt.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=At.CheckBox.createAppearanceStream()};H(wt,mt);var Nt=function(){lt.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,13):this.Ff=Z(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,21):this.Ff=Z(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,23):this.Ff=Z(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,24):this.Ff=Z(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,25):this.Ff=Z(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,26):this.Ff=Z(this.Ff,26)}});var t=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){Number.isInteger(e)&&(t=e)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};H(Nt,lt);var Lt=function(){Nt.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,14):this.Ff=Z(this.Ff,14)}}),this.password=!0};H(Lt,Nt);var At={CheckBox:{createAppearanceStream:function(){return{N:{On:At.CheckBox.YesNormal},D:{On:At.CheckBox.YesPushDown,Off:At.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=t.scope.internal.getFont(t.fontName,t.fontStyle).id,i=t.scope.__private__.encodeColorString(t.color),a=tt(t,t.caption);return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),r.push("BMC"),r.push("q"),r.push("0 0 1 rg"),r.push("/"+n+" "+U(a.fontSize)+" Tf "+i),r.push("BT"),r.push(a.text),r.push("ET"),r.push("Q"),r.push("EMC"),e.stream=r.join("\n"),e},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=t.scope.internal.getFont(t.fontName,t.fontStyle).id,n=t.scope.__private__.encodeColorString(t.color),i=[],a=At.internal.getHeight(t),o=At.internal.getWidth(t),s=tt(t,t.caption);return i.push("1 g"),i.push("0 0 "+U(o)+" "+U(a)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+U(o-1)+" "+U(a-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+r+" "+U(s.fontSize)+" Tf "+n),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:At.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=At.RadioButton.Circle.YesNormal,e.D[t]=At.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=At.internal.Bezier_C,a=Number((n*i).toFixed(5));return r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+a+" "+a+" "+n+" 0 "+n+" c"),r.push("-"+a+" "+n+" -"+n+" "+a+" -"+n+" 0 c"),r.push("-"+n+" -"+a+" -"+a+" -"+n+" 0 -"+n+" c"),r.push(a+" -"+n+" "+n+" -"+a+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*At.internal.Bezier_C).toFixed(5)),o=Number((n*At.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),r.push("0 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+o+" "+o+" "+n+" 0 "+n+" c"),r.push("-"+o+" "+n+" -"+n+" "+o+" -"+n+" 0 c"),r.push("-"+n+" -"+o+" -"+o+" -"+n+" 0 -"+n+" c"),r.push(o+" -"+n+" "+n+" -"+o+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*At.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:At.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=At.RadioButton.Cross.YesNormal,e.D[t]=At.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.calculateCross(t);return r.push("q"),r.push("1 1 "+U(At.internal.getWidth(t)-2)+" "+U(At.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(U(n.x1.x)+" "+U(n.x1.y)+" m"),r.push(U(n.x2.x)+" "+U(n.x2.y)+" l"),r.push(U(n.x4.x)+" "+U(n.x4.y)+" m"),r.push(U(n.x3.x)+" "+U(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=At.internal.calculateCross(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),n.push("f"),n.push("q"),n.push("1 1 "+U(At.internal.getWidth(t)-2)+" "+U(At.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(U(r.x1.x)+" "+U(r.x1.y)+" m"),n.push(U(r.x2.x)+" "+U(r.x2.y)+" l"),n.push(U(r.x4.x)+" "+U(r.x4.y)+" m"),n.push(U(r.x3.x)+" "+U(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=t.scope.internal.getFont(t.fontName,t.fontStyle).id,r=t.scope.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+r}};At.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=At.internal.getWidth(t),r=At.internal.getHeight(t),n=Math.min(e,r);return{x1:{x:(e-n)/2,y:(r-n)/2+n},x2:{x:(e-n)/2+n,y:(r-n)/2},x3:{x:(e-n)/2,y:(r-n)/2},x4:{x:(e-n)/2+n,y:(r-n)/2+n}}}},At.internal.getWidth=function(e){var r=0;return"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)&&(r=W(e.Rect[2])),r},At.internal.getHeight=function(e){var r=0;return"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)&&(r=W(e.Rect[3])),r};var xt=q.addField=function(t){if(at(this,t),!(t instanceof lt))throw new Error("Invalid argument passed to jsPDF.addField.");var e;return(e=t).scope.internal.acroformPlugin.printedOut&&(e.scope.internal.acroformPlugin.printedOut=!1,e.scope.internal.acroformPlugin.acroFormDictionaryRoot=null),e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e),t.page=t.scope.internal.getCurrentPageInfo().pageNumber,this};q.AcroFormChoiceField=ft,q.AcroFormListBox=dt,q.AcroFormComboBox=pt,q.AcroFormEditBox=gt,q.AcroFormButton=mt,q.AcroFormPushButton=vt,q.AcroFormRadioButton=bt,q.AcroFormCheckBox=wt,q.AcroFormTextField=Nt,q.AcroFormPasswordField=Lt,q.AcroFormAppearance=At,q.AcroForm={ChoiceField:ft,ListBox:dt,ComboBox:pt,EditBox:gt,Button:mt,PushButton:vt,RadioButton:bt,CheckBox:wt,TextField:Nt,PasswordField:Lt,Appearance:At},E.AcroForm={ChoiceField:ft,ListBox:dt,ComboBox:pt,EditBox:gt,Button:mt,PushButton:vt,RadioButton:bt,CheckBox:wt,TextField:Nt,PasswordField:Lt,Appearance:At};var St=E.AcroForm;function _t(t){return t.reduce((function(t,e,r){return t[e]=r,t}),{})}!function(e){e.__addimage__={};var r="UNKNOWN",n={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0],[255,216,255,219],[255,216,255,238]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],WEBP:[[82,73,70,70,void 0,void 0,void 0,void 0,87,69,66,80]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},i=e.__addimage__.getImageFileTypeByImageData=function(t,e){var i,a,o,s,c,u=r;if("RGBA"===(e=e||r)||void 0!==t.data&&t.data instanceof Uint8ClampedArray&&"height"in t&&"width"in t)return"RGBA";if(x(t))for(c in n)for(o=n[c],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t[a]){s=!1;break}if(!0===s){u=c;break}}else for(c in n)for(o=n[c],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t.charCodeAt(a)){s=!1;break}if(!0===s){u=c;break}}return u===r&&e!==r&&(u=e),u},a=function t(e){for(var r=this.internal.write,n=this.internal.putStream,i=(0,this.internal.getFilters)();-1!==i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"),1);e.objectId=this.internal.newObject();var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.width}),a.push({key:"Height",value:e.height}),e.colorSpace===b.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.palette.length/3-1)+" "+("sMask"in e&&void 0!==e.sMask?e.objectId+2:e.objectId+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.colorSpace}),e.colorSpace===b.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bitsPerComponent}),"decodeParameters"in e&&void 0!==e.decodeParameters&&a.push({key:"DecodeParms",value:"<<"+e.decodeParameters+">>"}),"transparency"in e&&Array.isArray(e.transparency)){for(var o="",s=0,c=e.transparency.length;s<c;s++)o+=e.transparency[s]+" "+e.transparency[s]+" ";a.push({key:"Mask",value:"["+o+"]"})}void 0!==e.sMask&&a.push({key:"SMask",value:e.objectId+1+" 0 R"});var u=void 0!==e.filter?["/"+e.filter]:void 0;if(n({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u,objectId:e.objectId}),r("endobj"),"sMask"in e&&void 0!==e.sMask){var h="/Predictor "+e.predictor+" /Colors 1 /BitsPerComponent "+e.bitsPerComponent+" /Columns "+e.width,l={width:e.width,height:e.height,colorSpace:"DeviceGray",bitsPerComponent:e.bitsPerComponent,decodeParameters:h,data:e.sMask};"filter"in e&&(l.filter=e.filter),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a.call(this,l)}if(e.colorSpace===b.INDEXED){var f=this.internal.newObject();n({data:_(new Uint8Array(e.palette)),objectId:f}),r("endobj")}},o=function(){var t=this.internal.collections.addImage_images;for(var e in t)a.call(this,t[e])},s=function(){var t,e=this.internal.collections.addImage_images,r=this.internal.write;for(var n in e)r("/I"+(t=e[n]).index,t.objectId,"0","R")},c=function(){this.internal.collections.addImage_images||(this.internal.collections.addImage_images={},this.internal.events.subscribe("putResources",o),this.internal.events.subscribe("putXobjectDict",s))},h=function(){var t=this.internal.collections.addImage_images;return c.call(this),t},l=function(){return Object.keys(this.internal.collections.addImage_images).length},f=function(t){return"function"==typeof e["process"+t.toUpperCase()]},d=function(e){return"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)&&1===e.nodeType},p=function(t,r){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return u(unescape(n).split("base64,").pop());var i=e.loadFile(n,!0);if(void 0!==i)return i}if("CANVAS"===t.nodeName){if(0===t.width||0===t.height)throw new Error("Given canvas must have data. Canvas width: "+t.width+", height: "+t.height);var a;switch(r){case"PNG":a="image/png";break;case"WEBP":a="image/webp";break;case"JPEG":case"JPG":default:a="image/jpeg"}return u(t.toDataURL(a,1).split("base64,").pop())}},g=function(t){var e=this.internal.collections.addImage_images;if(e)for(var r in e)if(t===e[r].alias)return e[r]},m=function(t,e,r){return t||e||(t=-96,e=-96),t<0&&(t=-1*r.width*72/t/this.internal.scaleFactor),e<0&&(e=-1*r.height*72/e/this.internal.scaleFactor),0===t&&(t=e*r.width/r.height),0===e&&(e=t*r.height/r.width),[t,e]},v=function(t,e,r,n,i,a){var o=m.call(this,r,n,i),s=this.internal.getCoordinateString,c=this.internal.getVerticalCoordinateString,u=h.call(this);if(r=o[0],n=o[1],u[i.index]=i,a){a*=Math.PI/180;var l=Math.cos(a),f=Math.sin(a),d=function(t){return t.toFixed(4)},p=[d(l),d(f),d(-1*f),d(l),0,0,"cm"]}this.internal.write("q"),a?(this.internal.write([1,"0","0",1,s(t),c(e+n),"cm"].join(" ")),this.internal.write(p.join(" ")),this.internal.write([s(r),"0","0",s(n),"0","0","cm"].join(" "))):this.internal.write([s(r),"0","0",s(n),s(t),c(e+n),"cm"].join(" ")),this.isAdvancedAPI()&&this.internal.write([1,0,0,-1,0,0,"cm"].join(" ")),this.internal.write("/I"+i.index+" Do"),this.internal.write("Q")},b=e.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"};e.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"};var y=e.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},w=e.__addimage__.sHashCode=function(t){var e,r,n=0;if("string"==typeof t)for(r=t.length,e=0;e<r;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;else if(x(t))for(r=t.byteLength/2,e=0;e<r;e++)n=(n<<5)-n+t[e],n|=0;return n},N=e.__addimage__.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2))&&(e=!1),e},L=e.__addimage__.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),r=null;if(2===e.length){var n=/^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e[0]);Array.isArray(n)&&(r={mimeType:n[1],charset:n[2],data:e[1]})}return r},A=e.__addimage__.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array};e.__addimage__.isArrayBuffer=function(t){return A()&&t instanceof ArrayBuffer};var x=e.__addimage__.isArrayBufferView=function(t){return A()&&"undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array)},S=e.__addimage__.binaryStringToUint8Array=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r},_=e.__addimage__.arrayBufferToBinaryString=function(t){for(var e="",r=x(t)?t:new Uint8Array(t),n=0;n<r.length;n+=8192)e+=String.fromCharCode.apply(null,r.subarray(n,n+8192));return e};e.addImage=function(){var e,n,i,a,o,s,u,h,l;if("number"==typeof arguments[1]?(n=r,i=arguments[1],a=arguments[2],o=arguments[3],s=arguments[4],u=arguments[5],h=arguments[6],l=arguments[7]):(n=arguments[1],i=arguments[2],a=arguments[3],o=arguments[4],s=arguments[5],u=arguments[6],h=arguments[7],l=arguments[8]),"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e=arguments[0])&&!d(e)&&"imageData"in e){var f=e;e=f.imageData,n=f.format||n||r,i=f.x||i||0,a=f.y||a||0,o=f.w||f.width||o,s=f.h||f.height||s,u=f.alias||u,h=f.compression||h,l=f.rotation||f.angle||l}var p=this.internal.getFilters();if(void 0===h&&-1!==p.indexOf("FlateEncode")&&(h="SLOW"),isNaN(i)||isNaN(a))throw new Error("Invalid coordinates passed to jsPDF.addImage");c.call(this);var g=P.call(this,e,n,u,h);return v.call(this,i,a,o,s,g,l),this};var P=function(t,n,a,o){var s,c,u;if("string"==typeof t&&i(t)===r){t=unescape(t);var h=k(t,!1);(""!==h||void 0!==(h=e.loadFile(t,!0)))&&(t=h)}if(d(t)&&(t=p(t,n)),n=i(t,n),!f(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if((null==(u=a)||0===u.length)&&(a=function(t){return"string"==typeof t||x(t)?w(t):x(t.data)?w(t.data):null}(t)),(s=g.call(this,a))||(A()&&(t instanceof Uint8Array||"RGBA"===n||(c=t,t=S(t))),s=this["process"+n.toUpperCase()](t,l.call(this),a,function(t){return t&&"string"==typeof t&&(t=t.toUpperCase()),t in e.image_compression?t:y.NONE}(o),c)),!s)throw new Error("An unknown error occurred whilst processing the image.");return s},k=e.__addimage__.convertBase64ToBinaryString=function(t,e){var r;e="boolean"!=typeof e||e;var n,i="";if("string"==typeof t){n=null!==(r=L(t))?r.data:t;try{i=u(n)}catch(t){if(e)throw N(n)?new Error("atob-Error in jsPDF.convertBase64ToBinaryString "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ")}}return i};e.getImageProperties=function(t){var n,a,o="";if(d(t)&&(t=p(t)),"string"==typeof t&&i(t)===r&&(""===(o=k(t,!1))&&(o=e.loadFile(t)||""),t=o),a=i(t),!f(a))throw new Error("addImage does not support files of type '"+a+"', please ensure that a plugin for '"+a+"' support is added.");if(!A()||t instanceof Uint8Array||(t=S(t)),!(n=this["process"+a.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return n.fileType=a,n}}(E.API),
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(t){if(void 0!==t&&""!=t)return!0};E.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var r,n,i,a=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,s=this.internal.getPageInfoByObjId(t.objId),c=t.pageContext.annotations,u=!1,h=0;h<c.length&&!u;h++)switch((r=c[h]).type){case"link":(e(r.options.url)||e(r.options.pageNumber))&&(u=!0);break;case"reference":case"text":case"freetext":u=!0}if(0!=u){this.internal.write("/Annots [");for(var l=0;l<c.length;l++){r=c[l];var f=this.internal.pdfEscape,d=this.internal.getEncryptor(t.objId);switch(r.type){case"reference":this.internal.write(" "+r.object.objId+" 0 R ");break;case"text":var p=this.internal.newAdditionalObject(),g=this.internal.newAdditionalObject(),m=this.internal.getEncryptor(p.objId),v=r.title||"Note";i="<</Type /Annot /Subtype /Text "+(n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y)+"] ")+"/Contents ("+f(m(r.contents))+")",i+=" /Popup "+g.objId+" 0 R",i+=" /P "+s.objId+" 0 R",i+=" /T ("+f(m(v))+") >>",p.content=i;var b=p.objId+" 0 R";i="<</Type /Annot /Subtype /Popup "+(n="/Rect ["+a(r.bounds.x+30)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w+30)+" "+o(r.bounds.y)+"] ")+" /Parent "+b,r.open&&(i+=" /Open true"),i+=" >>",g.content=i,this.internal.write(p.objId,"0 R",g.objId,"0 R");break;case"freetext":n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y+r.bounds.h)+"] ";var y=r.color||"#000000";i="<</Type /Annot /Subtype /FreeText "+n+"/Contents ("+f(d(r.contents))+")",i+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+y+")",i+=" /Border [0 0 0]",i+=" >>",this.internal.write(i);break;case"link":if(r.options.name){var w=this.annotations._nameMap[r.options.name];r.options.pageNumber=w.page,r.options.top=w.y}else r.options.top||(r.options.top=0);if(n="/Rect ["+r.finalBounds.x+" "+r.finalBounds.y+" "+r.finalBounds.w+" "+r.finalBounds.h+"] ",i="",r.options.url)i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /A <</S /URI /URI ("+f(d(r.options.url))+") >>";else if(r.options.pageNumber){switch(i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(r.options.pageNumber).objId+" 0 R",r.options.magFactor=r.options.magFactor||"XYZ",r.options.magFactor){case"Fit":i+=" /Fit]";break;case"FitH":i+=" /FitH "+r.options.top+"]";break;case"FitV":r.options.left=r.options.left||0,i+=" /FitV "+r.options.left+"]";break;case"XYZ":default:var N=o(r.options.top);r.options.left=r.options.left||0,void 0===r.options.zoom&&(r.options.zoom=0),i+=" /XYZ "+r.options.left+" "+N+" "+r.options.zoom+"]"}}""!=i&&(i+=" >>",this.internal.write(i))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,r,n,i){var a=this.internal.getCurrentPageInfo(),o=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;a.pageContext.annotations.push({finalBounds:{x:o(t),y:s(e),w:o(t+r),h:s(e+n)},options:i,type:"link"})},t.textWithLink=function(t,e,r,n){var i,a,o=this.getTextWidth(t),s=this.internal.getLineHeight()/this.internal.scaleFactor;if(void 0!==n.maxWidth){a=n.maxWidth;var c=this.splitTextToSize(t,a).length;i=Math.ceil(s*c)}else a=o,i=s;return this.text(t,e,r,n),r+=.2*s,"center"===n.align&&(e-=o/2),"right"===n.align&&(e-=o),this.link(e,r-s,a,i,n),o},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor}}(E.API),
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},r={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},n={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},i=[1570,1571,1573,1575];t.__arabicParser__={};var a=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==e[t.charCodeAt(0)]},o=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},s=t.__arabicParser__.isArabicEndLetter=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length<=2},c=t.__arabicParser__.isArabicAlfLetter=function(t){return o(t)&&i.indexOf(t.charCodeAt(0))>=0};t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=1};var u=t.__arabicParser__.arabicLetterHasFinalForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=2};t.__arabicParser__.arabicLetterHasInitialForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=3};var h=t.__arabicParser__.arabicLetterHasMedialForm=function(t){return o(t)&&a(t)&&4==e[t.charCodeAt(0)].length},l=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=r,i="",a=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(a++,"number"==typeof(n=n[t.charCodeAt(e)])&&(i+=String.fromCharCode(n),n=r,a=0),e===t.length-1&&(n=r,i+=t.charAt(e-(a-1)),e-=a-1,a=0)):(n=r,i+=t.charAt(e-a),e-=a,a=0);return i};t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==n[t.charCodeAt(0)]};var f=t.__arabicParser__.getCorrectForm=function(t,e,r){return o(t)?!1===a(t)?-1:!u(t)||!o(e)&&!o(r)||!o(r)&&s(e)||s(t)&&!o(e)||s(t)&&c(e)||s(t)&&s(e)?0:h(t)&&o(e)&&!s(e)&&o(r)&&u(r)?3:s(t)||!o(r)?1:2:-1},d=function(t){var r=0,n=0,i=0,a="",s="",c="",u=(t=t||"").split("\\s+"),h=[];for(r=0;r<u.length;r+=1){for(h.push(""),n=0;n<u[r].length;n+=1)a=u[r][n],s=u[r][n-1],c=u[r][n+1],o(a)?(i=f(a,s,c),h[r]+=-1!==i?String.fromCharCode(e[a.charCodeAt(0)][i]):a):h[r]+=a;h[r]=l(h[r])}return h.join(" ")},p=t.__arabicParser__.processArabic=t.processArabic=function(){var t,e="string"==typeof arguments[0]?arguments[0]:arguments[0].text,r=[];if(Array.isArray(e)){var n=0;for(r=[],n=0;n<e.length;n+=1)Array.isArray(e[n])?r.push([d(e[n][0]),e[n][1],e[n][2]]):r.push([d(e[n])]);t=r}else t=d(e);return"string"==typeof arguments[0]?t:(arguments[0].text=t,arguments[0])};t.events.push(["preProcessText",p])}(E.API),E.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",(function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")})),this.internal.events.subscribe("putCatalog",(function(){this.internal.out("/OpenAction "+e+" 0 R")}))}return this},
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(){var t=void 0;Object.defineProperty(this,"pdf",{get:function(){return t},set:function(e){t=e}});var e=150;Object.defineProperty(this,"width",{get:function(){return e},set:function(t){e=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=e+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var n=[];Object.defineProperty(this,"childNodes",{get:function(){return n},set:function(t){n=t}});var i={};Object.defineProperty(this,"style",{get:function(){return i},set:function(t){i=t}}),Object.defineProperty(this,"parentNode",{})};e.prototype.getContext=function(t,e){var r;if("2d"!==(t=t||"2d"))return null;for(r in e)this.pdf.context2d.hasOwnProperty(r)&&(this.pdf.context2d[r]=e[r]);return this.pdf.context2d._canvas=this,this.pdf.context2d},e.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},t.events.push(["initialized",function(){this.canvas=new e,this.canvas.pdf=this}])}(E.API),function(e){var r={left:0,top:0,bottom:0,right:0},n=!1,i=function(){void 0===this.internal.__cell__&&(this.internal.__cell__={},this.internal.__cell__.padding=3,this.internal.__cell__.headerFunction=void 0,this.internal.__cell__.margins=Object.assign({},r),this.internal.__cell__.margins.width=this.getPageWidth(),a.call(this))},a=function(){this.internal.__cell__.lastCell=new o,this.internal.__cell__.pages=1},o=function(){var t=arguments[0];Object.defineProperty(this,"x",{enumerable:!0,get:function(){return t},set:function(e){t=e}});var e=arguments[1];Object.defineProperty(this,"y",{enumerable:!0,get:function(){return e},set:function(t){e=t}});var r=arguments[2];Object.defineProperty(this,"width",{enumerable:!0,get:function(){return r},set:function(t){r=t}});var n=arguments[3];Object.defineProperty(this,"height",{enumerable:!0,get:function(){return n},set:function(t){n=t}});var i=arguments[4];Object.defineProperty(this,"text",{enumerable:!0,get:function(){return i},set:function(t){i=t}});var a=arguments[5];Object.defineProperty(this,"lineNumber",{enumerable:!0,get:function(){return a},set:function(t){a=t}});var o=arguments[6];return Object.defineProperty(this,"align",{enumerable:!0,get:function(){return o},set:function(t){o=t}}),this};o.prototype.clone=function(){return new o(this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align)},o.prototype.toArray=function(){return[this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align]},e.setHeaderFunction=function(t){return i.call(this),this.internal.__cell__.headerFunction="function"==typeof t?t:void 0,this},e.getTextDimensions=function(t,e){i.call(this);var r=(e=e||{}).fontSize||this.getFontSize(),n=e.font||this.getFont(),a=e.scaleFactor||this.internal.scaleFactor,o=0,s=0,c=0,u=this;if(!Array.isArray(t)&&"string"!=typeof t){if("number"!=typeof t)throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");t=String(t)}var h=e.maxWidth;h>0?"string"==typeof t?t=this.splitTextToSize(t,h):"[object Array]"===Object.prototype.toString.call(t)&&(t=t.reduce((function(t,e){return t.concat(u.splitTextToSize(e,h))}),[])):t=Array.isArray(t)?t:[t];for(var l=0;l<t.length;l++)o<(c=this.getStringUnitWidth(t[l],{font:n})*r)&&(o=c);return 0!==o&&(s=t.length),{w:o/=a,h:Math.max((s*r*this.getLineHeightFactor()-r*(this.getLineHeightFactor()-1))/a,0)}},e.cellAddPage=function(){i.call(this),this.addPage();var t=this.internal.__cell__.margins||r;return this.internal.__cell__.lastCell=new o(t.left,t.top,void 0,void 0),this.internal.__cell__.pages+=1,this};var s=e.cell=function(){var t;t=arguments[0]instanceof o?arguments[0]:new o(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]),i.call(this);var e=this.internal.__cell__.lastCell,a=this.internal.__cell__.padding,s=this.internal.__cell__.margins||r,c=this.internal.__cell__.tableHeaderRow,u=this.internal.__cell__.printHeaders;return void 0!==e.lineNumber&&(e.lineNumber===t.lineNumber?(t.x=(e.x||0)+(e.width||0),t.y=e.y||0):e.y+e.height+t.height+s.bottom>this.getPageHeight()?(this.cellAddPage(),t.y=s.top,u&&c&&(this.printHeaderRow(t.lineNumber,!0),t.y+=c[0].height)):t.y=e.y+e.height||t.y),void 0!==t.text[0]&&(this.rect(t.x,t.y,t.width,t.height,!0===n?"FD":void 0),"right"===t.align?this.text(t.text,t.x+t.width-a,t.y+a,{align:"right",baseline:"top"}):"center"===t.align?this.text(t.text,t.x+t.width/2,t.y+a,{align:"center",baseline:"top",maxWidth:t.width-a-a}):this.text(t.text,t.x+a,t.y+a,{align:"left",baseline:"top",maxWidth:t.width-a-a})),this.internal.__cell__.lastCell=t,this};e.table=function(e,n,u,h,l){if(i.call(this),!u)throw new Error("No data for PDF table.");var f,d,p,g,m=[],v=[],b=[],y={},w={},N=[],L=[],A=(l=l||{}).autoSize||!1,x=!1!==l.printHeaders,S=l.css&&void 0!==l.css["font-size"]?16*l.css["font-size"]:l.fontSize||12,_=l.margins||Object.assign({width:this.getPageWidth()},r),P="number"==typeof l.padding?l.padding:3,k=l.headerBackgroundColor||"#c8c8c8",I=l.headerTextColor||"#000";if(a.call(this),this.internal.__cell__.printHeaders=x,this.internal.__cell__.margins=_,this.internal.__cell__.table_font_size=S,this.internal.__cell__.padding=P,this.internal.__cell__.headerBackgroundColor=k,this.internal.__cell__.headerTextColor=I,this.setFontSize(S),null==h)v=m=Object.keys(u[0]),b=m.map((function(){return"left"}));else if(Array.isArray(h)&&"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(h[0]))for(m=h.map((function(t){return t.name})),v=h.map((function(t){return t.prompt||t.name||""})),b=h.map((function(t){return t.align||"left"})),f=0;f<h.length;f+=1)w[h[f].name]=h[f].width*(19.049976/25.4);else Array.isArray(h)&&"string"==typeof h[0]&&(v=m=h,b=m.map((function(){return"left"})));if(A||Array.isArray(h)&&"string"==typeof h[0])for(f=0;f<m.length;f+=1){for(y[g=m[f]]=u.map((function(t){return t[g]})),this.setFont(void 0,"bold"),N.push(this.getTextDimensions(v[f],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w),d=y[g],this.setFont(void 0,"normal"),p=0;p<d.length;p+=1)N.push(this.getTextDimensions(d[p],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w);w[g]=Math.max.apply(null,N)+P+P,N=[]}if(x){var F={};for(f=0;f<m.length;f+=1)F[m[f]]={},F[m[f]].text=v[f],F[m[f]].align=b[f];var C=c.call(this,F,w);L=m.map((function(t){return new o(e,n,w[t],C,F[t].text,void 0,F[t].align)})),this.setTableHeaderRow(L),this.printHeaderRow(1,!1)}var j=h.reduce((function(t,e){return t[e.name]=e.align,t}),{});for(f=0;f<u.length;f+=1){"rowStart"in l&&l.rowStart instanceof Function&&l.rowStart({row:f,data:u[f]},this);var O=c.call(this,u[f],w);for(p=0;p<m.length;p+=1){var B=u[f][m[p]];"cellStart"in l&&l.cellStart instanceof Function&&l.cellStart({row:f,col:p,data:B},this),s.call(this,new o(e,n,w[m[p]],O,B,f+2,j[m[p]]))}}return this.internal.__cell__.table_x=e,this.internal.__cell__.table_y=n,this};var c=function(t,e){var r=this.internal.__cell__.padding,n=this.internal.__cell__.table_font_size,i=this.internal.scaleFactor;return Object.keys(t).map((function(n){var i=t[n];return this.splitTextToSize(i.hasOwnProperty("text")?i.text:i,e[n]-r-r)}),this).map((function(t){return this.getLineHeightFactor()*t.length*n/i+r+r}),this).reduce((function(t,e){return Math.max(t,e)}),0)};e.setTableHeaderRow=function(t){i.call(this),this.internal.__cell__.tableHeaderRow=t},e.printHeaderRow=function(t,e){if(i.call(this),!this.internal.__cell__.tableHeaderRow)throw new Error("Property tableHeaderRow does not exist.");var r;if(n=!0,"function"==typeof this.internal.__cell__.headerFunction){var a=this.internal.__cell__.headerFunction(this,this.internal.__cell__.pages);this.internal.__cell__.lastCell=new o(a[0],a[1],a[2],a[3],void 0,-1)}this.setFont(void 0,"bold");for(var c=[],u=0;u<this.internal.__cell__.tableHeaderRow.length;u+=1){r=this.internal.__cell__.tableHeaderRow[u].clone(),e&&(r.y=this.internal.__cell__.margins.top||0,c.push(r)),r.lineNumber=t;var h=this.getTextColor();this.setTextColor(this.internal.__cell__.headerTextColor),this.setFillColor(this.internal.__cell__.headerBackgroundColor),s.call(this,r),this.setTextColor(h)}c.length>0&&this.setTableHeaderRow(c),this.setFont(void 0,"normal"),n=!1}}(E.API);var Pt={italic:["italic","oblique","normal"],oblique:["oblique","italic","normal"],normal:["normal","oblique","italic"]},kt=["ultra-condensed","extra-condensed","condensed","semi-condensed","normal","semi-expanded","expanded","extra-expanded","ultra-expanded"],It=_t(kt),Ft=[100,200,300,400,500,600,700,800,900],Ct=_t(Ft);function jt(t){var e=t.family.replace(/"|'/g,"").toLowerCase(),r=function(t){return Pt[t=t||"normal"]?t:"normal"}(t.style),n=function(t){if(!t)return 400;if("number"==typeof t)return t>=100&&t<=900&&t%100==0?t:400;if(/^\d00$/.test(t))return parseInt(t);switch(t){case"bold":return 700;case"normal":default:return 400}}(t.weight),i=function(t){return"number"==typeof It[t=t||"normal"]?t:"normal"}(t.stretch);return{family:e,style:r,weight:n,stretch:i,src:t.src||[],ref:t.ref||{name:e,style:[i,r,n].join(" ")}}}function Ot(t,e,r,n){var i;for(i=r;i>=0&&i<e.length;i+=n)if(t[e[i]])return t[e[i]];for(i=r;i>=0&&i<e.length;i-=n)if(t[e[i]])return t[e[i]]}var Bt={"sans-serif":"helvetica",fixed:"courier",monospace:"courier",terminal:"courier",cursive:"times",fantasy:"times",serif:"times"},Mt={caption:"times",icon:"times",menu:"times","message-box":"times","small-caption":"times","status-bar":"times"};function Et(t){return[t.stretch,t.style,t.weight,t.family].join(" ")}function qt(t,e,r){for(var n=(r=r||{}).defaultFontFamily||"times",i=Object.assign({},Bt,r.genericFontFamilies||{}),a=null,o=null,s=0;s<e.length;++s)if(i[(a=jt(e[s])).family]&&(a.family=i[a.family]),t.hasOwnProperty(a.family)){o=t[a.family];break}if(!(o=o||t[n]))throw new Error("Could not find a font-family for the rule '"+Et(a)+"' and default family '"+n+"'.");if(o=function(t,e){if(e[t])return e[t];var r=It[t],n=r<=It.normal?-1:1,i=Ot(e,kt,r,n);if(!i)throw new Error("Could not find a matching font-stretch value for "+t);return i}(a.stretch,o),o=function(t,e){if(e[t])return e[t];for(var r=Pt[t],n=0;n<r.length;++n)if(e[r[n]])return e[r[n]];throw new Error("Could not find a matching font-style for "+t)}(a.style,o),!(o=function(t,e){if(e[t])return e[t];if(400===t&&e[500])return e[500];if(500===t&&e[400])return e[400];var r=Ct[t],n=Ot(e,Ft,r,t<400?-1:1);if(!n)throw new Error("Could not find a matching font-weight for value "+t);return n}(a.weight,o)))throw new Error("Failed to resolve a font for the rule '"+Et(a)+"'.");return o}function Dt(t){return t.trimLeft()}function Rt(t,e){for(var r=0;r<t.length;){if(t.charAt(r)===e)return[t.substring(0,r),t.substring(r+1)];r+=1}return null}function Tt(t){var e=t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);return null===e?null:[e[0],t.substring(e[0].length)]}var Ut,zt,Ht,Wt=["times"];!function(e){var r,n,i,o,s,c,u,h,l,d=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new h,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new c,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new c,this.lineDashOffset=t.lineDashOffset||0,this.lineDash=t.lineDash||[],this.margin=t.margin||[0,0,0,0],this.prevPageLastElemOffset=t.prevPageLastElemOffset||0,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};e.events.push(["initialized",function(){this.context2d=new p(this),r=this.internal.f2,n=this.internal.getCoordinateString,i=this.internal.getVerticalCoordinateString,o=this.internal.getHorizontalCoordinate,s=this.internal.getVerticalCoordinate,c=this.internal.Point,u=this.internal.Rectangle,h=this.internal.Matrix,l=new d}]);var p=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}});var e=t;Object.defineProperty(this,"pdf",{get:function(){return e}});var r=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return r},set:function(t){r=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var i=0;Object.defineProperty(this,"posX",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var a=0;Object.defineProperty(this,"posY",{get:function(){return a},set:function(t){isNaN(t)||(a=t)}}),Object.defineProperty(this,"margin",{get:function(){return l.margin},set:function(t){var e;"number"==typeof t?e=[t,t,t,t]:((e=new Array(4))[0]=t[0],e[1]=t.length>=2?t[1]:e[0],e[2]=t.length>=3?t[2]:e[0],e[3]=t.length>=4?t[3]:e[1]),l.margin=e}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=t}});var s=0;Object.defineProperty(this,"lastBreak",{get:function(){return s},set:function(t){s=t}});var c=[];Object.defineProperty(this,"pageBreaks",{get:function(){return c},set:function(t){c=t}}),Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof d&&(l=t)}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t}});var u=[];Object.defineProperty(this,"ctxStack",{get:function(){return u},set:function(t){u=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=g(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=g(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}});var h=null;function f(t,e){if(null===h){var r=function(t){var e=[];return Object.keys(t).forEach((function(r){t[r].forEach((function(t){var n=null;switch(t){case"bold":n={family:r,weight:"bold"};break;case"italic":n={family:r,style:"italic"};break;case"bolditalic":n={family:r,weight:"bold",style:"italic"};break;case"":case"normal":n={family:r}}null!==n&&(n.ref={name:r,style:t},e.push(n))}))})),e}(t.getFontList());h=function(t){for(var e={},r=0;r<t.length;++r){var n=jt(t[r]),i=n.family,a=n.stretch,o=n.style,s=n.weight;e[i]=e[i]||{},e[i][a]=e[i][a]||{},e[i][a][o]=e[i][a][o]||{},e[i][a][o][s]=n}return e}(r.concat(e))}return h}var p=null;Object.defineProperty(this,"fontFaces",{get:function(){return p},set:function(t){h=null,p=t}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var r=e[1],n=(e[2],e[3]),i=e[4],a=(e[5],e[6]),o=/^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];i="px"===o?Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor),this.pdf.setFontSize(i);var s=function(t){var e,r,n=[],i=t.trim();if(""===i)return Wt;if(i in Mt)return[Mt[i]];for(;""!==i;){switch(r=null,e=(i=Dt(i)).charAt(0)){case'"':case"'":r=Rt(i.substring(1),e);break;default:r=Tt(i)}if(null===r)return Wt;if(n.push(r[0]),""!==(i=Dt(r[1]))&&","!==i.charAt(0))return Wt;i=i.replace(/^,/,"")}return n}(a);if(this.fontFaces){var c=qt(f(this.pdf,this.fontFaces),s.map((function(t){return{family:t,stretch:"normal",weight:n,style:r}})));this.pdf.setFont(c.ref.name,c.ref.style)}else{var u="";("bold"===n||parseInt(n,10)>=700||"bold"===r)&&(u="bold"),"italic"===r&&(u+="italic"),0===u.length&&(u="normal");for(var h="",l={arial:"Helvetica",Arial:"Helvetica",verdana:"Helvetica",Verdana:"Helvetica",helvetica:"Helvetica",Helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",cursive:"Times",fantasy:"Times",serif:"Times"},d=0;d<s.length;d++){if(void 0!==this.pdf.internal.getFont(s[d],u,{noFallback:!0,disableWarning:!0})){h=s[d];break}if("bolditalic"===u&&void 0!==this.pdf.internal.getFont(s[d],"bold",{noFallback:!0,disableWarning:!0}))h=s[d],u="bold";else if(void 0!==this.pdf.internal.getFont(s[d],"normal",{noFallback:!0,disableWarning:!0})){h=s[d],u="normal";break}}if(""===h)for(var p=0;p<s.length;p++)if(l[s[p]]){h=l[s[p]];break}h=""===h?"Times":h,this.pdf.setFont(h,u)}}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"lineDashOffset",{get:function(){return this.ctx.lineDashOffset},set:function(t){this.ctx.lineDashOffset=t,T.call(this)}}),Object.defineProperty(this,"lineDash",{get:function(){return this.ctx.lineDash},set:function(t){this.ctx.lineDash=t,T.call(this)}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};p.prototype.setLineDash=function(t){this.lineDash=t},p.prototype.getLineDash=function(){return this.lineDash.length%2?this.lineDash.concat(this.lineDash):this.lineDash.slice()},p.prototype.fill=function(){A.call(this,"fill",!1)},p.prototype.stroke=function(){A.call(this,"stroke",!1)},p.prototype.beginPath=function(){this.path=[{type:"begin"}]},p.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var r=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"mt",x:r.x,y:r.y}),this.ctx.lastPoint=new c(t,e)},p.prototype.closePath=function(){var e=new c(0,0),r=0;for(r=this.path.length-1;-1!==r;r--)if("begin"===this.path[r].type&&"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(this.path[r+1])&&"number"==typeof this.path[r+1].x){e=new c(this.path[r+1].x,this.path[r+1].y);break}this.path.push({type:"close"}),this.ctx.lastPoint=new c(e.x,e.y)},p.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var r=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"lt",x:r.x,y:r.y}),this.ctx.lastPoint=new c(r.x,r.y)},p.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),A.call(this,null,!0)},p.prototype.quadraticCurveTo=function(t,e,r,n){if(isNaN(r)||isNaN(n)||isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new c(r,n)),o=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new c(i.x,i.y)},p.prototype.bezierCurveTo=function(t,e,r,n,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var s=this.ctx.transform.applyToPoint(new c(i,o)),u=this.ctx.transform.applyToPoint(new c(t,e)),h=this.ctx.transform.applyToPoint(new c(r,n));this.path.push({type:"bct",x1:u.x,y1:u.y,x2:h.x,y2:h.y,x:s.x,y:s.y}),this.ctx.lastPoint=new c(s.x,s.y)},p.prototype.arc=function(t,e,r,n,i,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i))throw a.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var s=this.ctx.transform.applyToPoint(new c(t,e));t=s.x,e=s.y;var u=this.ctx.transform.applyToPoint(new c(0,r)),h=this.ctx.transform.applyToPoint(new c(0,0));r=Math.sqrt(Math.pow(u.x-h.x,2)+Math.pow(u.y-h.y,2))}Math.abs(i-n)>=2*Math.PI&&(n=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:r,startAngle:n,endAngle:i,counterclockwise:o})},p.prototype.arcTo=function(t,e,r,n,i){throw new Error("arcTo not implemented.")},p.prototype.rect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+r,e),this.lineTo(t+r,e+n),this.lineTo(t,e+n),this.lineTo(t,e),this.lineTo(t+r,e),this.lineTo(t,e)},p.prototype.fillRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!m.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,r,n),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin)}},p.prototype.strokeRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");v.call(this)||(this.beginPath(),this.rect(t,e,r,n),this.stroke())},p.prototype.clearRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,r,n))},p.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var n=new d(this.ctx);this.ctxStack.push(this.ctx),this.ctx=n}},p.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin,this.lineDash=this.ctx.lineDash,this.lineDashOffset=this.ctx.lineDashOffset)},p.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var g=function(t){var e,r,n,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))e=0,r=0,n=0,i=0;else{var a=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==a)e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=1;else if(null!==(a=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t)))e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=parseFloat(a[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var o=new f(t);t=o.ok?o.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,r=t.substring(2,3),r+=r,n=t.substring(3,4),n+=n):(e=t.substring(1,3),r=t.substring(3,5),n=t.substring(5,7)),e=parseInt(e,16),r=parseInt(r,16),n=parseInt(n,16)}}return{r:e,g:r,b:n,a:i,style:t}},m=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},v=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};p.prototype.fillText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw a.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(n=isNaN(n)?void 0:n,!m.call(this)){var i=q(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;C.call(this,{text:t,x:e,y:r,scale:o,angle:i,align:this.textAlign,maxWidth:n})}},p.prototype.strokeText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw a.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!v.call(this)){n=isNaN(n)?void 0:n;var i=q(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;C.call(this,{text:t,x:e,y:r,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:n})}},p.prototype.measureText=function(t){if("string"!=typeof t)throw a.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,r=this.pdf.internal.scaleFactor,n=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*n/e.internal.scaleFactor,o=function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this};return new o({width:i*=Math.round(96*r/72*1e4)/1e4})},p.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var r=new h(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(r)},p.prototype.rotate=function(t){if(isNaN(t))throw a.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new h(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},p.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var r=new h(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(r)},p.prototype.transform=function(t,e,r,n,i,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(o))throw a.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var s=new h(t,e,r,n,i,o);this.ctx.transform=this.ctx.transform.multiply(s)},p.prototype.setTransform=function(t,e,r,n,i,a){t=isNaN(t)?1:t,e=isNaN(e)?0:e,r=isNaN(r)?0:r,n=isNaN(n)?1:n,i=isNaN(i)?0:i,a=isNaN(a)?0:a,this.ctx.transform=new h(t,e,r,n,i,a)};var b=function(){return this.margin[0]>0||this.margin[1]>0||this.margin[2]>0||this.margin[3]>0};p.prototype.drawImage=function(t,e,r,n,i,a,o,s,c){var l=this.pdf.getImageProperties(t),f=1,d=1,p=1,g=1;void 0!==n&&void 0!==s&&(p=s/n,g=c/i,f=l.width/n*s/n,d=l.height/i*c/i),void 0===a&&(a=e,o=r,e=0,r=0),void 0!==n&&void 0===s&&(s=n,c=i),void 0===n&&void 0===s&&(s=l.width,c=l.height);for(var m,v=this.ctx.transform.decompose(),w=q(v.rotate.shx),A=new h,S=(A=(A=(A=A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a-e*p,o-r*g,n*f,i*d)),_=y.call(this,S),P=[],k=0;k<_.length;k+=1)-1===P.indexOf(_[k])&&P.push(_[k]);if(L(P),this.autoPaging)for(var I=P[0],F=P[P.length-1],C=I;C<F+1;C++){this.pdf.setPage(C);var j=this.pdf.internal.pageSize.width-this.margin[3]-this.margin[1],O=1===C?this.posY+this.margin[0]:this.margin[0],B=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],M=this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2],E=1===C?0:B+(C-2)*M;if(0!==this.ctx.clip_path.length){var D=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(m,this.posX+this.margin[3],-E+O+this.ctx.prevPageLastElemOffset),x.call(this,"fill",!0),this.path=D}var R=JSON.parse(JSON.stringify(S));R=N([R],this.posX+this.margin[3],-E+O+this.ctx.prevPageLastElemOffset)[0];var T=(C>I||C<F)&&b.call(this);T&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],j,M,null).clip().discardPath()),this.pdf.addImage(t,"JPEG",R.x,R.y,R.w,R.h,null,null,w),T&&this.pdf.restoreGraphicsState()}else this.pdf.addImage(t,"JPEG",S.x,S.y,S.w,S.h,null,null,w)};var y=function(t,e,r){var n=[];e=e||this.pdf.internal.pageSize.width,r=r||this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2];var i=this.posY+this.ctx.prevPageLastElemOffset;switch(t.type){default:case"mt":case"lt":n.push(Math.floor((t.y+i)/r)+1);break;case"arc":n.push(Math.floor((t.y+i-t.radius)/r)+1),n.push(Math.floor((t.y+i+t.radius)/r)+1);break;case"qct":var a=D(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);n.push(Math.floor((a.y+i)/r)+1),n.push(Math.floor((a.y+a.h+i)/r)+1);break;case"bct":var o=R(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);n.push(Math.floor((o.y+i)/r)+1),n.push(Math.floor((o.y+o.h+i)/r)+1);break;case"rect":n.push(Math.floor((t.y+i)/r)+1),n.push(Math.floor((t.y+t.h+i)/r)+1)}for(var s=0;s<n.length;s+=1)for(;this.pdf.internal.getNumberOfPages()<n[s];)w.call(this);return n},w=function(){var t=this.fillStyle,e=this.strokeStyle,r=this.font,n=this.lineCap,i=this.lineWidth,a=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=r,this.lineCap=n,this.lineWidth=i,this.lineJoin=a},N=function(t,e,r){for(var n=0;n<t.length;n++)switch(t[n].type){case"bct":t[n].x2+=e,t[n].y2+=r;case"qct":t[n].x1+=e,t[n].y1+=r;case"mt":case"lt":case"arc":default:t[n].x+=e,t[n].y+=r}return t},L=function(t){return t.sort((function(t,e){return t-e}))},A=function(t,e){for(var r,n,i=this.fillStyle,a=this.strokeStyle,o=this.lineCap,s=this.lineWidth,c=Math.abs(s*this.ctx.transform.scaleX),u=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),l=JSON.parse(JSON.stringify(this.path)),f=[],d=0;d<l.length;d++)if(void 0!==l[d].x)for(var p=y.call(this,l[d]),g=0;g<p.length;g+=1)-1===f.indexOf(p[g])&&f.push(p[g]);for(var m=0;m<f.length;m++)for(;this.pdf.internal.getNumberOfPages()<f[m];)w.call(this);if(L(f),this.autoPaging)for(var v=f[0],A=f[f.length-1],S=v;S<A+1;S++){this.pdf.setPage(S),this.fillStyle=i,this.strokeStyle=a,this.lineCap=o,this.lineWidth=c,this.lineJoin=u;var _=this.pdf.internal.pageSize.width-this.margin[3]-this.margin[1],P=1===S?this.posY+this.margin[0]:this.margin[0],k=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],I=this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2],F=1===S?0:k+(S-2)*I;if(0!==this.ctx.clip_path.length){var C=this.path;r=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(r,this.posX+this.margin[3],-F+P+this.ctx.prevPageLastElemOffset),x.call(this,t,!0),this.path=C}if(n=JSON.parse(JSON.stringify(h)),this.path=N(n,this.posX+this.margin[3],-F+P+this.ctx.prevPageLastElemOffset),!1===e||0===S){var j=(S>v||S<A)&&b.call(this);j&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],_,I,null).clip().discardPath()),x.call(this,t,e),j&&this.pdf.restoreGraphicsState()}this.lineWidth=s}else this.lineWidth=c,x.call(this,t,e),this.lineWidth=s;this.path=h},x=function(t,e){if(("stroke"!==t||e||!v.call(this))&&("stroke"===t||e||!m.call(this))){for(var r,n,i=[],a=this.path,o=0;o<a.length;o++){var s=a[o];switch(s.type){case"begin":i.push({begin:!0});break;case"close":i.push({close:!0});break;case"mt":i.push({start:s,deltas:[],abs:[]});break;case"lt":var c=i.length;if(a[o-1]&&!isNaN(a[o-1].x)&&(r=[s.x-a[o-1].x,s.y-a[o-1].y],c>0))for(;c>=0;c--)if(!0!==i[c-1].close&&!0!==i[c-1].begin){i[c-1].deltas.push(r),i[c-1].abs.push(s);break}break;case"bct":r=[s.x1-a[o-1].x,s.y1-a[o-1].y,s.x2-a[o-1].x,s.y2-a[o-1].y,s.x-a[o-1].x,s.y-a[o-1].y],i[i.length-1].deltas.push(r);break;case"qct":var u=a[o-1].x+2/3*(s.x1-a[o-1].x),h=a[o-1].y+2/3*(s.y1-a[o-1].y),l=s.x+2/3*(s.x1-s.x),f=s.y+2/3*(s.y1-s.y),d=s.x,p=s.y;r=[u-a[o-1].x,h-a[o-1].y,l-a[o-1].x,f-a[o-1].y,d-a[o-1].x,p-a[o-1].y],i[i.length-1].deltas.push(r);break;case"arc":i.push({deltas:[],abs:[],arc:!0}),Array.isArray(i[i.length-1].abs)&&i[i.length-1].abs.push(s)}}n=e?null:"stroke"===t?"stroke":"fill";for(var g=!1,b=0;b<i.length;b++)if(i[b].arc)for(var y=i[b].abs,w=0;w<y.length;w++){var N=y[w];"arc"===N.type?P.call(this,N.x,N.y,N.radius,N.startAngle,N.endAngle,N.counterclockwise,void 0,e,!g):j.call(this,N.x,N.y),g=!0}else if(!0===i[b].close)this.pdf.internal.out("h"),g=!1;else if(!0!==i[b].begin){var L=i[b].start.x,A=i[b].start.y;O.call(this,i[b].deltas,L,A),g=!0}n&&k.call(this,n),e&&I.call(this)}},S=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,r=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-r;case"top":return t+e-r;case"hanging":return t+e-2*r;case"middle":return t+e/2-r;case"ideographic":return t;case"alphabetic":default:return t}},_=function(t){return t+this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor*(this.pdf.internal.getLineHeightFactor()-1)};p.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},p.prototype.createPattern=function(){return this.createLinearGradient()},p.prototype.createRadialGradient=function(){return this.createLinearGradient()};var P=function(t,e,r,n,i,a,o,s,c){for(var u=M.call(this,r,n,i,a),h=0;h<u.length;h++){var l=u[h];0===h&&(c?F.call(this,l.x1+t,l.y1+e):j.call(this,l.x1+t,l.y1+e)),B.call(this,t,e,l.x2,l.y2,l.x3,l.y3,l.x4,l.y4)}s?I.call(this):k.call(this,o)},k=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},I=function(){this.pdf.clip(),this.pdf.discardPath()},F=function(t,e){this.pdf.internal.out(n(t)+" "+i(e)+" m")},C=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var r=this.pdf.getTextDimensions(t.text),n=S.call(this,t.y),i=_.call(this,n)-r.h,a=this.ctx.transform.applyToPoint(new c(t.x,n)),o=this.ctx.transform.decompose(),s=new h;s=(s=(s=s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);for(var l,f,d,p=this.ctx.transform.applyToRectangle(new u(t.x,n,r.w,r.h)),g=s.applyToRectangle(new u(t.x,i,r.w,r.h)),m=y.call(this,g),v=[],w=0;w<m.length;w+=1)-1===v.indexOf(m[w])&&v.push(m[w]);if(L(v),this.autoPaging)for(var A=v[0],P=v[v.length-1],k=A;k<P+1;k++){this.pdf.setPage(k);var I=1===k?this.posY+this.margin[0]:this.margin[0],F=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],C=this.pdf.internal.pageSize.height-this.margin[2],j=C-this.margin[0],O=this.pdf.internal.pageSize.width-this.margin[1],B=O-this.margin[3],M=1===k?0:F+(k-2)*j;if(0!==this.ctx.clip_path.length){var E=this.path;l=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(l,this.posX+this.margin[3],-1*M+I),x.call(this,"fill",!0),this.path=E}var q=N([JSON.parse(JSON.stringify(g))],this.posX+this.margin[3],-M+I+this.ctx.prevPageLastElemOffset)[0];t.scale>=.01&&(f=this.pdf.internal.getFontSize(),this.pdf.setFontSize(f*t.scale),d=this.lineWidth,this.lineWidth=d*t.scale);var D="text"!==this.autoPaging;if(D||q.y+q.h<=C){if(D||q.y>=I&&q.x<=O){var R=D?t.text:this.pdf.splitTextToSize(t.text,t.maxWidth||O-q.x)[0],T=N([JSON.parse(JSON.stringify(p))],this.posX+this.margin[3],-M+I+this.ctx.prevPageLastElemOffset)[0],U=D&&(k>A||k<P)&&b.call(this);U&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],B,j,null).clip().discardPath()),this.pdf.text(R,T.x,T.y,{angle:t.angle,align:e,renderingMode:t.renderingMode}),U&&this.pdf.restoreGraphicsState()}}else q.y<C&&(this.ctx.prevPageLastElemOffset+=C-q.y);t.scale>=.01&&(this.pdf.setFontSize(f),this.lineWidth=d)}else t.scale>=.01&&(f=this.pdf.internal.getFontSize(),this.pdf.setFontSize(f*t.scale),d=this.lineWidth,this.lineWidth=d*t.scale),this.pdf.text(t.text,a.x+this.posX,a.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),t.scale>=.01&&(this.pdf.setFontSize(f),this.lineWidth=d)},j=function(t,e,r,a){r=r||0,a=a||0,this.pdf.internal.out(n(t+r)+" "+i(e+a)+" l")},O=function(t,e,r){return this.pdf.lines(t,e,r,null,null)},B=function(t,e,n,i,a,c,u,h){this.pdf.internal.out([r(o(n+t)),r(s(i+e)),r(o(a+t)),r(s(c+e)),r(o(u+t)),r(s(h+e)),"c"].join(" "))},M=function(t,e,r,n){for(var i=2*Math.PI,a=Math.PI/2;e>r;)e-=i;var o=Math.abs(r-e);o<i&&n&&(o=i-o);for(var s=[],c=n?-1:1,u=e;o>1e-5;){var h=u+c*Math.min(o,a);s.push(E.call(this,t,u,h)),o-=Math.abs(h-u),u=h}return s},E=function(t,e,r){var n=(r-e)/2,i=t*Math.cos(n),a=t*Math.sin(n),o=i,s=-a,c=o*o+s*s,u=c+o*i+s*a,h=4/3*(Math.sqrt(2*c*u)-u)/(o*a-s*i),l=o-h*s,f=s+h*o,d=l,p=-f,g=n+e,m=Math.cos(g),v=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:l*m-f*v,y2:l*v+f*m,x3:d*m-p*v,y3:d*v+p*m,x4:t*Math.cos(r),y4:t*Math.sin(r)}},q=function(t){return 180*t/Math.PI},D=function(t,e,r,n,i,a){var o=t+.5*(r-t),s=e+.5*(n-e),c=i+.5*(r-i),h=a+.5*(n-a),l=Math.min(t,i,o,c),f=Math.max(t,i,o,c),d=Math.min(e,a,s,h),p=Math.max(e,a,s,h);return new u(l,d,f-l,p-d)},R=function(t,e,r,n,i,a,o,s){var c,h,l,f,d,p,g,m,v,b,y,w,N,L,A=r-t,x=n-e,S=i-r,_=a-n,P=o-i,k=s-a;for(h=0;h<41;h++)v=(g=(l=t+(c=h/40)*A)+c*((d=r+c*S)-l))+c*(d+c*(i+c*P-d)-g),b=(m=(f=e+c*x)+c*((p=n+c*_)-f))+c*(p+c*(a+c*k-p)-m),0==h?(y=v,w=b,N=v,L=b):(y=Math.min(y,v),w=Math.min(w,b),N=Math.max(N,v),L=Math.max(L,b));return new u(Math.round(y),Math.round(w),Math.round(N-y),Math.round(L-w))},T=function(){if(this.prevLineDash||this.ctx.lineDash.length||this.ctx.lineDashOffset){var t,e,r=(t=this.ctx.lineDash,e=this.ctx.lineDashOffset,JSON.stringify({lineDash:t,lineDashOffset:e}));this.prevLineDash!==r&&(this.pdf.setLineDash(this.ctx.lineDash,this.ctx.lineDashOffset),this.prevLineDash=r)}}}(E.API),
/**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var r=function(t){var e,r,n,i,a,o,s,c,u,h;for(/[^\x00-\xFF]/.test(t),r=[],n=0,i=(t+=e="\0\0\0\0".slice(t.length%4||4)).length;i>n;n+=4)0!==(a=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(o=(a=((a=((a=((a=(a-(h=a%85))/85)-(u=a%85))/85)-(c=a%85))/85)-(s=a%85))/85)%85,r.push(o+33,s+33,c+33,u+33,h+33)):r.push(122);return function(t,e){for(var r=e;r>0;r--)t.pop()}(r,e.length),String.fromCharCode.apply(String,r)+"~>"},n=function(t){var e,r,n,i,a,o=String,s="length",c=255,u="charCodeAt",h="slice",l="replace";for(t[h](-2),t=t[h](0,-2)[l](/\s/g,"")[l]("z","!!!!!"),n=[],i=0,a=(t+=e="uuuuu"[h](t[s]%5||5))[s];a>i;i+=5)r=52200625*(t[u](i)-33)+614125*(t[u](i+1)-33)+7225*(t[u](i+2)-33)+85*(t[u](i+3)-33)+(t[u](i+4)-33),n.push(c&r>>24,c&r>>16,c&r>>8,c&r);return function(t,e){for(var r=e;r>0;r--)t.pop()}(n,e[s]),o.fromCharCode.apply(o,n)},i=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var r="",n=0;n<t.length;n+=2)r+=String.fromCharCode("0x"+(t[n]+t[n+1]));return r},a=function(t){for(var r=new Uint8Array(t.length),n=t.length;n--;)r[n]=t.charCodeAt(n);return t=(r=Object(__WEBPACK_IMPORTED_MODULE_1_fflate__["b" /* zlibSync */])(r)).reduce((function(t,e){return t+String.fromCharCode(e)}),"")};t.processDataByFilters=function(t,e){var o=0,s=t||"",c=[];for("string"==typeof(e=e||[])&&(e=[e]),o=0;o<e.length;o+=1)switch(e[o]){case"ASCII85Decode":case"/ASCII85Decode":s=n(s),c.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":s=r(s),c.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":s=i(s),c.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":s=s.split("").map((function(t){return("0"+t.charCodeAt().toString(16)).slice(-2)})).join("")+">",c.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":s=a(s),c.push("/FlateDecode");break;default:throw new Error('The filter: "'+e[o]+'" is not implemented')}return{data:s,reverseChain:c.reverse().join(" ")}}}(E.API),
/**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.loadFile=function(t,e,r){return function(t,e,r){e=!1!==e,r="function"==typeof r?r:function(){};var n=void 0;try{n=function(t,e,r){var n=new XMLHttpRequest,i=0,a=function(t){var e=t.length,r=[],n=String.fromCharCode;for(i=0;i<e;i+=1)r.push(n(255&t.charCodeAt(i)));return r.join("")};if(n.open("GET",t,!e),n.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(n.onload=function(){200===n.status?r(a(this.responseText)):r(void 0)}),n.send(null),e&&200===n.status)return a(n.responseText)}(t,e,r)}catch(t){}return n}(t,e,r)},t.loadImageFile=t.loadFile}(E.API),function(e){function r(){return(n.html2canvas?Promise.resolve(n.html2canvas):new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1075))).catch((function(t){return Promise.reject(new Error("Could not load html2canvas: "+t))})).then((function(t){return t.default?t.default:t}))}function i(){return(n.DOMPurify?Promise.resolve(n.DOMPurify):__webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 3086))).catch((function(t){return Promise.reject(new Error("Could not load dompurify: "+t))})).then((function(t){return t.default?t.default:t}))}var a=function(e){var r=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e);return"undefined"===r?"undefined":"string"===r||e instanceof String?"string":"number"===r||e instanceof Number?"number":"function"===r||e instanceof Function?"function":e&&e.constructor===Array?"array":e&&1===e.nodeType?"element":"object"===r?"object":"unknown"},o=function(t,e){var r=document.createElement(t);for(var n in e.className&&(r.className=e.className),e.innerHTML&&e.dompurify&&(r.innerHTML=e.dompurify.sanitize(e.innerHTML)),e.style)r.style[n]=e.style[n];return r},s=function t(e){var r=Object.assign(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a.convert(Promise.resolve()),JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a.template))),n=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a.convert(Promise.resolve(),r);return n=(n=n.setProgress(1,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a,1,[__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a])).set(e)};(s.prototype=Object.create(Promise.prototype)).constructor=s,s.convert=function(t,e){return t.__proto__=e||s.prototype,t},s.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{},backgroundColor:"transparent"}},s.prototype.from=function(t,e){return this.then((function(){switch(e=e||function(t){switch(a(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase()?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.then(i).then((function(e){return this.set({src:o("div",{innerHTML:t,dompurify:e})})}));case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}}))},s.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},s.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then((function(){var t={position:"relative",display:"inline-block",width:("number"!=typeof this.opt.width||isNaN(this.opt.width)||"number"!=typeof this.opt.windowWidth||isNaN(this.opt.windowWidth)?Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth):this.opt.windowWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:this.opt.backgroundColor},e=function t(e,r){for(var n=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==r&&1===i.nodeType&&"SCRIPT"===i.nodeName||n.appendChild(t(i,r));return 1===e.nodeType&&("CANVAS"===e.nodeName?(n.width=e.width,n.height=e.height,n.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(n.value=e.value),n.addEventListener("load",(function(){n.scrollTop=e.scrollTop,n.scrollLeft=e.scrollLeft}),!0)),n}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=o("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=o("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(o("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"}))},s.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(r).then((function(t){var e=Object.assign({},this.opt.html2canvas);return delete e.onrendered,t(this.prop.container,e)})).then((function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)}))},s.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(r).then((function(t){var e=this.opt.jsPDF,r=this.opt.fontFaces,n="number"!=typeof this.opt.width||isNaN(this.opt.width)||"number"!=typeof this.opt.windowWidth||isNaN(this.opt.windowWidth)?1:this.opt.width/this.opt.windowWidth,i=Object.assign({async:!0,allowTaint:!0,scale:n,scrollX:this.opt.scrollX||0,scrollY:this.opt.scrollY||0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete i.onrendered,e.context2d.autoPaging=void 0===this.opt.autoPaging||this.opt.autoPaging,e.context2d.posX=this.opt.x,e.context2d.posY=this.opt.y,e.context2d.margin=this.opt.margin,e.context2d.fontFaces=r,r)for(var a=0;a<r.length;++a){var o=r[a],s=o.src.find((function(t){return"truetype"===t.format}));s&&e.addFont(s.url,o.ref.name,o.ref.style)}return i.windowHeight=i.windowHeight||0,i.windowHeight=0==i.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):i.windowHeight,e.context2d.save(!0),t(this.prop.container,i)})).then((function(t){this.opt.jsPDF.context2d.restore(!0),(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)}))},s.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then((function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t}))},s.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then((function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF}))},s.prototype.output=function(t,e,r){return"img"===(r=r||"pdf").toLowerCase()||"image"===r.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},s.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){return this.prop.pdf.output(t,e)}))},s.prototype.outputImg=function(t){return this.thenList([function(){return this.prop.img||this.toImg()}]).then((function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}}))},s.prototype.save=function(t){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then((function(){this.prop.pdf.save(this.opt.filename)}))},s.prototype.doCallback=function(){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){this.prop.callback(this.prop.pdf)}))},s.prototype.set=function(t){if("object"!==a(t))return this;var e=Object.keys(t||{}).map((function(e){if(e in s.template.prop)return function(){this.prop[e]=t[e]};switch(e){case"margin":return this.setMargin.bind(this,t.margin);case"jsPDF":return function(){return this.opt.jsPDF=t.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,t.pageSize);default:return function(){this.opt[e]=t[e]}}}),this);return this.then((function(){return this.thenList(e)}))},s.prototype.get=function(t,e){return this.then((function(){var r=t in s.template.prop?this.prop[t]:this.opt[t];return e?e(r):r}))},s.prototype.setMargin=function(t){return this.then((function(){switch(a(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t})).then(this.setPageSize)},s.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then((function(){(t=t||E.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t}))},s.prototype.setProgress=function(t,e,r,n){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=r&&(this.progress.n=r),null!=n&&(this.progress.stack=n),this.progress.ratio=this.progress.val/this.progress.state,this},s.prototype.updateProgress=function(t,e,r,n){return this.setProgress(t?this.progress.val+t:null,e||null,r?this.progress.n+r:null,n?this.progress.stack.concat(n):null)},s.prototype.then=function(t,e){var r=this;return this.thenCore(t,e,(function(t,e){return r.updateProgress(null,null,1,[t]),Promise.prototype.then.call(this,(function(e){return r.updateProgress(null,t),e})).then(t,e).then((function(t){return r.updateProgress(1),t}))}))},s.prototype.thenCore=function(t,e,r){r=r||Promise.prototype.then;t&&(t=t.bind(this)),e&&(e=e.bind(this));var n=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?this:s.convert(Object.assign({},this),Promise.prototype),i=r.call(n,t,e);return s.convert(i,this.__proto__)},s.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},s.prototype.thenList=function(t){var e=this;return t.forEach((function(t){e=e.thenCore(t)})),e},s.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return s.convert(e,this)},s.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},s.prototype.error=function(t){return this.then((function(){throw new Error(t)}))},s.prototype.using=s.prototype.set,s.prototype.saveAs=s.prototype.save,s.prototype.export=s.prototype.output,s.prototype.run=s.prototype.then,E.getPageSize=function(e,r,n){if("object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)){var i=e;e=i.orientation,r=i.unit||r,n=i.format||n}r=r||"mm",n=n||"a4",e=(""+(e||"P")).toLowerCase();var a,o=(""+n).toLowerCase(),s={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(r){case"pt":a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+r}var c,u=0,h=0;if(s.hasOwnProperty(o))u=s[o][1]/a,h=s[o][0]/a;else try{u=n[1],h=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===e||"portrait"===e)e="p",h>u&&(c=h,h=u,u=c);else{if("l"!==e&&"landscape"!==e)throw"Invalid orientation: "+e;e="l",u>h&&(c=h,h=u,u=c)}return{width:h,height:u,unit:r,k:a,orientation:e}},e.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.fontFaces=e.fontFaces?e.fontFaces.map(jt):null;var r=new s(e);return e.worker?r:r.from(t).doCallback()}}(E.API),E.API.addJS=function(t){return Ht=t,this.internal.events.subscribe("postPutResources",(function(){Ut=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(Ut+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),zt=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+Ht+")"),this.internal.out(">>"),this.internal.out("endobj")})),this.internal.events.subscribe("putCatalog",(function(){void 0!==Ut&&void 0!==zt&&this.internal.out("/Names <</JavaScript "+Ut+" 0 R>>")})),this},
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e;t.events.push(["postPutResources",function(){var t=this,r=/^(\d+) 0 obj$/;if(this.outline.root.children.length>0)for(var n=t.outline.render().split(/\r\n/),i=0;i<n.length;i++){var a=n[i],o=r.exec(a);if(null!=o){var s=o[1];t.internal.newObjectDeferredBegin(s,!1)}t.internal.write(a)}if(this.outline.createNamedDestinations){var c=this.internal.pages.length,u=[];for(i=0;i<c;i++){var h=t.internal.newObject();u.push(h);var l=t.internal.getPageInfo(i+1);t.internal.write("<< /D["+l.objId+" 0 R /XYZ null null null]>> endobj")}var f=t.internal.newObject();t.internal.write("<< /Names [ ");for(i=0;i<u.length;i++)t.internal.write("(page_"+(i+1)+")"+u[i]+" 0 R");t.internal.write(" ] >>","endobj"),e=t.internal.newObject(),t.internal.write("<< /Dests "+f+" 0 R"),t.internal.write(">>","endobj")}}]),t.events.push(["putCatalog",function(){this.outline.root.children.length>0&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+e+" 0 R"))}]),t.events.push(["initialized",function(){var t=this;t.outline={createNamedDestinations:!1,root:{children:[]}},t.outline.add=function(t,e,r){var n={title:e,options:r,children:[]};return null==t&&(t=this.root),t.children.push(n),n},t.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=t,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},t.outline.genIds_r=function(e){e.id=t.internal.newObjectDeferred();for(var r=0;r<e.children.length;r++)this.genIds_r(e.children[r])},t.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),t.children.length>0&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},t.outline.renderItems=function(e){for(var r=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<e.children.length;n++){var i=e.children[n];this.objStart(i),this.line("/Title "+this.makeString(i.title)),this.line("/Parent "+this.makeRef(e)),n>0&&this.line("/Prev "+this.makeRef(e.children[n-1])),n<e.children.length-1&&this.line("/Next "+this.makeRef(e.children[n+1])),i.children.length>0&&(this.line("/First "+this.makeRef(i.children[0])),this.line("/Last "+this.makeRef(i.children[i.children.length-1])));var a=this.count=this.count_r({count:0},i);if(a>0&&this.line("/Count "+a),i.options&&i.options.pageNumber){var o=t.internal.getPageInfo(i.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+r(0)+" 0]")}this.objEnd()}for(var s=0;s<e.children.length;s++)this.renderItems(e.children[s])},t.outline.line=function(t){this.ctx.val+=t+"\r\n"},t.outline.makeRef=function(t){return t.id+" 0 R"},t.outline.makeString=function(e){return"("+t.internal.pdfEscape(e)+")"},t.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},t.outline.objEnd=function(){this.ctx.val+=">> \r\nendobj\r\n"},t.outline.count_r=function(t,e){for(var r=0;r<e.children.length;r++)t.count++,this.count_r(t,e.children[r]);return t.count}}])}(E.API),
/**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=[192,193,194,195,196,197,198,199];t.processJPEG=function(t,r,n,i,a,o){var s,c=this.decode.DCT_DECODE,u=null;if("string"==typeof t||this.__addimage__.isArrayBuffer(t)||this.__addimage__.isArrayBufferView(t)){switch(t=a||t,t=this.__addimage__.isArrayBuffer(t)?new Uint8Array(t):t,(s=function(t){for(var r,n=256*t.charCodeAt(4)+t.charCodeAt(5),i=t.length,a={width:0,height:0,numcomponents:1},o=4;o<i;o+=2){if(o+=n,-1!==e.indexOf(t.charCodeAt(o+1))){r=256*t.charCodeAt(o+5)+t.charCodeAt(o+6),a={width:256*t.charCodeAt(o+7)+t.charCodeAt(o+8),height:r,numcomponents:t.charCodeAt(o+9)};break}n=256*t.charCodeAt(o+2)+t.charCodeAt(o+3)}return a}(t=this.__addimage__.isArrayBufferView(t)?this.__addimage__.arrayBufferToBinaryString(t):t)).numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;case 3:o=this.color_spaces.DEVICE_RGB}u={data:t,width:s.width,height:s.height,colorSpace:o,bitsPerComponent:8,filter:c,index:r,alias:n}}return u}}(E.API);var Vt,Gt,Yt,Jt,Xt,Kt=function(){var t,e,i;function a(t){var e,r,n,i,a,o,s,c,u,h,l,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},o=null;;){switch(e=this.readUInt32(),u=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":o&&this.animation.frames.push(o),this.pos+=4,o={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},a=this.readUInt16(),i=this.readUInt16()||100,o.delay=1e3*a/i,o.disposeOp=this.data[this.pos++],o.blendOp=this.data[this.pos++],o.data=[];break;case"IDAT":case"fdAT":for("fdAT"===u&&(this.pos+=4,e-=4),t=(null!=o?o.data:void 0)||this.imgData,f=0;0<=e?f<e:f>e;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(n=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>n)throw new Error("More transparent colors than palette size");if((h=n-this.transparency.indexed.length)>0)for(d=0;0<=h?d<h:d>h;0<=h?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(l=this.read(e)).indexOf(0),c=String.fromCharCode.apply(String,l.slice(0,s)),this.text[c]=String.fromCharCode.apply(String,l.slice(s+1));break;case"IEND":return o&&this.animation.frames.push(o),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,r=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*r,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}a.prototype.read=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;0<=t?++e:--e)r.push(this.data[this.pos++]);return r},a.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},a.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},a.prototype.decodePixels=function(t){var e=this.pixelBitlength/8,n=new Uint8Array(this.width*this.height*e),i=0,a=this;if(null==t&&(t=this.imgData),0===t.length)return new Uint8Array(0);function o(r,o,s,c){var u,h,l,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,I,F=Math.ceil((a.width-r)/s),C=Math.ceil((a.height-o)/c),j=a.width==F&&a.height==C;for(L=e*F,w=j?n:new Uint8Array(L*C),p=t.length,N=0,h=0;N<C&&i<p;){switch(t[i++]){case 0:for(f=S=0;S<L;f=S+=1)w[h++]=t[i++];break;case 1:for(f=_=0;_<L;f=_+=1)u=t[i++],d=f<e?0:w[h-e],w[h++]=(u+d)%256;break;case 2:for(f=P=0;P<L;f=P+=1)u=t[i++],l=(f-f%e)/e,A=N&&w[(N-1)*L+l*e+f%e],w[h++]=(A+u)%256;break;case 3:for(f=k=0;k<L;f=k+=1)u=t[i++],l=(f-f%e)/e,d=f<e?0:w[h-e],A=N&&w[(N-1)*L+l*e+f%e],w[h++]=(u+Math.floor((d+A)/2))%256;break;case 4:for(f=I=0;I<L;f=I+=1)u=t[i++],l=(f-f%e)/e,d=f<e?0:w[h-e],0===N?A=x=0:(A=w[(N-1)*L+l*e+f%e],x=l&&w[(N-1)*L+(l-1)*e+f%e]),g=d+A-x,m=Math.abs(g-d),b=Math.abs(g-A),y=Math.abs(g-x),v=m<=b&&m<=y?d:b<=y?A:x,w[h++]=(u+v)%256;break;default:throw new Error("Invalid filter algorithm: "+t[i-1])}if(!j){var O=((o+N*c)*a.width+r)*e,B=N*L;for(f=0;f<F;f+=1){for(var M=0;M<e;M+=1)n[O++]=w[B++];O+=(s-1)*e}}N++}}return t=Object(__WEBPACK_IMPORTED_MODULE_1_fflate__["a" /* unzlibSync */])(t),1==a.interlaceMethod?(o(0,0,8,8),o(4,0,8,8),o(0,4,4,8),o(2,0,4,4),o(0,2,2,4),o(1,0,2,2),o(0,1,1,2)):o(0,0,1,1),n},a.prototype.decodePalette=function(){var t,e,r,n,i,a,o,s,c;for(r=this.palette,a=this.transparency.indexed||[],i=new Uint8Array((a.length||0)+r.length),n=0,t=0,e=o=0,s=r.length;o<s;e=o+=3)i[n++]=r[e],i[n++]=r[e+1],i[n++]=r[e+2],i[n++]=null!=(c=a[t++])?c:255;return i},a.prototype.copyToImageData=function(t,e){var r,n,i,a,o,s,c,u,h,l,f;if(n=this.colors,h=null,r=this.hasAlphaChannel,this.palette.length&&(h=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),n=4,r=!0),u=(i=t.data||t).length,o=h||e,a=s=0,1===n)for(;a<u;)c=h?4*e[a/4]:s,l=o[c++],i[a++]=l,i[a++]=l,i[a++]=l,i[a++]=r?o[c++]:255,s=c;else for(;a<u;)c=h?4*e[a/4]:s,i[a++]=o[c++],i[a++]=o[c++],i[a++]=o[c++],i[a++]=r?o[c++]:255,s=c},a.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};var o=function(){if("[object Window]"===Object.prototype.toString.call(n)){try{e=n.document.createElement("canvas"),i=e.getContext("2d")}catch(t){return!1}return!0}return!1};return o(),t=function(t){var r;if(!0===o())return i.width=t.width,i.height=t.height,i.clearRect(0,0,t.width,t.height),i.putImageData(t,0,0),(r=new Image).src=e.toDataURL(),r;throw new Error("This method requires a Browser with Canvas-capability.")},a.prototype.decodeFrames=function(e){var r,n,i,a,o,s,c,u;if(this.animation){for(u=[],n=o=0,s=(c=this.animation.frames).length;o<s;n=++o)r=c[n],i=e.createImageData(r.width,r.height),a=this.decodePixels(new Uint8Array(r.data)),this.copyToImageData(i,a),r.imageData=i,u.push(r.image=t(i));return u}},a.prototype.renderFrame=function(t,e){var r,n,i;return r=(n=this.animation.frames)[e],i=n[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===r.blendOp&&t.clearRect(r.xOffset,r.yOffset,r.width,r.height),t.drawImage(r.image,r.xOffset,r.yOffset)},a.prototype.animate=function(t){var e,r,n,i,a,o,s=this;return r=0,o=this.animation,i=o.numFrames,n=o.frames,a=o.numPlays,(e=function(){var o,c;if(o=r++%i,c=n[o],s.renderFrame(t,o),i>1&&r/i<a)return s.animation._timeout=setTimeout(e,c.delay)})()},a.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},a.prototype.render=function(t){var e,r;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(r=e.createImageData(this.width,this.height),this.copyToImageData(r,this.decodePixels()),e.putImageData(r,0,0))},a}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
function Zt(t){var e=0;if(71!==t[e++]||73!==t[e++]||70!==t[e++]||56!==t[e++]||56!=(t[e++]+1&253)||97!==t[e++])throw new Error("Invalid GIF 87a/89a header.");var r=t[e++]|t[e++]<<8,n=t[e++]|t[e++]<<8,i=t[e++],a=i>>7,o=1<<(7&i)+1;t[e++];t[e++];var s=null,c=null;a&&(s=e,c=o,e+=3*o);var u=!0,h=[],l=0,f=null,d=0,p=null;for(this.width=r,this.height=n;u&&e<t.length;)switch(t[e++]){case 33:switch(t[e++]){case 255:if(11!==t[e]||78==t[e+1]&&69==t[e+2]&&84==t[e+3]&&83==t[e+4]&&67==t[e+5]&&65==t[e+6]&&80==t[e+7]&&69==t[e+8]&&50==t[e+9]&&46==t[e+10]&&48==t[e+11]&&3==t[e+12]&&1==t[e+13]&&0==t[e+16])e+=14,p=t[e++]|t[e++]<<8,e++;else for(e+=12;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}break;case 249:if(4!==t[e++]||0!==t[e+4])throw new Error("Invalid graphics extension block.");var g=t[e++];l=t[e++]|t[e++]<<8,f=t[e++],0==(1&g)&&(f=null),d=g>>2&7,e++;break;case 254:for(;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}break;default:throw new Error("Unknown graphic control label: 0x"+t[e-1].toString(16))}break;case 44:var m=t[e++]|t[e++]<<8,v=t[e++]|t[e++]<<8,b=t[e++]|t[e++]<<8,y=t[e++]|t[e++]<<8,w=t[e++],N=w>>6&1,L=1<<(7&w)+1,A=s,x=c,S=!1;if(w>>7){S=!0;A=e,x=L,e+=3*L}var _=e;for(e++;;){var P;if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}h.push({x:m,y:v,width:b,height:y,has_local_palette:S,palette_offset:A,palette_size:x,data_offset:_,data_length:e-_,transparent_index:f,interlaced:!!N,delay:l,disposal:d});break;case 59:u=!1;break;default:throw new Error("Unknown gif block: 0x"+t[e-1].toString(16))}this.numFrames=function(){return h.length},this.loopCount=function(){return p},this.frameInfo=function(t){if(t<0||t>=h.length)throw new Error("Frame index out of range.");return h[t]},this.decodeAndBlitFrameBGRA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);$t(t,i.data_offset,o,a);var s=i.palette_offset,c=i.transparent_index;null===c&&(c=256);var u=i.width,h=r-u,l=u,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*h;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===l&&(l=u,(p+=g)>=d&&(g=4*h+4*r*(m-1),p=f+(u+h)*(m<<1),m>>=1)),y===c)p+=4;else{var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=L,n[p++]=N,n[p++]=w,n[p++]=255}--l}},this.decodeAndBlitFrameRGBA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);$t(t,i.data_offset,o,a);var s=i.palette_offset,c=i.transparent_index;null===c&&(c=256);var u=i.width,h=r-u,l=u,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*h;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===l&&(l=u,(p+=g)>=d&&(g=4*h+4*r*(m-1),p=f+(u+h)*(m<<1),m>>=1)),y===c)p+=4;else{var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=w,n[p++]=N,n[p++]=L,n[p++]=255}--l}}}function $t(t,e,r,n){for(var i=t[e++],o=1<<i,s=o+1,c=s+1,u=i+1,h=(1<<u)-1,l=0,f=0,d=0,p=t[e++],g=new Int32Array(4096),m=null;;){for(;l<16&&0!==p;)f|=t[e++]<<l,l+=8,1===p?p=t[e++]:--p;if(l<u)break;var v=f&h;if(f>>=u,l-=u,v!==o){if(v===s)break;for(var b=v<c?v:m,y=0,w=b;w>o;)w=g[w]>>8,++y;var N=w;if(d+y+(b!==v?1:0)>n)return void a.log("Warning, gif stream longer than expected.");r[d++]=N;var L=d+=y;for(b!==v&&(r[d++]=N),w=b;y--;)w=g[w],r[--L]=255&w,w>>=8;null!==m&&c<4096&&(g[c++]=m<<8|N,c>=h+1&&u<12&&(++u,h=h<<1|1)),m=v}else c=s+1,h=(1<<(u=i+1))-1,m=null}return d!==n&&a.log("Warning, gif stream shorter than expected."),r}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/function Qt(t){var e,r,n,i,a,o=Math.floor,s=new Array(64),c=new Array(64),u=new Array(64),h=new Array(64),l=new Array(65535),f=new Array(65535),d=new Array(64),p=new Array(64),g=[],m=0,v=7,b=new Array(64),y=new Array(64),w=new Array(64),N=new Array(256),L=new Array(2048),A=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],x=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],S=[0,1,2,3,4,5,6,7,8,9,10,11],_=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],P=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],k=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],I=[0,1,2,3,4,5,6,7,8,9,10,11],F=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],C=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function j(t,e){for(var r=0,n=0,i=new Array,a=1;a<=16;a++){for(var o=1;o<=t[a];o++)i[e[n]]=[],i[e[n]][0]=r,i[e[n]][1]=a,n++,r++;r*=2}return i}function O(t){for(var e=t[0],r=t[1]-1;r>=0;)e&1<<r&&(m|=1<<v),r--,--v<0&&(255==m?(B(255),B(0)):B(m),v=7,m=0)}function B(t){g.push(t)}function M(t){B(t>>8&255),B(255&t)}function E(t,e,r,n,i){for(var a,o=i[0],s=i[240],c=function(t,e){var r,n,i,a,o,s,c,u,h,l,f=0;for(h=0;h<8;++h){r=t[f],n=t[f+1],i=t[f+2],a=t[f+3],o=t[f+4],s=t[f+5],c=t[f+6];var p=r+(u=t[f+7]),g=r-u,m=n+c,v=n-c,b=i+s,y=i-s,w=a+o,N=a-o,L=p+w,A=p-w,x=m+b,S=m-b;t[f]=L+x,t[f+4]=L-x;var _=.707106781*(S+A);t[f+2]=A+_,t[f+6]=A-_;var P=.382683433*((L=N+y)-(S=v+g)),k=.5411961*L+P,I=1.306562965*S+P,F=.707106781*(x=y+v),C=g+F,j=g-F;t[f+5]=j+k,t[f+3]=j-k,t[f+1]=C+I,t[f+7]=C-I,f+=8}for(f=0,h=0;h<8;++h){r=t[f],n=t[f+8],i=t[f+16],a=t[f+24],o=t[f+32],s=t[f+40],c=t[f+48];var O=r+(u=t[f+56]),B=r-u,M=n+c,E=n-c,q=i+s,D=i-s,R=a+o,T=a-o,U=O+R,z=O-R,H=M+q,W=M-q;t[f]=U+H,t[f+32]=U-H;var V=.707106781*(W+z);t[f+16]=z+V,t[f+48]=z-V;var G=.382683433*((U=T+D)-(W=E+B)),Y=.5411961*U+G,J=1.306562965*W+G,X=.707106781*(H=D+E),K=B+X,Z=B-X;t[f+40]=Z+Y,t[f+24]=Z-Y,t[f+8]=K+J,t[f+56]=K-J,f++}for(h=0;h<64;++h)l=t[h]*e[h],d[h]=l>0?l+.5|0:l-.5|0;return d}(t,e),u=0;u<64;++u)p[A[u]]=c[u];var h=p[0]-r;r=p[0],0==h?O(n[0]):(O(n[f[a=32767+h]]),O(l[a]));for(var g=63;g>0&&0==p[g];)g--;if(0==g)return O(o),r;for(var m,v=1;v<=g;){for(var b=v;0==p[v]&&v<=g;)++v;var y=v-b;if(y>=16){m=y>>4;for(var w=1;w<=m;++w)O(s);y&=15}a=32767+p[v],O(i[(y<<4)+f[a]]),O(l[a]),v++}return 63!=g&&O(o),r}function q(t){(t=Math.min(Math.max(t,1),100),a!=t)&&(!function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],r=0;r<64;r++){var n=o((e[r]*t+50)/100);n=Math.min(Math.max(n,1),255),s[A[r]]=n}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],a=0;a<64;a++){var l=o((i[a]*t+50)/100);l=Math.min(Math.max(l,1),255),c[A[a]]=l}for(var f=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],d=0,p=0;p<8;p++)for(var g=0;g<8;g++)u[d]=1/(s[A[d]]*f[p]*f[g]*8),h[d]=1/(c[A[d]]*f[p]*f[g]*8),d++}(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),a=t)}this.encode=function(t,a){a&&q(a),g=new Array,m=0,v=7,M(65496),M(65504),M(16),B(74),B(70),B(73),B(70),B(0),B(1),B(1),B(0),M(1),M(1),B(0),B(0),function(){M(65499),M(132),B(0);for(var t=0;t<64;t++)B(s[t]);B(1);for(var e=0;e<64;e++)B(c[e])}(),function(t,e){M(65472),M(17),B(8),M(e),M(t),B(3),B(1),B(17),B(0),B(2),B(17),B(1),B(3),B(17),B(1)}(t.width,t.height),function(){M(65476),M(418),B(0);for(var t=0;t<16;t++)B(x[t+1]);for(var e=0;e<=11;e++)B(S[e]);B(16);for(var r=0;r<16;r++)B(_[r+1]);for(var n=0;n<=161;n++)B(P[n]);B(1);for(var i=0;i<16;i++)B(k[i+1]);for(var a=0;a<=11;a++)B(I[a]);B(17);for(var o=0;o<16;o++)B(F[o+1]);for(var s=0;s<=161;s++)B(C[s])}(),M(65498),M(12),B(3),B(1),B(0),B(2),B(17),B(3),B(17),B(0),B(63),B(0);var o=0,l=0,f=0;m=0,v=7,this.encode.displayName="_encode_";for(var d,p,N,A,j,D,R,T,U,z=t.data,H=t.width,W=t.height,V=4*H,G=0;G<W;){for(d=0;d<V;){for(j=V*G+d,R=-1,T=0,U=0;U<64;U++)D=j+(T=U>>3)*V+(R=4*(7&U)),G+T>=W&&(D-=V*(G+1+T-W)),d+R>=V&&(D-=d+R-V+4),p=z[D++],N=z[D++],A=z[D++],b[U]=(L[p]+L[N+256>>0]+L[A+512>>0]>>16)-128,y[U]=(L[p+768>>0]+L[N+1024>>0]+L[A+1280>>0]>>16)-128,w[U]=(L[p+1280>>0]+L[N+1536>>0]+L[A+1792>>0]>>16)-128;o=E(b,u,o,e,n),l=E(y,h,l,r,i),f=E(w,h,f,r,i),d+=32}G+=8}if(v>=0){var Y=[];Y[1]=v+1,Y[0]=(1<<v+1)-1,O(Y)}return M(65497),new Uint8Array(g)},t=t||50,function(){for(var t=String.fromCharCode,e=0;e<256;e++)N[e]=t(e)}(),e=j(x,S),r=j(k,I),n=j(_,P),i=j(F,C),function(){for(var t=1,e=2,r=1;r<=15;r++){for(var n=t;n<e;n++)f[32767+n]=r,l[32767+n]=[],l[32767+n][1]=r,l[32767+n][0]=n;for(var i=-(e-1);i<=-t;i++)f[32767+i]=r,l[32767+i]=[],l[32767+i][1]=r,l[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)L[t]=19595*t,L[t+256>>0]=38470*t,L[t+512>>0]=7471*t+32768,L[t+768>>0]=-11059*t,L[t+1024>>0]=-21709*t,L[t+1280>>0]=32768*t+8421375,L[t+1536>>0]=-27439*t,L[t+1792>>0]=-5329*t}(),q(t)}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */function te(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}function ee(t){function e(t){if(!t)throw Error("assert :P")}function r(t,e,r){for(var n=0;4>n;n++)if(t[e+n]!=r.charCodeAt(n))return!0;return!1}function n(t,e,r,n,i){for(var a=0;a<i;a++)t[e+a]=r[n+a]}function i(t,e,r,n){for(var i=0;i<n;i++)t[e+i]=r}function a(t){return new Int32Array(t)}function o(t,e){for(var r=[],n=0;n<t;n++)r.push(new e);return r}function s(t,e){var r=[];return function t(r,n,i){for(var a=i[n],o=0;o<a&&(r.push(i.length>n+1?[]:new e),!(i.length<n+1));o++)t(r[o],n+1,i)}(r,0,t),r}var c=function(){var t=this;function c(t,e){for(var r=1<<e-1>>>0;t&r;)r>>>=1;return r?(t&r-1)+r:t}function u(t,r,n,i,a){e(!(i%n));do{t[r+(i-=n)]=a}while(0<i)}function h(t,r,n,i,o){if(e(2328>=o),512>=o)var s=a(512);else if(null==(s=a(o)))return 0;return function(t,r,n,i,o,s){var h,f,d=r,p=1<<n,g=a(16),m=a(16);for(e(0!=o),e(null!=i),e(null!=t),e(0<n),f=0;f<o;++f){if(15<i[f])return 0;++g[i[f]]}if(g[0]==o)return 0;for(m[1]=0,h=1;15>h;++h){if(g[h]>1<<h)return 0;m[h+1]=m[h]+g[h]}for(f=0;f<o;++f)h=i[f],0<i[f]&&(s[m[h]++]=f);if(1==m[15])return(i=new l).g=0,i.value=s[0],u(t,d,1,p,i),p;var v,b=-1,y=p-1,w=0,N=1,L=1,A=1<<n;for(f=0,h=1,o=2;h<=n;++h,o<<=1){if(N+=L<<=1,0>(L-=g[h]))return 0;for(;0<g[h];--g[h])(i=new l).g=h,i.value=s[f++],u(t,d+w,o,A,i),w=c(w,h)}for(h=n+1,o=2;15>=h;++h,o<<=1){if(N+=L<<=1,0>(L-=g[h]))return 0;for(;0<g[h];--g[h]){if(i=new l,(w&y)!=b){for(d+=A,v=1<<(b=h)-n;15>b&&!(0>=(v-=g[b]));)++b,v<<=1;p+=A=1<<(v=b-n),t[r+(b=w&y)].g=v+n,t[r+b].value=d-r-b}i.g=h-n,i.value=s[f++],u(t,d+(w>>n),o,A,i),w=c(w,h)}}return N!=2*m[15]-1?0:p}(t,r,n,i,o,s)}function l(){this.value=this.g=0}function f(){this.value=this.g=0}function d(){this.G=o(5,l),this.H=a(5),this.jc=this.Qb=this.qb=this.nd=0,this.pd=o(Dr,f)}function p(t,r,n,i){e(null!=t),e(null!=r),e(2147483648>i),t.Ca=254,t.I=0,t.b=-8,t.Ka=0,t.oa=r,t.pa=n,t.Jd=r,t.Yc=n+i,t.Zc=4<=i?n+i-4+1:n,_(t)}function g(t,e){for(var r=0;0<e--;)r|=k(t,128)<<e;return r}function m(t,e){var r=g(t,e);return P(t)?-r:r}function v(t,r,n,i){var a,o=0;for(e(null!=t),e(null!=r),e(4294967288>i),t.Sb=i,t.Ra=0,t.u=0,t.h=0,4<i&&(i=4),a=0;a<i;++a)o+=r[n+a]<<8*a;t.Ra=o,t.bb=i,t.oa=r,t.pa=n}function b(t){for(;8<=t.u&&t.bb<t.Sb;)t.Ra>>>=8,t.Ra+=t.oa[t.pa+t.bb]<<Ur-8>>>0,++t.bb,t.u-=8;A(t)&&(t.h=1,t.u=0)}function y(t,r){if(e(0<=r),!t.h&&r<=Tr){var n=L(t)&Rr[r];return t.u+=r,b(t),n}return t.h=1,t.u=0}function w(){this.b=this.Ca=this.I=0,this.oa=[],this.pa=0,this.Jd=[],this.Yc=0,this.Zc=[],this.Ka=0}function N(){this.Ra=0,this.oa=[],this.h=this.u=this.bb=this.Sb=this.pa=0}function L(t){return t.Ra>>>(t.u&Ur-1)>>>0}function A(t){return e(t.bb<=t.Sb),t.h||t.bb==t.Sb&&t.u>Ur}function x(t,e){t.u=e,t.h=A(t)}function S(t){t.u>=zr&&(e(t.u>=zr),b(t))}function _(t){e(null!=t&&null!=t.oa),t.pa<t.Zc?(t.I=(t.oa[t.pa++]|t.I<<8)>>>0,t.b+=8):(e(null!=t&&null!=t.oa),t.pa<t.Yc?(t.b+=8,t.I=t.oa[t.pa++]|t.I<<8):t.Ka?t.b=0:(t.I<<=8,t.b+=8,t.Ka=1))}function P(t){return g(t,1)}function k(t,e){var r=t.Ca;0>t.b&&_(t);var n=t.b,i=r*e>>>8,a=(t.I>>>n>i)+0;for(a?(r-=i,t.I-=i+1<<n>>>0):r=i+1,n=r,i=0;256<=n;)i+=8,n>>=8;return n=7^i+Hr[n],t.b-=n,t.Ca=(r<<n)-1,a}function I(t,e,r){t[e+0]=r>>24&255,t[e+1]=r>>16&255,t[e+2]=r>>8&255,t[e+3]=r>>0&255}function F(t,e){return t[e+0]<<0|t[e+1]<<8}function C(t,e){return F(t,e)|t[e+2]<<16}function j(t,e){return F(t,e)|F(t,e+2)<<16}function O(t,r){var n=1<<r;return e(null!=t),e(0<r),t.X=a(n),null==t.X?0:(t.Mb=32-r,t.Xa=r,1)}function B(t,r){e(null!=t),e(null!=r),e(t.Xa==r.Xa),n(r.X,0,t.X,0,1<<r.Xa)}function M(){this.X=[],this.Xa=this.Mb=0}function E(t,r,n,i){e(null!=n),e(null!=i);var a=n[0],o=i[0];return 0==a&&(a=(t*o+r/2)/r),0==o&&(o=(r*a+t/2)/t),0>=a||0>=o?0:(n[0]=a,i[0]=o,1)}function q(t,e){return t+(1<<e)-1>>>e}function D(t,e){return((4278255360&t)+(4278255360&e)>>>0&4278255360)+((16711935&t)+(16711935&e)>>>0&16711935)>>>0}function R(e,r){t[r]=function(r,n,i,a,o,s,c){var u;for(u=0;u<o;++u){var h=t[e](s[c+u-1],i,a+u);s[c+u]=D(r[n+u],h)}}}function T(){this.ud=this.hd=this.jd=0}function U(t,e){return((4278124286&(t^e))>>>1)+(t&e)>>>0}function z(t){return 0<=t&&256>t?t:0>t?0:255<t?255:void 0}function H(t,e){return z(t+(t-e+.5>>1))}function W(t,e,r){return Math.abs(e-r)-Math.abs(t-r)}function V(t,e,r,n,i,a,o){for(n=a[o-1],r=0;r<i;++r)a[o+r]=n=D(t[e+r],n)}function G(t,e,r,n,i){var a;for(a=0;a<r;++a){var o=t[e+a],s=o>>8&255,c=16711935&(c=(c=16711935&o)+((s<<16)+s));n[i+a]=(4278255360&o)+c>>>0}}function Y(t,e){e.jd=t>>0&255,e.hd=t>>8&255,e.ud=t>>16&255}function J(t,e,r,n,i,a){var o;for(o=0;o<n;++o){var s=e[r+o],c=s>>>8,u=s,h=255&(h=(h=s>>>16)+((t.jd<<24>>24)*(c<<24>>24)>>>5));u=255&(u=(u=u+((t.hd<<24>>24)*(c<<24>>24)>>>5))+((t.ud<<24>>24)*(h<<24>>24)>>>5));i[a+o]=(4278255360&s)+(h<<16)+u}}function X(e,r,n,i,a){t[r]=function(t,e,r,n,o,s,c,u,h){for(n=c;n<u;++n)for(c=0;c<h;++c)o[s++]=a(r[i(t[e++])])},t[e]=function(e,r,o,s,c,u,h){var l=8>>e.b,f=e.Ea,d=e.K[0],p=e.w;if(8>l)for(e=(1<<e.b)-1,p=(1<<l)-1;r<o;++r){var g,m=0;for(g=0;g<f;++g)g&e||(m=i(s[c++])),u[h++]=a(d[m&p]),m>>=l}else t["VP8LMapColor"+n](s,c,d,p,u,h,r,o,f)}}function K(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255}}function Z(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255,n[i++]=a>>24&255}}function $(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&240|o>>12&15,o=o>>0&240|o>>28&15;n[i++]=a,n[i++]=o}}function Q(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&248|o>>13&7,o=o>>5&224|o>>3&31;n[i++]=a,n[i++]=o}}function tt(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>0&255,n[i++]=a>>8&255,n[i++]=a>>16&255}}function et(t,e,r,i,a,o){if(0==o)for(r=e+r;e<r;)I(i,((o=t[e++])[0]>>24|o[1]>>8&65280|o[2]<<8&16711680|o[3]<<24)>>>0),a+=32;else n(i,a,t,e,r)}function rt(e,r){t[r][0]=t[e+"0"],t[r][1]=t[e+"1"],t[r][2]=t[e+"2"],t[r][3]=t[e+"3"],t[r][4]=t[e+"4"],t[r][5]=t[e+"5"],t[r][6]=t[e+"6"],t[r][7]=t[e+"7"],t[r][8]=t[e+"8"],t[r][9]=t[e+"9"],t[r][10]=t[e+"10"],t[r][11]=t[e+"11"],t[r][12]=t[e+"12"],t[r][13]=t[e+"13"],t[r][14]=t[e+"0"],t[r][15]=t[e+"0"]}function nt(t){return t==Hn||t==Wn||t==Vn||t==Gn}function it(){this.eb=[],this.size=this.A=this.fb=0}function at(){this.y=[],this.f=[],this.ea=[],this.F=[],this.Tc=this.Ed=this.Cd=this.Fd=this.lb=this.Db=this.Ab=this.fa=this.J=this.W=this.N=this.O=0}function ot(){this.Rd=this.height=this.width=this.S=0,this.f={},this.f.RGBA=new it,this.f.kb=new at,this.sd=null}function st(){this.width=[0],this.height=[0],this.Pd=[0],this.Qd=[0],this.format=[0]}function ct(){this.Id=this.fd=this.Md=this.hb=this.ib=this.da=this.bd=this.cd=this.j=this.v=this.Da=this.Sd=this.ob=0}function ut(t){return alert("todo:WebPSamplerProcessPlane"),t.T}function ht(t,e){var r=t.T,i=e.ba.f.RGBA,a=i.eb,o=i.fb+t.ka*i.A,s=vi[e.ba.S],c=t.y,u=t.O,h=t.f,l=t.N,f=t.ea,d=t.W,p=e.cc,g=e.dc,m=e.Mc,v=e.Nc,b=t.ka,y=t.ka+t.T,w=t.U,N=w+1>>1;for(0==b?s(c,u,null,null,h,l,f,d,h,l,f,d,a,o,null,null,w):(s(e.ec,e.fc,c,u,p,g,m,v,h,l,f,d,a,o-i.A,a,o,w),++r);b+2<y;b+=2)p=h,g=l,m=f,v=d,l+=t.Rc,d+=t.Rc,o+=2*i.A,s(c,(u+=2*t.fa)-t.fa,c,u,p,g,m,v,h,l,f,d,a,o-i.A,a,o,w);return u+=t.fa,t.j+y<t.o?(n(e.ec,e.fc,c,u,w),n(e.cc,e.dc,h,l,N),n(e.Mc,e.Nc,f,d,N),r--):1&y||s(c,u,null,null,h,l,f,d,h,l,f,d,a,o+i.A,null,null,w),r}function lt(t,r,n){var i=t.F,a=[t.J];if(null!=i){var o=t.U,s=r.ba.S,c=s==Tn||s==Vn;r=r.ba.f.RGBA;var u=[0],h=t.ka;u[0]=t.T,t.Kb&&(0==h?--u[0]:(--h,a[0]-=t.width),t.j+t.ka+t.T==t.o&&(u[0]=t.o-t.j-h));var l=r.eb;h=r.fb+h*r.A;t=Sn(i,a[0],t.width,o,u,l,h+(c?0:3),r.A),e(n==u),t&&nt(s)&&An(l,h,c,o,u,r.A)}return 0}function ft(t){var e=t.ma,r=e.ba.S,n=11>r,i=r==qn||r==Rn||r==Tn||r==Un||12==r||nt(r);if(e.memory=null,e.Ib=null,e.Jb=null,e.Nd=null,!Mr(e.Oa,t,i?11:12))return 0;if(i&&nt(r)&&br(),t.da)alert("todo:use_scaling");else{if(n){if(e.Ib=ut,t.Kb){if(r=t.U+1>>1,e.memory=a(t.U+2*r),null==e.memory)return 0;e.ec=e.memory,e.fc=0,e.cc=e.ec,e.dc=e.fc+t.U,e.Mc=e.cc,e.Nc=e.dc+r,e.Ib=ht,br()}}else alert("todo:EmitYUV");i&&(e.Jb=lt,n&&mr())}if(n&&!Ci){for(t=0;256>t;++t)ji[t]=89858*(t-128)+_i>>Si,Mi[t]=-22014*(t-128)+_i,Bi[t]=-45773*(t-128),Oi[t]=113618*(t-128)+_i>>Si;for(t=Pi;t<ki;++t)e=76283*(t-16)+_i>>Si,Ei[t-Pi]=Vt(e,255),qi[t-Pi]=Vt(e+8>>4,15);Ci=1}return 1}function dt(t){var r=t.ma,n=t.U,i=t.T;return e(!(1&t.ka)),0>=n||0>=i?0:(n=r.Ib(t,r),null!=r.Jb&&r.Jb(t,r,n),r.Dc+=n,1)}function pt(t){t.ma.memory=null}function gt(t,e,r,n){return 47!=y(t,8)?0:(e[0]=y(t,14)+1,r[0]=y(t,14)+1,n[0]=y(t,1),0!=y(t,3)?0:!t.h)}function mt(t,e){if(4>t)return t+1;var r=t-2>>1;return(2+(1&t)<<r)+y(e,r)+1}function vt(t,e){return 120<e?e-120:1<=(r=((r=$n[e-1])>>4)*t+(8-(15&r)))?r:1;var r}function bt(t,e,r){var n=L(r),i=t[e+=255&n].g-8;return 0<i&&(x(r,r.u+8),n=L(r),e+=t[e].value,e+=n&(1<<i)-1),x(r,r.u+t[e].g),t[e].value}function yt(t,r,n){return n.g+=t.g,n.value+=t.value<<r>>>0,e(8>=n.g),t.g}function wt(t,r,n){var i=t.xc;return e((r=0==i?0:t.vc[t.md*(n>>i)+(r>>i)])<t.Wb),t.Ya[r]}function Nt(t,r,i,a){var o=t.ab,s=t.c*r,c=t.C;r=c+r;var u=i,h=a;for(a=t.Ta,i=t.Ua;0<o--;){var l=t.gc[o],f=c,d=r,p=u,g=h,m=(h=a,u=i,l.Ea);switch(e(f<d),e(d<=l.nc),l.hc){case 2:Gr(p,g,(d-f)*m,h,u);break;case 0:var v=f,b=d,y=h,w=u,N=(_=l).Ea;0==v&&(Wr(p,g,null,null,1,y,w),V(p,g+1,0,0,N-1,y,w+1),g+=N,w+=N,++v);for(var L=1<<_.b,A=L-1,x=q(N,_.b),S=_.K,_=_.w+(v>>_.b)*x;v<b;){var P=S,k=_,I=1;for(Vr(p,g,y,w-N,1,y,w);I<N;){var F=(I&~A)+L;F>N&&(F=N),(0,Zr[P[k++]>>8&15])(p,g+ +I,y,w+I-N,F-I,y,w+I),I=F}g+=N,w+=N,++v&A||(_+=x)}d!=l.nc&&n(h,u-m,h,u+(d-f-1)*m,m);break;case 1:for(m=p,b=g,N=(p=l.Ea)-(w=p&~(y=(g=1<<l.b)-1)),v=q(p,l.b),L=l.K,l=l.w+(f>>l.b)*v;f<d;){for(A=L,x=l,S=new T,_=b+w,P=b+p;b<_;)Y(A[x++],S),$r(S,m,b,g,h,u),b+=g,u+=g;b<P&&(Y(A[x++],S),$r(S,m,b,N,h,u),b+=N,u+=N),++f&y||(l+=v)}break;case 3:if(p==h&&g==u&&0<l.b){for(b=h,p=m=u+(d-f)*m-(w=(d-f)*q(l.Ea,l.b)),g=h,y=u,v=[],w=(N=w)-1;0<=w;--w)v[w]=g[y+w];for(w=N-1;0<=w;--w)b[p+w]=v[w];Yr(l,f,d,h,m,h,u)}else Yr(l,f,d,p,g,h,u)}u=a,h=i}h!=i&&n(a,i,u,h,s)}function Lt(t,r){var n=t.V,i=t.Ba+t.c*t.C,a=r-t.C;if(e(r<=t.l.o),e(16>=a),0<a){var o=t.l,s=t.Ta,c=t.Ua,u=o.width;if(Nt(t,a,n,i),a=c=[c],e((n=t.C)<(i=r)),e(o.v<o.va),i>o.o&&(i=o.o),n<o.j){var h=o.j-n;n=o.j;a[0]+=h*u}if(n>=i?n=0:(a[0]+=4*o.v,o.ka=n-o.j,o.U=o.va-o.v,o.T=i-n,n=1),n){if(c=c[0],11>(n=t.ca).S){var l=n.f.RGBA,f=(i=n.S,a=o.U,o=o.T,h=l.eb,l.A),d=o;for(l=l.fb+t.Ma*l.A;0<d--;){var p=s,g=c,m=a,v=h,b=l;switch(i){case En:Qr(p,g,m,v,b);break;case qn:tn(p,g,m,v,b);break;case Hn:tn(p,g,m,v,b),An(v,b,0,m,1,0);break;case Dn:nn(p,g,m,v,b);break;case Rn:et(p,g,m,v,b,1);break;case Wn:et(p,g,m,v,b,1),An(v,b,0,m,1,0);break;case Tn:et(p,g,m,v,b,0);break;case Vn:et(p,g,m,v,b,0),An(v,b,1,m,1,0);break;case Un:en(p,g,m,v,b);break;case Gn:en(p,g,m,v,b),xn(v,b,m,1,0);break;case zn:rn(p,g,m,v,b);break;default:e(0)}c+=u,l+=f}t.Ma+=o}else alert("todo:EmitRescaledRowsYUVA");e(t.Ma<=n.height)}}t.C=r,e(t.C<=t.i)}function At(t){var e;if(0<t.ua)return 0;for(e=0;e<t.Wb;++e){var r=t.Ya[e].G,n=t.Ya[e].H;if(0<r[1][n[1]+0].g||0<r[2][n[2]+0].g||0<r[3][n[3]+0].g)return 0}return 1}function xt(t,r,n,i,a,o){if(0!=t.Z){var s=t.qd,c=t.rd;for(e(null!=mi[t.Z]);r<n;++r)mi[t.Z](s,c,i,a,i,a,o),s=i,c=a,a+=o;t.qd=s,t.rd=c}}function St(t,r){var n=t.l.ma,i=0==n.Z||1==n.Z?t.l.j:t.C;i=t.C<i?i:t.C;if(e(r<=t.l.o),r>i){var a=t.l.width,o=n.ca,s=n.tb+a*i,c=t.V,u=t.Ba+t.c*i,h=t.gc;e(1==t.ab),e(3==h[0].hc),Xr(h[0],i,r,c,u,o,s),xt(n,i,r,o,s,a)}t.C=t.Ma=r}function _t(t,r,n,i,a,o,s){var c=t.$/i,u=t.$%i,h=t.m,l=t.s,f=n+t.$,d=f;a=n+i*a;var p=n+i*o,g=280+l.ua,m=t.Pb?c:16777216,v=0<l.ua?l.Wa:null,b=l.wc,y=f<p?wt(l,u,c):null;e(t.C<o),e(p<=a);var w=!1;t:for(;;){for(;w||f<p;){var N=0;if(c>=m){var _=f-n;e((m=t).Pb),m.wd=m.m,m.xd=_,0<m.s.ua&&B(m.s.Wa,m.s.vb),m=c+ti}if(u&b||(y=wt(l,u,c)),e(null!=y),y.Qb&&(r[f]=y.qb,w=!0),!w)if(S(h),y.jc){N=h,_=r;var P=f,k=y.pd[L(N)&Dr-1];e(y.jc),256>k.g?(x(N,N.u+k.g),_[P]=k.value,N=0):(x(N,N.u+k.g-256),e(256<=k.value),N=k.value),0==N&&(w=!0)}else N=bt(y.G[0],y.H[0],h);if(h.h)break;if(w||256>N){if(!w)if(y.nd)r[f]=(y.qb|N<<8)>>>0;else{if(S(h),w=bt(y.G[1],y.H[1],h),S(h),_=bt(y.G[2],y.H[2],h),P=bt(y.G[3],y.H[3],h),h.h)break;r[f]=(P<<24|w<<16|N<<8|_)>>>0}if(w=!1,++f,++u>=i&&(u=0,++c,null!=s&&c<=o&&!(c%16)&&s(t,c),null!=v))for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N}else if(280>N){if(N=mt(N-256,h),_=bt(y.G[4],y.H[4],h),S(h),_=vt(i,_=mt(_,h)),h.h)break;if(f-n<_||a-f<N)break t;for(P=0;P<N;++P)r[f+P]=r[f+P-_];for(f+=N,u+=N;u>=i;)u-=i,++c,null!=s&&c<=o&&!(c%16)&&s(t,c);if(e(f<=a),u&b&&(y=wt(l,u,c)),null!=v)for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N}else{if(!(N<g))break t;for(w=N-280,e(null!=v);d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N;N=f,e(!(w>>>(_=v).Xa)),r[N]=_.X[w],w=!0}w||e(h.h==A(h))}if(t.Pb&&h.h&&f<a)e(t.m.h),t.a=5,t.m=t.wd,t.$=t.xd,0<t.s.ua&&B(t.s.vb,t.s.Wa);else{if(h.h)break t;null!=s&&s(t,c>o?o:c),t.a=0,t.$=f-n}return 1}return t.a=3,0}function Pt(t){e(null!=t),t.vc=null,t.yc=null,t.Ya=null;var r=t.Wa;null!=r&&(r.X=null),t.vb=null,e(null!=t)}function kt(){var e=new or;return null==e?null:(e.a=0,e.xb=gi,rt("Predictor","VP8LPredictors"),rt("Predictor","VP8LPredictors_C"),rt("PredictorAdd","VP8LPredictorsAdd"),rt("PredictorAdd","VP8LPredictorsAdd_C"),Gr=G,$r=J,Qr=K,tn=Z,en=$,rn=Q,nn=tt,t.VP8LMapColor32b=Jr,t.VP8LMapColor8b=Kr,e)}function It(t,r,n,s,c){var u=1,f=[t],p=[r],g=s.m,m=s.s,v=null,b=0;t:for(;;){if(n)for(;u&&y(g,1);){var w=f,N=p,A=s,_=1,P=A.m,k=A.gc[A.ab],I=y(P,2);if(A.Oc&1<<I)u=0;else{switch(A.Oc|=1<<I,k.hc=I,k.Ea=w[0],k.nc=N[0],k.K=[null],++A.ab,e(4>=A.ab),I){case 0:case 1:k.b=y(P,3)+2,_=It(q(k.Ea,k.b),q(k.nc,k.b),0,A,k.K),k.K=k.K[0];break;case 3:var F,C=y(P,8)+1,j=16<C?0:4<C?1:2<C?2:3;if(w[0]=q(k.Ea,j),k.b=j,F=_=It(C,1,0,A,k.K)){var B,M=C,E=k,R=1<<(8>>E.b),T=a(R);if(null==T)F=0;else{var U=E.K[0],z=E.w;for(T[0]=E.K[0][0],B=1;B<1*M;++B)T[B]=D(U[z+B],T[B-1]);for(;B<4*R;++B)T[B]=0;E.K[0]=null,E.K[0]=T,F=1}}_=F;break;case 2:break;default:e(0)}u=_}}if(f=f[0],p=p[0],u&&y(g,1)&&!(u=1<=(b=y(g,4))&&11>=b)){s.a=3;break t}var H;if(H=u)e:{var W,V,G,Y=s,J=f,X=p,K=b,Z=n,$=Y.m,Q=Y.s,tt=[null],et=1,rt=0,nt=Qn[K];r:for(;;){if(Z&&y($,1)){var it=y($,3)+2,at=q(J,it),ot=q(X,it),st=at*ot;if(!It(at,ot,0,Y,tt))break r;for(tt=tt[0],Q.xc=it,W=0;W<st;++W){var ct=tt[W]>>8&65535;tt[W]=ct,ct>=et&&(et=ct+1)}}if($.h)break r;for(V=0;5>V;++V){var ut=Xn[V];!V&&0<K&&(ut+=1<<K),rt<ut&&(rt=ut)}var ht=o(et*nt,l),lt=et,ft=o(lt,d);if(null==ft)var dt=null;else e(65536>=lt),dt=ft;var pt=a(rt);if(null==dt||null==pt||null==ht){Y.a=1;break r}var gt=ht;for(W=G=0;W<et;++W){var mt=dt[W],vt=mt.G,bt=mt.H,wt=0,Nt=1,Lt=0;for(V=0;5>V;++V){ut=Xn[V],vt[V]=gt,bt[V]=G,!V&&0<K&&(ut+=1<<K);n:{var At,xt=ut,St=Y,kt=pt,Ft=gt,Ct=G,jt=0,Ot=St.m,Bt=y(Ot,1);if(i(kt,0,0,xt),Bt){var Mt=y(Ot,1)+1,Et=y(Ot,1),qt=y(Ot,0==Et?1:8);kt[qt]=1,2==Mt&&(kt[qt=y(Ot,8)]=1);var Dt=1}else{var Rt=a(19),Tt=y(Ot,4)+4;if(19<Tt){St.a=3;var Ut=0;break n}for(At=0;At<Tt;++At)Rt[Zn[At]]=y(Ot,3);var zt=void 0,Ht=void 0,Wt=St,Vt=Rt,Gt=xt,Yt=kt,Jt=0,Xt=Wt.m,Kt=8,Zt=o(128,l);i:for(;h(Zt,0,7,Vt,19);){if(y(Xt,1)){var $t=2+2*y(Xt,3);if((zt=2+y(Xt,$t))>Gt)break i}else zt=Gt;for(Ht=0;Ht<Gt&&zt--;){S(Xt);var Qt=Zt[0+(127&L(Xt))];x(Xt,Xt.u+Qt.g);var te=Qt.value;if(16>te)Yt[Ht++]=te,0!=te&&(Kt=te);else{var ee=16==te,re=te-16,ne=Jn[re],ie=y(Xt,Yn[re])+ne;if(Ht+ie>Gt)break i;for(var ae=ee?Kt:0;0<ie--;)Yt[Ht++]=ae}}Jt=1;break i}Jt||(Wt.a=3),Dt=Jt}(Dt=Dt&&!Ot.h)&&(jt=h(Ft,Ct,8,kt,xt)),Dt&&0!=jt?Ut=jt:(St.a=3,Ut=0)}if(0==Ut)break r;if(Nt&&1==Kn[V]&&(Nt=0==gt[G].g),wt+=gt[G].g,G+=Ut,3>=V){var oe,se=pt[0];for(oe=1;oe<ut;++oe)pt[oe]>se&&(se=pt[oe]);Lt+=se}}if(mt.nd=Nt,mt.Qb=0,Nt&&(mt.qb=(vt[3][bt[3]+0].value<<24|vt[1][bt[1]+0].value<<16|vt[2][bt[2]+0].value)>>>0,0==wt&&256>vt[0][bt[0]+0].value&&(mt.Qb=1,mt.qb+=vt[0][bt[0]+0].value<<8)),mt.jc=!mt.Qb&&6>Lt,mt.jc){var ce,ue=mt;for(ce=0;ce<Dr;++ce){var he=ce,le=ue.pd[he],fe=ue.G[0][ue.H[0]+he];256<=fe.value?(le.g=fe.g+256,le.value=fe.value):(le.g=0,le.value=0,he>>=yt(fe,8,le),he>>=yt(ue.G[1][ue.H[1]+he],16,le),he>>=yt(ue.G[2][ue.H[2]+he],0,le),yt(ue.G[3][ue.H[3]+he],24,le))}}}Q.vc=tt,Q.Wb=et,Q.Ya=dt,Q.yc=ht,H=1;break e}H=0}if(!(u=H)){s.a=3;break t}if(0<b){if(m.ua=1<<b,!O(m.Wa,b)){s.a=1,u=0;break t}}else m.ua=0;var de=s,pe=f,ge=p,me=de.s,ve=me.xc;if(de.c=pe,de.i=ge,me.md=q(pe,ve),me.wc=0==ve?-1:(1<<ve)-1,n){s.xb=pi;break t}if(null==(v=a(f*p))){s.a=1,u=0;break t}u=(u=_t(s,v,0,f,p,p,null))&&!g.h;break t}return u?(null!=c?c[0]=v:(e(null==v),e(n)),s.$=0,n||Pt(m)):Pt(m),u}function Ft(t,r){var n=t.c*t.i,i=n+r+16*r;return e(t.c<=r),t.V=a(i),null==t.V?(t.Ta=null,t.Ua=0,t.a=1,0):(t.Ta=t.V,t.Ua=t.Ba+n+r,1)}function Ct(t,r){var n=t.C,i=r-n,a=t.V,o=t.Ba+t.c*n;for(e(r<=t.l.o);0<i;){var s=16<i?16:i,c=t.l.ma,u=t.l.width,h=u*s,l=c.ca,f=c.tb+u*n,d=t.Ta,p=t.Ua;Nt(t,s,a,o),_n(d,p,l,f,h),xt(c,n,n+s,l,f,u),i-=s,a+=s*t.c,n+=s}e(n==r),t.C=t.Ma=r}function jt(){this.ub=this.yd=this.td=this.Rb=0}function Ot(){this.Kd=this.Ld=this.Ud=this.Td=this.i=this.c=0}function Bt(){this.Fb=this.Bb=this.Cb=0,this.Zb=a(4),this.Lb=a(4)}function Mt(){this.Yb=function(){var t=[];return function t(e,r,n){for(var i=n[r],a=0;a<i&&(e.push(n.length>r+1?[]:0),!(n.length<r+1));a++)t(e[a],r+1,n)}(t,0,[3,11]),t}()}function Et(){this.jb=a(3),this.Wc=s([4,8],Mt),this.Xc=s([4,17],Mt)}function qt(){this.Pc=this.wb=this.Tb=this.zd=0,this.vd=new a(4),this.od=new a(4)}function Dt(){this.ld=this.La=this.dd=this.tc=0}function Rt(){this.Na=this.la=0}function Tt(){this.Sc=[0,0],this.Eb=[0,0],this.Qc=[0,0],this.ia=this.lc=0}function Ut(){this.ad=a(384),this.Za=0,this.Ob=a(16),this.$b=this.Ad=this.ia=this.Gc=this.Hc=this.Dd=0}function zt(){this.uc=this.M=this.Nb=0,this.wa=Array(new Dt),this.Y=0,this.ya=Array(new Ut),this.aa=0,this.l=new Gt}function Ht(){this.y=a(16),this.f=a(8),this.ea=a(8)}function Wt(){this.cb=this.a=0,this.sc="",this.m=new w,this.Od=new jt,this.Kc=new Ot,this.ed=new qt,this.Qa=new Bt,this.Ic=this.$c=this.Aa=0,this.D=new zt,this.Xb=this.Va=this.Hb=this.zb=this.yb=this.Ub=this.za=0,this.Jc=o(8,w),this.ia=0,this.pb=o(4,Tt),this.Pa=new Et,this.Bd=this.kc=0,this.Ac=[],this.Bc=0,this.zc=[0,0,0,0],this.Gd=Array(new Ht),this.Hd=0,this.rb=Array(new Rt),this.sb=0,this.wa=Array(new Dt),this.Y=0,this.oc=[],this.pc=0,this.sa=[],this.ta=0,this.qa=[],this.ra=0,this.Ha=[],this.B=this.R=this.Ia=0,this.Ec=[],this.M=this.ja=this.Vb=this.Fc=0,this.ya=Array(new Ut),this.L=this.aa=0,this.gd=s([4,2],Dt),this.ga=null,this.Fa=[],this.Cc=this.qc=this.P=0,this.Gb=[],this.Uc=0,this.mb=[],this.nb=0,this.rc=[],this.Ga=this.Vc=0}function Vt(t,e){return 0>t?0:t>e?e:t}function Gt(){this.T=this.U=this.ka=this.height=this.width=0,this.y=[],this.f=[],this.ea=[],this.Rc=this.fa=this.W=this.N=this.O=0,this.ma="void",this.put="VP8IoPutHook",this.ac="VP8IoSetupHook",this.bc="VP8IoTeardownHook",this.ha=this.Kb=0,this.data=[],this.hb=this.ib=this.da=this.o=this.j=this.va=this.v=this.Da=this.ob=this.w=0,this.F=[],this.J=0}function Yt(){var t=new Wt;return null!=t&&(t.a=0,t.sc="OK",t.cb=0,t.Xb=0,ni||(ni=Zt)),t}function Jt(t,e,r){return 0==t.a&&(t.a=e,t.sc=r,t.cb=0),0}function Xt(t,e,r){return 3<=r&&157==t[e+0]&&1==t[e+1]&&42==t[e+2]}function Kt(t,r){if(null==t)return 0;if(t.a=0,t.sc="OK",null==r)return Jt(t,2,"null VP8Io passed to VP8GetHeaders()");var n=r.data,a=r.w,o=r.ha;if(4>o)return Jt(t,7,"Truncated header.");var s=n[a+0]|n[a+1]<<8|n[a+2]<<16,c=t.Od;if(c.Rb=!(1&s),c.td=s>>1&7,c.yd=s>>4&1,c.ub=s>>5,3<c.td)return Jt(t,3,"Incorrect keyframe parameters.");if(!c.yd)return Jt(t,4,"Frame not displayable.");a+=3,o-=3;var u=t.Kc;if(c.Rb){if(7>o)return Jt(t,7,"cannot parse picture header");if(!Xt(n,a,o))return Jt(t,3,"Bad code word");u.c=16383&(n[a+4]<<8|n[a+3]),u.Td=n[a+4]>>6,u.i=16383&(n[a+6]<<8|n[a+5]),u.Ud=n[a+6]>>6,a+=7,o-=7,t.za=u.c+15>>4,t.Ub=u.i+15>>4,r.width=u.c,r.height=u.i,r.Da=0,r.j=0,r.v=0,r.va=r.width,r.o=r.height,r.da=0,r.ib=r.width,r.hb=r.height,r.U=r.width,r.T=r.height,i((s=t.Pa).jb,0,255,s.jb.length),e(null!=(s=t.Qa)),s.Cb=0,s.Bb=0,s.Fb=1,i(s.Zb,0,0,s.Zb.length),i(s.Lb,0,0,s.Lb)}if(c.ub>o)return Jt(t,7,"bad partition length");p(s=t.m,n,a,c.ub),a+=c.ub,o-=c.ub,c.Rb&&(u.Ld=P(s),u.Kd=P(s)),u=t.Qa;var h,l=t.Pa;if(e(null!=s),e(null!=u),u.Cb=P(s),u.Cb){if(u.Bb=P(s),P(s)){for(u.Fb=P(s),h=0;4>h;++h)u.Zb[h]=P(s)?m(s,7):0;for(h=0;4>h;++h)u.Lb[h]=P(s)?m(s,6):0}if(u.Bb)for(h=0;3>h;++h)l.jb[h]=P(s)?g(s,8):255}else u.Bb=0;if(s.Ka)return Jt(t,3,"cannot parse segment header");if((u=t.ed).zd=P(s),u.Tb=g(s,6),u.wb=g(s,3),u.Pc=P(s),u.Pc&&P(s)){for(l=0;4>l;++l)P(s)&&(u.vd[l]=m(s,6));for(l=0;4>l;++l)P(s)&&(u.od[l]=m(s,6))}if(t.L=0==u.Tb?0:u.zd?1:2,s.Ka)return Jt(t,3,"cannot parse filter header");var f=o;if(o=h=a,a=h+f,u=f,t.Xb=(1<<g(t.m,2))-1,f<3*(l=t.Xb))n=7;else{for(h+=3*l,u-=3*l,f=0;f<l;++f){var d=n[o+0]|n[o+1]<<8|n[o+2]<<16;d>u&&(d=u),p(t.Jc[+f],n,h,d),h+=d,u-=d,o+=3}p(t.Jc[+l],n,h,u),n=h<a?0:5}if(0!=n)return Jt(t,n,"cannot parse partitions");for(n=g(h=t.m,7),o=P(h)?m(h,4):0,a=P(h)?m(h,4):0,u=P(h)?m(h,4):0,l=P(h)?m(h,4):0,h=P(h)?m(h,4):0,f=t.Qa,d=0;4>d;++d){if(f.Cb){var v=f.Zb[d];f.Fb||(v+=n)}else{if(0<d){t.pb[d]=t.pb[0];continue}v=n}var b=t.pb[d];b.Sc[0]=ei[Vt(v+o,127)],b.Sc[1]=ri[Vt(v+0,127)],b.Eb[0]=2*ei[Vt(v+a,127)],b.Eb[1]=101581*ri[Vt(v+u,127)]>>16,8>b.Eb[1]&&(b.Eb[1]=8),b.Qc[0]=ei[Vt(v+l,117)],b.Qc[1]=ri[Vt(v+h,127)],b.lc=v+h}if(!c.Rb)return Jt(t,4,"Not a key frame.");for(P(s),c=t.Pa,n=0;4>n;++n){for(o=0;8>o;++o)for(a=0;3>a;++a)for(u=0;11>u;++u)l=k(s,ui[n][o][a][u])?g(s,8):si[n][o][a][u],c.Wc[n][o].Yb[a][u]=l;for(o=0;17>o;++o)c.Xc[n][o]=c.Wc[n][hi[o]]}return t.kc=P(s),t.kc&&(t.Bd=g(s,8)),t.cb=1}function Zt(t,e,r,n,i,a,o){var s=e[i].Yb[r];for(r=0;16>i;++i){if(!k(t,s[r+0]))return i;for(;!k(t,s[r+1]);)if(s=e[++i].Yb[0],r=0,16==i)return 16;var c=e[i+1].Yb;if(k(t,s[r+2])){var u=t,h=0;if(k(u,(f=s)[(l=r)+3]))if(k(u,f[l+6])){for(s=0,l=2*(h=k(u,f[l+8]))+(f=k(u,f[l+9+h])),h=0,f=ii[l];f[s];++s)h+=h+k(u,f[s]);h+=3+(8<<l)}else k(u,f[l+7])?(h=7+2*k(u,165),h+=k(u,145)):h=5+k(u,159);else h=k(u,f[l+4])?3+k(u,f[l+5]):2;s=c[2]}else h=1,s=c[1];c=o+ai[i],0>(u=t).b&&_(u);var l,f=u.b,d=(l=u.Ca>>1)-(u.I>>f)>>31;--u.b,u.Ca+=d,u.Ca|=1,u.I-=(l+1&d)<<f,a[c]=((h^d)-d)*n[(0<i)+0]}return 16}function $t(t){var e=t.rb[t.sb-1];e.la=0,e.Na=0,i(t.zc,0,0,t.zc.length),t.ja=0}function Qt(t,r){if(null==t)return 0;if(null==r)return Jt(t,2,"NULL VP8Io parameter in VP8Decode().");if(!t.cb&&!Kt(t,r))return 0;if(e(t.cb),null==r.ac||r.ac(r)){r.ob&&(t.L=0);var s=Ri[t.L];if(2==t.L?(t.yb=0,t.zb=0):(t.yb=r.v-s>>4,t.zb=r.j-s>>4,0>t.yb&&(t.yb=0),0>t.zb&&(t.zb=0)),t.Va=r.o+15+s>>4,t.Hb=r.va+15+s>>4,t.Hb>t.za&&(t.Hb=t.za),t.Va>t.Ub&&(t.Va=t.Ub),0<t.L){var c=t.ed;for(s=0;4>s;++s){var u;if(t.Qa.Cb){var h=t.Qa.Lb[s];t.Qa.Fb||(h+=c.Tb)}else h=c.Tb;for(u=0;1>=u;++u){var l=t.gd[s][u],f=h;if(c.Pc&&(f+=c.vd[0],u&&(f+=c.od[0])),0<(f=0>f?0:63<f?63:f)){var d=f;0<c.wb&&((d=4<c.wb?d>>2:d>>1)>9-c.wb&&(d=9-c.wb)),1>d&&(d=1),l.dd=d,l.tc=2*f+d,l.ld=40<=f?2:15<=f?1:0}else l.tc=0;l.La=u}}}s=0}else Jt(t,6,"Frame setup failed"),s=t.a;if(s=0==s){if(s){t.$c=0,0<t.Aa||(t.Ic=Ui);t:{s=t.Ic;c=4*(d=t.za);var p=32*d,g=d+1,m=0<t.L?d*(0<t.Aa?2:1):0,v=(2==t.Aa?2:1)*d;if((l=c+832+(u=3*(16*s+Ri[t.L])/2*p)+(h=null!=t.Fa&&0<t.Fa.length?t.Kc.c*t.Kc.i:0))!=l)s=0;else{if(l>t.Vb){if(t.Vb=0,t.Ec=a(l),t.Fc=0,null==t.Ec){s=Jt(t,1,"no memory during frame initialization.");break t}t.Vb=l}l=t.Ec,f=t.Fc,t.Ac=l,t.Bc=f,f+=c,t.Gd=o(p,Ht),t.Hd=0,t.rb=o(g+1,Rt),t.sb=1,t.wa=m?o(m,Dt):null,t.Y=0,t.D.Nb=0,t.D.wa=t.wa,t.D.Y=t.Y,0<t.Aa&&(t.D.Y+=d),e(!0),t.oc=l,t.pc=f,f+=832,t.ya=o(v,Ut),t.aa=0,t.D.ya=t.ya,t.D.aa=t.aa,2==t.Aa&&(t.D.aa+=d),t.R=16*d,t.B=8*d,d=(p=Ri[t.L])*t.R,p=p/2*t.B,t.sa=l,t.ta=f+d,t.qa=t.sa,t.ra=t.ta+16*s*t.R+p,t.Ha=t.qa,t.Ia=t.ra+8*s*t.B+p,t.$c=0,f+=u,t.mb=h?l:null,t.nb=h?f:null,e(f+h<=t.Fc+t.Vb),$t(t),i(t.Ac,t.Bc,0,c),s=1}}if(s){if(r.ka=0,r.y=t.sa,r.O=t.ta,r.f=t.qa,r.N=t.ra,r.ea=t.Ha,r.Vd=t.Ia,r.fa=t.R,r.Rc=t.B,r.F=null,r.J=0,!Cn){for(s=-255;255>=s;++s)Pn[255+s]=0>s?-s:s;for(s=-1020;1020>=s;++s)kn[1020+s]=-128>s?-128:127<s?127:s;for(s=-112;112>=s;++s)In[112+s]=-16>s?-16:15<s?15:s;for(s=-255;510>=s;++s)Fn[255+s]=0>s?0:255<s?255:s;Cn=1}an=ue,on=ae,cn=oe,un=se,hn=ce,sn=ie,ln=Je,fn=Xe,dn=$e,pn=Qe,gn=Ke,mn=Ze,vn=tr,bn=er,yn=ze,wn=He,Nn=We,Ln=Ve,fi[0]=xe,fi[1]=le,fi[2]=Le,fi[3]=Ae,fi[4]=Se,fi[5]=Pe,fi[6]=_e,fi[7]=ke,fi[8]=Fe,fi[9]=Ie,li[0]=ve,li[1]=de,li[2]=pe,li[3]=ge,li[4]=be,li[5]=ye,li[6]=we,di[0]=Be,di[1]=fe,di[2]=Ce,di[3]=je,di[4]=Ee,di[5]=Me,di[6]=qe,s=1}else s=0}s&&(s=function(t,r){for(t.M=0;t.M<t.Va;++t.M){var o,s=t.Jc[t.M&t.Xb],c=t.m,u=t;for(o=0;o<u.za;++o){var h=c,l=u,f=l.Ac,d=l.Bc+4*o,p=l.zc,g=l.ya[l.aa+o];if(l.Qa.Bb?g.$b=k(h,l.Pa.jb[0])?2+k(h,l.Pa.jb[2]):k(h,l.Pa.jb[1]):g.$b=0,l.kc&&(g.Ad=k(h,l.Bd)),g.Za=!k(h,145)+0,g.Za){var m=g.Ob,v=0;for(l=0;4>l;++l){var b,y=p[0+l];for(b=0;4>b;++b){y=ci[f[d+b]][y];for(var w=oi[k(h,y[0])];0<w;)w=oi[2*w+k(h,y[w])];y=-w,f[d+b]=y}n(m,v,f,d,4),v+=4,p[0+l]=y}}else y=k(h,156)?k(h,128)?1:3:k(h,163)?2:0,g.Ob[0]=y,i(f,d,y,4),i(p,0,y,4);g.Dd=k(h,142)?k(h,114)?k(h,183)?1:3:2:0}if(u.m.Ka)return Jt(t,7,"Premature end-of-partition0 encountered.");for(;t.ja<t.za;++t.ja){if(u=s,h=(c=t).rb[c.sb-1],f=c.rb[c.sb+c.ja],o=c.ya[c.aa+c.ja],d=c.kc?o.Ad:0)h.la=f.la=0,o.Za||(h.Na=f.Na=0),o.Hc=0,o.Gc=0,o.ia=0;else{var N,L;h=f,f=u,d=c.Pa.Xc,p=c.ya[c.aa+c.ja],g=c.pb[p.$b];if(l=p.ad,m=0,v=c.rb[c.sb-1],y=b=0,i(l,m,0,384),p.Za)var A=0,x=d[3];else{w=a(16);var S=h.Na+v.Na;if(S=ni(f,d[1],S,g.Eb,0,w,0),h.Na=v.Na=(0<S)+0,1<S)an(w,0,l,m);else{var _=w[0]+3>>3;for(w=0;256>w;w+=16)l[m+w]=_}A=1,x=d[0]}var P=15&h.la,I=15&v.la;for(w=0;4>w;++w){var F=1&I;for(_=L=0;4>_;++_)P=P>>1|(F=(S=ni(f,x,S=F+(1&P),g.Sc,A,l,m))>A)<<7,L=L<<2|(3<S?3:1<S?2:0!=l[m+0]),m+=16;P>>=4,I=I>>1|F<<7,b=(b<<8|L)>>>0}for(x=P,A=I>>4,N=0;4>N;N+=2){for(L=0,P=h.la>>4+N,I=v.la>>4+N,w=0;2>w;++w){for(F=1&I,_=0;2>_;++_)S=F+(1&P),P=P>>1|(F=0<(S=ni(f,d[2],S,g.Qc,0,l,m)))<<3,L=L<<2|(3<S?3:1<S?2:0!=l[m+0]),m+=16;P>>=2,I=I>>1|F<<5}y|=L<<4*N,x|=P<<4<<N,A|=(240&I)<<N}h.la=x,v.la=A,p.Hc=b,p.Gc=y,p.ia=43690&y?0:g.ia,d=!(b|y)}if(0<c.L&&(c.wa[c.Y+c.ja]=c.gd[o.$b][o.Za],c.wa[c.Y+c.ja].La|=!d),u.Ka)return Jt(t,7,"Premature end-of-file encountered.")}if($t(t),c=r,u=1,o=(s=t).D,h=0<s.L&&s.M>=s.zb&&s.M<=s.Va,0==s.Aa)t:{if(o.M=s.M,o.uc=h,Or(s,o),u=1,o=(L=s.D).Nb,h=(y=Ri[s.L])*s.R,f=y/2*s.B,w=16*o*s.R,_=8*o*s.B,d=s.sa,p=s.ta-h+w,g=s.qa,l=s.ra-f+_,m=s.Ha,v=s.Ia-f+_,I=0==(P=L.M),b=P>=s.Va-1,2==s.Aa&&Or(s,L),L.uc)for(F=(S=s).D.M,e(S.D.uc),L=S.yb;L<S.Hb;++L){A=L,x=F;var C=(j=(U=S).D).Nb;N=U.R;var j=j.wa[j.Y+A],O=U.sa,B=U.ta+16*C*N+16*A,M=j.dd,E=j.tc;if(0!=E)if(e(3<=E),1==U.L)0<A&&wn(O,B,N,E+4),j.La&&Ln(O,B,N,E),0<x&&yn(O,B,N,E+4),j.La&&Nn(O,B,N,E);else{var q=U.B,D=U.qa,R=U.ra+8*C*q+8*A,T=U.Ha,U=U.Ia+8*C*q+8*A;C=j.ld;0<A&&(fn(O,B,N,E+4,M,C),pn(D,R,T,U,q,E+4,M,C)),j.La&&(mn(O,B,N,E,M,C),bn(D,R,T,U,q,E,M,C)),0<x&&(ln(O,B,N,E+4,M,C),dn(D,R,T,U,q,E+4,M,C)),j.La&&(gn(O,B,N,E,M,C),vn(D,R,T,U,q,E,M,C))}}if(s.ia&&alert("todo:DitherRow"),null!=c.put){if(L=16*P,P=16*(P+1),I?(c.y=s.sa,c.O=s.ta+w,c.f=s.qa,c.N=s.ra+_,c.ea=s.Ha,c.W=s.Ia+_):(L-=y,c.y=d,c.O=p,c.f=g,c.N=l,c.ea=m,c.W=v),b||(P-=y),P>c.o&&(P=c.o),c.F=null,c.J=null,null!=s.Fa&&0<s.Fa.length&&L<P&&(c.J=lr(s,c,L,P-L),c.F=s.mb,null==c.F&&0==c.F.length)){u=Jt(s,3,"Could not decode alpha data.");break t}L<c.j&&(y=c.j-L,L=c.j,e(!(1&y)),c.O+=s.R*y,c.N+=s.B*(y>>1),c.W+=s.B*(y>>1),null!=c.F&&(c.J+=c.width*y)),L<P&&(c.O+=c.v,c.N+=c.v>>1,c.W+=c.v>>1,null!=c.F&&(c.J+=c.v),c.ka=L-c.j,c.U=c.va-c.v,c.T=P-L,u=c.put(c))}o+1!=s.Ic||b||(n(s.sa,s.ta-h,d,p+16*s.R,h),n(s.qa,s.ra-f,g,l+8*s.B,f),n(s.Ha,s.Ia-f,m,v+8*s.B,f))}if(!u)return Jt(t,6,"Output aborted.")}return 1}(t,r)),null!=r.bc&&r.bc(r),s&=1}return s?(t.cb=0,s):0}function te(t,e,r,n,i){i=t[e+r+32*n]+(i>>3),t[e+r+32*n]=-256&i?0>i?0:255:i}function ee(t,e,r,n,i,a){te(t,e,0,r,n+i),te(t,e,1,r,n+a),te(t,e,2,r,n-a),te(t,e,3,r,n-i)}function re(t){return(20091*t>>16)+t}function ne(t,e,r,n){var i,o=0,s=a(16);for(i=0;4>i;++i){var c=t[e+0]+t[e+8],u=t[e+0]-t[e+8],h=(35468*t[e+4]>>16)-re(t[e+12]),l=re(t[e+4])+(35468*t[e+12]>>16);s[o+0]=c+l,s[o+1]=u+h,s[o+2]=u-h,s[o+3]=c-l,o+=4,e++}for(i=o=0;4>i;++i)c=(t=s[o+0]+4)+s[o+8],u=t-s[o+8],h=(35468*s[o+4]>>16)-re(s[o+12]),te(r,n,0,0,c+(l=re(s[o+4])+(35468*s[o+12]>>16))),te(r,n,1,0,u+h),te(r,n,2,0,u-h),te(r,n,3,0,c-l),o++,n+=32}function ie(t,e,r,n){var i=t[e+0]+4,a=35468*t[e+4]>>16,o=re(t[e+4]),s=35468*t[e+1]>>16;ee(r,n,0,i+o,t=re(t[e+1]),s),ee(r,n,1,i+a,t,s),ee(r,n,2,i-a,t,s),ee(r,n,3,i-o,t,s)}function ae(t,e,r,n,i){ne(t,e,r,n),i&&ne(t,e+16,r,n+4)}function oe(t,e,r,n){on(t,e+0,r,n,1),on(t,e+32,r,n+128,1)}function se(t,e,r,n){var i;for(t=t[e+0]+4,i=0;4>i;++i)for(e=0;4>e;++e)te(r,n,e,i,t)}function ce(t,e,r,n){t[e+0]&&un(t,e+0,r,n),t[e+16]&&un(t,e+16,r,n+4),t[e+32]&&un(t,e+32,r,n+128),t[e+48]&&un(t,e+48,r,n+128+4)}function ue(t,e,r,n){var i,o=a(16);for(i=0;4>i;++i){var s=t[e+0+i]+t[e+12+i],c=t[e+4+i]+t[e+8+i],u=t[e+4+i]-t[e+8+i],h=t[e+0+i]-t[e+12+i];o[0+i]=s+c,o[8+i]=s-c,o[4+i]=h+u,o[12+i]=h-u}for(i=0;4>i;++i)s=(t=o[0+4*i]+3)+o[3+4*i],c=o[1+4*i]+o[2+4*i],u=o[1+4*i]-o[2+4*i],h=t-o[3+4*i],r[n+0]=s+c>>3,r[n+16]=h+u>>3,r[n+32]=s-c>>3,r[n+48]=h-u>>3,n+=64}function he(t,e,r){var n,i=e-32,a=Bn,o=255-t[i-1];for(n=0;n<r;++n){var s,c=a,u=o+t[e-1];for(s=0;s<r;++s)t[e+s]=c[u+t[i+s]];e+=32}}function le(t,e){he(t,e,4)}function fe(t,e){he(t,e,8)}function de(t,e){he(t,e,16)}function pe(t,e){var r;for(r=0;16>r;++r)n(t,e+32*r,t,e-32,16)}function ge(t,e){var r;for(r=16;0<r;--r)i(t,e,t[e-1],16),e+=32}function me(t,e,r){var n;for(n=0;16>n;++n)i(e,r+32*n,t,16)}function ve(t,e){var r,n=16;for(r=0;16>r;++r)n+=t[e-1+32*r]+t[e+r-32];me(n>>5,t,e)}function be(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e-1+32*r];me(n>>4,t,e)}function ye(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e+r-32];me(n>>4,t,e)}function we(t,e){me(128,t,e)}function Ne(t,e,r){return t+2*e+r+2>>2}function Le(t,e){var r,i=e-32;i=new Uint8Array([Ne(t[i-1],t[i+0],t[i+1]),Ne(t[i+0],t[i+1],t[i+2]),Ne(t[i+1],t[i+2],t[i+3]),Ne(t[i+2],t[i+3],t[i+4])]);for(r=0;4>r;++r)n(t,e+32*r,i,0,i.length)}function Ae(t,e){var r=t[e-1],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];I(t,e+0,16843009*Ne(t[e-1-32],r,n)),I(t,e+32,16843009*Ne(r,n,i)),I(t,e+64,16843009*Ne(n,i,a)),I(t,e+96,16843009*Ne(i,a,a))}function xe(t,e){var r,n=4;for(r=0;4>r;++r)n+=t[e+r-32]+t[e-1+32*r];for(n>>=3,r=0;4>r;++r)i(t,e+32*r,n,4)}function Se(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],c=t[e+2-32],u=t[e+3-32];t[e+0+96]=Ne(n,i,t[e-1+96]),t[e+1+96]=t[e+0+64]=Ne(r,n,i),t[e+2+96]=t[e+1+64]=t[e+0+32]=Ne(a,r,n),t[e+3+96]=t[e+2+64]=t[e+1+32]=t[e+0+0]=Ne(o,a,r),t[e+3+64]=t[e+2+32]=t[e+1+0]=Ne(s,o,a),t[e+3+32]=t[e+2+0]=Ne(c,s,o),t[e+3+0]=Ne(u,c,s)}function _e(t,e){var r=t[e+1-32],n=t[e+2-32],i=t[e+3-32],a=t[e+4-32],o=t[e+5-32],s=t[e+6-32],c=t[e+7-32];t[e+0+0]=Ne(t[e+0-32],r,n),t[e+1+0]=t[e+0+32]=Ne(r,n,i),t[e+2+0]=t[e+1+32]=t[e+0+64]=Ne(n,i,a),t[e+3+0]=t[e+2+32]=t[e+1+64]=t[e+0+96]=Ne(i,a,o),t[e+3+32]=t[e+2+64]=t[e+1+96]=Ne(a,o,s),t[e+3+64]=t[e+2+96]=Ne(o,s,c),t[e+3+96]=Ne(s,c,c)}function Pe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],c=t[e+2-32],u=t[e+3-32];t[e+0+0]=t[e+1+64]=a+o+1>>1,t[e+1+0]=t[e+2+64]=o+s+1>>1,t[e+2+0]=t[e+3+64]=s+c+1>>1,t[e+3+0]=c+u+1>>1,t[e+0+96]=Ne(i,n,r),t[e+0+64]=Ne(n,r,a),t[e+0+32]=t[e+1+96]=Ne(r,a,o),t[e+1+32]=t[e+2+96]=Ne(a,o,s),t[e+2+32]=t[e+3+96]=Ne(o,s,c),t[e+3+32]=Ne(s,c,u)}function ke(t,e){var r=t[e+0-32],n=t[e+1-32],i=t[e+2-32],a=t[e+3-32],o=t[e+4-32],s=t[e+5-32],c=t[e+6-32],u=t[e+7-32];t[e+0+0]=r+n+1>>1,t[e+1+0]=t[e+0+64]=n+i+1>>1,t[e+2+0]=t[e+1+64]=i+a+1>>1,t[e+3+0]=t[e+2+64]=a+o+1>>1,t[e+0+32]=Ne(r,n,i),t[e+1+32]=t[e+0+96]=Ne(n,i,a),t[e+2+32]=t[e+1+96]=Ne(i,a,o),t[e+3+32]=t[e+2+96]=Ne(a,o,s),t[e+3+64]=Ne(o,s,c),t[e+3+96]=Ne(s,c,u)}function Ie(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];t[e+0+0]=r+n+1>>1,t[e+2+0]=t[e+0+32]=n+i+1>>1,t[e+2+32]=t[e+0+64]=i+a+1>>1,t[e+1+0]=Ne(r,n,i),t[e+3+0]=t[e+1+32]=Ne(n,i,a),t[e+3+32]=t[e+1+64]=Ne(i,a,a),t[e+3+64]=t[e+2+64]=t[e+0+96]=t[e+1+96]=t[e+2+96]=t[e+3+96]=a}function Fe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96],o=t[e-1-32],s=t[e+0-32],c=t[e+1-32],u=t[e+2-32];t[e+0+0]=t[e+2+32]=r+o+1>>1,t[e+0+32]=t[e+2+64]=n+r+1>>1,t[e+0+64]=t[e+2+96]=i+n+1>>1,t[e+0+96]=a+i+1>>1,t[e+3+0]=Ne(s,c,u),t[e+2+0]=Ne(o,s,c),t[e+1+0]=t[e+3+32]=Ne(r,o,s),t[e+1+32]=t[e+3+64]=Ne(n,r,o),t[e+1+64]=t[e+3+96]=Ne(i,n,r),t[e+1+96]=Ne(a,i,n)}function Ce(t,e){var r;for(r=0;8>r;++r)n(t,e+32*r,t,e-32,8)}function je(t,e){var r;for(r=0;8>r;++r)i(t,e,t[e-1],8),e+=32}function Oe(t,e,r){var n;for(n=0;8>n;++n)i(e,r+32*n,t,8)}function Be(t,e){var r,n=8;for(r=0;8>r;++r)n+=t[e+r-32]+t[e-1+32*r];Oe(n>>4,t,e)}function Me(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e+r-32];Oe(n>>3,t,e)}function Ee(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e-1+32*r];Oe(n>>3,t,e)}function qe(t,e){Oe(128,t,e)}function De(t,e,r){var n=t[e-r],i=t[e+0],a=3*(i-n)+jn[1020+t[e-2*r]-t[e+r]],o=On[112+(a+4>>3)];t[e-r]=Bn[255+n+On[112+(a+3>>3)]],t[e+0]=Bn[255+i-o]}function Re(t,e,r,n){var i=t[e+0],a=t[e+r];return Mn[255+t[e-2*r]-t[e-r]]>n||Mn[255+a-i]>n}function Te(t,e,r,n){return 4*Mn[255+t[e-r]-t[e+0]]+Mn[255+t[e-2*r]-t[e+r]]<=n}function Ue(t,e,r,n,i){var a=t[e-3*r],o=t[e-2*r],s=t[e-r],c=t[e+0],u=t[e+r],h=t[e+2*r],l=t[e+3*r];return 4*Mn[255+s-c]+Mn[255+o-u]>n?0:Mn[255+t[e-4*r]-a]<=i&&Mn[255+a-o]<=i&&Mn[255+o-s]<=i&&Mn[255+l-h]<=i&&Mn[255+h-u]<=i&&Mn[255+u-c]<=i}function ze(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)Te(t,e+n,r,i)&&De(t,e+n,r)}function He(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)Te(t,e+n*r,1,i)&&De(t,e+n*r,1)}function We(t,e,r,n){var i;for(i=3;0<i;--i)ze(t,e+=4*r,r,n)}function Ve(t,e,r,n){var i;for(i=3;0<i;--i)He(t,e+=4,r,n)}function Ge(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Re(t,e,r,s))De(t,e,r);else{var c=t,u=e,h=r,l=c[u-2*h],f=c[u-h],d=c[u+0],p=c[u+h],g=c[u+2*h],m=27*(b=jn[1020+3*(d-f)+jn[1020+l-p]])+63>>7,v=18*b+63>>7,b=9*b+63>>7;c[u-3*h]=Bn[255+c[u-3*h]+b],c[u-2*h]=Bn[255+l+v],c[u-h]=Bn[255+f+m],c[u+0]=Bn[255+d-m],c[u+h]=Bn[255+p-v],c[u+2*h]=Bn[255+g-b]}e+=n}}function Ye(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Re(t,e,r,s))De(t,e,r);else{var c=t,u=e,h=r,l=c[u-h],f=c[u+0],d=c[u+h],p=On[112+((g=3*(f-l))+4>>3)],g=On[112+(g+3>>3)],m=p+1>>1;c[u-2*h]=Bn[255+c[u-2*h]+m],c[u-h]=Bn[255+l+g],c[u+0]=Bn[255+f-p],c[u+h]=Bn[255+d-m]}e+=n}}function Je(t,e,r,n,i,a){Ge(t,e,r,1,16,n,i,a)}function Xe(t,e,r,n,i,a){Ge(t,e,1,r,16,n,i,a)}function Ke(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4*r,r,1,16,n,i,a)}function Ze(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4,1,r,16,n,i,a)}function $e(t,e,r,n,i,a,o,s){Ge(t,e,i,1,8,a,o,s),Ge(r,n,i,1,8,a,o,s)}function Qe(t,e,r,n,i,a,o,s){Ge(t,e,1,i,8,a,o,s),Ge(r,n,1,i,8,a,o,s)}function tr(t,e,r,n,i,a,o,s){Ye(t,e+4*i,i,1,8,a,o,s),Ye(r,n+4*i,i,1,8,a,o,s)}function er(t,e,r,n,i,a,o,s){Ye(t,e+4,1,i,8,a,o,s),Ye(r,n+4,1,i,8,a,o,s)}function rr(){this.ba=new ot,this.ec=[],this.cc=[],this.Mc=[],this.Dc=this.Nc=this.dc=this.fc=0,this.Oa=new ct,this.memory=0,this.Ib="OutputFunc",this.Jb="OutputAlphaFunc",this.Nd="OutputRowFunc"}function nr(){this.data=[],this.offset=this.kd=this.ha=this.w=0,this.na=[],this.xa=this.gb=this.Ja=this.Sa=this.P=0}function ir(){this.nc=this.Ea=this.b=this.hc=0,this.K=[],this.w=0}function ar(){this.ua=0,this.Wa=new M,this.vb=new M,this.md=this.xc=this.wc=0,this.vc=[],this.Wb=0,this.Ya=new d,this.yc=new l}function or(){this.xb=this.a=0,this.l=new Gt,this.ca=new ot,this.V=[],this.Ba=0,this.Ta=[],this.Ua=0,this.m=new N,this.Pb=0,this.wd=new N,this.Ma=this.$=this.C=this.i=this.c=this.xd=0,this.s=new ar,this.ab=0,this.gc=o(4,ir),this.Oc=0}function sr(){this.Lc=this.Z=this.$a=this.i=this.c=0,this.l=new Gt,this.ic=0,this.ca=[],this.tb=0,this.qd=null,this.rd=0}function cr(t,e,r,n,i,a,o){for(t=null==t?0:t[e+0],e=0;e<o;++e)i[a+e]=t+r[n+e]&255,t=i[a+e]}function ur(t,e,r,n,i,a,o){var s;if(null==t)cr(null,null,r,n,i,a,o);else for(s=0;s<o;++s)i[a+s]=t[e+s]+r[n+s]&255}function hr(t,e,r,n,i,a,o){if(null==t)cr(null,null,r,n,i,a,o);else{var s,c=t[e+0],u=c,h=c;for(s=0;s<o;++s)u=h+(c=t[e+s])-u,h=r[n+s]+(-256&u?0>u?0:255:u)&255,u=c,i[a+s]=h}}function lr(t,r,i,o){var s=r.width,c=r.o;if(e(null!=t&&null!=r),0>i||0>=o||i+o>c)return null;if(!t.Cc){if(null==t.ga){var u;if(t.ga=new sr,(u=null==t.ga)||(u=r.width*r.o,e(0==t.Gb.length),t.Gb=a(u),t.Uc=0,null==t.Gb?u=0:(t.mb=t.Gb,t.nb=t.Uc,t.rc=null,u=1),u=!u),!u){u=t.ga;var h=t.Fa,l=t.P,f=t.qc,d=t.mb,p=t.nb,g=l+1,m=f-1,b=u.l;if(e(null!=h&&null!=d&&null!=r),mi[0]=null,mi[1]=cr,mi[2]=ur,mi[3]=hr,u.ca=d,u.tb=p,u.c=r.width,u.i=r.height,e(0<u.c&&0<u.i),1>=f)r=0;else if(u.$a=h[l+0]>>0&3,u.Z=h[l+0]>>2&3,u.Lc=h[l+0]>>4&3,l=h[l+0]>>6&3,0>u.$a||1<u.$a||4<=u.Z||1<u.Lc||l)r=0;else if(b.put=dt,b.ac=ft,b.bc=pt,b.ma=u,b.width=r.width,b.height=r.height,b.Da=r.Da,b.v=r.v,b.va=r.va,b.j=r.j,b.o=r.o,u.$a)t:{e(1==u.$a),r=kt();e:for(;;){if(null==r){r=0;break t}if(e(null!=u),u.mc=r,r.c=u.c,r.i=u.i,r.l=u.l,r.l.ma=u,r.l.width=u.c,r.l.height=u.i,r.a=0,v(r.m,h,g,m),!It(u.c,u.i,1,r,null))break e;if(1==r.ab&&3==r.gc[0].hc&&At(r.s)?(u.ic=1,h=r.c*r.i,r.Ta=null,r.Ua=0,r.V=a(h),r.Ba=0,null==r.V?(r.a=1,r=0):r=1):(u.ic=0,r=Ft(r,u.c)),!r)break e;r=1;break t}u.mc=null,r=0}else r=m>=u.c*u.i;u=!r}if(u)return null;1!=t.ga.Lc?t.Ga=0:o=c-i}e(null!=t.ga),e(i+o<=c);t:{if(r=(h=t.ga).c,c=h.l.o,0==h.$a){if(g=t.rc,m=t.Vc,b=t.Fa,l=t.P+1+i*r,f=t.mb,d=t.nb+i*r,e(l<=t.P+t.qc),0!=h.Z)for(e(null!=mi[h.Z]),u=0;u<o;++u)mi[h.Z](g,m,b,l,f,d,r),g=f,m=d,d+=r,l+=r;else for(u=0;u<o;++u)n(f,d,b,l,r),g=f,m=d,d+=r,l+=r;t.rc=g,t.Vc=m}else{if(e(null!=h.mc),r=i+o,e(null!=(u=h.mc)),e(r<=u.i),u.C>=r)r=1;else if(h.ic||mr(),h.ic){h=u.V,g=u.Ba,m=u.c;var y=u.i,w=(b=1,l=u.$/m,f=u.$%m,d=u.m,p=u.s,u.$),N=m*y,L=m*r,x=p.wc,_=w<L?wt(p,f,l):null;e(w<=N),e(r<=y),e(At(p));e:for(;;){for(;!d.h&&w<L;){if(f&x||(_=wt(p,f,l)),e(null!=_),S(d),256>(y=bt(_.G[0],_.H[0],d)))h[g+w]=y,++w,++f>=m&&(f=0,++l<=r&&!(l%16)&&St(u,l));else{if(!(280>y)){b=0;break e}y=mt(y-256,d);var P,k=bt(_.G[4],_.H[4],d);if(S(d),!(w>=(k=vt(m,k=mt(k,d)))&&N-w>=y)){b=0;break e}for(P=0;P<y;++P)h[g+w+P]=h[g+w+P-k];for(w+=y,f+=y;f>=m;)f-=m,++l<=r&&!(l%16)&&St(u,l);w<L&&f&x&&(_=wt(p,f,l))}e(d.h==A(d))}St(u,l>r?r:l);break e}!b||d.h&&w<N?(b=0,u.a=d.h?5:3):u.$=w,r=b}else r=_t(u,u.V,u.Ba,u.c,u.i,r,Ct);if(!r){o=0;break t}}i+o>=c&&(t.Cc=1),o=1}if(!o)return null;if(t.Cc&&(null!=(o=t.ga)&&(o.mc=null),t.ga=null,0<t.Ga))return alert("todo:WebPDequantizeLevels"),null}return t.nb+i*s}function fr(t,e,r,n,i,a){for(;0<i--;){var o,s=t,c=e+(r?1:0),u=t,h=e+(r?0:3);for(o=0;o<n;++o){var l=u[h+4*o];255!=l&&(l*=32897,s[c+4*o+0]=s[c+4*o+0]*l>>23,s[c+4*o+1]=s[c+4*o+1]*l>>23,s[c+4*o+2]=s[c+4*o+2]*l>>23)}e+=a}}function dr(t,e,r,n,i){for(;0<n--;){var a;for(a=0;a<r;++a){var o=t[e+2*a+0],s=15&(u=t[e+2*a+1]),c=4369*s,u=(240&u|u>>4)*c>>16;t[e+2*a+0]=(240&o|o>>4)*c>>16&240|(15&o|o<<4)*c>>16>>4&15,t[e+2*a+1]=240&u|s}e+=i}}function pr(t,e,r,n,i,a,o,s){var c,u,h=255;for(u=0;u<i;++u){for(c=0;c<n;++c){var l=t[e+c];a[o+4*c]=l,h&=l}e+=r,o+=s}return 255!=h}function gr(t,e,r,n,i){var a;for(a=0;a<i;++a)r[n+a]=t[e+a]>>8}function mr(){An=fr,xn=dr,Sn=pr,_n=gr}function vr(r,n,i){t[r]=function(t,r,a,o,s,c,u,h,l,f,d,p,g,m,v,b,y){var w,N=y-1>>1,L=s[c+0]|u[h+0]<<16,A=l[f+0]|d[p+0]<<16;e(null!=t);var x=3*L+A+131074>>2;for(n(t[r+0],255&x,x>>16,g,m),null!=a&&(x=3*A+L+131074>>2,n(a[o+0],255&x,x>>16,v,b)),w=1;w<=N;++w){var S=s[c+w]|u[h+w]<<16,_=l[f+w]|d[p+w]<<16,P=L+S+A+_+524296,k=P+2*(S+A)>>3;x=k+L>>1,L=(P=P+2*(L+_)>>3)+S>>1,n(t[r+2*w-1],255&x,x>>16,g,m+(2*w-1)*i),n(t[r+2*w-0],255&L,L>>16,g,m+(2*w-0)*i),null!=a&&(x=P+A>>1,L=k+_>>1,n(a[o+2*w-1],255&x,x>>16,v,b+(2*w-1)*i),n(a[o+2*w+0],255&L,L>>16,v,b+(2*w+0)*i)),L=S,A=_}1&y||(x=3*L+A+131074>>2,n(t[r+y-1],255&x,x>>16,g,m+(y-1)*i),null!=a&&(x=3*A+L+131074>>2,n(a[o+y-1],255&x,x>>16,v,b+(y-1)*i)))}}function br(){vi[En]=bi,vi[qn]=wi,vi[Dn]=yi,vi[Rn]=Ni,vi[Tn]=Li,vi[Un]=Ai,vi[zn]=xi,vi[Hn]=wi,vi[Wn]=Ni,vi[Vn]=Li,vi[Gn]=Ai}function yr(t){return t&~Fi?0>t?0:255:t>>Ii}function wr(t,e){return yr((19077*t>>8)+(26149*e>>8)-14234)}function Nr(t,e,r){return yr((19077*t>>8)-(6419*e>>8)-(13320*r>>8)+8708)}function Lr(t,e){return yr((19077*t>>8)+(33050*e>>8)-17685)}function Ar(t,e,r,n,i){n[i+0]=wr(t,r),n[i+1]=Nr(t,e,r),n[i+2]=Lr(t,e)}function xr(t,e,r,n,i){n[i+0]=Lr(t,e),n[i+1]=Nr(t,e,r),n[i+2]=wr(t,r)}function Sr(t,e,r,n,i){var a=Nr(t,e,r);e=a<<3&224|Lr(t,e)>>3,n[i+0]=248&wr(t,r)|a>>5,n[i+1]=e}function _r(t,e,r,n,i){var a=240&Lr(t,e)|15;n[i+0]=240&wr(t,r)|Nr(t,e,r)>>4,n[i+1]=a}function Pr(t,e,r,n,i){n[i+0]=255,Ar(t,e,r,n,i+1)}function kr(t,e,r,n,i){xr(t,e,r,n,i),n[i+3]=255}function Ir(t,e,r,n,i){Ar(t,e,r,n,i),n[i+3]=255}function Vt(t,e){return 0>t?0:t>e?e:t}function Fr(e,r,n){t[e]=function(t,e,i,a,o,s,c,u,h){for(var l=u+(-2&h)*n;u!=l;)r(t[e+0],i[a+0],o[s+0],c,u),r(t[e+1],i[a+0],o[s+0],c,u+n),e+=2,++a,++s,u+=2*n;1&h&&r(t[e+0],i[a+0],o[s+0],c,u)}}function Cr(t,e,r){return 0==r?0==t?0==e?6:5:0==e?4:0:r}function jr(t,e,r,n,i){switch(t>>>30){case 3:on(e,r,n,i,0);break;case 2:sn(e,r,n,i);break;case 1:un(e,r,n,i)}}function Or(t,e){var r,a,o=e.M,s=e.Nb,c=t.oc,u=t.pc+40,h=t.oc,l=t.pc+584,f=t.oc,d=t.pc+600;for(r=0;16>r;++r)c[u+32*r-1]=129;for(r=0;8>r;++r)h[l+32*r-1]=129,f[d+32*r-1]=129;for(0<o?c[u-1-32]=h[l-1-32]=f[d-1-32]=129:(i(c,u-32-1,127,21),i(h,l-32-1,127,9),i(f,d-32-1,127,9)),a=0;a<t.za;++a){var p=e.ya[e.aa+a];if(0<a){for(r=-1;16>r;++r)n(c,u+32*r-4,c,u+32*r+12,4);for(r=-1;8>r;++r)n(h,l+32*r-4,h,l+32*r+4,4),n(f,d+32*r-4,f,d+32*r+4,4)}var g=t.Gd,m=t.Hd+a,v=p.ad,b=p.Hc;if(0<o&&(n(c,u-32,g[m].y,0,16),n(h,l-32,g[m].f,0,8),n(f,d-32,g[m].ea,0,8)),p.Za){var y=c,w=u-32+16;for(0<o&&(a>=t.za-1?i(y,w,g[m].y[15],4):n(y,w,g[m+1].y,0,4)),r=0;4>r;r++)y[w+128+r]=y[w+256+r]=y[w+384+r]=y[w+0+r];for(r=0;16>r;++r,b<<=2)y=c,w=u+Di[r],fi[p.Ob[r]](y,w),jr(b,v,16*+r,y,w)}else if(y=Cr(a,o,p.Ob[0]),li[y](c,u),0!=b)for(r=0;16>r;++r,b<<=2)jr(b,v,16*+r,c,u+Di[r]);for(r=p.Gc,y=Cr(a,o,p.Dd),di[y](h,l),di[y](f,d),b=v,y=h,w=l,255&(p=r>>0)&&(170&p?cn(b,256,y,w):hn(b,256,y,w)),p=f,b=d,255&(r>>=8)&&(170&r?cn(v,320,p,b):hn(v,320,p,b)),o<t.Ub-1&&(n(g[m].y,0,c,u+480,16),n(g[m].f,0,h,l+224,8),n(g[m].ea,0,f,d+224,8)),r=8*s*t.B,g=t.sa,m=t.ta+16*a+16*s*t.R,v=t.qa,p=t.ra+8*a+r,b=t.Ha,y=t.Ia+8*a+r,r=0;16>r;++r)n(g,m+r*t.R,c,u+32*r,16);for(r=0;8>r;++r)n(v,p+r*t.B,h,l+32*r,8),n(b,y+r*t.B,f,d+32*r,8)}}function Br(t,n,i,a,o,s,c,u,h){var l=[0],f=[0],d=0,p=null!=h?h.kd:0,g=null!=h?h:new nr;if(null==t||12>i)return 7;g.data=t,g.w=n,g.ha=i,n=[n],i=[i],g.gb=[g.gb];t:{var m=n,b=i,y=g.gb;if(e(null!=t),e(null!=b),e(null!=y),y[0]=0,12<=b[0]&&!r(t,m[0],"RIFF")){if(r(t,m[0]+8,"WEBP")){y=3;break t}var w=j(t,m[0]+4);if(12>w||4294967286<w){y=3;break t}if(p&&w>b[0]-8){y=7;break t}y[0]=w,m[0]+=12,b[0]-=12}y=0}if(0!=y)return y;for(w=0<g.gb[0],i=i[0];;){t:{var L=t;b=n,y=i;var A=l,x=f,S=m=[0];if((k=d=[d])[0]=0,8>y[0])y=7;else{if(!r(L,b[0],"VP8X")){if(10!=j(L,b[0]+4)){y=3;break t}if(18>y[0]){y=7;break t}var _=j(L,b[0]+8),P=1+C(L,b[0]+12);if(2147483648<=P*(L=1+C(L,b[0]+15))){y=3;break t}null!=S&&(S[0]=_),null!=A&&(A[0]=P),null!=x&&(x[0]=L),b[0]+=18,y[0]-=18,k[0]=1}y=0}}if(d=d[0],m=m[0],0!=y)return y;if(b=!!(2&m),!w&&d)return 3;if(null!=s&&(s[0]=!!(16&m)),null!=c&&(c[0]=b),null!=u&&(u[0]=0),c=l[0],m=f[0],d&&b&&null==h){y=0;break}if(4>i){y=7;break}if(w&&d||!w&&!d&&!r(t,n[0],"ALPH")){i=[i],g.na=[g.na],g.P=[g.P],g.Sa=[g.Sa];t:{_=t,y=n,w=i;var k=g.gb;A=g.na,x=g.P,S=g.Sa;P=22,e(null!=_),e(null!=w),L=y[0];var I=w[0];for(e(null!=A),e(null!=S),A[0]=null,x[0]=null,S[0]=0;;){if(y[0]=L,w[0]=I,8>I){y=7;break t}var F=j(_,L+4);if(4294967286<F){y=3;break t}var O=8+F+1&-2;if(P+=O,0<k&&P>k){y=3;break t}if(!r(_,L,"VP8 ")||!r(_,L,"VP8L")){y=0;break t}if(I[0]<O){y=7;break t}r(_,L,"ALPH")||(A[0]=_,x[0]=L+8,S[0]=F),L+=O,I-=O}}if(i=i[0],g.na=g.na[0],g.P=g.P[0],g.Sa=g.Sa[0],0!=y)break}i=[i],g.Ja=[g.Ja],g.xa=[g.xa];t:if(k=t,y=n,w=i,A=g.gb[0],x=g.Ja,S=g.xa,_=y[0],L=!r(k,_,"VP8 "),P=!r(k,_,"VP8L"),e(null!=k),e(null!=w),e(null!=x),e(null!=S),8>w[0])y=7;else{if(L||P){if(k=j(k,_+4),12<=A&&k>A-12){y=3;break t}if(p&&k>w[0]-8){y=7;break t}x[0]=k,y[0]+=8,w[0]-=8,S[0]=P}else S[0]=5<=w[0]&&47==k[_+0]&&!(k[_+4]>>5),x[0]=w[0];y=0}if(i=i[0],g.Ja=g.Ja[0],g.xa=g.xa[0],n=n[0],0!=y)break;if(4294967286<g.Ja)return 3;if(null==u||b||(u[0]=g.xa?2:1),c=[c],m=[m],g.xa){if(5>i){y=7;break}u=c,p=m,b=s,null==t||5>i?t=0:5<=i&&47==t[n+0]&&!(t[n+4]>>5)?(w=[0],k=[0],A=[0],v(x=new N,t,n,i),gt(x,w,k,A)?(null!=u&&(u[0]=w[0]),null!=p&&(p[0]=k[0]),null!=b&&(b[0]=A[0]),t=1):t=0):t=0}else{if(10>i){y=7;break}u=m,null==t||10>i||!Xt(t,n+3,i-3)?t=0:(p=t[n+0]|t[n+1]<<8|t[n+2]<<16,b=16383&(t[n+7]<<8|t[n+6]),t=16383&(t[n+9]<<8|t[n+8]),1&p||3<(p>>1&7)||!(p>>4&1)||p>>5>=g.Ja||!b||!t?t=0:(c&&(c[0]=b),u&&(u[0]=t),t=1))}if(!t)return 3;if(c=c[0],m=m[0],d&&(l[0]!=c||f[0]!=m))return 3;null!=h&&(h[0]=g,h.offset=n-h.w,e(4294967286>n-h.w),e(h.offset==h.ha-i));break}return 0==y||7==y&&d&&null==h?(null!=s&&(s[0]|=null!=g.na&&0<g.na.length),null!=a&&(a[0]=c),null!=o&&(o[0]=m),0):y}function Mr(t,e,r){var n=e.width,i=e.height,a=0,o=0,s=n,c=i;if(e.Da=null!=t&&0<t.Da,e.Da&&(s=t.cd,c=t.bd,a=t.v,o=t.j,11>r||(a&=-2,o&=-2),0>a||0>o||0>=s||0>=c||a+s>n||o+c>i))return 0;if(e.v=a,e.j=o,e.va=a+s,e.o=o+c,e.U=s,e.T=c,e.da=null!=t&&0<t.da,e.da){if(!E(s,c,r=[t.ib],a=[t.hb]))return 0;e.ib=r[0],e.hb=a[0]}return e.ob=null!=t&&t.ob,e.Kb=null==t||!t.Sd,e.da&&(e.ob=e.ib<3*n/4&&e.hb<3*i/4,e.Kb=0),1}function Er(t){if(null==t)return 2;if(11>t.S){var e=t.f.RGBA;e.fb+=(t.height-1)*e.A,e.A=-e.A}else e=t.f.kb,t=t.height,e.O+=(t-1)*e.fa,e.fa=-e.fa,e.N+=(t-1>>1)*e.Ab,e.Ab=-e.Ab,e.W+=(t-1>>1)*e.Db,e.Db=-e.Db,null!=e.F&&(e.J+=(t-1)*e.lb,e.lb=-e.lb);return 0}function qr(t,e,r,n){if(null==n||0>=t||0>=e)return 2;if(null!=r){if(r.Da){var i=r.cd,o=r.bd,s=-2&r.v,c=-2&r.j;if(0>s||0>c||0>=i||0>=o||s+i>t||c+o>e)return 2;t=i,e=o}if(r.da){if(!E(t,e,i=[r.ib],o=[r.hb]))return 2;t=i[0],e=o[0]}}n.width=t,n.height=e;t:{var u=n.width,h=n.height;if(t=n.S,0>=u||0>=h||!(t>=En&&13>t))t=2;else{if(0>=n.Rd&&null==n.sd){s=o=i=e=0;var l=(c=u*zi[t])*h;if(11>t||(o=(h+1)/2*(e=(u+1)/2),12==t&&(s=(i=u)*h)),null==(h=a(l+2*o+s))){t=1;break t}n.sd=h,11>t?((u=n.f.RGBA).eb=h,u.fb=0,u.A=c,u.size=l):((u=n.f.kb).y=h,u.O=0,u.fa=c,u.Fd=l,u.f=h,u.N=0+l,u.Ab=e,u.Cd=o,u.ea=h,u.W=0+l+o,u.Db=e,u.Ed=o,12==t&&(u.F=h,u.J=0+l+2*o),u.Tc=s,u.lb=i)}if(e=1,i=n.S,o=n.width,s=n.height,i>=En&&13>i)if(11>i)t=n.f.RGBA,e&=(c=Math.abs(t.A))*(s-1)+o<=t.size,e&=c>=o*zi[i],e&=null!=t.eb;else{t=n.f.kb,c=(o+1)/2,l=(s+1)/2,u=Math.abs(t.fa);h=Math.abs(t.Ab);var f=Math.abs(t.Db),d=Math.abs(t.lb),p=d*(s-1)+o;e&=u*(s-1)+o<=t.Fd,e&=h*(l-1)+c<=t.Cd,e=(e&=f*(l-1)+c<=t.Ed)&u>=o&h>=c&f>=c,e&=null!=t.y,e&=null!=t.f,e&=null!=t.ea,12==i&&(e&=d>=o,e&=p<=t.Tc,e&=null!=t.F)}else e=0;t=e?0:2}}return 0!=t||null!=r&&r.fd&&(t=Er(n)),t}var Dr=64,Rr=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535,131071,262143,524287,1048575,2097151,4194303,8388607,16777215],Tr=24,Ur=32,zr=8,Hr=[0,0,1,1,2,2,2,2,3,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7];R("Predictor0","PredictorAdd0"),t.Predictor0=function(){return 4278190080},t.Predictor1=function(t){return t},t.Predictor2=function(t,e,r){return e[r+0]},t.Predictor3=function(t,e,r){return e[r+1]},t.Predictor4=function(t,e,r){return e[r-1]},t.Predictor5=function(t,e,r){return U(U(t,e[r+1]),e[r+0])},t.Predictor6=function(t,e,r){return U(t,e[r-1])},t.Predictor7=function(t,e,r){return U(t,e[r+0])},t.Predictor8=function(t,e,r){return U(e[r-1],e[r+0])},t.Predictor9=function(t,e,r){return U(e[r+0],e[r+1])},t.Predictor10=function(t,e,r){return U(U(t,e[r-1]),U(e[r+0],e[r+1]))},t.Predictor11=function(t,e,r){var n=e[r+0];return 0>=W(n>>24&255,t>>24&255,(e=e[r-1])>>24&255)+W(n>>16&255,t>>16&255,e>>16&255)+W(n>>8&255,t>>8&255,e>>8&255)+W(255&n,255&t,255&e)?n:t},t.Predictor12=function(t,e,r){var n=e[r+0];return(z((t>>24&255)+(n>>24&255)-((e=e[r-1])>>24&255))<<24|z((t>>16&255)+(n>>16&255)-(e>>16&255))<<16|z((t>>8&255)+(n>>8&255)-(e>>8&255))<<8|z((255&t)+(255&n)-(255&e)))>>>0},t.Predictor13=function(t,e,r){var n=e[r-1];return(H((t=U(t,e[r+0]))>>24&255,n>>24&255)<<24|H(t>>16&255,n>>16&255)<<16|H(t>>8&255,n>>8&255)<<8|H(t>>0&255,n>>0&255))>>>0};var Wr=t.PredictorAdd0;t.PredictorAdd1=V,R("Predictor2","PredictorAdd2"),R("Predictor3","PredictorAdd3"),R("Predictor4","PredictorAdd4"),R("Predictor5","PredictorAdd5"),R("Predictor6","PredictorAdd6"),R("Predictor7","PredictorAdd7"),R("Predictor8","PredictorAdd8"),R("Predictor9","PredictorAdd9"),R("Predictor10","PredictorAdd10"),R("Predictor11","PredictorAdd11"),R("Predictor12","PredictorAdd12"),R("Predictor13","PredictorAdd13");var Vr=t.PredictorAdd2;X("ColorIndexInverseTransform","MapARGB","32b",(function(t){return t>>8&255}),(function(t){return t})),X("VP8LColorIndexInverseTransformAlpha","MapAlpha","8b",(function(t){return t}),(function(t){return t>>8&255}));var Gr,Yr=t.ColorIndexInverseTransform,Jr=t.MapARGB,Xr=t.VP8LColorIndexInverseTransformAlpha,Kr=t.MapAlpha,Zr=t.VP8LPredictorsAdd=[];Zr.length=16,(t.VP8LPredictors=[]).length=16,(t.VP8LPredictorsAdd_C=[]).length=16,(t.VP8LPredictors_C=[]).length=16;var $r,Qr,tn,en,rn,nn,an,on,sn,cn,un,hn,ln,fn,dn,pn,gn,mn,vn,bn,yn,wn,Nn,Ln,An,xn,Sn,_n,Pn=a(511),kn=a(2041),In=a(225),Fn=a(767),Cn=0,jn=kn,On=In,Bn=Fn,Mn=Pn,En=0,qn=1,Dn=2,Rn=3,Tn=4,Un=5,zn=6,Hn=7,Wn=8,Vn=9,Gn=10,Yn=[2,3,7],Jn=[3,3,11],Xn=[280,256,256,256,40],Kn=[0,1,1,1,0],Zn=[17,18,0,1,2,3,4,5,16,6,7,8,9,10,11,12,13,14,15],$n=[24,7,23,25,40,6,39,41,22,26,38,42,56,5,55,57,21,27,54,58,37,43,72,4,71,73,20,28,53,59,70,74,36,44,88,69,75,52,60,3,87,89,19,29,86,90,35,45,68,76,85,91,51,61,104,2,103,105,18,30,102,106,34,46,84,92,67,77,101,107,50,62,120,1,119,121,83,93,17,31,100,108,66,78,118,122,33,47,117,123,49,63,99,109,82,94,0,116,124,65,79,16,32,98,110,48,115,125,81,95,64,114,126,97,111,80,113,127,96,112],Qn=[2954,2956,2958,2962,2970,2986,3018,3082,3212,3468,3980,5004],ti=8,ei=[4,5,6,7,8,9,10,10,11,12,13,14,15,16,17,17,18,19,20,20,21,21,22,22,23,23,24,25,25,26,27,28,29,30,31,32,33,34,35,36,37,37,38,39,40,41,42,43,44,45,46,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,76,77,78,79,80,81,82,83,84,85,86,87,88,89,91,93,95,96,98,100,101,102,104,106,108,110,112,114,116,118,122,124,126,128,130,132,134,136,138,140,143,145,148,151,154,157],ri=[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,119,122,125,128,131,134,137,140,143,146,149,152,155,158,161,164,167,170,173,177,181,185,189,193,197,201,205,209,213,217,221,225,229,234,239,245,249,254,259,264,269,274,279,284],ni=null,ii=[[173,148,140,0],[176,155,140,135,0],[180,157,141,134,130,0],[254,254,243,230,196,177,153,140,133,130,129,0]],ai=[0,1,4,8,5,2,3,6,9,12,13,10,7,11,14,15],oi=[-0,1,-1,2,-2,3,4,6,-3,5,-4,-5,-6,7,-7,8,-8,-9],si=[[[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]],[[253,136,254,255,228,219,128,128,128,128,128],[189,129,242,255,227,213,255,219,128,128,128],[106,126,227,252,214,209,255,255,128,128,128]],[[1,98,248,255,236,226,255,255,128,128,128],[181,133,238,254,221,234,255,154,128,128,128],[78,134,202,247,198,180,255,219,128,128,128]],[[1,185,249,255,243,255,128,128,128,128,128],[184,150,247,255,236,224,128,128,128,128,128],[77,110,216,255,236,230,128,128,128,128,128]],[[1,101,251,255,241,255,128,128,128,128,128],[170,139,241,252,236,209,255,255,128,128,128],[37,116,196,243,228,255,255,255,128,128,128]],[[1,204,254,255,245,255,128,128,128,128,128],[207,160,250,255,238,128,128,128,128,128,128],[102,103,231,255,211,171,128,128,128,128,128]],[[1,152,252,255,240,255,128,128,128,128,128],[177,135,243,255,234,225,128,128,128,128,128],[80,129,211,255,194,224,128,128,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[246,1,255,128,128,128,128,128,128,128,128],[255,128,128,128,128,128,128,128,128,128,128]]],[[[198,35,237,223,193,187,162,160,145,155,62],[131,45,198,221,172,176,220,157,252,221,1],[68,47,146,208,149,167,221,162,255,223,128]],[[1,149,241,255,221,224,255,255,128,128,128],[184,141,234,253,222,220,255,199,128,128,128],[81,99,181,242,176,190,249,202,255,255,128]],[[1,129,232,253,214,197,242,196,255,255,128],[99,121,210,250,201,198,255,202,128,128,128],[23,91,163,242,170,187,247,210,255,255,128]],[[1,200,246,255,234,255,128,128,128,128,128],[109,178,241,255,231,245,255,255,128,128,128],[44,130,201,253,205,192,255,255,128,128,128]],[[1,132,239,251,219,209,255,165,128,128,128],[94,136,225,251,218,190,255,255,128,128,128],[22,100,174,245,186,161,255,199,128,128,128]],[[1,182,249,255,232,235,128,128,128,128,128],[124,143,241,255,227,234,128,128,128,128,128],[35,77,181,251,193,211,255,205,128,128,128]],[[1,157,247,255,236,231,255,255,128,128,128],[121,141,235,255,225,227,255,255,128,128,128],[45,99,188,251,195,217,255,224,128,128,128]],[[1,1,251,255,213,255,128,128,128,128,128],[203,1,248,255,255,128,128,128,128,128,128],[137,1,177,255,224,255,128,128,128,128,128]]],[[[253,9,248,251,207,208,255,192,128,128,128],[175,13,224,243,193,185,249,198,255,255,128],[73,17,171,221,161,179,236,167,255,234,128]],[[1,95,247,253,212,183,255,255,128,128,128],[239,90,244,250,211,209,255,255,128,128,128],[155,77,195,248,188,195,255,255,128,128,128]],[[1,24,239,251,218,219,255,205,128,128,128],[201,51,219,255,196,186,128,128,128,128,128],[69,46,190,239,201,218,255,228,128,128,128]],[[1,191,251,255,255,128,128,128,128,128,128],[223,165,249,255,213,255,128,128,128,128,128],[141,124,248,255,255,128,128,128,128,128,128]],[[1,16,248,255,255,128,128,128,128,128,128],[190,36,230,255,236,255,128,128,128,128,128],[149,1,255,128,128,128,128,128,128,128,128]],[[1,226,255,128,128,128,128,128,128,128,128],[247,192,255,128,128,128,128,128,128,128,128],[240,128,255,128,128,128,128,128,128,128,128]],[[1,134,252,255,255,128,128,128,128,128,128],[213,62,250,255,255,128,128,128,128,128,128],[55,93,255,128,128,128,128,128,128,128,128]],[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]]],[[[202,24,213,235,186,191,220,160,240,175,255],[126,38,182,232,169,184,228,174,255,187,128],[61,46,138,219,151,178,240,170,255,216,128]],[[1,112,230,250,199,191,247,159,255,255,128],[166,109,228,252,211,215,255,174,128,128,128],[39,77,162,232,172,180,245,178,255,255,128]],[[1,52,220,246,198,199,249,220,255,255,128],[124,74,191,243,183,193,250,221,255,255,128],[24,71,130,219,154,170,243,182,255,255,128]],[[1,182,225,249,219,240,255,224,128,128,128],[149,150,226,252,216,205,255,171,128,128,128],[28,108,170,242,183,194,254,223,255,255,128]],[[1,81,230,252,204,203,255,192,128,128,128],[123,102,209,247,188,196,255,233,128,128,128],[20,95,153,243,164,173,255,203,128,128,128]],[[1,222,248,255,216,213,128,128,128,128,128],[168,175,246,252,235,205,255,255,128,128,128],[47,116,215,255,211,212,255,255,128,128,128]],[[1,121,236,253,212,214,255,255,128,128,128],[141,84,213,252,201,202,255,219,128,128,128],[42,80,160,240,162,185,255,205,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[244,1,255,128,128,128,128,128,128,128,128],[238,1,255,128,128,128,128,128,128,128,128]]]],ci=[[[231,120,48,89,115,113,120,152,112],[152,179,64,126,170,118,46,70,95],[175,69,143,80,85,82,72,155,103],[56,58,10,171,218,189,17,13,152],[114,26,17,163,44,195,21,10,173],[121,24,80,195,26,62,44,64,85],[144,71,10,38,171,213,144,34,26],[170,46,55,19,136,160,33,206,71],[63,20,8,114,114,208,12,9,226],[81,40,11,96,182,84,29,16,36]],[[134,183,89,137,98,101,106,165,148],[72,187,100,130,157,111,32,75,80],[66,102,167,99,74,62,40,234,128],[41,53,9,178,241,141,26,8,107],[74,43,26,146,73,166,49,23,157],[65,38,105,160,51,52,31,115,128],[104,79,12,27,217,255,87,17,7],[87,68,71,44,114,51,15,186,23],[47,41,14,110,182,183,21,17,194],[66,45,25,102,197,189,23,18,22]],[[88,88,147,150,42,46,45,196,205],[43,97,183,117,85,38,35,179,61],[39,53,200,87,26,21,43,232,171],[56,34,51,104,114,102,29,93,77],[39,28,85,171,58,165,90,98,64],[34,22,116,206,23,34,43,166,73],[107,54,32,26,51,1,81,43,31],[68,25,106,22,64,171,36,225,114],[34,19,21,102,132,188,16,76,124],[62,18,78,95,85,57,50,48,51]],[[193,101,35,159,215,111,89,46,111],[60,148,31,172,219,228,21,18,111],[112,113,77,85,179,255,38,120,114],[40,42,1,196,245,209,10,25,109],[88,43,29,140,166,213,37,43,154],[61,63,30,155,67,45,68,1,209],[100,80,8,43,154,1,51,26,71],[142,78,78,16,255,128,34,197,171],[41,40,5,102,211,183,4,1,221],[51,50,17,168,209,192,23,25,82]],[[138,31,36,171,27,166,38,44,229],[67,87,58,169,82,115,26,59,179],[63,59,90,180,59,166,93,73,154],[40,40,21,116,143,209,34,39,175],[47,15,16,183,34,223,49,45,183],[46,17,33,183,6,98,15,32,183],[57,46,22,24,128,1,54,17,37],[65,32,73,115,28,128,23,128,205],[40,3,9,115,51,192,18,6,223],[87,37,9,115,59,77,64,21,47]],[[104,55,44,218,9,54,53,130,226],[64,90,70,205,40,41,23,26,57],[54,57,112,184,5,41,38,166,213],[30,34,26,133,152,116,10,32,134],[39,19,53,221,26,114,32,73,255],[31,9,65,234,2,15,1,118,73],[75,32,12,51,192,255,160,43,51],[88,31,35,67,102,85,55,186,85],[56,21,23,111,59,205,45,37,192],[55,38,70,124,73,102,1,34,98]],[[125,98,42,88,104,85,117,175,82],[95,84,53,89,128,100,113,101,45],[75,79,123,47,51,128,81,171,1],[57,17,5,71,102,57,53,41,49],[38,33,13,121,57,73,26,1,85],[41,10,67,138,77,110,90,47,114],[115,21,2,10,102,255,166,23,6],[101,29,16,10,85,128,101,196,26],[57,18,10,102,102,213,34,20,43],[117,20,15,36,163,128,68,1,26]],[[102,61,71,37,34,53,31,243,192],[69,60,71,38,73,119,28,222,37],[68,45,128,34,1,47,11,245,171],[62,17,19,70,146,85,55,62,70],[37,43,37,154,100,163,85,160,1],[63,9,92,136,28,64,32,201,85],[75,15,9,9,64,255,184,119,16],[86,6,28,5,64,255,25,248,1],[56,8,17,132,137,255,55,116,128],[58,15,20,82,135,57,26,121,40]],[[164,50,31,137,154,133,25,35,218],[51,103,44,131,131,123,31,6,158],[86,40,64,135,148,224,45,183,128],[22,26,17,131,240,154,14,1,209],[45,16,21,91,64,222,7,1,197],[56,21,39,155,60,138,23,102,213],[83,12,13,54,192,255,68,47,28],[85,26,85,85,128,128,32,146,171],[18,11,7,63,144,171,4,4,246],[35,27,10,146,174,171,12,26,128]],[[190,80,35,99,180,80,126,54,45],[85,126,47,87,176,51,41,20,32],[101,75,128,139,118,146,116,128,85],[56,41,15,176,236,85,37,9,62],[71,30,17,119,118,255,17,18,138],[101,38,60,138,55,70,43,26,142],[146,36,19,30,171,255,97,27,20],[138,45,61,62,219,1,81,188,64],[32,41,20,117,151,142,20,21,163],[112,19,12,61,195,128,48,4,24]]],ui=[[[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[176,246,255,255,255,255,255,255,255,255,255],[223,241,252,255,255,255,255,255,255,255,255],[249,253,253,255,255,255,255,255,255,255,255]],[[255,244,252,255,255,255,255,255,255,255,255],[234,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255]],[[255,246,254,255,255,255,255,255,255,255,255],[239,253,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[251,255,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[251,254,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,254,253,255,254,255,255,255,255,255,255],[250,255,254,255,254,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[217,255,255,255,255,255,255,255,255,255,255],[225,252,241,253,255,255,254,255,255,255,255],[234,250,241,250,253,255,253,254,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[223,254,254,255,255,255,255,255,255,255,255],[238,253,254,254,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[249,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,255,255,255,255,255,255,255,255,255],[247,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[252,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[186,251,250,255,255,255,255,255,255,255,255],[234,251,244,254,255,255,255,255,255,255,255],[251,251,243,253,254,255,254,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[236,253,254,255,255,255,255,255,255,255,255],[251,253,253,254,254,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[254,254,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[254,254,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[248,255,255,255,255,255,255,255,255,255,255],[250,254,252,254,255,255,255,255,255,255,255],[248,254,249,253,255,255,255,255,255,255,255]],[[255,253,253,255,255,255,255,255,255,255,255],[246,253,253,255,255,255,255,255,255,255,255],[252,254,251,254,254,255,255,255,255,255,255]],[[255,254,252,255,255,255,255,255,255,255,255],[248,254,253,255,255,255,255,255,255,255,255],[253,255,254,254,255,255,255,255,255,255,255]],[[255,251,254,255,255,255,255,255,255,255,255],[245,251,254,255,255,255,255,255,255,255,255],[253,253,254,255,255,255,255,255,255,255,255]],[[255,251,253,255,255,255,255,255,255,255,255],[252,253,254,255,255,255,255,255,255,255,255],[255,254,255,255,255,255,255,255,255,255,255]],[[255,252,255,255,255,255,255,255,255,255,255],[249,255,254,255,255,255,255,255,255,255,255],[255,255,254,255,255,255,255,255,255,255,255]],[[255,255,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]]],hi=[0,1,2,3,6,4,5,6,6,6,6,6,6,6,6,7,0],li=[],fi=[],di=[],pi=1,gi=2,mi=[],vi=[];vr("UpsampleRgbLinePair",Ar,3),vr("UpsampleBgrLinePair",xr,3),vr("UpsampleRgbaLinePair",Ir,4),vr("UpsampleBgraLinePair",kr,4),vr("UpsampleArgbLinePair",Pr,4),vr("UpsampleRgba4444LinePair",_r,2),vr("UpsampleRgb565LinePair",Sr,2);var bi=t.UpsampleRgbLinePair,yi=t.UpsampleBgrLinePair,wi=t.UpsampleRgbaLinePair,Ni=t.UpsampleBgraLinePair,Li=t.UpsampleArgbLinePair,Ai=t.UpsampleRgba4444LinePair,xi=t.UpsampleRgb565LinePair,Si=16,_i=1<<Si-1,Pi=-227,ki=482,Ii=6,Fi=(256<<Ii)-1,Ci=0,ji=a(256),Oi=a(256),Bi=a(256),Mi=a(256),Ei=a(ki-Pi),qi=a(ki-Pi);Fr("YuvToRgbRow",Ar,3),Fr("YuvToBgrRow",xr,3),Fr("YuvToRgbaRow",Ir,4),Fr("YuvToBgraRow",kr,4),Fr("YuvToArgbRow",Pr,4),Fr("YuvToRgba4444Row",_r,2),Fr("YuvToRgb565Row",Sr,2);var Di=[0,4,8,12,128,132,136,140,256,260,264,268,384,388,392,396],Ri=[0,2,8],Ti=[8,7,6,4,4,2,2,2,1,1,1,1],Ui=1;this.WebPDecodeRGBA=function(t,r,n,i,a){var o=qn,s=new rr,c=new ot;s.ba=c,c.S=o,c.width=[c.width],c.height=[c.height];var u=c.width,h=c.height,l=new st;if(null==l||null==t)var f=2;else e(null!=l),f=Br(t,r,n,l.width,l.height,l.Pd,l.Qd,l.format,null);if(0!=f?u=0:(null!=u&&(u[0]=l.width[0]),null!=h&&(h[0]=l.height[0]),u=1),u){c.width=c.width[0],c.height=c.height[0],null!=i&&(i[0]=c.width),null!=a&&(a[0]=c.height);t:{if(i=new Gt,(a=new nr).data=t,a.w=r,a.ha=n,a.kd=1,r=[0],e(null!=a),(0==(t=Br(a.data,a.w,a.ha,null,null,null,r,null,a))||7==t)&&r[0]&&(t=4),0==(r=t)){if(e(null!=s),i.data=a.data,i.w=a.w+a.offset,i.ha=a.ha-a.offset,i.put=dt,i.ac=ft,i.bc=pt,i.ma=s,a.xa){if(null==(t=kt())){s=1;break t}if(function(t,r){var n=[0],i=[0],a=[0];e:for(;;){if(null==t)return 0;if(null==r)return t.a=2,0;if(t.l=r,t.a=0,v(t.m,r.data,r.w,r.ha),!gt(t.m,n,i,a)){t.a=3;break e}if(t.xb=gi,r.width=n[0],r.height=i[0],!It(n[0],i[0],1,t,null))break e;return 1}return e(0!=t.a),0}(t,i)){if(i=0==(r=qr(i.width,i.height,s.Oa,s.ba))){e:{i=t;r:for(;;){if(null==i){i=0;break e}if(e(null!=i.s.yc),e(null!=i.s.Ya),e(0<i.s.Wb),e(null!=(n=i.l)),e(null!=(a=n.ma)),0!=i.xb){if(i.ca=a.ba,i.tb=a.tb,e(null!=i.ca),!Mr(a.Oa,n,Rn)){i.a=2;break r}if(!Ft(i,n.width))break r;if(n.da)break r;if((n.da||nt(i.ca.S))&&mr(),11>i.ca.S||(alert("todo:WebPInitConvertARGBToYUV"),null!=i.ca.f.kb.F&&mr()),i.Pb&&0<i.s.ua&&null==i.s.vb.X&&!O(i.s.vb,i.s.Wa.Xa)){i.a=1;break r}i.xb=0}if(!_t(i,i.V,i.Ba,i.c,i.i,n.o,Lt))break r;a.Dc=i.Ma,i=1;break e}e(0!=i.a),i=0}i=!i}i&&(r=t.a)}else r=t.a}else{if(null==(t=new Yt)){s=1;break t}if(t.Fa=a.na,t.P=a.P,t.qc=a.Sa,Kt(t,i)){if(0==(r=qr(i.width,i.height,s.Oa,s.ba))){if(t.Aa=0,n=s.Oa,e(null!=(a=t)),null!=n){if(0<(u=0>(u=n.Md)?0:100<u?255:255*u/100)){for(h=l=0;4>h;++h)12>(f=a.pb[h]).lc&&(f.ia=u*Ti[0>f.lc?0:f.lc]>>3),l|=f.ia;l&&(alert("todo:VP8InitRandom"),a.ia=1)}a.Ga=n.Id,100<a.Ga?a.Ga=100:0>a.Ga&&(a.Ga=0)}Qt(t,i)||(r=t.a)}}else r=t.a}0==r&&null!=s.Oa&&s.Oa.fd&&(r=Er(s.ba))}s=r}o=0!=s?null:11>o?c.f.RGBA.eb:c.f.kb.y}else o=null;return o};var zi=[3,4,3,4,4,2,2,4,4,4,2,1,1]};function u(t,e){for(var r="",n=0;n<4;n++)r+=String.fromCharCode(t[e++]);return r}function h(t,e){return(t[e+0]<<0|t[e+1]<<8|t[e+2]<<16)>>>0}function l(t,e){return(t[e+0]<<0|t[e+1]<<8|t[e+2]<<16|t[e+3]<<24)>>>0}new c;var f=[0],d=[0],p=[],g=new c,m=t,v=function(t,e){var r={},n=0,i=!1,a=0,o=0;if(r.frames=[],!
/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */
function(t,e,r,n){for(var i=0;i<n;i++)if(t[e+i]!=r.charCodeAt(i))return!0;return!1}(t,e,"RIFF",4)){var s,c;l(t,e+=4);for(e+=8;e<t.length;){var f=u(t,e),d=l(t,e+=4);e+=4;var p=d+(1&d);switch(f){case"VP8 ":case"VP8L":void 0===r.frames[n]&&(r.frames[n]={});(v=r.frames[n]).src_off=i?o:e-8,v.src_size=a+d+8,n++,i&&(i=!1,a=0,o=0);break;case"VP8X":(v=r.header={}).feature_flags=t[e];var g=e+4;v.canvas_width=1+h(t,g);g+=3;v.canvas_height=1+h(t,g);g+=3;break;case"ALPH":i=!0,a=p+8,o=e-8;break;case"ANIM":(v=r.header).bgcolor=l(t,e);g=e+4;v.loop_count=(s=t)[(c=g)+0]<<0|s[c+1]<<8;g+=2;break;case"ANMF":var m,v;(v=r.frames[n]={}).offset_x=2*h(t,e),e+=3,v.offset_y=2*h(t,e),e+=3,v.width=1+h(t,e),e+=3,v.height=1+h(t,e),e+=3,v.duration=h(t,e),e+=3,m=t[e++],v.dispose=1&m,v.blend=m>>1&1}"ANMF"!=f&&(e+=p)}return r}}(m,0);v.response=m,v.rgbaoutput=!0,v.dataurl=!1;var b=v.header?v.header:null,y=v.frames?v.frames:null;if(b){b.loop_counter=b.loop_count,f=[b.canvas_height],d=[b.canvas_width];for(var w=0;w<y.length&&0!=y[w].blend;w++);}var N=y[0],L=g.WebPDecodeRGBA(m,N.src_off,N.src_size,d,f);N.rgba=L,N.imgwidth=d[0],N.imgheight=f[0];for(var A=0;A<d[0]*f[0]*4;A++)p[A]=L[A];return this.width=d,this.height=f,this.data=p,this}!function(t){var r=function(){return"function"==typeof __WEBPACK_IMPORTED_MODULE_1_fflate__["b" /* zlibSync */]},n=function(r,n,a,h){var l=4,f=s;switch(h){case t.image_compression.FAST:l=1,f=o;break;case t.image_compression.MEDIUM:l=6,f=c;break;case t.image_compression.SLOW:l=9,f=u}r=i(r,n,a,f);var d=Object(__WEBPACK_IMPORTED_MODULE_1_fflate__["b" /* zlibSync */])(r,{level:l});return t.__addimage__.arrayBufferToBinaryString(d)},i=function(t,e,r,n){for(var i,a,o,s=t.length/e,c=new Uint8Array(t.length+s),u=l(),h=0;h<s;h+=1){if(o=h*e,i=t.subarray(o,o+e),n)c.set(n(i,r,a),o+h);else{for(var d,p=u.length,g=[];d<p;d+=1)g[d]=u[d](i,r,a);var m=f(g.concat());c.set(g[m],o+h)}a=i}return c},a=function(t){var e=Array.apply([],t);return e.unshift(0),e},o=function(t,e){var r,n=[],i=t.length;n[0]=1;for(var a=0;a<i;a+=1)r=t[a-e]||0,n[a+1]=t[a]-r+256&255;return n},s=function(t,e,r){var n,i=[],a=t.length;i[0]=2;for(var o=0;o<a;o+=1)n=r&&r[o]||0,i[o+1]=t[o]-n+256&255;return i},c=function(t,e,r){var n,i,a=[],o=t.length;a[0]=3;for(var s=0;s<o;s+=1)n=t[s-e]||0,i=r&&r[s]||0,a[s+1]=t[s]+256-(n+i>>>1)&255;return a},u=function(t,e,r){var n,i,a,o,s=[],c=t.length;s[0]=4;for(var u=0;u<c;u+=1)n=t[u-e]||0,i=r&&r[u]||0,a=r&&r[u-e]||0,o=h(n,i,a),s[u+1]=t[u]-o+256&255;return s},h=function(t,e,r){if(t===e&&e===r)return t;var n=Math.abs(e-r),i=Math.abs(t-r),a=Math.abs(t+e-r-r);return n<=i&&n<=a?t:i<=a?e:r},l=function(){return[a,o,s,c,u]},f=function(t){var e=t.map((function(t){return t.reduce((function(t,e){return t+Math.abs(e)}),0)}));return e.indexOf(Math.min.apply(null,e))};t.processPNG=function(e,i,a,o){var s,c,u,h,l,f,d,p,g,m,v,b,y,w,N,L=this.decode.FLATE_DECODE,A="";if(this.__addimage__.isArrayBuffer(e)&&(e=new Uint8Array(e)),this.__addimage__.isArrayBufferView(e)){if(e=(u=new Kt(e)).imgData,c=u.bits,s=u.colorSpace,l=u.colors,-1!==[4,6].indexOf(u.colorType)){if(8===u.bits){g=(p=32==u.pixelBitlength?new Uint32Array(u.decodePixels().buffer):16==u.pixelBitlength?new Uint16Array(u.decodePixels().buffer):new Uint8Array(u.decodePixels().buffer)).length,v=new Uint8Array(g*u.colors),m=new Uint8Array(g);var x,S=u.pixelBitlength-u.bits;for(w=0,N=0;w<g;w++){for(y=p[w],x=0;x<S;)v[N++]=y>>>x&255,x+=u.bits;m[w]=y>>>x&255}}if(16===u.bits){g=(p=new Uint32Array(u.decodePixels().buffer)).length,v=new Uint8Array(g*(32/u.pixelBitlength)*u.colors),m=new Uint8Array(g*(32/u.pixelBitlength)),b=u.colors>1,w=0,N=0;for(var _=0;w<g;)y=p[w++],v[N++]=y>>>0&255,b&&(v[N++]=y>>>16&255,y=p[w++],v[N++]=y>>>0&255),m[_++]=y>>>16&255;c=8}o!==t.image_compression.NONE&&r()?(e=n(v,u.width*u.colors,u.colors,o),d=n(m,u.width,1,o)):(e=v,d=m,L=void 0)}if(3===u.colorType&&(s=this.color_spaces.INDEXED,f=u.palette,u.transparency.indexed)){var P=u.transparency.indexed,k=0;for(w=0,g=P.length;w<g;++w)k+=P[w];if((k/=255)===g-1&&-1!==P.indexOf(0))h=[P.indexOf(0)];else if(k!==g){for(p=u.decodePixels(),m=new Uint8Array(p.length),w=0,g=p.length;w<g;w++)m[w]=P[p[w]];d=n(m,u.width,1)}}var I=function(e){var r;switch(e){case t.image_compression.FAST:r=11;break;case t.image_compression.MEDIUM:r=13;break;case t.image_compression.SLOW:r=14;break;default:r=12}return r}(o);return L===this.decode.FLATE_DECODE&&(A="/Predictor "+I+" "),A+="/Colors "+l+" /BitsPerComponent "+c+" /Columns "+u.width,(this.__addimage__.isArrayBuffer(e)||this.__addimage__.isArrayBufferView(e))&&(e=this.__addimage__.arrayBufferToBinaryString(e)),(d&&this.__addimage__.isArrayBuffer(d)||this.__addimage__.isArrayBufferView(d))&&(d=this.__addimage__.arrayBufferToBinaryString(d)),{alias:a,data:e,index:i,filter:L,decodeParameters:A,transparency:h,palette:f,sMask:d,predictor:I,width:u.width,height:u.height,bitsPerComponent:c,colorSpace:s}}}}(E.API),function(t){t.processGIF89A=function(e,r,n,i){var a=new Zt(e),o=a.width,s=a.height,c=[];a.decodeAndBlitFrameRGBA(0,c);var u={data:c,width:o,height:s},h=new Qt(100).encode(u,100);return t.processJPEG.call(this,h,r,n,i)},t.processGIF87A=t.processGIF89A}(E.API),te.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var r=this.datav.getUint8(this.pos++,!0),n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:n,blue:r,quad:a}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},te.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){a.log("bit decode error:"+t)}},te.prototype.bit1=function(){var t,e=Math.ceil(this.width/8),r=e%4;for(t=this.height-1;t>=0;t--){for(var n=this.bottom_up?t:this.height-1-t,i=0;i<e;i++)for(var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var c=this.palette[a>>7-s&1];this.data[o+4*s]=c.blue,this.data[o+4*s+1]=c.green,this.data[o+4*s+2]=c.red,this.data[o+4*s+3]=255}0!==r&&(this.pos+=4-r)}},te.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<t;i++){var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+2*i*4,s=a>>4,c=15&a,u=this.palette[s];if(this.data[o]=u.blue,this.data[o+1]=u.green,this.data[o+2]=u.red,this.data[o+3]=255,2*i+1>=this.width)break;u=this.palette[c],this.data[o+4]=u.blue,this.data[o+4+1]=u.green,this.data[o+4+2]=u.red,this.data[o+4+3]=255}0!==e&&(this.pos+=4-e)}},te.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;e>=0;e--){for(var r=this.bottom_up?e:this.height-1-e,n=0;n<this.width;n++){var i=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+4*n;if(i<this.palette.length){var o=this.palette[i];this.data[a]=o.red,this.data[a+1]=o.green,this.data[a+2]=o.blue,this.data[a+3]=255}else this.data[a]=255,this.data[a+1]=255,this.data[a+2]=255,this.data[a+3]=255}0!==t&&(this.pos+=4-t)}},te.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<this.width;i++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var o=(a&e)/e*255|0,s=(a>>5&e)/e*255|0,c=(a>>10&e)/e*255|0,u=a>>15?255:0,h=n*this.width*4+4*i;this.data[h]=c,this.data[h+1]=s,this.data[h+2]=o,this.data[h+3]=u}this.pos+=t}},te.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),r=parseInt("111111",2),n=this.height-1;n>=0;n--){for(var i=this.bottom_up?n:this.height-1-n,a=0;a<this.width;a++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(o&e)/e*255|0,c=(o>>5&r)/r*255|0,u=(o>>11)/e*255|0,h=i*this.width*4+4*a;this.data[h]=u,this.data[h+1]=c,this.data[h+2]=s,this.data[h+3]=255}this.pos+=t}},te.prototype.bit24=function(){for(var t=this.height-1;t>=0;t--){for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=e*this.width*4+4*r;this.data[o]=a,this.data[o+1]=i,this.data[o+2]=n,this.data[o+3]=255}this.pos+=this.width%4}},te.prototype.bit32=function(){for(var t=this.height-1;t>=0;t--)for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*r;this.data[s]=a,this.data[s+1]=i,this.data[s+2]=n,this.data[s+3]=o}},te.prototype.getData=function(){return this.data},
/**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.processBMP=function(e,r,n,i){var a=new te(e,!1),o=a.width,s=a.height,c={data:a.getData(),width:o,height:s},u=new Qt(100).encode(c,100);return t.processJPEG.call(this,u,r,n,i)}}(E.API),ee.prototype.getData=function(){return this.data},
/**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.processWEBP=function(e,r,n,i){var a=new ee(e,!1),o=a.width,s=a.height,c={data:a.getData(),width:o,height:s},u=new Qt(100).encode(c,100);return t.processJPEG.call(this,u,r,n,i)}}(E.API),E.API.processRGBA=function(t,e,r){for(var n=t.data,i=n.length,a=new Uint8Array(i/4*3),o=new Uint8Array(i/4),s=0,c=0,u=0;u<i;u+=4){var h=n[u],l=n[u+1],f=n[u+2],d=n[u+3];a[s++]=h,a[s++]=l,a[s++]=f,o[c++]=d}var p=this.__addimage__.arrayBufferToBinaryString(a);return{alpha:this.__addimage__.arrayBufferToBinaryString(o),data:p,index:e,alias:r,colorSpace:"DeviceRGB",bitsPerComponent:8,width:t.width,height:t.height}},E.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"North Macedonia",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")})),this.internal.languageSettings.isSubscribed=!0)),this},Vt=E.API,Gt=Vt.getCharWidthsArray=function(e,r){var n,i,a=(r=r||{}).font||this.internal.getFont(),o=r.fontSize||this.internal.getFontSize(),s=r.charSpace||this.internal.getCharSpace(),c=r.widths?r.widths:a.metadata.Unicode.widths,u=c.fof?c.fof:1,h=r.kerning?r.kerning:a.metadata.Unicode.kerning,l=h.fof?h.fof:1,f=!1!==r.doKerning,d=0,p=e.length,g=0,m=c[0]||u,v=[];for(n=0;n<p;n++)i=e.charCodeAt(n),"function"==typeof a.metadata.widthOfString?v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i))+s*(1e3/o)||0)/1e3):(d=f&&"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(h[i])&&!isNaN(parseInt(h[i][g],10))?h[i][g]/l:0,v.push((c[i]||m)/u+d)),g=i;return v},Yt=Vt.getStringUnitWidth=function(t,e){var r=(e=e||{}).fontSize||this.internal.getFontSize(),n=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return Vt.processArabic&&(t=Vt.processArabic(t)),"function"==typeof n.metadata.widthOfString?n.metadata.widthOfString(t,r,i)/r:Gt.apply(this,arguments).reduce((function(t,e){return t+e}),0)},Jt=function(t,e,r,n){for(var i=[],a=0,o=t.length,s=0;a!==o&&s+e[a]<r;)s+=e[a],a++;i.push(t.slice(0,a));var c=a;for(s=0;a!==o;)s+e[a]>n&&(i.push(t.slice(c,a)),s=0,c=a),s+=e[a],a++;return c!==a&&i.push(t.slice(c,a)),i},Xt=function(t,e,r){r||(r={});var n,i,a,o,s,c,u,h=[],l=[h],f=r.textIndent||0,d=0,p=0,g=t.split(" "),m=Gt.apply(this,[" ",r])[0];if(c=-1===r.lineIndent?g[0].length+2:r.lineIndent||0){var v=Array(c).join(" "),b=[];g.map((function(t){(t=t.split(/\s*\n/)).length>1?b=b.concat(t.map((function(t,e){return(e&&t.length?"\n":"")+t}))):b.push(t[0])})),g=b,c=Yt.apply(this,[v,r])}for(a=0,o=g.length;a<o;a++){var y=0;if(n=g[a],c&&"\n"==n[0]&&(n=n.substr(1),y=1),f+d+(p=(i=Gt.apply(this,[n,r])).reduce((function(t,e){return t+e}),0))>e||y){if(p>e){for(s=Jt.apply(this,[n,i,e-(f+d),e]),h.push(s.shift()),h=[s.pop()];s.length;)l.push([s.shift()]);p=i.slice(n.length-(h[0]?h[0].length:0)).reduce((function(t,e){return t+e}),0)}else h=[n];l.push(h),f=p+c,d=m}else h.push(n),f+=d+p,d=m}return u=c?function(t,e){return(e?v:"")+t.join(" ")}:function(t){return t.join(" ")},l.map(u)},Vt.splitTextToSize=function(t,e,r){var n,i=(r=r||{}).fontSize||this.internal.getFontSize(),a=function(t){if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var e=this.internal.getFont(t.fontName,t.fontStyle);return e.metadata.Unicode?{widths:e.metadata.Unicode.widths||{0:1},kerning:e.metadata.Unicode.kerning||{}}:{font:e.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,r);n=Array.isArray(t)?t:String(t).split(/\r?\n/);var o=1*this.internal.scaleFactor*e/i;a.textIndent=r.textIndent?1*r.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=r.lineIndent;var s,c,u=[];for(s=0,c=n.length;s<c;s++)u=u.concat(Xt.apply(this,[n[s],o,a]));return u},function(e){e.__fontmetrics__=e.__fontmetrics__||{};for(var r="klmnopqrstuvwxyz",n={},i={},a=0;a<r.length;a++)n[r[a]]="0123456789abcdef"[a],i["0123456789abcdef"[a]]=r[a];var o=function(t){return"0x"+parseInt(t,10).toString(16)},s=e.__fontmetrics__.compress=function(e){var r,n,a,c,u=["{"];for(var h in e){if(r=e[h],isNaN(parseInt(h,10))?n="'"+h+"'":(h=parseInt(h,10),n=(n=o(h).slice(2)).slice(0,-1)+i[n.slice(-1)]),"number"==typeof r)r<0?(a=o(r).slice(3),c="-"):(a=o(r).slice(2),c=""),a=c+a.slice(0,-1)+i[a.slice(-1)];else{if("object"!==__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(r))throw new Error("Don't know what to do with value type "+__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(r)+".");a=s(r)}u.push(n+a)}return u.push("}"),u.join("")},c=e.__fontmetrics__.uncompress=function(t){if("string"!=typeof t)throw new Error("Invalid argument passed to uncompress.");for(var e,r,i,a,o={},s=1,c=o,u=[],h="",l="",f=t.length-1,d=1;d<f;d+=1)"'"==(a=t[d])?e?(i=e.join(""),e=void 0):e=[]:e?e.push(a):"{"==a?(u.push([c,i]),c={},i=void 0):"}"==a?((r=u.pop())[0][r[1]]=c,i=void 0,c=r[0]):"-"==a?s=-1:void 0===i?n.hasOwnProperty(a)?(h+=n[a],i=parseInt(h,16)*s,s=1,h=""):h+=a:n.hasOwnProperty(a)?(l+=n[a],c[i]=parseInt(l,16)*s,s=1,i=void 0,l=""):l+=a;return o},u={codePages:["WinAnsiEncoding"],WinAnsiEncoding:c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},h={Unicode:{Courier:u,"Courier-Bold":u,"Courier-BoldOblique":u,"Courier-Oblique":u,Helvetica:u,"Helvetica-Bold":u,"Helvetica-BoldOblique":u,"Helvetica-Oblique":u,"Times-Roman":u,"Times-Bold":u,"Times-BoldItalic":u,"Times-Italic":u}},l={Unicode:{"Courier-Oblique":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};e.events.push(["addFont",function(t){var e=t.font,r=l.Unicode[e.postScriptName];r&&(e.metadata.Unicode={},e.metadata.Unicode.widths=r.widths,e.metadata.Unicode.kerning=r.kerning);var n=h.Unicode[e.postScriptName];n&&(e.metadata.Unicode.encoding=n,e.encoding=n.codePages[0])}])}(E.API),
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r};t.API.events.push(["addFont",function(r){var n=void 0,i=r.font,a=r.instance;if(!i.isStandardFont){if(void 0===a)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");if("string"!=typeof(n=!1===a.existsFileInVFS(i.postScriptName)?a.loadFile(i.postScriptName):a.getFileFromVFS(i.postScriptName)))throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");!function(r,n){n=/^\x00\x01\x00\x00/.test(n)?e(n):e(u(n)),r.metadata=t.API.TTFFont.open(n),r.metadata.Unicode=r.metadata.Unicode||{encoding:{},kerning:{},widths:[]},r.metadata.glyIdsUsed=[0]}(i,n)}}])}(E),
/** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){function e(){return(n.canvg?Promise.resolve(n.canvg):__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 3087))).catch((function(t){return Promise.reject(new Error("Could not load canvg: "+t))})).then((function(t){return t.default?t.default:t}))}E.API.addSvgAsImage=function(t,r,n,i,o,s,c,u){if(isNaN(r)||isNaN(n))throw a.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(i)||isNaN(o))throw a.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var h=document.createElement("canvas");h.width=i,h.height=o;var l=h.getContext("2d");l.fillStyle="#fff",l.fillRect(0,0,h.width,h.height);var f={ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0},d=this;return e().then((function(e){return e.fromString(l,t,f)}),(function(){return Promise.reject(new Error("Could not load canvg."))})).then((function(t){return t.render(f)})).then((function(){d.addImage(h.toDataURL("image/jpeg",1),r,n,i,o,c,u)}))}}(),E.API.putTotalPages=function(t){var e,r=0;parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),r=this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),r=this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var n=1;n<=this.internal.getNumberOfPages();n++)for(var i=0;i<this.internal.pages[n].length;i++)this.internal.pages[n][i]=this.internal.pages[n][i].replace(e,r);return this},E.API.viewerPreferences=function(e,r){var n;e=e||{},r=r||!1;var i,a,o,s={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},c=Object.keys(s),u=[],h=0,l=0,f=0;function d(t,e){var r,n=!1;for(r=0;r<t.length;r+=1)t[r]===e&&(n=!0);return n}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(s)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===e||!0===r){var p=c.length;for(f=0;f<p;f+=1)n[c[f]].value=n[c[f]].defaultValue,n[c[f]].explicitSet=!1}if("object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e))for(a in e)if(o=e[a],d(c,a)&&void 0!==o){if("boolean"===n[a].type&&"boolean"==typeof o)n[a].value=o;else if("name"===n[a].type&&d(n[a].valueSet,o))n[a].value=o;else if("integer"===n[a].type&&Number.isInteger(o))n[a].value=o;else if("array"===n[a].type){for(h=0;h<o.length;h+=1)if(i=!0,1===o[h].length&&"number"==typeof o[h][0])u.push(String(o[h]-1));else if(o[h].length>1){for(l=0;l<o[h].length;l+=1)"number"!=typeof o[h][l]&&(i=!1);!0===i&&u.push([o[h][0]-1,o[h][1]-1].join(" "))}n[a].value="["+u.join(" ")+"]"}else n[a].value=n[a].defaultValue;n[a].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")})),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){var e=function(){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+this.internal.__metadata__.namespaceuri+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),r=unescape(encodeURIComponent(t)),n=unescape(encodeURIComponent(this.internal.__metadata__.metadata)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),a=unescape(encodeURIComponent("</x:xmpmeta>")),o=r.length+n.length+i.length+e.length+a.length;this.internal.__metadata__.metadata_object_number=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+o+" >>"),this.internal.write("stream"),this.internal.write(e+r+n+i+a),this.internal.write("endstream"),this.internal.write("endobj")},r=function(){this.internal.__metadata__.metadata_object_number&&this.internal.write("/Metadata "+this.internal.__metadata__.metadata_object_number+" 0 R")};t.addMetadata=function(t,n){return void 0===this.internal.__metadata__&&(this.internal.__metadata__={metadata:t,namespaceuri:n||"http://jspdf.default.namespaceuri/"},this.internal.events.subscribe("putCatalog",r),this.internal.events.subscribe("postPutResources",e)),this}}(E.API),function(t){var e=t.API,r=e.pdfEscape16=function(t,e){for(var r,n=e.metadata.Unicode.widths,i=["","0","00","000","0000"],a=[""],o=0,s=t.length;o<s;++o){if(r=e.metadata.characterToGlyph(t.charCodeAt(o)),e.metadata.glyIdsUsed.push(r),e.metadata.toUnicode[r]=t.charCodeAt(o),-1==n.indexOf(r)&&(n.push(r),n.push([parseInt(e.metadata.widthOfGlyph(r),10)])),"0"==r)return a.join("");r=r.toString(16),a.push(i[4-r.length],r)}return a.join("")},n=function(t){var e,r,n,i,a,o,s;for(a="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",n=[],o=0,s=(r=Object.keys(t).sort((function(t,e){return t-e}))).length;o<s;o++)e=r[o],n.length>=100&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar",n=[]),void 0!==t[e]&&null!==t[e]&&"function"==typeof t[e].toString&&(i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),n.push("<"+e+"><"+i+">"));return n.length&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar\n"),a+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream;if(r.metadata instanceof t.API.TTFFont&&"Identity-H"===r.encoding){for(var s=r.metadata.Unicode.widths,c=r.metadata.subset.encode(r.metadata.glyIdsUsed,1),u="",h=0;h<c.length;h++)u+=String.fromCharCode(c[h]);var l=a();o({data:u,addLength1:!0,objectId:l}),i("endobj");var f=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:f}),i("endobj");var d=a();i("<<"),i("/Type /FontDescriptor"),i("/FontName /"+F(r.fontName)),i("/FontFile2 "+l+" 0 R"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/Flags "+r.metadata.flags),i("/StemV "+r.metadata.stemV),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i(">>"),i("endobj");var p=a();i("<<"),i("/Type /Font"),i("/BaseFont /"+F(r.fontName)),i("/FontDescriptor "+d+" 0 R"),i("/W "+t.API.PDFObject.convert(s)),i("/CIDToGIDMap /Identity"),i("/DW 1000"),i("/Subtype /CIDFontType2"),i("/CIDSystemInfo"),i("<<"),i("/Supplement 0"),i("/Registry (Adobe)"),i("/Ordering ("+r.encoding+")"),i(">>"),i(">>"),i("endobj"),r.objectNumber=a(),i("<<"),i("/Type /Font"),i("/Subtype /Type0"),i("/ToUnicode "+f+" 0 R"),i("/BaseFont /"+F(r.fontName)),i("/Encoding /"+r.encoding),i("/DescendantFonts ["+p+" 0 R]"),i(">>"),i("endobj"),r.isAlreadyPutted=!0}}(e)}]);e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream;if(r.metadata instanceof t.API.TTFFont&&"WinAnsiEncoding"===r.encoding){for(var s=r.metadata.rawData,c="",u=0;u<s.length;u++)c+=String.fromCharCode(s[u]);var h=a();o({data:c,addLength1:!0,objectId:h}),i("endobj");var l=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:l}),i("endobj");var f=a();i("<<"),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i("/StemV "+r.metadata.stemV),i("/Type /FontDescriptor"),i("/FontFile2 "+h+" 0 R"),i("/Flags 96"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/FontName /"+F(r.fontName)),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i(">>"),i("endobj"),r.objectNumber=a();for(var d=0;d<r.metadata.hmtx.widths.length;d++)r.metadata.hmtx.widths[d]=parseInt(r.metadata.hmtx.widths[d]*(1e3/r.metadata.head.unitsPerEm));i("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+F(r.fontName)+"/FontDescriptor "+f+" 0 R/Encoding/"+r.encoding+" /FirstChar 29 /LastChar 255 /Widths "+t.API.PDFObject.convert(r.metadata.hmtx.widths)+">>"),i("endobj"),r.isAlreadyPutted=!0}}(e)}]);var i=function(t){var e,n=t.text||"",i=t.x,a=t.y,o=t.options||{},s=t.mutex||{},c=s.pdfEscape,u=s.activeFontKey,h=s.fonts,l=u,f="",d=0,p="",g=h[l].encoding;if("Identity-H"!==h[l].encoding)return{text:n,x:i,y:a,options:o,mutex:s};for(p=n,l=u,Array.isArray(n)&&(p=n[0]),d=0;d<p.length;d+=1)h[l].metadata.hasOwnProperty("cmap")&&(e=h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]),e||p[d].charCodeAt(0)<256&&h[l].metadata.hasOwnProperty("Unicode")?f+=p[d]:f+="";var m="";return parseInt(l.slice(1))<14||"WinAnsiEncoding"===g?m=c(f,l).split("").map((function(t){return t.charCodeAt(0).toString(16)})).join(""):"Identity-H"===g&&(m=r(f,h[l])),s.isHex=!0,{text:m,x:i,y:a,options:o,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",r=[],n={text:e,x:t.x,y:t.y,options:t.options,mutex:t.mutex};if(Array.isArray(e)){var a=0;for(a=0;a<e.length;a+=1)Array.isArray(e[a])&&3===e[a].length?r.push([i(Object.assign({},n,{text:e[a][0]})).text,e[a][1],e[a][2]]):r.push(i(Object.assign({},n,{text:e[a]})).text);t.text=r}else t.text=i(Object.assign({},n,{text:e})).text}])}(E),
/**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(){return void 0===this.internal.vFS&&(this.internal.vFS={}),!0};t.existsFileInVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]},t.addFileToVFS=function(t,r){return e.call(this),this.internal.vFS[t]=r,this},t.getFileFromVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null}}(E.API),
/**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var r,n,i,a,o,s,c,u=e,h=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],l=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],f={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},d={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},p=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],g=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),m=!1,v=0;this.__bidiEngine__={};var b=function(t){var e=t.charCodeAt(),r=e>>8,n=d[r];return void 0!==n?u[256*n+(255&e)]:252===r||253===r?"AL":g.test(r)?"L":8===r?"R":"N"},y=function(t){for(var e,r=0;r<t.length;r++){if("L"===(e=b(t.charAt(r))))return!1;if("R"===e)return!0}return!1},w=function(t,e,o,s){var c,u,h,l,f=e[s];switch(f){case"L":case"R":m=!1;break;case"N":case"AN":break;case"EN":m&&(f="AN");break;case"AL":m=!0,f="R";break;case"WS":f="N";break;case"CS":s<1||s+1>=e.length||"EN"!==(c=o[s-1])&&"AN"!==c||"EN"!==(u=e[s+1])&&"AN"!==u?f="N":m&&(u="AN"),f=u===c?u:"N";break;case"ES":f="EN"===(c=s>0?o[s-1]:"B")&&s+1<e.length&&"EN"===e[s+1]?"EN":"N";break;case"ET":if(s>0&&"EN"===o[s-1]){f="EN";break}if(m){f="N";break}for(h=s+1,l=e.length;h<l&&"ET"===e[h];)h++;f=h<l&&"EN"===e[h]?"EN":"N";break;case"NSM":if(i&&!a){for(l=e.length,h=s+1;h<l&&"NSM"===e[h];)h++;if(h<l){var d=t[s],p=d>=1425&&d<=2303||64286===d;if(c=e[h],p&&("R"===c||"AL"===c)){f="R";break}}}f=s<1||"B"===(c=e[s-1])?"N":o[s-1];break;case"B":m=!1,r=!0,f=v;break;case"S":n=!0,f="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":m=!1;break;case"BN":f="N"}return f},N=function(t,e,r){var n=t.split("");return r&&L(n,r,{hiLevel:v}),n.reverse(),e&&e.reverse(),n.join("")},L=function(t,e,i){var a,o,s,c,u,d=-1,p=t.length,g=0,y=[],N=v?l:h,L=[];for(m=!1,r=!1,n=!1,o=0;o<p;o++)L[o]=b(t[o]);for(s=0;s<p;s++){if(u=g,y[s]=w(t,L,y,s),a=240&(g=N[u][f[y[s]]]),g&=15,e[s]=c=N[g][5],a>0)if(16===a){for(o=d;o<s;o++)e[o]=1;d=-1}else d=-1;if(N[g][6])-1===d&&(d=s);else if(d>-1){for(o=d;o<s;o++)e[o]=c;d=-1}"B"===L[s]&&(e[s]=0),i.hiLevel|=c}n&&function(t,e,r){for(var n=0;n<r;n++)if("S"===t[n]){e[n]=v;for(var i=n-1;i>=0&&"WS"===t[i];i--)e[i]=v}}(L,e,p)},A=function(t,e,n,i,a){if(!(a.hiLevel<t)){if(1===t&&1===v&&!r)return e.reverse(),void(n&&n.reverse());for(var o,s,c,u,h=e.length,l=0;l<h;){if(i[l]>=t){for(c=l+1;c<h&&i[c]>=t;)c++;for(u=l,s=c-1;u<s;u++,s--)o=e[u],e[u]=e[s],e[s]=o,n&&(o=n[u],n[u]=n[s],n[s]=o);l=c}l++}}},x=function(t,e,r){var n=t.split(""),i={hiLevel:v};return r||(r=[]),L(n,r,i),function(t,e,r){if(0!==r.hiLevel&&c)for(var n,i=0;i<t.length;i++)1===e[i]&&(n=p.indexOf(t[i]))>=0&&(t[i]=p[n+1])}(n,r,i),A(2,n,e,r,i),A(1,n,e,r,i),n.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,r){if(function(t,e){if(e)for(var r=0;r<t.length;r++)e[r]=r;void 0===a&&(a=y(t)),void 0===s&&(s=y(t))}(t,e),i||!o||s)if(i&&o&&a^s)v=a?1:0,t=N(t,e,r);else if(!i&&o&&s)v=a?1:0,t=x(t,e,r),t=N(t,e);else if(!i||a||o||s){if(i&&!o&&a^s)t=N(t,e),a?(v=0,t=x(t,e,r)):(v=1,t=x(t,e,r),t=N(t,e));else if(i&&a&&!o&&s)v=1,t=x(t,e,r),t=N(t,e);else if(!i&&!o&&a^s){var n=c;a?(v=1,t=x(t,e,r),v=0,c=!1,t=x(t,e,r),c=n):(v=0,t=x(t,e,r),t=N(t,e),v=1,c=!1,t=x(t,e,r),c=n,t=N(t,e))}}else v=0,t=x(t,e,r);else v=a?1:0,t=x(t,e,r);return t},this.__bidiEngine__.setOptions=function(t){t&&(i=t.isInputVisual,o=t.isOutputVisual,a=t.isInputRtl,s=t.isOutputRtl,c=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],r=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),i=(t.mutex,n.lang,[]);if(n.isInputVisual="boolean"!=typeof n.isInputVisual||n.isInputVisual,r.setOptions(n),"[object Array]"===Object.prototype.toString.call(e)){var a=0;for(i=[],a=0;a<e.length;a+=1)"[object Array]"===Object.prototype.toString.call(e[a])?i.push([r.doBidiReorder(e[a][0]),e[a][1],e[a][2]]):i.push([r.doBidiReorder(e[a])]);t.text=i}else t.text=r.doBidiReorder(e);r.setOptions({isInputVisual:!0})}])}(E),E.API.TTFFont=function(){function t(t){var e;if(this.rawData=t,e=this.contents=new ne(t),this.contents.pos=4,"ttcf"===e.readString(4))throw new Error("TTCF not supported.");e.pos=0,this.parse(),this.subset=new Le(this),this.registerTTF()}return t.open=function(e){return new t(e)},t.prototype.parse=function(){return this.directory=new ie(this.contents),this.head=new se(this),this.name=new pe(this),this.cmap=new ue(this),this.toUnicode={},this.hhea=new he(this),this.maxp=new ge(this),this.hmtx=new me(this),this.post=new fe(this),this.os2=new le(this),this.loca=new Ne(this),this.glyf=new be(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},t.prototype.registerTTF=function(){var t,e,r,n,i;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var e,r,n,i;for(i=[],e=0,r=(n=this.bbox).length;e<r;e++)t=n[e],i.push(Math.round(t*this.scaleFactor));return i}.call(this),this.stemV=0,this.post.exists?(r=255&(n=this.post.italic_angle),0!=(32768&(e=n>>16))&&(e=-(1+(65535^e))),this.italicAngle=+(e+"."+r)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(i=this.familyClass)||2===i||3===i||4===i||5===i||7===i,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},t.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},t.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},t.prototype.widthOfString=function(t,e,r){var n,i,a,o;for(a=0,i=0,o=(t=""+t).length;0<=o?i<o:i>o;i=0<=o?++i:--i)n=t.charCodeAt(i),a+=this.widthOfGlyph(this.characterToGlyph(n))+r*(1e3/e)||0;return a*(e/1e3)},t.prototype.lineHeight=function(t,e){var r;return null==e&&(e=!1),r=e?this.lineGap:0,(this.ascender+r-this.decender)/1e3*t},t}();var re,ne=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return(t=this.readUInt32())>=2147483648?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return(t=this.readUInt16())>=32768?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;e=0<=t?++e:--e)r[e]=String.fromCharCode(this.readByte());return r.join("")},t.prototype.writeString=function(t){var e,r,n;for(n=[],e=0,r=t.length;0<=r?e<r:e>r;e=0<=r?++e:--e)n.push(this.writeByte(t.charCodeAt(e)));return n},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,r,n,i,a,o,s;return t=this.readByte(),e=this.readByte(),r=this.readByte(),n=this.readByte(),i=this.readByte(),a=this.readByte(),o=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^r)+4294967296*(255^n)+16777216*(255^i)+65536*(255^a)+256*(255^o)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*r+4294967296*n+16777216*i+65536*a+256*o+s},t.prototype.writeLongLong=function(t){var e,r;return e=Math.floor(t/4294967296),r=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(r>>24&255),this.writeByte(r>>16&255),this.writeByte(r>>8&255),this.writeByte(255&r)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,r;for(e=[],r=0;0<=t?r<t:r>t;r=0<=t?++r:--r)e.push(this.readByte());return e},t.prototype.write=function(t){var e,r,n,i;for(i=[],r=0,n=t.length;r<n;r++)e=t[r],i.push(this.writeByte(e));return i},t}(),ie=function(){var t;function e(t){var e,r,n;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},r=0,n=this.tableCount;0<=n?r<n:r>n;r=0<=n?++r:--r)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return e.prototype.encode=function(e){var r,n,i,a,o,s,c,u,h,l,f,d,p;for(p in f=Object.keys(e).length,s=Math.log(2),h=16*Math.floor(Math.log(f)/s),a=Math.floor(h/s),u=16*f-h,(n=new ne).writeInt(this.scalarType),n.writeShort(f),n.writeShort(h),n.writeShort(a),n.writeShort(u),i=16*f,c=n.pos+i,o=null,d=[],e)for(l=e[p],n.writeString(p),n.writeInt(t(l)),n.writeInt(c),n.writeInt(l.length),d=d.concat(l),"head"===p&&(o=c),c+=l.length;c%4;)d.push(0),c++;return n.write(d),r=2981146554-t(n.data),n.pos=o+8,n.writeUInt32(r),n.data},t=function(t){var e,r,n,i;for(t=ve.call(t);t.length%4;)t.push(0);for(n=new ne(t),r=0,e=0,i=t.length;e<i;e=e+=4)r+=n.readUInt32();return 4294967295&r},e}(),ae={}.hasOwnProperty,oe=function(t,e){for(var r in e)ae.call(e,r)&&(t[r]=e[r]);function n(){this.constructor=t}return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t};re=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var se=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new ne).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),ce=function(){function t(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m,v,b;switch(this.platformID=t.readUInt16(),this.encodingID=t.readShort(),this.offset=e+t.readInt(),h=t.pos,t.pos=this.offset,this.format=t.readUInt16(),this.length=t.readUInt16(),this.language=t.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=0;s<256;++s)this.codeMap[s]=t.readByte();break;case 4:for(f=t.readUInt16(),l=f/2,t.pos+=6,i=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),t.pos+=2,p=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),c=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),u=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),n=(this.length-t.pos+this.offset)/2,o=function(){var e,r;for(r=[],s=e=0;0<=n?e<n:e>n;s=0<=n?++e:--e)r.push(t.readUInt16());return r}(),s=m=0,b=i.length;m<b;s=++m)for(g=i[s],r=v=d=p[s];d<=g?v<=g:v>=g;r=d<=g?++v:--v)0===u[s]?a=r+c[s]:0!==(a=o[u[s]/2+(r-d)-(l-s)]||0)&&(a+=c[s]),this.codeMap[r]=65535&a}t.pos=h}return t.encode=function(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,I,F,C,j,O,B,M,E,q,D,R,T,U,z,H,W,V,G,Y;switch(I=new ne,a=Object.keys(t).sort((function(t,e){return t-e})),e){case"macroman":for(p=0,g=function(){var t=[];for(d=0;d<256;++d)t.push(0);return t}(),v={0:0},i={},F=0,B=a.length;F<B;F++)null==v[W=t[n=a[F]]]&&(v[W]=++p),i[n]={old:t[n],new:v[t[n]]},g[n]=v[t[n]];return I.writeUInt16(1),I.writeUInt16(0),I.writeUInt32(12),I.writeUInt16(0),I.writeUInt16(262),I.writeUInt16(0),I.write(g),{charMap:i,subtable:I.data,maxGlyphID:p+1};case"unicode":for(P=[],h=[],b=0,v={},r={},m=c=null,C=0,M=a.length;C<M;C++)null==v[w=t[n=a[C]]]&&(v[w]=++b),r[n]={old:w,new:v[w]},o=v[w]-n,null!=m&&o===c||(m&&h.push(m),P.push(n),c=o),m=n;for(m&&h.push(m),h.push(65535),P.push(65535),S=2*(x=P.length),A=2*Math.pow(Math.log(x)/Math.LN2,2),l=Math.log(A/2)/Math.LN2,L=2*x-A,s=[],N=[],f=[],d=j=0,E=P.length;j<E;d=++j){if(_=P[d],u=h[d],65535===_){s.push(0),N.push(0);break}if(_-(k=r[_].new)>=32768)for(s.push(0),N.push(2*(f.length+x-d)),n=O=_;_<=u?O<=u:O>=u;n=_<=u?++O:--O)f.push(r[n].new);else s.push(k-_),N.push(0)}for(I.writeUInt16(3),I.writeUInt16(1),I.writeUInt32(12),I.writeUInt16(4),I.writeUInt16(16+8*x+2*f.length),I.writeUInt16(0),I.writeUInt16(S),I.writeUInt16(A),I.writeUInt16(l),I.writeUInt16(L),z=0,q=h.length;z<q;z++)n=h[z],I.writeUInt16(n);for(I.writeUInt16(0),H=0,D=P.length;H<D;H++)n=P[H],I.writeUInt16(n);for(V=0,R=s.length;V<R;V++)o=s[V],I.writeUInt16(o);for(G=0,T=N.length;G<T;G++)y=N[G],I.writeUInt16(y);for(Y=0,U=f.length;Y<U;Y++)p=f[Y],I.writeUInt16(p);return{charMap:r,subtable:I.data,maxGlyphID:b+1}}},t}(),ue=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,r,n;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:r>n;r=0<=n?++r:--r)e=new ce(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var r,n;return null==e&&(e="macroman"),r=ce.encode(t,e),(n=new ne).writeUInt16(0),n.writeUInt16(1),r.table=n.data.concat(r.subtable),r},e}(),he=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),le=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="OS/2",e.prototype.parse=function(t){if(t.pos=this.offset,this.version=t.readUInt16(),this.averageCharWidth=t.readShort(),this.weightClass=t.readUInt16(),this.widthClass=t.readUInt16(),this.type=t.readShort(),this.ySubscriptXSize=t.readShort(),this.ySubscriptYSize=t.readShort(),this.ySubscriptXOffset=t.readShort(),this.ySubscriptYOffset=t.readShort(),this.ySuperscriptXSize=t.readShort(),this.ySuperscriptYSize=t.readShort(),this.ySuperscriptXOffset=t.readShort(),this.ySuperscriptYOffset=t.readShort(),this.yStrikeoutSize=t.readShort(),this.yStrikeoutPosition=t.readShort(),this.familyClass=t.readShort(),this.panose=function(){var e,r;for(r=[],e=0;e<10;++e)r.push(t.readByte());return r}(),this.charRange=function(){var e,r;for(r=[],e=0;e<4;++e)r.push(t.readInt());return r}(),this.vendorID=t.readString(4),this.selection=t.readShort(),this.firstCharIndex=t.readShort(),this.lastCharIndex=t.readShort(),this.version>0&&(this.ascent=t.readShort(),this.descent=t.readShort(),this.lineGap=t.readShort(),this.winAscent=t.readShort(),this.winDescent=t.readShort(),this.codePageRange=function(){var e,r;for(r=[],e=0;e<2;e=++e)r.push(t.readInt());return r}(),this.version>1))return this.xHeight=t.readShort(),this.capHeight=t.readShort(),this.defaultChar=t.readShort(),this.breakChar=t.readShort(),this.maxContext=t.readShort()},e}(),fe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="post",e.prototype.parse=function(t){var e,r,n;switch(t.pos=this.offset,this.format=t.readInt(),this.italicAngle=t.readInt(),this.underlinePosition=t.readShort(),this.underlineThickness=t.readShort(),this.isFixedPitch=t.readInt(),this.minMemType42=t.readInt(),this.maxMemType42=t.readInt(),this.minMemType1=t.readInt(),this.maxMemType1=t.readInt(),this.format){case 65536:break;case 131072:var i;for(r=t.readUInt16(),this.glyphNameIndex=[],i=0;0<=r?i<r:i>r;i=0<=r?++i:--i)this.glyphNameIndex.push(t.readUInt16());for(this.names=[],n=[];t.pos<this.offset+this.length;)e=t.readByte(),n.push(this.names.push(t.readString(e)));return n;case 151552:return r=t.readUInt16(),this.offsets=t.read(r);case 196608:break;case 262144:return this.map=function(){var e,r,n;for(n=[],i=e=0,r=this.file.maxp.numGlyphs;0<=r?e<r:e>r;i=0<=r?++e:--e)n.push(t.readUInt32());return n}.call(this)}},e}(),de=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},pe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="name",e.prototype.parse=function(t){var e,r,n,i,a,o,s,c,u,h,l;for(t.pos=this.offset,t.readShort(),e=t.readShort(),o=t.readShort(),r=[],i=0;0<=e?i<e:i>e;i=0<=e?++i:--i)r.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+o+t.readShort()});for(s={},i=u=0,h=r.length;u<h;i=++u)n=r[i],t.pos=n.offset,c=t.readString(n.length),a=new de(c,n),null==s[l=n.nameID]&&(s[l]=[]),s[n.nameID].push(a);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),ge=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),me=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="hmtx",e.prototype.parse=function(t){var e,r,n,i,a,o,s;for(t.pos=this.offset,this.metrics=[],e=0,o=this.file.hhea.numberOfMetrics;0<=o?e<o:e>o;e=0<=o?++e:--e)this.metrics.push({advance:t.readUInt16(),lsb:t.readInt16()});for(n=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var r,i;for(i=[],e=r=0;0<=n?r<n:r>n;e=0<=n?++r:--r)i.push(t.readInt16());return i}(),this.widths=function(){var t,e,r,n;for(n=[],t=0,e=(r=this.metrics).length;t<e;t++)i=r[t],n.push(i.advance);return n}.call(this),r=this.widths[this.widths.length-1],s=[],e=a=0;0<=n?a<n:a>n;e=0<=n?++a:--a)s.push(this.widths.push(r));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),ve=[].slice,be=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="glyf",e.prototype.parse=function(){return this.cache={}},e.prototype.glyphFor=function(t){var e,r,n,i,a,o,s,c,u,h;return t in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,r=i.indexOf(t),0===(n=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+r,a=(o=new ne(e.read(n))).readShort(),c=o.readShort(),h=o.readShort(),s=o.readShort(),u=o.readShort(),this.cache[t]=-1===a?new we(o,c,h,s,u):new ye(o,a,c,h,s,u),this.cache[t]))},e.prototype.encode=function(t,e,r){var n,i,a,o,s;for(a=[],i=[],o=0,s=e.length;o<s;o++)n=t[e[o]],i.push(a.length),n&&(a=a.concat(n.encode(r)));return i.push(a.length),{table:a,offsets:i}},e}(),ye=function(){function t(t,e,r,n,i,a){this.raw=t,this.numberOfContours=e,this.xMin=r,this.yMin=n,this.xMax=i,this.yMax=a,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),we=function(){function t(t,e,r,n,i){var a,o;for(this.raw=t,this.xMin=e,this.yMin=r,this.xMax=n,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],a=this.raw;o=a.readShort(),this.glyphOffsets.push(a.pos),this.glyphIDs.push(a.readUInt16()),32&o;)a.pos+=1&o?4:2,128&o?a.pos+=8:64&o?a.pos+=4:8&o&&(a.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(){var t,e,r;for(e=new ne(ve.call(this.raw.data)),t=0,r=this.glyphIDs.length;t<r;++t)e.pos=this.glyphOffsets[t];return e.data},t}(),Ne=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="loca",e.prototype.parse=function(t){var e,r;return t.pos=this.offset,e=this.file.head.indexToLocFormat,this.offsets=0===e?function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=2)n.push(2*t.readUInt16());return n}.call(this):function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=4)n.push(t.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var r=new Uint32Array(this.offsets.length),n=0,i=0,a=0;a<r.length;++a)if(r[a]=n,i<e.length&&e[i]==a){++i,r[a]=n;var o=this.offsets[a],s=this.offsets[a+1]-o;s>0&&(n+=s)}for(var c=new Array(4*r.length),u=0;u<r.length;++u)c[4*u+3]=255&r[u],c[4*u+2]=(65280&r[u])>>8,c[4*u+1]=(16711680&r[u])>>16,c[4*u]=(4278190080&r[u])>>24;return c},e}(),Le=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,r,n,i;for(e in n=this.font.cmap.tables[0].codeMap,t={},i=this.subset)r=i[e],t[e]=n[r];return t},t.prototype.glyphsFor=function(t){var e,r,n,i,a,o,s;for(n={},a=0,o=t.length;a<o;a++)n[i=t[a]]=this.font.glyf.glyphFor(i);for(i in e=[],n)(null!=(r=n[i])?r.compound:void 0)&&e.push.apply(e,r.glyphIDs);if(e.length>0)for(i in s=this.glyphsFor(e))r=s[i],n[i]=r;return n},t.prototype.encode=function(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m;for(n in r=ue.encode(this.generateCmap(),"unicode"),a=this.glyphsFor(t),f={0:0},m=r.charMap)f[(s=m[n]).old]=s.new;for(d in l=r.maxGlyphID,a)d in f||(f[d]=l++);return u=function(t){var e,r;for(e in r={},t)r[t[e]]=e;return r}(f),h=Object.keys(u).sort((function(t,e){return t-e})),p=function(){var t,e,r;for(r=[],t=0,e=h.length;t<e;t++)o=h[t],r.push(u[o]);return r}(),i=this.font.glyf.encode(a,p,f),c=this.font.loca.encode(i.offsets,p),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:c,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();E.API.PDFObject=function(){var t;function e(){}return t=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},e.convert=function(r){var n,i,a,o;if(Array.isArray(r))return"["+function(){var t,i,a;for(a=[],t=0,i=r.length;t<i;t++)n=r[t],a.push(e.convert(n));return a}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+t(r.getUTCFullYear(),4)+t(r.getUTCMonth(),2)+t(r.getUTCDate(),2)+t(r.getUTCHours(),2)+t(r.getUTCMinutes(),2)+t(r.getUTCSeconds(),2)+"Z)";if("[object Object]"==={}.toString.call(r)){for(i in a=["<<"],r)o=r[i],a.push("/"+i+" "+e.convert(o));return a.push(">>"),a.join("\n")}return""+r},e}();/* harmony default export */ __webpack_exports__["default"] = (E);
//# sourceMappingURL=jspdf.es.min.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(24)))

/***/ }),
/* 2617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FlateErrorCode */
/* unused harmony export Deflate */
/* unused harmony export AsyncDeflate */
/* unused harmony export deflate */
/* unused harmony export deflateSync */
/* unused harmony export Inflate */
/* unused harmony export AsyncInflate */
/* unused harmony export inflate */
/* unused harmony export inflateSync */
/* unused harmony export Gzip */
/* unused harmony export AsyncGzip */
/* unused harmony export gzip */
/* unused harmony export gzipSync */
/* unused harmony export Gunzip */
/* unused harmony export AsyncGunzip */
/* unused harmony export gunzip */
/* unused harmony export gunzipSync */
/* unused harmony export Zlib */
/* unused harmony export AsyncZlib */
/* unused harmony export zlib */
/* harmony export (immutable) */ __webpack_exports__["b"] = zlibSync;
/* unused harmony export Unzlib */
/* unused harmony export AsyncUnzlib */
/* unused harmony export unzlib */
/* harmony export (immutable) */ __webpack_exports__["a"] = unzlibSync;
/* unused harmony export compress */
/* unused harmony export AsyncCompress */
/* unused harmony export compressSync */
/* unused harmony export Compress */
/* unused harmony export Decompress */
/* unused harmony export AsyncDecompress */
/* unused harmony export decompress */
/* unused harmony export decompressSync */
/* unused harmony export DecodeUTF8 */
/* unused harmony export EncodeUTF8 */
/* unused harmony export strToU8 */
/* unused harmony export strFromU8 */
/* unused harmony export ZipPassThrough */
/* unused harmony export ZipDeflate */
/* unused harmony export AsyncZipDeflate */
/* unused harmony export Zip */
/* unused harmony export zip */
/* unused harmony export zipSync */
/* unused harmony export UnzipPassThrough */
/* unused harmony export UnzipInflate */
/* unused harmony export AsyncUnzipInflate */
/* unused harmony export Unzip */
/* unused harmony export unzip */
/* unused harmony export unzipSync */
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var ch2 = {};
var wk = (function (c, id, msg, transfer, cb) {
    var w = new Worker(ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], { type: 'text/javascript' }))));
    w.onmessage = function (e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        }
        else
            cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
});

// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, i32 = Int32Array;
// fixed length extra bits
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */ 0, 0, /* impossible */ 0]);
// fixed distance extra bits
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */ 0, 0]);
// code length index map
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
// get base, reverse index map from extra bits
var freb = function (eb, start) {
    var b = new u16(31);
    for (var i = 0; i < 31; ++i) {
        b[i] = start += 1 << eb[i - 1];
    }
    // numbers here are at max 18 bits
    var r = new i32(b[30]);
    for (var i = 1; i < 30; ++i) {
        for (var j = b[i]; j < b[i + 1]; ++j) {
            r[j] = ((j - b[i]) << 5) | i;
        }
    }
    return { b: b, r: r };
};
var _a = freb(fleb, 2), fl = _a.b, revfl = _a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b.b, revfd = _b.r;
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
    // reverse table algorithm from SO
    var x = ((i & 0xAAAA) >> 1) | ((i & 0x5555) << 1);
    x = ((x & 0xCCCC) >> 2) | ((x & 0x3333) << 2);
    x = ((x & 0xF0F0) >> 4) | ((x & 0x0F0F) << 4);
    rev[i] = (((x & 0xFF00) >> 8) | ((x & 0x00FF) << 8)) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = (function (cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for (; i < s; ++i) {
        if (cd[i])
            ++l[cd[i] - 1];
    }
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for (i = 1; i < mb; ++i) {
        le[i] = (le[i - 1] + l[i - 1]) << 1;
    }
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for (i = 0; i < s; ++i) {
            // ignore 0 lengths
            if (cd[i]) {
                // num encoding both symbol and bits read
                var sv = (i << 4) | cd[i];
                // free bits
                var r_1 = mb - cd[i];
                // start value
                var v = le[cd[i] - 1]++ << r_1;
                // m is end value
                for (var m = v | ((1 << r_1) - 1); v <= m; ++v) {
                    // every 16 bit value starting with the code yields the same result
                    co[rev[v] >> rvb] = sv;
                }
            }
        }
    }
    else {
        co = new u16(s);
        for (i = 0; i < s; ++i) {
            if (cd[i]) {
                co[i] = rev[le[cd[i] - 1]++] >> (15 - cd[i]);
            }
        }
    }
    return co;
});
// fixed length tree
var flt = new u8(288);
for (var i = 0; i < 144; ++i)
    flt[i] = 8;
for (var i = 144; i < 256; ++i)
    flt[i] = 9;
for (var i = 256; i < 280; ++i)
    flt[i] = 7;
for (var i = 280; i < 288; ++i)
    flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for (var i = 0; i < 32; ++i)
    fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function (a) {
    var m = a[0];
    for (var i = 1; i < a.length; ++i) {
        if (a[i] > m)
            m = a[i];
    }
    return m;
};
// read d, starting at bit p and mask with m
var bits = function (d, p, m) {
    var o = (p / 8) | 0;
    return ((d[o] | (d[o + 1] << 8)) >> (p & 7)) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function (d, p) {
    var o = (p / 8) | 0;
    return ((d[o] | (d[o + 1] << 8) | (d[o + 2] << 16)) >> (p & 7));
};
// get end of byte
var shft = function (p) { return ((p + 7) / 8) | 0; };
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function (v, s, e) {
    if (s == null || s < 0)
        s = 0;
    if (e == null || e > v.length)
        e = v.length;
    // can't use .constructor in case user-supplied
    return new u8(v.subarray(s, e));
};
/**
 * Codes for errors generated within this library
 */
var FlateErrorCode = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
    // determined by unknown compression method
];
;
var err = function (ind, msg, nt) {
    var e = new Error(msg || ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace)
        Error.captureStackTrace(e, err);
    if (!nt)
        throw e;
    return e;
};
// expands raw DEFLATE data
var inflt = function (dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l)
        return buf || new u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf)
        buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function (l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | (dat[s - 3] << 8), t = s + l;
                if (t > sl) {
                    if (noSt)
                        err(0);
                    break;
                }
                // ensure size
                if (resize)
                    cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            }
            else if (type == 1)
                lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for (var i = 0; i < hcLen; ++i) {
                    // use index map to get real code
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for (var i = 0; i < tl;) {
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) {
                        ldt[i++] = s;
                    }
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16)
                            n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17)
                            n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18)
                            n = 11 + bits(dat, pos, 127), pos += 7;
                        while (n--)
                            ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            }
            else
                err(1);
            if (pos > tbts) {
                if (noSt)
                    err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize)
            cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for (;; lpos = pos) {
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt)
                    err(0);
                break;
            }
            if (!c)
                err(2);
            if (sym < 256)
                buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            }
            else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d)
                    err(3);
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt)
                        err(0);
                    break;
                }
                if (resize)
                    cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0)
                        err(3);
                    for (; bt < dend; ++bt)
                        buf[bt] = dict[shift + bt];
                }
                for (; bt < end; ++bt)
                    buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm)
            final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var hTree = function (d, mb) {
    // Need extra info to make a tree
    var t = [];
    for (var i = 0; i < d.length; ++i) {
        if (d[i])
            t.push({ s: i, f: d[i] });
    }
    var s = t.length;
    var t2 = t.slice();
    if (!s)
        return { t: et, l: 0 };
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return { t: v, l: 1 };
    }
    t.sort(function (a, b) { return a.f - b.f; });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({ s: -1, f: 25001 });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = { s: -1, f: l.f + r.f, l: l, r: r };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while (i1 != s - 1) {
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = { s: -1, f: l.f + r.f, l: l, r: r };
    }
    var maxSym = t2[0].s;
    for (var i = 1; i < s; ++i) {
        if (t2[i].s > maxSym)
            maxSym = t2[i].s;
    }
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function (a, b) { return tr[b.s] - tr[a.s] || a.f - b.f; });
        for (; i < s; ++i) {
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << (mbt - tr[i2_1]));
                tr[i2_1] = mb;
            }
            else
                break;
        }
        dt >>= lft;
        while (dt > 0) {
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb)
                dt -= 1 << (mb - tr[i2_2]++ - 1);
            else
                ++i;
        }
        for (; i >= 0 && dt; --i) {
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return { t: new u8(tr), l: mbt };
};
// get the max length and assign length codes
var ln = function (n, l, d) {
    return n.s == -1
        ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1))
        : (l[n.s] = d);
};
// length codes generation
var lc = function (c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while (s && !c[--s])
        ;
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function (v) { cl[cli++] = v; };
    for (var i = 1; i <= s; ++i) {
        if (c[i] == cln && i != s)
            ++cls;
        else {
            if (!cln && cls > 2) {
                for (; cls > 138; cls -= 138)
                    w(32754);
                if (cls > 2) {
                    w(cls > 10 ? ((cls - 11) << 5) | 28690 : ((cls - 3) << 5) | 12305);
                    cls = 0;
                }
            }
            else if (cls > 3) {
                w(cln), --cls;
                for (; cls > 6; cls -= 6)
                    w(8304);
                if (cls > 2)
                    w(((cls - 3) << 5) | 8208), cls = 0;
            }
            while (cls--)
                w(cln);
            cls = 1;
            cln = c[i];
        }
    }
    return { c: cl.subarray(0, cli), n: s };
};
// calculate the length of output from tree, code lengths
var clen = function (cf, cl) {
    var l = 0;
    for (var i = 0; i < cl.length; ++i)
        l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function (out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for (var i = 0; i < s; ++i)
        out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function (dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new u16(19);
    for (var i = 0; i < lclt.length; ++i)
        ++lcfreq[lclt[i] & 31];
    for (var i = 0; i < lcdt.length; ++i)
        ++lcfreq[lcdt[i] & 31];
    var _e = hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc)
        ;
    var flen = (bl + 5) << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen)
        return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for (var i = 0; i < nlcc; ++i)
            wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [lclt, lcdt];
        for (var it = 0; it < 2; ++it) {
            var clct = lcts[it];
            for (var i = 0; i < clct.length; ++i) {
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15)
                    wbits(out, p, (clct[i] >> 5) & 127), p += clct[i] >> 12;
            }
        }
    }
    else {
        lm = flm, ll = flt, dm = fdm, dl = fdt;
    }
    for (var i = 0; i < li; ++i) {
        var sym = syms[i];
        if (sym > 255) {
            var len = (sym >> 18) & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7)
                wbits(out, p, (sym >> 23) & 31), p += fleb[len];
            var dst = sym & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3)
                wbits16(out, p, (sym >> 5) & 8191), p += fdeb[dst];
        }
        else {
            wbits16(out, p, lm[sym]), p += ll[sym];
        }
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new i32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function (dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos)
            w[0] = st.r >> 3;
        var opt = deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new u16(32768), head = st.h || new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function (i) { return (dat[i] ^ (dat[i + 1] << bs1_1) ^ (dat[i + 2] << bs2_1)) & msk_1; };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new i32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for (; i + 2 < s; ++i) {
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for (var j = 0; j < 286; ++j)
                        lf[j] = 0;
                    for (var j = 0; j < 30; ++j)
                        df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while (dif <= maxd && --ch_1 && imod != pimod) {
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl)
                                ;
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn)
                                    break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for (var j = 0; j < mmd; ++j) {
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md)
                                        md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | (revfl[l] << 18) | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                }
                else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for (i = Math.max(i, wi); i < s; ++i) {
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = (pos & 7) | w[(pos / 8) | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    }
    else {
        for (var i = st.w || 0; i < s + lst; i += 65535) {
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[(pos / 8) | 0] = lst;
                e = s;
            }
            pos = wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ (function () {
    var t = new Int32Array(256);
    for (var i = 0; i < 256; ++i) {
        var c = i, k = 9;
        while (--k)
            c = ((c & 1) && -306674912) ^ (c >>> 1);
        t[i] = c;
    }
    return t;
})();
// CRC32
var crc = function () {
    var c = -1;
    return {
        p: function (d) {
            // closures have awful performance
            var cr = c;
            for (var i = 0; i < d.length; ++i)
                cr = crct[(cr & 255) ^ d[i]] ^ (cr >>> 8);
            c = cr;
        },
        d: function () { return ~c; }
    };
};
// Adler32
var adler = function () {
    var a = 1, b = 0;
    return {
        p: function (d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for (var i = 0; i != l;) {
                var e = Math.min(i + 2655, l);
                for (; i < e; ++i)
                    m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function () {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | (b >> 8);
        }
    };
};
;
// deflate with opts
var dopt = function (dat, opt, pre, post, st) {
    if (!st) {
        st = { l: 1 };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? (st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20) : (12 + opt.mem), pre, post, st);
};
// Walmart object spread
var mrg = function (a, b) {
    var o = {};
    for (var k in a)
        o[k] = a[k];
    for (var k in b)
        o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function (fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for (var i = 0; i < dt.length; ++i) {
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                }
                else {
                    fnStr += st_1;
                    for (var t in v.prototype)
                        fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            }
            else
                fnStr += st_1;
        }
        else
            td[k] = v;
    }
    return fnStr;
};
var ch = [];
// clone bufs
var cbfs = function (v) {
    var tl = [];
    for (var k in v) {
        if (v[k].buffer) {
            tl.push((v[k] = new v[k].constructor(v[k])).buffer);
        }
    }
    return tl;
};
// use a worker to execute code
var wrkr = function (fns, init, id, cb) {
    if (!ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for (var i = 0; i < m; ++i)
            fnStr = wcln(fns[i], fnStr, td_1);
        ch[id] = { c: wcln(fns[m], fnStr, td_1), e: td_1 };
    }
    var td = mrg({}, ch[id].e);
    return wk(ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function () { return [u8, u16, i32, fleb, fdeb, clim, fl, fd, flrm, fdrm, rev, ec, hMap, max, bits, bits16, shft, slc, err, inflt, inflateSync, pbf, gopt]; };
var bDflt = function () { return [u8, u16, i32, fleb, fdeb, clim, revfl, revfd, flm, flt, fdm, fdt, rev, deo, et, hMap, wbits, wbits16, hTree, ln, lc, clen, wfblk, wblk, shft, slc, dflt, dopt, deflateSync, pbf]; };
// gzip extra
var gze = function () { return [gzh, gzhl, wbytes, crc, crct]; };
// gunzip extra
var guze = function () { return [gzs, gzl]; };
// zlib extra
var zle = function () { return [zlh, wbytes, adler]; };
// unzlib extra
var zule = function () { return [zls]; };
// post buf
var pbf = function (msg) { return postMessage(msg, [msg.buffer]); };
// get opts
var gopt = function (o) { return o && {
    out: o.size && new u8(o.size),
    dictionary: o.dictionary
}; };
// async helper
var cbify = function (dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function (err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([dat, opts], opts.consume ? [dat.buffer] : []);
    return function () { w.terminate(); };
};
// auto stream
var astrm = function (strm) {
    strm.ondata = function (dat, final) { return postMessage([dat, final], [dat.buffer]); };
    return function (ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([ev.data[0].length]);
        }
        else
            strm.flush();
    };
};
// async stream attach
var astrmify = function (fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = wrkr(fns, init, id, function (err, dat) {
        if (err)
            w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat))
            ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain)
                strm.ondrain(dat[0]);
        }
        else {
            if (dat[1])
                w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function (d, f) {
        if (!strm.ondata)
            err(5);
        if (t)
            strm.ondata(err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([d, t = f], [d.buffer]);
    };
    strm.terminate = function () { w.terminate(); };
    if (flush) {
        strm.flush = function () { w.postMessage([]); };
    }
};
// read 2 bytes
var b2 = function (d, b) { return d[b] | (d[b + 1] << 8); };
// read 4 bytes
var b4 = function (d, b) { return (d[b] | (d[b + 1] << 8) | (d[b + 2] << 16) | (d[b + 3] << 24)) >>> 0; };
var b8 = function (d, b) { return b4(d, b) + (b4(d, b + 4) * 4294967296); };
// write bytes
var wbytes = function (d, b, v) {
    for (; v; ++b)
        d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function (c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0)
        wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for (var i = 0; i <= fn.length; ++i)
            c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function (d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8)
        err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4)
        st += (d[10] | d[11] << 8) + 2;
    for (var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++])
        ;
    return st + (flg & 2);
};
// gzip length
var gzl = function (d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var gzhl = function (o) { return 10 + (o.filename ? o.filename.length + 1 : 0); };
// zlib header
var zlh = function (c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = (fl << 6) | (o.dictionary && 32);
    c[1] |= 31 - ((c[0] << 8) | c[1]) % 31;
    if (o.dictionary) {
        var h = adler();
        h.p(o.dictionary);
        wbytes(c, 2, h.d());
    }
};
// zlib start
var zls = function (d, dict) {
    if ((d[0] & 15) != 8 || (d[0] >> 4) > 7 || ((d[0] << 8 | d[1]) % 31))
        err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict)
        err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function StrmOpt(opts, cb) {
    if (typeof opts == 'function')
        cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */
var Deflate = /*#__PURE__*/ (function () {
    function Deflate(opts, cb) {
        if (typeof opts == 'function')
            cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = { l: 0, i: 32768, w: 32768, z: 32768 };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function (c, f) {
        this.ondata(dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Deflate.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        if (this.s.l)
            err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        }
        else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */
    Deflate.prototype.flush = function () {
        if (!this.ondata)
            err(5);
        if (this.s.l)
            err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}());

/**
 * Asynchronous streaming DEFLATE compression
 */
var AsyncDeflate = /*#__PURE__*/ (function () {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function () { return [astrm, Deflate]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}());

function deflate(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bDflt,
    ], function (ev) { return pbf(deflateSync(ev.data[0], ev.data[1])); }, 0, cb);
}
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */
function deflateSync(data, opts) {
    return dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */
var Inflate = /*#__PURE__*/ (function () {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function')
            cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = { i: 0, b: dict ? dict.length : 0 };
        this.o = new u8(32768);
        this.p = new u8(0);
        if (dict)
            this.o.set(dict);
    }
    Inflate.prototype.e = function (c) {
        if (!this.ondata)
            err(5);
        if (this.d)
            err(4);
        if (!this.p.length)
            this.p = c;
        else if (c.length) {
            var n = new u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function (final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = inflt(this.p, this.s, this.o);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, (this.s.p / 8) | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */
    Inflate.prototype.push = function (chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}());

/**
 * Asynchronous streaming DEFLATE decompression
 */
var AsyncInflate = /*#__PURE__*/ (function () {
    function AsyncInflate(opts, cb) {
        astrmify([
            bInflt,
            function () { return [astrm, Inflate]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Inflate(ev.data);
            onmessage = astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}());

function inflate(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bInflt
    ], function (ev) { return pbf(inflateSync(ev.data[0], gopt(ev.data[1]))); }, 1, cb);
}
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */
function inflateSync(data, opts) {
    return inflt(data, { i: 2 }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */
var Gzip = /*#__PURE__*/ (function () {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gzip.prototype.push = function (chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function (c, f) {
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, this.s);
        if (this.v)
            gzh(raw, this.o), this.v = 0;
        if (f)
            wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */
    Gzip.prototype.flush = function () {
        Deflate.prototype.flush.call(this);
    };
    return Gzip;
}());

/**
 * Asynchronous streaming GZIP compression
 */
var AsyncGzip = /*#__PURE__*/ (function () {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function () { return [astrm, Deflate, Gzip]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}());

function gzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bDflt,
        gze,
        function () { return [gzipSync]; }
    ], function (ev) { return pbf(gzipSync(ev.data[0], ev.data[1])); }, 2, cb);
}
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */
function gzipSync(data, opts) {
    if (!opts)
        opts = {};
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */
var Gunzip = /*#__PURE__*/ (function () {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        Inflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gunzip.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? gzs(p) : 4;
            if (s > p.length) {
                if (!final)
                    return;
            }
            else if (this.v > 1 && this.onmember) {
                this.onmember(this.r - p.length);
            }
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = shft(this.s.p) + 9;
            this.s = { i: 0 };
            this.o = new u8(0);
            this.push(new u8(0), final);
        }
    };
    return Gunzip;
}());

/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */
var AsyncGunzip = /*#__PURE__*/ (function () {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        astrmify([
            bInflt,
            guze,
            function () { return [astrm, Inflate, Gunzip]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Gunzip(ev.data);
            strm.onmember = function (offset) { return postMessage(offset); };
            onmessage = astrm(strm);
        }, 9, 0, function (offset) { return _this.onmember && _this.onmember(offset); });
    }
    return AsyncGunzip;
}());

function gunzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bInflt,
        guze,
        function () { return [gunzipSync]; }
    ], function (ev) { return pbf(gunzipSync(ev.data[0], ev.data[1])); }, 3, cb);
}
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */
function gunzipSync(data, opts) {
    var st = gzs(data);
    if (st + 8 > data.length)
        err(6, 'invalid gzip data');
    return inflt(data.subarray(st, -8), { i: 2 }, opts && opts.out || new u8(gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */
var Zlib = /*#__PURE__*/ (function () {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Zlib.prototype.push = function (chunk, final) {
        this.c.p(chunk);
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function (c, f) {
        var raw = dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v)
            zlh(raw, this.o), this.v = 0;
        if (f)
            wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */
    Zlib.prototype.flush = function () {
        Deflate.prototype.flush.call(this);
    };
    return Zlib;
}());

/**
 * Asynchronous streaming Zlib compression
 */
var AsyncZlib = /*#__PURE__*/ (function () {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function () { return [astrm, Deflate, Zlib]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}());

function zlib(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bDflt,
        zle,
        function () { return [zlibSync]; }
    ], function (ev) { return pbf(zlibSync(ev.data[0], ev.data[1])); }, 4, cb);
}
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */
function zlibSync(data, opts) {
    if (!opts)
        opts = {};
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */
var Unzlib = /*#__PURE__*/ (function () {
    function Unzlib(opts, cb) {
        Inflate.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Unzlib.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final)
                return;
            this.p = this.p.subarray(zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4)
                err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}());

/**
 * Asynchronous streaming Zlib decompression
 */
var AsyncUnzlib = /*#__PURE__*/ (function () {
    function AsyncUnzlib(opts, cb) {
        astrmify([
            bInflt,
            zule,
            function () { return [astrm, Inflate, Unzlib]; }
        ], this, StrmOpt.call(this, opts, cb), function (ev) {
            var strm = new Unzlib(ev.data);
            onmessage = astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}());

function unzlib(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return cbify(data, opts, [
        bInflt,
        zule,
        function () { return [unzlibSync]; }
    ], function (ev) { return pbf(unzlibSync(ev.data[0], gopt(ev.data[1]))); }, 5, cb);
}
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */
function unzlibSync(data, opts) {
    return inflt(data.subarray(zls(data, opts && opts.dictionary), -4), { i: 2 }, opts && opts.out, opts && opts.dictionary);
}
// Default algorithm for compression (used because having a known output size allows faster decompression)


/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var Decompress = /*#__PURE__*/ (function () {
    function Decompress(opts, cb) {
        this.o = StrmOpt.call(this, opts, cb) || {};
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function () {
        var _this = this;
        this.s.ondata = function (dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Decompress.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            }
            else
                this.p = chunk;
            if (this.p.length > 2) {
                this.s = (this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8)
                    ? new this.G(this.o)
                    : ((this.p[0] & 15) != 8 || (this.p[0] >> 4) > 7 || ((this.p[0] << 8 | this.p[1]) % 31))
                        ? new this.I(this.o)
                        : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        }
        else
            this.s.push(chunk, final);
    };
    return Decompress;
}());

/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var AsyncDecompress = /*#__PURE__*/ (function () {
    function AsyncDecompress(opts, cb) {
        Decompress.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
    }
    AsyncDecompress.prototype.i = function () {
        var _this = this;
        this.s.ondata = function (err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function (size) {
            _this.queuedSize -= size;
            if (_this.ondrain)
                _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    AsyncDecompress.prototype.push = function (chunk, final) {
        this.queuedSize += chunk.length;
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}());

function decompress(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    return (data[0] == 31 && data[1] == 139 && data[2] == 8)
        ? gunzip(data, opts, cb)
        : ((data[0] & 15) != 8 || (data[0] >> 4) > 7 || ((data[0] << 8 | data[1]) % 31))
            ? inflate(data, opts, cb)
            : unzlib(data, opts, cb);
}
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param opts The decompression options
 * @returns The decompressed version of the data
 */
function decompressSync(data, opts) {
    return (data[0] == 31 && data[1] == 139 && data[2] == 8)
        ? gunzipSync(data, opts)
        : ((data[0] & 15) != 8 || (data[0] >> 4) > 7 || ((data[0] << 8 | data[1]) % 31))
            ? inflateSync(data, opts)
            : unzlibSync(data, opts);
}
// flatten a directory structure
var fltn = function (d, p, t, o) {
    for (var k in d) {
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val))
            op = mrg(o, val[1]), val = val[0];
        if (val instanceof u8)
            t[n] = [val, op];
        else {
            t[n += '/'] = [new u8(0), op];
            fltn(val, n, t, o);
        }
    }
};
// text encoder
var te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var tds = 0;
try {
    td.decode(et, { stream: true });
    tds = 1;
}
catch (e) { }
// decode UTF8
var dutf8 = function (d) {
    for (var r = '', i = 0;;) {
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length)
            return { s: r, r: slc(d, i - 1) };
        if (!eb)
            r += String.fromCharCode(c);
        else if (eb == 3) {
            c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | (d[i++] & 63)) - 65536,
                r += String.fromCharCode(55296 | (c >> 10), 56320 | (c & 1023));
        }
        else if (eb & 1)
            r += String.fromCharCode((c & 31) << 6 | (d[i++] & 63));
        else
            r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | (d[i++] & 63));
    }
};
/**
 * Streaming UTF-8 decoding
 */
var DecodeUTF8 = /*#__PURE__*/ (function () {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */
    function DecodeUTF8(cb) {
        this.ondata = cb;
        if (tds)
            this.t = new TextDecoder();
        else
            this.p = et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    DecodeUTF8.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, { stream: true }), final);
            if (final) {
                if (this.t.decode().length)
                    err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p)
            err(4);
        var dat = new u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length)
                err(8);
            this.p = null;
        }
        else
            this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}());

/**
 * Streaming UTF-8 encoding
 */
var EncodeUTF8 = /*#__PURE__*/ (function () {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */
    function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */
    EncodeUTF8.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        if (this.d)
            err(4);
        this.ondata(strToU8(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}());

/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */
function strToU8(str, latin1) {
    if (latin1) {
        var ar_1 = new u8(str.length);
        for (var i = 0; i < str.length; ++i)
            ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if (te)
        return te.encode(str);
    var l = str.length;
    var ar = new u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function (v) { ar[ai++] = v; };
    for (var i = 0; i < l; ++i) {
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + ((l - i) << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1)
            w(c);
        else if (c < 2048)
            w(192 | (c >> 6)), w(128 | (c & 63));
        else if (c > 55295 && c < 57344)
            c = 65536 + (c & 1023 << 10) | (str.charCodeAt(++i) & 1023),
                w(240 | (c >> 18)), w(128 | ((c >> 12) & 63)), w(128 | ((c >> 6) & 63)), w(128 | (c & 63));
        else
            w(224 | (c >> 12)), w(128 | ((c >> 6) & 63)), w(128 | (c & 63));
    }
    return slc(ar, 0, ai);
}
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */
function strFromU8(dat, latin1) {
    if (latin1) {
        var r = '';
        for (var i = 0; i < dat.length; i += 16384)
            r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    }
    else if (td) {
        return td.decode(dat);
    }
    else {
        var _a = dutf8(dat), s = _a.s, r = _a.r;
        if (r.length)
            err(8);
        return s;
    }
}
;
// deflate bit flag
var dbf = function (l) { return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0; };
// skip local zip header
var slzh = function (d, b) { return b + 30 + b2(d, b + 26) + b2(d, b + 28); };
// read zip header
var zh = function (d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = b4(d, b + 20);
    var _a = z && bs == 4294967295 ? z64e(d, es) : [bs, b4(d, b + 24), b4(d, b + 42)], sc = _a[0], su = _a[1], off = _a[2];
    return [b2(d, b + 10), sc, su, fn, es + b2(d, b + 30) + b2(d, b + 32), off];
};
// read zip64 extra field
var z64e = function (d, b) {
    for (; b2(d, b) != 1; b += 4 + b2(d, b + 2))
        ;
    return [b8(d, b + 12), b8(d, b + 4), b8(d, b + 20)];
};
// extra field length
var exfl = function (ex) {
    var le = 0;
    if (ex) {
        for (var k in ex) {
            var l = ex[k].length;
            if (l > 65535)
                err(9);
            le += l + 4;
        }
    }
    return le;
};
// write zip header
var wzh = function (d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = exfl(ex);
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null)
        d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = (f.flag << 1) | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119)
        err(10);
    wbytes(d, b, (y << 25) | ((dt.getMonth() + 1) << 21) | (dt.getDate() << 16) | (dt.getHours() << 11) | (dt.getMinutes() << 5) | (dt.getSeconds() >> 1)), b += 4;
    if (c != -1) {
        wbytes(d, b, f.crc);
        wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        wbytes(d, b + 8, f.size);
    }
    wbytes(d, b + 12, fl);
    wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        wbytes(d, b, col);
        wbytes(d, b + 6, f.attrs);
        wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) {
        for (var k in ex) {
            var exf = ex[k], l = exf.length;
            wbytes(d, b, +k);
            wbytes(d, b + 2, l);
            d.set(exf, b + 4), b += 4 + l;
        }
    }
    if (col)
        d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var wzf = function (o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */
var ZipPassThrough = /*#__PURE__*/ (function () {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */
    function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */
    ZipPassThrough.prototype.process = function (chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    ZipPassThrough.prototype.push = function (chunk, final) {
        if (!this.ondata)
            err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final)
            this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}());

// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */
var ZipDeflate = /*#__PURE__*/ (function () {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */
    function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts)
            opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new Deflate(opts, function (dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
    }
    ZipDeflate.prototype.process = function (chunk, final) {
        try {
            this.d.push(chunk, final);
        }
        catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    ZipDeflate.prototype.push = function (chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}());

/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */
var AsyncZipDeflate = /*#__PURE__*/ (function () {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */
    function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts)
            opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new AsyncDeflate(opts, function (err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function (chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    AsyncZipDeflate.prototype.push = function (chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}());

// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */
var Zip = /*#__PURE__*/ (function () {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */
    function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */
    Zip.prototype.add = function (file) {
        var _this = this;
        if (!this.ondata)
            err(5);
        // finishing or finished
        if (this.d & 2)
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = strToU8(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && strToU8(com);
            var u = fl_1 != file.filename.length || (o && (com.length != o.length));
            var hl_1 = fl_1 + exfl(file.extra) + 30;
            if (fl_1 > 65535)
                this.ondata(err(11, 0, 1), null, false);
            var header = new u8(hl_1);
            wzh(header, 0, file, f, u, -1);
            var chks_1 = [header];
            var pAll_1 = function () {
                for (var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++) {
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function () {
                    if (file.terminate)
                        file.terminate();
                },
                r: function () {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt)
                            nxt.r();
                        else
                            _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function (err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                }
                else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new u8(16);
                        wbytes(dd, 0, 0x8074B50);
                        wbytes(dd, 4, file.crc);
                        wbytes(dd, 8, cl_1);
                        wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1)
                            uf_1.r();
                        tr_1 = 1;
                    }
                    else if (tr_1)
                        pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */
    Zip.prototype.end = function () {
        var _this = this;
        if (this.d & 2) {
            this.ondata(err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d)
            this.e();
        else
            this.u.push({
                r: function () {
                    if (!(_this.d & 1))
                        return;
                    _this.u.splice(-1, 1);
                    _this.e();
                },
                t: function () { }
            });
        this.d = 3;
    };
    Zip.prototype.e = function () {
        var bt = 0, l = 0, tl = 0;
        for (var _i = 0, _a = this.u; _i < _a.length; _i++) {
            var f = _a[_i];
            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new u8(tl + 22);
        for (var _b = 0, _c = this.u; _b < _c.length; _b++) {
            var f = _c[_b];
            wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */
    Zip.prototype.terminate = function () {
        for (var _i = 0, _a = this.u; _i < _a.length; _i++) {
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}());

function zip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    var r = {};
    fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function () {
        for (var i = 0; i < term.length; ++i)
            term[i]();
    };
    var cbd = function (a, b) {
        mt(function () { cb(a, b); });
    };
    mt(function () { cbd = cb; });
    var cbf = function () {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for (var i = 0; i < slft; ++i) {
            var f = files[i];
            try {
                var l = f.c.length;
                wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            }
            catch (e) {
                return cbd(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft)
        cbf();
    var _loop_1 = function (i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), size = file.length;
        c.p(file);
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function (e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            }
            else {
                var l = d.length;
                files[i] = mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || (m && (com.length != ms)),
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft)
                    cbf();
            }
        };
        if (s > 65535)
            cbl(err(11, 0, 1), null);
        if (!compression)
            cbl(null, file);
        else if (size < 160000) {
            try {
                cbl(null, deflateSync(file, p));
            }
            catch (e) {
                cbl(e, null);
            }
        }
        else
            term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for (var i = 0; i < slft; ++i) {
        _loop_1(i);
    }
    return tAll;
}
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */
function zipSync(data, opts) {
    if (!opts)
        opts = {};
    var r = {};
    var files = [];
    fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for (var fn in r) {
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = strToU8(fn), s = f.length;
        var com = p.comment, m = com && strToU8(com), ms = m && m.length;
        var exl = exfl(p.extra);
        if (s > 65535)
            err(11);
        var d = compression ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push(mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || (m && (com.length != ms)),
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for (var i = 0; i < files.length; ++i) {
        var f = files[i];
        wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + exfl(f.extra);
        out.set(f.c, f.o + badd);
        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */
var UnzipPassThrough = /*#__PURE__*/ (function () {
    function UnzipPassThrough() {
    }
    UnzipPassThrough.prototype.push = function (data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}());

/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */
var UnzipInflate = /*#__PURE__*/ (function () {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */
    function UnzipInflate() {
        var _this = this;
        this.i = new Inflate(function (dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function (data, final) {
        try {
            this.i.push(data, final);
        }
        catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}());

/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */
var AsyncUnzipInflate = /*#__PURE__*/ (function () {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */
    function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) {
            this.i = new Inflate(function (dat, final) {
                _this.ondata(null, dat, final);
            });
        }
        else {
            this.i = new AsyncInflate(function (err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function (data, final) {
        if (this.i.terminate)
            data = slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}());

/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */
var Unzip = /*#__PURE__*/ (function () {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */
    function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: UnzipPassThrough
        };
        this.p = et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Unzip.prototype.push = function (chunk, final) {
        var _this = this;
        if (!this.onfile)
            err(5);
        if (!this.p)
            err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d)
                this.d.push(toAdd, !this.c);
            else
                this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length)
                return this.push(chunk, final);
        }
        else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length)
                buf = chunk;
            else if (!chunk.length)
                buf = this.p;
            else {
                buf = new u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function () {
                var _a;
                var sig = b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = b2(buf, i + 6), cmp_1 = b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = b2(buf, i + 26), es = b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = b4(buf, i + 18), su_1 = b4(buf, i + 22);
                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) {
                            _a = dd ? [-2] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        }
                        else if (dd)
                            sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function () {
                                if (!file_1.ondata)
                                    err(5);
                                if (!sc_1)
                                    file_1.ondata(null, et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr)
                                        file_1.ondata(err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function (err, dat, final) { file_1.ondata(err, dat, final); };
                                    for (var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++) {
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c)
                                        _this.d = d_1;
                                    else
                                        d_1.push(et, true);
                                }
                            },
                            terminate: function () {
                                if (d_1 && d_1.terminate)
                                    d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0)
                            file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                }
                else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    }
                    else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for (; i < l - 4; ++i) {
                var state_1 = _loop_2();
                if (state_1 === "break")
                    break;
            }
            this.p = et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add)
                    add.push(dat, !!f);
                else
                    this.k[+(f == 2)].push(dat);
            }
            if (f & 2)
                return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c)
                err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */
    Unzip.prototype.register = function (decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}());

var mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function (fn) { fn(); };
function unzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        err(7);
    var term = [];
    var tAll = function () {
        for (var i = 0; i < term.length; ++i)
            term[i]();
    };
    var files = {};
    var cbd = function (a, b) {
        mt(function () { cb(a, b); });
    };
    mt(function () { cbd = cb; });
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558) {
            cbd(err(13, 0, 1), null);
            return tAll;
        }
    }
    ;
    var lft = b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = b4(data, e - 12);
            z = b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = b4(data, ze + 32);
                o = b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function (i) {
            var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
            o = no;
            var cbl = function (e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                }
                else {
                    if (d)
                        files[fn] = d;
                    if (!--lft)
                        cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1)
                    cbl(null, slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) {
                        try {
                            cbl(null, inflateSync(infl, { out: new u8(su) }));
                        }
                        catch (e) {
                            cbl(e, null);
                        }
                    }
                    else
                        term.push(inflate(infl, { size: su }, cbl));
                }
                else
                    cbl(err(14, 'unknown compression type ' + c_1, 1), null);
            }
            else
                cbl(null, null);
        };
        for (var i = 0; i < c; ++i) {
            _loop_3(i);
        }
    }
    else
        cbd(null, {});
    return tAll;
}
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @param opts The ZIP extraction options
 * @returns The decompressed files
 */
function unzipSync(data, opts) {
    var files = {};
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558)
            err(13);
    }
    ;
    var c = b2(data, e + 8);
    if (!c)
        return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = b4(data, e - 12);
        z = b4(data, ze) == 0x6064B50;
        if (z) {
            c = b4(data, ze + 32);
            o = b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for (var i = 0; i < c; ++i) {
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2)
                files[fn] = slc(data, b, b + sc);
            else if (c_2 == 8)
                files[fn] = inflateSync(data.subarray(b, b + sc), { out: new u8(su) });
            else
                err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}


/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(2619);
var v4 = __webpack_require__(2620);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1076);
var bytesToUuid = __webpack_require__(1077);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(1076);
var bytesToUuid = __webpack_require__(1077);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawReportStatusPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reportStatusPage = __webpack_require__(2622);

var _reportStatusPage2 = _interopRequireDefault(_reportStatusPage);

var _list = __webpack_require__(25);

var _tabs = __webpack_require__(188);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _button = __webpack_require__(8);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reportStatus = __webpack_require__(994);

var _reportStatus2 = _interopRequireDefault(_reportStatus);

var _smallAvatar = __webpack_require__(2623);

var _smallAvatar2 = _interopRequireDefault(_smallAvatar);

var _fixedDataTable = __webpack_require__(2625);

__webpack_require__(2657);

var _userMonthlySummaryPage = __webpack_require__(1066);

var _userMonthlySummaryPage2 = _interopRequireDefault(_userMonthlySummaryPage);

var _googleSigninProvider = __webpack_require__(200);

var _card = __webpack_require__(28);

var _menu = __webpack_require__(63);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _radio = __webpack_require__(503);

var _eventEmitter = __webpack_require__(1051);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * src/web/components/report-status-page.jsx
 * 日報提出状況ページ（right-side-page に表示）
 */

var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);

function ActivityIcon(props) {
  var icon = props.icon,
      color = props.color,
      ids = props.ids,
      _onClick = props.onClick;


  var diary_ids = ids && ids.split(',').map(function (id) {
    return parseInt(id);
  }) || [];
  var count = diary_ids.length || 0;

  if (count == 0) return _react2.default.createElement('div', { className: _reportStatus2.default.activityEmptyBadge });else return _react2.default.createElement(
    'div',
    { onClick: function onClick() {
        return _onClick(diary_ids);
      }, className: _reportStatus2.default.activityIcon },
    _react2.default.createElement(_font_icon2.default, { value: icon, className: _reportStatus2.default.activityFontIcon, style: { color: color } }),
    count > 1 && _react2.default.createElement(
      'span',
      { className: _reportStatus2.default.activityBadge },
      count
    )
  );
}

function WeekdayHeader(props) {
  var day = props.day,
      width = props.width,
      showDetail = props.showDetail,
      fetchActivityReportPrev = props.fetchActivityReportPrev,
      fetchActivityReportNext = props.fetchActivityReportNext;


  var weekdaysShort = _moment2.default.weekdaysShort();
  var weekday = day.day();
  var color = 'black';
  var arrow_left, arrow_right;
  var onClick;
  if (weekday == 0) {
    arrow_left = true;
    color = 'red';
    onClick = fetchActivityReportPrev;
  }
  if (weekday == 6) {
    arrow_right = true;
    color = 'blue';
    onClick = fetchActivityReportNext;
  }

  return _react2.default.createElement(
    _fixedDataTable.Cell,
    { width: width },
    _react2.default.createElement(
      'div',
      { onClick: onClick, className: color == 'black' && _reportStatus2.default.headerBlack || color == 'red' && _reportStatus2.default.headerRed || _reportStatus2.default.headerBlue },
      arrow_left && _react2.default.createElement(_font_icon2.default, { value: 'keyboard_arrow_left', className: _reportStatus2.default.headerFontIcon }),
      day.date(),
      ' ',
      _react2.default.createElement(
        'span',
        { className: _reportStatus2.default.headerBody },
        weekdaysShort[weekday]
      ),
      arrow_right && _react2.default.createElement(_font_icon2.default, { value: 'keyboard_arrow_right', className: _reportStatus2.default.headerFontIcon })
    )
  );
}

function ReportStatusCell(props) {
  var activityReports = props.activityReports,
      fetchActivityReport = props.fetchActivityReport,
      mode = props.mode,
      rowIndex = props.rowIndex,
      columnIndex = props.columnIndex,
      width = props.width,
      height = props.height,
      showDetail = props.showDetail,
      onClick = props.onClick;


  var activity = activityReports[rowIndex].activity[columnIndex];
  var diary = activity.diary,
      memo = activity.memo,
      kpi = activity.kpi,
      like = activity.like,
      comment = activity.comment;


  var schedule = activityReports[rowIndex].submission_schedules.length > 0 && activityReports[rowIndex].submission_schedules[columnIndex];
  var diaryData = diary && diary.length > 0;
  var kpiData = kpi && kpi.length > 0;

  var report_data = diaryData || kpiData;

  //schedule.submissionがfalseの場合、width,heightから左右のmargin:3 * 2を引いた分を渡すようにする
  var cell_width = !report_data && schedule && schedule.submission === false ? width - 6 : width;
  var cell_height = !report_data && schedule && schedule.submission === false ? width - 6 : height;

  return _react2.default.createElement(
    _fixedDataTable.Cell,
    { width: cell_width, height: cell_height, style: { backgroundColor: !report_data && schedule && schedule.submission === false && '#D3DEF1', margin: '3px' } },
    showDetail && _react2.default.createElement(
      'div',
      { className: _reportStatus2.default.cellBody },
      _react2.default.createElement(ActivityIcon, { icon: 'event_note', color: 'green', ids: diary, onClick: onClick }),
      _react2.default.createElement(ActivityIcon, { icon: 'insert_chart', color: 'green', ids: kpi, onClick: onClick }),
      _react2.default.createElement(ActivityIcon, { icon: 'assignment', color: 'green', ids: memo, onClick: onClick })
    ),
    showDetail && _react2.default.createElement(
      'div',
      { className: _reportStatus2.default.cellBody },
      _react2.default.createElement(ActivityIcon, { icon: 'favorite', color: 'red', ids: like, onClick: onClick }),
      _react2.default.createElement(ActivityIcon, { icon: 'comment', color: 'blue', ids: comment, onClick: onClick })
    ),
    !showDetail && diaryData && kpiData && _react2.default.createElement(
      'div',
      { className: _reportStatus2.default.cellBody },
      _react2.default.createElement(ActivityIcon, { icon: 'check', color: 'green', ids: diary.concat(',', kpi), onClick: onClick })
    ) || !showDetail && diaryData && !kpiData && _react2.default.createElement(
      'div',
      { className: _reportStatus2.default.cellBody },
      _react2.default.createElement(ActivityIcon, { icon: 'check', color: 'green', ids: diary, onClick: onClick })
    ) || !showDetail && !diaryData && kpiData && _react2.default.createElement(
      'div',
      { className: _reportStatus2.default.cellBody },
      _react2.default.createElement(ActivityIcon, { icon: 'check', color: 'green', ids: kpi, onClick: onClick })
    ) || null
  );
}

var TooltipButton = (0, _tooltip2.default)(_button.Button);

var ReportStatusPage = function (_React$Component) {
  _inherits(ReportStatusPage, _React$Component);

  function ReportStatusPage(props) {
    _classCallCheck(this, ReportStatusPage);

    //下記の処理を行わないとwillUnmountで記述しているremoveEventListenerがうまくいかない
    var _this = _possibleConstructorReturn(this, (ReportStatusPage.__proto__ || Object.getPrototypeOf(ReportStatusPage)).call(this, props));

    _this.state = {
      showMenu: false,
      showDownload: false,
      sendingMethodValue: 'local',
      checkFolder: true
    };

    _this.unLinkGoogleDrive = function () {
      _this.props.cancelGoogleDrive();
      _this.props.ui.gapiReady && _googleSigninProvider.GoogleLogin.signOut();
      _this.props.updateUI({ gapiReady: false, folder_id: 'undefined' });
    };

    _this.onGoogleSignSuccess = function () {
      _this.props.fetchUserInfo();
      _this.props.fetchFolders();
      _this.props.updateUI({ gapiReady: true });
    };

    _this.onSelectFolder = function (folder_id) {
      _this.props.updateUI({ folder_id: folder_id });
      _this.setState({ checkFolder: true });
    };

    _this.onDownloadFile = function () {
      if (_this.state.sendingMethodValue == 'local') {
        window.open(_this.props.exportUrl(_this.props));
      } else {
        // check GoogleDrive folder validation
        if (_this.props.ui.folder_id == 'undefined') {
          _this.setState({ checkFolder: false });
        } else {
          _this.setState({ checkFolder: true });
          _this.props.downloadFile(_this.props);
        }
      }
    };

    _this.sendingMethodChange = function (value) {
      _this.setState({ sendingMethodValue: value });
    };

    _this.changeWindowDisplay = function () {
      _this.props.updateUI({ innerWidth: _reactDom2.default.findDOMNode(_this).clientWidth });
      setTimeout(function () {
        return _this.props.updateUI({ innerHeight: _reactDom2.default.findDOMNode(_this).clientHeight });
      }, 0);
    };

    _this.onClick = function (user) {
      _this.props.updateUI({
        active: true,
        user: user
      });
    };

    _this.onClose = function () {
      _this.props.updateUI({
        active: false
      });
    };

    _this.exportUrl = function () {
      return window.open(_this.props.exportUrl(_this.props));
    };

    _this.reloadActivity = function () {
      return _this.props.reloadActivity(_this.props);
    };

    _this.changeWindowDisplay = _this.changeWindowDisplay.bind(_this);
    _this.debounce = _lodash2.default.debounce(_this.changeWindowDisplay, 500);
    _this.handleUpdateShowDownloadState = _this.handleUpdateShowDownloadState.bind(_this);
    return _this;
  }

  _createClass(ReportStatusPage, [{
    key: 'handleUpdateShowDownloadState',
    value: function handleUpdateShowDownloadState(newState) {
      // Update the state when the event is emitted
      this.setState(newState);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _eventEmitter.eventEmitter.on("updateShowDownloadState", this.handleUpdateShowDownloadState);
      this.props.updateUI({ innerWidth: _reactDom2.default.findDOMNode(this).clientWidth });
      setTimeout(function () {
        return _this2.props.updateUI({ innerHeight: _reactDom2.default.findDOMNode(_this2).clientHeight });
      }, 0);
      window.addEventListener('resize', this.debounce);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _eventEmitter.eventEmitter.removeListener("updateShowDownloadState", this.handleUpdateShowDownloadState);
      window.removeEventListener('resize', this.debounce);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isFoldersFetchFailed && this.props.isFoldersFetchFailed) {
        _googleSigninProvider.GoogleLogin.signOut();
        this.props.updateUI({ gapiReady: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          activityReports = _props.activityReports,
          group = _props.group,
          fetchActivityReport = _props.fetchActivityReport,
          openPickupDiaries = _props.openPickupDiaries,
          openUserTimeline = _props.openUserTimeline,
          exportUrl = _props.exportUrl,
          updateUI = _props.updateUI,
          currentUser = _props.currentUser,
          reloadActivity = _props.reloadActivity,
          folders = _props.folders,
          userinfo = _props.userinfo,
          fetchFolders = _props.fetchFolders,
          isFoldersFetching = _props.isFoldersFetching,
          isFoldersFetchFailed = _props.isFoldersFetchFailed,
          fetchUserInfo = _props.fetchUserInfo,
          cancelGoogleDrive = _props.cancelGoogleDrive,
          isUserInfoFetching = _props.isUserInfoFetching,
          isUserInfoFetchFailed = _props.isUserInfoFetchFailed,
          isUploadFetching = _props.isUploadFetching,
          isUploadFetchFailed = _props.isUploadFetchFailed,
          downlaodFile = _props.downlaodFile;


      var weekDays = activityReports && activityReports.length > 0 && _lodash2.default.map(activityReports[0].activity, function (activity) {
        return (0, _moment2.default)(activity.reported_at);
      });
      var innerWidth = Math.round(ui.innerWidth / 10) * 10; //一の位を0にするための処理
      var innerHeight = Math.round(ui.innerHeight / 10) * 10 - 115; //最後の115はappBarとCheckBoxと水平スクロールバーの高さを合計したもの
      var activityReportsHeight = activityReports && activityReports.length > 0 && (this.state.showDetail ? 80 : 38) * activityReports.length + 32;
      var nameWidth = 150;
      var innerMinWidth = nameWidth + 350; //一つ辺りのcolumnWidthが40pxになるように設定
      var columnWidth = Math.round((innerWidth - nameWidth) / 7);
      var startDay = weekDays && weekDays[0];

      var dropDownSource = [{ value: 'undefined', label: t('label:フォルダを選択して下さい') }];

      if (folders && folders.length > 0) {
        var folderOptions = folders.map(function (folder) {
          return {
            value: folder.id,
            label: folder.name
          };
        });
        dropDownSource = dropDownSource.concat(folderOptions);
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _rightSidePage2.default,
          { title: t('label:日報提出状況'), icon: 'check_box',
            rightAction: group.is_member && _react2.default.createElement(_button.IconButton, {
              icon: 'cloud_download',
              key: 'icon',
              disabled: this.state.showDownload,
              onClick: function onClick() {
                return _this3.setState({ showDownload: true });
              }
            })
          },
          this.state.showDownload && _react2.default.createElement(
            _card.Card,
            { style: { marginBottom: 20, background: '#f7f7f7' } },
            _react2.default.createElement(
              _card.CardText,
              { style: { textAlign: 'right', padding: '0px 10px' } },
              _react2.default.createElement(_button.IconButton, { icon: 'close', onClick: function onClick() {
                  return _this3.setState({ showDownload: false });
                } })
            ),
            (isFoldersFetching || isUploadFetching || isUserInfoFetching) && _react2.default.createElement(_loading2.default, null),
            _react2.default.createElement(
              _card.CardText,
              { className: _reportStatus2.default.sendingMethod },
              _react2.default.createElement(
                'strong',
                null,
                t('label:送信方法')
              ),
              _react2.default.createElement(
                _radio.RadioGroup,
                {
                  className: _reportStatus2.default.radioGroup,
                  value: this.state.sendingMethodValue,
                  onChange: this.sendingMethodChange
                },
                _react2.default.createElement(_radio.RadioButton, { label: t('label:ローカルに保存'), value: 'local' }),
                _react2.default.createElement(_radio.RadioButton, { label: 'Google\u30C9\u30E9\u30A4\u30D6', value: 'drive' })
              )
            ),
            this.state.sendingMethodValue == 'drive' && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _card.CardText,
                { className: _reportStatus2.default.googleSignInBtn },
                !ui.gapiReady && _react2.default.createElement(_googleSigninProvider.GoogleLogin, { label: t('label:Googleドライブに接続する'), onSuccess: this.onGoogleSignSuccess, type: 'google_drive' }),
                !isUserInfoFetchFailed && ui.gapiReady && userinfo && _react2.default.createElement(
                  _list.List,
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _reportStatus2.default.normalTitle },
                    t('label:アカウント')
                  ),
                  _react2.default.createElement(
                    _list.ListItem,
                    {
                      className: _reportStatus2.default.userInfo,
                      rightActions: [_react2.default.createElement(
                        _menu.IconMenu,
                        { key: 'menu', icon: 'more_vert', onClick: function onClick() {
                            return _this3.setState({ showMenu: true });
                          } },
                        _react2.default.createElement(_menu.MenuItem, {
                          icon: 'delete_forever',
                          onClick: this.unLinkGoogleDrive,
                          caption: t('label:Googleドライブを解除')
                        })
                      )]
                    },
                    _react2.default.createElement(
                      'span',
                      null,
                      userinfo.displayName
                    ),
                    _react2.default.createElement(
                      'span',
                      null,
                      '(',
                      userinfo.emailAddress,
                      ')'
                    )
                  )
                ),
                ui.gapiReady && _react2.default.createElement(
                  _list.List,
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _reportStatus2.default.normalTitle },
                    t('label:フォルダの選択')
                  ),
                  folders && folders.length == 0 && _react2.default.createElement(_list.ListItem, { caption: t('label:フォルダがありません'), selectable: false }),
                  _react2.default.createElement(_dropdown2.default, { auto: true,
                    source: dropDownSource,
                    value: ui.folder_id,
                    onChange: this.onSelectFolder
                  }),
                  !this.state.checkFolder && _react2.default.createElement(
                    _card.CardText,
                    { style: { color: 'red', paddingLeft: 0, paddingTop: 0 } },
                    _react2.default.createElement(_font_icon2.default, { value: 'error', style: { verticalAlign: 'bottom', fontSize: 18 } }),
                    _react2.default.createElement(
                      'span',
                      { style: { marginLeft: 5 } },
                      t('label:フォルダを選択して下さい1')
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _card.CardText,
              null,
              _react2.default.createElement(_button.Button, { raised: true, primary: true,
                disabled: this.state.sendingMethodValue == 'drive' && !ui.gapiReady,
                onClick: this.onDownloadFile,
                style: { width: '100%' },
                label: t('label:エクスポート')
              })
            )
          ),
          !isFetchFailed && _react2.default.createElement(_checkbox2.default, { checked: this.state.showDetail,
            label: t('label:詳細をすべて表示'),
            className: _reportStatus2.default.checkbox,
            onChange: function onChange() {
              return _this3.setState({ showDetail: !_this3.state.showDetail });
            } }),
          !isFetchFailed && !isFetching && activityReports && activityReports.length > 0 && _react2.default.createElement(
            _fixedDataTable.Table,
            {
              height: innerHeight >= activityReportsHeight ? activityReportsHeight : innerHeight
              //innerWidthがinnerMinWidthより下回った場合はinnerMinWidthを設定する なお15pxは右端のスクロールバーの横幅分である
              //innerHeightがactivityReportsHeightが上回った場合は右端のスクロールバーは必要ないため、その分の15pxはない状態にする
              , width: innerWidth <= innerMinWidth ? innerMinWidth + 15 : innerHeight >= activityReportsHeight ? innerWidth : innerWidth + 15,
              overflowX: 'hidden',
              headerHeight: 30,
              rowsCount: activityReports.length,
              rowHeight: this.state.showDetail ? 80 : 38 },
            _react2.default.createElement(_fixedDataTable.Column, { fixed: true,
              width: nameWidth,
              header: _react2.default.createElement(
                'div',
                { className: _reportStatus2.default.startDay },
                startDay && (0, _moment2.default)(startDay).format('ll') || ''
              ),
              cell: function cell(cellProps) {
                return _react2.default.createElement(
                  _fixedDataTable.Cell,
                  null,
                  _react2.default.createElement(
                    TooltipButton,
                    {
                      className: _reportStatus2.default.users,
                      tooltip: t('label:月間日報提出状況を表示'),
                      onClick: function onClick() {
                        _this3.onClick(activityReports[cellProps.rowIndex].user);
                      } },
                    _react2.default.createElement(_avatar2.default, { image: activityReports[cellProps.rowIndex].user.icon_image.thumb_url, theme: _smallAvatar2.default }),
                    '\xA0',
                    activityReports[cellProps.rowIndex].user.name
                  )
                );
              } }),
            _lodash2.default.map(weekDays, function (day, i) {
              return _react2.default.createElement(_fixedDataTable.Column, { key: i,
                width: innerWidth <= innerMinWidth ? 50 : columnWidth //innerWidthがinnerMinWidthより下回った場合は定数を設定する
                , header: _react2.default.createElement(WeekdayHeader, { day: day,
                  showDetail: _this3.state.showDetail,
                  fetchActivityReportPrev: function fetchActivityReportPrev() {
                    return fetchActivityReport(_this3.props, 'prev');
                  },
                  fetchActivityReportNext: function fetchActivityReportNext() {
                    return fetchActivityReport(_this3.props, 'next');
                  } }),
                cell: _react2.default.createElement(ReportStatusCell, { columnIndex: i, day: day,
                  onClick: openPickupDiaries,
                  showDetail: _this3.state.showDetail,
                  activityReports: activityReports }) });
            })
          ),
          !isFetchFailed && !isFetching && (!activityReports || activityReports.length == 0) && _react2.default.createElement(
            'div',
            { className: _reportStatus2.default.noMember },
            t('label:メンバーは登録されていません')
          ),
          isFetchFailed && _react2.default.createElement(
            'div',
            { className: _reportStatus2.default.failed },
            t('label:日報提出状況の取得に失敗しました')
          ),
          ui.user && _react2.default.createElement(_userMonthlySummaryPage2.default, {
            reportDate: ui.startDate,
            group: group,
            currentUser: currentUser,
            user: ui.user,
            onClose: this.onClose,
            open: ui.active })
        )
      );
    }
  }]);

  return ReportStatusPage;
}(_react2.default.Component);

var RawReportStatusPage = exports.RawReportStatusPage = ReportStatusPage;
exports.default = (0, _reportStatusPage2.default)(ReportStatusPage);

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isFetching: state.activityReport.isFetching,
    isFetchFailed: state.activityReport.isFetchFailed,
    activityReports: state.activityReport.items,
    group: (0, _find2.default)(state.groups.items, function (item) {
      return item.group_id == ownProps.params.group_id;
    }),
    access_token: state.sessions.access_token,
    currentUser: state.user.current,
    isFoldersFetching: state.googleApi.isFoldersFetching,
    isFoldersFetchFailed: state.googleApi.isFoldersFetchFailed,
    folders: state.googleApi.folders,
    isUserInfoFetching: state.googleApi.isUserInfoFetching,
    isUserInfoFetchFailed: state.googleApi.isUserInfoFetchFailed,
    userinfo: state.googleApi.userinfo,
    isUploadFetching: state.googleApi.isUploadFetching,
    isUploadFetchFailed: state.googleApi.isUploadFetchFailed
  };
};
// src/connects/report-status-page.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount(props) {
      return dispatch(_actions2.default.fetchActivityReports(props.group.group_id, props.ui.startDate.format('YYYY-MM-DD')));
    },

    fetchActivityReport: function fetchActivityReport(props, direction) {
      if (direction == 'prev') {
        var startDate = props.ui.startDate.clone().add(-7, 'days');
        dispatch(_actions2.default.fetchActivityReports(props.group.group_id, startDate.format('YYYY-MM-DD')));
        props.updateUI({ startDate: startDate });
      } else {
        var _startDate = props.ui.startDate.clone().add(7, 'days');
        dispatch(_actions2.default.fetchActivityReports(props.group.group_id, _startDate.format('YYYY-MM-DD')));
        props.updateUI({ startDate: _startDate });
      }
    },

    exportUrl: function exportUrl(props) {
      return _config2.default.baseUrl + 'v3/export/monthly_summary.xlsx?group_id=' + props.group.group_id + '&start_date=' + (0, _moment2.default)(props.ui.startDate).startOf('month').format('YYYY-MM-DD') + '&access_token=' + props.access_token;
    },

    openPickupDiaries: function openPickupDiaries(diary_ids) {
      return dispatch(_actions2.default.openRightSidePage('pickup_diaries', { diary_ids: diary_ids }, true));
    },

    openUserTimeline: function openUserTimeline(props, user) {
      return dispatch(_actions2.default.openRightSidePage('user_timeline', { group_id: props.group.group_id, user: user, user_id: user.user_id }, true));
    },

    willUnmount: function willUnmount() {
      dispatch(_actions2.default.clearActivityReports()), dispatch(_actions2.default.clearGoogleDriveFolders());
    },

    fetchUserInfo: function fetchUserInfo() {
      return dispatch(_actions2.default.fetchGoogleDriveUserInfo());
    },

    fetchFolders: function fetchFolders() {
      dispatch(_actions2.default.fetchGoogleDriveFolders());
    },

    cancelGoogleDrive: function cancelGoogleDrive() {
      dispatch(_actions2.default.clearGoogleDriveFolders());
    },

    downloadFile: function downloadFile(props) {
      var file_name = 'monthly_summary.xlsx';
      var file_url = _config2.default.baseUrl + 'v3/export/monthly_summary.xlsx?group_id=' + props.group.group_id + '&start_date=' + (0, _moment2.default)(props.ui.startDate).startOf('month').format('YYYY-MM-DD') + '&access_token=' + props.access_token;
      dispatch(_actions2.default.uploadGoogleDriveFile(props.ui.folder_id, file_name, file_url));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    startDate: (0, _moment2.default)().add(-(0, _moment2.default)().day(), 'days'),
    index: 0,
    innerWidth: 1000,
    innerHeight: 600,
    active: false,
    user: undefined,
    folder_id: 'undefined',
    gapiReady: false }
}), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('report_status'));

/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2624);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./small-avatar.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./small-avatar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.small-avatar--avatar--1wixngDh {\n  height: 32px;\n  width: 32px;\n  min-width: 32px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/small-avatar.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;CACjB","file":"small-avatar.css","sourcesContent":["\n.avatar {\n  height: 32px;\n  width: 32px;\n  min-width: 32px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"avatar": "small-avatar--avatar--1wixngDh"
};

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2626);


/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FixedDataTableRoot
 */



var _FixedDataTable = __webpack_require__(2627);

var _FixedDataTable2 = _interopRequireDefault(_FixedDataTable);

var _FixedDataTableCellDefault = __webpack_require__(1085);

var _FixedDataTableCellDefault2 = _interopRequireDefault(_FixedDataTableCellDefault);

var _FixedDataTableColumn = __webpack_require__(1084);

var _FixedDataTableColumn2 = _interopRequireDefault(_FixedDataTableColumn);

var _FixedDataTableColumnGroup = __webpack_require__(1083);

var _FixedDataTableColumnGroup2 = _interopRequireDefault(_FixedDataTableColumnGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FixedDataTableRoot = {
  Cell: _FixedDataTableCellDefault2.default,
  Column: _FixedDataTableColumn2.default,
  ColumnGroup: _FixedDataTableColumnGroup2.default,
  Table: _FixedDataTable2.default
};

FixedDataTableRoot.version = '0.8.6';
module.exports = FixedDataTableRoot;

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Copyright Schrodinger, LLC
                                                                                                                                                                                                                                                                   * All rights reserved.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                   * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * @providesModule FixedDataTable
                                                                                                                                                                                                                                                                   * @typechecks
                                                                                                                                                                                                                                                                   * @noflow
                                                                                                                                                                                                                                                                   */

/*eslint no-bitwise:1*/

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _createReactClass = __webpack_require__(206);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReactComponentWithPureRenderMixin = __webpack_require__(390);

var _ReactComponentWithPureRenderMixin2 = _interopRequireDefault(_ReactComponentWithPureRenderMixin);

var _ReactWheelHandler = __webpack_require__(1078);

var _ReactWheelHandler2 = _interopRequireDefault(_ReactWheelHandler);

var _ReactTouchHandler = __webpack_require__(2635);

var _ReactTouchHandler2 = _interopRequireDefault(_ReactTouchHandler);

var _Scrollbar = __webpack_require__(2636);

var _Scrollbar2 = _interopRequireDefault(_Scrollbar);

var _FixedDataTableBufferedRows = __webpack_require__(2645);

var _FixedDataTableBufferedRows2 = _interopRequireDefault(_FixedDataTableBufferedRows);

var _FixedDataTableColumnResizeHandle = __webpack_require__(2652);

var _FixedDataTableColumnResizeHandle2 = _interopRequireDefault(_FixedDataTableColumnResizeHandle);

var _FixedDataTableRow = __webpack_require__(1081);

var _FixedDataTableRow2 = _interopRequireDefault(_FixedDataTableRow);

var _FixedDataTableScrollHelper = __webpack_require__(2653);

var _FixedDataTableScrollHelper2 = _interopRequireDefault(_FixedDataTableScrollHelper);

var _FixedDataTableWidthHelper = __webpack_require__(2655);

var _FixedDataTableWidthHelper2 = _interopRequireDefault(_FixedDataTableWidthHelper);

var _FixedDataTableEventHelper = __webpack_require__(573);

var _FixedDataTableEventHelper2 = _interopRequireDefault(_FixedDataTableEventHelper);

var _cx = __webpack_require__(151);

var _cx2 = _interopRequireDefault(_cx);

var _debounceCore = __webpack_require__(2656);

var _debounceCore2 = _interopRequireDefault(_debounceCore);

var _emptyFunction = __webpack_require__(207);

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _invariant = __webpack_require__(292);

var _invariant2 = _interopRequireDefault(_invariant);

var _joinClasses = __webpack_require__(293);

var _joinClasses2 = _interopRequireDefault(_joinClasses);

var _shallowEqual = __webpack_require__(1086);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _FixedDataTableTranslateDOMPosition = __webpack_require__(391);

var _FixedDataTableTranslateDOMPosition2 = _interopRequireDefault(_FixedDataTableTranslateDOMPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactChildren = _React2.default.Children;

var EMPTY_OBJECT = {};
var BORDER_HEIGHT = 1;
var HEADER = 'header';
var FOOTER = 'footer';
var CELL = 'cell';
var ARROW_SCROLL_SPEED = 25;
var DRAG_SCROLL_SPEED = 15;
var DRAG_SCROLL_BUFFER = 100;

/**
 * Data grid component with fixed or scrollable header and columns.
 *
 * The layout of the data table is as follows:
 *
 * ```
 * +---------------------------------------------------+
 * | Fixed Column Group    | Scrollable Column Group   |
 * | Header                | Header                    |
 * |                       |                           |
 * +---------------------------------------------------+
 * |                       |                           |
 * | Fixed Header Columns  | Scrollable Header Columns |
 * |                       |                           |
 * +-----------------------+---------------------------+
 * |                       |                           |
 * | Fixed Body Columns    | Scrollable Body Columns   |
 * |                       |                           |
 * +-----------------------+---------------------------+
 * |                       |                           |
 * | Fixed Footer Columns  | Scrollable Footer Columns |
 * |                       |                           |
 * +-----------------------+---------------------------+
 * ```
 *
 * - Fixed Column Group Header: These are the headers for a group
 *   of columns if included in the table that do not scroll
 *   vertically or horizontally.
 *
 * - Scrollable Column Group Header: The header for a group of columns
 *   that do not move while scrolling vertically, but move horizontally
 *   with the horizontal scrolling.
 *
 * - Fixed Header Columns: The header columns that do not move while scrolling
 *   vertically or horizontally.
 *
 * - Scrollable Header Columns: The header columns that do not move
 *   while scrolling vertically, but move horizontally with the horizontal
 *   scrolling.
 *
 * - Fixed Body Columns: The body columns that do not move while scrolling
 *   horizontally, but move vertically with the vertical scrolling.
 *
 * - Scrollable Body Columns: The body columns that move while scrolling
 *   vertically or horizontally.
 */
var FixedDataTable = (0, _createReactClass2.default)({
  displayName: 'FixedDataTable',

  propTypes: {

    /**
     * Pixel width of table. If all columns do not fit,
     * a horizontal scrollbar will appear.
     */
    width: _propTypes2.default.number.isRequired,

    /**
     * Pixel height of table. If all rows do not fit,
     * a vertical scrollbar will appear.
     *
     * Either `height` or `maxHeight` must be specified.
     */
    height: _propTypes2.default.number,

    /**
     * Class name to be passed into parent container
     */
    className: _propTypes2.default.string,

    /**
     * Maximum pixel height of table. If all rows do not fit,
     * a vertical scrollbar will appear.
     *
     * Either `height` or `maxHeight` must be specified.
     */
    maxHeight: _propTypes2.default.number,

    /**
     * Pixel height of table's owner, this is used in a managed scrolling
     * situation when you want to slide the table up from below the fold
     * without having to constantly update the height on every scroll tick.
     * Instead, vary this property on scroll. By using `ownerHeight`, we
     * over-render the table while making sure the footer and horizontal
     * scrollbar of the table are visible when the current space for the table
     * in view is smaller than the final, over-flowing height of table. It
     * allows us to avoid resizing and reflowing table when it is moving in the
     * view.
     *
     * This is used if `ownerHeight < height` (or `maxHeight`).
     */
    ownerHeight: _propTypes2.default.number,

    overflowX: _propTypes2.default.oneOf(['hidden', 'auto']),
    overflowY: _propTypes2.default.oneOf(['hidden', 'auto']),

    /**
     * Boolean flag indicating of touch scrolling should be enabled
     * This feature is current in beta and may have bugs
     */
    touchScrollEnabled: _propTypes2.default.bool,

    /**
     * Boolean flags to control if scrolling with keys is enabled
     */
    keyboardScrollEnabled: _propTypes2.default.bool,
    keyboardPageEnabled: _propTypes2.default.bool,

    /**
     * Hide the scrollbar but still enable scroll functionality
     */
    showScrollbarX: _propTypes2.default.bool,
    showScrollbarY: _propTypes2.default.bool,

    /**
     * Callback when horizontally scrolling the grid.
     *
     * Return false to stop propagation.
     */
    onHorizontalScroll: _propTypes2.default.func,

    /**
     * Callback when vertically scrolling the grid.
     *
     * Return false to stop propagation.
     */
    onVerticalScroll: _propTypes2.default.func,

    /**
     * Number of rows in the table.
     */
    rowsCount: _propTypes2.default.number.isRequired,

    /**
     * Pixel height of rows unless `rowHeightGetter` is specified and returns
     * different value.
     */
    rowHeight: _propTypes2.default.number.isRequired,

    /**
     * If specified, `rowHeightGetter(index)` is called for each row and the
     * returned value overrides `rowHeight` for particular row.
     */
    rowHeightGetter: _propTypes2.default.func,

    /**
     * Pixel height of sub-row unless `subRowHeightGetter` is specified and returns
     * different value.  Defaults to 0 and no sub-row being displayed.
     */
    subRowHeight: _propTypes2.default.number,

    /**
     * If specified, `subRowHeightGetter(index)` is called for each row and the
     * returned value overrides `subRowHeight` for particular row.
     */
    subRowHeightGetter: _propTypes2.default.func,

    /**
     * The row expanded for table row.
     * This can either be a React element, or a function that generates
     * a React Element. By default, the React element passed in can expect to
     * receive the following props:
     *
     * ```
     * props: {
     *   rowIndex; number // (the row index)
     *   height: number // (supplied from the Table or rowHeightGetter)
     *   width: number // (supplied from the Table)
     * }
     * ```
     *
     * Because you are passing in your own React element, you can feel free to
     * pass in whatever props you may want or need.
     *
     * If you pass in a function, you will receive the same props object as the
     * first argument.
     */
    rowExpanded: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),

    /**
     * To get any additional CSS classes that should be added to a row,
     * `rowClassNameGetter(index)` is called.
     */
    rowClassNameGetter: _propTypes2.default.func,

    /**
     * If specified, `rowKeyGetter(index)` is called for each row and the
     * returned value overrides `key` for the particular row.
     */
    rowKeyGetter: _propTypes2.default.func,

    /**
     * Pixel height of the column group header.
     */
    groupHeaderHeight: _propTypes2.default.number,

    /**
     * Pixel height of header.
     */
    headerHeight: _propTypes2.default.number.isRequired,

    /**
     * Pixel height of fixedDataTableCellGroupLayout/cellGroupWrapper.
     * Default is headerHeight and groupHeaderHeight.
     *
     * This can be used with CSS to make a header cell span both the group & normal header row.
     * Setting this to a value larger than height will cause the content to
     * overflow the height. This is useful when adding a 2nd table as the group
     * header and vertically merging the 2 headers when a column is not part
     * of a group. Here are the necessary CSS changes:
     *
     * Both headers:
     *  - cellGroupWrapper needs overflow-x: hidden and pointer-events: none
     *  - cellGroup needs pointer-events: auto to reenable them on child els
     * Group header:
     *  - Layout/main needs overflow: visible and a higher z-index
     *  - CellLayout/main needs overflow-y: visible
     *  - cellGroup needs overflow: visible
     */
    cellGroupWrapperHeight: _propTypes2.default.number,

    /**
     * Pixel height of footer.
     */
    footerHeight: _propTypes2.default.number,

    /**
     * Value of horizontal scroll.
     */
    scrollLeft: _propTypes2.default.number,

    /**
     * Index of column to scroll to.
     */
    scrollToColumn: _propTypes2.default.number,

    /**
     * Value of vertical scroll.
     */
    scrollTop: _propTypes2.default.number,

    /**
     * Index of row to scroll to.
     */
    scrollToRow: _propTypes2.default.number,

    /**
     * Callback that is called when scrolling starts with current horizontal
     * and vertical scroll values.
     */
    onScrollStart: _propTypes2.default.func,

    /**
     * Callback that is called when scrolling ends or stops with new horizontal
     * and vertical scroll values.
     */
    onScrollEnd: _propTypes2.default.func,

    /**
     * If enabled scroll events will not be propagated outside of the table.
     */
    stopScrollPropagation: _propTypes2.default.bool,

    /**
     * Callback that is called when `rowHeightGetter` returns a different height
     * for a row than the `rowHeight` prop. This is necessary because initially
     * table estimates heights of some parts of the content.
     */
    onContentHeightChange: _propTypes2.default.func,

    /**
     * Callback that is called when a row is clicked.
     */
    onRowClick: _propTypes2.default.func,

    /**
     * Callback that is called when a row is double clicked.
     */
    onRowDoubleClick: _propTypes2.default.func,

    /**
     * Callback that is called when a mouse-down event happens on a row.
     */
    onRowMouseDown: _propTypes2.default.func,

    /**
     * Callback that is called when a mouse-up event happens on a row.
     */
    onRowMouseUp: _propTypes2.default.func,

    /**
     * Callback that is called when a mouse-enter event happens on a row.
     */
    onRowMouseEnter: _propTypes2.default.func,

    /**
     * Callback that is called when a mouse-leave event happens on a row.
     */
    onRowMouseLeave: _propTypes2.default.func,

    /**
     * Callback that is called when a touch-start event happens on a row.
     */
    onRowTouchStart: _propTypes2.default.func,

    /**
     * Callback that is called when a touch-end event happens on a row.
     */
    onRowTouchEnd: _propTypes2.default.func,

    /**
     * Callback that is called when a touch-move event happens on a row.
     */
    onRowTouchMove: _propTypes2.default.func,

    /**
     * Callback that is called when resizer has been released
     * and column needs to be updated.
     *
     * Required if the isResizable property is true on any column.
     *
     * ```
     * function(
     *   newColumnWidth: number,
     *   columnKey: string,
     * )
     * ```
     */
    onColumnResizeEndCallback: _propTypes2.default.func,

    /**
     * Callback that is called when reordering has been completed
     * and columns need to be updated.
     *
     * ```
     * function(
     *   event {
     *     columnBefore: string|undefined, // the column before the new location of this one
     *     columnAfter: string|undefined,  // the column after the new location of this one
     *     reorderColumn: string,          // the column key that was just reordered
     *   }
     * )
     * ```
     */
    onColumnReorderEndCallback: _propTypes2.default.func,

    /**
     * Whether a column is currently being resized.
     */
    isColumnResizing: _propTypes2.default.bool,

    /**
     * Whether columns are currently being reordered.
     */
    isColumnReordering: _propTypes2.default.bool,

    /**
     * The number of rows outside the viewport to prerender. Defaults to roughly
     * half of the number of visible rows.
     */
    bufferRowCount: _propTypes2.default.number
  },

  getDefaultProps: function getDefaultProps() /*object*/{
    return {
      footerHeight: 0,
      groupHeaderHeight: 0,
      headerHeight: 0,
      showScrollbarX: true,
      showScrollbarY: true,
      touchScrollEnabled: false,
      keyboardScrollEnabled: false,
      keyboardPageEnabled: false,
      stopScrollPropagation: false
    };
  },
  componentWillMount: function componentWillMount() {
    var props = this.props;

    var viewportHeight = (props.height === undefined ? props.maxHeight : props.height) - (props.headerHeight || 0) - (props.footerHeight || 0) - (props.groupHeaderHeight || 0);
    this._scrollHelper = new _FixedDataTableScrollHelper2.default(props.rowsCount, props.rowHeight, viewportHeight, props.rowHeightGetter, props.subRowHeight, props.subRowHeightGetter);

    this._didScrollStop = (0, _debounceCore2.default)(this._didScrollStopSync, 200, this);

    this._wheelHandler = new _ReactWheelHandler2.default(this._onScroll, this._shouldHandleWheelX, this._shouldHandleWheelY, props.stopScrollPropagation);
    this._touchHandler = new _ReactTouchHandler2.default(this._onScroll, this._shouldHandleTouchX, this._shouldHandleTouchY, props.stopScrollPropagation);

    this.setState(this._calculateState(props));
  },
  componentWillUnmount: function componentWillUnmount() {
    this._wheelHandler = null;
    this._touchHandler = null;

    // Cancel any pending debounced scroll handling and handle immediately.
    this._didScrollStop.reset();
    this._didScrollStopSync();
  },
  _shouldHandleTouchX: function _shouldHandleTouchX( /*number*/delta) /*boolean*/{
    return this.props.touchScrollEnabled && this._shouldHandleWheelX(delta);
  },
  _shouldHandleTouchY: function _shouldHandleTouchY( /*number*/delta) /*boolean*/{
    return this.props.touchScrollEnabled && this._shouldHandleWheelY(delta);
  },
  _shouldHandleWheelX: function _shouldHandleWheelX( /*number*/delta) /*boolean*/{
    if (this.props.overflowX === 'hidden') {
      return false;
    }

    delta = Math.round(delta);
    if (delta === 0) {
      return false;
    }

    return delta < 0 && this.state.scrollX > 0 || delta >= 0 && this.state.scrollX < this.state.maxScrollX;
  },
  _shouldHandleWheelY: function _shouldHandleWheelY( /*number*/delta) /*boolean*/{
    if (this.props.overflowY === 'hidden' || delta === 0) {
      return false;
    }

    delta = Math.round(delta);
    if (delta === 0) {
      return false;
    }

    return delta < 0 && this.state.scrollY > 0 || delta >= 0 && this.state.scrollY < this.state.maxScrollY;
  },
  _onKeyDown: function _onKeyDown(event) {
    if (this.props.keyboardPageEnabled) {
      switch (event.key) {
        case 'PageDown':
          this._onScroll(0, this._scrollbarYHeight);
          event.preventDefault();
          break;

        case 'PageUp':
          this._onScroll(0, this._scrollbarYHeight * -1);
          event.preventDefault();
          break;

        default:
          break;
      }
    }
    if (this.props.keyboardScrollEnabled) {
      switch (event.key) {

        case 'ArrowDown':
          this._onScroll(0, ARROW_SCROLL_SPEED);
          event.preventDefault();
          break;

        case 'ArrowUp':
          this._onScroll(0, ARROW_SCROLL_SPEED * -1);
          event.preventDefault();
          break;

        case 'ArrowRight':
          this._onScroll(ARROW_SCROLL_SPEED, 0);
          event.preventDefault();
          break;

        case 'ArrowLeft':
          this._onScroll(ARROW_SCROLL_SPEED * -1, 0);
          event.preventDefault();
          break;

        default:
          break;
      }
    }
  },
  _reportContentHeight: function _reportContentHeight() {
    var scrollContentHeight = this.state.scrollContentHeight;
    var reservedHeight = this.state.reservedHeight;
    var requiredHeight = scrollContentHeight + reservedHeight;
    var contentHeight;
    var useMaxHeight = this.props.height === undefined;
    if (useMaxHeight && this.props.maxHeight > requiredHeight) {
      contentHeight = requiredHeight;
    } else if (this.state.height > requiredHeight && this.props.ownerHeight) {
      contentHeight = Math.max(requiredHeight, this.props.ownerHeight);
    } else {
      contentHeight = this.state.height + this.state.maxScrollY;
    }
    if (contentHeight !== this._contentHeight && this.props.onContentHeightChange) {
      this.props.onContentHeightChange(contentHeight);
    }
    this._contentHeight = contentHeight;
  },
  componentDidMount: function componentDidMount() {
    this._reportContentHeight();
  },
  componentWillReceiveProps: function componentWillReceiveProps( /*object*/nextProps) {
    var newOverflowX = nextProps.overflowX;
    var newOverflowY = nextProps.overflowY;

    // In the case of controlled scrolling, notify.
    if (this.props.ownerHeight !== nextProps.ownerHeight || this.props.scrollTop !== nextProps.scrollTop || this.props.scrollLeft !== nextProps.scrollLeft) {
      this._didScrollStart();
    }

    // Cancel any pending debounced scroll handling and handle immediately.
    this._didScrollStop.reset();
    this._didScrollStopSync();

    this.setState(this._calculateState(nextProps, this.state));
  },
  componentDidUpdate: function componentDidUpdate() {
    this._reportContentHeight();
  },
  render: function render() /*object*/{
    var state = this.state;
    var props = this.props;

    var onColumnReorder = props.onColumnReorderEndCallback ? this._onColumnReorder : null;

    var groupHeader;
    if (state.useGroupHeader) {
      groupHeader = _React2.default.createElement(_FixedDataTableRow2.default, {
        key: 'group_header',
        isScrolling: this._isScrolling,
        className: (0, _joinClasses2.default)((0, _cx2.default)('fixedDataTableLayout/header'), (0, _cx2.default)('public/fixedDataTable/header')),
        width: state.width,
        height: state.groupHeaderHeight,
        cellGroupWrapperHeight: state.cellGroupWrapperHeight,
        index: 0,
        zIndex: 1,
        offsetTop: 0,
        scrollLeft: state.scrollX,
        fixedColumns: state.groupHeaderFixedColumns,
        fixedRightColumns: state.groupHeaderFixedRightColumns,
        scrollableColumns: state.groupHeaderScrollableColumns,
        onColumnResize: this._onColumnResize,
        onColumnReorder: onColumnReorder,
        onColumnReorderMove: this._onColumnReorderMove
      });
    }

    var maxScrollY = this.state.maxScrollY;
    var showScrollbarX = state.maxScrollX > 0 && state.overflowX !== 'hidden' && state.showScrollbarX !== false;
    var showScrollbarY = maxScrollY > 0 && state.overflowY !== 'hidden' && state.showScrollbarY !== false;
    var scrollbarXHeight = showScrollbarX ? _Scrollbar2.default.SIZE : 0;
    var scrollbarYHeight = state.height - scrollbarXHeight - 2 * BORDER_HEIGHT - state.footerHeight;

    var headerOffsetTop = state.useGroupHeader ? state.groupHeaderHeight : 0;
    var bodyOffsetTop = headerOffsetTop + state.headerHeight;
    scrollbarYHeight -= bodyOffsetTop;
    var bottomSectionOffset = 0;
    var footOffsetTop = props.maxHeight != null ? bodyOffsetTop + state.bodyHeight : bodyOffsetTop + scrollbarYHeight;
    var rowsContainerHeight = footOffsetTop + state.footerHeight;

    if (props.ownerHeight !== undefined && props.ownerHeight < state.height) {
      bottomSectionOffset = props.ownerHeight - state.height;

      footOffsetTop = Math.min(footOffsetTop, props.ownerHeight - state.footerHeight - scrollbarXHeight);

      scrollbarYHeight = Math.max(0, footOffsetTop - bodyOffsetTop);
    }
    this._scrollbarYHeight = scrollbarYHeight;

    var verticalScrollbar;
    if (showScrollbarY) {
      verticalScrollbar = _React2.default.createElement(_Scrollbar2.default, {
        size: scrollbarYHeight,
        contentSize: scrollbarYHeight + maxScrollY,
        onScroll: this._onVerticalScroll,
        verticalTop: bodyOffsetTop,
        position: state.scrollY
      });
    }

    var horizontalScrollbar;
    if (showScrollbarX) {
      var scrollbarXWidth = state.width;
      horizontalScrollbar = _React2.default.createElement(HorizontalScrollbar, {
        contentSize: scrollbarXWidth + state.maxScrollX,
        offset: bottomSectionOffset,
        onScroll: this._onHorizontalScroll,
        position: state.scrollX,
        size: scrollbarXWidth
      });
    }

    var dragKnob = _React2.default.createElement(_FixedDataTableColumnResizeHandle2.default, {
      height: state.height,
      initialWidth: state.columnResizingData.width || 0,
      minWidth: state.columnResizingData.minWidth || 0,
      maxWidth: state.columnResizingData.maxWidth || Number.MAX_VALUE,
      visible: !!state.isColumnResizing,
      leftOffset: state.columnResizingData.left || 0,
      knobHeight: state.headerHeight,
      initialEvent: state.columnResizingData.initialEvent,
      onColumnResizeEnd: props.onColumnResizeEndCallback,
      columnKey: state.columnResizingData.key,
      touchEnabled: state.touchScrollEnabled
    });

    var footer = null;
    if (state.footerHeight) {
      footer = _React2.default.createElement(_FixedDataTableRow2.default, {
        key: 'footer',
        isScrolling: this._isScrolling,
        className: (0, _joinClasses2.default)((0, _cx2.default)('fixedDataTableLayout/footer'), (0, _cx2.default)('public/fixedDataTable/footer')),
        width: state.width,
        height: state.footerHeight,
        index: -1,
        zIndex: 1,
        offsetTop: footOffsetTop,
        fixedColumns: state.footFixedColumns,
        fixedRightColumns: state.footFixedRightColumns,
        scrollableColumns: state.footScrollableColumns,
        scrollLeft: state.scrollX
      });
    }

    var rows = this._renderRows(bodyOffsetTop);

    var header = _React2.default.createElement(_FixedDataTableRow2.default, {
      key: 'header',
      isScrolling: this._isScrolling,
      className: (0, _joinClasses2.default)((0, _cx2.default)('fixedDataTableLayout/header'), (0, _cx2.default)('public/fixedDataTable/header')),
      width: state.width,
      height: state.headerHeight,
      cellGroupWrapperHeight: state.cellGroupWrapperHeight,
      index: -1,
      zIndex: 1,
      offsetTop: headerOffsetTop,
      scrollLeft: state.scrollX,
      fixedColumns: state.headFixedColumns,
      fixedRightColumns: state.headFixedRightColumns,
      scrollableColumns: state.headScrollableColumns,
      touchEnabled: state.touchScrollEnabled,
      onColumnResize: this._onColumnResize,
      onColumnReorder: onColumnReorder,
      onColumnReorderMove: this._onColumnReorderMove,
      onColumnReorderEnd: this._onColumnReorderEnd,
      isColumnReordering: !!state.isColumnReordering,
      columnReorderingData: state.columnReorderingData
    });

    var topShadow;
    var bottomShadow;
    if (state.scrollY) {
      topShadow = _React2.default.createElement('div', {
        className: (0, _joinClasses2.default)((0, _cx2.default)('fixedDataTableLayout/topShadow'), (0, _cx2.default)('public/fixedDataTable/topShadow')),
        style: { top: bodyOffsetTop }
      });
    }

    if (state.ownerHeight != null && state.ownerHeight < state.height && state.scrollContentHeight + state.reservedHeight > state.ownerHeight || state.scrollY < maxScrollY) {
      bottomShadow = _React2.default.createElement('div', {
        className: (0, _joinClasses2.default)((0, _cx2.default)('fixedDataTableLayout/bottomShadow'), (0, _cx2.default)('public/fixedDataTable/bottomShadow')),
        style: { top: footOffsetTop }
      });
    }

    return _React2.default.createElement(
      'div',
      {
        className: (0, _joinClasses2.default)(this.state.className, (0, _cx2.default)('fixedDataTableLayout/main'), (0, _cx2.default)('public/fixedDataTable/main')),
        tabIndex: 0,
        onKeyDown: this._onKeyDown,
        onWheel: this._wheelHandler.onWheel,
        onTouchStart: this._touchHandler.onTouchStart,
        onTouchEnd: this._touchHandler.onTouchEnd,
        onTouchMove: this._touchHandler.onTouchMove,
        onTouchCancel: this._touchHandler.onTouchCancel,
        style: { height: state.height, width: state.width } },
      _React2.default.createElement(
        'div',
        {
          className: (0, _cx2.default)('fixedDataTableLayout/rowsContainer'),
          style: { height: rowsContainerHeight, width: state.width } },
        dragKnob,
        groupHeader,
        header,
        rows,
        footer,
        topShadow,
        bottomShadow
      ),
      verticalScrollbar,
      horizontalScrollbar
    );
  },
  _renderRows: function _renderRows( /*number*/offsetTop) /*object*/{
    var state = this.state;

    return _React2.default.createElement(_FixedDataTableBufferedRows2.default, {
      isScrolling: this._isScrolling,
      defaultRowHeight: state.rowHeight,
      firstRowIndex: state.firstRowIndex,
      firstRowOffset: state.firstRowOffset,
      fixedColumns: state.bodyFixedColumns,
      fixedRightColumns: state.bodyFixedRightColumns,
      height: state.bodyHeight,
      offsetTop: offsetTop,
      onRowClick: state.onRowClick,
      onRowDoubleClick: state.onRowDoubleClick,
      onRowMouseDown: state.onRowMouseDown,
      onRowMouseUp: state.onRowMouseUp,
      onRowMouseEnter: state.onRowMouseEnter,
      onRowMouseLeave: state.onRowMouseLeave,
      onRowTouchStart: state.touchScrollEnabled ? state.onRowTouchStart : null,
      onRowTouchEnd: state.touchScrollEnabled ? state.onRowTouchEnd : null,
      onRowTouchMove: state.touchScrollEnabled ? state.onRowTouchMove : null,
      rowClassNameGetter: state.rowClassNameGetter,
      rowsCount: state.rowsCount,
      rowGetter: state.rowGetter,
      rowHeightGetter: state.rowHeightGetter,
      subRowHeight: state.subRowHeight,
      subRowHeightGetter: state.subRowHeightGetter,
      rowExpanded: state.rowExpanded,
      rowKeyGetter: state.rowKeyGetter,
      scrollLeft: state.scrollX,
      scrollableColumns: state.bodyScrollableColumns,
      showLastRowBorder: true,
      width: state.width,
      rowPositionGetter: this._scrollHelper.getRowPosition,
      bufferRowCount: this.state.bufferRowCount
    });
  },


  /**
   * This is called when a cell that is in the header of a column has its
   * resizer knob clicked on. It displays the resizer and puts in the correct
   * location on the table.
   */
  _onColumnResize: function _onColumnResize(
  /*number*/combinedWidth,
  /*number*/leftOffset,
  /*number*/cellWidth,
  /*?number*/cellMinWidth,
  /*?number*/cellMaxWidth,
  /*number|string*/columnKey,
  /*object*/event) {

    var coordinates = _FixedDataTableEventHelper2.default.getCoordinatesFromEvent(event);
    var x = coordinates.x;
    var y = coordinates.y;

    this.setState({
      isColumnResizing: true,
      columnResizingData: {
        left: leftOffset + combinedWidth - cellWidth,
        width: cellWidth,
        minWidth: cellMinWidth,
        maxWidth: cellMaxWidth,
        initialEvent: {
          clientX: x,
          clientY: y,
          preventDefault: _emptyFunction2.default
        },
        key: columnKey
      }
    });
  },
  _onColumnReorder: function _onColumnReorder(
  /*string*/columnKey,
  /*number*/width,
  /*number*/left,
  /*object*/event) {
    // No native support in IE11 for find, findIndex, or includes, so using some.
    var isFixed = this.state.headFixedColumns.some(function (column) {
      return column.props.columnKey === columnKey;
    });

    this.setState({
      isColumnReordering: true,
      columnReorderingData: {
        dragDistance: 0,
        isFixed: isFixed,
        scrollStart: this.state.scrollX,
        columnKey: columnKey,
        columnWidth: width,
        originalLeft: left,
        columnsBefore: [],
        columnsAfter: []
      }
    });
  },
  _onColumnReorderMove: function _onColumnReorderMove(
  /*number*/deltaX) {
    //NOTE Need to clone this object when use pureRendering
    var reorderingData = _extends({}, this.state.columnReorderingData);
    reorderingData.dragDistance = deltaX;
    reorderingData.columnBefore = undefined;
    reorderingData.columnAfter = undefined;

    var isFixedColumn = this.state.columnReorderingData.isFixed;
    var scrollX = this.state.scrollX;

    if (!isFixedColumn) {
      //Relative dragX position on scroll
      var dragX = reorderingData.originalLeft - reorderingData.scrollStart + reorderingData.dragDistance;

      var fixedColumnsWidth = this.state.bodyFixedColumns.reduce(function (sum, column) {
        return sum + column.props.width;
      }, 0);
      var relativeWidth = this.props.width - fixedColumnsWidth;

      //Scroll the table left or right if we drag near the edges of the table
      if (dragX > relativeWidth - DRAG_SCROLL_BUFFER) {
        scrollX = Math.min(scrollX + DRAG_SCROLL_SPEED, this.state.maxScrollX);
      } else if (dragX <= DRAG_SCROLL_BUFFER) {
        scrollX = Math.max(scrollX - DRAG_SCROLL_SPEED, 0);
      }

      reorderingData.dragDistance += this.state.scrollX - reorderingData.scrollStart;
    }

    this.setState({
      scrollX: scrollX,
      columnReorderingData: reorderingData
    });
  },
  _onColumnReorderEnd: function _onColumnReorderEnd(
  /*object*/props,
  /*object*/event) {

    var columnBefore = this.state.columnReorderingData.columnBefore;
    var columnAfter = this.state.columnReorderingData.columnAfter;
    var reorderColumn = this.state.columnReorderingData.columnKey;
    var cancelReorder = this.state.columnReorderingData.cancelReorder;

    this.setState({
      isColumnReordering: false,
      columnReorderingData: {}
    });

    if (cancelReorder) {
      return;
    }

    this.props.onColumnReorderEndCallback({
      columnBefore: columnBefore, columnAfter: columnAfter, reorderColumn: reorderColumn
    });

    var onHorizontalScroll = this.props.onHorizontalScroll;
    if (this.state.columnReorderingData.scrollStart !== this.state.scrollX && onHorizontalScroll) {
      onHorizontalScroll(this.state.scrollX);
    };
  },
  _areColumnSettingsIdentical: function _areColumnSettingsIdentical(oldColumns, newColumns) {
    if (oldColumns.length !== newColumns.length) {
      return false;
    }
    for (var index = 0; index < oldColumns.length; ++index) {
      if (!(0, _shallowEqual2.default)(oldColumns[index].props, newColumns[index].props)) {
        return false;
      }
    }
    return true;
  },
  _populateColumnsAndColumnData: function _populateColumnsAndColumnData(columns, columnGroups, oldState) {
    var canReuseColumnSettings = false;
    var canReuseColumnGroupSettings = false;

    if (oldState && oldState.columns) {
      canReuseColumnSettings = this._areColumnSettingsIdentical(columns, oldState.columns);
    }
    if (oldState && oldState.columnGroups && columnGroups) {
      canReuseColumnGroupSettings = this._areColumnSettingsIdentical(columnGroups, oldState.columnGroups);
    }

    var columnInfo = {};
    if (canReuseColumnSettings) {
      columnInfo.bodyFixedColumns = oldState.bodyFixedColumns;
      columnInfo.bodyFixedRightColumns = oldState.bodyFixedRightColumns;
      columnInfo.bodyScrollableColumns = oldState.bodyScrollableColumns;
      columnInfo.headFixedColumns = oldState.headFixedColumns;
      columnInfo.headFixedRightColumns = oldState.headFixedRightColumns;
      columnInfo.headScrollableColumns = oldState.headScrollableColumns;
      columnInfo.footFixedColumns = oldState.footFixedColumns;
      columnInfo.footFixedRightColumns = oldState.footFixedRightColumns;
      columnInfo.footScrollableColumns = oldState.footScrollableColumns;
    } else {
      var bodyColumnTypes = this._splitColumnTypes(columns);
      columnInfo.bodyFixedColumns = bodyColumnTypes.fixed;
      columnInfo.bodyFixedRightColumns = bodyColumnTypes.fixedRight;
      columnInfo.bodyScrollableColumns = bodyColumnTypes.scrollable;

      var headColumnTypes = this._splitColumnTypes(this._selectColumnElement(HEADER, columns));
      columnInfo.headFixedColumns = headColumnTypes.fixed;
      columnInfo.headFixedRightColumns = headColumnTypes.fixedRight;
      columnInfo.headScrollableColumns = headColumnTypes.scrollable;

      var footColumnTypes = this._splitColumnTypes(this._selectColumnElement(FOOTER, columns));
      columnInfo.footFixedColumns = footColumnTypes.fixed;
      columnInfo.footFixedRightColumns = footColumnTypes.fixedRight;
      columnInfo.footScrollableColumns = footColumnTypes.scrollable;
    }

    if (canReuseColumnGroupSettings) {
      columnInfo.groupHeaderFixedColumns = oldState.groupHeaderFixedColumns;
      columnInfo.groupHeaderFixedRightColumns = oldState.groupHeaderFixedRightColumns;
      columnInfo.groupHeaderScrollableColumns = oldState.groupHeaderScrollableColumns;
    } else {
      if (columnGroups) {
        var groupHeaderColumnTypes = this._splitColumnTypes(this._selectColumnElement(HEADER, columnGroups));
        columnInfo.groupHeaderFixedColumns = groupHeaderColumnTypes.fixed;
        columnInfo.groupHeaderFixedRightColumns = groupHeaderColumnTypes.fixedRight;
        columnInfo.groupHeaderScrollableColumns = groupHeaderColumnTypes.scrollable;
      }
    }

    return columnInfo;
  },
  _calculateState: function _calculateState( /*object*/props, /*?object*/oldState) /*object*/{
    (0, _invariant2.default)(props.height !== undefined || props.maxHeight !== undefined, 'You must set either a height or a maxHeight');

    var children = [];
    ReactChildren.forEach(props.children, function (child, index) {
      if (child == null) {
        return;
      }
      (0, _invariant2.default)(child.type.__TableColumnGroup__ || child.type.__TableColumn__, 'child type should be <FixedDataTableColumn /> or ' + '<FixedDataTableColumnGroup />');
      children.push(child);
    });

    var scrollState;
    var firstRowIndex = oldState && oldState.firstRowIndex || 0;
    var firstRowOffset = oldState && oldState.firstRowOffset || 0;
    var scrollY = oldState ? oldState.scrollY : 0;
    var scrollX = oldState ? oldState.scrollX : 0;

    var lastScrollLeft = oldState ? oldState.scrollLeft : 0;
    if (props.scrollLeft !== undefined && props.scrollLeft !== lastScrollLeft) {
      scrollX = props.scrollLeft;
    }

    if (oldState && (props.rowsCount !== oldState.rowsCount || props.rowHeight !== oldState.rowHeight || props.height !== oldState.height)) {
      // Number of rows changed, try to scroll to the row from before the
      // change
      var viewportHeight = (props.height === undefined ? props.maxHeight : props.height) - (props.headerHeight || 0) - (props.footerHeight || 0) - (props.groupHeaderHeight || 0);

      var oldViewportHeight = this._scrollHelper._viewportHeight;

      this._scrollHelper = new _FixedDataTableScrollHelper2.default(props.rowsCount, props.rowHeight, viewportHeight, props.rowHeightGetter, props.subRowHeight, props.subRowHeightGetter);
      scrollState = this._scrollHelper.scrollToRow(firstRowIndex, firstRowOffset);
      firstRowIndex = scrollState.index;
      firstRowOffset = scrollState.offset;
      scrollY = scrollState.position;
    } else if (oldState) {
      if (props.rowHeightGetter !== oldState.rowHeightGetter) {
        this._scrollHelper.setRowHeightGetter(props.rowHeightGetter);
      }
      if (props.subRowHeightGetter !== oldState.subRowHeightGetter) {
        this._scrollHelper.setSubRowHeightGetter(props.subRowHeightGetter);
      }
    }

    // Figure out if the vertical scrollbar will be visible first, 
    // because it will determine the width of the table
    var useGroupHeader = false;
    var groupHeaderHeight = 0;

    if (children.length && children[0].type.__TableColumnGroup__) {
      useGroupHeader = true;
      groupHeaderHeight = props.groupHeaderHeight;
    }

    var useMaxHeight = props.height === undefined;
    var height = Math.round(useMaxHeight ? props.maxHeight : props.height);
    var totalHeightReserved = props.footerHeight + props.headerHeight + groupHeaderHeight + 2 * BORDER_HEIGHT;
    var bodyHeight = height - totalHeightReserved;
    var scrollContentHeight = this._scrollHelper.getContentHeight();
    var totalHeightNeeded = scrollContentHeight + totalHeightReserved;
    var maxScrollY = Math.max(0, scrollContentHeight - bodyHeight);

    // If vertical scrollbar is necessary, adjust the table width to give it room
    var adjustedWidth = props.width;
    if (maxScrollY) {
      adjustedWidth = adjustedWidth - _Scrollbar2.default.SIZE - 1;
    }

    var lastScrollToRow = oldState ? oldState.scrollToRow : undefined;
    if (props.scrollToRow != null && (props.scrollToRow !== lastScrollToRow || viewportHeight !== oldViewportHeight)) {
      scrollState = this._scrollHelper.scrollRowIntoView(props.scrollToRow);
      firstRowIndex = scrollState.index;
      firstRowOffset = scrollState.offset;
      scrollY = scrollState.position;
    }

    var lastScrollTop = oldState ? oldState.scrollTop : undefined;
    if (props.scrollTop != null && props.scrollTop !== lastScrollTop) {
      scrollState = this._scrollHelper.scrollTo(props.scrollTop);
      firstRowIndex = scrollState.index;
      firstRowOffset = scrollState.offset;
      scrollY = scrollState.position;
    }

    var columnResizingData;
    if (props.isColumnResizing) {
      columnResizingData = oldState && oldState.columnResizingData;
    } else {
      columnResizingData = EMPTY_OBJECT;
    }

    var columns;
    var columnGroups;

    if (useGroupHeader) {
      var columnGroupSettings = _FixedDataTableWidthHelper2.default.adjustColumnGroupWidths(children, adjustedWidth);
      columns = columnGroupSettings.columns;
      columnGroups = columnGroupSettings.columnGroups;
    } else {
      columns = _FixedDataTableWidthHelper2.default.adjustColumnWidths(children, adjustedWidth);
    }

    var columnInfo = this._populateColumnsAndColumnData(columns, columnGroups, oldState);

    var lastScrollToColumn = oldState ? oldState.scrollToColumn : undefined;
    if (props.scrollToColumn !== null && props.scrollToColumn !== lastScrollToColumn) {
      // If selected column is a fixed column, don't scroll
      var fixedColumnsCount = columnInfo.bodyFixedColumns.length;
      if (props.scrollToColumn >= fixedColumnsCount) {
        var totalFixedColumnsWidth = 0;
        var i, column;
        for (i = 0; i < columnInfo.bodyFixedColumns.length; ++i) {
          column = columnInfo.bodyFixedColumns[i];
          totalFixedColumnsWidth += column.props.width;
        }

        var j;
        for (j = 0; j < columnInfo.bodyFixedRightColumns.length; ++j) {
          column = columnInfo.bodyFixedRightColumns[j];
          totalFixedColumnsWidth += column.props.width;
        }

        // Convert column index (0 indexed) to scrollable index (0 indexed)
        // and clamp to max scrollable index
        var scrollableColumnIndex = Math.min(props.scrollToColumn - fixedColumnsCount, columnInfo.bodyScrollableColumns.length - 1);

        // Sum width for all columns before column
        var previousColumnsWidth = 0;
        for (i = 0; i < scrollableColumnIndex; ++i) {
          column = columnInfo.bodyScrollableColumns[i];
          previousColumnsWidth += column.props.width;
        }

        // Get width of scrollable columns in viewport
        var availableScrollWidth = adjustedWidth - totalFixedColumnsWidth;

        // Get width of specified column
        var selectedColumnWidth = columnInfo.bodyScrollableColumns[scrollableColumnIndex].props.width;

        // Must scroll at least far enough for end of column (prevColWidth + selColWidth)
        // to be in viewport (availableScrollWidth = viewport width)
        var minAcceptableScrollPosition = previousColumnsWidth + selectedColumnWidth - availableScrollWidth;

        // If scrolled less than minimum amount, scroll to minimum amount
        // so column on right of viewport
        if (scrollX < minAcceptableScrollPosition) {
          scrollX = minAcceptableScrollPosition;
        }

        // If scrolled more than previous columns, at least part of column will be offscreen to left
        // Scroll so column is flush with left edge of viewport
        if (scrollX > previousColumnsWidth) {
          scrollX = previousColumnsWidth;
        }
      }
    }

    var scrollContentWidth = _FixedDataTableWidthHelper2.default.getTotalWidth(columns);

    var horizontalScrollbarVisible = scrollContentWidth > adjustedWidth && props.overflowX !== 'hidden' && props.showScrollbarX !== false;

    if (horizontalScrollbarVisible) {
      bodyHeight -= _Scrollbar2.default.SIZE;
      totalHeightNeeded += _Scrollbar2.default.SIZE;
      totalHeightReserved += _Scrollbar2.default.SIZE;
      // If the horizontal scrollbar appears, the vertical scrollbar may now be needed
      // since the bottom row might be partially obscured by the horizontal scrollbar.
      // We also need to make sure we don't double-dip and adjust the width twice
      var notAdjusted = adjustedWidth === props.width;
      maxScrollY = Math.max(0, scrollContentHeight - bodyHeight);
      if (notAdjusted && maxScrollY) {
        adjustedWidth = adjustedWidth - _Scrollbar2.default.SIZE - 1;
      }
    }

    var maxScrollX = Math.max(0, scrollContentWidth - adjustedWidth);
    scrollX = Math.min(scrollX, maxScrollX);
    scrollY = Math.min(scrollY, maxScrollY);

    if (!maxScrollY) {
      // no vertical scrollbar necessary, use the totals we tracked so we
      // can shrink-to-fit vertically
      if (useMaxHeight) {
        height = totalHeightNeeded;
      }
      bodyHeight = totalHeightNeeded - totalHeightReserved;
    }

    this._scrollHelper.setViewportHeight(bodyHeight);

    // This calculation is synonymous to Element.scrollTop
    var scrollTop = Math.abs(firstRowOffset - this._scrollHelper.getRowPosition(firstRowIndex));
    // This case can happen when the user is completely scrolled down and resizes the viewport to be taller vertically.
    // This is because we set the viewport height after having calculated the rows
    if (scrollTop !== scrollY) {
      scrollTop = maxScrollY;
      scrollState = this._scrollHelper.scrollTo(scrollTop);
      firstRowIndex = scrollState.index;
      firstRowOffset = scrollState.offset;
      scrollY = scrollState.position;
    }

    var cellGroupWrapperHeight = props.cellGroupWrapperHeight;

    // The order of elements in this object metters and bringing bodyHeight,
    // height or useGroupHeader to the top can break various features
    var newState = _extends({
      isColumnResizing: oldState && oldState.isColumnResizing
    }, columnInfo, props, {

      columns: columns,
      columnGroups: columnGroups,
      columnResizingData: columnResizingData,
      firstRowIndex: firstRowIndex,
      firstRowOffset: firstRowOffset,
      horizontalScrollbarVisible: horizontalScrollbarVisible,
      maxScrollX: maxScrollX,
      maxScrollY: maxScrollY,
      reservedHeight: totalHeightReserved,
      scrollContentHeight: scrollContentHeight,
      scrollX: scrollX,
      scrollY: scrollY,
      // These properties may overwrite properties defined in
      // columnInfo and props
      bodyHeight: bodyHeight,
      height: height,
      cellGroupWrapperHeight: cellGroupWrapperHeight,
      groupHeaderHeight: groupHeaderHeight,
      useGroupHeader: useGroupHeader
    });

    return newState;
  },
  _selectColumnElement: function _selectColumnElement( /*string*/type, /*array*/columns) /*array*/{
    var newColumns = [];
    for (var i = 0; i < columns.length; ++i) {
      var column = columns[i];
      newColumns.push(_React2.default.cloneElement(column, {
        cell: type ? column.props[type] : column.props[CELL]
      }));
    }
    return newColumns;
  },
  _splitColumnTypes: function _splitColumnTypes( /*array*/columns) /*object*/{
    var fixedColumns = [];
    var fixedRightColumns = [];
    var scrollableColumns = [];
    for (var i = 0; i < columns.length; ++i) {
      if (columns[i].props.fixed) {
        fixedColumns.push(columns[i]);
      } else if (columns[i].props.fixedRight) {
        fixedRightColumns.push(columns[i]);
      } else {
        scrollableColumns.push(columns[i]);
      }
    }
    return {
      fixed: fixedColumns,
      fixedRight: fixedRightColumns,
      scrollable: scrollableColumns
    };
  },
  _onScroll: function _onScroll( /*number*/deltaX, /*number*/deltaY) {
    if (!this._isScrolling) {
      this._didScrollStart();
    }
    var x = this.state.scrollX;
    if (Math.abs(deltaY) > Math.abs(deltaX) && this.props.overflowY !== 'hidden') {
      var scrollState = this._scrollHelper.scrollBy(Math.round(deltaY));
      var onVerticalScroll = this.props.onVerticalScroll;
      if (onVerticalScroll ? onVerticalScroll(scrollState.position) : true) {
        var maxScrollY = Math.max(0, scrollState.contentHeight - this.state.bodyHeight);
        this.setState({
          firstRowIndex: scrollState.index,
          firstRowOffset: scrollState.offset,
          scrollY: scrollState.position,
          scrollContentHeight: scrollState.contentHeight,
          maxScrollY: maxScrollY
        });
      }
    } else if (deltaX && this.props.overflowX !== 'hidden') {
      x += deltaX;
      x = x < 0 ? 0 : x;
      x = x > this.state.maxScrollX ? this.state.maxScrollX : x;

      //NOTE (asif) This is a hacky workaround to prevent FDT from setting its internal state
      var onHorizontalScroll = this.props.onHorizontalScroll;
      if (onHorizontalScroll ? onHorizontalScroll(x) : true) {
        this.setState({
          scrollX: x
        });
      }
    }

    this._didScrollStop();
  },
  _onHorizontalScroll: function _onHorizontalScroll( /*number*/scrollPos) {
    if (scrollPos === this.state.scrollX) {
      return;
    }

    if (!this._isScrolling) {
      this._didScrollStart();
    }
    var onHorizontalScroll = this.props.onHorizontalScroll;
    if (onHorizontalScroll ? onHorizontalScroll(scrollPos) : true) {
      this.setState({
        scrollX: scrollPos
      });
    }
    this._didScrollStop();
  },
  _onVerticalScroll: function _onVerticalScroll( /*number*/scrollPos) {
    if (scrollPos === this.state.scrollY) {
      return;
    }

    if (!this._isScrolling) {
      this._didScrollStart();
    }
    var scrollState = this._scrollHelper.scrollTo(Math.round(scrollPos));

    var onVerticalScroll = this.props.onVerticalScroll;
    if (onVerticalScroll ? onVerticalScroll(scrollState.position) : true) {
      this.setState({
        firstRowIndex: scrollState.index,
        firstRowOffset: scrollState.offset,
        scrollY: scrollState.position,
        scrollContentHeight: scrollState.contentHeight
      });
      this._didScrollStop();
    }
  },
  _didScrollStart: function _didScrollStart() {
    if (this._isScrolling) {
      return;
    }

    this._isScrolling = true;
    if (this.props.onScrollStart) {
      this.props.onScrollStart(this.state.scrollX, this.state.scrollY, this.state.firstRowIndex);
    }
  },


  // We need two versions of this function, one to finish up synchronously (for
  // example, in componentWillUnmount), and a debounced version for normal
  // scroll handling.
  _didScrollStopSync: function _didScrollStopSync() {
    if (!this._isScrolling) {
      return;
    }

    this._isScrolling = false;
    this.setState({ redraw: true });
    if (this.props.onScrollEnd) {
      this.props.onScrollEnd(this.state.scrollX, this.state.scrollY, this.state.firstRowIndex);
    }
  }
});

var HorizontalScrollbar = (0, _createReactClass2.default)({
  displayName: 'HorizontalScrollbar',
  mixins: [_ReactComponentWithPureRenderMixin2.default],

  propTypes: {
    contentSize: _propTypes2.default.number.isRequired,
    offset: _propTypes2.default.number.isRequired,
    onScroll: _propTypes2.default.func.isRequired,
    position: _propTypes2.default.number.isRequired,
    size: _propTypes2.default.number.isRequired
  },

  componentWillMount: function componentWillMount() {
    this._initialRender = true;
  },
  componentDidMount: function componentDidMount() {
    this._initialRender = false;
  },
  render: function render() /*object*/{
    var outerContainerStyle = {
      height: _Scrollbar2.default.SIZE,
      width: this.props.size
    };
    var innerContainerStyle = {
      height: _Scrollbar2.default.SIZE,
      position: 'absolute',
      overflow: 'hidden',
      width: this.props.size
    };
    (0, _FixedDataTableTranslateDOMPosition2.default)(innerContainerStyle, 0, this.props.offset, this._initialRender);

    return _React2.default.createElement(
      'div',
      {
        className: (0, _joinClasses2.default)((0, _cx2.default)('fixedDataTableLayout/horizontalScrollbar'), (0, _cx2.default)('public/fixedDataTable/horizontalScrollbar')),
        style: outerContainerStyle },
      _React2.default.createElement(
        'div',
        { style: innerContainerStyle },
        _React2.default.createElement(_Scrollbar2.default, _extends({}, this.props, {
          isOpaque: true,
          orientation: 'horizontal',
          offset: undefined
        }))
      )
    );
  }
});

module.exports = FixedDataTable;

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(80);

var emptyObject = __webpack_require__(302);
var _invariant = __webpack_require__(60);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(60);
var ReactPropTypesSecret = __webpack_require__(2630);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule normalizeWheel
 * @typechecks
 */



var _UserAgent_DEPRECATED = __webpack_require__(2632);

var _UserAgent_DEPRECATED2 = _interopRequireDefault(_UserAgent_DEPRECATED);

var _isEventSupported = __webpack_require__(2633);

var _isEventSupported2 = _interopRequireDefault(_isEventSupported);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Reasonable defaults
var PIXEL_STEP = 10;
var LINE_HEIGHT = 40;
var PAGE_HEIGHT = 800;

/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */
function normalizeWheel( /*object*/event) /*object*/{
  var sX = 0,
      sY = 0,
      // spinX, spinY
  pX = 0,
      pY = 0; // pixelX, pixelY

  // Legacy
  if ('detail' in event) {
    sY = event.detail;
  }
  if ('wheelDelta' in event) {
    sY = -event.wheelDelta / 120;
  }
  if ('wheelDeltaY' in event) {
    sY = -event.wheelDeltaY / 120;
  }
  if ('wheelDeltaX' in event) {
    sX = -event.wheelDeltaX / 120;
  }

  // side scrolling on FF with DOMMouseScroll
  if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) {
    pY = event.deltaY;
  }
  if ('deltaX' in event) {
    pX = event.deltaX;
  }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {
      // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {
      // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) {
    sX = pX < 1 ? -1 : 1;
  }
  if (pY && !sY) {
    sY = pY < 1 ? -1 : 1;
  }

  return { spinX: sX,
    spinY: sY,
    pixelX: pX,
    pixelY: pY };
}

/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */
normalizeWheel.getEventType = function () /*string*/{
  return _UserAgent_DEPRECATED2.default.firefox() ? 'DOMMouseScroll' : (0, _isEventSupported2.default)('wheel') ? 'wheel' : 'mousewheel';
};

module.exports = normalizeWheel;

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright Schrodinger, LLC
 *
 * @providesModule UserAgent_DEPRECATED
 */

/**
 *  Provides entirely client-side User Agent and OS detection. You should prefer
 *  the non-deprecated UserAgent module when possible, which exposes our
 *  authoritative server-side PHP-based detection to the client.
 *
 *  Usage is straightforward:
 *
 *    if (UserAgent_DEPRECATED.ie()) {
 *      //  IE
 *    }
 *
 *  You can also do version checks:
 *
 *    if (UserAgent_DEPRECATED.ie() >= 7) {
 *      //  IE7 or better
 *    }
 *
 *  The browser functions will return NaN if the browser does not match, so
 *  you can also do version compares the other way:
 *
 *    if (UserAgent_DEPRECATED.ie() < 7) {
 *      //  IE6 or worse
 *    }
 *
 *  Note that the version is a float and may include a minor version number,
 *  so you should always use range operators to perform comparisons, not
 *  strict equality.
 *
 *  **Note:** You should **strongly** prefer capability detection to browser
 *  version detection where it's reasonable:
 *
 *    http://www.quirksmode.org/js/support.html
 *
 *  Further, we have a large number of mature wrapper functions and classes
 *  which abstract away many browser irregularities. Check the documentation,
 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
 *  another copy of "event || window.event".
 *
 */

var _populated = false;

// Browsers
var _ie, _firefox, _opera, _webkit, _chrome;

// Actual IE browser for compatibility mode
var _ie_real_version;

// Platforms
var _osx, _windows, _linux, _android;

// Architectures
var _win64;

// Devices
var _iphone, _ipad, _native;

var _mobile;

function _populate() {
  if (_populated) {
    return;
  }

  _populated = true;

  // To work around buggy JS libraries that can't handle multi-digit
  // version numbers, Opera 10's user agent string claims it's Opera
  // 9, then later includes a Version/X.Y field:
  //
  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
  var uas = navigator.userAgent;
  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
  var os = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);

  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
  _ipad = /\b(iP[ao]d)/.exec(uas);
  _android = /Android/i.exec(uas);
  _native = /FBAN\/\w+;/i.exec(uas);
  _mobile = /Mobile/i.exec(uas);

  // Note that the IE team blog would have you believe you should be checking
  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
  // from either x64 or ia64;  so ultimately, you should just check for Win64
  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
  // Windows will send 'WOW64' instead.
  _win64 = !!/Win64/.exec(uas);

  if (agent) {
    _ie = agent[1] ? parseFloat(agent[1]) : agent[5] ? parseFloat(agent[5]) : NaN;
    // IE compatibility mode
    if (_ie && document && document.documentMode) {
      _ie = document.documentMode;
    }
    // grab the "true" ie version from the trident token if available
    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;

    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
    _opera = agent[3] ? parseFloat(agent[3]) : NaN;
    _webkit = agent[4] ? parseFloat(agent[4]) : NaN;
    if (_webkit) {
      // We do not add the regexp to the above test, because it will always
      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
      // the userAgent string.
      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
    } else {
      _chrome = NaN;
    }
  } else {
    _ie = _firefox = _opera = _chrome = _webkit = NaN;
  }

  if (os) {
    if (os[1]) {
      // Detect OS X version.  If no version number matches, set _osx to true.
      // Version examples:  10, 10_6_1, 10.7
      // Parses version number as a float, taking only first two sets of
      // digits.  If only one set of digits is found, returns just the major
      // version number.
      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);

      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
    } else {
      _osx = false;
    }
    _windows = !!os[2];
    _linux = !!os[3];
  } else {
    _osx = _windows = _linux = false;
  }
}

var UserAgent_DEPRECATED = {

  /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  ie: function ie() {
    return _populate() || _ie;
  },

  /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */
  ieCompatibilityMode: function ieCompatibilityMode() {
    return _populate() || _ie_real_version > _ie;
  },

  /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */
  ie64: function ie64() {
    return UserAgent_DEPRECATED.ie() && _win64;
  },

  /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  firefox: function firefox() {
    return _populate() || _firefox;
  },

  /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  opera: function opera() {
    return _populate() || _opera;
  },

  /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  webkit: function webkit() {
    return _populate() || _webkit;
  },

  /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */
  safari: function safari() {
    return UserAgent_DEPRECATED.webkit();
  },

  /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  chrome: function chrome() {
    return _populate() || _chrome;
  },

  /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */
  windows: function windows() {
    return _populate() || _windows;
  },

  /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */
  osx: function osx() {
    return _populate() || _osx;
  },

  /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */
  linux: function linux() {
    return _populate() || _linux;
  },

  /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */
  iphone: function iphone() {
    return _populate() || _iphone;
  },

  mobile: function mobile() {
    return _populate() || _iphone || _ipad || _android || _mobile;
  },

  nativeApp: function nativeApp() {
    // webviews inside of the native apps
    return _populate() || _native;
  },

  android: function android() {
    return _populate() || _android;
  },

  ipad: function ipad() {
    return _populate() || _ipad;
  }
};

module.exports = UserAgent_DEPRECATED;

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */



var _ExecutionEnvironment = __webpack_require__(1079);

var _ExecutionEnvironment2 = _interopRequireDefault(_ExecutionEnvironment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useHasFeature;
if (_ExecutionEnvironment2.default.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!_ExecutionEnvironment2.default.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule nativeRequestAnimationFrame
 */

var nativeRequestAnimationFrame = global.requestAnimationFrame || global.webkitRequestAnimationFrame || global.mozRequestAnimationFrame || global.oRequestAnimationFrame || global.msRequestAnimationFrame;

module.exports = nativeRequestAnimationFrame;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * This is utility that handles touch events and calls provided touch
 * callback with correct frame rate.
 * Deceleration logic based on http://ariya.ofilabs.com/2013/11/javascript-kinetic-scrolling-part-2.html
 *
 * @providesModule ReactTouchHandler
 * @typechecks
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _emptyFunction = __webpack_require__(207);

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _requestAnimationFramePolyfill = __webpack_require__(571);

var _requestAnimationFramePolyfill2 = _interopRequireDefault(_requestAnimationFramePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MOVE_AMPLITUDE = 1.6;
var DECELERATION_AMPLITUDE = 1.6;
var DECELERATION_FACTOR = 325;
var TRACKER_TIMEOUT = 100;

var ReactTouchHandler = function () {
  /**
   * onTouchScroll is the callback that will be called with right frame rate if
   * any touch events happened
   * onTouchScroll should is to be called with two arguments: deltaX and deltaY in
   * this order
   */
  function ReactTouchHandler(
  /*function*/onTouchScroll,
  /*boolean|function*/handleScrollX,
  /*boolean|function*/handleScrollY,
  /*?boolean|?function*/stopPropagation) {
    _classCallCheck(this, ReactTouchHandler);

    // The animation frame id for the drag scroll
    this._dragAnimationId = null;

    // The interval id for tracking the drag velocity
    this._trackerId = null;

    // Used to track the drag scroll delta while waiting for an animation frame
    this._deltaX = 0;
    this._deltaY = 0;

    // The last touch we processed while dragging.  Used to compute the delta and velocity above
    this._lastTouchX = 0;
    this._lastTouchY = 0;

    // Used to track a moving average of the scroll velocity while dragging
    this._velocityX = 0;
    this._velocityY = 0;

    // An accummulated drag scroll delta used to calculate velocity
    this._accumulatedDeltaX = 0;
    this._accumulatedDeltaY = 0;

    // Timestamp from the last interval frame we used to track velocity
    this._lastFrameTimestamp = Date.now();

    // Timestamp from the last animation frame we used to autoscroll after drag stop
    this._autoScrollTimestamp = Date.now();

    if (typeof handleScrollX !== 'function') {
      handleScrollX = handleScrollX ? _emptyFunction2.default.thatReturnsTrue : _emptyFunction2.default.thatReturnsFalse;
    }

    if (typeof handleScrollY !== 'function') {
      handleScrollY = handleScrollY ? _emptyFunction2.default.thatReturnsTrue : _emptyFunction2.default.thatReturnsFalse;
    }

    // TODO (jordan) Is configuring this necessary
    if (typeof stopPropagation !== 'function') {
      stopPropagation = stopPropagation ? _emptyFunction2.default.thatReturnsTrue : _emptyFunction2.default.thatReturnsFalse;
    }

    this._handleScrollX = handleScrollX;
    this._handleScrollY = handleScrollY;
    this._stopPropagation = stopPropagation;
    this._onTouchScrollCallback = onTouchScroll;

    this._didTouchMove = this._didTouchMove.bind(this);
    this._track = this._track.bind(this);
    this._autoScroll = this._autoScroll.bind(this);
    this._startAutoScroll = this._startAutoScroll.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchCancel = this.onTouchCancel.bind(this);
  }

  _createClass(ReactTouchHandler, [{
    key: 'onTouchStart',
    value: function onTouchStart( /*object*/event) {
      // Start tracking drag delta for scrolling
      this._lastTouchX = event.touches[0].pageX;
      this._lastTouchY = event.touches[0].pageY;

      // Reset our velocity and intermediate data used to compute velocity
      this._velocityX = 0;
      this._velocityY = 0;
      this._accumulatedDeltaX = 0;
      this._accumulatedDeltaY = 0;
      this._lastFrameTimestamp = Date.now();

      // Setup interval for tracking velocity
      clearInterval(this._trackerId);
      this._trackerId = setInterval(this._track, TRACKER_TIMEOUT);

      if (this._stopPropagation()) {
        event.stopPropagation();
      }
    }
  }, {
    key: 'onTouchEnd',
    value: function onTouchEnd( /*object*/event) {

      // Stop tracking velocity
      clearInterval(this._trackerId);
      this._trackerId = null;

      // Initialize decelerating autoscroll on drag stop
      (0, _requestAnimationFramePolyfill2.default)(this._startAutoScroll);

      if (this._stopPropagation()) {
        event.stopPropagation();
      }
    }
  }, {
    key: 'onTouchCancel',
    value: function onTouchCancel( /*object*/event) {

      // Stop tracking velocity
      clearInterval(this._trackerId);
      this._trackerId = null;

      if (this._stopPropagation()) {
        event.stopPropagation();
      }
    }
  }, {
    key: 'onTouchMove',
    value: function onTouchMove( /*object*/event) {
      var moveX = event.touches[0].pageX;
      var moveY = event.touches[0].pageY;

      // Compute delta scrolled since last drag
      // Mobile, scrolling is inverted
      this._deltaX = MOVE_AMPLITUDE * (this._lastTouchX - moveX);
      this._deltaY = MOVE_AMPLITUDE * (this._lastTouchY - moveY);

      var handleScrollX = this._handleScrollX(this._deltaX, this._deltaY);
      var handleScrollY = this._handleScrollY(this._deltaY, this._deltaX);
      if (!handleScrollX && !handleScrollY) {
        return;
      }

      // If we can handle scroll update last touch for computing delta
      if (handleScrollX) {
        this._lastTouchX = moveX;
      } else {
        this._deltaX = 0;
      }
      if (handleScrollY) {
        this._lastTouchY = moveY;
      } else {
        this._deltaY = 0;
      }

      event.preventDefault();

      // Ensure minimum delta magnitude is met to avoid jitter
      var changed = false;
      if (Math.abs(this._deltaX) > 2 || Math.abs(this._deltaY) > 2) {
        if (this._stopPropagation()) {
          event.stopPropagation();
        }
        changed = true;
      }

      // Request animation frame to trigger scroll of computed delta
      if (changed === true && this._dragAnimationId === null) {
        this._dragAnimationId = (0, _requestAnimationFramePolyfill2.default)(this._didTouchMove);
      }
    }

    /**
     * Fire scroll callback based on computed drag delta.
     * Also track accummulated delta so we can calculate velocity
     */

  }, {
    key: '_didTouchMove',
    value: function _didTouchMove() {
      this._dragAnimationId = null;

      this._onTouchScrollCallback(this._deltaX, this._deltaY);
      this._accumulatedDeltaX += this._deltaX;
      this._accumulatedDeltaY += this._deltaY;
      this._deltaX = 0;
      this._deltaY = 0;
    }

    /**
     * Compute velocity based on a weighted average of drag over last 100 ms and
     * previous velocity.  Combining into a moving average results in a smoother scroll.
     */

  }, {
    key: '_track',
    value: function _track() {
      var now = Date.now();
      var elapsed = now - this._lastFrameTimestamp;
      var oldVelocityX = this._velocityX;
      var oldVelocityY = this._velocityY;

      // We compute velocity using a weighted average of the current velocity and the previous velocity
      // If the previous velocity is 0, put the full weight on the last 100 ms
      var weight = 0.8;
      if (elapsed < TRACKER_TIMEOUT) {
        weight *= elapsed / TRACKER_TIMEOUT;
      }
      if (oldVelocityX === 0 && oldVelocityY === 0) {
        weight = 1;
      }

      // Formula for computing weighted average of velocity
      this._velocityX = weight * (TRACKER_TIMEOUT * this._accumulatedDeltaX / (1 + elapsed));
      if (weight < 1) {
        this._velocityX += (1 - weight) * oldVelocityX;
      }

      this._velocityY = weight * (TRACKER_TIMEOUT * this._accumulatedDeltaY / (1 + elapsed));
      if (weight < 1) {
        this._velocityY += (1 - weight) * oldVelocityY;
      }

      this._accumulatedDeltaX = 0;
      this._accumulatedDeltaY = 0;
      this._lastFrameTimestamp = now;
    }

    /**
     * To kick off deceleration / momentum scrolling,
     * handle any scrolling from a drag which was waiting for an animation frame
     * Then update our velocity
     * Finally start the momentum scrolling handler (autoScroll)
     */

  }, {
    key: '_startAutoScroll',
    value: function _startAutoScroll() {
      this._autoScrollTimestamp = Date.now();
      if (this._deltaX > 0 || this.deltaY > 0) {
        this._didTouchMove();
      }
      this._track();
      this._autoScroll();
    }

    /**
     * Compute a scroll delta with an exponential decay based on time elapsed since drag was released.
     * This is called recursively on animation frames until the delta is below a threshold (5 pixels)
     */

  }, {
    key: '_autoScroll',
    value: function _autoScroll() {
      var elapsed = Date.now() - this._autoScrollTimestamp;
      var factor = DECELERATION_AMPLITUDE * Math.exp(-elapsed / DECELERATION_FACTOR);
      var deltaX = factor * this._velocityX;
      var deltaY = factor * this._velocityY;

      if (Math.abs(deltaX) <= 5 || !this._handleScrollX(deltaX, deltaY)) {
        deltaX = 0;
      }
      if (Math.abs(deltaY) <= 5 || !this._handleScrollY(deltaY, deltaX)) {
        deltaY = 0;
      }

      if (deltaX !== 0 || deltaY !== 0) {
        this._onTouchScrollCallback(deltaX, deltaY);
        (0, _requestAnimationFramePolyfill2.default)(this._autoScroll);
      }
    }
  }]);

  return ReactTouchHandler;
}();

module.exports = ReactTouchHandler;

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _DOMMouseMoveTracker = __webpack_require__(572);

var _DOMMouseMoveTracker2 = _interopRequireDefault(_DOMMouseMoveTracker);

var _Keys = __webpack_require__(2639);

var _Keys2 = _interopRequireDefault(_Keys);

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _createReactClass = __webpack_require__(206);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReactDOM = __webpack_require__(2640);

var _ReactDOM2 = _interopRequireDefault(_ReactDOM);

var _ReactComponentWithPureRenderMixin = __webpack_require__(390);

var _ReactComponentWithPureRenderMixin2 = _interopRequireDefault(_ReactComponentWithPureRenderMixin);

var _ReactWheelHandler = __webpack_require__(1078);

var _ReactWheelHandler2 = _interopRequireDefault(_ReactWheelHandler);

var _cssVar = __webpack_require__(2641);

var _cssVar2 = _interopRequireDefault(_cssVar);

var _cx = __webpack_require__(151);

var _cx2 = _interopRequireDefault(_cx);

var _emptyFunction = __webpack_require__(207);

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _FixedDataTableTranslateDOMPosition = __webpack_require__(391);

var _FixedDataTableTranslateDOMPosition2 = _interopRequireDefault(_FixedDataTableTranslateDOMPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Scrollbar
 * @typechecks
 */

var UNSCROLLABLE_STATE = {
  position: 0,
  scrollable: false
};

var FACE_MARGIN = parseInt((0, _cssVar2.default)('scrollbar-face-margin'), 10);
var FACE_MARGIN_2 = FACE_MARGIN * 2;
var FACE_SIZE_MIN = 30;
var KEYBOARD_SCROLL_AMOUNT = 40;

var _lastScrolledScrollbar = null;

var Scrollbar = (0, _createReactClass2.default)({
  displayName: 'Scrollbar',
  mixins: [_ReactComponentWithPureRenderMixin2.default],

  propTypes: {
    contentSize: _propTypes2.default.number.isRequired,
    defaultPosition: _propTypes2.default.number,
    isOpaque: _propTypes2.default.bool,
    orientation: _propTypes2.default.oneOf(['vertical', 'horizontal']),
    onScroll: _propTypes2.default.func,
    position: _propTypes2.default.number,
    size: _propTypes2.default.number.isRequired,
    trackColor: _propTypes2.default.oneOf(['gray']),
    zIndex: _propTypes2.default.number,
    verticalTop: _propTypes2.default.number
  },

  getInitialState: function getInitialState() /*object*/{
    var props = this.props;
    return this._calculateState(props.position || props.defaultPosition || 0, props.size, props.contentSize, props.orientation);
  },
  componentWillReceiveProps: function componentWillReceiveProps( /*object*/nextProps) {
    var controlledPosition = nextProps.position;
    if (controlledPosition === undefined) {
      this._setNextState(this._calculateState(this.state.position, nextProps.size, nextProps.contentSize, nextProps.orientation));
    } else {
      this._setNextState(this._calculateState(controlledPosition, nextProps.size, nextProps.contentSize, nextProps.orientation), nextProps);
    }
  },
  getDefaultProps: function getDefaultProps() /*object*/{
    return {
      defaultPosition: 0,
      isOpaque: false,
      onScroll: _emptyFunction2.default,
      orientation: 'vertical',
      zIndex: 99
    };
  },
  render: function render() /*?object*/{
    if (!this.state.scrollable) {
      return null;
    }

    var size = this.props.size;
    var mainStyle;
    var faceStyle;
    var isHorizontal = this.state.isHorizontal;
    var isVertical = !isHorizontal;
    var isActive = this.state.focused || this.state.isDragging;
    var faceSize = this.state.faceSize;
    var isOpaque = this.props.isOpaque;
    var verticalTop = this.props.verticalTop || 0;

    var mainClassName = (0, _cx2.default)({
      'ScrollbarLayout/main': true,
      'ScrollbarLayout/mainVertical': isVertical,
      'ScrollbarLayout/mainHorizontal': isHorizontal,
      'public/Scrollbar/main': true,
      'public/Scrollbar/mainOpaque': isOpaque,
      'public/Scrollbar/mainActive': isActive
    });

    var faceClassName = (0, _cx2.default)({
      'ScrollbarLayout/face': true,
      'ScrollbarLayout/faceHorizontal': isHorizontal,
      'ScrollbarLayout/faceVertical': isVertical,
      'public/Scrollbar/faceActive': isActive,
      'public/Scrollbar/face': true
    });

    var position = this.state.position * this.state.scale + FACE_MARGIN;

    if (isHorizontal) {
      mainStyle = {
        width: size
      };
      faceStyle = {
        width: faceSize - FACE_MARGIN_2
      };
      (0, _FixedDataTableTranslateDOMPosition2.default)(faceStyle, position, 0, this._initialRender);
    } else {
      mainStyle = {
        top: verticalTop,
        height: size
      };
      faceStyle = {
        height: faceSize - FACE_MARGIN_2
      };
      (0, _FixedDataTableTranslateDOMPosition2.default)(faceStyle, 0, position, this._initialRender);
    }

    mainStyle.zIndex = this.props.zIndex;

    if (this.props.trackColor === 'gray') {
      mainStyle.backgroundColor = (0, _cssVar2.default)('fbui-desktop-background-light');
    }

    return _React2.default.createElement(
      'div',
      {
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        onKeyDown: this._onKeyDown,
        onMouseDown: this._onMouseDown,
        onWheel: this._wheelHandler.onWheel,
        className: mainClassName,
        style: mainStyle,
        tabIndex: 0 },
      _React2.default.createElement('div', {
        ref: 'face',
        className: faceClassName,
        style: faceStyle
      })
    );
  },
  componentWillMount: function componentWillMount() {
    var isHorizontal = this.props.orientation === 'horizontal';
    var onWheel = isHorizontal ? this._onWheelX : this._onWheelY;

    this._wheelHandler = new _ReactWheelHandler2.default(onWheel, this._shouldHandleX, // Should hanlde horizontal scroll
    this._shouldHandleY // Should handle vertical scroll
    );
    this._initialRender = true;
  },
  componentDidMount: function componentDidMount() {
    this._mouseMoveTracker = new _DOMMouseMoveTracker2.default(this._onMouseMove, this._onMouseMoveEnd, document.documentElement);

    if (this.props.position !== undefined && this.state.position !== this.props.position) {
      this._didScroll();
    }
    this._initialRender = false;
  },
  componentWillUnmount: function componentWillUnmount() {
    this._nextState = null;
    this._mouseMoveTracker.releaseMouseMoves();
    if (_lastScrolledScrollbar === this) {
      _lastScrolledScrollbar = null;
    }
    delete this._mouseMoveTracker;
  },
  scrollBy: function scrollBy( /*number*/delta) {
    this._onWheel(delta);
  },
  _shouldHandleX: function _shouldHandleX( /*number*/delta) /*boolean*/{
    return this.props.orientation === 'horizontal' ? this._shouldHandleChange(delta) : false;
  },
  _shouldHandleY: function _shouldHandleY( /*number*/delta) /*boolean*/{
    return this.props.orientation !== 'horizontal' ? this._shouldHandleChange(delta) : false;
  },
  _shouldHandleChange: function _shouldHandleChange( /*number*/delta) /*boolean*/{
    var nextState = this._calculateState(this.state.position + delta, this.props.size, this.props.contentSize, this.props.orientation);
    return nextState.position !== this.state.position;
  },
  _calculateState: function _calculateState(
  /*number*/position,
  /*number*/size,
  /*number*/contentSize,
  /*string*/orientation) /*object*/{
    if (size < 1 || contentSize <= size) {
      return UNSCROLLABLE_STATE;
    }

    var stateKey = position + '_' + size + '_' + contentSize + '_' + orientation;
    if (this._stateKey === stateKey) {
      return this._stateForKey;
    }

    // There are two types of positions here.
    // 1) Phisical position: changed by mouse / keyboard
    // 2) Logical position: changed by props.
    // The logical position will be kept as as internal state and the `render()`
    // function will translate it into physical position to render.

    var isHorizontal = orientation === 'horizontal';
    var scale = size / contentSize;
    var faceSize = size * scale;

    if (faceSize < FACE_SIZE_MIN) {
      scale = (size - FACE_SIZE_MIN) / (contentSize - size);
      faceSize = FACE_SIZE_MIN;
    }

    var scrollable = true;
    var maxPosition = contentSize - size;

    if (position < 0) {
      position = 0;
    } else if (position > maxPosition) {
      position = maxPosition;
    }

    var isDragging = this._mouseMoveTracker ? this._mouseMoveTracker.isDragging() : false;

    // This function should only return flat values that can be compared quiclky
    // by `ReactComponentWithPureRenderMixin`.
    var state = {
      faceSize: faceSize,
      isDragging: isDragging,
      isHorizontal: isHorizontal,
      position: position,
      scale: scale,
      scrollable: scrollable
    };

    // cache the state for later use.
    this._stateKey = stateKey;
    this._stateForKey = state;
    return state;
  },
  _onWheelY: function _onWheelY( /*number*/deltaX, /*number*/deltaY) {
    this._onWheel(deltaY);
  },
  _onWheelX: function _onWheelX( /*number*/deltaX, /*number*/deltaY) {
    this._onWheel(deltaX);
  },
  _onWheel: function _onWheel( /*number*/delta) {
    var props = this.props;

    // The mouse may move faster then the animation frame does.
    // Use `requestAnimationFrame` to avoid over-updating.
    this._setNextState(this._calculateState(this.state.position + delta, props.size, props.contentSize, props.orientation));
  },
  _onMouseDown: function _onMouseDown( /*object*/event) {
    var nextState;

    if (event.target !== _ReactDOM2.default.findDOMNode(this.refs.face)) {
      // Both `offsetX` and `layerX` are non-standard DOM property but they are
      // magically available for browsers somehow.
      var nativeEvent = event.nativeEvent;
      var position = this.state.isHorizontal ? nativeEvent.offsetX || nativeEvent.layerX : nativeEvent.offsetY || nativeEvent.layerY;

      // MouseDown on the scroll-track directly, move the center of the
      // scroll-face to the mouse position.
      var props = this.props;
      position /= this.state.scale;
      nextState = this._calculateState(position - this.state.faceSize * 0.5 / this.state.scale, props.size, props.contentSize, props.orientation);
    } else {
      nextState = {};
    }

    nextState.focused = true;
    this._setNextState(nextState);

    this._mouseMoveTracker.captureMouseMoves(event);
    // Focus the node so it may receive keyboard event.
    _ReactDOM2.default.findDOMNode(this).focus();
  },
  _onMouseMove: function _onMouseMove( /*number*/deltaX, /*number*/deltaY) {
    var props = this.props;
    var delta = this.state.isHorizontal ? deltaX : deltaY;
    delta /= this.state.scale;

    this._setNextState(this._calculateState(this.state.position + delta, props.size, props.contentSize, props.orientation));
  },
  _onMouseMoveEnd: function _onMouseMoveEnd() {
    this._nextState = null;
    this._mouseMoveTracker.releaseMouseMoves();
    this.setState({ isDragging: false });
  },
  _onKeyDown: function _onKeyDown( /*object*/event) {
    var keyCode = event.keyCode;

    if (keyCode === _Keys2.default.TAB) {
      // Let focus move off the scrollbar.
      return;
    }

    var distance = KEYBOARD_SCROLL_AMOUNT;
    var direction = 0;

    if (this.state.isHorizontal) {
      switch (keyCode) {
        case _Keys2.default.HOME:
          direction = -1;
          distance = this.props.contentSize;
          break;

        case _Keys2.default.LEFT:
          direction = -1;
          break;

        case _Keys2.default.RIGHT:
          direction = 1;
          break;

        default:
          return;
      }
    }

    if (!this.state.isHorizontal) {
      switch (keyCode) {
        case _Keys2.default.SPACE:
          if (event.shiftKey) {
            direction = -1;
          } else {
            direction = 1;
          }
          break;

        case _Keys2.default.HOME:
          direction = -1;
          distance = this.props.contentSize;
          break;

        case _Keys2.default.UP:
          direction = -1;
          break;

        case _Keys2.default.DOWN:
          direction = 1;
          break;

        case _Keys2.default.PAGE_UP:
          direction = -1;
          distance = this.props.size;
          break;

        case _Keys2.default.PAGE_DOWN:
          direction = 1;
          distance = this.props.size;
          break;

        default:
          return;
      }
    }

    event.preventDefault();

    var props = this.props;
    this._setNextState(this._calculateState(this.state.position + distance * direction, props.size, props.contentSize, props.orientation));
  },
  _onFocus: function _onFocus() {
    this.setState({
      focused: true
    });
  },
  _onBlur: function _onBlur() {
    this.setState({
      focused: false
    });
  },
  _blur: function _blur() {
    var el = _ReactDOM2.default.findDOMNode(this);
    if (!el) {
      return;
    }

    try {
      this._onBlur();
      el.blur();
    } catch (oops) {
      // pass
    }
  },
  _setNextState: function _setNextState( /*object*/nextState, /*?object*/props) {
    props = props || this.props;
    var controlledPosition = props.position;
    var willScroll = this.state.position !== nextState.position;
    if (controlledPosition === undefined) {
      var callback = willScroll ? this._didScroll : undefined;
      this.setState(nextState, callback);
    } else if (controlledPosition === nextState.position) {
      this.setState(nextState);
    } else {
      // Scrolling is controlled. Don't update the state and let the owner
      // to update the scrollbar instead.
      if (nextState.position !== undefined && nextState.position !== this.state.position) {
        this.props.onScroll(nextState.position);
      }
      return;
    }

    if (willScroll && _lastScrolledScrollbar !== this) {
      _lastScrolledScrollbar && _lastScrolledScrollbar._blur();
      _lastScrolledScrollbar = this;
    }
  },
  _didScroll: function _didScroll() {
    this.props.onScroll(this.state.position);
  }
});

Scrollbar.KEYBOARD_SCROLL_AMOUNT = KEYBOARD_SCROLL_AMOUNT;
Scrollbar.SIZE = parseInt((0, _cssVar2.default)('scrollbar-size'), 10);
Scrollbar.OFFSET = 1;

module.exports = Scrollbar;

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _emptyFunction = __webpack_require__(207);

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: _emptyFunction2.default
      };
    }
  },

  registerDefault: function registerDefault() {}
}; /**
    * Copyright Schrodinger, LLC
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    *
    * @providesModule EventListener
    * @typechecks
    */

module.exports = EventListener;

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule cancelAnimationFramePolyfill
 */

/**
 * Here is the native and polyfill version of cancelAnimationFrame.
 * Please don't use it directly and use cancelAnimationFrame module instead.
 */
var cancelAnimationFrame = global.cancelAnimationFrame || global.webkitCancelAnimationFrame || global.mozCancelAnimationFrame || global.oCancelAnimationFrame || global.msCancelAnimationFrame || global.clearTimeout;

module.exports = cancelAnimationFrame;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Keys
 */

module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOM
 */

module.exports = __webpack_require__(21);

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule cssVar
 * @typechecks
 */



// If you change these, you'll need to restart the dev server for it to take effect.

var CSS_VARS = {
  'scrollbar-face-active-color': '#7d7d7d',
  'scrollbar-face-color': '#c2c2c2',
  'scrollbar-face-margin': '4px',
  'scrollbar-face-radius': '6px',
  'scrollbar-size': '15px',
  'scrollbar-size-large': '17px',
  'scrollbar-track-color': '#fff',
  'border-color': '#d3d3d3',
  'fbui-white': '#fff',
  'fbui-desktop-background-light': '#f6f7f8'
};

/**
 * @param {string} name
 */
function cssVar(name) {
  if (CSS_VARS.hasOwnProperty(name)) {
    return CSS_VARS[name];
  }

  throw new Error('cssVar' + '("' + name + '"): Unexpected class transformation.');
}

cssVar.CSS_VARS = CSS_VARS;

module.exports = cssVar;

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule translateDOMPositionXY
 * @typechecks
 */



var _BrowserSupportCore = __webpack_require__(2643);

var _BrowserSupportCore2 = _interopRequireDefault(_BrowserSupportCore);

var _getVendorPrefixedName = __webpack_require__(1080);

var _getVendorPrefixedName2 = _interopRequireDefault(_getVendorPrefixedName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRANSFORM = (0, _getVendorPrefixedName2.default)('transform');
var BACKFACE_VISIBILITY = (0, _getVendorPrefixedName2.default)('backfaceVisibility');

var translateDOMPositionXY = function () {
  if (_BrowserSupportCore2.default.hasCSSTransforms()) {
    var ua = global.window ? global.window.navigator.userAgent : 'UNKNOWN';
    var isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua);
    // It appears that Safari messes up the composition order
    // of GPU-accelerated layers
    // (see bug https://bugs.webkit.org/show_bug.cgi?id=61824).
    // Use 2D translation instead.
    if (!isSafari && _BrowserSupportCore2.default.hasCSS3DTransforms()) {
      return function ( /*object*/style, /*number*/x, /*number*/y) {
        style[TRANSFORM] = 'translate3d(' + x + 'px,' + y + 'px,0)';
        style[BACKFACE_VISIBILITY] = 'hidden';
      };
    } else {
      return function ( /*object*/style, /*number*/x, /*number*/y) {
        style[TRANSFORM] = 'translate(' + x + 'px,' + y + 'px)';
      };
    }
  } else {
    return function ( /*object*/style, /*number*/x, /*number*/y) {
      style.left = x + 'px';
      style.top = y + 'px';
    };
  }
}();

module.exports = translateDOMPositionXY;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getVendorPrefixedName = __webpack_require__(1080);

var _getVendorPrefixedName2 = _interopRequireDefault(_getVendorPrefixedName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrowserSupportCore = {
  /**
   * @return {bool} True if browser supports css animations.
   */
  hasCSSAnimations: function hasCSSAnimations() {
    return !!(0, _getVendorPrefixedName2.default)('animationName');
  },

  /**
   * @return {bool} True if browser supports css transforms.
   */
  hasCSSTransforms: function hasCSSTransforms() {
    return !!(0, _getVendorPrefixedName2.default)('transform');
  },

  /**
   * @return {bool} True if browser supports css 3d transforms.
   */
  hasCSS3DTransforms: function hasCSS3DTransforms() {
    return !!(0, _getVendorPrefixedName2.default)('perspective');
  },

  /**
   * @return {bool} True if browser supports css transitions.
   */
  hasCSSTransitions: function hasCSSTransitions() {
    return !!(0, _getVendorPrefixedName2.default)('transition');
  }
}; /**
    * Copyright Schrodinger, LLC
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    *
    * @providesModule BrowserSupportCore
    */

module.exports = BrowserSupportCore;

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule camelize
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _createReactClass = __webpack_require__(206);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FixedDataTableRowBuffer = __webpack_require__(2646);

var _FixedDataTableRowBuffer2 = _interopRequireDefault(_FixedDataTableRowBuffer);

var _FixedDataTableRow = __webpack_require__(1081);

var _FixedDataTableRow2 = _interopRequireDefault(_FixedDataTableRow);

var _cx = __webpack_require__(151);

var _cx2 = _interopRequireDefault(_cx);

var _emptyFunction = __webpack_require__(207);

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _joinClasses = __webpack_require__(293);

var _joinClasses2 = _interopRequireDefault(_joinClasses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FixedDataTableBufferedRows
 * @typechecks
 */

var FixedDataTableBufferedRows = (0, _createReactClass2.default)({
  displayName: 'FixedDataTableBufferedRows',

  propTypes: {
    bufferRowCount: _propTypes2.default.number,
    isScrolling: _propTypes2.default.bool,
    defaultRowHeight: _propTypes2.default.number.isRequired,
    firstRowIndex: _propTypes2.default.number.isRequired,
    firstRowOffset: _propTypes2.default.number.isRequired,
    fixedColumns: _propTypes2.default.array.isRequired,
    fixedRightColumns: _propTypes2.default.array.isRequired,
    height: _propTypes2.default.number.isRequired,
    offsetTop: _propTypes2.default.number.isRequired,
    onRowClick: _propTypes2.default.func,
    onRowDoubleClick: _propTypes2.default.func,
    onRowMouseDown: _propTypes2.default.func,
    onRowMouseUp: _propTypes2.default.func,
    onRowMouseEnter: _propTypes2.default.func,
    onRowMouseLeave: _propTypes2.default.func,
    onRowTouchStart: _propTypes2.default.func,
    onRowTouchEnd: _propTypes2.default.func,
    onRowTouchMove: _propTypes2.default.func,
    rowClassNameGetter: _propTypes2.default.func,
    rowsCount: _propTypes2.default.number.isRequired,
    rowHeightGetter: _propTypes2.default.func,
    subRowHeight: _propTypes2.default.number,
    subRowHeightGetter: _propTypes2.default.func,
    rowExpanded: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
    rowKeyGetter: _propTypes2.default.func,
    rowPositionGetter: _propTypes2.default.func.isRequired,
    scrollLeft: _propTypes2.default.number.isRequired,
    scrollableColumns: _propTypes2.default.array.isRequired,
    showLastRowBorder: _propTypes2.default.bool,
    width: _propTypes2.default.number.isRequired
  },

  getInitialState: function getInitialState() /*object*/{
    this._rowBuffer = new _FixedDataTableRowBuffer2.default(this.props.rowsCount, this.props.defaultRowHeight, this.props.height, this._getRowHeight, this.props.bufferRowCount);
    return {
      rowsToRender: this._rowBuffer.getRows(this.props.firstRowIndex, this.props.firstRowOffset)
    };
  },
  componentWillMount: function componentWillMount() {
    this._staticRowArray = [];
    this._initialRender = true;
  },
  componentDidMount: function componentDidMount() {
    setTimeout(this._updateBuffer, 1000);
    this._initialRender = false;
  },
  componentWillReceiveProps: function componentWillReceiveProps( /*object*/nextProps) {
    if (nextProps.rowsCount !== this.props.rowsCount || nextProps.defaultRowHeight !== this.props.defaultRowHeight || nextProps.height !== this.props.height) {
      this._rowBuffer = new _FixedDataTableRowBuffer2.default(nextProps.rowsCount, nextProps.defaultRowHeight, nextProps.height, this._getRowHeight, this.props.bufferRowCount);
    }
    if (this.props.isScrolling && !nextProps.isScrolling) {
      this._updateBuffer();
    } else {
      this.setState({
        rowsToRender: this._rowBuffer.getRows(nextProps.firstRowIndex, nextProps.firstRowOffset)
      });
    }
  },
  _updateBuffer: function _updateBuffer() {
    if (this._rowBuffer) {
      this.setState({
        rowsToRender: this._rowBuffer.getRowsWithUpdatedBuffer()
      });
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate() /*boolean*/{
    // Don't add PureRenderMixin to this component please.
    return true;
  },
  componentWillUnmount: function componentWillUnmount() {
    this._rowBuffer = null;
    this._staticRowArray.length = 0;
  },
  render: function render() /*object*/{
    var props = this.props;
    var rowClassNameGetter = props.rowClassNameGetter || _emptyFunction2.default;
    var rowPositionGetter = props.rowPositionGetter;

    var rowsToRender = this.state.rowsToRender;

    //Sort the rows, we slice first to avoid changing original
    var sortedRowsToRender = rowsToRender.slice().sort(function (a, b) {
      return a - b;
    });
    var rowPositions = {};

    //Row position calculation requires that rows are calculated in order
    sortedRowsToRender.forEach(function (rowIndex) {
      rowPositions[rowIndex] = rowPositionGetter(rowIndex);
    });

    this._staticRowArray.length = rowsToRender.length;

    var baseOffsetTop = props.firstRowOffset - props.rowPositionGetter(props.firstRowIndex) + props.offsetTop;

    for (var i = 0; i < rowsToRender.length; ++i) {
      var rowIndex = rowsToRender[i];
      var currentRowHeight = this._getRowHeight(rowIndex);
      var currentSubRowHeight = this._getSubRowHeight(rowIndex);
      var rowOffsetTop = baseOffsetTop + rowPositions[rowIndex];
      var rowKey = props.rowKeyGetter ? props.rowKeyGetter(rowIndex) : i;

      var hasBottomBorder = rowIndex === props.rowsCount - 1 && props.showLastRowBorder;

      this._staticRowArray[i] = _React2.default.createElement(_FixedDataTableRow2.default, {
        key: rowKey,
        isScrolling: props.isScrolling,
        index: rowIndex,
        width: props.width,
        height: currentRowHeight,
        subRowHeight: currentSubRowHeight,
        rowExpanded: props.rowExpanded,
        scrollLeft: Math.round(props.scrollLeft),
        offsetTop: Math.round(rowOffsetTop),
        fixedColumns: props.fixedColumns,
        fixedRightColumns: props.fixedRightColumns,
        scrollableColumns: props.scrollableColumns,
        onClick: props.onRowClick,
        onDoubleClick: props.onRowDoubleClick,
        onMouseDown: props.onRowMouseDown,
        onMouseUp: props.onRowMouseUp,
        onMouseEnter: props.onRowMouseEnter,
        onMouseLeave: props.onRowMouseLeave,
        onTouchStart: props.onRowTouchStart,
        onTouchEnd: props.onRowTouchEnd,
        onTouchMove: props.onRowTouchMove,
        className: (0, _joinClasses2.default)(rowClassNameGetter(rowIndex), (0, _cx2.default)('public/fixedDataTable/bodyRow'), (0, _cx2.default)({
          'fixedDataTableLayout/hasBottomBorder': hasBottomBorder,
          'public/fixedDataTable/hasBottomBorder': hasBottomBorder
        }))
      });
    }

    return _React2.default.createElement(
      'div',
      null,
      this._staticRowArray
    );
  },
  _getRowHeight: function _getRowHeight( /*number*/index) /*number*/{
    return this.props.rowHeightGetter ? this.props.rowHeightGetter(index) : this.props.defaultRowHeight;
  },
  _getSubRowHeight: function _getSubRowHeight( /*number*/index) /*number*/{
    return this.props.subRowHeightGetter ? this.props.subRowHeightGetter(index) : this.props.subRowHeight;
  }
});

module.exports = FixedDataTableBufferedRows;

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FixedDataTableRowBuffer
 * @typechecks
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _IntegerBufferSet = __webpack_require__(2647);

var _IntegerBufferSet2 = _interopRequireDefault(_IntegerBufferSet);

var _clamp = __webpack_require__(392);

var _clamp2 = _interopRequireDefault(_clamp);

var _invariant = __webpack_require__(292);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MIN_BUFFER_ROWS = 3;
var MAX_BUFFER_ROWS = 6;

// FixedDataTableRowBuffer is a helper class that executes row buffering
// logic for FixedDataTable. It figures out which rows should be rendered
// and in which positions.

var FixedDataTableRowBuffer = function () {
  function FixedDataTableRowBuffer(
  /*number*/rowsCount,
  /*number*/defaultRowHeight,
  /*number*/viewportHeight,
  /*?function*/rowHeightGetter,
  /*?number*/bufferRowCount) {
    _classCallCheck(this, FixedDataTableRowBuffer);

    (0, _invariant2.default)(defaultRowHeight !== 0, "defaultRowHeight musn't be equal 0 in FixedDataTableRowBuffer");

    this._bufferSet = new _IntegerBufferSet2.default();
    this._defaultRowHeight = defaultRowHeight;
    this._viewportRowsBegin = 0;
    this._viewportRowsEnd = 0;
    this._maxVisibleRowCount = Math.ceil(viewportHeight / defaultRowHeight) + 1;
    this._bufferRowsCount = bufferRowCount != null ? bufferRowCount : (0, _clamp2.default)(Math.floor(this._maxVisibleRowCount / 2), MIN_BUFFER_ROWS, MAX_BUFFER_ROWS);
    this._rowsCount = rowsCount;
    this._rowHeightGetter = rowHeightGetter;
    this._rows = [];
    this._viewportHeight = viewportHeight;

    this.getRows = this.getRows.bind(this);
    this.getRowsWithUpdatedBuffer = this.getRowsWithUpdatedBuffer.bind(this);
  }

  _createClass(FixedDataTableRowBuffer, [{
    key: 'getRowsWithUpdatedBuffer',
    value: function getRowsWithUpdatedBuffer() /*array*/{
      var remainingBufferRows = 2 * this._bufferRowsCount;
      var bufferRowIndex = Math.max(this._viewportRowsBegin - this._bufferRowsCount, 0);
      while (bufferRowIndex < this._viewportRowsBegin) {
        this._addRowToBuffer(bufferRowIndex, this._viewportRowsBegin, this._viewportRowsEnd - 1);
        bufferRowIndex++;
        remainingBufferRows--;
      }
      bufferRowIndex = this._viewportRowsEnd;
      while (bufferRowIndex < this._rowsCount && remainingBufferRows > 0) {
        this._addRowToBuffer(bufferRowIndex, this._viewportRowsBegin, this._viewportRowsEnd - 1);
        bufferRowIndex++;
        remainingBufferRows--;
      }
      return this._rows;
    }
  }, {
    key: 'getRows',
    value: function getRows(
    /*number*/firstRowIndex,
    /*number*/firstRowOffset) /*array*/{
      var top = firstRowOffset;
      var totalHeight = top;
      var rowIndex = firstRowIndex;
      var endIndex = Math.min(firstRowIndex + this._maxVisibleRowCount, this._rowsCount);

      this._viewportRowsBegin = firstRowIndex;
      while (rowIndex < endIndex || totalHeight < this._viewportHeight && rowIndex < this._rowsCount) {
        this._addRowToBuffer(rowIndex, firstRowIndex, endIndex - 1);
        totalHeight += this._rowHeightGetter(rowIndex);
        ++rowIndex;
        // Store index after the last viewport row as end, to be able to
        // distinguish when there are no rows rendered in viewport
        this._viewportRowsEnd = rowIndex;
      }

      return this._rows;
    }
  }, {
    key: '_addRowToBuffer',
    value: function _addRowToBuffer(
    /*number*/rowIndex,
    /*number*/firstViewportRowIndex,
    /*number*/lastViewportRowIndex) {
      var rowPosition = this._bufferSet.getValuePosition(rowIndex);
      var viewportRowsCount = lastViewportRowIndex - firstViewportRowIndex + 1;
      var allowedRowsCount = viewportRowsCount + this._bufferRowsCount * 2;
      if (rowPosition === null && this._bufferSet.getSize() >= allowedRowsCount) {
        rowPosition = this._bufferSet.replaceFurthestValuePosition(firstViewportRowIndex, lastViewportRowIndex, rowIndex);
      }
      if (rowPosition === null) {
        // We can't reuse any of existing positions for this row. We have to
        // create new position
        rowPosition = this._bufferSet.getNewPositionForValue(rowIndex);
        this._rows[rowPosition] = rowIndex;
      } else {
        // This row already is in the table with rowPosition position or it
        // can replace row that is in that position
        this._rows[rowPosition] = rowIndex;
      }
    }
  }]);

  return FixedDataTableRowBuffer;
}();

module.exports = FixedDataTableRowBuffer;

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule IntegerBufferSet
 * @typechecks
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Heap = __webpack_require__(2648);

var _Heap2 = _interopRequireDefault(_Heap);

var _invariant = __webpack_require__(292);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Data structure that allows to store values and assign positions to them
// in a way to minimize changing positions of stored values when new ones are
// added or when some values are replaced. Stored elements are alwasy assigned
// a consecutive set of positoins startin from 0 up to count of elements less 1
// Following actions can be executed
// * get position assigned to given value (null if value is not stored)
// * create new entry for new value and get assigned position back
// * replace value that is furthest from specified value range with new value
//   and get it's position back
// All operations take amortized log(n) time where n is number of elements in
// the set.
var IntegerBufferSet = function () {
  function IntegerBufferSet() {
    _classCallCheck(this, IntegerBufferSet);

    this._valueToPositionMap = {};
    this._size = 0;
    this._smallValues = new _Heap2.default([], // Initial data in the heap
    this._smallerComparator);
    this._largeValues = new _Heap2.default([], // Initial data in the heap
    this._greaterComparator);

    this.getNewPositionForValue = this.getNewPositionForValue.bind(this);
    this.getValuePosition = this.getValuePosition.bind(this);
    this.getSize = this.getSize.bind(this);
    this.replaceFurthestValuePosition = this.replaceFurthestValuePosition.bind(this);
  }

  _createClass(IntegerBufferSet, [{
    key: 'getSize',
    value: function getSize() /*number*/{
      return this._size;
    }
  }, {
    key: 'getValuePosition',
    value: function getValuePosition( /*number*/value) /*?number*/{
      if (this._valueToPositionMap[value] === undefined) {
        return null;
      }
      return this._valueToPositionMap[value];
    }
  }, {
    key: 'getNewPositionForValue',
    value: function getNewPositionForValue( /*number*/value) /*number*/{
      (0, _invariant2.default)(this._valueToPositionMap[value] === undefined, "Shouldn't try to find new position for value already stored in BufferSet");
      var newPosition = this._size;
      this._size++;
      this._pushToHeaps(newPosition, value);
      this._valueToPositionMap[value] = newPosition;
      return newPosition;
    }
  }, {
    key: 'replaceFurthestValuePosition',
    value: function replaceFurthestValuePosition(
    /*number*/lowValue,
    /*number*/highValue,
    /*number*/newValue) /*?number*/{
      (0, _invariant2.default)(this._valueToPositionMap[newValue] === undefined, "Shouldn't try to replace values with value already stored value in " + "BufferSet");

      this._cleanHeaps();
      if (this._smallValues.empty() || this._largeValues.empty()) {
        // Threre are currently no values stored. We will have to create new
        // position for this value.
        return null;
      }

      var minValue = this._smallValues.peek().value;
      var maxValue = this._largeValues.peek().value;
      if (minValue >= lowValue && maxValue <= highValue) {
        // All values currently stored are necessary, we can't reuse any of them.
        return null;
      }

      var valueToReplace;
      if (lowValue - minValue > maxValue - highValue) {
        // minValue is further from provided range. We will reuse it's position.
        valueToReplace = minValue;
        this._smallValues.pop();
      } else {
        valueToReplace = maxValue;
        this._largeValues.pop();
      }
      var position = this._valueToPositionMap[valueToReplace];
      delete this._valueToPositionMap[valueToReplace];
      this._valueToPositionMap[newValue] = position;
      this._pushToHeaps(position, newValue);

      return position;
    }
  }, {
    key: '_pushToHeaps',
    value: function _pushToHeaps( /*number*/position, /*number*/value) {
      var element = {
        position: position,
        value: value
      };
      // We can reuse the same object in both heaps, because we don't mutate them
      this._smallValues.push(element);
      this._largeValues.push(element);
    }
  }, {
    key: '_cleanHeaps',
    value: function _cleanHeaps() {
      // We not usually only remove object from one heap while moving value.
      // Here we make sure that there is no stale data on top of heaps.
      this._cleanHeap(this._smallValues);
      this._cleanHeap(this._largeValues);
      var minHeapSize = Math.min(this._smallValues.size(), this._largeValues.size());
      var maxHeapSize = Math.max(this._smallValues.size(), this._largeValues.size());
      if (maxHeapSize > 10 * minHeapSize) {
        // There are many old values in one of heaps. We nned to get rid of them
        // to not use too avoid memory leaks
        this._recreateHeaps();
      }
    }
  }, {
    key: '_recreateHeaps',
    value: function _recreateHeaps() {
      var sourceHeap = this._smallValues.size() < this._largeValues.size() ? this._smallValues : this._largeValues;
      var newSmallValues = new _Heap2.default([], // Initial data in the heap
      this._smallerComparator);
      var newLargeValues = new _Heap2.default([], // Initial datat in the heap
      this._greaterComparator);
      while (!sourceHeap.empty()) {
        var element = sourceHeap.pop();
        // Push all stil valid elements to new heaps
        if (this._valueToPositionMap[element.value] !== undefined) {
          newSmallValues.push(element);
          newLargeValues.push(element);
        }
      }
      this._smallValues = newSmallValues;
      this._largeValues = newLargeValues;
    }
  }, {
    key: '_cleanHeap',
    value: function _cleanHeap( /*object*/heap) {
      while (!heap.empty() && this._valueToPositionMap[heap.peek().value] === undefined) {
        heap.pop();
      }
    }
  }, {
    key: '_smallerComparator',
    value: function _smallerComparator( /*object*/lhs, /*object*/rhs) /*boolean*/{
      return lhs.value < rhs.value;
    }
  }, {
    key: '_greaterComparator',
    value: function _greaterComparator( /*object*/lhs, /*object*/rhs) /*boolean*/{
      return lhs.value > rhs.value;
    }
  }]);

  return IntegerBufferSet;
}();

module.exports = IntegerBufferSet;

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Heap
 * @typechecks
 * @preventMunge
 */



/*
 * @param {*} a
 * @param {*} b
 * @return {boolean}
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function defaultComparator(a, b) {
  return a < b;
}

var Heap = function () {
  function Heap(items, comparator) {
    _classCallCheck(this, Heap);

    this._items = items || [];
    this._size = this._items.length;
    this._comparator = comparator || defaultComparator;
    this._heapify();
  }

  /*
   * @return {boolean}
   */


  _createClass(Heap, [{
    key: 'empty',
    value: function empty() {
      return this._size === 0;
    }

    /*
     * @return {*}
     */

  }, {
    key: 'pop',
    value: function pop() {
      if (this._size === 0) {
        return;
      }

      var elt = this._items[0];

      var lastElt = this._items.pop();
      this._size--;

      if (this._size > 0) {
        this._items[0] = lastElt;
        this._sinkDown(0);
      }

      return elt;
    }

    /*
     * @param {*} item
     */

  }, {
    key: 'push',
    value: function push(item) {
      this._items[this._size++] = item;
      this._bubbleUp(this._size - 1);
    }

    /*
     * @return {number}
     */

  }, {
    key: 'size',
    value: function size() {
      return this._size;
    }

    /*
     * @return {*}
     */

  }, {
    key: 'peek',
    value: function peek() {
      if (this._size === 0) {
        return;
      }

      return this._items[0];
    }
  }, {
    key: '_heapify',
    value: function _heapify() {
      for (var index = Math.floor((this._size + 1) / 2); index >= 0; index--) {
        this._sinkDown(index);
      }
    }

    /*
     * @parent {number} index
     */

  }, {
    key: '_bubbleUp',
    value: function _bubbleUp(index) {
      var elt = this._items[index];
      while (index > 0) {
        var parentIndex = Math.floor((index + 1) / 2) - 1;
        var parentElt = this._items[parentIndex];

        // if parentElt < elt, stop
        if (this._comparator(parentElt, elt)) {
          return;
        }

        // swap
        this._items[parentIndex] = elt;
        this._items[index] = parentElt;
        index = parentIndex;
      }
    }

    /*
     * @parent {number} index
     */

  }, {
    key: '_sinkDown',
    value: function _sinkDown(index) {
      var elt = this._items[index];

      while (true) {
        var leftChildIndex = 2 * (index + 1) - 1;
        var rightChildIndex = 2 * (index + 1);
        var swapIndex = -1;

        if (leftChildIndex < this._size) {
          var leftChild = this._items[leftChildIndex];
          if (this._comparator(leftChild, elt)) {
            swapIndex = leftChildIndex;
          }
        }

        if (rightChildIndex < this._size) {
          var rightChild = this._items[rightChildIndex];
          if (this._comparator(rightChild, elt)) {
            if (swapIndex === -1 || this._comparator(rightChild, this._items[swapIndex])) {
              swapIndex = rightChildIndex;
            }
          }
        }

        // if we don't have a swap, stop
        if (swapIndex === -1) {
          return;
        }

        this._items[index] = this._items[swapIndex];
        this._items[swapIndex] = elt;
        index = swapIndex;
      }
    }
  }]);

  return Heap;
}();

module.exports = Heap;

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FixedDataTableCellGroup
 * @typechecks
 */



var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _FixedDataTableHelper = __webpack_require__(1082);

var _FixedDataTableHelper2 = _interopRequireDefault(_FixedDataTableHelper);

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _createReactClass = __webpack_require__(206);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FixedDataTableCell = __webpack_require__(2650);

var _FixedDataTableCell2 = _interopRequireDefault(_FixedDataTableCell);

var _cx = __webpack_require__(151);

var _cx2 = _interopRequireDefault(_cx);

var _FixedDataTableTranslateDOMPosition = __webpack_require__(391);

var _FixedDataTableTranslateDOMPosition2 = _interopRequireDefault(_FixedDataTableTranslateDOMPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DIR_SIGN = _FixedDataTableHelper2.default.DIR_SIGN;

var FixedDataTableCellGroupImpl = (0, _createReactClass2.default)({
  displayName: 'FixedDataTableCellGroupImpl',

  /**
   * PropTypes are disabled in this component, because having them on slows
   * down the FixedDataTable hugely in DEV mode. You can enable them back for
   * development, but please don't commit this component with enabled propTypes.
   */
  propTypes_DISABLED_FOR_PERFORMANCE: {

    /**
     * Array of <FixedDataTableColumn />.
     */
    columns: _propTypes2.default.array.isRequired,

    isScrolling: _propTypes2.default.bool,

    left: _propTypes2.default.number,

    onColumnResize: _propTypes2.default.func,

    onColumnReorder: _propTypes2.default.func,
    onColumnReorderMove: _propTypes2.default.func,
    onColumnReorderEnd: _propTypes2.default.func,

    height: _propTypes2.default.number.isRequired,

    /**
     * Height of fixedDataTableCellGroupLayout/cellGroupWrapper.
     */
    cellGroupWrapperHeight: _propTypes2.default.number,

    rowHeight: _propTypes2.default.number.isRequired,

    rowIndex: _propTypes2.default.number.isRequired,

    width: _propTypes2.default.number.isRequired,

    zIndex: _propTypes2.default.number.isRequired,

    touchEnabled: _propTypes2.default.bool
  },

  componentWillMount: function componentWillMount() {
    this._initialRender = true;
  },
  componentDidMount: function componentDidMount() {
    this._initialRender = false;
  },
  render: function render() /*object*/{
    var props = this.props;
    var columns = props.columns;
    var cells = new Array(columns.length);

    var contentWidth = this._getColumnsWidth(columns);

    var isColumnReordering = props.isColumnReordering && columns.reduce(function (acc, column) {
      return acc || props.columnReorderingData.columnKey === column.props.columnKey;
    }, false);

    var currentPosition = 0;
    for (var i = 0, j = columns.length; i < j; i++) {
      var columnProps = columns[i].props;
      var recycable = columnProps.allowCellsRecycling && !isColumnReordering;
      if (!recycable || currentPosition - props.left <= props.width && currentPosition - props.left + columnProps.width >= 0) {
        var key = columnProps.columnKey || 'cell_' + i;
        cells[i] = this._renderCell(props.rowIndex, props.rowHeight, columnProps, currentPosition, key, contentWidth, isColumnReordering);
      }
      currentPosition += columnProps.width;
    }
    var style = {
      height: props.height,
      position: 'absolute',
      width: contentWidth,
      zIndex: props.zIndex
    };
    (0, _FixedDataTableTranslateDOMPosition2.default)(style, -1 * DIR_SIGN * props.left, 0, this._initialRender);

    return _React2.default.createElement(
      'div',
      {
        className: (0, _cx2.default)('fixedDataTableCellGroupLayout/cellGroup'),
        style: style },
      cells
    );
  },
  _renderCell: function _renderCell(
  /*number*/rowIndex,
  /*number*/height,
  /*object*/columnProps,
  /*number*/left,
  /*string*/key,
  /*number*/columnGroupWidth,
  /*boolean*/isColumnReordering) /*object*/{

    var cellIsResizable = columnProps.isResizable && this.props.onColumnResize;
    var onColumnResize = cellIsResizable ? this.props.onColumnResize : null;

    var cellIsReorderable = columnProps.isReorderable && this.props.onColumnReorder && rowIndex === -1 && columnGroupWidth !== columnProps.width;
    var onColumnReorder = cellIsReorderable ? this.props.onColumnReorder : null;

    var className = columnProps.cellClassName;
    var pureRendering = columnProps.pureRendering || false;

    return _React2.default.createElement(_FixedDataTableCell2.default, {
      isScrolling: this.props.isScrolling,
      align: columnProps.align,
      className: className,
      height: height,
      key: key,
      maxWidth: columnProps.maxWidth,
      minWidth: columnProps.minWidth,
      touchEnabled: this.props.touchEnabled,
      onColumnResize: onColumnResize,
      onColumnReorder: onColumnReorder,
      onColumnReorderMove: this.props.onColumnReorderMove,
      onColumnReorderEnd: this.props.onColumnReorderEnd,
      isColumnReordering: isColumnReordering,
      columnReorderingData: this.props.columnReorderingData,
      rowIndex: rowIndex,
      columnKey: columnProps.columnKey,
      width: columnProps.width,
      left: left,
      cell: columnProps.cell,
      columnGroupWidth: columnGroupWidth,
      pureRendering: pureRendering
    });
  },
  _getColumnsWidth: function _getColumnsWidth( /*array*/columns) /*number*/{
    var width = 0;
    for (var i = 0; i < columns.length; ++i) {
      width += columns[i].props.width;
    }
    return width;
  }
});

var FixedDataTableCellGroup = (0, _createReactClass2.default)({
  displayName: 'FixedDataTableCellGroup',

  /**
   * PropTypes are disabled in this component, because having them on slows
   * down the FixedDataTable hugely in DEV mode. You can enable them back for
   * development, but please don't commit this component with enabled propTypes.
   */
  propTypes_DISABLED_FOR_PERFORMANCE: {
    isScrolling: _propTypes2.default.bool,
    /**
     * Height of the row.
     */
    height: _propTypes2.default.number.isRequired,

    offsetLeft: _propTypes2.default.number,

    left: _propTypes2.default.number,
    /**
     * Z-index on which the row will be displayed. Used e.g. for keeping
     * header and footer in front of other rows.
     */
    zIndex: _propTypes2.default.number.isRequired
  },

  shouldComponentUpdate: function shouldComponentUpdate( /*object*/nextProps) /*boolean*/{
    return !nextProps.isScrolling || this.props.rowIndex !== nextProps.rowIndex || this.props.left !== nextProps.left;
  },
  getDefaultProps: function getDefaultProps() /*object*/{
    return {
      left: 0,
      offsetLeft: 0
    };
  },
  render: function render() /*object*/{
    var _props = this.props,
        offsetLeft = _props.offsetLeft,
        props = _objectWithoutProperties(_props, ['offsetLeft']);

    var style = {
      height: props.cellGroupWrapperHeight || props.height,
      width: props.width
    };

    if (DIR_SIGN === 1) {
      style.left = offsetLeft;
    } else {
      style.right = offsetLeft;
    }

    var onColumnResize = props.onColumnResize ? this._onColumnResize : null;

    return _React2.default.createElement(
      'div',
      {
        style: style,
        className: (0, _cx2.default)('fixedDataTableCellGroupLayout/cellGroupWrapper') },
      _React2.default.createElement(FixedDataTableCellGroupImpl, _extends({}, props, {
        onColumnResize: onColumnResize
      }))
    );
  },
  _onColumnResize: function _onColumnResize(
  /*number*/left,
  /*number*/width,
  /*?number*/minWidth,
  /*?number*/maxWidth,
  /*string|number*/columnKey,
  /*object*/event) {
    this.props.onColumnResize && this.props.onColumnResize(this.props.offsetLeft, left - this.props.left + width, width, minWidth, maxWidth, columnKey, event);
  }
});

module.exports = FixedDataTableCellGroup;

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _FixedDataTableCellDefault = __webpack_require__(1085);

var _FixedDataTableCellDefault2 = _interopRequireDefault(_FixedDataTableCellDefault);

var _FixedDataTableColumnReorderHandle = __webpack_require__(2651);

var _FixedDataTableColumnReorderHandle2 = _interopRequireDefault(_FixedDataTableColumnReorderHandle);

var _FixedDataTableHelper = __webpack_require__(1082);

var _FixedDataTableHelper2 = _interopRequireDefault(_FixedDataTableHelper);

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _createReactClass = __webpack_require__(206);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cx = __webpack_require__(151);

var _cx2 = _interopRequireDefault(_cx);

var _joinClasses = __webpack_require__(293);

var _joinClasses2 = _interopRequireDefault(_joinClasses);

var _shallowEqual = __webpack_require__(1086);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
                                                                                                                                                                                                                              * Copyright Schrodinger, LLC
                                                                                                                                                                                                                              * All rights reserved.
                                                                                                                                                                                                                              *
                                                                                                                                                                                                                              * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                              * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                              * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                              *
                                                                                                                                                                                                                              * @providesModule FixedDataTableCell
                                                                                                                                                                                                                              * @typechecks
                                                                                                                                                                                                                              */

var DIR_SIGN = _FixedDataTableHelper2.default.DIR_SIGN;

var DEFAULT_PROPS = {
  align: 'left',
  highlighted: false
};

var FixedDataTableCell = (0, _createReactClass2.default)({
  displayName: 'FixedDataTableCell',

  /**
   * PropTypes are disabled in this component, because having them on slows
   * down the FixedDataTable hugely in DEV mode. You can enable them back for
   * development, but please don't commit this component with enabled propTypes.
   */
  propTypes_DISABLED_FOR_PERFORMANCE: {
    isScrolling: _propTypes2.default.bool,
    align: _propTypes2.default.oneOf(['left', 'center', 'right']),
    className: _propTypes2.default.string,
    highlighted: _propTypes2.default.bool,
    width: _propTypes2.default.number.isRequired,
    minWidth: _propTypes2.default.number,
    maxWidth: _propTypes2.default.number,
    height: _propTypes2.default.number.isRequired,

    cell: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.func]),

    columnKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

    /**
     * The row index that will be passed to `cellRenderer` to render.
     */
    rowIndex: _propTypes2.default.number.isRequired,

    /**
     * Callback for when resizer knob (in FixedDataTableCell) is clicked
     * to initialize resizing. Please note this is only on the cells
     * in the header.
     * @param number combinedWidth
     * @param number left
     * @param number width
     * @param number minWidth
     * @param number maxWidth
     * @param number|string columnKey
     * @param object event
     */
    onColumnResize: _propTypes2.default.func,
    onColumnReorder: _propTypes2.default.func,

    /**
     * The left offset in pixels of the cell.
     */
    left: _propTypes2.default.number,

    /**
     * Flag for enhanced performance check
     */
    pureRendering: _propTypes2.default.bool,

    /**
     * Whether touch is enabled or not.
     */
    touchEnabled: _propTypes2.default.bool
  },

  getInitialState: function getInitialState() {
    return {
      isReorderingThisColumn: false,
      displacement: 0,
      reorderingDisplacement: 0
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
    if (nextProps.isScrolling && this.props.rowIndex === nextProps.rowIndex) {
      return false;
    }

    //Performance check not enabled
    if (!nextProps.pureRendering) {
      return true;
    }

    var _props = this.props,
        oldCell = _props.cell,
        oldIsScrolling = _props.isScrolling,
        oldProps = _objectWithoutProperties(_props, ['cell', 'isScrolling']);

    var newCell = nextProps.cell,
        newIsScrolling = nextProps.isScrolling,
        newProps = _objectWithoutProperties(nextProps, ['cell', 'isScrolling']);

    if (!(0, _shallowEqual2.default)(oldProps, newProps)) {
      return true;
    }

    if (!oldCell || !newCell || oldCell.type !== newCell.type) {
      return true;
    }

    if (!(0, _shallowEqual2.default)(oldCell.props, newCell.props)) {
      return true;
    }

    return false;
  },
  componentWillReceiveProps: function componentWillReceiveProps(props) {
    var left = props.left + this.state.displacement;

    var newState = {
      isReorderingThisColumn: false
    };

    if (props.isColumnReordering) {
      var originalLeft = props.columnReorderingData.originalLeft;
      var reorderCellLeft = originalLeft + props.columnReorderingData.dragDistance;
      var farthestPossiblePoint = props.columnGroupWidth - props.columnReorderingData.columnWidth;

      // ensure the cell isn't being dragged out of the column group
      reorderCellLeft = Math.max(reorderCellLeft, 0);
      reorderCellLeft = Math.min(reorderCellLeft, farthestPossiblePoint);

      if (props.columnKey === props.columnReorderingData.columnKey) {
        newState.displacement = reorderCellLeft - props.left;
        newState.isReorderingThisColumn = true;
      } else {
        var reorderCellRight = reorderCellLeft + props.columnReorderingData.columnWidth;
        var reorderCellCenter = reorderCellLeft + props.columnReorderingData.columnWidth / 2;
        var centerOfThisColumn = left + props.width / 2;

        var cellIsBeforeOneBeingDragged = reorderCellCenter > centerOfThisColumn;
        var cellWasOriginallyBeforeOneBeingDragged = originalLeft > props.left;
        var changedPosition = false;

        var dragPoint, thisCellPoint;
        if (cellIsBeforeOneBeingDragged) {
          if (reorderCellLeft < centerOfThisColumn) {
            changedPosition = true;
            if (cellWasOriginallyBeforeOneBeingDragged) {
              newState.displacement = props.columnReorderingData.columnWidth;
            } else {
              newState.displacement = 0;
            }
          }
        } else {
          if (reorderCellRight > centerOfThisColumn) {
            changedPosition = true;
            if (cellWasOriginallyBeforeOneBeingDragged) {
              newState.displacement = 0;
            } else {
              newState.displacement = props.columnReorderingData.columnWidth * -1;
            }
          }
        }

        if (changedPosition) {
          if (cellIsBeforeOneBeingDragged) {
            if (!props.columnReorderingData.columnAfter) {
              props.columnReorderingData.columnAfter = props.columnKey;
            }
          } else {
            props.columnReorderingData.columnBefore = props.columnKey;
          }
        } else if (cellIsBeforeOneBeingDragged) {
          props.columnReorderingData.columnBefore = props.columnKey;
        } else if (!props.columnReorderingData.columnAfter) {
          props.columnReorderingData.columnAfter = props.columnKey;
        }
      }
    } else {
      newState.displacement = 0;
    }

    this.setState(newState);
  },
  getDefaultProps: function getDefaultProps() /*object*/{
    return DEFAULT_PROPS;
  },
  render: function render() /*object*/{
    var _props2 = this.props,
        height = _props2.height,
        width = _props2.width,
        columnKey = _props2.columnKey,
        props = _objectWithoutProperties(_props2, ['height', 'width', 'columnKey']);

    var style = {
      height: height,
      width: width
    };

    if (DIR_SIGN === 1) {
      style.left = props.left;
    } else {
      style.right = props.left;
    }

    if (this.state.isReorderingThisColumn) {
      style.transform = 'translateX(' + this.state.displacement + 'px) translateZ(0)';
      style.zIndex = 1;
    }

    var className = (0, _joinClasses2.default)((0, _cx2.default)({
      'fixedDataTableCellLayout/main': true,
      'fixedDataTableCellLayout/lastChild': props.lastChild,
      'fixedDataTableCellLayout/alignRight': props.align === 'right',
      'fixedDataTableCellLayout/alignCenter': props.align === 'center',
      'public/fixedDataTableCell/alignRight': props.align === 'right',
      'public/fixedDataTableCell/highlighted': props.highlighted,
      'public/fixedDataTableCell/main': true,
      'public/fixedDataTableCell/hasReorderHandle': !!props.onColumnReorder,
      'public/fixedDataTableCell/reordering': this.state.isReorderingThisColumn
    }), props.className);

    var columnResizerComponent;
    if (props.onColumnResize) {
      var columnResizerStyle = {
        height: height
      };
      columnResizerComponent = _React2.default.createElement(
        'div',
        {
          className: (0, _cx2.default)('fixedDataTableCellLayout/columnResizerContainer'),
          style: columnResizerStyle,
          onMouseDown: this._onColumnResizerMouseDown,
          onTouchStart: this.props.touchEnabled ? this._onColumnResizerMouseDown : null,
          onTouchEnd: this.props.touchEnabled ? function (e) {
            return e.stopPropagation();
          } : null,
          onTouchMove: this.props.touchEnabled ? function (e) {
            return e.stopPropagation();
          } : null },
        _React2.default.createElement('div', {
          className: (0, _joinClasses2.default)((0, _cx2.default)('fixedDataTableCellLayout/columnResizerKnob'), (0, _cx2.default)('public/fixedDataTableCell/columnResizerKnob')),
          style: columnResizerStyle
        })
      );
    }

    var columnReorderComponent;
    if (props.onColumnReorder) {
      //header row
      columnReorderComponent = _React2.default.createElement(_FixedDataTableColumnReorderHandle2.default, _extends({
        columnKey: this.columnKey,
        touchEnabled: this.props.touchEnabled,
        onMouseDown: this._onColumnReorderMouseDown,
        onTouchStart: this._onColumnReorderMouseDown,
        height: height
      }, this.props));
    }

    var cellProps = {
      columnKey: columnKey,
      height: height,
      width: width
    };

    if (props.rowIndex >= 0) {
      cellProps.rowIndex = props.rowIndex;
    }

    var content;
    if (_React2.default.isValidElement(props.cell)) {
      content = _React2.default.cloneElement(props.cell, cellProps);
    } else if (typeof props.cell === 'function') {
      content = props.cell(cellProps);
    } else {
      content = _React2.default.createElement(
        _FixedDataTableCellDefault2.default,
        cellProps,
        props.cell
      );
    }

    return _React2.default.createElement(
      'div',
      { className: className, style: style },
      columnResizerComponent,
      columnReorderComponent,
      content
    );
  },
  _onColumnResizerMouseDown: function _onColumnResizerMouseDown( /*object*/event) {
    this.props.onColumnResize(this.props.left, this.props.width, this.props.minWidth, this.props.maxWidth, this.props.columnKey, event);
    /**
     * This prevents the rows from moving around when we resize the
     * headers on touch devices.
     */
    if (this.props.touchEnabled) {
      event.stopPropagation();
    }
  },
  _onColumnReorderMouseDown: function _onColumnReorderMouseDown( /*object*/event) {
    this.props.onColumnReorder(this.props.columnKey, this.props.width, this.props.left, event);
  }
});

module.exports = FixedDataTableCell;

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _DOMMouseMoveTracker = __webpack_require__(572);

var _DOMMouseMoveTracker2 = _interopRequireDefault(_DOMMouseMoveTracker);

var _Locale = __webpack_require__(574);

var _Locale2 = _interopRequireDefault(_Locale);

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _createReactClass = __webpack_require__(206);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReactComponentWithPureRenderMixin = __webpack_require__(390);

var _ReactComponentWithPureRenderMixin2 = _interopRequireDefault(_ReactComponentWithPureRenderMixin);

var _FixedDataTableEventHelper = __webpack_require__(573);

var _FixedDataTableEventHelper2 = _interopRequireDefault(_FixedDataTableEventHelper);

var _clamp = __webpack_require__(392);

var _clamp2 = _interopRequireDefault(_clamp);

var _cx = __webpack_require__(151);

var _cx2 = _interopRequireDefault(_cx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FixedDataTableColumnReorderHandle = (0, _createReactClass2.default)({
  displayName: 'FixedDataTableColumnReorderHandle',
  mixins: [_ReactComponentWithPureRenderMixin2.default],

  propTypes: {

    /**
     * When resizing is complete this is called.
     */
    onColumnReorderEnd: _propTypes2.default.func,

    /**
     * Column key for the column being reordered.
     */
    columnKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

    /**
     * Whether the reorder handle should respond to touch events or not.
     */
    touchEnabled: _propTypes2.default.bool
  },

  getInitialState: function getInitialState() /*object*/{
    return {
      dragDistance: 0
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps( /*object*/newProps) {},
  componentWillUnmount: function componentWillUnmount() {
    if (this._mouseMoveTracker) {
      cancelAnimationFrame(this.frameId);
      this.frameId = null;
      this._mouseMoveTracker.releaseMouseMoves();
      this._mouseMoveTracker = null;
    }
  },
  render: function render() /*object*/{
    var style = {
      height: this.props.height
    };
    return _React2.default.createElement('div', {
      className: (0, _cx2.default)({
        'fixedDataTableCellLayout/columnReorderContainer': true,
        'fixedDataTableCellLayout/columnReorderContainer/active': false
      }),
      onMouseDown: this.onMouseDown,
      onTouchStart: this.props.touchEnabled ? this.onMouseDown : null,
      onTouchEnd: this.props.touchEnabled ? function (e) {
        return e.stopPropagation();
      } : null,
      onTouchMove: this.props.touchEnabled ? function (e) {
        return e.stopPropagation();
      } : null,
      style: style });
  },
  onMouseDown: function onMouseDown(event) {
    var targetRect = event.target.getBoundingClientRect();
    var coordinates = _FixedDataTableEventHelper2.default.getCoordinatesFromEvent(event);

    var mouseLocationInElement = coordinates.x - targetRect.offsetLeft;
    var mouseLocationInRelationToColumnGroup = mouseLocationInElement + event.target.parentElement.offsetLeft;

    this._mouseMoveTracker = new _DOMMouseMoveTracker2.default(this._onMove, this._onColumnReorderEnd, document.body, this.props.touchEnabled);
    this._mouseMoveTracker.captureMouseMoves(event);
    this.setState({
      dragDistance: 0
    });
    this.props.onMouseDown({
      columnKey: this.props.columnKey,
      mouseLocation: {
        dragDistance: 0,
        inElement: mouseLocationInElement,
        inColumnGroup: mouseLocationInRelationToColumnGroup
      }
    });

    this._distance = 0;
    this._animating = true;
    this.frameId = requestAnimationFrame(this._updateState);

    /**
     * This prevents the rows from moving around when we drag the
     * headers on touch devices.
     */
    if (this.props.touchEnabled) {
      event.stopPropagation();
    }
  },
  _onMove: function _onMove( /*number*/deltaX) {
    this._distance = this.state.dragDistance + deltaX;
  },
  _onColumnReorderEnd: function _onColumnReorderEnd( /*boolean*/cancelReorder) {
    this._animating = false;
    cancelAnimationFrame(this.frameId);
    this.frameId = null;
    this._mouseMoveTracker.releaseMouseMoves();
    this.props.columnReorderingData.cancelReorder = cancelReorder;
    this.props.onColumnReorderEnd();
  },
  _updateState: function _updateState() {
    if (this._animating) {
      this.frameId = requestAnimationFrame(this._updateState);
    }
    this.setState({
      dragDistance: this._distance
    });
    this.props.onColumnReorderMove(this._distance);
  }
}); /**
     * Copyright Schrodinger, LLC
     * All rights reserved.
     *
     * This source code is licensed under the BSD-style license found in the
     * LICENSE file in the root directory of this source tree. An additional grant
     * of patent rights can be found in the PATENTS file in the same directory.
     *
     * This is to be used with the FixedDataTable. It is a header icon
     * that allows you to reorder the corresponding column.
     *
     * @providesModule FixedDataTableColumnReorderHandle
     * @typechecks
     */

module.exports = FixedDataTableColumnReorderHandle;

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _DOMMouseMoveTracker = __webpack_require__(572);

var _DOMMouseMoveTracker2 = _interopRequireDefault(_DOMMouseMoveTracker);

var _Locale = __webpack_require__(574);

var _Locale2 = _interopRequireDefault(_Locale);

var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

var _createReactClass = __webpack_require__(206);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReactComponentWithPureRenderMixin = __webpack_require__(390);

var _ReactComponentWithPureRenderMixin2 = _interopRequireDefault(_ReactComponentWithPureRenderMixin);

var _clamp = __webpack_require__(392);

var _clamp2 = _interopRequireDefault(_clamp);

var _cx = __webpack_require__(151);

var _cx2 = _interopRequireDefault(_cx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * This is to be used with the FixedDataTable. It is a read line
 * that when you click on a column that is resizable appears and allows
 * you to resize the corresponding column.
 *
 * @providesModule FixedDataTableColumnResizeHandle
 * @typechecks
 */

var FixedDataTableColumnResizeHandle = (0, _createReactClass2.default)({
  displayName: 'FixedDataTableColumnResizeHandle',
  mixins: [_ReactComponentWithPureRenderMixin2.default],

  propTypes: {
    visible: _propTypes2.default.bool.isRequired,

    /**
     * This is the height of the line
     */
    height: _propTypes2.default.number.isRequired,

    /**
     * Offset from left border of the table, please note
     * that the line is a border on diff. So this is really the
     * offset of the column itself.
     */
    leftOffset: _propTypes2.default.number.isRequired,

    /**
     * Height of the clickable region of the line.
     * This is assumed to be at the top of the line.
     */
    knobHeight: _propTypes2.default.number.isRequired,

    /**
     * The line is a border on a diff, so this is essentially
     * the width of column.
     */
    initialWidth: _propTypes2.default.number,

    /**
     * The minimum width this dragger will collapse to
     */
    minWidth: _propTypes2.default.number,

    /**
     * The maximum width this dragger will collapse to
     */
    maxWidth: _propTypes2.default.number,

    /**
     * Initial click event on the header cell.
     */
    initialEvent: _propTypes2.default.object,

    /**
     * When resizing is complete this is called.
     */
    onColumnResizeEnd: _propTypes2.default.func,

    /**
     * Column key for the column being resized.
     */
    columnKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

    /**
     * Whether the resize handle should respond to touch events or not.
     */
    touchEnabled: _propTypes2.default.bool
  },

  getInitialState: function getInitialState() /*object*/{
    return {
      width: 0,
      cursorDelta: 0
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps( /*object*/newProps) {
    if (newProps.initialEvent && !this._mouseMoveTracker.isDragging()) {
      this._mouseMoveTracker.captureMouseMoves(newProps.initialEvent);
      this.setState({
        width: newProps.initialWidth,
        cursorDelta: newProps.initialWidth
      });
    }
  },
  componentDidMount: function componentDidMount() {
    this._mouseMoveTracker = new _DOMMouseMoveTracker2.default(this._onMove, this._onColumnResizeEnd, document.body, this.props.touchEnabled);
  },
  componentWillUnmount: function componentWillUnmount() {
    this._mouseMoveTracker.releaseMouseMoves();
    this._mouseMoveTracker = null;
  },
  render: function render() /*object*/{
    var style = {
      width: this.state.width,
      height: this.props.height
    };
    if (_Locale2.default.isRTL()) {
      style.right = this.props.leftOffset;
    } else {
      style.left = this.props.leftOffset;
    }
    return _React2.default.createElement(
      'div',
      {
        className: (0, _cx2.default)({
          'fixedDataTableColumnResizerLineLayout/main': true,
          'fixedDataTableColumnResizerLineLayout/hiddenElem': !this.props.visible,
          'public/fixedDataTableColumnResizerLine/main': true
        }),
        style: style },
      _React2.default.createElement('div', {
        className: (0, _cx2.default)('fixedDataTableColumnResizerLineLayout/mouseArea'),
        style: { height: this.props.height }
      })
    );
  },
  _onMove: function _onMove( /*number*/deltaX) {
    if (_Locale2.default.isRTL()) {
      deltaX = -deltaX;
    }
    var newWidth = this.state.cursorDelta + deltaX;
    var newColumnWidth = (0, _clamp2.default)(newWidth, this.props.minWidth, this.props.maxWidth);

    // Please note cursor delta is the different between the currently width
    // and the new width.
    this.setState({
      width: newColumnWidth,
      cursorDelta: newWidth
    });
  },
  _onColumnResizeEnd: function _onColumnResizeEnd() {
    this._mouseMoveTracker.releaseMouseMoves();
    this.props.onColumnResizeEnd(this.state.width, this.props.columnKey);
  }
});

module.exports = FixedDataTableColumnResizeHandle;

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FixedDataTableScrollHelper
 * @typechecks
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PrefixIntervalTree = __webpack_require__(2654);

var _PrefixIntervalTree2 = _interopRequireDefault(_PrefixIntervalTree);

var _clamp = __webpack_require__(392);

var _clamp2 = _interopRequireDefault(_clamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BUFFER_ROWS = 5;
var NO_ROWS_SCROLL_RESULT = {
  index: 0,
  offset: 0,
  position: 0,
  contentHeight: 0
};

var FixedDataTableScrollHelper = function () {
  function FixedDataTableScrollHelper(
  /*number*/rowCount,
  /*number*/defaultRowHeight,
  /*number*/viewportHeight,
  /*?function*/rowHeightGetter) {
    var _this = this;

    var defaultSubRowHeight = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var
    /*?function*/subRowHeightGetter = arguments[5];

    _classCallCheck(this, FixedDataTableScrollHelper);

    var defaultFullRowHeight = defaultRowHeight + defaultSubRowHeight;
    this._rowOffsets = _PrefixIntervalTree2.default.uniform(rowCount, defaultFullRowHeight);
    this._storedHeights = new Array(rowCount);
    for (var i = 0; i < rowCount; ++i) {
      this._storedHeights[i] = defaultFullRowHeight;
    }
    this._rowCount = rowCount;
    this._position = 0;
    this._contentHeight = rowCount * defaultFullRowHeight;

    this._rowHeightGetter = rowHeightGetter;
    this._subRowHeightGetter = subRowHeightGetter;
    this._fullRowHeightGetter = function (rowIdx) {
      var rowHeight = _this._rowHeightGetter ? _this._rowHeightGetter(rowIdx) : defaultRowHeight;
      var subRowHeight = _this._subRowHeightGetter ? _this._subRowHeightGetter(rowIdx) : defaultSubRowHeight;
      return rowHeight + subRowHeight;
    };
    this._viewportHeight = viewportHeight;
    this.scrollRowIntoView = this.scrollRowIntoView.bind(this);
    this.setViewportHeight = this.setViewportHeight.bind(this);
    this.scrollBy = this.scrollBy.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
    this.scrollToRow = this.scrollToRow.bind(this);
    this.setRowHeightGetter = this.setRowHeightGetter.bind(this);
    this.setSubRowHeightGetter = this.setSubRowHeightGetter.bind(this);
    this.getContentHeight = this.getContentHeight.bind(this);
    this.getRowPosition = this.getRowPosition.bind(this);

    this._updateHeightsInViewport(0, 0);
  }

  _createClass(FixedDataTableScrollHelper, [{
    key: 'setRowHeightGetter',
    value: function setRowHeightGetter( /*function*/rowHeightGetter) {
      this._rowHeightGetter = rowHeightGetter;
    }
  }, {
    key: 'setSubRowHeightGetter',
    value: function setSubRowHeightGetter( /*function*/subRowHeightGetter) {
      this._subRowHeightGetter = subRowHeightGetter;
    }
  }, {
    key: 'setViewportHeight',
    value: function setViewportHeight( /*number*/viewportHeight) {
      this._viewportHeight = viewportHeight;
    }
  }, {
    key: 'getContentHeight',
    value: function getContentHeight() /*number*/{
      return this._contentHeight;
    }
  }, {
    key: '_updateHeightsInViewport',
    value: function _updateHeightsInViewport(
    /*number*/firstRowIndex,
    /*number*/firstRowOffset) {
      var top = firstRowOffset;
      var index = firstRowIndex;
      while (top <= this._viewportHeight && index < this._rowCount) {
        this._updateRowHeight(index);
        top += this._storedHeights[index];
        index++;
      }
    }
  }, {
    key: '_updateHeightsAboveViewport',
    value: function _updateHeightsAboveViewport( /*number*/firstRowIndex) {
      var index = firstRowIndex - 1;
      while (index >= 0 && index >= firstRowIndex - BUFFER_ROWS) {
        var delta = this._updateRowHeight(index);
        this._position += delta;
        index--;
      }
    }
  }, {
    key: '_updateRowHeight',
    value: function _updateRowHeight( /*number*/rowIndex) /*number*/{
      if (rowIndex < 0 || rowIndex >= this._rowCount) {
        return 0;
      }
      var newHeight = this._fullRowHeightGetter(rowIndex);
      if (newHeight !== this._storedHeights[rowIndex]) {
        var change = newHeight - this._storedHeights[rowIndex];
        this._rowOffsets.set(rowIndex, newHeight);
        this._storedHeights[rowIndex] = newHeight;
        this._contentHeight += change;
        return change;
      }
      return 0;
    }
  }, {
    key: 'getRowPosition',
    value: function getRowPosition( /*number*/rowIndex) /*number*/{
      this._updateRowHeight(rowIndex);
      return this._rowOffsets.sumUntil(rowIndex);
    }
  }, {
    key: 'scrollBy',
    value: function scrollBy( /*number*/delta) /*object*/{
      if (this._rowCount === 0) {
        return NO_ROWS_SCROLL_RESULT;
      }
      var firstRow = this._rowOffsets.greatestLowerBound(this._position);
      firstRow = (0, _clamp2.default)(firstRow, 0, Math.max(this._rowCount - 1, 0));
      var firstRowPosition = this._rowOffsets.sumUntil(firstRow);
      var rowIndex = firstRow;
      var position = this._position;

      var rowHeightChange = this._updateRowHeight(rowIndex);
      if (firstRowPosition !== 0) {
        position += rowHeightChange;
      }
      var visibleRowHeight = this._storedHeights[rowIndex] - (position - firstRowPosition);

      if (delta >= 0) {

        while (delta > 0 && rowIndex < this._rowCount) {
          if (delta < visibleRowHeight) {
            position += delta;
            delta = 0;
          } else {
            delta -= visibleRowHeight;
            position += visibleRowHeight;
            rowIndex++;
          }
          if (rowIndex < this._rowCount) {
            this._updateRowHeight(rowIndex);
            visibleRowHeight = this._storedHeights[rowIndex];
          }
        }
      } else if (delta < 0) {
        delta = -delta;
        var invisibleRowHeight = this._storedHeights[rowIndex] - visibleRowHeight;

        while (delta > 0 && rowIndex >= 0) {
          if (delta < invisibleRowHeight) {
            position -= delta;
            delta = 0;
          } else {
            position -= invisibleRowHeight;
            delta -= invisibleRowHeight;
            rowIndex--;
          }
          if (rowIndex >= 0) {
            var change = this._updateRowHeight(rowIndex);
            invisibleRowHeight = this._storedHeights[rowIndex];
            position += change;
          }
        }
      }

      var maxPosition = this._contentHeight - this._viewportHeight;
      position = (0, _clamp2.default)(position, 0, maxPosition);
      this._position = position;
      var firstRowIndex = this._rowOffsets.greatestLowerBound(position);
      firstRowIndex = (0, _clamp2.default)(firstRowIndex, 0, Math.max(this._rowCount - 1, 0));
      firstRowPosition = this._rowOffsets.sumUntil(firstRowIndex);
      var firstRowOffset = firstRowPosition - position;

      this._updateHeightsInViewport(firstRowIndex, firstRowOffset);
      this._updateHeightsAboveViewport(firstRowIndex);

      return {
        index: firstRowIndex,
        offset: firstRowOffset,
        position: this._position,
        contentHeight: this._contentHeight
      };
    }
  }, {
    key: '_getRowAtEndPosition',
    value: function _getRowAtEndPosition( /*number*/rowIndex) /*number*/{
      // We need to update enough rows above the selected one to be sure that when
      // we scroll to selected position all rows between first shown and selected
      // one have most recent heights computed and will not resize
      this._updateRowHeight(rowIndex);
      var currentRowIndex = rowIndex;
      var top = this._storedHeights[currentRowIndex];
      while (top < this._viewportHeight && currentRowIndex >= 0) {
        currentRowIndex--;
        if (currentRowIndex >= 0) {
          this._updateRowHeight(currentRowIndex);
          top += this._storedHeights[currentRowIndex];
        }
      }
      var position = this._rowOffsets.sumTo(rowIndex) - this._viewportHeight;
      if (position < 0) {
        position = 0;
      }
      return position;
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo( /*number*/position) /*object*/{
      if (this._rowCount === 0) {
        return NO_ROWS_SCROLL_RESULT;
      }
      if (position <= 0) {
        // If position less than or equal to 0 first row should be fully visible
        // on top
        this._position = 0;
        this._updateHeightsInViewport(0, 0);

        return {
          index: 0,
          offset: 0,
          position: this._position,
          contentHeight: this._contentHeight
        };
      } else if (position >= this._contentHeight - this._viewportHeight) {
        // If position is equal to or greater than max scroll value, we need
        // to make sure to have bottom border of last row visible.
        var rowIndex = this._rowCount - 1;
        position = this._getRowAtEndPosition(rowIndex);
      }
      this._position = position;

      var firstRowIndex = this._rowOffsets.greatestLowerBound(position);
      firstRowIndex = (0, _clamp2.default)(firstRowIndex, 0, Math.max(this._rowCount - 1, 0));
      var firstRowPosition = this._rowOffsets.sumUntil(firstRowIndex);
      var firstRowOffset = firstRowPosition - position;

      this._updateHeightsInViewport(firstRowIndex, firstRowOffset);
      this._updateHeightsAboveViewport(firstRowIndex);

      return {
        index: firstRowIndex,
        offset: firstRowOffset,
        position: this._position,
        contentHeight: this._contentHeight
      };
    }

    /**
     * Allows to scroll to selected row with specified offset. It always
     * brings that row to top of viewport with that offset
     */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow( /*number*/rowIndex, /*number*/offset) /*object*/{
      rowIndex = (0, _clamp2.default)(rowIndex, 0, Math.max(this._rowCount - 1, 0));
      offset = (0, _clamp2.default)(offset, -this._storedHeights[rowIndex], 0);
      var firstRow = this._rowOffsets.sumUntil(rowIndex);
      return this.scrollTo(firstRow - offset);
    }

    /**
     * Allows to scroll to selected row by bringing it to viewport with minimal
     * scrolling. This that if row is fully visible, scroll will not be changed.
     * If top border of row is above top of viewport it will be scrolled to be
     * fully visible on the top of viewport. If the bottom border of row is
     * below end of viewport, it will be scrolled up to be fully visible on the
     * bottom of viewport.
     */

  }, {
    key: 'scrollRowIntoView',
    value: function scrollRowIntoView( /*number*/rowIndex) /*object*/{
      rowIndex = (0, _clamp2.default)(rowIndex, 0, Math.max(this._rowCount - 1, 0));
      this._updateRowHeight(rowIndex);
      var rowBegin = this._rowOffsets.sumUntil(rowIndex);
      var rowEnd = rowBegin + this._storedHeights[rowIndex];
      if (rowBegin < this._position) {
        return this.scrollTo(rowBegin);
      } else if (this._position + this._viewportHeight < rowEnd) {
        var position = this._getRowAtEndPosition(rowIndex);
        return this.scrollTo(position);
      }
      return this.scrollTo(this._position);
    }
  }]);

  return FixedDataTableScrollHelper;
}();

module.exports = FixedDataTableScrollHelper;

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule PrefixIntervalTree
 * 
 * @typechecks
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _invariant = __webpack_require__(292);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var parent = function parent(node) {
  return Math.floor(node / 2);
};

var Int32Array = global.Int32Array || function (size) {
  var xs = [];
  for (var i = size - 1; i >= 0; --i) {
    xs[i] = 0;
  }
  return xs;
};

/**
 * Computes the next power of 2 after or equal to x.
 */
function ceilLog2(x) {
  var y = 1;
  while (y < x) {
    y *= 2;
  }
  return y;
}

/**
 * A prefix interval tree stores an numeric array and the partial sums of that
 * array. It is optimized for updating the values of the array without
 * recomputing all of the partial sums.
 *
 *   - O(ln n) update
 *   - O(1) lookup
 *   - O(ln n) compute a partial sum
 *   - O(n) space
 *
 * Note that the sequence of partial sums is one longer than the array, so that
 * the first partial sum is always 0, and the last partial sum is the sum of the
 * entire array.
 */

var PrefixIntervalTree = function () {
  function PrefixIntervalTree(xs) {
    _classCallCheck(this, PrefixIntervalTree);

    /**
     * Number of elements in the array
     *
     * @type {number}
     * @private
     */
    this._size = xs.length;

    /**
     * Half the size of the heap. It is also the number of non-leaf nodes, and the
     * index of the first element in the heap. Always a power of 2.
     *
     * @type {number}
     * @private
     */
    this._half = ceilLog2(this._size);

    /**
     * Binary heap
     *
     * @type {!Array.<number>}
     * @const
     * @private
     */
    this._heap = new Int32Array(2 * this._half);

    var i;
    for (i = 0; i < this._size; ++i) {
      this._heap[this._half + i] = xs[i];
    }

    for (i = this._half - 1; i > 0; --i) {
      this._heap[i] = this._heap[2 * i] + this._heap[2 * i + 1];
    }
  }

  _createClass(PrefixIntervalTree, [{
    key: 'set',
    value: function set(index, value) {
      (0, _invariant2.default)(0 <= index && index < this._size, 'Index out of range %s', index);

      var node = this._half + index;
      this._heap[node] = value;

      node = parent(node);
      for (; node !== 0; node = parent(node)) {
        this._heap[node] = this._heap[2 * node] + this._heap[2 * node + 1];
      }
    }
  }, {
    key: 'get',
    value: function get(index) {
      (0, _invariant2.default)(0 <= index && index < this._size, 'Index out of range %s', index);

      var node = this._half + index;
      return this._heap[node];
    }
  }, {
    key: 'getSize',
    value: function getSize() {
      return this._size;
    }

    /**
     * Returns the sum get(0) + get(1) + ... + get(end - 1).
     */

  }, {
    key: 'sumUntil',
    value: function sumUntil(end) {
      (0, _invariant2.default)(0 <= end && end < this._size + 1, 'Index out of range %s', end);

      if (end === 0) {
        return 0;
      }

      var node = this._half + end - 1;
      var sum = this._heap[node];
      for (; node !== 1; node = parent(node)) {
        if (node % 2 === 1) {
          sum += this._heap[node - 1];
        }
      }

      return sum;
    }

    /**
     * Returns the sum get(0) + get(1) + ... + get(inclusiveEnd).
     */

  }, {
    key: 'sumTo',
    value: function sumTo(inclusiveEnd) {
      (0, _invariant2.default)(0 <= inclusiveEnd && inclusiveEnd < this._size, 'Index out of range %s', inclusiveEnd);
      return this.sumUntil(inclusiveEnd + 1);
    }

    /**
     * Returns the sum get(begin) + get(begin + 1) + ... + get(end - 1).
     */

  }, {
    key: 'sum',
    value: function sum(begin, end) {
      (0, _invariant2.default)(begin <= end, 'Begin must precede end');
      return this.sumUntil(end) - this.sumUntil(begin);
    }

    /**
     * Returns the smallest i such that 0 <= i <= size and sumUntil(i) <= t, or
     * -1 if no such i exists.
     */

  }, {
    key: 'greatestLowerBound',
    value: function greatestLowerBound(t) {
      if (t < 0) {
        return -1;
      }

      var node = 1;
      if (this._heap[node] <= t) {
        return this._size;
      }

      while (node < this._half) {
        var leftSum = this._heap[2 * node];
        if (t < leftSum) {
          node = 2 * node;
        } else {
          node = 2 * node + 1;
          t -= leftSum;
        }
      }

      return node - this._half;
    }

    /**
     * Returns the smallest i such that 0 <= i <= size and sumUntil(i) < t, or
     * -1 if no such i exists.
     */

  }, {
    key: 'greatestStrictLowerBound',
    value: function greatestStrictLowerBound(t) {
      if (t <= 0) {
        return -1;
      }

      var node = 1;
      if (this._heap[node] < t) {
        return this._size;
      }

      while (node < this._half) {
        var leftSum = this._heap[2 * node];
        if (t <= leftSum) {
          node = 2 * node;
        } else {
          node = 2 * node + 1;
          t -= leftSum;
        }
      }

      return node - this._half;
    }

    /**
     * Returns the smallest i such that 0 <= i <= size and t <= sumUntil(i), or
     * size + 1 if no such i exists.
     */

  }, {
    key: 'leastUpperBound',
    value: function leastUpperBound(t) {
      return this.greatestStrictLowerBound(t) + 1;
    }

    /**
     * Returns the smallest i such that 0 <= i <= size and t < sumUntil(i), or
     * size + 1 if no such i exists.
     */

  }, {
    key: 'leastStrictUpperBound',
    value: function leastStrictUpperBound(t) {
      return this.greatestLowerBound(t) + 1;
    }
  }], [{
    key: 'uniform',
    value: function uniform(size, initialValue) {
      var xs = [];
      for (var i = size - 1; i >= 0; --i) {
        xs[i] = initialValue;
      }

      return new PrefixIntervalTree(xs);
    }
  }, {
    key: 'empty',
    value: function empty(size) {
      return PrefixIntervalTree.uniform(size, 0);
    }
  }]);

  return PrefixIntervalTree;
}();

module.exports = PrefixIntervalTree;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FixedDataTableWidthHelper
 * @typechecks
 */



var _React = __webpack_require__(95);

var _React2 = _interopRequireDefault(_React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTotalWidth( /*array*/columns) /*number*/{
  var totalWidth = 0;
  for (var i = 0; i < columns.length; ++i) {
    totalWidth += columns[i].props.width;
  }
  return totalWidth;
}

function getTotalFlexGrow( /*array*/columns) /*number*/{
  var totalFlexGrow = 0;
  for (var i = 0; i < columns.length; ++i) {
    totalFlexGrow += columns[i].props.flexGrow || 0;
  }
  return totalFlexGrow;
}

function distributeFlexWidth(
/*array*/columns,
/*number*/flexWidth) /*object*/{
  if (flexWidth <= 0) {
    return {
      columns: columns,
      width: getTotalWidth(columns)
    };
  }
  var remainingFlexGrow = getTotalFlexGrow(columns);
  var remainingFlexWidth = flexWidth;
  var newColumns = [];
  var totalWidth = 0;
  for (var i = 0; i < columns.length; ++i) {
    var column = columns[i];
    if (!column.props.flexGrow) {
      totalWidth += column.props.width;
      newColumns.push(column);
      continue;
    }
    var columnFlexWidth = Math.floor(column.props.flexGrow / remainingFlexGrow * remainingFlexWidth);
    var newColumnWidth = Math.floor(column.props.width + columnFlexWidth);
    totalWidth += newColumnWidth;

    remainingFlexGrow -= column.props.flexGrow;
    remainingFlexWidth -= columnFlexWidth;

    newColumns.push(_React2.default.cloneElement(column, { width: newColumnWidth }));
  }

  return {
    columns: newColumns,
    width: totalWidth
  };
}

function adjustColumnGroupWidths(
/*array*/columnGroups,
/*number*/expectedWidth) /*object*/{
  var allColumns = [];
  var i;
  for (i = 0; i < columnGroups.length; ++i) {
    _React2.default.Children.forEach(columnGroups[i].props.children, function (column) {
      allColumns.push(column);
    });
  }
  var columnsWidth = getTotalWidth(allColumns);
  var remainingFlexGrow = getTotalFlexGrow(allColumns);
  var remainingFlexWidth = Math.max(expectedWidth - columnsWidth, 0);

  var newAllColumns = [];
  var newColumnGroups = [];

  for (i = 0; i < columnGroups.length; ++i) {
    var columnGroup = columnGroups[i];
    var currentColumns = [];

    _React2.default.Children.forEach(columnGroup.props.children, function (column) {
      currentColumns.push(column);
    });

    var columnGroupFlexGrow = getTotalFlexGrow(currentColumns);
    var columnGroupFlexWidth = Math.floor(columnGroupFlexGrow / remainingFlexGrow * remainingFlexWidth);

    var newColumnSettings = distributeFlexWidth(currentColumns, columnGroupFlexWidth);

    remainingFlexGrow -= columnGroupFlexGrow;
    remainingFlexWidth -= columnGroupFlexWidth;

    for (var j = 0; j < newColumnSettings.columns.length; ++j) {
      newAllColumns.push(newColumnSettings.columns[j]);
    }

    newColumnGroups.push(_React2.default.cloneElement(columnGroup, { width: newColumnSettings.width }));
  }

  return {
    columns: newAllColumns,
    columnGroups: newColumnGroups
  };
}

function adjustColumnWidths(
/*array*/columns,
/*number*/expectedWidth) /*array*/{
  var columnsWidth = getTotalWidth(columns);
  if (columnsWidth < expectedWidth) {
    return distributeFlexWidth(columns, expectedWidth - columnsWidth).columns;
  }
  return columns;
}

var FixedDataTableWidthHelper = {
  getTotalWidth: getTotalWidth,
  getTotalFlexGrow: getTotalFlexGrow,
  distributeFlexWidth: distributeFlexWidth,
  adjustColumnWidths: adjustColumnWidths,
  adjustColumnGroupWidths: adjustColumnGroupWidths
};

module.exports = FixedDataTableWidthHelper;

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright Schrodinger, LLC
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule debounceCore
 * @typechecks
 */

/**
 * Invokes the given callback after a specified number of milliseconds have
 * elapsed, ignoring subsequent calls.
 *
 * For example, if you wanted to update a preview after the user stops typing
 * you could do the following:
 *
 *   elem.addEventListener('keyup', debounce(this.updatePreview, 250), false);
 *
 * The returned function has a reset method which can be called to cancel a
 * pending invocation.
 *
 *   var debouncedUpdatePreview = debounce(this.updatePreview, 250);
 *   elem.addEventListener('keyup', debouncedUpdatePreview, false);
 *
 *   // later, to cancel pending calls
 *   debouncedUpdatePreview.reset();
 *
 * @param {function} func - the function to debounce
 * @param {number} wait - how long to wait in milliseconds
 * @param {*} context - optional context to invoke the function in
 * @param {?function} setTimeoutFunc - an implementation of setTimeout
 *  if nothing is passed in the default setTimeout function is used
  * @param {?function} clearTimeoutFunc - an implementation of clearTimeout
 *  if nothing is passed in the default clearTimeout function is used
 */
function debounce(func, wait, context, setTimeoutFunc, clearTimeoutFunc) {
  setTimeoutFunc = setTimeoutFunc || setTimeout;
  clearTimeoutFunc = clearTimeoutFunc || clearTimeout;
  var timeout;

  function debouncer() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    debouncer.reset();

    var callback = function callback() {
      func.apply(context, args);
    };
    callback.__SMmeta = func.__SMmeta;
    timeout = setTimeoutFunc(callback, wait);
  }

  debouncer.reset = function () {
    clearTimeoutFunc(timeout);
  };

  return debouncer;
}

module.exports = debounce;

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2658);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js?importLoaders=1!../../postcss-loader/lib/index.js!./fixed-data-table.css", function() {
			var newContent = require("!!../../css-loader/index.js?importLoaders=1!../../postcss-loader/lib/index.js!./fixed-data-table.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "/**\n * FixedDataTable v0.8.6 \n *\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n */\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule fixedDataTableCellGroupLayout\n */\n\n.fixedDataTableCellGroupLayout_cellGroup {\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  white-space: nowrap;\n}\n\n.fixedDataTableCellGroupLayout_cellGroup > .public_fixedDataTableCell_main {\n  display: inline-block;\n  vertical-align: top;\n  white-space: normal;\n}\n\n.fixedDataTableCellGroupLayout_cellGroupWrapper {\n  position: absolute;\n  top: 0;\n}\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule fixedDataTableCellLayout\n */\n\n.fixedDataTableCellLayout_main {\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-width: 0 1px 0 0;\n  box-sizing: border-box;\n  display: block;\n  overflow: hidden;\n  position: absolute;\n  white-space: normal;\n}\n\n.fixedDataTableCellLayout_lastChild {\n  border-width: 0 1px 1px 0;\n}\n\n.fixedDataTableCellLayout_alignRight {\n  text-align: right;\n}\n\n.fixedDataTableCellLayout_alignCenter {\n  text-align: center;\n}\n\n.fixedDataTableCellLayout_wrap1 {\n  display: table;\n}\n\n.fixedDataTableCellLayout_wrap2 {\n  display: table-row;\n}\n\n.fixedDataTableCellLayout_wrap3 {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.fixedDataTableCellLayout_columnResizerContainer {\n  position: absolute;\n  right: 0px;\n  width: 6px;\n  z-index: 1;\n}\n\n.fixedDataTableCellLayout_columnResizerContainer:hover {\n  cursor: ew-resize;\n}\n\n.fixedDataTableCellLayout_columnResizerContainer:hover .fixedDataTableCellLayout_columnResizerKnob {\n  visibility: visible;\n}\n\n.fixedDataTableCellLayout_columnResizerKnob {\n  position: absolute;\n  right: 0px;\n  visibility: hidden;\n  width: 4px;\n}\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule fixedDataTableColumnResizerLineLayout\n */\n\n.fixedDataTableColumnResizerLineLayout_mouseArea {\n  cursor: ew-resize;\n  position: absolute;\n  right: -5px;\n  width: 12px;\n}\n\n.fixedDataTableColumnResizerLineLayout_main {\n  border-right-style: solid;\n  border-right-width: 1px;\n  box-sizing: border-box;\n  position: absolute;\n  z-index: 10;\n}\n\nbody[dir=\"rtl\"] .fixedDataTableColumnResizerLineLayout_main {\n  /* the resizer line is in the wrong position in RTL with no easy fix.\n   * Disabling is more useful than displaying it.\n   * #167 (github) should look into this and come up with a permanent fix.\n   */\n  display: none !important;\n}\n\n.fixedDataTableColumnResizerLineLayout_hiddenElem {\n  display: none !important;\n}\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule fixedDataTableLayout\n */\n\n.fixedDataTableLayout_main {\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n}\n\n.fixedDataTableLayout_header,\n.fixedDataTableLayout_hasBottomBorder {\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n}\n\n.fixedDataTableLayout_footer .public_fixedDataTableCell_main {\n  border-top-style: solid;\n  border-top-width: 1px;\n}\n\n.fixedDataTableLayout_topShadow,\n.fixedDataTableLayout_bottomShadow {\n  height: 4px;\n  left: 0;\n  position: absolute;\n  right: 0;\n  z-index: 1;\n}\n\n.fixedDataTableLayout_bottomShadow {\n  margin-top: -4px;\n}\n\n.fixedDataTableLayout_rowsContainer {\n  overflow: hidden;\n  position: relative;\n}\n\n.fixedDataTableLayout_horizontalScrollbar {\n  bottom: 0;\n  position: absolute;\n}\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule fixedDataTableRowLayout\n */\n\n.fixedDataTableRowLayout_main {\n  box-sizing: border-box;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n}\n\n.fixedDataTableRowLayout_body {\n  left: 0;\n  position: absolute;\n  top: 0;\n}\n\n.fixedDataTableRowLayout_rowExpanded {\n  box-sizing: border-box;\n  left: 0;\n  position: absolute;\n}\n\n.fixedDataTableRowLayout_fixedColumnsDivider {\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  border-left-style: solid;\n  border-left-width: 1px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 0;\n}\n\n.fixedDataTableRowLayout_columnsShadow {\n  position: absolute;\n  width: 4px;\n}\n\n.fixedDataTableRowLayout_columnsRightShadow {\n  right: 1px;\n}\n\n.fixedDataTableRowLayout_rowWrapper {\n  position: absolute;\n  top: 0;\n}\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule ScrollbarLayout\n */\n\n.ScrollbarLayout_main {\n  box-sizing: border-box;\n  outline: none;\n  overflow: hidden;\n  position: absolute;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.ScrollbarLayout_mainVertical {\n  bottom: 0;\n  right: 0;\n  top: 0;\n  width: 15px;\n}\n\n.ScrollbarLayout_mainHorizontal {\n  bottom: 0;\n  height: 15px;\n  left: 0;\n  transition-property: background-color height;\n}\n\n/* Touching the scroll-track directly makes the scroll-track bolder */\n\n.ScrollbarLayout_mainHorizontal.public_Scrollbar_mainActive,\n.ScrollbarLayout_mainHorizontal:hover {\n  height: 17px;\n}\n\n.ScrollbarLayout_face {\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: 1;\n  transition-duration: 250ms;\n  transition-timing-function: ease;\n  transition-property: background-color width position;\n}\n\n/**\n * This selector renders the \"nub\" of the scrollface. The nub must\n * be rendered as pseudo-element so that it won't receive any UI events then\n * we can get the correct `event.offsetX` and `event.offsetY` from the\n * scrollface element while dragging it.\n */\n\n.ScrollbarLayout_face:after {\n  border-radius: 6px;\n  content: '';\n  display: block;\n  position: absolute;\n  transition: background-color 250ms ease;\n}\n\n.ScrollbarLayout_faceHorizontal {\n  bottom: 0;\n  left: 0;\n  top: 0;\n}\n\n.ScrollbarLayout_faceHorizontal:after {\n  bottom: 4px;\n  left: 0;\n  top: 4px;\n  width: 100%;\n}\n\n.ScrollbarLayout_faceHorizontal.public_Scrollbar_faceActive:after,\n.ScrollbarLayout_main:hover .ScrollbarLayout_faceHorizontal:after {\n  bottom: 2px;\n}\n\n.ScrollbarLayout_faceVertical {\n  left: 0;\n  right: 0;\n  top: 0;\n}\n\n.ScrollbarLayout_faceVertical:after {\n  height: 100%;\n  left: 4px;\n  right: 4px;\n  top: 0;\n}\n\n.ScrollbarLayout_main:hover .ScrollbarLayout_faceVertical:after,\n.ScrollbarLayout_faceVertical.public_Scrollbar_faceActive:after {\n  left: 2px;\n  right: 2px;\n}\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule fixedDataTable\n *\n */\n\n/**\n * Table.\n */\n\n.public_fixedDataTable_main {\n  border-color: #d3d3d3;\n}\n\n.public_fixedDataTable_header,\n.public_fixedDataTable_hasBottomBorder {\n  border-color: #d3d3d3;\n}\n\n.public_fixedDataTable_header .public_fixedDataTableCell_main {\n  font-weight: bold;\n}\n\n.public_fixedDataTable_header,\n.public_fixedDataTable_header .public_fixedDataTableCell_main {\n  background-color: #f6f7f8;\n  background-image: linear-gradient(#fff, #efefef);\n}\n\n.public_fixedDataTable_footer .public_fixedDataTableCell_main {\n  background-color: #f6f7f8;\n  border-color: #d3d3d3;\n}\n\n.public_fixedDataTable_topShadow {\n  background: 0 0 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAECAYAAABP2FU6AAAAF0lEQVR4AWPUkNeSBhHCjJoK2twgFisAFagCCp3pJlAAAAAASUVORK5CYII=) repeat-x;\n}\n\n.public_fixedDataTable_bottomShadow {\n  background: 0 0 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAECAYAAABP2FU6AAAAHElEQVQI12MwNjZmZdAT1+Nm0JDWEGZQk1GTBgAWkwIeAEp52AAAAABJRU5ErkJggg==) repeat-x;\n}\n\n.public_fixedDataTable_horizontalScrollbar .public_Scrollbar_mainHorizontal {\n  background-color: #fff;\n}\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule fixedDataTableCell\n */\n\n/**\n * Table cell.\n */\n\n.public_fixedDataTableCell_main {\n  background-color: #fff;\n  border-color: #d3d3d3;\n}\n\n.public_fixedDataTableCell_highlighted {\n  background-color: #f4f4f4;\n}\n\n.public_fixedDataTableCell_cellContent {\n  padding: 8px;\n}\n\n.public_fixedDataTableCell_columnResizerKnob {\n  background-color: #0284ff;\n}\n\n.public_fixedDataTableCell_hasReorderHandle .public_fixedDataTableCell_cellContent {\n\tmargin-left: 12px;\n}\n\n/**\n * Column reorder goodies.\n */\n\n.fixedDataTableCellLayout_columnReorderContainer {\n  border-color: #0284ff;\n  background-color: rgba(0, 0, 0, .1);\n  width: 12px;\n  margin-right: -12px;\n  float: left;\n  cursor: move;\n}\n\n.fixedDataTableCellLayout_columnReorderContainer:after {\n\tcontent: '::';\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 1px;\n\t-webkit-transform: translateY(-50%);\n\t        transform: translateY(-50%);\n}\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule fixedDataTableColumnResizerLine\n *\n */\n\n/**\n * Column resizer line.\n */\n\n.public_fixedDataTableColumnResizerLine_main {\n  border-color: #0284ff;\n}\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule fixedDataTableRow\n */\n\n/**\n * Table row.\n */\n\n.public_fixedDataTableRow_main {\n  background-color: #fff;\n}\n\n.public_fixedDataTableRow_highlighted,\n.public_fixedDataTableRow_highlighted .public_fixedDataTableCell_main {\n  background-color: #f6f7f8;\n}\n\n.public_fixedDataTableRow_fixedColumnsDivider {\n  border-color: #d3d3d3;\n}\n\n.public_fixedDataTableRow_columnsShadow {\n  background: 0 0 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABCAYAAAD5PA/NAAAAFklEQVQIHWPSkNeSBmJhTQVtbiDNCgASagIIuJX8OgAAAABJRU5ErkJggg==) repeat-y;\n}\n\n.public_fixedDataTableRow_columnsRightShadow {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n/**\n * Copyright Schrodinger, LLC\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n *\n * @providesModule Scrollbar\n *\n */\n\n/**\n * Scrollbars.\n */\n\n/* Touching the scroll-track directly makes the scroll-track bolder */\n\n.public_Scrollbar_main.public_Scrollbar_mainActive,\n.public_Scrollbar_main {\n  background-color: #fff;\n  border-left: 1px solid #d3d3d3;\n}\n\n.public_Scrollbar_mainOpaque,\n.public_Scrollbar_mainOpaque.public_Scrollbar_mainActive,\n.public_Scrollbar_mainOpaque:hover {\n  background-color: #fff;\n}\n\n.public_Scrollbar_face:after {\n  background-color: #c2c2c2;\n}\n\n.public_Scrollbar_main:hover .public_Scrollbar_face:after,\n.public_Scrollbar_mainActive .public_Scrollbar_face:after,\n.public_Scrollbar_faceActive:after {\n  background-color: #7d7d7d;\n}\n", ""]);

// exports


/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDashboardPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dashboardPage = __webpack_require__(2660);

var _dashboardPage2 = _interopRequireDefault(_dashboardPage);

var _button = __webpack_require__(8);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _reactHighcharts = __webpack_require__(387);

var _reactHighcharts2 = _interopRequireDefault(_reactHighcharts);

var _dashboardUserPage = __webpack_require__(2661);

var _dashboardUserPage2 = _interopRequireDefault(_dashboardUserPage);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/*
 * src/web/components/dashboard-page.jsx
 */

var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);

var SUMMARY_CHART_HEIGHT = 300;
var MEMBERS_CHART_EACH_HEIGHT = 40;
var COLORS = {
  diary: '#2f7ed8',
  kpi: '#0d233a',
  memo: '#8bbc21',
  like: '#910000',
  comment: '#1aadce',
  line1: '#492970',
  line2: '#f28f43'
};

var DashboardPage = function (_React$Component) {
  _inherits(DashboardPage, _React$Component);

  function DashboardPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DashboardPage);

    for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DashboardPage.__proto__ || Object.getPrototypeOf(DashboardPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      innerWidth: undefined,
      summary_diary: true,
      summary_kpi: true,
      summary_memo: true,
      summary_like: true,
      summary_comment: true,
      members_diary: true,
      members_kpi: true,
      members_memo: true,
      members_like: true,
      members_comment: true,
      summaryChart: undefined,
      membersChart: undefined
    }, _this.onClose = function () {
      return _this.props.updateUI({ user: undefined });
    }, _this.onMembersXAxisClick = function (event) {
      var post = _lodash2.default.find(_this.props.posts, function (_post) {
        return _post.user.user_id == parseInt(event.target.id);
      });
      if (post && post.user) {
        var newUi = { user: post.user };
        setTimeout(function () {
          return _this.props.updateUI(newUi);
        }, 0);
      }
      return false;
    }, _this.toggleSummaryChart = function (key) {
      var _newState;

      var _key = 'summary_' + key;
      var _state = Object.assign({}, _this.state, _defineProperty({}, _key, !_this.state[_key]));
      var newState = (_newState = {}, _defineProperty(_newState, _key, _state[_key]), _defineProperty(_newState, 'summaryChart', _this.generateSummaryChart(_this.props, _state)), _newState);
      setTimeout(function () {
        return _this.setState(newState);
      }, 0);
      return false;
    }, _this.toggleMembersChart = function (key) {
      var _newState2;

      var _key = 'members_' + key;
      var _state = Object.assign({}, _this.state, _defineProperty({}, _key, !_this.state[_key]));
      var newState = (_newState2 = {}, _defineProperty(_newState2, _key, _state[_key]), _defineProperty(_newState2, 'membersChart', _this.generateMembersChart(_this.props, _state)), _newState2);
      setTimeout(function () {
        return _this.setState(newState);
      }, 0);
      return false;
    }, _this.generateSummaryChart = function (props, state) {
      var t = props.t,
          summary = props.summary;

      var summaryData = (0, _dashboardPage.calcSummaryData)(summary, {
        diary: state.summary_diary,
        kpi: state.summary_kpi,
        memo: state.summary_memo,
        like: state.summary_like,
        comment: state.summary_comment
      });
      return {
        chart: {
          type: 'column',
          height: SUMMARY_CHART_HEIGHT
        },
        title: { text: undefined },
        credits: { enabled: false },
        exporting: { enbaled: false },
        plotOptions: { column: { stacking: 'normal' } },
        legend: { maxHeight: 20 },
        xAxis: {
          categories: summaryData.x_axis,
          offset: SUMMARY_CHART_HEIGHT * -0.4 + 64,
          lineWidth: 0,
          tickWidth: 0,
          minorGridLineWidth: 0,
          labels: {
            autoRotation: false,
            style: { whiteSpace: 'nowrap' }
          }
        },
        yAxis: [{
          min: 0,
          height: SUMMARY_CHART_HEIGHT * 0.6 - 20,
          reversedStacks: false,
          title: { text: t('label:投稿数') }
        }, {
          min: 0,
          height: SUMMARY_CHART_HEIGHT * 0.4 - 60,
          top: SUMMARY_CHART_HEIGHT * 0.6 + 20,
          offset: 0,
          reversed: true,
          reversedStacks: false,
          title: { text: t('label:リアクション数') }
        }, {
          min: 0,
          opposite: true,
          height: SUMMARY_CHART_HEIGHT * 0.6 - 20,
          title: { text: t('label:1人平均') }
        }, {
          min: 0,
          opposite: true,
          reversed: true,
          height: SUMMARY_CHART_HEIGHT * 0.4 - 60,
          top: SUMMARY_CHART_HEIGHT * 0.6 + 20,
          offset: 0,
          title: { text: t('label:投稿あたり') }
        }],
        series: [{
          color: COLORS.diary,
          name: t('diary:diary'),
          data: summaryData.posts_data.diary,
          stack: 'posts',
          yAxis: 0,
          events: { legendItemClick: function legendItemClick() {
              return _this.toggleSummaryChart('diary');
            } }
        }, {
          color: COLORS.kpi,
          name: t('diary:kpi'),
          data: summaryData.posts_data.kpi,
          stack: 'posts',
          yAxis: 0,
          events: { legendItemClick: function legendItemClick() {
              return _this.toggleSummaryChart('kpi');
            } }
        }, {
          color: COLORS.memo,
          name: t('diary:memo'),
          data: summaryData.posts_data.memo,
          stack: 'posts',
          yAxis: 0,
          events: { legendItemClick: function legendItemClick() {
              return _this.toggleSummaryChart('memo');
            } }
        }, {
          color: COLORS.like,
          name: t('label:いいね'),
          data: summaryData.replies_data.like,
          stack: 'replies',
          yAxis: 1,
          events: { legendItemClick: function legendItemClick() {
              return _this.toggleSummaryChart('like');
            } }
        }, {
          color: COLORS.comment,
          name: t('label:コメント'),
          data: summaryData.replies_data.comment,
          stack: 'replies',
          yAxis: 1,
          events: { legendItemClick: function legendItemClick() {
              return _this.toggleSummaryChart('comment');
            } }
        }, {
          color: COLORS.line1,
          type: 'spline',
          name: t('label:平均投稿数'),
          data: summaryData.posts_data.avg,
          yAxis: 2,
          showInLegend: false
        }, {
          color: COLORS.line2,
          type: 'spline',
          name: t('label:平均リアクション数'),
          data: summaryData.replies_data.avg,
          yAxis: 3,
          showInLegend: false
        }]
      };
    }, _this.generateMembersChart = function (props, state) {
      var t = props.t,
          posts = props.posts,
          replies = props.replies;
      var innerWidth = state.innerWidth;

      var membersData = (0, _dashboardPage.calcMembersData)(posts, replies, {
        diary: state.members_diary,
        kpi: state.members_kpi,
        memo: state.members_memo,
        like: state.members_like,
        comment: state.members_comment
      });
      return {
        chart: {
          type: 'bar',
          height: membersData.x_axis.length * MEMBERS_CHART_EACH_HEIGHT + 90
        },
        title: { text: undefined },
        credits: { enabled: false },
        exporting: { enbaled: false },
        plotOptions: {
          bar: { stacking: 'normal' },
          series: {
            cursor: 'pointer',
            events: {
              click: function click(event) {
                return _this.props.updateUI({ user: event.point.category });
              }
            }
          }
        },
        tooltip: {
          formatter: function formatter(tooltip) {
            return tooltip.defaultFormatter.call(Object.assign({}, this, { key: this.key.name }), tooltip);
          }
        },
        xAxis: {
          categories: membersData.x_axis,
          offset: innerWidth * 0.4 - 50,
          width: 0,
          opposite: true,
          lineWidth: 0,
          tickWidth: 0,
          minorGridLineWidth: 0,
          labels: {
            useHTML: true,
            autoRotation: false,
            align: 'left',
            reserveSpace: false,
            formatter: function formatter() {
              return '<span style=\'cursor: pointer; font-weight: bold;\' class=\'members-x-axis\' id=\'' + this.value.user_id + '\'>' + this.value.name + '</span>';
            }
          }
        },
        yAxis: [{
          min: 0,
          width: innerWidth * 0.6 - 30,
          left: innerWidth * 0.4 + 30,
          opposite: true,
          reversedStacks: false,
          title: { text: t('label:投稿数') }
        }, {
          min: 0,
          width: innerWidth * 0.4 - 30,
          left: 0,
          offset: 0,
          opposite: true,
          reversed: true,
          reversedStacks: false,
          title: { text: t('label:リアクション数') }
        }],
        series: [{
          color: COLORS.like,
          name: t('label:いいね'),
          data: membersData.replies_data.like,
          stack: 'replies',
          yAxis: 1,
          events: { legendItemClick: function legendItemClick() {
              return _this.toggleMembersChart('like');
            } }
        }, {
          color: COLORS.comment,
          name: t('label:コメント'),
          data: membersData.replies_data.comment,
          stack: 'replies',
          yAxis: 1,
          events: { legendItemClick: function legendItemClick() {
              return _this.toggleMembersChart('comment');
            } }
        }, {
          color: COLORS.diary,
          name: t('diary:diary'),
          data: membersData.posts_data.diary,
          stack: 'posts',
          yAxis: 0,
          events: { legendItemClick: function legendItemClick() {
              return _this.toggleMembersChart('diary');
            } }
        }, {
          color: COLORS.kpi,
          name: t('diary:kpi'),
          data: membersData.posts_data.kpi,
          stack: 'posts',
          yAxis: 0,
          events: { legendItemClick: function legendItemClick() {
              return _this.toggleMembersChart('kpi');
            } }
        }, {
          color: COLORS.memo,
          name: t('diary:memo'),
          data: membersData.posts_data.memo,
          stack: 'posts',
          yAxis: 0,
          events: { legendItemClick: function legendItemClick() {
              return _this.toggleMembersChart('memo');
            } }
        }, {
          color: COLORS.line1,
          type: 'line',
          enableMouseTracking: false,
          marker: { enabled: false },
          dashStyle: 'dot',
          name: t('label:平均投稿数'),
          data: _lodash2.default.times(membersData.x_axis.length, _lodash2.default.constant(membersData.avg_posts)),
          yAxis: 0,
          showInLegend: false
        }, {
          color: COLORS.line2,
          type: 'line',
          enableMouseTracking: false,
          marker: { enabled: false },
          dashStyle: 'dot',
          name: t('label:平均リアクション数'),
          data: _lodash2.default.times(membersData.x_axis.length, _lodash2.default.constant(membersData.avg_replies)),
          yAxis: 1,
          showInLegend: false
        }]
      };
    }, _this.prevMonth = function () {
      return _this.props.prevMonth(_this.props);
    }, _this.nextMonth = function () {
      return _this.props.nextMonth(_this.props);
    }, _this.exportUrl = function () {
      return window.open(_this.props.exportUrl(_this.props));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DashboardPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ innerWidth: _reactDom2.default.findDOMNode(this).clientWidth });
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.summary !== nextProps.summary && nextProps.summary) this.setState({ summaryChart: this.generateSummaryChart(nextProps, this.state) });
      if ((this.props.posts !== nextProps.posts || this.props.replies !== nextProps.replies) && nextProps.posts && nextProps.replies) this.setState({ membersChart: this.generateMembersChart(nextProps, this.state) });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var onMembersXAxisClick = this.onMembersXAxisClick;
      setTimeout(function () {
        var xAxisLabels = document.getElementsByClassName('members-x-axis');
        for (var i = 0; i < xAxisLabels.length; i++) {
          xAxisLabels[i].onclick = onMembersXAxisClick;
        }
      }, 100);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          group = _props.group,
          ui = _props.ui,
          isFetching = _props.isFetching,
          summary = _props.summary,
          posts = _props.posts,
          replies = _props.replies,
          exportUrl = _props.exportUrl,
          isShowTimeStamp = _props.isShowTimeStamp;

      var endDate = ui.startDate.clone().endOf('month');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _rightSidePage2.default,
          { title: t('label:インサイト'), icon: 'insights',
            rightAction: _react2.default.createElement(_button.IconButton, { icon: 'cloud_download', key: 'icon', onClick: this.exportUrl }) },
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'strong',
              null,
              t('label:月次提出推移')
            )
          ),
          this.state.summaryChart && _react2.default.createElement(_reactHighcharts2.default, { config: this.state.summaryChart, isPureConfig: true }),
          isFetching && !this.state.summaryChart && _react2.default.createElement(
            'div',
            { style: { height: SUMMARY_CHART_HEIGHT, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
            _react2.default.createElement(_progress_bar2.default, { type: 'circular', multicolor: true, mode: 'indeterminate' })
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10, paddingTop: 10 } },
            _react2.default.createElement(
              'strong',
              null,
              t('label:日報提出状況')
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between' } },
            _react2.default.createElement(_button.Button, { icon: 'navigate_before', onClick: this.prevMonth }),
            _react2.default.createElement(
              'span',
              null,
              ui.startDate.format(t('format:month'))
            ),
            _react2.default.createElement(_button.Button, { icon: 'navigate_next', onClick: this.nextMonth, disabled: endDate.isAfter((0, _moment2.default)()) })
          ),
          this.state.membersChart && _react2.default.createElement(_reactHighcharts2.default, { config: this.state.membersChart, isPureConfig: true }),
          isFetching && !this.state.membersChart && _react2.default.createElement(
            'div',
            { style: { height: SUMMARY_CHART_HEIGHT, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } },
            _react2.default.createElement(_progress_bar2.default, { type: 'circular', multicolor: true, mode: 'indeterminate' })
          ),
          !isFetching && !summary && !posts && !replies && _react2.default.createElement(
            'div',
            null,
            t('label:日報提出状況の取得に失敗しました')
          ),
          isShowTimeStamp && ui.user && _react2.default.createElement(_dashboardUserPage2.default, { group: group, user: ui.user, onClose: this.onClose, open: !!ui.user, startDate: ui.startDate })
        )
      );
    }
  }]);

  return DashboardPage;
}(_react2.default.Component);

var RawDashboardPage = exports.RawDashboardPage = DashboardPage;
exports.default = (0, _dashboardPage2.default)(DashboardPage);

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;
exports.calcSummaryData = calcSummaryData;
exports.calcMembersData = calcMembersData;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reduce = __webpack_require__(160);

var _reduce2 = _interopRequireDefault(_reduce);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calcSummaryData(summary) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { diary: true, kpi: true, memo: true, like: true, comment: true };

  return {
    x_axis: summary.map(function (s) {
      return s.month.slice(0, 7);
    }),
    posts_data: {
      diary: summary.map(function (s) {
        return opts.diary && s.diary || null;
      }),
      kpi: summary.map(function (s) {
        return opts.kpi && s.kpi || null;
      }),
      memo: summary.map(function (s) {
        return opts.memo && s.memo || null;
      }),
      avg: summary.map(function (s) {
        return s.active_user > 0 ? Math.floor(((opts.diary && s.diary || 0) + (opts.kpi && s.kpi || 0) + (opts.memo && s.memo || 0)) / s.active_user * 10.0) / 10.0 : null;
      })
    },
    replies_data: {
      like: summary.map(function (s) {
        return opts.like && s.like || null;
      }),
      comment: summary.map(function (s) {
        return opts.comment && s.comment || null;
      }),
      avg: summary.map(function (s) {
        return s.diary + s.kpi + s.memo > 0 ? Math.floor(((opts.like && s.like || 0) + (opts.comment && s.comment || 0)) / (s.diary + s.kpi + s.memo) * 10.0) / 10.0 : null;
      })
    }
  };
}
// src/connects/dashboard-page.js

function calcMembersData(posts, replies) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { diary: true, kpi: true, memo: true, like: true, comment: true };

  var members = posts.map(function (m) {
    return m.user;
  });
  members = members.concat((0, _reduce2.default)(replies, function (r, m) {
    return members.find(function (mm) {
      return mm.user_id == m.user.user_id;
    }) ? r : r.concat(m.user);
  }, []));

  var postHash = (0, _reduce2.default)(posts, function (r, post) {
    r[post.user.user_id] = post;return r;
  }, {});
  var replyHash = (0, _reduce2.default)(replies, function (r, reply) {
    r[reply.user.user_id] = reply;return r;
  }, {});

  var _posts = members.map(function (m) {
    var item = postHash[m.user_id];
    return {
      user: m,
      diary: opts.diary ? item && item.diary || 0 : null,
      kpi: opts.kpi ? item && item.kpi || 0 : null,
      memo: opts.memo ? item && item.memo || 0 : null
    };
  });
  var _replies = members.map(function (m) {
    var item = replyHash[m.user_id];
    return {
      user: m,
      like: opts.like ? item && item.like || 0 : null,
      comment: opts.comment ? item && item.comment || 0 : null
    };
  });
  var avg_posts = posts.length > 0 ? Math.floor((0, _reduce2.default)(posts, function (r, post) {
    return (opts.diary && post.diary || 0) + (opts.kpi && post.kpi || 0) + (opts.memo && post.memo || 0) + r;
  }, 0) / posts.length * 10.0) / 10.0 : 0;
  var avg_replies = replies.length > 0 ? Math.floor((0, _reduce2.default)(replies, function (r, reply) {
    return (opts.like && reply.like || 0) + (opts.comment && reply.comment || 0) + r;
  }, 0) / replies.length * 10.0) / 10.0 : 0;

  return {
    x_axis: members,
    posts_data: {
      diary: _posts.map(function (p) {
        return p.diary || 0;
      }),
      kpi: _posts.map(function (p) {
        return p.kpi || 0;
      }),
      memo: _posts.map(function (p) {
        return p.memo || 0;
      })
    },
    replies_data: {
      like: _replies.map(function (p) {
        return p.like || 0;
      }),
      comment: _replies.map(function (p) {
        return p.comment || 0;
      })
    },
    avg_posts: avg_posts, avg_replies: avg_replies
  };
}

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isFetching: state.dashboard.isSummaryFetching || state.dashboard.isPostsFetching || state.dashboard.isRepliesFetching || state.dashboard.isReceivesFetching,
    group: (0, _find2.default)(state.groups.items, function (item) {
      return item.group_id == ownProps.params.group_id;
    }),
    summary: state.dashboard.summary,
    posts: state.dashboard.posts,
    replies: state.dashboard.replies,
    access_token: state.sessions.access_token,
    isShowTimeStamp: state.showTimeStamp ? state.showTimeStamp.isEnable : false
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount(props) {
      var endDate = props.ui.startDate.clone().endOf('month');
      var lastYear = props.ui.startDate.clone().add(-5, 'month');
      dispatch(_actions2.default.fetchDashboardSummary(props.group.group_id, lastYear.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
      dispatch(_actions2.default.fetchDashboardPosts(props.group.group_id, props.ui.startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
      dispatch(_actions2.default.fetchDashboardReplies(props.group.group_id, props.ui.startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
    },

    exportUrl: function exportUrl(props) {
      return _config2.default.baseUrl + 'v3/export/monthly_summary.xlsx?group_id=' + props.group.group_id + '&start_date=' + (0, _moment2.default)(props.ui.startDate).startOf('month').format('YYYY-MM-DD') + '&access_token=' + props.access_token;
    },

    nextMonth: function nextMonth(props) {
      var startDate = props.ui.startDate.clone().add(1, 'months');
      var endDate = startDate.clone().endOf('month');
      var lastYear = props.ui.startDate.clone().add(-4, 'month');
      props.updateUI({ startDate: startDate });
      dispatch(_actions2.default.fetchDashboardSummary(props.group.group_id, lastYear.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
      dispatch(_actions2.default.fetchDashboardPosts(props.group.group_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
      dispatch(_actions2.default.fetchDashboardReplies(props.group.group_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
    },

    prevMonth: function prevMonth(props) {
      var startDate = props.ui.startDate.clone().add(-1, 'months');
      var endDate = startDate.clone().endOf('month');
      var lastYear = props.ui.startDate.clone().add(-6, 'month');
      props.updateUI({ startDate: startDate });
      dispatch(_actions2.default.fetchDashboardSummary(props.group.group_id, lastYear.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
      dispatch(_actions2.default.fetchDashboardPosts(props.group.group_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
      dispatch(_actions2.default.fetchDashboardReplies(props.group.group_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
    },

    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearDashboardData());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    startDate: (0, _moment2.default)().startOf('month'),
    user: undefined,
    active: false
  } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('dashboard'));

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dashboardUserPage = __webpack_require__(2662);

var _dashboardUserPage2 = _interopRequireDefault(_dashboardUserPage);

var _dialog = __webpack_require__(47);

var _button = __webpack_require__(8);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _reactHighcharts = __webpack_require__(387);

var _reactHighcharts2 = _interopRequireDefault(_reactHighcharts);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _userMonthlySummaryPage = __webpack_require__(1067);

var _userMonthlySummaryPage2 = _interopRequireDefault(_userMonthlySummaryPage);

var _userMonthlyActivitiesTable = __webpack_require__(1068);

var _userMonthlyActivitiesTable2 = _interopRequireDefault(_userMonthlyActivitiesTable);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
* src/web/components/dashboard-user-page.jsx
* ユーザの月間サマリーページ（ポップアップ）
*/


var DETAILS_CHART_HEIGHT = 400;
var COLORS = {
  diary: '#2f7ed8',
  kpi: '#0d233a',
  memo: '#8bbc21',
  like: '#910000',
  comment: '#1aadce',
  line1: '#492970',
  line2: '#f28f43'
};

var DashboardUserPage = function (_React$Component) {
  _inherits(DashboardUserPage, _React$Component);

  function DashboardUserPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DashboardUserPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DashboardUserPage.__proto__ || Object.getPrototypeOf(DashboardUserPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { detailsChart: undefined }, _this.onClose = function () {
      return _this.props.onClose();
    }, _this.nextMonth = function () {
      return _this.props.nextMonth(_this.props);
    }, _this.prevMonth = function () {
      return _this.props.prevMonth(_this.props);
    }, _this.generateChart = function (props, state) {
      var t = props.t,
          actions = props.actions;

      var startDate = props.ui.startDate;
      var detailsData = (0, _dashboardUserPage.calcDetailsData)(actions);
      return {
        chart: {
          type: 'scatter',
          height: DETAILS_CHART_HEIGHT
        },
        title: { text: undefined },
        credits: { enabled: false },
        exporting: { enbaled: false },
        xAxis: {
          min: 1,
          max: startDate.clone().endOf('month').date(),
          startOnTick: true,
          endOnTick: true,
          tickInterval: 1,
          labels: {
            autoRotation: false,
            align: 'center',
            useHTML: true,
            formatter: function formatter() {
              var date = startDate.clone().add(_moment2.default.duration(this.value - 1, 'day'));
              if (date.day() == 6) // 土曜日
                return '<span style="color: blue">' + date.format('D<br/>ddd') + '</span>';
              if (date.day() == 0) // 日曜日
                return '<span style="color: red">' + date.format('D<br/>ddd') + '</span>';
              return date.format('D<br/>ddd');
            }
          }
        },
        yAxis: {
          min: 0, max: 24,
          reversed: true,
          tickInterval: 3,
          title: { text: undefined },
          labels: {
            autoRotation: false,
            formatter: function formatter() {
              return (0, _moment2.default)('2000-01-01 00:00:00').add(_moment2.default.duration(this.value, 'hour')).format('HH:mm');
            }
          }
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          useHTML: true,
          formatter: function formatter() {
            var text = this.point.time.slice(0, 5) + ' - ' + this.point.series.name;
            if (this.point.reported_diff) {
              text += ' (' + this.point.reported_at.slice(5, 10) + ')<br/><span style="color:red">' + this.point.reported_diff + '\u65E5\u9045\u308C</span>';
            }
            return text;
          }
        },
        series: [{
          color: COLORS.diary,
          name: t('diary:diary'),
          data: detailsData.diary,
          marker: {
            symbol: 'circle',
            radius: 10
          }
        }, {
          color: COLORS.kpi,
          name: t('diary:kpi'),
          data: detailsData.kpi,
          marker: {
            symbol: 'circle',
            radius: 10
          }
        }, {
          color: COLORS.memo,
          name: t('diary:memo'),
          data: detailsData.memo,
          marker: {
            symbol: 'circle',
            radius: 10
          }
        }, {
          color: COLORS.like,
          name: t('label:いいね'),
          data: detailsData.like,
          marker: {
            symbol: 'triangle',
            height: 10,
            width: 10
          }
        }, {
          color: COLORS.comment,
          name: t('label:コメント'),
          data: detailsData.comment,
          marker: {
            symbol: 'triangle',
            height: 10,
            width: 10
          }
        }]
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DashboardUserPage, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.actions !== nextProps.actions && nextProps.actions) this.setState({ detailsChart: this.generateChart(nextProps, this.state) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          user = _props.user,
          actions = _props.actions,
          onClose = _props.onClose,
          open = _props.open,
          isFetching = _props.isFetching;

      var endDate = ui.startDate.clone().endOf('month');

      return _react2.default.createElement(
        _dialog.Dialog,
        { theme: _userMonthlySummaryPage2.default,
          active: open,
          onEscKeyDown: this.onClose,
          onOverlayClick: this.onClose,
          title: t('label:月間サマリー', { name: user.name }),
          actions: [{ label: t('label:閉じる'), onClick: this.onClose, raised: true }] },
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'space-between', padding: '0 20px' } },
          _react2.default.createElement(_button.Button, { icon: 'navigate_before', onClick: this.prevMonth }),
          _react2.default.createElement(
            'span',
            null,
            ui.startDate.format(t('format:month'))
          ),
          _react2.default.createElement(_button.Button, { icon: 'navigate_next', onClick: this.nextMonth, disabled: endDate.isAfter((0, _moment2.default)()) })
        ),
        _react2.default.createElement(
          'div',
          { style: { height: DETAILS_CHART_HEIGHT } },
          this.state.detailsChart && _react2.default.createElement(_reactHighcharts2.default, { config: this.state.detailsChart }),
          isFetching && !this.state.detailsChart && _react2.default.createElement(_loading2.default, null)
        )
      );
    }
  }]);

  return DashboardUserPage;
}(_react2.default.Component);

exports.default = (0, _dashboardUserPage2.default)(DashboardUserPage);

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;
exports.calcDetailsData = calcDetailsData;

var _reactRedux = __webpack_require__(11);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _formValidator = __webpack_require__(41);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calcDetailsData(actions) {
  actions = (0, _map2.default)(actions, function (action) {
    return {
      x: (0, _moment2.default)(action.date).date(),
      y: _moment2.default.duration(action.time).as('hours'),
      time: action.time,
      type: action.type,
      reported_at: action.reported_at,
      reported_diff: action.reported_at && _moment2.default.duration((0, _moment2.default)(action.date).diff((0, _moment2.default)(action.reported_at))).as('days') || undefined
    };
  });
  return {
    diary: (0, _filter2.default)(actions, function (action) {
      return action.type == 'post-diary';
    }),
    kpi: (0, _filter2.default)(actions, function (action) {
      return action.type == 'post-kpi';
    }),
    memo: (0, _filter2.default)(actions, function (action) {
      return action.type == 'post-memo';
    }),
    like: (0, _filter2.default)(actions, function (action) {
      return action.type == 'reply-like';
    }),
    comment: (0, _filter2.default)(actions, function (action) {
      return action.type == 'reply-comment';
    })
  };
}
/**
* src/connects/dashboard-user-page.js
*/

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isFetching: state.dashboard.isDetailsFetching,
    user: state.dashboard.details && state.dashboard.details.user || ownProps.user,
    actions: state.dashboard.details && state.dashboard.details.actions
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount(props) {
      var endDate = props.ui.startDate.clone().endOf('month');
      dispatch(_actions2.default.fetchDashboardDetails(props.group.group_id, props.user.user_id, props.ui.startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (props.ui.startDate != nextProps.ui.startDate || props.user_id != nextProps.user_id) {
        var endDate = nextProps.ui.startDate.clone().endOf('month');
        dispatch(_actions2.default.fetchDashboardDetails(nextProps.group.group_id, nextProps.user.user_id, nextProps.ui.startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
      }
    },

    nextMonth: function nextMonth(props) {
      var startDate = props.ui.startDate.clone().add(1, 'months');
      var endDate = startDate.clone().endOf('month');
      props.updateUI({ startDate: startDate });
      dispatch(_actions2.default.fetchDashboardDetails(props.group.group_id, props.user.user_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
    },

    prevMonth: function prevMonth(props) {
      var startDate = props.ui.startDate.clone().add(-1, 'months');
      var endDate = startDate.clone().endOf('month');
      props.updateUI({ startDate: startDate });
      dispatch(_actions2.default.fetchDashboardDetails(props.group.group_id, props.user.user_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')));
    },

    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearDashboardDetails());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    startDate: function startDate(props) {
      return props.startDate || (0, _moment2.default)().startOf('month');
    }
  } }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawSubGroupTimelinePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _subGroupTimelinePage = __webpack_require__(2664);

var _subGroupTimelinePage2 = _interopRequireDefault(_subGroupTimelinePage);

__webpack_require__(502);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/sub-group-timeline-page.jsx

var SubGroupTimelinePage = function (_React$Component) {
  _inherits(SubGroupTimelinePage, _React$Component);

  function SubGroupTimelinePage() {
    _classCallCheck(this, SubGroupTimelinePage);

    return _possibleConstructorReturn(this, (SubGroupTimelinePage.__proto__ || Object.getPrototypeOf(SubGroupTimelinePage)).apply(this, arguments));
  }

  _createClass(SubGroupTimelinePage, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(_rightSidePage2.default, { title: '\u30B0\u30EB\u30FC\u30D7\u306E\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3', icon: 'people' });
    }
  }]);

  return SubGroupTimelinePage;
}(_react2.default.Component);

var RawSubGroupTimelinePage = exports.RawSubGroupTimelinePage = SubGroupTimelinePage;
exports.default = (0, _subGroupTimelinePage2.default)(SubGroupTimelinePage);

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/sub-group-timeline-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawChatRoomsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _chatRoomsPage = __webpack_require__(2666);

var _chatRoomsPage2 = _interopRequireDefault(_chatRoomsPage);

var _list = __webpack_require__(25);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _button = __webpack_require__(8);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _store = __webpack_require__(18);

var _chatRoomsList = __webpack_require__(2667);

var _chatRoomsList2 = _interopRequireDefault(_chatRoomsList);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _infiniteScroller = __webpack_require__(75);

var _theme = __webpack_require__(266);

var _theme2 = _interopRequireDefault(_theme);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _formValidator = __webpack_require__(41);

var _chatRoomSettingsPage = __webpack_require__(1087);

var _chatRoomSettingsPage2 = _interopRequireDefault(_chatRoomSettingsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/chat-rooms-page.jsx

var MAX_DISPLAY_COUNT = 13;
var MAX_MEMBER_COUNT = 100;

var ChatRoomsPage = function (_React$Component) {
  _inherits(ChatRoomsPage, _React$Component);

  function ChatRoomsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChatRoomsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatRoomsPage.__proto__ || Object.getPrototypeOf(ChatRoomsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.renderGroupMemberIcon = function (room) {
      var groupMembers = _lodash2.default.find(_this.props.chatRooms, function (_chatRoom) {
        return _chatRoom.chat_room_id == room.chat_room_id;
      }).members;
      var iconMembers = _lodash2.default.filter(groupMembers, function (_member) {
        return _member.user_id != _this.props.user.user_id;
      }).slice(0, 3);
      var renderItem = _react2.default.createElement(
        'div',
        { theme: _chatRoomsList2.default, className: 'membersField' },
        _react2.default.createElement('img', { className: 'chatAvatar', src: room.icon_image ? room.icon_image.thumb_url : iconMembers[0].icon_image.thumb_url }),
        _react2.default.createElement(
          'div',
          { className: 'countField' },
          _react2.default.createElement(
            'span',
            { key: 'count', className: 'membersCount' },
            groupMembers.length >= MAX_MEMBER_COUNT ? '99+' : groupMembers.length
          )
        )
      );
      return renderItem;
    }, _this.onAddUsers = function () {
      return _this.props.showUserSelectionDialog(_this.props.t('label:チャットの宛先を追加'), true, 'ACCOUNT_MEMBERS', undefined, _this.props.ui.users, function (users) {
        return _this.props.updateUI({ users: _lodash2.default.filter((0, _store.mergeArray)('user_id', [], users), function (_user) {
            return _user.user_id != _this.props.user.user_id;
          }) });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChatRoomsPage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          user = _props.user,
          hasMore = _props.hasMore,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          isRequesting = _props.isRequesting,
          isCreating = _props.isCreating,
          isCreateFailed = _props.isCreateFailed,
          created = _props.created,
          chatRooms = _props.chatRooms,
          openChatRoom = _props.openChatRoom,
          deleteChatRoom = _props.deleteChatRoom,
          createChatRoom = _props.createChatRoom,
          fetchChatRooms = _props.fetchChatRooms,
          showUserSelectionDialog = _props.showUserSelectionDialog,
          updateUI = _props.updateUI,
          chatRoomNames = _props.chatRoomNames;


      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: t('label:チャット'), icon: 'chat' },
        !isFetchFailed && _react2.default.createElement(
          'div',
          null,
          ui.users && ui.users.length > 0 && _react2.default.createElement(_button.Button, { raised: true, primary: true,
            disabled: isCreating,
            label: t('label:チャットを開始'),
            style: { verticalAlign: 'bottom', mergin: '2px 5px', float: 'right' },
            onClick: function onClick() {
              return createChatRoom(_this2.props);
            } }),
          _react2.default.createElement(_button.Button, { theme: _successButton2.default,
            raised: !(ui.users && ui.users.length > 0),
            floating: ui.users && ui.users.length > 0,
            mini: ui.users && ui.users.length > 0,
            label: !(ui.users && ui.users.length > 0) && t('label:新規作成'),
            icon: 'person_add',
            style: { verticalAlign: 'bottom', mergin: '2px 5px' },
            onClick: this.onAddUsers }),
          ui.users && _lodash2.default.map(ui.users.slice(0, MAX_DISPLAY_COUNT), function (user, i) {
            return _react2.default.createElement(_avatar2.default, { image: user.icon_image.thumb_url, style: { marginLeft: 2 } });
          }),
          ui.users && ui.users.length > MAX_DISPLAY_COUNT && _react2.default.createElement(_button.Button, {
            primary: true,
            onClick: this.onAddUsers,
            icon: 'arrow_forward',
            label: t('label:他n人', { n: ui.users.length - MAX_DISPLAY_COUNT }) + 'を' + t('label:すべて表示') })
        ),
        !isFetchFailed && chatRooms && chatRooms.length > 0 && _react2.default.createElement(
          _infiniteScroller.InfiniteScroll,
          { pageStart: 0,
            element: 'ul',
            initialLoad: false,
            className: (0, _classnames2.default)(_theme2.default.list),
            loadMore: function loadMore() {
              return !isFetching && fetchChatRooms(_this2.props);
            },
            hasMore: hasMore,
            loader: isFetching && _react2.default.createElement(_list.ListItem, { caption: t('label:読み込み中') }),
            useWindow: false },
          _lodash2.default.map(chatRoomNames, function (room, i) {
            return _react2.default.createElement(
              _list.ListItem,
              { key: room.chat_room_id,
                theme: _chatRoomsList2.default,
                avatar: !room.icon_image && room.thumbnail && room.thumbnail || undefined,
                leftIcon: room.icon_image ? _this2.renderGroupMemberIcon(room) : room.icon && chatRooms && _this2.renderGroupMemberIcon(room) || undefined,
                caption: room.name,
                onClick: function onClick() {
                  return openChatRoom(room.chat_room_id);
                },
                rightActions: [room.unread_count && room.unread_count > 0 && _react2.default.createElement(
                  'span',
                  { key: 'count', className: _chatRoomsList2.default.unreadCount },
                  room.unread_count < 10 ? room.unread_count : '10+'
                ) || _react2.default.createElement('span', { key: 'count' }), _react2.default.createElement(_button.IconButton, { icon: 'more_vert', key: 'icon',
                  onClick: function onClick() {
                    _this2.setState(_defineProperty({}, room.chat_room_id, true));
                  } })] },
              _react2.default.createElement(_chatRoomSettingsPage2.default, { key: 'page',
                open: _this2.state[room.chat_room_id],
                chatRoom: _lodash2.default.find(chatRooms, function (_chatRoom) {
                  return _chatRoom.chat_room_id == room.chat_room_id;
                }),
                chatRoomName: room,
                user: user,
                onClose: function onClose() {
                  return _this2.setState(_defineProperty({}, room.chat_room_id, false));
                } })
            );
          })
        ),
        !isCreateFailed && chatRooms && chatRooms.length == 0 && _react2.default.createElement(
          'div',
          { style: { marginTop: '20px', textAlign: 'center' } },
          t('label:チャットの履歴がありません')
        ),
        isFetchFailed && _react2.default.createElement(
          'div',
          { style: { marginTop: '10px', textAlign: 'center' } },
          t('label:チャットルームの取得に失敗しました')
        )
      );
    }
  }]);

  return ChatRoomsPage;
}(_react2.default.Component);

var RawChatRoomsPage = exports.RawChatRoomsPage = ChatRoomsPage;
exports.default = (0, _chatRoomsPage2.default)(ChatRoomsPage);

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // src/connects/chat-rooms-page.js

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

var _socketRsync = __webpack_require__(144);

var _socketRsync2 = _interopRequireDefault(_socketRsync);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.chatRooms.isFetching,
    isFetchFailed: state.chatRooms.isFetchFailed,
    isCreating: state.chatRooms.isCreating,
    isCreateFailed: state.chatRooms.isCreateFailed,
    created: state.chatRooms.created,
    chatRooms: state.chatRooms.items,
    user: state.user.current,
    productTour: state.productTour.state,
    hasMore: state.chatRooms.hasMore
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var names = stateProps.chatRooms && (0, _map2.default)(stateProps.chatRooms, function (room) {
    var thumbnail = room.members.length == 2 && (0, _filter2.default)(room.members, function (member) {
      return member.user_id != stateProps.user.user_id;
    })[0].icon_image.thumb_url || undefined;
    var icon = room.members.length > 2 && "people" || undefined;
    var members = (0, _filter2.default)(room.members, function (member) {
      return member.user_id != stateProps.user.user_id;
    }).slice(0, 3).map(function (member) {
      return member.name;
    }).join(', ');
    var sequence = room.sequence_id ? ' (' + room.sequence_id + ')' : '';
    return {
      name: room.name || (room.members.length > 4 ? members + '...' : members) + sequence,
      chat_room_id: room.chat_room_id,
      thumbnail: thumbnail,
      icon: icon,
      icon_image: room.icon_image,
      unread_count: room.unread_count
    };
  });

  return _extends({}, stateProps, dispatchProps, ownProps, {
    chatRoomNames: names
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openChatRoom: function openChatRoom(chat_room_id) {
      dispatch(_actions2.default.openRightSidePage('chat_messages', { chat_room_id: chat_room_id }, true));
    },

    deleteChatRoom: function deleteChatRoom(props, chatRoom) {
      dispatch(_actions2.default.deleteChatRoom(chatRoom.chat_room_id));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:チャットルームを削除しました', name: chatRoom.name }, 'success'));
    },

    createChatRoom: function createChatRoom(props) {
      dispatch(_actions2.default.createChatRoom(props.ui.users.map(function (member) {
        return member.user_id;
      })));
    },

    fetchChatRooms: function fetchChatRooms(props) {
      var offset = props.chatRooms && props.chatRooms.length || 0;
      dispatch(_actions2.default.fetchChatRooms(offset));
    },

    willMount: function willMount(props) {
      (!props.productTour || props.productTour.chatRoom != 'hide') && dispatch(_actions2.default.hideProductTour('chatRoom'));
      dispatch(_actions2.default.fetchChatRooms(0));
      dispatch(_actions2.default.fetchChatRoomUnreadCount());
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (props.isCreating && !nextProps.isCreating && !nextProps.isCreateFailed && nextProps.created) {
        dispatch(_actions2.default.openRightSidePage('chat_messages', { chat_room_id: nextProps.created.chat_room_id }, true));
      }
    },

    receiveSocket: function receiveSocket(message, message_type) {
      if (message_type == 'chat_room')
        /**
         * chat_roomを削除された場合／membersに自分自身が含まれていない場合は、ストアからchat_roomを削除するため、
         * パラメータに「true」を渡す
         */
        dispatch(_actions2.default.loadChatRoom(message.chat_room, message.deleted || message.chat_room.obsoleted));else if (message_type == 'chat' && message.appending)
        // チャットルームに新たな投稿があった場合、未読件数を取得する
        dispatch(_actions2.default.fetchChatRooms(0));
    },

    requestSync: function requestSync() {
      return dispatch(_actions2.default.fetchChatRooms(0));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactI18next.translate)(), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _socketRsync2.default)('chat', 'chat_room'), (0, _context2.default)({ showUserSelectionDialog: _propTypes2.default.func }), (0, _uiState2.default)({ state: { users: undefined } }), _lifecycle2.default, (0, _analytics.trackPage)('chat_rooms'));

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2668);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./chat-rooms-list.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./chat-rooms-list.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.chat-rooms-list--itemContentRoot--1CRk_HeZ {\n  min-width: calc(100% - 160px);\n  cursor: pointer;  \n}\n  \n.chat-rooms-list--unreadCount--2xZ3tcVk {\n  border-radius: 50%;\n  background: red;\n  color: #FFF;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  position: relative;\n  font-size: 80%;\n  line-height: 20px;\n}\n  \n.chat-rooms-list--itemText--Rx-jZYGz {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 12px;\n}\n  \n.chat-rooms-list--listItem--2_Tb1pxN:hover {\n  background-color:  #f3f0f0;\n}\n  \n.chat-rooms-list--left--14P0aXfo {\n  width: 50px;\n}\n  \n.chat-rooms-list--avatar--1OF4fBVz {\n  height: 40px;\n  width: 40px;\n  z-index: 3;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"0\" /><feOffset dx=\"3\" dy=\"1\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(255,255,255,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(2px 0px 0 rgb(255, 255, 255));\n          filter: drop-shadow(2px 0px 0 rgb(255, 255, 255))\n}\n  \n.chat-rooms-list--avatar--1OF4fBVz[class~=secondAvatar] {\n  margin-left: -34px;\n  z-index: 2;\n}\n  \n.chat-rooms-list--avatar--1OF4fBVz[class~=thirdAvatar] {\n  margin-left: -34px;\n  z-index: 1;\n}\n  \ndiv[class~=membersField] {\n  position: relative;\n}\n  \nimg[class~=chatAvatar] {\n  background-color: rgb(158, 158, 158);\n  border-radius: 50%;\n  height: 40px;\n}\n  \ndiv[class~=countField] {\n  position: absolute;\n  left: 25px;\n  top: 25px;\n  height: 20px;\n  width: 20px;\n  background-color: #646464;\n  border-radius: 10px;\n  padding: 12px;\n}\n  \nspan[class~=membersCount] {\n  position: absolute;\n  color: rgb(255, 255, 255);\n  font-size: 12px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}", "", {"version":3,"sources":["/./src/web/components/themes/chat-rooms-list.css"],"names":[],"mappings":";AACA;EACE,8BAA8B;EAC9B,gBAAgB;CACjB;;AAED;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;CACnB;;AAED;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;CACnB;;AAED;EACE,2BAA2B;CAC5B;;AAED;EACE,YAAY;CACb;;AAED;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,oYAAoY;EACpY,0DAA0D;UAClD,iDAAiD;CAC1D;;AAED;EACE,mBAAmB;EACnB,WAAW;CACZ;;AAED;EACE,mBAAmB;EACnB,WAAW;CACZ;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;CACd;;AAED;EACE,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,oBAAoB;EACpB,cAAc;CACf;;AAED;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,yCAAyC;EACzC,qCAAqC;CACtC","file":"chat-rooms-list.css","sourcesContent":["\n.itemContentRoot {\n  min-width: calc(100% - 160px);\n  cursor: pointer;  \n}\n  \n.unreadCount {\n  border-radius: 50%;\n  background: red;\n  color: #FFF;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  position: relative;\n  font-size: 80%;\n  line-height: 20px;\n}\n  \n.itemText {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-left: 12px;\n}\n  \n.listItem:hover {\n  background-color:  #f3f0f0;\n}\n  \n.left {\n  width: 50px;\n}\n  \n.avatar {\n  height: 40px;\n  width: 40px;\n  z-index: 3;\n  filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"0\" /><feOffset dx=\"3\" dy=\"1\" result=\"offsetblur\" /><feFlood flood-color=\"rgba(255,255,255,1)\" /><feComposite in2=\"offsetblur\" operator=\"in\" /><feMerge><feMergeNode /><feMergeNode in=\"SourceGraphic\" /></feMerge></filter></svg>#filter');\n  -webkit-filter: drop-shadow(2px 0px 0 rgb(255, 255, 255));\n          filter: drop-shadow(2px 0px 0 rgb(255, 255, 255))\n}\n  \n.avatar[class~=secondAvatar] {\n  margin-left: -34px;\n  z-index: 2;\n}\n  \n.avatar[class~=thirdAvatar] {\n  margin-left: -34px;\n  z-index: 1;\n}\n  \ndiv[class~=membersField] {\n  position: relative;\n}\n  \nimg[class~=chatAvatar] {\n  background-color: rgb(158, 158, 158);\n  border-radius: 50%;\n  height: 40px;\n}\n  \ndiv[class~=countField] {\n  position: absolute;\n  left: 25px;\n  top: 25px;\n  height: 20px;\n  width: 20px;\n  background-color: #646464;\n  border-radius: 10px;\n  padding: 12px;\n}\n  \nspan[class~=membersCount] {\n  position: absolute;\n  color: rgb(255, 255, 255);\n  font-size: 12px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"itemContentRoot": "chat-rooms-list--itemContentRoot--1CRk_HeZ",
	"unreadCount": "chat-rooms-list--unreadCount--2xZ3tcVk",
	"itemText": "chat-rooms-list--itemText--Rx-jZYGz",
	"listItem": "chat-rooms-list--listItem--2_Tb1pxN",
	"left": "chat-rooms-list--left--14P0aXfo",
	"avatar": "chat-rooms-list--avatar--1OF4fBVz"
};

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactI18next = __webpack_require__(2);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * src/connects/chat-room-settings-page.js
 */

exports.default = (0, _combineHoc2.default)((0, _reactI18next.translate)());

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _chatRoomFormPanel = __webpack_require__(2671);

var _chatRoomFormPanel2 = _interopRequireDefault(_chatRoomFormPanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _input = __webpack_require__(59);

__webpack_require__(349);

var _formValidator = __webpack_require__(41);

var _glamor = __webpack_require__(915);

var _fileUploadButton = __webpack_require__(180);

var _fileUploadButton2 = _interopRequireDefault(_fileUploadButton);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _reactRangeslider = __webpack_require__(348);

var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);

var _reactAvatarEditor = __webpack_require__(352);

var _reactAvatarEditor2 = _interopRequireDefault(_reactAvatarEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * src/web/components/chat-room-form-panel.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 基本設定
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// import Slider from 'react-toolbox/lib/slider' Slide in React Toolbx is buggy...


function calcCrop(avatar) {
  if (!avatar) return undefined;

  var rect = avatar.getCroppingRect();
  var width = avatar.state.image.resource.width;
  var height = avatar.state.image.resource.height;

  return {
    x: width * rect.x,
    y: height * rect.y,
    width: width * rect.width,
    height: height * rect.height
  };
}

var ChatRoomFormPanel = function (_React$Component) {
  _inherits(ChatRoomFormPanel, _React$Component);

  function ChatRoomFormPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChatRoomFormPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatRoomFormPanel.__proto__ || Object.getPrototypeOf(ChatRoomFormPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = { scale: 1.5 }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChatRoomFormPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          user = _props.user,
          isUpdating = _props.isUpdating,
          validateAndSubmit = _props.validateAndSubmit,
          chatRoom = _props.chatRoom,
          uploadFile = _props.uploadFile,
          uploadedFile = _props.uploadedFile,
          isUploading = _props.isUploading;


      return _react2.default.createElement(
        'form',
        { onSubmit: function onSubmit(event) {
            validateAndSubmit(_this2.props, isUpdating, event, calcCrop(_this2.refs.avatar));
          } },
        _react2.default.createElement(
          _card.Card,
          { theme: _flatCard2.default },
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:チャットルーム名')
              )
            ),
            _react2.default.createElement(_input.Input, { name: 'chatRoomName', required: true, autoFocus: true,
              label: t('label:チャットルーム名'),
              value: ui.name,
              icon: 'person',
              error: ui.nameError && t('error:チャットルーム名を入力してください'),
              onChange: (0, _formValidator.linkUI)(this, 'name')
            })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:アイコン画像')
              )
            ),
            _react2.default.createElement('br', null),
            !uploadedFile && !isUploading && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('img', { style: { width: 100, height: 100, borderRadius: '50%' }, src: chatRoom.icon_image ? chatRoom.icon_image.thumb_url : chatRoom.members[0].icon_image.thumb_url })
            ),
            uploadedFile && !isUploading && uploadedFile.file && _react2.default.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'column', width: 210 } },
              _react2.default.createElement(_reactAvatarEditor2.default, { ref: 'avatar',
                image: uploadedFile.file.thumb_url,
                width: 200,
                height: 200,
                border: 5,
                scale: this.state.scale,
                style: { cursor: 'move' } }),
              _react2.default.createElement(_reactRangeslider2.default, {
                min: 1,
                max: 5,
                step: 0.05,
                tooltip: false,
                value: this.state.scale,
                onChange: function onChange(value) {
                  return _this2.setState({ scale: value });
                } })
            ),
            isUploading && _react2.default.createElement(
              'div',
              { style: { height: '100%', width: '100%', display: 'flex', justifyContent: 'flex-start', marginLeft: '10px' } },
              _react2.default.createElement(_progress_bar2.default, { type: 'circular', multicolor: true, mode: 'indeterminate' })
            ),
            _react2.default.createElement(_fileUploadButton2.default, { raised: true,
              icon: 'add_a_photo',
              label: '\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E',
              single: true,
              onChange: function onChange(file) {
                return uploadFile(_this2.props, file);
              } })
          ),
          _react2.default.createElement(
            _card.CardActions,
            null,
            _react2.default.createElement(_button.Button, { raised: true, primary: true,
              type: 'submit',
              disabled: isUpdating,
              style: { width: '100%' },
              label: t('label:更新'),
              onClick: function onClick(event) {
                validateAndSubmit(_this2.props, isUpdating, event, calcCrop(_this2.refs.avatar));
              } })
          )
        )
      );
    }
  }]);

  return ChatRoomFormPanel;
}(_react2.default.Component);

exports.default = (0, _chatRoomFormPanel2.default)(ChatRoomFormPanel);

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * src/connects/chat-room-form-panel.js
                                                                                                                                                                                                                                                                   */

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _fileUpload = __webpack_require__(179);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _componentId = __webpack_require__(164);

var _componentId2 = _interopRequireDefault(_componentId);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _formValidator = __webpack_require__(41);

var _alertMessage = __webpack_require__(13);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    name: ownProps.chatRoom && ownProps.chatRoom.name || undefined,
    _uploadFile: state.uploadFile[ownProps.componentId]
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var uploadFile;
  if (stateProps._uploadFile) {
    uploadFile = (0, _find2.default)(stateProps._uploadFile, function (value, key) {
      return value;
    });
  }

  return _extends({
    isUploading: uploadFile && uploadFile.isUploading,
    uploadedFile: uploadFile && uploadFile.item
  }, ownProps, stateProps, dispatchProps);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    validateAndSubmit: function validateAndSubmit(props, callback) {
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var crop = arguments[3];

      if (event && event.preventDefault) event.preventDefault();

      (0, _formValidator.validate)(props.ui, { name: { rule: 'isRequired' } }, function (errors, nextUI) {
        props.updateUI(nextUI);
        if (!errors) {
          callback && callback();
          dispatch(_actions2.default.updateChatRoom(props.chatRoom.chat_room_id, props.ui.name, props.uploadedFile && props.uploadedFile.file_id, crop));
          dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:チャットルーム名を変更', name: props.ui.name }, 'success'));
        }
      });

      return false;
    },

    uploadFile: function uploadFile(props, file) {
      return !props.isUploading && (0, _fileUpload2.default)(file, dispatch, props.chatRoom.chat_room_id, 'chat_room', ownProps.componentId, true);
    }
  };
};

exports.default = (0, _combineHoc2.default)(_componentId2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({
  state: {
    name: function name(props) {
      return props.name;
    },
    nameError: undefined
  }
}), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _chatRoomMembersPanel = __webpack_require__(2673);

var _chatRoomMembersPanel2 = _interopRequireDefault(_chatRoomMembersPanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _list = __webpack_require__(25);

var _menu = __webpack_require__(63);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _lightButton = __webpack_require__(369);

var _lightButton2 = _interopRequireDefault(_lightButton);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * src/web/components/chat-room-members-panel.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var ChatRoomMemberList = function (_React$Component) {
  _inherits(ChatRoomMemberList, _React$Component);

  function ChatRoomMemberList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChatRoomMemberList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatRoomMemberList.__proto__ || Object.getPrototypeOf(ChatRoomMemberList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChatRoomMemberList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          chatRoom = _props.chatRoom,
          user = _props.user,
          leaveChatRoom = _props.leaveChatRoom;

      var otherMembers = chatRoom && _lodash2.default.filter(chatRoom.members, function (member) {
        return member.user_id != user.user_id;
      });

      if (!chatRoom.members || chatRoom.members.length == 0) return null;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _list.List,
          null,
          _lodash2.default.map(otherMembers, function (member, i) {
            return _react2.default.createElement(_list.ListItem, { key: member.user_id, index: i,
              avatar: member.icon_image.thumb_url,
              caption: member.name,
              rightActions: _lodash2.default.filter([_react2.default.createElement(_button.IconButton, { key: 'button', icon: 'close',
                disabled: otherMembers.length < 2 || member.user_id == user.user_id,
                onClick: function onClick() {
                  return _this2.setState(_defineProperty({}, member.user_id, true));
                } }), _react2.default.createElement(_confirmDialog2.default, { key: 'confirm' + member.user_id,
                title: t('label:メンバーを削除', { name: member.name }),
                open: _this2.state[member.user_id],
                onYes: function onYes() {
                  _this2.setState(_defineProperty({}, member.user_id, false));
                  leaveChatRoom(member, _this2.props);
                },
                onNo: function onNo() {
                  _this2.setState(_defineProperty({}, member.user_id, false));
                },
                yesLabel: t('label:削除'),
                noLabel: t('label:取り消し') })]) });
          })
        )
      );
    }
  }]);

  return ChatRoomMemberList;
}(_react2.default.Component);

var ChatRoomMembersPanel = function (_React$Component2) {
  _inherits(ChatRoomMembersPanel, _React$Component2);

  function ChatRoomMembersPanel() {
    var _ref2;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, ChatRoomMembersPanel);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = ChatRoomMembersPanel.__proto__ || Object.getPrototypeOf(ChatRoomMembersPanel)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = {}, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(ChatRoomMembersPanel, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          t = _props2.t,
          chatRoom = _props2.chatRoom,
          user = _props2.user,
          showUserSelectionDialog = _props2.showUserSelectionDialog,
          leaveChatRoom = _props2.leaveChatRoom,
          joinChatRoom = _props2.joinChatRoom,
          fetchChatRooms = _props2.fetchChatRooms,
          closeRightSidePage = _props2.closeRightSidePage;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(_button.Button, { raised: true, theme: _successButton2.default,
            icon: 'person_add',
            label: t('label:メンバーを追加'),
            style: { verticalAlign: 'bottom', mergin: '2px 5px' },
            onClick: function onClick() {
              showUserSelectionDialog(t('label:ユーザを選択'), true, 'ACCOUNT_MEMBERS', undefined, undefined, function (users) {
                return _lodash2.default.each(users, function (user) {
                  return joinChatRoom(user.user_id);
                });
              });
            }
          }),
          chatRoom.members && chatRoom.members.length > 2 && _react2.default.createElement(_button.Button, { raised: true, theme: _lightButton2.default,
            icon: 'person_outline',
            label: t('label:退室'),
            onClick: function onClick() {
              _this4.setState(_defineProperty({}, user.user_id, true));
            }
          }),
          chatRoom.members && chatRoom.members.length > 2 && _react2.default.createElement(_confirmDialog2.default, { key: 'leave',
            open: this.state[user.user_id],
            title: t('label:退室してもいいですか'),
            onYes: function onYes() {
              _this4.setState(_defineProperty({}, user.user_id, false));
              leaveChatRoom(user, _this4.props);
            },
            onNo: function onNo() {
              return _this4.setState(_defineProperty({}, user.user_id, false));
            },
            yesLabel: t('label:退室'),
            noLabel: t('label:取り消し') })
        ),
        _react2.default.createElement(
          _card.CardText,
          null,
          (!chatRoom.members || chatRoom.members.length == 0) && _react2.default.createElement(
            _list.List,
            null,
            _react2.default.createElement(_list.ListItem, { caption: t('label:メンバーは登録されていません') })
          ),
          _react2.default.createElement(ChatRoomMemberList, this.props)
        )
      );
    }
  }]);

  return ChatRoomMembersPanel;
}(_react2.default.Component);

exports.default = (0, _chatRoomMembersPanel2.default)(ChatRoomMembersPanel);

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    chatRoom: (0, _store.getArray)('chat_room_id', state.chatRooms.items, ownProps.chatRoom.chat_room_id),
    rightSidePage: state.rightSidePage.name,
    user: state.user.current
  };
}; /**
    * src/connects/chat-room-members-panel.js
    */

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    leaveChatRoom: function leaveChatRoom(user, props) {
      if (props.user.user_id == user.user_id) {
        dispatch(_actions2.default.leaveChatRoom(ownProps.chatRoom.chat_room_id, user.user_id));
        if (props.rightSidePage == 'chat_rooms') {
          props.onCloseDialog();
        }
      } else {
        dispatch(_actions2.default.excludeChatRoom(ownProps.chatRoom.chat_room_id, user.user_id));
      }
      dispatch((0, _alertMessage.emitAlertMessage)({ message: props.user.user_id == user.user_id && 'label:退室しました' || 'label:チャットルームから削除', name: user.name }, 'success'));
    },

    joinChatRoom: function joinChatRoom(user_id) {
      return dispatch(_actions2.default.joinChatRoom(ownProps.chatRoom.chat_room_id, user_id));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactI18next.translate)(), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _context2.default)({ showUserSelectionDialog: _propTypes2.default.func }), (0, _uiState2.default)({
  state: {
    users: undefined
  }
}), _lifecycle2.default, (0, _analytics.trackPage)('chatRoom_members'));

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _chatRoomDeletePanel = __webpack_require__(2675);

var _chatRoomDeletePanel2 = _interopRequireDefault(_chatRoomDeletePanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _list = __webpack_require__(25);

var _menu = __webpack_require__(63);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * src/web/components/chat-room-delete-panel.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var devicePC = true;

var ChatRoomDeletePanel = function (_React$Component) {
  _inherits(ChatRoomDeletePanel, _React$Component);

  function ChatRoomDeletePanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChatRoomDeletePanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatRoomDeletePanel.__proto__ || Object.getPrototypeOf(ChatRoomDeletePanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = { complete: false, deleteConfirm: false, deleteCheck: false }, _this.toggleConfirmDialog = function () {
      return _this.setState({ deleteConfirm: !_this.state.deleteConfirm });
    }, _this.onCancel = function () {
      _this.setState({ deleteConfirm: !_this.state.deleteConfirm, deleteCheck: !_this.state.deleteCheck });
    }, _this.deleteChatRoom = function (props) {
      _this.toggleConfirmDialog();
      _this.props.deleteChatRoom(props, devicePC);
    }, _this.onCheck = function () {
      _this.setState({ deleteCheck: !_this.state.deleteCheck });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChatRoomDeletePanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          chatRoomName = _props.chatRoomName,
          deleteChatRoom = _props.deleteChatRoom,
          messagePage = _props.messagePage,
          closeRightSidePage = _props.closeRightSidePage;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(
            'p',
            { style: { fontSize: 16, color: 'black', marginBottom: 5 } },
            t('label:チャットルームを削除します')
          ),
          _react2.default.createElement(
            'p',
            { style: { fontSize: 16, color: 'black', marginBottom: 5 } },
            t('label:チャットルームを削除していいですか')
          ),
          _react2.default.createElement(_checkbox2.default, {
            theme: _flatCard2.default,
            className: 'deleteCheck',
            checked: this.state.deleteCheck,
            onChange: this.onCheck,
            label: t('label:この操作はチャットルームに参加している全てのユーザーに影響します') })
        ),
        _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(_button.Button, { raised: true, primary: true,
            type: 'submit',
            style: { width: '100%' },
            label: t('label:削除'),
            disabled: !this.state.deleteCheck,
            onClick: this.toggleConfirmDialog
          })
        ),
        _react2.default.createElement(_confirmDialog2.default, { key: 'dialog',
          open: this.state.deleteConfirm,
          title: t('label:チャットルームを削除していいですか'),
          description: t('label:この操作は取り消せません'),
          yesLabel: t('label:削除'),
          noLabel: t('label:取り消し'),
          onNo: this.onCancel,
          onYes: function onYes() {
            return _this2.deleteChatRoom(_this2.props);
          } })
      );
    }
  }]);

  return ChatRoomDeletePanel;
}(_react2.default.Component);

exports.default = (0, _chatRoomDeletePanel2.default)(ChatRoomDeletePanel);

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    chatRoom: (0, _store.getArray)('chat_room_id', state.chatRooms.items, (ownProps.chatRoom || ownProps.chatRoomName).chat_room_id),
    isRequesting: state.chatRooms.isRequesting,
    isRequestFailed: state.chatRooms.isRequestFailed,
    rightSidePage: state.rightSidePage.name
  };
}; /**
    * src/connects/chat-room-delete-panel.js
    */

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    deleteChatRoom: function deleteChatRoom(props) {
      dispatch(_actions2.default.deleteChatRoom(props.chatRoomName.chat_room_id));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:チャットルームを削除しました', name: props.chatRoomName.name }, 'success'));
    },
    willUpdate: function willUpdate(props, nextProps) {
      if (props.isRequesting && !nextProps.isRequesting && !nextProps.isRequestFailed && props.rightSidePage == 'chat_rooms') {
        props.onCloseDialog();
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/chat-messages-page.js

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _alertMessage = __webpack_require__(13);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _socketRsync = __webpack_require__(144);

var _socketRsync2 = _interopRequireDefault(_socketRsync);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_DISPLAY_NAME = 6;

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var room_item = state.chatMessages[ownProps.params.chat_room_id];

  return {
    isFetching: room_item ? room_item.isFetching : false,
    isFetchFailed: room_item ? room_item.isFetchFailed : false,
    hasMore: room_item ? room_item.hasMore : true,
    chatRoom: (0, _find2.default)(state.chatRooms.items, function (item) {
      return item.chat_room_id == ownProps.params.chat_room_id;
    }),
    chatMessages: room_item ? room_item.items : undefined,
    user: state.user.current,
    likeConfig: state.likes ? state.likes.likeConfig : {}
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var filteredMembers = stateProps.chatRoom ? (0, _filter2.default)(stateProps.chatRoom.members, function (member) {
    return member.user_id != stateProps.user.user_id;
  }) : [];
  var thumbnail = stateProps.chatRoom && stateProps.chatRoom.members.length == 2 && filteredMembers[0] && filteredMembers[0].icon_image && filteredMembers[0].icon_image.thumb_url || undefined;
  var icon = stateProps.chatRoom && stateProps.chatRoom.members.length > 2 && "people" || undefined;
  var members = stateProps.chatRoom ? filteredMembers.slice(0, 3).map(function (member) {
    return member.name;
  }).join(', ') : '';

  var otherMembers = stateProps.chatRoom && (0, _filter2.default)(stateProps.chatRoom.members, function (member) {
    return member.user_id != stateProps.user.user_id;
  }) || [];

  var name = otherMembers && otherMembers.slice(0, 3).map(function (member) {
    return member.name;
  }).join(', ') + (otherMembers.length > 3 && ' ' + '...' || '');

  var userData = stateProps.chatRoom && (0, _filter2.default)(stateProps.chatRoom.members, function (member) {
    return member.user_id != stateProps.user.user_id;
  });
  var messageData = [];
  var members_name = [];
  stateProps.chatMessages && (0, _each2.default)(stateProps.chatMessages, function (message, i) {
    /**
     * メッセージの間隔が５分以上なら、時間を表示
     */
    if (i != 0 && (0, _moment2.default)(stateProps.chatMessages[i - 1].created_at).add(-5, 'minutes').isAfter(message.created_at)) {
      messageData.push({
        message_id: message.created_at,
        created_at: (0, _moment2.default)(stateProps.chatMessages[i - 1].created_at)
      });
    }
    /**
     * チャットルーム名が変更された場合
     */
    if (message.message_type == 'name_changed') {
      messageData.push({
        message_id: message.message_id,
        message: message
      });
    } else {
      if (i == 0) {
        members_name = message.user.name;
      }
      /**
       * 同じmessage_typeのメッセージを連続して受信した場合
       * 表示する名前をまとめ、messageDataの最後の要素を削除する
       */
      else {
          if (message.message_type && stateProps.chatMessages[i - 1].message_type == message.message_type) {
            members_name = members_name + ', ' + message.user.name;
            messageData.pop();
          } else members_name = message.user.name;
        }
      var selectUser = (0, _find2.default)(userData, function (users) {
        return users.user_id == message.user.user_id;
      });

      messageData.push({
        message_id: message.message_id,
        withName: otherMembers && otherMembers.length > 1,
        direction: message.user.user_id == stateProps.user.user_id,
        message: {
          chat_room_id: message.chat_room_id,
          message_id: message.message_id,
          message_type: message.message_type,
          user: {
            user_id: message.user.user_id,
            name: members_name,
            icon_image: message.user.icon_image && message.user.icon_image,
            description: selectUser && selectUser.description && selectUser.description
          },
          readers: message.readers && message.readers,
          files: message.files && message.files,
          message: message.message && message.message,
          attach_json: message.attach_json && message.attach_json,
          likes: message.likes && message.likes
        }
      });
    }
  });
  /**
   * chatMessagesの一番最後に時刻を入れる
   * いつからチャットが始まったかわかるように
   */
  stateProps.chatMessages && stateProps.chatMessages.length > 0 && messageData.push({
    message_id: 'beginning',
    created_at: (0, _moment2.default)(stateProps.chatMessages[stateProps.chatMessages.length - 1].created_at)
  });

  return _extends({}, stateProps, dispatchProps, ownProps, {
    chatRoomName: {
      name: stateProps.chatRoom && (stateProps.chatRoom.name || (stateProps.chatRoom.members.length > 4 ? members + ownProps.t('label:他n人', { n: stateProps.chatRoom.members.length - 4 }) : members)) || undefined,
      chat_room_id: stateProps.chatRoom && stateProps.chatRoom.chat_room_id || undefined,
      thumbnail: thumbnail,
      icon: icon,
      unread_count: stateProps.chatRoom && stateProps.chatRoom.unread_count || undefined
    },
    otherMembers: otherMembers,
    name: name,
    messageData: messageData
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchMessages: function fetchMessages(props) {
      return dispatch(_actions2.default.fetchChatMessages(ownProps.params.chat_room_id, props.chatMessages && props.chatMessages.length || 0));
    },

    joinChatRoom: function joinChatRoom(user_id) {
      return dispatch(_actions2.default.joinChatRoom(ownProps.params.chat_room_id, user_id));
    },

    leaveChatRoom: function leaveChatRoom(user_id) {
      return dispatch(_actions2.default.leaveChatRoom(ownProps.params.chat_room_id, user_id));
    },

    updateChatRoom: function updateChatRoom(name) {
      return dispatch(_actions2.default.updateChatRoom(ownProps.params.chat_room_id, name));
    },

    emitAlertMessage: function emitAlertMessage(message) {
      return dispatch((0, _alertMessage.emitAlertMessage)(message, 'topSuccess'));
    },

    deleteChatMessage: function deleteChatMessage(message_id) {
      return dispatch(_actions2.default.deleteChatMessage(ownProps.params.chat_room_id, message_id));
    },

    reactChat: function reactChat(message_id, reaction_type) {
      return dispatch(_actions2.default.reactChat(ownProps.params.chat_room_id, message_id, reaction_type));
    },

    unLikeChat: function unLikeChat(message_id, like_id) {
      return dispatch(_actions2.default.deleteReactChat(ownProps.params.chat_room_id, message_id, like_id));
    },

    willMount: function willMount(props) {
      dispatch(_actions2.default.fetchChatRoom(ownProps.params.chat_room_id));
      dispatch(_actions2.default.fetchChatMessages(ownProps.params.chat_room_id, 0));
      dispatch(_actions2.default.makeChatMessageRead(ownProps.params.chat_room_id));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (props.chatRoom && !nextProps.chatRoom) dispatch(_actions2.default.closeRightSidePage());
      if (props.params.chat_room_id != nextProps.params.chat_room_id) {
        dispatch(_actions2.default.fetchChatRoom(nextProps.params.chat_room_id));
        dispatch(_actions2.default.fetchChatMessages(nextProps.params.chat_room_id, 0));
      }
    },

    receiveSocket: function receiveSocket(message, message_type, props) {
      switch (message_type) {
        /**
         * message_typeのメッセージ受信時
         */
        case 'chat':
        case 'chat_meta_info':
          /**
           * 現在開いているchat_room_idの場合処理をする
           */
          if (message.chat_room_id == ownProps.params.chat_room_id) {
            if (message.deleted) {
              dispatch(_actions2.default.removeChatMessage(message.chat_room_id, message.message_id));
            } else {
              // 新規投稿メッセージ・添付ファイル(動画)のステータスの変化に関する更新情報のみ取り込むように
              if (message.appending || message.chat.user.user_id || message.chat.files && message.chat.files.length > 0) dispatch(_actions2.default.loadChatMessage(message.chat, message.appending));
              dispatch(_actions2.default.makeChatMessageRead(message.chat_room_id));
            }
          }
          break;
        /**
         * chat_room更新情報受信時
         *  現在開いているchat_room_idでかつ、chat_roomが削除された場合／membersに自分自身が含まれていない（自分がチャットルームのメンバーではなくなった）場合
         *  ・ストアからchat_roomを削除するため、パラメータに「true」を渡す
         *  ・rightSidePageを閉じる
         */
        case 'chat_room':
          if (message.chat_room_id != ownProps.params.chat_room_id) break;
          if (message.deleted || message.chat_room.obsoleted) {
            dispatch(_actions2.default.loadChatRoom(message.chat_room, true));
          } else dispatch(_actions2.default.loadChatRoom(message.chat_room, false));
          break;
        default:
          break;
      }
    },

    requestSync: function requestSync() {
      return dispatch(_actions2.default.fetchChatMessages(ownProps.params.chat_room_id, 0));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactI18next.translate)(), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: { url: false, openDoc: false, pdf: false, openPdf: false, openAlbum: false, individualChatRoom: false } }), (0, _socketRsync2.default)('chat', 'chat_meta_info', 'chat_room'), _lifecycle2.default, (0, _analytics.trackPage)('chat_messages'));

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _chatMessageItem = __webpack_require__(2678);

var _chatMessageItem2 = _interopRequireDefault(_chatMessageItem);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _link = __webpack_require__(183);

var _link2 = _interopRequireDefault(_link);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _urlRegexp = __webpack_require__(182);

var _emojiHelpers = __webpack_require__(146);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _chatMessage = __webpack_require__(1089);

var _chatMessage2 = _interopRequireDefault(_chatMessage);

var _tinyAvatar = __webpack_require__(2680);

var _tinyAvatar2 = _interopRequireDefault(_tinyAvatar);

var _infiniteScroller = __webpack_require__(75);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _attachments = __webpack_require__(567);

var _attachments2 = _interopRequireDefault(_attachments);

var _googleDoc = __webpack_require__(269);

var _googleDoc2 = _interopRequireDefault(_googleDoc);

var _gambaUrl = __webpack_require__(350);

var _gambaUrl2 = _interopRequireDefault(_gambaUrl);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _videoViewer = __webpack_require__(353);

var _videoViewer2 = _interopRequireDefault(_videoViewer);

var _attachmentFile = __webpack_require__(1052);

var _attachmentFile2 = _interopRequireDefault(_attachmentFile);

var _pdfPreviewDialog = __webpack_require__(373);

var _pdfPreviewDialog2 = _interopRequireDefault(_pdfPreviewDialog);

var _userDetailsModal = __webpack_require__(2682);

var _userDetailsModal2 = _interopRequireDefault(_userDetailsModal);

var _googleIcons = __webpack_require__(565);

var _googleIcons2 = _interopRequireDefault(_googleIcons);

var _emoji = __webpack_require__(187);

var _emoji2 = _interopRequireDefault(_emoji);

var _button = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // src/web/components/chat-message-item.jsx

var TooltipButton = (0, _tooltip2.default)(_button.Button);

var UrlRegex = (0, _urlRegexp.urlRegex)();

var TooltipLink = (0, _tooltip2.default)(_link2.default);

function replaceHref(match) {
  return '<a target="_blank" rel="noopener noreferrer" href="' + (match.match(/^http/) ? '' : 'http://') + match + '">' + (match.length > 80 ? match.slice(0, 30) + '...' + match.slice(match.length - 20, match.length) : match) + '</a>';
}

var ChatMessageItem = function (_React$Component) {
  _inherits(ChatMessageItem, _React$Component);

  function ChatMessageItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChatMessageItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatMessageItem.__proto__ || Object.getPrototypeOf(ChatMessageItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false, isConfirm: false, pdfThumbnail: true, isReactClicked: false }, _this.read = undefined, _this.renderGoogleDocUrl = function (url) {
      var attach_json = _this.props.message.attach_json && typeof _this.props.message.attach_json == 'string' && JSON.parse(_this.props.message.attach_json) || _this.props.message.attach_json;
      var urlLink = attach_json && attach_json.links[url];
      var image_url = urlLink && (urlLink.image_url || _googleIcons2.default[urlLink.mime_type || 'default'] || _googleIcons2.default['default']);
      var title = urlLink && urlLink.title || _this.props.t('label:Googleドキュメント');
      title = title && title.length > 20 ? title.slice(0, 20) + "..." : title;
      return '<div class=' + (!image_url && "googleDocIcon") + '><a class=' + (image_url ? "googleDoc" : "googleDocIcon") + ' style="background-color: transparent; border-radius: 5px; padding: 3px 7px; text-decoration: none; font-size: 90%; display: inline-block; vertical-align: middle; height: 24px; margin-top: 1px;" href="' + url + '">' + (image_url ? '<img src=' + image_url + ' style="height: 18px; vertical-align: middle;">' : '') + ('&nbsp;' + title + '</a></div>');
    }, _this.renderGambaUrl = function (url) {
      return '<a class="gambaUrl" style="font-size: 90%; text-decoration: none; display: inline-block;" href="' + url + '"><span class="material-icons" style="font-size: 90%; padding: 0 5px; margin-top: 1px;">bookmark</span>&nbsp;' + _this.props.t('label:gambaで開く') + '</a>';
    }, _this.renderLink = function (url) {
      var attach_json = _this.props.message.attach_json && typeof _this.props.message.attach_json == 'string' && JSON.parse(_this.props.message.attach_json) || _this.props.message.attach_json;
      var urlLink = attach_json && attach_json.links[url];
      var image_url = urlLink && urlLink.image_url;
      var title = urlLink && urlLink.title || (0, _gambaUrl2.default)(url) && _this.props.t('label:gambaで開く');
      title = title && title.length > 20 ? title.slice(0, 20) + "..." : title;
      var disp_url = (url.length > 40 ? url.slice(0, 40) + "..." : url).replace(/^https?:\/\/(www\.)?/, '');
      var target = (0, _gambaUrl2.default)(url) ? '' : 'target="_blank"';
      if (!title) {
        title = disp_url;
        disp_url = undefined;
      }
      if ((0, _gambaUrl2.default)(url)) disp_url = undefined;
      return '<div style="display: ' + (!image_url && "inline-block;") + '"><a ' + target + ' class=' + (image_url ? "image" : "chatMaterialIcon") + ' rel="noopener noreferrer" style="background-color: transparent; border-radius: 5px; display: ' + (image_url ? "inline-block" : "flex") + '; vertical-align: middle; text-decoration: none; padding: 0px 5px 0px 0px;" href="' + url + '">' + '<div style="display: flex; align-items: center;">' + (image_url ? '<img src="' + image_url + '" style="height: ' + (disp_url ? '32px' : '24px') + '; border-radius: 5px; margin-right: 3px 5px;"/>' : '') + '<div style="display: flex; flex-direction: column; margin-left: 2px; text-indent: initial; line-height: 95%;">' + ('<div style="font-size: 90%">' + title + '</div>') + (disp_url ? '<div style="font-size: 80%; color: #666;">' + disp_url + '</div>' : '') + '</div>' + '</div>' + '</a></div>';
    }, _this.showImagesView = function (image) {
      return _this.props.showImagesView('CHAT_ROOM', _this.props.message.chat_room_id, image);
    }, _this.showPdfPreview = function (pdf) {
      _this.props.openPdf(pdf, true);
    }, _this.onPdfThumbnailError = function () {
      return _this.setState({ pdfThumbnail: false });
    }, _this.onCloseButton = function () {
      return _this.setState({ active: true });
    }, _this.offCloseButton = function () {
      return _this.setState({ active: false });
    }, _this.onLoad = function (ev, video) {
      var _this$setState;

      _this.setState((_this$setState = {}, _defineProperty(_this$setState, 'width' + video.video_id, ev.target.width), _defineProperty(_this$setState, 'height' + video.video_id, ev.target.height), _this$setState));
    }, _this.deleteChatMessage = function () {
      _this.props.deleteChatMessage(_this.props.message.message_id);
      _this.setState({ isConfirm: false });
    }, _this.cancelDeleteMessage = function () {
      return _this.setState({ isConfirm: false });
    }, _this.getSize = function (image, clientWidth) {
      var width = !image.width ? _this.state['width' + image.video_id] : image.width;
      var height = !image.height ? _this.state['height' + image.video_id] : image.height;
      var wRatio = width > clientWidth * 0.6 ? clientWidth * 0.6 / width : 1.0;
      var hRatio = height * wRatio > 300 ? 300 / (height * wRatio) : 1.0;
      var ratio = 1.0;

      if (wRatio == 1.0) {
        if (hRatio == 1.0) {
          ratio = 1.0;
        } else {
          ratio = hRatio;
        }
      } else {
        if (hRatio == 1.0) {
          ratio = wRatio;
        } else {
          ratio = wRatio * hRatio;
        }
      }

      return { width: width * ratio, height: height * ratio };
    }, _this.selectChatIcon = function (user, chatRoomMember) {
      var existsChatRoom = _lodash2.default.find(chatRoomMember, function (member) {
        return member.user_id == user.user_id;
      });
      existsChatRoom ? _this.props.updateUI({ user: user, openDialog: true }) : _this.props.notChatRoomMember();
    }, _this.handleReactclick = function () {
      _this.setState(function (prevState) {
        if (prevState.isReactClicked) return null;
        _this.props.reactionChat();
        return { isReactClicked: true };
      });

      setTimeout(function () {
        return _this.setState({ isReactClicked: false });
      }, 800); // Re-enable after delay
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChatMessageItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var googleDocElements = _reactDom2.default.findDOMNode(this.component).querySelectorAll('a.googleDoc, a.googleDocIcon');
      _lodash2.default.each(googleDocElements, function (element) {
        element.onclick = function (event) {
          event.preventDefault();
          _this2.props.openDoc(element.href, true);
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          user = _props.user,
          message = _props.message,
          withName = _props.withName,
          readMessage = _props.readMessage,
          showImagesView = _props.showImagesView,
          chatPageWidth = _props.chatPageWidth,
          deleteChatMessage = _props.deleteChatMessage,
          chatRoomMember = _props.chatRoomMember,
          notChatRoomMember = _props.notChatRoomMember,
          individualChatRoom = _props.individualChatRoom,
          pdfs = _props.pdfs,
          files = _props.files,
          images = _props.images,
          videos = _props.videos,
          audios = _props.audios,
          isMessage = _props.isMessage,
          openPdf = _props.openPdf,
          openDoc = _props.openDoc,
          reactionChat = _props.reactionChat,
          likeConfig = _props.likeConfig,
          theme = _props.theme;


      var likes_count = message.likes ? message.likes.length : 0;

      var tooltip = message.likes.map(function (like) {
        return _react2.default.createElement(
          'div',
          { key: like.like_id },
          _react2.default.createElement(_avatar2.default, { image: like.user.icon_image.thumb_url, theme: theme }),
          '\xA0',
          like.user.name,
          ' \xA0',
          _react2.default.createElement('img', { style: { height: 16, width: 16 }, src: likeConfig && _emoji2.default[likeConfig[like.like_type].icon.replace('\\u', '')] })
        );
      });

      /* 同じlike_typeが配列内にある場合は除外する */
      var likesArray = message.likes && message.likes.reduce(function (prev, current) {
        if (!prev.some(function (e) {
          return e.like_type === current.like_type;
        })) {
          prev.push(current);
        }
        return prev;
      }, []);

      var htmlContent = message.message && (0, _emojiHelpers.convertEmojiHTML)(message.message.replace(UrlRegex, function (match) {
        return (0, _googleDoc2.default)(match) && _this3.renderGoogleDocUrl(match) || _this3.renderLink(match);
      })) || undefined;
      var isStamp = message.message && message.message.match(/<span class=['"]stamp [-a-zA-Z0-9]+["']><\/span>/);
      var direction = this.props.direction ? 'right' : 'left';
      var hasRead = message.user && (message.user.user_id == user.user_id || message.readers && _lodash2.default.find(message.readers, function (item) {
        return item.user_id == user.user_id;
      })) || false;

      var isReacted = message.likes.some(function (like) {
        return like.user.user_id === user.user_id;
      });

      var timeline_message;
      if (message.message_type) {
        switch (message.message_type) {
          case 'member_added':
            timeline_message = _react2.default.createElement(
              'div',
              { className: _chatMessage2.default.divider },
              _react2.default.createElement(
                'span',
                { className: _chatMessage2.default.span },
                t('label:メンバー入室', { name: message.user && message.user.name })
              )
            );
            break;
          case 'member_removed':
            timeline_message = _react2.default.createElement(
              'div',
              { className: _chatMessage2.default.divider },
              _react2.default.createElement(
                'span',
                { className: _chatMessage2.default.span },
                t('label:メンバー退室', { name: message.user && message.user.name })
              )
            );
            break;
          case 'name_changed':
            timeline_message = _react2.default.createElement(
              'div',
              { className: _chatMessage2.default.divider },
              _react2.default.createElement(
                'span',
                { className: _chatMessage2.default.span },
                t('label:チャットルーム名を変更', { name: message.name })
              )
            );
            break;
        }
      } else undefined;

      return _react2.default.createElement(
        'div',
        { ref: function ref(c) {
            return _this3.component = c;
          }, onDoubleClick: reactionChat },
        !message.message_type && _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(_chatMessage2.default.messageItem, direction),
            onMouseEnter: this.onCloseButton,
            onMouseLeave: this.offCloseButton },
          direction == 'right' && this.state.active && _react2.default.createElement(_font_icon2.default, { className: isStamp ? _chatMessage2.default.closeButtonStamp : _chatMessage2.default.closeButton,
            value: 'close',
            onClick: function onClick() {
              return _this3.setState({ isConfirm: true });
            } }),
          _react2.default.createElement(_confirmDialog2.default, { title: t('label:メッセージを削除'),
            description: t('label:この操作は取り消せません'),
            open: this.state.isConfirm,
            onYes: this.deleteChatMessage,
            onNo: this.cancelDeleteMessage,
            yesLabel: t('label:削除'),
            noLabel: t('label:取り消し') }),
          direction == 'left' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_avatar2.default, { className: 'chatIcon', image: message.user.icon_image.thumb_url, theme: _tinyAvatar2.default, onClick: function onClick() {
                return _this3.selectChatIcon(message.user, chatRoomMember);
              } })
          ),
          direction == 'right' && message.readers && message.readers.length > 0 && _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_chatMessage2.default.readers) },
            t('label:既読n', { n: message.readers.length > 1 ? message.readers.length : '' })
          ),
          _react2.default.createElement(
            'div',
            { className: _chatMessage2.default.contentDiv },
            withName && direction == 'left' && _react2.default.createElement(
              'div',
              { className: _chatMessage2.default.user },
              message.user.name || undefined
            ),
            !(isStamp || images.length > 0 || files.length > 0 || videos.length > 0 || audios.length > 0 || pdfs.length > 0) && _react2.default.createElement(
              'div',
              { style: { maxWidth: '' + chatPageWidth * 0.7 + 'px', display: 'inline-flex' },
                className: (0, _classnames2.default)(_chatMessage2.default.content, direction, direction == 'left' && withName && 'withName') },
              htmlContent && _react2.default.createElement('div', {
                className: _chatMessage2.default.messageText,
                dangerouslySetInnerHTML: { __html: htmlContent } })
            ),
            isStamp && _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: htmlContent } }),
            pdfs.length > 0 && this.state.pdfThumbnail && _lodash2.default.map(pdfs, function (pdf) {
              return _react2.default.createElement(
                'div',
                { className: _chatMessage2.default.pdfNameDiv },
                _react2.default.createElement('img', { key: pdf.file_id, src: pdf.file.thumb_url, onClick: function onClick() {
                    return _this3.showPdfPreview(pdf);
                  },
                  className: (0, _classnames2.default)(_chatMessage2.default.image, direction),
                  onError: _this3.onPdfThumbnailError,
                  style: { maxWidth: 0.8 * chatPageWidth, maxHeight: 300 } }),
                _react2.default.createElement(
                  'div',
                  { className: _chatMessage2.default.pdfName },
                  pdf.name
                )
              );
            }),
            pdfs.length > 0 && !this.state.pdfThumbnail && _lodash2.default.map(pdfs, function (pdf) {
              return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_attachmentFile2.default, { key: pdf.file_id, file: pdf, noTooltip: true, chat: true })
              );
            }),
            images.length > 0 && _lodash2.default.map(images, function (image) {
              return _react2.default.createElement('img', { ref: function ref(c) {
                  return _this3.image = c;
                },
                key: image.file_id, src: image.file.url, onClick: function onClick() {
                  return _this3.showImagesView(image);
                },
                className: (0, _classnames2.default)(_chatMessage2.default.image, direction),
                style: _this3.getSize(image, chatPageWidth) });
            }),
            videos.length > 0 && _lodash2.default.map(videos, function (video) {
              return _react2.default.createElement(
                'div',
                { key: video.video_id,
                  className: (0, _classnames2.default)(_chatMessage2.default.videoImageDiv),
                  onClick: function onClick() {
                    return _this3.showImagesView(video);
                  } },
                _react2.default.createElement('img', { ref: function ref(c) {
                    return _this3.image = c;
                  },
                  onLoad: function onLoad(ev) {
                    return _this3.onLoad(ev, video);
                  },
                  src: video.file.thumb_url,
                  className: (0, _classnames2.default)(_chatMessage2.default.image, direction),
                  style: _this3.state['width' + video.video_id] && _this3.state['height' + video.video_id] && _this3.getSize(video, chatPageWidth) }),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classnames2.default)(_chatMessage2.default.playArrow, direction) },
                  _react2.default.createElement(_avatar2.default, { icon: 'play_arrow' })
                )
              );
            }),
            audios.length > 0 && _lodash2.default.map(audios, function (audio) {
              var Component = audio.showTooltip ? TooltipLink : _link2.default;
              return _react2.default.createElement(
                Component,
                { key: audio.video_id,
                  className: (0, _classnames2.default)(_chatMessage2.default.videoImageDiv),
                  tooltip: audio.name,
                  download: false,
                  theme: _attachments2.default,
                  style: { display: 'inline' },
                  onClick: function onClick() {
                    return _this3.setState(_defineProperty({}, 'isPlay' + audio.video_id, true));
                  } },
                !_this3.state['isPlay' + audio.video_id] && _react2.default.createElement(
                  _chip2.default,
                  { className: (0, _classnames2.default)(_attachments2.default.chip, 'audiotrack') },
                  _react2.default.createElement(_avatar2.default, { className: (0, _classnames2.default)(_attachments2.default.avatar, 'audiotrack'), icon: 'audiotrack' }),
                  audio.filename
                ),
                _this3.state['isPlay' + audio.video_id] && _react2.default.createElement(_videoViewer2.default, { video: audio, t: t, parent_component: 'CHAT_MESSAGE', onEnd: function onEnd() {
                    return _this3.setState(_defineProperty({}, 'isPlay' + audio.video_id, false));
                  } })
              );
            }),
            _lodash2.default.map(files, function (file) {
              var Component = file.showTooltip ? TooltipLink : _link2.default;
              return _react2.default.createElement(
                Component,
                _defineProperty({ key: file.file_id,
                  href: file.status ? undefined : file.file.url,
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  className: direction == 'left' ? _chatMessage2.default.file : undefined,
                  style: { cursor: file.status && 'default' },
                  tooltip: file.name,
                  download: !file.isPdf || file.status ? true : false,
                  theme: _attachments2.default
                }, 'style', { display: 'inline' }),
                _react2.default.createElement(
                  _chip2.default,
                  { className: _attachments2.default.chipChat,
                    style: { cursor: file.status && 'default' } },
                  _react2.default.createElement(_avatar2.default, { className: file.status && file.status != 'committed' ? undefined : (0, _classnames2.default)(_attachments2.default.avatar, 'attach_file'), icon: "attach_file" }),
                  file.filename
                )
              );
            }),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center' } },
              direction === 'left' && _react2.default.createElement(
                'span',
                {
                  className: 'material-icons',
                  onClick: this.handleReactclick,
                  style: {
                    position: 'relative',
                    color: isReacted ? '#FEE876' : 'white',
                    fontSize: 14,
                    paddingTop: 5,
                    marginLeft: 20,
                    cursor: 'pointer',
                    userSelect: 'none', // Prevent selection
                    WebkitUserSelect: 'none', // Safari support
                    MozUserSelect: 'none', // Firefox support
                    MsUserSelect: 'none' // IE/Edge support
                  }
                },
                isReacted ? 'thumb_up' : 'thumb_up_off_alt'
              ),
              likes_count > 0 && _react2.default.createElement(
                TooltipButton,
                {
                  neutral: false,
                  ripple: false,
                  className: 'touchable ' + _chatMessage2.default.chatReactions,
                  tooltipPosition: 'vertical',
                  tooltip: tooltip,
                  onDoubleClick: function onDoubleClick(e) {
                    return e.preventDefault();
                  },
                  onClick: reactionChat
                },
                likesArray.length > 3 ? likesArray.slice(likesArray.length - 3, likesArray.length).map(function (like) {
                  return _react2.default.createElement('img', {
                    key: like.like_id,
                    style: { height: 16, width: 16 },
                    src: likeConfig && _emoji2.default[likeConfig[like.like_type].icon.replace('\\u', '')]
                  });
                }) : likesArray.slice(0, 3).map(function (like) {
                  return _react2.default.createElement('img', {
                    key: like.like_id,
                    style: { height: 12, width: 12 },
                    src: likeConfig && _emoji2.default[likeConfig[like.like_type].icon.replace('\\u', '')]
                  });
                }),
                '\xA0',
                t('label:n', { n: likes_count })
              )
            )
          ),
          ui.openDialog && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_userDetailsModal2.default, { chatMessage: true,
              t: t,
              user: ui.user,
              current_user: user,
              onClose: function onClose() {
                return updateUI({ user: undefined, openDialog: false });
              },
              open: ui.openDialog,
              individualChatRoom: individualChatRoom })
          )
        ) || _react2.default.createElement(
          'span',
          null,
          timeline_message
        )
      );
    }
  }]);

  return ChatMessageItem;
}(_react2.default.Component);

exports.default = (0, _chatMessageItem2.default)(ChatMessageItem);

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/**
* src/connects/chat-message-item.js
* 
*/

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _user = __webpack_require__(177);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isImage(file) {
  return file.content_type.match(/^image/);
}

function isPdf(file) {
  return file.content_type.match(/^application\/pdf/);
}

function isVideo(file) {
  return file.content_type.match(/^video/) && file.status == 'committed';
}

function isAudio(file) {
  return file.content_type.match(/^audio/) && file.status == 'committed';
}

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var files = ownProps.message.files && (0, _filter2.default)(ownProps.message.files, function (file) {
    return !isImage(file) && !isVideo(file) && !isAudio(file) && !isPdf(file);
  }).map(function (file) {
    var num = file && file.name.lastIndexOf('.');
    var basename = num != -1 && file.name.slice(0, num) || file.name;
    var extension = num != -1 && file.name.slice(num + 1, file.name.length) || '';
    file.filename = basename.length > 10 ? basename.slice(0, 10) + '...' + extension : file.name;
    file.showTooltip = basename.length > 10 ? true : false;
    return file;
  }) || [];

  var images = ownProps.message.files && (0, _filter2.default)(ownProps.message.files, function (file) {
    return isImage(file);
  }) || [];
  var videos = ownProps.message.files && (0, _filter2.default)(ownProps.message.files, function (file) {
    return isVideo(file);
  }) || [];
  var pdfs = ownProps.message.files && (0, _filter2.default)(ownProps.message.files, function (file) {
    return isPdf(file);
  }).map(function (file) {
    var num = file && file.name.lastIndexOf('.');
    var basename = num != -1 && file.name.slice(0, num) || file.name;
    var extension = num != -1 && file.name.slice(num + 1, file.name.length) || '';
    file.filename = basename.length > 10 ? basename.slice(0, 10) + '...' + extension : file.name;
    return file;
  }) || [];

  var audios = ownProps.message.files && (0, _filter2.default)(ownProps.message.files, function (file) {
    return isAudio(file);
  }).map(function (file) {
    var num = file && file.name.lastIndexOf('.');
    var basename = num != -1 && file.name.slice(0, num) || file.name;
    var extension = num != -1 && file.name.slice(num + 1, file.name.length) || '';
    file.filename = basename.length > 10 ? basename.slice(0, 10) + '...' + extension : file.name;
    file.showTooltip = basename.length > 10 ? true : false;
    file.isAudio = true;
    return file;
  }) || [];

  var isMessage = files.length == 0 && images.length == 0 && videos.length == 0 && audios.length == 0 && pdfs.length == 0;

  return _extends({}, stateProps, dispatchProps, ownProps, {
    pdfs: pdfs,
    files: files,
    images: images,
    videos: videos,
    audios: audios,
    isMessage: isMessage
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showGoogleDoc: function showGoogleDoc(url) {
      dispatch(_actions2.default.openRightSidePage('google_doc', { url: url }, true));
    },
    showPdfPreview: function showPdfPreview(file) {
      dispatch(_actions2.default.openRightSidePage('pdf_preview', { file: file }, true));
    },
    notChatRoomMember: function notChatRoomMember() {
      return dispatch((0, _alertMessage.emitAlertMessage)('label:対象ユーザーはこのチャットルームには参加していません。', 'error'));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(undefined, mapDispatchToProps, mergeProps), (0, _uiState2.default)({
  state: {
    user: undefined,
    openDialog: false
  }
}), (0, _context2.default)({ showImagesView: _propTypes2.default.func }), (0, _reactI18next.translate)());

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.chat-message--divider--2rmS9LbE {\n  clear: both;\n  font-size: 80%;\n  font-weight: bold;\n  color: white;\n  text-align: center;\n}\n\n.chat-message--messageItem--glEFHemE {\n  clear: both;\n  position: relative;\n  padding: 5px 12px;\n  font-size: 14px;\n  display: table;\n}\n\n.chat-message--messageItem--glEFHemE[class~=right] {\n  float: right;\n}\n\n.chat-message--messageItem--glEFHemE[class~=left] {\n  float: left;\n}\n\n.chat-message--readers--2x5Es9CN {\n  color: white;\n  font-weight: bold;\n  font-size: 70%;\n  margin-top: 3px;\n  padding-right: 2px;\n  display: table-cell;\n  vertical-align: bottom;\n}\n\n.chat-message--user--Z1hPQAS2 {\n  margin: 3px;\n  margin-left: 10px;\n  font-size: 12px;\n}\n\n.chat-message--content--SJeqNHMh {\n  padding: 6px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border-radius: 20px;\n}\n\n.chat-message--content--SJeqNHMh p {\n  margin: 0;\n}\n\n.chat-message--content--SJeqNHMh ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.chat-message--content--SJeqNHMh ol {\n  margin: 0;\n  padding-left: 1.5em;\n  text-indent: -1.5em;\n  list-style-position: inside;\n}\n\n/* これは箇条書きにURLリンクがある時のスタイル + image画像やチェックボックスとURLリンクを一緒にした時のスタイル */\n\n.chat-message--content--SJeqNHMh ol li div, .chat-message--content--SJeqNHMh input ~ div, .chat-message--content--SJeqNHMh img ~ div, .chat-message--content--SJeqNHMh input ~ span div, .chat-message--content--SJeqNHMh img ~ span div, .chat-message--content--SJeqNHMh span ~ div {\n  display: inline;\n}\n\n.chat-message--content--SJeqNHMh ul li div[class~=googleDocIcon] {\n  display: inline-block;\n}\n\n/* 箇条書きにURLリンクがあり、class=googleDocにmaterial-iconsが適用した時のスタイル */\n\n.chat-message--content--SJeqNHMh ol li a[class~=googleDoc] span{\n  margin-left: 20px;\n}\n\n/* 箇条書きにURLリンクがあり、class=materialIconが適用された時のスタイル */\n\n.chat-message--content--SJeqNHMh ol li a[class~=chatMaterialIcon],.chat-message--content--SJeqNHMh ol li a[class~=gambaUrl],.chat-message--content--SJeqNHMh ol li div a[class~=googleDocIcon]  {\n  padding: 3px 10px 3px 20px!important;\n}\n\n/* 箇条書きにURLリンクがあり、class=materialIconが適用された時のスタイル */\n\n.chat-message--content--SJeqNHMh ol li div a[class~=chatMaterialIcon],.chat-message--content--SJeqNHMh ol li div a[class~=googleDoc] {\n  padding: 3px 10px 3px 25px!important;\n}\n\n.chat-message--content--SJeqNHMh ol li a[class~=chatMaterialIcon] span,.chat-message--content--SJeqNHMh ol li a[class~=gambaUrl] span {\n  margin-left: 10px;\n}\n\n.chat-message--content--SJeqNHMh:before {\n  z-index: 0;\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  width: 0;\n  height: 0;\n  border-top: 2px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid transparent;\n}\n\n.chat-message--content--SJeqNHMh[class~=right] {\n  background: #99FF66;\n  border: 1px solid #99FF66;\n  margin-right: 3px;\n}\n\n.chat-message--content--SJeqNHMh[class~=right]:before {\n  border-left: 20px solid #99FF66;\n  right: 0;\n}\n\n.chat-message--content--SJeqNHMh[class~=left] {\n  background: white;\n  border: 1px solid white;\n  margin-left: 10px;\n}\n\n.chat-message--content--SJeqNHMh[class~=left]:before {\n  border-right: 20px solid white;\n  left: 0;\n  margin-left: 45px;\n}\n\n.chat-message--content--SJeqNHMh[class~=withName] {\n  margin-top: -3px;\n}\n\n.chat-message--content--SJeqNHMh[class~=withName]:before {\n  margin-top: 22px;\n}\n\n.chat-message--messageText--2NWihdae {\n  padding-right: 10px;\n  padding-left: 10px;\n  word-wrap: break-word;\n}\n\n.chat-message--image--3xFYr4V_ {\n  display: block;\n  margin: 3px auto;\n  cursor: pointer;\n  margin-left: 5px;\n  border-radius: 20px;\n}\n\n.chat-message--image--3xFYr4V_[class~=left] {\n  margin-left: 10px;\n}\n\n.chat-message--pdfNameDiv--1Xy2-Yad {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.chat-message--pdfName--2d9RGgrk {\n  position: absolute;\n  left: 8px;\n  right: 0px;\n  color: #EEE;\n  background: rgba(0, 0, 0, .6);\n  padding: 3px 20px;\n}\n\n.chat-message--contentDiv--YU9vizrT {\n  display: table-cell;\n  vertical-align: top;\n}\n\n.chat-message--file--W1NHgjZH {\n  display: inline;\n  margin-left: 10px;\n}\n\n.chat-message--span--2b3d2fXx {\n  border-radius: 20px;\n  background-Color: #8EB8FF;\n  padding-right: 5px;\n  padding-left: 5px;\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n.chat-message--baseDiv--2SMuT6_8 {\n  position: relative;\n}\n\n.chat-message--closeButton--2GT-X7tT {\n  margin-top: -5px;\n  margin-right: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  color: gray;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.chat-message--closeButtonStamp--2hDTANv5 {\n  margin-top: 10px;\n  margin-right: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  color: gray;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.chat-message--videoImageDiv--1P1p596u {\n  position: relative;\n  cursor: pointer;\n  overflow: hidden;\n  display: inline-block;\n}\n\n.chat-message--videoImageDiv--1P1p596u[class~=right] {\n  float: right;\n}\n\n.chat-message--videoImageDiv--1P1p596u[class~=left] {\n  float: left;\n}\n\n.chat-message--playArrow--2YCJT07O {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0, 1);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  display: -webkit-flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.chat-message--playArrow--2YCJT07O[class~=right] {\n  float: right;\n}\n\n.chat-message--playArrow--2YCJT07O[class~=left] {\n  float: left;\n  margin-left: 10px;\n}\n\n.chat-message--chatReactions--3dVlN4xf {\n  left: 5px;\n  float: left;\n  background-color: white;\n  border-radius: 12px;\n  min-width: 35px !important;\n  padding: 0 !important;\n  border: 1px solid #8EB8FF !important;\n  line-height: 0;\n  font-size: 12px;\n  height: 22px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/chat-message.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;CACpB;;AAED;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;CAChB;;AAED;EACE,aAAa;CACd;;AAED;EACE,YAAY;CACb;;AAED;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;CACxB;;AAED;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;CACjB;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;CACrB;;AAED;EACE,UAAU;CACX;;AAED;EACE,UAAU;EACV,mBAAmB;CACpB;;AAED;EACE,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,4BAA4B;CAC7B;;AAED,mEAAmE;;AAEnE;EACE,gBAAgB;CACjB;;AAED;EACE,sBAAsB;CACvB;;AAED,8DAA8D;;AAE9D;EACE,kBAAkB;CACnB;;AAED,mDAAmD;;AAEnD;EACE,qCAAqC;CACtC;;AAED,mDAAmD;;AAEnD;EACE,qCAAqC;CACtC;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,oCAAoC;EACpC,qCAAqC;EACrC,mCAAmC;CACpC;;AAED;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;CACnB;;AAED;EACE,gCAAgC;EAChC,SAAS;CACV;;AAED;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;CACnB;;AAED;EACE,+BAA+B;EAC/B,QAAQ;EACR,kBAAkB;CACnB;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;CACvB;;AAED;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;CACrB;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;;AAED;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;CACnB;;AAED;EACE,oBAAoB;EACpB,oBAAoB;CACrB;;AAED;EACE,gBAAgB;EAChB,kBAAkB;CACnB;;AAED;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;CACpB;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;CACjB;;AAED;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;CACjB;;AAED;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;CACvB;;AAED;EACE,aAAa;CACd;;AAED;EACE,YAAY;CACb;;AAED;EACE,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;MAClB,wBAAwB;EAC5B,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;CAC7B;;AAED;EACE,aAAa;CACd;;AAED;EACE,YAAY;EACZ,kBAAkB;CACnB;;AAED;EACE,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,aAAa;CACd","file":"chat-message.css","sourcesContent":["\n.divider {\n  clear: both;\n  font-size: 80%;\n  font-weight: bold;\n  color: white;\n  text-align: center;\n}\n\n.messageItem {\n  clear: both;\n  position: relative;\n  padding: 5px 12px;\n  font-size: 14px;\n  display: table;\n}\n\n.messageItem[class~=right] {\n  float: right;\n}\n\n.messageItem[class~=left] {\n  float: left;\n}\n\n.readers {\n  color: white;\n  font-weight: bold;\n  font-size: 70%;\n  margin-top: 3px;\n  padding-right: 2px;\n  display: table-cell;\n  vertical-align: bottom;\n}\n\n.user {\n  margin: 3px;\n  margin-left: 10px;\n  font-size: 12px;\n}\n\n.content {\n  padding: 6px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border-radius: 20px;\n}\n\n.content p {\n  margin: 0;\n}\n\n.content ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.content ol {\n  margin: 0;\n  padding-left: 1.5em;\n  text-indent: -1.5em;\n  list-style-position: inside;\n}\n\n/* これは箇条書きにURLリンクがある時のスタイル + image画像やチェックボックスとURLリンクを一緒にした時のスタイル */\n\n.content ol li div, .content input ~ div, .content img ~ div, .content input ~ span div, .content img ~ span div, .content span ~ div {\n  display: inline;\n}\n\n.content ul li div[class~=googleDocIcon] {\n  display: inline-block;\n}\n\n/* 箇条書きにURLリンクがあり、class=googleDocにmaterial-iconsが適用した時のスタイル */\n\n.content ol li a[class~=googleDoc] span{\n  margin-left: 20px;\n}\n\n/* 箇条書きにURLリンクがあり、class=materialIconが適用された時のスタイル */\n\n.content ol li a[class~=chatMaterialIcon],.content ol li a[class~=gambaUrl],.content ol li div a[class~=googleDocIcon]  {\n  padding: 3px 10px 3px 20px!important;\n}\n\n/* 箇条書きにURLリンクがあり、class=materialIconが適用された時のスタイル */\n\n.content ol li div a[class~=chatMaterialIcon],.content ol li div a[class~=googleDoc] {\n  padding: 3px 10px 3px 25px!important;\n}\n\n.content ol li a[class~=chatMaterialIcon] span,.content ol li a[class~=gambaUrl] span {\n  margin-left: 10px;\n}\n\n.content:before {\n  z-index: 0;\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  width: 0;\n  height: 0;\n  border-top: 2px solid transparent;\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid transparent;\n}\n\n.content[class~=right] {\n  background: #99FF66;\n  border: 1px solid #99FF66;\n  margin-right: 3px;\n}\n\n.content[class~=right]:before {\n  border-left: 20px solid #99FF66;\n  right: 0;\n}\n\n.content[class~=left] {\n  background: white;\n  border: 1px solid white;\n  margin-left: 10px;\n}\n\n.content[class~=left]:before {\n  border-right: 20px solid white;\n  left: 0;\n  margin-left: 45px;\n}\n\n.content[class~=withName] {\n  margin-top: -3px;\n}\n\n.content[class~=withName]:before {\n  margin-top: 22px;\n}\n\n.messageText {\n  padding-right: 10px;\n  padding-left: 10px;\n  word-wrap: break-word;\n}\n\n.image {\n  display: block;\n  margin: 3px auto;\n  cursor: pointer;\n  margin-left: 5px;\n  border-radius: 20px;\n}\n\n.image[class~=left] {\n  margin-left: 10px;\n}\n\n.pdfNameDiv {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.pdfName {\n  position: absolute;\n  left: 8px;\n  right: 0px;\n  color: #EEE;\n  background: rgba(0, 0, 0, .6);\n  padding: 3px 20px;\n}\n\n.contentDiv {\n  display: table-cell;\n  vertical-align: top;\n}\n\n.file {\n  display: inline;\n  margin-left: 10px;\n}\n\n.span {\n  border-radius: 20px;\n  background-Color: #8EB8FF;\n  padding-right: 5px;\n  padding-left: 5px;\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n.baseDiv {\n  position: relative;\n}\n\n.closeButton {\n  margin-top: -5px;\n  margin-right: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  color: gray;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.closeButtonStamp {\n  margin-top: 10px;\n  margin-right: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  color: gray;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.videoImageDiv {\n  position: relative;\n  cursor: pointer;\n  overflow: hidden;\n  display: inline-block;\n}\n\n.videoImageDiv[class~=right] {\n  float: right;\n}\n\n.videoImageDiv[class~=left] {\n  float: left;\n}\n\n.playArrow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0, 1);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  display: -webkit-flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.playArrow[class~=right] {\n  float: right;\n}\n\n.playArrow[class~=left] {\n  float: left;\n  margin-left: 10px;\n}\n\n.chatReactions {\n  left: 5px;\n  float: left;\n  background-color: white;\n  border-radius: 12px;\n  min-width: 35px !important;\n  padding: 0 !important;\n  border: 1px solid #8EB8FF !important;\n  line-height: 0;\n  font-size: 12px;\n  height: 22px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"divider": "chat-message--divider--2rmS9LbE",
	"messageItem": "chat-message--messageItem--glEFHemE",
	"readers": "chat-message--readers--2x5Es9CN",
	"user": "chat-message--user--Z1hPQAS2",
	"content": "chat-message--content--SJeqNHMh",
	"messageText": "chat-message--messageText--2NWihdae",
	"image": "chat-message--image--3xFYr4V_",
	"pdfNameDiv": "chat-message--pdfNameDiv--1Xy2-Yad",
	"pdfName": "chat-message--pdfName--2d9RGgrk",
	"contentDiv": "chat-message--contentDiv--YU9vizrT",
	"file": "chat-message--file--W1NHgjZH",
	"span": "chat-message--span--2b3d2fXx",
	"baseDiv": "chat-message--baseDiv--2SMuT6_8",
	"closeButton": "chat-message--closeButton--2GT-X7tT",
	"closeButtonStamp": "chat-message--closeButtonStamp--2hDTANv5",
	"videoImageDiv": "chat-message--videoImageDiv--1P1p596u",
	"playArrow": "chat-message--playArrow--2YCJT07O",
	"chatReactions": "chat-message--chatReactions--3dVlN4xf"
};

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2681);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./tiny-avatar.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./tiny-avatar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.tiny-avatar--avatar--35TzPlx9 {\n  height: 40px;\n  width: 40px;\n  min-width: 40px;\n  vertical-align: top;\n}\n\n.tiny-avatar--avatar--35TzPlx9[class~=chatIcon] {\n  cursor: pointer;\n}\n  ", "", {"version":3,"sources":["/./src/web/components/themes/tiny-avatar.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;CACrB;;AAED;EACE,gBAAgB;CACjB","file":"tiny-avatar.css","sourcesContent":["\n.avatar {\n  height: 40px;\n  width: 40px;\n  min-width: 40px;\n  vertical-align: top;\n}\n\n.avatar[class~=chatIcon] {\n  cursor: pointer;\n}\n  "],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"avatar": "tiny-avatar--avatar--35TzPlx9"
};

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _userDetailsModal = __webpack_require__(2683);

var _userDetailsModal2 = _interopRequireDefault(_userDetailsModal);

var _button = __webpack_require__(8);

var _dialog = __webpack_require__(47);

var _diaryContent = __webpack_require__(239);

var _diaryContent2 = _interopRequireDefault(_diaryContent);

var _favoriteButton = __webpack_require__(1069);

var _favoriteButton2 = _interopRequireDefault(_favoriteButton);

var _userDetailsModal3 = __webpack_require__(2684);

var _userDetailsModal4 = _interopRequireDefault(_userDetailsModal3);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * src/web/components/user-details-modal.jsx
 * ユーザアイコンをクリックすると、サムネイルを拡大表示し、
 * そこからお気に入り登録、投稿・月間の日報提出状況の表示ができる。
 */

var UserDetailsModal = function (_React$Component) {
  _inherits(UserDetailsModal, _React$Component);

  function UserDetailsModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserDetailsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserDetailsModal.__proto__ || Object.getPrototypeOf(UserDetailsModal)).call.apply(_ref, [this].concat(args))), _this), _this.showUserTimeline = function (group_id, user) {
      _this.props.onClose();
      _this.props.showUserTimeline(group_id, user);
    }, _this.showSummary = function () {
      _this.props.onClose();
      _this.props.showSummary();
    }, _this.showChatRooms = function () {
      _this.props.onClose();
      _this.props.showChatRooms();
    }, _this.openChatRoom = function (props) {
      _this.props.openChatRoom(props);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserDetailsModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          user = _props.user,
          current_user = _props.current_user,
          group = _props.group,
          showUserTimeline = _props.showUserTimeline,
          onClose = _props.onClose,
          showSummary = _props.showSummary,
          _props$open = _props.open,
          open = _props$open === undefined ? false : _props$open,
          isFavorite = _props.isFavorite,
          isCreating = _props.isCreating,
          isCreateFailed = _props.isCreateFailed,
          created = _props.created,
          toggleFavoriteUser = _props.toggleFavoriteUser,
          showChatRooms = _props.showChatRooms,
          openChatRoom = _props.openChatRoom,
          chatMessage = _props.chatMessage,
          individualChatRoom = _props.individualChatRoom;


      var is_favorite = user && isFavorite(user, this.props);

      var dialogAction = [{ label: t('label:日報提出状況'), onClick: function onClick() {
          return _this2.showSummary();
        }, raised: true }, { label: t('label:投稿を見る'), onClick: function onClick() {
          return _this2.showUserTimeline(group.group_id, user);
        }, raised: true, primary: true }, { label: t('label:チャットをする'), onClick: function onClick() {
          return _this2.openChatRoom(_this2.props);
        }, disabled: current_user.user_id != user.user_id ? false : true, raised: true, theme: _successButton2.default }];

      var chatDialogAction = !individualChatRoom && [{ label: t('label:チャットをする'), onClick: function onClick() {
          return _this2.openChatRoom(_this2.props);
        }, disabled: current_user.user_id != user.user_id ? false : true, raised: true, theme: _successButton2.default }] || undefined;

      return _react2.default.createElement(
        _dialog.Dialog,
        { active: open,
          theme: _userDetailsModal4.default,
          avoidKeyboard: false,
          onEscKeyDown: onClose,
          onOverlayClick: onClose,
          actions: chatMessage ? chatDialogAction : dialogAction },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: _userDetailsModal4.default.rightClose },
            _react2.default.createElement(_button.IconButton, { icon: 'close', onClick: onClose })
          ),
          !chatMessage && current_user.user_id != user.user_id && _react2.default.createElement(
            'div',
            { className: _userDetailsModal4.default.rightFollow },
            _react2.default.createElement(_button.Button, { className: is_favorite ? 'favorite' : '', icon: is_favorite ? "flag" : "outlined_flag", theme: _favoriteButton2.default,
              label: is_favorite ? t("label:フォロー中") : t("label:フォロー"),
              onClick: function onClick() {
                return toggleFavoriteUser(user, is_favorite);
              } })
          ),
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'center' } },
            _react2.default.createElement('img', { className: _userDetailsModal4.default.userImage, src: user.icon_image.thumb_url, style: { alignSelf: 'center', margin: 10, marginTop: 0 } }),
            _react2.default.createElement(
              'p',
              { style: { alignSelf: 'center', marginBottom: 5 } },
              user.name
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'center', marginBottom: '10px', padding: '0px' } },
            _react2.default.createElement(_diaryContent2.default, { comment: true, content: user.description && user.description || '', modalContent: true })
          )
        )
      );
    }
  }]);

  return UserDetailsModal;
}(_react2.default.Component);

exports.default = (0, _userDetailsModal2.default)(UserDetailsModal);

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _reactI18next = __webpack_require__(2);

var _alertMessage = __webpack_require__(13);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var isBlock = ownProps.user && (0, _find2.default)(state.block.users, function (user) {
    return user.user_id == ownProps.user.user_id;
  });
  return {
    favoriteUsers: state.favorite.users,
    isCreating: state.chatRooms.isCreating,
    isCreateFailed: state.chatRooms.isCreateFailed,
    created: state.chatRooms.created,
    isBlock: !!isBlock
  };
};
// src/connects/user-details-modal.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount() {
      return dispatch(_actions2.default.fetchFavoriteUsers());
    },
    showUserTimeline: function showUserTimeline(group_id, user) {
      return dispatch(_actions2.default.openRightSidePage('user_timeline', { group_id: group_id, user_id: user.user_id, user: user }));
    },
    openChatRoom: function openChatRoom(props) {
      if (props.current_user.user_id != props.user.user_id) {
        var chatuser = [props.user.user_id];
        dispatch(_actions2.default.createChatRoom(chatuser));
      } else {
        dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:ご自身のユーザーでチャットを行うことはできません' }, 'error'));
      }
    },
    isFavorite: function isFavorite(user, props) {
      return !!(0, _find2.default)(props.favoriteUsers, function (_user) {
        return _user.user_id == user.user_id;
      });
    },
    toggleFavoriteUser: function toggleFavoriteUser(user, isFavorite) {
      dispatch(_actions2.default.updateFavoriteUser(user.user_id, !isFavorite));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: !isFavorite ? 'label:お気に入りユーザに追加しました' : 'label:お気に入りユーザから削除しました', name: user && user.name }, 'success'));
    },
    willUpdate: function willUpdate(props, nextProps) {
      if (nextProps.open && props.isCreating && !nextProps.isCreating && !nextProps.isCreateFailed && nextProps.created) {
        dispatch(_actions2.default.openRightSidePage('chat_messages', { chat_room_id: nextProps.created.chat_room_id }));
        nextProps.onClose && nextProps.onClose();
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2685);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./user-details-modal.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./user-details-modal.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".user-details-modal--userImage--31W57CoP {\n  vertical-align: middle;\n  width: 100px;\n  height: 100px;\n  border-radius: 100px;\n}\n\n.user-details-modal--dialog--ACgRVrf8 {\n  width: 400px;\n}\n\n.user-details-modal--body--m8jKPvdq {\n  text-align: center;\n  padding: 0px;\n}\n\n.user-details-modal--rightClose--3h7HHn1y {\n  text-align: right;\n  margin-right: 5px;\n}\n\n.user-details-modal--rightFollow--xoXwrPnZ {\n  text-align: right;\n  margin-right: 20px;\n}\n\n.user-details-modal--navigation--3GgApw8U {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 0px auto;\n}\n\n.user-details-modal--button--3L0OaaKD {\n  margin: 5px auto 5px auto;\n  width: 250px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/user-details-modal.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,qBAAqB;CACtB;;AAED;EACE,aAAa;CACd;;AAED;EACE,mBAAmB;EACnB,aAAa;CACd;;AAED;EACE,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,kBAAkB;EAClB,mBAAmB;CACpB;;AAED;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,iBAAiB;CAClB;;AAED;EACE,0BAA0B;EAC1B,aAAa;CACd","file":"user-details-modal.css","sourcesContent":[".userImage {\n  vertical-align: middle;\n  width: 100px;\n  height: 100px;\n  border-radius: 100px;\n}\n\n.dialog {\n  width: 400px;\n}\n\n.body {\n  text-align: center;\n  padding: 0px;\n}\n\n.rightClose {\n  text-align: right;\n  margin-right: 5px;\n}\n\n.rightFollow {\n  text-align: right;\n  margin-right: 20px;\n}\n\n.navigation {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 0px auto;\n}\n\n.button {\n  margin: 5px auto 5px auto;\n  width: 250px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"userImage": "user-details-modal--userImage--31W57CoP",
	"dialog": "user-details-modal--dialog--ACgRVrf8",
	"body": "user-details-modal--body--m8jKPvdq",
	"rightClose": "user-details-modal--rightClose--3h7HHn1y",
	"rightFollow": "user-details-modal--rightFollow--xoXwrPnZ",
	"navigation": "user-details-modal--navigation--3GgApw8U",
	"button": "user-details-modal--button--3L0OaaKD"
};

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawChatMessageForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _chatMessageForm = __webpack_require__(2687);

var _chatMessageForm2 = _interopRequireDefault(_chatMessageForm);

var _button = __webpack_require__(8);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _fileUploadButton = __webpack_require__(180);

var _fileUploadButton2 = _interopRequireDefault(_fileUploadButton);

var _richTextEditor = __webpack_require__(181);

var _richTextEditor2 = _interopRequireDefault(_richTextEditor);

var _diaryFormButton = __webpack_require__(290);

var _diaryFormButton2 = _interopRequireDefault(_diaryFormButton);

var _messageStorage = __webpack_require__(1090);

var _messageStorage2 = _interopRequireDefault(_messageStorage);

var _diaryUrlLinks = __webpack_require__(1091);

var _diaryUrlLinks2 = _interopRequireDefault(_diaryUrlLinks);

var _confirmGoogleLogin = __webpack_require__(1092);

var _confirmGoogleLogin2 = _interopRequireDefault(_confirmGoogleLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/chat-message-form.jsx

var UNSUBMIT_MESSAGE = 'gambaApp.unSubmitMessage';

var ChatMessageForm = function (_React$Component) {
  _inherits(ChatMessageForm, _React$Component);

  function ChatMessageForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChatMessageForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatMessageForm.__proto__ || Object.getPrototypeOf(ChatMessageForm)).call.apply(_ref, [this].concat(args))), _this), _this.uploadFiles = function (files) {
      return _this.props.uploadFiles(_this.props, files);
    }, _this.showStampPalette = function () {
      return _this.props.showStampPalette(function (code) {
        return _this.props.postStampMessage(code);
      }, true);
    }, _this.onChangeEditor = function (event) {
      // Check if event and event.nativeEvent exist
      if (event && event.nativeEvent && event.nativeEvent.isComposing) {
        return; // Prevent premature updates during IME composition
      }
      _this.props.onChangeEditor(_this.props);
    }, _this.cancelMessage = function () {
      _this.props.cancelMessage(_this.props);
      _messageStorage2.default.getItem(UNSUBMIT_MESSAGE).then(function (canselMessage) {
        var canselMessages = JSON.parse(canselMessage || '[]');
        var canselFilter = _.filter(canselMessages, function (_canselMessage) {
          return _canselMessage.id !== _this.props.chatRoom.chat_room_id;
        });
        _messageStorage2.default.setItem(UNSUBMIT_MESSAGE, JSON.stringify(canselFilter));
      }).catch(function () {
        return undefined;
      });
    }, _this.onEditorInitialized = function (handlers) {
      _this.props.updateUI({ handlers: handlers });
      if (_this.unsubmitMessage) {
        setTimeout(function () {
          handlers.insertValue(_this.unsubmitMessage);_this.unsubmitMessage = undefined;
        }, 0);
      }
    }, _this.postChatMessage = function () {
      _this.props.postChatMessage(_this.props);
      _messageStorage2.default.getItem(UNSUBMIT_MESSAGE).then(function (submitMessage) {
        var submitMessages = JSON.parse(submitMessage || '[]');
        var submitFilter = _.filter(submitMessages, function (_submitMessage) {
          return _submitMessage.id !== _this.props.chatRoom.chat_room_id;
        });
        _messageStorage2.default.setItem(UNSUBMIT_MESSAGE, JSON.stringify(submitFilter));
      }).catch(function () {
        return undefined;
      });
    }, _this.onAddLink = function (link) {
      return _this.props.onAddLink(_this.props, link);
    }, _this.onDeleteLink = function (link) {
      return _this.props.onDeleteLink(_this.props, link);
    }, _this.onCancelConfirmGapi = function () {
      return _this.props.onCancelConfirmGapi(_this.props);
    }, _this.onSuccessConfirmGapi = function () {
      return _this.props.onSuccessConfirmGapi(_this.props);
    }, _this.onFocus = function () {
      return _this.props.updateUI({ hasFocus: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChatMessageForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _messageStorage2.default.getItem(UNSUBMIT_MESSAGE).then(function (_unsubmitMessage) {
        var unSubmitMessage = JSON.parse(_unsubmitMessage);
        var unSubmitIndex = _.findIndex(unSubmitMessage, function (_unSubmitMessage) {
          return _unSubmitMessage.id == _this2.props.chatRoom.chat_room_id;
        });
        if (_this2.props.ui.handlers) _this2.props.ui.handlers.insertValue(unSubmitMessage[unSubmitIndex].message);else _this2.unsubmitMessage = unSubmitMessage[unSubmitIndex].message;
      }).catch(function () {
        return undefined;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          isPosting = _props.isPosting,
          chatRoom = _props.chatRoom,
          postChatMessage = _props.postChatMessage,
          postStampMessage = _props.postStampMessage,
          cancelMessage = _props.cancelMessage,
          onChangeMessage = _props.onChangeMessage,
          uploadFiles = _props.uploadFiles,
          uploadedFiles = _props.uploadedFiles,
          uploadedVideos = _props.uploadedVideos,
          showStampPalette = _props.showStampPalette,
          updateUI = _props.updateUI,
          onChangeEditor = _props.onChangeEditor,
          showGoogleDoc = _props.showGoogleDoc,
          showGambaUrl = _props.showGambaUrl,
          urlInfo = _props.urlInfo;


      return _react2.default.createElement(
        'div',
        { style: {} },
        uploadedFiles && _.map(uploadedFiles, function (file, key) {
          return file && file.isUploading && _react2.default.createElement(_progress_bar2.default, { key: key, multicolor: true,
            mode: file.total && 'determinate' || 'indeterminate',
            value: file.total && file.loaded && file.loaded * 100 / file.total });
        }),
        uploadedVideos && _.map(uploadedVideos, function (video, key) {
          return video && video.isUploading && _react2.default.createElement(_progress_bar2.default, { key: key, multicolor: true,
            mode: video.total && 'determinate' || 'indeterminate',
            value: video.total && video.loaded && video.loaded * 100 / video.total });
        }),
        _react2.default.createElement(_richTextEditor2.default, { compact: true, hasFocus: true, noToolbar: true,
          chatMessage: true,
          onDrop: this.uploadFiles,
          onChange: this.onChangeEditor,
          onCompositionEnd: this.onChangeEditor // Handle IME finalized input
          , showGoogleDoc: showGoogleDoc,
          showGambaUrl: showGambaUrl,
          onFocus: this.onFocus,
          onAddLink: this.onAddLink,
          onDeleteLink: this.onDeleteLink,
          onEditorInitialized: this.onEditorInitialized,
          placeholder: t('label:メッセージを入力してください') }),
        _react2.default.createElement(_diaryUrlLinks2.default, { urlLinks: ui.urlLinks, onDeleteLink: this.onDeleteLink, isChat: true }),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex' } },
          _react2.default.createElement(_button.Button, { raised: true, primary: true,
            theme: _diaryFormButton2.default,
            disabled: isPosting || urlInfo && urlInfo.isFetching,
            icon: 'send',
            onClick: this.postChatMessage,
            label: t('label:送信'),
            style: { minWidth: 100 } }),
          _react2.default.createElement(_fileUploadButton2.default, { raised: true,
            theme: _diaryFormButton2.default,
            icon: 'add_a_photo',
            onChange: this.uploadFiles,
            label: t('label:添付') }),
          _react2.default.createElement(_button.Button, { raised: true,
            theme: _diaryFormButton2.default,
            icon: 'tag_faces',
            onClick: this.showStampPalette,
            label: t('label:スタンプ') }),
          _react2.default.createElement(_button.Button, {
            theme: _diaryFormButton2.default,
            style: { marginLeft: 'auto' },
            icon: 'close',
            onClick: this.cancelMessage,
            label: t('label:取り消し') })
        )
      );
    }
  }]);

  return ChatMessageForm;
}(_react2.default.Component);

var RawChatMessageForm = exports.RawChatMessageForm = ChatMessageForm;
exports.default = (0, _chatMessageForm2.default)(ChatMessageForm);

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _componentId = __webpack_require__(164);

var _componentId2 = _interopRequireDefault(_componentId);

var _fileUpload = __webpack_require__(179);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _findIndex = __webpack_require__(263);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _debounce = __webpack_require__(1047);

var _debounce2 = _interopRequireDefault(_debounce);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _messageStorage = __webpack_require__(1090);

var _messageStorage2 = _interopRequireDefault(_messageStorage);

var _googleDoc = __webpack_require__(269);

var _googleDoc2 = _interopRequireDefault(_googleDoc);

var _route = __webpack_require__(67);

var _urlRegexp = __webpack_require__(182);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNSUBMIT_MESSAGE = 'gambaApp.unSubmitMessage';
// src/connects/chat-message-form.js

var UrlRegex = (0, _urlRegexp.urlRegex)();

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var item = state.chatMessages[ownProps.chatRoom.chat_room_id] || {};
  return {
    isPosting: item.isPosting,
    isPostFailed: item.isPostFailed,
    withFiles: item.withFiles,
    uploadedFiles: state.uploadFile[ownProps.componentId],
    uploadedVideos: state.uploadVideo[ownProps.componentId],
    user: state.user.current,
    urlInfo: state.urlInfo[ownProps.componentId]
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var onChangeEditor = function onChangeEditor(text) {
    return _messageStorage2.default.getItem(UNSUBMIT_MESSAGE).then(function (unSubmitMessage) {
      var messages = JSON.parse(unSubmitMessage || '[]');
      var index = (0, _findIndex2.default)(messages, function (_message) {
        return _message.id == ownProps.chatRoom.chat_room_id;
      });
      if (index < 0) messages.push({
        type: 'chat_message',
        id: ownProps.chatRoom.chat_room_id,
        message: text
      });else messages[index].message = text;
      if (messages.length > 2) messages.shift();
      _messageStorage2.default.setItem(UNSUBMIT_MESSAGE, JSON.stringify(messages));
    }).catch(function () {
      return undefined;
    });
  };

  return {
    postChatMessage: function postChatMessage(props) {
      props.ui.handlers && props.ui.handlers.getValue(function (message) {
        var isExistMessage = message && message.replace(/<[^>]*>/g, '').trim().length > 0;
        if (!isExistMessage) {
          return;
        }
        var attach_json = props.ui.urlLinks && JSON.stringify({ links: props.ui.urlLinks });
        dispatch(_actions2.default.postChatMessage(ownProps.chatRoom.chat_room_id, message, undefined, undefined, attach_json));
      });
    },

    postStampMessage: function postStampMessage(code) {
      code && dispatch(_actions2.default.postChatMessage(ownProps.chatRoom.chat_room_id, '<div><span class="stamp ' + code + '"></span></div>'));
    },

    onChangeMessage: onChangeEditor,
    onChangeEditor: (0, _debounce2.default)(function (props) {
      return props.ui.handlers && props.ui.handlers.getValue(function (text) {
        return onChangeEditor(text);
      });
    }, 500),

    uploadFiles: function uploadFiles(props, files) {
      return (0, _fileUpload2.default)(files, dispatch, props.user.user_id, 'user', ownProps.componentId);
    },

    cancelMessage: function cancelMessage(props) {
      props.ui.handlers && props.ui.handlers.clearValue();
      props.updateUI({ urlLinks: undefined });
    },

    willUnmount: function willUnmount() {
      dispatch(_actions2.default.clearUploadFilesAndVideos(ownProps.componentId));
    },

    willUpdate: function willUpdate(props, nextProps) {
      // gapiReadyがtrueになり、linkにファイル名を取得すべきGoogleドキュメントのURLが格納されている
      if (!props.ui.gapiReady && nextProps.ui.gapiReady && nextProps.ui.link) {
        dispatch(_actions2.default.fetchGoogleDriveFile(nextProps.ui.link, nextProps.componentId));
      }
      // fetchUrlInfoでリンク先情報を取得した
      if (props.urlInfo !== nextProps.urlInfo && nextProps.urlInfo && !nextProps.urlInfo.isFetchFailed && nextProps.ui.handlers) {
        var urlLinks = Object.assign({}, nextProps.ui.urlLinks);
        (0, _each2.default)(nextProps.urlInfo, function (v, k) {
          if (v && !v.isFetching && v.item && (!props.urlInfo || props.urlInfo[k] !== v.item)) {
            urlLinks[k] = v.item;
          }
        });
        nextProps.updateUI({ urlLinks: urlLinks });
      }
      // fetcuUrlInfoでリンク先情報の取得に失敗した
      if (props.urlInfo !== nextProps.urlInfo && nextProps.urlInfo && nextProps.urlInfo.isFetchFailed) {
        nextProps.updateUI({ gapiReady: false });
      }

      if (!props.ui.hasFocus && nextProps.ui.hasFocus && nextProps.urlLinks && nextProps.ui.handlers) {
        nextProps.ui.handlers.getValue(function (message) {
          // 本文中のURLでattach_jsonに含まれていないものがあれば情報を取得する
          var match = void 0;
          while (match = UrlRegex.exec(message)) {
            var url = match[0];
            if ((!nextProps.urlLinks || !nextProps.urlLinks[url]) && !(0, _googleDoc2.default)(url)) dispatch(_actions2.default.fetchUrlInfo(url, nextProps.componentId));
          }
        });
      }
      if (props.isPosting && !nextProps.isPosting && !nextProps.isPostFailed && (!nextProps.withFiles || nextProps.withFiles && nextProps.ui.urlLinks)) {
        nextProps.ui.handlers.clearValue();
        nextProps.updateUI({ urlLinks: undefined });
        dispatch(_actions2.default.clearUrlInfo(nextProps.componentId));
        _messageStorage2.default.getItem(UNSUBMIT_MESSAGE).then(function (nextCanselMessage) {
          var nextCanselMessages = JSON.parse(nextCanselMessage || '[]');
          var nextCanselFilter = (0, _filter2.default)(nextCanselMessages, function (_nextCanselMessage) {
            return _nextCanselMessage.id !== nextProps.chatRoom.chat_room_id;
          });
          _messageStorage2.default.setItem(UNSUBMIT_MESSAGE, JSON.stringify(nextCanselFilter));
        }).catch(function () {
          return undefined;
        });
      }
      if (props.uploadedFiles != nextProps.uploadedFiles && !!nextProps.uploadedFiles) {
        (0, _each2.default)(nextProps.uploadedFiles, function (value, key) {
          if (props.uploadedFiles && props.uploadedFiles[key] && props.uploadedFiles[key].isUploading && value && !value.isUploading && !value.isUploadFailed) {
            dispatch(_actions2.default.postChatMessage(ownProps.chatRoom.chat_room_id, '<div></div>', [value.item.file_id], undefined, undefined));
            dispatch(_actions2.default.cancelUploadFile(ownProps.componentId, key));
          }
        });
      }
      if (props.uploadedVideos != nextProps.uploadedVideos && !!nextProps.uploadedVideos) {
        (0, _each2.default)(nextProps.uploadedVideos, function (value, key) {
          if (props.uploadedVideos && props.uploadedVideos[key] && props.uploadedVideos[key].isUploading && value && !value.isUploading && !value.isUploadFailed) {
            dispatch(_actions2.default.postChatMessage(ownProps.chatRoom.chat_room_id, '<div></div>', undefined, [value.item.video_id], undefined));
            dispatch(_actions2.default.cancelUploadVideo(ownProps.componentId, key));
          }
        });
      }
    },
    onAddLink: function onAddLink(props, link) {
      if ((0, _googleDoc2.default)(link)) {
        if (props.ui.gapiReady) {
          dispatch(_actions2.default.fetchGoogleDriveFile(link, props.componentId));
        } else {
          props.updateUI({ confirmGapi: true, link: link });
        }
      } else dispatch(_actions2.default.fetchUrlInfo(link, props.componentId));
    },
    onDeleteLink: function onDeleteLink(props, link) {
      var urlLinks = Object.assign({}, props.ui.urlLinks);
      delete urlLinks[link];
      props.updateUI({ urlLinks: urlLinks });
    },
    showGoogleDoc: function showGoogleDoc(url) {
      return dispatch(_actions2.default.openRightSidePage('google_doc', { url: url }, true));
    },
    showGambaUrl: function showGambaUrl(url) {
      var paths = url.replace(/^.+groups\//, '').split('/');
      var kpi_id, diary_id, chat_room_id, match;
      var group_id = parseInt(paths[0]);
      if (paths.length == 2 && paths[1] == 'timeline') {
        (0, _route.pushRoute)('group_timeline', { group_id: group_id });
      } else if (paths.length == 1 && paths[0] == 'home') {
        (0, _route.pushRoute)('home_group');
      } else if (paths.length == 4 && paths[2] == 'kpi_chart') {
        kpi_id = parseInt(paths[3]);
        dispatch(_actions2.default.openRightSidePage('kpi_chart', { group_id: group_id, kpi_id: kpi_id }));
      } else if (paths.length == 3 && (match = paths[2].match(/^pickup\?diary_ids=([0-9]+)$/))) {
        diary_id = parseInt(match[1]);
        dispatch(_actions2.default.openRightSidePage('pickup_diaries', { diary_ids: [diary_id] }));
      } else if (paths.length == 3 && paths[1] == 'messages') {
        chat_room_id = parseInt(paths[2]);
        dispatch(_actions2.default.openRightSidePage('chat_messages', { chat_room_id: chat_room_id }));
      }
    },
    onCancelConfirmGapi: function onCancelConfirmGapi(props) {
      return props.updateUI({ confirmGapi: false });
    },
    onSuccessConfirmGapi: function onSuccessConfirmGapi(props) {
      return props.updateUI({ confirmGapi: false, gapiReady: true });
    },
    hideKeyboard: function hideKeyboard(props) {
      return props.ui.handlers && props.ui.handlers.hideKeyboard();
    }
  };
};

exports.default = (0, _combineHoc2.default)(_componentId2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    handlers: undefined,
    urlLinks: undefined,
    link: undefined,
    gapiReady: function gapiReady() {
      return window.gapi && window.gapi.client && window.gapi.client.getToken();
    },
    confirmGapi: false,
    hasFocus: false
  } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackHandlers)('postChatMessage', 'post_chat_message'), (0, _analytics.trackHandlers)('postStampMessage', 'post_chat_message'), (0, _context2.default)({ showStampPalette: _propTypes2.default.func }));

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _dialog = __webpack_require__(47);

var _button = __webpack_require__(8);

var _pdfPreview = __webpack_require__(558);

var _pdfPreview2 = _interopRequireDefault(_pdfPreview);

var _app_bar = __webpack_require__(122);

var _app_bar2 = _interopRequireDefault(_app_bar);

var _navigation = __webpack_require__(147);

var _rightSidePageAppBar = __webpack_require__(559);

var _rightSidePageAppBar2 = _interopRequireDefault(_rightSidePageAppBar);

var _googleSigninProvider = __webpack_require__(200);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * src/web/components/google-doc-dialog.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var GoogleDocDialog = function (_React$PureComponent) {
  _inherits(GoogleDocDialog, _React$PureComponent);

  function GoogleDocDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GoogleDocDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GoogleDocDialog.__proto__ || Object.getPrototypeOf(GoogleDocDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      googleLogin: false
    }, _this.onGoogleSigninSuccess = function () {
      return _this.setState({ googleLogin: true });
    }, _this.closeDialog = function () {
      return _this.props.closeDoc();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GoogleDocDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          open = _props.open,
          params = _props.params,
          closeDoc = _props.closeDoc;


      return _react2.default.createElement(
        _dialog.Dialog,
        {
          className: _pdfPreview2.default.docDialog,
          active: open,
          nEscKeyDown: this.closeDialog,
          onOverlayClick: this.closeDialog },
        _react2.default.createElement(
          _app_bar2.default,
          { flat: true, title: t('label:Googleドキュメント'), theme: _rightSidePageAppBar2.default },
          _react2.default.createElement(
            _navigation.Navigation,
            { type: 'horizontal', style: { whiteSpace: 'nowrap' } },
            _react2.default.createElement(_button.IconButton, { icon: 'open_in_new', href: params, target: '_blank', rel: 'noopener noreferrer' }),
            _react2.default.createElement(_button.IconButton, { icon: 'close', onClick: this.closeDialog })
          )
        ),
        !this.state.googleLogin && _react2.default.createElement(_googleSigninProvider.GoogleLogin, { label: t('label:Googleドキュメントに接続'), onSuccess: this.onGoogleSigninSuccess }) || _react2.default.createElement('iframe', { style: { border: '0px', width: '100%', height: 'calc(100vh - 120px)' }, src: params })
      );
    }
  }]);

  return GoogleDocDialog;
}(_react2.default.PureComponent);

exports.default = (0, _reactI18next.translate)()(GoogleDocDialog);

/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _albumPage = __webpack_require__(995);

var _albumPage2 = _interopRequireDefault(_albumPage);

var _chatAlbum = __webpack_require__(2690);

var _chatAlbum2 = _interopRequireDefault(_chatAlbum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/web/components/chat-album.jsx

exports.default = (0, _chatAlbum2.default)(_albumPage2.default);

/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/caht-album.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    isFetching: state.chatRooms.isFetching,
    isFetchFailed: state.chatRooms.isFetchFailed,
    images: state.chatRooms.imageItems,
    files: state.chatRooms.fileItems,
    videos: state.chatRooms.videoItems,
    hasMoreImage: state.chatRooms.hasMoreImage,
    hasMoreFile: state.chatRooms.hasMoreFile,
    hasMoreVideo: state.chatRooms.hasMoreVideo
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willMount: function willMount() {
      return dispatch(_actions2.default.fetchAlbumChatImage(ownProps.chatRoom.chat_room_id, 'image', 0));
    },
    willUnmount: function willUnmount() {
      return dispatch(_actions2.default.clearChatAlbum());
    },
    fetchImage: function fetchImage(props) {
      var offset = props.images && props.images.length || 0;
      dispatch(_actions2.default.fetchAlbumChatImage(ownProps.chatRoom.chat_room_id, 'image', offset));
    },
    fetchFile: function fetchFile(props) {
      var offset = props.files && props.files.length || 0;
      dispatch(_actions2.default.fetchAlbumChatFile(ownProps.chatRoom.chat_room_id, 'others', offset));
    },
    fetchVideo: function fetchVideo(props) {
      var offset = props.videos && props.videos.length || 0;
      dispatch(_actions2.default.fetchAlbumChatVideo(ownProps.chatRoom.chat_room_id, offset));
    },
    onChangeTab: function onChangeTab(tabIndex, props) {
      switch (tabIndex) {
        case 0:
          if (!props.images) {
            dispatch(_actions2.default.fetchAlbumChatImage(ownProps.chatRoom.chat_room_id, 'image', 0));
          }
          break;
        case 1:
          if (!props.videos) dispatch(_actions2.default.fetchAlbumChatVideo(ownProps.chatRoom.chat_room_id, 0));
          break;
        case 2:
          if (!props.files) dispatch(_actions2.default.fetchAlbumChatFile(ownProps.chatRoom.chat_room_id, 'others', 0));
          break;
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({
  state: {
    tabIndex: function tabIndex(props) {
      return props.params && props.params.tabIndex || 0;
    }
  }
}), (0, _context2.default)({ showImagesView: _propTypes2.default.func }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawGoogleCalendarPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _googleCalendarPage = __webpack_require__(2692);

var _googleCalendarPage2 = _interopRequireDefault(_googleCalendarPage);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _bidirectionalInfiniteScroll = __webpack_require__(2694);

var _bidirectionalInfiniteScroll2 = _interopRequireDefault(_bidirectionalInfiniteScroll);

var _list = __webpack_require__(25);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _googleSigninProvider = __webpack_require__(200);

var _MicrosoftLogin = __webpack_require__(2695);

var _theme = __webpack_require__(266);

var _theme2 = _interopRequireDefault(_theme);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _compactList = __webpack_require__(489);

var _compactList2 = _interopRequireDefault(_compactList);

var _googleCalendarItem = __webpack_require__(2698);

var _googleCalendarItem2 = _interopRequireDefault(_googleCalendarItem);

var _googleCalendarHeaderItem = __webpack_require__(2700);

var _googleCalendarHeaderItem2 = _interopRequireDefault(_googleCalendarHeaderItem);

var _googleCalendarList = __webpack_require__(575);

var _googleCalendarList2 = _interopRequireDefault(_googleCalendarList);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _reactCalendar = __webpack_require__(2701);

var _reactCalendar2 = _interopRequireDefault(_reactCalendar);

__webpack_require__(2721);

var _i18n = __webpack_require__(173);

var _i18n2 = _interopRequireDefault(_i18n);

var _msalBrowser = __webpack_require__(2723);

var _analytics = __webpack_require__(27);

var _outlookAccessToken = __webpack_require__(332);

var _outlookAccessToken2 = _interopRequireDefault(_outlookAccessToken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/google-calendar-page.jsx

var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);

var GoogleCalendarPage = function (_React$Component) {
  _inherits(GoogleCalendarPage, _React$Component);

  function GoogleCalendarPage(props) {
    _classCallCheck(this, GoogleCalendarPage);

    var _this = _possibleConstructorReturn(this, (GoogleCalendarPage.__proto__ || Object.getPrototypeOf(GoogleCalendarPage)).call(this, props));

    _this.state = { date: new Date(), msalUser: '' };

    _this.onGooglSigninSuccess = function () {
      _this.props.fetchCalendars();
      _this.props.updateUI({ gapiReady: true });
      (0, _analytics.track)('onGooglSigninSuccess');
    };

    _this.onMicrosoftSigninSuccess = function (msalUser) {
      _this.props.fetchOutlookCalendars();
      _this.props.updateUI({ isOutlookReady: true, msalUser: msalUser });
      (0, _analytics.track)('onMicrosoftSigninSuccess');
    };

    _this.onChange = function (date) {
      _this.setState({ date: date });
      _this.props.updateUI({ date: (0, _moment2.default)(date).format('YYYY-MM-DD') });
      _this.props.ui.gapiReady && _this.props.fetchEvents(_this.props, date);
      _this.props.ui.isOutlookReady && _this.props.fetchOutlookEvents(_this.props, date);
    };

    _this.toggleImportInfo = function (checkedDate) {
      _this.props.updateUI({
        checkedDates: Object.assign({}, _this.props.ui.checkedDates, _defineProperty({}, checkedDate, !_this.props.ui.checkedDates[checkedDate]))
      });
    };

    _this.toggleTimeImportInfo = function (checkedDate) {
      _this.props.updateUI({
        checkedTimeDates: Object.assign({}, _this.props.ui.checkedTimeDates, _defineProperty({}, checkedDate, !_this.props.ui.checkedTimeDates[checkedDate]))
      });
    };

    _this.copyCalendarEvents = function (date, inDescription, inTime) {
      _this.props.copyCalendarEvents(_this.props, date, inDescription, inTime);
    };

    _this.reloadCalendar = function () {
      _this.setState({ date: new Date() });
      _this.props.updateUI({ date: (0, _moment2.default)().format('YYYY-MM-DD') });
      _this.props.reloadEventsCalendar(_this.props);
    };

    _this.onOutlookLogout = function () {
      var logoutRequest = {
        account: _this.msalClient.getAccountByUsername(_this.state.msalUser)
      };
      _this.msalClient.logoutPopup(logoutRequest).then(function (res) {
        _this.props.outlookLogout();
        _this.rightAction && _this.rightAction.shift();
      });
    };

    _this.onChangeCalendar = function (calendar) {
      if (calendar == 'cancel') {
        _this.props.ui.gapiReady && _googleSigninProvider.GoogleLogin.signOut();
        _this.props.ui.isOutlookReady && _this.onOutlookLogout();
        _this.props.updateUI({ gapiReady: false, isOutlookReady: false });
        _this.props.refreshEvents(_this.props);
        _this.rightAction && _this.rightAction.shift();
      } else {
        _this.setState({ date: new Date() });
        _this.props.updateUI({ date: (0, _moment2.default)().format('YYYY-MM-DD') });
        _this.props.changeCalendar(_this.props, calendar);
      }
    };

    _this.msalClient = new _msalBrowser.PublicClientApplication(_config2.default.msal);
    _this.rightAction = [_react2.default.createElement(TooltipIconButton, { key: 'update', icon: 'update', tooltip: props.t('label:再読み込み'), onClick: _this.reloadCalendar })];
    return _this;
  }

  _createClass(GoogleCalendarPage, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.isFetchFailed && this.props.isFetchFailed) {
        _googleSigninProvider.GoogleLogin.signOut();
        this.props.updateUI({ gapiReady: false });
        this.props.refreshEvents(this.props);
      }
      if (!prevProps.isOutlookCalendarFetchFailed && this.props.isOutlookCalendarFetchFailed) {
        this.props.updateUI({ isOutlookReady: false });
      }
      if (!prevProps.ui.isOutlookReady && this.props.ui.isOutlookReady) this.rightAction.unshift(_react2.default.createElement(TooltipIconButton, { key: 'open_in_new', icon: 'open_in_new', tooltip: this.props.t('label:Outlookカレンダーを開く'), href: 'https://outlook.live.com/calendar/', target: '_blank', rel: 'noopener noreferrer' }));
      if (!prevProps.ui.gapiReady && this.props.ui.gapiReady) this.rightAction.unshift(_react2.default.createElement(TooltipIconButton, { key: 'open_in_new', icon: 'open_in_new', tooltip: this.props.t('label:Googleカレンダーを開く'), href: 'https://calendar.google.com/calendar/', target: '_blank', rel: 'noopener noreferrer' }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          events = _props.events,
          calendars = _props.calendars,
          fetchCalendars = _props.fetchCalendars,
          refreshEvents = _props.refreshEvents,
          fetchEvents = _props.fetchEvents,
          reloadEventsCalendar = _props.reloadEventsCalendar,
          updateUI = _props.updateUI,
          copyCalendarEvents = _props.copyCalendarEvents,
          changeCalendar = _props.changeCalendar,
          hasAfter = _props.hasAfter,
          hasBefore = _props.hasBefore,
          loadCalendar = _props.loadCalendar,
          isOutlookFetching = _props.isOutlookFetching,
          isOutlookFetchFailed = _props.isOutlookFetchFailed,
          isOutlookCalendarFetchFailed = _props.isOutlookCalendarFetchFailed,
          outlookEvents = _props.outlookEvents,
          outlookCalendars = _props.outlookCalendars;


      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: t('label:カレンダー'),
          rightAction: this.rightAction,
          icon: 'event_available' },
        !ui.gapiReady && !ui.isOutlookReady && _react2.default.createElement(_googleSigninProvider.GoogleLogin, { label: t('label:Googleカレンダーに接続'), onSuccess: this.onGooglSigninSuccess }),
        !isFetchFailed && ui.gapiReady && !ui.isOutlookReady && calendars && _react2.default.createElement(
          'div',
          { style: { margin: '0px 10px' } },
          _react2.default.createElement(_dropdown2.default, { auto: true,
            source: calendars.map(function (cal) {
              return { value: cal.id, label: cal.name };
            }).concat({ value: 'cancel', label: t('label:Googleカレンダーを解除') }),
            value: ui.calendar,
            onChange: this.onChangeCalendar })
        ),
        !isFetchFailed && ui.gapiReady && _react2.default.createElement(
          'div',
          { style: { overflow: 'scroll', height: 'calc(100vh - 160px - 64px)', padding: 5 } },
          _react2.default.createElement(_reactCalendar2.default, {
            className: 'react-calendar',
            locale: _i18n2.default.language,
            calendarType: 'US',
            onChange: this.onChange,
            value: this.state.date,
            prev2Label: null,
            next2Label: null
          }),
          events && events[ui.calendar] && _react2.default.createElement(_googleCalendarHeaderItem2.default, {
            event: events[ui.calendar][ui.date],
            selectDate: ui.date,
            checked: this.props.ui.checkedDates[ui.date],
            checkedTime: !this.props.ui.checkedTimeDates[ui.date],
            t: this.props.t,
            copyCalendarEvents: this.copyCalendarEvents,
            toggleImportInfo: this.toggleImportInfo,
            toggleTimeImportInfo: this.toggleTimeImportInfo }),
          events && events[ui.calendar] && (typeof events[ui.calendar][ui.date] == 'undefined' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_loading2.default, null)
          ) || events && events[ui.calendar] && events[ui.calendar][ui.date].length > 0 && _lodash2.default.map(events[ui.calendar][ui.date], function (event) {
            return _react2.default.createElement(_googleCalendarItem2.default, {
              key: event.event_id,
              event: event,
              checked: _this2.props.ui.checkedDates[ui.date],
              checkedTime: !_this2.props.ui.checkedTimeDates[ui.date],
              t: _this2.props.t });
          }) || _react2.default.createElement(_list.ListItem, { theme: _googleCalendarList2.default, ripple: false, caption: t('label:予定がありません') }))
        ),
        !ui.isOutlookReady && !ui.gapiReady && _react2.default.createElement(_MicrosoftLogin.MicrosoftLogin, { label: t('label:Outlookカレンダーに接続'), msalClient: this.msalClient, isOutlookCalendarFetchFailed: isOutlookCalendarFetchFailed, onSuccess: this.onMicrosoftSigninSuccess, loadAccessToken: this.props.loadAccessToken, emitAlertMessage: this.props.emitAlertMessage }),
        !isOutlookFetchFailed && ui.isOutlookReady && !ui.gapiReady && outlookCalendars && _react2.default.createElement(
          'div',
          { style: { margin: '0px 10px' } },
          _react2.default.createElement(_dropdown2.default, { auto: true,
            source: outlookCalendars.map(function (cal) {
              return { value: cal.id, label: cal.name };
            }).concat({ value: 'cancel', label: t('label:Outlookカレンダーを解除') }),
            value: ui.calendar,
            onChange: this.onChangeCalendar })
        ),
        !isOutlookFetchFailed && ui.isOutlookReady && _react2.default.createElement(
          'div',
          { style: { overflow: 'scroll', height: 'calc(100vh - 160px - 64px)', padding: 5 } },
          _react2.default.createElement(_reactCalendar2.default, {
            className: 'react-calendar',
            locale: _i18n2.default.language,
            calendarType: 'US',
            onChange: this.onChange,
            value: this.state.date,
            prev2Label: null,
            next2Label: null
          }),
          outlookEvents && outlookEvents[ui.calendar] && _react2.default.createElement(_googleCalendarHeaderItem2.default, {
            event: outlookEvents[ui.calendar][ui.date],
            selectDate: ui.date,
            checked: this.props.ui.checkedDates[ui.date],
            checkedTime: !this.props.ui.checkedTimeDates[ui.date],
            t: this.props.t,
            copyCalendarEvents: this.copyCalendarEvents,
            toggleImportInfo: this.toggleImportInfo,
            toggleTimeImportInfo: this.toggleTimeImportInfo }),
          outlookEvents && outlookEvents[ui.calendar] && (typeof outlookEvents[ui.calendar][ui.date] == 'undefined' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_loading2.default, null)
          ) || outlookEvents && outlookEvents[ui.calendar] && outlookEvents[ui.calendar][ui.date].length > 0 && _lodash2.default.map(outlookEvents[ui.calendar][ui.date], function (event) {
            return _react2.default.createElement(_googleCalendarItem2.default, {
              key: event.event_id,
              event: event,
              checked: _this2.props.ui.checkedDates[ui.date],
              checkedTime: !_this2.props.ui.checkedTimeDates[ui.date],
              t: _this2.props.t });
          }) || _react2.default.createElement(_list.ListItem, { theme: _googleCalendarList2.default, ripple: false, caption: t('label:予定がありません') }))
        )
      );
    }
  }]);

  return GoogleCalendarPage;
}(_react2.default.Component);

var RawGoogleCalendarPage = exports.RawGoogleCalendarPage = GoogleCalendarPage;
exports.default = (0, _googleCalendarPage2.default)(GoogleCalendarPage);

/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _alertMessage = __webpack_require__(13);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _googleCalendarHtmlParse = __webpack_require__(2693);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _outlookAccessToken = __webpack_require__(332);

var _outlookAccessToken2 = _interopRequireDefault(_outlookAccessToken);

var _analytics = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/google-calendar-page.js

var MAX_MONTHS = 1;

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.googleApi.isFetching,
    isFetchFailed: state.googleApi.isFetchFailed,
    isCalendarFetchFailed: state.googleApi.isCalendarFetchFailed,
    events: state.googleApi.events,
    calendars: state.googleApi.calendars,
    rightSidePage: state.rightSidePage,
    isOutlookFetching: state.outlookApi.isFetching,
    isOutlookFetchFailed: state.outlookApi.isFetchFailed,
    isOutlookCalendarFetchFailed: state.outlookApi.isCalendarFetchFailed,
    outlookEvents: state.outlookApi.events,
    outlookCalendars: state.outlookApi.calendars
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount(props) {
      return props.updateUI({ date: (0, _moment2.default)().format('YYYY-MM-DD') });
    },
    willUnmount: function willUnmount() {
      dispatch(_actions2.default.clearGoogleCalendarEvents());
      dispatch(_actions2.default.clearGoogleCalendarCalendars());
      dispatch(_actions2.default.clearOutlookCalendarEvents());
      dispatch(_actions2.default.clearOutlookCalendars());
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (!props.isFetchFailed && nextProps.isFetchFailed || !props.isCalendarFetchFailed && nextProps.isCalendarFetchFailed) {
        nextProps.updateUI({ gapiReady: false });
        dispatch((0, _alertMessage.emitAlertMessage)({ message: "label:Googleカレンダーの取得に失敗しました" }, 'error'));
      }
      //gapiReadyがtrueになったタイミングで読み出しされる
      if (!props.ui.gapiReady && nextProps.ui.gapiReady) {
        dispatch(_actions2.default.fetchGoogleCalendarEvents(nextProps.ui.date, nextProps.ui.calendar));
      }

      if (!props.isOutlookFetchFailed && nextProps.isOutlookFetchFailed || !props.isOutlookCalendarFetchFailed && nextProps.isOutlookCalendarFetchFailed) {
        nextProps.updateUI({ isOutlookReady: false });
        dispatch((0, _alertMessage.emitAlertMessage)({ message: "label:Outlookカレンダーの取得に失敗しました" }, 'error'));
      }

      if (!props.outlookCalendars && nextProps.outlookCalendars) {
        if (nextProps.outlookCalendars.length > 0) {
          //初回のデフォルトカレンダーを設定
          var defaultCalendar = nextProps.outlookCalendars.filter(function (item) {
            return item.isDefaultCalendar;
          })[0];
          defaultCalendar && nextProps.updateUI({ calendar: defaultCalendar.id });
          dispatch(_actions2.default.fetchOutlookCalendarEvents(nextProps.ui.date, defaultCalendar.id));
        } else {
          dispatch((0, _alertMessage.emitAlertMessage)({ message: "label:Outlookカレンダーの取得に失敗しました" }, 'error'));
        }
      }
    },

    fetchCalendars: function fetchCalendars() {
      return dispatch(_actions2.default.fetchGoogleCalendarCalendars());
    },

    changeCalendar: function changeCalendar(props, calendar) {
      //メールアドレスを切り替えた際にeventの中身をclearする
      props.updateUI({ calendar: calendar });

      //切り替えた後の今日の日付と予定が表示されるようにする
      var changeCalendarDate = (0, _moment2.default)().utcOffset(0).format();
      props.ui.gapiReady && dispatch(_actions2.default.fetchGoogleCalendarEvents(changeCalendarDate, calendar));
      props.ui.isOutlookReady && dispatch(_actions2.default.fetchOutlookCalendarEvents(changeCalendarDate, calendar));
    },

    refreshEvents: function refreshEvents(props) {
      props.updateUI({ calendar: 'primary' });
      props.ui.gapiReady && dispatch(_actions2.default.clearGoogleCalendarEvents());
      props.ui.isOutlookReady && dispatch(_actions2.default.clearOutlookCalendarEvents());
    },

    reloadEventsCalendar: function reloadEventsCalendar(props) {
      if (props.isFetching || props.isOutlookFetching) return;
      var todayDate = (0, _moment2.default)().utcOffset(0).format();
      props.ui.gapiReady && dispatch(_actions2.default.fetchGoogleCalendarEvents(todayDate, props.ui.calendar));
      props.ui.isOutlookReady && dispatch(_actions2.default.fetchOutlookCalendarEvents(todayDate, props.ui.calendar));
    },

    fetchEvents: function fetchEvents(props, date) {
      if (props.isFetching) return;
      var eventDate = (0, _moment2.default)(date).utcOffset(0).format();
      dispatch(_actions2.default.fetchGoogleCalendarEvents(eventDate, props.ui.calendar));
    },

    signInEvents: function signInEvents(props) {
      props.updateUI({ gapiReady: true });
      if (props.isFetching) return;
      props.updateUI({ calendar: props.ui.calendar });
      var todayDate = (0, _moment2.default)().utcOffset(0).format();
      dispatch(_actions2.default.fetchGoogleCalendarEvents(todayDate, props.ui.calendar));
    },

    copyCalendarEvents: function copyCalendarEvents(props, date, inDescription, inTime) {
      var events = props.ui.gapiReady && props.events || props.outlookEvents;
      if (events && events[props.ui.calendar][props.ui.date].length > 0) {
        var eventsHTML = '<div><u>' + (0, _moment2.default)(date).format('llll') + '</u><br></div>' + (0, _filter2.default)(events[props.ui.calendar][props.ui.date], function (event) {
          return event.date == date || (0, _moment2.default)(event.startTime).format('YYYY-MM-DD') != (0, _moment2.default)(event.endTime).format('YYYY-MM-DD') || event.endDate && event.date <= event.endDate;
        }).map(function (event) {
          return '<div>'
          //日を跨ぎでかつ時間指定のある予定や終日予定の場合は表示文言を変更する
          + (event.startTime && inTime ? (0, _moment2.default)(event.startTime).format('YYYY-MM-DD') != (0, _moment2.default)(event.endTime).format('YYYY-MM-DD') ? (0, _moment2.default)(event.startTime).format('MMMDo(dd) HH:mm') + ' ~ ' + (0, _moment2.default)(event.endTime).format('MMMDo(dd) HH:mm') : (0, _moment2.default)(event.startTime).format('HH:mm') + '-' + (0, _moment2.default)(event.endTime).format('HH:mm') : event.date && event.endDate && inTime ? '終日' : '') + (inTime ? ' ' : '') + event.title + ('' + (props.ui.isOutlookReady ? '' : '<br>')) + (inDescription && event.description && '' + ((0, _googleCalendarHtmlParse.removeHTML)(event.description) + '<br></div>') || '</div>');
        }).join('') + '<div><br></div>';
        dispatch(_actions2.default.insertDiaryForm(eventsHTML));
      } else {
        dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:予定がないため貼付けできません' }, 'error'));
      }
    },
    loadAccessToken: function loadAccessToken(microsoftAccess) {
      _outlookAccessToken2.default.set(microsoftAccess);
    },
    fetchOutlookCalendars: function fetchOutlookCalendars() {
      return dispatch(_actions2.default.fetchOutlookCalendars());
    },
    fetchOutlookEvents: function fetchOutlookEvents(props, date) {
      if (props.isOutlookFetching) return;
      var eventDate = (0, _moment2.default)(date).utcOffset(0).format();
      dispatch(_actions2.default.fetchOutlookCalendarEvents(eventDate, props.ui.calendar));
    },
    changeOutlookCalendar: function changeOutlookCalendar(props, calendar) {
      //メールアドレスを切り替えた際にeventの中身をclearする
      props.updateUI({ calendar: calendar });

      //切り替えた後の今日の日付と予定が表示されるようにする
      var changeCalendarDate = (0, _moment2.default)().utcOffset(0).format();
      dispatch(_actions2.default.fetchOutlookCalendarEvents(changeCalendarDate, calendar));
    },
    outlookLogout: function outlookLogout() {
      _outlookAccessToken2.default.clear();
      dispatch(_actions2.default.clearOutlookCalendarEvents());
      dispatch(_actions2.default.clearOutlookCalendars());
    },
    emitAlertMessage: function emitAlertMessage(message) {
      return dispatch((0, _alertMessage.emitAlertMessage)(message, 'error'));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    calendar: 'primary',
    gapiReady: false,
    isOutlookReady: false,
    checkedDates: [],
    checkedTimeDates: [],
    date: undefined
  } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('calendar_page'));

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeHTML = removeHTML;
// src/helpers/google-calendar-html-parse.js

//<br>タグ以外のタグを削除
function removeHTML(html) {
  if (!html || html.length == 0) return null;
  return html.replace(/(<br>|<br \/>)/g, '\n').replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '').replace(/\n/g, '<br>').replace(/(<br>\s*)+/ig, '<br>'); //連続する<br>を1つに変換
}

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;
// src/web/components/bidirectonal-infinite-scroll.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BidirectinalInfiniteScroll = (_temp = _class = function (_PureComponent) {
  _inherits(BidirectinalInfiniteScroll, _PureComponent);

  function BidirectinalInfiniteScroll(props) {
    _classCallCheck(this, BidirectinalInfiniteScroll);

    var _this = _possibleConstructorReturn(this, (BidirectinalInfiniteScroll.__proto__ || Object.getPrototypeOf(BidirectinalInfiniteScroll)).call(this, props));

    _this.load = _lodash2.default.debounce(_this.props.load, 100);
    //this.load = this.props.load
    _this.scrollListener = _this.scrollListener.bind(_this);
    return _this;
  }

  _createClass(BidirectinalInfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollWindow = this.scrollComponent.parentNode;
      this.attachScrollListener();
    }
  }, {
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate() {
      var scrollEl = this.scrollComponent.parentNode;
      this.scrollHeight = scrollEl.scrollHeight;
      this.scrollTop = scrollEl.scrollTop;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.attachScrollListener();
      var scrollEl = this.scrollComponent.parentNode;

      if (prevProps.children !== this.props.children) {
        //console.log(`didUpdate children:${this.props.children.length} direction:${this.direction} scrollTop:${this.scrollTop} new scrollHeight:${scrollEl.scrollHeight} old scrollHeight:${this.scrollHeight}`, scrollEl)
        if (this.direction < 0) scrollEl.scrollTop = this.scrollTop + (scrollEl.scrollHeight - this.scrollHeight);else scrollEl.scrollTop = this.scrollTop;
        //console.log('scrollTop', scrollEl.scrollTop)
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.detachScrollListener();
    }
  }, {
    key: 'detachScrollListener',
    value: function detachScrollListener() {
      var scrollEl = this.scrollComponent.parentNode;

      scrollEl.removeEventListener('scroll', this.scrollListener);
      scrollEl.removeEventListener('resize', this.scrollListener);
    }
  }, {
    key: 'attachScrollListener',
    value: function attachScrollListener() {
      var scrollEl = this.scrollComponent.parentNode;
      if (!this.props.hasAfter && !this.props.hasBefore) return;

      scrollEl.addEventListener('scroll', this.scrollListener);
      scrollEl.addEventListener('resize', this.scrollListener);

      this.scrollListener();
    }
  }, {
    key: 'scrollListener',
    value: function scrollListener() {
      var el = this.scrollComponent;
      var scrollEl = this.scrollComponent.parentNode;

      //console.log(`scrollListener scrollTop:${el.parentNode.scrollTop} clientHeight:${el.parentNode.clientHeight} scrollHeight:${el.scrollHeight}`)
      if (this.props.hasBefore && el.parentNode.scrollTop < this.props.threshold) {
        this.detachScrollListener();
        this.direction = -1;
        this.load(-1);
      }
      if (this.props.hasAfter && el.scrollHeight - el.parentNode.scrollTop - el.parentNode.clientHeight < this.props.threshold) {
        this.detachScrollListener();
        this.direction = 1;
        this.load(1);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          element = _props.element,
          load = _props.load,
          threshold = _props.threshold,
          props = _objectWithoutProperties(_props, ['children', 'element', 'load', 'threshold']);

      props.ref = function (node) {
        _this2.scrollComponent = node;
      };

      return _react2.default.createElement(element, props, children);
    }
  }]);

  return BidirectinalInfiniteScroll;
}(_react.PureComponent), _class.propTypes = {
  element: _propTypes2.default.string,
  load: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired,
  threshold: _propTypes2.default.number,
  hasBefore: _propTypes2.default.bool,
  hasAfter: _propTypes2.default.bool
}, _class.defaultProps = {
  element: 'div',
  threshold: 1
}, _temp);
exports.default = BidirectinalInfiniteScroll;

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicrosoftLogin = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _button = __webpack_require__(8);

__webpack_require__(2696);

var _outlookAccessToken = __webpack_require__(332);

var _outlookAccessToken2 = _interopRequireDefault(_outlookAccessToken);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _analytics = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/google-signin-provider.jsx

// or import the fetch polyfill you installed


var styles = {
  container: {
    marginTop: 8
  },
  loginBottun: {
    display: 'inline-block',
    background: '#303fa8',
    color: '#fff',
    width: '100%',
    fontWeight: 'bold'
  }
};

var loginRequest = {
  scopes: ['https://graph.microsoft.com/Calendars.Read', 'https://graph.microsoft.com/Calendars.ReadBasic', 'https://graph.microsoft.com/User.Read'], // 認可するスコープを指定します
  prompt: 'login',
  sid: '1234567890' // セッションIDを指定します
};

var MicrosoftLogin = exports.MicrosoftLogin = function (_React$PureComponent) {
  _inherits(MicrosoftLogin, _React$PureComponent);

  function MicrosoftLogin(props) {
    _classCallCheck(this, MicrosoftLogin);

    var _this = _possibleConstructorReturn(this, (MicrosoftLogin.__proto__ || Object.getPrototypeOf(MicrosoftLogin)).call(this));
    // ログイン状態のチェック


    _this.state = { isAuthenticated: false, username: '' };

    _this.login = function () {
      (0, _analytics.track)('onMicrosoftSigninClick');
      var account = _this.props.msalClient.getActiveAccount();
      if (!account) {
        // Remove the old item in sessionStorage before sending the login request
        if (sessionStorage.getItem('msal.interaction.status')) {
          sessionStorage.removeItem('msal.interaction.status');
        }

        _this.props.msalClient.loginPopup(loginRequest).then(function (res) {
          _this.setState({ username: res.account.username });
          var microsoftAccess = {
            accessToken: res.accessToken,
            username: res.account.username
          };
          _this.props.loadAccessToken(microsoftAccess);
          _this.props.onSuccess(microsoftAccess.username);
        });
      } else {
        _this.props.msalClient.acquireTokenSilent(account);
      }
    };

    var accounts = props.msalClient.getAllAccounts();
    if (accounts.length > 0 && !props.isOutlookCalendarFetchFailed) {
      var request = {
        scopes: ['https://graph.microsoft.com/Calendars.Read', 'https://graph.microsoft.com/Calendars.ReadBasic', 'https://graph.microsoft.com/User.Read'], // 認可するスコープを指定
        sid: '1234567890', // セッションIDを指定
        prompt: 'none',
        account: accounts[0]
      };
      props.msalClient.acquireTokenSilent(request).then(function (res) {
        var microsoftAccess = {
          accessToken: res.accessToken,
          username: res.account.username
        };
        _outlookAccessToken2.default.set(microsoftAccess);
        props.onSuccess(microsoftAccess.username);
      });
    }
    return _this;
  }

  _createClass(MicrosoftLogin, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: styles.container },
        _react2.default.createElement(_button.Button, { primary: true, style: styles.loginBottun, onClick: this.login, label: this.props.label })
      );
    }
  }]);

  return MicrosoftLogin;
}(_react2.default.PureComponent);

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(2697);
module.exports = self.fetch.bind(self);


/***/ }),
/* 2697 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)

    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _list = __webpack_require__(25);

var _googleCalendarList = __webpack_require__(575);

var _googleCalendarList2 = _interopRequireDefault(_googleCalendarList);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // src/native/components/google-calendar-item.jsx

var MAX_COUNT = 60;

var GoogleCalendarItem = function (_React$Component) {
  _inherits(GoogleCalendarItem, _React$Component);

  function GoogleCalendarItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GoogleCalendarItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GoogleCalendarItem.__proto__ || Object.getPrototypeOf(GoogleCalendarItem)).call.apply(_ref, [this].concat(args))), _this), _this.displayDescription = function (desc) {
      if (!desc || desc.length == 0) return null;
      var rowDesc = desc.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '').replace(/^[ \t\n\r\f]+|\s+$/g, '');
      if (desc.length > MAX_COUNT) return rowDesc.slice(0, MAX_COUNT) + '...';else return rowDesc;
    }, _this.setCaption = function (event, checkedTime) {
      //日跨ぎ判定
      var isStraddleTheDay = event && (0, _moment2.default)(event.startTime).format('YYYY-MM-DD') != (0, _moment2.default)(event.endTime).format('YYYY-MM-DD') ? true : false;
      if (isStraddleTheDay) {
        return _react2.default.createElement(
          'div',
          null,
          checkedTime && (0, _moment2.default)(event.startTime).format('MMMDo(dd) HH:mm') + ' ~ ' + (0, _moment2.default)(event.endTime).format('MMMDo(dd) HH:mm'),
          ' ',
          event.title
        );
      } else {
        if (event.startTime) return _react2.default.createElement(
          'div',
          null,
          checkedTime && (0, _moment2.default)(event.startTime).format('HH:mm') + ' - ' + (0, _moment2.default)(event.endTime).format('HH:mm'),
          ' ',
          event.title
        );else if (event.date && event.endDate) return _react2.default.createElement(
          'div',
          null,
          checkedTime && _this.props.t('label:終日'),
          ' ',
          event.title
        );
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GoogleCalendarItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          id = _props.id,
          event = _props.event,
          checked = _props.checked,
          checkedTime = _props.checkedTime;


      var showDescription = event.description && checked;

      return _react2.default.createElement(_list.ListItem, { ripple: false,
        theme: _googleCalendarList2.default,
        caption: this.setCaption(event, checkedTime),
        legend: showDescription ? this.displayDescription(event.description) : null });
    }
  }]);

  return GoogleCalendarItem;
}(_react2.default.Component);

exports.default = GoogleCalendarItem;

/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".google-calendar-list--listItem--Z80YPs9D {\n  list-style: none;\n  margin-bottom: 16px;\n}\n\n.google-calendar-list--item--zeRzdIXQ {\n  min-height: 32px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.google-calendar-list--subheader--rGhNBXCL {\n  line-height: 32px;\n}\n\n.google-calendar-list--button--3v0hMW0R {\n  height: 30px;\n  line-height: 30px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/google-calendar-list.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;CACrB;;AAED;EACE,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;CACrB;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,aAAa;EACb,kBAAkB;CACnB","file":"google-calendar-list.css","sourcesContent":[".listItem {\n  list-style: none;\n  margin-bottom: 16px;\n}\n\n.item {\n  min-height: 32px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.subheader {\n  line-height: 32px;\n}\n\n.button {\n  height: 30px;\n  line-height: 30px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"listItem": "google-calendar-list--listItem--Z80YPs9D",
	"item": "google-calendar-list--item--zeRzdIXQ",
	"subheader": "google-calendar-list--subheader--rGhNBXCL",
	"button": "google-calendar-list--button--3v0hMW0R"
};

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _list = __webpack_require__(25);

var _button = __webpack_require__(8);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _googleCalendarList = __webpack_require__(575);

var _googleCalendarList2 = _interopRequireDefault(_googleCalendarList);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // src/native/components/google-calendar-header-item.jsx

var GoogleCalendarHeaderItem = function (_React$Component) {
    _inherits(GoogleCalendarHeaderItem, _React$Component);

    function GoogleCalendarHeaderItem() {
        _classCallCheck(this, GoogleCalendarHeaderItem);

        return _possibleConstructorReturn(this, (GoogleCalendarHeaderItem.__proto__ || Object.getPrototypeOf(GoogleCalendarHeaderItem)).apply(this, arguments));
    }

    _createClass(GoogleCalendarHeaderItem, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                t = _props.t,
                key = _props.key,
                event = _props.event,
                copyCalendarEvents = _props.copyCalendarEvents,
                toggleImportInfo = _props.toggleImportInfo,
                toggleTimeImportInfo = _props.toggleTimeImportInfo,
                checked = _props.checked,
                checkedTime = _props.checkedTime,
                selectDate = _props.selectDate;

            return _react2.default.createElement(_list.ListSubHeader, {
                theme: _googleCalendarList2.default,
                caption: _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', marginTop: "30px" } },
                    _react2.default.createElement(
                        'div',
                        { style: { color: 'black', fontWeight: 'bold' } },
                        (0, _moment2.default)(selectDate).format('LLLL')
                    ),
                    event && event.length > 0 && _react2.default.createElement(
                        'div',
                        { style: { display: 'flex', marginLeft: 'auto', flexDirection: 'row' } },
                        _react2.default.createElement(
                            'div',
                            { style: { marginTop: 8, marginRight: 8 } },
                            _react2.default.createElement(_checkbox2.default, { key: 'checkbox', checked: checked,
                                onChange: function onChange() {
                                    return toggleImportInfo(selectDate);
                                }, label: t('label:説明を表示') })
                        ),
                        _react2.default.createElement(
                            'div',
                            { style: { marginTop: 8, marginRight: 8 } },
                            _react2.default.createElement(_checkbox2.default, { key: 'checkbox', checked: checkedTime,
                                onChange: function onChange() {
                                    return toggleTimeImportInfo(selectDate);
                                }, label: t('label:時間を表示') })
                        ),
                        _react2.default.createElement(_button.Button, { primary: true,
                            label: t('label:日報にコピー'), raised: true,
                            theme: _googleCalendarList2.default,
                            icon: 'content_copy',
                            onClick: function onClick() {
                                return copyCalendarEvents(selectDate, checked, checkedTime);
                            } })
                    )
                ) });
        }
    }]);

    return GoogleCalendarHeaderItem;
}(_react2.default.Component);

exports.default = GoogleCalendarHeaderItem;

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function get() {
    return _Calendar["default"];
  }
});
Object.defineProperty(exports, "CenturyView", {
  enumerable: true,
  get: function get() {
    return _CenturyView["default"];
  }
});
Object.defineProperty(exports, "DecadeView", {
  enumerable: true,
  get: function get() {
    return _DecadeView["default"];
  }
});
Object.defineProperty(exports, "YearView", {
  enumerable: true,
  get: function get() {
    return _YearView["default"];
  }
});
Object.defineProperty(exports, "MonthView", {
  enumerable: true,
  get: function get() {
    return _MonthView["default"];
  }
});
exports["default"] = void 0;

var _Calendar = _interopRequireDefault(__webpack_require__(2702));

var _CenturyView = _interopRequireDefault(__webpack_require__(1093));

var _DecadeView = _interopRequireDefault(__webpack_require__(1095));

var _YearView = _interopRequireDefault(__webpack_require__(1096));

var _MonthView = _interopRequireDefault(__webpack_require__(1097));

__webpack_require__(2719);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// File is created during build phase and placed in dist directory
// eslint-disable-next-line import/no-unresolved
var _default = _Calendar["default"];
exports["default"] = _default;

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _reactLifecyclesCompat = __webpack_require__(2705);

var _mergeClassNames = _interopRequireDefault(__webpack_require__(286));

var _Navigation = _interopRequireDefault(__webpack_require__(2706));

var _CenturyView = _interopRequireDefault(__webpack_require__(1093));

var _DecadeView = _interopRequireDefault(__webpack_require__(1095));

var _YearView = _interopRequireDefault(__webpack_require__(1096));

var _MonthView = _interopRequireDefault(__webpack_require__(1097));

var _dates = __webpack_require__(96);

var _propTypes2 = __webpack_require__(83);

var _utils = __webpack_require__(1094);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var baseClassName = 'react-calendar';
var allViews = ['century', 'decade', 'year', 'month'];
var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);

var datesAreDifferent = function datesAreDifferent(date1, date2) {
  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
};
/**
 * Returns views array with disallowed values cut off.
 */


var getLimitedViews = function getLimitedViews(minDetail, maxDetail) {
  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
};
/**
 * Determines whether a given view is allowed with currently applied settings.
 */


var isViewAllowed = function isViewAllowed(view, minDetail, maxDetail) {
  var views = getLimitedViews(minDetail, maxDetail);
  return views.indexOf(view) !== -1;
};
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */


var getView = function getView(view, minDetail, maxDetail) {
  if (isViewAllowed(view, minDetail, maxDetail)) {
    return view;
  }

  return getLimitedViews(minDetail, maxDetail).pop();
};
/**
 * Returns value type that can be returned with currently applied settings.
 */


var getValueType = function getValueType(maxDetail) {
  return allValueTypes[allViews.indexOf(maxDetail)];
};

var getValueFrom = function getValueFrom(value) {
  if (!value) {
    return null;
  }

  var rawValueFrom = value instanceof Array && value.length === 2 ? value[0] : value;

  if (!rawValueFrom) {
    return null;
  }

  var valueFromDate = new Date(rawValueFrom);

  if (isNaN(valueFromDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  return valueFromDate;
};

var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate, maxDetail) {
  var valueFrom = getValueFrom(value);

  if (!valueFrom) {
    return null;
  }

  var detailValueFrom = (0, _dates.getBegin)(getValueType(maxDetail), valueFrom);
  return (0, _utils.between)(detailValueFrom, minDate, maxDate);
};

var getValueTo = function getValueTo(value) {
  if (!value) {
    return null;
  }

  var rawValueTo = value instanceof Array && value.length === 2 ? value[1] : value;

  if (!rawValueTo) {
    return null;
  }

  var valueToDate = new Date(rawValueTo);

  if (isNaN(valueToDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  return valueToDate;
};

var getDetailValueTo = function getDetailValueTo(value, minDate, maxDate, maxDetail) {
  var valueTo = getValueTo(value);

  if (!valueTo) {
    return null;
  }

  var detailValueTo = (0, _dates.getEnd)(getValueType(maxDetail), valueTo);
  return (0, _utils.between)(detailValueTo, minDate, maxDate);
};

var getDetailValueArray = function getDetailValueArray(value, minDate, maxDate, maxDetail) {
  if (value instanceof Array) {
    return value;
  }

  return [getDetailValueFrom(value, minDate, maxDate, maxDetail), getDetailValueTo(value, minDate, maxDate, maxDetail)];
};

var getActiveStartDate = function getActiveStartDate(props) {
  var activeStartDate = props.activeStartDate,
      maxDate = props.maxDate,
      maxDetail = props.maxDetail,
      minDate = props.minDate,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view;
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = getDetailValueFrom(value, minDate, maxDate, maxDetail) || activeStartDate || new Date();
  return (0, _dates.getBegin)(rangeType, valueFrom);
};

var Calendar =
/*#__PURE__*/
function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "setActiveStartDate", function (activeStartDate) {
      var onActiveDateChange = _this.props.onActiveDateChange;

      _this.setState({
        activeStartDate: activeStartDate
      }, function () {
        var view = _this.state.view;
        (0, _utils.callIfDefined)(onActiveDateChange, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "drillDown", function (activeStartDate) {
      if (!_this.drillDownAvailable) {
        return;
      }

      var _this$props = _this.props,
          maxDetail = _this$props.maxDetail,
          minDetail = _this$props.minDetail,
          onDrillDown = _this$props.onDrillDown;
      var views = getLimitedViews(minDetail, maxDetail);

      _this.setState(function (prevState) {
        var nextView = views[views.indexOf(prevState.view) + 1];
        return {
          activeStartDate: activeStartDate,
          view: nextView
        };
      }, function () {
        var view = _this.state.view;
        (0, _utils.callIfDefined)(onDrillDown, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "drillUp", function () {
      if (!_this.drillUpAvailable) {
        return;
      }

      var _this$props2 = _this.props,
          maxDetail = _this$props2.maxDetail,
          minDetail = _this$props2.minDetail,
          onDrillUp = _this$props2.onDrillUp;
      var views = getLimitedViews(minDetail, maxDetail);

      _this.setState(function (prevState) {
        var nextView = views[views.indexOf(prevState.view) - 1];
        var activeStartDate = (0, _dates.getBegin)(nextView, prevState.activeStartDate);
        return {
          activeStartDate: activeStartDate,
          view: nextView
        };
      }, function () {
        var _this$state = _this.state,
            activeStartDate = _this$state.activeStartDate,
            view = _this$state.view;
        (0, _utils.callIfDefined)(onDrillUp, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          selectRange = _this$props3.selectRange;
      var nextValue;
      var callback;

      if (selectRange) {
        var previousValue = _this.state.value; // Range selection turned on

        if (!previousValue || [].concat(previousValue).length !== 1 // 0 or 2 - either way we're starting a new array
        ) {
            // First value
            nextValue = (0, _dates.getBegin)(_this.valueType, value);
          } else {
          // Second value
          nextValue = (0, _dates.getValueRange)(_this.valueType, previousValue, value);

          callback = function callback() {
            return (0, _utils.callIfDefined)(onChange, nextValue);
          };
        }
      } else {
        // Range selection turned off
        nextValue = _this.getProcessedValue(value);

        callback = function callback() {
          return (0, _utils.callIfDefined)(onChange, nextValue);
        };
      }

      _this.setState({
        value: nextValue
      }, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function (value) {
      _this.setState(function (prevState) {
        if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
          return null;
        }

        return {
          hover: value
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        hover: null
      });
    });

    return _this;
  }

  _createClass(Calendar, [{
    key: "getProcessedValue",

    /**
     * Gets current value in a desired format.
     */
    value: function getProcessedValue(value) {
      var _this$props4 = this.props,
          minDate = _this$props4.minDate,
          maxDate = _this$props4.maxDate,
          maxDetail = _this$props4.maxDetail,
          returnValue = _this$props4.returnValue;

      var processFunction = function () {
        switch (returnValue) {
          case 'start':
            return getDetailValueFrom;

          case 'end':
            return getDetailValueTo;

          case 'range':
            return getDetailValueArray;

          default:
            throw new Error('Invalid returnValue.');
        }
      }();

      return processFunction(value, minDate, maxDate, maxDetail);
    }
    /**
     * Called when the user uses navigation buttons.
     */

  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props5 = this.props,
          calendarType = _this$props5.calendarType,
          locale = _this$props5.locale,
          maxDate = _this$props5.maxDate,
          minDate = _this$props5.minDate,
          renderChildren = _this$props5.renderChildren,
          selectRange = _this$props5.selectRange,
          tileClassName = _this$props5.tileClassName,
          tileContent = _this$props5.tileContent,
          tileDisabled = _this$props5.tileDisabled;
      var _this$state2 = this.state,
          activeStartDate = _this$state2.activeStartDate,
          hover = _this$state2.hover,
          value = _this$state2.value,
          view = _this$state2.view;
      var onMouseOver = this.onMouseOver,
          valueType = this.valueType;
      var commonProps = {
        activeStartDate: activeStartDate,
        hover: hover,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        onMouseOver: selectRange ? onMouseOver : null,
        tileClassName: tileClassName,
        tileContent: tileContent || renderChildren,
        // For backwards compatibility
        tileDisabled: tileDisabled,
        value: value,
        valueType: valueType
      };
      var clickAction = this.drillDownAvailable ? this.drillDown : this.onChange;

      switch (view) {
        case 'century':
          {
            var onClickDecade = this.props.onClickDecade;
            return _react["default"].createElement(_CenturyView["default"], _extends({
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDecade)
            }, commonProps));
          }

        case 'decade':
          {
            var onClickYear = this.props.onClickYear;
            return _react["default"].createElement(_DecadeView["default"], _extends({
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickYear)
            }, commonProps));
          }

        case 'year':
          {
            var _this$props6 = this.props,
                formatMonth = _this$props6.formatMonth,
                onClickMonth = _this$props6.onClickMonth;
            return _react["default"].createElement(_YearView["default"], _extends({
              formatMonth: formatMonth,
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickMonth)
            }, commonProps));
          }

        case 'month':
          {
            var _this$props7 = this.props,
                formatShortWeekday = _this$props7.formatShortWeekday,
                onClickDay = _this$props7.onClickDay,
                onClickWeekNumber = _this$props7.onClickWeekNumber,
                showFixedNumberOfWeeks = _this$props7.showFixedNumberOfWeeks,
                showNeighboringMonth = _this$props7.showNeighboringMonth,
                showWeekNumbers = _this$props7.showWeekNumbers;
            var onMouseLeave = this.onMouseLeave;
            return _react["default"].createElement(_MonthView["default"], _extends({
              calendarType: calendarType,
              formatShortWeekday: formatShortWeekday,
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDay),
              onClickWeekNumber: onClickWeekNumber,
              onMouseLeave: onMouseLeave,
              showFixedNumberOfWeeks: showFixedNumberOfWeeks,
              showNeighboringMonth: showNeighboringMonth,
              showWeekNumbers: showWeekNumbers
            }, commonProps));
          }

        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var showNavigation = this.props.showNavigation;

      if (!showNavigation) {
        return null;
      }

      var _this$props8 = this.props,
          formatMonthYear = _this$props8.formatMonthYear,
          locale = _this$props8.locale,
          maxDate = _this$props8.maxDate,
          maxDetail = _this$props8.maxDetail,
          minDate = _this$props8.minDate,
          minDetail = _this$props8.minDetail,
          navigationAriaLabel = _this$props8.navigationAriaLabel,
          navigationLabel = _this$props8.navigationLabel,
          next2AriaLabel = _this$props8.next2AriaLabel,
          next2Label = _this$props8.next2Label,
          nextAriaLabel = _this$props8.nextAriaLabel,
          nextLabel = _this$props8.nextLabel,
          prev2AriaLabel = _this$props8.prev2AriaLabel,
          prev2Label = _this$props8.prev2Label,
          prevAriaLabel = _this$props8.prevAriaLabel,
          prevLabel = _this$props8.prevLabel;
      var _this$state3 = this.state,
          activeStartDate = _this$state3.activeStartDate,
          view = _this$state3.view;
      return _react["default"].createElement(_Navigation["default"], {
        activeStartDate: activeStartDate,
        drillUp: this.drillUp,
        formatMonthYear: formatMonthYear,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        navigationAriaLabel: navigationAriaLabel,
        navigationLabel: navigationLabel,
        next2AriaLabel: next2AriaLabel,
        next2Label: next2Label,
        nextAriaLabel: nextAriaLabel,
        nextLabel: nextLabel,
        prev2AriaLabel: prev2AriaLabel,
        prev2Label: prev2Label,
        prevAriaLabel: prevAriaLabel,
        prevLabel: prevLabel,
        setActiveStartDate: this.setActiveStartDate,
        view: view,
        views: getLimitedViews(minDetail, maxDetail)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          className = _this$props9.className,
          selectRange = _this$props9.selectRange;
      var value = this.state.value;
      var onMouseLeave = this.onMouseLeave;
      var valueArray = [].concat(value);
      return _react["default"].createElement("div", {
        className: (0, _mergeClassNames["default"])(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), className)
      }, this.renderNavigation(), _react["default"].createElement("div", {
        className: "".concat(baseClassName, "__viewContainer"),
        onBlur: selectRange ? onMouseLeave : null,
        onMouseLeave: selectRange ? onMouseLeave : null
      }, this.renderContent()));
    }
  }, {
    key: "drillDownAvailable",
    get: function get() {
      var _this$props10 = this.props,
          maxDetail = _this$props10.maxDetail,
          minDetail = _this$props10.minDetail;
      var view = this.state.view;
      var views = getLimitedViews(minDetail, maxDetail);
      return views.indexOf(view) < views.length - 1;
    }
  }, {
    key: "drillUpAvailable",
    get: function get() {
      var _this$props11 = this.props,
          maxDetail = _this$props11.maxDetail,
          minDetail = _this$props11.minDetail;
      var view = this.state.view;
      var views = getLimitedViews(minDetail, maxDetail);
      return views.indexOf(view) > 0;
    }
  }, {
    key: "valueType",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      return getValueType(maxDetail);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var minDate = nextProps.minDate,
          maxDate = nextProps.maxDate,
          minDetail = nextProps.minDetail,
          maxDetail = nextProps.maxDetail;
      var nextState = {};
      /**
       * If the next activeStartDate is different from the current one, update
       * activeStartDate (for display) and activeStartDateProps (for future comparisons)
       */

      var nextActiveStartDate = getActiveStartDate(nextProps);

      if (datesAreDifferent(nextActiveStartDate, prevState.activeStartDateProps)) {
        nextState.activeStartDate = nextActiveStartDate;
        nextState.activeStartDateProps = nextActiveStartDate;
      }
      /**
       * If the next view is different from the current one, and the previously set view is not
       * valid based on minDetail and maxDetail, get a new one.
       */


      var nextView = getView(nextProps.view, minDetail, maxDetail);

      if (nextView !== prevState.viewProps && !isViewAllowed(prevState.view, minDetail, maxDetail)) {
        nextState.view = nextView;
        nextState.viewProps = nextView;
      }
      /**
       * If the next value is different from the current one (with an exception of situation in
       * which values provided are limited by minDate and maxDate so that the dates are the same),
       * get a new one.
       */


      var values = [nextProps.value, prevState.valueProps];

      if (nextState.view // Allowed view changed
      || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
        return getValueFrom(value, minDate, maxDate, maxDetail);
      }))) || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
        return getValueTo(value, minDate, maxDate, maxDetail);
      })))) {
        nextState.value = nextProps.value;
        nextState.valueProps = nextProps.value;
      }

      if (!nextProps.selectRange && prevState.hover) {
        nextState.hover = null;
      }

      return nextState;
    }
  }]);

  return Calendar;
}(_react.Component);

exports["default"] = Calendar;
Calendar.defaultProps = {
  maxDetail: 'month',
  minDetail: 'century',
  returnValue: 'start',
  showNavigation: true,
  showNeighboringMonth: true,
  view: 'month'
};
Calendar.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date),
  calendarType: _propTypes2.isCalendarType,
  className: _propTypes2.isClassName,
  formatMonth: _propTypes["default"].func,
  formatMonthYear: _propTypes["default"].func,
  formatShortWeekday: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  maxDate: _propTypes2.isMaxDate,
  maxDetail: _propTypes["default"].oneOf(allViews),
  minDate: _propTypes2.isMinDate,
  minDetail: _propTypes["default"].oneOf(allViews),
  navigationAriaLabel: _propTypes["default"].string,
  navigationLabel: _propTypes["default"].func,
  next2AriaLabel: _propTypes["default"].string,
  next2Label: _propTypes["default"].node,
  nextAriaLabel: _propTypes["default"].string,
  nextLabel: _propTypes["default"].node,
  onActiveDateChange: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClickDay: _propTypes["default"].func,
  onClickDecade: _propTypes["default"].func,
  onClickMonth: _propTypes["default"].func,
  onClickWeekNumber: _propTypes["default"].func,
  onClickYear: _propTypes["default"].func,
  onDrillDown: _propTypes["default"].func,
  onDrillUp: _propTypes["default"].func,
  prev2AriaLabel: _propTypes["default"].string,
  prev2Label: _propTypes["default"].node,
  prevAriaLabel: _propTypes["default"].string,
  prevLabel: _propTypes["default"].node,
  renderChildren: _propTypes["default"].func,
  // For backwards compatibility
  returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
  selectRange: _propTypes["default"].bool,
  showFixedNumberOfWeeks: _propTypes["default"].bool,
  showNavigation: _propTypes["default"].bool,
  showNeighboringMonth: _propTypes["default"].bool,
  showWeekNumbers: _propTypes["default"].bool,
  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes2.isClassName]),
  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  tileDisabled: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes2.isValue]),
  view: _propTypes["default"].oneOf(allViews)
};
(0, _reactLifecyclesCompat.polyfill)(Calendar);

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(2704);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Navigation;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _dates = __webpack_require__(96);

var _dateFormatter = __webpack_require__(393);

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var className = 'react-calendar__navigation';

function Navigation(_ref) {
  var date = _ref.activeStartDate,
      drillUp = _ref.drillUp,
      formatMonthYear = _ref.formatMonthYear,
      locale = _ref.locale,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      navigationAriaLabel = _ref.navigationAriaLabel,
      navigationLabel = _ref.navigationLabel,
      next2AriaLabel = _ref.next2AriaLabel,
      next2Label = _ref.next2Label,
      nextAriaLabel = _ref.nextAriaLabel,
      nextLabel = _ref.nextLabel,
      prev2AriaLabel = _ref.prev2AriaLabel,
      prev2Label = _ref.prev2Label,
      prevAriaLabel = _ref.prevAriaLabel,
      prevLabel = _ref.prevLabel,
      setActiveStartDate = _ref.setActiveStartDate,
      view = _ref.view,
      views = _ref.views;
  var drillUpAvailable = views.indexOf(view) > 0;
  var shouldShowPrevNext2Buttons = view !== 'century';
  var previousActiveStartDate = (0, _dates.getBeginPrevious)(view, date);
  var previousActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates.getBeginPrevious2)(view, date);
  var nextActiveStartDate = (0, _dates.getBeginNext)(view, date);
  var nextActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates.getBeginNext2)(view, date);

  var prevButtonDisabled = function () {
    if (previousActiveStartDate.getFullYear() < 1000) {
      return true;
    }

    var previousActiveEndDate = (0, _dates.getEndPrevious)(view, date);
    return minDate && minDate >= previousActiveEndDate;
  }();

  var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function () {
    if (previousActiveStartDate2.getFullYear() < 1000) {
      return true;
    }

    var previousActiveEndDate = (0, _dates.getEndPrevious2)(view, date);
    return minDate && minDate >= previousActiveEndDate;
  }();

  var nextButtonDisabled = maxDate && maxDate <= nextActiveStartDate;
  var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate <= nextActiveStartDate2;

  function onClickPrevious() {
    setActiveStartDate(previousActiveStartDate);
  }

  function onClickPrevious2() {
    setActiveStartDate(previousActiveStartDate2);
  }

  function onClickNext() {
    setActiveStartDate(nextActiveStartDate);
  }

  function onClickNext2() {
    setActiveStartDate(nextActiveStartDate2);
  }

  var label = function () {
    switch (view) {
      case 'century':
        return (0, _dates.getCenturyLabel)(date);

      case 'decade':
        return (0, _dates.getDecadeLabel)(date);

      case 'year':
        return (0, _dates.getYear)(date);

      case 'month':
        return formatMonthYear(locale, date);

      default:
        throw new Error("Invalid view: ".concat(view, "."));
    }
  }();

  return _react["default"].createElement("div", {
    className: className,
    style: {
      display: 'flex'
    }
  }, prev2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
    "aria-label": prev2AriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__prev2-button"),
    disabled: prev2ButtonDisabled,
    onClick: onClickPrevious2,
    type: "button"
  }, prev2Label), _react["default"].createElement("button", {
    "aria-label": prevAriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__prev-button"),
    disabled: prevButtonDisabled,
    onClick: onClickPrevious,
    type: "button"
  }, prevLabel), _react["default"].createElement("button", {
    "aria-label": navigationAriaLabel,
    className: "react-calendar__navigation__label",
    disabled: !drillUpAvailable,
    onClick: drillUp,
    style: {
      flexGrow: 1
    },
    type: "button"
  }, navigationLabel ? navigationLabel({
    date: date,
    view: view,
    label: label
  }) : label), _react["default"].createElement("button", {
    "aria-label": nextAriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__next-button"),
    disabled: nextButtonDisabled,
    onClick: onClickNext,
    type: "button"
  }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
    "aria-label": next2AriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__next2-button"),
    disabled: next2ButtonDisabled,
    onClick: onClickNext2,
    type: "button"
  }, next2Label));
}

Navigation.defaultProps = {
  formatMonthYear: _dateFormatter.formatMonthYear,
  navigationAriaLabel: '',
  next2AriaLabel: '',
  next2Label: '»',
  nextAriaLabel: '',
  nextLabel: '›',
  prev2AriaLabel: '',
  prev2Label: '«',
  prevAriaLabel: '',
  prevLabel: '‹'
};
Navigation.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  drillUp: _propTypes["default"].func.isRequired,
  formatMonthYear: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  maxDate: _propTypes["default"].instanceOf(Date),
  minDate: _propTypes["default"].instanceOf(Date),
  navigationAriaLabel: _propTypes["default"].string,
  navigationLabel: _propTypes["default"].func,
  next2AriaLabel: _propTypes["default"].string,
  next2Label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  nextAriaLabel: _propTypes["default"].string,
  nextLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  prev2AriaLabel: _propTypes["default"].string,
  prev2Label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  prevAriaLabel: _propTypes["default"].string,
  prevLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  setActiveStartDate: _propTypes["default"].func.isRequired,
  view: _propTypes2.isView.isRequired,
  views: _propTypes2.isViews.isRequired
};

/***/ }),
/* 2707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserLocales", function() { return getUserLocales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserLocale", function() { return getUserLocale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_once__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_once___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_once__);


function filterDuplicates(arr) {
  return arr.filter(function (el, index, self) {
    return self.indexOf(el) === index;
  });
}

function fixLowercaseProperties(arr) {
  return arr.map(function (el) {
    if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
      return el;
    }

    var splitEl = el.split('-');
    return "".concat(splitEl[0], "-").concat(splitEl[1].toUpperCase());
  });
}

function getUserLocalesInternal() {
  var languageList = [];

  if (typeof window !== 'undefined') {
    if (window.navigator.languages) {
      languageList = languageList.concat(window.navigator.languages);
    }

    if (window.navigator.language) {
      languageList.push(window.navigator.language);
    }

    if (window.navigator.userLanguage) {
      languageList.push(window.navigator.userLanguage);
    }

    if (window.navigator.browserLanguage) {
      languageList.push(window.navigator.browserLanguage);
    }

    if (window.navigator.systemLanguage) {
      languageList.push(window.navigator.systemLanguage);
    }
  }

  languageList.push('en-US'); // Fallback

  return fixLowercaseProperties(filterDuplicates(languageList));
}

var getUserLocales = __WEBPACK_IMPORTED_MODULE_0_lodash_once___default()(getUserLocalesInternal);

function getUserLocaleInternal() {
  return getUserLocales()[0];
}

var getUserLocale = __WEBPACK_IMPORTED_MODULE_0_lodash_once___default()(getUserLocaleInternal);
/* harmony default export */ __webpack_exports__["default"] = (getUserLocale);

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Decades;

var _react = _interopRequireDefault(__webpack_require__(0));

var _TileGroup = _interopRequireDefault(__webpack_require__(394));

var _Decade = _interopRequireDefault(__webpack_require__(2709));

var _dates = __webpack_require__(96);

var _propTypes = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Decades(props) {
  var activeStartDate = props.activeStartDate;
  var start = (0, _dates.getBeginOfCenturyYear)(activeStartDate);
  var end = start + 99;
  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
    className: "react-calendar__century-view__decades",
    dateTransform: _dates.getBeginOfDecade,
    dateType: "decade",
    end: end,
    start: start,
    step: 10,
    tile: _Decade["default"]
  }));
}

Decades.propTypes = _objectSpread({}, _propTypes.tileGroupProps);

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Decade;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _Tile = _interopRequireDefault(__webpack_require__(395));

var _dates = __webpack_require__(96);

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__century-view__decades__decade';

function Decade(_ref) {
  var classes = _ref.classes,
      point = _ref.point,
      otherProps = _objectWithoutProperties(_ref, ["classes", "point"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    maxDateTransform: _dates.getEndOfDecade,
    minDateTransform: _dates.getBeginOfDecade,
    view: "century"
  }), (0, _dates.getDecadeLabel)(point));
}

Decade.propTypes = _objectSpread({}, _propTypes2.tileProps, {
  point: _propTypes["default"].number.isRequired
});

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Years;

var _react = _interopRequireDefault(__webpack_require__(0));

var _TileGroup = _interopRequireDefault(__webpack_require__(394));

var _Year = _interopRequireDefault(__webpack_require__(2711));

var _dates = __webpack_require__(96);

var _propTypes = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Years(props) {
  var activeStartDate = props.activeStartDate;
  var start = (0, _dates.getBeginOfDecadeYear)(activeStartDate);
  var end = start + 9;
  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
    className: "react-calendar__decade-view__years",
    dateTransform: function dateTransform(year) {
      return new Date(year, 0, 1);
    },
    dateType: "year",
    end: end,
    start: start,
    tile: _Year["default"]
  }));
}

Years.propTypes = _objectSpread({}, _propTypes.tileGroupProps);

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Year;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _Tile = _interopRequireDefault(__webpack_require__(395));

var _dates = __webpack_require__(96);

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__decade-view__years__year';

function Year(_ref) {
  var classes = _ref.classes,
      point = _ref.point,
      otherProps = _objectWithoutProperties(_ref, ["classes", "point"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    maxDateTransform: _dates.getEndOfYear,
    minDateTransform: _dates.getBeginOfYear,
    view: "decade"
  }), point);
}

Year.propTypes = _objectSpread({}, _propTypes2.tileProps, {
  point: _propTypes["default"].number.isRequired
});

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Months;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _TileGroup = _interopRequireDefault(__webpack_require__(394));

var _Month = _interopRequireDefault(__webpack_require__(2713));

var _dates = __webpack_require__(96);

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Months(props) {
  var activeStartDate = props.activeStartDate;
  var start = 0;
  var end = 11;
  var year = (0, _dates.getYear)(activeStartDate);
  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
    className: "react-calendar__year-view__months",
    dateTransform: function dateTransform(monthIndex) {
      return new Date(year, monthIndex, 1);
    },
    dateType: "month",
    end: end,
    start: start,
    tile: _Month["default"]
  }));
}

Months.propTypes = _objectSpread({}, _propTypes2.tileGroupProps, {
  locale: _propTypes["default"].string
});

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Month;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _Tile = _interopRequireDefault(__webpack_require__(395));

var _dates = __webpack_require__(96);

var _dateFormatter = __webpack_require__(393);

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__year-view__months__month';

function Month(_ref) {
  var classes = _ref.classes,
      date = _ref.date,
      formatMonth = _ref.formatMonth,
      locale = _ref.locale,
      otherProps = _objectWithoutProperties(_ref, ["classes", "date", "formatMonth", "locale"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    date: date,
    formatAbbr: _dateFormatter.formatMonthYear,
    locale: locale,
    maxDateTransform: _dates.getEndOfMonth,
    minDateTransform: _dates.getBeginOfMonth,
    view: "year"
  }), formatMonth(locale, date));
}

Month.defaultProps = {
  formatMonth: _dateFormatter.formatMonth
};
Month.propTypes = _objectSpread({}, _propTypes2.tileProps, {
  formatMonth: _propTypes["default"].func
});

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Days;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _TileGroup = _interopRequireDefault(__webpack_require__(394));

var _Day = _interopRequireDefault(__webpack_require__(2715));

var _dates = __webpack_require__(96);

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Days(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType;

  var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks,
      showNeighboringMonth = props.showNeighboringMonth,
      otherProps = _objectWithoutProperties(props, ["showFixedNumberOfWeeks", "showNeighboringMonth"]);

  var year = (0, _dates.getYear)(activeStartDate);
  var monthIndex = (0, _dates.getMonthIndex)(activeStartDate);
  var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
  var dayOfWeek = (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
  var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
  /**
   * Defines on which day of the month the grid shall start. If we simply show current
   * month, we obviously start on day one, but if showNeighboringMonth is set to
   * true, we need to find the beginning of the week the first day of the month is in.
   */

  var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
  /**
   * Defines on which day of the month the grid shall end. If we simply show current
   * month, we need to stop on the last day of the month, but if showNeighboringMonth
   * is set to true, we need to find the end of the week the last day of the month is in.
   */

  var end = function () {
    if (showFixedNumberOfWeeks) {
      // Always show 6 weeks
      return start + 6 * 7 - 1;
    }

    var daysInMonth = (0, _dates.getDaysInMonth)(activeStartDate);

    if (showNeighboringMonth) {
      var activeEndDate = new Date(year, monthIndex, daysInMonth);
      return daysInMonth + (7 - (0, _dates.getDayOfWeek)(activeEndDate, calendarType) - 1);
    }

    return daysInMonth;
  }();

  return _react["default"].createElement(_TileGroup["default"], _extends({}, otherProps, {
    className: "react-calendar__month-view__days",
    count: 7,
    currentMonthIndex: monthIndex,
    dateTransform: function dateTransform(day) {
      return new Date(year, monthIndex, day);
    },
    dateType: "day",
    end: end,
    offset: offset,
    start: start,
    tile: _Day["default"]
  }));
}

Days.propTypes = _objectSpread({
  calendarType: _propTypes2.isCalendarType.isRequired,
  showFixedNumberOfWeeks: _propTypes["default"].bool,
  showNeighboringMonth: _propTypes["default"].bool
}, _propTypes2.tileGroupProps);

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Day;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _Tile = _interopRequireDefault(__webpack_require__(395));

var _dates = __webpack_require__(96);

var _dateFormatter = __webpack_require__(393);

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__month-view__days__day';

function Day(_ref) {
  var calendarType = _ref.calendarType,
      classes = _ref.classes,
      currentMonthIndex = _ref.currentMonthIndex,
      date = _ref.date,
      otherProps = _objectWithoutProperties(_ref, ["calendarType", "classes", "currentMonthIndex", "date"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className, (0, _dates.isWeekend)(date, calendarType) ? "".concat(className, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className, "--neighboringMonth") : null),
    date: date,
    formatAbbr: _dateFormatter.formatLongDate,
    maxDateTransform: _dates.getEndOfDay,
    minDateTransform: _dates.getBeginOfDay,
    view: "month"
  }), (0, _dates.getDay)(date));
}

Day.propTypes = _objectSpread({}, _propTypes2.tileProps, {
  currentMonthIndex: _propTypes["default"].number.isRequired
});

/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Weekdays;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _Flex = _interopRequireDefault(__webpack_require__(576));

var _dates = __webpack_require__(96);

var _dateFormatter = __webpack_require__(393);

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Weekdays(props) {
  var calendarType = props.calendarType,
      formatShortWeekday = props.formatShortWeekday,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave;
  var anyDate = new Date();
  var beginOfMonth = (0, _dates.getBeginOfMonth)(anyDate);
  var year = (0, _dates.getYear)(beginOfMonth);
  var monthIndex = (0, _dates.getMonthIndex)(beginOfMonth);
  var weekdays = [];

  for (var weekday = 1; weekday <= 7; weekday += 1) {
    var weekdayDate = new Date(year, monthIndex, weekday - (0, _dates.getDayOfWeek)(beginOfMonth, calendarType));
    var abbr = (0, _dateFormatter.formatWeekday)(locale, weekdayDate);
    weekdays.push(_react["default"].createElement("div", {
      key: weekday,
      className: "react-calendar__month-view__weekdays__weekday"
    }, _react["default"].createElement("abbr", {
      "aria-label": abbr,
      title: abbr
    }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
  }

  return _react["default"].createElement(_Flex["default"], {
    className: "react-calendar__month-view__weekdays",
    count: 7,
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave
  }, weekdays);
}

Weekdays.defaultProps = {
  formatShortWeekday: _dateFormatter.formatShortWeekday
};
Weekdays.propTypes = {
  calendarType: _propTypes2.isCalendarType.isRequired,
  formatShortWeekday: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  onMouseLeave: _propTypes["default"].func
};

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WeekNumbers;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

var _WeekNumber = _interopRequireDefault(__webpack_require__(2718));

var _Flex = _interopRequireDefault(__webpack_require__(576));

var _dates = __webpack_require__(96);

var _propTypes2 = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function WeekNumbers(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType,
      onClickWeekNumber = props.onClickWeekNumber,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

  var numberOfWeeks = function () {
    if (showFixedNumberOfWeeks) {
      return 6;
    }

    var numberOfDays = (0, _dates.getDaysInMonth)(activeStartDate);
    var startWeekday = (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
    var days = numberOfDays - (7 - startWeekday);
    return 1 + Math.ceil(days / 7);
  }();

  var dates = function () {
    var year = (0, _dates.getYear)(activeStartDate);
    var monthIndex = (0, _dates.getMonthIndex)(activeStartDate);
    var day = (0, _dates.getDay)(activeStartDate);
    var result = [];

    for (var index = 0; index < numberOfWeeks; index += 1) {
      result.push((0, _dates.getBeginOfWeek)(new Date(year, monthIndex, day + index * 7), calendarType));
    }

    return result;
  }();

  var weekNumbers = dates.map(function (date) {
    return (0, _dates.getWeekNumber)(date, calendarType);
  });
  return _react["default"].createElement(_Flex["default"], {
    className: "react-calendar__month-view__weekNumbers",
    count: numberOfWeeks,
    direction: "column",
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave,
    style: {
      flexBasis: 'calc(100% * (1 / 8)',
      flexShrink: 0
    }
  }, weekNumbers.map(function (weekNumber, weekIndex) {
    return _react["default"].createElement(_WeekNumber["default"], {
      key: weekNumber,
      date: dates[weekIndex],
      onClickWeekNumber: onClickWeekNumber,
      weekNumber: weekNumber
    });
  }));
}

WeekNumbers.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  calendarType: _propTypes2.isCalendarType.isRequired,
  onClickWeekNumber: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  showFixedNumberOfWeeks: _propTypes["default"].bool
};

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WeekNumber;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(79));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function WeekNumber(_ref) {
  var date = _ref.date,
      onClickWeekNumber = _ref.onClickWeekNumber,
      weekNumber = _ref.weekNumber;
  return onClickWeekNumber ? _react["default"].createElement("button", {
    className: "react-calendar__tile",
    onClick: function onClick() {
      return onClickWeekNumber(weekNumber, date);
    },
    style: {
      flexGrow: 1
    },
    type: "button"
  }, _react["default"].createElement("span", null, weekNumber)) : _react["default"].createElement("div", {
    className: "react-calendar__tile",
    style: {
      flexGrow: 1
    }
  }, _react["default"].createElement("span", null, weekNumber));
}

WeekNumber.propTypes = {
  date: _propTypes["default"].instanceOf(Date).isRequired,
  onClickWeekNumber: _propTypes["default"].func,
  weekNumber: _propTypes["default"].number.isRequired
};

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2720);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js??ref--1-1!../../postcss-loader/lib/index.js!./Calendar.css", function() {
			var newContent = require("!!../../css-loader/index.js??ref--1-1!../../postcss-loader/lib/index.js!./Calendar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".Calendar--react-calendar--NE_ZNv8m {\n  width: 350px;\n  max-width: 100%;\n  background: white;\n  border: 1px solid #a0a096;\n  font-family: Arial, Helvetica, sans-serif;\n  line-height: 1.125em;\n}\n.Calendar--react-calendar--NE_ZNv8m,\n.Calendar--react-calendar--NE_ZNv8m *,\n.Calendar--react-calendar--NE_ZNv8m *:before,\n.Calendar--react-calendar--NE_ZNv8m *:after {\n  box-sizing: border-box;\n}\n.Calendar--react-calendar--NE_ZNv8m button {\n  margin: 0;\n  border: 0;\n  outline: none;\n}\n.Calendar--react-calendar--NE_ZNv8m button:enabled:hover {\n  cursor: pointer;\n}\n.Calendar--react-calendar__navigation--2XItShcK {\n  height: 44px;\n  margin-bottom: 1em;\n}\n.Calendar--react-calendar__navigation--2XItShcK button {\n  min-width: 44px;\n  background: none;\n}\n.Calendar--react-calendar__navigation--2XItShcK button:enabled:hover,\n.Calendar--react-calendar__navigation--2XItShcK button:enabled:focus {\n  background-color: #e6e6e6;\n}\n.Calendar--react-calendar__navigation--2XItShcK button[disabled] {\n  background-color: #f0f0f0;\n}\n.Calendar--react-calendar__month-view__weekdays--2XGjiCuy {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 0.75em;\n}\n.Calendar--react-calendar__month-view__weekdays__weekday--2sNC3LgC {\n  padding: 0.5em;\n}\n.Calendar--react-calendar__month-view__weekNumbers--2XCSikY3 {\n  font-weight: bold;\n}\n.Calendar--react-calendar__month-view__weekNumbers--2XCSikY3 .Calendar--react-calendar__tile--3zifVFYY {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  font-size: 0.75em;\n  padding: 1em 0.66667em;\n}\n.Calendar--react-calendar__month-view__days__day--weekend--1Xtzq9z7 {\n  color: #d10000;\n}\n.Calendar--react-calendar__month-view__days__day--neighboringMonth--1wETIY_M {\n  color: #757575;\n}\n.Calendar--react-calendar__year-view--2Ov7l9oz .Calendar--react-calendar__tile--3zifVFYY,\n.Calendar--react-calendar__decade-view--1XlbgB5o .Calendar--react-calendar__tile--3zifVFYY,\n.Calendar--react-calendar__century-view--3Bb4n0qq .Calendar--react-calendar__tile--3zifVFYY {\n  padding: 2em 0.5em;\n}\n.Calendar--react-calendar__tile--3zifVFYY {\n  max-width: 100%;\n  text-align: center;\n  padding: 0.75em 0.5em;\n  background: none;\n}\n.Calendar--react-calendar__tile--3zifVFYY:disabled {\n  background-color: #f0f0f0;\n}\n.Calendar--react-calendar__tile--3zifVFYY:enabled:hover,\n.Calendar--react-calendar__tile--3zifVFYY:enabled:focus {\n  background-color: #e6e6e6;\n}\n.Calendar--react-calendar__tile--hasActive--2wWqujM6 {\n  background: #76baff;\n}\n.Calendar--react-calendar__tile--hasActive--2wWqujM6:enabled:hover,\n.Calendar--react-calendar__tile--hasActive--2wWqujM6:enabled:focus {\n  background: #a9d4ff;\n}\n.Calendar--react-calendar__tile--active--1IK03KRa {\n  background: #006edc;\n  color: white;\n}\n.Calendar--react-calendar__tile--active--1IK03KRa:enabled:hover,\n.Calendar--react-calendar__tile--active--1IK03KRa:enabled:focus {\n  background: #1087ff;\n}\n.Calendar--react-calendar--selectRange--1d2ZWp2B .Calendar--react-calendar__tile--hover--3DvAv-PI {\n  background-color: #e6e6e6;\n}\n", "", {"version":3,"sources":["/../../../shared/rnclient/node_modules/react-calendar/dist/Calendar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,0CAA0C;EAC1C,qBAAqB;CACtB;AACD;;;;EAIE,uBAAuB;CACxB;AACD;EACE,UAAU;EACV,UAAU;EACV,cAAc;CACf;AACD;EACE,gBAAgB;CACjB;AACD;EACE,aAAa;EACb,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;CAClB;AACD;;EAEE,0BAA0B;CAC3B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,eAAe;CAChB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;EAChC,kBAAkB;EAClB,uBAAuB;CACxB;AACD;EACE,eAAe;CAChB;AACD;EACE,eAAe;CAChB;AACD;;;EAGE,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;CAClB;AACD;EACE,0BAA0B;CAC3B;AACD;;EAEE,0BAA0B;CAC3B;AACD;EACE,oBAAoB;CACrB;AACD;;EAEE,oBAAoB;CACrB;AACD;EACE,oBAAoB;EACpB,aAAa;CACd;AACD;;EAEE,oBAAoB;CACrB;AACD;EACE,0BAA0B;CAC3B","file":"Calendar.css","sourcesContent":[".react-calendar {\n  width: 350px;\n  max-width: 100%;\n  background: white;\n  border: 1px solid #a0a096;\n  font-family: Arial, Helvetica, sans-serif;\n  line-height: 1.125em;\n}\n.react-calendar,\n.react-calendar *,\n.react-calendar *:before,\n.react-calendar *:after {\n  box-sizing: border-box;\n}\n.react-calendar button {\n  margin: 0;\n  border: 0;\n  outline: none;\n}\n.react-calendar button:enabled:hover {\n  cursor: pointer;\n}\n.react-calendar__navigation {\n  height: 44px;\n  margin-bottom: 1em;\n}\n.react-calendar__navigation button {\n  min-width: 44px;\n  background: none;\n}\n.react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n  background-color: #e6e6e6;\n}\n.react-calendar__navigation button[disabled] {\n  background-color: #f0f0f0;\n}\n.react-calendar__month-view__weekdays {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 0.75em;\n}\n.react-calendar__month-view__weekdays__weekday {\n  padding: 0.5em;\n}\n.react-calendar__month-view__weekNumbers {\n  font-weight: bold;\n}\n.react-calendar__month-view__weekNumbers .react-calendar__tile {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  font-size: 0.75em;\n  padding: 1em 0.66667em;\n}\n.react-calendar__month-view__days__day--weekend {\n  color: #d10000;\n}\n.react-calendar__month-view__days__day--neighboringMonth {\n  color: #757575;\n}\n.react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n  padding: 2em 0.5em;\n}\n.react-calendar__tile {\n  max-width: 100%;\n  text-align: center;\n  padding: 0.75em 0.5em;\n  background: none;\n}\n.react-calendar__tile:disabled {\n  background-color: #f0f0f0;\n}\n.react-calendar__tile:enabled:hover,\n.react-calendar__tile:enabled:focus {\n  background-color: #e6e6e6;\n}\n.react-calendar__tile--hasActive {\n  background: #76baff;\n}\n.react-calendar__tile--hasActive:enabled:hover,\n.react-calendar__tile--hasActive:enabled:focus {\n  background: #a9d4ff;\n}\n.react-calendar__tile--active {\n  background: #006edc;\n  color: white;\n}\n.react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n  background: #1087ff;\n}\n.react-calendar--selectRange .react-calendar__tile--hover {\n  background-color: #e6e6e6;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"react-calendar": "Calendar--react-calendar--NE_ZNv8m",
	"react-calendar__navigation": "Calendar--react-calendar__navigation--2XItShcK",
	"react-calendar__month-view__weekdays": "Calendar--react-calendar__month-view__weekdays--2XGjiCuy",
	"react-calendar__month-view__weekdays__weekday": "Calendar--react-calendar__month-view__weekdays__weekday--2sNC3LgC",
	"react-calendar__month-view__weekNumbers": "Calendar--react-calendar__month-view__weekNumbers--2XCSikY3",
	"react-calendar__tile": "Calendar--react-calendar__tile--3zifVFYY",
	"react-calendar__month-view__days__day--weekend": "Calendar--react-calendar__month-view__days__day--weekend--1Xtzq9z7",
	"react-calendar__month-view__days__day--neighboringMonth": "Calendar--react-calendar__month-view__days__day--neighboringMonth--1wETIY_M",
	"react-calendar__year-view": "Calendar--react-calendar__year-view--2Ov7l9oz",
	"react-calendar__decade-view": "Calendar--react-calendar__decade-view--1XlbgB5o",
	"react-calendar__century-view": "Calendar--react-calendar__century-view--3Bb4n0qq",
	"react-calendar__tile--hasActive": "Calendar--react-calendar__tile--hasActive--2wWqujM6",
	"react-calendar__tile--active": "Calendar--react-calendar__tile--active--1IK03KRa",
	"react-calendar--selectRange": "Calendar--react-calendar--selectRange--1d2ZWp2B",
	"react-calendar__tile--hover": "Calendar--react-calendar__tile--hover--3DvAv-PI"
};

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2722);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js?importLoaders=1!../../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js!../../../../../../../shared/rnclient/node_modules/extract-text-webpack-plugin/loader.js??ref--12-0!../../../../../../../shared/rnclient/node_modules/style-loader/index.js!../../../../../../../shared/rnclient/node_modules/css-loader/index.js?sourceMap&localIdentName=[local]___[hash:base64:5]!../../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js?outputStyle=expanded!./calendar.scss", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js?importLoaders=1!../../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js!../../../../../../../shared/rnclient/node_modules/extract-text-webpack-plugin/loader.js??ref--12-0!../../../../../../../shared/rnclient/node_modules/style-loader/index.js!../../../../../../../shared/rnclient/node_modules/css-loader/index.js?sourceMap&localIdentName=[local]___[hash:base64:5]!../../../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js?outputStyle=expanded!./calendar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internals_js__ = __webpack_require__(2724);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "internals", function() { return __WEBPACK_IMPORTED_MODULE_0__internals_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_PublicClientApplication_js__ = __webpack_require__(2756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PublicClientApplication", function() { return __WEBPACK_IMPORTED_MODULE_1__app_PublicClientApplication_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Configuration_js__ = __webpack_require__(583);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_IFRAME_TIMEOUT_MS", function() { return __WEBPACK_IMPORTED_MODULE_2__config_Configuration_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ApiId", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserCacheLocation", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CacheLookupPolicy", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionStatus", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionType", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WrapperSKU", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["r"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_BrowserUtils_js__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserUtils", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_BrowserUtils_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserAuthError", function() { return __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserAuthErrorMessage", function() { return __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_BrowserConfigurationAuthError_js__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserConfigurationAuthError", function() { return __WEBPACK_IMPORTED_MODULE_6__error_BrowserConfigurationAuthError_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserConfigurationAuthErrorMessage", function() { return __WEBPACK_IMPORTED_MODULE_6__error_BrowserConfigurationAuthError_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_IPublicClientApplication_js__ = __webpack_require__(2761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stubbedPublicClientApplication", function() { return __WEBPACK_IMPORTED_MODULE_7__app_IPublicClientApplication_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__navigation_NavigationClient_js__ = __webpack_require__(1126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationClient", function() { return __WEBPACK_IMPORTED_MODULE_8__navigation_NavigationClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__event_EventMessage_js__ = __webpack_require__(2762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EventMessageUtils", function() { return __WEBPACK_IMPORTED_MODULE_9__event_EventMessage_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__event_EventType_js__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EventType", function() { return __WEBPACK_IMPORTED_MODULE_10__event_EventType_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__crypto_SignedHttpRequest_js__ = __webpack_require__(2763);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SignedHttpRequest", function() { return __WEBPACK_IMPORTED_MODULE_11__crypto_SignedHttpRequest_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccountEntity", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AuthError", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AuthErrorMessage", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationHeaderParser", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationScheme", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AzureCloudInstance", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClientAuthError", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClientAuthErrorMessage", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClientConfigurationError", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClientConfigurationErrorMessage", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionRequiredAuthError", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["B"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InteractionRequiredAuthErrorMessage", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["C"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["E"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["F"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OIDC_DEFAULT_SCOPES", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["G"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PerformanceEvents", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["I"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProtocolMode", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["M"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ServerError", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["S"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StringUtils", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["W"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UrlString", function() { return __WEBPACK_IMPORTED_MODULE_12__azure_msal_common__["_2"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__packageMetadata_js__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return __WEBPACK_IMPORTED_MODULE_13__packageMetadata_js__["b"]; });
/*! @azure/msal-browser v2.38.3 2023-10-27 */
















//# sourceMappingURL=index.js.map


/***/ }),
/* 2724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cache_BrowserCacheManager_js__ = __webpack_require__(1098);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserCacheManager", function() { return __WEBPACK_IMPORTED_MODULE_0__cache_BrowserCacheManager_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interaction_client_StandardInteractionClient_js__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StandardInteractionClient", function() { return __WEBPACK_IMPORTED_MODULE_1__interaction_client_StandardInteractionClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__interaction_client_RedirectClient_js__ = __webpack_require__(1121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RedirectClient", function() { return __WEBPACK_IMPORTED_MODULE_2__interaction_client_RedirectClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interaction_client_PopupClient_js__ = __webpack_require__(1123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopupClient", function() { return __WEBPACK_IMPORTED_MODULE_3__interaction_client_PopupClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__interaction_client_SilentIframeClient_js__ = __webpack_require__(1124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SilentIframeClient", function() { return __WEBPACK_IMPORTED_MODULE_4__interaction_client_SilentIframeClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interaction_client_SilentCacheClient_js__ = __webpack_require__(582);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SilentCacheClient", function() { return __WEBPACK_IMPORTED_MODULE_5__interaction_client_SilentCacheClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__interaction_client_SilentRefreshClient_js__ = __webpack_require__(1127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SilentRefreshClient", function() { return __WEBPACK_IMPORTED_MODULE_6__interaction_client_SilentRefreshClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__interaction_client_NativeInteractionClient_js__ = __webpack_require__(298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NativeInteractionClient", function() { return __WEBPACK_IMPORTED_MODULE_7__interaction_client_NativeInteractionClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__interaction_handler_RedirectHandler_js__ = __webpack_require__(1122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RedirectHandler", function() { return __WEBPACK_IMPORTED_MODULE_8__interaction_handler_RedirectHandler_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__event_EventHandler_js__ = __webpack_require__(1128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EventHandler", function() { return __WEBPACK_IMPORTED_MODULE_9__event_EventHandler_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__broker_nativeBroker_NativeMessageHandler_js__ = __webpack_require__(243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NativeMessageHandler", function() { return __WEBPACK_IMPORTED_MODULE_10__broker_nativeBroker_NativeMessageHandler_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserConstants", function() { return __WEBPACK_IMPORTED_MODULE_11__utils_BrowserConstants_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TemporaryCacheKeys", function() { return __WEBPACK_IMPORTED_MODULE_11__utils_BrowserConstants_js__["q"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__crypto_CryptoOps_js__ = __webpack_require__(584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CryptoOps", function() { return __WEBPACK_IMPORTED_MODULE_12__crypto_CryptoOps_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__error_NativeAuthError_js__ = __webpack_require__(299);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NativeAuthError", function() { return __WEBPACK_IMPORTED_MODULE_13__error_NativeAuthError_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__telemetry_BrowserPerformanceClient_js__ = __webpack_require__(1132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserPerformanceClient", function() { return __WEBPACK_IMPORTED_MODULE_14__telemetry_BrowserPerformanceClient_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__telemetry_BrowserPerformanceMeasurement_js__ = __webpack_require__(1133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserPerformanceMeasurement", function() { return __WEBPACK_IMPORTED_MODULE_15__telemetry_BrowserPerformanceMeasurement_js__["a"]; });
/*! @azure/msal-browser v2.38.3 2023-10-27 */


















/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
//# sourceMappingURL=internals.js.map


/***/ }),
/* 2725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthorizationCodeClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseClient_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request_RequestParameterBuilder_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__response_ResponseHandler_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__url_UrlString_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__crypto_PopTokenGenerator_js__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_TimeUtils_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__account_ClientInfo_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__account_CcsCredential_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__request_RequestValidator_js__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__ = __webpack_require__(153);
/*! @azure/msal-common v13.3.1 2023-10-27 */

















/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Oauth2.0 Authorization Code client
 */
var AuthorizationCodeClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(AuthorizationCodeClient, _super);
    function AuthorizationCodeClient(configuration, performanceClient) {
        var _this = _super.call(this, configuration, performanceClient) || this;
        // Flag to indicate if client is for hybrid spa auth code redemption
        _this.includeRedirectUri = true;
        return _this;
    }
    /**
     * Creates the URL of the authorization request letting the user input credentials and consent to the
     * application. The URL target the /authorize endpoint of the authority configured in the
     * application object.
     *
     * Once the user inputs their credentials and consents, the authority will send a response to the redirect URI
     * sent in the request and should contain an authorization code, which can then be used to acquire tokens via
     * acquireToken(AuthorizationCodeRequest)
     * @param request
     */
    AuthorizationCodeClient.prototype.getAuthCodeUrl = function (request) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var queryString;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].GetAuthCodeUrl, request.correlationId);
                        (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthClientCreateQueryString, request.correlationId);
                        return [4 /*yield*/, this.createAuthCodeUrlQueryString(request)];
                    case 1:
                        queryString = _c.sent();
                        return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_7__url_UrlString_js__["a" /* UrlString */].appendQueryString(this.authority.authorizationEndpoint, queryString)];
                }
            });
        });
    };
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */
    AuthorizationCodeClient.prototype.acquireToken = function (request, authCodePayload) {
        var _a, _b, _c, _d, _e, _f;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var atsMeasurement, reqTimestamp, response, requestId, httpVerAuthority, responseHandler;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!request || !request.code) {
                            throw __WEBPACK_IMPORTED_MODULE_6__error_ClientAuthError_js__["a" /* ClientAuthError */].createTokenRequestCannotBeMadeError();
                        }
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthClientAcquireToken, request.correlationId);
                        atsMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement("AuthCodeClientAcquireToken", request.correlationId);
                        this.logger.info("in acquireToken call in auth-code client");
                        reqTimestamp = __WEBPACK_IMPORTED_MODULE_9__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds();
                        (_c = this.performanceClient) === null || _c === void 0 ? void 0 : _c.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthClientExecuteTokenRequest, request.correlationId);
                        return [4 /*yield*/, this.executeTokenRequest(this.authority, request)];
                    case 1:
                        response = _g.sent();
                        requestId = (_d = response.headers) === null || _d === void 0 ? void 0 : _d[__WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["q" /* HeaderNames */].X_MS_REQUEST_ID];
                        httpVerAuthority = (_e = response.headers) === null || _e === void 0 ? void 0 : _e[__WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["q" /* HeaderNames */].X_MS_HTTP_VERSION];
                        if (httpVerAuthority) {
                            atsMeasurement === null || atsMeasurement === void 0 ? void 0 : atsMeasurement.addStaticFields({
                                httpVerAuthority: httpVerAuthority
                            });
                        }
                        responseHandler = new __WEBPACK_IMPORTED_MODULE_4__response_ResponseHandler_js__["a" /* ResponseHandler */](this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin, this.performanceClient);
                        // Validate response. This function throws a server error if an error is returned by the server.
                        responseHandler.validateTokenResponse(response.body);
                        (_f = this.performanceClient) === null || _f === void 0 ? void 0 : _f.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].HandleServerTokenResponse, request.correlationId);
                        return [2 /*return*/, responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request, authCodePayload, undefined, undefined, undefined, requestId).then(function (result) {
                                atsMeasurement === null || atsMeasurement === void 0 ? void 0 : atsMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            })
                                .catch(function (error) {
                                _this.logger.verbose("Error in fetching token in ACC", request.correlationId);
                                atsMeasurement === null || atsMeasurement === void 0 ? void 0 : atsMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            })];
                }
            });
        });
    };
    /**
     * Handles the hash fragment response from public client code request. Returns a code response used by
     * the client to exchange for a token in acquireToken.
     * @param hashFragment
     */
    AuthorizationCodeClient.prototype.handleFragmentResponse = function (hashFragment, cachedState) {
        // Handle responses.
        var responseHandler = new __WEBPACK_IMPORTED_MODULE_4__response_ResponseHandler_js__["a" /* ResponseHandler */](this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, null, null);
        // Deserialize hash fragment response parameters.
        var hashUrlString = new __WEBPACK_IMPORTED_MODULE_7__url_UrlString_js__["a" /* UrlString */](hashFragment);
        // Deserialize hash fragment response parameters.
        var serverParams = __WEBPACK_IMPORTED_MODULE_7__url_UrlString_js__["a" /* UrlString */].getDeserializedHash(hashUrlString.getHash());
        // Get code response
        responseHandler.validateServerAuthorizationCodeResponse(serverParams, cachedState, this.cryptoUtils);
        // throw when there is no auth code in the response
        if (!serverParams.code) {
            throw __WEBPACK_IMPORTED_MODULE_6__error_ClientAuthError_js__["a" /* ClientAuthError */].createNoAuthCodeInServerResponseError();
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, serverParams), { 
            // Code param is optional in ServerAuthorizationCodeResponse but required in AuthorizationCodePaylod
            code: serverParams.code });
    };
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */
    AuthorizationCodeClient.prototype.getLogoutUri = function (logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) {
            throw __WEBPACK_IMPORTED_MODULE_12__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createEmptyLogoutRequestError();
        }
        var queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return __WEBPACK_IMPORTED_MODULE_7__url_UrlString_js__["a" /* UrlString */].appendQueryString(this.authority.endSessionEndpoint, queryString);
    };
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */
    AuthorizationCodeClient.prototype.executeTokenRequest = function (authority, request) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var queryParametersString, endpoint, requestBody, ccsCredential, clientInfo, headers, thumbprint;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthClientExecuteTokenRequest, request.correlationId);
                        (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthClientCreateTokenRequestBody, request.correlationId);
                        queryParametersString = this.createTokenQueryParameters(request);
                        endpoint = __WEBPACK_IMPORTED_MODULE_7__url_UrlString_js__["a" /* UrlString */].appendQueryString(authority.tokenEndpoint, queryParametersString);
                        return [4 /*yield*/, this.createTokenRequestBody(request)];
                    case 1:
                        requestBody = _c.sent();
                        ccsCredential = undefined;
                        if (request.clientInfo) {
                            try {
                                clientInfo = Object(__WEBPACK_IMPORTED_MODULE_10__account_ClientInfo_js__["a" /* buildClientInfo */])(request.clientInfo, this.cryptoUtils);
                                ccsCredential = {
                                    credential: "" + clientInfo.uid + __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["D" /* Separators */].CLIENT_INFO_SEPARATOR + clientInfo.utid,
                                    type: __WEBPACK_IMPORTED_MODULE_11__account_CcsCredential_js__["a" /* CcsCredentialType */].HOME_ACCOUNT_ID
                                };
                            }
                            catch (e) {
                                this.logger.verbose("Could not parse client info for CCS Header: " + e);
                            }
                        }
                        headers = this.createTokenRequestHeaders(ccsCredential || request.ccsCredential);
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: authority.canonicalAuthority,
                            scopes: request.scopes,
                            claims: request.claims,
                            authenticationScheme: request.authenticationScheme,
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            sshKid: request.sshKid
                        };
                        return [2 /*return*/, this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint)];
                }
            });
        });
    };
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */
    AuthorizationCodeClient.prototype.createTokenRequestBody = function (request) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var parameterBuilder, clientAssertion, popTokenGenerator, reqCnfData, correlationId, ccsCred, clientInfo, clientInfo;
            var _c;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthClientCreateTokenRequestBody, request.correlationId);
                        parameterBuilder = new __WEBPACK_IMPORTED_MODULE_2__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        /*
                         * For hybrid spa flow, there will be a code but no verifier
                         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
                         */
                        if (!this.includeRedirectUri) {
                            // Just validate
                            __WEBPACK_IMPORTED_MODULE_13__request_RequestValidator_js__["a" /* RequestValidator */].validateRedirectUri(request.redirectUri);
                        }
                        else {
                            // Validate and include redirect uri
                            parameterBuilder.addRedirectUri(request.redirectUri);
                        }
                        // Add scope array, parameter builder will add default scopes and dedupe
                        parameterBuilder.addScopes(request.scopes);
                        // add code: user set, not validated
                        parameterBuilder.addAuthorizationCode(request.code);
                        // Add library metadata
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
                        parameterBuilder.addThrottling();
                        if (this.serverTelemetryManager) {
                            parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
                        }
                        // add code_verifier if passed
                        if (request.codeVerifier) {
                            parameterBuilder.addCodeVerifier(request.codeVerifier);
                        }
                        if (this.config.clientCredentials.clientSecret) {
                            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
                        }
                        if (this.config.clientCredentials.clientAssertion) {
                            clientAssertion = this.config.clientCredentials.clientAssertion;
                            parameterBuilder.addClientAssertion(clientAssertion.assertion);
                            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
                        }
                        parameterBuilder.addGrantType(__WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["p" /* GrantType */].AUTHORIZATION_CODE_GRANT);
                        parameterBuilder.addClientInfo();
                        if (!(request.authenticationScheme === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["e" /* AuthenticationScheme */].POP)) return [3 /*break*/, 2];
                        popTokenGenerator = new __WEBPACK_IMPORTED_MODULE_8__crypto_PopTokenGenerator_js__["a" /* PopTokenGenerator */](this.cryptoUtils, this.performanceClient);
                        (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].PopTokenGenerateCnf, request.correlationId);
                        return [4 /*yield*/, popTokenGenerator.generateCnf(request)];
                    case 1:
                        reqCnfData = _d.sent();
                        // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
                        parameterBuilder.addPopToken(reqCnfData.reqCnfString);
                        return [3 /*break*/, 3];
                    case 2:
                        if (request.authenticationScheme === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["e" /* AuthenticationScheme */].SSH) {
                            if (request.sshJwk) {
                                parameterBuilder.addSshJwk(request.sshJwk);
                            }
                            else {
                                throw __WEBPACK_IMPORTED_MODULE_12__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createMissingSshJwkError();
                            }
                        }
                        _d.label = 3;
                    case 3:
                        correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
                        parameterBuilder.addCorrelationId(correlationId);
                        if (!__WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__["a" /* StringUtils */].isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
                            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        }
                        ccsCred = undefined;
                        if (request.clientInfo) {
                            try {
                                clientInfo = Object(__WEBPACK_IMPORTED_MODULE_10__account_ClientInfo_js__["a" /* buildClientInfo */])(request.clientInfo, this.cryptoUtils);
                                ccsCred = {
                                    credential: "" + clientInfo.uid + __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["D" /* Separators */].CLIENT_INFO_SEPARATOR + clientInfo.utid,
                                    type: __WEBPACK_IMPORTED_MODULE_11__account_CcsCredential_js__["a" /* CcsCredentialType */].HOME_ACCOUNT_ID
                                };
                            }
                            catch (e) {
                                this.logger.verbose("Could not parse client info for CCS Header: " + e);
                            }
                        }
                        else {
                            ccsCred = request.ccsCredential;
                        }
                        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
                        if (this.config.systemOptions.preventCorsPreflight && ccsCred) {
                            switch (ccsCred.type) {
                                case __WEBPACK_IMPORTED_MODULE_11__account_CcsCredential_js__["a" /* CcsCredentialType */].HOME_ACCOUNT_ID:
                                    try {
                                        clientInfo = Object(__WEBPACK_IMPORTED_MODULE_10__account_ClientInfo_js__["b" /* buildClientInfoFromHomeAccountId */])(ccsCred.credential);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    }
                                    catch (e) {
                                        this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                                    }
                                    break;
                                case __WEBPACK_IMPORTED_MODULE_11__account_CcsCredential_js__["a" /* CcsCredentialType */].UPN:
                                    parameterBuilder.addCcsUpn(ccsCred.credential);
                                    break;
                            }
                        }
                        if (request.tokenBodyParameters) {
                            parameterBuilder.addExtraQueryParameters(request.tokenBodyParameters);
                        }
                        // Add hybrid spa parameters if not already provided
                        if (request.enableSpaAuthorizationCode && (!request.tokenBodyParameters || !request.tokenBodyParameters[__WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["b" /* AADServerParamKeys */].RETURN_SPA_CODE])) {
                            parameterBuilder.addExtraQueryParameters((_c = {},
                                _c[__WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["b" /* AADServerParamKeys */].RETURN_SPA_CODE] = "1",
                                _c));
                        }
                        return [2 /*return*/, parameterBuilder.createQueryString()];
                }
            });
        });
    };
    /**
     * This API validates the `AuthorizationCodeUrlRequest` and creates a URL
     * @param request
     */
    AuthorizationCodeClient.prototype.createAuthCodeUrlQueryString = function (request) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var parameterBuilder, requestScopes, correlationId, accountSid, accountLoginHintClaim, clientInfo, clientInfo, clientInfo, popTokenGenerator, reqCnfData;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_14__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthClientCreateQueryString, request.correlationId);
                        parameterBuilder = new __WEBPACK_IMPORTED_MODULE_2__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        requestScopes = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["e" /* __spreadArrays */])(request.scopes || [], request.extraScopesToConsent || []);
                        parameterBuilder.addScopes(requestScopes);
                        // validate the redirectUri (to be a non null value)
                        parameterBuilder.addRedirectUri(request.redirectUri);
                        correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
                        parameterBuilder.addCorrelationId(correlationId);
                        // add response_mode. If not passed in it defaults to query.
                        parameterBuilder.addResponseMode(request.responseMode);
                        // add response_type = code
                        parameterBuilder.addResponseTypeCode();
                        // add library info parameters
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
                        // add client_info=1
                        parameterBuilder.addClientInfo();
                        if (request.codeChallenge && request.codeChallengeMethod) {
                            parameterBuilder.addCodeChallengeParams(request.codeChallenge, request.codeChallengeMethod);
                        }
                        if (request.prompt) {
                            parameterBuilder.addPrompt(request.prompt);
                        }
                        if (request.domainHint) {
                            parameterBuilder.addDomainHint(request.domainHint);
                        }
                        // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
                        if (request.prompt !== __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["w" /* PromptValue */].SELECT_ACCOUNT) {
                            // AAD will throw if prompt=select_account is passed with an account hint
                            if (request.sid && request.prompt === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["w" /* PromptValue */].NONE) {
                                // SessionID is only used in silent calls
                                this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request");
                                parameterBuilder.addSid(request.sid);
                            }
                            else if (request.account) {
                                accountSid = this.extractAccountSid(request.account);
                                accountLoginHintClaim = this.extractLoginHint(request.account);
                                // If login_hint claim is present, use it over sid/username
                                if (accountLoginHintClaim) {
                                    this.logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account");
                                    parameterBuilder.addLoginHint(accountLoginHintClaim);
                                    try {
                                        clientInfo = Object(__WEBPACK_IMPORTED_MODULE_10__account_ClientInfo_js__["b" /* buildClientInfoFromHomeAccountId */])(request.account.homeAccountId);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    }
                                    catch (e) {
                                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                                    }
                                }
                                else if (accountSid && request.prompt === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["w" /* PromptValue */].NONE) {
                                    /*
                                     * If account and loginHint are provided, we will check account first for sid before adding loginHint
                                     * SessionId is only used in silent calls
                                     */
                                    this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account");
                                    parameterBuilder.addSid(accountSid);
                                    try {
                                        clientInfo = Object(__WEBPACK_IMPORTED_MODULE_10__account_ClientInfo_js__["b" /* buildClientInfoFromHomeAccountId */])(request.account.homeAccountId);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    }
                                    catch (e) {
                                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                                    }
                                }
                                else if (request.loginHint) {
                                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request");
                                    parameterBuilder.addLoginHint(request.loginHint);
                                    parameterBuilder.addCcsUpn(request.loginHint);
                                }
                                else if (request.account.username) {
                                    // Fallback to account username if provided
                                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account");
                                    parameterBuilder.addLoginHint(request.account.username);
                                    try {
                                        clientInfo = Object(__WEBPACK_IMPORTED_MODULE_10__account_ClientInfo_js__["b" /* buildClientInfoFromHomeAccountId */])(request.account.homeAccountId);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    }
                                    catch (e) {
                                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                                    }
                                }
                            }
                            else if (request.loginHint) {
                                this.logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request");
                                parameterBuilder.addLoginHint(request.loginHint);
                                parameterBuilder.addCcsUpn(request.loginHint);
                            }
                        }
                        else {
                            this.logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
                        }
                        if (request.nonce) {
                            parameterBuilder.addNonce(request.nonce);
                        }
                        if (request.state) {
                            parameterBuilder.addState(request.state);
                        }
                        if (!__WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
                            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        }
                        if (request.extraQueryParameters) {
                            parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
                        }
                        if (!request.nativeBroker) return [3 /*break*/, 2];
                        // signal ests that this is a WAM call
                        parameterBuilder.addNativeBroker();
                        if (!(request.authenticationScheme === __WEBPACK_IMPORTED_MODULE_3__utils_Constants_js__["e" /* AuthenticationScheme */].POP)) return [3 /*break*/, 2];
                        popTokenGenerator = new __WEBPACK_IMPORTED_MODULE_8__crypto_PopTokenGenerator_js__["a" /* PopTokenGenerator */](this.cryptoUtils);
                        return [4 /*yield*/, popTokenGenerator.generateCnf(request)];
                    case 1:
                        reqCnfData = _b.sent();
                        parameterBuilder.addPopToken(reqCnfData.reqCnfString);
                        _b.label = 2;
                    case 2: return [2 /*return*/, parameterBuilder.createQueryString()];
                }
            });
        });
    };
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */
    AuthorizationCodeClient.prototype.createLogoutUrlQueryString = function (request) {
        var parameterBuilder = new __WEBPACK_IMPORTED_MODULE_2__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
        if (request.postLogoutRedirectUri) {
            parameterBuilder.addPostLogoutRedirectUri(request.postLogoutRedirectUri);
        }
        if (request.correlationId) {
            parameterBuilder.addCorrelationId(request.correlationId);
        }
        if (request.idTokenHint) {
            parameterBuilder.addIdTokenHint(request.idTokenHint);
        }
        if (request.state) {
            parameterBuilder.addState(request.state);
        }
        if (request.logoutHint) {
            parameterBuilder.addLogoutHint(request.logoutHint);
        }
        if (request.extraQueryParameters) {
            parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
        }
        return parameterBuilder.createQueryString();
    };
    /**
     * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
     * @param account
     */
    AuthorizationCodeClient.prototype.extractAccountSid = function (account) {
        var _a;
        return ((_a = account.idTokenClaims) === null || _a === void 0 ? void 0 : _a.sid) || null;
    };
    AuthorizationCodeClient.prototype.extractLoginHint = function (account) {
        var _a;
        return ((_a = account.idTokenClaims) === null || _a === void 0 ? void 0 : _a.login_hint) || null;
    };
    return AuthorizationCodeClient;
}(__WEBPACK_IMPORTED_MODULE_1__BaseClient_js__["a" /* BaseClient */]));


//# sourceMappingURL=AuthorizationCodeClient.js.map


/***/ }),
/* 2726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DeviceCodeClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseClient_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request_RequestParameterBuilder_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_TimeUtils_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__response_ResponseHandler_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__error_ServerError_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__url_UrlString_js__ = __webpack_require__(152);
/*! @azure/msal-common v13.3.1 2023-10-27 */












/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * OAuth2.0 Device code client
 */
var DeviceCodeClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(DeviceCodeClient, _super);
    function DeviceCodeClient(configuration) {
        return _super.call(this, configuration) || this;
    }
    /**
     * Gets device code from device code endpoint, calls back to with device code response, and
     * polls token endpoint to exchange device code for tokens
     * @param request
     */
    DeviceCodeClient.prototype.acquireToken = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var deviceCodeResponse, reqTimestamp, response, responseHandler;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDeviceCode(request)];
                    case 1:
                        deviceCodeResponse = _a.sent();
                        request.deviceCodeCallback(deviceCodeResponse);
                        reqTimestamp = __WEBPACK_IMPORTED_MODULE_5__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds();
                        return [4 /*yield*/, this.acquireTokenWithDeviceCode(request, deviceCodeResponse)];
                    case 2:
                        response = _a.sent();
                        responseHandler = new __WEBPACK_IMPORTED_MODULE_6__response_ResponseHandler_js__["a" /* ResponseHandler */](this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
                        // Validate response. This function throws a server error if an error is returned by the server.
                        responseHandler.validateTokenResponse(response);
                        return [4 /*yield*/, responseHandler.handleServerTokenResponse(response, this.authority, reqTimestamp, request)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates device code request and executes http GET
     * @param request
     */
    DeviceCodeClient.prototype.getDeviceCode = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var queryParametersString, endpoint, queryString, headers, thumbprint;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                queryParametersString = this.createExtraQueryParameters(request);
                endpoint = __WEBPACK_IMPORTED_MODULE_9__url_UrlString_js__["a" /* UrlString */].appendQueryString(this.authority.deviceCodeEndpoint, queryParametersString);
                queryString = this.createQueryString(request);
                headers = this.createTokenRequestHeaders();
                thumbprint = {
                    clientId: this.config.authOptions.clientId,
                    authority: request.authority,
                    scopes: request.scopes,
                    claims: request.claims,
                    authenticationScheme: request.authenticationScheme,
                    resourceRequestMethod: request.resourceRequestMethod,
                    resourceRequestUri: request.resourceRequestUri,
                    shrClaims: request.shrClaims,
                    sshKid: request.sshKid
                };
                return [2 /*return*/, this.executePostRequestToDeviceCodeEndpoint(endpoint, queryString, headers, thumbprint)];
            });
        });
    };
    /**
     * Creates query string for the device code request
     * @param request
     */
    DeviceCodeClient.prototype.createExtraQueryParameters = function (request) {
        var parameterBuilder = new __WEBPACK_IMPORTED_MODULE_3__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
        if (request.extraQueryParameters) {
            parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
        }
        return parameterBuilder.createQueryString();
    };
    /**
     * Executes POST request to device code endpoint
     * @param deviceCodeEndpoint
     * @param queryString
     * @param headers
     */
    DeviceCodeClient.prototype.executePostRequestToDeviceCodeEndpoint = function (deviceCodeEndpoint, queryString, headers, thumbprint) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _a, userCode, deviceCode, verificationUri, expiresIn, interval, message;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.networkManager.sendPostRequest(thumbprint, deviceCodeEndpoint, {
                            body: queryString,
                            headers: headers
                        })];
                    case 1:
                        _a = (_b.sent()).body, userCode = _a.user_code, deviceCode = _a.device_code, verificationUri = _a.verification_uri, expiresIn = _a.expires_in, interval = _a.interval, message = _a.message;
                        return [2 /*return*/, {
                                userCode: userCode,
                                deviceCode: deviceCode,
                                verificationUri: verificationUri,
                                expiresIn: expiresIn,
                                interval: interval,
                                message: message
                            }];
                }
            });
        });
    };
    /**
     * Create device code endpoint query parameters and returns string
     */
    DeviceCodeClient.prototype.createQueryString = function (request) {
        var parameterBuilder = new __WEBPACK_IMPORTED_MODULE_3__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
        parameterBuilder.addScopes(request.scopes);
        parameterBuilder.addClientId(this.config.authOptions.clientId);
        if (request.extraQueryParameters) {
            parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
        }
        if (!__WEBPACK_IMPORTED_MODULE_7__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        }
        return parameterBuilder.createQueryString();
    };
    /**
     * Breaks the polling with specific conditions.
     * @param request CommonDeviceCodeRequest
     * @param deviceCodeResponse DeviceCodeResponse
     */
    DeviceCodeClient.prototype.continuePolling = function (deviceCodeExpirationTime, userSpecifiedTimeout, userSpecifiedCancelFlag) {
        if (userSpecifiedCancelFlag) {
            this.logger.error("Token request cancelled by setting DeviceCodeRequest.cancel = true");
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createDeviceCodeCancelledError();
        }
        else if (userSpecifiedTimeout && userSpecifiedTimeout < deviceCodeExpirationTime && __WEBPACK_IMPORTED_MODULE_5__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds() > userSpecifiedTimeout) {
            this.logger.error("User defined timeout for device code polling reached. The timeout was set for " + userSpecifiedTimeout);
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createUserTimeoutReachedError();
        }
        else if (__WEBPACK_IMPORTED_MODULE_5__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds() > deviceCodeExpirationTime) {
            if (userSpecifiedTimeout) {
                this.logger.verbose("User specified timeout ignored as the device code has expired before the timeout elapsed. The user specified timeout was set for " + userSpecifiedTimeout);
            }
            this.logger.error("Device code expired. Expiration time of device code was " + deviceCodeExpirationTime);
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createDeviceCodeExpiredError();
        }
        return true;
    };
    /**
     * Creates token request with device code response and polls token endpoint at interval set by the device code
     * response
     * @param request
     * @param deviceCodeResponse
     */
    DeviceCodeClient.prototype.acquireTokenWithDeviceCode = function (request, deviceCodeResponse) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var queryParametersString, endpoint, requestBody, headers, userSpecifiedTimeout, deviceCodeExpirationTime, pollingIntervalMilli, thumbprint, response;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParametersString = this.createTokenQueryParameters(request);
                        endpoint = __WEBPACK_IMPORTED_MODULE_9__url_UrlString_js__["a" /* UrlString */].appendQueryString(this.authority.tokenEndpoint, queryParametersString);
                        requestBody = this.createTokenRequestBody(request, deviceCodeResponse);
                        headers = this.createTokenRequestHeaders();
                        userSpecifiedTimeout = request.timeout ? __WEBPACK_IMPORTED_MODULE_5__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds() + request.timeout : undefined;
                        deviceCodeExpirationTime = __WEBPACK_IMPORTED_MODULE_5__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds() + deviceCodeResponse.expiresIn;
                        pollingIntervalMilli = deviceCodeResponse.interval * 1000;
                        _a.label = 1;
                    case 1:
                        if (!this.continuePolling(deviceCodeExpirationTime, userSpecifiedTimeout, request.cancel)) return [3 /*break*/, 8];
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: request.authority,
                            scopes: request.scopes,
                            claims: request.claims,
                            authenticationScheme: request.authenticationScheme,
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            sshKid: request.sshKid
                        };
                        return [4 /*yield*/, this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint)];
                    case 2:
                        response = _a.sent();
                        if (!(response.body && response.body.error)) return [3 /*break*/, 6];
                        if (!(response.body.error === __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].AUTHORIZATION_PENDING)) return [3 /*break*/, 4];
                        this.logger.info("Authorization pending. Continue polling.");
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__utils_TimeUtils_js__["a" /* TimeUtils */].delay(pollingIntervalMilli)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        // for any other error, throw
                        this.logger.info("Unexpected error in polling from the server");
                        throw __WEBPACK_IMPORTED_MODULE_8__error_ServerError_js__["a" /* ServerError */].createPostRequestFailed(response.body.error);
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.logger.verbose("Authorization completed successfully. Polling stopped.");
                        return [2 /*return*/, response.body];
                    case 7: return [3 /*break*/, 1];
                    case 8:
                        /*
                         * The above code should've thrown by this point, but to satisfy TypeScript,
                         * and in the rare case the conditionals in continuePolling() may not catch everything...
                         */
                        this.logger.error("Polling stopped for unknown reasons.");
                        throw __WEBPACK_IMPORTED_MODULE_2__error_ClientAuthError_js__["a" /* ClientAuthError */].createDeviceCodeUnknownError();
                }
            });
        });
    };
    /**
     * Creates query parameters and converts to string.
     * @param request
     * @param deviceCodeResponse
     */
    DeviceCodeClient.prototype.createTokenRequestBody = function (request, deviceCodeResponse) {
        var requestParameters = new __WEBPACK_IMPORTED_MODULE_3__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
        requestParameters.addScopes(request.scopes);
        requestParameters.addClientId(this.config.authOptions.clientId);
        requestParameters.addGrantType(__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["p" /* GrantType */].DEVICE_CODE_GRANT);
        requestParameters.addDeviceCode(deviceCodeResponse.deviceCode);
        var correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
        requestParameters.addCorrelationId(correlationId);
        requestParameters.addClientInfo();
        requestParameters.addLibraryInfo(this.config.libraryInfo);
        requestParameters.addApplicationTelemetry(this.config.telemetry.application);
        requestParameters.addThrottling();
        if (this.serverTelemetryManager) {
            requestParameters.addServerTelemetry(this.serverTelemetryManager);
        }
        if (!__WEBPACK_IMPORTED_MODULE_7__utils_StringUtils_js__["a" /* StringUtils */].isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
            requestParameters.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        }
        return requestParameters.createQueryString();
    };
    return DeviceCodeClient;
}(__WEBPACK_IMPORTED_MODULE_1__BaseClient_js__["a" /* BaseClient */]));


//# sourceMappingURL=DeviceCodeClient.js.map


/***/ }),
/* 2727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClientCredentialClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseClient_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request_RequestParameterBuilder_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request_ScopeSet_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__response_ResponseHandler_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_TimeUtils_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__url_UrlString_js__ = __webpack_require__(152);
/*! @azure/msal-common v13.3.1 2023-10-27 */












/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * OAuth2.0 client credential grant
 */
var ClientCredentialClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(ClientCredentialClient, _super);
    function ClientCredentialClient(configuration, appTokenProvider) {
        var _this = _super.call(this, configuration) || this;
        _this.appTokenProvider = appTokenProvider;
        return _this;
    }
    /**
     * Public API to acquire a token with ClientCredential Flow for Confidential clients
     * @param request
     */
    ClientCredentialClient.prototype.acquireToken = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var cachedAuthenticationResult;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.scopeSet = new __WEBPACK_IMPORTED_MODULE_3__request_ScopeSet_js__["a" /* ScopeSet */](request.scopes || []);
                        if (!request.skipCache) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.executeTokenRequest(request, this.authority)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.getCachedAuthenticationResult(request)];
                    case 3:
                        cachedAuthenticationResult = _a.sent();
                        if (!cachedAuthenticationResult) return [3 /*break*/, 4];
                        return [2 /*return*/, cachedAuthenticationResult];
                    case 4: return [4 /*yield*/, this.executeTokenRequest(request, this.authority)];
                    case 5: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * looks up cache if the tokens are cached already
     */
    ClientCredentialClient.prototype.getCachedAuthenticationResult = function (request) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var cachedAccessToken;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        cachedAccessToken = this.readAccessTokenFromCache();
                        if (!cachedAccessToken) {
                            (_a = this.serverTelemetryManager) === null || _a === void 0 ? void 0 : _a.setCacheOutcome(__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["i" /* CacheOutcome */].NO_CACHED_ACCESS_TOKEN);
                            return [2 /*return*/, null];
                        }
                        if (__WEBPACK_IMPORTED_MODULE_6__utils_TimeUtils_js__["a" /* TimeUtils */].isTokenExpired(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
                            (_b = this.serverTelemetryManager) === null || _b === void 0 ? void 0 : _b.setCacheOutcome(__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["i" /* CacheOutcome */].CACHED_ACCESS_TOKEN_EXPIRED);
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__response_ResponseHandler_js__["a" /* ResponseHandler */].generateAuthenticationResult(this.cryptoUtils, this.authority, {
                                account: null,
                                idToken: null,
                                accessToken: cachedAccessToken,
                                refreshToken: null,
                                appMetadata: null
                            }, true, request)];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Reads access token from the cache
     */
    ClientCredentialClient.prototype.readAccessTokenFromCache = function () {
        var accessTokenFilter = {
            homeAccountId: __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
            environment: this.authority.canonicalAuthorityUrlComponents.HostNameAndPort,
            credentialType: __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN,
            clientId: this.config.authOptions.clientId,
            realm: this.authority.tenant,
            target: __WEBPACK_IMPORTED_MODULE_3__request_ScopeSet_js__["a" /* ScopeSet */].createSearchScopes(this.scopeSet.asArray())
        };
        var accessTokens = this.cacheManager.getAccessTokensByFilter(accessTokenFilter);
        if (accessTokens.length < 1) {
            return null;
        }
        else if (accessTokens.length > 1) {
            throw __WEBPACK_IMPORTED_MODULE_8__error_ClientAuthError_js__["a" /* ClientAuthError */].createMultipleMatchingTokensInCacheError();
        }
        return accessTokens[0];
    };
    /**
     * Makes a network call to request the token from the service
     * @param request
     * @param authority
     */
    ClientCredentialClient.prototype.executeTokenRequest = function (request, authority) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var serverTokenResponse, reqTimestamp, appTokenPropviderParameters, appTokenProviderResult, queryParametersString, endpoint, requestBody, headers, thumbprint, response, responseHandler, tokenResponse;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.appTokenProvider) return [3 /*break*/, 2];
                        this.logger.info("Using appTokenProvider extensibility.");
                        appTokenPropviderParameters = {
                            correlationId: request.correlationId,
                            tenantId: this.config.authOptions.authority.tenant,
                            scopes: request.scopes,
                            claims: request.claims,
                        };
                        reqTimestamp = __WEBPACK_IMPORTED_MODULE_6__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds();
                        return [4 /*yield*/, this.appTokenProvider(appTokenPropviderParameters)];
                    case 1:
                        appTokenProviderResult = _a.sent();
                        serverTokenResponse = {
                            access_token: appTokenProviderResult.accessToken,
                            expires_in: appTokenProviderResult.expiresInSeconds,
                            refresh_in: appTokenProviderResult.refreshInSeconds,
                            token_type: __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["e" /* AuthenticationScheme */].BEARER
                        };
                        return [3 /*break*/, 4];
                    case 2:
                        queryParametersString = this.createTokenQueryParameters(request);
                        endpoint = __WEBPACK_IMPORTED_MODULE_9__url_UrlString_js__["a" /* UrlString */].appendQueryString(authority.tokenEndpoint, queryParametersString);
                        requestBody = this.createTokenRequestBody(request);
                        headers = this.createTokenRequestHeaders();
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: request.authority,
                            scopes: request.scopes,
                            claims: request.claims,
                            authenticationScheme: request.authenticationScheme,
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            sshKid: request.sshKid
                        };
                        reqTimestamp = __WEBPACK_IMPORTED_MODULE_6__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds();
                        return [4 /*yield*/, this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint)];
                    case 3:
                        response = _a.sent();
                        serverTokenResponse = response.body;
                        _a.label = 4;
                    case 4:
                        responseHandler = new __WEBPACK_IMPORTED_MODULE_5__response_ResponseHandler_js__["a" /* ResponseHandler */](this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
                        responseHandler.validateTokenResponse(serverTokenResponse);
                        return [4 /*yield*/, responseHandler.handleServerTokenResponse(serverTokenResponse, this.authority, reqTimestamp, request)];
                    case 5:
                        tokenResponse = _a.sent();
                        return [2 /*return*/, tokenResponse];
                }
            });
        });
    };
    /**
     * generate the request to the server in the acceptable format
     * @param request
     */
    ClientCredentialClient.prototype.createTokenRequestBody = function (request) {
        var parameterBuilder = new __WEBPACK_IMPORTED_MODULE_2__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
        parameterBuilder.addClientId(this.config.authOptions.clientId);
        parameterBuilder.addScopes(request.scopes, false);
        parameterBuilder.addGrantType(__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["p" /* GrantType */].CLIENT_CREDENTIALS_GRANT);
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        parameterBuilder.addThrottling();
        if (this.serverTelemetryManager) {
            parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
        }
        var correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
        parameterBuilder.addCorrelationId(correlationId);
        if (this.config.clientCredentials.clientSecret) {
            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
        }
        // Use clientAssertion from request, fallback to client assertion in base configuration
        var clientAssertion = request.clientAssertion || this.config.clientCredentials.clientAssertion;
        if (clientAssertion) {
            parameterBuilder.addClientAssertion(clientAssertion.assertion);
            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
        }
        if (!__WEBPACK_IMPORTED_MODULE_7__utils_StringUtils_js__["a" /* StringUtils */].isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        }
        return parameterBuilder.createQueryString();
    };
    return ClientCredentialClient;
}(__WEBPACK_IMPORTED_MODULE_1__BaseClient_js__["a" /* BaseClient */]));


//# sourceMappingURL=ClientCredentialClient.js.map


/***/ }),
/* 2728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OnBehalfOfClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseClient_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__request_RequestParameterBuilder_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request_ScopeSet_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__response_ResponseHandler_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_TimeUtils_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_AuthToken_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__url_UrlString_js__ = __webpack_require__(152);
/*! @azure/msal-common v13.3.1 2023-10-27 */












/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * On-Behalf-Of client
 */
var OnBehalfOfClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(OnBehalfOfClient, _super);
    function OnBehalfOfClient(configuration) {
        return _super.call(this, configuration) || this;
    }
    /**
     * Public API to acquire tokens with on behalf of flow
     * @param request
     */
    OnBehalfOfClient.prototype.acquireToken = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _a;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.scopeSet = new __WEBPACK_IMPORTED_MODULE_3__request_ScopeSet_js__["a" /* ScopeSet */](request.scopes || []);
                        // generate the user_assertion_hash for OBOAssertion
                        _a = this;
                        return [4 /*yield*/, this.cryptoUtils.hashString(request.oboAssertion)];
                    case 1:
                        // generate the user_assertion_hash for OBOAssertion
                        _a.userAssertionHash = _b.sent();
                        if (!request.skipCache) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.executeTokenRequest(request, this.authority, this.userAssertionHash)];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3:
                        _b.trys.push([3, 5, , 7]);
                        return [4 /*yield*/, this.getCachedAuthenticationResult(request)];
                    case 4: return [2 /*return*/, _b.sent()];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, this.executeTokenRequest(request, this.authority, this.userAssertionHash)];
                    case 6: 
                    // Any failure falls back to interactive request, once we implement distributed cache, we plan to handle `createRefreshRequiredError` to refresh using the RT
                    return [2 /*return*/, _b.sent()];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * look up cache for tokens
     * Find idtoken in the cache
     * Find accessToken based on user assertion and account info in the cache
     * Please note we are not yet supported OBO tokens refreshed with long lived RT. User will have to send a new assertion if the current access token expires
     * This is to prevent security issues when the assertion changes over time, however, longlived RT helps retaining the session
     * @param request
     */
    OnBehalfOfClient.prototype.getCachedAuthenticationResult = function (request) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var cachedAccessToken, cachedIdToken, idTokenObject, cachedAccount, localAccountId, accountInfo;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        cachedAccessToken = this.readAccessTokenFromCacheForOBO(this.config.authOptions.clientId, request);
                        if (!cachedAccessToken) {
                            // Must refresh due to non-existent access_token.
                            (_a = this.serverTelemetryManager) === null || _a === void 0 ? void 0 : _a.setCacheOutcome(__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["i" /* CacheOutcome */].NO_CACHED_ACCESS_TOKEN);
                            this.logger.info("SilentFlowClient:acquireCachedToken - No access token found in cache for the given properties.");
                            throw __WEBPACK_IMPORTED_MODULE_8__error_ClientAuthError_js__["a" /* ClientAuthError */].createRefreshRequiredError();
                        }
                        else if (__WEBPACK_IMPORTED_MODULE_6__utils_TimeUtils_js__["a" /* TimeUtils */].isTokenExpired(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
                            // Access token expired, will need to renewed
                            (_b = this.serverTelemetryManager) === null || _b === void 0 ? void 0 : _b.setCacheOutcome(__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["i" /* CacheOutcome */].CACHED_ACCESS_TOKEN_EXPIRED);
                            this.logger.info("OnbehalfofFlow:getCachedAuthenticationResult - Cached access token is expired or will expire within " + this.config.systemOptions.tokenRenewalOffsetSeconds + " seconds.");
                            throw __WEBPACK_IMPORTED_MODULE_8__error_ClientAuthError_js__["a" /* ClientAuthError */].createRefreshRequiredError();
                        }
                        cachedIdToken = this.readIdTokenFromCacheForOBO(cachedAccessToken.homeAccountId);
                        cachedAccount = null;
                        if (cachedIdToken) {
                            idTokenObject = new __WEBPACK_IMPORTED_MODULE_7__account_AuthToken_js__["a" /* AuthToken */](cachedIdToken.secret, this.config.cryptoInterface);
                            localAccountId = idTokenObject.claims.oid ? idTokenObject.claims.oid : idTokenObject.claims.sub;
                            accountInfo = {
                                homeAccountId: cachedIdToken.homeAccountId,
                                environment: cachedIdToken.environment,
                                tenantId: cachedIdToken.realm,
                                username: __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].EMPTY_STRING,
                                localAccountId: localAccountId || __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["m" /* Constants */].EMPTY_STRING
                            };
                            cachedAccount = this.cacheManager.readAccountFromCache(accountInfo);
                        }
                        // increment telemetry cache hit counter
                        if (this.config.serverTelemetryManager) {
                            this.config.serverTelemetryManager.incrementCacheHits();
                        }
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__response_ResponseHandler_js__["a" /* ResponseHandler */].generateAuthenticationResult(this.cryptoUtils, this.authority, {
                                account: cachedAccount,
                                accessToken: cachedAccessToken,
                                idToken: cachedIdToken,
                                refreshToken: null,
                                appMetadata: null
                            }, true, request, idTokenObject)];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * read idtoken from cache, this is a specific implementation for OBO as the requirements differ from a generic lookup in the cacheManager
     * Certain use cases of OBO flow do not expect an idToken in the cache/or from the service
     * @param request
     */
    OnBehalfOfClient.prototype.readIdTokenFromCacheForOBO = function (atHomeAccountId) {
        var idTokenFilter = {
            homeAccountId: atHomeAccountId,
            environment: this.authority.canonicalAuthorityUrlComponents.HostNameAndPort,
            credentialType: __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["n" /* CredentialType */].ID_TOKEN,
            clientId: this.config.authOptions.clientId,
            realm: this.authority.tenant
        };
        var idTokens = this.cacheManager.getIdTokensByFilter(idTokenFilter);
        // When acquiring a token on behalf of an application, there might not be an id token in the cache
        if (idTokens.length < 1) {
            return null;
        }
        return idTokens[0];
    };
    /**
     * Fetches the cached access token based on incoming assertion
     * @param clientId
     * @param request
     * @param userAssertionHash
     */
    OnBehalfOfClient.prototype.readAccessTokenFromCacheForOBO = function (clientId, request) {
        var authScheme = request.authenticationScheme || __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["e" /* AuthenticationScheme */].BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */
        var credentialType = (authScheme && authScheme.toLowerCase() !== __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["e" /* AuthenticationScheme */].BEARER.toLowerCase()) ? __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN_WITH_AUTH_SCHEME : __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["n" /* CredentialType */].ACCESS_TOKEN;
        var accessTokenFilter = {
            credentialType: credentialType,
            clientId: clientId,
            target: __WEBPACK_IMPORTED_MODULE_3__request_ScopeSet_js__["a" /* ScopeSet */].createSearchScopes(this.scopeSet.asArray()),
            tokenType: authScheme,
            keyId: request.sshKid,
            requestedClaimsHash: request.requestedClaimsHash,
            userAssertionHash: this.userAssertionHash
        };
        var accessTokens = this.cacheManager.getAccessTokensByFilter(accessTokenFilter);
        var numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            return null;
        }
        else if (numAccessTokens > 1) {
            throw __WEBPACK_IMPORTED_MODULE_8__error_ClientAuthError_js__["a" /* ClientAuthError */].createMultipleMatchingTokensInCacheError();
        }
        return accessTokens[0];
    };
    /**
     * Make a network call to the server requesting credentials
     * @param request
     * @param authority
     */
    OnBehalfOfClient.prototype.executeTokenRequest = function (request, authority, userAssertionHash) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var queryParametersString, endpoint, requestBody, headers, thumbprint, reqTimestamp, response, responseHandler, tokenResponse;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParametersString = this.createTokenQueryParameters(request);
                        endpoint = __WEBPACK_IMPORTED_MODULE_9__url_UrlString_js__["a" /* UrlString */].appendQueryString(authority.tokenEndpoint, queryParametersString);
                        requestBody = this.createTokenRequestBody(request);
                        headers = this.createTokenRequestHeaders();
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: request.authority,
                            scopes: request.scopes,
                            claims: request.claims,
                            authenticationScheme: request.authenticationScheme,
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            sshKid: request.sshKid
                        };
                        reqTimestamp = __WEBPACK_IMPORTED_MODULE_6__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds();
                        return [4 /*yield*/, this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint)];
                    case 1:
                        response = _a.sent();
                        responseHandler = new __WEBPACK_IMPORTED_MODULE_5__response_ResponseHandler_js__["a" /* ResponseHandler */](this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
                        responseHandler.validateTokenResponse(response.body);
                        return [4 /*yield*/, responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request, undefined, userAssertionHash)];
                    case 2:
                        tokenResponse = _a.sent();
                        return [2 /*return*/, tokenResponse];
                }
            });
        });
    };
    /**
     * generate a server request in accepable format
     * @param request
     */
    OnBehalfOfClient.prototype.createTokenRequestBody = function (request) {
        var parameterBuilder = new __WEBPACK_IMPORTED_MODULE_2__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
        parameterBuilder.addClientId(this.config.authOptions.clientId);
        parameterBuilder.addScopes(request.scopes);
        parameterBuilder.addGrantType(__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["p" /* GrantType */].JWT_BEARER);
        parameterBuilder.addClientInfo();
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        parameterBuilder.addThrottling();
        if (this.serverTelemetryManager) {
            parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
        }
        var correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
        parameterBuilder.addCorrelationId(correlationId);
        parameterBuilder.addRequestTokenUse(__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["b" /* AADServerParamKeys */].ON_BEHALF_OF);
        parameterBuilder.addOboAssertion(request.oboAssertion);
        if (this.config.clientCredentials.clientSecret) {
            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
        }
        if (this.config.clientCredentials.clientAssertion) {
            var clientAssertion = this.config.clientCredentials.clientAssertion;
            parameterBuilder.addClientAssertion(clientAssertion.assertion);
            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
        }
        if (request.claims || (this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0)) {
            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        }
        return parameterBuilder.createQueryString();
    };
    return OnBehalfOfClient;
}(__WEBPACK_IMPORTED_MODULE_1__BaseClient_js__["a" /* BaseClient */]));


//# sourceMappingURL=OnBehalfOfClient.js.map


/***/ }),
/* 2729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SilentFlowClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseClient_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_AuthToken_js__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_TimeUtils_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RefreshTokenClient_js__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__response_ResponseHandler_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StringUtils_js__ = __webpack_require__(65);
/*! @azure/msal-common v13.3.1 2023-10-27 */












/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var SilentFlowClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(SilentFlowClient, _super);
    function SilentFlowClient(configuration, performanceClient) {
        return _super.call(this, configuration, performanceClient) || this;
    }
    /**
     * Retrieves a token from cache if it is still valid, or uses the cached refresh token to renew
     * the given token and returns the renewed token
     * @param request
     */
    SilentFlowClient.prototype.acquireToken = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var e_1, refreshTokenClient;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.acquireCachedToken(request)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 instanceof __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */] && e_1.errorCode === __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["b" /* ClientAuthErrorMessage */].tokenRefreshRequired.code) {
                            refreshTokenClient = new __WEBPACK_IMPORTED_MODULE_4__RefreshTokenClient_js__["a" /* RefreshTokenClient */](this.config, this.performanceClient);
                            return [2 /*return*/, refreshTokenClient.acquireTokenByRefreshToken(request)];
                        }
                        else {
                            throw e_1;
                        }
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */
    SilentFlowClient.prototype.acquireCachedToken = function (request) {
        var _a, _b, _c, _d, _e;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var environment, cacheRecord;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        // Cannot renew token if no request object is given.
                        if (!request) {
                            throw __WEBPACK_IMPORTED_MODULE_6__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createEmptyTokenRequestError();
                        }
                        if (request.forceRefresh) {
                            // Must refresh due to present force_refresh flag.
                            (_a = this.serverTelemetryManager) === null || _a === void 0 ? void 0 : _a.setCacheOutcome(__WEBPACK_IMPORTED_MODULE_8__utils_Constants_js__["i" /* CacheOutcome */].FORCE_REFRESH);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Skipping cache because forceRefresh is true.");
                            throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createRefreshRequiredError();
                        }
                        else if (!this.config.cacheOptions.claimsBasedCachingEnabled && !__WEBPACK_IMPORTED_MODULE_9__utils_StringUtils_js__["a" /* StringUtils */].isEmptyObj(request.claims)) {
                            // Must refresh due to presence of claims in request preventing cache lookup
                            (_b = this.serverTelemetryManager) === null || _b === void 0 ? void 0 : _b.setCacheOutcome(__WEBPACK_IMPORTED_MODULE_8__utils_Constants_js__["i" /* CacheOutcome */].CLAIMS_REQUESTED_CACHE_SKIPPED);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Skipping cache because claims-based caching is disabled and claims were requested.");
                            throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createRefreshRequiredError();
                        }
                        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
                        if (!request.account) {
                            throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createNoAccountInSilentRequestError();
                        }
                        environment = request.authority || this.authority.getPreferredCache();
                        cacheRecord = this.cacheManager.readCacheRecord(request.account, request, environment);
                        if (!cacheRecord.accessToken) {
                            // Must refresh due to non-existent access_token.
                            (_c = this.serverTelemetryManager) === null || _c === void 0 ? void 0 : _c.setCacheOutcome(__WEBPACK_IMPORTED_MODULE_8__utils_Constants_js__["i" /* CacheOutcome */].NO_CACHED_ACCESS_TOKEN);
                            this.logger.info("SilentFlowClient:acquireCachedToken - No access token found in cache for the given properties.");
                            throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createRefreshRequiredError();
                        }
                        else if (__WEBPACK_IMPORTED_MODULE_3__utils_TimeUtils_js__["a" /* TimeUtils */].wasClockTurnedBack(cacheRecord.accessToken.cachedAt) ||
                            __WEBPACK_IMPORTED_MODULE_3__utils_TimeUtils_js__["a" /* TimeUtils */].isTokenExpired(cacheRecord.accessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
                            // Must refresh due to expired access_token.
                            (_d = this.serverTelemetryManager) === null || _d === void 0 ? void 0 : _d.setCacheOutcome(__WEBPACK_IMPORTED_MODULE_8__utils_Constants_js__["i" /* CacheOutcome */].CACHED_ACCESS_TOKEN_EXPIRED);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token is expired or will expire within " + this.config.systemOptions.tokenRenewalOffsetSeconds + " seconds.");
                            throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createRefreshRequiredError();
                        }
                        else if (cacheRecord.accessToken.refreshOn && __WEBPACK_IMPORTED_MODULE_3__utils_TimeUtils_js__["a" /* TimeUtils */].isTokenExpired(cacheRecord.accessToken.refreshOn, 0)) {
                            // Must refresh due to the refresh_in value.
                            (_e = this.serverTelemetryManager) === null || _e === void 0 ? void 0 : _e.setCacheOutcome(__WEBPACK_IMPORTED_MODULE_8__utils_Constants_js__["i" /* CacheOutcome */].REFRESH_CACHED_ACCESS_TOKEN);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token's refreshOn property has been exceeded'.");
                            throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createRefreshRequiredError();
                        }
                        if (this.config.serverTelemetryManager) {
                            this.config.serverTelemetryManager.incrementCacheHits();
                        }
                        return [4 /*yield*/, this.generateResultFromCacheRecord(cacheRecord, request)];
                    case 1: return [2 /*return*/, _f.sent()];
                }
            });
        });
    };
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */
    SilentFlowClient.prototype.generateResultFromCacheRecord = function (cacheRecord, request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var idTokenObj, authTime;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (cacheRecord.idToken) {
                            idTokenObj = new __WEBPACK_IMPORTED_MODULE_2__account_AuthToken_js__["a" /* AuthToken */](cacheRecord.idToken.secret, this.config.cryptoInterface);
                        }
                        // token max_age check
                        if (request.maxAge || (request.maxAge === 0)) {
                            authTime = idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.auth_time;
                            if (!authTime) {
                                throw __WEBPACK_IMPORTED_MODULE_5__error_ClientAuthError_js__["a" /* ClientAuthError */].createAuthTimeNotFoundError();
                            }
                            __WEBPACK_IMPORTED_MODULE_2__account_AuthToken_js__["a" /* AuthToken */].checkMaxAge(authTime, request.maxAge);
                        }
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__response_ResponseHandler_js__["a" /* ResponseHandler */].generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, idTokenObj)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SilentFlowClient;
}(__WEBPACK_IMPORTED_MODULE_1__BaseClient_js__["a" /* BaseClient */]));


//# sourceMappingURL=SilentFlowClient.js.map


/***/ }),
/* 2730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UsernamePasswordClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseClient_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__response_ResponseHandler_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request_RequestParameterBuilder_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_TimeUtils_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_CcsCredential_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__url_UrlString_js__ = __webpack_require__(152);
/*! @azure/msal-common v13.3.1 2023-10-27 */











/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Oauth2.0 Password grant client
 * Note: We are only supporting public clients for password grant and for purely testing purposes
 */
var UsernamePasswordClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(UsernamePasswordClient, _super);
    function UsernamePasswordClient(configuration) {
        return _super.call(this, configuration) || this;
    }
    /**
     * API to acquire a token by passing the username and password to the service in exchage of credentials
     * password_grant
     * @param request
     */
    UsernamePasswordClient.prototype.acquireToken = function (request) {
        var _a, _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var atsMeasurement, reqTimestamp, response, httpVerToken, responseHandler, tokenResponse;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        atsMeasurement = (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.startMeasurement("UsernamePasswordClientAcquireToken", request.correlationId);
                        this.logger.info("in acquireToken call in username-password client");
                        reqTimestamp = __WEBPACK_IMPORTED_MODULE_6__utils_TimeUtils_js__["a" /* TimeUtils */].nowSeconds();
                        return [4 /*yield*/, this.executeTokenRequest(this.authority, request)];
                    case 1:
                        response = _c.sent();
                        httpVerToken = (_b = response.headers) === null || _b === void 0 ? void 0 : _b[__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["q" /* HeaderNames */].X_MS_HTTP_VERSION];
                        atsMeasurement === null || atsMeasurement === void 0 ? void 0 : atsMeasurement.addStaticFields({
                            httpVerToken: httpVerToken
                        });
                        responseHandler = new __WEBPACK_IMPORTED_MODULE_2__response_ResponseHandler_js__["a" /* ResponseHandler */](this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
                        // Validate response. This function throws a server error if an error is returned by the server.
                        responseHandler.validateTokenResponse(response.body);
                        tokenResponse = responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request);
                        return [2 /*return*/, tokenResponse];
                }
            });
        });
    };
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */
    UsernamePasswordClient.prototype.executeTokenRequest = function (authority, request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var queryParametersString, endpoint, requestBody, headers, thumbprint;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                queryParametersString = this.createTokenQueryParameters(request);
                endpoint = __WEBPACK_IMPORTED_MODULE_8__url_UrlString_js__["a" /* UrlString */].appendQueryString(authority.tokenEndpoint, queryParametersString);
                requestBody = this.createTokenRequestBody(request);
                headers = this.createTokenRequestHeaders({
                    credential: request.username,
                    type: __WEBPACK_IMPORTED_MODULE_7__account_CcsCredential_js__["a" /* CcsCredentialType */].UPN
                });
                thumbprint = {
                    clientId: this.config.authOptions.clientId,
                    authority: authority.canonicalAuthority,
                    scopes: request.scopes,
                    claims: request.claims,
                    authenticationScheme: request.authenticationScheme,
                    resourceRequestMethod: request.resourceRequestMethod,
                    resourceRequestUri: request.resourceRequestUri,
                    shrClaims: request.shrClaims,
                    sshKid: request.sshKid
                };
                return [2 /*return*/, this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint)];
            });
        });
    };
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */
    UsernamePasswordClient.prototype.createTokenRequestBody = function (request) {
        var parameterBuilder = new __WEBPACK_IMPORTED_MODULE_3__request_RequestParameterBuilder_js__["a" /* RequestParameterBuilder */]();
        parameterBuilder.addClientId(this.config.authOptions.clientId);
        parameterBuilder.addUsername(request.username);
        parameterBuilder.addPassword(request.password);
        parameterBuilder.addScopes(request.scopes);
        parameterBuilder.addResponseTypeForTokenAndIdToken();
        parameterBuilder.addGrantType(__WEBPACK_IMPORTED_MODULE_4__utils_Constants_js__["p" /* GrantType */].RESOURCE_OWNER_PASSWORD_GRANT);
        parameterBuilder.addClientInfo();
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        parameterBuilder.addThrottling();
        if (this.serverTelemetryManager) {
            parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
        }
        var correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
        parameterBuilder.addCorrelationId(correlationId);
        if (this.config.clientCredentials.clientSecret) {
            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
        }
        if (this.config.clientCredentials.clientAssertion) {
            var clientAssertion = this.config.clientCredentials.clientAssertion;
            parameterBuilder.addClientAssertion(clientAssertion.assertion);
            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__utils_StringUtils_js__["a" /* StringUtils */].isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        }
        if (this.config.systemOptions.preventCorsPreflight && request.username) {
            parameterBuilder.addCcsUpn(request.username);
        }
        return parameterBuilder.createQueryString();
    };
    return UsernamePasswordClient;
}(__WEBPACK_IMPORTED_MODULE_1__BaseClient_js__["a" /* BaseClient */]));


//# sourceMappingURL=UsernamePasswordClient.js.map


/***/ }),
/* 2731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isOpenIdConfigResponse; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isOpenIdConfigResponse(response) {
    return (response.hasOwnProperty("authorization_endpoint") &&
        response.hasOwnProperty("token_endpoint") &&
        response.hasOwnProperty("issuer") &&
        response.hasOwnProperty("jwks_uri"));
}


//# sourceMappingURL=OpenIdConfigResponse.js.map


/***/ }),
/* 2732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndpointMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InstanceDiscoveryMetadata; });
/* unused harmony export rawMetdataJSON */
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var rawMetdataJSON = { "endpointMetadata": { "https://login.microsoftonline.com/common/": { "token_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/token", "token_endpoint_auth_methods_supported": ["client_secret_post", "private_key_jwt", "client_secret_basic"], "jwks_uri": "https://login.microsoftonline.com/common/discovery/v2.0/keys", "response_modes_supported": ["query", "fragment", "form_post"], "subject_types_supported": ["pairwise"], "id_token_signing_alg_values_supported": ["RS256"], "response_types_supported": ["code", "id_token", "code id_token", "id_token token"], "scopes_supported": ["openid", "profile", "email", "offline_access"], "issuer": "https://login.microsoftonline.com/{tenantid}/v2.0", "request_uri_parameter_supported": false, "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo", "authorization_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/authorize", "device_authorization_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/devicecode", "http_logout_supported": true, "frontchannel_logout_supported": true, "end_session_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/logout", "claims_supported": ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], "kerberos_endpoint": "https://login.microsoftonline.com/common/kerberos", "tenant_region_scope": null, "cloud_instance_name": "microsoftonline.com", "cloud_graph_host_name": "graph.windows.net", "msgraph_host": "graph.microsoft.com", "rbac_url": "https://pas.windows.net" }, "https://login.chinacloudapi.cn/common/": { "token_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/token", "token_endpoint_auth_methods_supported": ["client_secret_post", "private_key_jwt", "client_secret_basic"], "jwks_uri": "https://login.chinacloudapi.cn/common/discovery/v2.0/keys", "response_modes_supported": ["query", "fragment", "form_post"], "subject_types_supported": ["pairwise"], "id_token_signing_alg_values_supported": ["RS256"], "response_types_supported": ["code", "id_token", "code id_token", "id_token token"], "scopes_supported": ["openid", "profile", "email", "offline_access"], "issuer": "https://login.partner.microsoftonline.cn/{tenantid}/v2.0", "request_uri_parameter_supported": false, "userinfo_endpoint": "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo", "authorization_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/authorize", "device_authorization_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/devicecode", "http_logout_supported": true, "frontchannel_logout_supported": true, "end_session_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/logout", "claims_supported": ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], "kerberos_endpoint": "https://login.chinacloudapi.cn/common/kerberos", "tenant_region_scope": null, "cloud_instance_name": "partner.microsoftonline.cn", "cloud_graph_host_name": "graph.chinacloudapi.cn", "msgraph_host": "microsoftgraph.chinacloudapi.cn", "rbac_url": "https://pas.chinacloudapi.cn" }, "https://login.microsoftonline.us/common/": { "token_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/token", "token_endpoint_auth_methods_supported": ["client_secret_post", "private_key_jwt", "client_secret_basic"], "jwks_uri": "https://login.microsoftonline.us/common/discovery/v2.0/keys", "response_modes_supported": ["query", "fragment", "form_post"], "subject_types_supported": ["pairwise"], "id_token_signing_alg_values_supported": ["RS256"], "response_types_supported": ["code", "id_token", "code id_token", "id_token token"], "scopes_supported": ["openid", "profile", "email", "offline_access"], "issuer": "https://login.microsoftonline.us/{tenantid}/v2.0", "request_uri_parameter_supported": false, "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo", "authorization_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/authorize", "device_authorization_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/devicecode", "http_logout_supported": true, "frontchannel_logout_supported": true, "end_session_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/logout", "claims_supported": ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], "kerberos_endpoint": "https://login.microsoftonline.us/common/kerberos", "tenant_region_scope": null, "cloud_instance_name": "microsoftonline.us", "cloud_graph_host_name": "graph.windows.net", "msgraph_host": "graph.microsoft.com", "rbac_url": "https://pasff.usgovcloudapi.net" }, "https://login.microsoftonline.com/consumers/": { "token_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/token", "token_endpoint_auth_methods_supported": ["client_secret_post", "private_key_jwt", "client_secret_basic"], "jwks_uri": "https://login.microsoftonline.com/consumers/discovery/v2.0/keys", "response_modes_supported": ["query", "fragment", "form_post"], "subject_types_supported": ["pairwise"], "id_token_signing_alg_values_supported": ["RS256"], "response_types_supported": ["code", "id_token", "code id_token", "id_token token"], "scopes_supported": ["openid", "profile", "email", "offline_access"], "issuer": "https://login.microsoftonline.com/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0", "request_uri_parameter_supported": false, "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo", "authorization_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/authorize", "device_authorization_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/devicecode", "http_logout_supported": true, "frontchannel_logout_supported": true, "end_session_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/logout", "claims_supported": ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], "kerberos_endpoint": "https://login.microsoftonline.com/consumers/kerberos", "tenant_region_scope": null, "cloud_instance_name": "microsoftonline.com", "cloud_graph_host_name": "graph.windows.net", "msgraph_host": "graph.microsoft.com", "rbac_url": "https://pas.windows.net" }, "https://login.chinacloudapi.cn/consumers/": { "token_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/token", "token_endpoint_auth_methods_supported": ["client_secret_post", "private_key_jwt", "client_secret_basic"], "jwks_uri": "https://login.chinacloudapi.cn/consumers/discovery/v2.0/keys", "response_modes_supported": ["query", "fragment", "form_post"], "subject_types_supported": ["pairwise"], "id_token_signing_alg_values_supported": ["RS256"], "response_types_supported": ["code", "id_token", "code id_token", "id_token token"], "scopes_supported": ["openid", "profile", "email", "offline_access"], "issuer": "https://login.partner.microsoftonline.cn/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0", "request_uri_parameter_supported": false, "userinfo_endpoint": "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo", "authorization_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/authorize", "device_authorization_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/devicecode", "http_logout_supported": true, "frontchannel_logout_supported": true, "end_session_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/logout", "claims_supported": ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], "kerberos_endpoint": "https://login.chinacloudapi.cn/consumers/kerberos", "tenant_region_scope": null, "cloud_instance_name": "partner.microsoftonline.cn", "cloud_graph_host_name": "graph.chinacloudapi.cn", "msgraph_host": "microsoftgraph.chinacloudapi.cn", "rbac_url": "https://pas.chinacloudapi.cn" }, "https://login.microsoftonline.us/consumers/": { "token_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/token", "token_endpoint_auth_methods_supported": ["client_secret_post", "private_key_jwt", "client_secret_basic"], "jwks_uri": "https://login.microsoftonline.us/consumers/discovery/v2.0/keys", "response_modes_supported": ["query", "fragment", "form_post"], "subject_types_supported": ["pairwise"], "id_token_signing_alg_values_supported": ["RS256"], "response_types_supported": ["code", "id_token", "code id_token", "id_token token"], "scopes_supported": ["openid", "profile", "email", "offline_access"], "issuer": "https://login.microsoftonline.us/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0", "request_uri_parameter_supported": false, "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo", "authorization_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/authorize", "device_authorization_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/devicecode", "http_logout_supported": true, "frontchannel_logout_supported": true, "end_session_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/logout", "claims_supported": ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], "kerberos_endpoint": "https://login.microsoftonline.us/consumers/kerberos", "tenant_region_scope": null, "cloud_instance_name": "microsoftonline.us", "cloud_graph_host_name": "graph.windows.net", "msgraph_host": "graph.microsoft.com", "rbac_url": "https://pasff.usgovcloudapi.net" }, "https://login.microsoftonline.com/organizations/": { "token_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/token", "token_endpoint_auth_methods_supported": ["client_secret_post", "private_key_jwt", "client_secret_basic"], "jwks_uri": "https://login.microsoftonline.com/organizations/discovery/v2.0/keys", "response_modes_supported": ["query", "fragment", "form_post"], "subject_types_supported": ["pairwise"], "id_token_signing_alg_values_supported": ["RS256"], "response_types_supported": ["code", "id_token", "code id_token", "id_token token"], "scopes_supported": ["openid", "profile", "email", "offline_access"], "issuer": "https://login.microsoftonline.com/{tenantid}/v2.0", "request_uri_parameter_supported": false, "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo", "authorization_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize", "device_authorization_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/devicecode", "http_logout_supported": true, "frontchannel_logout_supported": true, "end_session_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/logout", "claims_supported": ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], "kerberos_endpoint": "https://login.microsoftonline.com/organizations/kerberos", "tenant_region_scope": null, "cloud_instance_name": "microsoftonline.com", "cloud_graph_host_name": "graph.windows.net", "msgraph_host": "graph.microsoft.com", "rbac_url": "https://pas.windows.net" }, "https://login.chinacloudapi.cn/organizations/": { "token_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/token", "token_endpoint_auth_methods_supported": ["client_secret_post", "private_key_jwt", "client_secret_basic"], "jwks_uri": "https://login.chinacloudapi.cn/organizations/discovery/v2.0/keys", "response_modes_supported": ["query", "fragment", "form_post"], "subject_types_supported": ["pairwise"], "id_token_signing_alg_values_supported": ["RS256"], "response_types_supported": ["code", "id_token", "code id_token", "id_token token"], "scopes_supported": ["openid", "profile", "email", "offline_access"], "issuer": "https://login.partner.microsoftonline.cn/{tenantid}/v2.0", "request_uri_parameter_supported": false, "userinfo_endpoint": "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo", "authorization_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/authorize", "device_authorization_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/devicecode", "http_logout_supported": true, "frontchannel_logout_supported": true, "end_session_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/logout", "claims_supported": ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], "kerberos_endpoint": "https://login.chinacloudapi.cn/organizations/kerberos", "tenant_region_scope": null, "cloud_instance_name": "partner.microsoftonline.cn", "cloud_graph_host_name": "graph.chinacloudapi.cn", "msgraph_host": "microsoftgraph.chinacloudapi.cn", "rbac_url": "https://pas.chinacloudapi.cn" }, "https://login.microsoftonline.us/organizations/": { "token_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/token", "token_endpoint_auth_methods_supported": ["client_secret_post", "private_key_jwt", "client_secret_basic"], "jwks_uri": "https://login.microsoftonline.us/organizations/discovery/v2.0/keys", "response_modes_supported": ["query", "fragment", "form_post"], "subject_types_supported": ["pairwise"], "id_token_signing_alg_values_supported": ["RS256"], "response_types_supported": ["code", "id_token", "code id_token", "id_token token"], "scopes_supported": ["openid", "profile", "email", "offline_access"], "issuer": "https://login.microsoftonline.us/{tenantid}/v2.0", "request_uri_parameter_supported": false, "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo", "authorization_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/authorize", "device_authorization_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/devicecode", "http_logout_supported": true, "frontchannel_logout_supported": true, "end_session_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/logout", "claims_supported": ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], "kerberos_endpoint": "https://login.microsoftonline.us/organizations/kerberos", "tenant_region_scope": null, "cloud_instance_name": "microsoftonline.us", "cloud_graph_host_name": "graph.windows.net", "msgraph_host": "graph.microsoft.com", "rbac_url": "https://pasff.usgovcloudapi.net" } }, "instanceDiscoveryMetadata": { "https://login.microsoftonline.com/common/": { "tenant_discovery_endpoint": "https://login.microsoftonline.com/common/v2.0/.well-known/openid-configuration", "api-version": "1.1", "metadata": [{ "preferred_network": "login.microsoftonline.com", "preferred_cache": "login.windows.net", "aliases": ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { "preferred_network": "login.partner.microsoftonline.cn", "preferred_cache": "login.partner.microsoftonline.cn", "aliases": ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { "preferred_network": "login.microsoftonline.de", "preferred_cache": "login.microsoftonline.de", "aliases": ["login.microsoftonline.de"] }, { "preferred_network": "login.microsoftonline.us", "preferred_cache": "login.microsoftonline.us", "aliases": ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { "preferred_network": "login-us.microsoftonline.com", "preferred_cache": "login-us.microsoftonline.com", "aliases": ["login-us.microsoftonline.com"] }] }, "https://login.chinacloudapi.cn/common/": { "tenant_discovery_endpoint": "https://login.chinacloudapi.cn/common/v2.0/.well-known/openid-configuration", "api-version": "1.1", "metadata": [{ "preferred_network": "login.microsoftonline.com", "preferred_cache": "login.windows.net", "aliases": ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { "preferred_network": "login.partner.microsoftonline.cn", "preferred_cache": "login.partner.microsoftonline.cn", "aliases": ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { "preferred_network": "login.microsoftonline.de", "preferred_cache": "login.microsoftonline.de", "aliases": ["login.microsoftonline.de"] }, { "preferred_network": "login.microsoftonline.us", "preferred_cache": "login.microsoftonline.us", "aliases": ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { "preferred_network": "login-us.microsoftonline.com", "preferred_cache": "login-us.microsoftonline.com", "aliases": ["login-us.microsoftonline.com"] }] }, "https://login.microsoftonline.us/common/": { "tenant_discovery_endpoint": "https://login.microsoftonline.us/common/v2.0/.well-known/openid-configuration", "api-version": "1.1", "metadata": [{ "preferred_network": "login.microsoftonline.com", "preferred_cache": "login.windows.net", "aliases": ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { "preferred_network": "login.partner.microsoftonline.cn", "preferred_cache": "login.partner.microsoftonline.cn", "aliases": ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { "preferred_network": "login.microsoftonline.de", "preferred_cache": "login.microsoftonline.de", "aliases": ["login.microsoftonline.de"] }, { "preferred_network": "login.microsoftonline.us", "preferred_cache": "login.microsoftonline.us", "aliases": ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { "preferred_network": "login-us.microsoftonline.com", "preferred_cache": "login-us.microsoftonline.com", "aliases": ["login-us.microsoftonline.com"] }] }, "https://login.microsoftonline.com/consumers/": { "tenant_discovery_endpoint": "https://login.microsoftonline.com/consumers/v2.0/.well-known/openid-configuration", "api-version": "1.1", "metadata": [{ "preferred_network": "login.microsoftonline.com", "preferred_cache": "login.windows.net", "aliases": ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { "preferred_network": "login.partner.microsoftonline.cn", "preferred_cache": "login.partner.microsoftonline.cn", "aliases": ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { "preferred_network": "login.microsoftonline.de", "preferred_cache": "login.microsoftonline.de", "aliases": ["login.microsoftonline.de"] }, { "preferred_network": "login.microsoftonline.us", "preferred_cache": "login.microsoftonline.us", "aliases": ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { "preferred_network": "login-us.microsoftonline.com", "preferred_cache": "login-us.microsoftonline.com", "aliases": ["login-us.microsoftonline.com"] }] }, "https://login.chinacloudapi.cn/consumers/": { "tenant_discovery_endpoint": "https://login.chinacloudapi.cn/consumers/v2.0/.well-known/openid-configuration", "api-version": "1.1", "metadata": [{ "preferred_network": "login.microsoftonline.com", "preferred_cache": "login.windows.net", "aliases": ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { "preferred_network": "login.partner.microsoftonline.cn", "preferred_cache": "login.partner.microsoftonline.cn", "aliases": ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { "preferred_network": "login.microsoftonline.de", "preferred_cache": "login.microsoftonline.de", "aliases": ["login.microsoftonline.de"] }, { "preferred_network": "login.microsoftonline.us", "preferred_cache": "login.microsoftonline.us", "aliases": ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { "preferred_network": "login-us.microsoftonline.com", "preferred_cache": "login-us.microsoftonline.com", "aliases": ["login-us.microsoftonline.com"] }] }, "https://login.microsoftonline.us/consumers/": { "tenant_discovery_endpoint": "https://login.microsoftonline.us/consumers/v2.0/.well-known/openid-configuration", "api-version": "1.1", "metadata": [{ "preferred_network": "login.microsoftonline.com", "preferred_cache": "login.windows.net", "aliases": ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { "preferred_network": "login.partner.microsoftonline.cn", "preferred_cache": "login.partner.microsoftonline.cn", "aliases": ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { "preferred_network": "login.microsoftonline.de", "preferred_cache": "login.microsoftonline.de", "aliases": ["login.microsoftonline.de"] }, { "preferred_network": "login.microsoftonline.us", "preferred_cache": "login.microsoftonline.us", "aliases": ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { "preferred_network": "login-us.microsoftonline.com", "preferred_cache": "login-us.microsoftonline.com", "aliases": ["login-us.microsoftonline.com"] }] }, "https://login.microsoftonline.com/organizations/": { "tenant_discovery_endpoint": "https://login.microsoftonline.com/organizations/v2.0/.well-known/openid-configuration", "api-version": "1.1", "metadata": [{ "preferred_network": "login.microsoftonline.com", "preferred_cache": "login.windows.net", "aliases": ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { "preferred_network": "login.partner.microsoftonline.cn", "preferred_cache": "login.partner.microsoftonline.cn", "aliases": ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { "preferred_network": "login.microsoftonline.de", "preferred_cache": "login.microsoftonline.de", "aliases": ["login.microsoftonline.de"] }, { "preferred_network": "login.microsoftonline.us", "preferred_cache": "login.microsoftonline.us", "aliases": ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { "preferred_network": "login-us.microsoftonline.com", "preferred_cache": "login-us.microsoftonline.com", "aliases": ["login-us.microsoftonline.com"] }] }, "https://login.chinacloudapi.cn/organizations/": { "tenant_discovery_endpoint": "https://login.chinacloudapi.cn/organizations/v2.0/.well-known/openid-configuration", "api-version": "1.1", "metadata": [{ "preferred_network": "login.microsoftonline.com", "preferred_cache": "login.windows.net", "aliases": ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { "preferred_network": "login.partner.microsoftonline.cn", "preferred_cache": "login.partner.microsoftonline.cn", "aliases": ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { "preferred_network": "login.microsoftonline.de", "preferred_cache": "login.microsoftonline.de", "aliases": ["login.microsoftonline.de"] }, { "preferred_network": "login.microsoftonline.us", "preferred_cache": "login.microsoftonline.us", "aliases": ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { "preferred_network": "login-us.microsoftonline.com", "preferred_cache": "login-us.microsoftonline.com", "aliases": ["login-us.microsoftonline.com"] }] }, "https://login.microsoftonline.us/organizations/": { "tenant_discovery_endpoint": "https://login.microsoftonline.us/organizations/v2.0/.well-known/openid-configuration", "api-version": "1.1", "metadata": [{ "preferred_network": "login.microsoftonline.com", "preferred_cache": "login.windows.net", "aliases": ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { "preferred_network": "login.partner.microsoftonline.cn", "preferred_cache": "login.partner.microsoftonline.cn", "aliases": ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { "preferred_network": "login.microsoftonline.de", "preferred_cache": "login.microsoftonline.de", "aliases": ["login.microsoftonline.de"] }, { "preferred_network": "login.microsoftonline.us", "preferred_cache": "login.microsoftonline.us", "aliases": ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { "preferred_network": "login-us.microsoftonline.com", "preferred_cache": "login-us.microsoftonline.com", "aliases": ["login-us.microsoftonline.com"] }] } } };
var EndpointMetadata = rawMetdataJSON.endpointMetadata;
var InstanceDiscoveryMetadata = rawMetdataJSON.instanceDiscoveryMetadata;


//# sourceMappingURL=AuthorityMetadata.js.map


/***/ }),
/* 2733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isCloudInstanceDiscoveryResponse; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isCloudInstanceDiscoveryResponse(response) {
    return (response.hasOwnProperty("tenant_discovery_endpoint") &&
        response.hasOwnProperty("metadata"));
}


//# sourceMappingURL=CloudInstanceDiscoveryResponse.js.map


/***/ }),
/* 2734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isCloudInstanceDiscoveryErrorResponse; });
/*! @azure/msal-common v13.3.1 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
function isCloudInstanceDiscoveryErrorResponse(response) {
    return (response.hasOwnProperty("error") &&
        response.hasOwnProperty("error_description"));
}


//# sourceMappingURL=CloudInstanceDiscoveryErrorResponse.js.map


/***/ }),
/* 2735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegionDiscovery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__telemetry_performance_PerformanceEvent_js__ = __webpack_require__(153);
/*! @azure/msal-common v13.3.1 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var RegionDiscovery = /** @class */ (function () {
    function RegionDiscovery(networkInterface, performanceClient, correlationId) {
        this.networkInterface = networkInterface;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */
    RegionDiscovery.prototype.detectRegion = function (environmentRegion, regionDiscoveryMetadata) {
        var _a, _b, _c, _d;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var autodetectedRegionName, options, localIMDSVersionResponse, currentIMDSVersion, currentIMDSVersionResponse;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_2__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RegionDiscoveryDetectRegion, this.correlationId);
                        autodetectedRegionName = environmentRegion;
                        if (!!autodetectedRegionName) return [3 /*break*/, 8];
                        options = RegionDiscovery.IMDS_OPTIONS;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 6, , 7]);
                        (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_2__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RegionDiscoveryGetRegionFromIMDS, this.correlationId);
                        return [4 /*yield*/, this.getRegionFromIMDS(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].IMDS_VERSION, options)];
                    case 2:
                        localIMDSVersionResponse = _e.sent();
                        if (localIMDSVersionResponse.status === __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["z" /* ResponseCodes */].httpSuccess) {
                            autodetectedRegionName = localIMDSVersionResponse.body;
                            regionDiscoveryMetadata.region_source = __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["y" /* RegionDiscoverySources */].IMDS;
                        }
                        if (!(localIMDSVersionResponse.status === __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["z" /* ResponseCodes */].httpBadRequest)) return [3 /*break*/, 5];
                        (_c = this.performanceClient) === null || _c === void 0 ? void 0 : _c.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_2__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RegionDiscoveryGetCurrentVersion, this.correlationId);
                        return [4 /*yield*/, this.getCurrentVersion(options)];
                    case 3:
                        currentIMDSVersion = _e.sent();
                        if (!currentIMDSVersion) {
                            regionDiscoveryMetadata.region_source = __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["y" /* RegionDiscoverySources */].FAILED_AUTO_DETECTION;
                            return [2 /*return*/, null];
                        }
                        (_d = this.performanceClient) === null || _d === void 0 ? void 0 : _d.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_2__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RegionDiscoveryGetRegionFromIMDS, this.correlationId);
                        return [4 /*yield*/, this.getRegionFromIMDS(currentIMDSVersion, options)];
                    case 4:
                        currentIMDSVersionResponse = _e.sent();
                        if (currentIMDSVersionResponse.status === __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["z" /* ResponseCodes */].httpSuccess) {
                            autodetectedRegionName = currentIMDSVersionResponse.body;
                            regionDiscoveryMetadata.region_source = __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["y" /* RegionDiscoverySources */].IMDS;
                        }
                        _e.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        _e.sent();
                        regionDiscoveryMetadata.region_source = __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["y" /* RegionDiscoverySources */].FAILED_AUTO_DETECTION;
                        return [2 /*return*/, null];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        regionDiscoveryMetadata.region_source = __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["y" /* RegionDiscoverySources */].ENVIRONMENT_VARIABLE;
                        _e.label = 9;
                    case 9:
                        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
                        if (!autodetectedRegionName) {
                            regionDiscoveryMetadata.region_source = __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["y" /* RegionDiscoverySources */].FAILED_AUTO_DETECTION;
                        }
                        return [2 /*return*/, autodetectedRegionName || null];
                }
            });
        });
    };
    /**
     * Make the call to the IMDS endpoint
     *
     * @param imdsEndpointUrl
     * @returns Promise<NetworkResponse<string>>
     */
    RegionDiscovery.prototype.getRegionFromIMDS = function (version, options) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_2__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RegionDiscoveryGetRegionFromIMDS, this.correlationId);
                return [2 /*return*/, this.networkInterface.sendGetRequestAsync(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].IMDS_ENDPOINT + "?api-version=" + version + "&format=text", options, __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].IMDS_TIMEOUT)];
            });
        });
    };
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */
    RegionDiscovery.prototype.getCurrentVersion = function (options) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var response;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_2__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].RegionDiscoveryGetCurrentVersion, this.correlationId);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.networkInterface.sendGetRequestAsync(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].IMDS_ENDPOINT + "?format=json", options)];
                    case 2:
                        response = _b.sent();
                        // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
                        if (response.status === __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["z" /* ResponseCodes */].httpBadRequest && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) {
                            return [2 /*return*/, response.body["newest-versions"][0]];
                        }
                        return [2 /*return*/, null];
                    case 3:
                        _b.sent();
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Options for the IMDS endpoint request
    RegionDiscovery.IMDS_OPTIONS = {
        headers: {
            Metadata: "true",
        },
    };
    return RegionDiscovery;
}());


//# sourceMappingURL=RegionDiscovery.js.map


/***/ }),
/* 2736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthorityFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Authority_js__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_StringUtils_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__telemetry_performance_PerformanceEvent_js__ = __webpack_require__(153);
/*! @azure/msal-common v13.3.1 2023-10-27 */








/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var AuthorityFactory = /** @class */ (function () {
    function AuthorityFactory() {
    }
    /**
     * Create an authority object of the correct type based on the url
     * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
     *
     * Also performs endpoint discovery.
     *
     * @param authorityUri
     * @param networkClient
     * @param protocolMode
     */
    AuthorityFactory.createDiscoveredInstance = function (authorityUri, networkClient, cacheManager, authorityOptions, logger, performanceClient, correlationId) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var authorityUriFinal, acquireTokenAuthority, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        performanceClient === null || performanceClient === void 0 ? void 0 : performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_5__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityFactoryCreateDiscoveredInstance, correlationId);
                        authorityUriFinal = __WEBPACK_IMPORTED_MODULE_1__Authority_js__["a" /* Authority */].transformCIAMAuthority(authorityUri);
                        acquireTokenAuthority = AuthorityFactory.createInstance(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, performanceClient, correlationId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        performanceClient === null || performanceClient === void 0 ? void 0 : performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_5__telemetry_performance_PerformanceEvent_js__["c" /* PerformanceEvents */].AuthorityResolveEndpointsAsync, correlationId);
                        return [4 /*yield*/, acquireTokenAuthority.resolveEndpointsAsync()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, acquireTokenAuthority];
                    case 3:
                        e_1 = _a.sent();
                        throw __WEBPACK_IMPORTED_MODULE_4__error_ClientAuthError_js__["a" /* ClientAuthError */].createEndpointDiscoveryIncompleteError(e_1);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create an authority object of the correct type based on the url
     * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
     *
     * Does not perform endpoint discovery.
     *
     * @param authorityUrl
     * @param networkInterface
     * @param protocolMode
     */
    AuthorityFactory.createInstance = function (authorityUrl, networkInterface, cacheManager, authorityOptions, logger, performanceClient, correlationId) {
        // Throw error if authority url is empty
        if (__WEBPACK_IMPORTED_MODULE_3__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(authorityUrl)) {
            throw __WEBPACK_IMPORTED_MODULE_2__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createUrlEmptyError();
        }
        return new __WEBPACK_IMPORTED_MODULE_1__Authority_js__["a" /* Authority */](authorityUrl, networkInterface, cacheManager, authorityOptions, logger, performanceClient, correlationId);
    };
    return AuthorityFactory;
}());


//# sourceMappingURL=AuthorityFactory.js.map


/***/ }),
/* 2737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThrottlingEntity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ThrottlingEntity = /** @class */ (function () {
    function ThrottlingEntity() {
    }
    /**
     * validates if a given cache entry is "Throttling", parses <key,value>
     * @param key
     * @param entity
     */
    ThrottlingEntity.isThrottlingEntity = function (key, entity) {
        var validateKey = false;
        if (key) {
            validateKey = key.indexOf(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["F" /* ThrottlingConstants */].THROTTLING_PREFIX) === 0;
        }
        var validateEntity = true;
        if (entity) {
            validateEntity = entity.hasOwnProperty("throttleTime");
        }
        return validateKey && validateEntity;
    };
    return ThrottlingEntity;
}());


//# sourceMappingURL=ThrottlingEntity.js.map


/***/ }),
/* 2738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StubbedNetworkModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_AuthError_js__ = __webpack_require__(112);
/*! @azure/msal-common v13.3.1 2023-10-27 */



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var StubbedNetworkModule = {
    sendGetRequestAsync: function () {
        var notImplErr = "Network interface - sendGetRequestAsync() has not been implemented for the Network interface.";
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr));
    },
    sendPostRequestAsync: function () {
        var notImplErr = "Network interface - sendPostRequestAsync() has not been implemented for the Network interface.";
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_AuthError_js__["a" /* AuthError */].createUnexpectedError(notImplErr));
    }
};


//# sourceMappingURL=INetworkModule.js.map


/***/ }),
/* 2739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JoseHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_JoseHeaderError_js__ = __webpack_require__(2740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var JoseHeader = /** @class */ (function () {
    function JoseHeader(options) {
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */
    JoseHeader.getShrHeaderString = function (shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_JoseHeaderError_js__["a" /* JoseHeaderError */].createMissingKidError();
        }
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_JoseHeaderError_js__["a" /* JoseHeaderError */].createMissingAlgError();
        }
        var shrHeader = new JoseHeader({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["r" /* JsonTypes */].Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    };
    return JoseHeader;
}());


//# sourceMappingURL=JoseHeader.js.map


/***/ }),
/* 2740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JoseHeaderError; });
/* unused harmony export JoseHeaderErrorMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthError_js__ = __webpack_require__(112);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */
var JoseHeaderErrorMessage = {
    missingKidError: {
        code: "missing_kid_error",
        desc: "The JOSE Header for the requested JWT, JWS or JWK object requires a keyId to be configured as the 'kid' header claim. No 'kid' value was provided."
    },
    missingAlgError: {
        code: "missing_alg_error",
        desc: "The JOSE Header for the requested JWT, JWS or JWK object requires an algorithm to be specified as the 'alg' header claim. No 'alg' value was provided."
    },
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */
var JoseHeaderError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(JoseHeaderError, _super);
    function JoseHeaderError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "JoseHeaderError";
        Object.setPrototypeOf(_this, JoseHeaderError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when keyId isn't set on JOSE header.
     */
    JoseHeaderError.createMissingKidError = function () {
        return new JoseHeaderError(JoseHeaderErrorMessage.missingKidError.code, JoseHeaderErrorMessage.missingKidError.desc);
    };
    /**
     * Creates an error thrown when algorithm isn't set on JOSE header.
     */
    JoseHeaderError.createMissingAlgError = function () {
        return new JoseHeaderError(JoseHeaderErrorMessage.missingAlgError.code, JoseHeaderErrorMessage.missingAlgError.desc);
    };
    return JoseHeaderError;
}(__WEBPACK_IMPORTED_MODULE_1__AuthError_js__["a" /* AuthError */]));


//# sourceMappingURL=JoseHeaderError.js.map


/***/ }),
/* 2741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticationHeaderParser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__ = __webpack_require__(32);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This is a helper class that parses supported HTTP response authentication headers to extract and return
 * header challenge values that can be used outside the basic authorization flows.
 */
var AuthenticationHeaderParser = /** @class */ (function () {
    function AuthenticationHeaderParser(headers) {
        this.headers = headers;
    }
    /**
     * This method parses the SHR nonce value out of either the Authentication-Info or WWW-Authenticate authentication headers.
     * @returns
     */
    AuthenticationHeaderParser.prototype.getShrNonce = function () {
        // Attempt to parse nonce from Authentiacation-Info
        var authenticationInfo = this.headers[__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["q" /* HeaderNames */].AuthenticationInfo];
        if (authenticationInfo) {
            var authenticationInfoChallenges = this.parseChallenges(authenticationInfo);
            if (authenticationInfoChallenges.nextnonce) {
                return authenticationInfoChallenges.nextnonce;
            }
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInvalidAuthenticationHeaderError(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["q" /* HeaderNames */].AuthenticationInfo, "nextnonce challenge is missing.");
        }
        // Attempt to parse nonce from WWW-Authenticate
        var wwwAuthenticate = this.headers[__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["q" /* HeaderNames */].WWWAuthenticate];
        if (wwwAuthenticate) {
            var wwwAuthenticateChallenges = this.parseChallenges(wwwAuthenticate);
            if (wwwAuthenticateChallenges.nonce) {
                return wwwAuthenticateChallenges.nonce;
            }
            throw __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createInvalidAuthenticationHeaderError(__WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["q" /* HeaderNames */].WWWAuthenticate, "nonce challenge is missing.");
        }
        // If neither header is present, throw missing headers error
        throw __WEBPACK_IMPORTED_MODULE_0__error_ClientConfigurationError_js__["a" /* ClientConfigurationError */].createMissingNonceAuthenticationHeadersError();
    };
    /**
     * Parses an HTTP header's challenge set into a key/value map.
     * @param header
     * @returns
     */
    AuthenticationHeaderParser.prototype.parseChallenges = function (header) {
        var schemeSeparator = header.indexOf(" ");
        var challenges = header.substr(schemeSeparator + 1).split(",");
        var challengeMap = {};
        challenges.forEach(function (challenge) {
            var _a = challenge.split("="), key = _a[0], value = _a[1];
            // Remove escaped quotation marks (', ") from challenge string to keep only the challenge value
            challengeMap[key] = unescape(value.replace(/['"]+/g, __WEBPACK_IMPORTED_MODULE_1__utils_Constants_js__["m" /* Constants */].EMPTY_STRING));
        });
        return challengeMap;
    };
    return AuthenticationHeaderParser;
}());


//# sourceMappingURL=AuthenticationHeaderParser.js.map


/***/ }),
/* 2742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerTelemetryManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cache_entities_ServerTelemetryEntity_js__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__ = __webpack_require__(65);
/*! @azure/msal-common v13.3.1 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ServerTelemetryManager = /** @class */ (function () {
    function ServerTelemetryManager(telemetryRequest, cacheManager) {
        this.cacheOutcome = __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["i" /* CacheOutcome */].NO_CACHE_HIT;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        this.wrapperVer = telemetryRequest.wrapperVer || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
        this.telemetryCacheKey = __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].CACHE_KEY + __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["D" /* Separators */].CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */
    ServerTelemetryManager.prototype.generateCurrentRequestHeaderValue = function () {
        var request = "" + this.apiId + __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].VALUE_SEPARATOR + this.cacheOutcome;
        var platformFields = [this.wrapperSKU, this.wrapperVer].join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].VALUE_SEPARATOR);
        var regionDiscoveryFields = this.getRegionDiscoveryFields();
        var requestWithRegionDiscoveryFields = [request, regionDiscoveryFields].join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].VALUE_SEPARATOR);
        return [__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].SCHEMA_VERSION, requestWithRegionDiscoveryFields, platformFields].join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].CATEGORY_SEPARATOR);
    };
    /**
     * API to add MSER Telemetry for the last failed request
     */
    ServerTelemetryManager.prototype.generateLastRequestHeaderValue = function () {
        var lastRequests = this.getLastRequests();
        var maxErrors = ServerTelemetryManager.maxErrorsToSend(lastRequests);
        var failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].VALUE_SEPARATOR);
        var errors = lastRequests.errors.slice(0, maxErrors).join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].VALUE_SEPARATOR);
        var errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        var overflow = maxErrors < errorCount ? __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].OVERFLOW_TRUE : __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].OVERFLOW_FALSE;
        var platformFields = [errorCount, overflow].join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].VALUE_SEPARATOR);
        return [__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].SCHEMA_VERSION, lastRequests.cacheHits, failedRequests, errors, platformFields].join(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].CATEGORY_SEPARATOR);
    };
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */
    ServerTelemetryManager.prototype.cacheFailedRequest = function (error) {
        var lastRequests = this.getLastRequests();
        if (lastRequests.errors.length >= __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].MAX_CACHED_ERRORS) {
            // Remove a cached error to make room, first in first out
            lastRequests.failedRequests.shift(); // apiId
            lastRequests.failedRequests.shift(); // correlationId
            lastRequests.errors.shift();
        }
        lastRequests.failedRequests.push(this.apiId, this.correlationId);
        if (!__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(error.subError)) {
            lastRequests.errors.push(error.subError);
        }
        else if (!__WEBPACK_IMPORTED_MODULE_2__utils_StringUtils_js__["a" /* StringUtils */].isEmpty(error.errorCode)) {
            lastRequests.errors.push(error.errorCode);
        }
        else if (!!error && error.toString()) {
            lastRequests.errors.push(error.toString());
        }
        else {
            lastRequests.errors.push(__WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].UNKNOWN_ERROR);
        }
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return;
    };
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */
    ServerTelemetryManager.prototype.incrementCacheHits = function () {
        var lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return lastRequests.cacheHits;
    };
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */
    ServerTelemetryManager.prototype.getLastRequests = function () {
        var initialValue = new __WEBPACK_IMPORTED_MODULE_1__cache_entities_ServerTelemetryEntity_js__["a" /* ServerTelemetryEntity */]();
        var lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
        return lastRequests || initialValue;
    };
    /**
     * Remove server telemetry cache entry
     */
    ServerTelemetryManager.prototype.clearTelemetryCache = function () {
        var lastRequests = this.getLastRequests();
        var numErrorsFlushed = ServerTelemetryManager.maxErrorsToSend(lastRequests);
        var errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) {
            // All errors were sent on last request, clear Telemetry cache
            this.cacheManager.removeItem(this.telemetryCacheKey);
        }
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            var serverTelemEntity = new __WEBPACK_IMPORTED_MODULE_1__cache_entities_ServerTelemetryEntity_js__["a" /* ServerTelemetryEntity */]();
            serverTelemEntity.failedRequests = lastRequests.failedRequests.slice(numErrorsFlushed * 2); // failedRequests contains 2 items for each error
            serverTelemEntity.errors = lastRequests.errors.slice(numErrorsFlushed);
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity);
        }
    };
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */
    ServerTelemetryManager.maxErrorsToSend = function (serverTelemetryEntity) {
        var i;
        var maxErrors = 0;
        var dataSize = 0;
        var errorCount = serverTelemetryEntity.errors.length;
        for (i = 0; i < errorCount; i++) {
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            var apiId = serverTelemetryEntity.failedRequests[2 * i] || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
            var correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
            var errorCode = serverTelemetryEntity.errors[i] || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING;
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["B" /* SERVER_TELEM_CONSTANTS */].MAX_LAST_HEADER_BYTES) {
                // Adding this entry to the header would still keep header size below the limit
                maxErrors += 1;
            }
            else {
                break;
            }
        }
        return maxErrors;
    };
    /**
     * Get the region discovery fields
     *
     * @returns string
     */
    ServerTelemetryManager.prototype.getRegionDiscoveryFields = function () {
        var regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING);
        regionDiscoveryFields.push(this.regionSource || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING);
        regionDiscoveryFields.push(this.regionOutcome || __WEBPACK_IMPORTED_MODULE_0__utils_Constants_js__["m" /* Constants */].EMPTY_STRING);
        return regionDiscoveryFields.join(",");
    };
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */
    ServerTelemetryManager.prototype.updateRegionDiscoveryMetadata = function (regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    };
    /**
     * Set cache outcome
     */
    ServerTelemetryManager.prototype.setCacheOutcome = function (cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    };
    return ServerTelemetryManager;
}());


//# sourceMappingURL=ServerTelemetryManager.js.map


/***/ }),
/* 2743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StubPerformanceClient; });
/* unused harmony export StubPerformanceMeasurement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PerformanceClient_js__ = __webpack_require__(1117);
/*! @azure/msal-common v13.3.1 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var StubPerformanceMeasurement = /** @class */ (function () {
    function StubPerformanceMeasurement() {
    }
    /* eslint-disable-next-line @typescript-eslint/no-empty-function */
    StubPerformanceMeasurement.prototype.startMeasurement = function () { };
    /* eslint-disable-next-line @typescript-eslint/no-empty-function */
    StubPerformanceMeasurement.prototype.endMeasurement = function () { };
    StubPerformanceMeasurement.prototype.flushMeasurement = function () {
        return null;
    };
    return StubPerformanceMeasurement;
}());
var StubPerformanceClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(StubPerformanceClient, _super);
    function StubPerformanceClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StubPerformanceClient.prototype.generateId = function () {
        return "callback-id";
    };
    StubPerformanceClient.prototype.startPerformanceMeasuremeant = function () {
        return new StubPerformanceMeasurement();
    };
    StubPerformanceClient.prototype.startPerformanceMeasurement = function () {
        return new StubPerformanceMeasurement();
    };
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    StubPerformanceClient.prototype.calculateQueuedTime = function (preQueueTime, currentTime) {
        return 0;
    };
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    StubPerformanceClient.prototype.addQueueMeasurement = function (eventName, correlationId, queueTime) {
        return;
    };
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    StubPerformanceClient.prototype.setPreQueueTime = function (eventName, correlationId) {
        return;
    };
    return StubPerformanceClient;
}(__WEBPACK_IMPORTED_MODULE_1__PerformanceClient_js__["a" /* PerformanceClient */]));


//# sourceMappingURL=StubPerformanceClient.js.map


/***/ }),
/* 2744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__ = __webpack_require__(46);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var BrowserStorage = /** @class */ (function () {
    function BrowserStorage(cacheLocation) {
        this.validateWindowStorage(cacheLocation);
        this.windowStorage = window[cacheLocation];
    }
    BrowserStorage.prototype.validateWindowStorage = function (cacheLocation) {
        if (cacheLocation !== __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].LocalStorage && cacheLocation !== __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].SessionStorage) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStorageNotSupportedError(cacheLocation);
        }
        var storageSupported = !!window[cacheLocation];
        if (!storageSupported) {
            throw __WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStorageNotSupportedError(cacheLocation);
        }
    };
    BrowserStorage.prototype.getItem = function (key) {
        return this.windowStorage.getItem(key);
    };
    BrowserStorage.prototype.setItem = function (key, value) {
        this.windowStorage.setItem(key, value);
    };
    BrowserStorage.prototype.removeItem = function (key) {
        this.windowStorage.removeItem(key);
    };
    BrowserStorage.prototype.getKeys = function () {
        return Object.keys(this.windowStorage);
    };
    BrowserStorage.prototype.containsKey = function (key) {
        return this.windowStorage.hasOwnProperty(key);
    };
    return BrowserStorage;
}());


//# sourceMappingURL=BrowserStorage.js.map


/***/ }),
/* 2745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__ = __webpack_require__(46);
/*! @azure/msal-browser v2.38.3 2023-10-27 */






/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */
var FetchClient = /** @class */ (function () {
    function FetchClient() {
    }
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */
    FetchClient.prototype.sendGetRequestAsync = function (url, options) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var response, e_1, _a;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetch(url, {
                                method: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["i" /* HTTP_REQUEST_TYPE */].GET,
                                headers: this.getFetchHeaders(options)
                            })];
                    case 1:
                        response = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        if (window.navigator.onLine) {
                            throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createGetRequestFailedError(e_1, url);
                        }
                        else {
                            throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNoNetworkConnectivityError();
                        }
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        _a = {
                            headers: this.getHeaderDict(response.headers)
                        };
                        return [4 /*yield*/, response.json()];
                    case 4: return [2 /*return*/, (_a.body = (_b.sent()),
                            _a.status = response.status,
                            _a)];
                    case 5:
                        _b.sent();
                        throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createFailedToParseNetworkResponseError(url);
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */
    FetchClient.prototype.sendPostRequestAsync = function (url, options) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var reqBody, response, e_3, _a;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        reqBody = (options && options.body) || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(url, {
                                method: __WEBPACK_IMPORTED_MODULE_3__utils_BrowserConstants_js__["i" /* HTTP_REQUEST_TYPE */].POST,
                                headers: this.getFetchHeaders(options),
                                body: reqBody
                            })];
                    case 2:
                        response = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _b.sent();
                        if (window.navigator.onLine) {
                            throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createPostRequestFailedError(e_3, url);
                        }
                        else {
                            throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNoNetworkConnectivityError();
                        }
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        _a = {
                            headers: this.getHeaderDict(response.headers)
                        };
                        return [4 /*yield*/, response.json()];
                    case 5: return [2 /*return*/, (_a.body = (_b.sent()),
                            _a.status = response.status,
                            _a)];
                    case 6:
                        _b.sent();
                        throw __WEBPACK_IMPORTED_MODULE_2__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createFailedToParseNetworkResponseError(url);
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get Fetch API Headers object from string map
     * @param inputHeaders
     */
    FetchClient.prototype.getFetchHeaders = function (options) {
        var headers = new Headers();
        if (!(options && options.headers)) {
            return headers;
        }
        var optionsHeaders = options.headers;
        Object.keys(optionsHeaders).forEach(function (key) {
            headers.append(key, optionsHeaders[key]);
        });
        return headers;
    };
    FetchClient.prototype.getHeaderDict = function (headers) {
        var headerDict = {};
        headers.forEach(function (value, key) {
            headerDict[key] = value;
        });
        return headerDict;
    };
    return FetchClient;
}());


//# sourceMappingURL=FetchClient.js.map


/***/ }),
/* 2746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XhrClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__ = __webpack_require__(46);
/*! @azure/msal-browser v2.38.3 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This client implements the XMLHttpRequest class to send GET and POST requests.
 */
var XhrClient = /** @class */ (function () {
    function XhrClient() {
    }
    /**
     * XhrClient for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */
    XhrClient.prototype.sendGetRequestAsync = function (url, options) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.sendRequestAsync(url, __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["i" /* HTTP_REQUEST_TYPE */].GET, options)];
            });
        });
    };
    /**
     * XhrClient for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */
    XhrClient.prototype.sendPostRequestAsync = function (url, options) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.sendRequestAsync(url, __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["i" /* HTTP_REQUEST_TYPE */].POST, options)];
            });
        });
    };
    /**
     * Helper for XhrClient requests.
     * @param url
     * @param method
     * @param options
     */
    XhrClient.prototype.sendRequestAsync = function (url, method, options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url, /* async: */ true);
            _this.setXhrHeaders(xhr, options);
            xhr.onload = function () {
                if (xhr.status < 200 || xhr.status >= 300) {
                    if (method === __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["i" /* HTTP_REQUEST_TYPE */].POST) {
                        reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createPostRequestFailedError("Failed with status " + xhr.status, url));
                    }
                    else {
                        reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createGetRequestFailedError("Failed with status " + xhr.status, url));
                    }
                }
                try {
                    var jsonResponse = JSON.parse(xhr.responseText);
                    var networkResponse = {
                        headers: _this.getHeaderDict(xhr),
                        body: jsonResponse,
                        status: xhr.status
                    };
                    resolve(networkResponse);
                }
                catch (e) {
                    reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createFailedToParseNetworkResponseError(url));
                }
            };
            xhr.onerror = function () {
                if (window.navigator.onLine) {
                    if (method === __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["i" /* HTTP_REQUEST_TYPE */].POST) {
                        reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createPostRequestFailedError("Failed with status " + xhr.status, url));
                    }
                    else {
                        reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createGetRequestFailedError("Failed with status " + xhr.status, url));
                    }
                }
                else {
                    reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNoNetworkConnectivityError());
                }
            };
            if (method === __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["i" /* HTTP_REQUEST_TYPE */].POST && options && options.body) {
                xhr.send(options.body);
            }
            else if (method === __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["i" /* HTTP_REQUEST_TYPE */].GET) {
                xhr.send();
            }
            else {
                throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createHttpMethodNotImplementedError(method);
            }
        });
    };
    /**
     * Helper to set XHR headers for request.
     * @param xhr
     * @param options
     */
    XhrClient.prototype.setXhrHeaders = function (xhr, options) {
        if (options && options.headers) {
            var headers_1 = options.headers;
            Object.keys(headers_1).forEach(function (key) {
                xhr.setRequestHeader(key, headers_1[key]);
            });
        }
    };
    /**
     * Gets a string map of the headers received in the response.
     *
     * Algorithm comes from https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders
     * @param xhr
     */
    XhrClient.prototype.getHeaderDict = function (xhr) {
        var headerString = xhr.getAllResponseHeaders();
        var headerArr = headerString.trim().split(/[\r\n]+/);
        var headerDict = {};
        headerArr.forEach(function (value) {
            var parts = value.split(": ");
            var headerName = parts.shift();
            var headerVal = parts.join(": ");
            if (headerName && headerVal) {
                headerDict[headerName] = headerVal;
            }
        });
        return headerDict;
    };
    return XhrClient;
}());


//# sourceMappingURL=XhrClient.js.map


/***/ }),
/* 2747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MathUtils; });
/*! @azure/msal-browser v2.38.3 2023-10-27 */

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Utility class for math specific functions in browser.
 */
var MathUtils = /** @class */ (function () {
    function MathUtils() {
    }
    /**
     * Decimal to Hex
     *
     * @param num
     */
    MathUtils.decimalToHex = function (num) {
        var hex = num.toString(16);
        while (hex.length < 2) {
            hex = "0" + hex;
        }
        return hex;
    };
    return MathUtils;
}());


//# sourceMappingURL=MathUtils.js.map


/***/ }),
/* 2748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base64Decode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_BrowserStringUtils_js__ = __webpack_require__(300);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */
var Base64Decode = /** @class */ (function () {
    function Base64Decode() {
    }
    /**
     * Returns a URL-safe plaintext decoded string from b64 encoded input.
     * @param input
     */
    Base64Decode.prototype.decode = function (input) {
        var encodedString = input.replace(/-/g, "+").replace(/_/g, "/");
        switch (encodedString.length % 4) {
            case 0:
                break;
            case 2:
                encodedString += "==";
                break;
            case 3:
                encodedString += "=";
                break;
            default:
                throw new Error("Invalid base64 string");
        }
        var inputUtf8Arr = this.base64DecToArr(encodedString);
        return __WEBPACK_IMPORTED_MODULE_1__utils_BrowserStringUtils_js__["a" /* BrowserStringUtils */].utf8ArrToString(inputUtf8Arr);
    };
    /**
     * Decodes base64 into Uint8Array
     * @param base64String
     * @param nBlockSize
     */
    Base64Decode.prototype.base64DecToArr = function (base64String, nBlockSize) {
        var sB64Enc = base64String.replace(/[^A-Za-z0-9\+\/]/g, __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING);
        var nInLen = sB64Enc.length;
        var nOutLen = nBlockSize ? Math.ceil((nInLen * 3 + 1 >>> 2) / nBlockSize) * nBlockSize : nInLen * 3 + 1 >>> 2;
        var aBytes = new Uint8Array(nOutLen);
        for (var nMod3 = void 0, nMod4 = void 0, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++) {
            nMod4 = nInIdx & 3;
            nUint24 |= this.b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 18 - 6 * nMod4;
            if (nMod4 === 3 || nInLen - nInIdx === 1) {
                for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++) {
                    aBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255;
                }
                nUint24 = 0;
            }
        }
        return aBytes;
    };
    /**
     * Base64 string to array decoding helper
     * @param charNum
     */
    Base64Decode.prototype.b64ToUint6 = function (charNum) {
        return charNum > 64 && charNum < 91 ?
            charNum - 65
            : charNum > 96 && charNum < 123 ?
                charNum - 71
                : charNum > 47 && charNum < 58 ?
                    charNum + 4
                    : charNum === 43 ?
                        62
                        : charNum === 47 ?
                            63
                            :
                                0;
    };
    return Base64Decode;
}());


//# sourceMappingURL=Base64Decode.js.map


/***/ }),
/* 2749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PkceGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__encode_Base64Encode_js__ = __webpack_require__(1130);
/*! @azure/msal-browser v2.38.3 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
// Constant byte array length
var RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * Class which exposes APIs to generate PKCE codes and code verifiers.
 */
var PkceGenerator = /** @class */ (function () {
    function PkceGenerator(cryptoObj) {
        this.base64Encode = new __WEBPACK_IMPORTED_MODULE_2__encode_Base64Encode_js__["a" /* Base64Encode */]();
        this.cryptoObj = cryptoObj;
    }
    /**
     * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
     */
    PkceGenerator.prototype.generateCodes = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var codeVerifier, codeChallenge;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        codeVerifier = this.generateCodeVerifier();
                        return [4 /*yield*/, this.generateCodeChallengeFromVerifier(codeVerifier)];
                    case 1:
                        codeChallenge = _a.sent();
                        return [2 /*return*/, {
                                verifier: codeVerifier,
                                challenge: codeChallenge
                            }];
                }
            });
        });
    };
    /**
     * Generates a random 32 byte buffer and returns the base64
     * encoded string to be used as a PKCE Code Verifier
     */
    PkceGenerator.prototype.generateCodeVerifier = function () {
        try {
            // Generate random values as utf-8
            var buffer = new Uint8Array(RANDOM_BYTE_ARR_LENGTH);
            this.cryptoObj.getRandomValues(buffer);
            // encode verifier as base64
            var pkceCodeVerifierB64 = this.base64Encode.urlEncodeArr(buffer);
            return pkceCodeVerifierB64;
        }
        catch (e) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createPkceNotGeneratedError(e);
        }
    };
    /**
     * Creates a base64 encoded PKCE Code Challenge string from the
     * hash created from the PKCE Code Verifier supplied
     */
    PkceGenerator.prototype.generateCodeChallengeFromVerifier = function (pkceCodeVerifier) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var pkceHashedCodeVerifier, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cryptoObj.sha256Digest(pkceCodeVerifier)];
                    case 1:
                        pkceHashedCodeVerifier = _a.sent();
                        // encode hash as base64
                        return [2 /*return*/, this.base64Encode.urlEncodeArr(new Uint8Array(pkceHashedCodeVerifier))];
                    case 2:
                        e_1 = _a.sent();
                        throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createPkceNotGeneratedError(e_1);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return PkceGenerator;
}());


//# sourceMappingURL=PkceGenerator.js.map


/***/ }),
/* 2750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModernBrowserCrypto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__ = __webpack_require__(46);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ModernBrowserCrypto = /** @class */ (function () {
    function ModernBrowserCrypto() {
    }
    ModernBrowserCrypto.prototype.getRandomValues = function (dataBuffer) {
        return window.crypto.getRandomValues(dataBuffer);
    };
    ModernBrowserCrypto.prototype.generateKey = function (algorithm, extractable, keyUsages) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, window.crypto.subtle.generateKey(algorithm, extractable, keyUsages)];
            });
        });
    };
    ModernBrowserCrypto.prototype.exportKey = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, window.crypto.subtle.exportKey(__WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["m" /* KEY_FORMAT_JWK */], key)];
            });
        });
    };
    ModernBrowserCrypto.prototype.importKey = function (keyData, algorithm, extractable, keyUsages) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, window.crypto.subtle.importKey(__WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["m" /* KEY_FORMAT_JWK */], keyData, algorithm, extractable, keyUsages)];
            });
        });
    };
    ModernBrowserCrypto.prototype.sign = function (algorithm, key, data) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, window.crypto.subtle.sign(algorithm, key, data)];
            });
        });
    };
    ModernBrowserCrypto.prototype.digest = function (algorithm, data) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, window.crypto.subtle.digest(algorithm, data)];
            });
        });
    };
    return ModernBrowserCrypto;
}());


//# sourceMappingURL=ModernBrowserCrypto.js.map


/***/ }),
/* 2751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MsrBrowserCrypto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__ = __webpack_require__(46);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var MsrBrowserCrypto = /** @class */ (function () {
    function MsrBrowserCrypto() {
    }
    MsrBrowserCrypto.prototype.initPrng = function (entropy) {
        // Turn into array, as initPrng seems to not always like Uint8Array (even though it should support both)
        return window.msrCrypto.initPrng(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["f" /* __spread */])(entropy));
    };
    MsrBrowserCrypto.prototype.getRandomValues = function (dataBuffer) {
        return window.msrCrypto.getRandomValues(dataBuffer);
    };
    MsrBrowserCrypto.prototype.generateKey = function (algorithm, extractable, keyUsages) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, window.msrCrypto.subtle.generateKey(algorithm, extractable, keyUsages)];
            });
        });
    };
    MsrBrowserCrypto.prototype.exportKey = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, window.msrCrypto.subtle.exportKey(__WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["m" /* KEY_FORMAT_JWK */], key)];
            });
        });
    };
    MsrBrowserCrypto.prototype.importKey = function (keyData, algorithm, extractable, keyUsages) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, window.msrCrypto.subtle.importKey(__WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["m" /* KEY_FORMAT_JWK */], keyData, algorithm, extractable, keyUsages)];
            });
        });
    };
    MsrBrowserCrypto.prototype.sign = function (algorithm, key, data) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, window.msrCrypto.subtle.sign(algorithm, key, data)];
            });
        });
    };
    MsrBrowserCrypto.prototype.digest = function (algorithm, data) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, window.msrCrypto.subtle.digest(algorithm, data)];
            });
        });
    };
    return MsrBrowserCrypto;
}());


//# sourceMappingURL=MsrBrowserCrypto.js.map


/***/ }),
/* 2752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MsBrowserCrypto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_BrowserStringUtils_js__ = __webpack_require__(300);
/*! @azure/msal-browser v2.38.3 2023-10-27 */






/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var MsBrowserCrypto = /** @class */ (function () {
    function MsBrowserCrypto() {
    }
    MsBrowserCrypto.prototype.getRandomValues = function (dataBuffer) {
        return window["msCrypto"].getRandomValues(dataBuffer);
    };
    MsBrowserCrypto.prototype.generateKey = function (algorithm, extractable, keyUsages) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var msGenerateKey = window["msCrypto"].subtle.generateKey(algorithm, extractable, keyUsages);
                        msGenerateKey.addEventListener("complete", function (e) {
                            resolve(e.target.result);
                        });
                        msGenerateKey.addEventListener("error", function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    MsBrowserCrypto.prototype.exportKey = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var msExportKey = window["msCrypto"].subtle.exportKey(__WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["m" /* KEY_FORMAT_JWK */], key);
                        msExportKey.addEventListener("complete", function (e) {
                            var resultBuffer = e.target.result;
                            var resultString = __WEBPACK_IMPORTED_MODULE_3__utils_BrowserStringUtils_js__["a" /* BrowserStringUtils */].utf8ArrToString(new Uint8Array(resultBuffer))
                                .replace(/\r/g, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING)
                                .replace(/\n/g, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING)
                                .replace(/\t/g, __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING)
                                .split(" ").join(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING)
                                .replace("\u0000", __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING);
                            try {
                                resolve(JSON.parse(resultString));
                            }
                            catch (e) {
                                reject(e);
                            }
                        });
                        msExportKey.addEventListener("error", function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    MsBrowserCrypto.prototype.importKey = function (keyData, algorithm, extractable, keyUsages) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var keyString, keyBuffer;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                keyString = __WEBPACK_IMPORTED_MODULE_3__utils_BrowserStringUtils_js__["a" /* BrowserStringUtils */].getSortedObjectString(keyData);
                keyBuffer = __WEBPACK_IMPORTED_MODULE_3__utils_BrowserStringUtils_js__["a" /* BrowserStringUtils */].stringToArrayBuffer(keyString);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var msImportKey = window["msCrypto"].subtle.importKey(__WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["m" /* KEY_FORMAT_JWK */], keyBuffer, algorithm, extractable, keyUsages);
                        msImportKey.addEventListener("complete", function (e) {
                            resolve(e.target.result);
                        });
                        msImportKey.addEventListener("error", function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    MsBrowserCrypto.prototype.sign = function (algorithm, key, data) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var msSign = window["msCrypto"].subtle.sign(algorithm, key, data);
                        msSign.addEventListener("complete", function (e) {
                            resolve(e.target.result);
                        });
                        msSign.addEventListener("error", function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    MsBrowserCrypto.prototype.digest = function (algorithm, data) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var digestOperation = window["msCrypto"].subtle.digest(algorithm, data.buffer);
                        digestOperation.addEventListener("complete", function (e) {
                            resolve(e.target.result);
                        });
                        digestOperation.addEventListener("error", function (error) {
                            reject(error);
                        });
                    })];
            });
        });
    };
    return MsBrowserCrypto;
}());


//# sourceMappingURL=MsBrowserCrypto.js.map


/***/ }),
/* 2753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CryptoKeyStore; });
/* unused harmony export CryptoKeyStoreNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncMemoryStorage_js__ = __webpack_require__(2754);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var CryptoKeyStoreNames;
(function (CryptoKeyStoreNames) {
    CryptoKeyStoreNames["asymmetricKeys"] = "asymmetricKeys";
    CryptoKeyStoreNames["symmetricKeys"] = "symmetricKeys";
})(CryptoKeyStoreNames || (CryptoKeyStoreNames = {}));
/**
 * MSAL CryptoKeyStore DB Version 2
 */
var CryptoKeyStore = /** @class */ (function () {
    function CryptoKeyStore(logger) {
        this.logger = logger;
        this.asymmetricKeys = new __WEBPACK_IMPORTED_MODULE_1__AsyncMemoryStorage_js__["a" /* AsyncMemoryStorage */](this.logger, CryptoKeyStoreNames.asymmetricKeys);
        this.symmetricKeys = new __WEBPACK_IMPORTED_MODULE_1__AsyncMemoryStorage_js__["a" /* AsyncMemoryStorage */](this.logger, CryptoKeyStoreNames.symmetricKeys);
    }
    CryptoKeyStore.prototype.clear = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Delete in-memory keystores
                        this.asymmetricKeys.clearInMemory();
                        this.symmetricKeys.clearInMemory();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.asymmetricKeys.clearPersistent()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1 instanceof Error) {
                            this.logger.error("Clearing keystore failed with error: " + e_1.message);
                        }
                        else {
                            this.logger.error("Clearing keystore failed with unknown error");
                        }
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return CryptoKeyStore;
}());


//# sourceMappingURL=CryptoKeyStore.js.map


/***/ }),
/* 2754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncMemoryStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DatabaseStorage_js__ = __webpack_require__(2755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryStorage_js__ = __webpack_require__(1118);
/*! @azure/msal-browser v2.38.3 2023-10-27 */






/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */
var AsyncMemoryStorage = /** @class */ (function () {
    function AsyncMemoryStorage(logger, storeName) {
        this.inMemoryCache = new __WEBPACK_IMPORTED_MODULE_3__MemoryStorage_js__["a" /* MemoryStorage */]();
        this.indexedDBCache = new __WEBPACK_IMPORTED_MODULE_2__DatabaseStorage_js__["a" /* DatabaseStorage */]();
        this.logger = logger;
        this.storeName = storeName;
    }
    AsyncMemoryStorage.prototype.handleDatabaseAccessError = function (error) {
        if (error instanceof __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */] && error.errorCode === __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["b" /* BrowserAuthErrorMessage */].databaseUnavailable.code) {
            this.logger.error("Could not access persistent storage. This may be caused by browser privacy features which block persistent storage in third-party contexts.");
        }
        else {
            throw error;
        }
    };
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     */
    AsyncMemoryStorage.prototype.getItem = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var item, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item = this.inMemoryCache.getItem(key);
                        if (!!item) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.logger.verbose("Queried item not found in in-memory cache, now querying persistent storage.");
                        return [4 /*yield*/, this.indexedDBCache.getItem(key)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_1 = _a.sent();
                        this.handleDatabaseAccessError(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, item];
                }
            });
        });
    };
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     */
    AsyncMemoryStorage.prototype.setItem = function (key, value) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var e_2;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.inMemoryCache.setItem(key, value);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.indexedDBCache.setItem(key, value)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.handleDatabaseAccessError(e_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     */
    AsyncMemoryStorage.prototype.removeItem = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var e_3;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.inMemoryCache.removeItem(key);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.indexedDBCache.removeItem(key)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        this.handleDatabaseAccessError(e_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     */
    AsyncMemoryStorage.prototype.getKeys = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var cacheKeys, e_4;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cacheKeys = this.inMemoryCache.getKeys();
                        if (!(cacheKeys.length === 0)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.logger.verbose("In-memory cache is empty, now querying persistent storage.");
                        return [4 /*yield*/, this.indexedDBCache.getKeys()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_4 = _a.sent();
                        this.handleDatabaseAccessError(e_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, cacheKeys];
                }
            });
        });
    };
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     */
    AsyncMemoryStorage.prototype.containsKey = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var containsKey, e_5;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        containsKey = this.inMemoryCache.containsKey(key);
                        if (!!containsKey) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.logger.verbose("Key not found in in-memory cache, now querying persistent storage.");
                        return [4 /*yield*/, this.indexedDBCache.containsKey(key)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_5 = _a.sent();
                        this.handleDatabaseAccessError(e_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, containsKey];
                }
            });
        });
    };
    /**
     * Clears in-memory Map
     */
    AsyncMemoryStorage.prototype.clearInMemory = function () {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose("Deleting in-memory keystore " + this.storeName);
        this.inMemoryCache.clear();
        this.logger.verbose("In-memory keystore " + this.storeName + " deleted");
    };
    /**
     * Tries to delete the IndexedDB database
     * @returns
     */
    AsyncMemoryStorage.prototype.clearPersistent = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var dbDeleted, e_6;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.logger.verbose("Deleting persistent keystore");
                        return [4 /*yield*/, this.indexedDBCache.deleteDatabase()];
                    case 1:
                        dbDeleted = _a.sent();
                        if (dbDeleted) {
                            this.logger.verbose("Persistent keystore deleted");
                        }
                        return [2 /*return*/, dbDeleted];
                    case 2:
                        e_6 = _a.sent();
                        this.handleDatabaseAccessError(e_6);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return AsyncMemoryStorage;
}());


//# sourceMappingURL=AsyncMemoryStorage.js.map


/***/ }),
/* 2755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatabaseStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__ = __webpack_require__(46);
/*! @azure/msal-browser v2.38.3 2023-10-27 */





/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */
var DatabaseStorage = /** @class */ (function () {
    function DatabaseStorage() {
        this.dbName = __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["e" /* DB_NAME */];
        this.version = __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["g" /* DB_VERSION */];
        this.tableName = __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["f" /* DB_TABLE_NAME */];
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */
    DatabaseStorage.prototype.open = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var openDB = window.indexedDB.open(_this.dbName, _this.version);
                        openDB.addEventListener("upgradeneeded", function (e) {
                            var event = e;
                            event.target.result.createObjectStore(_this.tableName);
                        });
                        openDB.addEventListener("success", function (e) {
                            var event = e;
                            _this.db = event.target.result;
                            _this.dbOpen = true;
                            resolve();
                        });
                        openDB.addEventListener("error", function () { return reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createDatabaseUnavailableError()); });
                    })];
            });
        });
    };
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */
    DatabaseStorage.prototype.closeConnection = function () {
        var db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    };
    /**
     * Opens database if it's not already open
     */
    DatabaseStorage.prototype.validateDbIsOpen = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.dbOpen) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.open()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */
    DatabaseStorage.prototype.getItem = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateDbIsOpen()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                // TODO: Add timeouts?
                                if (!_this.db) {
                                    return reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createDatabaseNotOpenError());
                                }
                                var transaction = _this.db.transaction([_this.tableName], "readonly");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbGet = objectStore.get(key);
                                dbGet.addEventListener("success", function (e) {
                                    var event = e;
                                    _this.closeConnection();
                                    resolve(event.target.result);
                                });
                                dbGet.addEventListener("error", function (e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })];
                }
            });
        });
    };
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */
    DatabaseStorage.prototype.setItem = function (key, payload) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateDbIsOpen()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                // TODO: Add timeouts?
                                if (!_this.db) {
                                    return reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createDatabaseNotOpenError());
                                }
                                var transaction = _this.db.transaction([_this.tableName], "readwrite");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbPut = objectStore.put(payload, key);
                                dbPut.addEventListener("success", function () {
                                    _this.closeConnection();
                                    resolve();
                                });
                                dbPut.addEventListener("error", function (e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })];
                }
            });
        });
    };
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */
    DatabaseStorage.prototype.removeItem = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateDbIsOpen()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                if (!_this.db) {
                                    return reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createDatabaseNotOpenError());
                                }
                                var transaction = _this.db.transaction([_this.tableName], "readwrite");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbDelete = objectStore.delete(key);
                                dbDelete.addEventListener("success", function () {
                                    _this.closeConnection();
                                    resolve();
                                });
                                dbDelete.addEventListener("error", function (e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })];
                }
            });
        });
    };
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */
    DatabaseStorage.prototype.getKeys = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateDbIsOpen()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                if (!_this.db) {
                                    return reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createDatabaseNotOpenError());
                                }
                                var transaction = _this.db.transaction([_this.tableName], "readonly");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbGetKeys = objectStore.getAllKeys();
                                dbGetKeys.addEventListener("success", function (e) {
                                    var event = e;
                                    _this.closeConnection();
                                    resolve(event.target.result);
                                });
                                dbGetKeys.addEventListener("error", function (e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })];
                }
            });
        });
    };
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */
    DatabaseStorage.prototype.containsKey = function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateDbIsOpen()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                if (!_this.db) {
                                    return reject(__WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createDatabaseNotOpenError());
                                }
                                var transaction = _this.db.transaction([_this.tableName], "readonly");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbContainsKey = objectStore.count(key);
                                dbContainsKey.addEventListener("success", function (e) {
                                    var event = e;
                                    _this.closeConnection();
                                    resolve(event.target.result === 1);
                                });
                                dbContainsKey.addEventListener("error", function (e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })];
                }
            });
        });
    };
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */
    DatabaseStorage.prototype.deleteDatabase = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                // Check if database being deleted exists
                if (this.db && this.dbOpen) {
                    this.closeConnection();
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var deleteDbRequest = window.indexedDB.deleteDatabase(__WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["e" /* DB_NAME */]);
                        deleteDbRequest.addEventListener("success", function () { return resolve(true); });
                        deleteDbRequest.addEventListener("blocked", function () { return resolve(true); });
                        deleteDbRequest.addEventListener("error", function () { return reject(false); });
                    })];
            });
        });
    };
    return DatabaseStorage;
}());


//# sourceMappingURL=DatabaseStorage.js.map


/***/ }),
/* 2756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PublicClientApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ClientApplication_js__ = __webpack_require__(2757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event_EventType_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_NativeAuthError_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__broker_nativeBroker_NativeMessageHandler_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_BrowserUtils_js__ = __webpack_require__(172);
/*! @azure/msal-browser v2.38.3 2023-10-27 */











/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */
var PublicClientApplication = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(PublicClientApplication, _super);
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration object for the MSAL PublicClientApplication instance
     */
    function PublicClientApplication(configuration) {
        var _this = _super.call(this, configuration) || this;
        _this.astsAsyncMeasurement = undefined;
        _this.activeSilentTokenRequests = new Map();
        // Register listener functions
        _this.trackPageVisibility = _this.trackPageVisibility.bind(_this);
        return _this;
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */
    PublicClientApplication.prototype.loginRedirect = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var correlationId;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                correlationId = this.getRequestCorrelationId(request);
                this.logger.verbose("loginRedirect called", correlationId);
                return [2 /*return*/, this.acquireTokenRedirect(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({ correlationId: correlationId }, (request || __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["h" /* DEFAULT_REQUEST */])))];
            });
        });
    };
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    PublicClientApplication.prototype.loginPopup = function (request) {
        var correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginPopup called", correlationId);
        return this.acquireTokenPopup(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({ correlationId: correlationId }, (request || __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["h" /* DEFAULT_REQUEST */])));
    };
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */
    PublicClientApplication.prototype.acquireTokenSilent = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var correlationId, atsMeasurement, account, thumbprint, silentRequestKey, cachedResponse, response;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                correlationId = this.getRequestCorrelationId(request);
                atsMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenSilent, correlationId);
                atsMeasurement.addStaticFields({
                    cacheLookupPolicy: request.cacheLookupPolicy
                });
                this.preflightBrowserEnvironmentCheck(__WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["l" /* InteractionType */].Silent);
                this.logger.verbose("acquireTokenSilent called", correlationId);
                account = request.account || this.getActiveAccount();
                if (!account) {
                    throw __WEBPACK_IMPORTED_MODULE_5__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNoAccountError();
                }
                thumbprint = {
                    clientId: this.config.auth.clientId,
                    authority: request.authority || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
                    scopes: request.scopes,
                    homeAccountIdentifier: account.homeAccountId,
                    claims: request.claims,
                    authenticationScheme: request.authenticationScheme,
                    resourceRequestMethod: request.resourceRequestMethod,
                    resourceRequestUri: request.resourceRequestUri,
                    shrClaims: request.shrClaims,
                    sshKid: request.sshKid
                };
                silentRequestKey = JSON.stringify(thumbprint);
                cachedResponse = this.activeSilentTokenRequests.get(silentRequestKey);
                if (typeof cachedResponse === "undefined") {
                    this.logger.verbose("acquireTokenSilent called for the first time, storing active request", correlationId);
                    this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenSilentAsync, correlationId);
                    response = this.acquireTokenSilentAsync(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request), { correlationId: correlationId }), account)
                        .then(function (result) {
                        _this.activeSilentTokenRequests.delete(silentRequestKey);
                        atsMeasurement.addStaticFields({
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length
                        });
                        atsMeasurement.endMeasurement({
                            success: true,
                            fromCache: result.fromCache,
                            isNativeBroker: result.fromNativeBroker,
                            cacheLookupPolicy: request.cacheLookupPolicy,
                            requestId: result.requestId,
                        });
                        return result;
                    })
                        .catch(function (error) {
                        _this.activeSilentTokenRequests.delete(silentRequestKey);
                        atsMeasurement.endMeasurement({
                            errorCode: error.errorCode,
                            subErrorCode: error.subError,
                            success: false
                        });
                        throw error;
                    });
                    this.activeSilentTokenRequests.set(silentRequestKey, response);
                    return [2 /*return*/, response];
                }
                else {
                    this.logger.verbose("acquireTokenSilent has been called previously, returning the result from the first call", correlationId);
                    // Discard measurements for memoized calls, as they are usually only a couple of ms and will artificially deflate metrics
                    atsMeasurement.discardMeasurement();
                    return [2 /*return*/, cachedResponse];
                }
            });
        });
    };
    PublicClientApplication.prototype.trackPageVisibility = function () {
        if (!this.astsAsyncMeasurement) {
            return;
        }
        this.logger.info("Perf: Visibility change detected");
        this.astsAsyncMeasurement.increment({
            visibilityChangeCount: 1,
        });
    };
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */
    PublicClientApplication.prototype.acquireTokenSilentAsync = function (request, account) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var result, silentRequest, silentCacheClient, silentRequest_1, requestWithCLP_1;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenSilentAsync, request.correlationId);
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_4__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_START, __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, request);
                        this.astsAsyncMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenSilentAsync, request.correlationId);
                        (_a = this.astsAsyncMeasurement) === null || _a === void 0 ? void 0 : _a.increment({
                            visibilityChangeCount: 0
                        });
                        document.addEventListener("visibilitychange", this.trackPageVisibility);
                        if (!(__WEBPACK_IMPORTED_MODULE_7__broker_nativeBroker_NativeMessageHandler_js__["a" /* NativeMessageHandler */].isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, request.authenticationScheme) && account.nativeAccountId)) return [3 /*break*/, 1];
                        this.logger.verbose("acquireTokenSilent - attempting to acquire token from native platform");
                        silentRequest = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request), { account: account });
                        result = this.acquireTokenNative(silentRequest, __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenSilent_silentFlow).catch(function (e) { return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(_this, void 0, void 0, function () {
                            var silentIframeClient;
                            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                                // If native token acquisition fails for availability reasons fallback to web flow
                                if (e instanceof __WEBPACK_IMPORTED_MODULE_6__error_NativeAuthError_js__["a" /* NativeAuthError */] && e.isFatal()) {
                                    this.logger.verbose("acquireTokenSilent - native platform unavailable, falling back to web flow");
                                    this.nativeExtensionProvider = undefined; // Prevent future requests from continuing to attempt
                                    silentIframeClient = this.createSilentIframeClient(request.correlationId);
                                    return [2 /*return*/, silentIframeClient.acquireToken(request)];
                                }
                                throw e;
                            });
                        }); });
                        return [3 /*break*/, 3];
                    case 1:
                        this.logger.verbose("acquireTokenSilent - attempting to acquire token from web flow");
                        silentCacheClient = this.createSilentCacheClient(request.correlationId);
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].InitializeSilentRequest, request.correlationId);
                        return [4 /*yield*/, silentCacheClient.initializeSilentRequest(request, account)];
                    case 2:
                        silentRequest_1 = _b.sent();
                        requestWithCLP_1 = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request), { 
                            // set the request's CacheLookupPolicy to Default if it was not optionally passed in
                            cacheLookupPolicy: request.cacheLookupPolicy || __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].Default });
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenFromCache, silentRequest_1.correlationId);
                        result = this.acquireTokenFromCache(silentCacheClient, silentRequest_1, requestWithCLP_1).catch(function (cacheError) {
                            if (requestWithCLP_1.cacheLookupPolicy === __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].AccessToken) {
                                throw cacheError;
                            }
                            // block the reload if it occurred inside a hidden iframe
                            __WEBPACK_IMPORTED_MODULE_8__utils_BrowserUtils_js__["a" /* BrowserUtils */].blockReloadInHiddenIframes();
                            _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_4__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_NETWORK_START, __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, silentRequest_1);
                            _this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenByRefreshToken, silentRequest_1.correlationId);
                            return _this.acquireTokenByRefreshToken(silentRequest_1, requestWithCLP_1).catch(function (refreshTokenError) {
                                var isServerError = refreshTokenError instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["S" /* ServerError */];
                                var isInteractionRequiredError = refreshTokenError instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["B" /* InteractionRequiredAuthError */];
                                var rtNotFound = (refreshTokenError.errorCode === __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["C" /* InteractionRequiredAuthErrorMessage */].noTokensFoundError.code);
                                var isInvalidGrantError = (refreshTokenError.errorCode === __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["c" /* BrowserConstants */].INVALID_GRANT_ERROR);
                                if ((!isServerError ||
                                    !isInvalidGrantError ||
                                    isInteractionRequiredError ||
                                    requestWithCLP_1.cacheLookupPolicy === __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].AccessTokenAndRefreshToken ||
                                    requestWithCLP_1.cacheLookupPolicy === __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].RefreshToken)
                                    && (requestWithCLP_1.cacheLookupPolicy !== __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].Skip)
                                    && !rtNotFound) {
                                    throw refreshTokenError;
                                }
                                _this.logger.verbose("Refresh token expired/invalid or CacheLookupPolicy is set to Skip, attempting acquire token by iframe.", request.correlationId);
                                _this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenBySilentIframe, silentRequest_1.correlationId);
                                return _this.acquireTokenBySilentIframe(silentRequest_1);
                            });
                        });
                        _b.label = 3;
                    case 3: return [2 /*return*/, result.then(function (response) {
                            var _a;
                            _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_4__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_SUCCESS, __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, response);
                            (_a = _this.astsAsyncMeasurement) === null || _a === void 0 ? void 0 : _a.endMeasurement({
                                success: true,
                                fromCache: response.fromCache,
                                isNativeBroker: response.fromNativeBroker,
                                requestId: response.requestId
                            });
                            return response;
                        }).catch(function (tokenRenewalError) {
                            var _a;
                            _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_4__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_FAILURE, __WEBPACK_IMPORTED_MODULE_2__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, null, tokenRenewalError);
                            (_a = _this.astsAsyncMeasurement) === null || _a === void 0 ? void 0 : _a.endMeasurement({
                                errorCode: tokenRenewalError.errorCode,
                                subErrorCode: tokenRenewalError.subError,
                                success: false
                            });
                            throw tokenRenewalError;
                        }).finally(function () {
                            document.removeEventListener("visibilitychange", _this.trackPageVisibility);
                        })];
                }
            });
        });
    };
    return PublicClientApplication;
}(__WEBPACK_IMPORTED_MODULE_3__ClientApplication_js__["a" /* ClientApplication */]));


//# sourceMappingURL=PublicClientApplication.js.map


/***/ }),
/* 2757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__crypto_CryptoOps_js__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cache_BrowserCacheManager_js__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_Configuration_js__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_BrowserUtils_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packageMetadata_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__event_EventType_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__error_BrowserConfigurationAuthError_js__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__event_EventHandler_js__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__interaction_client_PopupClient_js__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__interaction_client_RedirectClient_js__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__interaction_client_SilentIframeClient_js__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__interaction_client_SilentRefreshClient_js__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__cache_TokenCache_js__ = __webpack_require__(2758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__interaction_client_NativeInteractionClient_js__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__broker_nativeBroker_NativeMessageHandler_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__error_NativeAuthError_js__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__interaction_client_SilentCacheClient_js__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__interaction_client_SilentAuthCodeClient_js__ = __webpack_require__(2759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__telemetry_BrowserPerformanceClient_js__ = __webpack_require__(1132);
/*! @azure/msal-browser v2.38.3 2023-10-27 */

























/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var ClientApplication = /** @class */ (function () {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */
    function ClientApplication(configuration) {
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */
        this.isBrowserEnvironment = typeof window !== "undefined";
        // Set the configuration.
        this.config = Object(__WEBPACK_IMPORTED_MODULE_4__config_Configuration_js__["b" /* buildConfiguration */])(configuration, this.isBrowserEnvironment);
        this.initialized = false;
        // Initialize logger
        this.logger = new __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["F" /* Logger */](this.config.system.loggerOptions, __WEBPACK_IMPORTED_MODULE_7__packageMetadata_js__["a" /* name */], __WEBPACK_IMPORTED_MODULE_7__packageMetadata_js__["b" /* version */]);
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.isBrowserEnvironment ?
            new __WEBPACK_IMPORTED_MODULE_22__telemetry_BrowserPerformanceClient_js__["a" /* BrowserPerformanceClient */](this.config.auth.clientId, this.config.auth.authority, this.logger, __WEBPACK_IMPORTED_MODULE_7__packageMetadata_js__["a" /* name */], __WEBPACK_IMPORTED_MODULE_7__packageMetadata_js__["b" /* version */], this.config.telemetry.application, this.config.system.cryptoOptions) :
            new __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["X" /* StubPerformanceClient */](this.config.auth.clientId, this.config.auth.authority, this.logger, __WEBPACK_IMPORTED_MODULE_7__packageMetadata_js__["a" /* name */], __WEBPACK_IMPORTED_MODULE_7__packageMetadata_js__["b" /* version */], this.config.telemetry.application);
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new __WEBPACK_IMPORTED_MODULE_1__crypto_CryptoOps_js__["a" /* CryptoOps */](this.logger, this.performanceClient, this.config.system.cryptoOptions) : __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["x" /* DEFAULT_CRYPTO_IMPLEMENTATION */];
        this.eventHandler = new __WEBPACK_IMPORTED_MODULE_10__event_EventHandler_js__["a" /* EventHandler */](this.logger, this.browserCrypto);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ?
            new __WEBPACK_IMPORTED_MODULE_3__cache_BrowserCacheManager_js__["a" /* BrowserCacheManager */](this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger) :
            Object(__WEBPACK_IMPORTED_MODULE_3__cache_BrowserCacheManager_js__["b" /* DEFAULT_BROWSER_CACHE_MANAGER */])(this.config.auth.clientId, this.logger);
        // initialize in memory storage for native flows
        var nativeCacheOptions = {
            cacheLocation: __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].MemoryStorage,
            temporaryCacheLocation: __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].MemoryStorage,
            storeAuthStateInCookie: false,
            secureCookies: false,
            cacheMigrationEnabled: false,
            claimsBasedCachingEnabled: true
        };
        this.nativeInternalStorage = new __WEBPACK_IMPORTED_MODULE_3__cache_BrowserCacheManager_js__["a" /* BrowserCacheManager */](this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger);
        // Initialize the token cache
        this.tokenCache = new __WEBPACK_IMPORTED_MODULE_15__cache_TokenCache_js__["a" /* TokenCache */](this.config, this.browserStorage, this.logger, this.browserCrypto);
        // Register listener functions
        this.trackPageVisibilityWithMeasurement = this.trackPageVisibilityWithMeasurement.bind(this);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     */
    ClientApplication.prototype.initialize = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var allowNativeBroker, initMeasurement, _a, e_1, claimsTokensRemovalMeasurement;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.trace("initialize called");
                        if (this.initialized) {
                            this.logger.info("initialize has already been called, exiting early.");
                            return [2 /*return*/];
                        }
                        allowNativeBroker = this.config.system.allowNativeBroker;
                        initMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].InitializeClientApplication);
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].INITIALIZE_START);
                        if (!allowNativeBroker) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_17__broker_nativeBroker_NativeMessageHandler_js__["a" /* NativeMessageHandler */].createProvider(this.logger, this.config.system.nativeBrokerHandshakeTimeout, this.performanceClient)];
                    case 2:
                        _a.nativeExtensionProvider = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.logger.verbose(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!this.config.cache.claimsBasedCachingEnabled) return [3 /*break*/, 6];
                        this.logger.verbose("Claims-based caching is disabled. Clearing the previous cache with claims");
                        claimsTokensRemovalMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].ClearTokensAndKeysWithClaims);
                        return [4 /*yield*/, this.browserStorage.clearTokensAndKeysWithClaims()];
                    case 5:
                        _b.sent();
                        claimsTokensRemovalMeasurement.endMeasurement({ success: true });
                        _b.label = 6;
                    case 6:
                        this.initialized = true;
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].INITIALIZE_END);
                        initMeasurement.endMeasurement({ allowNativeBroker: allowNativeBroker, success: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */
    ClientApplication.prototype.handleRedirectPromise = function (hash) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var loggedInAccounts, redirectResponseKey, response, request, redirectResponse, nativeClient, correlationId, redirectClient;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                this.logger.verbose("handleRedirectPromise called");
                // Block token acquisition before initialize has been called if native brokering is enabled
                __WEBPACK_IMPORTED_MODULE_6__utils_BrowserUtils_js__["a" /* BrowserUtils */].blockNativeBrokerCalledBeforeInitialized(this.config.system.allowNativeBroker, this.initialized);
                loggedInAccounts = this.getAllAccounts();
                if (this.isBrowserEnvironment) {
                    redirectResponseKey = hash || __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                    response = this.redirectResponse.get(redirectResponseKey);
                    if (typeof response === "undefined") {
                        this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].HANDLE_REDIRECT_START, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                        this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
                        request = this.browserStorage.getCachedNativeRequest();
                        redirectResponse = void 0;
                        if (request && __WEBPACK_IMPORTED_MODULE_17__broker_nativeBroker_NativeMessageHandler_js__["a" /* NativeMessageHandler */].isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider) && this.nativeExtensionProvider && !hash) {
                            this.logger.trace("handleRedirectPromise - acquiring token from native platform");
                            nativeClient = new __WEBPACK_IMPORTED_MODULE_16__interaction_client_NativeInteractionClient_js__["a" /* NativeInteractionClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["a" /* ApiId */].handleRedirectPromise, this.performanceClient, this.nativeExtensionProvider, request.accountId, this.nativeInternalStorage, request.correlationId);
                            redirectResponse = nativeClient.handleRedirectPromise();
                        }
                        else {
                            this.logger.trace("handleRedirectPromise - acquiring token from web flow");
                            correlationId = this.browserStorage.getTemporaryCache(__WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["q" /* TemporaryCacheKeys */].CORRELATION_ID, true) || __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
                            redirectClient = this.createRedirectClient(correlationId);
                            redirectResponse = redirectClient.handleRedirectPromise(hash);
                        }
                        response = redirectResponse.then(function (result) {
                            if (result) {
                                // Emit login event if number of accounts change
                                var isLoggingIn = loggedInAccounts.length < _this.getAllAccounts().length;
                                if (isLoggingIn) {
                                    _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].LOGIN_SUCCESS, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, result);
                                    _this.logger.verbose("handleRedirectResponse returned result, login success");
                                }
                                else {
                                    _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_SUCCESS, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, result);
                                    _this.logger.verbose("handleRedirectResponse returned result, acquire token success");
                                }
                            }
                            _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].HANDLE_REDIRECT_END, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                            return result;
                        }).catch(function (e) {
                            // Emit login event if there is an account
                            if (loggedInAccounts.length > 0) {
                                _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_FAILURE, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, null, e);
                            }
                            else {
                                _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].LOGIN_FAILURE, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, null, e);
                            }
                            _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].HANDLE_REDIRECT_END, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                            throw e;
                        });
                        this.redirectResponse.set(redirectResponseKey, response);
                    }
                    else {
                        this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
                    }
                    return [2 /*return*/, response];
                }
                this.logger.verbose("handleRedirectPromise returns null, not browser environment");
                return [2 /*return*/, null];
            });
        });
    };
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */
    ClientApplication.prototype.acquireTokenRedirect = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var correlationId, isLoggedIn, result, nativeClient, redirectClient;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                correlationId = this.getRequestCorrelationId(request);
                this.logger.verbose("acquireTokenRedirect called", correlationId);
                this.preflightBrowserEnvironmentCheck(__WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                isLoggedIn = this.getAllAccounts().length > 0;
                if (isLoggedIn) {
                    this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_START, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, request);
                }
                else {
                    this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].LOGIN_START, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, request);
                }
                if (this.nativeExtensionProvider && this.canUseNative(request)) {
                    nativeClient = new __WEBPACK_IMPORTED_MODULE_16__interaction_client_NativeInteractionClient_js__["a" /* NativeInteractionClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenRedirect, this.performanceClient, this.nativeExtensionProvider, this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
                    result = nativeClient.acquireTokenRedirect(request).catch(function (e) {
                        if (e instanceof __WEBPACK_IMPORTED_MODULE_18__error_NativeAuthError_js__["a" /* NativeAuthError */] && e.isFatal()) {
                            _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                            var redirectClient = _this.createRedirectClient(request.correlationId);
                            return redirectClient.acquireToken(request);
                        }
                        else if (e instanceof __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["B" /* InteractionRequiredAuthError */]) {
                            _this.logger.verbose("acquireTokenRedirect - Resolving interaction required error thrown by native broker by falling back to web flow");
                            var redirectClient = _this.createRedirectClient(request.correlationId);
                            return redirectClient.acquireToken(request);
                        }
                        _this.browserStorage.setInteractionInProgress(false);
                        throw e;
                    });
                }
                else {
                    redirectClient = this.createRedirectClient(request.correlationId);
                    result = redirectClient.acquireToken(request);
                }
                return [2 /*return*/, result.catch(function (e) {
                        // If logged in, emit acquire token events
                        if (isLoggedIn) {
                            _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_FAILURE, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, null, e);
                        }
                        else {
                            _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].LOGIN_FAILURE, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect, null, e);
                        }
                        throw e;
                    })];
            });
        });
    };
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    ClientApplication.prototype.acquireTokenPopup = function (request) {
        var _this = this;
        var correlationId = this.getRequestCorrelationId(request);
        var atPopupMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenPopup, correlationId);
        try {
            this.logger.verbose("acquireTokenPopup called", correlationId);
            this.preflightBrowserEnvironmentCheck(__WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Popup);
        }
        catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        var loggedInAccounts = this.getAllAccounts();
        if (loggedInAccounts.length > 0) {
            this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_START, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, request);
        }
        else {
            this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].LOGIN_START, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, request);
        }
        var result;
        if (this.canUseNative(request)) {
            result = this.acquireTokenNative(request, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenPopup).then(function (response) {
                _this.browserStorage.setInteractionInProgress(false);
                atPopupMeasurement.endMeasurement({
                    success: true,
                    isNativeBroker: true,
                    requestId: response.requestId
                });
                return response;
            }).catch(function (e) {
                if (e instanceof __WEBPACK_IMPORTED_MODULE_18__error_NativeAuthError_js__["a" /* NativeAuthError */] && e.isFatal()) {
                    _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                    var popupClient = _this.createPopupClient(request.correlationId);
                    return popupClient.acquireToken(request);
                }
                else if (e instanceof __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["B" /* InteractionRequiredAuthError */]) {
                    _this.logger.verbose("acquireTokenPopup - Resolving interaction required error thrown by native broker by falling back to web flow");
                    var popupClient = _this.createPopupClient(request.correlationId);
                    return popupClient.acquireToken(request);
                }
                _this.browserStorage.setInteractionInProgress(false);
                throw e;
            });
        }
        else {
            var popupClient = this.createPopupClient(request.correlationId);
            result = popupClient.acquireToken(request);
        }
        return result.then(function (result) {
            /*
             *  If logged in, emit acquire token events
             */
            var isLoggingIn = loggedInAccounts.length < _this.getAllAccounts().length;
            if (isLoggingIn) {
                _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].LOGIN_SUCCESS, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, result);
            }
            else {
                _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_SUCCESS, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, result);
            }
            atPopupMeasurement.addStaticFields({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.endMeasurement({
                success: true,
                requestId: result.requestId
            });
            return result;
        }).catch(function (e) {
            if (loggedInAccounts.length > 0) {
                _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_FAILURE, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, null, e);
            }
            else {
                _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].LOGIN_FAILURE, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Popup, null, e);
            }
            atPopupMeasurement.endMeasurement({
                errorCode: e.errorCode,
                subErrorCode: e.subError,
                success: false
            });
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        });
    };
    ClientApplication.prototype.trackPageVisibilityWithMeasurement = function () {
        var measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) {
            return;
        }
        this.logger.info("Perf: Visibility change detected in ", measurement.event.name);
        measurement.increment({
            visibilityChangeCount: 1,
        });
    };
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    ClientApplication.prototype.ssoSilent = function (request) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var correlationId, validRequest, result, silentIframeClient;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                correlationId = this.getRequestCorrelationId(request);
                validRequest = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request), { 
                    // will be PromptValue.NONE or PromptValue.NO_SESSION
                    prompt: request.prompt, correlationId: correlationId });
                this.preflightBrowserEnvironmentCheck(__WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Silent);
                this.ssoSilentMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].SsoSilent, correlationId);
                (_a = this.ssoSilentMeasurement) === null || _a === void 0 ? void 0 : _a.increment({
                    visibilityChangeCount: 0
                });
                document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
                this.logger.verbose("ssoSilent called", correlationId);
                this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].SSO_SILENT_START, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, validRequest);
                if (this.canUseNative(validRequest)) {
                    result = this.acquireTokenNative(validRequest, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["a" /* ApiId */].ssoSilent).catch(function (e) {
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof __WEBPACK_IMPORTED_MODULE_18__error_NativeAuthError_js__["a" /* NativeAuthError */] && e.isFatal()) {
                            _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                            var silentIframeClient = _this.createSilentIframeClient(validRequest.correlationId);
                            return silentIframeClient.acquireToken(validRequest);
                        }
                        throw e;
                    });
                }
                else {
                    silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                    result = silentIframeClient.acquireToken(validRequest);
                }
                return [2 /*return*/, result.then(function (response) {
                        var _a, _b;
                        _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].SSO_SILENT_SUCCESS, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, response);
                        (_a = _this.ssoSilentMeasurement) === null || _a === void 0 ? void 0 : _a.addStaticFields({
                            accessTokenSize: response.accessToken.length,
                            idTokenSize: response.idToken.length
                        });
                        (_b = _this.ssoSilentMeasurement) === null || _b === void 0 ? void 0 : _b.endMeasurement({
                            success: true,
                            isNativeBroker: response.fromNativeBroker,
                            requestId: response.requestId
                        });
                        return response;
                    }).catch(function (e) {
                        var _a;
                        _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].SSO_SILENT_FAILURE, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, null, e);
                        (_a = _this.ssoSilentMeasurement) === null || _a === void 0 ? void 0 : _a.endMeasurement({
                            errorCode: e.errorCode,
                            subErrorCode: e.subError,
                            success: false
                        });
                        throw e;
                    }).finally(function () {
                        document.removeEventListener("visibilitychange", _this.trackPageVisibilityWithMeasurement);
                    })];
            });
        });
    };
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */
    ClientApplication.prototype.acquireTokenByCode = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var correlationId, atbcMeasurement, hybridAuthCode_1, response;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                correlationId = this.getRequestCorrelationId(request);
                this.preflightBrowserEnvironmentCheck(__WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Silent);
                this.logger.trace("acquireTokenByCode called", correlationId);
                this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_BY_CODE_START, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, request);
                atbcMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenByCode, request.correlationId);
                try {
                    if (request.code && request.nativeAccountId) {
                        // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
                        throw __WEBPACK_IMPORTED_MODULE_21__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createSpaCodeAndNativeAccountIdPresentError();
                    }
                    else if (request.code) {
                        hybridAuthCode_1 = request.code;
                        response = this.hybridAuthCodeResponses.get(hybridAuthCode_1);
                        if (!response) {
                            this.logger.verbose("Initiating new acquireTokenByCode request", correlationId);
                            response = this.acquireTokenByCodeAsync(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, request), { correlationId: correlationId }))
                                .then(function (result) {
                                _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_BY_CODE_SUCCESS, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, result);
                                _this.hybridAuthCodeResponses.delete(hybridAuthCode_1);
                                atbcMeasurement.addStaticFields({
                                    accessTokenSize: result.accessToken.length,
                                    idTokenSize: result.idToken.length
                                });
                                atbcMeasurement.endMeasurement({
                                    success: true,
                                    isNativeBroker: result.fromNativeBroker,
                                    requestId: result.requestId
                                });
                                return result;
                            })
                                .catch(function (error) {
                                _this.hybridAuthCodeResponses.delete(hybridAuthCode_1);
                                _this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_BY_CODE_FAILURE, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, null, error);
                                atbcMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            });
                            this.hybridAuthCodeResponses.set(hybridAuthCode_1, response);
                        }
                        else {
                            this.logger.verbose("Existing acquireTokenByCode request found", request.correlationId);
                            atbcMeasurement.discardMeasurement();
                        }
                        return [2 /*return*/, response];
                    }
                    else if (request.nativeAccountId) {
                        if (this.canUseNative(request, request.nativeAccountId)) {
                            return [2 /*return*/, this.acquireTokenNative(request, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenByCode, request.nativeAccountId).catch(function (e) {
                                    // If native token acquisition fails for availability reasons fallback to standard flow
                                    if (e instanceof __WEBPACK_IMPORTED_MODULE_18__error_NativeAuthError_js__["a" /* NativeAuthError */] && e.isFatal()) {
                                        _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                                    }
                                    throw e;
                                })];
                        }
                        else {
                            throw __WEBPACK_IMPORTED_MODULE_21__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToAcquireTokenFromNativePlatformError();
                        }
                    }
                    else {
                        throw __WEBPACK_IMPORTED_MODULE_21__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createAuthCodeOrNativeAccountIdRequiredError();
                    }
                }
                catch (e) {
                    this.eventHandler.emitEvent(__WEBPACK_IMPORTED_MODULE_8__event_EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_BY_CODE_FAILURE, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Silent, null, e);
                    atbcMeasurement.endMeasurement({
                        errorCode: e instanceof __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["d" /* AuthError */] && e.errorCode || undefined,
                        subErrorCode: e instanceof __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["d" /* AuthError */] && e.subError || undefined,
                        success: false
                    });
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */
    ClientApplication.prototype.acquireTokenByCodeAsync = function (request) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var silentAuthCodeClient, silentTokenResult;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.trace("acquireTokenByCodeAsync called", request.correlationId);
                        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenByCodeAsync, request.correlationId);
                        (_a = this.acquireTokenByCodeAsyncMeasurement) === null || _a === void 0 ? void 0 : _a.increment({
                            visibilityChangeCount: 0
                        });
                        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
                        silentAuthCodeClient = this.createSilentAuthCodeClient(request.correlationId);
                        return [4 /*yield*/, silentAuthCodeClient.acquireToken(request).then(function (response) {
                                var _a;
                                (_a = _this.acquireTokenByCodeAsyncMeasurement) === null || _a === void 0 ? void 0 : _a.endMeasurement({
                                    success: true,
                                    fromCache: response.fromCache,
                                    isNativeBroker: response.fromNativeBroker,
                                    requestId: response.requestId
                                });
                                return response;
                            }).catch(function (tokenRenewalError) {
                                var _a;
                                (_a = _this.acquireTokenByCodeAsyncMeasurement) === null || _a === void 0 ? void 0 : _a.endMeasurement({
                                    errorCode: tokenRenewalError.errorCode,
                                    subErrorCode: tokenRenewalError.subError,
                                    success: false
                                });
                                throw tokenRenewalError;
                            }).finally(function () {
                                document.removeEventListener("visibilitychange", _this.trackPageVisibilityWithMeasurement);
                            })];
                    case 1:
                        silentTokenResult = _b.sent();
                        return [2 /*return*/, silentTokenResult];
                }
            });
        });
    };
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */
    ClientApplication.prototype.acquireTokenFromCache = function (silentCacheClient, commonRequest, silentRequest) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenFromCache, commonRequest.correlationId);
                switch (silentRequest.cacheLookupPolicy) {
                    case __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].Default:
                    case __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].AccessToken:
                    case __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].AccessTokenAndRefreshToken:
                        return [2 /*return*/, silentCacheClient.acquireToken(commonRequest)];
                    default:
                        throw __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["r" /* ClientAuthError */].createRefreshRequiredError();
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */
    ClientApplication.prototype.acquireTokenByRefreshToken = function (commonRequest, silentRequest) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var silentRefreshClient;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenByRefreshToken, commonRequest.correlationId);
                switch (silentRequest.cacheLookupPolicy) {
                    case __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].Default:
                    case __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].AccessTokenAndRefreshToken:
                    case __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].RefreshToken:
                    case __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["d" /* CacheLookupPolicy */].RefreshTokenAndNetwork:
                        silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].SilentRefreshClientAcquireToken, commonRequest.correlationId);
                        return [2 /*return*/, silentRefreshClient.acquireToken(commonRequest)];
                    default:
                        throw __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["r" /* ClientAuthError */].createRefreshRequiredError();
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */
    ClientApplication.prototype.acquireTokenBySilentIframe = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var silentIframeClient;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                this.performanceClient.addQueueMeasurement(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].AcquireTokenBySilentIframe, request.correlationId);
                silentIframeClient = this.createSilentIframeClient(request.correlationId);
                this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["I" /* PerformanceEvents */].SilentIframeClientAcquireToken, request.correlationId);
                return [2 /*return*/, silentIframeClient.acquireToken(request)];
            });
        });
    };
    // #endregion
    // #region Logout
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */
    ClientApplication.prototype.logout = function (logoutRequest) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var correlationId;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                correlationId = this.getRequestCorrelationId(logoutRequest);
                this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.", correlationId);
                return [2 /*return*/, this.logoutRedirect(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({ correlationId: correlationId }, logoutRequest))];
            });
        });
    };
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */
    ClientApplication.prototype.logoutRedirect = function (logoutRequest) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var correlationId, redirectClient;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                correlationId = this.getRequestCorrelationId(logoutRequest);
                this.preflightBrowserEnvironmentCheck(__WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect);
                redirectClient = this.createRedirectClient(correlationId);
                return [2 /*return*/, redirectClient.logout(logoutRequest)];
            });
        });
    };
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */
    ClientApplication.prototype.logoutPopup = function (logoutRequest) {
        try {
            var correlationId = this.getRequestCorrelationId(logoutRequest);
            this.preflightBrowserEnvironmentCheck(__WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Popup);
            var popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest);
        }
        catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    };
    // #endregion
    // #region Account APIs
    /**
     * Returns all accounts that MSAL currently has data for.
     * (the account object is created at the time of successful login)
     * or empty array when no accounts are found
     * @returns Array of account objects in cache
     */
    ClientApplication.prototype.getAllAccounts = function () {
        this.logger.verbose("getAllAccounts called");
        return this.isBrowserEnvironment ? this.browserStorage.getAllAccounts() : [];
    };
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */
    ClientApplication.prototype.getAccountByUsername = function (username) {
        this.logger.trace("getAccountByUsername called");
        if (!username) {
            this.logger.warning("getAccountByUsername: No username provided");
            return null;
        }
        var account = this.browserStorage.getAccountInfoFilteredBy({ username: username });
        if (account) {
            this.logger.verbose("getAccountByUsername: Account matching username found, returning");
            this.logger.verbosePii("getAccountByUsername: Returning signed-in accounts matching username: " + username);
            return account;
        }
        else {
            this.logger.verbose("getAccountByUsername: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */
    ClientApplication.prototype.getAccountByHomeId = function (homeAccountId) {
        this.logger.trace("getAccountByHomeId called");
        if (!homeAccountId) {
            this.logger.warning("getAccountByHomeId: No homeAccountId provided");
            return null;
        }
        var account = this.browserStorage.getAccountInfoFilteredBy({ homeAccountId: homeAccountId });
        if (account) {
            this.logger.verbose("getAccountByHomeId: Account matching homeAccountId found, returning");
            this.logger.verbosePii("getAccountByHomeId: Returning signed-in accounts matching homeAccountId: " + homeAccountId);
            return account;
        }
        else {
            this.logger.verbose("getAccountByHomeId: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */
    ClientApplication.prototype.getAccountByLocalId = function (localAccountId) {
        this.logger.trace("getAccountByLocalId called");
        if (!localAccountId) {
            this.logger.warning("getAccountByLocalId: No localAccountId provided");
            return null;
        }
        var account = this.browserStorage.getAccountInfoFilteredBy({ localAccountId: localAccountId });
        if (account) {
            this.logger.verbose("getAccountByLocalId: Account matching localAccountId found, returning");
            this.logger.verbosePii("getAccountByLocalId: Returning signed-in accounts matching localAccountId: " + localAccountId);
            return account;
        }
        else {
            this.logger.verbose("getAccountByLocalId: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */
    ClientApplication.prototype.setActiveAccount = function (account) {
        this.browserStorage.setActiveAccount(account);
    };
    /**
     * Gets the currently active account
     */
    ClientApplication.prototype.getActiveAccount = function () {
        return this.browserStorage.getActiveAccount();
    };
    // #endregion
    // #region Helpers
    /**
     * Helper to validate app environment before making an auth request
     *
     * @protected
     * @param {InteractionType} interactionType What kind of interaction is being used
     * @param {boolean} [setInteractionInProgress=true] Whether to set interaction in progress temp cache flag
     */
    ClientApplication.prototype.preflightBrowserEnvironmentCheck = function (interactionType, setInteractionInProgress) {
        if (setInteractionInProgress === void 0) { setInteractionInProgress = true; }
        this.logger.verbose("preflightBrowserEnvironmentCheck started");
        // Block request if not in browser environment
        __WEBPACK_IMPORTED_MODULE_6__utils_BrowserUtils_js__["a" /* BrowserUtils */].blockNonBrowserEnvironment(this.isBrowserEnvironment);
        // Block redirects if in an iframe
        __WEBPACK_IMPORTED_MODULE_6__utils_BrowserUtils_js__["a" /* BrowserUtils */].blockRedirectInIframe(interactionType, this.config.system.allowRedirectInIframe);
        // Block auth requests inside a hidden iframe
        __WEBPACK_IMPORTED_MODULE_6__utils_BrowserUtils_js__["a" /* BrowserUtils */].blockReloadInHiddenIframes();
        // Block redirectUri opened in a popup from calling MSAL APIs
        __WEBPACK_IMPORTED_MODULE_6__utils_BrowserUtils_js__["a" /* BrowserUtils */].blockAcquireTokenInPopups();
        // Block token acquisition before initialize has been called if native brokering is enabled
        __WEBPACK_IMPORTED_MODULE_6__utils_BrowserUtils_js__["a" /* BrowserUtils */].blockNativeBrokerCalledBeforeInitialized(this.config.system.allowNativeBroker, this.initialized);
        // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
        if (interactionType === __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect &&
            this.config.cache.cacheLocation === __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["b" /* BrowserCacheLocation */].MemoryStorage &&
            !this.config.cache.storeAuthStateInCookie) {
            throw __WEBPACK_IMPORTED_MODULE_9__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createInMemoryRedirectUnavailableError();
        }
        if (interactionType === __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect || interactionType === __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["l" /* InteractionType */].Popup) {
            this.preflightInteractiveRequest(setInteractionInProgress);
        }
    };
    /**
     * Preflight check for interactive requests
     *
     * @protected
     * @param {boolean} setInteractionInProgress Whether to set interaction in progress temp cache flag
     */
    ClientApplication.prototype.preflightInteractiveRequest = function (setInteractionInProgress) {
        this.logger.verbose("preflightInteractiveRequest called, validating app environment");
        // block the reload if it occurred inside a hidden iframe
        __WEBPACK_IMPORTED_MODULE_6__utils_BrowserUtils_js__["a" /* BrowserUtils */].blockReloadInHiddenIframes();
        // Set interaction in progress temporary cache or throw if alread set.
        if (setInteractionInProgress) {
            this.browserStorage.setInteractionInProgress(true);
        }
    };
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */
    ClientApplication.prototype.acquireTokenNative = function (request, apiId, accountId) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var nativeClient;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                this.logger.trace("acquireTokenNative called");
                if (!this.nativeExtensionProvider) {
                    throw __WEBPACK_IMPORTED_MODULE_21__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createNativeConnectionNotEstablishedError();
                }
                nativeClient = new __WEBPACK_IMPORTED_MODULE_16__interaction_client_NativeInteractionClient_js__["a" /* NativeInteractionClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.nativeExtensionProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
                return [2 /*return*/, nativeClient.acquireToken(request)];
            });
        });
    };
    /**
     * Returns boolean indicating if this request can use the native broker
     * @param request
     */
    ClientApplication.prototype.canUseNative = function (request, accountId) {
        this.logger.trace("canUseNative called");
        if (!__WEBPACK_IMPORTED_MODULE_17__broker_nativeBroker_NativeMessageHandler_js__["a" /* NativeMessageHandler */].isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, request.authenticationScheme)) {
            this.logger.trace("canUseNative: isNativeAvailable returned false, returning false");
            return false;
        }
        if (request.prompt) {
            switch (request.prompt) {
                case __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["L" /* PromptValue */].NONE:
                case __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["L" /* PromptValue */].CONSENT:
                case __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["L" /* PromptValue */].LOGIN:
                    this.logger.trace("canUseNative: prompt is compatible with native flow");
                    break;
                default:
                    this.logger.trace("canUseNative: prompt = " + request.prompt + " is not compatible with native flow, returning false");
                    return false;
            }
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("canUseNative: nativeAccountId is not available, returning false");
            return false;
        }
        return true;
    };
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */
    ClientApplication.prototype.getNativeAccountId = function (request) {
        var account = request.account || this.browserStorage.getAccountInfoByHints(request.loginHint, request.sid) || this.getActiveAccount();
        return account && account.nativeAccountId || "";
    };
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */
    ClientApplication.prototype.createPopupClient = function (correlationId) {
        return new __WEBPACK_IMPORTED_MODULE_11__interaction_client_PopupClient_js__["a" /* PopupClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */
    ClientApplication.prototype.createRedirectClient = function (correlationId) {
        return new __WEBPACK_IMPORTED_MODULE_12__interaction_client_RedirectClient_js__["a" /* RedirectClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */
    ClientApplication.prototype.createSilentIframeClient = function (correlationId) {
        return new __WEBPACK_IMPORTED_MODULE_13__interaction_client_SilentIframeClient_js__["a" /* SilentIframeClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["a" /* ApiId */].ssoSilent, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */
    ClientApplication.prototype.createSilentCacheClient = function (correlationId) {
        return new __WEBPACK_IMPORTED_MODULE_19__interaction_client_SilentCacheClient_js__["a" /* SilentCacheClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */
    ClientApplication.prototype.createSilentRefreshClient = function (correlationId) {
        return new __WEBPACK_IMPORTED_MODULE_14__interaction_client_SilentRefreshClient_js__["a" /* SilentRefreshClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */
    ClientApplication.prototype.createSilentAuthCodeClient = function (correlationId) {
        return new __WEBPACK_IMPORTED_MODULE_20__interaction_client_SilentAuthCodeClient_js__["a" /* SilentAuthCodeClient */](this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, __WEBPACK_IMPORTED_MODULE_5__utils_BrowserConstants_js__["a" /* ApiId */].acquireTokenByCode, this.performanceClient, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Adds event callbacks to array
     * @param callback
     */
    ClientApplication.prototype.addEventCallback = function (callback) {
        return this.eventHandler.addEventCallback(callback);
    };
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */
    ClientApplication.prototype.removeEventCallback = function (callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    };
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */
    ClientApplication.prototype.addPerformanceCallback = function (callback) {
        return this.performanceClient.addPerformanceCallback(callback);
    };
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */
    ClientApplication.prototype.removePerformanceCallback = function (callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    };
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */
    ClientApplication.prototype.enableAccountStorageEvents = function () {
        this.eventHandler.enableAccountStorageEvents();
    };
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */
    ClientApplication.prototype.disableAccountStorageEvents = function () {
        this.eventHandler.disableAccountStorageEvents();
    };
    /**
     * Gets the token cache for the application.
     */
    ClientApplication.prototype.getTokenCache = function () {
        return this.tokenCache;
    };
    /**
     * Returns the logger instance
     */
    ClientApplication.prototype.getLogger = function () {
        return this.logger;
    };
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */
    ClientApplication.prototype.setLogger = function (logger) {
        this.logger = logger;
    };
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */
    ClientApplication.prototype.initializeWrapperLibrary = function (sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    };
    /**
     * Sets navigation client
     * @param navigationClient
     */
    ClientApplication.prototype.setNavigationClient = function (navigationClient) {
        this.navigationClient = navigationClient;
    };
    /**
     * Returns the configuration object
     */
    ClientApplication.prototype.getConfiguration = function () {
        return this.config;
    };
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */
    ClientApplication.prototype.getRequestCorrelationId = function (request) {
        if (request === null || request === void 0 ? void 0 : request.correlationId) {
            return request.correlationId;
        }
        if (this.isBrowserEnvironment) {
            return this.browserCrypto.createNewGuid();
        }
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */
        return __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
    };
    return ClientApplication;
}());


//# sourceMappingURL=ClientApplication.js.map


/***/ }),
/* 2758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__ = __webpack_require__(49);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Token cache manager
 */
var TokenCache = /** @class */ (function () {
    function TokenCache(configuration, storage, logger, cryptoObj) {
        this.isBrowserEnvironment = typeof window !== "undefined";
        this.config = configuration;
        this.storage = storage;
        this.logger = logger;
        this.cryptoObj = cryptoObj;
    }
    // Move getAllAccounts here and cache utility APIs
    /**
     * API to load tokens to msal-browser cache.
     * @param request
     * @param response
     * @param options
     * @returns `AuthenticationResult` for the response that was loaded.
     */
    TokenCache.prototype.loadExternalTokens = function (request, response, options) {
        this.logger.info("TokenCache - loadExternalTokens called");
        if (!response.id_token) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToLoadTokenError("Please ensure server response includes id token.");
        }
        var idToken = new __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["f" /* AuthToken */](response.id_token, this.cryptoObj);
        var cacheRecord;
        var authority;
        if (request.account) {
            var cacheRecordAccount = this.loadAccount(idToken, request.account.environment, undefined, undefined, request.account.homeAccountId);
            cacheRecord = new __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["p" /* CacheRecord */](cacheRecordAccount, this.loadIdToken(idToken, cacheRecordAccount.homeAccountId, request.account.environment, request.account.tenantId), this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, request.account.environment, request.account.tenantId, options), this.loadRefreshToken(request, response, cacheRecordAccount.homeAccountId, request.account.environment));
        }
        else if (request.authority) {
            var authorityUrl = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["i" /* Authority */].generateAuthority(request.authority, request.azureCloudOptions);
            var authorityOptions = {
                protocolMode: this.config.auth.protocolMode,
                knownAuthorities: this.config.auth.knownAuthorities,
                cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                authorityMetadata: this.config.auth.authorityMetadata,
                skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache,
            };
            authority = new __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["i" /* Authority */](authorityUrl, this.config.system.networkClient, this.storage, authorityOptions, this.logger);
            // "clientInfo" from options takes precedence over "clientInfo" in response
            if (options.clientInfo) {
                this.logger.trace("TokenCache - homeAccountId from options");
                var cacheRecordAccount = this.loadAccount(idToken, authority.hostnameAndPort, options.clientInfo, authority.authorityType);
                cacheRecord = new __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["p" /* CacheRecord */](cacheRecordAccount, this.loadIdToken(idToken, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant), this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant, options), this.loadRefreshToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort));
            }
            else if (response.client_info) {
                this.logger.trace("TokenCache - homeAccountId from response");
                var cacheRecordAccount = this.loadAccount(idToken, authority.hostnameAndPort, response.client_info, authority.authorityType);
                cacheRecord = new __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["p" /* CacheRecord */](cacheRecordAccount, this.loadIdToken(idToken, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant), this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant, options), this.loadRefreshToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort));
            }
            else {
                throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToLoadTokenError("Please provide clientInfo in the response or options.");
            }
        }
        else {
            throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToLoadTokenError("Please provide a request with an account or a request with authority.");
        }
        return this.generateAuthenticationResult(request, idToken, cacheRecord, authority);
    };
    /**
     * Helper function to load account to msal-browser cache
     * @param idToken
     * @param environment
     * @param clientInfo
     * @param authorityType
     * @param requestHomeAccountId
     * @returns `AccountEntity`
     */
    TokenCache.prototype.loadAccount = function (idToken, environment, clientInfo, authorityType, requestHomeAccountId) {
        var homeAccountId;
        if (requestHomeAccountId) {
            homeAccountId = requestHomeAccountId;
        }
        else if (authorityType !== undefined && clientInfo) {
            homeAccountId = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["b" /* AccountEntity */].generateHomeAccountId(clientInfo, authorityType, this.logger, this.cryptoObj, idToken);
        }
        if (!homeAccountId) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToLoadTokenError("Unexpected missing homeAccountId");
        }
        var accountEntity = clientInfo ?
            __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["b" /* AccountEntity */].createAccount(clientInfo, homeAccountId, idToken, undefined, undefined, undefined, environment) :
            __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["b" /* AccountEntity */].createGenericAccount(homeAccountId, idToken, undefined, undefined, undefined, environment);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading account");
            this.storage.setAccount(accountEntity);
            return accountEntity;
        }
        else {
            throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
        }
    };
    /**
     * Helper function to load id tokens to msal-browser cache
     * @param idToken
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `IdTokenEntity`
     */
    TokenCache.prototype.loadIdToken = function (idToken, homeAccountId, environment, tenantId) {
        var idTokenEntity = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["A" /* IdTokenEntity */].createIdTokenEntity(homeAccountId, environment, idToken.rawToken, this.config.auth.clientId, tenantId);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading id token");
            this.storage.setIdTokenCredential(idTokenEntity);
            return idTokenEntity;
        }
        else {
            throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
        }
    };
    /**
     * Helper function to load access tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `AccessTokenEntity`
     */
    TokenCache.prototype.loadAccessToken = function (request, response, homeAccountId, environment, tenantId, options) {
        if (!response.access_token) {
            this.logger.verbose("TokenCache - No access token provided for caching");
            return null;
        }
        if (!response.expires_in) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToLoadTokenError("Please ensure server response includes expires_in value.");
        }
        if (!options.extendedExpiresOn) {
            throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToLoadTokenError("Please provide an extendedExpiresOn value in the options.");
        }
        var scopes = new __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["R" /* ScopeSet */](request.scopes).printScopes();
        var expiresOn = options.expiresOn || (response.expires_in + new Date().getTime() / 1000);
        var extendedExpiresOn = options.extendedExpiresOn;
        var accessTokenEntity = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["a" /* AccessTokenEntity */].createAccessTokenEntity(homeAccountId, environment, response.access_token, this.config.auth.clientId, tenantId, scopes, expiresOn, extendedExpiresOn, this.cryptoObj);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading access token");
            this.storage.setAccessTokenCredential(accessTokenEntity);
            return accessTokenEntity;
        }
        else {
            throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
        }
    };
    /**
     * Helper function to load refresh tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @returns `RefreshTokenEntity`
     */
    TokenCache.prototype.loadRefreshToken = function (request, response, homeAccountId, environment) {
        if (!response.refresh_token) {
            this.logger.verbose("TokenCache - No refresh token provided for caching");
            return null;
        }
        var refreshTokenEntity = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["P" /* RefreshTokenEntity */].createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, this.config.auth.clientId);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading refresh token");
            this.storage.setRefreshTokenCredential(refreshTokenEntity);
            return refreshTokenEntity;
        }
        else {
            throw __WEBPACK_IMPORTED_MODULE_1__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
        }
    };
    /**
     * Helper function to generate an `AuthenticationResult` for the result.
     * @param request
     * @param idTokenObj
     * @param cacheRecord
     * @param authority
     * @returns `AuthenticationResult`
     */
    TokenCache.prototype.generateAuthenticationResult = function (request, idTokenObj, cacheRecord, authority) {
        var _a, _b, _c;
        var accessToken = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
        var responseScopes = [];
        var expiresOn = null;
        var extExpiresOn;
        if (cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.accessToken) {
            accessToken = cacheRecord.accessToken.secret;
            responseScopes = __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["R" /* ScopeSet */].fromString(cacheRecord.accessToken.target).asArray();
            expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
            extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
        }
        var uid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.oid) || (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.sub) || __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
        var tid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.tid) || __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING;
        return {
            authority: authority ? authority.canonicalAuthority : __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: (cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.account) ? cacheRecord.account.getAccountInfo() : null,
            idToken: idTokenObj ? idTokenObj.rawToken : __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
            idTokenClaims: idTokenObj ? idTokenObj.claims : {},
            accessToken: accessToken,
            fromCache: true,
            expiresOn: expiresOn,
            correlationId: request.correlationId || __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
            requestId: __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
            extExpiresOn: extExpiresOn,
            familyId: __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
            tokenType: ((_a = cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.accessToken) === null || _a === void 0 ? void 0 : _a.tokenType) || __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
            state: __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
            cloudGraphHostName: ((_b = cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.account) === null || _b === void 0 ? void 0 : _b.cloudGraphHostName) || __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
            msGraphHost: ((_c = cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.account) === null || _c === void 0 ? void 0 : _c.msGraphHost) || __WEBPACK_IMPORTED_MODULE_0__azure_msal_common__["v" /* Constants */].EMPTY_STRING,
            code: undefined,
            fromNativeBroker: false
        };
    };
    return TokenCache;
}());


//# sourceMappingURL=TokenCache.js.map


/***/ }),
/* 2759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SilentAuthCodeClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StandardInteractionClient_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interaction_handler_SilentHandler_js__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HybridSpaAuthorizationCodeClient_js__ = __webpack_require__(2760);
/*! @azure/msal-browser v2.38.3 2023-10-27 */









/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var SilentAuthCodeClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(SilentAuthCodeClient, _super);
    function SilentAuthCodeClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        _this.apiId = apiId;
        return _this;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */
    SilentAuthCodeClient.prototype.acquireToken = function (request) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var silentRequest, serverTelemetryManager, authCodeRequest, clientConfig, authClient, silentHandler, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.trace("SilentAuthCodeClient.acquireToken called");
                        // Auth code payload is required
                        if (!request.code) {
                            throw __WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createAuthCodeRequiredError();
                        }
                        // Create silent request
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [4 /*yield*/, this.initializeAuthorizationRequest(request, __WEBPACK_IMPORTED_MODULE_4__utils_BrowserConstants_js__["l" /* InteractionType */].Silent)];
                    case 1:
                        silentRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(silentRequest.state, silentRequest.nonce, silentRequest.authority, silentRequest.loginHint || __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["v" /* Constants */].EMPTY_STRING, silentRequest.account || null);
                        serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        authCodeRequest = Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["a" /* __assign */])({}, silentRequest), { code: request.code });
                        // Initialize the client
                        this.performanceClient.setPreQueueTime(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["I" /* PerformanceEvents */].StandardInteractionClientGetClientConfiguration, request.correlationId);
                        return [4 /*yield*/, this.getClientConfiguration(serverTelemetryManager, silentRequest.authority)];
                    case 3:
                        clientConfig = _a.sent();
                        authClient = new __WEBPACK_IMPORTED_MODULE_6__HybridSpaAuthorizationCodeClient_js__["a" /* HybridSpaAuthorizationCodeClient */](clientConfig);
                        this.logger.verbose("Auth code client created");
                        silentHandler = new __WEBPACK_IMPORTED_MODULE_5__interaction_handler_SilentHandler_js__["a" /* SilentHandler */](authClient, this.browserStorage, authCodeRequest, this.logger, this.config.system, this.performanceClient);
                        // Handle auth code parameters from request
                        return [2 /*return*/, silentHandler.handleCodeResponseFromServer({
                                code: request.code,
                                msgraph_host: request.msGraphHost,
                                cloud_graph_host_name: request.cloudGraphHostName,
                                cloud_instance_host_name: request.cloudInstanceHostName
                            }, silentRequest.state, authClient.authority, this.networkClient, false)];
                    case 4:
                        e_1 = _a.sent();
                        if (e_1 instanceof __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["d" /* AuthError */]) {
                            e_1.setCorrelationId(this.correlationId);
                        }
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(silentRequest.state);
                        throw e_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */
    SilentAuthCodeClient.prototype.logout = function () {
        // Synchronous so we must reject
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_3__error_BrowserAuthError_js__["a" /* BrowserAuthError */].createSilentLogoutUnsupportedError());
    };
    return SilentAuthCodeClient;
}(__WEBPACK_IMPORTED_MODULE_2__StandardInteractionClient_js__["a" /* StandardInteractionClient */]));


//# sourceMappingURL=SilentAuthCodeClient.js.map


/***/ }),
/* 2760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HybridSpaAuthorizationCodeClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azure_msal_common__ = __webpack_require__(31);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var HybridSpaAuthorizationCodeClient = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["c" /* __extends */])(HybridSpaAuthorizationCodeClient, _super);
    function HybridSpaAuthorizationCodeClient(config) {
        var _this = _super.call(this, config) || this;
        _this.includeRedirectUri = false;
        return _this;
    }
    return HybridSpaAuthorizationCodeClient;
}(__WEBPACK_IMPORTED_MODULE_1__azure_msal_common__["m" /* AuthorizationCodeClient */]));


//# sourceMappingURL=HybridSpaAuthorizationCodeClient.js.map


/***/ }),
/* 2761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stubbedPublicClientApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__ = __webpack_require__(296);
/*! @azure/msal-browser v2.38.3 2023-10-27 */



/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var stubbedPublicClientApplication = {
    initialize: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    acquireTokenPopup: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    acquireTokenRedirect: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    acquireTokenSilent: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    acquireTokenByCode: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    getAllAccounts: function () {
        return [];
    },
    getAccountByHomeId: function () {
        return null;
    },
    getAccountByUsername: function () {
        return null;
    },
    getAccountByLocalId: function () {
        return null;
    },
    handleRedirectPromise: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    loginPopup: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    loginRedirect: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    logout: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    logoutRedirect: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    logoutPopup: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    ssoSilent: function () {
        return Promise.reject(__WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError());
    },
    addEventCallback: function () {
        return null;
    },
    removeEventCallback: function () {
        return;
    },
    addPerformanceCallback: function () {
        return "";
    },
    removePerformanceCallback: function () {
        return false;
    },
    enableAccountStorageEvents: function () {
        return;
    },
    disableAccountStorageEvents: function () {
        return;
    },
    getTokenCache: function () {
        throw __WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError();
    },
    getLogger: function () {
        throw __WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError();
    },
    setLogger: function () {
        return;
    },
    setActiveAccount: function () {
        return;
    },
    getActiveAccount: function () {
        return null;
    },
    initializeWrapperLibrary: function () {
        return;
    },
    setNavigationClient: function () {
        return;
    },
    getConfiguration: function () {
        throw __WEBPACK_IMPORTED_MODULE_0__error_BrowserConfigurationAuthError_js__["a" /* BrowserConfigurationAuthError */].createStubPcaInstanceCalledError();
    }
};


//# sourceMappingURL=IPublicClientApplication.js.map


/***/ }),
/* 2762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventMessageUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventType_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__ = __webpack_require__(46);
/*! @azure/msal-browser v2.38.3 2023-10-27 */




/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var EventMessageUtils = /** @class */ (function () {
    function EventMessageUtils() {
    }
    /**
     * Gets interaction status from event message
     * @param message
     * @param currentStatus
     */
    EventMessageUtils.getInteractionStatusFromEvent = function (message, currentStatus) {
        switch (message.eventType) {
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].LOGIN_START:
                return __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].Login;
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].SSO_SILENT_START:
                return __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].SsoSilent;
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_START:
                if (message.interactionType === __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect || message.interactionType === __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["l" /* InteractionType */].Popup) {
                    return __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].AcquireToken;
                }
                break;
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].HANDLE_REDIRECT_START:
                return __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].HandleRedirect;
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].LOGOUT_START:
                return __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].Logout;
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].SSO_SILENT_SUCCESS:
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].SSO_SILENT_FAILURE:
                if (currentStatus && currentStatus !== __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].SsoSilent) {
                    // Prevent this event from clearing any status other than ssoSilent
                    break;
                }
                return __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].None;
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].LOGOUT_END:
                if (currentStatus && currentStatus !== __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].Logout) {
                    // Prevent this event from clearing any status other than logout
                    break;
                }
                return __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].None;
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].HANDLE_REDIRECT_END:
                if (currentStatus && currentStatus !== __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].HandleRedirect) {
                    // Prevent this event from clearing any status other than handleRedirect
                    break;
                }
                return __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].None;
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].LOGIN_SUCCESS:
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].LOGIN_FAILURE:
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_SUCCESS:
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].ACQUIRE_TOKEN_FAILURE:
            case __WEBPACK_IMPORTED_MODULE_0__EventType_js__["a" /* EventType */].RESTORE_FROM_BFCACHE:
                if (message.interactionType === __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["l" /* InteractionType */].Redirect || message.interactionType === __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["l" /* InteractionType */].Popup) {
                    if (currentStatus && currentStatus !== __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].Login && currentStatus !== __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].AcquireToken) {
                        // Prevent this event from clearing any status other than login or acquireToken
                        break;
                    }
                    return __WEBPACK_IMPORTED_MODULE_1__utils_BrowserConstants_js__["k" /* InteractionStatus */].None;
                }
                break;
        }
        return null;
    };
    return EventMessageUtils;
}());


//# sourceMappingURL=EventMessage.js.map


/***/ }),
/* 2763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SignedHttpRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CryptoOps_js__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packageMetadata_js__ = __webpack_require__(297);
/*! @azure/msal-browser v2.38.3 2023-10-27 */






/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var SignedHttpRequest = /** @class */ (function () {
    function SignedHttpRequest(shrParameters, shrOptions) {
        var loggerOptions = (shrOptions && shrOptions.loggerOptions) || {};
        this.logger = new __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["F" /* Logger */](loggerOptions, __WEBPACK_IMPORTED_MODULE_3__packageMetadata_js__["a" /* name */], __WEBPACK_IMPORTED_MODULE_3__packageMetadata_js__["b" /* version */]);
        this.cryptoOps = new __WEBPACK_IMPORTED_MODULE_1__CryptoOps_js__["a" /* CryptoOps */](this.logger);
        this.popTokenGenerator = new __WEBPACK_IMPORTED_MODULE_2__azure_msal_common__["K" /* PopTokenGenerator */](this.cryptoOps);
        this.shrParameters = shrParameters;
    }
    /**
     * Generates and caches a keypair for the given request options.
     * @returns Public key digest, which should be sent to the token issuer.
     */
    SignedHttpRequest.prototype.generatePublicKeyThumbprint = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var kid;
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.popTokenGenerator.generateKid(this.shrParameters)];
                    case 1:
                        kid = (_a.sent()).kid;
                        return [2 /*return*/, kid];
                }
            });
        });
    };
    /**
     * Generates a signed http request for the given payload with the given key.
     * @param payload Payload to sign (e.g. access token)
     * @param publicKeyThumbprint Public key digest (from generatePublicKeyThumbprint API)
     * @param claims Additional claims to include/override in the signed JWT
     * @returns Pop token signed with the corresponding private key
     */
    SignedHttpRequest.prototype.signRequest = function (payload, publicKeyThumbprint, claims) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, this.popTokenGenerator.signPayload(payload, publicKeyThumbprint, this.shrParameters, claims)];
            });
        });
    };
    /**
     * Removes cached keys from browser for given public key thumbprint
     * @param publicKeyThumbprint Public key digest (from generatePublicKeyThumbprint API)
     * @returns If keys are properly deleted
     */
    SignedHttpRequest.prototype.removeKeys = function (publicKeyThumbprint) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0__virtual_tslib_js__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cryptoOps.removeTokenBindingKey(publicKeyThumbprint)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SignedHttpRequest;
}());


//# sourceMappingURL=SignedHttpRequest.js.map


/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactI18next = __webpack_require__(2);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _pdfPreview = __webpack_require__(558);

var _pdfPreview2 = _interopRequireDefault(_pdfPreview);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _reactPdf = __webpack_require__(996);

var _i18n = __webpack_require__(173);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * src/web/components/pdf-preview-page.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * PDFファイル表示用コンポーネント
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

(0, _reactPdf.setOptions)({
  cMapUrl: '//cdn.jsdelivr.net/npm/pdfjs-dist@2.0.305/cmaps/',
  cMapPacked: true,
  workerSrc: '//cdn.jsdelivr.net/npm/pdfjs-dist@2.0.305/build/pdf.worker.js'
});

var MAX_PDF_PAGES = 50;
var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);

var styles = {
  errorContainer: {
    display: 'flex',
    fontSize: 12,
    overflow: 'auto'
  }
};

var PdfPreviewPage = function (_React$Component) {
  _inherits(PdfPreviewPage, _React$Component);

  function PdfPreviewPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PdfPreviewPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PdfPreviewPage.__proto__ || Object.getPrototypeOf(PdfPreviewPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      width: undefined,
      numPages: 0,
      scale: 1,
      isLoadError: false
    }, _this.onDocumentLoadSuccess = function (document) {
      _this.setState({ numPages: document.numPages, isLoadError: false });
    }, _this.onZoomIn = function () {
      var scale = _this.state.scale * 1.3;
      _this.setState({ scale: scale >= 3 ? 3 : scale });
    }, _this.onZoomOut = function () {
      var scale = _this.state.scale * 0.7;
      _this.setState({ scale: scale <= 1 ? 1 : scale });
    }, _this.onLoadError = function () {
      return _this.setState({ isLoadError: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PdfPreviewPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({ width: _reactDom2.default.findDOMNode(_this2.ref).clientWidth });
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          params = _props.params;

      var file = params.file;
      var numPages = this.state.numPages;

      var fontIconStyle = {
        fontSize: 18,
        position: 'absolute',
        left: _i18n2.default.language == 'ja' ? 210 : 255
      };
      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: file.name, icon: 'picture_as_pdf', ref: function ref(c) {
            return _this3.ref = c;
          },
          rightAction: [_react2.default.createElement(TooltipIconButton, { icon: 'open_in_new', href: file.file.url, target: '_blank', rel: 'noopener noreferrer', tooltip: t('label:別ウィンドウで表示') })],
          absoluteFooter: _react2.default.createElement(
            'nav',
            { className: _pdfPreview2.default.nav },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline' }, onClick: this.onZoomIn },
              _react2.default.createElement(TooltipIconButton, { className: _pdfPreview2.default.navCenter, icon: 'add_circle_outline', tooltip: t('label:拡大') })
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'inline' }, onClick: this.onZoomOut },
              _react2.default.createElement(TooltipIconButton, { className: _pdfPreview2.default.navCenter, icon: 'remove_circle_outline', tooltip: t('label:縮小') })
            )
          ) },
        this.state.isLoadError && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            null,
            t('error:画像の読み込みに失敗しました')
          ),
          _react2.default.createElement(
            'div',
            { style: styles.errorContainer },
            t('error:暗号化PDF説明'),
            _react2.default.createElement(_font_icon2.default, { value: 'open_in_new', style: fontIconStyle })
          )
        ),
        _react2.default.createElement(
          _reactPdf.Document,
          { file: file.file.url,
            error: _react2.default.createElement('div', null),
            loading: t('label:読み込み中'),
            onLoadSuccess: this.onDocumentLoadSuccess,
            onLoadError: this.onLoadError },
          Array.from(new Array(Math.min(numPages, MAX_PDF_PAGES)), function (el, index) {
            return _react2.default.createElement(_reactPdf.Page, { key: 'page_' + (index + 1), pageNumber: index + 1, width: _this3.state.width * _this3.state.scale });
          })
        ),
        numPages > MAX_PDF_PAGES && _react2.default.createElement(
          'div',
          { style: { padding: '0 10px', fontSize: '80%', marginBottom: '30px' } },
          t('label:MAXページまでを表示しています')
        )
      );
    }
  }]);

  return PdfPreviewPage;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)()(PdfPreviewPage);

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rightSidePage = __webpack_require__(72);

var _rightSidePage2 = _interopRequireDefault(_rightSidePage);

var _button = __webpack_require__(8);

var _reactI18next = __webpack_require__(2);

var _googleSigninProvider = __webpack_require__(200);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * src/web/components/google-doc-page.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Googleドキュメント表示用コンポーネント
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var GoogleDocPage = function (_React$Component) {
  _inherits(GoogleDocPage, _React$Component);

  function GoogleDocPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GoogleDocPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GoogleDocPage.__proto__ || Object.getPrototypeOf(GoogleDocPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      googleLogin: false
    }, _this.onGoogleSigninSuccess = function () {
      return _this.setState({ googleLogin: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GoogleDocPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          params = _props.params;


      return _react2.default.createElement(
        _rightSidePage2.default,
        { title: t('label:Googleドキュメント'), icon: 'insert_drive_file', scrolling: 'no',
          rightAction: [_react2.default.createElement(_button.IconButton, { icon: 'open_in_new', href: params.url, target: '_blank', rel: 'noopener noreferrer' })] },
        !this.state.googleLogin && _react2.default.createElement(_googleSigninProvider.GoogleLogin, { label: t('label:Googleドキュメントに接続'), onSuccess: this.onGoogleSigninSuccess }) || _react2.default.createElement('iframe', { style: { border: '0px', width: '100%', height: 'calc(100vh - 120px)' }, src: params.url })
      );
    }
  }]);

  return GoogleDocPage;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)()(GoogleDocPage);

/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDiaryForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _diaryForm = __webpack_require__(2767);

var _diaryForm2 = _interopRequireDefault(_diaryForm);

var _button = __webpack_require__(8);

var _card = __webpack_require__(28);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _input = __webpack_require__(59);

var _input2 = _interopRequireDefault(_input);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _diaryUploadFiles = __webpack_require__(569);

var _diaryUploadFiles2 = _interopRequireDefault(_diaryUploadFiles);

var _richTextEditor = __webpack_require__(181);

var _richTextEditor2 = _interopRequireDefault(_richTextEditor);

var _reportedDatePicker = __webpack_require__(2769);

var _reportedDatePicker2 = _interopRequireDefault(_reportedDatePicker);

var _diaryFormsKpiItem = __webpack_require__(2770);

var _diaryFormsKpiItem2 = _interopRequireDefault(_diaryFormsKpiItem);

var _fileUploadButton = __webpack_require__(180);

var _fileUploadButton2 = _interopRequireDefault(_fileUploadButton);

var _savedDiary = __webpack_require__(2771);

var _savedDiary2 = _interopRequireDefault(_savedDiary);

var _diaryUrlLinks = __webpack_require__(1091);

var _diaryUrlLinks2 = _interopRequireDefault(_diaryUrlLinks);

var _diaryFormsFields = __webpack_require__(2777);

var _diaryFormsFields2 = _interopRequireDefault(_diaryFormsFields);

var _confirmGoogleLogin = __webpack_require__(1092);

var _confirmGoogleLogin2 = _interopRequireDefault(_confirmGoogleLogin);

var _diaryFormButton = __webpack_require__(290);

var _diaryFormButton2 = _interopRequireDefault(_diaryFormButton);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _subjectInput = __webpack_require__(2780);

var _subjectInput2 = _interopRequireDefault(_subjectInput);

var _animationCss = __webpack_require__(184);

var _animationCss2 = _interopRequireDefault(_animationCss);

var _emojiHelpers = __webpack_require__(146);

var _formValidator = __webpack_require__(41);

var _draftSelectionDialog = __webpack_require__(2782);

var _draftSelectionDialog2 = _interopRequireDefault(_draftSelectionDialog);

var _reviewCard = __webpack_require__(1059);

var _reviewCard2 = _interopRequireDefault(_reviewCard);

var _store = __webpack_require__(18);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/diary-form.jsx

var POST_TYPES = [{ value: 'diary', icon: 'event_note' }, { value: 'kpi', icon: 'insert_chart' }, { value: 'memo', icon: 'assignment' }];
var teststring = '\u8A55\u4FA1: \u2B50\u2B50\u2B50\u2B50\u2606 4/5\n\n<p><strong>\u826F\u304B\u3063\u305F\u70B9:</strong></p>\n<p>\u4ECA\u65E5\u306E\u30BF\u30B9\u30AF\u3068\u305D\u306E\u6210\u679C\u304C\u660E\u78BA\u306B\u8A18\u8FF0\u3055\u308C\u3066\u304A\u308A\u3001\u65E5\u3005\u306E\u696D\u52D9\u9032\u6357\u304C\u5177\u4F53\u7684\u306B\u628A\u63E1\u3067\u304D\u307E\u3059\u3002</p>\n<p>\u6B21\u306E\u65E5\u306E\u4E88\u5B9A\u304C\u8A73\u7D30\u306B\u8A18\u8F09\u3055\u308C\u3066\u304A\u308A\u3001\u8A08\u753B\u7684\u306A\u696D\u52D9\u9042\u884C\u304C\u4F3A\u3048\u307E\u3059\u3002</p>\n<p>\u554F\u984C\u70B9\u304C\u6319\u3052\u3089\u308C\u3066\u304A\u308A\u3001\u8AB2\u984C\u3078\u306E\u610F\u8B58\u304C\u9AD8\u3044\u3053\u3068\u304C\u308F\u304B\u308A\u307E\u3059\u3002</p>\n<br/>\n<p><strong>\u6539\u5584\u70B9:</strong></p>\n<p>\u554F\u984C\u70B9\u306B\u5BFE\u3059\u308B\u6539\u5584\u7B56\u3084\u89E3\u6C7A\u65B9\u6CD5\u306E\u8A18\u8FF0\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059\u3002\u554F\u984C\u3092\u6307\u6458\u3059\u308B\u3060\u3051\u3067\u306A\u304F\u3001\u5177\u4F53\u7684\u306A\u89E3\u6C7A\u7B56\u3092\u691C\u8A0E\u3057\u307E\u3057\u3087\u3046\u3002</p>\n<p>\u65E5\u5831\u306E\u8A18\u8FF0\u304C\u4E00\u90E8\u7C21\u6F54\u3059\u304E\u308B\u7B87\u6240\u304C\u3042\u308A\u307E\u3059\u3002\u3082\u3046\u5C11\u3057\u8A73\u7D30\u306A\u60C5\u5831\u3092\u52A0\u3048\u308B\u3053\u3068\u3067\u3001\u65E5\u5831\u306E\u6709\u7528\u6027\u3092\u3055\u3089\u306B\u9AD8\u3081\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002</p>\n<p>\u30BF\u30B9\u30AF\u306E\u512A\u5148\u9806\u4F4D\u3084\u3001\u305D\u308C\u306B\u5BFE\u3059\u308B\u6642\u9593\u7BA1\u7406\u306E\u8A18\u8FF0\u304C\u898B\u3089\u308C\u307E\u305B\u3093\u3002\u52B9\u7387\u7684\u306A\u696D\u52D9\u9032\u884C\u306E\u305F\u3081\u306B\u306F\u3001\u3053\u308C\u3089\u306E\u60C5\u5831\u3082\u542B\u3081\u308B\u3068\u3088\u3044\u3067\u3057\u3087\u3046\u3002</p>\n<br/>\n<p><strong>gamba\u6D3B\u7528\u306E\u30D2\u30F3\u30C8:</strong></p>\n<p>AWS Lambda\u306E\u65B0\u6A5F\u80FD\u3001\u30EC\u30B9\u30DD\u30F3\u30B9\u30B9\u30C8\u30EA\u30FC\u30DF\u30F3\u30B0\u3092\u5229\u7528\u3057\u3066\u3001\u65E5\u5831\u306E\u5185\u5BB9\u3092\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u306B\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u3059\u308B\u30B7\u30B9\u30C6\u30E0\u3092\u69CB\u7BC9\u3057\u3066\u307F\u307E\u3057\u3087\u3046\u3002\u4F8B\u3048\u3070\u3001\u65E5\u5831\u306B\u8A18\u8F09\u3055\u308C\u305F\u30BF\u30B9\u30AF\u306E\u9032\u6357\u72B6\u6CC1\u3084\u554F\u984C\u70B9\u3092\u5206\u6790\u3057\u3001\u6539\u5584\u7B56\u3092\u81EA\u52D5\u7684\u306B\u63D0\u6848\u3059\u308BLambda\u95A2\u6570\u3092\u958B\u767A\u3059\u308B\u3053\u3068\u304C\u8003\u3048\u3089\u308C\u307E\u3059\u3002\u3053\u306E\u3088\u3046\u306A\u81EA\u52D5\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF\u30B7\u30B9\u30C6\u30E0\u3092\u5C0E\u5165\u3059\u308B\u3053\u3068\u3067\u3001\u65E5\u5831\u306E\u8CEA\u306E\u5411\u4E0A\u3068\u696D\u52D9\u52B9\u7387\u306E\u5411\u4E0A\u304C\u671F\u5F85\u3067\u304D\u307E\u3059\u3002</p>';

var DiaryForm = function (_PureComponent) {
  _inherits(DiaryForm, _PureComponent);

  function DiaryForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DiaryForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiaryForm.__proto__ || Object.getPrototypeOf(DiaryForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false, isReviewActive: false }, _this.validateAndSubmit = function (ev) {
      _this.props.ui.saveMessage && _this.props.updateUI({ saveMessage: false });
      _this.props.validateAndSubmit(_this.props, ev);
    }, _this.onEditorInitialized = function (editorHandlers) {
      return _this.props.updateUI({ editorHandlers: editorHandlers });
    }, _this.onTemplateSelect = function (name, attach_json, id) {
      if (id == 'last_diary') {
        if (attach_json && attach_json.category) {
          _this.props.onChangeCategory(attach_json.category, _this.props), _this.props.updateUI({ fields: attach_json ? attach_json.fields : [] });
        }
      } else if (attach_json && attach_json.category) {
        attach_json.category != 'memo' ? (_this.props.onChangeCategory(attach_json.category, _this.props), _this.props.updateUI({ fields: attach_json ? attach_json.fields : [] })) : (_this.props.onChangeCategory(attach_json.category, _this.props), _this.props.updateUI({ fields: attach_json ? attach_json.fields : [], subject: name }));
      } else {
        _this.props.updateUI({ fields: attach_json ? attach_json.fields : [], subject: name });
      }
    }, _this.onUpdateField = function (index, field) {
      return _this.props.onUpdateField(_this.props, index, field);
    }, _this.onCancel = function () {
      _this.props.ui.saveMessage && _this.props.updateUI({ saveMessage: false });
      _this.props.onCancel(_this.props);
    }, _this.onChangeDate = function (date) {
      return _this.props.updateUI({ reported_at: date });
    }, _this.onChangeEditor = function () {
      return _this.props.onChangeEditor(_this.props);
    }, _this.onFocus = function () {
      return _this.props.updateUI({ hasFocus: true });
    }, _this.onAddLink = function (link) {
      return _this.props.onAddLink(_this.props, link);
    }, _this.onDeleteLink = function (link) {
      return _this.props.onDeleteLink(_this.props, link);
    }, _this.onCancelConfirmGapi = function () {
      return _this.props.onCancelConfirmGapi(_this.props);
    }, _this.onSuccessConfirmGapi = function () {
      return _this.props.onSuccessConfirmGapi(_this.props);
    }, _this.onChangeCategory = function (category) {
      return _this.props.onChangeCategory(category, _this.props);
    }, _this.openDraftSelectionDialog = function () {
      return _this.setState({ active: true });
    }, _this.closeDraftSelectionDialog = function () {
      return _this.setState({ active: false });
    }, _this.showUserSelectionDialog = function () {
      return _this.props.showUserSelectionDialog(_this.props.t('label:読んでみての宛先を追加'), true, 'GROUP_MEMBERS_MENTION', _this.props.group && _this.props.group, _this.props.ui.mentions, function (users) {
        return _this.props.updateUI({
          mentions: (0, _store.mergeArray)('user_id', [], users)
        });
      });
    }, _this.onSendChatGPT = function () {
      _this.props.ui.editorHandlers && _this.props.ui.editorHandlers.getValue(function (content) {
        _this.props.askGpt(content);
      });
    }, _this.onOpenReview = function () {
      _this.props.setReviewTarget('form');
      _this.props.onOpenReview();
    }, _this.onChangeValue = function (ev, kpi, str) {
      var ev_value = isNaN(parseFloat(ev.target.value)) ? 0 : parseFloat(ev.target.value);
      if (str == 'actual') {
        if (typeof kpi.total != 'undefined') {
          _this.props.updateUI({
            values: Object.assign({}, _this.props.ui.values, _defineProperty({}, kpi.kpi_id, ev_value)),
            total_values: Object.assign({}, _this.props.ui.total_values, _defineProperty({}, kpi.kpi_id, kpi.total - kpi.actual + ev_value)),
            hasFocus: true
          });
        } else {
          _this.props.updateUI({
            values: Object.assign({}, _this.props.ui.values, _defineProperty({}, kpi.kpi_id, ev_value)),
            hasFocus: true
          });
        }
      } else {
        _this.props.updateUI({
          values: Object.assign({}, _this.props.ui.values, _defineProperty({}, kpi.kpi_id, ev_value - kpi.total + kpi.actual)),
          total_values: Object.assign({}, _this.props.ui.total_values, _defineProperty({}, kpi.kpi_id, ev_value)),
          hasFocus: true
        });
      }
    }, _this.handleKeyPress = function (ev) {
      // Check if the pressed key is 'Enter' and element is input tag
      if (ev.target.tagName.toLowerCase() == 'input' && ev.key == 'Enter') {
        // Prevent the default action to avoid form submission
        ev.preventDefault();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DiaryForm, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.savedDiaries && this.props.savedDiaries.length != 0 && (!nextProps.savedDiaries || nextProps.savedDiaries.length == 0)) {
        this.closeDraftSelectionDialog();
      }
      // 編集対象の投稿が読み込まれたタイミングでスクロールポジションを先頭に移動する
      // もしくは投稿を編集中に、別の投稿を編集しようとした場合もスクロールを先頭に移動させる
      if (!this.props.isEditDiaryFetching && nextProps.isEditDiaryFetching && (nextProps.current || nextProps.ui.hasFocus) || !this.props.current && nextProps.current) this.props.onScrollTop();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          group = _props.group,
          isPosting = _props.isPosting,
          isPostFailed = _props.isPostFailed,
          isSaving = _props.isSaving,
          isUploading = _props.isUploading,
          uploadedFiles = _props.uploadedFiles,
          uploadedVideos = _props.uploadedVideos,
          current = _props.current,
          templates = _props.templates,
          templateActions = _props.templateActions,
          savedDiaries = _props.savedDiaries,
          validateAndSubmit = _props.validateAndSubmit,
          uploadFiles = _props.uploadFiles,
          onChangeEditor = _props.onChangeEditor,
          onCancel = _props.onCancel,
          onWindowFocus = _props.onWindowFocus,
          openGoogleCalendarPage = _props.openGoogleCalendarPage,
          openGroupKPIPanel = _props.openGroupKPIPanel,
          updateUI = _props.updateUI,
          componentId = _props.componentId,
          kpi = _props.kpi,
          _showKpi = _props.showKpi,
          showGoogleDoc = _props.showGoogleDoc,
          showGambaUrl = _props.showGambaUrl,
          blinkEditForm = _props.blinkEditForm,
          onAddLink = _props.onAddLink,
          onDeleteLink = _props.onDeleteLink,
          urlLinks = _props.urlLinks,
          onCancelConfirmGapi = _props.onCancelConfirmGapi,
          onSuccessConfirmGapi = _props.onSuccessConfirmGapi,
          onUpdateField = _props.onUpdateField,
          socketStatus = _props.socketStatus,
          showUserSelectionDialog = _props.showUserSelectionDialog,
          chatGptReview = _props.chatGptReview,
          review = _props.review,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          reviewTarget = _props.reviewTarget,
          isReviewCompleted = _props.isReviewCompleted,
          isReviewEnable = _props.isReviewEnable;


      return _react2.default.createElement(
        'form',
        { onSubmit: this.validateAndSubmit, onKeyPress: this.handleKeyPress },
        _react2.default.createElement(_dropdown2.default, { auto: true, theme: _diaryFormButton2.default, source: POST_TYPES,
          disabled: current && current.status == 'committed',
          template: function template(item) {
            return _react2.default.createElement(
              'span',
              null,
              '\xA0',
              _react2.default.createElement(_font_icon2.default, { value: item.icon, style: { verticalAlign: 'bottom' } }),
              '\xA0',
              t('diary:' + item.value)
            );
          },
          value: ui.category,
          onChange: this.onChangeCategory }),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex' } },
          ui.category != 'memo' && _react2.default.createElement(_reportedDatePicker2.default, { category: ui.category,
            date: ui.reported_at,
            onChangeDate: this.onChangeDate }),
          ui.category == 'memo' && _react2.default.createElement(_input2.default, { theme: _subjectInput2.default,
            name: 'subject',
            type: 'text',
            required: true,
            hint: t('label:ノートのタイトル'),
            error: ui.subjectError && t('error:タイトルを入力してください'),
            value: (0, _emojiHelpers.convertEmojiChar)(ui.subject || ''),
            onChange: (0, _formValidator.linkUI)(this, 'subject') }),
          _react2.default.createElement(
            'div',
            { style: { marginLeft: 'auto', marginBottom: 4 } },
            savedDiaries && savedDiaries.length != 0 && _react2.default.createElement(_button.Button, { raised: true,
              className: ui.saveMessage ? _diaryFormButton2.default.save_button : '',
              theme: _diaryFormButton2.default,
              onClick: this.openDraftSelectionDialog,
              disabled: ui.hasFocus,
              icon: ui.saveMessage && _react2.default.createElement(_font_icon2.default, { value: 'check_circle', className: _diaryFormButton2.default.save_msg }),
              label: t('label:下書き', { count: savedDiaries.length }) }),
            _react2.default.createElement(_draftSelectionDialog2.default, { diaries: savedDiaries,
              active: this.state.active, group: group,
              onClose: this.closeDraftSelectionDialog, isEdit: current })
          )
        ),
        ui.category == 'kpi' && kpi && kpi.map(function (item) {
          return _react2.default.createElement(_diaryFormsKpiItem2.default, { key: item.kpi_id,
            kpi: item,
            showKpi: function showKpi() {
              return _showKpi(item.kpi_id);
            },
            onChange: _this2.onChangeValue,
            error: ui.values[item.kpi_id + 'Error'],
            value: ui.values[item.kpi_id],
            total_error: ui.total_values[item.kpi_id + 'Error'],
            total_value: ui.total_values[item.kpi_id] });
        }),
        ui.category == 'kpi' && (!kpi || kpi.length == 0) && _react2.default.createElement(
          'div',
          { style: { margin: '5px' } },
          t('label:KPIがありません')
        ),
        group.is_admin && ui.category == 'kpi' && _react2.default.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'column', marginBottom: '5px' } },
          _react2.default.createElement(_button.Button, { icon: 'add', theme: _successButton2.default, raised: true,
            label: t('label:KPIを作成'),
            onClick: openGroupKPIPanel })
        ),
        _react2.default.createElement(_richTextEditor2.default, {
          blinking: blinkEditForm,
          onEditorInitialized: this.onEditorInitialized,
          onChange: this.onChangeEditor,
          onFocus: this.onFocus,
          onTemplateSelect: this.onTemplateSelect,
          category: ui.category,
          templates: templates,
          templateActions: templateActions,
          showGoogleDoc: showGoogleDoc,
          showGambaUrl: showGambaUrl,
          onAddLink: this.onAddLink,
          onDrop: uploadFiles }),
        ui.contentError && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: _diaryFormButton2.default.error_msg },
            t('error:本文を入力してください')
          )
        ),
        _react2.default.createElement(_diaryFormsFields2.default, { fields: ui.fields, onUpdateField: this.onUpdateField }),
        _react2.default.createElement(_diaryUrlLinks2.default, { urlLinks: ui.urlLinks, onDeleteLink: this.onDeleteLink }),
        _react2.default.createElement(_diaryUploadFiles2.default, { componentId: componentId }),
        !ui.gapiReady && _react2.default.createElement(_confirmGoogleLogin2.default, { open: ui.confirmGapi, onClose: this.onCancelConfirmGapi, onSuccess: this.onSuccessConfirmGapi }),
        ui.hasFocus && this.props.isOpenReviewPanel && reviewTarget == 'form' && _react2.default.createElement(_reviewCard2.default, { t: t, onCloseReview: this.props.onCloseReview, isReviewCompleted: isReviewCompleted, onSendChatGPT: this.onSendChatGPT, review: review, isFetching: isFetching, isFetchFailed: isFetchFailed }),
        ui.hasFocus && _react2.default.createElement(
          'div',
          { style: { display: 'flex', marginBottom: '4px' } },
          _react2.default.createElement(_button.Button, {
            raised: !(ui.mentions && ui.mentions.length > 0),
            floating: ui.mentions && ui.mentions.length > 0,
            mini: ui.mentions && ui.mentions.length > 0,
            onClick: this.showUserSelectionDialog,
            icon: 'person_add',
            theme: _successButton2.default,
            label: !(ui.mentions && ui.mentions.length > 0) && t('label:読んでみての宛先を追加') }),
          ui.mentions && _lodash2.default.map(ui.mentions.slice(0, 5), function (mention, i) {
            return _react2.default.createElement(_avatar2.default, { image: mention.icon_image.thumb_url, style: { marginLeft: 2 } });
          }),
          ui.mentions && ui.mentions.length > 5 && _react2.default.createElement(_button.Button, {
            primary: true,
            onClick: this.showUserSelectionDialog,
            icon: 'arrow_forward',
            label: t('label:他n人', { n: ui.mentions.length - 5 }) + 'を' + t('label:すべて表示') })
        ),
        ui.hasFocus && socketStatus != 'connected' && _react2.default.createElement(
          'span',
          { className: _diaryFormButton2.default.error_msg },
          t('error:インターネット接続に問題があります')
        ),
        ui.hasFocus && ui.postError && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: _diaryFormButton2.default.error_msg },
            t('error:データの送信に失敗しました')
          )
        ),
        ui.hasFocus && _react2.default.createElement(
          'div',
          { style: { display: 'flex' } },
          _react2.default.createElement(_button.Button, _extends({ raised: true, primary: true
          }, (0, _animationCss2.default)(blinkEditForm), {
            theme: _diaryFormButton2.default,
            disabled: isPosting || isSaving || isUploading || ui.category == 'kpi' && (!kpi || kpi.length == 0),
            icon: 'send',
            type: 'submit',
            label: t('label:投稿') })),
          _react2.default.createElement(_button.Button, { raised: true,
            icon: 'auto_awesome',
            disabled: isFetching,
            theme: _diaryFormButton2.default,
            onClick: this.onOpenReview,
            label: 'AIレビュー' }),
          _react2.default.createElement(_fileUploadButton2.default, { raised: true,
            theme: _diaryFormButton2.default,
            icon: 'add_a_photo',
            onChange: uploadFiles,
            label: t('label:添付') }),
          _react2.default.createElement(_button.Button, { raised: true,
            icon: 'event_available',
            theme: _diaryFormButton2.default,
            onClick: openGoogleCalendarPage,
            label: t('label:カレンダー連携') }),
          _react2.default.createElement(_button.Button, {
            icon: 'close',
            theme: _diaryFormButton2.default,
            style: { marginLeft: 'auto' },
            onClick: this.onCancel,
            label: t('label:閉じる') })
        )
      );
    }
  }]);

  return DiaryForm;
}(_pureComponent2.default);

var RawDiaryForm = exports.RawDiaryForm = DiaryForm;
exports.default = (0, _diaryForm2.default)(DiaryForm);

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/diary-forms-base.js

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _fileUpload = __webpack_require__(179);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _formValidator = __webpack_require__(41);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _some = __webpack_require__(161);

var _some2 = _interopRequireDefault(_some);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _route = __webpack_require__(67);

var _googleDoc = __webpack_require__(269);

var _googleDoc2 = _interopRequireDefault(_googleDoc);

var _gambaUrl = __webpack_require__(350);

var _gambaUrl2 = _interopRequireDefault(_gambaUrl);

var _urlRegexp = __webpack_require__(182);

var _componentId = __webpack_require__(164);

var _componentId2 = _interopRequireDefault(_componentId);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _windowFocus = __webpack_require__(904);

var _windowFocus2 = _interopRequireDefault(_windowFocus);

var _reactI18next = __webpack_require__(2);

var _analytics = __webpack_require__(27);

var _uploadedFilesChanged = __webpack_require__(2768);

var _uploadedFilesChanged2 = _interopRequireDefault(_uploadedFilesChanged);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMPTY_HASH = {};
var UrlRegex = (0, _urlRegexp.urlRegex)();
var MAX_FIELD_TEXT_LEN = 2 * 1024;

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: state.user.current,
    isPosting: state.diaries.isPosting,
    isPostFailed: state.diaries.isPostFailed,
    isSaving: state.savedDiaries.isPosting,
    isSaveFailed: state.savedDiaries.isPostFailed,
    uploadedFiles: state.uploadFile[ownProps.componentId] || EMPTY_HASH,
    uploadedVideos: state.uploadVideo[ownProps.componentId] || EMPTY_HASH,
    current: state.savedDiaries.current,
    templates: state.diaryTemplates.items,
    savedDiaries: state.savedDiaries.items,
    insertHTML: state.diaryForm.insert && state.diaryForm.insert.html,
    kpi: state.diaryKPI.items,
    rightSidePageIsGoogleCalendar: state.rightSidePage.name == 'google_calendar',
    rightSidePageIsCreateDiary: state.rightSidePage.name == 'create_diary',
    isPhone: state.media.isPhone,
    firstLogin: state.user.firstLogin,
    productTour: state.productTour.state,
    socketStatus: state.socket.status,
    urlInfo: state.urlInfo[ownProps.componentId],
    isEditDiaryFetching: state.editDiary.isFetching,
    group: ownProps.group,
    review: state.lambdaApi.stream,
    isFetching: state.lambdaApi.isFetching,
    isFetchFailed: state.lambdaApi.isFetchFailed,
    isOpenReviewPanel: state.lambdaApi.isOpenReviewPanel,
    isReviewCompleted: state.lambdaApi.isCompleted,
    isReviewEnable: state.reviewSetting.isEnable
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var isUploading;
  (0, _each2.default)(stateProps.uploadedFiles, function (value, key) {
    value && value.isUploading && (isUploading = true);
  });
  (0, _each2.default)(stateProps.uploadedVideos, function (value, key) {
    value && value.isUploading && (isUploading = true);
  });
  var templateActions = [{
    name: 'user_templates_setting',
    callback: function callback() {
      return dispatchProps.showUserTemplatesSetting();
    }
  }];
  if (ownProps.group.is_admin) templateActions.push({
    name: 'group_templates_setting',
    callback: function callback() {
      return dispatchProps.showGroupTemplatesSetting();
    }
  });

  return _extends({
    blinkEditForm: stateProps.firstLogin && (!stateProps.productTour || stateProps.productTour.submitDiary != 'hide'),
    templateActions: templateActions,
    isUploading: isUploading
  }, stateProps, dispatchProps, ownProps);
};

function normalizeFields(fields) {
  if (!fields) return undefined;
  return (0, _map2.default)(fields, function (field) {
    field = Object.assign({}, field);
    if (field.type == 'date') // dateの場合は日付の書式に整形
      field.value = field.value && (0, _moment2.default)(field.value).format('YYYY-MM-DD') || undefined;
    if (field.type == 'numeric') // numericの場合は実数に変換
      field.value = parseFloat(field.value);
    return field;
  });
}

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var onChangeEditor = _lodash2.default.debounce(function (props) {
    if (!props.isPosting && !props.isSaving && props.ui.hasFocus && props.socketStatus == 'connected' && props.ui.editorHandlers) {
      props.ui.editorHandlers.getValue(function (content) {
        var files = (0, _map2.default)((0, _filter2.default)(props.uploadedFiles, function (file) {
          return file && file.item;
        }), function (file) {
          return file.item.file_id;
        });
        var videos = (0, _map2.default)((0, _filter2.default)(props.uploadedVideos, function (file) {
          return file && file.item;
        }), function (file) {
          return file.item.video_id;
        });
        var mentions = (0, _map2.default)(props.ui.mentions, function (mention) {
          return mention.user_id;
        });
        var attach_json = {
          links: props.ui.urlLinks,
          fields: normalizeFields(props.ui.fields)
        };

        if (props.ui.category == 'kpi' && props.kpi && props.kpi.length > 0) {
          attach_json.kpi_status = props.kpi.map(function (item) {
            return Object.assign({}, item, {
              actual: isNaN(parseFloat(props.ui.values[item.kpi_id])) ? undefined : parseFloat(props.ui.values[item.kpi_id]),
              total: typeof item.total == 'undefined' ? undefined : parseFloat(props.ui.total_values[item.kpi_id])
            });
          });
          if (!content || content.length == 0) content = '<div></div>';
        }

        if (props.ui.fields && props.ui.fields.length > 0 && (!content || content.length == 0)) content = '<div></div>';

        if (content && content.length > 0 && (!props.current || props.current && props.current.status != 'committed')) {
          // 一時保存
          dispatch(_actions2.default.saveDiary(props.group.group_id, props.current && props.current.diary_id, props.ui.category, props.ui.reported_at, props.ui.subject, content, files, videos, attach_json && JSON.stringify(attach_json) || undefined, mentions));
        }
      });
    }
  }, 1500);

  return {
    validateAndSubmit: function validateAndSubmit(props) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      event && event.preventDefault && event.preventDefault();
      onChangeEditor.cancel(); // onChangeEditorのdebounce実行をキャンセルする
      props.blinkEditForm && dispatch(_actions2.default.hideProductTour('submitDiary'));
      props.ui.editorHandlers && props.ui.editorHandlers.getValue(function (content) {
        var files = (0, _filter2.default)((0, _map2.default)(props.uploadedFiles, function (file) {
          return file && file.item && file.item.file_id;
        }), function (file) {
          return file;
        });
        var videos = (0, _filter2.default)((0, _map2.default)(props.uploadedVideos, function (file) {
          return file && file.item && file.item.video_id;
        }), function (file) {
          return file;
        });
        var mentions = (0, _map2.default)(props.ui.mentions, function (mention) {
          return mention.user_id;
        });
        var attach_json = {
          links: props.ui.urlLinks,
          fields: normalizeFields(props.ui.fields)
        };
        var rules = {};

        if (props.ui.category == 'kpi' && props.kpi && props.kpi.length > 0) {
          attach_json.kpi_status = props.kpi.map(function (item) {
            return Object.assign({}, item, {
              actual: isNaN(parseFloat(props.ui.values[item.kpi_id])) ? undefined : parseFloat(props.ui.values[item.kpi_id]),
              total: typeof item.total == 'undefined' ? undefined : parseFloat(props.ui.total_values[item.kpi_id])
            });
          });
          if (!content || content.length == 0) content = '<div></div>';
        }

        if (props.ui.fields && props.ui.fields.length > 0) {
          (0, _each2.default)(props.ui.fields, function (item, index) {
            if (item.required) rules['fields.' + index + '.value'] = { rule: 'isRequired' };
          });
          if (!content || content.length == 0) content = '<div></div>';
        }
        if (props.ui.category == 'memo') rules.subject = { rule: 'isRequired' };
        if (props.ui.category == 'kpi') {
          (0, _each2.default)(props.kpi, function (item) {
            rules['values.' + item.kpi_id] = { rule: 'isNumber' };
            rules['total_values.' + item.kpi_id] = { rule: 'isNumber' };
          });
        }

        (0, _formValidator.validate)(props.ui, rules, function (errors, errorState) {
          if (!content || content.length == 0) {
            errors = true;
            errorState.contentError = true;
          }
          if (errorState.fields) {
            var fields = props.ui.fields.concat();
            (0, _each2.default)(errorState.fields, function (state, key) {
              return fields[key] = state;
            });
            errorState.fields = fields;
          }
          props.updateUI(errorState);

          if (!errors)
            // 投稿
            dispatch(_actions2.default.postOrUpdateDiary(props.group.group_id, props.current && props.current.diary_id, props.ui.category, props.ui.category == 'memo' ? new Date() : props.ui.reported_at, props.ui.category == 'memo' ? props.ui.subject : undefined, content, files, videos, attach_json && JSON.stringify(attach_json) || undefined, mentions));
        });
      });
    },

    uploadFiles: function uploadFiles(files) {
      return (0, _fileUpload2.default)(files, dispatch, ownProps.group.group_id, 'group', ownProps.componentId);
    },

    onChangeEditor: onChangeEditor,

    onAddLink: function onAddLink(props, link) {
      if ((0, _googleDoc2.default)(link)) {
        if (props.ui.gapiReady) dispatch(_actions2.default.fetchGoogleDriveFile(link, props.componentId));else props.updateUI({ confirmGapi: true, link: link });
      } else dispatch(_actions2.default.fetchUrlInfo(link, props.componentId));
    },

    onDeleteLink: function onDeleteLink(props, link) {
      var urlLinks = Object.assign({}, props.ui.urlLinks);
      delete urlLinks[link];
      props.updateUI({ urlLinks: urlLinks });
    },

    onCancelConfirmGapi: function onCancelConfirmGapi(props) {
      return props.updateUI({ confirmGapi: false });
    },
    onSuccessConfirmGapi: function onSuccessConfirmGapi(props) {
      return props.updateUI({ confirmGapi: false, gapiReady: true });
    },

    // windowにフォーカスが当たった際、日付が変わっていれば更新する
    onWindowFocus: function onWindowFocus(props) {
      dispatch(_actions2.default.fetchSavedDiaries(ownProps.group.group_id, props.user.user_id));
      if (!props.current && !(0, _moment2.default)().isSame(props.ui.reported_at, 'day')) props.updateUI({ reported_at: new Date() });
    },

    onUpdateField: function onUpdateField(props, index, value) {
      // props.ui.fields[index].value の値を value に更新する
      // fieldのオブジェクトを複製して、value を入れ替えて、
      // props.ui.fields[index] の中身を差し替えた配列を fields に作成する
      var field = Object.assign({}, props.ui.fields[index]);
      // 文字列の長さが MAX_FIELD_TEXT_LEN 以上の場合は後ろを切り捨てる
      if (value && value.toString().length > MAX_FIELD_TEXT_LEN && (field.type == 'text' || field.type == 'string')) value = value.toString().slice(0, MAX_FIELD_TEXT_LEN);
      if (value && field.type == 'numeric') value = value.toString().replace(/[^-0-9.]/g, '');
      field.value = value;
      var fields = props.ui.fields.map(function (f, i) {
        return i == index ? field : f;
      });
      // 必須入力のfieldが未入力エラーになっている場合、
      // props.ui.fields['0.valueError'] = true のように格納されているため
      // この状態を先の fields 配列に反映する
      (0, _each2.default)((0, _filter2.default)(Object.keys(props.ui.fields), function (key) {
        var _keys = key.split('.');
        return _keys[1] == 'valueError' && _keys[0] + 0 != index;
      }), function (key) {
        var _key = key.split('.');
        var item = fields[+_key[0]];
        if (item.required && (!item.value || item.value.length == 0)) {
          fields[key] = true;
        } else {
          fields[key] = false;
        }
      });
      props.updateUI({ fields: fields });
    },

    willMount: function willMount(props) {
      props.updateUI({ reported_at: new Date() });
      if (ownProps.group && props.user) {
        dispatch(_actions2.default.fetchDiaryTemplates(ownProps.group.group_id, props.user.user_id));
        dispatch(_actions2.default.fetchSavedDiaries(ownProps.group.group_id, props.user.user_id));
      }
      ownProps.group && dispatch(_actions2.default.fetchDiaryKpi(ownProps.group.group_id, new Date()));
    },

    willUnmount: function willUnmount(props) {
      dispatch(_actions2.default.clearSavedDiary());
      dispatch(_actions2.default.clearUploadFilesAndVideos(ownProps.componentId));
    },

    willUpdate: function willUpdate(props, nextProps) {
      // 投稿処理が完了 / 編集が取り消された
      if (props.isPosting && !nextProps.isPosting && !nextProps.isPostFailed || props.ui.hasFocus && !nextProps.ui.hasFocus || props.current && !nextProps.current || props.group.group_id != nextProps.group.group_id) {
        if (props.isPosting && !nextProps.isPosting && !nextProps.isPostFailed) {
          if (props.current && props.current.status == 'committed') {
            dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:投稿の編集が完了しました' }, 'postSuccess'));
          } else {
            dispatch((0, _alertMessage.emitAlertMessage)({ message: 'diary:' + props.ui.category + '\u3092\u6295\u7A3F' }, 'postSuccess'));
          }
        }

        if (nextProps.ui.editorHandlers) nextProps.ui.editorHandlers.clearValue();
        nextProps.updateUI({
          subject: '',
          reported_at: new Date(),
          subjectError: undefined,
          contentError: undefined,
          postError: undefined,
          hasFocus: false,
          urlLinks: undefined,
          fields: [],
          mentions: []
        });
        dispatch(_actions2.default.clearUrlInfo(nextProps.componentId));
        dispatch(_actions2.default.clearUploadFilesAndVideos(nextProps.componentId));
        dispatch(_actions2.default.clearSavedDiary());
        dispatch(_actions2.default.fetchSavedDiaries(nextProps.group.group_id, nextProps.user.user_id));
        dispatch(_actions2.default.fetchDiaryKpi(nextProps.group.group_id, new Date()));
        dispatch(_actions2.default.fetchDiaryTemplates(nextProps.group.group_id, nextProps.user.user_id));

        if (props.rightSidePageIsGoogleCalendar) dispatch(_actions2.default.closeRightSidePage());
      }

      // 一時保存処理ができたタイミングでui.saveMessageをtrueにする
      if (!props.isSaving && nextProps.isSaving && !nextProps.ui.saveMessage) {
        nextProps.updateUI({ saveMessage: true });
        setTimeout(function () {
          return nextProps.updateUI({ saveMessage: false });
        }, 5000);
      }

      // 投稿や一時保存でエラーが発生した
      if (!props.isPostFailed && nextProps.isPostFailed || !props.isSaveFailed && nextProps.isSaveFailed) {
        nextProps.updateUI({ postError: true });
      }

      // 投稿や一時保存のエラーが解消した
      if (props.isPostFailed && !nextProps.isPostFailed || props.isSaveFailed && !nextProps.isSaveFailed) {
        nextProps.updateUI({ postError: undefined });
      }

      // reported_atが変更された
      if (!(0, _moment2.default)(props.ui.reported_at).isSame(nextProps.ui.reported_at, 'date')) {
        dispatch(_actions2.default.fetchDiaryTemplates(nextProps.group.group_id, nextProps.user.user_id));
        dispatch(_actions2.default.fetchDiaryKpi(nextProps.group.group_id, nextProps.ui.reported_at));
      }

      // KPIが更新された（編集中でない場合は値を更新）
      if (!nextProps.current && props.kpi !== nextProps.kpi) {
        var values = {};
        var total_values = {};
        (0, _each2.default)(nextProps.kpi, function (item) {
          values[item.kpi_id.toString()] = item.actual ? item.actual : '0';
          total_values[item.kpi_id.toString()] = item.total ? item.total : '0';
        });
        nextProps.updateUI({ values: values, total_values: total_values });
      }

      // subject, category, fields, 添付ファイルのいずれかが変更された
      if (nextProps.current && (props.ui.subject != nextProps.ui.subject || props.ui.category != nextProps.ui.category || (0, _uploadedFilesChanged2.default)(props.uploadedFiles, nextProps.uploadedFiles, 'file_id') || (0, _uploadedFilesChanged2.default)(props.uploadedVideos, nextProps.uploadedVideos, 'video_id') || props.ui.fields && nextProps.ui.fields && props.ui.fields.length == nextProps.ui.fields.length && (0, _some2.default)(nextProps.ui.fields, function (field, i) {
        return field !== props.ui.fields[i];
      }))) {
        nextProps.onChangeEditor(nextProps);
      }

      // HTMLを挿入する
      if (nextProps.insertHTML && props.insertHTML != nextProps.insertHTML) {
        nextProps.ui.editorHandlers.insertValue(nextProps.insertHTML);
        dispatch(_actions2.default.clearInsertDiaryForm());
        nextProps.onChangeEditor(nextProps);
      }

      // 新たに編集対象が読み込まれた
      if (!props.current && nextProps.current && !props.ui.hasFocus && nextProps.ui.editorHandlers || !props.ui.editorHandlers && nextProps.ui.editorHandlers && nextProps.current) {
        nextProps.ui.editorHandlers.insertValue(nextProps.current.content);
        var attach_json = typeof nextProps.current.attach_json == 'string' && JSON.parse(nextProps.current.attach_json) || nextProps.current.attach_json;
        // attach_jsonのkpiをvalues, total_valuesに格納する
        var values = {};
        var total_values = {};
        if (nextProps.current.category == 'kpi' && attach_json) {
          (0, _each2.default)(attach_json.kpi_status, function (item) {
            values[item.kpi_id.toString()] = item.actual ? item.actual : '0';
            total_values[item.kpi_id.toString()] = item.total ? item.total : '0';
          });
        }

        // attach_jsonのlinksをurlLinksに格納する
        var urlLinks = {};
        if (attach_json && attach_json.links) urlLinks = attach_json.links;

        nextProps.updateUI({
          reported_at: (0, _moment2.default)(nextProps.current.reported_at).toDate(),
          subject: nextProps.current.subject,
          values: values,
          total_values: total_values,
          category: nextProps.current.category,
          fields: attach_json ? attach_json.fields : [],
          urlLinks: urlLinks,
          mentions: nextProps.current.mention_users
        });

        // 編集時には右サイドページを閉じる
        if (!props.rightSidePageIsCreateDiary) // create_diaryページを表示中の場合はスキップ
          dispatch(_actions2.default.closeRightSidePage());

        // 添付ファイルをstoreに読み込む
        (0, _each2.default)(nextProps.current.files, function (file) {
          var loadId = Math.random().toString().slice(-12);
          if (file.file_id) dispatch(_actions2.default.uploadFileCompleted(file, nextProps.componentId, loadId));else dispatch(_actions2.default.uploadVideoCompleted(file, nextProps.componentId, loadId));
        });

        // 本文中のURLでattach_jsonに含まれていないものがあれば情報を取得する
        var match = void 0;
        while (match = UrlRegex.exec(nextProps.current.content)) {
          var url = match[0];
          if ((!attach_json || !attach_json.links || !attach_json.links[url]) && !(0, _googleDoc2.default)(url)) dispatch(_actions2.default.fetchUrlInfo(url, nextProps.componentId));
        }
      }

      // gapiReadyがtrueになり、linkにファイル名を取得すべきGoogleドキュメントのURLが格納されている
      if (!props.ui.gapiReady && nextProps.ui.gapiReady && nextProps.ui.link) {
        dispatch(_actions2.default.fetchGoogleDriveFile(nextProps.ui.link, nextProps.componentId));
      }

      // fetchUrlInfoでリンク先情報を取得した
      if (props.urlInfo !== nextProps.urlInfo && nextProps.urlInfo && !nextProps.urlInfo.isFetchFailed && nextProps.current) {
        var urlLinks = Object.assign({}, nextProps.ui.urlLinks);
        (0, _each2.default)(nextProps.urlInfo, function (v, k) {
          if (v && !v.isFetching && v.item && (!props.urlInfo || props.urlInfo[k] !== v.item)) {
            urlLinks[k] = v.item;
          }
        });
        nextProps.updateUI({ urlLinks: urlLinks });
      }

      // fetcuUrlInfoでリンク先情報の取得に失敗した
      if (props.urlInfo !== nextProps.urlInfo && nextProps.urlInfo && nextProps.urlInfo.isFetchFailed) {
        nextProps.updateUI({ gapiReady: false });
      }

      // すでに編集中の状態でさらに編集を行おうとした場合
      if (!props.isEditDiaryFetching && nextProps.isEditDiaryFetching && (nextProps.current || nextProps.ui.hasFocus)) {
        dispatch((0, _alertMessage.emitAlertMessage)({ message: 'error:別の投稿を編集中です' }, 'error'));
      }
    },

    onChangeCategory: function onChangeCategory(category, props) {
      if (props.current && props.current.status == 'committed') return;
      if (category == 'memo') props.updateUI({ category: category });else props.updateUI({ category: category, subject: undefined });
    },

    onCancel: function onCancel(props) {
      props.updateUI({ hasFocus: false });
      onChangeEditor.cancel();
    },
    openGoogleCalendarPage: function openGoogleCalendarPage() {
      return dispatch(_actions2.default.openRightSidePage('google_calendar', {}));
    },

    closeRightSidePage: function closeRightSidePage() {
      return dispatch(_actions2.default.closeRightSidePage());
    },

    showKpi: function showKpi(kpi_id) {
      return dispatch(_actions2.default.openRightSidePage('kpi_chart', { kpi_id: kpi_id, group_id: ownProps.group.group_id }));
    },

    openGroupKPIPanel: function openGroupKPIPanel() {
      return dispatch(_actions2.default.openGroupSettingsPage('kpi'));
    },

    showUserTemplatesSetting: function showUserTemplatesSetting() {
      return dispatch(_actions2.default.openUserSettingsPage('templates'));
    },
    showGroupTemplatesSetting: function showGroupTemplatesSetting() {
      return ownProps.group.is_admin && dispatch(_actions2.default.openGroupSettingsPage('templates'));
    },
    showGoogleDoc: function showGoogleDoc(url) {
      return dispatch(_actions2.default.openRightSidePage('google_doc', { url: url }, true));
    },
    showGambaUrl: function showGambaUrl(url) {
      var paths = url.replace(/^.+groups\//, '').split('/');
      var kpi_id, diary_id, chat_room_id, match;
      var group_id = parseInt(paths[0]);
      if (paths.length == 2 && paths[1] == 'timeline') {
        (0, _route.pushRoute)('group_timeline', { group_id: group_id });
      } else if (paths.length == 1 && paths[0] == 'home') {
        (0, _route.pushRoute)('home_group');
      } else if (paths.length == 4 && paths[2] == 'kpi_chart') {
        kpi_id = parseInt(paths[3]);
        dispatch(_actions2.default.openRightSidePage('kpi_chart', { group_id: group_id, kpi_id: kpi_id }));
      } else if (paths.length == 3 && (match = paths[2].match(/^pickup\?diary_ids=([0-9]+)$/))) {
        diary_id = parseInt(match[1]);
        dispatch(_actions2.default.openRightSidePage('pickup_diaries', { diary_ids: [diary_id] }));
      } else if (paths.length == 3 && paths[1] == 'messages') {
        chat_room_id = parseInt(paths[2]);
        dispatch(_actions2.default.openRightSidePage('chat_messages', { chat_room_id: chat_room_id }));
      }
    },
    askGpt: function askGpt(message) {
      return dispatch(_actions2.default.fetchReview(message));
    },
    onOpenReview: function onOpenReview() {
      return dispatch(_actions2.default.openReviewPanel());
    },
    onCloseReview: function onCloseReview() {
      dispatch(_actions2.default.closeReviewPanel());
    }
  };
};

exports.default = (0, _combineHoc2.default)(_componentId2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({
  state: {
    category: 'diary',
    editorHandlers: undefined,
    subject: '',
    reported_at: undefined,
    subjectError: undefined,
    contentError: undefined,
    postError: undefined,
    hasFocus: false,
    urlLinks: undefined,
    confirmGapi: false,
    link: undefined,
    values: {},
    total_values: {},
    dateValue: undefined,
    timeValue: undefined,
    fields: [],
    mentions: undefined,
    saveMessage: false,
    gapiReady: function gapiReady() {
      return window.gapi && window.gapi.client && window.gapi.client.getToken();
    }
  }
}), (0, _context2.default)({ showUserSelectionDialog: _propTypes2.default.func }), _lifecycle2.default, _windowFocus2.default, (0, _reactI18next.translate)(), (0, _analytics.trackHandlers)('validateAndSubmit', 'diary_submit'), (0, _analytics.trackHandlers)('askGpt', 'ask_gpt_diary_form'));

/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUploadedFilesChanged;

var _shallowEqual = __webpack_require__(264);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUploadedFilesChanged(thisUploadedFiles, nextUploadedFiles) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'file_id';

  var thisKeys = thisUploadedFiles && Object.keys(thisUploadedFiles);
  var nextKeys = nextUploadedFiles && Object.keys(nextUploadedFiles);
  var thisIds = thisUploadedFiles && thisKeys.map(function (key) {
    return thisUploadedFiles[key] && thisUploadedFiles[key][mode];
  });
  var nextIds = nextUploadedFiles && nextKeys.map(function (key) {
    return nextUploadedFiles[key] && nextUploadedFiles[key][mode];
  });

  if (!(0, _shallowEqual2.default)(thisKeys, nextKeys) || !(0, _shallowEqual2.default)(thisIds, nextIds)) return true;
}
// src/helpers/uploaded-files-changed.js

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _date_picker = __webpack_require__(354);

var _button = __webpack_require__(8);

var _diaryUploadFiles = __webpack_require__(569);

var _diaryUploadFiles2 = _interopRequireDefault(_diaryUploadFiles);

var _richTextEditor = __webpack_require__(181);

var _richTextEditor2 = _interopRequireDefault(_richTextEditor);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reportedDatePicker = __webpack_require__(535);

var _reportedDatePicker2 = _interopRequireDefault(_reportedDatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = {
  months: _moment2.default.months(),
  monthsShort: _moment2.default.monthsShort(),
  weekdays: _moment2.default.weekdays(),
  weekdaysShort: _moment2.default.weekdaysShort(),
  weekdaysLetter: _moment2.default.weekdaysShort()
};
// src/web/components/reported-date-picker.jsx

function ReportedDatePicker(props) {
  var t = props.t,
      ui = props.ui,
      date = props.date,
      onChangeDate = props.onChangeDate,
      category = props.category,
      updateUI = props.updateUI;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_button.Button, { flat: true, className: _reportedDatePicker2.default.label,
      onClick: function onClick() {
        return updateUI({ active: true });
      },
      label: t('format:diary_subject', { reported_at: date, category: t('diary:' + category) }) }),
    _react2.default.createElement(_date_picker.DatePickerDialog, { active: ui.active,
      theme: _reportedDatePicker2.default,
      autoOk: true,
      okLabel: t('label:了解'),
      cancelLabel: t('label:取り消し'),
      locale: locale,
      value: date,
      sundayFirstDayOfWeek: true,
      onEscKeyDoan: function onEscKeyDoan() {
        return updateUI({ active: false });
      },
      onOverlayClick: function onOverlayClick() {
        return updateUI({ active: false });
      },
      onSelect: function onSelect(_date) {
        updateUI({ active: false });onChangeDate(_date);
      },
      onDismiss: function onDismiss() {
        return updateUI({ active: false });
      } })
  );
}

exports.default = (0, _reactI18next.translate)()((0, _uiState2.default)({ state: { active: false } })(ReportedDatePicker));

/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/diary-forms-kpi-item.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _reactCssThemr = __webpack_require__(10);

var _button = __webpack_require__(8);

var _diaryKpi = __webpack_require__(564);

var _diaryKpi2 = _interopRequireDefault(_diaryKpi);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _formatNumber = __webpack_require__(201);

var _input = __webpack_require__(59);

var _input2 = _interopRequireDefault(_input);

var _compactInput = __webpack_require__(909);

var _compactInput2 = _interopRequireDefault(_compactInput);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);

function Row(props) {
  var t = props.t,
      theme = props.theme,
      label = props.label,
      value = props.value,
      error = props.error,
      isPercent = props.isPercent,
      onChange = props.onChange,
      format = props.format,
      unit = props.unit;


  var step = 1;
  if (format && format.decimal_1) step = 0.1;else if (format && format.decimal_2) step = 0.01;else if (format && format.decimal_3) step = 0.001;

  return _react2.default.createElement(
    'div',
    { className: theme.row },
    _react2.default.createElement(
      'div',
      { className: theme.label },
      label
    ),
    !onChange && _react2.default.createElement(
      'div',
      { className: theme.value },
      !onChange && !isPercent && _react2.default.createElement(
        'span',
        null,
        format.prepend_unit && _react2.default.createElement(
          'span',
          { className: theme.unit },
          unit
        ),
        _react2.default.createElement(
          'span',
          { className: theme.number },
          (0, _formatNumber.formatNumber)(value, format)
        ),
        !format.prepend_unit && _react2.default.createElement(
          'span',
          { className: theme.unit },
          unit
        )
      ),
      !onChange && isPercent && value >= 1.0 && isFinite(value) && _react2.default.createElement(
        'span',
        { className: theme.achieved },
        t('label:達成')
      ),
      !onChange && isPercent && _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { className: theme.number },
          (0, _formatNumber.percent)(value)
        ),
        _react2.default.createElement(
          'span',
          { className: theme.unit },
          '%'
        )
      )
    ),
    onChange && _react2.default.createElement('input', { type: 'number',
      step: step,
      autoComplete: false,
      onChange: onChange,
      placeholder: error && t('label:値を入力してください'),
      className: (0, _classnames2.default)(theme.input, error && theme.error),
      value: value || '' }),
    onChange && _react2.default.createElement(
      'div',
      { className: theme.unit },
      unit
    )
  );
}

var DiaryFormsKPIItem = (_dec = (0, _reactCssThemr.themr)('DiaryFormsKPIItem', _diaryKpi2.default), _dec(_class = function (_React$Component) {
  _inherits(DiaryFormsKPIItem, _React$Component);

  function DiaryFormsKPIItem() {
    _classCallCheck(this, DiaryFormsKPIItem);

    return _possibleConstructorReturn(this, (DiaryFormsKPIItem.__proto__ || Object.getPrototypeOf(DiaryFormsKPIItem)).apply(this, arguments));
  }

  _createClass(DiaryFormsKPIItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          kpi = _props.kpi,
          _onChange = _props.onChange,
          value = _props.value,
          total_value = _props.total_value,
          error = _props.error,
          total_error = _props.total_error,
          showKpi = _props.showKpi;


      var opt_value = typeof kpi.total == 'undefined' ? value : total_value;

      return _react2.default.createElement(
        'div',
        { className: theme.kpi },
        _react2.default.createElement(
          'h3',
          { className: (0, _classnames2.default)(theme.title, theme.clickable), onClick: showKpi },
          kpi.name,
          _react2.default.createElement(TooltipIconButton, { icon: 'arrow_forward', tooltip: t('label:グラフを表示') })
        ),
        _react2.default.createElement(
          'div',
          { className: theme.rows },
          _react2.default.createElement(Row, { t: t, theme: theme, label: t('label:目標'), value: kpi.target, format: kpi.display_format, unit: kpi.unit }),
          _react2.default.createElement(Row, { t: t, theme: theme, label: t('label:実績'), value: value, format: kpi.display_format, unit: kpi.unit, onChange: function onChange(ev) {
              return _onChange(ev, kpi, 'actual');
            }, error: error }),
          typeof kpi.total != 'undefined' && _react2.default.createElement(Row, { t: t, theme: theme, label: t('label:累計'), value: total_value, format: kpi.display_format, unit: kpi.unit, onChange: function onChange(ev) {
              return _onChange(ev, kpi, 'total');
            }, error: total_error }),
          _react2.default.createElement(Row, { t: t, theme: theme, label: t('label:達成率'), value: opt_value / kpi.target, isPercent: true })
        )
      );
    }
  }]);

  return DiaryFormsKPIItem;
}(_react2.default.Component)) || _class);
exports.default = (0, _reactI18next.translate)()(DiaryFormsKPIItem);

/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawSavedDiary = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _savedDiary = __webpack_require__(2772);

var _savedDiary2 = _interopRequireDefault(_savedDiary);

var _chip = __webpack_require__(91);

var _chip2 = _interopRequireDefault(_chip);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _link = __webpack_require__(183);

var _link2 = _interopRequireDefault(_link);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _flash = __webpack_require__(2773);

var _flash2 = _interopRequireDefault(_flash);

var _savedDiary3 = __webpack_require__(2775);

var _savedDiary4 = _interopRequireDefault(_savedDiary3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/saved-diary.jsx

var SavedDiary = function (_React$Component) {
  _inherits(SavedDiary, _React$Component);

  function SavedDiary() {
    _classCallCheck(this, SavedDiary);

    var _this = _possibleConstructorReturn(this, (SavedDiary.__proto__ || Object.getPrototypeOf(SavedDiary)).call(this));

    _this.state = { deleteConfirm: false, update: undefined };

    _this.setTimer = function (timestamp) {
      var interval;
      var elapsed = (0, _moment2.default)().diff((0, _moment2.default)(timestamp), 'seconds');
      if (elapsed < 60) // 1分未満
        interval = 30; // 30秒ごと
      else if (elapsed < 10 * 60) // 10分未満
          interval = 2 * 60; // 2分ごと
        else if (elapsed < 60 * 60) // 1時間未満
            interval = 10 * 60; // 10分ごと
          else if (elapsed < 24 * 60 * 60) // 24時間未満
              interval = 60 * 60; // 1時間ごと
            else // それ以降
              interval = 12 * 60 * 60; // 12時間ごと
      _this.timer && clearInterval(_this.timer);
      _this.timer = setInterval(_this.update, interval * 1000);
    };
    _this.update = function () {
      _this.setState({ update: new Date() });
    };
    return _this;
  }

  _createClass(SavedDiary, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isCurrent) this.setTimer(this.props.diary.updated_at);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.timer && clearInterval(this.timer);
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isCurrent) {
        this.setTimer(nextProps.diary.updated_at);

        var dom = _reactDom2.default.findDOMNode(this);
        dom.className = dom.className.replace(_flash2.default.flash, '');
        if (this.props.diary.updated_at != nextProps.diary.updated_at) {
          setTimeout(function () {
            return dom.className += ' ' + _flash2.default.flash;
          }, 50);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          diary = _props.diary,
          isCurrent = _props.isCurrent,
          isEdit = _props.isEdit,
          isFetching = _props.isFetching,
          deleteSavedDiary = _props.deleteSavedDiary,
          editSavedDiary = _props.editSavedDiary;


      if (isCurrent) return _react2.default.createElement(
        _chip2.default,
        { deletable: true, theme: _savedDiary4.default,
          onDeleteClick: function onDeleteClick() {
            return _this2.setState({ deleteConfirm: true });
          } },
        _react2.default.createElement(_avatar2.default, { style: { background: 'pink' }, icon: 'mode_edit' }),
        t('format:savedAt', { timestamp: diary.updated_at }),
        _react2.default.createElement(_confirmDialog2.default, { open: this.state.deleteConfirm,
          title: t('label:保存された投稿を削除してもいいですか'),
          description: t('label:この操作は取り消せません'),
          yesLabel: t('label:削除'),
          noLabel: t('label:取り消し'),
          onYes: function onYes() {
            _this2.setState({ deleteConfirm: false });deleteSavedDiary();
          },
          onNo: function onNo() {
            return _this2.setState({ deleteConfirm: false });
          } })
      );else return _react2.default.createElement(
        _link2.default,
        { onClick: !isEdit && !isFetching && editSavedDiary || undefined, theme: _savedDiary4.default, style: { cursor: !isEdit && 'pointer' || 'default' } },
        _react2.default.createElement(
          _chip2.default,
          { deletable: true, theme: _savedDiary4.default,
            onDeleteClick: function onDeleteClick(e) {
              e.stopPropagation();_this2.setState({ deleteConfirm: true });
            } },
          _react2.default.createElement(_avatar2.default, { icon: 'save' }),
          diary.subject && (diary.subject.length > 8 && diary.subject.slice(0, 8) + '...' || diary.subject) || t('format:diary_subject', { reported_at: diary.reported_at, category: t('diary:' + diary.category) }),
          _react2.default.createElement(_confirmDialog2.default, { open: this.state.deleteConfirm,
            title: t('label:保存された投稿を削除してもいいですか'),
            description: t('label:この操作は取り消せません'),
            yesLabel: t('label:削除'),
            noLabel: t('label:取り消し'),
            onYes: function onYes() {
              _this2.setState({ deleteConfirm: false });deleteSavedDiary();
            },
            onNo: function onNo() {
              return _this2.setState({ deleteConfirm: false });
            } })
        )
      );
    }
  }]);

  return SavedDiary;
}(_react2.default.Component);

// TODO:
//  自動保存がかかったら保存した時刻を表示してブリンクさせる
//  クリックしたら編集できるように

var RawSavedDiary = exports.RawSavedDiary = SavedDiary;
exports.default = (0, _savedDiary2.default)(SavedDiary);

/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/saved-diary.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.savedDiaries.isFetching
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    deleteSavedDiary: function deleteSavedDiary() {
      return dispatch(_actions2.default.deleteSavedDiary(ownProps.diary.diary_id));
    },
    editSavedDiary: function editSavedDiary() {
      return dispatch(_actions2.default.editDiary(ownProps.diary.diary_id));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2774);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./flash.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./flash.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n@-webkit-keyframes flash--highlightflash--3Jhsnfbp {\n    0% { background: auto; }\n   50% { background: #FFFF99; }\n  100% { background: auto; }\n}\n\n@keyframes flash--highlightflash--3Jhsnfbp {\n    0% { background: auto; }\n   50% { background: #FFFF99; }\n  100% { background: auto; }\n}\n\n.flash--flash--QUjvd76S {\n  animation: flash--highlightflash--3Jhsnfbp 1s;\n  -webkit-animation: flash--highlightflash--3Jhsnfbp 1s;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/flash.css"],"names":[],"mappings":";AACA;IACI,KAAK,iBAAiB,EAAE;GACzB,MAAM,oBAAoB,EAAE;EAC7B,OAAO,iBAAiB,EAAE;CAC3B;;AAED;IACI,KAAK,iBAAiB,EAAE;GACzB,MAAM,oBAAoB,EAAE;EAC7B,OAAO,iBAAiB,EAAE;CAC3B;;AAED;EACE,8CAA6B;EAC7B,sDAAqC;CACtC","file":"flash.css","sourcesContent":["\n@-webkit-keyframes highlightflash {\n    0% { background: auto; }\n   50% { background: #FFFF99; }\n  100% { background: auto; }\n}\n\n@keyframes highlightflash {\n    0% { background: auto; }\n   50% { background: #FFFF99; }\n  100% { background: auto; }\n}\n\n.flash {\n  animation: highlightflash 1s;\n  -webkit-animation: highlightflash 1s;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"flash": "flash--flash--QUjvd76S",
	"highlightflash": "flash--highlightflash--3Jhsnfbp"
};

/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2776);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./saved-diary.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./saved-diary.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.saved-diary--link--rRfIkUDs {\n  display: inline-block;\n}\n\n.saved-diary--chip--1s6zMFHD {\n  vertical-align: middle;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/saved-diary.css"],"names":[],"mappings":";AACA;EACE,sBAAsB;CACvB;;AAED;EACE,uBAAuB;CACxB","file":"saved-diary.css","sourcesContent":["\n.link {\n  display: inline-block;\n}\n\n.chip {\n  vertical-align: middle;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"link": "saved-diary--link--rRfIkUDs",
	"chip": "saved-diary--chip--1s6zMFHD"
};

/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _dec2, _class3, _dec3, _class5, _dec4, _class6, _dec5, _class8, _dec6, _class10;
// src/web/components/diary-forms-fields.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _button = __webpack_require__(8);

var _list = __webpack_require__(25);

var _date_picker = __webpack_require__(354);

var _dialog = __webpack_require__(47);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _timePickerDialog = __webpack_require__(972);

var _timePickerDialog2 = _interopRequireDefault(_timePickerDialog);

var _input = __webpack_require__(59);

var _input2 = _interopRequireDefault(_input);

var _fieldListItem = __webpack_require__(1053);

var _fieldListItem2 = _interopRequireDefault(_fieldListItem);

var _reportedDatePicker = __webpack_require__(535);

var _reportedDatePicker2 = _interopRequireDefault(_reportedDatePicker);

var _scrollableDialog = __webpack_require__(2778);

var _scrollableDialog2 = _interopRequireDefault(_scrollableDialog);

var _reactI18next = __webpack_require__(2);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _fieldIcons = __webpack_require__(522);

var _fieldIcons2 = _interopRequireDefault(_fieldIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var locale = {
  months: _moment2.default.months(),
  monthsShort: _moment2.default.monthsShort(),
  weekdays: _moment2.default.weekdays(),
  weekdaysShort: _moment2.default.weekdaysShort(),
  weekdaysLetter: _moment2.default.weekdaysShort()
};

var DateFieldItem = (_dec = (0, _reactI18next.translate)(), _dec(_class = function (_React$Component) {
  _inherits(DateFieldItem, _React$Component);

  function DateFieldItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateFieldItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateFieldItem.__proto__ || Object.getPrototypeOf(DateFieldItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DateFieldItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          field = _props.field,
          index = _props.index,
          error = _props.error,
          onUpdateField = _props.onUpdateField;


      return _react2.default.createElement(
        _list.ListItem,
        { selectable: true, leftIcon: _fieldIcons2.default[field.type], theme: _fieldListItem2.default,
          className: error && 'error',
          caption: field.name, legend: field.value && (0, _moment2.default)(field.value).format('YYYY-MM-DD') || field.required && t('label:値を入力してください'),
          onClick: function onClick() {
            return _this2.setState({ active: true });
          } },
        _react2.default.createElement(_date_picker.DatePickerDialog, { active: this.state.active,
          theme: _reportedDatePicker2.default,
          autoOk: true,
          okLabel: t('label:OK'),
          cancelLabel: t('label:取り消し'),
          locale: locale,
          value: field.value ? new Date(field.value) : new Date(),
          onEscKeyDown: function onEscKeyDown() {
            return _this2.setState({ active: false });
          },
          onOverlayClick: function onOverlayClick() {
            return _this2.setState({ active: false });
          },
          onSelect: function onSelect(date) {
            onUpdateField(index, date);
            _this2.setState({ active: false });
          },
          onDismiss: function onDismiss() {
            return _this2.setState({ active: false });
          } })
      );
    }
  }]);

  return DateFieldItem;
}(_react2.default.Component)) || _class);
var TimeFieldItem = (_dec2 = (0, _reactI18next.translate)(), _dec2(_class3 = function (_React$Component2) {
  _inherits(TimeFieldItem, _React$Component2);

  function TimeFieldItem() {
    var _ref2;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, TimeFieldItem);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = TimeFieldItem.__proto__ || Object.getPrototypeOf(TimeFieldItem)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = { active: false }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(TimeFieldItem, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          t = _props2.t,
          field = _props2.field,
          index = _props2.index,
          error = _props2.error,
          onUpdateField = _props2.onUpdateField;


      return _react2.default.createElement(
        _list.ListItem,
        { selectable: true, leftIcon: _fieldIcons2.default[field.type], theme: _fieldListItem2.default,
          className: error && 'error',
          caption: field.name, legend: field.value || field.required && t('label:値を入力してください'),
          onClick: function onClick() {
            return _this4.setState({ active: true });
          } },
        _react2.default.createElement(_timePickerDialog2.default, { active: this.state.active,
          value: field.value,
          okLabel: t('label:OK'),
          cancelLabel: t('label:取り消し'),
          onSelect: function onSelect(time) {
            onUpdateField(index, time);
            _this4.setState({ active: false });
          },
          onCancel: function onCancel() {
            return _this4.setState({ active: false });
          } })
      );
    }
  }]);

  return TimeFieldItem;
}(_react2.default.Component)) || _class3);
var StringFieldItem = (_dec3 = (0, _reactI18next.translate)(), _dec3(_class5 = function (_React$Component3) {
  _inherits(StringFieldItem, _React$Component3);

  function StringFieldItem() {
    _classCallCheck(this, StringFieldItem);

    return _possibleConstructorReturn(this, (StringFieldItem.__proto__ || Object.getPrototypeOf(StringFieldItem)).apply(this, arguments));
  }

  _createClass(StringFieldItem, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          t = _props3.t,
          field = _props3.field,
          index = _props3.index,
          error = _props3.error,
          onUpdateField = _props3.onUpdateField;


      return _react2.default.createElement(
        _list.ListItem,
        { ripple: false, selectable: true, leftIcon: _fieldIcons2.default[field.type], theme: _fieldListItem2.default, className: "input" + (error && ' error' || '') },
        _react2.default.createElement(
          _list.ListItemContent,
          null,
          _react2.default.createElement(_input2.default, { type: field.type == "string" ? 'text' : 'number', step: 'any',
            theme: _fieldListItem2.default,
            label: field.name + (error && ': ' + t('label:値を入力してください') || ''),
            value: field.value,
            error: error,
            hint: field.required && t('label:値を入力してください'),
            onChange: function onChange(value) {
              return onUpdateField(index, value);
            } })
        )
      );
    }
  }]);

  return StringFieldItem;
}(_react2.default.Component)) || _class5);
var TextFieldItem = (_dec4 = (0, _reactI18next.translate)(), _dec4(_class6 = function (_React$Component4) {
  _inherits(TextFieldItem, _React$Component4);

  function TextFieldItem() {
    var _ref3;

    var _temp3, _this6, _ret3;

    _classCallCheck(this, TextFieldItem);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this6 = _possibleConstructorReturn(this, (_ref3 = TextFieldItem.__proto__ || Object.getPrototypeOf(TextFieldItem)).call.apply(_ref3, [this].concat(args))), _this6), _this6.adjustHeight = function () {
      var target = _reactDom2.default.findDOMNode(_this6.refs.textarea).getElementsByTagName('textarea')[0];
      var lineHeight = Number(target.getAttribute("rows"));
      while (target.scrollHeight > target.offsetHeight) {
        lineHeight++;
        target.setAttribute("rows", lineHeight);
      }
    }, _this6.onChange = function (value) {
      _this6.adjustHeight();
      _this6.props.onUpdateField(_this6.props.index, value);
    }, _temp3), _possibleConstructorReturn(_this6, _ret3);
  }

  _createClass(TextFieldItem, [{
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          t = _props4.t,
          field = _props4.field,
          index = _props4.index,
          error = _props4.error,
          onUpdateField = _props4.onUpdateField;


      return _react2.default.createElement(
        _list.ListItem,
        { ripple: false, selectable: true, leftIcon: _fieldIcons2.default[field.type], theme: _fieldListItem2.default, className: "input" + (error && ' error' || '') },
        _react2.default.createElement(
          _list.ListItemContent,
          null,
          _react2.default.createElement(_input2.default, { type: 'text', ref: 'textarea', theme: _fieldListItem2.default,
            multiline: true, rows: 5,
            label: field.name + (error && ': ' + t('label:値を入力してください') || ''),
            hint: field.required && t('label:値を入力してください'),
            error: error,
            value: field.value,
            onFocus: this.adjustHeight,
            onChange: this.onChange })
        )
      );
    }
  }]);

  return TextFieldItem;
}(_react2.default.Component)) || _class6);
var DropDownFieldItem = (_dec5 = (0, _reactI18next.translate)(), _dec5(_class8 = function (_React$Component5) {
  _inherits(DropDownFieldItem, _React$Component5);

  function DropDownFieldItem() {
    var _ref4;

    var _temp4, _this7, _ret4;

    _classCallCheck(this, DropDownFieldItem);

    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _ret4 = (_temp4 = (_this7 = _possibleConstructorReturn(this, (_ref4 = DropDownFieldItem.__proto__ || Object.getPrototypeOf(DropDownFieldItem)).call.apply(_ref4, [this].concat(args))), _this7), _this7.state = { active: false }, _temp4), _possibleConstructorReturn(_this7, _ret4);
  }

  _createClass(DropDownFieldItem, [{
    key: 'render',
    value: function render() {
      var _this8 = this;

      var _props5 = this.props,
          t = _props5.t,
          field = _props5.field,
          index = _props5.index,
          error = _props5.error,
          onUpdateField = _props5.onUpdateField;


      return _react2.default.createElement(
        _list.ListItem,
        { selectable: true, leftIcon: _fieldIcons2.default[field.type], theme: _fieldListItem2.default,
          className: error && 'error',
          caption: field.name, legend: field.value || field.required && t('label:値を入力してください'),
          onClick: function onClick() {
            return _this8.setState({ active: true });
          } },
        _react2.default.createElement(
          _dialog.Dialog,
          { active: this.state.active, theme: _scrollableDialog2.default,
            onEscKeyDown: function onEscKeyDown() {
              return _this8.setState({ active: false });
            },
            onOverlayClick: function onOverlayClick() {
              return _this8.setState({ active: false });
            },
            actions: [{ label: t('label:取り消し'), onClick: function onClick() {
                return _this8.setState({ active: false });
              } }] },
          _react2.default.createElement(
            _list.List,
            { selectable: true, ripple: true },
            _.map(field.options, function (item, i) {
              return _react2.default.createElement(_list.ListItem, { key: i, caption: item, onClick: function onClick() {
                  onUpdateField(index, item);
                  _this8.setState({ active: false });
                } });
            })
          )
        )
      );
    }
  }]);

  return DropDownFieldItem;
}(_react2.default.Component)) || _class8);
var DiaryFormsFields = (_dec6 = (0, _reactI18next.translate)(), _dec6(_class10 = function (_React$Component6) {
  _inherits(DiaryFormsFields, _React$Component6);

  function DiaryFormsFields() {
    _classCallCheck(this, DiaryFormsFields);

    return _possibleConstructorReturn(this, (DiaryFormsFields.__proto__ || Object.getPrototypeOf(DiaryFormsFields)).apply(this, arguments));
  }

  _createClass(DiaryFormsFields, [{
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          t = _props6.t,
          fields = _props6.fields,
          onUpdateField = _props6.onUpdateField;


      if (!fields || fields.length == 0) return null;

      return _react2.default.createElement(
        _list.List,
        { selectable: true, ripple: true, theme: _fieldListItem2.default },
        _.map(fields, function (field, i) {
          return field.type == 'date' && _react2.default.createElement(DateFieldItem, { key: i, field: field, error: fields[i + '.valueError'], index: i, onUpdateField: onUpdateField }) || field.type == 'time' && _react2.default.createElement(TimeFieldItem, { key: i, field: field, error: fields[i + '.valueError'], index: i, onUpdateField: onUpdateField }) || field.type == 'text' && _react2.default.createElement(TextFieldItem, { key: i, field: field, error: fields[i + '.valueError'], index: i, onUpdateField: onUpdateField }) || field.type == 'string' && _react2.default.createElement(StringFieldItem, { key: i, field: field, error: fields[i + '.valueError'], index: i, onUpdateField: onUpdateField }) || field.type == 'numeric' && _react2.default.createElement(StringFieldItem, { key: i, field: field, error: fields[i + '.valueError'], index: i, onUpdateField: onUpdateField }) || field.type == 'dropdown' && _react2.default.createElement(DropDownFieldItem, { key: i, field: field, error: fields[i + '.valueError'], index: i, onUpdateField: onUpdateField });
        })
      );
    }
  }]);

  return DiaryFormsFields;
}(_react2.default.Component)) || _class10);
exports.default = DiaryFormsFields;

/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2779);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./scrollable-dialog.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./scrollable-dialog.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.scrollable-dialog--body--jF9Pc1qU {\n  overflow: scroll;\n  padding: 4px;\n  margin: 20px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/scrollable-dialog.css"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;CACd","file":"scrollable-dialog.css","sourcesContent":["\n.body {\n  overflow: scroll;\n  padding: 4px;\n  margin: 20px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"body": "scrollable-dialog--body--jF9Pc1qU"
};

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2781);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./subject-input.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./subject-input.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "\n.subject-input--input--1U-vf3XE {\n  padding: 3px 0;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n\n.subject-input--inputElement--1EfSec-V {\n  background: white;\n  padding-left: 6px;\n}\n\n.subject-input--input--1U-vf3XE[class~=fluid] {\n  width: 100%;\n}\n\n.subject-input--hint--2bJ_bqi1 {\n  top: 15px;\n  left: 6px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/subject-input.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,oBAAoB;MAChB,YAAY;UACR,QAAQ;CACjB;;AAED;EACE,kBAAkB;EAClB,kBAAkB;CACnB;;AAED;EACE,YAAY;CACb;;AAED;EACE,UAAU;EACV,UAAU;CACX","file":"subject-input.css","sourcesContent":["\n.input {\n  padding: 3px 0;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n\n.inputElement {\n  background: white;\n  padding-left: 6px;\n}\n\n.input[class~=fluid] {\n  width: 100%;\n}\n\n.hint {\n  top: 15px;\n  left: 6px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"input": "subject-input--input--1U-vf3XE",
	"inputElement": "subject-input--inputElement--1EfSec-V",
	"hint": "subject-input--hint--2bJ_bqi1"
};

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDraftSelectionDialog = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _draftSelectionDialog = __webpack_require__(2783);

var _draftSelectionDialog2 = _interopRequireDefault(_draftSelectionDialog);

var _classnames = __webpack_require__(14);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _dialog = __webpack_require__(47);

var _list = __webpack_require__(25);

var _button = __webpack_require__(8);

var _scrollableDialogPanel = __webpack_require__(163);

var _scrollableDialogPanel2 = _interopRequireDefault(_scrollableDialogPanel);

var _actionDialog = __webpack_require__(224);

var _actionDialog2 = _interopRequireDefault(_actionDialog);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _diaryTimestamp = __webpack_require__(238);

var _diaryTimestamp2 = _interopRequireDefault(_diaryTimestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/draft-selection-dialog.jsx

var DraftSelectionDialog = function (_PureComponent) {
  _inherits(DraftSelectionDialog, _PureComponent);

  function DraftSelectionDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DraftSelectionDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraftSelectionDialog.__proto__ || Object.getPrototypeOf(DraftSelectionDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = { confirmId: undefined, isOpen: false }, _this.cancelDeleteMessage = function () {
      return _this.setState({ confirmId: undefined, isOpen: false });
    }, _this.onDeletePress = function (diary_id) {
      _this.props.deleteSavedDiary(diary_id);
      _this.setState({ confirmId: undefined });
    }, _this.onEditPress = function (diary_id) {
      _this.props.editSavedDiary(diary_id);
      _this.props.onClose();
    }, _this.onRightClick = function (diary_id) {
      return _this.setState({ confirmId: diary_id });
    }, _this.onOpen = function () {
      return _this.setState({ isOpen: true });
    }, _this.onDeleteAllPress = function (group_id) {
      _this.props.deleteAllSavedDiary(group_id);
      _this.setState({ isOpen: false });
    }, _this.getRowText = function (html) {
      if (!html || html.length == 0) return null;
      var rowText = html.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '').replace(/ ?:emoji-([-0-9a-f]+): ?/ig, '').replace(/^[ \t\n\r\f]+|\s+$/g, '');
      return rowText.slice(0, 50);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DraftSelectionDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          active = _props.active,
          diaries = _props.diaries,
          onClose = _props.onClose,
          isEdit = _props.isEdit,
          isFetching = _props.isFetching,
          updateUI = _props.updateUI,
          group = _props.group;


      if (!diaries) {
        return null;
      }

      return _react2.default.createElement(
        _dialog.Dialog,
        { active: active, theme: _actionDialog2.default,
          title: t('label:下書きを選択'),
          actions: [{ raised: true, label: t('label:取り消し'), onClick: onClose }],
          onOverlayClick: onClose,
          onEscKeyDown: onClose },
        _react2.default.createElement(
          _scrollableDialogPanel2.default,
          null,
          _react2.default.createElement(_button.Button, { icon: 'delete', label: t('label:全て削除'), raised: true, style: { marginLeft: 4, marginTop: 4 }, onClick: function onClick() {
              return _this2.onOpen();
            } }),
          _react2.default.createElement(
            _list.List,
            null,
            diaries && _lodash2.default.map(diaries, function (diary, i) {
              return _react2.default.createElement(
                'div',
                { key: i },
                _react2.default.createElement(_list.ListItem, { selectable: true, theme: _actionDialog2.default, className: 'text_hidden',
                  onClick: function onClick() {
                    return _this2.onEditPress(diary.diary_id);
                  },
                  caption: _this2.getRowText(diary.subject) || t('format:diary_subject', { reported_at: diary.reported_at, category: t('diary:' + diary.category) }),
                  legend: _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'div',
                      { style: { marginLeft: 3 } },
                      _this2.getRowText(diary.content)
                    ),
                    _react2.default.createElement(_diaryTimestamp2.default, { timestamp: diary.updated_at })
                  ),
                  rightActions: [_react2.default.createElement(_button.IconButton, { icon: 'close', key: 'icon',
                    onClick: function onClick() {
                      return _this2.onRightClick(diary.diary_id);
                    } })] }),
                _react2.default.createElement(_list.ListDivider, null),
                _react2.default.createElement(_confirmDialog2.default, { title: t('label:保存された投稿を削除してもいいですか'),
                  description: t('label:この操作は取り消せません'),
                  open: _this2.state.confirmId == diary.diary_id,
                  onYes: function onYes() {
                    return _this2.onDeletePress(diary.diary_id);
                  },
                  onNo: _this2.cancelDeleteMessage,
                  yesLabel: t('label:削除'),
                  noLabel: t('label:取り消し') })
              );
            })
          ),
          _react2.default.createElement(_confirmDialog2.default, { title: t('label:保存された全ての投稿を削除してもいいですか'),
            description: t('label:この操作は取り消せません'),
            open: this.state.isOpen,
            onYes: function onYes() {
              return _this2.onDeleteAllPress(group.group_id);
            },
            onNo: this.cancelDeleteMessage,
            yesLabel: t('label:削除'),
            noLabel: t('label:取り消し') })
        )
      );
    }
  }]);

  return DraftSelectionDialog;
}(_pureComponent2.default);

var RawDraftSelectionDialog = exports.RawDraftSelectionDialog = DraftSelectionDialog;
exports.default = (0, _draftSelectionDialog2.default)(DraftSelectionDialog);

/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/draft-selection-dialog.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.savedDiaries.isFetching
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    deleteSavedDiary: function deleteSavedDiary(diary_id) {
      return dispatch(_actions2.default.deleteSavedDiary(diary_id));
    },
    editSavedDiary: function editSavedDiary(diary_id) {
      return dispatch(_actions2.default.editDiary(diary_id));
    },
    deleteAllSavedDiary: function deleteAllSavedDiary(group_id) {
      return dispatch(_actions2.default.deleteAllSavedDiary(group_id));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawUnreadDiariesCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;
// src/web/components/unread-diaries-card.jsx

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = __webpack_require__(10);

var _diary = __webpack_require__(71);

var _diary2 = _interopRequireDefault(_diary);

var _unreadDiariesCard = __webpack_require__(2785);

var _unreadDiariesCard2 = _interopRequireDefault(_unreadDiariesCard);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnreadDiariesCard = (_dec = (0, _reactCssThemr.themr)('Diary', _diary2.default), _dec(_class = function (_React$Component) {
  _inherits(UnreadDiariesCard, _React$Component);

  function UnreadDiariesCard() {
    _classCallCheck(this, UnreadDiariesCard);

    return _possibleConstructorReturn(this, (UnreadDiariesCard.__proto__ || Object.getPrototypeOf(UnreadDiariesCard)).apply(this, arguments));
  }

  _createClass(UnreadDiariesCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          theme = _props.theme,
          group = _props.group,
          showUnreadTimeline = _props.showUnreadTimeline,
          flushUnreads = _props.flushUnreads,
          unreadCount = _props.unreadCount;


      if (!unreadCount) return null;

      return _react2.default.createElement(
        _card.Card,
        { theme: theme },
        _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', width: '100%' } },
            _react2.default.createElement(
              'div',
              { style: { flexGrow: 1, lineHeight: '36px' } },
              unreadCount < 10 && t('label:未読の投稿があります', { unreadCount: unreadCount }) || t('label:未読の投稿がたくさんあります')
            ),
            _react2.default.createElement(_button.Button, { raised: true, label: t('label:すべて開封にする'), onClick: flushUnreads }),
            _react2.default.createElement(_button.Button, { raised: true, primary: true, label: t('label:未読の投稿を開く'), onClick: showUnreadTimeline })
          )
        )
      );
    }
  }]);

  return UnreadDiariesCard;
}(_react2.default.Component)) || _class);
var RawUnreadDiariesCard = exports.RawUnreadDiariesCard = UnreadDiariesCard;
exports.default = (0, _unreadDiariesCard2.default)(UnreadDiariesCard);

/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/unread-diaries-card.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    unreadCount: ownProps.group && parseInt(ownProps.group.unreadCount),
    newItems: state.diaries.newItems
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    showUnreadTimeline: function showUnreadTimeline() {
      if (ownProps.group) {
        dispatch(_actions2.default.openRightSidePage('unread_timeline', { group_id: ownProps.group.group_id }));
        setTimeout(function () {
          return dispatch(_actions2.default.mergeNewDiaries(ownProps.group.group_id));
        }, 3000);
      } else dispatch(_actions2.default.mergeNewDiaries('home'));
    },

    flushUnreads: function flushUnreads() {
      dispatch(_actions2.default.mergeNewDiaries());
      dispatch(_actions2.default.closeRightSidePage(true));
      if (ownProps.group) {
        dispatch(_actions2.default.flushUnreadDiaries(ownProps.group.group_id));
        setTimeout(function () {
          dispatch(_actions2.default.fetchDiaries(ownProps.group.group_id, 0));
          dispatch(_actions2.default.fetchGroupUnreadCount(ownProps.group.group_id));
        }, 500);
      }
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _inviteMembersDialog = __webpack_require__(2787);

var _inviteMembersDialog2 = _interopRequireDefault(_inviteMembersDialog);

var _reactI18next = __webpack_require__(2);

var _dialog = __webpack_require__(47);

var _dialog2 = _interopRequireDefault(_dialog);

var _button = __webpack_require__(8);

var _button2 = _interopRequireDefault(_button);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _analytics = __webpack_require__(27);

var _inviteIcon = __webpack_require__(2789);

var _inviteIcon2 = _interopRequireDefault(_inviteIcon);

var _inviteMembersDialog3 = __webpack_require__(2792);

var _inviteMembersDialog4 = _interopRequireDefault(_inviteMembersDialog3);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * src/web/components/invite-members-dialog.jsx
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * メンバー招待ダイアログ
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var InviteMembersDialog = function (_React$Component) {
  _inherits(InviteMembersDialog, _React$Component);

  function InviteMembersDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InviteMembersDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InviteMembersDialog.__proto__ || Object.getPrototypeOf(InviteMembersDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = { already_display: false }, _this.openURL = function () {
      _this.onClose();
      (0, _analytics.track)('invite_users');
    }, _this.onChangeCheckBox = function () {
      _this.props.setIsHiddenToStore(!_this.props.ui.isHidden);
      _this.props.updateUI({ isHidden: !_this.props.ui.isHidden });
    }, _this.onClose = function () {
      _this.props.updateUI({ active: false });
      _this.props.onHide();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InviteMembersDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          usersAdminUrl = _props.usersAdminUrl,
          registrationUrl = _props.registrationUrl,
          already_display = _props.already_display,
          onHide = _props.onHide;


      return _react2.default.createElement(
        _dialog2.default,
        { active: !already_display && ui.active,
          theme: _inviteMembersDialog4.default,
          type: 'small',
          onEscKeyDown: this.onClose,
          onOverlayClick: this.onClose,
          title: t('label:ウェルカムメッセージ'),
          actions: [{ label: t('label:閉じる'), onClick: this.onClose, raised: true }] },
        _react2.default.createElement(
          'div',
          { className: _inviteMembersDialog4.default.subTitle },
          t('label:無料ウェブ説明')
        ),
        _react2.default.createElement(
          'div',
          null,
          t('label:ウェブ説明詳細')
        ),
        _react2.default.createElement(
          'div',
          { className: _inviteMembersDialog4.default.image },
          _react2.default.createElement('img', { className: _inviteIcon2.default.image })
        ),
        _react2.default.createElement(
          'div',
          { className: _inviteMembersDialog4.default.inviteButton },
          _react2.default.createElement(
            _button2.default,
            {
              className: _inviteMembersDialog4.default.inviteMenu,
              onClick: this.openURL,
              href: _config2.default.timerexUrl,
              primary: true, raised: true,
              target: '_blank' },
            t('label:ウェブ説明予約(WEB版)')
          )
        )
      );
    }
  }]);

  return InviteMembersDialog;
}(_react2.default.Component);

exports.default = (0, _inviteMembersDialog2.default)(InviteMembersDialog);

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _inviteMembersDialogStore = __webpack_require__(2788);

var _inviteMembersDialogStore2 = _interopRequireDefault(_inviteMembersDialogStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/invite-members-dialog.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: state.user.current,
    registrationUrl: state.registrationUrl.url
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount(props) {
      _inviteMembersDialogStore2.default.get(function (isHidden) {
        props.updateUI({ isHidden: !!isHidden });
      });
      dispatch(_actions2.default.getRegistrationUrl(props.group.group_id));
    },

    willUpdate: function willUpdate(props, nextProps) {
      if (props.group.group_id != nextProps.group.group_id) {
        dispatch(_actions2.default.getRegistrationUrl(nextProps.group.group_id));
      }

      if (!props.ui.active && !nextProps.ui.isHidden) {
        nextProps.updateUI({ active: true });
      }
    },

    setIsHiddenToStore: function setIsHiddenToStore(isHidden) {
      return _inviteMembersDialogStore2.default.set(isHidden);
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _uiState2.default)({ state: {
    active: false,
    isHidden: false
  } }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _permanentStore = __webpack_require__(118);

var _permanentStore2 = _interopRequireDefault(_permanentStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEY = "gambaApp.invite-members-dialog"; /**
                                             * src/actions/invite-members-dialog-store.js
                                             * localStorageに対し、メンバー招待ダイアログ（トライアル中表示）の表示／非表示を格納、取得、クリア
                                             */

exports.default = (0, _permanentStore2.default)(KEY);

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2790);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./invite-icon.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./invite-icon.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".invite-icon--image--1s76cQk9 {\n  vertical-align: middle;\n  width: 300px;\n  height: 240px;\n  text-align: center;\n  content: url(" + __webpack_require__(2791) + ");\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/invite-icon.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uCAA8C;CAC/C","file":"invite-icon.css","sourcesContent":[".image {\n  vertical-align: middle;\n  width: 300px;\n  height: 240px;\n  text-align: center;\n  content: url('../../images/login-dialog.png');\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"image": "invite-icon--image--1s76cQk9"
};

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "391f8ec82eaf827442a65b4640194c46.png";

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2793);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./invite-members-dialog.css", function() {
			var newContent = require("!!../../../../../../../shared/rnclient/node_modules/css-loader/index.js??ref--1-1!../../../../../../../shared/rnclient/node_modules/postcss-loader/lib/index.js!./invite-members-dialog.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".invite-members-dialog--dialog--3OQCGoK4 {\n  width: 500px;\n}\n\n.invite-members-dialog--body--35JPt-HW {\n  padding-bottom: 0px;\n  font-size: 14px;\n  margin-top:  10px;\n  text-align: center;\n  color: black;\n}\n\n.invite-members-dialog--field--2d_Ngyrd {\n  margin-bottom: 0px;\n}\n\n.invite-members-dialog--navigation--25yRuCNG {\n  padding-top: 0px;\n}\n\n.invite-members-dialog--inviteMenu--2zCF3Owz {\n  color: black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  width: 450px;\n}\n\n.invite-members-dialog--button--1aUaLTjF {\n  text-align: center;\n}\n\n.invite-members-dialog--inviteMenuList--23JMNa2V {\n  width: 180px;\n  margin: auto;\n}\n\n.invite-members-dialog--href--2D9r5ybD {\n  text-decoration: none;\n  color: black;\n}\n\n.invite-members-dialog--inviteMenuText--3Fy3wOWy {\n  vertical-align: middle;\n  margin-left: 10px;\n}\n\n.invite-members-dialog--checkbox--26MvI4_x {\n  margin-top: 20px;\n  margin-bottom: 0px;\n}\n\n.invite-members-dialog--title--ycExQg54 {\n  text-align: center;\n}\n\n.invite-members-dialog--subTitle--pGCX0u9p {\n  white-space: pre-line;\n  line-height: 0.8;\n  color: black;\n  text-align: center;\n  padding-top: 5px;\n  padding-bottom: 10px;\n  font-size: 18px;\n}\n\n.invite-members-dialog--image--1NO-in1L {\n  margin-top: 10px;\n}", "", {"version":3,"sources":["/./src/web/components/themes/invite-members-dialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;CACd;;AAED;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;CACd;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;CACd;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,aAAa;EACb,aAAa;CACd;;AAED;EACE,sBAAsB;EACtB,aAAa;CACd;;AAED;EACE,uBAAuB;EACvB,kBAAkB;CACnB;;AAED;EACE,iBAAiB;EACjB,mBAAmB;CACpB;;AAED;EACE,mBAAmB;CACpB;;AAED;EACE,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;CACjB;;AAED;EACE,iBAAiB;CAClB","file":"invite-members-dialog.css","sourcesContent":[".dialog {\n  width: 500px;\n}\n\n.body {\n  padding-bottom: 0px;\n  font-size: 14px;\n  margin-top:  10px;\n  text-align: center;\n  color: black;\n}\n\n.field {\n  margin-bottom: 0px;\n}\n\n.navigation {\n  padding-top: 0px;\n}\n\n.inviteMenu {\n  color: black;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  width: 450px;\n}\n\n.button {\n  text-align: center;\n}\n\n.inviteMenuList {\n  width: 180px;\n  margin: auto;\n}\n\n.href {\n  text-decoration: none;\n  color: black;\n}\n\n.inviteMenuText {\n  vertical-align: middle;\n  margin-left: 10px;\n}\n\n.checkbox {\n  margin-top: 20px;\n  margin-bottom: 0px;\n}\n\n.title {\n  text-align: center;\n}\n\n.subTitle {\n  white-space: pre-line;\n  line-height: 0.8;\n  color: black;\n  text-align: center;\n  padding-top: 5px;\n  padding-bottom: 10px;\n  font-size: 18px;\n}\n\n.image {\n  margin-top: 10px;\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"dialog": "invite-members-dialog--dialog--3OQCGoK4",
	"body": "invite-members-dialog--body--35JPt-HW",
	"field": "invite-members-dialog--field--2d_Ngyrd",
	"navigation": "invite-members-dialog--navigation--25yRuCNG",
	"inviteMenu": "invite-members-dialog--inviteMenu--2zCF3Owz",
	"button": "invite-members-dialog--button--1aUaLTjF",
	"inviteMenuList": "invite-members-dialog--inviteMenuList--23JMNa2V",
	"href": "invite-members-dialog--href--2D9r5ybD",
	"inviteMenuText": "invite-members-dialog--inviteMenuText--3Fy3wOWy",
	"checkbox": "invite-members-dialog--checkbox--26MvI4_x",
	"title": "invite-members-dialog--title--ycExQg54",
	"subTitle": "invite-members-dialog--subTitle--pGCX0u9p",
	"image": "invite-members-dialog--image--1NO-in1L"
};

/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawHomeGroupsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _homeGroupsPage = __webpack_require__(2795);

var _homeGroupsPage2 = _interopRequireDefault(_homeGroupsPage);

var _layout = __webpack_require__(85);

var _button = __webpack_require__(8);

var _homeGroupsNav = __webpack_require__(2796);

var _homeGroupsNav2 = _interopRequireDefault(_homeGroupsNav);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _infiniteScroller = __webpack_require__(75);

var _twoColumnLayout = __webpack_require__(205);

var _twoColumnLayout2 = _interopRequireDefault(_twoColumnLayout);

var _oneColumnLayout = __webpack_require__(386);

var _oneColumnLayout2 = _interopRequireDefault(_oneColumnLayout);

var _diary = __webpack_require__(171);

var _diary2 = _interopRequireDefault(_diary);

var _groupMemberIcons = __webpack_require__(1061);

var _groupMemberIcons2 = _interopRequireDefault(_groupMemberIcons);

var _rightSidebar = __webpack_require__(389);

var _rightSidebar2 = _interopRequireDefault(_rightSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/home-groups-page.jsx

var HomeGroupsPage = function (_PureComponent) {
  _inherits(HomeGroupsPage, _PureComponent);

  function HomeGroupsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HomeGroupsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HomeGroupsPage.__proto__ || Object.getPrototypeOf(HomeGroupsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { responses: [], reviewTarget: undefined }, _this.loadMore = function () {
      return _this.props.fetchDiaries(_this.props);
    }, _this.loader = _react2.default.createElement(
      'div',
      { style: { width: '100%', textAlign: 'center' } },
      _react2.default.createElement(_progress_bar2.default, { type: 'circular', mode: 'indeterminate', multicolor: true })
    ), _this.onReplyScrollFrom = function (offset) {
      //COMMENT_FORM_HEIGHTはコメントフォームの高さ
      var COMMENT_FORM_HEIGHT = 222;
      //返信コメントへの返信の場合、コメントフォームまでスクロールする
      _this.refs.panel && (_reactDom2.default.findDOMNode(_this.refs.panel).scrollTop += offset + COMMENT_FORM_HEIGHT);
    }, _this.openSearchDrawer = function () {
      return _this.props.updateUI({ openDrawer: !_this.props.ui.openDrawer });
    }, _this.setReviewTarget = function (target) {
      return _this.setState({ reviewTarget: target });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HomeGroupsPage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          diaries = _props.diaries,
          user = _props.user,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          isRightSidebar = _props.isRightSidebar,
          hasMore = _props.hasMore,
          params = _props.params,
          location = _props.location,
          fetchDiaries = _props.fetchDiaries,
          children = _props.children,
          likeConfig = _props.likeConfig;

      var parentTheme = isRightSidebar ? _twoColumnLayout2.default : _oneColumnLayout2.default;

      return _react2.default.createElement(
        _layout.Panel,
        { style: { height: '100vh', position: 'fixed' } },
        _react2.default.createElement(_homeGroupsNav2.default, { openSearchDrawer: this.openSearchDrawer, openDrawer: ui.openDrawer }),
        _react2.default.createElement(
          _layout.Layout,
          { theme: parentTheme },
          _react2.default.createElement(
            _layout.Panel,
            { bodyScroll: true, theme: parentTheme, style: { left: 0 }, ref: 'panel' },
            !diaries && isFetching && _react2.default.createElement(_loading2.default, null),
            _react2.default.createElement(
              _infiniteScroller.InfiniteScroll,
              { pageStart: 0,
                hasMore: hasMore && !isFetchFailed,
                initialLoad: false,
                loadMore: this.loadMore,
                loader: diaries && this.loader,
                useWindow: false },
              diaries && diaries.map(function (diary) {
                return _react2.default.createElement(_diary2.default, { key: diary.diary_id, diary: diary, user: user, onReplyScrollFrom: _this2.onReplyScrollFrom, likeConfig: likeConfig, openSidePage: isRightSidebar, chatGptReview: _this2.state.responses, clearGptReview: _this2.clearGptReview, sendChatGPT: _this2.sendMessage, reviewTarget: _this2.state.reviewTarget, setReviewTarget: _this2.setReviewTarget });
              }) || []
            ),
            diaries && diaries.length == 0 && !hasMore && !isFetchFailed && _react2.default.createElement(
              'div',
              { style: { padding: '20px' } },
              t('label:投稿がありません')
            ),
            diaries && diaries.length > 0 && !hasMore && !isFetchFailed && _react2.default.createElement(
              'div',
              { style: { fontSize: '80%', padding: '0 20px', color: '#999' } },
              t('label:一番最後の投稿です')
            ),
            isFetchFailed && _react2.default.createElement(
              'div',
              { style: { padding: '20px' } },
              _react2.default.createElement(
                'div',
                { style: { fontSize: '90%', marginBottom: '10px' } },
                t('error:読み込みに失敗しました')
              ),
              _react2.default.createElement(_button.Button, { raised: true,
                onClick: function onClick() {
                  return fetchDiaries(_this2.props, true);
                },
                label: t('label:再読み込み'),
                style: { width: '100%' } })
            )
          ),
          isRightSidebar && _react2.default.createElement(
            _layout.Sidebar,
            { theme: _twoColumnLayout2.default, pinned: true, scrollY: true, width: 50 },
            _react2.default.createElement(
              _rightSidebar2.default,
              { user: user },
              children
            )
          )
        )
      );
    }
  }]);

  return HomeGroupsPage;
}(_pureComponent2.default);

var RawHomeGroupsPage = exports.RawHomeGroupsPage = HomeGroupsPage;
exports.default = (0, _homeGroupsPage2.default)(HomeGroupsPage);

/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _analytics = __webpack_require__(27);

var _socketRsync = __webpack_require__(144);

var _socketRsync2 = _interopRequireDefault(_socketRsync);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _agentType = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/home-groups-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var diaries = state.diaries.groups.home;

  return {
    user: state.user.current,
    isFetching: diaries && diaries.isFetching,
    isFetchFailed: diaries && diaries.isFetchFailed,
    hasMore: diaries && diaries.hasMore,
    diaries: diaries && diaries.items,
    isRightSidebar: (state.rightSidePage.name || ownProps.children) && true,
    isPhone: state.media.isPhone,
    rightSidePage: state.rightSidePage,
    likeConfig: state.likes.likeConfig,
    binding: true
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    fetchDiaries: dispatchProps.fetchDiaries.bind(stateProps)
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  function _readDiary(props, diary) {
    var read = diary.user.user_id == props.user.user_id || diary.readers && (0, _find2.default)(diary.readers, function (reader) {
      return reader.user.user_id == props.user.user_id;
    });
    if (!read) {
      !props.emitSocket('mark_as_read', { diary_id: diary.diary_id }) && dispatch(_actions2.default.markDiaryRead(diary.diary_id));
    }
  }

  return {
    fetchDiaries: function fetchDiaries(props) {
      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this && this.binding) props = this;
      if (props.isFetching || props.isFetchFailed && !reset) return;
      var offset = reset ? 0 : props.diaries && props.diaries.length || 0;
      dispatch(_actions2.default.fetchHomeDiaries(offset));
    },

    openSearchDrawer: function openSearchDrawer(props) {
      return dispatch(_actions2.default.openRightSidePage('search_drawer', { group_id: 'home' }));
    },
    clearDiaries: function clearDiaries() {
      return dispatch(_actions2.default.clearDiaries('home'));
    },
    closeRightSidePage: function closeRightSidePage() {
      return dispatch(_actions2.default.closeRightSidePage(true));
    },

    readDiary: _readDiary,
    _readDiary: _readDiary,
    willMount: function willMount() {
      dispatch(_actions2.default.fetchHomeNotificationsUnreadCount());
      dispatch(_actions2.default.fetchHomeDiaries(0));
    },

    willUnmount: function willUnmount() {
      dispatch(_actions2.default.closeRightSidePage(true));
      dispatch(_actions2.default.clearPreservedQueries());
    },

    receiveSocket: function receiveSocket(message, message_type, props) {
      switch (message_type) {
        case 'diary':
          dispatch(_actions2.default.loadDiary(Object.assign({}, message.diary, { group: message.group }), {
            appending: message.appending,
            own_post: message.diary.user.user_id == props.user.user_id,
            group_id: 'home'
          }));
          break;
        case 'diary_delete':
          dispatch(_actions2.default.loadDiary(message.diary, { deleted: true, group_id: 'home' }));
          break;
        case 'notification':
          dispatch(_actions2.default.loadHomeNotificationUnreadCount(message.home_count));
          break;
      }
    },

    requestSync: function requestSync() {
      dispatch(_actions2.default.fetchHomeNotificationsUnreadCount());
      dispatch(_actions2.default.fetchHomeDiaries(0));
    },
    // webでsearch-drawerを開くために必要
    editSearchDrawer: function editSearchDrawer(props) {
      return props.updateUI({ openDrawer: true });
    }
  };
};

exports.default = (0, _combineHoc2.default)(_socketRsync.requireSocketEmit, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _socketRsync2.default)('notification', 'diary', 'diary_delete'), (0, _uiState2.default)({ state: { active: false, openDrawer: false } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('home_timeline'), (0, _context.inject)({ _readDiary: _propTypes2.default.func, editSearchDrawer: _propTypes2.default.func }));

/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawHomeGroupsNav = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _homeGroupsNav = __webpack_require__(2797);

var _homeGroupsNav2 = _interopRequireDefault(_homeGroupsNav);

var _reactNotificationBadge = __webpack_require__(186);

var _reactNotificationBadge2 = _interopRequireDefault(_reactNotificationBadge);

var _app_bar = __webpack_require__(122);

var _button = __webpack_require__(8);

var _navigation = __webpack_require__(147);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _searchDrawer = __webpack_require__(370);

var _searchDrawer2 = _interopRequireDefault(_searchDrawer);

var _noWrappedNavigation = __webpack_require__(371);

var _noWrappedNavigation2 = _interopRequireDefault(_noWrappedNavigation);

var _appBar = __webpack_require__(372);

var _appBar2 = _interopRequireDefault(_appBar);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _animationCss = __webpack_require__(184);

var _animationCss2 = _interopRequireDefault(_animationCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-nav.jsx

var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);

var HomeGroupsNav = function (_React$Component) {
  _inherits(HomeGroupsNav, _React$Component);

  function HomeGroupsNav() {
    _classCallCheck(this, HomeGroupsNav);

    return _possibleConstructorReturn(this, (HomeGroupsNav.__proto__ || Object.getPrototypeOf(HomeGroupsNav)).apply(this, arguments));
  }

  _createClass(HomeGroupsNav, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.title = this.props.notificationUnreadCount > 0 ? '(' + this.props.notificationUnreadCount + ') ' + this.props.t('label:すべてのグループ') + ' - gamba!' : this.props.t('label:すべてのグループ') + ' - gamba!';
    }
  }, {
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps) {
      //未読通知があるか判定
      if (this.props.notificationUnreadCount != nextProps.notificationUnreadCount) document.title = nextProps.notificationUnreadCount > 0 ? '(' + nextProps.notificationUnreadCount + ') ' + this.props.t('label:すべてのグループ') + ' - gamba!' : this.props.t('label:すべてのグループ') + ' - gamba!';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          sidebarDocked = _props.sidebarDocked,
          onLeftIconClick = _props.onLeftIconClick,
          isPhone = _props.isPhone,
          notificationUnreadCount = _props.notificationUnreadCount,
          showNotifications = _props.showNotifications,
          showChatRooms = _props.showChatRooms,
          chatUnreadCount = _props.chatUnreadCount,
          blinkChatButton = _props.blinkChatButton,
          openSearchDrawer = _props.openSearchDrawer,
          openDrawer = _props.openDrawer;


      return _react2.default.createElement(
        _app_bar.AppBar,
        { leftIcon: isPhone && 'menu' || '',
          onLeftIconClick: onLeftIconClick,
          theme: _appBar2.default },
        _react2.default.createElement(
          'div',
          { style: { marginRight: 'auto' } },
          !isPhone && _react2.default.createElement(
            'div',
            { style: { display: 'inline' } },
            _react2.default.createElement(_avatar2.default, { icon: 'home' }),
            '\xA0'
          ),
          _react2.default.createElement(
            'b',
            null,
            t('label:すべてのグループ')
          )
        ),
        _react2.default.createElement(
          _navigation.Navigation,
          { type: 'horizontal', theme: _noWrappedNavigation2.default },
          _react2.default.createElement(_reactNotificationBadge2.default, { count: notificationUnreadCount,
            containerStyle: { position: 'absolute', top: '10px', right: '50px' },
            effect: _reactNotificationBadge.Effect.SCALE }),
          _react2.default.createElement(_reactNotificationBadge2.default, { count: chatUnreadCount,
            containerStyle: { position: 'absolute', top: '10px', right: '0px' },
            effect: _reactNotificationBadge.Effect.SCALE }),
          _react2.default.createElement(TooltipIconButton, { inverse: true,
            tooltip: t('label:検索'),
            icon: 'search',
            onClick: openSearchDrawer }),
          _react2.default.createElement(TooltipIconButton, { inverse: true,
            tooltip: t('label:新着の通知'),
            icon: 'notifications' + (!notificationUnreadCount && '_none' || ''),
            onClick: showNotifications }),
          _react2.default.createElement(TooltipIconButton, _extends({ inverse: true
          }, (0, _animationCss2.default)(blinkChatButton), {
            tooltip: t('label:チャット'),
            icon: 'comment',
            onClick: showChatRooms })),
          _react2.default.createElement(_searchDrawer2.default, { active: openDrawer, group: { group_id: 'home' }, onClose: openSearchDrawer })
        )
      );
    }
  }]);

  return HomeGroupsNav;
}(_react2.default.Component);

var RawHomeGroupsNav = exports.RawHomeGroupsNav = HomeGroupsNav;
exports.default = (0, _homeGroupsNav2.default)(HomeGroupsNav);

/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/home-groups-nav.js

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var unreadCount = state.notifications.unreadCount;

  return {
    isPhone: state.media.isPhone,
    notificationUnreadCount: unreadCount && unreadCount.home,
    chatUnreadCount: state.chatRooms.unreadCount,
    announce: !state.announce.close,
    firstLogin: state.user.firstLogin,
    productTour: state.productTour.state
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, stateProps, dispatchProps, ownProps, {
    blinkChatButton: stateProps.firstLogin && (!stateProps.productTour || stateProps.productTour.chatRoom != 'hide')
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onLeftIconClick: function onLeftIconClick() {
      return dispatch(_actions2.default.openSidebar());
    },
    showNotifications: function showNotifications() {
      return dispatch(_actions2.default.openRightSidePage('notifications', { group_id: 'home' }));
    },
    showChatRooms: function showChatRooms() {
      return dispatch(_actions2.default.openRightSidePage('chat_rooms', {}));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: { searchDrawer: false } }), (0, _reactI18next.translate)());

/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDivisionGroupsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _divisionGroupsPage = __webpack_require__(2799);

var _divisionGroupsPage2 = _interopRequireDefault(_divisionGroupsPage);

var _layout = __webpack_require__(85);

var _button = __webpack_require__(8);

var _divisionGroupsNav = __webpack_require__(2800);

var _divisionGroupsNav2 = _interopRequireDefault(_divisionGroupsNav);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _infiniteScroller = __webpack_require__(75);

var _twoColumnLayout = __webpack_require__(205);

var _twoColumnLayout2 = _interopRequireDefault(_twoColumnLayout);

var _oneColumnLayout = __webpack_require__(386);

var _oneColumnLayout2 = _interopRequireDefault(_oneColumnLayout);

var _diary = __webpack_require__(171);

var _diary2 = _interopRequireDefault(_diary);

var _rightSidebar = __webpack_require__(389);

var _rightSidebar2 = _interopRequireDefault(_rightSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/division-groups-page.jsx

var DivisionGroupsPage = function (_PureComponent) {
  _inherits(DivisionGroupsPage, _PureComponent);

  function DivisionGroupsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DivisionGroupsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DivisionGroupsPage.__proto__ || Object.getPrototypeOf(DivisionGroupsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { responses: [], reviewTarget: undefined }, _this.loadMore = function () {
      return _this.props.fetchDiaries(_this.props);
    }, _this.loader = _react2.default.createElement(
      'div',
      { style: { width: '100%', textAlign: 'center' } },
      _react2.default.createElement(_progress_bar2.default, { type: 'circular', mode: 'indeterminate', multicolor: true })
    ), _this.onReplyScrollFrom = function (offset) {
      //COMMENT_FORM_HEIGHTはコメントフォームの高さ
      var COMMENT_FORM_HEIGHT = 222;
      //返信コメントへの返信の場合、コメントフォームまでスクロールする
      _this.refs.panel && (_reactDom2.default.findDOMNode(_this.refs.panel).scrollTop += offset + COMMENT_FORM_HEIGHT);
    }, _this.openSearchDrawer = function () {
      return _this.props.updateUI({ openDrawer: !_this.props.ui.openDrawer });
    }, _this.setReviewTarget = function (target) {
      return _this.setState({ reviewTarget: target });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DivisionGroupsPage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          diaries = _props.diaries,
          user = _props.user,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          isRightSidebar = _props.isRightSidebar,
          hasMore = _props.hasMore,
          params = _props.params,
          location = _props.location,
          fetchDiaries = _props.fetchDiaries,
          children = _props.children,
          likeConfig = _props.likeConfig;

      var parentTheme = isRightSidebar ? _twoColumnLayout2.default : _oneColumnLayout2.default;

      return _react2.default.createElement(
        _layout.Panel,
        { style: { height: '100vh', position: 'fixed' } },
        _react2.default.createElement(_divisionGroupsNav2.default, { division_id: params.division_id, openSearchDrawer: this.openSearchDrawer, openDrawer: ui.openDrawer }),
        _react2.default.createElement(
          _layout.Layout,
          { theme: parentTheme },
          _react2.default.createElement(
            _layout.Panel,
            { bodyScroll: true, theme: parentTheme, style: { left: 0 }, ref: 'panel' },
            !diaries && isFetching && _react2.default.createElement(_loading2.default, null),
            _react2.default.createElement(
              _infiniteScroller.InfiniteScroll,
              { pageStart: 0,
                hasMore: hasMore && !isFetchFailed,
                initialLoad: false,
                loadMore: this.loadMore,
                loader: diaries && this.loader,
                useWindow: false },
              diaries && diaries.map(function (diary) {
                return _react2.default.createElement(_diary2.default, { key: diary.diary_id, diary: diary, user: user, onReplyScrollFrom: _this2.onReplyScrollFrom, likeConfig: likeConfig, openSidePage: isRightSidebar, setReviewTarget: _this2.setReviewTarget, chatGptReview: _this2.state.responses, clearGptReview: _this2.clearGptReview, sendChatGPT: _this2.sendMessage, reviewTarget: _this2.state.reviewTarget });
              }) || []
            ),
            diaries && diaries.length == 0 && !hasMore && !isFetchFailed && _react2.default.createElement(
              'div',
              { style: { padding: '20px' } },
              t('label:投稿がありません')
            ),
            diaries && diaries.length > 0 && !hasMore && !isFetchFailed && _react2.default.createElement(
              'div',
              { style: { fontSize: '80%', padding: '0 20px', color: '#999' } },
              t('label:一番最後の投稿です')
            ),
            isFetchFailed && _react2.default.createElement(
              'div',
              { style: { padding: '20px' } },
              _react2.default.createElement(
                'div',
                { style: { fontSize: '90%', marginBottom: '10px' } },
                t('error:読み込みに失敗しました')
              ),
              _react2.default.createElement(_button.Button, { raised: true,
                onClick: function onClick() {
                  return fetchDiaries(_this2.props, true);
                },
                label: t('label:再読み込み'),
                style: { width: '100%' } })
            )
          ),
          isRightSidebar && _react2.default.createElement(
            _layout.Sidebar,
            { theme: _twoColumnLayout2.default, pinned: true, scrollY: true, width: 50 },
            _react2.default.createElement(
              _rightSidebar2.default,
              { user: user },
              children
            )
          )
        )
      );
    }
  }]);

  return DivisionGroupsPage;
}(_pureComponent2.default);

var RawDivisionGroupsPage = exports.RawDivisionGroupsPage = DivisionGroupsPage;
exports.default = (0, _divisionGroupsPage2.default)(DivisionGroupsPage);

/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _analytics = __webpack_require__(27);

var _socketRsync = __webpack_require__(144);

var _socketRsync2 = _interopRequireDefault(_socketRsync);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _agentType = __webpack_require__(142);

var _store = __webpack_require__(18);

var _route = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/division-groups-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var diaries = state.diaries.groups.home;
  var division = (0, _store.getArray)('division_id', state.divisions.items, state.divisions.currentId) || undefined;

  return {
    user: state.user.current,
    isFetching: diaries && diaries.isFetching,
    isFetchFailed: diaries && diaries.isFetchFailed,
    hasMore: diaries && diaries.hasMore,
    diaries: diaries && diaries.items,
    isRightSidebar: (state.rightSidePage.name || ownProps.children) && true,
    isPhone: state.media.isPhone,
    rightSidePage: state.rightSidePage,
    likeConfig: state.likes.likeConfig,
    binding: true,
    currentDivisionId: state.divisions.currentId,
    divisionSettings: state.divisionSettings,
    division: division
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    fetchDiaries: dispatchProps.fetchDiaries.bind(stateProps)
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  function _readDiary(props, diary) {
    var read = diary.user.user_id == props.user.user_id || diary.readers && (0, _find2.default)(diary.readers, function (reader) {
      return reader.user.user_id == props.user.user_id;
    });
    if (!read) {
      !props.emitSocket('mark_as_read', { diary_id: diary.diary_id }) && dispatch(_actions2.default.markDiaryRead(diary.diary_id));
    }
  }

  return {
    fetchDiaries: function fetchDiaries(props) {
      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this && this.binding) props = this;
      if (props.isFetching || props.isFetchFailed && !reset) return;
      var offset = reset ? 0 : props.diaries && props.diaries.length || 0;
      dispatch(_actions2.default.fetchHomeDiaries(offset, props.currentDivisionId));
    },

    openSearchDrawer: function openSearchDrawer(props) {
      return dispatch(_actions2.default.openRightSidePage('search_drawer', { group_id: 'home' }));
    },
    clearDiaries: function clearDiaries() {
      return dispatch(_actions2.default.clearDiaries('home'));
    },
    closeRightSidePage: function closeRightSidePage() {
      return dispatch(_actions2.default.closeRightSidePage(true));
    },

    readDiary: _readDiary,
    _readDiary: _readDiary,

    willMount: function willMount(props) {
      var division_id = props.params.division_id;

      dispatch(_actions2.default.fetchHomeNotificationsUnreadCount(division_id));
      dispatch(_actions2.default.fetchHomeDiaries(0, division_id));
      if (props.params && props.params.division_id) dispatch(_actions2.default.setCurrentDivisionId(props.params.division_id));
    },

    willUnmount: function willUnmount() {
      dispatch(_actions2.default.closeRightSidePage(true));
      dispatch(_actions2.default.clearPreservedQueries());
    },
    willUpdate: function willUpdate(props, nextProps) {
      if (props.division && !nextProps.division) {
        (0, _route.replaceRoute)('main');
      }
      if (props.params.division_id != nextProps.params.division_id) {
        dispatch(_actions2.default.closeRightSidePage(true));
        var division_id = nextProps.params.division_id;

        dispatch(_actions2.default.fetchHomeNotificationsUnreadCount(division_id));
        dispatch(_actions2.default.fetchHomeDiaries(0, division_id));
        dispatch(_actions2.default.setCurrentDivisionId(nextProps.params.division_id));
      }
    },

    receiveSocket: function receiveSocket(message, message_type, props) {
      switch (message_type) {
        case 'diary':
          dispatch(_actions2.default.loadDiary(Object.assign({}, message.diary, { group: message.group }), {
            appending: message.appending,
            own_post: message.diary.user.user_id == props.user.user_id,
            group_id: 'home'
          }));
          break;
        case 'diary_delete':
          dispatch(_actions2.default.loadDiary(message.diary, { deleted: true, group_id: 'home' }));
          break;
        case 'notification':
          dispatch(_actions2.default.loadHomeNotificationUnreadCount(message.home_count));
          break;
      }
    },

    requestSync: function requestSync(props) {
      var division_id = props.params.division_id;

      dispatch(_actions2.default.fetchHomeNotificationsUnreadCount(division_id));
      dispatch(_actions2.default.fetchHomeDiaries(0, division_id));
    },
    // webでsearch-drawerを開くために必要
    editSearchDrawer: function editSearchDrawer(props) {
      return props.updateUI({ openDrawer: true });
    },
    closeDivisionSettingsPage: function closeDivisionSettingsPage() {
      return dispatch(_actions2.default.closeDivisionSettingsPage());
    }
  };
};

exports.default = (0, _combineHoc2.default)(_socketRsync.requireSocketEmit, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _socketRsync2.default)('notification', 'diary', 'diary_delete'), (0, _uiState2.default)({ state: { active: false, openDrawer: false } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _context.inject)({ _readDiary: _propTypes2.default.func, editSearchDrawer: _propTypes2.default.func }), (0, _analytics.trackPage)('division_timeline'));

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDivisionGroupsNav = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _divisionGroupsNav = __webpack_require__(2801);

var _divisionGroupsNav2 = _interopRequireDefault(_divisionGroupsNav);

var _reactNotificationBadge = __webpack_require__(186);

var _reactNotificationBadge2 = _interopRequireDefault(_reactNotificationBadge);

var _app_bar = __webpack_require__(122);

var _button = __webpack_require__(8);

var _navigation = __webpack_require__(147);

var _menu = __webpack_require__(63);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _searchDrawer = __webpack_require__(370);

var _searchDrawer2 = _interopRequireDefault(_searchDrawer);

var _divisionSettingsPage = __webpack_require__(2802);

var _divisionSettingsPage2 = _interopRequireDefault(_divisionSettingsPage);

var _noWrappedNavigation = __webpack_require__(371);

var _noWrappedNavigation2 = _interopRequireDefault(_noWrappedNavigation);

var _appBar = __webpack_require__(372);

var _appBar2 = _interopRequireDefault(_appBar);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _animationCss = __webpack_require__(184);

var _animationCss2 = _interopRequireDefault(_animationCss);

var _zIndexMenu = __webpack_require__(536);

var _zIndexMenu2 = _interopRequireDefault(_zIndexMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/division-groups-nav.jsx

var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);
var TooltipIconMenu = (0, _tooltip2.default)(_menu.IconMenu);

var DivisionGroupsNav = function (_React$Component) {
  _inherits(DivisionGroupsNav, _React$Component);

  function DivisionGroupsNav() {
    _classCallCheck(this, DivisionGroupsNav);

    return _possibleConstructorReturn(this, (DivisionGroupsNav.__proto__ || Object.getPrototypeOf(DivisionGroupsNav)).apply(this, arguments));
  }

  _createClass(DivisionGroupsNav, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.title = this.props.notificationUnreadCount > 0 ? '(' + this.props.notificationUnreadCount + ') ' + this.props.division.name + ' - gamba!' : this.props.division.name + ' - gamba!';
    }
  }, {
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps) {
      //未読通知があるか判定
      if (this.props.notificationUnreadCount != nextProps.notificationUnreadCount) document.title = nextProps.notificationUnreadCount > 0 ? '(' + nextProps.notificationUnreadCount + ') ' + this.props.division.name + ' - gamba!' : this.props.division.name + ' - gamba!';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          sidebarDocked = _props.sidebarDocked,
          onLeftIconClick = _props.onLeftIconClick,
          isPhone = _props.isPhone,
          notificationUnreadCount = _props.notificationUnreadCount,
          showNotifications = _props.showNotifications,
          showChatRooms = _props.showChatRooms,
          chatUnreadCount = _props.chatUnreadCount,
          blinkChatButton = _props.blinkChatButton,
          openSearchDrawer = _props.openSearchDrawer,
          openDrawer = _props.openDrawer,
          division = _props.division,
          openDivisionSettingsPage = _props.openDivisionSettingsPage;


      if (!division.name) return null;

      return _react2.default.createElement(
        _app_bar.AppBar,
        { leftIcon: isPhone && 'menu' || '',
          onLeftIconClick: onLeftIconClick,
          theme: _appBar2.default },
        _react2.default.createElement(
          'div',
          { style: { marginRight: 'auto' } },
          !isPhone && _react2.default.createElement(
            'div',
            { style: { display: 'inline' } },
            _react2.default.createElement(_avatar2.default, { image: division.icon_image.thumb_url }),
            '\xA0'
          ),
          _react2.default.createElement(
            'b',
            null,
            division.name
          )
        ),
        _react2.default.createElement(
          _navigation.Navigation,
          { type: 'horizontal', theme: _noWrappedNavigation2.default },
          _react2.default.createElement(_reactNotificationBadge2.default, { count: notificationUnreadCount,
            containerStyle: { position: 'absolute', top: '10px', right: '50px' },
            effect: _reactNotificationBadge.Effect.SCALE }),
          _react2.default.createElement(_reactNotificationBadge2.default, { count: chatUnreadCount,
            containerStyle: { position: 'absolute', top: '10px', right: '0px' },
            effect: _reactNotificationBadge.Effect.SCALE }),
          _react2.default.createElement(TooltipIconButton, { inverse: true,
            tooltip: t('label:検索'),
            icon: 'search',
            onClick: openSearchDrawer }),
          user && user.account_admin && _react2.default.createElement(
            TooltipIconMenu,
            { inverse: true, tooltip: t('label:Section settings'), icon: 'more_vert', theme: _zIndexMenu2.default },
            _react2.default.createElement(_menu.MenuItem, { icon: 'settings', caption: t('label:Section settings'), onClick: openDivisionSettingsPage })
          ),
          _react2.default.createElement(TooltipIconButton, { inverse: true,
            tooltip: t('label:新着の通知'),
            icon: 'notifications' + (!notificationUnreadCount && '_none' || ''),
            onClick: showNotifications }),
          _react2.default.createElement(TooltipIconButton, _extends({ inverse: true
          }, (0, _animationCss2.default)(blinkChatButton), {
            tooltip: t('label:チャット'),
            icon: 'comment',
            onClick: showChatRooms })),
          _react2.default.createElement(_searchDrawer2.default, { active: openDrawer, group: { group_id: 'home' }, onClose: openSearchDrawer }),
          _react2.default.createElement(_divisionSettingsPage2.default, { division: division })
        )
      );
    }
  }]);

  return DivisionGroupsNav;
}(_react2.default.Component);

var RawDivisionGroupsNav = exports.RawDivisionGroupsNav = DivisionGroupsNav;
exports.default = (0, _divisionGroupsNav2.default)(DivisionGroupsNav);

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/division-groups-nav.js

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _store = __webpack_require__(18);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var unreadCount = state.notifications.unreadCount;
  return {
    isPhone: state.media.isPhone,
    notificationUnreadCount: unreadCount && unreadCount.home,
    chatUnreadCount: state.chatRooms.unreadCount,
    announce: !state.announce.close,
    firstLogin: state.user.firstLogin,
    productTour: state.productTour.state,
    division: (0, _store.getArray)('division_id', state.divisions.items, state.divisions.currentId) || {},
    user: state.user.current
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, stateProps, dispatchProps, ownProps, {
    blinkChatButton: stateProps.firstLogin && (!stateProps.productTour || stateProps.productTour.chatRoom != 'hide')
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onLeftIconClick: function onLeftIconClick() {
      return dispatch(_actions2.default.openSidebar());
    },
    showNotifications: function showNotifications() {
      return dispatch(_actions2.default.openRightSidePage('notifications', { group_id: 'home' }));
    },
    showChatRooms: function showChatRooms() {
      return dispatch(_actions2.default.openRightSidePage('chat_rooms', {}));
    },
    openDivisionSettingsPage: function openDivisionSettingsPage() {
      return dispatch(_actions2.default.openDivisionSettingsPage());
    },
    openSettingPage: function openSettingPage() {
      return dispatch(_actions2.default.openDivisionSettingsPage());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: { searchDrawer: false } }), (0, _reactI18next.translate)());

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDivisionSettingsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _settingsPage = __webpack_require__(268);

var _divisionSettingsPage = __webpack_require__(2803);

var _divisionSettingsPage2 = _interopRequireDefault(_divisionSettingsPage);

var _divisionBasicSettingPanel = __webpack_require__(2804);

var _divisionBasicSettingPanel2 = _interopRequireDefault(_divisionBasicSettingPanel);

var _divisionGroupManagementPanel = __webpack_require__(2806);

var _divisionGroupManagementPanel2 = _interopRequireDefault(_divisionGroupManagementPanel);

var _divisionExportPanel = __webpack_require__(2808);

var _divisionExportPanel2 = _interopRequireDefault(_divisionExportPanel);

var _divisionDeletePanel = __webpack_require__(2810);

var _divisionDeletePanel2 = _interopRequireDefault(_divisionDeletePanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-settings-page.jsx

var DivisionSettingsPage = function (_React$Component) {
  _inherits(DivisionSettingsPage, _React$Component);

  function DivisionSettingsPage() {
    _classCallCheck(this, DivisionSettingsPage);

    return _possibleConstructorReturn(this, (DivisionSettingsPage.__proto__ || Object.getPrototypeOf(DivisionSettingsPage)).apply(this, arguments));
  }

  _createClass(DivisionSettingsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          user = _props.user,
          active = _props.active,
          onClose = _props.onClose,
          name = _props.name,
          division = _props.division;

      return _react2.default.createElement(
        _settingsPage.SettingsPage,
        { title: t('label:Section settings'),
          active: active,
          onCloseDialog: onClose,
          name: 'division_setting',
          initialName: 'members' },
        _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'profile',
          params: { division: division },
          label: t('label:基本設定'),
          icon: 'group_work',
          component: _divisionBasicSettingPanel2.default
        }),
        _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'members',
          params: { division: division },
          label: t('label:Group management'),
          icon: 'people',
          division: division,
          component: _divisionGroupManagementPanel2.default }),
        _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'remind',
          params: { division: division },
          label: t('label:Download'),
          icon: 'cloud_download',
          component: _divisionExportPanel2.default }),
        _react2.default.createElement(_settingsPage.SettingsPanel, { name: 'templates',
          params: { division: division },
          label: t('label:Move to trash'),
          icon: 'delete',
          division: division,
          component: _divisionDeletePanel2.default })
      );
    }
  }]);

  return DivisionSettingsPage;
}(_react2.default.Component);

var RawDivisionSettingsPage = exports.RawDivisionSettingsPage = DivisionSettingsPage;
exports.default = (0, _divisionSettingsPage2.default)(DivisionSettingsPage);

/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var group = ownProps.group && (0, _store.getArray)('group_id', state.groups.items, ownProps.group.group_id) || undefined;

  return {
    isPhone: state.media.isPhone,
    group: group,
    name: state.divisionSettings.name,
    active: state.divisionSettings.active
  };
};
// src/connects/division-settings-page.js

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch(_actions2.default.closeDivisionSettingsPage());
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactI18next.translate)());

/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDivisionBasicSettingPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _divisionBaiscSettingsPage = __webpack_require__(2805);

var _divisionBaiscSettingsPage2 = _interopRequireDefault(_divisionBaiscSettingsPage);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _input = __webpack_require__(59);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _reactRangeslider = __webpack_require__(348);

var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);

__webpack_require__(349);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _fileUploadButton = __webpack_require__(180);

var _fileUploadButton2 = _interopRequireDefault(_fileUploadButton);

var _formValidator = __webpack_require__(41);

var _reactAvatarEditor = __webpack_require__(352);

var _reactAvatarEditor2 = _interopRequireDefault(_reactAvatarEditor);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-form-panel.jsx

// import Slider from 'react-toolbox/lib/slider' Slide in React Toolbx is buggy...


function calcCrop(avatar) {
  if (!avatar) return undefined;

  var rect = avatar.getCroppingRect();
  var width = avatar.state.image.resource.width;
  var height = avatar.state.image.resource.height;
  //console.log(`rect x:${rect.x} y:${rect.y} w:${rect.width} h:${rect.height}, image: w:${width} h:${height}`)
  //console.log(`calc x:${width * rect.x} y:${height * rect.y} w:${width * rect.width} h:${height * rect.height}`)

  return {
    x: width * rect.x,
    y: height * rect.y,
    width: width * rect.width,
    height: height * rect.height
  };
}

function dropdownTemplate(item) {
  return _react2.default.createElement(
    'div',
    { style: { display: 'flex', flexDirection: 'row' } },
    _react2.default.createElement(_font_icon2.default, { value: item.icon, style: { verticalAlign: 'middle' } }),
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', flexDirection: 'column', marginLeft: 5 } },
      _react2.default.createElement(
        'strong',
        null,
        item.label
      ),
      _react2.default.createElement(
        'small',
        null,
        item.description
      )
    )
  );
}

var DivisionBasicSettingPanel = function (_React$Component) {
  _inherits(DivisionBasicSettingPanel, _React$Component);

  function DivisionBasicSettingPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DivisionBasicSettingPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DivisionBasicSettingPanel.__proto__ || Object.getPrototypeOf(DivisionBasicSettingPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = { scale: 1.5 }, _this.onChange = function () {
      return _this.props.updateUI({ cancelRemindMail: !_this.props.ui.cancelRemindMail });
    }, _this.onChangeLocale = function (locale) {
      return _this.props.updateUI({ locale: locale });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DivisionBasicSettingPanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          isUpdating = _props.isUpdating,
          group = _props.group,
          updateUI = _props.updateUI,
          uploadFile = _props.uploadFile,
          uploadedFile = _props.uploadedFile,
          validateAndSubmit = _props.validateAndSubmit,
          isUploading = _props.isUploading,
          division = _props.division;

      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          'form',
          { onSubmit: function onSubmit(e) {
              return validateAndSubmit(_this2.props, calcCrop(_this2.refs.avatar), e);
            } },
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:Section name')
              )
            ),
            _react2.default.createElement(_input.Input, { name: 'name', required: true,
              label: t('label:Section name'),
              value: ui.name,
              icon: 'person',
              onChange: (0, _formValidator.linkUI)(this, 'name'),
              error: ui.nameError && t('error:グループ名を入力してください')
            })
          ),
          _react2.default.createElement(
            _card.CardText,
            null,
            _react2.default.createElement(
              'normal',
              null,
              _react2.default.createElement(
                'strong',
                null,
                t('label:アイコン画像')
              )
            ),
            _react2.default.createElement('br', null),
            !uploadedFile && !isUploading && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('img', { style: { width: 100, height: 100, borderRadius: '50%' }, src: division.icon_image.thumb_url })
            ),
            uploadedFile && !isUploading && uploadedFile.file && _react2.default.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'column', width: 210 } },
              _react2.default.createElement(_reactAvatarEditor2.default, { ref: 'avatar',
                image: uploadedFile.file.thumb_url,
                width: 200,
                height: 200,
                border: 5,
                scale: this.state.scale,
                style: { cursor: 'move' } }),
              _react2.default.createElement(_reactRangeslider2.default, {
                min: 1,
                max: 5,
                step: 0.05,
                tooltip: false,
                value: this.state.scale,
                onChange: function onChange(value) {
                  return _this2.setState({ scale: value });
                } })
            ),
            isUploading && _react2.default.createElement(
              'div',
              { style: { height: '100%', width: '100%', display: 'flex', justifyContent: 'flex-start', marginLeft: '10px' } },
              _react2.default.createElement(_progress_bar2.default, { type: 'circular', multicolor: true, mode: 'indeterminate' })
            ),
            _react2.default.createElement(_fileUploadButton2.default, { raised: true,
              icon: 'add_a_photo',
              label: '\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E',
              single: true,
              onChange: function onChange(file) {
                return uploadFile(_this2.props, file);
              } })
          ),
          _react2.default.createElement(
            _card.CardActions,
            null,
            _react2.default.createElement(_button.Button, { raised: true, primary: true,
              type: 'submit',
              disabled: isUpdating,
              style: { width: '100%' },
              label: t(division ? 'label:更新' : 'label:新規作成') })
          )
        )
      );
    }
  }]);

  return DivisionBasicSettingPanel;
}(_react2.default.Component);

var RawDivisionBasicSettingPanel = exports.RawDivisionBasicSettingPanel = DivisionBasicSettingPanel;
exports.default = (0, _divisionBaiscSettingsPage2.default)(DivisionBasicSettingPanel);

/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeProps = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/division-settings-page.js

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _fileUpload = __webpack_require__(179);

var _fileUpload2 = _interopRequireDefault(_fileUpload);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _componentId = __webpack_require__(164);

var _componentId2 = _interopRequireDefault(_componentId);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _formValidator = __webpack_require__(41);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var division = (0, _store.getArray)('division_id', state.divisions.items, state.divisions.currentId) || {};
  return {
    isPhone: state.media.isPhone,
    division: division,
    _uploadFile: state.uploadFile[ownProps.componentId],
    isUpdating: state.divisionSettings.isUpdating,
    isUpdateFailed: state.divisionSettings.isUpdateFailed
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onClose: function onClose() {
      return dispatch(_actions2.default.closeDivisionSettingsPage());
    },
    validateAndSubmit: function validateAndSubmit(props, crop) {
      var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      if (event && event.preventDefault) event.preventDefault();

      (0, _formValidator.validate)(props.ui, {
        name: { rule: 'isRequired' }
      }, function (errors, nextUI) {
        props.updateUI(nextUI);

        if (errors) {
          return;
        }

        if (props.division) {
          dispatch(_actions2.default.updateDivision(props.division.division_id, props.ui.name, props.ui.access_type, props.uploadedFile && props.uploadedFile.file_id, crop));
        }
      });
      return false;
    },
    uploadFile: function uploadFile(props, file) {
      return !props.isUploading && (0, _fileUpload2.default)(file, dispatch, props.division.division_id, 'division', ownProps.componentId, true);
    },
    willUpdate: function willUpdate(props, nextProps) {
      // changing isFetching true => false
      if (props.isUpdating && !nextProps.isUpdating) {
        if (!nextProps.isUpdateFailed) {
          // successfully updated
          dispatch((0, _alertMessage.emitAlertMessage)("label:Section preferences have been updated", "success"));
        }
      }
    },
    willMount: function willMount(props) {},

    willUnmount: function willUnmount() {}
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var uploadFile;
  if (stateProps._uploadFile) {
    uploadFile = (0, _find2.default)(stateProps._uploadFile, function (value, key) {
      return value;
    });
  }

  return _extends({
    isUploading: uploadFile && uploadFile.isUploading,
    uploadedFile: uploadFile && uploadFile.item
  }, ownProps, stateProps, dispatchProps, {
    isUpdating: stateProps.isUpdating,
    isUpdateFailed: stateProps.isUpdateFailed
  });
};

exports.default = (0, _combineHoc2.default)(_componentId2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({
  state: {
    active: false,
    name: function name(props) {
      return props.division.name ? props.division.name : '';
    },
    access_type: function access_type(props) {
      return props.division.is_private ? 'private_access' : 'public_access';
    },
    params: undefined,
    nameError: undefined,
    handlers: undefined
  },
  exports: true
}), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _analytics.trackPage)('division_profile'), (0, _analytics.trackHandlers)('validateAndSubmit', 'group_form_submit'));

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDivisionGroupManagementPanel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _divisionGroupsManagerPanel = __webpack_require__(2807);

var _divisionGroupsManagerPanel2 = _interopRequireDefault(_divisionGroupsManagerPanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _font_icon = __webpack_require__(23);

var _font_icon2 = _interopRequireDefault(_font_icon);

var _list = __webpack_require__(25);

var _menu = __webpack_require__(63);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _switch = __webpack_require__(227);

var _switch2 = _interopRequireDefault(_switch);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

var _guideMessage = __webpack_require__(533);

var _guideMessage2 = _interopRequireDefault(_guideMessage);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _successButton = __webpack_require__(69);

var _successButton2 = _interopRequireDefault(_successButton);

var _lightButton = __webpack_require__(369);

var _lightButton2 = _interopRequireDefault(_lightButton);

var _sortable = __webpack_require__(278);

var _sortable2 = _interopRequireDefault(_sortable);

var _groupMembersSorting = __webpack_require__(534);

var _groupMembersSorting2 = _interopRequireDefault(_groupMembersSorting);

var _reactSortableHoc = __webpack_require__(231);

var _analytics = __webpack_require__(27);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/division-group-management-panel.jsx

var DivisionGroupManagementPanel = function (_React$Component) {
  _inherits(DivisionGroupManagementPanel, _React$Component);

  function DivisionGroupManagementPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DivisionGroupManagementPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DivisionGroupManagementPanel.__proto__ || Object.getPrototypeOf(DivisionGroupManagementPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = { scale: 1.5, sorting: false }, _this.showGroupSelectionDialog = function () {
      _this.props.showGroupSelectionDialog(_this.props.t('label:Select_group'), true, 'OTHER_GROUPS', undefined, function (groups) {
        return _this.props.addDivisionGroups(_this.props, groups);
      });
      (0, _analytics.track)('division_groups_add');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DivisionGroupManagementPanel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          showGroupSelectionDialog = _props.showGroupSelectionDialog,
          division = _props.division,
          groups = _props.groups;

      if (!division || !groups || groups.length == 0) return null;
      var division_groups = division.groups.map(function (g) {
        return groups.find(function (group) {
          return group.group_id == g.id;
        });
      }).filter(function (g) {
        return g;
      });

      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(_button.Button, { raised: true, theme: _successButton2.default,
            icon: 'add',
            label: t('label:既存グループを追加'),
            onClick: this.showGroupSelectionDialog })
        ),
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(SortableGroupsList, _extends({}, this.props, { groups: division_groups,
            helperClass: _sortable2.default.sortable }))
        )
      );
    }
  }]);

  return DivisionGroupManagementPanel;
}(_react2.default.Component);

var GroupsList = function (_React$Component2) {
  _inherits(GroupsList, _React$Component2);

  function GroupsList() {
    var _ref2;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, GroupsList);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = GroupsList.__proto__ || Object.getPrototypeOf(GroupsList)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {}, _this2.showRemoveGroupSelectionDialog = function () {
      _this2.setState(_defineProperty({}, 'deleteConfirm' + group.group_id, false));
      updateDivisionGroup(_this2.props, group, 'remove');
      updateUI({ active: true });
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(GroupsList, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          t = _props2.t,
          updateUI = _props2.updateUI,
          groups = _props2.groups,
          sorting = _props2.sorting,
          selectSorting = _props2.selectSorting,
          updateDivisionGroup = _props2.updateDivisionGroup;


      return _react2.default.createElement(
        'div',
        { style: { cursor: sorting && 'move' || 'inherit' } },
        _react2.default.createElement(
          _list.List,
          null,
          _lodash2.default.map(groups, function (group, i) {
            return _react2.default.createElement(
              SortableListItem,
              { key: group.group_id, selectable: false, ripple: false, index: i,
                theme: _groupMembersSorting2.default,
                className: (selectSorting ? 'active_sorting' : '') + ' ' + group.access_type,
                disabled: !sorting,
                avatar: group.icon_image.thumb_url,
                caption: group.name,
                rightActions: _lodash2.default.filter([_react2.default.createElement(_button.IconButton, { key: 'remove', icon: 'close', onClick: function onClick() {
                    return _this3.setState(_defineProperty({}, 'deleteConfirm' + group.group_id, true));
                  } }), _react2.default.createElement(_confirmDialog2.default, { key: 'remove_dialog',
                  title: t('label:can_i_remove_group', { name: group.name }),
                  description: t('label:division_group_remove_consequence'),
                  open: _this3.state['deleteConfirm' + group.group_id],
                  yesLabel: t('label:外す'),
                  noLabel: t('label:取り消し'),
                  onYes: function onYes() {
                    _this3.setState(_defineProperty({}, 'deleteConfirm' + group.group_id, false));
                    updateDivisionGroup(_this3.props, group, 'remove');
                    updateUI({ active: true });
                  },
                  onNo: function onNo() {
                    return _this3.setState(_defineProperty({}, 'deleteConfirm' + group.group_id, false));
                  } })], function (item) {
                  return item;
                })
              },
              _react2.default.createElement(
                _list.ListItemContent,
                null,
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    { style: { color: 'rgb(33, 33, 33)', fontSize: 16 } },
                    group.name
                  ),
                  _react2.default.createElement(
                    'p',
                    { style: { color: 'rgb(117, 117, 117)' } },
                    t('label:persons_count', { value: group.members_count })
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);

  return GroupsList;
}(_react2.default.Component);

var SortableGroupsList = (0, _reactSortableHoc.SortableContainer)(GroupsList);
var SortableListItem = (0, _reactSortableHoc.SortableElement)(_list.ListItem);
var RawDivisionGroupManagementPanel = exports.RawDivisionGroupManagementPanel = DivisionGroupManagementPanel;
exports.default = (0, _divisionGroupsManagerPanel2.default)(DivisionGroupManagementPanel);

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeProps = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/division-settings-page.js


var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _componentId = __webpack_require__(164);

var _componentId2 = _interopRequireDefault(_componentId);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _analytics = __webpack_require__(27);

var _alertMessage = __webpack_require__(13);

var _store = __webpack_require__(18);

var _i18n = __webpack_require__(173);

var _i18n2 = _interopRequireDefault(_i18n);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//state is an object init from reducer
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var division = ownProps.division && (0, _store.getArray)('division_id', state.divisions.items, state.divisions.currentId) || {};

  return {
    isPhone: state.media.isPhone,
    division: division,
    groups: state.groups.items
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    willUpdate: function willUpdate(props, nextProps) {},
    willMount: function willMount(props) {},
    willUnmount: function willUnmount() {},

    addDivisionGroups: function addDivisionGroups(props, groups) {
      var groupNames = (0, _map2.default)(groups, function (group) {
        dispatch(_actions2.default.updateDivisionGroup(props.division.division_id, group.group_id, 'add'));
        return group.name;
      }).join(', ');
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:added_group', name: groupNames }, 'success'));
    },

    updateDivisionGroup: function updateDivisionGroup(props, group, membership) {
      if (membership == 'remove') dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:group_removed_from_division', name: group.name }, 'success'));
      dispatch(_actions2.default.updateDivisionGroup(props.division.division_id, group.group_id, membership));
    }
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  var uploadFile;
  if (stateProps._uploadFile) {
    uploadFile = (0, _find2.default)(stateProps._uploadFile, function (value, key) {
      return value;
    });
  }

  return _extends({}, ownProps, stateProps, dispatchProps);
};

exports.default = (0, _combineHoc2.default)(_componentId2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({
  state: {
    active: false
  },
  exports: true
}), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _context2.default)({ showGroupSelectionDialog: _propTypes2.default.func }));

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDivisionExportPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _divisionExportPanel = __webpack_require__(2809);

var _divisionExportPanel2 = _interopRequireDefault(_divisionExportPanel);

var _card = __webpack_require__(28);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _button = __webpack_require__(8);

var _dropdown = __webpack_require__(74);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _formValidator = __webpack_require__(41);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _datePicker = __webpack_require__(165);

var _datePicker2 = _interopRequireDefault(_datePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/group-form-panel.jsx

var DivisionExportPanel = function (_React$Component) {
  _inherits(DivisionExportPanel, _React$Component);

  function DivisionExportPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DivisionExportPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DivisionExportPanel.__proto__ || Object.getPrototypeOf(DivisionExportPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = { exportAll: true, fields: [], exportAllGroups: true, groups: [], exportGroupFields: [] }, _this.toggleExportAll = function () {
      return _this.setState({ exportAll: !_this.state.exportAll });
    }, _this.toggleExportGroupFields = function (groupId) {
      if (!_this.state.exportGroupFields.includes(groupId)) {
        _this.setState({ exportGroupFields: _this.state.exportGroupFields.concat(groupId) });
      } else {
        var fieldListChecks = _this.props.field_list.filter(function (item) {
          return item.group_id === groupId;
        }).map(function (item) {
          return item.fields;
        }).flat().filter(function (item, index, self) {
          return index === self.findIndex(function (i) {
            return i.group_id === item.group_id && i.name === item.name;
          });
        });
        var listFieldChecked = [];
        fieldListChecks && fieldListChecks.forEach(function (field) {
          if (!_this.state.fields.includes(field)) {
            listFieldChecked.push(field);
          }
        });
        _this.setState({
          exportGroupFields: _this.state.exportGroupFields.filter(function (gId) {
            return gId !== groupId;
          }),
          fields: [].concat(_toConsumableArray(_this.state.fields), listFieldChecked)
        });
      }
    }, _this.toggleField = function (field) {
      if (_this.state.fields.includes(field)) _this.setState({ fields: _.filter(_this.state.fields, function (_field) {
          return _field != field;
        }) });else _this.setState({ fields: _this.state.fields.concat(field) });
    }, _this.toggleExportAllGroups = function () {
      return _this.setState({ exportAllGroups: !_this.state.exportAllGroups });
    }, _this.toggleGroup = function (group) {
      if (_this.state.groups.includes(group)) _this.setState({ groups: _.filter(_this.state.groups, function (_group) {
          return _group != group;
        }) });else _this.setState({ groups: _this.state.groups.concat(group) });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DivisionExportPanel, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.field_list != nextProps.field_list) this.setState({ fields: nextProps.field_list.map(function (i) {
          return i.fields;
        }).flat().filter(function (item, index, self) {
          return index === self.findIndex(function (i) {
            return i.group_id === item.group_id && i.name === item.name;
          });
        }) });
      if (this.props.division) this.setState({ groups: nextProps.allGroups.filter(function (group) {
          return nextProps.division.groups.map(function (g) {
            return g.id;
          }).includes(group.group_id);
        }).map(function (g) {
          return g.group_id;
        }) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          groupExportUrl = _props.groupExportUrl,
          field_list = _props.field_list,
          division = _props.division,
          allGroups = _props.allGroups;

      var groups = allGroups.filter(function (group) {
        return division.groups.map(function (g) {
          return g.id;
        }).includes(group.group_id);
      });

      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(
            'strong',
            null,
            t('label:開始日')
          ),
          _react2.default.createElement(_datePicker2.default, { label: t('label:開始日'),
            value: ui.startDate.toDate(),
            maxDate: ui.endDate.toDate(),
            onChange: function onChange(date) {
              return updateUI({ startDate: (0, _moment2.default)(date) });
            } })
        ),
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(
            'strong',
            null,
            t('label:終了日')
          ),
          _react2.default.createElement(_datePicker2.default, { label: t('label:終了日'),
            value: ui.endDate.toDate(),
            minDate: ui.startDate.toDate(),
            onChange: function onChange(date) {
              return updateUI({ endDate: (0, _moment2.default)(date) });
            } })
        ),
        _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(_button.Button, { raised: true, primary: true,
            type: 'submit',
            href: groupExportUrl(ui.startDate, ui.endDate, this.state.exportAll ? undefined : this.state.fields, this.state.exportAllGroups ? undefined : this.state.groups),
            target: '_blank',
            rel: 'noopener noreferrer',
            style: { width: '100%' },
            label: t('label:Excelダウンロード') })
        ),
        groups && groups.length > 0 && _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_checkbox2.default, { checked: this.state.exportAllGroups,
              label: t('label:export_all_groups'),
              onChange: this.toggleExportAllGroups }),
            _react2.default.createElement(
              'ul',
              null,
              !this.state.exportAllGroups && _.map(groups, function (group, i) {
                return _react2.default.createElement(
                  'li',
                  { key: i },
                  _react2.default.createElement(_checkbox2.default, { checked: _this2.state.groups.includes(group.group_id),
                    label: group.name, onChange: function onChange() {
                      return _this2.toggleGroup(group.group_id);
                    } })
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_checkbox2.default, { checked: this.state.exportAll,
              label: t('label:すべて抽出'),
              onChange: this.toggleExportAll }),
            !this.state.exportAll && groups && groups.map(function (group, index) {
              return _react2.default.createElement(
                'div',
                { key: index },
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_checkbox2.default, {
                      key: group.group_id,
                      checked: !_this2.state.exportGroupFields.includes(group.group_id),
                      label: group.name,
                      onChange: function onChange() {
                        return _this2.toggleExportGroupFields(group.group_id);
                      } })
                  ),
                  _this2.state.exportGroupFields.includes(group.group_id) && _react2.default.createElement(
                    'ul',
                    null,
                    field_list && field_list.filter(function (item) {
                      return item.group_id === group.group_id;
                    }).map(function (item) {
                      return item.fields;
                    }).flat().filter(function (item, index, self) {
                      return index === self.findIndex(function (i) {
                        return i.group_id === item.group_id && i.name === item.name;
                      });
                    }).map(function (field, i) {
                      return _react2.default.createElement(
                        'li',
                        { key: i },
                        _react2.default.createElement(_checkbox2.default, {
                          checked: _this2.state.fields.includes(field),
                          label: field.name,
                          onChange: function onChange() {
                            return _this2.toggleField(field);
                          }
                        })
                      );
                    })
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);

  return DivisionExportPanel;
}(_react2.default.Component);

var RawDivisionExportPanel = exports.RawDivisionExportPanel = DivisionExportPanel;
exports.default = (0, _divisionExportPanel2.default)(DivisionExportPanel);

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeProps = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/division-export-panel.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var fieldList = [];
  state.groups.items && state.groups.items.forEach(function (group) {
    state.templates.field_list && state.templates.field_list.forEach(function (item) {
      if (item.group_id === 0) {
        fieldList.push({
          group_id: group.group_id,
          fields: item.fields.map(function (i) {
            return { group_id: group.group_id, name: i.name };
          })
        });
      }
      if (item.group_id === group.group_id) {
        fieldList.push(item);
      }
    });
  });
  return {
    access_token: state.sessions.access_token,
    field_list: fieldList,
    user: state.user.current,
    allGroups: state.groups.items
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    willMount: function willMount(props) {
      if (props.user && props.division && props.allGroups && props.division.groups[0]) {
        var groups = props.allGroups.filter(function (group) {
          return props.division.groups.map(function (g) {
            return g.id;
          }).includes(group.group_id);
        });
        dispatch(_actions2.default.fetchTemplateFields(groups.map(function (g) {
          return g.group_id;
        }).join(','), props.user.user_id, true));
      }
    }
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    groupExportUrl: function groupExportUrl(startDate, endDate, fields, group_ids) {
      var groups = stateProps.allGroups.filter(function (group) {
        return ownProps.division.groups.map(function (g) {
          return g.id;
        }).includes(group.group_id);
      });
      var params = {
        group_ids: group_ids ? group_ids.join(',') : groups.map(function (g) {
          return g.group_id;
        }).join(','),
        start_date: (0, _moment2.default)(startDate).format('YYYY-MM-DD'),
        end_date: (0, _moment2.default)(endDate).format('YYYY-MM-DD'),
        selection_type: 'selection_group',
        access_token: stateProps.access_token
      };
      if (fields) {
        var fieldNames = [];
        params.group_ids && params.group_ids.split(',').forEach(function (groupId) {
          fields.forEach(function (field) {
            if (field.group_id == groupId) {
              fieldNames.push(groupId + '_' + field.name);
            }
          });
        });
        params.group_field_names = fieldNames.join(',');
      }
      return _config2.default.baseUrl + 'v3/export/groups?' + (0, _map2.default)(params, function (value, key) {
        return key + '=' + encodeURI(value);
      }).join('&');
    }
  });
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: { startDate: (0, _moment2.default)().startOf('month'), endDate: (0, _moment2.default)() } }), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDivisionDeletePanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _divisionDeletePanel = __webpack_require__(2811);

var _divisionDeletePanel2 = _interopRequireDefault(_divisionDeletePanel);

var _card = __webpack_require__(28);

var _button = __webpack_require__(8);

var _checkbox = __webpack_require__(54);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _flatCard = __webpack_require__(48);

var _flatCard2 = _interopRequireDefault(_flatCard);

var _confirmDialog = __webpack_require__(50);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/division-delete-panel.jsx

var DivisionDeletePanel = function (_React$Component) {
  _inherits(DivisionDeletePanel, _React$Component);

  function DivisionDeletePanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DivisionDeletePanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DivisionDeletePanel.__proto__ || Object.getPrototypeOf(DivisionDeletePanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = { deleteConfirm: false, deleteCheck: false }, _this.toggleConfirmDialog = function () {
      return _this.setState({ deleteConfirm: !_this.state.deleteConfirm });
    }, _this.onCancel = function () {
      _this.setState({ deleteConfirm: !_this.state.deleteConfirm, deleteCheck: !_this.state.deleteCheck });
    }, _this.deleteDivision = function () {
      _this.toggleConfirmDialog();
      _this.props.deleteDivision();
    }, _this.onCheck = function () {
      _this.setState({ deleteCheck: !_this.state.deleteCheck });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DivisionDeletePanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;


      return _react2.default.createElement(
        _card.Card,
        { theme: _flatCard2.default },
        _react2.default.createElement(
          _card.CardText,
          null,
          _react2.default.createElement(
            'p',
            { style: { fontSize: 16, color: 'black', marginBottom: 5 } },
            t('label:Move to trash')
          ),
          _react2.default.createElement(
            'p',
            { style: { fontSize: 16, color: 'black', marginBottom: 5 } },
            t('label:are_you_sure_you_want_to_move_the_division_to_trash')
          ),
          _react2.default.createElement(_checkbox2.default, {
            theme: _flatCard2.default,
            className: 'deleteCheck',
            checked: this.state.deleteCheck,
            onChange: this.onCheck,
            label: t('label:this_operation_will_affect_all_users_participating_in_the_division') }),
          _react2.default.createElement(
            'div',
            { style: { marginLeft: 28 } },
            t('label:complete_deletion_restoration_explanation')
          )
        ),
        _react2.default.createElement(
          _card.CardActions,
          null,
          _react2.default.createElement(_button.Button, { raised: true, primary: true,
            type: 'submit',
            style: { width: '100%' },
            label: t('label:Move to trash'),
            disabled: !this.state.deleteCheck,
            onClick: this.toggleConfirmDialog
          })
        ),
        _react2.default.createElement(_confirmDialog2.default, { key: 'dialog',
          open: this.state.deleteConfirm,
          title: t('label:are_you_sure_you_want_to_move_the_division_to_trash'),
          description: _react2.default.createElement(
            'div',
            { style: { flexDirection: 'column' } },
            _react2.default.createElement(
              'div',
              null,
              t('label:this_operation_will_affect_all_users_participating_in_the_division')
            ),
            _react2.default.createElement(
              'div',
              null,
              t('label:complete_deletion_restoration_explanation')
            )
          ),
          yesLabel: t('label:Move to trash'),
          noLabel: t('label:取り消し'),
          onNo: this.onCancel,
          onYes: function onYes() {
            return _this2.deleteDivision();
          } })
      );
    }
  }]);

  return DivisionDeletePanel;
}(_react2.default.Component);

var RawDivisionDeletePanel = exports.RawDivisionDeletePanel = DivisionDeletePanel;
exports.default = (0, _divisionDeletePanel2.default)(DivisionDeletePanel);

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = undefined;

var _reactRedux = __webpack_require__(11);

var _reactI18next = __webpack_require__(2);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _alertMessage = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * src/connects/division-delete-panel.js
 */

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    deleteDivision: function deleteDivision() {
      ownProps.onCloseDialog && ownProps.onCloseDialog();
      dispatch(_actions2.default.deleteDivision(ownProps.division.division_id));
      dispatch((0, _alertMessage.emitAlertMessage)({ message: 'label:Move to trash', name: ownProps.division.name }, 'success'));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(undefined, mapDispatchToProps), _lifecycle2.default, (0, _reactI18next.translate)());

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDivisionNotSetGroupsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pureComponent = __webpack_require__(86);

var _pureComponent2 = _interopRequireDefault(_pureComponent);

var _reactDom = __webpack_require__(21);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _divisionNotSetGroupsPage = __webpack_require__(2813);

var _divisionNotSetGroupsPage2 = _interopRequireDefault(_divisionNotSetGroupsPage);

var _layout = __webpack_require__(85);

var _button = __webpack_require__(8);

var _divisionNotSetGroupsNav = __webpack_require__(2814);

var _divisionNotSetGroupsNav2 = _interopRequireDefault(_divisionNotSetGroupsNav);

var _progress_bar = __webpack_require__(78);

var _progress_bar2 = _interopRequireDefault(_progress_bar);

var _loading = __webpack_require__(44);

var _loading2 = _interopRequireDefault(_loading);

var _infiniteScroller = __webpack_require__(75);

var _twoColumnLayout = __webpack_require__(205);

var _twoColumnLayout2 = _interopRequireDefault(_twoColumnLayout);

var _oneColumnLayout = __webpack_require__(386);

var _oneColumnLayout2 = _interopRequireDefault(_oneColumnLayout);

var _diary = __webpack_require__(171);

var _diary2 = _interopRequireDefault(_diary);

var _rightSidebar = __webpack_require__(389);

var _rightSidebar2 = _interopRequireDefault(_rightSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/division-not-set-groups-page.jsx

var DivisionNotSetGroupsPage = function (_PureComponent) {
  _inherits(DivisionNotSetGroupsPage, _PureComponent);

  function DivisionNotSetGroupsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DivisionNotSetGroupsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DivisionNotSetGroupsPage.__proto__ || Object.getPrototypeOf(DivisionNotSetGroupsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { responses: [], reviewTarget: undefined }, _this.loadMore = function () {
      return _this.props.fetchDiaries(_this.props);
    }, _this.loader = _react2.default.createElement(
      'div',
      { style: { width: '100%', textAlign: 'center' } },
      _react2.default.createElement(_progress_bar2.default, { type: 'circular', mode: 'indeterminate', multicolor: true })
    ), _this.onReplyScrollFrom = function (offset) {
      //COMMENT_FORM_HEIGHTはコメントフォームの高さ
      var COMMENT_FORM_HEIGHT = 222;
      //返信コメントへの返信の場合、コメントフォームまでスクロールする
      _this.refs.panel && (_reactDom2.default.findDOMNode(_this.refs.panel).scrollTop += offset + COMMENT_FORM_HEIGHT);
    }, _this.openSearchDrawer = function () {
      return _this.props.updateUI({ openDrawer: !_this.props.ui.openDrawer });
    }, _this.setReviewTarget = function (target) {
      return _this.setState({ reviewTarget: target });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DivisionNotSetGroupsPage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          diaries = _props.diaries,
          user = _props.user,
          isFetching = _props.isFetching,
          isFetchFailed = _props.isFetchFailed,
          isRightSidebar = _props.isRightSidebar,
          hasMore = _props.hasMore,
          params = _props.params,
          location = _props.location,
          fetchDiaries = _props.fetchDiaries,
          children = _props.children,
          likeConfig = _props.likeConfig;

      var parentTheme = isRightSidebar ? _twoColumnLayout2.default : _oneColumnLayout2.default;

      return _react2.default.createElement(
        _layout.Panel,
        { style: { height: '100vh', position: 'fixed' } },
        _react2.default.createElement(_divisionNotSetGroupsNav2.default, { division_id: params.division_id, openSearchDrawer: this.openSearchDrawer, openDrawer: ui.openDrawer }),
        _react2.default.createElement(
          _layout.Layout,
          { theme: parentTheme },
          _react2.default.createElement(
            _layout.Panel,
            { bodyScroll: true, theme: parentTheme, style: { left: 0 }, ref: 'panel' },
            !diaries && isFetching && _react2.default.createElement(_loading2.default, null),
            _react2.default.createElement(
              _infiniteScroller.InfiniteScroll,
              { pageStart: 0,
                hasMore: hasMore && !isFetchFailed,
                initialLoad: false,
                loadMore: this.loadMore,
                loader: diaries && this.loader,
                useWindow: false },
              diaries && diaries.map(function (diary) {
                return _react2.default.createElement(_diary2.default, { key: diary.diary_id, diary: diary, user: user, onReplyScrollFrom: _this2.onReplyScrollFrom, likeConfig: likeConfig, openSidePage: isRightSidebar, setReviewTarget: _this2.setReviewTarget, chatGptReview: _this2.state.responses, clearGptReview: _this2.clearGptReview, sendChatGPT: _this2.sendMessage, reviewTarget: _this2.state.reviewTarget });
              }) || []
            ),
            diaries && diaries.length == 0 && !hasMore && !isFetchFailed && _react2.default.createElement(
              'div',
              { style: { padding: '20px' } },
              t('label:投稿がありません')
            ),
            diaries && diaries.length > 0 && !hasMore && !isFetchFailed && _react2.default.createElement(
              'div',
              { style: { fontSize: '80%', padding: '0 20px', color: '#999' } },
              t('label:一番最後の投稿です')
            ),
            isFetchFailed && _react2.default.createElement(
              'div',
              { style: { padding: '20px' } },
              _react2.default.createElement(
                'div',
                { style: { fontSize: '90%', marginBottom: '10px' } },
                t('error:読み込みに失敗しました')
              ),
              _react2.default.createElement(_button.Button, { raised: true,
                onClick: function onClick() {
                  return fetchDiaries(_this2.props, true);
                },
                label: t('label:再読み込み'),
                style: { width: '100%' } })
            )
          ),
          isRightSidebar && _react2.default.createElement(
            _layout.Sidebar,
            { theme: _twoColumnLayout2.default, pinned: true, scrollY: true, width: 50 },
            _react2.default.createElement(
              _rightSidebar2.default,
              { user: user },
              children
            )
          )
        )
      );
    }
  }]);

  return DivisionNotSetGroupsPage;
}(_pureComponent2.default);

var RawDivisionNotSetGroupsPage = exports.RawDivisionNotSetGroupsPage = DivisionNotSetGroupsPage;
exports.default = (0, _divisionNotSetGroupsPage2.default)(DivisionNotSetGroupsPage);

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _reactI18next = __webpack_require__(2);

var _lifecycle = __webpack_require__(15);

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _analytics = __webpack_require__(27);

var _socketRsync = __webpack_require__(144);

var _socketRsync2 = _interopRequireDefault(_socketRsync);

var _context = __webpack_require__(39);

var _context2 = _interopRequireDefault(_context);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _agentType = __webpack_require__(142);

var _store = __webpack_require__(18);

var _route = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/connects/division-not-set-groups-page.js

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var diaries = state.diaries.groups.home;

  return {
    user: state.user.current,
    isFetching: diaries && diaries.isFetching,
    isFetchFailed: diaries && diaries.isFetchFailed,
    hasMore: diaries && diaries.hasMore,
    diaries: diaries && diaries.items,
    isRightSidebar: (state.rightSidePage.name || ownProps.children) && true,
    isPhone: state.media.isPhone,
    rightSidePage: state.rightSidePage,
    likeConfig: state.likes.likeConfig,
    binding: true,
    currentDivisionId: state.divisions.currentId
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    fetchDiaries: dispatchProps.fetchDiaries.bind(stateProps)
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  function _readDiary(props, diary) {
    var read = diary.user.user_id == props.user.user_id || diary.readers && (0, _find2.default)(diary.readers, function (reader) {
      return reader.user.user_id == props.user.user_id;
    });
    if (!read) {
      !props.emitSocket('mark_as_read', { diary_id: diary.diary_id }) && dispatch(_actions2.default.markDiaryRead(diary.diary_id));
    }
  }

  return {
    fetchDiaries: function fetchDiaries(props) {
      var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this && this.binding) props = this;
      if (props.isFetching || props.isFetchFailed && !reset) return;
      var offset = reset ? 0 : props.diaries && props.diaries.length || 0;
      dispatch(_actions2.default.fetchHomeDiaries(offset, props.currentDivisionId));
    },

    openSearchDrawer: function openSearchDrawer(props) {
      return dispatch(_actions2.default.openRightSidePage('search_drawer', { group_id: 'home' }));
    },
    clearDiaries: function clearDiaries() {
      return dispatch(_actions2.default.clearDiaries('home'));
    },
    closeRightSidePage: function closeRightSidePage() {
      return dispatch(_actions2.default.closeRightSidePage(true));
    },

    readDiary: _readDiary,
    _readDiary: _readDiary,

    willMount: function willMount(props) {
      var division_id = props.params.division_id;

      dispatch(_actions2.default.fetchHomeNotificationsUnreadCount(division_id));
      dispatch(_actions2.default.fetchHomeDiaries(0, division_id));
      if (props.params && props.params.division_id) dispatch(_actions2.default.setCurrentDivisionId(props.params.division_id));
    },

    willUnmount: function willUnmount() {
      dispatch(_actions2.default.closeRightSidePage(true));
      dispatch(_actions2.default.clearPreservedQueries());
    },
    willUpdate: function willUpdate(props, nextProps) {
      if (props.params.division_id != nextProps.params.division_id) {
        dispatch(_actions2.default.closeRightSidePage(true));
        var division_id = nextProps.params.division_id;

        dispatch(_actions2.default.fetchHomeNotificationsUnreadCount(division_id));
        dispatch(_actions2.default.fetchHomeDiaries(0, division_id));
        dispatch(_actions2.default.setCurrentDivisionId(nextProps.params.division_id));
      }
    },

    receiveSocket: function receiveSocket(message, message_type, props) {
      switch (message_type) {
        case 'diary':
          dispatch(_actions2.default.loadDiary(Object.assign({}, message.diary, { group: message.group }), {
            appending: message.appending,
            own_post: message.diary.user.user_id == props.user.user_id,
            group_id: 'home'
          }));
          break;
        case 'diary_delete':
          dispatch(_actions2.default.loadDiary(message.diary, { deleted: true, group_id: 'home' }));
          break;
        case 'notification':
          dispatch(_actions2.default.loadHomeNotificationUnreadCount(message.home_count));
          break;
      }
    },

    requestSync: function requestSync(props) {
      var division_id = props.params.division_id;

      dispatch(_actions2.default.fetchHomeNotificationsUnreadCount(division_id));
      dispatch(_actions2.default.fetchHomeDiaries(0, division_id));
    },
    // webでsearch-drawerを開くために必要
    editSearchDrawer: function editSearchDrawer(props) {
      return props.updateUI({ openDrawer: true });
    }
  };
};

exports.default = (0, _combineHoc2.default)(_socketRsync.requireSocketEmit, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _socketRsync2.default)('notification', 'diary', 'diary_delete'), (0, _uiState2.default)({ state: { active: false, openDrawer: false } }), _lifecycle2.default, (0, _reactI18next.translate)(), (0, _context.inject)({ _readDiary: _propTypes2.default.func, editSearchDrawer: _propTypes2.default.func }));

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawDivisionNotSetGroupsNav = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _divisionNotSetGroupsNav = __webpack_require__(2815);

var _divisionNotSetGroupsNav2 = _interopRequireDefault(_divisionNotSetGroupsNav);

var _reactNotificationBadge = __webpack_require__(186);

var _reactNotificationBadge2 = _interopRequireDefault(_reactNotificationBadge);

var _app_bar = __webpack_require__(122);

var _button = __webpack_require__(8);

var _navigation = __webpack_require__(147);

var _menu = __webpack_require__(63);

var _avatar = __webpack_require__(26);

var _avatar2 = _interopRequireDefault(_avatar);

var _searchDrawer = __webpack_require__(370);

var _searchDrawer2 = _interopRequireDefault(_searchDrawer);

var _noWrappedNavigation = __webpack_require__(371);

var _noWrappedNavigation2 = _interopRequireDefault(_noWrappedNavigation);

var _appBar = __webpack_require__(372);

var _appBar2 = _interopRequireDefault(_appBar);

var _tooltip = __webpack_require__(36);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _animationCss = __webpack_require__(184);

var _animationCss2 = _interopRequireDefault(_animationCss);

var _zIndexMenu = __webpack_require__(536);

var _zIndexMenu2 = _interopRequireDefault(_zIndexMenu);

var _logo = __webpack_require__(490);

var _logo2 = _interopRequireDefault(_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/division-not-set-groups-nav.jsx

var TooltipIconButton = (0, _tooltip2.default)(_button.IconButton);
var TooltipIconMenu = (0, _tooltip2.default)(_menu.IconMenu);

var DivisionNotSetGroupsNav = function (_React$Component) {
  _inherits(DivisionNotSetGroupsNav, _React$Component);

  function DivisionNotSetGroupsNav() {
    _classCallCheck(this, DivisionNotSetGroupsNav);

    return _possibleConstructorReturn(this, (DivisionNotSetGroupsNav.__proto__ || Object.getPrototypeOf(DivisionNotSetGroupsNav)).apply(this, arguments));
  }

  _createClass(DivisionNotSetGroupsNav, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.title = this.props.notificationUnreadCount > 0 ? '(' + this.props.notificationUnreadCount + ') ' + this.props.t('label:セクションなし') + ' - gamba!' : this.props.t('label:セクションなし') + ' - gamba!';
    }
  }, {
    key: 'UNSAFE_componentWillUpdate',
    value: function UNSAFE_componentWillUpdate(nextProps) {
      //未読通知があるか判定
      if (this.props.notificationUnreadCount != nextProps.notificationUnreadCount) document.title = nextProps.notificationUnreadCount > 0 ? '(' + nextProps.notificationUnreadCount + ') ' + this.props.t('label:セクションなし') + ' - gamba!' : this.props.t('label:セクションなし') + ' - gamba!';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          t = _props.t,
          ui = _props.ui,
          updateUI = _props.updateUI,
          sidebarDocked = _props.sidebarDocked,
          onLeftIconClick = _props.onLeftIconClick,
          isPhone = _props.isPhone,
          notificationUnreadCount = _props.notificationUnreadCount,
          showNotifications = _props.showNotifications,
          showChatRooms = _props.showChatRooms,
          chatUnreadCount = _props.chatUnreadCount,
          blinkChatButton = _props.blinkChatButton,
          openSearchDrawer = _props.openSearchDrawer,
          openDrawer = _props.openDrawer;


      return _react2.default.createElement(
        _app_bar.AppBar,
        { leftIcon: isPhone && 'menu' || '',
          onLeftIconClick: onLeftIconClick,
          theme: _appBar2.default },
        _react2.default.createElement(
          'div',
          { style: { marginRight: 'auto' } },
          !isPhone && _react2.default.createElement(
            'div',
            { style: { display: 'inline' } },
            _react2.default.createElement(_avatar2.default, { image: _logo2.default }),
            '\xA0'
          ),
          _react2.default.createElement(
            'b',
            null,
            t('label:セクションなし')
          )
        ),
        _react2.default.createElement(
          _navigation.Navigation,
          { type: 'horizontal', theme: _noWrappedNavigation2.default },
          _react2.default.createElement(_reactNotificationBadge2.default, { count: notificationUnreadCount,
            containerStyle: { position: 'absolute', top: '10px', right: '50px' },
            effect: _reactNotificationBadge.Effect.SCALE }),
          _react2.default.createElement(_reactNotificationBadge2.default, { count: chatUnreadCount,
            containerStyle: { position: 'absolute', top: '10px', right: '0px' },
            effect: _reactNotificationBadge.Effect.SCALE }),
          _react2.default.createElement(TooltipIconButton, { inverse: true,
            tooltip: t('label:検索'),
            icon: 'search',
            onClick: openSearchDrawer }),
          _react2.default.createElement(TooltipIconButton, { inverse: true,
            tooltip: t('label:新着の通知'),
            icon: 'notifications' + (!notificationUnreadCount && '_none' || ''),
            onClick: showNotifications }),
          _react2.default.createElement(TooltipIconButton, _extends({ inverse: true
          }, (0, _animationCss2.default)(blinkChatButton), {
            tooltip: t('label:チャット'),
            icon: 'comment',
            onClick: showChatRooms })),
          _react2.default.createElement(_searchDrawer2.default, { active: openDrawer, group: { group_id: 'home' }, onClose: openSearchDrawer })
        )
      );
    }
  }]);

  return DivisionNotSetGroupsNav;
}(_react2.default.Component);

var RawDivisionNotSetGroupsNav = exports.RawDivisionNotSetGroupsNav = DivisionNotSetGroupsNav;
exports.default = (0, _divisionNotSetGroupsNav2.default)(DivisionNotSetGroupsNav);

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mergeProps = exports.mapStateToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
// src/connects/division-groups-nav.js

var _reactRedux = __webpack_require__(11);

var _uiState = __webpack_require__(17);

var _uiState2 = _interopRequireDefault(_uiState);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _reactI18next = __webpack_require__(2);

var _store = __webpack_require__(18);

var _combineHoc = __webpack_require__(12);

var _combineHoc2 = _interopRequireDefault(_combineHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var unreadCount = state.notifications.unreadCount;
  return {
    isPhone: state.media.isPhone,
    notificationUnreadCount: unreadCount && unreadCount.home,
    chatUnreadCount: state.chatRooms.unreadCount,
    announce: !state.announce.close,
    firstLogin: state.user.firstLogin,
    productTour: state.productTour.state,
    user: state.user.current
  };
};

var mergeProps = exports.mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, stateProps, dispatchProps, ownProps, {
    blinkChatButton: stateProps.firstLogin && (!stateProps.productTour || stateProps.productTour.chatRoom != 'hide')
  });
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onLeftIconClick: function onLeftIconClick() {
      return dispatch(_actions2.default.openSidebar());
    },
    showNotifications: function showNotifications() {
      return dispatch(_actions2.default.openRightSidePage('notifications', { group_id: 'home' }));
    },
    showChatRooms: function showChatRooms() {
      return dispatch(_actions2.default.openRightSidePage('chat_rooms', {}));
    }
  };
};

exports.default = (0, _combineHoc2.default)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), (0, _uiState2.default)({ state: { searchDrawer: false } }), (0, _reactI18next.translate)());

/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(2);

var _route = __webpack_require__(67);

var _button = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// src/web/components/unavailable-page.jsx

var UnavailablePage = function (_React$Component) {
  _inherits(UnavailablePage, _React$Component);

  function UnavailablePage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnavailablePage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnavailablePage.__proto__ || Object.getPrototypeOf(UnavailablePage)).call.apply(_ref, [this].concat(args))), _this), _this.setDocumentTitle = function () {
      return document.title = _this.props.t('label:サービスは現在ご利用いただけません') + ' - gamba!';
    }, _this.checkService = function () {
      return (0, _route.pushRoute)('main');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnavailablePage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setDocumentTitle();
      this.timer = setInterval(this.checkService, 30 * 1000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.timer && clearInterval(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { style: { padding: 30 } },
        _react2.default.createElement(
          'h1',
          { style: { fontFamily: '"Century Gothic", Questrial, sans-serif', fontWeight: 'bold', color: 'red' } },
          'gamba!'
        ),
        _react2.default.createElement(
          'div',
          { style: { width: '100%' } },
          _react2.default.createElement(
            'h3',
            null,
            t('label:サービスは現在ご利用いただけません')
          ),
          _react2.default.createElement(
            'div',
            null,
            t('message:メンテナンス中')
          ),
          _react2.default.createElement('img', { src: "https://gamba-v2-assets.s3-ap-northeast-1.amazonaws.com/assets/maintenance-gambakun.png",
            style: { display: 'block', marginLeft: 'auto', marginRight: 'auto' } })
        ),
        _react2.default.createElement(_button.Button, { raised: true,
          label: t('label:お知らせページを開く'),
          href: 'https://www.getgamba.com/info/',
          target: '_blank', rel: 'noopener noreferrer' })
      );
    }
  }]);

  return UnavailablePage;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)()(UnavailablePage);

/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = accountReducer;

var _account = __webpack_require__(773);

var _store = __webpack_require__(18);

// src/reducers/account-reducer.js

var initialState = {
  isFetching: false,
  hasMore: true,
  hasMembers: false,
  items: undefined
};

function accountReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _account.FETCH_ACCOUNT_MEMBERS_REQUESTED:
    case _account.FETCH_MENTION_TO_USERS_REQUESTED:
    case _account.FETCH_OTHER_MEMBERS_REQUESTED:
    case _account.FETCH_OTHER_MEMBERS_COUNT_REQUESTED:
    case _account.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _account.FETCH_ACCOUNT_MEMBERS_FAILED:
    case _account.FETCH_MENTION_TO_USERS_FAILED:
    case _account.FETCH_OTHER_MEMBERS_FAILED:
    case _account.FETCH_OTHER_MEMBERS_COUNT_FAILED:
    case _account.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _account.FETCH_ACCOUNT_MEMBERS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.offset > 0 ? (0, _store.mergeArray)('user_id', state.items, action.results) : action.results,
        hasMore: action.results.length == _account.FETCH_USERS_LENGTH
      });

    case _account.FETCH_MENTION_TO_USERS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.offset > 0 ? (0, _store.mergeArray)('user_id', state.items, action.results) : action.results,
        hasMore: action.results.length == _account.FETCH_USERS_LENGTH
      });

    case _account.FETCH_OTHER_MEMBERS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.offset > 0 ? (0, _store.mergeArray)('user_id', state.items, action.results) : action.results,
        hasMore: action.results.length == _account.FETCH_USERS_LENGTH
      });

    case _account.FETCH_OTHER_MEMBERS_COUNT_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        hasMembers: action.results.length > 0
      });

    case _account.FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.offset > 0 ? (0, _store.mergeArray)('user_id', state.items, action.results) : action.results,
        hasMore: action.results.length == _account.FETCH_USERS_LENGTH
      });

    case _account.CLEAR_FETCHED_USERS:
      return initialState;

    case _account.FETCH_GROUP_MEMBERS_USERS:
      return Object.assign({}, state, {
        items: action.users,
        hasMore: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activityReportReducer;

var _activityReport = __webpack_require__(818);

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  isMonthlyFetching: false,
  isMonthlyFetchFailed: false
};
// src/reducers/activity-report-reducer.js

function activityReportReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _activityReport.FETCH_ACTIVITY_REPORTS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _activityReport.FETCH_ACTIVITY_REPORTS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: action.results
      });

    case _activityReport.FETCH_ACTIVITY_REPORTS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _activityReport.CLEAR_ACTIVITY_REPORTS:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: undefined
      });

    case _activityReport.FETCH_MONTHLY_ACTIVITY_REPORT_REQUESTED:
      return Object.assign({}, state, {
        isMonthlyFetching: true,
        isMonthlyFetchFailed: false
      });

    case _activityReport.FETCH_MONTHLY_ACTIVITY_REPORT_COMPLETED:
      return Object.assign({}, state, {
        isMonthlyFetching: false,
        isMonthlyFetchFailed: false,
        monthly_item: action.results
      });

    case _activityReport.FETCH_MONTHLY_ACTIVITY_REPORT_FAILED:
      return Object.assign({}, state, {
        isMonthlyFetching: false,
        isMonthlyFetchFailed: true
      });

    case _activityReport.CLEAR_MONTHLY_ACTIVITY_REPORTS:
      return Object.assign({}, state, {
        isMonthlyFetching: false,
        isMonthlyFetchFailed: false,
        monthly_item: undefined
      });

    default:
      return state;
  }
}

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = announceReducer;

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _announce = __webpack_require__(819);

var _maxBy = __webpack_require__(1070);

var _maxBy2 = _interopRequireDefault(_maxBy);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * isFetching: announces取得中のフラグ
 * announce: お知らせの配列
 * latest: お知らせの中でもっとも最大のstart_at
 * close: leftsidebarの「お知らせ」表示切り替え
 */

// src/reducers/announce-reducer.js

var initialState = {
  isFetching: false,
  announces: undefined,
  latest: undefined,
  close: true
};

function announceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _announce.FETCH_ANNOUNCE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _announce.FETCH_ANNOUNCE_COMPLETED:
      var announces = action.results;
      var latest = undefined;
      if (announces && announces.length > 0) {
        latest = (0, _moment2.default)((0, _maxBy2.default)(announces, function (announce) {
          return announce.start_at;
        }).start_at).format('YYYY-MM-DD HH:mm:SS');
      }
      return Object.assign({}, state, {
        isFetching: false,
        close: true,
        announces: announces,
        latest: latest
      });

    case _announce.FETCH_ANNOUNCE_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _announce.CLOSE_ANNOUNCE:
      return Object.assign({}, state, {
        close: true
      });

    case _announce.OPEN_ANNOUNCE:
      return Object.assign({}, state, {
        close: false
      });

    case _announce.CLEAR_ANNOUNCE:
      return Object.assign({}, initialState);

    default:
      return state;
  }
}

/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = attachmentsReducer;

var _attachments = __webpack_require__(820);

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  items: undefined
};
// src/reducers/attachments-reducer.js

function attachmentsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _attachments.FETCH_ATTACHMENTS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _attachments.FETCH_ATTACHMENTS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: action.results
      });

    case _attachments.FETCH_ATTACHMENTS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _attachments.CLEAR_ATTACHMENTS:
      return Object.assign({}, state, {
        isFetching: false,
        items: undefined
      });

    default:
      return state;
  }
}

/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildNoReducer;

var _config = __webpack_require__(30);

var _config2 = _interopRequireDefault(_config);

var _buildNo = __webpack_require__(821);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/reducers/build-no-reducer.js

var initialState = {
  isFetching: false,
  reloadNeeded: false
};

function buildNoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _buildNo.FETCH_BUILD_NO_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _buildNo.FETCH_BUILD_NO_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        reloadNeeded: action.results.build_no != _config2.default.BUILD_NO
      });

    case _buildNo.FETCH_BUILD_NO_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chatMessagesReducer;

var _chatMessages = __webpack_require__(822);

var _translate = __webpack_require__(262);

var _store = __webpack_require__(18);

var _reactChat = __webpack_require__(462);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/chat-messages-reducer.js

var initialState = {
  isRequesting: false
};

function chatMessagesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var item = void 0;
  switch (action.type) {
    case _chatMessages.FETCH_CHAT_MESSAGES_REQUESTED:
      item = Object.assign({}, state[action.chat_room_id] || {}, {
        isFetching: true,
        isFetchFailed: false,
        hasMore: true
      });
      return Object.assign({}, state, _defineProperty({}, action.chat_room_id, item));

    case _chatMessages.POST_CHAT_MESSAGE_REQUESTED:
      item = Object.assign({}, state[action.chat_room_id] || {}, {
        isPosting: true,
        isPostFailed: false,
        withFiles: action.withFiles
      });
      return Object.assign({}, state, _defineProperty({}, action.chat_room_id, item));

    case _chatMessages.DELETE_CHAT_MESSAGE_REQUESTED:
      return Object.assign({}, state, {
        isRequesting: true
      });

    case _chatMessages.POST_CHAT_MESSAGE_FAILED:
      item = Object.assign({}, state[action.chat_room_id] || {}, {
        isPosting: false,
        isPostFailed: true
      });
      return Object.assign({}, state, _defineProperty({}, action.chat_room_id, item));

    case _chatMessages.DELETE_CHAT_MESSAGE_FAILED:
      return Object.assign({}, state, {
        isRequesting: false
      });

    case _chatMessages.FETCH_CHAT_MESSAGES_FAILED:
      item = Object.assign({}, state[action.chat_room_id] || {}, {
        isFetching: false,
        isFetchFailed: true
      });
      return Object.assign({}, state, _defineProperty({}, action.chat_room_id, item));

    case _chatMessages.FETCH_CHAT_MESSAGES_COMPLETED:
    case _reactChat.REACT_CHAT_COMPLETED:
    case _reactChat.DELETE_REACT_CHAT_COMPLETED:
      item = state[action.chat_room_id] || {};
      item = Object.assign({}, state[action.chat_room_id] || {}, {
        isFetching: false,
        hasMore: action.results.length == 10,
        items: action.offset > 0 ? (0, _store.mergeArray)('message_id', item.items, action.results) : action.results
      });
      return Object.assign({}, state, _defineProperty({}, action.chat_room_id, item));

    case _chatMessages.POST_CHAT_MESSAGE_COMPLETED:
      item = state[action.chat_room_id] || {};
      item = Object.assign({}, item, {
        isPosting: false,
        items: (0, _store.mergeArray)('message_id', item.items, [action.results], 'replace_or_prepend')
      });
      return Object.assign({}, state, _defineProperty({}, action.chat_room_id, item));

    case _chatMessages.DELETE_CHAT_MESSAGE_COMPLETED:
      item = state[action.chat_room_id] || {};
      item = Object.assign({}, item, {
        isRequesting: false,
        items: (0, _store.deleteArray)('message_id', item.items, [action.results.message_id])
      });
      return Object.assign({}, state, _defineProperty({}, action.chat_room_id, item));

    case _chatMessages.CLEAR_CHAT_MESSAGES:
      return initialState;

    case _chatMessages.LOAD_CHAT_MESSAGE:
      item = state[action.chat.chat_room_id];
      if (!item) return state; // chat_room_idのデータがからの場合は何もしない

      var current_message = (0, _store.getArray)('message_id', item.items, action.chat.message_id);
      if ((current_message && current_message.readers && current_message.readers.length || 0) > (action.chat.readers && action.chat.readers.length || 0)) return state; // 受け取ったmessageのreadersの数が、現在storeに入っているものより少ない場合は、データが先祖返りしているため破棄する

      if (action.appending || item.items && item.items.find(function (i) {
        return i.message_id == action.chat.message_id;
      })) {
        item = Object.assign({}, item, {
          // action.appendingがtrueの場合は末尾に追加・さもなくば破棄
          items: (0, _store.mergeArray)('message_id', item.items, [action.chat], action.appending ? 'replace_or_prepend' : 'discard')
        });
        return Object.assign({}, state, _defineProperty({}, action.chat.chat_room_id, item));
      } else return state;

    case _chatMessages.REMOVE_CHAT_MESSAGE:
      item = state[action.chat_room_id];
      if (!item) return state; // chat_room_idのデータがからの場合は何もしない
      item = Object.assign({}, item, {
        isRequesting: false,
        items: (0, _store.deleteArray)('message_id', item.items, [action.message_id])
      });
      return Object.assign({}, state, _defineProperty({}, action.chat_room_id, item));

    case _translate.TRANSLATE_MESSAGE_COMPLETED:
      item = state[action.chat_room_id];
      if (!item) return state; // chat_room_idのデータがからの場合は何もしない
      item = Object.assign({}, item, {
        items: (0, _store.updateArray)('message_id', item.items, action.message_id, 'attach_json', action.result.attach_json)
      });
      return Object.assign({}, state, _defineProperty({}, action.chat_room_id, item));

    default:
      return state;
  }
}

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chatRoomsReducer;

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

var _chatRooms = __webpack_require__(823);

var _store = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/reducers/chat-rooms-reducer.js

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  isRequesting: false,
  isRequestFailed: false,
  isCreating: false,
  isCreateFailed: false,
  items: undefined,
  imageItems: undefined,
  fileItems: undefined,
  videoItems: undefined,
  created: undefined,
  hasMoreImage: true,
  hasMoreFile: true,
  hasMoreVideo: true,
  hasMore: true,
  unreadCount: undefined
};

function chatRoomsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _chatRooms.FETCH_CHAT_ROOMS_REQUESTED:
    case _chatRooms.FETCH_CHAT_ROOM_REQUESTED:
    case _chatRooms.FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED:
    case _chatRooms.FETCH_ALBUM_CHAT_IMAGE_REQUESTED:
    case _chatRooms.FETCH_ALBUM_CHAT_FILE_REQUESTED:
    case _chatRooms.FETCH_ALBUM_CHAT_VIDEO_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _chatRooms.CREATE_CHAT_ROOM_REQUESTED:
      return Object.assign({}, state, {
        isCreating: true,
        isCreateFailed: false,
        created: undefined
      });

    case _chatRooms.MAKE_CHAT_MESSAGE_READ_REQUESTED:
    case _chatRooms.DELETE_CHAT_ROOM_REQUESTED:
      return Object.assign({}, state, {
        isRequesting: true,
        isRequestFailed: false
      });

    case _chatRooms.DELETE_CHAT_ROOM_REQUESTED:
    case _chatRooms.JOIN_CHAT_ROOM_REQUESTED:
    case _chatRooms.LEAVE_CHAT_ROOM_REQUESTED:
    case _chatRooms.UPDATE_CHAT_ROOM_REQUESTED:
    case _chatRooms.EXCLUDE_CHAT_ROOM_REQUESTED:
      return Object.assign({}, state, {
        isRequesting: true
      });

    case _chatRooms.FETCH_CHAT_ROOMS_FAILED:
    case _chatRooms.FETCH_CHAT_ROOM_FAILED:
    case _chatRooms.FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED:
    case _chatRooms.FETCH_ALBUM_CHAT_IMAGE_FAILED:
    case _chatRooms.FETCH_ALBUM_CHAT_FILE_FAILED:
    case _chatRooms.FETCH_ALBUM_CHAT_VIDEO_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _chatRooms.CREATE_CHAT_ROOM_FAILED:
      return Object.assign({}, state, {
        isCreating: false,
        isCreateFailed: true
      });

    case _chatRooms.DELETE_CHAT_ROOM_FAILED:
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: true
      });

    case _chatRooms.JOIN_CHAT_ROOM_FAILED:
    case _chatRooms.LEAVE_CHAT_ROOM_FAILED:
    case _chatRooms.UPDATE_CHAT_ROOM_FAILED:
    case _chatRooms.EXCLUDE_CHAT_ROOM_FAILED:
    case _chatRooms.MAKE_CHAT_MESSAGE_READ_FAILED:
      return Object.assign({}, state, {
        isRequesting: false
      });

    case _chatRooms.FETCH_CHAT_ROOMS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: action.offset > 0 ? (0, _store.mergeArray)('chat_room_id', state.items, action.results) : action.results,
        hasMore: action.results.length == _chatRooms.FETCH_CHAT_ROOMS_LENGTH
      });

    case _chatRooms.FETCH_ALBUM_CHAT_IMAGE_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        imageItems: action.offset > 0 ? (0, _store.mergeArray)('file_id', state.imageItems, action.results.files) : action.results.files,
        hasMoreImage: action.results.files.length == _chatRooms.FETCH_ALBUM_LENGTH
      });

    case _chatRooms.FETCH_ALBUM_CHAT_FILE_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        fileItems: action.offset > 0 ? (0, _store.mergeArray)('file_id', state.fileItems, action.results.files) : action.results.files,
        hasMoreFile: action.results.files.length == _chatRooms.FETCH_ALBUM_LENGTH
      });

    case _chatRooms.FETCH_ALBUM_CHAT_VIDEO_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        videoItems: action.offset > 0 ? (0, _store.mergeArray)('video_id', state.videoItems, action.results.files) : action.results.files,
        hasMoreVideo: action.results.files.length == _chatRooms.FETCH_ALBUM_LENGTH
      });

    case _chatRooms.CLEAR_CHAT_ALBUM:
      return Object.assign({}, state, {
        imageItems: undefined,
        fileItems: undefined,
        videoItems: undefined
      });

    case _chatRooms.CREATE_CHAT_ROOM_COMPLETED:
      return Object.assign({}, state, {
        isCreating: false,
        created: action.results,
        items: (0, _store.mergeArray)('chat_room_id', state.items, [action.results], 'replace_or_prepend')
      });

    case _chatRooms.FETCH_CHAT_ROOM_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: (0, _store.mergeArray)('chat_room_id', state.items, [action.results], 'replace_or_prepend')
      });

    case _chatRooms.FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED:
      return Object.assign({}, state, {
        unreadCount: action.results.unread_count
      });

    case _chatRooms.CLEAR_CHAT_ROOM_UNREAD_COUNT:
      return Object.assign({}, state, {
        unreadCount: undefined
      });

    case _chatRooms.LOAD_CHAT_ROOM_UNREAD_COUNT:
      if (state.unreadCount == action.unread_count) return state;else return Object.assign({}, state, {
        unreadCount: action.unread_count
      });

    case _chatRooms.DELETE_CHAT_ROOM_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: false,
        items: (0, _store.deleteArray)('chat_room_id', state.items, action.results.chat_room_id)
      });

    case _chatRooms.JOIN_CHAT_ROOM_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        items: (0, _store.mergeArray)('chat_room_id', state.items, [action.results], 'replace_or_prepend')
      });

    case _chatRooms.LEAVE_CHAT_ROOM_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        items: (0, _store.deleteArray)('chat_room_id', state.items, action.results.chat_room_id)
      });

    case _chatRooms.UPDATE_CHAT_ROOM_COMPLETED:
      var results = Object.assign({}, action.results, {
        icon_image: {
          url: action.results.icon_image.url + ('?refresh=' + Math.random()),
          thumb_url: action.results.icon_image.thumb_url + ('?refresh=' + Math.random())
        }
      });
      return Object.assign({}, state, {
        isRequesting: false,
        items: (0, _store.mergeArray)('chat_room_id', state.items, [action.results], 'replace_or_prepend')
      });

    case _chatRooms.CLEAR_CHAT_ROOMS:
      return Object.assign({}, initialState, {
        unreadCount: state.unreadCount
      });

    case _chatRooms.EXCLUDE_CHAT_ROOM_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        items: (0, _store.mergeArray)('chat_room_id', state.items, [action.results], 'replace_or_prepend')
      });

    case _chatRooms.LOAD_CHAT_ROOM:
      return Object.assign({}, state, {
        items: action.deleted && (0, _store.deleteArray)('chat_room_id', state.items, action.chat_room.chat_room_id) || (0, _store.mergeArray)('chat_room_id', state.items, [action.chat_room], 'replace_or_prepend')
      });
    case _chatRooms.MAKE_CHAT_MESSAGE_READ_COMPLETED:
      return Object.assign({}, state, {
        unreadCount: action.results.unread_count,
        isRequesting: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = commentsReducer;

var _comments = __webpack_require__(330);

var initialState = {
  isFetching: false,
  isPosting: false,
  isPostFailed: false
};
// src/reducers/comments-reducer.js

function commentsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _comments.POST_COMMENT_REQUESTED:
      return Object.assign({}, state, {
        isPosting: true,
        isPostFailed: false
      });

    case _comments.PUT_COMMENT_REQUESTED:
      return Object.assign({}, state, {
        isPosting: true,
        isPostFailed: false
      });

    case _comments.DELETE_COMMENT_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _comments.POST_COMMENT_FAILED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: true
      });

    case _comments.PUT_COMMENT_FAILED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: true
      });

    case _comments.DELETE_COMMENT_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _comments.POST_COMMENT_COMPLETED:
    case _comments.PUT_COMMENT_COMPLETED:
      return Object.assign({}, state, {
        isPosting: false
      });

    case _comments.DELETE_COMMENT_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diariesReducer;

var _agentType = __webpack_require__(142);

var _diaries = __webpack_require__(259);

var _homeDiaries = __webpack_require__(826);

var _comments = __webpack_require__(330);

var _likes = __webpack_require__(331);

var _translate = __webpack_require__(262);

var _store = __webpack_require__(18);

var _findIndex = __webpack_require__(263);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _reduce = __webpack_require__(160);

var _reduce2 = _interopRequireDefault(_reduce);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/diaries-reducer.js

// スマートフォンとWebで挙動を変えるため


var initialState = {
  isPosting: false,
  isPostFailed: false,
  isRequesting: false,
  groups: {} // isFetching, isFetchFailed, items, newItems, hasMore
};

function updateGroup(groups, group_id, group) {
  var _group = Object.assign({}, groups[group_id], group);
  return Object.assign({}, groups, _defineProperty({}, group_id, _group));
}

function diariesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var groups = void 0;

  switch (action.type) {
    case _diaries.FETCH_DIARIES_REQUESTED:
    case _homeDiaries.FETCH_HOME_DIARIES_REQUESTED:
      return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          isFetching: true,
          isFetchFailed: false
        })
      });

    case _diaries.FLUSH_UNREAD_DIARIES_REQUESTED:
    case _diaries.DELETE_DIARY_REQUESTED:
    case _diaries.MARK_DIARY_READ_REQUESTED:
      return Object.assign({}, state, {
        isRequesting: true
      });

    case _diaries.POST_OR_UPDATE_DIARY_REQUESTED:
      return Object.assign({}, state, {
        isPosting: true,
        isPostFailed: false
      });

    case _diaries.FETCH_DIARIES_FAILED:
    case _homeDiaries.FETCH_HOME_DIARIES_FAILED:
      return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          isFetching: false,
          isFetchFailed: true
        })
      }) || state;

    case _diaries.FLUSH_UNREAD_DIARIES_FAILED:
    case _diaries.DELETE_DIARY_FAILED:
    case _diaries.MARK_DIARY_READ_FAILED:
      return Object.assign({}, state, {
        isRequesting: false
      });

    case _diaries.POST_OR_UPDATE_DIARY_FAILED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: true
      });

    case _diaries.FETCH_DIARIES_COMPLETED:
    case _homeDiaries.FETCH_HOME_DIARIES_COMPLETED:
      return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          isFetching: false,
          isFetchFailed: false,
          items: action.offset > 0 && state.groups[action.group_id] ? (0, _store.mergeArray)('diary_id', state.groups[action.group_id].items, action.results) : action.results,
          newItems: action.offset == 0 ? [] : state.groups[action.group_id].newItems,
          hasMore: action.results.length == 10
        })
      });

    case _diaries.FLUSH_UNREAD_DIARIES_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        groups: updateGroup(state.groups, action.group_id, {
          items: action.results
        })
      });

    case _diaries.POST_OR_UPDATE_DIARY_COMPLETED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: false,
        groups: updateGroup(state.groups, action.group_id, {
          items: (0, _store.mergeArray)('diary_id', state.groups[action.group_id].items, [action.results], 'prepend')
        })
      });

    case _diaries.DELETE_DIARY_COMPLETED:
      groups = (0, _reduce2.default)(state.groups, function (r, group, id) {
        var index = (0, _findIndex2.default)(group.items, function (item) {
          return item.diary_id == action.results.diary_id;
        });
        if (index >= 0) {
          group.items = (0, _store.deleteArray)('diary_id', group.items, action.results.diary_id);
        }
        r[id] = group;
        return r;
      }, {});
      return Object.assign({}, state, {
        isRequesting: false, groups: groups
      });

    case _diaries.MARK_DIARY_READ_COMPLETED:
    case _comments.POST_COMMENT_COMPLETED:
    case _comments.PUT_COMMENT_COMPLETED:
    case _comments.DELETE_COMMENT_COMPLETED:
    case _likes.LIKE_DIARY_COMPLETED:
    case _likes.LIKE_COMMENT_COMPLETED:
    case _likes.DELETE_LIKE_COMPLETED:
      groups = (0, _reduce2.default)(state.groups, function (r, group, id) {
        var index = (0, _findIndex2.default)(group.items, function (item) {
          return item.diary_id == action.results.diary_id;
        });
        if (index >= 0) {
          var items = group.items.concat();
          var _group = group.items[index].group;
          var item = Object.assign({}, action.results);
          item.group = _group;
          items[index] = item;
          group.items = items;
        }
        r[id] = group;
        return r;
      }, {});
      return Object.assign({}, state, {
        isRequesting: false, groups: groups
      });

    case _diaries.CLEAR_DIARIES:
      if (action.group_id) {
        var _groups = Object.assign({}, state.groups);
        delete _groups[action.group_id];
        return Object.assign({}, state, { groups: _groups });
      } else return initialState;

    case _diaries.LOAD_DIARY:
      if (!state.groups[action.group_id]) return state;

      if (action.deleted) {
        return Object.assign({}, state, {
          groups: updateGroup(state.groups, action.group_id, {
            items: (0, _store.deleteArray)('diary_id', state.groups[action.group_id].items, action.diary.diary_id)
          })
        });
      } else if (action.appending) {
        //if (isSmartPhone && (!action.own_post || getArray('diary_id', state.items, action.diary.diary_id)))
        if (_agentType.isSmartPhone && !action.own_post)
          // スマホの場合で、自分自身の投稿でないappendingな場合はnewItemsに受信した投稿をためておく
          return Object.assign({}, state, {
            groups: updateGroup(state.groups, action.group_id, {
              newItems: (0, _store.mergeArray)('diary_id', state.groups[action.group_id].newItems, [action.diary], 'prepend')
            })
          });else return Object.assign({}, state, {
          groups: updateGroup(state.groups, action.group_id, {
            items: (0, _store.mergeArray)('diary_id', state.groups[action.group_id].items, [action.diary], 'prepend')
          })
        });
      } else {
        if (state.groups[action.group_id].items && state.groups[action.group_id].items.find(function (d) {
          return d.diary_id == action.diary.diary_id;
        }) || state.groups[action.group_id].newItems && state.groups[action.group_id].newItems.find(function (d) {
          return d.diary_id == action.diary.diary_id;
        })) return Object.assign({}, state, {
          groups: updateGroup(state.groups, action.group_id, {
            items: (0, _store.mergeArray)('diary_id', state.groups[action.group_id].items, [action.diary], 'discard'),
            newItems: state.groups[action.group_id].newItems && (0, _store.mergeArray)('diary_id', state.groups[action.group_id].newItems, [action.diary], 'discard') || []
          })
        });else return state;
      }

    case _diaries.MERGE_NEW_DIARIES:
      if (state.groups[action.group_id]) return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          items: (0, _store.mergeArray)('diary_id', state.groups[action.group_id].items, state.groups[action.group_id].newItems, 'prepend'),
          newItems: []
        })
      });else return state;

    case _translate.TRANSLATE_DIARY_COMPLETED:
      if (state.groups[action.group_id]) return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          items: (0, _store.updateArray)('diary_id', state.groups[action.group_id].items, action.diary_id, 'attach_json', action.results.attach_json)
        })
      });else return state;

    case _translate.TRANSLATE_COMMENT_COMPLETED:
      if (state.groups[action.group_id]) {
        var diary = (0, _store.getArray)('diary_id', state.groups[action.group_id].items, action.diary_id);
        if (!diary) return state;
        var comments = diary.comments && (0, _map2.default)(diary.comments, function (comment) {
          if (comment.comment_id == action.comment_id) return Object.assign({}, comment, { attach_json: action.results.attach_json });else {
            var sub_comments = comment.comments && (0, _map2.default)(comment.comments, function (sub_comment) {
              if (sub_comment.comment_id == action.comment_id) return Object.assign({}, sub_comment, { attach_json: action.results.attach_json });else return sub_comment;
            }) || undefined;
            return Object.assign({}, comment, { comments: sub_comments });
          }
        }) || undefined;
        return Object.assign({}, state, {
          groups: updateGroup(state.groups, action.group_id, {
            items: (0, _store.updateArray)('diary_id', state.groups[action.group_id].items, action.diary_id, 'comments', comments)
          })
        });
      } else return state;

    default:
      return state;
  }
}

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diaryTemplatesReducer;

var _store = __webpack_require__(18);

var _templates = __webpack_require__(463);

// src/reducers/diary-templates-reducer.js

var initialState = {
  isFetching: false,
  items: undefined
};

function diaryTemplatesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _templates.FETCH_DIARY_TEMPLATES_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _templates.FETCH_DIARY_TEMPLATES_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _templates.FETCH_DIARY_TEMPLATES_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.results
      });

    case _templates.CREATE_TEMPLATE_COMPLETED:
      return Object.assign({}, state, {
        items: (0, _store.mergeArray)('template_id', state.items, [action.results])
      });

    case _templates.UPDATE_TEMPLATE_COMPLETED:
      return Object.assign({}, state, {
        items: (0, _store.mergeArray)('template_id', state.items, [action.results])
      });

    case _templates.DELETE_TEMPLATE_COMPLETED:
      return Object.assign({}, state, {
        items: (0, _store.deleteArray)('template_id', state.items, action.results.template_id)
      });

    case _templates.CLEAR_DIARY_TEMPLATES:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diaryKpiReducer;

var _store = __webpack_require__(18);

var _kpi = __webpack_require__(461);

// src/reducers/diary-kpi-reducer.js

var initialState = {
  isFetching: false,
  items: undefined
};

function diaryKpiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _kpi.FETCH_DIARY_KPI_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _kpi.FETCH_DIARY_KPI_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _kpi.FETCH_DIARY_KPI_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.results
      });

    case _kpi.CLEAR_DIARY_KPI:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = favoritesReducer;

var _store = __webpack_require__(18);

var _favorite = __webpack_require__(460);

// src/reducers/favorite-reducer.js

var initialState = {
  isFetching: false,
  users: undefined
};

function favoritesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _favorite.FETCH_FAVORITE_GROUPS_REQUESTED:
    case _favorite.FETCH_FAVORITE_USERS_REQUESTED:
    case _favorite.UPDATE_FAVORITE_GROUP_REQUESTED:
    case _favorite.UPDATE_FAVORITE_USER_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _favorite.FETCH_FAVORITE_GROUPS_FAILED:
    case _favorite.FETCH_FAVORITE_USERS_FAILED:
    case _favorite.UPDATE_FAVORITE_GROUP_FAILED:
    case _favorite.UPDATE_FAVORITE_USER_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _favorite.FETCH_FAVORITE_GROUPS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _favorite.FETCH_FAVORITE_USERS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        users: action.results
      });

    case _favorite.UPDATE_FAVORITE_GROUP_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _favorite.UPDATE_FAVORITE_USER_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        users: action.results
      });

    case _favorite.CLEAR_FAVORITE_USERS:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = blockReducer;

var _store = __webpack_require__(18);

var _block = __webpack_require__(824);

// src/reducers/block-reducer.js

var initialState = {
  isFetching: false,
  users: undefined,
  diaries: undefined
};

function blockReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _block.FETCH_BLOCK_DIARIES_REQUESTED:
    case _block.FETCH_BLOCK_USERS_REQUESTED:
    case _block.UPDATE_BLOCK_DIARY_REQUESTED:
    case _block.UPDATE_BLOCK_USER_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _block.FETCH_BLOCK_DIARIES_FAILED:
    case _block.FETCH_BLOCK_USERS_FAILED:
    case _block.UPDATE_BLOCK_DIARY_FAILED:
    case _block.UPDATE_BLOCK_USER_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _block.FETCH_BLOCK_DIARIES_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        diaries: action.results
      });

    case _block.FETCH_BLOCK_USERS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        users: action.results
      });

    case _block.UPDATE_BLOCK_DIARY_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        diaries: action.results
      });

    case _block.UPDATE_BLOCK_USER_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        users: action.results
      });

    case _block.CLEAR_BLOCK_USERS:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _initialState;

exports.default = groupsReducer;

var _store = __webpack_require__(18);

var _groups = __webpack_require__(825);

var _user = __webpack_require__(177);

var _favorite = __webpack_require__(460);

var _sessions = __webpack_require__(260);

var _diaries = __webpack_require__(259);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _isEqual = __webpack_require__(226);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/groups-reducer.js

var initialState = (_initialState = {
  isFetching: false,
  isFetchFailed: false,
  isFetchingGroup: false,
  isFetchGroupFailed: false,
  isRequesting: false,
  isRequestFailed: false,
  isUpdating: false,
  isUpdateFailed: false,
  isMembershipUpdating: false,
  isMembershipUpdateFailed: false,
  isRemindSettingUpdating: false,
  isRemindSettingUpdateFailed: false,
  items: undefined,
  imageItems: undefined,
  fileItems: undefined,
  videoItems: undefined,
  created: undefined,
  hasMoreImage: true,
  hasMoreFile: true,
  hasMoreVideo: true,
  remindSchedule: undefined
}, _defineProperty(_initialState, 'created', undefined), _defineProperty(_initialState, 'scheduled_settings', undefined), _defineProperty(_initialState, 'isScheduledSettingsFetching', false), _defineProperty(_initialState, 'isScheduledSettingsFailed', false), _defineProperty(_initialState, 'isUpdateScheduledSettingsFetching', false), _defineProperty(_initialState, 'isUpdateScheduledSettingsFailed', false), _initialState);

function groupsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var items = void 0,
      group = void 0,
      old_group = void 0;

  switch (action.type) {
    case _groups.FETCH_GROUPS_REQUESTED:
    case _groups.SORT_GROUPS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false,
        isFetchGroupFailed: false
      });

    case _groups.FETCH_ALBUM_GROUP_IMAGE_REQUESTED:
    case _groups.FETCH_ALBUM_GROUP_FILE_REQUESTED:
    case _groups.FETCH_ALBUM_GROUP_VIDEO_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _groups.FETCH_GROUP_REQUESTED:
      return Object.assign({}, state, {
        isFetchingGroup: true,
        isFetchGroupFailed: false
      });

    case _groups.FETCH_GROUP_UNREAD_COUNT_REQUESTED:
    case _groups.FETCH_ALL_UNREAD_COUNT_REQUESTED:
    case _groups.DELETE_GROUP_REQUESTED:
    case _groups.MERGE_GROUP_REQUESTED:
      return Object.assign({}, state, {
        isRequesting: true,
        isRequestFailed: false
      });

    case _sessions.LOGOUT_COMPLETED:
      return Object.assign({}, state, {
        items: undefined
      });

    case _groups.CREATE_GROUP_REQUESTED:
    case _groups.UPDATE_GROUP_REQUESTED:
      return Object.assign({}, state, {
        isUpdating: true,
        isUpdateFailed: false
      });

    case _groups.UPDATE_GROUP_MEMBERSHIP_REQUESTED:
    case _groups.SORT_GROUP_MEMBERS_REQUESTED:
      return Object.assign({}, state, {
        isMembershipUpdating: true,
        isMembershipUpdateFailed: false
      });

    case _groups.UPDATE_REMIND_MAIL_SETTING_REQUESTED:
    case _groups.UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED:
      return Object.assign({}, state, {
        isRemindSettingUpdating: true,
        isRemindSettingUpdateFailed: false
      });

    case _groups.FETCH_REMIND_MAIL_SETTINGS_REQUESTED:
      return Object.assign({}, state, {
        remindSchedule: undefined,
        isRequesting: true,
        isRequestFailed: false
      });

    case _groups.FETCH_GROUPS_FAILED:
    case _groups.SORT_GROUPS_FAILED:
    case _groups.FETCH_ALBUM_GROUP_IMAGE_FAILED:
    case _groups.FETCH_ALBUM_GROUP_FILE_FAILED:
    case _groups.FETCH_ALBUM_GROUP_VIDEO_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _groups.FETCH_GROUP_FAILED:
      return Object.assign({}, state, {
        isFetchingGroup: false,
        isFetchGroupFailed: true
      });

    case _groups.FETCH_GROUP_UNREAD_COUNT_FAILED:
    case _groups.FETCH_ALL_UNREAD_COUNT_FAILED:
    case _groups.MERGE_GROUP_FAILED:
    case _groups.DELETE_GROUP_FAILED:
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: true
      });

    case _groups.CREATE_GROUP_FAILED:
    case _groups.UPDATE_GROUP_FAILED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: true
      });

    case _groups.UPDATE_GROUP_MEMBERSHIP_FAILED:
    case _groups.SORT_GROUP_MEMBERS_FAILED:
      return Object.assign({}, state, {
        isMembershipUpdating: false,
        isMembershipUpdateFailed: true
      });

    case _groups.FETCH_REMIND_MAIL_SETTINGS_FAILED:
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: true
      });

    case _groups.UPDATE_REMIND_MAIL_SETTING_FAILED:
    case _groups.UPDATE_REMIND_MAIL_SCHEDULE_FAILED:
      return Object.assign({}, state, {
        isRemindSettingUpdating: false,
        isRemindSettingUpdateFailed: true
      });

    case _groups.FETCH_GROUPS_COMPLETED:
    case _groups.SORT_GROUPS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: !state.items ? action.results : (0, _map2.default)(action.results, function (result) {
          var group = (0, _find2.default)(state.items, function (item) {
            return item.group_id == result.group_id;
          });
          if (!group) return result; // itemsに含まれていない新たなgroupが帰ってきた場合
          else if ((0, _isEqual2.default)(group, result)) return group; // itemsに入っているgroupの内容と同一内容だった場合
            else return Object.assign({}, group, result); // itemsに入っているgroupの内容と異なる場合
        })
      });

    case _groups.FETCH_ALBUM_GROUP_IMAGE_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        hasMoreImage: action.results.files.length == _groups.FETCH_ALBUM_LENGTH,
        imageItems: action.offset > 0 ? (0, _store.mergeArray)('file_id', state.imageItems, action.results.files) : action.results.files
      });

    case _groups.FETCH_ALBUM_GROUP_FILE_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        hasMoreFile: action.results.files.length == _groups.FETCH_ALBUM_LENGTH,
        fileItems: action.offset > 0 ? (0, _store.mergeArray)('file_id', state.fileItems, action.results.files) : action.results.files
      });

    case _groups.FETCH_ALBUM_GROUP_VIDEO_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        hasMoreVideo: action.results.files.length == _groups.FETCH_ALBUM_LENGTH,
        videoItems: action.offset > 0 ? (0, _store.mergeArray)('video_id', state.videoItems, action.results.files) : action.results.files
      });

    case _groups.CLEAR_GROUP_ALBUM:
      return Object.assign({}, state, {
        isFetching: false,
        imageItems: undefined,
        fileItems: undefined,
        videoItems: undefined
      });

    case _groups.FETCH_GROUP_UNREAD_COUNT_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: false,
        items: (0, _store.updateArray)('group_id', state.items, action.results.group_id, 'unreadCount', action.results.unreads)
      });

    case _groups.LOAD_GROUP_UNREAD_COUNT:
      items = (0, _store.updateArray)('group_id', state.items, action.group_id, 'unreadCount', action.unreads);
      if (state.items !== items) return Object.assign({}, state, { items: items });else return state;

    case _diaries.FLUSH_UNREAD_DIARIES_COMPLETED:
      return Object.assign({}, state, {
        items: (0, _store.updateArray)('group_id', state.items, action.group_id, 'unreadCount', 0)
      });

    case _groups.FETCH_ALL_UNREAD_COUNT_COMPLETED:
      items = state.items;
      (0, _each2.default)(action.results, function (item) {
        items = (0, _store.updateArray)('group_id', items, item.group_id, 'unreadCount', item.unreads);
      });
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: false,
        items: items
      });

    case _groups.FETCH_GROUP_COMPLETED:
      old_group = (0, _store.getArray)('group_id', state.items, action.results.group_id);
      group = old_group ? Object.assign({}, action.results, { unreadCount: old_group.unreadCount }) : action.results;
      if ((0, _isEqual2.default)(group, old_group)) group = old_group;

      return Object.assign({}, state, {
        isFetchingGroup: false,
        isFetchGroupFailed: false,
        items: (0, _store.mergeArray)('group_id', state.items, [group])
      });

    case _groups.CREATE_GROUP_COMPLETED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: false,
        items: (0, _store.mergeArray)('group_id', state.items, [action.results]),
        created: action.results
      });

    case _groups.UPDATE_GROUP_COMPLETED:
      var results = Object.assign({}, action.results, {
        icon_image: {
          url: action.results.icon_image.url + ('?refresh=' + Math.random()),
          thumb_url: action.results.icon_image.thumb_url + ('?refresh=' + Math.random())
        }
      });
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: false,
        items: (0, _store.mergeArray)('group_id', state.items, [results])
      });

    case _groups.UPDATE_GROUP_MEMBERSHIP_COMPLETED:
      return Object.assign({}, state, {
        isMembershipUpdating: false,
        isMembershipUpdateFailed: false,
        items: (0, _store.mergeArray)('group_id', state.items, [action.results])
      });

    case _groups.SORT_GROUP_MEMBERS_COMPLETED:
      return Object.assign({}, state, {
        isMembershipUpdating: false,
        isMembershipUpdateFailed: false,
        items: (0, _store.mergeArray)('group_id', state.items, [action.results])
      });

    case _groups.DELETE_GROUP_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: false,
        items: (0, _store.deleteArray)('group_id', state.items, action.results.group_id)
      });

    case _groups.MERGE_GROUP_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: false,
        items: (0, _store.deleteArray)('group_id', state.items, action.results.group_id)
      });

    case _groups.FETCH_REMIND_MAIL_SETTINGS_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: false,
        remindSchedule: action.results
      });

    case _groups.UPDATE_REMIND_MAIL_SETTING_COMPLETED:
      return Object.assign({}, state, {
        isRemindSettingUpdating: false,
        isRemindSettingUpdateFailed: false,
        items: (0, _store.mergeArray)('group_id', state.items, [action.results])
      });

    case _groups.UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED:
      return Object.assign({}, state, {
        isRemindSettingUpdating: false,
        isRemindSettingUpdateFailed: false,
        remindSchedule: action.results
      });

    case _favorite.FETCH_FAVORITE_GROUPS_COMPLETED:
    case _favorite.UPDATE_FAVORITE_GROUP_COMPLETED:
      items = state.items.map(function (item) {
        var __item = (0, _find2.default)(action.results, function (_item) {
          return _item.group_id == item.group_id;
        });
        return Object.assign({}, item, {
          favorite: !!(__item && __item.favorite)
        });
      });
      return Object.assign({}, state, {
        items: items
      });

    case _groups.SEARCH_GROUPS:
      return Object.assign({}, state, {
        search: action.query
      });

    case _groups.LOAD_GROUP:
      if (action.deleted || !action.group.can_read) return Object.assign({}, state, {
        items: (0, _store.deleteArray)('group_id', state.items, action.group.group_id)
      });

      old_group = (0, _store.getArray)('group_id', state.items, action.group.group_id);
      group = old_group ? Object.assign({}, action.group, { unreadCount: old_group.unreadCount }) : action.group;

      return Object.assign({}, state, {
        items: (0, _store.mergeArray)('group_id', state.items, [group])
      });

    case _user.UPDATE_USER_PROFILE_COMPLETED:
      var user = action.results;
      items = (0, _map2.default)(state.items, function (group) {
        var members = (0, _map2.default)(group.members, function (member) {
          return member.user_id == user.user_id ? user : member;
        });
        return Object.assign({}, group, { members: members });
      });
      return Object.assign({}, state, { items: items });

    case _groups.FETCH_SCHEDULED_SETTINGS_REQUESTED:
      return Object.assign({}, state, {
        isScheduledSettingsFetching: true,
        isScheduledSettingsFailed: false
      });

    case _groups.UPDATE_SCHEDULED_SETTINGS_REQUESTED:
      return Object.assign({}, state, {
        isUpdateScheduledSettingsFetching: true,
        isUpdateScheduledSettingsFailed: false
      });

    case _groups.FETCH_SCHEDULED_SETTINGS_FAILED:
      return Object.assign({}, state, {
        isScheduledSettingsFetching: false,
        isScheduledSettingsFailed: true
      });

    case _groups.UPDATE_SCHEDULED_SETTINGS_FAILED:
      return Object.assign({}, state, {
        isUpdateScheduledSettingsFetching: false,
        isUpdateScheduledSettingsFailed: true
      });

    case _groups.FETCH_SCHEDULED_SETTINGS_COMPLETED:
      return Object.assign({}, state, {
        isScheduledSettingsFetching: false,
        isScheduledSettingsFailed: false,
        scheduled_settings: action.results.group_membership
      });

    case _groups.UPDATE_SCHEDULED_SETTINGS_COMPLETED:
      return Object.assign({}, state, {
        isUpdateScheduledSettingsFetching: false,
        isUpdateScheduledSettingsFailed: false
      });

    case _groups.CLEAR_SCHEDULED_SETTINGS:
      return Object.assign({}, state, {
        scheduled_settings: undefined
      });

    default:
      return state;
  }
}

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = kpiChartReducer;

var _store = __webpack_require__(18);

var _kpiChart = __webpack_require__(829);

// src/reducers/kpi-chart-reducer.js

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  isUpdating: false,
  isUpdateFailed: false,
  items: undefined,
  current: undefined
};

function kpiChartReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _kpiChart.FETCH_KPI_CHART_REQUESTED:
    case _kpiChart.FETCH_KPI_LIST_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _kpiChart.UPDATE_KPI_ACTUAL_RECORD_REQUESTED:
      return Object.assign({}, state, {
        isUpdating: true,
        isUpdateFailed: false
      });

    case _kpiChart.FETCH_KPI_CHART_FAILED:
    case _kpiChart.FETCH_KPI_LIST_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _kpiChart.UPDATE_KPI_ACTUAL_RECORD_FAILED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: true
      });

    case _kpiChart.FETCH_KPI_CHART_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        current: action.results
      });

    case _kpiChart.UPDATE_KPI_ACTUAL_RECORD_COMPLETED:
      return Object.assign({}, state, {
        isUpdating: false
      });

    case _kpiChart.FETCH_KPI_LIST_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: (0, _store.mergeArray)('kpi_id', state.items, action.results)
      });

    case _kpiChart.CLEAR_KPI_CHART:
      return Object.assign({}, state, {
        current: undefined
      });

    default:
      return state;
  }
}

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = kpiReducer;

var _store = __webpack_require__(18);

var _kpi = __webpack_require__(461);

// src/reducers/kpi-reducer.js

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  isUpdating: false,
  isUpdateFailed: false,
  items: undefined,
  closedItems: undefined,
  hasMoreClosedItems: true,
  scrollPosition: undefined
};

function kpiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _kpi.FETCH_KPIS_REQUESTED:
    case _kpi.FETCH_GROUP_KPIS_REQUESTED:
    case _kpi.FETCH_CHART_KPIS_REQUESTED:
    case _kpi.FETCH_COMPARISON_KPIS_REQUESTED:
    case _kpi.FETCH_KPI_REQUESTED:
    case _kpi.FETCH_CLOSED_KPIS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _kpi.CREATE_KPI_REQUESTED:
    case _kpi.UPDATE_KPI_REQUESTED:
    case _kpi.DELETE_KPI_REQUESTED:
    case _kpi.SORT_KPIS_REQUESTED:
      return Object.assign({}, state, {
        isUpdating: true,
        isUpdateFailed: false
      });

    case _kpi.FETCH_KPIS_FAILED:
    case _kpi.FETCH_GROUP_KPIS_FAILED:
    case _kpi.FETCH_CHART_KPIS_FAILED:
    case _kpi.FETCH_COMPARISON_KPIS_FAILED:
    case _kpi.FETCH_KPI_FAILED:
    case _kpi.FETCH_CLOSED_KPIS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _kpi.CREATE_KPI_FAILED:
    case _kpi.UPDATE_KPI_FAILED:
    case _kpi.DELETE_KPI_FAILED:
    case _kpi.SORT_KPIS_FAILED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: true
      });

    case _kpi.FETCH_KPIS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: action.results
      });

    case _kpi.FETCH_CHART_KPIS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        chart_items: action.results
      });

    case _kpi.FETCH_GROUP_KPIS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        group_items: action.results
      });

    case _kpi.FETCH_COMPARISON_KPIS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        comparison_items: action.results
      });

    case _kpi.FETCH_KPI_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: (0, _store.mergeArray)('kpi_id', state.items, [action.results])
      });

    case _kpi.FETCH_CLOSED_KPIS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        closedItems: action.offset > 0 ? (0, _store.mergeArray)('kpi_id', state.closedItems, action.results) : action.results,
        hasMoreClosedItems: action.results.length == 10
      });

    case _kpi.CREATE_KPI_COMPLETED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: false,
        items: (0, _store.mergeArray)('kpi_id', state.items, [action.results])
      });

    case _kpi.UPDATE_KPI_COMPLETED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: false,
        items: (0, _store.mergeArray)('kpi_id', state.items, [action.results])
      });

    case _kpi.DELETE_KPI_COMPLETED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: false,
        items: (0, _store.deleteArray)('kpi_id', state.items, action.results.kpi_id),
        closedItems: (0, _store.deleteArray)('kpi_id', state.closedItems, action.results.kpi_id)
      });

    case _kpi.SORT_KPIS_COMPLETED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: false,
        items: action.results
      });

    case _kpi.CLEAR_KPIS:
      return initialState;

    case _kpi.CLEAR_CLOSED_KPIS:
      return Object.assign({}, state, {
        closedItems: undefined,
        scrollPosition: undefined
      });

    case _kpi.KEEP_SCROLL_POSITION:
      return Object.assign({}, state, {
        scrollPosition: action.offset
      });

    default:
      return state;
  }
}

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = likesReducer;

var _store = __webpack_require__(18);

var _reduce = __webpack_require__(160);

var _reduce2 = _interopRequireDefault(_reduce);

var _likes = __webpack_require__(331);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false
};
// src/reducers/likes-reducer.js

function likesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _likes.LIKE_DIARY_REQUESTED:
    case _likes.LIKE_COMMENT_REQUESTED:
    case _likes.FETCH_LIKE_CONFIG_REQUESTED:
    case _likes.DELETE_LIKE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _likes.LIKE_DIARY_FAILED:
    case _likes.LIKE_COMMENT_FAILED:
    case _likes.FETCH_LIKE_CONFIG_FAILED:
    case _likes.DELETE_LIKE_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _likes.LIKE_DIARY_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _likes.LIKE_COMMENT_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _likes.FETCH_LIKE_CONFIG_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        likeConfig: (0, _reduce2.default)(action.results, function (r, item) {
          r[item.like_type] = { icon: item.icon, label: item.label };
          return r;
        }, {})

      });

    case _likes.DELETE_LIKE_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pinsReducer;

var _store = __webpack_require__(18);

var _pins = __webpack_require__(830);

// src/reducers/pins-reducer.js

var initialState = {
  isFetching: false
};

function pinsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _pins.PIN_DIARY_REQUESTED:
    case _pins.UNPIN_DIARY_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _pins.PIN_DIARY_FAILED:
    case _pins.UNPIN_DIARY_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _pins.PIN_DIARY_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _pins.UNPIN_DIARY_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = notificationsReducer;

var _store = __webpack_require__(18);

var _notifications = __webpack_require__(831);

var _homeNotifications = __webpack_require__(827);

var _user = __webpack_require__(177);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/notifications-reducer.js

var initialState = {
  isRequesting: false,
  groups: {},
  unreadCount: {}
};

function updateGroup(groups, group_id, group) {
  var _group = Object.assign({}, groups[group_id], group);
  return Object.assign({}, groups, _defineProperty({}, group_id, _group));
}

function notificationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _notifications.FETCH_NOTIFICATIONS_REQUESTED:
    case _homeNotifications.FETCH_HOME_NOTIFICATIONS_REQUESTED:
      return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          isFetching: true,
          isFetchFailed: false
        })
      });

    case _notifications.FETCH_NOTIFICATIONS_UNREAD_COUNT_REQUESTED:
    case _notifications.FLUSH_UNREAD_NOTIFICATIONS_REQUESTED:
    case _homeNotifications.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_REQUESTED:
    case _homeNotifications.FLUSH_UNREAD_HOME_NOTIFICATIONS_REQUESTED:
      return Object.assign({}, state, {
        isRequesting: true
      });

    case _notifications.FETCH_NOTIFICATIONS_FAILED:
    case _homeNotifications.FETCH_HOME_NOTIFICATIONS_FAILED:
      return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          isFetching: false,
          isFetchFailed: true
        })
      });

    case _notifications.FETCH_NOTIFICATIONS_UNREAD_COUNT_FAILED:
    case _notifications.FLUSH_UNREAD_NOTIFICATIONS_FAILED:
    case _homeNotifications.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_FAILED:
    case _homeNotifications.FLUSH_UNREAD_HOME_NOTIFICATIONS_FAILED:
      return Object.assign({}, state, {
        isRequesting: false
      });

    case _notifications.FETCH_NOTIFICATIONS_COMPLETED:
    case _homeNotifications.FETCH_HOME_NOTIFICATIONS_COMPLETED:
      return Object.assign({}, state, {
        groups: updateGroup(state.groups, action.group_id, {
          isFetching: false,
          isFetchFailed: false,
          items: action.offset > 0 && state.groups[action.group_id] ? (0, _store.mergeArray)('notification_id', state.groups[action.group_id].items, action.results) : action.results,
          hasMore: action.results.length == 10
        })
      });

    case _notifications.FETCH_NOTIFICATIONS_UNREAD_COUNT_COMPLETED:
    case _homeNotifications.FETCH_HOME_NOTIFICATIONS_UNREAD_COUNT_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        unreadCount: Object.assign({}, state.unreadCount, _defineProperty({}, action.group_id, action.results.count))
      });

    case _homeNotifications.LOAD_HOME_NOTIFICATION_UNREAD_COUNT:
    case _notifications.LOAD_NOTIFICATION_UNREAD_COUNT:
      if (!state.unreadCount || state.unreadCount[action.group_id] != action.count) return Object.assign({}, state, {
        unreadCount: Object.assign({}, state.unreadCount, _defineProperty({}, action.group_id, action.count))
      });else return state;

    case _notifications.FLUSH_UNREAD_NOTIFICATIONS_COMPLETED:
    case _homeNotifications.FLUSH_UNREAD_HOME_NOTIFICATIONS_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        unreadCount: !state.unreadCount || state.unreadCount[action.group_id] != action.results.count ? Object.assign({}, state.unreadCount, _defineProperty({}, action.group_id, action.results.count)) : state.unreadCount
      });

    case _notifications.UPDATE_NOTIFICATION_STATUS_COMPLETED:
      var groups = state.groups[action.results.group_id] ? updateGroup(state.groups, action.results.group_id, {
        items: (0, _store.mergeArray)('notification_id', state.groups[action.results.group_id].items, [action.results], 'discard')
      }) : state.groups;
      if (state.groups.home && state.groups.home.items) groups = updateGroup(groups, 'home', {
        items: (0, _store.mergeArray)('notification_id', state.groups.home.items, [action.results], 'discard')
      });
      return Object.assign({}, state, { groups: groups });

    case _notifications.CLEAR_NOTIFICATIONS:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = organizationsReducer;

var _store = __webpack_require__(18);

var _organizations = __webpack_require__(832);

// src/reducers/organizations-reducer.js

var initialState = {
  isFetching: false,
  isRequesting: false,
  items: undefined
};

function organizationsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _organizations.FETCH_ORGANIZATIONS_REQUESTED:
    case _organizations.FETCH_ORGANIZATION_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _organizations.FETCH_ORGANIZATION_MEMBERS_REQUESTED:
    case _organizations.UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED:
    case _organizations.FETCH_ORGANIZATION_GROUPS_REQUESTED:
      return Object.assign({}, state, {
        isRequesting: true
      });

    case _organizations.FETCH_ORGANIZATIONS_FAILED:
    case _organizations.FETCH_ORGANIZATION_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _organizations.FETCH_ORGANIZATION_MEMBERS_FAILED:
    case _organizations.UPDATE_ORGANIZATION_MEMBERSHIP_FAILED:
    case _organizations.FETCH_ORGANIZATION_GROUPS_FAILED:
      return Object.assign({}, state, {
        isRequesting: false
      });

    case _organizations.FETCH_ORGANIZATIONS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.results
      });

    case _organizations.FETCH_ORGANIZATION_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: [].concat((0, _store.replaceTree)('organization_id', state.items, action.results))
      });

    case _organizations.FETCH_ORGANIZATION_MEMBERS_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        members: action.results
      });

    case _organizations.UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        members: action.results
      });

    case _organizations.FETCH_ORGANIZATION_GROUPS_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        groups: action.results
      });

    default:
      return state;
  }
}

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = preservedQueriesReducer;

var _store = __webpack_require__(18);

var _preservedQueries = __webpack_require__(833);

// src/reducers/preserved-queries-reducer.js

var initialState = {
  isFetching: false,
  isCreating: false,
  items: undefined
};

function preservedQueriesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _preservedQueries.FETCH_PRESERVED_QUERIES_REQUESTED:
    case _preservedQueries.DELETE_PRESERVED_QUERY_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _preservedQueries.CREATE_PRESERVED_QUERY_REQUESTED:
      return Object.assign({}, state, {
        isCreating: true
      });

    case _preservedQueries.FETCH_PRESERVED_QUERIES_FAILED:
    case _preservedQueries.DELETE_PRESERVED_QUERY_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _preservedQueries.CREATE_PRESERVED_QUERY_FAILED:
      return Object.assign({}, state, {
        isCreating: false
      });

    case _preservedQueries.FETCH_PRESERVED_QUERIES_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.results
      });

    case _preservedQueries.CREATE_PRESERVED_QUERY_COMPLETED:
      return Object.assign({}, state, {
        isCreating: false,
        created_query_id: action.results.query_id,
        items: (0, _store.mergeArray)('query_id', state.items, [action.results])
      });

    case _preservedQueries.DELETE_PRESERVED_QUERY_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: (0, _store.deleteArray)('query_id', state.items, action.results.query_id)
      });

    case _preservedQueries.CLEAR_PRESERVED_QUERIES:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = savedDiariesReducer;

var _store = __webpack_require__(18);

var _savedDiaries = __webpack_require__(834);

var _editDiary = __webpack_require__(466);

var _diaries = __webpack_require__(259);

// src/reducers/saved-diaries-reducer.js

var initialState = {
  isFetching: false,
  isPosting: false,
  isPostFailed: false,
  items: undefined,
  current: undefined
};

function savedDiariesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _savedDiaries.SAVE_DIARY_REQUESTED:
      return Object.assign({}, state, {
        isPosting: true,
        isPostFailed: false
      });

    case _savedDiaries.SAVE_DIARY_COMPLETED:
      if (!state.isPosting) return state;

      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: false,
        items: (0, _store.mergeArray)('diary_id', state.items, [action.results]),
        current: action.results
      });

    case _savedDiaries.CLEAR_SAVED_DIARY:
      return Object.assign({}, state, {
        isPosting: false,
        current: undefined
      });

    case _savedDiaries.SAVE_DIARY_FAILED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: true
      });

    case _savedDiaries.FETCH_SAVED_DIARIES_REQUESTED:
    case _savedDiaries.DELETE_SAVED_DIARY_REQUESTED:
    case _savedDiaries.DELETE_ALL_SAVED_DIARY_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _savedDiaries.FETCH_SAVED_DIARIES_FAILED:
    case _savedDiaries.DELETE_SAVED_DIARY_FAILED:
    case _savedDiaries.DELETE_ALL_SAVED_DIARY_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _savedDiaries.FETCH_SAVED_DIARIES_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.results
      });

    case _savedDiaries.DELETE_SAVED_DIARY_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: (0, _store.deleteArray)('diary_id', state.items, action.results.diary_id),
        current: state.current && state.current.diary_id == action.results.diary_id ? undefined : state.current
      });

    case _savedDiaries.DELETE_ALL_SAVED_DIARY_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: [],
        current: state.current && state.current.diary_id == action.results.diary_id ? undefined : state.current
      });
    case _diaries.POST_OR_UPDATE_DIARY_COMPLETED:
      return Object.assign({}, state, {
        current: undefined
      });

    case _editDiary.EDIT_DIARY_COMPLETED:
      if (!state.current) return Object.assign({}, state, {
        current: action.results
      });else return state;

    case _savedDiaries.CLEAR_SAVED_DIARIES:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sessionsReducer;

var _store = __webpack_require__(18);

var _accessToken = __webpack_require__(220);

var _accessToken2 = _interopRequireDefault(_accessToken);

var _sessions = __webpack_require__(260);

var _user = __webpack_require__(177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/reducers/sessions-reducer.js

var initialState = {
  isFetching: false,
  login: false,
  access_token: undefined,
  isFailed: false
};
_accessToken2.default.get(function (token) {
  initialState.login = !!token;
  initialState.access_token = token;
});

function sessionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _sessions.LOGIN_REQUESTED:
    case _sessions.LOGOUT_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _sessions.LOGIN_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFailed: true
      });

    case _sessions.LOGOUT_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _sessions.LOGIN_COMPLETED:
      if (action.results.access_token) return Object.assign({}, state, {
        isFetching: false,
        isFailed: false,
        login: true,
        access_token: action.results.access_token,
        password_change_required: undefined,
        password_required: undefined,
        passcode_required: undefined,
        sso_required: undefined,
        sso_url: undefined
      });else return Object.assign({}, state, {
        isFetching: false,
        isFailed: false,
        password_required: action.results.password_required,
        passcode_required: action.results.passcode_required,
        password_change_required: action.results.password_change_required,
        sso_required: action.results.sso_required,
        sso_url: action.results.sso_url
      });

    case _sessions.CLEAR_LOGIN_STATUS:
      return Object.assign({}, state, {
        isFetching: false,
        isFailed: false,
        password_change_required: undefined,
        password_required: undefined,
        passcode_required: undefined,
        sso_required: undefined,
        sso_url: undefined
      });

    case _user.UPDATE_PASSWORD_COMPLETED:
      return Object.assign({}, state, {
        access_token: action.results.access_token
      });

    case _sessions.LOGOUT_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        login: false,
        access_token: undefined
      });

    case _sessions.CHECK_LOGIN_STATUS_COMPLETED:
      return Object.assign({}, state, {
        isChecking: false,
        login: action.access_token ? true : false,
        access_token: action.access_token
      });

    case _sessions.CHECK_LOGIN_STATUS_REQUESTED:
      return Object.assign({}, state, {
        isChecking: true
      });

    default:
      return state;
  }
}

/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = subDiariesReducer;

var _store = __webpack_require__(18);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _subDiaries = __webpack_require__(835);

var _homeSubDiaries = __webpack_require__(828);

var _diaries = __webpack_require__(259);

var _comments = __webpack_require__(330);

var _likes = __webpack_require__(331);

var _translate = __webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/sub-diaries-reducer.js

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  hasMore: true,
  items: undefined
};

function updateGroup(groups, group_id, group) {
  var _group = Object.assign({}, groups[group_id], group);
  return Object.assign({}, groups, _defineProperty({}, group_id, _group));
}

function subDiariesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _subDiaries.FETCH_SUB_DIARIES_REQUESTED:
    case _subDiaries.SEARCH_DIARIES_REQUESTED:
    case _homeSubDiaries.FETCH_HOME_SUB_DIARIES_REQUESTED:
    case _homeSubDiaries.FETCH_HOME_SUB_USER_DIARIES_REQUESTED:
    case _homeSubDiaries.SEARCH_HOME_DIARIES_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false,
        hasMore: true
      });

    case _subDiaries.FETCH_SUB_DIARY_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _subDiaries.FETCH_SUB_DIARIES_FAILED:
    case _subDiaries.SEARCH_DIARIES_FAILED:
    case _homeSubDiaries.FETCH_HOME_SUB_DIARIES_FAILED:
    case _homeSubDiaries.FETCH_HOME_SUB_USER_DIARIES_FAILED:
    case _homeSubDiaries.SEARCH_HOME_DIARIES_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _subDiaries.FETCH_SUB_DIARY_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _subDiaries.FETCH_SUB_DIARIES_COMPLETED:
    case _subDiaries.SEARCH_DIARIES_COMPLETED:
    case _homeSubDiaries.FETCH_HOME_SUB_DIARIES_COMPLETED:
    case _homeSubDiaries.FETCH_HOME_SUB_USER_DIARIES_COMPLETED:
    case _homeSubDiaries.SEARCH_HOME_DIARIES_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: action.offset > 0 ? (0, _store.mergeArray)('diary_id', state.items, action.results) : action.results,
        hasMore: action.results.length == 10
      });

    case _subDiaries.LOAD_DIARY_TO_SUB_DIARIES:
      return Object.assign({}, state, {
        items: [action.diary],
        hasMore: false
      });

    case _subDiaries.FETCH_SUB_DIARY_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: (0, _store.mergeArray)('diary_id', state.items, [action.results], 'append')
      });

    case _diaries.MARK_DIARY_READ_COMPLETED:
    case _comments.POST_COMMENT_COMPLETED:
    case _comments.PUT_COMMENT_COMPLETED:
    case _comments.DELETE_COMMENT_COMPLETED:
    case _likes.LIKE_DIARY_COMPLETED:
    case _likes.LIKE_COMMENT_COMPLETED:
    case _likes.DELETE_LIKE_COMPLETED:
      var original_items = Object.assign([], state.items);
      var target_items = [action.results];

      target_items.forEach(function (target_item) {

        var index = original_items.findIndex(function (orig_elm) {
          return orig_elm['diary_id'] === target_item['diary_id'];
        });
        if (index >= 0) {
          // Add the 'group' from the original diary to the fetched diary
          target_item.group = original_items[index].group;
        }
      });

      return Object.assign({}, state, {
        items: (0, _store.mergeArray)('diary_id', state.items, target_items, 'discard')
      });

    case _diaries.LOAD_DIARY:
      if (action.deleted) {
        return Object.assign({}, state, {
          items: (0, _store.deleteArray)('diary_id', state.items, action.diary.diary_id)
        });
      }
      return Object.assign({}, state, {
        items: (0, _store.mergeArray)('diary_id', state.items, [action.diary], 'discard')
      });

    case _diaries.DELETE_DIARY_COMPLETED:
      return Object.assign({}, state, {
        items: (0, _store.deleteArray)('diary_id', state.items, action.results.diary_id)
      });

    case _subDiaries.CLEAR_SUB_DIARIES:
      return initialState;

    case _translate.TRANSLATE_DIARY_COMPLETED:
      return Object.assign({}, state, {
        items: (0, _store.updateArray)('diary_id', state.items, action.diary_id, 'attach_json', action.results.attach_json)
      });

    case _translate.TRANSLATE_COMMENT_COMPLETED:
      var diary = (0, _store.getArray)('diary_id', state.items, action.diary_id);
      if (!diary) return state;
      var comments = diary.comments && (0, _map2.default)(diary.comments, function (comment) {
        if (comment.comment_id == action.comment_id) return Object.assign({}, comment, { attach_json: action.results.attach_json });else {
          var sub_comments = comment.comments && (0, _map2.default)(comment.comments, function (sub_comment) {
            if (sub_comment.comment_id == action.comment_id) return Object.assign({}, sub_comment, { attach_json: action.results.attach_json });else return sub_comment;
          }) || undefined;
          return Object.assign({}, comment, { comments: sub_comments });
        }
      }) || undefined;
      return Object.assign({}, state, {
        items: (0, _store.updateArray)('diary_id', state.items, action.diary_id, 'comments', comments)
      });

    default:
      return state;
  }
}

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = subscribesReducer;

var _store = __webpack_require__(18);

var _subscribe = __webpack_require__(836);

// src/reducers/subscribes-reducer.js

var initialState = {
  isFetching: false
};

function subscribesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _subscribe.SUBSCRIBE_DEVICE_TOKEN_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _subscribe.SUBSCRIBE_DEVICE_TOKEN_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _subscribe.SUBSCRIBE_DEVICE_TOKEN_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = templatesReducer;

var _store = __webpack_require__(18);

var _templates = __webpack_require__(463);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _flatten = __webpack_require__(479);

var _flatten2 = _interopRequireDefault(_flatten);

var _uniq = __webpack_require__(486);

var _uniq2 = _interopRequireDefault(_uniq);

var _filter = __webpack_require__(53);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/reducers/templates-reducer.js

var initialState = {
  isFetching: false,
  isUpdating: false,
  isUpdateFailed: false,
  items: undefined,
  field_list: undefined
};

function templatesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _templates.FETCH_TEMPLATES_REQUESTED:
    case _templates.FETCH_TEMPLATE_REQUESTED:
    case _templates.DELETE_TEMPLATE_REQUESTED:
    case _templates.IMPORT_USER_PROFILE_TEMPLATE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _templates.CREATE_TEMPLATE_REQUESTED:
    case _templates.UPDATE_TEMPLATE_REQUESTED:
      return Object.assign({}, state, {
        isUpdating: true,
        isUpdateFailed: false
      });

    case _templates.FETCH_TEMPLATES_FAILED:
    case _templates.FETCH_TEMPLATE_LIST_FAILED:
    case _templates.FETCH_TEMPLATE_FAILED:
    case _templates.DELETE_TEMPLATE_FAILED:
    case _templates.IMPORT_USER_PROFILE_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _templates.CREATE_TEMPLATE_FAILED:
    case _templates.UPDATE_TEMPLATE_FAILED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: true
      });

    case _templates.FETCH_TEMPLATES_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.results
      });

    case _templates.FETCH_TEMPLATE_LIST_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        list: undefined
      });

    case _templates.FETCH_TEMPLATE_LIST_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        list: action.results
      });

    case _templates.FETCH_TEMPLATE_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: (0, _store.mergeArray)('template_id', state.items, [action.results])
      });

    case _templates.CREATE_TEMPLATE_COMPLETED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: false,
        items: (0, _store.mergeArray)('template_id', state.items, [action.results])
      });

    case _templates.UPDATE_TEMPLATE_COMPLETED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: false,
        items: (0, _store.mergeArray)('template_id', state.items, [action.results])
      });

    case _templates.DELETE_TEMPLATE_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: (0, _store.deleteArray)('template_id', state.items, action.results.template_id)
      });

    case _templates.FETCH_TEMPLATE_FIELDS_COMPLETED:
      var attach_jsons = (0, _filter2.default)((0, _map2.default)(action.results, function (template) {
        return template.attach_json;
      }), function (json) {
        return json && json.fields;
      });
      return Object.assign({}, state, {
        field_list: (0, _uniq2.default)((0, _map2.default)((0, _flatten2.default)((0, _map2.default)(attach_jsons, function (json) {
          return json.fields;
        })), function (field) {
          return field.name;
        }))
      });

    case _templates.FETCH_TEMPLATE_ALL_FIELDS_COMPLETED:
      var fieldList = action.results.filter(function (item) {
        return item.attach_json.fields.length > 0;
      }).map(function (item) {
        return {
          group_id: item.group_id ? item.group_id : 0,
          fields: item.attach_json.fields.map(function (field) {
            return {
              group_id: item.group_id ? item.group_id : 0,
              name: field.name
            };
          })
        };
      });
      return Object.assign({}, state, {
        field_list: fieldList
      });

    case _templates.IMPORT_USER_PROFILE_TEMPLATE_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        userProfileTemplate: action.results[0]
      });

    case _templates.CLEAR_USER_PROFILE_TEMPLATE:
      return Object.assign({}, state, {
        userProfileTemplate: undefined
      });

    case _templates.CLEAR_TEMPLATES:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uploadFileReducer;

var _store = __webpack_require__(18);

var _cloneDeep = __webpack_require__(585);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _merge6 = __webpack_require__(587);

var _merge7 = _interopRequireDefault(_merge6);

var _uploadFile = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/upload-file-reducer.js

var initialState = {};

function uploadFileReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _uploadFile.UPLOAD_FILE_REQUESTED:
      return (0, _merge7.default)((0, _cloneDeep2.default)(state), _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, {
        isUploading: true,
        loaded: null,
        total: null,
        single: action.single
      })));

    case _uploadFile.UPLOAD_FILE_FAILED:
      return (0, _merge7.default)((0, _cloneDeep2.default)(state), _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, null)));

    case _uploadFile.UPLOAD_FILE_COMPLETED:
      if (action.single) return Object.assign({}, state, _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, {
        isUploading: false,
        item: action.results,
        loaded: null,
        total: null
      })));else return (0, _merge7.default)((0, _cloneDeep2.default)(state), _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, {
        isUploading: false,
        item: action.results,
        loaded: null,
        total: null
      })));

    case _uploadFile.UPLOAD_FILE_PROGRESS:
      return (0, _merge7.default)((0, _cloneDeep2.default)(state), _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, {
        isUploading: true,
        loaded: action.loaded,
        total: action.total
      })));

    case _uploadFile.CANCEL_UPLOAD_FILE:
      return (0, _merge7.default)((0, _cloneDeep2.default)(state), _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, null)));

    case _uploadFile.CLEAR_UPLOAD_FILES_AND_VIDEOS:
      return Object.assign({}, state, _defineProperty({}, action.componentId, undefined));

    default:
      return state;
  }
}

/***/ }),
/* 2844 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(311),
    arrayEach = __webpack_require__(816),
    assignValue = __webpack_require__(422),
    baseAssign = __webpack_require__(2845),
    baseAssignIn = __webpack_require__(2846),
    cloneBuffer = __webpack_require__(1134),
    copyArray = __webpack_require__(487),
    copySymbols = __webpack_require__(2849),
    copySymbolsIn = __webpack_require__(2850),
    getAllKeys = __webpack_require__(762),
    getAllKeysIn = __webpack_require__(2851),
    getTag = __webpack_require__(317),
    initCloneArray = __webpack_require__(2852),
    initCloneByTag = __webpack_require__(2853),
    initCloneObject = __webpack_require__(1137),
    isArray = __webpack_require__(62),
    isBuffer = __webpack_require__(310),
    isMap = __webpack_require__(2858),
    isObject = __webpack_require__(98),
    isSet = __webpack_require__(2860),
    keys = __webpack_require__(138);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(218),
    keys = __webpack_require__(138);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(218),
    keysIn = __webpack_require__(400);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(98),
    isPrototype = __webpack_require__(308),
    nativeKeysIn = __webpack_require__(2848);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 2848 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(218),
    getSymbols = __webpack_require__(437);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(218),
    getSymbolsIn = __webpack_require__(1135);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(763),
    getSymbolsIn = __webpack_require__(1135),
    keysIn = __webpack_require__(400);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 2852 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(586),
    cloneDataView = __webpack_require__(2854),
    cloneRegExp = __webpack_require__(2855),
    cloneSymbol = __webpack_require__(2856),
    cloneTypedArray = __webpack_require__(1136);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(586);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 2855 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(217);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(98);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(2859),
    baseUnary = __webpack_require__(251),
    nodeUtil = __webpack_require__(430);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(317),
    isObjectLike = __webpack_require__(117);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(2861),
    baseUnary = __webpack_require__(251),
    nodeUtil = __webpack_require__(430);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(317),
    isObjectLike = __webpack_require__(117);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(311),
    assignMergeValue = __webpack_require__(1138),
    baseFor = __webpack_require__(756),
    baseMergeDeep = __webpack_require__(2863),
    isObject = __webpack_require__(98),
    keysIn = __webpack_require__(400),
    safeGet = __webpack_require__(1139);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(1138),
    cloneBuffer = __webpack_require__(1134),
    cloneTypedArray = __webpack_require__(1136),
    copyArray = __webpack_require__(487),
    initCloneObject = __webpack_require__(1137),
    isArguments = __webpack_require__(309),
    isArray = __webpack_require__(62),
    isArrayLikeObject = __webpack_require__(886),
    isBuffer = __webpack_require__(310),
    isFunction = __webpack_require__(424),
    isObject = __webpack_require__(98),
    isPlainObject = __webpack_require__(743),
    isTypedArray = __webpack_require__(429),
    safeGet = __webpack_require__(1139),
    toPlainObject = __webpack_require__(2864);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(218),
    keysIn = __webpack_require__(400);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uploadVideoReducer;

var _store = __webpack_require__(18);

var _merge6 = __webpack_require__(587);

var _merge7 = _interopRequireDefault(_merge6);

var _cloneDeep = __webpack_require__(585);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _uploadVideo = __webpack_require__(464);

var _uploadFile = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/upload-video-reducer.js

var initialState = {};

function uploadVideoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _uploadVideo.UPLOAD_VIDEO_REQUESTED:
      return (0, _merge7.default)((0, _cloneDeep2.default)(state), _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, {
        isUploading: true,
        loaded: null,
        total: null
      })));

    case _uploadVideo.UPLOAD_VIDEO_FAILED:
      return (0, _merge7.default)((0, _cloneDeep2.default)(state), _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, null)));

    case _uploadVideo.UPLOAD_VIDEO_COMPLETED:
      return (0, _merge7.default)((0, _cloneDeep2.default)(state), _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, {
        isUploading: false,
        item: action.results,
        loaded: null,
        total: null
      })));

    case _uploadVideo.UPLOAD_VIDEO_PROGRESS:
      return (0, _merge7.default)((0, _cloneDeep2.default)(state), _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, {
        isUploading: true,
        loaded: action.loaded,
        total: action.total
      })));

    case _uploadVideo.CANCEL_UPLOAD_VIDEO:
      return (0, _merge7.default)((0, _cloneDeep2.default)(state), _defineProperty({}, action.componentId, _defineProperty({}, action.uploadId, null)));

    case _uploadFile.CLEAR_UPLOAD_FILES_AND_VIDEOS:
      return Object.assign({}, state, _defineProperty({}, action.componentId, undefined));

    default:
      return state;
  }
}

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userReducer;

var _store = __webpack_require__(18);

var _user = __webpack_require__(177);

var _sessions = __webpack_require__(260);

var _isEqual = __webpack_require__(226);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  isFailed: false,
  isNotificationUpdating: false,
  isNotificationUpdateFailed: false,
  isProfileUpdating: false,
  isProfileUpdateFailed: false,
  isPasswordUpdating: false,
  isPasswordUpdateFailed: false,
  isEmailUpdating: false,
  isEmailUpdateFailed: false,
  isConfirmationRequesting: false,
  isConfirmationRequestFailed: false,
  current: undefined,
  notificationSettings: undefined,
  firstLogin: false
};
// src/reducers/user-reducer.js
function userReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _user.FETCH_NOTIFICATION_SETTINGS_REQUESTED:
    case _user.FETCH_CURRENT_USER_REQUESTED:
    case _user.SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFailed: false
      });

    case _user.UPDATE_NOTIFICATION_SETTINGS_REQUESTED:
    case _user.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED:
    case _user.UPDATE_SCHEDULE_TYPE_REQUESTED:
    case _user.UPDATE_SCHEDULE_ACTIVE_REQUESTED:
    case _user.UPDATE_DAY_SCHEDULE_REQUESTED:
    case _user.UPDATE_CUSTOM_SCHEDULE_REQUESTED:
      return Object.assign({}, state, {
        isNotificationUpdating: true,
        isNotificationUpdateFailed: false
      });

    case _user.UPDATE_USER_PROFILE_REQUESTED:
    case _user.UPDATE_USER_MENU_ITEMS_REQUESTED:
      return Object.assign({}, state, {
        isProfileUpdating: true,
        isProfileUpdateFailed: false
      });

    case _user.UPDATE_PASSWORD_REQUESTED:
      return Object.assign({}, state, {
        isPasswordUpdating: true,
        isPasswordUpdateFailed: false
      });

    case _user.REQUEST_CONFIRMATION_MAIL_REQUESTED:
      return Object.assign({}, state, {
        isConfirmationRequesting: true,
        isConfirmationRequestFailed: false
      });

    case _user.UPDATE_EMAIL_REQUESTED:
      return Object.assign({}, state, {
        isEmailUpdating: true,
        isEmailUpdateFailed: false
      });

    case _user.FETCH_NOTIFICATION_SETTINGS_FAILED:
    case _user.FETCH_CURRENT_USER_FAILED:
    case _user.SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFailed: true
      });

    case _user.UPDATE_NOTIFICATION_SETTINGS_FAILED:
    case _user.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED:
    case _user.UPDATE_SCHEDULE_TYPE_FAILED:
    case _user.UPDATE_SCHEDULE_ACTIVE_FAILED:
    case _user.UPDATE_DAY_SCHEDULE_FAILED:
    case _user.UPDATE_CUSTOM_SCHEDULE_FAILED:
      return Object.assign({}, state, {
        isNotificationUpdating: false,
        isNotificationUpdateFailed: true
      });

    case _user.UPDATE_USER_PROFILE_FAILED:
    case _user.UPDATE_USER_MENU_ITEMS_FAILED:
      return Object.assign({}, state, {
        isProfileUpdating: false,
        isProfileUpdateFailed: true
      });

    case _user.UPDATE_PASSWORD_FAILED:
      return Object.assign({}, state, {
        isPasswordUpdating: false,
        isPasswordUpdateFailed: true
      });

    case _user.REQUEST_CONFIRMATION_MAIL_FAILED:
      return Object.assign({}, state, {
        isConfirmationRequesting: false,
        isConfirmationRequestFailed: true
      });

    case _user.UPDATE_EMAIL_FAILED:
      return Object.assign({}, state, {
        isEmailUpdating: false,
        isEmailUpdateFailed: true
      });

    case _user.FETCH_NOTIFICATION_SETTINGS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFailed: false,
        notificationSettings: action.results
      });

    case _user.UPDATE_NOTIFICATION_SETTINGS_COMPLETED:
    case _user.UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED:
    case _user.UPDATE_SCHEDULE_TYPE_COMPLETED:
    case _user.UPDATE_SCHEDULE_ACTIVE_COMPLETED:
    case _user.UPDATE_DAY_SCHEDULE_COMPLETED:
    case _user.UPDATE_CUSTOM_SCHEDULE_COMPLETED:
      return Object.assign({}, state, {
        isNotificationUpdating: false,
        isNotificationUpdateFailed: false,
        notificationSettings: action.results
      });

    case _user.FETCH_CURRENT_USER_COMPLETED:
      var current = state.current;
      if (!(0, _isEqual2.default)(current, action.results)) current = action.results;

      return Object.assign({}, state, {
        isFailed: false,
        isFetching: false,
        current: current,
        firstLogin: action.results.sign_in_count <= 1 && (0, _moment2.default)(action.results.created_at).isAfter((0, _moment2.default)().add(-10, 'days'))
      });

    case _user.SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED:
      return Object.assign({}, state, {
        isFailed: false,
        isFetching: false,
        current: action.results
      });

    case _sessions.LOGOUT_COMPLETED:
      return Object.assign({}, initialState);

    case _user.UPDATE_USER_PROFILE_COMPLETED:
    case _user.UPDATE_USER_MENU_ITEMS_COMPLETED:
      var results = Object.assign({}, action.results, {
        icon_image: {
          url: action.results.icon_image.url + ('?refresh=' + Math.random()),
          thumb_url: action.results.icon_image.thumb_url + ('?refresh=' + Math.random())
        }
      });
      return Object.assign({}, state, {
        isProfileUpdating: false,
        isProfileUpdateFailed: false,
        current: results,
        firstLogin: action.results.sign_in_count <= 1 && (0, _moment2.default)(action.results.created_at).isAfter((0, _moment2.default)().add(-10, 'days'))
      });

    case _user.UPDATE_PASSWORD_COMPLETED:
      return Object.assign({}, state, {
        isPasswordUpdating: false,
        isPasswordUpdateFailed: false
      });

    case _user.UPDATE_EMAIL_COMPLETED:
      return Object.assign({}, state, {
        isEmailUpdating: false,
        isEmailUpdateFailed: false,
        current: action.results
      });

    case _user.REQUEST_CONFIRMATION_MAIL_COMPLETED:
      return Object.assign({}, state, {
        isConfirmationRequesting: false,
        isConfirmationRequestFailed: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usersReducer;

var _store = __webpack_require__(18);

var _users = __webpack_require__(837);

var _user = __webpack_require__(177);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/users-reducer.js

var initialState = {
  isFetching: false,
  items: undefined
};

function usersReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _user.UPDATE_USER_PROFILE_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: Object.assign({}, state.items, _defineProperty({}, action.results.user_id, action.results))
      });
    case _users.FETCH_USER_INFO_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _users.FETCH_USER_INFO_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _users.FETCH_USER_INFO_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        items: Object.assign({}, state.items, _defineProperty({}, action.results.user_id, action.results))
      });

    default:
      return state;
  }
}

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sidebarReducer;

var _sidebar = __webpack_require__(838);

var initialState = {
  open: true,
  docked: true
};
// src/reducers/sidebar-reducer.js

function sidebarReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _sidebar.OPEN_SIDEBAR:
      return Object.assign({}, state, {
        open: true
      });

    case _sidebar.CLOSE_SIDEBAR:
      return Object.assign({}, state, {
        open: false
      });

    case _sidebar.DOCK_SIDEBAR:
      return Object.assign({}, state, {
        docked: true
      });

    case _sidebar.UNDOCK_SIDEBAR:
      return Object.assign({}, state, {
        docked: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rightSidebarReducer;

var _rightSidebar = __webpack_require__(840);

var _cloneDeep = __webpack_require__(585);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _each = __webpack_require__(58);

var _each2 = _interopRequireDefault(_each);

var _isArray = __webpack_require__(62);

var _isArray2 = _interopRequireDefault(_isArray);

var _isEqual = __webpack_require__(226);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _concat = __webpack_require__(908);

var _concat2 = _interopRequireDefault(_concat);

var _isObject = __webpack_require__(98);

var _isObject2 = _interopRequireDefault(_isObject);

var _merge = __webpack_require__(587);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/reducers/right-sidebar-reducer.js

var initialState = {
  name: undefined,
  params: undefined,
  lastState: undefined
};

function rightSidebarReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _rightSidebar.OPEN_RIGHT_SIDE_PAGE:
      var params = (0, _cloneDeep2.default)(action.params);
      delete params.append;
      action.params.append && (0, _each2.default)(action.params.append, function (value, key) {
        params[key] = value;
        if (state.params && state.params[key] && (0, _isArray2.default)(state.params[key])) {
          params[key] = (0, _concat2.default)(state.params[key], value);
        } else if (state.params && state.params[key] && (0, _isObject2.default)(state.params[key])) {
          params[key] = (0, _merge2.default)(state.params[key], value);
        }
      });
      if (state.name == action.name && (0, _isEqual2.default)(state.params, params) && !action.push) return state;
      return Object.assign({}, state, {
        name: action.name,
        params: params,
        lastState: action.push && { name: state.name, params: state.params } || undefined
      });

    case _rightSidebar.CLOSE_RIGHT_SIDE_PAGE:
      if (state.lastState && !action.forced) return Object.assign({}, state, {
        name: state.lastState.name,
        params: state.lastState.params,
        lastState: undefined
      });else return Object.assign({}, state, {
        name: undefined,
        params: undefined,
        lastState: undefined
      });

    default:
      return state;
  }
}

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = googleApiReducer;

var _store = __webpack_require__(18);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _googleApi = __webpack_require__(465);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/google-api-reducer.js

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  isCalendarFatching: false,
  isCalendarFatchFailed: false,
  calendars: undefined,
  events: undefined,
  selectDate: undefined,
  isFoldersFetching: false,
  isFoldersFetchFailed: false,
  folders: undefined,
  isUserInfoFetching: false,
  isUserInfoFetchFailed: false,
  userinfo: undefined,
  isUploadFetching: false,
  isUploadFetchFailed: false,
  refresh_token: undefined,
  isRefreshTokenFetching: false,
  isRefreshTokenFailed: false
};

function googleApiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _googleApi.FETCH_GOOGLE_CALENDAR_EVENTS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _googleApi.FETCH_GOOGLE_CALENDAR_CALENDARS_REQUESTED:
      return Object.assign({}, state, {
        isCalendarFetching: true,
        isCalendarFetchFailed: false
      });

    case _googleApi.FETCH_GOOGLE_DRIVE_FOLDERS_REQUESTED:
      return Object.assign({}, state, {
        isFoldersFetching: true,
        isFoldersFetchFailed: false
      });

    case _googleApi.FETCH_GOOGLE_DRIVE_USERINFO_REQUESTED:
      return Object.assign({}, state, {
        isUserInfoFetching: true,
        isUserInfoFetchFailed: false
      });

    case _googleApi.UPLOAD_GOOGLE_DRIVE_FILE_REQUESTED:
      return Object.assign({}, state, {
        isUploadFetching: true,
        isUploadFetchFailed: false
      });

    case _googleApi.FETCH_REFRESH_TOKEN_REQUESTED:
      return Object.assign({}, state, {
        isRefreshTokenFetching: true,
        isRefreshTokenFailed: false
      });

    case _googleApi.FETCH_GOOGLE_CALENDAR_EVENTS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _googleApi.FETCH_GOOGLE_CALENDAR_CALENDARS_FAILED:
      return Object.assign({}, state, {
        isCalendarFetching: false,
        isCalendarFetchFailed: true
      });

    case _googleApi.FETCH_REFRESH_TOKEN_FAILED:
      return Object.assign({}, state, {
        isRefreshTokenFetching: false,
        isRefreshTokenFailed: true
      });

    case _googleApi.FETCH_GOOGLE_DRIVE_FOLDERS_FAILED:
      return Object.assign({}, state, {
        isFoldersFetching: false,
        isFoldersFetchFailed: true
      });

    case _googleApi.FETCH_GOOGLE_DRIVE_USERINFO_FAILED:
      return Object.assign({}, state, {
        isUserInfoFetching: false,
        isUserInfoFetchFailed: true
      });

    case _googleApi.UPLOAD_GOOGLE_DRIVE_FILE_FAILED:
      return Object.assign({}, state, {
        isUploadFetching: false,
        isUploadFetchFailed: true
      });

    case _googleApi.FETCH_GOOGLE_CALENDAR_EVENTS_COMPLETED:
      //1日の予定を取得する
      var resultsData = action.results && action.results.filter(function (result) {
        return result.startTime && result.endTime && (0, _moment2.default)(result.startTime).format('YYYY-MM-DD') == (0, _moment2.default)(result.endTime).format('YYYY-MM-DD');
      });
      //日跨ぎの予定または終日の予定をfilterする
      var straddlingTheDayData = action.results && action.results.filter(function (result) {
        return result.startTime && result.endTime && (0, _moment2.default)(result.startTime).format('YYYY-MM-DD') != (0, _moment2.default)(result.endTime).format('YYYY-MM-DD') || result.date && result.endDate;
      });

      //straddlingTheDayDataで取得した値が配列の先頭に来るようにする
      var calendarData = resultsData && straddlingTheDayData && straddlingTheDayData.length > 0 ? straddlingTheDayData.concat(resultsData) : null;

      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        events: Object.assign({}, state.events, _defineProperty({}, action.calendar, Object.assign({}, state.events ? state.events[action.calendar] : {}, calendarData ? _defineProperty({}, (0, _moment2.default)(action.selectDate).format('YYYY-MM-DD'), calendarData) : _defineProperty({}, (0, _moment2.default)(action.selectDate).format('YYYY-MM-DD'), action.results))))
      });

    case _googleApi.FETCH_GOOGLE_CALENDAR_CALENDARS_COMPLETED:
      return Object.assign({}, state, {
        isCalendarFetching: false,
        isCalendarFetchFailed: false,
        calendars: action.results
      });

    case _googleApi.FETCH_GOOGLE_DRIVE_FOLDERS_COMPLETED:
      return Object.assign({}, state, {
        isFoldersFetching: false,
        isFoldersFetchFailed: false,
        folders: action.results
      });

    case _googleApi.FETCH_GOOGLE_DRIVE_USERINFO_COMPLETED:
      return Object.assign({}, state, {
        isUserInfoFetching: false,
        isUserInfoFetchFailed: false,
        userinfo: action.results
      });

    case _googleApi.UPLOAD_GOOGLE_DRIVE_FILE_COMPLETED:
      return Object.assign({}, state, {
        isUploadFetching: false,
        isUploadFetchFailed: false
      });

    case _googleApi.FETCH_REFRESH_TOKEN_COMPLETED:
      return Object.assign({}, state, {
        isRefreshTokenFetching: false,
        isRefreshTokenFailed: false,
        refresh_token: action.results.refresh_token
      });

    case _googleApi.CLEAR_GOOGLE_CALENDAR_EVENTS:
      return Object.assign({}, state, {
        events: undefined,
        selectDate: undefined
      });

    case _googleApi.CLEAR_GOOGLE_CALENDAR_CALENDARS:
      return initialState;

    case _googleApi.CLEAR_GOOGLE_DRIVE_FOLDERS:
      return initialState;

    default:
      return state;
  }
}

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = outlookApiReducer;

var _store = __webpack_require__(18);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _outlookCalendar = __webpack_require__(841);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/outlook-api-reducer.js

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  isCalendarFatching: false,
  isCalendarFatchFailed: false,
  calendars: undefined,
  events: undefined,
  selectDate: undefined
};

function outlookApiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {

    case _outlookCalendar.FETCH_OUTLOOK_CALENDARS_REQUESTED:
      return Object.assign({}, state, {
        isCalendarFetching: true,
        isCalendarFetchFailed: false
      });

    case _outlookCalendar.FETCH_OUTLOOK_CALENDARS_FAILED:
      return Object.assign({}, state, {
        isCalendarFetching: false,
        isCalendarFetchFailed: true
      });

    case _outlookCalendar.FETCH_OUTLOOK_CALENDARS_COMPLETED:
      return Object.assign({}, state, {
        isCalendarFetching: false,
        isCalendarFetchFailed: false,
        calendars: action.results
      });

    case _outlookCalendar.FETCH_OUTLOOK_CALENDAR_EVENTS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _outlookCalendar.FETCH_OUTLOOK_CALENDAR_EVENTS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _outlookCalendar.CLEAR_OUTLOOK_CALENDARS:
      return {
        calendars: undefined
      };

    case _outlookCalendar.FETCH_OUTLOOK_CALENDAR_EVENTS_COMPLETED:
      //1日の予定を取得する
      var resultsData = action.results && action.results.filter(function (result) {
        return result.startTime && result.endTime && (0, _moment2.default)(result.startTime).format('YYYY-MM-DD') == (0, _moment2.default)(result.endTime).format('YYYY-MM-DD');
      });
      //日跨ぎの予定または終日の予定をfilterする
      var straddlingTheDayData = action.results && action.results.filter(function (result) {
        return result.startTime && result.endTime && (0, _moment2.default)(result.startTime).format('YYYY-MM-DD') != (0, _moment2.default)(result.endTime).format('YYYY-MM-DD') || result.date && result.endDate;
      });

      //straddlingTheDayDataで取得した値が配列の先頭に来るようにする
      var calendarData = resultsData && straddlingTheDayData && straddlingTheDayData.length > 0 ? straddlingTheDayData.concat(resultsData) : null;

      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        events: Object.assign({}, state.events, _defineProperty({}, action.calendar, Object.assign({}, state.events ? state.events[action.calendar] : {}, calendarData ? _defineProperty({}, (0, _moment2.default)(action.selectDate).format('YYYY-MM-DD'), calendarData) : _defineProperty({}, (0, _moment2.default)(action.selectDate).format('YYYY-MM-DD'), action.results))))
      });

    case _outlookCalendar.CLEAR_OUTLOOK_CALENDAR_EVENTS:
      return Object.assign({}, state, {
        events: undefined,
        selectDate: undefined
      });

    default:
      return state;
  }
}

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diaryFormReducer;

var _diaryForm = __webpack_require__(842);

var initialState = {
  insert: {
    html: undefined
  }
};
// src/reducers/diary-form-reducer.js

function diaryFormReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _diaryForm.INSERT_DIARY_FORM:
      return Object.assign({}, state, {
        insert: {
          html: action.html
        }
      });

    case _diaryForm.CLEAR_INSERT_DIARY_FORM:
      return Object.assign({}, state, {
        insert: {
          html: undefined
        }
      });

    default:
      return state;
  }
}

/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = editDiaryReducer;

var _editDiary = __webpack_require__(466);

var initialState = {
  isFetching: false
};
// src/reducers/edit-diary-reducer.js

function editDiaryReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _editDiary.EDIT_DIARY_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _editDiary.EDIT_DIARY_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _editDiary.EDIT_DIARY_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    default:
      return initialState;
  }
}

/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = groupSettingsReducer;

var _groupSettings = __webpack_require__(843);

var initialState = {
  name: undefined,
  active: false
};
// src/reducers/group-settings-reducer.js

function groupSettingsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _groupSettings.OPEN_GROUP_SETTINGS_PAGE:
      return Object.assign({}, state, {
        name: action.name,
        active: true
      });

    case _groupSettings.CLOSE_GROUP_SETTINGS_PAGE:
      return Object.assign({}, state, {
        name: undefined,
        active: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userSettingsReducer;

var _userSettings = __webpack_require__(844);

var initialState = {
  name: undefined,
  active: false
};
// src/reducers/user-settings-reducer.js

function userSettingsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _userSettings.OPEN_USER_SETTINGS_PAGE:
      return Object.assign({}, state, {
        name: action.name,
        active: true
      });

    case _userSettings.CLOSE_USER_SETTINGS_PAGE:
      return Object.assign({}, state, {
        name: undefined,
        active: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = socketReducer;

var _socket = __webpack_require__(839);

var _store = __webpack_require__(18);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/socket-reducer.js

var initialState = {
  status: undefined,
  items: {}
};

function socketReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _socket.SOCKET_CONNECT:
      return Object.assign({}, state, {
        status: 'connected',
        items: {}
      });

    case _socket.SOCKET_RECONNECT:
      return Object.assign({}, state, {
        status: 'connected',
        items: {}
      });

    case _socket.SOCKET_RECONNECTING:
      return Object.assign({}, state, {
        status: 'reconnecting',
        items: {}
      });

    case _socket.SOCKET_DISCONNECT:
      return Object.assign({}, state, {
        status: undefined,
        items: {}
      });

    case _socket.SOCKET_RECEIVE:
      var items = state.items[action.message_type];
      return Object.assign({}, state, {
        items: Object.assign({}, state.items, _defineProperty({}, action.message_type, items ? items.concat(action.params) : [action.params]))
      });

    default:
      return state;
  }
}

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return state; // do nothing for Web app
};

/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = productTourReducer;

var _productTour = __webpack_require__(845);

var initialState = {
  state: undefined
};
// src/reducers/product-tour-reducer.js

function productTourReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _productTour.FETCH_PRODUCT_TOUR_STATE:
      return Object.assign({}, state, {
        state: action.state
      });

    default:
      return state;
  }
}

/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRegistrationUrlReducer;

var _registrationUrl = __webpack_require__(846);

var initialState = {
  isFetching: false,
  url: undefined
}; // src/reducers/registration-url-reducer.js

function getRegistrationUrlReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _registrationUrl.GET_REGISTRATION_URL_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _registrationUrl.GET_REGISTRATION_URL_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _registrationUrl.GET_REGISTRATION_URL_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        url: action.results.url
      });

    default:
      return state;
  }
}

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = accountOtherMembersCountReducer;

var _accountOtherMembersCount = __webpack_require__(847);

var initialState = {
  isFetching: false,
  otherMembers: false
};
// src/reducers/account-other-members-count-reducer.js

function accountOtherMembersCountReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _accountOtherMembersCount.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _accountOtherMembersCount.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _accountOtherMembersCount.FETCH_ACCOUNT_OTHER_MEMBERS_COUNT_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        otherMembers: action.results.length > 0
      });

    default:
      return state;
  }
}

/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = urlInfoReducer;

var _store = __webpack_require__(18);

var _urlInfo = __webpack_require__(848);

var _googleApi = __webpack_require__(465);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// src/reducers/user-reducer.js


var initialState = {};

function urlInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _googleApi.FETCH_GOOGLE_DRIVE_FILE_REQUESTED:
    case _urlInfo.FETCH_URL_INFO_REQUESTED:
      return Object.assign({}, state, _defineProperty({}, action.componentId, Object.assign({}, state[action.componentId] || {}, _defineProperty({
        isFetching: true,
        isFetchFailed: false
      }, action.url, {
        item: undefined
      }))));

    case _googleApi.FETCH_GOOGLE_DRIVE_FILE_COMPLETED:
    case _urlInfo.FETCH_URL_INFO_COMPLETED:
      return Object.assign({}, state, _defineProperty({}, action.componentId, Object.assign({}, state[action.componentId] || {}, _defineProperty({
        isFetching: false,
        isFetchFailed: false
      }, action.url, {
        item: action.results
      }))));

    case _urlInfo.FETCH_URL_INFO_FAILED:
    case _googleApi.FETCH_GOOGLE_DRIVE_FILE_FAILED:
      return Object.assign({}, state, _defineProperty({}, action.componentId, Object.assign({}, state[action.componentId] || {}, _defineProperty({
        isFetching: false,
        isFetchFailed: true
      }, action.url, undefined))));

    case _urlInfo.CLEAR_URL_INFO:
      return Object.assign({}, state, _defineProperty({}, action.componentId, undefined));

    default:
      return state;
  }
}

/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imagesViewReducer;

var _imagesView = __webpack_require__(849);

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  items: undefined
};
// src/reducers/attachments-reducer.js

function imagesViewReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _imagesView.FETCH_IMAGES_VIEW_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _imagesView.FETCH_IMAGES_VIEW_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: action.results
      });

    case _imagesView.FETCH_IMAGES_VIEW_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _imagesView.CLEAR_IMAGES_VIEW:
      return Object.assign({}, state, {
        isFetching: false,
        items: undefined
      });

    default:
      return state;
  }
}

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = translateReducer;

var _store = __webpack_require__(18);

var _translate = __webpack_require__(262);

// src/reducers/translate-reducer.js

var initialState = {
  isTranslating: false
};

function translateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _translate.TRANSLATE_DIARY_REQUESTED:
    case _translate.TRANSLATE_COMMENT_REQUESTED:
    case _translate.TRANSLATE_MESSAGE_REQUESTED:
      return Object.assign({}, state, {
        isTranslating: true
      });

    case _translate.TRANSLATE_DIARY_FAILED:
    case _translate.TRANSLATE_COMMENT_FAILED:
    case _translate.TRANSLATE_MESSAGE_FAILED:
      return Object.assign({}, state, {
        isTranslating: false
      });

    case _translate.TRANSLATE_DIARY_COMPLETED:
      return Object.assign({}, state, {
        isTranslating: false
      });

    case _translate.TRANSLATE_COMMENT_COMPLETED:
      return Object.assign({}, state, {
        isTranslating: false
      });

    case _translate.TRANSLATE_MESSAGE_COMPLETED:
      return Object.assign({}, state, {
        isTranslating: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dashboardReducer;

var _store = __webpack_require__(18);

var _dashboard = __webpack_require__(850);

// src/reducers/dashboard-reducer.js

var initialState = {
  isSummaryFetching: false,
  isPostsFetching: false,
  isRepliesFetching: false,
  isReceivesFetching: false,
  isDetailsFetching: false,
  summary: undefined,
  posts: undefined,
  replies: undefined,
  receives: undefined,
  details: undefined
};

function dashboardReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _dashboard.FETCH_DASHBOARD_SUMMARY_REQUESTED:
      return Object.assign({}, state, {
        isSummaryFetching: true
      });

    case _dashboard.FETCH_DASHBOARD_POSTS_REQUESTED:
      return Object.assign({}, state, {
        isPostsFetching: true
      });

    case _dashboard.FETCH_DASHBOARD_REPLIES_REQUESTED:
      return Object.assign({}, state, {
        isRepliesFetching: true
      });

    case _dashboard.FETCH_DASHBOARD_RECEIVES_REQUESTED:
      return Object.assign({}, state, {
        isReceivesFetching: true
      });

    case _dashboard.FETCH_DASHBOARD_DETAILS_REQUESTED:
      return Object.assign({}, state, {
        isDetailsFetching: true
      });

    case _dashboard.FETCH_DASHBOARD_SUMMARY_FAILED:
      return Object.assign({}, state, {
        isSummaryFetching: false
      });

    case _dashboard.FETCH_DASHBOARD_POSTS_FAILED:
      return Object.assign({}, state, {
        isPostsFetching: false
      });

    case _dashboard.FETCH_DASHBOARD_REPLIES_FAILED:
      return Object.assign({}, state, {
        isRepliesFetching: false
      });

    case _dashboard.FETCH_DASHBOARD_RECEIVES_FAILED:
      return Object.assign({}, state, {
        isReceivesFetching: false
      });

    case _dashboard.FETCH_DASHBOARD_DETAILS_FAILED:
      return Object.assign({}, state, {
        isDetailsFetching: false
      });

    case _dashboard.FETCH_DASHBOARD_SUMMARY_COMPLETED:
      return Object.assign({}, state, {
        isSummaryFetching: false,
        summary: action.results.summary
      });

    case _dashboard.FETCH_DASHBOARD_POSTS_COMPLETED:
      return Object.assign({}, state, {
        isPostsFetching: false,
        posts: action.results.members
      });

    case _dashboard.FETCH_DASHBOARD_REPLIES_COMPLETED:
      return Object.assign({}, state, {
        isRepliesFetching: false,
        replies: action.results.members
      });

    case _dashboard.FETCH_DASHBOARD_RECEIVES_COMPLETED:
      return Object.assign({}, state, {
        isReceivesFetching: false,
        receives: action.results.members
      });

    case _dashboard.FETCH_DASHBOARD_DETAILS_COMPLETED:
      return Object.assign({}, state, {
        isDetailsFetching: false,
        details: action.results
      });

    case _dashboard.CLEAR_DASHBOARD_DATA:
      return initialState;

    case _dashboard.CLEAR_DASHBOARD_DETAILS:
      return Object.assign({}, state, {
        isDetailsFetching: false,
        details: undefined
      });

    default:
      return state;
  }
}

/***/ }),
/* 2885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = submissionSchedulesReducer;

var _submissionSchedules = __webpack_require__(851);

var initialState = {
  isSaving: false,
  isSaveFailed: false
};
// src/reducers/submission-schedules-reducer.js

function submissionSchedulesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _submissionSchedules.SAVE_SUBMISSION_SCHEDULES_REQUESTED:
      return Object.assign({}, state, {
        isSaving: true,
        isSaveFailed: false
      });

    case _submissionSchedules.SAVE_SUBMISSION_SCHEDULES_COMPLETED:
      return Object.assign({}, state, {
        isSaving: false,
        isSaveFailed: false,
        schedules: action.results
      });

    case _submissionSchedules.SAVE_SUBMISSION_SCHEDULES_FAILED:
      return Object.assign({}, state, {
        isSaving: false,
        isSaveFailed: true
      });

    default:
      return state;
  }
}

/***/ }),
/* 2886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reportReducer;

var _report = __webpack_require__(852);

var initialState = {
  isRequesting: false
};
// src/reducers/report-reducer.js

function reportReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {

    case _report.POST_USER_REPORT_REQUESTED:
    case _report.POST_CONTENT_REPORT_REQUESTED:
      return Object.assign({}, state, {
        isPosting: true,
        isPostFailed: false
      });

    case _report.POST_USER_REPORT_FAILED:
    case _report.POST_CONTENT_REPORT_FAILED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: true
      });

    case _report.POST_USER_REPORT_COMPLETED:
    case _report.POST_CONTENT_REPORT_COMPLETED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: true
      });

    default:
      return state;
  }
}

/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = diaryReportReducer;

var _diaryReport = __webpack_require__(467);

var _store = __webpack_require__(18);

// src/reducers/report-reducer.js

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  isPosting: false,
  isPostFailed: false,
  isWeeklyReport: false,
  isMonthlyReport: false,
  weeklyReportStartDate: undefined,
  monthlyReportStartDate: undefined,
  inputDiaryUserCount: undefined
};

function diaryReportReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _diaryReport.FETCH_DIARY_REPORT_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });
    case _diaryReport.FETCH_DIARY_REPORT_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });

    case _diaryReport.FETCH_DIARY_REPORT_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        isWeeklyReport: action.results.is_weekly_report,
        isMonthlyReport: action.results.is_monthly_report,
        weeklyReportStartDate: action.results.weekly_report_start_date,
        monthlyReportStartDate: action.results.monthly_report_start_date,
        inputDiaryUserCount: action.results.input_diary_user_count
      });

    case _diaryReport.POST_DIARY_REPORT_REQUESTED:
      return Object.assign({}, state, {
        isPosting: true,
        isPostFailed: false
      });

    case _diaryReport.POST_DIARY_REPORT_FAILED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: true
      });

    case _diaryReport.POST_DIARY_REPORT_COMPLETED:
      return Object.assign({}, state, {
        isPosting: false,
        isPostFailed: true,
        isWeeklyReport: action.results.is_weekly_report,
        isMonthlyReport: action.results.is_monthly_report,
        weeklyReportStartDate: action.results.weekly_report_start_date,
        monthlyReportStartDate: action.results.monthly_report_start_date,
        inputDiaryUserCount: action.results.input_diary_user_count
      });

    default:
      return state;
  }
}

/***/ }),
/* 2888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = divisionsReducer;

var _store = __webpack_require__(18);

var _map = __webpack_require__(43);

var _map2 = _interopRequireDefault(_map);

var _find = __webpack_require__(33);

var _find2 = _interopRequireDefault(_find);

var _isEqual = __webpack_require__(226);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _divisions = __webpack_require__(468);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  items: undefined,
  currentId: undefined,
  currentDivision: undefined,
  activeDialog: false,
  isMembershipUpdating: false,
  isMembershipUpdateFailed: false
};
// src/reducers/divisions-reducer.js

function divisionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _divisions.FETCH_DIVISIONS_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });

    case _divisions.FETCH_DIVISIONS_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: false,
        items: !state.items ? action.results : (0, _map2.default)(action.results, function (result) {
          var division = (0, _find2.default)(state.items, function (item) {
            return item.division_id == result.division_id;
          });
          if (!division) return result; // new devision
          else if ((0, _isEqual2.default)(division, result)) return division; // dont update same division
            else return Object.assign({}, division, result); // devision content change
        })
      });

    case _divisions.UPDATE_DIVISION_COMPLETED:
      return Object.assign({}, state, {
        items: (0, _store.mergeArray)('division_id', state.items, [action.results])
      });

    case _divisions.FETCH_DIVISIONS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });
    case _divisions.SET_CURRENT_ID:
      return Object.assign({}, state, {
        currentId: action.currentId
      });
    case _divisions.SET_CURRENT_DIVISION:
      return Object.assign({}, state, {
        currentId: action.currentDivision
      });
    case _divisions.UPDATE_DIVISION_GROUP_REQUESTED:
    case _divisions.DELETE_DIVISION_REQUESTED:
      return Object.assign({}, state, {
        isMembershipUpdating: true,
        isMembershipUpdateFailed: false
      });
    case _divisions.UPDATE_DIVISION_GROUP_FAILED:
    case _divisions.DELETE_DIVISION_FAILED:
      return Object.assign({}, state, {
        isMembershipUpdating: false,
        isMembershipUpdateFailed: true
      });
    case _divisions.UPDATE_DIVISION_GROUP_COMPLETED:
      return Object.assign({}, state, {
        isMembershipUpdating: false,
        isMembershipUpdateFailed: false,
        items: (0, _store.mergeArray)('division_id', state.items, [action.results])
      });

    case _divisions.DELETE_DIVISION_COMPLETED:
      return Object.assign({}, state, {
        isRequesting: false,
        isRequestFailed: false,
        items: (0, _store.deleteArray)('division_id', state.items, action.results.division_id)
      });

    default:
      return state;
  }
}

/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = divisionSettingsReducer;

var _store = __webpack_require__(18);

var _divisionSettings = __webpack_require__(856);

// src/reducers/divisions-settings-reducer.js
var initialState = {
  name: undefined,
  active: false,
  isRequesting: false,
  isRequestFailed: false,
  isUpdating: false,
  isUpdateFailed: false,
  division: undefined
};

function divisionSettingsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _divisionSettings.OPEN_DIVISION_SETTINGS_PAGE:
      return Object.assign({}, state, {
        name: action.name,
        active: true
      });
      break;

    case _divisionSettings.CLOSE_DIVISION_SETTINGS_PAGE:
      return Object.assign({}, state, {
        name: undefined,
        active: false
      });
      break;

    case _divisionSettings.UPDATE_DIVISION_COMPLETED:
      return Object.assign({}, state, {
        isUpdating: false,
        isUpdateFailed: false,
        division: action.results,
        name: action.results.name
      });
      break;

    case _divisionSettings.UPDATE_DIVISION_REQUESTED:
    case _divisionSettings.CREATE_DIVISION_REQUESTED:
      return Object.assign({}, state, {
        isUpdating: true
      });
      break;

    default:

      return state;
  }
}

/***/ }),
/* 2890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = divisionSettingsReducer;

var _divisionsGroupManager = __webpack_require__(857);

var initialState = {
  isFetchedGroup: false,
  groupSort: 'desc',
  divisionGroups: []
};
// src/reducers/divisions-settings-reducer.js

function divisionSettingsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {

    case _divisionsGroupManager.FETCH_DIVISION_GROUP_COMPLETED:
      return Object.assign({}, state, {
        divisionGroups: action.results
      });

    default:

      return state;
  }
}

/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = menusReducer;

var _menus = __webpack_require__(858);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
// src/reducers/menus-reducer.js

var initialState = {
  items: [],
  flashNewFreeGroupId: undefined,
  sortingMenu: undefined,
  expandedDivisions: [],
  expandedDivisionSort: [],
  canExpandDivNotSetGroup: false,
  canExpandDivSortNotSetGroup: false
};
var MaxItemPerMenu = 100;

function menusReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _menus.INIT_MENU:
      var divisionsMenu = [].concat(_toConsumableArray(action.results)).filter(function (item) {
        return item.type === 'division';
      });
      return Object.assign({}, state, {
        items: action.results.sort(function (item1, item2) {
          return item1.position - item2.position;
        }),
        canExpandDivNotSetGroup: state.canExpandDivNotSetGroup || divisionsMenu.length === 0,
        canExpandDivSortNotSetGroup: state.canExpandDivSortNotSetGroup || divisionsMenu.length === 0,
        expandedDivisions: divisionsMenu.length === 1 ? [divisionsMenu[0].item_id] : state.expandedDivisions,
        expandedDivisionSort: divisionsMenu.length === 1 ? [divisionsMenu[0].item_id] : state.expandedDivisionSort
      });
    case _menus.SORT_MENU:
      {
        var _action$results = action.results,
            oldPosition = _action$results.oldPosition,
            newPosition = _action$results.newPosition;

        var fromMenu = state.items.find(function (item) {
          return item.position == oldPosition;
        });
        var toMenu = state.items.find(function (item) {
          return item.position == newPosition;
        });
        if (!fromMenu || !toMenu || fromMenu.type != toMenu.type) return Object.assign({}, state, {
          items: [].concat(_toConsumableArray(state.items))
        });
        if (fromMenu.type == 'group' && Math.floor(newPosition / MaxItemPerMenu) != Math.floor(oldPosition / MaxItemPerMenu)) return Object.assign({}, state, {
          items: [].concat(_toConsumableArray(state.items))
        });

        var newItems = [].concat(_toConsumableArray(state.items)).filter(function (item) {
          return item.position != oldPosition;
        });
        var updatedPosition = newPosition < oldPosition ? newPosition - 0.5 : newPosition + 0.5;
        newItems.push(_extends({}, fromMenu, { position: updatedPosition }));
        newItems.sort(function (item1, item2) {
          return item1.position - item2.position;
        });
        (0, _menus.applyMenuPosition)(newItems);
        return Object.assign({}, state, {
          items: newItems
        });
      }

    case _menus.SET_FREE_MENU:
      {
        var position = action.results.position;

        var _fromMenu = state.items.find(function (item) {
          return item.position == position;
        });
        var _newItems = [].concat(_toConsumableArray(state.items)).filter(function (item) {
          return item.type != 'group' || item.item_id != _fromMenu.item_id;
        });
        var _newPosition = Math.floor(position / MaxItemPerMenu) * MaxItemPerMenu - 1;
        _newItems.push(_extends({}, _fromMenu, { is_free: true, position: _newPosition, parent_id: null }));
        _newItems.sort(function (item1, item2) {
          return item1.position - item2.position;
        });
        (0, _menus.applyMenuPosition)(_newItems);
        return Object.assign({}, state, {
          items: _newItems
        });
      }

    case _menus.SET_NOT_FREE_MENU:
      {
        var _action$results2 = action.results,
            _position = _action$results2.position,
            groupDivisionIds = _action$results2.groupDivisionIds;

        var _fromMenu2 = state.items.find(function (item) {
          return item.position == _position;
        });
        var _newItems2 = [].concat(_toConsumableArray(state.items)).filter(function (item) {
          return item.type != 'group' || item.item_id != _fromMenu2.item_id;
        });
        groupDivisionIds.forEach(function (division_id) {
          var sameParentItems = _newItems2.filter(function (item) {
            return item.parent_id == division_id;
          });
          var parentItem = _newItems2.find(function (item) {
            return item.item_id == division_id;
          });
          var newPosition = sameParentItems.length > 0 ? sameParentItems.slice(-1)[0].position + 1 : parentItem.position + 1;
          _newItems2.push(_extends({}, _fromMenu2, { is_free: false, position: newPosition, parent_id: division_id }));
        });
        return Object.assign({}, state, {
          items: _newItems2.sort(function (item1, item2) {
            return item1.position - item2.position;
          })
        });
      }
    case _menus.SET_FLASH_NEW_FREE_GROUP_ID:
      return Object.assign({}, state, {
        flashNewFreeGroupId: action.results
      });
    case _menus.EXPAND_DIVISION:
      var expandedDivisions = [].concat(_toConsumableArray(state.expandedDivisions));
      expandedDivisions.push(action.results);
      return Object.assign({}, state, {
        expandedDivisions: expandedDivisions
      });
    case _menus.EXPAND_DIVISION_SORT:
      var expandedDivisionSort = [].concat(_toConsumableArray(state.expandedDivisionSort));
      expandedDivisionSort.push(action.results);
      return Object.assign({}, state, {
        expandedDivisionSort: expandedDivisionSort
      });
    case _menus.EXPAND_DIVISION_NOT_SET_GROUP:
      return Object.assign({}, state, {
        canExpandDivNotSetGroup: !state.canExpandDivNotSetGroup
      });
    case _menus.EXPAND_DIVISION_SORT_NOT_SET_GROUP:
      return Object.assign({}, state, {
        canExpandDivSortNotSetGroup: !state.canExpandDivSortNotSetGroup
      });
    case _menus.COLLAPSE_DIVISION:
      return Object.assign({}, state, {
        expandedDivisions: state.expandedDivisions.filter(function (division_id) {
          return division_id != action.results;
        })
      });
    case _menus.COLLAPSE_DIVISION_SORT:
      return Object.assign({}, state, {
        expandedDivisionSort: state.expandedDivisionSort.filter(function (division_id) {
          return division_id != action.results;
        })
      });
    case _menus.SET_SORTING_MENU_POSITION:
      {
        var _position2 = action.results;
        var menu = state.items.find(function (item) {
          return item.position == _position2;
        });
        return Object.assign({}, state, {
          sortingMenu: menu
        });
      }

    default:
      return state;
  }
}

/***/ }),
/* 2892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lambdaApiReducer;

var _store = __webpack_require__(18);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _review = __webpack_require__(859);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
// src/reducers/lambda-api-reducer.js

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  stream: ['<strong>', '💡AIに日報のレビューを依頼できます。</strong>'],
  isOpenReviewPanel: false
};

function lambdaApiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {

    case _review.FETCH_REVIEW_REQUESTED:
      return Object.assign({}, state, {
        isOpenReviewPanel: true,
        isFetching: true,
        isFetchFailed: false,
        stream: []
      });

    case _review.FETCH_REVIEW_STREAMING:
      return Object.assign({}, state, {
        isOpenReviewPanel: true,
        isFetching: true,
        isFetchFailed: false,
        stream: [].concat(_toConsumableArray(state.stream), [action.results]),
        type: undefined
      });

    case _review.FETCH_REVIEW_FAILED:
      return Object.assign({}, state, {
        isOpenReviewPanel: true,
        isFetching: false,
        isFetchFailed: true,
        stream: ['エラーが発生しました。もう一度お試しください。']
      });

    case _review.FETCH_REVIEW_COMPLETED:
      return Object.assign({}, state, {
        isOpenReviewPanel: true,
        isFetching: false,
        isFetchFailed: false,
        isCompleted: true
      });

    case _review.OPEN_REVIEW_PANEL:
      return Object.assign({}, state, {
        isOpenReviewPanel: true,
        stream: ['<strong>', '💡日報を書いてAIにレビューを依頼できます。</strong>']
      });
    case _review.CLOSE_REVIEW_PANEL:
      return Object.assign({}, state, {
        isOpenReviewPanel: false,
        isCompleted: false,
        stream: ['<strong>', '💡日報を書いてAIにレビューを依頼できます。</strong>']
      });
    case _review.CLEAR_REVIEW:
      return {
        isOpenReviewPanel: true,
        stream: []
      };
    case _review.INITIALIZE_REVIEW:
    default:
      return state;
  }
}

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reviewSettingReducer;

var _store = __webpack_require__(18);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _reviewSetting = __webpack_require__(860);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/reducers/lambda-api-reducer.js

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  isEnable: true
};

function reviewSettingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {

    case _reviewSetting.FETCH_REVIEW_SETTING_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });
    case _reviewSetting.FETCH_REVIEW_SETTING_COMPLETED:
      return Object.assign({}, state, action.results, {
        isFetching: false,
        isFetchFailed: false,
        isEnable: action.results.ai_review
      });
    case _reviewSetting.FETCH_REVIEW_SETTING_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });
    case _reviewSetting.UPDATE_REVIEW_SETTING_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });
    case _reviewSetting.UPDATE_REVIEW_SETTING_COMPLETED:
      return Object.assign({}, state, action.results, {
        isFetching: false,
        isFetchFailed: false,
        isEnable: action.results.isEnable
      });
    case _reviewSetting.UPDATE_REVIEW_SETTING_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });
    default:
      return state;
  }
}

/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reactChatReducer;

var _store = __webpack_require__(18);

var _reduce = __webpack_require__(160);

var _reduce2 = _interopRequireDefault(_reduce);

var _reactChat = __webpack_require__(462);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  isFetching: false
};
// src/reducers/react-chat-reducer.js

function reactChatReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _reactChat.REACT_CHAT_REQUESTED:
    case _reactChat.DELETE_LIKE_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _reactChat.REACT_CHAT_FAILED:
    case _reactChat.DELETE_LIKE_FAILED:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _reactChat.REACT_CHAT_COMPLETED:
    case _reactChat.DELETE_LIKE_COMPLETED:
      return Object.assign({}, state, {
        isFetching: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = showTimeStampSettingReducer;

var _store = __webpack_require__(18);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _showTimestampeSetting = __webpack_require__(861);

var _actions = __webpack_require__(9);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// src/reducers/show-timestampe-setting-reducer.js

var initialState = {
  isFetching: false,
  isFetchFailed: false,
  isEnable: true
};

function showTimeStampSettingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {

    case _showTimestampeSetting.FETCH_SHOW_TIMESTAMP_SETTING_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        isFetchFailed: false
      });
    case _showTimestampeSetting.FETCH_SHOW_TIMESTAMP_SETTING_COMPLETED:
      return Object.assign({}, state, action.results, {
        isFetching: false,
        isFetchFailed: false,
        isEnable: action.results.show_timestamp
      });
    case _showTimestampeSetting.FETCH_SHOW_TIMESTAMP_SETTING_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchFailed: true
      });
    default:
      return state;
  }
}

/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2897);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js?importLoaders=1!../postcss-loader/lib/index.js!./index.css", function() {
			var newContent = require("!!../css-loader/index.js?importLoaders=1!../postcss-loader/lib/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, ".smartbanner-show {\r\n\tmargin-top: 80px;\r\n}\r\n\r\n.smartbanner-show .smartbanner {\r\n\tdisplay: block;\r\n}\r\n\r\n/** Default **/\r\n\r\n.smartbanner {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tdisplay: none;\r\n\twidth: 100%;\r\n\theight: 80px;\r\n\tline-height: 80px;\r\n\tfont-family: 'Helvetica Neue', sans-serif;\r\n\tbackground: #f4f4f4;\r\n\tz-index: 9998;\r\n\t-webkit-font-smoothing: antialiased;\r\n\toverflow: hidden;\r\n\t-webkit-text-size-adjust: none;\r\n}\r\n\r\n.smartbanner-container {\r\n\tmargin: 0 auto;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.smartbanner-close {\r\n\tdisplay: inline-block;\r\n\tvertical-align: middle;\r\n\tmargin: 0 5px 0 5px;\r\n\tfont-family: 'ArialRoundedMTBold', Arial;\r\n\tfont-size: 20px;\r\n\ttext-align: center;\r\n\tcolor: #888;\r\n\ttext-decoration: none;\r\n\tborder: 0;\r\n\tborder-radius: 14px;\r\n\t-webkit-font-smoothing: subpixel-antialiased;\r\n}\r\n\r\n.smartbanner-close:active,\r\n.smartbanner-close:hover {\r\n\tcolor: #aaa;\r\n}\r\n\r\n.smartbanner-icon {\r\n\tdisplay: inline-block;\r\n\tvertical-align: middle;\r\n\twidth: 57px;\r\n\theight: 57px;\r\n\tmargin-right: 12px;\r\n\tbackground-size: cover;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.smartbanner-info {\r\n\tdisplay: inline-block;\r\n\tvertical-align: middle;\r\n\twidth: 44%;\r\n\tfont-size: 11px;\r\n\tline-height: 1.2em;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.smartbanner-title {\r\n\tfont-size: 13px;\r\n\tline-height: 18px;\r\n}\r\n\r\n.smartbanner-button {\r\n\tposition: absolute;\r\n\tright: 20px;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tmargin: auto 0;\r\n\theight: 24px;\r\n\tfont-size: 14px;\r\n\tline-height: 24px;\r\n\ttext-align: center;\r\n\tfont-weight: bold;\r\n\tcolor: #6a6a6a;\r\n\ttext-transform: uppercase;\r\n\ttext-decoration: none;\r\n\ttext-shadow: 0 1px 0 rgba(255, 255, 255, .8);\r\n}\r\n\r\n.smartbanner-button:active,\r\n.smartbanner-button:hover {\r\n\tcolor: #aaa;\r\n}\r\n\r\n.smartbanner-button-text {\r\n}\r\n\r\n.smartbanner-button-text:active,\r\n.smartbanner-button-text:hover {\r\n}\r\n\r\n/** iOS **/\r\n\r\n.smartbanner-ios {\r\n\tbackground: #f4f4f4;\r\n\tbackground: linear-gradient(to bottom, #f4f4f4, #cdcdcd);\r\n\tbox-shadow: 0 1px 2px rgba(0, 0, 0, .5);\r\n\tline-height: 80px;\r\n}\r\n\r\n.smartbanner-ios .smartbanner-close {\r\n\tborder: 0;\r\n\twidth: 18px;\r\n\theight: 18px;\r\n\tline-height: 18px;\r\n\tcolor: #888;\r\n\ttext-shadow: 0 1px 0 white;\r\n}\r\n\r\n.smartbanner-ios .smartbanner-close:active,\r\n.smartbanner-ios .smartbanner-close:hover {\r\n\tcolor: #aaa;\r\n}\r\n\r\n.smartbanner-ios .smartbanner-icon {\r\n\tbackground: rgba(0, 0, 0, .6);\r\n\tbackground-size: cover;\r\n\tbox-shadow: 0 1px 3px rgba(0, 0, 0, .3);\r\n}\r\n\r\n.smartbanner-ios .smartbanner-info {\r\n\tcolor: #6a6a6a;\r\n\ttext-shadow: 0 1px 0 rgba(255, 255, 255, .8);\r\n}\r\n\r\n.smartbanner-ios .smartbanner-title {\r\n\tcolor: #4d4d4d;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.smartbanner-ios .smartbanner-button {\r\n\tpadding: 0 10px;\r\n\tmin-width: 10%;\r\n\tcolor: #6a6a6a;\r\n\tbackground: #efefef;\r\n\tbackground: linear-gradient(to bottom, #efefef, #dcdcdc);\r\n\tborder-radius: 3px;\r\n\tbox-shadow: inset 0 0 0 1px #bfbfbf, 0 1px 0 rgba(255, 255, 255, .6), 0 2px 0 rgba(255, 255, 255, .7) inset;\r\n}\r\n\r\n.smartbanner-ios .smartbanner-button:active,\r\n.smartbanner-ios .smartbanner-button:hover {\r\n\tbackground: #dcdcdc;\r\n\tbackground: linear-gradient(to bottom, #dcdcdc, #efefef);\r\n}\r\n\r\n.smartbanner-ios .smartbanner-button-text {\r\n}\r\n\r\n.smartbanner-ios .smartbanner-button-text:active,\r\n.smartbanner-ios .smartbanner-button-text:hover {\r\n}\r\n\r\n/** Android **/\r\n\r\n.smartbanner-android {\r\n\tbackground: #3d3d3d url(data:image/gif;base64,R0lGODlhCAAIAIABAFVVVf///yH5BAEHAAEALAAAAAAIAAgAAAINRG4XudroGJBRsYcxKAA7);\r\n\tbox-shadow: inset 0 4px 0 #88b131;\r\n\tline-height: 82px;\r\n}\r\n\r\n.smartbanner-android .smartbanner-close {\r\n\tborder: 0;\r\n\twidth: 17px;\r\n\theight: 17px;\r\n\tline-height: 17px;\r\n\tmargin-right: 7px;\r\n\tcolor: #b1b1b3;\r\n\tbackground: #1c1e21;\r\n\ttext-shadow: 0 1px 1px #000;\r\n\tbox-shadow: 0 1px 2px rgba(0, 0, 0, .8) inset, 0 1px 1px rgba(255, 255, 255, .3);\r\n}\r\n\r\n.smartbanner-android .smartbanner-close:active,\r\n.smartbanner-android .smartbanner-close:hover {\r\n\tcolor: #eee;\r\n}\r\n\r\n.smartbanner-android .smartbanner-icon {\r\n\tbackground-color: transparent;\r\n\tbox-shadow: none;\r\n}\r\n\r\n.smartbanner-android .smartbanner-info {\r\n\tcolor: #ccc;\r\n\ttext-shadow: 0 1px 2px #000;\r\n}\r\n\r\n.smartbanner-android .smartbanner-title {\r\n\tcolor: #fff;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.smartbanner-android .smartbanner-button {\r\n\tmin-width: 12%;\r\n\tcolor: #d1d1d1;\r\n\tpadding: 0;\r\n\tbackground: none;\r\n\tborder-radius: 0;\r\n\tbox-shadow: 0 0 0 1px #333, 0 0 0 2px #dddcdc;\r\n}\r\n\r\n.smartbanner-android .smartbanner-button:active,\r\n.smartbanner-android .smartbanner-button:hover {\r\n\tbackground: none;\r\n}\r\n\r\n.smartbanner-android .smartbanner-button-text {\r\n\ttext-align: center;\r\n\tdisplay: block;\r\n\tpadding: 0 10px;\r\n\tbackground: #42b6c9;\r\n\tbackground: linear-gradient(to bottom, #42b6c9, #39a9bb);\r\n\ttext-transform: none;\r\n\ttext-shadow: none;\r\n\tbox-shadow: none;\r\n}\r\n\r\n.smartbanner-android .smartbanner-button-text:active,\r\n.smartbanner-android .smartbanner-button-text:hover {\r\n\tbackground: #2ac7e1;\r\n}\r\n\r\n/** Windows **/\r\n\r\n.smartbanner-windows {\r\n\tbackground: #f4f4f4;\r\n\tbackground: linear-gradient(to bottom, #f4f4f4, #cdcdcd);\r\n\tbox-shadow: 0 1px 2px rgba(0, 0, 0, .5);\r\n\tline-height: 80px;\r\n}\r\n\r\n.smartbanner-windows .smartbanner-close {\r\n\tborder: 0;\r\n\twidth: 18px;\r\n\theight: 18px;\r\n\tline-height: 18px;\r\n\tcolor: #888;\r\n\ttext-shadow: 0 1px 0 white;\r\n}\r\n\r\n.smartbanner-windows .smartbanner-close:active,\r\n.smartbanner-windows .smartbanner-close:hover {\r\n\tcolor: #aaa;\r\n}\r\n\r\n.smartbanner-windows .smartbanner-icon {\r\n\tbackground: rgba(0, 0, 0, .6);\r\n\tbackground-size: cover;\r\n\tbox-shadow: 0 1px 3px rgba(0, 0, 0, .3);\r\n}\r\n\r\n.smartbanner-windows .smartbanner-info {\r\n\tcolor: #6a6a6a;\r\n\ttext-shadow: 0 1px 0 rgba(255, 255, 255, .8);\r\n}\r\n\r\n.smartbanner-windows .smartbanner-title {\r\n\tcolor: #4d4d4d;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.smartbanner-windows .smartbanner-button {\r\n\tpadding: 0 10px;\r\n\tmin-width: 10%;\r\n\tcolor: #6a6a6a;\r\n\tbackground: #efefef;\r\n\tbackground: linear-gradient(to bottom, #efefef, #dcdcdc);\r\n\tborder-radius: 3px;\r\n\tbox-shadow: inset 0 0 0 1px #bfbfbf, 0 1px 0 rgba(255, 255, 255, .6), 0 2px 0 rgba(255, 255, 255, .7) inset;\r\n}\r\n\r\n.smartbanner-windows .smartbanner-button:active,\r\n.smartbanner-windows .smartbanner-button:hover {\r\n\tbackground: #dcdcdc;\r\n\tbackground: linear-gradient(to bottom, #dcdcdc, #efefef);\r\n}\r\n\r\n.smartbanner-windows .smartbanner-button-text {\r\n}\r\n\r\n.smartbanner-windows .smartbanner-button-text:active,\r\n.smartbanner-windows .smartbanner-button-text:hover {\r\n}\r\n", ""]);

// exports


/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extend = __webpack_require__(80);
var q = __webpack_require__(2899);
var doc = __webpack_require__(2900);
var cookie = __webpack_require__(2902);
var ua = __webpack_require__(1140);

// IE < 11 doesn't support navigator language property.
/* global navigator */
var userLangAttribute = navigator.language || navigator.userLanguage || navigator.browserLanguage;
var userLang = userLangAttribute.slice(-2) || 'us';
var root = doc && doc.documentElement;

// platform dependent functionality
var mixins = {
	ios: {
		appMeta: 'apple-itunes-app',
		iconRels: ['apple-touch-icon-precomposed', 'apple-touch-icon'],
		getStoreLink: function () {
			return 'https://itunes.apple.com/' + this.options.appStoreLanguage + '/app/id' + this.appId + "?mt=8";
		}
	},
	android: {
		appMeta: 'google-play-app',
		iconRels: ['android-touch-icon', 'apple-touch-icon-precomposed', 'apple-touch-icon'],
		getStoreLink: function () {
			return 'http://play.google.com/store/apps/details?id=' + this.appId;
		}
	},
	windows: {
		appMeta: 'msApplication-ID',
		iconRels: ['windows-touch-icon', 'apple-touch-icon-precomposed', 'apple-touch-icon'],
		getStoreLink: function () {
			return 'http://www.windowsphone.com/s?appid=' + this.appId;
		}
	}
};

var SmartBanner = function (options) {
	var agent = ua(navigator.userAgent);
	this.options = extend({}, {
		daysHidden: 15,
		daysReminder: 90,
		appStoreLanguage: userLang, // Language code for App Store
		button: 'OPEN', // Text for the install button
		store: {
			ios: 'On the App Store',
			android: 'In Google Play',
			windows: 'In the Windows Store'
		},
		price: {
			ios: 'FREE',
			android: 'FREE',
			windows: 'FREE'
		},
		theme: '', // put platform type ('ios', 'android', etc.) here to force single theme on all device
		icon: '', // full path to icon image if not using website icon image
		force: '', // put platform type ('ios', 'android', etc.) here for emulation

	}, options || {});

	if (this.options.force) {
		this.type = this.options.force;
	} else if (agent.os.name === 'Windows Phone' || agent.os.name === 'Windows Mobile') {
		this.type = 'windows';
	} else if (agent.os.name === 'iOS') {
		this.type = 'ios';
	} else if (agent.os.name === 'Android') {
		this.type = 'android';
	}

	// Don't show banner on ANY of the following conditions:
	// - device os is not supported,
	// - user is on mobile safari for ios 6 or greater (iOS >= 6 has native support for SmartAppBanner)
	// - running on standalone mode
	// - user dismissed banner
	var unsupported = !this.type || !this.options.store[this.type];
	if (unsupported) {
		return;
	}

	this.appMeta = mixins[this.type].appMeta;
	this.parseAppId();

	var isMobileSafari = (this.type === 'ios' && agent.browser.name === 'Mobile Safari' && parseInt(agent.os.version, 10) >= 6);

	var runningStandAlone = navigator.standalone;
	var userDismissed = cookie.get(this.appId + '-smartbanner-closed');
	var userInstalled = cookie.get(this.appId + '-smartbanner-installed');

	if (isMobileSafari || runningStandAlone || userDismissed || userInstalled) {
		return;
	}

	extend(this, mixins[this.type]);

	// - If we dont have app id in meta, dont display the banner
	// - If opened in safari IOS, dont display the banner
	if (!this.appId && agent.os.name === 'IOS' && agent.browser.name === 'Safari') {
		return;
	}

	this.create();
	this.show();
};

SmartBanner.prototype = {
	constructor: SmartBanner,

	create: function () {
		var link = this.getStoreLink();
		var inStore = this.options.price[this.type] + ' - ' + this.options.store[this.type];
		var icon;

		if (this.options.icon) {
			icon = this.options.icon;
		} else {
			for (var i = 0; i < this.iconRels.length; i++) {
				var rel = q('link[rel="' + this.iconRels[i] + '"]');

				if (rel) {
					icon = rel.getAttribute('href');
					break;
				}
			}
		}

		var sb = doc.createElement('div');
		var theme = this.options.theme || this.type;

		sb.className = 'smartbanner smartbanner-' + theme;
		sb.innerHTML = '<div class="smartbanner-container">' +
							'<a href="javascript:void(0);" class="smartbanner-close">&times;</a>' +
							'<span class="smartbanner-icon" style="background-image: url(' + icon + ')"></span>' +
							'<div class="smartbanner-info">' +
								'<div class="smartbanner-title">' + this.options.title + '</div>' +
								'<div>' + this.options.author + '</div>' +
								'<span>' + inStore + '</span>' +
							'</div>' +
							'<a href="' + link + '" class="smartbanner-button">' +
								'<span class="smartbanner-button-text">' + this.options.button + '</span>' +
							'</a>' +
						'</div>';

		// there isn’t neccessary a body
		if (doc.body) {
			doc.body.appendChild(sb);
		}		else if (doc) {
			doc.addEventListener('DOMContentLoaded', function () {
				doc.body.appendChild(sb);
			});
		}

		q('.smartbanner-button', sb).addEventListener('click', this.install.bind(this), false);
		q('.smartbanner-close', sb).addEventListener('click', this.close.bind(this), false);
	},
	hide: function () {
		root.classList.remove('smartbanner-show');

		if (typeof this.options.close === 'function') {
			return this.options.close();
		}
	},
	show: function () {
		root.classList.add('smartbanner-show');
		if (typeof this.options.show === 'function') {
			return this.options.show();
		}
	},
	close: function () {
		this.hide();
		cookie.set(this.appId + '-smartbanner-closed', 'true', {
			path: '/',
			expires: new Date(Number(new Date()) + (this.options.daysHidden * 1000 * 60 * 60 * 24))
		});
		if (typeof this.options.close === 'function') {
			return this.options.close();
		}
	},
	install: function () {
		this.hide();
		cookie.set(this.appId + '-smartbanner-installed', 'true', {
			path: '/',
			expires: new Date(Number(new Date()) + (this.options.daysReminder * 1000 * 60 * 60 * 24))
		});
		if (typeof this.options.close === 'function') {
			return this.options.close();
		}
	},
	parseAppId: function () {
		var meta = q('meta[name="' + this.appMeta + '"]');
		if (!meta) {
			return;
		}

		if (this.type === 'windows') {
			this.appId = meta.getAttribute('content');
		} else {
			this.appId = /app-id=([^\s,]+)/.exec(meta.getAttribute('content'))[1];
		}

		return this.appId;
	}
};

module.exports = SmartBanner;


/***/ }),
/* 2899 */
/***/ (function(module, exports) {

function one(selector, el) {
  return el.querySelector(selector);
}

exports = module.exports = function(selector, el){
  el = el || document;
  return one(selector, el);
};

exports.all = function(selector, el){
  el = el || document;
  return el.querySelectorAll(selector);
};

exports.engine = function(obj){
  if (!obj.one) throw new Error('.one callback required');
  if (!obj.all) throw new Error('.all callback required');
  one = obj.one;
  exports.all = obj.all;
  return exports;
};


/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @module  get-doc
 */

var hasDom = __webpack_require__(2901);

module.exports = hasDom() ? document : null;

/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function () {
	return typeof window !== 'undefined'
		&& typeof document !== 'undefined'
		&& typeof document.createElement === 'function';
};


/***/ }),
/* 2902 */
/***/ (function(module, exports) {

var exports = module.exports = function (doc) {
    if (!doc) doc = {};
    if (typeof doc === 'string') doc = { cookie: doc };
    if (doc.cookie === undefined) doc.cookie = '';
    
    var self = {};
    self.get = function (key) {
        var splat = doc.cookie.split(/;\s*/);
        for (var i = 0; i < splat.length; i++) {
            var ps = splat[i].split('=');
            var k = unescape(ps[0]);
            if (k === key) return unescape(ps[1]);
        }
        return undefined;
    };
    
    self.set = function (key, value, opts) {
        if (!opts) opts = {};
        var s = escape(key) + '=' + escape(value);
        if (opts.expires) s += '; expires=' + opts.expires;
        if (opts.path) s += '; path=' + escape(opts.path);
        if (opts.domain) s += '; domain=' + escape(opts.domain);
        if (opts.secure) s += '; secure';
        doc.cookie = s;
        return s;
    };
    return self;
};

if (typeof document !== 'undefined') {
    var cookie = exports(document);
    exports.get = cookie.get;
    exports.set = cookie.set;
}


/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

var UserAgentParser = __webpack_require__(1140)
var languageMessages = __webpack_require__(2904)
var deepExtend = __webpack_require__(2905)

var DEFAULTS = {
	Chrome: 57, // Includes Chrome for mobile devices
	Edge: 39,
	Safari: 10,
	"Mobile Safari": 10,
	Opera: 50,
	Firefox: 50,
	Vivaldi: 1,
	IE: false
}

var EDGEHTML_VS_EDGE_VERSIONS = {
	12: 0.1,
	13: 21,
	14: 31,
	15: 39,
	16: 41,
	17: 42,
	18: 44
}

var COLORS = {
	salmon: "#f25648",
	white: "white"
}

var updateDefaults = function(defaults, updatedValues) {
	for (var key in updatedValues) {
		defaults[key] = updatedValues[key]
	}

	return defaults
}

module.exports = function(options) {
	var main = function() {
		// Despite the docs, UA needs to be provided to constructor explicitly:
		// https://github.com/faisalman/ua-parser-js/issues/90
		var parsedUserAgent = new UserAgentParser(window.navigator.userAgent).getResult()

		// Variable definition (before ajax)
		var outdatedUI = document.getElementById("outdated")

		options = options || {}

		var browserLocale = window.navigator.language || window.navigator.userLanguage // Everyone else, IE

		// Set default options
		var browserSupport = options.browserSupport ? updateDefaults(DEFAULTS, options.browserSupport) : DEFAULTS
		// CSS property to check for. You may also like 'borderSpacing', 'boxShadow', 'transform', 'borderImage';
		var requiredCssProperty = options.requiredCssProperty || false
		var backgroundColor = options.backgroundColor || COLORS.salmon
		var textColor = options.textColor || COLORS.white
		var fullscreen = options.fullscreen || false
		var language = options.language || browserLocale.slice(0, 2) // Language code

		var updateSource = "web" // Other possible values are 'googlePlay' or 'appStore'. Determines where we tell users to go for upgrades.

		// Chrome mobile is still Chrome (unlike Safari which is 'Mobile Safari')
		var isAndroid = parsedUserAgent.os.name === "Android"
		if (isAndroid) {
			updateSource = "googlePlay"
		}

		var isAndroidButNotChrome
		if (options.requireChromeOnAndroid) {
			isAndroidButNotChrome = isAndroid && parsedUserAgent.browser.name !== "Chrome"
		}

		if (parsedUserAgent.os.name === "iOS") {
			updateSource = "appStore"
		}

		var done = true

		var changeOpacity = function(opacityValue) {
			outdatedUI.style.opacity = opacityValue / 100
			outdatedUI.style.filter = "alpha(opacity=" + opacityValue + ")"
		}

		var fadeIn = function(opacityValue) {
			changeOpacity(opacityValue)
			if (opacityValue === 1) {
				outdatedUI.style.display = "table"
			}
			if (opacityValue === 100) {
				done = true
			}
		}

		var parseMinorVersion = function (version) {
			return version.replace(/[^\d.]/g,'').split(".")[1];
		}

		var isBrowserUnsupported = function() {
			var browserName = parsedUserAgent.browser.name
			var isUnsupported = false
			if (!(browserName in browserSupport)) {
				if (!options.isUnknownBrowserOK) {
					isUnsupported = true
				}
			} else if (!browserSupport[browserName]) {
				isUnsupported = true
			}
			return isUnsupported;
		}

		var isBrowserOutOfDate = function() {
			var browserName = parsedUserAgent.browser.name
			var browserMajorVersion = parsedUserAgent.browser.major
			if (browserName === "Edge") {
				browserMajorVersion = EDGEHTML_VS_EDGE_VERSIONS[browserMajorVersion]
			}
			var isOutOfDate = false
			if (isBrowserUnsupported()) {
				isOutOfDate = true;
			} else if (browserName in browserSupport) {
				var minVersion = browserSupport[browserName];
				if (typeof minVersion == 'object') {
					var minMajorVersion = minVersion.major;
					var minMinorVersion = minVersion.minor;

					if (browserMajorVersion < minMajorVersion) {
						isOutOfDate = true
					} else if (browserMajorVersion == minMajorVersion) {
						var browserMinorVersion = parseMinorVersion(parsedUserAgent.browser.version)

						if (browserMinorVersion < minMinorVersion) {
							isOutOfDate = true
						}
					}
				} else if (browserMajorVersion < minVersion) {
					isOutOfDate = true
				}
			}
			return isOutOfDate
		}

		// Returns true if a browser supports a css3 property
		var isPropertySupported = function(property) {
			if (!property) {
				return true
			}
			var div = document.createElement("div")
			var vendorPrefixes = ["khtml", "ms", "o", "moz", "webkit"]
			var count = vendorPrefixes.length

			// Note: HTMLElement.style.hasOwnProperty seems broken in Edge
			if (property in div.style) {
				return true
			}

			property = property.replace(/^[a-z]/, function(val) {
				return val.toUpperCase()
			})

			while (count--) {
				var prefixedProperty = vendorPrefixes[count] + property
				// See comment re: HTMLElement.style.hasOwnProperty above
				if (prefixedProperty in div.style) {
					return true
				}
			}
			return false
		}

		var makeFadeInFunction = function(opacityValue) {
			return function() {
				fadeIn(opacityValue)
			}
		}

		// Style element explicitly - TODO: investigate and delete if not needed
		var startStylesAndEvents = function() {
			var buttonClose = document.getElementById("buttonCloseUpdateBrowser")
			var buttonUpdate = document.getElementById("buttonUpdateBrowser")

			//check settings attributes
			outdatedUI.style.backgroundColor = backgroundColor
			//way too hard to put !important on IE6
			outdatedUI.style.color = textColor
			outdatedUI.children[0].children[0].style.color = textColor
			outdatedUI.children[0].children[1].style.color = textColor

			// Update button is desktop only
			if (buttonUpdate) {
				buttonUpdate.style.color = textColor
				if (buttonUpdate.style.borderColor) {
					buttonUpdate.style.borderColor = textColor
				}

				// Override the update button color to match the background color
				buttonUpdate.onmouseover = function() {
					this.style.color = backgroundColor
					this.style.backgroundColor = textColor
				}

				buttonUpdate.onmouseout = function() {
					this.style.color = textColor
					this.style.backgroundColor = backgroundColor
				}
			}

			buttonClose.style.color = textColor

			buttonClose.onmousedown = function() {
				outdatedUI.style.display = "none"
				return false
			}
		}

		var getmessage = function(lang) {
			var defaultMessages = languageMessages[lang] || languageMessages.en
			var customMessages = options.messages && options.messages[lang]
			var messages = deepExtend({}, defaultMessages, customMessages)

			var updateMessages = {
				web:
					"<p>" +
					messages.update.web +
					'<a id="buttonUpdateBrowser" rel="nofollow" href="' +
					messages.url +
					'">' +
					messages.callToAction +
					"</a></p>",
				googlePlay:
					"<p>" +
					messages.update.googlePlay +
					'<a id="buttonUpdateBrowser" rel="nofollow" href="https://play.google.com/store/apps/details?id=com.android.chrome">' +
					messages.callToAction +
					"</a></p>",
				appStore: "<p>" + messages.update[updateSource] + "</p>"
			}

			var updateMessage = updateMessages[updateSource]

			var browserSupportMessage = messages.outOfDate;
			if (isBrowserUnsupported() && messages.unsupported) {
				browserSupportMessage = messages.unsupported;
			}

			return (
				'<div class="vertical-center"><h6>' +
				browserSupportMessage +
				"</h6>" +
				updateMessage +
				'<p class="last"><a href="#" id="buttonCloseUpdateBrowser" title="' +
				messages.close +
				'">&times;</a></p></div>'
			)
		}

		// Check if browser is supported
		if (isBrowserOutOfDate() || !isPropertySupported(requiredCssProperty) || isAndroidButNotChrome) {
			// This is an outdated browser
			if (done && outdatedUI.style.opacity !== "1") {
				done = false

				for (var opacity = 1; opacity <= 100; opacity++) {
					setTimeout(makeFadeInFunction(opacity), opacity * 8)
				}
			}

			var insertContentHere = document.getElementById("outdated")
			if (fullscreen) {
				insertContentHere.classList.add("fullscreen")
			}
			insertContentHere.innerHTML = getmessage(language)
			startStylesAndEvents()
		}
	}

	// Load main when DOM ready.
	var oldOnload = window.onload
	if (typeof window.onload !== "function") {
		window.onload = main
	} else {
		window.onload = function() {
			if (oldOnload) {
				oldOnload()
			}
			main()
		}
	}
}


/***/ }),
/* 2904 */
/***/ (function(module, exports) {

module.exports = {
	"br": {
		"outOfDate": "O seu navegador est&aacute; desatualizado!",
		"update": {
			"web": "Atualize o seu navegador para ter uma melhor experi&ecirc;ncia e visualiza&ccedil;&atilde;o deste site. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/br",
		"callToAction": "Atualize o seu navegador agora",
		"close": "Fechar"
	},
	"ca": {
		"outOfDate": "El vostre navegador no està actualitzat!",
		"update": {
			"web": "Actualitzeu el vostre navegador per veure correctament aquest lloc web. ",
			"googlePlay": "Instal·leu Chrome des de Google Play",
			"appStore": "Actualitzeu iOS des de l'aplicació Configuració"
		},
		"url": "http://outdatedbrowser.com/es",
		"callToAction": "Actualitzar el meu navegador ara",
		"close": "Tancar"
	},
	"cn": {
		"outOfDate": "您的浏览器已过时",
		"update": {
			"web": "要正常浏览本网站请升级您的浏览器。",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/cn",
		"callToAction": "现在升级",
		"close": "关闭"
	},
	"cz": {
		"outOfDate": "Váš prohlížeč je zastaralý!",
		"update": {
			"web": "Pro správné zobrazení těchto stránek aktualizujte svůj prohlížeč. ",
			"googlePlay": "Nainstalujte si Chrome z Google Play",
			"appStore": "Aktualizujte si systém iOS"
		},
		"url": "http://outdatedbrowser.com/cz",
		"callToAction": "Aktualizovat nyní svůj prohlížeč",
		"close": "Zavřít"
	},
	"da": {
		"outOfDate": "Din browser er forældet!",
		"update": {
			"web": "Opdatér din browser for at få vist denne hjemmeside korrekt. ",
			"googlePlay": "Installér venligst Chrome fra Google Play",
			"appStore": "Opdatér venligst iOS"
		},
		"url": "http://outdatedbrowser.com/da",
		"callToAction": "Opdatér din browser nu",
		"close": "Luk"
	},
	"de": {
		"outOfDate": "Ihr Browser ist veraltet!",
		"update": {
			"web": "Bitte aktualisieren Sie Ihren Browser, um diese Website korrekt darzustellen. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/de",
		"callToAction": "Den Browser jetzt aktualisieren ",
		"close": "Schließen"
	},
	"ee": {
		"outOfDate": "Sinu veebilehitseja on vananenud!",
		"update": {
			"web": "Palun uuenda oma veebilehitsejat, et näha lehekülge korrektselt. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/ee",
		"callToAction": "Uuenda oma veebilehitsejat kohe",
		"close": "Sulge"
	},
	"en": {
		"outOfDate": "Your browser is out-of-date!",
		"update": {
			"web": "Update your browser to view this website correctly. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "Update my browser now",
		"close": "Close"
	},
	"es": {
		"outOfDate": "¡Tu navegador está anticuado!",
		"update": {
			"web": "Actualiza tu navegador para ver esta página correctamente. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/es",
		"callToAction": "Actualizar mi navegador ahora",
		"close": "Cerrar"
	},
	"fa": {
		"rightToLeft": true,
		"outOfDate": "مرورگر شما منسوخ شده است!",
		"update": {
			"web": "جهت مشاهده صحیح این وبسایت، مرورگرتان را بروز رسانی نمایید. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "همین حالا مرورگرم را بروز کن",
		"close": "Close"
	},
	"fi": {
		"outOfDate": "Selaimesi on vanhentunut!",
		"update": {
			"web": "Lataa ajantasainen selain n&auml;hd&auml;ksesi t&auml;m&auml;n sivun oikein. ",
			"googlePlay": "Asenna uusin Chrome Google Play -kaupasta",
			"appStore": "Päivitä iOS puhelimesi asetuksista"
		},
		"url": "http://outdatedbrowser.com/fi",
		"callToAction": "P&auml;ivit&auml; selaimeni nyt ",
		"close": "Sulje"
	},
	"fr": {
		"outOfDate": "Votre navigateur n'est plus compatible !",
		"update": {
			"web": "Mettez à jour votre navigateur pour afficher correctement ce site Web. ",
			"googlePlay": "Merci d'installer Chrome depuis le Google Play Store",
			"appStore": "Merci de mettre à jour iOS depuis l'application Réglages"
		},
		"url": "http://outdatedbrowser.com/fr",
		"callToAction": "Mettre à jour maintenant ",
		"close": "Fermer"
	},
	"hu": {
		"outOfDate": "A böngészője elavult!",
		"update": {
			"web": "Firssítse vagy cserélje le a böngészőjét. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/hu",
		"callToAction": "A böngészőm frissítése ",
		"close": "Close"
	},
	"id": {
		"outOfDate": "Browser yang Anda gunakan sudah ketinggalan zaman!",
		"update": {
			"web": "Perbaharuilah browser Anda agar bisa menjelajahi website ini dengan nyaman. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "Perbaharui browser sekarang ",
		"close": "Close"
	},
	"it": {
		"outOfDate": "Il tuo browser non &egrave; aggiornato!",
		"update": {
			"web": "Aggiornalo per vedere questo sito correttamente. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/it",
		"callToAction": "Aggiorna ora",
		"close": "Chiudi"
	},
	"lt": {
		"outOfDate": "Jūsų naršyklės versija yra pasenusi!",
		"update": {
			"web": "Atnaujinkite savo naršyklę, kad galėtumėte peržiūrėti šią svetainę tinkamai. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "Atnaujinti naršyklę ",
		"close": "Close"
	},
	"nl": {
		"outOfDate": "Je gebruikt een oude browser!",
		"update": {
			"web": "Update je browser om deze website correct te bekijken. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/nl",
		"callToAction": "Update mijn browser nu ",
		"close": "Sluiten"
	},
	"pl": {
		"outOfDate": "Twoja przeglądarka jest przestarzała!",
		"update": {
			"web": "Zaktualizuj swoją przeglądarkę, aby poprawnie wyświetlić tę stronę. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/pl",
		"callToAction": "Zaktualizuj przeglądarkę już teraz",
		"close": "Close"
	},
	"pt": {
		"outOfDate": "O seu browser est&aacute; desatualizado!",
		"update": {
			"web": "Atualize o seu browser para ter uma melhor experi&ecirc;ncia e visualiza&ccedil;&atilde;o deste site. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/pt",
		"callToAction": "Atualize o seu browser agora",
		"close": "Fechar"
	},
	"ro": {
		"outOfDate": "Browserul este învechit!",
		"update": {
			"web": "Actualizați browserul pentru a vizualiza corect acest site. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "Actualizați browserul acum!",
		"close": "Close"
	},
	"ru": {
		"outOfDate": "Ваш браузер устарел!",
		"update": {
			"web": "Обновите ваш браузер для правильного отображения этого сайта. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/ru",
		"callToAction": "Обновить мой браузер ",
		"close": "Закрыть"
	},
	"si": {
		"outOfDate": "Vaš brskalnik je zastarel!",
		"update": {
			"web": "Za pravilen prikaz spletne strani posodobite vaš brskalnik. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/si",
		"callToAction": "Posodobi brskalnik ",
		"close": "Zapri"
	},
	"sv": {
		"outOfDate": "Din webbläsare stödjs ej längre!",
		"update": {
			"web": "Uppdatera din webbläsare för att webbplatsen ska visas korrekt. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/",
		"callToAction": "Uppdatera min webbläsare nu",
		"close": "Stäng"
	},
	"ua": {
		"outOfDate": "Ваш браузер застарів!",
		"update": {
			"web": "Оновіть ваш браузер для правильного відображення цього сайта. ",
			"googlePlay": "Please install Chrome from Google Play",
			"appStore": "Please update iOS from the Settings App"
		},
		"url": "http://outdatedbrowser.com/ua",
		"callToAction": "Оновити мій браузер ",
		"close": "Закрити"
	}
};

/***/ }),
/* 2905 */
/***/ (function(module, exports) {

/* Highly dumbed down version of https://github.com/unclechu/node-deep-extend */

/**
 * Extening object that entered in first argument.
 *
 * Returns extended object or false if have no target object or incorrect type.
 *
 * If you wish to clone source object (without modify it), just use empty new
 * object as first argument, like this:
 *   deepExtend({}, yourObj_1, [yourObj_N]);
 */
module.exports = function deepExtend(/*obj_1, [obj_2], [obj_N]*/) {
	if (arguments.length < 1 || typeof arguments[0] !== "object") {
		return false
	}

	if (arguments.length < 2) {
		return arguments[0]
	}

	var target = arguments[0]

	for (var i = 1; i < arguments.length; i++) {
		var obj = arguments[i]

		for (var key in obj) {
			var src = target[key]
			var val = obj[key]

			if (typeof val !== "object" || val === null) {
				target[key] = val

				// just clone arrays (and recursive clone objects inside)
			} else if (typeof src !== "object" || src === null) {
				target[key] = deepExtend({}, val)

				// source value and new value is objects both, extending...
			} else {
				target[key] = deepExtend(src, val)
			}
		}
	}

	return target
}


/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2907);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(6)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../shared/rnclient/node_modules/css-loader/index.js?importLoaders=1!../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js!../../../../../shared/rnclient/node_modules/extract-text-webpack-plugin/loader.js??ref--12-0!../../../../../shared/rnclient/node_modules/style-loader/index.js!../../../../../shared/rnclient/node_modules/css-loader/index.js?sourceMap&localIdentName=[local]___[hash:base64:5]!../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js?outputStyle=expanded!./outdated-browser-rework-style.scss", function() {
			var newContent = require("!!../../../../../shared/rnclient/node_modules/css-loader/index.js?importLoaders=1!../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js!../../../../../shared/rnclient/node_modules/extract-text-webpack-plugin/loader.js??ref--12-0!../../../../../shared/rnclient/node_modules/style-loader/index.js!../../../../../shared/rnclient/node_modules/css-loader/index.js?sourceMap&localIdentName=[local]___[hash:base64:5]!../../../../../shared/rnclient/node_modules/sass-loader/dist/cjs.js?outputStyle=expanded!./outdated-browser-rework-style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(2909);

__webpack_require__(3080);

__webpack_require__(3081);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(961);
__webpack_require__(2910);
__webpack_require__(2911);
__webpack_require__(2912);
__webpack_require__(2913);
__webpack_require__(2914);
__webpack_require__(2915);
__webpack_require__(2916);
__webpack_require__(2917);
__webpack_require__(2918);
__webpack_require__(2919);
__webpack_require__(2920);
__webpack_require__(2921);
__webpack_require__(2922);
__webpack_require__(2923);
__webpack_require__(2924);
__webpack_require__(2925);
__webpack_require__(276);
__webpack_require__(2926);
__webpack_require__(2927);
__webpack_require__(2928);
__webpack_require__(2929);
__webpack_require__(2930);
__webpack_require__(2931);
__webpack_require__(2932);
__webpack_require__(2933);
__webpack_require__(2934);
__webpack_require__(2935);
__webpack_require__(1020);
__webpack_require__(1019);
__webpack_require__(2936);
__webpack_require__(2937);
__webpack_require__(2938);
__webpack_require__(2939);
__webpack_require__(2940);
__webpack_require__(2941);
__webpack_require__(2942);
__webpack_require__(2943);
__webpack_require__(2944);
__webpack_require__(2945);
__webpack_require__(2946);
__webpack_require__(2947);
__webpack_require__(2948);
__webpack_require__(2949);
__webpack_require__(2950);
__webpack_require__(2951);
__webpack_require__(2952);
__webpack_require__(1018);
__webpack_require__(2953);
__webpack_require__(2954);
__webpack_require__(2955);
__webpack_require__(2956);
__webpack_require__(2957);
__webpack_require__(2958);
__webpack_require__(2959);
__webpack_require__(355);
__webpack_require__(2960);
__webpack_require__(2961);
__webpack_require__(960);
__webpack_require__(2962);
__webpack_require__(959);
__webpack_require__(2963);
__webpack_require__(2964);
__webpack_require__(2965);
__webpack_require__(2966);
__webpack_require__(2967);
__webpack_require__(2968);
__webpack_require__(2969);
__webpack_require__(2970);
__webpack_require__(2971);
__webpack_require__(2972);
__webpack_require__(2973);
__webpack_require__(2974);
__webpack_require__(2975);
__webpack_require__(2976);
__webpack_require__(2977);
__webpack_require__(2978);
__webpack_require__(2980);
__webpack_require__(2981);
__webpack_require__(2983);
__webpack_require__(949);
__webpack_require__(2984);
__webpack_require__(2985);
__webpack_require__(2986);
__webpack_require__(2987);
__webpack_require__(2988);
__webpack_require__(2989);
__webpack_require__(2990);
__webpack_require__(2991);
__webpack_require__(2992);
__webpack_require__(2993);
__webpack_require__(2994);
__webpack_require__(2995);
__webpack_require__(2996);
__webpack_require__(2997);
__webpack_require__(2998);
__webpack_require__(2999);
__webpack_require__(952);
__webpack_require__(3000);
__webpack_require__(359);
__webpack_require__(3001);
__webpack_require__(1150);
__webpack_require__(3002);
__webpack_require__(1151);
__webpack_require__(3003);
__webpack_require__(3004);
__webpack_require__(3005);
__webpack_require__(3006);
__webpack_require__(1022);
__webpack_require__(516);
__webpack_require__(1152);
__webpack_require__(554);
__webpack_require__(3007);
__webpack_require__(3008);
__webpack_require__(3009);
__webpack_require__(3010);
__webpack_require__(3011);
__webpack_require__(3012);
__webpack_require__(3013);
__webpack_require__(3014);
__webpack_require__(3015);
__webpack_require__(3016);
__webpack_require__(3017);
__webpack_require__(3018);
__webpack_require__(3019);
__webpack_require__(3020);
__webpack_require__(3021);
__webpack_require__(3022);
__webpack_require__(3023);
__webpack_require__(3024);
__webpack_require__(3025);
__webpack_require__(3026);
__webpack_require__(3027);
__webpack_require__(3028);
__webpack_require__(3029);
__webpack_require__(3030);
__webpack_require__(3031);
__webpack_require__(3032);
__webpack_require__(1017);
__webpack_require__(3033);
__webpack_require__(3034);
__webpack_require__(3035);
__webpack_require__(3036);
__webpack_require__(3037);
__webpack_require__(3038);
__webpack_require__(3039);
__webpack_require__(3040);
__webpack_require__(964);
__webpack_require__(965);
__webpack_require__(3041);
__webpack_require__(1032);
__webpack_require__(3042);
__webpack_require__(3043);
__webpack_require__(3044);
__webpack_require__(3045);
__webpack_require__(3046);
__webpack_require__(954);
__webpack_require__(3047);
__webpack_require__(957);
__webpack_require__(3048);
__webpack_require__(1030);
__webpack_require__(3049);
__webpack_require__(958);
__webpack_require__(3050);
__webpack_require__(1031);
__webpack_require__(3051);
__webpack_require__(3052);
__webpack_require__(3053);
__webpack_require__(3054);
__webpack_require__(3055);
__webpack_require__(3056);
__webpack_require__(3057);
__webpack_require__(3058);
__webpack_require__(3059);
__webpack_require__(3060);
__webpack_require__(3061);
__webpack_require__(3062);
__webpack_require__(3063);
__webpack_require__(3064);
__webpack_require__(3065);
__webpack_require__(3066);
__webpack_require__(1026);
__webpack_require__(1027);
__webpack_require__(3067);
__webpack_require__(3068);
__webpack_require__(3069);
__webpack_require__(3070);
__webpack_require__(3071);
__webpack_require__(3072);
__webpack_require__(3073);
__webpack_require__(3074);
__webpack_require__(3075);
__webpack_require__(3076);
__webpack_require__(3077);
__webpack_require__(3078);
__webpack_require__(3079);
__webpack_require__(361);
module.exports = __webpack_require__(51);


/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(191) });


/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(56), 'Object', { defineProperty: __webpack_require__(61).f });


/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(56), 'Object', { defineProperties: __webpack_require__(947) });


/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(100);
var $getOwnPropertyDescriptor = __webpack_require__(102).f;

__webpack_require__(135)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(64);
var $getPrototypeOf = __webpack_require__(101);

__webpack_require__(135)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(64);
var $keys = __webpack_require__(192);

__webpack_require__(135)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(135)('getOwnPropertyNames', function () {
  return __webpack_require__(963).f;
});


/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(40);
var meta = __webpack_require__(168).onFreeze;

__webpack_require__(135)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(40);
var meta = __webpack_require__(168).onFreeze;

__webpack_require__(135)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(40);
var meta = __webpack_require__(168).onFreeze;

__webpack_require__(135)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(40);

__webpack_require__(135)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(40);

__webpack_require__(135)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(40);

__webpack_require__(135)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(3);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1028) });


/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { is: __webpack_require__(1141) });


/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(518).set });


/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(3);

$export($export.P, 'Function', { bind: __webpack_require__(1142) });


/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(61).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(56) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(101);
var HAS_INSTANCE = __webpack_require__(52)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(61).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(1143);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(1144);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(34);
var has = __webpack_require__(99);
var cof = __webpack_require__(109);
var inheritIfRequired = __webpack_require__(517);
var toPrimitive = __webpack_require__(124);
var fails = __webpack_require__(37);
var gOPN = __webpack_require__(199).f;
var gOPD = __webpack_require__(102).f;
var dP = __webpack_require__(61).f;
var $trim = __webpack_require__(244).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(191)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(56) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(93)(global, NUMBER, $Number);
}


/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toInteger = __webpack_require__(107);
var aNumberValue = __webpack_require__(1145);
var repeat = __webpack_require__(589);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(37)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $fails = __webpack_require__(37);
var aNumberValue = __webpack_require__(1145);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(3);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(3);
var _isFinite = __webpack_require__(34).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(3);
var isInteger = __webpack_require__(1021);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(1144);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(1143);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(3);
var log1p = __webpack_require__(1146);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(3);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(3);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(3);
var sign = __webpack_require__(590);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(3);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(3);
var $expm1 = __webpack_require__(591);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { fround: __webpack_require__(1147) });


/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(3);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(3);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(37)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { log1p: __webpack_require__(1146) });


/***/ }),
/* 2953 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { sign: __webpack_require__(590) });


/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(591);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(37)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(591);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(193);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(100);
var toLength = __webpack_require__(55);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 2959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(244)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $at = __webpack_require__(356)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(55);
var context = __webpack_require__(519);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(520)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(589)
});


/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(97)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(97)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(97)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(97)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(97)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(97)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(97)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(97)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(97)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 2972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(97)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 2973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(97)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(97)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(97)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(3);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(64);
var toPrimitive = __webpack_require__(124);

$export($export.P + $export.F * __webpack_require__(37)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(3);
var toISOString = __webpack_require__(2979);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(37);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(93)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 2981 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(52)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(92)(proto, TO_PRIMITIVE, __webpack_require__(2982));


/***/ }),
/* 2982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(29);
var toPrimitive = __webpack_require__(124);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 2983 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(3);

$export($export.S, 'Array', { isArray: __webpack_require__(360) });


/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var createProperty = __webpack_require__(513);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(37)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 2985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(3);
var toIObject = __webpack_require__(100);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(275) != Object || !__webpack_require__(115)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var html = __webpack_require__(511);
var cof = __webpack_require__(109);
var toAbsoluteIndex = __webpack_require__(193);
var toLength = __webpack_require__(55);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(37)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 2987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var aFunction = __webpack_require__(82);
var toObject = __webpack_require__(64);
var fails = __webpack_require__(37);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(115)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 2988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $forEach = __webpack_require__(125)(0);
var STRICT = __webpack_require__(115)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $map = __webpack_require__(125)(1);

$export($export.P + $export.F * !__webpack_require__(115)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $filter = __webpack_require__(125)(2);

$export($export.P + $export.F * !__webpack_require__(115)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $some = __webpack_require__(125)(3);

$export($export.P + $export.F * !__webpack_require__(115)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $every = __webpack_require__(125)(4);

$export($export.P + $export.F * !__webpack_require__(115)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(1148);

$export($export.P + $export.F * !__webpack_require__(115)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 2994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(1148);

$export($export.P + $export.F * !__webpack_require__(115)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $indexOf = __webpack_require__(357)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(115)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 2996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(100);
var toInteger = __webpack_require__(107);
var toLength = __webpack_require__(55);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(115)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { copyWithin: __webpack_require__(1149) });

__webpack_require__(167)('copyWithin');


/***/ }),
/* 2998 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { fill: __webpack_require__(592) });

__webpack_require__(167)('fill');


/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(125)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(167)(KEY);


/***/ }),
/* 3000 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(197)('Array');


/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var inheritIfRequired = __webpack_require__(517);
var dP = __webpack_require__(61).f;
var gOPN = __webpack_require__(199).f;
var isRegExp = __webpack_require__(365);
var $flags = __webpack_require__(301);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(56) && (!CORRECT_NEW || __webpack_require__(37)(function () {
  re2[__webpack_require__(52)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(93)(global, 'RegExp', $RegExp);
}

__webpack_require__(197)('RegExp');


/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(1151);
var anObject = __webpack_require__(29);
var $flags = __webpack_require__(301);
var DESCRIPTORS = __webpack_require__(56);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(93)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(37)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(29);
var toLength = __webpack_require__(55);
var advanceStringIndex = __webpack_require__(594);
var regExpExec = __webpack_require__(401);

// @@match logic
__webpack_require__(402)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(29);
var toObject = __webpack_require__(64);
var toLength = __webpack_require__(55);
var toInteger = __webpack_require__(107);
var advanceStringIndex = __webpack_require__(594);
var regExpExec = __webpack_require__(401);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(402)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(29);
var sameValue = __webpack_require__(1141);
var regExpExec = __webpack_require__(401);

// @@search logic
__webpack_require__(402)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(365);
var anObject = __webpack_require__(29);
var speciesConstructor = __webpack_require__(288);
var advanceStringIndex = __webpack_require__(594);
var toLength = __webpack_require__(55);
var callRegExpExec = __webpack_require__(401);
var regexpExec = __webpack_require__(593);
var fails = __webpack_require__(37);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(402)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(1029);
var validate = __webpack_require__(198);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(362)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $typed = __webpack_require__(403);
var buffer = __webpack_require__(595);
var anObject = __webpack_require__(29);
var toAbsoluteIndex = __webpack_require__(193);
var toLength = __webpack_require__(55);
var isObject = __webpack_require__(40);
var ArrayBuffer = __webpack_require__(34).ArrayBuffer;
var speciesConstructor = __webpack_require__(288);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(37)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(197)(ARRAY_BUFFER);


/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
$export($export.G + $export.W + $export.F * !__webpack_require__(403).ABV, {
  DataView: __webpack_require__(595).DataView
});


/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 3012 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 3015 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 3016 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 3017 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 3018 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 3019 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(82);
var anObject = __webpack_require__(29);
var rApply = (__webpack_require__(34).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(37)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 3020 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(3);
var create = __webpack_require__(191);
var aFunction = __webpack_require__(82);
var anObject = __webpack_require__(29);
var isObject = __webpack_require__(40);
var fails = __webpack_require__(37);
var bind = __webpack_require__(1142);
var rConstruct = (__webpack_require__(34).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 3021 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(61);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(29);
var toPrimitive = __webpack_require__(124);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(37)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(3);
var gOPD = __webpack_require__(102).f;
var anObject = __webpack_require__(29);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 3023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(29);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(508)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 3024 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(102);
var getPrototypeOf = __webpack_require__(101);
var has = __webpack_require__(99);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(40);
var anObject = __webpack_require__(29);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(102);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(29);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 3026 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(3);
var getProto = __webpack_require__(101);
var anObject = __webpack_require__(29);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 3027 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(29);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(1154) });


/***/ }),
/* 3030 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(29);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 3031 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(61);
var gOPD = __webpack_require__(102);
var getPrototypeOf = __webpack_require__(101);
var has = __webpack_require__(99);
var $export = __webpack_require__(3);
var createDesc = __webpack_require__(189);
var anObject = __webpack_require__(29);
var isObject = __webpack_require__(40);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 3032 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(3);
var setProto = __webpack_require__(518);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 3033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(1155);
var toObject = __webpack_require__(64);
var toLength = __webpack_require__(55);
var aFunction = __webpack_require__(82);
var arraySpeciesCreate = __webpack_require__(515);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(167)('flatMap');


/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(1155);
var toObject = __webpack_require__(64);
var toLength = __webpack_require__(55);
var toInteger = __webpack_require__(107);
var arraySpeciesCreate = __webpack_require__(515);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(167)('flatten');


/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(3);
var $at = __webpack_require__(356)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(1156);
var userAgent = __webpack_require__(383);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(1156);
var userAgent = __webpack_require__(383);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(244)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(244)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(3);
var defined = __webpack_require__(123);
var toLength = __webpack_require__(55);
var isRegExp = __webpack_require__(365);
var getFlags = __webpack_require__(301);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(508)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(3);
var ownKeys = __webpack_require__(1154);
var toIObject = __webpack_require__(100);
var gOPD = __webpack_require__(102);
var createProperty = __webpack_require__(513);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $entries = __webpack_require__(1033)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(64);
var aFunction = __webpack_require__(82);
var $defineProperty = __webpack_require__(61);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(56) && $export($export.P + __webpack_require__(404), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(64);
var aFunction = __webpack_require__(82);
var $defineProperty = __webpack_require__(61);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(56) && $export($export.P + __webpack_require__(404), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(64);
var toPrimitive = __webpack_require__(124);
var getPrototypeOf = __webpack_require__(101);
var getOwnPropertyDescriptor = __webpack_require__(102).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(56) && $export($export.P + __webpack_require__(404), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(64);
var toPrimitive = __webpack_require__(124);
var getPrototypeOf = __webpack_require__(101);
var getOwnPropertyDescriptor = __webpack_require__(102).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(56) && $export($export.P + __webpack_require__(404), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(3);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(955)('Set') });


/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(363)('Set');


/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(363)('WeakSet');


/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(364)('Set');


/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(364)('WeakSet');


/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(3);

$export($export.G, { global: __webpack_require__(34) });


/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(3);

$export($export.S, 'System', { global: __webpack_require__(34) });


/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(3);
var cof = __webpack_require__(109);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var scale = __webpack_require__(1157);
var fround = __webpack_require__(1147);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 3059 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 3064 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { scale: __webpack_require__(1157) });


/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(3);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(155);
var anObject = __webpack_require__(29);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(155);
var anObject = __webpack_require__(29);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(155);
var anObject = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(101);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(1152);
var from = __webpack_require__(956);
var metadata = __webpack_require__(155);
var anObject = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(101);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(155);
var anObject = __webpack_require__(29);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(155);
var anObject = __webpack_require__(29);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(155);
var anObject = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(101);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 3074 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(155);
var anObject = __webpack_require__(29);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(155);
var anObject = __webpack_require__(29);
var aFunction = __webpack_require__(82);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(3);
var microtask = __webpack_require__(552)();
var process = __webpack_require__(34).process;
var isNode = __webpack_require__(109)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(3);
var global = __webpack_require__(34);
var core = __webpack_require__(51);
var microtask = __webpack_require__(552)();
var OBSERVABLE = __webpack_require__(52)('observable');
var aFunction = __webpack_require__(82);
var anObject = __webpack_require__(29);
var anInstance = __webpack_require__(195);
var redefineAll = __webpack_require__(194);
var hide = __webpack_require__(92);
var forOf = __webpack_require__(196);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(197)('Observable');


/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(34);
var $export = __webpack_require__(3);
var userAgent = __webpack_require__(383);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $task = __webpack_require__(551);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3082);
module.exports = __webpack_require__(51).RegExp.escape;


/***/ }),
/* 3082 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(3);
var $re = __webpack_require__(3083)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 3083 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js